(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec308"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec308"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ijIqx", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $d55c76a4750c0547$export$ffb0004e005737fa; }, function (v) { return $d55c76a4750c0547$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $d55c76a4750c0547$export$34b9dba7ce09269b; }, function (v) { return $d55c76a4750c0547$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $d55c76a4750c0547$export$25062201e9e25d76; }, function (v) { return $d55c76a4750c0547$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d55c76a4750c0547$export$ffb0004e005737fa;
var $d55c76a4750c0547$export$34b9dba7ce09269b;
var $d55c76a4750c0547$export$25062201e9e25d76;
'use strict';

var $ieT14 = parcelRequire("ieT14");
var $d55c76a4750c0547$var$k = Symbol.for("react.element"), $d55c76a4750c0547$var$l = Symbol.for("react.fragment"), $d55c76a4750c0547$var$m = Object.prototype.hasOwnProperty, $d55c76a4750c0547$var$n = $ieT14.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $d55c76a4750c0547$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d55c76a4750c0547$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$d55c76a4750c0547$var$m.call(a, b) && !$d55c76a4750c0547$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $d55c76a4750c0547$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $d55c76a4750c0547$var$n.current
    };
}
$d55c76a4750c0547$export$ffb0004e005737fa = $d55c76a4750c0547$var$l;
$d55c76a4750c0547$export$34b9dba7ce09269b = $d55c76a4750c0547$var$q;
$d55c76a4750c0547$export$25062201e9e25d76 = $d55c76a4750c0547$var$q;

});
parcelRegister("ieT14", function(module, exports) {
'use strict';

module.exports = (parcelRequire("enZUw"));

});
parcelRegister("enZUw", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $a7933cd919fa1fc0$export$dca3b0875bd9a954; }, function (v) { return $a7933cd919fa1fc0$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $a7933cd919fa1fc0$export$16fa2f45be04daa8; }, function (v) { return $a7933cd919fa1fc0$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $a7933cd919fa1fc0$export$ffb0004e005737fa; }, function (v) { return $a7933cd919fa1fc0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $a7933cd919fa1fc0$export$e2c29f18771995cb; }, function (v) { return $a7933cd919fa1fc0$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $a7933cd919fa1fc0$export$221d75b3f55bb0bd; }, function (v) { return $a7933cd919fa1fc0$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $a7933cd919fa1fc0$export$5f8d39834fd61797; }, function (v) { return $a7933cd919fa1fc0$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $a7933cd919fa1fc0$export$74bf444e3cd11ea5; }, function (v) { return $a7933cd919fa1fc0$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $a7933cd919fa1fc0$export$ae55be85d98224ed; }, function (v) { return $a7933cd919fa1fc0$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $a7933cd919fa1fc0$export$3ba232387fd5d6dd; }, function (v) { return $a7933cd919fa1fc0$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $a7933cd919fa1fc0$export$e530037191fcd5d7; }, function (v) { return $a7933cd919fa1fc0$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $a7933cd919fa1fc0$export$fd42f52fd3ae1109; }, function (v) { return $a7933cd919fa1fc0$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $a7933cd919fa1fc0$export$c8a8987d4410bf2d; }, function (v) { return $a7933cd919fa1fc0$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $a7933cd919fa1fc0$export$d38cd72104c1f0e9; }, function (v) { return $a7933cd919fa1fc0$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $a7933cd919fa1fc0$export$7d1e3a5e95ceca43; }, function (v) { return $a7933cd919fa1fc0$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $a7933cd919fa1fc0$export$257a8862b851cb5b; }, function (v) { return $a7933cd919fa1fc0$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $a7933cd919fa1fc0$export$a8257692ac88316c; }, function (v) { return $a7933cd919fa1fc0$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $a7933cd919fa1fc0$export$488013bae63b21da; }, function (v) { return $a7933cd919fa1fc0$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $a7933cd919fa1fc0$export$7c73462e0d25e514; }, function (v) { return $a7933cd919fa1fc0$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $a7933cd919fa1fc0$export$7568632d0d33d16d; }, function (v) { return $a7933cd919fa1fc0$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $a7933cd919fa1fc0$export$88948ce120ea2619; }, function (v) { return $a7933cd919fa1fc0$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $a7933cd919fa1fc0$export$35808ee640e87ca7; }, function (v) { return $a7933cd919fa1fc0$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $a7933cd919fa1fc0$export$fae74005e78b1a27; }, function (v) { return $a7933cd919fa1fc0$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $a7933cd919fa1fc0$export$dc8fbce3eb94dc1e; }, function (v) { return $a7933cd919fa1fc0$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $a7933cd919fa1fc0$export$6a7bc4e911dc01cf; }, function (v) { return $a7933cd919fa1fc0$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $a7933cd919fa1fc0$export$6d9c69b0de29b591; }, function (v) { return $a7933cd919fa1fc0$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $a7933cd919fa1fc0$export$f680877a34711e37; }, function (v) { return $a7933cd919fa1fc0$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $a7933cd919fa1fc0$export$d5a552a76deda3c2; }, function (v) { return $a7933cd919fa1fc0$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $a7933cd919fa1fc0$export$aaabe4eda9ed9969; }, function (v) { return $a7933cd919fa1fc0$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $a7933cd919fa1fc0$export$e5c5a5f917a5871c; }, function (v) { return $a7933cd919fa1fc0$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $a7933cd919fa1fc0$export$1538c33de8887b59; }, function (v) { return $a7933cd919fa1fc0$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $a7933cd919fa1fc0$export$13e3392192263954; }, function (v) { return $a7933cd919fa1fc0$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $a7933cd919fa1fc0$export$b8f5890fc79d6aca; }, function (v) { return $a7933cd919fa1fc0$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $a7933cd919fa1fc0$export$60241385465d0a34; }, function (v) { return $a7933cd919fa1fc0$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $a7933cd919fa1fc0$export$306c0aa65ff9ec16; }, function (v) { return $a7933cd919fa1fc0$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $a7933cd919fa1fc0$export$7b286972b8d8ccbf; }, function (v) { return $a7933cd919fa1fc0$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $a7933cd919fa1fc0$export$83d89fbfd8236492; }, function (v) { return $a7933cd919fa1fc0$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a7933cd919fa1fc0$export$dca3b0875bd9a954;
var $a7933cd919fa1fc0$export$16fa2f45be04daa8;
var $a7933cd919fa1fc0$export$ffb0004e005737fa;
var $a7933cd919fa1fc0$export$e2c29f18771995cb;
var $a7933cd919fa1fc0$export$221d75b3f55bb0bd;
var $a7933cd919fa1fc0$export$5f8d39834fd61797;
var $a7933cd919fa1fc0$export$74bf444e3cd11ea5;
var $a7933cd919fa1fc0$export$ae55be85d98224ed;
var $a7933cd919fa1fc0$export$3ba232387fd5d6dd;
var $a7933cd919fa1fc0$export$e530037191fcd5d7;
var $a7933cd919fa1fc0$export$fd42f52fd3ae1109;
var $a7933cd919fa1fc0$export$c8a8987d4410bf2d;
var $a7933cd919fa1fc0$export$d38cd72104c1f0e9;
var $a7933cd919fa1fc0$export$7d1e3a5e95ceca43;
var $a7933cd919fa1fc0$export$257a8862b851cb5b;
var $a7933cd919fa1fc0$export$a8257692ac88316c;
var $a7933cd919fa1fc0$export$488013bae63b21da;
var $a7933cd919fa1fc0$export$7c73462e0d25e514;
var $a7933cd919fa1fc0$export$7568632d0d33d16d;
var $a7933cd919fa1fc0$export$88948ce120ea2619;
var $a7933cd919fa1fc0$export$35808ee640e87ca7;
var $a7933cd919fa1fc0$export$fae74005e78b1a27;
var $a7933cd919fa1fc0$export$dc8fbce3eb94dc1e;
var $a7933cd919fa1fc0$export$6a7bc4e911dc01cf;
var $a7933cd919fa1fc0$export$6d9c69b0de29b591;
var $a7933cd919fa1fc0$export$f680877a34711e37;
var $a7933cd919fa1fc0$export$d5a552a76deda3c2;
var $a7933cd919fa1fc0$export$aaabe4eda9ed9969;
var $a7933cd919fa1fc0$export$e5c5a5f917a5871c;
var $a7933cd919fa1fc0$export$1538c33de8887b59;
var $a7933cd919fa1fc0$export$13e3392192263954;
var $a7933cd919fa1fc0$export$b8f5890fc79d6aca;
var $a7933cd919fa1fc0$export$60241385465d0a34;
var $a7933cd919fa1fc0$export$306c0aa65ff9ec16;
var $a7933cd919fa1fc0$export$7b286972b8d8ccbf;
var $a7933cd919fa1fc0$export$83d89fbfd8236492;
'use strict';
var $a7933cd919fa1fc0$var$l = Symbol.for("react.element"), $a7933cd919fa1fc0$var$n = Symbol.for("react.portal"), $a7933cd919fa1fc0$var$p = Symbol.for("react.fragment"), $a7933cd919fa1fc0$var$q = Symbol.for("react.strict_mode"), $a7933cd919fa1fc0$var$r = Symbol.for("react.profiler"), $a7933cd919fa1fc0$var$t = Symbol.for("react.provider"), $a7933cd919fa1fc0$var$u = Symbol.for("react.context"), $a7933cd919fa1fc0$var$v = Symbol.for("react.forward_ref"), $a7933cd919fa1fc0$var$w = Symbol.for("react.suspense"), $a7933cd919fa1fc0$var$x = Symbol.for("react.memo"), $a7933cd919fa1fc0$var$y = Symbol.for("react.lazy"), $a7933cd919fa1fc0$var$z = Symbol.iterator;
function $a7933cd919fa1fc0$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $a7933cd919fa1fc0$var$z && a[$a7933cd919fa1fc0$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $a7933cd919fa1fc0$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $a7933cd919fa1fc0$var$C = Object.assign, $a7933cd919fa1fc0$var$D = {};
function $a7933cd919fa1fc0$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $a7933cd919fa1fc0$var$D;
    this.updater = e || $a7933cd919fa1fc0$var$B;
}
$a7933cd919fa1fc0$var$E.prototype.isReactComponent = {};
$a7933cd919fa1fc0$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$a7933cd919fa1fc0$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $a7933cd919fa1fc0$var$F() {}
$a7933cd919fa1fc0$var$F.prototype = $a7933cd919fa1fc0$var$E.prototype;
function $a7933cd919fa1fc0$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $a7933cd919fa1fc0$var$D;
    this.updater = e || $a7933cd919fa1fc0$var$B;
}
var $a7933cd919fa1fc0$var$H = $a7933cd919fa1fc0$var$G.prototype = new $a7933cd919fa1fc0$var$F;
$a7933cd919fa1fc0$var$H.constructor = $a7933cd919fa1fc0$var$G;
$a7933cd919fa1fc0$var$C($a7933cd919fa1fc0$var$H, $a7933cd919fa1fc0$var$E.prototype);
$a7933cd919fa1fc0$var$H.isPureReactComponent = !0;
var $a7933cd919fa1fc0$var$I = Array.isArray, $a7933cd919fa1fc0$var$J = Object.prototype.hasOwnProperty, $a7933cd919fa1fc0$var$K = {
    current: null
}, $a7933cd919fa1fc0$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $a7933cd919fa1fc0$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$a7933cd919fa1fc0$var$J.call(b, d) && !$a7933cd919fa1fc0$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $a7933cd919fa1fc0$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $a7933cd919fa1fc0$var$K.current
    };
}
function $a7933cd919fa1fc0$var$N(a, b) {
    return {
        $$typeof: $a7933cd919fa1fc0$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $a7933cd919fa1fc0$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a7933cd919fa1fc0$var$l;
}
function $a7933cd919fa1fc0$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $a7933cd919fa1fc0$var$P = /\/+/g;
function $a7933cd919fa1fc0$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $a7933cd919fa1fc0$var$escape("" + a.key) : b.toString(36);
}
function $a7933cd919fa1fc0$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $a7933cd919fa1fc0$var$l:
                case $a7933cd919fa1fc0$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $a7933cd919fa1fc0$var$Q(h, 0) : d, $a7933cd919fa1fc0$var$I(c) ? (e = "", null != a && (e = a.replace($a7933cd919fa1fc0$var$P, "$&/") + "/"), $a7933cd919fa1fc0$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($a7933cd919fa1fc0$var$O(c) && (c = $a7933cd919fa1fc0$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($a7933cd919fa1fc0$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($a7933cd919fa1fc0$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $a7933cd919fa1fc0$var$Q(k, g);
        h += $a7933cd919fa1fc0$var$R(k, b, e, f, c);
    }
    else if (f = $a7933cd919fa1fc0$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $a7933cd919fa1fc0$var$Q(k, g++), h += $a7933cd919fa1fc0$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $a7933cd919fa1fc0$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $a7933cd919fa1fc0$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $a7933cd919fa1fc0$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $a7933cd919fa1fc0$var$U = {
    current: null
}, $a7933cd919fa1fc0$var$V = {
    transition: null
}, $a7933cd919fa1fc0$var$W = {
    ReactCurrentDispatcher: $a7933cd919fa1fc0$var$U,
    ReactCurrentBatchConfig: $a7933cd919fa1fc0$var$V,
    ReactCurrentOwner: $a7933cd919fa1fc0$var$K
};
function $a7933cd919fa1fc0$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$a7933cd919fa1fc0$export$dca3b0875bd9a954 = {
    map: $a7933cd919fa1fc0$var$S,
    forEach: function(a, b, e) {
        $a7933cd919fa1fc0$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $a7933cd919fa1fc0$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $a7933cd919fa1fc0$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$a7933cd919fa1fc0$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$a7933cd919fa1fc0$export$16fa2f45be04daa8 = $a7933cd919fa1fc0$var$E;
$a7933cd919fa1fc0$export$ffb0004e005737fa = $a7933cd919fa1fc0$var$p;
$a7933cd919fa1fc0$export$e2c29f18771995cb = $a7933cd919fa1fc0$var$r;
$a7933cd919fa1fc0$export$221d75b3f55bb0bd = $a7933cd919fa1fc0$var$G;
$a7933cd919fa1fc0$export$5f8d39834fd61797 = $a7933cd919fa1fc0$var$q;
$a7933cd919fa1fc0$export$74bf444e3cd11ea5 = $a7933cd919fa1fc0$var$w;
$a7933cd919fa1fc0$export$ae55be85d98224ed = $a7933cd919fa1fc0$var$W;
$a7933cd919fa1fc0$export$3ba232387fd5d6dd = $a7933cd919fa1fc0$var$X;
$a7933cd919fa1fc0$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $a7933cd919fa1fc0$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $a7933cd919fa1fc0$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$a7933cd919fa1fc0$var$J.call(b, f) && !$a7933cd919fa1fc0$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $a7933cd919fa1fc0$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$a7933cd919fa1fc0$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $a7933cd919fa1fc0$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $a7933cd919fa1fc0$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$a7933cd919fa1fc0$export$c8a8987d4410bf2d = $a7933cd919fa1fc0$var$M;
$a7933cd919fa1fc0$export$d38cd72104c1f0e9 = function(a) {
    var b = $a7933cd919fa1fc0$var$M.bind(null, a);
    b.type = a;
    return b;
};
$a7933cd919fa1fc0$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$a7933cd919fa1fc0$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $a7933cd919fa1fc0$var$v,
        render: a
    };
};
$a7933cd919fa1fc0$export$a8257692ac88316c = $a7933cd919fa1fc0$var$O;
$a7933cd919fa1fc0$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $a7933cd919fa1fc0$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $a7933cd919fa1fc0$var$T
    };
};
$a7933cd919fa1fc0$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $a7933cd919fa1fc0$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$a7933cd919fa1fc0$export$7568632d0d33d16d = function(a) {
    var b = $a7933cd919fa1fc0$var$V.transition;
    $a7933cd919fa1fc0$var$V.transition = {};
    try {
        a();
    } finally{
        $a7933cd919fa1fc0$var$V.transition = b;
    }
};
$a7933cd919fa1fc0$export$88948ce120ea2619 = $a7933cd919fa1fc0$var$X;
$a7933cd919fa1fc0$export$35808ee640e87ca7 = function(a, b) {
    return $a7933cd919fa1fc0$var$U.current.useCallback(a, b);
};
$a7933cd919fa1fc0$export$fae74005e78b1a27 = function(a) {
    return $a7933cd919fa1fc0$var$U.current.useContext(a);
};
$a7933cd919fa1fc0$export$dc8fbce3eb94dc1e = function() {};
$a7933cd919fa1fc0$export$6a7bc4e911dc01cf = function(a) {
    return $a7933cd919fa1fc0$var$U.current.useDeferredValue(a);
};
$a7933cd919fa1fc0$export$6d9c69b0de29b591 = function(a, b) {
    return $a7933cd919fa1fc0$var$U.current.useEffect(a, b);
};
$a7933cd919fa1fc0$export$f680877a34711e37 = function() {
    return $a7933cd919fa1fc0$var$U.current.useId();
};
$a7933cd919fa1fc0$export$d5a552a76deda3c2 = function(a, b, e) {
    return $a7933cd919fa1fc0$var$U.current.useImperativeHandle(a, b, e);
};
$a7933cd919fa1fc0$export$aaabe4eda9ed9969 = function(a, b) {
    return $a7933cd919fa1fc0$var$U.current.useInsertionEffect(a, b);
};
$a7933cd919fa1fc0$export$e5c5a5f917a5871c = function(a, b) {
    return $a7933cd919fa1fc0$var$U.current.useLayoutEffect(a, b);
};
$a7933cd919fa1fc0$export$1538c33de8887b59 = function(a, b) {
    return $a7933cd919fa1fc0$var$U.current.useMemo(a, b);
};
$a7933cd919fa1fc0$export$13e3392192263954 = function(a, b, e) {
    return $a7933cd919fa1fc0$var$U.current.useReducer(a, b, e);
};
$a7933cd919fa1fc0$export$b8f5890fc79d6aca = function(a) {
    return $a7933cd919fa1fc0$var$U.current.useRef(a);
};
$a7933cd919fa1fc0$export$60241385465d0a34 = function(a) {
    return $a7933cd919fa1fc0$var$U.current.useState(a);
};
$a7933cd919fa1fc0$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $a7933cd919fa1fc0$var$U.current.useSyncExternalStore(a, b, e);
};
$a7933cd919fa1fc0$export$7b286972b8d8ccbf = function() {
    return $a7933cd919fa1fc0$var$U.current.useTransition();
};
$a7933cd919fa1fc0$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("8jKnw", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $60e412df8c449d66$export$ae55be85d98224ed; }, function (v) { return $60e412df8c449d66$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $60e412df8c449d66$export$d39a5bbd09211389; }, function (v) { return $60e412df8c449d66$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $60e412df8c449d66$export$882461b6382ed46c; }, function (v) { return $60e412df8c449d66$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $60e412df8c449d66$export$466bfc07425424d5; }, function (v) { return $60e412df8c449d66$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $60e412df8c449d66$export$cd75ccfd720a3cd4; }, function (v) { return $60e412df8c449d66$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $60e412df8c449d66$export$fa8d919ba61d84db; }, function (v) { return $60e412df8c449d66$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $60e412df8c449d66$export$757ceba2d55c277e; }, function (v) { return $60e412df8c449d66$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $60e412df8c449d66$export$b3890eb0ae9dca99; }, function (v) { return $60e412df8c449d66$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $60e412df8c449d66$export$502457920280e6be; }, function (v) { return $60e412df8c449d66$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $60e412df8c449d66$export$c78a37762a8d58e1; }, function (v) { return $60e412df8c449d66$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $60e412df8c449d66$export$dc54d992c10e8a18; }, function (v) { return $60e412df8c449d66$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $60e412df8c449d66$export$83d89fbfd8236492; }, function (v) { return $60e412df8c449d66$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $60e412df8c449d66$export$ae55be85d98224ed;
var $60e412df8c449d66$export$d39a5bbd09211389;
var $60e412df8c449d66$export$882461b6382ed46c;
var $60e412df8c449d66$export$466bfc07425424d5;
var $60e412df8c449d66$export$cd75ccfd720a3cd4;
var $60e412df8c449d66$export$fa8d919ba61d84db;
var $60e412df8c449d66$export$757ceba2d55c277e;
var $60e412df8c449d66$export$b3890eb0ae9dca99;
var $60e412df8c449d66$export$502457920280e6be;
var $60e412df8c449d66$export$c78a37762a8d58e1;
var $60e412df8c449d66$export$dc54d992c10e8a18;
var $60e412df8c449d66$export$83d89fbfd8236492;
'use strict';

var $ieT14 = parcelRequire("ieT14");

var $7Vk7y = parcelRequire("7Vk7y");
function $60e412df8c449d66$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $60e412df8c449d66$var$da = new Set, $60e412df8c449d66$var$ea = {};
function $60e412df8c449d66$var$fa(a, b) {
    $60e412df8c449d66$var$ha(a, b);
    $60e412df8c449d66$var$ha(a + "Capture", b);
}
function $60e412df8c449d66$var$ha(a, b) {
    $60e412df8c449d66$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$60e412df8c449d66$var$da.add(b[a]);
}
var $60e412df8c449d66$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $60e412df8c449d66$var$ja = Object.prototype.hasOwnProperty, $60e412df8c449d66$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $60e412df8c449d66$var$la = {}, $60e412df8c449d66$var$ma = {};
function $60e412df8c449d66$var$oa(a) {
    if ($60e412df8c449d66$var$ja.call($60e412df8c449d66$var$ma, a)) return !0;
    if ($60e412df8c449d66$var$ja.call($60e412df8c449d66$var$la, a)) return !1;
    if ($60e412df8c449d66$var$ka.test(a)) return $60e412df8c449d66$var$ma[a] = !0;
    $60e412df8c449d66$var$la[a] = !0;
    return !1;
}
function $60e412df8c449d66$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $60e412df8c449d66$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $60e412df8c449d66$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $60e412df8c449d66$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $60e412df8c449d66$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $60e412df8c449d66$var$z[a] = new $60e412df8c449d66$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $60e412df8c449d66$var$z[b] = new $60e412df8c449d66$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $60e412df8c449d66$var$z[a] = new $60e412df8c449d66$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $60e412df8c449d66$var$z[a] = new $60e412df8c449d66$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $60e412df8c449d66$var$z[a] = new $60e412df8c449d66$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $60e412df8c449d66$var$z[a] = new $60e412df8c449d66$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $60e412df8c449d66$var$z[a] = new $60e412df8c449d66$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $60e412df8c449d66$var$z[a] = new $60e412df8c449d66$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $60e412df8c449d66$var$z[a] = new $60e412df8c449d66$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $60e412df8c449d66$var$ra = /[\-:]([a-z])/g;
function $60e412df8c449d66$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($60e412df8c449d66$var$ra, $60e412df8c449d66$var$sa);
    $60e412df8c449d66$var$z[b] = new $60e412df8c449d66$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($60e412df8c449d66$var$ra, $60e412df8c449d66$var$sa);
    $60e412df8c449d66$var$z[b] = new $60e412df8c449d66$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($60e412df8c449d66$var$ra, $60e412df8c449d66$var$sa);
    $60e412df8c449d66$var$z[b] = new $60e412df8c449d66$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $60e412df8c449d66$var$z[a] = new $60e412df8c449d66$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$60e412df8c449d66$var$z.xlinkHref = new $60e412df8c449d66$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $60e412df8c449d66$var$z[a] = new $60e412df8c449d66$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $60e412df8c449d66$var$ta(a, b, c, d) {
    var e = $60e412df8c449d66$var$z.hasOwnProperty(b) ? $60e412df8c449d66$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $60e412df8c449d66$var$qa(b, c, e, d) && (c = null), d || null === e ? $60e412df8c449d66$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $60e412df8c449d66$var$ua = $ieT14.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $60e412df8c449d66$var$va = Symbol.for("react.element"), $60e412df8c449d66$var$wa = Symbol.for("react.portal"), $60e412df8c449d66$var$ya = Symbol.for("react.fragment"), $60e412df8c449d66$var$za = Symbol.for("react.strict_mode"), $60e412df8c449d66$var$Aa = Symbol.for("react.profiler"), $60e412df8c449d66$var$Ba = Symbol.for("react.provider"), $60e412df8c449d66$var$Ca = Symbol.for("react.context"), $60e412df8c449d66$var$Da = Symbol.for("react.forward_ref"), $60e412df8c449d66$var$Ea = Symbol.for("react.suspense"), $60e412df8c449d66$var$Fa = Symbol.for("react.suspense_list"), $60e412df8c449d66$var$Ga = Symbol.for("react.memo"), $60e412df8c449d66$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $60e412df8c449d66$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $60e412df8c449d66$var$Ja = Symbol.iterator;
function $60e412df8c449d66$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $60e412df8c449d66$var$Ja && a[$60e412df8c449d66$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $60e412df8c449d66$var$A = Object.assign, $60e412df8c449d66$var$La;
function $60e412df8c449d66$var$Ma(a) {
    if (void 0 === $60e412df8c449d66$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $60e412df8c449d66$var$La = b && b[1] || "";
    }
    return "\n" + $60e412df8c449d66$var$La + a;
}
var $60e412df8c449d66$var$Na = !1;
function $60e412df8c449d66$var$Oa(a, b) {
    if (!a || $60e412df8c449d66$var$Na) return "";
    $60e412df8c449d66$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $60e412df8c449d66$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $60e412df8c449d66$var$Ma(a) : "";
}
function $60e412df8c449d66$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $60e412df8c449d66$var$Ma(a.type);
        case 16:
            return $60e412df8c449d66$var$Ma("Lazy");
        case 13:
            return $60e412df8c449d66$var$Ma("Suspense");
        case 19:
            return $60e412df8c449d66$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $60e412df8c449d66$var$Oa(a.type, !1), a;
        case 11:
            return a = $60e412df8c449d66$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $60e412df8c449d66$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $60e412df8c449d66$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $60e412df8c449d66$var$ya:
            return "Fragment";
        case $60e412df8c449d66$var$wa:
            return "Portal";
        case $60e412df8c449d66$var$Aa:
            return "Profiler";
        case $60e412df8c449d66$var$za:
            return "StrictMode";
        case $60e412df8c449d66$var$Ea:
            return "Suspense";
        case $60e412df8c449d66$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $60e412df8c449d66$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $60e412df8c449d66$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $60e412df8c449d66$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $60e412df8c449d66$var$Ga:
            return b = a.displayName || null, null !== b ? b : $60e412df8c449d66$var$Qa(a.type) || "Memo";
        case $60e412df8c449d66$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $60e412df8c449d66$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $60e412df8c449d66$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $60e412df8c449d66$var$Qa(b);
        case 8:
            return b === $60e412df8c449d66$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $60e412df8c449d66$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $60e412df8c449d66$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $60e412df8c449d66$var$Ua(a) {
    var b = $60e412df8c449d66$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $60e412df8c449d66$var$Va(a) {
    a._valueTracker || (a._valueTracker = $60e412df8c449d66$var$Ua(a));
}
function $60e412df8c449d66$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $60e412df8c449d66$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $60e412df8c449d66$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $60e412df8c449d66$var$Ya(a, b) {
    var c = b.checked;
    return $60e412df8c449d66$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $60e412df8c449d66$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $60e412df8c449d66$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $60e412df8c449d66$var$ab(a, b) {
    b = b.checked;
    null != b && $60e412df8c449d66$var$ta(a, "checked", b, !1);
}
function $60e412df8c449d66$var$bb(a, b) {
    $60e412df8c449d66$var$ab(a, b);
    var c = $60e412df8c449d66$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $60e412df8c449d66$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $60e412df8c449d66$var$cb(a, b.type, $60e412df8c449d66$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $60e412df8c449d66$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $60e412df8c449d66$var$cb(a, b, c) {
    if ("number" !== b || $60e412df8c449d66$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $60e412df8c449d66$var$eb = Array.isArray;
function $60e412df8c449d66$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $60e412df8c449d66$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $60e412df8c449d66$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($60e412df8c449d66$var$p(91));
    return $60e412df8c449d66$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $60e412df8c449d66$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($60e412df8c449d66$var$p(92));
            if ($60e412df8c449d66$var$eb(c)) {
                if (1 < c.length) throw Error($60e412df8c449d66$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $60e412df8c449d66$var$Sa(c)
    };
}
function $60e412df8c449d66$var$ib(a, b) {
    var c = $60e412df8c449d66$var$Sa(b.value), d = $60e412df8c449d66$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $60e412df8c449d66$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $60e412df8c449d66$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $60e412df8c449d66$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $60e412df8c449d66$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $60e412df8c449d66$var$mb, $60e412df8c449d66$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $60e412df8c449d66$var$mb = $60e412df8c449d66$var$mb || document.createElement("div");
        $60e412df8c449d66$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $60e412df8c449d66$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $60e412df8c449d66$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $60e412df8c449d66$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $60e412df8c449d66$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($60e412df8c449d66$var$pb).forEach(function(a) {
    $60e412df8c449d66$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $60e412df8c449d66$var$pb[b] = $60e412df8c449d66$var$pb[a];
    });
});
function $60e412df8c449d66$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $60e412df8c449d66$var$pb.hasOwnProperty(a) && $60e412df8c449d66$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $60e412df8c449d66$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $60e412df8c449d66$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $60e412df8c449d66$var$tb = $60e412df8c449d66$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $60e412df8c449d66$var$ub(a, b) {
    if (b) {
        if ($60e412df8c449d66$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($60e412df8c449d66$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($60e412df8c449d66$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($60e412df8c449d66$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($60e412df8c449d66$var$p(62));
    }
}
function $60e412df8c449d66$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $60e412df8c449d66$var$wb = null;
function $60e412df8c449d66$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $60e412df8c449d66$var$yb = null, $60e412df8c449d66$var$zb = null, $60e412df8c449d66$var$Ab = null;
function $60e412df8c449d66$var$Bb(a) {
    if (a = $60e412df8c449d66$var$Cb(a)) {
        if ("function" !== typeof $60e412df8c449d66$var$yb) throw Error($60e412df8c449d66$var$p(280));
        var b = a.stateNode;
        b && (b = $60e412df8c449d66$var$Db(b), $60e412df8c449d66$var$yb(a.stateNode, a.type, b));
    }
}
function $60e412df8c449d66$var$Eb(a) {
    $60e412df8c449d66$var$zb ? $60e412df8c449d66$var$Ab ? $60e412df8c449d66$var$Ab.push(a) : $60e412df8c449d66$var$Ab = [
        a
    ] : $60e412df8c449d66$var$zb = a;
}
function $60e412df8c449d66$var$Fb() {
    if ($60e412df8c449d66$var$zb) {
        var a = $60e412df8c449d66$var$zb, b = $60e412df8c449d66$var$Ab;
        $60e412df8c449d66$var$Ab = $60e412df8c449d66$var$zb = null;
        $60e412df8c449d66$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$60e412df8c449d66$var$Bb(b[a]);
    }
}
function $60e412df8c449d66$var$Gb(a, b) {
    return a(b);
}
function $60e412df8c449d66$var$Hb() {}
var $60e412df8c449d66$var$Ib = !1;
function $60e412df8c449d66$var$Jb(a, b, c) {
    if ($60e412df8c449d66$var$Ib) return a(b, c);
    $60e412df8c449d66$var$Ib = !0;
    try {
        return $60e412df8c449d66$var$Gb(a, b, c);
    } finally{
        if ($60e412df8c449d66$var$Ib = !1, null !== $60e412df8c449d66$var$zb || null !== $60e412df8c449d66$var$Ab) $60e412df8c449d66$var$Hb(), $60e412df8c449d66$var$Fb();
    }
}
function $60e412df8c449d66$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $60e412df8c449d66$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($60e412df8c449d66$var$p(231, b, typeof c));
    return c;
}
var $60e412df8c449d66$var$Lb = !1;
if ($60e412df8c449d66$var$ia) try {
    var $60e412df8c449d66$var$Mb = {};
    Object.defineProperty($60e412df8c449d66$var$Mb, "passive", {
        get: function() {
            $60e412df8c449d66$var$Lb = !0;
        }
    });
    window.addEventListener("test", $60e412df8c449d66$var$Mb, $60e412df8c449d66$var$Mb);
    window.removeEventListener("test", $60e412df8c449d66$var$Mb, $60e412df8c449d66$var$Mb);
} catch (a) {
    $60e412df8c449d66$var$Lb = !1;
}
function $60e412df8c449d66$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $60e412df8c449d66$var$Ob = !1, $60e412df8c449d66$var$Pb = null, $60e412df8c449d66$var$Qb = !1, $60e412df8c449d66$var$Rb = null, $60e412df8c449d66$var$Sb = {
    onError: function(a) {
        $60e412df8c449d66$var$Ob = !0;
        $60e412df8c449d66$var$Pb = a;
    }
};
function $60e412df8c449d66$var$Tb(a, b, c, d, e, f, g, h, k) {
    $60e412df8c449d66$var$Ob = !1;
    $60e412df8c449d66$var$Pb = null;
    $60e412df8c449d66$var$Nb.apply($60e412df8c449d66$var$Sb, arguments);
}
function $60e412df8c449d66$var$Ub(a, b, c, d, e, f, g, h, k) {
    $60e412df8c449d66$var$Tb.apply(this, arguments);
    if ($60e412df8c449d66$var$Ob) {
        if ($60e412df8c449d66$var$Ob) {
            var l = $60e412df8c449d66$var$Pb;
            $60e412df8c449d66$var$Ob = !1;
            $60e412df8c449d66$var$Pb = null;
        } else throw Error($60e412df8c449d66$var$p(198));
        $60e412df8c449d66$var$Qb || ($60e412df8c449d66$var$Qb = !0, $60e412df8c449d66$var$Rb = l);
    }
}
function $60e412df8c449d66$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $60e412df8c449d66$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $60e412df8c449d66$var$Xb(a) {
    if ($60e412df8c449d66$var$Vb(a) !== a) throw Error($60e412df8c449d66$var$p(188));
}
function $60e412df8c449d66$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $60e412df8c449d66$var$Vb(a);
        if (null === b) throw Error($60e412df8c449d66$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $60e412df8c449d66$var$Xb(e), a;
                if (f === d) return $60e412df8c449d66$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($60e412df8c449d66$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($60e412df8c449d66$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($60e412df8c449d66$var$p(190));
    }
    if (3 !== c.tag) throw Error($60e412df8c449d66$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $60e412df8c449d66$var$Zb(a) {
    a = $60e412df8c449d66$var$Yb(a);
    return null !== a ? $60e412df8c449d66$var$$b(a) : null;
}
function $60e412df8c449d66$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $60e412df8c449d66$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $60e412df8c449d66$var$ac = $7Vk7y.unstable_scheduleCallback, $60e412df8c449d66$var$bc = $7Vk7y.unstable_cancelCallback, $60e412df8c449d66$var$cc = $7Vk7y.unstable_shouldYield, $60e412df8c449d66$var$dc = $7Vk7y.unstable_requestPaint, $60e412df8c449d66$var$B = $7Vk7y.unstable_now, $60e412df8c449d66$var$ec = $7Vk7y.unstable_getCurrentPriorityLevel, $60e412df8c449d66$var$fc = $7Vk7y.unstable_ImmediatePriority, $60e412df8c449d66$var$gc = $7Vk7y.unstable_UserBlockingPriority, $60e412df8c449d66$var$hc = $7Vk7y.unstable_NormalPriority, $60e412df8c449d66$var$ic = $7Vk7y.unstable_LowPriority, $60e412df8c449d66$var$jc = $7Vk7y.unstable_IdlePriority, $60e412df8c449d66$var$kc = null, $60e412df8c449d66$var$lc = null;
function $60e412df8c449d66$var$mc(a) {
    if ($60e412df8c449d66$var$lc && "function" === typeof $60e412df8c449d66$var$lc.onCommitFiberRoot) try {
        $60e412df8c449d66$var$lc.onCommitFiberRoot($60e412df8c449d66$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $60e412df8c449d66$var$oc = Math.clz32 ? Math.clz32 : $60e412df8c449d66$var$nc, $60e412df8c449d66$var$pc = Math.log, $60e412df8c449d66$var$qc = Math.LN2;
function $60e412df8c449d66$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($60e412df8c449d66$var$pc(a) / $60e412df8c449d66$var$qc | 0) | 0;
}
var $60e412df8c449d66$var$rc = 64, $60e412df8c449d66$var$sc = 4194304;
function $60e412df8c449d66$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $60e412df8c449d66$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $60e412df8c449d66$var$tc(h) : (f &= g, 0 !== f && (d = $60e412df8c449d66$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $60e412df8c449d66$var$tc(g) : 0 !== f && (d = $60e412df8c449d66$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $60e412df8c449d66$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $60e412df8c449d66$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $60e412df8c449d66$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $60e412df8c449d66$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $60e412df8c449d66$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $60e412df8c449d66$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $60e412df8c449d66$var$yc() {
    var a = $60e412df8c449d66$var$rc;
    $60e412df8c449d66$var$rc <<= 1;
    0 === ($60e412df8c449d66$var$rc & 4194240) && ($60e412df8c449d66$var$rc = 64);
    return a;
}
function $60e412df8c449d66$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $60e412df8c449d66$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $60e412df8c449d66$var$oc(b);
    a[b] = c;
}
function $60e412df8c449d66$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $60e412df8c449d66$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $60e412df8c449d66$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $60e412df8c449d66$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $60e412df8c449d66$var$C = 0;
function $60e412df8c449d66$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $60e412df8c449d66$var$Ec, $60e412df8c449d66$var$Fc, $60e412df8c449d66$var$Gc, $60e412df8c449d66$var$Hc, $60e412df8c449d66$var$Ic, $60e412df8c449d66$var$Jc = !1, $60e412df8c449d66$var$Kc = [], $60e412df8c449d66$var$Lc = null, $60e412df8c449d66$var$Mc = null, $60e412df8c449d66$var$Nc = null, $60e412df8c449d66$var$Oc = new Map, $60e412df8c449d66$var$Pc = new Map, $60e412df8c449d66$var$Qc = [], $60e412df8c449d66$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $60e412df8c449d66$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $60e412df8c449d66$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $60e412df8c449d66$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $60e412df8c449d66$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $60e412df8c449d66$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $60e412df8c449d66$var$Pc.delete(b.pointerId);
    }
}
function $60e412df8c449d66$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $60e412df8c449d66$var$Cb(b), null !== b && $60e412df8c449d66$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $60e412df8c449d66$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $60e412df8c449d66$var$Lc = $60e412df8c449d66$var$Tc($60e412df8c449d66$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $60e412df8c449d66$var$Mc = $60e412df8c449d66$var$Tc($60e412df8c449d66$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $60e412df8c449d66$var$Nc = $60e412df8c449d66$var$Tc($60e412df8c449d66$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $60e412df8c449d66$var$Oc.set(f, $60e412df8c449d66$var$Tc($60e412df8c449d66$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $60e412df8c449d66$var$Pc.set(f, $60e412df8c449d66$var$Tc($60e412df8c449d66$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $60e412df8c449d66$var$Vc(a) {
    var b = $60e412df8c449d66$var$Wc(a.target);
    if (null !== b) {
        var c = $60e412df8c449d66$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $60e412df8c449d66$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $60e412df8c449d66$var$Ic(a.priority, function() {
                        $60e412df8c449d66$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $60e412df8c449d66$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $60e412df8c449d66$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $60e412df8c449d66$var$wb = d;
            c.target.dispatchEvent(d);
            $60e412df8c449d66$var$wb = null;
        } else return b = $60e412df8c449d66$var$Cb(c), null !== b && $60e412df8c449d66$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $60e412df8c449d66$var$Zc(a, b, c) {
    $60e412df8c449d66$var$Xc(a) && c.delete(b);
}
function $60e412df8c449d66$var$$c() {
    $60e412df8c449d66$var$Jc = !1;
    null !== $60e412df8c449d66$var$Lc && $60e412df8c449d66$var$Xc($60e412df8c449d66$var$Lc) && ($60e412df8c449d66$var$Lc = null);
    null !== $60e412df8c449d66$var$Mc && $60e412df8c449d66$var$Xc($60e412df8c449d66$var$Mc) && ($60e412df8c449d66$var$Mc = null);
    null !== $60e412df8c449d66$var$Nc && $60e412df8c449d66$var$Xc($60e412df8c449d66$var$Nc) && ($60e412df8c449d66$var$Nc = null);
    $60e412df8c449d66$var$Oc.forEach($60e412df8c449d66$var$Zc);
    $60e412df8c449d66$var$Pc.forEach($60e412df8c449d66$var$Zc);
}
function $60e412df8c449d66$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $60e412df8c449d66$var$Jc || ($60e412df8c449d66$var$Jc = !0, $7Vk7y.unstable_scheduleCallback($7Vk7y.unstable_NormalPriority, $60e412df8c449d66$var$$c)));
}
function $60e412df8c449d66$var$bd(a) {
    function b(b) {
        return $60e412df8c449d66$var$ad(b, a);
    }
    if (0 < $60e412df8c449d66$var$Kc.length) {
        $60e412df8c449d66$var$ad($60e412df8c449d66$var$Kc[0], a);
        for(var c = 1; c < $60e412df8c449d66$var$Kc.length; c++){
            var d = $60e412df8c449d66$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $60e412df8c449d66$var$Lc && $60e412df8c449d66$var$ad($60e412df8c449d66$var$Lc, a);
    null !== $60e412df8c449d66$var$Mc && $60e412df8c449d66$var$ad($60e412df8c449d66$var$Mc, a);
    null !== $60e412df8c449d66$var$Nc && $60e412df8c449d66$var$ad($60e412df8c449d66$var$Nc, a);
    $60e412df8c449d66$var$Oc.forEach(b);
    $60e412df8c449d66$var$Pc.forEach(b);
    for(c = 0; c < $60e412df8c449d66$var$Qc.length; c++)d = $60e412df8c449d66$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $60e412df8c449d66$var$Qc.length && (c = $60e412df8c449d66$var$Qc[0], null === c.blockedOn);)$60e412df8c449d66$var$Vc(c), null === c.blockedOn && $60e412df8c449d66$var$Qc.shift();
}
var $60e412df8c449d66$var$cd = $60e412df8c449d66$var$ua.ReactCurrentBatchConfig, $60e412df8c449d66$var$dd = !0;
function $60e412df8c449d66$var$ed(a, b, c, d) {
    var e = $60e412df8c449d66$var$C, f = $60e412df8c449d66$var$cd.transition;
    $60e412df8c449d66$var$cd.transition = null;
    try {
        $60e412df8c449d66$var$C = 1, $60e412df8c449d66$var$fd(a, b, c, d);
    } finally{
        $60e412df8c449d66$var$C = e, $60e412df8c449d66$var$cd.transition = f;
    }
}
function $60e412df8c449d66$var$gd(a, b, c, d) {
    var e = $60e412df8c449d66$var$C, f = $60e412df8c449d66$var$cd.transition;
    $60e412df8c449d66$var$cd.transition = null;
    try {
        $60e412df8c449d66$var$C = 4, $60e412df8c449d66$var$fd(a, b, c, d);
    } finally{
        $60e412df8c449d66$var$C = e, $60e412df8c449d66$var$cd.transition = f;
    }
}
function $60e412df8c449d66$var$fd(a, b, c, d) {
    if ($60e412df8c449d66$var$dd) {
        var e = $60e412df8c449d66$var$Yc(a, b, c, d);
        if (null === e) $60e412df8c449d66$var$hd(a, b, d, $60e412df8c449d66$var$id, c), $60e412df8c449d66$var$Sc(a, d);
        else if ($60e412df8c449d66$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($60e412df8c449d66$var$Sc(a, d), b & 4 && -1 < $60e412df8c449d66$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $60e412df8c449d66$var$Cb(e);
                null !== f && $60e412df8c449d66$var$Ec(f);
                f = $60e412df8c449d66$var$Yc(a, b, c, d);
                null === f && $60e412df8c449d66$var$hd(a, b, d, $60e412df8c449d66$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $60e412df8c449d66$var$hd(a, b, d, null, c);
    }
}
var $60e412df8c449d66$var$id = null;
function $60e412df8c449d66$var$Yc(a, b, c, d) {
    $60e412df8c449d66$var$id = null;
    a = $60e412df8c449d66$var$xb(d);
    a = $60e412df8c449d66$var$Wc(a);
    if (null !== a) {
        if (b = $60e412df8c449d66$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $60e412df8c449d66$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $60e412df8c449d66$var$id = a;
    return null;
}
function $60e412df8c449d66$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($60e412df8c449d66$var$ec()){
                case $60e412df8c449d66$var$fc:
                    return 1;
                case $60e412df8c449d66$var$gc:
                    return 4;
                case $60e412df8c449d66$var$hc:
                case $60e412df8c449d66$var$ic:
                    return 16;
                case $60e412df8c449d66$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $60e412df8c449d66$var$kd = null, $60e412df8c449d66$var$ld = null, $60e412df8c449d66$var$md = null;
function $60e412df8c449d66$var$nd() {
    if ($60e412df8c449d66$var$md) return $60e412df8c449d66$var$md;
    var a, b = $60e412df8c449d66$var$ld, c = b.length, d, e = "value" in $60e412df8c449d66$var$kd ? $60e412df8c449d66$var$kd.value : $60e412df8c449d66$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $60e412df8c449d66$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $60e412df8c449d66$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $60e412df8c449d66$var$pd() {
    return !0;
}
function $60e412df8c449d66$var$qd() {
    return !1;
}
function $60e412df8c449d66$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $60e412df8c449d66$var$pd : $60e412df8c449d66$var$qd;
        this.isPropagationStopped = $60e412df8c449d66$var$qd;
        return this;
    }
    $60e412df8c449d66$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $60e412df8c449d66$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $60e412df8c449d66$var$pd);
        },
        persist: function() {},
        isPersistent: $60e412df8c449d66$var$pd
    });
    return b;
}
var $60e412df8c449d66$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $60e412df8c449d66$var$td = $60e412df8c449d66$var$rd($60e412df8c449d66$var$sd), $60e412df8c449d66$var$ud = $60e412df8c449d66$var$A({}, $60e412df8c449d66$var$sd, {
    view: 0,
    detail: 0
}), $60e412df8c449d66$var$vd = $60e412df8c449d66$var$rd($60e412df8c449d66$var$ud), $60e412df8c449d66$var$wd, $60e412df8c449d66$var$xd, $60e412df8c449d66$var$yd, $60e412df8c449d66$var$Ad = $60e412df8c449d66$var$A({}, $60e412df8c449d66$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $60e412df8c449d66$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $60e412df8c449d66$var$yd && ($60e412df8c449d66$var$yd && "mousemove" === a.type ? ($60e412df8c449d66$var$wd = a.screenX - $60e412df8c449d66$var$yd.screenX, $60e412df8c449d66$var$xd = a.screenY - $60e412df8c449d66$var$yd.screenY) : $60e412df8c449d66$var$xd = $60e412df8c449d66$var$wd = 0, $60e412df8c449d66$var$yd = a);
        return $60e412df8c449d66$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $60e412df8c449d66$var$xd;
    }
}), $60e412df8c449d66$var$Bd = $60e412df8c449d66$var$rd($60e412df8c449d66$var$Ad), $60e412df8c449d66$var$Cd = $60e412df8c449d66$var$A({}, $60e412df8c449d66$var$Ad, {
    dataTransfer: 0
}), $60e412df8c449d66$var$Dd = $60e412df8c449d66$var$rd($60e412df8c449d66$var$Cd), $60e412df8c449d66$var$Ed = $60e412df8c449d66$var$A({}, $60e412df8c449d66$var$ud, {
    relatedTarget: 0
}), $60e412df8c449d66$var$Fd = $60e412df8c449d66$var$rd($60e412df8c449d66$var$Ed), $60e412df8c449d66$var$Gd = $60e412df8c449d66$var$A({}, $60e412df8c449d66$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $60e412df8c449d66$var$Hd = $60e412df8c449d66$var$rd($60e412df8c449d66$var$Gd), $60e412df8c449d66$var$Id = $60e412df8c449d66$var$A({}, $60e412df8c449d66$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $60e412df8c449d66$var$Jd = $60e412df8c449d66$var$rd($60e412df8c449d66$var$Id), $60e412df8c449d66$var$Kd = $60e412df8c449d66$var$A({}, $60e412df8c449d66$var$sd, {
    data: 0
}), $60e412df8c449d66$var$Ld = $60e412df8c449d66$var$rd($60e412df8c449d66$var$Kd), $60e412df8c449d66$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $60e412df8c449d66$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $60e412df8c449d66$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $60e412df8c449d66$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $60e412df8c449d66$var$Od[a]) ? !!b[a] : !1;
}
function $60e412df8c449d66$var$zd() {
    return $60e412df8c449d66$var$Pd;
}
var $60e412df8c449d66$var$Qd = $60e412df8c449d66$var$A({}, $60e412df8c449d66$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $60e412df8c449d66$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $60e412df8c449d66$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $60e412df8c449d66$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $60e412df8c449d66$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $60e412df8c449d66$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $60e412df8c449d66$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $60e412df8c449d66$var$Rd = $60e412df8c449d66$var$rd($60e412df8c449d66$var$Qd), $60e412df8c449d66$var$Sd = $60e412df8c449d66$var$A({}, $60e412df8c449d66$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $60e412df8c449d66$var$Td = $60e412df8c449d66$var$rd($60e412df8c449d66$var$Sd), $60e412df8c449d66$var$Ud = $60e412df8c449d66$var$A({}, $60e412df8c449d66$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $60e412df8c449d66$var$zd
}), $60e412df8c449d66$var$Vd = $60e412df8c449d66$var$rd($60e412df8c449d66$var$Ud), $60e412df8c449d66$var$Wd = $60e412df8c449d66$var$A({}, $60e412df8c449d66$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $60e412df8c449d66$var$Xd = $60e412df8c449d66$var$rd($60e412df8c449d66$var$Wd), $60e412df8c449d66$var$Yd = $60e412df8c449d66$var$A({}, $60e412df8c449d66$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $60e412df8c449d66$var$Zd = $60e412df8c449d66$var$rd($60e412df8c449d66$var$Yd), $60e412df8c449d66$var$$d = [
    9,
    13,
    27,
    32
], $60e412df8c449d66$var$ae = $60e412df8c449d66$var$ia && "CompositionEvent" in window, $60e412df8c449d66$var$be = null;
$60e412df8c449d66$var$ia && "documentMode" in document && ($60e412df8c449d66$var$be = document.documentMode);
var $60e412df8c449d66$var$ce = $60e412df8c449d66$var$ia && "TextEvent" in window && !$60e412df8c449d66$var$be, $60e412df8c449d66$var$de = $60e412df8c449d66$var$ia && (!$60e412df8c449d66$var$ae || $60e412df8c449d66$var$be && 8 < $60e412df8c449d66$var$be && 11 >= $60e412df8c449d66$var$be), $60e412df8c449d66$var$ee = String.fromCharCode(32), $60e412df8c449d66$var$fe = !1;
function $60e412df8c449d66$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $60e412df8c449d66$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $60e412df8c449d66$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $60e412df8c449d66$var$ie = !1;
function $60e412df8c449d66$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $60e412df8c449d66$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $60e412df8c449d66$var$fe = !0;
            return $60e412df8c449d66$var$ee;
        case "textInput":
            return a = b.data, a === $60e412df8c449d66$var$ee && $60e412df8c449d66$var$fe ? null : a;
        default:
            return null;
    }
}
function $60e412df8c449d66$var$ke(a, b) {
    if ($60e412df8c449d66$var$ie) return "compositionend" === a || !$60e412df8c449d66$var$ae && $60e412df8c449d66$var$ge(a, b) ? (a = $60e412df8c449d66$var$nd(), $60e412df8c449d66$var$md = $60e412df8c449d66$var$ld = $60e412df8c449d66$var$kd = null, $60e412df8c449d66$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $60e412df8c449d66$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $60e412df8c449d66$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $60e412df8c449d66$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$60e412df8c449d66$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $60e412df8c449d66$var$ne(a, b, c, d) {
    $60e412df8c449d66$var$Eb(d);
    b = $60e412df8c449d66$var$oe(b, "onChange");
    0 < b.length && (c = new $60e412df8c449d66$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $60e412df8c449d66$var$pe = null, $60e412df8c449d66$var$qe = null;
function $60e412df8c449d66$var$re(a) {
    $60e412df8c449d66$var$se(a, 0);
}
function $60e412df8c449d66$var$te(a) {
    var b = $60e412df8c449d66$var$ue(a);
    if ($60e412df8c449d66$var$Wa(b)) return a;
}
function $60e412df8c449d66$var$ve(a, b) {
    if ("change" === a) return b;
}
var $60e412df8c449d66$var$we = !1;
if ($60e412df8c449d66$var$ia) {
    var $60e412df8c449d66$var$xe;
    if ($60e412df8c449d66$var$ia) {
        var $60e412df8c449d66$var$ye = "oninput" in document;
        if (!$60e412df8c449d66$var$ye) {
            var $60e412df8c449d66$var$ze = document.createElement("div");
            $60e412df8c449d66$var$ze.setAttribute("oninput", "return;");
            $60e412df8c449d66$var$ye = "function" === typeof $60e412df8c449d66$var$ze.oninput;
        }
        $60e412df8c449d66$var$xe = $60e412df8c449d66$var$ye;
    } else $60e412df8c449d66$var$xe = !1;
    $60e412df8c449d66$var$we = $60e412df8c449d66$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $60e412df8c449d66$var$Ae() {
    $60e412df8c449d66$var$pe && ($60e412df8c449d66$var$pe.detachEvent("onpropertychange", $60e412df8c449d66$var$Be), $60e412df8c449d66$var$qe = $60e412df8c449d66$var$pe = null);
}
function $60e412df8c449d66$var$Be(a) {
    if ("value" === a.propertyName && $60e412df8c449d66$var$te($60e412df8c449d66$var$qe)) {
        var b = [];
        $60e412df8c449d66$var$ne(b, $60e412df8c449d66$var$qe, a, $60e412df8c449d66$var$xb(a));
        $60e412df8c449d66$var$Jb($60e412df8c449d66$var$re, b);
    }
}
function $60e412df8c449d66$var$Ce(a, b, c) {
    "focusin" === a ? ($60e412df8c449d66$var$Ae(), $60e412df8c449d66$var$pe = b, $60e412df8c449d66$var$qe = c, $60e412df8c449d66$var$pe.attachEvent("onpropertychange", $60e412df8c449d66$var$Be)) : "focusout" === a && $60e412df8c449d66$var$Ae();
}
function $60e412df8c449d66$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $60e412df8c449d66$var$te($60e412df8c449d66$var$qe);
}
function $60e412df8c449d66$var$Ee(a, b) {
    if ("click" === a) return $60e412df8c449d66$var$te(b);
}
function $60e412df8c449d66$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $60e412df8c449d66$var$te(b);
}
function $60e412df8c449d66$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $60e412df8c449d66$var$He = "function" === typeof Object.is ? Object.is : $60e412df8c449d66$var$Ge;
function $60e412df8c449d66$var$Ie(a, b) {
    if ($60e412df8c449d66$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$60e412df8c449d66$var$ja.call(b, e) || !$60e412df8c449d66$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $60e412df8c449d66$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $60e412df8c449d66$var$Ke(a, b) {
    var c = $60e412df8c449d66$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $60e412df8c449d66$var$Je(c);
    }
}
function $60e412df8c449d66$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $60e412df8c449d66$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $60e412df8c449d66$var$Me() {
    for(var a = window, b = $60e412df8c449d66$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $60e412df8c449d66$var$Xa(a.document);
    }
    return b;
}
function $60e412df8c449d66$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $60e412df8c449d66$var$Oe(a) {
    var b = $60e412df8c449d66$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $60e412df8c449d66$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $60e412df8c449d66$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $60e412df8c449d66$var$Ke(c, f);
                var g = $60e412df8c449d66$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $60e412df8c449d66$var$Pe = $60e412df8c449d66$var$ia && "documentMode" in document && 11 >= document.documentMode, $60e412df8c449d66$var$Qe = null, $60e412df8c449d66$var$Re = null, $60e412df8c449d66$var$Se = null, $60e412df8c449d66$var$Te = !1;
function $60e412df8c449d66$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $60e412df8c449d66$var$Te || null == $60e412df8c449d66$var$Qe || $60e412df8c449d66$var$Qe !== $60e412df8c449d66$var$Xa(d) || (d = $60e412df8c449d66$var$Qe, "selectionStart" in d && $60e412df8c449d66$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $60e412df8c449d66$var$Se && $60e412df8c449d66$var$Ie($60e412df8c449d66$var$Se, d) || ($60e412df8c449d66$var$Se = d, d = $60e412df8c449d66$var$oe($60e412df8c449d66$var$Re, "onSelect"), 0 < d.length && (b = new $60e412df8c449d66$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $60e412df8c449d66$var$Qe)));
}
function $60e412df8c449d66$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $60e412df8c449d66$var$We = {
    animationend: $60e412df8c449d66$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $60e412df8c449d66$var$Ve("Animation", "AnimationIteration"),
    animationstart: $60e412df8c449d66$var$Ve("Animation", "AnimationStart"),
    transitionend: $60e412df8c449d66$var$Ve("Transition", "TransitionEnd")
}, $60e412df8c449d66$var$Xe = {}, $60e412df8c449d66$var$Ye = {};
$60e412df8c449d66$var$ia && ($60e412df8c449d66$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $60e412df8c449d66$var$We.animationend.animation, delete $60e412df8c449d66$var$We.animationiteration.animation, delete $60e412df8c449d66$var$We.animationstart.animation), "TransitionEvent" in window || delete $60e412df8c449d66$var$We.transitionend.transition);
function $60e412df8c449d66$var$Ze(a) {
    if ($60e412df8c449d66$var$Xe[a]) return $60e412df8c449d66$var$Xe[a];
    if (!$60e412df8c449d66$var$We[a]) return a;
    var b = $60e412df8c449d66$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $60e412df8c449d66$var$Ye) return $60e412df8c449d66$var$Xe[a] = b[c];
    return a;
}
var $60e412df8c449d66$var$$e = $60e412df8c449d66$var$Ze("animationend"), $60e412df8c449d66$var$af = $60e412df8c449d66$var$Ze("animationiteration"), $60e412df8c449d66$var$bf = $60e412df8c449d66$var$Ze("animationstart"), $60e412df8c449d66$var$cf = $60e412df8c449d66$var$Ze("transitionend"), $60e412df8c449d66$var$df = new Map, $60e412df8c449d66$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $60e412df8c449d66$var$ff(a, b) {
    $60e412df8c449d66$var$df.set(a, b);
    $60e412df8c449d66$var$fa(b, [
        a
    ]);
}
for(var $60e412df8c449d66$var$gf = 0; $60e412df8c449d66$var$gf < $60e412df8c449d66$var$ef.length; $60e412df8c449d66$var$gf++){
    var $60e412df8c449d66$var$hf = $60e412df8c449d66$var$ef[$60e412df8c449d66$var$gf], $60e412df8c449d66$var$jf = $60e412df8c449d66$var$hf.toLowerCase(), $60e412df8c449d66$var$kf = $60e412df8c449d66$var$hf[0].toUpperCase() + $60e412df8c449d66$var$hf.slice(1);
    $60e412df8c449d66$var$ff($60e412df8c449d66$var$jf, "on" + $60e412df8c449d66$var$kf);
}
$60e412df8c449d66$var$ff($60e412df8c449d66$var$$e, "onAnimationEnd");
$60e412df8c449d66$var$ff($60e412df8c449d66$var$af, "onAnimationIteration");
$60e412df8c449d66$var$ff($60e412df8c449d66$var$bf, "onAnimationStart");
$60e412df8c449d66$var$ff("dblclick", "onDoubleClick");
$60e412df8c449d66$var$ff("focusin", "onFocus");
$60e412df8c449d66$var$ff("focusout", "onBlur");
$60e412df8c449d66$var$ff($60e412df8c449d66$var$cf, "onTransitionEnd");
$60e412df8c449d66$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$60e412df8c449d66$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$60e412df8c449d66$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$60e412df8c449d66$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$60e412df8c449d66$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$60e412df8c449d66$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$60e412df8c449d66$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$60e412df8c449d66$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$60e412df8c449d66$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$60e412df8c449d66$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $60e412df8c449d66$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $60e412df8c449d66$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($60e412df8c449d66$var$lf));
function $60e412df8c449d66$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $60e412df8c449d66$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $60e412df8c449d66$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $60e412df8c449d66$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $60e412df8c449d66$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($60e412df8c449d66$var$Qb) throw a = $60e412df8c449d66$var$Rb, $60e412df8c449d66$var$Qb = !1, $60e412df8c449d66$var$Rb = null, a;
}
function $60e412df8c449d66$var$D(a, b) {
    var c = b[$60e412df8c449d66$var$of];
    void 0 === c && (c = b[$60e412df8c449d66$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($60e412df8c449d66$var$pf(b, a, 2, !1), c.add(d));
}
function $60e412df8c449d66$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $60e412df8c449d66$var$pf(c, a, d, b);
}
var $60e412df8c449d66$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $60e412df8c449d66$var$sf(a) {
    if (!a[$60e412df8c449d66$var$rf]) {
        a[$60e412df8c449d66$var$rf] = !0;
        $60e412df8c449d66$var$da.forEach(function(b) {
            "selectionchange" !== b && ($60e412df8c449d66$var$mf.has(b) || $60e412df8c449d66$var$qf(b, !1, a), $60e412df8c449d66$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$60e412df8c449d66$var$rf] || (b[$60e412df8c449d66$var$rf] = !0, $60e412df8c449d66$var$qf("selectionchange", !1, b));
    }
}
function $60e412df8c449d66$var$pf(a, b, c, d) {
    switch($60e412df8c449d66$var$jd(b)){
        case 1:
            var e = $60e412df8c449d66$var$ed;
            break;
        case 4:
            e = $60e412df8c449d66$var$gd;
            break;
        default:
            e = $60e412df8c449d66$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$60e412df8c449d66$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $60e412df8c449d66$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $60e412df8c449d66$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $60e412df8c449d66$var$Jb(function() {
        var d = f, e = $60e412df8c449d66$var$xb(c), g = [];
        a: {
            var h = $60e412df8c449d66$var$df.get(a);
            if (void 0 !== h) {
                var k = $60e412df8c449d66$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $60e412df8c449d66$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $60e412df8c449d66$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $60e412df8c449d66$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $60e412df8c449d66$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $60e412df8c449d66$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $60e412df8c449d66$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $60e412df8c449d66$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $60e412df8c449d66$var$Vd;
                        break;
                    case $60e412df8c449d66$var$$e:
                    case $60e412df8c449d66$var$af:
                    case $60e412df8c449d66$var$bf:
                        k = $60e412df8c449d66$var$Hd;
                        break;
                    case $60e412df8c449d66$var$cf:
                        k = $60e412df8c449d66$var$Xd;
                        break;
                    case "scroll":
                        k = $60e412df8c449d66$var$vd;
                        break;
                    case "wheel":
                        k = $60e412df8c449d66$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $60e412df8c449d66$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $60e412df8c449d66$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $60e412df8c449d66$var$Kb(w, x), null != F && t.push($60e412df8c449d66$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $60e412df8c449d66$var$wb && (n = c.relatedTarget || c.fromElement) && ($60e412df8c449d66$var$Wc(n) || n[$60e412df8c449d66$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $60e412df8c449d66$var$Wc(n) : null, null !== n && (J = $60e412df8c449d66$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $60e412df8c449d66$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $60e412df8c449d66$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $60e412df8c449d66$var$ue(k);
                        u = null == n ? h : $60e412df8c449d66$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $60e412df8c449d66$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $60e412df8c449d66$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $60e412df8c449d66$var$vf(F))u++;
                            for(; 0 < w - u;)t = $60e412df8c449d66$var$vf(t), w--;
                            for(; 0 < u - w;)x = $60e412df8c449d66$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $60e412df8c449d66$var$vf(t);
                                x = $60e412df8c449d66$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $60e412df8c449d66$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $60e412df8c449d66$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $60e412df8c449d66$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $60e412df8c449d66$var$ve;
                else if ($60e412df8c449d66$var$me(h)) {
                    if ($60e412df8c449d66$var$we) na = $60e412df8c449d66$var$Fe;
                    else {
                        na = $60e412df8c449d66$var$De;
                        var xa = $60e412df8c449d66$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $60e412df8c449d66$var$Ee);
                if (na && (na = na(a, d))) {
                    $60e412df8c449d66$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $60e412df8c449d66$var$cb(h, "number", h.value);
            }
            xa = d ? $60e412df8c449d66$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($60e412df8c449d66$var$me(xa) || "true" === xa.contentEditable) $60e412df8c449d66$var$Qe = xa, $60e412df8c449d66$var$Re = d, $60e412df8c449d66$var$Se = null;
                    break;
                case "focusout":
                    $60e412df8c449d66$var$Se = $60e412df8c449d66$var$Re = $60e412df8c449d66$var$Qe = null;
                    break;
                case "mousedown":
                    $60e412df8c449d66$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $60e412df8c449d66$var$Te = !1;
                    $60e412df8c449d66$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($60e412df8c449d66$var$Pe) break;
                case "keydown":
                case "keyup":
                    $60e412df8c449d66$var$Ue(g, c, e);
            }
            var $a;
            if ($60e412df8c449d66$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $60e412df8c449d66$var$ie ? $60e412df8c449d66$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($60e412df8c449d66$var$de && "ko" !== c.locale && ($60e412df8c449d66$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $60e412df8c449d66$var$ie && ($a = $60e412df8c449d66$var$nd()) : ($60e412df8c449d66$var$kd = e, $60e412df8c449d66$var$ld = "value" in $60e412df8c449d66$var$kd ? $60e412df8c449d66$var$kd.value : $60e412df8c449d66$var$kd.textContent, $60e412df8c449d66$var$ie = !0)), xa = $60e412df8c449d66$var$oe(d, ba), 0 < xa.length && (ba = new $60e412df8c449d66$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $60e412df8c449d66$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $60e412df8c449d66$var$ce ? $60e412df8c449d66$var$je(a, c) : $60e412df8c449d66$var$ke(a, c)) d = $60e412df8c449d66$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $60e412df8c449d66$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $60e412df8c449d66$var$se(g, b);
    });
}
function $60e412df8c449d66$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $60e412df8c449d66$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $60e412df8c449d66$var$Kb(a, c), null != f && d.unshift($60e412df8c449d66$var$tf(a, f, e)), f = $60e412df8c449d66$var$Kb(a, b), null != f && d.push($60e412df8c449d66$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $60e412df8c449d66$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $60e412df8c449d66$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $60e412df8c449d66$var$Kb(c, f), null != k && g.unshift($60e412df8c449d66$var$tf(c, k, h))) : e || (k = $60e412df8c449d66$var$Kb(c, f), null != k && g.push($60e412df8c449d66$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $60e412df8c449d66$var$xf = /\r\n?/g, $60e412df8c449d66$var$yf = /\u0000|\uFFFD/g;
function $60e412df8c449d66$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($60e412df8c449d66$var$xf, "\n").replace($60e412df8c449d66$var$yf, "");
}
function $60e412df8c449d66$var$Af(a, b, c) {
    b = $60e412df8c449d66$var$zf(b);
    if ($60e412df8c449d66$var$zf(a) !== b && c) throw Error($60e412df8c449d66$var$p(425));
}
function $60e412df8c449d66$var$Bf() {}
var $60e412df8c449d66$var$Cf = null, $60e412df8c449d66$var$Df = null;
function $60e412df8c449d66$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $60e412df8c449d66$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $60e412df8c449d66$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $60e412df8c449d66$var$Hf = "function" === typeof Promise ? Promise : void 0, $60e412df8c449d66$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $60e412df8c449d66$var$Hf ? function(a) {
    return $60e412df8c449d66$var$Hf.resolve(null).then(a).catch($60e412df8c449d66$var$If);
} : $60e412df8c449d66$var$Ff;
function $60e412df8c449d66$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $60e412df8c449d66$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $60e412df8c449d66$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $60e412df8c449d66$var$bd(b);
}
function $60e412df8c449d66$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $60e412df8c449d66$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $60e412df8c449d66$var$Nf = Math.random().toString(36).slice(2), $60e412df8c449d66$var$Of = "__reactFiber$" + $60e412df8c449d66$var$Nf, $60e412df8c449d66$var$Pf = "__reactProps$" + $60e412df8c449d66$var$Nf, $60e412df8c449d66$var$uf = "__reactContainer$" + $60e412df8c449d66$var$Nf, $60e412df8c449d66$var$of = "__reactEvents$" + $60e412df8c449d66$var$Nf, $60e412df8c449d66$var$Qf = "__reactListeners$" + $60e412df8c449d66$var$Nf, $60e412df8c449d66$var$Rf = "__reactHandles$" + $60e412df8c449d66$var$Nf;
function $60e412df8c449d66$var$Wc(a) {
    var b = a[$60e412df8c449d66$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$60e412df8c449d66$var$uf] || c[$60e412df8c449d66$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $60e412df8c449d66$var$Mf(a); null !== a;){
                if (c = a[$60e412df8c449d66$var$Of]) return c;
                a = $60e412df8c449d66$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $60e412df8c449d66$var$Cb(a) {
    a = a[$60e412df8c449d66$var$Of] || a[$60e412df8c449d66$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $60e412df8c449d66$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($60e412df8c449d66$var$p(33));
}
function $60e412df8c449d66$var$Db(a) {
    return a[$60e412df8c449d66$var$Pf] || null;
}
var $60e412df8c449d66$var$Sf = [], $60e412df8c449d66$var$Tf = -1;
function $60e412df8c449d66$var$Uf(a) {
    return {
        current: a
    };
}
function $60e412df8c449d66$var$E(a) {
    0 > $60e412df8c449d66$var$Tf || (a.current = $60e412df8c449d66$var$Sf[$60e412df8c449d66$var$Tf], $60e412df8c449d66$var$Sf[$60e412df8c449d66$var$Tf] = null, $60e412df8c449d66$var$Tf--);
}
function $60e412df8c449d66$var$G(a, b) {
    $60e412df8c449d66$var$Tf++;
    $60e412df8c449d66$var$Sf[$60e412df8c449d66$var$Tf] = a.current;
    a.current = b;
}
var $60e412df8c449d66$var$Vf = {}, $60e412df8c449d66$var$H = $60e412df8c449d66$var$Uf($60e412df8c449d66$var$Vf), $60e412df8c449d66$var$Wf = $60e412df8c449d66$var$Uf(!1), $60e412df8c449d66$var$Xf = $60e412df8c449d66$var$Vf;
function $60e412df8c449d66$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $60e412df8c449d66$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $60e412df8c449d66$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $60e412df8c449d66$var$$f() {
    $60e412df8c449d66$var$E($60e412df8c449d66$var$Wf);
    $60e412df8c449d66$var$E($60e412df8c449d66$var$H);
}
function $60e412df8c449d66$var$ag(a, b, c) {
    if ($60e412df8c449d66$var$H.current !== $60e412df8c449d66$var$Vf) throw Error($60e412df8c449d66$var$p(168));
    $60e412df8c449d66$var$G($60e412df8c449d66$var$H, b);
    $60e412df8c449d66$var$G($60e412df8c449d66$var$Wf, c);
}
function $60e412df8c449d66$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($60e412df8c449d66$var$p(108, $60e412df8c449d66$var$Ra(a) || "Unknown", e));
    return $60e412df8c449d66$var$A({}, c, d);
}
function $60e412df8c449d66$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $60e412df8c449d66$var$Vf;
    $60e412df8c449d66$var$Xf = $60e412df8c449d66$var$H.current;
    $60e412df8c449d66$var$G($60e412df8c449d66$var$H, a);
    $60e412df8c449d66$var$G($60e412df8c449d66$var$Wf, $60e412df8c449d66$var$Wf.current);
    return !0;
}
function $60e412df8c449d66$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($60e412df8c449d66$var$p(169));
    c ? (a = $60e412df8c449d66$var$bg(a, b, $60e412df8c449d66$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $60e412df8c449d66$var$E($60e412df8c449d66$var$Wf), $60e412df8c449d66$var$E($60e412df8c449d66$var$H), $60e412df8c449d66$var$G($60e412df8c449d66$var$H, a)) : $60e412df8c449d66$var$E($60e412df8c449d66$var$Wf);
    $60e412df8c449d66$var$G($60e412df8c449d66$var$Wf, c);
}
var $60e412df8c449d66$var$eg = null, $60e412df8c449d66$var$fg = !1, $60e412df8c449d66$var$gg = !1;
function $60e412df8c449d66$var$hg(a) {
    null === $60e412df8c449d66$var$eg ? $60e412df8c449d66$var$eg = [
        a
    ] : $60e412df8c449d66$var$eg.push(a);
}
function $60e412df8c449d66$var$ig(a) {
    $60e412df8c449d66$var$fg = !0;
    $60e412df8c449d66$var$hg(a);
}
function $60e412df8c449d66$var$jg() {
    if (!$60e412df8c449d66$var$gg && null !== $60e412df8c449d66$var$eg) {
        $60e412df8c449d66$var$gg = !0;
        var a = 0, b = $60e412df8c449d66$var$C;
        try {
            var c = $60e412df8c449d66$var$eg;
            for($60e412df8c449d66$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $60e412df8c449d66$var$eg = null;
            $60e412df8c449d66$var$fg = !1;
        } catch (e) {
            throw null !== $60e412df8c449d66$var$eg && ($60e412df8c449d66$var$eg = $60e412df8c449d66$var$eg.slice(a + 1)), $60e412df8c449d66$var$ac($60e412df8c449d66$var$fc, $60e412df8c449d66$var$jg), e;
        } finally{
            $60e412df8c449d66$var$C = b, $60e412df8c449d66$var$gg = !1;
        }
    }
    return null;
}
var $60e412df8c449d66$var$kg = [], $60e412df8c449d66$var$lg = 0, $60e412df8c449d66$var$mg = null, $60e412df8c449d66$var$ng = 0, $60e412df8c449d66$var$og = [], $60e412df8c449d66$var$pg = 0, $60e412df8c449d66$var$qg = null, $60e412df8c449d66$var$rg = 1, $60e412df8c449d66$var$sg = "";
function $60e412df8c449d66$var$tg(a, b) {
    $60e412df8c449d66$var$kg[$60e412df8c449d66$var$lg++] = $60e412df8c449d66$var$ng;
    $60e412df8c449d66$var$kg[$60e412df8c449d66$var$lg++] = $60e412df8c449d66$var$mg;
    $60e412df8c449d66$var$mg = a;
    $60e412df8c449d66$var$ng = b;
}
function $60e412df8c449d66$var$ug(a, b, c) {
    $60e412df8c449d66$var$og[$60e412df8c449d66$var$pg++] = $60e412df8c449d66$var$rg;
    $60e412df8c449d66$var$og[$60e412df8c449d66$var$pg++] = $60e412df8c449d66$var$sg;
    $60e412df8c449d66$var$og[$60e412df8c449d66$var$pg++] = $60e412df8c449d66$var$qg;
    $60e412df8c449d66$var$qg = a;
    var d = $60e412df8c449d66$var$rg;
    a = $60e412df8c449d66$var$sg;
    var e = 32 - $60e412df8c449d66$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $60e412df8c449d66$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $60e412df8c449d66$var$rg = 1 << 32 - $60e412df8c449d66$var$oc(b) + e | c << e | d;
        $60e412df8c449d66$var$sg = f + a;
    } else $60e412df8c449d66$var$rg = 1 << f | c << e | d, $60e412df8c449d66$var$sg = a;
}
function $60e412df8c449d66$var$vg(a) {
    null !== a.return && ($60e412df8c449d66$var$tg(a, 1), $60e412df8c449d66$var$ug(a, 1, 0));
}
function $60e412df8c449d66$var$wg(a) {
    for(; a === $60e412df8c449d66$var$mg;)$60e412df8c449d66$var$mg = $60e412df8c449d66$var$kg[--$60e412df8c449d66$var$lg], $60e412df8c449d66$var$kg[$60e412df8c449d66$var$lg] = null, $60e412df8c449d66$var$ng = $60e412df8c449d66$var$kg[--$60e412df8c449d66$var$lg], $60e412df8c449d66$var$kg[$60e412df8c449d66$var$lg] = null;
    for(; a === $60e412df8c449d66$var$qg;)$60e412df8c449d66$var$qg = $60e412df8c449d66$var$og[--$60e412df8c449d66$var$pg], $60e412df8c449d66$var$og[$60e412df8c449d66$var$pg] = null, $60e412df8c449d66$var$sg = $60e412df8c449d66$var$og[--$60e412df8c449d66$var$pg], $60e412df8c449d66$var$og[$60e412df8c449d66$var$pg] = null, $60e412df8c449d66$var$rg = $60e412df8c449d66$var$og[--$60e412df8c449d66$var$pg], $60e412df8c449d66$var$og[$60e412df8c449d66$var$pg] = null;
}
var $60e412df8c449d66$var$xg = null, $60e412df8c449d66$var$yg = null, $60e412df8c449d66$var$I = !1, $60e412df8c449d66$var$zg = null;
function $60e412df8c449d66$var$Ag(a, b) {
    var c = $60e412df8c449d66$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $60e412df8c449d66$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $60e412df8c449d66$var$xg = a, $60e412df8c449d66$var$yg = $60e412df8c449d66$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $60e412df8c449d66$var$xg = a, $60e412df8c449d66$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $60e412df8c449d66$var$qg ? {
                id: $60e412df8c449d66$var$rg,
                overflow: $60e412df8c449d66$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $60e412df8c449d66$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $60e412df8c449d66$var$xg = a, $60e412df8c449d66$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $60e412df8c449d66$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $60e412df8c449d66$var$Eg(a) {
    if ($60e412df8c449d66$var$I) {
        var b = $60e412df8c449d66$var$yg;
        if (b) {
            var c = b;
            if (!$60e412df8c449d66$var$Cg(a, b)) {
                if ($60e412df8c449d66$var$Dg(a)) throw Error($60e412df8c449d66$var$p(418));
                b = $60e412df8c449d66$var$Lf(c.nextSibling);
                var d = $60e412df8c449d66$var$xg;
                b && $60e412df8c449d66$var$Cg(a, b) ? $60e412df8c449d66$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $60e412df8c449d66$var$I = !1, $60e412df8c449d66$var$xg = a);
            }
        } else {
            if ($60e412df8c449d66$var$Dg(a)) throw Error($60e412df8c449d66$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $60e412df8c449d66$var$I = !1;
            $60e412df8c449d66$var$xg = a;
        }
    }
}
function $60e412df8c449d66$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $60e412df8c449d66$var$xg = a;
}
function $60e412df8c449d66$var$Gg(a) {
    if (a !== $60e412df8c449d66$var$xg) return !1;
    if (!$60e412df8c449d66$var$I) return $60e412df8c449d66$var$Fg(a), $60e412df8c449d66$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$60e412df8c449d66$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $60e412df8c449d66$var$yg)) {
        if ($60e412df8c449d66$var$Dg(a)) throw $60e412df8c449d66$var$Hg(), Error($60e412df8c449d66$var$p(418));
        for(; b;)$60e412df8c449d66$var$Ag(a, b), b = $60e412df8c449d66$var$Lf(b.nextSibling);
    }
    $60e412df8c449d66$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($60e412df8c449d66$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $60e412df8c449d66$var$yg = $60e412df8c449d66$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $60e412df8c449d66$var$yg = null;
        }
    } else $60e412df8c449d66$var$yg = $60e412df8c449d66$var$xg ? $60e412df8c449d66$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $60e412df8c449d66$var$Hg() {
    for(var a = $60e412df8c449d66$var$yg; a;)a = $60e412df8c449d66$var$Lf(a.nextSibling);
}
function $60e412df8c449d66$var$Ig() {
    $60e412df8c449d66$var$yg = $60e412df8c449d66$var$xg = null;
    $60e412df8c449d66$var$I = !1;
}
function $60e412df8c449d66$var$Jg(a) {
    null === $60e412df8c449d66$var$zg ? $60e412df8c449d66$var$zg = [
        a
    ] : $60e412df8c449d66$var$zg.push(a);
}
var $60e412df8c449d66$var$Kg = $60e412df8c449d66$var$ua.ReactCurrentBatchConfig;
function $60e412df8c449d66$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($60e412df8c449d66$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($60e412df8c449d66$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($60e412df8c449d66$var$p(284));
        if (!c._owner) throw Error($60e412df8c449d66$var$p(290, a));
    }
    return a;
}
function $60e412df8c449d66$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($60e412df8c449d66$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $60e412df8c449d66$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $60e412df8c449d66$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $60e412df8c449d66$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $60e412df8c449d66$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $60e412df8c449d66$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $60e412df8c449d66$var$Ha && $60e412df8c449d66$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $60e412df8c449d66$var$Lg(a, b, c), d.return = a, d;
        d = $60e412df8c449d66$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $60e412df8c449d66$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $60e412df8c449d66$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $60e412df8c449d66$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $60e412df8c449d66$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $60e412df8c449d66$var$va:
                    return c = $60e412df8c449d66$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $60e412df8c449d66$var$Lg(a, null, b), c.return = a, c;
                case $60e412df8c449d66$var$wa:
                    return b = $60e412df8c449d66$var$Sg(b, a.mode, c), b.return = a, b;
                case $60e412df8c449d66$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($60e412df8c449d66$var$eb(b) || $60e412df8c449d66$var$Ka(b)) return b = $60e412df8c449d66$var$Tg(b, a.mode, c, null), b.return = a, b;
            $60e412df8c449d66$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $60e412df8c449d66$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $60e412df8c449d66$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $60e412df8c449d66$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($60e412df8c449d66$var$eb(c) || $60e412df8c449d66$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $60e412df8c449d66$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $60e412df8c449d66$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $60e412df8c449d66$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $60e412df8c449d66$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($60e412df8c449d66$var$eb(d) || $60e412df8c449d66$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $60e412df8c449d66$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $60e412df8c449d66$var$I && $60e412df8c449d66$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $60e412df8c449d66$var$I && $60e412df8c449d66$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $60e412df8c449d66$var$I && $60e412df8c449d66$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $60e412df8c449d66$var$Ka(h);
        if ("function" !== typeof l) throw Error($60e412df8c449d66$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($60e412df8c449d66$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $60e412df8c449d66$var$I && $60e412df8c449d66$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $60e412df8c449d66$var$I && $60e412df8c449d66$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $60e412df8c449d66$var$I && $60e412df8c449d66$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $60e412df8c449d66$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $60e412df8c449d66$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $60e412df8c449d66$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $60e412df8c449d66$var$Ha && $60e412df8c449d66$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $60e412df8c449d66$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $60e412df8c449d66$var$ya ? (d = $60e412df8c449d66$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $60e412df8c449d66$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $60e412df8c449d66$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $60e412df8c449d66$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $60e412df8c449d66$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $60e412df8c449d66$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($60e412df8c449d66$var$eb(f)) return n(a, d, f, h);
            if ($60e412df8c449d66$var$Ka(f)) return t(a, d, f, h);
            $60e412df8c449d66$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $60e412df8c449d66$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $60e412df8c449d66$var$Ug = $60e412df8c449d66$var$Og(!0), $60e412df8c449d66$var$Vg = $60e412df8c449d66$var$Og(!1), $60e412df8c449d66$var$Wg = $60e412df8c449d66$var$Uf(null), $60e412df8c449d66$var$Xg = null, $60e412df8c449d66$var$Yg = null, $60e412df8c449d66$var$Zg = null;
function $60e412df8c449d66$var$$g() {
    $60e412df8c449d66$var$Zg = $60e412df8c449d66$var$Yg = $60e412df8c449d66$var$Xg = null;
}
function $60e412df8c449d66$var$ah(a) {
    var b = $60e412df8c449d66$var$Wg.current;
    $60e412df8c449d66$var$E($60e412df8c449d66$var$Wg);
    a._currentValue = b;
}
function $60e412df8c449d66$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $60e412df8c449d66$var$ch(a, b) {
    $60e412df8c449d66$var$Xg = a;
    $60e412df8c449d66$var$Zg = $60e412df8c449d66$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($60e412df8c449d66$var$dh = !0), a.firstContext = null);
}
function $60e412df8c449d66$var$eh(a) {
    var b = a._currentValue;
    if ($60e412df8c449d66$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $60e412df8c449d66$var$Yg) {
            if (null === $60e412df8c449d66$var$Xg) throw Error($60e412df8c449d66$var$p(308));
            $60e412df8c449d66$var$Yg = a;
            $60e412df8c449d66$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $60e412df8c449d66$var$Yg = $60e412df8c449d66$var$Yg.next = a;
    }
    return b;
}
var $60e412df8c449d66$var$fh = null;
function $60e412df8c449d66$var$gh(a) {
    null === $60e412df8c449d66$var$fh ? $60e412df8c449d66$var$fh = [
        a
    ] : $60e412df8c449d66$var$fh.push(a);
}
function $60e412df8c449d66$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $60e412df8c449d66$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $60e412df8c449d66$var$ih(a, d);
}
function $60e412df8c449d66$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $60e412df8c449d66$var$jh = !1;
function $60e412df8c449d66$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $60e412df8c449d66$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $60e412df8c449d66$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $60e412df8c449d66$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($60e412df8c449d66$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $60e412df8c449d66$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $60e412df8c449d66$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $60e412df8c449d66$var$ih(a, c);
}
function $60e412df8c449d66$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $60e412df8c449d66$var$Cc(a, c);
    }
}
function $60e412df8c449d66$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $60e412df8c449d66$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $60e412df8c449d66$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $60e412df8c449d66$var$A({}, q, r);
                            break a;
                        case 2:
                            $60e412df8c449d66$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $60e412df8c449d66$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $60e412df8c449d66$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($60e412df8c449d66$var$p(191, e));
            e.call(d);
        }
    }
}
var $60e412df8c449d66$var$th = {}, $60e412df8c449d66$var$uh = $60e412df8c449d66$var$Uf($60e412df8c449d66$var$th), $60e412df8c449d66$var$vh = $60e412df8c449d66$var$Uf($60e412df8c449d66$var$th), $60e412df8c449d66$var$wh = $60e412df8c449d66$var$Uf($60e412df8c449d66$var$th);
function $60e412df8c449d66$var$xh(a) {
    if (a === $60e412df8c449d66$var$th) throw Error($60e412df8c449d66$var$p(174));
    return a;
}
function $60e412df8c449d66$var$yh(a, b) {
    $60e412df8c449d66$var$G($60e412df8c449d66$var$wh, b);
    $60e412df8c449d66$var$G($60e412df8c449d66$var$vh, a);
    $60e412df8c449d66$var$G($60e412df8c449d66$var$uh, $60e412df8c449d66$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $60e412df8c449d66$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $60e412df8c449d66$var$lb(b, a);
    }
    $60e412df8c449d66$var$E($60e412df8c449d66$var$uh);
    $60e412df8c449d66$var$G($60e412df8c449d66$var$uh, b);
}
function $60e412df8c449d66$var$zh() {
    $60e412df8c449d66$var$E($60e412df8c449d66$var$uh);
    $60e412df8c449d66$var$E($60e412df8c449d66$var$vh);
    $60e412df8c449d66$var$E($60e412df8c449d66$var$wh);
}
function $60e412df8c449d66$var$Ah(a) {
    $60e412df8c449d66$var$xh($60e412df8c449d66$var$wh.current);
    var b = $60e412df8c449d66$var$xh($60e412df8c449d66$var$uh.current);
    var c = $60e412df8c449d66$var$lb(b, a.type);
    b !== c && ($60e412df8c449d66$var$G($60e412df8c449d66$var$vh, a), $60e412df8c449d66$var$G($60e412df8c449d66$var$uh, c));
}
function $60e412df8c449d66$var$Bh(a) {
    $60e412df8c449d66$var$vh.current === a && ($60e412df8c449d66$var$E($60e412df8c449d66$var$uh), $60e412df8c449d66$var$E($60e412df8c449d66$var$vh));
}
var $60e412df8c449d66$var$L = $60e412df8c449d66$var$Uf(0);
function $60e412df8c449d66$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $60e412df8c449d66$var$Dh = [];
function $60e412df8c449d66$var$Eh() {
    for(var a = 0; a < $60e412df8c449d66$var$Dh.length; a++)$60e412df8c449d66$var$Dh[a]._workInProgressVersionPrimary = null;
    $60e412df8c449d66$var$Dh.length = 0;
}
var $60e412df8c449d66$var$Fh = $60e412df8c449d66$var$ua.ReactCurrentDispatcher, $60e412df8c449d66$var$Gh = $60e412df8c449d66$var$ua.ReactCurrentBatchConfig, $60e412df8c449d66$var$Hh = 0, $60e412df8c449d66$var$M = null, $60e412df8c449d66$var$N = null, $60e412df8c449d66$var$O = null, $60e412df8c449d66$var$Ih = !1, $60e412df8c449d66$var$Jh = !1, $60e412df8c449d66$var$Kh = 0, $60e412df8c449d66$var$Lh = 0;
function $60e412df8c449d66$var$P() {
    throw Error($60e412df8c449d66$var$p(321));
}
function $60e412df8c449d66$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$60e412df8c449d66$var$He(a[c], b[c])) return !1;
    return !0;
}
function $60e412df8c449d66$var$Nh(a, b, c, d, e, f) {
    $60e412df8c449d66$var$Hh = f;
    $60e412df8c449d66$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $60e412df8c449d66$var$Fh.current = null === a || null === a.memoizedState ? $60e412df8c449d66$var$Oh : $60e412df8c449d66$var$Ph;
    a = c(d, e);
    if ($60e412df8c449d66$var$Jh) {
        f = 0;
        do {
            $60e412df8c449d66$var$Jh = !1;
            $60e412df8c449d66$var$Kh = 0;
            if (25 <= f) throw Error($60e412df8c449d66$var$p(301));
            f += 1;
            $60e412df8c449d66$var$O = $60e412df8c449d66$var$N = null;
            b.updateQueue = null;
            $60e412df8c449d66$var$Fh.current = $60e412df8c449d66$var$Qh;
            a = c(d, e);
        }while ($60e412df8c449d66$var$Jh);
    }
    $60e412df8c449d66$var$Fh.current = $60e412df8c449d66$var$Rh;
    b = null !== $60e412df8c449d66$var$N && null !== $60e412df8c449d66$var$N.next;
    $60e412df8c449d66$var$Hh = 0;
    $60e412df8c449d66$var$O = $60e412df8c449d66$var$N = $60e412df8c449d66$var$M = null;
    $60e412df8c449d66$var$Ih = !1;
    if (b) throw Error($60e412df8c449d66$var$p(300));
    return a;
}
function $60e412df8c449d66$var$Sh() {
    var a = 0 !== $60e412df8c449d66$var$Kh;
    $60e412df8c449d66$var$Kh = 0;
    return a;
}
function $60e412df8c449d66$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $60e412df8c449d66$var$O ? $60e412df8c449d66$var$M.memoizedState = $60e412df8c449d66$var$O = a : $60e412df8c449d66$var$O = $60e412df8c449d66$var$O.next = a;
    return $60e412df8c449d66$var$O;
}
function $60e412df8c449d66$var$Uh() {
    if (null === $60e412df8c449d66$var$N) {
        var a = $60e412df8c449d66$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $60e412df8c449d66$var$N.next;
    var b = null === $60e412df8c449d66$var$O ? $60e412df8c449d66$var$M.memoizedState : $60e412df8c449d66$var$O.next;
    if (null !== b) $60e412df8c449d66$var$O = b, $60e412df8c449d66$var$N = a;
    else {
        if (null === a) throw Error($60e412df8c449d66$var$p(310));
        $60e412df8c449d66$var$N = a;
        a = {
            memoizedState: $60e412df8c449d66$var$N.memoizedState,
            baseState: $60e412df8c449d66$var$N.baseState,
            baseQueue: $60e412df8c449d66$var$N.baseQueue,
            queue: $60e412df8c449d66$var$N.queue,
            next: null
        };
        null === $60e412df8c449d66$var$O ? $60e412df8c449d66$var$M.memoizedState = $60e412df8c449d66$var$O = a : $60e412df8c449d66$var$O = $60e412df8c449d66$var$O.next = a;
    }
    return $60e412df8c449d66$var$O;
}
function $60e412df8c449d66$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $60e412df8c449d66$var$Wh(a) {
    var b = $60e412df8c449d66$var$Uh(), c = b.queue;
    if (null === c) throw Error($60e412df8c449d66$var$p(311));
    c.lastRenderedReducer = a;
    var d = $60e412df8c449d66$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($60e412df8c449d66$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $60e412df8c449d66$var$M.lanes |= m;
                $60e412df8c449d66$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $60e412df8c449d66$var$He(d, b.memoizedState) || ($60e412df8c449d66$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $60e412df8c449d66$var$M.lanes |= f, $60e412df8c449d66$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $60e412df8c449d66$var$Xh(a) {
    var b = $60e412df8c449d66$var$Uh(), c = b.queue;
    if (null === c) throw Error($60e412df8c449d66$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $60e412df8c449d66$var$He(f, b.memoizedState) || ($60e412df8c449d66$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $60e412df8c449d66$var$Yh() {}
function $60e412df8c449d66$var$Zh(a, b) {
    var c = $60e412df8c449d66$var$M, d = $60e412df8c449d66$var$Uh(), e = b(), f = !$60e412df8c449d66$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $60e412df8c449d66$var$dh = !0);
    d = d.queue;
    $60e412df8c449d66$var$$h($60e412df8c449d66$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $60e412df8c449d66$var$O && $60e412df8c449d66$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $60e412df8c449d66$var$bi(9, $60e412df8c449d66$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $60e412df8c449d66$var$Q) throw Error($60e412df8c449d66$var$p(349));
        0 !== ($60e412df8c449d66$var$Hh & 30) || $60e412df8c449d66$var$di(c, b, e);
    }
    return e;
}
function $60e412df8c449d66$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $60e412df8c449d66$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $60e412df8c449d66$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $60e412df8c449d66$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $60e412df8c449d66$var$ei(b) && $60e412df8c449d66$var$fi(a);
}
function $60e412df8c449d66$var$ai(a, b, c) {
    return c(function() {
        $60e412df8c449d66$var$ei(b) && $60e412df8c449d66$var$fi(a);
    });
}
function $60e412df8c449d66$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$60e412df8c449d66$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $60e412df8c449d66$var$fi(a) {
    var b = $60e412df8c449d66$var$ih(a, 1);
    null !== b && $60e412df8c449d66$var$gi(b, a, 1, -1);
}
function $60e412df8c449d66$var$hi(a) {
    var b = $60e412df8c449d66$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $60e412df8c449d66$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $60e412df8c449d66$var$ii.bind(null, $60e412df8c449d66$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $60e412df8c449d66$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $60e412df8c449d66$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $60e412df8c449d66$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $60e412df8c449d66$var$ji() {
    return $60e412df8c449d66$var$Uh().memoizedState;
}
function $60e412df8c449d66$var$ki(a, b, c, d) {
    var e = $60e412df8c449d66$var$Th();
    $60e412df8c449d66$var$M.flags |= a;
    e.memoizedState = $60e412df8c449d66$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $60e412df8c449d66$var$li(a, b, c, d) {
    var e = $60e412df8c449d66$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $60e412df8c449d66$var$N) {
        var g = $60e412df8c449d66$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $60e412df8c449d66$var$Mh(d, g.deps)) {
            e.memoizedState = $60e412df8c449d66$var$bi(b, c, f, d);
            return;
        }
    }
    $60e412df8c449d66$var$M.flags |= a;
    e.memoizedState = $60e412df8c449d66$var$bi(1 | b, c, f, d);
}
function $60e412df8c449d66$var$mi(a, b) {
    return $60e412df8c449d66$var$ki(8390656, 8, a, b);
}
function $60e412df8c449d66$var$$h(a, b) {
    return $60e412df8c449d66$var$li(2048, 8, a, b);
}
function $60e412df8c449d66$var$ni(a, b) {
    return $60e412df8c449d66$var$li(4, 2, a, b);
}
function $60e412df8c449d66$var$oi(a, b) {
    return $60e412df8c449d66$var$li(4, 4, a, b);
}
function $60e412df8c449d66$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $60e412df8c449d66$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $60e412df8c449d66$var$li(4, 4, $60e412df8c449d66$var$pi.bind(null, b, a), c);
}
function $60e412df8c449d66$var$ri() {}
function $60e412df8c449d66$var$si(a, b) {
    var c = $60e412df8c449d66$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $60e412df8c449d66$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $60e412df8c449d66$var$ti(a, b) {
    var c = $60e412df8c449d66$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $60e412df8c449d66$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $60e412df8c449d66$var$ui(a, b, c) {
    if (0 === ($60e412df8c449d66$var$Hh & 21)) return a.baseState && (a.baseState = !1, $60e412df8c449d66$var$dh = !0), a.memoizedState = c;
    $60e412df8c449d66$var$He(c, b) || (c = $60e412df8c449d66$var$yc(), $60e412df8c449d66$var$M.lanes |= c, $60e412df8c449d66$var$rh |= c, a.baseState = !0);
    return b;
}
function $60e412df8c449d66$var$vi(a, b) {
    var c = $60e412df8c449d66$var$C;
    $60e412df8c449d66$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $60e412df8c449d66$var$Gh.transition;
    $60e412df8c449d66$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $60e412df8c449d66$var$C = c, $60e412df8c449d66$var$Gh.transition = d;
    }
}
function $60e412df8c449d66$var$wi() {
    return $60e412df8c449d66$var$Uh().memoizedState;
}
function $60e412df8c449d66$var$xi(a, b, c) {
    var d = $60e412df8c449d66$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($60e412df8c449d66$var$zi(a)) $60e412df8c449d66$var$Ai(b, c);
    else if (c = $60e412df8c449d66$var$hh(a, b, c, d), null !== c) {
        var e = $60e412df8c449d66$var$R();
        $60e412df8c449d66$var$gi(c, a, d, e);
        $60e412df8c449d66$var$Bi(c, b, d);
    }
}
function $60e412df8c449d66$var$ii(a, b, c) {
    var d = $60e412df8c449d66$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($60e412df8c449d66$var$zi(a)) $60e412df8c449d66$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($60e412df8c449d66$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $60e412df8c449d66$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $60e412df8c449d66$var$hh(a, b, e, d);
        null !== c && (e = $60e412df8c449d66$var$R(), $60e412df8c449d66$var$gi(c, a, d, e), $60e412df8c449d66$var$Bi(c, b, d));
    }
}
function $60e412df8c449d66$var$zi(a) {
    var b = a.alternate;
    return a === $60e412df8c449d66$var$M || null !== b && b === $60e412df8c449d66$var$M;
}
function $60e412df8c449d66$var$Ai(a, b) {
    $60e412df8c449d66$var$Jh = $60e412df8c449d66$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $60e412df8c449d66$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $60e412df8c449d66$var$Cc(a, c);
    }
}
var $60e412df8c449d66$var$Rh = {
    readContext: $60e412df8c449d66$var$eh,
    useCallback: $60e412df8c449d66$var$P,
    useContext: $60e412df8c449d66$var$P,
    useEffect: $60e412df8c449d66$var$P,
    useImperativeHandle: $60e412df8c449d66$var$P,
    useInsertionEffect: $60e412df8c449d66$var$P,
    useLayoutEffect: $60e412df8c449d66$var$P,
    useMemo: $60e412df8c449d66$var$P,
    useReducer: $60e412df8c449d66$var$P,
    useRef: $60e412df8c449d66$var$P,
    useState: $60e412df8c449d66$var$P,
    useDebugValue: $60e412df8c449d66$var$P,
    useDeferredValue: $60e412df8c449d66$var$P,
    useTransition: $60e412df8c449d66$var$P,
    useMutableSource: $60e412df8c449d66$var$P,
    useSyncExternalStore: $60e412df8c449d66$var$P,
    useId: $60e412df8c449d66$var$P,
    unstable_isNewReconciler: !1
}, $60e412df8c449d66$var$Oh = {
    readContext: $60e412df8c449d66$var$eh,
    useCallback: function(a, b) {
        $60e412df8c449d66$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $60e412df8c449d66$var$eh,
    useEffect: $60e412df8c449d66$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $60e412df8c449d66$var$ki(4194308, 4, $60e412df8c449d66$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $60e412df8c449d66$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $60e412df8c449d66$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $60e412df8c449d66$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $60e412df8c449d66$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $60e412df8c449d66$var$xi.bind(null, $60e412df8c449d66$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $60e412df8c449d66$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $60e412df8c449d66$var$hi,
    useDebugValue: $60e412df8c449d66$var$ri,
    useDeferredValue: function(a) {
        return $60e412df8c449d66$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $60e412df8c449d66$var$hi(!1), b = a[0];
        a = $60e412df8c449d66$var$vi.bind(null, a[1]);
        $60e412df8c449d66$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $60e412df8c449d66$var$M, e = $60e412df8c449d66$var$Th();
        if ($60e412df8c449d66$var$I) {
            if (void 0 === c) throw Error($60e412df8c449d66$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $60e412df8c449d66$var$Q) throw Error($60e412df8c449d66$var$p(349));
            0 !== ($60e412df8c449d66$var$Hh & 30) || $60e412df8c449d66$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $60e412df8c449d66$var$mi($60e412df8c449d66$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $60e412df8c449d66$var$bi(9, $60e412df8c449d66$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $60e412df8c449d66$var$Th(), b = $60e412df8c449d66$var$Q.identifierPrefix;
        if ($60e412df8c449d66$var$I) {
            var c = $60e412df8c449d66$var$sg;
            var d = $60e412df8c449d66$var$rg;
            c = (d & ~(1 << 32 - $60e412df8c449d66$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $60e412df8c449d66$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $60e412df8c449d66$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $60e412df8c449d66$var$Ph = {
    readContext: $60e412df8c449d66$var$eh,
    useCallback: $60e412df8c449d66$var$si,
    useContext: $60e412df8c449d66$var$eh,
    useEffect: $60e412df8c449d66$var$$h,
    useImperativeHandle: $60e412df8c449d66$var$qi,
    useInsertionEffect: $60e412df8c449d66$var$ni,
    useLayoutEffect: $60e412df8c449d66$var$oi,
    useMemo: $60e412df8c449d66$var$ti,
    useReducer: $60e412df8c449d66$var$Wh,
    useRef: $60e412df8c449d66$var$ji,
    useState: function() {
        return $60e412df8c449d66$var$Wh($60e412df8c449d66$var$Vh);
    },
    useDebugValue: $60e412df8c449d66$var$ri,
    useDeferredValue: function(a) {
        var b = $60e412df8c449d66$var$Uh();
        return $60e412df8c449d66$var$ui(b, $60e412df8c449d66$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $60e412df8c449d66$var$Wh($60e412df8c449d66$var$Vh)[0], b = $60e412df8c449d66$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $60e412df8c449d66$var$Yh,
    useSyncExternalStore: $60e412df8c449d66$var$Zh,
    useId: $60e412df8c449d66$var$wi,
    unstable_isNewReconciler: !1
}, $60e412df8c449d66$var$Qh = {
    readContext: $60e412df8c449d66$var$eh,
    useCallback: $60e412df8c449d66$var$si,
    useContext: $60e412df8c449d66$var$eh,
    useEffect: $60e412df8c449d66$var$$h,
    useImperativeHandle: $60e412df8c449d66$var$qi,
    useInsertionEffect: $60e412df8c449d66$var$ni,
    useLayoutEffect: $60e412df8c449d66$var$oi,
    useMemo: $60e412df8c449d66$var$ti,
    useReducer: $60e412df8c449d66$var$Xh,
    useRef: $60e412df8c449d66$var$ji,
    useState: function() {
        return $60e412df8c449d66$var$Xh($60e412df8c449d66$var$Vh);
    },
    useDebugValue: $60e412df8c449d66$var$ri,
    useDeferredValue: function(a) {
        var b = $60e412df8c449d66$var$Uh();
        return null === $60e412df8c449d66$var$N ? b.memoizedState = a : $60e412df8c449d66$var$ui(b, $60e412df8c449d66$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $60e412df8c449d66$var$Xh($60e412df8c449d66$var$Vh)[0], b = $60e412df8c449d66$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $60e412df8c449d66$var$Yh,
    useSyncExternalStore: $60e412df8c449d66$var$Zh,
    useId: $60e412df8c449d66$var$wi,
    unstable_isNewReconciler: !1
};
function $60e412df8c449d66$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $60e412df8c449d66$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $60e412df8c449d66$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $60e412df8c449d66$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $60e412df8c449d66$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $60e412df8c449d66$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $60e412df8c449d66$var$R(), e = $60e412df8c449d66$var$yi(a), f = $60e412df8c449d66$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $60e412df8c449d66$var$nh(a, f, e);
        null !== b && ($60e412df8c449d66$var$gi(b, a, e, d), $60e412df8c449d66$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $60e412df8c449d66$var$R(), e = $60e412df8c449d66$var$yi(a), f = $60e412df8c449d66$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $60e412df8c449d66$var$nh(a, f, e);
        null !== b && ($60e412df8c449d66$var$gi(b, a, e, d), $60e412df8c449d66$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $60e412df8c449d66$var$R(), d = $60e412df8c449d66$var$yi(a), e = $60e412df8c449d66$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $60e412df8c449d66$var$nh(a, e, d);
        null !== b && ($60e412df8c449d66$var$gi(b, a, d, c), $60e412df8c449d66$var$oh(b, a, d));
    }
};
function $60e412df8c449d66$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$60e412df8c449d66$var$Ie(c, d) || !$60e412df8c449d66$var$Ie(e, f) : !0;
}
function $60e412df8c449d66$var$Gi(a, b, c) {
    var d = !1, e = $60e412df8c449d66$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $60e412df8c449d66$var$eh(f) : (e = $60e412df8c449d66$var$Zf(b) ? $60e412df8c449d66$var$Xf : $60e412df8c449d66$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $60e412df8c449d66$var$Yf(a, e) : $60e412df8c449d66$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $60e412df8c449d66$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $60e412df8c449d66$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $60e412df8c449d66$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $60e412df8c449d66$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $60e412df8c449d66$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $60e412df8c449d66$var$eh(f) : (f = $60e412df8c449d66$var$Zf(b) ? $60e412df8c449d66$var$Xf : $60e412df8c449d66$var$H.current, e.context = $60e412df8c449d66$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($60e412df8c449d66$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $60e412df8c449d66$var$Ei.enqueueReplaceState(e, e.state, null), $60e412df8c449d66$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $60e412df8c449d66$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $60e412df8c449d66$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $60e412df8c449d66$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $60e412df8c449d66$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $60e412df8c449d66$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $60e412df8c449d66$var$Ni(a, b, c) {
    c = $60e412df8c449d66$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $60e412df8c449d66$var$Oi || ($60e412df8c449d66$var$Oi = !0, $60e412df8c449d66$var$Pi = d);
        $60e412df8c449d66$var$Li(a, b);
    };
    return c;
}
function $60e412df8c449d66$var$Qi(a, b, c) {
    c = $60e412df8c449d66$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $60e412df8c449d66$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $60e412df8c449d66$var$Li(a, b);
        "function" !== typeof d && (null === $60e412df8c449d66$var$Ri ? $60e412df8c449d66$var$Ri = new Set([
            this
        ]) : $60e412df8c449d66$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $60e412df8c449d66$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $60e412df8c449d66$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $60e412df8c449d66$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $60e412df8c449d66$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $60e412df8c449d66$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $60e412df8c449d66$var$mh(-1, 1), b.tag = 2, $60e412df8c449d66$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $60e412df8c449d66$var$Wi = $60e412df8c449d66$var$ua.ReactCurrentOwner, $60e412df8c449d66$var$dh = !1;
function $60e412df8c449d66$var$Xi(a, b, c, d) {
    b.child = null === a ? $60e412df8c449d66$var$Vg(b, null, c, d) : $60e412df8c449d66$var$Ug(b, a.child, c, d);
}
function $60e412df8c449d66$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $60e412df8c449d66$var$ch(b, e);
    d = $60e412df8c449d66$var$Nh(a, b, c, d, f, e);
    c = $60e412df8c449d66$var$Sh();
    if (null !== a && !$60e412df8c449d66$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $60e412df8c449d66$var$Zi(a, b, e);
    $60e412df8c449d66$var$I && c && $60e412df8c449d66$var$vg(b);
    b.flags |= 1;
    $60e412df8c449d66$var$Xi(a, b, d, e);
    return b.child;
}
function $60e412df8c449d66$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$60e412df8c449d66$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $60e412df8c449d66$var$bj(a, b, f, d, e);
        a = $60e412df8c449d66$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $60e412df8c449d66$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $60e412df8c449d66$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $60e412df8c449d66$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $60e412df8c449d66$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($60e412df8c449d66$var$Ie(f, d) && a.ref === b.ref) {
            if ($60e412df8c449d66$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($60e412df8c449d66$var$dh = !0);
            else return b.lanes = a.lanes, $60e412df8c449d66$var$Zi(a, b, e);
        }
    }
    return $60e412df8c449d66$var$cj(a, b, c, d, e);
}
function $60e412df8c449d66$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $60e412df8c449d66$var$G($60e412df8c449d66$var$ej, $60e412df8c449d66$var$fj), $60e412df8c449d66$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $60e412df8c449d66$var$G($60e412df8c449d66$var$ej, $60e412df8c449d66$var$fj), $60e412df8c449d66$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $60e412df8c449d66$var$G($60e412df8c449d66$var$ej, $60e412df8c449d66$var$fj);
            $60e412df8c449d66$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $60e412df8c449d66$var$G($60e412df8c449d66$var$ej, $60e412df8c449d66$var$fj), $60e412df8c449d66$var$fj |= d;
    $60e412df8c449d66$var$Xi(a, b, e, c);
    return b.child;
}
function $60e412df8c449d66$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $60e412df8c449d66$var$cj(a, b, c, d, e) {
    var f = $60e412df8c449d66$var$Zf(c) ? $60e412df8c449d66$var$Xf : $60e412df8c449d66$var$H.current;
    f = $60e412df8c449d66$var$Yf(b, f);
    $60e412df8c449d66$var$ch(b, e);
    c = $60e412df8c449d66$var$Nh(a, b, c, d, f, e);
    d = $60e412df8c449d66$var$Sh();
    if (null !== a && !$60e412df8c449d66$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $60e412df8c449d66$var$Zi(a, b, e);
    $60e412df8c449d66$var$I && d && $60e412df8c449d66$var$vg(b);
    b.flags |= 1;
    $60e412df8c449d66$var$Xi(a, b, c, e);
    return b.child;
}
function $60e412df8c449d66$var$hj(a, b, c, d, e) {
    if ($60e412df8c449d66$var$Zf(c)) {
        var f = !0;
        $60e412df8c449d66$var$cg(b);
    } else f = !1;
    $60e412df8c449d66$var$ch(b, e);
    if (null === b.stateNode) $60e412df8c449d66$var$ij(a, b), $60e412df8c449d66$var$Gi(b, c, d), $60e412df8c449d66$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $60e412df8c449d66$var$eh(l) : (l = $60e412df8c449d66$var$Zf(c) ? $60e412df8c449d66$var$Xf : $60e412df8c449d66$var$H.current, l = $60e412df8c449d66$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $60e412df8c449d66$var$Hi(b, g, d, l);
        $60e412df8c449d66$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $60e412df8c449d66$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $60e412df8c449d66$var$Wf.current || $60e412df8c449d66$var$jh ? ("function" === typeof m && ($60e412df8c449d66$var$Di(b, c, m, d), k = b.memoizedState), (h = $60e412df8c449d66$var$jh || $60e412df8c449d66$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $60e412df8c449d66$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $60e412df8c449d66$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $60e412df8c449d66$var$eh(k) : (k = $60e412df8c449d66$var$Zf(c) ? $60e412df8c449d66$var$Xf : $60e412df8c449d66$var$H.current, k = $60e412df8c449d66$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $60e412df8c449d66$var$Hi(b, g, d, k);
        $60e412df8c449d66$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $60e412df8c449d66$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $60e412df8c449d66$var$Wf.current || $60e412df8c449d66$var$jh ? ("function" === typeof y && ($60e412df8c449d66$var$Di(b, c, y, d), n = b.memoizedState), (l = $60e412df8c449d66$var$jh || $60e412df8c449d66$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $60e412df8c449d66$var$jj(a, b, c, d, f, e);
}
function $60e412df8c449d66$var$jj(a, b, c, d, e, f) {
    $60e412df8c449d66$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $60e412df8c449d66$var$dg(b, c, !1), $60e412df8c449d66$var$Zi(a, b, f);
    d = b.stateNode;
    $60e412df8c449d66$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $60e412df8c449d66$var$Ug(b, a.child, null, f), b.child = $60e412df8c449d66$var$Ug(b, null, h, f)) : $60e412df8c449d66$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $60e412df8c449d66$var$dg(b, c, !0);
    return b.child;
}
function $60e412df8c449d66$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $60e412df8c449d66$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $60e412df8c449d66$var$ag(a, b.context, !1);
    $60e412df8c449d66$var$yh(a, b.containerInfo);
}
function $60e412df8c449d66$var$lj(a, b, c, d, e) {
    $60e412df8c449d66$var$Ig();
    $60e412df8c449d66$var$Jg(e);
    b.flags |= 256;
    $60e412df8c449d66$var$Xi(a, b, c, d);
    return b.child;
}
var $60e412df8c449d66$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $60e412df8c449d66$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $60e412df8c449d66$var$oj(a, b, c) {
    var d = b.pendingProps, e = $60e412df8c449d66$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $60e412df8c449d66$var$G($60e412df8c449d66$var$L, e & 1);
    if (null === a) {
        $60e412df8c449d66$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $60e412df8c449d66$var$pj(g, d, 0, null), a = $60e412df8c449d66$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $60e412df8c449d66$var$nj(c), b.memoizedState = $60e412df8c449d66$var$mj, a) : $60e412df8c449d66$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $60e412df8c449d66$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $60e412df8c449d66$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $60e412df8c449d66$var$Pg(h, f) : (f = $60e412df8c449d66$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $60e412df8c449d66$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $60e412df8c449d66$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $60e412df8c449d66$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $60e412df8c449d66$var$qj(a, b) {
    b = $60e412df8c449d66$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $60e412df8c449d66$var$sj(a, b, c, d) {
    null !== d && $60e412df8c449d66$var$Jg(d);
    $60e412df8c449d66$var$Ug(b, a.child, null, c);
    a = $60e412df8c449d66$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $60e412df8c449d66$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $60e412df8c449d66$var$Ki(Error($60e412df8c449d66$var$p(422))), $60e412df8c449d66$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $60e412df8c449d66$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $60e412df8c449d66$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $60e412df8c449d66$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $60e412df8c449d66$var$nj(g);
        b.memoizedState = $60e412df8c449d66$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $60e412df8c449d66$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($60e412df8c449d66$var$p(419));
        d = $60e412df8c449d66$var$Ki(f, d, void 0);
        return $60e412df8c449d66$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($60e412df8c449d66$var$dh || h) {
        d = $60e412df8c449d66$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $60e412df8c449d66$var$ih(a, e), $60e412df8c449d66$var$gi(d, a, e, -1));
        }
        $60e412df8c449d66$var$tj();
        d = $60e412df8c449d66$var$Ki(Error($60e412df8c449d66$var$p(421)));
        return $60e412df8c449d66$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $60e412df8c449d66$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $60e412df8c449d66$var$yg = $60e412df8c449d66$var$Lf(e.nextSibling);
    $60e412df8c449d66$var$xg = b;
    $60e412df8c449d66$var$I = !0;
    $60e412df8c449d66$var$zg = null;
    null !== a && ($60e412df8c449d66$var$og[$60e412df8c449d66$var$pg++] = $60e412df8c449d66$var$rg, $60e412df8c449d66$var$og[$60e412df8c449d66$var$pg++] = $60e412df8c449d66$var$sg, $60e412df8c449d66$var$og[$60e412df8c449d66$var$pg++] = $60e412df8c449d66$var$qg, $60e412df8c449d66$var$rg = a.id, $60e412df8c449d66$var$sg = a.overflow, $60e412df8c449d66$var$qg = b);
    b = $60e412df8c449d66$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $60e412df8c449d66$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $60e412df8c449d66$var$bh(a.return, b, c);
}
function $60e412df8c449d66$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $60e412df8c449d66$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $60e412df8c449d66$var$Xi(a, b, d.children, c);
    d = $60e412df8c449d66$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $60e412df8c449d66$var$vj(a, c, b);
            else if (19 === a.tag) $60e412df8c449d66$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $60e412df8c449d66$var$G($60e412df8c449d66$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $60e412df8c449d66$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $60e412df8c449d66$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $60e412df8c449d66$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $60e412df8c449d66$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $60e412df8c449d66$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $60e412df8c449d66$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $60e412df8c449d66$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $60e412df8c449d66$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($60e412df8c449d66$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $60e412df8c449d66$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $60e412df8c449d66$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $60e412df8c449d66$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $60e412df8c449d66$var$kj(b);
            $60e412df8c449d66$var$Ig();
            break;
        case 5:
            $60e412df8c449d66$var$Ah(b);
            break;
        case 1:
            $60e412df8c449d66$var$Zf(b.type) && $60e412df8c449d66$var$cg(b);
            break;
        case 4:
            $60e412df8c449d66$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $60e412df8c449d66$var$G($60e412df8c449d66$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $60e412df8c449d66$var$G($60e412df8c449d66$var$L, $60e412df8c449d66$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $60e412df8c449d66$var$oj(a, b, c);
                $60e412df8c449d66$var$G($60e412df8c449d66$var$L, $60e412df8c449d66$var$L.current & 1);
                a = $60e412df8c449d66$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $60e412df8c449d66$var$G($60e412df8c449d66$var$L, $60e412df8c449d66$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $60e412df8c449d66$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $60e412df8c449d66$var$G($60e412df8c449d66$var$L, $60e412df8c449d66$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $60e412df8c449d66$var$dj(a, b, c);
    }
    return $60e412df8c449d66$var$Zi(a, b, c);
}
var $60e412df8c449d66$var$zj, $60e412df8c449d66$var$Aj, $60e412df8c449d66$var$Bj, $60e412df8c449d66$var$Cj;
$60e412df8c449d66$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$60e412df8c449d66$var$Aj = function() {};
$60e412df8c449d66$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $60e412df8c449d66$var$xh($60e412df8c449d66$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $60e412df8c449d66$var$Ya(a, e);
                d = $60e412df8c449d66$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $60e412df8c449d66$var$A({}, e, {
                    value: void 0
                });
                d = $60e412df8c449d66$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $60e412df8c449d66$var$gb(a, e);
                d = $60e412df8c449d66$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $60e412df8c449d66$var$Bf);
        }
        $60e412df8c449d66$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($60e412df8c449d66$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($60e412df8c449d66$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $60e412df8c449d66$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$60e412df8c449d66$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $60e412df8c449d66$var$Dj(a, b) {
    if (!$60e412df8c449d66$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $60e412df8c449d66$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $60e412df8c449d66$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $60e412df8c449d66$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $60e412df8c449d66$var$S(b), null;
        case 1:
            return $60e412df8c449d66$var$Zf(b.type) && $60e412df8c449d66$var$$f(), $60e412df8c449d66$var$S(b), null;
        case 3:
            d = b.stateNode;
            $60e412df8c449d66$var$zh();
            $60e412df8c449d66$var$E($60e412df8c449d66$var$Wf);
            $60e412df8c449d66$var$E($60e412df8c449d66$var$H);
            $60e412df8c449d66$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $60e412df8c449d66$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $60e412df8c449d66$var$zg && ($60e412df8c449d66$var$Fj($60e412df8c449d66$var$zg), $60e412df8c449d66$var$zg = null));
            $60e412df8c449d66$var$Aj(a, b);
            $60e412df8c449d66$var$S(b);
            return null;
        case 5:
            $60e412df8c449d66$var$Bh(b);
            var e = $60e412df8c449d66$var$xh($60e412df8c449d66$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $60e412df8c449d66$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($60e412df8c449d66$var$p(166));
                    $60e412df8c449d66$var$S(b);
                    return null;
                }
                a = $60e412df8c449d66$var$xh($60e412df8c449d66$var$uh.current);
                if ($60e412df8c449d66$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$60e412df8c449d66$var$Of] = b;
                    d[$60e412df8c449d66$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $60e412df8c449d66$var$D("cancel", d);
                            $60e412df8c449d66$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $60e412df8c449d66$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $60e412df8c449d66$var$lf.length; e++)$60e412df8c449d66$var$D($60e412df8c449d66$var$lf[e], d);
                            break;
                        case "source":
                            $60e412df8c449d66$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $60e412df8c449d66$var$D("error", d);
                            $60e412df8c449d66$var$D("load", d);
                            break;
                        case "details":
                            $60e412df8c449d66$var$D("toggle", d);
                            break;
                        case "input":
                            $60e412df8c449d66$var$Za(d, f);
                            $60e412df8c449d66$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $60e412df8c449d66$var$D("invalid", d);
                            break;
                        case "textarea":
                            $60e412df8c449d66$var$hb(d, f), $60e412df8c449d66$var$D("invalid", d);
                    }
                    $60e412df8c449d66$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $60e412df8c449d66$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $60e412df8c449d66$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $60e412df8c449d66$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $60e412df8c449d66$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $60e412df8c449d66$var$Va(d);
                            $60e412df8c449d66$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $60e412df8c449d66$var$Va(d);
                            $60e412df8c449d66$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $60e412df8c449d66$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $60e412df8c449d66$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$60e412df8c449d66$var$Of] = b;
                    a[$60e412df8c449d66$var$Pf] = d;
                    $60e412df8c449d66$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $60e412df8c449d66$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $60e412df8c449d66$var$D("cancel", a);
                                $60e412df8c449d66$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $60e412df8c449d66$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $60e412df8c449d66$var$lf.length; e++)$60e412df8c449d66$var$D($60e412df8c449d66$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $60e412df8c449d66$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $60e412df8c449d66$var$D("error", a);
                                $60e412df8c449d66$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $60e412df8c449d66$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $60e412df8c449d66$var$Za(a, d);
                                e = $60e412df8c449d66$var$Ya(a, d);
                                $60e412df8c449d66$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $60e412df8c449d66$var$A({}, d, {
                                    value: void 0
                                });
                                $60e412df8c449d66$var$D("invalid", a);
                                break;
                            case "textarea":
                                $60e412df8c449d66$var$hb(a, d);
                                e = $60e412df8c449d66$var$gb(a, d);
                                $60e412df8c449d66$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $60e412df8c449d66$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $60e412df8c449d66$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $60e412df8c449d66$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $60e412df8c449d66$var$ob(a, k) : "number" === typeof k && $60e412df8c449d66$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($60e412df8c449d66$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $60e412df8c449d66$var$D("scroll", a) : null != k && $60e412df8c449d66$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $60e412df8c449d66$var$Va(a);
                                $60e412df8c449d66$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $60e412df8c449d66$var$Va(a);
                                $60e412df8c449d66$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $60e412df8c449d66$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $60e412df8c449d66$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $60e412df8c449d66$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $60e412df8c449d66$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $60e412df8c449d66$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $60e412df8c449d66$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($60e412df8c449d66$var$p(166));
                c = $60e412df8c449d66$var$xh($60e412df8c449d66$var$wh.current);
                $60e412df8c449d66$var$xh($60e412df8c449d66$var$uh.current);
                if ($60e412df8c449d66$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$60e412df8c449d66$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $60e412df8c449d66$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $60e412df8c449d66$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $60e412df8c449d66$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$60e412df8c449d66$var$Of] = b, b.stateNode = d;
            }
            $60e412df8c449d66$var$S(b);
            return null;
        case 13:
            $60e412df8c449d66$var$E($60e412df8c449d66$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($60e412df8c449d66$var$I && null !== $60e412df8c449d66$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $60e412df8c449d66$var$Hg(), $60e412df8c449d66$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $60e412df8c449d66$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($60e412df8c449d66$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($60e412df8c449d66$var$p(317));
                        f[$60e412df8c449d66$var$Of] = b;
                    } else $60e412df8c449d66$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $60e412df8c449d66$var$S(b);
                    f = !1;
                } else null !== $60e412df8c449d66$var$zg && ($60e412df8c449d66$var$Fj($60e412df8c449d66$var$zg), $60e412df8c449d66$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($60e412df8c449d66$var$L.current & 1) ? 0 === $60e412df8c449d66$var$T && ($60e412df8c449d66$var$T = 3) : $60e412df8c449d66$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $60e412df8c449d66$var$S(b);
            return null;
        case 4:
            return $60e412df8c449d66$var$zh(), $60e412df8c449d66$var$Aj(a, b), null === a && $60e412df8c449d66$var$sf(b.stateNode.containerInfo), $60e412df8c449d66$var$S(b), null;
        case 10:
            return $60e412df8c449d66$var$ah(b.type._context), $60e412df8c449d66$var$S(b), null;
        case 17:
            return $60e412df8c449d66$var$Zf(b.type) && $60e412df8c449d66$var$$f(), $60e412df8c449d66$var$S(b), null;
        case 19:
            $60e412df8c449d66$var$E($60e412df8c449d66$var$L);
            f = b.memoizedState;
            if (null === f) return $60e412df8c449d66$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $60e412df8c449d66$var$Dj(f, !1);
                else {
                    if (0 !== $60e412df8c449d66$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $60e412df8c449d66$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $60e412df8c449d66$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $60e412df8c449d66$var$G($60e412df8c449d66$var$L, $60e412df8c449d66$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $60e412df8c449d66$var$B() > $60e412df8c449d66$var$Gj && (b.flags |= 128, d = !0, $60e412df8c449d66$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $60e412df8c449d66$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $60e412df8c449d66$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$60e412df8c449d66$var$I) return $60e412df8c449d66$var$S(b), null;
                    } else 2 * $60e412df8c449d66$var$B() - f.renderingStartTime > $60e412df8c449d66$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $60e412df8c449d66$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $60e412df8c449d66$var$B(), b.sibling = null, c = $60e412df8c449d66$var$L.current, $60e412df8c449d66$var$G($60e412df8c449d66$var$L, d ? c & 1 | 2 : c & 1), b;
            $60e412df8c449d66$var$S(b);
            return null;
        case 22:
        case 23:
            return $60e412df8c449d66$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($60e412df8c449d66$var$fj & 1073741824) && ($60e412df8c449d66$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $60e412df8c449d66$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($60e412df8c449d66$var$p(156, b.tag));
}
function $60e412df8c449d66$var$Ij(a, b) {
    $60e412df8c449d66$var$wg(b);
    switch(b.tag){
        case 1:
            return $60e412df8c449d66$var$Zf(b.type) && $60e412df8c449d66$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $60e412df8c449d66$var$zh(), $60e412df8c449d66$var$E($60e412df8c449d66$var$Wf), $60e412df8c449d66$var$E($60e412df8c449d66$var$H), $60e412df8c449d66$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $60e412df8c449d66$var$Bh(b), null;
        case 13:
            $60e412df8c449d66$var$E($60e412df8c449d66$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($60e412df8c449d66$var$p(340));
                $60e412df8c449d66$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $60e412df8c449d66$var$E($60e412df8c449d66$var$L), null;
        case 4:
            return $60e412df8c449d66$var$zh(), null;
        case 10:
            return $60e412df8c449d66$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $60e412df8c449d66$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $60e412df8c449d66$var$Jj = !1, $60e412df8c449d66$var$U = !1, $60e412df8c449d66$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $60e412df8c449d66$var$V = null;
function $60e412df8c449d66$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $60e412df8c449d66$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $60e412df8c449d66$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $60e412df8c449d66$var$W(a, b, d);
    }
}
var $60e412df8c449d66$var$Nj = !1;
function $60e412df8c449d66$var$Oj(a, b) {
    $60e412df8c449d66$var$Cf = $60e412df8c449d66$var$dd;
    a = $60e412df8c449d66$var$Me();
    if ($60e412df8c449d66$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $60e412df8c449d66$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $60e412df8c449d66$var$dd = !1;
    for($60e412df8c449d66$var$V = b; null !== $60e412df8c449d66$var$V;)if (b = $60e412df8c449d66$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $60e412df8c449d66$var$V = a;
    else for(; null !== $60e412df8c449d66$var$V;){
        b = $60e412df8c449d66$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $60e412df8c449d66$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($60e412df8c449d66$var$p(163));
            }
        } catch (F) {
            $60e412df8c449d66$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $60e412df8c449d66$var$V = a;
            break;
        }
        $60e412df8c449d66$var$V = b.return;
    }
    n = $60e412df8c449d66$var$Nj;
    $60e412df8c449d66$var$Nj = !1;
    return n;
}
function $60e412df8c449d66$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $60e412df8c449d66$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $60e412df8c449d66$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $60e412df8c449d66$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $60e412df8c449d66$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $60e412df8c449d66$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$60e412df8c449d66$var$Of], delete b[$60e412df8c449d66$var$Pf], delete b[$60e412df8c449d66$var$of], delete b[$60e412df8c449d66$var$Qf], delete b[$60e412df8c449d66$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $60e412df8c449d66$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $60e412df8c449d66$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $60e412df8c449d66$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $60e412df8c449d66$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $60e412df8c449d66$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($60e412df8c449d66$var$Vj(a, b, c), a = a.sibling; null !== a;)$60e412df8c449d66$var$Vj(a, b, c), a = a.sibling;
}
function $60e412df8c449d66$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($60e412df8c449d66$var$Wj(a, b, c), a = a.sibling; null !== a;)$60e412df8c449d66$var$Wj(a, b, c), a = a.sibling;
}
var $60e412df8c449d66$var$X = null, $60e412df8c449d66$var$Xj = !1;
function $60e412df8c449d66$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$60e412df8c449d66$var$Zj(a, b, c), c = c.sibling;
}
function $60e412df8c449d66$var$Zj(a, b, c) {
    if ($60e412df8c449d66$var$lc && "function" === typeof $60e412df8c449d66$var$lc.onCommitFiberUnmount) try {
        $60e412df8c449d66$var$lc.onCommitFiberUnmount($60e412df8c449d66$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $60e412df8c449d66$var$U || $60e412df8c449d66$var$Lj(c, b);
        case 6:
            var d = $60e412df8c449d66$var$X, e = $60e412df8c449d66$var$Xj;
            $60e412df8c449d66$var$X = null;
            $60e412df8c449d66$var$Yj(a, b, c);
            $60e412df8c449d66$var$X = d;
            $60e412df8c449d66$var$Xj = e;
            null !== $60e412df8c449d66$var$X && ($60e412df8c449d66$var$Xj ? (a = $60e412df8c449d66$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $60e412df8c449d66$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $60e412df8c449d66$var$X && ($60e412df8c449d66$var$Xj ? (a = $60e412df8c449d66$var$X, c = c.stateNode, 8 === a.nodeType ? $60e412df8c449d66$var$Kf(a.parentNode, c) : 1 === a.nodeType && $60e412df8c449d66$var$Kf(a, c), $60e412df8c449d66$var$bd(a)) : $60e412df8c449d66$var$Kf($60e412df8c449d66$var$X, c.stateNode));
            break;
        case 4:
            d = $60e412df8c449d66$var$X;
            e = $60e412df8c449d66$var$Xj;
            $60e412df8c449d66$var$X = c.stateNode.containerInfo;
            $60e412df8c449d66$var$Xj = !0;
            $60e412df8c449d66$var$Yj(a, b, c);
            $60e412df8c449d66$var$X = d;
            $60e412df8c449d66$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$60e412df8c449d66$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $60e412df8c449d66$var$Mj(c, b, g) : 0 !== (f & 4) && $60e412df8c449d66$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $60e412df8c449d66$var$Yj(a, b, c);
            break;
        case 1:
            if (!$60e412df8c449d66$var$U && ($60e412df8c449d66$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $60e412df8c449d66$var$W(c, b, h);
            }
            $60e412df8c449d66$var$Yj(a, b, c);
            break;
        case 21:
            $60e412df8c449d66$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($60e412df8c449d66$var$U = (d = $60e412df8c449d66$var$U) || null !== c.memoizedState, $60e412df8c449d66$var$Yj(a, b, c), $60e412df8c449d66$var$U = d) : $60e412df8c449d66$var$Yj(a, b, c);
            break;
        default:
            $60e412df8c449d66$var$Yj(a, b, c);
    }
}
function $60e412df8c449d66$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $60e412df8c449d66$var$Kj);
        b.forEach(function(b) {
            var d = $60e412df8c449d66$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $60e412df8c449d66$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $60e412df8c449d66$var$X = h.stateNode;
                        $60e412df8c449d66$var$Xj = !1;
                        break a;
                    case 3:
                        $60e412df8c449d66$var$X = h.stateNode.containerInfo;
                        $60e412df8c449d66$var$Xj = !0;
                        break a;
                    case 4:
                        $60e412df8c449d66$var$X = h.stateNode.containerInfo;
                        $60e412df8c449d66$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $60e412df8c449d66$var$X) throw Error($60e412df8c449d66$var$p(160));
            $60e412df8c449d66$var$Zj(f, g, e);
            $60e412df8c449d66$var$X = null;
            $60e412df8c449d66$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $60e412df8c449d66$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$60e412df8c449d66$var$dk(b, a), b = b.sibling;
}
function $60e412df8c449d66$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $60e412df8c449d66$var$ck(b, a);
            $60e412df8c449d66$var$ek(a);
            if (d & 4) {
                try {
                    $60e412df8c449d66$var$Pj(3, a, a.return), $60e412df8c449d66$var$Qj(3, a);
                } catch (t) {
                    $60e412df8c449d66$var$W(a, a.return, t);
                }
                try {
                    $60e412df8c449d66$var$Pj(5, a, a.return);
                } catch (t) {
                    $60e412df8c449d66$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $60e412df8c449d66$var$ck(b, a);
            $60e412df8c449d66$var$ek(a);
            d & 512 && null !== c && $60e412df8c449d66$var$Lj(c, c.return);
            break;
        case 5:
            $60e412df8c449d66$var$ck(b, a);
            $60e412df8c449d66$var$ek(a);
            d & 512 && null !== c && $60e412df8c449d66$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $60e412df8c449d66$var$ob(e, "");
                } catch (t) {
                    $60e412df8c449d66$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $60e412df8c449d66$var$ab(e, f);
                    $60e412df8c449d66$var$vb(h, g);
                    var l = $60e412df8c449d66$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $60e412df8c449d66$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $60e412df8c449d66$var$nb(e, q) : "children" === m ? $60e412df8c449d66$var$ob(e, q) : $60e412df8c449d66$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $60e412df8c449d66$var$bb(e, f);
                            break;
                        case "textarea":
                            $60e412df8c449d66$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $60e412df8c449d66$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $60e412df8c449d66$var$fb(e, !!f.multiple, f.defaultValue, !0) : $60e412df8c449d66$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$60e412df8c449d66$var$Pf] = f;
                } catch (t) {
                    $60e412df8c449d66$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $60e412df8c449d66$var$ck(b, a);
            $60e412df8c449d66$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($60e412df8c449d66$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $60e412df8c449d66$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $60e412df8c449d66$var$ck(b, a);
            $60e412df8c449d66$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $60e412df8c449d66$var$bd(b.containerInfo);
            } catch (t) {
                $60e412df8c449d66$var$W(a, a.return, t);
            }
            break;
        case 4:
            $60e412df8c449d66$var$ck(b, a);
            $60e412df8c449d66$var$ek(a);
            break;
        case 13:
            $60e412df8c449d66$var$ck(b, a);
            $60e412df8c449d66$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($60e412df8c449d66$var$fk = $60e412df8c449d66$var$B()));
            d & 4 && $60e412df8c449d66$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($60e412df8c449d66$var$U = (l = $60e412df8c449d66$var$U) || m, $60e412df8c449d66$var$ck(b, a), $60e412df8c449d66$var$U = l) : $60e412df8c449d66$var$ck(b, a);
            $60e412df8c449d66$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($60e412df8c449d66$var$V = a, m = a.child; null !== m;){
                    for(q = $60e412df8c449d66$var$V = m; null !== $60e412df8c449d66$var$V;){
                        r = $60e412df8c449d66$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $60e412df8c449d66$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $60e412df8c449d66$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $60e412df8c449d66$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $60e412df8c449d66$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $60e412df8c449d66$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $60e412df8c449d66$var$V = y) : $60e412df8c449d66$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $60e412df8c449d66$var$rb("display", g));
                            } catch (t) {
                                $60e412df8c449d66$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $60e412df8c449d66$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $60e412df8c449d66$var$ck(b, a);
            $60e412df8c449d66$var$ek(a);
            d & 4 && $60e412df8c449d66$var$ak(a);
            break;
        case 21:
            break;
        default:
            $60e412df8c449d66$var$ck(b, a), $60e412df8c449d66$var$ek(a);
    }
}
function $60e412df8c449d66$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($60e412df8c449d66$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($60e412df8c449d66$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($60e412df8c449d66$var$ob(e, ""), d.flags &= -33);
                    var f = $60e412df8c449d66$var$Uj(a);
                    $60e412df8c449d66$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $60e412df8c449d66$var$Uj(a);
                    $60e412df8c449d66$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($60e412df8c449d66$var$p(161));
            }
        } catch (k) {
            $60e412df8c449d66$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $60e412df8c449d66$var$hk(a, b, c) {
    $60e412df8c449d66$var$V = a;
    $60e412df8c449d66$var$ik(a, b, c);
}
function $60e412df8c449d66$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $60e412df8c449d66$var$V;){
        var e = $60e412df8c449d66$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $60e412df8c449d66$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $60e412df8c449d66$var$U;
                h = $60e412df8c449d66$var$Jj;
                var l = $60e412df8c449d66$var$U;
                $60e412df8c449d66$var$Jj = g;
                if (($60e412df8c449d66$var$U = k) && !l) for($60e412df8c449d66$var$V = e; null !== $60e412df8c449d66$var$V;)g = $60e412df8c449d66$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $60e412df8c449d66$var$jk(e) : null !== k ? (k.return = g, $60e412df8c449d66$var$V = k) : $60e412df8c449d66$var$jk(e);
                for(; null !== f;)$60e412df8c449d66$var$V = f, $60e412df8c449d66$var$ik(f, b, c), f = f.sibling;
                $60e412df8c449d66$var$V = e;
                $60e412df8c449d66$var$Jj = h;
                $60e412df8c449d66$var$U = l;
            }
            $60e412df8c449d66$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $60e412df8c449d66$var$V = f) : $60e412df8c449d66$var$kk(a, b, c);
    }
}
function $60e412df8c449d66$var$kk(a) {
    for(; null !== $60e412df8c449d66$var$V;){
        var b = $60e412df8c449d66$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $60e412df8c449d66$var$U || $60e412df8c449d66$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$60e412df8c449d66$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $60e412df8c449d66$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $60e412df8c449d66$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $60e412df8c449d66$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $60e412df8c449d66$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($60e412df8c449d66$var$p(163));
                }
                $60e412df8c449d66$var$U || b.flags & 512 && $60e412df8c449d66$var$Rj(b);
            } catch (r) {
                $60e412df8c449d66$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $60e412df8c449d66$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $60e412df8c449d66$var$V = c;
            break;
        }
        $60e412df8c449d66$var$V = b.return;
    }
}
function $60e412df8c449d66$var$gk(a) {
    for(; null !== $60e412df8c449d66$var$V;){
        var b = $60e412df8c449d66$var$V;
        if (b === a) {
            $60e412df8c449d66$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $60e412df8c449d66$var$V = c;
            break;
        }
        $60e412df8c449d66$var$V = b.return;
    }
}
function $60e412df8c449d66$var$jk(a) {
    for(; null !== $60e412df8c449d66$var$V;){
        var b = $60e412df8c449d66$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $60e412df8c449d66$var$Qj(4, b);
                    } catch (k) {
                        $60e412df8c449d66$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $60e412df8c449d66$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $60e412df8c449d66$var$Rj(b);
                    } catch (k) {
                        $60e412df8c449d66$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $60e412df8c449d66$var$Rj(b);
                    } catch (k) {
                        $60e412df8c449d66$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $60e412df8c449d66$var$W(b, b.return, k);
        }
        if (b === a) {
            $60e412df8c449d66$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $60e412df8c449d66$var$V = h;
            break;
        }
        $60e412df8c449d66$var$V = b.return;
    }
}
var $60e412df8c449d66$var$lk = Math.ceil, $60e412df8c449d66$var$mk = $60e412df8c449d66$var$ua.ReactCurrentDispatcher, $60e412df8c449d66$var$nk = $60e412df8c449d66$var$ua.ReactCurrentOwner, $60e412df8c449d66$var$ok = $60e412df8c449d66$var$ua.ReactCurrentBatchConfig, $60e412df8c449d66$var$K = 0, $60e412df8c449d66$var$Q = null, $60e412df8c449d66$var$Y = null, $60e412df8c449d66$var$Z = 0, $60e412df8c449d66$var$fj = 0, $60e412df8c449d66$var$ej = $60e412df8c449d66$var$Uf(0), $60e412df8c449d66$var$T = 0, $60e412df8c449d66$var$pk = null, $60e412df8c449d66$var$rh = 0, $60e412df8c449d66$var$qk = 0, $60e412df8c449d66$var$rk = 0, $60e412df8c449d66$var$sk = null, $60e412df8c449d66$var$tk = null, $60e412df8c449d66$var$fk = 0, $60e412df8c449d66$var$Gj = Infinity, $60e412df8c449d66$var$uk = null, $60e412df8c449d66$var$Oi = !1, $60e412df8c449d66$var$Pi = null, $60e412df8c449d66$var$Ri = null, $60e412df8c449d66$var$vk = !1, $60e412df8c449d66$var$wk = null, $60e412df8c449d66$var$xk = 0, $60e412df8c449d66$var$yk = 0, $60e412df8c449d66$var$zk = null, $60e412df8c449d66$var$Ak = -1, $60e412df8c449d66$var$Bk = 0;
function $60e412df8c449d66$var$R() {
    return 0 !== ($60e412df8c449d66$var$K & 6) ? $60e412df8c449d66$var$B() : -1 !== $60e412df8c449d66$var$Ak ? $60e412df8c449d66$var$Ak : $60e412df8c449d66$var$Ak = $60e412df8c449d66$var$B();
}
function $60e412df8c449d66$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($60e412df8c449d66$var$K & 2) && 0 !== $60e412df8c449d66$var$Z) return $60e412df8c449d66$var$Z & -$60e412df8c449d66$var$Z;
    if (null !== $60e412df8c449d66$var$Kg.transition) return 0 === $60e412df8c449d66$var$Bk && ($60e412df8c449d66$var$Bk = $60e412df8c449d66$var$yc()), $60e412df8c449d66$var$Bk;
    a = $60e412df8c449d66$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $60e412df8c449d66$var$jd(a.type);
    return a;
}
function $60e412df8c449d66$var$gi(a, b, c, d) {
    if (50 < $60e412df8c449d66$var$yk) throw $60e412df8c449d66$var$yk = 0, $60e412df8c449d66$var$zk = null, Error($60e412df8c449d66$var$p(185));
    $60e412df8c449d66$var$Ac(a, c, d);
    if (0 === ($60e412df8c449d66$var$K & 2) || a !== $60e412df8c449d66$var$Q) a === $60e412df8c449d66$var$Q && (0 === ($60e412df8c449d66$var$K & 2) && ($60e412df8c449d66$var$qk |= c), 4 === $60e412df8c449d66$var$T && $60e412df8c449d66$var$Ck(a, $60e412df8c449d66$var$Z)), $60e412df8c449d66$var$Dk(a, d), 1 === c && 0 === $60e412df8c449d66$var$K && 0 === (b.mode & 1) && ($60e412df8c449d66$var$Gj = $60e412df8c449d66$var$B() + 500, $60e412df8c449d66$var$fg && $60e412df8c449d66$var$jg());
}
function $60e412df8c449d66$var$Dk(a, b) {
    var c = a.callbackNode;
    $60e412df8c449d66$var$wc(a, b);
    var d = $60e412df8c449d66$var$uc(a, a === $60e412df8c449d66$var$Q ? $60e412df8c449d66$var$Z : 0);
    if (0 === d) null !== c && $60e412df8c449d66$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $60e412df8c449d66$var$bc(c);
        if (1 === b) 0 === a.tag ? $60e412df8c449d66$var$ig($60e412df8c449d66$var$Ek.bind(null, a)) : $60e412df8c449d66$var$hg($60e412df8c449d66$var$Ek.bind(null, a)), $60e412df8c449d66$var$Jf(function() {
            0 === ($60e412df8c449d66$var$K & 6) && $60e412df8c449d66$var$jg();
        }), c = null;
        else {
            switch($60e412df8c449d66$var$Dc(d)){
                case 1:
                    c = $60e412df8c449d66$var$fc;
                    break;
                case 4:
                    c = $60e412df8c449d66$var$gc;
                    break;
                case 16:
                    c = $60e412df8c449d66$var$hc;
                    break;
                case 536870912:
                    c = $60e412df8c449d66$var$jc;
                    break;
                default:
                    c = $60e412df8c449d66$var$hc;
            }
            c = $60e412df8c449d66$var$Fk(c, $60e412df8c449d66$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $60e412df8c449d66$var$Gk(a, b) {
    $60e412df8c449d66$var$Ak = -1;
    $60e412df8c449d66$var$Bk = 0;
    if (0 !== ($60e412df8c449d66$var$K & 6)) throw Error($60e412df8c449d66$var$p(327));
    var c = a.callbackNode;
    if ($60e412df8c449d66$var$Hk() && a.callbackNode !== c) return null;
    var d = $60e412df8c449d66$var$uc(a, a === $60e412df8c449d66$var$Q ? $60e412df8c449d66$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $60e412df8c449d66$var$Ik(a, d);
    else {
        b = d;
        var e = $60e412df8c449d66$var$K;
        $60e412df8c449d66$var$K |= 2;
        var f = $60e412df8c449d66$var$Jk();
        if ($60e412df8c449d66$var$Q !== a || $60e412df8c449d66$var$Z !== b) $60e412df8c449d66$var$uk = null, $60e412df8c449d66$var$Gj = $60e412df8c449d66$var$B() + 500, $60e412df8c449d66$var$Kk(a, b);
        for(;;)try {
            $60e412df8c449d66$var$Lk();
            break;
        } catch (h) {
            $60e412df8c449d66$var$Mk(a, h);
        }
        $60e412df8c449d66$var$$g();
        $60e412df8c449d66$var$mk.current = f;
        $60e412df8c449d66$var$K = e;
        null !== $60e412df8c449d66$var$Y ? b = 0 : ($60e412df8c449d66$var$Q = null, $60e412df8c449d66$var$Z = 0, b = $60e412df8c449d66$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $60e412df8c449d66$var$xc(a), 0 !== e && (d = e, b = $60e412df8c449d66$var$Nk(a, e)));
        if (1 === b) throw c = $60e412df8c449d66$var$pk, $60e412df8c449d66$var$Kk(a, 0), $60e412df8c449d66$var$Ck(a, d), $60e412df8c449d66$var$Dk(a, $60e412df8c449d66$var$B()), c;
        if (6 === b) $60e412df8c449d66$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$60e412df8c449d66$var$Ok(e) && (b = $60e412df8c449d66$var$Ik(a, d), 2 === b && (f = $60e412df8c449d66$var$xc(a), 0 !== f && (d = f, b = $60e412df8c449d66$var$Nk(a, f))), 1 === b)) throw c = $60e412df8c449d66$var$pk, $60e412df8c449d66$var$Kk(a, 0), $60e412df8c449d66$var$Ck(a, d), $60e412df8c449d66$var$Dk(a, $60e412df8c449d66$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($60e412df8c449d66$var$p(345));
                case 2:
                    $60e412df8c449d66$var$Pk(a, $60e412df8c449d66$var$tk, $60e412df8c449d66$var$uk);
                    break;
                case 3:
                    $60e412df8c449d66$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $60e412df8c449d66$var$fk + 500 - $60e412df8c449d66$var$B(), 10 < b)) {
                        if (0 !== $60e412df8c449d66$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $60e412df8c449d66$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $60e412df8c449d66$var$Ff($60e412df8c449d66$var$Pk.bind(null, a, $60e412df8c449d66$var$tk, $60e412df8c449d66$var$uk), b);
                        break;
                    }
                    $60e412df8c449d66$var$Pk(a, $60e412df8c449d66$var$tk, $60e412df8c449d66$var$uk);
                    break;
                case 4:
                    $60e412df8c449d66$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $60e412df8c449d66$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $60e412df8c449d66$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $60e412df8c449d66$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $60e412df8c449d66$var$Ff($60e412df8c449d66$var$Pk.bind(null, a, $60e412df8c449d66$var$tk, $60e412df8c449d66$var$uk), d);
                        break;
                    }
                    $60e412df8c449d66$var$Pk(a, $60e412df8c449d66$var$tk, $60e412df8c449d66$var$uk);
                    break;
                case 5:
                    $60e412df8c449d66$var$Pk(a, $60e412df8c449d66$var$tk, $60e412df8c449d66$var$uk);
                    break;
                default:
                    throw Error($60e412df8c449d66$var$p(329));
            }
        }
    }
    $60e412df8c449d66$var$Dk(a, $60e412df8c449d66$var$B());
    return a.callbackNode === c ? $60e412df8c449d66$var$Gk.bind(null, a) : null;
}
function $60e412df8c449d66$var$Nk(a, b) {
    var c = $60e412df8c449d66$var$sk;
    a.current.memoizedState.isDehydrated && ($60e412df8c449d66$var$Kk(a, b).flags |= 256);
    a = $60e412df8c449d66$var$Ik(a, b);
    2 !== a && (b = $60e412df8c449d66$var$tk, $60e412df8c449d66$var$tk = c, null !== b && $60e412df8c449d66$var$Fj(b));
    return a;
}
function $60e412df8c449d66$var$Fj(a) {
    null === $60e412df8c449d66$var$tk ? $60e412df8c449d66$var$tk = a : $60e412df8c449d66$var$tk.push.apply($60e412df8c449d66$var$tk, a);
}
function $60e412df8c449d66$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$60e412df8c449d66$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $60e412df8c449d66$var$Ck(a, b) {
    b &= ~$60e412df8c449d66$var$rk;
    b &= ~$60e412df8c449d66$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $60e412df8c449d66$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $60e412df8c449d66$var$Ek(a) {
    if (0 !== ($60e412df8c449d66$var$K & 6)) throw Error($60e412df8c449d66$var$p(327));
    $60e412df8c449d66$var$Hk();
    var b = $60e412df8c449d66$var$uc(a, 0);
    if (0 === (b & 1)) return $60e412df8c449d66$var$Dk(a, $60e412df8c449d66$var$B()), null;
    var c = $60e412df8c449d66$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $60e412df8c449d66$var$xc(a);
        0 !== d && (b = d, c = $60e412df8c449d66$var$Nk(a, d));
    }
    if (1 === c) throw c = $60e412df8c449d66$var$pk, $60e412df8c449d66$var$Kk(a, 0), $60e412df8c449d66$var$Ck(a, b), $60e412df8c449d66$var$Dk(a, $60e412df8c449d66$var$B()), c;
    if (6 === c) throw Error($60e412df8c449d66$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $60e412df8c449d66$var$Pk(a, $60e412df8c449d66$var$tk, $60e412df8c449d66$var$uk);
    $60e412df8c449d66$var$Dk(a, $60e412df8c449d66$var$B());
    return null;
}
function $60e412df8c449d66$var$Qk(a, b) {
    var c = $60e412df8c449d66$var$K;
    $60e412df8c449d66$var$K |= 1;
    try {
        return a(b);
    } finally{
        $60e412df8c449d66$var$K = c, 0 === $60e412df8c449d66$var$K && ($60e412df8c449d66$var$Gj = $60e412df8c449d66$var$B() + 500, $60e412df8c449d66$var$fg && $60e412df8c449d66$var$jg());
    }
}
function $60e412df8c449d66$var$Rk(a) {
    null !== $60e412df8c449d66$var$wk && 0 === $60e412df8c449d66$var$wk.tag && 0 === ($60e412df8c449d66$var$K & 6) && $60e412df8c449d66$var$Hk();
    var b = $60e412df8c449d66$var$K;
    $60e412df8c449d66$var$K |= 1;
    var c = $60e412df8c449d66$var$ok.transition, d = $60e412df8c449d66$var$C;
    try {
        if ($60e412df8c449d66$var$ok.transition = null, $60e412df8c449d66$var$C = 1, a) return a();
    } finally{
        $60e412df8c449d66$var$C = d, $60e412df8c449d66$var$ok.transition = c, $60e412df8c449d66$var$K = b, 0 === ($60e412df8c449d66$var$K & 6) && $60e412df8c449d66$var$jg();
    }
}
function $60e412df8c449d66$var$Hj() {
    $60e412df8c449d66$var$fj = $60e412df8c449d66$var$ej.current;
    $60e412df8c449d66$var$E($60e412df8c449d66$var$ej);
}
function $60e412df8c449d66$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $60e412df8c449d66$var$Gf(c));
    if (null !== $60e412df8c449d66$var$Y) for(c = $60e412df8c449d66$var$Y.return; null !== c;){
        var d = c;
        $60e412df8c449d66$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $60e412df8c449d66$var$$f();
                break;
            case 3:
                $60e412df8c449d66$var$zh();
                $60e412df8c449d66$var$E($60e412df8c449d66$var$Wf);
                $60e412df8c449d66$var$E($60e412df8c449d66$var$H);
                $60e412df8c449d66$var$Eh();
                break;
            case 5:
                $60e412df8c449d66$var$Bh(d);
                break;
            case 4:
                $60e412df8c449d66$var$zh();
                break;
            case 13:
                $60e412df8c449d66$var$E($60e412df8c449d66$var$L);
                break;
            case 19:
                $60e412df8c449d66$var$E($60e412df8c449d66$var$L);
                break;
            case 10:
                $60e412df8c449d66$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $60e412df8c449d66$var$Hj();
        }
        c = c.return;
    }
    $60e412df8c449d66$var$Q = a;
    $60e412df8c449d66$var$Y = a = $60e412df8c449d66$var$Pg(a.current, null);
    $60e412df8c449d66$var$Z = $60e412df8c449d66$var$fj = b;
    $60e412df8c449d66$var$T = 0;
    $60e412df8c449d66$var$pk = null;
    $60e412df8c449d66$var$rk = $60e412df8c449d66$var$qk = $60e412df8c449d66$var$rh = 0;
    $60e412df8c449d66$var$tk = $60e412df8c449d66$var$sk = null;
    if (null !== $60e412df8c449d66$var$fh) {
        for(b = 0; b < $60e412df8c449d66$var$fh.length; b++)if (c = $60e412df8c449d66$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $60e412df8c449d66$var$fh = null;
    }
    return a;
}
function $60e412df8c449d66$var$Mk(a, b) {
    do {
        var c = $60e412df8c449d66$var$Y;
        try {
            $60e412df8c449d66$var$$g();
            $60e412df8c449d66$var$Fh.current = $60e412df8c449d66$var$Rh;
            if ($60e412df8c449d66$var$Ih) {
                for(var d = $60e412df8c449d66$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $60e412df8c449d66$var$Ih = !1;
            }
            $60e412df8c449d66$var$Hh = 0;
            $60e412df8c449d66$var$O = $60e412df8c449d66$var$N = $60e412df8c449d66$var$M = null;
            $60e412df8c449d66$var$Jh = !1;
            $60e412df8c449d66$var$Kh = 0;
            $60e412df8c449d66$var$nk.current = null;
            if (null === c || null === c.return) {
                $60e412df8c449d66$var$T = 1;
                $60e412df8c449d66$var$pk = b;
                $60e412df8c449d66$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $60e412df8c449d66$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $60e412df8c449d66$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $60e412df8c449d66$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $60e412df8c449d66$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $60e412df8c449d66$var$Si(f, l, b);
                            $60e412df8c449d66$var$tj();
                            break a;
                        }
                        k = Error($60e412df8c449d66$var$p(426));
                    }
                } else if ($60e412df8c449d66$var$I && h.mode & 1) {
                    var J = $60e412df8c449d66$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $60e412df8c449d66$var$Vi(J, g, h, f, b);
                        $60e412df8c449d66$var$Jg($60e412df8c449d66$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $60e412df8c449d66$var$Ji(k, h);
                4 !== $60e412df8c449d66$var$T && ($60e412df8c449d66$var$T = 2);
                null === $60e412df8c449d66$var$sk ? $60e412df8c449d66$var$sk = [
                    f
                ] : $60e412df8c449d66$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $60e412df8c449d66$var$Ni(f, k, b);
                            $60e412df8c449d66$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $60e412df8c449d66$var$Ri || !$60e412df8c449d66$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $60e412df8c449d66$var$Qi(f, h, b);
                                $60e412df8c449d66$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $60e412df8c449d66$var$Sk(c);
        } catch (na) {
            b = na;
            $60e412df8c449d66$var$Y === c && null !== c && ($60e412df8c449d66$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $60e412df8c449d66$var$Jk() {
    var a = $60e412df8c449d66$var$mk.current;
    $60e412df8c449d66$var$mk.current = $60e412df8c449d66$var$Rh;
    return null === a ? $60e412df8c449d66$var$Rh : a;
}
function $60e412df8c449d66$var$tj() {
    if (0 === $60e412df8c449d66$var$T || 3 === $60e412df8c449d66$var$T || 2 === $60e412df8c449d66$var$T) $60e412df8c449d66$var$T = 4;
    null === $60e412df8c449d66$var$Q || 0 === ($60e412df8c449d66$var$rh & 268435455) && 0 === ($60e412df8c449d66$var$qk & 268435455) || $60e412df8c449d66$var$Ck($60e412df8c449d66$var$Q, $60e412df8c449d66$var$Z);
}
function $60e412df8c449d66$var$Ik(a, b) {
    var c = $60e412df8c449d66$var$K;
    $60e412df8c449d66$var$K |= 2;
    var d = $60e412df8c449d66$var$Jk();
    if ($60e412df8c449d66$var$Q !== a || $60e412df8c449d66$var$Z !== b) $60e412df8c449d66$var$uk = null, $60e412df8c449d66$var$Kk(a, b);
    for(;;)try {
        $60e412df8c449d66$var$Tk();
        break;
    } catch (e) {
        $60e412df8c449d66$var$Mk(a, e);
    }
    $60e412df8c449d66$var$$g();
    $60e412df8c449d66$var$K = c;
    $60e412df8c449d66$var$mk.current = d;
    if (null !== $60e412df8c449d66$var$Y) throw Error($60e412df8c449d66$var$p(261));
    $60e412df8c449d66$var$Q = null;
    $60e412df8c449d66$var$Z = 0;
    return $60e412df8c449d66$var$T;
}
function $60e412df8c449d66$var$Tk() {
    for(; null !== $60e412df8c449d66$var$Y;)$60e412df8c449d66$var$Uk($60e412df8c449d66$var$Y);
}
function $60e412df8c449d66$var$Lk() {
    for(; null !== $60e412df8c449d66$var$Y && !$60e412df8c449d66$var$cc();)$60e412df8c449d66$var$Uk($60e412df8c449d66$var$Y);
}
function $60e412df8c449d66$var$Uk(a) {
    var b = $60e412df8c449d66$var$Vk(a.alternate, a, $60e412df8c449d66$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $60e412df8c449d66$var$Sk(a) : $60e412df8c449d66$var$Y = b;
    $60e412df8c449d66$var$nk.current = null;
}
function $60e412df8c449d66$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $60e412df8c449d66$var$Ej(c, b, $60e412df8c449d66$var$fj), null !== c) {
                $60e412df8c449d66$var$Y = c;
                return;
            }
        } else {
            c = $60e412df8c449d66$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $60e412df8c449d66$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $60e412df8c449d66$var$T = 6;
                $60e412df8c449d66$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $60e412df8c449d66$var$Y = b;
            return;
        }
        $60e412df8c449d66$var$Y = b = a;
    }while (null !== b);
    0 === $60e412df8c449d66$var$T && ($60e412df8c449d66$var$T = 5);
}
function $60e412df8c449d66$var$Pk(a, b, c) {
    var d = $60e412df8c449d66$var$C, e = $60e412df8c449d66$var$ok.transition;
    try {
        $60e412df8c449d66$var$ok.transition = null, $60e412df8c449d66$var$C = 1, $60e412df8c449d66$var$Wk(a, b, c, d);
    } finally{
        $60e412df8c449d66$var$ok.transition = e, $60e412df8c449d66$var$C = d;
    }
    return null;
}
function $60e412df8c449d66$var$Wk(a, b, c, d) {
    do $60e412df8c449d66$var$Hk();
    while (null !== $60e412df8c449d66$var$wk);
    if (0 !== ($60e412df8c449d66$var$K & 6)) throw Error($60e412df8c449d66$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($60e412df8c449d66$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $60e412df8c449d66$var$Bc(a, f);
    a === $60e412df8c449d66$var$Q && ($60e412df8c449d66$var$Y = $60e412df8c449d66$var$Q = null, $60e412df8c449d66$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $60e412df8c449d66$var$vk || ($60e412df8c449d66$var$vk = !0, $60e412df8c449d66$var$Fk($60e412df8c449d66$var$hc, function() {
        $60e412df8c449d66$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $60e412df8c449d66$var$ok.transition;
        $60e412df8c449d66$var$ok.transition = null;
        var g = $60e412df8c449d66$var$C;
        $60e412df8c449d66$var$C = 1;
        var h = $60e412df8c449d66$var$K;
        $60e412df8c449d66$var$K |= 4;
        $60e412df8c449d66$var$nk.current = null;
        $60e412df8c449d66$var$Oj(a, c);
        $60e412df8c449d66$var$dk(c, a);
        $60e412df8c449d66$var$Oe($60e412df8c449d66$var$Df);
        $60e412df8c449d66$var$dd = !!$60e412df8c449d66$var$Cf;
        $60e412df8c449d66$var$Df = $60e412df8c449d66$var$Cf = null;
        a.current = c;
        $60e412df8c449d66$var$hk(c, a, e);
        $60e412df8c449d66$var$dc();
        $60e412df8c449d66$var$K = h;
        $60e412df8c449d66$var$C = g;
        $60e412df8c449d66$var$ok.transition = f;
    } else a.current = c;
    $60e412df8c449d66$var$vk && ($60e412df8c449d66$var$vk = !1, $60e412df8c449d66$var$wk = a, $60e412df8c449d66$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($60e412df8c449d66$var$Ri = null);
    $60e412df8c449d66$var$mc(c.stateNode, d);
    $60e412df8c449d66$var$Dk(a, $60e412df8c449d66$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($60e412df8c449d66$var$Oi) throw $60e412df8c449d66$var$Oi = !1, a = $60e412df8c449d66$var$Pi, $60e412df8c449d66$var$Pi = null, a;
    0 !== ($60e412df8c449d66$var$xk & 1) && 0 !== a.tag && $60e412df8c449d66$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $60e412df8c449d66$var$zk ? $60e412df8c449d66$var$yk++ : ($60e412df8c449d66$var$yk = 0, $60e412df8c449d66$var$zk = a) : $60e412df8c449d66$var$yk = 0;
    $60e412df8c449d66$var$jg();
    return null;
}
function $60e412df8c449d66$var$Hk() {
    if (null !== $60e412df8c449d66$var$wk) {
        var a = $60e412df8c449d66$var$Dc($60e412df8c449d66$var$xk), b = $60e412df8c449d66$var$ok.transition, c = $60e412df8c449d66$var$C;
        try {
            $60e412df8c449d66$var$ok.transition = null;
            $60e412df8c449d66$var$C = 16 > a ? 16 : a;
            if (null === $60e412df8c449d66$var$wk) var d = !1;
            else {
                a = $60e412df8c449d66$var$wk;
                $60e412df8c449d66$var$wk = null;
                $60e412df8c449d66$var$xk = 0;
                if (0 !== ($60e412df8c449d66$var$K & 6)) throw Error($60e412df8c449d66$var$p(331));
                var e = $60e412df8c449d66$var$K;
                $60e412df8c449d66$var$K |= 4;
                for($60e412df8c449d66$var$V = a.current; null !== $60e412df8c449d66$var$V;){
                    var f = $60e412df8c449d66$var$V, g = f.child;
                    if (0 !== ($60e412df8c449d66$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($60e412df8c449d66$var$V = l; null !== $60e412df8c449d66$var$V;){
                                    var m = $60e412df8c449d66$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $60e412df8c449d66$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $60e412df8c449d66$var$V = q;
                                    else for(; null !== $60e412df8c449d66$var$V;){
                                        m = $60e412df8c449d66$var$V;
                                        var r = m.sibling, y = m.return;
                                        $60e412df8c449d66$var$Sj(m);
                                        if (m === l) {
                                            $60e412df8c449d66$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $60e412df8c449d66$var$V = r;
                                            break;
                                        }
                                        $60e412df8c449d66$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $60e412df8c449d66$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $60e412df8c449d66$var$V = g;
                    else b: for(; null !== $60e412df8c449d66$var$V;){
                        f = $60e412df8c449d66$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $60e412df8c449d66$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $60e412df8c449d66$var$V = x;
                            break b;
                        }
                        $60e412df8c449d66$var$V = f.return;
                    }
                }
                var w = a.current;
                for($60e412df8c449d66$var$V = w; null !== $60e412df8c449d66$var$V;){
                    g = $60e412df8c449d66$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $60e412df8c449d66$var$V = u;
                    else b: for(g = w; null !== $60e412df8c449d66$var$V;){
                        h = $60e412df8c449d66$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $60e412df8c449d66$var$Qj(9, h);
                            }
                        } catch (na) {
                            $60e412df8c449d66$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $60e412df8c449d66$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $60e412df8c449d66$var$V = F;
                            break b;
                        }
                        $60e412df8c449d66$var$V = h.return;
                    }
                }
                $60e412df8c449d66$var$K = e;
                $60e412df8c449d66$var$jg();
                if ($60e412df8c449d66$var$lc && "function" === typeof $60e412df8c449d66$var$lc.onPostCommitFiberRoot) try {
                    $60e412df8c449d66$var$lc.onPostCommitFiberRoot($60e412df8c449d66$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $60e412df8c449d66$var$C = c, $60e412df8c449d66$var$ok.transition = b;
        }
    }
    return !1;
}
function $60e412df8c449d66$var$Xk(a, b, c) {
    b = $60e412df8c449d66$var$Ji(c, b);
    b = $60e412df8c449d66$var$Ni(a, b, 1);
    a = $60e412df8c449d66$var$nh(a, b, 1);
    b = $60e412df8c449d66$var$R();
    null !== a && ($60e412df8c449d66$var$Ac(a, 1, b), $60e412df8c449d66$var$Dk(a, b));
}
function $60e412df8c449d66$var$W(a, b, c) {
    if (3 === a.tag) $60e412df8c449d66$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $60e412df8c449d66$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $60e412df8c449d66$var$Ri || !$60e412df8c449d66$var$Ri.has(d))) {
                a = $60e412df8c449d66$var$Ji(c, a);
                a = $60e412df8c449d66$var$Qi(b, a, 1);
                b = $60e412df8c449d66$var$nh(b, a, 1);
                a = $60e412df8c449d66$var$R();
                null !== b && ($60e412df8c449d66$var$Ac(b, 1, a), $60e412df8c449d66$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $60e412df8c449d66$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $60e412df8c449d66$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $60e412df8c449d66$var$Q === a && ($60e412df8c449d66$var$Z & c) === c && (4 === $60e412df8c449d66$var$T || 3 === $60e412df8c449d66$var$T && ($60e412df8c449d66$var$Z & 130023424) === $60e412df8c449d66$var$Z && 500 > $60e412df8c449d66$var$B() - $60e412df8c449d66$var$fk ? $60e412df8c449d66$var$Kk(a, 0) : $60e412df8c449d66$var$rk |= c);
    $60e412df8c449d66$var$Dk(a, b);
}
function $60e412df8c449d66$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $60e412df8c449d66$var$sc, $60e412df8c449d66$var$sc <<= 1, 0 === ($60e412df8c449d66$var$sc & 130023424) && ($60e412df8c449d66$var$sc = 4194304)));
    var c = $60e412df8c449d66$var$R();
    a = $60e412df8c449d66$var$ih(a, b);
    null !== a && ($60e412df8c449d66$var$Ac(a, b, c), $60e412df8c449d66$var$Dk(a, c));
}
function $60e412df8c449d66$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $60e412df8c449d66$var$Yk(a, c);
}
function $60e412df8c449d66$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($60e412df8c449d66$var$p(314));
    }
    null !== d && d.delete(b);
    $60e412df8c449d66$var$Yk(a, c);
}
var $60e412df8c449d66$var$Vk;
$60e412df8c449d66$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $60e412df8c449d66$var$Wf.current) $60e412df8c449d66$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $60e412df8c449d66$var$dh = !1, $60e412df8c449d66$var$yj(a, b, c);
            $60e412df8c449d66$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $60e412df8c449d66$var$dh = !1, $60e412df8c449d66$var$I && 0 !== (b.flags & 1048576) && $60e412df8c449d66$var$ug(b, $60e412df8c449d66$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $60e412df8c449d66$var$ij(a, b);
            a = b.pendingProps;
            var e = $60e412df8c449d66$var$Yf(b, $60e412df8c449d66$var$H.current);
            $60e412df8c449d66$var$ch(b, c);
            e = $60e412df8c449d66$var$Nh(null, b, d, a, e, c);
            var f = $60e412df8c449d66$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $60e412df8c449d66$var$Zf(d) ? (f = !0, $60e412df8c449d66$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $60e412df8c449d66$var$kh(b), e.updater = $60e412df8c449d66$var$Ei, b.stateNode = e, e._reactInternals = b, $60e412df8c449d66$var$Ii(b, d, a, c), b = $60e412df8c449d66$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $60e412df8c449d66$var$I && f && $60e412df8c449d66$var$vg(b), $60e412df8c449d66$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $60e412df8c449d66$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $60e412df8c449d66$var$Zk(d);
                a = $60e412df8c449d66$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $60e412df8c449d66$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $60e412df8c449d66$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $60e412df8c449d66$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $60e412df8c449d66$var$$i(null, b, d, $60e412df8c449d66$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($60e412df8c449d66$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $60e412df8c449d66$var$Ci(d, e), $60e412df8c449d66$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $60e412df8c449d66$var$Ci(d, e), $60e412df8c449d66$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $60e412df8c449d66$var$kj(b);
                if (null === a) throw Error($60e412df8c449d66$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $60e412df8c449d66$var$lh(a, b);
                $60e412df8c449d66$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $60e412df8c449d66$var$Ji(Error($60e412df8c449d66$var$p(423)), b);
                        b = $60e412df8c449d66$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $60e412df8c449d66$var$Ji(Error($60e412df8c449d66$var$p(424)), b);
                        b = $60e412df8c449d66$var$lj(a, b, d, c, e);
                        break a;
                    } else for($60e412df8c449d66$var$yg = $60e412df8c449d66$var$Lf(b.stateNode.containerInfo.firstChild), $60e412df8c449d66$var$xg = b, $60e412df8c449d66$var$I = !0, $60e412df8c449d66$var$zg = null, c = $60e412df8c449d66$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $60e412df8c449d66$var$Ig();
                    if (d === e) {
                        b = $60e412df8c449d66$var$Zi(a, b, c);
                        break a;
                    }
                    $60e412df8c449d66$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $60e412df8c449d66$var$Ah(b), null === a && $60e412df8c449d66$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $60e412df8c449d66$var$Ef(d, e) ? g = null : null !== f && $60e412df8c449d66$var$Ef(d, f) && (b.flags |= 32), $60e412df8c449d66$var$gj(a, b), $60e412df8c449d66$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $60e412df8c449d66$var$Eg(b), null;
        case 13:
            return $60e412df8c449d66$var$oj(a, b, c);
        case 4:
            return $60e412df8c449d66$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $60e412df8c449d66$var$Ug(b, null, d, c) : $60e412df8c449d66$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $60e412df8c449d66$var$Ci(d, e), $60e412df8c449d66$var$Yi(a, b, d, e, c);
        case 7:
            return $60e412df8c449d66$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $60e412df8c449d66$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $60e412df8c449d66$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $60e412df8c449d66$var$G($60e412df8c449d66$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($60e412df8c449d66$var$He(f.value, g)) {
                        if (f.children === e.children && !$60e412df8c449d66$var$Wf.current) {
                            b = $60e412df8c449d66$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $60e412df8c449d66$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $60e412df8c449d66$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($60e412df8c449d66$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $60e412df8c449d66$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $60e412df8c449d66$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $60e412df8c449d66$var$ch(b, c), e = $60e412df8c449d66$var$eh(e), d = d(e), b.flags |= 1, $60e412df8c449d66$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $60e412df8c449d66$var$Ci(d, b.pendingProps), e = $60e412df8c449d66$var$Ci(d.type, e), $60e412df8c449d66$var$$i(a, b, d, e, c);
        case 15:
            return $60e412df8c449d66$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $60e412df8c449d66$var$Ci(d, e), $60e412df8c449d66$var$ij(a, b), b.tag = 1, $60e412df8c449d66$var$Zf(d) ? (a = !0, $60e412df8c449d66$var$cg(b)) : a = !1, $60e412df8c449d66$var$ch(b, c), $60e412df8c449d66$var$Gi(b, d, e), $60e412df8c449d66$var$Ii(b, d, e, c), $60e412df8c449d66$var$jj(null, b, d, !0, a, c);
        case 19:
            return $60e412df8c449d66$var$xj(a, b, c);
        case 22:
            return $60e412df8c449d66$var$dj(a, b, c);
    }
    throw Error($60e412df8c449d66$var$p(156, b.tag));
};
function $60e412df8c449d66$var$Fk(a, b) {
    return $60e412df8c449d66$var$ac(a, b);
}
function $60e412df8c449d66$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $60e412df8c449d66$var$Bg(a, b, c, d) {
    return new $60e412df8c449d66$var$$k(a, b, c, d);
}
function $60e412df8c449d66$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $60e412df8c449d66$var$Zk(a) {
    if ("function" === typeof a) return $60e412df8c449d66$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $60e412df8c449d66$var$Da) return 11;
        if (a === $60e412df8c449d66$var$Ga) return 14;
    }
    return 2;
}
function $60e412df8c449d66$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $60e412df8c449d66$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $60e412df8c449d66$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $60e412df8c449d66$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $60e412df8c449d66$var$ya:
            return $60e412df8c449d66$var$Tg(c.children, e, f, b);
        case $60e412df8c449d66$var$za:
            g = 8;
            e |= 8;
            break;
        case $60e412df8c449d66$var$Aa:
            return a = $60e412df8c449d66$var$Bg(12, c, b, e | 2), a.elementType = $60e412df8c449d66$var$Aa, a.lanes = f, a;
        case $60e412df8c449d66$var$Ea:
            return a = $60e412df8c449d66$var$Bg(13, c, b, e), a.elementType = $60e412df8c449d66$var$Ea, a.lanes = f, a;
        case $60e412df8c449d66$var$Fa:
            return a = $60e412df8c449d66$var$Bg(19, c, b, e), a.elementType = $60e412df8c449d66$var$Fa, a.lanes = f, a;
        case $60e412df8c449d66$var$Ia:
            return $60e412df8c449d66$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $60e412df8c449d66$var$Ba:
                    g = 10;
                    break a;
                case $60e412df8c449d66$var$Ca:
                    g = 9;
                    break a;
                case $60e412df8c449d66$var$Da:
                    g = 11;
                    break a;
                case $60e412df8c449d66$var$Ga:
                    g = 14;
                    break a;
                case $60e412df8c449d66$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($60e412df8c449d66$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $60e412df8c449d66$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $60e412df8c449d66$var$Tg(a, b, c, d) {
    a = $60e412df8c449d66$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $60e412df8c449d66$var$pj(a, b, c, d) {
    a = $60e412df8c449d66$var$Bg(22, a, d, b);
    a.elementType = $60e412df8c449d66$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $60e412df8c449d66$var$Qg(a, b, c) {
    a = $60e412df8c449d66$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $60e412df8c449d66$var$Sg(a, b, c) {
    b = $60e412df8c449d66$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $60e412df8c449d66$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $60e412df8c449d66$var$zc(0);
    this.expirationTimes = $60e412df8c449d66$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $60e412df8c449d66$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $60e412df8c449d66$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $60e412df8c449d66$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $60e412df8c449d66$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $60e412df8c449d66$var$kh(f);
    return a;
}
function $60e412df8c449d66$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $60e412df8c449d66$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $60e412df8c449d66$var$dl(a) {
    if (!a) return $60e412df8c449d66$var$Vf;
    a = a._reactInternals;
    a: {
        if ($60e412df8c449d66$var$Vb(a) !== a || 1 !== a.tag) throw Error($60e412df8c449d66$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($60e412df8c449d66$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($60e412df8c449d66$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($60e412df8c449d66$var$Zf(c)) return $60e412df8c449d66$var$bg(a, c, b);
    }
    return b;
}
function $60e412df8c449d66$var$el(a, b, c, d, e, f, g, h, k) {
    a = $60e412df8c449d66$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $60e412df8c449d66$var$dl(null);
    c = a.current;
    d = $60e412df8c449d66$var$R();
    e = $60e412df8c449d66$var$yi(c);
    f = $60e412df8c449d66$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $60e412df8c449d66$var$nh(c, f, e);
    a.current.lanes = e;
    $60e412df8c449d66$var$Ac(a, e, d);
    $60e412df8c449d66$var$Dk(a, d);
    return a;
}
function $60e412df8c449d66$var$fl(a, b, c, d) {
    var e = b.current, f = $60e412df8c449d66$var$R(), g = $60e412df8c449d66$var$yi(e);
    c = $60e412df8c449d66$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $60e412df8c449d66$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $60e412df8c449d66$var$nh(e, b, g);
    null !== a && ($60e412df8c449d66$var$gi(a, e, g, f), $60e412df8c449d66$var$oh(a, e, g));
    return g;
}
function $60e412df8c449d66$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $60e412df8c449d66$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $60e412df8c449d66$var$il(a, b) {
    $60e412df8c449d66$var$hl(a, b);
    (a = a.alternate) && $60e412df8c449d66$var$hl(a, b);
}
function $60e412df8c449d66$var$jl() {
    return null;
}
var $60e412df8c449d66$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $60e412df8c449d66$var$ll(a) {
    this._internalRoot = a;
}
$60e412df8c449d66$var$ml.prototype.render = $60e412df8c449d66$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($60e412df8c449d66$var$p(409));
    $60e412df8c449d66$var$fl(a, b, null, null);
};
$60e412df8c449d66$var$ml.prototype.unmount = $60e412df8c449d66$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $60e412df8c449d66$var$Rk(function() {
            $60e412df8c449d66$var$fl(null, a, null, null);
        });
        b[$60e412df8c449d66$var$uf] = null;
    }
};
function $60e412df8c449d66$var$ml(a) {
    this._internalRoot = a;
}
$60e412df8c449d66$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $60e412df8c449d66$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $60e412df8c449d66$var$Qc.length && 0 !== b && b < $60e412df8c449d66$var$Qc[c].priority; c++);
        $60e412df8c449d66$var$Qc.splice(c, 0, a);
        0 === c && $60e412df8c449d66$var$Vc(a);
    }
};
function $60e412df8c449d66$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $60e412df8c449d66$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $60e412df8c449d66$var$pl() {}
function $60e412df8c449d66$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $60e412df8c449d66$var$gl(g);
                f.call(a);
            };
        }
        var g = $60e412df8c449d66$var$el(b, d, a, 0, null, !1, !1, "", $60e412df8c449d66$var$pl);
        a._reactRootContainer = g;
        a[$60e412df8c449d66$var$uf] = g.current;
        $60e412df8c449d66$var$sf(8 === a.nodeType ? a.parentNode : a);
        $60e412df8c449d66$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $60e412df8c449d66$var$gl(k);
            h.call(a);
        };
    }
    var k = $60e412df8c449d66$var$bl(a, 0, !1, null, null, !1, !1, "", $60e412df8c449d66$var$pl);
    a._reactRootContainer = k;
    a[$60e412df8c449d66$var$uf] = k.current;
    $60e412df8c449d66$var$sf(8 === a.nodeType ? a.parentNode : a);
    $60e412df8c449d66$var$Rk(function() {
        $60e412df8c449d66$var$fl(b, k, c, d);
    });
    return k;
}
function $60e412df8c449d66$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $60e412df8c449d66$var$gl(g);
                h.call(a);
            };
        }
        $60e412df8c449d66$var$fl(b, g, a, e);
    } else g = $60e412df8c449d66$var$ql(c, b, a, e, d);
    return $60e412df8c449d66$var$gl(g);
}
$60e412df8c449d66$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $60e412df8c449d66$var$tc(b.pendingLanes);
                0 !== c && ($60e412df8c449d66$var$Cc(b, c | 1), $60e412df8c449d66$var$Dk(b, $60e412df8c449d66$var$B()), 0 === ($60e412df8c449d66$var$K & 6) && ($60e412df8c449d66$var$Gj = $60e412df8c449d66$var$B() + 500, $60e412df8c449d66$var$jg()));
            }
            break;
        case 13:
            $60e412df8c449d66$var$Rk(function() {
                var b = $60e412df8c449d66$var$ih(a, 1);
                if (null !== b) {
                    var c = $60e412df8c449d66$var$R();
                    $60e412df8c449d66$var$gi(b, a, 1, c);
                }
            }), $60e412df8c449d66$var$il(a, 1);
    }
};
$60e412df8c449d66$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $60e412df8c449d66$var$ih(a, 134217728);
        if (null !== b) {
            var c = $60e412df8c449d66$var$R();
            $60e412df8c449d66$var$gi(b, a, 134217728, c);
        }
        $60e412df8c449d66$var$il(a, 134217728);
    }
};
$60e412df8c449d66$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $60e412df8c449d66$var$yi(a), c = $60e412df8c449d66$var$ih(a, b);
        if (null !== c) {
            var d = $60e412df8c449d66$var$R();
            $60e412df8c449d66$var$gi(c, a, b, d);
        }
        $60e412df8c449d66$var$il(a, b);
    }
};
$60e412df8c449d66$var$Hc = function() {
    return $60e412df8c449d66$var$C;
};
$60e412df8c449d66$var$Ic = function(a, b) {
    var c = $60e412df8c449d66$var$C;
    try {
        return $60e412df8c449d66$var$C = a, b();
    } finally{
        $60e412df8c449d66$var$C = c;
    }
};
$60e412df8c449d66$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $60e412df8c449d66$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $60e412df8c449d66$var$Db(d);
                        if (!e) throw Error($60e412df8c449d66$var$p(90));
                        $60e412df8c449d66$var$Wa(d);
                        $60e412df8c449d66$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $60e412df8c449d66$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $60e412df8c449d66$var$fb(a, !!c.multiple, b, !1);
    }
};
$60e412df8c449d66$var$Gb = $60e412df8c449d66$var$Qk;
$60e412df8c449d66$var$Hb = $60e412df8c449d66$var$Rk;
var $60e412df8c449d66$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $60e412df8c449d66$var$Cb,
        $60e412df8c449d66$var$ue,
        $60e412df8c449d66$var$Db,
        $60e412df8c449d66$var$Eb,
        $60e412df8c449d66$var$Fb,
        $60e412df8c449d66$var$Qk
    ]
}, $60e412df8c449d66$var$tl = {
    findFiberByHostInstance: $60e412df8c449d66$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $60e412df8c449d66$var$ul = {
    bundleType: $60e412df8c449d66$var$tl.bundleType,
    version: $60e412df8c449d66$var$tl.version,
    rendererPackageName: $60e412df8c449d66$var$tl.rendererPackageName,
    rendererConfig: $60e412df8c449d66$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $60e412df8c449d66$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $60e412df8c449d66$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $60e412df8c449d66$var$tl.findFiberByHostInstance || $60e412df8c449d66$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $60e412df8c449d66$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$60e412df8c449d66$var$vl.isDisabled && $60e412df8c449d66$var$vl.supportsFiber) try {
        $60e412df8c449d66$var$kc = $60e412df8c449d66$var$vl.inject($60e412df8c449d66$var$ul), $60e412df8c449d66$var$lc = $60e412df8c449d66$var$vl;
    } catch (a) {}
}
$60e412df8c449d66$export$ae55be85d98224ed = $60e412df8c449d66$var$sl;
$60e412df8c449d66$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$60e412df8c449d66$var$nl(b)) throw Error($60e412df8c449d66$var$p(200));
    return $60e412df8c449d66$var$cl(a, b, null, c);
};
$60e412df8c449d66$export$882461b6382ed46c = function(a, b) {
    if (!$60e412df8c449d66$var$nl(a)) throw Error($60e412df8c449d66$var$p(299));
    var c = !1, d = "", e = $60e412df8c449d66$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $60e412df8c449d66$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$60e412df8c449d66$var$uf] = b.current;
    $60e412df8c449d66$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $60e412df8c449d66$var$ll(b);
};
$60e412df8c449d66$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($60e412df8c449d66$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($60e412df8c449d66$var$p(268, a));
    }
    a = $60e412df8c449d66$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$60e412df8c449d66$export$cd75ccfd720a3cd4 = function(a) {
    return $60e412df8c449d66$var$Rk(a);
};
$60e412df8c449d66$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$60e412df8c449d66$var$ol(b)) throw Error($60e412df8c449d66$var$p(200));
    return $60e412df8c449d66$var$rl(null, a, b, !0, c);
};
$60e412df8c449d66$export$757ceba2d55c277e = function(a, b, c) {
    if (!$60e412df8c449d66$var$nl(a)) throw Error($60e412df8c449d66$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $60e412df8c449d66$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $60e412df8c449d66$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$60e412df8c449d66$var$uf] = b.current;
    $60e412df8c449d66$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $60e412df8c449d66$var$ml(b);
};
$60e412df8c449d66$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$60e412df8c449d66$var$ol(b)) throw Error($60e412df8c449d66$var$p(200));
    return $60e412df8c449d66$var$rl(null, a, b, !1, c);
};
$60e412df8c449d66$export$502457920280e6be = function(a) {
    if (!$60e412df8c449d66$var$ol(a)) throw Error($60e412df8c449d66$var$p(40));
    return a._reactRootContainer ? ($60e412df8c449d66$var$Rk(function() {
        $60e412df8c449d66$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$60e412df8c449d66$var$uf] = null;
        });
    }), !0) : !1;
};
$60e412df8c449d66$export$c78a37762a8d58e1 = $60e412df8c449d66$var$Qk;
$60e412df8c449d66$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$60e412df8c449d66$var$ol(c)) throw Error($60e412df8c449d66$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($60e412df8c449d66$var$p(38));
    return $60e412df8c449d66$var$rl(a, b, c, !1, d);
};
$60e412df8c449d66$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("7Vk7y", function(module, exports) {
'use strict';

module.exports = (parcelRequire("iAR8A"));

});
parcelRegister("iAR8A", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $d894cec55a571349$export$c4744153514ff05d; }, function (v) { return $d894cec55a571349$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $d894cec55a571349$export$3e506c1ccc9cc1a7; }, function (v) { return $d894cec55a571349$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $d894cec55a571349$export$e26fe2ed2fa76875; }, function (v) { return $d894cec55a571349$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $d894cec55a571349$export$502329bbf4b505b1; }, function (v) { return $d894cec55a571349$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $d894cec55a571349$export$6e3807111c4874c4; }, function (v) { return $d894cec55a571349$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $d894cec55a571349$export$c27134553091fb3a; }, function (v) { return $d894cec55a571349$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $d894cec55a571349$export$33ee1acdc04fd2a2; }, function (v) { return $d894cec55a571349$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $d894cec55a571349$export$b00a404bbd5edef2; }, function (v) { return $d894cec55a571349$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $d894cec55a571349$export$8352ce38b91d0c62; }, function (v) { return $d894cec55a571349$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $d894cec55a571349$export$d66a1c1c77bd778b; }, function (v) { return $d894cec55a571349$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $d894cec55a571349$export$d3dfb8e4810cb555; }, function (v) { return $d894cec55a571349$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $d894cec55a571349$export$839f9183b0465a69; }, function (v) { return $d894cec55a571349$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $d894cec55a571349$export$72fdf0e06517287b; }, function (v) { return $d894cec55a571349$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $d894cec55a571349$export$4b844e58a3e414b4; }, function (v) { return $d894cec55a571349$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $d894cec55a571349$export$816d2913ae6b83b1; }, function (v) { return $d894cec55a571349$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $d894cec55a571349$export$61bcfe829111a1d0; }, function (v) { return $d894cec55a571349$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $d894cec55a571349$export$7ee8c9beb337bc3f; }, function (v) { return $d894cec55a571349$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $d894cec55a571349$export$b5836b71941fa3ed; }, function (v) { return $d894cec55a571349$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $d894cec55a571349$export$cf845f2c119da08a; }, function (v) { return $d894cec55a571349$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d894cec55a571349$export$c4744153514ff05d;
var $d894cec55a571349$export$3e506c1ccc9cc1a7;
var $d894cec55a571349$export$e26fe2ed2fa76875;
var $d894cec55a571349$export$502329bbf4b505b1;
var $d894cec55a571349$export$6e3807111c4874c4;
var $d894cec55a571349$export$c27134553091fb3a;
var $d894cec55a571349$export$33ee1acdc04fd2a2;
var $d894cec55a571349$export$b00a404bbd5edef2;
var $d894cec55a571349$export$8352ce38b91d0c62;
var $d894cec55a571349$export$d66a1c1c77bd778b;
var $d894cec55a571349$export$d3dfb8e4810cb555;
var $d894cec55a571349$export$839f9183b0465a69;
var $d894cec55a571349$export$72fdf0e06517287b;
var $d894cec55a571349$export$4b844e58a3e414b4;
var $d894cec55a571349$export$816d2913ae6b83b1;
var $d894cec55a571349$export$61bcfe829111a1d0;
var $d894cec55a571349$export$7ee8c9beb337bc3f;
var $d894cec55a571349$export$b5836b71941fa3ed;
var $d894cec55a571349$export$cf845f2c119da08a;
'use strict';
function $d894cec55a571349$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $d894cec55a571349$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $d894cec55a571349$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $d894cec55a571349$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $d894cec55a571349$var$g(C, c)) n < e && 0 > $d894cec55a571349$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $d894cec55a571349$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $d894cec55a571349$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $d894cec55a571349$var$l = performance;
    $d894cec55a571349$export$c4744153514ff05d = function() {
        return $d894cec55a571349$var$l.now();
    };
} else {
    var $d894cec55a571349$var$p = Date, $d894cec55a571349$var$q = $d894cec55a571349$var$p.now();
    $d894cec55a571349$export$c4744153514ff05d = function() {
        return $d894cec55a571349$var$p.now() - $d894cec55a571349$var$q;
    };
}
var $d894cec55a571349$var$r = [], $d894cec55a571349$var$t = [], $d894cec55a571349$var$u = 1, $d894cec55a571349$var$v = null, $d894cec55a571349$var$y = 3, $d894cec55a571349$var$z = !1, $d894cec55a571349$var$A = !1, $d894cec55a571349$var$B = !1, $d894cec55a571349$var$D = "function" === typeof setTimeout ? setTimeout : null, $d894cec55a571349$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $d894cec55a571349$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $d894cec55a571349$var$G(a) {
    for(var b = $d894cec55a571349$var$h($d894cec55a571349$var$t); null !== b;){
        if (null === b.callback) $d894cec55a571349$var$k($d894cec55a571349$var$t);
        else if (b.startTime <= a) $d894cec55a571349$var$k($d894cec55a571349$var$t), b.sortIndex = b.expirationTime, $d894cec55a571349$var$f($d894cec55a571349$var$r, b);
        else break;
        b = $d894cec55a571349$var$h($d894cec55a571349$var$t);
    }
}
function $d894cec55a571349$var$H(a) {
    $d894cec55a571349$var$B = !1;
    $d894cec55a571349$var$G(a);
    if (!$d894cec55a571349$var$A) {
        if (null !== $d894cec55a571349$var$h($d894cec55a571349$var$r)) $d894cec55a571349$var$A = !0, $d894cec55a571349$var$I($d894cec55a571349$var$J);
        else {
            var b = $d894cec55a571349$var$h($d894cec55a571349$var$t);
            null !== b && $d894cec55a571349$var$K($d894cec55a571349$var$H, b.startTime - a);
        }
    }
}
function $d894cec55a571349$var$J(a, b) {
    $d894cec55a571349$var$A = !1;
    $d894cec55a571349$var$B && ($d894cec55a571349$var$B = !1, $d894cec55a571349$var$E($d894cec55a571349$var$L), $d894cec55a571349$var$L = -1);
    $d894cec55a571349$var$z = !0;
    var c = $d894cec55a571349$var$y;
    try {
        $d894cec55a571349$var$G(b);
        for($d894cec55a571349$var$v = $d894cec55a571349$var$h($d894cec55a571349$var$r); null !== $d894cec55a571349$var$v && (!($d894cec55a571349$var$v.expirationTime > b) || a && !$d894cec55a571349$var$M());){
            var d = $d894cec55a571349$var$v.callback;
            if ("function" === typeof d) {
                $d894cec55a571349$var$v.callback = null;
                $d894cec55a571349$var$y = $d894cec55a571349$var$v.priorityLevel;
                var e = d($d894cec55a571349$var$v.expirationTime <= b);
                b = $d894cec55a571349$export$c4744153514ff05d();
                "function" === typeof e ? $d894cec55a571349$var$v.callback = e : $d894cec55a571349$var$v === $d894cec55a571349$var$h($d894cec55a571349$var$r) && $d894cec55a571349$var$k($d894cec55a571349$var$r);
                $d894cec55a571349$var$G(b);
            } else $d894cec55a571349$var$k($d894cec55a571349$var$r);
            $d894cec55a571349$var$v = $d894cec55a571349$var$h($d894cec55a571349$var$r);
        }
        if (null !== $d894cec55a571349$var$v) var w = !0;
        else {
            var m = $d894cec55a571349$var$h($d894cec55a571349$var$t);
            null !== m && $d894cec55a571349$var$K($d894cec55a571349$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $d894cec55a571349$var$v = null, $d894cec55a571349$var$y = c, $d894cec55a571349$var$z = !1;
    }
}
var $d894cec55a571349$var$N = !1, $d894cec55a571349$var$O = null, $d894cec55a571349$var$L = -1, $d894cec55a571349$var$P = 5, $d894cec55a571349$var$Q = -1;
function $d894cec55a571349$var$M() {
    return $d894cec55a571349$export$c4744153514ff05d() - $d894cec55a571349$var$Q < $d894cec55a571349$var$P ? !1 : !0;
}
function $d894cec55a571349$var$R() {
    if (null !== $d894cec55a571349$var$O) {
        var a = $d894cec55a571349$export$c4744153514ff05d();
        $d894cec55a571349$var$Q = a;
        var b = !0;
        try {
            b = $d894cec55a571349$var$O(!0, a);
        } finally{
            b ? $d894cec55a571349$var$S() : ($d894cec55a571349$var$N = !1, $d894cec55a571349$var$O = null);
        }
    } else $d894cec55a571349$var$N = !1;
}
var $d894cec55a571349$var$S;
if ("function" === typeof $d894cec55a571349$var$F) $d894cec55a571349$var$S = function() {
    $d894cec55a571349$var$F($d894cec55a571349$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $d894cec55a571349$var$T = new MessageChannel, $d894cec55a571349$var$U = $d894cec55a571349$var$T.port2;
    $d894cec55a571349$var$T.port1.onmessage = $d894cec55a571349$var$R;
    $d894cec55a571349$var$S = function() {
        $d894cec55a571349$var$U.postMessage(null);
    };
} else $d894cec55a571349$var$S = function() {
    $d894cec55a571349$var$D($d894cec55a571349$var$R, 0);
};
function $d894cec55a571349$var$I(a) {
    $d894cec55a571349$var$O = a;
    $d894cec55a571349$var$N || ($d894cec55a571349$var$N = !0, $d894cec55a571349$var$S());
}
function $d894cec55a571349$var$K(a, b) {
    $d894cec55a571349$var$L = $d894cec55a571349$var$D(function() {
        a($d894cec55a571349$export$c4744153514ff05d());
    }, b);
}
$d894cec55a571349$export$3e506c1ccc9cc1a7 = 5;
$d894cec55a571349$export$e26fe2ed2fa76875 = 1;
$d894cec55a571349$export$502329bbf4b505b1 = 4;
$d894cec55a571349$export$6e3807111c4874c4 = 3;
$d894cec55a571349$export$c27134553091fb3a = null;
$d894cec55a571349$export$33ee1acdc04fd2a2 = 2;
$d894cec55a571349$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$d894cec55a571349$export$8352ce38b91d0c62 = function() {
    $d894cec55a571349$var$A || $d894cec55a571349$var$z || ($d894cec55a571349$var$A = !0, $d894cec55a571349$var$I($d894cec55a571349$var$J));
};
$d894cec55a571349$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $d894cec55a571349$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$d894cec55a571349$export$d3dfb8e4810cb555 = function() {
    return $d894cec55a571349$var$y;
};
$d894cec55a571349$export$839f9183b0465a69 = function() {
    return $d894cec55a571349$var$h($d894cec55a571349$var$r);
};
$d894cec55a571349$export$72fdf0e06517287b = function(a) {
    switch($d894cec55a571349$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $d894cec55a571349$var$y;
    }
    var c = $d894cec55a571349$var$y;
    $d894cec55a571349$var$y = b;
    try {
        return a();
    } finally{
        $d894cec55a571349$var$y = c;
    }
};
$d894cec55a571349$export$4b844e58a3e414b4 = function() {};
$d894cec55a571349$export$816d2913ae6b83b1 = function() {};
$d894cec55a571349$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $d894cec55a571349$var$y;
    $d894cec55a571349$var$y = a;
    try {
        return b();
    } finally{
        $d894cec55a571349$var$y = c;
    }
};
$d894cec55a571349$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $d894cec55a571349$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $d894cec55a571349$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $d894cec55a571349$var$f($d894cec55a571349$var$t, a), null === $d894cec55a571349$var$h($d894cec55a571349$var$r) && a === $d894cec55a571349$var$h($d894cec55a571349$var$t) && ($d894cec55a571349$var$B ? ($d894cec55a571349$var$E($d894cec55a571349$var$L), $d894cec55a571349$var$L = -1) : $d894cec55a571349$var$B = !0, $d894cec55a571349$var$K($d894cec55a571349$var$H, c - d))) : (a.sortIndex = e, $d894cec55a571349$var$f($d894cec55a571349$var$r, a), $d894cec55a571349$var$A || $d894cec55a571349$var$z || ($d894cec55a571349$var$A = !0, $d894cec55a571349$var$I($d894cec55a571349$var$J)));
    return a;
};
$d894cec55a571349$export$b5836b71941fa3ed = $d894cec55a571349$var$M;
$d894cec55a571349$export$cf845f2c119da08a = function(a) {
    var b = $d894cec55a571349$var$y;
    return function() {
        var c = $d894cec55a571349$var$y;
        $d894cec55a571349$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $d894cec55a571349$var$y = c;
        }
    };
};

});



parcelRegister("hftWx", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $8eJJq = parcelRequire("8eJJq");
function $c8eb107341c78519$var$emptyFunction() {}
function $c8eb107341c78519$var$emptyFunctionWithReset() {}
$c8eb107341c78519$var$emptyFunctionWithReset.resetWarningCache = $c8eb107341c78519$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $8eJJq) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $c8eb107341c78519$var$emptyFunctionWithReset,
        resetWarningCache: $c8eb107341c78519$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("8eJJq", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $5ff31aea21160c94$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $5ff31aea21160c94$var$ReactPropTypesSecret;

});


parcelRegister("axZz6", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $7adcbe08fe661985$export$2b8d127b894957b9; }, function (v) { return $7adcbe08fe661985$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $7adcbe08fe661985$export$cea3a54a6425200c; }, function (v) { return $7adcbe08fe661985$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $7adcbe08fe661985$export$a7c73072b1a182ae; }, function (v) { return $7adcbe08fe661985$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $7adcbe08fe661985$export$9f27bc3417b4524d; }, function (v) { return $7adcbe08fe661985$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $7adcbe08fe661985$export$db77ccec0bb4ccac; }, function (v) { return $7adcbe08fe661985$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $7adcbe08fe661985$export$8392c0c9d3dcbd35; }, function (v) { return $7adcbe08fe661985$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $7adcbe08fe661985$export$ffb0004e005737fa; }, function (v) { return $7adcbe08fe661985$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $7adcbe08fe661985$export$b624eff549462981; }, function (v) { return $7adcbe08fe661985$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $7adcbe08fe661985$export$7897aa7841a5380c; }, function (v) { return $7adcbe08fe661985$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $7adcbe08fe661985$export$602eac185826482c; }, function (v) { return $7adcbe08fe661985$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $7adcbe08fe661985$export$e2c29f18771995cb; }, function (v) { return $7adcbe08fe661985$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $7adcbe08fe661985$export$5f8d39834fd61797; }, function (v) { return $7adcbe08fe661985$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $7adcbe08fe661985$export$74bf444e3cd11ea5; }, function (v) { return $7adcbe08fe661985$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $7adcbe08fe661985$export$92387174baf9b227; }, function (v) { return $7adcbe08fe661985$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $7adcbe08fe661985$export$ec112efeb987d9c6; }, function (v) { return $7adcbe08fe661985$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $7adcbe08fe661985$export$b706b080d889d2c9; }, function (v) { return $7adcbe08fe661985$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $7adcbe08fe661985$export$5be5a87408f70ddc; }, function (v) { return $7adcbe08fe661985$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $7adcbe08fe661985$export$45a5e7f76e0caa8d; }, function (v) { return $7adcbe08fe661985$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $7adcbe08fe661985$export$455c2e768291efa6; }, function (v) { return $7adcbe08fe661985$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $7adcbe08fe661985$export$9522e17588c12572; }, function (v) { return $7adcbe08fe661985$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $7adcbe08fe661985$export$2110ac352bb060b9; }, function (v) { return $7adcbe08fe661985$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $7adcbe08fe661985$export$56885ab8b9c456ab; }, function (v) { return $7adcbe08fe661985$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $7adcbe08fe661985$export$d927fcb6adf8f9de; }, function (v) { return $7adcbe08fe661985$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $7adcbe08fe661985$export$b82d16f27459e05a; }, function (v) { return $7adcbe08fe661985$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $7adcbe08fe661985$export$522c17b4f5e123e8; }, function (v) { return $7adcbe08fe661985$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $7adcbe08fe661985$export$1aabd8a0274ecfd6; }, function (v) { return $7adcbe08fe661985$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $7adcbe08fe661985$export$9b621391a187a31a; }, function (v) { return $7adcbe08fe661985$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $7adcbe08fe661985$export$f5bbd400c2f4426f; }, function (v) { return $7adcbe08fe661985$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7adcbe08fe661985$export$2b8d127b894957b9;
var $7adcbe08fe661985$export$cea3a54a6425200c;
var $7adcbe08fe661985$export$a7c73072b1a182ae;
var $7adcbe08fe661985$export$9f27bc3417b4524d;
var $7adcbe08fe661985$export$db77ccec0bb4ccac;
var $7adcbe08fe661985$export$8392c0c9d3dcbd35;
var $7adcbe08fe661985$export$ffb0004e005737fa;
var $7adcbe08fe661985$export$b624eff549462981;
var $7adcbe08fe661985$export$7897aa7841a5380c;
var $7adcbe08fe661985$export$602eac185826482c;
var $7adcbe08fe661985$export$e2c29f18771995cb;
var $7adcbe08fe661985$export$5f8d39834fd61797;
var $7adcbe08fe661985$export$74bf444e3cd11ea5;
var $7adcbe08fe661985$export$92387174baf9b227;
var $7adcbe08fe661985$export$ec112efeb987d9c6;
var $7adcbe08fe661985$export$b706b080d889d2c9;
var $7adcbe08fe661985$export$5be5a87408f70ddc;
var $7adcbe08fe661985$export$45a5e7f76e0caa8d;
var $7adcbe08fe661985$export$455c2e768291efa6;
var $7adcbe08fe661985$export$9522e17588c12572;
var $7adcbe08fe661985$export$2110ac352bb060b9;
var $7adcbe08fe661985$export$56885ab8b9c456ab;
var $7adcbe08fe661985$export$d927fcb6adf8f9de;
var $7adcbe08fe661985$export$b82d16f27459e05a;
var $7adcbe08fe661985$export$522c17b4f5e123e8;
var $7adcbe08fe661985$export$1aabd8a0274ecfd6;
var $7adcbe08fe661985$export$9b621391a187a31a;
var $7adcbe08fe661985$export$f5bbd400c2f4426f;
'use strict';
var $7adcbe08fe661985$var$b = "function" === typeof Symbol && Symbol.for, $7adcbe08fe661985$var$c = $7adcbe08fe661985$var$b ? Symbol.for("react.element") : 60103, $7adcbe08fe661985$var$d = $7adcbe08fe661985$var$b ? Symbol.for("react.portal") : 60106, $7adcbe08fe661985$var$e = $7adcbe08fe661985$var$b ? Symbol.for("react.fragment") : 60107, $7adcbe08fe661985$var$f = $7adcbe08fe661985$var$b ? Symbol.for("react.strict_mode") : 60108, $7adcbe08fe661985$var$g = $7adcbe08fe661985$var$b ? Symbol.for("react.profiler") : 60114, $7adcbe08fe661985$var$h = $7adcbe08fe661985$var$b ? Symbol.for("react.provider") : 60109, $7adcbe08fe661985$var$k = $7adcbe08fe661985$var$b ? Symbol.for("react.context") : 60110, $7adcbe08fe661985$var$l = $7adcbe08fe661985$var$b ? Symbol.for("react.async_mode") : 60111, $7adcbe08fe661985$var$m = $7adcbe08fe661985$var$b ? Symbol.for("react.concurrent_mode") : 60111, $7adcbe08fe661985$var$n = $7adcbe08fe661985$var$b ? Symbol.for("react.forward_ref") : 60112, $7adcbe08fe661985$var$p = $7adcbe08fe661985$var$b ? Symbol.for("react.suspense") : 60113, $7adcbe08fe661985$var$q = $7adcbe08fe661985$var$b ? Symbol.for("react.suspense_list") : 60120, $7adcbe08fe661985$var$r = $7adcbe08fe661985$var$b ? Symbol.for("react.memo") : 60115, $7adcbe08fe661985$var$t = $7adcbe08fe661985$var$b ? Symbol.for("react.lazy") : 60116, $7adcbe08fe661985$var$v = $7adcbe08fe661985$var$b ? Symbol.for("react.block") : 60121, $7adcbe08fe661985$var$w = $7adcbe08fe661985$var$b ? Symbol.for("react.fundamental") : 60117, $7adcbe08fe661985$var$x = $7adcbe08fe661985$var$b ? Symbol.for("react.responder") : 60118, $7adcbe08fe661985$var$y = $7adcbe08fe661985$var$b ? Symbol.for("react.scope") : 60119;
function $7adcbe08fe661985$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $7adcbe08fe661985$var$c:
                switch(a = a.type, a){
                    case $7adcbe08fe661985$var$l:
                    case $7adcbe08fe661985$var$m:
                    case $7adcbe08fe661985$var$e:
                    case $7adcbe08fe661985$var$g:
                    case $7adcbe08fe661985$var$f:
                    case $7adcbe08fe661985$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $7adcbe08fe661985$var$k:
                            case $7adcbe08fe661985$var$n:
                            case $7adcbe08fe661985$var$t:
                            case $7adcbe08fe661985$var$r:
                            case $7adcbe08fe661985$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $7adcbe08fe661985$var$d:
                return u;
        }
    }
}
function $7adcbe08fe661985$var$A(a) {
    return $7adcbe08fe661985$var$z(a) === $7adcbe08fe661985$var$m;
}
$7adcbe08fe661985$export$2b8d127b894957b9 = $7adcbe08fe661985$var$l;
$7adcbe08fe661985$export$cea3a54a6425200c = $7adcbe08fe661985$var$m;
$7adcbe08fe661985$export$a7c73072b1a182ae = $7adcbe08fe661985$var$k;
$7adcbe08fe661985$export$9f27bc3417b4524d = $7adcbe08fe661985$var$h;
$7adcbe08fe661985$export$db77ccec0bb4ccac = $7adcbe08fe661985$var$c;
$7adcbe08fe661985$export$8392c0c9d3dcbd35 = $7adcbe08fe661985$var$n;
$7adcbe08fe661985$export$ffb0004e005737fa = $7adcbe08fe661985$var$e;
$7adcbe08fe661985$export$b624eff549462981 = $7adcbe08fe661985$var$t;
$7adcbe08fe661985$export$7897aa7841a5380c = $7adcbe08fe661985$var$r;
$7adcbe08fe661985$export$602eac185826482c = $7adcbe08fe661985$var$d;
$7adcbe08fe661985$export$e2c29f18771995cb = $7adcbe08fe661985$var$g;
$7adcbe08fe661985$export$5f8d39834fd61797 = $7adcbe08fe661985$var$f;
$7adcbe08fe661985$export$74bf444e3cd11ea5 = $7adcbe08fe661985$var$p;
$7adcbe08fe661985$export$92387174baf9b227 = function(a) {
    return $7adcbe08fe661985$var$A(a) || $7adcbe08fe661985$var$z(a) === $7adcbe08fe661985$var$l;
};
$7adcbe08fe661985$export$ec112efeb987d9c6 = $7adcbe08fe661985$var$A;
$7adcbe08fe661985$export$b706b080d889d2c9 = function(a) {
    return $7adcbe08fe661985$var$z(a) === $7adcbe08fe661985$var$k;
};
$7adcbe08fe661985$export$5be5a87408f70ddc = function(a) {
    return $7adcbe08fe661985$var$z(a) === $7adcbe08fe661985$var$h;
};
$7adcbe08fe661985$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $7adcbe08fe661985$var$c;
};
$7adcbe08fe661985$export$455c2e768291efa6 = function(a) {
    return $7adcbe08fe661985$var$z(a) === $7adcbe08fe661985$var$n;
};
$7adcbe08fe661985$export$9522e17588c12572 = function(a) {
    return $7adcbe08fe661985$var$z(a) === $7adcbe08fe661985$var$e;
};
$7adcbe08fe661985$export$2110ac352bb060b9 = function(a) {
    return $7adcbe08fe661985$var$z(a) === $7adcbe08fe661985$var$t;
};
$7adcbe08fe661985$export$56885ab8b9c456ab = function(a) {
    return $7adcbe08fe661985$var$z(a) === $7adcbe08fe661985$var$r;
};
$7adcbe08fe661985$export$d927fcb6adf8f9de = function(a) {
    return $7adcbe08fe661985$var$z(a) === $7adcbe08fe661985$var$d;
};
$7adcbe08fe661985$export$b82d16f27459e05a = function(a) {
    return $7adcbe08fe661985$var$z(a) === $7adcbe08fe661985$var$g;
};
$7adcbe08fe661985$export$522c17b4f5e123e8 = function(a) {
    return $7adcbe08fe661985$var$z(a) === $7adcbe08fe661985$var$f;
};
$7adcbe08fe661985$export$1aabd8a0274ecfd6 = function(a) {
    return $7adcbe08fe661985$var$z(a) === $7adcbe08fe661985$var$p;
};
$7adcbe08fe661985$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $7adcbe08fe661985$var$e || a === $7adcbe08fe661985$var$m || a === $7adcbe08fe661985$var$g || a === $7adcbe08fe661985$var$f || a === $7adcbe08fe661985$var$p || a === $7adcbe08fe661985$var$q || "object" === typeof a && null !== a && (a.$$typeof === $7adcbe08fe661985$var$t || a.$$typeof === $7adcbe08fe661985$var$r || a.$$typeof === $7adcbe08fe661985$var$h || a.$$typeof === $7adcbe08fe661985$var$k || a.$$typeof === $7adcbe08fe661985$var$n || a.$$typeof === $7adcbe08fe661985$var$w || a.$$typeof === $7adcbe08fe661985$var$x || a.$$typeof === $7adcbe08fe661985$var$y || a.$$typeof === $7adcbe08fe661985$var$v);
};
$7adcbe08fe661985$export$f5bbd400c2f4426f = $7adcbe08fe661985$var$z;

});

parcelRegister("dYDVz", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $a2cfd9bb3782a117$export$2b8d127b894957b9; }, function (v) { return $a2cfd9bb3782a117$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $a2cfd9bb3782a117$export$cea3a54a6425200c; }, function (v) { return $a2cfd9bb3782a117$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $a2cfd9bb3782a117$export$a7c73072b1a182ae; }, function (v) { return $a2cfd9bb3782a117$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $a2cfd9bb3782a117$export$9f27bc3417b4524d; }, function (v) { return $a2cfd9bb3782a117$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $a2cfd9bb3782a117$export$db77ccec0bb4ccac; }, function (v) { return $a2cfd9bb3782a117$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $a2cfd9bb3782a117$export$8392c0c9d3dcbd35; }, function (v) { return $a2cfd9bb3782a117$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $a2cfd9bb3782a117$export$ffb0004e005737fa; }, function (v) { return $a2cfd9bb3782a117$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $a2cfd9bb3782a117$export$b624eff549462981; }, function (v) { return $a2cfd9bb3782a117$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $a2cfd9bb3782a117$export$7897aa7841a5380c; }, function (v) { return $a2cfd9bb3782a117$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $a2cfd9bb3782a117$export$602eac185826482c; }, function (v) { return $a2cfd9bb3782a117$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $a2cfd9bb3782a117$export$e2c29f18771995cb; }, function (v) { return $a2cfd9bb3782a117$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $a2cfd9bb3782a117$export$5f8d39834fd61797; }, function (v) { return $a2cfd9bb3782a117$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $a2cfd9bb3782a117$export$74bf444e3cd11ea5; }, function (v) { return $a2cfd9bb3782a117$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $a2cfd9bb3782a117$export$92387174baf9b227; }, function (v) { return $a2cfd9bb3782a117$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $a2cfd9bb3782a117$export$ec112efeb987d9c6; }, function (v) { return $a2cfd9bb3782a117$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $a2cfd9bb3782a117$export$b706b080d889d2c9; }, function (v) { return $a2cfd9bb3782a117$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $a2cfd9bb3782a117$export$5be5a87408f70ddc; }, function (v) { return $a2cfd9bb3782a117$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $a2cfd9bb3782a117$export$45a5e7f76e0caa8d; }, function (v) { return $a2cfd9bb3782a117$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $a2cfd9bb3782a117$export$455c2e768291efa6; }, function (v) { return $a2cfd9bb3782a117$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $a2cfd9bb3782a117$export$9522e17588c12572; }, function (v) { return $a2cfd9bb3782a117$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $a2cfd9bb3782a117$export$2110ac352bb060b9; }, function (v) { return $a2cfd9bb3782a117$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $a2cfd9bb3782a117$export$56885ab8b9c456ab; }, function (v) { return $a2cfd9bb3782a117$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $a2cfd9bb3782a117$export$d927fcb6adf8f9de; }, function (v) { return $a2cfd9bb3782a117$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $a2cfd9bb3782a117$export$b82d16f27459e05a; }, function (v) { return $a2cfd9bb3782a117$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $a2cfd9bb3782a117$export$522c17b4f5e123e8; }, function (v) { return $a2cfd9bb3782a117$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $a2cfd9bb3782a117$export$1aabd8a0274ecfd6; }, function (v) { return $a2cfd9bb3782a117$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $a2cfd9bb3782a117$export$9b621391a187a31a; }, function (v) { return $a2cfd9bb3782a117$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $a2cfd9bb3782a117$export$f5bbd400c2f4426f; }, function (v) { return $a2cfd9bb3782a117$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a2cfd9bb3782a117$export$2b8d127b894957b9;
var $a2cfd9bb3782a117$export$cea3a54a6425200c;
var $a2cfd9bb3782a117$export$a7c73072b1a182ae;
var $a2cfd9bb3782a117$export$9f27bc3417b4524d;
var $a2cfd9bb3782a117$export$db77ccec0bb4ccac;
var $a2cfd9bb3782a117$export$8392c0c9d3dcbd35;
var $a2cfd9bb3782a117$export$ffb0004e005737fa;
var $a2cfd9bb3782a117$export$b624eff549462981;
var $a2cfd9bb3782a117$export$7897aa7841a5380c;
var $a2cfd9bb3782a117$export$602eac185826482c;
var $a2cfd9bb3782a117$export$e2c29f18771995cb;
var $a2cfd9bb3782a117$export$5f8d39834fd61797;
var $a2cfd9bb3782a117$export$74bf444e3cd11ea5;
var $a2cfd9bb3782a117$export$92387174baf9b227;
var $a2cfd9bb3782a117$export$ec112efeb987d9c6;
var $a2cfd9bb3782a117$export$b706b080d889d2c9;
var $a2cfd9bb3782a117$export$5be5a87408f70ddc;
var $a2cfd9bb3782a117$export$45a5e7f76e0caa8d;
var $a2cfd9bb3782a117$export$455c2e768291efa6;
var $a2cfd9bb3782a117$export$9522e17588c12572;
var $a2cfd9bb3782a117$export$2110ac352bb060b9;
var $a2cfd9bb3782a117$export$56885ab8b9c456ab;
var $a2cfd9bb3782a117$export$d927fcb6adf8f9de;
var $a2cfd9bb3782a117$export$b82d16f27459e05a;
var $a2cfd9bb3782a117$export$522c17b4f5e123e8;
var $a2cfd9bb3782a117$export$1aabd8a0274ecfd6;
var $a2cfd9bb3782a117$export$9b621391a187a31a;
var $a2cfd9bb3782a117$export$f5bbd400c2f4426f;
'use strict';
var $a2cfd9bb3782a117$var$b = "function" === typeof Symbol && Symbol.for, $a2cfd9bb3782a117$var$c = $a2cfd9bb3782a117$var$b ? Symbol.for("react.element") : 60103, $a2cfd9bb3782a117$var$d = $a2cfd9bb3782a117$var$b ? Symbol.for("react.portal") : 60106, $a2cfd9bb3782a117$var$e = $a2cfd9bb3782a117$var$b ? Symbol.for("react.fragment") : 60107, $a2cfd9bb3782a117$var$f = $a2cfd9bb3782a117$var$b ? Symbol.for("react.strict_mode") : 60108, $a2cfd9bb3782a117$var$g = $a2cfd9bb3782a117$var$b ? Symbol.for("react.profiler") : 60114, $a2cfd9bb3782a117$var$h = $a2cfd9bb3782a117$var$b ? Symbol.for("react.provider") : 60109, $a2cfd9bb3782a117$var$k = $a2cfd9bb3782a117$var$b ? Symbol.for("react.context") : 60110, $a2cfd9bb3782a117$var$l = $a2cfd9bb3782a117$var$b ? Symbol.for("react.async_mode") : 60111, $a2cfd9bb3782a117$var$m = $a2cfd9bb3782a117$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a2cfd9bb3782a117$var$n = $a2cfd9bb3782a117$var$b ? Symbol.for("react.forward_ref") : 60112, $a2cfd9bb3782a117$var$p = $a2cfd9bb3782a117$var$b ? Symbol.for("react.suspense") : 60113, $a2cfd9bb3782a117$var$q = $a2cfd9bb3782a117$var$b ? Symbol.for("react.suspense_list") : 60120, $a2cfd9bb3782a117$var$r = $a2cfd9bb3782a117$var$b ? Symbol.for("react.memo") : 60115, $a2cfd9bb3782a117$var$t = $a2cfd9bb3782a117$var$b ? Symbol.for("react.lazy") : 60116, $a2cfd9bb3782a117$var$v = $a2cfd9bb3782a117$var$b ? Symbol.for("react.block") : 60121, $a2cfd9bb3782a117$var$w = $a2cfd9bb3782a117$var$b ? Symbol.for("react.fundamental") : 60117, $a2cfd9bb3782a117$var$x = $a2cfd9bb3782a117$var$b ? Symbol.for("react.responder") : 60118, $a2cfd9bb3782a117$var$y = $a2cfd9bb3782a117$var$b ? Symbol.for("react.scope") : 60119;
function $a2cfd9bb3782a117$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a2cfd9bb3782a117$var$c:
                switch(a = a.type, a){
                    case $a2cfd9bb3782a117$var$l:
                    case $a2cfd9bb3782a117$var$m:
                    case $a2cfd9bb3782a117$var$e:
                    case $a2cfd9bb3782a117$var$g:
                    case $a2cfd9bb3782a117$var$f:
                    case $a2cfd9bb3782a117$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a2cfd9bb3782a117$var$k:
                            case $a2cfd9bb3782a117$var$n:
                            case $a2cfd9bb3782a117$var$t:
                            case $a2cfd9bb3782a117$var$r:
                            case $a2cfd9bb3782a117$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a2cfd9bb3782a117$var$d:
                return u;
        }
    }
}
function $a2cfd9bb3782a117$var$A(a) {
    return $a2cfd9bb3782a117$var$z(a) === $a2cfd9bb3782a117$var$m;
}
$a2cfd9bb3782a117$export$2b8d127b894957b9 = $a2cfd9bb3782a117$var$l;
$a2cfd9bb3782a117$export$cea3a54a6425200c = $a2cfd9bb3782a117$var$m;
$a2cfd9bb3782a117$export$a7c73072b1a182ae = $a2cfd9bb3782a117$var$k;
$a2cfd9bb3782a117$export$9f27bc3417b4524d = $a2cfd9bb3782a117$var$h;
$a2cfd9bb3782a117$export$db77ccec0bb4ccac = $a2cfd9bb3782a117$var$c;
$a2cfd9bb3782a117$export$8392c0c9d3dcbd35 = $a2cfd9bb3782a117$var$n;
$a2cfd9bb3782a117$export$ffb0004e005737fa = $a2cfd9bb3782a117$var$e;
$a2cfd9bb3782a117$export$b624eff549462981 = $a2cfd9bb3782a117$var$t;
$a2cfd9bb3782a117$export$7897aa7841a5380c = $a2cfd9bb3782a117$var$r;
$a2cfd9bb3782a117$export$602eac185826482c = $a2cfd9bb3782a117$var$d;
$a2cfd9bb3782a117$export$e2c29f18771995cb = $a2cfd9bb3782a117$var$g;
$a2cfd9bb3782a117$export$5f8d39834fd61797 = $a2cfd9bb3782a117$var$f;
$a2cfd9bb3782a117$export$74bf444e3cd11ea5 = $a2cfd9bb3782a117$var$p;
$a2cfd9bb3782a117$export$92387174baf9b227 = function(a) {
    return $a2cfd9bb3782a117$var$A(a) || $a2cfd9bb3782a117$var$z(a) === $a2cfd9bb3782a117$var$l;
};
$a2cfd9bb3782a117$export$ec112efeb987d9c6 = $a2cfd9bb3782a117$var$A;
$a2cfd9bb3782a117$export$b706b080d889d2c9 = function(a) {
    return $a2cfd9bb3782a117$var$z(a) === $a2cfd9bb3782a117$var$k;
};
$a2cfd9bb3782a117$export$5be5a87408f70ddc = function(a) {
    return $a2cfd9bb3782a117$var$z(a) === $a2cfd9bb3782a117$var$h;
};
$a2cfd9bb3782a117$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a2cfd9bb3782a117$var$c;
};
$a2cfd9bb3782a117$export$455c2e768291efa6 = function(a) {
    return $a2cfd9bb3782a117$var$z(a) === $a2cfd9bb3782a117$var$n;
};
$a2cfd9bb3782a117$export$9522e17588c12572 = function(a) {
    return $a2cfd9bb3782a117$var$z(a) === $a2cfd9bb3782a117$var$e;
};
$a2cfd9bb3782a117$export$2110ac352bb060b9 = function(a) {
    return $a2cfd9bb3782a117$var$z(a) === $a2cfd9bb3782a117$var$t;
};
$a2cfd9bb3782a117$export$56885ab8b9c456ab = function(a) {
    return $a2cfd9bb3782a117$var$z(a) === $a2cfd9bb3782a117$var$r;
};
$a2cfd9bb3782a117$export$d927fcb6adf8f9de = function(a) {
    return $a2cfd9bb3782a117$var$z(a) === $a2cfd9bb3782a117$var$d;
};
$a2cfd9bb3782a117$export$b82d16f27459e05a = function(a) {
    return $a2cfd9bb3782a117$var$z(a) === $a2cfd9bb3782a117$var$g;
};
$a2cfd9bb3782a117$export$522c17b4f5e123e8 = function(a) {
    return $a2cfd9bb3782a117$var$z(a) === $a2cfd9bb3782a117$var$f;
};
$a2cfd9bb3782a117$export$1aabd8a0274ecfd6 = function(a) {
    return $a2cfd9bb3782a117$var$z(a) === $a2cfd9bb3782a117$var$p;
};
$a2cfd9bb3782a117$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a2cfd9bb3782a117$var$e || a === $a2cfd9bb3782a117$var$m || a === $a2cfd9bb3782a117$var$g || a === $a2cfd9bb3782a117$var$f || a === $a2cfd9bb3782a117$var$p || a === $a2cfd9bb3782a117$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a2cfd9bb3782a117$var$t || a.$$typeof === $a2cfd9bb3782a117$var$r || a.$$typeof === $a2cfd9bb3782a117$var$h || a.$$typeof === $a2cfd9bb3782a117$var$k || a.$$typeof === $a2cfd9bb3782a117$var$n || a.$$typeof === $a2cfd9bb3782a117$var$w || a.$$typeof === $a2cfd9bb3782a117$var$x || a.$$typeof === $a2cfd9bb3782a117$var$y || a.$$typeof === $a2cfd9bb3782a117$var$v);
};
$a2cfd9bb3782a117$export$f5bbd400c2f4426f = $a2cfd9bb3782a117$var$z;

});

parcelRegister("eVk2i", function(module, exports) {

var $f7sIv = parcelRequire("f7sIv");
var $add5ee499482fd60$var$_typeof = $f7sIv.default;
function $add5ee499482fd60$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $add5ee499482fd60$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $add5ee499482fd60$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($add5ee499482fd60$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $add5ee499482fd60$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("f7sIv", function(module, exports) {
function $b01dc90613e433d9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $b01dc90613e433d9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $b01dc90613e433d9$var$_typeof(o);
}
module.exports = $b01dc90613e433d9$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("3ZxP0", function(module, exports) {
// Save global object in a variable
var __global__ = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || typeof $parcel$global !== 'undefined' && $parcel$global;
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = __global__.DOMException;
    }
    F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
    return new F();
}();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis1) {
    var irrelevant = function(exports1) {
        /* eslint-disable no-prototype-builtins */ var g = typeof globalThis1 !== 'undefined' && globalThis1 || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
        typeof $parcel$global !== 'undefined' && $parcel$global || {};
        var support = {
            searchParams: 'URLSearchParams' in g,
            iterable: 'Symbol' in g && 'iterator' in Symbol,
            blob: 'FileReader' in g && 'Blob' in g && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in g,
            arrayBuffer: 'ArrayBuffer' in g
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body._noBody) return;
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
            var encoding = match ? match[1] : 'utf-8';
            reader.readAsText(blob, encoding);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ // eslint-disable-next-line no-self-assign
                this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) {
                    this._noBody = true;
                    this._bodyText = '';
                } else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) this.blob = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                    this._bodyArrayBuffer
                ]));
                else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                else return Promise.resolve(new Blob([
                    this._bodyText
                ]));
            };
            this.arrayBuffer = function() {
                if (this._bodyArrayBuffer) {
                    var isConsumed = consumed(this);
                    if (isConsumed) return isConsumed;
                    else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                    else return Promise.resolve(this._bodyArrayBuffer);
                } else if (support.blob) return this.blob().then(readBlobAsArrayBuffer);
                else throw new Error('could not read as ArrayBuffer');
            };
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'CONNECT',
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'PATCH',
            'POST',
            'PUT',
            'TRACE'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal || function() {
                if ('AbortController' in g) {
                    var ctrl = new AbortController();
                    return ctrl.signal;
                }
            }();
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
            if (this.method === 'GET' || this.method === 'HEAD') {
                if (options.cache === 'no-store' || options.cache === 'no-cache') {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split('\r').map(function(header) {
                return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    try {
                        headers.append(key, value);
                    } catch (error) {
                        console.warn('Response ' + error.message);
                    }
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 200,
                statusText: ''
            });
            response.ok = false;
            response.status = 0;
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = g.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    // This check if specifically for when a user fetches a file locally from the file system
                    // Only if the status is out of a normal range
                    if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
                    else options.status = xhr.status;
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request failed'));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request timed out'));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports1.DOMException('Aborted', 'AbortError'));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === '' && g.location.href ? g.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr) {
                    if (support.blob) xhr.responseType = 'blob';
                    else if (support.arrayBuffer) xhr.responseType = 'arraybuffer';
                }
                if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers || g.Headers && init.headers instanceof g.Headers)) {
                    var names = [];
                    Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                        names.push(normalizeName(name));
                        xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                    });
                    request.headers.forEach(function(value, name) {
                        if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
                    });
                } else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!g.fetch) {
            g.fetch = fetch;
            g.Headers = Headers;
            g.Request = Request;
            g.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
        return exports1;
    }({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("k5HZY", function(module, exports) {



(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        'module',
        './clipboard-action',
        'tiny-emitter',
        'good-listener'
    ], factory);
    else {
        var mod;
        factory(module, (parcelRequire("f3BXb")), (parcelRequire("69pXx")), (parcelRequire("af7JM")));
    }
})(this, function(module1, _clipboardAction, _tinyEmitter, _goodListener) {
    'use strict';
    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);
    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);
    var _goodListener2 = _interopRequireDefault(_goodListener);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var _createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var Clipboard = function(_Emitter) {
        _inherits(Clipboard, _Emitter);
        /**
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         * @param {Object} options
         */ function Clipboard(trigger, options) {
            _classCallCheck(this, Clipboard);
            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));
            _this.resolveOptions(options);
            _this.listenClick(trigger);
            return _this;
        }
        /**
         * Defines if attributes would be resolved using internal setter functions
         * or custom functions that were passed in the constructor.
         * @param {Object} options
         */ _createClass(Clipboard, [
            {
                key: 'resolveOptions',
                value: function resolveOptions() {
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
                    this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
                    this.text = typeof options.text === 'function' ? options.text : this.defaultText;
                    this.container = _typeof(options.container) === 'object' ? options.container : document.body;
                }
            },
            {
                key: 'listenClick',
                value: function listenClick(trigger) {
                    var _this2 = this;
                    this.listener = (0, _goodListener2.default)(trigger, 'click', function(e) {
                        return _this2.onClick(e);
                    });
                }
            },
            {
                key: 'onClick',
                value: function onClick(e) {
                    var trigger = e.delegateTarget || e.currentTarget;
                    if (this.clipboardAction) this.clipboardAction = null;
                    this.clipboardAction = new _clipboardAction2.default({
                        action: this.action(trigger),
                        target: this.target(trigger),
                        text: this.text(trigger),
                        container: this.container,
                        trigger: trigger,
                        emitter: this
                    });
                }
            },
            {
                key: 'defaultAction',
                value: function defaultAction(trigger) {
                    return getAttributeValue('action', trigger);
                }
            },
            {
                key: 'defaultTarget',
                value: function defaultTarget(trigger) {
                    var selector = getAttributeValue('target', trigger);
                    if (selector) return document.querySelector(selector);
                }
            },
            {
                key: 'defaultText',
                value: function defaultText(trigger) {
                    return getAttributeValue('text', trigger);
                }
            },
            {
                key: 'destroy',
                value: function destroy() {
                    this.listener.destroy();
                    if (this.clipboardAction) {
                        this.clipboardAction.destroy();
                        this.clipboardAction = null;
                    }
                }
            }
        ], [
            {
                key: 'isSupported',
                value: function isSupported() {
                    var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
                        'copy',
                        'cut'
                    ];
                    var actions = typeof action === 'string' ? [
                        action
                    ] : action;
                    var support = !!document.queryCommandSupported;
                    actions.forEach(function(action) {
                        support = support && !!document.queryCommandSupported(action);
                    });
                    return support;
                }
            }
        ]);
        return Clipboard;
    }(_tinyEmitter2.default);
    /**
     * Helper function to retrieve attribute value.
     * @param {String} suffix
     * @param {Element} element
     */ function getAttributeValue(suffix, element) {
        var attribute = 'data-clipboard-' + suffix;
        if (!element.hasAttribute(attribute)) return;
        return element.getAttribute(attribute);
    }
    module1.exports = Clipboard;
});

});
parcelRegister("f3BXb", function(module, exports) {

(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        'module',
        'select'
    ], factory);
    else {
        var mod;
        factory(module, (parcelRequire("aaeNJ")));
    }
})(this, function(module1, _select) {
    'use strict';
    var _select2 = _interopRequireDefault(_select);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var _createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var ClipboardAction = function() {
        /**
         * @param {Object} options
         */ function ClipboardAction(options) {
            _classCallCheck(this, ClipboardAction);
            this.resolveOptions(options);
            this.initSelection();
        }
        /**
         * Defines base properties passed from constructor.
         * @param {Object} options
         */ _createClass(ClipboardAction, [
            {
                key: 'resolveOptions',
                value: function resolveOptions() {
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    this.action = options.action;
                    this.container = options.container;
                    this.emitter = options.emitter;
                    this.target = options.target;
                    this.text = options.text;
                    this.trigger = options.trigger;
                    this.selectedText = '';
                }
            },
            {
                key: 'initSelection',
                value: function initSelection() {
                    if (this.text) this.selectFake();
                    else if (this.target) this.selectTarget();
                }
            },
            {
                key: 'selectFake',
                value: function selectFake() {
                    var _this = this;
                    var isRTL = document.documentElement.getAttribute('dir') == 'rtl';
                    this.removeFake();
                    this.fakeHandlerCallback = function() {
                        return _this.removeFake();
                    };
                    this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;
                    this.fakeElem = document.createElement('textarea');
                    // Prevent zooming on iOS
                    this.fakeElem.style.fontSize = '12pt';
                    // Reset box model
                    this.fakeElem.style.border = '0';
                    this.fakeElem.style.padding = '0';
                    this.fakeElem.style.margin = '0';
                    // Move element out of screen horizontally
                    this.fakeElem.style.position = 'absolute';
                    this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
                    // Move element to the same position vertically
                    var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                    this.fakeElem.style.top = yPosition + 'px';
                    this.fakeElem.setAttribute('readonly', '');
                    this.fakeElem.value = this.text;
                    this.container.appendChild(this.fakeElem);
                    this.selectedText = (0, _select2.default)(this.fakeElem);
                    this.copyText();
                }
            },
            {
                key: 'removeFake',
                value: function removeFake() {
                    if (this.fakeHandler) {
                        this.container.removeEventListener('click', this.fakeHandlerCallback);
                        this.fakeHandler = null;
                        this.fakeHandlerCallback = null;
                    }
                    if (this.fakeElem) {
                        this.container.removeChild(this.fakeElem);
                        this.fakeElem = null;
                    }
                }
            },
            {
                key: 'selectTarget',
                value: function selectTarget() {
                    this.selectedText = (0, _select2.default)(this.target);
                    this.copyText();
                }
            },
            {
                key: 'copyText',
                value: function copyText() {
                    var succeeded = void 0;
                    try {
                        succeeded = document.execCommand(this.action);
                    } catch (err) {
                        succeeded = false;
                    }
                    this.handleResult(succeeded);
                }
            },
            {
                key: 'handleResult',
                value: function handleResult(succeeded) {
                    this.emitter.emit(succeeded ? 'success' : 'error', {
                        action: this.action,
                        text: this.selectedText,
                        trigger: this.trigger,
                        clearSelection: this.clearSelection.bind(this)
                    });
                }
            },
            {
                key: 'clearSelection',
                value: function clearSelection() {
                    if (this.trigger) this.trigger.focus();
                    window.getSelection().removeAllRanges();
                }
            },
            {
                key: 'destroy',
                value: function destroy() {
                    this.removeFake();
                }
            },
            {
                key: 'action',
                set: function set() {
                    var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';
                    this._action = action;
                    if (this._action !== 'copy' && this._action !== 'cut') throw new Error('Invalid "action" value, use either "copy" or "cut"');
                },
                get: function get() {
                    return this._action;
                }
            },
            {
                key: 'target',
                set: function set(target) {
                    if (target !== undefined) {
                        if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                            if (this.action === 'copy' && target.hasAttribute('disabled')) throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                            if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                            this._target = target;
                        } else throw new Error('Invalid "target" value, use a valid Element');
                    }
                },
                get: function get() {
                    return this._target;
                }
            }
        ]);
        return ClipboardAction;
    }();
    module1.exports = ClipboardAction;
});

});
parcelRegister("aaeNJ", function(module, exports) {
function $766651c1ea9cca66$var$select(element) {
    var selectedText;
    if (element.nodeName === 'SELECT') {
        element.focus();
        selectedText = element.value;
    } else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');
        if (!isReadOnly) element.setAttribute('readonly', '');
        element.select();
        element.setSelectionRange(0, element.value.length);
        if (!isReadOnly) element.removeAttribute('readonly');
        selectedText = element.value;
    } else {
        if (element.hasAttribute('contenteditable')) element.focus();
        var selection = window.getSelection();
        var range = document.createRange();
        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);
        selectedText = selection.toString();
    }
    return selectedText;
}
module.exports = $766651c1ea9cca66$var$select;

});


parcelRegister("69pXx", function(module, exports) {
function $47a7b85556738152$var$E() {
// Keep this empty so it's easier to inherit from
// (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}
$47a7b85556738152$var$E.prototype = {
    on: function(name, callback, ctx) {
        var e = this.e || (this.e = {});
        (e[name] || (e[name] = [])).push({
            fn: callback,
            ctx: ctx
        });
        return this;
    },
    once: function(name, callback, ctx) {
        var self = this;
        function listener() {
            self.off(name, listener);
            callback.apply(ctx, arguments);
        }
        listener._ = callback;
        return this.on(name, listener, ctx);
    },
    emit: function(name) {
        var data = [].slice.call(arguments, 1);
        var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
        var i = 0;
        var len = evtArr.length;
        for(i; i < len; i++)evtArr[i].fn.apply(evtArr[i].ctx, data);
        return this;
    },
    off: function(name, callback) {
        var e = this.e || (this.e = {});
        var evts = e[name];
        var liveEvents = [];
        if (evts && callback) {
            for(var i = 0, len = evts.length; i < len; i++)if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
        }
        // Remove event from queue to prevent memory leak
        // Suggested by https://github.com/lazd
        // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
        liveEvents.length ? e[name] = liveEvents : delete e[name];
        return this;
    }
};
module.exports = $47a7b85556738152$var$E;
module.exports.TinyEmitter = $47a7b85556738152$var$E;

});

parcelRegister("af7JM", function(module, exports) {

var $829vA = parcelRequire("829vA");

var $1pCld = parcelRequire("1pCld");
/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function $77514e973f6de81b$var$listen(target, type, callback) {
    if (!target && !type && !callback) throw new Error('Missing required arguments');
    if (!$829vA.string(type)) throw new TypeError('Second argument must be a String');
    if (!$829vA.fn(callback)) throw new TypeError('Third argument must be a Function');
    if ($829vA.node(target)) return $77514e973f6de81b$var$listenNode(target, type, callback);
    else if ($829vA.nodeList(target)) return $77514e973f6de81b$var$listenNodeList(target, type, callback);
    else if ($829vA.string(target)) return $77514e973f6de81b$var$listenSelector(target, type, callback);
    else throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
}
/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function $77514e973f6de81b$var$listenNode(node, type, callback) {
    node.addEventListener(type, callback);
    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    };
}
/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function $77514e973f6de81b$var$listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });
    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    };
}
/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function $77514e973f6de81b$var$listenSelector(selector, type, callback) {
    return $1pCld(document.body, selector, type, callback);
}
module.exports = $77514e973f6de81b$var$listen;

});
parcelRegister("829vA", function(module, exports) {

$parcel$export(module.exports, "node", function () { return $5d95e2d3c1bcf345$export$35059013cd4a06db; }, function (v) { return $5d95e2d3c1bcf345$export$35059013cd4a06db = v; });
$parcel$export(module.exports, "nodeList", function () { return $5d95e2d3c1bcf345$export$a1c973dcd05de293; }, function (v) { return $5d95e2d3c1bcf345$export$a1c973dcd05de293 = v; });
$parcel$export(module.exports, "string", function () { return $5d95e2d3c1bcf345$export$22b082955e083ec3; }, function (v) { return $5d95e2d3c1bcf345$export$22b082955e083ec3 = v; });
$parcel$export(module.exports, "fn", function () { return $5d95e2d3c1bcf345$export$edf0a6961c7cffcc; }, function (v) { return $5d95e2d3c1bcf345$export$edf0a6961c7cffcc = v; });
/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */ var $5d95e2d3c1bcf345$export$35059013cd4a06db;
/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */ var $5d95e2d3c1bcf345$export$a1c973dcd05de293;
/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */ var $5d95e2d3c1bcf345$export$22b082955e083ec3;
/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */ var $5d95e2d3c1bcf345$export$edf0a6961c7cffcc;
$5d95e2d3c1bcf345$export$35059013cd4a06db = function(value) {
    return value !== undefined && value instanceof HTMLElement && value.nodeType === 1;
};
$5d95e2d3c1bcf345$export$a1c973dcd05de293 = function(value) {
    var type = Object.prototype.toString.call(value);
    return value !== undefined && (type === '[object NodeList]' || type === '[object HTMLCollection]') && 'length' in value && (value.length === 0 || $5d95e2d3c1bcf345$export$35059013cd4a06db(value[0]));
};
$5d95e2d3c1bcf345$export$22b082955e083ec3 = function(value) {
    return typeof value === 'string' || value instanceof String;
};
$5d95e2d3c1bcf345$export$edf0a6961c7cffcc = function(value) {
    var type = Object.prototype.toString.call(value);
    return type === '[object Function]';
};

});

parcelRegister("1pCld", function(module, exports) {

var $6oUBV = parcelRequire("6oUBV");
/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function $1075ddfc046cb63c$var$_delegate(element, selector, type, callback, useCapture) {
    var listenerFn = $1075ddfc046cb63c$var$listener.apply(this, arguments);
    element.addEventListener(type, listenerFn, useCapture);
    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    };
}
/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function $1075ddfc046cb63c$var$delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') return $1075ddfc046cb63c$var$_delegate.apply(null, arguments);
    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') // Use `document` as the first parameter, then apply arguments
    // This is a short way to .unshift `arguments` without running into deoptimizations
    return $1075ddfc046cb63c$var$_delegate.bind(null, document).apply(null, arguments);
    // Handle Selector-based usage
    if (typeof elements === 'string') elements = document.querySelectorAll(elements);
    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function(element) {
        return $1075ddfc046cb63c$var$_delegate(element, selector, type, callback, useCapture);
    });
}
/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */ function $1075ddfc046cb63c$var$listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = $6oUBV(e.target, selector);
        if (e.delegateTarget) callback.call(element, e);
    };
}
module.exports = $1075ddfc046cb63c$var$delegate;

});
parcelRegister("6oUBV", function(module, exports) {
var $4a90e5abce4320c2$var$DOCUMENT_NODE_TYPE = 9;
/**
 * A polyfill for Element.matches()
 */ if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var $4a90e5abce4320c2$var$proto = Element.prototype;
    $4a90e5abce4320c2$var$proto.matches = $4a90e5abce4320c2$var$proto.matchesSelector || $4a90e5abce4320c2$var$proto.mozMatchesSelector || $4a90e5abce4320c2$var$proto.msMatchesSelector || $4a90e5abce4320c2$var$proto.oMatchesSelector || $4a90e5abce4320c2$var$proto.webkitMatchesSelector;
}
/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */ function $4a90e5abce4320c2$var$closest(element, selector) {
    while(element && element.nodeType !== $4a90e5abce4320c2$var$DOCUMENT_NODE_TYPE){
        if (typeof element.matches === 'function' && element.matches(selector)) return element;
        element = element.parentNode;
    }
}
module.exports = $4a90e5abce4320c2$var$closest;

});




parcelRegister("9WE80", function(module, exports) {

$parcel$export(module.exports, "createRule", function () { return createRule; });
$parcel$export(module.exports, "toCssValue", function () { return toCssValue; });
$parcel$export(module.exports, "RuleList", function () { return RuleList; });
$parcel$export(module.exports, "create", function () { return createJss; });
$parcel$export(module.exports, "hasCSSTOMSupport", function () { return hasCSSTOMSupport; });
$parcel$export(module.exports, "getDynamicStyles", function () { return getDynamicStyles; });

var $7KYiL = parcelRequire("7KYiL");

var $4rd5g = parcelRequire("4rd5g");

var $dHtmh = parcelRequire("dHtmh");

var $knpET = parcelRequire("knpET");

var $47eu9 = parcelRequire("47eu9");

var $6ai22 = parcelRequire("6ai22");

var $c9rwC = parcelRequire("c9rwC");
var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
    if (style == null || typeof style !== 'object') return style;
    if (Array.isArray(style)) return style.map(cloneStyle);
    if (style.constructor !== plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function createRule(name, decl, options) {
    if (name === void 0) name = 'unnamed';
    var jss = options.jss;
    var declCopy = cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var join = function join(value, by) {
    var result = '';
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === '!important') break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var toCssValue = function toCssValue(value) {
    if (!Array.isArray(value)) return value;
    var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === '!important') break;
        if (cssValue) cssValue += ', ';
        cssValue += join(value[i], ' ');
    }
    else cssValue = join(value, ', '); // Add !important, because it was ignored.
    if (value[value.length - 1] === '!important') cssValue += ' !important';
    return cssValue;
};
function getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: '',
        space: ''
    };
    return {
        linebreak: '\n',
        space: ' '
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function indentStr(str, indent) {
    var result = '';
    for(var index = 0; index < indent; index++)result += '  ';
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = '';
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== 'fallbacks') {
            if (result) result += linebreak;
            result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = function(str) {
    return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
};
var BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = 'style';
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $47eu9.default)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $6ai22.default)((0, $6ai22.default)(_this)), sheet);
            _this.selectorText = "." + escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    };
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== 'object') json[prop] = value;
            else if (Array.isArray(value)) json[prop] = toCssValue(value);
        }
        return json;
    };
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $7KYiL.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.selectorText, this.style, opts);
    };
    (0, $knpET.default)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') return null;
        return new StyleRule(key, style, options);
    }
};
var defaultToStringOptions = {
    indent: 1,
    children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = 'conditional';
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match(atRegExp);
        this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new RuleList((0, $7KYiL.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    };
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    };
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    };
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    };
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions.indent;
        if (options.children == null) options.children = defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
    };
    return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
    }
};
var defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = 'keyframes';
        this.at = '@keyframes';
        this.isProcessed = false;
        var nameMatch = key.match(nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = 'noname';
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : escape(generateId(this, sheet));
        this.rules = new RuleList((0, $7KYiL.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $7KYiL.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions$1;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
        if (options.children == null) options.children = defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === 'string') return val.replace(refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style' || !sheet) return style;
        if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
        if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case 'animation':
                return findReferencedKeyframe(val, sheet.keyframes);
            case 'animation-name':
                return findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $47eu9.default)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $7KYiL.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === 'keyframes') return new KeyframeRule(key, style, options);
        return null;
    }
};
var FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = 'font-face';
        this.at = '@font-face';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = '';
            for(var index = 0; index < this.style.length; index++){
                str += toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
    }
};
var ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = 'viewport';
        this.at = '@viewport';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
    }
};
var SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = 'simple';
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = '';
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += '\n';
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var keysMap = {
    '@charset': true,
    '@import': true,
    '@namespace': true
};
var pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in keysMap ? new SimpleRule(key, value, options) : null;
    }
};
var plugins = [
    pluginStyleRule,
    pluginConditionalRule,
    pluginKeyframesRule,
    pluginKeyframeRule,
    pluginFontFaceRule,
    pluginViewportRule,
    pluginSimpleRule
];
var defaultUpdateOptions = {
    process: true
};
var forceUpdateOptions = {
    force: true,
    process: true
};
var RuleList = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $7KYiL.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + escape(this.classes[key]);
        var rule = createRule(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    };
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, $7KYiL.default)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    };
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    };
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    };
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    };
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    };
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    };
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof KeyframesRule) delete this.keyframes[rule.name];
    };
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    };
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, forceUpdateOptions);
            }
        }
    };
    _proto.toString = function toString(options) {
        var str = '';
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $7KYiL.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new RuleList(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    };
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    };
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    };
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    };
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    };
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    };
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    };
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === 'object' ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    };
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    };
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    };
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    };
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    };
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    };
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    };
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    };
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    };
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    };
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    };
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: 'external'
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var SheetsRegistry = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    };
    _proto.reset = function reset() {
        this.registry = [];
    };
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    };
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $c9rwC.default)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = '';
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $knpET.default)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var sheets = new SheetsRegistry();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var createGenerateId = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = '';
        var prefix = '';
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return '';
    }
};
/**
 * Set a style property.
 */ var setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) cssValue = toCssValue(value);
         // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else {
            var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
            var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
            cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
        }
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var getHead = memoize(function() {
    return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function findCommentNode(text) {
    var head = getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function findPrevNode(options) {
    var registry = sheets.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === 'string') {
        var comment = findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var getNonce = memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute('content') : null;
});
var _insertRule = function insertRule(container, rule, index) {
    try {
        if ('insertRule' in container) container.insertRule(rule, index);
        else if ('appendRule' in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var createStyle = function createStyle() {
    var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = '\n';
    return el;
};
var DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = getPropertyValue;
        this.setProperty = setProperty;
        this.removeProperty = removeProperty;
        this.setSelector = setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) sheets.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || createStyle();
        this.element.setAttribute('data-jss', '');
        if (media) this.element.setAttribute('media', media);
        if (meta) this.element.setAttribute('data-meta', meta);
        var nonce = getNonce();
        if (nonce) this.element.setAttribute('nonce', nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    };
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = '\n';
        }
    };
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    };
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    };
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === 'conditional' || rule.type === 'keyframes') {
                var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = _insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof StyleSheet) this.cssRules.splice(index, 0, cssRule);
    };
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    };
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    };
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    };
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var instanceCounter = 0;
var Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = instanceCounter++;
        this.version = "10.10.0";
        this.plugins = new PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: createGenerateId,
            Renderer: (0, $4rd5g.default) ? DomRenderer : null,
            plugins: []
        };
        this.generateId = createGenerateId({
            minify: false
        });
        for(var i = 0; i < plugins.length; i++)this.plugins.use(plugins[i], {
            queue: 'internal'
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $7KYiL.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ('Renderer' in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    };
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== 'number') index = sheets.index === 0 ? 0 : sheets.index + 1;
        var sheet = new StyleSheet(styles, (0, $7KYiL.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    };
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        sheets.remove(sheet);
        return this;
    };
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === 'object') return this.createRule(undefined, name, style);
        var ruleOptions = (0, $7KYiL.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = createRule(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    };
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var createJss = function createJss(options) {
    return new Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var SheetsManager = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $dHtmh.default)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $dHtmh.default)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $knpET.default)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function getDynamicStyles(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === 'function') {
            if (!to) to = {};
            to[key] = value;
        } else if (type === 'object' && value !== null && !Array.isArray(value)) {
            var extracted = getDynamicStyles(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var index = createJss();
var $01de554c197645ad$export$2e2bcd8739ae039 = index;

});
parcelRegister("7KYiL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a5b9af0a3251752$export$2e2bcd8739ae039; });
function $5a5b9af0a3251752$export$2e2bcd8739ae039() {
    return $5a5b9af0a3251752$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5a5b9af0a3251752$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("4rd5g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33b3d53f3d9d0105$export$2e2bcd8739ae039; });
var $33b3d53f3d9d0105$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $33b3d53f3d9d0105$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $33b3d53f3d9d0105$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $33b3d53f3d9d0105$var$_typeof(document)) === 'object' && document.nodeType === 9;
var $33b3d53f3d9d0105$export$2e2bcd8739ae039 = $33b3d53f3d9d0105$export$4e09c449d6c407f7;

});

parcelRegister("dHtmh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f961075fefc58a1$export$2e2bcd8739ae039; });
var $9f961075fefc58a1$var$isProduction = true;
function $9f961075fefc58a1$var$warning(condition, message) {
    if (!$9f961075fefc58a1$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $9f961075fefc58a1$export$2e2bcd8739ae039 = $9f961075fefc58a1$var$warning;

});

parcelRegister("knpET", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed59dbe796b79a5f$export$2e2bcd8739ae039; });

var $3z9tA = parcelRequire("3z9tA");
function $ed59dbe796b79a5f$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $3z9tA.default)(o.key), o);
    }
}
function $ed59dbe796b79a5f$export$2e2bcd8739ae039(e, r, t) {
    return r && $ed59dbe796b79a5f$var$_defineProperties(e.prototype, r), t && $ed59dbe796b79a5f$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("3z9tA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $298bfdc53829ddfb$export$2e2bcd8739ae039; });

var $DfFKD = parcelRequire("DfFKD");

var $jYgE7 = parcelRequire("jYgE7");
function $298bfdc53829ddfb$export$2e2bcd8739ae039(t) {
    var i = (0, $jYgE7.default)(t, "string");
    return "symbol" == (0, $DfFKD.default)(i) ? i : i + "";
}

});
parcelRegister("DfFKD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $075fccd8969dddb8$export$2e2bcd8739ae039; });
function $075fccd8969dddb8$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $075fccd8969dddb8$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $075fccd8969dddb8$export$2e2bcd8739ae039(o);
}

});

parcelRegister("jYgE7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8a088797ee38104$export$2e2bcd8739ae039; });

var $DfFKD = parcelRequire("DfFKD");
function $e8a088797ee38104$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $DfFKD.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $DfFKD.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("47eu9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ff30d5c37b13b37$export$2e2bcd8739ae039; });

var $6ye0i = parcelRequire("6ye0i");
function $2ff30d5c37b13b37$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $6ye0i.default)(t, o);
}

});
parcelRegister("6ye0i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c50c7e9cafe80d1$export$2e2bcd8739ae039; });
function $4c50c7e9cafe80d1$export$2e2bcd8739ae039(t, e) {
    return $4c50c7e9cafe80d1$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $4c50c7e9cafe80d1$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("6ai22", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47d1aa039885913f$export$2e2bcd8739ae039; });
function $47d1aa039885913f$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("c9rwC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d8bad366d225c0e$export$2e2bcd8739ae039; });
function $8d8bad366d225c0e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("hGSYJ", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $ce11018549df5945$export$306c0aa65ff9ec16; }, function (v) { return $ce11018549df5945$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ce11018549df5945$export$306c0aa65ff9ec16;
"use strict";

var $ieT14 = parcelRequire("ieT14");
function $ce11018549df5945$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $ce11018549df5945$var$objectIs = "function" === typeof Object.is ? Object.is : $ce11018549df5945$var$is, $ce11018549df5945$var$useState = $ieT14.useState, $ce11018549df5945$var$useEffect = $ieT14.useEffect, $ce11018549df5945$var$useLayoutEffect = $ieT14.useLayoutEffect, $ce11018549df5945$var$useDebugValue = $ieT14.useDebugValue;
function $ce11018549df5945$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $ce11018549df5945$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $ce11018549df5945$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $ce11018549df5945$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $ce11018549df5945$var$useEffect(function() {
        $ce11018549df5945$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $ce11018549df5945$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $ce11018549df5945$var$useDebugValue(value);
    return value;
}
function $ce11018549df5945$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$ce11018549df5945$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $ce11018549df5945$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $ce11018549df5945$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $ce11018549df5945$var$useSyncExternalStore$1 : $ce11018549df5945$var$useSyncExternalStore$2;
$ce11018549df5945$export$306c0aa65ff9ec16 = void 0 !== $ieT14.useSyncExternalStore ? $ieT14.useSyncExternalStore : $ce11018549df5945$var$shim;

});

parcelRegister("fgoQ6", function(module, exports) {

$parcel$export(module.exports, "SecondaryAlert", function () { return SecondaryAlert; });
$parcel$export(module.exports, "useTimedAlerts", function () { return useTimedAlerts; });
$parcel$export(module.exports, "Announcement", function () { return Announcement; });
$parcel$export(module.exports, "Breadcrumbs", function () { return Breadcrumbs; });
$parcel$export(module.exports, "PrimaryButton", function () { return PrimaryButton; });
$parcel$export(module.exports, "SecondaryButton", function () { return SecondaryButton; });
$parcel$export(module.exports, "TertiaryButton", function () { return TertiaryButton; });
$parcel$export(module.exports, "CollapsibleSidebar", function () { return CollapsibleSidebar; });
$parcel$export(module.exports, "Table", function () { return Table; });
$parcel$export(module.exports, "TableBody", function () { return TableBody; });
$parcel$export(module.exports, "TableHead", function () { return TableHead; });
$parcel$export(module.exports, "HeaderCell", function () { return HeaderCell; });
$parcel$export(module.exports, "OutlinedInput", function () { return outlinedInput; });
$parcel$export(module.exports, "OutlinedSelect", function () { return OutlinedSelect; });
$parcel$export(module.exports, "PhoneInputMask", function () { return PhoneInputMask; });
$parcel$export(module.exports, "StyledCheckbox", function () { return StyledCheckbox; });
$parcel$export(module.exports, "SearchBar", function () { return SearchBar; });

var $ieT14 = parcelRequire("ieT14");

var $bAMo1 = parcelRequire("bAMo1");
var $kfphy = parcelRequire("kfphy");
var $ajNLv = parcelRequire("ajNLv");
var $4leCF = parcelRequire("4leCF");
var $l1pHr = parcelRequire("l1pHr");
var $1vmhz = parcelRequire("1vmhz");
var $6BTs4 = parcelRequire("6BTs4");
var $e1kqS = parcelRequire("e1kqS");
var $etCDZ = parcelRequire("etCDZ");
var $aXXRU = parcelRequire("aXXRU");
var $8DFBm = parcelRequire("8DFBm");
var $7nM46 = parcelRequire("7nM46");
var $k43Wb = parcelRequire("k43Wb");
var $dwg6U = parcelRequire("dwg6U");

var $ekezX = parcelRequire("ekezX");
var $f7wB2 = parcelRequire("f7wB2");
var $fpdl2 = parcelRequire("fpdl2");
var $kRJN7 = parcelRequire("kRJN7");
var $whS22 = parcelRequire("whS22");
var $knRao = parcelRequire("knRao");
var $3WBJn = parcelRequire("3WBJn");
var $f3VQ2 = parcelRequire("f3VQ2");
var $1KcBP = parcelRequire("1KcBP");
var $Uxz4Y = parcelRequire("Uxz4Y");
var $iwN3n = parcelRequire("iwN3n");
var $bPjUl = parcelRequire("bPjUl");
var $e1ONw = parcelRequire("e1ONw");
var $5TjLg = parcelRequire("5TjLg");
var $3mOXj = parcelRequire("3mOXj");
var $fVNJ1 = parcelRequire("fVNJ1");
var $aanJt = parcelRequire("aanJt");
var $7t0W0 = parcelRequire("7t0W0");
var $356Vi = parcelRequire("356Vi");
var $aIJrd = parcelRequire("aIJrd");

var $6mt9R = parcelRequire("6mt9R");

var $e1ONw = parcelRequire("e1ONw");
var $aIJrd = parcelRequire("aIJrd");
parcelRequire("hTxQ8");
var $jDPUx = parcelRequire("jDPUx");
var $blOHq = parcelRequire("blOHq");
var $1evnz = parcelRequire("1evnz");
var $4UuJL = parcelRequire("4UuJL");
var $geBL0 = parcelRequire("geBL0");
var $2T7UM = parcelRequire("2T7UM");
var $1CQ7S = parcelRequire("1CQ7S");
var $kWKG2 = parcelRequire("kWKG2");
var $3FIbj = parcelRequire("3FIbj");
var $ikHyM = parcelRequire("ikHyM");
var $ksTt2 = parcelRequire("ksTt2");
var $5xV2T = parcelRequire("5xV2T");
var $a8f6W = parcelRequire("a8f6W");
var $3v896 = parcelRequire("3v896");
var $6zofg = parcelRequire("6zofg");
var $cYPu0 = parcelRequire("cYPu0");
var $lhtzE = parcelRequire("lhtzE");
var $jJTTX = parcelRequire("jJTTX");
var $1N69U = parcelRequire("1N69U");

var $eYT2J = parcelRequire("eYT2J");

var $lamW6 = parcelRequire("lamW6");
function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') return;
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
/** @deprecated */ function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
// Portal Sass Colors
var blue = {
    100: '#eaf3f8',
    200: '#89cbdf',
    300: '#00aafc',
    400: '#0092e0',
    500: '#0084ba',
    600: '#006da8',
    700: '#074F86',
    800: '#00223C'
};
var neutral = {
    100: '#ffffff',
    200: '#efefef',
    250: '#dadada',
    300: '#d1cece',
    400: '#c6c4c4',
    500: '#8a8a8a',
    550: '#7f7f7f',
    600: '#4f4f4f',
    700: '#000000'
};
var status = {
    success: {
        light: '#dff0d0',
        medium: '#65B500',
        dark: '#04844B' // p1 fill
    },
    error: {
        light: '#f5dbd9',
        medium: '#ebafa6',
        dark: '#c92100'
    },
    warning: {
        light: '#ffeadb',
        medium: '#ff7e1c',
        dark: '#C25400'
    },
    info: {
        light: '#e1f1f6',
        medium: '#89cbdf',
        dark: '#007cbb'
    },
    deactive: '#8a8a8a'
};
var pallette = __assign({
    primary: blue[700],
    backgroundLight: neutral[100],
    backgroundDark: blue[800],
    textLight: neutral[100],
    textDark: neutral[700]
}, status);
var fontFamilies = {
    heading: 'Montserrat, Helvetica, sans-serif',
    body: "'Open Sans', Helvetica, Arial, sans-serif",
    code: "'Fira Code', monospace"
};
var typeScale = {
    h1: '1.5rem',
    h2: '1.5rem',
    h3: '1.25rem',
    h4: '1.25rem',
    h5: '1rem',
    h6: '1rem',
    body1: '14px',
    body2: '12px',
    label1: '12px',
    label2: '14px',
    caption: '12px'
};
/**
 * Common typographical styles from Portal Style Guide
 */ var TextStyles = {
    h1: {
        fontFamily: fontFamilies.heading,
        fontSize: typeScale.h1,
        fontWeight: 600
    },
    h2: {
        fontFamily: fontFamilies.heading,
        fontSize: typeScale.h2,
        fontWeight: 300,
        color: blue[600]
    },
    h3: {
        fontFamily: fontFamilies.heading,
        fontSize: typeScale.h3,
        fontWeight: 600,
        textTransform: 'uppercase'
    },
    h4: {
        fontFamily: fontFamilies.heading,
        fontSize: typeScale.h4,
        fontWeight: 300,
        textTransform: 'uppercase'
    },
    h5: {
        fontFamily: fontFamilies.heading,
        fontSize: typeScale.h5,
        fontWeight: 600
    },
    h6: {
        fontFamily: fontFamilies.heading,
        fontSize: typeScale.h6,
        fontWeight: 300
    },
    label1: {
        fontFamily: fontFamilies.heading,
        color: neutral[600],
        fontWeight: 300,
        fontSize: typeScale.label1,
        margin: 0
    },
    label2: {
        fontFamily: fontFamilies.heading,
        color: neutral[600],
        fontWeight: 300,
        fontSize: typeScale.label2,
        margin: 0
    },
    label4: {
        fontFamily: fontFamilies.heading,
        fontWeight: 200,
        fontSize: 11,
        color: neutral[600]
    },
    body1: {
        fontFamily: fontFamilies.body,
        color: neutral[700],
        fontWeight: 300,
        fontSize: typeScale.body1,
        letterSpacing: 0.3,
        lineHeight: 1.43
    },
    body2: {
        fontFamily: fontFamilies.body,
        color: neutral[600],
        fontWeight: 400,
        fontSize: typeScale.body2,
        lineHeight: 1.33
    },
    caption: {
        fontFamily: fontFamilies.body,
        color: neutral[600],
        fontWeight: 300,
        fontSize: typeScale.caption
    }
};
function bgColor$1(type) {
    switch(type){
        case 'success':
            return pallette.success.dark;
        case 'info':
            return pallette.info.dark;
        case 'warning':
            return pallette.warning.dark;
        case 'error':
            return pallette.error.dark;
    }
}
var useStyles$A = (0, $e1ONw.default)({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: '36px',
        borderRadius: 2,
        padding: '0 10px',
        marginBottom: '20px',
        backgroundColor: function(props) {
            return bgColor$1(props.type);
        },
        '& svg': {
            marginRight: '10px',
            color: 'white',
            fontSize: '16px'
        }
    },
    message: {
        fontFamily: fontFamilies.heading,
        color: 'white',
        fontSize: 14,
        fontWeight: 500,
        letterSpacing: '-0.1px'
    }
});
/**
 * Primary Alert (a.k.a. Priority 1 Alert) should be used for announcements
 */ var PrimaryAlert = function(props) {
    var classes = useStyles$A(props);
    var renderIcon = function(type) {
        switch(type){
            case 'success':
                return $ieT14.createElement((0, $ajNLv.default), null);
            case 'info':
                return $ieT14.createElement((0, $aXXRU.default), null);
            case 'warning':
                return $ieT14.createElement((0, $dwg6U.default), null);
            case 'error':
                return $ieT14.createElement((0, $1vmhz.default), null);
        }
    };
    return $ieT14.createElement("div", {
        className: classes.root
    }, renderIcon(props.type), $ieT14.createElement("span", {
        className: classes.message
    }, props.message));
};
function bgColor(type) {
    switch(type){
        case 'success':
            return pallette.success.light;
        case 'info':
            return pallette.info.light;
        case 'warning':
            return pallette.warning.light;
        case 'error':
            return pallette.error.light;
    }
}
function borderColor(type) {
    switch(type){
        case 'success':
            return pallette.success.medium;
        case 'info':
            return pallette.info.medium;
        case 'warning':
            return pallette.warning.medium;
        case 'error':
            return pallette.error.medium;
    }
}
function iconColor(type) {
    switch(type){
        case 'success':
            return pallette.success.dark;
        case 'info':
            return pallette.info.dark;
        case 'warning':
            return pallette.warning.dark;
        case 'error':
            return pallette.error.dark;
    }
}
var useStyles$z = (0, $e1ONw.default)({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: '28px',
        borderRadius: '3px',
        padding: '0 8px',
        marginBottom: '20px',
        backgroundColor: function(props) {
            return bgColor(props.type);
        },
        border: function(props) {
            return "1px solid " + borderColor(props.type);
        },
        '& svg': {
            marginRight: '8px',
            color: function(props) {
                return iconColor(props.type);
            },
            fontSize: '14px'
        }
    },
    message: {
        fontFamily: fontFamilies.heading,
        color: neutral[600],
        fontSize: 12,
        fontWeight: 500,
        letterSpacing: '-0.1px'
    }
});
/**
 * Secondary Alerts (a.k.a. Priority 2 Alerts) should be used for successful completion, completion error and other less urgent messages
 */ var SecondaryAlert = function(props) {
    var classes = useStyles$z(props);
    var renderIcon = function(type) {
        switch(type){
            case 'success':
                return $ieT14.createElement((0, $ajNLv.default), null);
            case 'info':
                return $ieT14.createElement((0, $aXXRU.default), null);
            case 'warning':
                return $ieT14.createElement((0, $dwg6U.default), null);
            case 'error':
                return $ieT14.createElement((0, $1vmhz.default), null);
        }
    };
    return $ieT14.createElement("div", {
        className: classes.root
    }, renderIcon(props.type), $ieT14.createElement("span", {
        className: classes.message
    }, props.message));
};
var useTimedAlerts = function() {
    var _a = $ieT14.useState(''), errorMessage = _a[0], setErrorMessage = _a[1];
    var _b = $ieT14.useState(''), successMessage = _b[0], setSuccessMessage = _b[1];
    $ieT14.useEffect(function() {
        var timer = setTimeout(function() {
            setSuccessMessage('');
        }, 5000);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        successMessage
    ]);
    $ieT14.useEffect(function() {
        var timer = setTimeout(function() {
            setErrorMessage('');
        }, 5000);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        errorMessage
    ]);
    return {
        successMessage: successMessage,
        setSuccessMessage: setSuccessMessage,
        errorMessage: errorMessage,
        setErrorMessage: setErrorMessage
    };
};
function toVal(mix) {
    var k, y, str = '';
    if (typeof mix === 'string' || typeof mix === 'number') str += mix;
    else if (typeof mix === 'object') {
        if (Array.isArray(mix)) for(k = 0; k < mix.length; k++){
            if (mix[k]) {
                if (y = toVal(mix[k])) {
                    str && (str += ' ');
                    str += y;
                }
            }
        }
        else {
            for(k in mix)if (mix[k]) {
                str && (str += ' ');
                str += k;
            }
        }
    }
    return str;
}
function clsx() {
    var i = 0, tmp, x, str = '';
    while(i < arguments.length){
        if (tmp = arguments[i++]) {
            if (x = toVal(tmp)) {
                str && (str += ' ');
                str += x;
            }
        }
    }
    return str;
}
var useStyles$y = (0, $e1ONw.default)({
    root: function(props) {
        return {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderRadius: 2,
            fontSize: 14,
            letterSpacing: '-0.1px',
            padding: props.hasExitIcon ? '0 0 0 20px' : '0 20px',
            marginBottom: 20,
            fontFamily: fontFamilies.heading
        };
    },
    primary: {
        backgroundColor: status.info.dark,
        border: "solid 1px " + status.info.dark,
        color: '#fff'
    },
    secondary: {
        backgroundColor: status.info.light,
        border: "solid 1px " + status.info.medium,
        color: neutral[600]
    },
    iconButtonWrapper: {
        padding: '0 10px'
    },
    closeIcon: function(props) {
        return {
            color: props.type == 'primary' ? neutral[100] : neutral[600]
        };
    }
});
/**
 * Component to render site wide announcements with HTML content generated by TinyMCE
 */ var Announcement = function(_a) {
    var type = _a.type, className = _a.className, content = _a.content, hasExitIcon = _a.hasExitIcon, onClose = _a.onClose;
    var classes = useStyles$y({
        type: type,
        hasExitIcon: hasExitIcon
    });
    if (!content) return $ieT14.createElement("div", null);
    return $ieT14.createElement("div", {
        className: clsx(classes.root, className, type == 'primary' && classes.primary, type == 'secondary' && classes.secondary)
    }, $ieT14.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: content
        }
    }), hasExitIcon && $ieT14.createElement("div", {
        className: classes.iconButtonWrapper
    }, $ieT14.createElement((0, $1KcBP.default), {
        size: "small",
        edge: "end",
        onClick: function(event) {
            onClose(event);
        }
    }, $ieT14.createElement((0, $l1pHr.default), {
        className: classes.closeIcon
    }))));
};
var useStyles$x = (0, $e1ONw.default)({
    root: {
        display: 'flex',
        alignItems: 'center',
        '& svg': {
            margin: '0 13px'
        },
        '& a': {
            fontFamily: fontFamilies.heading,
            textDecoration: 'none',
            fontSize: TextStyles.h1.fontSize,
            color: blue[600]
        },
        '& p': __assign(__assign({}, TextStyles.h1), {
            margin: 0
        })
    }
});
/**
 * Breadcrumbs show the user their location in the information architecture relative to the current page, generally used in multi-level views
 */ var Breadcrumbs = function(_a) {
    var breadcrumbs = _a.breadcrumbs, currentPage = _a.currentPage, className = _a.className;
    var classes = useStyles$x();
    /**
     * @function renderBreadcrumbs - Renders each individual link/title and arrow
     */ var renderBreadcrumbs = function() {
        return breadcrumbs.map(function(breadcrumb, index) {
            return(// Full syntax for fragment needed in order to complete build
            $ieT14.createElement($ieT14.Fragment, {
                key: "breadcrumb-" + index
            }, $ieT14.createElement((0, $6mt9R.Link), {
                to: breadcrumb.path
            }, breadcrumb.title), $ieT14.createElement((0, $7nM46.default), null)));
        });
    };
    return $ieT14.createElement("div", {
        className: clsx(classes.root, className)
    }, renderBreadcrumbs(), typeof currentPage === 'string' || typeof currentPage === 'number' ? $ieT14.createElement("p", null, currentPage) : currentPage);
};
var EmbeddedSelectControl = (0, $aIJrd.default)({
    root: {
        margin: 0,
        '& .MuiInputLabel-root': {
            background: 'white',
            color: neutral[600],
            fontFamily: fontFamilies.heading,
            fontWeight: 300,
            fontSize: '14px'
        },
        '& .MuiInputBase-root': {
            fontFamily: fontFamilies.heading,
            fontSize: TextStyles.h2.fontSize,
            minWidth: 100,
            '&.Mui-focused fieldset': {
                borderColor: blue[300]
            },
            '&.Mui-focused .MuiSelect-root': {
                backgroundColor: neutral[100]
            }
        },
        '& .MuiSelect-icon': {
            right: -8
        }
    }
})((0, $whS22.default));
/**
 * Outlined Select, select component based styled MUI FormControl
 */ var EmbeddedSelect = function(_a) {
    var id = _a.id, title = _a.title, handleChange = _a.handleChange, handleBlur = _a.handleBlur, options = _a.options, value = _a.value;
    return $ieT14.createElement(EmbeddedSelectControl, {
        variant: "outlined",
        margin: "dense"
    }, $ieT14.createElement((0, $Uxz4Y.default), null, title), $ieT14.createElement((0, $aanJt.default), {
        native: true,
        id: id,
        value: value,
        onChange: handleChange,
        onBlur: handleBlur
    }, options));
};
/**
 * baseStyles
 * make base styles object for primary and secondary buttons
 */ var baseButtonStyles = (0, $e1ONw.default)({
    root: {
        padding: '0 18px',
        borderRadius: '2px',
        minHeight: '30px',
        whiteSpace: 'nowrap',
        fontFamily: fontFamilies.heading,
        fontSize: '13px',
        fontWeight: 400,
        textTransform: 'inherit',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: pallette.textLight
    }
});
var useStyles$w = (0, $e1ONw.default)({
    root: {
        minWidth: '200px',
        backgroundColor: pallette.backgroundDark,
        '&.Mui-disabled': {
            backgroundColor: neutral[250],
            color: neutral[600]
        },
        '&:hover': {
            backgroundColor: blue[600]
        },
        '&:focus': {
            backgroundColor: blue[300],
            color: pallette.textDark
        }
    }
});
/**
 * Primary Button:
 * The highest priority button, generally used for final submit buttons in views with user input.
 * Extends Material UI Button, see https://material-ui.com/api/button/
 */ var PrimaryButton = function(_a) {
    var text = _a.text, title = _a.title, deactive = _a.deactive, styles = _a.styles, handleClick = _a.handleClick;
    var base = baseButtonStyles();
    var classes = useStyles$w();
    return $ieT14.createElement((0, $ekezX.default), {
        className: clsx(base.root, classes.root),
        type: "submit",
        title: title,
        onClick: function(event) {
            event.preventDefault();
            handleClick();
        },
        variant: "contained",
        disabled: deactive,
        style: styles
    }, text);
};
var useStyles$v = (0, $e1ONw.default)({
    root: {
        backgroundColor: blue[500],
        color: pallette.textLight,
        '&:hover': {
            backgroundColor: blue[600]
        },
        '&:active': {
            backgroundColor: blue[300],
            color: neutral[700]
        },
        '&:focus': {
            backgroundColor: blue[300]
        }
    }
});
/**
 * Button with lower priority than Primary Buttons
 */ var SecondaryButton = function(_a) {
    var text = _a.text, title = _a.title, deactive = _a.deactive, extraStyles = _a.styles, handleClick = _a.handleClick, component = _a.component, preventDefault = _a.preventDefault, props = __rest(_a, [
        "text",
        "title",
        "deactive",
        "styles",
        "handleClick",
        "component",
        "preventDefault"
    ]);
    var base = baseButtonStyles();
    var classes = useStyles$v();
    return $ieT14.createElement((0, $ekezX.default), __assign({
        title: title,
        className: clsx(base.root, classes.root),
        onClick: function(event) {
            if (preventDefault === undefined || preventDefault) event.preventDefault();
            handleClick();
        },
        variant: "contained",
        color: "primary",
        disabled: deactive,
        style: extraStyles,
        component: component
    }, props), text);
};
var useStyles$u = (0, $e1ONw.default)({
    root: {
        fontFamily: fontFamilies.heading,
        fontWeight: 300,
        lineHeight: 1.45,
        fontSize: 11,
        color: blue[600],
        textTransform: 'uppercase',
        cursor: 'pointer'
    },
    button: {
        border: 'none',
        backgroundColor: 'transparent'
    }
});
/**
 * Tertiary Button. A text button intended to be embedded within other components such as tables.
 */ var TertiaryButton = function(_a) {
    var text = _a.text, title = _a.title, deactive = _a.deactive, handleClick = _a.handleClick, className = _a.className, component = _a.component;
    var classes = useStyles$u();
    if (deactive) return $ieT14.createElement("div", null);
    return $ieT14.createElement($ieT14.Fragment, null, component && component == 'button' ? $ieT14.createElement("button", {
        type: "button",
        className: clsx(classes.root, classes.button, className),
        title: title,
        onClick: function(event) {
            handleClick(event);
        }
    }, text) : $ieT14.createElement("span", {
        className: clsx(classes.root, className),
        title: title,
        onClick: function(event) {
            return handleClick(event);
        }
    }, text));
};
/** Provide StackedArea with d3 generators */ function useStackedArea(width, height, data, dataKey) {
    var stackSeries = (0, $a8f6W.default)().keys(Object.keys(dataKey))(data);
    var margin = {
        top: 5,
        right: 0,
        bottom: 5,
        left: 20
    };
    var x = (0, $kWKG2.default)().domain((0, $1CQ7S.default)(data.length)).range([
        margin.left,
        width - margin.right
    ]);
    var y = (0, $3FIbj.default)().domain([
        0,
        (0, $2T7UM.default)(stackSeries, function(series) {
            return (0, $2T7UM.default)(series, function(point) {
                return point[1];
            });
        })
    ]).range([
        height - margin.bottom,
        margin.top
    ]);
    var areaGen = (0, $jDPUx.default)().x(function(_, i) {
        return x(i);
    }).y0(function(d) {
        return y(d[0]);
    }).y1(function(d) {
        return y(d[1]);
    });
    var yAxis = function(g) {
        return g.attr('transform', "translate(" + margin.left + ",-1)").call((0, $blOHq.axisLeft)(y).ticks(1)).call(function(sel) {
            return sel.select('.domain').remove();
        }).call(function(sel) {
            return sel.select('.tick:nth-child(2)').attr('transform', "translate(0," + (margin.top + 1) + ")");
        });
    };
    return {
        stackSeries: stackSeries,
        x: x,
        y: y,
        areaGen: areaGen,
        yAxis: yAxis
    };
}
var useStyles$t = (0, $e1ONw.default)(function(theme) {
    return {
        root: {
            display: 'flex',
            width: '100%',
            height: '100%'
        },
        svg: function(_a) {
            var svgHeight = _a.svgHeight, svgWidth = _a.svgWidth;
            return {
                fontFamily: 'Open Sans',
                height: svgHeight,
                width: svgWidth
            };
        },
        lines: {
            fill: 'none',
            strokeWidth: 1,
            strokeLinejoin: 'round',
            strokeLinecap: 'round'
        }
    };
});
var StackedArea = function(_a) {
    var viewBoxWidth = _a.viewBoxWidth, viewBoxHeight = _a.viewBoxHeight, data = _a.data, dataKey = _a.dataKey, containerClassName = _a.containerClassName, svgHeight = _a.svgHeight, svgWidth = _a.svgWidth;
    var classes = useStyles$t({
        svgHeight: svgHeight,
        svgWidth: svgWidth
    });
    var areasRef = $ieT14.useRef();
    var linesRef = $ieT14.useRef();
    var axisRef = $ieT14.useRef();
    var _b = useStackedArea(viewBoxWidth, viewBoxHeight, data, dataKey), stackSeries = _b.stackSeries, areaGen = _b.areaGen, x = _b.x, y = _b.y, yAxis = _b.yAxis;
    var getTransition = function() {
        return (0, $1N69U.default)().duration(500);
    };
    $ieT14.useEffect(function() {
        (0, $ksTt2.default)(areasRef.current).selectAll('path').data(stackSeries).join(function(enter) {
            return enter.append('path').attr('fill', function(_a) {
                var key = _a.key;
                return dataKey[key][0];
            }).attr('d', areaGen);
        }, function(update) {
            return update.call(function() {
                return update.transition(getTransition()).attr('d', areaGen);
            });
        });
    }, [
        areasRef,
        stackSeries
    ]);
    $ieT14.useEffect(function() {
        (0, $ksTt2.default)(linesRef.current).selectAll('path').data(stackSeries).join(function(enter) {
            return enter.append('path').attr('stroke', function(d) {
                return dataKey[d.key][1];
            }).attr('d', (0, $geBL0.default)().x(function(d, i) {
                return x(i);
            }).y(function(d) {
                return y(d[1]);
            }));
        }, function(update) {
            return update.call(function() {
                return update.transition(getTransition()).attr('d', (0, $geBL0.default)().x(function(d, i) {
                    return x(i);
                }).y(function(d) {
                    return y(d[1]);
                }));
            });
        });
    }, [
        linesRef,
        stackSeries
    ]);
    $ieT14.useEffect(function() {
        (0, $ksTt2.default)(axisRef.current).call(yAxis);
    }, [
        axisRef,
        stackSeries
    ]);
    return $ieT14.createElement("div", {
        className: clsx(classes.root, containerClassName)
    }, $ieT14.createElement("svg", {
        className: classes.svg,
        viewBox: "0 0 " + viewBoxWidth + " " + viewBoxHeight
    }, $ieT14.createElement("g", {
        ref: areasRef
    }), $ieT14.createElement("g", {
        className: classes.lines,
        ref: linesRef
    }), $ieT14.createElement("g", {
        ref: axisRef
    })));
};
/** Custom hook to use d3 to generate chart rendering functions from given data */ function useStatusCalendar(data) {
    var cellSize = 20;
    var width = cellSize * 31 + 4;
    var height = cellSize * 8;
    var margin = {
        top: cellSize,
        right: 0,
        bottom: 0,
        left: cellSize * 2 + 2
    };
    // Beginning of the year of the earliest date in the dataset
    var yearStart = (0, $jJTTX.timeYear).floor(data[0].date);
    // Week number of first date in data
    var weekOffset = (0, $lhtzE.timeSunday).count(yearStart, data[0].date);
    /** Derive x distance from interval between year start and start of the given week */ var x = function(d) {
        return ((0, $lhtzE.timeSunday).count(yearStart, d.date) - weekOffset) * cellSize + margin.left;
    };
    /** Derive Y distance per day from interval between week start and given day */ var y = function(d) {
        return (0, $3v896.timeDay).count((0, $lhtzE.timeSunday).floor(d.date), d.date) * cellSize + margin.top;
    };
    /** Retrieve the cell color based on datum status */ var color = function(d) {
        switch(d.status){
            case 'success':
                return '#69B34C';
            case 'fail':
                return '#FF4E11';
            case 'warn':
                return '#FAB733';
            default:
                return neutral[300];
        }
    };
    // Array of the starting Date of each month in the dataset date range
    var months = (0, $cYPu0.timeMonths)(data[0].date, data[data.length - 1].date);
    /** Draw the lines separating each month
     * @param month: starting Date of the current month passed in from array of months in data
     */ function pathMonth(month) {
        var day = month.getDay();
        // week counted from the first day of the first year of data minus the offset
        var week = (0, $lhtzE.timeSunday).count((0, $jJTTX.timeYear)(yearStart), month) - weekOffset;
        // if month starts on Sunday, start straight vertical line before week
        // otherwise draw around last day of prev month
        return day === 0 ? "M" + week * cellSize + ",0V" + 7 * cellSize : "M" + (week + 1) * cellSize + ",0V" + day * cellSize + "H" + week * cellSize + "V" + 7 * cellSize;
    }
    /** draw the month labels and lines separating each month in the calendar */ var monthAxis = function(g) {
        var monthGroups = g.selectAll('g').data(months).join('g').attr('transform', "translate(" + (margin.left - cellSize * 0.1) + " " + (margin.top - cellSize * 0.1) + ")");
        monthGroups.selectAll('*').remove();
        monthGroups.append('path').attr('fill', 'none').attr('stroke', neutral[600]).attr('stroke-width', '1').attr('d', pathMonth);
        monthGroups.append('text').attr('x', function(d) {
            return ((0, $lhtzE.timeSunday).count(yearStart, d) - weekOffset + (d.getDay() == 0 ? 0 : 1)) * cellSize;
        }).attr('y', cellSize * -0.5).attr('dominant-baseline', 'middle').attr('font-size', "" + cellSize * 0.65).text(function(d) {
            return (0, $6zofg.timeFormat)('%b')(d);
        });
    };
    /** Easter Egg. */ var spin = false;
    var handleSpin = function() {
        spin = !spin;
        (0, $5xV2T.default)('rect').style('animation-play-state', spin ? 'running' : 'paused');
    };
    /** draw the day labels for each row in the grid */ var dayAxis = function(g) {
        g.attr('transform', "translate(" + (margin.left - cellSize / 2) + " " + margin.top + ")").selectAll('text').data('SMTWTFS'.split('')).join('text').attr('y', function(d, i) {
            return cellSize * i + cellSize / 2;
        }).attr('x', '0').attr('id', function(d, i) {
            return i == 4 ? 'spin' : null;
        }).attr('dominant-baseline', 'middle').attr('font-size', "" + cellSize * 0.55).attr('text-anchor', 'middle').text(function(d) {
            return d;
        });
        g.selectChild('#spin').on('click', handleSpin);
    };
    return {
        cellSize: cellSize,
        x: x,
        y: y,
        color: color,
        monthAxis: monthAxis,
        dayAxis: dayAxis,
        viewBoxWidth: width,
        viewBoxHeight: height
    };
}
var useStyles$s = (0, $e1ONw.default)(function(theme) {
    return {
        root: {
            display: 'flex',
            width: '100%',
            height: '100%'
        },
        svg: function(_a) {
            var svgHeight = _a.svgHeight, svgWidth = _a.svgWidth;
            return {
                fontFamily: fontFamilies.body,
                height: svgHeight,
                width: svgWidth
            };
        },
        lines: {
            fill: 'none',
            strokeWidth: 1,
            strokeLinejoin: 'round',
            strokeLinecap: 'round'
        },
        tooltip: {
            '& path': {
                fill: neutral[100],
                stroke: neutral[400]
            },
            '& rect': {
                fill: neutral[100],
                stroke: neutral[400]
            }
        },
        tooltipText: {
            fontSize: 12,
            textAnchor: 'middle'
        },
        rect: {
            '&:hover': {
                opacity: '50%'
            },
            animationName: '$spin',
            animationFillMode: 'both',
            animationDuration: '4s',
            animationPlayState: 'paused'
        },
        '@keyframes spin': {
            '0%': {
                transform: 'rotate(0)'
            },
            '100%': {
                transform: 'rotate(360deg)'
            }
        }
    };
});
/**
 * Function to ensure the dataset is sorted and has 180 days of data.
 * If longer, show the last 180 days. If shorter, add filler days to display inactive days where no data exists.
 */ var formatData = function(data) {
    // format date strings into Date objects
    var formatted = data.map(function(d) {
        return {
            date: new Date(d.date),
            status: d.status,
            description: d.description
        };
    }).sort(function(a, b) {
        if (a.date > b.date) return 1;
        else if (a.date < b.date) return -1;
        else return 0;
    });
    var earliestDate = (0, $3v896.timeDay).offset(new Date(), -180);
    // Remove any dates before 180 days ago, if needed
    if (formatted[0].date < earliestDate || formatted.length > 180) formatted = formatted.filter(function(d) {
        return d.date >= earliestDate;
    });
    if (formatted.length < 180) {
        // if missing days, fill with status: null days
        var dateFill = (0, $3v896.timeDay).range(earliestDate, new Date());
        // Interpolate existing days and filler days
        return dateFill.map(function(day) {
            return formatted.length > 0 && formatted[0].date.valueOf() == day.valueOf() ? formatted.shift() : {
                date: day,
                status: null,
                description: ''
            };
        });
    }
    return formatted;
};
/**
 * Render a status calendar -- a compact historical view of status data.
 *
 * The chart shows 180 days of data. If there is less it will fill with null
 * values up to the earliest date in the set. If there is more it will truncate
 * to the most recent 180 days.
 *
 * Currently time is handled using the local time settings in d3-time and
 * timezones of the incoming data are ignored. UTC time could be handled
 * with UTC specific d3-time functions.
 */ var StatusCalendar = function(_a) {
    var data = _a.data, containerClassName = _a.containerClassName, svgHeight = _a.svgHeight, svgWidth = _a.svgWidth;
    var _b = $ieT14.useState(formatData(data)), currentData = _b[0], setCurrentData = _b[1];
    var _c = useStatusCalendar(currentData), cellSize = _c.cellSize, x = _c.x, y = _c.y, color = _c.color, dayAxis = _c.dayAxis, monthAxis = _c.monthAxis, viewBoxWidth = _c.viewBoxWidth, viewBoxHeight = _c.viewBoxHeight;
    var classes = useStyles$s({
        svgHeight: svgHeight,
        svgWidth: svgWidth
    });
    var gridRef = $ieT14.useRef();
    var dayAxisRef = $ieT14.useRef();
    var monthAxisRef = $ieT14.useRef();
    var tooltipTextRef = $ieT14.useRef();
    var _d = $ieT14.useState(), tooltip = _d[0], setTooltip = _d[1];
    var _e = $ieT14.useState({
        width: 0,
        height: 0,
        translateX: 0,
        translateY: 0
    }), tooltipBox = _e[0], setTooltipBox = _e[1];
    var dateFormat = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
    };
    $ieT14.useEffect(function() {
        setCurrentData(formatData(data));
    }, [
        data
    ]);
    $ieT14.useEffect(function() {
        (0, $ksTt2.default)(gridRef.current).selectAll('rect').data(currentData).join('rect').attr('width', cellSize * 0.8).attr('height', cellSize * 0.8).attr('x', x).attr('y', y).attr('fill', color).attr('class', classes.rect).attr('transform-origin', function(d) {
            return x(d) + cellSize / 2 + " " + (y(d) + cellSize / 2);
        }).style('animation-delay', function(_, i) {
            return i * 20 + "ms";
        }).on('mouseover', function(_, d) {
            d.status && setTooltip(__assign(__assign({}, d), {
                x: x(d),
                y: y(d)
            }));
        }).on('mouseout', function() {
            return setTooltip(null);
        });
    }, [
        gridRef,
        currentData
    ]);
    $ieT14.useEffect(function() {
        (0, $ksTt2.default)(monthAxisRef.current).call(monthAxis);
    }, [
        monthAxisRef,
        currentData
    ]);
    $ieT14.useEffect(function() {
        (0, $ksTt2.default)(dayAxisRef.current).call(dayAxis);
    }, [
        dayAxisRef
    ]);
    $ieT14.useEffect(function() {
        if (tooltip) {
            var box = tooltipTextRef.current.getBBox();
            var width = box.width + 6;
            var height = box.height + 2;
            var translateX = void 0;
            if (tooltip.x < width / 2) translateX = 4;
            else if (viewBoxWidth - tooltip.x < width / 2 + cellSize * 0.4) translateX = viewBoxWidth - width - 4;
            else translateX = tooltip.x - width / 2 + cellSize * 0.4;
            var translateY = tooltip.y < viewBoxHeight / 2 ? tooltip.y + cellSize : tooltip.y - height - 3;
            setTooltipBox({
                width: width,
                height: height,
                translateX: translateX,
                translateY: translateY
            });
        }
    }, [
        tooltip
    ]);
    function getStatusText(status) {
        switch(status){
            case 'success':
                return 'Pass';
            case 'fail':
                return 'Fail';
            case 'warn':
                return 'Warn';
            default:
                return '';
        }
    }
    return $ieT14.createElement("div", {
        className: clsx(classes.root, containerClassName)
    }, $ieT14.createElement("svg", {
        className: classes.svg,
        viewBox: "0 0 " + viewBoxWidth + " " + viewBoxHeight
    }, $ieT14.createElement("defs", null, $ieT14.createElement("filter", {
        id: "tooltip-shadow"
    }, $ieT14.createElement("feDropShadow", {
        dx: "0",
        dy: "1.5",
        stdDeviation: "2",
        floodColor: neutral[600]
    }))), $ieT14.createElement("g", {
        ref: gridRef
    }), $ieT14.createElement("g", {
        ref: dayAxisRef
    }), $ieT14.createElement("g", {
        ref: monthAxisRef
    }), tooltip && $ieT14.createElement("g", {
        className: classes.tooltip,
        transform: "translate(" + tooltipBox.translateX + " " + tooltipBox.translateY + ")",
        style: {
            filter: 'url(#tooltip-shadow)'
        }
    }, $ieT14.createElement("rect", {
        width: tooltipBox.width,
        height: tooltipBox.height,
        rx: "2"
    }), $ieT14.createElement("g", {
        ref: tooltipTextRef
    }, $ieT14.createElement("text", {
        x: tooltipBox.width / 2,
        y: "4",
        dominantBaseline: "hanging",
        fontWeight: "600",
        className: classes.tooltipText
    }, tooltip.date.toLocaleString('en-US', dateFormat)), $ieT14.createElement("text", {
        x: tooltipBox.width / 2,
        y: "16",
        dominantBaseline: "hanging",
        className: classes.tooltipText
    }, getStatusText(tooltip.status)), $ieT14.createElement("text", {
        x: tooltipBox.width / 2,
        y: "28",
        dominantBaseline: "hanging",
        className: classes.tooltipText
    }, tooltip.description)))));
};
/**
 * Custom hook leveraging d3 to provide functions and data transform needed to render the chart
 */ function useStackedBarChart(data, options) {
    var margin = {
        top: options.svgHeight > 150 ? 20 : 10,
        right: 20,
        bottom: options.showXAxis ? 40 : 12,
        left: options.showYValues ? 40 : 0
    };
    /**
     * Transform the raw data set into a d3.stack
     * Include any data keys other than date
     */ var series = $ieT14.useMemo(function() {
        var stackGen = (0, $a8f6W.default)().keys(Object.keys(data[0]).filter(function(d) {
            return d != 'date';
        }));
        return stackGen(data);
    }, [
        data
    ]);
    /**
     * Calculate the mean and standard deviation of the dataset in order to
     * reduce the effect of outliers in the data by clamping the domain
     */ var domainClamp = $ieT14.useMemo(function() {
        var array = [];
        data.forEach(function(d) {
            var sum = 0;
            for(var prop in d)if (prop !== 'date') sum += d[prop];
            array.push(sum);
        });
        var n = array.length;
        var mean = array.reduce(function(a, b) {
            return a + b;
        }) / n;
        var standardDeviation = Math.sqrt(array.map(function(val) {
            return Math.pow(val - mean, 2);
        }).reduce(function(a, b) {
            return a + b;
        }) / n);
        // clamp data upper limit to within two standard deviations of the mean (95% of normalized values)
        return mean + standardDeviation * 2;
    }, [
        data
    ]);
    /**
     * Generate the x scale: a d3 time scale that maps dates into x positions in pixels
     */ var x = $ieT14.useCallback((0, $ikHyM.default)().domain([
        data[0].date,
        options.relativeToNow ? new Date() : data[data.length - 1].date
    ]).rangeRound([
        margin.left,
        options.svgWidth - margin.right
    ]).nice(), [
        data,
        options
    ]);
    /**
     * Generate the y scale: a d3 linear scale that maps values into y positions in pixels
     */ var y = $ieT14.useCallback((0, $3FIbj.default)().clamp(true).domain([
        0,
        domainClamp
    ]).range([
        options.svgHeight - margin.bottom,
        margin.top
    ]), [
        series,
        options
    ]);
    /**
     * Render the x axis in a d3 selection
     */ var xAxis = $ieT14.useCallback(function(g) {
        return g.attr('transform', "translate(0," + (options.svgHeight - 20) + ")").call((0, $blOHq.axisBottom)(x).ticks(8).tickSizeOuter(0)).call(function(sel) {
            return sel.select('.domain').remove();
        });
    }, [
        x
    ]);
    /**
     * Render the y axis in a d3 selection
     */ var yAxis = $ieT14.useCallback(function(g) {
        return g.attr('transform', "translate(" + margin.left + ",0)").call((0, $blOHq.axisRight)(y).tickSize(options.svgWidth - margin.left - margin.right).ticks(2, 's')).call(function(sel) {
            return sel.select('.domain').remove();
        }).call(function(sel) {
            return sel.attr('stroke-opacity', 0.5).attr('stroke-dasharray', '2,2');
        }).call(function(sel) {
            return sel.selectAll('.tick text').attr('text-anchor', 'end').attr('x', -4).attr('dy', 2);
        });
    }, [
        y
    ]);
    return {
        margin: margin,
        x: x,
        y: y,
        xAxis: xAxis,
        yAxis: yAxis,
        series: series
    };
}
var DateFormatter = Intl.DateTimeFormat('en-US');
var DateTimeFormatter = Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
});
/**
 * Determine whether a background color is light or dark to choose whether white
 * or black text will be more legible
 * original credit: https://awik.io/determine-color-bright-dark-using-javascript/
 */ function lightOrDark(color) {
    // Variables for red, green, blue values
    var r, g, b;
    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {
        // If RGB --> store the red, green, blue values in separate variables
        var rgb = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
        r = Number(rgb[1]);
        g = Number(rgb[2]);
        b = Number(rgb[3]);
    } else {
        // If hex --> Convert it to RGB: http://gist.github.com/983661
        var hex = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'));
        r = hex >> 16;
        g = hex >> 8 & 255;
        b = hex & 255;
    }
    // HSP equation from http://alienryderflex.com/hsp.html
    var hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
    // Using the HSP value, determine whether the color is light or dark
    if (hsp > 127.5) return 'light';
    else return 'dark';
}
var useStyles$r = (0, $e1ONw.default)(function(theme) {
    return {
        root: {},
        text: function(_a) {
            var x = _a.x, svgWidth = _a.svgWidth;
            return {
                fontSize: 16,
                dominantBaseline: 'hanging',
                textAnchor: x < svgWidth / 2 ? 'start' : 'end'
            };
        }
    };
});
/**
 * Render the tooltip in the Stacked bar Chart on hover over bars
 * - Places tooltip the right or left of the corresponding bar depending on where there is more space
 * - Sets the background of data labels to their legend color and determines whether the text
 *   should be dark or light colored for visibility
 */ var BarChartTooltip = function(_a) {
    var x = _a.x, y = _a.y, content = _a.content, svgWidth = _a.svgWidth, legend = _a.legend;
    var classes = useStyles$r({
        x: x,
        svgWidth: svgWidth
    });
    var dateRef = $ieT14.useRef();
    var _b = $ieT14.useState(), dateRect = _b[0], setDateRect = _b[1];
    $ieT14.useLayoutEffect(function() {
        if (dateRef.current) {
            var bbox = dateRef.current.getBBox();
            setDateRect(bbox);
        }
    }, [
        dateRef,
        content,
        x,
        y
    ]);
    return $ieT14.createElement("g", {
        transform: "translate(" + (x < svgWidth / 2 ? x + 20 : x - 10) + "," + y + ")"
    }, dateRect && $ieT14.createElement("rect", {
        x: dateRect.x - 5,
        y: dateRect.y,
        width: dateRect.width + 10,
        height: dateRect.height,
        fill: "rgba(32,32,32,0.8)"
    }), $ieT14.createElement("text", {
        className: classes.text,
        ref: dateRef,
        fill: "white"
    }, DateTimeFormatter.format(content.date)), dateRect && content.data.map(function(d, i) {
        return $ieT14.createElement(TextWithBG, {
            y: dateRect.height * i + dateRect.height,
            content: d.name + ": " + d.amount,
            className: classes.text,
            color: legend.find(function(label) {
                return label.name == d.name;
            }).color,
            key: d.name
        });
    }));
};
var TextWithBG = function(_a) {
    var y = _a.y, content = _a.content, className = _a.className, color = _a.color;
    var textRef = $ieT14.useRef();
    var _b = $ieT14.useState(), textRect = _b[0], setTextRect = _b[1];
    $ieT14.useLayoutEffect(function() {
        if (textRef.current) {
            var bbox = textRef.current.getBBox();
            setTextRect(bbox);
        }
    }, [
        textRef,
        content,
        y
    ]);
    return $ieT14.createElement($ieT14.Fragment, null, textRect && $ieT14.createElement("rect", {
        x: textRect.x - 5,
        y: textRect.y,
        width: textRect.width + 10,
        height: textRect.height,
        fill: color
    }), $ieT14.createElement("text", {
        ref: textRef,
        dy: y,
        className: className,
        fill: lightOrDark(color) == 'light' ? 'black' : 'white'
    }, content));
};
var defaultOptions$2 = {
    showXAxis: true,
    showLegend: true,
    showDots: true,
    showYValues: true,
    svgWidth: 800,
    svgHeight: 200,
    relativeToNow: false
};
var useStyles$q = (0, $e1ONw.default)({
    root: {
        width: '100%',
        height: '100%'
    },
    svg: {
        fontFamily: fontFamilies.body,
        height: '100%',
        width: '100%'
    },
    hoverMask: {
        visibility: 'hidden',
        pointerEvents: 'all',
        cursor: 'crosshair'
    },
    hoverBar: {
        pointerEvents: 'all',
        cursor: 'crosshair',
        '& .hover:hover': {
            fill: 'rgba(0,0,0,.2)'
        }
    },
    legend: {
        display: 'flex',
        justifyContent: 'flex-end',
        '& div': {
            margin: '0 3px',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center'
        }
    },
    labelColor: {
        height: '.7em',
        width: '.7em'
    },
    label: {
        fontFamily: fontFamilies.body,
        fontSize: '.8em',
        margin: 0
    }
});
/**
 * ## Stacked Bar Chart
 *
 * Render a stacked bar chart on a time axis using data of type StackedBarEvent
 */ var StackedBarChart = function(_a) {
    var data = _a.data, containerClassName = _a.containerClassName, legend = _a.legend, options = _a.options;
    var classes = useStyles$q();
    var localOptions = $ieT14.useMemo(function() {
        if (options) {
            var tempOptions = __assign({}, defaultOptions$2);
            for(var option in options)tempOptions[option] = options[option];
            return tempOptions;
        } else return defaultOptions$2;
    }, [
        options
    ]);
    var _b = useStackedBarChart(data, localOptions), margin = _b.margin, x = _b.x, y = _b.y, xAxis = _b.xAxis, yAxis = _b.yAxis, series = _b.series;
    var xAxisRef = $ieT14.useRef();
    var yAxisRef = $ieT14.useRef();
    var barsRef = $ieT14.useRef();
    var outOfBoundsRef = $ieT14.useRef();
    var hoverRef = $ieT14.useRef();
    var dotsRef = $ieT14.useRef();
    var _c = $ieT14.useState(), tooltip = _c[0], setTooltip = _c[1];
    $ieT14.useEffect(function() {
        if (legend.length != series.length) throw Error('Bar Chart: Number of items in legend and data do not match');
    }, [
        series,
        legend
    ]);
    /**
     * Render X Axis
     */ $ieT14.useEffect(function() {
        if (localOptions.showXAxis) (0, $ksTt2.default)(xAxisRef.current).call(xAxis);
        else if (!localOptions.showXAxis && xAxisRef.current && xAxisRef.current.firstChild) // if showXAxis changes to false, remove axis
        while(xAxisRef.current.firstChild)xAxisRef.current.removeChild(xAxisRef.current.firstChild);
    }, [
        xAxis,
        localOptions
    ]);
    /**
     * Render Y Axis
     */ $ieT14.useEffect(function() {
        (0, $ksTt2.default)(yAxisRef.current).call(yAxis);
    }, [
        yAxis
    ]);
    /**
     * Render Bars and Dots
     */ $ieT14.useEffect(function() {
        var barWidth;
        if (localOptions.barWidth) barWidth = localOptions.barWidth;
        else if (data.length < 10) barWidth = 12;
        else if (data.length < 40) barWidth = 8;
        else if (data.length < 80) barWidth = 6;
        else barWidth = 4;
        (0, $ksTt2.default)(barsRef.current).selectAll('g').data(series).join('g').attr('fill', function(d) {
            return legend.find(function(l) {
                return l.key == d.key;
            }).color;
        }).selectAll('rect').data(function(d) {
            return d;
        }).join('rect').attr('x', function(d, i) {
            return x(d.data.date) - barWidth / 2;
        }).attr('y', function(d) {
            return y(d[1]);
        }).attr('height', function(d) {
            return y(d[0]) - y(d[1]);
        }).attr('width', barWidth);
        (0, $ksTt2.default)(outOfBoundsRef.current).selectAll('g').data(series).join('g').lower() // reverse the order so that the color of lower bars takes precendence
        .attr('fill', function(d) {
            return legend.find(function(l) {
                return l.key == d.key;
            }).color;
        }).selectAll('polygon').data(function(events) {
            return events.filter(function(event) {
                return y(event[1]) == margin.top;
            });
        }).join('polygon').attr('points', function(d) {
            var xcenter = x(d.data.date);
            return xcenter - barWidth + ", " + margin.top + " " + xcenter + ", " + (margin.top - barWidth - 2) + " " + (xcenter + barWidth) + ", " + margin.top;
        });
        (0, $ksTt2.default)(hoverRef.current).selectAll('rect').data(data).join('rect').attr('x', function(d, i) {
            return x(d.date) - barWidth / 2;
        }).attr('y', margin.top).attr('height', localOptions.svgHeight - margin.top - margin.bottom).attr('width', barWidth).attr('fill', 'transparent').attr('class', 'hover').on('mouseenter', function(e, d) {
            setTooltip({
                x: x(d.date) - 4,
                y: margin.top / 2,
                content: {
                    date: d.date,
                    data: legend.map(function(l) {
                        return {
                            name: l.name,
                            amount: d[l.key]
                        };
                    })
                }
            });
        }).on('mouseleave', function() {
            setTooltip(null);
        });
        if (localOptions.showDots) {
            var dotWidth = void 0;
            if (data.length < 40) dotWidth = 8;
            else if (data.length < 80) dotWidth = 6;
            else dotWidth = 4;
            (0, $ksTt2.default)(dotsRef.current).selectAll('circle').data(series[0]).join('circle').attr('cx', function(d) {
                return x(d.data.date);
            }).attr('cy', localOptions.svgHeight - margin.bottom + 8).attr('r', dotWidth / 2).attr('fill', '#1F82BF').attr('class', 'dot');
        } else if (!localOptions.showDots && dotsRef.current && dotsRef.current.firstChild) // if dots change to false, remove dots
        while(dotsRef.current.firstChild)dotsRef.current.removeChild(dotsRef.current.firstChild);
    }, [
        x,
        y,
        series,
        localOptions
    ]);
    return $ieT14.createElement("div", {
        className: clsx(classes.root, containerClassName)
    }, $ieT14.createElement("svg", {
        className: classes.svg,
        viewBox: "0 0 " + localOptions.svgWidth + " " + localOptions.svgHeight
    }, $ieT14.createElement("g", {
        ref: yAxisRef
    }), localOptions.showXAxis && $ieT14.createElement("g", {
        ref: xAxisRef
    }), $ieT14.createElement("g", {
        ref: barsRef
    }), $ieT14.createElement("g", {
        ref: outOfBoundsRef
    }), $ieT14.createElement("rect", {
        x: margin.left,
        y: margin.top,
        width: localOptions.svgWidth - margin.top - margin.left,
        height: localOptions.svgHeight - margin.top - margin.bottom,
        className: classes.hoverMask
    }), $ieT14.createElement("g", {
        ref: hoverRef,
        className: classes.hoverBar
    }), localOptions.showDots && $ieT14.createElement("g", {
        ref: dotsRef
    }), tooltip && $ieT14.createElement(BarChartTooltip, __assign({}, tooltip, {
        svgWidth: localOptions.svgWidth,
        legend: legend
    }))), localOptions.showLegend && $ieT14.createElement("div", {
        className: classes.legend
    }, legend.map(function(label) {
        return $ieT14.createElement("div", {
            key: "label-" + label.name
        }, $ieT14.createElement("div", {
            className: classes.labelColor,
            style: {
                backgroundColor: "" + label.color
            }
        }), $ieT14.createElement("p", {
            className: classes.label
        }, label.name));
    })));
};
function max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}
function min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}
function sum$1(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}
function left(node) {
    return node.depth;
}
function justify(node, n) {
    return node.sourceLinks.length ? node.depth : n - 1;
}
function constant$1(x) {
    return function() {
        return x;
    };
}
function ascendingSourceBreadth(a, b) {
    return ascendingBreadth(a.source, b.source) || a.index - b.index;
}
function ascendingTargetBreadth(a, b) {
    return ascendingBreadth(a.target, b.target) || a.index - b.index;
}
function ascendingBreadth(a, b) {
    return a.y0 - b.y0;
}
function value(d) {
    return d.value;
}
function defaultId(d) {
    return d.index;
}
function defaultNodes(graph) {
    return graph.nodes;
}
function defaultLinks(graph) {
    return graph.links;
}
function find$1(nodeById, id) {
    const node = nodeById.get(id);
    if (!node) throw new Error("missing: " + id);
    return node;
}
function computeLinkBreadths({ nodes }) {
    for (const node of nodes){
        let y0 = node.y0;
        let y1 = y0;
        for (const link of node.sourceLinks){
            link.y0 = y0 + link.width / 2;
            y0 += link.width;
        }
        for (const link of node.targetLinks){
            link.y1 = y1 + link.width / 2;
            y1 += link.width;
        }
    }
}
function Sankey$1() {
    let x0 = 0, y0 = 0, x1 = 1, y1 = 1; // extent
    let dx = 24; // nodeWidth
    let dy = 8, py; // nodePadding
    let id = defaultId;
    let align = justify;
    let sort;
    let linkSort;
    let nodes = defaultNodes;
    let links = defaultLinks;
    let iterations = 6;
    function sankey() {
        const graph = {
            nodes: nodes.apply(null, arguments),
            links: links.apply(null, arguments)
        };
        computeNodeLinks(graph);
        computeNodeValues(graph);
        computeNodeDepths(graph);
        computeNodeHeights(graph);
        computeNodeBreadths(graph);
        computeLinkBreadths(graph);
        return graph;
    }
    sankey.update = function(graph) {
        computeLinkBreadths(graph);
        return graph;
    };
    sankey.nodeId = function(_) {
        return arguments.length ? (id = typeof _ === "function" ? _ : constant$1(_), sankey) : id;
    };
    sankey.nodeAlign = function(_) {
        return arguments.length ? (align = typeof _ === "function" ? _ : constant$1(_), sankey) : align;
    };
    sankey.nodeSort = function(_) {
        return arguments.length ? (sort = _, sankey) : sort;
    };
    sankey.nodeWidth = function(_) {
        return arguments.length ? (dx = +_, sankey) : dx;
    };
    sankey.nodePadding = function(_) {
        return arguments.length ? (dy = py = +_, sankey) : dy;
    };
    sankey.nodes = function(_) {
        return arguments.length ? (nodes = typeof _ === "function" ? _ : constant$1(_), sankey) : nodes;
    };
    sankey.links = function(_) {
        return arguments.length ? (links = typeof _ === "function" ? _ : constant$1(_), sankey) : links;
    };
    sankey.linkSort = function(_) {
        return arguments.length ? (linkSort = _, sankey) : linkSort;
    };
    sankey.size = function(_) {
        return arguments.length ? (x0 = y0 = 0, x1 = +_[0], y1 = +_[1], sankey) : [
            x1 - x0,
            y1 - y0
        ];
    };
    sankey.extent = function(_) {
        return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], sankey) : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    sankey.iterations = function(_) {
        return arguments.length ? (iterations = +_, sankey) : iterations;
    };
    function computeNodeLinks({ nodes, links }) {
        for (const [i, node] of nodes.entries()){
            node.index = i;
            node.sourceLinks = [];
            node.targetLinks = [];
        }
        const nodeById = new Map(nodes.map((d, i)=>[
                id(d, i, nodes),
                d
            ]));
        for (const [i, link] of links.entries()){
            link.index = i;
            let { source, target } = link;
            if (typeof source !== "object") source = link.source = find$1(nodeById, source);
            if (typeof target !== "object") target = link.target = find$1(nodeById, target);
            source.sourceLinks.push(link);
            target.targetLinks.push(link);
        }
        if (linkSort != null) for (const { sourceLinks, targetLinks } of nodes){
            sourceLinks.sort(linkSort);
            targetLinks.sort(linkSort);
        }
    }
    function computeNodeValues({ nodes }) {
        for (const node of nodes)node.value = node.fixedValue === undefined ? Math.max(sum$1(node.sourceLinks, value), sum$1(node.targetLinks, value)) : node.fixedValue;
    }
    function computeNodeDepths({ nodes }) {
        const n = nodes.length;
        let current = new Set(nodes);
        let next = new Set;
        let x = 0;
        while(current.size){
            for (const node of current){
                node.depth = x;
                for (const { target } of node.sourceLinks)next.add(target);
            }
            if (++x > n) throw new Error("circular link");
            current = next;
            next = new Set;
        }
    }
    function computeNodeHeights({ nodes }) {
        const n = nodes.length;
        let current = new Set(nodes);
        let next = new Set;
        let x = 0;
        while(current.size){
            for (const node of current){
                node.height = x;
                for (const { source } of node.targetLinks)next.add(source);
            }
            if (++x > n) throw new Error("circular link");
            current = next;
            next = new Set;
        }
    }
    function computeNodeLayers({ nodes }) {
        const x = max(nodes, (d)=>d.depth) + 1;
        const kx = (x1 - x0 - dx) / (x - 1);
        const columns = new Array(x);
        for (const node of nodes){
            const i = Math.max(0, Math.min(x - 1, Math.floor(align.call(null, node, x))));
            node.layer = i;
            node.x0 = x0 + i * kx;
            node.x1 = node.x0 + dx;
            if (columns[i]) columns[i].push(node);
            else columns[i] = [
                node
            ];
        }
        if (sort) for (const column of columns)column.sort(sort);
        return columns;
    }
    function initializeNodeBreadths(columns) {
        const ky = min(columns, (c)=>(y1 - y0 - (c.length - 1) * py) / sum$1(c, value));
        for (const nodes of columns){
            let y = y0;
            for (const node of nodes){
                node.y0 = y;
                node.y1 = y + node.value * ky;
                y = node.y1 + py;
                for (const link of node.sourceLinks)link.width = link.value * ky;
            }
            y = (y1 - y + py) / (nodes.length + 1);
            for(let i = 0; i < nodes.length; ++i){
                const node = nodes[i];
                node.y0 += y * (i + 1);
                node.y1 += y * (i + 1);
            }
            reorderLinks(nodes);
        }
    }
    function computeNodeBreadths(graph) {
        const columns = computeNodeLayers(graph);
        py = Math.min(dy, (y1 - y0) / (max(columns, (c)=>c.length) - 1));
        initializeNodeBreadths(columns);
        for(let i = 0; i < iterations; ++i){
            const alpha = Math.pow(0.99, i);
            const beta = Math.max(1 - alpha, (i + 1) / iterations);
            relaxRightToLeft(columns, alpha, beta);
            relaxLeftToRight(columns, alpha, beta);
        }
    }
    // Reposition each node based on its incoming (target) links.
    function relaxLeftToRight(columns, alpha, beta) {
        for(let i = 1, n = columns.length; i < n; ++i){
            const column = columns[i];
            for (const target of column){
                let y = 0;
                let w = 0;
                for (const { source, value } of target.targetLinks){
                    let v = value * (target.layer - source.layer);
                    y += targetTop(source, target) * v;
                    w += v;
                }
                if (!(w > 0)) continue;
                let dy = (y / w - target.y0) * alpha;
                target.y0 += dy;
                target.y1 += dy;
                reorderNodeLinks(target);
            }
            if (sort === undefined) column.sort(ascendingBreadth);
            resolveCollisions(column, beta);
        }
    }
    // Reposition each node based on its outgoing (source) links.
    function relaxRightToLeft(columns, alpha, beta) {
        for(let n = columns.length, i = n - 2; i >= 0; --i){
            const column = columns[i];
            for (const source of column){
                let y = 0;
                let w = 0;
                for (const { target, value } of source.sourceLinks){
                    let v = value * (target.layer - source.layer);
                    y += sourceTop(source, target) * v;
                    w += v;
                }
                if (!(w > 0)) continue;
                let dy = (y / w - source.y0) * alpha;
                source.y0 += dy;
                source.y1 += dy;
                reorderNodeLinks(source);
            }
            if (sort === undefined) column.sort(ascendingBreadth);
            resolveCollisions(column, beta);
        }
    }
    function resolveCollisions(nodes, alpha) {
        const i = nodes.length >> 1;
        const subject = nodes[i];
        resolveCollisionsBottomToTop(nodes, subject.y0 - py, i - 1, alpha);
        resolveCollisionsTopToBottom(nodes, subject.y1 + py, i + 1, alpha);
        resolveCollisionsBottomToTop(nodes, y1, nodes.length - 1, alpha);
        resolveCollisionsTopToBottom(nodes, y0, 0, alpha);
    }
    // Push any overlapping nodes down.
    function resolveCollisionsTopToBottom(nodes, y, i, alpha) {
        for(; i < nodes.length; ++i){
            const node = nodes[i];
            const dy = (y - node.y0) * alpha;
            if (dy > 1e-6) node.y0 += dy, node.y1 += dy;
            y = node.y1 + py;
        }
    }
    // Push any overlapping nodes up.
    function resolveCollisionsBottomToTop(nodes, y, i, alpha) {
        for(; i >= 0; --i){
            const node = nodes[i];
            const dy = (node.y1 - y) * alpha;
            if (dy > 1e-6) node.y0 -= dy, node.y1 -= dy;
            y = node.y0 - py;
        }
    }
    function reorderNodeLinks({ sourceLinks, targetLinks }) {
        if (linkSort === undefined) {
            for (const { source: { sourceLinks } } of targetLinks)sourceLinks.sort(ascendingTargetBreadth);
            for (const { target: { targetLinks } } of sourceLinks)targetLinks.sort(ascendingSourceBreadth);
        }
    }
    function reorderLinks(nodes) {
        if (linkSort === undefined) for (const { sourceLinks, targetLinks } of nodes){
            sourceLinks.sort(ascendingTargetBreadth);
            targetLinks.sort(ascendingSourceBreadth);
        }
    }
    // Returns the target.y0 that would produce an ideal link from source to target.
    function targetTop(source, target) {
        let y = source.y0 - (source.sourceLinks.length - 1) * py / 2;
        for (const { target: node, width } of source.sourceLinks){
            if (node === target) break;
            y += width + py;
        }
        for (const { source: node, width } of target.targetLinks){
            if (node === source) break;
            y -= width;
        }
        return y;
    }
    // Returns the source.y0 that would produce an ideal link from source to target.
    function sourceTop(source, target) {
        let y = target.y0 - (target.targetLinks.length - 1) * py / 2;
        for (const { source: node, width } of target.targetLinks){
            if (node === source) break;
            y += width + py;
        }
        for (const { target: node, width } of source.sourceLinks){
            if (node === target) break;
            y -= width;
        }
        return y;
    }
    return sankey;
}
var pi$1 = Math.PI, tau$1 = 2 * pi$1, epsilon$1 = 1e-6, tauEpsilon = tau$1 - epsilon$1;
function Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function path() {
    return new Path;
}
Path.prototype = path.prototype = {
    constructor: Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > epsilon$1)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$1) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi$1 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > epsilon$1) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > epsilon$1 || Math.abs(this._y1 - y0) > epsilon$1) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % tau$1 + tau$1;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > epsilon$1) this._ += "A" + r + "," + r + ",0," + +(da >= pi$1) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
function constant(x) {
    return function constant() {
        return x;
    };
}
function x$2(p) {
    return p[0];
}
function y$2(p) {
    return p[1];
}
var slice = Array.prototype.slice;
function linkSource(d) {
    return d.source;
}
function linkTarget(d) {
    return d.target;
}
function link(curve) {
    var source = linkSource, target = linkTarget, x = x$2, y = y$2, context = null;
    function link() {
        var buffer, argv = slice.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
        if (!context) context = buffer = path();
        curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
        if (buffer) return context = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : constant(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : constant(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, link) : context;
    };
    return link;
}
function curveHorizontal(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}
function linkHorizontal() {
    return link(curveHorizontal);
}
function horizontalSource(d) {
    return [
        d.source.x1,
        d.y0
    ];
}
function horizontalTarget(d) {
    return [
        d.target.x0,
        d.y1
    ];
}
function sankeyLinkHorizontal() {
    return linkHorizontal().source(horizontalSource).target(horizontalTarget);
}
function useSankey(options) {
    var margin = {
        top: options.fontSize,
        right: 5,
        bottom: options.fontSize,
        left: 5
    };
    var layoutGenerator = $ieT14.useCallback(function(nodes, links) {
        var sankeyGen = Sankey$1().nodeId(function(d) {
            return d.name;
        }).nodeAlign(left).nodeWidth(15).nodePadding(10).extent([
            [
                margin.left,
                margin.top
            ],
            [
                options.svgWidth - margin.right,
                options.svgHeight - margin.bottom
            ]
        ]);
        return sankeyGen({
            nodes: nodes.map(function(d) {
                return Object.assign({}, d);
            }),
            links: links.map(function(d) {
                return Object.assign({}, d);
            })
        });
    }, [
        margin,
        options
    ]);
    return {
        layoutGenerator: layoutGenerator,
        format: function(value, units) {
            return (0, $4UuJL.format)(',.0f')(value) + " " + units;
        }
    };
}
var useStyles$p = (0, $e1ONw.default)({
    root: {
        width: '100%',
        height: '100%'
    },
    svg: {
        fontFamily: fontFamilies.body,
        height: '100%',
        width: '100%'
    }
});
/**
 * ## Sankey Chart
 * Render a Sankey diagram illustrating flow between multiple points in a system
 */ var Sankey = function(_a) {
    var data = _a.data, options = _a.options;
    var classes = useStyles$p();
    var nodeRef = $ieT14.useRef();
    var linkRef = $ieT14.useRef();
    var textRef = $ieT14.useRef();
    var localOptions = $ieT14.useMemo(function() {
        var defaults = {
            svgWidth: 800,
            svgHeight: 100,
            fontSize: 20
        };
        return options != undefined ? {
            svgWidth: options.svgWidth != undefined ? options.svgWidth : defaults.svgWidth,
            svgHeight: options.svgHeight != undefined ? options.svgHeight : defaults.svgHeight,
            fontSize: options.fontSize != undefined ? options.fontSize : defaults.fontSize
        } : defaults;
    }, []);
    var _b = useSankey(localOptions), layoutGenerator = _b.layoutGenerator, format = _b.format;
    var _c = $ieT14.useMemo(function() {
        return layoutGenerator(data.nodes, data.links);
    }, []), nodes = _c.nodes, links = _c.links;
    $ieT14.useEffect(function() {
        (0, $ksTt2.default)(nodeRef.current).attr('stroke', '#000').selectAll('rect').data(nodes).join('rect').attr('x', function(d) {
            return d.x0;
        }).attr('y', function(d) {
            return d.y0;
        }).attr('height', function(d) {
            return d.y1 - d.y0;
        }).attr('width', function(d) {
            return d.x1 - d.x0;
        }).attr('fill', function(d) {
            return d.color;
        }).append('title').text(function(d) {
            return d.name + "\n" + format(d.value, data.units);
        });
        (0, $ksTt2.default)(textRef.current).attr('font-family', 'sans-serif').attr('font-size', localOptions.fontSize).selectAll('text').data(nodes).join('text').attr('x', function(d) {
            return d.x0 < localOptions.svgWidth / 2 ? d.x1 + 6 : d.x0 - 6;
        }).attr('y', function(d) {
            return (d.y1 + d.y0) / 2;
        }).attr('dy', '0.35em').attr('text-anchor', function(d) {
            return d.x0 < localOptions.svgWidth / 2 ? 'start' : 'end';
        }).attr('fill', '#000').attr('stroke', 'none').text(function(d) {
            return d.name;
        });
    }, [
        nodes
    ]);
    $ieT14.useEffect(function() {
        var link = (0, $ksTt2.default)(linkRef.current).attr('fill', 'none').attr('stroke-opacity', 0.5).selectAll('g').data(links).join('g').style('mix-blend-mode', 'multiply');
        link.append('path').attr('d', sankeyLinkHorizontal())// @ts-ignore: Property 'x' does not exist on type 'Y'
        .attr('stroke', function(d) {
            return d.target.color;
        }).attr('stroke-width', function(d) {
            return Math.max(1, d.width);
        });
        link.append('title')// @ts-ignore: Property 'x' does not exist on type 'Y'
        .text(function(d) {
            return d.source.name + " \u2192 " + d.target.name + "\n" + format(d.value, data.units);
        });
    }, [
        links
    ]);
    return $ieT14.createElement("div", {
        className: classes.root
    }, $ieT14.createElement("svg", {
        className: classes.svg,
        viewBox: "0 0 " + localOptions.svgWidth + " " + localOptions.svgHeight
    }, $ieT14.createElement("g", {
        ref: nodeRef
    }), $ieT14.createElement("g", {
        ref: linkRef
    }), $ieT14.createElement("g", {
        ref: textRef
    })));
};
/**
 * Custom hook leveraging d3 to provide functions and data transform needed to render the chart
 */ function useThresholdBarChart(data, options) {
    var bottom = 4;
    if (options.showXAxis) bottom = 40;
    else if (options.showDots) bottom = 16;
    var margin = {
        top: 20,
        right: 20,
        bottom: bottom,
        left: options.showYValues ? 40 : 0
    };
    /**
     * Calculate the mean and standard deviation of the dataset in order to
     * reduce the effect of outliers in the data by clamping the domain
     * Clamp to whichever is larger: two standard deviations above mean or double
     * the highest threshold in the data
     */ var domainClamp = $ieT14.useMemo(function() {
        var highestThreshold = data.map(function(d) {
            return d.threshold;
        }).reduce(function(a, b) {
            return a > b ? a : b;
        }, 0);
        var amounts = data.map(function(d) {
            return d.amount;
        });
        var mean = amounts.reduce(function(a, b) {
            return a + b;
        }) / amounts.length;
        var standardDeviation = Math.sqrt(amounts.map(function(val) {
            return Math.pow(val - mean, 2);
        }).reduce(function(a, b) {
            return a + b;
        }) / amounts.length);
        var devClamp = mean + standardDeviation * 2;
        return devClamp < highestThreshold * 2 ? highestThreshold * 2 : devClamp;
    }, [
        data
    ]);
    /**
     * Generate the x scale: a d3 time scale that maps dates into x positions in pixels
     */ var x = $ieT14.useCallback((0, $ikHyM.default)().domain([
        data[0].date,
        options.relativeToNow ? new Date() : data[data.length - 1].date
    ]).range([
        margin.left,
        options.svgWidth - margin.right
    ]).nice(), [
        data,
        options
    ]);
    /**
     * Generate the y scale: a d3 linear scale that maps values into y positions in pixels
     */ var y = $ieT14.useCallback((0, $3FIbj.default)().clamp(true).domain([
        0,
        domainClamp
    ]).range([
        options.svgHeight - margin.bottom,
        margin.top
    ]), [
        domainClamp,
        options
    ]);
    /**
     * Render the x axis in a d3 selection
     */ var xAxis = $ieT14.useCallback(function(g) {
        return g.attr('transform', "translate(0," + (options.svgHeight - 20) + ")").call((0, $blOHq.axisBottom)(x).ticks(8).tickSizeOuter(0)).call(function(sel) {
            return sel.select('.domain').remove();
        });
    }, [
        x
    ]);
    /**
     * Render the y axis in a d3 selection
     */ var yAxis = $ieT14.useCallback(function(g) {
        return g.attr('transform', "translate(" + margin.left + ",0)").call((0, $blOHq.axisRight)(y).tickSize(options.svgWidth - margin.left - margin.right).ticks(2, 's')).call(function(sel) {
            return sel.select('.domain').remove();
        }).call(function(sel) {
            return sel.attr('stroke-opacity', 0.5).attr('stroke-dasharray', '2,2');
        }).call(function(sel) {
            return sel.selectAll('.tick text').attr('text-anchor', 'end').attr('x', -4).attr('dy', 2);
        });
    }, [
        y
    ]);
    return {
        margin: margin,
        x: x,
        y: y,
        xAxis: xAxis,
        yAxis: yAxis
    };
}
var useStyles$o = (0, $e1ONw.default)(function(theme) {
    return {
        text: function(_a) {
            var x = _a.x, svgWidth = _a.svgWidth;
            return {
                fontFamily: fontFamilies.body,
                fontSize: 16,
                dominantBaseline: 'hanging',
                textAnchor: x < svgWidth / 2 ? 'start' : 'end'
            };
        }
    };
});
/**
 *  ## Threshold Tooltip
 *
 * Render a tooltip in the threshold bar chart. Shown when hovering over a bar.
 */ var ThresholdTooltip = function(_a) {
    var data = _a.data, svgWidth = _a.svgWidth;
    var classes = useStyles$o({
        x: data.x,
        svgWidth: svgWidth
    });
    var dateRef = $ieT14.useRef();
    var _b = $ieT14.useState(), dateRect = _b[0], setDateRect = _b[1];
    var valueRef = $ieT14.useRef();
    var _c = $ieT14.useState(), valueRect = _c[0], setValueRect = _c[1];
    var thresholdRef = $ieT14.useRef();
    var _d = $ieT14.useState(), thresholdRect = _d[0], setThresholdRect = _d[1];
    $ieT14.useLayoutEffect(function() {
        if (dateRef.current) setDateRect(dateRef.current.getBBox());
    }, [
        dateRef,
        data
    ]);
    $ieT14.useLayoutEffect(function() {
        if (valueRef.current) setValueRect(valueRef.current.getBBox());
    }, [
        valueRef,
        data
    ]);
    $ieT14.useLayoutEffect(function() {
        if (thresholdRef.current) setThresholdRect(thresholdRef.current.getBBox());
    }, [
        thresholdRef,
        data
    ]);
    return $ieT14.createElement("g", {
        transform: "translate(" + (data.x < svgWidth / 2 ? data.x + 20 : data.x - 10) + "," + data.y + ")"
    }, dateRect && $ieT14.createElement("rect", {
        x: dateRect.x - 5,
        y: dateRect.y,
        width: dateRect.width + 10,
        height: dateRect.height,
        fill: "rgba(32,32,32,0.8)"
    }), $ieT14.createElement("text", {
        className: classes.text,
        ref: dateRef,
        fill: "white"
    }, DateTimeFormatter.format(data.date)), valueRect && $ieT14.createElement("rect", {
        x: valueRect.x - 5,
        y: valueRect.y + 22,
        width: valueRect.width + 10,
        height: valueRect.height,
        fill: data.isPassing ? '#1F82BF' : '#ad1f1f'
    }), $ieT14.createElement("text", {
        transform: "translate(0, 22)",
        className: classes.text,
        ref: valueRef,
        fill: "white"
    }, "Value: " + data.amount), thresholdRect && $ieT14.createElement("rect", {
        x: thresholdRect.x - 5,
        y: thresholdRect.y + 44,
        width: thresholdRect.width + 10,
        height: thresholdRect.height,
        fill: data.isPassing ? '#1F82BF' : '#ad1f1f'
    }), $ieT14.createElement("text", {
        transform: "translate(0, 44)",
        className: classes.text,
        ref: thresholdRef,
        fill: "white"
    }, "Threshold: " + data.comparative + " " + data.threshold));
};
var defaultOptions$1 = {
    showXAxis: true,
    showDots: true,
    showYValues: true,
    svgWidth: 800,
    svgHeight: 200,
    relativeToNow: false
};
var useStyles$n = (0, $e1ONw.default)({
    root: {
        width: '100%',
        height: '100%'
    },
    svg: {
        fontFamily: fontFamilies.body,
        height: '100%',
        width: '100%'
    },
    hoverMask: {
        visibility: 'hidden',
        pointerEvents: 'all',
        cursor: 'crosshair'
    },
    hoverBar: {
        pointerEvents: 'all',
        cursor: 'crosshair',
        '& .hover:hover': {
            fill: 'rgba(0,0,0,.2)'
        }
    }
});
function getBarWidth(options, dataLength) {
    var barWidth;
    if (options.barWidth) barWidth = options.barWidth;
    else if (dataLength < 10) barWidth = 12;
    else if (dataLength < 40) barWidth = 8;
    else if (dataLength < 80) barWidth = 6;
    else barWidth = 4;
    return barWidth;
}
/**
 *  ## Threshold Bar Chart
 *
 * Renders a combined bar/line chart showing a series of threshold test results
 * as bars and the threshold value overlayed as a line.
 */ var ThresholdBarChart = function(_a) {
    var data = _a.data, options = _a.options, containerClassName = _a.containerClassName;
    var classes = useStyles$n();
    var xAxisRef = $ieT14.useRef();
    var yAxisRef = $ieT14.useRef();
    var barsRef = $ieT14.useRef();
    var lineRef = $ieT14.useRef();
    var outOfBoundsRef = $ieT14.useRef();
    var hoverRef = $ieT14.useRef();
    var dotsRef = $ieT14.useRef();
    var _b = $ieT14.useState(), tooltip = _b[0], setTooltip = _b[1];
    var localOptions = $ieT14.useMemo(function() {
        if (options) {
            var tempOptions = __assign({}, defaultOptions$1);
            for(var option in options)tempOptions[option] = options[option];
            return tempOptions;
        } else return defaultOptions$1;
    }, [
        options
    ]);
    var _c = useThresholdBarChart(data, localOptions), margin = _c.margin, x = _c.x, y = _c.y, xAxis = _c.xAxis, yAxis = _c.yAxis;
    /**
     * Render X Axis
     */ $ieT14.useEffect(function() {
        if (localOptions.showXAxis) (0, $ksTt2.default)(xAxisRef.current).call(xAxis);
        else if (!localOptions.showXAxis && xAxisRef.current && xAxisRef.current.firstChild) // if showXAxis changes to false, remove axis
        while(xAxisRef.current.firstChild)xAxisRef.current.removeChild(xAxisRef.current.firstChild);
    }, [
        xAxis,
        localOptions
    ]);
    /**
     * Render Y Axis
     */ $ieT14.useEffect(function() {
        (0, $ksTt2.default)(yAxisRef.current).call(yAxis);
    }, [
        yAxis
    ]);
    /**
     * Render Bars, lines, Dots
     */ $ieT14.useEffect(function() {
        var pass = '#1F82BF';
        var fail = '#ed6666';
        var barWidth = getBarWidth(localOptions, data.length);
        (0, $ksTt2.default)(barsRef.current).selectAll('rect').data(data).join('rect').attr('fill', function(d) {
            return d.isPassing ? pass : fail;
        }).attr('x', function(d) {
            return x(d.date) - barWidth / 2;
        }).attr('y', function(d) {
            return y(d.amount);
        }).attr('height', function(d) {
            return y(0) - y(d.amount);
        }).attr('width', barWidth);
        (0, $ksTt2.default)(outOfBoundsRef.current).selectAll('polygon').data(data.filter(function(d) {
            return y(d.amount) == margin.top;
        })).join('polygon').attr('fill', fail).attr('points', function(d) {
            var xcenter = x(d.date);
            return xcenter - barWidth + ", " + margin.top + " " + xcenter + ", " + (margin.top - barWidth - 2) + " " + (xcenter + barWidth) + ", " + margin.top;
        });
        while(lineRef.current.firstChild)lineRef.current.removeChild(lineRef.current.firstChild);
        (0, $ksTt2.default)(lineRef.current).append('path').datum(data).attr('fill', 'none').attr('stroke', blue[300]).attr('stroke-width', 2).attr('d', (0, $geBL0.default)().defined(function(d) {
            return !isNaN(d.amount);
        }).curve((0, $1evnz.default)).x(function(d) {
            return x(d.date);
        }).y(function(d) {
            return y(d.threshold);
        }));
        (0, $ksTt2.default)(hoverRef.current).selectAll('rect').data(data).join('rect').attr('x', function(d, i) {
            return x(d.date) - barWidth / 2;
        }).attr('y', margin.top).attr('height', localOptions.svgHeight - margin.top - margin.bottom).attr('width', barWidth).attr('fill', 'transparent').attr('class', 'hover').on('mouseenter', function(e, d) {
            setTooltip({
                x: x(d.date) - 4,
                y: margin.top,
                date: d.date,
                isPassing: d.isPassing,
                amount: d.amount,
                comparative: d.comparative,
                threshold: d.threshold
            });
        }).on('mouseleave', function() {
            setTooltip(null);
        });
        if (localOptions.showDots) {
            var dotWidth = void 0;
            if (data.length < 40) dotWidth = 8;
            else if (data.length < 80) dotWidth = 6;
            else dotWidth = 4;
            (0, $ksTt2.default)(dotsRef.current).selectAll('circle').data(data).join('circle').attr('cx', function(d) {
                return x(d.date);
            }).attr('cy', localOptions.svgHeight - margin.bottom + 8).attr('r', dotWidth / 2).attr('fill', function(d) {
                return d.isPassing ? pass : fail;
            }).attr('class', 'dot');
        } else if (!localOptions.showDots && dotsRef.current && dotsRef.current.firstChild) // if dots change to false, remove dots
        while(dotsRef.current.firstChild)dotsRef.current.removeChild(dotsRef.current.firstChild);
    }, [
        x,
        y,
        data,
        localOptions
    ]);
    return $ieT14.createElement("div", {
        className: clsx(classes.root, containerClassName)
    }, $ieT14.createElement("svg", {
        viewBox: "0 0 " + localOptions.svgWidth + " " + localOptions.svgHeight
    }, $ieT14.createElement("g", {
        ref: yAxisRef
    }), localOptions.showXAxis && $ieT14.createElement("g", {
        ref: xAxisRef
    }), $ieT14.createElement("g", {
        ref: barsRef
    }), $ieT14.createElement("g", {
        ref: lineRef
    }), localOptions.showDots && $ieT14.createElement("g", {
        ref: dotsRef
    }), $ieT14.createElement("g", {
        ref: outOfBoundsRef
    }), $ieT14.createElement("rect", {
        x: margin.left,
        y: margin.top,
        width: localOptions.svgWidth - margin.top - margin.left,
        height: localOptions.svgHeight - margin.top - margin.bottom,
        className: classes.hoverMask
    }), $ieT14.createElement("g", {
        ref: hoverRef,
        className: classes.hoverBar
    }), tooltip && $ieT14.createElement(ThresholdTooltip, {
        data: tooltip,
        svgWidth: localOptions.svgWidth
    })));
};
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function unwrapExports(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
function createCommonjsModule(fn, basedir, module1) {
    return module1 = {
        path: basedir,
        exports: {},
        require: function(path, base) {
            return commonjsRequire(path, base === undefined || base === null ? module1.path : base);
        }
    }, fn(module1, module1.exports), module1.exports;
}
function getCjsExportFromNamespace(n) {
    return n && n['default'] || n;
}
function commonjsRequire() {
    throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}
var objectWithoutPropertiesLoose = createCommonjsModule(function(module1) {
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    module1.exports = _objectWithoutPropertiesLoose, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
});
var objectWithoutProperties = createCommonjsModule(function(module1) {
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    module1.exports = _objectWithoutProperties, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
});
var _objectWithoutProperties$1 = /*@__PURE__*/ unwrapExports(objectWithoutProperties);
var arrayLikeToArray = createCommonjsModule(function(module1) {
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    module1.exports = _arrayLikeToArray, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
});
var arrayWithoutHoles = createCommonjsModule(function(module1) {
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return arrayLikeToArray(arr);
    }
    module1.exports = _arrayWithoutHoles, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
});
var iterableToArray = createCommonjsModule(function(module1) {
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    module1.exports = _iterableToArray, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
});
var unsupportedIterableToArray = createCommonjsModule(function(module1) {
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
    }
    module1.exports = _unsupportedIterableToArray, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
});
var nonIterableSpread = createCommonjsModule(function(module1) {
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    module1.exports = _nonIterableSpread, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
});
var toConsumableArray = createCommonjsModule(function(module1) {
    function _toConsumableArray(arr) {
        return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
    }
    module1.exports = _toConsumableArray, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
});
var _toConsumableArray$1 = /*@__PURE__*/ unwrapExports(toConsumableArray);
var defineProperty$1 = createCommonjsModule(function(module1) {
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    module1.exports = _defineProperty, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
});
var _defineProperty$1 = /*@__PURE__*/ unwrapExports(defineProperty$1);
var _extends_1 = createCommonjsModule(function(module1) {
    function _extends() {
        module1.exports = _extends = Object.assign || function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        }, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
        return _extends.apply(this, arguments);
    }
    module1.exports = _extends, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
});
var _extends$1 = /*@__PURE__*/ unwrapExports(_extends_1);
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$1(Object(source), !0).forEach(function(key) {
            _defineProperty$1(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
//
// Super simple, non-algorithmic solution since the
// number of class names will not be greater than 4
function powerSetPermutations(arr) {
    var arrLength = arr.length;
    if (arrLength === 0 || arrLength === 1) return arr;
    if (arrLength === 2) // prettier-ignore
    return [
        arr[0],
        arr[1],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0])
    ];
    if (arrLength === 3) return [
        arr[0],
        arr[1],
        arr[2],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0])
    ];
    if (arrLength >= 4) // Currently does not support more than 4 extra
    // class names (after `.token` has been removed)
    return [
        arr[0],
        arr[1],
        arr[2],
        arr[3],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[1], ".").concat(arr[0])
    ];
}
var classNameCombinations = {};
function getClassNameCombinations(classNames) {
    if (classNames.length === 0 || classNames.length === 1) return classNames;
    var key = classNames.join('.');
    if (!classNameCombinations[key]) classNameCombinations[key] = powerSetPermutations(classNames);
    return classNameCombinations[key];
}
function createStyleObject(classNames) {
    var elementStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var stylesheet = arguments.length > 2 ? arguments[2] : undefined;
    var nonTokenClassNames = classNames.filter(function(className) {
        return className !== 'token';
    });
    var classNamesCombinations = getClassNameCombinations(nonTokenClassNames);
    return classNamesCombinations.reduce(function(styleObject, className) {
        return _objectSpread$1(_objectSpread$1({}, styleObject), stylesheet[className]);
    }, elementStyle);
}
function createClassNameString(classNames) {
    return classNames.join(' ');
}
function createChildren(stylesheet, useInlineStyles) {
    var childrenCount = 0;
    return function(children) {
        childrenCount += 1;
        return children.map(function(child, i) {
            return createElement({
                node: child,
                stylesheet: stylesheet,
                useInlineStyles: useInlineStyles,
                key: "code-segment-".concat(childrenCount, "-").concat(i)
            });
        });
    };
}
function createElement(_ref) {
    var node = _ref.node, stylesheet = _ref.stylesheet, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style, useInlineStyles = _ref.useInlineStyles, key = _ref.key;
    var properties = node.properties, type = node.type, TagName = node.tagName, value = node.value;
    if (type === 'text') return value;
    else if (TagName) {
        var childrenCreator = createChildren(stylesheet, useInlineStyles);
        var props;
        if (!useInlineStyles) props = _objectSpread$1(_objectSpread$1({}, properties), {}, {
            className: createClassNameString(properties.className)
        });
        else {
            var allStylesheetSelectors = Object.keys(stylesheet).reduce(function(classes, selector) {
                selector.split('.').forEach(function(className) {
                    if (!classes.includes(className)) classes.push(className);
                });
                return classes;
            }, []); // For compatibility with older versions of react-syntax-highlighter
            var startingClassName = properties.className && properties.className.includes('token') ? [
                'token'
            ] : [];
            var className = properties.className && startingClassName.concat(properties.className.filter(function(className) {
                return !allStylesheetSelectors.includes(className);
            }));
            props = _objectSpread$1(_objectSpread$1({}, properties), {}, {
                className: createClassNameString(className) || undefined,
                style: createStyleObject(properties.className, Object.assign({}, properties.style, style), stylesheet)
            });
        }
        var children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement(TagName, _extends$1({
            key: key
        }, props), children);
    }
}
var checkForListedLanguage = function(astGenerator, language) {
    var langs = astGenerator.listLanguages();
    return langs.indexOf(language) !== -1;
};
var _excluded = [
    "language",
    "children",
    "style",
    "customStyle",
    "codeTagProps",
    "useInlineStyles",
    "showLineNumbers",
    "showInlineLineNumbers",
    "startingLineNumber",
    "lineNumberContainerStyle",
    "lineNumberStyle",
    "wrapLines",
    "wrapLongLines",
    "lineProps",
    "renderer",
    "PreTag",
    "CodeTag",
    "code",
    "astGenerator"
];
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty$1(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var newLineRegex = /\n/g;
function getNewLines(str) {
    return str.match(newLineRegex);
}
function getAllLineNumbers(_ref) {
    var lines = _ref.lines, startingLineNumber = _ref.startingLineNumber, style = _ref.style;
    return lines.map(function(_, i) {
        var number = i + startingLineNumber;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement("span", {
            key: "line-".concat(i),
            className: "react-syntax-highlighter-line-number",
            style: typeof style === 'function' ? style(number) : style
        }, "".concat(number, "\n"));
    });
}
function AllLineNumbers(_ref2) {
    var codeString = _ref2.codeString, codeStyle = _ref2.codeStyle, _ref2$containerStyle = _ref2.containerStyle, containerStyle = _ref2$containerStyle === void 0 ? {
        "float": 'left',
        paddingRight: '10px'
    } : _ref2$containerStyle, _ref2$numberStyle = _ref2.numberStyle, numberStyle = _ref2$numberStyle === void 0 ? {} : _ref2$numberStyle, startingLineNumber = _ref2.startingLineNumber;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement("code", {
        style: Object.assign({}, codeStyle, containerStyle)
    }, getAllLineNumbers({
        lines: codeString.replace(/\n$/, '').split('\n'),
        style: numberStyle,
        startingLineNumber: startingLineNumber
    }));
}
function getEmWidthOfNumber(num) {
    return "".concat(num.toString().length, ".25em");
}
function getInlineLineNumber(lineNumber, inlineLineNumberStyle) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: "line-number--".concat(lineNumber),
            className: [
                'comment',
                'linenumber',
                'react-syntax-highlighter-line-number'
            ],
            style: inlineLineNumberStyle
        },
        children: [
            {
                type: 'text',
                value: lineNumber
            }
        ]
    };
}
function assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber) {
    // minimally necessary styling for line numbers
    var defaultLineNumberStyle = {
        display: 'inline-block',
        minWidth: getEmWidthOfNumber(largestLineNumber),
        paddingRight: '1em',
        textAlign: 'right',
        userSelect: 'none'
    }; // prep custom styling
    var customLineNumberStyle = typeof lineNumberStyle === 'function' ? lineNumberStyle(lineNumber) : lineNumberStyle; // combine
    var assembledStyle = _objectSpread(_objectSpread({}, defaultLineNumberStyle), customLineNumberStyle);
    return assembledStyle;
}
function createLineElement(_ref3) {
    var children = _ref3.children, lineNumber = _ref3.lineNumber, lineNumberStyle = _ref3.lineNumberStyle, largestLineNumber = _ref3.largestLineNumber, showInlineLineNumbers = _ref3.showInlineLineNumbers, _ref3$lineProps = _ref3.lineProps, lineProps = _ref3$lineProps === void 0 ? {} : _ref3$lineProps, _ref3$className = _ref3.className, className = _ref3$className === void 0 ? [] : _ref3$className, showLineNumbers = _ref3.showLineNumbers, wrapLongLines = _ref3.wrapLongLines;
    var properties = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    properties['className'] = className;
    if (lineNumber && showInlineLineNumbers) {
        var inlineLineNumberStyle = assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber);
        children.unshift(getInlineLineNumber(lineNumber, inlineLineNumberStyle));
    }
    if (wrapLongLines & showLineNumbers) properties.style = _objectSpread(_objectSpread({}, properties.style), {}, {
        display: 'flex'
    });
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: children
    };
}
function flattenCodeTree(tree) {
    var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var newTree = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    for(var i = 0; i < tree.length; i++){
        var node = tree[i];
        if (node.type === 'text') newTree.push(createLineElement({
            children: [
                node
            ],
            className: _toConsumableArray$1(new Set(className))
        }));
        else if (node.children) {
            var classNames = className.concat(node.properties.className);
            flattenCodeTree(node.children, classNames).forEach(function(i) {
                return newTree.push(i);
            });
        }
    }
    return newTree;
}
function processLines(codeTree, wrapLines, lineProps, showLineNumbers, showInlineLineNumbers, startingLineNumber, largestLineNumber, lineNumberStyle, wrapLongLines) {
    var _ref4;
    var tree = flattenCodeTree(codeTree.value);
    var newTree = [];
    var lastLineBreakIndex = -1;
    var index = 0;
    function createWrappedLine(children, lineNumber) {
        var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        return createLineElement({
            children: children,
            lineNumber: lineNumber,
            lineNumberStyle: lineNumberStyle,
            largestLineNumber: largestLineNumber,
            showInlineLineNumbers: showInlineLineNumbers,
            lineProps: lineProps,
            className: className,
            showLineNumbers: showLineNumbers,
            wrapLongLines: wrapLongLines
        });
    }
    function createUnwrappedLine(children, lineNumber) {
        if (showLineNumbers && lineNumber && showInlineLineNumbers) {
            var inlineLineNumberStyle = assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber);
            children.unshift(getInlineLineNumber(lineNumber, inlineLineNumberStyle));
        }
        return children;
    }
    function createLine(children, lineNumber) {
        var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        return wrapLines || className.length > 0 ? createWrappedLine(children, lineNumber, className) : createUnwrappedLine(children, lineNumber);
    }
    var _loop = function _loop() {
        var node = tree[index];
        var value = node.children[0].value;
        var newLines = getNewLines(value);
        if (newLines) {
            var splitValue = value.split('\n');
            splitValue.forEach(function(text, i) {
                var lineNumber = showLineNumbers && newTree.length + startingLineNumber;
                var newChild = {
                    type: 'text',
                    value: "".concat(text, "\n")
                }; // if it's the first line
                if (i === 0) {
                    var _children = tree.slice(lastLineBreakIndex + 1, index).concat(createLineElement({
                        children: [
                            newChild
                        ],
                        className: node.properties.className
                    }));
                    var _line = createLine(_children, lineNumber);
                    newTree.push(_line); // if it's the last line
                } else if (i === splitValue.length - 1) {
                    var stringChild = tree[index + 1] && tree[index + 1].children && tree[index + 1].children[0];
                    var lastLineInPreviousSpan = {
                        type: 'text',
                        value: "".concat(text)
                    };
                    if (stringChild) {
                        var newElem = createLineElement({
                            children: [
                                lastLineInPreviousSpan
                            ],
                            className: node.properties.className
                        });
                        tree.splice(index + 1, 0, newElem);
                    } else {
                        var _children2 = [
                            lastLineInPreviousSpan
                        ];
                        var _line2 = createLine(_children2, lineNumber, node.properties.className);
                        newTree.push(_line2);
                    } // if it's neither the first nor the last line
                } else {
                    var _children3 = [
                        newChild
                    ];
                    var _line3 = createLine(_children3, lineNumber, node.properties.className);
                    newTree.push(_line3);
                }
            });
            lastLineBreakIndex = index;
        }
        index++;
    };
    while(index < tree.length)_loop();
    if (lastLineBreakIndex !== tree.length - 1) {
        var children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            var lineNumber = showLineNumbers && newTree.length + startingLineNumber;
            var line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    return wrapLines ? newTree : (_ref4 = []).concat.apply(_ref4, newTree);
}
function defaultRenderer(_ref5) {
    var rows = _ref5.rows, stylesheet = _ref5.stylesheet, useInlineStyles = _ref5.useInlineStyles;
    return rows.map(function(node, i) {
        return createElement({
            node: node,
            stylesheet: stylesheet,
            useInlineStyles: useInlineStyles,
            key: "code-segement".concat(i)
        });
    });
} // only highlight.js has the highlightAuto method
function isHighlightJs(astGenerator) {
    return astGenerator && typeof astGenerator.highlightAuto !== 'undefined';
}
function getCodeTree(_ref6) {
    var astGenerator = _ref6.astGenerator, language = _ref6.language, code = _ref6.code, defaultCodeValue = _ref6.defaultCodeValue;
    // figure out whether we're using lowlight/highlight or refractor/prism
    // then attempt highlighting accordingly
    // lowlight/highlight?
    if (isHighlightJs(astGenerator)) {
        var hasLanguage = checkForListedLanguage(astGenerator, language);
        if (language === 'text') return {
            value: defaultCodeValue,
            language: 'text'
        };
        else if (hasLanguage) return astGenerator.highlight(language, code);
        else return astGenerator.highlightAuto(code);
    } // must be refractor/prism, then
    try {
        return language && language !== 'text' ? {
            value: astGenerator.highlight(code, language)
        } : {
            value: defaultCodeValue
        };
    } catch (e) {
        return {
            value: defaultCodeValue
        };
    }
}
function highlight$1(defaultAstGenerator, defaultStyle) {
    return function SyntaxHighlighter(_ref7) {
        var language = _ref7.language, children = _ref7.children, _ref7$style = _ref7.style, style = _ref7$style === void 0 ? defaultStyle : _ref7$style, _ref7$customStyle = _ref7.customStyle, customStyle = _ref7$customStyle === void 0 ? {} : _ref7$customStyle, _ref7$codeTagProps = _ref7.codeTagProps, codeTagProps = _ref7$codeTagProps === void 0 ? {
            className: language ? "language-".concat(language) : undefined,
            style: _objectSpread(_objectSpread({}, style['code[class*="language-"]']), style["code[class*=\"language-".concat(language, "\"]")])
        } : _ref7$codeTagProps, _ref7$useInlineStyles = _ref7.useInlineStyles, useInlineStyles = _ref7$useInlineStyles === void 0 ? true : _ref7$useInlineStyles, _ref7$showLineNumbers = _ref7.showLineNumbers, showLineNumbers = _ref7$showLineNumbers === void 0 ? false : _ref7$showLineNumbers, _ref7$showInlineLineN = _ref7.showInlineLineNumbers, showInlineLineNumbers = _ref7$showInlineLineN === void 0 ? true : _ref7$showInlineLineN, _ref7$startingLineNum = _ref7.startingLineNumber, startingLineNumber = _ref7$startingLineNum === void 0 ? 1 : _ref7$startingLineNum, lineNumberContainerStyle = _ref7.lineNumberContainerStyle, _ref7$lineNumberStyle = _ref7.lineNumberStyle, lineNumberStyle = _ref7$lineNumberStyle === void 0 ? {} : _ref7$lineNumberStyle, wrapLines = _ref7.wrapLines, _ref7$wrapLongLines = _ref7.wrapLongLines, wrapLongLines = _ref7$wrapLongLines === void 0 ? false : _ref7$wrapLongLines, _ref7$lineProps = _ref7.lineProps, lineProps = _ref7$lineProps === void 0 ? {} : _ref7$lineProps, renderer = _ref7.renderer, _ref7$PreTag = _ref7.PreTag, PreTag = _ref7$PreTag === void 0 ? 'pre' : _ref7$PreTag, _ref7$CodeTag = _ref7.CodeTag, CodeTag = _ref7$CodeTag === void 0 ? 'code' : _ref7$CodeTag, _ref7$code = _ref7.code, code = _ref7$code === void 0 ? (Array.isArray(children) ? children[0] : children) || '' : _ref7$code, astGenerator = _ref7.astGenerator, rest = _objectWithoutProperties$1(_ref7, _excluded);
        astGenerator = astGenerator || defaultAstGenerator;
        var allLineNumbers = showLineNumbers ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement(AllLineNumbers, {
            containerStyle: lineNumberContainerStyle,
            codeStyle: codeTagProps.style || {},
            numberStyle: lineNumberStyle,
            startingLineNumber: startingLineNumber,
            codeString: code
        }) : null;
        var defaultPreStyle = style.hljs || style['pre[class*="language-"]'] || {
            backgroundColor: '#fff'
        };
        var generatorClassName = isHighlightJs(astGenerator) ? 'hljs' : 'prismjs';
        var preProps = useInlineStyles ? Object.assign({}, rest, {
            style: Object.assign({}, defaultPreStyle, customStyle)
        }) : Object.assign({}, rest, {
            className: rest.className ? "".concat(generatorClassName, " ").concat(rest.className) : generatorClassName,
            style: Object.assign({}, customStyle)
        });
        if (wrapLongLines) codeTagProps.style = _objectSpread(_objectSpread({}, codeTagProps.style), {}, {
            whiteSpace: 'pre-wrap'
        });
        else codeTagProps.style = _objectSpread(_objectSpread({}, codeTagProps.style), {}, {
            whiteSpace: 'pre'
        });
        if (!astGenerator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement(PreTag, preProps, allLineNumbers, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement(CodeTag, codeTagProps, code));
        /*
     * Some custom renderers rely on individual row elements so we need to turn wrapLines on
     * if renderer is provided and wrapLines is undefined.
     */ if (wrapLines === undefined && renderer || wrapLongLines) wrapLines = true;
        renderer = renderer || defaultRenderer;
        var defaultCodeValue = [
            {
                type: 'text',
                value: code
            }
        ];
        var codeTree = getCodeTree({
            astGenerator: astGenerator,
            language: language,
            code: code,
            defaultCodeValue: defaultCodeValue
        });
        if (codeTree.language === null) codeTree.value = defaultCodeValue;
         // determine largest line number so that we can force minWidth on all linenumber elements
        var largestLineNumber = codeTree.value.length + startingLineNumber;
        var rows = processLines(codeTree, wrapLines, lineProps, showLineNumbers, showInlineLineNumbers, startingLineNumber, largestLineNumber, lineNumberStyle, wrapLongLines);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement(PreTag, preProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement(CodeTag, codeTagProps, !showInlineLineNumbers && allLineNumbers, renderer({
            rows: rows,
            stylesheet: style,
            useInlineStyles: useInlineStyles
        })));
    };
}
var immutable = extend;
var hasOwnProperty$a = Object.prototype.hasOwnProperty;
function extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (hasOwnProperty$a.call(source, key)) target[key] = source[key];
    }
    return target;
}
var schema = Schema;
var proto$1 = Schema.prototype;
proto$1.space = null;
proto$1.normal = {};
proto$1.property = {};
function Schema(property, normal, space) {
    this.property = property;
    this.normal = normal;
    if (space) this.space = space;
}
var merge_1 = merge;
function merge(definitions) {
    var length = definitions.length;
    var property = [];
    var normal = [];
    var index = -1;
    var info;
    var space;
    while(++index < length){
        info = definitions[index];
        property.push(info.property);
        normal.push(info.normal);
        space = info.space;
    }
    return new schema(immutable.apply(null, property), immutable.apply(null, normal), space);
}
var normalize_1 = normalize;
function normalize(value) {
    return value.toLowerCase();
}
var info = Info;
var proto = Info.prototype;
proto.space = null;
proto.attribute = null;
proto.property = null;
proto.boolean = false;
proto.booleanish = false;
proto.overloadedBoolean = false;
proto.number = false;
proto.commaSeparated = false;
proto.spaceSeparated = false;
proto.commaOrSpaceSeparated = false;
proto.mustUseProperty = false;
proto.defined = false;
function Info(property, attribute) {
    this.property = property;
    this.attribute = attribute;
}
var powers = 0;
var boolean_1 = increment$1();
var booleanish$2 = increment$1();
var overloadedBoolean$1 = increment$1();
var number$2 = increment$1();
var spaceSeparated$2 = increment$1();
var commaSeparated$1 = increment$1();
var commaOrSpaceSeparated = increment$1();
function increment$1() {
    return Math.pow(2, ++powers);
}
var types = {
    boolean: boolean_1,
    booleanish: booleanish$2,
    overloadedBoolean: overloadedBoolean$1,
    number: number$2,
    spaceSeparated: spaceSeparated$2,
    commaSeparated: commaSeparated$1,
    commaOrSpaceSeparated: commaOrSpaceSeparated
};
var definedInfo = DefinedInfo;
DefinedInfo.prototype = new info();
DefinedInfo.prototype.defined = true;
var checks = [
    'boolean',
    'booleanish',
    'overloadedBoolean',
    'number',
    'commaSeparated',
    'spaceSeparated',
    'commaOrSpaceSeparated'
];
var checksLength = checks.length;
function DefinedInfo(property, attribute, mask, space) {
    var index = -1;
    var check;
    mark(this, 'space', space);
    info.call(this, property, attribute);
    while(++index < checksLength){
        check = checks[index];
        mark(this, check, (mask & types[check]) === types[check]);
    }
}
function mark(values, key, value) {
    if (value) values[key] = value;
}
var create_1 = create;
function create(definition) {
    var space = definition.space;
    var mustUseProperty = definition.mustUseProperty || [];
    var attributes = definition.attributes || {};
    var props = definition.properties;
    var transform = definition.transform;
    var property = {};
    var normal = {};
    var prop;
    var info;
    for(prop in props){
        info = new definedInfo(prop, transform(attributes, prop), props[prop], space);
        if (mustUseProperty.indexOf(prop) !== -1) info.mustUseProperty = true;
        property[prop] = info;
        normal[normalize_1(prop)] = prop;
        normal[normalize_1(info.attribute)] = prop;
    }
    return new schema(property, normal, space);
}
var xlink = create_1({
    space: 'xlink',
    transform: xlinkTransform,
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});
function xlinkTransform(_, prop) {
    return 'xlink:' + prop.slice(5).toLowerCase();
}
var xml = create_1({
    space: 'xml',
    transform: xmlTransform,
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});
function xmlTransform(_, prop) {
    return 'xml:' + prop.slice(3).toLowerCase();
}
var caseSensitiveTransform_1 = caseSensitiveTransform;
function caseSensitiveTransform(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}
var caseInsensitiveTransform_1 = caseInsensitiveTransform;
function caseInsensitiveTransform(attributes, property) {
    return caseSensitiveTransform_1(attributes, property.toLowerCase());
}
var xmlns = create_1({
    space: 'xmlns',
    attributes: {
        xmlnsxlink: 'xmlns:xlink'
    },
    transform: caseInsensitiveTransform_1,
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});
var booleanish$1 = types.booleanish;
var number$1 = types.number;
var spaceSeparated$1 = types.spaceSeparated;
var aria = create_1({
    transform: ariaTransform,
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: booleanish$1,
        ariaAutoComplete: null,
        ariaBusy: booleanish$1,
        ariaChecked: booleanish$1,
        ariaColCount: number$1,
        ariaColIndex: number$1,
        ariaColSpan: number$1,
        ariaControls: spaceSeparated$1,
        ariaCurrent: null,
        ariaDescribedBy: spaceSeparated$1,
        ariaDetails: null,
        ariaDisabled: booleanish$1,
        ariaDropEffect: spaceSeparated$1,
        ariaErrorMessage: null,
        ariaExpanded: booleanish$1,
        ariaFlowTo: spaceSeparated$1,
        ariaGrabbed: booleanish$1,
        ariaHasPopup: null,
        ariaHidden: booleanish$1,
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: spaceSeparated$1,
        ariaLevel: number$1,
        ariaLive: null,
        ariaModal: booleanish$1,
        ariaMultiLine: booleanish$1,
        ariaMultiSelectable: booleanish$1,
        ariaOrientation: null,
        ariaOwns: spaceSeparated$1,
        ariaPlaceholder: null,
        ariaPosInSet: number$1,
        ariaPressed: booleanish$1,
        ariaReadOnly: booleanish$1,
        ariaRelevant: null,
        ariaRequired: booleanish$1,
        ariaRoleDescription: spaceSeparated$1,
        ariaRowCount: number$1,
        ariaRowIndex: number$1,
        ariaRowSpan: number$1,
        ariaSelected: booleanish$1,
        ariaSetSize: number$1,
        ariaSort: null,
        ariaValueMax: number$1,
        ariaValueMin: number$1,
        ariaValueNow: number$1,
        ariaValueText: null,
        role: null
    }
});
function ariaTransform(_, prop) {
    return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase();
}
var boolean = types.boolean;
var overloadedBoolean = types.overloadedBoolean;
var booleanish = types.booleanish;
var number = types.number;
var spaceSeparated = types.spaceSeparated;
var commaSeparated = types.commaSeparated;
var html$1 = create_1({
    space: 'html',
    attributes: {
        acceptcharset: 'accept-charset',
        classname: 'class',
        htmlfor: 'for',
        httpequiv: 'http-equiv'
    },
    transform: caseInsensitiveTransform_1,
    mustUseProperty: [
        'checked',
        'multiple',
        'muted',
        'selected'
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: commaSeparated,
        acceptCharset: spaceSeparated,
        accessKey: spaceSeparated,
        action: null,
        allow: null,
        allowFullScreen: boolean,
        allowPaymentRequest: boolean,
        allowUserMedia: boolean,
        alt: null,
        as: null,
        async: boolean,
        autoCapitalize: null,
        autoComplete: spaceSeparated,
        autoFocus: boolean,
        autoPlay: boolean,
        capture: boolean,
        charSet: null,
        checked: boolean,
        cite: null,
        className: spaceSeparated,
        cols: number,
        colSpan: null,
        content: null,
        contentEditable: booleanish,
        controls: boolean,
        controlsList: spaceSeparated,
        coords: number | commaSeparated,
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: boolean,
        defer: boolean,
        dir: null,
        dirName: null,
        disabled: boolean,
        download: overloadedBoolean,
        draggable: booleanish,
        encType: null,
        enterKeyHint: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: boolean,
        formTarget: null,
        headers: spaceSeparated,
        height: number,
        hidden: boolean,
        high: number,
        href: null,
        hrefLang: null,
        htmlFor: spaceSeparated,
        httpEquiv: spaceSeparated,
        id: null,
        imageSizes: null,
        imageSrcSet: commaSeparated,
        inputMode: null,
        integrity: null,
        is: null,
        isMap: boolean,
        itemId: null,
        itemProp: spaceSeparated,
        itemRef: spaceSeparated,
        itemScope: boolean,
        itemType: spaceSeparated,
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: boolean,
        low: number,
        manifest: null,
        max: null,
        maxLength: number,
        media: null,
        method: null,
        min: null,
        minLength: number,
        multiple: boolean,
        muted: boolean,
        name: null,
        nonce: null,
        noModule: boolean,
        noValidate: boolean,
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforePrint: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextMenu: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: boolean,
        optimum: number,
        pattern: null,
        ping: spaceSeparated,
        placeholder: null,
        playsInline: boolean,
        poster: null,
        preload: null,
        readOnly: boolean,
        referrerPolicy: null,
        rel: spaceSeparated,
        required: boolean,
        reversed: boolean,
        rows: number,
        rowSpan: number,
        sandbox: spaceSeparated,
        scope: null,
        scoped: boolean,
        seamless: boolean,
        selected: boolean,
        shape: null,
        size: number,
        sizes: null,
        slot: null,
        span: number,
        spellCheck: booleanish,
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: commaSeparated,
        start: number,
        step: null,
        style: null,
        tabIndex: number,
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: boolean,
        useMap: null,
        value: booleanish,
        width: number,
        wrap: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: spaceSeparated,
        axis: null,
        background: null,
        bgColor: null,
        border: number,
        borderColor: null,
        bottomMargin: number,
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: boolean,
        declare: boolean,
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: number,
        leftMargin: number,
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: number,
        marginWidth: number,
        noResize: boolean,
        noHref: boolean,
        noShade: boolean,
        noWrap: boolean,
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: number,
        rules: null,
        scheme: null,
        scrolling: booleanish,
        standby: null,
        summary: null,
        text: null,
        topMargin: number,
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: number,
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: boolean,
        disableRemotePlayback: boolean,
        prefix: null,
        property: null,
        results: number,
        security: null,
        unselectable: null
    }
});
var html_1$1 = merge_1([
    xml,
    xlink,
    xmlns,
    aria,
    html$1
]);
var data = 'data';
var find_1 = find;
var valid = /^data[-\w.:]+$/i;
var dash$1 = /-[a-z]/g;
var cap$1 = /[A-Z]/g;
function find(schema, value) {
    var normal = normalize_1(value);
    var prop = value;
    var Type = info;
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === data && valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === '-') prop = datasetToProperty(value);
        else value = datasetToAttribute(value);
        Type = definedInfo;
    }
    return new Type(prop, value);
}
function datasetToProperty(attribute) {
    var value = attribute.slice(5).replace(dash$1, camelcase);
    return data + value.charAt(0).toUpperCase() + value.slice(1);
}
function datasetToAttribute(property) {
    var value = property.slice(4);
    if (dash$1.test(value)) return property;
    value = value.replace(cap$1, kebab);
    if (value.charAt(0) !== '-') value = '-' + value;
    return data + value;
}
function kebab($0) {
    return '-' + $0.toLowerCase();
}
function camelcase($0) {
    return $0.charAt(1).toUpperCase();
}
var hastUtilParseSelector = parse$3;
var search = /[#.]/g;
// Create a hast element from a simple CSS selector.
function parse$3(selector, defaultTagName) {
    var value = selector || '';
    var name = defaultTagName || 'div';
    var props = {};
    var start = 0;
    var subvalue;
    var previous;
    var match;
    while(start < value.length){
        search.lastIndex = start;
        match = search.exec(value);
        subvalue = value.slice(start, match ? match.index : value.length);
        if (subvalue) {
            if (!previous) name = subvalue;
            else if (previous === '#') props.id = subvalue;
            else if (props.className) props.className.push(subvalue);
            else props.className = [
                subvalue
            ];
            start += subvalue.length;
        }
        if (match) {
            previous = match[0];
            start++;
        }
    }
    return {
        type: 'element',
        tagName: name,
        properties: props,
        children: []
    };
}
var parse_1$1 = parse$2;
var stringify_1$1 = stringify$2;
var empty$2 = '';
var space$2 = ' ';
var whiteSpace = /[ \t\n\r\f]+/g;
function parse$2(value) {
    var input = String(value || empty$2).trim();
    return input === empty$2 ? [] : input.split(whiteSpace);
}
function stringify$2(values) {
    return values.join(space$2).trim();
}
var spaceSeparatedTokens = {
    parse: parse_1$1,
    stringify: stringify_1$1
};
var parse_1 = parse$1;
var stringify_1 = stringify$1;
var comma$1 = ',';
var space$1 = ' ';
var empty$1 = '';
// Parse comma-separated tokens to an array.
function parse$1(value) {
    var values = [];
    var input = String(value || empty$1);
    var index = input.indexOf(comma$1);
    var lastIndex = 0;
    var end = false;
    var val;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        val = input.slice(lastIndex, index).trim();
        if (val || !end) values.push(val);
        lastIndex = index + 1;
        index = input.indexOf(comma$1, lastIndex);
    }
    return values;
}
// Compile an array to comma-separated tokens.
// `options.padLeft` (default: `true`) pads a space left of each token, and
// `options.padRight` (default: `false`) pads a space to the right of each token.
function stringify$1(values, options) {
    var settings = options || {};
    var left = settings.padLeft === false ? empty$1 : space$1;
    var right = settings.padRight ? space$1 : empty$1;
    // Ensure the last empty entry is seen.
    if (values[values.length - 1] === empty$1) values = values.concat(empty$1);
    return values.join(right + comma$1 + left).trim();
}
var commaSeparatedTokens = {
    parse: parse_1,
    stringify: stringify_1
};
var spaces = spaceSeparatedTokens.parse;
var commas = commaSeparatedTokens.parse;
var factory_1 = factory;
var own$3 = {}.hasOwnProperty;
function factory(schema, defaultTagName, caseSensitive) {
    var adjust = caseSensitive ? createAdjustMap(caseSensitive) : null;
    return h;
    // Hyperscript compatible DSL for creating virtual hast trees.
    function h(selector, properties) {
        var node = hastUtilParseSelector(selector, defaultTagName);
        var children = Array.prototype.slice.call(arguments, 2);
        var name = node.tagName.toLowerCase();
        var property;
        node.tagName = adjust && own$3.call(adjust, name) ? adjust[name] : name;
        if (properties && isChildren(properties, node)) {
            children.unshift(properties);
            properties = null;
        }
        if (properties) for(property in properties)addProperty(node.properties, property, properties[property]);
        addChild(node.children, children);
        if (node.tagName === 'template') {
            node.content = {
                type: 'root',
                children: node.children
            };
            node.children = [];
        }
        return node;
    }
    function addProperty(properties, key, value) {
        var info;
        var property;
        var result;
        // Ignore nullish and NaN values.
        if (value === null || value === undefined || value !== value) return;
        info = find_1(schema, key);
        property = info.property;
        result = value;
        // Handle list values.
        if (typeof result === 'string') {
            if (info.spaceSeparated) result = spaces(result);
            else if (info.commaSeparated) result = commas(result);
            else if (info.commaOrSpaceSeparated) result = spaces(commas(result).join(' '));
        }
        // Accept `object` on style.
        if (property === 'style' && typeof value !== 'string') result = style$2(result);
        // Class-names (which can be added both on the `selector` and here).
        if (property === 'className' && properties.className) result = properties.className.concat(result);
        properties[property] = parsePrimitives(info, property, result);
    }
}
function isChildren(value, node) {
    return typeof value === 'string' || 'length' in value || isNode(node.tagName, value);
}
function isNode(tagName, value) {
    var type = value.type;
    if (tagName === 'input' || !type || typeof type !== 'string') return false;
    if (typeof value.children === 'object' && 'length' in value.children) return true;
    type = type.toLowerCase();
    if (tagName === 'button') return type !== 'menu' && type !== 'submit' && type !== 'reset' && type !== 'button';
    return 'value' in value;
}
function addChild(nodes, value) {
    var index;
    var length;
    if (typeof value === 'string' || typeof value === 'number') {
        nodes.push({
            type: 'text',
            value: String(value)
        });
        return;
    }
    if (typeof value === 'object' && 'length' in value) {
        index = -1;
        length = value.length;
        while(++index < length)addChild(nodes, value[index]);
        return;
    }
    if (typeof value !== 'object' || !('type' in value)) throw new Error('Expected node, nodes, or string, got `' + value + '`');
    nodes.push(value);
}
// Parse a (list of) primitives.
function parsePrimitives(info, name, value) {
    var index;
    var length;
    var result;
    if (typeof value !== 'object' || !('length' in value)) return parsePrimitive(info, name, value);
    length = value.length;
    index = -1;
    result = [];
    while(++index < length)result[index] = parsePrimitive(info, name, value[index]);
    return result;
}
// Parse a single primitives.
function parsePrimitive(info, name, value) {
    var result = value;
    if (info.number || info.positiveNumber) {
        if (!isNaN(result) && result !== '') result = Number(result);
    } else if (info.boolean || info.overloadedBoolean) // Accept `boolean` and `string`.
    {
        if (typeof result === 'string' && (result === '' || normalize_1(value) === normalize_1(name))) result = true;
    }
    return result;
}
function style$2(value) {
    var result = [];
    var key;
    for(key in value)result.push([
        key,
        value[key]
    ].join(': '));
    return result.join('; ');
}
function createAdjustMap(values) {
    var length = values.length;
    var index = -1;
    var result = {};
    var value;
    while(++index < length){
        value = values[index];
        result[value.toLowerCase()] = value;
    }
    return result;
}
var html = factory_1(html_1$1, 'div');
html.displayName = 'html';
var html_1 = html;
var hastscript = html_1;
var AElig$1 = "\xc6";
var AMP$1 = "&";
var Aacute$1 = "\xc1";
var Acirc$1 = "\xc2";
var Agrave$1 = "\xc0";
var Aring$1 = "\xc5";
var Atilde$1 = "\xc3";
var Auml$1 = "\xc4";
var COPY$1 = "\xa9";
var Ccedil$1 = "\xc7";
var ETH$1 = "\xd0";
var Eacute$1 = "\xc9";
var Ecirc$1 = "\xca";
var Egrave$1 = "\xc8";
var Euml$1 = "\xcb";
var GT$1 = ">";
var Iacute$1 = "\xcd";
var Icirc$1 = "\xce";
var Igrave$1 = "\xcc";
var Iuml$1 = "\xcf";
var LT$1 = "<";
var Ntilde$1 = "\xd1";
var Oacute$1 = "\xd3";
var Ocirc$1 = "\xd4";
var Ograve$1 = "\xd2";
var Oslash$1 = "\xd8";
var Otilde$1 = "\xd5";
var Ouml$1 = "\xd6";
var QUOT$1 = "\"";
var REG$1 = "\xae";
var THORN$1 = "\xde";
var Uacute$1 = "\xda";
var Ucirc$1 = "\xdb";
var Ugrave$1 = "\xd9";
var Uuml$1 = "\xdc";
var Yacute$1 = "\xdd";
var aacute$1 = "\xe1";
var acirc$1 = "\xe2";
var acute$1 = "\xb4";
var aelig$1 = "\xe6";
var agrave$1 = "\xe0";
var amp$1 = "&";
var aring$1 = "\xe5";
var atilde$1 = "\xe3";
var auml$1 = "\xe4";
var brvbar$1 = "\xa6";
var ccedil$1 = "\xe7";
var cedil$1 = "\xb8";
var cent$1 = "\xa2";
var copy$1 = "\xa9";
var curren$1 = "\xa4";
var deg$1 = "\xb0";
var divide$1 = "\xf7";
var eacute$1 = "\xe9";
var ecirc$1 = "\xea";
var egrave$1 = "\xe8";
var eth$1 = "\xf0";
var euml$1 = "\xeb";
var frac12$1 = "\xbd";
var frac14$1 = "\xbc";
var frac34$1 = "\xbe";
var gt$1 = ">";
var iacute$1 = "\xed";
var icirc$1 = "\xee";
var iexcl$1 = "\xa1";
var igrave$1 = "\xec";
var iquest$1 = "\xbf";
var iuml$1 = "\xef";
var laquo$1 = "\xab";
var lt$1 = "<";
var macr$1 = "\xaf";
var micro$1 = "\xb5";
var middot$1 = "\xb7";
var nbsp$1 = "\xa0";
var not$1 = "\xac";
var ntilde$1 = "\xf1";
var oacute$1 = "\xf3";
var ocirc$1 = "\xf4";
var ograve$1 = "\xf2";
var ordf$1 = "\xaa";
var ordm$1 = "\xba";
var oslash$1 = "\xf8";
var otilde$1 = "\xf5";
var ouml$1 = "\xf6";
var para$1 = "\xb6";
var plusmn$1 = "\xb1";
var pound$1 = "\xa3";
var quot$1 = "\"";
var raquo$1 = "\xbb";
var reg$1 = "\xae";
var sect$1 = "\xa7";
var shy$1 = "\xad";
var sup1$1 = "\xb9";
var sup2$1 = "\xb2";
var sup3$1 = "\xb3";
var szlig$1 = "\xdf";
var thorn$1 = "\xfe";
var times$1 = "\xd7";
var uacute$1 = "\xfa";
var ucirc$1 = "\xfb";
var ugrave$1 = "\xf9";
var uml$1 = "\xa8";
var uuml$1 = "\xfc";
var yacute$1 = "\xfd";
var yen$1 = "\xa5";
var yuml$1 = "\xff";
var index$2 = {
    AElig: AElig$1,
    AMP: AMP$1,
    Aacute: Aacute$1,
    Acirc: Acirc$1,
    Agrave: Agrave$1,
    Aring: Aring$1,
    Atilde: Atilde$1,
    Auml: Auml$1,
    COPY: COPY$1,
    Ccedil: Ccedil$1,
    ETH: ETH$1,
    Eacute: Eacute$1,
    Ecirc: Ecirc$1,
    Egrave: Egrave$1,
    Euml: Euml$1,
    GT: GT$1,
    Iacute: Iacute$1,
    Icirc: Icirc$1,
    Igrave: Igrave$1,
    Iuml: Iuml$1,
    LT: LT$1,
    Ntilde: Ntilde$1,
    Oacute: Oacute$1,
    Ocirc: Ocirc$1,
    Ograve: Ograve$1,
    Oslash: Oslash$1,
    Otilde: Otilde$1,
    Ouml: Ouml$1,
    QUOT: QUOT$1,
    REG: REG$1,
    THORN: THORN$1,
    Uacute: Uacute$1,
    Ucirc: Ucirc$1,
    Ugrave: Ugrave$1,
    Uuml: Uuml$1,
    Yacute: Yacute$1,
    aacute: aacute$1,
    acirc: acirc$1,
    acute: acute$1,
    aelig: aelig$1,
    agrave: agrave$1,
    amp: amp$1,
    aring: aring$1,
    atilde: atilde$1,
    auml: auml$1,
    brvbar: brvbar$1,
    ccedil: ccedil$1,
    cedil: cedil$1,
    cent: cent$1,
    copy: copy$1,
    curren: curren$1,
    deg: deg$1,
    divide: divide$1,
    eacute: eacute$1,
    ecirc: ecirc$1,
    egrave: egrave$1,
    eth: eth$1,
    euml: euml$1,
    frac12: frac12$1,
    frac14: frac14$1,
    frac34: frac34$1,
    gt: gt$1,
    iacute: iacute$1,
    icirc: icirc$1,
    iexcl: iexcl$1,
    igrave: igrave$1,
    iquest: iquest$1,
    iuml: iuml$1,
    laquo: laquo$1,
    lt: lt$1,
    macr: macr$1,
    micro: micro$1,
    middot: middot$1,
    nbsp: nbsp$1,
    not: not$1,
    ntilde: ntilde$1,
    oacute: oacute$1,
    ocirc: ocirc$1,
    ograve: ograve$1,
    ordf: ordf$1,
    ordm: ordm$1,
    oslash: oslash$1,
    otilde: otilde$1,
    ouml: ouml$1,
    para: para$1,
    plusmn: plusmn$1,
    pound: pound$1,
    quot: quot$1,
    raquo: raquo$1,
    reg: reg$1,
    sect: sect$1,
    shy: shy$1,
    sup1: sup1$1,
    sup2: sup2$1,
    sup3: sup3$1,
    szlig: szlig$1,
    thorn: thorn$1,
    times: times$1,
    uacute: uacute$1,
    ucirc: ucirc$1,
    ugrave: ugrave$1,
    uml: uml$1,
    uuml: uuml$1,
    yacute: yacute$1,
    yen: yen$1,
    yuml: yuml$1
};
var characterEntitiesLegacy = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    AElig: AElig$1,
    AMP: AMP$1,
    Aacute: Aacute$1,
    Acirc: Acirc$1,
    Agrave: Agrave$1,
    Aring: Aring$1,
    Atilde: Atilde$1,
    Auml: Auml$1,
    COPY: COPY$1,
    Ccedil: Ccedil$1,
    ETH: ETH$1,
    Eacute: Eacute$1,
    Ecirc: Ecirc$1,
    Egrave: Egrave$1,
    Euml: Euml$1,
    GT: GT$1,
    Iacute: Iacute$1,
    Icirc: Icirc$1,
    Igrave: Igrave$1,
    Iuml: Iuml$1,
    LT: LT$1,
    Ntilde: Ntilde$1,
    Oacute: Oacute$1,
    Ocirc: Ocirc$1,
    Ograve: Ograve$1,
    Oslash: Oslash$1,
    Otilde: Otilde$1,
    Ouml: Ouml$1,
    QUOT: QUOT$1,
    REG: REG$1,
    THORN: THORN$1,
    Uacute: Uacute$1,
    Ucirc: Ucirc$1,
    Ugrave: Ugrave$1,
    Uuml: Uuml$1,
    Yacute: Yacute$1,
    aacute: aacute$1,
    acirc: acirc$1,
    acute: acute$1,
    aelig: aelig$1,
    agrave: agrave$1,
    amp: amp$1,
    aring: aring$1,
    atilde: atilde$1,
    auml: auml$1,
    brvbar: brvbar$1,
    ccedil: ccedil$1,
    cedil: cedil$1,
    cent: cent$1,
    copy: copy$1,
    curren: curren$1,
    deg: deg$1,
    divide: divide$1,
    eacute: eacute$1,
    ecirc: ecirc$1,
    egrave: egrave$1,
    eth: eth$1,
    euml: euml$1,
    frac12: frac12$1,
    frac14: frac14$1,
    frac34: frac34$1,
    gt: gt$1,
    iacute: iacute$1,
    icirc: icirc$1,
    iexcl: iexcl$1,
    igrave: igrave$1,
    iquest: iquest$1,
    iuml: iuml$1,
    laquo: laquo$1,
    lt: lt$1,
    macr: macr$1,
    micro: micro$1,
    middot: middot$1,
    nbsp: nbsp$1,
    not: not$1,
    ntilde: ntilde$1,
    oacute: oacute$1,
    ocirc: ocirc$1,
    ograve: ograve$1,
    ordf: ordf$1,
    ordm: ordm$1,
    oslash: oslash$1,
    otilde: otilde$1,
    ouml: ouml$1,
    para: para$1,
    plusmn: plusmn$1,
    pound: pound$1,
    quot: quot$1,
    raquo: raquo$1,
    reg: reg$1,
    sect: sect$1,
    shy: shy$1,
    sup1: sup1$1,
    sup2: sup2$1,
    sup3: sup3$1,
    szlig: szlig$1,
    thorn: thorn$1,
    times: times$1,
    uacute: uacute$1,
    ucirc: ucirc$1,
    ugrave: ugrave$1,
    uml: uml$1,
    uuml: uuml$1,
    yacute: yacute$1,
    yen: yen$1,
    yuml: yuml$1,
    'default': index$2
});
var index$1 = {
    "0": "\uFFFD",
    "128": "\u20AC",
    "130": "\u201A",
    "131": "\u0192",
    "132": "\u201E",
    "133": "\u2026",
    "134": "\u2020",
    "135": "\u2021",
    "136": "\u02C6",
    "137": "\u2030",
    "138": "\u0160",
    "139": "\u2039",
    "140": "\u0152",
    "142": "\u017D",
    "145": "\u2018",
    "146": "\u2019",
    "147": "\u201C",
    "148": "\u201D",
    "149": "\u2022",
    "150": "\u2013",
    "151": "\u2014",
    "152": "\u02DC",
    "153": "\u2122",
    "154": "\u0161",
    "155": "\u203A",
    "156": "\u0153",
    "158": "\u017E",
    "159": "\u0178"
};
var characterReferenceInvalid = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    'default': index$1
});
var isDecimal = decimal;
// Check if the given character code, or the character code at the first
// character, is decimal.
function decimal(character) {
    var code = typeof character === 'string' ? character.charCodeAt(0) : character;
    return code >= 48 && code <= 57 /* 0-9 */ ;
}
var isHexadecimal = hexadecimal;
// Check if the given character code, or the character code at the first
// character, is hexadecimal.
function hexadecimal(character) {
    var code = typeof character === 'string' ? character.charCodeAt(0) : character;
    return code >= 97 /* a */  && code <= 102 || code >= 65 /* A */  && code <= 70 || code >= 48 /* A */  && code <= 57;
}
var isAlphabetical = alphabetical;
// Check if the given character code, or the character code at the first
// character, is alphabetical.
function alphabetical(character) {
    var code = typeof character === 'string' ? character.charCodeAt(0) : character;
    return code >= 97 && code <= 122 || code >= 65 && code <= 90;
}
var isAlphanumerical = alphanumerical;
// Check if the given character code, or the character code at the first
// character, is alphanumerical.
function alphanumerical(character) {
    return isAlphabetical(character) || isDecimal(character);
}
var AEli = "\xc6";
var AElig = "\xc6";
var AM = "&";
var AMP = "&";
var Aacut = "\xc1";
var Aacute = "\xc1";
var Abreve = "\u0102";
var Acir = "\xc2";
var Acirc = "\xc2";
var Acy = "\u0410";
var Afr = "\uD835\uDD04";
var Agrav = "\xc0";
var Agrave = "\xc0";
var Alpha = "\u0391";
var Amacr = "\u0100";
var And = "\u2A53";
var Aogon = "\u0104";
var Aopf = "\uD835\uDD38";
var ApplyFunction = "\u2061";
var Arin = "\xc5";
var Aring = "\xc5";
var Ascr = "\uD835\uDC9C";
var Assign = "\u2254";
var Atild = "\xc3";
var Atilde = "\xc3";
var Aum = "\xc4";
var Auml = "\xc4";
var Backslash = "\u2216";
var Barv = "\u2AE7";
var Barwed = "\u2306";
var Bcy = "\u0411";
var Because = "\u2235";
var Bernoullis = "\u212C";
var Beta = "\u0392";
var Bfr = "\uD835\uDD05";
var Bopf = "\uD835\uDD39";
var Breve = "\u02D8";
var Bscr = "\u212C";
var Bumpeq = "\u224E";
var CHcy = "\u0427";
var COP = "\xa9";
var COPY = "\xa9";
var Cacute = "\u0106";
var Cap = "\u22D2";
var CapitalDifferentialD = "\u2145";
var Cayleys = "\u212D";
var Ccaron = "\u010C";
var Ccedi = "\xc7";
var Ccedil = "\xc7";
var Ccirc = "\u0108";
var Cconint = "\u2230";
var Cdot = "\u010A";
var Cedilla = "\xb8";
var CenterDot = "\xb7";
var Cfr = "\u212D";
var Chi = "\u03A7";
var CircleDot = "\u2299";
var CircleMinus = "\u2296";
var CirclePlus = "\u2295";
var CircleTimes = "\u2297";
var ClockwiseContourIntegral = "\u2232";
var CloseCurlyDoubleQuote = "\u201D";
var CloseCurlyQuote = "\u2019";
var Colon = "\u2237";
var Colone = "\u2A74";
var Congruent = "\u2261";
var Conint = "\u222F";
var ContourIntegral = "\u222E";
var Copf = "\u2102";
var Coproduct = "\u2210";
var CounterClockwiseContourIntegral = "\u2233";
var Cross = "\u2A2F";
var Cscr = "\uD835\uDC9E";
var Cup = "\u22D3";
var CupCap = "\u224D";
var DD = "\u2145";
var DDotrahd = "\u2911";
var DJcy = "\u0402";
var DScy = "\u0405";
var DZcy = "\u040F";
var Dagger = "\u2021";
var Darr = "\u21A1";
var Dashv = "\u2AE4";
var Dcaron = "\u010E";
var Dcy = "\u0414";
var Del = "\u2207";
var Delta = "\u0394";
var Dfr = "\uD835\uDD07";
var DiacriticalAcute = "\xb4";
var DiacriticalDot = "\u02D9";
var DiacriticalDoubleAcute = "\u02DD";
var DiacriticalGrave = "`";
var DiacriticalTilde = "\u02DC";
var Diamond = "\u22C4";
var DifferentialD = "\u2146";
var Dopf = "\uD835\uDD3B";
var Dot = "\xa8";
var DotDot = "\u20DC";
var DotEqual = "\u2250";
var DoubleContourIntegral = "\u222F";
var DoubleDot = "\xa8";
var DoubleDownArrow = "\u21D3";
var DoubleLeftArrow = "\u21D0";
var DoubleLeftRightArrow = "\u21D4";
var DoubleLeftTee = "\u2AE4";
var DoubleLongLeftArrow = "\u27F8";
var DoubleLongLeftRightArrow = "\u27FA";
var DoubleLongRightArrow = "\u27F9";
var DoubleRightArrow = "\u21D2";
var DoubleRightTee = "\u22A8";
var DoubleUpArrow = "\u21D1";
var DoubleUpDownArrow = "\u21D5";
var DoubleVerticalBar = "\u2225";
var DownArrow = "\u2193";
var DownArrowBar = "\u2913";
var DownArrowUpArrow = "\u21F5";
var DownBreve = "\u0311";
var DownLeftRightVector = "\u2950";
var DownLeftTeeVector = "\u295E";
var DownLeftVector = "\u21BD";
var DownLeftVectorBar = "\u2956";
var DownRightTeeVector = "\u295F";
var DownRightVector = "\u21C1";
var DownRightVectorBar = "\u2957";
var DownTee = "\u22A4";
var DownTeeArrow = "\u21A7";
var Downarrow = "\u21D3";
var Dscr = "\uD835\uDC9F";
var Dstrok = "\u0110";
var ENG = "\u014A";
var ET = "\xd0";
var ETH = "\xd0";
var Eacut = "\xc9";
var Eacute = "\xc9";
var Ecaron = "\u011A";
var Ecir = "\xca";
var Ecirc = "\xca";
var Ecy = "\u042D";
var Edot = "\u0116";
var Efr = "\uD835\uDD08";
var Egrav = "\xc8";
var Egrave = "\xc8";
var Element$2 = "\u2208";
var Emacr = "\u0112";
var EmptySmallSquare = "\u25FB";
var EmptyVerySmallSquare = "\u25AB";
var Eogon = "\u0118";
var Eopf = "\uD835\uDD3C";
var Epsilon = "\u0395";
var Equal = "\u2A75";
var EqualTilde = "\u2242";
var Equilibrium = "\u21CC";
var Escr = "\u2130";
var Esim = "\u2A73";
var Eta = "\u0397";
var Eum = "\xcb";
var Euml = "\xcb";
var Exists = "\u2203";
var ExponentialE = "\u2147";
var Fcy = "\u0424";
var Ffr = "\uD835\uDD09";
var FilledSmallSquare = "\u25FC";
var FilledVerySmallSquare = "\u25AA";
var Fopf = "\uD835\uDD3D";
var ForAll = "\u2200";
var Fouriertrf = "\u2131";
var Fscr = "\u2131";
var GJcy = "\u0403";
var G$1 = ">";
var GT = ">";
var Gamma = "\u0393";
var Gammad = "\u03DC";
var Gbreve = "\u011E";
var Gcedil = "\u0122";
var Gcirc = "\u011C";
var Gcy = "\u0413";
var Gdot = "\u0120";
var Gfr = "\uD835\uDD0A";
var Gg = "\u22D9";
var Gopf = "\uD835\uDD3E";
var GreaterEqual = "\u2265";
var GreaterEqualLess = "\u22DB";
var GreaterFullEqual = "\u2267";
var GreaterGreater = "\u2AA2";
var GreaterLess = "\u2277";
var GreaterSlantEqual = "\u2A7E";
var GreaterTilde = "\u2273";
var Gscr = "\uD835\uDCA2";
var Gt = "\u226B";
var HARDcy = "\u042A";
var Hacek = "\u02C7";
var Hat = "^";
var Hcirc = "\u0124";
var Hfr = "\u210C";
var HilbertSpace = "\u210B";
var Hopf = "\u210D";
var HorizontalLine = "\u2500";
var Hscr = "\u210B";
var Hstrok = "\u0126";
var HumpDownHump = "\u224E";
var HumpEqual = "\u224F";
var IEcy = "\u0415";
var IJlig = "\u0132";
var IOcy = "\u0401";
var Iacut = "\xcd";
var Iacute = "\xcd";
var Icir = "\xce";
var Icirc = "\xce";
var Icy = "\u0418";
var Idot = "\u0130";
var Ifr = "\u2111";
var Igrav = "\xcc";
var Igrave = "\xcc";
var Im = "\u2111";
var Imacr = "\u012A";
var ImaginaryI = "\u2148";
var Implies = "\u21D2";
var Int = "\u222C";
var Integral = "\u222B";
var Intersection = "\u22C2";
var InvisibleComma = "\u2063";
var InvisibleTimes = "\u2062";
var Iogon = "\u012E";
var Iopf = "\uD835\uDD40";
var Iota = "\u0399";
var Iscr = "\u2110";
var Itilde = "\u0128";
var Iukcy = "\u0406";
var Ium = "\xcf";
var Iuml = "\xcf";
var Jcirc = "\u0134";
var Jcy = "\u0419";
var Jfr = "\uD835\uDD0D";
var Jopf = "\uD835\uDD41";
var Jscr = "\uD835\uDCA5";
var Jsercy = "\u0408";
var Jukcy = "\u0404";
var KHcy = "\u0425";
var KJcy = "\u040C";
var Kappa = "\u039A";
var Kcedil = "\u0136";
var Kcy = "\u041A";
var Kfr = "\uD835\uDD0E";
var Kopf = "\uD835\uDD42";
var Kscr = "\uD835\uDCA6";
var LJcy = "\u0409";
var L = "<";
var LT = "<";
var Lacute = "\u0139";
var Lambda = "\u039B";
var Lang = "\u27EA";
var Laplacetrf = "\u2112";
var Larr = "\u219E";
var Lcaron = "\u013D";
var Lcedil = "\u013B";
var Lcy = "\u041B";
var LeftAngleBracket = "\u27E8";
var LeftArrow = "\u2190";
var LeftArrowBar = "\u21E4";
var LeftArrowRightArrow = "\u21C6";
var LeftCeiling = "\u2308";
var LeftDoubleBracket = "\u27E6";
var LeftDownTeeVector = "\u2961";
var LeftDownVector = "\u21C3";
var LeftDownVectorBar = "\u2959";
var LeftFloor = "\u230A";
var LeftRightArrow = "\u2194";
var LeftRightVector = "\u294E";
var LeftTee = "\u22A3";
var LeftTeeArrow = "\u21A4";
var LeftTeeVector = "\u295A";
var LeftTriangle = "\u22B2";
var LeftTriangleBar = "\u29CF";
var LeftTriangleEqual = "\u22B4";
var LeftUpDownVector = "\u2951";
var LeftUpTeeVector = "\u2960";
var LeftUpVector = "\u21BF";
var LeftUpVectorBar = "\u2958";
var LeftVector = "\u21BC";
var LeftVectorBar = "\u2952";
var Leftarrow = "\u21D0";
var Leftrightarrow = "\u21D4";
var LessEqualGreater = "\u22DA";
var LessFullEqual = "\u2266";
var LessGreater = "\u2276";
var LessLess = "\u2AA1";
var LessSlantEqual = "\u2A7D";
var LessTilde = "\u2272";
var Lfr = "\uD835\uDD0F";
var Ll = "\u22D8";
var Lleftarrow = "\u21DA";
var Lmidot = "\u013F";
var LongLeftArrow = "\u27F5";
var LongLeftRightArrow = "\u27F7";
var LongRightArrow = "\u27F6";
var Longleftarrow = "\u27F8";
var Longleftrightarrow = "\u27FA";
var Longrightarrow = "\u27F9";
var Lopf = "\uD835\uDD43";
var LowerLeftArrow = "\u2199";
var LowerRightArrow = "\u2198";
var Lscr = "\u2112";
var Lsh = "\u21B0";
var Lstrok = "\u0141";
var Lt = "\u226A";
var Mcy = "\u041C";
var MediumSpace = "\u205F";
var Mellintrf = "\u2133";
var Mfr = "\uD835\uDD10";
var MinusPlus = "\u2213";
var Mopf = "\uD835\uDD44";
var Mscr = "\u2133";
var Mu = "\u039C";
var NJcy = "\u040A";
var Nacute = "\u0143";
var Ncaron = "\u0147";
var Ncedil = "\u0145";
var Ncy = "\u041D";
var NegativeMediumSpace = "\u200B";
var NegativeThickSpace = "\u200B";
var NegativeThinSpace = "\u200B";
var NegativeVeryThinSpace = "\u200B";
var NestedGreaterGreater = "\u226B";
var NestedLessLess = "\u226A";
var NewLine = "\n";
var Nfr = "\uD835\uDD11";
var NoBreak = "\u2060";
var NonBreakingSpace = "\xa0";
var Nopf = "\u2115";
var Not = "\u2AEC";
var NotCongruent = "\u2262";
var NotCupCap = "\u226D";
var NotDoubleVerticalBar = "\u2226";
var NotElement = "\u2209";
var NotEqual = "\u2260";
var NotEqualTilde = "\u2242\u0338";
var NotExists = "\u2204";
var NotGreater = "\u226F";
var NotGreaterEqual = "\u2271";
var NotGreaterFullEqual = "\u2267\u0338";
var NotGreaterGreater = "\u226B\u0338";
var NotGreaterLess = "\u2279";
var NotGreaterSlantEqual = "\u2A7E\u0338";
var NotGreaterTilde = "\u2275";
var NotHumpDownHump = "\u224E\u0338";
var NotHumpEqual = "\u224F\u0338";
var NotLeftTriangle = "\u22EA";
var NotLeftTriangleBar = "\u29CF\u0338";
var NotLeftTriangleEqual = "\u22EC";
var NotLess = "\u226E";
var NotLessEqual = "\u2270";
var NotLessGreater = "\u2278";
var NotLessLess = "\u226A\u0338";
var NotLessSlantEqual = "\u2A7D\u0338";
var NotLessTilde = "\u2274";
var NotNestedGreaterGreater = "\u2AA2\u0338";
var NotNestedLessLess = "\u2AA1\u0338";
var NotPrecedes = "\u2280";
var NotPrecedesEqual = "\u2AAF\u0338";
var NotPrecedesSlantEqual = "\u22E0";
var NotReverseElement = "\u220C";
var NotRightTriangle = "\u22EB";
var NotRightTriangleBar = "\u29D0\u0338";
var NotRightTriangleEqual = "\u22ED";
var NotSquareSubset = "\u228F\u0338";
var NotSquareSubsetEqual = "\u22E2";
var NotSquareSuperset = "\u2290\u0338";
var NotSquareSupersetEqual = "\u22E3";
var NotSubset = "\u2282\u20D2";
var NotSubsetEqual = "\u2288";
var NotSucceeds = "\u2281";
var NotSucceedsEqual = "\u2AB0\u0338";
var NotSucceedsSlantEqual = "\u22E1";
var NotSucceedsTilde = "\u227F\u0338";
var NotSuperset = "\u2283\u20D2";
var NotSupersetEqual = "\u2289";
var NotTilde = "\u2241";
var NotTildeEqual = "\u2244";
var NotTildeFullEqual = "\u2247";
var NotTildeTilde = "\u2249";
var NotVerticalBar = "\u2224";
var Nscr = "\uD835\uDCA9";
var Ntild = "\xd1";
var Ntilde = "\xd1";
var Nu = "\u039D";
var OElig = "\u0152";
var Oacut = "\xd3";
var Oacute = "\xd3";
var Ocir = "\xd4";
var Ocirc = "\xd4";
var Ocy = "\u041E";
var Odblac = "\u0150";
var Ofr = "\uD835\uDD12";
var Ograv = "\xd2";
var Ograve = "\xd2";
var Omacr = "\u014C";
var Omega = "\u03A9";
var Omicron = "\u039F";
var Oopf = "\uD835\uDD46";
var OpenCurlyDoubleQuote = "\u201C";
var OpenCurlyQuote = "\u2018";
var Or = "\u2A54";
var Oscr = "\uD835\uDCAA";
var Oslas = "\xd8";
var Oslash = "\xd8";
var Otild = "\xd5";
var Otilde = "\xd5";
var Otimes = "\u2A37";
var Oum = "\xd6";
var Ouml = "\xd6";
var OverBar = "\u203E";
var OverBrace = "\u23DE";
var OverBracket = "\u23B4";
var OverParenthesis = "\u23DC";
var PartialD = "\u2202";
var Pcy = "\u041F";
var Pfr = "\uD835\uDD13";
var Phi = "\u03A6";
var Pi = "\u03A0";
var PlusMinus = "\xb1";
var Poincareplane = "\u210C";
var Popf = "\u2119";
var Pr = "\u2ABB";
var Precedes = "\u227A";
var PrecedesEqual = "\u2AAF";
var PrecedesSlantEqual = "\u227C";
var PrecedesTilde = "\u227E";
var Prime = "\u2033";
var Product = "\u220F";
var Proportion = "\u2237";
var Proportional = "\u221D";
var Pscr = "\uD835\uDCAB";
var Psi = "\u03A8";
var QUO = "\"";
var QUOT = "\"";
var Qfr = "\uD835\uDD14";
var Qopf = "\u211A";
var Qscr = "\uD835\uDCAC";
var RBarr = "\u2910";
var RE = "\xae";
var REG = "\xae";
var Racute = "\u0154";
var Rang = "\u27EB";
var Rarr = "\u21A0";
var Rarrtl = "\u2916";
var Rcaron = "\u0158";
var Rcedil = "\u0156";
var Rcy = "\u0420";
var Re = "\u211C";
var ReverseElement = "\u220B";
var ReverseEquilibrium = "\u21CB";
var ReverseUpEquilibrium = "\u296F";
var Rfr = "\u211C";
var Rho = "\u03A1";
var RightAngleBracket = "\u27E9";
var RightArrow = "\u2192";
var RightArrowBar = "\u21E5";
var RightArrowLeftArrow = "\u21C4";
var RightCeiling = "\u2309";
var RightDoubleBracket = "\u27E7";
var RightDownTeeVector = "\u295D";
var RightDownVector = "\u21C2";
var RightDownVectorBar = "\u2955";
var RightFloor = "\u230B";
var RightTee = "\u22A2";
var RightTeeArrow = "\u21A6";
var RightTeeVector = "\u295B";
var RightTriangle = "\u22B3";
var RightTriangleBar = "\u29D0";
var RightTriangleEqual = "\u22B5";
var RightUpDownVector = "\u294F";
var RightUpTeeVector = "\u295C";
var RightUpVector = "\u21BE";
var RightUpVectorBar = "\u2954";
var RightVector = "\u21C0";
var RightVectorBar = "\u2953";
var Rightarrow = "\u21D2";
var Ropf = "\u211D";
var RoundImplies = "\u2970";
var Rrightarrow = "\u21DB";
var Rscr = "\u211B";
var Rsh = "\u21B1";
var RuleDelayed = "\u29F4";
var SHCHcy = "\u0429";
var SHcy = "\u0428";
var SOFTcy = "\u042C";
var Sacute = "\u015A";
var Sc = "\u2ABC";
var Scaron = "\u0160";
var Scedil = "\u015E";
var Scirc = "\u015C";
var Scy = "\u0421";
var Sfr = "\uD835\uDD16";
var ShortDownArrow = "\u2193";
var ShortLeftArrow = "\u2190";
var ShortRightArrow = "\u2192";
var ShortUpArrow = "\u2191";
var Sigma = "\u03A3";
var SmallCircle = "\u2218";
var Sopf = "\uD835\uDD4A";
var Sqrt = "\u221A";
var Square = "\u25A1";
var SquareIntersection = "\u2293";
var SquareSubset = "\u228F";
var SquareSubsetEqual = "\u2291";
var SquareSuperset = "\u2290";
var SquareSupersetEqual = "\u2292";
var SquareUnion = "\u2294";
var Sscr = "\uD835\uDCAE";
var Star = "\u22C6";
var Sub = "\u22D0";
var Subset = "\u22D0";
var SubsetEqual = "\u2286";
var Succeeds = "\u227B";
var SucceedsEqual = "\u2AB0";
var SucceedsSlantEqual = "\u227D";
var SucceedsTilde = "\u227F";
var SuchThat = "\u220B";
var Sum = "\u2211";
var Sup = "\u22D1";
var Superset = "\u2283";
var SupersetEqual = "\u2287";
var Supset = "\u22D1";
var THOR = "\xde";
var THORN = "\xde";
var TRADE = "\u2122";
var TSHcy = "\u040B";
var TScy = "\u0426";
var Tab = "\t";
var Tau = "\u03A4";
var Tcaron = "\u0164";
var Tcedil = "\u0162";
var Tcy = "\u0422";
var Tfr = "\uD835\uDD17";
var Therefore = "\u2234";
var Theta = "\u0398";
var ThickSpace = "\u205F\u200A";
var ThinSpace = "\u2009";
var Tilde = "\u223C";
var TildeEqual = "\u2243";
var TildeFullEqual = "\u2245";
var TildeTilde = "\u2248";
var Topf = "\uD835\uDD4B";
var TripleDot = "\u20DB";
var Tscr = "\uD835\uDCAF";
var Tstrok = "\u0166";
var Uacut = "\xda";
var Uacute = "\xda";
var Uarr = "\u219F";
var Uarrocir = "\u2949";
var Ubrcy = "\u040E";
var Ubreve = "\u016C";
var Ucir = "\xdb";
var Ucirc = "\xdb";
var Ucy = "\u0423";
var Udblac = "\u0170";
var Ufr = "\uD835\uDD18";
var Ugrav = "\xd9";
var Ugrave = "\xd9";
var Umacr = "\u016A";
var UnderBar = "_";
var UnderBrace = "\u23DF";
var UnderBracket = "\u23B5";
var UnderParenthesis = "\u23DD";
var Union = "\u22C3";
var UnionPlus = "\u228E";
var Uogon = "\u0172";
var Uopf = "\uD835\uDD4C";
var UpArrow = "\u2191";
var UpArrowBar = "\u2912";
var UpArrowDownArrow = "\u21C5";
var UpDownArrow = "\u2195";
var UpEquilibrium = "\u296E";
var UpTee = "\u22A5";
var UpTeeArrow = "\u21A5";
var Uparrow = "\u21D1";
var Updownarrow = "\u21D5";
var UpperLeftArrow = "\u2196";
var UpperRightArrow = "\u2197";
var Upsi = "\u03D2";
var Upsilon = "\u03A5";
var Uring = "\u016E";
var Uscr = "\uD835\uDCB0";
var Utilde = "\u0168";
var Uum = "\xdc";
var Uuml = "\xdc";
var VDash = "\u22AB";
var Vbar = "\u2AEB";
var Vcy = "\u0412";
var Vdash = "\u22A9";
var Vdashl = "\u2AE6";
var Vee = "\u22C1";
var Verbar = "\u2016";
var Vert = "\u2016";
var VerticalBar = "\u2223";
var VerticalLine = "|";
var VerticalSeparator = "\u2758";
var VerticalTilde = "\u2240";
var VeryThinSpace = "\u200A";
var Vfr = "\uD835\uDD19";
var Vopf = "\uD835\uDD4D";
var Vscr = "\uD835\uDCB1";
var Vvdash = "\u22AA";
var Wcirc = "\u0174";
var Wedge = "\u22C0";
var Wfr = "\uD835\uDD1A";
var Wopf = "\uD835\uDD4E";
var Wscr = "\uD835\uDCB2";
var Xfr = "\uD835\uDD1B";
var Xi = "\u039E";
var Xopf = "\uD835\uDD4F";
var Xscr = "\uD835\uDCB3";
var YAcy = "\u042F";
var YIcy = "\u0407";
var YUcy = "\u042E";
var Yacut = "\xdd";
var Yacute = "\xdd";
var Ycirc = "\u0176";
var Ycy = "\u042B";
var Yfr = "\uD835\uDD1C";
var Yopf = "\uD835\uDD50";
var Yscr = "\uD835\uDCB4";
var Yuml = "\u0178";
var ZHcy = "\u0416";
var Zacute = "\u0179";
var Zcaron = "\u017D";
var Zcy = "\u0417";
var Zdot = "\u017B";
var ZeroWidthSpace = "\u200B";
var Zeta = "\u0396";
var Zfr = "\u2128";
var Zopf = "\u2124";
var Zscr = "\uD835\uDCB5";
var aacut = "\xe1";
var aacute = "\xe1";
var abreve = "\u0103";
var ac = "\u223E";
var acE = "\u223E\u0333";
var acd = "\u223F";
var acir = "\xe2";
var acirc = "\xe2";
var acut = "\xb4";
var acute = "\xb4";
var acy = "\u0430";
var aeli = "\xe6";
var aelig = "\xe6";
var af = "\u2061";
var afr = "\uD835\uDD1E";
var agrav = "\xe0";
var agrave = "\xe0";
var alefsym = "\u2135";
var aleph = "\u2135";
var alpha = "\u03B1";
var amacr = "\u0101";
var amalg = "\u2A3F";
var am = "&";
var amp = "&";
var and = "\u2227";
var andand = "\u2A55";
var andd = "\u2A5C";
var andslope = "\u2A58";
var andv = "\u2A5A";
var ang = "\u2220";
var ange = "\u29A4";
var angle = "\u2220";
var angmsd = "\u2221";
var angmsdaa = "\u29A8";
var angmsdab = "\u29A9";
var angmsdac = "\u29AA";
var angmsdad = "\u29AB";
var angmsdae = "\u29AC";
var angmsdaf = "\u29AD";
var angmsdag = "\u29AE";
var angmsdah = "\u29AF";
var angrt = "\u221F";
var angrtvb = "\u22BE";
var angrtvbd = "\u299D";
var angsph = "\u2222";
var angst = "\xc5";
var angzarr = "\u237C";
var aogon = "\u0105";
var aopf = "\uD835\uDD52";
var ap = "\u2248";
var apE = "\u2A70";
var apacir = "\u2A6F";
var ape = "\u224A";
var apid = "\u224B";
var apos = "'";
var approx = "\u2248";
var approxeq = "\u224A";
var arin = "\xe5";
var aring = "\xe5";
var ascr = "\uD835\uDCB6";
var ast = "*";
var asymp = "\u2248";
var asympeq = "\u224D";
var atild = "\xe3";
var atilde = "\xe3";
var aum = "\xe4";
var auml = "\xe4";
var awconint = "\u2233";
var awint = "\u2A11";
var bNot = "\u2AED";
var backcong = "\u224C";
var backepsilon = "\u03F6";
var backprime = "\u2035";
var backsim = "\u223D";
var backsimeq = "\u22CD";
var barvee = "\u22BD";
var barwed = "\u2305";
var barwedge = "\u2305";
var bbrk = "\u23B5";
var bbrktbrk = "\u23B6";
var bcong = "\u224C";
var bcy = "\u0431";
var bdquo = "\u201E";
var becaus = "\u2235";
var because = "\u2235";
var bemptyv = "\u29B0";
var bepsi = "\u03F6";
var bernou = "\u212C";
var beta = "\u03B2";
var beth = "\u2136";
var between = "\u226C";
var bfr = "\uD835\uDD1F";
var bigcap = "\u22C2";
var bigcirc = "\u25EF";
var bigcup = "\u22C3";
var bigodot = "\u2A00";
var bigoplus = "\u2A01";
var bigotimes = "\u2A02";
var bigsqcup = "\u2A06";
var bigstar = "\u2605";
var bigtriangledown = "\u25BD";
var bigtriangleup = "\u25B3";
var biguplus = "\u2A04";
var bigvee = "\u22C1";
var bigwedge = "\u22C0";
var bkarow = "\u290D";
var blacklozenge = "\u29EB";
var blacksquare = "\u25AA";
var blacktriangle = "\u25B4";
var blacktriangledown = "\u25BE";
var blacktriangleleft = "\u25C2";
var blacktriangleright = "\u25B8";
var blank = "\u2423";
var blk12 = "\u2592";
var blk14 = "\u2591";
var blk34 = "\u2593";
var block = "\u2588";
var bne = "=\u20E5";
var bnequiv = "\u2261\u20E5";
var bnot = "\u2310";
var bopf = "\uD835\uDD53";
var bot = "\u22A5";
var bottom = "\u22A5";
var bowtie = "\u22C8";
var boxDL = "\u2557";
var boxDR = "\u2554";
var boxDl = "\u2556";
var boxDr = "\u2553";
var boxH = "\u2550";
var boxHD = "\u2566";
var boxHU = "\u2569";
var boxHd = "\u2564";
var boxHu = "\u2567";
var boxUL = "\u255D";
var boxUR = "\u255A";
var boxUl = "\u255C";
var boxUr = "\u2559";
var boxV = "\u2551";
var boxVH = "\u256C";
var boxVL = "\u2563";
var boxVR = "\u2560";
var boxVh = "\u256B";
var boxVl = "\u2562";
var boxVr = "\u255F";
var boxbox = "\u29C9";
var boxdL = "\u2555";
var boxdR = "\u2552";
var boxdl = "\u2510";
var boxdr = "\u250C";
var boxh = "\u2500";
var boxhD = "\u2565";
var boxhU = "\u2568";
var boxhd = "\u252C";
var boxhu = "\u2534";
var boxminus = "\u229F";
var boxplus = "\u229E";
var boxtimes = "\u22A0";
var boxuL = "\u255B";
var boxuR = "\u2558";
var boxul = "\u2518";
var boxur = "\u2514";
var boxv = "\u2502";
var boxvH = "\u256A";
var boxvL = "\u2561";
var boxvR = "\u255E";
var boxvh = "\u253C";
var boxvl = "\u2524";
var boxvr = "\u251C";
var bprime = "\u2035";
var breve = "\u02D8";
var brvba = "\xa6";
var brvbar = "\xa6";
var bscr = "\uD835\uDCB7";
var bsemi = "\u204F";
var bsim = "\u223D";
var bsime = "\u22CD";
var bsol = "\\";
var bsolb = "\u29C5";
var bsolhsub = "\u27C8";
var bull = "\u2022";
var bullet = "\u2022";
var bump = "\u224E";
var bumpE = "\u2AAE";
var bumpe = "\u224F";
var bumpeq = "\u224F";
var cacute = "\u0107";
var cap = "\u2229";
var capand = "\u2A44";
var capbrcup = "\u2A49";
var capcap = "\u2A4B";
var capcup = "\u2A47";
var capdot = "\u2A40";
var caps = "\u2229\uFE00";
var caret = "\u2041";
var caron = "\u02C7";
var ccaps = "\u2A4D";
var ccaron = "\u010D";
var ccedi = "\xe7";
var ccedil = "\xe7";
var ccirc = "\u0109";
var ccups = "\u2A4C";
var ccupssm = "\u2A50";
var cdot = "\u010B";
var cedi = "\xb8";
var cedil = "\xb8";
var cemptyv = "\u29B2";
var cen = "\xa2";
var cent = "\xa2";
var centerdot = "\xb7";
var cfr = "\uD835\uDD20";
var chcy = "\u0447";
var check = "\u2713";
var checkmark = "\u2713";
var chi = "\u03C7";
var cir = "\u25CB";
var cirE = "\u29C3";
var circ = "\u02C6";
var circeq = "\u2257";
var circlearrowleft = "\u21BA";
var circlearrowright = "\u21BB";
var circledR = "\xae";
var circledS = "\u24C8";
var circledast = "\u229B";
var circledcirc = "\u229A";
var circleddash = "\u229D";
var cire = "\u2257";
var cirfnint = "\u2A10";
var cirmid = "\u2AEF";
var cirscir = "\u29C2";
var clubs = "\u2663";
var clubsuit = "\u2663";
var colon = ":";
var colone = "\u2254";
var coloneq = "\u2254";
var comma = ",";
var commat = "@";
var comp = "\u2201";
var compfn = "\u2218";
var complement = "\u2201";
var complexes = "\u2102";
var cong = "\u2245";
var congdot = "\u2A6D";
var conint = "\u222E";
var copf = "\uD835\uDD54";
var coprod = "\u2210";
var cop = "\xa9";
var copy = "\xa9";
var copysr = "\u2117";
var crarr = "\u21B5";
var cross = "\u2717";
var cscr = "\uD835\uDCB8";
var csub = "\u2ACF";
var csube = "\u2AD1";
var csup = "\u2AD0";
var csupe = "\u2AD2";
var ctdot = "\u22EF";
var cudarrl = "\u2938";
var cudarrr = "\u2935";
var cuepr = "\u22DE";
var cuesc = "\u22DF";
var cularr = "\u21B6";
var cularrp = "\u293D";
var cup = "\u222A";
var cupbrcap = "\u2A48";
var cupcap = "\u2A46";
var cupcup = "\u2A4A";
var cupdot = "\u228D";
var cupor = "\u2A45";
var cups = "\u222A\uFE00";
var curarr = "\u21B7";
var curarrm = "\u293C";
var curlyeqprec = "\u22DE";
var curlyeqsucc = "\u22DF";
var curlyvee = "\u22CE";
var curlywedge = "\u22CF";
var curre = "\xa4";
var curren = "\xa4";
var curvearrowleft = "\u21B6";
var curvearrowright = "\u21B7";
var cuvee = "\u22CE";
var cuwed = "\u22CF";
var cwconint = "\u2232";
var cwint = "\u2231";
var cylcty = "\u232D";
var dArr = "\u21D3";
var dHar = "\u2965";
var dagger = "\u2020";
var daleth = "\u2138";
var darr = "\u2193";
var dash = "\u2010";
var dashv = "\u22A3";
var dbkarow = "\u290F";
var dblac = "\u02DD";
var dcaron = "\u010F";
var dcy = "\u0434";
var dd = "\u2146";
var ddagger = "\u2021";
var ddarr = "\u21CA";
var ddotseq = "\u2A77";
var de = "\xb0";
var deg = "\xb0";
var delta = "\u03B4";
var demptyv = "\u29B1";
var dfisht = "\u297F";
var dfr = "\uD835\uDD21";
var dharl = "\u21C3";
var dharr = "\u21C2";
var diam = "\u22C4";
var diamond = "\u22C4";
var diamondsuit = "\u2666";
var diams = "\u2666";
var die = "\xa8";
var digamma = "\u03DD";
var disin = "\u22F2";
var div$1 = "\xf7";
var divid = "\xf7";
var divide = "\xf7";
var divideontimes = "\u22C7";
var divonx = "\u22C7";
var djcy = "\u0452";
var dlcorn = "\u231E";
var dlcrop = "\u230D";
var dollar = "$";
var dopf = "\uD835\uDD55";
var dot = "\u02D9";
var doteq = "\u2250";
var doteqdot = "\u2251";
var dotminus = "\u2238";
var dotplus = "\u2214";
var dotsquare = "\u22A1";
var doublebarwedge = "\u2306";
var downarrow = "\u2193";
var downdownarrows = "\u21CA";
var downharpoonleft = "\u21C3";
var downharpoonright = "\u21C2";
var drbkarow = "\u2910";
var drcorn = "\u231F";
var drcrop = "\u230C";
var dscr = "\uD835\uDCB9";
var dscy = "\u0455";
var dsol = "\u29F6";
var dstrok = "\u0111";
var dtdot = "\u22F1";
var dtri = "\u25BF";
var dtrif = "\u25BE";
var duarr = "\u21F5";
var duhar = "\u296F";
var dwangle = "\u29A6";
var dzcy = "\u045F";
var dzigrarr = "\u27FF";
var eDDot = "\u2A77";
var eDot = "\u2251";
var eacut = "\xe9";
var eacute = "\xe9";
var easter = "\u2A6E";
var ecaron = "\u011B";
var ecir = "\xea";
var ecirc = "\xea";
var ecolon = "\u2255";
var ecy = "\u044D";
var edot = "\u0117";
var ee = "\u2147";
var efDot = "\u2252";
var efr = "\uD835\uDD22";
var eg = "\u2A9A";
var egrav = "\xe8";
var egrave = "\xe8";
var egs = "\u2A96";
var egsdot = "\u2A98";
var el$2 = "\u2A99";
var elinters = "\u23E7";
var ell = "\u2113";
var els = "\u2A95";
var elsdot = "\u2A97";
var emacr = "\u0113";
var empty = "\u2205";
var emptyset = "\u2205";
var emptyv = "\u2205";
var emsp13 = "\u2004";
var emsp14 = "\u2005";
var emsp = "\u2003";
var eng = "\u014B";
var ensp = "\u2002";
var eogon = "\u0119";
var eopf = "\uD835\uDD56";
var epar = "\u22D5";
var eparsl = "\u29E3";
var eplus = "\u2A71";
var epsi = "\u03B5";
var epsilon = "\u03B5";
var epsiv = "\u03F5";
var eqcirc = "\u2256";
var eqcolon = "\u2255";
var eqsim = "\u2242";
var eqslantgtr = "\u2A96";
var eqslantless = "\u2A95";
var equals = "=";
var equest = "\u225F";
var equiv = "\u2261";
var equivDD = "\u2A78";
var eqvparsl = "\u29E5";
var erDot = "\u2253";
var erarr = "\u2971";
var escr = "\u212F";
var esdot = "\u2250";
var esim = "\u2242";
var eta = "\u03B7";
var et = "\xf0";
var eth = "\xf0";
var eum = "\xeb";
var euml = "\xeb";
var euro = "\u20AC";
var excl = "!";
var exist = "\u2203";
var expectation = "\u2130";
var exponentiale = "\u2147";
var fallingdotseq = "\u2252";
var fcy = "\u0444";
var female = "\u2640";
var ffilig = "\uFB03";
var fflig = "\uFB00";
var ffllig = "\uFB04";
var ffr = "\uD835\uDD23";
var filig = "\uFB01";
var fjlig = "fj";
var flat = "\u266D";
var fllig = "\uFB02";
var fltns = "\u25B1";
var fnof = "\u0192";
var fopf = "\uD835\uDD57";
var forall = "\u2200";
var fork = "\u22D4";
var forkv = "\u2AD9";
var fpartint = "\u2A0D";
var frac1 = "\xbc";
var frac12 = "\xbd";
var frac13 = "\u2153";
var frac14 = "\xbc";
var frac15 = "\u2155";
var frac16 = "\u2159";
var frac18 = "\u215B";
var frac23 = "\u2154";
var frac25 = "\u2156";
var frac3 = "\xbe";
var frac34 = "\xbe";
var frac35 = "\u2157";
var frac38 = "\u215C";
var frac45 = "\u2158";
var frac56 = "\u215A";
var frac58 = "\u215D";
var frac78 = "\u215E";
var frasl = "\u2044";
var frown = "\u2322";
var fscr = "\uD835\uDCBB";
var gE = "\u2267";
var gEl = "\u2A8C";
var gacute = "\u01F5";
var gamma = "\u03B3";
var gammad = "\u03DD";
var gap = "\u2A86";
var gbreve = "\u011F";
var gcirc = "\u011D";
var gcy = "\u0433";
var gdot = "\u0121";
var ge = "\u2265";
var gel = "\u22DB";
var geq = "\u2265";
var geqq = "\u2267";
var geqslant = "\u2A7E";
var ges = "\u2A7E";
var gescc = "\u2AA9";
var gesdot = "\u2A80";
var gesdoto = "\u2A82";
var gesdotol = "\u2A84";
var gesl = "\u22DB\uFE00";
var gesles = "\u2A94";
var gfr = "\uD835\uDD24";
var gg = "\u226B";
var ggg = "\u22D9";
var gimel = "\u2137";
var gjcy = "\u0453";
var gl = "\u2277";
var glE = "\u2A92";
var gla = "\u2AA5";
var glj = "\u2AA4";
var gnE = "\u2269";
var gnap = "\u2A8A";
var gnapprox = "\u2A8A";
var gne = "\u2A88";
var gneq = "\u2A88";
var gneqq = "\u2269";
var gnsim = "\u22E7";
var gopf = "\uD835\uDD58";
var grave = "`";
var gscr = "\u210A";
var gsim = "\u2273";
var gsime = "\u2A8E";
var gsiml = "\u2A90";
var g$2 = ">";
var gt = ">";
var gtcc = "\u2AA7";
var gtcir = "\u2A7A";
var gtdot = "\u22D7";
var gtlPar = "\u2995";
var gtquest = "\u2A7C";
var gtrapprox = "\u2A86";
var gtrarr = "\u2978";
var gtrdot = "\u22D7";
var gtreqless = "\u22DB";
var gtreqqless = "\u2A8C";
var gtrless = "\u2277";
var gtrsim = "\u2273";
var gvertneqq = "\u2269\uFE00";
var gvnE = "\u2269\uFE00";
var hArr = "\u21D4";
var hairsp = "\u200A";
var half = "\xbd";
var hamilt = "\u210B";
var hardcy = "\u044A";
var harr = "\u2194";
var harrcir = "\u2948";
var harrw = "\u21AD";
var hbar = "\u210F";
var hcirc = "\u0125";
var hearts = "\u2665";
var heartsuit = "\u2665";
var hellip = "\u2026";
var hercon = "\u22B9";
var hfr = "\uD835\uDD25";
var hksearow = "\u2925";
var hkswarow = "\u2926";
var hoarr = "\u21FF";
var homtht = "\u223B";
var hookleftarrow = "\u21A9";
var hookrightarrow = "\u21AA";
var hopf = "\uD835\uDD59";
var horbar = "\u2015";
var hscr = "\uD835\uDCBD";
var hslash = "\u210F";
var hstrok = "\u0127";
var hybull = "\u2043";
var hyphen = "\u2010";
var iacut = "\xed";
var iacute = "\xed";
var ic = "\u2063";
var icir = "\xee";
var icirc = "\xee";
var icy = "\u0438";
var iecy = "\u0435";
var iexc = "\xa1";
var iexcl = "\xa1";
var iff = "\u21D4";
var ifr = "\uD835\uDD26";
var igrav = "\xec";
var igrave = "\xec";
var ii = "\u2148";
var iiiint = "\u2A0C";
var iiint = "\u222D";
var iinfin = "\u29DC";
var iiota = "\u2129";
var ijlig = "\u0133";
var imacr = "\u012B";
var image = "\u2111";
var imagline = "\u2110";
var imagpart = "\u2111";
var imath = "\u0131";
var imof = "\u22B7";
var imped = "\u01B5";
var incare = "\u2105";
var infin = "\u221E";
var infintie = "\u29DD";
var inodot = "\u0131";
var int = "\u222B";
var intcal = "\u22BA";
var integers = "\u2124";
var intercal = "\u22BA";
var intlarhk = "\u2A17";
var intprod = "\u2A3C";
var iocy = "\u0451";
var iogon = "\u012F";
var iopf = "\uD835\uDD5A";
var iota = "\u03B9";
var iprod = "\u2A3C";
var iques = "\xbf";
var iquest = "\xbf";
var iscr = "\uD835\uDCBE";
var isin = "\u2208";
var isinE = "\u22F9";
var isindot = "\u22F5";
var isins = "\u22F4";
var isinsv = "\u22F3";
var isinv = "\u2208";
var it = "\u2062";
var itilde = "\u0129";
var iukcy = "\u0456";
var ium = "\xef";
var iuml = "\xef";
var jcirc = "\u0135";
var jcy = "\u0439";
var jfr = "\uD835\uDD27";
var jmath = "\u0237";
var jopf = "\uD835\uDD5B";
var jscr = "\uD835\uDCBF";
var jsercy = "\u0458";
var jukcy = "\u0454";
var kappa = "\u03BA";
var kappav = "\u03F0";
var kcedil = "\u0137";
var kcy = "\u043A";
var kfr = "\uD835\uDD28";
var kgreen = "\u0138";
var khcy = "\u0445";
var kjcy = "\u045C";
var kopf = "\uD835\uDD5C";
var kscr = "\uD835\uDCC0";
var lAarr = "\u21DA";
var lArr = "\u21D0";
var lAtail = "\u291B";
var lBarr = "\u290E";
var lE = "\u2266";
var lEg = "\u2A8B";
var lHar = "\u2962";
var lacute = "\u013A";
var laemptyv = "\u29B4";
var lagran = "\u2112";
var lambda = "\u03BB";
var lang = "\u27E8";
var langd = "\u2991";
var langle = "\u27E8";
var lap = "\u2A85";
var laqu = "\xab";
var laquo = "\xab";
var larr = "\u2190";
var larrb = "\u21E4";
var larrbfs = "\u291F";
var larrfs = "\u291D";
var larrhk = "\u21A9";
var larrlp = "\u21AB";
var larrpl = "\u2939";
var larrsim = "\u2973";
var larrtl = "\u21A2";
var lat = "\u2AAB";
var latail = "\u2919";
var late = "\u2AAD";
var lates = "\u2AAD\uFE00";
var lbarr = "\u290C";
var lbbrk = "\u2772";
var lbrace = "{";
var lbrack = "[";
var lbrke = "\u298B";
var lbrksld = "\u298F";
var lbrkslu = "\u298D";
var lcaron = "\u013E";
var lcedil = "\u013C";
var lceil = "\u2308";
var lcub = "{";
var lcy = "\u043B";
var ldca = "\u2936";
var ldquo = "\u201C";
var ldquor = "\u201E";
var ldrdhar = "\u2967";
var ldrushar = "\u294B";
var ldsh = "\u21B2";
var le = "\u2264";
var leftarrow = "\u2190";
var leftarrowtail = "\u21A2";
var leftharpoondown = "\u21BD";
var leftharpoonup = "\u21BC";
var leftleftarrows = "\u21C7";
var leftrightarrow = "\u2194";
var leftrightarrows = "\u21C6";
var leftrightharpoons = "\u21CB";
var leftrightsquigarrow = "\u21AD";
var leftthreetimes = "\u22CB";
var leg = "\u22DA";
var leq = "\u2264";
var leqq = "\u2266";
var leqslant = "\u2A7D";
var les = "\u2A7D";
var lescc = "\u2AA8";
var lesdot = "\u2A7F";
var lesdoto = "\u2A81";
var lesdotor = "\u2A83";
var lesg = "\u22DA\uFE00";
var lesges = "\u2A93";
var lessapprox = "\u2A85";
var lessdot = "\u22D6";
var lesseqgtr = "\u22DA";
var lesseqqgtr = "\u2A8B";
var lessgtr = "\u2276";
var lesssim = "\u2272";
var lfisht = "\u297C";
var lfloor = "\u230A";
var lfr = "\uD835\uDD29";
var lg = "\u2276";
var lgE = "\u2A91";
var lhard = "\u21BD";
var lharu = "\u21BC";
var lharul = "\u296A";
var lhblk = "\u2584";
var ljcy = "\u0459";
var ll = "\u226A";
var llarr = "\u21C7";
var llcorner = "\u231E";
var llhard = "\u296B";
var lltri = "\u25FA";
var lmidot = "\u0140";
var lmoust = "\u23B0";
var lmoustache = "\u23B0";
var lnE = "\u2268";
var lnap = "\u2A89";
var lnapprox = "\u2A89";
var lne = "\u2A87";
var lneq = "\u2A87";
var lneqq = "\u2268";
var lnsim = "\u22E6";
var loang = "\u27EC";
var loarr = "\u21FD";
var lobrk = "\u27E6";
var longleftarrow = "\u27F5";
var longleftrightarrow = "\u27F7";
var longmapsto = "\u27FC";
var longrightarrow = "\u27F6";
var looparrowleft = "\u21AB";
var looparrowright = "\u21AC";
var lopar = "\u2985";
var lopf = "\uD835\uDD5D";
var loplus = "\u2A2D";
var lotimes = "\u2A34";
var lowast = "\u2217";
var lowbar = "_";
var loz = "\u25CA";
var lozenge = "\u25CA";
var lozf = "\u29EB";
var lpar = "(";
var lparlt = "\u2993";
var lrarr = "\u21C6";
var lrcorner = "\u231F";
var lrhar = "\u21CB";
var lrhard = "\u296D";
var lrm = "\u200E";
var lrtri = "\u22BF";
var lsaquo = "\u2039";
var lscr = "\uD835\uDCC1";
var lsh = "\u21B0";
var lsim = "\u2272";
var lsime = "\u2A8D";
var lsimg = "\u2A8F";
var lsqb = "[";
var lsquo = "\u2018";
var lsquor = "\u201A";
var lstrok = "\u0142";
var l$2 = "<";
var lt = "<";
var ltcc = "\u2AA6";
var ltcir = "\u2A79";
var ltdot = "\u22D6";
var lthree = "\u22CB";
var ltimes = "\u22C9";
var ltlarr = "\u2976";
var ltquest = "\u2A7B";
var ltrPar = "\u2996";
var ltri = "\u25C3";
var ltrie = "\u22B4";
var ltrif = "\u25C2";
var lurdshar = "\u294A";
var luruhar = "\u2966";
var lvertneqq = "\u2268\uFE00";
var lvnE = "\u2268\uFE00";
var mDDot = "\u223A";
var mac = "\xaf";
var macr = "\xaf";
var male = "\u2642";
var malt = "\u2720";
var maltese = "\u2720";
var map = "\u21A6";
var mapsto = "\u21A6";
var mapstodown = "\u21A7";
var mapstoleft = "\u21A4";
var mapstoup = "\u21A5";
var marker = "\u25AE";
var mcomma = "\u2A29";
var mcy = "\u043C";
var mdash = "\u2014";
var measuredangle = "\u2221";
var mfr = "\uD835\uDD2A";
var mho = "\u2127";
var micr = "\xb5";
var micro = "\xb5";
var mid = "\u2223";
var midast = "*";
var midcir = "\u2AF0";
var middo = "\xb7";
var middot = "\xb7";
var minus = "\u2212";
var minusb = "\u229F";
var minusd = "\u2238";
var minusdu = "\u2A2A";
var mlcp = "\u2ADB";
var mldr = "\u2026";
var mnplus = "\u2213";
var models = "\u22A7";
var mopf = "\uD835\uDD5E";
var mp = "\u2213";
var mscr = "\uD835\uDCC2";
var mstpos = "\u223E";
var mu = "\u03BC";
var multimap = "\u22B8";
var mumap = "\u22B8";
var nGg = "\u22D9\u0338";
var nGt = "\u226B\u20D2";
var nGtv = "\u226B\u0338";
var nLeftarrow = "\u21CD";
var nLeftrightarrow = "\u21CE";
var nLl = "\u22D8\u0338";
var nLt = "\u226A\u20D2";
var nLtv = "\u226A\u0338";
var nRightarrow = "\u21CF";
var nVDash = "\u22AF";
var nVdash = "\u22AE";
var nabla = "\u2207";
var nacute = "\u0144";
var nang = "\u2220\u20D2";
var nap = "\u2249";
var napE = "\u2A70\u0338";
var napid = "\u224B\u0338";
var napos = "\u0149";
var napprox = "\u2249";
var natur = "\u266E";
var natural = "\u266E";
var naturals = "\u2115";
var nbs = "\xa0";
var nbsp = "\xa0";
var nbump = "\u224E\u0338";
var nbumpe = "\u224F\u0338";
var ncap = "\u2A43";
var ncaron = "\u0148";
var ncedil = "\u0146";
var ncong = "\u2247";
var ncongdot = "\u2A6D\u0338";
var ncup = "\u2A42";
var ncy = "\u043D";
var ndash = "\u2013";
var ne = "\u2260";
var neArr = "\u21D7";
var nearhk = "\u2924";
var nearr = "\u2197";
var nearrow = "\u2197";
var nedot = "\u2250\u0338";
var nequiv = "\u2262";
var nesear = "\u2928";
var nesim = "\u2242\u0338";
var nexist = "\u2204";
var nexists = "\u2204";
var nfr = "\uD835\uDD2B";
var ngE = "\u2267\u0338";
var nge = "\u2271";
var ngeq = "\u2271";
var ngeqq = "\u2267\u0338";
var ngeqslant = "\u2A7E\u0338";
var nges = "\u2A7E\u0338";
var ngsim = "\u2275";
var ngt = "\u226F";
var ngtr = "\u226F";
var nhArr = "\u21CE";
var nharr = "\u21AE";
var nhpar = "\u2AF2";
var ni = "\u220B";
var nis = "\u22FC";
var nisd = "\u22FA";
var niv = "\u220B";
var njcy = "\u045A";
var nlArr = "\u21CD";
var nlE = "\u2266\u0338";
var nlarr = "\u219A";
var nldr = "\u2025";
var nle = "\u2270";
var nleftarrow = "\u219A";
var nleftrightarrow = "\u21AE";
var nleq = "\u2270";
var nleqq = "\u2266\u0338";
var nleqslant = "\u2A7D\u0338";
var nles = "\u2A7D\u0338";
var nless = "\u226E";
var nlsim = "\u2274";
var nlt = "\u226E";
var nltri = "\u22EA";
var nltrie = "\u22EC";
var nmid = "\u2224";
var nopf = "\uD835\uDD5F";
var no = "\xac";
var not = "\xac";
var notin = "\u2209";
var notinE = "\u22F9\u0338";
var notindot = "\u22F5\u0338";
var notinva = "\u2209";
var notinvb = "\u22F7";
var notinvc = "\u22F6";
var notni = "\u220C";
var notniva = "\u220C";
var notnivb = "\u22FE";
var notnivc = "\u22FD";
var npar = "\u2226";
var nparallel = "\u2226";
var nparsl = "\u2AFD\u20E5";
var npart = "\u2202\u0338";
var npolint = "\u2A14";
var npr = "\u2280";
var nprcue = "\u22E0";
var npre = "\u2AAF\u0338";
var nprec = "\u2280";
var npreceq = "\u2AAF\u0338";
var nrArr = "\u21CF";
var nrarr = "\u219B";
var nrarrc = "\u2933\u0338";
var nrarrw = "\u219D\u0338";
var nrightarrow = "\u219B";
var nrtri = "\u22EB";
var nrtrie = "\u22ED";
var nsc = "\u2281";
var nsccue = "\u22E1";
var nsce = "\u2AB0\u0338";
var nscr = "\uD835\uDCC3";
var nshortmid = "\u2224";
var nshortparallel = "\u2226";
var nsim = "\u2241";
var nsime = "\u2244";
var nsimeq = "\u2244";
var nsmid = "\u2224";
var nspar = "\u2226";
var nsqsube = "\u22E2";
var nsqsupe = "\u22E3";
var nsub = "\u2284";
var nsubE = "\u2AC5\u0338";
var nsube = "\u2288";
var nsubset = "\u2282\u20D2";
var nsubseteq = "\u2288";
var nsubseteqq = "\u2AC5\u0338";
var nsucc = "\u2281";
var nsucceq = "\u2AB0\u0338";
var nsup = "\u2285";
var nsupE = "\u2AC6\u0338";
var nsupe = "\u2289";
var nsupset = "\u2283\u20D2";
var nsupseteq = "\u2289";
var nsupseteqq = "\u2AC6\u0338";
var ntgl = "\u2279";
var ntild = "\xf1";
var ntilde = "\xf1";
var ntlg = "\u2278";
var ntriangleleft = "\u22EA";
var ntrianglelefteq = "\u22EC";
var ntriangleright = "\u22EB";
var ntrianglerighteq = "\u22ED";
var nu = "\u03BD";
var num = "#";
var numero = "\u2116";
var numsp = "\u2007";
var nvDash = "\u22AD";
var nvHarr = "\u2904";
var nvap = "\u224D\u20D2";
var nvdash = "\u22AC";
var nvge = "\u2265\u20D2";
var nvgt = ">\u20D2";
var nvinfin = "\u29DE";
var nvlArr = "\u2902";
var nvle = "\u2264\u20D2";
var nvlt = "<\u20D2";
var nvltrie = "\u22B4\u20D2";
var nvrArr = "\u2903";
var nvrtrie = "\u22B5\u20D2";
var nvsim = "\u223C\u20D2";
var nwArr = "\u21D6";
var nwarhk = "\u2923";
var nwarr = "\u2196";
var nwarrow = "\u2196";
var nwnear = "\u2927";
var oS = "\u24C8";
var oacut = "\xf3";
var oacute = "\xf3";
var oast = "\u229B";
var ocir = "\xf4";
var ocirc = "\xf4";
var ocy = "\u043E";
var odash = "\u229D";
var odblac = "\u0151";
var odiv = "\u2A38";
var odot = "\u2299";
var odsold = "\u29BC";
var oelig = "\u0153";
var ofcir = "\u29BF";
var ofr = "\uD835\uDD2C";
var ogon = "\u02DB";
var ograv = "\xf2";
var ograve = "\xf2";
var ogt = "\u29C1";
var ohbar = "\u29B5";
var ohm = "\u03A9";
var oint = "\u222E";
var olarr = "\u21BA";
var olcir = "\u29BE";
var olcross = "\u29BB";
var oline = "\u203E";
var olt = "\u29C0";
var omacr = "\u014D";
var omega = "\u03C9";
var omicron = "\u03BF";
var omid = "\u29B6";
var ominus = "\u2296";
var oopf = "\uD835\uDD60";
var opar = "\u29B7";
var operp = "\u29B9";
var oplus = "\u2295";
var or = "\u2228";
var orarr = "\u21BB";
var ord = "\xba";
var order = "\u2134";
var orderof = "\u2134";
var ordf = "\xaa";
var ordm = "\xba";
var origof = "\u22B6";
var oror = "\u2A56";
var orslope = "\u2A57";
var orv = "\u2A5B";
var oscr = "\u2134";
var oslas = "\xf8";
var oslash = "\xf8";
var osol = "\u2298";
var otild = "\xf5";
var otilde = "\xf5";
var otimes = "\u2297";
var otimesas = "\u2A36";
var oum = "\xf6";
var ouml = "\xf6";
var ovbar = "\u233D";
var par = "\xb6";
var para = "\xb6";
var parallel = "\u2225";
var parsim = "\u2AF3";
var parsl = "\u2AFD";
var part = "\u2202";
var pcy = "\u043F";
var percnt = "%";
var period = ".";
var permil = "\u2030";
var perp = "\u22A5";
var pertenk = "\u2031";
var pfr = "\uD835\uDD2D";
var phi = "\u03C6";
var phiv = "\u03D5";
var phmmat = "\u2133";
var phone = "\u260E";
var pi = "\u03C0";
var pitchfork = "\u22D4";
var piv = "\u03D6";
var planck = "\u210F";
var planckh = "\u210E";
var plankv = "\u210F";
var plus = "+";
var plusacir = "\u2A23";
var plusb = "\u229E";
var pluscir = "\u2A22";
var plusdo = "\u2214";
var plusdu = "\u2A25";
var pluse = "\u2A72";
var plusm = "\xb1";
var plusmn = "\xb1";
var plussim = "\u2A26";
var plustwo = "\u2A27";
var pm = "\xb1";
var pointint = "\u2A15";
var popf = "\uD835\uDD61";
var poun = "\xa3";
var pound = "\xa3";
var pr = "\u227A";
var prE = "\u2AB3";
var prap = "\u2AB7";
var prcue = "\u227C";
var pre = "\u2AAF";
var prec = "\u227A";
var precapprox = "\u2AB7";
var preccurlyeq = "\u227C";
var preceq = "\u2AAF";
var precnapprox = "\u2AB9";
var precneqq = "\u2AB5";
var precnsim = "\u22E8";
var precsim = "\u227E";
var prime = "\u2032";
var primes = "\u2119";
var prnE = "\u2AB5";
var prnap = "\u2AB9";
var prnsim = "\u22E8";
var prod = "\u220F";
var profalar = "\u232E";
var profline = "\u2312";
var profsurf = "\u2313";
var prop = "\u221D";
var propto = "\u221D";
var prsim = "\u227E";
var prurel = "\u22B0";
var pscr = "\uD835\uDCC5";
var psi = "\u03C8";
var puncsp = "\u2008";
var qfr = "\uD835\uDD2E";
var qint = "\u2A0C";
var qopf = "\uD835\uDD62";
var qprime = "\u2057";
var qscr = "\uD835\uDCC6";
var quaternions = "\u210D";
var quatint = "\u2A16";
var quest = "?";
var questeq = "\u225F";
var quo = "\"";
var quot = "\"";
var rAarr = "\u21DB";
var rArr = "\u21D2";
var rAtail = "\u291C";
var rBarr = "\u290F";
var rHar = "\u2964";
var race = "\u223D\u0331";
var racute = "\u0155";
var radic = "\u221A";
var raemptyv = "\u29B3";
var rang = "\u27E9";
var rangd = "\u2992";
var range = "\u29A5";
var rangle = "\u27E9";
var raqu = "\xbb";
var raquo = "\xbb";
var rarr = "\u2192";
var rarrap = "\u2975";
var rarrb = "\u21E5";
var rarrbfs = "\u2920";
var rarrc = "\u2933";
var rarrfs = "\u291E";
var rarrhk = "\u21AA";
var rarrlp = "\u21AC";
var rarrpl = "\u2945";
var rarrsim = "\u2974";
var rarrtl = "\u21A3";
var rarrw = "\u219D";
var ratail = "\u291A";
var ratio = "\u2236";
var rationals = "\u211A";
var rbarr = "\u290D";
var rbbrk = "\u2773";
var rbrace = "}";
var rbrack = "]";
var rbrke = "\u298C";
var rbrksld = "\u298E";
var rbrkslu = "\u2990";
var rcaron = "\u0159";
var rcedil = "\u0157";
var rceil = "\u2309";
var rcub = "}";
var rcy = "\u0440";
var rdca = "\u2937";
var rdldhar = "\u2969";
var rdquo = "\u201D";
var rdquor = "\u201D";
var rdsh = "\u21B3";
var real = "\u211C";
var realine = "\u211B";
var realpart = "\u211C";
var reals = "\u211D";
var rect = "\u25AD";
var re = "\xae";
var reg = "\xae";
var rfisht = "\u297D";
var rfloor = "\u230B";
var rfr = "\uD835\uDD2F";
var rhard = "\u21C1";
var rharu = "\u21C0";
var rharul = "\u296C";
var rho = "\u03C1";
var rhov = "\u03F1";
var rightarrow = "\u2192";
var rightarrowtail = "\u21A3";
var rightharpoondown = "\u21C1";
var rightharpoonup = "\u21C0";
var rightleftarrows = "\u21C4";
var rightleftharpoons = "\u21CC";
var rightrightarrows = "\u21C9";
var rightsquigarrow = "\u219D";
var rightthreetimes = "\u22CC";
var ring = "\u02DA";
var risingdotseq = "\u2253";
var rlarr = "\u21C4";
var rlhar = "\u21CC";
var rlm = "\u200F";
var rmoust = "\u23B1";
var rmoustache = "\u23B1";
var rnmid = "\u2AEE";
var roang = "\u27ED";
var roarr = "\u21FE";
var robrk = "\u27E7";
var ropar = "\u2986";
var ropf = "\uD835\uDD63";
var roplus = "\u2A2E";
var rotimes = "\u2A35";
var rpar = ")";
var rpargt = "\u2994";
var rppolint = "\u2A12";
var rrarr = "\u21C9";
var rsaquo = "\u203A";
var rscr = "\uD835\uDCC7";
var rsh = "\u21B1";
var rsqb = "]";
var rsquo = "\u2019";
var rsquor = "\u2019";
var rthree = "\u22CC";
var rtimes = "\u22CA";
var rtri = "\u25B9";
var rtrie = "\u22B5";
var rtrif = "\u25B8";
var rtriltri = "\u29CE";
var ruluhar = "\u2968";
var rx = "\u211E";
var sacute = "\u015B";
var sbquo = "\u201A";
var sc = "\u227B";
var scE = "\u2AB4";
var scap = "\u2AB8";
var scaron = "\u0161";
var sccue = "\u227D";
var sce = "\u2AB0";
var scedil = "\u015F";
var scirc = "\u015D";
var scnE = "\u2AB6";
var scnap = "\u2ABA";
var scnsim = "\u22E9";
var scpolint = "\u2A13";
var scsim = "\u227F";
var scy = "\u0441";
var sdot = "\u22C5";
var sdotb = "\u22A1";
var sdote = "\u2A66";
var seArr = "\u21D8";
var searhk = "\u2925";
var searr = "\u2198";
var searrow = "\u2198";
var sec = "\xa7";
var sect = "\xa7";
var semi = ";";
var seswar = "\u2929";
var setminus = "\u2216";
var setmn = "\u2216";
var sext = "\u2736";
var sfr = "\uD835\uDD30";
var sfrown = "\u2322";
var sharp = "\u266F";
var shchcy = "\u0449";
var shcy = "\u0448";
var shortmid = "\u2223";
var shortparallel = "\u2225";
var sh = "\xad";
var shy = "\xad";
var sigma = "\u03C3";
var sigmaf = "\u03C2";
var sigmav = "\u03C2";
var sim = "\u223C";
var simdot = "\u2A6A";
var sime = "\u2243";
var simeq = "\u2243";
var simg = "\u2A9E";
var simgE = "\u2AA0";
var siml = "\u2A9D";
var simlE = "\u2A9F";
var simne = "\u2246";
var simplus = "\u2A24";
var simrarr = "\u2972";
var slarr = "\u2190";
var smallsetminus = "\u2216";
var smashp = "\u2A33";
var smeparsl = "\u29E4";
var smid = "\u2223";
var smile = "\u2323";
var smt = "\u2AAA";
var smte = "\u2AAC";
var smtes = "\u2AAC\uFE00";
var softcy = "\u044C";
var sol = "/";
var solb = "\u29C4";
var solbar = "\u233F";
var sopf = "\uD835\uDD64";
var spades = "\u2660";
var spadesuit = "\u2660";
var spar = "\u2225";
var sqcap = "\u2293";
var sqcaps = "\u2293\uFE00";
var sqcup = "\u2294";
var sqcups = "\u2294\uFE00";
var sqsub = "\u228F";
var sqsube = "\u2291";
var sqsubset = "\u228F";
var sqsubseteq = "\u2291";
var sqsup = "\u2290";
var sqsupe = "\u2292";
var sqsupset = "\u2290";
var sqsupseteq = "\u2292";
var squ = "\u25A1";
var square = "\u25A1";
var squarf = "\u25AA";
var squf = "\u25AA";
var srarr = "\u2192";
var sscr = "\uD835\uDCC8";
var ssetmn = "\u2216";
var ssmile = "\u2323";
var sstarf = "\u22C6";
var star = "\u2606";
var starf = "\u2605";
var straightepsilon = "\u03F5";
var straightphi = "\u03D5";
var strns = "\xaf";
var sub = "\u2282";
var subE = "\u2AC5";
var subdot = "\u2ABD";
var sube = "\u2286";
var subedot = "\u2AC3";
var submult = "\u2AC1";
var subnE = "\u2ACB";
var subne = "\u228A";
var subplus = "\u2ABF";
var subrarr = "\u2979";
var subset = "\u2282";
var subseteq = "\u2286";
var subseteqq = "\u2AC5";
var subsetneq = "\u228A";
var subsetneqq = "\u2ACB";
var subsim = "\u2AC7";
var subsub = "\u2AD5";
var subsup = "\u2AD3";
var succ = "\u227B";
var succapprox = "\u2AB8";
var succcurlyeq = "\u227D";
var succeq = "\u2AB0";
var succnapprox = "\u2ABA";
var succneqq = "\u2AB6";
var succnsim = "\u22E9";
var succsim = "\u227F";
var sum = "\u2211";
var sung = "\u266A";
var sup = "\u2283";
var sup1 = "\xb9";
var sup2 = "\xb2";
var sup3 = "\xb3";
var supE = "\u2AC6";
var supdot = "\u2ABE";
var supdsub = "\u2AD8";
var supe = "\u2287";
var supedot = "\u2AC4";
var suphsol = "\u27C9";
var suphsub = "\u2AD7";
var suplarr = "\u297B";
var supmult = "\u2AC2";
var supnE = "\u2ACC";
var supne = "\u228B";
var supplus = "\u2AC0";
var supset = "\u2283";
var supseteq = "\u2287";
var supseteqq = "\u2AC6";
var supsetneq = "\u228B";
var supsetneqq = "\u2ACC";
var supsim = "\u2AC8";
var supsub = "\u2AD4";
var supsup = "\u2AD6";
var swArr = "\u21D9";
var swarhk = "\u2926";
var swarr = "\u2199";
var swarrow = "\u2199";
var swnwar = "\u292A";
var szli = "\xdf";
var szlig = "\xdf";
var target = "\u2316";
var tau = "\u03C4";
var tbrk = "\u23B4";
var tcaron = "\u0165";
var tcedil = "\u0163";
var tcy = "\u0442";
var tdot = "\u20DB";
var telrec = "\u2315";
var tfr = "\uD835\uDD31";
var there4 = "\u2234";
var therefore = "\u2234";
var theta = "\u03B8";
var thetasym = "\u03D1";
var thetav = "\u03D1";
var thickapprox = "\u2248";
var thicksim = "\u223C";
var thinsp = "\u2009";
var thkap = "\u2248";
var thksim = "\u223C";
var thor = "\xfe";
var thorn = "\xfe";
var tilde = "\u02DC";
var time = "\xd7";
var times = "\xd7";
var timesb = "\u22A0";
var timesbar = "\u2A31";
var timesd = "\u2A30";
var tint = "\u222D";
var toea = "\u2928";
var top = "\u22A4";
var topbot = "\u2336";
var topcir = "\u2AF1";
var topf = "\uD835\uDD65";
var topfork = "\u2ADA";
var tosa = "\u2929";
var tprime = "\u2034";
var trade = "\u2122";
var triangle = "\u25B5";
var triangledown = "\u25BF";
var triangleleft = "\u25C3";
var trianglelefteq = "\u22B4";
var triangleq = "\u225C";
var triangleright = "\u25B9";
var trianglerighteq = "\u22B5";
var tridot = "\u25EC";
var trie = "\u225C";
var triminus = "\u2A3A";
var triplus = "\u2A39";
var trisb = "\u29CD";
var tritime = "\u2A3B";
var trpezium = "\u23E2";
var tscr = "\uD835\uDCC9";
var tscy = "\u0446";
var tshcy = "\u045B";
var tstrok = "\u0167";
var twixt = "\u226C";
var twoheadleftarrow = "\u219E";
var twoheadrightarrow = "\u21A0";
var uArr = "\u21D1";
var uHar = "\u2963";
var uacut = "\xfa";
var uacute = "\xfa";
var uarr = "\u2191";
var ubrcy = "\u045E";
var ubreve = "\u016D";
var ucir = "\xfb";
var ucirc = "\xfb";
var ucy = "\u0443";
var udarr = "\u21C5";
var udblac = "\u0171";
var udhar = "\u296E";
var ufisht = "\u297E";
var ufr = "\uD835\uDD32";
var ugrav = "\xf9";
var ugrave = "\xf9";
var uharl = "\u21BF";
var uharr = "\u21BE";
var uhblk = "\u2580";
var ulcorn = "\u231C";
var ulcorner = "\u231C";
var ulcrop = "\u230F";
var ultri = "\u25F8";
var umacr = "\u016B";
var um = "\xa8";
var uml = "\xa8";
var uogon = "\u0173";
var uopf = "\uD835\uDD66";
var uparrow = "\u2191";
var updownarrow = "\u2195";
var upharpoonleft = "\u21BF";
var upharpoonright = "\u21BE";
var uplus = "\u228E";
var upsi = "\u03C5";
var upsih = "\u03D2";
var upsilon = "\u03C5";
var upuparrows = "\u21C8";
var urcorn = "\u231D";
var urcorner = "\u231D";
var urcrop = "\u230E";
var uring = "\u016F";
var urtri = "\u25F9";
var uscr = "\uD835\uDCCA";
var utdot = "\u22F0";
var utilde = "\u0169";
var utri = "\u25B5";
var utrif = "\u25B4";
var uuarr = "\u21C8";
var uum = "\xfc";
var uuml = "\xfc";
var uwangle = "\u29A7";
var vArr = "\u21D5";
var vBar = "\u2AE8";
var vBarv = "\u2AE9";
var vDash = "\u22A8";
var vangrt = "\u299C";
var varepsilon = "\u03F5";
var varkappa = "\u03F0";
var varnothing = "\u2205";
var varphi = "\u03D5";
var varpi = "\u03D6";
var varpropto = "\u221D";
var varr = "\u2195";
var varrho = "\u03F1";
var varsigma = "\u03C2";
var varsubsetneq = "\u228A\uFE00";
var varsubsetneqq = "\u2ACB\uFE00";
var varsupsetneq = "\u228B\uFE00";
var varsupsetneqq = "\u2ACC\uFE00";
var vartheta = "\u03D1";
var vartriangleleft = "\u22B2";
var vartriangleright = "\u22B3";
var vcy = "\u0432";
var vdash = "\u22A2";
var vee = "\u2228";
var veebar = "\u22BB";
var veeeq = "\u225A";
var vellip = "\u22EE";
var verbar = "|";
var vert = "|";
var vfr = "\uD835\uDD33";
var vltri = "\u22B2";
var vnsub = "\u2282\u20D2";
var vnsup = "\u2283\u20D2";
var vopf = "\uD835\uDD67";
var vprop = "\u221D";
var vrtri = "\u22B3";
var vscr = "\uD835\uDCCB";
var vsubnE = "\u2ACB\uFE00";
var vsubne = "\u228A\uFE00";
var vsupnE = "\u2ACC\uFE00";
var vsupne = "\u228B\uFE00";
var vzigzag = "\u299A";
var wcirc = "\u0175";
var wedbar = "\u2A5F";
var wedge = "\u2227";
var wedgeq = "\u2259";
var weierp = "\u2118";
var wfr = "\uD835\uDD34";
var wopf = "\uD835\uDD68";
var wp = "\u2118";
var wr = "\u2240";
var wreath = "\u2240";
var wscr = "\uD835\uDCCC";
var xcap = "\u22C2";
var xcirc = "\u25EF";
var xcup = "\u22C3";
var xdtri = "\u25BD";
var xfr = "\uD835\uDD35";
var xhArr = "\u27FA";
var xharr = "\u27F7";
var xi = "\u03BE";
var xlArr = "\u27F8";
var xlarr = "\u27F5";
var xmap = "\u27FC";
var xnis = "\u22FB";
var xodot = "\u2A00";
var xopf = "\uD835\uDD69";
var xoplus = "\u2A01";
var xotime = "\u2A02";
var xrArr = "\u27F9";
var xrarr = "\u27F6";
var xscr = "\uD835\uDCCD";
var xsqcup = "\u2A06";
var xuplus = "\u2A04";
var xutri = "\u25B3";
var xvee = "\u22C1";
var xwedge = "\u22C0";
var yacut = "\xfd";
var yacute = "\xfd";
var yacy = "\u044F";
var ycirc = "\u0177";
var ycy = "\u044B";
var ye = "\xa5";
var yen = "\xa5";
var yfr = "\uD835\uDD36";
var yicy = "\u0457";
var yopf = "\uD835\uDD6A";
var yscr = "\uD835\uDCCE";
var yucy = "\u044E";
var yum = "\xff";
var yuml = "\xff";
var zacute = "\u017A";
var zcaron = "\u017E";
var zcy = "\u0437";
var zdot = "\u017C";
var zeetrf = "\u2128";
var zeta = "\u03B6";
var zfr = "\uD835\uDD37";
var zhcy = "\u0436";
var zigrarr = "\u21DD";
var zopf = "\uD835\uDD6B";
var zscr = "\uD835\uDCCF";
var zwj = "\u200D";
var zwnj = "\u200C";
var index = {
    AEli: AEli,
    AElig: AElig,
    AM: AM,
    AMP: AMP,
    Aacut: Aacut,
    Aacute: Aacute,
    Abreve: Abreve,
    Acir: Acir,
    Acirc: Acirc,
    Acy: Acy,
    Afr: Afr,
    Agrav: Agrav,
    Agrave: Agrave,
    Alpha: Alpha,
    Amacr: Amacr,
    And: And,
    Aogon: Aogon,
    Aopf: Aopf,
    ApplyFunction: ApplyFunction,
    Arin: Arin,
    Aring: Aring,
    Ascr: Ascr,
    Assign: Assign,
    Atild: Atild,
    Atilde: Atilde,
    Aum: Aum,
    Auml: Auml,
    Backslash: Backslash,
    Barv: Barv,
    Barwed: Barwed,
    Bcy: Bcy,
    Because: Because,
    Bernoullis: Bernoullis,
    Beta: Beta,
    Bfr: Bfr,
    Bopf: Bopf,
    Breve: Breve,
    Bscr: Bscr,
    Bumpeq: Bumpeq,
    CHcy: CHcy,
    COP: COP,
    COPY: COPY,
    Cacute: Cacute,
    Cap: Cap,
    CapitalDifferentialD: CapitalDifferentialD,
    Cayleys: Cayleys,
    Ccaron: Ccaron,
    Ccedi: Ccedi,
    Ccedil: Ccedil,
    Ccirc: Ccirc,
    Cconint: Cconint,
    Cdot: Cdot,
    Cedilla: Cedilla,
    CenterDot: CenterDot,
    Cfr: Cfr,
    Chi: Chi,
    CircleDot: CircleDot,
    CircleMinus: CircleMinus,
    CirclePlus: CirclePlus,
    CircleTimes: CircleTimes,
    ClockwiseContourIntegral: ClockwiseContourIntegral,
    CloseCurlyDoubleQuote: CloseCurlyDoubleQuote,
    CloseCurlyQuote: CloseCurlyQuote,
    Colon: Colon,
    Colone: Colone,
    Congruent: Congruent,
    Conint: Conint,
    ContourIntegral: ContourIntegral,
    Copf: Copf,
    Coproduct: Coproduct,
    CounterClockwiseContourIntegral: CounterClockwiseContourIntegral,
    Cross: Cross,
    Cscr: Cscr,
    Cup: Cup,
    CupCap: CupCap,
    DD: DD,
    DDotrahd: DDotrahd,
    DJcy: DJcy,
    DScy: DScy,
    DZcy: DZcy,
    Dagger: Dagger,
    Darr: Darr,
    Dashv: Dashv,
    Dcaron: Dcaron,
    Dcy: Dcy,
    Del: Del,
    Delta: Delta,
    Dfr: Dfr,
    DiacriticalAcute: DiacriticalAcute,
    DiacriticalDot: DiacriticalDot,
    DiacriticalDoubleAcute: DiacriticalDoubleAcute,
    DiacriticalGrave: DiacriticalGrave,
    DiacriticalTilde: DiacriticalTilde,
    Diamond: Diamond,
    DifferentialD: DifferentialD,
    Dopf: Dopf,
    Dot: Dot,
    DotDot: DotDot,
    DotEqual: DotEqual,
    DoubleContourIntegral: DoubleContourIntegral,
    DoubleDot: DoubleDot,
    DoubleDownArrow: DoubleDownArrow,
    DoubleLeftArrow: DoubleLeftArrow,
    DoubleLeftRightArrow: DoubleLeftRightArrow,
    DoubleLeftTee: DoubleLeftTee,
    DoubleLongLeftArrow: DoubleLongLeftArrow,
    DoubleLongLeftRightArrow: DoubleLongLeftRightArrow,
    DoubleLongRightArrow: DoubleLongRightArrow,
    DoubleRightArrow: DoubleRightArrow,
    DoubleRightTee: DoubleRightTee,
    DoubleUpArrow: DoubleUpArrow,
    DoubleUpDownArrow: DoubleUpDownArrow,
    DoubleVerticalBar: DoubleVerticalBar,
    DownArrow: DownArrow,
    DownArrowBar: DownArrowBar,
    DownArrowUpArrow: DownArrowUpArrow,
    DownBreve: DownBreve,
    DownLeftRightVector: DownLeftRightVector,
    DownLeftTeeVector: DownLeftTeeVector,
    DownLeftVector: DownLeftVector,
    DownLeftVectorBar: DownLeftVectorBar,
    DownRightTeeVector: DownRightTeeVector,
    DownRightVector: DownRightVector,
    DownRightVectorBar: DownRightVectorBar,
    DownTee: DownTee,
    DownTeeArrow: DownTeeArrow,
    Downarrow: Downarrow,
    Dscr: Dscr,
    Dstrok: Dstrok,
    ENG: ENG,
    ET: ET,
    ETH: ETH,
    Eacut: Eacut,
    Eacute: Eacute,
    Ecaron: Ecaron,
    Ecir: Ecir,
    Ecirc: Ecirc,
    Ecy: Ecy,
    Edot: Edot,
    Efr: Efr,
    Egrav: Egrav,
    Egrave: Egrave,
    Element: Element$2,
    Emacr: Emacr,
    EmptySmallSquare: EmptySmallSquare,
    EmptyVerySmallSquare: EmptyVerySmallSquare,
    Eogon: Eogon,
    Eopf: Eopf,
    Epsilon: Epsilon,
    Equal: Equal,
    EqualTilde: EqualTilde,
    Equilibrium: Equilibrium,
    Escr: Escr,
    Esim: Esim,
    Eta: Eta,
    Eum: Eum,
    Euml: Euml,
    Exists: Exists,
    ExponentialE: ExponentialE,
    Fcy: Fcy,
    Ffr: Ffr,
    FilledSmallSquare: FilledSmallSquare,
    FilledVerySmallSquare: FilledVerySmallSquare,
    Fopf: Fopf,
    ForAll: ForAll,
    Fouriertrf: Fouriertrf,
    Fscr: Fscr,
    GJcy: GJcy,
    G: G$1,
    GT: GT,
    Gamma: Gamma,
    Gammad: Gammad,
    Gbreve: Gbreve,
    Gcedil: Gcedil,
    Gcirc: Gcirc,
    Gcy: Gcy,
    Gdot: Gdot,
    Gfr: Gfr,
    Gg: Gg,
    Gopf: Gopf,
    GreaterEqual: GreaterEqual,
    GreaterEqualLess: GreaterEqualLess,
    GreaterFullEqual: GreaterFullEqual,
    GreaterGreater: GreaterGreater,
    GreaterLess: GreaterLess,
    GreaterSlantEqual: GreaterSlantEqual,
    GreaterTilde: GreaterTilde,
    Gscr: Gscr,
    Gt: Gt,
    HARDcy: HARDcy,
    Hacek: Hacek,
    Hat: Hat,
    Hcirc: Hcirc,
    Hfr: Hfr,
    HilbertSpace: HilbertSpace,
    Hopf: Hopf,
    HorizontalLine: HorizontalLine,
    Hscr: Hscr,
    Hstrok: Hstrok,
    HumpDownHump: HumpDownHump,
    HumpEqual: HumpEqual,
    IEcy: IEcy,
    IJlig: IJlig,
    IOcy: IOcy,
    Iacut: Iacut,
    Iacute: Iacute,
    Icir: Icir,
    Icirc: Icirc,
    Icy: Icy,
    Idot: Idot,
    Ifr: Ifr,
    Igrav: Igrav,
    Igrave: Igrave,
    Im: Im,
    Imacr: Imacr,
    ImaginaryI: ImaginaryI,
    Implies: Implies,
    Int: Int,
    Integral: Integral,
    Intersection: Intersection,
    InvisibleComma: InvisibleComma,
    InvisibleTimes: InvisibleTimes,
    Iogon: Iogon,
    Iopf: Iopf,
    Iota: Iota,
    Iscr: Iscr,
    Itilde: Itilde,
    Iukcy: Iukcy,
    Ium: Ium,
    Iuml: Iuml,
    Jcirc: Jcirc,
    Jcy: Jcy,
    Jfr: Jfr,
    Jopf: Jopf,
    Jscr: Jscr,
    Jsercy: Jsercy,
    Jukcy: Jukcy,
    KHcy: KHcy,
    KJcy: KJcy,
    Kappa: Kappa,
    Kcedil: Kcedil,
    Kcy: Kcy,
    Kfr: Kfr,
    Kopf: Kopf,
    Kscr: Kscr,
    LJcy: LJcy,
    L: L,
    LT: LT,
    Lacute: Lacute,
    Lambda: Lambda,
    Lang: Lang,
    Laplacetrf: Laplacetrf,
    Larr: Larr,
    Lcaron: Lcaron,
    Lcedil: Lcedil,
    Lcy: Lcy,
    LeftAngleBracket: LeftAngleBracket,
    LeftArrow: LeftArrow,
    LeftArrowBar: LeftArrowBar,
    LeftArrowRightArrow: LeftArrowRightArrow,
    LeftCeiling: LeftCeiling,
    LeftDoubleBracket: LeftDoubleBracket,
    LeftDownTeeVector: LeftDownTeeVector,
    LeftDownVector: LeftDownVector,
    LeftDownVectorBar: LeftDownVectorBar,
    LeftFloor: LeftFloor,
    LeftRightArrow: LeftRightArrow,
    LeftRightVector: LeftRightVector,
    LeftTee: LeftTee,
    LeftTeeArrow: LeftTeeArrow,
    LeftTeeVector: LeftTeeVector,
    LeftTriangle: LeftTriangle,
    LeftTriangleBar: LeftTriangleBar,
    LeftTriangleEqual: LeftTriangleEqual,
    LeftUpDownVector: LeftUpDownVector,
    LeftUpTeeVector: LeftUpTeeVector,
    LeftUpVector: LeftUpVector,
    LeftUpVectorBar: LeftUpVectorBar,
    LeftVector: LeftVector,
    LeftVectorBar: LeftVectorBar,
    Leftarrow: Leftarrow,
    Leftrightarrow: Leftrightarrow,
    LessEqualGreater: LessEqualGreater,
    LessFullEqual: LessFullEqual,
    LessGreater: LessGreater,
    LessLess: LessLess,
    LessSlantEqual: LessSlantEqual,
    LessTilde: LessTilde,
    Lfr: Lfr,
    Ll: Ll,
    Lleftarrow: Lleftarrow,
    Lmidot: Lmidot,
    LongLeftArrow: LongLeftArrow,
    LongLeftRightArrow: LongLeftRightArrow,
    LongRightArrow: LongRightArrow,
    Longleftarrow: Longleftarrow,
    Longleftrightarrow: Longleftrightarrow,
    Longrightarrow: Longrightarrow,
    Lopf: Lopf,
    LowerLeftArrow: LowerLeftArrow,
    LowerRightArrow: LowerRightArrow,
    Lscr: Lscr,
    Lsh: Lsh,
    Lstrok: Lstrok,
    Lt: Lt,
    "Map": "\u2905",
    Mcy: Mcy,
    MediumSpace: MediumSpace,
    Mellintrf: Mellintrf,
    Mfr: Mfr,
    MinusPlus: MinusPlus,
    Mopf: Mopf,
    Mscr: Mscr,
    Mu: Mu,
    NJcy: NJcy,
    Nacute: Nacute,
    Ncaron: Ncaron,
    Ncedil: Ncedil,
    Ncy: Ncy,
    NegativeMediumSpace: NegativeMediumSpace,
    NegativeThickSpace: NegativeThickSpace,
    NegativeThinSpace: NegativeThinSpace,
    NegativeVeryThinSpace: NegativeVeryThinSpace,
    NestedGreaterGreater: NestedGreaterGreater,
    NestedLessLess: NestedLessLess,
    NewLine: NewLine,
    Nfr: Nfr,
    NoBreak: NoBreak,
    NonBreakingSpace: NonBreakingSpace,
    Nopf: Nopf,
    Not: Not,
    NotCongruent: NotCongruent,
    NotCupCap: NotCupCap,
    NotDoubleVerticalBar: NotDoubleVerticalBar,
    NotElement: NotElement,
    NotEqual: NotEqual,
    NotEqualTilde: NotEqualTilde,
    NotExists: NotExists,
    NotGreater: NotGreater,
    NotGreaterEqual: NotGreaterEqual,
    NotGreaterFullEqual: NotGreaterFullEqual,
    NotGreaterGreater: NotGreaterGreater,
    NotGreaterLess: NotGreaterLess,
    NotGreaterSlantEqual: NotGreaterSlantEqual,
    NotGreaterTilde: NotGreaterTilde,
    NotHumpDownHump: NotHumpDownHump,
    NotHumpEqual: NotHumpEqual,
    NotLeftTriangle: NotLeftTriangle,
    NotLeftTriangleBar: NotLeftTriangleBar,
    NotLeftTriangleEqual: NotLeftTriangleEqual,
    NotLess: NotLess,
    NotLessEqual: NotLessEqual,
    NotLessGreater: NotLessGreater,
    NotLessLess: NotLessLess,
    NotLessSlantEqual: NotLessSlantEqual,
    NotLessTilde: NotLessTilde,
    NotNestedGreaterGreater: NotNestedGreaterGreater,
    NotNestedLessLess: NotNestedLessLess,
    NotPrecedes: NotPrecedes,
    NotPrecedesEqual: NotPrecedesEqual,
    NotPrecedesSlantEqual: NotPrecedesSlantEqual,
    NotReverseElement: NotReverseElement,
    NotRightTriangle: NotRightTriangle,
    NotRightTriangleBar: NotRightTriangleBar,
    NotRightTriangleEqual: NotRightTriangleEqual,
    NotSquareSubset: NotSquareSubset,
    NotSquareSubsetEqual: NotSquareSubsetEqual,
    NotSquareSuperset: NotSquareSuperset,
    NotSquareSupersetEqual: NotSquareSupersetEqual,
    NotSubset: NotSubset,
    NotSubsetEqual: NotSubsetEqual,
    NotSucceeds: NotSucceeds,
    NotSucceedsEqual: NotSucceedsEqual,
    NotSucceedsSlantEqual: NotSucceedsSlantEqual,
    NotSucceedsTilde: NotSucceedsTilde,
    NotSuperset: NotSuperset,
    NotSupersetEqual: NotSupersetEqual,
    NotTilde: NotTilde,
    NotTildeEqual: NotTildeEqual,
    NotTildeFullEqual: NotTildeFullEqual,
    NotTildeTilde: NotTildeTilde,
    NotVerticalBar: NotVerticalBar,
    Nscr: Nscr,
    Ntild: Ntild,
    Ntilde: Ntilde,
    Nu: Nu,
    OElig: OElig,
    Oacut: Oacut,
    Oacute: Oacute,
    Ocir: Ocir,
    Ocirc: Ocirc,
    Ocy: Ocy,
    Odblac: Odblac,
    Ofr: Ofr,
    Ograv: Ograv,
    Ograve: Ograve,
    Omacr: Omacr,
    Omega: Omega,
    Omicron: Omicron,
    Oopf: Oopf,
    OpenCurlyDoubleQuote: OpenCurlyDoubleQuote,
    OpenCurlyQuote: OpenCurlyQuote,
    Or: Or,
    Oscr: Oscr,
    Oslas: Oslas,
    Oslash: Oslash,
    Otild: Otild,
    Otilde: Otilde,
    Otimes: Otimes,
    Oum: Oum,
    Ouml: Ouml,
    OverBar: OverBar,
    OverBrace: OverBrace,
    OverBracket: OverBracket,
    OverParenthesis: OverParenthesis,
    PartialD: PartialD,
    Pcy: Pcy,
    Pfr: Pfr,
    Phi: Phi,
    Pi: Pi,
    PlusMinus: PlusMinus,
    Poincareplane: Poincareplane,
    Popf: Popf,
    Pr: Pr,
    Precedes: Precedes,
    PrecedesEqual: PrecedesEqual,
    PrecedesSlantEqual: PrecedesSlantEqual,
    PrecedesTilde: PrecedesTilde,
    Prime: Prime,
    Product: Product,
    Proportion: Proportion,
    Proportional: Proportional,
    Pscr: Pscr,
    Psi: Psi,
    QUO: QUO,
    QUOT: QUOT,
    Qfr: Qfr,
    Qopf: Qopf,
    Qscr: Qscr,
    RBarr: RBarr,
    RE: RE,
    REG: REG,
    Racute: Racute,
    Rang: Rang,
    Rarr: Rarr,
    Rarrtl: Rarrtl,
    Rcaron: Rcaron,
    Rcedil: Rcedil,
    Rcy: Rcy,
    Re: Re,
    ReverseElement: ReverseElement,
    ReverseEquilibrium: ReverseEquilibrium,
    ReverseUpEquilibrium: ReverseUpEquilibrium,
    Rfr: Rfr,
    Rho: Rho,
    RightAngleBracket: RightAngleBracket,
    RightArrow: RightArrow,
    RightArrowBar: RightArrowBar,
    RightArrowLeftArrow: RightArrowLeftArrow,
    RightCeiling: RightCeiling,
    RightDoubleBracket: RightDoubleBracket,
    RightDownTeeVector: RightDownTeeVector,
    RightDownVector: RightDownVector,
    RightDownVectorBar: RightDownVectorBar,
    RightFloor: RightFloor,
    RightTee: RightTee,
    RightTeeArrow: RightTeeArrow,
    RightTeeVector: RightTeeVector,
    RightTriangle: RightTriangle,
    RightTriangleBar: RightTriangleBar,
    RightTriangleEqual: RightTriangleEqual,
    RightUpDownVector: RightUpDownVector,
    RightUpTeeVector: RightUpTeeVector,
    RightUpVector: RightUpVector,
    RightUpVectorBar: RightUpVectorBar,
    RightVector: RightVector,
    RightVectorBar: RightVectorBar,
    Rightarrow: Rightarrow,
    Ropf: Ropf,
    RoundImplies: RoundImplies,
    Rrightarrow: Rrightarrow,
    Rscr: Rscr,
    Rsh: Rsh,
    RuleDelayed: RuleDelayed,
    SHCHcy: SHCHcy,
    SHcy: SHcy,
    SOFTcy: SOFTcy,
    Sacute: Sacute,
    Sc: Sc,
    Scaron: Scaron,
    Scedil: Scedil,
    Scirc: Scirc,
    Scy: Scy,
    Sfr: Sfr,
    ShortDownArrow: ShortDownArrow,
    ShortLeftArrow: ShortLeftArrow,
    ShortRightArrow: ShortRightArrow,
    ShortUpArrow: ShortUpArrow,
    Sigma: Sigma,
    SmallCircle: SmallCircle,
    Sopf: Sopf,
    Sqrt: Sqrt,
    Square: Square,
    SquareIntersection: SquareIntersection,
    SquareSubset: SquareSubset,
    SquareSubsetEqual: SquareSubsetEqual,
    SquareSuperset: SquareSuperset,
    SquareSupersetEqual: SquareSupersetEqual,
    SquareUnion: SquareUnion,
    Sscr: Sscr,
    Star: Star,
    Sub: Sub,
    Subset: Subset,
    SubsetEqual: SubsetEqual,
    Succeeds: Succeeds,
    SucceedsEqual: SucceedsEqual,
    SucceedsSlantEqual: SucceedsSlantEqual,
    SucceedsTilde: SucceedsTilde,
    SuchThat: SuchThat,
    Sum: Sum,
    Sup: Sup,
    Superset: Superset,
    SupersetEqual: SupersetEqual,
    Supset: Supset,
    THOR: THOR,
    THORN: THORN,
    TRADE: TRADE,
    TSHcy: TSHcy,
    TScy: TScy,
    Tab: Tab,
    Tau: Tau,
    Tcaron: Tcaron,
    Tcedil: Tcedil,
    Tcy: Tcy,
    Tfr: Tfr,
    Therefore: Therefore,
    Theta: Theta,
    ThickSpace: ThickSpace,
    ThinSpace: ThinSpace,
    Tilde: Tilde,
    TildeEqual: TildeEqual,
    TildeFullEqual: TildeFullEqual,
    TildeTilde: TildeTilde,
    Topf: Topf,
    TripleDot: TripleDot,
    Tscr: Tscr,
    Tstrok: Tstrok,
    Uacut: Uacut,
    Uacute: Uacute,
    Uarr: Uarr,
    Uarrocir: Uarrocir,
    Ubrcy: Ubrcy,
    Ubreve: Ubreve,
    Ucir: Ucir,
    Ucirc: Ucirc,
    Ucy: Ucy,
    Udblac: Udblac,
    Ufr: Ufr,
    Ugrav: Ugrav,
    Ugrave: Ugrave,
    Umacr: Umacr,
    UnderBar: UnderBar,
    UnderBrace: UnderBrace,
    UnderBracket: UnderBracket,
    UnderParenthesis: UnderParenthesis,
    Union: Union,
    UnionPlus: UnionPlus,
    Uogon: Uogon,
    Uopf: Uopf,
    UpArrow: UpArrow,
    UpArrowBar: UpArrowBar,
    UpArrowDownArrow: UpArrowDownArrow,
    UpDownArrow: UpDownArrow,
    UpEquilibrium: UpEquilibrium,
    UpTee: UpTee,
    UpTeeArrow: UpTeeArrow,
    Uparrow: Uparrow,
    Updownarrow: Updownarrow,
    UpperLeftArrow: UpperLeftArrow,
    UpperRightArrow: UpperRightArrow,
    Upsi: Upsi,
    Upsilon: Upsilon,
    Uring: Uring,
    Uscr: Uscr,
    Utilde: Utilde,
    Uum: Uum,
    Uuml: Uuml,
    VDash: VDash,
    Vbar: Vbar,
    Vcy: Vcy,
    Vdash: Vdash,
    Vdashl: Vdashl,
    Vee: Vee,
    Verbar: Verbar,
    Vert: Vert,
    VerticalBar: VerticalBar,
    VerticalLine: VerticalLine,
    VerticalSeparator: VerticalSeparator,
    VerticalTilde: VerticalTilde,
    VeryThinSpace: VeryThinSpace,
    Vfr: Vfr,
    Vopf: Vopf,
    Vscr: Vscr,
    Vvdash: Vvdash,
    Wcirc: Wcirc,
    Wedge: Wedge,
    Wfr: Wfr,
    Wopf: Wopf,
    Wscr: Wscr,
    Xfr: Xfr,
    Xi: Xi,
    Xopf: Xopf,
    Xscr: Xscr,
    YAcy: YAcy,
    YIcy: YIcy,
    YUcy: YUcy,
    Yacut: Yacut,
    Yacute: Yacute,
    Ycirc: Ycirc,
    Ycy: Ycy,
    Yfr: Yfr,
    Yopf: Yopf,
    Yscr: Yscr,
    Yuml: Yuml,
    ZHcy: ZHcy,
    Zacute: Zacute,
    Zcaron: Zcaron,
    Zcy: Zcy,
    Zdot: Zdot,
    ZeroWidthSpace: ZeroWidthSpace,
    Zeta: Zeta,
    Zfr: Zfr,
    Zopf: Zopf,
    Zscr: Zscr,
    aacut: aacut,
    aacute: aacute,
    abreve: abreve,
    ac: ac,
    acE: acE,
    acd: acd,
    acir: acir,
    acirc: acirc,
    acut: acut,
    acute: acute,
    acy: acy,
    aeli: aeli,
    aelig: aelig,
    af: af,
    afr: afr,
    agrav: agrav,
    agrave: agrave,
    alefsym: alefsym,
    aleph: aleph,
    alpha: alpha,
    amacr: amacr,
    amalg: amalg,
    am: am,
    amp: amp,
    and: and,
    andand: andand,
    andd: andd,
    andslope: andslope,
    andv: andv,
    ang: ang,
    ange: ange,
    angle: angle,
    angmsd: angmsd,
    angmsdaa: angmsdaa,
    angmsdab: angmsdab,
    angmsdac: angmsdac,
    angmsdad: angmsdad,
    angmsdae: angmsdae,
    angmsdaf: angmsdaf,
    angmsdag: angmsdag,
    angmsdah: angmsdah,
    angrt: angrt,
    angrtvb: angrtvb,
    angrtvbd: angrtvbd,
    angsph: angsph,
    angst: angst,
    angzarr: angzarr,
    aogon: aogon,
    aopf: aopf,
    ap: ap,
    apE: apE,
    apacir: apacir,
    ape: ape,
    apid: apid,
    apos: apos,
    approx: approx,
    approxeq: approxeq,
    arin: arin,
    aring: aring,
    ascr: ascr,
    ast: ast,
    asymp: asymp,
    asympeq: asympeq,
    atild: atild,
    atilde: atilde,
    aum: aum,
    auml: auml,
    awconint: awconint,
    awint: awint,
    bNot: bNot,
    backcong: backcong,
    backepsilon: backepsilon,
    backprime: backprime,
    backsim: backsim,
    backsimeq: backsimeq,
    barvee: barvee,
    barwed: barwed,
    barwedge: barwedge,
    bbrk: bbrk,
    bbrktbrk: bbrktbrk,
    bcong: bcong,
    bcy: bcy,
    bdquo: bdquo,
    becaus: becaus,
    because: because,
    bemptyv: bemptyv,
    bepsi: bepsi,
    bernou: bernou,
    beta: beta,
    beth: beth,
    between: between,
    bfr: bfr,
    bigcap: bigcap,
    bigcirc: bigcirc,
    bigcup: bigcup,
    bigodot: bigodot,
    bigoplus: bigoplus,
    bigotimes: bigotimes,
    bigsqcup: bigsqcup,
    bigstar: bigstar,
    bigtriangledown: bigtriangledown,
    bigtriangleup: bigtriangleup,
    biguplus: biguplus,
    bigvee: bigvee,
    bigwedge: bigwedge,
    bkarow: bkarow,
    blacklozenge: blacklozenge,
    blacksquare: blacksquare,
    blacktriangle: blacktriangle,
    blacktriangledown: blacktriangledown,
    blacktriangleleft: blacktriangleleft,
    blacktriangleright: blacktriangleright,
    blank: blank,
    blk12: blk12,
    blk14: blk14,
    blk34: blk34,
    block: block,
    bne: bne,
    bnequiv: bnequiv,
    bnot: bnot,
    bopf: bopf,
    bot: bot,
    bottom: bottom,
    bowtie: bowtie,
    boxDL: boxDL,
    boxDR: boxDR,
    boxDl: boxDl,
    boxDr: boxDr,
    boxH: boxH,
    boxHD: boxHD,
    boxHU: boxHU,
    boxHd: boxHd,
    boxHu: boxHu,
    boxUL: boxUL,
    boxUR: boxUR,
    boxUl: boxUl,
    boxUr: boxUr,
    boxV: boxV,
    boxVH: boxVH,
    boxVL: boxVL,
    boxVR: boxVR,
    boxVh: boxVh,
    boxVl: boxVl,
    boxVr: boxVr,
    boxbox: boxbox,
    boxdL: boxdL,
    boxdR: boxdR,
    boxdl: boxdl,
    boxdr: boxdr,
    boxh: boxh,
    boxhD: boxhD,
    boxhU: boxhU,
    boxhd: boxhd,
    boxhu: boxhu,
    boxminus: boxminus,
    boxplus: boxplus,
    boxtimes: boxtimes,
    boxuL: boxuL,
    boxuR: boxuR,
    boxul: boxul,
    boxur: boxur,
    boxv: boxv,
    boxvH: boxvH,
    boxvL: boxvL,
    boxvR: boxvR,
    boxvh: boxvh,
    boxvl: boxvl,
    boxvr: boxvr,
    bprime: bprime,
    breve: breve,
    brvba: brvba,
    brvbar: brvbar,
    bscr: bscr,
    bsemi: bsemi,
    bsim: bsim,
    bsime: bsime,
    bsol: bsol,
    bsolb: bsolb,
    bsolhsub: bsolhsub,
    bull: bull,
    bullet: bullet,
    bump: bump,
    bumpE: bumpE,
    bumpe: bumpe,
    bumpeq: bumpeq,
    cacute: cacute,
    cap: cap,
    capand: capand,
    capbrcup: capbrcup,
    capcap: capcap,
    capcup: capcup,
    capdot: capdot,
    caps: caps,
    caret: caret,
    caron: caron,
    ccaps: ccaps,
    ccaron: ccaron,
    ccedi: ccedi,
    ccedil: ccedil,
    ccirc: ccirc,
    ccups: ccups,
    ccupssm: ccupssm,
    cdot: cdot,
    cedi: cedi,
    cedil: cedil,
    cemptyv: cemptyv,
    cen: cen,
    cent: cent,
    centerdot: centerdot,
    cfr: cfr,
    chcy: chcy,
    check: check,
    checkmark: checkmark,
    chi: chi,
    cir: cir,
    cirE: cirE,
    circ: circ,
    circeq: circeq,
    circlearrowleft: circlearrowleft,
    circlearrowright: circlearrowright,
    circledR: circledR,
    circledS: circledS,
    circledast: circledast,
    circledcirc: circledcirc,
    circleddash: circleddash,
    cire: cire,
    cirfnint: cirfnint,
    cirmid: cirmid,
    cirscir: cirscir,
    clubs: clubs,
    clubsuit: clubsuit,
    colon: colon,
    colone: colone,
    coloneq: coloneq,
    comma: comma,
    commat: commat,
    comp: comp,
    compfn: compfn,
    complement: complement,
    complexes: complexes,
    cong: cong,
    congdot: congdot,
    conint: conint,
    copf: copf,
    coprod: coprod,
    cop: cop,
    copy: copy,
    copysr: copysr,
    crarr: crarr,
    cross: cross,
    cscr: cscr,
    csub: csub,
    csube: csube,
    csup: csup,
    csupe: csupe,
    ctdot: ctdot,
    cudarrl: cudarrl,
    cudarrr: cudarrr,
    cuepr: cuepr,
    cuesc: cuesc,
    cularr: cularr,
    cularrp: cularrp,
    cup: cup,
    cupbrcap: cupbrcap,
    cupcap: cupcap,
    cupcup: cupcup,
    cupdot: cupdot,
    cupor: cupor,
    cups: cups,
    curarr: curarr,
    curarrm: curarrm,
    curlyeqprec: curlyeqprec,
    curlyeqsucc: curlyeqsucc,
    curlyvee: curlyvee,
    curlywedge: curlywedge,
    curre: curre,
    curren: curren,
    curvearrowleft: curvearrowleft,
    curvearrowright: curvearrowright,
    cuvee: cuvee,
    cuwed: cuwed,
    cwconint: cwconint,
    cwint: cwint,
    cylcty: cylcty,
    dArr: dArr,
    dHar: dHar,
    dagger: dagger,
    daleth: daleth,
    darr: darr,
    dash: dash,
    dashv: dashv,
    dbkarow: dbkarow,
    dblac: dblac,
    dcaron: dcaron,
    dcy: dcy,
    dd: dd,
    ddagger: ddagger,
    ddarr: ddarr,
    ddotseq: ddotseq,
    de: de,
    deg: deg,
    delta: delta,
    demptyv: demptyv,
    dfisht: dfisht,
    dfr: dfr,
    dharl: dharl,
    dharr: dharr,
    diam: diam,
    diamond: diamond,
    diamondsuit: diamondsuit,
    diams: diams,
    die: die,
    digamma: digamma,
    disin: disin,
    div: div$1,
    divid: divid,
    divide: divide,
    divideontimes: divideontimes,
    divonx: divonx,
    djcy: djcy,
    dlcorn: dlcorn,
    dlcrop: dlcrop,
    dollar: dollar,
    dopf: dopf,
    dot: dot,
    doteq: doteq,
    doteqdot: doteqdot,
    dotminus: dotminus,
    dotplus: dotplus,
    dotsquare: dotsquare,
    doublebarwedge: doublebarwedge,
    downarrow: downarrow,
    downdownarrows: downdownarrows,
    downharpoonleft: downharpoonleft,
    downharpoonright: downharpoonright,
    drbkarow: drbkarow,
    drcorn: drcorn,
    drcrop: drcrop,
    dscr: dscr,
    dscy: dscy,
    dsol: dsol,
    dstrok: dstrok,
    dtdot: dtdot,
    dtri: dtri,
    dtrif: dtrif,
    duarr: duarr,
    duhar: duhar,
    dwangle: dwangle,
    dzcy: dzcy,
    dzigrarr: dzigrarr,
    eDDot: eDDot,
    eDot: eDot,
    eacut: eacut,
    eacute: eacute,
    easter: easter,
    ecaron: ecaron,
    ecir: ecir,
    ecirc: ecirc,
    ecolon: ecolon,
    ecy: ecy,
    edot: edot,
    ee: ee,
    efDot: efDot,
    efr: efr,
    eg: eg,
    egrav: egrav,
    egrave: egrave,
    egs: egs,
    egsdot: egsdot,
    el: el$2,
    elinters: elinters,
    ell: ell,
    els: els,
    elsdot: elsdot,
    emacr: emacr,
    empty: empty,
    emptyset: emptyset,
    emptyv: emptyv,
    emsp13: emsp13,
    emsp14: emsp14,
    emsp: emsp,
    eng: eng,
    ensp: ensp,
    eogon: eogon,
    eopf: eopf,
    epar: epar,
    eparsl: eparsl,
    eplus: eplus,
    epsi: epsi,
    epsilon: epsilon,
    epsiv: epsiv,
    eqcirc: eqcirc,
    eqcolon: eqcolon,
    eqsim: eqsim,
    eqslantgtr: eqslantgtr,
    eqslantless: eqslantless,
    equals: equals,
    equest: equest,
    equiv: equiv,
    equivDD: equivDD,
    eqvparsl: eqvparsl,
    erDot: erDot,
    erarr: erarr,
    escr: escr,
    esdot: esdot,
    esim: esim,
    eta: eta,
    et: et,
    eth: eth,
    eum: eum,
    euml: euml,
    euro: euro,
    excl: excl,
    exist: exist,
    expectation: expectation,
    exponentiale: exponentiale,
    fallingdotseq: fallingdotseq,
    fcy: fcy,
    female: female,
    ffilig: ffilig,
    fflig: fflig,
    ffllig: ffllig,
    ffr: ffr,
    filig: filig,
    fjlig: fjlig,
    flat: flat,
    fllig: fllig,
    fltns: fltns,
    fnof: fnof,
    fopf: fopf,
    forall: forall,
    fork: fork,
    forkv: forkv,
    fpartint: fpartint,
    frac1: frac1,
    frac12: frac12,
    frac13: frac13,
    frac14: frac14,
    frac15: frac15,
    frac16: frac16,
    frac18: frac18,
    frac23: frac23,
    frac25: frac25,
    frac3: frac3,
    frac34: frac34,
    frac35: frac35,
    frac38: frac38,
    frac45: frac45,
    frac56: frac56,
    frac58: frac58,
    frac78: frac78,
    frasl: frasl,
    frown: frown,
    fscr: fscr,
    gE: gE,
    gEl: gEl,
    gacute: gacute,
    gamma: gamma,
    gammad: gammad,
    gap: gap,
    gbreve: gbreve,
    gcirc: gcirc,
    gcy: gcy,
    gdot: gdot,
    ge: ge,
    gel: gel,
    geq: geq,
    geqq: geqq,
    geqslant: geqslant,
    ges: ges,
    gescc: gescc,
    gesdot: gesdot,
    gesdoto: gesdoto,
    gesdotol: gesdotol,
    gesl: gesl,
    gesles: gesles,
    gfr: gfr,
    gg: gg,
    ggg: ggg,
    gimel: gimel,
    gjcy: gjcy,
    gl: gl,
    glE: glE,
    gla: gla,
    glj: glj,
    gnE: gnE,
    gnap: gnap,
    gnapprox: gnapprox,
    gne: gne,
    gneq: gneq,
    gneqq: gneqq,
    gnsim: gnsim,
    gopf: gopf,
    grave: grave,
    gscr: gscr,
    gsim: gsim,
    gsime: gsime,
    gsiml: gsiml,
    g: g$2,
    gt: gt,
    gtcc: gtcc,
    gtcir: gtcir,
    gtdot: gtdot,
    gtlPar: gtlPar,
    gtquest: gtquest,
    gtrapprox: gtrapprox,
    gtrarr: gtrarr,
    gtrdot: gtrdot,
    gtreqless: gtreqless,
    gtreqqless: gtreqqless,
    gtrless: gtrless,
    gtrsim: gtrsim,
    gvertneqq: gvertneqq,
    gvnE: gvnE,
    hArr: hArr,
    hairsp: hairsp,
    half: half,
    hamilt: hamilt,
    hardcy: hardcy,
    harr: harr,
    harrcir: harrcir,
    harrw: harrw,
    hbar: hbar,
    hcirc: hcirc,
    hearts: hearts,
    heartsuit: heartsuit,
    hellip: hellip,
    hercon: hercon,
    hfr: hfr,
    hksearow: hksearow,
    hkswarow: hkswarow,
    hoarr: hoarr,
    homtht: homtht,
    hookleftarrow: hookleftarrow,
    hookrightarrow: hookrightarrow,
    hopf: hopf,
    horbar: horbar,
    hscr: hscr,
    hslash: hslash,
    hstrok: hstrok,
    hybull: hybull,
    hyphen: hyphen,
    iacut: iacut,
    iacute: iacute,
    ic: ic,
    icir: icir,
    icirc: icirc,
    icy: icy,
    iecy: iecy,
    iexc: iexc,
    iexcl: iexcl,
    iff: iff,
    ifr: ifr,
    igrav: igrav,
    igrave: igrave,
    ii: ii,
    iiiint: iiiint,
    iiint: iiint,
    iinfin: iinfin,
    iiota: iiota,
    ijlig: ijlig,
    imacr: imacr,
    image: image,
    imagline: imagline,
    imagpart: imagpart,
    imath: imath,
    imof: imof,
    imped: imped,
    "in": "\u2208",
    incare: incare,
    infin: infin,
    infintie: infintie,
    inodot: inodot,
    int: int,
    intcal: intcal,
    integers: integers,
    intercal: intercal,
    intlarhk: intlarhk,
    intprod: intprod,
    iocy: iocy,
    iogon: iogon,
    iopf: iopf,
    iota: iota,
    iprod: iprod,
    iques: iques,
    iquest: iquest,
    iscr: iscr,
    isin: isin,
    isinE: isinE,
    isindot: isindot,
    isins: isins,
    isinsv: isinsv,
    isinv: isinv,
    it: it,
    itilde: itilde,
    iukcy: iukcy,
    ium: ium,
    iuml: iuml,
    jcirc: jcirc,
    jcy: jcy,
    jfr: jfr,
    jmath: jmath,
    jopf: jopf,
    jscr: jscr,
    jsercy: jsercy,
    jukcy: jukcy,
    kappa: kappa,
    kappav: kappav,
    kcedil: kcedil,
    kcy: kcy,
    kfr: kfr,
    kgreen: kgreen,
    khcy: khcy,
    kjcy: kjcy,
    kopf: kopf,
    kscr: kscr,
    lAarr: lAarr,
    lArr: lArr,
    lAtail: lAtail,
    lBarr: lBarr,
    lE: lE,
    lEg: lEg,
    lHar: lHar,
    lacute: lacute,
    laemptyv: laemptyv,
    lagran: lagran,
    lambda: lambda,
    lang: lang,
    langd: langd,
    langle: langle,
    lap: lap,
    laqu: laqu,
    laquo: laquo,
    larr: larr,
    larrb: larrb,
    larrbfs: larrbfs,
    larrfs: larrfs,
    larrhk: larrhk,
    larrlp: larrlp,
    larrpl: larrpl,
    larrsim: larrsim,
    larrtl: larrtl,
    lat: lat,
    latail: latail,
    late: late,
    lates: lates,
    lbarr: lbarr,
    lbbrk: lbbrk,
    lbrace: lbrace,
    lbrack: lbrack,
    lbrke: lbrke,
    lbrksld: lbrksld,
    lbrkslu: lbrkslu,
    lcaron: lcaron,
    lcedil: lcedil,
    lceil: lceil,
    lcub: lcub,
    lcy: lcy,
    ldca: ldca,
    ldquo: ldquo,
    ldquor: ldquor,
    ldrdhar: ldrdhar,
    ldrushar: ldrushar,
    ldsh: ldsh,
    le: le,
    leftarrow: leftarrow,
    leftarrowtail: leftarrowtail,
    leftharpoondown: leftharpoondown,
    leftharpoonup: leftharpoonup,
    leftleftarrows: leftleftarrows,
    leftrightarrow: leftrightarrow,
    leftrightarrows: leftrightarrows,
    leftrightharpoons: leftrightharpoons,
    leftrightsquigarrow: leftrightsquigarrow,
    leftthreetimes: leftthreetimes,
    leg: leg,
    leq: leq,
    leqq: leqq,
    leqslant: leqslant,
    les: les,
    lescc: lescc,
    lesdot: lesdot,
    lesdoto: lesdoto,
    lesdotor: lesdotor,
    lesg: lesg,
    lesges: lesges,
    lessapprox: lessapprox,
    lessdot: lessdot,
    lesseqgtr: lesseqgtr,
    lesseqqgtr: lesseqqgtr,
    lessgtr: lessgtr,
    lesssim: lesssim,
    lfisht: lfisht,
    lfloor: lfloor,
    lfr: lfr,
    lg: lg,
    lgE: lgE,
    lhard: lhard,
    lharu: lharu,
    lharul: lharul,
    lhblk: lhblk,
    ljcy: ljcy,
    ll: ll,
    llarr: llarr,
    llcorner: llcorner,
    llhard: llhard,
    lltri: lltri,
    lmidot: lmidot,
    lmoust: lmoust,
    lmoustache: lmoustache,
    lnE: lnE,
    lnap: lnap,
    lnapprox: lnapprox,
    lne: lne,
    lneq: lneq,
    lneqq: lneqq,
    lnsim: lnsim,
    loang: loang,
    loarr: loarr,
    lobrk: lobrk,
    longleftarrow: longleftarrow,
    longleftrightarrow: longleftrightarrow,
    longmapsto: longmapsto,
    longrightarrow: longrightarrow,
    looparrowleft: looparrowleft,
    looparrowright: looparrowright,
    lopar: lopar,
    lopf: lopf,
    loplus: loplus,
    lotimes: lotimes,
    lowast: lowast,
    lowbar: lowbar,
    loz: loz,
    lozenge: lozenge,
    lozf: lozf,
    lpar: lpar,
    lparlt: lparlt,
    lrarr: lrarr,
    lrcorner: lrcorner,
    lrhar: lrhar,
    lrhard: lrhard,
    lrm: lrm,
    lrtri: lrtri,
    lsaquo: lsaquo,
    lscr: lscr,
    lsh: lsh,
    lsim: lsim,
    lsime: lsime,
    lsimg: lsimg,
    lsqb: lsqb,
    lsquo: lsquo,
    lsquor: lsquor,
    lstrok: lstrok,
    l: l$2,
    lt: lt,
    ltcc: ltcc,
    ltcir: ltcir,
    ltdot: ltdot,
    lthree: lthree,
    ltimes: ltimes,
    ltlarr: ltlarr,
    ltquest: ltquest,
    ltrPar: ltrPar,
    ltri: ltri,
    ltrie: ltrie,
    ltrif: ltrif,
    lurdshar: lurdshar,
    luruhar: luruhar,
    lvertneqq: lvertneqq,
    lvnE: lvnE,
    mDDot: mDDot,
    mac: mac,
    macr: macr,
    male: male,
    malt: malt,
    maltese: maltese,
    map: map,
    mapsto: mapsto,
    mapstodown: mapstodown,
    mapstoleft: mapstoleft,
    mapstoup: mapstoup,
    marker: marker,
    mcomma: mcomma,
    mcy: mcy,
    mdash: mdash,
    measuredangle: measuredangle,
    mfr: mfr,
    mho: mho,
    micr: micr,
    micro: micro,
    mid: mid,
    midast: midast,
    midcir: midcir,
    middo: middo,
    middot: middot,
    minus: minus,
    minusb: minusb,
    minusd: minusd,
    minusdu: minusdu,
    mlcp: mlcp,
    mldr: mldr,
    mnplus: mnplus,
    models: models,
    mopf: mopf,
    mp: mp,
    mscr: mscr,
    mstpos: mstpos,
    mu: mu,
    multimap: multimap,
    mumap: mumap,
    nGg: nGg,
    nGt: nGt,
    nGtv: nGtv,
    nLeftarrow: nLeftarrow,
    nLeftrightarrow: nLeftrightarrow,
    nLl: nLl,
    nLt: nLt,
    nLtv: nLtv,
    nRightarrow: nRightarrow,
    nVDash: nVDash,
    nVdash: nVdash,
    nabla: nabla,
    nacute: nacute,
    nang: nang,
    nap: nap,
    napE: napE,
    napid: napid,
    napos: napos,
    napprox: napprox,
    natur: natur,
    natural: natural,
    naturals: naturals,
    nbs: nbs,
    nbsp: nbsp,
    nbump: nbump,
    nbumpe: nbumpe,
    ncap: ncap,
    ncaron: ncaron,
    ncedil: ncedil,
    ncong: ncong,
    ncongdot: ncongdot,
    ncup: ncup,
    ncy: ncy,
    ndash: ndash,
    ne: ne,
    neArr: neArr,
    nearhk: nearhk,
    nearr: nearr,
    nearrow: nearrow,
    nedot: nedot,
    nequiv: nequiv,
    nesear: nesear,
    nesim: nesim,
    nexist: nexist,
    nexists: nexists,
    nfr: nfr,
    ngE: ngE,
    nge: nge,
    ngeq: ngeq,
    ngeqq: ngeqq,
    ngeqslant: ngeqslant,
    nges: nges,
    ngsim: ngsim,
    ngt: ngt,
    ngtr: ngtr,
    nhArr: nhArr,
    nharr: nharr,
    nhpar: nhpar,
    ni: ni,
    nis: nis,
    nisd: nisd,
    niv: niv,
    njcy: njcy,
    nlArr: nlArr,
    nlE: nlE,
    nlarr: nlarr,
    nldr: nldr,
    nle: nle,
    nleftarrow: nleftarrow,
    nleftrightarrow: nleftrightarrow,
    nleq: nleq,
    nleqq: nleqq,
    nleqslant: nleqslant,
    nles: nles,
    nless: nless,
    nlsim: nlsim,
    nlt: nlt,
    nltri: nltri,
    nltrie: nltrie,
    nmid: nmid,
    nopf: nopf,
    no: no,
    not: not,
    notin: notin,
    notinE: notinE,
    notindot: notindot,
    notinva: notinva,
    notinvb: notinvb,
    notinvc: notinvc,
    notni: notni,
    notniva: notniva,
    notnivb: notnivb,
    notnivc: notnivc,
    npar: npar,
    nparallel: nparallel,
    nparsl: nparsl,
    npart: npart,
    npolint: npolint,
    npr: npr,
    nprcue: nprcue,
    npre: npre,
    nprec: nprec,
    npreceq: npreceq,
    nrArr: nrArr,
    nrarr: nrarr,
    nrarrc: nrarrc,
    nrarrw: nrarrw,
    nrightarrow: nrightarrow,
    nrtri: nrtri,
    nrtrie: nrtrie,
    nsc: nsc,
    nsccue: nsccue,
    nsce: nsce,
    nscr: nscr,
    nshortmid: nshortmid,
    nshortparallel: nshortparallel,
    nsim: nsim,
    nsime: nsime,
    nsimeq: nsimeq,
    nsmid: nsmid,
    nspar: nspar,
    nsqsube: nsqsube,
    nsqsupe: nsqsupe,
    nsub: nsub,
    nsubE: nsubE,
    nsube: nsube,
    nsubset: nsubset,
    nsubseteq: nsubseteq,
    nsubseteqq: nsubseteqq,
    nsucc: nsucc,
    nsucceq: nsucceq,
    nsup: nsup,
    nsupE: nsupE,
    nsupe: nsupe,
    nsupset: nsupset,
    nsupseteq: nsupseteq,
    nsupseteqq: nsupseteqq,
    ntgl: ntgl,
    ntild: ntild,
    ntilde: ntilde,
    ntlg: ntlg,
    ntriangleleft: ntriangleleft,
    ntrianglelefteq: ntrianglelefteq,
    ntriangleright: ntriangleright,
    ntrianglerighteq: ntrianglerighteq,
    nu: nu,
    num: num,
    numero: numero,
    numsp: numsp,
    nvDash: nvDash,
    nvHarr: nvHarr,
    nvap: nvap,
    nvdash: nvdash,
    nvge: nvge,
    nvgt: nvgt,
    nvinfin: nvinfin,
    nvlArr: nvlArr,
    nvle: nvle,
    nvlt: nvlt,
    nvltrie: nvltrie,
    nvrArr: nvrArr,
    nvrtrie: nvrtrie,
    nvsim: nvsim,
    nwArr: nwArr,
    nwarhk: nwarhk,
    nwarr: nwarr,
    nwarrow: nwarrow,
    nwnear: nwnear,
    oS: oS,
    oacut: oacut,
    oacute: oacute,
    oast: oast,
    ocir: ocir,
    ocirc: ocirc,
    ocy: ocy,
    odash: odash,
    odblac: odblac,
    odiv: odiv,
    odot: odot,
    odsold: odsold,
    oelig: oelig,
    ofcir: ofcir,
    ofr: ofr,
    ogon: ogon,
    ograv: ograv,
    ograve: ograve,
    ogt: ogt,
    ohbar: ohbar,
    ohm: ohm,
    oint: oint,
    olarr: olarr,
    olcir: olcir,
    olcross: olcross,
    oline: oline,
    olt: olt,
    omacr: omacr,
    omega: omega,
    omicron: omicron,
    omid: omid,
    ominus: ominus,
    oopf: oopf,
    opar: opar,
    operp: operp,
    oplus: oplus,
    or: or,
    orarr: orarr,
    ord: ord,
    order: order,
    orderof: orderof,
    ordf: ordf,
    ordm: ordm,
    origof: origof,
    oror: oror,
    orslope: orslope,
    orv: orv,
    oscr: oscr,
    oslas: oslas,
    oslash: oslash,
    osol: osol,
    otild: otild,
    otilde: otilde,
    otimes: otimes,
    otimesas: otimesas,
    oum: oum,
    ouml: ouml,
    ovbar: ovbar,
    par: par,
    para: para,
    parallel: parallel,
    parsim: parsim,
    parsl: parsl,
    part: part,
    pcy: pcy,
    percnt: percnt,
    period: period,
    permil: permil,
    perp: perp,
    pertenk: pertenk,
    pfr: pfr,
    phi: phi,
    phiv: phiv,
    phmmat: phmmat,
    phone: phone,
    pi: pi,
    pitchfork: pitchfork,
    piv: piv,
    planck: planck,
    planckh: planckh,
    plankv: plankv,
    plus: plus,
    plusacir: plusacir,
    plusb: plusb,
    pluscir: pluscir,
    plusdo: plusdo,
    plusdu: plusdu,
    pluse: pluse,
    plusm: plusm,
    plusmn: plusmn,
    plussim: plussim,
    plustwo: plustwo,
    pm: pm,
    pointint: pointint,
    popf: popf,
    poun: poun,
    pound: pound,
    pr: pr,
    prE: prE,
    prap: prap,
    prcue: prcue,
    pre: pre,
    prec: prec,
    precapprox: precapprox,
    preccurlyeq: preccurlyeq,
    preceq: preceq,
    precnapprox: precnapprox,
    precneqq: precneqq,
    precnsim: precnsim,
    precsim: precsim,
    prime: prime,
    primes: primes,
    prnE: prnE,
    prnap: prnap,
    prnsim: prnsim,
    prod: prod,
    profalar: profalar,
    profline: profline,
    profsurf: profsurf,
    prop: prop,
    propto: propto,
    prsim: prsim,
    prurel: prurel,
    pscr: pscr,
    psi: psi,
    puncsp: puncsp,
    qfr: qfr,
    qint: qint,
    qopf: qopf,
    qprime: qprime,
    qscr: qscr,
    quaternions: quaternions,
    quatint: quatint,
    quest: quest,
    questeq: questeq,
    quo: quo,
    quot: quot,
    rAarr: rAarr,
    rArr: rArr,
    rAtail: rAtail,
    rBarr: rBarr,
    rHar: rHar,
    race: race,
    racute: racute,
    radic: radic,
    raemptyv: raemptyv,
    rang: rang,
    rangd: rangd,
    range: range,
    rangle: rangle,
    raqu: raqu,
    raquo: raquo,
    rarr: rarr,
    rarrap: rarrap,
    rarrb: rarrb,
    rarrbfs: rarrbfs,
    rarrc: rarrc,
    rarrfs: rarrfs,
    rarrhk: rarrhk,
    rarrlp: rarrlp,
    rarrpl: rarrpl,
    rarrsim: rarrsim,
    rarrtl: rarrtl,
    rarrw: rarrw,
    ratail: ratail,
    ratio: ratio,
    rationals: rationals,
    rbarr: rbarr,
    rbbrk: rbbrk,
    rbrace: rbrace,
    rbrack: rbrack,
    rbrke: rbrke,
    rbrksld: rbrksld,
    rbrkslu: rbrkslu,
    rcaron: rcaron,
    rcedil: rcedil,
    rceil: rceil,
    rcub: rcub,
    rcy: rcy,
    rdca: rdca,
    rdldhar: rdldhar,
    rdquo: rdquo,
    rdquor: rdquor,
    rdsh: rdsh,
    real: real,
    realine: realine,
    realpart: realpart,
    reals: reals,
    rect: rect,
    re: re,
    reg: reg,
    rfisht: rfisht,
    rfloor: rfloor,
    rfr: rfr,
    rhard: rhard,
    rharu: rharu,
    rharul: rharul,
    rho: rho,
    rhov: rhov,
    rightarrow: rightarrow,
    rightarrowtail: rightarrowtail,
    rightharpoondown: rightharpoondown,
    rightharpoonup: rightharpoonup,
    rightleftarrows: rightleftarrows,
    rightleftharpoons: rightleftharpoons,
    rightrightarrows: rightrightarrows,
    rightsquigarrow: rightsquigarrow,
    rightthreetimes: rightthreetimes,
    ring: ring,
    risingdotseq: risingdotseq,
    rlarr: rlarr,
    rlhar: rlhar,
    rlm: rlm,
    rmoust: rmoust,
    rmoustache: rmoustache,
    rnmid: rnmid,
    roang: roang,
    roarr: roarr,
    robrk: robrk,
    ropar: ropar,
    ropf: ropf,
    roplus: roplus,
    rotimes: rotimes,
    rpar: rpar,
    rpargt: rpargt,
    rppolint: rppolint,
    rrarr: rrarr,
    rsaquo: rsaquo,
    rscr: rscr,
    rsh: rsh,
    rsqb: rsqb,
    rsquo: rsquo,
    rsquor: rsquor,
    rthree: rthree,
    rtimes: rtimes,
    rtri: rtri,
    rtrie: rtrie,
    rtrif: rtrif,
    rtriltri: rtriltri,
    ruluhar: ruluhar,
    rx: rx,
    sacute: sacute,
    sbquo: sbquo,
    sc: sc,
    scE: scE,
    scap: scap,
    scaron: scaron,
    sccue: sccue,
    sce: sce,
    scedil: scedil,
    scirc: scirc,
    scnE: scnE,
    scnap: scnap,
    scnsim: scnsim,
    scpolint: scpolint,
    scsim: scsim,
    scy: scy,
    sdot: sdot,
    sdotb: sdotb,
    sdote: sdote,
    seArr: seArr,
    searhk: searhk,
    searr: searr,
    searrow: searrow,
    sec: sec,
    sect: sect,
    semi: semi,
    seswar: seswar,
    setminus: setminus,
    setmn: setmn,
    sext: sext,
    sfr: sfr,
    sfrown: sfrown,
    sharp: sharp,
    shchcy: shchcy,
    shcy: shcy,
    shortmid: shortmid,
    shortparallel: shortparallel,
    sh: sh,
    shy: shy,
    sigma: sigma,
    sigmaf: sigmaf,
    sigmav: sigmav,
    sim: sim,
    simdot: simdot,
    sime: sime,
    simeq: simeq,
    simg: simg,
    simgE: simgE,
    siml: siml,
    simlE: simlE,
    simne: simne,
    simplus: simplus,
    simrarr: simrarr,
    slarr: slarr,
    smallsetminus: smallsetminus,
    smashp: smashp,
    smeparsl: smeparsl,
    smid: smid,
    smile: smile,
    smt: smt,
    smte: smte,
    smtes: smtes,
    softcy: softcy,
    sol: sol,
    solb: solb,
    solbar: solbar,
    sopf: sopf,
    spades: spades,
    spadesuit: spadesuit,
    spar: spar,
    sqcap: sqcap,
    sqcaps: sqcaps,
    sqcup: sqcup,
    sqcups: sqcups,
    sqsub: sqsub,
    sqsube: sqsube,
    sqsubset: sqsubset,
    sqsubseteq: sqsubseteq,
    sqsup: sqsup,
    sqsupe: sqsupe,
    sqsupset: sqsupset,
    sqsupseteq: sqsupseteq,
    squ: squ,
    square: square,
    squarf: squarf,
    squf: squf,
    srarr: srarr,
    sscr: sscr,
    ssetmn: ssetmn,
    ssmile: ssmile,
    sstarf: sstarf,
    star: star,
    starf: starf,
    straightepsilon: straightepsilon,
    straightphi: straightphi,
    strns: strns,
    sub: sub,
    subE: subE,
    subdot: subdot,
    sube: sube,
    subedot: subedot,
    submult: submult,
    subnE: subnE,
    subne: subne,
    subplus: subplus,
    subrarr: subrarr,
    subset: subset,
    subseteq: subseteq,
    subseteqq: subseteqq,
    subsetneq: subsetneq,
    subsetneqq: subsetneqq,
    subsim: subsim,
    subsub: subsub,
    subsup: subsup,
    succ: succ,
    succapprox: succapprox,
    succcurlyeq: succcurlyeq,
    succeq: succeq,
    succnapprox: succnapprox,
    succneqq: succneqq,
    succnsim: succnsim,
    succsim: succsim,
    sum: sum,
    sung: sung,
    sup: sup,
    sup1: sup1,
    sup2: sup2,
    sup3: sup3,
    supE: supE,
    supdot: supdot,
    supdsub: supdsub,
    supe: supe,
    supedot: supedot,
    suphsol: suphsol,
    suphsub: suphsub,
    suplarr: suplarr,
    supmult: supmult,
    supnE: supnE,
    supne: supne,
    supplus: supplus,
    supset: supset,
    supseteq: supseteq,
    supseteqq: supseteqq,
    supsetneq: supsetneq,
    supsetneqq: supsetneqq,
    supsim: supsim,
    supsub: supsub,
    supsup: supsup,
    swArr: swArr,
    swarhk: swarhk,
    swarr: swarr,
    swarrow: swarrow,
    swnwar: swnwar,
    szli: szli,
    szlig: szlig,
    target: target,
    tau: tau,
    tbrk: tbrk,
    tcaron: tcaron,
    tcedil: tcedil,
    tcy: tcy,
    tdot: tdot,
    telrec: telrec,
    tfr: tfr,
    there4: there4,
    therefore: therefore,
    theta: theta,
    thetasym: thetasym,
    thetav: thetav,
    thickapprox: thickapprox,
    thicksim: thicksim,
    thinsp: thinsp,
    thkap: thkap,
    thksim: thksim,
    thor: thor,
    thorn: thorn,
    tilde: tilde,
    time: time,
    times: times,
    timesb: timesb,
    timesbar: timesbar,
    timesd: timesd,
    tint: tint,
    toea: toea,
    top: top,
    topbot: topbot,
    topcir: topcir,
    topf: topf,
    topfork: topfork,
    tosa: tosa,
    tprime: tprime,
    trade: trade,
    triangle: triangle,
    triangledown: triangledown,
    triangleleft: triangleleft,
    trianglelefteq: trianglelefteq,
    triangleq: triangleq,
    triangleright: triangleright,
    trianglerighteq: trianglerighteq,
    tridot: tridot,
    trie: trie,
    triminus: triminus,
    triplus: triplus,
    trisb: trisb,
    tritime: tritime,
    trpezium: trpezium,
    tscr: tscr,
    tscy: tscy,
    tshcy: tshcy,
    tstrok: tstrok,
    twixt: twixt,
    twoheadleftarrow: twoheadleftarrow,
    twoheadrightarrow: twoheadrightarrow,
    uArr: uArr,
    uHar: uHar,
    uacut: uacut,
    uacute: uacute,
    uarr: uarr,
    ubrcy: ubrcy,
    ubreve: ubreve,
    ucir: ucir,
    ucirc: ucirc,
    ucy: ucy,
    udarr: udarr,
    udblac: udblac,
    udhar: udhar,
    ufisht: ufisht,
    ufr: ufr,
    ugrav: ugrav,
    ugrave: ugrave,
    uharl: uharl,
    uharr: uharr,
    uhblk: uhblk,
    ulcorn: ulcorn,
    ulcorner: ulcorner,
    ulcrop: ulcrop,
    ultri: ultri,
    umacr: umacr,
    um: um,
    uml: uml,
    uogon: uogon,
    uopf: uopf,
    uparrow: uparrow,
    updownarrow: updownarrow,
    upharpoonleft: upharpoonleft,
    upharpoonright: upharpoonright,
    uplus: uplus,
    upsi: upsi,
    upsih: upsih,
    upsilon: upsilon,
    upuparrows: upuparrows,
    urcorn: urcorn,
    urcorner: urcorner,
    urcrop: urcrop,
    uring: uring,
    urtri: urtri,
    uscr: uscr,
    utdot: utdot,
    utilde: utilde,
    utri: utri,
    utrif: utrif,
    uuarr: uuarr,
    uum: uum,
    uuml: uuml,
    uwangle: uwangle,
    vArr: vArr,
    vBar: vBar,
    vBarv: vBarv,
    vDash: vDash,
    vangrt: vangrt,
    varepsilon: varepsilon,
    varkappa: varkappa,
    varnothing: varnothing,
    varphi: varphi,
    varpi: varpi,
    varpropto: varpropto,
    varr: varr,
    varrho: varrho,
    varsigma: varsigma,
    varsubsetneq: varsubsetneq,
    varsubsetneqq: varsubsetneqq,
    varsupsetneq: varsupsetneq,
    varsupsetneqq: varsupsetneqq,
    vartheta: vartheta,
    vartriangleleft: vartriangleleft,
    vartriangleright: vartriangleright,
    vcy: vcy,
    vdash: vdash,
    vee: vee,
    veebar: veebar,
    veeeq: veeeq,
    vellip: vellip,
    verbar: verbar,
    vert: vert,
    vfr: vfr,
    vltri: vltri,
    vnsub: vnsub,
    vnsup: vnsup,
    vopf: vopf,
    vprop: vprop,
    vrtri: vrtri,
    vscr: vscr,
    vsubnE: vsubnE,
    vsubne: vsubne,
    vsupnE: vsupnE,
    vsupne: vsupne,
    vzigzag: vzigzag,
    wcirc: wcirc,
    wedbar: wedbar,
    wedge: wedge,
    wedgeq: wedgeq,
    weierp: weierp,
    wfr: wfr,
    wopf: wopf,
    wp: wp,
    wr: wr,
    wreath: wreath,
    wscr: wscr,
    xcap: xcap,
    xcirc: xcirc,
    xcup: xcup,
    xdtri: xdtri,
    xfr: xfr,
    xhArr: xhArr,
    xharr: xharr,
    xi: xi,
    xlArr: xlArr,
    xlarr: xlarr,
    xmap: xmap,
    xnis: xnis,
    xodot: xodot,
    xopf: xopf,
    xoplus: xoplus,
    xotime: xotime,
    xrArr: xrArr,
    xrarr: xrarr,
    xscr: xscr,
    xsqcup: xsqcup,
    xuplus: xuplus,
    xutri: xutri,
    xvee: xvee,
    xwedge: xwedge,
    yacut: yacut,
    yacute: yacute,
    yacy: yacy,
    ycirc: ycirc,
    ycy: ycy,
    ye: ye,
    yen: yen,
    yfr: yfr,
    yicy: yicy,
    yopf: yopf,
    yscr: yscr,
    yucy: yucy,
    yum: yum,
    yuml: yuml,
    zacute: zacute,
    zcaron: zcaron,
    zcy: zcy,
    zdot: zdot,
    zeetrf: zeetrf,
    zeta: zeta,
    zfr: zfr,
    zhcy: zhcy,
    zigrarr: zigrarr,
    zopf: zopf,
    zscr: zscr,
    zwj: zwj,
    zwnj: zwnj
};
var characterEntities$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    AEli: AEli,
    AElig: AElig,
    AM: AM,
    AMP: AMP,
    Aacut: Aacut,
    Aacute: Aacute,
    Abreve: Abreve,
    Acir: Acir,
    Acirc: Acirc,
    Acy: Acy,
    Afr: Afr,
    Agrav: Agrav,
    Agrave: Agrave,
    Alpha: Alpha,
    Amacr: Amacr,
    And: And,
    Aogon: Aogon,
    Aopf: Aopf,
    ApplyFunction: ApplyFunction,
    Arin: Arin,
    Aring: Aring,
    Ascr: Ascr,
    Assign: Assign,
    Atild: Atild,
    Atilde: Atilde,
    Aum: Aum,
    Auml: Auml,
    Backslash: Backslash,
    Barv: Barv,
    Barwed: Barwed,
    Bcy: Bcy,
    Because: Because,
    Bernoullis: Bernoullis,
    Beta: Beta,
    Bfr: Bfr,
    Bopf: Bopf,
    Breve: Breve,
    Bscr: Bscr,
    Bumpeq: Bumpeq,
    CHcy: CHcy,
    COP: COP,
    COPY: COPY,
    Cacute: Cacute,
    Cap: Cap,
    CapitalDifferentialD: CapitalDifferentialD,
    Cayleys: Cayleys,
    Ccaron: Ccaron,
    Ccedi: Ccedi,
    Ccedil: Ccedil,
    Ccirc: Ccirc,
    Cconint: Cconint,
    Cdot: Cdot,
    Cedilla: Cedilla,
    CenterDot: CenterDot,
    Cfr: Cfr,
    Chi: Chi,
    CircleDot: CircleDot,
    CircleMinus: CircleMinus,
    CirclePlus: CirclePlus,
    CircleTimes: CircleTimes,
    ClockwiseContourIntegral: ClockwiseContourIntegral,
    CloseCurlyDoubleQuote: CloseCurlyDoubleQuote,
    CloseCurlyQuote: CloseCurlyQuote,
    Colon: Colon,
    Colone: Colone,
    Congruent: Congruent,
    Conint: Conint,
    ContourIntegral: ContourIntegral,
    Copf: Copf,
    Coproduct: Coproduct,
    CounterClockwiseContourIntegral: CounterClockwiseContourIntegral,
    Cross: Cross,
    Cscr: Cscr,
    Cup: Cup,
    CupCap: CupCap,
    DD: DD,
    DDotrahd: DDotrahd,
    DJcy: DJcy,
    DScy: DScy,
    DZcy: DZcy,
    Dagger: Dagger,
    Darr: Darr,
    Dashv: Dashv,
    Dcaron: Dcaron,
    Dcy: Dcy,
    Del: Del,
    Delta: Delta,
    Dfr: Dfr,
    DiacriticalAcute: DiacriticalAcute,
    DiacriticalDot: DiacriticalDot,
    DiacriticalDoubleAcute: DiacriticalDoubleAcute,
    DiacriticalGrave: DiacriticalGrave,
    DiacriticalTilde: DiacriticalTilde,
    Diamond: Diamond,
    DifferentialD: DifferentialD,
    Dopf: Dopf,
    Dot: Dot,
    DotDot: DotDot,
    DotEqual: DotEqual,
    DoubleContourIntegral: DoubleContourIntegral,
    DoubleDot: DoubleDot,
    DoubleDownArrow: DoubleDownArrow,
    DoubleLeftArrow: DoubleLeftArrow,
    DoubleLeftRightArrow: DoubleLeftRightArrow,
    DoubleLeftTee: DoubleLeftTee,
    DoubleLongLeftArrow: DoubleLongLeftArrow,
    DoubleLongLeftRightArrow: DoubleLongLeftRightArrow,
    DoubleLongRightArrow: DoubleLongRightArrow,
    DoubleRightArrow: DoubleRightArrow,
    DoubleRightTee: DoubleRightTee,
    DoubleUpArrow: DoubleUpArrow,
    DoubleUpDownArrow: DoubleUpDownArrow,
    DoubleVerticalBar: DoubleVerticalBar,
    DownArrow: DownArrow,
    DownArrowBar: DownArrowBar,
    DownArrowUpArrow: DownArrowUpArrow,
    DownBreve: DownBreve,
    DownLeftRightVector: DownLeftRightVector,
    DownLeftTeeVector: DownLeftTeeVector,
    DownLeftVector: DownLeftVector,
    DownLeftVectorBar: DownLeftVectorBar,
    DownRightTeeVector: DownRightTeeVector,
    DownRightVector: DownRightVector,
    DownRightVectorBar: DownRightVectorBar,
    DownTee: DownTee,
    DownTeeArrow: DownTeeArrow,
    Downarrow: Downarrow,
    Dscr: Dscr,
    Dstrok: Dstrok,
    ENG: ENG,
    ET: ET,
    ETH: ETH,
    Eacut: Eacut,
    Eacute: Eacute,
    Ecaron: Ecaron,
    Ecir: Ecir,
    Ecirc: Ecirc,
    Ecy: Ecy,
    Edot: Edot,
    Efr: Efr,
    Egrav: Egrav,
    Egrave: Egrave,
    Element: Element$2,
    Emacr: Emacr,
    EmptySmallSquare: EmptySmallSquare,
    EmptyVerySmallSquare: EmptyVerySmallSquare,
    Eogon: Eogon,
    Eopf: Eopf,
    Epsilon: Epsilon,
    Equal: Equal,
    EqualTilde: EqualTilde,
    Equilibrium: Equilibrium,
    Escr: Escr,
    Esim: Esim,
    Eta: Eta,
    Eum: Eum,
    Euml: Euml,
    Exists: Exists,
    ExponentialE: ExponentialE,
    Fcy: Fcy,
    Ffr: Ffr,
    FilledSmallSquare: FilledSmallSquare,
    FilledVerySmallSquare: FilledVerySmallSquare,
    Fopf: Fopf,
    ForAll: ForAll,
    Fouriertrf: Fouriertrf,
    Fscr: Fscr,
    GJcy: GJcy,
    G: G$1,
    GT: GT,
    Gamma: Gamma,
    Gammad: Gammad,
    Gbreve: Gbreve,
    Gcedil: Gcedil,
    Gcirc: Gcirc,
    Gcy: Gcy,
    Gdot: Gdot,
    Gfr: Gfr,
    Gg: Gg,
    Gopf: Gopf,
    GreaterEqual: GreaterEqual,
    GreaterEqualLess: GreaterEqualLess,
    GreaterFullEqual: GreaterFullEqual,
    GreaterGreater: GreaterGreater,
    GreaterLess: GreaterLess,
    GreaterSlantEqual: GreaterSlantEqual,
    GreaterTilde: GreaterTilde,
    Gscr: Gscr,
    Gt: Gt,
    HARDcy: HARDcy,
    Hacek: Hacek,
    Hat: Hat,
    Hcirc: Hcirc,
    Hfr: Hfr,
    HilbertSpace: HilbertSpace,
    Hopf: Hopf,
    HorizontalLine: HorizontalLine,
    Hscr: Hscr,
    Hstrok: Hstrok,
    HumpDownHump: HumpDownHump,
    HumpEqual: HumpEqual,
    IEcy: IEcy,
    IJlig: IJlig,
    IOcy: IOcy,
    Iacut: Iacut,
    Iacute: Iacute,
    Icir: Icir,
    Icirc: Icirc,
    Icy: Icy,
    Idot: Idot,
    Ifr: Ifr,
    Igrav: Igrav,
    Igrave: Igrave,
    Im: Im,
    Imacr: Imacr,
    ImaginaryI: ImaginaryI,
    Implies: Implies,
    Int: Int,
    Integral: Integral,
    Intersection: Intersection,
    InvisibleComma: InvisibleComma,
    InvisibleTimes: InvisibleTimes,
    Iogon: Iogon,
    Iopf: Iopf,
    Iota: Iota,
    Iscr: Iscr,
    Itilde: Itilde,
    Iukcy: Iukcy,
    Ium: Ium,
    Iuml: Iuml,
    Jcirc: Jcirc,
    Jcy: Jcy,
    Jfr: Jfr,
    Jopf: Jopf,
    Jscr: Jscr,
    Jsercy: Jsercy,
    Jukcy: Jukcy,
    KHcy: KHcy,
    KJcy: KJcy,
    Kappa: Kappa,
    Kcedil: Kcedil,
    Kcy: Kcy,
    Kfr: Kfr,
    Kopf: Kopf,
    Kscr: Kscr,
    LJcy: LJcy,
    L: L,
    LT: LT,
    Lacute: Lacute,
    Lambda: Lambda,
    Lang: Lang,
    Laplacetrf: Laplacetrf,
    Larr: Larr,
    Lcaron: Lcaron,
    Lcedil: Lcedil,
    Lcy: Lcy,
    LeftAngleBracket: LeftAngleBracket,
    LeftArrow: LeftArrow,
    LeftArrowBar: LeftArrowBar,
    LeftArrowRightArrow: LeftArrowRightArrow,
    LeftCeiling: LeftCeiling,
    LeftDoubleBracket: LeftDoubleBracket,
    LeftDownTeeVector: LeftDownTeeVector,
    LeftDownVector: LeftDownVector,
    LeftDownVectorBar: LeftDownVectorBar,
    LeftFloor: LeftFloor,
    LeftRightArrow: LeftRightArrow,
    LeftRightVector: LeftRightVector,
    LeftTee: LeftTee,
    LeftTeeArrow: LeftTeeArrow,
    LeftTeeVector: LeftTeeVector,
    LeftTriangle: LeftTriangle,
    LeftTriangleBar: LeftTriangleBar,
    LeftTriangleEqual: LeftTriangleEqual,
    LeftUpDownVector: LeftUpDownVector,
    LeftUpTeeVector: LeftUpTeeVector,
    LeftUpVector: LeftUpVector,
    LeftUpVectorBar: LeftUpVectorBar,
    LeftVector: LeftVector,
    LeftVectorBar: LeftVectorBar,
    Leftarrow: Leftarrow,
    Leftrightarrow: Leftrightarrow,
    LessEqualGreater: LessEqualGreater,
    LessFullEqual: LessFullEqual,
    LessGreater: LessGreater,
    LessLess: LessLess,
    LessSlantEqual: LessSlantEqual,
    LessTilde: LessTilde,
    Lfr: Lfr,
    Ll: Ll,
    Lleftarrow: Lleftarrow,
    Lmidot: Lmidot,
    LongLeftArrow: LongLeftArrow,
    LongLeftRightArrow: LongLeftRightArrow,
    LongRightArrow: LongRightArrow,
    Longleftarrow: Longleftarrow,
    Longleftrightarrow: Longleftrightarrow,
    Longrightarrow: Longrightarrow,
    Lopf: Lopf,
    LowerLeftArrow: LowerLeftArrow,
    LowerRightArrow: LowerRightArrow,
    Lscr: Lscr,
    Lsh: Lsh,
    Lstrok: Lstrok,
    Lt: Lt,
    Mcy: Mcy,
    MediumSpace: MediumSpace,
    Mellintrf: Mellintrf,
    Mfr: Mfr,
    MinusPlus: MinusPlus,
    Mopf: Mopf,
    Mscr: Mscr,
    Mu: Mu,
    NJcy: NJcy,
    Nacute: Nacute,
    Ncaron: Ncaron,
    Ncedil: Ncedil,
    Ncy: Ncy,
    NegativeMediumSpace: NegativeMediumSpace,
    NegativeThickSpace: NegativeThickSpace,
    NegativeThinSpace: NegativeThinSpace,
    NegativeVeryThinSpace: NegativeVeryThinSpace,
    NestedGreaterGreater: NestedGreaterGreater,
    NestedLessLess: NestedLessLess,
    NewLine: NewLine,
    Nfr: Nfr,
    NoBreak: NoBreak,
    NonBreakingSpace: NonBreakingSpace,
    Nopf: Nopf,
    Not: Not,
    NotCongruent: NotCongruent,
    NotCupCap: NotCupCap,
    NotDoubleVerticalBar: NotDoubleVerticalBar,
    NotElement: NotElement,
    NotEqual: NotEqual,
    NotEqualTilde: NotEqualTilde,
    NotExists: NotExists,
    NotGreater: NotGreater,
    NotGreaterEqual: NotGreaterEqual,
    NotGreaterFullEqual: NotGreaterFullEqual,
    NotGreaterGreater: NotGreaterGreater,
    NotGreaterLess: NotGreaterLess,
    NotGreaterSlantEqual: NotGreaterSlantEqual,
    NotGreaterTilde: NotGreaterTilde,
    NotHumpDownHump: NotHumpDownHump,
    NotHumpEqual: NotHumpEqual,
    NotLeftTriangle: NotLeftTriangle,
    NotLeftTriangleBar: NotLeftTriangleBar,
    NotLeftTriangleEqual: NotLeftTriangleEqual,
    NotLess: NotLess,
    NotLessEqual: NotLessEqual,
    NotLessGreater: NotLessGreater,
    NotLessLess: NotLessLess,
    NotLessSlantEqual: NotLessSlantEqual,
    NotLessTilde: NotLessTilde,
    NotNestedGreaterGreater: NotNestedGreaterGreater,
    NotNestedLessLess: NotNestedLessLess,
    NotPrecedes: NotPrecedes,
    NotPrecedesEqual: NotPrecedesEqual,
    NotPrecedesSlantEqual: NotPrecedesSlantEqual,
    NotReverseElement: NotReverseElement,
    NotRightTriangle: NotRightTriangle,
    NotRightTriangleBar: NotRightTriangleBar,
    NotRightTriangleEqual: NotRightTriangleEqual,
    NotSquareSubset: NotSquareSubset,
    NotSquareSubsetEqual: NotSquareSubsetEqual,
    NotSquareSuperset: NotSquareSuperset,
    NotSquareSupersetEqual: NotSquareSupersetEqual,
    NotSubset: NotSubset,
    NotSubsetEqual: NotSubsetEqual,
    NotSucceeds: NotSucceeds,
    NotSucceedsEqual: NotSucceedsEqual,
    NotSucceedsSlantEqual: NotSucceedsSlantEqual,
    NotSucceedsTilde: NotSucceedsTilde,
    NotSuperset: NotSuperset,
    NotSupersetEqual: NotSupersetEqual,
    NotTilde: NotTilde,
    NotTildeEqual: NotTildeEqual,
    NotTildeFullEqual: NotTildeFullEqual,
    NotTildeTilde: NotTildeTilde,
    NotVerticalBar: NotVerticalBar,
    Nscr: Nscr,
    Ntild: Ntild,
    Ntilde: Ntilde,
    Nu: Nu,
    OElig: OElig,
    Oacut: Oacut,
    Oacute: Oacute,
    Ocir: Ocir,
    Ocirc: Ocirc,
    Ocy: Ocy,
    Odblac: Odblac,
    Ofr: Ofr,
    Ograv: Ograv,
    Ograve: Ograve,
    Omacr: Omacr,
    Omega: Omega,
    Omicron: Omicron,
    Oopf: Oopf,
    OpenCurlyDoubleQuote: OpenCurlyDoubleQuote,
    OpenCurlyQuote: OpenCurlyQuote,
    Or: Or,
    Oscr: Oscr,
    Oslas: Oslas,
    Oslash: Oslash,
    Otild: Otild,
    Otilde: Otilde,
    Otimes: Otimes,
    Oum: Oum,
    Ouml: Ouml,
    OverBar: OverBar,
    OverBrace: OverBrace,
    OverBracket: OverBracket,
    OverParenthesis: OverParenthesis,
    PartialD: PartialD,
    Pcy: Pcy,
    Pfr: Pfr,
    Phi: Phi,
    Pi: Pi,
    PlusMinus: PlusMinus,
    Poincareplane: Poincareplane,
    Popf: Popf,
    Pr: Pr,
    Precedes: Precedes,
    PrecedesEqual: PrecedesEqual,
    PrecedesSlantEqual: PrecedesSlantEqual,
    PrecedesTilde: PrecedesTilde,
    Prime: Prime,
    Product: Product,
    Proportion: Proportion,
    Proportional: Proportional,
    Pscr: Pscr,
    Psi: Psi,
    QUO: QUO,
    QUOT: QUOT,
    Qfr: Qfr,
    Qopf: Qopf,
    Qscr: Qscr,
    RBarr: RBarr,
    RE: RE,
    REG: REG,
    Racute: Racute,
    Rang: Rang,
    Rarr: Rarr,
    Rarrtl: Rarrtl,
    Rcaron: Rcaron,
    Rcedil: Rcedil,
    Rcy: Rcy,
    Re: Re,
    ReverseElement: ReverseElement,
    ReverseEquilibrium: ReverseEquilibrium,
    ReverseUpEquilibrium: ReverseUpEquilibrium,
    Rfr: Rfr,
    Rho: Rho,
    RightAngleBracket: RightAngleBracket,
    RightArrow: RightArrow,
    RightArrowBar: RightArrowBar,
    RightArrowLeftArrow: RightArrowLeftArrow,
    RightCeiling: RightCeiling,
    RightDoubleBracket: RightDoubleBracket,
    RightDownTeeVector: RightDownTeeVector,
    RightDownVector: RightDownVector,
    RightDownVectorBar: RightDownVectorBar,
    RightFloor: RightFloor,
    RightTee: RightTee,
    RightTeeArrow: RightTeeArrow,
    RightTeeVector: RightTeeVector,
    RightTriangle: RightTriangle,
    RightTriangleBar: RightTriangleBar,
    RightTriangleEqual: RightTriangleEqual,
    RightUpDownVector: RightUpDownVector,
    RightUpTeeVector: RightUpTeeVector,
    RightUpVector: RightUpVector,
    RightUpVectorBar: RightUpVectorBar,
    RightVector: RightVector,
    RightVectorBar: RightVectorBar,
    Rightarrow: Rightarrow,
    Ropf: Ropf,
    RoundImplies: RoundImplies,
    Rrightarrow: Rrightarrow,
    Rscr: Rscr,
    Rsh: Rsh,
    RuleDelayed: RuleDelayed,
    SHCHcy: SHCHcy,
    SHcy: SHcy,
    SOFTcy: SOFTcy,
    Sacute: Sacute,
    Sc: Sc,
    Scaron: Scaron,
    Scedil: Scedil,
    Scirc: Scirc,
    Scy: Scy,
    Sfr: Sfr,
    ShortDownArrow: ShortDownArrow,
    ShortLeftArrow: ShortLeftArrow,
    ShortRightArrow: ShortRightArrow,
    ShortUpArrow: ShortUpArrow,
    Sigma: Sigma,
    SmallCircle: SmallCircle,
    Sopf: Sopf,
    Sqrt: Sqrt,
    Square: Square,
    SquareIntersection: SquareIntersection,
    SquareSubset: SquareSubset,
    SquareSubsetEqual: SquareSubsetEqual,
    SquareSuperset: SquareSuperset,
    SquareSupersetEqual: SquareSupersetEqual,
    SquareUnion: SquareUnion,
    Sscr: Sscr,
    Star: Star,
    Sub: Sub,
    Subset: Subset,
    SubsetEqual: SubsetEqual,
    Succeeds: Succeeds,
    SucceedsEqual: SucceedsEqual,
    SucceedsSlantEqual: SucceedsSlantEqual,
    SucceedsTilde: SucceedsTilde,
    SuchThat: SuchThat,
    Sum: Sum,
    Sup: Sup,
    Superset: Superset,
    SupersetEqual: SupersetEqual,
    Supset: Supset,
    THOR: THOR,
    THORN: THORN,
    TRADE: TRADE,
    TSHcy: TSHcy,
    TScy: TScy,
    Tab: Tab,
    Tau: Tau,
    Tcaron: Tcaron,
    Tcedil: Tcedil,
    Tcy: Tcy,
    Tfr: Tfr,
    Therefore: Therefore,
    Theta: Theta,
    ThickSpace: ThickSpace,
    ThinSpace: ThinSpace,
    Tilde: Tilde,
    TildeEqual: TildeEqual,
    TildeFullEqual: TildeFullEqual,
    TildeTilde: TildeTilde,
    Topf: Topf,
    TripleDot: TripleDot,
    Tscr: Tscr,
    Tstrok: Tstrok,
    Uacut: Uacut,
    Uacute: Uacute,
    Uarr: Uarr,
    Uarrocir: Uarrocir,
    Ubrcy: Ubrcy,
    Ubreve: Ubreve,
    Ucir: Ucir,
    Ucirc: Ucirc,
    Ucy: Ucy,
    Udblac: Udblac,
    Ufr: Ufr,
    Ugrav: Ugrav,
    Ugrave: Ugrave,
    Umacr: Umacr,
    UnderBar: UnderBar,
    UnderBrace: UnderBrace,
    UnderBracket: UnderBracket,
    UnderParenthesis: UnderParenthesis,
    Union: Union,
    UnionPlus: UnionPlus,
    Uogon: Uogon,
    Uopf: Uopf,
    UpArrow: UpArrow,
    UpArrowBar: UpArrowBar,
    UpArrowDownArrow: UpArrowDownArrow,
    UpDownArrow: UpDownArrow,
    UpEquilibrium: UpEquilibrium,
    UpTee: UpTee,
    UpTeeArrow: UpTeeArrow,
    Uparrow: Uparrow,
    Updownarrow: Updownarrow,
    UpperLeftArrow: UpperLeftArrow,
    UpperRightArrow: UpperRightArrow,
    Upsi: Upsi,
    Upsilon: Upsilon,
    Uring: Uring,
    Uscr: Uscr,
    Utilde: Utilde,
    Uum: Uum,
    Uuml: Uuml,
    VDash: VDash,
    Vbar: Vbar,
    Vcy: Vcy,
    Vdash: Vdash,
    Vdashl: Vdashl,
    Vee: Vee,
    Verbar: Verbar,
    Vert: Vert,
    VerticalBar: VerticalBar,
    VerticalLine: VerticalLine,
    VerticalSeparator: VerticalSeparator,
    VerticalTilde: VerticalTilde,
    VeryThinSpace: VeryThinSpace,
    Vfr: Vfr,
    Vopf: Vopf,
    Vscr: Vscr,
    Vvdash: Vvdash,
    Wcirc: Wcirc,
    Wedge: Wedge,
    Wfr: Wfr,
    Wopf: Wopf,
    Wscr: Wscr,
    Xfr: Xfr,
    Xi: Xi,
    Xopf: Xopf,
    Xscr: Xscr,
    YAcy: YAcy,
    YIcy: YIcy,
    YUcy: YUcy,
    Yacut: Yacut,
    Yacute: Yacute,
    Ycirc: Ycirc,
    Ycy: Ycy,
    Yfr: Yfr,
    Yopf: Yopf,
    Yscr: Yscr,
    Yuml: Yuml,
    ZHcy: ZHcy,
    Zacute: Zacute,
    Zcaron: Zcaron,
    Zcy: Zcy,
    Zdot: Zdot,
    ZeroWidthSpace: ZeroWidthSpace,
    Zeta: Zeta,
    Zfr: Zfr,
    Zopf: Zopf,
    Zscr: Zscr,
    aacut: aacut,
    aacute: aacute,
    abreve: abreve,
    ac: ac,
    acE: acE,
    acd: acd,
    acir: acir,
    acirc: acirc,
    acut: acut,
    acute: acute,
    acy: acy,
    aeli: aeli,
    aelig: aelig,
    af: af,
    afr: afr,
    agrav: agrav,
    agrave: agrave,
    alefsym: alefsym,
    aleph: aleph,
    alpha: alpha,
    amacr: amacr,
    amalg: amalg,
    am: am,
    amp: amp,
    and: and,
    andand: andand,
    andd: andd,
    andslope: andslope,
    andv: andv,
    ang: ang,
    ange: ange,
    angle: angle,
    angmsd: angmsd,
    angmsdaa: angmsdaa,
    angmsdab: angmsdab,
    angmsdac: angmsdac,
    angmsdad: angmsdad,
    angmsdae: angmsdae,
    angmsdaf: angmsdaf,
    angmsdag: angmsdag,
    angmsdah: angmsdah,
    angrt: angrt,
    angrtvb: angrtvb,
    angrtvbd: angrtvbd,
    angsph: angsph,
    angst: angst,
    angzarr: angzarr,
    aogon: aogon,
    aopf: aopf,
    ap: ap,
    apE: apE,
    apacir: apacir,
    ape: ape,
    apid: apid,
    apos: apos,
    approx: approx,
    approxeq: approxeq,
    arin: arin,
    aring: aring,
    ascr: ascr,
    ast: ast,
    asymp: asymp,
    asympeq: asympeq,
    atild: atild,
    atilde: atilde,
    aum: aum,
    auml: auml,
    awconint: awconint,
    awint: awint,
    bNot: bNot,
    backcong: backcong,
    backepsilon: backepsilon,
    backprime: backprime,
    backsim: backsim,
    backsimeq: backsimeq,
    barvee: barvee,
    barwed: barwed,
    barwedge: barwedge,
    bbrk: bbrk,
    bbrktbrk: bbrktbrk,
    bcong: bcong,
    bcy: bcy,
    bdquo: bdquo,
    becaus: becaus,
    because: because,
    bemptyv: bemptyv,
    bepsi: bepsi,
    bernou: bernou,
    beta: beta,
    beth: beth,
    between: between,
    bfr: bfr,
    bigcap: bigcap,
    bigcirc: bigcirc,
    bigcup: bigcup,
    bigodot: bigodot,
    bigoplus: bigoplus,
    bigotimes: bigotimes,
    bigsqcup: bigsqcup,
    bigstar: bigstar,
    bigtriangledown: bigtriangledown,
    bigtriangleup: bigtriangleup,
    biguplus: biguplus,
    bigvee: bigvee,
    bigwedge: bigwedge,
    bkarow: bkarow,
    blacklozenge: blacklozenge,
    blacksquare: blacksquare,
    blacktriangle: blacktriangle,
    blacktriangledown: blacktriangledown,
    blacktriangleleft: blacktriangleleft,
    blacktriangleright: blacktriangleright,
    blank: blank,
    blk12: blk12,
    blk14: blk14,
    blk34: blk34,
    block: block,
    bne: bne,
    bnequiv: bnequiv,
    bnot: bnot,
    bopf: bopf,
    bot: bot,
    bottom: bottom,
    bowtie: bowtie,
    boxDL: boxDL,
    boxDR: boxDR,
    boxDl: boxDl,
    boxDr: boxDr,
    boxH: boxH,
    boxHD: boxHD,
    boxHU: boxHU,
    boxHd: boxHd,
    boxHu: boxHu,
    boxUL: boxUL,
    boxUR: boxUR,
    boxUl: boxUl,
    boxUr: boxUr,
    boxV: boxV,
    boxVH: boxVH,
    boxVL: boxVL,
    boxVR: boxVR,
    boxVh: boxVh,
    boxVl: boxVl,
    boxVr: boxVr,
    boxbox: boxbox,
    boxdL: boxdL,
    boxdR: boxdR,
    boxdl: boxdl,
    boxdr: boxdr,
    boxh: boxh,
    boxhD: boxhD,
    boxhU: boxhU,
    boxhd: boxhd,
    boxhu: boxhu,
    boxminus: boxminus,
    boxplus: boxplus,
    boxtimes: boxtimes,
    boxuL: boxuL,
    boxuR: boxuR,
    boxul: boxul,
    boxur: boxur,
    boxv: boxv,
    boxvH: boxvH,
    boxvL: boxvL,
    boxvR: boxvR,
    boxvh: boxvh,
    boxvl: boxvl,
    boxvr: boxvr,
    bprime: bprime,
    breve: breve,
    brvba: brvba,
    brvbar: brvbar,
    bscr: bscr,
    bsemi: bsemi,
    bsim: bsim,
    bsime: bsime,
    bsol: bsol,
    bsolb: bsolb,
    bsolhsub: bsolhsub,
    bull: bull,
    bullet: bullet,
    bump: bump,
    bumpE: bumpE,
    bumpe: bumpe,
    bumpeq: bumpeq,
    cacute: cacute,
    cap: cap,
    capand: capand,
    capbrcup: capbrcup,
    capcap: capcap,
    capcup: capcup,
    capdot: capdot,
    caps: caps,
    caret: caret,
    caron: caron,
    ccaps: ccaps,
    ccaron: ccaron,
    ccedi: ccedi,
    ccedil: ccedil,
    ccirc: ccirc,
    ccups: ccups,
    ccupssm: ccupssm,
    cdot: cdot,
    cedi: cedi,
    cedil: cedil,
    cemptyv: cemptyv,
    cen: cen,
    cent: cent,
    centerdot: centerdot,
    cfr: cfr,
    chcy: chcy,
    check: check,
    checkmark: checkmark,
    chi: chi,
    cir: cir,
    cirE: cirE,
    circ: circ,
    circeq: circeq,
    circlearrowleft: circlearrowleft,
    circlearrowright: circlearrowright,
    circledR: circledR,
    circledS: circledS,
    circledast: circledast,
    circledcirc: circledcirc,
    circleddash: circleddash,
    cire: cire,
    cirfnint: cirfnint,
    cirmid: cirmid,
    cirscir: cirscir,
    clubs: clubs,
    clubsuit: clubsuit,
    colon: colon,
    colone: colone,
    coloneq: coloneq,
    comma: comma,
    commat: commat,
    comp: comp,
    compfn: compfn,
    complement: complement,
    complexes: complexes,
    cong: cong,
    congdot: congdot,
    conint: conint,
    copf: copf,
    coprod: coprod,
    cop: cop,
    copy: copy,
    copysr: copysr,
    crarr: crarr,
    cross: cross,
    cscr: cscr,
    csub: csub,
    csube: csube,
    csup: csup,
    csupe: csupe,
    ctdot: ctdot,
    cudarrl: cudarrl,
    cudarrr: cudarrr,
    cuepr: cuepr,
    cuesc: cuesc,
    cularr: cularr,
    cularrp: cularrp,
    cup: cup,
    cupbrcap: cupbrcap,
    cupcap: cupcap,
    cupcup: cupcup,
    cupdot: cupdot,
    cupor: cupor,
    cups: cups,
    curarr: curarr,
    curarrm: curarrm,
    curlyeqprec: curlyeqprec,
    curlyeqsucc: curlyeqsucc,
    curlyvee: curlyvee,
    curlywedge: curlywedge,
    curre: curre,
    curren: curren,
    curvearrowleft: curvearrowleft,
    curvearrowright: curvearrowright,
    cuvee: cuvee,
    cuwed: cuwed,
    cwconint: cwconint,
    cwint: cwint,
    cylcty: cylcty,
    dArr: dArr,
    dHar: dHar,
    dagger: dagger,
    daleth: daleth,
    darr: darr,
    dash: dash,
    dashv: dashv,
    dbkarow: dbkarow,
    dblac: dblac,
    dcaron: dcaron,
    dcy: dcy,
    dd: dd,
    ddagger: ddagger,
    ddarr: ddarr,
    ddotseq: ddotseq,
    de: de,
    deg: deg,
    delta: delta,
    demptyv: demptyv,
    dfisht: dfisht,
    dfr: dfr,
    dharl: dharl,
    dharr: dharr,
    diam: diam,
    diamond: diamond,
    diamondsuit: diamondsuit,
    diams: diams,
    die: die,
    digamma: digamma,
    disin: disin,
    div: div$1,
    divid: divid,
    divide: divide,
    divideontimes: divideontimes,
    divonx: divonx,
    djcy: djcy,
    dlcorn: dlcorn,
    dlcrop: dlcrop,
    dollar: dollar,
    dopf: dopf,
    dot: dot,
    doteq: doteq,
    doteqdot: doteqdot,
    dotminus: dotminus,
    dotplus: dotplus,
    dotsquare: dotsquare,
    doublebarwedge: doublebarwedge,
    downarrow: downarrow,
    downdownarrows: downdownarrows,
    downharpoonleft: downharpoonleft,
    downharpoonright: downharpoonright,
    drbkarow: drbkarow,
    drcorn: drcorn,
    drcrop: drcrop,
    dscr: dscr,
    dscy: dscy,
    dsol: dsol,
    dstrok: dstrok,
    dtdot: dtdot,
    dtri: dtri,
    dtrif: dtrif,
    duarr: duarr,
    duhar: duhar,
    dwangle: dwangle,
    dzcy: dzcy,
    dzigrarr: dzigrarr,
    eDDot: eDDot,
    eDot: eDot,
    eacut: eacut,
    eacute: eacute,
    easter: easter,
    ecaron: ecaron,
    ecir: ecir,
    ecirc: ecirc,
    ecolon: ecolon,
    ecy: ecy,
    edot: edot,
    ee: ee,
    efDot: efDot,
    efr: efr,
    eg: eg,
    egrav: egrav,
    egrave: egrave,
    egs: egs,
    egsdot: egsdot,
    el: el$2,
    elinters: elinters,
    ell: ell,
    els: els,
    elsdot: elsdot,
    emacr: emacr,
    empty: empty,
    emptyset: emptyset,
    emptyv: emptyv,
    emsp13: emsp13,
    emsp14: emsp14,
    emsp: emsp,
    eng: eng,
    ensp: ensp,
    eogon: eogon,
    eopf: eopf,
    epar: epar,
    eparsl: eparsl,
    eplus: eplus,
    epsi: epsi,
    epsilon: epsilon,
    epsiv: epsiv,
    eqcirc: eqcirc,
    eqcolon: eqcolon,
    eqsim: eqsim,
    eqslantgtr: eqslantgtr,
    eqslantless: eqslantless,
    equals: equals,
    equest: equest,
    equiv: equiv,
    equivDD: equivDD,
    eqvparsl: eqvparsl,
    erDot: erDot,
    erarr: erarr,
    escr: escr,
    esdot: esdot,
    esim: esim,
    eta: eta,
    et: et,
    eth: eth,
    eum: eum,
    euml: euml,
    euro: euro,
    excl: excl,
    exist: exist,
    expectation: expectation,
    exponentiale: exponentiale,
    fallingdotseq: fallingdotseq,
    fcy: fcy,
    female: female,
    ffilig: ffilig,
    fflig: fflig,
    ffllig: ffllig,
    ffr: ffr,
    filig: filig,
    fjlig: fjlig,
    flat: flat,
    fllig: fllig,
    fltns: fltns,
    fnof: fnof,
    fopf: fopf,
    forall: forall,
    fork: fork,
    forkv: forkv,
    fpartint: fpartint,
    frac1: frac1,
    frac12: frac12,
    frac13: frac13,
    frac14: frac14,
    frac15: frac15,
    frac16: frac16,
    frac18: frac18,
    frac23: frac23,
    frac25: frac25,
    frac3: frac3,
    frac34: frac34,
    frac35: frac35,
    frac38: frac38,
    frac45: frac45,
    frac56: frac56,
    frac58: frac58,
    frac78: frac78,
    frasl: frasl,
    frown: frown,
    fscr: fscr,
    gE: gE,
    gEl: gEl,
    gacute: gacute,
    gamma: gamma,
    gammad: gammad,
    gap: gap,
    gbreve: gbreve,
    gcirc: gcirc,
    gcy: gcy,
    gdot: gdot,
    ge: ge,
    gel: gel,
    geq: geq,
    geqq: geqq,
    geqslant: geqslant,
    ges: ges,
    gescc: gescc,
    gesdot: gesdot,
    gesdoto: gesdoto,
    gesdotol: gesdotol,
    gesl: gesl,
    gesles: gesles,
    gfr: gfr,
    gg: gg,
    ggg: ggg,
    gimel: gimel,
    gjcy: gjcy,
    gl: gl,
    glE: glE,
    gla: gla,
    glj: glj,
    gnE: gnE,
    gnap: gnap,
    gnapprox: gnapprox,
    gne: gne,
    gneq: gneq,
    gneqq: gneqq,
    gnsim: gnsim,
    gopf: gopf,
    grave: grave,
    gscr: gscr,
    gsim: gsim,
    gsime: gsime,
    gsiml: gsiml,
    g: g$2,
    gt: gt,
    gtcc: gtcc,
    gtcir: gtcir,
    gtdot: gtdot,
    gtlPar: gtlPar,
    gtquest: gtquest,
    gtrapprox: gtrapprox,
    gtrarr: gtrarr,
    gtrdot: gtrdot,
    gtreqless: gtreqless,
    gtreqqless: gtreqqless,
    gtrless: gtrless,
    gtrsim: gtrsim,
    gvertneqq: gvertneqq,
    gvnE: gvnE,
    hArr: hArr,
    hairsp: hairsp,
    half: half,
    hamilt: hamilt,
    hardcy: hardcy,
    harr: harr,
    harrcir: harrcir,
    harrw: harrw,
    hbar: hbar,
    hcirc: hcirc,
    hearts: hearts,
    heartsuit: heartsuit,
    hellip: hellip,
    hercon: hercon,
    hfr: hfr,
    hksearow: hksearow,
    hkswarow: hkswarow,
    hoarr: hoarr,
    homtht: homtht,
    hookleftarrow: hookleftarrow,
    hookrightarrow: hookrightarrow,
    hopf: hopf,
    horbar: horbar,
    hscr: hscr,
    hslash: hslash,
    hstrok: hstrok,
    hybull: hybull,
    hyphen: hyphen,
    iacut: iacut,
    iacute: iacute,
    ic: ic,
    icir: icir,
    icirc: icirc,
    icy: icy,
    iecy: iecy,
    iexc: iexc,
    iexcl: iexcl,
    iff: iff,
    ifr: ifr,
    igrav: igrav,
    igrave: igrave,
    ii: ii,
    iiiint: iiiint,
    iiint: iiint,
    iinfin: iinfin,
    iiota: iiota,
    ijlig: ijlig,
    imacr: imacr,
    image: image,
    imagline: imagline,
    imagpart: imagpart,
    imath: imath,
    imof: imof,
    imped: imped,
    incare: incare,
    infin: infin,
    infintie: infintie,
    inodot: inodot,
    int: int,
    intcal: intcal,
    integers: integers,
    intercal: intercal,
    intlarhk: intlarhk,
    intprod: intprod,
    iocy: iocy,
    iogon: iogon,
    iopf: iopf,
    iota: iota,
    iprod: iprod,
    iques: iques,
    iquest: iquest,
    iscr: iscr,
    isin: isin,
    isinE: isinE,
    isindot: isindot,
    isins: isins,
    isinsv: isinsv,
    isinv: isinv,
    it: it,
    itilde: itilde,
    iukcy: iukcy,
    ium: ium,
    iuml: iuml,
    jcirc: jcirc,
    jcy: jcy,
    jfr: jfr,
    jmath: jmath,
    jopf: jopf,
    jscr: jscr,
    jsercy: jsercy,
    jukcy: jukcy,
    kappa: kappa,
    kappav: kappav,
    kcedil: kcedil,
    kcy: kcy,
    kfr: kfr,
    kgreen: kgreen,
    khcy: khcy,
    kjcy: kjcy,
    kopf: kopf,
    kscr: kscr,
    lAarr: lAarr,
    lArr: lArr,
    lAtail: lAtail,
    lBarr: lBarr,
    lE: lE,
    lEg: lEg,
    lHar: lHar,
    lacute: lacute,
    laemptyv: laemptyv,
    lagran: lagran,
    lambda: lambda,
    lang: lang,
    langd: langd,
    langle: langle,
    lap: lap,
    laqu: laqu,
    laquo: laquo,
    larr: larr,
    larrb: larrb,
    larrbfs: larrbfs,
    larrfs: larrfs,
    larrhk: larrhk,
    larrlp: larrlp,
    larrpl: larrpl,
    larrsim: larrsim,
    larrtl: larrtl,
    lat: lat,
    latail: latail,
    late: late,
    lates: lates,
    lbarr: lbarr,
    lbbrk: lbbrk,
    lbrace: lbrace,
    lbrack: lbrack,
    lbrke: lbrke,
    lbrksld: lbrksld,
    lbrkslu: lbrkslu,
    lcaron: lcaron,
    lcedil: lcedil,
    lceil: lceil,
    lcub: lcub,
    lcy: lcy,
    ldca: ldca,
    ldquo: ldquo,
    ldquor: ldquor,
    ldrdhar: ldrdhar,
    ldrushar: ldrushar,
    ldsh: ldsh,
    le: le,
    leftarrow: leftarrow,
    leftarrowtail: leftarrowtail,
    leftharpoondown: leftharpoondown,
    leftharpoonup: leftharpoonup,
    leftleftarrows: leftleftarrows,
    leftrightarrow: leftrightarrow,
    leftrightarrows: leftrightarrows,
    leftrightharpoons: leftrightharpoons,
    leftrightsquigarrow: leftrightsquigarrow,
    leftthreetimes: leftthreetimes,
    leg: leg,
    leq: leq,
    leqq: leqq,
    leqslant: leqslant,
    les: les,
    lescc: lescc,
    lesdot: lesdot,
    lesdoto: lesdoto,
    lesdotor: lesdotor,
    lesg: lesg,
    lesges: lesges,
    lessapprox: lessapprox,
    lessdot: lessdot,
    lesseqgtr: lesseqgtr,
    lesseqqgtr: lesseqqgtr,
    lessgtr: lessgtr,
    lesssim: lesssim,
    lfisht: lfisht,
    lfloor: lfloor,
    lfr: lfr,
    lg: lg,
    lgE: lgE,
    lhard: lhard,
    lharu: lharu,
    lharul: lharul,
    lhblk: lhblk,
    ljcy: ljcy,
    ll: ll,
    llarr: llarr,
    llcorner: llcorner,
    llhard: llhard,
    lltri: lltri,
    lmidot: lmidot,
    lmoust: lmoust,
    lmoustache: lmoustache,
    lnE: lnE,
    lnap: lnap,
    lnapprox: lnapprox,
    lne: lne,
    lneq: lneq,
    lneqq: lneqq,
    lnsim: lnsim,
    loang: loang,
    loarr: loarr,
    lobrk: lobrk,
    longleftarrow: longleftarrow,
    longleftrightarrow: longleftrightarrow,
    longmapsto: longmapsto,
    longrightarrow: longrightarrow,
    looparrowleft: looparrowleft,
    looparrowright: looparrowright,
    lopar: lopar,
    lopf: lopf,
    loplus: loplus,
    lotimes: lotimes,
    lowast: lowast,
    lowbar: lowbar,
    loz: loz,
    lozenge: lozenge,
    lozf: lozf,
    lpar: lpar,
    lparlt: lparlt,
    lrarr: lrarr,
    lrcorner: lrcorner,
    lrhar: lrhar,
    lrhard: lrhard,
    lrm: lrm,
    lrtri: lrtri,
    lsaquo: lsaquo,
    lscr: lscr,
    lsh: lsh,
    lsim: lsim,
    lsime: lsime,
    lsimg: lsimg,
    lsqb: lsqb,
    lsquo: lsquo,
    lsquor: lsquor,
    lstrok: lstrok,
    l: l$2,
    lt: lt,
    ltcc: ltcc,
    ltcir: ltcir,
    ltdot: ltdot,
    lthree: lthree,
    ltimes: ltimes,
    ltlarr: ltlarr,
    ltquest: ltquest,
    ltrPar: ltrPar,
    ltri: ltri,
    ltrie: ltrie,
    ltrif: ltrif,
    lurdshar: lurdshar,
    luruhar: luruhar,
    lvertneqq: lvertneqq,
    lvnE: lvnE,
    mDDot: mDDot,
    mac: mac,
    macr: macr,
    male: male,
    malt: malt,
    maltese: maltese,
    map: map,
    mapsto: mapsto,
    mapstodown: mapstodown,
    mapstoleft: mapstoleft,
    mapstoup: mapstoup,
    marker: marker,
    mcomma: mcomma,
    mcy: mcy,
    mdash: mdash,
    measuredangle: measuredangle,
    mfr: mfr,
    mho: mho,
    micr: micr,
    micro: micro,
    mid: mid,
    midast: midast,
    midcir: midcir,
    middo: middo,
    middot: middot,
    minus: minus,
    minusb: minusb,
    minusd: minusd,
    minusdu: minusdu,
    mlcp: mlcp,
    mldr: mldr,
    mnplus: mnplus,
    models: models,
    mopf: mopf,
    mp: mp,
    mscr: mscr,
    mstpos: mstpos,
    mu: mu,
    multimap: multimap,
    mumap: mumap,
    nGg: nGg,
    nGt: nGt,
    nGtv: nGtv,
    nLeftarrow: nLeftarrow,
    nLeftrightarrow: nLeftrightarrow,
    nLl: nLl,
    nLt: nLt,
    nLtv: nLtv,
    nRightarrow: nRightarrow,
    nVDash: nVDash,
    nVdash: nVdash,
    nabla: nabla,
    nacute: nacute,
    nang: nang,
    nap: nap,
    napE: napE,
    napid: napid,
    napos: napos,
    napprox: napprox,
    natur: natur,
    natural: natural,
    naturals: naturals,
    nbs: nbs,
    nbsp: nbsp,
    nbump: nbump,
    nbumpe: nbumpe,
    ncap: ncap,
    ncaron: ncaron,
    ncedil: ncedil,
    ncong: ncong,
    ncongdot: ncongdot,
    ncup: ncup,
    ncy: ncy,
    ndash: ndash,
    ne: ne,
    neArr: neArr,
    nearhk: nearhk,
    nearr: nearr,
    nearrow: nearrow,
    nedot: nedot,
    nequiv: nequiv,
    nesear: nesear,
    nesim: nesim,
    nexist: nexist,
    nexists: nexists,
    nfr: nfr,
    ngE: ngE,
    nge: nge,
    ngeq: ngeq,
    ngeqq: ngeqq,
    ngeqslant: ngeqslant,
    nges: nges,
    ngsim: ngsim,
    ngt: ngt,
    ngtr: ngtr,
    nhArr: nhArr,
    nharr: nharr,
    nhpar: nhpar,
    ni: ni,
    nis: nis,
    nisd: nisd,
    niv: niv,
    njcy: njcy,
    nlArr: nlArr,
    nlE: nlE,
    nlarr: nlarr,
    nldr: nldr,
    nle: nle,
    nleftarrow: nleftarrow,
    nleftrightarrow: nleftrightarrow,
    nleq: nleq,
    nleqq: nleqq,
    nleqslant: nleqslant,
    nles: nles,
    nless: nless,
    nlsim: nlsim,
    nlt: nlt,
    nltri: nltri,
    nltrie: nltrie,
    nmid: nmid,
    nopf: nopf,
    no: no,
    not: not,
    notin: notin,
    notinE: notinE,
    notindot: notindot,
    notinva: notinva,
    notinvb: notinvb,
    notinvc: notinvc,
    notni: notni,
    notniva: notniva,
    notnivb: notnivb,
    notnivc: notnivc,
    npar: npar,
    nparallel: nparallel,
    nparsl: nparsl,
    npart: npart,
    npolint: npolint,
    npr: npr,
    nprcue: nprcue,
    npre: npre,
    nprec: nprec,
    npreceq: npreceq,
    nrArr: nrArr,
    nrarr: nrarr,
    nrarrc: nrarrc,
    nrarrw: nrarrw,
    nrightarrow: nrightarrow,
    nrtri: nrtri,
    nrtrie: nrtrie,
    nsc: nsc,
    nsccue: nsccue,
    nsce: nsce,
    nscr: nscr,
    nshortmid: nshortmid,
    nshortparallel: nshortparallel,
    nsim: nsim,
    nsime: nsime,
    nsimeq: nsimeq,
    nsmid: nsmid,
    nspar: nspar,
    nsqsube: nsqsube,
    nsqsupe: nsqsupe,
    nsub: nsub,
    nsubE: nsubE,
    nsube: nsube,
    nsubset: nsubset,
    nsubseteq: nsubseteq,
    nsubseteqq: nsubseteqq,
    nsucc: nsucc,
    nsucceq: nsucceq,
    nsup: nsup,
    nsupE: nsupE,
    nsupe: nsupe,
    nsupset: nsupset,
    nsupseteq: nsupseteq,
    nsupseteqq: nsupseteqq,
    ntgl: ntgl,
    ntild: ntild,
    ntilde: ntilde,
    ntlg: ntlg,
    ntriangleleft: ntriangleleft,
    ntrianglelefteq: ntrianglelefteq,
    ntriangleright: ntriangleright,
    ntrianglerighteq: ntrianglerighteq,
    nu: nu,
    num: num,
    numero: numero,
    numsp: numsp,
    nvDash: nvDash,
    nvHarr: nvHarr,
    nvap: nvap,
    nvdash: nvdash,
    nvge: nvge,
    nvgt: nvgt,
    nvinfin: nvinfin,
    nvlArr: nvlArr,
    nvle: nvle,
    nvlt: nvlt,
    nvltrie: nvltrie,
    nvrArr: nvrArr,
    nvrtrie: nvrtrie,
    nvsim: nvsim,
    nwArr: nwArr,
    nwarhk: nwarhk,
    nwarr: nwarr,
    nwarrow: nwarrow,
    nwnear: nwnear,
    oS: oS,
    oacut: oacut,
    oacute: oacute,
    oast: oast,
    ocir: ocir,
    ocirc: ocirc,
    ocy: ocy,
    odash: odash,
    odblac: odblac,
    odiv: odiv,
    odot: odot,
    odsold: odsold,
    oelig: oelig,
    ofcir: ofcir,
    ofr: ofr,
    ogon: ogon,
    ograv: ograv,
    ograve: ograve,
    ogt: ogt,
    ohbar: ohbar,
    ohm: ohm,
    oint: oint,
    olarr: olarr,
    olcir: olcir,
    olcross: olcross,
    oline: oline,
    olt: olt,
    omacr: omacr,
    omega: omega,
    omicron: omicron,
    omid: omid,
    ominus: ominus,
    oopf: oopf,
    opar: opar,
    operp: operp,
    oplus: oplus,
    or: or,
    orarr: orarr,
    ord: ord,
    order: order,
    orderof: orderof,
    ordf: ordf,
    ordm: ordm,
    origof: origof,
    oror: oror,
    orslope: orslope,
    orv: orv,
    oscr: oscr,
    oslas: oslas,
    oslash: oslash,
    osol: osol,
    otild: otild,
    otilde: otilde,
    otimes: otimes,
    otimesas: otimesas,
    oum: oum,
    ouml: ouml,
    ovbar: ovbar,
    par: par,
    para: para,
    parallel: parallel,
    parsim: parsim,
    parsl: parsl,
    part: part,
    pcy: pcy,
    percnt: percnt,
    period: period,
    permil: permil,
    perp: perp,
    pertenk: pertenk,
    pfr: pfr,
    phi: phi,
    phiv: phiv,
    phmmat: phmmat,
    phone: phone,
    pi: pi,
    pitchfork: pitchfork,
    piv: piv,
    planck: planck,
    planckh: planckh,
    plankv: plankv,
    plus: plus,
    plusacir: plusacir,
    plusb: plusb,
    pluscir: pluscir,
    plusdo: plusdo,
    plusdu: plusdu,
    pluse: pluse,
    plusm: plusm,
    plusmn: plusmn,
    plussim: plussim,
    plustwo: plustwo,
    pm: pm,
    pointint: pointint,
    popf: popf,
    poun: poun,
    pound: pound,
    pr: pr,
    prE: prE,
    prap: prap,
    prcue: prcue,
    pre: pre,
    prec: prec,
    precapprox: precapprox,
    preccurlyeq: preccurlyeq,
    preceq: preceq,
    precnapprox: precnapprox,
    precneqq: precneqq,
    precnsim: precnsim,
    precsim: precsim,
    prime: prime,
    primes: primes,
    prnE: prnE,
    prnap: prnap,
    prnsim: prnsim,
    prod: prod,
    profalar: profalar,
    profline: profline,
    profsurf: profsurf,
    prop: prop,
    propto: propto,
    prsim: prsim,
    prurel: prurel,
    pscr: pscr,
    psi: psi,
    puncsp: puncsp,
    qfr: qfr,
    qint: qint,
    qopf: qopf,
    qprime: qprime,
    qscr: qscr,
    quaternions: quaternions,
    quatint: quatint,
    quest: quest,
    questeq: questeq,
    quo: quo,
    quot: quot,
    rAarr: rAarr,
    rArr: rArr,
    rAtail: rAtail,
    rBarr: rBarr,
    rHar: rHar,
    race: race,
    racute: racute,
    radic: radic,
    raemptyv: raemptyv,
    rang: rang,
    rangd: rangd,
    range: range,
    rangle: rangle,
    raqu: raqu,
    raquo: raquo,
    rarr: rarr,
    rarrap: rarrap,
    rarrb: rarrb,
    rarrbfs: rarrbfs,
    rarrc: rarrc,
    rarrfs: rarrfs,
    rarrhk: rarrhk,
    rarrlp: rarrlp,
    rarrpl: rarrpl,
    rarrsim: rarrsim,
    rarrtl: rarrtl,
    rarrw: rarrw,
    ratail: ratail,
    ratio: ratio,
    rationals: rationals,
    rbarr: rbarr,
    rbbrk: rbbrk,
    rbrace: rbrace,
    rbrack: rbrack,
    rbrke: rbrke,
    rbrksld: rbrksld,
    rbrkslu: rbrkslu,
    rcaron: rcaron,
    rcedil: rcedil,
    rceil: rceil,
    rcub: rcub,
    rcy: rcy,
    rdca: rdca,
    rdldhar: rdldhar,
    rdquo: rdquo,
    rdquor: rdquor,
    rdsh: rdsh,
    real: real,
    realine: realine,
    realpart: realpart,
    reals: reals,
    rect: rect,
    re: re,
    reg: reg,
    rfisht: rfisht,
    rfloor: rfloor,
    rfr: rfr,
    rhard: rhard,
    rharu: rharu,
    rharul: rharul,
    rho: rho,
    rhov: rhov,
    rightarrow: rightarrow,
    rightarrowtail: rightarrowtail,
    rightharpoondown: rightharpoondown,
    rightharpoonup: rightharpoonup,
    rightleftarrows: rightleftarrows,
    rightleftharpoons: rightleftharpoons,
    rightrightarrows: rightrightarrows,
    rightsquigarrow: rightsquigarrow,
    rightthreetimes: rightthreetimes,
    ring: ring,
    risingdotseq: risingdotseq,
    rlarr: rlarr,
    rlhar: rlhar,
    rlm: rlm,
    rmoust: rmoust,
    rmoustache: rmoustache,
    rnmid: rnmid,
    roang: roang,
    roarr: roarr,
    robrk: robrk,
    ropar: ropar,
    ropf: ropf,
    roplus: roplus,
    rotimes: rotimes,
    rpar: rpar,
    rpargt: rpargt,
    rppolint: rppolint,
    rrarr: rrarr,
    rsaquo: rsaquo,
    rscr: rscr,
    rsh: rsh,
    rsqb: rsqb,
    rsquo: rsquo,
    rsquor: rsquor,
    rthree: rthree,
    rtimes: rtimes,
    rtri: rtri,
    rtrie: rtrie,
    rtrif: rtrif,
    rtriltri: rtriltri,
    ruluhar: ruluhar,
    rx: rx,
    sacute: sacute,
    sbquo: sbquo,
    sc: sc,
    scE: scE,
    scap: scap,
    scaron: scaron,
    sccue: sccue,
    sce: sce,
    scedil: scedil,
    scirc: scirc,
    scnE: scnE,
    scnap: scnap,
    scnsim: scnsim,
    scpolint: scpolint,
    scsim: scsim,
    scy: scy,
    sdot: sdot,
    sdotb: sdotb,
    sdote: sdote,
    seArr: seArr,
    searhk: searhk,
    searr: searr,
    searrow: searrow,
    sec: sec,
    sect: sect,
    semi: semi,
    seswar: seswar,
    setminus: setminus,
    setmn: setmn,
    sext: sext,
    sfr: sfr,
    sfrown: sfrown,
    sharp: sharp,
    shchcy: shchcy,
    shcy: shcy,
    shortmid: shortmid,
    shortparallel: shortparallel,
    sh: sh,
    shy: shy,
    sigma: sigma,
    sigmaf: sigmaf,
    sigmav: sigmav,
    sim: sim,
    simdot: simdot,
    sime: sime,
    simeq: simeq,
    simg: simg,
    simgE: simgE,
    siml: siml,
    simlE: simlE,
    simne: simne,
    simplus: simplus,
    simrarr: simrarr,
    slarr: slarr,
    smallsetminus: smallsetminus,
    smashp: smashp,
    smeparsl: smeparsl,
    smid: smid,
    smile: smile,
    smt: smt,
    smte: smte,
    smtes: smtes,
    softcy: softcy,
    sol: sol,
    solb: solb,
    solbar: solbar,
    sopf: sopf,
    spades: spades,
    spadesuit: spadesuit,
    spar: spar,
    sqcap: sqcap,
    sqcaps: sqcaps,
    sqcup: sqcup,
    sqcups: sqcups,
    sqsub: sqsub,
    sqsube: sqsube,
    sqsubset: sqsubset,
    sqsubseteq: sqsubseteq,
    sqsup: sqsup,
    sqsupe: sqsupe,
    sqsupset: sqsupset,
    sqsupseteq: sqsupseteq,
    squ: squ,
    square: square,
    squarf: squarf,
    squf: squf,
    srarr: srarr,
    sscr: sscr,
    ssetmn: ssetmn,
    ssmile: ssmile,
    sstarf: sstarf,
    star: star,
    starf: starf,
    straightepsilon: straightepsilon,
    straightphi: straightphi,
    strns: strns,
    sub: sub,
    subE: subE,
    subdot: subdot,
    sube: sube,
    subedot: subedot,
    submult: submult,
    subnE: subnE,
    subne: subne,
    subplus: subplus,
    subrarr: subrarr,
    subset: subset,
    subseteq: subseteq,
    subseteqq: subseteqq,
    subsetneq: subsetneq,
    subsetneqq: subsetneqq,
    subsim: subsim,
    subsub: subsub,
    subsup: subsup,
    succ: succ,
    succapprox: succapprox,
    succcurlyeq: succcurlyeq,
    succeq: succeq,
    succnapprox: succnapprox,
    succneqq: succneqq,
    succnsim: succnsim,
    succsim: succsim,
    sum: sum,
    sung: sung,
    sup: sup,
    sup1: sup1,
    sup2: sup2,
    sup3: sup3,
    supE: supE,
    supdot: supdot,
    supdsub: supdsub,
    supe: supe,
    supedot: supedot,
    suphsol: suphsol,
    suphsub: suphsub,
    suplarr: suplarr,
    supmult: supmult,
    supnE: supnE,
    supne: supne,
    supplus: supplus,
    supset: supset,
    supseteq: supseteq,
    supseteqq: supseteqq,
    supsetneq: supsetneq,
    supsetneqq: supsetneqq,
    supsim: supsim,
    supsub: supsub,
    supsup: supsup,
    swArr: swArr,
    swarhk: swarhk,
    swarr: swarr,
    swarrow: swarrow,
    swnwar: swnwar,
    szli: szli,
    szlig: szlig,
    target: target,
    tau: tau,
    tbrk: tbrk,
    tcaron: tcaron,
    tcedil: tcedil,
    tcy: tcy,
    tdot: tdot,
    telrec: telrec,
    tfr: tfr,
    there4: there4,
    therefore: therefore,
    theta: theta,
    thetasym: thetasym,
    thetav: thetav,
    thickapprox: thickapprox,
    thicksim: thicksim,
    thinsp: thinsp,
    thkap: thkap,
    thksim: thksim,
    thor: thor,
    thorn: thorn,
    tilde: tilde,
    time: time,
    times: times,
    timesb: timesb,
    timesbar: timesbar,
    timesd: timesd,
    tint: tint,
    toea: toea,
    top: top,
    topbot: topbot,
    topcir: topcir,
    topf: topf,
    topfork: topfork,
    tosa: tosa,
    tprime: tprime,
    trade: trade,
    triangle: triangle,
    triangledown: triangledown,
    triangleleft: triangleleft,
    trianglelefteq: trianglelefteq,
    triangleq: triangleq,
    triangleright: triangleright,
    trianglerighteq: trianglerighteq,
    tridot: tridot,
    trie: trie,
    triminus: triminus,
    triplus: triplus,
    trisb: trisb,
    tritime: tritime,
    trpezium: trpezium,
    tscr: tscr,
    tscy: tscy,
    tshcy: tshcy,
    tstrok: tstrok,
    twixt: twixt,
    twoheadleftarrow: twoheadleftarrow,
    twoheadrightarrow: twoheadrightarrow,
    uArr: uArr,
    uHar: uHar,
    uacut: uacut,
    uacute: uacute,
    uarr: uarr,
    ubrcy: ubrcy,
    ubreve: ubreve,
    ucir: ucir,
    ucirc: ucirc,
    ucy: ucy,
    udarr: udarr,
    udblac: udblac,
    udhar: udhar,
    ufisht: ufisht,
    ufr: ufr,
    ugrav: ugrav,
    ugrave: ugrave,
    uharl: uharl,
    uharr: uharr,
    uhblk: uhblk,
    ulcorn: ulcorn,
    ulcorner: ulcorner,
    ulcrop: ulcrop,
    ultri: ultri,
    umacr: umacr,
    um: um,
    uml: uml,
    uogon: uogon,
    uopf: uopf,
    uparrow: uparrow,
    updownarrow: updownarrow,
    upharpoonleft: upharpoonleft,
    upharpoonright: upharpoonright,
    uplus: uplus,
    upsi: upsi,
    upsih: upsih,
    upsilon: upsilon,
    upuparrows: upuparrows,
    urcorn: urcorn,
    urcorner: urcorner,
    urcrop: urcrop,
    uring: uring,
    urtri: urtri,
    uscr: uscr,
    utdot: utdot,
    utilde: utilde,
    utri: utri,
    utrif: utrif,
    uuarr: uuarr,
    uum: uum,
    uuml: uuml,
    uwangle: uwangle,
    vArr: vArr,
    vBar: vBar,
    vBarv: vBarv,
    vDash: vDash,
    vangrt: vangrt,
    varepsilon: varepsilon,
    varkappa: varkappa,
    varnothing: varnothing,
    varphi: varphi,
    varpi: varpi,
    varpropto: varpropto,
    varr: varr,
    varrho: varrho,
    varsigma: varsigma,
    varsubsetneq: varsubsetneq,
    varsubsetneqq: varsubsetneqq,
    varsupsetneq: varsupsetneq,
    varsupsetneqq: varsupsetneqq,
    vartheta: vartheta,
    vartriangleleft: vartriangleleft,
    vartriangleright: vartriangleright,
    vcy: vcy,
    vdash: vdash,
    vee: vee,
    veebar: veebar,
    veeeq: veeeq,
    vellip: vellip,
    verbar: verbar,
    vert: vert,
    vfr: vfr,
    vltri: vltri,
    vnsub: vnsub,
    vnsup: vnsup,
    vopf: vopf,
    vprop: vprop,
    vrtri: vrtri,
    vscr: vscr,
    vsubnE: vsubnE,
    vsubne: vsubne,
    vsupnE: vsupnE,
    vsupne: vsupne,
    vzigzag: vzigzag,
    wcirc: wcirc,
    wedbar: wedbar,
    wedge: wedge,
    wedgeq: wedgeq,
    weierp: weierp,
    wfr: wfr,
    wopf: wopf,
    wp: wp,
    wr: wr,
    wreath: wreath,
    wscr: wscr,
    xcap: xcap,
    xcirc: xcirc,
    xcup: xcup,
    xdtri: xdtri,
    xfr: xfr,
    xhArr: xhArr,
    xharr: xharr,
    xi: xi,
    xlArr: xlArr,
    xlarr: xlarr,
    xmap: xmap,
    xnis: xnis,
    xodot: xodot,
    xopf: xopf,
    xoplus: xoplus,
    xotime: xotime,
    xrArr: xrArr,
    xrarr: xrarr,
    xscr: xscr,
    xsqcup: xsqcup,
    xuplus: xuplus,
    xutri: xutri,
    xvee: xvee,
    xwedge: xwedge,
    yacut: yacut,
    yacute: yacute,
    yacy: yacy,
    ycirc: ycirc,
    ycy: ycy,
    ye: ye,
    yen: yen,
    yfr: yfr,
    yicy: yicy,
    yopf: yopf,
    yscr: yscr,
    yucy: yucy,
    yum: yum,
    yuml: yuml,
    zacute: zacute,
    zcaron: zcaron,
    zcy: zcy,
    zdot: zdot,
    zeetrf: zeetrf,
    zeta: zeta,
    zfr: zfr,
    zhcy: zhcy,
    zigrarr: zigrarr,
    zopf: zopf,
    zscr: zscr,
    zwj: zwj,
    zwnj: zwnj,
    'default': index
});
var characterEntities = getCjsExportFromNamespace(characterEntities$1);
var decodeEntity_1 = decodeEntity;
var own$2 = {}.hasOwnProperty;
function decodeEntity(characters) {
    return own$2.call(characterEntities, characters) ? characterEntities[characters] : false;
}
var legacy = getCjsExportFromNamespace(characterEntitiesLegacy);
var invalid = getCjsExportFromNamespace(characterReferenceInvalid);
var parseEntities_1 = parseEntities;
var own$1 = {}.hasOwnProperty;
var fromCharCode = String.fromCharCode;
var noop = Function.prototype;
// Default settings.
var defaults = {
    warning: null,
    reference: null,
    text: null,
    warningContext: null,
    referenceContext: null,
    textContext: null,
    position: {},
    additional: null,
    attribute: false,
    nonTerminated: true
};
// Characters.
var tab = 9; // '\t'
var lineFeed = 10; // '\n'
var formFeed = 12; // '\f'
var space = 32; // ' '
var ampersand = 38; // '&'
var semicolon = 59; // ';'
var lessThan = 60; // '<'
var equalsTo = 61; // '='
var numberSign = 35; // '#'
var uppercaseX = 88; // 'X'
var lowercaseX = 120; // 'x'
var replacementCharacter = 65533; // '�'
// Reference types.
var name = 'named';
var hexa = 'hexadecimal';
var deci = 'decimal';
// Map of bases.
var bases = {};
bases[hexa] = 16;
bases[deci] = 10;
// Map of types to tests.
// Each type of character reference accepts different characters.
// This test is used to detect whether a reference has ended (as the semicolon
// is not strictly needed).
var tests = {};
tests[name] = isAlphanumerical;
tests[deci] = isDecimal;
tests[hexa] = isHexadecimal;
// Warning types.
var namedNotTerminated = 1;
var numericNotTerminated = 2;
var namedEmpty = 3;
var numericEmpty = 4;
var namedUnknown = 5;
var numericDisallowed = 6;
var numericProhibited = 7;
// Warning messages.
var messages = {};
messages[namedNotTerminated] = 'Named character references must be terminated by a semicolon';
messages[numericNotTerminated] = 'Numeric character references must be terminated by a semicolon';
messages[namedEmpty] = 'Named character references cannot be empty';
messages[numericEmpty] = 'Numeric character references cannot be empty';
messages[namedUnknown] = 'Named character references must be known';
messages[numericDisallowed] = 'Numeric character references cannot be disallowed';
messages[numericProhibited] = 'Numeric character references cannot be outside the permissible Unicode range';
// Wrap to ensure clean parameters are given to `parse`.
function parseEntities(value, options) {
    var settings = {};
    var option;
    var key;
    if (!options) options = {};
    for(key in defaults){
        option = options[key];
        settings[key] = option === null || option === undefined ? defaults[key] : option;
    }
    if (settings.position.indent || settings.position.start) {
        settings.indent = settings.position.indent || [];
        settings.position = settings.position.start;
    }
    return parse(value, settings);
}
// Parse entities.
// eslint-disable-next-line complexity
function parse(value, settings) {
    var additional = settings.additional;
    var nonTerminated = settings.nonTerminated;
    var handleText = settings.text;
    var handleReference = settings.reference;
    var handleWarning = settings.warning;
    var textContext = settings.textContext;
    var referenceContext = settings.referenceContext;
    var warningContext = settings.warningContext;
    var pos = settings.position;
    var indent = settings.indent || [];
    var length = value.length;
    var index = 0;
    var lines = -1;
    var column = pos.column || 1;
    var line = pos.line || 1;
    var queue = '';
    var result = [];
    var entityCharacters;
    var namedEntity;
    var terminated;
    var characters;
    var character;
    var reference;
    var following;
    var warning;
    var reason;
    var output;
    var entity;
    var begin;
    var start;
    var type;
    var test;
    var prev;
    var next;
    var diff;
    var end;
    if (typeof additional === 'string') additional = additional.charCodeAt(0);
    // Cache the current point.
    prev = now();
    // Wrap `handleWarning`.
    warning = handleWarning ? parseError : noop;
    // Ensure the algorithm walks over the first character and the end
    // (inclusive).
    index--;
    length++;
    while(++index < length){
        // If the previous character was a newline.
        if (character === lineFeed) column = indent[lines] || 1;
        character = value.charCodeAt(index);
        if (character === ampersand) {
            following = value.charCodeAt(index + 1);
            // The behaviour depends on the identity of the next character.
            if (following === tab || following === lineFeed || following === formFeed || following === space || following === ampersand || following === lessThan || following !== following || additional && following === additional) {
                // Not a character reference.
                // No characters are consumed, and nothing is returned.
                // This is not an error, either.
                queue += fromCharCode(character);
                column++;
                continue;
            }
            start = index + 1;
            begin = start;
            end = start;
            if (following === numberSign) {
                // Numerical entity.
                end = ++begin;
                // The behaviour further depends on the next character.
                following = value.charCodeAt(end);
                if (following === uppercaseX || following === lowercaseX) {
                    // ASCII hex digits.
                    type = hexa;
                    end = ++begin;
                } else // ASCII digits.
                type = deci;
            } else // Named entity.
            type = name;
            entityCharacters = '';
            entity = '';
            characters = '';
            test = tests[type];
            end--;
            while(++end < length){
                following = value.charCodeAt(end);
                if (!test(following)) break;
                characters += fromCharCode(following);
                // Check if we can match a legacy named reference.
                // If so, we cache that as the last viable named reference.
                // This ensures we do not need to walk backwards later.
                if (type === name && own$1.call(legacy, characters)) {
                    entityCharacters = characters;
                    entity = legacy[characters];
                }
            }
            terminated = value.charCodeAt(end) === semicolon;
            if (terminated) {
                end++;
                namedEntity = type === name ? decodeEntity_1(characters) : false;
                if (namedEntity) {
                    entityCharacters = characters;
                    entity = namedEntity;
                }
            }
            diff = 1 + end - start;
            if (!terminated && !nonTerminated) ;
            else if (!characters) // An empty (possible) entity is valid, unless it’s numeric (thus an
            // ampersand followed by an octothorp).
            {
                if (type !== name) warning(numericEmpty, diff);
            } else if (type === name) {
                // An ampersand followed by anything unknown, and not terminated, is
                // invalid.
                if (terminated && !entity) warning(namedUnknown, 1);
                else {
                    // If theres something after an entity name which is not known, cap
                    // the reference.
                    if (entityCharacters !== characters) {
                        end = begin + entityCharacters.length;
                        diff = 1 + end - begin;
                        terminated = false;
                    }
                    // If the reference is not terminated, warn.
                    if (!terminated) {
                        reason = entityCharacters ? namedNotTerminated : namedEmpty;
                        if (settings.attribute) {
                            following = value.charCodeAt(end);
                            if (following === equalsTo) {
                                warning(reason, diff);
                                entity = null;
                            } else if (isAlphanumerical(following)) entity = null;
                            else warning(reason, diff);
                        } else warning(reason, diff);
                    }
                }
                reference = entity;
            } else {
                if (!terminated) // All non-terminated numeric entities are not rendered, and trigger a
                // warning.
                warning(numericNotTerminated, diff);
                // When terminated and number, parse as either hexadecimal or decimal.
                reference = parseInt(characters, bases[type]);
                // Trigger a warning when the parsed number is prohibited, and replace
                // with replacement character.
                if (prohibited(reference)) {
                    warning(numericProhibited, diff);
                    reference = fromCharCode(replacementCharacter);
                } else if (reference in invalid) {
                    // Trigger a warning when the parsed number is disallowed, and replace
                    // by an alternative.
                    warning(numericDisallowed, diff);
                    reference = invalid[reference];
                } else {
                    // Parse the number.
                    output = '';
                    // Trigger a warning when the parsed number should not be used.
                    if (disallowed(reference)) warning(numericDisallowed, diff);
                    // Stringify the number.
                    if (reference > 0xffff) {
                        reference -= 0x10000;
                        output += fromCharCode(reference >>> 10 | 0xd800);
                        reference = 0xdc00 | reference & 0x3ff;
                    }
                    reference = output + fromCharCode(reference);
                }
            }
            // Found it!
            // First eat the queued characters as normal text, then eat an entity.
            if (reference) {
                flush();
                prev = now();
                index = end - 1;
                column += end - start + 1;
                result.push(reference);
                next = now();
                next.offset++;
                if (handleReference) handleReference.call(referenceContext, reference, {
                    start: prev,
                    end: next
                }, value.slice(start - 1, end));
                prev = next;
            } else {
                // If we could not find a reference, queue the checked characters (as
                // normal characters), and move the pointer to their end.
                // This is possible because we can be certain neither newlines nor
                // ampersands are included.
                characters = value.slice(start - 1, end);
                queue += characters;
                column += characters.length;
                index = end - 1;
            }
        } else {
            // Handle anything other than an ampersand, including newlines and EOF.
            if (character === 10 // Line feed
            ) {
                line++;
                lines++;
                column = 0;
            }
            if (character === character) {
                queue += fromCharCode(character);
                column++;
            } else flush();
        }
    }
    // Return the reduced nodes.
    return result.join('');
    // Get current position.
    function now() {
        return {
            line: line,
            column: column,
            offset: index + (pos.offset || 0)
        };
    }
    // “Throw” a parse-error: a warning.
    function parseError(code, offset) {
        var position = now();
        position.column += offset;
        position.offset += offset;
        handleWarning.call(warningContext, messages[code], position, code);
    }
    // Flush `queue` (normal text).
    // Macro invoked before each entity and at the end of `value`.
    // Does nothing when `queue` is empty.
    function flush() {
        if (queue) {
            result.push(queue);
            if (handleText) handleText.call(textContext, queue, {
                start: prev,
                end: now()
            });
            queue = '';
        }
    }
}
// Check if `character` is outside the permissible unicode range.
function prohibited(code) {
    return code >= 0xd800 && code <= 0xdfff || code > 0x10ffff;
}
// Check if `character` is disallowed.
function disallowed(code) {
    return code >= 0x0001 && code <= 0x0008 || code === 0x000b || code >= 0x000d && code <= 0x001f || code >= 0x007f && code <= 0x009f || code >= 0xfdd0 && code <= 0xfdef || (code & 0xffff) === 0xffff || (code & 0xffff) === 0xfffe;
}
var prismCore = createCommonjsModule(function(module1) {
    /// <reference lib="WebWorker"/>
    var _self = typeof window !== 'undefined' ? window // if in browser
     : typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope ? self // if in worker
     : {} // if in node js
    ;
    /**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */ var Prism = function(_self) {
        // Private helper vars
        var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
        var uniqueId = 0;
        // The grammar object for plaintext
        var plainTextGrammar = {};
        var _ = {
            /**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ manual: _self.Prism && _self.Prism.manual,
            /**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
            /**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */ util: {
                encode: function encode(tokens) {
                    if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                    else if (Array.isArray(tokens)) return tokens.map(encode);
                    else return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
                },
                /**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */ type: function(o) {
                    return Object.prototype.toString.call(o).slice(8, -1);
                },
                /**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */ objId: function(obj) {
                    if (!obj['__id']) Object.defineProperty(obj, '__id', {
                        value: ++uniqueId
                    });
                    return obj['__id'];
                },
                /**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */ clone: function deepClone(o, visited) {
                    visited = visited || {};
                    var clone;
                    var id;
                    switch(_.util.type(o)){
                        case 'Object':
                            id = _.util.objId(o);
                            if (visited[id]) return visited[id];
                            clone = /** @type {Record<string, any>} */ {};
                            visited[id] = clone;
                            for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                            return /** @type {any} */ clone;
                        case 'Array':
                            id = _.util.objId(o);
                            if (visited[id]) return visited[id];
                            clone = [];
                            visited[id] = clone;
                            /** @type {any} */ o.forEach(function(v, i) {
                                clone[i] = deepClone(v, visited);
                            });
                            return /** @type {any} */ clone;
                        default:
                            return o;
                    }
                },
                /**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */ getLanguage: function(element) {
                    while(element){
                        var m = lang.exec(element.className);
                        if (m) return m[1].toLowerCase();
                        element = element.parentElement;
                    }
                    return 'none';
                },
                /**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */ setLanguage: function(element, language) {
                    // remove all `language-xxxx` classes
                    // (this might leave behind a leading space)
                    element.className = element.className.replace(RegExp(lang, 'gi'), '');
                    // add the new `language-xxxx` class
                    // (using `classList` will automatically clean up spaces for us)
                    element.classList.add('language-' + language);
                },
                /**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */ currentScript: function() {
                    if (typeof document === 'undefined') return null;
                    if ('currentScript' in document && true /* hack to trip TS' flow analysis */ ) return /** @type {any} */ document.currentScript;
                    // IE11 workaround
                    // we'll get the src of the current script by parsing IE11's error stack trace
                    // this will not work for inline scripts
                    try {
                        throw new Error();
                    } catch (err) {
                        // Get file src url from stack. Specifically works with the format of stack traces in IE.
                        // A stack will look like this:
                        //
                        // Error
                        //    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
                        //    at Global code (http://localhost/components/prism-core.js:606:1)
                        var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
                        if (src) {
                            var scripts = document.getElementsByTagName('script');
                            for(var i in scripts){
                                if (scripts[i].src == src) return scripts[i];
                            }
                        }
                        return null;
                    }
                },
                /**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */ isActive: function(element, className, defaultActivation) {
                    var no = 'no-' + className;
                    while(element){
                        var classList = element.classList;
                        if (classList.contains(className)) return true;
                        if (classList.contains(no)) return false;
                        element = element.parentElement;
                    }
                    return !!defaultActivation;
                }
            },
            /**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ languages: {
                /**
			 * The grammar for plain, unformatted text.
			 */ plain: plainTextGrammar,
                plaintext: plainTextGrammar,
                text: plainTextGrammar,
                txt: plainTextGrammar,
                /**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */ extend: function(id, redef) {
                    var lang = _.util.clone(_.languages[id]);
                    for(var key in redef)lang[key] = redef[key];
                    return lang;
                },
                /**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */ insertBefore: function(inside, before, insert, root) {
                    root = root || /** @type {any} */ _.languages;
                    var grammar = root[inside];
                    /** @type {Grammar} */ var ret = {};
                    for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                        if (token == before) {
                            for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                        }
                        // Do not insert token which also occur in insert. See #1525
                        if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                    }
                    var old = root[inside];
                    root[inside] = ret;
                    // Update references in other language definitions
                    _.languages.DFS(_.languages, function(key, value) {
                        if (value === old && key != inside) this[key] = ret;
                    });
                    return ret;
                },
                // Traverse a language definition with Depth First Search
                DFS: function DFS(o, callback, type, visited) {
                    visited = visited || {};
                    var objId = _.util.objId;
                    for(var i in o)if (o.hasOwnProperty(i)) {
                        callback.call(o, i, o[i], type || i);
                        var property = o[i];
                        var propertyType = _.util.type(property);
                        if (propertyType === 'Object' && !visited[objId(property)]) {
                            visited[objId(property)] = true;
                            DFS(property, callback, null, visited);
                        } else if (propertyType === 'Array' && !visited[objId(property)]) {
                            visited[objId(property)] = true;
                            DFS(property, callback, i, visited);
                        }
                    }
                }
            },
            plugins: {},
            /**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */ highlightAll: function(async, callback) {
                _.highlightAllUnder(document, async, callback);
            },
            /**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */ highlightAllUnder: function(container, async, callback) {
                var env = {
                    callback: callback,
                    container: container,
                    selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
                };
                _.hooks.run('before-highlightall', env);
                env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
                _.hooks.run('before-all-elements-highlight', env);
                for(var i = 0, element; element = env.elements[i++];)_.highlightElement(element, async === true, env.callback);
            },
            /**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */ highlightElement: function(element, async, callback) {
                // Find language
                var language = _.util.getLanguage(element);
                var grammar = _.languages[language];
                // Set language on the element, if not present
                _.util.setLanguage(element, language);
                // Set language on the parent, for styling
                var parent = element.parentElement;
                if (parent && parent.nodeName.toLowerCase() === 'pre') _.util.setLanguage(parent, language);
                var code = element.textContent;
                var env = {
                    element: element,
                    language: language,
                    grammar: grammar,
                    code: code
                };
                function insertHighlightedCode(highlightedCode) {
                    env.highlightedCode = highlightedCode;
                    _.hooks.run('before-insert', env);
                    env.element.innerHTML = env.highlightedCode;
                    _.hooks.run('after-highlight', env);
                    _.hooks.run('complete', env);
                    callback && callback.call(env.element);
                }
                _.hooks.run('before-sanity-check', env);
                // plugins may change/add the parent/element
                parent = env.element.parentElement;
                if (parent && parent.nodeName.toLowerCase() === 'pre' && !parent.hasAttribute('tabindex')) parent.setAttribute('tabindex', '0');
                if (!env.code) {
                    _.hooks.run('complete', env);
                    callback && callback.call(env.element);
                    return;
                }
                _.hooks.run('before-highlight', env);
                if (!env.grammar) {
                    insertHighlightedCode(_.util.encode(env.code));
                    return;
                }
                if (async && _self.Worker) {
                    var worker = new Worker(_.filename);
                    worker.onmessage = function(evt) {
                        insertHighlightedCode(evt.data);
                    };
                    worker.postMessage(JSON.stringify({
                        language: env.language,
                        code: env.code,
                        immediateClose: true
                    }));
                } else insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
            },
            /**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */ highlight: function(text, grammar, language) {
                var env = {
                    code: text,
                    grammar: grammar,
                    language: language
                };
                _.hooks.run('before-tokenize', env);
                if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
                env.tokens = _.tokenize(env.code, env.grammar);
                _.hooks.run('after-tokenize', env);
                return Token.stringify(_.util.encode(env.tokens), env.language);
            },
            /**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */ tokenize: function(text, grammar) {
                var rest = grammar.rest;
                if (rest) {
                    for(var token in rest)grammar[token] = rest[token];
                    delete grammar.rest;
                }
                var tokenList = new LinkedList();
                addAfter(tokenList, tokenList.head, text);
                matchGrammar(text, tokenList, grammar, tokenList.head, 0);
                return toArray(tokenList);
            },
            /**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ hooks: {
                all: {},
                /**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */ add: function(name, callback) {
                    var hooks = _.hooks.all;
                    hooks[name] = hooks[name] || [];
                    hooks[name].push(callback);
                },
                /**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */ run: function(name, env) {
                    var callbacks = _.hooks.all[name];
                    if (!callbacks || !callbacks.length) return;
                    for(var i = 0, callback; callback = callbacks[i++];)callback(env);
                }
            },
            Token: Token
        };
        _self.Prism = _;
        // Typescript note:
        // The following can be used to import the Token type in JSDoc:
        //
        //   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
        /**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */ function Token(type, content, alias, matchedStr) {
            /**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */ this.type = type;
            /**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */ this.content = content;
            /**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */ this.alias = alias;
            // Copy of the full string this token was created from
            this.length = (matchedStr || '').length | 0;
        }
        /**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */ /**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */ Token.stringify = function stringify(o, language) {
            if (typeof o == 'string') return o;
            if (Array.isArray(o)) {
                var s = '';
                o.forEach(function(e) {
                    s += stringify(e, language);
                });
                return s;
            }
            var env = {
                type: o.type,
                content: stringify(o.content, language),
                tag: 'span',
                classes: [
                    'token',
                    o.type
                ],
                attributes: {},
                language: language
            };
            var aliases = o.alias;
            if (aliases) {
                if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
                else env.classes.push(aliases);
            }
            _.hooks.run('wrap', env);
            var attributes = '';
            for(var name in env.attributes)attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
            return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
        };
        /**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */ function matchPattern(pattern, pos, text, lookbehind) {
            pattern.lastIndex = pos;
            var match = pattern.exec(text);
            if (match && lookbehind && match[1]) {
                // change the match to remove the text matched by the Prism lookbehind group
                var lookbehindLength = match[1].length;
                match.index += lookbehindLength;
                match[0] = match[0].slice(lookbehindLength);
            }
            return match;
        }
        /**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */ function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
            for(var token in grammar){
                if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
                var patterns = grammar[token];
                patterns = Array.isArray(patterns) ? patterns : [
                    patterns
                ];
                for(var j = 0; j < patterns.length; ++j){
                    if (rematch && rematch.cause == token + ',' + j) return;
                    var patternObj = patterns[j];
                    var inside = patternObj.inside;
                    var lookbehind = !!patternObj.lookbehind;
                    var greedy = !!patternObj.greedy;
                    var alias = patternObj.alias;
                    if (greedy && !patternObj.pattern.global) {
                        // Without the global flag, lastIndex won't work
                        var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                        patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
                    }
                    /** @type {RegExp} */ var pattern = patternObj.pattern || patternObj;
                    for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                        if (rematch && pos >= rematch.reach) break;
                        var str = currentNode.value;
                        if (tokenList.length > text.length) // Something went terribly wrong, ABORT, ABORT!
                        return;
                        if (str instanceof Token) continue;
                        var removeCount = 1; // this is the to parameter of removeBetween
                        var match;
                        if (greedy) {
                            match = matchPattern(pattern, pos, text, lookbehind);
                            if (!match || match.index >= text.length) break;
                            var from = match.index;
                            var to = match.index + match[0].length;
                            var p = pos;
                            // find the node that contains the match
                            p += currentNode.value.length;
                            while(from >= p){
                                currentNode = currentNode.next;
                                p += currentNode.value.length;
                            }
                            // adjust pos (and p)
                            p -= currentNode.value.length;
                            pos = p;
                            // the current node is a Token, then the match starts inside another Token, which is invalid
                            if (currentNode.value instanceof Token) continue;
                            // find the last node which is affected by this match
                            for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === 'string'); k = k.next){
                                removeCount++;
                                p += k.value.length;
                            }
                            removeCount--;
                            // replace with the new match
                            str = text.slice(pos, p);
                            match.index -= pos;
                        } else {
                            match = matchPattern(pattern, 0, str, lookbehind);
                            if (!match) continue;
                        }
                        // eslint-disable-next-line no-redeclare
                        var from = match.index;
                        var matchStr = match[0];
                        var before = str.slice(0, from);
                        var after = str.slice(from + matchStr.length);
                        var reach = pos + str.length;
                        if (rematch && reach > rematch.reach) rematch.reach = reach;
                        var removeFrom = currentNode.prev;
                        if (before) {
                            removeFrom = addAfter(tokenList, removeFrom, before);
                            pos += before.length;
                        }
                        removeRange(tokenList, removeFrom, removeCount);
                        var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                        currentNode = addAfter(tokenList, removeFrom, wrapped);
                        if (after) addAfter(tokenList, currentNode, after);
                        if (removeCount > 1) {
                            // at least one Token object was removed, so we have to do some rematching
                            // this can only happen if the current pattern is greedy
                            /** @type {RematchOptions} */ var nestedRematch = {
                                cause: token + ',' + j,
                                reach: reach
                            };
                            matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                            // the reach might have been extended because of the rematching
                            if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                        }
                    }
                }
            }
        }
        /**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */ /**
	 * @template T
	 * @private
	 */ function LinkedList() {
            /** @type {LinkedListNode<T>} */ var head = {
                value: null,
                prev: null,
                next: null
            };
            /** @type {LinkedListNode<T>} */ var tail = {
                value: null,
                prev: head,
                next: null
            };
            head.next = tail;
            /** @type {LinkedListNode<T>} */ this.head = head;
            /** @type {LinkedListNode<T>} */ this.tail = tail;
            this.length = 0;
        }
        /**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */ function addAfter(list, node, value) {
            // assumes that node != list.tail && values.length >= 0
            var next = node.next;
            var newNode = {
                value: value,
                prev: node,
                next: next
            };
            node.next = newNode;
            next.prev = newNode;
            list.length++;
            return newNode;
        }
        /**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */ function removeRange(list, node, count) {
            var next = node.next;
            for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
            node.next = next;
            next.prev = node;
            list.length -= i;
        }
        /**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */ function toArray(list) {
            var array = [];
            var node = list.head.next;
            while(node !== list.tail){
                array.push(node.value);
                node = node.next;
            }
            return array;
        }
        if (!_self.document) {
            if (!_self.addEventListener) // in Node.js
            return _;
            if (!_.disableWorkerMessageHandler) // In worker
            _self.addEventListener('message', function(evt) {
                var message = JSON.parse(evt.data);
                var lang = message.language;
                var code = message.code;
                var immediateClose = message.immediateClose;
                _self.postMessage(_.highlight(code, _.languages[lang], lang));
                if (immediateClose) _self.close();
            }, false);
            return _;
        }
        // Get current script and highlight
        var script = _.util.currentScript();
        if (script) {
            _.filename = script.src;
            if (script.hasAttribute('data-manual')) _.manual = true;
        }
        function highlightAutomaticallyCallback() {
            if (!_.manual) _.highlightAll();
        }
        if (!_.manual) {
            // If the document state is "loading", then we'll use DOMContentLoaded.
            // If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
            // DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
            // might take longer one animation frame to execute which can create a race condition where only some plugins have
            // been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
            // See https://github.com/PrismJS/prism/issues/2102
            var readyState = document.readyState;
            if (readyState === 'loading' || readyState === 'interactive' && script && script.defer) document.addEventListener('DOMContentLoaded', highlightAutomaticallyCallback);
            else if (window.requestAnimationFrame) window.requestAnimationFrame(highlightAutomaticallyCallback);
            else window.setTimeout(highlightAutomaticallyCallback, 16);
        }
        return _;
    }(_self);
    if (module1.exports) module1.exports = Prism;
    // hack for components to work correctly in node.js
    if (typeof commonjsGlobal !== 'undefined') commonjsGlobal.Prism = Prism;
// some additional documentation/types
/**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */ /**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */ /**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */ /**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */ });
var markup_1 = markup;
markup.displayName = 'markup';
markup.aliases = [
    'html',
    'mathml',
    'svg',
    'xml',
    'ssml',
    'atom',
    'rss'
];
function markup(Prism) {
    Prism.languages.markup = {
        comment: {
            pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
            greedy: true
        },
        prolog: {
            pattern: /<\?[\s\S]+?\?>/,
            greedy: true
        },
        doctype: {
            // https://www.w3.org/TR/xml/#NT-doctypedecl
            pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
            greedy: true,
            inside: {
                'internal-subset': {
                    pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                    lookbehind: true,
                    greedy: true,
                    inside: null // see below
                },
                string: {
                    pattern: /"[^"]*"|'[^']*'/,
                    greedy: true
                },
                punctuation: /^<!|>$|[[\]]/,
                'doctype-tag': /^DOCTYPE/i,
                name: /[^\s<>'"]+/
            }
        },
        cdata: {
            pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
            greedy: true
        },
        tag: {
            pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
            greedy: true,
            inside: {
                tag: {
                    pattern: /^<\/?[^\s>\/]+/,
                    inside: {
                        punctuation: /^<\/?/,
                        namespace: /^[^\s>\/:]+:/
                    }
                },
                'special-attr': [],
                'attr-value': {
                    pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                    inside: {
                        punctuation: [
                            {
                                pattern: /^=/,
                                alias: 'attr-equals'
                            },
                            /"|'/
                        ]
                    }
                },
                punctuation: /\/?>/,
                'attr-name': {
                    pattern: /[^\s>\/]+/,
                    inside: {
                        namespace: /^[^\s>\/:]+:/
                    }
                }
            }
        },
        entity: [
            {
                pattern: /&[\da-z]{1,8};/i,
                alias: 'named-entity'
            },
            /&#x?[\da-f]{1,8};/i
        ]
    };
    Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] = Prism.languages.markup['entity'];
    Prism.languages.markup['doctype'].inside['internal-subset'].inside = Prism.languages.markup; // Plugin to make entity title show the real entity, idea by Roman Komarov
    Prism.hooks.add('wrap', function(env) {
        if (env.type === 'entity') env.attributes['title'] = env.content.value.replace(/&amp;/, '&');
    });
    Object.defineProperty(Prism.languages.markup.tag, 'addInlined', {
        /**
     * Adds an inlined language to markup.
     *
     * An example of an inlined language is CSS with `<style>` tags.
     *
     * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addInlined('style', 'css');
     */ value: function addInlined(tagName, lang) {
            var includedCdataInside = {};
            includedCdataInside['language-' + lang] = {
                pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
                lookbehind: true,
                inside: Prism.languages[lang]
            };
            includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;
            var inside = {
                'included-cdata': {
                    pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                    inside: includedCdataInside
                }
            };
            inside['language-' + lang] = {
                pattern: /[\s\S]+/,
                inside: Prism.languages[lang]
            };
            var def = {};
            def[tagName] = {
                pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                    return tagName;
                }), 'i'),
                lookbehind: true,
                greedy: true,
                inside: inside
            };
            Prism.languages.insertBefore('markup', 'cdata', def);
        }
    });
    Object.defineProperty(Prism.languages.markup.tag, 'addAttribute', {
        /**
     * Adds an pattern to highlight languages embedded in HTML attributes.
     *
     * An example of an inlined language is CSS with `style` attributes.
     *
     * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addAttribute('style', 'css');
     */ value: function(attrName, lang) {
            Prism.languages.markup.tag.inside['special-attr'].push({
                pattern: RegExp(/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, 'i'),
                lookbehind: true,
                inside: {
                    'attr-name': /^[^\s=]+/,
                    'attr-value': {
                        pattern: /=[\s\S]+/,
                        inside: {
                            value: {
                                pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                                lookbehind: true,
                                alias: [
                                    lang,
                                    'language-' + lang
                                ],
                                inside: Prism.languages[lang]
                            },
                            punctuation: [
                                {
                                    pattern: /^=/,
                                    alias: 'attr-equals'
                                },
                                /"|'/
                            ]
                        }
                    }
                }
            });
        }
    });
    Prism.languages.html = Prism.languages.markup;
    Prism.languages.mathml = Prism.languages.markup;
    Prism.languages.svg = Prism.languages.markup;
    Prism.languages.xml = Prism.languages.extend('markup', {});
    Prism.languages.ssml = Prism.languages.xml;
    Prism.languages.atom = Prism.languages.xml;
    Prism.languages.rss = Prism.languages.xml;
}
var css_1 = css$1;
css$1.displayName = 'css';
css$1.aliases = [];
function css$1(Prism) {
    (function(Prism) {
        var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
        Prism.languages.css = {
            comment: /\/\*[\s\S]*?\*\//,
            atrule: {
                pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,
                inside: {
                    rule: /^@[\w-]+/,
                    'selector-function-argument': {
                        pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                        lookbehind: true,
                        alias: 'selector'
                    },
                    keyword: {
                        pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                        lookbehind: true
                    } // See rest below
                }
            },
            url: {
                // https://drafts.csswg.org/css-values-3/#urls
                pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
                greedy: true,
                inside: {
                    function: /^url/i,
                    punctuation: /^\(|\)$/,
                    string: {
                        pattern: RegExp('^' + string.source + '$'),
                        alias: 'url'
                    }
                }
            },
            selector: {
                pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
                lookbehind: true
            },
            string: {
                pattern: string,
                greedy: true
            },
            property: {
                pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
                lookbehind: true
            },
            important: /!important\b/i,
            function: {
                pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
                lookbehind: true
            },
            punctuation: /[(){};:,]/
        };
        Prism.languages.css['atrule'].inside.rest = Prism.languages.css;
        var markup = Prism.languages.markup;
        if (markup) {
            markup.tag.addInlined('style', 'css');
            markup.tag.addAttribute('style', 'css');
        }
    })(Prism);
}
var clike_1 = clike;
clike.displayName = 'clike';
clike.aliases = [];
function clike(Prism) {
    Prism.languages.clike = {
        comment: [
            {
                pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
            greedy: true
        },
        'class-name': {
            pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
            lookbehind: true,
            inside: {
                punctuation: /[.\\]/
            }
        },
        keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
        boolean: /\b(?:false|true)\b/,
        function: /\b\w+(?=\()/,
        number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
        operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
        punctuation: /[{}[\];(),.:]/
    };
}
var javascript_1 = javascript;
javascript.displayName = 'javascript';
javascript.aliases = [
    'js'
];
function javascript(Prism) {
    Prism.languages.javascript = Prism.languages.extend('clike', {
        'class-name': [
            Prism.languages.clike['class-name'],
            {
                pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
                lookbehind: true
            }
        ],
        keyword: [
            {
                pattern: /((?:^|\})\s*)catch\b/,
                lookbehind: true
            },
            {
                pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
                lookbehind: true
            }
        ],
        // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
        function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
        number: {
            pattern: RegExp(/(^|[^\w$])/.source + '(?:' + // constant
            (/NaN|Infinity/.source + '|' + // binary integer
            /0[bB][01]+(?:_[01]+)*n?/.source + '|' + // octal integer
            /0[oO][0-7]+(?:_[0-7]+)*n?/.source + '|' + // hexadecimal integer
            /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + '|' + // decimal bigint
            /\d+(?:_\d+)*n/.source + '|' + // decimal number (integer or float) but no bigint
            /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ')' + /(?![\w$])/.source),
            lookbehind: true
        },
        operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
    });
    Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
    Prism.languages.insertBefore('javascript', 'keyword', {
        regex: {
            // eslint-disable-next-line regexp/no-dupe-characters-character-class
            pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/,
            lookbehind: true,
            greedy: true,
            inside: {
                'regex-source': {
                    pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                    lookbehind: true,
                    alias: 'language-regex',
                    inside: Prism.languages.regex
                },
                'regex-delimiter': /^\/|\/$/,
                'regex-flags': /^[a-z]+$/
            }
        },
        // This must be declared before keyword because we use "function" inside the look-forward
        'function-variable': {
            pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
            alias: 'function'
        },
        parameter: [
            {
                pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            {
                pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            {
                pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
                lookbehind: true,
                inside: Prism.languages.javascript
            },
            {
                pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
                lookbehind: true,
                inside: Prism.languages.javascript
            }
        ],
        constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
    });
    Prism.languages.insertBefore('javascript', 'string', {
        hashbang: {
            pattern: /^#!.*/,
            greedy: true,
            alias: 'comment'
        },
        'template-string': {
            pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
            greedy: true,
            inside: {
                'template-punctuation': {
                    pattern: /^`|`$/,
                    alias: 'string'
                },
                interpolation: {
                    pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                    lookbehind: true,
                    inside: {
                        'interpolation-punctuation': {
                            pattern: /^\$\{|\}$/,
                            alias: 'punctuation'
                        },
                        rest: Prism.languages.javascript
                    }
                },
                string: /[\s\S]+/
            }
        },
        'string-property': {
            pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
            lookbehind: true,
            greedy: true,
            alias: 'property'
        }
    });
    Prism.languages.insertBefore('javascript', 'operator', {
        'literal-property': {
            pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
            lookbehind: true,
            alias: 'property'
        }
    });
    if (Prism.languages.markup) {
        Prism.languages.markup.tag.addInlined('script', 'javascript'); // add attribute support for all DOM events.
        // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
        Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, 'javascript');
    }
    Prism.languages.js = Prism.languages.javascript;
}
/* global window, self */ // istanbul ignore next - Don't allow Prism to run on page load in browser or
// to start messaging from workers.
var ctx = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof commonjsGlobal === 'object' ? commonjsGlobal : {};
var restore = capture();
ctx.Prism = {
    manual: true,
    disableWorkerMessageHandler: true
};
// Load all stuff in `prism.js` itself, except for `prism-file-highlight.js`.
// The wrapped non-leaky grammars are loaded instead of Prism’s originals.
restore();
var own = {}.hasOwnProperty;
// Inherit.
function Refractor() {}
Refractor.prototype = prismCore;
// Construct.
var refract = new Refractor();
// Expose.
var core = refract;
// Create.
refract.highlight = highlight;
refract.register = register;
refract.alias = alias;
refract.registered = registered;
refract.listLanguages = listLanguages;
// Register bundled grammars.
register(markup_1);
register(css_1);
register(clike_1);
register(javascript_1);
refract.util.encode = encode;
refract.Token.stringify = stringify;
function register(grammar) {
    if (typeof grammar !== 'function' || !grammar.displayName) throw new Error('Expected `function` for `grammar`, got `' + grammar + '`');
    // Do not duplicate registrations.
    if (refract.languages[grammar.displayName] === undefined) grammar(refract);
}
function alias(name, alias) {
    var languages = refract.languages;
    var map = name;
    var key;
    var list;
    var length;
    var index;
    if (alias) {
        map = {};
        map[name] = alias;
    }
    for(key in map){
        list = map[key];
        list = typeof list === 'string' ? [
            list
        ] : list;
        length = list.length;
        index = -1;
        while(++index < length)languages[list[index]] = languages[key];
    }
}
function highlight(value, name) {
    var sup = prismCore.highlight;
    var grammar;
    if (typeof value !== 'string') throw new Error('Expected `string` for `value`, got `' + value + '`');
    // `name` is a grammar object.
    if (refract.util.type(name) === 'Object') {
        grammar = name;
        name = null;
    } else {
        if (typeof name !== 'string') throw new Error('Expected `string` for `name`, got `' + name + '`');
        if (own.call(refract.languages, name)) grammar = refract.languages[name];
        else throw new Error('Unknown language: `' + name + '` is not registered');
    }
    return sup.call(this, value, grammar, name);
}
function registered(language) {
    if (typeof language !== 'string') throw new Error('Expected `string` for `language`, got `' + language + '`');
    return own.call(refract.languages, language);
}
function listLanguages() {
    var languages = refract.languages;
    var list = [];
    var language;
    for(language in languages)if (own.call(languages, language) && typeof languages[language] === 'object') list.push(language);
    return list;
}
function stringify(value, language, parent) {
    var env;
    if (typeof value === 'string') return {
        type: 'text',
        value: value
    };
    if (refract.util.type(value) === 'Array') return stringifyAll(value, language);
    env = {
        type: value.type,
        content: refract.Token.stringify(value.content, language, parent),
        tag: 'span',
        classes: [
            'token',
            value.type
        ],
        attributes: {},
        language: language,
        parent: parent
    };
    if (value.alias) env.classes = env.classes.concat(value.alias);
    refract.hooks.run('wrap', env);
    return hastscript(env.tag + '.' + env.classes.join('.'), attributes(env.attributes), env.content);
}
function stringifyAll(values, language) {
    var result = [];
    var length = values.length;
    var index = -1;
    var value;
    while(++index < length){
        value = values[index];
        if (value !== '' && value !== null && value !== undefined) result.push(value);
    }
    index = -1;
    length = result.length;
    while(++index < length){
        value = result[index];
        result[index] = refract.Token.stringify(value, language, result);
    }
    return result;
}
function encode(tokens) {
    return tokens;
}
function attributes(attrs) {
    var key;
    for(key in attrs)attrs[key] = parseEntities_1(attrs[key]);
    return attrs;
}
function capture() {
    var defined = 'Prism' in ctx;
    /* istanbul ignore next */ var current = defined ? ctx.Prism : undefined;
    return restore;
    function restore() {
        /* istanbul ignore else - Clean leaks after Prism. */ if (defined) ctx.Prism = current;
        else delete ctx.Prism;
        defined = undefined;
        current = undefined;
    }
}
var SyntaxHighlighter = highlight$1(core, {});
SyntaxHighlighter.registerLanguage = function(_, language) {
    return core.register(language);
};
SyntaxHighlighter.alias = function(name, aliases) {
    return core.alias(name, aliases);
};
var SyntaxHighlighter$1 = SyntaxHighlighter;
var sql_1 = sql$2;
sql$2.displayName = 'sql';
sql$2.aliases = [];
function sql$2(Prism) {
    Prism.languages.sql = {
        comment: {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
            lookbehind: true
        },
        variable: [
            {
                pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
                greedy: true
            },
            /@[\w.$]+/
        ],
        string: {
            pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
            greedy: true,
            lookbehind: true
        },
        identifier: {
            pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
            greedy: true,
            lookbehind: true,
            inside: {
                punctuation: /^`|`$/
            }
        },
        function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
        // Should we highlight user defined functions too?
        keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
        boolean: /\b(?:FALSE|NULL|TRUE)\b/i,
        number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
        operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
        punctuation: /[;[\]()`,.]/
    };
}
var bash_1 = bash$2;
bash$2.displayName = 'bash';
bash$2.aliases = [
    'shell'
];
function bash$2(Prism) {
    (function(Prism) {
        // $ set | grep '^[A-Z][^[:space:]]*=' | cut -d= -f1 | tr '\n' '|'
        // + LC_ALL, RANDOM, REPLY, SECONDS.
        // + make sure PS1..4 are here as they are not always set,
        // - some useless things.
        var envVars = '\\b(?:BASH|BASHOPTS|BASH_ALIASES|BASH_ARGC|BASH_ARGV|BASH_CMDS|BASH_COMPLETION_COMPAT_DIR|BASH_LINENO|BASH_REMATCH|BASH_SOURCE|BASH_VERSINFO|BASH_VERSION|COLORTERM|COLUMNS|COMP_WORDBREAKS|DBUS_SESSION_BUS_ADDRESS|DEFAULTS_PATH|DESKTOP_SESSION|DIRSTACK|DISPLAY|EUID|GDMSESSION|GDM_LANG|GNOME_KEYRING_CONTROL|GNOME_KEYRING_PID|GPG_AGENT_INFO|GROUPS|HISTCONTROL|HISTFILE|HISTFILESIZE|HISTSIZE|HOME|HOSTNAME|HOSTTYPE|IFS|INSTANCE|JOB|LANG|LANGUAGE|LC_ADDRESS|LC_ALL|LC_IDENTIFICATION|LC_MEASUREMENT|LC_MONETARY|LC_NAME|LC_NUMERIC|LC_PAPER|LC_TELEPHONE|LC_TIME|LESSCLOSE|LESSOPEN|LINES|LOGNAME|LS_COLORS|MACHTYPE|MAILCHECK|MANDATORY_PATH|NO_AT_BRIDGE|OLDPWD|OPTERR|OPTIND|ORBIT_SOCKETDIR|OSTYPE|PAPERSIZE|PATH|PIPESTATUS|PPID|PS1|PS2|PS3|PS4|PWD|RANDOM|REPLY|SECONDS|SELINUX_INIT|SESSION|SESSIONTYPE|SESSION_MANAGER|SHELL|SHELLOPTS|SHLVL|SSH_AUTH_SOCK|TERM|UID|UPSTART_EVENTS|UPSTART_INSTANCE|UPSTART_JOB|UPSTART_SESSION|USER|WINDOWID|XAUTHORITY|XDG_CONFIG_DIRS|XDG_CURRENT_DESKTOP|XDG_DATA_DIRS|XDG_GREETER_DATA_DIR|XDG_MENU_PREFIX|XDG_RUNTIME_DIR|XDG_SEAT|XDG_SEAT_PATH|XDG_SESSION_DESKTOP|XDG_SESSION_ID|XDG_SESSION_PATH|XDG_SESSION_TYPE|XDG_VTNR|XMODIFIERS)\\b';
        var commandAfterHeredoc = {
            pattern: /(^(["']?)\w+\2)[ \t]+\S.*/,
            lookbehind: true,
            alias: 'punctuation',
            // this looks reasonably well in all themes
            inside: null // see below
        };
        var insideString = {
            bash: commandAfterHeredoc,
            environment: {
                pattern: RegExp('\\$' + envVars),
                alias: 'constant'
            },
            variable: [
                // [0]: Arithmetic Environment
                {
                    pattern: /\$?\(\([\s\S]+?\)\)/,
                    greedy: true,
                    inside: {
                        // If there is a $ sign at the beginning highlight $(( and )) as variable
                        variable: [
                            {
                                pattern: /(^\$\(\([\s\S]+)\)\)/,
                                lookbehind: true
                            },
                            /^\$\(\(/
                        ],
                        number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
                        // Operators according to https://www.gnu.org/software/bash/manual/bashref.html#Shell-Arithmetic
                        operator: /--|\+\+|\*\*=?|<<=?|>>=?|&&|\|\||[=!+\-*/%<>^&|]=?|[?~:]/,
                        // If there is no $ sign at the beginning highlight (( and )) as punctuation
                        punctuation: /\(\(?|\)\)?|,|;/
                    }
                },
                {
                    pattern: /\$\((?:\([^)]+\)|[^()])+\)|`[^`]+`/,
                    greedy: true,
                    inside: {
                        variable: /^\$\(|^`|\)$|`$/
                    }
                },
                {
                    pattern: /\$\{[^}]+\}/,
                    greedy: true,
                    inside: {
                        operator: /:[-=?+]?|[!\/]|##?|%%?|\^\^?|,,?/,
                        punctuation: /[\[\]]/,
                        environment: {
                            pattern: RegExp('(\\{)' + envVars),
                            lookbehind: true,
                            alias: 'constant'
                        }
                    }
                },
                /\$(?:\w+|[#?*!@$])/
            ],
            // Escape sequences from echo and printf's manuals, and escaped quotes.
            entity: /\\(?:[abceEfnrtv\\"]|O?[0-7]{1,3}|U[0-9a-fA-F]{8}|u[0-9a-fA-F]{4}|x[0-9a-fA-F]{1,2})/
        };
        Prism.languages.bash = {
            shebang: {
                pattern: /^#!\s*\/.*/,
                alias: 'important'
            },
            comment: {
                pattern: /(^|[^"{\\$])#.*/,
                lookbehind: true
            },
            'function-name': [
                // a) function foo {
                // b) foo() {
                // c) function foo() {
                // but not “foo {”
                {
                    // a) and c)
                    pattern: /(\bfunction\s+)[\w-]+(?=(?:\s*\(?:\s*\))?\s*\{)/,
                    lookbehind: true,
                    alias: 'function'
                },
                {
                    // b)
                    pattern: /\b[\w-]+(?=\s*\(\s*\)\s*\{)/,
                    alias: 'function'
                }
            ],
            // Highlight variable names as variables in for and select beginnings.
            'for-or-select': {
                pattern: /(\b(?:for|select)\s+)\w+(?=\s+in\s)/,
                alias: 'variable',
                lookbehind: true
            },
            // Highlight variable names as variables in the left-hand part
            // of assignments (“=” and “+=”).
            'assign-left': {
                pattern: /(^|[\s;|&]|[<>]\()\w+(?=\+?=)/,
                inside: {
                    environment: {
                        pattern: RegExp('(^|[\\s;|&]|[<>]\\()' + envVars),
                        lookbehind: true,
                        alias: 'constant'
                    }
                },
                alias: 'variable',
                lookbehind: true
            },
            string: [
                // Support for Here-documents https://en.wikipedia.org/wiki/Here_document
                {
                    pattern: /((?:^|[^<])<<-?\s*)(\w+)\s[\s\S]*?(?:\r?\n|\r)\2/,
                    lookbehind: true,
                    greedy: true,
                    inside: insideString
                },
                // → No expansion (so no “inside”).
                {
                    pattern: /((?:^|[^<])<<-?\s*)(["'])(\w+)\2\s[\s\S]*?(?:\r?\n|\r)\3/,
                    lookbehind: true,
                    greedy: true,
                    inside: {
                        bash: commandAfterHeredoc
                    }
                },
                {
                    // https://www.gnu.org/software/bash/manual/html_node/Double-Quotes.html
                    pattern: /(^|[^\\](?:\\\\)*)"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/,
                    lookbehind: true,
                    greedy: true,
                    inside: insideString
                },
                {
                    // https://www.gnu.org/software/bash/manual/html_node/Single-Quotes.html
                    pattern: /(^|[^$\\])'[^']*'/,
                    lookbehind: true,
                    greedy: true
                },
                {
                    // https://www.gnu.org/software/bash/manual/html_node/ANSI_002dC-Quoting.html
                    pattern: /\$'(?:[^'\\]|\\[\s\S])*'/,
                    greedy: true,
                    inside: {
                        entity: insideString.entity
                    }
                }
            ],
            environment: {
                pattern: RegExp('\\$?' + envVars),
                alias: 'constant'
            },
            variable: insideString.variable,
            function: {
                pattern: /(^|[\s;|&]|[<>]\()(?:add|apropos|apt|apt-cache|apt-get|aptitude|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|bzip2|cal|cat|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|column|comm|composer|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|docker|docker-compose|du|egrep|eject|env|ethtool|expand|expect|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|head|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|jobs|join|kill|killall|less|link|ln|locate|logname|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|node|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|podman|podman-compose|popd|pr|printcap|printenv|ps|pushd|pv|quota|quotacheck|quotactl|ram|rar|rcp|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|sh|shellcheck|shuf|shutdown|sleep|slocate|sort|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|tac|tail|tar|tee|time|timeout|top|touch|tr|traceroute|tsort|tty|umount|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|v|vcpkg|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zenity|zip|zsh|zypper)(?=$|[)\s;|&])/,
                lookbehind: true
            },
            keyword: {
                pattern: /(^|[\s;|&]|[<>]\()(?:case|do|done|elif|else|esac|fi|for|function|if|in|select|then|until|while)(?=$|[)\s;|&])/,
                lookbehind: true
            },
            // https://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
            builtin: {
                pattern: /(^|[\s;|&]|[<>]\()(?:\.|:|alias|bind|break|builtin|caller|cd|command|continue|declare|echo|enable|eval|exec|exit|export|getopts|hash|help|let|local|logout|mapfile|printf|pwd|read|readarray|readonly|return|set|shift|shopt|source|test|times|trap|type|typeset|ulimit|umask|unalias|unset)(?=$|[)\s;|&])/,
                lookbehind: true,
                // Alias added to make those easier to distinguish from strings.
                alias: 'class-name'
            },
            boolean: {
                pattern: /(^|[\s;|&]|[<>]\()(?:false|true)(?=$|[)\s;|&])/,
                lookbehind: true
            },
            'file-descriptor': {
                pattern: /\B&\d\b/,
                alias: 'important'
            },
            operator: {
                // Lots of redirections here, but not just that.
                pattern: /\d?<>|>\||\+=|=[=~]?|!=?|<<[<-]?|[&\d]?>>|\d[<>]&?|[<>][&=]?|&[>&]?|\|[&|]?/,
                inside: {
                    'file-descriptor': {
                        pattern: /^\d/,
                        alias: 'important'
                    }
                }
            },
            punctuation: /\$?\(\(?|\)\)?|\.\.|[{}[\];\\]/,
            number: {
                pattern: /(^|\s)(?:[1-9]\d*|0)(?:[.,]\d+)?\b/,
                lookbehind: true
            }
        };
        commandAfterHeredoc.inside = Prism.languages.bash;
        /* Patterns in command substitution. */ var toBeCopied = [
            'comment',
            'function-name',
            'for-or-select',
            'assign-left',
            'string',
            'environment',
            'function',
            'keyword',
            'builtin',
            'boolean',
            'file-descriptor',
            'operator',
            'punctuation',
            'number'
        ];
        var inside = insideString.variable[1].inside;
        for(var i = 0; i < toBeCopied.length; i++)inside[toBeCopied[i]] = Prism.languages.bash[toBeCopied[i]];
        Prism.languages.shell = Prism.languages.bash;
    })(Prism);
}
var typescript_1 = typescript$2;
typescript$2.displayName = 'typescript';
typescript$2.aliases = [
    'ts'
];
function typescript$2(Prism) {
    (function(Prism) {
        Prism.languages.typescript = Prism.languages.extend('javascript', {
            'class-name': {
                pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
                lookbehind: true,
                greedy: true,
                inside: null // see below
            },
            builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
        }); // The keywords TypeScript adds to JavaScript
        Prism.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, /\btype\b(?=\s*(?:[\{*]|$))/); // doesn't work with TS because TS is too complex
        delete Prism.languages.typescript['parameter'];
        delete Prism.languages.typescript['literal-property']; // a version of typescript specifically for highlighting types
        var typeInside = Prism.languages.extend('typescript', {});
        delete typeInside['class-name'];
        Prism.languages.typescript['class-name'].inside = typeInside;
        Prism.languages.insertBefore('typescript', 'function', {
            decorator: {
                pattern: /@[$\w\xA0-\uFFFF]+/,
                inside: {
                    at: {
                        pattern: /^@/,
                        alias: 'operator'
                    },
                    function: /^[\s\S]+/
                }
            },
            'generic-function': {
                // e.g. foo<T extends "bar" | "baz">( ...
                pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
                greedy: true,
                inside: {
                    function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
                    generic: {
                        pattern: /<[\s\S]+/,
                        // everything after the first <
                        alias: 'class-name',
                        inside: typeInside
                    }
                }
            }
        });
        Prism.languages.ts = Prism.languages.typescript;
    })(Prism);
}
var json_1 = json$2;
json$2.displayName = 'json';
json$2.aliases = [
    'webmanifest'
];
function json$2(Prism) {
    // https://www.json.org/json-en.html
    Prism.languages.json = {
        property: {
            pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
            lookbehind: true,
            greedy: true
        },
        string: {
            pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
            lookbehind: true,
            greedy: true
        },
        comment: {
            pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
            greedy: true
        },
        number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
        punctuation: /[{}[\],]/,
        operator: /:/,
        boolean: /\b(?:false|true)\b/,
        null: {
            pattern: /\bnull\b/,
            alias: 'keyword'
        }
    };
    Prism.languages.webmanifest = Prism.languages.json;
}
var jsx_1 = jsx$2;
jsx$2.displayName = 'jsx';
jsx$2.aliases = [];
function jsx$2(Prism) {
    (function(Prism) {
        var javascript = Prism.util.clone(Prism.languages.javascript);
        var space = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source;
        var braces = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source;
        var spread = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
        /**
     * @param {string} source
     * @param {string} [flags]
     */ function re(source, flags) {
            source = source.replace(/<S>/g, function() {
                return space;
            }).replace(/<BRACES>/g, function() {
                return braces;
            }).replace(/<SPREAD>/g, function() {
                return spread;
            });
            return RegExp(source, flags);
        }
        spread = re(spread).source;
        Prism.languages.jsx = Prism.languages.extend('markup', javascript);
        Prism.languages.jsx.tag.pattern = re(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source);
        Prism.languages.jsx.tag.inside['tag'].pattern = /^<\/?[^\s>\/]*/;
        Prism.languages.jsx.tag.inside['attr-value'].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/;
        Prism.languages.jsx.tag.inside['tag'].inside['class-name'] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/;
        Prism.languages.jsx.tag.inside['comment'] = javascript['comment'];
        Prism.languages.insertBefore('inside', 'attr-name', {
            spread: {
                pattern: re(/<SPREAD>/.source),
                inside: Prism.languages.jsx
            }
        }, Prism.languages.jsx.tag);
        Prism.languages.insertBefore('inside', 'special-attr', {
            script: {
                // Allow for two levels of nesting
                pattern: re(/=<BRACES>/.source),
                alias: 'language-javascript',
                inside: {
                    'script-punctuation': {
                        pattern: /^=(?=\{)/,
                        alias: 'punctuation'
                    },
                    rest: Prism.languages.jsx
                }
            }
        }, Prism.languages.jsx.tag); // The following will handle plain text inside tags
        var stringifyToken = function(token) {
            if (!token) return '';
            if (typeof token === 'string') return token;
            if (typeof token.content === 'string') return token.content;
            return token.content.map(stringifyToken).join('');
        };
        var walkTokens = function(tokens) {
            var openedTags = [];
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                var notTagNorBrace = false;
                if (typeof token !== 'string') {
                    if (token.type === 'tag' && token.content[0] && token.content[0].type === 'tag') {
                        // We found a tag, now find its kind
                        if (token.content[0].content[0].content === '</') // Closing tag
                        {
                            if (openedTags.length > 0 && openedTags[openedTags.length - 1].tagName === stringifyToken(token.content[0].content[1])) // Pop matching opening tag
                            openedTags.pop();
                        } else {
                            if (token.content[token.content.length - 1].content === '/>') ;
                            else // Opening tag
                            openedTags.push({
                                tagName: stringifyToken(token.content[0].content[1]),
                                openedBraces: 0
                            });
                        }
                    } else if (openedTags.length > 0 && token.type === 'punctuation' && token.content === '{') // Here we might have entered a JSX context inside a tag
                    openedTags[openedTags.length - 1].openedBraces++;
                    else if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces > 0 && token.type === 'punctuation' && token.content === '}') // Here we might have left a JSX context inside a tag
                    openedTags[openedTags.length - 1].openedBraces--;
                    else notTagNorBrace = true;
                }
                if (notTagNorBrace || typeof token === 'string') {
                    if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces === 0) {
                        // Here we are inside a tag, and not inside a JSX context.
                        // That's plain text: drop any tokens matched.
                        var plainText = stringifyToken(token); // And merge text with adjacent text
                        if (i < tokens.length - 1 && (typeof tokens[i + 1] === 'string' || tokens[i + 1].type === 'plain-text')) {
                            plainText += stringifyToken(tokens[i + 1]);
                            tokens.splice(i + 1, 1);
                        }
                        if (i > 0 && (typeof tokens[i - 1] === 'string' || tokens[i - 1].type === 'plain-text')) {
                            plainText = stringifyToken(tokens[i - 1]) + plainText;
                            tokens.splice(i - 1, 1);
                            i--;
                        }
                        tokens[i] = new Prism.Token('plain-text', plainText, null, plainText);
                    }
                }
                if (token.content && typeof token.content !== 'string') walkTokens(token.content);
            }
        };
        Prism.hooks.add('after-tokenize', function(env) {
            if (env.language !== 'jsx' && env.language !== 'tsx') return;
            walkTokens(env.tokens);
        });
    })(Prism);
}
var powershell_1 = powershell$2;
powershell$2.displayName = 'powershell';
powershell$2.aliases = [];
function powershell$2(Prism) {
    (function(Prism) {
        var powershell = Prism.languages.powershell = {
            comment: [
                {
                    pattern: /(^|[^`])<#[\s\S]*?#>/,
                    lookbehind: true
                },
                {
                    pattern: /(^|[^`])#.*/,
                    lookbehind: true
                }
            ],
            string: [
                {
                    pattern: /"(?:`[\s\S]|[^`"])*"/,
                    greedy: true,
                    inside: null // see below
                },
                {
                    pattern: /'(?:[^']|'')*'/,
                    greedy: true
                }
            ],
            // Matches name spaces as well as casts, attribute decorators. Force starting with letter to avoid matching array indices
            // Supports two levels of nested brackets (e.g. `[OutputType([System.Collections.Generic.List[int]])]`)
            namespace: /\[[a-z](?:\[(?:\[[^\]]*\]|[^\[\]])*\]|[^\[\]])*\]/i,
            boolean: /\$(?:false|true)\b/i,
            variable: /\$\w+\b/,
            // Cmdlets and aliases. Aliases should come last, otherwise "write" gets preferred over "write-host" for example
            // Get-Command | ?{ $_.ModuleName -match "Microsoft.PowerShell.(Util|Core|Management)" }
            // Get-Alias | ?{ $_.ReferencedCommand.Module.Name -match "Microsoft.PowerShell.(Util|Core|Management)" }
            function: [
                /\b(?:Add|Approve|Assert|Backup|Block|Checkpoint|Clear|Close|Compare|Complete|Compress|Confirm|Connect|Convert|ConvertFrom|ConvertTo|Copy|Debug|Deny|Disable|Disconnect|Dismount|Edit|Enable|Enter|Exit|Expand|Export|Find|ForEach|Format|Get|Grant|Group|Hide|Import|Initialize|Install|Invoke|Join|Limit|Lock|Measure|Merge|Move|New|Open|Optimize|Out|Ping|Pop|Protect|Publish|Push|Read|Receive|Redo|Register|Remove|Rename|Repair|Request|Reset|Resize|Resolve|Restart|Restore|Resume|Revoke|Save|Search|Select|Send|Set|Show|Skip|Sort|Split|Start|Step|Stop|Submit|Suspend|Switch|Sync|Tee|Test|Trace|Unblock|Undo|Uninstall|Unlock|Unprotect|Unpublish|Unregister|Update|Use|Wait|Watch|Where|Write)-[a-z]+\b/i,
                /\b(?:ac|cat|chdir|clc|cli|clp|clv|compare|copy|cp|cpi|cpp|cvpa|dbp|del|diff|dir|ebp|echo|epal|epcsv|epsn|erase|fc|fl|ft|fw|gal|gbp|gc|gci|gcs|gdr|gi|gl|gm|gp|gps|group|gsv|gu|gv|gwmi|iex|ii|ipal|ipcsv|ipsn|irm|iwmi|iwr|kill|lp|ls|measure|mi|mount|move|mp|mv|nal|ndr|ni|nv|ogv|popd|ps|pushd|pwd|rbp|rd|rdr|ren|ri|rm|rmdir|rni|rnp|rp|rv|rvpa|rwmi|sal|saps|sasv|sbp|sc|select|set|shcm|si|sl|sleep|sls|sort|sp|spps|spsv|start|sv|swmi|tee|trcm|type|write)\b/i
            ],
            // per http://technet.microsoft.com/en-us/library/hh847744.aspx
            keyword: /\b(?:Begin|Break|Catch|Class|Continue|Data|Define|Do|DynamicParam|Else|ElseIf|End|Exit|Filter|Finally|For|ForEach|From|Function|If|InlineScript|Parallel|Param|Process|Return|Sequence|Switch|Throw|Trap|Try|Until|Using|Var|While|Workflow)\b/i,
            operator: {
                pattern: /(^|\W)(?:!|-(?:b?(?:and|x?or)|as|(?:Not)?(?:Contains|In|Like|Match)|eq|ge|gt|is(?:Not)?|Join|le|lt|ne|not|Replace|sh[lr])\b|-[-=]?|\+[+=]?|[*\/%]=?)/i,
                lookbehind: true
            },
            punctuation: /[|{}[\];(),.]/
        }; // Variable interpolation inside strings, and nested expressions
        powershell.string[0].inside = {
            function: {
                // Allow for one level of nesting
                pattern: /(^|[^`])\$\((?:\$\([^\r\n()]*\)|(?!\$\()[^\r\n)])*\)/,
                lookbehind: true,
                inside: powershell
            },
            boolean: powershell.boolean,
            variable: powershell.variable
        };
    })(Prism);
}
var python_1 = python$2;
python$2.displayName = 'python';
python$2.aliases = [
    'py'
];
function python$2(Prism) {
    Prism.languages.python = {
        comment: {
            pattern: /(^|[^\\])#.*/,
            lookbehind: true,
            greedy: true
        },
        'string-interpolation': {
            pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
            greedy: true,
            inside: {
                interpolation: {
                    // "{" <expression> <optional "!s", "!r", or "!a"> <optional ":" format specifier> "}"
                    pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
                    lookbehind: true,
                    inside: {
                        'format-spec': {
                            pattern: /(:)[^:(){}]+(?=\}$)/,
                            lookbehind: true
                        },
                        'conversion-option': {
                            pattern: /![sra](?=[:}]$)/,
                            alias: 'punctuation'
                        },
                        rest: null
                    }
                },
                string: /[\s\S]+/
            }
        },
        'triple-quoted-string': {
            pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
            greedy: true,
            alias: 'string'
        },
        string: {
            pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
            greedy: true
        },
        function: {
            pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
            lookbehind: true
        },
        'class-name': {
            pattern: /(\bclass\s+)\w+/i,
            lookbehind: true
        },
        decorator: {
            pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
            lookbehind: true,
            alias: [
                'annotation',
                'punctuation'
            ],
            inside: {
                punctuation: /\./
            }
        },
        keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
        builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
        boolean: /\b(?:False|None|True)\b/,
        number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
        operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
        punctuation: /[{}[\];(),.:]/
    };
    Prism.languages.python['string-interpolation'].inside['interpolation'].inside.rest = Prism.languages.python;
    Prism.languages.py = Prism.languages.python;
}
var tsx_1 = tsx$2;
tsx$2.displayName = 'tsx';
tsx$2.aliases = [];
function tsx$2(Prism) {
    Prism.register(jsx_1);
    Prism.register(typescript_1);
    (function(Prism) {
        var typescript = Prism.util.clone(Prism.languages.typescript);
        Prism.languages.tsx = Prism.languages.extend('jsx', typescript); // doesn't work with TS because TS is too complex
        delete Prism.languages.tsx['parameter'];
        delete Prism.languages.tsx['literal-property']; // This will prevent collisions between TSX tags and TS generic types.
        // Idea by https://github.com/karlhorky
        // Discussion: https://github.com/PrismJS/prism/issues/2594#issuecomment-710666928
        var tag = Prism.languages.tsx.tag;
        tag.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + '(?:' + tag.pattern.source + ')', tag.pattern.flags);
        tag.lookbehind = true;
    })(Prism);
}
var prismStyle = {
    "code[class*=\"language-\"]": {
        "fontFamily": "Consolas, Menlo, Monaco, \"Andale Mono WT\", \"Andale Mono\", \"Lucida Console\", \"Lucida Sans Typewriter\", \"DejaVu Sans Mono\", \"Bitstream Vera Sans Mono\", \"Liberation Mono\", \"Nimbus Mono L\", \"Courier New\", Courier, monospace",
        "fontSize": "14px",
        "lineHeight": "1.375",
        "direction": "ltr",
        "textAlign": "left",
        "whiteSpace": "pre",
        "wordSpacing": "normal",
        "wordBreak": "normal",
        "MozTabSize": "4",
        "OTabSize": "4",
        "tabSize": "4",
        "WebkitHyphens": "none",
        "MozHyphens": "none",
        "msHyphens": "none",
        "hyphens": "none",
        "background": "#f5f7ff",
        "color": "#5e6687"
    },
    "pre[class*=\"language-\"]": {
        "fontFamily": "Consolas, Menlo, Monaco, \"Andale Mono WT\", \"Andale Mono\", \"Lucida Console\", \"Lucida Sans Typewriter\", \"DejaVu Sans Mono\", \"Bitstream Vera Sans Mono\", \"Liberation Mono\", \"Nimbus Mono L\", \"Courier New\", Courier, monospace",
        "fontSize": "14px",
        "lineHeight": "1.375",
        "direction": "ltr",
        "textAlign": "left",
        "whiteSpace": "pre",
        "wordSpacing": "normal",
        "wordBreak": "normal",
        "MozTabSize": "4",
        "OTabSize": "4",
        "tabSize": "4",
        "WebkitHyphens": "none",
        "MozHyphens": "none",
        "msHyphens": "none",
        "hyphens": "none",
        "background": "#f5f7ff",
        "color": "#5e6687",
        "padding": "1em",
        "margin": ".5em 0",
        "overflow": "auto"
    },
    "pre > code[class*=\"language-\"]": {
        "fontSize": "1em"
    },
    "pre[class*=\"language-\"]::-moz-selection": {
        "textShadow": "none",
        "background": "#dfe2f1"
    },
    "pre[class*=\"language-\"] ::-moz-selection": {
        "textShadow": "none",
        "background": "#dfe2f1"
    },
    "code[class*=\"language-\"]::-moz-selection": {
        "textShadow": "none",
        "background": "#dfe2f1"
    },
    "code[class*=\"language-\"] ::-moz-selection": {
        "textShadow": "none",
        "background": "#dfe2f1"
    },
    "pre[class*=\"language-\"]::selection": {
        "textShadow": "none",
        "background": "#dfe2f1"
    },
    "pre[class*=\"language-\"] ::selection": {
        "textShadow": "none",
        "background": "#dfe2f1"
    },
    "code[class*=\"language-\"]::selection": {
        "textShadow": "none",
        "background": "#dfe2f1"
    },
    "code[class*=\"language-\"] ::selection": {
        "textShadow": "none",
        "background": "#dfe2f1"
    },
    ":not(pre) > code[class*=\"language-\"]": {
        "padding": ".1em",
        "borderRadius": ".3em"
    },
    "comment": {
        "color": "#898ea4"
    },
    "prolog": {
        "color": "#898ea4"
    },
    "doctype": {
        "color": "#898ea4"
    },
    "cdata": {
        "color": "#898ea4"
    },
    "punctuation": {
        "color": "#5e6687"
    },
    "namespace": {
        "Opacity": ".7"
    },
    "operator": {
        "color": "#c76b29"
    },
    "boolean": {
        "color": "#c76b29"
    },
    "number": {
        "color": "#c76b29"
    },
    "property": {
        "color": "#c08b30"
    },
    "tag": {
        "color": "#3d8fd1"
    },
    "string": {
        "color": "#22a2c9"
    },
    "selector": {
        "color": "#6679cc"
    },
    "attr-name": {
        "color": "#c76b29"
    },
    "entity": {
        "color": "#22a2c9",
        "cursor": "help"
    },
    "url": {
        "color": "#22a2c9"
    },
    ".language-css .token.string": {
        "color": "#22a2c9"
    },
    ".style .token.string": {
        "color": "#22a2c9"
    },
    "attr-value": {
        "color": "#ac9739"
    },
    "keyword": {
        "color": "#ac9739"
    },
    "control": {
        "color": "#ac9739"
    },
    "directive": {
        "color": "#ac9739"
    },
    "unit": {
        "color": "#ac9739"
    },
    "statement": {
        "color": "#22a2c9"
    },
    "regex": {
        "color": "#22a2c9"
    },
    "atrule": {
        "color": "#22a2c9"
    },
    "placeholder": {
        "color": "#3d8fd1"
    },
    "variable": {
        "color": "#3d8fd1"
    },
    "deleted": {
        "textDecoration": "line-through"
    },
    "inserted": {
        "borderBottom": "1px dotted #202746",
        "textDecoration": "none"
    },
    "italic": {
        "fontStyle": "italic"
    },
    "important": {
        "fontWeight": "bold",
        "color": "#c94922"
    },
    "bold": {
        "fontWeight": "bold"
    },
    "pre > code.highlight": {
        "Outline": "0.4em solid #c94922",
        "OutlineOffset": ".4em"
    },
    ".line-numbers.line-numbers .line-numbers-rows": {
        "borderRightColor": "#dfe2f1"
    },
    ".line-numbers .line-numbers-rows > span:before": {
        "color": "#979db4"
    },
    ".line-highlight.line-highlight": {
        "background": "linear-gradient(to right, rgba(107, 115, 148, 0.2) 70%, rgba(107, 115, 148, 0))"
    }
};
var interopRequireDefault = createCommonjsModule(function(module1) {
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    module1.exports = _interopRequireDefault, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
});
var sql = createCommonjsModule(function(module1, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1["default"] = void 0;
    var _sql = interopRequireDefault(sql_1);
    var _default = _sql["default"];
    exports1["default"] = _default;
});
var sql$1 = /*@__PURE__*/ unwrapExports(sql);
var python = createCommonjsModule(function(module1, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1["default"] = void 0;
    var _python = interopRequireDefault(python_1);
    var _default = _python["default"];
    exports1["default"] = _default;
});
var python$1 = /*@__PURE__*/ unwrapExports(python);
var jsx = createCommonjsModule(function(module1, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1["default"] = void 0;
    var _jsx = interopRequireDefault(jsx_1);
    var _default = _jsx["default"];
    exports1["default"] = _default;
});
var jsx$1 = /*@__PURE__*/ unwrapExports(jsx);
var tsx = createCommonjsModule(function(module1, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1["default"] = void 0;
    var _tsx = interopRequireDefault(tsx_1);
    var _default = _tsx["default"];
    exports1["default"] = _default;
});
var tsx$1 = /*@__PURE__*/ unwrapExports(tsx);
var typescript = createCommonjsModule(function(module1, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1["default"] = void 0;
    var _typescript = interopRequireDefault(typescript_1);
    var _default = _typescript["default"];
    exports1["default"] = _default;
});
var typescript$1 = /*@__PURE__*/ unwrapExports(typescript);
var json = createCommonjsModule(function(module1, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1["default"] = void 0;
    var _json = interopRequireDefault(json_1);
    var _default = _json["default"];
    exports1["default"] = _default;
});
var json$1 = /*@__PURE__*/ unwrapExports(json);
var bash = createCommonjsModule(function(module1, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1["default"] = void 0;
    var _bash = interopRequireDefault(bash_1);
    var _default = _bash["default"];
    exports1["default"] = _default;
});
var bash$1 = /*@__PURE__*/ unwrapExports(bash);
var powershell = createCommonjsModule(function(module1, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1["default"] = void 0;
    var _powershell = interopRequireDefault(powershell_1);
    var _default = _powershell["default"];
    exports1["default"] = _default;
});
var powershell$1 = /*@__PURE__*/ unwrapExports(powershell);
SyntaxHighlighter$1.registerLanguage('sql', sql$1);
SyntaxHighlighter$1.registerLanguage('python', python$1);
SyntaxHighlighter$1.registerLanguage('jsx', jsx$1);
SyntaxHighlighter$1.registerLanguage('tsx', tsx$1);
SyntaxHighlighter$1.registerLanguage('typescript', typescript$1);
SyntaxHighlighter$1.registerLanguage('json', json$1);
SyntaxHighlighter$1.registerLanguage('bash', bash$1);
SyntaxHighlighter$1.registerLanguage('powershell', powershell$1);
var useStyles$m = (0, $e1ONw.default)({
    code: {
        fontFamily: fontFamilies.code
    }
});
/**
 * A wrapper for react-syntax-highlighter with default styles importing only
 * necessary languages and styles. At its core, uses prismjs for syntax
 * highlighting and refractor for virtual DOM support. See
 * https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * for all possible props to be forwarded to the highlighter.
 */ function CodeBlock(_a) {
    var code = _a.code, args = __rest(_a, [
        "code"
    ]);
    var classes = useStyles$m();
    var customStyle = {
        fontFamily: fontFamilies.code,
        fontSize: '14px'
    };
    var lineNumberStyle = {
        fontFamily: fontFamilies.code,
        minWidth: '2em'
    };
    return $ieT14.createElement(SyntaxHighlighter$1, __assign({
        style: prismStyle,
        customStyle: customStyle,
        lineNumberStyle: lineNumberStyle,
        codeTagProps: {
            className: classes.code
        }
    }, args), code.trim());
}
var useStyles$l = (0, $e1ONw.default)(function(theme) {
    return {
        root: function(props) {
            return {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                position: 'relative',
                width: props.width,
                transition: 'width 200ms',
                '&.collapsed': {
                    width: props.collapsedWidth
                }
            };
        },
        collapseButton: {
            position: 'absolute',
            top: '2px',
            right: '-13px',
            borderRadius: '50%',
            backgroundColor: theme.palette.background.default,
            width: '26px',
            height: '26px',
            color: '#000',
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 999,
            '&:hover': {
                backgroundColor: theme.palette.secondary.main
            }
        },
        icon: {
            fontSize: '29px',
            color: theme.palette.secondary.main,
            transform: 'rotate(0)',
            transition: 'transform 300ms',
            '&.collapsed': {
                transform: 'rotate(-180deg)'
            },
            '&:hover': {
                color: theme.palette.common.white
            }
        },
        childrenContainer: {
            overflow: 'hidden'
        }
    };
});
/**
 * Higher order component which renders a collapsible sidebar area for a child menu
 */ var CollapsibleSidebar = function(_a) {
    var initialCollapse = _a.initialCollapse, collapsed = _a.collapsed, setCollapsed = _a.setCollapsed, children = _a.children, className = _a.className, width = _a.width, collapsedWidth = _a.collapsedWidth;
    var classes = useStyles$l({
        width: width,
        collapsedWidth: collapsedWidth
    });
    $ieT14.useEffect(function() {
        if (initialCollapse != collapsed) setCollapsed(initialCollapse);
    }, []);
    var toggleCollapse = function() {
        setCollapsed(!collapsed);
    };
    return $ieT14.createElement("div", {
        className: clsx(classes.root, className, collapsed && 'collapsed')
    }, children, $ieT14.createElement("div", {
        className: classes.collapseButton,
        onClick: toggleCollapse
    }, $ieT14.createElement((0, $8DFBm.default), {
        className: clsx(classes.icon, collapsed && 'collapsed')
    })));
};
var StatusChip = (0, $7t0W0.default)(function(_a) {
    _a.color;
    _a.size;
    var other = __rest(_a, [
        "color",
        "size"
    ]);
    return $ieT14.createElement((0, $f7wB2.default), __assign({}, other));
})(__assign(__assign({}, TextStyles.label1), {
    backgroundColor: function(_a) {
        var color = _a.color;
        return status[color].dark;
    },
    color: neutral[100],
    fontWeight: 600,
    fontSize: 14,
    height: function(_a) {
        var size = _a.size;
        return size == 'small' ? '20px' : '24px';
    },
    borderRadius: function(_a) {
        var size = _a.size;
        return size == 'small' ? '10px' : '12px';
    },
    '& .MuiChip-label': {
        padding: '0 8px'
    }
}));
var useStyles$k = (0, $e1ONw.default)(function(theme) {
    return {
        cell: {
            position: 'relative',
            paddingLeft: function(_a) {
                var nestLevel = _a.nestLevel;
                return nestLevel ? 30 + nestLevel * 30 : 30;
            }
        },
        collapseButton: {
            position: 'absolute',
            left: function(_a) {
                var nestLevel = _a.nestLevel;
                return nestLevel ? nestLevel * 30 : 0;
            },
            top: 10
        },
        collapseIcon: {
            transform: 'rotate(0)',
            transition: 'transform 300ms',
            '&.collapsed': {
                transform: 'rotate(-90deg)'
            }
        },
        titleGroup: {
            marginRight: 10,
            maxWidth: 250
        },
        title: {
            fontFamily: fontFamilies.heading,
            fontSize: 18,
            fontWeight: 500,
            lineHeight: 1,
            color: blue[800],
            margin: 0,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        },
        subtitle: __assign(__assign({}, TextStyles.label2), {
            color: neutral[500],
            margin: 0,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }),
        statusChip: {
            margin: '0 2px'
        }
    };
});
var DataGridRowHeader = function(_a) {
    var title = _a.title, subtitle = _a.subtitle, statuses = _a.statuses, collapsible = _a.collapsible, collapsed = _a.collapsed, setCollapsed = _a.setCollapsed, nestLevel = _a.nestLevel;
    var classes = useStyles$k({
        nestLevel: nestLevel
    });
    return $ieT14.createElement("div", {
        className: classes.cell
    }, collapsible && $ieT14.createElement((0, $1KcBP.default), {
        "aria-label": collapsed ? 'open' : 'close',
        onClick: function() {
            return setCollapsed(!collapsed);
        },
        className: classes.collapseButton,
        size: "small"
    }, $ieT14.createElement((0, $e1kqS.default), {
        className: clsx(classes.collapseIcon, collapsed && 'collapsed')
    })), $ieT14.createElement("div", {
        className: classes.titleGroup
    }, $ieT14.createElement("h2", {
        className: classes.title
    }, title), subtitle && $ieT14.createElement("p", {
        className: classes.subtitle
    }, subtitle)), statuses && statuses.map(function(status, i) {
        return $ieT14.createElement(StatusChip, {
            size: "small",
            label: status.label,
            color: status.level,
            className: classes.statusChip,
            key: i
        });
    }));
};
var useStyles$j = (0, $e1ONw.default)({
    root: {
        height: '100%',
        padding: '0 4px',
        '& > div': {
            // height: 50,
            minHeight: 50,
            display: 'flex',
            alignItems: 'center'
        }
    }
});
var DataGridCell = function(_a) {
    var children = _a.children, className = _a.className;
    var classes = useStyles$j();
    return $ieT14.createElement("div", {
        className: clsx(classes.root, className)
    }, children);
};
var useStyles$i = (0, $e1ONw.default)({
    cellText: {
        margin: 0,
        fontFamily: fontFamilies.heading,
        fontSize: 16
    }
});
var DataGridTextCell = function(_a) {
    var value = _a.value;
    var classes = useStyles$i();
    return $ieT14.createElement("div", null, $ieT14.createElement("p", {
        className: classes.cellText
    }, value));
};
var useStyles$h = (0, $e1ONw.default)({
    table: {
        width: '100%',
        textAlign: 'left',
        borderCollapse: 'collapse'
    },
    loading: {
        opacity: '0.7',
        pointerEvents: 'none'
    }
});
/**
 * Table with optional sorting,
 */ var Table = function(_a) {
    var children = _a.children, loading = _a.loading, results = _a.results, className = _a.className;
    var classes = useStyles$h();
    return $ieT14.createElement("table", {
        className: clsx(loading && results && results.length > 0 && classes.loading, classes.table, className)
    }, children);
};
var useStyles$g = (0, $e1ONw.default)(function(theme) {
    return {
        root: {
            position: 'relative',
            height: 27,
            '& td': __assign(__assign({}, TextStyles.caption), {
                paddingTop: 25,
                paddingRight: 20,
                paddingBottom: 11,
                '&:first-child': {
                    paddingLeft: 38
                }
            })
        }
    };
});
/**
 * Table Body, container for table rows
 */ var TableBody = function(_a) {
    var children = _a.children, className = _a.className;
    var classes = useStyles$g();
    return $ieT14.createElement("tbody", {
        className: clsx(classes.root, className)
    }, children);
};
var useStyles$f = (0, $e1ONw.default)({
    tableHead: {
        position: 'relative',
        height: 27
    }
});
/**
 * TableHead: styled Table header row, includes both thead and tr
 */ var TableHead = function(_a) {
    var children = _a.children, className = _a.className;
    var classes = useStyles$f();
    return $ieT14.createElement("thead", {
        className: clsx(classes.tableHead, className)
    }, $ieT14.createElement("tr", null, children));
};
var useStyles$e = (0, $e1ONw.default)(function() {
    return (0, $kRJN7.default)({
        button: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: 'none',
            backgroundColor: 'white',
            padding: '0',
            margin: '0',
            cursor: 'pointer',
            '& svg': {
                width: '14px',
                height: '7px'
            }
        },
        ascending: {
            paddingTop: '3px',
            paddingBottom: '1px',
            paddingLeft: '2px',
            paddingRight: '2px'
        },
        descending: {
            paddingTop: '1px',
            paddingBottom: '3px',
            paddingLeft: '2px',
            paddingRight: '2px'
        },
        disabled: {
            cursor: 'default'
        }
    });
});
var SortButton = function(_a) {
    var direction = _a.direction, current = _a.current, onClick = _a.onClick;
    var classes = useStyles$e();
    return $ieT14.createElement("button", {
        className: clsx(classes.button, direction === 'Ascending' ? classes.ascending : classes.descending, current && classes.disabled),
        "aria-label": direction,
        onClick: onClick,
        disabled: current
    }, direction === 'Ascending' && $ieT14.createElement("svg", {
        viewBox: "-100 -100 200 100"
    }, $ieT14.createElement("polygon", {
        points: "-80,-20 80,-20 0,-100",
        fill: current ? '#00223c' : '#c4c4c4',
        strokeWidth: "0"
    })), direction === 'Descending' && $ieT14.createElement("svg", {
        viewBox: "-100 0 200 100",
        height: "16px",
        width: "16px"
    }, $ieT14.createElement("polygon", {
        points: "-80,20 80,20 0,100",
        fill: current ? '#00223c' : '#c4c4c4'
    })));
};
var useStyles$d = (0, $e1ONw.default)(function(theme) {
    return {
        cell: __assign(__assign({}, TextStyles.label1), {
            zIndex: 100,
            textTransform: 'uppercase',
            position: 'sticky',
            top: 0,
            background: neutral[100],
            whiteSpace: 'nowrap',
            paddingTop: 0,
            paddingRight: 20,
            paddingBottom: 11,
            '&:first-child': {
                paddingLeft: 38
            },
            '&::after': {
                content: "''",
                position: 'absolute',
                width: '100%',
                bottom: '1px',
                left: 0,
                height: '1px',
                backgroundColor: neutral[250]
            }
        }),
        current: {
            '& $inner > button': {
                fontWeight: 600
            }
        },
        inner: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            height: 22,
            '&> button': __assign(__assign({}, TextStyles.label1), {
                textTransform: 'uppercase',
                background: neutral[100],
                whiteSpace: 'nowrap',
                border: 'none',
                padding: 0,
                cursor: 'pointer'
            })
        },
        title: {},
        sortGroup: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginLeft: 4
        }
    };
});
/**
 * HeaderCell -- renders th in table header with optional sorting buttons
 */ var HeaderCell = function(_a) {
    var title = _a.title, scope = _a.scope, orderField = _a.orderField, orderColumn = _a.orderColumn, orderDirection = _a.orderDirection, reorderHandler = _a.reorderHandler, colspan = _a.colspan, className = _a.className;
    var classes = useStyles$d();
    var clickHandler = function() {
        var direction;
        if (orderField !== orderColumn) direction = 'asc';
        else direction = orderDirection === 'asc' ? 'desc' : 'asc';
        if (reorderHandler && orderField) reorderHandler(orderField, direction);
    };
    return $ieT14.createElement("th", {
        className: clsx(classes.cell, orderField === orderColumn && classes.current, className),
        scope: scope,
        colSpan: colspan
    }, $ieT14.createElement("div", {
        className: classes.inner
    }, orderColumn && reorderHandler && orderField ? $ieT14.createElement($ieT14.Fragment, null, $ieT14.createElement("button", {
        className: classes.title,
        "aria-label": "Order by " + title,
        title: "Order by " + title,
        onClick: clickHandler
    }, title || ''), $ieT14.createElement("div", {
        className: classes.sortGroup
    }, $ieT14.createElement(SortButton, {
        direction: "Ascending",
        current: orderField === orderColumn && orderDirection === 'asc',
        onClick: function() {
            return reorderHandler(orderField, 'asc');
        }
    }), $ieT14.createElement(SortButton, {
        direction: "Descending",
        current: orderField === orderColumn && orderDirection === 'desc',
        onClick: function() {
            return reorderHandler(orderField, 'desc');
        }
    }))) : $ieT14.createElement("span", {
        className: classes.title
    }, title || '')));
};
var useStyles$c = (0, $e1ONw.default)({
    detailTable: {
        paddingLeft: function(_a) {
            var nestLevel = _a.nestLevel;
            return nestLevel * 30 + 30;
        },
        display: 'flex',
        margin: '8px 0 16px',
        zIndex: 0,
        gridColumn: function(_a) {
            var columnCount = _a.columnCount;
            return "1 / " + (columnCount + 1);
        },
        height: function(_a) {
            var tableHeight = _a.tableHeight;
            return tableHeight;
        },
        transition: 'height 300ms',
        '& td, & th': {
            padding: '0 3px'
        },
        '&.collapsed': {
            height: 0,
            margin: 0
        }
    },
    link: __assign(__assign({}, TextStyles.caption), {
        color: blue[600],
        textDecoration: 'none'
    })
});
var DataGridDetailTable = function(_a) {
    var detailTable = _a.detailTable, collapsed = _a.collapsed, nestLevel = _a.nestLevel, columnCount = _a.columnCount;
    var tableHeight = 22 + detailTable.rows.length * 16;
    var classes = useStyles$c({
        tableHeight: tableHeight,
        nestLevel: nestLevel,
        columnCount: columnCount
    });
    var renderCellContent = function(cell) {
        var content = cell.content;
        if (cell.format) {
            if (cell.format == 'date') content = DateFormatter.format(new Date(cell.content));
            else if (cell.format == 'datetime') content = DateTimeFormatter.format(new Date(cell.content));
        }
        if (cell.isLink && cell.link) {
            if (cell.link.isExternal) return $ieT14.createElement("a", {
                href: cell.link.url,
                className: classes.link,
                rel: "nofollow noreferrer",
                target: "_blank"
            }, content);
            else $ieT14.createElement((0, $6mt9R.Link), {
                to: cell.link.url
            }, content);
        }
        return content;
    };
    return $ieT14.createElement("div", {
        className: clsx(classes.detailTable, collapsed && 'collapsed')
    }, $ieT14.createElement(Table, null, $ieT14.createElement(TableHead, null, detailTable.columns.map(function(column, i) {
        return $ieT14.createElement(HeaderCell, {
            title: column,
            key: i
        });
    })), $ieT14.createElement(TableBody, null, detailTable.rows.map(function(row, i) {
        return $ieT14.createElement("tr", {
            key: i
        }, row.map(function(cell, j) {
            return $ieT14.createElement("td", {
                key: "dt-cell-" + j
            }, renderCellContent(cell));
        }));
    }))));
};
var useStyles$b = (0, $e1ONw.default)({
    errorIcon: {
        color: status.error.dark,
        opacity: '0.7',
        '&:hover': {
            opacity: 1
        }
    },
    noData: __assign({}, TextStyles.label1)
});
/**
 * Render the trends graph at the end of a row of the table, using either data
 * included in the datagrid data or lazy loading data for each row when the
 * parent row is opened
 */ var DataGridTrendsViz = function(_a) {
    var trends = _a.trends, parentCollapsed = _a.parentCollapsed, accessToken = _a.accessToken;
    var classes = useStyles$b();
    var _b = $ieT14.useState('apiPath' in trends ? true : false), loading = _b[0], setLoading = _b[1];
    var _c = $ieT14.useState('data' in trends && trends.data), data = _c[0], setData = _c[1];
    var _d = $ieT14.useState('dataKey' in trends && trends.dataKey), key = _d[0], setKey = _d[1];
    var _e = $ieT14.useState(''), loadError = _e[0], setLoadError = _e[1];
    $ieT14.useEffect(function() {
        if (loading && !parentCollapsed && 'apiPath' in trends && accessToken) fetch(trends.apiPath, {
            headers: {
                Authorization: "Bearer " + accessToken
            }
        }).then(function(res) {
            return res.json();
        }).then(function(resBody) {
            if (resBody.success) {
                setData(resBody.data);
                setKey(resBody.dataKey);
                setLoading(false);
            } else {
                setLoading(false);
                setLoadError(resBody.message);
            }
        }).catch(function(err) {
            setLoadError(String(err));
            setLoading(false);
        });
    }, [
        loading,
        parentCollapsed
    ]);
    var render = function() {
        if (loading) return $ieT14.createElement((0, $fpdl2.default), {
            size: 20
        });
        else if (loadError) return $ieT14.createElement((0, $356Vi.default), {
            title: loadError
        }, $ieT14.createElement((0, $1vmhz.default), {
            fontSize: "small",
            className: classes.errorIcon
        }));
        else if (data && key && data.length > 0) return $ieT14.createElement(StackedArea, {
            data: data,
            dataKey: key,
            viewBoxWidth: 300,
            viewBoxHeight: 50,
            svgHeight: 50
        });
        else return $ieT14.createElement("div", {
            className: classes.noData
        }, $ieT14.createElement("p", null, "(No data available.)"));
    };
    return $ieT14.createElement("div", null, render());
};
var useStyles$a = (0, $e1ONw.default)({
    cell: {
        height: function(_a) {
            var parentCollapsed = _a.parentCollapsed;
            return parentCollapsed ? 0 : 50;
        },
        transition: 'height 300ms'
    },
    rootRow: {
        borderTop: "2px solid " + neutral[400],
        '& > div': {
            height: 54
        }
    }
});
var renderTextContent = function(content, format) {
    if (format) {
        if (format == 'date') return DateFormatter.format(new Date(content));
        else if (format == 'datetime') return DateTimeFormatter.format(new Date(content));
    }
    return content;
};
/**
 * Render a row of the data grid, recursively rendering any children (initially
 * collapsed) and a detail table when the current level has detail data
 */ var DataGridRow = function(_a) {
    var columns = _a.columns, columnCount = _a.columnCount, row = _a.row, parentCollapsed = _a.parentCollapsed, accessToken = _a.accessToken;
    var classes = useStyles$a({
        parentCollapsed: parentCollapsed
    });
    var _b = $ieT14.useState(true), collapsed = _b[0], setCollapsed = _b[1];
    $ieT14.useEffect(function() {
        parentCollapsed && setCollapsed(true);
    }, [
        parentCollapsed
    ]);
    return $ieT14.createElement($ieT14.Fragment, null, $ieT14.createElement(DataGridCell, {
        className: clsx(classes.cell, row.nestLevel == 0 && classes.rootRow)
    }, $ieT14.createElement(DataGridRowHeader, {
        title: row.title,
        subtitle: row.subtitle,
        statuses: row.statuses,
        nestLevel: row.nestLevel,
        collapsible: row.hasChildren,
        collapsed: collapsed,
        setCollapsed: setCollapsed
    })), columns.filter(function(column) {
        return column.key != 'header' && column.key != 'trends';
    }).map(function(column) {
        return $ieT14.createElement(DataGridCell, {
            className: clsx(classes.cell, row.nestLevel == 0 && classes.rootRow),
            key: column.key
        }, $ieT14.createElement(DataGridTextCell, {
            value: renderTextContent(row[column.key], column.format)
        }));
    }), $ieT14.createElement(DataGridCell, {
        className: clsx(classes.cell, row.nestLevel == 0 && classes.rootRow)
    }, $ieT14.createElement(DataGridTrendsViz, {
        parentCollapsed: parentCollapsed,
        trends: row.trends,
        accessToken: accessToken
    })), row.detailTable && row.detailTable.rows.length > 0 && $ieT14.createElement(DataGridDetailTable, {
        detailTable: row.detailTable,
        columnCount: columnCount,
        collapsed: collapsed,
        nestLevel: row.nestLevel
    }), row.hasChildren && row.children.length > 0 && row.children.map(function(subrow, i) {
        return $ieT14.createElement(DataGridRow, {
            columns: columns,
            columnCount: columnCount,
            row: subrow,
            parentCollapsed: collapsed,
            accessToken: accessToken,
            key: subrow.title + "-" + i
        });
    }));
};
var useStyles$9 = (0, $e1ONw.default)({
    root: {
        width: '100%',
        display: 'grid',
        gridTemplateColumns: function(_a) {
            var columns = _a.columns;
            return columns.map(function(_a) {
                _a.title;
                var maxWidth = _a.maxWidth;
                return "minmax(max-content, " + (maxWidth ? maxWidth : '1fr') + ")";
            }).join(' ');
        },
        gridTemplateRows: '28px',
        borderBottom: "2px solid " + neutral[400],
        '& > div': {
            overflowY: 'hidden',
            '&:first-child': {
                paddingLeft: 34
            }
        }
    },
    headerCell: __assign(__assign({}, TextStyles.label1), {
        textTransform: 'uppercase',
        '& p': {
            margin: 0
        }
    })
});
/**
 * Component to render a data grid: A table-like collapsible tree view.
 */ var DataGrid = function(_a) {
    var data = _a.data, accessToken = _a.accessToken;
    var classes = useStyles$9({
        columns: data.columns
    });
    return $ieT14.createElement("div", {
        className: classes.root
    }, data.columns.map(function(column) {
        return $ieT14.createElement(DataGridCell, {
            className: classes.headerCell,
            key: column.title
        }, $ieT14.createElement("p", null, column.title));
    }), data.rows.map(function(row, i) {
        return $ieT14.createElement(DataGridRow, {
            columns: data.columns,
            columnCount: data.columns.length,
            row: row,
            parentCollapsed: false,
            key: row.title + "-" + i,
            accessToken: accessToken
        });
    }));
};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var freeGlobal$1 = freeGlobal;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root$1 = freeGlobal$1 || freeSelf || Function('return this')();
var root$2 = root$1;
/** Built-in value references. */ var Symbol$1 = root$2.Symbol;
var Symbol$2 = Symbol$1;
/** Used for built-in method references. */ var objectProto$b = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$9 = objectProto$b.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString$1 = objectProto$b.toString;
/** Built-in value references. */ var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty$9.call(value, symToStringTag$1), tag = value[symToStringTag$1];
    try {
        value[symToStringTag$1] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString$1.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag$1] = tag;
        else delete value[symToStringTag$1];
    }
    return result;
}
/** Used for built-in method references. */ var objectProto$a = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto$a.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
/** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag$1 = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/** Used to detect overreaching core-js shims. */ var coreJsData = root$2['__core-js_shared__'];
var coreJsData$1 = coreJsData;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/** Used for built-in method references. */ var funcProto$1 = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString$1 = funcProto$1.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString$1.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto$9 = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty$8 = objectProto$9.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty$8).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/* Built-in method references that are verified to be native. */ var Map$1 = getNative(root$2, 'Map');
var Map$2 = Map$1;
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, 'create');
var nativeCreate$1 = nativeCreate;
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var objectProto$8 = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$7 = objectProto$8.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate$1) {
        var result = data[key];
        return result === HASH_UNDEFINED$2 ? undefined : result;
    }
    return hasOwnProperty$7.call(data, key) ? data[key] : undefined;
}
/** Used for built-in method references. */ var objectProto$7 = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$6 = objectProto$7.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate$1 ? data[key] !== undefined : hasOwnProperty$6.call(data, key);
}
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate$1 && value === undefined ? HASH_UNDEFINED$1 : value;
    return this;
}
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map$2 || ListCache),
        'string': new Hash
    };
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG$3 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$1 ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/** Built-in value references. */ var Uint8Array = root$2.Uint8Array;
var Uint8Array$1 = Uint8Array;
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG$2 = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag$1 = '[object Boolean]', dateTag$1 = '[object Date]', errorTag$1 = '[object Error]', mapTag$2 = '[object Map]', numberTag$1 = '[object Number]', regexpTag$1 = '[object RegExp]', setTag$2 = '[object Set]', stringTag$1 = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag$1 = '[object ArrayBuffer]', dataViewTag$2 = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol$2 ? Symbol$2.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag$2:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag$1:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) return false;
            return true;
        case boolTag$1:
        case dateTag$1:
        case numberTag$1:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag$1:
            return object.name == other.name && object.message == other.message;
        case regexpTag$1:
        case stringTag$1:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag$2:
            var convert = mapToArray;
        case setTag$2:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
var isArray$1 = isArray;
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray$1(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/** Used for built-in method references. */ var objectProto$6 = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable$1.call(object, symbol);
    });
};
var getSymbols$1 = getSymbols;
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/** `Object#toString` result references. */ var argsTag$2 = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag$2;
}
/** Used for built-in method references. */ var objectProto$5 = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$5 = objectProto$5.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty$5.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
var isArguments$1 = isArguments;
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
/** Detect free variable `exports`. */ var freeExports$1 = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule$1 = freeExports$1 && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
/** Built-in value references. */ var Buffer = moduleExports$1 ? root$2.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
var isBuffer$1 = isBuffer;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER$1 = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER$1 : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/** `Object#toString` result references. */ var argsTag$1 = '[object Arguments]', arrayTag$1 = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag$1 = '[object Map]', numberTag = '[object Number]', objectTag$2 = '[object Object]', regexpTag = '[object RegExp]', setTag$1 = '[object Set]', stringTag = '[object String]', weakMapTag$1 = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag$1 = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag] = typedArrayTags[setTag$1] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag$1] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal$1.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var nodeUtil$1 = nodeUtil;
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray$1 = isTypedArray;
/** Used for built-in method references. */ var objectProto$4 = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$4 = objectProto$4.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray$1(value), isArg = !isArr && isArguments$1(value), isBuff = !isArr && !isArg && isBuffer$1(value), isType = !isArr && !isArg && !isBuff && isTypedArray$1(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty$4.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/** Used for built-in method references. */ var objectProto$3 = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$3;
    return value === proto;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
var nativeKeys$1 = nativeKeys;
/** Used for built-in method references. */ var objectProto$2 = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$3 = objectProto$2.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys$1(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty$3.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols$1);
}
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG$1 = 1;
/** Used for built-in method references. */ var objectProto$1 = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$2 = objectProto$1.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty$2.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/* Built-in method references that are verified to be native. */ var DataView = getNative(root$2, 'DataView');
var DataView$1 = DataView;
/* Built-in method references that are verified to be native. */ var Promise$1 = getNative(root$2, 'Promise');
var Promise$2 = Promise$1;
/* Built-in method references that are verified to be native. */ var Set$1 = getNative(root$2, 'Set');
var Set$2 = Set$1;
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root$2, 'WeakMap');
var WeakMap$1 = WeakMap;
/** `Object#toString` result references. */ var mapTag = '[object Map]', objectTag$1 = '[object Object]', promiseTag = '[object Promise]', setTag = '[object Set]', weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$2), promiseCtorString = toSource(Promise$2), setCtorString = toSource(Set$2), weakMapCtorString = toSource(WeakMap$1);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag || Map$2 && getTag(new Map$2) != mapTag || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set$2 && getTag(new Set$2) != setTag || WeakMap$1 && getTag(new WeakMap$1) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag$1 ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
var getTag$1 = getTag;
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', objectTag = '[object Object]';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty$1 = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray$1(object), othIsArr = isArray$1(other), objTag = objIsArr ? arrayTag : getTag$1(object), othTag = othIsArr ? arrayTag : getTag$1(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer$1(object)) {
        if (!isBuffer$1(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray$1(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty$1.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty$1.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
var CssTextField$1 = (0, $aIJrd.default)({
    root: {
        width: '100%',
        '& label.Mui-focused': {
            color: '#4F4F4F'
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                borderColor: '#00AAFC'
            }
        },
        '& .MuiFormHelperText-root': {
            color: 'red'
        }
    }
})((0, $eYT2J.default));
/**
 * Outlined Input: full width outlined input, customized from mui. API: https://material-ui.com/api/outlined-input/
 */ var outlinedInput = $ieT14.memo(function OutlinedInput(props) {
    return $ieT14.createElement(CssTextField$1, __assign({}, props, {
        margin: "normal",
        variant: "outlined"
    }));
}, function(prevProps, nextProps) {
    return isEqual(prevProps.value, nextProps.value) && isEqual(prevProps.error, nextProps.error);
});
var CssSelect = (0, $aIJrd.default)({
    root: {
        '& .MuiInputLabel-root': {
            background: 'white',
            color: neutral[600],
            fontFamily: fontFamilies.heading,
            fontWeight: 300,
            fontSize: '14px'
        },
        '& .MuiInputBase-root': {
            fontFamily: fontFamilies.body,
            minWidth: 125,
            '&.Mui-focused fieldset': {
                borderColor: blue[300]
            },
            '&.Mui-focused .MuiSelect-root': {
                backgroundColor: neutral[100]
            }
        }
    }
})((0, $whS22.default));
/**
 * Outlined Select, select component based styled MUI FormControl
 * Props for the styled FormControl component can be attached directly to this component (via ...rest)
 */ var OutlinedSelect = function(_a) {
    var id = _a.id, title = _a.title, handleChange = _a.handleChange, handleBlur = _a.handleBlur, options = _a.options, value = _a.value, selectProps = _a.selectProps, rest = __rest(_a, [
        "id",
        "title",
        "handleChange",
        "handleBlur",
        "options",
        "value",
        "selectProps"
    ]);
    return $ieT14.createElement(CssSelect, __assign({
        variant: "outlined",
        margin: "normal"
    }, rest), title && $ieT14.createElement((0, $Uxz4Y.default), null, title), $ieT14.createElement((0, $aanJt.default), __assign({
        native: true,
        id: id,
        value: value,
        onChange: handleChange,
        onBlur: handleBlur
    }, selectProps), options));
};
var reactTextMask = createCommonjsModule(function(module1, exports1) {
    !function(e, t) {
        module1.exports = t((0, (/*@__PURE__*/$parcel$interopDefault($ieT14))));
    }(commonjsGlobal, function(e) {
        return function(e) {
            function t(n) {
                if (r[n]) return r[n].exports;
                var o = r[n] = {
                    exports: {},
                    id: n,
                    loaded: !1
                };
                return e[n].call(o.exports, o, o.exports, t), o.loaded = !0, o.exports;
            }
            var r = {};
            return t.m = e, t.c = r, t.p = "", t(0);
        }([
            function(e, t, r) {
                function n(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                function o(e, t) {
                    var r = {};
                    for(var n in e)t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
                    return r;
                }
                function i(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function a(e, t) {
                    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return !t || "object" != typeof t && "function" != typeof t ? e : t;
                }
                function u(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.conformToMask = void 0;
                var s = Object.assign || function(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = arguments[t];
                        for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                    }
                    return e;
                }, l = function() {
                    function e(e, t) {
                        for(var r = 0; r < t.length; r++){
                            var n = t[r];
                            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                        }
                    }
                    return function(t, r, n) {
                        return r && e(t.prototype, r), n && e(t, n), t;
                    };
                }(), f = r(3);
                Object.defineProperty(t, "conformToMask", {
                    enumerable: !0,
                    get: function() {
                        return n(f).default;
                    }
                });
                var c = r(11), p = n(c), d = r(9), h = n(d), v = r(5), y = n(v), m = r(2), b = function(e) {
                    function t() {
                        var e;
                        i(this, t);
                        for(var r = arguments.length, n = Array(r), o = 0; o < r; o++)n[o] = arguments[o];
                        var u = a(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [
                            this
                        ].concat(n)));
                        return u.setRef = u.setRef.bind(u), u.onBlur = u.onBlur.bind(u), u.onChange = u.onChange.bind(u), u;
                    }
                    return u(t, e), l(t, [
                        {
                            key: "setRef",
                            value: function(e) {
                                this.inputElement = e;
                            }
                        },
                        {
                            key: "initTextMask",
                            value: function() {
                                var e = this.props, t = this.props.value;
                                this.textMaskInputElement = (0, y.default)(s({
                                    inputElement: this.inputElement
                                }, e)), this.textMaskInputElement.update(t);
                            }
                        },
                        {
                            key: "componentDidMount",
                            value: function() {
                                this.initTextMask();
                            }
                        },
                        {
                            key: "componentDidUpdate",
                            value: function(e) {
                                var t = this.props, r = t.value, n = t.pipe, o = t.mask, i = t.guide, a = t.placeholderChar, u = t.showMask, s = {
                                    guide: i,
                                    placeholderChar: a,
                                    showMask: u
                                }, l = "function" == typeof n && "function" == typeof e.pipe ? n.toString() !== e.pipe.toString() : (0, m.isNil)(n) && !(0, m.isNil)(e.pipe) || !(0, m.isNil)(n) && (0, m.isNil)(e.pipe), f = o.toString() !== e.mask.toString(), c = Object.keys(s).some(function(t) {
                                    return s[t] !== e[t];
                                }) || f || l, p = r !== this.inputElement.value;
                                (p || c) && this.initTextMask();
                            }
                        },
                        {
                            key: "render",
                            value: function e() {
                                var t = this.props, e = t.render, r = o(t, [
                                    "render"
                                ]);
                                return delete r.mask, delete r.guide, delete r.pipe, delete r.placeholderChar, delete r.keepCharPositions, delete r.value, delete r.onBlur, delete r.onChange, delete r.showMask, e(this.setRef, s({
                                    onBlur: this.onBlur,
                                    onChange: this.onChange,
                                    defaultValue: this.props.value
                                }, r));
                            }
                        },
                        {
                            key: "onChange",
                            value: function(e) {
                                this.textMaskInputElement.update(), "function" == typeof this.props.onChange && this.props.onChange(e);
                            }
                        },
                        {
                            key: "onBlur",
                            value: function(e) {
                                "function" == typeof this.props.onBlur && this.props.onBlur(e);
                            }
                        }
                    ]), t;
                }(p.default.PureComponent);
                t.default = b, b.propTypes = {
                    mask: h.default.oneOfType([
                        h.default.array,
                        h.default.func,
                        h.default.bool,
                        h.default.shape({
                            mask: h.default.oneOfType([
                                h.default.array,
                                h.default.func
                            ]),
                            pipe: h.default.func
                        })
                    ]).isRequired,
                    guide: h.default.bool,
                    value: h.default.oneOfType([
                        h.default.string,
                        h.default.number
                    ]),
                    pipe: h.default.func,
                    placeholderChar: h.default.string,
                    keepCharPositions: h.default.bool,
                    showMask: h.default.bool
                }, b.defaultProps = {
                    render: function(e, t) {
                        return p.default.createElement("input", s({
                            ref: e
                        }, t));
                    }
                };
            },
            function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.placeholderChar = "_", t.strFunction = "function";
            },
            function(e, t, r) {
                function n() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : f, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l.placeholderChar;
                    if (!o(e)) throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");
                    if (e.indexOf(t) !== -1) throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n" + ("The placeholder character that was received is: " + JSON.stringify(t) + "\n\n") + ("The mask that was received is: " + JSON.stringify(e)));
                    return e.map(function(e) {
                        return e instanceof RegExp ? t : e;
                    }).join("");
                }
                function o(e) {
                    return Array.isArray && Array.isArray(e) || e instanceof Array;
                }
                function i(e) {
                    return "string" == typeof e || e instanceof String;
                }
                function a(e) {
                    return "number" == typeof e && void 0 === e.length && !isNaN(e);
                }
                function u(e) {
                    return "undefined" == typeof e || null === e;
                }
                function s(e) {
                    for(var t = [], r = void 0; r = e.indexOf(c), r !== -1;)t.push(r), e.splice(r, 1);
                    return {
                        maskWithoutCaretTraps: e,
                        indexes: t
                    };
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.convertMaskToPlaceholder = n, t.isArray = o, t.isString = i, t.isNumber = a, t.isNil = u, t.processCaretTraps = s;
                var l = r(1), f = [], c = "[]";
            },
            function(e, t, r) {
                function n() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : s, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : u, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                    if (!(0, i.isArray)(t)) {
                        if (("undefined" == typeof t ? "undefined" : o(t)) !== a.strFunction) throw new Error("Text-mask:conformToMask; The mask property must be an array.");
                        t = t(e, r), t = (0, i.processCaretTraps)(t).maskWithoutCaretTraps;
                    }
                    var n = r.guide, l = void 0 === n || n, f = r.previousConformedValue, c = void 0 === f ? s : f, p = r.placeholderChar, d = void 0 === p ? a.placeholderChar : p, h = r.placeholder, v = void 0 === h ? (0, i.convertMaskToPlaceholder)(t, d) : h, y = r.currentCaretPosition, m = r.keepCharPositions, b = l === !1 && void 0 !== c, g = e.length, k = c.length, C = v.length, O = t.length, T = g - k, P = T > 0, x = y + (P ? -T : 0), w = x + Math.abs(T);
                    if (m === !0 && !P) {
                        for(var S = s, _ = x; _ < w; _++)v[_] === d && (S += d);
                        e = e.slice(0, x) + S + e.slice(x, g);
                    }
                    for(var M = e.split(s).map(function(e, t) {
                        return {
                            char: e,
                            isNew: t >= x && t < w
                        };
                    }), j = g - 1; j >= 0; j--){
                        var E = M[j].char;
                        if (E !== d) {
                            var R = j >= x && k === O;
                            E === v[R ? j - T : j] && M.splice(j, 1);
                        }
                    }
                    var V = s, N = !1;
                    e: for(var A = 0; A < C; A++){
                        var B = v[A];
                        if (B === d) {
                            if (M.length > 0) for(; M.length > 0;){
                                var I = M.shift(), F = I.char, q = I.isNew;
                                if (F === d && b !== !0) {
                                    V += d;
                                    continue e;
                                }
                                if (t[A].test(F)) {
                                    if (m === !0 && q !== !1 && c !== s && l !== !1 && P) {
                                        for(var D = M.length, L = null, W = 0; W < D; W++){
                                            var J = M[W];
                                            if (J.char !== d && J.isNew === !1) break;
                                            if (J.char === d) {
                                                L = W;
                                                break;
                                            }
                                        }
                                        null !== L ? (V += F, M.splice(L, 1)) : A--;
                                    } else V += F;
                                    continue e;
                                }
                                N = !0;
                            }
                            b === !1 && (V += v.substr(A, C));
                            break;
                        }
                        V += B;
                    }
                    if (b && P === !1) {
                        for(var U = null, H = 0; H < V.length; H++)v[H] === d && (U = H);
                        V = null !== U ? V.substr(0, U + 1) : s;
                    }
                    return {
                        conformedValue: V,
                        meta: {
                            someCharsRejected: N
                        }
                    };
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                };
                t.default = n;
                var i = r(2), a = r(1), u = [], s = "";
            },
            function(e, t) {
                function r(e) {
                    var t = e.previousConformedValue, r = void 0 === t ? o : t, i = e.previousPlaceholder, a = void 0 === i ? o : i, u = e.currentCaretPosition, s = void 0 === u ? 0 : u, l = e.conformedValue, f = e.rawValue, c = e.placeholderChar, p = e.placeholder, d = e.indexesOfPipedChars, h = void 0 === d ? n : d, v = e.caretTrapIndexes, y = void 0 === v ? n : v;
                    if (0 === s || !f.length) return 0;
                    var m = f.length, b = r.length, g = p.length, k = l.length, C = m - b, O = C > 0, T = 0 === b, P = C > 1 && !O && !T;
                    if (P) return s;
                    var x = O && (r === l || l === p), w = 0, S = void 0, _ = void 0;
                    if (x) w = s - C;
                    else {
                        var M = l.toLowerCase(), j = f.toLowerCase(), E = j.substr(0, s).split(o), R = E.filter(function(e) {
                            return M.indexOf(e) !== -1;
                        });
                        _ = R[R.length - 1];
                        var V = a.substr(0, R.length).split(o).filter(function(e) {
                            return e !== c;
                        }).length, N = p.substr(0, R.length).split(o).filter(function(e) {
                            return e !== c;
                        }).length, A = N !== V, B = void 0 !== a[R.length - 1] && void 0 !== p[R.length - 2] && a[R.length - 1] !== c && a[R.length - 1] !== p[R.length - 1] && a[R.length - 1] === p[R.length - 2];
                        !O && (A || B) && V > 0 && p.indexOf(_) > -1 && void 0 !== f[s] && (S = !0, _ = f[s]);
                        for(var I = h.map(function(e) {
                            return M[e];
                        }), F = I.filter(function(e) {
                            return e === _;
                        }).length, q = R.filter(function(e) {
                            return e === _;
                        }).length, D = p.substr(0, p.indexOf(c)).split(o).filter(function(e, t) {
                            return e === _ && f[t] !== e;
                        }).length, L = D + q + F + (S ? 1 : 0), W = 0, J = 0; J < k; J++){
                            var U = M[J];
                            if (w = J + 1, U === _ && W++, W >= L) break;
                        }
                    }
                    if (O) {
                        for(var H = w, Y = w; Y <= g; Y++)if (p[Y] === c && (H = Y), p[Y] === c || y.indexOf(Y) !== -1 || Y === g) return H;
                    } else if (S) {
                        for(var z = w - 1; z >= 0; z--)if (l[z] === _ || y.indexOf(z) !== -1 || 0 === z) return z;
                    } else for(var G = w; G >= 0; G--)if (p[G - 1] === c || y.indexOf(G) !== -1 || 0 === G) return G;
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = r;
                var n = [], o = "";
            },
            function(e, t, r) {
                function n(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                function o(e) {
                    var t = {
                        previousConformedValue: void 0,
                        previousPlaceholder: void 0
                    };
                    return {
                        state: t,
                        update: function(r) {
                            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e, o = n.inputElement, l = n.mask, c = n.guide, y = n.pipe, b = n.placeholderChar, g = void 0 === b ? h.placeholderChar : b, k = n.keepCharPositions, C = void 0 !== k && k, O = n.showMask, T = void 0 !== O && O;
                            if ("undefined" == typeof r && (r = o.value), r !== t.previousConformedValue) {
                                ("undefined" == typeof l ? "undefined" : s(l)) === m && void 0 !== l.pipe && void 0 !== l.mask && (y = l.pipe, l = l.mask);
                                var P = void 0, x = void 0;
                                if (l instanceof Array && (P = (0, d.convertMaskToPlaceholder)(l, g)), l !== !1) {
                                    var w = a(r), S = o.selectionEnd, _ = t.previousConformedValue, M = t.previousPlaceholder, j = void 0;
                                    if (("undefined" == typeof l ? "undefined" : s(l)) === h.strFunction) {
                                        if (x = l(w, {
                                            currentCaretPosition: S,
                                            previousConformedValue: _,
                                            placeholderChar: g
                                        }), x === !1) return;
                                        var E = (0, d.processCaretTraps)(x), R = E.maskWithoutCaretTraps, V = E.indexes;
                                        x = R, j = V, P = (0, d.convertMaskToPlaceholder)(x, g);
                                    } else x = l;
                                    var N = {
                                        previousConformedValue: _,
                                        guide: c,
                                        placeholderChar: g,
                                        pipe: y,
                                        placeholder: P,
                                        currentCaretPosition: S,
                                        keepCharPositions: C
                                    }, A = (0, p.default)(w, x, N), B = A.conformedValue, I = ("undefined" == typeof y ? "undefined" : s(y)) === h.strFunction, F = {};
                                    I && (F = y(B, u({
                                        rawValue: w
                                    }, N)), F === !1 ? F = {
                                        value: _,
                                        rejected: !0
                                    } : (0, d.isString)(F) && (F = {
                                        value: F
                                    }));
                                    var q = I ? F.value : B, D = (0, f.default)({
                                        previousConformedValue: _,
                                        previousPlaceholder: M,
                                        conformedValue: q,
                                        placeholder: P,
                                        rawValue: w,
                                        currentCaretPosition: S,
                                        placeholderChar: g,
                                        indexesOfPipedChars: F.indexesOfPipedChars,
                                        caretTrapIndexes: j
                                    }), L = q === P && 0 === D, W = T ? P : v, J = L ? W : q;
                                    t.previousConformedValue = J, t.previousPlaceholder = P, o.value !== J && (o.value = J, i(o, D));
                                }
                            }
                        }
                    };
                }
                function i(e, t) {
                    document.activeElement === e && (b ? g(function() {
                        return e.setSelectionRange(t, t, y);
                    }, 0) : e.setSelectionRange(t, t, y));
                }
                function a(e) {
                    if ((0, d.isString)(e)) return e;
                    if ((0, d.isNumber)(e)) return String(e);
                    if (void 0 === e || null === e) return v;
                    throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n " + JSON.stringify(e));
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var u = Object.assign || function(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = arguments[t];
                        for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                    }
                    return e;
                }, s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                };
                t.default = o;
                var l = r(4), f = n(l), c = r(3), p = n(c), d = r(2), h = r(1), v = "", y = "none", m = "object", b = "undefined" != typeof navigator && /Android/i.test(navigator.userAgent), g = "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : setTimeout;
            },
            function(e, t) {
                function r(e) {
                    return function() {
                        return e;
                    };
                }
                var n = function() {};
                n.thatReturns = r, n.thatReturnsFalse = r(!1), n.thatReturnsTrue = r(!0), n.thatReturnsNull = r(null), n.thatReturnsThis = function() {
                    return this;
                }, n.thatReturnsArgument = function(e) {
                    return e;
                }, e.exports = n;
            },
            function(e, t, r) {
                function n(e, t, r, n, i, a, u, s) {
                    if (!e) {
                        var l;
                        if (void 0 === t) l = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
                        else {
                            var f = [
                                r,
                                n,
                                i,
                                a,
                                u,
                                s
                            ], c = 0;
                            l = new Error(t.replace(/%s/g, function() {
                                return f[c++];
                            })), l.name = "Invariant Violation";
                        }
                        throw l.framesToPop = 1, l;
                    }
                }
                e.exports = n;
            },
            function(e, t, r) {
                var n = r(6), o = r(7), i = r(10);
                e.exports = function() {
                    function e(e, t, r, n, a, u) {
                        u !== i && o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                    }
                    function t() {
                        return e;
                    }
                    e.isRequired = e;
                    var r = {
                        array: e,
                        bool: e,
                        func: e,
                        number: e,
                        object: e,
                        string: e,
                        symbol: e,
                        any: e,
                        arrayOf: t,
                        element: e,
                        instanceOf: t,
                        node: e,
                        objectOf: t,
                        oneOf: t,
                        oneOfType: t,
                        shape: t,
                        exact: t
                    };
                    return r.checkPropTypes = n, r.PropTypes = r, r;
                };
            },
            function(e, t, r) {
                e.exports = r(8)();
            },
            function(e, t) {
                var r = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
                e.exports = r;
            },
            function(t, r) {
                t.exports = e;
            }
        ]);
    });
});
var MaskedInput = /*@__PURE__*/ unwrapExports(reactTextMask);
var useStyles$8 = (0, $e1ONw.default)({
    root: {
        '&::placeholder': {
            color: 'black',
            opacity: '1'
        }
    }
});
/**
 * Mask for phone number inputs showing guides in format `(555) 555-5555`. To be used as the component in an OutlinedInput as `InputProps={{ inputComponent: PhoneInputMask as any }}`
 */ var PhoneInputMask = function(props) {
    var inputRef = props.inputRef, className = props.className, other = __rest(props, [
        "inputRef",
        "className"
    ]);
    var classes = useStyles$8();
    return $ieT14.createElement(MaskedInput, __assign({}, other, {
        ref: function(ref) {
            inputRef(ref ? ref.inputElement : null);
        },
        mask: [
            '(',
            /[1-9]/,
            /\d/,
            /\d/,
            ')',
            ' ',
            /\d/,
            /\d/,
            /\d/,
            '-',
            /\d/,
            /\d/,
            /\d/,
            /\d/
        ],
        placeholder: '(\u2000\u2000\u2000) \u2000\u2000\u2000-\u2000\u2000\u2000\u2000',
        placeholderChar: '\u2000',
        className: clsx(classes.root, className)
    }));
};
function chainPropTypes(propType1, propType2) {
    return function() {
        return null;
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _typeof$1(obj) {
    "@babel/helpers - typeof";
    return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof$1(obj);
}
function isPlainObject(item) {
    return item && _typeof$1(item) === 'object' && item.constructor === Object;
}
function deepmerge(target, source) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        clone: true
    };
    var output = options.clone ? _extends({}, target) : target;
    if (isPlainObject(target) && isPlainObject(source)) Object.keys(source).forEach(function(key) {
        // Avoid prototype pollution
        if (key === '__proto__') return;
        if (isPlainObject(source[key]) && key in target) output[key] = deepmerge(target[key], source[key], options);
        else output[key] = source[key];
    });
    return output;
}
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var b$1 = "function" === typeof Symbol && Symbol.for, c$1 = b$1 ? Symbol.for("react.element") : 60103, d$1 = b$1 ? Symbol.for("react.portal") : 60106, e$1 = b$1 ? Symbol.for("react.fragment") : 60107, f$1 = b$1 ? Symbol.for("react.strict_mode") : 60108, g$1 = b$1 ? Symbol.for("react.profiler") : 60114, h$1 = b$1 ? Symbol.for("react.provider") : 60109, k$1 = b$1 ? Symbol.for("react.context") : 60110, l$1 = b$1 ? Symbol.for("react.async_mode") : 60111, m$1 = b$1 ? Symbol.for("react.concurrent_mode") : 60111, n$1 = b$1 ? Symbol.for("react.forward_ref") : 60112, p$1 = b$1 ? Symbol.for("react.suspense") : 60113, q$1 = b$1 ? Symbol.for("react.suspense_list") : 60120, r$1 = b$1 ? Symbol.for("react.memo") : 60115, t = b$1 ? Symbol.for("react.lazy") : 60116, v$1 = b$1 ? Symbol.for("react.block") : 60121, w$1 = b$1 ? Symbol.for("react.fundamental") : 60117, x$1 = b$1 ? Symbol.for("react.responder") : 60118, y$1 = b$1 ? Symbol.for("react.scope") : 60119;
function z$1(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c$1:
                switch(a = a.type, a){
                    case l$1:
                    case m$1:
                    case e$1:
                    case g$1:
                    case f$1:
                    case p$1:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k$1:
                            case n$1:
                            case t:
                            case r$1:
                            case h$1:
                                return a;
                            default:
                                return u;
                        }
                }
            case d$1:
                return u;
        }
    }
}
function A$1(a) {
    return z$1(a) === m$1;
}
var AsyncMode = l$1;
var ConcurrentMode = m$1;
var ContextConsumer$1 = k$1;
var ContextProvider$1 = h$1;
var Element$1 = c$1;
var ForwardRef$1 = n$1;
var Fragment$1 = e$1;
var Lazy$1 = t;
var Memo$1 = r$1;
var Portal$1 = d$1;
var Profiler$1 = g$1;
var StrictMode$1 = f$1;
var Suspense$1 = p$1;
var isAsyncMode$1 = function(a) {
    return A$1(a) || z$1(a) === l$1;
};
var isConcurrentMode$1 = A$1;
var isContextConsumer$1 = function(a) {
    return z$1(a) === k$1;
};
var isContextProvider$1 = function(a) {
    return z$1(a) === h$1;
};
var isElement$1 = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c$1;
};
var isForwardRef$1 = function(a) {
    return z$1(a) === n$1;
};
var isFragment$1 = function(a) {
    return z$1(a) === e$1;
};
var isLazy$1 = function(a) {
    return z$1(a) === t;
};
var isMemo$1 = function(a) {
    return z$1(a) === r$1;
};
var isPortal$1 = function(a) {
    return z$1(a) === d$1;
};
var isProfiler$1 = function(a) {
    return z$1(a) === g$1;
};
var isStrictMode$1 = function(a) {
    return z$1(a) === f$1;
};
var isSuspense$1 = function(a) {
    return z$1(a) === p$1;
};
var isValidElementType$1 = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e$1 || a === m$1 || a === g$1 || a === f$1 || a === p$1 || a === q$1 || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r$1 || a.$$typeof === h$1 || a.$$typeof === k$1 || a.$$typeof === n$1 || a.$$typeof === w$1 || a.$$typeof === x$1 || a.$$typeof === y$1 || a.$$typeof === v$1);
};
var typeOf$1 = z$1;
var reactIs_production_min$1 = {
    AsyncMode: AsyncMode,
    ConcurrentMode: ConcurrentMode,
    ContextConsumer: ContextConsumer$1,
    ContextProvider: ContextProvider$1,
    Element: Element$1,
    ForwardRef: ForwardRef$1,
    Fragment: Fragment$1,
    Lazy: Lazy$1,
    Memo: Memo$1,
    Portal: Portal$1,
    Profiler: Profiler$1,
    StrictMode: StrictMode$1,
    Suspense: Suspense$1,
    isAsyncMode: isAsyncMode$1,
    isConcurrentMode: isConcurrentMode$1,
    isContextConsumer: isContextConsumer$1,
    isContextProvider: isContextProvider$1,
    isElement: isElement$1,
    isForwardRef: isForwardRef$1,
    isFragment: isFragment$1,
    isLazy: isLazy$1,
    isMemo: isMemo$1,
    isPortal: isPortal$1,
    isProfiler: isProfiler$1,
    isStrictMode: isStrictMode$1,
    isSuspense: isSuspense$1,
    isValidElementType: isValidElementType$1,
    typeOf: typeOf$1
};
var reactIs_development$1 = createCommonjsModule(function(module1, exports1) {});
var reactIs$2 = createCommonjsModule(function(module1) {
    module1.exports = reactIs_production_min$1;
});
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ /* eslint-disable no-unused-vars */ var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
var objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
        if (getOwnPropertySymbols$1) {
            symbols = getOwnPropertySymbols$1(from);
            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret$2;
var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);
var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var has$1 = has$2;
var printWarning$1 = function() {};
var ReactPropTypesSecret, loggedTypeFailures, has;
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
    var typeSpecName, error, err, ex, stack;
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ checkPropTypes$1.resetWarningCache = function() {};
var checkPropTypes_1 = checkPropTypes$1;
var checkPropTypes = checkPropTypes_1;
var printWarning = function() {};
function emptyFunctionThatReturnsNull() {
    return null;
}
var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === 'function') return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = '<<anonymous>>';
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker('array'),
        bigint: createPrimitiveTypeChecker('bigint'),
        bool: createPrimitiveTypeChecker('boolean'),
        func: createPrimitiveTypeChecker('function'),
        number: createPrimitiveTypeChecker('number'),
        object: createPrimitiveTypeChecker('object'),
        string: createPrimitiveTypeChecker('string'),
        symbol: createPrimitiveTypeChecker('symbol'),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === 'object' ? data : {};
        this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache, manualPropTypeWarningCount;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== ReactPropTypesSecret$1) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = 'Invariant Violation';
                    throw err;
                } else var cacheKey;
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                    return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
                    expectedType: expectedType
                });
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!reactIs$2.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) return emptyFunctionThatReturnsNull;
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === 'symbol') return String(value);
                return value;
            });
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
            for(var key in propValue)if (has$1(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) return emptyFunctionThatReturnsNull;
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== 'function') {
                printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
                return emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            var expectedTypes = [];
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
                if (checkerResult == null) return null;
                if (checkerResult.data && has$1(checkerResult.data, 'expectedType')) expectedTypes.push(checkerResult.data.expectedType);
            }
            var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            // We need to check all keys in case some are required but missing from props.
            var allKeys = objectAssign({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if (has$1(shapeTypes, key) && typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                if (!checker) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case 'number':
            case 'string':
            case 'undefined':
                return true;
            case 'boolean':
                return !propValue;
            case 'object':
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue['@@toStringTag'] === 'Symbol') return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === 'function' && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return 'array';
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
        if (isSymbol(propType, propValue)) return 'symbol';
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === 'undefined' || propValue === null) return '' + propValue;
        var propType = getPropType(propValue);
        if (propType === 'object') {
            if (propValue instanceof Date) return 'date';
            else if (propValue instanceof RegExp) return 'regexp';
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case 'array':
            case 'object':
                return 'an ' + type;
            case 'boolean':
            case 'date':
            case 'regexp':
                return 'a ' + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret$1) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    } // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};
var require$$1 = factoryWithTypeCheckers;
var require$$2 = factoryWithThrowingShims;
var propTypes = createCommonjsModule(function(module1) {
    var ReactIs, throwOnDirectAccess;
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module1.exports = require$$2();
});
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
function exactProp(propTypes) {
    return propTypes;
}
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var b = 60103, c = 60106, d = 60107, e = 60108, f = 60114, g = 60109, h = 60110, k = 60112, l = 60113, m = 60120, n = 60115, p = 60116, q = 60121, r = 60122, u = 60117, v = 60129, w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var x = Symbol.for;
    b = x("react.element");
    c = x("react.portal");
    d = x("react.fragment");
    e = x("react.strict_mode");
    f = x("react.profiler");
    g = x("react.provider");
    h = x("react.context");
    k = x("react.forward_ref");
    l = x("react.suspense");
    m = x("react.suspense_list");
    n = x("react.memo");
    p = x("react.lazy");
    q = x("react.block");
    r = x("react.server.block");
    u = x("react.fundamental");
    v = x("react.debug_trace_mode");
    w = x("react.legacy_hidden");
}
function y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case b:
                switch(a = a.type, a){
                    case d:
                    case f:
                    case e:
                    case l:
                    case m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case h:
                            case k:
                            case p:
                            case n:
                            case g:
                                return a;
                            default:
                                return t;
                        }
                }
            case c:
                return t;
        }
    }
}
var z = g, A = b, B = k, C = d, D = p, E = n, F = c, G = f, H = e, I = l;
var ContextConsumer = h;
var ContextProvider = z;
var Element = A;
var ForwardRef = B;
var Fragment = C;
var Lazy = D;
var Memo = E;
var Portal = F;
var Profiler = G;
var StrictMode = H;
var Suspense = I;
var isAsyncMode = function() {
    return !1;
};
var isConcurrentMode = function() {
    return !1;
};
var isContextConsumer = function(a) {
    return y(a) === h;
};
var isContextProvider = function(a) {
    return y(a) === g;
};
var isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
};
var isForwardRef = function(a) {
    return y(a) === k;
};
var isFragment = function(a) {
    return y(a) === d;
};
var isLazy = function(a) {
    return y(a) === p;
};
var isMemo = function(a) {
    return y(a) === n;
};
var isPortal = function(a) {
    return y(a) === c;
};
var isProfiler = function(a) {
    return y(a) === f;
};
var isStrictMode = function(a) {
    return y(a) === e;
};
var isSuspense = function(a) {
    return y(a) === l;
};
var isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === v || a === e || a === l || a === m || a === w || "object" === typeof a && null !== a && (a.$$typeof === p || a.$$typeof === n || a.$$typeof === g || a.$$typeof === h || a.$$typeof === k || a.$$typeof === u || a.$$typeof === q || a[0] === r) ? !0 : !1;
};
var typeOf = y;
var reactIs_production_min = {
    ContextConsumer: ContextConsumer,
    ContextProvider: ContextProvider,
    Element: Element,
    ForwardRef: ForwardRef,
    Fragment: Fragment,
    Lazy: Lazy,
    Memo: Memo,
    Portal: Portal,
    Profiler: Profiler,
    StrictMode: StrictMode,
    Suspense: Suspense,
    isAsyncMode: isAsyncMode,
    isConcurrentMode: isConcurrentMode,
    isContextConsumer: isContextConsumer,
    isContextProvider: isContextProvider,
    isElement: isElement,
    isForwardRef: isForwardRef,
    isFragment: isFragment,
    isLazy: isLazy,
    isMemo: isMemo,
    isPortal: isPortal,
    isProfiler: isProfiler,
    isStrictMode: isStrictMode,
    isSuspense: isSuspense,
    isValidElementType: isValidElementType,
    typeOf: typeOf
};
var reactIs_development = createCommonjsModule(function(module1, exports1) {});
var reactIs = createCommonjsModule(function(module1) {
    module1.exports = reactIs_production_min;
});
var reactIs$1 = reactIs;
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
    var match = "".concat(fn).match(fnNameMatchRegex);
    var name = match && match[1];
    return name || '';
}
/**
 * @param {function} Component
 * @param {string} fallback
 * @returns {string | undefined}
 */ function getFunctionComponentName(Component) {
    var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}
function getWrappedName(outerType, innerType, wrapperName) {
    var functionName = getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE 11 support
 *
 * @param {React.ReactType} Component
 * @returns {string | undefined}
 */ function getDisplayName(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return getFunctionComponentName(Component, 'Component');
    if (_typeof$1(Component) === 'object') switch(Component.$$typeof){
        case reactIs$1.ForwardRef:
            return getWrappedName(Component, Component.render, 'ForwardRef');
        case reactIs$1.Memo:
            return getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var nested = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';
/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */ var pseudoClasses = [
    'checked',
    'disabled',
    'error',
    'focused',
    'focusVisible',
    'required',
    'expanded',
    'selected'
]; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js
function createGenerateClassName() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$disableGloba = options.disableGlobal, disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba, _options$productionPr = options.productionPrefix, productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr, _options$seed = options.seed, seed = _options$seed === void 0 ? '' : _options$seed;
    var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
    var ruleCounter = 0;
    var getNextCounterId = function getNextCounterId() {
        ruleCounter += 1;
        return ruleCounter;
    };
    return function(rule, styleSheet) {
        var name = styleSheet.options.name; // Is a global static MUI style?
        if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if (pseudoClasses.indexOf(rule.key) !== -1) return "Mui-".concat(rule.key);
            var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
            if (!styleSheet.options.theme[nested] || seed !== '') return prefix;
            return "".concat(prefix, "-").concat(getNextCounterId());
        }
        var suffix;
        return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    };
}
/* eslint-disable no-restricted-syntax */ function getThemeProps(params) {
    var theme = params.theme, name = params.name, props = params.props;
    if (!theme || !theme.props || !theme.props[name]) return props;
     // Resolve default props, code borrow from React source.
    // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
    var defaultProps = theme.props[name];
    var propName;
    for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
    return props;
}
var isProduction = true;
function warning(condition, message) {
    if (!isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
    if (style == null || typeof style !== 'object') return style;
    if (Array.isArray(style)) return style.map(cloneStyle);
    if (style.constructor !== plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function createRule(name, decl, options) {
    if (name === void 0) name = 'unnamed';
    var jss = options.jss;
    var declCopy = cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var join = function join(value, by) {
    var result = '';
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === '!important') break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var toCssValue = function toCssValue(value, ignoreImportant) {
    if (ignoreImportant === void 0) ignoreImportant = false;
    if (!Array.isArray(value)) return value;
    var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === '!important') break;
        if (cssValue) cssValue += ', ';
        cssValue += join(value[i], ' ');
    }
    else cssValue = join(value, ', '); // Add !important, because it was ignored.
    if (!ignoreImportant && value[value.length - 1] === '!important') cssValue += ' !important';
    return cssValue;
};
function getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: '',
        space: ''
    };
    return {
        linebreak: '\n',
        space: ' '
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function indentStr(str, indent) {
    var result = '';
    for(var index = 0; index < indent; index++)result += '  ';
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = '';
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== 'fallbacks') {
            if (result) result += linebreak;
            result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = function(str) {
    return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
};
var BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = 'style';
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    _inheritsLoose(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId(_assertThisInitialized(_assertThisInitialized(_this)), sheet);
            _this.selectorText = "." + escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    };
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== 'object') json[prop] = value;
            else if (Array.isArray(value)) json[prop] = toCssValue(value);
        }
        return json;
    };
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? _extends({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.selectorText, this.style, opts);
    };
    _createClass(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') return null;
        return new StyleRule(key, style, options);
    }
};
var defaultToStringOptions = {
    indent: 1,
    children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = 'conditional';
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match(atRegExp);
        this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new RuleList(_extends({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    };
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    };
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    };
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    };
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions.indent;
        if (options.children == null) options.children = defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
    };
    return ConditionalRule;
}();
var keyRegExp = /@media|@supports\s+/;
var pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
    }
};
var defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = 'keyframes';
        this.at = '@keyframes';
        this.isProcessed = false;
        var nameMatch = key.match(nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = 'noname';
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : escape(generateId(this, sheet));
        this.rules = new RuleList(_extends({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], _extends({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions$1;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
        if (options.children == null) options.children = defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp$1 = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === 'string') return val.replace(refRegExp$1, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style' || !sheet) return style;
        if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
        if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case 'animation':
                return findReferencedKeyframe(val, sheet.keyframes);
            case 'animation-name':
                return findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    _inheritsLoose(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? _extends({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === 'keyframes') return new KeyframeRule(key, style, options);
        return null;
    }
};
var FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = 'font-face';
        this.at = '@font-face';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = '';
            for(var index = 0; index < this.style.length; index++){
                str += toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
    }
};
var ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = 'viewport';
        this.at = '@viewport';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
    }
};
var SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = 'simple';
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = '';
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += '\n';
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var keysMap = {
    '@charset': true,
    '@import': true,
    '@namespace': true
};
var pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in keysMap ? new SimpleRule(key, value, options) : null;
    }
};
var plugins$1 = [
    pluginStyleRule,
    pluginConditionalRule,
    pluginKeyframesRule,
    pluginKeyframeRule,
    pluginFontFaceRule,
    pluginViewportRule,
    pluginSimpleRule
];
var defaultUpdateOptions = {
    process: true
};
var forceUpdateOptions = {
    force: true,
    process: true
};
var RuleList = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = _extends({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + escape(this.classes[key]);
        var rule = createRule(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    };
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = _extends({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    };
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    };
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    };
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    };
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    };
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    };
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof KeyframesRule) delete this.keyframes[rule.name];
    };
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    };
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, forceUpdateOptions);
            }
        }
    };
    _proto.toString = function toString(options) {
        var str = '';
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = _extends({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new RuleList(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    };
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    };
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    };
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    };
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    };
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    };
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    };
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === 'object' ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    };
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    };
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    };
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    };
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    };
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    };
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    };
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    };
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    };
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    };
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    };
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: 'external'
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var SheetsRegistry = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    };
    _proto.reset = function reset() {
        this.registry = [];
    };
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    };
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = _objectWithoutPropertiesLoose(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = '';
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    _createClass(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var sheets = new SheetsRegistry();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var createGenerateId = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = '';
        var prefix = '';
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return '';
    }
};
/**
 * Set a style property.
 */ var setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) {
            cssValue = toCssValue(value, true);
            if (value[value.length - 1] === '!important') {
                cssRule.style.setProperty(prop, cssValue, 'important');
                return true;
            }
        } // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else cssRule.style.setProperty(prop, cssValue);
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var getHead = memoize(function() {
    return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function findCommentNode(text) {
    var head = getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function findPrevNode(options) {
    var registry = sheets.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === 'string') {
        var comment = findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var getNonce = memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute('content') : null;
});
var _insertRule = function insertRule(container, rule, index) {
    try {
        if ('insertRule' in container) container.insertRule(rule, index);
        else if ('appendRule' in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var createStyle = function createStyle() {
    var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = '\n';
    return el;
};
var DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = getPropertyValue;
        this.setProperty = setProperty;
        this.removeProperty = removeProperty;
        this.setSelector = setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) sheets.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || createStyle();
        this.element.setAttribute('data-jss', '');
        if (media) this.element.setAttribute('media', media);
        if (meta) this.element.setAttribute('data-meta', meta);
        var nonce = getNonce();
        if (nonce) this.element.setAttribute('nonce', nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    };
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = '\n';
        }
    };
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    };
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    };
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === 'conditional' || rule.type === 'keyframes') {
                var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = _insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof StyleSheet) this.cssRules.splice(index, 0, cssRule);
    };
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    };
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    };
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    };
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var instanceCounter = 0;
var Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = instanceCounter++;
        this.version = "10.9.0";
        this.plugins = new PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: createGenerateId,
            Renderer: isBrowser ? DomRenderer : null,
            plugins: []
        };
        this.generateId = createGenerateId({
            minify: false
        });
        for(var i = 0; i < plugins$1.length; i++)this.plugins.use(plugins$1[i], {
            queue: 'internal'
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = _extends({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ('Renderer' in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    };
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== 'number') index = sheets.index === 0 ? 0 : sheets.index + 1;
        var sheet = new StyleSheet(styles, _extends({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    };
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        sheets.remove(sheet);
        return this;
    };
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === 'object') return this.createRule(undefined, name, style);
        var ruleOptions = _extends({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = createRule(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    };
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var createJss = function createJss(options) {
    return new Jss(options);
};
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function getDynamicStyles(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === 'function') {
            if (!to) to = {};
            to[key] = value;
        } else if (type === 'object' && value !== null && !Array.isArray(value)) {
            var extracted = getDynamicStyles(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ createJss();
var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;
var functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== 'function') return null;
            var rule = createRule(name, {}, options);
            rule[fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if (fnValuesNs in rule || fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== 'function') continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var functions = functionPlugin;
var at = '@global';
var atPrefix = '@global ';
var GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = 'global';
        this.at = at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new RuleList(_extends({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    };
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    };
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    };
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    };
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = 'global';
        this.at = at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr(atPrefix.length);
        this.rule = options.jss.createRule(selector, style, _extends({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : '';
    };
    return GlobalPrefixedRule;
}();
var separatorRegExp$1 = /\s*,\s*/g;
function addScope(selector, scope) {
    var parts = selector.split(separatorRegExp$1);
    var scoped = '';
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ', ';
    }
    return scoped;
}
function handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], _extends({}, options, {
        selector: addScope(name, rule.selector)
    }));
    delete style[at];
}
function handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
        var selector = addScope(prop.substr(at.length), rule.selector);
        sheet.addRule(selector, style[prop], _extends({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === at) return new GlobalContainerRule(name, styles, options);
        if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) return new GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== 'style' || !sheet) return;
        handleNestedGlobalContainerRule(rule, sheet);
        handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split(separatorRegExp);
        var nestedSelectors = nestedProp.split(separatorRegExp);
        var result = '';
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return _extends({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = _extends({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style') return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf('&') !== -1;
            var isNestedConditional = prop[0] === '@';
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace(refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ('replaceRule' in container) // for backward compatibility
                container.replaceRule(name, style[prop], _extends({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], _extends({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
/* eslint-disable no-var, prefer-template */ var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache$2 = {};
function toHyphenLower(match) {
    return '-' + match.toLowerCase();
}
function hyphenateStyleName(name) {
    if (cache$2.hasOwnProperty(name)) return cache$2[name];
    var hName = name.replace(uppercasePattern, toHyphenLower);
    return cache$2[name] = msPattern.test(hName) ? '-' + hName : hName;
}
/**
 * Convert camel cased property names to dash separated.
 */ function convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf('--') === 0 ? prop : hyphenateStyleName(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);
        else converted.fallbacks = convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = convertCase(style[index]);
            return style;
        }
        return convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf('--') === 0) return value;
        var hyphenatedProp = hyphenateStyleName(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var px = hasCSSTOMSupport && CSS ? CSS.px : 'px';
var ms = hasCSSTOMSupport && CSS ? CSS.ms : 'ms';
var percent = hasCSSTOMSupport && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var defaultUnits = {
    // Animation properties
    'animation-delay': ms,
    'animation-duration': ms,
    // Background properties
    'background-position': px,
    'background-position-x': px,
    'background-position-y': px,
    'background-size': px,
    // Border Properties
    border: px,
    'border-bottom': px,
    'border-bottom-left-radius': px,
    'border-bottom-right-radius': px,
    'border-bottom-width': px,
    'border-left': px,
    'border-left-width': px,
    'border-radius': px,
    'border-right': px,
    'border-right-width': px,
    'border-top': px,
    'border-top-left-radius': px,
    'border-top-right-radius': px,
    'border-top-width': px,
    'border-width': px,
    'border-block': px,
    'border-block-end': px,
    'border-block-end-width': px,
    'border-block-start': px,
    'border-block-start-width': px,
    'border-block-width': px,
    'border-inline': px,
    'border-inline-end': px,
    'border-inline-end-width': px,
    'border-inline-start': px,
    'border-inline-start-width': px,
    'border-inline-width': px,
    'border-start-start-radius': px,
    'border-start-end-radius': px,
    'border-end-start-radius': px,
    'border-end-end-radius': px,
    // Margin properties
    margin: px,
    'margin-bottom': px,
    'margin-left': px,
    'margin-right': px,
    'margin-top': px,
    'margin-block': px,
    'margin-block-end': px,
    'margin-block-start': px,
    'margin-inline': px,
    'margin-inline-end': px,
    'margin-inline-start': px,
    // Padding properties
    padding: px,
    'padding-bottom': px,
    'padding-left': px,
    'padding-right': px,
    'padding-top': px,
    'padding-block': px,
    'padding-block-end': px,
    'padding-block-start': px,
    'padding-inline': px,
    'padding-inline-end': px,
    'padding-inline-start': px,
    // Mask properties
    'mask-position-x': px,
    'mask-position-y': px,
    'mask-size': px,
    // Width and height properties
    height: px,
    width: px,
    'min-height': px,
    'max-height': px,
    'min-width': px,
    'max-width': px,
    // Position properties
    bottom: px,
    left: px,
    top: px,
    right: px,
    inset: px,
    'inset-block': px,
    'inset-block-end': px,
    'inset-block-start': px,
    'inset-inline': px,
    'inset-inline-end': px,
    'inset-inline-start': px,
    // Shadow properties
    'box-shadow': px,
    'text-shadow': px,
    // Column properties
    'column-gap': px,
    'column-rule': px,
    'column-rule-width': px,
    'column-width': px,
    // Font and text properties
    'font-size': px,
    'font-size-delta': px,
    'letter-spacing': px,
    'text-decoration-thickness': px,
    'text-indent': px,
    'text-stroke': px,
    'text-stroke-width': px,
    'word-spacing': px,
    // Motion properties
    motion: px,
    'motion-offset': px,
    // Outline properties
    outline: px,
    'outline-offset': px,
    'outline-width': px,
    // Perspective properties
    perspective: px,
    'perspective-origin-x': percent,
    'perspective-origin-y': percent,
    // Transform properties
    'transform-origin': percent,
    'transform-origin-x': percent,
    'transform-origin-y': percent,
    'transform-origin-z': percent,
    // Transition properties
    'transition-delay': ms,
    'transition-duration': ms,
    // Alignment properties
    'vertical-align': px,
    'flex-basis': px,
    // Some random properties
    'shape-margin': px,
    size: px,
    gap: px,
    // Grid properties
    grid: px,
    'grid-gap': px,
    'row-gap': px,
    'grid-row-gap': px,
    'grid-column-gap': px,
    'grid-template-rows': px,
    'grid-template-columns': px,
    'grid-auto-rows': px,
    'grid-auto-columns': px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    'box-shadow-x': px,
    'box-shadow-y': px,
    'box-shadow-blur': px,
    'box-shadow-spread': px,
    'font-line-height': px,
    'text-shadow-x': px,
    'text-shadow-y': px,
    'text-shadow-blur': px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */ function iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = iterate(prop, value[i], options);
    else if (typeof value === 'object') {
        if (prop === 'fallbacks') for(var innerProp in value)value[innerProp] = iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === 'number' && isNaN(value) === false) {
        var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === px)) return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        for(var prop in style)style[prop] = iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
// Export javascript style and css style vendor prefixes.
var js = '';
var css = '';
var vendor = '';
var browser = '';
var isTouch = isBrowser && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.
if (isBrowser) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var jsCssMap = {
        Moz: '-moz-',
        ms: '-ms-',
        O: '-o-',
        Webkit: '-webkit-'
    };
    var _document$createEleme = document.createElement('p'), style$1 = _document$createEleme.style;
    var testProp = 'Transform';
    for(var key in jsCssMap)if (key + testProp in style$1) {
        js = key;
        css = jsCssMap[key];
        break;
    }
     // Correctly detect the Edge browser.
    if (js === 'Webkit' && 'msHyphens' in style$1) {
        js = 'ms';
        css = jsCssMap.ms;
        browser = 'edge';
    } // Correctly detect the Safari browser.
    if (js === 'Webkit' && '-apple-trailing-word' in style$1) vendor = 'apple';
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var prefix = {
    js: js,
    css: css,
    vendor: vendor,
    browser: browser,
    isTouch: isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function supportedKeyframes(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if (prefix.js === 'ms') return key;
    return "@" + prefix.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var appearence = {
    noPrefill: [
        'appearance'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'appearance') return false;
        if (prefix.js === 'ms') return "-webkit-" + prop;
        return prefix.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var colorAdjust = {
    noPrefill: [
        'color-adjust'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'color-adjust') return false;
        if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
        return prop;
    }
};
var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function toUpper(match, c) {
    return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function camelize(str) {
    return str.replace(regExp, toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function pascalize(str) {
    return camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var mask = {
    noPrefill: [
        'mask'
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if (prefix.js === 'Webkit') {
            var longhand = 'mask-image';
            if (camelize(longhand) in style) return prop;
            if (prefix.js + pascalize(longhand) in style) return prefix.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var textOrientation = {
    noPrefill: [
        'text-orientation'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'text-orientation') return false;
        if (prefix.vendor === 'apple' && !prefix.isTouch) return prefix.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var transform = {
    noPrefill: [
        'transform'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transform') return false;
        if (options.transform) return prop;
        return prefix.css + prop;
    }
};
// https://caniuse.com/#search=transition
var transition = {
    noPrefill: [
        'transition'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transition') return false;
        if (options.transition) return prop;
        return prefix.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var writingMode = {
    noPrefill: [
        'writing-mode'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'writing-mode') return false;
        if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') return prefix.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var userSelect = {
    noPrefill: [
        'user-select'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'user-select') return false;
        if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') return prefix.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if (prefix.js === 'Webkit') {
            var jsProp = "WebkitColumn" + pascalize(prop);
            return jsProp in style ? prefix.css + "column-" + prop : false;
        }
        if (prefix.js === 'Moz') {
            var _jsProp = "page" + pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if (prefix.js === 'Moz') return prop;
        var newProp = prop.replace('-inline', '');
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return camelize(prop) in style ? prop : false;
    }
};
var prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.
        if (prop[0] === '-' && prop[1] === '-') return prop;
        if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.
        if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== 'scroll-snap') return false;
        if (prefix.js === 'ms') return "" + prefix.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'overscroll-behavior') return false;
        if (prefix.js === 'ms') return prefix.css + "scroll-chaining";
        return prop;
    }
};
var propMap = {
    'flex-grow': 'flex-positive',
    'flex-shrink': 'flex-negative',
    'flex-basis': 'flex-preferred-size',
    'justify-content': 'flex-pack',
    order: 'flex-order',
    'align-items': 'flex-align',
    'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = propMap[prop];
        if (!newProp) return false;
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
    }
};
var propMap$1 = {
    flex: 'box-flex',
    'flex-grow': 'box-flex',
    'flex-direction': [
        'box-orient',
        'box-direction'
    ],
    order: 'box-ordinal-group',
    'align-items': 'box-align',
    'flex-flow': [
        'box-orient',
        'box-direction'
    ],
    'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);
var prefixCss = function prefixCss(p) {
    return prefix.css + p;
}; // Support old flex spec from 2009.
var flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if (propKeys.indexOf(prop) > -1) {
            var newProp = propMap$1[prop];
            if (!Array.isArray(newProp)) return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!(prefix.js + pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map(prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var plugins = [
    appearence,
    colorAdjust,
    mask,
    textOrientation,
    transform,
    transition,
    writingMode,
    userSelect,
    breakPropsOld,
    inlineLogicalOld,
    unprefixed,
    prefixed,
    scrollSnap,
    overscrollBehavior,
    flex2012,
    flex2009
];
var propertyDetectors = plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var noPrefill = plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, _toConsumableArray(p.noPrefill));
    return a;
}, []);
var el;
var cache$1 = {};
if (isBrowser) {
    el = document.createElement('p'); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var computed = window.getComputedStyle(document.documentElement, '');
    for(var key$1 in computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1)) cache$1[computed[key$1]] = computed[key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    noPrefill.forEach(function(x) {
        return delete cache$1[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function supportedProperty(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if (cache$1[prop] != null) return cache$1[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === 'transition' || prop === 'transform') options[prop] = prop in el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < propertyDetectors.length; i++){
        cache$1[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.
        if (cache$1[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        el.style[prop] = '';
    } catch (err) {
        return false;
    }
    return cache$1[prop];
}
var cache$1$1 = {};
var transitionProperties = {
    transition: 1,
    'transition-property': 1,
    '-webkit-transition': 1,
    '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function prefixTransitionCallback(match, p1, p2) {
    if (p1 === 'var') return 'var';
    if (p1 === 'all') return 'all';
    if (p2 === 'all') return ', all';
    var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (isBrowser) el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function supportedValue(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if (cache$1$1[cacheKey] != null) return cache$1$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        cache$1$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if (transitionProperties[property]) prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
    else if (el$1.style[property] === '') {
        // Value with a vendor prefix.
        prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.
        el$1.style[property] = prefixedValue; // Return false if value not supported.
        if (el$1.style[property] === '') {
            cache$1$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    el$1.style[property] = ''; // Write current value to cache.
    cache$1$1[cacheKey] = prefixedValue;
    return cache$1$1[cacheKey];
}
/**
 * Add vendor prefix to a property name when needed.
 */ function jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === 'keyframes') {
            var atRule = rule;
            atRule.at = supportedKeyframes(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === 'fallbacks' && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = supportedProperty(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = supportedValue(supportedProp, toCssValue(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return supportedValue(prop, toCssValue(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
/**
 * Sort props by length.
 */ function jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== 'style') return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
function jssPreset() {
    return {
        plugins: [
            functions(),
            jssGlobal(),
            jssNested(),
            camelCase(),
            defaultUnit(),
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === 'undefined' ? null : jssVendorPrefixer(),
            jssPropsSort()
        ]
    };
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function mergeClasses() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var baseClasses = options.baseClasses, newClasses = options.newClasses, Component = options.Component;
    if (!newClasses) return baseClasses;
    var nextClasses = _extends({}, baseClasses);
    Object.keys(newClasses).forEach(function(key) {
        if (newClasses[key]) nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    });
    return nextClasses;
}
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
    set: function set(cache, key1, key2, value) {
        var subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: function get(cache, key1, key2) {
        var subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: function _delete(cache, key1, key2) {
        var subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var multiKeyStore$1 = multiKeyStore;
var ThemeContext = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createContext(null);
var ThemeContext$1 = ThemeContext;
function useTheme() {
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useContext(ThemeContext$1);
    return theme;
}
var jss = createJss(jssPreset()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
var generateClassName = createGenerateClassName(); // Exported for test purposes
var sheetsManager = new Map();
var defaultOptions = {
    disableGeneration: false,
    generateClassName: generateClassName,
    jss: jss,
    sheetsCache: null,
    sheetsManager: sheetsManager,
    sheetsRegistry: null
};
var StylesContext = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createContext(defaultOptions);
var injectFirstNode;
function StylesProvider(props) {
    var children = props.children, _props$injectFirst = props.injectFirst, injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst, _props$disableGenerat = props.disableGeneration, disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat, localOptions = _objectWithoutProperties(props, [
        "children",
        "injectFirst",
        "disableGeneration"
    ]);
    var outerOptions = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useContext(StylesContext);
    var context = _extends({}, outerOptions, {
        disableGeneration: disableGeneration
    }, localOptions);
    if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
        if (!injectFirstNode) {
            var head = document.head;
            injectFirstNode = document.createComment('mui-inject-first');
            head.insertBefore(injectFirstNode, head.firstChild);
        }
        context.jss = createJss({
            plugins: jssPreset().plugins,
            insertionPoint: injectFirstNode
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement(StylesContext.Provider, {
        value: context
    }, children);
}
/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = -1000000000;
function increment() {
    indexCounter += 1;
    return indexCounter;
}
// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};
var noopTheme$1 = noopTheme;
function getStylesCreator(stylesOrCreator) {
    var themingEnabled = typeof stylesOrCreator === 'function';
    return {
        create: function create(theme, name) {
            var styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.overrides || !theme.overrides[name]) return styles;
            var overrides = theme.overrides[name];
            var stylesWithOverrides = _extends({}, styles);
            Object.keys(overrides).forEach(function(key) {
                stylesWithOverrides[key] = deepmerge(stylesWithOverrides[key], overrides[key]);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}
function getClasses(_ref, classes, Component) {
    var state = _ref.state, stylesOptions = _ref.stylesOptions;
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
     // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    var generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = mergeClasses({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function attach(_ref2, props) {
    var state = _ref2.state, theme = _ref2.theme, stylesOptions = _ref2.stylesOptions, stylesCreator = _ref2.stylesCreator, name = _ref2.name;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = multiKeyStore$1.get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        multiKeyStore$1.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    var options = _extends({}, stylesCreator.options, stylesOptions, {
        theme: theme,
        flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        var staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = multiKeyStore$1.get(stylesOptions.sheetsCache, stylesCreator, theme);
        var styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, _extends({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) multiKeyStore$1.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = getDynamicStyles(styles);
    }
    if (sheetManager.dynamicStyles) {
        var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, _extends({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = mergeClasses({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function update(_ref3, props) {
    var state = _ref3.state;
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function detach(_ref4) {
    var state = _ref4.state, theme = _ref4.theme, stylesOptions = _ref4.stylesOptions, stylesCreator = _ref4.stylesCreator;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = multiKeyStore$1.get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        multiKeyStore$1.delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function useSynchronousEffect(func, values) {
    var key = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useRef([]);
    var output; // Store "generation" key. Just returns a new object every time
    var currentKey = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useMemo(function() {
        return {};
    }, values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useEffect(function() {
        return function() {
            if (output) output();
        };
    }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function makeStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var name = options.name, classNamePrefixOption = options.classNamePrefix, Component = options.Component, _options$defaultTheme = options.defaultTheme, defaultTheme = _options$defaultTheme === void 0 ? noopTheme$1 : _options$defaultTheme, stylesOptions2 = _objectWithoutProperties(options, [
        "name",
        "classNamePrefix",
        "Component",
        "defaultTheme"
    ]);
    var stylesCreator = getStylesCreator(stylesOrCreator);
    var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
    stylesCreator.options = {
        index: increment(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    var useStyles = function useStyles() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var theme = useTheme() || defaultTheme;
        var stylesOptions = _extends({}, (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useContext(StylesContext), stylesOptions2);
        var instance = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useRef();
        var shouldUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useRef();
        useSynchronousEffect(function() {
            var current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return function() {
                detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useEffect(function() {
            if (shouldUpdate.current) update(instance.current, props);
            shouldUpdate.current = true;
        });
        var classes = getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs$2.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs$2.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs$2.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
var hoistNonReactStatics_cjs = hoistNonReactStatics;
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.
var withStyles = function withStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function(Component) {
        var defaultTheme = options.defaultTheme, _options$withTheme = options.withTheme, withTheme = _options$withTheme === void 0 ? false : _options$withTheme, name = options.name, stylesOptions = _objectWithoutProperties(options, [
            "defaultTheme",
            "withTheme",
            "name"
        ]);
        var classNamePrefix = name;
        var displayName;
        var useStyles = makeStyles(stylesOrCreator, _extends({
            defaultTheme: defaultTheme,
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var WithStyles = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).forwardRef(function WithStyles(props, ref) {
            props.classes;
            var innerRef = props.innerRef, other = _objectWithoutProperties(props, [
                "classes",
                "innerRef"
            ]); // The wrapper receives only user supplied props, which could be a subset of
            // the actual props Component might receive due to merging with defaultProps.
            // So copying it here would give us the same result in the wrapper as well.
            var classes = useStyles(_extends({}, Component.defaultProps, props));
            var theme;
            var more = other;
            if (typeof name === 'string' || withTheme) {
                // name and withTheme are invariant in the outer scope
                // eslint-disable-next-line react-hooks/rules-of-hooks
                theme = useTheme() || defaultTheme;
                if (name) more = getThemeProps({
                    theme: theme,
                    name: name,
                    props: other
                });
                 // Provide the theme to the wrapped component.
                // So we don't have to use the `withTheme()` Higher-order Component.
                if (withTheme && !more.theme) more.theme = theme;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement(Component, _extends({
                ref: innerRef || ref,
                classes: classes
            }, more));
        });
        hoistNonReactStatics_cjs(WithStyles, Component);
        return WithStyles;
    };
};
var withStyles$1 = withStyles;
var CssTextField = withStyles$1({
    root: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: '#ffffff',
            width: '100%'
        },
        '& label.Mui-focused, & label.MuiFormLabel-filled': {
            display: 'none'
        }
    }
})((0, $eYT2J.default));
/**
 * A customized Material UI TextField input with white background and no border label.
 */ var SimpleOutlinedInput = function(props) {
    return $ieT14.createElement(CssTextField, __assign({}, props, {
        variant: "outlined",
        size: "small",
        InputLabelProps: {
            shrink: false
        }
    }));
};
var useStyles$7 = (0, $e1ONw.default)({
    root: {
        '&:hover': {
            backgroundColor: 'transparent'
        }
    },
    icon: {
        borderRadius: 3,
        width: 16,
        height: 16,
        border: "1px solid " + neutral[300],
        backgroundColor: neutral[100],
        '$root.Mui-focusVisible &': {
            border: "1px solid " + blue[300]
        },
        'input:hover ~ &': {
            backgroundColor: blue[100]
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            border: "1px solid " + neutral[500],
            background: neutral[500]
        }
    },
    checkedIcon: {
        border: "1px solid " + blue[600],
        backgroundColor: blue[600],
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""'
        },
        'input:hover ~ &': {
            backgroundColor: blue[700],
            border: "1px solid " + blue[700]
        }
    }
});
/** Styled MUI Checkbox */ function StyledCheckbox(props) {
    var classes = useStyles$7();
    return $ieT14.createElement((0, $lamW6.default), __assign({
        className: classes.root,
        disableRipple: true,
        color: "default",
        checkedIcon: $ieT14.createElement("span", {
            className: clsx(classes.icon, classes.checkedIcon)
        }),
        icon: $ieT14.createElement("span", {
            className: classes.icon
        }),
        inputProps: {
            'aria-label': 'decorative checkbox'
        }
    }, props));
}
var useStyles$6 = (0, $e1ONw.default)({
    formGroup: {
        alignItems: 'flex-start',
        '& MuiCheckbox-root': {
            padding: 0
        }
    },
    formLabel: {
        color: neutral[600]
    },
    inputLabel: {
        marginLeft: 0,
        '& .MuiFormControlLabel-label': {
            fontFamily: fontFamilies.heading,
            fontSize: 14,
            lineHeight: 1.25
        },
        '& .MuiIconButton-root': {
            padding: 4
        }
    },
    selectActions: {
        fontFamily: fontFamilies.heading,
        fontSize: 11,
        color: neutral[500],
        padding: '0 4px',
        '& p': {
            margin: 0
        }
    },
    selectAllNone: {
        height: 30
    },
    noFilters: __assign({}, TextStyles.label1)
});
/**
 * Render a section of filter options in the fitler sidebar
 */ var FilterGroup = function(_a) {
    var filters = _a.filters, title = _a.title, selected = _a.selected, updateSelectedFilters = _a.updateSelectedFilters;
    var classes = useStyles$6();
    var _b = $ieT14.useState(selected), checked = _b[0], setChecked = _b[1];
    $ieT14.useEffect(function() {
        setChecked(selected);
    }, []);
    // selected can change via cancel button in parent
    $ieT14.useEffect(function() {
        setChecked(selected);
    }, [
        selected
    ]);
    var handleCheckToggle = function(event) {
        // check if ids are numerical to maintain type after checking
        // against stringified version (checkbox name attribute must be string)
        var idtype = filters && filters.length > 0 ? typeof filters[0].id : null;
        var idString = idtype == 'string' ? event.target.name : Number(event.target.name);
        var tempChecked = __spreadArrays(checked);
        var curidx = tempChecked.indexOf(idString);
        if (curidx == -1) {
            // convert back to number if id type is number
            if (idtype == 'string') tempChecked.push(event.target.name);
            else if (idtype == 'number') tempChecked.push(Number(event.target.name));
        } else tempChecked.splice(curidx, 1);
        setChecked(tempChecked);
        updateSelectedFilters(title, tempChecked);
    };
    var selectAll = function() {
        var tempChecked = filters.map(function(filter) {
            return filter.id;
        });
        setChecked(tempChecked);
        updateSelectedFilters(title, tempChecked);
    };
    var selectNone = function() {
        setChecked([]);
        updateSelectedFilters(title, []);
    };
    return $ieT14.createElement((0, $whS22.default), {
        component: "fieldset"
    }, $ieT14.createElement((0, $f3VQ2.default), {
        component: "legend",
        className: classes.formLabel
    }, title), $ieT14.createElement((0, $3WBJn.default), {
        className: classes.formGroup
    }, $ieT14.createElement("div", {
        className: classes.selectActions
    }, $ieT14.createElement("p", null, "Select:", $ieT14.createElement(TertiaryButton, {
        component: "button",
        text: "All",
        title: "All",
        handleClick: function(event) {
            return selectAll();
        },
        className: classes.selectAllNone
    }), "|", $ieT14.createElement(TertiaryButton, {
        component: "button",
        text: "None",
        title: "None",
        handleClick: function(event) {
            return selectNone();
        },
        className: classes.selectAllNone
    }))), filters.length ? filters.map(function(filter, idx) {
        return $ieT14.createElement((0, $knRao.default), {
            key: "filter-" + idx,
            control: $ieT14.createElement(StyledCheckbox, {
                checked: checked.includes(filter.id),
                onChange: function(event) {
                    handleCheckToggle(event);
                },
                name: String(filter.id)
            }),
            label: filter.name,
            className: classes.inputLabel
        });
    }) : $ieT14.createElement("p", {
        className: classes.noFilters
    }, "No filters available")));
};
var performanceNow = createCommonjsModule(function(module1) {
    // Generated by CoffeeScript 1.12.2
    (function() {
        var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
        if (typeof performance !== "undefined" && performance !== null && performance.now) module1.exports = function() {
            return performance.now();
        };
        else if (Date.now) {
            module1.exports = function() {
                return Date.now() - loadTime;
            };
            loadTime = Date.now();
        } else {
            module1.exports = function() {
                return new Date().getTime() - loadTime;
            };
            loadTime = new Date().getTime();
        }
    }).call(commonjsGlobal);
});
var root = typeof window === 'undefined' ? commonjsGlobal : window, vendors = [
    'moz',
    'webkit'
], suffix = 'AnimationFrame', raf = root['request' + suffix], caf = root['cancel' + suffix] || root['cancelRequest' + suffix];
for(var i = 0; !raf && i < vendors.length; i++){
    raf = root[vendors[i] + 'Request' + suffix];
    caf = root[vendors[i] + 'Cancel' + suffix] || root[vendors[i] + 'CancelRequest' + suffix];
}
// Some versions of FF have rAF but not cAF
if (!raf || !caf) {
    var last = 0, id = 0, queue = [], frameDuration = 1000 / 60;
    raf = function(callback) {
        if (queue.length === 0) {
            var _now = performanceNow(), next = Math.max(0, frameDuration - (_now - last));
            last = next + _now;
            setTimeout(function() {
                var cp = queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                queue.length = 0;
                for(var i = 0; i < cp.length; i++){
                    if (!cp[i].cancelled) try {
                        cp[i].callback(last);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
            }, Math.round(next));
        }
        queue.push({
            handle: ++id,
            callback: callback,
            cancelled: false
        });
        return id;
    };
    caf = function(handle) {
        for(var i = 0; i < queue.length; i++)if (queue[i].handle === handle) queue[i].cancelled = true;
    };
}
var raf_1 = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return raf.call(root, fn);
};
var cancel = function() {
    caf.apply(root, arguments);
};
var polyfill = function(object) {
    if (!object) object = root;
    object.requestAnimationFrame = raf;
    object.cancelAnimationFrame = caf;
};
raf_1.cancel = cancel;
raf_1.polyfill = polyfill;
var div = null;
var prefixes = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
var prefixStyle = function prefixStyle(prop) {
    // re-use a dummy div
    if (!div) div = document.createElement('div');
    var style = div.style;
    // prop exists without prefix
    if (prop in style) return prop;
    // borderRadius -> BorderRadius
    var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1);
    // find the vendor-prefixed prop
    for(var i = prefixes.length; i >= 0; i--){
        var name = prefixes[i] + titleCase;
        // e.g. WebkitBorderRadius or webkitBorderRadius
        if (name in style) return name;
    }
    return false;
};
/**
 * Export.
 */ var toNoCase_1 = toNoCase;
/**
 * Test whether a string is camel-case.
 */ var hasSpace = /\s/;
var hasSeparator = /(_|-|\.|:)/;
var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/;
/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */ function toNoCase(string) {
    if (hasSpace.test(string)) return string.toLowerCase();
    if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase();
    if (hasCamel.test(string)) return uncamelize(string).toLowerCase();
    return string.toLowerCase();
}
/**
 * Separator splitter.
 */ var separatorSplitter = /[\W_]+(.|$)/g;
/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */ function unseparate(string) {
    return string.replace(separatorSplitter, function(m, next) {
        return next ? ' ' + next : '';
    });
}
/**
 * Camelcase splitter.
 */ var camelSplitter = /(.)([A-Z]+)/g;
/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */ function uncamelize(string) {
    return string.replace(camelSplitter, function(m, previous, uppers) {
        return previous + ' ' + uppers.toLowerCase().split('').join(' ');
    });
}
/**
 * Export.
 */ var toSpaceCase_1 = toSpaceCase;
/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */ function toSpaceCase(string) {
    return toNoCase_1(string).replace(/[\W_]+(.|$)/g, function(matches, match) {
        return match ? ' ' + match : '';
    }).trim();
}
/**
 * Export.
 */ var toCamelCase_1 = toCamelCase;
/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */ function toCamelCase(string) {
    return toSpaceCase_1(string).replace(/\s(\w)/g, function(matches, letter) {
        return letter.toUpperCase();
    });
}
/* The following list is defined in React's core */ var IS_UNITLESS = {
    animationIterationCount: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridColumn: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    stopOpacity: true,
    strokeDashoffset: true,
    strokeOpacity: true,
    strokeWidth: true
};
var addPxToStyle = function(name, value) {
    if (typeof value === 'number' && !IS_UNITLESS[name]) return value + 'px';
    else return value;
};
var cache = {
    'float': 'cssFloat'
};
function style(element, property, value) {
    var camel = cache[property];
    if (typeof camel === 'undefined') camel = detect(property);
    // may be false if CSS prop is unsupported
    if (camel) {
        if (value === undefined) return element.style[camel];
        element.style[camel] = addPxToStyle(camel, value);
    }
}
function each(element, properties) {
    for(var k in properties)if (properties.hasOwnProperty(k)) style(element, k, properties[k]);
}
function detect(cssProp) {
    var camel = toCamelCase_1(cssProp);
    var result = prefixStyle(camel);
    cache[camel] = cache[cssProp] = cache[result] = result;
    return result;
}
function set() {
    if (arguments.length === 2) {
        if (typeof arguments[1] === 'string') arguments[0].style.cssText = arguments[1];
        else each(arguments[0], arguments[1]);
    } else style(arguments[0], arguments[1], arguments[2]);
}
var domCss = set;
var set_1 = set;
var get = function(element, properties) {
    if (Array.isArray(properties)) return properties.reduce(function(obj, prop) {
        obj[prop] = style(element, prop || '');
        return obj;
    }, {});
    else return style(element, properties || '');
};
domCss.set = set_1;
domCss.get = get;
var isString_1 = createCommonjsModule(function(module1, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1["default"] = isString;
    function isString(maybe) {
        return typeof maybe === 'string';
    }
});
var getScrollbarWidth_1 = createCommonjsModule(function(module1, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1["default"] = getScrollbarWidth;
    var _domCss2 = _interopRequireDefault(domCss);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    var scrollbarWidth = false;
    function getScrollbarWidth() {
        if (scrollbarWidth !== false) return scrollbarWidth;
        /* istanbul ignore else */ if (typeof document !== 'undefined') {
            var div = document.createElement('div');
            (0, _domCss2["default"])(div, {
                width: 100,
                height: 100,
                position: 'absolute',
                top: -9999,
                overflow: 'scroll',
                MsOverflowStyle: 'scrollbar'
            });
            document.body.appendChild(div);
            scrollbarWidth = div.offsetWidth - div.clientWidth;
            document.body.removeChild(div);
        } else scrollbarWidth = 0;
        return scrollbarWidth || 0;
    }
});
var returnFalse_1 = createCommonjsModule(function(module1, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1["default"] = returnFalse;
    function returnFalse() {
        return false;
    }
});
var getInnerWidth_1 = createCommonjsModule(function(module1, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1["default"] = getInnerWidth;
    function getInnerWidth(el) {
        var clientWidth = el.clientWidth;
        var _getComputedStyle = getComputedStyle(el), paddingLeft = _getComputedStyle.paddingLeft, paddingRight = _getComputedStyle.paddingRight;
        return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
    }
});
var getInnerHeight_1 = createCommonjsModule(function(module1, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1["default"] = getInnerHeight;
    function getInnerHeight(el) {
        var clientHeight = el.clientHeight;
        var _getComputedStyle = getComputedStyle(el), paddingTop = _getComputedStyle.paddingTop, paddingBottom = _getComputedStyle.paddingBottom;
        return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
    }
});
var styles = createCommonjsModule(function(module1, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.containerStyleDefault = {
        position: 'relative',
        overflow: 'hidden',
        width: '100%',
        height: '100%'
    };
    // Overrides containerStyleDefault properties
    exports1.containerStyleAutoHeight = {
        height: 'auto'
    };
    exports1.viewStyleDefault = {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'scroll',
        WebkitOverflowScrolling: 'touch'
    };
    // Overrides viewStyleDefault properties
    exports1.viewStyleAutoHeight = {
        position: 'relative',
        top: undefined,
        left: undefined,
        right: undefined,
        bottom: undefined
    };
    exports1.viewStyleUniversalInitial = {
        overflow: 'hidden',
        marginRight: 0,
        marginBottom: 0
    };
    exports1.trackHorizontalStyleDefault = {
        position: 'absolute',
        height: 6
    };
    exports1.trackVerticalStyleDefault = {
        position: 'absolute',
        width: 6
    };
    exports1.thumbHorizontalStyleDefault = {
        position: 'relative',
        display: 'block',
        height: '100%'
    };
    exports1.thumbVerticalStyleDefault = {
        position: 'relative',
        display: 'block',
        width: '100%'
    };
    exports1.disableSelectStyle = {
        userSelect: 'none'
    };
    exports1.disableSelectStyleReset = {
        userSelect: ''
    };
});
var defaultRenderElements = createCommonjsModule(function(module1, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    exports1.renderViewDefault = renderViewDefault;
    exports1.renderTrackHorizontalDefault = renderTrackHorizontalDefault;
    exports1.renderTrackVerticalDefault = renderTrackVerticalDefault;
    exports1.renderThumbHorizontalDefault = renderThumbHorizontalDefault;
    exports1.renderThumbVerticalDefault = renderThumbVerticalDefault;
    var _react2 = _interopRequireDefault((0, (/*@__PURE__*/$parcel$interopDefault($ieT14))));
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function _objectWithoutProperties(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    }
    /* eslint-disable react/prop-types */ function renderViewDefault(props) {
        return _react2["default"].createElement('div', props);
    }
    function renderTrackHorizontalDefault(_ref) {
        var style = _ref.style, props = _objectWithoutProperties(_ref, [
            'style'
        ]);
        var finalStyle = _extends({}, style, {
            right: 2,
            bottom: 2,
            left: 2,
            borderRadius: 3
        });
        return _react2["default"].createElement('div', _extends({
            style: finalStyle
        }, props));
    }
    function renderTrackVerticalDefault(_ref2) {
        var style = _ref2.style, props = _objectWithoutProperties(_ref2, [
            'style'
        ]);
        var finalStyle = _extends({}, style, {
            right: 2,
            bottom: 2,
            top: 2,
            borderRadius: 3
        });
        return _react2["default"].createElement('div', _extends({
            style: finalStyle
        }, props));
    }
    function renderThumbHorizontalDefault(_ref3) {
        var style = _ref3.style, props = _objectWithoutProperties(_ref3, [
            'style'
        ]);
        var finalStyle = _extends({}, style, {
            cursor: 'pointer',
            borderRadius: 'inherit',
            backgroundColor: 'rgba(0,0,0,.2)'
        });
        return _react2["default"].createElement('div', _extends({
            style: finalStyle
        }, props));
    }
    function renderThumbVerticalDefault(_ref4) {
        var style = _ref4.style, props = _objectWithoutProperties(_ref4, [
            'style'
        ]);
        var finalStyle = _extends({}, style, {
            cursor: 'pointer',
            borderRadius: 'inherit',
            backgroundColor: 'rgba(0,0,0,.2)'
        });
        return _react2["default"].createElement('div', _extends({
            style: finalStyle
        }, props));
    }
});
var _propTypes = propTypes;
var Scrollbars_1 = createCommonjsModule(function(module1, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    var _createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var _raf3 = _interopRequireDefault(raf_1);
    var _domCss2 = _interopRequireDefault(domCss);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _isString2 = _interopRequireDefault(isString_1);
    var _getScrollbarWidth2 = _interopRequireDefault(getScrollbarWidth_1);
    var _returnFalse2 = _interopRequireDefault(returnFalse_1);
    var _getInnerWidth2 = _interopRequireDefault(getInnerWidth_1);
    var _getInnerHeight2 = _interopRequireDefault(getInnerHeight_1);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    function _objectWithoutProperties(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _possibleConstructorReturn(self1, call) {
        if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self1;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var Scrollbars = function(_Component) {
        _inherits(Scrollbars, _Component);
        function Scrollbars(props) {
            var _ref;
            _classCallCheck(this, Scrollbars);
            for(var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
            var _this = _possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [
                this,
                props
            ].concat(rest)));
            _this.getScrollLeft = _this.getScrollLeft.bind(_this);
            _this.getScrollTop = _this.getScrollTop.bind(_this);
            _this.getScrollWidth = _this.getScrollWidth.bind(_this);
            _this.getScrollHeight = _this.getScrollHeight.bind(_this);
            _this.getClientWidth = _this.getClientWidth.bind(_this);
            _this.getClientHeight = _this.getClientHeight.bind(_this);
            _this.getValues = _this.getValues.bind(_this);
            _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_this);
            _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_this);
            _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_this);
            _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_this);
            _this.scrollLeft = _this.scrollLeft.bind(_this);
            _this.scrollTop = _this.scrollTop.bind(_this);
            _this.scrollToLeft = _this.scrollToLeft.bind(_this);
            _this.scrollToTop = _this.scrollToTop.bind(_this);
            _this.scrollToRight = _this.scrollToRight.bind(_this);
            _this.scrollToBottom = _this.scrollToBottom.bind(_this);
            _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_this);
            _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_this);
            _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_this);
            _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_this);
            _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_this);
            _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_this);
            _this.handleWindowResize = _this.handleWindowResize.bind(_this);
            _this.handleScroll = _this.handleScroll.bind(_this);
            _this.handleDrag = _this.handleDrag.bind(_this);
            _this.handleDragEnd = _this.handleDragEnd.bind(_this);
            _this.state = {
                didMountUniversal: false
            };
            return _this;
        }
        _createClass(Scrollbars, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addListeners();
                    this.update();
                    this.componentDidMountUniversal();
                }
            },
            {
                key: 'componentDidMountUniversal',
                value: function componentDidMountUniversal() {
                    // eslint-disable-line react/sort-comp
                    var universal = this.props.universal;
                    if (!universal) return;
                    this.setState({
                        didMountUniversal: true
                    });
                }
            },
            {
                key: 'componentDidUpdate',
                value: function componentDidUpdate() {
                    this.update();
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeListeners();
                    (0, raf_1.cancel)(this.requestFrame);
                    clearTimeout(this.hideTracksTimeout);
                    clearInterval(this.detectScrollingInterval);
                }
            },
            {
                key: 'getScrollLeft',
                value: function getScrollLeft() {
                    if (!this.view) return 0;
                    return this.view.scrollLeft;
                }
            },
            {
                key: 'getScrollTop',
                value: function getScrollTop() {
                    if (!this.view) return 0;
                    return this.view.scrollTop;
                }
            },
            {
                key: 'getScrollWidth',
                value: function getScrollWidth() {
                    if (!this.view) return 0;
                    return this.view.scrollWidth;
                }
            },
            {
                key: 'getScrollHeight',
                value: function getScrollHeight() {
                    if (!this.view) return 0;
                    return this.view.scrollHeight;
                }
            },
            {
                key: 'getClientWidth',
                value: function getClientWidth() {
                    if (!this.view) return 0;
                    return this.view.clientWidth;
                }
            },
            {
                key: 'getClientHeight',
                value: function getClientHeight() {
                    if (!this.view) return 0;
                    return this.view.clientHeight;
                }
            },
            {
                key: 'getValues',
                value: function getValues() {
                    var _ref2 = this.view || {}, _ref2$scrollLeft = _ref2.scrollLeft, scrollLeft = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft, _ref2$scrollTop = _ref2.scrollTop, scrollTop = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop, _ref2$scrollWidth = _ref2.scrollWidth, scrollWidth = _ref2$scrollWidth === undefined ? 0 : _ref2$scrollWidth, _ref2$scrollHeight = _ref2.scrollHeight, scrollHeight = _ref2$scrollHeight === undefined ? 0 : _ref2$scrollHeight, _ref2$clientWidth = _ref2.clientWidth, clientWidth = _ref2$clientWidth === undefined ? 0 : _ref2$clientWidth, _ref2$clientHeight = _ref2.clientHeight, clientHeight = _ref2$clientHeight === undefined ? 0 : _ref2$clientHeight;
                    return {
                        left: scrollLeft / (scrollWidth - clientWidth) || 0,
                        top: scrollTop / (scrollHeight - clientHeight) || 0,
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop,
                        scrollWidth: scrollWidth,
                        scrollHeight: scrollHeight,
                        clientWidth: clientWidth,
                        clientHeight: clientHeight
                    };
                }
            },
            {
                key: 'getThumbHorizontalWidth',
                value: function getThumbHorizontalWidth() {
                    var _props = this.props, thumbSize = _props.thumbSize, thumbMinSize = _props.thumbMinSize;
                    var _view = this.view, scrollWidth = _view.scrollWidth, clientWidth = _view.clientWidth;
                    var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
                    var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
                    if (trackWidth === width) return 0;
                    if (thumbSize) return thumbSize;
                    return Math.max(width, thumbMinSize);
                }
            },
            {
                key: 'getThumbVerticalHeight',
                value: function getThumbVerticalHeight() {
                    var _props2 = this.props, thumbSize = _props2.thumbSize, thumbMinSize = _props2.thumbMinSize;
                    var _view2 = this.view, scrollHeight = _view2.scrollHeight, clientHeight = _view2.clientHeight;
                    var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
                    var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
                    if (trackHeight === height) return 0;
                    if (thumbSize) return thumbSize;
                    return Math.max(height, thumbMinSize);
                }
            },
            {
                key: 'getScrollLeftForOffset',
                value: function getScrollLeftForOffset(offset) {
                    var _view3 = this.view, scrollWidth = _view3.scrollWidth, clientWidth = _view3.clientWidth;
                    var trackWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
                    var thumbWidth = this.getThumbHorizontalWidth();
                    return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
                }
            },
            {
                key: 'getScrollTopForOffset',
                value: function getScrollTopForOffset(offset) {
                    var _view4 = this.view, scrollHeight = _view4.scrollHeight, clientHeight = _view4.clientHeight;
                    var trackHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
                    var thumbHeight = this.getThumbVerticalHeight();
                    return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
                }
            },
            {
                key: 'scrollLeft',
                value: function scrollLeft() {
                    var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    if (!this.view) return;
                    this.view.scrollLeft = left;
                }
            },
            {
                key: 'scrollTop',
                value: function scrollTop() {
                    var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    if (!this.view) return;
                    this.view.scrollTop = top;
                }
            },
            {
                key: 'scrollToLeft',
                value: function scrollToLeft() {
                    if (!this.view) return;
                    this.view.scrollLeft = 0;
                }
            },
            {
                key: 'scrollToTop',
                value: function scrollToTop() {
                    if (!this.view) return;
                    this.view.scrollTop = 0;
                }
            },
            {
                key: 'scrollToRight',
                value: function scrollToRight() {
                    if (!this.view) return;
                    this.view.scrollLeft = this.view.scrollWidth;
                }
            },
            {
                key: 'scrollToBottom',
                value: function scrollToBottom() {
                    if (!this.view) return;
                    this.view.scrollTop = this.view.scrollHeight;
                }
            },
            {
                key: 'addListeners',
                value: function addListeners() {
                    /* istanbul ignore if */ if (typeof document === 'undefined' || !this.view) return;
                    var view = this.view, trackHorizontal = this.trackHorizontal, trackVertical = this.trackVertical, thumbHorizontal = this.thumbHorizontal, thumbVertical = this.thumbVertical;
                    view.addEventListener('scroll', this.handleScroll);
                    if (!(0, _getScrollbarWidth2["default"])()) return;
                    trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
                    trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
                    trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
                    trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
                    trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
                    trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
                    thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
                    thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
                    window.addEventListener('resize', this.handleWindowResize);
                }
            },
            {
                key: 'removeListeners',
                value: function removeListeners() {
                    /* istanbul ignore if */ if (typeof document === 'undefined' || !this.view) return;
                    var view = this.view, trackHorizontal = this.trackHorizontal, trackVertical = this.trackVertical, thumbHorizontal = this.thumbHorizontal, thumbVertical = this.thumbVertical;
                    view.removeEventListener('scroll', this.handleScroll);
                    if (!(0, _getScrollbarWidth2["default"])()) return;
                    trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
                    trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
                    trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
                    trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
                    trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
                    trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
                    thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
                    thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
                    window.removeEventListener('resize', this.handleWindowResize);
                    // Possibly setup by `handleDragStart`
                    this.teardownDragging();
                }
            },
            {
                key: 'handleScroll',
                value: function handleScroll(event) {
                    var _this2 = this;
                    var _props3 = this.props, onScroll = _props3.onScroll, onScrollFrame = _props3.onScrollFrame;
                    if (onScroll) onScroll(event);
                    this.update(function(values) {
                        var scrollLeft = values.scrollLeft, scrollTop = values.scrollTop;
                        _this2.viewScrollLeft = scrollLeft;
                        _this2.viewScrollTop = scrollTop;
                        if (onScrollFrame) onScrollFrame(values);
                    });
                    this.detectScrolling();
                }
            },
            {
                key: 'handleScrollStart',
                value: function handleScrollStart() {
                    var onScrollStart = this.props.onScrollStart;
                    if (onScrollStart) onScrollStart();
                    this.handleScrollStartAutoHide();
                }
            },
            {
                key: 'handleScrollStartAutoHide',
                value: function handleScrollStartAutoHide() {
                    var autoHide = this.props.autoHide;
                    if (!autoHide) return;
                    this.showTracks();
                }
            },
            {
                key: 'handleScrollStop',
                value: function handleScrollStop() {
                    var onScrollStop = this.props.onScrollStop;
                    if (onScrollStop) onScrollStop();
                    this.handleScrollStopAutoHide();
                }
            },
            {
                key: 'handleScrollStopAutoHide',
                value: function handleScrollStopAutoHide() {
                    var autoHide = this.props.autoHide;
                    if (!autoHide) return;
                    this.hideTracks();
                }
            },
            {
                key: 'handleWindowResize',
                value: function handleWindowResize() {
                    this.update();
                }
            },
            {
                key: 'handleHorizontalTrackMouseDown',
                value: function handleHorizontalTrackMouseDown(event) {
                    event.preventDefault();
                    var target = event.target, clientX = event.clientX;
                    var _target$getBoundingCl = target.getBoundingClientRect(), targetLeft = _target$getBoundingCl.left;
                    var thumbWidth = this.getThumbHorizontalWidth();
                    var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
                    this.view.scrollLeft = this.getScrollLeftForOffset(offset);
                }
            },
            {
                key: 'handleVerticalTrackMouseDown',
                value: function handleVerticalTrackMouseDown(event) {
                    event.preventDefault();
                    var target = event.target, clientY = event.clientY;
                    var _target$getBoundingCl2 = target.getBoundingClientRect(), targetTop = _target$getBoundingCl2.top;
                    var thumbHeight = this.getThumbVerticalHeight();
                    var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
                    this.view.scrollTop = this.getScrollTopForOffset(offset);
                }
            },
            {
                key: 'handleHorizontalThumbMouseDown',
                value: function handleHorizontalThumbMouseDown(event) {
                    event.preventDefault();
                    this.handleDragStart(event);
                    var target = event.target, clientX = event.clientX;
                    var offsetWidth = target.offsetWidth;
                    var _target$getBoundingCl3 = target.getBoundingClientRect(), left = _target$getBoundingCl3.left;
                    this.prevPageX = offsetWidth - (clientX - left);
                }
            },
            {
                key: 'handleVerticalThumbMouseDown',
                value: function handleVerticalThumbMouseDown(event) {
                    event.preventDefault();
                    this.handleDragStart(event);
                    var target = event.target, clientY = event.clientY;
                    var offsetHeight = target.offsetHeight;
                    var _target$getBoundingCl4 = target.getBoundingClientRect(), top = _target$getBoundingCl4.top;
                    this.prevPageY = offsetHeight - (clientY - top);
                }
            },
            {
                key: 'setupDragging',
                value: function setupDragging() {
                    (0, _domCss2["default"])(document.body, styles.disableSelectStyle);
                    document.addEventListener('mousemove', this.handleDrag);
                    document.addEventListener('mouseup', this.handleDragEnd);
                    document.onselectstart = _returnFalse2["default"];
                }
            },
            {
                key: 'teardownDragging',
                value: function teardownDragging() {
                    (0, _domCss2["default"])(document.body, styles.disableSelectStyleReset);
                    document.removeEventListener('mousemove', this.handleDrag);
                    document.removeEventListener('mouseup', this.handleDragEnd);
                    document.onselectstart = undefined;
                }
            },
            {
                key: 'handleDragStart',
                value: function handleDragStart(event) {
                    this.dragging = true;
                    event.stopImmediatePropagation();
                    this.setupDragging();
                }
            },
            {
                key: 'handleDrag',
                value: function handleDrag(event) {
                    if (this.prevPageX) {
                        var clientX = event.clientX;
                        var _trackHorizontal$getB = this.trackHorizontal.getBoundingClientRect(), trackLeft = _trackHorizontal$getB.left;
                        var thumbWidth = this.getThumbHorizontalWidth();
                        var clickPosition = thumbWidth - this.prevPageX;
                        var offset = -trackLeft + clientX - clickPosition;
                        this.view.scrollLeft = this.getScrollLeftForOffset(offset);
                    }
                    if (this.prevPageY) {
                        var clientY = event.clientY;
                        var _trackVertical$getBou = this.trackVertical.getBoundingClientRect(), trackTop = _trackVertical$getBou.top;
                        var thumbHeight = this.getThumbVerticalHeight();
                        var _clickPosition = thumbHeight - this.prevPageY;
                        var _offset = -trackTop + clientY - _clickPosition;
                        this.view.scrollTop = this.getScrollTopForOffset(_offset);
                    }
                    return false;
                }
            },
            {
                key: 'handleDragEnd',
                value: function handleDragEnd() {
                    this.dragging = false;
                    this.prevPageX = this.prevPageY = 0;
                    this.teardownDragging();
                    this.handleDragEndAutoHide();
                }
            },
            {
                key: 'handleDragEndAutoHide',
                value: function handleDragEndAutoHide() {
                    var autoHide = this.props.autoHide;
                    if (!autoHide) return;
                    this.hideTracks();
                }
            },
            {
                key: 'handleTrackMouseEnter',
                value: function handleTrackMouseEnter() {
                    this.trackMouseOver = true;
                    this.handleTrackMouseEnterAutoHide();
                }
            },
            {
                key: 'handleTrackMouseEnterAutoHide',
                value: function handleTrackMouseEnterAutoHide() {
                    var autoHide = this.props.autoHide;
                    if (!autoHide) return;
                    this.showTracks();
                }
            },
            {
                key: 'handleTrackMouseLeave',
                value: function handleTrackMouseLeave() {
                    this.trackMouseOver = false;
                    this.handleTrackMouseLeaveAutoHide();
                }
            },
            {
                key: 'handleTrackMouseLeaveAutoHide',
                value: function handleTrackMouseLeaveAutoHide() {
                    var autoHide = this.props.autoHide;
                    if (!autoHide) return;
                    this.hideTracks();
                }
            },
            {
                key: 'showTracks',
                value: function showTracks() {
                    clearTimeout(this.hideTracksTimeout);
                    (0, _domCss2["default"])(this.trackHorizontal, {
                        opacity: 1
                    });
                    (0, _domCss2["default"])(this.trackVertical, {
                        opacity: 1
                    });
                }
            },
            {
                key: 'hideTracks',
                value: function hideTracks() {
                    var _this3 = this;
                    if (this.dragging) return;
                    if (this.scrolling) return;
                    if (this.trackMouseOver) return;
                    var autoHideTimeout = this.props.autoHideTimeout;
                    clearTimeout(this.hideTracksTimeout);
                    this.hideTracksTimeout = setTimeout(function() {
                        (0, _domCss2["default"])(_this3.trackHorizontal, {
                            opacity: 0
                        });
                        (0, _domCss2["default"])(_this3.trackVertical, {
                            opacity: 0
                        });
                    }, autoHideTimeout);
                }
            },
            {
                key: 'detectScrolling',
                value: function detectScrolling() {
                    var _this4 = this;
                    if (this.scrolling) return;
                    this.scrolling = true;
                    this.handleScrollStart();
                    this.detectScrollingInterval = setInterval(function() {
                        if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
                            clearInterval(_this4.detectScrollingInterval);
                            _this4.scrolling = false;
                            _this4.handleScrollStop();
                        }
                        _this4.lastViewScrollLeft = _this4.viewScrollLeft;
                        _this4.lastViewScrollTop = _this4.viewScrollTop;
                    }, 100);
                }
            },
            {
                key: 'raf',
                value: function raf(callback) {
                    var _this5 = this;
                    if (this.requestFrame) _raf3["default"].cancel(this.requestFrame);
                    this.requestFrame = (0, _raf3["default"])(function() {
                        _this5.requestFrame = undefined;
                        callback();
                    });
                }
            },
            {
                key: 'update',
                value: function update(callback) {
                    var _this6 = this;
                    this.raf(function() {
                        return _this6._update(callback);
                    });
                }
            },
            {
                key: '_update',
                value: function _update(callback) {
                    var _props4 = this.props, onUpdate = _props4.onUpdate, hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;
                    var values = this.getValues();
                    if ((0, _getScrollbarWidth2["default"])()) {
                        var scrollLeft = values.scrollLeft, clientWidth = values.clientWidth, scrollWidth = values.scrollWidth;
                        var trackHorizontalWidth = (0, _getInnerWidth2["default"])(this.trackHorizontal);
                        var thumbHorizontalWidth = this.getThumbHorizontalWidth();
                        var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
                        var thumbHorizontalStyle = {
                            width: thumbHorizontalWidth,
                            transform: 'translateX(' + thumbHorizontalX + 'px)'
                        };
                        var scrollTop = values.scrollTop, clientHeight = values.clientHeight, scrollHeight = values.scrollHeight;
                        var trackVerticalHeight = (0, _getInnerHeight2["default"])(this.trackVertical);
                        var thumbVerticalHeight = this.getThumbVerticalHeight();
                        var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
                        var thumbVerticalStyle = {
                            height: thumbVerticalHeight,
                            transform: 'translateY(' + thumbVerticalY + 'px)'
                        };
                        if (hideTracksWhenNotNeeded) {
                            var trackHorizontalStyle = {
                                visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
                            };
                            var trackVerticalStyle = {
                                visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
                            };
                            (0, _domCss2["default"])(this.trackHorizontal, trackHorizontalStyle);
                            (0, _domCss2["default"])(this.trackVertical, trackVerticalStyle);
                        }
                        (0, _domCss2["default"])(this.thumbHorizontal, thumbHorizontalStyle);
                        (0, _domCss2["default"])(this.thumbVertical, thumbVerticalStyle);
                    }
                    if (onUpdate) onUpdate(values);
                    if (typeof callback !== 'function') return;
                    callback(values);
                }
            },
            {
                key: 'render',
                value: function render() {
                    var _this7 = this;
                    var scrollbarWidth = (0, _getScrollbarWidth2["default"])();
                    /* eslint-disable no-unused-vars */ var _props5 = this.props;
                    _props5.onScroll;
                    _props5.onScrollFrame;
                    _props5.onScrollStart;
                    _props5.onScrollStop;
                    _props5.onUpdate;
                    var renderView = _props5.renderView, renderTrackHorizontal = _props5.renderTrackHorizontal, renderTrackVertical = _props5.renderTrackVertical, renderThumbHorizontal = _props5.renderThumbHorizontal, renderThumbVertical = _props5.renderThumbVertical, tagName = _props5.tagName;
                    _props5.hideTracksWhenNotNeeded;
                    var autoHide = _props5.autoHide;
                    _props5.autoHideTimeout;
                    var autoHideDuration = _props5.autoHideDuration;
                    _props5.thumbSize;
                    _props5.thumbMinSize;
                    var universal = _props5.universal, autoHeight = _props5.autoHeight, autoHeightMin = _props5.autoHeightMin, autoHeightMax = _props5.autoHeightMax, style = _props5.style, children = _props5.children, props = _objectWithoutProperties(_props5, [
                        'onScroll',
                        'onScrollFrame',
                        'onScrollStart',
                        'onScrollStop',
                        'onUpdate',
                        'renderView',
                        'renderTrackHorizontal',
                        'renderTrackVertical',
                        'renderThumbHorizontal',
                        'renderThumbVertical',
                        'tagName',
                        'hideTracksWhenNotNeeded',
                        'autoHide',
                        'autoHideTimeout',
                        'autoHideDuration',
                        'thumbSize',
                        'thumbMinSize',
                        'universal',
                        'autoHeight',
                        'autoHeightMin',
                        'autoHeightMax',
                        'style',
                        'children'
                    ]);
                    /* eslint-enable no-unused-vars */ var didMountUniversal = this.state.didMountUniversal;
                    var containerStyle = _extends({}, styles.containerStyleDefault, autoHeight && _extends({}, styles.containerStyleAutoHeight, {
                        minHeight: autoHeightMin,
                        maxHeight: autoHeightMax
                    }), style);
                    var viewStyle = _extends({}, styles.viewStyleDefault, {
                        // Hide scrollbars by setting a negative margin
                        marginRight: scrollbarWidth ? -scrollbarWidth : 0,
                        marginBottom: scrollbarWidth ? -scrollbarWidth : 0
                    }, autoHeight && _extends({}, styles.viewStyleAutoHeight, {
                        // Add scrollbarWidth to autoHeight in order to compensate negative margins
                        minHeight: (0, _isString2["default"])(autoHeightMin) ? 'calc(' + autoHeightMin + ' + ' + scrollbarWidth + 'px)' : autoHeightMin + scrollbarWidth,
                        maxHeight: (0, _isString2["default"])(autoHeightMax) ? 'calc(' + autoHeightMax + ' + ' + scrollbarWidth + 'px)' : autoHeightMax + scrollbarWidth
                    }), autoHeight && universal && !didMountUniversal && {
                        minHeight: autoHeightMin,
                        maxHeight: autoHeightMax
                    }, universal && !didMountUniversal && styles.viewStyleUniversalInitial);
                    var trackAutoHeightStyle = {
                        transition: 'opacity ' + autoHideDuration + 'ms',
                        opacity: 0
                    };
                    var trackHorizontalStyle = _extends({}, styles.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                        display: 'none'
                    });
                    var trackVerticalStyle = _extends({}, styles.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                        display: 'none'
                    });
                    return (0, (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement)(tagName, _extends({}, props, {
                        style: containerStyle,
                        ref: function ref(_ref3) {
                            _this7.container = _ref3;
                        }
                    }), [
                        (0, (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).cloneElement)(renderView({
                            style: viewStyle
                        }), {
                            key: 'view',
                            ref: function ref(_ref4) {
                                _this7.view = _ref4;
                            }
                        }, children),
                        (0, (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).cloneElement)(renderTrackHorizontal({
                            style: trackHorizontalStyle
                        }), {
                            key: 'trackHorizontal',
                            ref: function ref(_ref5) {
                                _this7.trackHorizontal = _ref5;
                            }
                        }, (0, (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).cloneElement)(renderThumbHorizontal({
                            style: styles.thumbHorizontalStyleDefault
                        }), {
                            ref: function ref(_ref6) {
                                _this7.thumbHorizontal = _ref6;
                            }
                        })),
                        (0, (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).cloneElement)(renderTrackVertical({
                            style: trackVerticalStyle
                        }), {
                            key: 'trackVertical',
                            ref: function ref(_ref7) {
                                _this7.trackVertical = _ref7;
                            }
                        }, (0, (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).cloneElement)(renderThumbVertical({
                            style: styles.thumbVerticalStyleDefault
                        }), {
                            ref: function ref(_ref8) {
                                _this7.thumbVertical = _ref8;
                            }
                        }))
                    ]);
                }
            }
        ]);
        return Scrollbars;
    }((0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).Component);
    exports1["default"] = Scrollbars;
    Scrollbars.propTypes = {
        onScroll: _propTypes2["default"].func,
        onScrollFrame: _propTypes2["default"].func,
        onScrollStart: _propTypes2["default"].func,
        onScrollStop: _propTypes2["default"].func,
        onUpdate: _propTypes2["default"].func,
        renderView: _propTypes2["default"].func,
        renderTrackHorizontal: _propTypes2["default"].func,
        renderTrackVertical: _propTypes2["default"].func,
        renderThumbHorizontal: _propTypes2["default"].func,
        renderThumbVertical: _propTypes2["default"].func,
        tagName: _propTypes2["default"].string,
        thumbSize: _propTypes2["default"].number,
        thumbMinSize: _propTypes2["default"].number,
        hideTracksWhenNotNeeded: _propTypes2["default"].bool,
        autoHide: _propTypes2["default"].bool,
        autoHideTimeout: _propTypes2["default"].number,
        autoHideDuration: _propTypes2["default"].number,
        autoHeight: _propTypes2["default"].bool,
        autoHeightMin: _propTypes2["default"].oneOfType([
            _propTypes2["default"].number,
            _propTypes2["default"].string
        ]),
        autoHeightMax: _propTypes2["default"].oneOfType([
            _propTypes2["default"].number,
            _propTypes2["default"].string
        ]),
        universal: _propTypes2["default"].bool,
        style: _propTypes2["default"].object,
        children: _propTypes2["default"].node
    };
    Scrollbars.defaultProps = {
        renderView: defaultRenderElements.renderViewDefault,
        renderTrackHorizontal: defaultRenderElements.renderTrackHorizontalDefault,
        renderTrackVertical: defaultRenderElements.renderTrackVerticalDefault,
        renderThumbHorizontal: defaultRenderElements.renderThumbHorizontalDefault,
        renderThumbVertical: defaultRenderElements.renderThumbVerticalDefault,
        tagName: 'div',
        thumbMinSize: 30,
        hideTracksWhenNotNeeded: false,
        autoHide: false,
        autoHideTimeout: 1000,
        autoHideDuration: 200,
        autoHeight: false,
        autoHeightMin: 0,
        autoHeightMax: 200,
        universal: false
    };
});
var lib = createCommonjsModule(function(module1, exports1) {
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Scrollbars = undefined;
    var _Scrollbars2 = _interopRequireDefault(Scrollbars_1);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            "default": obj
        };
    }
    exports1["default"] = _Scrollbars2["default"];
    exports1.Scrollbars = _Scrollbars2["default"];
});
var Scrollbars = /*@__PURE__*/ unwrapExports(lib);
var useStyles$5 = (0, $e1ONw.default)({
    root: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
    },
    header: function(props) {
        return {
            height: 43,
            padding: 8,
            display: 'flex',
            justifyContent: 'space-between',
            fontFamily: fontFamilies.heading,
            borderBottom: props.isCollapsed ? 'none' : "1px solid " + neutral[300]
        };
    },
    iconWrapper: function(props) {
        return {
            width: props.isCollapsed ? '100%' : 'auto',
            display: 'flex',
            alignItems: 'center',
            '& svg': {
                display: 'block',
                margin: props.isCollapsed ? '0 auto' : '0 5px 0 0'
            },
            '& .filters': {
                margin: 0,
                fontWeight: 600,
                fontSize: '1rem'
            }
        };
    },
    loadingFilters: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        paddingTop: '12px'
    },
    inactive: __assign(__assign({
        display: 'flex',
        justifyContent: 'center',
        paddingTop: '12px'
    }, TextStyles.label1), {
        whiteSpace: 'nowrap',
        opacity: 1,
        transition: 'opacity 150ms',
        '&.collapsed': {
            opacity: 0
        }
    }),
    filterActions: function(props) {
        return {
            visibility: props.isCollapsed ? 'hidden' : 'visible',
            borderBottom: "1px solid " + neutral[300],
            padding: 8,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '& button:first-of-type': {
                marginRight: 8
            }
        };
    },
    filterGroup: function(props) {
        return {
            visibility: props.isCollapsed ? 'hidden' : 'visible',
            padding: 8,
            whiteSpace: 'nowrap',
            '&:not(:last-child)': {
                borderBottom: "1px solid " + neutral[300]
            }
        };
    },
    clearFilters: {
        display: 'flex',
        alignItems: 'center'
    },
    chip: {
        fontSize: 12,
        lineHeight: '14px',
        fontFamily: fontFamilies.body,
        color: 'white',
        backgroundColor: blue[500],
        padding: '0 8px',
        borderRadius: '8px'
    }
});
/**
 * Render filter sidebar content
 * @param isCollapsed - collapse state of parent collapsible sidebar component
 * @param setActiveFilters - state dispatch for active filters from parent view
 */ var FilterMenu = function(_a) {
    var isCollapsed = _a.isCollapsed, activeFilters = _a.activeFilters, setActiveFilters = _a.setActiveFilters, loading = _a.loading;
    var classes = useStyles$5({
        isCollapsed: isCollapsed
    });
    var _b = $ieT14.useState(activeFilters), selectedFilters = _b[0], setSelectedFilters = _b[1];
    var _c = $ieT14.useState(0), activeCount = _c[0], setActiveCount = _c[1];
    var totalFilters = activeFilters.reduce(function(acc, cur) {
        return acc + cur.filters.length;
    }, 0);
    $ieT14.useEffect(function() {
        setActiveCount(activeFilters.reduce(function(acc, cur) {
            return acc + cur.active.length;
        }, 0));
        setSelectedFilters(activeFilters);
    }, [
        activeFilters
    ]);
    var handleActivation = function() {
        setActiveFilters(selectedFilters);
    };
    var handleCancel = function() {
        setSelectedFilters(activeFilters);
    };
    var updateSelectedFilters = function(title, selected) {
        var updated = selectedFilters.map(function(filterGroup) {
            if (filterGroup.title == title) return {
                title: title,
                id: filterGroup.id,
                filters: filterGroup.filters,
                active: selected
            };
            return filterGroup;
        });
        setSelectedFilters(updated);
    };
    var clearAll = function() {
        var cleared = activeFilters.map(function(filter) {
            return __assign(__assign({}, filter), {
                active: filter.filters.map(function(f) {
                    return f.id;
                })
            });
        });
        setActiveFilters(cleared);
        setSelectedFilters(cleared);
    };
    var renderContent = function() {
        if (loading) return $ieT14.createElement("div", {
            className: classes.loadingFilters
        }, $ieT14.createElement((0, $fpdl2.default), {
            size: 20
        }));
        else if (activeFilters.length == 0) return $ieT14.createElement("div", {
            className: clsx(classes.inactive, isCollapsed && 'collapsed')
        }, $ieT14.createElement("p", null, "No Filters Available"));
        return $ieT14.createElement($ieT14.Fragment, null, $ieT14.createElement("div", {
            className: classes.filterActions
        }, $ieT14.createElement(TertiaryButton, {
            component: "button",
            text: "cancel",
            title: "cancel",
            handleClick: handleCancel
        }), $ieT14.createElement(SecondaryButton, {
            text: "Apply",
            title: "Apply",
            handleClick: handleActivation
        })), $ieT14.createElement(Scrollbars, {
            style: {
                flex: 1
            },
            hidden: isCollapsed
        }, selectedFilters.map(function(filterGroup) {
            return $ieT14.createElement("div", {
                className: classes.filterGroup,
                key: filterGroup.id
            }, $ieT14.createElement(FilterGroup, {
                title: filterGroup.title,
                filters: filterGroup.filters,
                selected: filterGroup.active,
                updateSelectedFilters: updateSelectedFilters
            }));
        })));
    };
    return $ieT14.createElement("div", {
        className: classes.root
    }, $ieT14.createElement("div", {
        className: classes.header
    }, $ieT14.createElement("div", {
        className: classes.iconWrapper
    }, $ieT14.createElement((0, $etCDZ.default), null), !isCollapsed && $ieT14.createElement("p", {
        className: "filters"
    }, "Filters")), !isCollapsed && totalFilters != activeCount && $ieT14.createElement("div", {
        className: classes.clearFilters
    }, $ieT14.createElement(TertiaryButton, {
        component: "button",
        title: "Clear All",
        text: "Clear All",
        handleClick: clearAll,
        className: classes.clearButton
    }), $ieT14.createElement("span", {
        className: classes.chip
    }, activeCount))), renderContent());
};
var useStyles$4 = (0, $e1ONw.default)({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        borderBottom: "1px solid " + neutral[200],
        paddingBottom: 4
    },
    title: {
        '& p': {
            margin: 0
        }
    },
    subtitle: {
        fontFamily: 'Open Sans',
        fontSize: 12,
        fontWeight: 300,
        color: neutral[600]
    },
    mainTitle: {
        fontFamily: 'Montserrat',
        fontWeight: 600,
        fontSize: '20px',
        color: neutral[600],
        marginTop: 4
    },
    withoutSubtitle: {
        marginTop: 20
    },
    status: {
        margin: 0,
        marginRight: 20
    },
    statusLabel: __assign({}, TextStyles.label1),
    statusText: __assign({}, TextStyles.body1)
});
var Header = function(_a) {
    var title = _a.title, status = _a.status, subtitle = _a.subtitle;
    var classes = useStyles$4();
    return $ieT14.createElement("div", {
        className: classes.root
    }, $ieT14.createElement("div", {
        className: classes.title
    }, $ieT14.createElement("p", {
        className: classes.subtitle
    }, subtitle), $ieT14.createElement("p", {
        className: clsx(classes.mainTitle, !subtitle && classes.withoutSubtitle)
    }, title)), status && $ieT14.createElement("p", {
        className: classes.status
    }, $ieT14.createElement("span", {
        className: classes.statusLabel
    }, "Status:\u00A0"), $ieT14.createElement("span", {
        className: classes.statusText
    }, status)));
};
var useStyles$3 = (0, $e1ONw.default)({
    container: {
        position: 'relative',
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        padding: '14px 40px 10px 23px',
        backgroundColor: 'white',
        outline: 'none',
        borderRadius: '3px',
        boxShadow: '0 2px 2px 2px rgba(0, 0, 0, 0.07)'
    },
    modal: {
        margin: 'auto'
    },
    exitButton: {
        position: 'absolute',
        right: 8,
        top: 8,
        color: neutral[600],
        cursor: 'pointer'
    },
    content: {
        flex: 1
    }
});
/**
 * ModalDialog: Base modal with header and close icon button
 */ var ModalDialog = function(_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, subtitle = _a.subtitle, title = _a.title, status = _a.status, children = _a.children, width = _a.width, className = _a.className, modalClassName = _a.modalClassName;
    var classes = useStyles$3();
    return $ieT14.createElement((0, $fVNJ1.default), {
        className: clsx(classes.modal, modalClassName),
        style: {
            width: width
        },
        open: isOpen,
        onClose: function(option) {
            return onClose(!isOpen, option);
        }
    }, $ieT14.createElement("div", {
        className: clsx(classes.container, className)
    }, $ieT14.createElement((0, $1KcBP.default), {
        onClick: function() {
            return onClose(!isOpen, null);
        },
        size: "small",
        className: classes.exitButton
    }, $ieT14.createElement((0, $l1pHr.default), null)), $ieT14.createElement(Header, {
        title: title,
        status: status,
        subtitle: subtitle
    }), $ieT14.createElement("div", {
        className: clsx(classes.content, 'modal-content')
    }, children)));
};
function useModal() {
    var _a = $ieT14.useState(false), modalIsOpen = _a[0], setModalIsOpen = _a[1];
    var openModal = function() {
        return setModalIsOpen(true);
    };
    var closeModal = function() {
        return setModalIsOpen(false);
    };
    return {
        modalIsOpen: modalIsOpen,
        openModal: openModal,
        closeModal: closeModal
    };
}
var useStyles$2 = (0, $e1ONw.default)({
    menu: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        width: '100%',
        borderBottom: "2px solid " + neutral[200],
        margin: 0,
        padding: 0,
        listStyle: 'none'
    },
    link: {
        boxSizing: 'content-box',
        color: neutral[600],
        position: 'relative',
        top: 4,
        padding: 10,
        borderBottom: '4px solid transparent',
        textDecoration: 'none',
        fontWeight: 400,
        fontFamily: fontFamilies.heading,
        fontSize: 16,
        '&:not(:last-of-type)': {
            marginRight: 20
        },
        '&.active': {
            fontWeight: 600,
            borderBottom: "4px solid " + blue[600]
        }
    },
    menuItem: {
        margin: 0,
        padding: 0,
        whiteSpace: 'nowrap'
    }
});
/**
 * Component that renders tabbed navigation within a view, supplemental to a primary navigation
 */ var SecondaryNavigation = function(_a) {
    var menuItems = _a.menuItems;
    var classes = useStyles$2();
    return $ieT14.createElement("ul", {
        className: classes.menu
    }, menuItems.map(function(menuItem, index) {
        return $ieT14.createElement((0, $6mt9R.NavLink), {
            to: menuItem.url,
            className: classes.link,
            key: index,
            exact: menuItem.exact
        }, $ieT14.createElement("li", {
            className: classes.menuItem
        }, menuItem.title));
    }));
};
var useStyles$1 = (0, $e1ONw.default)({
    root: {
        boxSizing: 'border-box',
        border: '1px solid #115a80',
        borderRadius: '15px',
        height: '32px',
        width: '268px',
        '&:focus-within': {
            border: "1px solid " + blue[300]
        }
    },
    form: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginLeft: '5px',
        marginRight: '5px',
        height: '100%',
        '&.disabled': {
            backgroundColor: 'rgba(239, 239, 239, 0.3)',
            cursor: 'not-allowed'
        },
        '& .MuiIconButton-root:hover': {
            backgroundColor: blue[100]
        },
        '& input': {
            boxSizing: 'border-box',
            border: 'none',
            width: '100%',
            fontFamily: fontFamilies.heading,
            fontSize: '14px',
            color: blue[800],
            cursor: 'pointer',
            outlineWidth: 0,
            '&:disabled': {
                cursor: 'not-allowed',
                backgroundColor: 'transparent'
            }
        },
        '& input::placeholder': {
            color: neutral[500]
        },
        '& svg': {
            fontSize: '20px',
            color: blue[600],
            '&.icon-only': {
                padding: 3,
                color: neutral[600]
            }
        }
    }
});
/**
 * SearchBar, controlled component for search bar used with tables and help documents
 */ var SearchBar = function(_a) {
    var value = _a.value, updateValue = _a.updateValue, placeholder = _a.placeholder, submitHandler = _a.submitHandler, _b = _a.disabled, disabled = _b === void 0 ? false : _b, inputProps = _a.inputProps, _c = _a.allowSubmitButton, allowSubmitButton = _c === void 0 ? true : _c, showClearButton = _a.showClearButton, className = _a.className;
    var classes = useStyles$1();
    var inputRef = $ieT14.useRef();
    var handleSubmit = function(event) {
        event.preventDefault();
        submitHandler && submitHandler();
    };
    var handleChange = function(event) {
        updateValue(event.target.value);
    };
    var handleClear = function() {
        updateValue('');
        inputRef.current.focus();
    };
    return $ieT14.createElement("div", {
        className: clsx(classes.root, className)
    }, $ieT14.createElement("form", {
        className: clsx(classes.form, disabled && 'disabled'),
        onSubmit: function(event) {
            return handleSubmit(event);
        }
    }, allowSubmitButton ? $ieT14.createElement((0, $1KcBP.default), {
        "aria-label": "search",
        size: "small",
        type: "submit",
        disabled: disabled
    }, $ieT14.createElement((0, $k43Wb.default), null)) : $ieT14.createElement((0, $k43Wb.default), {
        className: "icon-only"
    }), $ieT14.createElement("input", __assign({
        ref: inputRef,
        value: value,
        onChange: handleChange,
        disabled: disabled,
        placeholder: placeholder
    }, inputProps)), showClearButton && value.length > 0 && $ieT14.createElement((0, $1KcBP.default), {
        size: "small",
        onClick: handleClear,
        disabled: disabled
    }, $ieT14.createElement((0, $4leCF.default), null))));
};
/**
 * useSearch
 * @function useSearch - Custom hook for the search bar
 */ var useSearch = function() {
    var _a = $ieT14.useState(false), isSearching = _a[0], setIsSearching = _a[1];
    var _b = $ieT14.useState(''), searchQuery = _b[0], setSearchQuery = _b[1];
    var updateSearchQuery = function(value) {
        setSearchQuery(value);
        if (!value) setIsSearching(false);
        if (value) setIsSearching(true);
    };
    return {
        searchQuery: searchQuery,
        updateSearchQuery: updateSearchQuery,
        isSearching: isSearching,
        setIsSearching: setIsSearching
    };
};
var useStyles = (0, $e1ONw.default)({
    root: {
        overflow: 'hidden'
    },
    menuButton: {
        padding: '7px 8px',
        marginBottom: 2,
        '& .MuiButton-label': {
            textTransform: 'none',
            fontFamily: 'Montserrat',
            fontSize: 14,
            fontWeight: 'normal',
            color: '#00223c'
        }
    },
    userIcon: {
        width: 17,
        height: 17
    }
});
var StyledMenu = (0, $aIJrd.default)({
    paper: {
        border: '1px solid #d3d4d5'
    }
})(function(props) {
    return $ieT14.createElement((0, $5TjLg.default), __assign({
        elevation: 0,
        getContentAnchorEl: null,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'center'
        }
    }, props));
});
/**
 * Render a logged in user menu with logout option
 */ var UserMenu = function(_a) {
    var userName = _a.userName, handleLogout = _a.handleLogout;
    var classes = useStyles();
    var _b = $ieT14.useState(), anchorEl = _b[0], setAnchorEl = _b[1];
    var openMenu = function(event) {
        setAnchorEl(event.currentTarget);
    };
    var closeMenu = function() {
        setAnchorEl(null);
    };
    return $ieT14.createElement($ieT14.Fragment, null, $ieT14.createElement("div", {
        className: classes.root
    }, $ieT14.createElement((0, $ekezX.default), {
        "aria-controls": "customized-menu",
        "aria-haspopup": "true",
        onClick: openMenu,
        className: classes.menuButton,
        size: "large",
        startIcon: $ieT14.createElement((0, $bAMo1.default), {
            className: classes.userIcon
        }),
        endIcon: $ieT14.createElement((0, $kfphy.default), {
            htmlColor: neutral[600]
        })
    }, userName)), $ieT14.createElement(StyledMenu, {
        id: "customized-menu",
        anchorEl: anchorEl,
        keepMounted: true,
        open: Boolean(anchorEl),
        onClose: closeMenu
    }, $ieT14.createElement((0, $3mOXj.default), {
        onClick: handleLogout
    }, $ieT14.createElement((0, $iwN3n.default), null, $ieT14.createElement((0, $6BTs4.default), null)), $ieT14.createElement((0, $bPjUl.default), {
        primary: "Logout"
    }))));
};

});
parcelRegister("bAMo1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8708970b66316e89$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $8708970b66316e89$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
}), 'AccountCircle');

});
parcelRegister("6432u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46a579512dd253c6$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $ieT14 = parcelRequire("ieT14");

var $5SbGE = parcelRequire("5SbGE");
function $46a579512dd253c6$export$2e2bcd8739ae039(path, displayName) {
    var Component = function Component(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement((0, $5SbGE.default), (0, $edxsd.default)({
            ref: ref
        }, props), path);
    };
    Component.muiName = (0, $5SbGE.default).muiName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).forwardRef(Component));
}

});
parcelRegister("edxsd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a59c3ad8dbfe0a1b$export$2e2bcd8739ae039; });
function $a59c3ad8dbfe0a1b$export$2e2bcd8739ae039() {
    return $a59c3ad8dbfe0a1b$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a59c3ad8dbfe0a1b$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("5SbGE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $446b0facceca6856$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");


var $aIJrd = parcelRequire("aIJrd");

var $2EBFt = parcelRequire("2EBFt");
var $446b0facceca6856$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            userSelect: 'none',
            width: '1em',
            height: '1em',
            display: 'inline-block',
            fill: 'currentColor',
            flexShrink: 0,
            fontSize: theme.typography.pxToRem(24),
            transition: theme.transitions.create('fill', {
                duration: theme.transitions.duration.shorter
            })
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="action"`. */ colorAction: {
            color: theme.palette.action.active
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `color="disabled"`. */ colorDisabled: {
            color: theme.palette.action.disabled
        },
        /* Styles applied to the root element if `fontSize="inherit"`. */ fontSizeInherit: {
            fontSize: 'inherit'
        },
        /* Styles applied to the root element if `fontSize="small"`. */ fontSizeSmall: {
            fontSize: theme.typography.pxToRem(20)
        },
        /* Styles applied to the root element if `fontSize="large"`. */ fontSizeLarge: {
            fontSize: theme.typography.pxToRem(35)
        }
    };
};
var $446b0facceca6856$var$SvgIcon = /*#__PURE__*/ $ieT14.forwardRef(function SvgIcon(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'inherit' : _props$color, _props$component = props.component, Component = _props$component === void 0 ? 'svg' : _props$component, _props$fontSize = props.fontSize, fontSize = _props$fontSize === void 0 ? 'medium' : _props$fontSize, htmlColor = props.htmlColor, titleAccess = props.titleAccess, _props$viewBox = props.viewBox, viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox, other = (0, $eTwGP.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "fontSize",
        "htmlColor",
        "titleAccess",
        "viewBox"
    ]);
    return /*#__PURE__*/ $ieT14.createElement(Component, (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className, color !== 'inherit' && classes["color".concat((0, $2EBFt.default)(color))], fontSize !== 'default' && fontSize !== 'medium' && classes["fontSize".concat((0, $2EBFt.default)(fontSize))]),
        focusable: "false",
        viewBox: viewBox,
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, other), children, titleAccess ? /*#__PURE__*/ $ieT14.createElement("title", null, titleAccess) : null);
});
$446b0facceca6856$var$SvgIcon.muiName = 'SvgIcon';
var $446b0facceca6856$export$2e2bcd8739ae039 = (0, $aIJrd.default)($446b0facceca6856$export$9dd6ff9ea0189349, {
    name: 'MuiSvgIcon'
})($446b0facceca6856$var$SvgIcon);

});
parcelRegister("eTwGP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad7f8f3e68437fe5$export$2e2bcd8739ae039; });

var $k5TUp = parcelRequire("k5TUp");
function $ad7f8f3e68437fe5$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $k5TUp.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("k5TUp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea0fa4a08687412f$export$2e2bcd8739ae039; });
function $ea0fa4a08687412f$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("j6s32", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de845599be7aeffd$export$2e2bcd8739ae039; });
function $de845599be7aeffd$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $de845599be7aeffd$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $de845599be7aeffd$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $de845599be7aeffd$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $de845599be7aeffd$export$2e2bcd8739ae039 = $de845599be7aeffd$export$4f5d2d50c9deca37;

});

parcelRegister("aIJrd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0203a21ac71fba50$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $8awOk = parcelRequire("8awOk");

var $kkrWC = parcelRequire("kkrWC");
function $0203a21ac71fba50$var$withStyles(stylesOrCreator, options) {
    return (0, $8awOk.default)(stylesOrCreator, (0, $edxsd.default)({
        defaultTheme: (0, $kkrWC.default)
    }, options));
}
var $0203a21ac71fba50$export$2e2bcd8739ae039 = $0203a21ac71fba50$var$withStyles;

});
parcelRegister("8awOk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f28b572fd934cdb$export$2e2bcd8739ae039; });

var $4gAfe = parcelRequire("4gAfe");

var $g0186 = parcelRequire("g0186");

var $ieT14 = parcelRequire("ieT14");


var $6YpfP = parcelRequire("6YpfP");


var $db7Kr = parcelRequire("db7Kr");

var $bKHfy = parcelRequire("bKHfy");

var $kfQ2O = parcelRequire("kfQ2O");
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.
var $5f28b572fd934cdb$var$withStyles = function withStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function(Component) {
        var defaultTheme = options.defaultTheme, _options$withTheme = options.withTheme, withTheme = _options$withTheme === void 0 ? false : _options$withTheme, name = options.name, stylesOptions = (0, $g0186.default)(options, [
            "defaultTheme",
            "withTheme",
            "name"
        ]);
        var classNamePrefix = name;
        var displayName;
        var useStyles = (0, $db7Kr.default)(stylesOrCreator, (0, $4gAfe.default)({
            defaultTheme: defaultTheme,
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var WithStyles = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).forwardRef(function WithStyles(props, ref) {
            var classesProp = props.classes, innerRef = props.innerRef, other = (0, $g0186.default)(props, [
                "classes",
                "innerRef"
            ]); // The wrapper receives only user supplied props, which could be a subset of
            // the actual props Component might receive due to merging with defaultProps.
            // So copying it here would give us the same result in the wrapper as well.
            var classes = useStyles((0, $4gAfe.default)({}, Component.defaultProps, props));
            var theme;
            var more = other;
            if (typeof name === 'string' || withTheme) {
                // name and withTheme are invariant in the outer scope
                // eslint-disable-next-line react-hooks/rules-of-hooks
                theme = (0, $kfQ2O.default)() || defaultTheme;
                if (name) more = (0, $bKHfy.default)({
                    theme: theme,
                    name: name,
                    props: other
                });
                 // Provide the theme to the wrapped component.
                // So we don't have to use the `withTheme()` Higher-order Component.
                if (withTheme && !more.theme) more.theme = theme;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement(Component, (0, $4gAfe.default)({
                ref: innerRef || ref,
                classes: classes
            }, more));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6YpfP)))(WithStyles, Component);
        return WithStyles;
    };
};
var $5f28b572fd934cdb$export$2e2bcd8739ae039 = $5f28b572fd934cdb$var$withStyles;

});
parcelRegister("4gAfe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31b4c57f4eb1116c$export$2e2bcd8739ae039; });
function $31b4c57f4eb1116c$export$2e2bcd8739ae039() {
    return $31b4c57f4eb1116c$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $31b4c57f4eb1116c$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("g0186", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba5d85c06df26dcb$export$2e2bcd8739ae039; });

var $mS30g = parcelRequire("mS30g");
function $ba5d85c06df26dcb$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $mS30g.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("mS30g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $044bfae25fc36c05$export$2e2bcd8739ae039; });
function $044bfae25fc36c05$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("6YpfP", function(module, exports) {
'use strict';

var $frljO = parcelRequire("frljO");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $513befa40fb62d02$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $513befa40fb62d02$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $513befa40fb62d02$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $513befa40fb62d02$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $513befa40fb62d02$var$TYPE_STATICS = {};
$513befa40fb62d02$var$TYPE_STATICS[$frljO.ForwardRef] = $513befa40fb62d02$var$FORWARD_REF_STATICS;
$513befa40fb62d02$var$TYPE_STATICS[$frljO.Memo] = $513befa40fb62d02$var$MEMO_STATICS;
function $513befa40fb62d02$var$getStatics(component) {
    // React v16.11 and below
    if ($frljO.isMemo(component)) return $513befa40fb62d02$var$MEMO_STATICS;
     // React v16.12 and above
    return $513befa40fb62d02$var$TYPE_STATICS[component['$$typeof']] || $513befa40fb62d02$var$REACT_STATICS;
}
var $513befa40fb62d02$var$defineProperty = Object.defineProperty;
var $513befa40fb62d02$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $513befa40fb62d02$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $513befa40fb62d02$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $513befa40fb62d02$var$getPrototypeOf = Object.getPrototypeOf;
var $513befa40fb62d02$var$objectPrototype = Object.prototype;
function $513befa40fb62d02$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($513befa40fb62d02$var$objectPrototype) {
            var inheritedComponent = $513befa40fb62d02$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $513befa40fb62d02$var$objectPrototype) $513befa40fb62d02$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $513befa40fb62d02$var$getOwnPropertyNames(sourceComponent);
        if ($513befa40fb62d02$var$getOwnPropertySymbols) keys = keys.concat($513befa40fb62d02$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $513befa40fb62d02$var$getStatics(targetComponent);
        var sourceStatics = $513befa40fb62d02$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$513befa40fb62d02$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $513befa40fb62d02$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $513befa40fb62d02$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $513befa40fb62d02$var$hoistNonReactStatics;

});
parcelRegister("frljO", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dYDVz"));

});


parcelRegister("db7Kr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9982500bd35dba63$export$2e2bcd8739ae039; });

var $g0186 = parcelRequire("g0186");

var $4gAfe = parcelRequire("4gAfe");

var $ieT14 = parcelRequire("ieT14");

var $9WE80 = parcelRequire("9WE80");

var $iajeC = parcelRequire("iajeC");

var $gmlGP = parcelRequire("gmlGP");

var $kfQ2O = parcelRequire("kfQ2O");

var $in2Z9 = parcelRequire("in2Z9");

var $3SCg9 = parcelRequire("3SCg9");

var $TpYGg = parcelRequire("TpYGg");

var $gZPDU = parcelRequire("gZPDU");
function $9982500bd35dba63$var$getClasses(_ref, classes, Component) {
    var state = _ref.state, stylesOptions = _ref.stylesOptions;
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
     // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    var generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $iajeC.default)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $9982500bd35dba63$var$attach(_ref2, props) {
    var state = _ref2.state, theme = _ref2.theme, stylesOptions = _ref2.stylesOptions, stylesCreator = _ref2.stylesCreator, name = _ref2.name;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $gmlGP.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $gmlGP.default).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    var options = (0, $4gAfe.default)({}, stylesCreator.options, stylesOptions, {
        theme: theme,
        flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        var staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $gmlGP.default).get(stylesOptions.sheetsCache, stylesCreator, theme);
        var styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $4gAfe.default)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $gmlGP.default).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $9WE80.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $4gAfe.default)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $iajeC.default)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $9982500bd35dba63$var$update(_ref3, props) {
    var state = _ref3.state;
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $9982500bd35dba63$var$detach(_ref4) {
    var state = _ref4.state, theme = _ref4.theme, stylesOptions = _ref4.stylesOptions, stylesCreator = _ref4.stylesCreator;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $gmlGP.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $gmlGP.default).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $9982500bd35dba63$var$useSynchronousEffect(func, values) {
    var key = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useRef([]);
    var output; // Store "generation" key. Just returns a new object every time
    var currentKey = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useMemo(function() {
        return {};
    }, values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useEffect(function() {
        return function() {
            if (output) output();
        };
    }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $9982500bd35dba63$export$2e2bcd8739ae039(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var name = options.name, classNamePrefixOption = options.classNamePrefix, Component = options.Component, _options$defaultTheme = options.defaultTheme, defaultTheme = _options$defaultTheme === void 0 ? (0, $gZPDU.default) : _options$defaultTheme, stylesOptions2 = (0, $g0186.default)(options, [
        "name",
        "classNamePrefix",
        "Component",
        "defaultTheme"
    ]);
    var stylesCreator = (0, $TpYGg.default)(stylesOrCreator);
    var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
    stylesCreator.options = {
        index: (0, $3SCg9.increment)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    var useStyles = function useStyles() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var theme = (0, $kfQ2O.default)() || defaultTheme;
        var stylesOptions = (0, $4gAfe.default)({}, (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useContext((0, $in2Z9.StylesContext)), stylesOptions2);
        var instance = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useRef();
        var shouldUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useRef();
        $9982500bd35dba63$var$useSynchronousEffect(function() {
            var current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $9982500bd35dba63$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return function() {
                $9982500bd35dba63$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useEffect(function() {
            if (shouldUpdate.current) $9982500bd35dba63$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        var classes = $9982500bd35dba63$var$getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}

});
parcelRegister("iajeC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d39814c906577170$export$2e2bcd8739ae039; });

var $4gAfe = parcelRequire("4gAfe");

function $d39814c906577170$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var baseClasses = options.baseClasses, newClasses = options.newClasses, Component = options.Component;
    if (!newClasses) return baseClasses;
    var nextClasses = (0, $4gAfe.default)({}, baseClasses);
    Object.keys(newClasses).forEach(function(key) {
        if (newClasses[key]) nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    });
    return nextClasses;
}

});

parcelRegister("gmlGP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be8f86936ddceeff$export$2e2bcd8739ae039; });
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var $be8f86936ddceeff$var$multiKeyStore = {
    set: function set(cache, key1, key2, value) {
        var subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: function get(cache, key1, key2) {
        var subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: function _delete(cache, key1, key2) {
        var subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $be8f86936ddceeff$export$2e2bcd8739ae039 = $be8f86936ddceeff$var$multiKeyStore;

});

parcelRegister("kfQ2O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebed944ff80daafe$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");

var $2aIlz = parcelRequire("2aIlz");
function $ebed944ff80daafe$export$2e2bcd8739ae039() {
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useContext((0, $2aIlz.default));
    return theme;
}

});
parcelRegister("2aIlz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $194eea4aceb4771b$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");
var $194eea4aceb4771b$var$ThemeContext = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createContext(null);
var $194eea4aceb4771b$export$2e2bcd8739ae039 = $194eea4aceb4771b$var$ThemeContext;

});


parcelRegister("in2Z9", function(module, exports) {

$parcel$export(module.exports, "StylesContext", function () { return $d5fcb0cdcbd95cec$export$f4de434b269fe487; });

var $4gAfe = parcelRequire("4gAfe");

var $g0186 = parcelRequire("g0186");

var $ieT14 = parcelRequire("ieT14");



var $8U8XA = parcelRequire("8U8XA");

var $9WE80 = parcelRequire("9WE80");

var $bHFfP = parcelRequire("bHFfP");
var $d5fcb0cdcbd95cec$var$jss = (0, $9WE80.create)((0, $bHFfP.default)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
var $d5fcb0cdcbd95cec$var$generateClassName = (0, $8U8XA.default)(); // Exported for test purposes
var $d5fcb0cdcbd95cec$export$70a8aea9ff58d1cd = new Map();
var $d5fcb0cdcbd95cec$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $d5fcb0cdcbd95cec$var$generateClassName,
    jss: $d5fcb0cdcbd95cec$var$jss,
    sheetsCache: null,
    sheetsManager: $d5fcb0cdcbd95cec$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
var $d5fcb0cdcbd95cec$export$f4de434b269fe487 = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createContext($d5fcb0cdcbd95cec$var$defaultOptions);
var $d5fcb0cdcbd95cec$var$injectFirstNode;
function $d5fcb0cdcbd95cec$export$2e2bcd8739ae039(props) {
    var children = props.children, _props$injectFirst = props.injectFirst, injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst, _props$disableGenerat = props.disableGeneration, disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat, localOptions = (0, $g0186.default)(props, [
        "children",
        "injectFirst",
        "disableGeneration"
    ]);
    var outerOptions = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useContext($d5fcb0cdcbd95cec$export$f4de434b269fe487);
    var context = (0, $4gAfe.default)({}, outerOptions, {
        disableGeneration: disableGeneration
    }, localOptions);
    if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
        if (!$d5fcb0cdcbd95cec$var$injectFirstNode) {
            var head = document.head;
            $d5fcb0cdcbd95cec$var$injectFirstNode = document.createComment('mui-inject-first');
            head.insertBefore($d5fcb0cdcbd95cec$var$injectFirstNode, head.firstChild);
        }
        context.jss = (0, $9WE80.create)({
            plugins: (0, $bHFfP.default)().plugins,
            insertionPoint: $d5fcb0cdcbd95cec$var$injectFirstNode
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($d5fcb0cdcbd95cec$export$f4de434b269fe487.Provider, {
        value: context
    }, children);
}

});
parcelRegister("8U8XA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67ba80f7e702a5e4$export$2e2bcd8739ae039; });

var $6vrzA = parcelRequire("6vrzA");
/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */ var $67ba80f7e702a5e4$var$pseudoClasses = [
    'checked',
    'disabled',
    'error',
    'focused',
    'focusVisible',
    'required',
    'expanded',
    'selected'
]; // Returns a function which generates unique class names based on counters.
function $67ba80f7e702a5e4$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$disableGloba = options.disableGlobal, disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba, _options$productionPr = options.productionPrefix, productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr, _options$seed = options.seed, seed = _options$seed === void 0 ? '' : _options$seed;
    var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
    var ruleCounter = 0;
    var getNextCounterId = function getNextCounterId() {
        ruleCounter += 1;
        return ruleCounter;
    };
    return function(rule, styleSheet) {
        var name = styleSheet.options.name; // Is a global static MUI style?
        if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($67ba80f7e702a5e4$var$pseudoClasses.indexOf(rule.key) !== -1) return "Mui-".concat(rule.key);
            var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
            if (!styleSheet.options.theme[0, $6vrzA.default] || seed !== '') return prefix;
            return "".concat(prefix, "-").concat(getNextCounterId());
        }
        var suffix;
        return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    };
}

});
parcelRegister("6vrzA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bcb06b9e006eff7$export$2e2bcd8739ae039; });
var $4bcb06b9e006eff7$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $4bcb06b9e006eff7$export$2e2bcd8739ae039 = $4bcb06b9e006eff7$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

});


parcelRegister("bHFfP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8853b61db6733785$export$2e2bcd8739ae039; });

var $d407R = parcelRequire("d407R");

var $cKdt4 = parcelRequire("cKdt4");

var $9luK5 = parcelRequire("9luK5");

var $4l5Jw = parcelRequire("4l5Jw");

var $dlmEF = parcelRequire("dlmEF");

var $1P8mh = parcelRequire("1P8mh");

var $5fUzF = parcelRequire("5fUzF");
function $8853b61db6733785$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $d407R.default)(),
            (0, $cKdt4.default)(),
            (0, $9luK5.default)(),
            (0, $4l5Jw.default)(),
            (0, $dlmEF.default)(),
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === 'undefined' ? null : (0, $1P8mh.default)(),
            (0, $5fUzF.default)()
        ]
    };
}

});
parcelRegister("d407R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $982bbf1347a6905f$export$2e2bcd8739ae039; });


var $9WE80 = parcelRequire("9WE80");
var $982bbf1347a6905f$var$now = Date.now();
var $982bbf1347a6905f$var$fnValuesNs = "fnValues" + $982bbf1347a6905f$var$now;
var $982bbf1347a6905f$var$fnRuleNs = "fnStyle" + ++$982bbf1347a6905f$var$now;
var $982bbf1347a6905f$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== 'function') return null;
            var rule = (0, $9WE80.createRule)(name, {}, options);
            rule[$982bbf1347a6905f$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($982bbf1347a6905f$var$fnValuesNs in rule || $982bbf1347a6905f$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== 'function') continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$982bbf1347a6905f$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$982bbf1347a6905f$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$982bbf1347a6905f$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $982bbf1347a6905f$export$2e2bcd8739ae039 = $982bbf1347a6905f$var$functionPlugin;

});

parcelRegister("cKdt4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94743a58016ad35a$export$2e2bcd8739ae039; });

var $gLWUF = parcelRequire("gLWUF");

var $9WE80 = parcelRequire("9WE80");
var $94743a58016ad35a$var$at = '@global';
var $94743a58016ad35a$var$atPrefix = '@global ';
var $94743a58016ad35a$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = 'global';
        this.at = $94743a58016ad35a$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $9WE80.RuleList)((0, $gLWUF.default)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    };
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    };
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    };
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    };
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var $94743a58016ad35a$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = 'global';
        this.at = $94743a58016ad35a$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($94743a58016ad35a$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $gLWUF.default)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : '';
    };
    return GlobalPrefixedRule;
}();
var $94743a58016ad35a$var$separatorRegExp = /\s*,\s*/g;
function $94743a58016ad35a$var$addScope(selector, scope) {
    var parts = selector.split($94743a58016ad35a$var$separatorRegExp);
    var scoped = '';
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ', ';
    }
    return scoped;
}
function $94743a58016ad35a$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$94743a58016ad35a$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $gLWUF.default)({}, options, {
        selector: $94743a58016ad35a$var$addScope(name, rule.selector)
    }));
    delete style[$94743a58016ad35a$var$at];
}
function $94743a58016ad35a$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== '@' || prop.substr(0, $94743a58016ad35a$var$at.length) !== $94743a58016ad35a$var$at) continue;
        var selector = $94743a58016ad35a$var$addScope(prop.substr($94743a58016ad35a$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $gLWUF.default)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $94743a58016ad35a$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $94743a58016ad35a$var$at) return new $94743a58016ad35a$var$GlobalContainerRule(name, styles, options);
        if (name[0] === '@' && name.substr(0, $94743a58016ad35a$var$atPrefix.length) === $94743a58016ad35a$var$atPrefix) return new $94743a58016ad35a$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== 'style' || !sheet) return;
        $94743a58016ad35a$var$handleNestedGlobalContainerRule(rule, sheet);
        $94743a58016ad35a$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $94743a58016ad35a$export$2e2bcd8739ae039 = $94743a58016ad35a$var$jssGlobal;

});
parcelRegister("gLWUF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c35ebbffa694121c$export$2e2bcd8739ae039; });
function $c35ebbffa694121c$export$2e2bcd8739ae039() {
    return $c35ebbffa694121c$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c35ebbffa694121c$export$2e2bcd8739ae039.apply(null, arguments);
}

});


parcelRegister("9luK5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cddec0035140d52$export$2e2bcd8739ae039; });

var $qOtFg = parcelRequire("qOtFg");

var $6cddec0035140d52$var$separatorRegExp = /\s*,\s*/g;
var $6cddec0035140d52$var$parentRegExp = /&/g;
var $6cddec0035140d52$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $6cddec0035140d52$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($6cddec0035140d52$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($6cddec0035140d52$var$separatorRegExp);
        var result = '';
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf('&') !== -1 ? nested.replace($6cddec0035140d52$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $qOtFg.default)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $qOtFg.default)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style') return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf('&') !== -1;
            var isNestedConditional = prop[0] === '@';
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($6cddec0035140d52$var$refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ('replaceRule' in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, $qOtFg.default)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, $qOtFg.default)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $6cddec0035140d52$export$2e2bcd8739ae039 = $6cddec0035140d52$var$jssNested;

});
parcelRegister("qOtFg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $050995985f9b7c2c$export$2e2bcd8739ae039; });
function $050995985f9b7c2c$export$2e2bcd8739ae039() {
    return $050995985f9b7c2c$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $050995985f9b7c2c$export$2e2bcd8739ae039.apply(null, arguments);
}

});


parcelRegister("4l5Jw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $328d92165a708f94$export$2e2bcd8739ae039; });

var $3DHnF = parcelRequire("3DHnF");
/**
 * Convert camel cased property names to dash separated.
 */ function $328d92165a708f94$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf('--') === 0 ? prop : (0, $3DHnF.default)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($328d92165a708f94$var$convertCase);
        else converted.fallbacks = $328d92165a708f94$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $328d92165a708f94$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $328d92165a708f94$var$convertCase(style[index]);
            return style;
        }
        return $328d92165a708f94$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf('--') === 0) return value;
        var hyphenatedProp = (0, $3DHnF.default)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $328d92165a708f94$export$2e2bcd8739ae039 = $328d92165a708f94$var$camelCase;

});
parcelRegister("3DHnF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a66aa25264f525a$export$2e2bcd8739ae039; });
/* eslint-disable no-var, prefer-template */ var $2a66aa25264f525a$var$uppercasePattern = /[A-Z]/g;
var $2a66aa25264f525a$var$msPattern = /^ms-/;
var $2a66aa25264f525a$var$cache = {};
function $2a66aa25264f525a$var$toHyphenLower(match) {
    return '-' + match.toLowerCase();
}
function $2a66aa25264f525a$var$hyphenateStyleName(name) {
    if ($2a66aa25264f525a$var$cache.hasOwnProperty(name)) return $2a66aa25264f525a$var$cache[name];
    var hName = name.replace($2a66aa25264f525a$var$uppercasePattern, $2a66aa25264f525a$var$toHyphenLower);
    return $2a66aa25264f525a$var$cache[name] = $2a66aa25264f525a$var$msPattern.test(hName) ? '-' + hName : hName;
}
var $2a66aa25264f525a$export$2e2bcd8739ae039 = $2a66aa25264f525a$var$hyphenateStyleName;

});


parcelRegister("dlmEF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b6ecf52d3196e4e$export$2e2bcd8739ae039; });

var $9WE80 = parcelRequire("9WE80");
var $9b6ecf52d3196e4e$var$px = (0, $9WE80.hasCSSTOMSupport) && CSS ? CSS.px : 'px';
var $9b6ecf52d3196e4e$var$ms = (0, $9WE80.hasCSSTOMSupport) && CSS ? CSS.ms : 'ms';
var $9b6ecf52d3196e4e$var$percent = (0, $9WE80.hasCSSTOMSupport) && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $9b6ecf52d3196e4e$var$defaultUnits = {
    // Animation properties
    'animation-delay': $9b6ecf52d3196e4e$var$ms,
    'animation-duration': $9b6ecf52d3196e4e$var$ms,
    // Background properties
    'background-position': $9b6ecf52d3196e4e$var$px,
    'background-position-x': $9b6ecf52d3196e4e$var$px,
    'background-position-y': $9b6ecf52d3196e4e$var$px,
    'background-size': $9b6ecf52d3196e4e$var$px,
    // Border Properties
    border: $9b6ecf52d3196e4e$var$px,
    'border-bottom': $9b6ecf52d3196e4e$var$px,
    'border-bottom-left-radius': $9b6ecf52d3196e4e$var$px,
    'border-bottom-right-radius': $9b6ecf52d3196e4e$var$px,
    'border-bottom-width': $9b6ecf52d3196e4e$var$px,
    'border-left': $9b6ecf52d3196e4e$var$px,
    'border-left-width': $9b6ecf52d3196e4e$var$px,
    'border-radius': $9b6ecf52d3196e4e$var$px,
    'border-right': $9b6ecf52d3196e4e$var$px,
    'border-right-width': $9b6ecf52d3196e4e$var$px,
    'border-top': $9b6ecf52d3196e4e$var$px,
    'border-top-left-radius': $9b6ecf52d3196e4e$var$px,
    'border-top-right-radius': $9b6ecf52d3196e4e$var$px,
    'border-top-width': $9b6ecf52d3196e4e$var$px,
    'border-width': $9b6ecf52d3196e4e$var$px,
    'border-block': $9b6ecf52d3196e4e$var$px,
    'border-block-end': $9b6ecf52d3196e4e$var$px,
    'border-block-end-width': $9b6ecf52d3196e4e$var$px,
    'border-block-start': $9b6ecf52d3196e4e$var$px,
    'border-block-start-width': $9b6ecf52d3196e4e$var$px,
    'border-block-width': $9b6ecf52d3196e4e$var$px,
    'border-inline': $9b6ecf52d3196e4e$var$px,
    'border-inline-end': $9b6ecf52d3196e4e$var$px,
    'border-inline-end-width': $9b6ecf52d3196e4e$var$px,
    'border-inline-start': $9b6ecf52d3196e4e$var$px,
    'border-inline-start-width': $9b6ecf52d3196e4e$var$px,
    'border-inline-width': $9b6ecf52d3196e4e$var$px,
    'border-start-start-radius': $9b6ecf52d3196e4e$var$px,
    'border-start-end-radius': $9b6ecf52d3196e4e$var$px,
    'border-end-start-radius': $9b6ecf52d3196e4e$var$px,
    'border-end-end-radius': $9b6ecf52d3196e4e$var$px,
    // Margin properties
    margin: $9b6ecf52d3196e4e$var$px,
    'margin-bottom': $9b6ecf52d3196e4e$var$px,
    'margin-left': $9b6ecf52d3196e4e$var$px,
    'margin-right': $9b6ecf52d3196e4e$var$px,
    'margin-top': $9b6ecf52d3196e4e$var$px,
    'margin-block': $9b6ecf52d3196e4e$var$px,
    'margin-block-end': $9b6ecf52d3196e4e$var$px,
    'margin-block-start': $9b6ecf52d3196e4e$var$px,
    'margin-inline': $9b6ecf52d3196e4e$var$px,
    'margin-inline-end': $9b6ecf52d3196e4e$var$px,
    'margin-inline-start': $9b6ecf52d3196e4e$var$px,
    // Padding properties
    padding: $9b6ecf52d3196e4e$var$px,
    'padding-bottom': $9b6ecf52d3196e4e$var$px,
    'padding-left': $9b6ecf52d3196e4e$var$px,
    'padding-right': $9b6ecf52d3196e4e$var$px,
    'padding-top': $9b6ecf52d3196e4e$var$px,
    'padding-block': $9b6ecf52d3196e4e$var$px,
    'padding-block-end': $9b6ecf52d3196e4e$var$px,
    'padding-block-start': $9b6ecf52d3196e4e$var$px,
    'padding-inline': $9b6ecf52d3196e4e$var$px,
    'padding-inline-end': $9b6ecf52d3196e4e$var$px,
    'padding-inline-start': $9b6ecf52d3196e4e$var$px,
    // Mask properties
    'mask-position-x': $9b6ecf52d3196e4e$var$px,
    'mask-position-y': $9b6ecf52d3196e4e$var$px,
    'mask-size': $9b6ecf52d3196e4e$var$px,
    // Width and height properties
    height: $9b6ecf52d3196e4e$var$px,
    width: $9b6ecf52d3196e4e$var$px,
    'min-height': $9b6ecf52d3196e4e$var$px,
    'max-height': $9b6ecf52d3196e4e$var$px,
    'min-width': $9b6ecf52d3196e4e$var$px,
    'max-width': $9b6ecf52d3196e4e$var$px,
    // Position properties
    bottom: $9b6ecf52d3196e4e$var$px,
    left: $9b6ecf52d3196e4e$var$px,
    top: $9b6ecf52d3196e4e$var$px,
    right: $9b6ecf52d3196e4e$var$px,
    inset: $9b6ecf52d3196e4e$var$px,
    'inset-block': $9b6ecf52d3196e4e$var$px,
    'inset-block-end': $9b6ecf52d3196e4e$var$px,
    'inset-block-start': $9b6ecf52d3196e4e$var$px,
    'inset-inline': $9b6ecf52d3196e4e$var$px,
    'inset-inline-end': $9b6ecf52d3196e4e$var$px,
    'inset-inline-start': $9b6ecf52d3196e4e$var$px,
    // Shadow properties
    'box-shadow': $9b6ecf52d3196e4e$var$px,
    'text-shadow': $9b6ecf52d3196e4e$var$px,
    // Column properties
    'column-gap': $9b6ecf52d3196e4e$var$px,
    'column-rule': $9b6ecf52d3196e4e$var$px,
    'column-rule-width': $9b6ecf52d3196e4e$var$px,
    'column-width': $9b6ecf52d3196e4e$var$px,
    // Font and text properties
    'font-size': $9b6ecf52d3196e4e$var$px,
    'font-size-delta': $9b6ecf52d3196e4e$var$px,
    'letter-spacing': $9b6ecf52d3196e4e$var$px,
    'text-decoration-thickness': $9b6ecf52d3196e4e$var$px,
    'text-indent': $9b6ecf52d3196e4e$var$px,
    'text-stroke': $9b6ecf52d3196e4e$var$px,
    'text-stroke-width': $9b6ecf52d3196e4e$var$px,
    'word-spacing': $9b6ecf52d3196e4e$var$px,
    // Motion properties
    motion: $9b6ecf52d3196e4e$var$px,
    'motion-offset': $9b6ecf52d3196e4e$var$px,
    // Outline properties
    outline: $9b6ecf52d3196e4e$var$px,
    'outline-offset': $9b6ecf52d3196e4e$var$px,
    'outline-width': $9b6ecf52d3196e4e$var$px,
    // Perspective properties
    perspective: $9b6ecf52d3196e4e$var$px,
    'perspective-origin-x': $9b6ecf52d3196e4e$var$percent,
    'perspective-origin-y': $9b6ecf52d3196e4e$var$percent,
    // Transform properties
    'transform-origin': $9b6ecf52d3196e4e$var$percent,
    'transform-origin-x': $9b6ecf52d3196e4e$var$percent,
    'transform-origin-y': $9b6ecf52d3196e4e$var$percent,
    'transform-origin-z': $9b6ecf52d3196e4e$var$percent,
    // Transition properties
    'transition-delay': $9b6ecf52d3196e4e$var$ms,
    'transition-duration': $9b6ecf52d3196e4e$var$ms,
    // Alignment properties
    'vertical-align': $9b6ecf52d3196e4e$var$px,
    'flex-basis': $9b6ecf52d3196e4e$var$px,
    // Some random properties
    'shape-margin': $9b6ecf52d3196e4e$var$px,
    size: $9b6ecf52d3196e4e$var$px,
    gap: $9b6ecf52d3196e4e$var$px,
    // Grid properties
    grid: $9b6ecf52d3196e4e$var$px,
    'grid-gap': $9b6ecf52d3196e4e$var$px,
    'row-gap': $9b6ecf52d3196e4e$var$px,
    'grid-row-gap': $9b6ecf52d3196e4e$var$px,
    'grid-column-gap': $9b6ecf52d3196e4e$var$px,
    'grid-template-rows': $9b6ecf52d3196e4e$var$px,
    'grid-template-columns': $9b6ecf52d3196e4e$var$px,
    'grid-auto-rows': $9b6ecf52d3196e4e$var$px,
    'grid-auto-columns': $9b6ecf52d3196e4e$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    'box-shadow-x': $9b6ecf52d3196e4e$var$px,
    'box-shadow-y': $9b6ecf52d3196e4e$var$px,
    'box-shadow-blur': $9b6ecf52d3196e4e$var$px,
    'box-shadow-spread': $9b6ecf52d3196e4e$var$px,
    'font-line-height': $9b6ecf52d3196e4e$var$px,
    'text-shadow-x': $9b6ecf52d3196e4e$var$px,
    'text-shadow-y': $9b6ecf52d3196e4e$var$px,
    'text-shadow-blur': $9b6ecf52d3196e4e$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $9b6ecf52d3196e4e$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $9b6ecf52d3196e4e$var$units = $9b6ecf52d3196e4e$var$addCamelCasedVersion($9b6ecf52d3196e4e$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $9b6ecf52d3196e4e$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $9b6ecf52d3196e4e$var$iterate(prop, value[i], options);
    else if (typeof value === 'object') {
        if (prop === 'fallbacks') for(var innerProp in value)value[innerProp] = $9b6ecf52d3196e4e$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $9b6ecf52d3196e4e$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === 'number' && isNaN(value) === false) {
        var unit = options[prop] || $9b6ecf52d3196e4e$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $9b6ecf52d3196e4e$var$px)) return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $9b6ecf52d3196e4e$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $9b6ecf52d3196e4e$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        for(var prop in style)style[prop] = $9b6ecf52d3196e4e$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $9b6ecf52d3196e4e$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $9b6ecf52d3196e4e$export$2e2bcd8739ae039 = $9b6ecf52d3196e4e$var$defaultUnit;

});

parcelRegister("1P8mh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $154109a54c213e27$export$2e2bcd8739ae039; });

var $1U16h = parcelRequire("1U16h");

var $9WE80 = parcelRequire("9WE80");
/**
 * Add vendor prefix to a property name when needed.
 */ function $154109a54c213e27$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === 'keyframes') {
            var atRule = rule;
            atRule.at = (0, $1U16h.supportedKeyframes)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === 'fallbacks' && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $1U16h.supportedProperty)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $1U16h.supportedValue)(supportedProp, (0, $9WE80.toCssValue)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $1U16h.supportedValue)(prop, (0, $9WE80.toCssValue)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $154109a54c213e27$export$2e2bcd8739ae039 = $154109a54c213e27$var$jssVendorPrefixer;

});
parcelRegister("1U16h", function(module, exports) {

$parcel$export(module.exports, "supportedKeyframes", function () { return $162bdfe7c043978f$export$b6aa0648d950180a; });
$parcel$export(module.exports, "supportedProperty", function () { return $162bdfe7c043978f$export$ce097f82c2e4551a; });
$parcel$export(module.exports, "supportedValue", function () { return $162bdfe7c043978f$export$511766124059c277; });

var $4rd5g = parcelRequire("4rd5g");

var $29OAR = parcelRequire("29OAR");
// Export javascript style and css style vendor prefixes.
var $162bdfe7c043978f$var$js = '';
var $162bdfe7c043978f$var$css = '';
var $162bdfe7c043978f$var$vendor = '';
var $162bdfe7c043978f$var$browser = '';
var $162bdfe7c043978f$var$isTouch = (0, $4rd5g.default) && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.
if (0, $4rd5g.default) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $162bdfe7c043978f$var$jsCssMap = {
        Moz: '-moz-',
        ms: '-ms-',
        O: '-o-',
        Webkit: '-webkit-'
    };
    var $162bdfe7c043978f$var$_document$createEleme = document.createElement('p'), $162bdfe7c043978f$var$style = $162bdfe7c043978f$var$_document$createEleme.style;
    var $162bdfe7c043978f$var$testProp = 'Transform';
    for(var $162bdfe7c043978f$var$key in $162bdfe7c043978f$var$jsCssMap)if ($162bdfe7c043978f$var$key + $162bdfe7c043978f$var$testProp in $162bdfe7c043978f$var$style) {
        $162bdfe7c043978f$var$js = $162bdfe7c043978f$var$key;
        $162bdfe7c043978f$var$css = $162bdfe7c043978f$var$jsCssMap[$162bdfe7c043978f$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($162bdfe7c043978f$var$js === 'Webkit' && 'msHyphens' in $162bdfe7c043978f$var$style) {
        $162bdfe7c043978f$var$js = 'ms';
        $162bdfe7c043978f$var$css = $162bdfe7c043978f$var$jsCssMap.ms;
        $162bdfe7c043978f$var$browser = 'edge';
    } // Correctly detect the Safari browser.
    if ($162bdfe7c043978f$var$js === 'Webkit' && '-apple-trailing-word' in $162bdfe7c043978f$var$style) $162bdfe7c043978f$var$vendor = 'apple';
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $162bdfe7c043978f$export$82e9f45cca5ba907 = {
    js: $162bdfe7c043978f$var$js,
    css: $162bdfe7c043978f$var$css,
    vendor: $162bdfe7c043978f$var$vendor,
    browser: $162bdfe7c043978f$var$browser,
    isTouch: $162bdfe7c043978f$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $162bdfe7c043978f$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($162bdfe7c043978f$export$82e9f45cca5ba907.js === 'ms') return key;
    return "@" + $162bdfe7c043978f$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $162bdfe7c043978f$var$appearence = {
    noPrefill: [
        'appearance'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'appearance') return false;
        if ($162bdfe7c043978f$export$82e9f45cca5ba907.js === 'ms') return "-webkit-" + prop;
        return $162bdfe7c043978f$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $162bdfe7c043978f$var$colorAdjust = {
    noPrefill: [
        'color-adjust'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'color-adjust') return false;
        if ($162bdfe7c043978f$export$82e9f45cca5ba907.js === 'Webkit') return $162bdfe7c043978f$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $162bdfe7c043978f$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $162bdfe7c043978f$var$toUpper(match, c) {
    return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $162bdfe7c043978f$var$camelize(str) {
    return str.replace($162bdfe7c043978f$var$regExp, $162bdfe7c043978f$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $162bdfe7c043978f$var$pascalize(str) {
    return $162bdfe7c043978f$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $162bdfe7c043978f$var$mask = {
    noPrefill: [
        'mask'
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($162bdfe7c043978f$export$82e9f45cca5ba907.js === 'Webkit') {
            var longhand = 'mask-image';
            if ($162bdfe7c043978f$var$camelize(longhand) in style) return prop;
            if ($162bdfe7c043978f$export$82e9f45cca5ba907.js + $162bdfe7c043978f$var$pascalize(longhand) in style) return $162bdfe7c043978f$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $162bdfe7c043978f$var$textOrientation = {
    noPrefill: [
        'text-orientation'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'text-orientation') return false;
        if ($162bdfe7c043978f$export$82e9f45cca5ba907.vendor === 'apple' && !$162bdfe7c043978f$export$82e9f45cca5ba907.isTouch) return $162bdfe7c043978f$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $162bdfe7c043978f$var$transform = {
    noPrefill: [
        'transform'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transform') return false;
        if (options.transform) return prop;
        return $162bdfe7c043978f$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $162bdfe7c043978f$var$transition = {
    noPrefill: [
        'transition'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transition') return false;
        if (options.transition) return prop;
        return $162bdfe7c043978f$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $162bdfe7c043978f$var$writingMode = {
    noPrefill: [
        'writing-mode'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'writing-mode') return false;
        if ($162bdfe7c043978f$export$82e9f45cca5ba907.js === 'Webkit' || $162bdfe7c043978f$export$82e9f45cca5ba907.js === 'ms' && $162bdfe7c043978f$export$82e9f45cca5ba907.browser !== 'edge') return $162bdfe7c043978f$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $162bdfe7c043978f$var$userSelect = {
    noPrefill: [
        'user-select'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'user-select') return false;
        if ($162bdfe7c043978f$export$82e9f45cca5ba907.js === 'Moz' || $162bdfe7c043978f$export$82e9f45cca5ba907.js === 'ms' || $162bdfe7c043978f$export$82e9f45cca5ba907.vendor === 'apple') return $162bdfe7c043978f$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $162bdfe7c043978f$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($162bdfe7c043978f$export$82e9f45cca5ba907.js === 'Webkit') {
            var jsProp = "WebkitColumn" + $162bdfe7c043978f$var$pascalize(prop);
            return jsProp in style ? $162bdfe7c043978f$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($162bdfe7c043978f$export$82e9f45cca5ba907.js === 'Moz') {
            var _jsProp = "page" + $162bdfe7c043978f$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $162bdfe7c043978f$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($162bdfe7c043978f$export$82e9f45cca5ba907.js === 'Moz') return prop;
        var newProp = prop.replace('-inline', '');
        return $162bdfe7c043978f$export$82e9f45cca5ba907.js + $162bdfe7c043978f$var$pascalize(newProp) in style ? $162bdfe7c043978f$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $162bdfe7c043978f$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $162bdfe7c043978f$var$camelize(prop) in style ? prop : false;
    }
};
var $162bdfe7c043978f$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $162bdfe7c043978f$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.
        if (prop[0] === '-' && prop[1] === '-') return prop;
        if ($162bdfe7c043978f$export$82e9f45cca5ba907.js + pascalized in style) return $162bdfe7c043978f$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($162bdfe7c043978f$export$82e9f45cca5ba907.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $162bdfe7c043978f$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== 'scroll-snap') return false;
        if ($162bdfe7c043978f$export$82e9f45cca5ba907.js === 'ms') return "" + $162bdfe7c043978f$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $162bdfe7c043978f$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'overscroll-behavior') return false;
        if ($162bdfe7c043978f$export$82e9f45cca5ba907.js === 'ms') return $162bdfe7c043978f$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $162bdfe7c043978f$var$propMap = {
    'flex-grow': 'flex-positive',
    'flex-shrink': 'flex-negative',
    'flex-basis': 'flex-preferred-size',
    'justify-content': 'flex-pack',
    order: 'flex-order',
    'align-items': 'flex-align',
    'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $162bdfe7c043978f$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $162bdfe7c043978f$var$propMap[prop];
        if (!newProp) return false;
        return $162bdfe7c043978f$export$82e9f45cca5ba907.js + $162bdfe7c043978f$var$pascalize(newProp) in style ? $162bdfe7c043978f$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $162bdfe7c043978f$var$propMap$1 = {
    flex: 'box-flex',
    'flex-grow': 'box-flex',
    'flex-direction': [
        'box-orient',
        'box-direction'
    ],
    order: 'box-ordinal-group',
    'align-items': 'box-align',
    'flex-flow': [
        'box-orient',
        'box-direction'
    ],
    'justify-content': 'box-pack'
};
var $162bdfe7c043978f$var$propKeys = Object.keys($162bdfe7c043978f$var$propMap$1);
var $162bdfe7c043978f$var$prefixCss = function prefixCss(p) {
    return $162bdfe7c043978f$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $162bdfe7c043978f$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($162bdfe7c043978f$var$propKeys.indexOf(prop) > -1) {
            var newProp = $162bdfe7c043978f$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $162bdfe7c043978f$export$82e9f45cca5ba907.js + $162bdfe7c043978f$var$pascalize(newProp) in style ? $162bdfe7c043978f$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($162bdfe7c043978f$export$82e9f45cca5ba907.js + $162bdfe7c043978f$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($162bdfe7c043978f$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $162bdfe7c043978f$var$plugins = [
    $162bdfe7c043978f$var$appearence,
    $162bdfe7c043978f$var$colorAdjust,
    $162bdfe7c043978f$var$mask,
    $162bdfe7c043978f$var$textOrientation,
    $162bdfe7c043978f$var$transform,
    $162bdfe7c043978f$var$transition,
    $162bdfe7c043978f$var$writingMode,
    $162bdfe7c043978f$var$userSelect,
    $162bdfe7c043978f$var$breakPropsOld,
    $162bdfe7c043978f$var$inlineLogicalOld,
    $162bdfe7c043978f$var$unprefixed,
    $162bdfe7c043978f$var$prefixed,
    $162bdfe7c043978f$var$scrollSnap,
    $162bdfe7c043978f$var$overscrollBehavior,
    $162bdfe7c043978f$var$flex2012,
    $162bdfe7c043978f$var$flex2009
];
var $162bdfe7c043978f$var$propertyDetectors = $162bdfe7c043978f$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $162bdfe7c043978f$var$noPrefill = $162bdfe7c043978f$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $29OAR.default)(p.noPrefill));
    return a;
}, []);
var $162bdfe7c043978f$var$el;
var $162bdfe7c043978f$var$cache = {};
if (0, $4rd5g.default) {
    $162bdfe7c043978f$var$el = document.createElement('p'); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $162bdfe7c043978f$var$computed = window.getComputedStyle(document.documentElement, '');
    for(var $162bdfe7c043978f$var$key$1 in $162bdfe7c043978f$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($162bdfe7c043978f$var$key$1)) $162bdfe7c043978f$var$cache[$162bdfe7c043978f$var$computed[$162bdfe7c043978f$var$key$1]] = $162bdfe7c043978f$var$computed[$162bdfe7c043978f$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $162bdfe7c043978f$var$noPrefill.forEach(function(x) {
        return delete $162bdfe7c043978f$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $162bdfe7c043978f$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$162bdfe7c043978f$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($162bdfe7c043978f$var$cache[prop] != null) return $162bdfe7c043978f$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === 'transition' || prop === 'transform') options[prop] = prop in $162bdfe7c043978f$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $162bdfe7c043978f$var$propertyDetectors.length; i++){
        $162bdfe7c043978f$var$cache[prop] = $162bdfe7c043978f$var$propertyDetectors[i](prop, $162bdfe7c043978f$var$el.style, options); // Break loop, if value found.
        if ($162bdfe7c043978f$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $162bdfe7c043978f$var$el.style[prop] = '';
    } catch (err) {
        return false;
    }
    return $162bdfe7c043978f$var$cache[prop];
}
var $162bdfe7c043978f$var$cache$1 = {};
var $162bdfe7c043978f$var$transitionProperties = {
    transition: 1,
    'transition-property': 1,
    '-webkit-transition': 1,
    '-webkit-transition-property': 1
};
var $162bdfe7c043978f$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $162bdfe7c043978f$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $162bdfe7c043978f$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === 'var') return 'var';
    if (p1 === 'all') return 'all';
    if (p2 === 'all') return ', all';
    var prefixedValue = p1 ? $162bdfe7c043978f$export$ce097f82c2e4551a(p1) : ", " + $162bdfe7c043978f$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $4rd5g.default) $162bdfe7c043978f$var$el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $162bdfe7c043978f$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$162bdfe7c043978f$var$el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($162bdfe7c043978f$var$cache$1[cacheKey] != null) return $162bdfe7c043978f$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $162bdfe7c043978f$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $162bdfe7c043978f$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($162bdfe7c043978f$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($162bdfe7c043978f$var$transPropsRegExp, $162bdfe7c043978f$var$prefixTransitionCallback);
    else if ($162bdfe7c043978f$var$el$1.style[property] === '') {
        // Value with a vendor prefix.
        prefixedValue = $162bdfe7c043978f$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === '-ms-flex') $162bdfe7c043978f$var$el$1.style[property] = '-ms-flexbox'; // Test prefixed value.
        $162bdfe7c043978f$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($162bdfe7c043978f$var$el$1.style[property] === '') {
            $162bdfe7c043978f$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $162bdfe7c043978f$var$el$1.style[property] = ''; // Write current value to cache.
    $162bdfe7c043978f$var$cache$1[cacheKey] = prefixedValue;
    return $162bdfe7c043978f$var$cache$1[cacheKey];
}

});
parcelRegister("29OAR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1923aae008b586b9$export$2e2bcd8739ae039; });

var $ktGmL = parcelRequire("ktGmL");

var $EKeF1 = parcelRequire("EKeF1");

var $2Qb0M = parcelRequire("2Qb0M");

var $5cD3D = parcelRequire("5cD3D");
function $1923aae008b586b9$export$2e2bcd8739ae039(r) {
    return (0, $ktGmL.default)(r) || (0, $EKeF1.default)(r) || (0, $2Qb0M.default)(r) || (0, $5cD3D.default)();
}

});
parcelRegister("ktGmL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee87611c4ee27854$export$2e2bcd8739ae039; });

var $GA7IS = parcelRequire("GA7IS");
function $ee87611c4ee27854$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $GA7IS.default)(r);
}

});
parcelRegister("GA7IS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07fff1bed40215bc$export$2e2bcd8739ae039; });
function $07fff1bed40215bc$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("EKeF1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07a799f10be5b13a$export$2e2bcd8739ae039; });
function $07a799f10be5b13a$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("2Qb0M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2118fac7c642056e$export$2e2bcd8739ae039; });

var $GA7IS = parcelRequire("GA7IS");
function $2118fac7c642056e$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $GA7IS.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $GA7IS.default)(r, a) : void 0;
    }
}

});

parcelRegister("5cD3D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c9c5ec796e7438e$export$2e2bcd8739ae039; });
function $3c9c5ec796e7438e$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("5fUzF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d3a3cec0c78dd8a$export$2e2bcd8739ae039; });
/**
 * Sort props by length.
 */ function $3d3a3cec0c78dd8a$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== 'style') return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $3d3a3cec0c78dd8a$export$2e2bcd8739ae039 = $3d3a3cec0c78dd8a$var$jssPropsSort;

});



parcelRegister("3SCg9", function(module, exports) {

$parcel$export(module.exports, "increment", function () { return $2d3417ceedff949b$export$a2647aa13413c947; });
/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var $2d3417ceedff949b$var$indexCounter = -1000000000;
function $2d3417ceedff949b$export$a2647aa13413c947() {
    $2d3417ceedff949b$var$indexCounter += 1;
    return $2d3417ceedff949b$var$indexCounter;
}

});

parcelRegister("TpYGg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a6949cdafc77648$export$2e2bcd8739ae039; });

var $4gAfe = parcelRequire("4gAfe");
parcelRequire("4y2TO");

var $3GOjU = parcelRequire("3GOjU");

function $0a6949cdafc77648$export$2e2bcd8739ae039(stylesOrCreator) {
    var themingEnabled = typeof stylesOrCreator === 'function';
    return {
        create: function create(theme, name) {
            var styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.overrides || !theme.overrides[name]) return styles;
            var overrides = theme.overrides[name];
            var stylesWithOverrides = (0, $4gAfe.default)({}, styles);
            Object.keys(overrides).forEach(function(key) {
                stylesWithOverrides[key] = (0, $3GOjU.default)(stylesWithOverrides[key], overrides[key]);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}

});
parcelRegister("4y2TO", function(module, exports) {
function $34fc961db650cb22$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $34fc961db650cb22$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $34fc961db650cb22$export$2e2bcd8739ae039(o);
}

});

parcelRegister("3GOjU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2afc53e04c2dbbd8$export$2e2bcd8739ae039; });

var $6YDmE = parcelRequire("6YDmE");

var $5IfTr = parcelRequire("5IfTr");
function $2afc53e04c2dbbd8$export$53b83ca8eaab0383(item) {
    return item && (0, $5IfTr.default)(item) === 'object' && item.constructor === Object;
}
function $2afc53e04c2dbbd8$export$2e2bcd8739ae039(target, source) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        clone: true
    };
    var output = options.clone ? (0, $6YDmE.default)({}, target) : target;
    if ($2afc53e04c2dbbd8$export$53b83ca8eaab0383(target) && $2afc53e04c2dbbd8$export$53b83ca8eaab0383(source)) Object.keys(source).forEach(function(key) {
        // Avoid prototype pollution
        if (key === '__proto__') return;
        if ($2afc53e04c2dbbd8$export$53b83ca8eaab0383(source[key]) && key in target) output[key] = $2afc53e04c2dbbd8$export$2e2bcd8739ae039(target[key], source[key], options);
        else output[key] = source[key];
    });
    return output;
}

});
parcelRegister("6YDmE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5146e1991077eb46$export$2e2bcd8739ae039; });
function $5146e1991077eb46$export$2e2bcd8739ae039() {
    return $5146e1991077eb46$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5146e1991077eb46$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("5IfTr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $428d63e3dbb79dd8$export$2e2bcd8739ae039; });
function $428d63e3dbb79dd8$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $428d63e3dbb79dd8$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $428d63e3dbb79dd8$export$2e2bcd8739ae039(o);
}

});



parcelRegister("gZPDU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5fa6705e4f54e11$export$2e2bcd8739ae039; });
// We use the same empty object to ref count the styles that don't need a theme object.
var $c5fa6705e4f54e11$var$noopTheme = {};
var $c5fa6705e4f54e11$export$2e2bcd8739ae039 = $c5fa6705e4f54e11$var$noopTheme;

});


parcelRegister("bKHfy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88e58a1e93e45bb9$export$2e2bcd8739ae039; });
/* eslint-disable no-restricted-syntax */ function $88e58a1e93e45bb9$export$2e2bcd8739ae039(params) {
    var theme = params.theme, name = params.name, props = params.props;
    if (!theme || !theme.props || !theme.props[name]) return props;
     // Resolve default props, code borrow from React source.
    // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
    var defaultProps = theme.props[name];
    var propName;
    for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
    return props;
}

});


parcelRegister("kkrWC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eccb5a17700eb5dc$export$2e2bcd8739ae039; });

var $gXLwJ = parcelRequire("gXLwJ");
var $eccb5a17700eb5dc$var$defaultTheme = (0, $gXLwJ.default)();
var $eccb5a17700eb5dc$export$2e2bcd8739ae039 = $eccb5a17700eb5dc$var$defaultTheme;

});
parcelRegister("gXLwJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c59705e4977790de$export$2e2bcd8739ae039; });
parcelRequire("9p9Gy");

var $eTwGP = parcelRequire("eTwGP");

var $3GOjU = parcelRequire("3GOjU");

var $3CxNI = parcelRequire("3CxNI");

var $h9n38 = parcelRequire("h9n38");

var $gw3i5 = parcelRequire("gw3i5");

var $9LLq7 = parcelRequire("9LLq7");

var $aR1UD = parcelRequire("aR1UD");

var $9UMX8 = parcelRequire("9UMX8");

var $diTy2 = parcelRequire("diTy2");

var $ejUtG = parcelRequire("ejUtG");

var $7fkth = parcelRequire("7fkth");
function $c59705e4977790de$var$createTheme() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$breakpoints = options.breakpoints, breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints, _options$mixins = options.mixins, mixinsInput = _options$mixins === void 0 ? {} : _options$mixins, _options$palette = options.palette, paletteInput = _options$palette === void 0 ? {} : _options$palette, spacingInput = options.spacing, _options$typography = options.typography, typographyInput = _options$typography === void 0 ? {} : _options$typography, other = (0, $eTwGP.default)(options, [
        "breakpoints",
        "mixins",
        "palette",
        "spacing",
        "typography"
    ]);
    var palette = (0, $gw3i5.default)(paletteInput);
    var breakpoints = (0, $3CxNI.default)(breakpointsInput);
    var spacing = (0, $diTy2.default)(spacingInput);
    var muiTheme = (0, $3GOjU.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        mixins: (0, $h9n38.default)(breakpoints, spacing, mixinsInput),
        overrides: {},
        // Inject custom styles
        palette: palette,
        props: {},
        // Provide default props
        shadows: (0, $aR1UD.default),
        typography: (0, $9LLq7.default)(palette, typographyInput),
        spacing: spacing,
        shape: (0, $9UMX8.default),
        transitions: (0, $ejUtG.default),
        zIndex: (0, $7fkth.default)
    }, other);
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    muiTheme = args.reduce(function(acc, argument) {
        return (0, $3GOjU.default)(acc, argument);
    }, muiTheme);
    var pseudoClasses, traverse;
    return muiTheme;
}
var $c59705e4977790de$var$warnedOnce = false;
function $c59705e4977790de$export$c469355549431d9b() {
    return $c59705e4977790de$var$createTheme.apply(void 0, arguments);
}
var $c59705e4977790de$export$2e2bcd8739ae039 = $c59705e4977790de$var$createTheme;

});
parcelRegister("9p9Gy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d8df6306230a3ee$export$2e2bcd8739ae039; });

var $kOL9i = parcelRequire("kOL9i");
function $6d8df6306230a3ee$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $kOL9i.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("kOL9i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f27d0cf4c09abc16$export$2e2bcd8739ae039; });

var $ar9wC = parcelRequire("ar9wC");

var $kLVF4 = parcelRequire("kLVF4");
function $f27d0cf4c09abc16$export$2e2bcd8739ae039(t) {
    var i = (0, $kLVF4.default)(t, "string");
    return "symbol" == (0, $ar9wC.default)(i) ? i : i + "";
}

});
parcelRegister("ar9wC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7993d07afbb5abcd$export$2e2bcd8739ae039; });
function $7993d07afbb5abcd$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $7993d07afbb5abcd$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7993d07afbb5abcd$export$2e2bcd8739ae039(o);
}

});

parcelRegister("kLVF4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1f4ecce77332802$export$2e2bcd8739ae039; });

var $ar9wC = parcelRequire("ar9wC");
function $f1f4ecce77332802$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $ar9wC.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $ar9wC.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("3CxNI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a2f23de431aa438$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");
var $2a2f23de431aa438$export$ed97f33186d4b816 = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
]; // Keep in mind that @media is inclusive by the CSS specification.
function $2a2f23de431aa438$export$2e2bcd8739ae039(breakpoints) {
    var _breakpoints$values = breakpoints.values, values = _breakpoints$values === void 0 ? {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
    } : _breakpoints$values, _breakpoints$unit = breakpoints.unit, unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit, _breakpoints$step = breakpoints.step, step = _breakpoints$step === void 0 ? 5 : _breakpoints$step, other = (0, $eTwGP.default)(breakpoints, [
        "values",
        "unit",
        "step"
    ]);
    function up(key) {
        var value = typeof values[key] === 'number' ? values[key] : key;
        return "@media (min-width:".concat(value).concat(unit, ")");
    }
    function down(key) {
        var endIndex = $2a2f23de431aa438$export$ed97f33186d4b816.indexOf(key) + 1;
        var upperbound = values[$2a2f23de431aa438$export$ed97f33186d4b816[endIndex]];
        if (endIndex === $2a2f23de431aa438$export$ed97f33186d4b816.length) // xl down applies to all sizes
        return up('xs');
        var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
        return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
    }
    function between(start, end) {
        var endIndex = $2a2f23de431aa438$export$ed97f33186d4b816.indexOf(end);
        if (endIndex === $2a2f23de431aa438$export$ed97f33186d4b816.length - 1) return up(start);
        return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[$2a2f23de431aa438$export$ed97f33186d4b816[endIndex + 1]] === 'number' ? values[$2a2f23de431aa438$export$ed97f33186d4b816[endIndex + 1]] : end) - step / 100).concat(unit, ")");
    }
    function only(key) {
        return between(key, key);
    }
    var warnedOnce = false;
    function width(key) {
        return values[key];
    }
    return (0, $edxsd.default)({
        keys: $2a2f23de431aa438$export$ed97f33186d4b816,
        values: values,
        up: up,
        down: down,
        between: between,
        only: only,
        width: width
    }, other);
}

});

parcelRegister("h9n38", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7c52817da3cefe7$export$2e2bcd8739ae039; });

var $9p9Gy = parcelRequire("9p9Gy");

var $edxsd = parcelRequire("edxsd");
function $c7c52817da3cefe7$export$2e2bcd8739ae039(breakpoints, spacing, mixins) {
    var _toolbar;
    return (0, $edxsd.default)({
        gutters: function gutters() {
            var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            console.warn([
                'Material-UI: theme.mixins.gutters() is deprecated.',
                'You can use the source of the mixin directly:',
                "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "
            ].join('\n'));
            return (0, $edxsd.default)({
                paddingLeft: spacing(2),
                paddingRight: spacing(2)
            }, styles, (0, $9p9Gy.default)({}, breakpoints.up('sm'), (0, $edxsd.default)({
                paddingLeft: spacing(3),
                paddingRight: spacing(3)
            }, styles[breakpoints.up('sm')])));
        },
        toolbar: (_toolbar = {
            minHeight: 56
        }, (0, $9p9Gy.default)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
            minHeight: 48
        }), (0, $9p9Gy.default)(_toolbar, breakpoints.up('sm'), {
            minHeight: 64
        }), _toolbar)
    }, mixins);
}

});

parcelRegister("gw3i5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0622ffb4cf9aaff$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $3GOjU = parcelRequire("3GOjU");
var $bPjvu = parcelRequire("bPjvu");

var $3evk9 = parcelRequire("3evk9");

var $cbey2 = parcelRequire("cbey2");

var $aKPAB = parcelRequire("aKPAB");

var $7rO6l = parcelRequire("7rO6l");

var $fpPVY = parcelRequire("fpPVY");

var $7s2Kf = parcelRequire("7s2Kf");

var $9zOfc = parcelRequire("9zOfc");

var $1hJPn = parcelRequire("1hJPn");

var $86m3e = parcelRequire("86m3e");
var $c0622ffb4cf9aaff$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.54)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)',
        // Text hints.
        hint: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $3evk9.default).white,
        default: (0, $cbey2.default)[50]
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
var $c0622ffb4cf9aaff$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $3evk9.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        hint: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: (0, $cbey2.default)[800],
        default: '#303030'
    },
    action: {
        active: (0, $3evk9.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $c0622ffb4cf9aaff$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    var tonalOffsetLight = tonalOffset.light || tonalOffset;
    var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $86m3e.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $86m3e.darken)(intent.main, tonalOffsetDark);
    }
}
function $c0622ffb4cf9aaff$export$2e2bcd8739ae039(palette) {
    var _palette$primary = palette.primary, primary = _palette$primary === void 0 ? {
        light: (0, $aKPAB.default)[300],
        main: (0, $aKPAB.default)[500],
        dark: (0, $aKPAB.default)[700]
    } : _palette$primary, _palette$secondary = palette.secondary, secondary = _palette$secondary === void 0 ? {
        light: (0, $7rO6l.default).A200,
        main: (0, $7rO6l.default).A400,
        dark: (0, $7rO6l.default).A700
    } : _palette$secondary, _palette$error = palette.error, error = _palette$error === void 0 ? {
        light: (0, $fpPVY.default)[300],
        main: (0, $fpPVY.default)[500],
        dark: (0, $fpPVY.default)[700]
    } : _palette$error, _palette$warning = palette.warning, warning = _palette$warning === void 0 ? {
        light: (0, $7s2Kf.default)[300],
        main: (0, $7s2Kf.default)[500],
        dark: (0, $7s2Kf.default)[700]
    } : _palette$warning, _palette$info = palette.info, info = _palette$info === void 0 ? {
        light: (0, $9zOfc.default)[300],
        main: (0, $9zOfc.default)[500],
        dark: (0, $9zOfc.default)[700]
    } : _palette$info, _palette$success = palette.success, success = _palette$success === void 0 ? {
        light: (0, $1hJPn.default)[300],
        main: (0, $1hJPn.default)[500],
        dark: (0, $1hJPn.default)[700]
    } : _palette$success, _palette$type = palette.type, type = _palette$type === void 0 ? 'light' : _palette$type, _palette$contrastThre = palette.contrastThreshold, contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre, _palette$tonalOffset = palette.tonalOffset, tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset, other = (0, $eTwGP.default)(palette, [
        "primary",
        "secondary",
        "error",
        "warning",
        "info",
        "success",
        "type",
        "contrastThreshold",
        "tonalOffset"
    ]); // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        var contrastText = (0, $86m3e.getContrastRatio)(background, $c0622ffb4cf9aaff$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $c0622ffb4cf9aaff$export$55ce6f3a06c59543.text.primary : $c0622ffb4cf9aaff$export$a43af521ac8c3202.text.primary;
        var contrast;
        return contrastText;
    }
    var augmentColor = function augmentColor(color) {
        var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
        var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
        var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
        color = (0, $edxsd.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.main) throw new Error((0, $bPjvu.default)(4, mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $bPjvu.default)(5, JSON.stringify(color.main)));
        $c0622ffb4cf9aaff$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $c0622ffb4cf9aaff$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    var types = {
        dark: $c0622ffb4cf9aaff$export$55ce6f3a06c59543,
        light: $c0622ffb4cf9aaff$export$a43af521ac8c3202
    };
    var paletteOutput = (0, $3GOjU.default)((0, $edxsd.default)({
        // A collection of common colors.
        common: (0, $3evk9.default),
        // The palette type, can be light or dark.
        type: type,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor(primary),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor(error),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor(warning),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor(info),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor(success),
        // The grey colors.
        grey: (0, $cbey2.default),
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText: getContrastText,
        // Generate a rich color object.
        augmentColor: augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: tonalOffset
    }, types[type]), other);
    return paletteOutput;
}

});
parcelRegister("bPjvu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89c396cf6eabb773$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $89c396cf6eabb773$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ var url = 'https://mui.com/production-error/?code=' + code;
    for(var i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});

parcelRegister("3evk9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25aafa39d7802339$export$2e2bcd8739ae039; });
var $25aafa39d7802339$var$common = {
    black: '#000',
    white: '#fff'
};
var $25aafa39d7802339$export$2e2bcd8739ae039 = $25aafa39d7802339$var$common;

});

parcelRegister("cbey2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8de1cc0be034b1d5$export$2e2bcd8739ae039; });
var $8de1cc0be034b1d5$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#d5d5d5',
    A200: '#aaaaaa',
    A400: '#303030',
    A700: '#616161'
};
var $8de1cc0be034b1d5$export$2e2bcd8739ae039 = $8de1cc0be034b1d5$var$grey;

});

parcelRegister("aKPAB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d4637d498102d09$export$2e2bcd8739ae039; });
var $7d4637d498102d09$var$indigo = {
    50: '#e8eaf6',
    100: '#c5cae9',
    200: '#9fa8da',
    300: '#7986cb',
    400: '#5c6bc0',
    500: '#3f51b5',
    600: '#3949ab',
    700: '#303f9f',
    800: '#283593',
    900: '#1a237e',
    A100: '#8c9eff',
    A200: '#536dfe',
    A400: '#3d5afe',
    A700: '#304ffe'
};
var $7d4637d498102d09$export$2e2bcd8739ae039 = $7d4637d498102d09$var$indigo;

});

parcelRegister("7rO6l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56c1eb16cb963b9f$export$2e2bcd8739ae039; });
var $56c1eb16cb963b9f$var$pink = {
    50: '#fce4ec',
    100: '#f8bbd0',
    200: '#f48fb1',
    300: '#f06292',
    400: '#ec407a',
    500: '#e91e63',
    600: '#d81b60',
    700: '#c2185b',
    800: '#ad1457',
    900: '#880e4f',
    A100: '#ff80ab',
    A200: '#ff4081',
    A400: '#f50057',
    A700: '#c51162'
};
var $56c1eb16cb963b9f$export$2e2bcd8739ae039 = $56c1eb16cb963b9f$var$pink;

});

parcelRegister("fpPVY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b39179d8b1e29dd5$export$2e2bcd8739ae039; });
var $b39179d8b1e29dd5$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $b39179d8b1e29dd5$export$2e2bcd8739ae039 = $b39179d8b1e29dd5$var$red;

});

parcelRegister("7s2Kf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56cd46fde71c76db$export$2e2bcd8739ae039; });
var $56cd46fde71c76db$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $56cd46fde71c76db$export$2e2bcd8739ae039 = $56cd46fde71c76db$var$orange;

});

parcelRegister("9zOfc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f8e5b689a7bd616$export$2e2bcd8739ae039; });
var $6f8e5b689a7bd616$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $6f8e5b689a7bd616$export$2e2bcd8739ae039 = $6f8e5b689a7bd616$var$blue;

});

parcelRegister("1hJPn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0efaed688decc424$export$2e2bcd8739ae039; });
var $0efaed688decc424$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $0efaed688decc424$export$2e2bcd8739ae039 = $0efaed688decc424$var$green;

});

parcelRegister("86m3e", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", function () { return $5e5ffd25e7d6750e$export$d061e26956a60b0a; });
$parcel$export(module.exports, "emphasize", function () { return $5e5ffd25e7d6750e$export$e665714f76e581fd; });
$parcel$export(module.exports, "darken", function () { return $5e5ffd25e7d6750e$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $5e5ffd25e7d6750e$export$c0816ed86df316af; });
$parcel$export(module.exports, "fade", function () { return $5e5ffd25e7d6750e$export$cbea29d068a2e18f; });
$parcel$export(module.exports, "alpha", function () { return $5e5ffd25e7d6750e$export$58f0f39f63f3cf42; });

var $bPjvu = parcelRequire("bPjvu");
/* eslint-disable no-use-before-define */ /**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $5e5ffd25e7d6750e$var$clamp(value) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    return Math.min(Math.max(min, value), max);
}
function $5e5ffd25e7d6750e$export$5a544e13ad4e1fa5(color) {
    color = color.substr(1);
    var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
    var colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map(function(n) {
        return n + n;
    });
    return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function(n, index) {
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', '), ")") : '';
}
function $5e5ffd25e7d6750e$var$intToHex(int) {
    var hex = int.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
}
function $5e5ffd25e7d6750e$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    var _decomposeColor = $5e5ffd25e7d6750e$export$677b39864803984e(color), values = _decomposeColor.values;
    return "#".concat(values.map(function(n) {
        return $5e5ffd25e7d6750e$var$intToHex(n);
    }).join(''));
}
function $5e5ffd25e7d6750e$export$29fb7152bd3f781a(color) {
    color = $5e5ffd25e7d6750e$export$677b39864803984e(color);
    var _color = color, values = _color.values;
    var h = values[0];
    var s = values[1] / 100;
    var l = values[2] / 100;
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
        return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };
    var type = 'rgb';
    var rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $5e5ffd25e7d6750e$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $5e5ffd25e7d6750e$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $5e5ffd25e7d6750e$export$677b39864803984e($5e5ffd25e7d6750e$export$5a544e13ad4e1fa5(color));
    var marker = color.indexOf('(');
    var type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla'
    ].indexOf(type) === -1) throw new Error((0, $bPjvu.default)(3, color));
    var values = color.substring(marker + 1, color.length - 1).split(',');
    values = values.map(function(value) {
        return parseFloat(value);
    });
    return {
        type: type,
        values: values
    };
}
function $5e5ffd25e7d6750e$export$211a73f2b8c10ce4(color) {
    var type = color.type;
    var values = color.values;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function(n, i) {
        return i < 3 ? parseInt(n, 10) : n;
    });
    else if (type.indexOf('hsl') !== -1) {
        values[1] = "".concat(values[1], "%");
        values[2] = "".concat(values[2], "%");
    }
    return "".concat(type, "(").concat(values.join(', '), ")");
}
function $5e5ffd25e7d6750e$export$d061e26956a60b0a(foreground, background) {
    var lumA = $5e5ffd25e7d6750e$export$c852d90bf7403b62(foreground);
    var lumB = $5e5ffd25e7d6750e$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $5e5ffd25e7d6750e$export$c852d90bf7403b62(color) {
    color = $5e5ffd25e7d6750e$export$677b39864803984e(color);
    var rgb = color.type === 'hsl' ? $5e5ffd25e7d6750e$export$677b39864803984e($5e5ffd25e7d6750e$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map(function(val) {
        val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $5e5ffd25e7d6750e$export$e665714f76e581fd(color) {
    var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
    return $5e5ffd25e7d6750e$export$c852d90bf7403b62(color) > 0.5 ? $5e5ffd25e7d6750e$export$4b073707ff63303(color, coefficient) : $5e5ffd25e7d6750e$export$c0816ed86df316af(color, coefficient);
}
var $5e5ffd25e7d6750e$var$warnedOnce = false;
function $5e5ffd25e7d6750e$export$cbea29d068a2e18f(color, value) {
    return $5e5ffd25e7d6750e$export$58f0f39f63f3cf42(color, value);
}
function $5e5ffd25e7d6750e$export$58f0f39f63f3cf42(color, value) {
    color = $5e5ffd25e7d6750e$export$677b39864803984e(color);
    value = $5e5ffd25e7d6750e$var$clamp(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    color.values[3] = value;
    return $5e5ffd25e7d6750e$export$211a73f2b8c10ce4(color);
}
function $5e5ffd25e7d6750e$export$4b073707ff63303(color, coefficient) {
    color = $5e5ffd25e7d6750e$export$677b39864803984e(color);
    coefficient = $5e5ffd25e7d6750e$var$clamp(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(var i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $5e5ffd25e7d6750e$export$211a73f2b8c10ce4(color);
}
function $5e5ffd25e7d6750e$export$c0816ed86df316af(color, coefficient) {
    color = $5e5ffd25e7d6750e$export$677b39864803984e(color);
    coefficient = $5e5ffd25e7d6750e$var$clamp(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(var i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    return $5e5ffd25e7d6750e$export$211a73f2b8c10ce4(color);
}

});


parcelRegister("9LLq7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71cd498108ce24d7$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $3GOjU = parcelRequire("3GOjU");
function $71cd498108ce24d7$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
var $71cd498108ce24d7$var$warnedOnce = false;
function $71cd498108ce24d7$var$roundWithDeprecationWarning(value) {
    return $71cd498108ce24d7$var$round(value);
}
var $71cd498108ce24d7$var$caseAllCaps = {
    textTransform: 'uppercase'
};
var $71cd498108ce24d7$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $71cd498108ce24d7$export$2e2bcd8739ae039(palette, typography) {
    var _ref = typeof typography === 'function' ? typography(palette) : typography, _ref$fontFamily = _ref.fontFamily, fontFamily = _ref$fontFamily === void 0 ? $71cd498108ce24d7$var$defaultFontFamily : _ref$fontFamily, _ref$fontSize = _ref.fontSize, fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize, _ref$fontWeightLight = _ref.fontWeightLight, fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight, _ref$fontWeightRegula = _ref.fontWeightRegular, fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula, _ref$fontWeightMedium = _ref.fontWeightMedium, fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium, _ref$fontWeightBold = _ref.fontWeightBold, fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold, _ref$htmlFontSize = _ref.htmlFontSize, htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize, allVariants = _ref.allVariants, pxToRem2 = _ref.pxToRem, other = (0, $eTwGP.default)(_ref, [
        "fontFamily",
        "fontSize",
        "fontWeightLight",
        "fontWeightRegular",
        "fontWeightMedium",
        "fontWeightBold",
        "htmlFontSize",
        "allVariants",
        "pxToRem"
    ]);
    var coef = fontSize / 14;
    var pxToRem = pxToRem2 || function(size) {
        return "".concat(size / htmlFontSize * coef, "rem");
    };
    var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
        return (0, $edxsd.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight: lineHeight
        }, fontFamily === $71cd498108ce24d7$var$defaultFontFamily ? {
            letterSpacing: "".concat($71cd498108ce24d7$var$round(letterSpacing / size), "em")
        } : {}, casing, allVariants);
    };
    var variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $71cd498108ce24d7$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $71cd498108ce24d7$var$caseAllCaps)
    };
    return (0, $3GOjU.default)((0, $edxsd.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        round: $71cd498108ce24d7$var$roundWithDeprecationWarning,
        // TODO v5: remove
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("aR1UD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e70566112dadb06$export$2e2bcd8739ae039; });
var $7e70566112dadb06$var$shadowKeyUmbraOpacity = 0.2;
var $7e70566112dadb06$var$shadowKeyPenumbraOpacity = 0.14;
var $7e70566112dadb06$var$shadowAmbientShadowOpacity = 0.12;
function $7e70566112dadb06$var$createShadow() {
    return [
        "".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat($7e70566112dadb06$var$shadowKeyUmbraOpacity, ")"),
        "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat($7e70566112dadb06$var$shadowKeyPenumbraOpacity, ")"),
        "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat($7e70566112dadb06$var$shadowAmbientShadowOpacity, ")")
    ].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
var $7e70566112dadb06$var$shadows = [
    'none',
    $7e70566112dadb06$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $7e70566112dadb06$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $7e70566112dadb06$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $7e70566112dadb06$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $7e70566112dadb06$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $7e70566112dadb06$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $7e70566112dadb06$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $7e70566112dadb06$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $7e70566112dadb06$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $7e70566112dadb06$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $7e70566112dadb06$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $7e70566112dadb06$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $7e70566112dadb06$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $7e70566112dadb06$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $7e70566112dadb06$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $7e70566112dadb06$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $7e70566112dadb06$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $7e70566112dadb06$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $7e70566112dadb06$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $7e70566112dadb06$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $7e70566112dadb06$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $7e70566112dadb06$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $7e70566112dadb06$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $7e70566112dadb06$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $7e70566112dadb06$export$2e2bcd8739ae039 = $7e70566112dadb06$var$shadows;

});

parcelRegister("9UMX8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $737f510585eeba66$export$2e2bcd8739ae039; });
var $737f510585eeba66$var$shape = {
    borderRadius: 4
};
var $737f510585eeba66$export$2e2bcd8739ae039 = $737f510585eeba66$var$shape;

});

parcelRegister("diTy2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9af80b7bd1f6643a$export$2e2bcd8739ae039; });

var $2J9Wo = parcelRequire("2J9Wo");
var $9af80b7bd1f6643a$var$warnOnce;
function $9af80b7bd1f6643a$export$2e2bcd8739ae039() {
    var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
     // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
    // Smaller components, such as icons and type, can align to a 4dp grid.
    // https://material.io/design/layout/understanding-layout.html#usage
    var transform = (0, $2J9Wo.createUnarySpacing)({
        spacing: spacingInput
    });
    var spacing = function spacing() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 0) return transform(1);
        if (args.length === 1) return transform(args[0]);
        return args.map(function(argument) {
            if (typeof argument === 'string') return argument;
            var output = transform(argument);
            return typeof output === 'number' ? "".concat(output, "px") : output;
        }).join(' ');
    }; // Backward compatibility, to remove in v5.
    Object.defineProperty(spacing, 'unit', {
        get: function get() {
            return spacingInput;
        }
    });
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("2J9Wo", function(module, exports) {

$parcel$export(module.exports, "createUnarySpacing", function () { return $1fc77ecc1b65bb2a$export$1def6f833384e3d1; });

var $bkzxY = parcelRequire("bkzxY");


var $1zcB5 = parcelRequire("1zcB5");

var $is7Hx = parcelRequire("is7Hx");

var $g8IFw = parcelRequire("g8IFw");
var $1fc77ecc1b65bb2a$var$properties = {
    m: 'margin',
    p: 'padding'
};
var $1fc77ecc1b65bb2a$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
var $1fc77ecc1b65bb2a$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
var $1fc77ecc1b65bb2a$var$getCssProperties = (0, $g8IFw.default)(function(prop) {
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($1fc77ecc1b65bb2a$var$aliases[prop]) prop = $1fc77ecc1b65bb2a$var$aliases[prop];
        else return [
            prop
        ];
    }
    var _prop$split = prop.split(''), _prop$split2 = (0, $bkzxY.default)(_prop$split, 2), a = _prop$split2[0], b = _prop$split2[1];
    var property = $1fc77ecc1b65bb2a$var$properties[a];
    var direction = $1fc77ecc1b65bb2a$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map(function(dir) {
        return property + dir;
    }) : [
        property + direction
    ];
});
var $1fc77ecc1b65bb2a$var$spacingKeys = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY'
];
function $1fc77ecc1b65bb2a$export$1def6f833384e3d1(theme) {
    var themeSpacing = theme.spacing || 8;
    if (typeof themeSpacing === 'number') return function(abs) {
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return function(abs) {
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return function() {
        return undefined;
    };
}
function $1fc77ecc1b65bb2a$var$getValue(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    var abs = Math.abs(propValue);
    var transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return "-".concat(transformed);
}
function $1fc77ecc1b65bb2a$var$getStyleFromPropValue(cssProperties, transformer) {
    return function(propValue) {
        return cssProperties.reduce(function(acc, cssProperty) {
            acc[cssProperty] = $1fc77ecc1b65bb2a$var$getValue(transformer, propValue);
            return acc;
        }, {});
    };
}
function $1fc77ecc1b65bb2a$var$spacing(props) {
    var theme = props.theme;
    var transformer = $1fc77ecc1b65bb2a$export$1def6f833384e3d1(theme);
    return Object.keys(props).map(function(prop) {
        // Using a hash computation over an array iteration could be faster, but with only 28 items,
        // it's doesn't worth the bundle size.
        if ($1fc77ecc1b65bb2a$var$spacingKeys.indexOf(prop) === -1) return null;
        var cssProperties = $1fc77ecc1b65bb2a$var$getCssProperties(prop);
        var styleFromPropValue = $1fc77ecc1b65bb2a$var$getStyleFromPropValue(cssProperties, transformer);
        var propValue = props[prop];
        return (0, $1zcB5.handleBreakpoints)(props, propValue, styleFromPropValue);
    }).reduce((0, $is7Hx.default), {});
}
$1fc77ecc1b65bb2a$var$spacing.propTypes = {};
$1fc77ecc1b65bb2a$var$spacing.filterProps = $1fc77ecc1b65bb2a$var$spacingKeys;
var $1fc77ecc1b65bb2a$export$2e2bcd8739ae039 = $1fc77ecc1b65bb2a$var$spacing;

});
parcelRegister("bkzxY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83fd22d739dce809$export$2e2bcd8739ae039; });

var $clqJ0 = parcelRequire("clqJ0");

var $p5e5g = parcelRequire("p5e5g");

var $9wsGO = parcelRequire("9wsGO");

var $83IxS = parcelRequire("83IxS");
function $83fd22d739dce809$export$2e2bcd8739ae039(r, e) {
    return (0, $clqJ0.default)(r) || (0, $p5e5g.default)(r, e) || (0, $9wsGO.default)(r, e) || (0, $83IxS.default)();
}

});
parcelRegister("clqJ0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fcc2d367d772af5$export$2e2bcd8739ae039; });
function $8fcc2d367d772af5$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("p5e5g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04b663b87da4a8ee$export$2e2bcd8739ae039; });
function $04b663b87da4a8ee$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("9wsGO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6eed5b5983167568$export$2e2bcd8739ae039; });

var $bidVz = parcelRequire("bidVz");
function $6eed5b5983167568$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $bidVz.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $bidVz.default)(r, a) : void 0;
    }
}

});
parcelRegister("bidVz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $838c2dda8ead874c$export$2e2bcd8739ae039; });
function $838c2dda8ead874c$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("83IxS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5de128550241e800$export$2e2bcd8739ae039; });
function $5de128550241e800$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("1zcB5", function(module, exports) {

$parcel$export(module.exports, "handleBreakpoints", function () { return $1242d4dc3c313c31$export$88347efdb2e19abd; });

var $lvrvN = parcelRequire("lvrvN");

var $3tuRS = parcelRequire("3tuRS");

var $1PSi9 = parcelRequire("1PSi9");


var $is7Hx = parcelRequire("is7Hx");
// For instance with the first breakpoint xs: [xs, sm[.
var $1242d4dc3c313c31$var$values = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
};
var $1242d4dc3c313c31$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: function up(key) {
        return "@media (min-width:".concat($1242d4dc3c313c31$var$values[key], "px)");
    }
};
function $1242d4dc3c313c31$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    if (Array.isArray(propValue)) {
        var themeBreakpoints = props.theme.breakpoints || $1242d4dc3c313c31$var$defaultBreakpoints;
        return propValue.reduce(function(acc, item, index) {
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if ((0, $1PSi9.default)(propValue) === 'object') {
        var _themeBreakpoints = props.theme.breakpoints || $1242d4dc3c313c31$var$defaultBreakpoints;
        return Object.keys(propValue).reduce(function(acc, breakpoint) {
            acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
            return acc;
        }, {});
    }
    var output = styleFromPropValue(propValue);
    return output;
}
function $1242d4dc3c313c31$var$breakpoints(styleFunction) {
    var newStyleFunction = function newStyleFunction(props) {
        var base = styleFunction(props);
        var themeBreakpoints = props.theme.breakpoints || $1242d4dc3c313c31$var$defaultBreakpoints;
        var extended = themeBreakpoints.keys.reduce(function(acc, key) {
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $3tuRS.default)({
                    theme: props.theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $is7Hx.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ].concat((0, $lvrvN.default)(styleFunction.filterProps));
    return newStyleFunction;
}
var $1242d4dc3c313c31$export$2e2bcd8739ae039 = $1242d4dc3c313c31$var$breakpoints;

});
parcelRegister("lvrvN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa81d57bbe8451a3$export$2e2bcd8739ae039; });

var $aW9h6 = parcelRequire("aW9h6");

var $c1h7W = parcelRequire("c1h7W");

var $9wsGO = parcelRequire("9wsGO");

var $7YK2z = parcelRequire("7YK2z");
function $fa81d57bbe8451a3$export$2e2bcd8739ae039(r) {
    return (0, $aW9h6.default)(r) || (0, $c1h7W.default)(r) || (0, $9wsGO.default)(r) || (0, $7YK2z.default)();
}

});
parcelRegister("aW9h6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f6683f4fccd8a6f$export$2e2bcd8739ae039; });

var $bidVz = parcelRequire("bidVz");
function $7f6683f4fccd8a6f$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $bidVz.default)(r);
}

});

parcelRegister("c1h7W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c02dd1f7634d7e9$export$2e2bcd8739ae039; });
function $8c02dd1f7634d7e9$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("7YK2z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5cf1d9abede8d955$export$2e2bcd8739ae039; });
function $5cf1d9abede8d955$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("3tuRS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $287c064682bce2ca$export$2e2bcd8739ae039; });
function $287c064682bce2ca$export$2e2bcd8739ae039() {
    return $287c064682bce2ca$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $287c064682bce2ca$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("1PSi9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1564ab1a5ad324ee$export$2e2bcd8739ae039; });
function $1564ab1a5ad324ee$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $1564ab1a5ad324ee$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1564ab1a5ad324ee$export$2e2bcd8739ae039(o);
}

});

parcelRegister("is7Hx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6f0d0d335debf6a$export$2e2bcd8739ae039; });

var $3GOjU = parcelRequire("3GOjU");
function $d6f0d0d335debf6a$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $3GOjU.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $d6f0d0d335debf6a$export$2e2bcd8739ae039 = $d6f0d0d335debf6a$var$merge;

});


parcelRegister("g8IFw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc000afa1f5ff9f4$export$2e2bcd8739ae039; });
function $bc000afa1f5ff9f4$export$2e2bcd8739ae039(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("ejUtG", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $a6cea659158b0b01$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $a6cea659158b0b01$export$2e2bcd8739ae039; });

var $eTwGP = parcelRequire("eTwGP");
var $a6cea659158b0b01$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
var $a6cea659158b0b01$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $a6cea659158b0b01$var$formatMs(milliseconds) {
    return "".concat(Math.round(milliseconds), "ms");
}
var /**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */ $a6cea659158b0b01$export$2e2bcd8739ae039 = {
    easing: $a6cea659158b0b01$export$24c5ac7c37452e7d,
    duration: $a6cea659158b0b01$export$1f34108aa9eb96ab,
    create: function create() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            'all'
        ];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _options$duration = options.duration, durationOption = _options$duration === void 0 ? $a6cea659158b0b01$export$1f34108aa9eb96ab.standard : _options$duration, _options$easing = options.easing, easingOption = _options$easing === void 0 ? $a6cea659158b0b01$export$24c5ac7c37452e7d.easeInOut : _options$easing, _options$delay = options.delay, delay = _options$delay === void 0 ? 0 : _options$delay, other = (0, $eTwGP.default)(options, [
            "duration",
            "easing",
            "delay"
        ]);
        var isString, isNumber;
        return (Array.isArray(props) ? props : [
            props
        ]).map(function(animatedProp) {
            return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : $a6cea659158b0b01$var$formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : $a6cea659158b0b01$var$formatMs(delay));
        }).join(',');
    },
    getAutoHeightDuration: function getAutoHeightDuration(height) {
        if (!height) return 0;
        var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
        return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
    }
};

});

parcelRegister("7fkth", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5469d04d2af55543$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var $5469d04d2af55543$var$zIndex = {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $5469d04d2af55543$export$2e2bcd8739ae039 = $5469d04d2af55543$var$zIndex;

});




parcelRegister("2EBFt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1eec8946fbbc9b35$export$2e2bcd8739ae039; });

var $bPjvu = parcelRequire("bPjvu");
function $1eec8946fbbc9b35$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $bPjvu.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});




parcelRegister("kfphy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebd8d1ddbd644c98$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $ebd8d1ddbd644c98$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

});

parcelRegister("ajNLv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7832480bb8f83e56$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $7832480bb8f83e56$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckCircle');

});

parcelRegister("4leCF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32947752ec538b6c$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $32947752ec538b6c$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');

});

parcelRegister("l1pHr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4dda062cd61abe3$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $f4dda062cd61abe3$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

});

parcelRegister("1vmhz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1189f88404f847a2$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $1189f88404f847a2$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
}), 'Error');

});

parcelRegister("6BTs4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d01365cc68cfdb7$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $4d01365cc68cfdb7$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'ExitToApp');

});

parcelRegister("e1kqS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3510223f4636c99$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $a3510223f4636c99$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');

});

parcelRegister("etCDZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8a1c0099358f2f3$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $a8a1c0099358f2f3$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
}), 'FilterList');

});

parcelRegister("aXXRU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fbddab73a549c5e$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $7fbddab73a549c5e$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
}), 'Info');

});

parcelRegister("8DFBm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64a23c747b2c8401$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $64a23c747b2c8401$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'KeyboardArrowLeft');

});

parcelRegister("7nM46", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55fff722c34e5016$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $55fff722c34e5016$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'KeyboardArrowRight');

});

parcelRegister("k43Wb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03c50519d5488969$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $03c50519d5488969$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search');

});

parcelRegister("dwg6U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d7ac2be72483040$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $9d7ac2be72483040$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), 'Warning');

});

parcelRegister("ekezX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6de3e00fe5bf840$export$2e2bcd8739ae039; });

var $eTwGP = parcelRequire("eTwGP");

var $edxsd = parcelRequire("edxsd");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $aIJrd = parcelRequire("aIJrd");

var $86m3e = parcelRequire("86m3e");

var $51wR9 = parcelRequire("51wR9");

var $2EBFt = parcelRequire("2EBFt");
var $a6de3e00fe5bf840$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $edxsd.default)({}, theme.typography.button, {
            boxSizing: 'border-box',
            minWidth: 64,
            padding: '6px 16px',
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.text.primary,
            transition: theme.transitions.create([
                'background-color',
                'box-shadow',
                'border'
            ], {
                duration: theme.transitions.duration.short
            }),
            '&:hover': {
                textDecoration: 'none',
                backgroundColor: (0, $86m3e.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                },
                '&$disabled': {
                    backgroundColor: 'transparent'
                }
            },
            '&$disabled': {
                color: theme.palette.action.disabled
            }
        }),
        /* Styles applied to the span element that wraps the children. */ label: {
            width: '100%',
            // Ensure the correct width for iOS Safari
            display: 'inherit',
            alignItems: 'inherit',
            justifyContent: 'inherit'
        },
        /* Styles applied to the root element if `variant="text"`. */ text: {
            padding: '6px 8px'
        },
        /* Styles applied to the root element if `variant="text"` and `color="primary"`. */ textPrimary: {
            color: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: (0, $86m3e.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */ textSecondary: {
            color: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: (0, $86m3e.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            padding: '5px 15px',
            border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
            '&$disabled': {
                border: "1px solid ".concat(theme.palette.action.disabledBackground)
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */ outlinedPrimary: {
            color: theme.palette.primary.main,
            border: "1px solid ".concat((0, $86m3e.alpha)(theme.palette.primary.main, 0.5)),
            '&:hover': {
                border: "1px solid ".concat(theme.palette.primary.main),
                backgroundColor: (0, $86m3e.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */ outlinedSecondary: {
            color: theme.palette.secondary.main,
            border: "1px solid ".concat((0, $86m3e.alpha)(theme.palette.secondary.main, 0.5)),
            '&:hover': {
                border: "1px solid ".concat(theme.palette.secondary.main),
                backgroundColor: (0, $86m3e.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&$disabled': {
                border: "1px solid ".concat(theme.palette.action.disabled)
            }
        },
        /* Styles applied to the root element if `variant="contained"`. */ contained: {
            color: theme.palette.getContrastText(theme.palette.grey[300]),
            backgroundColor: theme.palette.grey[300],
            boxShadow: theme.shadows[2],
            '&:hover': {
                backgroundColor: theme.palette.grey.A100,
                boxShadow: theme.shadows[4],
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    boxShadow: theme.shadows[2],
                    backgroundColor: theme.palette.grey[300]
                },
                '&$disabled': {
                    backgroundColor: theme.palette.action.disabledBackground
                }
            },
            '&$focusVisible': {
                boxShadow: theme.shadows[6]
            },
            '&:active': {
                boxShadow: theme.shadows[8]
            },
            '&$disabled': {
                color: theme.palette.action.disabled,
                boxShadow: theme.shadows[0],
                backgroundColor: theme.palette.action.disabledBackground
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */ containedPrimary: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: theme.palette.primary.dark,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.palette.primary.main
                }
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */ containedSecondary: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: theme.palette.secondary.dark,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.palette.secondary.main
                }
            }
        },
        /* Styles applied to the root element if `disableElevation={true}`. */ disableElevation: {
            boxShadow: 'none',
            '&:hover': {
                boxShadow: 'none'
            },
            '&$focusVisible': {
                boxShadow: 'none'
            },
            '&:active': {
                boxShadow: 'none'
            },
            '&$disabled': {
                boxShadow: 'none'
            }
        },
        /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */ focusVisible: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: 'inherit',
            borderColor: 'currentColor'
        },
        /* Styles applied to the root element if `size="small"` and `variant="text"`. */ textSizeSmall: {
            padding: '4px 5px',
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="text"`. */ textSizeLarge: {
            padding: '8px 11px',
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */ outlinedSizeSmall: {
            padding: '3px 9px',
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */ outlinedSizeLarge: {
            padding: '7px 21px',
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="contained"`. */ containedSizeSmall: {
            padding: '4px 10px',
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="contained"`. */ containedSizeLarge: {
            padding: '8px 22px',
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {},
        /* Styles applied to the root element if `size="large"`. */ sizeLarge: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: '100%'
        },
        /* Styles applied to the startIcon element if supplied. */ startIcon: {
            display: 'inherit',
            marginRight: 8,
            marginLeft: -4,
            '&$iconSizeSmall': {
                marginLeft: -2
            }
        },
        /* Styles applied to the endIcon element if supplied. */ endIcon: {
            display: 'inherit',
            marginRight: -4,
            marginLeft: 8,
            '&$iconSizeSmall': {
                marginRight: -2
            }
        },
        /* Styles applied to the icon element if supplied and `size="small"`. */ iconSizeSmall: {
            '& > *:first-child': {
                fontSize: 18
            }
        },
        /* Styles applied to the icon element if supplied and `size="medium"`. */ iconSizeMedium: {
            '& > *:first-child': {
                fontSize: 20
            }
        },
        /* Styles applied to the icon element if supplied and `size="large"`. */ iconSizeLarge: {
            '& > *:first-child': {
                fontSize: 22
            }
        }
    };
};
var $a6de3e00fe5bf840$var$Button = /*#__PURE__*/ $ieT14.forwardRef(function Button(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'default' : _props$color, _props$component = props.component, component = _props$component === void 0 ? 'button' : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableElevati = props.disableElevation, disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, endIconProp = props.endIcon, focusVisibleClassName = props.focusVisibleClassName, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, startIconProp = props.startIcon, _props$type = props.type, type = _props$type === void 0 ? 'button' : _props$type, _props$variant = props.variant, variant = _props$variant === void 0 ? 'text' : _props$variant, other = (0, $eTwGP.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "disableElevation",
        "disableFocusRipple",
        "endIcon",
        "focusVisibleClassName",
        "fullWidth",
        "size",
        "startIcon",
        "type",
        "variant"
    ]);
    var startIcon = startIconProp && /*#__PURE__*/ $ieT14.createElement("span", {
        className: (0, $j6s32.default)(classes.startIcon, classes["iconSize".concat((0, $2EBFt.default)(size))])
    }, startIconProp);
    var endIcon = endIconProp && /*#__PURE__*/ $ieT14.createElement("span", {
        className: (0, $j6s32.default)(classes.endIcon, classes["iconSize".concat((0, $2EBFt.default)(size))])
    }, endIconProp);
    return /*#__PURE__*/ $ieT14.createElement((0, $51wR9.default), (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, classes[variant], className, color === 'inherit' ? classes.colorInherit : color !== 'default' && classes["".concat(variant).concat((0, $2EBFt.default)(color))], size !== 'medium' && [
            classes["".concat(variant, "Size").concat((0, $2EBFt.default)(size))],
            classes["size".concat((0, $2EBFt.default)(size))]
        ], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $j6s32.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other), /*#__PURE__*/ $ieT14.createElement("span", {
        className: classes.label
    }, startIcon, children, endIcon));
});
var $a6de3e00fe5bf840$export$2e2bcd8739ae039 = (0, $aIJrd.default)($a6de3e00fe5bf840$export$9dd6ff9ea0189349, {
    name: 'MuiButton'
})($a6de3e00fe5bf840$var$Button);

});
parcelRegister("51wR9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a868850f59eb209$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $3tOoB = parcelRequire("3tOoB");

var $j6s32 = parcelRequire("j6s32");


var $3A1Xf = parcelRequire("3A1Xf");

var $N8hF2 = parcelRequire("N8hF2");


var $aIJrd = parcelRequire("aIJrd");

var $6LYoZ = parcelRequire("6LYoZ");

var $8FAah = parcelRequire("8FAah");
var $3a868850f59eb209$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        WebkitTapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: 'pointer',
        userSelect: 'none',
        verticalAlign: 'middle',
        '-moz-appearance': 'none',
        // Reset
        '-webkit-appearance': 'none',
        // Reset
        textDecoration: 'none',
        // So we take precedent over the style of a native <a /> element.
        color: 'inherit',
        '&::-moz-focus-inner': {
            borderStyle: 'none' // Remove Firefox dotted outline.
        },
        '&$disabled': {
            pointerEvents: 'none',
            // Disable link interactions
            cursor: 'default'
        },
        '@media print': {
            colorAdjust: 'exact'
        }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
    /* Pseudo-class applied to the root element if keyboard focused. */ focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ var $3a868850f59eb209$var$ButtonBase = /*#__PURE__*/ $ieT14.forwardRef(function ButtonBase(props, ref) {
    var action = props.action, buttonRefProp = props.buttonRef, _props$centerRipple = props.centerRipple, centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple, children = props.children, classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? 'button' : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableRipple = props.disableRipple, disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple, _props$disableTouchRi = props.disableTouchRipple, disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi, _props$focusRipple = props.focusRipple, focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple, focusVisibleClassName = props.focusVisibleClassName, onBlur = props.onBlur, onClick = props.onClick, onFocus = props.onFocus, onFocusVisible = props.onFocusVisible, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, onMouseDown = props.onMouseDown, onMouseLeave = props.onMouseLeave, onMouseUp = props.onMouseUp, onTouchEnd = props.onTouchEnd, onTouchMove = props.onTouchMove, onTouchStart = props.onTouchStart, onDragLeave = props.onDragLeave, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, TouchRippleProps = props.TouchRippleProps, _props$type = props.type, type = _props$type === void 0 ? 'button' : _props$type, other = (0, $eTwGP.default)(props, [
        "action",
        "buttonRef",
        "centerRipple",
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "disableRipple",
        "disableTouchRipple",
        "focusRipple",
        "focusVisibleClassName",
        "onBlur",
        "onClick",
        "onFocus",
        "onFocusVisible",
        "onKeyDown",
        "onKeyUp",
        "onMouseDown",
        "onMouseLeave",
        "onMouseUp",
        "onTouchEnd",
        "onTouchMove",
        "onTouchStart",
        "onDragLeave",
        "tabIndex",
        "TouchRippleProps",
        "type"
    ]);
    var buttonRef = $ieT14.useRef(null);
    function getButtonNode() {
        // #StrictMode ready
        return $3tOoB.findDOMNode(buttonRef.current);
    }
    var rippleRef = $ieT14.useRef(null);
    var _React$useState = $ieT14.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
    if (disabled && focusVisible) setFocusVisible(false);
    var _useIsFocusVisible = (0, $6LYoZ.default)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    $ieT14.useImperativeHandle(action, function() {
        return {
            focusVisible: function focusVisible() {
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        };
    }, []);
    $ieT14.useEffect(function() {
        if (focusVisible && focusRipple && !disableRipple) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible
    ]);
    function useRippleHandler(rippleAction, eventCallback) {
        var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
        return (0, $N8hF2.default)(function(event) {
            if (eventCallback) eventCallback(event);
            var ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    var handleMouseDown = useRippleHandler('start', onMouseDown);
    var handleDragLeave = useRippleHandler('stop', onDragLeave);
    var handleMouseUp = useRippleHandler('stop', onMouseUp);
    var handleMouseLeave = useRippleHandler('stop', function(event) {
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    var handleTouchStart = useRippleHandler('start', onTouchStart);
    var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    var handleTouchMove = useRippleHandler('stop', onTouchMove);
    var handleBlur = useRippleHandler('stop', function(event) {
        if (focusVisible) {
            onBlurVisible(event);
            setFocusVisible(false);
        }
        if (onBlur) onBlur(event);
    }, false);
    var handleFocus = (0, $N8hF2.default)(function(event) {
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if (isFocusVisible(event)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    var isNonNativeButton = function isNonNativeButton() {
        var button = getButtonNode();
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ var keydownRef = $ieT14.useRef(false);
    var handleKeyDown = (0, $N8hF2.default)(function(event) {
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
         // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    var handleKeyUp = (0, $N8hF2.default)(function(event) {
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
         // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    var ComponentProp = component;
    if (ComponentProp === 'button' && other.href) ComponentProp = 'a';
    var buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type;
        buttonProps.disabled = disabled;
    } else {
        if (ComponentProp !== 'a' || !other.href) buttonProps.role = 'button';
        buttonProps['aria-disabled'] = disabled;
    }
    var handleUserRef = (0, $3A1Xf.default)(buttonRefProp, ref);
    var handleOwnRef = (0, $3A1Xf.default)(focusVisibleRef, buttonRef);
    var handleRef = (0, $3A1Xf.default)(handleUserRef, handleOwnRef);
    var _React$useState2 = $ieT14.useState(false), mountedState = _React$useState2[0], setMountedState = _React$useState2[1];
    $ieT14.useEffect(function() {
        setMountedState(true);
    }, []);
    var enableTouchRipple = mountedState && !disableRipple && !disabled;
    return /*#__PURE__*/ $ieT14.createElement(ComponentProp, (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className, focusVisible && [
            classes.focusVisible,
            focusVisibleClassName
        ], disabled && classes.disabled),
        onBlur: handleBlur,
        onClick: onClick,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex
    }, buttonProps, other), children, enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ $ieT14.createElement((0, $8FAah.default), (0, $edxsd.default)({
        ref: rippleRef,
        center: centerRipple
    }, TouchRippleProps)) : null);
});
var $3a868850f59eb209$export$2e2bcd8739ae039 = (0, $aIJrd.default)($3a868850f59eb209$export$9dd6ff9ea0189349, {
    name: 'MuiButtonBase'
})($3a868850f59eb209$var$ButtonBase);

});
parcelRegister("3tOoB", function(module, exports) {
'use strict';
function $288b2c13e1d6e616$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($288b2c13e1d6e616$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$288b2c13e1d6e616$var$checkDCE();

module.exports = (parcelRequire("8jKnw"));

});

parcelRegister("3A1Xf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29b6400531300358$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");

var $kC3Zv = parcelRequire("kC3Zv");
function $29b6400531300358$export$2e2bcd8739ae039(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */ return $ieT14.useMemo(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            (0, $kC3Zv.default)(refA, refValue);
            (0, $kC3Zv.default)(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}

});
parcelRegister("kC3Zv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f01a73d15a8c618a$export$2e2bcd8739ae039; });
// TODO v5: consider to make it private
function $f01a73d15a8c618a$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}

});


parcelRegister("N8hF2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $093b00b81407dee0$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");
var $093b00b81407dee0$var$useEnhancedEffect = typeof window !== 'undefined' ? $ieT14.useLayoutEffect : $ieT14.useEffect;
function $093b00b81407dee0$export$2e2bcd8739ae039(fn) {
    var ref = $ieT14.useRef(fn);
    $093b00b81407dee0$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return $ieT14.useCallback(function() {
        return (0, ref.current).apply(void 0, arguments);
    }, []);
}

});

parcelRegister("6LYoZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ee5fc71424aacc2$export$2e2bcd8739ae039; });
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

var $ieT14 = parcelRequire("ieT14");

var $3tOoB = parcelRequire("3tOoB");
var $4ee5fc71424aacc2$var$hadKeyboardEvent = true;
var $4ee5fc71424aacc2$var$hadFocusVisibleRecently = false;
var $4ee5fc71424aacc2$var$hadFocusVisibleRecentlyTimeout = null;
var $4ee5fc71424aacc2$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */ function $4ee5fc71424aacc2$var$focusTriggersKeyboardModality(node) {
    var type = node.type, tagName = node.tagName;
    if (tagName === 'INPUT' && $4ee5fc71424aacc2$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $4ee5fc71424aacc2$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $4ee5fc71424aacc2$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $4ee5fc71424aacc2$var$handlePointerDown() {
    $4ee5fc71424aacc2$var$hadKeyboardEvent = false;
}
function $4ee5fc71424aacc2$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($4ee5fc71424aacc2$var$hadFocusVisibleRecently) $4ee5fc71424aacc2$var$hadKeyboardEvent = true;
    }
}
function $4ee5fc71424aacc2$var$prepare(doc) {
    doc.addEventListener('keydown', $4ee5fc71424aacc2$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $4ee5fc71424aacc2$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $4ee5fc71424aacc2$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $4ee5fc71424aacc2$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $4ee5fc71424aacc2$var$handleVisibilityChange, true);
}
function $4ee5fc71424aacc2$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $4ee5fc71424aacc2$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $4ee5fc71424aacc2$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $4ee5fc71424aacc2$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $4ee5fc71424aacc2$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $4ee5fc71424aacc2$var$handleVisibilityChange, true);
}
function $4ee5fc71424aacc2$var$isFocusVisible(event) {
    var target = event.target;
    try {
        return target.matches(':focus-visible');
    } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
    // we use our own heuristic for those browsers
    // rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    // no need for validFocusTarget check. the user does that by attaching it to
    // focusable events only
    return $4ee5fc71424aacc2$var$hadKeyboardEvent || $4ee5fc71424aacc2$var$focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */ function $4ee5fc71424aacc2$var$handleBlurVisible() {
    // To detect a tab/window switch, we look for a blur event followed
    // rapidly by a visibility change.
    // If we don't see a visibility change within 100ms, it's probably a
    // regular focus change.
    $4ee5fc71424aacc2$var$hadFocusVisibleRecently = true;
    window.clearTimeout($4ee5fc71424aacc2$var$hadFocusVisibleRecentlyTimeout);
    $4ee5fc71424aacc2$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
        $4ee5fc71424aacc2$var$hadFocusVisibleRecently = false;
    }, 100);
}
function $4ee5fc71424aacc2$export$2e2bcd8739ae039() {
    var ref = $ieT14.useCallback(function(instance) {
        var node = $3tOoB.findDOMNode(instance);
        if (node != null) $4ee5fc71424aacc2$var$prepare(node.ownerDocument);
    }, []);
    return {
        isFocusVisible: $4ee5fc71424aacc2$var$isFocusVisible,
        onBlurVisible: $4ee5fc71424aacc2$var$handleBlurVisible,
        ref: ref
    };
}

});

parcelRegister("8FAah", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64fe34a0d235a9e6$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $83KOU = parcelRequire("83KOU");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $5IIYw = parcelRequire("5IIYw");

var $j6s32 = parcelRequire("j6s32");

var $aIJrd = parcelRequire("aIJrd");

var $cQqSw = parcelRequire("cQqSw");
var $64fe34a0d235a9e6$var$DURATION = 550;
var $64fe34a0d235a9e6$export$95d0c9356b2231a3 = 80;
var $64fe34a0d235a9e6$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            overflow: 'hidden',
            pointerEvents: 'none',
            position: 'absolute',
            zIndex: 0,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            borderRadius: 'inherit'
        },
        /* Styles applied to the internal `Ripple` components `ripple` class. */ ripple: {
            opacity: 0,
            position: 'absolute'
        },
        /* Styles applied to the internal `Ripple` components `rippleVisible` class. */ rippleVisible: {
            opacity: 0.3,
            transform: 'scale(1)',
            animation: "$enter ".concat($64fe34a0d235a9e6$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */ ripplePulsate: {
            animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
        },
        /* Styles applied to the internal `Ripple` components `child` class. */ child: {
            opacity: 1,
            display: 'block',
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            backgroundColor: 'currentColor'
        },
        /* Styles applied to the internal `Ripple` components `childLeaving` class. */ childLeaving: {
            opacity: 0,
            animation: "$exit ".concat($64fe34a0d235a9e6$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `childPulsate` class. */ childPulsate: {
            position: 'absolute',
            left: 0,
            top: 0,
            animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
        },
        '@keyframes enter': {
            '0%': {
                transform: 'scale(0)',
                opacity: 0.1
            },
            '100%': {
                transform: 'scale(1)',
                opacity: 0.3
            }
        },
        '@keyframes exit': {
            '0%': {
                opacity: 1
            },
            '100%': {
                opacity: 0
            }
        },
        '@keyframes pulsate': {
            '0%': {
                transform: 'scale(1)'
            },
            '50%': {
                transform: 'scale(0.92)'
            },
            '100%': {
                transform: 'scale(1)'
            }
        }
    };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ var $64fe34a0d235a9e6$var$TouchRipple = /*#__PURE__*/ $ieT14.forwardRef(function TouchRipple(props, ref) {
    var _props$center = props.center, centerProp = _props$center === void 0 ? false : _props$center, classes = props.classes, className = props.className, other = (0, $eTwGP.default)(props, [
        "center",
        "classes",
        "className"
    ]);
    var _React$useState = $ieT14.useState([]), ripples = _React$useState[0], setRipples = _React$useState[1];
    var nextKey = $ieT14.useRef(0);
    var rippleCallback = $ieT14.useRef(null);
    $ieT14.useEffect(function() {
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]); // Used to filter out mouse emulated events on mobile.
    var ignoringMouseDown = $ieT14.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    var startTimer = $ieT14.useRef(null); // This is the hook called once the previous timeout is ready.
    var startTimerCommit = $ieT14.useRef(null);
    var container = $ieT14.useRef(null);
    $ieT14.useEffect(function() {
        return function() {
            clearTimeout(startTimer.current);
        };
    }, []);
    var startCommit = $ieT14.useCallback(function(params) {
        var pulsate = params.pulsate, rippleX = params.rippleX, rippleY = params.rippleY, rippleSize = params.rippleSize, cb = params.cb;
        setRipples(function(oldRipples) {
            return [].concat((0, $83KOU.default)(oldRipples), [
                /*#__PURE__*/ $ieT14.createElement((0, $cQqSw.default), {
                    key: nextKey.current,
                    classes: classes,
                    timeout: $64fe34a0d235a9e6$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                })
            ]);
        });
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    var start = $ieT14.useCallback(function() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var cb = arguments.length > 2 ? arguments[2] : undefined;
        var _options$pulsate = options.pulsate, pulsate = _options$pulsate === void 0 ? false : _options$pulsate, _options$center = options.center, center = _options$center === void 0 ? centerProp || options.pulsate : _options$center, _options$fakeElement = options.fakeElement, fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
        if (event.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event.type === 'touchstart') ignoringMouseDown.current = true;
        var element = fakeElement ? null : container.current;
        var rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        }; // Get the size of the ripple
        var rippleX;
        var rippleY;
        var rippleSize;
        if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            var _ref = event.touches ? event.touches[0] : event, clientX = _ref.clientX, clientY = _ref.clientY;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
        } // Touche devices
        if (event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = function() {
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                }; // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(function() {
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $64fe34a0d235a9e6$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    var pulsate = $ieT14.useCallback(function() {
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    var stop = $ieT14.useCallback(function(event, cb) {
        clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event.type === 'touchend' && startTimerCommit.current) {
            event.persist();
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(function() {
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples(function(oldRipples) {
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $ieT14.useImperativeHandle(ref, function() {
        return {
            pulsate: pulsate,
            start: start,
            stop: stop
        };
    }, [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ $ieT14.createElement("span", (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className),
        ref: container
    }, other), /*#__PURE__*/ $ieT14.createElement((0, $5IIYw.default), {
        component: null,
        exit: true
    }, ripples));
});
var $64fe34a0d235a9e6$export$2e2bcd8739ae039 = (0, $aIJrd.default)($64fe34a0d235a9e6$export$9dd6ff9ea0189349, {
    flip: false,
    name: 'MuiTouchRipple'
})(/*#__PURE__*/ $ieT14.memo($64fe34a0d235a9e6$var$TouchRipple));

});
parcelRegister("83KOU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5de2ec0a7d98fcdd$export$2e2bcd8739ae039; });

var $3jIx9 = parcelRequire("3jIx9");

var $5jWgG = parcelRequire("5jWgG");

var $3aDwg = parcelRequire("3aDwg");

var $Q6NMt = parcelRequire("Q6NMt");
function $5de2ec0a7d98fcdd$export$2e2bcd8739ae039(r) {
    return (0, $3jIx9.default)(r) || (0, $5jWgG.default)(r) || (0, $3aDwg.default)(r) || (0, $Q6NMt.default)();
}

});
parcelRegister("3jIx9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26a5b0e7c87e85a0$export$2e2bcd8739ae039; });

var $XOnMa = parcelRequire("XOnMa");
function $26a5b0e7c87e85a0$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $XOnMa.default)(r);
}

});
parcelRegister("XOnMa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b3c97b6ee3f8e7d$export$2e2bcd8739ae039; });
function $0b3c97b6ee3f8e7d$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("5jWgG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3dfbeceed9f66824$export$2e2bcd8739ae039; });
function $3dfbeceed9f66824$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("3aDwg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24f0f5fce9dcc9d6$export$2e2bcd8739ae039; });

var $XOnMa = parcelRequire("XOnMa");
function $24f0f5fce9dcc9d6$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $XOnMa.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $XOnMa.default)(r, a) : void 0;
    }
}

});

parcelRegister("Q6NMt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09ca2229a11abe83$export$2e2bcd8739ae039; });
function $09ca2229a11abe83$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("5IIYw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42a3f2f512b6903a$export$2e2bcd8739ae039; });

var $9YxmX = parcelRequire("9YxmX");

var $fMZXI = parcelRequire("fMZXI");

var $01J4r = parcelRequire("01J4r");

var $hsveB = parcelRequire("hsveB");


var $ieT14 = parcelRequire("ieT14");

var $hJXl0 = parcelRequire("hJXl0");

var $ccH61 = parcelRequire("ccH61");
var $42a3f2f512b6903a$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $42a3f2f512b6903a$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $42a3f2f512b6903a$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $hsveB.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $01J4r.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $ccH61.getInitialChildMapping)(nextProps, handleExited) : (0, $ccH61.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $ccH61.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $fMZXI.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $9YxmX.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $42a3f2f512b6903a$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement((0, $hJXl0.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement((0, $hJXl0.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).Component);
$42a3f2f512b6903a$var$TransitionGroup.propTypes = {};
$42a3f2f512b6903a$var$TransitionGroup.defaultProps = $42a3f2f512b6903a$var$defaultProps;
var $42a3f2f512b6903a$export$2e2bcd8739ae039 = $42a3f2f512b6903a$var$TransitionGroup;

});
parcelRegister("9YxmX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74339a185ae6402d$export$2e2bcd8739ae039; });
function $74339a185ae6402d$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("fMZXI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7eb671e3ed3acfb$export$2e2bcd8739ae039; });
function $b7eb671e3ed3acfb$export$2e2bcd8739ae039() {
    return $b7eb671e3ed3acfb$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b7eb671e3ed3acfb$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("01J4r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00530e31125d5d76$export$2e2bcd8739ae039; });
function $00530e31125d5d76$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("hsveB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb5d47b34bf7ff52$export$2e2bcd8739ae039; });

var $fIpo6 = parcelRequire("fIpo6");
function $cb5d47b34bf7ff52$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $fIpo6.default)(t, o);
}

});
parcelRegister("fIpo6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b70ea88d569085bb$export$2e2bcd8739ae039; });
function $b70ea88d569085bb$export$2e2bcd8739ae039(t, e) {
    return $b70ea88d569085bb$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $b70ea88d569085bb$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("hJXl0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cea4aae6fcf934c0$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");
var $cea4aae6fcf934c0$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createContext(null);

});

parcelRegister("ccH61", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $8e28090426b2fcdf$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $8e28090426b2fcdf$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $8e28090426b2fcdf$export$36fd1af28d383ec0; });

var $ieT14 = parcelRequire("ieT14");
function $8e28090426b2fcdf$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $ieT14.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $ieT14.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $8e28090426b2fcdf$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $8e28090426b2fcdf$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $8e28090426b2fcdf$export$fa71e2345c31d7a2(props, onExited) {
    return $8e28090426b2fcdf$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $ieT14.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $8e28090426b2fcdf$var$getProp(child, 'appear', props),
            enter: $8e28090426b2fcdf$var$getProp(child, 'enter', props),
            exit: $8e28090426b2fcdf$var$getProp(child, 'exit', props)
        });
    });
}
function $8e28090426b2fcdf$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $8e28090426b2fcdf$export$bbc8a025727ea824(nextProps.children);
    var children = $8e28090426b2fcdf$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $ieT14.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $ieT14.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $ieT14.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $8e28090426b2fcdf$var$getProp(child, 'exit', nextProps),
            enter: $8e28090426b2fcdf$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $ieT14.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $ieT14.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $ieT14.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $8e28090426b2fcdf$var$getProp(child, 'exit', nextProps),
            enter: $8e28090426b2fcdf$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

});


parcelRegister("cQqSw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $959f30da767b8e95$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $N8hF2 = parcelRequire("N8hF2");
var $959f30da767b8e95$var$useEnhancedEffect = typeof window === 'undefined' ? $ieT14.useEffect : $ieT14.useLayoutEffect;
/**
 * @ignore - internal component.
 */ function $959f30da767b8e95$var$Ripple(props) {
    var classes = props.classes, _props$pulsate = props.pulsate, pulsate = _props$pulsate === void 0 ? false : _props$pulsate, rippleX = props.rippleX, rippleY = props.rippleY, rippleSize = props.rippleSize, inProp = props.in, _props$onExited = props.onExited, onExited = _props$onExited === void 0 ? function() {} : _props$onExited, timeout = props.timeout;
    var _React$useState = $ieT14.useState(false), leaving = _React$useState[0], setLeaving = _React$useState[1];
    var rippleClassName = (0, $j6s32.default)(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    var childClassName = (0, $j6s32.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    var handleExited = (0, $N8hF2.default)(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority
    $959f30da767b8e95$var$useEnhancedEffect(function() {
        if (!inProp) {
            // react-transition-group#onExit
            setLeaving(true); // react-transition-group#onExited
            var timeoutId = setTimeout(handleExited, timeout);
            return function() {
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        handleExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ $ieT14.createElement("span", {
        className: rippleClassName,
        style: rippleStyles
    }, /*#__PURE__*/ $ieT14.createElement("span", {
        className: childClassName
    }));
}
var $959f30da767b8e95$export$2e2bcd8739ae039 = $959f30da767b8e95$var$Ripple;

});




parcelRegister("f7wB2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b020cb6def2dd735$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $hthAT = parcelRequire("hthAT");

var $aIJrd = parcelRequire("aIJrd");

var $86m3e = parcelRequire("86m3e");

var $3A1Xf = parcelRequire("3A1Xf");


var $2EBFt = parcelRequire("2EBFt");

var $51wR9 = parcelRequire("51wR9");
var $b020cb6def2dd735$export$9dd6ff9ea0189349 = function styles(theme) {
    var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
    var deleteIconColor = (0, $86m3e.alpha)(theme.palette.text.primary, 0.26);
    return {
        /* Styles applied to the root element. */ root: {
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(13),
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: 32,
            color: theme.palette.getContrastText(backgroundColor),
            backgroundColor: backgroundColor,
            borderRadius: 16,
            whiteSpace: 'nowrap',
            transition: theme.transitions.create([
                'background-color',
                'box-shadow'
            ]),
            // label will inherit this from root, then `clickable` class overrides this for both
            cursor: 'default',
            // We disable the focus ring for mouse, touch and keyboard users.
            outline: 0,
            textDecoration: 'none',
            border: 'none',
            // Remove `button` border
            padding: 0,
            // Remove `button` padding
            verticalAlign: 'middle',
            boxSizing: 'border-box',
            '&$disabled': {
                opacity: 0.5,
                pointerEvents: 'none'
            },
            '& $avatar': {
                marginLeft: 5,
                marginRight: -6,
                width: 24,
                height: 24,
                color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
                fontSize: theme.typography.pxToRem(12)
            },
            '& $avatarColorPrimary': {
                color: theme.palette.primary.contrastText,
                backgroundColor: theme.palette.primary.dark
            },
            '& $avatarColorSecondary': {
                color: theme.palette.secondary.contrastText,
                backgroundColor: theme.palette.secondary.dark
            },
            '& $avatarSmall': {
                marginLeft: 4,
                marginRight: -4,
                width: 18,
                height: 18,
                fontSize: theme.typography.pxToRem(10)
            }
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            height: 24
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `onClick` is defined or `clickable={true}`. */ clickable: {
            userSelect: 'none',
            WebkitTapHighlightColor: 'transparent',
            cursor: 'pointer',
            '&:hover, &:focus': {
                backgroundColor: (0, $86m3e.emphasize)(backgroundColor, 0.08)
            },
            '&:active': {
                boxShadow: theme.shadows[1]
            }
        },
        /* Styles applied to the root element if `onClick` and `color="primary"` is defined or `clickable={true}`. */ clickableColorPrimary: {
            '&:hover, &:focus': {
                backgroundColor: (0, $86m3e.emphasize)(theme.palette.primary.main, 0.08)
            }
        },
        /* Styles applied to the root element if `onClick` and `color="secondary"` is defined or `clickable={true}`. */ clickableColorSecondary: {
            '&:hover, &:focus': {
                backgroundColor: (0, $86m3e.emphasize)(theme.palette.secondary.main, 0.08)
            }
        },
        /* Styles applied to the root element if `onDelete` is defined. */ deletable: {
            '&:focus': {
                backgroundColor: (0, $86m3e.emphasize)(backgroundColor, 0.08)
            }
        },
        /* Styles applied to the root element if `onDelete` and `color="primary"` is defined. */ deletableColorPrimary: {
            '&:focus': {
                backgroundColor: (0, $86m3e.emphasize)(theme.palette.primary.main, 0.2)
            }
        },
        /* Styles applied to the root element if `onDelete` and `color="secondary"` is defined. */ deletableColorSecondary: {
            '&:focus': {
                backgroundColor: (0, $86m3e.emphasize)(theme.palette.secondary.main, 0.2)
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            backgroundColor: 'transparent',
            border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
            '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
                backgroundColor: (0, $86m3e.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
            },
            '& $avatar': {
                marginLeft: 4
            },
            '& $avatarSmall': {
                marginLeft: 2
            },
            '& $icon': {
                marginLeft: 4
            },
            '& $iconSmall': {
                marginLeft: 2
            },
            '& $deleteIcon': {
                marginRight: 5
            },
            '& $deleteIconSmall': {
                marginRight: 3
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */ outlinedPrimary: {
            color: theme.palette.primary.main,
            border: "1px solid ".concat(theme.palette.primary.main),
            '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
                backgroundColor: (0, $86m3e.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */ outlinedSecondary: {
            color: theme.palette.secondary.main,
            border: "1px solid ".concat(theme.palette.secondary.main),
            '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
                backgroundColor: (0, $86m3e.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
            }
        },
        // TODO v5: remove
        /* Styles applied to the `avatar` element. */ avatar: {},
        /* Styles applied to the `avatar` element if `size="small"`. */ avatarSmall: {},
        /* Styles applied to the `avatar` element if `color="primary"`. */ avatarColorPrimary: {},
        /* Styles applied to the `avatar` element if `color="secondary"`. */ avatarColorSecondary: {},
        /* Styles applied to the `icon` element. */ icon: {
            color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
            marginLeft: 5,
            marginRight: -6
        },
        /* Styles applied to the `icon` element if `size="small"`. */ iconSmall: {
            width: 18,
            height: 18,
            marginLeft: 4,
            marginRight: -4
        },
        /* Styles applied to the `icon` element if `color="primary"`. */ iconColorPrimary: {
            color: 'inherit'
        },
        /* Styles applied to the `icon` element if `color="secondary"`. */ iconColorSecondary: {
            color: 'inherit'
        },
        /* Styles applied to the label `span` element. */ label: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            paddingLeft: 12,
            paddingRight: 12,
            whiteSpace: 'nowrap'
        },
        /* Styles applied to the label `span` element if `size="small"`. */ labelSmall: {
            paddingLeft: 8,
            paddingRight: 8
        },
        /* Styles applied to the `deleteIcon` element. */ deleteIcon: {
            WebkitTapHighlightColor: 'transparent',
            color: deleteIconColor,
            height: 22,
            width: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: (0, $86m3e.alpha)(deleteIconColor, 0.4)
            }
        },
        /* Styles applied to the `deleteIcon` element if `size="small"`. */ deleteIconSmall: {
            height: 16,
            width: 16,
            marginRight: 4,
            marginLeft: -4
        },
        /* Styles applied to the deleteIcon element if `color="primary"` and `variant="default"`. */ deleteIconColorPrimary: {
            color: (0, $86m3e.alpha)(theme.palette.primary.contrastText, 0.7),
            '&:hover, &:active': {
                color: theme.palette.primary.contrastText
            }
        },
        /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="default"`. */ deleteIconColorSecondary: {
            color: (0, $86m3e.alpha)(theme.palette.secondary.contrastText, 0.7),
            '&:hover, &:active': {
                color: theme.palette.secondary.contrastText
            }
        },
        /* Styles applied to the deleteIcon element if `color="primary"` and `variant="outlined"`. */ deleteIconOutlinedColorPrimary: {
            color: (0, $86m3e.alpha)(theme.palette.primary.main, 0.7),
            '&:hover, &:active': {
                color: theme.palette.primary.main
            }
        },
        /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="outlined"`. */ deleteIconOutlinedColorSecondary: {
            color: (0, $86m3e.alpha)(theme.palette.secondary.main, 0.7),
            '&:hover, &:active': {
                color: theme.palette.secondary.main
            }
        }
    };
};
function $b020cb6def2dd735$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ var $b020cb6def2dd735$var$Chip = /*#__PURE__*/ $ieT14.forwardRef(function Chip(props, ref) {
    var avatarProp = props.avatar, classes = props.classes, className = props.className, clickableProp = props.clickable, _props$color = props.color, color = _props$color === void 0 ? 'default' : _props$color, ComponentProp = props.component, deleteIconProp = props.deleteIcon, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, iconProp = props.icon, label = props.label, onClick = props.onClick, onDelete = props.onDelete, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, _props$variant = props.variant, variant = _props$variant === void 0 ? 'default' : _props$variant, other = (0, $eTwGP.default)(props, [
        "avatar",
        "classes",
        "className",
        "clickable",
        "color",
        "component",
        "deleteIcon",
        "disabled",
        "icon",
        "label",
        "onClick",
        "onDelete",
        "onKeyDown",
        "onKeyUp",
        "size",
        "variant"
    ]);
    var chipRef = $ieT14.useRef(null);
    var handleRef = (0, $3A1Xf.default)(chipRef, ref);
    var handleDeleteIconClick = function handleDeleteIconClick(event) {
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    var handleKeyDown = function handleKeyDown(event) {
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $b020cb6def2dd735$var$isDeleteKeyboardEvent(event)) // will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    var handleKeyUp = function handleKeyUp(event) {
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $b020cb6def2dd735$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === 'Escape' && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    var clickable = clickableProp !== false && onClick ? true : clickableProp;
    var small = size === 'small';
    var Component = ComponentProp || (clickable ? (0, $51wR9.default) : 'div');
    var moreProps = Component === (0, $51wR9.default) ? {
        component: 'div'
    } : {};
    var deleteIcon = null;
    if (onDelete) {
        var customClasses = (0, $j6s32.default)(color !== 'default' && (variant === "default" ? classes["deleteIconColor".concat((0, $2EBFt.default)(color))] : classes["deleteIconOutlinedColor".concat((0, $2EBFt.default)(color))]), small && classes.deleteIconSmall);
        deleteIcon = deleteIconProp && /*#__PURE__*/ $ieT14.isValidElement(deleteIconProp) ? /*#__PURE__*/ $ieT14.cloneElement(deleteIconProp, {
            className: (0, $j6s32.default)(deleteIconProp.props.className, classes.deleteIcon, customClasses),
            onClick: handleDeleteIconClick
        }) : /*#__PURE__*/ $ieT14.createElement((0, $hthAT.default), {
            className: (0, $j6s32.default)(classes.deleteIcon, customClasses),
            onClick: handleDeleteIconClick
        });
    }
    var avatar = null;
    if (avatarProp && /*#__PURE__*/ $ieT14.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $ieT14.cloneElement(avatarProp, {
        className: (0, $j6s32.default)(classes.avatar, avatarProp.props.className, small && classes.avatarSmall, color !== 'default' && classes["avatarColor".concat((0, $2EBFt.default)(color))])
    });
    var icon = null;
    if (iconProp && /*#__PURE__*/ $ieT14.isValidElement(iconProp)) icon = /*#__PURE__*/ $ieT14.cloneElement(iconProp, {
        className: (0, $j6s32.default)(classes.icon, iconProp.props.className, small && classes.iconSmall, color !== 'default' && classes["iconColor".concat((0, $2EBFt.default)(color))])
    });
    return /*#__PURE__*/ $ieT14.createElement(Component, (0, $edxsd.default)({
        role: clickable || onDelete ? 'button' : undefined,
        className: (0, $j6s32.default)(classes.root, className, color !== 'default' && [
            classes["color".concat((0, $2EBFt.default)(color))],
            clickable && classes["clickableColor".concat((0, $2EBFt.default)(color))],
            onDelete && classes["deletableColor".concat((0, $2EBFt.default)(color))]
        ], variant !== "default" && [
            classes.outlined,
            {
                'primary': classes.outlinedPrimary,
                'secondary': classes.outlinedSecondary
            }[color]
        ], disabled && classes.disabled, small && classes.sizeSmall, clickable && classes.clickable, onDelete && classes.deletable),
        "aria-disabled": disabled ? true : undefined,
        tabIndex: clickable || onDelete ? 0 : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef
    }, moreProps, other), avatar || icon, /*#__PURE__*/ $ieT14.createElement("span", {
        className: (0, $j6s32.default)(classes.label, small && classes.labelSmall)
    }, label), deleteIcon);
});
var $b020cb6def2dd735$export$2e2bcd8739ae039 = (0, $aIJrd.default)($b020cb6def2dd735$export$9dd6ff9ea0189349, {
    name: 'MuiChip'
})($b020cb6def2dd735$var$Chip);

});
parcelRegister("hthAT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb82cae3b4c96c56$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var /**
 * @ignore - internal component.
 */ $cb82cae3b4c96c56$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');

});


parcelRegister("fpdl2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b373898ad8dbe087$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");


var $aIJrd = parcelRequire("aIJrd");

var $2EBFt = parcelRequire("2EBFt");
var $b373898ad8dbe087$var$SIZE = 44;
var $b373898ad8dbe087$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'inline-block'
        },
        /* Styles applied to the root element if `variant="static"`. */ static: {
            transition: theme.transitions.create('transform')
        },
        /* Styles applied to the root element if `variant="indeterminate"`. */ indeterminate: {
            animation: '$circular-rotate 1.4s linear infinite'
        },
        /* Styles applied to the root element if `variant="determinate"`. */ determinate: {
            transition: theme.transitions.create('transform')
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the `svg` element. */ svg: {
            display: 'block' // Keeps the progress centered
        },
        /* Styles applied to the `circle` svg path. */ circle: {
            stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
        },
        /* Styles applied to the `circle` svg path if `variant="static"`. */ circleStatic: {
            transition: theme.transitions.create('stroke-dashoffset')
        },
        /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */ circleIndeterminate: {
            animation: '$circular-dash 1.4s ease-in-out infinite',
            // Some default value that looks fine waiting for the animation to kicks in.
            strokeDasharray: '80px, 200px',
            strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.
        },
        /* Styles applied to the `circle` svg path if `variant="determinate"`. */ circleDeterminate: {
            transition: theme.transitions.create('stroke-dashoffset')
        },
        '@keyframes circular-rotate': {
            '0%': {
                // Fix IE 11 wobbly
                transformOrigin: '50% 50%'
            },
            '100%': {
                transform: 'rotate(360deg)'
            }
        },
        '@keyframes circular-dash': {
            '0%': {
                strokeDasharray: '1px, 200px',
                strokeDashoffset: '0px'
            },
            '50%': {
                strokeDasharray: '100px, 200px',
                strokeDashoffset: '-15px'
            },
            '100%': {
                strokeDasharray: '100px, 200px',
                strokeDashoffset: '-125px'
            }
        },
        /* Styles applied to the `circle` svg path if `disableShrink={true}`. */ circleDisableShrink: {
            animation: 'none'
        }
    };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ var $b373898ad8dbe087$var$CircularProgress = /*#__PURE__*/ $ieT14.forwardRef(function CircularProgress(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, _props$disableShrink = props.disableShrink, disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink, _props$size = props.size, size = _props$size === void 0 ? 40 : _props$size, style = props.style, _props$thickness = props.thickness, thickness = _props$thickness === void 0 ? 3.6 : _props$thickness, _props$value = props.value, value = _props$value === void 0 ? 0 : _props$value, _props$variant = props.variant, variant = _props$variant === void 0 ? 'indeterminate' : _props$variant, other = (0, $eTwGP.default)(props, [
        "classes",
        "className",
        "color",
        "disableShrink",
        "size",
        "style",
        "thickness",
        "value",
        "variant"
    ]);
    var circleStyle = {};
    var rootStyle = {};
    var rootProps = {};
    if (variant === 'determinate' || variant === 'static') {
        var circumference = 2 * Math.PI * (($b373898ad8dbe087$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ $ieT14.createElement("div", (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className, color !== 'inherit' && classes["color".concat((0, $2EBFt.default)(color))], {
            'determinate': classes.determinate,
            'indeterminate': classes.indeterminate,
            'static': classes.static
        }[variant]),
        style: (0, $edxsd.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ref: ref,
        role: "progressbar"
    }, rootProps, other), /*#__PURE__*/ $ieT14.createElement("svg", {
        className: classes.svg,
        viewBox: "".concat($b373898ad8dbe087$var$SIZE / 2, " ").concat($b373898ad8dbe087$var$SIZE / 2, " ").concat($b373898ad8dbe087$var$SIZE, " ").concat($b373898ad8dbe087$var$SIZE)
    }, /*#__PURE__*/ $ieT14.createElement("circle", {
        className: (0, $j6s32.default)(classes.circle, disableShrink && classes.circleDisableShrink, {
            'determinate': classes.circleDeterminate,
            'indeterminate': classes.circleIndeterminate,
            'static': classes.circleStatic
        }[variant]),
        style: circleStyle,
        cx: $b373898ad8dbe087$var$SIZE,
        cy: $b373898ad8dbe087$var$SIZE,
        r: ($b373898ad8dbe087$var$SIZE - thickness) / 2,
        fill: "none",
        strokeWidth: thickness
    })));
});
var $b373898ad8dbe087$export$2e2bcd8739ae039 = (0, $aIJrd.default)($b373898ad8dbe087$export$9dd6ff9ea0189349, {
    name: 'MuiCircularProgress',
    flip: false
})($b373898ad8dbe087$var$CircularProgress);

});

parcelRegister("kRJN7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f30c471769bf7b3e$export$2e2bcd8739ae039; });

var $1eBoX = parcelRequire("1eBoX");
function $f30c471769bf7b3e$export$2e2bcd8739ae039(styles) {
    // warning(
    //   warnOnce,
    //   [
    //     'Material-UI: createStyles from @material-ui/core/styles is deprecated.',
    //     'Please use @material-ui/styles/createStyles',
    //   ].join('\n'),
    // );
    // warnOnce = true;
    return (0, $1eBoX.default)(styles);
}

});
parcelRegister("1eBoX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e641c64e214e7da$export$2e2bcd8739ae039; });
function $0e641c64e214e7da$export$2e2bcd8739ae039(styles) {
    return styles;
}

});


parcelRegister("whS22", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0610d9faa61729a5$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $033Qn = parcelRequire("033Qn");

var $aIJrd = parcelRequire("aIJrd");

var $2EBFt = parcelRequire("2EBFt");

var $gX17d = parcelRequire("gX17d");

var $bJmSx = parcelRequire("bJmSx");
var $0610d9faa61729a5$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'inline-flex',
        flexDirection: 'column',
        position: 'relative',
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: 'top' // Fix alignment issue on Safari.
    },
    /* Styles applied to the root element if `margin="normal"`. */ marginNormal: {
        marginTop: 16,
        marginBottom: 8
    },
    /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
        marginTop: 8,
        marginBottom: 4
    },
    /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
        width: '100%'
    }
};
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️Only one input can be used within a FormControl.
 */ var $0610d9faa61729a5$var$FormControl = /*#__PURE__*/ $ieT14.forwardRef(function FormControl(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, visuallyFocused = props.focused, _props$hiddenLabel = props.hiddenLabel, hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel, _props$margin = props.margin, margin = _props$margin === void 0 ? 'none' : _props$margin, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, size = props.size, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $eTwGP.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "error",
        "fullWidth",
        "focused",
        "hiddenLabel",
        "margin",
        "required",
        "size",
        "variant"
    ]);
    var _React$useState = $ieT14.useState(function() {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialAdornedStart = false;
        if (children) $ieT14.Children.forEach(children, function(child) {
            if (!(0, $gX17d.default)(child, [
                'Input',
                'Select'
            ])) return;
            var input = (0, $gX17d.default)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $033Qn.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    }), adornedStart = _React$useState[0], setAdornedStart = _React$useState[1];
    var _React$useState2 = $ieT14.useState(function() {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialFilled = false;
        if (children) $ieT14.Children.forEach(children, function(child) {
            if (!(0, $gX17d.default)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $033Qn.isFilled)(child.props, true)) initialFilled = true;
        });
        return initialFilled;
    }), filled = _React$useState2[0], setFilled = _React$useState2[1];
    var _React$useState3 = $ieT14.useState(false), _focused = _React$useState3[0], setFocused = _React$useState3[1];
    var focused = visuallyFocused !== undefined ? visuallyFocused : _focused;
    if (disabled && focused) setFocused(false);
    var registerEffect;
    var registeredInput;
    var onFilled = $ieT14.useCallback(function() {
        setFilled(true);
    }, []);
    var onEmpty = $ieT14.useCallback(function() {
        setFilled(false);
    }, []);
    var childContext = {
        adornedStart: adornedStart,
        setAdornedStart: setAdornedStart,
        color: color,
        disabled: disabled,
        error: error,
        filled: filled,
        focused: focused,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: (size === 'small' ? 'dense' : undefined) || margin,
        onBlur: function onBlur() {
            setFocused(false);
        },
        onEmpty: onEmpty,
        onFilled: onFilled,
        onFocus: function onFocus() {
            setFocused(true);
        },
        registerEffect: registerEffect,
        required: required,
        variant: variant
    };
    return /*#__PURE__*/ $ieT14.createElement((0, $bJmSx.default).Provider, {
        value: childContext
    }, /*#__PURE__*/ $ieT14.createElement(Component, (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className, margin !== 'none' && classes["margin".concat((0, $2EBFt.default)(margin))], fullWidth && classes.fullWidth),
        ref: ref
    }, other), children));
});
var $0610d9faa61729a5$export$2e2bcd8739ae039 = (0, $aIJrd.default)($0610d9faa61729a5$export$9dd6ff9ea0189349, {
    name: 'MuiFormControl'
})($0610d9faa61729a5$var$FormControl);

});
parcelRegister("033Qn", function(module, exports) {

$parcel$export(module.exports, "isFilled", function () { return $0093433fe01cf3a4$export$d652b828d7fdeff8; });
$parcel$export(module.exports, "isAdornedStart", function () { return $0093433fe01cf3a4$export$1b68bdfa56faeb5d; });
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $0093433fe01cf3a4$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
function $0093433fe01cf3a4$export$d652b828d7fdeff8(obj) {
    var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return obj && ($0093433fe01cf3a4$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $0093433fe01cf3a4$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
} // Determine if an Input is adorned on start.
function $0093433fe01cf3a4$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}

});

parcelRegister("gX17d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c573058b984e784e$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");
function $c573058b984e784e$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $ieT14.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

});

parcelRegister("bJmSx", function(module, exports) {

$parcel$export(module.exports, "useFormControl", function () { return $88a5a4eb62f60d35$export$62ecd8ad1bbe1a18; });
$parcel$export(module.exports, "default", function () { return $88a5a4eb62f60d35$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");
/**
 * @ignore - internal component.
 */ var $88a5a4eb62f60d35$var$FormControlContext = $ieT14.createContext();
function $88a5a4eb62f60d35$export$62ecd8ad1bbe1a18() {
    return $ieT14.useContext($88a5a4eb62f60d35$var$FormControlContext);
}
var $88a5a4eb62f60d35$export$2e2bcd8739ae039 = $88a5a4eb62f60d35$var$FormControlContext;

});


parcelRegister("knRao", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed6f326c7478b6f7$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");


var $aRcbT = parcelRequire("aRcbT");

var $aIJrd = parcelRequire("aIJrd");

var $47zxZ = parcelRequire("47zxZ");

var $2EBFt = parcelRequire("2EBFt");
var $ed6f326c7478b6f7$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'inline-flex',
            alignItems: 'center',
            cursor: 'pointer',
            // For correct alignment with the text.
            verticalAlign: 'middle',
            WebkitTapHighlightColor: 'transparent',
            marginLeft: -11,
            marginRight: 16,
            // used for row presentation of radio/checkbox
            '&$disabled': {
                cursor: 'default'
            }
        },
        /* Styles applied to the root element if `labelPlacement="start"`. */ labelPlacementStart: {
            flexDirection: 'row-reverse',
            marginLeft: 16,
            // used for row presentation of radio/checkbox
            marginRight: -11
        },
        /* Styles applied to the root element if `labelPlacement="top"`. */ labelPlacementTop: {
            flexDirection: 'column-reverse',
            marginLeft: 16
        },
        /* Styles applied to the root element if `labelPlacement="bottom"`. */ labelPlacementBottom: {
            flexDirection: 'column',
            marginLeft: 16
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the label's Typography component. */ label: {
            '&$disabled': {
                color: theme.palette.text.disabled
            }
        }
    };
};
/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ var $ed6f326c7478b6f7$var$FormControlLabel = /*#__PURE__*/ $ieT14.forwardRef(function FormControlLabel(props, ref) {
    var checked = props.checked, classes = props.classes, className = props.className, control = props.control, disabledProp = props.disabled, inputRef = props.inputRef, label = props.label, _props$labelPlacement = props.labelPlacement, labelPlacement = _props$labelPlacement === void 0 ? 'end' : _props$labelPlacement, name = props.name, onChange = props.onChange, value = props.value, other = (0, $eTwGP.default)(props, [
        "checked",
        "classes",
        "className",
        "control",
        "disabled",
        "inputRef",
        "label",
        "labelPlacement",
        "name",
        "onChange",
        "value"
    ]);
    var muiFormControl = (0, $aRcbT.default)();
    var disabled = disabledProp;
    if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') disabled = control.props.disabled;
    if (typeof disabled === 'undefined' && muiFormControl) disabled = muiFormControl.disabled;
    var controlProps = {
        disabled: disabled
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach(function(key) {
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    return /*#__PURE__*/ $ieT14.createElement("label", (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className, labelPlacement !== 'end' && classes["labelPlacement".concat((0, $2EBFt.default)(labelPlacement))], disabled && classes.disabled),
        ref: ref
    }, other), /*#__PURE__*/ $ieT14.cloneElement(control, controlProps), /*#__PURE__*/ $ieT14.createElement((0, $47zxZ.default), {
        component: "span",
        className: (0, $j6s32.default)(classes.label, disabled && classes.disabled)
    }, label));
});
var $ed6f326c7478b6f7$export$2e2bcd8739ae039 = (0, $aIJrd.default)($ed6f326c7478b6f7$export$9dd6ff9ea0189349, {
    name: 'MuiFormControlLabel'
})($ed6f326c7478b6f7$var$FormControlLabel);

});
parcelRegister("aRcbT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e784f70854713d3$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");

var $bJmSx = parcelRequire("bJmSx");
function $7e784f70854713d3$export$2e2bcd8739ae039() {
    return $ieT14.useContext((0, $bJmSx.default));
}

});

parcelRegister("47zxZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $300363c98e4c1224$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $aIJrd = parcelRequire("aIJrd");

var $2EBFt = parcelRequire("2EBFt");
var $300363c98e4c1224$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            margin: 0
        },
        /* Styles applied to the root element if `variant="body2"`. */ body2: theme.typography.body2,
        /* Styles applied to the root element if `variant="body1"`. */ body1: theme.typography.body1,
        /* Styles applied to the root element if `variant="caption"`. */ caption: theme.typography.caption,
        /* Styles applied to the root element if `variant="button"`. */ button: theme.typography.button,
        /* Styles applied to the root element if `variant="h1"`. */ h1: theme.typography.h1,
        /* Styles applied to the root element if `variant="h2"`. */ h2: theme.typography.h2,
        /* Styles applied to the root element if `variant="h3"`. */ h3: theme.typography.h3,
        /* Styles applied to the root element if `variant="h4"`. */ h4: theme.typography.h4,
        /* Styles applied to the root element if `variant="h5"`. */ h5: theme.typography.h5,
        /* Styles applied to the root element if `variant="h6"`. */ h6: theme.typography.h6,
        /* Styles applied to the root element if `variant="subtitle1"`. */ subtitle1: theme.typography.subtitle1,
        /* Styles applied to the root element if `variant="subtitle2"`. */ subtitle2: theme.typography.subtitle2,
        /* Styles applied to the root element if `variant="overline"`. */ overline: theme.typography.overline,
        /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */ srOnly: {
            position: 'absolute',
            height: 1,
            width: 1,
            overflow: 'hidden'
        },
        /* Styles applied to the root element if `align="left"`. */ alignLeft: {
            textAlign: 'left'
        },
        /* Styles applied to the root element if `align="center"`. */ alignCenter: {
            textAlign: 'center'
        },
        /* Styles applied to the root element if `align="right"`. */ alignRight: {
            textAlign: 'right'
        },
        /* Styles applied to the root element if `align="justify"`. */ alignJustify: {
            textAlign: 'justify'
        },
        /* Styles applied to the root element if `nowrap={true}`. */ noWrap: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        /* Styles applied to the root element if `gutterBottom={true}`. */ gutterBottom: {
            marginBottom: '0.35em'
        },
        /* Styles applied to the root element if `paragraph={true}`. */ paragraph: {
            marginBottom: 16
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: 'inherit'
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="textPrimary"`. */ colorTextPrimary: {
            color: theme.palette.text.primary
        },
        /* Styles applied to the root element if `color="textSecondary"`. */ colorTextSecondary: {
            color: theme.palette.text.secondary
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `display="inline"`. */ displayInline: {
            display: 'inline'
        },
        /* Styles applied to the root element if `display="block"`. */ displayBlock: {
            display: 'block'
        }
    };
};
var $300363c98e4c1224$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p'
};
var $300363c98e4c1224$var$Typography = /*#__PURE__*/ $ieT14.forwardRef(function Typography(props, ref) {
    var _props$align = props.align, align = _props$align === void 0 ? 'inherit' : _props$align, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'initial' : _props$color, component = props.component, _props$display = props.display, display = _props$display === void 0 ? 'initial' : _props$display, _props$gutterBottom = props.gutterBottom, gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom, _props$noWrap = props.noWrap, noWrap = _props$noWrap === void 0 ? false : _props$noWrap, _props$paragraph = props.paragraph, paragraph = _props$paragraph === void 0 ? false : _props$paragraph, _props$variant = props.variant, variant = _props$variant === void 0 ? 'body1' : _props$variant, _props$variantMapping = props.variantMapping, variantMapping = _props$variantMapping === void 0 ? $300363c98e4c1224$var$defaultVariantMapping : _props$variantMapping, other = (0, $eTwGP.default)(props, [
        "align",
        "classes",
        "className",
        "color",
        "component",
        "display",
        "gutterBottom",
        "noWrap",
        "paragraph",
        "variant",
        "variantMapping"
    ]);
    var Component = component || (paragraph ? 'p' : variantMapping[variant] || $300363c98e4c1224$var$defaultVariantMapping[variant]) || 'span';
    return /*#__PURE__*/ $ieT14.createElement(Component, (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat((0, $2EBFt.default)(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat((0, $2EBFt.default)(align))], display !== 'initial' && classes["display".concat((0, $2EBFt.default)(display))]),
        ref: ref
    }, other));
});
var $300363c98e4c1224$export$2e2bcd8739ae039 = (0, $aIJrd.default)($300363c98e4c1224$export$9dd6ff9ea0189349, {
    name: 'MuiTypography'
})($300363c98e4c1224$var$Typography);

});


parcelRegister("3WBJn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2df40e757e52d7d1$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $aIJrd = parcelRequire("aIJrd");
var $2df40e757e52d7d1$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap'
    },
    /* Styles applied to the root element if `row={true}`. */ row: {
        flexDirection: 'row'
    }
};
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ var $2df40e757e52d7d1$var$FormGroup = /*#__PURE__*/ $ieT14.forwardRef(function FormGroup(props, ref) {
    var classes = props.classes, className = props.className, _props$row = props.row, row = _props$row === void 0 ? false : _props$row, other = (0, $eTwGP.default)(props, [
        "classes",
        "className",
        "row"
    ]);
    return /*#__PURE__*/ $ieT14.createElement("div", (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className, row && classes.row),
        ref: ref
    }, other));
});
var $2df40e757e52d7d1$export$2e2bcd8739ae039 = (0, $aIJrd.default)($2df40e757e52d7d1$export$9dd6ff9ea0189349, {
    name: 'MuiFormGroup'
})($2df40e757e52d7d1$var$FormGroup);

});

parcelRegister("f3VQ2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af74005391b0df04$export$2e2bcd8739ae039; });

var $eTwGP = parcelRequire("eTwGP");

var $edxsd = parcelRequire("edxsd");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $gAQ3E = parcelRequire("gAQ3E");

var $aRcbT = parcelRequire("aRcbT");

var $2EBFt = parcelRequire("2EBFt");

var $aIJrd = parcelRequire("aIJrd");
var $af74005391b0df04$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $edxsd.default)({
            color: theme.palette.text.secondary
        }, theme.typography.body1, {
            lineHeight: 1,
            padding: 0,
            '&$focused': {
                color: theme.palette.primary.main
            },
            '&$disabled': {
                color: theme.palette.text.disabled
            },
            '&$error': {
                color: theme.palette.error.main
            }
        }),
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {
            '&$focused': {
                color: theme.palette.secondary.main
            }
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `filled={true}`. */ filled: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {},
        /* Styles applied to the asterisk element. */ asterisk: {
            '&$error': {
                color: theme.palette.error.main
            }
        }
    };
};
var $af74005391b0df04$var$FormLabel = /*#__PURE__*/ $ieT14.forwardRef(function FormLabel(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, color = props.color, _props$component = props.component, Component = _props$component === void 0 ? 'label' : _props$component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, required = props.required, other = (0, $eTwGP.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "required"
    ]);
    var muiFormControl = (0, $aRcbT.default)();
    var fcs = (0, $gAQ3E.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    return /*#__PURE__*/ $ieT14.createElement(Component, (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, classes["color".concat((0, $2EBFt.default)(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
        ref: ref
    }, other), children, fcs.required && /*#__PURE__*/ $ieT14.createElement("span", {
        "aria-hidden": true,
        className: (0, $j6s32.default)(classes.asterisk, fcs.error && classes.error)
    }, "\u2009", '*'));
});
var $af74005391b0df04$export$2e2bcd8739ae039 = (0, $aIJrd.default)($af74005391b0df04$export$9dd6ff9ea0189349, {
    name: 'MuiFormLabel'
})($af74005391b0df04$var$FormLabel);

});
parcelRegister("gAQ3E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c14863c47867a483$export$2e2bcd8739ae039; });
function $c14863c47867a483$export$2e2bcd8739ae039(_ref) {
    var props = _ref.props, states = _ref.states, muiFormControl = _ref.muiFormControl;
    return states.reduce(function(acc, state) {
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});


parcelRegister("1KcBP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1453de3a06dbcc66$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");


var $aIJrd = parcelRequire("aIJrd");

var $86m3e = parcelRequire("86m3e");

var $51wR9 = parcelRequire("51wR9");

var $2EBFt = parcelRequire("2EBFt");
var $1453de3a06dbcc66$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            textAlign: 'center',
            flex: '0 0 auto',
            fontSize: theme.typography.pxToRem(24),
            padding: 12,
            borderRadius: '50%',
            overflow: 'visible',
            // Explicitly set the default value to solve a bug on IE 11.
            color: theme.palette.action.active,
            transition: theme.transitions.create('background-color', {
                duration: theme.transitions.duration.shortest
            }),
            '&:hover': {
                backgroundColor: (0, $86m3e.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&$disabled': {
                backgroundColor: 'transparent',
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `edge="start"`. */ edgeStart: {
            marginLeft: -12,
            '$sizeSmall&': {
                marginLeft: -3
            }
        },
        /* Styles applied to the root element if `edge="end"`. */ edgeEnd: {
            marginRight: -12,
            '$sizeSmall&': {
                marginRight: -3
            }
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: 'inherit'
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: (0, $86m3e.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: (0, $86m3e.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            padding: 3,
            fontSize: theme.typography.pxToRem(18)
        },
        /* Styles applied to the children container element. */ label: {
            width: '100%',
            display: 'flex',
            alignItems: 'inherit',
            justifyContent: 'inherit'
        }
    };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */ var $1453de3a06dbcc66$var$IconButton = /*#__PURE__*/ $ieT14.forwardRef(function IconButton(props, ref) {
    var _props$edge = props.edge, edge = _props$edge === void 0 ? false : _props$edge, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'default' : _props$color, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, other = (0, $eTwGP.default)(props, [
        "edge",
        "children",
        "classes",
        "className",
        "color",
        "disabled",
        "disableFocusRipple",
        "size"
    ]);
    return /*#__PURE__*/ $ieT14.createElement((0, $51wR9.default), (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className, color !== 'default' && classes["color".concat((0, $2EBFt.default)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0, $2EBFt.default)(size))], {
            'start': classes.edgeStart,
            'end': classes.edgeEnd
        }[edge]),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other), /*#__PURE__*/ $ieT14.createElement("span", {
        className: classes.label
    }, children));
});
var $1453de3a06dbcc66$export$2e2bcd8739ae039 = (0, $aIJrd.default)($1453de3a06dbcc66$export$9dd6ff9ea0189349, {
    name: 'MuiIconButton'
})($1453de3a06dbcc66$var$IconButton);

});

parcelRegister("Uxz4Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a9f4458ae057292$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $gAQ3E = parcelRequire("gAQ3E");

var $aRcbT = parcelRequire("aRcbT");

var $aIJrd = parcelRequire("aIJrd");

var $f3VQ2 = parcelRequire("f3VQ2");
var $0a9f4458ae057292$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'block',
            transformOrigin: 'top left'
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {},
        /* Pseudo-class applied to the asterisk element. */ asterisk: {},
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {
            position: 'absolute',
            left: 0,
            top: 0,
            // slight alteration to spec spacing to match visual spec result
            transform: 'translate(0, 24px) scale(1)'
        },
        /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
            // Compensation for the `Input.inputDense` style.
            transform: 'translate(0, 21px) scale(1)'
        },
        /* Styles applied to the `input` element if `shrink={true}`. */ shrink: {
            transform: 'translate(0, 1.5px) scale(0.75)',
            transformOrigin: 'top left'
        },
        /* Styles applied to the `input` element if `disableAnimation={false}`. */ animated: {
            transition: theme.transitions.create([
                'color',
                'transform'
            ], {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            })
        },
        /* Styles applied to the root element if `variant="filled"`. */ filled: {
            // Chrome's autofill feature gives the input field a yellow background.
            // Since the input field is behind the label in the HTML tree,
            // the input field is drawn last and hides the label with an opaque background color.
            // zIndex: 1 will raise the label above opaque background-colors of input.
            zIndex: 1,
            pointerEvents: 'none',
            transform: 'translate(12px, 20px) scale(1)',
            '&$marginDense': {
                transform: 'translate(12px, 17px) scale(1)'
            },
            '&$shrink': {
                transform: 'translate(12px, 10px) scale(0.75)',
                '&$marginDense': {
                    transform: 'translate(12px, 7px) scale(0.75)'
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            // see comment above on filled.zIndex
            zIndex: 1,
            pointerEvents: 'none',
            transform: 'translate(14px, 20px) scale(1)',
            '&$marginDense': {
                transform: 'translate(14px, 12px) scale(1)'
            },
            '&$shrink': {
                transform: 'translate(14px, -6px) scale(0.75)'
            }
        }
    };
};
var $0a9f4458ae057292$var$InputLabel = /*#__PURE__*/ $ieT14.forwardRef(function InputLabel(props, ref) {
    var classes = props.classes, className = props.className, _props$disableAnimati = props.disableAnimation, disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati, margin = props.margin, shrinkProp = props.shrink, variant = props.variant, other = (0, $eTwGP.default)(props, [
        "classes",
        "className",
        "disableAnimation",
        "margin",
        "shrink",
        "variant"
    ]);
    var muiFormControl = (0, $aRcbT.default)();
    var shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    var fcs = (0, $gAQ3E.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'margin',
            'variant'
        ]
    });
    return /*#__PURE__*/ $ieT14.createElement((0, $f3VQ2.default), (0, $edxsd.default)({
        "data-shrink": shrink,
        className: (0, $j6s32.default)(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, fcs.margin === 'dense' && classes.marginDense, {
            'filled': classes.filled,
            'outlined': classes.outlined
        }[fcs.variant]),
        classes: {
            focused: classes.focused,
            disabled: classes.disabled,
            error: classes.error,
            required: classes.required,
            asterisk: classes.asterisk
        },
        ref: ref
    }, other));
});
var $0a9f4458ae057292$export$2e2bcd8739ae039 = (0, $aIJrd.default)($0a9f4458ae057292$export$9dd6ff9ea0189349, {
    name: 'MuiInputLabel'
})($0a9f4458ae057292$var$InputLabel);

});

parcelRegister("iwN3n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7d14422f3b6e87f$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $aIJrd = parcelRequire("aIJrd");

var $2Mf9x = parcelRequire("2Mf9x");
var $d7d14422f3b6e87f$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            minWidth: 56,
            color: theme.palette.action.active,
            flexShrink: 0,
            display: 'inline-flex'
        },
        /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */ alignItemsFlexStart: {
            marginTop: 8
        }
    };
};
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ var $d7d14422f3b6e87f$var$ListItemIcon = /*#__PURE__*/ $ieT14.forwardRef(function ListItemIcon(props, ref) {
    var classes = props.classes, className = props.className, other = (0, $eTwGP.default)(props, [
        "classes",
        "className"
    ]);
    var context = $ieT14.useContext((0, $2Mf9x.default));
    return /*#__PURE__*/ $ieT14.createElement("div", (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
        ref: ref
    }, other));
});
var $d7d14422f3b6e87f$export$2e2bcd8739ae039 = (0, $aIJrd.default)($d7d14422f3b6e87f$export$9dd6ff9ea0189349, {
    name: 'MuiListItemIcon'
})($d7d14422f3b6e87f$var$ListItemIcon);

});
parcelRegister("2Mf9x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $205bd17d81ad1aa2$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");
/**
 * @ignore - internal component.
 */ var $205bd17d81ad1aa2$var$ListContext = $ieT14.createContext({});
var $205bd17d81ad1aa2$export$2e2bcd8739ae039 = $205bd17d81ad1aa2$var$ListContext;

});


parcelRegister("bPjUl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89c3e6672f6f87cc$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $aIJrd = parcelRequire("aIJrd");

var $47zxZ = parcelRequire("47zxZ");

var $2Mf9x = parcelRequire("2Mf9x");
var $89c3e6672f6f87cc$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        flex: '1 1 auto',
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    },
    /* Styles applied to the `Typography` components if primary and secondary are set. */ multiline: {
        marginTop: 6,
        marginBottom: 6
    },
    /* Styles applied to the `Typography` components if dense. */ dense: {},
    /* Styles applied to the root element if `inset={true}`. */ inset: {
        paddingLeft: 56
    },
    /* Styles applied to the primary `Typography` component. */ primary: {},
    /* Styles applied to the secondary `Typography` component. */ secondary: {}
};
var $89c3e6672f6f87cc$var$ListItemText = /*#__PURE__*/ $ieT14.forwardRef(function ListItemText(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$disableTypogra = props.disableTypography, disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra, _props$inset = props.inset, inset = _props$inset === void 0 ? false : _props$inset, primaryProp = props.primary, primaryTypographyProps = props.primaryTypographyProps, secondaryProp = props.secondary, secondaryTypographyProps = props.secondaryTypographyProps, other = (0, $eTwGP.default)(props, [
        "children",
        "classes",
        "className",
        "disableTypography",
        "inset",
        "primary",
        "primaryTypographyProps",
        "secondary",
        "secondaryTypographyProps"
    ]);
    var _React$useContext = $ieT14.useContext((0, $2Mf9x.default)), dense = _React$useContext.dense;
    var primary = primaryProp != null ? primaryProp : children;
    if (primary != null && primary.type !== (0, $47zxZ.default) && !disableTypography) primary = /*#__PURE__*/ $ieT14.createElement((0, $47zxZ.default), (0, $edxsd.default)({
        variant: dense ? 'body2' : 'body1',
        className: classes.primary,
        component: "span",
        display: "block"
    }, primaryTypographyProps), primary);
    var secondary = secondaryProp;
    if (secondary != null && secondary.type !== (0, $47zxZ.default) && !disableTypography) secondary = /*#__PURE__*/ $ieT14.createElement((0, $47zxZ.default), (0, $edxsd.default)({
        variant: "body2",
        className: classes.secondary,
        color: "textSecondary",
        display: "block"
    }, secondaryTypographyProps), secondary);
    return /*#__PURE__*/ $ieT14.createElement("div", (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className, dense && classes.dense, inset && classes.inset, primary && secondary && classes.multiline),
        ref: ref
    }, other), primary, secondary);
});
var $89c3e6672f6f87cc$export$2e2bcd8739ae039 = (0, $aIJrd.default)($89c3e6672f6f87cc$export$9dd6ff9ea0189349, {
    name: 'MuiListItemText'
})($89c3e6672f6f87cc$var$ListItemText);

});

parcelRegister("e1ONw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a368901253491e0b$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $db7Kr = parcelRequire("db7Kr");

var $kkrWC = parcelRequire("kkrWC");
function $a368901253491e0b$var$makeStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return (0, $db7Kr.default)(stylesOrCreator, (0, $edxsd.default)({
        defaultTheme: (0, $kkrWC.default)
    }, options));
}
var $a368901253491e0b$export$2e2bcd8739ae039 = $a368901253491e0b$var$makeStyles;

});

parcelRegister("5TjLg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44a16af791f6158b$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");
parcelRequire("fqwRx");


var $j6s32 = parcelRequire("j6s32");


var $aIJrd = parcelRequire("aIJrd");

var $lzS53 = parcelRequire("lzS53");

var $bZlCc = parcelRequire("bZlCc");

var $3tOoB = parcelRequire("3tOoB");

var $kC3Zv = parcelRequire("kC3Zv");

var $hgPMF = parcelRequire("hgPMF");

var $44a16af791f6158b$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
var $44a16af791f6158b$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
var $44a16af791f6158b$export$9dd6ff9ea0189349 = {
    /* Styles applied to the `Paper` component. */ paper: {
        // specZ: The maximum height of a simple menu should be one or more rows less than the view
        // height. This ensures a tapable area outside of the simple menu with which to dismiss
        // the menu.
        maxHeight: 'calc(100% - 96px)',
        // Add iOS momentum scrolling.
        WebkitOverflowScrolling: 'touch'
    },
    /* Styles applied to the `List` component via `MenuList`. */ list: {
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }
};
var $44a16af791f6158b$var$Menu = /*#__PURE__*/ $ieT14.forwardRef(function Menu(props, ref) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, children = props.children, classes = props.classes, _props$disableAutoFoc = props.disableAutoFocusItem, disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$MenuListProps = props.MenuListProps, MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps, onClose = props.onClose, onEnteringProp = props.onEntering, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, PopoverClasses = props.PopoverClasses, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura, _props$TransitionProp = props.TransitionProps;
    _props$TransitionProp = _props$TransitionProp === void 0 ? {} : _props$TransitionProp;
    var onEntering = _props$TransitionProp.onEntering, TransitionProps = (0, $eTwGP.default)(_props$TransitionProp, [
        "onEntering"
    ]), _props$variant = props.variant, variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant, other = (0, $eTwGP.default)(props, [
        "autoFocus",
        "children",
        "classes",
        "disableAutoFocusItem",
        "MenuListProps",
        "onClose",
        "onEntering",
        "open",
        "PaperProps",
        "PopoverClasses",
        "transitionDuration",
        "TransitionProps",
        "variant"
    ]);
    var theme = (0, $hgPMF.default)();
    var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    var menuListActionsRef = $ieT14.useRef(null);
    var contentAnchorRef = $ieT14.useRef(null);
    var getContentAnchorEl = function getContentAnchorEl() {
        return contentAnchorRef.current;
    };
    var handleEntering = function handleEntering(element, isAppearing) {
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEnteringProp) onEnteringProp(element, isAppearing);
        if (onEntering) onEntering(element, isAppearing);
    };
    var handleListKeyDown = function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $ieT14.Children.map(children, function(child, index) {
        if (!/*#__PURE__*/ $ieT14.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant !== "menu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    var items = $ieT14.Children.map(children, function(child, index) {
        if (index === activeItemIndex) return /*#__PURE__*/ $ieT14.cloneElement(child, {
            ref: function ref(instance) {
                // #StrictMode ready
                contentAnchorRef.current = $3tOoB.findDOMNode(instance);
                (0, $kC3Zv.default)(child.ref, instance);
            }
        });
        return child;
    });
    return /*#__PURE__*/ $ieT14.createElement((0, $lzS53.default), (0, $edxsd.default)({
        getContentAnchorEl: getContentAnchorEl,
        classes: PopoverClasses,
        onClose: onClose,
        TransitionProps: (0, $edxsd.default)({
            onEntering: handleEntering
        }, TransitionProps),
        anchorOrigin: theme.direction === 'rtl' ? $44a16af791f6158b$var$RTL_ORIGIN : $44a16af791f6158b$var$LTR_ORIGIN,
        transformOrigin: theme.direction === 'rtl' ? $44a16af791f6158b$var$RTL_ORIGIN : $44a16af791f6158b$var$LTR_ORIGIN,
        PaperProps: (0, $edxsd.default)({}, PaperProps, {
            classes: (0, $edxsd.default)({}, PaperProps.classes, {
                root: classes.paper
            })
        }),
        open: open,
        ref: ref,
        transitionDuration: transitionDuration
    }, other), /*#__PURE__*/ $ieT14.createElement((0, $bZlCc.default), (0, $edxsd.default)({
        onKeyDown: handleListKeyDown,
        actions: menuListActionsRef,
        autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
        autoFocusItem: autoFocusItem,
        variant: variant
    }, MenuListProps, {
        className: (0, $j6s32.default)(classes.list, MenuListProps.className)
    }), items));
});
var $44a16af791f6158b$export$2e2bcd8739ae039 = (0, $aIJrd.default)($44a16af791f6158b$export$9dd6ff9ea0189349, {
    name: 'MuiMenu'
})($44a16af791f6158b$var$Menu);

});
parcelRegister("fqwRx", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3GdTW"));

});
parcelRegister("3GdTW", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $2ae013dd5f43139b$export$a7c73072b1a182ae; }, function (v) { return $2ae013dd5f43139b$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $2ae013dd5f43139b$export$9f27bc3417b4524d; }, function (v) { return $2ae013dd5f43139b$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $2ae013dd5f43139b$export$db77ccec0bb4ccac; }, function (v) { return $2ae013dd5f43139b$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $2ae013dd5f43139b$export$8392c0c9d3dcbd35; }, function (v) { return $2ae013dd5f43139b$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $2ae013dd5f43139b$export$ffb0004e005737fa; }, function (v) { return $2ae013dd5f43139b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $2ae013dd5f43139b$export$b624eff549462981; }, function (v) { return $2ae013dd5f43139b$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $2ae013dd5f43139b$export$7897aa7841a5380c; }, function (v) { return $2ae013dd5f43139b$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $2ae013dd5f43139b$export$602eac185826482c; }, function (v) { return $2ae013dd5f43139b$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $2ae013dd5f43139b$export$e2c29f18771995cb; }, function (v) { return $2ae013dd5f43139b$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $2ae013dd5f43139b$export$5f8d39834fd61797; }, function (v) { return $2ae013dd5f43139b$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $2ae013dd5f43139b$export$74bf444e3cd11ea5; }, function (v) { return $2ae013dd5f43139b$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $2ae013dd5f43139b$export$92387174baf9b227; }, function (v) { return $2ae013dd5f43139b$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $2ae013dd5f43139b$export$ec112efeb987d9c6; }, function (v) { return $2ae013dd5f43139b$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $2ae013dd5f43139b$export$b706b080d889d2c9; }, function (v) { return $2ae013dd5f43139b$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $2ae013dd5f43139b$export$5be5a87408f70ddc; }, function (v) { return $2ae013dd5f43139b$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $2ae013dd5f43139b$export$45a5e7f76e0caa8d; }, function (v) { return $2ae013dd5f43139b$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $2ae013dd5f43139b$export$455c2e768291efa6; }, function (v) { return $2ae013dd5f43139b$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $2ae013dd5f43139b$export$9522e17588c12572; }, function (v) { return $2ae013dd5f43139b$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $2ae013dd5f43139b$export$2110ac352bb060b9; }, function (v) { return $2ae013dd5f43139b$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $2ae013dd5f43139b$export$56885ab8b9c456ab; }, function (v) { return $2ae013dd5f43139b$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $2ae013dd5f43139b$export$d927fcb6adf8f9de; }, function (v) { return $2ae013dd5f43139b$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $2ae013dd5f43139b$export$b82d16f27459e05a; }, function (v) { return $2ae013dd5f43139b$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $2ae013dd5f43139b$export$522c17b4f5e123e8; }, function (v) { return $2ae013dd5f43139b$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $2ae013dd5f43139b$export$1aabd8a0274ecfd6; }, function (v) { return $2ae013dd5f43139b$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $2ae013dd5f43139b$export$9b621391a187a31a; }, function (v) { return $2ae013dd5f43139b$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $2ae013dd5f43139b$export$f5bbd400c2f4426f; }, function (v) { return $2ae013dd5f43139b$export$f5bbd400c2f4426f = v; });
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2ae013dd5f43139b$export$a7c73072b1a182ae;
var $2ae013dd5f43139b$export$9f27bc3417b4524d;
var $2ae013dd5f43139b$export$db77ccec0bb4ccac;
var $2ae013dd5f43139b$export$8392c0c9d3dcbd35;
var $2ae013dd5f43139b$export$ffb0004e005737fa;
var $2ae013dd5f43139b$export$b624eff549462981;
var $2ae013dd5f43139b$export$7897aa7841a5380c;
var $2ae013dd5f43139b$export$602eac185826482c;
var $2ae013dd5f43139b$export$e2c29f18771995cb;
var $2ae013dd5f43139b$export$5f8d39834fd61797;
var $2ae013dd5f43139b$export$74bf444e3cd11ea5;
var $2ae013dd5f43139b$export$92387174baf9b227;
var $2ae013dd5f43139b$export$ec112efeb987d9c6;
var $2ae013dd5f43139b$export$b706b080d889d2c9;
var $2ae013dd5f43139b$export$5be5a87408f70ddc;
var $2ae013dd5f43139b$export$45a5e7f76e0caa8d;
var $2ae013dd5f43139b$export$455c2e768291efa6;
var $2ae013dd5f43139b$export$9522e17588c12572;
var $2ae013dd5f43139b$export$2110ac352bb060b9;
var $2ae013dd5f43139b$export$56885ab8b9c456ab;
var $2ae013dd5f43139b$export$d927fcb6adf8f9de;
var $2ae013dd5f43139b$export$b82d16f27459e05a;
var $2ae013dd5f43139b$export$522c17b4f5e123e8;
var $2ae013dd5f43139b$export$1aabd8a0274ecfd6;
var $2ae013dd5f43139b$export$9b621391a187a31a;
var $2ae013dd5f43139b$export$f5bbd400c2f4426f;
'use strict';
var $2ae013dd5f43139b$var$b = 60103, $2ae013dd5f43139b$var$c = 60106, $2ae013dd5f43139b$var$d = 60107, $2ae013dd5f43139b$var$e = 60108, $2ae013dd5f43139b$var$f = 60114, $2ae013dd5f43139b$var$g = 60109, $2ae013dd5f43139b$var$h = 60110, $2ae013dd5f43139b$var$k = 60112, $2ae013dd5f43139b$var$l = 60113, $2ae013dd5f43139b$var$m = 60120, $2ae013dd5f43139b$var$n = 60115, $2ae013dd5f43139b$var$p = 60116, $2ae013dd5f43139b$var$q = 60121, $2ae013dd5f43139b$var$r = 60122, $2ae013dd5f43139b$var$u = 60117, $2ae013dd5f43139b$var$v = 60129, $2ae013dd5f43139b$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $2ae013dd5f43139b$var$x = Symbol.for;
    $2ae013dd5f43139b$var$b = $2ae013dd5f43139b$var$x("react.element");
    $2ae013dd5f43139b$var$c = $2ae013dd5f43139b$var$x("react.portal");
    $2ae013dd5f43139b$var$d = $2ae013dd5f43139b$var$x("react.fragment");
    $2ae013dd5f43139b$var$e = $2ae013dd5f43139b$var$x("react.strict_mode");
    $2ae013dd5f43139b$var$f = $2ae013dd5f43139b$var$x("react.profiler");
    $2ae013dd5f43139b$var$g = $2ae013dd5f43139b$var$x("react.provider");
    $2ae013dd5f43139b$var$h = $2ae013dd5f43139b$var$x("react.context");
    $2ae013dd5f43139b$var$k = $2ae013dd5f43139b$var$x("react.forward_ref");
    $2ae013dd5f43139b$var$l = $2ae013dd5f43139b$var$x("react.suspense");
    $2ae013dd5f43139b$var$m = $2ae013dd5f43139b$var$x("react.suspense_list");
    $2ae013dd5f43139b$var$n = $2ae013dd5f43139b$var$x("react.memo");
    $2ae013dd5f43139b$var$p = $2ae013dd5f43139b$var$x("react.lazy");
    $2ae013dd5f43139b$var$q = $2ae013dd5f43139b$var$x("react.block");
    $2ae013dd5f43139b$var$r = $2ae013dd5f43139b$var$x("react.server.block");
    $2ae013dd5f43139b$var$u = $2ae013dd5f43139b$var$x("react.fundamental");
    $2ae013dd5f43139b$var$v = $2ae013dd5f43139b$var$x("react.debug_trace_mode");
    $2ae013dd5f43139b$var$w = $2ae013dd5f43139b$var$x("react.legacy_hidden");
}
function $2ae013dd5f43139b$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $2ae013dd5f43139b$var$b:
                switch(a = a.type, a){
                    case $2ae013dd5f43139b$var$d:
                    case $2ae013dd5f43139b$var$f:
                    case $2ae013dd5f43139b$var$e:
                    case $2ae013dd5f43139b$var$l:
                    case $2ae013dd5f43139b$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2ae013dd5f43139b$var$h:
                            case $2ae013dd5f43139b$var$k:
                            case $2ae013dd5f43139b$var$p:
                            case $2ae013dd5f43139b$var$n:
                            case $2ae013dd5f43139b$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $2ae013dd5f43139b$var$c:
                return t;
        }
    }
}
var $2ae013dd5f43139b$var$z = $2ae013dd5f43139b$var$g, $2ae013dd5f43139b$var$A = $2ae013dd5f43139b$var$b, $2ae013dd5f43139b$var$B = $2ae013dd5f43139b$var$k, $2ae013dd5f43139b$var$C = $2ae013dd5f43139b$var$d, $2ae013dd5f43139b$var$D = $2ae013dd5f43139b$var$p, $2ae013dd5f43139b$var$E = $2ae013dd5f43139b$var$n, $2ae013dd5f43139b$var$F = $2ae013dd5f43139b$var$c, $2ae013dd5f43139b$var$G = $2ae013dd5f43139b$var$f, $2ae013dd5f43139b$var$H = $2ae013dd5f43139b$var$e, $2ae013dd5f43139b$var$I = $2ae013dd5f43139b$var$l;
$2ae013dd5f43139b$export$a7c73072b1a182ae = $2ae013dd5f43139b$var$h;
$2ae013dd5f43139b$export$9f27bc3417b4524d = $2ae013dd5f43139b$var$z;
$2ae013dd5f43139b$export$db77ccec0bb4ccac = $2ae013dd5f43139b$var$A;
$2ae013dd5f43139b$export$8392c0c9d3dcbd35 = $2ae013dd5f43139b$var$B;
$2ae013dd5f43139b$export$ffb0004e005737fa = $2ae013dd5f43139b$var$C;
$2ae013dd5f43139b$export$b624eff549462981 = $2ae013dd5f43139b$var$D;
$2ae013dd5f43139b$export$7897aa7841a5380c = $2ae013dd5f43139b$var$E;
$2ae013dd5f43139b$export$602eac185826482c = $2ae013dd5f43139b$var$F;
$2ae013dd5f43139b$export$e2c29f18771995cb = $2ae013dd5f43139b$var$G;
$2ae013dd5f43139b$export$5f8d39834fd61797 = $2ae013dd5f43139b$var$H;
$2ae013dd5f43139b$export$74bf444e3cd11ea5 = $2ae013dd5f43139b$var$I;
$2ae013dd5f43139b$export$92387174baf9b227 = function() {
    return !1;
};
$2ae013dd5f43139b$export$ec112efeb987d9c6 = function() {
    return !1;
};
$2ae013dd5f43139b$export$b706b080d889d2c9 = function(a) {
    return $2ae013dd5f43139b$var$y(a) === $2ae013dd5f43139b$var$h;
};
$2ae013dd5f43139b$export$5be5a87408f70ddc = function(a) {
    return $2ae013dd5f43139b$var$y(a) === $2ae013dd5f43139b$var$g;
};
$2ae013dd5f43139b$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2ae013dd5f43139b$var$b;
};
$2ae013dd5f43139b$export$455c2e768291efa6 = function(a) {
    return $2ae013dd5f43139b$var$y(a) === $2ae013dd5f43139b$var$k;
};
$2ae013dd5f43139b$export$9522e17588c12572 = function(a) {
    return $2ae013dd5f43139b$var$y(a) === $2ae013dd5f43139b$var$d;
};
$2ae013dd5f43139b$export$2110ac352bb060b9 = function(a) {
    return $2ae013dd5f43139b$var$y(a) === $2ae013dd5f43139b$var$p;
};
$2ae013dd5f43139b$export$56885ab8b9c456ab = function(a) {
    return $2ae013dd5f43139b$var$y(a) === $2ae013dd5f43139b$var$n;
};
$2ae013dd5f43139b$export$d927fcb6adf8f9de = function(a) {
    return $2ae013dd5f43139b$var$y(a) === $2ae013dd5f43139b$var$c;
};
$2ae013dd5f43139b$export$b82d16f27459e05a = function(a) {
    return $2ae013dd5f43139b$var$y(a) === $2ae013dd5f43139b$var$f;
};
$2ae013dd5f43139b$export$522c17b4f5e123e8 = function(a) {
    return $2ae013dd5f43139b$var$y(a) === $2ae013dd5f43139b$var$e;
};
$2ae013dd5f43139b$export$1aabd8a0274ecfd6 = function(a) {
    return $2ae013dd5f43139b$var$y(a) === $2ae013dd5f43139b$var$l;
};
$2ae013dd5f43139b$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2ae013dd5f43139b$var$d || a === $2ae013dd5f43139b$var$f || a === $2ae013dd5f43139b$var$v || a === $2ae013dd5f43139b$var$e || a === $2ae013dd5f43139b$var$l || a === $2ae013dd5f43139b$var$m || a === $2ae013dd5f43139b$var$w || "object" === typeof a && null !== a && (a.$$typeof === $2ae013dd5f43139b$var$p || a.$$typeof === $2ae013dd5f43139b$var$n || a.$$typeof === $2ae013dd5f43139b$var$g || a.$$typeof === $2ae013dd5f43139b$var$h || a.$$typeof === $2ae013dd5f43139b$var$k || a.$$typeof === $2ae013dd5f43139b$var$u || a.$$typeof === $2ae013dd5f43139b$var$q || a[0] === $2ae013dd5f43139b$var$r) ? !0 : !1;
};
$2ae013dd5f43139b$export$f5bbd400c2f4426f = $2ae013dd5f43139b$var$y;

});


parcelRegister("lzS53", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb56d120ad8e2c59$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $3tOoB = parcelRequire("3tOoB");


var $hJtzf = parcelRequire("hJtzf");

var $j6s32 = parcelRequire("j6s32");

var $7e6Rg = parcelRequire("7e6Rg");

var $d0hS6 = parcelRequire("d0hS6");

var $biB4f = parcelRequire("biB4f");


var $aIJrd = parcelRequire("aIJrd");

var $fVNJ1 = parcelRequire("fVNJ1");

var $27v2x = parcelRequire("27v2x");

var $lwgYO = parcelRequire("lwgYO");
function $fb56d120ad8e2c59$export$6fcff0dc60346367(rect, vertical) {
    var offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $fb56d120ad8e2c59$export$a6a488ff68b1bf7b(rect, horizontal) {
    var offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $fb56d120ad8e2c59$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map(function(n) {
        return typeof n === 'number' ? "".concat(n, "px") : n;
    }).join(' ');
} // Sum the scrollTop between two elements.
function $fb56d120ad8e2c59$var$getScrollParent(parent, child) {
    var element = child;
    var scrollTop = 0;
    while(element && element !== parent){
        element = element.parentElement;
        scrollTop += element.scrollTop;
    }
    return scrollTop;
}
function $fb56d120ad8e2c59$var$getAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
var $fb56d120ad8e2c59$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {},
    /* Styles applied to the `Paper` component. */ paper: {
        position: 'absolute',
        overflowY: 'auto',
        overflowX: 'hidden',
        // So we see the popover when it's empty.
        // It's most likely on issue on userland.
        minWidth: 16,
        minHeight: 16,
        maxWidth: 'calc(100% - 32px)',
        maxHeight: 'calc(100% - 32px)',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }
};
var $fb56d120ad8e2c59$var$Popover = /*#__PURE__*/ $ieT14.forwardRef(function Popover(props, ref) {
    var action = props.action, anchorEl = props.anchorEl, _props$anchorOrigin = props.anchorOrigin, anchorOrigin = _props$anchorOrigin === void 0 ? {
        vertical: 'top',
        horizontal: 'left'
    } : _props$anchorOrigin, anchorPosition = props.anchorPosition, _props$anchorReferenc = props.anchorReference, anchorReference = _props$anchorReferenc === void 0 ? 'anchorEl' : _props$anchorReferenc, children = props.children, classes = props.classes, className = props.className, containerProp = props.container, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 8 : _props$elevation, getContentAnchorEl = props.getContentAnchorEl, _props$marginThreshol = props.marginThreshold, marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, _props$transformOrigi = props.transformOrigin, transformOrigin = _props$transformOrigi === void 0 ? {
        vertical: 'top',
        horizontal: 'left'
    } : _props$transformOrigi, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $27v2x.default) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura, _props$TransitionProp = props.TransitionProps, TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp, other = (0, $eTwGP.default)(props, [
        "action",
        "anchorEl",
        "anchorOrigin",
        "anchorPosition",
        "anchorReference",
        "children",
        "classes",
        "className",
        "container",
        "elevation",
        "getContentAnchorEl",
        "marginThreshold",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "open",
        "PaperProps",
        "transformOrigin",
        "TransitionComponent",
        "transitionDuration",
        "TransitionProps"
    ]);
    var paperRef = $ieT14.useRef(); // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    var getAnchorOffset = $ieT14.useCallback(function(contentAnchorOffset) {
        if (anchorReference === 'anchorPosition') return anchorPosition;
        var resolvedAnchorEl = $fb56d120ad8e2c59$var$getAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover
        var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $7e6Rg.default)(paperRef.current).body;
        var anchorRect = anchorElement.getBoundingClientRect();
        var box;
        var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
        return {
            top: anchorRect.top + $fb56d120ad8e2c59$export$6fcff0dc60346367(anchorRect, anchorVertical),
            left: anchorRect.left + $fb56d120ad8e2c59$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]); // Returns the vertical offset of inner content to anchor the transform on if provided
    var getContentAnchorOffset = $ieT14.useCallback(function(element) {
        var contentAnchorOffset = 0;
        if (getContentAnchorEl && anchorReference === 'anchorEl') {
            var contentAnchorEl = getContentAnchorEl(element);
            if (contentAnchorEl && element.contains(contentAnchorEl)) {
                var scrollTop = $fb56d120ad8e2c59$var$getScrollParent(element, contentAnchorEl);
                contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
            } // != the default value
        }
        return contentAnchorOffset;
    }, [
        anchorOrigin.vertical,
        anchorReference,
        getContentAnchorEl
    ]); // Return the base transform origin using the element
    // and taking the content anchor offset into account if in use
    var getTransformOrigin = $ieT14.useCallback(function(elemRect) {
        var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return {
            vertical: $fb56d120ad8e2c59$export$6fcff0dc60346367(elemRect, transformOrigin.vertical) + contentAnchorOffset,
            horizontal: $fb56d120ad8e2c59$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    var getPositioningStyle = $ieT14.useCallback(function(element) {
        // Check if the parent has requested anchoring on an inner content node
        var contentAnchorOffset = getContentAnchorOffset(element);
        var elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        }; // Get the transform origin point on the element itself
        var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $fb56d120ad8e2c59$var$getTransformOriginValue(elemTransformOrigin)
        };
         // Get the offset of of the anchoring element
        var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning
        var top = anchorOffset.top - elemTransformOrigin.vertical;
        var left = anchorOffset.left - elemTransformOrigin.horizontal;
        var bottom = top + elemRect.height;
        var right = left + elemRect.width; // Use the parent window of the anchorEl if provided
        var containerWindow = (0, $d0hS6.default)($fb56d120ad8e2c59$var$getAnchorEl(anchorEl)); // Window thresholds taking required margin into account
        var heightThreshold = containerWindow.innerHeight - marginThreshold;
        var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting
        if (top < marginThreshold) {
            var diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (bottom > heightThreshold) {
            var _diff = bottom - heightThreshold;
            top -= _diff;
            elemTransformOrigin.vertical += _diff;
        }
        if (left < marginThreshold) {
            var _diff2 = left - marginThreshold;
            left -= _diff2;
            elemTransformOrigin.horizontal += _diff2;
        } else if (right > widthThreshold) {
            var _diff3 = right - widthThreshold;
            left -= _diff3;
            elemTransformOrigin.horizontal += _diff3;
        }
        return {
            top: "".concat(Math.round(top), "px"),
            left: "".concat(Math.round(left), "px"),
            transformOrigin: $fb56d120ad8e2c59$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getContentAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    var setPositioningStyles = $ieT14.useCallback(function() {
        var element = paperRef.current;
        if (!element) return;
        var positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
    }, [
        getPositioningStyle
    ]);
    var handleEntering = function handleEntering(element, isAppearing) {
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    var handlePaperRef = $ieT14.useCallback(function(instance) {
        // #StrictMode ready
        paperRef.current = $3tOoB.findDOMNode(instance);
    }, []);
    $ieT14.useEffect(function() {
        if (open) setPositioningStyles();
    });
    $ieT14.useImperativeHandle(action, function() {
        return open ? {
            updatePosition: function updatePosition() {
                setPositioningStyles();
            }
        } : null;
    }, [
        open,
        setPositioningStyles
    ]);
    $ieT14.useEffect(function() {
        if (!open) return undefined;
        var handleResize = (0, $hJtzf.default)(function() {
            setPositioningStyles();
        });
        window.addEventListener('resize', handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener('resize', handleResize);
        };
    }, [
        open,
        setPositioningStyles
    ]);
    var transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
     // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    var container = containerProp || (anchorEl ? (0, $7e6Rg.default)($fb56d120ad8e2c59$var$getAnchorEl(anchorEl)).body : undefined);
    return /*#__PURE__*/ $ieT14.createElement((0, $fVNJ1.default), (0, $edxsd.default)({
        container: container,
        open: open,
        ref: ref,
        BackdropProps: {
            invisible: true
        },
        className: (0, $j6s32.default)(classes.root, className)
    }, other), /*#__PURE__*/ $ieT14.createElement(TransitionComponent, (0, $edxsd.default)({
        appear: true,
        in: open,
        onEnter: onEnter,
        onEntered: onEntered,
        onExit: onExit,
        onExited: onExited,
        onExiting: onExiting,
        timeout: transitionDuration
    }, TransitionProps, {
        onEntering: (0, $biB4f.default)(handleEntering, TransitionProps.onEntering)
    }), /*#__PURE__*/ $ieT14.createElement((0, $lwgYO.default), (0, $edxsd.default)({
        elevation: elevation,
        ref: handlePaperRef
    }, PaperProps, {
        className: (0, $j6s32.default)(classes.paper, PaperProps.className)
    }), children)));
});
var $fb56d120ad8e2c59$export$2e2bcd8739ae039 = (0, $aIJrd.default)($fb56d120ad8e2c59$export$9dd6ff9ea0189349, {
    name: 'MuiPopover'
})($fb56d120ad8e2c59$var$Popover);

});
parcelRegister("hJtzf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce8d932117759d6f$export$2e2bcd8739ae039; });
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $ce8d932117759d6f$export$2e2bcd8739ae039(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
    var timeout;
    function debounced() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        // eslint-disable-next-line consistent-this
        var that = this;
        var later = function later() {
            func.apply(that, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = function() {
        clearTimeout(timeout);
    };
    return debounced;
}

});

parcelRegister("7e6Rg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $542f29175629069a$export$2e2bcd8739ae039; });
function $542f29175629069a$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});

parcelRegister("d0hS6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9779235b31c64344$export$2e2bcd8739ae039; });

var $7e6Rg = parcelRequire("7e6Rg");
function $9779235b31c64344$export$2e2bcd8739ae039(node) {
    var doc = (0, $7e6Rg.default)(node);
    return doc.defaultView || window;
}

});

parcelRegister("biB4f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $839e20f8729cd452$export$2e2bcd8739ae039; });
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $839e20f8729cd452$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    return funcs.reduce(function(acc, func) {
        if (func == null) return acc;
        return function chainedFunction() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, function() {});
}

});

parcelRegister("fVNJ1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b992c0486efc94fb$export$2e2bcd8739ae039; });

var $eTwGP = parcelRequire("eTwGP");

var $edxsd = parcelRequire("edxsd");

var $ieT14 = parcelRequire("ieT14");

var $3tOoB = parcelRequire("3tOoB");


var $bKHfy = parcelRequire("bKHfy");
var $kfQ2O = parcelRequire("kfQ2O");



var $7e6Rg = parcelRequire("7e6Rg");

var $lVvVc = parcelRequire("lVvVc");

var $biB4f = parcelRequire("biB4f");

var $3A1Xf = parcelRequire("3A1Xf");

var $N8hF2 = parcelRequire("N8hF2");

var $7fkth = parcelRequire("7fkth");

var $5MUU3 = parcelRequire("5MUU3");

var $6mTME = parcelRequire("6mTME");

var $hzHpr = parcelRequire("hzHpr");
function $b992c0486efc94fb$var$getContainer(container) {
    container = typeof container === 'function' ? container() : container;
    return $3tOoB.findDOMNode(container);
}
function $b992c0486efc94fb$var$getHasTransition(props) {
    return props.children ? props.children.props.hasOwnProperty('in') : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
var $b992c0486efc94fb$var$defaultManager = new (0, $5MUU3.default)();
var $b992c0486efc94fb$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: 'fixed',
            zIndex: theme.zIndex.modal,
            right: 0,
            bottom: 0,
            top: 0,
            left: 0
        },
        /* Styles applied to the root element if the `Modal` has exited. */ hidden: {
            visibility: 'hidden'
        }
    };
};
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ var $b992c0486efc94fb$var$Modal = /*#__PURE__*/ $ieT14.forwardRef(function Modal(inProps, ref) {
    var theme = (0, $kfQ2O.default)();
    var props = (0, $bKHfy.default)({
        name: 'MuiModal',
        props: (0, $edxsd.default)({}, inProps),
        theme: theme
    });
    var _props$BackdropCompon = props.BackdropComponent, BackdropComponent = _props$BackdropCompon === void 0 ? (0, $hzHpr.default) : _props$BackdropCompon, BackdropProps = props.BackdropProps, children = props.children, _props$closeAfterTran = props.closeAfterTransition, closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran, container = props.container, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableBackdro = props.disableBackdropClick, disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableEscapeK = props.disableEscapeKeyDown, disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, _props$disableScrollL = props.disableScrollLock, disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL, _props$hideBackdrop = props.hideBackdrop, hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop, _props$keepMounted = props.keepMounted, keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted, _props$manager = props.manager, manager = _props$manager === void 0 ? $b992c0486efc94fb$var$defaultManager : _props$manager, onBackdropClick = props.onBackdropClick, onClose = props.onClose, onEscapeKeyDown = props.onEscapeKeyDown, onRendered = props.onRendered, open = props.open, other = (0, $eTwGP.default)(props, [
        "BackdropComponent",
        "BackdropProps",
        "children",
        "closeAfterTransition",
        "container",
        "disableAutoFocus",
        "disableBackdropClick",
        "disableEnforceFocus",
        "disableEscapeKeyDown",
        "disablePortal",
        "disableRestoreFocus",
        "disableScrollLock",
        "hideBackdrop",
        "keepMounted",
        "manager",
        "onBackdropClick",
        "onClose",
        "onEscapeKeyDown",
        "onRendered",
        "open"
    ]);
    var _React$useState = $ieT14.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
    var modal = $ieT14.useRef({});
    var mountNodeRef = $ieT14.useRef(null);
    var modalRef = $ieT14.useRef(null);
    var handleRef = (0, $3A1Xf.default)(modalRef, ref);
    var hasTransition = $b992c0486efc94fb$var$getHasTransition(props);
    var getDoc = function getDoc() {
        return (0, $7e6Rg.default)(mountNodeRef.current);
    };
    var getModal = function getModal() {
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    var handleMounted = function handleMounted() {
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        }); // Fix a bug on Chrome where the scroll isn't initially 0.
        modalRef.current.scrollTop = 0;
    };
    var handleOpen = (0, $N8hF2.default)(function() {
        var resolvedContainer = $b992c0486efc94fb$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer); // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    var isTopModal = $ieT14.useCallback(function() {
        return manager.isTopModal(getModal());
    }, [
        manager
    ]);
    var handlePortalRef = (0, $N8hF2.default)(function(node) {
        mountNodeRef.current = node;
        if (!node) return;
        if (onRendered) onRendered();
        if (open && isTopModal()) handleMounted();
        else (0, $5MUU3.ariaHidden)(modalRef.current, true);
    });
    var handleClose = $ieT14.useCallback(function() {
        manager.remove(getModal());
    }, [
        manager
    ]);
    $ieT14.useEffect(function() {
        return function() {
            handleClose();
        };
    }, [
        handleClose
    ]);
    $ieT14.useEffect(function() {
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    var handleEnter = function handleEnter() {
        setExited(false);
    };
    var handleExited = function handleExited() {
        setExited(true);
        if (closeAfterTransition) handleClose();
    };
    var handleBackdropClick = function handleBackdropClick(event) {
        if (event.target !== event.currentTarget) return;
        if (onBackdropClick) onBackdropClick(event);
        if (!disableBackdropClick && onClose) onClose(event, 'backdropClick');
    };
    var handleKeyDown = function handleKeyDown(event) {
        // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviours like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== 'Escape' || !isTopModal()) return;
        if (onEscapeKeyDown) onEscapeKeyDown(event);
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) onClose(event, 'escapeKeyDown');
        }
    };
    var inlineStyle = $b992c0486efc94fb$export$9dd6ff9ea0189349(theme || {
        zIndex: (0, $7fkth.default)
    });
    var childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = children.props.tabIndex || '-1';
     // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, $biB4f.default)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, $biB4f.default)(handleExited, children.props.onExited);
    }
    return /*#__PURE__*/ $ieT14.createElement((0, $lVvVc.default), {
        ref: handlePortalRef,
        container: container,
        disablePortal: disablePortal
    }, /*#__PURE__*/ $ieT14.createElement("div", (0, $edxsd.default)({
        ref: handleRef,
        onKeyDown: handleKeyDown,
        role: "presentation"
    }, other, {
        style: (0, $edxsd.default)({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
    }), hideBackdrop ? null : /*#__PURE__*/ $ieT14.createElement(BackdropComponent, (0, $edxsd.default)({
        open: open,
        onClick: handleBackdropClick
    }, BackdropProps)), /*#__PURE__*/ $ieT14.createElement((0, $6mTME.default), {
        disableEnforceFocus: disableEnforceFocus,
        disableAutoFocus: disableAutoFocus,
        disableRestoreFocus: disableRestoreFocus,
        getDoc: getDoc,
        isEnabled: isTopModal,
        open: open
    }, /*#__PURE__*/ $ieT14.cloneElement(children, childProps))));
});
var $b992c0486efc94fb$export$2e2bcd8739ae039 = $b992c0486efc94fb$var$Modal;

});
parcelRegister("lVvVc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff67aed25ad438b3$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");

var $3tOoB = parcelRequire("3tOoB");




var $kC3Zv = parcelRequire("kC3Zv");

var $3A1Xf = parcelRequire("3A1Xf");
function $ff67aed25ad438b3$var$getContainer(container) {
    container = typeof container === 'function' ? container() : container; // #StrictMode ready
    return $3tOoB.findDOMNode(container);
}
var $ff67aed25ad438b3$var$useEnhancedEffect = typeof window !== 'undefined' ? $ieT14.useLayoutEffect : $ieT14.useEffect;
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */ var $ff67aed25ad438b3$var$Portal = /*#__PURE__*/ $ieT14.forwardRef(function Portal(props, ref) {
    var children = props.children, container = props.container, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, onRendered = props.onRendered;
    var _React$useState = $ieT14.useState(null), mountNode = _React$useState[0], setMountNode = _React$useState[1];
    var handleRef = (0, $3A1Xf.default)(/*#__PURE__*/ $ieT14.isValidElement(children) ? children.ref : null, ref);
    $ff67aed25ad438b3$var$useEnhancedEffect(function() {
        if (!disablePortal) setMountNode($ff67aed25ad438b3$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    $ff67aed25ad438b3$var$useEnhancedEffect(function() {
        if (mountNode && !disablePortal) {
            (0, $kC3Zv.default)(ref, mountNode);
            return function() {
                (0, $kC3Zv.default)(ref, null);
            };
        }
        return undefined;
    }, [
        ref,
        mountNode,
        disablePortal
    ]);
    $ff67aed25ad438b3$var$useEnhancedEffect(function() {
        if (onRendered && (mountNode || disablePortal)) onRendered();
    }, [
        onRendered,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $ieT14.isValidElement(children)) return /*#__PURE__*/ $ieT14.cloneElement(children, {
            ref: handleRef
        });
        return children;
    }
    return mountNode ? /*#__PURE__*/ $3tOoB.createPortal(children, mountNode) : mountNode;
});
var $ff67aed25ad438b3$export$2e2bcd8739ae039 = $ff67aed25ad438b3$var$Portal;

});

parcelRegister("5MUU3", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", function () { return $436d933cf89cecaa$export$e1bd0c6150f13d96; });
$parcel$export(module.exports, "default", function () { return $436d933cf89cecaa$export$2e2bcd8739ae039; });

var $iVqsp = parcelRequire("iVqsp");

var $kpKMr = parcelRequire("kpKMr");

var $83KOU = parcelRequire("83KOU");

var $2vUN7 = parcelRequire("2vUN7");

var $7e6Rg = parcelRequire("7e6Rg");

var $d0hS6 = parcelRequire("d0hS6");
function $436d933cf89cecaa$var$isOverflowing(container) {
    var doc = (0, $7e6Rg.default)(container);
    if (doc.body === container) return (0, $d0hS6.default)(doc).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $436d933cf89cecaa$export$e1bd0c6150f13d96(node, show) {
    if (show) node.setAttribute('aria-hidden', 'true');
    else node.removeAttribute('aria-hidden');
}
function $436d933cf89cecaa$var$getPaddingRight(node) {
    return parseInt(window.getComputedStyle(node)['padding-right'], 10) || 0;
}
function $436d933cf89cecaa$var$ariaHiddenSiblings(container, mountNode, currentNode) {
    var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var show = arguments.length > 4 ? arguments[4] : undefined;
    var blacklist = [
        mountNode,
        currentNode
    ].concat((0, $83KOU.default)(nodesToExclude));
    var blacklistTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE'
    ];
    [].forEach.call(container.children, function(node) {
        if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) $436d933cf89cecaa$export$e1bd0c6150f13d96(node, show);
    });
}
function $436d933cf89cecaa$var$findIndexOf(containerInfo, callback) {
    var idx = -1;
    containerInfo.some(function(item, index) {
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $436d933cf89cecaa$var$handleContainer(containerInfo, props) {
    var restoreStyle = [];
    var restorePaddings = [];
    var container = containerInfo.container;
    var fixedNodes;
    if (!props.disableScrollLock) {
        if ($436d933cf89cecaa$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            var scrollbarSize = (0, $2vUN7.default)();
            restoreStyle.push({
                value: container.style.paddingRight,
                key: 'padding-right',
                el: container
            }); // Use computed style, here to get the real padding to add our scrollbar width.
            container.style['padding-right'] = "".concat($436d933cf89cecaa$var$getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.
            fixedNodes = (0, $7e6Rg.default)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedNodes, function(node) {
                restorePaddings.push(node.style.paddingRight);
                node.style.paddingRight = "".concat($436d933cf89cecaa$var$getPaddingRight(node) + scrollbarSize, "px");
            });
        } // Improve Gatsby support
        // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
        var parent = container.parentElement;
        var scrollContainer = parent.nodeName === 'HTML' && window.getComputedStyle(parent)['overflow-y'] === 'scroll' ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            key: 'overflow',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    var restore = function restore() {
        if (fixedNodes) [].forEach.call(fixedNodes, function(node, i) {
            if (restorePaddings[i]) node.style.paddingRight = restorePaddings[i];
            else node.style.removeProperty('padding-right');
        });
        restoreStyle.forEach(function(_ref) {
            var value = _ref.value, el = _ref.el, key = _ref.key;
            if (value) el.style.setProperty(key, value);
            else el.style.removeProperty(key);
        });
    };
    return restore;
}
function $436d933cf89cecaa$var$getHiddenSiblings(container) {
    var hiddenSiblings = [];
    [].forEach.call(container.children, function(node) {
        if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(node);
    });
    return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */ var $436d933cf89cecaa$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ModalManager() {
        (0, $iVqsp.default)(this, ModalManager);
        // this.modals[modalIndex] = modal
        this.modals = []; // this.containers[containerIndex] = {
        //   modals: [],
        //   container,
        //   restore: null,
        // }
        this.containers = [];
    }
    (0, $kpKMr.default)(ModalManager, [
        {
            key: "add",
            value: function add(modal, container) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex !== -1) return modalIndex;
                modalIndex = this.modals.length;
                this.modals.push(modal); // If the modal we are adding is already in the DOM.
                if (modal.modalRef) $436d933cf89cecaa$export$e1bd0c6150f13d96(modal.modalRef, false);
                var hiddenSiblingNodes = $436d933cf89cecaa$var$getHiddenSiblings(container);
                $436d933cf89cecaa$var$ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
                var containerIndex = $436d933cf89cecaa$var$findIndexOf(this.containers, function(item) {
                    return item.container === container;
                });
                if (containerIndex !== -1) {
                    this.containers[containerIndex].modals.push(modal);
                    return modalIndex;
                }
                this.containers.push({
                    modals: [
                        modal
                    ],
                    container: container,
                    restore: null,
                    hiddenSiblingNodes: hiddenSiblingNodes
                });
                return modalIndex;
            }
        },
        {
            key: "mount",
            value: function mount(modal, props) {
                var containerIndex = $436d933cf89cecaa$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                if (!containerInfo.restore) containerInfo.restore = $436d933cf89cecaa$var$handleContainer(containerInfo, props);
            }
        },
        {
            key: "remove",
            value: function remove(modal) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex === -1) return modalIndex;
                var containerIndex = $436d933cf89cecaa$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
                this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.
                if (containerInfo.modals.length === 0) {
                    // The modal might be closed before it had the chance to be mounted in the DOM.
                    if (containerInfo.restore) containerInfo.restore();
                    if (modal.modalRef) // In case the modal wasn't in the DOM yet.
                    $436d933cf89cecaa$export$e1bd0c6150f13d96(modal.modalRef, true);
                    $436d933cf89cecaa$var$ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
                    this.containers.splice(containerIndex, 1);
                } else {
                    // Otherwise make sure the next top modal is visible to a screen reader.
                    var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
                    // aria-hidden because the dom element doesn't exist either
                    // when modal was unmounted before modalRef gets null
                    if (nextTop.modalRef) $436d933cf89cecaa$export$e1bd0c6150f13d96(nextTop.modalRef, false);
                }
                return modalIndex;
            }
        },
        {
            key: "isTopModal",
            value: function isTopModal(modal) {
                return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
            }
        }
    ]);
    return ModalManager;
}();

});
parcelRegister("iVqsp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc7212b33222a940$export$2e2bcd8739ae039; });
function $dc7212b33222a940$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("kpKMr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edca6e06c54227b6$export$2e2bcd8739ae039; });

var $kOL9i = parcelRequire("kOL9i");
function $edca6e06c54227b6$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $kOL9i.default)(o.key), o);
    }
}
function $edca6e06c54227b6$export$2e2bcd8739ae039(e, r, t) {
    return r && $edca6e06c54227b6$var$_defineProperties(e.prototype, r), t && $edca6e06c54227b6$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("2vUN7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d4a878fa470ba64$export$2e2bcd8739ae039; });
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
function $1d4a878fa470ba64$export$2e2bcd8739ae039() {
    var scrollDiv = document.createElement('div');
    scrollDiv.style.width = '99px';
    scrollDiv.style.height = '99px';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    scrollDiv.style.overflow = 'scroll';
    document.body.appendChild(scrollDiv);
    var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarSize;
}

});


parcelRegister("6mTME", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a3011a0ea130bca$export$2e2bcd8739ae039; });
/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex, camelcase */ 
var $ieT14 = parcelRequire("ieT14");

var $3tOoB = parcelRequire("3tOoB");


var $7e6Rg = parcelRequire("7e6Rg");

var $3A1Xf = parcelRequire("3A1Xf");

/**
 * Utility component that locks focus inside the component.
 */ function $4a3011a0ea130bca$var$Unstable_TrapFocus(props) {
    var children = props.children, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, getDoc = props.getDoc, isEnabled = props.isEnabled, open = props.open;
    var ignoreNextEnforceFocus = $ieT14.useRef();
    var sentinelStart = $ieT14.useRef(null);
    var sentinelEnd = $ieT14.useRef(null);
    var nodeToRestore = $ieT14.useRef();
    var rootRef = $ieT14.useRef(null); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $ieT14.useCallback(function(instance) {
        // #StrictMode ready
        rootRef.current = $3tOoB.findDOMNode(instance);
    }, []);
    var handleRef = (0, $3A1Xf.default)(children.ref, handleOwnRef);
    var prevOpenRef = $ieT14.useRef();
    $ieT14.useEffect(function() {
        prevOpenRef.current = open;
    }, [
        open
    ]);
    if (!prevOpenRef.current && open && typeof window !== 'undefined') // WARNING: Potentially unsafe in concurrent mode.
    // The way the read on `nodeToRestore` is setup could make this actually safe.
    // Say we render `open={false}` -> `open={true}` but never commit.
    // We have now written a state that wasn't committed. But no committed effect
    // will read this wrong value. We only read from `nodeToRestore` in effects
    // that were committed on `open={true}`
    // WARNING: Prevents the instance from being garbage collected. Should only
    // hold a weak ref.
    nodeToRestore.current = getDoc().activeElement;
    $ieT14.useEffect(function() {
        if (!open) return;
        var doc = (0, $7e6Rg.default)(rootRef.current); // We might render an empty child.
        if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', -1);
            rootRef.current.focus();
        }
        var contain = function contain() {
            var rootElement = rootRef.current; // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (rootRef.current && !rootRef.current.contains(doc.activeElement)) rootRef.current.focus();
        };
        var loopFocus = function loopFocus(event) {
            // 9 = Tab
            if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) return;
             // Make sure the next tab starts from the right place.
            if (doc.activeElement === rootRef.current) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (event.shiftKey) sentinelEnd.current.focus();
                else sentinelStart.current.focus();
            }
        };
        doc.addEventListener('focus', contain, true);
        doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        var interval = setInterval(function() {
            contain();
        }, 50);
        return function() {
            clearInterval(interval);
            doc.removeEventListener('focus', contain, true);
            doc.removeEventListener('keydown', loopFocus, true); // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE 11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE 11 have a focus method.
                // Once IE 11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) nodeToRestore.current.focus();
                nodeToRestore.current = null;
            }
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open
    ]);
    return /*#__PURE__*/ $ieT14.createElement($ieT14.Fragment, null, /*#__PURE__*/ $ieT14.createElement("div", {
        tabIndex: 0,
        ref: sentinelStart,
        "data-test": "sentinelStart"
    }), /*#__PURE__*/ $ieT14.cloneElement(children, {
        ref: handleRef
    }), /*#__PURE__*/ $ieT14.createElement("div", {
        tabIndex: 0,
        ref: sentinelEnd,
        "data-test": "sentinelEnd"
    }));
}
var $4a3011a0ea130bca$export$2e2bcd8739ae039 = $4a3011a0ea130bca$var$Unstable_TrapFocus;

});

parcelRegister("hzHpr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccb760c297512a32$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");

var $ccb760c297512a32$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        zIndex: -1,
        position: 'fixed',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    },
    /* Styles applied to the root element if `invisible={true}`. */ invisible: {
        backgroundColor: 'transparent'
    }
};
/**
 * @ignore - internal component.
 */ var $ccb760c297512a32$var$SimpleBackdrop = /*#__PURE__*/ $ieT14.forwardRef(function SimpleBackdrop(props, ref) {
    var _props$invisible = props.invisible, invisible = _props$invisible === void 0 ? false : _props$invisible, open = props.open, other = (0, $eTwGP.default)(props, [
        "invisible",
        "open"
    ]);
    return open ? /*#__PURE__*/ $ieT14.createElement("div", (0, $edxsd.default)({
        "aria-hidden": true,
        ref: ref
    }, other, {
        style: (0, $edxsd.default)({}, $ccb760c297512a32$export$9dd6ff9ea0189349.root, invisible ? $ccb760c297512a32$export$9dd6ff9ea0189349.invisible : {}, other.style)
    })) : null;
});
var $ccb760c297512a32$export$2e2bcd8739ae039 = $ccb760c297512a32$var$SimpleBackdrop;

});


parcelRegister("27v2x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18b450187ec16767$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $dcIvM = parcelRequire("dcIvM");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $4XMe5 = parcelRequire("4XMe5");

var $hgPMF = parcelRequire("hgPMF");

var $1VWiP = parcelRequire("1VWiP");

var $3A1Xf = parcelRequire("3A1Xf");
function $18b450187ec16767$var$getScale(value) {
    return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}
var $18b450187ec16767$var$styles = {
    entering: {
        opacity: 1,
        transform: $18b450187ec16767$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $18b450187ec16767$var$Grow = /*#__PURE__*/ $ieT14.forwardRef(function Grow(props, ref) {
    var children = props.children, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? 'auto' : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $4XMe5.default) : _props$TransitionComp, other = (0, $eTwGP.default)(props, [
        "children",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var timer = $ieT14.useRef();
    var autoTimeout = $ieT14.useRef();
    var theme = (0, $hgPMF.default)();
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $ieT14.useRef(null);
    var foreignRef = (0, $3A1Xf.default)(children.ref, ref);
    var handleRef = (0, $3A1Xf.default)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $dcIvM.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        (0, $1VWiP.reflow)(node); // So the animation always start from the start.
        var _getTransitionProps = (0, $1VWiP.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: 'enter'
        }), transitionDuration = _getTransitionProps.duration, delay = _getTransitionProps.delay;
        var duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: duration * 0.666,
                delay: delay
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var _getTransitionProps2 = (0, $1VWiP.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: 'exit'
        }), transitionDuration = _getTransitionProps2.duration, delay = _getTransitionProps2.delay;
        var duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: duration * 0.666,
                delay: delay || duration * 0.333
            })
        ].join(',');
        node.style.opacity = '0';
        node.style.transform = $18b450187ec16767$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
        var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
        if (timeout === 'auto') timer.current = setTimeout(next, autoTimeout.current || 0);
    };
    $ieT14.useEffect(function() {
        return function() {
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ $ieT14.createElement(TransitionComponent, (0, $edxsd.default)({
        appear: true,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: addEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $ieT14.cloneElement(children, (0, $edxsd.default)({
            style: (0, $edxsd.default)({
                opacity: 0,
                transform: $18b450187ec16767$var$getScale(0.75),
                visibility: state === 'exited' && !inProp ? 'hidden' : undefined
            }, $18b450187ec16767$var$styles[state], style, children.props.style),
            ref: handleRef
        }, childProps));
    });
});
$18b450187ec16767$var$Grow.muiSupportAuto = true;
var $18b450187ec16767$export$2e2bcd8739ae039 = $18b450187ec16767$var$Grow;

});
parcelRegister("dcIvM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99ceec6b18b454d0$export$2e2bcd8739ae039; });

var $dYa6U = parcelRequire("dYa6U");

var $6UlSq = parcelRequire("6UlSq");

var $3aDwg = parcelRequire("3aDwg");

var $7YQUf = parcelRequire("7YQUf");
function $99ceec6b18b454d0$export$2e2bcd8739ae039(r, e) {
    return (0, $dYa6U.default)(r) || (0, $6UlSq.default)(r, e) || (0, $3aDwg.default)(r, e) || (0, $7YQUf.default)();
}

});
parcelRegister("dYa6U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2b8b8b321a24c64$export$2e2bcd8739ae039; });
function $a2b8b8b321a24c64$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("6UlSq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $014c45f500b5e160$export$2e2bcd8739ae039; });
function $014c45f500b5e160$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("7YQUf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5cf72d1414b5bab4$export$2e2bcd8739ae039; });
function $5cf72d1414b5bab4$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("4XMe5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39d214d88cb3540a$export$2e2bcd8739ae039; });

var $9YxmX = parcelRequire("9YxmX");

var $hsveB = parcelRequire("hsveB");


var $ieT14 = parcelRequire("ieT14");

var $3tOoB = parcelRequire("3tOoB");

var $dNwDy = parcelRequire("dNwDy");


var $hJXl0 = parcelRequire("hJXl0");

var $cMgtJ = parcelRequire("cMgtJ");
var $39d214d88cb3540a$export$bb38bb9a1161268 = 'unmounted';
var $39d214d88cb3540a$export$84cbff306f539230 = 'exited';
var $39d214d88cb3540a$export$df38205c966be359 = 'entering';
var $39d214d88cb3540a$export$78e9e6e3e014d60a = 'entered';
var $39d214d88cb3540a$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $39d214d88cb3540a$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $hsveB.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $39d214d88cb3540a$export$84cbff306f539230;
                _this.appearStatus = $39d214d88cb3540a$export$df38205c966be359;
            } else initialStatus = $39d214d88cb3540a$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $39d214d88cb3540a$export$bb38bb9a1161268;
        else initialStatus = $39d214d88cb3540a$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $39d214d88cb3540a$export$bb38bb9a1161268) return {
            status: $39d214d88cb3540a$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $39d214d88cb3540a$export$df38205c966be359 && status !== $39d214d88cb3540a$export$78e9e6e3e014d60a) nextStatus = $39d214d88cb3540a$export$df38205c966be359;
            } else if (status === $39d214d88cb3540a$export$df38205c966be359 || status === $39d214d88cb3540a$export$78e9e6e3e014d60a) nextStatus = $39d214d88cb3540a$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $39d214d88cb3540a$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($3tOoB))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $cMgtJ.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $39d214d88cb3540a$export$84cbff306f539230) this.setState({
            status: $39d214d88cb3540a$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($3tOoB))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $dNwDy.default).disabled) {
            this.safeSetState({
                status: $39d214d88cb3540a$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $39d214d88cb3540a$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $39d214d88cb3540a$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($3tOoB))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $dNwDy.default).disabled) {
            this.safeSetState({
                status: $39d214d88cb3540a$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $39d214d88cb3540a$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $39d214d88cb3540a$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($3tOoB))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $39d214d88cb3540a$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $9YxmX.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement((0, $hJXl0.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).Component);
$39d214d88cb3540a$var$Transition.contextType = (0, $hJXl0.default);
$39d214d88cb3540a$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $39d214d88cb3540a$var$noop() {}
$39d214d88cb3540a$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $39d214d88cb3540a$var$noop,
    onEntering: $39d214d88cb3540a$var$noop,
    onEntered: $39d214d88cb3540a$var$noop,
    onExit: $39d214d88cb3540a$var$noop,
    onExiting: $39d214d88cb3540a$var$noop,
    onExited: $39d214d88cb3540a$var$noop
};
$39d214d88cb3540a$var$Transition.UNMOUNTED = $39d214d88cb3540a$export$bb38bb9a1161268;
$39d214d88cb3540a$var$Transition.EXITED = $39d214d88cb3540a$export$84cbff306f539230;
$39d214d88cb3540a$var$Transition.ENTERING = $39d214d88cb3540a$export$df38205c966be359;
$39d214d88cb3540a$var$Transition.ENTERED = $39d214d88cb3540a$export$78e9e6e3e014d60a;
$39d214d88cb3540a$var$Transition.EXITING = $39d214d88cb3540a$export$4aacc83d4d59139f;
var $39d214d88cb3540a$export$2e2bcd8739ae039 = $39d214d88cb3540a$var$Transition;

});
parcelRegister("dNwDy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0b92af83e69aff9$export$2e2bcd8739ae039; });
var $a0b92af83e69aff9$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("cMgtJ", function(module, exports) {

$parcel$export(module.exports, "forceReflow", function () { return $94d6c00025212d9c$export$7d26bbb1236dafd6; });
var $94d6c00025212d9c$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("hgPMF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c92c198217b80308$export$2e2bcd8739ae039; });

var $kfQ2O = parcelRequire("kfQ2O");
parcelRequire("ieT14");

var $kkrWC = parcelRequire("kkrWC");
function $c92c198217b80308$export$2e2bcd8739ae039() {
    var theme = (0, $kfQ2O.default)() || (0, $kkrWC.default);
    return theme;
}

});

parcelRegister("1VWiP", function(module, exports) {

$parcel$export(module.exports, "reflow", function () { return $16885706d9410dc7$export$b7a864e1eaef9de5; });
$parcel$export(module.exports, "getTransitionProps", function () { return $16885706d9410dc7$export$8cb1e9b404609ae9; });
var $16885706d9410dc7$export$b7a864e1eaef9de5 = function reflow(node) {
    return node.scrollTop;
};
function $16885706d9410dc7$export$8cb1e9b404609ae9(props, options) {
    var timeout = props.timeout, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style;
    return {
        duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        delay: style.transitionDelay
    };
}

});


parcelRegister("lwgYO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $faa9c1f387096845$export$2e2bcd8739ae039; });

var $eTwGP = parcelRequire("eTwGP");

var $edxsd = parcelRequire("edxsd");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");


var $aIJrd = parcelRequire("aIJrd");
var $faa9c1f387096845$export$9dd6ff9ea0189349 = function styles(theme) {
    var elevations = {};
    theme.shadows.forEach(function(shadow, index) {
        elevations["elevation".concat(index)] = {
            boxShadow: shadow
        };
    });
    return (0, $edxsd.default)({
        /* Styles applied to the root element. */ root: {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            transition: theme.transitions.create('box-shadow')
        },
        /* Styles applied to the root element if `square={false}`. */ rounded: {
            borderRadius: theme.shape.borderRadius
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            border: "1px solid ".concat(theme.palette.divider)
        }
    }, elevations);
};
var $faa9c1f387096845$var$Paper = /*#__PURE__*/ $ieT14.forwardRef(function Paper(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$square = props.square, square = _props$square === void 0 ? false : _props$square, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 1 : _props$elevation, _props$variant = props.variant, variant = _props$variant === void 0 ? 'elevation' : _props$variant, other = (0, $eTwGP.default)(props, [
        "classes",
        "className",
        "component",
        "square",
        "elevation",
        "variant"
    ]);
    return /*#__PURE__*/ $ieT14.createElement(Component, (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className, variant === 'outlined' ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
        ref: ref
    }, other));
});
var $faa9c1f387096845$export$2e2bcd8739ae039 = (0, $aIJrd.default)($faa9c1f387096845$export$9dd6ff9ea0189349, {
    name: 'MuiPaper'
})($faa9c1f387096845$var$Paper);

});


parcelRegister("bZlCc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ba6288a9253bd1a$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");
parcelRequire("fqwRx");


var $3tOoB = parcelRequire("3tOoB");

var $7e6Rg = parcelRequire("7e6Rg");

var $dxqtw = parcelRequire("dxqtw");

var $2vUN7 = parcelRequire("2vUN7");

var $3A1Xf = parcelRequire("3A1Xf");
function $8ba6288a9253bd1a$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $8ba6288a9253bd1a$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $8ba6288a9253bd1a$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    var text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function $8ba6288a9253bd1a$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    var wrappedOnce = false;
    var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        } // Same logic as useAutocomplete.js
        var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$8ba6288a9253bd1a$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return;
        }
    }
}
var $8ba6288a9253bd1a$var$useEnhancedEffect = typeof window === 'undefined' ? $ieT14.useEffect : $ieT14.useLayoutEffect;
/**
 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
 * It's exposed to help customization of the [`Menu`](/api/menu/) component. If you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ var $8ba6288a9253bd1a$var$MenuList = /*#__PURE__*/ $ieT14.forwardRef(function MenuList(props, ref) {
    var actions = props.actions, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$autoFocusItem = props.autoFocusItem, autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem, children = props.children, className = props.className, _props$disabledItemsF = props.disabledItemsFocusable, disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF, _props$disableListWra = props.disableListWrap, disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra, onKeyDown = props.onKeyDown, _props$variant = props.variant, variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant, other = (0, $eTwGP.default)(props, [
        "actions",
        "autoFocus",
        "autoFocusItem",
        "children",
        "className",
        "disabledItemsFocusable",
        "disableListWrap",
        "onKeyDown",
        "variant"
    ]);
    var listRef = $ieT14.useRef(null);
    var textCriteriaRef = $ieT14.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    $8ba6288a9253bd1a$var$useEnhancedEffect(function() {
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $ieT14.useImperativeHandle(actions, function() {
        return {
            adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                var noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    var scrollbarSize = "".concat((0, $2vUN7.default)(true), "px");
                    listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
                }
                return listRef.current;
            }
        };
    }, []);
    var handleKeyDown = function handleKeyDown(event) {
        var list = listRef.current;
        var key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ var currentFocus = (0, $7e6Rg.default)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $8ba6288a9253bd1a$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $8ba6288a9253bd1a$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $8ba6288a9253bd1a$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $8ba6288a9253bd1a$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $8ba6288a9253bd1a$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $8ba6288a9253bd1a$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $8ba6288a9253bd1a$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $8ba6288a9253bd1a$var$previousItem);
        } else if (key.length === 1) {
            var criteria = textCriteriaRef.current;
            var lowerKey = key.toLowerCase();
            var currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            var keepFocusOnCurrent = currentFocus && !criteria.repeating && $8ba6288a9253bd1a$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $8ba6288a9253bd1a$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $8ba6288a9253bd1a$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    var handleOwnRef = $ieT14.useCallback(function(instance) {
        // #StrictMode ready
        listRef.current = $3tOoB.findDOMNode(instance);
    }, []);
    var handleRef = (0, $3A1Xf.default)(handleOwnRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $ieT14.Children.forEach(children, function(child, index) {
        if (!/*#__PURE__*/ $ieT14.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    var items = $ieT14.Children.map(children, function(child, index) {
        if (index === activeItemIndex) {
            var newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $ieT14.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ $ieT14.createElement((0, $dxqtw.default), (0, $edxsd.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other), items);
});
var $8ba6288a9253bd1a$export$2e2bcd8739ae039 = $8ba6288a9253bd1a$var$MenuList;

});
parcelRegister("dxqtw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9db2e4da7ae6f5c7$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $aIJrd = parcelRequire("aIJrd");

var $2Mf9x = parcelRequire("2Mf9x");
var $9db2e4da7ae6f5c7$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'relative'
    },
    /* Styles applied to the root element if `disablePadding={false}`. */ padding: {
        paddingTop: 8,
        paddingBottom: 8
    },
    /* Styles applied to the root element if dense. */ dense: {},
    /* Styles applied to the root element if a `subheader` is provided. */ subheader: {
        paddingTop: 0
    }
};
var $9db2e4da7ae6f5c7$var$List = /*#__PURE__*/ $ieT14.forwardRef(function List(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'ul' : _props$component, _props$dense = props.dense, dense = _props$dense === void 0 ? false : _props$dense, _props$disablePadding = props.disablePadding, disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding, subheader = props.subheader, other = (0, $eTwGP.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "dense",
        "disablePadding",
        "subheader"
    ]);
    var context = $ieT14.useMemo(function() {
        return {
            dense: dense
        };
    }, [
        dense
    ]);
    return /*#__PURE__*/ $ieT14.createElement((0, $2Mf9x.default).Provider, {
        value: context
    }, /*#__PURE__*/ $ieT14.createElement(Component, (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
        ref: ref
    }, other), subheader, children));
});
var $9db2e4da7ae6f5c7$export$2e2bcd8739ae039 = (0, $aIJrd.default)($9db2e4da7ae6f5c7$export$9dd6ff9ea0189349, {
    name: 'MuiList'
})($9db2e4da7ae6f5c7$var$List);

});



parcelRegister("3mOXj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $273af3e9247c2c9d$export$2e2bcd8739ae039; });

var $eTwGP = parcelRequire("eTwGP");

var $9p9Gy = parcelRequire("9p9Gy");

var $edxsd = parcelRequire("edxsd");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $aIJrd = parcelRequire("aIJrd");

var $1fCJg = parcelRequire("1fCJg");
var $273af3e9247c2c9d$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $edxsd.default)({}, theme.typography.body1, (0, $9p9Gy.default)({
            minHeight: 48,
            paddingTop: 6,
            paddingBottom: 6,
            boxSizing: 'border-box',
            width: 'auto',
            overflow: 'hidden',
            whiteSpace: 'nowrap'
        }, theme.breakpoints.up('sm'), {
            minHeight: 'auto'
        })),
        // TODO v5: remove
        /* Styles applied to the root element if `disableGutters={false}`. */ gutters: {},
        /* Styles applied to the root element if `selected={true}`. */ selected: {},
        /* Styles applied to the root element if dense. */ dense: (0, $edxsd.default)({}, theme.typography.body2, {
            minHeight: 'auto'
        })
    };
};
var $273af3e9247c2c9d$var$MenuItem = /*#__PURE__*/ $ieT14.forwardRef(function MenuItem(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? 'li' : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, ListItemClasses = props.ListItemClasses, _props$role = props.role, role = _props$role === void 0 ? 'menuitem' : _props$role, selected = props.selected, tabIndexProp = props.tabIndex, other = (0, $eTwGP.default)(props, [
        "classes",
        "className",
        "component",
        "disableGutters",
        "ListItemClasses",
        "role",
        "selected",
        "tabIndex"
    ]);
    var tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ $ieT14.createElement((0, $1fCJg.default), (0, $edxsd.default)({
        button: true,
        role: role,
        tabIndex: tabIndex,
        component: component,
        selected: selected,
        disableGutters: disableGutters,
        classes: (0, $edxsd.default)({
            dense: classes.dense
        }, ListItemClasses),
        className: (0, $j6s32.default)(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
        ref: ref
    }, other));
});
var $273af3e9247c2c9d$export$2e2bcd8739ae039 = (0, $aIJrd.default)($273af3e9247c2c9d$export$9dd6ff9ea0189349, {
    name: 'MuiMenuItem'
})($273af3e9247c2c9d$var$MenuItem);

});
parcelRegister("1fCJg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e953befeee832b2$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");


var $aIJrd = parcelRequire("aIJrd");

var $51wR9 = parcelRequire("51wR9");

var $gX17d = parcelRequire("gX17d");

var $3A1Xf = parcelRequire("3A1Xf");

var $2Mf9x = parcelRequire("2Mf9x");

var $3tOoB = parcelRequire("3tOoB");
var $0e953befeee832b2$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */ root: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            position: 'relative',
            textDecoration: 'none',
            width: '100%',
            boxSizing: 'border-box',
            textAlign: 'left',
            paddingTop: 8,
            paddingBottom: 8,
            '&$focusVisible': {
                backgroundColor: theme.palette.action.selected
            },
            '&$selected, &$selected:hover': {
                backgroundColor: theme.palette.action.selected
            },
            '&$disabled': {
                opacity: 0.5
            }
        },
        /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */ container: {
            position: 'relative'
        },
        /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */ focusVisible: {},
        /* Styles applied to the `component` element if dense. */ dense: {
            paddingTop: 4,
            paddingBottom: 4
        },
        /* Styles applied to the `component` element if `alignItems="flex-start"`. */ alignItemsFlexStart: {
            alignItems: 'flex-start'
        },
        /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the inner `component` element if `divider={true}`. */ divider: {
            borderBottom: "1px solid ".concat(theme.palette.divider),
            backgroundClip: 'padding-box'
        },
        /* Styles applied to the inner `component` element if `disableGutters={false}`. */ gutters: {
            paddingLeft: 16,
            paddingRight: 16
        },
        /* Styles applied to the inner `component` element if `button={true}`. */ button: {
            transition: theme.transitions.create('background-color', {
                duration: theme.transitions.duration.shortest
            }),
            '&:hover': {
                textDecoration: 'none',
                backgroundColor: theme.palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */ secondaryAction: {
            // Add some space to avoid collision as `ListItemSecondaryAction`
            // is absolutely positioned.
            paddingRight: 48
        },
        /* Pseudo-class applied to the root element if `selected={true}`. */ selected: {}
    };
};
var $0e953befeee832b2$var$useEnhancedEffect = typeof window === 'undefined' ? $ieT14.useEffect : $ieT14.useLayoutEffect;
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ var $0e953befeee832b2$var$ListItem = /*#__PURE__*/ $ieT14.forwardRef(function ListItem(props, ref) {
    var _props$alignItems = props.alignItems, alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$button = props.button, button = _props$button === void 0 ? false : _props$button, childrenProp = props.children, classes = props.classes, className = props.className, componentProp = props.component, _props$ContainerCompo = props.ContainerComponent, ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo, _props$ContainerProps = props.ContainerProps;
    _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;
    var ContainerClassName = _props$ContainerProps.className, ContainerProps = (0, $eTwGP.default)(_props$ContainerProps, [
        "className"
    ]), _props$dense = props.dense, dense = _props$dense === void 0 ? false : _props$dense, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$divider = props.divider, divider = _props$divider === void 0 ? false : _props$divider, focusVisibleClassName = props.focusVisibleClassName, _props$selected = props.selected, selected = _props$selected === void 0 ? false : _props$selected, other = (0, $eTwGP.default)(props, [
        "alignItems",
        "autoFocus",
        "button",
        "children",
        "classes",
        "className",
        "component",
        "ContainerComponent",
        "ContainerProps",
        "dense",
        "disabled",
        "disableGutters",
        "divider",
        "focusVisibleClassName",
        "selected"
    ]);
    var context = $ieT14.useContext((0, $2Mf9x.default));
    var childContext = {
        dense: dense || context.dense || false,
        alignItems: alignItems
    };
    var listItemRef = $ieT14.useRef(null);
    $0e953befeee832b2$var$useEnhancedEffect(function() {
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    var children = $ieT14.Children.toArray(childrenProp);
    var hasSecondaryAction = children.length && (0, $gX17d.default)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    var handleOwnRef = $ieT14.useCallback(function(instance) {
        // #StrictMode ready
        listItemRef.current = $3tOoB.findDOMNode(instance);
    }, []);
    var handleRef = (0, $3A1Xf.default)(handleOwnRef, ref);
    var componentProps = (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
        disabled: disabled
    }, other);
    var Component = componentProp || 'li';
    if (button) {
        componentProps.component = componentProp || 'div';
        componentProps.focusVisibleClassName = (0, $j6s32.default)(classes.focusVisible, focusVisibleClassName);
        Component = (0, $51wR9.default);
    }
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ $ieT14.createElement((0, $2Mf9x.default).Provider, {
            value: childContext
        }, /*#__PURE__*/ $ieT14.createElement(ContainerComponent, (0, $edxsd.default)({
            className: (0, $j6s32.default)(classes.container, ContainerClassName),
            ref: handleRef
        }, ContainerProps), /*#__PURE__*/ $ieT14.createElement(Component, componentProps, children), children.pop()));
    }
    return /*#__PURE__*/ $ieT14.createElement((0, $2Mf9x.default).Provider, {
        value: childContext
    }, /*#__PURE__*/ $ieT14.createElement(Component, (0, $edxsd.default)({
        ref: handleRef
    }, componentProps), children));
});
var $0e953befeee832b2$export$2e2bcd8739ae039 = (0, $aIJrd.default)($0e953befeee832b2$export$9dd6ff9ea0189349, {
    name: 'MuiListItem'
})($0e953befeee832b2$var$ListItem);

});


parcelRegister("aanJt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $766d3f529cf4df77$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $iajeC = parcelRequire("iajeC");

var $5ghU5 = parcelRequire("5ghU5");

var $gAQ3E = parcelRequire("gAQ3E");

var $aRcbT = parcelRequire("aRcbT");

var $aIJrd = parcelRequire("aIJrd");

var $dLbmY = parcelRequire("dLbmY");

var $1WkvG = parcelRequire("1WkvG");

var $6HZkN = parcelRequire("6HZkN");

var $c4z5m = parcelRequire("c4z5m");

var $cVgD8 = parcelRequire("cVgD8");

var $d6SUv = parcelRequire("d6SUv");
var $766d3f529cf4df77$export$9dd6ff9ea0189349 = (0, $6HZkN.styles);
var $766d3f529cf4df77$var$_ref = /*#__PURE__*/ $ieT14.createElement((0, $1WkvG.default), null);
var $766d3f529cf4df77$var$_ref2 = /*#__PURE__*/ $ieT14.createElement((0, $cVgD8.default), null);
var $766d3f529cf4df77$var$Select = /*#__PURE__*/ $ieT14.forwardRef(function Select(props, ref) {
    var _props$autoWidth = props.autoWidth, autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth, children = props.children, classes = props.classes, _props$displayEmpty = props.displayEmpty, displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? (0, $dLbmY.default) : _props$IconComponent, id = props.id, input = props.input, inputProps = props.inputProps, label = props.label, labelId = props.labelId, _props$labelWidth = props.labelWidth, labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth, MenuProps = props.MenuProps, _props$multiple = props.multiple, multiple = _props$multiple === void 0 ? false : _props$multiple, _props$native = props.native, native = _props$native === void 0 ? false : _props$native, onClose = props.onClose, onOpen = props.onOpen, open = props.open, renderValue = props.renderValue, SelectDisplayProps = props.SelectDisplayProps, _props$variant = props.variant, variantProps = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $eTwGP.default)(props, [
        "autoWidth",
        "children",
        "classes",
        "displayEmpty",
        "IconComponent",
        "id",
        "input",
        "inputProps",
        "label",
        "labelId",
        "labelWidth",
        "MenuProps",
        "multiple",
        "native",
        "onClose",
        "onOpen",
        "open",
        "renderValue",
        "SelectDisplayProps",
        "variant"
    ]);
    var inputComponent = native ? (0, $c4z5m.default) : (0, $5ghU5.default);
    var muiFormControl = (0, $aRcbT.default)();
    var fcs = (0, $gAQ3E.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant'
        ]
    });
    var variant = fcs.variant || variantProps;
    var InputComponent = input || ({
        standard: $766d3f529cf4df77$var$_ref,
        outlined: /*#__PURE__*/ $ieT14.createElement((0, $d6SUv.default), {
            label: label,
            labelWidth: labelWidth
        }),
        filled: $766d3f529cf4df77$var$_ref2
    })[variant];
    return /*#__PURE__*/ $ieT14.cloneElement(InputComponent, (0, $edxsd.default)({
        // Most of the logic is implemented in `SelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent: inputComponent,
        inputProps: (0, $edxsd.default)({
            children: children,
            IconComponent: IconComponent,
            variant: variant,
            type: undefined,
            // We render a select. We can ignore the type provided by the `Input`.
            multiple: multiple
        }, native ? {
            id: id
        } : {
            autoWidth: autoWidth,
            displayEmpty: displayEmpty,
            labelId: labelId,
            MenuProps: MenuProps,
            onClose: onClose,
            onOpen: onOpen,
            open: open,
            renderValue: renderValue,
            SelectDisplayProps: (0, $edxsd.default)({
                id: id
            }, SelectDisplayProps)
        }, inputProps, {
            classes: inputProps ? (0, $iajeC.default)({
                baseClasses: classes,
                newClasses: inputProps.classes,
                Component: Select
            }) : classes
        }, input ? input.props.inputProps : {}),
        ref: ref
    }, other));
});
$766d3f529cf4df77$var$Select.muiName = 'Select';
var $766d3f529cf4df77$export$2e2bcd8739ae039 = (0, $aIJrd.default)($766d3f529cf4df77$export$9dd6ff9ea0189349, {
    name: 'MuiSelect'
})($766d3f529cf4df77$var$Select);

});
parcelRegister("5ghU5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d4c55af6046b331$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $dcIvM = parcelRequire("dcIvM");

var $eTwGP = parcelRequire("eTwGP");

var $ar9wC = parcelRequire("ar9wC");

var $bPjvu = parcelRequire("bPjvu");

var $ieT14 = parcelRequire("ieT14");
parcelRequire("fqwRx");


var $j6s32 = parcelRequire("j6s32");

var $7e6Rg = parcelRequire("7e6Rg");

var $2EBFt = parcelRequire("2EBFt");

var $5TjLg = parcelRequire("5TjLg");

var $033Qn = parcelRequire("033Qn");

var $3A1Xf = parcelRequire("3A1Xf");

var $kuovH = parcelRequire("kuovH");
function $3d4c55af6046b331$var$areEqualValues(a, b) {
    if ((0, $ar9wC.default)(b) === 'object' && b !== null) return a === b;
    return String(a) === String(b);
}
function $3d4c55af6046b331$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
/**
 * @ignore - internal component.
 */ var $3d4c55af6046b331$var$SelectInput = /*#__PURE__*/ $ieT14.forwardRef(function SelectInput(props, ref) {
    var ariaLabel = props['aria-label'], autoFocus = props.autoFocus, autoWidth = props.autoWidth, children = props.children, classes = props.classes, className = props.className, defaultValue = props.defaultValue, disabled = props.disabled, displayEmpty = props.displayEmpty, IconComponent = props.IconComponent, inputRefProp = props.inputRef, labelId = props.labelId, _props$MenuProps = props.MenuProps, MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps, multiple = props.multiple, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClose = props.onClose, onFocus = props.onFocus, onOpen = props.onOpen, openProp = props.open, readOnly = props.readOnly, renderValue = props.renderValue, _props$SelectDisplayP = props.SelectDisplayProps, SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP, tabIndexProp = props.tabIndex, type = props.type, valueProp = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $eTwGP.default)(props, [
        "aria-label",
        "autoFocus",
        "autoWidth",
        "children",
        "classes",
        "className",
        "defaultValue",
        "disabled",
        "displayEmpty",
        "IconComponent",
        "inputRef",
        "labelId",
        "MenuProps",
        "multiple",
        "name",
        "onBlur",
        "onChange",
        "onClose",
        "onFocus",
        "onOpen",
        "open",
        "readOnly",
        "renderValue",
        "SelectDisplayProps",
        "tabIndex",
        "type",
        "value",
        "variant"
    ]);
    var _useControlled = (0, $kuovH.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    }), _useControlled2 = (0, $dcIvM.default)(_useControlled, 2), value = _useControlled2[0], setValue = _useControlled2[1];
    var inputRef = $ieT14.useRef(null);
    var _React$useState = $ieT14.useState(null), displayNode = _React$useState[0], setDisplayNode = _React$useState[1];
    var _React$useRef = $ieT14.useRef(openProp != null), isOpenControlled = _React$useRef.current;
    var _React$useState2 = $ieT14.useState(), menuMinWidthState = _React$useState2[0], setMenuMinWidthState = _React$useState2[1];
    var _React$useState3 = $ieT14.useState(false), openState = _React$useState3[0], setOpenState = _React$useState3[1];
    var handleRef = (0, $3A1Xf.default)(ref, inputRefProp);
    $ieT14.useImperativeHandle(handleRef, function() {
        return {
            focus: function focus() {
                displayNode.focus();
            },
            node: inputRef.current,
            value: value
        };
    }, [
        displayNode,
        value
    ]);
    $ieT14.useEffect(function() {
        if (autoFocus && displayNode) displayNode.focus();
    }, [
        autoFocus,
        displayNode
    ]);
    $ieT14.useEffect(function() {
        if (displayNode) {
            var label = (0, $7e6Rg.default)(displayNode).getElementById(labelId);
            if (label) {
                var handler = function handler() {
                    if (getSelection().isCollapsed) displayNode.focus();
                };
                label.addEventListener('click', handler);
                return function() {
                    label.removeEventListener('click', handler);
                };
            }
        }
        return undefined;
    }, [
        labelId,
        displayNode
    ]);
    var update = function update(open, event) {
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
            setOpenState(open);
        }
    };
    var handleMouseDown = function handleMouseDown(event) {
        // Ignore everything but left-click
        if (event.button !== 0) return;
         // Hijack the default focus behavior.
        event.preventDefault();
        displayNode.focus();
        update(true, event);
    };
    var handleClose = function handleClose(event) {
        update(false, event);
    };
    var childrenArray = $ieT14.Children.toArray(children); // Support autofill.
    var handleChange = function handleChange(event) {
        var index = childrenArray.map(function(child) {
            return child.props.value;
        }).indexOf(event.target.value);
        if (index === -1) return;
        var child = childrenArray[index];
        setValue(child.props.value);
        if (onChange) onChange(event, child);
    };
    var handleItemClick = function handleItemClick(child) {
        return function(event) {
            if (!multiple) update(false, event);
            var newValue;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                var itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value === newValue) return;
            setValue(newValue);
            if (onChange) {
                event.persist(); // Preact support, target is read only property on a native event.
                Object.defineProperty(event, 'target', {
                    writable: true,
                    value: {
                        value: newValue,
                        name: name
                    }
                });
                onChange(event, child);
            }
        };
    };
    var handleKeyDown = function handleKeyDown(event) {
        if (!readOnly) {
            var validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
                'Enter'
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    var open = displayNode !== null && (isOpenControlled ? openProp : openState);
    var handleBlur = function handleBlur(event) {
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            event.persist(); // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    var display;
    var displaySingle;
    var displayMultiple = [];
    var computeDisplay = false;
    var foundMatch = false; // No need to display any value if the field is empty.
    if ((0, $033Qn.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    var items = childrenArray.map(function(child) {
        if (!/*#__PURE__*/ $ieT14.isValidElement(child)) return null;
        var selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $bPjvu.default)(2));
            selected = value.some(function(v) {
                return $3d4c55af6046b331$var$areEqualValues(v, child.props.value);
            });
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $3d4c55af6046b331$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $ieT14.cloneElement(child, {
            'aria-selected': selected ? 'true' : undefined,
            onClick: handleItemClick(child),
            onKeyUp: function onKeyUp(event) {
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    if (computeDisplay) display = multiple ? displayMultiple.join(', ') : displaySingle;
     // Avoid performing a layout computation in the render method.
    var menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = displayNode.clientWidth;
    var tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
    return /*#__PURE__*/ $ieT14.createElement($ieT14.Fragment, null, /*#__PURE__*/ $ieT14.createElement("div", (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
        ref: setDisplayNode,
        tabIndex: tabIndex,
        role: "button",
        "aria-disabled": disabled ? 'true' : undefined,
        "aria-expanded": open ? 'true' : undefined,
        "aria-haspopup": "listbox",
        "aria-label": ariaLabel,
        "aria-labelledby": [
            labelId,
            buttonId
        ].filter(Boolean).join(' ') || undefined,
        onKeyDown: handleKeyDown,
        onMouseDown: disabled || readOnly ? null : handleMouseDown,
        onBlur: handleBlur,
        onFocus: onFocus
    }, SelectDisplayProps, {
        // The id is required for proper a11y
        id: buttonId
    }), $3d4c55af6046b331$var$isEmpty(display) ? /*#__PURE__*/ // eslint-disable-next-line react/no-danger
    $ieT14.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: '&#8203;'
        }
    }) : display), /*#__PURE__*/ $ieT14.createElement("input", (0, $edxsd.default)({
        value: Array.isArray(value) ? value.join(',') : value,
        name: name,
        ref: inputRef,
        "aria-hidden": true,
        onChange: handleChange,
        tabIndex: -1,
        className: classes.nativeInput,
        autoFocus: autoFocus
    }, other)), /*#__PURE__*/ $ieT14.createElement(IconComponent, {
        className: (0, $j6s32.default)(classes.icon, classes["icon".concat((0, $2EBFt.default)(variant))], open && classes.iconOpen, disabled && classes.disabled)
    }), /*#__PURE__*/ $ieT14.createElement((0, $5TjLg.default), (0, $edxsd.default)({
        id: "menu-".concat(name || ''),
        anchorEl: displayNode,
        open: open,
        onClose: handleClose
    }, MenuProps, {
        MenuListProps: (0, $edxsd.default)({
            'aria-labelledby': labelId,
            role: 'listbox',
            disableListWrap: true
        }, MenuProps.MenuListProps),
        PaperProps: (0, $edxsd.default)({}, MenuProps.PaperProps, {
            style: (0, $edxsd.default)({
                minWidth: menuMinWidth
            }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
        })
    }), items));
});
var $3d4c55af6046b331$export$2e2bcd8739ae039 = $3d4c55af6046b331$var$SelectInput;

});
parcelRegister("kuovH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eea99f38c9171ac0$export$2e2bcd8739ae039; });
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ 
var $ieT14 = parcelRequire("ieT14");
function $eea99f38c9171ac0$export$2e2bcd8739ae039(_ref) {
    var controlled = _ref.controlled, defaultProp = _ref.default, name = _ref.name, _ref$state = _ref.state, state = _ref$state === void 0 ? 'value' : _ref$state;
    var _React$useRef = $ieT14.useRef(controlled !== undefined), isControlled = _React$useRef.current;
    var _React$useState = $ieT14.useState(defaultProp), valueState = _React$useState[0], setValue = _React$useState[1];
    var value = isControlled ? controlled : valueState;
    var _React$useRef2, defaultValue;
    var setValueIfUncontrolled = $ieT14.useCallback(function(newValue) {
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRegister("dLbmY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0487be6605c0bdd$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var /**
 * @ignore - internal component.
 */ $a0487be6605c0bdd$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

});

parcelRegister("1WkvG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $169b1e11d0c223c0$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");


var $eg6hn = parcelRequire("eg6hn");

var $aIJrd = parcelRequire("aIJrd");
var $169b1e11d0c223c0$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === 'light';
    var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative'
        },
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {
            'label + &': {
                marginTop: 16
            }
        },
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if color secondary. */ colorSecondary: {
            '&$underline:after': {
                borderBottomColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if `disableUnderline={false}`. */ underline: {
            '&:after': {
                borderBottom: "2px solid ".concat(theme.palette.primary.main),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '""',
                position: 'absolute',
                right: 0,
                transform: 'scaleX(0)',
                transition: theme.transitions.create('transform', {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }),
                pointerEvents: 'none' // Transparent to the hover style.
            },
            '&$focused:after': {
                transform: 'scaleX(1)'
            },
            '&$error:after': {
                borderBottomColor: theme.palette.error.main,
                transform: 'scaleX(1)' // error is always underlined in red
            },
            '&:before': {
                borderBottom: "1px solid ".concat(bottomLineColor),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '"\\00a0"',
                position: 'absolute',
                right: 0,
                transition: theme.transitions.create('border-bottom-color', {
                    duration: theme.transitions.duration.shorter
                }),
                pointerEvents: 'none' // Transparent to the hover style.
            },
            '&:hover:not($disabled):before': {
                borderBottom: "2px solid ".concat(theme.palette.text.primary),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    borderBottom: "1px solid ".concat(bottomLineColor)
                }
            },
            '&$disabled:before': {
                borderBottomStyle: 'dotted'
            }
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {},
        /* Styles applied to the `input` element. */ input: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {},
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {},
        /* Styles applied to the `input` element if `type="search"`. */ inputTypeSearch: {}
    };
};
var $169b1e11d0c223c0$var$Input = /*#__PURE__*/ $ieT14.forwardRef(function Input(props, ref) {
    var disableUnderline = props.disableUnderline, classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, other = (0, $eTwGP.default)(props, [
        "disableUnderline",
        "classes",
        "fullWidth",
        "inputComponent",
        "multiline",
        "type"
    ]);
    return /*#__PURE__*/ $ieT14.createElement((0, $eg6hn.default), (0, $edxsd.default)({
        classes: (0, $edxsd.default)({}, classes, {
            root: (0, $j6s32.default)(classes.root, !disableUnderline && classes.underline),
            underline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$169b1e11d0c223c0$var$Input.muiName = 'Input';
var $169b1e11d0c223c0$export$2e2bcd8739ae039 = (0, $aIJrd.default)($169b1e11d0c223c0$export$9dd6ff9ea0189349, {
    name: 'MuiInput'
})($169b1e11d0c223c0$var$Input);

});
parcelRegister("eg6hn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6176e40cdd5c044$export$2e2bcd8739ae039; });

var $eTwGP = parcelRequire("eTwGP");

var $edxsd = parcelRequire("edxsd");

var $bPjvu = parcelRequire("bPjvu");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $gAQ3E = parcelRequire("gAQ3E");

var $bJmSx = parcelRequire("bJmSx");

var $aIJrd = parcelRequire("aIJrd");

var $2EBFt = parcelRequire("2EBFt");

var $3A1Xf = parcelRequire("3A1Xf");

var $7VdLd = parcelRequire("7VdLd");

var $033Qn = parcelRequire("033Qn");
var $a6176e40cdd5c044$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === 'light';
    var placeholder = {
        color: 'currentColor',
        opacity: light ? 0.42 : 0.5,
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    var placeholderHidden = {
        opacity: '0 !important'
    };
    var placeholderVisible = {
        opacity: light ? 0.42 : 0.5
    };
    return {
        '@global': {
            '@keyframes mui-auto-fill': {},
            '@keyframes mui-auto-fill-cancel': {}
        },
        /* Styles applied to the root element. */ root: (0, $edxsd.default)({}, theme.typography.body1, {
            color: theme.palette.text.primary,
            lineHeight: '1.1876em',
            // Reset (19px), match the native input line-height
            boxSizing: 'border-box',
            // Prevent padding issue with fullWidth.
            position: 'relative',
            cursor: 'text',
            display: 'inline-flex',
            alignItems: 'center',
            '&$disabled': {
                color: theme.palette.text.disabled,
                cursor: 'default'
            }
        }),
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {},
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {},
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: "".concat(6, "px 0 ").concat(7, "px"),
            '&$marginDense': {
                paddingTop: 3
            }
        },
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: '100%'
        },
        /* Styles applied to the `input` element. */ input: {
            font: 'inherit',
            letterSpacing: 'inherit',
            color: 'currentColor',
            padding: "".concat(6, "px 0 ").concat(7, "px"),
            border: 0,
            boxSizing: 'content-box',
            background: 'none',
            height: '1.1876em',
            // Reset (19px), match the native input line-height
            margin: 0,
            // Reset for Safari
            WebkitTapHighlightColor: 'transparent',
            display: 'block',
            // Make the flex item shrink with Firefox
            minWidth: 0,
            width: '100%',
            // Fix IE 11 width issue
            animationName: 'mui-auto-fill-cancel',
            animationDuration: '10ms',
            '&::-webkit-input-placeholder': placeholder,
            '&::-moz-placeholder': placeholder,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholder,
            // IE 11
            '&::-ms-input-placeholder': placeholder,
            // Edge
            '&:focus': {
                outline: 0
            },
            // Reset Firefox invalid required input style
            '&:invalid': {
                boxShadow: 'none'
            },
            '&::-webkit-search-decoration': {
                // Remove the padding when type=search.
                '-webkit-appearance': 'none'
            },
            // Show and hide the placeholder logic
            'label[data-shrink=false] + $formControl &': {
                '&::-webkit-input-placeholder': placeholderHidden,
                '&::-moz-placeholder': placeholderHidden,
                // Firefox 19+
                '&:-ms-input-placeholder': placeholderHidden,
                // IE 11
                '&::-ms-input-placeholder': placeholderHidden,
                // Edge
                '&:focus::-webkit-input-placeholder': placeholderVisible,
                '&:focus::-moz-placeholder': placeholderVisible,
                // Firefox 19+
                '&:focus:-ms-input-placeholder': placeholderVisible,
                // IE 11
                '&:focus::-ms-input-placeholder': placeholderVisible // Edge
            },
            '&$disabled': {
                opacity: 1 // Reset iOS opacity
            },
            '&:-webkit-autofill': {
                animationDuration: '5000s',
                animationName: 'mui-auto-fill'
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 3
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            height: 'auto',
            resize: 'none',
            padding: 0
        },
        /* Styles applied to the `input` element if `type="search"`. */ inputTypeSearch: {
            // Improve type search style.
            '-moz-appearance': 'textfield',
            '-webkit-appearance': 'textfield'
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {},
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {},
        /* Styles applied to the `input` element if `hiddenLabel={true}`. */ inputHiddenLabel: {}
    };
};
var $a6176e40cdd5c044$var$useEnhancedEffect = typeof window === 'undefined' ? $ieT14.useEffect : $ieT14.useLayoutEffect;
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ var $a6176e40cdd5c044$var$InputBase = /*#__PURE__*/ $ieT14.forwardRef(function InputBase(props, ref) {
    var ariaDescribedby = props['aria-describedby'], autoComplete = props.autoComplete, autoFocus = props.autoFocus, classes = props.classes, className = props.className, color = props.color, defaultValue = props.defaultValue, disabled = props.disabled, endAdornment = props.endAdornment, error = props.error, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, id = props.id, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent, _props$inputProps = props.inputProps, inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps, inputRefProp = props.inputRef, margin = props.margin, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClick = props.onClick, onFocus = props.onFocus, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, placeholder = props.placeholder, readOnly = props.readOnly, renderSuffix = props.renderSuffix, rows = props.rows, rowsMax = props.rowsMax, rowsMin = props.rowsMin, maxRows = props.maxRows, minRows = props.minRows, startAdornment = props.startAdornment, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, valueProp = props.value, other = (0, $eTwGP.default)(props, [
        "aria-describedby",
        "autoComplete",
        "autoFocus",
        "classes",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "endAdornment",
        "error",
        "fullWidth",
        "id",
        "inputComponent",
        "inputProps",
        "inputRef",
        "margin",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onClick",
        "onFocus",
        "onKeyDown",
        "onKeyUp",
        "placeholder",
        "readOnly",
        "renderSuffix",
        "rows",
        "rowsMax",
        "rowsMin",
        "maxRows",
        "minRows",
        "startAdornment",
        "type",
        "value"
    ]);
    var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    var _React$useRef = $ieT14.useRef(value != null), isControlled = _React$useRef.current;
    var inputRef = $ieT14.useRef();
    var handleInputRefWarning = $ieT14.useCallback(function(instance) {}, []);
    var handleInputPropsRefProp = (0, $3A1Xf.default)(inputPropsProp.ref, handleInputRefWarning);
    var handleInputRefProp = (0, $3A1Xf.default)(inputRefProp, handleInputPropsRefProp);
    var handleInputRef = (0, $3A1Xf.default)(inputRef, handleInputRefProp);
    var _React$useState = $ieT14.useState(false), focused = _React$useState[0], setFocused = _React$useState[1];
    var muiFormControl = (0, $bJmSx.useFormControl)();
    var fcs = (0, $gAQ3E.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'margin',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $ieT14.useEffect(function() {
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    var onFilled = muiFormControl && muiFormControl.onFilled;
    var onEmpty = muiFormControl && muiFormControl.onEmpty;
    var checkDirty = $ieT14.useCallback(function(obj) {
        if ((0, $033Qn.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    $a6176e40cdd5c044$var$useEnhancedEffect(function() {
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    var handleFocus = function handleFocus(event) {
        // Fix a bug with IE 11 where the focus/blur events are triggered
        // while the input is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    var handleBlur = function handleBlur(event) {
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    var handleChange = function handleChange(event) {
        if (!isControlled) {
            var element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $bPjvu.default)(1));
            checkDirty({
                value: element.value
            });
        }
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (inputPropsProp.onChange) inputPropsProp.onChange.apply(inputPropsProp, [
            event
        ].concat(args));
         // Perform in the willUpdate
        if (onChange) onChange.apply(void 0, [
            event
        ].concat(args));
    }; // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $ieT14.useEffect(function() {
        checkDirty(inputRef.current);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    var handleClick = function handleClick(event) {
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    var InputComponent = inputComponent;
    var inputProps = (0, $edxsd.default)({}, inputPropsProp, {
        ref: handleInputRef
    });
    if (typeof InputComponent !== 'string') inputProps = (0, $edxsd.default)({
        // Rename ref to inputRef as we don't know the
        // provided `inputComponent` structure.
        inputRef: handleInputRef,
        type: type
    }, inputProps, {
        ref: null
    });
    else if (multiline) {
        if (rows && !maxRows && !minRows && !rowsMax && !rowsMin) InputComponent = 'textarea';
        else {
            inputProps = (0, $edxsd.default)({
                minRows: rows || minRows,
                rowsMax: rowsMax,
                maxRows: maxRows
            }, inputProps);
            InputComponent = (0, $7VdLd.default);
        }
    } else inputProps = (0, $edxsd.default)({
        type: type
    }, inputProps);
    var handleAutoFill = function handleAutoFill(event) {
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $ieT14.useEffect(function() {
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    return /*#__PURE__*/ $ieT14.createElement("div", (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, classes["color".concat((0, $2EBFt.default)(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === 'dense' && classes.marginDense),
        onClick: handleClick,
        ref: ref
    }, other), startAdornment, /*#__PURE__*/ $ieT14.createElement((0, $bJmSx.default).Provider, {
        value: null
    }, /*#__PURE__*/ $ieT14.createElement(InputComponent, (0, $edxsd.default)({
        "aria-invalid": fcs.error,
        "aria-describedby": ariaDescribedby,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        disabled: fcs.disabled,
        id: id,
        onAnimationStart: handleAutoFill,
        name: name,
        placeholder: placeholder,
        readOnly: readOnly,
        required: fcs.required,
        rows: rows,
        value: value,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    }, inputProps, {
        className: (0, $j6s32.default)(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === 'search' && classes.inputTypeSearch, fcs.margin === 'dense' && classes.inputMarginDense),
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus
    }))), endAdornment, renderSuffix ? renderSuffix((0, $edxsd.default)({}, fcs, {
        startAdornment: startAdornment
    })) : null);
});
var $a6176e40cdd5c044$export$2e2bcd8739ae039 = (0, $aIJrd.default)($a6176e40cdd5c044$export$9dd6ff9ea0189349, {
    name: 'MuiInputBase'
})($a6176e40cdd5c044$var$InputBase);

});
parcelRegister("7VdLd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c4887d4b5659870$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $hJtzf = parcelRequire("hJtzf");

var $3A1Xf = parcelRequire("3A1Xf");

function $5c4887d4b5659870$var$getStyleValue(computedStyle, property) {
    return parseInt(computedStyle[property], 10) || 0;
}
var $5c4887d4b5659870$var$useEnhancedEffect = typeof window !== 'undefined' ? $ieT14.useLayoutEffect : $ieT14.useEffect;
var $5c4887d4b5659870$var$styles = {
    /* Styles applied to the shadow textarea element. */ shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
var $5c4887d4b5659870$var$TextareaAutosize = /*#__PURE__*/ $ieT14.forwardRef(function TextareaAutosize(props, ref) {
    var onChange = props.onChange, rows = props.rows, rowsMax = props.rowsMax, rowsMinProp = props.rowsMin, maxRowsProp = props.maxRows, _props$minRows = props.minRows, minRowsProp = _props$minRows === void 0 ? 1 : _props$minRows, style = props.style, value = props.value, other = (0, $eTwGP.default)(props, [
        "onChange",
        "rows",
        "rowsMax",
        "rowsMin",
        "maxRows",
        "minRows",
        "style",
        "value"
    ]);
    var maxRows = maxRowsProp || rowsMax;
    var minRows = rows || rowsMinProp || minRowsProp;
    var _React$useRef = $ieT14.useRef(value != null), isControlled = _React$useRef.current;
    var inputRef = $ieT14.useRef(null);
    var handleRef = (0, $3A1Xf.default)(ref, inputRef);
    var shadowRef = $ieT14.useRef(null);
    var renders = $ieT14.useRef(0);
    var _React$useState = $ieT14.useState({}), state = _React$useState[0], setState = _React$useState[1];
    var syncHeight = $ieT14.useCallback(function() {
        var input = inputRef.current;
        var computedStyle = window.getComputedStyle(input);
        var inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || 'x';
        if (inputShallow.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += ' ';
        var boxSizing = computedStyle['box-sizing'];
        var padding = $5c4887d4b5659870$var$getStyleValue(computedStyle, 'padding-bottom') + $5c4887d4b5659870$var$getStyleValue(computedStyle, 'padding-top');
        var border = $5c4887d4b5659870$var$getStyleValue(computedStyle, 'border-bottom-width') + $5c4887d4b5659870$var$getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content
        var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row
        inputShallow.value = 'x';
        var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content
        var outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.
        var outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        var overflow = Math.abs(outerHeight - innerHeight) <= 1;
        setState(function(prevState) {
            // Need a large enough difference to update the height.
            // This prevents infinite rendering loop.
            if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
                renders.current += 1;
                return {
                    overflow: overflow,
                    outerHeightStyle: outerHeightStyle
                };
            }
            return prevState;
        });
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    $ieT14.useEffect(function() {
        var handleResize = (0, $hJtzf.default)(function() {
            renders.current = 0;
            syncHeight();
        });
        window.addEventListener('resize', handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener('resize', handleResize);
        };
    }, [
        syncHeight
    ]);
    $5c4887d4b5659870$var$useEnhancedEffect(function() {
        syncHeight();
    });
    $ieT14.useEffect(function() {
        renders.current = 0;
    }, [
        value
    ]);
    var handleChange = function handleChange(event) {
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ $ieT14.createElement($ieT14.Fragment, null, /*#__PURE__*/ $ieT14.createElement("textarea", (0, $edxsd.default)({
        value: value,
        onChange: handleChange,
        ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
        ,
        rows: minRows,
        style: (0, $edxsd.default)({
            height: state.outerHeightStyle,
            // Need a large enough difference to allow scrolling.
            // This prevents infinite rendering loop.
            overflow: state.overflow ? 'hidden' : null
        }, style)
    }, other)), /*#__PURE__*/ $ieT14.createElement("textarea", {
        "aria-hidden": true,
        className: props.className,
        readOnly: true,
        ref: shadowRef,
        tabIndex: -1,
        style: (0, $edxsd.default)({}, $5c4887d4b5659870$var$styles.shadow, style)
    }));
});
var $5c4887d4b5659870$export$2e2bcd8739ae039 = $5c4887d4b5659870$var$TextareaAutosize;

});



parcelRegister("6HZkN", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $4e2655f23b6c34c4$export$9dd6ff9ea0189349; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $c4z5m = parcelRequire("c4z5m");

var $aIJrd = parcelRequire("aIJrd");

var $gAQ3E = parcelRequire("gAQ3E");

var $aRcbT = parcelRequire("aRcbT");

var $dLbmY = parcelRequire("dLbmY");

var $1WkvG = parcelRequire("1WkvG");
var $4e2655f23b6c34c4$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the select component `root` class. */ root: {},
        /* Styles applied to the select component `select` class. */ select: {
            '-moz-appearance': 'none',
            // Reset
            '-webkit-appearance': 'none',
            // Reset
            // When interacting quickly, the text can end up selected.
            // Native select can't be selected either.
            userSelect: 'none',
            borderRadius: 0,
            // Reset
            minWidth: 16,
            // So it doesn't collapse.
            cursor: 'pointer',
            '&:focus': {
                // Show that it's not an text input
                backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
                borderRadius: 0 // Reset Chrome style
            },
            // Remove IE 11 arrow
            '&::-ms-expand': {
                display: 'none'
            },
            '&$disabled': {
                cursor: 'default'
            },
            '&[multiple]': {
                height: 'auto'
            },
            '&:not([multiple]) option, &:not([multiple]) optgroup': {
                backgroundColor: theme.palette.background.paper
            },
            '&&': {
                paddingRight: 24
            }
        },
        /* Styles applied to the select component if `variant="filled"`. */ filled: {
            '&&': {
                paddingRight: 32
            }
        },
        /* Styles applied to the select component if `variant="outlined"`. */ outlined: {
            borderRadius: theme.shape.borderRadius,
            '&&': {
                paddingRight: 32
            }
        },
        /* Styles applied to the select component `selectMenu` class. */ selectMenu: {
            height: 'auto',
            // Resets for multpile select with chips
            minHeight: '1.1876em',
            // Required for select\text-field height consistency
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden'
        },
        /* Pseudo-class applied to the select component `disabled` class. */ disabled: {},
        /* Styles applied to the icon component. */ icon: {
            // We use a position absolute over a flexbox in order to forward the pointer events
            // to the input and to support wrapping tags..
            position: 'absolute',
            right: 0,
            top: 'calc(50% - 12px)',
            // Center vertically
            pointerEvents: 'none',
            // Don't block pointer events on the select under the icon.
            color: theme.palette.action.active,
            '&$disabled': {
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the icon component if the popup is open. */ iconOpen: {
            transform: 'rotate(180deg)'
        },
        /* Styles applied to the icon component if `variant="filled"`. */ iconFilled: {
            right: 7
        },
        /* Styles applied to the icon component if `variant="outlined"`. */ iconOutlined: {
            right: 7
        },
        /* Styles applied to the underlying native input component. */ nativeInput: {
            bottom: 0,
            left: 0,
            position: 'absolute',
            opacity: 0,
            pointerEvents: 'none',
            width: '100%'
        }
    };
};
var $4e2655f23b6c34c4$var$defaultInput = /*#__PURE__*/ $ieT14.createElement((0, $1WkvG.default), null);
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */ var $4e2655f23b6c34c4$var$NativeSelect = /*#__PURE__*/ $ieT14.forwardRef(function NativeSelect(props, ref) {
    var children = props.children, classes = props.classes, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? (0, $dLbmY.default) : _props$IconComponent, _props$input = props.input, input = _props$input === void 0 ? $4e2655f23b6c34c4$var$defaultInput : _props$input, inputProps = props.inputProps, variant = props.variant, other = (0, $eTwGP.default)(props, [
        "children",
        "classes",
        "IconComponent",
        "input",
        "inputProps",
        "variant"
    ]);
    var muiFormControl = (0, $aRcbT.default)();
    var fcs = (0, $gAQ3E.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant'
        ]
    });
    return /*#__PURE__*/ $ieT14.cloneElement(input, (0, $edxsd.default)({
        // Most of the logic is implemented in `NativeSelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent: (0, $c4z5m.default),
        inputProps: (0, $edxsd.default)({
            children: children,
            classes: classes,
            IconComponent: IconComponent,
            variant: fcs.variant,
            type: undefined
        }, inputProps, input ? input.props.inputProps : {}),
        ref: ref
    }, other));
});
$4e2655f23b6c34c4$var$NativeSelect.muiName = 'Select';
var $4e2655f23b6c34c4$export$2e2bcd8739ae039 = (0, $aIJrd.default)($4e2655f23b6c34c4$export$9dd6ff9ea0189349, {
    name: 'MuiNativeSelect'
})($4e2655f23b6c34c4$var$NativeSelect);

});
parcelRegister("c4z5m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ca112fcbad4dbdf$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");


var $2EBFt = parcelRequire("2EBFt");
/**
 * @ignore - internal component.
 */ var $8ca112fcbad4dbdf$var$NativeSelectInput = /*#__PURE__*/ $ieT14.forwardRef(function NativeSelectInput(props, ref) {
    var classes = props.classes, className = props.className, disabled = props.disabled, IconComponent = props.IconComponent, inputRef = props.inputRef, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $eTwGP.default)(props, [
        "classes",
        "className",
        "disabled",
        "IconComponent",
        "inputRef",
        "variant"
    ]);
    return /*#__PURE__*/ $ieT14.createElement($ieT14.Fragment, null, /*#__PURE__*/ $ieT14.createElement("select", (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, classes.select, classes[variant], className, disabled && classes.disabled),
        disabled: disabled,
        ref: inputRef || ref
    }, other)), props.multiple ? null : /*#__PURE__*/ $ieT14.createElement(IconComponent, {
        className: (0, $j6s32.default)(classes.icon, classes["icon".concat((0, $2EBFt.default)(variant))], disabled && classes.disabled)
    }));
});
var $8ca112fcbad4dbdf$export$2e2bcd8739ae039 = $8ca112fcbad4dbdf$var$NativeSelectInput;

});


parcelRegister("cVgD8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9687b5550ff0bf5e$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");


var $eg6hn = parcelRequire("eg6hn");

var $aIJrd = parcelRequire("aIJrd");
var $9687b5550ff0bf5e$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === 'light';
    var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    var backgroundColor = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)';
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative',
            backgroundColor: backgroundColor,
            borderTopLeftRadius: theme.shape.borderRadius,
            borderTopRightRadius: theme.shape.borderRadius,
            transition: theme.transitions.create('background-color', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            '&:hover': {
                backgroundColor: light ? 'rgba(0, 0, 0, 0.13)' : 'rgba(255, 255, 255, 0.13)',
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: backgroundColor
                }
            },
            '&$focused': {
                backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)'
            },
            '&$disabled': {
                backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
            }
        },
        /* Styles applied to the root element if color secondary. */ colorSecondary: {
            '&$underline:after': {
                borderBottomColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if `disableUnderline={false}`. */ underline: {
            '&:after': {
                borderBottom: "2px solid ".concat(theme.palette.primary.main),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '""',
                position: 'absolute',
                right: 0,
                transform: 'scaleX(0)',
                transition: theme.transitions.create('transform', {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }),
                pointerEvents: 'none' // Transparent to the hover style.
            },
            '&$focused:after': {
                transform: 'scaleX(1)'
            },
            '&$error:after': {
                borderBottomColor: theme.palette.error.main,
                transform: 'scaleX(1)' // error is always underlined in red
            },
            '&:before': {
                borderBottom: "1px solid ".concat(bottomLineColor),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '"\\00a0"',
                position: 'absolute',
                right: 0,
                transition: theme.transitions.create('border-bottom-color', {
                    duration: theme.transitions.duration.shorter
                }),
                pointerEvents: 'none' // Transparent to the hover style.
            },
            '&:hover:before': {
                borderBottom: "1px solid ".concat(theme.palette.text.primary)
            },
            '&$disabled:before': {
                borderBottomStyle: 'dotted'
            }
        },
        /* Pseudo-class applied to the root element if the component is focused. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {
            paddingLeft: 12
        },
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {
            paddingRight: 12
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: '27px 12px 10px',
            '&$marginDense': {
                paddingTop: 23,
                paddingBottom: 6
            }
        },
        /* Styles applied to the `input` element. */ input: {
            padding: '27px 12px 10px',
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
                caretColor: theme.palette.type === 'light' ? null : '#fff',
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 23,
            paddingBottom: 6
        },
        /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */ inputHiddenLabel: {
            paddingTop: 18,
            paddingBottom: 19,
            '&$inputMarginDense': {
                paddingTop: 10,
                paddingBottom: 11
            }
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            padding: 0
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {
            paddingLeft: 0
        },
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {
            paddingRight: 0
        }
    };
};
var $9687b5550ff0bf5e$var$FilledInput = /*#__PURE__*/ $ieT14.forwardRef(function FilledInput(props, ref) {
    var disableUnderline = props.disableUnderline, classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, other = (0, $eTwGP.default)(props, [
        "disableUnderline",
        "classes",
        "fullWidth",
        "inputComponent",
        "multiline",
        "type"
    ]);
    return /*#__PURE__*/ $ieT14.createElement((0, $eg6hn.default), (0, $edxsd.default)({
        classes: (0, $edxsd.default)({}, classes, {
            root: (0, $j6s32.default)(classes.root, !disableUnderline && classes.underline),
            underline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$9687b5550ff0bf5e$var$FilledInput.muiName = 'Input';
var $9687b5550ff0bf5e$export$2e2bcd8739ae039 = (0, $aIJrd.default)($9687b5550ff0bf5e$export$9dd6ff9ea0189349, {
    name: 'MuiFilledInput'
})($9687b5550ff0bf5e$var$FilledInput);

});

parcelRegister("d6SUv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98b66df633994e68$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");


var $eg6hn = parcelRequire("eg6hn");

var $dSOCD = parcelRequire("dSOCD");

var $aIJrd = parcelRequire("aIJrd");
var $98b66df633994e68$export$9dd6ff9ea0189349 = function styles(theme) {
    var borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative',
            borderRadius: theme.shape.borderRadius,
            '&:hover $notchedOutline': {
                borderColor: theme.palette.text.primary
            },
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                '&:hover $notchedOutline': {
                    borderColor: borderColor
                }
            },
            '&$focused $notchedOutline': {
                borderColor: theme.palette.primary.main,
                borderWidth: 2
            },
            '&$error $notchedOutline': {
                borderColor: theme.palette.error.main
            },
            '&$disabled $notchedOutline': {
                borderColor: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {
            '&$focused $notchedOutline': {
                borderColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {
            paddingLeft: 14
        },
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {
            paddingRight: 14
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: '18.5px 14px',
            '&$marginDense': {
                paddingTop: 10.5,
                paddingBottom: 10.5
            }
        },
        /* Styles applied to the `NotchedOutline` element. */ notchedOutline: {
            borderColor: borderColor
        },
        /* Styles applied to the `input` element. */ input: {
            padding: '18.5px 14px',
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
                caretColor: theme.palette.type === 'light' ? null : '#fff',
                borderRadius: 'inherit'
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 10.5,
            paddingBottom: 10.5
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            padding: 0
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {
            paddingLeft: 0
        },
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {
            paddingRight: 0
        }
    };
};
var $98b66df633994e68$var$OutlinedInput = /*#__PURE__*/ $ieT14.forwardRef(function OutlinedInput(props, ref) {
    var classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent, label = props.label, _props$labelWidth = props.labelWidth, labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, notched = props.notched, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, other = (0, $eTwGP.default)(props, [
        "classes",
        "fullWidth",
        "inputComponent",
        "label",
        "labelWidth",
        "multiline",
        "notched",
        "type"
    ]);
    return /*#__PURE__*/ $ieT14.createElement((0, $eg6hn.default), (0, $edxsd.default)({
        renderSuffix: function renderSuffix(state) {
            return /*#__PURE__*/ $ieT14.createElement((0, $dSOCD.default), {
                className: classes.notchedOutline,
                label: label,
                labelWidth: labelWidth,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            });
        },
        classes: (0, $edxsd.default)({}, classes, {
            root: (0, $j6s32.default)(classes.root, classes.underline),
            notchedOutline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$98b66df633994e68$var$OutlinedInput.muiName = 'Input';
var $98b66df633994e68$export$2e2bcd8739ae039 = (0, $aIJrd.default)($98b66df633994e68$export$9dd6ff9ea0189349, {
    name: 'MuiOutlinedInput'
})($98b66df633994e68$var$OutlinedInput);

});
parcelRegister("dSOCD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1b796047a18539a$export$2e2bcd8739ae039; });

var $9p9Gy = parcelRequire("9p9Gy");

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $aIJrd = parcelRequire("aIJrd");

var $hgPMF = parcelRequire("hgPMF");

var $2EBFt = parcelRequire("2EBFt");
var $a1b796047a18539a$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: 'absolute',
            bottom: 0,
            right: 0,
            top: -5,
            left: 0,
            margin: 0,
            padding: '0 8px',
            pointerEvents: 'none',
            borderRadius: 'inherit',
            borderStyle: 'solid',
            borderWidth: 1,
            overflow: 'hidden'
        },
        /* Styles applied to the legend element when `labelWidth` is provided. */ legend: {
            textAlign: 'left',
            padding: 0,
            lineHeight: '11px',
            // sync with `height` in `legend` styles
            transition: theme.transitions.create('width', {
                duration: 150,
                easing: theme.transitions.easing.easeOut
            })
        },
        /* Styles applied to the legend element. */ legendLabelled: {
            display: 'block',
            width: 'auto',
            textAlign: 'left',
            padding: 0,
            height: 11,
            // sync with `lineHeight` in `legend` styles
            fontSize: '0.75em',
            visibility: 'hidden',
            maxWidth: 0.01,
            transition: theme.transitions.create('max-width', {
                duration: 50,
                easing: theme.transitions.easing.easeOut
            }),
            '& > span': {
                paddingLeft: 5,
                paddingRight: 5,
                display: 'inline-block'
            }
        },
        /* Styles applied to the legend element is notched. */ legendNotched: {
            maxWidth: 1000,
            transition: theme.transitions.create('max-width', {
                duration: 100,
                easing: theme.transitions.easing.easeOut,
                delay: 50
            })
        }
    };
};
/**
 * @ignore - internal component.
 */ var $a1b796047a18539a$var$NotchedOutline = /*#__PURE__*/ $ieT14.forwardRef(function NotchedOutline(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, label = props.label, labelWidthProp = props.labelWidth, notched = props.notched, style = props.style, other = (0, $eTwGP.default)(props, [
        "children",
        "classes",
        "className",
        "label",
        "labelWidth",
        "notched",
        "style"
    ]);
    var theme = (0, $hgPMF.default)();
    var align = theme.direction === 'rtl' ? 'right' : 'left';
    if (label !== undefined) return /*#__PURE__*/ $ieT14.createElement("fieldset", (0, $edxsd.default)({
        "aria-hidden": true,
        className: (0, $j6s32.default)(classes.root, className),
        ref: ref,
        style: style
    }, other), /*#__PURE__*/ $ieT14.createElement("legend", {
        className: (0, $j6s32.default)(classes.legendLabelled, notched && classes.legendNotched)
    }, label ? /*#__PURE__*/ $ieT14.createElement("span", null, label) : /*#__PURE__*/ $ieT14.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: '&#8203;'
        }
    })));
    var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
    return /*#__PURE__*/ $ieT14.createElement("fieldset", (0, $edxsd.default)({
        "aria-hidden": true,
        style: (0, $edxsd.default)((0, $9p9Gy.default)({}, "padding".concat((0, $2EBFt.default)(align)), 8), style),
        className: (0, $j6s32.default)(classes.root, className),
        ref: ref
    }, other), /*#__PURE__*/ $ieT14.createElement("legend", {
        className: classes.legend,
        style: {
            // IE 11: fieldset with legend does not render
            // a border radius. This maintains consistency
            // by always having a legend rendered
            width: notched ? labelWidth : 0.01
        }
    }, /*#__PURE__*/ $ieT14.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: '&#8203;'
        }
    })));
});
var $a1b796047a18539a$export$2e2bcd8739ae039 = (0, $aIJrd.default)($a1b796047a18539a$export$9dd6ff9ea0189349, {
    name: 'PrivateNotchedOutline'
})($a1b796047a18539a$var$NotchedOutline);

});



parcelRegister("7t0W0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56fbf76a850a6f32$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $1zXPm = parcelRequire("1zXPm");

var $kkrWC = parcelRequire("kkrWC");
var $56fbf76a850a6f32$var$styled = function styled(Component) {
    var componentCreator = (0, $1zXPm.default)(Component);
    return function(style, options) {
        return componentCreator(style, (0, $edxsd.default)({
            defaultTheme: (0, $kkrWC.default)
        }, options));
    };
};
var $56fbf76a850a6f32$export$2e2bcd8739ae039 = $56fbf76a850a6f32$var$styled;

});
parcelRegister("1zXPm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $126777c8dd798ffb$export$2e2bcd8739ae039; });

var $4gAfe = parcelRequire("4gAfe");

var $g0186 = parcelRequire("g0186");

var $ieT14 = parcelRequire("ieT14");

var $j6s32 = parcelRequire("j6s32");



var $6YpfP = parcelRequire("6YpfP");

var $db7Kr = parcelRequire("db7Kr");
function $126777c8dd798ffb$var$omit(input, fields) {
    var output = {};
    Object.keys(input).forEach(function(prop) {
        if (fields.indexOf(prop) === -1) output[prop] = input[prop];
    });
    return output;
} // styled-components's API removes the mapping between components and styles.
function $126777c8dd798ffb$export$2e2bcd8739ae039(Component) {
    var componentCreator = function componentCreator(style) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var name = options.name, stylesOptions = (0, $g0186.default)(options, [
            "name"
        ]);
        var classNamePrefix = name;
        var displayName;
        var stylesOrCreator = typeof style === 'function' ? function(theme) {
            return {
                root: function root(props) {
                    return style((0, $4gAfe.default)({
                        theme: theme
                    }, props));
                }
            };
        } : {
            root: style
        };
        var useStyles = (0, $db7Kr.default)(stylesOrCreator, (0, $4gAfe.default)({
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var filterProps;
        var propTypes = {};
        if (style.filterProps) {
            filterProps = style.filterProps;
            delete style.filterProps;
        }
        /* eslint-disable react/forbid-foreign-prop-types */ if (style.propTypes) {
            propTypes = style.propTypes;
            delete style.propTypes;
        }
        /* eslint-enable react/forbid-foreign-prop-types */ var StyledComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).forwardRef(function StyledComponent(props, ref) {
            var children = props.children, classNameProp = props.className, clone = props.clone, ComponentProp = props.component, other = (0, $g0186.default)(props, [
                "children",
                "className",
                "clone",
                "component"
            ]);
            var classes = useStyles(props);
            var className = (0, $j6s32.default)(classes.root, classNameProp);
            var spread = other;
            if (filterProps) spread = $126777c8dd798ffb$var$omit(spread, filterProps);
            if (clone) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).cloneElement(children, (0, $4gAfe.default)({
                className: (0, $j6s32.default)(children.props.className, className)
            }, spread));
            if (typeof children === 'function') return children((0, $4gAfe.default)({
                className: className
            }, spread));
            var FinalComponent = ComponentProp || Component;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement(FinalComponent, (0, $4gAfe.default)({
                ref: ref,
                className: className
            }, spread), children);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6YpfP)))(StyledComponent, Component);
        return StyledComponent;
    };
    return componentCreator;
}

});


parcelRegister("356Vi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23e7358474af4d49$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $dcIvM = parcelRequire("dcIvM");

var $eTwGP = parcelRequire("eTwGP");

var $9p9Gy = parcelRequire("9p9Gy");

var $ieT14 = parcelRequire("ieT14");

var $3tOoB = parcelRequire("3tOoB");


var $j6s32 = parcelRequire("j6s32");

var $3GOjU = parcelRequire("3GOjU");

var $86m3e = parcelRequire("86m3e");

var $aIJrd = parcelRequire("aIJrd");

var $2EBFt = parcelRequire("2EBFt");

var $27v2x = parcelRequire("27v2x");

var $cAxr1 = parcelRequire("cAxr1");

var $3A1Xf = parcelRequire("3A1Xf");

var $BEV8A = parcelRequire("BEV8A");

var $kC3Zv = parcelRequire("kC3Zv");

var $6LYoZ = parcelRequire("6LYoZ");

var $kuovH = parcelRequire("kuovH");

var $hgPMF = parcelRequire("hgPMF");
function $23e7358474af4d49$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
function $23e7358474af4d49$var$arrowGenerator() {
    return {
        '&[x-placement*="bottom"] $arrow': {
            top: 0,
            left: 0,
            marginTop: '-0.71em',
            marginLeft: 4,
            marginRight: 4,
            '&::before': {
                transformOrigin: '0 100%'
            }
        },
        '&[x-placement*="top"] $arrow': {
            bottom: 0,
            left: 0,
            marginBottom: '-0.71em',
            marginLeft: 4,
            marginRight: 4,
            '&::before': {
                transformOrigin: '100% 0'
            }
        },
        '&[x-placement*="right"] $arrow': {
            left: 0,
            marginLeft: '-0.71em',
            height: '1em',
            width: '0.71em',
            marginTop: 4,
            marginBottom: 4,
            '&::before': {
                transformOrigin: '100% 100%'
            }
        },
        '&[x-placement*="left"] $arrow': {
            right: 0,
            marginRight: '-0.71em',
            height: '1em',
            width: '0.71em',
            marginTop: 4,
            marginBottom: 4,
            '&::before': {
                transformOrigin: '0 0'
            }
        }
    };
}
var $23e7358474af4d49$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the Popper component. */ popper: {
            zIndex: theme.zIndex.tooltip,
            pointerEvents: 'none' // disable jss-rtl plugin
        },
        /* Styles applied to the Popper component if `interactive={true}`. */ popperInteractive: {
            pointerEvents: 'auto'
        },
        /* Styles applied to the Popper component if `arrow={true}`. */ popperArrow: $23e7358474af4d49$var$arrowGenerator(),
        /* Styles applied to the tooltip (label wrapper) element. */ tooltip: {
            backgroundColor: (0, $86m3e.alpha)(theme.palette.grey[700], 0.9),
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.common.white,
            fontFamily: theme.typography.fontFamily,
            padding: '4px 8px',
            fontSize: theme.typography.pxToRem(10),
            lineHeight: "".concat($23e7358474af4d49$var$round(1.4), "em"),
            maxWidth: 300,
            wordWrap: 'break-word',
            fontWeight: theme.typography.fontWeightMedium
        },
        /* Styles applied to the tooltip (label wrapper) element if `arrow={true}`. */ tooltipArrow: {
            position: 'relative',
            margin: '0'
        },
        /* Styles applied to the arrow element. */ arrow: {
            overflow: 'hidden',
            position: 'absolute',
            width: '1em',
            height: '0.71em',
            boxSizing: 'border-box',
            color: (0, $86m3e.alpha)(theme.palette.grey[700], 0.9),
            '&::before': {
                content: '""',
                margin: 'auto',
                display: 'block',
                width: '100%',
                height: '100%',
                backgroundColor: 'currentColor',
                transform: 'rotate(45deg)'
            }
        },
        /* Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */ touch: {
            padding: '8px 16px',
            fontSize: theme.typography.pxToRem(14),
            lineHeight: "".concat($23e7358474af4d49$var$round(16 / 14), "em"),
            fontWeight: theme.typography.fontWeightRegular
        },
        /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */ tooltipPlacementLeft: (0, $9p9Gy.default)({
            transformOrigin: 'right center',
            margin: '0 24px '
        }, theme.breakpoints.up('sm'), {
            margin: '0 14px'
        }),
        /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */ tooltipPlacementRight: (0, $9p9Gy.default)({
            transformOrigin: 'left center',
            margin: '0 24px'
        }, theme.breakpoints.up('sm'), {
            margin: '0 14px'
        }),
        /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */ tooltipPlacementTop: (0, $9p9Gy.default)({
            transformOrigin: 'center bottom',
            margin: '24px 0'
        }, theme.breakpoints.up('sm'), {
            margin: '14px 0'
        }),
        /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */ tooltipPlacementBottom: (0, $9p9Gy.default)({
            transformOrigin: 'center top',
            margin: '24px 0'
        }, theme.breakpoints.up('sm'), {
            margin: '14px 0'
        })
    };
};
var $23e7358474af4d49$var$hystersisOpen = false;
var $23e7358474af4d49$var$hystersisTimer = null;
function $23e7358474af4d49$export$b9ee5a7ace0541f8() {
    $23e7358474af4d49$var$hystersisOpen = false;
    clearTimeout($23e7358474af4d49$var$hystersisTimer);
}
var $23e7358474af4d49$var$Tooltip = /*#__PURE__*/ $ieT14.forwardRef(function Tooltip(props, ref) {
    var _props$arrow = props.arrow, arrow = _props$arrow === void 0 ? false : _props$arrow, children = props.children, classes = props.classes, _props$disableFocusLi = props.disableFocusListener, disableFocusListener = _props$disableFocusLi === void 0 ? false : _props$disableFocusLi, _props$disableHoverLi = props.disableHoverListener, disableHoverListener = _props$disableHoverLi === void 0 ? false : _props$disableHoverLi, _props$disableTouchLi = props.disableTouchListener, disableTouchListener = _props$disableTouchLi === void 0 ? false : _props$disableTouchLi, _props$enterDelay = props.enterDelay, enterDelay = _props$enterDelay === void 0 ? 100 : _props$enterDelay, _props$enterNextDelay = props.enterNextDelay, enterNextDelay = _props$enterNextDelay === void 0 ? 0 : _props$enterNextDelay, _props$enterTouchDela = props.enterTouchDelay, enterTouchDelay = _props$enterTouchDela === void 0 ? 700 : _props$enterTouchDela, idProp = props.id, _props$interactive = props.interactive, interactive = _props$interactive === void 0 ? false : _props$interactive, _props$leaveDelay = props.leaveDelay, leaveDelay = _props$leaveDelay === void 0 ? 0 : _props$leaveDelay, _props$leaveTouchDela = props.leaveTouchDelay, leaveTouchDelay = _props$leaveTouchDela === void 0 ? 1500 : _props$leaveTouchDela, onClose = props.onClose, onOpen = props.onOpen, openProp = props.open, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottom' : _props$placement, _props$PopperComponen = props.PopperComponent, PopperComponent = _props$PopperComponen === void 0 ? (0, $cAxr1.default) : _props$PopperComponen, PopperProps = props.PopperProps, title = props.title, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $27v2x.default) : _props$TransitionComp, TransitionProps = props.TransitionProps, other = (0, $eTwGP.default)(props, [
        "arrow",
        "children",
        "classes",
        "disableFocusListener",
        "disableHoverListener",
        "disableTouchListener",
        "enterDelay",
        "enterNextDelay",
        "enterTouchDelay",
        "id",
        "interactive",
        "leaveDelay",
        "leaveTouchDelay",
        "onClose",
        "onOpen",
        "open",
        "placement",
        "PopperComponent",
        "PopperProps",
        "title",
        "TransitionComponent",
        "TransitionProps"
    ]);
    var theme = (0, $hgPMF.default)();
    var _React$useState = $ieT14.useState(), childNode = _React$useState[0], setChildNode = _React$useState[1];
    var _React$useState2 = $ieT14.useState(null), arrowRef = _React$useState2[0], setArrowRef = _React$useState2[1];
    var ignoreNonTouchEvents = $ieT14.useRef(false);
    var closeTimer = $ieT14.useRef();
    var enterTimer = $ieT14.useRef();
    var leaveTimer = $ieT14.useRef();
    var touchTimer = $ieT14.useRef();
    var _useControlled = (0, $kuovH.default)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    }), _useControlled2 = (0, $dcIvM.default)(_useControlled, 2), openState = _useControlled2[0], setOpenState = _useControlled2[1];
    var open = openState;
    var _React$useRef, isControlled;
    var id = (0, $BEV8A.default)(idProp);
    $ieT14.useEffect(function() {
        return function() {
            clearTimeout(closeTimer.current);
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            clearTimeout(touchTimer.current);
        };
    }, []);
    var handleOpen = function handleOpen(event) {
        clearTimeout($23e7358474af4d49$var$hystersisTimer);
        $23e7358474af4d49$var$hystersisOpen = true; // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen) onOpen(event);
    };
    var handleEnter = function handleEnter() {
        var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return function(event) {
            var childrenProps = children.props;
            if (event.type === 'mouseover' && childrenProps.onMouseOver && forward) childrenProps.onMouseOver(event);
            if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
             // Remove the title ahead of time.
            // We don't want to wait for the next render commit.
            // We would risk displaying two tooltips at the same time (native + this one).
            if (childNode) childNode.removeAttribute('title');
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            if (enterDelay || $23e7358474af4d49$var$hystersisOpen && enterNextDelay) {
                event.persist();
                enterTimer.current = setTimeout(function() {
                    handleOpen(event);
                }, $23e7358474af4d49$var$hystersisOpen ? enterNextDelay : enterDelay);
            } else handleOpen(event);
        };
    };
    var _useIsFocusVisible = (0, $6LYoZ.default)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    var _React$useState3 = $ieT14.useState(false), childIsFocusVisible = _React$useState3[0], setChildIsFocusVisible = _React$useState3[1];
    var handleBlur = function handleBlur() {
        if (childIsFocusVisible) {
            setChildIsFocusVisible(false);
            onBlurVisible();
        }
    };
    var handleFocus = function handleFocus() {
        var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return function(event) {
            // Workaround for https://github.com/facebook/react/issues/7769
            // The autoFocus of React might trigger the event before the componentDidMount.
            // We need to account for this eventuality.
            if (!childNode) setChildNode(event.currentTarget);
            if (isFocusVisible(event)) {
                setChildIsFocusVisible(true);
                handleEnter()(event);
            }
            var childrenProps = children.props;
            if (childrenProps.onFocus && forward) childrenProps.onFocus(event);
        };
    };
    var handleClose = function handleClose(event) {
        clearTimeout($23e7358474af4d49$var$hystersisTimer);
        $23e7358474af4d49$var$hystersisTimer = setTimeout(function() {
            $23e7358474af4d49$var$hystersisOpen = false;
        }, 800 + leaveDelay);
        setOpenState(false);
        if (onClose) onClose(event);
        clearTimeout(closeTimer.current);
        closeTimer.current = setTimeout(function() {
            ignoreNonTouchEvents.current = false;
        }, theme.transitions.duration.shortest);
    };
    var handleLeave = function handleLeave() {
        var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return function(event) {
            var childrenProps = children.props;
            if (event.type === 'blur') {
                if (childrenProps.onBlur && forward) childrenProps.onBlur(event);
                handleBlur();
            }
            if (event.type === 'mouseleave' && childrenProps.onMouseLeave && event.currentTarget === childNode) childrenProps.onMouseLeave(event);
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            event.persist();
            leaveTimer.current = setTimeout(function() {
                handleClose(event);
            }, leaveDelay);
        };
    };
    var detectTouchStart = function detectTouchStart(event) {
        ignoreNonTouchEvents.current = true;
        var childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    var handleTouchStart = function handleTouchStart(event) {
        detectTouchStart(event);
        clearTimeout(leaveTimer.current);
        clearTimeout(closeTimer.current);
        clearTimeout(touchTimer.current);
        event.persist();
        touchTimer.current = setTimeout(function() {
            handleEnter()(event);
        }, enterTouchDelay);
    };
    var handleTouchEnd = function handleTouchEnd(event) {
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        clearTimeout(touchTimer.current);
        clearTimeout(leaveTimer.current);
        event.persist();
        leaveTimer.current = setTimeout(function() {
            handleClose(event);
        }, leaveTouchDelay);
    };
    var handleUseRef = (0, $3A1Xf.default)(setChildNode, ref);
    var handleFocusRef = (0, $3A1Xf.default)(focusVisibleRef, handleUseRef); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $ieT14.useCallback(function(instance) {
        // #StrictMode ready
        (0, $kC3Zv.default)(handleFocusRef, $3tOoB.findDOMNode(instance));
    }, [
        handleFocusRef
    ]);
    var handleRef = (0, $3A1Xf.default)(children.ref, handleOwnRef); // There is no point in displaying an empty tooltip.
    if (title === '') open = false;
     // For accessibility and SEO concerns, we render the title to the DOM node when
    // the tooltip is hidden. However, we have made a tradeoff when
    // `disableHoverListener` is set. This title logic is disabled.
    // It's allowing us to keep the implementation size minimal.
    // We are open to change the tradeoff.
    var shouldShowNativeTitle = !open && !disableHoverListener;
    var childrenProps = (0, $edxsd.default)({
        'aria-describedby': open ? id : null,
        title: shouldShowNativeTitle && typeof title === 'string' ? title : null
    }, other, children.props, {
        className: (0, $j6s32.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    });
    var interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = handleEnter();
        childrenProps.onMouseLeave = handleLeave();
        if (interactive) {
            interactiveWrapperListeners.onMouseOver = handleEnter(false);
            interactiveWrapperListeners.onMouseLeave = handleLeave(false);
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = handleFocus();
        childrenProps.onBlur = handleLeave();
        if (interactive) {
            interactiveWrapperListeners.onFocus = handleFocus(false);
            interactiveWrapperListeners.onBlur = handleLeave(false);
        }
    }
    var mergedPopperProps = $ieT14.useMemo(function() {
        return (0, $3GOjU.default)({
            popperOptions: {
                modifiers: {
                    arrow: {
                        enabled: Boolean(arrowRef),
                        element: arrowRef
                    }
                }
            }
        }, PopperProps);
    }, [
        arrowRef,
        PopperProps
    ]);
    return /*#__PURE__*/ $ieT14.createElement($ieT14.Fragment, null, /*#__PURE__*/ $ieT14.cloneElement(children, childrenProps), /*#__PURE__*/ $ieT14.createElement(PopperComponent, (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.popper, interactive && classes.popperInteractive, arrow && classes.popperArrow),
        placement: placement,
        anchorEl: childNode,
        open: childNode ? open : false,
        id: childrenProps['aria-describedby'],
        transition: true
    }, interactiveWrapperListeners, mergedPopperProps), function(_ref) {
        var placementInner = _ref.placement, TransitionPropsInner = _ref.TransitionProps;
        return /*#__PURE__*/ $ieT14.createElement(TransitionComponent, (0, $edxsd.default)({
            timeout: theme.transitions.duration.shorter
        }, TransitionPropsInner, TransitionProps), /*#__PURE__*/ $ieT14.createElement("div", {
            className: (0, $j6s32.default)(classes.tooltip, classes["tooltipPlacement".concat((0, $2EBFt.default)(placementInner.split('-')[0]))], ignoreNonTouchEvents.current && classes.touch, arrow && classes.tooltipArrow)
        }, title, arrow ? /*#__PURE__*/ $ieT14.createElement("span", {
            className: classes.arrow,
            ref: setArrowRef
        }) : null));
    }));
});
var $23e7358474af4d49$export$2e2bcd8739ae039 = (0, $aIJrd.default)($23e7358474af4d49$export$9dd6ff9ea0189349, {
    name: 'MuiTooltip',
    flip: false
})($23e7358474af4d49$var$Tooltip);

});
parcelRegister("cAxr1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92a2c84c562bed03$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $f6Enz = parcelRequire("f6Enz");


var $kfQ2O = parcelRequire("kfQ2O");

var $lVvVc = parcelRequire("lVvVc");

var $biB4f = parcelRequire("biB4f");

var $kC3Zv = parcelRequire("kC3Zv");

var $3A1Xf = parcelRequire("3A1Xf");
function $92a2c84c562bed03$var$flipPlacement(placement, theme) {
    var direction = theme && theme.direction || 'ltr';
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $92a2c84c562bed03$var$getAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
var $92a2c84c562bed03$var$useEnhancedEffect = typeof window !== 'undefined' ? $ieT14.useLayoutEffect : $ieT14.useEffect;
var $92a2c84c562bed03$var$defaultPopperOptions = {};
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v1/) for positioning.
 */ var $92a2c84c562bed03$var$Popper = /*#__PURE__*/ $ieT14.forwardRef(function Popper(props, ref) {
    var anchorEl = props.anchorEl, children = props.children, container = props.container, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, _props$keepMounted = props.keepMounted, keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted, modifiers = props.modifiers, open = props.open, _props$placement = props.placement, initialPlacement = _props$placement === void 0 ? 'bottom' : _props$placement, _props$popperOptions = props.popperOptions, popperOptions = _props$popperOptions === void 0 ? $92a2c84c562bed03$var$defaultPopperOptions : _props$popperOptions, popperRefProp = props.popperRef, style = props.style, _props$transition = props.transition, transition = _props$transition === void 0 ? false : _props$transition, other = (0, $eTwGP.default)(props, [
        "anchorEl",
        "children",
        "container",
        "disablePortal",
        "keepMounted",
        "modifiers",
        "open",
        "placement",
        "popperOptions",
        "popperRef",
        "style",
        "transition"
    ]);
    var tooltipRef = $ieT14.useRef(null);
    var ownRef = (0, $3A1Xf.default)(tooltipRef, ref);
    var popperRef = $ieT14.useRef(null);
    var handlePopperRef = (0, $3A1Xf.default)(popperRef, popperRefProp);
    var handlePopperRefRef = $ieT14.useRef(handlePopperRef);
    $92a2c84c562bed03$var$useEnhancedEffect(function() {
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $ieT14.useImperativeHandle(popperRefProp, function() {
        return popperRef.current;
    }, []);
    var _React$useState = $ieT14.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
    var theme = (0, $kfQ2O.default)();
    var rtlPlacement = $92a2c84c562bed03$var$flipPlacement(initialPlacement, theme);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ var _React$useState2 = $ieT14.useState(rtlPlacement), placement = _React$useState2[0], setPlacement = _React$useState2[1];
    $ieT14.useEffect(function() {
        if (popperRef.current) popperRef.current.update();
    });
    var handleOpen = $ieT14.useCallback(function() {
        if (!tooltipRef.current || !anchorEl || !open) return;
        if (popperRef.current) {
            popperRef.current.destroy();
            handlePopperRefRef.current(null);
        }
        var handlePopperUpdate = function handlePopperUpdate(data) {
            setPlacement(data.placement);
        };
        var resolvedAnchorEl = $92a2c84c562bed03$var$getAnchorEl(anchorEl);
        var box;
        var popper = new (0, $f6Enz.default)($92a2c84c562bed03$var$getAnchorEl(anchorEl), tooltipRef.current, (0, $edxsd.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: (0, $edxsd.default)({}, disablePortal ? {} : {
                // It's using scrollParent by default, we can use the viewport when using a portal.
                preventOverflow: {
                    boundariesElement: 'window'
                }
            }, modifiers, popperOptions.modifiers),
            // We could have been using a custom modifier like react-popper is doing.
            // But it seems this is the best public API for this use case.
            onCreate: (0, $biB4f.default)(handlePopperUpdate, popperOptions.onCreate),
            onUpdate: (0, $biB4f.default)(handlePopperUpdate, popperOptions.onUpdate)
        }));
        handlePopperRefRef.current(popper);
    }, [
        anchorEl,
        disablePortal,
        modifiers,
        open,
        rtlPlacement,
        popperOptions
    ]);
    var handleRef = $ieT14.useCallback(function(node) {
        (0, $kC3Zv.default)(ownRef, node);
        handleOpen();
    }, [
        ownRef,
        handleOpen
    ]);
    var handleEnter = function handleEnter() {
        setExited(false);
    };
    var handleClose = function handleClose() {
        if (!popperRef.current) return;
        popperRef.current.destroy();
        handlePopperRefRef.current(null);
    };
    var handleExited = function handleExited() {
        setExited(true);
        handleClose();
    };
    $ieT14.useEffect(function() {
        return function() {
            handleClose();
        };
    }, []);
    $ieT14.useEffect(function() {
        if (!open && !transition) // Otherwise handleExited will call this.
        handleClose();
    }, [
        open,
        transition
    ]);
    if (!keepMounted && !open && (!transition || exited)) return null;
    var childProps = {
        placement: placement
    };
    if (transition) childProps.TransitionProps = {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    };
    return /*#__PURE__*/ $ieT14.createElement((0, $lVvVc.default), {
        disablePortal: disablePortal,
        container: container
    }, /*#__PURE__*/ $ieT14.createElement("div", (0, $edxsd.default)({
        ref: handleRef,
        role: "tooltip"
    }, other, {
        style: (0, $edxsd.default)({
            // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
            position: 'fixed',
            // Fix Popper.js display issue
            top: 0,
            left: 0,
            display: !open && keepMounted && !transition ? 'none' : null
        }, style)
    }), typeof children === 'function' ? children(childProps) : children));
});
var $92a2c84c562bed03$export$2e2bcd8739ae039 = $92a2c84c562bed03$var$Popper;

});
parcelRegister("f6Enz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aff6bd07c355b4d9$export$2e2bcd8739ae039; });
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1-lts
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $aff6bd07c355b4d9$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
var $aff6bd07c355b4d9$var$timeoutDuration = function() {
    var longerTimeoutBrowsers = [
        'Edge',
        'Trident',
        'Firefox'
    ];
    for(var i = 0; i < longerTimeoutBrowsers.length; i += 1){
        if ($aff6bd07c355b4d9$var$isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) return 1;
    }
    return 0;
}();
function $aff6bd07c355b4d9$var$microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function $aff6bd07c355b4d9$var$taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, $aff6bd07c355b4d9$var$timeoutDuration);
        }
    };
}
var $aff6bd07c355b4d9$var$supportsMicroTasks = $aff6bd07c355b4d9$var$isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var $aff6bd07c355b4d9$var$debounce = $aff6bd07c355b4d9$var$supportsMicroTasks ? $aff6bd07c355b4d9$var$microtaskDebounce : $aff6bd07c355b4d9$var$taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function $aff6bd07c355b4d9$var$isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function $aff6bd07c355b4d9$var$getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var window1 = element.ownerDocument.defaultView;
    var css = window1.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function $aff6bd07c355b4d9$var$getParentNode(element) {
    if (element.nodeName === 'HTML') return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function $aff6bd07c355b4d9$var$getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case 'HTML':
        case 'BODY':
            return element.ownerDocument.body;
        case '#document':
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = $aff6bd07c355b4d9$var$getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return $aff6bd07c355b4d9$var$getScrollParent($aff6bd07c355b4d9$var$getParentNode(element));
}
/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */ function $aff6bd07c355b4d9$var$getReferenceNode(reference) {
    return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var $aff6bd07c355b4d9$var$isIE11 = $aff6bd07c355b4d9$var$isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var $aff6bd07c355b4d9$var$isIE10 = $aff6bd07c355b4d9$var$isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function $aff6bd07c355b4d9$var$isIE(version) {
    if (version === 11) return $aff6bd07c355b4d9$var$isIE11;
    if (version === 10) return $aff6bd07c355b4d9$var$isIE10;
    return $aff6bd07c355b4d9$var$isIE11 || $aff6bd07c355b4d9$var$isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function $aff6bd07c355b4d9$var$getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = $aff6bd07c355b4d9$var$isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        'TH',
        'TD',
        'TABLE'
    ].indexOf(offsetParent.nodeName) !== -1 && $aff6bd07c355b4d9$var$getStyleComputedProperty(offsetParent, 'position') === 'static') return $aff6bd07c355b4d9$var$getOffsetParent(offsetParent);
    return offsetParent;
}
function $aff6bd07c355b4d9$var$isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY') return false;
    return nodeName === 'HTML' || $aff6bd07c355b4d9$var$getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function $aff6bd07c355b4d9$var$getRoot(node) {
    if (node.parentNode !== null) return $aff6bd07c355b4d9$var$getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function $aff6bd07c355b4d9$var$findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if ($aff6bd07c355b4d9$var$isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return $aff6bd07c355b4d9$var$getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = $aff6bd07c355b4d9$var$getRoot(element1);
    if (element1root.host) return $aff6bd07c355b4d9$var$findCommonOffsetParent(element1root.host, element2);
    else return $aff6bd07c355b4d9$var$findCommonOffsetParent(element1, $aff6bd07c355b4d9$var$getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function $aff6bd07c355b4d9$var$getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
    var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function $aff6bd07c355b4d9$var$includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = $aff6bd07c355b4d9$var$getScroll(element, 'top');
    var scrollLeft = $aff6bd07c355b4d9$var$getScroll(element, 'left');
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function $aff6bd07c355b4d9$var$getBordersSize(styles, axis) {
    var sideA = axis === 'x' ? 'Left' : 'Top';
    var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
    return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}
function $aff6bd07c355b4d9$var$getSize(axis, body, html, computedStyle) {
    return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], $aff6bd07c355b4d9$var$isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}
function $aff6bd07c355b4d9$var$getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = $aff6bd07c355b4d9$var$isIE(10) && getComputedStyle(html);
    return {
        height: $aff6bd07c355b4d9$var$getSize('Height', body, html, computedStyle),
        width: $aff6bd07c355b4d9$var$getSize('Width', body, html, computedStyle)
    };
}
var $aff6bd07c355b4d9$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $aff6bd07c355b4d9$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $aff6bd07c355b4d9$var$defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $aff6bd07c355b4d9$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function $aff6bd07c355b4d9$var$getClientRect(offsets) {
    return $aff6bd07c355b4d9$var$_extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function $aff6bd07c355b4d9$var$getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if ($aff6bd07c355b4d9$var$isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = $aff6bd07c355b4d9$var$getScroll(element, 'top');
            var scrollLeft = $aff6bd07c355b4d9$var$getScroll(element, 'left');
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === 'HTML' ? $aff6bd07c355b4d9$var$getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.width;
    var height = sizes.height || element.clientHeight || result.height;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = $aff6bd07c355b4d9$var$getStyleComputedProperty(element);
        horizScrollbar -= $aff6bd07c355b4d9$var$getBordersSize(styles, 'x');
        vertScrollbar -= $aff6bd07c355b4d9$var$getBordersSize(styles, 'y');
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return $aff6bd07c355b4d9$var$getClientRect(result);
}
function $aff6bd07c355b4d9$var$getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = $aff6bd07c355b4d9$var$isIE(10);
    var isHTML = parent.nodeName === 'HTML';
    var childrenRect = $aff6bd07c355b4d9$var$getBoundingClientRect(children);
    var parentRect = $aff6bd07c355b4d9$var$getBoundingClientRect(parent);
    var scrollParent = $aff6bd07c355b4d9$var$getScrollParent(children);
    var styles = $aff6bd07c355b4d9$var$getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = $aff6bd07c355b4d9$var$getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop);
        var marginLeft = parseFloat(styles.marginLeft);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') offsets = $aff6bd07c355b4d9$var$includeScroll(offsets, parent);
    return offsets;
}
function $aff6bd07c355b4d9$var$getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = $aff6bd07c355b4d9$var$getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? $aff6bd07c355b4d9$var$getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? $aff6bd07c355b4d9$var$getScroll(html, 'left') : 0;
    var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return $aff6bd07c355b4d9$var$getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function $aff6bd07c355b4d9$var$isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') return false;
    if ($aff6bd07c355b4d9$var$getStyleComputedProperty(element, 'position') === 'fixed') return true;
    var parentNode = $aff6bd07c355b4d9$var$getParentNode(element);
    if (!parentNode) return false;
    return $aff6bd07c355b4d9$var$isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function $aff6bd07c355b4d9$var$getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || $aff6bd07c355b4d9$var$isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && $aff6bd07c355b4d9$var$getStyleComputedProperty(el, 'transform') === 'none')el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function $aff6bd07c355b4d9$var$getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? $aff6bd07c355b4d9$var$getFixedPositionOffsetParent(popper) : $aff6bd07c355b4d9$var$findCommonOffsetParent(popper, $aff6bd07c355b4d9$var$getReferenceNode(reference));
    // Handle viewport case
    if (boundariesElement === 'viewport') boundaries = $aff6bd07c355b4d9$var$getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === 'scrollParent') {
            boundariesNode = $aff6bd07c355b4d9$var$getScrollParent($aff6bd07c355b4d9$var$getParentNode(reference));
            if (boundariesNode.nodeName === 'BODY') boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === 'window') boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = $aff6bd07c355b4d9$var$getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === 'HTML' && !$aff6bd07c355b4d9$var$isFixed(offsetParent)) {
            var _getWindowSizes = $aff6bd07c355b4d9$var$getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === 'number';
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function $aff6bd07c355b4d9$var$getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $aff6bd07c355b4d9$var$computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf('auto') === -1) return placement;
    var boundaries = $aff6bd07c355b4d9$var$getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return $aff6bd07c355b4d9$var$_extends({
            key: key
        }, rects[key], {
            area: $aff6bd07c355b4d9$var$getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split('-')[1];
    return computedPlacement + (variation ? '-' + variation : '');
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function $aff6bd07c355b4d9$var$getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? $aff6bd07c355b4d9$var$getFixedPositionOffsetParent(popper) : $aff6bd07c355b4d9$var$findCommonOffsetParent(popper, $aff6bd07c355b4d9$var$getReferenceNode(reference));
    return $aff6bd07c355b4d9$var$getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function $aff6bd07c355b4d9$var$getOuterSizes(element) {
    var window1 = element.ownerDocument.defaultView;
    var styles = window1.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function $aff6bd07c355b4d9$var$getOppositePlacement(placement) {
    var hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function $aff6bd07c355b4d9$var$getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split('-')[0];
    // Get popper node sizes
    var popperRect = $aff6bd07c355b4d9$var$getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        'right',
        'left'
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? 'top' : 'left';
    var secondarySide = isHoriz ? 'left' : 'top';
    var measurement = isHoriz ? 'height' : 'width';
    var secondaryMeasurement = !isHoriz ? 'height' : 'width';
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[$aff6bd07c355b4d9$var$getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $aff6bd07c355b4d9$var$find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $aff6bd07c355b4d9$var$findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = $aff6bd07c355b4d9$var$find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function $aff6bd07c355b4d9$var$runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, $aff6bd07c355b4d9$var$findIndex(modifiers, 'name', ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier['function']) // eslint-disable-line dot-notation
        console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
        var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && $aff6bd07c355b4d9$var$isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = $aff6bd07c355b4d9$var$getClientRect(data.offsets.popper);
            data.offsets.reference = $aff6bd07c355b4d9$var$getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function $aff6bd07c355b4d9$var$update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = $aff6bd07c355b4d9$var$getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = $aff6bd07c355b4d9$var$computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = $aff6bd07c355b4d9$var$getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
    // run the modifiers
    data = $aff6bd07c355b4d9$var$runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function $aff6bd07c355b4d9$var$isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function $aff6bd07c355b4d9$var$getSupportedPropertyName(property) {
    var prefixes = [
        false,
        'ms',
        'Webkit',
        'Moz',
        'O'
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? '' + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== 'undefined') return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function $aff6bd07c355b4d9$var$destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if ($aff6bd07c355b4d9$var$isModifierEnabled(this.modifiers, 'applyStyle')) {
        this.popper.removeAttribute('x-placement');
        this.popper.style.position = '';
        this.popper.style.top = '';
        this.popper.style.left = '';
        this.popper.style.right = '';
        this.popper.style.bottom = '';
        this.popper.style.willChange = '';
        this.popper.style[$aff6bd07c355b4d9$var$getSupportedPropertyName('transform')] = '';
    }
    this.disableEventListeners();
    // remove the popper if user explicitly asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function $aff6bd07c355b4d9$var$getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function $aff6bd07c355b4d9$var$attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === 'BODY';
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) $aff6bd07c355b4d9$var$attachToScrollParents($aff6bd07c355b4d9$var$getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $aff6bd07c355b4d9$var$setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    $aff6bd07c355b4d9$var$getWindow(reference).addEventListener('resize', state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = $aff6bd07c355b4d9$var$getScrollParent(reference);
    $aff6bd07c355b4d9$var$attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function $aff6bd07c355b4d9$var$enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = $aff6bd07c355b4d9$var$setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $aff6bd07c355b4d9$var$removeEventListeners(reference, state) {
    // Remove resize event listener on window
    $aff6bd07c355b4d9$var$getWindow(reference).removeEventListener('resize', state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener('scroll', state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function $aff6bd07c355b4d9$var$disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = $aff6bd07c355b4d9$var$removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function $aff6bd07c355b4d9$var$isNumeric(n) {
    return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $aff6bd07c355b4d9$var$setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = '';
        // add unit if the value is numeric and is one of the following
        if ([
            'width',
            'height',
            'top',
            'right',
            'bottom',
            'left'
        ].indexOf(prop) !== -1 && $aff6bd07c355b4d9$var$isNumeric(styles[prop])) unit = 'px';
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $aff6bd07c355b4d9$var$setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function $aff6bd07c355b4d9$var$applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    $aff6bd07c355b4d9$var$setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    $aff6bd07c355b4d9$var$setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) $aff6bd07c355b4d9$var$setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function $aff6bd07c355b4d9$var$applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = $aff6bd07c355b4d9$var$getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = $aff6bd07c355b4d9$var$computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute('x-placement', placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    $aff6bd07c355b4d9$var$setStyles(popper, {
        position: options.positionFixed ? 'fixed' : 'absolute'
    });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */ function $aff6bd07c355b4d9$var$getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = [
        'left',
        'right'
    ].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf('-') !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var $aff6bd07c355b4d9$var$isFirefox = $aff6bd07c355b4d9$var$isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $aff6bd07c355b4d9$var$computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = $aff6bd07c355b4d9$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'applyStyle';
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = $aff6bd07c355b4d9$var$getOffsetParent(data.instance.popper);
    var offsetParentRect = $aff6bd07c355b4d9$var$getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = $aff6bd07c355b4d9$var$getRoundedOffsets(data, window.devicePixelRatio < 2 || !$aff6bd07c355b4d9$var$isFirefox);
    var sideA = x === 'bottom' ? 'top' : 'bottom';
    var sideB = y === 'right' ? 'left' : 'right';
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = $aff6bd07c355b4d9$var$getSupportedPropertyName('transform');
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === 'bottom') {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === 'HTML') top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === 'right') {
        if (offsetParent.nodeName === 'HTML') left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = 'transform';
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === 'bottom' ? -1 : 1;
        var invertLeft = sideB === 'right' ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ', ' + sideB;
    }
    // Attributes
    var attributes = {
        'x-placement': data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = $aff6bd07c355b4d9$var$_extends({}, attributes, data.attributes);
    data.styles = $aff6bd07c355b4d9$var$_extends({}, styles, data.styles);
    data.arrowStyles = $aff6bd07c355b4d9$var$_extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function $aff6bd07c355b4d9$var$isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = $aff6bd07c355b4d9$var$find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = '`' + requestingName + '`';
        var requested = '`' + requestedName + '`';
        console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $aff6bd07c355b4d9$var$arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!$aff6bd07c355b4d9$var$isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn('WARNING: `arrow.element` must be child of its popper element!');
        return data;
    }
    var placement = data.placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        'left',
        'right'
    ].indexOf(placement) !== -1;
    var len = isVertical ? 'height' : 'width';
    var sideCapitalized = isVertical ? 'Top' : 'Left';
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? 'left' : 'top';
    var opSide = isVertical ? 'bottom' : 'right';
    var arrowElementSize = $aff6bd07c355b4d9$var$getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = $aff6bd07c355b4d9$var$getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = $aff6bd07c355b4d9$var$getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
    var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, $aff6bd07c355b4d9$var$defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), $aff6bd07c355b4d9$var$defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function $aff6bd07c355b4d9$var$getOppositeVariation(variation) {
    if (variation === 'end') return 'start';
    else if (variation === 'start') return 'end';
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var $aff6bd07c355b4d9$var$placements = [
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start'
];
// Get rid of `auto` `auto-start` and `auto-end`
var $aff6bd07c355b4d9$var$validPlacements = $aff6bd07c355b4d9$var$placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function $aff6bd07c355b4d9$var$clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = $aff6bd07c355b4d9$var$validPlacements.indexOf(placement);
    var arr = $aff6bd07c355b4d9$var$validPlacements.slice(index + 1).concat($aff6bd07c355b4d9$var$validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var $aff6bd07c355b4d9$var$BEHAVIORS = {
    FLIP: 'flip',
    CLOCKWISE: 'clockwise',
    COUNTERCLOCKWISE: 'counterclockwise'
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $aff6bd07c355b4d9$var$flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if ($aff6bd07c355b4d9$var$isModifierEnabled(data.instance.modifiers, 'inner')) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = $aff6bd07c355b4d9$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split('-')[0];
    var placementOpposite = $aff6bd07c355b4d9$var$getOppositePlacement(placement);
    var variation = data.placement.split('-')[1] || '';
    var flipOrder = [];
    switch(options.behavior){
        case $aff6bd07c355b4d9$var$BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case $aff6bd07c355b4d9$var$BEHAVIORS.CLOCKWISE:
            flipOrder = $aff6bd07c355b4d9$var$clockwise(placement);
            break;
        case $aff6bd07c355b4d9$var$BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = $aff6bd07c355b4d9$var$clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split('-')[0];
        placementOpposite = $aff6bd07c355b4d9$var$getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            'top',
            'bottom'
        ].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = $aff6bd07c355b4d9$var$getOppositeVariation(variation);
            data.placement = placement + (variation ? '-' + variation : '');
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = $aff6bd07c355b4d9$var$_extends({}, data.offsets.popper, $aff6bd07c355b4d9$var$getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = $aff6bd07c355b4d9$var$runModifiers(data.instance.modifiers, data, 'flip');
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $aff6bd07c355b4d9$var$keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split('-')[0];
    var floor = Math.floor;
    var isVertical = [
        'top',
        'bottom'
    ].indexOf(placement) !== -1;
    var side = isVertical ? 'right' : 'bottom';
    var opSide = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function $aff6bd07c355b4d9$var$toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf('%') === 0) {
        var element = void 0;
        switch(unit){
            case '%p':
                element = popperOffsets;
                break;
            case '%':
            case '%r':
            default:
                element = referenceOffsets;
        }
        var rect = $aff6bd07c355b4d9$var$getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === 'vh' || unit === 'vw') {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === 'vh') size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function $aff6bd07c355b4d9$var$parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        'right',
        'left'
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf($aff6bd07c355b4d9$var$find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(',') === -1) console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === '' && [
                '+',
                '-'
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return $aff6bd07c355b4d9$var$toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if ($aff6bd07c355b4d9$var$isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function $aff6bd07c355b4d9$var$offset(data, _ref) {
    var offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split('-')[0];
    var offsets = void 0;
    if ($aff6bd07c355b4d9$var$isNumeric(+offset)) offsets = [
        +offset,
        0
    ];
    else offsets = $aff6bd07c355b4d9$var$parseOffset(offset, popper, reference, basePlacement);
    if (basePlacement === 'left') {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === 'right') {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === 'top') {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === 'bottom') {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $aff6bd07c355b4d9$var$preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || $aff6bd07c355b4d9$var$getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = $aff6bd07c355b4d9$var$getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = $aff6bd07c355b4d9$var$getSupportedPropertyName('transform');
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = '';
    popperStyles.left = '';
    popperStyles[transformProp] = '';
    var boundaries = $aff6bd07c355b4d9$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return $aff6bd07c355b4d9$var$defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === 'right' ? 'left' : 'top';
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
            return $aff6bd07c355b4d9$var$defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            'left',
            'top'
        ].indexOf(placement) !== -1 ? 'primary' : 'secondary';
        popper = $aff6bd07c355b4d9$var$_extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $aff6bd07c355b4d9$var$shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var shiftvariation = placement.split('-')[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            'bottom',
            'top'
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? 'left' : 'top';
        var measurement = isVertical ? 'width' : 'height';
        var shiftOffsets = {
            start: $aff6bd07c355b4d9$var$defineProperty({}, side, reference[side]),
            end: $aff6bd07c355b4d9$var$defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = $aff6bd07c355b4d9$var$_extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $aff6bd07c355b4d9$var$hide(data) {
    if (!$aff6bd07c355b4d9$var$isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) return data;
    var refRect = data.offsets.reference;
    var bound = $aff6bd07c355b4d9$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'preventOverflow';
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes['x-out-of-boundaries'] = '';
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes['x-out-of-boundaries'] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $aff6bd07c355b4d9$var$inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        'left',
        'right'
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        'top',
        'left'
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
    data.placement = $aff6bd07c355b4d9$var$getOppositePlacement(placement);
    data.offsets.popper = $aff6bd07c355b4d9$var$getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var $aff6bd07c355b4d9$var$modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $aff6bd07c355b4d9$var$shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $aff6bd07c355b4d9$var$offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $aff6bd07c355b4d9$var$preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            'left',
            'right',
            'top',
            'bottom'
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: 'scrollParent'
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $aff6bd07c355b4d9$var$keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $aff6bd07c355b4d9$var$arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: '[x-arrow]'
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $aff6bd07c355b4d9$var$flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: 'flip',
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: 'viewport',
        /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariations: false,
        /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariationsByContent: false
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: $aff6bd07c355b4d9$var$inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $aff6bd07c355b4d9$var$hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $aff6bd07c355b4d9$var$computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: 'bottom',
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: 'right'
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $aff6bd07c355b4d9$var$applyStyle,
        /** @prop {Function} */ onLoad: $aff6bd07c355b4d9$var$applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var $aff6bd07c355b4d9$var$Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: 'bottom',
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: $aff6bd07c355b4d9$var$modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var $aff6bd07c355b4d9$var$Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $aff6bd07c355b4d9$var$classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = $aff6bd07c355b4d9$var$debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = $aff6bd07c355b4d9$var$_extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys($aff6bd07c355b4d9$var$_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = $aff6bd07c355b4d9$var$_extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return $aff6bd07c355b4d9$var$_extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && $aff6bd07c355b4d9$var$isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    $aff6bd07c355b4d9$var$createClass(Popper, [
        {
            key: 'update',
            value: function update$$1() {
                return $aff6bd07c355b4d9$var$update.call(this);
            }
        },
        {
            key: 'destroy',
            value: function destroy$$1() {
                return $aff6bd07c355b4d9$var$destroy.call(this);
            }
        },
        {
            key: 'enableEventListeners',
            value: function enableEventListeners$$1() {
                return $aff6bd07c355b4d9$var$enableEventListeners.call(this);
            }
        },
        {
            key: 'disableEventListeners',
            value: function disableEventListeners$$1() {
                return $aff6bd07c355b4d9$var$disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ $aff6bd07c355b4d9$var$Popper.Utils = (typeof window !== 'undefined' ? window : $parcel$global).PopperUtils;
$aff6bd07c355b4d9$var$Popper.placements = $aff6bd07c355b4d9$var$placements;
$aff6bd07c355b4d9$var$Popper.Defaults = $aff6bd07c355b4d9$var$Defaults;
var $aff6bd07c355b4d9$export$2e2bcd8739ae039 = $aff6bd07c355b4d9$var$Popper;

});


parcelRegister("BEV8A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $071332ca0c6f7353$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");
function $071332ca0c6f7353$export$2e2bcd8739ae039(idOverride) {
    var _React$useState = $ieT14.useState(idOverride), defaultId = _React$useState[0], setDefaultId = _React$useState[1];
    var id = idOverride || defaultId;
    $ieT14.useEffect(function() {
        if (defaultId == null) // Fallback to this default id when possible.
        // Use the random value for client-side rendering only.
        // We can't use it server-side.
        setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }, [
        defaultId
    ]);
    return id;
}

});


parcelRegister("6mt9R", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", function () { return $4a1b6a5005968e71$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "HashRouter", function () { return $4a1b6a5005968e71$export$7221d69dcfc8e36b; });
$parcel$export(module.exports, "Link", function () { return $4a1b6a5005968e71$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "NavLink", function () { return $4a1b6a5005968e71$export$b0d92dbee9b5b60d; });
$parcel$export(module.exports, "MemoryRouter", function () { return (parcelRequire("eYoAG")).MemoryRouter; });
$parcel$export(module.exports, "Prompt", function () { return (parcelRequire("eYoAG")).Prompt; });
$parcel$export(module.exports, "Redirect", function () { return (parcelRequire("eYoAG")).Redirect; });
$parcel$export(module.exports, "Route", function () { return (parcelRequire("eYoAG")).Route; });
$parcel$export(module.exports, "Router", function () { return (parcelRequire("eYoAG")).Router; });
$parcel$export(module.exports, "StaticRouter", function () { return (parcelRequire("eYoAG")).StaticRouter; });
$parcel$export(module.exports, "Switch", function () { return (parcelRequire("eYoAG")).Switch; });
$parcel$export(module.exports, "generatePath", function () { return (parcelRequire("eYoAG")).generatePath; });
$parcel$export(module.exports, "matchPath", function () { return (parcelRequire("eYoAG")).matchPath; });
$parcel$export(module.exports, "useHistory", function () { return (parcelRequire("eYoAG")).useHistory; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("eYoAG")).useLocation; });
$parcel$export(module.exports, "useParams", function () { return (parcelRequire("eYoAG")).useParams; });
$parcel$export(module.exports, "useRouteMatch", function () { return (parcelRequire("eYoAG")).useRouteMatch; });
$parcel$export(module.exports, "withRouter", function () { return (parcelRequire("eYoAG")).withRouter; });

var $eYoAG = parcelRequire("eYoAG");

var $cVomO = parcelRequire("cVomO");

var $ieT14 = parcelRequire("ieT14");

var $jz0Qr = parcelRequire("jz0Qr");



var $6nmdQ = parcelRequire("6nmdQ");

var $891MO = parcelRequire("891MO");

var $kuuqU = parcelRequire("kuuqU");
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $4a1b6a5005968e71$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $cVomO.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $jz0Qr.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement((0, $eYoAG.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $4a1b6a5005968e71$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $cVomO.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $jz0Qr.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement((0, $eYoAG.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).Component);
var $4a1b6a5005968e71$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $4a1b6a5005968e71$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $jz0Qr.createLocation)(to, null, null, currentLocation) : to;
};
var $4a1b6a5005968e71$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $4a1b6a5005968e71$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).forwardRef;
if (typeof $4a1b6a5005968e71$var$forwardRef === "undefined") $4a1b6a5005968e71$var$forwardRef = $4a1b6a5005968e71$var$forwardRefShim;
function $4a1b6a5005968e71$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $4a1b6a5005968e71$var$LinkAnchor = $4a1b6a5005968e71$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $891MO.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $6nmdQ.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$4a1b6a5005968e71$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($4a1b6a5005968e71$var$forwardRefShim !== $4a1b6a5005968e71$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $4a1b6a5005968e71$export$a6c7ac8248d6e38a = $4a1b6a5005968e71$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $4a1b6a5005968e71$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $891MO.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement((0, $eYoAG.__RouterContext).Consumer, null, function(context) {
        !context && (0, $kuuqU.default)(false);
        var history = context.history;
        var location = $4a1b6a5005968e71$var$normalizeToLocation($4a1b6a5005968e71$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $6nmdQ.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $4a1b6a5005968e71$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $jz0Qr.createPath)(context.location) === (0, $jz0Qr.createPath)($4a1b6a5005968e71$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($4a1b6a5005968e71$var$forwardRefShim !== $4a1b6a5005968e71$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement(component, props);
    });
});
var $4a1b6a5005968e71$var$toType, $4a1b6a5005968e71$var$refType;
var $4a1b6a5005968e71$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $4a1b6a5005968e71$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).forwardRef;
if (typeof $4a1b6a5005968e71$var$forwardRef$1 === "undefined") $4a1b6a5005968e71$var$forwardRef$1 = $4a1b6a5005968e71$var$forwardRefShim$1;
function $4a1b6a5005968e71$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $4a1b6a5005968e71$export$b0d92dbee9b5b60d = $4a1b6a5005968e71$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $891MO.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement((0, $eYoAG.__RouterContext).Consumer, null, function(context) {
        !context && (0, $kuuqU.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $4a1b6a5005968e71$var$normalizeToLocation($4a1b6a5005968e71$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $eYoAG.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $4a1b6a5005968e71$var$joinClassnames(className, activeClassName);
            style = (0, $6nmdQ.default)({}, style, activeStyle);
        }
        var props = (0, $6nmdQ.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($4a1b6a5005968e71$var$forwardRefShim$1 !== $4a1b6a5005968e71$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($4a1b6a5005968e71$export$a6c7ac8248d6e38a, props);
    });
});
var $4a1b6a5005968e71$var$ariaCurrentType;

});
parcelRegister("eYoAG", function(module, exports) {

$parcel$export(module.exports, "__RouterContext", function () { return $ae69be746fee84b4$export$63baa8ccbe60bb07; });
$parcel$export(module.exports, "Router", function () { return $ae69be746fee84b4$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "MemoryRouter", function () { return $ae69be746fee84b4$export$ae46f04cfaffe093; });
$parcel$export(module.exports, "Prompt", function () { return $ae69be746fee84b4$export$83716a4aa1642908; });
$parcel$export(module.exports, "generatePath", function () { return $ae69be746fee84b4$export$82476f982757e71e; });
$parcel$export(module.exports, "Redirect", function () { return $ae69be746fee84b4$export$2d8d895a0a0f636e; });
$parcel$export(module.exports, "matchPath", function () { return $ae69be746fee84b4$export$81336c211d5ff295; });
$parcel$export(module.exports, "Route", function () { return $ae69be746fee84b4$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "StaticRouter", function () { return $ae69be746fee84b4$export$cac06da4d76d935b; });
$parcel$export(module.exports, "Switch", function () { return $ae69be746fee84b4$export$b5d5cf8927ab7262; });
$parcel$export(module.exports, "withRouter", function () { return $ae69be746fee84b4$export$369b6b2b30582e8e; });
$parcel$export(module.exports, "useHistory", function () { return $ae69be746fee84b4$export$3420e1dc2c4a518c; });
$parcel$export(module.exports, "useLocation", function () { return $ae69be746fee84b4$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useParams", function () { return $ae69be746fee84b4$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "useRouteMatch", function () { return $ae69be746fee84b4$export$632be4bb944c1bc7; });

var $ipjou = parcelRequire("ipjou");

var $ieT14 = parcelRequire("ieT14");

var $aLnZv = parcelRequire("aLnZv");

var $jz0Qr = parcelRequire("jz0Qr");


var $kuuqU = parcelRequire("kuuqU");

var $791Yt = parcelRequire("791Yt");

var $cydz8 = parcelRequire("cydz8");
parcelRequire("lI8NJ");

var $6zhis = parcelRequire("6zhis");

var $6YpfP = parcelRequire("6YpfP");
var $ae69be746fee84b4$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $ae69be746fee84b4$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $ae69be746fee84b4$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $ae69be746fee84b4$var$commonjsGlobal[key] = ($ae69be746fee84b4$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $ae69be746fee84b4$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $ae69be746fee84b4$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $ae69be746fee84b4$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $ae69be746fee84b4$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $ae69be746fee84b4$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $ipjou.default)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $ae69be746fee84b4$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($ae69be746fee84b4$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $ae69be746fee84b4$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($aLnZv))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $ipjou.default)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $ae69be746fee84b4$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $ae69be746fee84b4$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $ae69be746fee84b4$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($aLnZv))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $ae69be746fee84b4$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createContext || $ae69be746fee84b4$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $ae69be746fee84b4$var$createNamedContext = function createNamedContext(name) {
    var context = $ae69be746fee84b4$var$createContext();
    context.displayName = name;
    return context;
};
var $ae69be746fee84b4$export$c213558b66925821 = /*#__PURE__*/ $ae69be746fee84b4$var$createNamedContext("Router-History");
var $ae69be746fee84b4$export$63baa8ccbe60bb07 = /*#__PURE__*/ $ae69be746fee84b4$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $ae69be746fee84b4$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $ipjou.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($ae69be746fee84b4$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($ae69be746fee84b4$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $ae69be746fee84b4$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $ipjou.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $jz0Qr.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($ae69be746fee84b4$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).Component);
var $ae69be746fee84b4$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $ipjou.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $ae69be746fee84b4$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($ae69be746fee84b4$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $kuuqU.default)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($ae69be746fee84b4$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $ae69be746fee84b4$var$messageType;
var $ae69be746fee84b4$var$cache = {};
var $ae69be746fee84b4$var$cacheLimit = 10000;
var $ae69be746fee84b4$var$cacheCount = 0;
function $ae69be746fee84b4$var$compilePath(path) {
    if ($ae69be746fee84b4$var$cache[path]) return $ae69be746fee84b4$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($cydz8))).compile(path);
    if ($ae69be746fee84b4$var$cacheCount < $ae69be746fee84b4$var$cacheLimit) {
        $ae69be746fee84b4$var$cache[path] = generator;
        $ae69be746fee84b4$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $ae69be746fee84b4$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $ae69be746fee84b4$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $ae69be746fee84b4$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($ae69be746fee84b4$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $kuuqU.default)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $jz0Qr.createLocation)(computedMatch ? typeof to === "string" ? $ae69be746fee84b4$export$82476f982757e71e(to, computedMatch.params) : (0, $791Yt.default)({}, to, {
            pathname: $ae69be746fee84b4$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($ae69be746fee84b4$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $jz0Qr.createLocation)(prevProps.to);
                if (!(0, $jz0Qr.locationsAreEqual)(prevLocation, (0, $791Yt.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $ae69be746fee84b4$var$cache$1 = {};
var $ae69be746fee84b4$var$cacheLimit$1 = 10000;
var $ae69be746fee84b4$var$cacheCount$1 = 0;
function $ae69be746fee84b4$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $ae69be746fee84b4$var$cache$1[cacheKey] || ($ae69be746fee84b4$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($cydz8)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($ae69be746fee84b4$var$cacheCount$1 < $ae69be746fee84b4$var$cacheLimit$1) {
        pathCache[path] = result;
        $ae69be746fee84b4$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $ae69be746fee84b4$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $ae69be746fee84b4$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $ae69be746fee84b4$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).Children.count(children) === 0;
}
function $ae69be746fee84b4$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $ae69be746fee84b4$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $ipjou.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($ae69be746fee84b4$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $kuuqU.default)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $ae69be746fee84b4$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $791Yt.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $ae69be746fee84b4$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($ae69be746fee84b4$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).Component);
function $ae69be746fee84b4$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $ae69be746fee84b4$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $791Yt.default)({}, location, {
        pathname: $ae69be746fee84b4$var$addLeadingSlash(basename) + location.pathname
    });
}
function $ae69be746fee84b4$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $ae69be746fee84b4$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $791Yt.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $ae69be746fee84b4$var$createURL(location) {
    return typeof location === "string" ? location : (0, $jz0Qr.createPath)(location);
}
function $ae69be746fee84b4$var$staticHandler(methodName) {
    return function() {
        (0, $kuuqU.default)(false);
    };
}
function $ae69be746fee84b4$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $ae69be746fee84b4$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $ipjou.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $ae69be746fee84b4$var$noop;
        };
        _this.handleBlock = function() {
            return $ae69be746fee84b4$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $ae69be746fee84b4$var$addBasename(basename, (0, $jz0Qr.createLocation)(location));
        context.url = $ae69be746fee84b4$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $6zhis.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $ae69be746fee84b4$var$addLeadingSlash(basename + $ae69be746fee84b4$var$createURL(path));
            },
            action: "POP",
            location: $ae69be746fee84b4$var$stripBasename(basename, (0, $jz0Qr.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $ae69be746fee84b4$var$staticHandler("go"),
            goBack: $ae69be746fee84b4$var$staticHandler("goBack"),
            goForward: $ae69be746fee84b4$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($ae69be746fee84b4$export$55185c17a0fcbe46, (0, $791Yt.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $ae69be746fee84b4$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $ipjou.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($ae69be746fee84b4$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $kuuqU.default)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $ae69be746fee84b4$export$81336c211d5ff295(location.pathname, (0, $791Yt.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $ae69be746fee84b4$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $6zhis.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($ae69be746fee84b4$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $kuuqU.default)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement(Component, (0, $791Yt.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6YpfP)))(C, Component);
}
var $ae69be746fee84b4$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useContext;
function $ae69be746fee84b4$export$3420e1dc2c4a518c() {
    return $ae69be746fee84b4$var$useContext($ae69be746fee84b4$export$c213558b66925821);
}
function $ae69be746fee84b4$export$45d76561a5302f2b() {
    return $ae69be746fee84b4$var$useContext($ae69be746fee84b4$export$63baa8ccbe60bb07).location;
}
function $ae69be746fee84b4$export$99eaa27ddbbb95ef() {
    var match = $ae69be746fee84b4$var$useContext($ae69be746fee84b4$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $ae69be746fee84b4$export$632be4bb944c1bc7(path) {
    var location = $ae69be746fee84b4$export$45d76561a5302f2b();
    var match = $ae69be746fee84b4$var$useContext($ae69be746fee84b4$export$63baa8ccbe60bb07).match;
    return path ? $ae69be746fee84b4$export$81336c211d5ff295(location.pathname, path) : match;
}
var $ae69be746fee84b4$var$global$1, $ae69be746fee84b4$var$key, $ae69be746fee84b4$var$buildNames, $ae69be746fee84b4$var$initialBuildName, $ae69be746fee84b4$var$secondaryBuildName;

});
parcelRegister("ipjou", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6699b09ab27339e$export$2e2bcd8739ae039; });

var $geCg8 = parcelRequire("geCg8");
function $d6699b09ab27339e$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $geCg8.default)(t, o);
}

});
parcelRegister("geCg8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd1ba1a12b257caf$export$2e2bcd8739ae039; });
function $bd1ba1a12b257caf$export$2e2bcd8739ae039(t, e) {
    return $bd1ba1a12b257caf$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $bd1ba1a12b257caf$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("aLnZv", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0205b1264a1f46b7$var$ReactIs, $0205b1264a1f46b7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hftWx"))();

});

parcelRegister("jz0Qr", function(module, exports) {

$parcel$export(module.exports, "createPath", function () { return $e3e1f0fd5c4c9e8d$export$fe53371bee54353d; });
$parcel$export(module.exports, "createLocation", function () { return $e3e1f0fd5c4c9e8d$export$90c043f1c57770b8; });
$parcel$export(module.exports, "locationsAreEqual", function () { return $e3e1f0fd5c4c9e8d$export$c3e8bb440bd55b18; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $e3e1f0fd5c4c9e8d$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $e3e1f0fd5c4c9e8d$export$b71fdd3798280242; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $e3e1f0fd5c4c9e8d$export$2b76ad033c6e6d08; });

var $eqpm3 = parcelRequire("eqpm3");

var $hZqi0 = parcelRequire("hZqi0");

var $2lj2u = parcelRequire("2lj2u");


var $kuuqU = parcelRequire("kuuqU");
function $e3e1f0fd5c4c9e8d$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $e3e1f0fd5c4c9e8d$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $e3e1f0fd5c4c9e8d$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $e3e1f0fd5c4c9e8d$var$stripBasename(path, prefix) {
    return $e3e1f0fd5c4c9e8d$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $e3e1f0fd5c4c9e8d$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $e3e1f0fd5c4c9e8d$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $e3e1f0fd5c4c9e8d$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $e3e1f0fd5c4c9e8d$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $e3e1f0fd5c4c9e8d$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $eqpm3.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $hZqi0.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $e3e1f0fd5c4c9e8d$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $2lj2u.default)(a.state, b.state);
}
function $e3e1f0fd5c4c9e8d$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $e3e1f0fd5c4c9e8d$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $e3e1f0fd5c4c9e8d$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $e3e1f0fd5c4c9e8d$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $e3e1f0fd5c4c9e8d$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $e3e1f0fd5c4c9e8d$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $e3e1f0fd5c4c9e8d$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $e3e1f0fd5c4c9e8d$var$PopStateEvent = 'popstate';
var $e3e1f0fd5c4c9e8d$var$HashChangeEvent = 'hashchange';
function $e3e1f0fd5c4c9e8d$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $e3e1f0fd5c4c9e8d$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$e3e1f0fd5c4c9e8d$var$canUseDOM && (0, $kuuqU.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $e3e1f0fd5c4c9e8d$var$supportsHistory();
    var needsHashChangeListener = !$e3e1f0fd5c4c9e8d$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $e3e1f0fd5c4c9e8d$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $e3e1f0fd5c4c9e8d$var$stripTrailingSlash($e3e1f0fd5c4c9e8d$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $e3e1f0fd5c4c9e8d$var$stripBasename(path, basename);
        return $e3e1f0fd5c4c9e8d$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $e3e1f0fd5c4c9e8d$var$createTransitionManager();
    function setState(nextState) {
        (0, $eqpm3.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($e3e1f0fd5c4c9e8d$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($e3e1f0fd5c4c9e8d$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($e3e1f0fd5c4c9e8d$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $e3e1f0fd5c4c9e8d$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $e3e1f0fd5c4c9e8d$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $e3e1f0fd5c4c9e8d$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($e3e1f0fd5c4c9e8d$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($e3e1f0fd5c4c9e8d$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($e3e1f0fd5c4c9e8d$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($e3e1f0fd5c4c9e8d$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $e3e1f0fd5c4c9e8d$var$HashChangeEvent$1 = 'hashchange';
var $e3e1f0fd5c4c9e8d$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $e3e1f0fd5c4c9e8d$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $e3e1f0fd5c4c9e8d$var$stripLeadingSlash,
        decodePath: $e3e1f0fd5c4c9e8d$var$addLeadingSlash
    },
    slash: {
        encodePath: $e3e1f0fd5c4c9e8d$var$addLeadingSlash,
        decodePath: $e3e1f0fd5c4c9e8d$var$addLeadingSlash
    }
};
function $e3e1f0fd5c4c9e8d$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $e3e1f0fd5c4c9e8d$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $e3e1f0fd5c4c9e8d$var$pushHashPath(path) {
    window.location.hash = path;
}
function $e3e1f0fd5c4c9e8d$var$replaceHashPath(path) {
    window.location.replace($e3e1f0fd5c4c9e8d$var$stripHash(window.location.href) + '#' + path);
}
function $e3e1f0fd5c4c9e8d$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$e3e1f0fd5c4c9e8d$var$canUseDOM && (0, $kuuqU.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $e3e1f0fd5c4c9e8d$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $e3e1f0fd5c4c9e8d$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $e3e1f0fd5c4c9e8d$var$stripTrailingSlash($e3e1f0fd5c4c9e8d$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $e3e1f0fd5c4c9e8d$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($e3e1f0fd5c4c9e8d$var$getHashPath());
        if (basename) path = $e3e1f0fd5c4c9e8d$var$stripBasename(path, basename);
        return $e3e1f0fd5c4c9e8d$export$90c043f1c57770b8(path);
    }
    var transitionManager = $e3e1f0fd5c4c9e8d$var$createTransitionManager();
    function setState(nextState) {
        (0, $eqpm3.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $e3e1f0fd5c4c9e8d$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $e3e1f0fd5c4c9e8d$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $e3e1f0fd5c4c9e8d$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($e3e1f0fd5c4c9e8d$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($e3e1f0fd5c4c9e8d$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $e3e1f0fd5c4c9e8d$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $e3e1f0fd5c4c9e8d$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $e3e1f0fd5c4c9e8d$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $e3e1f0fd5c4c9e8d$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $e3e1f0fd5c4c9e8d$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $e3e1f0fd5c4c9e8d$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $e3e1f0fd5c4c9e8d$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $e3e1f0fd5c4c9e8d$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $e3e1f0fd5c4c9e8d$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($e3e1f0fd5c4c9e8d$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $e3e1f0fd5c4c9e8d$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $e3e1f0fd5c4c9e8d$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $e3e1f0fd5c4c9e8d$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $e3e1f0fd5c4c9e8d$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($e3e1f0fd5c4c9e8d$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($e3e1f0fd5c4c9e8d$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($e3e1f0fd5c4c9e8d$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $e3e1f0fd5c4c9e8d$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $e3e1f0fd5c4c9e8d$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $e3e1f0fd5c4c9e8d$var$createTransitionManager();
    function setState(nextState) {
        (0, $eqpm3.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $e3e1f0fd5c4c9e8d$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $e3e1f0fd5c4c9e8d$export$90c043f1c57770b8(entry, undefined, createKey()) : $e3e1f0fd5c4c9e8d$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $e3e1f0fd5c4c9e8d$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $e3e1f0fd5c4c9e8d$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $e3e1f0fd5c4c9e8d$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $e3e1f0fd5c4c9e8d$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

});
parcelRegister("eqpm3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8072953d7e076fb$export$2e2bcd8739ae039; });
function $a8072953d7e076fb$export$2e2bcd8739ae039() {
    return $a8072953d7e076fb$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a8072953d7e076fb$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("hZqi0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d18c86b590e6c752$export$2e2bcd8739ae039; });
function $d18c86b590e6c752$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $d18c86b590e6c752$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $d18c86b590e6c752$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $d18c86b590e6c752$var$isAbsolute(to);
    var isFromAbs = from && $d18c86b590e6c752$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $d18c86b590e6c752$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $d18c86b590e6c752$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $d18c86b590e6c752$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $d18c86b590e6c752$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$d18c86b590e6c752$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $d18c86b590e6c752$export$2e2bcd8739ae039 = $d18c86b590e6c752$var$resolvePathname;

});

parcelRegister("2lj2u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b4c4fb2ee573138$export$2e2bcd8739ae039; });
function $1b4c4fb2ee573138$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $1b4c4fb2ee573138$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $1b4c4fb2ee573138$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $1b4c4fb2ee573138$var$valueOf(a);
        var bValue = $1b4c4fb2ee573138$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $1b4c4fb2ee573138$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $1b4c4fb2ee573138$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $1b4c4fb2ee573138$export$2e2bcd8739ae039 = $1b4c4fb2ee573138$var$valueEqual;

});

parcelRegister("kuuqU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eeae375eb9f2b656$export$2e2bcd8739ae039; });
var $eeae375eb9f2b656$var$isProduction = true;
var $eeae375eb9f2b656$var$prefix = 'Invariant failed';
function $eeae375eb9f2b656$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($eeae375eb9f2b656$var$isProduction) throw new Error($eeae375eb9f2b656$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($eeae375eb9f2b656$var$prefix, ": ").concat(provided) : $eeae375eb9f2b656$var$prefix;
    throw new Error(value);
}

});


parcelRegister("791Yt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $533ae7bd5b2cad1b$export$2e2bcd8739ae039; });
function $533ae7bd5b2cad1b$export$2e2bcd8739ae039() {
    return $533ae7bd5b2cad1b$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $533ae7bd5b2cad1b$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("cydz8", function(module, exports) {

var $aNcDD = parcelRequire("aNcDD");
/**
 * Expose `pathToRegexp`.
 */ module.exports = $92332edd679dfe63$var$pathToRegexp;
module.exports.parse = $92332edd679dfe63$var$parse;
module.exports.compile = $92332edd679dfe63$var$compile;
module.exports.tokensToFunction = $92332edd679dfe63$var$tokensToFunction;
module.exports.tokensToRegExp = $92332edd679dfe63$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $92332edd679dfe63$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $92332edd679dfe63$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $92332edd679dfe63$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $92332edd679dfe63$var$escapeGroup(pattern) : asterisk ? '.*' : $92332edd679dfe63$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $92332edd679dfe63$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $92332edd679dfe63$var$escapeString(delimiter) + ']+?';
    return $92332edd679dfe63$var$escapeString(prevText) + '|(?:(?!' + $92332edd679dfe63$var$escapeString(prevText) + ')[^' + $92332edd679dfe63$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $92332edd679dfe63$var$compile(str, options) {
    return $92332edd679dfe63$var$tokensToFunction($92332edd679dfe63$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $92332edd679dfe63$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $92332edd679dfe63$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $92332edd679dfe63$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $92332edd679dfe63$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $92332edd679dfe63$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($aNcDD(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $92332edd679dfe63$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $92332edd679dfe63$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $92332edd679dfe63$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $92332edd679dfe63$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $92332edd679dfe63$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $92332edd679dfe63$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $92332edd679dfe63$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $92332edd679dfe63$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($92332edd679dfe63$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $92332edd679dfe63$var$flags(options));
    return $92332edd679dfe63$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $92332edd679dfe63$var$stringToRegexp(path, keys, options) {
    return $92332edd679dfe63$var$tokensToRegExp($92332edd679dfe63$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $92332edd679dfe63$var$tokensToRegExp(tokens, keys, options) {
    if (!$aNcDD(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $92332edd679dfe63$var$escapeString(token);
        else {
            var prefix = $92332edd679dfe63$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $92332edd679dfe63$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $92332edd679dfe63$var$attachKeys(new RegExp('^' + route, $92332edd679dfe63$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $92332edd679dfe63$var$pathToRegexp(path, keys, options) {
    if (!$aNcDD(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $92332edd679dfe63$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($aNcDD(path)) return $92332edd679dfe63$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $92332edd679dfe63$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

});
parcelRegister("aNcDD", function(module, exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};

});


parcelRegister("lI8NJ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("axZz6"));

});

parcelRegister("6zhis", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c836dc02aa1949f$export$2e2bcd8739ae039; });
function $4c836dc02aa1949f$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("cVomO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $968db5ae014c0a77$export$2e2bcd8739ae039; });

var $cau6T = parcelRequire("cau6T");
function $968db5ae014c0a77$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $cau6T.default)(t, o);
}

});
parcelRegister("cau6T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8dbdc6778da8a071$export$2e2bcd8739ae039; });
function $8dbdc6778da8a071$export$2e2bcd8739ae039(t, e) {
    return $8dbdc6778da8a071$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $8dbdc6778da8a071$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("6nmdQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a4620ef5e9889ca$export$2e2bcd8739ae039; });
function $4a4620ef5e9889ca$export$2e2bcd8739ae039() {
    return $4a4620ef5e9889ca$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4a4620ef5e9889ca$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("891MO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ee08cb96e1f3fcc$export$2e2bcd8739ae039; });
function $5ee08cb96e1f3fcc$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("hTxQ8", function(module, exports) {
$parcel$export(module.exports, "axisBottom", function () { return (parcelRequire("blOHq")).axisBottom; });
$parcel$export(module.exports, "axisLeft", function () { return (parcelRequire("blOHq")).axisLeft; });
$parcel$export(module.exports, "axisRight", function () { return (parcelRequire("blOHq")).axisRight; });
$parcel$export(module.exports, "format", function () { return (parcelRequire("4UuJL")).format; });
$parcel$export(module.exports, "timeDay", function () { return (parcelRequire("3v896")).timeDay; });
$parcel$export(module.exports, "timeMonths", function () { return (parcelRequire("cYPu0")).timeMonths; });
$parcel$export(module.exports, "timeSunday", function () { return (parcelRequire("lhtzE")).timeSunday; });
$parcel$export(module.exports, "timeWeek", function () { return (parcelRequire("lhtzE")).timeSunday; });
$parcel$export(module.exports, "timeYear", function () { return (parcelRequire("jJTTX")).timeYear; });
$parcel$export(module.exports, "timeFormat", function () { return (parcelRequire("6zofg")).timeFormat; });
$parcel$export(module.exports, "transition", function () { return (parcelRequire("1N69U")).default; });

$parcel$export(module.exports, "max", function () { return (parcelRequire("2T7UM")).default; });
$parcel$export(module.exports, "range", function () { return (parcelRequire("1CQ7S")).default; });
$parcel$export(module.exports, "scaleBand", function () { return (parcelRequire("kWKG2")).default; });
$parcel$export(module.exports, "scaleLinear", function () { return (parcelRequire("3FIbj")).default; });
$parcel$export(module.exports, "scaleTime", function () { return (parcelRequire("ikHyM")).default; });
$parcel$export(module.exports, "select", function () { return (parcelRequire("ksTt2")).default; });
$parcel$export(module.exports, "selectAll", function () { return (parcelRequire("5xV2T")).default; });
$parcel$export(module.exports, "area", function () { return (parcelRequire("jDPUx")).default; });
$parcel$export(module.exports, "curveStep", function () { return (parcelRequire("1evnz")).default; });
$parcel$export(module.exports, "line", function () { return (parcelRequire("geBL0")).default; });
$parcel$export(module.exports, "stack", function () { return (parcelRequire("a8f6W")).default; });

var $2T7UM = parcelRequire("2T7UM");
var $1CQ7S = parcelRequire("1CQ7S");
parcelRequire("blOHq");
parcelRequire("3qnEP");










parcelRequire("4UuJL");








var $kWKG2 = parcelRequire("kWKG2");
var $3FIbj = parcelRequire("3FIbj");
var $ikHyM = parcelRequire("ikHyM");


var $ksTt2 = parcelRequire("ksTt2");
var $5xV2T = parcelRequire("5xV2T");

var $jDPUx = parcelRequire("jDPUx");
var $1evnz = parcelRequire("1evnz");
var $geBL0 = parcelRequire("geBL0");
var $a8f6W = parcelRequire("a8f6W");

parcelRequire("6zofg");

parcelRequire("4WsfD");
parcelRequire("4gk9Q");

});
parcelRegister("2T7UM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21a6db87091875b4$export$2e2bcd8739ae039; });
function $21a6db87091875b4$export$2e2bcd8739ae039(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("1CQ7S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12f1c6338482fcd3$export$2e2bcd8739ae039; });
function $12f1c6338482fcd3$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("blOHq", function(module, exports) {

$parcel$export(module.exports, "axisRight", function () { return $8438fbbd85c57f34$export$b0d2e24dc4f898f0; });
$parcel$export(module.exports, "axisBottom", function () { return $8438fbbd85c57f34$export$e5cb22533a15e72e; });
$parcel$export(module.exports, "axisLeft", function () { return $8438fbbd85c57f34$export$2749afb169a520d2; });

var $8MIvT = parcelRequire("8MIvT");
var $8438fbbd85c57f34$var$top = 1, $8438fbbd85c57f34$var$right = 2, $8438fbbd85c57f34$var$bottom = 3, $8438fbbd85c57f34$var$left = 4, $8438fbbd85c57f34$var$epsilon = 1e-6;
function $8438fbbd85c57f34$var$translateX(x) {
    return "translate(" + x + ",0)";
}
function $8438fbbd85c57f34$var$translateY(y) {
    return "translate(0," + y + ")";
}
function $8438fbbd85c57f34$var$number(scale) {
    return (d)=>+scale(d);
}
function $8438fbbd85c57f34$var$center(scale, offset) {
    offset = Math.max(0, scale.bandwidth() - offset * 2) / 2;
    if (scale.round()) offset = Math.round(offset);
    return (d)=>+scale(d) + offset;
}
function $8438fbbd85c57f34$var$entering() {
    return !this.__axis;
}
function $8438fbbd85c57f34$var$axis(orient, scale) {
    var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k = orient === $8438fbbd85c57f34$var$top || orient === $8438fbbd85c57f34$var$left ? -1 : 1, x = orient === $8438fbbd85c57f34$var$left || orient === $8438fbbd85c57f34$var$right ? "x" : "y", transform = orient === $8438fbbd85c57f34$var$top || orient === $8438fbbd85c57f34$var$bottom ? $8438fbbd85c57f34$var$translateX : $8438fbbd85c57f34$var$translateY;
    function axis(context) {
        var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : (0, $8MIvT.default) : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + offset, range1 = +range[range.length - 1] + offset, position = (scale.bandwidth ? $8438fbbd85c57f34$var$center : $8438fbbd85c57f34$var$number)(scale.copy(), offset), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
            null
        ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
        path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
        tick = tick.merge(tickEnter);
        line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
        text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === $8438fbbd85c57f34$var$top ? "0em" : orient === $8438fbbd85c57f34$var$bottom ? "0.71em" : "0.32em"));
        if (context !== selection) {
            path = path.transition(context);
            tick = tick.transition(context);
            line = line.transition(context);
            text = text.transition(context);
            tickExit = tickExit.transition(context).attr("opacity", $8438fbbd85c57f34$var$epsilon).attr("transform", function(d) {
                return isFinite(d = position(d)) ? transform(d + offset) : this.getAttribute("transform");
            });
            tickEnter.attr("opacity", $8438fbbd85c57f34$var$epsilon).attr("transform", function(d) {
                var p = this.parentNode.__axis;
                return transform((p && isFinite(p = p(d)) ? p : position(d)) + offset);
            });
        }
        tickExit.remove();
        path.attr("d", orient === $8438fbbd85c57f34$var$left || orient === $8438fbbd85c57f34$var$right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H" + offset + "V" + range1 + "H" + k * tickSizeOuter : "M" + offset + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V" + offset + "H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + "," + offset + "H" + range1);
        tick.attr("opacity", 1).attr("transform", function(d) {
            return transform(position(d) + offset);
        });
        line.attr(x + "2", k * tickSizeInner);
        text.attr(x, k * spacing).text(format);
        selection.filter($8438fbbd85c57f34$var$entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === $8438fbbd85c57f34$var$right ? "start" : orient === $8438fbbd85c57f34$var$left ? "end" : "middle");
        selection.each(function() {
            this.__axis = position;
        });
    }
    axis.scale = function(_) {
        return arguments.length ? (scale = _, axis) : scale;
    };
    axis.ticks = function() {
        return tickArguments = Array.from(arguments), axis;
    };
    axis.tickArguments = function(_) {
        return arguments.length ? (tickArguments = _ == null ? [] : Array.from(_), axis) : tickArguments.slice();
    };
    axis.tickValues = function(_) {
        return arguments.length ? (tickValues = _ == null ? null : Array.from(_), axis) : tickValues && tickValues.slice();
    };
    axis.tickFormat = function(_) {
        return arguments.length ? (tickFormat = _, axis) : tickFormat;
    };
    axis.tickSize = function(_) {
        return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
    };
    axis.tickSizeInner = function(_) {
        return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
    };
    axis.tickSizeOuter = function(_) {
        return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
    };
    axis.tickPadding = function(_) {
        return arguments.length ? (tickPadding = +_, axis) : tickPadding;
    };
    axis.offset = function(_) {
        return arguments.length ? (offset = +_, axis) : offset;
    };
    return axis;
}
function $8438fbbd85c57f34$export$59b8cfab074bdeb1(scale) {
    return $8438fbbd85c57f34$var$axis($8438fbbd85c57f34$var$top, scale);
}
function $8438fbbd85c57f34$export$b0d2e24dc4f898f0(scale) {
    return $8438fbbd85c57f34$var$axis($8438fbbd85c57f34$var$right, scale);
}
function $8438fbbd85c57f34$export$e5cb22533a15e72e(scale) {
    return $8438fbbd85c57f34$var$axis($8438fbbd85c57f34$var$bottom, scale);
}
function $8438fbbd85c57f34$export$2749afb169a520d2(scale) {
    return $8438fbbd85c57f34$var$axis($8438fbbd85c57f34$var$left, scale);
}

});
parcelRegister("8MIvT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $665555df4ddb7e41$export$2e2bcd8739ae039; });
function $665555df4ddb7e41$export$2e2bcd8739ae039(x) {
    return x;
}

});


parcelRegister("3qnEP", function(module, exports) {

var $4QJEs = parcelRequire("4QJEs");

});
parcelRegister("4QJEs", function(module, exports) {

var $cMYF7 = parcelRequire("cMYF7");

var $2ssAA = parcelRequire("2ssAA");

var $2oxjG = parcelRequire("2oxjG");

var $bjzWC = parcelRequire("bjzWC");
var $ksTt2 = parcelRequire("ksTt2");
parcelRequire("4WsfD");
var $eip42 = parcelRequire("eip42");

var $j0HRg = parcelRequire("j0HRg");

var $b4pix = parcelRequire("b4pix");

var $3nxni = parcelRequire("3nxni");
var $387f6e383bd022ef$var$MODE_DRAG = {
    name: "drag"
}, $387f6e383bd022ef$var$MODE_SPACE = {
    name: "space"
}, $387f6e383bd022ef$var$MODE_HANDLE = {
    name: "handle"
}, $387f6e383bd022ef$var$MODE_CENTER = {
    name: "center"
};
const { abs: $387f6e383bd022ef$var$abs, max: $387f6e383bd022ef$var$max, min: $387f6e383bd022ef$var$min } = Math;
function $387f6e383bd022ef$var$number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function $387f6e383bd022ef$var$number2(e) {
    return [
        $387f6e383bd022ef$var$number1(e[0]),
        $387f6e383bd022ef$var$number1(e[1])
    ];
}
var $387f6e383bd022ef$var$X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map($387f6e383bd022ef$var$type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var $387f6e383bd022ef$var$Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map($387f6e383bd022ef$var$type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var $387f6e383bd022ef$var$XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map($387f6e383bd022ef$var$type),
    input: function(xy) {
        return xy == null ? null : $387f6e383bd022ef$var$number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var $387f6e383bd022ef$var$cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var $387f6e383bd022ef$var$flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var $387f6e383bd022ef$var$flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var $387f6e383bd022ef$var$signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var $387f6e383bd022ef$var$signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function $387f6e383bd022ef$var$type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function $387f6e383bd022ef$var$defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function $387f6e383bd022ef$var$defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function $387f6e383bd022ef$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function $387f6e383bd022ef$var$local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function $387f6e383bd022ef$var$empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function $387f6e383bd022ef$export$69760394fc76f689(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function $387f6e383bd022ef$export$979ace6c88860aa8() {
    return $387f6e383bd022ef$var$brush($387f6e383bd022ef$var$X);
}
function $387f6e383bd022ef$export$468748b530991c54() {
    return $387f6e383bd022ef$var$brush($387f6e383bd022ef$var$Y);
}
function $387f6e383bd022ef$export$2e2bcd8739ae039() {
    return $387f6e383bd022ef$var$brush($387f6e383bd022ef$var$XY);
}
function $387f6e383bd022ef$var$brush(dim) {
    var extent = $387f6e383bd022ef$var$defaultExtent, filter = $387f6e383bd022ef$var$defaultFilter, touchable = $387f6e383bd022ef$var$defaultTouchable, keys = true, listeners = (0, $cMYF7.default)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            $387f6e383bd022ef$var$type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", $387f6e383bd022ef$var$cursors.overlay).merge(overlay).each(function() {
            var extent = $387f6e383bd022ef$var$local(this).extent;
            (0, $ksTt2.default)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            $387f6e383bd022ef$var$type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", $387f6e383bd022ef$var$cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return $387f6e383bd022ef$var$cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection, event) {
        if (group.tween) group.on("start.brush", function(event) {
            emitter(this, arguments).beforestart().start(event);
        }).on("interrupt.brush end.brush", function(event) {
            emitter(this, arguments).end(event);
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, $2oxjG.default)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, $eip42.default)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start(event).brush(event).end(event);
        });
    };
    brush.clear = function(group, event) {
        brush.move(group, null, event);
    };
    function redraw() {
        var group = (0, $ksTt2.default)(this), selection = $387f6e383bd022ef$var$local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function(event, mode) {
            if (this.starting) this.starting = false, this.emit("start", event, mode);
            else this.emit("brush", event);
            return this;
        },
        brush: function(event, mode) {
            this.emit("brush", event, mode);
            return this;
        },
        end: function(event, mode) {
            if (--this.active === 0) delete this.state.emitter, this.emit("end", event, mode);
            return this;
        },
        emit: function(type, event, mode) {
            var d = (0, $ksTt2.default)(this.that).datum();
            listeners.call(type, this.that, new (0, $b4pix.default)(type, {
                sourceEvent: event,
                target: brush,
                selection: dim.output(this.state.selection),
                mode: mode,
                dispatch: listeners
            }), d);
        }
    };
    function started(event) {
        if (touchending && !event.touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = event.target.__data__.type, mode = (keys && event.metaKey ? type = "overlay" : type) === "selection" ? $387f6e383bd022ef$var$MODE_DRAG : keys && event.altKey ? $387f6e383bd022ef$var$MODE_CENTER : $387f6e383bd022ef$var$MODE_HANDLE, signX = dim === $387f6e383bd022ef$var$Y ? null : $387f6e383bd022ef$var$signsX[type], signY = dim === $387f6e383bd022ef$var$X ? null : $387f6e383bd022ef$var$signsY[type], state = $387f6e383bd022ef$var$local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && event.shiftKey, lockX, lockY, points = Array.from(event.touches || [
            event
        ], (t)=>{
            const i = t.identifier;
            t = (0, $bjzWC.default)(t, that);
            t.point0 = t.slice();
            t.identifier = i;
            return t;
        });
        (0, $eip42.default)(that);
        var emit = emitter(that, arguments, true).beforestart();
        if (type === "overlay") {
            if (selection) moving = true;
            const pts = [
                points[0],
                points[1] || points[0]
            ];
            state.selection = selection = [
                [
                    w0 = dim === $387f6e383bd022ef$var$Y ? W : $387f6e383bd022ef$var$min(pts[0][0], pts[1][0]),
                    n0 = dim === $387f6e383bd022ef$var$X ? N : $387f6e383bd022ef$var$min(pts[0][1], pts[1][1])
                ],
                [
                    e0 = dim === $387f6e383bd022ef$var$Y ? E : $387f6e383bd022ef$var$max(pts[0][0], pts[1][0]),
                    s0 = dim === $387f6e383bd022ef$var$X ? S : $387f6e383bd022ef$var$max(pts[0][1], pts[1][1])
                ]
            ];
            if (points.length > 1) move(event);
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, $ksTt2.default)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", $387f6e383bd022ef$var$cursors[type]);
        if (event.touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, $ksTt2.default)(event.view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, $2ssAA.default)(event.view);
        }
        redraw.call(that);
        emit.start(event, mode.name);
        function moved(event) {
            for (const p of event.changedTouches || [
                event
            ]){
                for (const d of points)if (d.identifier === p.identifier) d.cur = (0, $bjzWC.default)(p, that);
            }
            if (shifting && !lockX && !lockY && points.length === 1) {
                const point = points[0];
                if ($387f6e383bd022ef$var$abs(point.cur[0] - point[0]) > $387f6e383bd022ef$var$abs(point.cur[1] - point[1])) lockY = true;
                else lockX = true;
            }
            for (const point of points)if (point.cur) point[0] = point.cur[0], point[1] = point.cur[1];
            moving = true;
            (0, $3nxni.default)(event);
            move(event);
        }
        function move(event) {
            const point = points[0], point0 = point.point0;
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case $387f6e383bd022ef$var$MODE_SPACE:
                case $387f6e383bd022ef$var$MODE_DRAG:
                    if (signX) dx = $387f6e383bd022ef$var$max(W - w0, $387f6e383bd022ef$var$min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = $387f6e383bd022ef$var$max(N - n0, $387f6e383bd022ef$var$min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case $387f6e383bd022ef$var$MODE_HANDLE:
                    if (points[1]) {
                        if (signX) w1 = $387f6e383bd022ef$var$max(W, $387f6e383bd022ef$var$min(E, points[0][0])), e1 = $387f6e383bd022ef$var$max(W, $387f6e383bd022ef$var$min(E, points[1][0])), signX = 1;
                        if (signY) n1 = $387f6e383bd022ef$var$max(N, $387f6e383bd022ef$var$min(S, points[0][1])), s1 = $387f6e383bd022ef$var$max(N, $387f6e383bd022ef$var$min(S, points[1][1])), signY = 1;
                    } else {
                        if (signX < 0) dx = $387f6e383bd022ef$var$max(W - w0, $387f6e383bd022ef$var$min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                        else if (signX > 0) dx = $387f6e383bd022ef$var$max(W - e0, $387f6e383bd022ef$var$min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                        if (signY < 0) dy = $387f6e383bd022ef$var$max(N - n0, $387f6e383bd022ef$var$min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                        else if (signY > 0) dy = $387f6e383bd022ef$var$max(N - s0, $387f6e383bd022ef$var$min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    }
                    break;
                case $387f6e383bd022ef$var$MODE_CENTER:
                    if (signX) w1 = $387f6e383bd022ef$var$max(W, $387f6e383bd022ef$var$min(E, w0 - dx * signX)), e1 = $387f6e383bd022ef$var$max(W, $387f6e383bd022ef$var$min(E, e0 + dx * signX));
                    if (signY) n1 = $387f6e383bd022ef$var$max(N, $387f6e383bd022ef$var$min(S, n0 - dy * signY)), s1 = $387f6e383bd022ef$var$max(N, $387f6e383bd022ef$var$min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in $387f6e383bd022ef$var$flipX) overlay.attr("cursor", $387f6e383bd022ef$var$cursors[type = $387f6e383bd022ef$var$flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in $387f6e383bd022ef$var$flipY) overlay.attr("cursor", $387f6e383bd022ef$var$cursors[type = $387f6e383bd022ef$var$flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush(event, mode.name);
            }
        }
        function ended(event) {
            (0, $3nxni.nopropagation)(event);
            if (event.touches) {
                if (event.touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, $2ssAA.yesdrag)(event.view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", $387f6e383bd022ef$var$cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if ($387f6e383bd022ef$var$empty(selection)) state.selection = null, redraw.call(that);
            emit.end(event, mode.name);
        }
        function keydowned(event) {
            switch(event.keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === $387f6e383bd022ef$var$MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = $387f6e383bd022ef$var$MODE_CENTER;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $387f6e383bd022ef$var$MODE_HANDLE || mode === $387f6e383bd022ef$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = $387f6e383bd022ef$var$MODE_SPACE;
                        overlay.attr("cursor", $387f6e383bd022ef$var$cursors.selection);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $3nxni.default)(event);
        }
        function keyupped(event) {
            switch(event.keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move(event);
                    }
                    break;
                case 18:
                    if (mode === $387f6e383bd022ef$var$MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = $387f6e383bd022ef$var$MODE_HANDLE;
                        move(event);
                    }
                    break;
                case 32:
                    if (mode === $387f6e383bd022ef$var$MODE_SPACE) {
                        if (event.altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = $387f6e383bd022ef$var$MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = $387f6e383bd022ef$var$MODE_HANDLE;
                        }
                        overlay.attr("cursor", $387f6e383bd022ef$var$cursors[type]);
                        move(event);
                    }
                    break;
                default:
                    return;
            }
            (0, $3nxni.default)(event);
        }
    }
    function touchmoved(event) {
        emitter(this, arguments).moved(event);
    }
    function touchended(event) {
        emitter(this, arguments).ended(event);
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = $387f6e383bd022ef$var$number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $j0HRg.default)($387f6e383bd022ef$var$number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $j0HRg.default)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $j0HRg.default)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}

});
parcelRegister("cMYF7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94f905fefb380f6e$export$2e2bcd8739ae039; });
var $94f905fefb380f6e$var$noop = {
    value: ()=>{}
};
function $94f905fefb380f6e$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $94f905fefb380f6e$var$Dispatch(_);
}
function $94f905fefb380f6e$var$Dispatch(_) {
    this._ = _;
}
function $94f905fefb380f6e$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$94f905fefb380f6e$var$Dispatch.prototype = $94f905fefb380f6e$var$dispatch.prototype = {
    constructor: $94f905fefb380f6e$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $94f905fefb380f6e$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $94f905fefb380f6e$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $94f905fefb380f6e$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $94f905fefb380f6e$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $94f905fefb380f6e$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $94f905fefb380f6e$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $94f905fefb380f6e$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $94f905fefb380f6e$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $94f905fefb380f6e$export$2e2bcd8739ae039 = $94f905fefb380f6e$var$dispatch;

});

parcelRegister("2ssAA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ca45f78da680fc4$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "yesdrag", function () { return $1ca45f78da680fc4$export$833237748009e1e1; });

var $ksTt2 = parcelRequire("ksTt2");

var $kWxs6 = parcelRequire("kWxs6");
function $1ca45f78da680fc4$export$2e2bcd8739ae039(view) {
    var root = view.document.documentElement, selection = (0, $ksTt2.default)(view).on("dragstart.drag", (0, $kWxs6.default), (0, $kWxs6.nonpassivecapture));
    if ("onselectstart" in root) selection.on("selectstart.drag", (0, $kWxs6.default), (0, $kWxs6.nonpassivecapture));
    else {
        root.__noselect = root.style.MozUserSelect;
        root.style.MozUserSelect = "none";
    }
}
function $1ca45f78da680fc4$export$833237748009e1e1(view, noclick) {
    var root = view.document.documentElement, selection = (0, $ksTt2.default)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, $kWxs6.default), (0, $kWxs6.nonpassivecapture));
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}

});
parcelRegister("ksTt2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee6172dbfdd36358$export$2e2bcd8739ae039; });

var $gbmQo = parcelRequire("gbmQo");
function $ee6172dbfdd36358$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $gbmQo.Selection)([
        [
            document.querySelector(selector)
        ]
    ], [
        document.documentElement
    ]) : new (0, $gbmQo.Selection)([
        [
            selector
        ]
    ], (0, $gbmQo.root));
}

});
parcelRegister("gbmQo", function(module, exports) {

$parcel$export(module.exports, "root", function () { return $bc7f64cbb6d21edf$export$e8e78c978b129247; });
$parcel$export(module.exports, "Selection", function () { return $bc7f64cbb6d21edf$export$52baac22726c72bf; });
$parcel$export(module.exports, "default", function () { return $bc7f64cbb6d21edf$export$2e2bcd8739ae039; });

var $1r25j = parcelRequire("1r25j");

var $5djjD = parcelRequire("5djjD");

var $jW1Yu = parcelRequire("jW1Yu");

var $jMG7U = parcelRequire("jMG7U");

var $kV792 = parcelRequire("kV792");

var $1BR9M = parcelRequire("1BR9M");

var $e8CKF = parcelRequire("e8CKF");

var $fYoK0 = parcelRequire("fYoK0");

var $ik3Ye = parcelRequire("ik3Ye");

var $g5j6k = parcelRequire("g5j6k");

var $kHnMX = parcelRequire("kHnMX");

var $lnaWT = parcelRequire("lnaWT");

var $l5Zwu = parcelRequire("l5Zwu");

var $i0aIt = parcelRequire("i0aIt");

var $law9J = parcelRequire("law9J");

var $1m83r = parcelRequire("1m83r");

var $3bPL7 = parcelRequire("3bPL7");

var $2SEUW = parcelRequire("2SEUW");

var $9vpbu = parcelRequire("9vpbu");

var $kwD7i = parcelRequire("kwD7i");

var $9BFHc = parcelRequire("9BFHc");

var $5SrSa = parcelRequire("5SrSa");

var $gKRZM = parcelRequire("gKRZM");

var $eovX4 = parcelRequire("eovX4");

var $8aMRq = parcelRequire("8aMRq");

var $K0B6n = parcelRequire("K0B6n");

var $cwbhp = parcelRequire("cwbhp");

var $kPmCU = parcelRequire("kPmCU");

var $iNWqO = parcelRequire("iNWqO");

var $iwkAW = parcelRequire("iwkAW");

var $aml7D = parcelRequire("aml7D");

var $iIcz4 = parcelRequire("iIcz4");

var $ixkJ0 = parcelRequire("ixkJ0");

var $kcrvd = parcelRequire("kcrvd");
var $bc7f64cbb6d21edf$export$e8e78c978b129247 = [
    null
];
function $bc7f64cbb6d21edf$export$52baac22726c72bf(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function $bc7f64cbb6d21edf$var$selection() {
    return new $bc7f64cbb6d21edf$export$52baac22726c72bf([
        [
            document.documentElement
        ]
    ], $bc7f64cbb6d21edf$export$e8e78c978b129247);
}
function $bc7f64cbb6d21edf$var$selection_selection() {
    return this;
}
$bc7f64cbb6d21edf$export$52baac22726c72bf.prototype = $bc7f64cbb6d21edf$var$selection.prototype = {
    constructor: $bc7f64cbb6d21edf$export$52baac22726c72bf,
    select: (0, $1r25j.default),
    selectAll: (0, $5djjD.default),
    selectChild: (0, $jW1Yu.default),
    selectChildren: (0, $jMG7U.default),
    filter: (0, $kV792.default),
    data: (0, $1BR9M.default),
    enter: (0, $e8CKF.default),
    exit: (0, $fYoK0.default),
    join: (0, $ik3Ye.default),
    merge: (0, $g5j6k.default),
    selection: $bc7f64cbb6d21edf$var$selection_selection,
    order: (0, $kHnMX.default),
    sort: (0, $lnaWT.default),
    call: (0, $l5Zwu.default),
    nodes: (0, $i0aIt.default),
    node: (0, $law9J.default),
    size: (0, $1m83r.default),
    empty: (0, $3bPL7.default),
    each: (0, $2SEUW.default),
    attr: (0, $9vpbu.default),
    style: (0, $kwD7i.default),
    property: (0, $9BFHc.default),
    classed: (0, $5SrSa.default),
    text: (0, $gKRZM.default),
    html: (0, $eovX4.default),
    raise: (0, $8aMRq.default),
    lower: (0, $K0B6n.default),
    append: (0, $cwbhp.default),
    insert: (0, $kPmCU.default),
    remove: (0, $iNWqO.default),
    clone: (0, $iwkAW.default),
    datum: (0, $aml7D.default),
    on: (0, $iIcz4.default),
    dispatch: (0, $ixkJ0.default),
    [Symbol.iterator]: (0, $kcrvd.default)
};
var $bc7f64cbb6d21edf$export$2e2bcd8739ae039 = $bc7f64cbb6d21edf$var$selection;

});
parcelRegister("1r25j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10b9ee08d6221de9$export$2e2bcd8739ae039; });

var $gbmQo = parcelRequire("gbmQo");

var $2DouR = parcelRequire("2DouR");
function $10b9ee08d6221de9$export$2e2bcd8739ae039(select) {
    if (typeof select !== "function") select = (0, $2DouR.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
        }
    }
    return new (0, $gbmQo.Selection)(subgroups, this._parents);
}

});
parcelRegister("2DouR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1eb239d296057a69$export$2e2bcd8739ae039; });
function $1eb239d296057a69$var$none() {}
function $1eb239d296057a69$export$2e2bcd8739ae039(selector) {
    return selector == null ? $1eb239d296057a69$var$none : function() {
        return this.querySelector(selector);
    };
}

});


parcelRegister("5djjD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cbd2657dd4498ae$export$2e2bcd8739ae039; });

var $gbmQo = parcelRequire("gbmQo");

var $cSsWF = parcelRequire("cSsWF");

var $4daKR = parcelRequire("4daKR");
function $3cbd2657dd4498ae$var$arrayAll(select) {
    return function() {
        return (0, $cSsWF.default)(select.apply(this, arguments));
    };
}
function $3cbd2657dd4498ae$export$2e2bcd8739ae039(select) {
    if (typeof select === "function") select = $3cbd2657dd4498ae$var$arrayAll(select);
    else select = (0, $4daKR.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            subgroups.push(select.call(node, node.__data__, i, group));
            parents.push(node);
        }
    }
    return new (0, $gbmQo.Selection)(subgroups, parents);
}

});
parcelRegister("cSsWF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9600fb17a214f041$export$2e2bcd8739ae039; });
// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
function $9600fb17a214f041$export$2e2bcd8739ae039(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}

});

parcelRegister("4daKR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3110b80259e17254$export$2e2bcd8739ae039; });
function $3110b80259e17254$var$empty() {
    return [];
}
function $3110b80259e17254$export$2e2bcd8739ae039(selector) {
    return selector == null ? $3110b80259e17254$var$empty : function() {
        return this.querySelectorAll(selector);
    };
}

});


parcelRegister("jW1Yu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e834f7342be1d606$export$2e2bcd8739ae039; });

var $bAk2W = parcelRequire("bAk2W");
var $e834f7342be1d606$var$find = Array.prototype.find;
function $e834f7342be1d606$var$childFind(match) {
    return function() {
        return $e834f7342be1d606$var$find.call(this.children, match);
    };
}
function $e834f7342be1d606$var$childFirst() {
    return this.firstElementChild;
}
function $e834f7342be1d606$export$2e2bcd8739ae039(match) {
    return this.select(match == null ? $e834f7342be1d606$var$childFirst : $e834f7342be1d606$var$childFind(typeof match === "function" ? match : (0, $bAk2W.childMatcher)(match)));
}

});
parcelRegister("bAk2W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86f29b5242e914d4$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "childMatcher", function () { return $86f29b5242e914d4$export$90c2759c036528; });
function $86f29b5242e914d4$export$2e2bcd8739ae039(selector) {
    return function() {
        return this.matches(selector);
    };
}
function $86f29b5242e914d4$export$90c2759c036528(selector) {
    return function(node) {
        return node.matches(selector);
    };
}

});


parcelRegister("jMG7U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6732d7a70c1632e$export$2e2bcd8739ae039; });

var $bAk2W = parcelRequire("bAk2W");
var $e6732d7a70c1632e$var$filter = Array.prototype.filter;
function $e6732d7a70c1632e$var$children() {
    return Array.from(this.children);
}
function $e6732d7a70c1632e$var$childrenFilter(match) {
    return function() {
        return $e6732d7a70c1632e$var$filter.call(this.children, match);
    };
}
function $e6732d7a70c1632e$export$2e2bcd8739ae039(match) {
    return this.selectAll(match == null ? $e6732d7a70c1632e$var$children : $e6732d7a70c1632e$var$childrenFilter(typeof match === "function" ? match : (0, $bAk2W.childMatcher)(match)));
}

});

parcelRegister("kV792", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3aeac546b44343e$export$2e2bcd8739ae039; });

var $gbmQo = parcelRequire("gbmQo");

var $bAk2W = parcelRequire("bAk2W");
function $f3aeac546b44343e$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $bAk2W.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $gbmQo.Selection)(subgroups, this._parents);
}

});

parcelRegister("1BR9M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12c27af70146ee78$export$2e2bcd8739ae039; });

var $gbmQo = parcelRequire("gbmQo");

var $e8CKF = parcelRequire("e8CKF");

var $3TbH0 = parcelRequire("3TbH0");
function $12c27af70146ee78$var$bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, $e8CKF.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function $12c27af70146ee78$var$bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, $e8CKF.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function $12c27af70146ee78$var$datum(node) {
    return node.__data__;
}
function $12c27af70146ee78$export$2e2bcd8739ae039(value, key) {
    if (!arguments.length) return Array.from(this, $12c27af70146ee78$var$datum);
    var bind = key ? $12c27af70146ee78$var$bindKey : $12c27af70146ee78$var$bindIndex, parents = this._parents, groups = this._groups;
    if (typeof value !== "function") value = (0, $3TbH0.default)(value);
    for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
        var parent = parents[j], group = groups[j], groupLength = group.length, data = $12c27af70146ee78$var$arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
        bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
        // Now connect the enter nodes to their following update node, such that
        // appendChild can insert the materialized enter node before this node,
        // rather than at the end of the parent node.
        for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
            if (i0 >= i1) i1 = i0 + 1;
            while(!(next = updateGroup[i1]) && ++i1 < dataLength);
            previous._next = next || null;
        }
    }
    update = new (0, $gbmQo.Selection)(update, parents);
    update._enter = enter;
    update._exit = exit;
    return update;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function $12c27af70146ee78$var$arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}

});
parcelRegister("e8CKF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4afdf4d2984e837$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "EnterNode", function () { return $a4afdf4d2984e837$export$67b01759a14cf6a4; });

var $96suQ = parcelRequire("96suQ");

var $gbmQo = parcelRequire("gbmQo");
function $a4afdf4d2984e837$export$2e2bcd8739ae039() {
    return new (0, $gbmQo.Selection)(this._enter || this._groups.map((0, $96suQ.default)), this._parents);
}
function $a4afdf4d2984e837$export$67b01759a14cf6a4(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
$a4afdf4d2984e837$export$67b01759a14cf6a4.prototype = {
    constructor: $a4afdf4d2984e837$export$67b01759a14cf6a4,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};

});
parcelRegister("96suQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a0ac762d07bf6b0$export$2e2bcd8739ae039; });
function $6a0ac762d07bf6b0$export$2e2bcd8739ae039(update) {
    return new Array(update.length);
}

});


parcelRegister("3TbH0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d4f940f3991b782$export$2e2bcd8739ae039; });
function $2d4f940f3991b782$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});


parcelRegister("fYoK0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba0fa6ac2121f0a7$export$2e2bcd8739ae039; });

var $96suQ = parcelRequire("96suQ");

var $gbmQo = parcelRequire("gbmQo");
function $ba0fa6ac2121f0a7$export$2e2bcd8739ae039() {
    return new (0, $gbmQo.Selection)(this._exit || this._groups.map((0, $96suQ.default)), this._parents);
}

});

parcelRegister("ik3Ye", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d56d2cb2ca0b66ca$export$2e2bcd8739ae039; });
function $d56d2cb2ca0b66ca$export$2e2bcd8739ae039(onenter, onupdate, onexit) {
    var enter = this.enter(), update = this, exit = this.exit();
    if (typeof onenter === "function") {
        enter = onenter(enter);
        if (enter) enter = enter.selection();
    } else enter = enter.append(onenter + "");
    if (onupdate != null) {
        update = onupdate(update);
        if (update) update = update.selection();
    }
    if (onexit == null) exit.remove();
    else onexit(exit);
    return enter && update ? enter.merge(update).order() : update;
}

});

parcelRegister("g5j6k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb5bee0abd8e0fbb$export$2e2bcd8739ae039; });

var $gbmQo = parcelRequire("gbmQo");
function $bb5bee0abd8e0fbb$export$2e2bcd8739ae039(context) {
    var selection = context.selection ? context.selection() : context;
    for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $gbmQo.Selection)(merges, this._parents);
}

});

parcelRegister("kHnMX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f11a46be077ae3dd$export$2e2bcd8739ae039; });
function $f11a46be077ae3dd$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
        for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
            if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
            next = node;
        }
    }
    return this;
}

});

parcelRegister("lnaWT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8f43d2f1d3180b4$export$2e2bcd8739ae039; });

var $gbmQo = parcelRequire("gbmQo");
function $f8f43d2f1d3180b4$export$2e2bcd8739ae039(compare) {
    if (!compare) compare = $f8f43d2f1d3180b4$var$ascending;
    function compareNode(a, b) {
        return a && b ? compare(a.__data__, b.__data__) : !a - !b;
    }
    for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
        sortgroup.sort(compareNode);
    }
    return new (0, $gbmQo.Selection)(sortgroups, this._parents).order();
}
function $f8f43d2f1d3180b4$var$ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("l5Zwu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5b9c9d18622e33f$export$2e2bcd8739ae039; });
function $f5b9c9d18622e33f$export$2e2bcd8739ae039() {
    var callback = arguments[0];
    arguments[0] = this;
    callback.apply(null, arguments);
    return this;
}

});

parcelRegister("i0aIt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1b08a187c86c7a7$export$2e2bcd8739ae039; });
function $d1b08a187c86c7a7$export$2e2bcd8739ae039() {
    return Array.from(this);
}

});

parcelRegister("law9J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f69379a1309adc23$export$2e2bcd8739ae039; });
function $f69379a1309adc23$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
        var node = group[i];
        if (node) return node;
    }
    return null;
}

});

parcelRegister("1m83r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fce17fa489a299f$export$2e2bcd8739ae039; });
function $0fce17fa489a299f$export$2e2bcd8739ae039() {
    let size = 0;
    for (const node of this)++size; // eslint-disable-line no-unused-vars
    return size;
}

});

parcelRegister("3bPL7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $252a8c70b4356708$export$2e2bcd8739ae039; });
function $252a8c70b4356708$export$2e2bcd8739ae039() {
    return !this.node();
}

});

parcelRegister("2SEUW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21905d40a49dce29$export$2e2bcd8739ae039; });
function $21905d40a49dce29$export$2e2bcd8739ae039(callback) {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
    return this;
}

});

parcelRegister("9vpbu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6eba8b5ceeef8d8a$export$2e2bcd8739ae039; });

var $3B9Xw = parcelRequire("3B9Xw");
function $6eba8b5ceeef8d8a$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $6eba8b5ceeef8d8a$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $6eba8b5ceeef8d8a$var$attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function $6eba8b5ceeef8d8a$var$attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function $6eba8b5ceeef8d8a$var$attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function $6eba8b5ceeef8d8a$var$attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}
function $6eba8b5ceeef8d8a$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $3B9Xw.default)(name);
    if (arguments.length < 2) {
        var node = this.node();
        return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
    }
    return this.each((value == null ? fullname.local ? $6eba8b5ceeef8d8a$var$attrRemoveNS : $6eba8b5ceeef8d8a$var$attrRemove : typeof value === "function" ? fullname.local ? $6eba8b5ceeef8d8a$var$attrFunctionNS : $6eba8b5ceeef8d8a$var$attrFunction : fullname.local ? $6eba8b5ceeef8d8a$var$attrConstantNS : $6eba8b5ceeef8d8a$var$attrConstant)(fullname, value));
}

});
parcelRegister("3B9Xw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29ec8d70a2254843$export$2e2bcd8739ae039; });

var $htf4P = parcelRequire("htf4P");
function $29ec8d70a2254843$export$2e2bcd8739ae039(name) {
    var prefix = name += "", i = prefix.indexOf(":");
    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
    return (0, $htf4P.default).hasOwnProperty(prefix) ? {
        space: (0, $htf4P.default)[prefix],
        local: name
    } : name; // eslint-disable-line no-prototype-builtins
}

});
parcelRegister("htf4P", function(module, exports) {

$parcel$export(module.exports, "xhtml", function () { return $cb80d70eec280e89$export$201a3f7520ccc326; });
$parcel$export(module.exports, "default", function () { return $cb80d70eec280e89$export$2e2bcd8739ae039; });
var $cb80d70eec280e89$export$201a3f7520ccc326 = "http://www.w3.org/1999/xhtml";
var $cb80d70eec280e89$export$2e2bcd8739ae039 = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: $cb80d70eec280e89$export$201a3f7520ccc326,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};

});



parcelRegister("kwD7i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef15238a9da2c8f5$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "styleValue", function () { return $ef15238a9da2c8f5$export$5e3cec964f0b5efd; });

var $9vYVz = parcelRequire("9vYVz");
function $ef15238a9da2c8f5$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $ef15238a9da2c8f5$var$styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function $ef15238a9da2c8f5$var$styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function $ef15238a9da2c8f5$export$2e2bcd8739ae039(name, value, priority) {
    return arguments.length > 1 ? this.each((value == null ? $ef15238a9da2c8f5$var$styleRemove : typeof value === "function" ? $ef15238a9da2c8f5$var$styleFunction : $ef15238a9da2c8f5$var$styleConstant)(name, value, priority == null ? "" : priority)) : $ef15238a9da2c8f5$export$5e3cec964f0b5efd(this.node(), name);
}
function $ef15238a9da2c8f5$export$5e3cec964f0b5efd(node, name) {
    return node.style.getPropertyValue(name) || (0, $9vYVz.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}

});
parcelRegister("9vYVz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ed64540aedc3948$export$2e2bcd8739ae039; });
function $6ed64540aedc3948$export$2e2bcd8739ae039(node) {
    return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
     || node.document && node // node is a Window
     || node.defaultView; // node is a Document
}

});


parcelRegister("9BFHc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fe7e9b0734433b5$export$2e2bcd8739ae039; });
function $6fe7e9b0734433b5$var$propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function $6fe7e9b0734433b5$var$propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function $6fe7e9b0734433b5$var$propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}
function $6fe7e9b0734433b5$export$2e2bcd8739ae039(name, value) {
    return arguments.length > 1 ? this.each((value == null ? $6fe7e9b0734433b5$var$propertyRemove : typeof value === "function" ? $6fe7e9b0734433b5$var$propertyFunction : $6fe7e9b0734433b5$var$propertyConstant)(name, value)) : this.node()[name];
}

});

parcelRegister("5SrSa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44779dcf3b021fcb$export$2e2bcd8739ae039; });
function $44779dcf3b021fcb$var$classArray(string) {
    return string.trim().split(/^|\s+/);
}
function $44779dcf3b021fcb$var$classList(node) {
    return node.classList || new $44779dcf3b021fcb$var$ClassList(node);
}
function $44779dcf3b021fcb$var$ClassList(node) {
    this._node = node;
    this._names = $44779dcf3b021fcb$var$classArray(node.getAttribute("class") || "");
}
$44779dcf3b021fcb$var$ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function $44779dcf3b021fcb$var$classedAdd(node, names) {
    var list = $44779dcf3b021fcb$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function $44779dcf3b021fcb$var$classedRemove(node, names) {
    var list = $44779dcf3b021fcb$var$classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function $44779dcf3b021fcb$var$classedTrue(names) {
    return function() {
        $44779dcf3b021fcb$var$classedAdd(this, names);
    };
}
function $44779dcf3b021fcb$var$classedFalse(names) {
    return function() {
        $44779dcf3b021fcb$var$classedRemove(this, names);
    };
}
function $44779dcf3b021fcb$var$classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? $44779dcf3b021fcb$var$classedAdd : $44779dcf3b021fcb$var$classedRemove)(this, names);
    };
}
function $44779dcf3b021fcb$export$2e2bcd8739ae039(name, value) {
    var names = $44779dcf3b021fcb$var$classArray(name + "");
    if (arguments.length < 2) {
        var list = $44779dcf3b021fcb$var$classList(this.node()), i = -1, n = names.length;
        while(++i < n)if (!list.contains(names[i])) return false;
        return true;
    }
    return this.each((typeof value === "function" ? $44779dcf3b021fcb$var$classedFunction : value ? $44779dcf3b021fcb$var$classedTrue : $44779dcf3b021fcb$var$classedFalse)(names, value));
}

});

parcelRegister("gKRZM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c32ad39849cb600b$export$2e2bcd8739ae039; });
function $c32ad39849cb600b$var$textRemove() {
    this.textContent = "";
}
function $c32ad39849cb600b$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $c32ad39849cb600b$var$textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}
function $c32ad39849cb600b$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $c32ad39849cb600b$var$textRemove : (typeof value === "function" ? $c32ad39849cb600b$var$textFunction : $c32ad39849cb600b$var$textConstant)(value)) : this.node().textContent;
}

});

parcelRegister("eovX4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7ac1784f996f5db$export$2e2bcd8739ae039; });
function $a7ac1784f996f5db$var$htmlRemove() {
    this.innerHTML = "";
}
function $a7ac1784f996f5db$var$htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function $a7ac1784f996f5db$var$htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}
function $a7ac1784f996f5db$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.each(value == null ? $a7ac1784f996f5db$var$htmlRemove : (typeof value === "function" ? $a7ac1784f996f5db$var$htmlFunction : $a7ac1784f996f5db$var$htmlConstant)(value)) : this.node().innerHTML;
}

});

parcelRegister("8aMRq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f3528a487a6457b$export$2e2bcd8739ae039; });
function $5f3528a487a6457b$var$raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}
function $5f3528a487a6457b$export$2e2bcd8739ae039() {
    return this.each($5f3528a487a6457b$var$raise);
}

});

parcelRegister("K0B6n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08a4c2a0793a9aed$export$2e2bcd8739ae039; });
function $08a4c2a0793a9aed$var$lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function $08a4c2a0793a9aed$export$2e2bcd8739ae039() {
    return this.each($08a4c2a0793a9aed$var$lower);
}

});

parcelRegister("cwbhp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91d1391ae8295102$export$2e2bcd8739ae039; });

var $1YXWr = parcelRequire("1YXWr");
function $91d1391ae8295102$export$2e2bcd8739ae039(name) {
    var create = typeof name === "function" ? name : (0, $1YXWr.default)(name);
    return this.select(function() {
        return this.appendChild(create.apply(this, arguments));
    });
}

});
parcelRegister("1YXWr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1719e43438949144$export$2e2bcd8739ae039; });

var $3B9Xw = parcelRequire("3B9Xw");

var $htf4P = parcelRequire("htf4P");
function $1719e43438949144$var$creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, $htf4P.xhtml) && document.documentElement.namespaceURI === (0, $htf4P.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function $1719e43438949144$var$creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}
function $1719e43438949144$export$2e2bcd8739ae039(name) {
    var fullname = (0, $3B9Xw.default)(name);
    return (fullname.local ? $1719e43438949144$var$creatorFixed : $1719e43438949144$var$creatorInherit)(fullname);
}

});


parcelRegister("kPmCU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f29a1f34f8eb1acd$export$2e2bcd8739ae039; });

var $1YXWr = parcelRequire("1YXWr");

var $2DouR = parcelRequire("2DouR");
function $f29a1f34f8eb1acd$var$constantNull() {
    return null;
}
function $f29a1f34f8eb1acd$export$2e2bcd8739ae039(name, before) {
    var create = typeof name === "function" ? name : (0, $1YXWr.default)(name), select = before == null ? $f29a1f34f8eb1acd$var$constantNull : typeof before === "function" ? before : (0, $2DouR.default)(before);
    return this.select(function() {
        return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
    });
}

});

parcelRegister("iNWqO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db0a20d8a762bc50$export$2e2bcd8739ae039; });
function $db0a20d8a762bc50$var$remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}
function $db0a20d8a762bc50$export$2e2bcd8739ae039() {
    return this.each($db0a20d8a762bc50$var$remove);
}

});

parcelRegister("iwkAW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7bb30e00aefefa8$export$2e2bcd8739ae039; });
function $d7bb30e00aefefa8$var$selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $d7bb30e00aefefa8$var$selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function $d7bb30e00aefefa8$export$2e2bcd8739ae039(deep) {
    return this.select(deep ? $d7bb30e00aefefa8$var$selection_cloneDeep : $d7bb30e00aefefa8$var$selection_cloneShallow);
}

});

parcelRegister("aml7D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78ac57e410e5e3d5$export$2e2bcd8739ae039; });
function $78ac57e410e5e3d5$export$2e2bcd8739ae039(value) {
    return arguments.length ? this.property("__data__", value) : this.node().__data__;
}

});

parcelRegister("iIcz4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9f615229f04a5ec$export$2e2bcd8739ae039; });
function $d9f615229f04a5ec$var$contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function $d9f615229f04a5ec$var$parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function $d9f615229f04a5ec$var$onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function $d9f615229f04a5ec$var$onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = $d9f615229f04a5ec$var$contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function $d9f615229f04a5ec$export$2e2bcd8739ae039(typename, value, options) {
    var typenames = $d9f615229f04a5ec$var$parseTypenames(typename + ""), i, n = typenames.length, t;
    if (arguments.length < 2) {
        var on = this.node().__on;
        if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
            if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
        }
        return;
    }
    on = value ? $d9f615229f04a5ec$var$onAdd : $d9f615229f04a5ec$var$onRemove;
    for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
    return this;
}

});

parcelRegister("ixkJ0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7eb629371e817aa$export$2e2bcd8739ae039; });

var $9vYVz = parcelRequire("9vYVz");
function $d7eb629371e817aa$var$dispatchEvent(node, type, params) {
    var window = (0, $9vYVz.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function $d7eb629371e817aa$var$dispatchConstant(type, params) {
    return function() {
        return $d7eb629371e817aa$var$dispatchEvent(this, type, params);
    };
}
function $d7eb629371e817aa$var$dispatchFunction(type, params) {
    return function() {
        return $d7eb629371e817aa$var$dispatchEvent(this, type, params.apply(this, arguments));
    };
}
function $d7eb629371e817aa$export$2e2bcd8739ae039(type, params) {
    return this.each((typeof params === "function" ? $d7eb629371e817aa$var$dispatchFunction : $d7eb629371e817aa$var$dispatchConstant)(type, params));
}

});

parcelRegister("kcrvd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb4a430d1f316203$export$2e2bcd8739ae039; });
function* $eb4a430d1f316203$export$2e2bcd8739ae039() {
    for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
        for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
    }
}

});



parcelRegister("kWxs6", function(module, exports) {

$parcel$export(module.exports, "nonpassivecapture", function () { return $f3f32c59fae17af2$export$35431a0e47022de1; });
$parcel$export(module.exports, "default", function () { return $f3f32c59fae17af2$export$2e2bcd8739ae039; });
// These are typically used in conjunction with noevent to ensure that we can
// preventDefault on the event.
const $f3f32c59fae17af2$export$524615cd03e458cc = {
    passive: false
};
const $f3f32c59fae17af2$export$35431a0e47022de1 = {
    capture: true,
    passive: false
};
function $f3f32c59fae17af2$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $f3f32c59fae17af2$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}

});


parcelRegister("2oxjG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1be7aa9e5f3fcbe6$export$2e2bcd8739ae039; });

var $jV0cA = parcelRequire("jV0cA");

var $kvKPU = parcelRequire("kvKPU");

var $ksjkd = parcelRequire("ksjkd");

var $Vauyh = parcelRequire("Vauyh");

var $7MusT = parcelRequire("7MusT");

var $hKmy6 = parcelRequire("hKmy6");

var $f6fq4 = parcelRequire("f6fq4");

var $11AiG = parcelRequire("11AiG");

var $2hDrn = parcelRequire("2hDrn");
function $1be7aa9e5f3fcbe6$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $11AiG.default)(b) : (t === "number" ? (0, $7MusT.default) : t === "string" ? (c = (0, $jV0cA.default)(b)) ? (b = c, $kvKPU.default) : (0, $f6fq4.default) : b instanceof (0, $jV0cA.default) ? (0, $kvKPU.default) : b instanceof Date ? (0, $Vauyh.default) : (0, $2hDrn.isNumberArray)(b) ? (0, $2hDrn.default) : Array.isArray(b) ? (0, $ksjkd.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $hKmy6.default) : (0, $7MusT.default))(a, b);
}

});
parcelRegister("jV0cA", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return Color; });
$parcel$export(module.exports, "darker", function () { return darker; });
$parcel$export(module.exports, "brighter", function () { return brighter; });
$parcel$export(module.exports, "default", function () { return color; });
$parcel$export(module.exports, "hslConvert", function () { return hslConvert; });
$parcel$export(module.exports, "Rgb", function () { return Rgb; });
$parcel$export(module.exports, "rgbConvert", function () { return rgbConvert; });
$parcel$export(module.exports, "rgb", function () { return rgb; });
$parcel$export(module.exports, "hsl", function () { return hsl; });

var $bzUm5 = parcelRequire("bzUm5");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $bzUm5.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $bzUm5.default)(Rgb, rgb, (0, $bzUm5.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $bzUm5.default)(Hsl, hsl, (0, $bzUm5.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("bzUm5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86dead91ea700dda$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $86dead91ea700dda$export$8b58be045bf06082; });
function $86dead91ea700dda$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $86dead91ea700dda$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("kvKPU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eeeb089bec854ce2$export$2e2bcd8739ae039; });

var $jV0cA = parcelRequire("jV0cA");

var $6dn3Z = parcelRequire("6dn3Z");

var $cEDHl = parcelRequire("cEDHl");

var $6Hghl = parcelRequire("6Hghl");
var $eeeb089bec854ce2$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $6Hghl.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $jV0cA.rgb)(start)).r, (end = (0, $jV0cA.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $6Hghl.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $eeeb089bec854ce2$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $jV0cA.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $eeeb089bec854ce2$export$2c0e28f2e2852d3f = $eeeb089bec854ce2$var$rgbSpline((0, $6dn3Z.default));
var $eeeb089bec854ce2$export$53d5214f625ccd4c = $eeeb089bec854ce2$var$rgbSpline((0, $cEDHl.default));

});
parcelRegister("6dn3Z", function(module, exports) {

$parcel$export(module.exports, "basis", function () { return $4865d8e1c040ac7b$export$4e41033bfeec1a4c; });
$parcel$export(module.exports, "default", function () { return $4865d8e1c040ac7b$export$2e2bcd8739ae039; });
function $4865d8e1c040ac7b$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $4865d8e1c040ac7b$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $4865d8e1c040ac7b$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("cEDHl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $936803ac3ebb1e88$export$2e2bcd8739ae039; });

var $6dn3Z = parcelRequire("6dn3Z");
function $936803ac3ebb1e88$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $6dn3Z.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("6Hghl", function(module, exports) {

$parcel$export(module.exports, "gamma", function () { return $4e0362dfac3acfb1$export$a7ebe8cc6aaf8d37; });
$parcel$export(module.exports, "default", function () { return $4e0362dfac3acfb1$export$2e2bcd8739ae039; });

var $11AiG = parcelRequire("11AiG");
function $4e0362dfac3acfb1$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $4e0362dfac3acfb1$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $4e0362dfac3acfb1$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $4e0362dfac3acfb1$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $11AiG.default)(isNaN(a) ? b : a);
}
function $4e0362dfac3acfb1$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $4e0362dfac3acfb1$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $4e0362dfac3acfb1$var$exponential(a, b, y) : (0, $11AiG.default)(isNaN(a) ? b : a);
    };
}
function $4e0362dfac3acfb1$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $4e0362dfac3acfb1$var$linear(a, d) : (0, $11AiG.default)(isNaN(a) ? b : a);
}

});
parcelRegister("11AiG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bf20af51c3dc7fd$export$2e2bcd8739ae039; });
var $0bf20af51c3dc7fd$export$2e2bcd8739ae039 = (x)=>()=>x;

});



parcelRegister("ksjkd", function(module, exports) {

$parcel$export(module.exports, "genericArray", function () { return $ee4569bcba1cb5a4$export$15d09067c6a5ee49; });

var $2oxjG = parcelRequire("2oxjG");

var $2hDrn = parcelRequire("2hDrn");
function $ee4569bcba1cb5a4$export$2e2bcd8739ae039(a, b) {
    return ((0, $2hDrn.isNumberArray)(b) ? (0, $2hDrn.default) : $ee4569bcba1cb5a4$export$15d09067c6a5ee49)(a, b);
}
function $ee4569bcba1cb5a4$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $2oxjG.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("2hDrn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a9bc3661fa8655a$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "isNumberArray", function () { return $1a9bc3661fa8655a$export$5cd576d1827d40c8; });
function $1a9bc3661fa8655a$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $1a9bc3661fa8655a$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("Vauyh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0abd766eef17c64a$export$2e2bcd8739ae039; });
function $0abd766eef17c64a$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("7MusT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5aa4a5d61b30d497$export$2e2bcd8739ae039; });
function $5aa4a5d61b30d497$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("hKmy6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03558d4fdb7a4b8f$export$2e2bcd8739ae039; });

var $2oxjG = parcelRequire("2oxjG");
function $03558d4fdb7a4b8f$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $2oxjG.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("f6fq4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afe36089470ed779$export$2e2bcd8739ae039; });

var $7MusT = parcelRequire("7MusT");
var $afe36089470ed779$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $afe36089470ed779$var$reB = new RegExp($afe36089470ed779$var$reA.source, "g");
function $afe36089470ed779$var$zero(b) {
    return function() {
        return b;
    };
}
function $afe36089470ed779$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $afe36089470ed779$export$2e2bcd8739ae039(a, b) {
    var bi = $afe36089470ed779$var$reA.lastIndex = $afe36089470ed779$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $afe36089470ed779$var$reA.exec(a)) && (bm = $afe36089470ed779$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $7MusT.default)(am, bm)
            });
        }
        bi = $afe36089470ed779$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $afe36089470ed779$var$one(q[0].x) : $afe36089470ed779$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("bjzWC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83cd59e297a0b883$export$2e2bcd8739ae039; });

var $8vHUo = parcelRequire("8vHUo");
function $83cd59e297a0b883$export$2e2bcd8739ae039(event, node) {
    event = (0, $8vHUo.default)(event);
    if (node === undefined) node = event.currentTarget;
    if (node) {
        var svg = node.ownerSVGElement || node;
        if (svg.createSVGPoint) {
            var point = svg.createSVGPoint();
            point.x = event.clientX, point.y = event.clientY;
            point = point.matrixTransform(node.getScreenCTM().inverse());
            return [
                point.x,
                point.y
            ];
        }
        if (node.getBoundingClientRect) {
            var rect = node.getBoundingClientRect();
            return [
                event.clientX - rect.left - node.clientLeft,
                event.clientY - rect.top - node.clientTop
            ];
        }
    }
    return [
        event.pageX,
        event.pageY
    ];
}

});
parcelRegister("8vHUo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6323474b7120fe31$export$2e2bcd8739ae039; });
function $6323474b7120fe31$export$2e2bcd8739ae039(event) {
    let sourceEvent;
    while(sourceEvent = event.sourceEvent)event = sourceEvent;
    return event;
}

});


parcelRegister("4WsfD", function(module, exports) {

$parcel$export(module.exports, "transition", function () { return (parcelRequire("1N69U")).default; });
$parcel$export(module.exports, "interrupt", function () { return (parcelRequire("eip42")).default; });
parcelRequire("dsDns");

var $1N69U = parcelRequire("1N69U");


var $eip42 = parcelRequire("eip42");

});
parcelRegister("dsDns", function(module, exports) {

var $gbmQo = parcelRequire("gbmQo");

var $lLsVi = parcelRequire("lLsVi");

var $i2zmu = parcelRequire("i2zmu");
(0, $gbmQo.default).prototype.interrupt = (0, $lLsVi.default);
(0, $gbmQo.default).prototype.transition = (0, $i2zmu.default);

});
parcelRegister("lLsVi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd846c4bf02c535e$export$2e2bcd8739ae039; });

var $eip42 = parcelRequire("eip42");
function $fd846c4bf02c535e$export$2e2bcd8739ae039(name) {
    return this.each(function() {
        (0, $eip42.default)(this, name);
    });
}

});
parcelRegister("eip42", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a686305b7f0268cb$export$2e2bcd8739ae039; });

var $lEnJf = parcelRequire("lEnJf");
function $a686305b7f0268cb$export$2e2bcd8739ae039(node, name) {
    var schedules = node.__transition, schedule, active, empty = true, i;
    if (!schedules) return;
    name = name == null ? null : name + "";
    for(i in schedules){
        if ((schedule = schedules[i]).name !== name) {
            empty = false;
            continue;
        }
        active = schedule.state > (0, $lEnJf.STARTING) && schedule.state < (0, $lEnJf.ENDING);
        schedule.state = (0, $lEnJf.ENDED);
        schedule.timer.stop();
        schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
        delete schedules[i];
    }
    if (empty) delete node.__transition;
}

});
parcelRegister("lEnJf", function(module, exports) {

$parcel$export(module.exports, "STARTING", function () { return $fc2fbd75fe01183a$export$a5d151aee16efd42; });
$parcel$export(module.exports, "ENDING", function () { return $fc2fbd75fe01183a$export$a2e792214ded83b2; });
$parcel$export(module.exports, "ENDED", function () { return $fc2fbd75fe01183a$export$9d38167254403955; });
$parcel$export(module.exports, "default", function () { return $fc2fbd75fe01183a$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "init", function () { return $fc2fbd75fe01183a$export$2cd8252107eb640b; });
$parcel$export(module.exports, "get", function () { return $fc2fbd75fe01183a$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "set", function () { return $fc2fbd75fe01183a$export$adaa4cf7ef1b65be; });

var $cMYF7 = parcelRequire("cMYF7");

var $cca7U = parcelRequire("cca7U");
var $7QIeD = parcelRequire("7QIeD");
var $fc2fbd75fe01183a$var$emptyOn = (0, $cMYF7.default)("start", "end", "cancel", "interrupt");
var $fc2fbd75fe01183a$var$emptyTween = [];
var $fc2fbd75fe01183a$export$ff39ebd4bb12b718 = 0;
var $fc2fbd75fe01183a$export$584530fe98d14a84 = 1;
var $fc2fbd75fe01183a$export$a5d151aee16efd42 = 2;
var $fc2fbd75fe01183a$export$fb935ab5849a0db9 = 3;
var $fc2fbd75fe01183a$export$1573e22b087389af = 4;
var $fc2fbd75fe01183a$export$a2e792214ded83b2 = 5;
var $fc2fbd75fe01183a$export$9d38167254403955 = 6;
function $fc2fbd75fe01183a$export$2e2bcd8739ae039(node, name, id, index, group, timing) {
    var schedules = node.__transition;
    if (!schedules) node.__transition = {};
    else if (id in schedules) return;
    $fc2fbd75fe01183a$var$create(node, id, {
        name: name,
        index: index,
        group: group,
        on: $fc2fbd75fe01183a$var$emptyOn,
        tween: $fc2fbd75fe01183a$var$emptyTween,
        time: timing.time,
        delay: timing.delay,
        duration: timing.duration,
        ease: timing.ease,
        timer: null,
        state: $fc2fbd75fe01183a$export$ff39ebd4bb12b718
    });
}
function $fc2fbd75fe01183a$export$2cd8252107eb640b(node, id) {
    var schedule = $fc2fbd75fe01183a$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $fc2fbd75fe01183a$export$ff39ebd4bb12b718) throw new Error("too late; already scheduled");
    return schedule;
}
function $fc2fbd75fe01183a$export$adaa4cf7ef1b65be(node, id) {
    var schedule = $fc2fbd75fe01183a$export$3988ae62b71be9a3(node, id);
    if (schedule.state > $fc2fbd75fe01183a$export$fb935ab5849a0db9) throw new Error("too late; already running");
    return schedule;
}
function $fc2fbd75fe01183a$export$3988ae62b71be9a3(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function $fc2fbd75fe01183a$var$create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, $7QIeD.timer)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = $fc2fbd75fe01183a$export$584530fe98d14a84;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== $fc2fbd75fe01183a$export$584530fe98d14a84) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === $fc2fbd75fe01183a$export$fb935ab5849a0db9) return (0, $cca7U.default)(start);
            // Interrupt the active transition, if any.
            if (o.state === $fc2fbd75fe01183a$export$1573e22b087389af) {
                o.state = $fc2fbd75fe01183a$export$9d38167254403955;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = $fc2fbd75fe01183a$export$9d38167254403955;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, $cca7U.default)(function() {
            if (self.state === $fc2fbd75fe01183a$export$fb935ab5849a0db9) {
                self.state = $fc2fbd75fe01183a$export$1573e22b087389af;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = $fc2fbd75fe01183a$export$a5d151aee16efd42;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== $fc2fbd75fe01183a$export$a5d151aee16efd42) return; // interrupted
        self.state = $fc2fbd75fe01183a$export$fb935ab5849a0db9;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = $fc2fbd75fe01183a$export$a2e792214ded83b2, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === $fc2fbd75fe01183a$export$a2e792214ded83b2) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = $fc2fbd75fe01183a$export$9d38167254403955;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}

});
parcelRegister("cca7U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e0e75f42563fd62$export$2e2bcd8739ae039; });

var $7QIeD = parcelRequire("7QIeD");
function $8e0e75f42563fd62$export$2e2bcd8739ae039(callback, delay, time) {
    var t = new (0, $7QIeD.Timer);
    delay = delay == null ? 0 : +delay;
    t.restart((elapsed)=>{
        t.stop();
        callback(elapsed + delay);
    }, delay, time);
    return t;
}

});
parcelRegister("7QIeD", function(module, exports) {

$parcel$export(module.exports, "now", function () { return $5b6fb3e76cf62574$export$461939dd4422153; });
$parcel$export(module.exports, "Timer", function () { return $5b6fb3e76cf62574$export$c57e9b2d8b9e4de; });
$parcel$export(module.exports, "timer", function () { return $5b6fb3e76cf62574$export$9dc4ecf953986f04; });
var $5b6fb3e76cf62574$var$frame = 0, $5b6fb3e76cf62574$var$timeout = 0, $5b6fb3e76cf62574$var$interval = 0, $5b6fb3e76cf62574$var$pokeDelay = 1000, $5b6fb3e76cf62574$var$taskHead, $5b6fb3e76cf62574$var$taskTail, $5b6fb3e76cf62574$var$clockLast = 0, $5b6fb3e76cf62574$var$clockNow = 0, $5b6fb3e76cf62574$var$clockSkew = 0, $5b6fb3e76cf62574$var$clock = typeof performance === "object" && performance.now ? performance : Date, $5b6fb3e76cf62574$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $5b6fb3e76cf62574$export$461939dd4422153() {
    return $5b6fb3e76cf62574$var$clockNow || ($5b6fb3e76cf62574$var$setFrame($5b6fb3e76cf62574$var$clearNow), $5b6fb3e76cf62574$var$clockNow = $5b6fb3e76cf62574$var$clock.now() + $5b6fb3e76cf62574$var$clockSkew);
}
function $5b6fb3e76cf62574$var$clearNow() {
    $5b6fb3e76cf62574$var$clockNow = 0;
}
function $5b6fb3e76cf62574$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$5b6fb3e76cf62574$export$c57e9b2d8b9e4de.prototype = $5b6fb3e76cf62574$export$9dc4ecf953986f04.prototype = {
    constructor: $5b6fb3e76cf62574$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $5b6fb3e76cf62574$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $5b6fb3e76cf62574$var$taskTail !== this) {
            if ($5b6fb3e76cf62574$var$taskTail) $5b6fb3e76cf62574$var$taskTail._next = this;
            else $5b6fb3e76cf62574$var$taskHead = this;
            $5b6fb3e76cf62574$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $5b6fb3e76cf62574$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $5b6fb3e76cf62574$var$sleep();
        }
    }
};
function $5b6fb3e76cf62574$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $5b6fb3e76cf62574$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $5b6fb3e76cf62574$export$d60154c1d7f3990e() {
    $5b6fb3e76cf62574$export$461939dd4422153(); // Get the current time, if not already set.
    ++$5b6fb3e76cf62574$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $5b6fb3e76cf62574$var$taskHead, e;
    while(t){
        if ((e = $5b6fb3e76cf62574$var$clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --$5b6fb3e76cf62574$var$frame;
}
function $5b6fb3e76cf62574$var$wake() {
    $5b6fb3e76cf62574$var$clockNow = ($5b6fb3e76cf62574$var$clockLast = $5b6fb3e76cf62574$var$clock.now()) + $5b6fb3e76cf62574$var$clockSkew;
    $5b6fb3e76cf62574$var$frame = $5b6fb3e76cf62574$var$timeout = 0;
    try {
        $5b6fb3e76cf62574$export$d60154c1d7f3990e();
    } finally{
        $5b6fb3e76cf62574$var$frame = 0;
        $5b6fb3e76cf62574$var$nap();
        $5b6fb3e76cf62574$var$clockNow = 0;
    }
}
function $5b6fb3e76cf62574$var$poke() {
    var now = $5b6fb3e76cf62574$var$clock.now(), delay = now - $5b6fb3e76cf62574$var$clockLast;
    if (delay > $5b6fb3e76cf62574$var$pokeDelay) $5b6fb3e76cf62574$var$clockSkew -= delay, $5b6fb3e76cf62574$var$clockLast = now;
}
function $5b6fb3e76cf62574$var$nap() {
    var t0, t1 = $5b6fb3e76cf62574$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $5b6fb3e76cf62574$var$taskHead = t2;
    }
    $5b6fb3e76cf62574$var$taskTail = t0;
    $5b6fb3e76cf62574$var$sleep(time);
}
function $5b6fb3e76cf62574$var$sleep(time) {
    if ($5b6fb3e76cf62574$var$frame) return; // Soonest alarm already set, or will be.
    if ($5b6fb3e76cf62574$var$timeout) $5b6fb3e76cf62574$var$timeout = clearTimeout($5b6fb3e76cf62574$var$timeout);
    var delay = time - $5b6fb3e76cf62574$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $5b6fb3e76cf62574$var$timeout = setTimeout($5b6fb3e76cf62574$var$wake, time - $5b6fb3e76cf62574$var$clock.now() - $5b6fb3e76cf62574$var$clockSkew);
        if ($5b6fb3e76cf62574$var$interval) $5b6fb3e76cf62574$var$interval = clearInterval($5b6fb3e76cf62574$var$interval);
    } else {
        if (!$5b6fb3e76cf62574$var$interval) $5b6fb3e76cf62574$var$clockLast = $5b6fb3e76cf62574$var$clock.now(), $5b6fb3e76cf62574$var$interval = setInterval($5b6fb3e76cf62574$var$poke, $5b6fb3e76cf62574$var$pokeDelay);
        $5b6fb3e76cf62574$var$frame = 1, $5b6fb3e76cf62574$var$setFrame($5b6fb3e76cf62574$var$wake);
    }
}

});





parcelRegister("i2zmu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d223d7fbdb548853$export$2e2bcd8739ae039; });

var $1N69U = parcelRequire("1N69U");

var $lEnJf = parcelRequire("lEnJf");

var $kAS3Z = parcelRequire("kAS3Z");

var $7QIeD = parcelRequire("7QIeD");
var $d223d7fbdb548853$var$defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, $kAS3Z.cubicInOut)
};
function $d223d7fbdb548853$var$inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}
function $d223d7fbdb548853$export$2e2bcd8739ae039(name) {
    var id, timing;
    if (name instanceof (0, $1N69U.Transition)) id = name._id, name = name._name;
    else id = (0, $1N69U.newId)(), (timing = $d223d7fbdb548853$var$defaultTiming).time = (0, $7QIeD.now)(), name = name == null ? null : name + "";
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, $lEnJf.default)(node, name, id, i, group, timing || $d223d7fbdb548853$var$inherit(node, id));
    }
    return new (0, $1N69U.Transition)(groups, this._parents, name, id);
}

});
parcelRegister("1N69U", function(module, exports) {

$parcel$export(module.exports, "Transition", function () { return $14df25160c512861$export$be58926105124dd4; });
$parcel$export(module.exports, "default", function () { return $14df25160c512861$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "newId", function () { return $14df25160c512861$export$9ffd10a3fbdc175b; });

var $gbmQo = parcelRequire("gbmQo");

var $3fOsQ = parcelRequire("3fOsQ");

var $kf89K = parcelRequire("kf89K");

var $3A0mc = parcelRequire("3A0mc");

var $9cs2b = parcelRequire("9cs2b");

var $by8fi = parcelRequire("by8fi");

var $1dt3c = parcelRequire("1dt3c");

var $glxhB = parcelRequire("glxhB");

var $2nyaJ = parcelRequire("2nyaJ");

var $iv5PN = parcelRequire("iv5PN");

var $7GAgM = parcelRequire("7GAgM");

var $95byG = parcelRequire("95byG");

var $ewM9T = parcelRequire("ewM9T");

var $e76Vs = parcelRequire("e76Vs");

var $3hjja = parcelRequire("3hjja");

var $kIpdD = parcelRequire("kIpdD");

var $4Twz1 = parcelRequire("4Twz1");

var $cRFSB = parcelRequire("cRFSB");

var $3Ydjj = parcelRequire("3Ydjj");

var $4BnEM = parcelRequire("4BnEM");

var $7Pf2m = parcelRequire("7Pf2m");
var $14df25160c512861$var$id = 0;
function $14df25160c512861$export$be58926105124dd4(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function $14df25160c512861$export$2e2bcd8739ae039(name) {
    return (0, $gbmQo.default)().transition(name);
}
function $14df25160c512861$export$9ffd10a3fbdc175b() {
    return ++$14df25160c512861$var$id;
}
var $14df25160c512861$var$selection_prototype = (0, $gbmQo.default).prototype;
$14df25160c512861$export$be58926105124dd4.prototype = $14df25160c512861$export$2e2bcd8739ae039.prototype = {
    constructor: $14df25160c512861$export$be58926105124dd4,
    select: (0, $95byG.default),
    selectAll: (0, $ewM9T.default),
    selectChild: $14df25160c512861$var$selection_prototype.selectChild,
    selectChildren: $14df25160c512861$var$selection_prototype.selectChildren,
    filter: (0, $glxhB.default),
    merge: (0, $2nyaJ.default),
    selection: (0, $e76Vs.default),
    transition: (0, $3Ydjj.default),
    call: $14df25160c512861$var$selection_prototype.call,
    nodes: $14df25160c512861$var$selection_prototype.nodes,
    node: $14df25160c512861$var$selection_prototype.node,
    size: $14df25160c512861$var$selection_prototype.size,
    empty: $14df25160c512861$var$selection_prototype.empty,
    each: $14df25160c512861$var$selection_prototype.each,
    on: (0, $iv5PN.default),
    attr: (0, $3fOsQ.default),
    attrTween: (0, $kf89K.default),
    style: (0, $3hjja.default),
    styleTween: (0, $kIpdD.default),
    text: (0, $4Twz1.default),
    textTween: (0, $cRFSB.default),
    remove: (0, $7GAgM.default),
    tween: (0, $4BnEM.default),
    delay: (0, $3A0mc.default),
    duration: (0, $9cs2b.default),
    ease: (0, $by8fi.default),
    easeVarying: (0, $1dt3c.default),
    end: (0, $7Pf2m.default),
    [Symbol.iterator]: $14df25160c512861$var$selection_prototype[Symbol.iterator]
};

});
parcelRegister("3fOsQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25e9eaf7e215e8b4$export$2e2bcd8739ae039; });

var $82fpR = parcelRequire("82fpR");

var $3B9Xw = parcelRequire("3B9Xw");

var $4BnEM = parcelRequire("4BnEM");

var $6oE6l = parcelRequire("6oE6l");
function $25e9eaf7e215e8b4$var$attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function $25e9eaf7e215e8b4$var$attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function $25e9eaf7e215e8b4$var$attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $25e9eaf7e215e8b4$var$attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $25e9eaf7e215e8b4$var$attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $25e9eaf7e215e8b4$var$attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $25e9eaf7e215e8b4$export$2e2bcd8739ae039(name, value) {
    var fullname = (0, $3B9Xw.default)(name), i = fullname === "transform" ? (0, $82fpR.interpolateTransformSvg) : (0, $6oE6l.default);
    return this.attrTween(name, typeof value === "function" ? (fullname.local ? $25e9eaf7e215e8b4$var$attrFunctionNS : $25e9eaf7e215e8b4$var$attrFunction)(fullname, i, (0, $4BnEM.tweenValue)(this, "attr." + name, value)) : value == null ? (fullname.local ? $25e9eaf7e215e8b4$var$attrRemoveNS : $25e9eaf7e215e8b4$var$attrRemove)(fullname) : (fullname.local ? $25e9eaf7e215e8b4$var$attrConstantNS : $25e9eaf7e215e8b4$var$attrConstant)(fullname, i, value));
}

});
parcelRegister("82fpR", function(module, exports) {

$parcel$export(module.exports, "interpolateTransformCss", function () { return $5d9a77f24211024b$export$56bec7123bb3589a; });
$parcel$export(module.exports, "interpolateTransformSvg", function () { return $5d9a77f24211024b$export$da8cba906d64c082; });

var $7MusT = parcelRequire("7MusT");

var $6eNoX = parcelRequire("6eNoX");
function $5d9a77f24211024b$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $7MusT.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $7MusT.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $7MusT.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $7MusT.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $7MusT.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $7MusT.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $5d9a77f24211024b$export$56bec7123bb3589a = $5d9a77f24211024b$var$interpolateTransform((0, $6eNoX.parseCss), "px, ", "px)", "deg)");
var $5d9a77f24211024b$export$da8cba906d64c082 = $5d9a77f24211024b$var$interpolateTransform((0, $6eNoX.parseSvg), ", ", ")", ")");

});
parcelRegister("6eNoX", function(module, exports) {

$parcel$export(module.exports, "parseCss", function () { return $48aa5f048527ea01$export$59ad369bf4938177; });
$parcel$export(module.exports, "parseSvg", function () { return $48aa5f048527ea01$export$f9ef43f9a1d89a18; });

var $d4djN = parcelRequire("d4djN");
var $48aa5f048527ea01$var$svgNode;
function $48aa5f048527ea01$export$59ad369bf4938177(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, $d4djN.identity) : (0, $d4djN.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $48aa5f048527ea01$export$f9ef43f9a1d89a18(value) {
    if (value == null) return 0, $d4djN.identity;
    if (!$48aa5f048527ea01$var$svgNode) $48aa5f048527ea01$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $48aa5f048527ea01$var$svgNode.setAttribute("transform", value);
    if (!(value = $48aa5f048527ea01$var$svgNode.transform.baseVal.consolidate())) return 0, $d4djN.identity;
    value = value.matrix;
    return (0, $d4djN.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("d4djN", function(module, exports) {

$parcel$export(module.exports, "identity", function () { return $9835fad433fb3aac$export$f0954fd7d5368655; });
$parcel$export(module.exports, "default", function () { return $9835fad433fb3aac$export$2e2bcd8739ae039; });
var $9835fad433fb3aac$var$degrees = 180 / Math.PI;
var $9835fad433fb3aac$export$f0954fd7d5368655 = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function $9835fad433fb3aac$export$2e2bcd8739ae039(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $9835fad433fb3aac$var$degrees,
        skewX: Math.atan(skewX) * $9835fad433fb3aac$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("4BnEM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $359cf7e17f64a4f4$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "tweenValue", function () { return $359cf7e17f64a4f4$export$f78ce6ab10405d82; });

var $lEnJf = parcelRequire("lEnJf");
function $359cf7e17f64a4f4$var$tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, $lEnJf.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function $359cf7e17f64a4f4$var$tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, $lEnJf.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function $359cf7e17f64a4f4$export$2e2bcd8739ae039(name, value) {
    var id = this._id;
    name += "";
    if (arguments.length < 2) {
        var tween = (0, $lEnJf.get)(this.node(), id).tween;
        for(var i = 0, n = tween.length, t; i < n; ++i){
            if ((t = tween[i]).name === name) return t.value;
        }
        return null;
    }
    return this.each((value == null ? $359cf7e17f64a4f4$var$tweenRemove : $359cf7e17f64a4f4$var$tweenFunction)(id, name, value));
}
function $359cf7e17f64a4f4$export$f78ce6ab10405d82(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, $lEnJf.set)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, $lEnJf.get)(node, id).value[name];
    };
}

});

parcelRegister("6oE6l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a84174802c82a1b$export$2e2bcd8739ae039; });

var $jV0cA = parcelRequire("jV0cA");

var $7MusT = parcelRequire("7MusT");
var $kvKPU = parcelRequire("kvKPU");
var $f6fq4 = parcelRequire("f6fq4");
function $4a84174802c82a1b$export$2e2bcd8739ae039(a, b) {
    var c;
    return (typeof b === "number" ? (0, $7MusT.default) : b instanceof (0, $jV0cA.default) ? (0, $kvKPU.default) : (c = (0, $jV0cA.default)(b)) ? (b = c, $kvKPU.default) : (0, $f6fq4.default))(a, b);
}

});


parcelRegister("kf89K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebcb88fe11e15354$export$2e2bcd8739ae039; });

var $3B9Xw = parcelRequire("3B9Xw");
function $ebcb88fe11e15354$var$attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function $ebcb88fe11e15354$var$attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function $ebcb88fe11e15354$var$attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $ebcb88fe11e15354$var$attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $ebcb88fe11e15354$var$attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $ebcb88fe11e15354$var$attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $ebcb88fe11e15354$export$2e2bcd8739ae039(name, value) {
    var key = "attr." + name;
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    var fullname = (0, $3B9Xw.default)(name);
    return this.tween(key, (fullname.local ? $ebcb88fe11e15354$var$attrTweenNS : $ebcb88fe11e15354$var$attrTween)(fullname, value));
}

});

parcelRegister("3A0mc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29b502c559badd05$export$2e2bcd8739ae039; });

var $lEnJf = parcelRequire("lEnJf");
function $29b502c559badd05$var$delayFunction(id, value) {
    return function() {
        (0, $lEnJf.init)(this, id).delay = +value.apply(this, arguments);
    };
}
function $29b502c559badd05$var$delayConstant(id, value) {
    return value = +value, function() {
        (0, $lEnJf.init)(this, id).delay = value;
    };
}
function $29b502c559badd05$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $29b502c559badd05$var$delayFunction : $29b502c559badd05$var$delayConstant)(id, value)) : (0, $lEnJf.get)(this.node(), id).delay;
}

});

parcelRegister("9cs2b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b2afb136bf568de$export$2e2bcd8739ae039; });

var $lEnJf = parcelRequire("lEnJf");
function $6b2afb136bf568de$var$durationFunction(id, value) {
    return function() {
        (0, $lEnJf.set)(this, id).duration = +value.apply(this, arguments);
    };
}
function $6b2afb136bf568de$var$durationConstant(id, value) {
    return value = +value, function() {
        (0, $lEnJf.set)(this, id).duration = value;
    };
}
function $6b2afb136bf568de$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each((typeof value === "function" ? $6b2afb136bf568de$var$durationFunction : $6b2afb136bf568de$var$durationConstant)(id, value)) : (0, $lEnJf.get)(this.node(), id).duration;
}

});

parcelRegister("by8fi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8689441b0fd0e6e6$export$2e2bcd8739ae039; });

var $lEnJf = parcelRequire("lEnJf");
function $8689441b0fd0e6e6$var$easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, $lEnJf.set)(this, id).ease = value;
    };
}
function $8689441b0fd0e6e6$export$2e2bcd8739ae039(value) {
    var id = this._id;
    return arguments.length ? this.each($8689441b0fd0e6e6$var$easeConstant(id, value)) : (0, $lEnJf.get)(this.node(), id).ease;
}

});

parcelRegister("1dt3c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e2d8a335b98e8c8$export$2e2bcd8739ae039; });

var $lEnJf = parcelRequire("lEnJf");
function $0e2d8a335b98e8c8$var$easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, $lEnJf.set)(this, id).ease = v;
    };
}
function $0e2d8a335b98e8c8$export$2e2bcd8739ae039(value) {
    if (typeof value !== "function") throw new Error;
    return this.each($0e2d8a335b98e8c8$var$easeVarying(this._id, value));
}

});

parcelRegister("glxhB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be686cd2cecc0588$export$2e2bcd8739ae039; });

var $bAk2W = parcelRequire("bAk2W");

var $1N69U = parcelRequire("1N69U");
function $be686cd2cecc0588$export$2e2bcd8739ae039(match) {
    if (typeof match !== "function") match = (0, $bAk2W.default)(match);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
    }
    return new (0, $1N69U.Transition)(subgroups, this._parents, this._name, this._id);
}

});

parcelRegister("2nyaJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1bb83c9f1af571cc$export$2e2bcd8739ae039; });

var $1N69U = parcelRequire("1N69U");
function $1bb83c9f1af571cc$export$2e2bcd8739ae039(transition) {
    if (transition._id !== this._id) throw new Error;
    for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
        for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
    }
    for(; j < m0; ++j)merges[j] = groups0[j];
    return new (0, $1N69U.Transition)(merges, this._parents, this._name, this._id);
}

});

parcelRegister("iv5PN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d77fa5d364eafd73$export$2e2bcd8739ae039; });

var $lEnJf = parcelRequire("lEnJf");
function $d77fa5d364eafd73$var$start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function $d77fa5d364eafd73$var$onFunction(id, name, listener) {
    var on0, on1, sit = $d77fa5d364eafd73$var$start(name) ? (0, $lEnJf.init) : (0, $lEnJf.set);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}
function $d77fa5d364eafd73$export$2e2bcd8739ae039(name, listener) {
    var id = this._id;
    return arguments.length < 2 ? (0, $lEnJf.get)(this.node(), id).on.on(name) : this.each($d77fa5d364eafd73$var$onFunction(id, name, listener));
}

});

parcelRegister("7GAgM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5988970f2097e7f9$export$2e2bcd8739ae039; });
function $5988970f2097e7f9$var$removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}
function $5988970f2097e7f9$export$2e2bcd8739ae039() {
    return this.on("end.remove", $5988970f2097e7f9$var$removeFunction(this._id));
}

});

parcelRegister("95byG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69cd8bf6dd05d5ff$export$2e2bcd8739ae039; });

var $2DouR = parcelRequire("2DouR");

var $1N69U = parcelRequire("1N69U");

var $lEnJf = parcelRequire("lEnJf");
function $69cd8bf6dd05d5ff$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $2DouR.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            subgroup[i] = subnode;
            (0, $lEnJf.default)(subgroup[i], name, id, i, subgroup, (0, $lEnJf.get)(node, id));
        }
    }
    return new (0, $1N69U.Transition)(subgroups, this._parents, name, id);
}

});

parcelRegister("ewM9T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9396928e998b928$export$2e2bcd8739ae039; });

var $4daKR = parcelRequire("4daKR");

var $1N69U = parcelRequire("1N69U");

var $lEnJf = parcelRequire("lEnJf");
function $a9396928e998b928$export$2e2bcd8739ae039(select) {
    var name = this._name, id = this._id;
    if (typeof select !== "function") select = (0, $4daKR.default)(select);
    for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, $lEnJf.get)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, $lEnJf.default)(child, name, id, k, children, inherit);
            subgroups.push(children);
            parents.push(node);
        }
    }
    return new (0, $1N69U.Transition)(subgroups, parents, name, id);
}

});

parcelRegister("e76Vs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4671771b3473325$export$2e2bcd8739ae039; });

var $gbmQo = parcelRequire("gbmQo");
var $a4671771b3473325$var$Selection = (0, $gbmQo.default).prototype.constructor;
function $a4671771b3473325$export$2e2bcd8739ae039() {
    return new $a4671771b3473325$var$Selection(this._groups, this._parents);
}

});

parcelRegister("3hjja", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2631efce62a363fc$export$2e2bcd8739ae039; });

var $82fpR = parcelRequire("82fpR");

var $kwD7i = parcelRequire("kwD7i");

var $lEnJf = parcelRequire("lEnJf");

var $4BnEM = parcelRequire("4BnEM");

var $6oE6l = parcelRequire("6oE6l");
function $2631efce62a363fc$var$styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $kwD7i.styleValue)(this, name), string1 = (this.style.removeProperty(name), (0, $kwD7i.styleValue)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function $2631efce62a363fc$var$styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function $2631efce62a363fc$var$styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, $kwD7i.styleValue)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function $2631efce62a363fc$var$styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, $kwD7i.styleValue)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, $kwD7i.styleValue)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function $2631efce62a363fc$var$styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, $lEnJf.set)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = $2631efce62a363fc$var$styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}
function $2631efce62a363fc$export$2e2bcd8739ae039(name, value, priority) {
    var i = (name += "") === "transform" ? (0, $82fpR.interpolateTransformCss) : (0, $6oE6l.default);
    return value == null ? this.styleTween(name, $2631efce62a363fc$var$styleNull(name, i)).on("end.style." + name, $2631efce62a363fc$var$styleRemove(name)) : typeof value === "function" ? this.styleTween(name, $2631efce62a363fc$var$styleFunction(name, i, (0, $4BnEM.tweenValue)(this, "style." + name, value))).each($2631efce62a363fc$var$styleMaybeRemove(this._id, name)) : this.styleTween(name, $2631efce62a363fc$var$styleConstant(name, i, value), priority).on("end.style." + name, null);
}

});

parcelRegister("kIpdD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f14b7aa7e41253e7$export$2e2bcd8739ae039; });
function $f14b7aa7e41253e7$var$styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function $f14b7aa7e41253e7$var$styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && $f14b7aa7e41253e7$var$styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}
function $f14b7aa7e41253e7$export$2e2bcd8739ae039(name, value, priority) {
    var key = "style." + (name += "");
    if (arguments.length < 2) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $f14b7aa7e41253e7$var$styleTween(name, value, priority == null ? "" : priority));
}

});

parcelRegister("4Twz1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39058efea86132a6$export$2e2bcd8739ae039; });

var $4BnEM = parcelRequire("4BnEM");
function $39058efea86132a6$var$textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function $39058efea86132a6$var$textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}
function $39058efea86132a6$export$2e2bcd8739ae039(value) {
    return this.tween("text", typeof value === "function" ? $39058efea86132a6$var$textFunction((0, $4BnEM.tweenValue)(this, "text", value)) : $39058efea86132a6$var$textConstant(value == null ? "" : value + ""));
}

});

parcelRegister("cRFSB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95daebb824acd367$export$2e2bcd8739ae039; });
function $95daebb824acd367$var$textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function $95daebb824acd367$var$textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && $95daebb824acd367$var$textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function $95daebb824acd367$export$2e2bcd8739ae039(value) {
    var key = "text";
    if (arguments.length < 1) return (key = this.tween(key)) && key._value;
    if (value == null) return this.tween(key, null);
    if (typeof value !== "function") throw new Error;
    return this.tween(key, $95daebb824acd367$var$textTween(value));
}

});

parcelRegister("3Ydjj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e414ce2a06ced51$export$2e2bcd8739ae039; });

var $1N69U = parcelRequire("1N69U");

var $lEnJf = parcelRequire("lEnJf");
function $2e414ce2a06ced51$export$2e2bcd8739ae039() {
    var name = this._name, id0 = this._id, id1 = (0, $1N69U.newId)();
    for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
        for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
            var inherit = (0, $lEnJf.get)(node, id0);
            (0, $lEnJf.default)(node, name, id1, i, group, {
                time: inherit.time + inherit.delay + inherit.duration,
                delay: 0,
                duration: inherit.duration,
                ease: inherit.ease
            });
        }
    }
    return new (0, $1N69U.Transition)(groups, this._parents, name, id1);
}

});

parcelRegister("7Pf2m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b28f5e1a11680b4$export$2e2bcd8739ae039; });

var $lEnJf = parcelRequire("lEnJf");
function $5b28f5e1a11680b4$export$2e2bcd8739ae039() {
    var on0, on1, that = this, id = that._id, size = that.size();
    return new Promise(function(resolve, reject) {
        var cancel = {
            value: reject
        }, end = {
            value: function() {
                if (--size === 0) resolve();
            }
        };
        that.each(function() {
            var schedule = (0, $lEnJf.set)(this, id), on = schedule.on;
            // If this node shared a dispatch with the previous node,
            // just assign the updated shared dispatch and we’re done!
            // Otherwise, copy-on-write.
            if (on !== on0) {
                on1 = (on0 = on).copy();
                on1._.cancel.push(cancel);
                on1._.interrupt.push(cancel);
                on1._.end.push(end);
            }
            schedule.on = on1;
        });
        // The selection was empty, resolve end immediately
        if (size === 0) resolve();
    });
}

});


parcelRegister("kAS3Z", function(module, exports) {

$parcel$export(module.exports, "cubicInOut", function () { return $efe11b4a99525144$export$89238d3bc79d3ada; });
function $efe11b4a99525144$export$b1a09cb1b71f86aa(t) {
    return t * t * t;
}
function $efe11b4a99525144$export$68d528839c701b6(t) {
    return --t * t * t + 1;
}
function $efe11b4a99525144$export$89238d3bc79d3ada(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

});




parcelRegister("j0HRg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd7009b371e16639$export$2e2bcd8739ae039; });
var $dd7009b371e16639$export$2e2bcd8739ae039 = (x)=>()=>x;

});

parcelRegister("b4pix", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80f3b111fea1b7dc$export$2e2bcd8739ae039; });
function $80f3b111fea1b7dc$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, selection: selection, mode: mode, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        selection: {
            value: selection,
            enumerable: true,
            configurable: true
        },
        mode: {
            value: mode,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}

});

parcelRegister("3nxni", function(module, exports) {

$parcel$export(module.exports, "nopropagation", function () { return $275d689a9db3af69$export$2e2561858db9bf47; });
$parcel$export(module.exports, "default", function () { return $275d689a9db3af69$export$2e2bcd8739ae039; });
function $275d689a9db3af69$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $275d689a9db3af69$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}

});



parcelRegister("4UuJL", function(module, exports) {

$parcel$export(module.exports, "format", function () { return $39343c207f9c6ea5$export$d9468344d3651243; });
$parcel$export(module.exports, "formatPrefix", function () { return $39343c207f9c6ea5$export$8d85692a469dde6f; });

var $2IbEc = parcelRequire("2IbEc");
var $39343c207f9c6ea5$var$locale;
var $39343c207f9c6ea5$export$d9468344d3651243;
var $39343c207f9c6ea5$export$8d85692a469dde6f;
$39343c207f9c6ea5$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $39343c207f9c6ea5$export$2e2bcd8739ae039(definition) {
    $39343c207f9c6ea5$var$locale = (0, $2IbEc.default)(definition);
    $39343c207f9c6ea5$export$d9468344d3651243 = $39343c207f9c6ea5$var$locale.format;
    $39343c207f9c6ea5$export$8d85692a469dde6f = $39343c207f9c6ea5$var$locale.formatPrefix;
    return $39343c207f9c6ea5$var$locale;
}

});
parcelRegister("2IbEc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f98b9bbe02f3600$export$2e2bcd8739ae039; });

var $eJmO0 = parcelRequire("eJmO0");

var $e3BNo = parcelRequire("e3BNo");

var $b4kxT = parcelRequire("b4kxT");

var $k9Xea = parcelRequire("k9Xea");

var $294DB = parcelRequire("294DB");

var $aofhA = parcelRequire("aofhA");

var $l6c7D = parcelRequire("l6c7D");

var $e6LSR = parcelRequire("e6LSR");
var $1f98b9bbe02f3600$var$map = Array.prototype.map, $1f98b9bbe02f3600$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $1f98b9bbe02f3600$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $e6LSR.default) : (0, $e3BNo.default)($1f98b9bbe02f3600$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $e6LSR.default) : (0, $b4kxT.default)($1f98b9bbe02f3600$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $k9Xea.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $aofhA.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $aofhA.default)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $294DB.default)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $1f98b9bbe02f3600$var$prefixes[8 + (0, $l6c7D.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $k9Xea.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $eJmO0.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $1f98b9bbe02f3600$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("eJmO0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab96f55abfea0a64$export$2e2bcd8739ae039; });

var $28LVg = parcelRequire("28LVg");
function $ab96f55abfea0a64$export$2e2bcd8739ae039(x) {
    return x = (0, $28LVg.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("28LVg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18f1808d42fef9dd$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "formatDecimalParts", function () { return $18f1808d42fef9dd$export$8f8e23dd27dc19f5; });
function $18f1808d42fef9dd$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $18f1808d42fef9dd$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("e3BNo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3bea9ed5a12b1fb$export$2e2bcd8739ae039; });
function $a3bea9ed5a12b1fb$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("b4kxT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80f00161836b15cd$export$2e2bcd8739ae039; });
function $80f00161836b15cd$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("k9Xea", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ead2973d9abdcfb5$export$2e2bcd8739ae039; });
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $ead2973d9abdcfb5$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $ead2973d9abdcfb5$export$2e2bcd8739ae039(specifier) {
    if (!(match = $ead2973d9abdcfb5$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $ead2973d9abdcfb5$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$ead2973d9abdcfb5$export$2e2bcd8739ae039.prototype = $ead2973d9abdcfb5$export$963aac351db36ed4.prototype; // instanceof
function $ead2973d9abdcfb5$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$ead2973d9abdcfb5$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("294DB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $190005005de22f7f$export$2e2bcd8739ae039; });
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $190005005de22f7f$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("aofhA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01f3bdefd08ac02b$export$2e2bcd8739ae039; });

var $28LVg = parcelRequire("28LVg");

var $l6c7D = parcelRequire("l6c7D");

var $5ATkj = parcelRequire("5ATkj");
var $01f3bdefd08ac02b$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $28LVg.default),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $5ATkj.default)(x * 100, p),
    "r": (0, $5ATkj.default),
    "s": (0, $l6c7D.default),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};

});
parcelRegister("l6c7D", function(module, exports) {

$parcel$export(module.exports, "prefixExponent", function () { return $f5c38fb43bb97dce$export$6863724d9a42263; });
$parcel$export(module.exports, "default", function () { return $f5c38fb43bb97dce$export$2e2bcd8739ae039; });

var $28LVg = parcelRequire("28LVg");
var $f5c38fb43bb97dce$export$6863724d9a42263;
function $f5c38fb43bb97dce$export$2e2bcd8739ae039(x, p) {
    var d = (0, $28LVg.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($f5c38fb43bb97dce$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $28LVg.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("5ATkj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $412b3b45ebbcb199$export$2e2bcd8739ae039; });

var $28LVg = parcelRequire("28LVg");
function $412b3b45ebbcb199$export$2e2bcd8739ae039(x, p) {
    var d = (0, $28LVg.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("e6LSR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a456c4faf63f1fe4$export$2e2bcd8739ae039; });
function $a456c4faf63f1fe4$export$2e2bcd8739ae039(x) {
    return x;
}

});



parcelRegister("kWKG2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3fd6e7e3b074f9f$export$2e2bcd8739ae039; });

var $1CQ7S = parcelRequire("1CQ7S");

var $9TBtm = parcelRequire("9TBtm");

var $hRqXm = parcelRequire("hRqXm");
function $f3fd6e7e3b074f9f$export$2e2bcd8739ae039() {
    var scale = (0, $hRqXm.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $1CQ7S.default)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $f3fd6e7e3b074f9f$export$2e2bcd8739ae039(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $9TBtm.initRange).apply(rescale(), arguments);
}
function $f3fd6e7e3b074f9f$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $f3fd6e7e3b074f9f$var$pointish(copy());
    };
    return scale;
}
function $f3fd6e7e3b074f9f$export$105684a3041cb6f3() {
    return $f3fd6e7e3b074f9f$var$pointish($f3fd6e7e3b074f9f$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("9TBtm", function(module, exports) {

$parcel$export(module.exports, "initRange", function () { return $7346515f684a94a9$export$23c7bb9e6558da2a; });
function $7346515f684a94a9$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $7346515f684a94a9$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("hRqXm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d00c4be5c9651cc7$export$2e2bcd8739ae039; });

var $8fbaS = parcelRequire("8fbaS");

var $9TBtm = parcelRequire("9TBtm");
const $d00c4be5c9651cc7$export$e4f898ab14d9d460 = Symbol("implicit");
function $d00c4be5c9651cc7$export$2e2bcd8739ae039() {
    var index = new (0, $8fbaS.InternMap)(), domain = [], range = [], unknown = $d00c4be5c9651cc7$export$e4f898ab14d9d460;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $d00c4be5c9651cc7$export$e4f898ab14d9d460) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, $8fbaS.InternMap)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $d00c4be5c9651cc7$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $9TBtm.initRange).apply(scale, arguments);
    return scale;
}

});
parcelRegister("8fbaS", function(module, exports) {

$parcel$export(module.exports, "InternMap", function () { return $6008646e5bf54b11$export$dcc6fb7d82b5bc7b; });
class $6008646e5bf54b11$export$dcc6fb7d82b5bc7b extends Map {
    constructor(entries, key = $6008646e5bf54b11$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($6008646e5bf54b11$var$intern_get(this, key));
    }
    has(key) {
        return super.has($6008646e5bf54b11$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($6008646e5bf54b11$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($6008646e5bf54b11$var$intern_delete(this, key));
    }
}
class $6008646e5bf54b11$export$55278c3294239828 extends Set {
    constructor(values, key = $6008646e5bf54b11$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($6008646e5bf54b11$var$intern_get(this, value));
    }
    add(value) {
        return super.add($6008646e5bf54b11$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($6008646e5bf54b11$var$intern_delete(this, value));
    }
}
function $6008646e5bf54b11$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $6008646e5bf54b11$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $6008646e5bf54b11$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $6008646e5bf54b11$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});



parcelRegister("3FIbj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ac778f4116124b8$export$2e2bcd8739ae039; });

var $3JKlU = parcelRequire("3JKlU");

var $iJXki = parcelRequire("iJXki");

var $9TBtm = parcelRequire("9TBtm");

var $iXC1w = parcelRequire("iXC1w");
function $2ac778f4116124b8$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $3JKlU.default)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $iXC1w.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $3JKlU.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $2ac778f4116124b8$export$2e2bcd8739ae039() {
    var scale = (0, $iJXki.default)();
    scale.copy = function() {
        return (0, $iJXki.copy)(scale, $2ac778f4116124b8$export$2e2bcd8739ae039());
    };
    (0, $9TBtm.initRange).apply(scale, arguments);
    return $2ac778f4116124b8$export$16a5d4b4a61a274d(scale);
}

});
parcelRegister("3JKlU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b8987b3d47876e2$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "tickIncrement", function () { return $2b8987b3d47876e2$export$bc64d00cc98e7e95; });
$parcel$export(module.exports, "tickStep", function () { return $2b8987b3d47876e2$export$81087d9b915d4ede; });
const $2b8987b3d47876e2$var$e10 = Math.sqrt(50), $2b8987b3d47876e2$var$e5 = Math.sqrt(10), $2b8987b3d47876e2$var$e2 = Math.sqrt(2);
function $2b8987b3d47876e2$var$tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= $2b8987b3d47876e2$var$e10 ? 10 : error >= $2b8987b3d47876e2$var$e5 ? 5 : error >= $2b8987b3d47876e2$var$e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return $2b8987b3d47876e2$var$tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function $2b8987b3d47876e2$export$2e2bcd8739ae039(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? $2b8987b3d47876e2$var$tickSpec(stop, start, count) : $2b8987b3d47876e2$var$tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function $2b8987b3d47876e2$export$bc64d00cc98e7e95(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return $2b8987b3d47876e2$var$tickSpec(start, stop, count)[2];
}
function $2b8987b3d47876e2$export$81087d9b915d4ede(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? $2b8987b3d47876e2$export$bc64d00cc98e7e95(stop, start, count) : $2b8987b3d47876e2$export$bc64d00cc98e7e95(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}

});

parcelRegister("iJXki", function(module, exports) {

$parcel$export(module.exports, "copy", function () { return $da4a72ed93cf3ad2$export$784d13d8ee351f07; });
$parcel$export(module.exports, "default", function () { return $da4a72ed93cf3ad2$export$2e2bcd8739ae039; });

var $9gO50 = parcelRequire("9gO50");

var $2oxjG = parcelRequire("2oxjG");
var $7MusT = parcelRequire("7MusT");
var $2IZCf = parcelRequire("2IZCf");

var $ehLhl = parcelRequire("ehLhl");

var $g6k4c = parcelRequire("g6k4c");
var $da4a72ed93cf3ad2$var$unit = [
    0,
    1
];
function $da4a72ed93cf3ad2$export$f0954fd7d5368655(x) {
    return x;
}
function $da4a72ed93cf3ad2$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $ehLhl.default)(isNaN(b) ? NaN : 0.5);
}
function $da4a72ed93cf3ad2$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $da4a72ed93cf3ad2$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $da4a72ed93cf3ad2$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $da4a72ed93cf3ad2$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $da4a72ed93cf3ad2$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $da4a72ed93cf3ad2$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $9gO50.default)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $da4a72ed93cf3ad2$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $da4a72ed93cf3ad2$export$6b468dcfb64c653c() {
    var domain = $da4a72ed93cf3ad2$var$unit, range = $da4a72ed93cf3ad2$var$unit, interpolate = (0, $2oxjG.default), transform, untransform, unknown, clamp = $da4a72ed93cf3ad2$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $da4a72ed93cf3ad2$export$f0954fd7d5368655) clamp = $da4a72ed93cf3ad2$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $da4a72ed93cf3ad2$var$polymap : $da4a72ed93cf3ad2$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $7MusT.default))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $g6k4c.default)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $2IZCf.default), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $da4a72ed93cf3ad2$export$f0954fd7d5368655, rescale()) : clamp !== $da4a72ed93cf3ad2$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $da4a72ed93cf3ad2$export$2e2bcd8739ae039() {
    return $da4a72ed93cf3ad2$export$6b468dcfb64c653c()($da4a72ed93cf3ad2$export$f0954fd7d5368655, $da4a72ed93cf3ad2$export$f0954fd7d5368655);
}

});
parcelRegister("9gO50", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6bfc747a7770e81d$export$2e2bcd8739ae039; });

var $fbDu8 = parcelRequire("fbDu8");

var $dzY68 = parcelRequire("dzY68");

var $dWKBU = parcelRequire("dWKBU");
const $6bfc747a7770e81d$var$ascendingBisect = (0, $dzY68.default)((0, $fbDu8.default));
const $6bfc747a7770e81d$export$4d945ad3ad5751b0 = $6bfc747a7770e81d$var$ascendingBisect.right;
const $6bfc747a7770e81d$export$df7d25c84ebd12a5 = $6bfc747a7770e81d$var$ascendingBisect.left;
const $6bfc747a7770e81d$export$c1cb828b1117c77b = (0, $dzY68.default)((0, $dWKBU.default)).center;
var $6bfc747a7770e81d$export$2e2bcd8739ae039 = $6bfc747a7770e81d$export$4d945ad3ad5751b0;

});
parcelRegister("fbDu8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0e68301a7642637$export$2e2bcd8739ae039; });
function $b0e68301a7642637$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("dzY68", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e2d297051f2e799$export$2e2bcd8739ae039; });

var $fbDu8 = parcelRequire("fbDu8");

var $iUw3G = parcelRequire("iUw3G");
function $9e2d297051f2e799$export$2e2bcd8739ae039(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, $fbDu8.default);
        compare2 = (d, x)=>(0, $fbDu8.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, $fbDu8.default) || f === (0, $iUw3G.default) ? f : $9e2d297051f2e799$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $9e2d297051f2e799$var$zero() {
    return 0;
}

});
parcelRegister("iUw3G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc4653175854364f$export$2e2bcd8739ae039; });
function $dc4653175854364f$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("dWKBU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a274d900d5b75454$export$2e2bcd8739ae039; });
function $a274d900d5b75454$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $a274d900d5b75454$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("2IZCf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fbf7c79ec5d0a27$export$2e2bcd8739ae039; });
function $1fbf7c79ec5d0a27$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("ehLhl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a66753cff0e49946$export$2e2bcd8739ae039; });
function $a66753cff0e49946$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("g6k4c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb8cc5b29e5284aa$export$2e2bcd8739ae039; });
function $bb8cc5b29e5284aa$export$2e2bcd8739ae039(x) {
    return +x;
}

});


parcelRegister("iXC1w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcdb3b5d2596ee34$export$2e2bcd8739ae039; });

var $3JKlU = parcelRequire("3JKlU");

var $4UuJL = parcelRequire("4UuJL");
var $k9Xea = parcelRequire("k9Xea");
var $iAeos = parcelRequire("iAeos");
var $jsjzh = parcelRequire("jsjzh");
var $19qK0 = parcelRequire("19qK0");
function $dcdb3b5d2596ee34$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $3JKlU.tickStep)(start, stop, count), precision;
    specifier = (0, $k9Xea.default)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $jsjzh.default)(step, value))) specifier.precision = precision;
            return (0, $4UuJL.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $19qK0.default)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $iAeos.default)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $4UuJL.format)(specifier);
}

});
parcelRegister("iAeos", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d876c10d57a8e7b6$export$2e2bcd8739ae039; });

var $eJmO0 = parcelRequire("eJmO0");
function $d876c10d57a8e7b6$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $eJmO0.default)(Math.abs(step)));
}

});

parcelRegister("jsjzh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e29fcfa482ec09a3$export$2e2bcd8739ae039; });

var $eJmO0 = parcelRequire("eJmO0");
function $e29fcfa482ec09a3$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $eJmO0.default)(value) / 3))) * 3 - (0, $eJmO0.default)(Math.abs(step)));
}

});

parcelRegister("19qK0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d6b5ff0b3b2d61e$export$2e2bcd8739ae039; });

var $eJmO0 = parcelRequire("eJmO0");
function $0d6b5ff0b3b2d61e$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $eJmO0.default)(max) - (0, $eJmO0.default)(step)) + 1;
}

});



parcelRegister("ikHyM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d58be2584f14158a$export$2e2bcd8739ae039; });

var $3v896 = parcelRequire("3v896");
var $lasmO = parcelRequire("lasmO");
var $kn8PX = parcelRequire("kn8PX");
var $cYPu0 = parcelRequire("cYPu0");
var $j9ELx = parcelRequire("j9ELx");
var $3ZxcH = parcelRequire("3ZxcH");
var $lhtzE = parcelRequire("lhtzE");
var $jJTTX = parcelRequire("jJTTX");

var $6zofg = parcelRequire("6zofg");

var $iJXki = parcelRequire("iJXki");

var $9TBtm = parcelRequire("9TBtm");

var $D3ZWw = parcelRequire("D3ZWw");
function $d58be2584f14158a$var$date(t) {
    return new Date(t);
}
function $d58be2584f14158a$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $d58be2584f14158a$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $iJXki.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $d58be2584f14158a$var$number)) : domain().map($d58be2584f14158a$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $D3ZWw.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $iJXki.copy)(scale, $d58be2584f14158a$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $d58be2584f14158a$export$2e2bcd8739ae039() {
    return (0, $9TBtm.initRange).apply($d58be2584f14158a$export$56bbcdb8aca31149((0, $3ZxcH.timeTicks), (0, $3ZxcH.timeTickInterval), (0, $jJTTX.timeYear), (0, $cYPu0.timeMonth), (0, $lhtzE.timeSunday), (0, $3v896.timeDay), (0, $lasmO.timeHour), (0, $kn8PX.timeMinute), (0, $j9ELx.second), (0, $6zofg.timeFormat)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("3v896", function(module, exports) {

$parcel$export(module.exports, "timeDay", function () { return $28ca95edf7af2e1d$export$8888529b966033e5; });
$parcel$export(module.exports, "utcDay", function () { return $28ca95edf7af2e1d$export$c8cbc42cefd47140; });
$parcel$export(module.exports, "unixDay", function () { return $28ca95edf7af2e1d$export$fb065be2d7ea4a71; });

var $cxpk3 = parcelRequire("cxpk3");

var $dYP3l = parcelRequire("dYP3l");
const $28ca95edf7af2e1d$export$8888529b966033e5 = (0, $cxpk3.timeInterval)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $dYP3l.durationMinute)) / (0, $dYP3l.durationDay), (date)=>date.getDate() - 1);
const $28ca95edf7af2e1d$export$6657a54f3034cf45 = $28ca95edf7af2e1d$export$8888529b966033e5.range;
const $28ca95edf7af2e1d$export$c8cbc42cefd47140 = (0, $cxpk3.timeInterval)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $dYP3l.durationDay);
}, (date)=>{
    return date.getUTCDate() - 1;
});
const $28ca95edf7af2e1d$export$d277e198508549a1 = $28ca95edf7af2e1d$export$c8cbc42cefd47140.range;
const $28ca95edf7af2e1d$export$fb065be2d7ea4a71 = (0, $cxpk3.timeInterval)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $dYP3l.durationDay);
}, (date)=>{
    return Math.floor(date / (0, $dYP3l.durationDay));
});
const $28ca95edf7af2e1d$export$a491caaf5e9481aa = $28ca95edf7af2e1d$export$fb065be2d7ea4a71.range;

});
parcelRegister("cxpk3", function(module, exports) {

$parcel$export(module.exports, "timeInterval", function () { return $920c3598f046cfb7$export$1a539c8b2950ab40; });
const $920c3598f046cfb7$var$t0 = new Date, $920c3598f046cfb7$var$t1 = new Date;
function $920c3598f046cfb7$export$1a539c8b2950ab40(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = (date)=>{
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = (date)=>{
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = (date)=>{
        const d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = (date, step)=>{
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = (start, stop, step)=>{
        const range = [];
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        let previous;
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = (test)=>{
        return $920c3598f046cfb7$export$1a539c8b2950ab40((date)=>{
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, (date, step)=>{
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = (start, end)=>{
            $920c3598f046cfb7$var$t0.setTime(+start), $920c3598f046cfb7$var$t1.setTime(+end);
            floori($920c3598f046cfb7$var$t0), floori($920c3598f046cfb7$var$t1);
            return Math.floor(count($920c3598f046cfb7$var$t0, $920c3598f046cfb7$var$t1));
        };
        interval.every = (step)=>{
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
        };
    }
    return interval;
}

});

parcelRegister("dYP3l", function(module, exports) {

$parcel$export(module.exports, "durationSecond", function () { return $a2d87b0419a0b63f$export$79ef0e34099623dc; });
$parcel$export(module.exports, "durationMinute", function () { return $a2d87b0419a0b63f$export$683905d551c33fa9; });
$parcel$export(module.exports, "durationHour", function () { return $a2d87b0419a0b63f$export$4157bf0c8e241659; });
$parcel$export(module.exports, "durationDay", function () { return $a2d87b0419a0b63f$export$353686095f4fbf45; });
$parcel$export(module.exports, "durationWeek", function () { return $a2d87b0419a0b63f$export$c241eb88520d5016; });
$parcel$export(module.exports, "durationMonth", function () { return $a2d87b0419a0b63f$export$ab95684df7020b26; });
$parcel$export(module.exports, "durationYear", function () { return $a2d87b0419a0b63f$export$61f8ee2d834c6959; });
const $a2d87b0419a0b63f$export$79ef0e34099623dc = 1000;
const $a2d87b0419a0b63f$export$683905d551c33fa9 = $a2d87b0419a0b63f$export$79ef0e34099623dc * 60;
const $a2d87b0419a0b63f$export$4157bf0c8e241659 = $a2d87b0419a0b63f$export$683905d551c33fa9 * 60;
const $a2d87b0419a0b63f$export$353686095f4fbf45 = $a2d87b0419a0b63f$export$4157bf0c8e241659 * 24;
const $a2d87b0419a0b63f$export$c241eb88520d5016 = $a2d87b0419a0b63f$export$353686095f4fbf45 * 7;
const $a2d87b0419a0b63f$export$ab95684df7020b26 = $a2d87b0419a0b63f$export$353686095f4fbf45 * 30;
const $a2d87b0419a0b63f$export$61f8ee2d834c6959 = $a2d87b0419a0b63f$export$353686095f4fbf45 * 365;

});


parcelRegister("lasmO", function(module, exports) {

$parcel$export(module.exports, "timeHour", function () { return $f690893db40eef63$export$46c68a5833bc315b; });
$parcel$export(module.exports, "utcHour", function () { return $f690893db40eef63$export$31f6f2b3c63ac75e; });

var $cxpk3 = parcelRequire("cxpk3");

var $dYP3l = parcelRequire("dYP3l");
const $f690893db40eef63$export$46c68a5833bc315b = (0, $cxpk3.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $dYP3l.durationSecond) - date.getMinutes() * (0, $dYP3l.durationMinute));
}, (date, step)=>{
    date.setTime(+date + step * (0, $dYP3l.durationHour));
}, (start, end)=>{
    return (end - start) / (0, $dYP3l.durationHour);
}, (date)=>{
    return date.getHours();
});
const $f690893db40eef63$export$fb843f9087cd5235 = $f690893db40eef63$export$46c68a5833bc315b.range;
const $f690893db40eef63$export$31f6f2b3c63ac75e = (0, $cxpk3.timeInterval)((date)=>{
    date.setUTCMinutes(0, 0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $dYP3l.durationHour));
}, (start, end)=>{
    return (end - start) / (0, $dYP3l.durationHour);
}, (date)=>{
    return date.getUTCHours();
});
const $f690893db40eef63$export$6e7a76cd5f50b719 = $f690893db40eef63$export$31f6f2b3c63ac75e.range;

});

parcelRegister("kn8PX", function(module, exports) {

$parcel$export(module.exports, "timeMinute", function () { return $ed4ccf76b10e7445$export$a7e4c34a52f0576; });
$parcel$export(module.exports, "utcMinute", function () { return $ed4ccf76b10e7445$export$efe6712d6003761b; });

var $cxpk3 = parcelRequire("cxpk3");

var $dYP3l = parcelRequire("dYP3l");
const $ed4ccf76b10e7445$export$a7e4c34a52f0576 = (0, $cxpk3.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $dYP3l.durationSecond));
}, (date, step)=>{
    date.setTime(+date + step * (0, $dYP3l.durationMinute));
}, (start, end)=>{
    return (end - start) / (0, $dYP3l.durationMinute);
}, (date)=>{
    return date.getMinutes();
});
const $ed4ccf76b10e7445$export$186d65358374c0a2 = $ed4ccf76b10e7445$export$a7e4c34a52f0576.range;
const $ed4ccf76b10e7445$export$efe6712d6003761b = (0, $cxpk3.timeInterval)((date)=>{
    date.setUTCSeconds(0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $dYP3l.durationMinute));
}, (start, end)=>{
    return (end - start) / (0, $dYP3l.durationMinute);
}, (date)=>{
    return date.getUTCMinutes();
});
const $ed4ccf76b10e7445$export$cedd563624e8ee50 = $ed4ccf76b10e7445$export$efe6712d6003761b.range;

});

parcelRegister("cYPu0", function(module, exports) {

$parcel$export(module.exports, "timeMonth", function () { return $973306160256e21b$export$7e1084fb688591c1; });
$parcel$export(module.exports, "timeMonths", function () { return $973306160256e21b$export$3e24aa839cd0f1c4; });
$parcel$export(module.exports, "utcMonth", function () { return $973306160256e21b$export$cd49b3d2bcfe50d5; });

var $cxpk3 = parcelRequire("cxpk3");
const $973306160256e21b$export$7e1084fb688591c1 = (0, $cxpk3.timeInterval)((date)=>{
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setMonth(date.getMonth() + step);
}, (start, end)=>{
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date)=>{
    return date.getMonth();
});
const $973306160256e21b$export$3e24aa839cd0f1c4 = $973306160256e21b$export$7e1084fb688591c1.range;
const $973306160256e21b$export$cd49b3d2bcfe50d5 = (0, $cxpk3.timeInterval)((date)=>{
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCMonth(date.getUTCMonth() + step);
}, (start, end)=>{
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date)=>{
    return date.getUTCMonth();
});
const $973306160256e21b$export$49159f585997498 = $973306160256e21b$export$cd49b3d2bcfe50d5.range;

});

parcelRegister("j9ELx", function(module, exports) {

$parcel$export(module.exports, "second", function () { return $df1e7ac9cc7d5384$export$3d3c77ce7df7d30d; });

var $cxpk3 = parcelRequire("cxpk3");

var $dYP3l = parcelRequire("dYP3l");
const $df1e7ac9cc7d5384$export$3d3c77ce7df7d30d = (0, $cxpk3.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds());
}, (date, step)=>{
    date.setTime(+date + step * (0, $dYP3l.durationSecond));
}, (start, end)=>{
    return (end - start) / (0, $dYP3l.durationSecond);
}, (date)=>{
    return date.getUTCSeconds();
});
const $df1e7ac9cc7d5384$export$4792e48abc550fa1 = $df1e7ac9cc7d5384$export$3d3c77ce7df7d30d.range;

});

parcelRegister("3ZxcH", function(module, exports) {

$parcel$export(module.exports, "timeTicks", function () { return $2e80d335c574554e$export$60c76498552d28a6; });
$parcel$export(module.exports, "timeTickInterval", function () { return $2e80d335c574554e$export$69511150134dd174; });

var $dzY68 = parcelRequire("dzY68");
var $3JKlU = parcelRequire("3JKlU");

var $dYP3l = parcelRequire("dYP3l");

var $6xKfT = parcelRequire("6xKfT");

var $j9ELx = parcelRequire("j9ELx");

var $kn8PX = parcelRequire("kn8PX");

var $lasmO = parcelRequire("lasmO");

var $3v896 = parcelRequire("3v896");

var $lhtzE = parcelRequire("lhtzE");

var $cYPu0 = parcelRequire("cYPu0");

var $jJTTX = parcelRequire("jJTTX");
function $2e80d335c574554e$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, $j9ELx.second),
            1,
            (0, $dYP3l.durationSecond)
        ],
        [
            (0, $j9ELx.second),
            5,
            5 * (0, $dYP3l.durationSecond)
        ],
        [
            (0, $j9ELx.second),
            15,
            15 * (0, $dYP3l.durationSecond)
        ],
        [
            (0, $j9ELx.second),
            30,
            30 * (0, $dYP3l.durationSecond)
        ],
        [
            minute,
            1,
            (0, $dYP3l.durationMinute)
        ],
        [
            minute,
            5,
            5 * (0, $dYP3l.durationMinute)
        ],
        [
            minute,
            15,
            15 * (0, $dYP3l.durationMinute)
        ],
        [
            minute,
            30,
            30 * (0, $dYP3l.durationMinute)
        ],
        [
            hour,
            1,
            (0, $dYP3l.durationHour)
        ],
        [
            hour,
            3,
            3 * (0, $dYP3l.durationHour)
        ],
        [
            hour,
            6,
            6 * (0, $dYP3l.durationHour)
        ],
        [
            hour,
            12,
            12 * (0, $dYP3l.durationHour)
        ],
        [
            day,
            1,
            (0, $dYP3l.durationDay)
        ],
        [
            day,
            2,
            2 * (0, $dYP3l.durationDay)
        ],
        [
            week,
            1,
            (0, $dYP3l.durationWeek)
        ],
        [
            month,
            1,
            (0, $dYP3l.durationMonth)
        ],
        [
            month,
            3,
            3 * (0, $dYP3l.durationMonth)
        ],
        [
            year,
            1,
            (0, $dYP3l.durationYear)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $dzY68.default)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $3JKlU.tickStep)(start / (0, $dYP3l.durationYear), stop / (0, $dYP3l.durationYear), count));
        if (i === 0) return (0, $6xKfT.millisecond).every(Math.max((0, $3JKlU.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$2e80d335c574554e$export$826ba5ae907e9767, $2e80d335c574554e$export$6262d8d056ea44c4] = $2e80d335c574554e$var$ticker((0, $jJTTX.utcYear), (0, $cYPu0.utcMonth), (0, $lhtzE.utcSunday), (0, $3v896.unixDay), (0, $lasmO.utcHour), (0, $kn8PX.utcMinute));
const [$2e80d335c574554e$export$60c76498552d28a6, $2e80d335c574554e$export$69511150134dd174] = $2e80d335c574554e$var$ticker((0, $jJTTX.timeYear), (0, $cYPu0.timeMonth), (0, $lhtzE.timeSunday), (0, $3v896.timeDay), (0, $lasmO.timeHour), (0, $kn8PX.timeMinute));

});
parcelRegister("6xKfT", function(module, exports) {

$parcel$export(module.exports, "millisecond", function () { return $4c39b4844082569e$export$edc5e5cb87280477; });

var $cxpk3 = parcelRequire("cxpk3");
const $4c39b4844082569e$export$edc5e5cb87280477 = (0, $cxpk3.timeInterval)(()=>{
// noop
}, (date, step)=>{
    date.setTime(+date + step);
}, (start, end)=>{
    return end - start;
});
// An optimized implementation for this simple case.
$4c39b4844082569e$export$edc5e5cb87280477.every = (k)=>{
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $4c39b4844082569e$export$edc5e5cb87280477;
    return (0, $cxpk3.timeInterval)((date)=>{
        date.setTime(Math.floor(date / k) * k);
    }, (date, step)=>{
        date.setTime(+date + step * k);
    }, (start, end)=>{
        return (end - start) / k;
    });
};
const $4c39b4844082569e$export$9a27fac83d67afd3 = $4c39b4844082569e$export$edc5e5cb87280477.range;

});

parcelRegister("lhtzE", function(module, exports) {

$parcel$export(module.exports, "timeSunday", function () { return $f7e2204cb1a8d4d3$export$22ee6205b762968c; });
$parcel$export(module.exports, "timeMonday", function () { return $f7e2204cb1a8d4d3$export$e79bbe0177cf1b01; });
$parcel$export(module.exports, "timeThursday", function () { return $f7e2204cb1a8d4d3$export$608689422d5cf9f4; });
$parcel$export(module.exports, "utcSunday", function () { return $f7e2204cb1a8d4d3$export$4898b06303a92011; });
$parcel$export(module.exports, "utcMonday", function () { return $f7e2204cb1a8d4d3$export$9cfc53b9cfafd080; });
$parcel$export(module.exports, "utcThursday", function () { return $f7e2204cb1a8d4d3$export$1db08111baec2f53; });

var $cxpk3 = parcelRequire("cxpk3");

var $dYP3l = parcelRequire("dYP3l");
function $f7e2204cb1a8d4d3$var$timeWeekday(i) {
    return (0, $cxpk3.timeInterval)((date)=>{
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setDate(date.getDate() + step * 7);
    }, (start, end)=>{
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $dYP3l.durationMinute)) / (0, $dYP3l.durationWeek);
    });
}
const $f7e2204cb1a8d4d3$export$22ee6205b762968c = $f7e2204cb1a8d4d3$var$timeWeekday(0);
const $f7e2204cb1a8d4d3$export$e79bbe0177cf1b01 = $f7e2204cb1a8d4d3$var$timeWeekday(1);
const $f7e2204cb1a8d4d3$export$57c0658c29f77708 = $f7e2204cb1a8d4d3$var$timeWeekday(2);
const $f7e2204cb1a8d4d3$export$3fbeef226c256e43 = $f7e2204cb1a8d4d3$var$timeWeekday(3);
const $f7e2204cb1a8d4d3$export$608689422d5cf9f4 = $f7e2204cb1a8d4d3$var$timeWeekday(4);
const $f7e2204cb1a8d4d3$export$548e5227aa183dca = $f7e2204cb1a8d4d3$var$timeWeekday(5);
const $f7e2204cb1a8d4d3$export$c56a3ad248908e19 = $f7e2204cb1a8d4d3$var$timeWeekday(6);
const $f7e2204cb1a8d4d3$export$eac514c8a8674eba = $f7e2204cb1a8d4d3$export$22ee6205b762968c.range;
const $f7e2204cb1a8d4d3$export$f7219b1481948356 = $f7e2204cb1a8d4d3$export$e79bbe0177cf1b01.range;
const $f7e2204cb1a8d4d3$export$77e22b12c5bed05b = $f7e2204cb1a8d4d3$export$57c0658c29f77708.range;
const $f7e2204cb1a8d4d3$export$b85d407a471809e8 = $f7e2204cb1a8d4d3$export$3fbeef226c256e43.range;
const $f7e2204cb1a8d4d3$export$c1bc1c49254c8855 = $f7e2204cb1a8d4d3$export$608689422d5cf9f4.range;
const $f7e2204cb1a8d4d3$export$3691a1557fff46f1 = $f7e2204cb1a8d4d3$export$548e5227aa183dca.range;
const $f7e2204cb1a8d4d3$export$b755452d02cba8d2 = $f7e2204cb1a8d4d3$export$c56a3ad248908e19.range;
function $f7e2204cb1a8d4d3$var$utcWeekday(i) {
    return (0, $cxpk3.timeInterval)((date)=>{
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, (start, end)=>{
        return (end - start) / (0, $dYP3l.durationWeek);
    });
}
const $f7e2204cb1a8d4d3$export$4898b06303a92011 = $f7e2204cb1a8d4d3$var$utcWeekday(0);
const $f7e2204cb1a8d4d3$export$9cfc53b9cfafd080 = $f7e2204cb1a8d4d3$var$utcWeekday(1);
const $f7e2204cb1a8d4d3$export$2a6d545f77eceb15 = $f7e2204cb1a8d4d3$var$utcWeekday(2);
const $f7e2204cb1a8d4d3$export$a5c25d8ed64433c4 = $f7e2204cb1a8d4d3$var$utcWeekday(3);
const $f7e2204cb1a8d4d3$export$1db08111baec2f53 = $f7e2204cb1a8d4d3$var$utcWeekday(4);
const $f7e2204cb1a8d4d3$export$29265e34dd5921f7 = $f7e2204cb1a8d4d3$var$utcWeekday(5);
const $f7e2204cb1a8d4d3$export$85b74dad05049604 = $f7e2204cb1a8d4d3$var$utcWeekday(6);
const $f7e2204cb1a8d4d3$export$6f3e1c2b0f7d7880 = $f7e2204cb1a8d4d3$export$4898b06303a92011.range;
const $f7e2204cb1a8d4d3$export$1d2d8b858bb366f9 = $f7e2204cb1a8d4d3$export$9cfc53b9cfafd080.range;
const $f7e2204cb1a8d4d3$export$1d5f6785fc7f30f8 = $f7e2204cb1a8d4d3$export$2a6d545f77eceb15.range;
const $f7e2204cb1a8d4d3$export$7a75faf0e37ef4af = $f7e2204cb1a8d4d3$export$a5c25d8ed64433c4.range;
const $f7e2204cb1a8d4d3$export$417eb959611b2f2f = $f7e2204cb1a8d4d3$export$1db08111baec2f53.range;
const $f7e2204cb1a8d4d3$export$59d308db7af08c64 = $f7e2204cb1a8d4d3$export$29265e34dd5921f7.range;
const $f7e2204cb1a8d4d3$export$a124108a0a7f34c8 = $f7e2204cb1a8d4d3$export$85b74dad05049604.range;

});

parcelRegister("jJTTX", function(module, exports) {

$parcel$export(module.exports, "timeYear", function () { return $e5ed95279d9c801e$export$cd17cfe45df0c046; });
$parcel$export(module.exports, "utcYear", function () { return $e5ed95279d9c801e$export$d5c3802e389714c4; });

var $cxpk3 = parcelRequire("cxpk3");
const $e5ed95279d9c801e$export$cd17cfe45df0c046 = (0, $cxpk3.timeInterval)((date)=>{
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setFullYear(date.getFullYear() + step);
}, (start, end)=>{
    return end.getFullYear() - start.getFullYear();
}, (date)=>{
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$e5ed95279d9c801e$export$cd17cfe45df0c046.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $cxpk3.timeInterval)((date)=>{
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step * k);
    });
};
const $e5ed95279d9c801e$export$69a4e90dd2cc3bd1 = $e5ed95279d9c801e$export$cd17cfe45df0c046.range;
const $e5ed95279d9c801e$export$d5c3802e389714c4 = (0, $cxpk3.timeInterval)((date)=>{
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end)=>{
    return end.getUTCFullYear() - start.getUTCFullYear();
}, (date)=>{
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$e5ed95279d9c801e$export$d5c3802e389714c4.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $cxpk3.timeInterval)((date)=>{
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
const $e5ed95279d9c801e$export$3e24d311e17f5802 = $e5ed95279d9c801e$export$d5c3802e389714c4.range;

});


parcelRegister("6zofg", function(module, exports) {

$parcel$export(module.exports, "timeFormat", function () { return $4c88d18af6c20fb6$export$94f4d87fad5dcf9a; });

var $kwVvQ = parcelRequire("kwVvQ");
var $4c88d18af6c20fb6$var$locale;
var $4c88d18af6c20fb6$export$94f4d87fad5dcf9a;
var $4c88d18af6c20fb6$export$32b9cd16e1b8c8d2;
var $4c88d18af6c20fb6$export$1a08fe38f63ebbbb;
var $4c88d18af6c20fb6$export$3edae9cf8e233729;
$4c88d18af6c20fb6$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $4c88d18af6c20fb6$export$2e2bcd8739ae039(definition) {
    $4c88d18af6c20fb6$var$locale = (0, $kwVvQ.default)(definition);
    $4c88d18af6c20fb6$export$94f4d87fad5dcf9a = $4c88d18af6c20fb6$var$locale.format;
    $4c88d18af6c20fb6$export$32b9cd16e1b8c8d2 = $4c88d18af6c20fb6$var$locale.parse;
    $4c88d18af6c20fb6$export$1a08fe38f63ebbbb = $4c88d18af6c20fb6$var$locale.utcFormat;
    $4c88d18af6c20fb6$export$3edae9cf8e233729 = $4c88d18af6c20fb6$var$locale.utcParse;
    return $4c88d18af6c20fb6$var$locale;
}

});
parcelRegister("kwVvQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef23689746a3a6f5$export$2e2bcd8739ae039; });

var $3v896 = parcelRequire("3v896");
var $lhtzE = parcelRequire("lhtzE");
var $jJTTX = parcelRequire("jJTTX");
function $ef23689746a3a6f5$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $ef23689746a3a6f5$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $ef23689746a3a6f5$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $ef23689746a3a6f5$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $ef23689746a3a6f5$var$formatRe(locale_periods), periodLookup = $ef23689746a3a6f5$var$formatLookup(locale_periods), weekdayRe = $ef23689746a3a6f5$var$formatRe(locale_weekdays), weekdayLookup = $ef23689746a3a6f5$var$formatLookup(locale_weekdays), shortWeekdayRe = $ef23689746a3a6f5$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $ef23689746a3a6f5$var$formatLookup(locale_shortWeekdays), monthRe = $ef23689746a3a6f5$var$formatRe(locale_months), monthLookup = $ef23689746a3a6f5$var$formatLookup(locale_months), shortMonthRe = $ef23689746a3a6f5$var$formatRe(locale_shortMonths), shortMonthLookup = $ef23689746a3a6f5$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $ef23689746a3a6f5$var$formatDayOfMonth,
        "e": $ef23689746a3a6f5$var$formatDayOfMonth,
        "f": $ef23689746a3a6f5$var$formatMicroseconds,
        "g": $ef23689746a3a6f5$var$formatYearISO,
        "G": $ef23689746a3a6f5$var$formatFullYearISO,
        "H": $ef23689746a3a6f5$var$formatHour24,
        "I": $ef23689746a3a6f5$var$formatHour12,
        "j": $ef23689746a3a6f5$var$formatDayOfYear,
        "L": $ef23689746a3a6f5$var$formatMilliseconds,
        "m": $ef23689746a3a6f5$var$formatMonthNumber,
        "M": $ef23689746a3a6f5$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $ef23689746a3a6f5$var$formatUnixTimestamp,
        "s": $ef23689746a3a6f5$var$formatUnixTimestampSeconds,
        "S": $ef23689746a3a6f5$var$formatSeconds,
        "u": $ef23689746a3a6f5$var$formatWeekdayNumberMonday,
        "U": $ef23689746a3a6f5$var$formatWeekNumberSunday,
        "V": $ef23689746a3a6f5$var$formatWeekNumberISO,
        "w": $ef23689746a3a6f5$var$formatWeekdayNumberSunday,
        "W": $ef23689746a3a6f5$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $ef23689746a3a6f5$var$formatYear,
        "Y": $ef23689746a3a6f5$var$formatFullYear,
        "Z": $ef23689746a3a6f5$var$formatZone,
        "%": $ef23689746a3a6f5$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $ef23689746a3a6f5$var$formatUTCDayOfMonth,
        "e": $ef23689746a3a6f5$var$formatUTCDayOfMonth,
        "f": $ef23689746a3a6f5$var$formatUTCMicroseconds,
        "g": $ef23689746a3a6f5$var$formatUTCYearISO,
        "G": $ef23689746a3a6f5$var$formatUTCFullYearISO,
        "H": $ef23689746a3a6f5$var$formatUTCHour24,
        "I": $ef23689746a3a6f5$var$formatUTCHour12,
        "j": $ef23689746a3a6f5$var$formatUTCDayOfYear,
        "L": $ef23689746a3a6f5$var$formatUTCMilliseconds,
        "m": $ef23689746a3a6f5$var$formatUTCMonthNumber,
        "M": $ef23689746a3a6f5$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $ef23689746a3a6f5$var$formatUnixTimestamp,
        "s": $ef23689746a3a6f5$var$formatUnixTimestampSeconds,
        "S": $ef23689746a3a6f5$var$formatUTCSeconds,
        "u": $ef23689746a3a6f5$var$formatUTCWeekdayNumberMonday,
        "U": $ef23689746a3a6f5$var$formatUTCWeekNumberSunday,
        "V": $ef23689746a3a6f5$var$formatUTCWeekNumberISO,
        "w": $ef23689746a3a6f5$var$formatUTCWeekdayNumberSunday,
        "W": $ef23689746a3a6f5$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $ef23689746a3a6f5$var$formatUTCYear,
        "Y": $ef23689746a3a6f5$var$formatUTCFullYear,
        "Z": $ef23689746a3a6f5$var$formatUTCZone,
        "%": $ef23689746a3a6f5$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $ef23689746a3a6f5$var$parseDayOfMonth,
        "e": $ef23689746a3a6f5$var$parseDayOfMonth,
        "f": $ef23689746a3a6f5$var$parseMicroseconds,
        "g": $ef23689746a3a6f5$var$parseYear,
        "G": $ef23689746a3a6f5$var$parseFullYear,
        "H": $ef23689746a3a6f5$var$parseHour24,
        "I": $ef23689746a3a6f5$var$parseHour24,
        "j": $ef23689746a3a6f5$var$parseDayOfYear,
        "L": $ef23689746a3a6f5$var$parseMilliseconds,
        "m": $ef23689746a3a6f5$var$parseMonthNumber,
        "M": $ef23689746a3a6f5$var$parseMinutes,
        "p": parsePeriod,
        "q": $ef23689746a3a6f5$var$parseQuarter,
        "Q": $ef23689746a3a6f5$var$parseUnixTimestamp,
        "s": $ef23689746a3a6f5$var$parseUnixTimestampSeconds,
        "S": $ef23689746a3a6f5$var$parseSeconds,
        "u": $ef23689746a3a6f5$var$parseWeekdayNumberMonday,
        "U": $ef23689746a3a6f5$var$parseWeekNumberSunday,
        "V": $ef23689746a3a6f5$var$parseWeekNumberISO,
        "w": $ef23689746a3a6f5$var$parseWeekdayNumberSunday,
        "W": $ef23689746a3a6f5$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $ef23689746a3a6f5$var$parseYear,
        "Y": $ef23689746a3a6f5$var$parseFullYear,
        "Z": $ef23689746a3a6f5$var$parseZone,
        "%": $ef23689746a3a6f5$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $ef23689746a3a6f5$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $ef23689746a3a6f5$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $ef23689746a3a6f5$var$utcDate($ef23689746a3a6f5$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $lhtzE.utcMonday).ceil(week) : (0, $lhtzE.utcMonday)(week);
                    week = (0, $3v896.utcDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $ef23689746a3a6f5$var$localDate($ef23689746a3a6f5$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $lhtzE.timeMonday).ceil(week) : (0, $lhtzE.timeMonday)(week);
                    week = (0, $3v896.timeDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $ef23689746a3a6f5$var$utcDate($ef23689746a3a6f5$var$newDate(d.y, 0, 1)).getUTCDay() : $ef23689746a3a6f5$var$localDate($ef23689746a3a6f5$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $ef23689746a3a6f5$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $ef23689746a3a6f5$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $ef23689746a3a6f5$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $ef23689746a3a6f5$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $ef23689746a3a6f5$var$numberRe = /^\s*\d+/, $ef23689746a3a6f5$var$percentRe = /^%/, $ef23689746a3a6f5$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $ef23689746a3a6f5$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $ef23689746a3a6f5$var$requote(s) {
    return s.replace($ef23689746a3a6f5$var$requoteRe, "\\$&");
}
function $ef23689746a3a6f5$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($ef23689746a3a6f5$var$requote).join("|") + ")", "i");
}
function $ef23689746a3a6f5$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $ef23689746a3a6f5$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $ef23689746a3a6f5$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $ef23689746a3a6f5$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $ef23689746a3a6f5$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $ef23689746a3a6f5$var$parseWeekNumberSunday(d, string, i) {
    var n = $ef23689746a3a6f5$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $ef23689746a3a6f5$var$parseWeekNumberISO(d, string, i) {
    var n = $ef23689746a3a6f5$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $ef23689746a3a6f5$var$parseWeekNumberMonday(d, string, i) {
    var n = $ef23689746a3a6f5$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $ef23689746a3a6f5$var$parseFullYear(d, string, i) {
    var n = $ef23689746a3a6f5$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $ef23689746a3a6f5$var$parseYear(d, string, i) {
    var n = $ef23689746a3a6f5$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $ef23689746a3a6f5$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $ef23689746a3a6f5$var$parseQuarter(d, string, i) {
    var n = $ef23689746a3a6f5$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $ef23689746a3a6f5$var$parseMonthNumber(d, string, i) {
    var n = $ef23689746a3a6f5$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $ef23689746a3a6f5$var$parseDayOfMonth(d, string, i) {
    var n = $ef23689746a3a6f5$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $ef23689746a3a6f5$var$parseDayOfYear(d, string, i) {
    var n = $ef23689746a3a6f5$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $ef23689746a3a6f5$var$parseHour24(d, string, i) {
    var n = $ef23689746a3a6f5$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $ef23689746a3a6f5$var$parseMinutes(d, string, i) {
    var n = $ef23689746a3a6f5$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $ef23689746a3a6f5$var$parseSeconds(d, string, i) {
    var n = $ef23689746a3a6f5$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $ef23689746a3a6f5$var$parseMilliseconds(d, string, i) {
    var n = $ef23689746a3a6f5$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $ef23689746a3a6f5$var$parseMicroseconds(d, string, i) {
    var n = $ef23689746a3a6f5$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $ef23689746a3a6f5$var$parseLiteralPercent(d, string, i) {
    var n = $ef23689746a3a6f5$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $ef23689746a3a6f5$var$parseUnixTimestamp(d, string, i) {
    var n = $ef23689746a3a6f5$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $ef23689746a3a6f5$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $ef23689746a3a6f5$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $ef23689746a3a6f5$var$formatDayOfMonth(d, p) {
    return $ef23689746a3a6f5$var$pad(d.getDate(), p, 2);
}
function $ef23689746a3a6f5$var$formatHour24(d, p) {
    return $ef23689746a3a6f5$var$pad(d.getHours(), p, 2);
}
function $ef23689746a3a6f5$var$formatHour12(d, p) {
    return $ef23689746a3a6f5$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $ef23689746a3a6f5$var$formatDayOfYear(d, p) {
    return $ef23689746a3a6f5$var$pad(1 + (0, $3v896.timeDay).count((0, $jJTTX.timeYear)(d), d), p, 3);
}
function $ef23689746a3a6f5$var$formatMilliseconds(d, p) {
    return $ef23689746a3a6f5$var$pad(d.getMilliseconds(), p, 3);
}
function $ef23689746a3a6f5$var$formatMicroseconds(d, p) {
    return $ef23689746a3a6f5$var$formatMilliseconds(d, p) + "000";
}
function $ef23689746a3a6f5$var$formatMonthNumber(d, p) {
    return $ef23689746a3a6f5$var$pad(d.getMonth() + 1, p, 2);
}
function $ef23689746a3a6f5$var$formatMinutes(d, p) {
    return $ef23689746a3a6f5$var$pad(d.getMinutes(), p, 2);
}
function $ef23689746a3a6f5$var$formatSeconds(d, p) {
    return $ef23689746a3a6f5$var$pad(d.getSeconds(), p, 2);
}
function $ef23689746a3a6f5$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $ef23689746a3a6f5$var$formatWeekNumberSunday(d, p) {
    return $ef23689746a3a6f5$var$pad((0, $lhtzE.timeSunday).count((0, $jJTTX.timeYear)(d) - 1, d), p, 2);
}
function $ef23689746a3a6f5$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $lhtzE.timeThursday)(d) : (0, $lhtzE.timeThursday).ceil(d);
}
function $ef23689746a3a6f5$var$formatWeekNumberISO(d, p) {
    d = $ef23689746a3a6f5$var$dISO(d);
    return $ef23689746a3a6f5$var$pad((0, $lhtzE.timeThursday).count((0, $jJTTX.timeYear)(d), d) + ((0, $jJTTX.timeYear)(d).getDay() === 4), p, 2);
}
function $ef23689746a3a6f5$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $ef23689746a3a6f5$var$formatWeekNumberMonday(d, p) {
    return $ef23689746a3a6f5$var$pad((0, $lhtzE.timeMonday).count((0, $jJTTX.timeYear)(d) - 1, d), p, 2);
}
function $ef23689746a3a6f5$var$formatYear(d, p) {
    return $ef23689746a3a6f5$var$pad(d.getFullYear() % 100, p, 2);
}
function $ef23689746a3a6f5$var$formatYearISO(d, p) {
    d = $ef23689746a3a6f5$var$dISO(d);
    return $ef23689746a3a6f5$var$pad(d.getFullYear() % 100, p, 2);
}
function $ef23689746a3a6f5$var$formatFullYear(d, p) {
    return $ef23689746a3a6f5$var$pad(d.getFullYear() % 10000, p, 4);
}
function $ef23689746a3a6f5$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $lhtzE.timeThursday)(d) : (0, $lhtzE.timeThursday).ceil(d);
    return $ef23689746a3a6f5$var$pad(d.getFullYear() % 10000, p, 4);
}
function $ef23689746a3a6f5$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $ef23689746a3a6f5$var$pad(z / 60 | 0, "0", 2) + $ef23689746a3a6f5$var$pad(z % 60, "0", 2);
}
function $ef23689746a3a6f5$var$formatUTCDayOfMonth(d, p) {
    return $ef23689746a3a6f5$var$pad(d.getUTCDate(), p, 2);
}
function $ef23689746a3a6f5$var$formatUTCHour24(d, p) {
    return $ef23689746a3a6f5$var$pad(d.getUTCHours(), p, 2);
}
function $ef23689746a3a6f5$var$formatUTCHour12(d, p) {
    return $ef23689746a3a6f5$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $ef23689746a3a6f5$var$formatUTCDayOfYear(d, p) {
    return $ef23689746a3a6f5$var$pad(1 + (0, $3v896.utcDay).count((0, $jJTTX.utcYear)(d), d), p, 3);
}
function $ef23689746a3a6f5$var$formatUTCMilliseconds(d, p) {
    return $ef23689746a3a6f5$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $ef23689746a3a6f5$var$formatUTCMicroseconds(d, p) {
    return $ef23689746a3a6f5$var$formatUTCMilliseconds(d, p) + "000";
}
function $ef23689746a3a6f5$var$formatUTCMonthNumber(d, p) {
    return $ef23689746a3a6f5$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $ef23689746a3a6f5$var$formatUTCMinutes(d, p) {
    return $ef23689746a3a6f5$var$pad(d.getUTCMinutes(), p, 2);
}
function $ef23689746a3a6f5$var$formatUTCSeconds(d, p) {
    return $ef23689746a3a6f5$var$pad(d.getUTCSeconds(), p, 2);
}
function $ef23689746a3a6f5$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $ef23689746a3a6f5$var$formatUTCWeekNumberSunday(d, p) {
    return $ef23689746a3a6f5$var$pad((0, $lhtzE.utcSunday).count((0, $jJTTX.utcYear)(d) - 1, d), p, 2);
}
function $ef23689746a3a6f5$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $lhtzE.utcThursday)(d) : (0, $lhtzE.utcThursday).ceil(d);
}
function $ef23689746a3a6f5$var$formatUTCWeekNumberISO(d, p) {
    d = $ef23689746a3a6f5$var$UTCdISO(d);
    return $ef23689746a3a6f5$var$pad((0, $lhtzE.utcThursday).count((0, $jJTTX.utcYear)(d), d) + ((0, $jJTTX.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $ef23689746a3a6f5$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $ef23689746a3a6f5$var$formatUTCWeekNumberMonday(d, p) {
    return $ef23689746a3a6f5$var$pad((0, $lhtzE.utcMonday).count((0, $jJTTX.utcYear)(d) - 1, d), p, 2);
}
function $ef23689746a3a6f5$var$formatUTCYear(d, p) {
    return $ef23689746a3a6f5$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $ef23689746a3a6f5$var$formatUTCYearISO(d, p) {
    d = $ef23689746a3a6f5$var$UTCdISO(d);
    return $ef23689746a3a6f5$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $ef23689746a3a6f5$var$formatUTCFullYear(d, p) {
    return $ef23689746a3a6f5$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $ef23689746a3a6f5$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $lhtzE.utcThursday)(d) : (0, $lhtzE.utcThursday).ceil(d);
    return $ef23689746a3a6f5$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $ef23689746a3a6f5$var$formatUTCZone() {
    return "+0000";
}
function $ef23689746a3a6f5$var$formatLiteralPercent() {
    return "%";
}
function $ef23689746a3a6f5$var$formatUnixTimestamp(d) {
    return +d;
}
function $ef23689746a3a6f5$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRegister("D3ZWw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0756be9195b07683$export$2e2bcd8739ae039; });
function $0756be9195b07683$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("5xV2T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $409c48e0dc7634c7$export$2e2bcd8739ae039; });

var $cSsWF = parcelRequire("cSsWF");

var $gbmQo = parcelRequire("gbmQo");
function $409c48e0dc7634c7$export$2e2bcd8739ae039(selector) {
    return typeof selector === "string" ? new (0, $gbmQo.Selection)([
        document.querySelectorAll(selector)
    ], [
        document.documentElement
    ]) : new (0, $gbmQo.Selection)([
        (0, $cSsWF.default)(selector)
    ], (0, $gbmQo.root));
}

});

parcelRegister("jDPUx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4c9ed4310fd339e$export$2e2bcd8739ae039; });

var $1JqCX = parcelRequire("1JqCX");

var $44ZCV = parcelRequire("44ZCV");

var $4DNgL = parcelRequire("4DNgL");

var $geBL0 = parcelRequire("geBL0");

var $9jwus = parcelRequire("9jwus");

var $jcw9l = parcelRequire("jcw9l");
function $e4c9ed4310fd339e$export$2e2bcd8739ae039(x0, y0, y1) {
    var x1 = null, defined = (0, $44ZCV.default)(true), context = null, curve = (0, $4DNgL.default), output = null, path = (0, $9jwus.withPath)(area);
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? (0, $jcw9l.x) : (0, $44ZCV.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $44ZCV.default)(0) : (0, $44ZCV.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? (0, $jcw9l.y) : (0, $44ZCV.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $1JqCX.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = path());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $geBL0.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $44ZCV.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $44ZCV.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $44ZCV.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $44ZCV.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $44ZCV.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $44ZCV.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $44ZCV.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("1JqCX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $142ea60bf88fc165$export$2e2bcd8739ae039; });
var $142ea60bf88fc165$export$58adb3bec8346d0f = Array.prototype.slice;
function $142ea60bf88fc165$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("44ZCV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f8756f2b1a00f4e$export$2e2bcd8739ae039; });
function $2f8756f2b1a00f4e$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("4DNgL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $361105cac365cfb3$export$2e2bcd8739ae039; });
function $361105cac365cfb3$var$Linear(context) {
    this._context = context;
}
$361105cac365cfb3$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $361105cac365cfb3$export$2e2bcd8739ae039(context) {
    return new $361105cac365cfb3$var$Linear(context);
}

});

parcelRegister("geBL0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd1b3dec4e611164$export$2e2bcd8739ae039; });

var $1JqCX = parcelRequire("1JqCX");

var $44ZCV = parcelRequire("44ZCV");

var $4DNgL = parcelRequire("4DNgL");

var $9jwus = parcelRequire("9jwus");

var $jcw9l = parcelRequire("jcw9l");
function $bd1b3dec4e611164$export$2e2bcd8739ae039(x, y) {
    var defined = (0, $44ZCV.default)(true), context = null, curve = (0, $4DNgL.default), output = null, path = (0, $9jwus.withPath)(line);
    x = typeof x === "function" ? x : x === undefined ? (0, $jcw9l.x) : (0, $44ZCV.default)(x);
    y = typeof y === "function" ? y : y === undefined ? (0, $jcw9l.y) : (0, $44ZCV.default)(y);
    function line(data) {
        var i, n = (data = (0, $1JqCX.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = path());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $44ZCV.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $44ZCV.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $44ZCV.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("9jwus", function(module, exports) {

$parcel$export(module.exports, "withPath", function () { return $6c7f174fdbd7b09c$export$fb6e83118a5dcd45; });

var $iXKSZ = parcelRequire("iXKSZ");
function $6c7f174fdbd7b09c$export$fb6e83118a5dcd45(shape) {
    let digits = 3;
    shape.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        return shape;
    };
    return ()=>new (0, $iXKSZ.Path)(digits);
}

});
parcelRegister("iXKSZ", function(module, exports) {

$parcel$export(module.exports, "Path", function () { return $dce21b43123cd7a3$export$4b2950bdac9b6ee9; });
const $dce21b43123cd7a3$var$pi = Math.PI, $dce21b43123cd7a3$var$tau = 2 * $dce21b43123cd7a3$var$pi, $dce21b43123cd7a3$var$epsilon = 1e-6, $dce21b43123cd7a3$var$tauEpsilon = $dce21b43123cd7a3$var$tau - $dce21b43123cd7a3$var$epsilon;
function $dce21b43123cd7a3$var$append(strings) {
    this._ += strings[0];
    for(let i = 1, n = strings.length; i < n; ++i)this._ += arguments[i] + strings[i];
}
function $dce21b43123cd7a3$var$appendRound(digits) {
    let d = Math.floor(digits);
    if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
    if (d > 15) return $dce21b43123cd7a3$var$append;
    const k = 10 ** d;
    return function(strings) {
        this._ += strings[0];
        for(let i = 1, n = strings.length; i < n; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
    };
}
class $dce21b43123cd7a3$export$4b2950bdac9b6ee9 {
    constructor(digits){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
        this._append = digits == null ? $dce21b43123cd7a3$var$append : $dce21b43123cd7a3$var$appendRound(digits);
    }
    moveTo(x, y) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._append`Z`;
        }
    }
    lineTo(x, y) {
        this._append`L${this._x1 = +x},${this._y1 = +y}`;
    }
    quadraticCurveTo(x1, y1, x, y) {
        this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
    }
    bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
    }
    arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._append`M${this._x1 = x1},${this._y1 = y1}`;
        else if (!(l01_2 > $dce21b43123cd7a3$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $dce21b43123cd7a3$var$epsilon) || !r) this._append`L${this._x1 = x1},${this._y1 = y1}`;
        else {
            let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($dce21b43123cd7a3$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $dce21b43123cd7a3$var$epsilon) this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
            this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
        }
    }
    arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._append`M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $dce21b43123cd7a3$var$epsilon || Math.abs(this._y1 - y0) > $dce21b43123cd7a3$var$epsilon) this._append`L${x0},${y0}`;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $dce21b43123cd7a3$var$tau + $dce21b43123cd7a3$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $dce21b43123cd7a3$var$tauEpsilon) this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
        else if (da > $dce21b43123cd7a3$var$epsilon) this._append`A${r},${r},0,${+(da >= $dce21b43123cd7a3$var$pi)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
    }
    rect(x, y, w, h) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
    }
    toString() {
        return this._;
    }
}
function $dce21b43123cd7a3$export$bb654e07daaf8c3a() {
    return new $dce21b43123cd7a3$export$4b2950bdac9b6ee9;
}
// Allow instanceof d3.path
$dce21b43123cd7a3$export$bb654e07daaf8c3a.prototype = $dce21b43123cd7a3$export$4b2950bdac9b6ee9.prototype;
function $dce21b43123cd7a3$export$e181c6ece8d9cc5f(digits = 3) {
    return new $dce21b43123cd7a3$export$4b2950bdac9b6ee9(+digits);
}

});


parcelRegister("jcw9l", function(module, exports) {

$parcel$export(module.exports, "x", function () { return $dfa81394fa30b9ab$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "y", function () { return $dfa81394fa30b9ab$export$4a5767248b18ef41; });
function $dfa81394fa30b9ab$export$d141bba7fdc215a3(p) {
    return p[0];
}
function $dfa81394fa30b9ab$export$4a5767248b18ef41(p) {
    return p[1];
}

});



parcelRegister("1evnz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e5f70868da64f87$export$2e2bcd8739ae039; });
function $0e5f70868da64f87$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$0e5f70868da64f87$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $0e5f70868da64f87$export$2e2bcd8739ae039(context) {
    return new $0e5f70868da64f87$var$Step(context, 0.5);
}
function $0e5f70868da64f87$export$10eafa5b7478b343(context) {
    return new $0e5f70868da64f87$var$Step(context, 0);
}
function $0e5f70868da64f87$export$793b3db073781cbb(context) {
    return new $0e5f70868da64f87$var$Step(context, 1);
}

});

parcelRegister("a8f6W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76065f710fd98f00$export$2e2bcd8739ae039; });

var $1JqCX = parcelRequire("1JqCX");

var $44ZCV = parcelRequire("44ZCV");

var $d6Koh = parcelRequire("d6Koh");

var $bHKsv = parcelRequire("bHKsv");
function $76065f710fd98f00$var$stackValue(d, key) {
    return d[key];
}
function $76065f710fd98f00$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $76065f710fd98f00$export$2e2bcd8739ae039() {
    var keys = (0, $44ZCV.default)([]), order = (0, $bHKsv.default), offset = (0, $d6Koh.default), value = $76065f710fd98f00$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $76065f710fd98f00$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $1JqCX.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $44ZCV.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $44ZCV.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? (0, $bHKsv.default) : typeof _ === "function" ? _ : (0, $44ZCV.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? (0, $d6Koh.default) : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("d6Koh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98afd21b81cdf9d5$export$2e2bcd8739ae039; });
function $98afd21b81cdf9d5$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("bHKsv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8857bf9b3a66a9b9$export$2e2bcd8739ae039; });
function $8857bf9b3a66a9b9$export$2e2bcd8739ae039(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("4gk9Q", function(module, exports) {

var $3hAWc = parcelRequire("3hAWc");

var $3FdFg = parcelRequire("3FdFg");

});
parcelRegister("3hAWc", function(module, exports) {

var $cMYF7 = parcelRequire("cMYF7");

var $2ssAA = parcelRequire("2ssAA");

var $6hHIr = parcelRequire("6hHIr");

var $bjzWC = parcelRequire("bjzWC");
var $ksTt2 = parcelRequire("ksTt2");
parcelRequire("4WsfD");
var $eip42 = parcelRequire("eip42");

var $2I0St = parcelRequire("2I0St");

var $csGcR = parcelRequire("csGcR");

var $3FdFg = parcelRequire("3FdFg");

var $kuA0E = parcelRequire("kuA0E");
// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function $263f9cad837c6431$var$defaultFilter(event) {
    return (!event.ctrlKey || event.type === 'wheel') && !event.button;
}
function $263f9cad837c6431$var$defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function $263f9cad837c6431$var$defaultTransform() {
    return this.__zoom || (0, $3FdFg.identity);
}
function $263f9cad837c6431$var$defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function $263f9cad837c6431$var$defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function $263f9cad837c6431$var$defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}
function $263f9cad837c6431$export$2e2bcd8739ae039() {
    var filter = $263f9cad837c6431$var$defaultFilter, extent = $263f9cad837c6431$var$defaultExtent, constrain = $263f9cad837c6431$var$defaultConstrain, wheelDelta = $263f9cad837c6431$var$defaultWheelDelta, touchable = $263f9cad837c6431$var$defaultTouchable, scaleExtent = [
        0,
        Infinity
    ], translateExtent = [
        [
            -Infinity,
            -Infinity
        ],
        [
            Infinity,
            Infinity
        ]
    ], duration = 250, interpolate = (0, $6hHIr.default), listeners = (0, $cMYF7.default)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
    function zoom(selection) {
        selection.property("__zoom", $263f9cad837c6431$var$defaultTransform).on("wheel.zoom", wheeled, {
            passive: false
        }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    zoom.transform = function(collection, transform, point, event) {
        var selection = collection.selection ? collection.selection() : collection;
        selection.property("__zoom", $263f9cad837c6431$var$defaultTransform);
        if (collection !== selection) schedule(collection, transform, point, event);
        else selection.interrupt().each(function() {
            gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
        });
    };
    zoom.scaleBy = function(selection, k, p, event) {
        zoom.scaleTo(selection, function() {
            var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return k0 * k1;
        }, p, event);
    };
    zoom.scaleTo = function(selection, k, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
            return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
        }, p, event);
    };
    zoom.translateBy = function(selection, x, y, event) {
        zoom.transform(selection, function() {
            return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
        }, null, event);
    };
    zoom.translateTo = function(selection, x, y, p, event) {
        zoom.transform(selection, function() {
            var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
            return constrain((0, $3FdFg.identity).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
        }, p, event);
    };
    function scale(transform, k) {
        k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
        return k === transform.k ? transform : new (0, $3FdFg.Transform)(k, transform.x, transform.y);
    }
    function translate(transform, p0, p1) {
        var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
        return x === transform.x && y === transform.y ? transform : new (0, $3FdFg.Transform)(transform.k, x, y);
    }
    function centroid(extent) {
        return [
            (+extent[0][0] + +extent[1][0]) / 2,
            (+extent[0][1] + +extent[1][1]) / 2
        ];
    }
    function schedule(transition, transform, point, event) {
        transition.on("start.zoom", function() {
            gesture(this, arguments).event(event).start();
        }).on("interrupt.zoom end.zoom", function() {
            gesture(this, arguments).event(event).end();
        }).tween("zoom", function() {
            var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
            return function(t) {
                if (t === 1) t = b; // Avoid rounding error on end.
                else {
                    var l = i(t), k = w / l[2];
                    t = new (0, $3FdFg.Transform)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                }
                g.zoom(null, t);
            };
        });
    }
    function gesture(that, args, clean) {
        return !clean && that.__zooming || new Gesture(that, args);
    }
    function Gesture(that, args) {
        this.that = that;
        this.args = args;
        this.active = 0;
        this.sourceEvent = null;
        this.extent = extent.apply(that, args);
        this.taps = 0;
    }
    Gesture.prototype = {
        event: function(event) {
            if (event) this.sourceEvent = event;
            return this;
        },
        start: function() {
            if (++this.active === 1) {
                this.that.__zooming = this;
                this.emit("start");
            }
            return this;
        },
        zoom: function(key, transform) {
            if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
            if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
            if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
            this.that.__zoom = transform;
            this.emit("zoom");
            return this;
        },
        end: function() {
            if (--this.active === 0) {
                delete this.that.__zooming;
                this.emit("end");
            }
            return this;
        },
        emit: function(type) {
            var d = (0, $ksTt2.default)(this.that).datum();
            listeners.call(type, this.that, new (0, $csGcR.default)(type, {
                sourceEvent: this.sourceEvent,
                target: zoom,
                type: type,
                transform: this.that.__zoom,
                dispatch: listeners
            }), d);
        }
    };
    function wheeled(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, $bjzWC.default)(event);
        // If the mouse is in the same location as before, reuse it.
        // If there were recent wheel events, reset the wheel idle timeout.
        if (g.wheel) {
            if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
            clearTimeout(g.wheel);
        } else if (t.k === k) return;
        else {
            g.mouse = [
                p,
                t.invert(p)
            ];
            (0, $eip42.default)(this);
            g.start();
        }
        (0, $kuA0E.default)(event);
        g.wheel = setTimeout(wheelidled, wheelDelay);
        g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
        function wheelidled() {
            g.wheel = null;
            g.end();
        }
    }
    function mousedowned(event, ...args) {
        if (touchending || !filter.apply(this, arguments)) return;
        var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = (0, $ksTt2.default)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, $bjzWC.default)(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
        (0, $2ssAA.default)(event.view);
        (0, $kuA0E.nopropagation)(event);
        g.mouse = [
            p,
            this.__zoom.invert(p)
        ];
        (0, $eip42.default)(this);
        g.start();
        function mousemoved(event) {
            (0, $kuA0E.default)(event);
            if (!g.moved) {
                var dx = event.clientX - x0, dy = event.clientY - y0;
                g.moved = dx * dx + dy * dy > clickDistance2;
            }
            g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, $bjzWC.default)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
        }
        function mouseupped(event) {
            v.on("mousemove.zoom mouseup.zoom", null);
            (0, $2ssAA.yesdrag)(event.view, g.moved);
            (0, $kuA0E.default)(event);
            g.event(event).end();
        }
    }
    function dblclicked(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var t0 = this.__zoom, p0 = (0, $bjzWC.default)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
        (0, $kuA0E.default)(event);
        if (duration > 0) (0, $ksTt2.default)(this).transition().duration(duration).call(schedule, t1, p0, event);
        else (0, $ksTt2.default)(this).call(zoom.transform, t1, p0, event);
    }
    function touchstarted(event, ...args) {
        if (!filter.apply(this, arguments)) return;
        var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
        (0, $kuA0E.nopropagation)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $bjzWC.default)(t, this);
            p = [
                p,
                this.__zoom.invert(p),
                t.identifier
            ];
            if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
            else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
        }
        if (touchstarting) touchstarting = clearTimeout(touchstarting);
        if (started) {
            if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                touchstarting = null;
            }, touchDelay);
            (0, $eip42.default)(this);
            g.start();
        }
    }
    function touchmoved(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
        (0, $kuA0E.default)(event);
        for(i = 0; i < n; ++i){
            t = touches[i], p = (0, $bjzWC.default)(t, this);
            if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
            else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
        }
        t = g.that.__zoom;
        if (g.touch1) {
            var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
            t = scale(t, Math.sqrt(dp / dl));
            p = [
                (p0[0] + p1[0]) / 2,
                (p0[1] + p1[1]) / 2
            ];
            l = [
                (l0[0] + l1[0]) / 2,
                (l0[1] + l1[1]) / 2
            ];
        } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
        else return;
        g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
    }
    function touchended(event, ...args) {
        if (!this.__zooming) return;
        var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
        (0, $kuA0E.nopropagation)(event);
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function() {
            touchending = null;
        }, touchDelay);
        for(i = 0; i < n; ++i){
            t = touches[i];
            if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
            else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
        }
        if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
        if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
        else {
            g.end();
            // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
            if (g.taps === 2) {
                t = (0, $bjzWC.default)(t, this);
                if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                    var p = (0, $ksTt2.default)(this).on("dblclick.zoom");
                    if (p) p.apply(this, arguments);
                }
            }
        }
    }
    zoom.wheelDelta = function(_) {
        return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, $2I0St.default)(+_), zoom) : wheelDelta;
    };
    zoom.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, $2I0St.default)(!!_), zoom) : filter;
    };
    zoom.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, $2I0St.default)(!!_), zoom) : touchable;
    };
    zoom.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, $2I0St.default)([
            [
                +_[0][0],
                +_[0][1]
            ],
            [
                +_[1][0],
                +_[1][1]
            ]
        ]), zoom) : extent;
    };
    zoom.scaleExtent = function(_) {
        return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
            scaleExtent[0],
            scaleExtent[1]
        ];
    };
    zoom.translateExtent = function(_) {
        return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
            [
                translateExtent[0][0],
                translateExtent[0][1]
            ],
            [
                translateExtent[1][0],
                translateExtent[1][1]
            ]
        ];
    };
    zoom.constrain = function(_) {
        return arguments.length ? (constrain = _, zoom) : constrain;
    };
    zoom.duration = function(_) {
        return arguments.length ? (duration = +_, zoom) : duration;
    };
    zoom.interpolate = function(_) {
        return arguments.length ? (interpolate = _, zoom) : interpolate;
    };
    zoom.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? zoom : value;
    };
    zoom.clickDistance = function(_) {
        return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
    };
    zoom.tapDistance = function(_) {
        return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
    };
    return zoom;
}

});
parcelRegister("6hHIr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49363dad5e4df8bc$export$2e2bcd8739ae039; });
var $49363dad5e4df8bc$var$epsilon2 = 1e-12;
function $49363dad5e4df8bc$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $49363dad5e4df8bc$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $49363dad5e4df8bc$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $49363dad5e4df8bc$export$2e2bcd8739ae039 = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < $49363dad5e4df8bc$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $49363dad5e4df8bc$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $49363dad5e4df8bc$var$tanh(rho * s + r0) - $49363dad5e4df8bc$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $49363dad5e4df8bc$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);

});

parcelRegister("2I0St", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f905f1cc5ecc091$export$2e2bcd8739ae039; });
var $1f905f1cc5ecc091$export$2e2bcd8739ae039 = (x)=>()=>x;

});

parcelRegister("csGcR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9128d6db38e6b63d$export$2e2bcd8739ae039; });
function $9128d6db38e6b63d$export$2e2bcd8739ae039(type, { sourceEvent: sourceEvent, target: target, transform: transform, dispatch: dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}

});

parcelRegister("3FdFg", function(module, exports) {

$parcel$export(module.exports, "Transform", function () { return $2aafccebee77c849$export$563a914cafbdc389; });
$parcel$export(module.exports, "identity", function () { return $2aafccebee77c849$export$f0954fd7d5368655; });
function $2aafccebee77c849$export$563a914cafbdc389(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
$2aafccebee77c849$export$563a914cafbdc389.prototype = {
    constructor: $2aafccebee77c849$export$563a914cafbdc389,
    scale: function(k) {
        return k === 1 ? this : new $2aafccebee77c849$export$563a914cafbdc389(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new $2aafccebee77c849$export$563a914cafbdc389(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var $2aafccebee77c849$export$f0954fd7d5368655 = new $2aafccebee77c849$export$563a914cafbdc389(1, 0, 0);
$2aafccebee77c849$export$2e2bcd8739ae039.prototype = $2aafccebee77c849$export$563a914cafbdc389.prototype;
function $2aafccebee77c849$export$2e2bcd8739ae039(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return $2aafccebee77c849$export$f0954fd7d5368655;
    return node.__zoom;
}

});

parcelRegister("kuA0E", function(module, exports) {

$parcel$export(module.exports, "nopropagation", function () { return $eeb28ab9eb194518$export$2e2561858db9bf47; });
$parcel$export(module.exports, "default", function () { return $eeb28ab9eb194518$export$2e2bcd8739ae039; });
function $eeb28ab9eb194518$export$2e2561858db9bf47(event) {
    event.stopImmediatePropagation();
}
function $eeb28ab9eb194518$export$2e2bcd8739ae039(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}

});




parcelRegister("eYT2J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae815dab1227c65c$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");



var $1WkvG = parcelRequire("1WkvG");

var $cVgD8 = parcelRequire("cVgD8");

var $d6SUv = parcelRequire("d6SUv");

var $Uxz4Y = parcelRequire("Uxz4Y");

var $whS22 = parcelRequire("whS22");

var $cecER = parcelRequire("cecER");

var $aanJt = parcelRequire("aanJt");

var $aIJrd = parcelRequire("aIJrd");
var $ae815dab1227c65c$var$variantComponent = {
    standard: (0, $1WkvG.default),
    filled: (0, $cVgD8.default),
    outlined: (0, $d6SUv.default)
};
var $ae815dab1227c65c$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {}
};
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/api/form-control/)
 * - [InputLabel](/api/input-label/)
 * - [FilledInput](/api/filled-input/)
 * - [OutlinedInput](/api/outlined-input/)
 * - [Input](/api/input/)
 * - [FormHelperText](/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ var $ae815dab1227c65c$var$TextField = /*#__PURE__*/ $ieT14.forwardRef(function TextField(props, ref) {
    var autoComplete = props.autoComplete, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, defaultValue = props.defaultValue, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, FormHelperTextProps = props.FormHelperTextProps, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, helperText = props.helperText, hiddenLabel = props.hiddenLabel, id = props.id, InputLabelProps = props.InputLabelProps, inputProps = props.inputProps, InputProps = props.InputProps, inputRef = props.inputRef, label = props.label, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, placeholder = props.placeholder, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, rows = props.rows, rowsMax = props.rowsMax, maxRows = props.maxRows, minRows = props.minRows, _props$select = props.select, select = _props$select === void 0 ? false : _props$select, SelectProps = props.SelectProps, type = props.type, value = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $eTwGP.default)(props, [
        "autoComplete",
        "autoFocus",
        "children",
        "classes",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "error",
        "FormHelperTextProps",
        "fullWidth",
        "helperText",
        "hiddenLabel",
        "id",
        "InputLabelProps",
        "inputProps",
        "InputProps",
        "inputRef",
        "label",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "placeholder",
        "required",
        "rows",
        "rowsMax",
        "maxRows",
        "minRows",
        "select",
        "SelectProps",
        "type",
        "value",
        "variant"
    ]);
    var InputMore = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') InputMore.notched = InputLabelProps.shrink;
        if (label) {
            var _InputLabelProps$requ;
            var displayRequired = (_InputLabelProps$requ = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.required) !== null && _InputLabelProps$requ !== void 0 ? _InputLabelProps$requ : required;
            InputMore.label = /*#__PURE__*/ $ieT14.createElement($ieT14.Fragment, null, label, displayRequired && "\xA0*");
        }
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore['aria-describedby'] = undefined;
    }
    var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
    var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
    var InputComponent = $ae815dab1227c65c$var$variantComponent[variant];
    var InputElement = /*#__PURE__*/ $ieT14.createElement(InputComponent, (0, $edxsd.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        rowsMax: rowsMax,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ $ieT14.createElement((0, $whS22.default), (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        ref: ref,
        required: required,
        color: color,
        variant: variant
    }, other), label && /*#__PURE__*/ $ieT14.createElement((0, $Uxz4Y.default), (0, $edxsd.default)({
        htmlFor: id,
        id: inputLabelId
    }, InputLabelProps), label), select ? /*#__PURE__*/ $ieT14.createElement((0, $aanJt.default), (0, $edxsd.default)({
        "aria-describedby": helperTextId,
        id: id,
        labelId: inputLabelId,
        value: value,
        input: InputElement
    }, SelectProps), children) : InputElement, helperText && /*#__PURE__*/ $ieT14.createElement((0, $cecER.default), (0, $edxsd.default)({
        id: helperTextId
    }, FormHelperTextProps), helperText));
});
var $ae815dab1227c65c$export$2e2bcd8739ae039 = (0, $aIJrd.default)($ae815dab1227c65c$export$9dd6ff9ea0189349, {
    name: 'MuiTextField'
})($ae815dab1227c65c$var$TextField);

});
parcelRegister("cecER", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e709c737d22ea4f$export$2e2bcd8739ae039; });

var $eTwGP = parcelRequire("eTwGP");

var $edxsd = parcelRequire("edxsd");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $gAQ3E = parcelRequire("gAQ3E");

var $aRcbT = parcelRequire("aRcbT");

var $aIJrd = parcelRequire("aIJrd");
var $8e709c737d22ea4f$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $edxsd.default)({
            color: theme.palette.text.secondary
        }, theme.typography.caption, {
            textAlign: 'left',
            marginTop: 3,
            margin: 0,
            '&$disabled': {
                color: theme.palette.text.disabled
            },
            '&$error': {
                color: theme.palette.error.main
            }
        }),
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
            marginTop: 4
        },
        /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */ contained: {
            marginLeft: 14,
            marginRight: 14
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `filled={true}`. */ filled: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {}
    };
};
var $8e709c737d22ea4f$var$FormHelperText = /*#__PURE__*/ $ieT14.forwardRef(function FormHelperText(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'p' : _props$component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, margin = props.margin, required = props.required, variant = props.variant, other = (0, $eTwGP.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "margin",
        "required",
        "variant"
    ]);
    var muiFormControl = (0, $aRcbT.default)();
    var fcs = (0, $gAQ3E.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'margin',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    return /*#__PURE__*/ $ieT14.createElement(Component, (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, (fcs.variant === 'filled' || fcs.variant === 'outlined') && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, fcs.margin === 'dense' && classes.marginDense),
        ref: ref
    }, other), children === ' ' ? /*#__PURE__*/ // eslint-disable-next-line react/no-danger
    $ieT14.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: '&#8203;'
        }
    }) : children);
});
var $8e709c737d22ea4f$export$2e2bcd8739ae039 = (0, $aIJrd.default)($8e709c737d22ea4f$export$9dd6ff9ea0189349, {
    name: 'MuiFormHelperText'
})($8e709c737d22ea4f$var$FormHelperText);

});


parcelRegister("lamW6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f68c52cc7c5c2188$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");


var $ak9X1 = parcelRequire("ak9X1");

var $4L5rH = parcelRequire("4L5rH");

var $6vqhY = parcelRequire("6vqhY");

var $86m3e = parcelRequire("86m3e");

var $jTN8i = parcelRequire("jTN8i");

var $2EBFt = parcelRequire("2EBFt");

var $aIJrd = parcelRequire("aIJrd");
var $f68c52cc7c5c2188$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            color: theme.palette.text.secondary
        },
        /* Pseudo-class applied to the root element if `checked={true}`. */ checked: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `indeterminate={true}`. */ indeterminate: {},
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            '&$checked': {
                color: theme.palette.primary.main,
                '&:hover': {
                    backgroundColor: (0, $86m3e.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            '&$disabled': {
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            '&$checked': {
                color: theme.palette.secondary.main,
                '&:hover': {
                    backgroundColor: (0, $86m3e.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            '&$disabled': {
                color: theme.palette.action.disabled
            }
        }
    };
};
var $f68c52cc7c5c2188$var$defaultCheckedIcon = /*#__PURE__*/ $ieT14.createElement((0, $6vqhY.default), null);
var $f68c52cc7c5c2188$var$defaultIcon = /*#__PURE__*/ $ieT14.createElement((0, $4L5rH.default), null);
var $f68c52cc7c5c2188$var$defaultIndeterminateIcon = /*#__PURE__*/ $ieT14.createElement((0, $jTN8i.default), null);
var $f68c52cc7c5c2188$var$Checkbox = /*#__PURE__*/ $ieT14.forwardRef(function Checkbox(props, ref) {
    var _props$checkedIcon = props.checkedIcon, checkedIcon = _props$checkedIcon === void 0 ? $f68c52cc7c5c2188$var$defaultCheckedIcon : _props$checkedIcon, classes = props.classes, _props$color = props.color, color = _props$color === void 0 ? 'secondary' : _props$color, _props$icon = props.icon, iconProp = _props$icon === void 0 ? $f68c52cc7c5c2188$var$defaultIcon : _props$icon, _props$indeterminate = props.indeterminate, indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate, _props$indeterminateI = props.indeterminateIcon, indeterminateIconProp = _props$indeterminateI === void 0 ? $f68c52cc7c5c2188$var$defaultIndeterminateIcon : _props$indeterminateI, inputProps = props.inputProps, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, other = (0, $eTwGP.default)(props, [
        "checkedIcon",
        "classes",
        "color",
        "icon",
        "indeterminate",
        "indeterminateIcon",
        "inputProps",
        "size"
    ]);
    var icon = indeterminate ? indeterminateIconProp : iconProp;
    var indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    return /*#__PURE__*/ $ieT14.createElement((0, $ak9X1.default), (0, $edxsd.default)({
        type: "checkbox",
        classes: {
            root: (0, $j6s32.default)(classes.root, classes["color".concat((0, $2EBFt.default)(color))], indeterminate && classes.indeterminate),
            checked: classes.checked,
            disabled: classes.disabled
        },
        color: color,
        inputProps: (0, $edxsd.default)({
            'data-indeterminate': indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $ieT14.cloneElement(icon, {
            fontSize: icon.props.fontSize === undefined && size === "small" ? size : icon.props.fontSize
        }),
        checkedIcon: /*#__PURE__*/ $ieT14.cloneElement(indeterminateIcon, {
            fontSize: indeterminateIcon.props.fontSize === undefined && size === "small" ? size : indeterminateIcon.props.fontSize
        }),
        ref: ref
    }, other));
});
var $f68c52cc7c5c2188$export$2e2bcd8739ae039 = (0, $aIJrd.default)($f68c52cc7c5c2188$export$9dd6ff9ea0189349, {
    name: 'MuiCheckbox'
})($f68c52cc7c5c2188$var$Checkbox);

});
parcelRegister("ak9X1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78437db3c66b2628$export$2e2bcd8739ae039; });

var $edxsd = parcelRequire("edxsd");

var $dcIvM = parcelRequire("dcIvM");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");


var $kuovH = parcelRequire("kuovH");

var $aRcbT = parcelRequire("aRcbT");

var $aIJrd = parcelRequire("aIJrd");

var $1KcBP = parcelRequire("1KcBP");
var $78437db3c66b2628$export$9dd6ff9ea0189349 = {
    root: {
        padding: 9
    },
    checked: {},
    disabled: {},
    input: {
        cursor: 'inherit',
        position: 'absolute',
        opacity: 0,
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        margin: 0,
        padding: 0,
        zIndex: 1
    }
};
/**
 * @ignore - internal component.
 */ var $78437db3c66b2628$var$SwitchBase = /*#__PURE__*/ $ieT14.forwardRef(function SwitchBase(props, ref) {
    var autoFocus = props.autoFocus, checkedProp = props.checked, checkedIcon = props.checkedIcon, classes = props.classes, className = props.className, defaultChecked = props.defaultChecked, disabledProp = props.disabled, icon = props.icon, id = props.id, inputProps = props.inputProps, inputRef = props.inputRef, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, readOnly = props.readOnly, required = props.required, tabIndex = props.tabIndex, type = props.type, value = props.value, other = (0, $eTwGP.default)(props, [
        "autoFocus",
        "checked",
        "checkedIcon",
        "classes",
        "className",
        "defaultChecked",
        "disabled",
        "icon",
        "id",
        "inputProps",
        "inputRef",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "readOnly",
        "required",
        "tabIndex",
        "type",
        "value"
    ]);
    var _useControlled = (0, $kuovH.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    }), _useControlled2 = (0, $dcIvM.default)(_useControlled, 2), checked = _useControlled2[0], setCheckedState = _useControlled2[1];
    var muiFormControl = (0, $aRcbT.default)();
    var handleFocus = function handleFocus(event) {
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    var handleBlur = function handleBlur(event) {
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    var handleInputChange = function handleInputChange(event) {
        var newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v5: remove the second argument.
        onChange(event, newChecked);
    };
    var disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    var hasLabelFor = type === 'checkbox' || type === 'radio';
    return /*#__PURE__*/ $ieT14.createElement((0, $1KcBP.default), (0, $edxsd.default)({
        component: "span",
        className: (0, $j6s32.default)(classes.root, className, checked && classes.checked, disabled && classes.disabled),
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ref: ref
    }, other), /*#__PURE__*/ $ieT14.createElement("input", (0, $edxsd.default)({
        autoFocus: autoFocus,
        checked: checkedProp,
        defaultChecked: defaultChecked,
        className: classes.input,
        disabled: disabled,
        id: hasLabelFor && id,
        name: name,
        onChange: handleInputChange,
        readOnly: readOnly,
        ref: inputRef,
        required: required,
        tabIndex: tabIndex,
        type: type,
        value: value
    }, inputProps)), checked ? checkedIcon : icon);
}); // NB: If changed, please update Checkbox, Switch and Radio
var $78437db3c66b2628$export$2e2bcd8739ae039 = (0, $aIJrd.default)($78437db3c66b2628$export$9dd6ff9ea0189349, {
    name: 'PrivateSwitchBase'
})($78437db3c66b2628$var$SwitchBase);

});

parcelRegister("4L5rH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $376fc69beabaac12$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var /**
 * @ignore - internal component.
 */ $376fc69beabaac12$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');

});

parcelRegister("6vqhY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bca07c134cfeecf$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var /**
 * @ignore - internal component.
 */ $4bca07c134cfeecf$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');

});

parcelRegister("jTN8i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7c9441fa7493d0c$export$2e2bcd8739ae039; });

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var /**
 * @ignore - internal component.
 */ $e7c9441fa7493d0c$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');

});



parcelRegister("87yK1", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("f6MGZ", function(module, exports) {


!function(t, e) {
    var n, i;
    module.exports = e((parcelRequire("ieT14")), (parcelRequire("87yK1")));
}("undefined" != typeof self ? self : module.exports, function(t, e) {
    return function(t) {
        var e = {};
        function n(i) {
            if (e[i]) return e[i].exports;
            var a = e[i] = {
                i: i,
                l: !1,
                exports: {}
            };
            return t[i].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
        }
        return n.m = t, n.c = e, n.d = function(t, e, i) {
            n.o(t, e) || Object.defineProperty(t, e, {
                enumerable: !0,
                get: i
            });
        }, n.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, n.t = function(t, e) {
            if (1 & e && (t = n(t)), 8 & e) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var i = Object.create(null);
            if (n.r(i), Object.defineProperty(i, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t) for(var a in t)n.d(i, a, (function(e) {
                return t[e];
            }).bind(null, a));
            return i;
        }, n.n = function(t) {
            var e = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return n.d(e, "a", e), e;
        }, n.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, n.p = "", n(n.s = 107);
    }({
        0: function(e, n) {
            e.exports = t;
        },
        1: function(t, n) {
            t.exports = e;
        },
        107: function(t, e, n) {
            "use strict";
            var i, a = this && this.__extends || (i = function(t, e) {
                return (i = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t, e) {
                    t.__proto__ = e;
                } || function(t, e) {
                    for(var n in e)e.hasOwnProperty(n) && (t[n] = e[n]);
                })(t, e);
            }, function(t, e) {
                function n() {
                    this.constructor = t;
                }
                i(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n);
            }), r = this && this.__assign || function() {
                return (r = Object.assign || function(t) {
                    for(var e, n = 1, i = arguments.length; n < i; n++)for(var a in e = arguments[n])Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
                    return t;
                }).apply(this, arguments);
            }, o = this && this.__rest || function(t, e) {
                var n = {};
                for(var i in t)Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
                if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
                    var a = 0;
                    for(i = Object.getOwnPropertySymbols(t); a < i.length; a++)e.indexOf(i[a]) < 0 && Object.prototype.propertyIsEnumerable.call(t, i[a]) && (n[i[a]] = t[i[a]]);
                }
                return n;
            }, s = this && this.__importDefault || function(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            };
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var u = s(n(0)), c = s(n(1)), d = n(155), p = n(38), l = n(108);
            e.withRipple = function(t) {
                var e;
                return (e = function(e) {
                    function n() {
                        var n = null !== e && e.apply(this, arguments) || this;
                        return n.isComponentMounted = !0, n.isTouched = !1, n.displayName = "WithRipple(" + function(t) {
                            return t.displayName || t.name || "Component";
                        }(t) + ")", n.state = {
                            classList: new Set,
                            style: {}
                        }, n.initializeFoundation = function(t, e) {
                            var i = n.createAdapter(t, e);
                            n.foundation = new d.MDCRippleFoundation(i), n.foundation.init();
                        }, n.createAdapter = function(t, e) {
                            return {
                                browserSupportsCssVars: function() {
                                    return p.supportsCssVariables(window);
                                },
                                isUnbounded: function() {
                                    return n.props.unbounded;
                                },
                                isSurfaceActive: function() {
                                    return e ? l.matches(e, ":active") : l.matches(t, ":active");
                                },
                                isSurfaceDisabled: function() {
                                    return n.props.disabled;
                                },
                                addClass: function(t) {
                                    n.isComponentMounted && n.setState({
                                        classList: n.state.classList.add(t)
                                    });
                                },
                                removeClass: function(t) {
                                    if (n.isComponentMounted) {
                                        var e = n.state.classList;
                                        e.delete(t), n.setState({
                                            classList: e
                                        });
                                    }
                                },
                                registerDocumentInteractionHandler: function(t, e) {
                                    return document.documentElement.addEventListener(t, e, p.applyPassive());
                                },
                                deregisterDocumentInteractionHandler: function(t, e) {
                                    return document.documentElement.removeEventListener(t, e, p.applyPassive());
                                },
                                registerResizeHandler: function(t) {
                                    return window.addEventListener("resize", t);
                                },
                                deregisterResizeHandler: function(t) {
                                    return window.removeEventListener("resize", t);
                                },
                                updateCssVariable: n.updateCssVariable,
                                computeBoundingRect: function() {
                                    return n.isComponentMounted ? n.props.computeBoundingRect ? n.props.computeBoundingRect(t) : t.getBoundingClientRect() : {
                                        bottom: 0,
                                        height: 0,
                                        left: 0,
                                        right: 0,
                                        top: 0,
                                        width: 0,
                                        x: 0,
                                        y: 0
                                    };
                                },
                                containsEventTarget: function(t) {
                                    return !(!e || null === t) && e.contains(t);
                                },
                                registerInteractionHandler: function() {
                                    return null;
                                },
                                deregisterInteractionHandler: function() {
                                    return null;
                                },
                                getWindowPageOffset: function() {
                                    return {
                                        x: window.pageXOffset,
                                        y: window.pageYOffset
                                    };
                                }
                            };
                        }, n.handleFocus = function(t) {
                            n.props.onFocus && n.props.onFocus(t), n.foundation.handleFocus();
                        }, n.handleBlur = function(t) {
                            n.props.onBlur && n.props.onBlur(t), n.foundation.handleBlur();
                        }, n.handleMouseDown = function(t) {
                            n.props.onMouseDown && n.props.onMouseDown(t), n.isTouched ? n.isTouched = !1 : n.activateRipple(t);
                        }, n.handleMouseUp = function(t) {
                            n.props.onMouseUp && n.props.onMouseUp(t), n.deactivateRipple();
                        }, n.handleTouchStart = function(t) {
                            n.isTouched = !0, n.props.onTouchStart && n.props.onTouchStart(t), n.activateRipple(t);
                        }, n.handleTouchEnd = function(t) {
                            n.props.onTouchEnd && n.props.onTouchEnd(t), n.deactivateRipple();
                        }, n.handleKeyDown = function(t) {
                            n.props.onKeyDown && n.props.onKeyDown(t), n.activateRipple(t);
                        }, n.handleKeyUp = function(t) {
                            n.props.onKeyUp && n.props.onKeyUp(t), n.deactivateRipple();
                        }, n.activateRipple = function(t) {
                            t.persist(), n.foundation.activate(t.nativeEvent);
                        }, n.deactivateRipple = function() {
                            n.foundation.deactivate();
                        }, n.updateCssVariable = function(t, e) {
                            n.isComponentMounted && n.setState(function(i) {
                                var a = Object.assign({}, n.state.style, i.style);
                                return null === e ? delete a[t] : a[t] = e, Object.assign(i, {
                                    style: a
                                });
                            });
                        }, n;
                    }
                    return a(n, e), n.prototype.componentDidMount = function() {
                        if (!this.foundation) throw new Error("You must call initRipple from the element's ref prop to initialize the adapter for withRipple");
                    }, n.prototype.componentDidUpdate = function(t) {
                        this.props.disabled !== t.disabled && this.props.disabled && this.foundation.handleBlur();
                    }, n.prototype.componentWillUnmount = function() {
                        this.foundation && (this.isComponentMounted = !1, this.foundation.destroy());
                    }, Object.defineProperty(n.prototype, "classes", {
                        get: function() {
                            var t = this.props.className, e = this.state.classList;
                            return c.default(Array.from(e), t);
                        },
                        enumerable: !0,
                        configurable: !0
                    }), Object.defineProperty(n.prototype, "style", {
                        get: function() {
                            var t = this.props.style, e = this.state.style;
                            return Object.assign({}, e, t);
                        },
                        enumerable: !0,
                        configurable: !0
                    }), n.prototype.render = function() {
                        var e = this.props, n = (e.unbounded, e.style, e.className, e.onMouseDown, e.onMouseUp, e.onTouchStart, e.onTouchEnd, e.onKeyDown, e.onKeyUp, e.onFocus, e.onBlur, o(e, [
                            "unbounded",
                            "style",
                            "className",
                            "onMouseDown",
                            "onMouseUp",
                            "onTouchStart",
                            "onTouchEnd",
                            "onKeyDown",
                            "onKeyUp",
                            "onFocus",
                            "onBlur"
                        ])), i = r({}, n, {
                            onMouseDown: this.handleMouseDown,
                            onMouseUp: this.handleMouseUp,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd,
                            onKeyDown: this.handleKeyDown,
                            onKeyUp: this.handleKeyUp,
                            onFocus: this.handleFocus,
                            onBlur: this.handleBlur,
                            initRipple: this.initializeFoundation,
                            className: this.classes,
                            style: this.style
                        });
                        return u.default.createElement(t, r({}, i));
                    }, n;
                }(u.default.Component)).defaultProps = r({
                    unbounded: !1,
                    disabled: !1,
                    style: {},
                    className: "",
                    onMouseDown: function() {},
                    onMouseUp: function() {},
                    onTouchStart: function() {},
                    onTouchEnd: function() {},
                    onKeyDown: function() {},
                    onKeyUp: function() {},
                    onFocus: function() {},
                    onBlur: function() {}
                }, t.defaultProps), e;
            };
        },
        108: function(t, e, n) {
            "use strict";
            /**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ function i(t, e) {
                if (t.closest) return t.closest(e);
                for(var n = t; n;){
                    if (a(n, e)) return n;
                    n = n.parentElement;
                }
                return null;
            }
            function a(t, e) {
                return (t.matches || t.webkitMatchesSelector || t.msMatchesSelector).call(t, e);
            }
            n.r(e), n.d(e, "closest", function() {
                return i;
            }), n.d(e, "matches", function() {
                return a;
            });
        },
        155: function(t, e, n) {
            "use strict";
            n.r(e);
            "function" == typeof Symbol && Symbol.iterator;
            /*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ var i = function(t, e) {
                return (i = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t, e) {
                    t.__proto__ = e;
                } || function(t, e) {
                    for(var n in e)e.hasOwnProperty(n) && (t[n] = e[n]);
                })(t, e);
            };
            var a = function() {
                return (a = Object.assign || function(t) {
                    for(var e, n = 1, i = arguments.length; n < i; n++)for(var a in e = arguments[n])Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
                    return t;
                }).apply(this, arguments);
            };
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var r = function() {
                function t(t) {
                    void 0 === t && (t = {}), this.adapter_ = t;
                }
                return Object.defineProperty(t, "cssClasses", {
                    get: function() {
                        return {};
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(t, "strings", {
                    get: function() {
                        return {};
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(t, "numbers", {
                    get: function() {
                        return {};
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(t, "defaultAdapter", {
                    get: function() {
                        return {};
                    },
                    enumerable: !0,
                    configurable: !0
                }), t.prototype.init = function() {}, t.prototype.destroy = function() {}, t;
            }(), o = {
                BG_FOCUSED: "mdc-ripple-upgraded--background-focused",
                FG_ACTIVATION: "mdc-ripple-upgraded--foreground-activation",
                FG_DEACTIVATION: "mdc-ripple-upgraded--foreground-deactivation",
                ROOT: "mdc-ripple-upgraded",
                UNBOUNDED: "mdc-ripple-upgraded--unbounded"
            }, s = {
                VAR_FG_SCALE: "--mdc-ripple-fg-scale",
                VAR_FG_SIZE: "--mdc-ripple-fg-size",
                VAR_FG_TRANSLATE_END: "--mdc-ripple-fg-translate-end",
                VAR_FG_TRANSLATE_START: "--mdc-ripple-fg-translate-start",
                VAR_LEFT: "--mdc-ripple-left",
                VAR_TOP: "--mdc-ripple-top"
            }, u = {
                DEACTIVATION_TIMEOUT_MS: 225,
                FG_DEACTIVATION_MS: 150,
                INITIAL_ORIGIN_SCALE: .6,
                PADDING: 10,
                TAP_DELAY_MS: 300
            }, c = n(38);
            n.d(e, "MDCRippleFoundation", function() {
                return f;
            });
            /**
 * @license
 * Copyright 2016 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var d = [
                "touchstart",
                "pointerdown",
                "mousedown",
                "keydown"
            ], p = [
                "touchend",
                "pointerup",
                "mouseup",
                "contextmenu"
            ], l = [], f = function(t) {
                function e(n) {
                    var i = t.call(this, a({}, e.defaultAdapter, n)) || this;
                    return i.activationAnimationHasEnded_ = !1, i.activationTimer_ = 0, i.fgDeactivationRemovalTimer_ = 0, i.fgScale_ = "0", i.frame_ = {
                        width: 0,
                        height: 0
                    }, i.initialSize_ = 0, i.layoutFrame_ = 0, i.maxRadius_ = 0, i.unboundedCoords_ = {
                        left: 0,
                        top: 0
                    }, i.activationState_ = i.defaultActivationState_(), i.activationTimerCallback_ = function() {
                        i.activationAnimationHasEnded_ = !0, i.runDeactivationUXLogicIfReady_();
                    }, i.activateHandler_ = function(t) {
                        return i.activate_(t);
                    }, i.deactivateHandler_ = function() {
                        return i.deactivate_();
                    }, i.focusHandler_ = function() {
                        return i.handleFocus();
                    }, i.blurHandler_ = function() {
                        return i.handleBlur();
                    }, i.resizeHandler_ = function() {
                        return i.layout();
                    }, i;
                }
                return function(t, e) {
                    function n() {
                        this.constructor = t;
                    }
                    i(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n);
                }(e, t), Object.defineProperty(e, "cssClasses", {
                    get: function() {
                        return o;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(e, "strings", {
                    get: function() {
                        return s;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(e, "numbers", {
                    get: function() {
                        return u;
                    },
                    enumerable: !0,
                    configurable: !0
                }), Object.defineProperty(e, "defaultAdapter", {
                    get: function() {
                        return {
                            addClass: function() {},
                            browserSupportsCssVars: function() {
                                return !0;
                            },
                            computeBoundingRect: function() {
                                return {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0,
                                    width: 0,
                                    height: 0
                                };
                            },
                            containsEventTarget: function() {
                                return !0;
                            },
                            deregisterDocumentInteractionHandler: function() {},
                            deregisterInteractionHandler: function() {},
                            deregisterResizeHandler: function() {},
                            getWindowPageOffset: function() {
                                return {
                                    x: 0,
                                    y: 0
                                };
                            },
                            isSurfaceActive: function() {
                                return !0;
                            },
                            isSurfaceDisabled: function() {
                                return !0;
                            },
                            isUnbounded: function() {
                                return !0;
                            },
                            registerDocumentInteractionHandler: function() {},
                            registerInteractionHandler: function() {},
                            registerResizeHandler: function() {},
                            removeClass: function() {},
                            updateCssVariable: function() {}
                        };
                    },
                    enumerable: !0,
                    configurable: !0
                }), e.prototype.init = function() {
                    var t = this, n = this.supportsPressRipple_();
                    if (this.registerRootHandlers_(n), n) {
                        var i = e.cssClasses, a = i.ROOT, r = i.UNBOUNDED;
                        requestAnimationFrame(function() {
                            t.adapter_.addClass(a), t.adapter_.isUnbounded() && (t.adapter_.addClass(r), t.layoutInternal_());
                        });
                    }
                }, e.prototype.destroy = function() {
                    var t = this;
                    if (this.supportsPressRipple_()) {
                        this.activationTimer_ && (clearTimeout(this.activationTimer_), this.activationTimer_ = 0, this.adapter_.removeClass(e.cssClasses.FG_ACTIVATION)), this.fgDeactivationRemovalTimer_ && (clearTimeout(this.fgDeactivationRemovalTimer_), this.fgDeactivationRemovalTimer_ = 0, this.adapter_.removeClass(e.cssClasses.FG_DEACTIVATION));
                        var n = e.cssClasses, i = n.ROOT, a = n.UNBOUNDED;
                        requestAnimationFrame(function() {
                            t.adapter_.removeClass(i), t.adapter_.removeClass(a), t.removeCssVars_();
                        });
                    }
                    this.deregisterRootHandlers_(), this.deregisterDeactivationHandlers_();
                }, e.prototype.activate = function(t) {
                    this.activate_(t);
                }, e.prototype.deactivate = function() {
                    this.deactivate_();
                }, e.prototype.layout = function() {
                    var t = this;
                    this.layoutFrame_ && cancelAnimationFrame(this.layoutFrame_), this.layoutFrame_ = requestAnimationFrame(function() {
                        t.layoutInternal_(), t.layoutFrame_ = 0;
                    });
                }, e.prototype.setUnbounded = function(t) {
                    var n = e.cssClasses.UNBOUNDED;
                    t ? this.adapter_.addClass(n) : this.adapter_.removeClass(n);
                }, e.prototype.handleFocus = function() {
                    var t = this;
                    requestAnimationFrame(function() {
                        return t.adapter_.addClass(e.cssClasses.BG_FOCUSED);
                    });
                }, e.prototype.handleBlur = function() {
                    var t = this;
                    requestAnimationFrame(function() {
                        return t.adapter_.removeClass(e.cssClasses.BG_FOCUSED);
                    });
                }, e.prototype.supportsPressRipple_ = function() {
                    return this.adapter_.browserSupportsCssVars();
                }, e.prototype.defaultActivationState_ = function() {
                    return {
                        activationEvent: void 0,
                        hasDeactivationUXRun: !1,
                        isActivated: !1,
                        isProgrammatic: !1,
                        wasActivatedByPointer: !1,
                        wasElementMadeActive: !1
                    };
                }, e.prototype.registerRootHandlers_ = function(t) {
                    var e = this;
                    t && (d.forEach(function(t) {
                        e.adapter_.registerInteractionHandler(t, e.activateHandler_);
                    }), this.adapter_.isUnbounded() && this.adapter_.registerResizeHandler(this.resizeHandler_)), this.adapter_.registerInteractionHandler("focus", this.focusHandler_), this.adapter_.registerInteractionHandler("blur", this.blurHandler_);
                }, e.prototype.registerDeactivationHandlers_ = function(t) {
                    var e = this;
                    "keydown" === t.type ? this.adapter_.registerInteractionHandler("keyup", this.deactivateHandler_) : p.forEach(function(t) {
                        e.adapter_.registerDocumentInteractionHandler(t, e.deactivateHandler_);
                    });
                }, e.prototype.deregisterRootHandlers_ = function() {
                    var t = this;
                    d.forEach(function(e) {
                        t.adapter_.deregisterInteractionHandler(e, t.activateHandler_);
                    }), this.adapter_.deregisterInteractionHandler("focus", this.focusHandler_), this.adapter_.deregisterInteractionHandler("blur", this.blurHandler_), this.adapter_.isUnbounded() && this.adapter_.deregisterResizeHandler(this.resizeHandler_);
                }, e.prototype.deregisterDeactivationHandlers_ = function() {
                    var t = this;
                    this.adapter_.deregisterInteractionHandler("keyup", this.deactivateHandler_), p.forEach(function(e) {
                        t.adapter_.deregisterDocumentInteractionHandler(e, t.deactivateHandler_);
                    });
                }, e.prototype.removeCssVars_ = function() {
                    var t = this, n = e.strings;
                    Object.keys(n).forEach(function(e) {
                        0 === e.indexOf("VAR_") && t.adapter_.updateCssVariable(n[e], null);
                    });
                }, e.prototype.activate_ = function(t) {
                    var e = this;
                    if (!this.adapter_.isSurfaceDisabled()) {
                        var n = this.activationState_;
                        if (!n.isActivated) {
                            var i = this.previousActivationEvent_;
                            if (!(i && void 0 !== t && i.type !== t.type)) n.isActivated = !0, n.isProgrammatic = void 0 === t, n.activationEvent = t, n.wasActivatedByPointer = !n.isProgrammatic && void 0 !== t && ("mousedown" === t.type || "touchstart" === t.type || "pointerdown" === t.type), void 0 !== t && l.length > 0 && l.some(function(t) {
                                return e.adapter_.containsEventTarget(t);
                            }) ? this.resetActivationState_() : (void 0 !== t && (l.push(t.target), this.registerDeactivationHandlers_(t)), n.wasElementMadeActive = this.checkElementMadeActive_(t), n.wasElementMadeActive && this.animateActivation_(), requestAnimationFrame(function() {
                                l = [], n.wasElementMadeActive || void 0 === t || " " !== t.key && 32 !== t.keyCode || (n.wasElementMadeActive = e.checkElementMadeActive_(t), n.wasElementMadeActive && e.animateActivation_()), n.wasElementMadeActive || (e.activationState_ = e.defaultActivationState_());
                            }));
                        }
                    }
                }, e.prototype.checkElementMadeActive_ = function(t) {
                    return void 0 === t || "keydown" !== t.type || this.adapter_.isSurfaceActive();
                }, e.prototype.animateActivation_ = function() {
                    var t = this, n = e.strings, i = n.VAR_FG_TRANSLATE_START, a = n.VAR_FG_TRANSLATE_END, r = e.cssClasses, o = r.FG_DEACTIVATION, s = r.FG_ACTIVATION, u = e.numbers.DEACTIVATION_TIMEOUT_MS;
                    this.layoutInternal_();
                    var c = "", d = "";
                    if (!this.adapter_.isUnbounded()) {
                        var p = this.getFgTranslationCoordinates_(), l = p.startPoint, f = p.endPoint;
                        c = l.x + "px, " + l.y + "px", d = f.x + "px, " + f.y + "px";
                    }
                    this.adapter_.updateCssVariable(i, c), this.adapter_.updateCssVariable(a, d), clearTimeout(this.activationTimer_), clearTimeout(this.fgDeactivationRemovalTimer_), this.rmBoundedActivationClasses_(), this.adapter_.removeClass(o), this.adapter_.computeBoundingRect(), this.adapter_.addClass(s), this.activationTimer_ = setTimeout(function() {
                        return t.activationTimerCallback_();
                    }, u);
                }, e.prototype.getFgTranslationCoordinates_ = function() {
                    var t, e = this.activationState_, n = e.activationEvent;
                    return {
                        startPoint: t = {
                            x: (t = e.wasActivatedByPointer ? Object(c.getNormalizedEventCoords)(n, this.adapter_.getWindowPageOffset(), this.adapter_.computeBoundingRect()) : {
                                x: this.frame_.width / 2,
                                y: this.frame_.height / 2
                            }).x - this.initialSize_ / 2,
                            y: t.y - this.initialSize_ / 2
                        },
                        endPoint: {
                            x: this.frame_.width / 2 - this.initialSize_ / 2,
                            y: this.frame_.height / 2 - this.initialSize_ / 2
                        }
                    };
                }, e.prototype.runDeactivationUXLogicIfReady_ = function() {
                    var t = this, n = e.cssClasses.FG_DEACTIVATION, i = this.activationState_, a = i.hasDeactivationUXRun, r = i.isActivated;
                    (a || !r) && this.activationAnimationHasEnded_ && (this.rmBoundedActivationClasses_(), this.adapter_.addClass(n), this.fgDeactivationRemovalTimer_ = setTimeout(function() {
                        t.adapter_.removeClass(n);
                    }, u.FG_DEACTIVATION_MS));
                }, e.prototype.rmBoundedActivationClasses_ = function() {
                    var t = e.cssClasses.FG_ACTIVATION;
                    this.adapter_.removeClass(t), this.activationAnimationHasEnded_ = !1, this.adapter_.computeBoundingRect();
                }, e.prototype.resetActivationState_ = function() {
                    var t = this;
                    this.previousActivationEvent_ = this.activationState_.activationEvent, this.activationState_ = this.defaultActivationState_(), setTimeout(function() {
                        return t.previousActivationEvent_ = void 0;
                    }, e.numbers.TAP_DELAY_MS);
                }, e.prototype.deactivate_ = function() {
                    var t = this, e = this.activationState_;
                    if (e.isActivated) {
                        var n = a({}, e);
                        e.isProgrammatic ? (requestAnimationFrame(function() {
                            return t.animateDeactivation_(n);
                        }), this.resetActivationState_()) : (this.deregisterDeactivationHandlers_(), requestAnimationFrame(function() {
                            t.activationState_.hasDeactivationUXRun = !0, t.animateDeactivation_(n), t.resetActivationState_();
                        }));
                    }
                }, e.prototype.animateDeactivation_ = function(t) {
                    var e = t.wasActivatedByPointer, n = t.wasElementMadeActive;
                    (e || n) && this.runDeactivationUXLogicIfReady_();
                }, e.prototype.layoutInternal_ = function() {
                    var t = this;
                    this.frame_ = this.adapter_.computeBoundingRect();
                    var n = Math.max(this.frame_.height, this.frame_.width);
                    this.maxRadius_ = this.adapter_.isUnbounded() ? n : Math.sqrt(Math.pow(t.frame_.width, 2) + Math.pow(t.frame_.height, 2)) + e.numbers.PADDING, this.initialSize_ = Math.floor(n * e.numbers.INITIAL_ORIGIN_SCALE), this.fgScale_ = "" + this.maxRadius_ / this.initialSize_, this.updateLayoutCssVars_();
                }, e.prototype.updateLayoutCssVars_ = function() {
                    var t = e.strings, n = t.VAR_FG_SIZE, i = t.VAR_LEFT, a = t.VAR_TOP, r = t.VAR_FG_SCALE;
                    this.adapter_.updateCssVariable(n, this.initialSize_ + "px"), this.adapter_.updateCssVariable(r, this.fgScale_), this.adapter_.isUnbounded() && (this.unboundedCoords_ = {
                        left: Math.round(this.frame_.width / 2 - this.initialSize_ / 2),
                        top: Math.round(this.frame_.height / 2 - this.initialSize_ / 2)
                    }, this.adapter_.updateCssVariable(i, this.unboundedCoords_.left + "px"), this.adapter_.updateCssVariable(a, this.unboundedCoords_.top + "px"));
                }, e;
            }(r);
            e.default = f;
        },
        38: function(t, e, n) {
            "use strict";
            var i, a;
            function r(t, e) {
                void 0 === e && (e = !1);
                var n = t.CSS, a = i;
                if ("boolean" == typeof i && !e) return i;
                if (!(n && "function" == typeof n.supports)) return !1;
                var r = n.supports("--css-vars", "yes"), o = n.supports("(--css-vars: yes)") && n.supports("color", "#00000000");
                return a = !(!r && !o) && !function(t) {
                    var e = t.document, n = e.createElement("div");
                    n.className = "mdc-ripple-surface--test-edge-var-bug", e.body.appendChild(n);
                    var i = t.getComputedStyle(n), a = null !== i && "solid" === i.borderTopStyle;
                    return n.remove(), a;
                }(t), e || (i = a), a;
            }
            function o(t, e) {
                if (void 0 === t && (t = window), void 0 === e && (e = !1), void 0 === a || e) {
                    var n = !1;
                    try {
                        t.document.addEventListener("test", function() {}, {
                            get passive () {
                                return n = !0;
                            }
                        });
                    } catch (t) {}
                    a = n;
                }
                return !!a && {
                    passive: !0
                };
            }
            function s(t, e, n) {
                if (!t) return {
                    x: 0,
                    y: 0
                };
                var i, a, r = e.x, o = e.y, s = r + n.left, u = o + n.top;
                if ("touchstart" === t.type) {
                    var c = t;
                    i = c.changedTouches[0].pageX - s, a = c.changedTouches[0].pageY - u;
                } else {
                    var d = t;
                    i = d.pageX - s, a = d.pageY - u;
                }
                return {
                    x: i,
                    y: a
                };
            }
            n.r(e), n.d(e, "supportsCssVariables", function() {
                return r;
            }), n.d(e, "applyPassive", function() {
                return o;
            }), n.d(e, "getNormalizedEventCoords", function() {
                return s;
            });
        }
    });
});

});

parcelRegister("3yIjW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $6432u.default;
    }
});

var $6432u = parcelRequire("6432u");

});

parcelRegister("fRnKy", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.18.1';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("3umuy", function(module, exports) {
//! moment.js
//! version : 2.31.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidOffset: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid$2(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidOffset && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid$1(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg + '\n' + new Error().stack);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\e)|(\\)?(eHHmm|[Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        var cacheKey = '$' + format;
        if (!hasOwnProp(formatFunctions, cacheKey)) formatFunctions[cacheKey] = makeFormatFunction(format);
        return formatFunctions[cacheKey](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get$2(this, unit);
        };
    }
    function get$2(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod$1(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod$1(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord, monthsParseProperties = [
        'monthsParse',
        'longMonthsParse',
        'shortMonthsParse',
        'monthsRegex',
        'monthsShortRegex',
        'monthsStrictRegex',
        'monthsShortStrictRegex'
    ];
    function clearMonthsParseCache(locale, config) {
        var i, prop;
        for(i = 0; i < monthsParseProperties.length; i++){
            prop = monthsParseProperties[i];
            if (!hasOwnProp(config, prop)) delete locale['_' + prop];
        }
    }
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse$1(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse$1.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get$2(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    addFormatToken('eHHmm', 0, 0, function() {
        return '' + this.weekday() + zeroFill(this.hours(), 2) + zeroFill(this.minutes(), 2);
    });
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('eHHmm', match5to6);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    addWeekParseToken('eHHmm', function(input, week, config) {
        var weekdayEnd = input.length - 4;
        week.e = toInt(input.substr(0, weekdayEnd));
        config._a[HOUR] = toInt(input.substr(weekdayEnd, 2));
        config._a[MINUTE] = toInt(input.substr(weekdayEnd + 2));
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord, weekdaysParseProperties = [
        'weekdaysParse',
        'fullWeekdaysParse',
        'shortWeekdaysParse',
        'minWeekdaysParse',
        'weekdaysRegex',
        'weekdaysShortRegex',
        'weekdaysMinRegex',
        'weekdaysStrictRegex',
        'weekdaysShortStrictRegex',
        'weekdaysMinStrictRegex'
    ];
    function clearWeekdaysParseCache(locale, config) {
        var i, prop;
        for(i = 0; i < weekdaysParseProperties.length; i++){
            prop = weekdaysParseProperties[i];
            if (!hasOwnProp(config, prop)) delete locale['_' + prop];
        }
    }
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get$2(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    function set(config) {
        var prop, i;
        clearMonthsParseCache(this, config);
        clearWeekdaysParseCache(this, config);
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar$1(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()], formatCache = this._longDateFormatCache;
        if (format || !formatUpper) return format;
        if (formatCache && formatCache[key] && formatCache[key].formatUpper === formatUpper) return formatCache[key].format;
        format = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        if (!formatCache) formatCache = this._longDateFormatCache = {};
        formatCache[key] = {
            formatUpper: formatUpper,
            format: format
        };
        return format;
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTimeWithoutPostformat(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function relativeTime$1(number, withoutSuffix, string, isFuture) {
        return this.postformat(relativeTimeWithoutPostformat.call(this, number, withoutSuffix, string, isFuture));
    }
    function pastFutureWithoutPostformat(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    function pastFuture(diff, output) {
        return this.postformat(pastFutureWithoutPostformat.call(this, diff, output));
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYearFromDayOfYear(year, dayOfYear, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), week = Math.floor((dayOfYear - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = year - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(year, dow, doy)) {
            resWeek = week - weeksInYear(year, dow, doy);
            resYear = year + 1;
        } else {
            resYear = year;
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        return weekOfYearFromDayOfYear(mom.year(), mom.dayOfYear(), dow, doy);
    }
    function weekOfYearFromDate(year, month, date, dow, doy) {
        var dayOfYear = Math.round((createUTCDate(year, month, date) - createUTCDate(year, 0, 1)) / 864e5) + 1;
        return weekOfYearFromDayOfYear(year, dayOfYear, dow, doy);
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Only canonical locale module names are safe to append to the require path.
        return typeof name === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(name);
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire, normalizedName;
        // Preserve exact custom locale names before trying the canonical built-in name.
        // Use hasOwnProp rather than a plain lookup so that names like "__proto__",
        // "constructor", or "prototype" can't resolve to an inherited Object.prototype
        // property instead of a real (or missing) locale entry.
        if (hasOwnProp(locales, name)) return locales[name];
        normalizedName = normalizeLocale(name);
        if (hasOwnProp(locales, normalizedName)) return locales[normalizedName];
        // TODO: Find a better way to register and load all the locales in Node
        if (module && module.exports && isLocaleNameSane(normalizedName)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + normalizedName);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[normalizedName] = null; // null means not found
        }
        if (hasOwnProp(locales, normalizedName)) return locales[normalizedName];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        var locale, tmpLocale = loadLocale(name), parentConfig = baseConfig;
        if (tmpLocale != null) name = tmpLocale._abbr;
        if (config != null) {
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config, now, forWeek) {
        var hadWeekContext = Object.prototype.hasOwnProperty.call(config, '_isDefaultDatePartsForWeek'), weekContext = config._isDefaultDatePartsForWeek;
        // hooks is actually the exported moment object
        config._isDefaultDatePartsForWeek = !!forWeek;
        try {
            return hooks._getDefaultDateParts(config, now, forWeek);
        } finally{
            if (hadWeekContext) config._isDefaultDatePartsForWeek = weekContext;
            else delete config._isDefaultDatePartsForWeek;
        }
    }
    function currentDateNow(config) {
        var now = config._defaultDatePartsNow;
        if (!now) return hooks.now();
        if (!now.hasValue) {
            now.value = hooks.now();
            now.hasValue = true;
        }
        return now.value;
    }
    // Internal hook for extensions that supply omitted calendar fields.
    function getDefaultDateParts(config, now, forWeek) {
        var useWeekDefaults = forWeek || config._isDefaultDatePartsForWeek, nowValue = useWeekDefaults ? createLocal(now) : new Date(now);
        if (useWeekDefaults) return [
            nowValue.year(),
            nowValue.month(),
            nowValue.date()
        ];
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    hooks._getDefaultDateParts = getDefaultDateParts;
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], now, currentDate, expectedWeekday, yearToUse, dateIsDefaulted;
        if (config._d) return;
        if (config._a[YEAR] == null || config._a[MONTH] == null || config._a[DATE] == null) {
            now = currentDateNow(config);
            currentDate = currentDateArray(config, now);
        }
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config, currentDateArray(config, now, true));
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = config._a[YEAR] != null ? config._a[YEAR] : currentDate[YEAR];
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        dateIsDefaulted = config._a[YEAR] == null || config._a[MONTH] == null || config._a[DATE] == null;
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && !dateIsDefaulted && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config, currentDate) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYearFromDate(currentDate[YEAR], currentDate[MONTH], currentDate[DATE], 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYearFromDate(currentDate[YEAR], currentDate[MONTH], currentDate[DATE], dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, defaultDatePartsNow = {}, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._defaultDatePartsNow = defaultDatePartsNow;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid$2(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid$1({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid$2(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid$1();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid$1();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        for(i = 0; i < moments.length; ++i)if (isMoment(moments[i])) {
            res = moments[i];
            break;
        }
        if (!res) return createInvalid$1();
        for(++i; i < moments.length; ++i)if (isMoment(moments[i]) && (!moments[i].isValid() || moments[i][fn](res))) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        var offset = offsetFromString(matchShortOffset, input);
        config._useUTC = true;
        config._tzm = offset;
        if (offset === null) getParsingFlags(config).invalidOffset = input;
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        if (toInt(parts[2]) > 59 || (parts[0] === '+' ? minutes > 840 : minutes > 720)) return null;
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract$1(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract$1(this, dur, direction);
            return this;
        };
    }
    function addSubtract$1(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get$2(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get$2(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add$1 = createAdder(1, 'add'), subtract$1 = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone$1() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString$1(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf$1() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid() {
        return isValid$2(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto$2 = Moment.prototype;
    proto$2.add = add$1;
    proto$2.calendar = calendar;
    proto$2.clone = clone$1;
    proto$2.diff = diff;
    proto$2.endOf = endOf;
    proto$2.format = format;
    proto$2.from = from;
    proto$2.fromNow = fromNow;
    proto$2.to = to;
    proto$2.toNow = toNow;
    proto$2.get = stringGet;
    proto$2.invalidAt = invalidAt;
    proto$2.isAfter = isAfter;
    proto$2.isBefore = isBefore;
    proto$2.isBetween = isBetween;
    proto$2.isSame = isSame;
    proto$2.isSameOrAfter = isSameOrAfter;
    proto$2.isSameOrBefore = isSameOrBefore;
    proto$2.isValid = isValid;
    proto$2.lang = lang;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.max = prototypeMax;
    proto$2.min = prototypeMin;
    proto$2.parsingFlags = parsingFlags;
    proto$2.set = stringSet;
    proto$2.startOf = startOf;
    proto$2.subtract = subtract$1;
    proto$2.toArray = toArray;
    proto$2.toObject = toObject;
    proto$2.toDate = toDate;
    proto$2.toISOString = toISOString$1;
    proto$2.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto$2[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto$2.toJSON = toJSON;
    proto$2.toString = toString;
    proto$2.unix = unix;
    proto$2.valueOf = valueOf$1;
    proto$2.creationData = creationData;
    proto$2.eraName = getEraName;
    proto$2.eraNarrow = getEraNarrow;
    proto$2.eraAbbr = getEraAbbr;
    proto$2.eraYear = getEraYear;
    proto$2.year = getSetYear;
    proto$2.isLeapYear = getIsLeapYear;
    proto$2.weekYear = getSetWeekYear;
    proto$2.isoWeekYear = getSetISOWeekYear;
    proto$2.quarter = proto$2.quarters = getSetQuarter;
    proto$2.month = getSetMonth;
    proto$2.daysInMonth = getDaysInMonth;
    proto$2.week = proto$2.weeks = getSetWeek;
    proto$2.isoWeek = proto$2.isoWeeks = getSetISOWeek;
    proto$2.weeksInYear = getWeeksInYear;
    proto$2.weeksInWeekYear = getWeeksInWeekYear;
    proto$2.isoWeeksInYear = getISOWeeksInYear;
    proto$2.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto$2.date = getSetDayOfMonth;
    proto$2.day = proto$2.days = getSetDayOfWeek;
    proto$2.weekday = getSetLocaleDayOfWeek;
    proto$2.isoWeekday = getSetISODayOfWeek;
    proto$2.dayOfYear = getSetDayOfYear;
    proto$2.hour = proto$2.hours = getSetHour;
    proto$2.minute = proto$2.minutes = getSetMinute;
    proto$2.second = proto$2.seconds = getSetSecond;
    proto$2.millisecond = proto$2.milliseconds = getSetMillisecond;
    proto$2.utcOffset = getSetOffset;
    proto$2.utc = setOffsetToUTC;
    proto$2.local = setOffsetToLocal;
    proto$2.parseZone = setOffsetToParsedOffset;
    proto$2.hasAlignedHourOffset = hasAlignedHourOffset;
    proto$2.isDST = isDaylightSavingTime;
    proto$2.isLocal = isLocal;
    proto$2.isUtcOffset = isUtcOffset;
    proto$2.isUtc = isUtc;
    proto$2.isUTC = isUtc;
    proto$2.zoneAbbr = getZoneAbbr;
    proto$2.zoneName = getZoneName;
    proto$2.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto$2.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto$2.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto$2.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto$2.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar$1;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime$1;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs$1() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add(input, value) {
        return addSubtract(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract(input, value) {
        return addSubtract(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf = asMilliseconds;
    function clone() {
        return createDuration(this);
    }
    function get(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return relativeTimeWithoutPostformat.call(locale, number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = extend(extend({}, thresholds), argThresholds || {});
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime(this, !withSuffix, th, locale);
        if (withSuffix) output = pastFutureWithoutPostformat.call(locale, +this, output);
        return locale.postformat(output);
    }
    var abs = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs(this._milliseconds) / 1000, days = abs(this._days), months = abs(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto = Duration.prototype;
    proto.isValid = isValid$1;
    proto.abs = abs$1;
    proto.add = add;
    proto.subtract = subtract;
    proto.as = as;
    proto.asMilliseconds = asMilliseconds;
    proto.asSeconds = asSeconds;
    proto.asMinutes = asMinutes;
    proto.asHours = asHours;
    proto.asDays = asDays;
    proto.asWeeks = asWeeks;
    proto.asMonths = asMonths;
    proto.asQuarters = asQuarters;
    proto.asYears = asYears;
    proto.valueOf = valueOf;
    proto._bubble = bubble;
    proto.clone = clone;
    proto.get = get;
    proto.milliseconds = milliseconds;
    proto.seconds = seconds;
    proto.minutes = minutes;
    proto.hours = hours;
    proto.days = days;
    proto.weeks = weeks;
    proto.months = months;
    proto.years = years;
    proto.humanize = humanize;
    proto.toISOString = toISOString;
    proto.toString = toISOString;
    proto.toJSON = toISOString;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString);
    proto.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.31.0';
    setHookCallback(createLocal);
    hooks.fn = proto$2;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid$1;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto$2;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("8FQwk", function(module, exports) {

$parcel$export(module.exports, "FormikConsumer", function () { return FormikConsumer; });
$parcel$export(module.exports, "useFormikContext", function () { return useFormikContext; });
$parcel$export(module.exports, "Formik", function () { return Formik; });

var $8EPlH = parcelRequire("8EPlH");

var $ezNfy = parcelRequire("ezNfy");

var $8gdbO = parcelRequire("8gdbO");

var $ieT14 = parcelRequire("ieT14");

var $dOnUN = parcelRequire("dOnUN");

var $dHtmh = parcelRequire("dHtmh");

var $am4ol = parcelRequire("am4ol");

var $pFTwR = parcelRequire("pFTwR");

var $6YpfP = parcelRequire("6YpfP");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var FormikContext = /*#__PURE__*/ (0, $ieT14.createContext)(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $ieT14.useContext)(FormikContext);
    !!!formik && (0, $dHtmh.default)(false);
    return formik;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === 'function';
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $ieT14.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== 'undefined' ? document : undefined);
    if (typeof doc === 'undefined') return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $pFTwR.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
     // check if path is not in the end
    if (p !== path.length && !obj) return def;
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $am4ol.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $pFTwR.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $am4ol.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case 'SET_VALUES':
            return _extends({}, state, {
                values: msg.payload
            });
        case 'SET_TOUCHED':
            return _extends({}, state, {
                touched: msg.payload
            });
        case 'SET_ERRORS':
            if ((0, (/*@__PURE__*/$parcel$interopDefault($dOnUN)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case 'SET_STATUS':
            return _extends({}, state, {
                status: msg.payload
            });
        case 'SET_ISSUBMITTING':
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case 'SET_ISVALIDATING':
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case 'SET_FIELD_VALUE':
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_TOUCHED':
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_ERROR':
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case 'RESET_FORM':
            return _extends({}, state, msg.payload);
        case 'SET_FORMIK_STATE':
            return msg.payload(state);
        case 'SUBMIT_ATTEMPT':
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case 'SUBMIT_FAILURE':
            return _extends({}, state, {
                isSubmitting: false
            });
        case 'SUBMIT_SUCCESS':
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $ieT14.useRef)(props.initialValues);
    var initialErrors = (0, $ieT14.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $ieT14.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $ieT14.useRef)(props.initialStatus);
    var isMounted = (0, $ieT14.useRef)(false);
    var fieldRegistry = (0, $ieT14.useRef)({});
    (0, $ieT14.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useState = (0, $ieT14.useState)(0), setIteration = _React$useState[1];
    var stateRef = (0, $ieT14.useRef)({
        values: (0, $8gdbO.default)(props.initialValues),
        errors: (0, $8gdbO.default)(props.initialErrors) || emptyErrors,
        touched: (0, $8gdbO.default)(props.initialTouched) || emptyTouched,
        status: (0, $8gdbO.default)(props.initialStatus),
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    });
    var state = stateRef.current;
    var dispatch = (0, $ieT14.useCallback)(function(action) {
        var prev = stateRef.current;
        stateRef.current = formikReducer(prev, action); // force rerender
        if (prev !== stateRef.current) setIteration(function(x) {
            return x + 1;
        });
    }, []);
    var runValidateHandler = (0, $ieT14.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $ieT14.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === 'ValidationError') resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $ieT14.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $ieT14.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $ieT14.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $8EPlH.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: 'SET_ISVALIDATING',
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
                dispatch({
                    type: 'SET_ERRORS',
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $ieT14.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($dOnUN)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $ieT14.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: 'RESET_FORM',
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched,
        props.onReset
    ]);
    (0, $ieT14.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($dOnUN)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
                if (validateOnMount) validateFormWithHighPriority(initialValues.current);
            }
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $ieT14.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($dOnUN)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: 'SET_ERRORS',
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $ieT14.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($dOnUN)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: 'SET_TOUCHED',
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $ieT14.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($dOnUN)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: 'SET_STATUS',
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: 'SET_FIELD_ERROR',
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: 'SET_ISVALIDATING',
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: 'SET_ISVALIDATING',
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: getIn(error, name)
                    }
                });
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $ieT14.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $ieT14.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: 'SET_TOUCHED',
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $ieT14.useCallback)(function(errors) {
        dispatch({
            type: 'SET_ERRORS',
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: 'SET_VALUES',
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $ieT14.useCallback)(function(field, value) {
        dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        dispatch({
            type: 'SET_FIELD_VALUE',
            payload: {
                field: field,
                value: value
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
    });
    var executeChange = (0, $ieT14.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            field;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: 'SET_FIELD_TOUCHED',
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $ieT14.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        field;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $ieT14.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: 'SET_FORMIK_STATE',
            payload: stateOrCb
        });
        else dispatch({
            type: 'SET_FORMIK_STATE',
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $ieT14.useCallback)(function(status) {
        dispatch({
            type: 'SET_STATUS',
            payload: status
        });
    }, []);
    var setSubmitting = (0, $ieT14.useCallback)(function(isSubmitting) {
        dispatch({
            type: 'SET_ISSUBMITTING',
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: 'SUBMIT_ATTEMPT'
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: 'SUBMIT_SUCCESS'
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: 'SUBMIT_FAILURE'
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: 'SUBMIT_FAILURE'
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $ieT14.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $ieT14.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $ieT14.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === 'checkbox') {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === 'radio') {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === 'select' && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $ieT14.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($dOnUN)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $ieT14.useMemo)(function() {
        return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $ieT14.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $ieT14.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $ieT14.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $ieT14.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    var normalizedValues = prepareDataForValidation(values);
    return schema[sync ? 'validateSync' : 'validate'](normalizedValues, {
        abortEarly: false,
        context: context || normalizedValues
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $ezNfy.default)(value)) return prepareDataForValidation(value);
            else return value !== '' ? value : undefined;
        });
        else if ((0, $ezNfy.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== '' ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === 'undefined') {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $8EPlH.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $8EPlH.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === 'boolean') return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == 'true' || valueProp == 'false') return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $ieT14.useLayoutEffect) : (0, $ieT14.useEffect);
function useEventCallback(fn) {
    var ref = (0, $ieT14.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $ieT14.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $ieT14.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $dHtmh.default)(false);
    var fieldHelpers = (0, $ieT14.useMemo)(function() {
        return getFieldHelpers(fieldName);
    }, [
        getFieldHelpers,
        fieldName
    ]);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        fieldHelpers
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, className = _ref.className, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component",
        "className"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $ieT14.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === 'string') {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $ieT14.createElement)(component, _extends({
                ref: innerRef
            }, field, rest, {
                className: className
            }), children);
        } // We don't pass `meta` for backwards compat
        return (0, $ieT14.createElement)(component, _extends({
            field: field,
            form: formik
        }, props, {
            className: className
        }), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || 'input';
    if (typeof asElement === 'string') {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $ieT14.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest, {
            className: className
        }), children);
    }
    return (0, $ieT14.createElement)(asElement, _extends({}, field, props, {
        className: className
    }), children);
}
var Form = /*#__PURE__*/ (0, $ieT14.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : '#';
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $ieT14.createElement)("form", _extends({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = 'Form';
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(args)) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                _this.renderFormComponent = function(formikProps) {
                    return (0, $ieT14.createElement)(Component$1, _extends({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $ieT14.createElement)(Formik, _extends({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $ieT14.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($6YpfP)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $ieT14.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $dHtmh.default)(false);
            return (0, $ieT14.createElement)(Comp, _extends({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($6YpfP)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
    var fn = typeof alteration === 'function' ? alteration : defaultFunction;
    return function(data) {
        if (Array.isArray(data) || isObject(data)) {
            var clone = copyArrayLike(data);
            return fn(clone);
        } // This can be assumed to be a primitive, which
        // is a case for top level validation errors
        return data;
    };
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = createAlterationHandler(alterErrors, fn);
                var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $8gdbO.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                length = arr.length;
                return arr;
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        };
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($dOnUN)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
             // if the array only includes undefined values we have to return an empty array
            return isFunction(copy.every) ? copy.every(function(v) {
                return v === undefined;
            }) ? [] : copy : copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array.slice();
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $ieT14.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? (0, $ieT14.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $ieT14.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $ieT14.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $ieT14.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $dHtmh.default)(false);
        !!(component && render) && (0, $dHtmh.default)(false);
        !!(is && children && isFunction(children)) && (0, $dHtmh.default)(false);
        !!(component && children && isFunction(children)) && (0, $dHtmh.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $dHtmh.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === 'string') {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $ieT14.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $ieT14.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || 'input';
        if (typeof asElement === 'string') {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $ieT14.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $ieT14.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $ieT14.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("8EPlH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64d9e3f9fa8620ff$export$2e2bcd8739ae039; });
var $64d9e3f9fa8620ff$var$isMergeableObject = function isMergeableObject(value) {
    return $64d9e3f9fa8620ff$var$isNonNullObject(value) && !$64d9e3f9fa8620ff$var$isSpecial(value);
};
function $64d9e3f9fa8620ff$var$isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function $64d9e3f9fa8620ff$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $64d9e3f9fa8620ff$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $64d9e3f9fa8620ff$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var $64d9e3f9fa8620ff$var$REACT_ELEMENT_TYPE = $64d9e3f9fa8620ff$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function $64d9e3f9fa8620ff$var$isReactElement(value) {
    return value.$$typeof === $64d9e3f9fa8620ff$var$REACT_ELEMENT_TYPE;
}
function $64d9e3f9fa8620ff$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $64d9e3f9fa8620ff$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $64d9e3f9fa8620ff$var$deepmerge($64d9e3f9fa8620ff$var$emptyTarget(value), value, options) : value;
}
function $64d9e3f9fa8620ff$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $64d9e3f9fa8620ff$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $64d9e3f9fa8620ff$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $64d9e3f9fa8620ff$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $64d9e3f9fa8620ff$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $64d9e3f9fa8620ff$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $64d9e3f9fa8620ff$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $64d9e3f9fa8620ff$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $64d9e3f9fa8620ff$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $64d9e3f9fa8620ff$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $64d9e3f9fa8620ff$var$mergeObject(target, source, options);
}
$64d9e3f9fa8620ff$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $64d9e3f9fa8620ff$var$deepmerge(prev, next, options);
    }, {});
};
var $64d9e3f9fa8620ff$var$deepmerge_1 = $64d9e3f9fa8620ff$var$deepmerge;
var $64d9e3f9fa8620ff$export$2e2bcd8739ae039 = $64d9e3f9fa8620ff$var$deepmerge_1;

});

parcelRegister("ezNfy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9ca898f00dc548a$export$2e2bcd8739ae039; });

var $aOclx = parcelRequire("aOclx");

var $6BRoO = parcelRequire("6BRoO");

var $htrdJ = parcelRequire("htrdJ");
/** `Object#toString` result references. */ var $a9ca898f00dc548a$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $a9ca898f00dc548a$var$funcProto = Function.prototype, $a9ca898f00dc548a$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $a9ca898f00dc548a$var$funcToString = $a9ca898f00dc548a$var$funcProto.toString;
/** Used to check objects for own properties. */ var $a9ca898f00dc548a$var$hasOwnProperty = $a9ca898f00dc548a$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $a9ca898f00dc548a$var$objectCtorString = $a9ca898f00dc548a$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $a9ca898f00dc548a$var$isPlainObject(value) {
    if (!(0, $htrdJ.default)(value) || (0, $aOclx.default)(value) != $a9ca898f00dc548a$var$objectTag) return false;
    var proto = (0, $6BRoO.default)(value);
    if (proto === null) return true;
    var Ctor = $a9ca898f00dc548a$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $a9ca898f00dc548a$var$funcToString.call(Ctor) == $a9ca898f00dc548a$var$objectCtorString;
}
var $a9ca898f00dc548a$export$2e2bcd8739ae039 = $a9ca898f00dc548a$var$isPlainObject;

});
parcelRegister("aOclx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7de826a1d3d1f7d4$export$2e2bcd8739ae039; });

var $2rF6I = parcelRequire("2rF6I");

var $dc0x0 = parcelRequire("dc0x0");

var $donEs = parcelRequire("donEs");
/** `Object#toString` result references. */ var $7de826a1d3d1f7d4$var$nullTag = '[object Null]', $7de826a1d3d1f7d4$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $7de826a1d3d1f7d4$var$symToStringTag = (0, $2rF6I.default) ? (0, $2rF6I.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $7de826a1d3d1f7d4$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $7de826a1d3d1f7d4$var$undefinedTag : $7de826a1d3d1f7d4$var$nullTag;
    return $7de826a1d3d1f7d4$var$symToStringTag && $7de826a1d3d1f7d4$var$symToStringTag in Object(value) ? (0, $dc0x0.default)(value) : (0, $donEs.default)(value);
}
var $7de826a1d3d1f7d4$export$2e2bcd8739ae039 = $7de826a1d3d1f7d4$var$baseGetTag;

});
parcelRegister("2rF6I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c7dfd7367d1cfb0$export$2e2bcd8739ae039; });

var $3Ij6y = parcelRequire("3Ij6y");
/** Built-in value references. */ var $1c7dfd7367d1cfb0$var$Symbol = (0, $3Ij6y.default).Symbol;
var $1c7dfd7367d1cfb0$export$2e2bcd8739ae039 = $1c7dfd7367d1cfb0$var$Symbol;

});
parcelRegister("3Ij6y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b444cfaea4a273b$export$2e2bcd8739ae039; });

var $7mT7T = parcelRequire("7mT7T");
/** Detect free variable `self`. */ var $2b444cfaea4a273b$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $2b444cfaea4a273b$var$root = (0, $7mT7T.default) || $2b444cfaea4a273b$var$freeSelf || Function('return this')();
var $2b444cfaea4a273b$export$2e2bcd8739ae039 = $2b444cfaea4a273b$var$root;

});
parcelRegister("7mT7T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55d55965f197713e$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $55d55965f197713e$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $55d55965f197713e$export$2e2bcd8739ae039 = $55d55965f197713e$var$freeGlobal;

});



parcelRegister("dc0x0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99accee39cea537a$export$2e2bcd8739ae039; });

var $2rF6I = parcelRequire("2rF6I");
/** Used for built-in method references. */ var $99accee39cea537a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $99accee39cea537a$var$hasOwnProperty = $99accee39cea537a$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $99accee39cea537a$var$nativeObjectToString = $99accee39cea537a$var$objectProto.toString;
/** Built-in value references. */ var $99accee39cea537a$var$symToStringTag = (0, $2rF6I.default) ? (0, $2rF6I.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $99accee39cea537a$var$getRawTag(value) {
    var isOwn = $99accee39cea537a$var$hasOwnProperty.call(value, $99accee39cea537a$var$symToStringTag), tag = value[$99accee39cea537a$var$symToStringTag];
    try {
        value[$99accee39cea537a$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $99accee39cea537a$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$99accee39cea537a$var$symToStringTag] = tag;
        else delete value[$99accee39cea537a$var$symToStringTag];
    }
    return result;
}
var $99accee39cea537a$export$2e2bcd8739ae039 = $99accee39cea537a$var$getRawTag;

});

parcelRegister("donEs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9bffdcf3a33e124e$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $9bffdcf3a33e124e$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $9bffdcf3a33e124e$var$nativeObjectToString = $9bffdcf3a33e124e$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $9bffdcf3a33e124e$var$objectToString(value) {
    return $9bffdcf3a33e124e$var$nativeObjectToString.call(value);
}
var $9bffdcf3a33e124e$export$2e2bcd8739ae039 = $9bffdcf3a33e124e$var$objectToString;

});


parcelRegister("6BRoO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cff9ebfa9b0a78d$export$2e2bcd8739ae039; });

var $kK46S = parcelRequire("kK46S");
/** Built-in value references. */ var $4cff9ebfa9b0a78d$var$getPrototype = (0, $kK46S.default)(Object.getPrototypeOf, Object);
var $4cff9ebfa9b0a78d$export$2e2bcd8739ae039 = $4cff9ebfa9b0a78d$var$getPrototype;

});
parcelRegister("kK46S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f19b4aa7c9b16850$export$2e2bcd8739ae039; });
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $f19b4aa7c9b16850$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $f19b4aa7c9b16850$export$2e2bcd8739ae039 = $f19b4aa7c9b16850$var$overArg;

});


parcelRegister("htrdJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb8a4287d6ccc07f$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $cb8a4287d6ccc07f$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $cb8a4287d6ccc07f$export$2e2bcd8739ae039 = $cb8a4287d6ccc07f$var$isObjectLike;

});


parcelRegister("8gdbO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $603a0c8132884673$export$2e2bcd8739ae039; });

var $h4J7V = parcelRequire("h4J7V");
/** Used to compose bitmasks for cloning. */ var $603a0c8132884673$var$CLONE_DEEP_FLAG = 1, $603a0c8132884673$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $603a0c8132884673$var$cloneDeep(value) {
    return (0, $h4J7V.default)(value, $603a0c8132884673$var$CLONE_DEEP_FLAG | $603a0c8132884673$var$CLONE_SYMBOLS_FLAG);
}
var $603a0c8132884673$export$2e2bcd8739ae039 = $603a0c8132884673$var$cloneDeep;

});
parcelRegister("h4J7V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6e5d0a94eb47096$export$2e2bcd8739ae039; });

var $3Kdys = parcelRequire("3Kdys");

var $7XPtO = parcelRequire("7XPtO");

var $cH5El = parcelRequire("cH5El");

var $fJzij = parcelRequire("fJzij");

var $53Goz = parcelRequire("53Goz");

var $aXBGR = parcelRequire("aXBGR");

var $jAo82 = parcelRequire("jAo82");

var $2hfo0 = parcelRequire("2hfo0");

var $k2Gbx = parcelRequire("k2Gbx");

var $bEDOD = parcelRequire("bEDOD");

var $9VO6F = parcelRequire("9VO6F");

var $3g10V = parcelRequire("3g10V");

var $6kMii = parcelRequire("6kMii");

var $9meY7 = parcelRequire("9meY7");

var $i7XTz = parcelRequire("i7XTz");

var $gWMuS = parcelRequire("gWMuS");

var $97TKc = parcelRequire("97TKc");

var $j8aPM = parcelRequire("j8aPM");

var $ewHgJ = parcelRequire("ewHgJ");

var $1LTMZ = parcelRequire("1LTMZ");

var $5J6u5 = parcelRequire("5J6u5");

var $iVZ3k = parcelRequire("iVZ3k");
/** Used to compose bitmasks for cloning. */ var $c6e5d0a94eb47096$var$CLONE_DEEP_FLAG = 1, $c6e5d0a94eb47096$var$CLONE_FLAT_FLAG = 2, $c6e5d0a94eb47096$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $c6e5d0a94eb47096$var$argsTag = '[object Arguments]', $c6e5d0a94eb47096$var$arrayTag = '[object Array]', $c6e5d0a94eb47096$var$boolTag = '[object Boolean]', $c6e5d0a94eb47096$var$dateTag = '[object Date]', $c6e5d0a94eb47096$var$errorTag = '[object Error]', $c6e5d0a94eb47096$var$funcTag = '[object Function]', $c6e5d0a94eb47096$var$genTag = '[object GeneratorFunction]', $c6e5d0a94eb47096$var$mapTag = '[object Map]', $c6e5d0a94eb47096$var$numberTag = '[object Number]', $c6e5d0a94eb47096$var$objectTag = '[object Object]', $c6e5d0a94eb47096$var$regexpTag = '[object RegExp]', $c6e5d0a94eb47096$var$setTag = '[object Set]', $c6e5d0a94eb47096$var$stringTag = '[object String]', $c6e5d0a94eb47096$var$symbolTag = '[object Symbol]', $c6e5d0a94eb47096$var$weakMapTag = '[object WeakMap]';
var $c6e5d0a94eb47096$var$arrayBufferTag = '[object ArrayBuffer]', $c6e5d0a94eb47096$var$dataViewTag = '[object DataView]', $c6e5d0a94eb47096$var$float32Tag = '[object Float32Array]', $c6e5d0a94eb47096$var$float64Tag = '[object Float64Array]', $c6e5d0a94eb47096$var$int8Tag = '[object Int8Array]', $c6e5d0a94eb47096$var$int16Tag = '[object Int16Array]', $c6e5d0a94eb47096$var$int32Tag = '[object Int32Array]', $c6e5d0a94eb47096$var$uint8Tag = '[object Uint8Array]', $c6e5d0a94eb47096$var$uint8ClampedTag = '[object Uint8ClampedArray]', $c6e5d0a94eb47096$var$uint16Tag = '[object Uint16Array]', $c6e5d0a94eb47096$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $c6e5d0a94eb47096$var$cloneableTags = {};
$c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$argsTag] = $c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$arrayTag] = $c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$arrayBufferTag] = $c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$dataViewTag] = $c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$boolTag] = $c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$dateTag] = $c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$float32Tag] = $c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$float64Tag] = $c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$int8Tag] = $c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$int16Tag] = $c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$int32Tag] = $c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$mapTag] = $c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$numberTag] = $c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$objectTag] = $c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$regexpTag] = $c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$setTag] = $c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$stringTag] = $c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$symbolTag] = $c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$uint8Tag] = $c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$uint8ClampedTag] = $c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$uint16Tag] = $c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$uint32Tag] = true;
$c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$errorTag] = $c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$funcTag] = $c6e5d0a94eb47096$var$cloneableTags[$c6e5d0a94eb47096$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $c6e5d0a94eb47096$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $c6e5d0a94eb47096$var$CLONE_DEEP_FLAG, isFlat = bitmask & $c6e5d0a94eb47096$var$CLONE_FLAT_FLAG, isFull = bitmask & $c6e5d0a94eb47096$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $ewHgJ.default)(value)) return value;
    var isArr = (0, $gWMuS.default)(value);
    if (isArr) {
        result = (0, $6kMii.default)(value);
        if (!isDeep) return (0, $jAo82.default)(value, result);
    } else {
        var tag = (0, $3g10V.default)(value), isFunc = tag == $c6e5d0a94eb47096$var$funcTag || tag == $c6e5d0a94eb47096$var$genTag;
        if ((0, $97TKc.default)(value)) return (0, $aXBGR.default)(value, isDeep);
        if (tag == $c6e5d0a94eb47096$var$objectTag || tag == $c6e5d0a94eb47096$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $i7XTz.default)(value);
            if (!isDeep) return isFlat ? (0, $k2Gbx.default)(value, (0, $53Goz.default)(result, value)) : (0, $2hfo0.default)(value, (0, $fJzij.default)(result, value));
        } else {
            if (!$c6e5d0a94eb47096$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $9meY7.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $3Kdys.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $1LTMZ.default)(value)) value.forEach(function(subValue) {
        result.add($c6e5d0a94eb47096$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $j8aPM.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $c6e5d0a94eb47096$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $9VO6F.default) : (0, $bEDOD.default) : isFlat ? (0, $iVZ3k.default) : (0, $5J6u5.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $7XPtO.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $cH5El.default)(result, key, $c6e5d0a94eb47096$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $c6e5d0a94eb47096$export$2e2bcd8739ae039 = $c6e5d0a94eb47096$var$baseClone;

});
parcelRegister("3Kdys", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ba02eae9f382b1f$export$2e2bcd8739ae039; });

var $fmJtf = parcelRequire("fmJtf");

var $i59QJ = parcelRequire("i59QJ");

var $lNfhD = parcelRequire("lNfhD");

var $fFuGJ = parcelRequire("fFuGJ");

var $1b5Q1 = parcelRequire("1b5Q1");

var $8tMR3 = parcelRequire("8tMR3");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $2ba02eae9f382b1f$var$Stack(entries) {
    var data = this.__data__ = new (0, $fmJtf.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$2ba02eae9f382b1f$var$Stack.prototype.clear = (0, $i59QJ.default);
$2ba02eae9f382b1f$var$Stack.prototype['delete'] = (0, $lNfhD.default);
$2ba02eae9f382b1f$var$Stack.prototype.get = (0, $fFuGJ.default);
$2ba02eae9f382b1f$var$Stack.prototype.has = (0, $1b5Q1.default);
$2ba02eae9f382b1f$var$Stack.prototype.set = (0, $8tMR3.default);
var $2ba02eae9f382b1f$export$2e2bcd8739ae039 = $2ba02eae9f382b1f$var$Stack;

});
parcelRegister("fmJtf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2fc2e9b0d98dbcd$export$2e2bcd8739ae039; });

var $kvooW = parcelRequire("kvooW");

var $70JHs = parcelRequire("70JHs");

var $2LRxA = parcelRequire("2LRxA");

var $oRwLW = parcelRequire("oRwLW");

var $bN34T = parcelRequire("bN34T");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $b2fc2e9b0d98dbcd$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$b2fc2e9b0d98dbcd$var$ListCache.prototype.clear = (0, $kvooW.default);
$b2fc2e9b0d98dbcd$var$ListCache.prototype['delete'] = (0, $70JHs.default);
$b2fc2e9b0d98dbcd$var$ListCache.prototype.get = (0, $2LRxA.default);
$b2fc2e9b0d98dbcd$var$ListCache.prototype.has = (0, $oRwLW.default);
$b2fc2e9b0d98dbcd$var$ListCache.prototype.set = (0, $bN34T.default);
var $b2fc2e9b0d98dbcd$export$2e2bcd8739ae039 = $b2fc2e9b0d98dbcd$var$ListCache;

});
parcelRegister("kvooW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eed9a17e970a48a9$export$2e2bcd8739ae039; });
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $eed9a17e970a48a9$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $eed9a17e970a48a9$export$2e2bcd8739ae039 = $eed9a17e970a48a9$var$listCacheClear;

});

parcelRegister("70JHs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51abfb8decfe0928$export$2e2bcd8739ae039; });

var $7866J = parcelRequire("7866J");
/** Used for built-in method references. */ var $51abfb8decfe0928$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $51abfb8decfe0928$var$splice = $51abfb8decfe0928$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $51abfb8decfe0928$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $7866J.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $51abfb8decfe0928$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $51abfb8decfe0928$export$2e2bcd8739ae039 = $51abfb8decfe0928$var$listCacheDelete;

});
parcelRegister("7866J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $530e049ee467271c$export$2e2bcd8739ae039; });

var $8fgm0 = parcelRequire("8fgm0");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $530e049ee467271c$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $8fgm0.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $530e049ee467271c$export$2e2bcd8739ae039 = $530e049ee467271c$var$assocIndexOf;

});
parcelRegister("8fgm0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $600c69026dd8a7d5$export$2e2bcd8739ae039; });
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $600c69026dd8a7d5$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $600c69026dd8a7d5$export$2e2bcd8739ae039 = $600c69026dd8a7d5$var$eq;

});



parcelRegister("2LRxA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2049809e43e890d2$export$2e2bcd8739ae039; });

var $7866J = parcelRequire("7866J");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $2049809e43e890d2$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $7866J.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $2049809e43e890d2$export$2e2bcd8739ae039 = $2049809e43e890d2$var$listCacheGet;

});

parcelRegister("oRwLW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04abc377f9948803$export$2e2bcd8739ae039; });

var $7866J = parcelRequire("7866J");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $04abc377f9948803$var$listCacheHas(key) {
    return (0, $7866J.default)(this.__data__, key) > -1;
}
var $04abc377f9948803$export$2e2bcd8739ae039 = $04abc377f9948803$var$listCacheHas;

});

parcelRegister("bN34T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8956a87ffd59a92f$export$2e2bcd8739ae039; });

var $7866J = parcelRequire("7866J");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $8956a87ffd59a92f$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $7866J.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $8956a87ffd59a92f$export$2e2bcd8739ae039 = $8956a87ffd59a92f$var$listCacheSet;

});


parcelRegister("i59QJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2a05582f1671378$export$2e2bcd8739ae039; });

var $fmJtf = parcelRequire("fmJtf");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $d2a05582f1671378$var$stackClear() {
    this.__data__ = new (0, $fmJtf.default);
    this.size = 0;
}
var $d2a05582f1671378$export$2e2bcd8739ae039 = $d2a05582f1671378$var$stackClear;

});

parcelRegister("lNfhD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdda078e9ff5d25c$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $fdda078e9ff5d25c$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $fdda078e9ff5d25c$export$2e2bcd8739ae039 = $fdda078e9ff5d25c$var$stackDelete;

});

parcelRegister("fFuGJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6827d6804c280a0$export$2e2bcd8739ae039; });
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b6827d6804c280a0$var$stackGet(key) {
    return this.__data__.get(key);
}
var $b6827d6804c280a0$export$2e2bcd8739ae039 = $b6827d6804c280a0$var$stackGet;

});

parcelRegister("1b5Q1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0dbb58d7eb51a32a$export$2e2bcd8739ae039; });
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0dbb58d7eb51a32a$var$stackHas(key) {
    return this.__data__.has(key);
}
var $0dbb58d7eb51a32a$export$2e2bcd8739ae039 = $0dbb58d7eb51a32a$var$stackHas;

});

parcelRegister("8tMR3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62c6edb66e25fa33$export$2e2bcd8739ae039; });

var $fmJtf = parcelRequire("fmJtf");

var $9i3mU = parcelRequire("9i3mU");

var $8yqDV = parcelRequire("8yqDV");
/** Used as the size to enable large array optimizations. */ var $62c6edb66e25fa33$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $62c6edb66e25fa33$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $fmJtf.default)) {
        var pairs = data.__data__;
        if (!(0, $9i3mU.default) || pairs.length < $62c6edb66e25fa33$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $8yqDV.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $62c6edb66e25fa33$export$2e2bcd8739ae039 = $62c6edb66e25fa33$var$stackSet;

});
parcelRegister("9i3mU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c3868694cd4504b$export$2e2bcd8739ae039; });

var $aenjD = parcelRequire("aenjD");

var $3Ij6y = parcelRequire("3Ij6y");
/* Built-in method references that are verified to be native. */ var $6c3868694cd4504b$var$Map = (0, $aenjD.default)((0, $3Ij6y.default), 'Map');
var $6c3868694cd4504b$export$2e2bcd8739ae039 = $6c3868694cd4504b$var$Map;

});
parcelRegister("aenjD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $772d4c2f8f7944b6$export$2e2bcd8739ae039; });

var $9voy9 = parcelRequire("9voy9");

var $cc9vT = parcelRequire("cc9vT");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $772d4c2f8f7944b6$var$getNative(object, key) {
    var value = (0, $cc9vT.default)(object, key);
    return (0, $9voy9.default)(value) ? value : undefined;
}
var $772d4c2f8f7944b6$export$2e2bcd8739ae039 = $772d4c2f8f7944b6$var$getNative;

});
parcelRegister("9voy9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6eba0d686068aeaa$export$2e2bcd8739ae039; });

var $1YX81 = parcelRequire("1YX81");

var $lcDO9 = parcelRequire("lcDO9");

var $ewHgJ = parcelRequire("ewHgJ");

var $47kku = parcelRequire("47kku");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $6eba0d686068aeaa$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $6eba0d686068aeaa$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $6eba0d686068aeaa$var$funcProto = Function.prototype, $6eba0d686068aeaa$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $6eba0d686068aeaa$var$funcToString = $6eba0d686068aeaa$var$funcProto.toString;
/** Used to check objects for own properties. */ var $6eba0d686068aeaa$var$hasOwnProperty = $6eba0d686068aeaa$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $6eba0d686068aeaa$var$reIsNative = RegExp('^' + $6eba0d686068aeaa$var$funcToString.call($6eba0d686068aeaa$var$hasOwnProperty).replace($6eba0d686068aeaa$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $6eba0d686068aeaa$var$baseIsNative(value) {
    if (!(0, $ewHgJ.default)(value) || (0, $lcDO9.default)(value)) return false;
    var pattern = (0, $1YX81.default)(value) ? $6eba0d686068aeaa$var$reIsNative : $6eba0d686068aeaa$var$reIsHostCtor;
    return pattern.test((0, $47kku.default)(value));
}
var $6eba0d686068aeaa$export$2e2bcd8739ae039 = $6eba0d686068aeaa$var$baseIsNative;

});
parcelRegister("1YX81", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $171942b8c3c99a6f$export$2e2bcd8739ae039; });

var $aOclx = parcelRequire("aOclx");

var $ewHgJ = parcelRequire("ewHgJ");
/** `Object#toString` result references. */ var $171942b8c3c99a6f$var$asyncTag = '[object AsyncFunction]', $171942b8c3c99a6f$var$funcTag = '[object Function]', $171942b8c3c99a6f$var$genTag = '[object GeneratorFunction]', $171942b8c3c99a6f$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $171942b8c3c99a6f$var$isFunction(value) {
    if (!(0, $ewHgJ.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $aOclx.default)(value);
    return tag == $171942b8c3c99a6f$var$funcTag || tag == $171942b8c3c99a6f$var$genTag || tag == $171942b8c3c99a6f$var$asyncTag || tag == $171942b8c3c99a6f$var$proxyTag;
}
var $171942b8c3c99a6f$export$2e2bcd8739ae039 = $171942b8c3c99a6f$var$isFunction;

});
parcelRegister("ewHgJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9359e217936ae7b$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $a9359e217936ae7b$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $a9359e217936ae7b$export$2e2bcd8739ae039 = $a9359e217936ae7b$var$isObject;

});


parcelRegister("lcDO9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6f998f84943bffe$export$2e2bcd8739ae039; });

var $cN3Rs = parcelRequire("cN3Rs");
/** Used to detect methods masquerading as native. */ var $f6f998f84943bffe$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $cN3Rs.default) && (0, $cN3Rs.default).keys && (0, $cN3Rs.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $f6f998f84943bffe$var$isMasked(func) {
    return !!$f6f998f84943bffe$var$maskSrcKey && $f6f998f84943bffe$var$maskSrcKey in func;
}
var $f6f998f84943bffe$export$2e2bcd8739ae039 = $f6f998f84943bffe$var$isMasked;

});
parcelRegister("cN3Rs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94fd0e6a230c5636$export$2e2bcd8739ae039; });

var $3Ij6y = parcelRequire("3Ij6y");
/** Used to detect overreaching core-js shims. */ var $94fd0e6a230c5636$var$coreJsData = (0, $3Ij6y.default)['__core-js_shared__'];
var $94fd0e6a230c5636$export$2e2bcd8739ae039 = $94fd0e6a230c5636$var$coreJsData;

});


parcelRegister("47kku", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ff795e502a39d30$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $2ff795e502a39d30$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $2ff795e502a39d30$var$funcToString = $2ff795e502a39d30$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $2ff795e502a39d30$var$toSource(func) {
    if (func != null) {
        try {
            return $2ff795e502a39d30$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $2ff795e502a39d30$export$2e2bcd8739ae039 = $2ff795e502a39d30$var$toSource;

});


parcelRegister("cc9vT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e0dfc2ce9b1d3b4$export$2e2bcd8739ae039; });
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $8e0dfc2ce9b1d3b4$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $8e0dfc2ce9b1d3b4$export$2e2bcd8739ae039 = $8e0dfc2ce9b1d3b4$var$getValue;

});



parcelRegister("8yqDV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63a62a75c889281e$export$2e2bcd8739ae039; });

var $f0alU = parcelRequire("f0alU");

var $3Az8h = parcelRequire("3Az8h");

var $dAkeh = parcelRequire("dAkeh");

var $4QlY9 = parcelRequire("4QlY9");

var $3guej = parcelRequire("3guej");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $63a62a75c889281e$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$63a62a75c889281e$var$MapCache.prototype.clear = (0, $f0alU.default);
$63a62a75c889281e$var$MapCache.prototype['delete'] = (0, $3Az8h.default);
$63a62a75c889281e$var$MapCache.prototype.get = (0, $dAkeh.default);
$63a62a75c889281e$var$MapCache.prototype.has = (0, $4QlY9.default);
$63a62a75c889281e$var$MapCache.prototype.set = (0, $3guej.default);
var $63a62a75c889281e$export$2e2bcd8739ae039 = $63a62a75c889281e$var$MapCache;

});
parcelRegister("f0alU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aebee2da44b15064$export$2e2bcd8739ae039; });

var $64Q0V = parcelRequire("64Q0V");

var $fmJtf = parcelRequire("fmJtf");

var $9i3mU = parcelRequire("9i3mU");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $aebee2da44b15064$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $64Q0V.default),
        'map': new ((0, $9i3mU.default) || (0, $fmJtf.default)),
        'string': new (0, $64Q0V.default)
    };
}
var $aebee2da44b15064$export$2e2bcd8739ae039 = $aebee2da44b15064$var$mapCacheClear;

});
parcelRegister("64Q0V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46cb76abee0b36ed$export$2e2bcd8739ae039; });

var $5fLEo = parcelRequire("5fLEo");

var $6f3S0 = parcelRequire("6f3S0");

var $fZKkg = parcelRequire("fZKkg");

var $a6XEX = parcelRequire("a6XEX");

var $9TYLA = parcelRequire("9TYLA");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $46cb76abee0b36ed$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$46cb76abee0b36ed$var$Hash.prototype.clear = (0, $5fLEo.default);
$46cb76abee0b36ed$var$Hash.prototype['delete'] = (0, $6f3S0.default);
$46cb76abee0b36ed$var$Hash.prototype.get = (0, $fZKkg.default);
$46cb76abee0b36ed$var$Hash.prototype.has = (0, $a6XEX.default);
$46cb76abee0b36ed$var$Hash.prototype.set = (0, $9TYLA.default);
var $46cb76abee0b36ed$export$2e2bcd8739ae039 = $46cb76abee0b36ed$var$Hash;

});
parcelRegister("5fLEo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d3350d7c84517c0$export$2e2bcd8739ae039; });

var $ddbTs = parcelRequire("ddbTs");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $3d3350d7c84517c0$var$hashClear() {
    this.__data__ = (0, $ddbTs.default) ? (0, $ddbTs.default)(null) : {};
    this.size = 0;
}
var $3d3350d7c84517c0$export$2e2bcd8739ae039 = $3d3350d7c84517c0$var$hashClear;

});
parcelRegister("ddbTs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99e5b70c817457a3$export$2e2bcd8739ae039; });

var $aenjD = parcelRequire("aenjD");
/* Built-in method references that are verified to be native. */ var $99e5b70c817457a3$var$nativeCreate = (0, $aenjD.default)(Object, 'create');
var $99e5b70c817457a3$export$2e2bcd8739ae039 = $99e5b70c817457a3$var$nativeCreate;

});


parcelRegister("6f3S0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48b7254b41dbd7b4$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $48b7254b41dbd7b4$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $48b7254b41dbd7b4$export$2e2bcd8739ae039 = $48b7254b41dbd7b4$var$hashDelete;

});

parcelRegister("fZKkg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba507cde2461ab46$export$2e2bcd8739ae039; });

var $ddbTs = parcelRequire("ddbTs");
/** Used to stand-in for `undefined` hash values. */ var $ba507cde2461ab46$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $ba507cde2461ab46$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ba507cde2461ab46$var$hasOwnProperty = $ba507cde2461ab46$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba507cde2461ab46$var$hashGet(key) {
    var data = this.__data__;
    if (0, $ddbTs.default) {
        var result = data[key];
        return result === $ba507cde2461ab46$var$HASH_UNDEFINED ? undefined : result;
    }
    return $ba507cde2461ab46$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $ba507cde2461ab46$export$2e2bcd8739ae039 = $ba507cde2461ab46$var$hashGet;

});

parcelRegister("a6XEX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75c8be152f22b513$export$2e2bcd8739ae039; });

var $ddbTs = parcelRequire("ddbTs");
/** Used for built-in method references. */ var $75c8be152f22b513$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $75c8be152f22b513$var$hasOwnProperty = $75c8be152f22b513$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $75c8be152f22b513$var$hashHas(key) {
    var data = this.__data__;
    return (0, $ddbTs.default) ? data[key] !== undefined : $75c8be152f22b513$var$hasOwnProperty.call(data, key);
}
var $75c8be152f22b513$export$2e2bcd8739ae039 = $75c8be152f22b513$var$hashHas;

});

parcelRegister("9TYLA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7358630f12247e51$export$2e2bcd8739ae039; });

var $ddbTs = parcelRequire("ddbTs");
/** Used to stand-in for `undefined` hash values. */ var $7358630f12247e51$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $7358630f12247e51$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $ddbTs.default) && value === undefined ? $7358630f12247e51$var$HASH_UNDEFINED : value;
    return this;
}
var $7358630f12247e51$export$2e2bcd8739ae039 = $7358630f12247e51$var$hashSet;

});



parcelRegister("3Az8h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29cffc80cfe1c9c5$export$2e2bcd8739ae039; });

var $jDPP6 = parcelRequire("jDPP6");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $29cffc80cfe1c9c5$var$mapCacheDelete(key) {
    var result = (0, $jDPP6.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $29cffc80cfe1c9c5$export$2e2bcd8739ae039 = $29cffc80cfe1c9c5$var$mapCacheDelete;

});
parcelRegister("jDPP6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4c9dbd9f965c2f5$export$2e2bcd8739ae039; });

var $hjnWx = parcelRequire("hjnWx");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $e4c9dbd9f965c2f5$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $hjnWx.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $e4c9dbd9f965c2f5$export$2e2bcd8739ae039 = $e4c9dbd9f965c2f5$var$getMapData;

});
parcelRegister("hjnWx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9a6c8a5ec320dc3$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $c9a6c8a5ec320dc3$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $c9a6c8a5ec320dc3$export$2e2bcd8739ae039 = $c9a6c8a5ec320dc3$var$isKeyable;

});



parcelRegister("dAkeh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e3e544090cd20e9$export$2e2bcd8739ae039; });

var $jDPP6 = parcelRequire("jDPP6");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $9e3e544090cd20e9$var$mapCacheGet(key) {
    return (0, $jDPP6.default)(this, key).get(key);
}
var $9e3e544090cd20e9$export$2e2bcd8739ae039 = $9e3e544090cd20e9$var$mapCacheGet;

});

parcelRegister("4QlY9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $386d0f60383d1ba5$export$2e2bcd8739ae039; });

var $jDPP6 = parcelRequire("jDPP6");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $386d0f60383d1ba5$var$mapCacheHas(key) {
    return (0, $jDPP6.default)(this, key).has(key);
}
var $386d0f60383d1ba5$export$2e2bcd8739ae039 = $386d0f60383d1ba5$var$mapCacheHas;

});

parcelRegister("3guej", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $260a50bb85754b6b$export$2e2bcd8739ae039; });

var $jDPP6 = parcelRequire("jDPP6");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $260a50bb85754b6b$var$mapCacheSet(key, value) {
    var data = (0, $jDPP6.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $260a50bb85754b6b$export$2e2bcd8739ae039 = $260a50bb85754b6b$var$mapCacheSet;

});




parcelRegister("7XPtO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5cc5f9ec59ec4af1$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $5cc5f9ec59ec4af1$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $5cc5f9ec59ec4af1$export$2e2bcd8739ae039 = $5cc5f9ec59ec4af1$var$arrayEach;

});

parcelRegister("cH5El", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93dde214e59fd3c5$export$2e2bcd8739ae039; });

var $aFuC1 = parcelRequire("aFuC1");

var $8fgm0 = parcelRequire("8fgm0");
/** Used for built-in method references. */ var $93dde214e59fd3c5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $93dde214e59fd3c5$var$hasOwnProperty = $93dde214e59fd3c5$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $93dde214e59fd3c5$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($93dde214e59fd3c5$var$hasOwnProperty.call(object, key) && (0, $8fgm0.default)(objValue, value)) || value === undefined && !(key in object)) (0, $aFuC1.default)(object, key, value);
}
var $93dde214e59fd3c5$export$2e2bcd8739ae039 = $93dde214e59fd3c5$var$assignValue;

});
parcelRegister("aFuC1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c457aaf8b9b0457$export$2e2bcd8739ae039; });

var $64Pso = parcelRequire("64Pso");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $7c457aaf8b9b0457$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $64Pso.default)) (0, $64Pso.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $7c457aaf8b9b0457$export$2e2bcd8739ae039 = $7c457aaf8b9b0457$var$baseAssignValue;

});
parcelRegister("64Pso", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46cb080d6475753e$export$2e2bcd8739ae039; });

var $aenjD = parcelRequire("aenjD");
var $46cb080d6475753e$var$defineProperty = function() {
    try {
        var func = (0, $aenjD.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $46cb080d6475753e$export$2e2bcd8739ae039 = $46cb080d6475753e$var$defineProperty;

});



parcelRegister("fJzij", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7466fb44c3a8a88$export$2e2bcd8739ae039; });

var $8eT7Q = parcelRequire("8eT7Q");

var $5J6u5 = parcelRequire("5J6u5");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $b7466fb44c3a8a88$var$baseAssign(object, source) {
    return object && (0, $8eT7Q.default)(source, (0, $5J6u5.default)(source), object);
}
var $b7466fb44c3a8a88$export$2e2bcd8739ae039 = $b7466fb44c3a8a88$var$baseAssign;

});
parcelRegister("8eT7Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ffa645557b2ea24$export$2e2bcd8739ae039; });

var $cH5El = parcelRequire("cH5El");

var $aFuC1 = parcelRequire("aFuC1");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $5ffa645557b2ea24$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $aFuC1.default)(object, key, newValue);
        else (0, $cH5El.default)(object, key, newValue);
    }
    return object;
}
var $5ffa645557b2ea24$export$2e2bcd8739ae039 = $5ffa645557b2ea24$var$copyObject;

});

parcelRegister("5J6u5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42b62f5eb6b61485$export$2e2bcd8739ae039; });

var $7r63J = parcelRequire("7r63J");

var $dlwcA = parcelRequire("dlwcA");

var $7N4fd = parcelRequire("7N4fd");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $42b62f5eb6b61485$var$keys(object) {
    return (0, $7N4fd.default)(object) ? (0, $7r63J.default)(object) : (0, $dlwcA.default)(object);
}
var $42b62f5eb6b61485$export$2e2bcd8739ae039 = $42b62f5eb6b61485$var$keys;

});
parcelRegister("7r63J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $569fc13b4d2c3d7a$export$2e2bcd8739ae039; });

var $dRAwd = parcelRequire("dRAwd");

var $8EmDt = parcelRequire("8EmDt");

var $gWMuS = parcelRequire("gWMuS");

var $97TKc = parcelRequire("97TKc");

var $cuKQh = parcelRequire("cuKQh");

var $4l6UB = parcelRequire("4l6UB");
/** Used for built-in method references. */ var $569fc13b4d2c3d7a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $569fc13b4d2c3d7a$var$hasOwnProperty = $569fc13b4d2c3d7a$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $569fc13b4d2c3d7a$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $gWMuS.default)(value), isArg = !isArr && (0, $8EmDt.default)(value), isBuff = !isArr && !isArg && (0, $97TKc.default)(value), isType = !isArr && !isArg && !isBuff && (0, $4l6UB.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $dRAwd.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $569fc13b4d2c3d7a$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $cuKQh.default)(key, length)))) result.push(key);
    return result;
}
var $569fc13b4d2c3d7a$export$2e2bcd8739ae039 = $569fc13b4d2c3d7a$var$arrayLikeKeys;

});
parcelRegister("dRAwd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a17c8d6b9ff5bf47$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $a17c8d6b9ff5bf47$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $a17c8d6b9ff5bf47$export$2e2bcd8739ae039 = $a17c8d6b9ff5bf47$var$baseTimes;

});

parcelRegister("8EmDt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64c39e1f5626f62f$export$2e2bcd8739ae039; });

var $bBa9H = parcelRequire("bBa9H");

var $htrdJ = parcelRequire("htrdJ");
/** Used for built-in method references. */ var $64c39e1f5626f62f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64c39e1f5626f62f$var$hasOwnProperty = $64c39e1f5626f62f$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $64c39e1f5626f62f$var$propertyIsEnumerable = $64c39e1f5626f62f$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $64c39e1f5626f62f$var$isArguments = (0, $bBa9H.default)(function() {
    return arguments;
}()) ? (0, $bBa9H.default) : function(value) {
    return (0, $htrdJ.default)(value) && $64c39e1f5626f62f$var$hasOwnProperty.call(value, 'callee') && !$64c39e1f5626f62f$var$propertyIsEnumerable.call(value, 'callee');
};
var $64c39e1f5626f62f$export$2e2bcd8739ae039 = $64c39e1f5626f62f$var$isArguments;

});
parcelRegister("bBa9H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $871b0717f6b7c7fb$export$2e2bcd8739ae039; });

var $aOclx = parcelRequire("aOclx");

var $htrdJ = parcelRequire("htrdJ");
/** `Object#toString` result references. */ var $871b0717f6b7c7fb$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $871b0717f6b7c7fb$var$baseIsArguments(value) {
    return (0, $htrdJ.default)(value) && (0, $aOclx.default)(value) == $871b0717f6b7c7fb$var$argsTag;
}
var $871b0717f6b7c7fb$export$2e2bcd8739ae039 = $871b0717f6b7c7fb$var$baseIsArguments;

});


parcelRegister("gWMuS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c567ae9b40df185f$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $c567ae9b40df185f$var$isArray = Array.isArray;
var $c567ae9b40df185f$export$2e2bcd8739ae039 = $c567ae9b40df185f$var$isArray;

});

parcelRegister("97TKc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a50021b433486f6$export$2e2bcd8739ae039; });

var $3Ij6y = parcelRequire("3Ij6y");

var $kGKdO = parcelRequire("kGKdO");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $3Ij6y.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $kGKdO.default);
var $6a50021b433486f6$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("kGKdO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0fb95940c0e3285$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $f0fb95940c0e3285$var$stubFalse() {
    return false;
}
var $f0fb95940c0e3285$export$2e2bcd8739ae039 = $f0fb95940c0e3285$var$stubFalse;

});


parcelRegister("cuKQh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $918c9f44ad27fe6b$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $918c9f44ad27fe6b$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $918c9f44ad27fe6b$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $918c9f44ad27fe6b$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $918c9f44ad27fe6b$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $918c9f44ad27fe6b$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $918c9f44ad27fe6b$export$2e2bcd8739ae039 = $918c9f44ad27fe6b$var$isIndex;

});

parcelRegister("4l6UB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $328e7c266dd31881$export$2e2bcd8739ae039; });

var $3GMV2 = parcelRequire("3GMV2");

var $4RKOH = parcelRequire("4RKOH");

var $9RktA = parcelRequire("9RktA");
/* Node.js helper references. */ var $328e7c266dd31881$var$nodeIsTypedArray = (0, $9RktA.default) && (0, $9RktA.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $328e7c266dd31881$var$isTypedArray = $328e7c266dd31881$var$nodeIsTypedArray ? (0, $4RKOH.default)($328e7c266dd31881$var$nodeIsTypedArray) : (0, $3GMV2.default);
var $328e7c266dd31881$export$2e2bcd8739ae039 = $328e7c266dd31881$var$isTypedArray;

});
parcelRegister("3GMV2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2afb3d9fbc893c44$export$2e2bcd8739ae039; });

var $aOclx = parcelRequire("aOclx");

var $1cF3g = parcelRequire("1cF3g");

var $htrdJ = parcelRequire("htrdJ");
/** `Object#toString` result references. */ var $2afb3d9fbc893c44$var$argsTag = '[object Arguments]', $2afb3d9fbc893c44$var$arrayTag = '[object Array]', $2afb3d9fbc893c44$var$boolTag = '[object Boolean]', $2afb3d9fbc893c44$var$dateTag = '[object Date]', $2afb3d9fbc893c44$var$errorTag = '[object Error]', $2afb3d9fbc893c44$var$funcTag = '[object Function]', $2afb3d9fbc893c44$var$mapTag = '[object Map]', $2afb3d9fbc893c44$var$numberTag = '[object Number]', $2afb3d9fbc893c44$var$objectTag = '[object Object]', $2afb3d9fbc893c44$var$regexpTag = '[object RegExp]', $2afb3d9fbc893c44$var$setTag = '[object Set]', $2afb3d9fbc893c44$var$stringTag = '[object String]', $2afb3d9fbc893c44$var$weakMapTag = '[object WeakMap]';
var $2afb3d9fbc893c44$var$arrayBufferTag = '[object ArrayBuffer]', $2afb3d9fbc893c44$var$dataViewTag = '[object DataView]', $2afb3d9fbc893c44$var$float32Tag = '[object Float32Array]', $2afb3d9fbc893c44$var$float64Tag = '[object Float64Array]', $2afb3d9fbc893c44$var$int8Tag = '[object Int8Array]', $2afb3d9fbc893c44$var$int16Tag = '[object Int16Array]', $2afb3d9fbc893c44$var$int32Tag = '[object Int32Array]', $2afb3d9fbc893c44$var$uint8Tag = '[object Uint8Array]', $2afb3d9fbc893c44$var$uint8ClampedTag = '[object Uint8ClampedArray]', $2afb3d9fbc893c44$var$uint16Tag = '[object Uint16Array]', $2afb3d9fbc893c44$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $2afb3d9fbc893c44$var$typedArrayTags = {};
$2afb3d9fbc893c44$var$typedArrayTags[$2afb3d9fbc893c44$var$float32Tag] = $2afb3d9fbc893c44$var$typedArrayTags[$2afb3d9fbc893c44$var$float64Tag] = $2afb3d9fbc893c44$var$typedArrayTags[$2afb3d9fbc893c44$var$int8Tag] = $2afb3d9fbc893c44$var$typedArrayTags[$2afb3d9fbc893c44$var$int16Tag] = $2afb3d9fbc893c44$var$typedArrayTags[$2afb3d9fbc893c44$var$int32Tag] = $2afb3d9fbc893c44$var$typedArrayTags[$2afb3d9fbc893c44$var$uint8Tag] = $2afb3d9fbc893c44$var$typedArrayTags[$2afb3d9fbc893c44$var$uint8ClampedTag] = $2afb3d9fbc893c44$var$typedArrayTags[$2afb3d9fbc893c44$var$uint16Tag] = $2afb3d9fbc893c44$var$typedArrayTags[$2afb3d9fbc893c44$var$uint32Tag] = true;
$2afb3d9fbc893c44$var$typedArrayTags[$2afb3d9fbc893c44$var$argsTag] = $2afb3d9fbc893c44$var$typedArrayTags[$2afb3d9fbc893c44$var$arrayTag] = $2afb3d9fbc893c44$var$typedArrayTags[$2afb3d9fbc893c44$var$arrayBufferTag] = $2afb3d9fbc893c44$var$typedArrayTags[$2afb3d9fbc893c44$var$boolTag] = $2afb3d9fbc893c44$var$typedArrayTags[$2afb3d9fbc893c44$var$dataViewTag] = $2afb3d9fbc893c44$var$typedArrayTags[$2afb3d9fbc893c44$var$dateTag] = $2afb3d9fbc893c44$var$typedArrayTags[$2afb3d9fbc893c44$var$errorTag] = $2afb3d9fbc893c44$var$typedArrayTags[$2afb3d9fbc893c44$var$funcTag] = $2afb3d9fbc893c44$var$typedArrayTags[$2afb3d9fbc893c44$var$mapTag] = $2afb3d9fbc893c44$var$typedArrayTags[$2afb3d9fbc893c44$var$numberTag] = $2afb3d9fbc893c44$var$typedArrayTags[$2afb3d9fbc893c44$var$objectTag] = $2afb3d9fbc893c44$var$typedArrayTags[$2afb3d9fbc893c44$var$regexpTag] = $2afb3d9fbc893c44$var$typedArrayTags[$2afb3d9fbc893c44$var$setTag] = $2afb3d9fbc893c44$var$typedArrayTags[$2afb3d9fbc893c44$var$stringTag] = $2afb3d9fbc893c44$var$typedArrayTags[$2afb3d9fbc893c44$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $2afb3d9fbc893c44$var$baseIsTypedArray(value) {
    return (0, $htrdJ.default)(value) && (0, $1cF3g.default)(value.length) && !!$2afb3d9fbc893c44$var$typedArrayTags[(0, $aOclx.default)(value)];
}
var $2afb3d9fbc893c44$export$2e2bcd8739ae039 = $2afb3d9fbc893c44$var$baseIsTypedArray;

});
parcelRegister("1cF3g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e06c172b3a7111e$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $0e06c172b3a7111e$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $0e06c172b3a7111e$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $0e06c172b3a7111e$var$MAX_SAFE_INTEGER;
}
var $0e06c172b3a7111e$export$2e2bcd8739ae039 = $0e06c172b3a7111e$var$isLength;

});


parcelRegister("4RKOH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38b06d7b3decb22b$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $38b06d7b3decb22b$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $38b06d7b3decb22b$export$2e2bcd8739ae039 = $38b06d7b3decb22b$var$baseUnary;

});

parcelRegister("9RktA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72d8f271f4b06530$export$2e2bcd8739ae039; });

var $7mT7T = parcelRequire("7mT7T");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $7mT7T.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $72d8f271f4b06530$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("dlwcA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0281e81d88eb7c8f$export$2e2bcd8739ae039; });

var $jG36a = parcelRequire("jG36a");

var $6ELZx = parcelRequire("6ELZx");
/** Used for built-in method references. */ var $0281e81d88eb7c8f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0281e81d88eb7c8f$var$hasOwnProperty = $0281e81d88eb7c8f$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $0281e81d88eb7c8f$var$baseKeys(object) {
    if (!(0, $jG36a.default)(object)) return (0, $6ELZx.default)(object);
    var result = [];
    for(var key in Object(object))if ($0281e81d88eb7c8f$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $0281e81d88eb7c8f$export$2e2bcd8739ae039 = $0281e81d88eb7c8f$var$baseKeys;

});
parcelRegister("jG36a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e53457dabba1e132$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $e53457dabba1e132$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $e53457dabba1e132$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $e53457dabba1e132$var$objectProto;
    return value === proto;
}
var $e53457dabba1e132$export$2e2bcd8739ae039 = $e53457dabba1e132$var$isPrototype;

});

parcelRegister("6ELZx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d8bb4a1d1173443$export$2e2bcd8739ae039; });

var $kK46S = parcelRequire("kK46S");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $4d8bb4a1d1173443$var$nativeKeys = (0, $kK46S.default)(Object.keys, Object);
var $4d8bb4a1d1173443$export$2e2bcd8739ae039 = $4d8bb4a1d1173443$var$nativeKeys;

});


parcelRegister("7N4fd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ac066d861b5a3e2$export$2e2bcd8739ae039; });

var $1YX81 = parcelRequire("1YX81");

var $1cF3g = parcelRequire("1cF3g");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $5ac066d861b5a3e2$var$isArrayLike(value) {
    return value != null && (0, $1cF3g.default)(value.length) && !(0, $1YX81.default)(value);
}
var $5ac066d861b5a3e2$export$2e2bcd8739ae039 = $5ac066d861b5a3e2$var$isArrayLike;

});



parcelRegister("53Goz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3aee1e5d46edd77d$export$2e2bcd8739ae039; });

var $8eT7Q = parcelRequire("8eT7Q");

var $iVZ3k = parcelRequire("iVZ3k");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $3aee1e5d46edd77d$var$baseAssignIn(object, source) {
    return object && (0, $8eT7Q.default)(source, (0, $iVZ3k.default)(source), object);
}
var $3aee1e5d46edd77d$export$2e2bcd8739ae039 = $3aee1e5d46edd77d$var$baseAssignIn;

});
parcelRegister("iVZ3k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc8ce8a3a2f5758e$export$2e2bcd8739ae039; });

var $7r63J = parcelRequire("7r63J");

var $dywEU = parcelRequire("dywEU");

var $7N4fd = parcelRequire("7N4fd");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $dc8ce8a3a2f5758e$var$keysIn(object) {
    return (0, $7N4fd.default)(object) ? (0, $7r63J.default)(object, true) : (0, $dywEU.default)(object);
}
var $dc8ce8a3a2f5758e$export$2e2bcd8739ae039 = $dc8ce8a3a2f5758e$var$keysIn;

});
parcelRegister("dywEU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9de7c8b433444e88$export$2e2bcd8739ae039; });

var $ewHgJ = parcelRequire("ewHgJ");

var $jG36a = parcelRequire("jG36a");

var $cNNn8 = parcelRequire("cNNn8");
/** Used for built-in method references. */ var $9de7c8b433444e88$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9de7c8b433444e88$var$hasOwnProperty = $9de7c8b433444e88$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $9de7c8b433444e88$var$baseKeysIn(object) {
    if (!(0, $ewHgJ.default)(object)) return (0, $cNNn8.default)(object);
    var isProto = (0, $jG36a.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$9de7c8b433444e88$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $9de7c8b433444e88$export$2e2bcd8739ae039 = $9de7c8b433444e88$var$baseKeysIn;

});
parcelRegister("cNNn8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95205bea30cbea4f$export$2e2bcd8739ae039; });
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $95205bea30cbea4f$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $95205bea30cbea4f$export$2e2bcd8739ae039 = $95205bea30cbea4f$var$nativeKeysIn;

});




parcelRegister("aXBGR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7faca6996a5975f5$export$2e2bcd8739ae039; });

var $3Ij6y = parcelRequire("3Ij6y");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $3Ij6y.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $7faca6996a5975f5$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("jAo82", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4241895697b08cb$export$2e2bcd8739ae039; });
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $e4241895697b08cb$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $e4241895697b08cb$export$2e2bcd8739ae039 = $e4241895697b08cb$var$copyArray;

});

parcelRegister("2hfo0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a891aa7b82ab531$export$2e2bcd8739ae039; });

var $8eT7Q = parcelRequire("8eT7Q");

var $eQzxR = parcelRequire("eQzxR");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $1a891aa7b82ab531$var$copySymbols(source, object) {
    return (0, $8eT7Q.default)(source, (0, $eQzxR.default)(source), object);
}
var $1a891aa7b82ab531$export$2e2bcd8739ae039 = $1a891aa7b82ab531$var$copySymbols;

});
parcelRegister("eQzxR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $acf17e8ff5ff7622$export$2e2bcd8739ae039; });

var $4jR8y = parcelRequire("4jR8y");

var $ftVXb = parcelRequire("ftVXb");
/** Used for built-in method references. */ var $acf17e8ff5ff7622$var$objectProto = Object.prototype;
/** Built-in value references. */ var $acf17e8ff5ff7622$var$propertyIsEnumerable = $acf17e8ff5ff7622$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $acf17e8ff5ff7622$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $acf17e8ff5ff7622$var$getSymbols = !$acf17e8ff5ff7622$var$nativeGetSymbols ? (0, $ftVXb.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $4jR8y.default)($acf17e8ff5ff7622$var$nativeGetSymbols(object), function(symbol) {
        return $acf17e8ff5ff7622$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $acf17e8ff5ff7622$export$2e2bcd8739ae039 = $acf17e8ff5ff7622$var$getSymbols;

});
parcelRegister("4jR8y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $325227a4a6d9637a$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $325227a4a6d9637a$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $325227a4a6d9637a$export$2e2bcd8739ae039 = $325227a4a6d9637a$var$arrayFilter;

});

parcelRegister("ftVXb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b45684d7b0cede01$export$2e2bcd8739ae039; });
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $b45684d7b0cede01$var$stubArray() {
    return [];
}
var $b45684d7b0cede01$export$2e2bcd8739ae039 = $b45684d7b0cede01$var$stubArray;

});



parcelRegister("k2Gbx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e974b79df8b5bdfc$export$2e2bcd8739ae039; });

var $8eT7Q = parcelRequire("8eT7Q");

var $40jju = parcelRequire("40jju");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $e974b79df8b5bdfc$var$copySymbolsIn(source, object) {
    return (0, $8eT7Q.default)(source, (0, $40jju.default)(source), object);
}
var $e974b79df8b5bdfc$export$2e2bcd8739ae039 = $e974b79df8b5bdfc$var$copySymbolsIn;

});
parcelRegister("40jju", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ea624b8d0b108f9$export$2e2bcd8739ae039; });

var $375WW = parcelRequire("375WW");

var $6BRoO = parcelRequire("6BRoO");

var $eQzxR = parcelRequire("eQzxR");

var $ftVXb = parcelRequire("ftVXb");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2ea624b8d0b108f9$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $2ea624b8d0b108f9$var$getSymbolsIn = !$2ea624b8d0b108f9$var$nativeGetSymbols ? (0, $ftVXb.default) : function(object) {
    var result = [];
    while(object){
        (0, $375WW.default)(result, (0, $eQzxR.default)(object));
        object = (0, $6BRoO.default)(object);
    }
    return result;
};
var $2ea624b8d0b108f9$export$2e2bcd8739ae039 = $2ea624b8d0b108f9$var$getSymbolsIn;

});
parcelRegister("375WW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2446a4029202236f$export$2e2bcd8739ae039; });
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $2446a4029202236f$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $2446a4029202236f$export$2e2bcd8739ae039 = $2446a4029202236f$var$arrayPush;

});



parcelRegister("bEDOD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87c250afc31c295e$export$2e2bcd8739ae039; });

var $aqw2M = parcelRequire("aqw2M");

var $eQzxR = parcelRequire("eQzxR");

var $5J6u5 = parcelRequire("5J6u5");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $87c250afc31c295e$var$getAllKeys(object) {
    return (0, $aqw2M.default)(object, (0, $5J6u5.default), (0, $eQzxR.default));
}
var $87c250afc31c295e$export$2e2bcd8739ae039 = $87c250afc31c295e$var$getAllKeys;

});
parcelRegister("aqw2M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $797530504ba364fa$export$2e2bcd8739ae039; });

var $375WW = parcelRequire("375WW");

var $gWMuS = parcelRequire("gWMuS");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $797530504ba364fa$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $gWMuS.default)(object) ? result : (0, $375WW.default)(result, symbolsFunc(object));
}
var $797530504ba364fa$export$2e2bcd8739ae039 = $797530504ba364fa$var$baseGetAllKeys;

});


parcelRegister("9VO6F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73b04e0c02a367fb$export$2e2bcd8739ae039; });

var $aqw2M = parcelRequire("aqw2M");

var $40jju = parcelRequire("40jju");

var $iVZ3k = parcelRequire("iVZ3k");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $73b04e0c02a367fb$var$getAllKeysIn(object) {
    return (0, $aqw2M.default)(object, (0, $iVZ3k.default), (0, $40jju.default));
}
var $73b04e0c02a367fb$export$2e2bcd8739ae039 = $73b04e0c02a367fb$var$getAllKeysIn;

});

parcelRegister("3g10V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25f3a7162ee97ea0$export$2e2bcd8739ae039; });

var $iiYu2 = parcelRequire("iiYu2");

var $9i3mU = parcelRequire("9i3mU");

var $hDr0u = parcelRequire("hDr0u");

var $hA8KU = parcelRequire("hA8KU");

var $9glzz = parcelRequire("9glzz");

var $aOclx = parcelRequire("aOclx");

var $47kku = parcelRequire("47kku");
/** `Object#toString` result references. */ var $25f3a7162ee97ea0$var$mapTag = '[object Map]', $25f3a7162ee97ea0$var$objectTag = '[object Object]', $25f3a7162ee97ea0$var$promiseTag = '[object Promise]', $25f3a7162ee97ea0$var$setTag = '[object Set]', $25f3a7162ee97ea0$var$weakMapTag = '[object WeakMap]';
var $25f3a7162ee97ea0$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $25f3a7162ee97ea0$var$dataViewCtorString = (0, $47kku.default)((0, $iiYu2.default)), $25f3a7162ee97ea0$var$mapCtorString = (0, $47kku.default)((0, $9i3mU.default)), $25f3a7162ee97ea0$var$promiseCtorString = (0, $47kku.default)((0, $hDr0u.default)), $25f3a7162ee97ea0$var$setCtorString = (0, $47kku.default)((0, $hA8KU.default)), $25f3a7162ee97ea0$var$weakMapCtorString = (0, $47kku.default)((0, $9glzz.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $25f3a7162ee97ea0$var$getTag = (0, $aOclx.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $iiYu2.default) && $25f3a7162ee97ea0$var$getTag(new (0, $iiYu2.default)(new ArrayBuffer(1))) != $25f3a7162ee97ea0$var$dataViewTag || (0, $9i3mU.default) && $25f3a7162ee97ea0$var$getTag(new (0, $9i3mU.default)) != $25f3a7162ee97ea0$var$mapTag || (0, $hDr0u.default) && $25f3a7162ee97ea0$var$getTag((0, $hDr0u.default).resolve()) != $25f3a7162ee97ea0$var$promiseTag || (0, $hA8KU.default) && $25f3a7162ee97ea0$var$getTag(new (0, $hA8KU.default)) != $25f3a7162ee97ea0$var$setTag || (0, $9glzz.default) && $25f3a7162ee97ea0$var$getTag(new (0, $9glzz.default)) != $25f3a7162ee97ea0$var$weakMapTag) $25f3a7162ee97ea0$var$getTag = function(value) {
    var result = (0, $aOclx.default)(value), Ctor = result == $25f3a7162ee97ea0$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $47kku.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $25f3a7162ee97ea0$var$dataViewCtorString:
            return $25f3a7162ee97ea0$var$dataViewTag;
        case $25f3a7162ee97ea0$var$mapCtorString:
            return $25f3a7162ee97ea0$var$mapTag;
        case $25f3a7162ee97ea0$var$promiseCtorString:
            return $25f3a7162ee97ea0$var$promiseTag;
        case $25f3a7162ee97ea0$var$setCtorString:
            return $25f3a7162ee97ea0$var$setTag;
        case $25f3a7162ee97ea0$var$weakMapCtorString:
            return $25f3a7162ee97ea0$var$weakMapTag;
    }
    return result;
};
var $25f3a7162ee97ea0$export$2e2bcd8739ae039 = $25f3a7162ee97ea0$var$getTag;

});
parcelRegister("iiYu2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d538d3349f7cb551$export$2e2bcd8739ae039; });

var $aenjD = parcelRequire("aenjD");

var $3Ij6y = parcelRequire("3Ij6y");
/* Built-in method references that are verified to be native. */ var $d538d3349f7cb551$var$DataView = (0, $aenjD.default)((0, $3Ij6y.default), 'DataView');
var $d538d3349f7cb551$export$2e2bcd8739ae039 = $d538d3349f7cb551$var$DataView;

});

parcelRegister("hDr0u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd6b073565cc119c$export$2e2bcd8739ae039; });

var $aenjD = parcelRequire("aenjD");

var $3Ij6y = parcelRequire("3Ij6y");
/* Built-in method references that are verified to be native. */ var $cd6b073565cc119c$var$Promise = (0, $aenjD.default)((0, $3Ij6y.default), 'Promise');
var $cd6b073565cc119c$export$2e2bcd8739ae039 = $cd6b073565cc119c$var$Promise;

});

parcelRegister("hA8KU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cccc9729b5ce2805$export$2e2bcd8739ae039; });

var $aenjD = parcelRequire("aenjD");

var $3Ij6y = parcelRequire("3Ij6y");
/* Built-in method references that are verified to be native. */ var $cccc9729b5ce2805$var$Set = (0, $aenjD.default)((0, $3Ij6y.default), 'Set');
var $cccc9729b5ce2805$export$2e2bcd8739ae039 = $cccc9729b5ce2805$var$Set;

});

parcelRegister("9glzz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6be657909296cee8$export$2e2bcd8739ae039; });

var $aenjD = parcelRequire("aenjD");

var $3Ij6y = parcelRequire("3Ij6y");
/* Built-in method references that are verified to be native. */ var $6be657909296cee8$var$WeakMap = (0, $aenjD.default)((0, $3Ij6y.default), 'WeakMap');
var $6be657909296cee8$export$2e2bcd8739ae039 = $6be657909296cee8$var$WeakMap;

});


parcelRegister("6kMii", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49ca1288e9881e2d$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $49ca1288e9881e2d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $49ca1288e9881e2d$var$hasOwnProperty = $49ca1288e9881e2d$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $49ca1288e9881e2d$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $49ca1288e9881e2d$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $49ca1288e9881e2d$export$2e2bcd8739ae039 = $49ca1288e9881e2d$var$initCloneArray;

});

parcelRegister("9meY7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d01c794897f7025$export$2e2bcd8739ae039; });

var $lJZak = parcelRequire("lJZak");

var $21yq7 = parcelRequire("21yq7");

var $2KcCh = parcelRequire("2KcCh");

var $68ubc = parcelRequire("68ubc");

var $024nO = parcelRequire("024nO");
/** `Object#toString` result references. */ var $6d01c794897f7025$var$boolTag = '[object Boolean]', $6d01c794897f7025$var$dateTag = '[object Date]', $6d01c794897f7025$var$mapTag = '[object Map]', $6d01c794897f7025$var$numberTag = '[object Number]', $6d01c794897f7025$var$regexpTag = '[object RegExp]', $6d01c794897f7025$var$setTag = '[object Set]', $6d01c794897f7025$var$stringTag = '[object String]', $6d01c794897f7025$var$symbolTag = '[object Symbol]';
var $6d01c794897f7025$var$arrayBufferTag = '[object ArrayBuffer]', $6d01c794897f7025$var$dataViewTag = '[object DataView]', $6d01c794897f7025$var$float32Tag = '[object Float32Array]', $6d01c794897f7025$var$float64Tag = '[object Float64Array]', $6d01c794897f7025$var$int8Tag = '[object Int8Array]', $6d01c794897f7025$var$int16Tag = '[object Int16Array]', $6d01c794897f7025$var$int32Tag = '[object Int32Array]', $6d01c794897f7025$var$uint8Tag = '[object Uint8Array]', $6d01c794897f7025$var$uint8ClampedTag = '[object Uint8ClampedArray]', $6d01c794897f7025$var$uint16Tag = '[object Uint16Array]', $6d01c794897f7025$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $6d01c794897f7025$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $6d01c794897f7025$var$arrayBufferTag:
            return (0, $lJZak.default)(object);
        case $6d01c794897f7025$var$boolTag:
        case $6d01c794897f7025$var$dateTag:
            return new Ctor(+object);
        case $6d01c794897f7025$var$dataViewTag:
            return (0, $21yq7.default)(object, isDeep);
        case $6d01c794897f7025$var$float32Tag:
        case $6d01c794897f7025$var$float64Tag:
        case $6d01c794897f7025$var$int8Tag:
        case $6d01c794897f7025$var$int16Tag:
        case $6d01c794897f7025$var$int32Tag:
        case $6d01c794897f7025$var$uint8Tag:
        case $6d01c794897f7025$var$uint8ClampedTag:
        case $6d01c794897f7025$var$uint16Tag:
        case $6d01c794897f7025$var$uint32Tag:
            return (0, $024nO.default)(object, isDeep);
        case $6d01c794897f7025$var$mapTag:
            return new Ctor;
        case $6d01c794897f7025$var$numberTag:
        case $6d01c794897f7025$var$stringTag:
            return new Ctor(object);
        case $6d01c794897f7025$var$regexpTag:
            return (0, $2KcCh.default)(object);
        case $6d01c794897f7025$var$setTag:
            return new Ctor;
        case $6d01c794897f7025$var$symbolTag:
            return (0, $68ubc.default)(object);
    }
}
var $6d01c794897f7025$export$2e2bcd8739ae039 = $6d01c794897f7025$var$initCloneByTag;

});
parcelRegister("lJZak", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd3d3f24dd85b914$export$2e2bcd8739ae039; });

var $d1K7a = parcelRequire("d1K7a");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $fd3d3f24dd85b914$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $d1K7a.default)(result).set(new (0, $d1K7a.default)(arrayBuffer));
    return result;
}
var $fd3d3f24dd85b914$export$2e2bcd8739ae039 = $fd3d3f24dd85b914$var$cloneArrayBuffer;

});
parcelRegister("d1K7a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97bf23c1cbb15952$export$2e2bcd8739ae039; });

var $3Ij6y = parcelRequire("3Ij6y");
/** Built-in value references. */ var $97bf23c1cbb15952$var$Uint8Array = (0, $3Ij6y.default).Uint8Array;
var $97bf23c1cbb15952$export$2e2bcd8739ae039 = $97bf23c1cbb15952$var$Uint8Array;

});


parcelRegister("21yq7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17965feac23546aa$export$2e2bcd8739ae039; });

var $lJZak = parcelRequire("lJZak");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $17965feac23546aa$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $lJZak.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $17965feac23546aa$export$2e2bcd8739ae039 = $17965feac23546aa$var$cloneDataView;

});

parcelRegister("2KcCh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ff9aa0081292ee1$export$2e2bcd8739ae039; });
/** Used to match `RegExp` flags from their coerced string values. */ var $1ff9aa0081292ee1$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $1ff9aa0081292ee1$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $1ff9aa0081292ee1$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $1ff9aa0081292ee1$export$2e2bcd8739ae039 = $1ff9aa0081292ee1$var$cloneRegExp;

});

parcelRegister("68ubc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $477ae6768ff9c85f$export$2e2bcd8739ae039; });

var $2rF6I = parcelRequire("2rF6I");
/** Used to convert symbols to primitives and strings. */ var $477ae6768ff9c85f$var$symbolProto = (0, $2rF6I.default) ? (0, $2rF6I.default).prototype : undefined, $477ae6768ff9c85f$var$symbolValueOf = $477ae6768ff9c85f$var$symbolProto ? $477ae6768ff9c85f$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $477ae6768ff9c85f$var$cloneSymbol(symbol) {
    return $477ae6768ff9c85f$var$symbolValueOf ? Object($477ae6768ff9c85f$var$symbolValueOf.call(symbol)) : {};
}
var $477ae6768ff9c85f$export$2e2bcd8739ae039 = $477ae6768ff9c85f$var$cloneSymbol;

});

parcelRegister("024nO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $006396686d3c2350$export$2e2bcd8739ae039; });

var $lJZak = parcelRequire("lJZak");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $006396686d3c2350$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $lJZak.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $006396686d3c2350$export$2e2bcd8739ae039 = $006396686d3c2350$var$cloneTypedArray;

});


parcelRegister("i7XTz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3275762875d05dc$export$2e2bcd8739ae039; });

var $eKjEU = parcelRequire("eKjEU");

var $6BRoO = parcelRequire("6BRoO");

var $jG36a = parcelRequire("jG36a");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $d3275762875d05dc$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $jG36a.default)(object) ? (0, $eKjEU.default)((0, $6BRoO.default)(object)) : {};
}
var $d3275762875d05dc$export$2e2bcd8739ae039 = $d3275762875d05dc$var$initCloneObject;

});
parcelRegister("eKjEU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abc49c66331eb122$export$2e2bcd8739ae039; });

var $ewHgJ = parcelRequire("ewHgJ");
/** Built-in value references. */ var $abc49c66331eb122$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $abc49c66331eb122$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $ewHgJ.default)(proto)) return {};
        if ($abc49c66331eb122$var$objectCreate) return $abc49c66331eb122$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $abc49c66331eb122$export$2e2bcd8739ae039 = $abc49c66331eb122$var$baseCreate;

});


parcelRegister("j8aPM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ded72b23dae2009e$export$2e2bcd8739ae039; });

var $hIUV5 = parcelRequire("hIUV5");

var $4RKOH = parcelRequire("4RKOH");

var $9RktA = parcelRequire("9RktA");
/* Node.js helper references. */ var $ded72b23dae2009e$var$nodeIsMap = (0, $9RktA.default) && (0, $9RktA.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $ded72b23dae2009e$var$isMap = $ded72b23dae2009e$var$nodeIsMap ? (0, $4RKOH.default)($ded72b23dae2009e$var$nodeIsMap) : (0, $hIUV5.default);
var $ded72b23dae2009e$export$2e2bcd8739ae039 = $ded72b23dae2009e$var$isMap;

});
parcelRegister("hIUV5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce72b2ce6889e0cd$export$2e2bcd8739ae039; });

var $3g10V = parcelRequire("3g10V");

var $htrdJ = parcelRequire("htrdJ");
/** `Object#toString` result references. */ var $ce72b2ce6889e0cd$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $ce72b2ce6889e0cd$var$baseIsMap(value) {
    return (0, $htrdJ.default)(value) && (0, $3g10V.default)(value) == $ce72b2ce6889e0cd$var$mapTag;
}
var $ce72b2ce6889e0cd$export$2e2bcd8739ae039 = $ce72b2ce6889e0cd$var$baseIsMap;

});


parcelRegister("1LTMZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14a574ce0a04fb61$export$2e2bcd8739ae039; });

var $lsUvh = parcelRequire("lsUvh");

var $4RKOH = parcelRequire("4RKOH");

var $9RktA = parcelRequire("9RktA");
/* Node.js helper references. */ var $14a574ce0a04fb61$var$nodeIsSet = (0, $9RktA.default) && (0, $9RktA.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $14a574ce0a04fb61$var$isSet = $14a574ce0a04fb61$var$nodeIsSet ? (0, $4RKOH.default)($14a574ce0a04fb61$var$nodeIsSet) : (0, $lsUvh.default);
var $14a574ce0a04fb61$export$2e2bcd8739ae039 = $14a574ce0a04fb61$var$isSet;

});
parcelRegister("lsUvh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa080ae586fb5227$export$2e2bcd8739ae039; });

var $3g10V = parcelRequire("3g10V");

var $htrdJ = parcelRequire("htrdJ");
/** `Object#toString` result references. */ var $fa080ae586fb5227$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $fa080ae586fb5227$var$baseIsSet(value) {
    return (0, $htrdJ.default)(value) && (0, $3g10V.default)(value) == $fa080ae586fb5227$var$setTag;
}
var $fa080ae586fb5227$export$2e2bcd8739ae039 = $fa080ae586fb5227$var$baseIsSet;

});




parcelRegister("dOnUN", function(module, exports) {
'use strict';
var $a0e27ee3a47349b8$var$isArray = Array.isArray;
var $a0e27ee3a47349b8$var$keyList = Object.keys;
var $a0e27ee3a47349b8$var$hasProp = Object.prototype.hasOwnProperty;
var $a0e27ee3a47349b8$var$hasElementType = typeof Element !== 'undefined';
function $a0e27ee3a47349b8$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $a0e27ee3a47349b8$var$isArray(a), arrB = $a0e27ee3a47349b8$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$a0e27ee3a47349b8$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $a0e27ee3a47349b8$var$keyList(a);
        length = keys.length;
        if (length !== $a0e27ee3a47349b8$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$a0e27ee3a47349b8$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($a0e27ee3a47349b8$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$a0e27ee3a47349b8$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $a0e27ee3a47349b8$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("am4ol", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $789f5d928e3db729$export$2e2bcd8739ae039; });

var $h4J7V = parcelRequire("h4J7V");
/** Used to compose bitmasks for cloning. */ var $789f5d928e3db729$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $789f5d928e3db729$var$clone(value) {
    return (0, $h4J7V.default)(value, $789f5d928e3db729$var$CLONE_SYMBOLS_FLAG);
}
var $789f5d928e3db729$export$2e2bcd8739ae039 = $789f5d928e3db729$var$clone;

});

parcelRegister("pFTwR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04d2d550b1be66a2$export$2e2bcd8739ae039; });

var $7oS7I = parcelRequire("7oS7I");

var $jAo82 = parcelRequire("jAo82");

var $gWMuS = parcelRequire("gWMuS");

var $kksbD = parcelRequire("kksbD");

var $7T17N = parcelRequire("7T17N");

var $inbCX = parcelRequire("inbCX");

var $41HS9 = parcelRequire("41HS9");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $04d2d550b1be66a2$var$toPath(value) {
    if ((0, $gWMuS.default)(value)) return (0, $7oS7I.default)(value, (0, $inbCX.default));
    return (0, $kksbD.default)(value) ? [
        value
    ] : (0, $jAo82.default)((0, $7T17N.default)((0, $41HS9.default)(value)));
}
var $04d2d550b1be66a2$export$2e2bcd8739ae039 = $04d2d550b1be66a2$var$toPath;

});
parcelRegister("7oS7I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5634c21849168547$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $5634c21849168547$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $5634c21849168547$export$2e2bcd8739ae039 = $5634c21849168547$var$arrayMap;

});

parcelRegister("kksbD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eccb8a343e5d8c47$export$2e2bcd8739ae039; });

var $aOclx = parcelRequire("aOclx");

var $htrdJ = parcelRequire("htrdJ");
/** `Object#toString` result references. */ var $eccb8a343e5d8c47$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $eccb8a343e5d8c47$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $htrdJ.default)(value) && (0, $aOclx.default)(value) == $eccb8a343e5d8c47$var$symbolTag;
}
var $eccb8a343e5d8c47$export$2e2bcd8739ae039 = $eccb8a343e5d8c47$var$isSymbol;

});

parcelRegister("7T17N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bde8ad03d77e302$export$2e2bcd8739ae039; });

var $5RjJS = parcelRequire("5RjJS");
/** Used to match property names within property paths. */ var $5bde8ad03d77e302$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $5bde8ad03d77e302$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $5bde8ad03d77e302$var$stringToPath = (0, $5RjJS.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($5bde8ad03d77e302$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($5bde8ad03d77e302$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $5bde8ad03d77e302$export$2e2bcd8739ae039 = $5bde8ad03d77e302$var$stringToPath;

});
parcelRegister("5RjJS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $444136bdd77ecd03$export$2e2bcd8739ae039; });

var $4Z5tN = parcelRequire("4Z5tN");
/** Used as the maximum memoize cache size. */ var $444136bdd77ecd03$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $444136bdd77ecd03$var$memoizeCapped(func) {
    var result = (0, $4Z5tN.default)(func, function(key) {
        if (cache.size === $444136bdd77ecd03$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $444136bdd77ecd03$export$2e2bcd8739ae039 = $444136bdd77ecd03$var$memoizeCapped;

});
parcelRegister("4Z5tN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a111c14df8aa5f8$export$2e2bcd8739ae039; });

var $8yqDV = parcelRequire("8yqDV");
/** Error message constants. */ var $3a111c14df8aa5f8$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $3a111c14df8aa5f8$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($3a111c14df8aa5f8$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($3a111c14df8aa5f8$var$memoize.Cache || (0, $8yqDV.default));
    return memoized;
}
// Expose `MapCache`.
$3a111c14df8aa5f8$var$memoize.Cache = (0, $8yqDV.default);
var $3a111c14df8aa5f8$export$2e2bcd8739ae039 = $3a111c14df8aa5f8$var$memoize;

});



parcelRegister("inbCX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d60364eeacdcfdb1$export$2e2bcd8739ae039; });

var $kksbD = parcelRequire("kksbD");
/** Used as references for various `Number` constants. */ var $d60364eeacdcfdb1$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $d60364eeacdcfdb1$var$toKey(value) {
    if (typeof value == 'string' || (0, $kksbD.default)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$d60364eeacdcfdb1$var$INFINITY ? '-0' : result;
}
var $d60364eeacdcfdb1$export$2e2bcd8739ae039 = $d60364eeacdcfdb1$var$toKey;

});

parcelRegister("41HS9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ee9499485f90298$export$2e2bcd8739ae039; });

var $54yYc = parcelRequire("54yYc");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $2ee9499485f90298$var$toString(value) {
    return value == null ? '' : (0, $54yYc.default)(value);
}
var $2ee9499485f90298$export$2e2bcd8739ae039 = $2ee9499485f90298$var$toString;

});
parcelRegister("54yYc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b1873c4d7567017$export$2e2bcd8739ae039; });

var $2rF6I = parcelRequire("2rF6I");

var $7oS7I = parcelRequire("7oS7I");

var $gWMuS = parcelRequire("gWMuS");

var $kksbD = parcelRequire("kksbD");
/** Used as references for various `Number` constants. */ var $3b1873c4d7567017$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $3b1873c4d7567017$var$symbolProto = (0, $2rF6I.default) ? (0, $2rF6I.default).prototype : undefined, $3b1873c4d7567017$var$symbolToString = $3b1873c4d7567017$var$symbolProto ? $3b1873c4d7567017$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $3b1873c4d7567017$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $gWMuS.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $7oS7I.default)(value, $3b1873c4d7567017$var$baseToString) + '';
    if ((0, $kksbD.default)(value)) return $3b1873c4d7567017$var$symbolToString ? $3b1873c4d7567017$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$3b1873c4d7567017$var$INFINITY ? '-0' : result;
}
var $3b1873c4d7567017$export$2e2bcd8739ae039 = $3b1873c4d7567017$var$baseToString;

});




parcelRegister("l52Kb", function(module, exports) {

var $dSq9F = parcelRequire("dSq9F");

var $8h8Q5 = parcelRequire("8h8Q5");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $dSq9F.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $8h8Q5;
module.exports = isBuffer;

});
parcelRegister("dSq9F", function(module, exports) {

var $eOviQ = parcelRequire("eOviQ");
/** Detect free variable `self`. */ var $a1a49b4f43a2c84a$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $a1a49b4f43a2c84a$var$root = $eOviQ || $a1a49b4f43a2c84a$var$freeSelf || Function('return this')();
module.exports = $a1a49b4f43a2c84a$var$root;

});
parcelRegister("eOviQ", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $ac8e044e6e456ce1$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $ac8e044e6e456ce1$var$freeGlobal;

});


parcelRegister("8h8Q5", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $6066c48c8dd81edc$var$stubFalse() {
    return false;
}
module.exports = $6066c48c8dd81edc$var$stubFalse;

});


parcelRegister("9zqsx", function(module, exports) {

var $eOviQ = parcelRequire("eOviQ");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $eOviQ.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("drUUa", function(module, exports) {
var $9ca9f0170d0b88d9$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $9ca9f0170d0b88d9$var$core; // eslint-disable-line no-undef

});

parcelRegister("5vqyJ", function(module, exports) {
// optional / simple context binding

var $f4tkp = parcelRequire("f4tkp");
module.exports = function(fn, that, length) {
    $f4tkp(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("f4tkp", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("7WXS7", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("8X6w6"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("8X6w6", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("aQ3Gk", function(module, exports) {

var $dVk9w = parcelRequire("dVk9w");

var $ctyju = parcelRequire("ctyju");
var $7e419dd76407caf1$require$document = $ctyju.document;
// typeof document.createElement is 'object' in old IE
var $7e419dd76407caf1$var$is = $dVk9w($7e419dd76407caf1$require$document) && $dVk9w($7e419dd76407caf1$require$document.createElement);
module.exports = function(it) {
    return $7e419dd76407caf1$var$is ? $7e419dd76407caf1$require$document.createElement(it) : {};
};

});
parcelRegister("dVk9w", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});

parcelRegister("ctyju", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $9152cf61464366f5$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $9152cf61464366f5$var$global; // eslint-disable-line no-undef

});


parcelRegister("fuayA", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $bJJTS = parcelRequire("bJJTS");

var $ajxqy = parcelRequire("ajxqy");

var $cuqdI = parcelRequire("cuqdI");

var $b461d8be9789ef6a$var$IE_PROTO = (parcelRequire("fKSWF"))('IE_PROTO');
var $b461d8be9789ef6a$var$Empty = function() {};
var $b461d8be9789ef6a$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $b461d8be9789ef6a$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("aQ3Gk"))('iframe');
    var i = $cuqdI.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("dekp0")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $b461d8be9789ef6a$var$createDict = iframeDocument.F;
    while(i--)delete $b461d8be9789ef6a$var$createDict[$b461d8be9789ef6a$var$PROTOTYPE][$cuqdI[i]];
    return $b461d8be9789ef6a$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $b461d8be9789ef6a$var$Empty[$b461d8be9789ef6a$var$PROTOTYPE] = $bJJTS(O);
        result = new $b461d8be9789ef6a$var$Empty();
        $b461d8be9789ef6a$var$Empty[$b461d8be9789ef6a$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$b461d8be9789ef6a$var$IE_PROTO] = O;
    } else result = $b461d8be9789ef6a$var$createDict();
    return Properties === undefined ? result : $ajxqy(result, Properties);
};

});
parcelRegister("bJJTS", function(module, exports) {

var $dVk9w = parcelRequire("dVk9w");
module.exports = function(it) {
    if (!$dVk9w(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});

parcelRegister("ajxqy", function(module, exports) {

var $eAqg8 = parcelRequire("eAqg8");

var $bJJTS = parcelRequire("bJJTS");

var $8pzi1 = parcelRequire("8pzi1");

module.exports = (parcelRequire("7WXS7")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $bJJTS(O);
    var keys = $8pzi1(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$eAqg8.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("eAqg8", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $a9e8cc0a0cd08e45$export$2d1720544b23b823; }, function (v) { return $a9e8cc0a0cd08e45$export$2d1720544b23b823 = v; });
var $a9e8cc0a0cd08e45$export$2d1720544b23b823;

var $bJJTS = parcelRequire("bJJTS");

var $hggpw = parcelRequire("hggpw");

var $yire2 = parcelRequire("yire2");
var $a9e8cc0a0cd08e45$var$dP = Object.defineProperty;

$a9e8cc0a0cd08e45$export$2d1720544b23b823 = (parcelRequire("7WXS7")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $bJJTS(O);
    P = $yire2(P, true);
    $bJJTS(Attributes);
    if ($hggpw) try {
        return $a9e8cc0a0cd08e45$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("hggpw", function(module, exports) {



module.exports = !(parcelRequire("7WXS7")) && !(parcelRequire("8X6w6"))(function() {
    return Object.defineProperty((parcelRequire("aQ3Gk"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});

parcelRegister("yire2", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $dVk9w = parcelRequire("dVk9w");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$dVk9w(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$dVk9w(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$dVk9w(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$dVk9w(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("8pzi1", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $aEZUI = parcelRequire("aEZUI");

var $cuqdI = parcelRequire("cuqdI");
module.exports = Object.keys || function keys(O) {
    return $aEZUI(O, $cuqdI);
};

});
parcelRegister("aEZUI", function(module, exports) {

var $jbmvv = parcelRequire("jbmvv");

var $BHezA = parcelRequire("BHezA");

var $7c2daa98ecc96c89$var$arrayIndexOf = (parcelRequire("bX1ib"))(false);

var $7c2daa98ecc96c89$var$IE_PROTO = (parcelRequire("fKSWF"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $BHezA(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $7c2daa98ecc96c89$var$IE_PROTO) $jbmvv(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($jbmvv(O, key = names[i++])) ~$7c2daa98ecc96c89$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("jbmvv", function(module, exports) {
var $df7080e00c6a51ea$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $df7080e00c6a51ea$var$hasOwnProperty.call(it, key);
};

});

parcelRegister("BHezA", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $38pb5 = parcelRequire("38pb5");

var $19C7H = parcelRequire("19C7H");
module.exports = function(it) {
    return $38pb5($19C7H(it));
};

});
parcelRegister("38pb5", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $eepw1 = parcelRequire("eepw1");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $eepw1(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("eepw1", function(module, exports) {
var $a5c62a5a872d530c$var$toString = {}.toString;
module.exports = function(it) {
    return $a5c62a5a872d530c$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("19C7H", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("bX1ib", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $BHezA = parcelRequire("BHezA");

var $41yWG = parcelRequire("41yWG");

var $jUQ92 = parcelRequire("jUQ92");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $BHezA($this);
        var length = $41yWG(O.length);
        var index = $jUQ92(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("41yWG", function(module, exports) {
// 7.1.15 ToLength

var $gPLQp = parcelRequire("gPLQp");
var $2ee25cdf0b0ff250$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $2ee25cdf0b0ff250$var$min($gPLQp(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("gPLQp", function(module, exports) {
// 7.1.4 ToInteger
var $c41685a51fcef002$var$ceil = Math.ceil;
var $c41685a51fcef002$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $c41685a51fcef002$var$floor : $c41685a51fcef002$var$ceil)(it);
};

});


parcelRegister("jUQ92", function(module, exports) {

var $gPLQp = parcelRequire("gPLQp");
var $e7fbb22c65df399f$var$max = Math.max;
var $e7fbb22c65df399f$var$min = Math.min;
module.exports = function(index, length) {
    index = $gPLQp(index);
    return index < 0 ? $e7fbb22c65df399f$var$max(index + length, 0) : $e7fbb22c65df399f$var$min(index, length);
};

});


parcelRegister("fKSWF", function(module, exports) {

var $b785c5e04e1e9df5$var$shared = (parcelRequire("fhfbj"))('keys');

var $3RCaR = parcelRequire("3RCaR");
module.exports = function(key) {
    return $b785c5e04e1e9df5$var$shared[key] || ($b785c5e04e1e9df5$var$shared[key] = $3RCaR(key));
};

});
parcelRegister("fhfbj", function(module, exports) {

var $drUUa = parcelRequire("drUUa");

var $ctyju = parcelRequire("ctyju");
var $b1f438407b8b0ab2$var$SHARED = '__core-js_shared__';
var $b1f438407b8b0ab2$var$store = $ctyju[$b1f438407b8b0ab2$var$SHARED] || ($ctyju[$b1f438407b8b0ab2$var$SHARED] = {});

(module.exports = function(key, value) {
    return $b1f438407b8b0ab2$var$store[key] || ($b1f438407b8b0ab2$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $drUUa.version,
    mode: (parcelRequire("lEAOK")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("lEAOK", function(module, exports) {
module.exports = true;

});


parcelRegister("3RCaR", function(module, exports) {
var $2d03eef45ee6d58d$var$id = 0;
var $2d03eef45ee6d58d$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$2d03eef45ee6d58d$var$id + $2d03eef45ee6d58d$var$px).toString(36));
};

});



parcelRegister("cuqdI", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});



parcelRegister("dekp0", function(module, exports) {

var $ctyju = parcelRequire("ctyju");
var $9a1c68a2f9cf9b66$require$document = $ctyju.document;
module.exports = $9a1c68a2f9cf9b66$require$document && $9a1c68a2f9cf9b66$require$document.documentElement;

});


parcelRegister("kpHXZ", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $dVk9w = parcelRequire("dVk9w");

var $bJJTS = parcelRequire("bJJTS");
var $edc83f482c498c0a$var$check = function(O, proto) {
    $bJJTS(O);
    if (!$dVk9w(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("5vqyJ"))(Function.call, (parcelRequire("d1sO7")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $edc83f482c498c0a$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $edc83f482c498c0a$var$check
};

});
parcelRegister("d1sO7", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $97b1b6e4e836eb52$export$2d1720544b23b823; }, function (v) { return $97b1b6e4e836eb52$export$2d1720544b23b823 = v; });
var $97b1b6e4e836eb52$export$2d1720544b23b823;

var $5klSG = parcelRequire("5klSG");

var $2vck7 = parcelRequire("2vck7");

var $BHezA = parcelRequire("BHezA");

var $yire2 = parcelRequire("yire2");

var $jbmvv = parcelRequire("jbmvv");

var $hggpw = parcelRequire("hggpw");
var $97b1b6e4e836eb52$var$gOPD = Object.getOwnPropertyDescriptor;

$97b1b6e4e836eb52$export$2d1720544b23b823 = (parcelRequire("7WXS7")) ? $97b1b6e4e836eb52$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $BHezA(O);
    P = $yire2(P, true);
    if ($hggpw) try {
        return $97b1b6e4e836eb52$var$gOPD(O, P);
    } catch (e) {}
    if ($jbmvv(O, P)) return $2vck7(!$5klSG.f.call(O, P), O[P]);
};

});
parcelRegister("5klSG", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $3e0fcb24056a978a$export$2d1720544b23b823; }, function (v) { return $3e0fcb24056a978a$export$2d1720544b23b823 = v; });
var $3e0fcb24056a978a$export$2d1720544b23b823;
$3e0fcb24056a978a$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});

parcelRegister("2vck7", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});



parcelRegister("2tNbD", function(module, exports) {
parcelRequire("pan8c");

module.exports = (parcelRequire("drUUa")).Object.assign;

});
parcelRegister("pan8c", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $5Q5bp = parcelRequire("5Q5bp");

$5Q5bp($5Q5bp.S + $5Q5bp.F, 'Object', {
    assign: (parcelRequire("4bmWC"))
});

});
parcelRegister("5Q5bp", function(module, exports) {

var $ctyju = parcelRequire("ctyju");

var $drUUa = parcelRequire("drUUa");

var $5vqyJ = parcelRequire("5vqyJ");

var $b7o2x = parcelRequire("b7o2x");

var $jbmvv = parcelRequire("jbmvv");
var $4405d44d80cbc775$var$PROTOTYPE = 'prototype';
var $4405d44d80cbc775$var$$export = function(type, name, source) {
    var IS_FORCED = type & $4405d44d80cbc775$var$$export.F;
    var IS_GLOBAL = type & $4405d44d80cbc775$var$$export.G;
    var IS_STATIC = type & $4405d44d80cbc775$var$$export.S;
    var IS_PROTO = type & $4405d44d80cbc775$var$$export.P;
    var IS_BIND = type & $4405d44d80cbc775$var$$export.B;
    var IS_WRAP = type & $4405d44d80cbc775$var$$export.W;
    var exports = IS_GLOBAL ? $drUUa : $drUUa[name] || ($drUUa[name] = {});
    var expProto = exports[$4405d44d80cbc775$var$PROTOTYPE];
    var target = IS_GLOBAL ? $ctyju : IS_STATIC ? $ctyju[name] : ($ctyju[name] || {})[$4405d44d80cbc775$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $jbmvv(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $5vqyJ(out, $ctyju) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$4405d44d80cbc775$var$PROTOTYPE] = C[$4405d44d80cbc775$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $5vqyJ(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $4405d44d80cbc775$var$$export.R && expProto && !expProto[key]) $b7o2x(expProto, key, out);
        }
    }
};
// type bitmap
$4405d44d80cbc775$var$$export.F = 1; // forced
$4405d44d80cbc775$var$$export.G = 2; // global
$4405d44d80cbc775$var$$export.S = 4; // static
$4405d44d80cbc775$var$$export.P = 8; // proto
$4405d44d80cbc775$var$$export.B = 16; // bind
$4405d44d80cbc775$var$$export.W = 32; // wrap
$4405d44d80cbc775$var$$export.U = 64; // safe
$4405d44d80cbc775$var$$export.R = 128; // real proto method for `library`
module.exports = $4405d44d80cbc775$var$$export;

});
parcelRegister("b7o2x", function(module, exports) {

var $eAqg8 = parcelRequire("eAqg8");

var $2vck7 = parcelRequire("2vck7");

module.exports = (parcelRequire("7WXS7")) ? function(object, key, value) {
    return $eAqg8.f(object, key, $2vck7(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});


parcelRegister("4bmWC", function(module, exports) {
'use strict';

var $7WXS7 = parcelRequire("7WXS7");

var $8pzi1 = parcelRequire("8pzi1");

var $7Pyeu = parcelRequire("7Pyeu");

var $5klSG = parcelRequire("5klSG");

var $3xZcq = parcelRequire("3xZcq");

var $38pb5 = parcelRequire("38pb5");
var $30b9fcc8db1a670c$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$30b9fcc8db1a670c$var$$assign || (parcelRequire("8X6w6"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $30b9fcc8db1a670c$var$$assign({}, A)[S] != 7 || Object.keys($30b9fcc8db1a670c$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $3xZcq(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $7Pyeu.f;
    var isEnum = $5klSG.f;
    while(aLen > index){
        var S = $38pb5(arguments[index++]);
        var keys = getSymbols ? $8pzi1(S).concat(getSymbols(S)) : $8pzi1(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$7WXS7 || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $30b9fcc8db1a670c$var$$assign;

});
parcelRegister("7Pyeu", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $5b37d9bf401babf3$export$2d1720544b23b823; }, function (v) { return $5b37d9bf401babf3$export$2d1720544b23b823 = v; });
var $5b37d9bf401babf3$export$2d1720544b23b823;
$5b37d9bf401babf3$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("3xZcq", function(module, exports) {
// 7.1.13 ToObject(argument)

var $19C7H = parcelRequire("19C7H");
module.exports = function(it) {
    return Object($19C7H(it));
};

});




parcelRegister("lwi4T", function(module, exports) {
parcelRequire("fizrr");

module.exports = (parcelRequire("drUUa")).Object.values;

});
parcelRegister("fizrr", function(module, exports) {
// https://github.com/tc39/proposal-object-values-entries

var $5Q5bp = parcelRequire("5Q5bp");

var $02dfce922de0b95a$var$$values = (parcelRequire("iG0f5"))(false);
$5Q5bp($5Q5bp.S, 'Object', {
    values: function values(it) {
        return $02dfce922de0b95a$var$$values(it);
    }
});

});
parcelRegister("iG0f5", function(module, exports) {

var $7WXS7 = parcelRequire("7WXS7");

var $8pzi1 = parcelRequire("8pzi1");

var $BHezA = parcelRequire("BHezA");

var $5klSG = parcelRequire("5klSG");
var $d98c56577ea8977b$require$isEnum = $5klSG.f;
module.exports = function(isEntries) {
    return function(it) {
        var O = $BHezA(it);
        var keys = $8pzi1(O);
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!$7WXS7 || $d98c56577ea8977b$require$isEnum.call(O, key)) result.push(isEntries ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};

});



parcelRegister("4IhFa", function(module, exports) {
parcelRequire("5IRQi");

module.exports = (parcelRequire("drUUa")).Object.keys;

});
parcelRegister("5IRQi", function(module, exports) {
// 19.1.2.14 Object.keys(O)

var $3xZcq = parcelRequire("3xZcq");

var $8pzi1 = parcelRequire("8pzi1");

(parcelRequire("3OjhO"))('keys', function() {
    return function keys(it) {
        return $8pzi1($3xZcq(it));
    };
});

});
parcelRegister("3OjhO", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $5Q5bp = parcelRequire("5Q5bp");

var $drUUa = parcelRequire("drUUa");

var $8X6w6 = parcelRequire("8X6w6");
module.exports = function(KEY, exec) {
    var fn = ($drUUa.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $5Q5bp($5Q5bp.S + $5Q5bp.F * $8X6w6(function() {
        fn(1);
    }), 'Object', exp);
};

});



parcelRegister("i3LOS", function(module, exports) {
parcelRequire("aJyts");

module.exports = (parcelRequire("drUUa")).Date.now;

});
parcelRegister("aJyts", function(module, exports) {
// 20.3.3.1 / 15.9.4.4 Date.now()

var $5Q5bp = parcelRequire("5Q5bp");
$5Q5bp($5Q5bp.S, 'Date', {
    now: function() {
        return new Date().getTime();
    }
});

});


parcelRegister("cct7W", function(module, exports) {
parcelRequire("77jZk");

module.exports = (parcelRequire("drUUa")).Number.isInteger;

});
parcelRegister("77jZk", function(module, exports) {
// 20.1.2.3 Number.isInteger(number)

var $5Q5bp = parcelRequire("5Q5bp");

$5Q5bp($5Q5bp.S, 'Number', {
    isInteger: (parcelRequire("ixevG"))
});

});
parcelRegister("ixevG", function(module, exports) {
// 20.1.2.3 Number.isInteger(number)

var $dVk9w = parcelRequire("dVk9w");
var $d7e6906fd68aba03$var$floor = Math.floor;
module.exports = function isInteger(it) {
    return !$dVk9w(it) && isFinite(it) && $d7e6906fd68aba03$var$floor(it) === it;
};

});



var $aab0dac2fed7d1ac$exports = {};
$parcel$extendImportMap({
    "3INcZ": "logo.b9d8f334.png",
    "CUxfr": "help-document-editor.bcc38d97.css"
});

var $8991ead30e777b29$exports = {};
'use strict';

$8991ead30e777b29$exports = (parcelRequire("ijIqx"));


/* eslint no-extend-native: "off" */ // Polyfill taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find?v=control#Polyfill
// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) Object.defineProperty(Array.prototype, 'find', {
    value: function(predicate) {
        // 1. Let O be ? ToObject(this value).
        if (this == null) throw new TypeError('"this" is null or not defined');
        var o = Object(this);
        // 2. Let len be ? ToLength(? Get(O, "length")).
        var len = o.length >>> 0;
        // 3. If IsCallable(predicate) is false, throw a TypeError exception.
        if (typeof predicate !== 'function') throw new TypeError('predicate must be a function');
        // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
        var thisArg = arguments[1];
        // 5. Let k be 0.
        var k = 0;
        // 6. Repeat, while k < len
        while(k < len){
            // a. Let Pk be ! ToString(k).
            // b. Let kValue be ? Get(O, Pk).
            // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
            // d. If testResult is true, return kValue.
            var kValue = o[k];
            if (predicate.call(thisArg, kValue, k, o)) return kValue;
            // e. Increase k by 1.
            k++;
        }
        // 7. Return undefined.
        return undefined;
    }
});


parcelRequire("ieT14");
var $74fc34f240fc23e5$export$882461b6382ed46c;
var $74fc34f240fc23e5$export$757ceba2d55c277e;
'use strict';

var $3tOoB = parcelRequire("3tOoB");
var $74fc34f240fc23e5$var$i;
$74fc34f240fc23e5$export$882461b6382ed46c = $3tOoB.createRoot;
$74fc34f240fc23e5$export$757ceba2d55c277e = $3tOoB.hydrateRoot;



parcelRequire("ieT14");

parcelRequire("ieT14");

var $6mt9R = parcelRequire("6mt9R");

parcelRequire("ieT14");

var $eYoAG = parcelRequire("eYoAG");

var $eYoAG = parcelRequire("eYoAG");
/*
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

var $ieT14 = parcelRequire("ieT14");
/*!
 * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $a4a11e297e121f39$exports = {};
function $a4a11e297e121f39$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $a4a11e297e121f39$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $a4a11e297e121f39$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $a4a11e297e121f39$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
$a4a11e297e121f39$exports = $a4a11e297e121f39$var$_asyncToGenerator, $a4a11e297e121f39$exports.__esModule = true, $a4a11e297e121f39$exports["default"] = $a4a11e297e121f39$exports;


var $bc640ab0637076b3$exports = {};
var $396d43cfc1f75e0a$exports = {};
function $396d43cfc1f75e0a$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$396d43cfc1f75e0a$exports = $396d43cfc1f75e0a$var$_arrayWithHoles, $396d43cfc1f75e0a$exports.__esModule = true, $396d43cfc1f75e0a$exports["default"] = $396d43cfc1f75e0a$exports;


var $8dbb2ab22449140f$exports = {};
function $8dbb2ab22449140f$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$8dbb2ab22449140f$exports = $8dbb2ab22449140f$var$_iterableToArrayLimit, $8dbb2ab22449140f$exports.__esModule = true, $8dbb2ab22449140f$exports["default"] = $8dbb2ab22449140f$exports;


var $c847ca1d25b289f6$exports = {};
var $3df82b681a9a81a9$exports = {};
function $3df82b681a9a81a9$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$3df82b681a9a81a9$exports = $3df82b681a9a81a9$var$_arrayLikeToArray, $3df82b681a9a81a9$exports.__esModule = true, $3df82b681a9a81a9$exports["default"] = $3df82b681a9a81a9$exports;


function $c847ca1d25b289f6$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3df82b681a9a81a9$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3df82b681a9a81a9$exports(r, a) : void 0;
    }
}
$c847ca1d25b289f6$exports = $c847ca1d25b289f6$var$_unsupportedIterableToArray, $c847ca1d25b289f6$exports.__esModule = true, $c847ca1d25b289f6$exports["default"] = $c847ca1d25b289f6$exports;


var $16e4977280a6aca0$exports = {};
function $16e4977280a6aca0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$16e4977280a6aca0$exports = $16e4977280a6aca0$var$_nonIterableRest, $16e4977280a6aca0$exports.__esModule = true, $16e4977280a6aca0$exports["default"] = $16e4977280a6aca0$exports;


function $bc640ab0637076b3$var$_slicedToArray(r, e) {
    return $396d43cfc1f75e0a$exports(r) || $8dbb2ab22449140f$exports(r, e) || $c847ca1d25b289f6$exports(r, e) || $16e4977280a6aca0$exports();
}
$bc640ab0637076b3$exports = $bc640ab0637076b3$var$_slicedToArray, $bc640ab0637076b3$exports.__esModule = true, $bc640ab0637076b3$exports["default"] = $bc640ab0637076b3$exports;


var $afbd3bca675d3652$exports = {};
// TODO(Babel 8): Remove this file.

var $afbd3bca675d3652$var$runtime = (parcelRequire("eVk2i"))();
$afbd3bca675d3652$exports = $afbd3bca675d3652$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $afbd3bca675d3652$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $afbd3bca675d3652$var$runtime;
    else Function("r", "regeneratorRuntime = r")($afbd3bca675d3652$var$runtime);
}



var $ieT14 = parcelRequire("ieT14");
var $c54b3d2ef9f9e60a$exports = {};
/*! For license information please see default.js.LICENSE.txt */ var $fcfa90861d16c270$exports = {};
// shim for using process in browser
var $fcfa90861d16c270$var$process = $fcfa90861d16c270$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $fcfa90861d16c270$var$cachedSetTimeout;
var $fcfa90861d16c270$var$cachedClearTimeout;
function $fcfa90861d16c270$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $fcfa90861d16c270$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $fcfa90861d16c270$var$cachedSetTimeout = setTimeout;
        else $fcfa90861d16c270$var$cachedSetTimeout = $fcfa90861d16c270$var$defaultSetTimout;
    } catch (e) {
        $fcfa90861d16c270$var$cachedSetTimeout = $fcfa90861d16c270$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $fcfa90861d16c270$var$cachedClearTimeout = clearTimeout;
        else $fcfa90861d16c270$var$cachedClearTimeout = $fcfa90861d16c270$var$defaultClearTimeout;
    } catch (e) {
        $fcfa90861d16c270$var$cachedClearTimeout = $fcfa90861d16c270$var$defaultClearTimeout;
    }
})();
function $fcfa90861d16c270$var$runTimeout(fun) {
    if ($fcfa90861d16c270$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($fcfa90861d16c270$var$cachedSetTimeout === $fcfa90861d16c270$var$defaultSetTimout || !$fcfa90861d16c270$var$cachedSetTimeout) && setTimeout) {
        $fcfa90861d16c270$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $fcfa90861d16c270$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $fcfa90861d16c270$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $fcfa90861d16c270$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $fcfa90861d16c270$var$runClearTimeout(marker) {
    if ($fcfa90861d16c270$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($fcfa90861d16c270$var$cachedClearTimeout === $fcfa90861d16c270$var$defaultClearTimeout || !$fcfa90861d16c270$var$cachedClearTimeout) && clearTimeout) {
        $fcfa90861d16c270$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $fcfa90861d16c270$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $fcfa90861d16c270$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $fcfa90861d16c270$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $fcfa90861d16c270$var$queue = [];
var $fcfa90861d16c270$var$draining = false;
var $fcfa90861d16c270$var$currentQueue;
var $fcfa90861d16c270$var$queueIndex = -1;
function $fcfa90861d16c270$var$cleanUpNextTick() {
    if (!$fcfa90861d16c270$var$draining || !$fcfa90861d16c270$var$currentQueue) return;
    $fcfa90861d16c270$var$draining = false;
    if ($fcfa90861d16c270$var$currentQueue.length) $fcfa90861d16c270$var$queue = $fcfa90861d16c270$var$currentQueue.concat($fcfa90861d16c270$var$queue);
    else $fcfa90861d16c270$var$queueIndex = -1;
    if ($fcfa90861d16c270$var$queue.length) $fcfa90861d16c270$var$drainQueue();
}
function $fcfa90861d16c270$var$drainQueue() {
    if ($fcfa90861d16c270$var$draining) return;
    var timeout = $fcfa90861d16c270$var$runTimeout($fcfa90861d16c270$var$cleanUpNextTick);
    $fcfa90861d16c270$var$draining = true;
    var len = $fcfa90861d16c270$var$queue.length;
    while(len){
        $fcfa90861d16c270$var$currentQueue = $fcfa90861d16c270$var$queue;
        $fcfa90861d16c270$var$queue = [];
        while(++$fcfa90861d16c270$var$queueIndex < len)if ($fcfa90861d16c270$var$currentQueue) $fcfa90861d16c270$var$currentQueue[$fcfa90861d16c270$var$queueIndex].run();
        $fcfa90861d16c270$var$queueIndex = -1;
        len = $fcfa90861d16c270$var$queue.length;
    }
    $fcfa90861d16c270$var$currentQueue = null;
    $fcfa90861d16c270$var$draining = false;
    $fcfa90861d16c270$var$runClearTimeout(timeout);
}
$fcfa90861d16c270$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $fcfa90861d16c270$var$queue.push(new $fcfa90861d16c270$var$Item(fun, args));
    if ($fcfa90861d16c270$var$queue.length === 1 && !$fcfa90861d16c270$var$draining) $fcfa90861d16c270$var$runTimeout($fcfa90861d16c270$var$drainQueue);
};
// v8 likes predictible objects
function $fcfa90861d16c270$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$fcfa90861d16c270$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$fcfa90861d16c270$var$process.title = 'browser';
$fcfa90861d16c270$var$process.browser = true;
$fcfa90861d16c270$var$process.env = {};
$fcfa90861d16c270$var$process.argv = [];
$fcfa90861d16c270$var$process.version = ''; // empty string to avoid regexp issues
$fcfa90861d16c270$var$process.versions = {};
function $fcfa90861d16c270$var$noop() {}
$fcfa90861d16c270$var$process.on = $fcfa90861d16c270$var$noop;
$fcfa90861d16c270$var$process.addListener = $fcfa90861d16c270$var$noop;
$fcfa90861d16c270$var$process.once = $fcfa90861d16c270$var$noop;
$fcfa90861d16c270$var$process.off = $fcfa90861d16c270$var$noop;
$fcfa90861d16c270$var$process.removeListener = $fcfa90861d16c270$var$noop;
$fcfa90861d16c270$var$process.removeAllListeners = $fcfa90861d16c270$var$noop;
$fcfa90861d16c270$var$process.emit = $fcfa90861d16c270$var$noop;
$fcfa90861d16c270$var$process.prependListener = $fcfa90861d16c270$var$noop;
$fcfa90861d16c270$var$process.prependOnceListener = $fcfa90861d16c270$var$noop;
$fcfa90861d16c270$var$process.listeners = function(name) {
    return [];
};
$fcfa90861d16c270$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$fcfa90861d16c270$var$process.cwd = function() {
    return '/';
};
$fcfa90861d16c270$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$fcfa90861d16c270$var$process.umask = function() {
    return 0;
};


!function(e1, t) {
    $c54b3d2ef9f9e60a$exports = t();
}(self, function() {
    return function() {
        var e1 = {
            9748: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    b: function() {
                        return Z;
                    }
                });
                var r = n(5385), o = n(9123), i = n(1971);
                function a(e1, t) {
                    var n = {};
                    return Object.assign(n, t), !n.stateToken && e1.stateToken && (n.stateToken = e1.stateToken), n;
                }
                function u(e1, t) {
                    return t = a(e1, t), (0, r.v_)(e1, e1.getIssuerOrigin() + "/api/v1/authn", t, {
                        withCredentials: !0
                    });
                }
                function c(e1) {
                    return !!f(e1);
                }
                function s(e1, t, n, o, i) {
                    return i = Object.assign({
                        withCredentials: !0
                    }, i), (0, r.v_)(e1, n, o, i).then(function(e1) {
                        return t.createTransaction(e1);
                    });
                }
                function f(e1) {
                    return e1.options.storageUtil.storage.get(i.STATE_TOKEN_KEY_NAME);
                }
                var l = n(3144), p = n(5671), d = n(4942), h = n(3193), v = n(4771), y = n(6718);
                function g(e1, t, n, i, u, c) {
                    if (Array.isArray(u)) return function(r, a) {
                        if (!r) throw new o.Z("Must provide a link name");
                        var s = (0, h.sE)(u, {
                            name: r
                        });
                        if (!s) throw new o.Z("No link found for that name");
                        return g(e1, t, n, i, s, c)(a);
                    };
                    if (u.hints && u.hints.allow && 1 === u.hints.allow.length) switch(u.hints.allow[0]){
                        case "GET":
                            return function() {
                                return (0, r.U2)(e1, u.href, {
                                    withCredentials: !0
                                });
                            };
                        case "POST":
                            return function(r) {
                                c && c.isPolling && (c.isPolling = !1);
                                var f = a(n, r);
                                "MFA_ENROLL" !== n.status && "FACTOR_ENROLL" !== n.status || Object.assign(f, {
                                    factorType: i.factorType,
                                    provider: i.provider
                                });
                                var l = {}, p = f.autoPush;
                                if (void 0 !== p) {
                                    if ("function" == typeof p) try {
                                        l.autoPush = !!p();
                                    } catch (e1) {
                                        return Promise.reject(new o.Z("AutoPush resulted in an error."));
                                    }
                                    else null !== p && (l.autoPush = !!p);
                                    f = (0, h.CE)(f, "autoPush");
                                }
                                var d = f.rememberDevice;
                                if (void 0 !== d) {
                                    if ("function" == typeof d) try {
                                        l.rememberDevice = !!d();
                                    } catch (e1) {
                                        return Promise.reject(new o.Z("RememberDevice resulted in an error."));
                                    }
                                    else null !== d && (l.rememberDevice = !!d);
                                    f = (0, h.CE)(f, "rememberDevice");
                                } else f.profile && void 0 !== f.profile.updatePhone && (f.profile.updatePhone && (l.updatePhone = !0), f.profile = (0, h.CE)(f.profile, "updatePhone"));
                                var v = u.href + (0, y.UK)(l);
                                return s(e1, t, v, f);
                            };
                    }
                }
                var m = n(8750), b = n(6573);
                function k(e1, t, n) {
                    return function(u) {
                        var c, s, f, l;
                        (0, v.hj)(u) ? c = u : (0, v.Kn)(u) && (c = u.delay, s = u.rememberDevice, f = u.autoPush, l = u.transactionCallBack), c || 0 === c || (c = i.DEFAULT_POLLING_DELAY);
                        var p = (0, h.Rg)(t, "next", "poll");
                        n.isPolling = !0;
                        var d = 0;
                        return (function i() {
                            return n.isPolling ? (function() {
                                var n = {};
                                if ("function" == typeof f) try {
                                    n.autoPush = !!f();
                                } catch (e1) {
                                    return Promise.reject(new o.Z("AutoPush resulted in an error."));
                                }
                                else null != f && (n.autoPush = !!f);
                                if ("function" == typeof s) try {
                                    n.rememberDevice = !!s();
                                } catch (e1) {
                                    return Promise.reject(new o.Z("RememberDevice resulted in an error."));
                                }
                                else null != s && (n.rememberDevice = !!s);
                                var i = p.href + (0, y.UK)(n);
                                return (0, r.v_)(e1, i, function(e1) {
                                    return a(e1);
                                }(t), {
                                    saveAuthnState: !1,
                                    withCredentials: !0,
                                    pollingIntent: !0
                                });
                            })().then(function(t) {
                                if (d = 0, t.factorResult && "WAITING" === t.factorResult) {
                                    if (!n.isPolling) throw new b.Z;
                                    return "function" == typeof l && l(t), (0, m.gw)(c).then(i);
                                }
                                return n.isPolling = !1, e1.tx.createTransaction(t);
                            }).catch(function(e1) {
                                if (e1.xhr && (0 === e1.xhr.status || 429 === e1.xhr.status) && d <= 4) {
                                    var t = 1e3 * Math.pow(2, d);
                                    return d++, (0, m.gw)(t).then(i);
                                }
                                throw e1;
                            }) : Promise.reject(new b.Z);
                        })().catch(function(e1) {
                            throw n.isPolling = !1, e1;
                        });
                    };
                }
                function w(e1, t, n, r, o) {
                    if (r = r || n, r = (0, h.d9)(r), Array.isArray(r)) {
                        for(var i = [], a = 0, u = r.length; a < u; a++)i.push(w(e1, t, n, r[a], o));
                        return i;
                    }
                    var c = r._embedded || {};
                    for(var s in c)Object.prototype.hasOwnProperty.call(c, s) && ((0, v.Kn)(c[s]) || Array.isArray(c[s])) && (c[s] = w(e1, t, n, c[s], o));
                    var f = function(e1, t, n, r, o) {
                        var i = {};
                        for(var a in r._links)if (Object.prototype.hasOwnProperty.call(r._links, a)) {
                            var u = r._links[a];
                            if ("next" === a && (a = u.name), u.type) i[a] = u;
                            else if ("poll" === a) i.poll = k(e1, n, o);
                            else {
                                var c = g(e1, t, n, r, u, o);
                                c && (i[a] = c);
                            }
                        }
                        return i;
                    }(e1, t, n, r, o);
                    return Object.assign(c, f), r = (0, h.CE)(r, "_embedded", "_links"), Object.assign(r, c), r;
                }
                var O = (0, l.Z)(function e1(t, n) {
                    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                    (0, p.Z)(this, e1), (0, d.Z)(this, "next", void 0), (0, d.Z)(this, "cancel", void 0), (0, d.Z)(this, "skip", void 0), (0, d.Z)(this, "unlock", void 0), (0, d.Z)(this, "changePassword", void 0), (0, d.Z)(this, "resetPassword", void 0), (0, d.Z)(this, "answer", void 0), (0, d.Z)(this, "recovery", void 0), (0, d.Z)(this, "verify", void 0), (0, d.Z)(this, "resend", void 0), (0, d.Z)(this, "activate", void 0), (0, d.Z)(this, "poll", void 0), (0, d.Z)(this, "prev", void 0), (0, d.Z)(this, "data", void 0), (0, d.Z)(this, "stateToken", void 0), (0, d.Z)(this, "sessionToken", void 0), (0, d.Z)(this, "status", void 0), (0, d.Z)(this, "user", void 0), (0, d.Z)(this, "factor", void 0), (0, d.Z)(this, "factors", void 0), (0, d.Z)(this, "policy", void 0), (0, d.Z)(this, "scopes", void 0), (0, d.Z)(this, "target", void 0), (0, d.Z)(this, "authentication", void 0), this.data = void 0, this.status = void 0, r && (this.data = r, Object.assign(this, w(t, n, r, r, {})), delete this.stateToken, "RECOVERY_CHALLENGE" !== r.status || r._links || (this.cancel = function() {
                        return Promise.resolve(n.createTransaction());
                    }));
                });
                function Z(e1) {
                    var t = {
                        status: u.bind(null, e1),
                        resume: function(n) {
                            return function(e1, t, n) {
                                if (!n || !n.stateToken) {
                                    var r = f(e1);
                                    if (!r) return Promise.reject(new o.Z("No transaction to resume"));
                                    n = {
                                        stateToken: r
                                    };
                                }
                                return u(e1, n).then(function(e1) {
                                    return t.createTransaction(e1);
                                });
                            }(e1, t, n);
                        },
                        exists: c.bind(null, e1),
                        introspect: function(n) {
                            return function(e1, t, n) {
                                if (!n || !n.stateToken) {
                                    var i = f(e1);
                                    if (!i) return Promise.reject(new o.Z("No transaction to evaluate"));
                                    n = {
                                        stateToken: i
                                    };
                                }
                                return (function(e1, t) {
                                    return t = a(e1, t), (0, r.v_)(e1, e1.getIssuerOrigin() + "/api/v1/authn/introspect", t, {
                                        withCredentials: !0
                                    });
                                })(e1, n).then(function(e1) {
                                    return t.createTransaction(e1);
                                });
                            }(e1, t, n);
                        },
                        createTransaction: function(n) {
                            return new O(e1, t, n);
                        },
                        postToTransaction: function(n, r, o) {
                            return s(e1, t, n, r, o);
                        }
                    };
                    return t;
                }
            },
            3398: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    b: function() {
                        return r.b;
                    },
                    t: function() {
                        return o.t;
                    }
                });
                var r = n(9748), o = n(3164);
            },
            3164: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    t: function() {
                        return y;
                    }
                });
                var r = n(5861), o = n(5671), i = n(3144), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(4687), p = n.n(l), d = n(3193), h = n(8719), v = n(9748);
                function y(e1) {
                    return function(e1) {
                        (0, u.Z)(m, e1);
                        var t, n, l, y, g = (l = m, y = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, t = (0, s.Z)(l);
                            if (y) {
                                var n = (0, s.Z)(this).constructor;
                                e1 = Reflect.construct(t, arguments, n);
                            } else e1 = t.apply(this, arguments);
                            return (0, c.Z)(this, e1);
                        });
                        function m() {
                            var e1;
                            (0, o.Z)(this, m);
                            for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                            return e1 = g.call.apply(g, [
                                this
                            ].concat(n)), (0, f.Z)((0, a.Z)(e1), "tx", void 0), (0, f.Z)((0, a.Z)(e1), "authn", void 0), (0, f.Z)((0, a.Z)(e1), "fingerprint", void 0), e1.authn = e1.tx = (0, v.b)((0, a.Z)(e1)), e1.fingerprint = h.Z.bind(null, (0, a.Z)(e1)), e1;
                        }
                        return (0, i.Z)(m, [
                            {
                                key: "signIn",
                                value: (n = (0, r.Z)(p().mark(function e1(t) {
                                    var n, r = this;
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t = (0, d.d9)(t || {}), n = function(e1) {
                                                    return delete t.sendFingerprint, r.tx.postToTransaction("/api/v1/authn", t, e1);
                                                }, t.sendFingerprint) {
                                                    e1.next = 4;
                                                    break;
                                                }
                                                return e1.abrupt("return", n());
                                            case 4:
                                                return e1.abrupt("return", this.fingerprint().then(function(e1) {
                                                    return n({
                                                        headers: {
                                                            "X-Device-Fingerprint": e1
                                                        }
                                                    });
                                                }));
                                            case 5:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return n.apply(this, arguments);
                                })
                            },
                            {
                                key: "signInWithCredentials",
                                value: (t = (0, r.Z)(p().mark(function e1(t) {
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.abrupt("return", this.signIn(t));
                                            case 1:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return t.apply(this, arguments);
                                })
                            },
                            {
                                key: "forgotPassword",
                                value: function(e1) {
                                    return this.tx.postToTransaction("/api/v1/authn/recovery/password", e1);
                                }
                            },
                            {
                                key: "unlockAccount",
                                value: function(e1) {
                                    return this.tx.postToTransaction("/api/v1/authn/recovery/unlock", e1);
                                }
                            },
                            {
                                key: "verifyRecoveryToken",
                                value: function(e1) {
                                    return this.tx.postToTransaction("/api/v1/authn/recovery/token", e1);
                                }
                            }
                        ]), m;
                    }(e1);
                }
            },
            9893: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return l;
                    }
                });
                var r = n(3144), o = n(5671), i = n(4942), a = n(3193), u = n(415), c = n(1971), s = n(4279), f = n.n(s);
                function l(e1) {
                    var t = (0, r.Z)(function t() {
                        (0, o.Z)(this, t), (0, i.Z)(this, "options", void 0), (0, i.Z)(this, "emitter", void 0), (0, i.Z)(this, "features", void 0);
                        var n = new e1(arguments.length && (arguments.length <= 0 ? void 0 : arguments[0]) || {});
                        this.options = (0, a.YY)(n), this.emitter = new (f()), this.features = u;
                    });
                    return (0, i.Z)(t, "features", u), (0, i.Z)(t, "constants", c), t.features = t.prototype.features = u, Object.assign(t, {
                        constants: c
                    }), t;
                }
            },
            3306: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return o.X;
                    },
                    a: function() {
                        return r.a;
                    }
                });
                var r = n(9893), o = n(5093);
            },
            5093: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return a;
                    }
                });
                var r = n(3144), o = n(5671), i = n(4942);
                function a() {
                    return (0, r.Z)(function e1(t) {
                        (0, o.Z)(this, e1), (0, i.Z)(this, "devMode", void 0), this.devMode = !!t.devMode;
                    });
                }
            },
            4858: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = arguments[t];
                        for(var r in n)e1[r] = n[r];
                    }
                    return e1;
                }
                n.d(t, {
                    Z: function() {
                        return f;
                    }
                });
                var o = function e1(t, n) {
                    function o(e1, o, i) {
                        if ("undefined" != typeof document) {
                            "number" == typeof (i = r({}, n, i)).expires && (i.expires = new Date(Date.now() + 864e5 * i.expires)), i.expires && (i.expires = i.expires.toUTCString()), e1 = encodeURIComponent(e1).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
                            var a = "";
                            for(var u in i)i[u] && (a += "; " + u, !0 !== i[u] && (a += "=" + i[u].split(";")[0]));
                            return document.cookie = e1 + "=" + t.write(o, e1) + a;
                        }
                    }
                    return Object.create({
                        set: o,
                        get: function(e1) {
                            if ("undefined" != typeof document && (!arguments.length || e1)) {
                                for(var n = document.cookie ? document.cookie.split("; ") : [], r = {}, o = 0; o < n.length; o++){
                                    var i = n[o].split("="), a = i.slice(1).join("=");
                                    try {
                                        var u = decodeURIComponent(i[0]);
                                        if (r[u] = t.read(a, u), e1 === u) break;
                                    } catch (e1) {}
                                }
                                return e1 ? r[e1] : r;
                            }
                        },
                        remove: function(e1, t) {
                            o(e1, "", r({}, t, {
                                expires: -1
                            }));
                        },
                        withAttributes: function(t) {
                            return e1(this.converter, r({}, this.attributes, t));
                        },
                        withConverter: function(t) {
                            return e1(r({}, this.converter, t), this.attributes);
                        }
                    }, {
                        attributes: {
                            value: Object.freeze(n)
                        },
                        converter: {
                            value: Object.freeze(t)
                        }
                    });
                }({
                    read: function(e1) {
                        return '"' === e1[0] && (e1 = e1.slice(1, -1)), e1.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
                    },
                    write: function(e1) {
                        return encodeURIComponent(e1).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
                    }
                }, {
                    path: "/"
                }), i = o, a = n(9123), u = n(146), c = n(415), s = {
                    browserHasLocalStorage: function() {
                        try {
                            var e1 = this.getLocalStorage();
                            return this.testStorage(e1);
                        } catch (e1) {
                            return !1;
                        }
                    },
                    browserHasSessionStorage: function() {
                        try {
                            var e1 = this.getSessionStorage();
                            return this.testStorage(e1);
                        } catch (e1) {
                            return !1;
                        }
                    },
                    testStorageType: function(e1) {
                        var t = !1;
                        switch(e1){
                            case "sessionStorage":
                                t = this.browserHasSessionStorage();
                                break;
                            case "localStorage":
                                t = this.browserHasLocalStorage();
                                break;
                            case "cookie":
                            case "memory":
                                t = !0;
                                break;
                            default:
                                t = !1;
                        }
                        return t;
                    },
                    getStorageByType: function(e1, t) {
                        var n;
                        switch(e1){
                            case "sessionStorage":
                                n = this.getSessionStorage();
                                break;
                            case "localStorage":
                                n = this.getLocalStorage();
                                break;
                            case "cookie":
                                n = this.getCookieStorage(t);
                                break;
                            case "memory":
                                n = this.getInMemoryStorage();
                                break;
                            default:
                                throw new a.Z("Unrecognized storage option: ".concat(e1));
                        }
                        return n;
                    },
                    findStorageType: function(e1) {
                        var t, n;
                        return t = (e1 = e1.slice()).shift(), (n = e1.length ? e1[0] : null) ? this.testStorageType(t) ? t : ((0, u.ZK)("This browser doesn't support ".concat(t, ". Switching to ").concat(n, ".")), this.findStorageType(e1)) : t;
                    },
                    getLocalStorage: function() {
                        return (0, c.isIE11OrLess)() && !window.onstorage && (window.onstorage = function() {}), localStorage;
                    },
                    getSessionStorage: function() {
                        return sessionStorage;
                    },
                    getCookieStorage: function(e1) {
                        var t = this, n = e1.secure, r = e1.sameSite, o = e1.sessionCookie;
                        if (void 0 === n || void 0 === r) throw new a.Z('getCookieStorage: "secure" and "sameSite" options must be provided');
                        var i = {
                            getItem: this.storage.get,
                            setItem: function(e1, i) {
                                var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "2200-01-01T00:00:00.000Z";
                                a = o ? null : a, t.storage.set(e1, i, a, {
                                    secure: n,
                                    sameSite: r
                                });
                            },
                            removeItem: function(e1) {
                                t.storage.delete(e1);
                            }
                        };
                        return e1.useSeparateCookies ? {
                            getItem: function(e1) {
                                var t = i.getItem(), n = {};
                                return Object.keys(t).forEach(function(r) {
                                    0 === r.indexOf(e1) && (n[r.replace("".concat(e1, "_"), "")] = JSON.parse(t[r]));
                                }), JSON.stringify(n);
                            },
                            setItem: function(e1, t) {
                                var n = JSON.parse(this.getItem(e1));
                                t = JSON.parse(t), Object.keys(t).forEach(function(r) {
                                    var o = e1 + "_" + r, a = JSON.stringify(t[r]);
                                    i.setItem(o, a), delete n[r];
                                }), Object.keys(n).forEach(function(t) {
                                    i.removeItem(e1 + "_" + t);
                                });
                            },
                            removeItem: function(e1) {
                                var t = JSON.parse(this.getItem(e1));
                                Object.keys(t).forEach(function(t) {
                                    i.removeItem(e1 + "_" + t);
                                });
                            }
                        } : i;
                    },
                    inMemoryStore: {},
                    getInMemoryStorage: function() {
                        var e1 = this;
                        return {
                            getItem: function(t) {
                                return e1.inMemoryStore[t];
                            },
                            setItem: function(t, n) {
                                e1.inMemoryStore[t] = n;
                            }
                        };
                    },
                    testStorage: function(e1) {
                        var t = "okta-test-storage";
                        try {
                            return e1.setItem(t, t), e1.removeItem(t), !0;
                        } catch (e1) {
                            return !1;
                        }
                    },
                    storage: {
                        set: function(e1, t, n, r) {
                            var o = r.sameSite, u = r.secure;
                            if (void 0 === u || void 0 === o) throw new a.Z('storage.set: "secure" and "sameSite" options must be provided');
                            var c = {
                                path: r.path || "/",
                                secure: u,
                                sameSite: o
                            };
                            return Date.parse(n) && (c.expires = new Date(n)), i.set(e1, t, c), this.get(e1);
                        },
                        get: function(e1) {
                            return arguments.length ? i.get(e1) : i.get();
                        },
                        delete: function(e1) {
                            return i.remove(e1, {
                                path: "/"
                            });
                        }
                    }
                }, f = s;
            },
            8719: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return u;
                    }
                });
                var r = n(9123), o = n(415), i = n(4970), a = function(e1, t) {
                    return t.source === e1.contentWindow;
                };
                function u(e1, t) {
                    var n;
                    if (!(0, o.isFingerprintSupported)()) return Promise.reject(new r.Z("Fingerprinting is not supported on this device"));
                    var u, c, s, f = null !== (n = null == t ? void 0 : t.container) && void 0 !== n ? n : document.body;
                    return new Promise(function(n, o) {
                        (c = document.createElement("iframe")).style.display = "none", s = function(t) {
                            if (a(c, t) && t && t.data && t.origin === e1.getIssuerOrigin()) {
                                var i, u, s;
                                try {
                                    i = JSON.parse(t.data);
                                } catch (e1) {
                                    return;
                                }
                                if (i) return "FingerprintAvailable" === i.type ? n(i.fingerprint) : "FingerprintServiceReady" !== i.type ? o(new r.Z("No data")) : void (null === (u = c) || void 0 === u || null === (s = u.contentWindow) || void 0 === s || s.postMessage(JSON.stringify({
                                    type: "GetFingerprint"
                                }), t.origin));
                            }
                        }, (0, i.NH)(window, "message", s), c.src = e1.getIssuerOrigin() + "/auth/services/devicefingerprint", f.appendChild(c), u = setTimeout(function() {
                            o(new r.Z("Fingerprinting timed out"));
                        }, (null == t ? void 0 : t.timeout) || 15e3);
                    }).finally(function() {
                        var e1;
                        clearTimeout(u), (0, i.ys)(window, "message", s), f.contains(c) && (null === (e1 = c.parentElement) || void 0 === e1 || e1.removeChild(c));
                    });
                }
            },
            1971: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    ACCESS_TOKEN_STORAGE_KEY: function() {
                        return v;
                    },
                    CACHE_STORAGE_NAME: function() {
                        return s;
                    },
                    DEFAULT_CACHE_DURATION: function() {
                        return u;
                    },
                    DEFAULT_CODE_CHALLENGE_METHOD: function() {
                        return w;
                    },
                    DEFAULT_MAX_CLOCK_SKEW: function() {
                        return a;
                    },
                    DEFAULT_POLLING_DELAY: function() {
                        return o;
                    },
                    IDX_API_VERSION: function() {
                        return O;
                    },
                    IDX_RESPONSE_STORAGE_NAME: function() {
                        return h;
                    },
                    ID_TOKEN_STORAGE_KEY: function() {
                        return y;
                    },
                    IOS_MAX_RETRY_COUNT: function() {
                        return i;
                    },
                    MAX_VERIFIER_LENGTH: function() {
                        return k;
                    },
                    MIN_VERIFIER_LENGTH: function() {
                        return b;
                    },
                    ORIGINAL_URI_STORAGE_NAME: function() {
                        return d;
                    },
                    PKCE_STORAGE_NAME: function() {
                        return f;
                    },
                    REFERRER_PATH_STORAGE_KEY: function() {
                        return m;
                    },
                    REFRESH_TOKEN_STORAGE_KEY: function() {
                        return g;
                    },
                    SHARED_TRANSACTION_STORAGE_NAME: function() {
                        return p;
                    },
                    STATE_TOKEN_KEY_NAME: function() {
                        return r;
                    },
                    TOKEN_STORAGE_NAME: function() {
                        return c;
                    },
                    TRANSACTION_STORAGE_NAME: function() {
                        return l;
                    }
                });
                var r = "oktaStateToken", o = 500, i = 3, a = 300, u = 86400, c = "okta-token-storage", s = "okta-cache-storage", f = "okta-pkce-storage", l = "okta-transaction-storage", p = "okta-shared-transaction-storage", d = "okta-original-uri-storage", h = "okta-idx-response-storage", v = "accessToken", y = "idToken", g = "refreshToken", m = "referrerPath", b = 43, k = 128, w = "S256", O = "1.0.0";
            },
            1018: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    E: function() {
                        return k;
                    },
                    a: function() {
                        return g;
                    }
                });
                var r = n(5861), o = n(5671), i = n(3144), a = n(4942), u = n(4687), c = n.n(u), s = n(3615), f = n.n(s), l = n(9123), p = n(7088), d = n(3548), h = n(146);
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, a.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var g = null, m = {
                    updateAuthStatePromise: null,
                    canceledTimes: 0
                }, b = "authStateChange", k = function() {
                    function e1(t) {
                        var n = this;
                        if ((0, o.Z)(this, e1), (0, a.Z)(this, "_sdk", void 0), (0, a.Z)(this, "_pending", void 0), (0, a.Z)(this, "_authState", void 0), (0, a.Z)(this, "_prevAuthState", void 0), (0, a.Z)(this, "_logOptions", void 0), (0, a.Z)(this, "_transformQueue", void 0), !t.emitter) throw new l.Z("Emitter should be initialized before AuthStateManager");
                        this._sdk = t, this._pending = y({}, m), this._authState = g, this._logOptions = {}, this._prevAuthState = null, this._transformQueue = new d.b({
                            quiet: !0
                        }), t.tokenManager.on(p.O3, function(e1, t) {
                            n._setLogOptions({
                                event: p.O3,
                                key: e1,
                                token: t
                            }), n.updateAuthState();
                        }), t.tokenManager.on(p.FT, function(e1, t) {
                            n._setLogOptions({
                                event: p.FT,
                                key: e1,
                                token: t
                            }), n.updateAuthState();
                        });
                    }
                    var t;
                    return (0, i.Z)(e1, [
                        {
                            key: "_setLogOptions",
                            value: function(e1) {
                                this._logOptions = e1;
                            }
                        },
                        {
                            key: "getAuthState",
                            value: function() {
                                return this._authState;
                            }
                        },
                        {
                            key: "getPreviousAuthState",
                            value: function() {
                                return this._prevAuthState;
                            }
                        },
                        {
                            key: "updateAuthState",
                            value: (t = (0, r.Z)(c().mark(function e1() {
                                var t, n, r, o, i, a, u, s = this;
                                return c().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (t = this._sdk.options, n = t.transformAuthState, r = t.devMode, o = function(e1) {
                                                var t = s._logOptions, n = t.event, r = t.key, o = t.token;
                                                (0, h.dr)().group("OKTA-AUTH-JS:updateAuthState: Event:".concat(n, " Status:").concat(e1)), (0, h.dr)().log(r, o), (0, h.dr)().log("Current authState", s._authState), (0, h.dr)().groupEnd(), s._logOptions = {};
                                            }, i = function(e1) {
                                                var t, n;
                                                n = e1, (t = s._authState) && t.isAuthenticated === n.isAuthenticated && JSON.stringify(t.idToken) === JSON.stringify(n.idToken) && JSON.stringify(t.accessToken) === JSON.stringify(n.accessToken) && t.error === n.error ? r && o("unchanged") : (s._prevAuthState = s._authState, s._authState = e1, s._sdk.emitter.emit(b, y({}, e1)), r && o("emitted"));
                                            }, a = function e1(t) {
                                                return s._pending.updateAuthStatePromise.then(function() {
                                                    var n = s._pending.updateAuthStatePromise;
                                                    return n && n !== t ? e1(n) : s.getAuthState();
                                                });
                                            }, !this._pending.updateAuthStatePromise) {
                                                e1.next = 11;
                                                break;
                                            }
                                            if (!(this._pending.canceledTimes >= 10)) {
                                                e1.next = 10;
                                                break;
                                            }
                                            return r && o("terminated"), e1.abrupt("return", a(this._pending.updateAuthStatePromise));
                                        case 10:
                                            this._pending.updateAuthStatePromise.cancel();
                                        case 11:
                                            return u = new (f())(function(e1, t, a) {
                                                a.shouldReject = !1, a(function() {
                                                    s._pending.updateAuthStatePromise = null, s._pending.canceledTimes = s._pending.canceledTimes + 1, r && o("canceled");
                                                });
                                                var c = function(t) {
                                                    u.isCanceled ? e1() : (i(t), e1(), s._pending = y({}, m));
                                                };
                                                s._sdk.isAuthenticated().then(function() {
                                                    if (u.isCanceled) e1();
                                                    else {
                                                        var t = s._sdk.tokenManager.getTokensSync(), r = t.accessToken, o = t.idToken, i = t.refreshToken, a = {
                                                            accessToken: r,
                                                            idToken: o,
                                                            refreshToken: i,
                                                            isAuthenticated: !(!r || !o)
                                                        };
                                                        (n ? s._transformQueue.push(n, null, s._sdk, a) : Promise.resolve(a)).then(function(e1) {
                                                            return c(e1);
                                                        }).catch(function(e1) {
                                                            return c({
                                                                accessToken: r,
                                                                idToken: o,
                                                                refreshToken: i,
                                                                isAuthenticated: !1,
                                                                error: e1
                                                            });
                                                        });
                                                    }
                                                });
                                            }), this._pending.updateAuthStatePromise = u, e1.abrupt("return", a(u));
                                        case 14:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "subscribe",
                            value: function(e1) {
                                this._sdk.emitter.on(b, e1);
                            }
                        },
                        {
                            key: "unsubscribe",
                            value: function(e1) {
                                this._sdk.emitter.off(b, e1);
                            }
                        }
                    ]), e1;
                }();
            },
            4376: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    W: function() {
                        return ye;
                    }
                });
                var r = n(885), o = n(2982), i = n(5861), a = n(5671), u = n(3144), c = n(4942), s = n(4687), f = n.n(s);
                Promise.resolve(!1);
                var l = Promise.resolve(!0), p = Promise.resolve();
                function d(e1, t) {
                    return e1 || (e1 = 0), new Promise(function(n) {
                        return setTimeout(function() {
                            return n(t);
                        }, e1);
                    });
                }
                function h() {
                    return Math.random().toString(36).substring(2);
                }
                var v = 0;
                function y() {
                    var e1 = 1e3 * Date.now();
                    return e1 <= v && (e1 = v + 1), v = e1, e1;
                }
                var g = {
                    create: function(e1) {
                        var t = {
                            time: y(),
                            messagesCallback: null,
                            bc: new BroadcastChannel(e1),
                            subFns: []
                        };
                        return t.bc.onmessage = function(e1) {
                            t.messagesCallback && t.messagesCallback(e1.data);
                        }, t;
                    },
                    close: function(e1) {
                        e1.bc.close(), e1.subFns = [];
                    },
                    onMessage: function(e1, t) {
                        e1.messagesCallback = t;
                    },
                    postMessage: function(e1, t) {
                        try {
                            return e1.bc.postMessage(t, !1), p;
                        } catch (e1) {
                            return Promise.reject(e1);
                        }
                    },
                    canBeUsed: function() {
                        if ("undefined" != typeof globalThis && globalThis.Deno && globalThis.Deno.args) return !0;
                        if ("undefined" == typeof window && "undefined" == typeof self || "function" != typeof BroadcastChannel) return !1;
                        if (BroadcastChannel._pubkey) throw new Error("BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill");
                        return !0;
                    },
                    type: "native",
                    averageResponseTime: function() {
                        return 150;
                    },
                    microSeconds: y
                };
                class m {
                    ttl;
                    map = new Map;
                    _to = !1;
                    constructor(e1){
                        this.ttl = e1;
                    }
                    has(e1) {
                        return this.map.has(e1);
                    }
                    add(e1) {
                        this.map.set(e1, b()), this._to || (this._to = !0, setTimeout(()=>{
                            this._to = !1, function(e1) {
                                const t = b() - e1.ttl, n = e1.map[Symbol.iterator]();
                                for(;;){
                                    const r = n.next().value;
                                    if (!r) return;
                                    const o = r[0];
                                    if (!(r[1] < t)) return;
                                    e1.map.delete(o);
                                }
                            }(this);
                        }, 0));
                    }
                    clear() {
                        this.map.clear();
                    }
                }
                function b() {
                    return Date.now();
                }
                function k() {
                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = JSON.parse(JSON.stringify(e1));
                    return void 0 === t.webWorkerSupport && (t.webWorkerSupport = !0), t.idb || (t.idb = {}), t.idb.ttl || (t.idb.ttl = 45e3), t.idb.fallbackInterval || (t.idb.fallbackInterval = 150), e1.idb && "function" == typeof e1.idb.onclose && (t.idb.onclose = e1.idb.onclose), t.localstorage || (t.localstorage = {}), t.localstorage.removeTimeout || (t.localstorage.removeTimeout = 6e4), e1.methods && (t.methods = e1.methods), t.node || (t.node = {}), t.node.ttl || (t.node.ttl = 12e4), t.node.maxParallelWrites || (t.node.maxParallelWrites = 2048), void 0 === t.node.useFastPath && (t.node.useFastPath = !0), t;
                }
                var w = "messages", O = {
                    durability: "relaxed"
                };
                function Z() {
                    if ("undefined" != typeof indexedDB) return indexedDB;
                    if ("undefined" != typeof window) {
                        if (void 0 !== window.mozIndexedDB) return window.mozIndexedDB;
                        if (void 0 !== window.webkitIndexedDB) return window.webkitIndexedDB;
                        if (void 0 !== window.msIndexedDB) return window.msIndexedDB;
                    }
                    return !1;
                }
                function T(e1) {
                    e1.commit && e1.commit();
                }
                function E(e1) {
                    e1.closed || S(e1).then(function() {
                        return d(e1.options.idb.fallbackInterval);
                    }).then(function() {
                        return E(e1);
                    });
                }
                function S(e1) {
                    return e1.closed ? p : e1.messagesCallback ? (function(e1, t) {
                        var n = e1.transaction(w, "readonly", O), r = n.objectStore(w), o = [], i = IDBKeyRange.bound(t + 1, 1 / 0);
                        if (r.getAll) {
                            var a = r.getAll(i);
                            return new Promise(function(e1, t) {
                                a.onerror = function(e1) {
                                    return t(e1);
                                }, a.onsuccess = function(t) {
                                    e1(t.target.result);
                                };
                            });
                        }
                        return new Promise(function(e1, a) {
                            var u = function() {
                                try {
                                    return i = IDBKeyRange.bound(t + 1, 1 / 0), r.openCursor(i);
                                } catch (e1) {
                                    return r.openCursor();
                                }
                            }();
                            u.onerror = function(e1) {
                                return a(e1);
                            }, u.onsuccess = function(r) {
                                var i = r.target.result;
                                i ? i.value.id < t + 1 ? i.continue(t + 1) : (o.push(i.value), i.continue()) : (T(n), e1(o));
                            };
                        });
                    })(e1.db, e1.lastCursorId).then(function(t) {
                        var n = t.filter(function(e1) {
                            return !!e1;
                        }).map(function(t) {
                            return t.id > e1.lastCursorId && (e1.lastCursorId = t.id), t;
                        }).filter(function(t) {
                            return function(e1, t) {
                                return !(e1.uuid === t.uuid || t.eMIs.has(e1.id) || e1.data.time < t.messagesCallbackTime);
                            }(t, e1);
                        }).sort(function(e1, t) {
                            return e1.time - t.time;
                        });
                        return n.forEach(function(t) {
                            e1.messagesCallback && (e1.eMIs.add(t.id), e1.messagesCallback(t.data));
                        }), p;
                    }) : p;
                }
                var P = {
                    create: function(e1, t) {
                        return t = k(t), (function(e1) {
                            var t = "pubkey.broadcast-channel-0-" + e1, n = Z().open(t);
                            return n.onupgradeneeded = function(e1) {
                                e1.target.result.createObjectStore(w, {
                                    keyPath: "id",
                                    autoIncrement: !0
                                });
                            }, new Promise(function(e1, t) {
                                n.onerror = function(e1) {
                                    return t(e1);
                                }, n.onsuccess = function() {
                                    e1(n.result);
                                };
                            });
                        })(e1).then(function(n) {
                            var r = {
                                closed: !1,
                                lastCursorId: 0,
                                channelName: e1,
                                options: t,
                                uuid: h(),
                                eMIs: new m(2 * t.idb.ttl),
                                writeBlockPromise: p,
                                messagesCallback: null,
                                readQueuePromises: [],
                                db: n
                            };
                            return n.onclose = function() {
                                r.closed = !0, t.idb.onclose && t.idb.onclose();
                            }, E(r), r;
                        });
                    },
                    close: function(e1) {
                        e1.closed = !0, e1.db.close();
                    },
                    onMessage: function(e1, t, n) {
                        e1.messagesCallbackTime = n, e1.messagesCallback = t, S(e1);
                    },
                    postMessage: function(e1, t) {
                        return e1.writeBlockPromise = e1.writeBlockPromise.then(function() {
                            return function(e1, t, n) {
                                var r = {
                                    uuid: t,
                                    time: Date.now(),
                                    data: n
                                }, o = e1.transaction([
                                    w
                                ], "readwrite", O);
                                return new Promise(function(e1, t) {
                                    o.oncomplete = function() {
                                        return e1();
                                    }, o.onerror = function(e1) {
                                        return t(e1);
                                    }, o.objectStore(w).add(r), T(o);
                                });
                            }(e1.db, e1.uuid, t);
                        }).then(function() {
                            0 === Math.floor(11 * Math.random() + 0) && function(e1) {
                                var t, n, r, o, i, a;
                                return (t = e1.db, n = e1.options.idb.ttl, r = Date.now() - n, o = t.transaction(w, "readonly", O), i = o.objectStore(w), a = [], new Promise(function(e1) {
                                    i.openCursor().onsuccess = function(t) {
                                        var n = t.target.result;
                                        if (n) {
                                            var i = n.value;
                                            i.time < r ? (a.push(i), n.continue()) : (T(o), e1(a));
                                        } else e1(a);
                                    };
                                })).then(function(t) {
                                    return function(e1, t) {
                                        if (e1.closed) return Promise.resolve([]);
                                        var n = e1.db.transaction(w, "readwrite", O).objectStore(w);
                                        return Promise.all(t.map(function(e1) {
                                            var t = n.delete(e1);
                                            return new Promise(function(e1) {
                                                t.onsuccess = function() {
                                                    return e1();
                                                };
                                            });
                                        }));
                                    }(e1, t.map(function(e1) {
                                        return e1.id;
                                    }));
                                });
                            }(e1);
                        }), e1.writeBlockPromise;
                    },
                    canBeUsed: function() {
                        return !!Z();
                    },
                    type: "idb",
                    averageResponseTime: function(e1) {
                        return 2 * e1.idb.fallbackInterval;
                    },
                    microSeconds: y
                };
                function x() {
                    var e1;
                    if ("undefined" == typeof window) return null;
                    try {
                        e1 = window.localStorage, e1 = window["ie8-eventlistener/storage"] || window.localStorage;
                    } catch (e1) {}
                    return e1;
                }
                function A(e1) {
                    return "pubkey.broadcastChannel-" + e1;
                }
                function R() {
                    var e1 = x();
                    if (!e1) return !1;
                    try {
                        var t = "__broadcastchannel_check";
                        e1.setItem(t, "works"), e1.removeItem(t);
                    } catch (e1) {
                        return !1;
                    }
                    return !0;
                }
                var _ = {
                    create: function(e1, t) {
                        if (t = k(t), !R()) throw new Error("BroadcastChannel: localstorage cannot be used");
                        var n = h(), r = new m(t.localstorage.removeTimeout), o = {
                            channelName: e1,
                            uuid: n,
                            eMIs: r
                        };
                        return o.listener = function(e1, t) {
                            var i = A(e1), a = function(e1) {
                                var t;
                                e1.key === i && (t = JSON.parse(e1.newValue), o.messagesCallback && t.uuid !== n && t.token && !r.has(t.token) && (t.data.time && t.data.time < o.messagesCallbackTime || (r.add(t.token), o.messagesCallback(t.data))));
                            };
                            return window.addEventListener("storage", a), a;
                        }(e1), o;
                    },
                    close: function(e1) {
                        var t;
                        t = e1.listener, window.removeEventListener("storage", t);
                    },
                    onMessage: function(e1, t, n) {
                        e1.messagesCallbackTime = n, e1.messagesCallback = t;
                    },
                    postMessage: function(e1, t) {
                        return new Promise(function(n) {
                            d().then(function() {
                                var r = A(e1.channelName), o = {
                                    token: h(),
                                    time: Date.now(),
                                    data: t,
                                    uuid: e1.uuid
                                }, i = JSON.stringify(o);
                                x().setItem(r, i);
                                var a = document.createEvent("Event");
                                a.initEvent("storage", !0, !0), a.key = r, a.newValue = i, window.dispatchEvent(a), n();
                            });
                        });
                    },
                    canBeUsed: R,
                    type: "localstorage",
                    averageResponseTime: function() {
                        var e1 = navigator.userAgent.toLowerCase();
                        return e1.includes("safari") && !e1.includes("chrome") ? 240 : 120;
                    },
                    microSeconds: y
                }, j = y, C = new Set, I = {
                    create: function(e1) {
                        var t = {
                            time: j(),
                            name: e1,
                            messagesCallback: null
                        };
                        return C.add(t), t;
                    },
                    close: function(e1) {
                        C.delete(e1);
                    },
                    onMessage: function(e1, t) {
                        e1.messagesCallback = t;
                    },
                    postMessage: function(e1, t) {
                        return new Promise(function(n) {
                            return setTimeout(function() {
                                Array.from(C).forEach(function(n) {
                                    n.name === e1.name && n !== e1 && n.messagesCallback && n.time < t.time && n.messagesCallback(t);
                                }), n();
                            }, 5);
                        });
                    },
                    canBeUsed: function() {
                        return !0;
                    },
                    type: "simulate",
                    averageResponseTime: function() {
                        return 5;
                    },
                    microSeconds: j
                }, D = [
                    g,
                    P,
                    _
                ], M = new Set, N = 0, U = function(e1, t) {
                    var n, r, o;
                    this.id = N++, M.add(this), this.name = e1, this.options = k(t), this.method = function(e1) {
                        var t = [].concat(e1.methods, D).filter(Boolean);
                        if (e1.type) {
                            if ("simulate" === e1.type) return I;
                            var n = t.find(function(t) {
                                return t.type === e1.type;
                            });
                            if (n) return n;
                            throw new Error("method-type " + e1.type + " not found");
                        }
                        e1.webWorkerSupport || (t = t.filter(function(e1) {
                            return "idb" !== e1.type;
                        }));
                        var r = t.find(function(e1) {
                            return e1.canBeUsed();
                        });
                        if (r) return r;
                        throw new Error("No usable method found in " + JSON.stringify(D.map(function(e1) {
                            return e1.type;
                        })));
                    }(this.options), this._iL = !1, this._onML = null, this._addEL = {
                        message: [],
                        internal: []
                    }, this._uMP = new Set, this._befC = [], this._prepP = null, (o = r = (n = this).method.create(n.name, n.options)) && "function" == typeof o.then ? (n._prepP = r, r.then(function(e1) {
                        n._state = e1;
                    })) : n._state = r;
                };
                function L(e1, t, n) {
                    var r = {
                        time: e1.method.microSeconds(),
                        type: t,
                        data: n
                    };
                    return (e1._prepP ? e1._prepP : p).then(function() {
                        var t = e1.method.postMessage(e1._state, r);
                        return e1._uMP.add(t), t.catch().then(function() {
                            return e1._uMP.delete(t);
                        }), t;
                    });
                }
                function H(e1) {
                    return e1._addEL.message.length > 0 || e1._addEL.internal.length > 0;
                }
                function B(e1, t, n) {
                    e1._addEL[t].push(n), function(e1) {
                        if (!e1._iL && H(e1)) {
                            var t = function(t) {
                                e1._addEL[t.type].forEach(function(e1) {
                                    t.time >= e1.time && e1.fn(t.data);
                                });
                            }, n = e1.method.microSeconds();
                            e1._prepP ? e1._prepP.then(function() {
                                e1._iL = !0, e1.method.onMessage(e1._state, t, n);
                            }) : (e1._iL = !0, e1.method.onMessage(e1._state, t, n));
                        }
                    }(e1);
                }
                function K(e1, t, n) {
                    e1._addEL[t] = e1._addEL[t].filter(function(e1) {
                        return e1 !== n;
                    }), function(e1) {
                        if (e1._iL && !H(e1)) {
                            e1._iL = !1;
                            var t = e1.method.microSeconds();
                            e1.method.onMessage(e1._state, null, t);
                        }
                    }(e1);
                }
                U._pubkey = !0, U.prototype = {
                    postMessage: function(e1) {
                        if (this.closed) throw new Error("BroadcastChannel.postMessage(): Cannot post message after channel has closed " + JSON.stringify(e1));
                        return L(this, "message", e1);
                    },
                    postInternal: function(e1) {
                        return L(this, "internal", e1);
                    },
                    set onmessage (e){
                        var t1 = {
                            time: this.method.microSeconds(),
                            fn: e
                        };
                        K(this, "message", this._onML), e && "function" == typeof e ? (this._onML = t1, B(this, "message", t1)) : this._onML = null;
                    },
                    addEventListener: function(e1, t) {
                        B(this, e1, {
                            time: this.method.microSeconds(),
                            fn: t
                        });
                    },
                    removeEventListener: function(e1, t) {
                        K(this, e1, this._addEL[e1].find(function(e1) {
                            return e1.fn === t;
                        }));
                    },
                    close: function() {
                        var e1 = this;
                        if (!this.closed) {
                            M.delete(this), this.closed = !0;
                            var t = this._prepP ? this._prepP : p;
                            return this._onML = null, this._addEL.message = [], t.then(function() {
                                return Promise.all(Array.from(e1._uMP));
                            }).then(function() {
                                return Promise.all(e1._befC.map(function(e1) {
                                    return e1();
                                }));
                            }).then(function() {
                                return e1.method.close(e1._state);
                            });
                        }
                    },
                    get type () {
                        return this.method.type;
                    },
                    get isClosed () {
                        return this.closed;
                    }
                };
                var F = "[object process]" === Object.prototype.toString.call(0) ? function(e1) {
                    $fcfa90861d16c270$exports.on("exit", function() {
                        return e1();
                    }), $fcfa90861d16c270$exports.on("beforeExit", function() {
                        return e1().then(function() {
                            return $fcfa90861d16c270$exports.exit();
                        });
                    }), $fcfa90861d16c270$exports.on("SIGINT", function() {
                        return e1().then(function() {
                            return $fcfa90861d16c270$exports.exit();
                        });
                    }), $fcfa90861d16c270$exports.on("uncaughtException", function(t) {
                        return e1().then(function() {
                            console.trace(t), $fcfa90861d16c270$exports.exit(101);
                        });
                    });
                } : function(e1) {
                    if ("function" == typeof WorkerGlobalScope && self instanceof WorkerGlobalScope) {
                        var t = self.close.bind(self);
                        self.close = function() {
                            return e1(), t();
                        };
                    } else {
                        if ("function" != typeof window.addEventListener) return;
                        window.addEventListener("beforeunload", function() {
                            e1();
                        }, !0), window.addEventListener("unload", function() {
                            e1();
                        }, !0);
                    }
                }, G = new Set, V = !1;
                function q() {
                    var e1 = [];
                    return G.forEach(function(t) {
                        e1.push(t()), G.delete(t);
                    }), Promise.all(e1);
                }
                function W(e1, t) {
                    var n = {
                        context: "leader",
                        action: t,
                        token: e1.token
                    };
                    return e1.broadcastChannel.postInternal(n);
                }
                function Y(e1) {
                    e1.isLeader = !0, e1._hasLeader = !0;
                    var t = function(e1) {
                        if (V || (V = !0, F(q)), "function" != typeof e1) throw new Error("Listener is no function");
                        return G.add(e1), {
                            remove: function() {
                                return G.delete(e1);
                            },
                            run: function() {
                                return G.delete(e1), e1();
                            }
                        };
                    }(function() {
                        return e1.die();
                    });
                    e1._unl.push(t);
                    var n = function(t) {
                        "leader" === t.context && "apply" === t.action && W(e1, "tell"), "leader" !== t.context || "tell" !== t.action || e1._dpLC || (e1._dpLC = !0, e1._dpL(), W(e1, "tell"));
                    };
                    return e1.broadcastChannel.addEventListener("internal", n), e1._lstns.push(n), W(e1, "tell");
                }
                var z = function(e1, t) {
                    var n = this;
                    this.broadcastChannel = e1, e1._befC.push(function() {
                        return n.die();
                    }), this._options = t, this.isLeader = !1, this.isDead = !1, this.token = h(), this._lstns = [], this._unl = [], this._dpL = function() {}, this._dpLC = !1, this._wKMC = {}, this.lN = "pubkey-bc||" + e1.method.type + "||" + e1.name;
                };
                z.prototype = {
                    hasLeader: function() {
                        var e1 = this;
                        return navigator.locks.query().then(function(t) {
                            var n = t.held ? t.held.filter(function(t) {
                                return t.name === e1.lN;
                            }) : [];
                            return !!(n && n.length > 0);
                        });
                    },
                    awaitLeadership: function() {
                        var e1 = this;
                        if (!this._wLMP) {
                            this._wKMC.c = new AbortController;
                            var t = new Promise(function(t, n) {
                                e1._wKMC.res = t, e1._wKMC.rej = n;
                            });
                            this._wLMP = new Promise(function(n) {
                                navigator.locks.request(e1.lN, {
                                    signal: e1._wKMC.c.signal
                                }, function() {
                                    return e1._wKMC.c = void 0, Y(e1), n(), t;
                                }).catch(function() {});
                            });
                        }
                        return this._wLMP;
                    },
                    set onduplicate (e){},
                    die: function() {
                        var e1 = this;
                        return this._lstns.forEach(function(t) {
                            return e1.broadcastChannel.removeEventListener("internal", t);
                        }), this._lstns = [], this._unl.forEach(function(e1) {
                            return e1.remove();
                        }), this._unl = [], this.isLeader && (this.isLeader = !1), this.isDead = !0, this._wKMC.res && this._wKMC.res(), this._wKMC.c && this._wKMC.c.abort("LeaderElectionWebLock.die() called"), W(this, "death");
                    }
                };
                var Q = function(e1, t) {
                    var n = this;
                    this.broadcastChannel = e1, this._options = t, this.isLeader = !1, this._hasLeader = !1, this.isDead = !1, this.token = h(), this._aplQ = p, this._aplQC = 0, this._unl = [], this._lstns = [], this._dpL = function() {}, this._dpLC = !1;
                    var r = function(e1) {
                        "leader" === e1.context && ("death" === e1.action && (n._hasLeader = !1), "tell" === e1.action && (n._hasLeader = !0));
                    };
                    this.broadcastChannel.addEventListener("internal", r), this._lstns.push(r);
                };
                function X(e1, t) {
                    if (e1._leaderElector) throw new Error("BroadcastChannel already has a leader-elector");
                    t = function(e1, t) {
                        return e1 || (e1 = {}), (e1 = JSON.parse(JSON.stringify(e1))).fallbackInterval || (e1.fallbackInterval = 3e3), e1.responseTime || (e1.responseTime = t.method.averageResponseTime(t.options)), e1;
                    }(t, e1);
                    var n = "undefined" != typeof navigator && void 0 !== navigator.locks && "function" == typeof navigator.locks.request ? new z(e1, t) : new Q(e1, t);
                    return e1._befC.push(function() {
                        return n.die();
                    }), e1._leaderElector = n, n;
                }
                Q.prototype = {
                    hasLeader: function() {
                        return Promise.resolve(this._hasLeader);
                    },
                    applyOnce: function(e1) {
                        var t = this;
                        return this.isLeader ? d(0, !0) : this.isDead ? d(0, !1) : this._aplQC > 1 ? this._aplQ : (this._aplQC = this._aplQC + 1, this._aplQ = this._aplQ.then(function() {
                            return function() {
                                if (t.isLeader) return l;
                                var n, r = !1, o = new Promise(function(e1) {
                                    n = function() {
                                        r = !0, e1();
                                    };
                                }), i = function(e1) {
                                    "leader" === e1.context && e1.token != t.token && ("apply" === e1.action && e1.token > t.token && n(), "tell" === e1.action && (n(), t._hasLeader = !0));
                                };
                                t.broadcastChannel.addEventListener("internal", i);
                                var a = e1 ? 4 * t._options.responseTime : t._options.responseTime;
                                return W(t, "apply").then(function() {
                                    return Promise.race([
                                        d(a),
                                        o.then(function() {
                                            return Promise.reject(new Error);
                                        })
                                    ]);
                                }).then(function() {
                                    return W(t, "apply");
                                }).then(function() {
                                    return Promise.race([
                                        d(a),
                                        o.then(function() {
                                            return Promise.reject(new Error);
                                        })
                                    ]);
                                }).catch(function() {}).then(function() {
                                    return t.broadcastChannel.removeEventListener("internal", i), !r && Y(t).then(function() {
                                        return !0;
                                    });
                                });
                            }();
                        }).then(function() {
                            t._aplQC = t._aplQC - 1;
                        }), this._aplQ.then(function() {
                            return t.isLeader;
                        }));
                    },
                    awaitLeadership: function() {
                        var e1;
                        return this._aLP || (this._aLP = (e1 = this).isLeader ? p : new Promise(function(t) {
                            var n = !1;
                            function r() {
                                n || (n = !0, e1.broadcastChannel.removeEventListener("internal", i), t(!0));
                            }
                            e1.applyOnce().then(function() {
                                e1.isLeader && r();
                            });
                            var o = function() {
                                return d(e1._options.fallbackInterval).then(function() {
                                    if (!e1.isDead && !n) return e1.isLeader ? void r() : e1.applyOnce(!0).then(function() {
                                        e1.isLeader ? r() : o();
                                    });
                                });
                            };
                            o();
                            var i = function(t) {
                                "leader" === t.context && "death" === t.action && (e1._hasLeader = !1, e1.applyOnce().then(function() {
                                    e1.isLeader && r();
                                }));
                            };
                            e1.broadcastChannel.addEventListener("internal", i), e1._lstns.push(i);
                        })), this._aLP;
                    },
                    set onduplicate (e){
                        this._dpL = e;
                    },
                    die: function() {
                        var e1 = this;
                        return this._lstns.forEach(function(t) {
                            return e1.broadcastChannel.removeEventListener("internal", t);
                        }), this._lstns = [], this._unl.forEach(function(e1) {
                            return e1.remove();
                        }), this._unl = [], this.isLeader && (this._hasLeader = !1, this.isLeader = !1), this.isDead = !0, W(this, "death");
                    }
                };
                var J = n(415), $ = function() {
                    function e1() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        (0, a.Z)(this, e1), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "channel", void 0), (0, c.Z)(this, "elector", void 0), (0, c.Z)(this, "started", !1), this.options = t, this.onLeaderDuplicate = this.onLeaderDuplicate.bind(this), this.onLeader = this.onLeader.bind(this);
                    }
                    var t, n, r;
                    return (0, u.Z)(e1, [
                        {
                            key: "onLeaderDuplicate",
                            value: function() {}
                        },
                        {
                            key: "onLeader",
                            value: (r = (0, i.Z)(f().mark(function e1() {
                                var t, n;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.next = 2, null === (t = (n = this.options).onLeader) || void 0 === t ? void 0 : t.call(n);
                                        case 2:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return r.apply(this, arguments);
                            })
                        },
                        {
                            key: "isLeader",
                            value: function() {
                                var e1;
                                return !(null === (e1 = this.elector) || void 0 === e1 || !e1.isLeader);
                            }
                        },
                        {
                            key: "hasLeader",
                            value: function() {
                                var e1;
                                return !(null === (e1 = this.elector) || void 0 === e1 || !e1.hasLeader);
                            }
                        },
                        {
                            key: "start",
                            value: (n = (0, i.Z)(f().mark(function e1() {
                                var t;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            this.canStart() && (t = this.options.electionChannelName, this.channel = new U(t), this.elector = X(this.channel), this.elector.onduplicate = this.onLeaderDuplicate, this.elector.awaitLeadership().then(this.onLeader), this.started = !0);
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: (t = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (!this.started) {
                                                e1.next = 11;
                                                break;
                                            }
                                            if (!this.elector) {
                                                e1.next = 5;
                                                break;
                                            }
                                            return e1.next = 4, this.elector.die();
                                        case 4:
                                            this.elector = void 0;
                                        case 5:
                                            if (!this.channel) {
                                                e1.next = 10;
                                                break;
                                            }
                                            return this.channel.postInternal = function() {
                                                return Promise.resolve();
                                            }, e1.next = 9, this.channel.close();
                                        case 9:
                                            this.channel = void 0;
                                        case 10:
                                            this.started = !1;
                                        case 11:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "requiresLeadership",
                            value: function() {
                                return !1;
                            }
                        },
                        {
                            key: "isStarted",
                            value: function() {
                                return this.started;
                            }
                        },
                        {
                            key: "canStart",
                            value: function() {
                                return (0, J.isBrowser)() && !this.started;
                            }
                        }
                    ]), e1;
                }(), ee = n(9123), te = n(6488), ne = n(7088), re = function() {
                    function e1(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        (0, a.Z)(this, e1), (0, c.Z)(this, "tokenManager", void 0), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "renewTimeQueue", void 0), (0, c.Z)(this, "started", !1), this.tokenManager = t, this.options = n, this.renewTimeQueue = [], this.onTokenExpiredHandler = this.onTokenExpiredHandler.bind(this);
                    }
                    var t, n;
                    return (0, u.Z)(e1, [
                        {
                            key: "shouldThrottleRenew",
                            value: function() {
                                var e1 = !1;
                                if (this.renewTimeQueue.push(Date.now()), this.renewTimeQueue.length >= 10) {
                                    var t = this.renewTimeQueue.shift();
                                    e1 = this.renewTimeQueue[this.renewTimeQueue.length - 1] - t < 3e4;
                                }
                                return e1;
                            }
                        },
                        {
                            key: "requiresLeadership",
                            value: function() {
                                return !!this.options.syncStorage && (0, J.isBrowser)();
                            }
                        },
                        {
                            key: "processExpiredTokens",
                            value: function() {
                                var e1 = this, t = this.tokenManager.getStorage().getStorage();
                                Object.keys(t).forEach(function(n) {
                                    var r = t[n];
                                    !(0, te.z9)(r) && e1.tokenManager.hasExpired(r) && e1.onTokenExpiredHandler(n);
                                });
                            }
                        },
                        {
                            key: "onTokenExpiredHandler",
                            value: function(e1) {
                                if (this.options.autoRenew) {
                                    if (this.shouldThrottleRenew()) {
                                        var t = new ee.Z("Too many token renew requests");
                                        this.tokenManager.emitError(t);
                                    } else this.tokenManager.renew(e1).catch(function() {});
                                } else this.options.autoRemove && this.tokenManager.remove(e1);
                            }
                        },
                        {
                            key: "canStart",
                            value: function() {
                                return !(!this.options.autoRenew && !this.options.autoRemove || this.started);
                            }
                        },
                        {
                            key: "start",
                            value: (n = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            this.canStart() && (this.tokenManager.on(ne.$Y, this.onTokenExpiredHandler), this.tokenManager.isStarted() && this.processExpiredTokens(), this.started = !0);
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: (t = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            this.started && (this.tokenManager.off(ne.$Y, this.onTokenExpiredHandler), this.renewTimeQueue = [], this.started = !1);
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "isStarted",
                            value: function() {
                                return this.started;
                            }
                        }
                    ]), e1;
                }(), oe = function() {
                    function e1(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        (0, a.Z)(this, e1), (0, c.Z)(this, "tokenManager", void 0), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "channel", void 0), (0, c.Z)(this, "started", !1), (0, c.Z)(this, "enablePostMessage", !0), this.tokenManager = t, this.options = n, this.onTokenAddedHandler = this.onTokenAddedHandler.bind(this), this.onTokenRemovedHandler = this.onTokenRemovedHandler.bind(this), this.onTokenRenewedHandler = this.onTokenRenewedHandler.bind(this), this.onSetStorageHandler = this.onSetStorageHandler.bind(this), this.onSyncMessageHandler = this.onSyncMessageHandler.bind(this);
                    }
                    var t, n;
                    return (0, u.Z)(e1, [
                        {
                            key: "requiresLeadership",
                            value: function() {
                                return !1;
                            }
                        },
                        {
                            key: "isStarted",
                            value: function() {
                                return this.started;
                            }
                        },
                        {
                            key: "canStart",
                            value: function() {
                                return !!this.options.syncStorage && (0, J.isBrowser)() && !this.started;
                            }
                        },
                        {
                            key: "start",
                            value: (n = (0, i.Z)(f().mark(function e1() {
                                var t;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (this.canStart()) {
                                                e1.next = 2;
                                                break;
                                            }
                                            return e1.abrupt("return");
                                        case 2:
                                            t = this.options.syncChannelName, e1.prev = 3, this.channel = new U(t), e1.next = 10;
                                            break;
                                        case 7:
                                            throw e1.prev = 7, e1.t0 = e1.catch(3), new ee.Z("SyncStorageService is not supported in current browser.");
                                        case 10:
                                            this.tokenManager.on(ne.O3, this.onTokenAddedHandler), this.tokenManager.on(ne.FT, this.onTokenRemovedHandler), this.tokenManager.on(ne.E, this.onTokenRenewedHandler), this.tokenManager.on(ne.zr, this.onSetStorageHandler), this.channel.addEventListener("message", this.onSyncMessageHandler), this.started = !0;
                                        case 16:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this, [
                                    [
                                        3,
                                        7
                                    ]
                                ]);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: (t = (0, i.Z)(f().mark(function e1() {
                                var t, n;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (!this.started) {
                                                e1.next = 10;
                                                break;
                                            }
                                            return this.tokenManager.off(ne.O3, this.onTokenAddedHandler), this.tokenManager.off(ne.FT, this.onTokenRemovedHandler), this.tokenManager.off(ne.E, this.onTokenRenewedHandler), this.tokenManager.off(ne.zr, this.onSetStorageHandler), null === (t = this.channel) || void 0 === t || t.removeEventListener("message", this.onSyncMessageHandler), e1.next = 8, null === (n = this.channel) || void 0 === n ? void 0 : n.close();
                                        case 8:
                                            this.channel = void 0, this.started = !1;
                                        case 10:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "onTokenAddedHandler",
                            value: function(e1, t) {
                                var n;
                                this.enablePostMessage && (null === (n = this.channel) || void 0 === n || n.postMessage({
                                    type: ne.O3,
                                    key: e1,
                                    token: t
                                }));
                            }
                        },
                        {
                            key: "onTokenRemovedHandler",
                            value: function(e1, t) {
                                var n;
                                this.enablePostMessage && (null === (n = this.channel) || void 0 === n || n.postMessage({
                                    type: ne.FT,
                                    key: e1,
                                    token: t
                                }));
                            }
                        },
                        {
                            key: "onTokenRenewedHandler",
                            value: function(e1, t, n) {
                                var r;
                                this.enablePostMessage && (null === (r = this.channel) || void 0 === r || r.postMessage({
                                    type: ne.E,
                                    key: e1,
                                    token: t,
                                    oldToken: n
                                }));
                            }
                        },
                        {
                            key: "onSetStorageHandler",
                            value: function(e1) {
                                var t;
                                null === (t = this.channel) || void 0 === t || t.postMessage({
                                    type: ne.zr,
                                    storage: e1
                                });
                            }
                        },
                        {
                            key: "onSyncMessageHandler",
                            value: function(e1) {
                                switch(this.enablePostMessage = !1, e1.type){
                                    case ne.zr:
                                        this.tokenManager.getStorage().setStorage(e1.storage);
                                        break;
                                    case ne.O3:
                                        this.tokenManager.emitAdded(e1.key, e1.token), this.tokenManager.setExpireEventTimeout(e1.key, e1.token);
                                        break;
                                    case ne.FT:
                                        this.tokenManager.clearExpireEventTimeout(e1.key), this.tokenManager.emitRemoved(e1.key, e1.token);
                                        break;
                                    case ne.E:
                                        this.tokenManager.emitRenewed(e1.key, e1.token, e1.oldToken);
                                }
                                this.enablePostMessage = !0;
                            }
                        }
                    ]), e1;
                }(), ie = function() {
                    return Math.floor(Date.now() / 1e3);
                }, ae = function() {
                    function e1(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        (0, a.Z)(this, e1), (0, c.Z)(this, "tokenManager", void 0), (0, c.Z)(this, "started", !1), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "lastHidden", -1), (0, c.Z)(this, "onPageVisbilityChange", void 0), this.tokenManager = t, this.options = n, this.onPageVisbilityChange = this._onPageVisbilityChange.bind(this);
                    }
                    var t, n;
                    return (0, u.Z)(e1, [
                        {
                            key: "_onPageVisbilityChange",
                            value: function() {
                                if (document.hidden) this.lastHidden = ie();
                                else if (this.lastHidden > 0 && ie() - this.lastHidden >= this.options.tabInactivityDuration) {
                                    var e1 = this.tokenManager.getTokensSync(), t = e1.accessToken, n = e1.idToken;
                                    if (t && this.tokenManager.hasExpired(t)) {
                                        var r = this.tokenManager.getStorageKeyByType("accessToken");
                                        this.tokenManager.renew(r).catch(function() {});
                                    } else if (n && this.tokenManager.hasExpired(n)) {
                                        var o = this.tokenManager.getStorageKeyByType("idToken");
                                        this.tokenManager.renew(o).catch(function() {});
                                    }
                                }
                            }
                        },
                        {
                            key: "start",
                            value: (n = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            this.canStart() && document && (document.addEventListener("visibilitychange", this.onPageVisbilityChange), this.started = !0);
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: (t = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            document && (document.removeEventListener("visibilitychange", this.onPageVisbilityChange), this.started = !1);
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "canStart",
                            value: function() {
                                return (0, J.isBrowser)() && !!this.options.autoRenew && !!this.options.renewOnTabActivation && !this.started;
                            }
                        },
                        {
                            key: "requiresLeadership",
                            value: function() {
                                return !1;
                            }
                        },
                        {
                            key: "isStarted",
                            value: function() {
                                return this.started;
                            }
                        }
                    ]), e1;
                }(), ue = n(3193);
                function ce(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function se(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? ce(Object(n), !0).forEach(function(t) {
                            (0, c.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : ce(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function fe(e1, t) {
                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e1) || (n = function(e1, t) {
                            if (e1) {
                                if ("string" == typeof e1) return le(e1, t);
                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? le(e1, t) : void 0;
                            }
                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                            n && (e1 = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e1.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e1[r++]
                                    };
                                },
                                e: function(e1) {
                                    throw e1;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, u = !1;
                    return {
                        s: function() {
                            n = n.call(e1);
                        },
                        n: function() {
                            var e1 = n.next();
                            return a = e1.done, e1;
                        },
                        e: function(e1) {
                            u = !0, i = e1;
                        },
                        f: function() {
                            try {
                                a || null == n.return || n.return();
                            } finally{
                                if (u) throw i;
                            }
                        }
                    };
                }
                function le(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var pe = "autoRenew", de = "syncStorage", he = "leaderElection", ve = "renewOnTabActivation", ye = function() {
                    function e1(t) {
                        var n = this, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        (0, a.Z)(this, e1), (0, c.Z)(this, "sdk", void 0), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "services", void 0), (0, c.Z)(this, "started", void 0), this.sdk = t, this.onLeader = this.onLeader.bind(this);
                        var o = t.tokenManager.getOptions(), i = o.autoRenew, u = o.autoRemove, s = o.syncStorage;
                        r.electionChannelName = r.electionChannelName || r.broadcastChannelName, this.options = Object.assign({}, e1.defaultOptions, {
                            autoRenew: i,
                            autoRemove: u,
                            syncStorage: s
                        }, {
                            electionChannelName: "".concat(t.options.clientId, "-election"),
                            syncChannelName: "".concat(t.options.clientId, "-sync")
                        }, (0, ue.YY)(r)), this.started = !1, this.services = new Map, e1.knownServices.forEach(function(e1) {
                            var t = n.createService(e1);
                            t && n.services.set(e1, t);
                        });
                    }
                    var t, n, s, l, p;
                    return (0, u.Z)(e1, [
                        {
                            key: "onLeader",
                            value: (p = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (!this.started) {
                                                e1.next = 3;
                                                break;
                                            }
                                            return e1.next = 3, this.startServices();
                                        case 3:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return p.apply(this, arguments);
                            })
                        },
                        {
                            key: "isLeader",
                            value: function() {
                                var e1;
                                return null === (e1 = this.getService(he)) || void 0 === e1 ? void 0 : e1.isLeader();
                            }
                        },
                        {
                            key: "isLeaderRequired",
                            value: function() {
                                return (0, o.Z)(this.services.values()).some(function(e1) {
                                    return e1.canStart() && e1.requiresLeadership();
                                });
                            }
                        },
                        {
                            key: "start",
                            value: (l = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (!this.started) {
                                                e1.next = 2;
                                                break;
                                            }
                                            return e1.abrupt("return");
                                        case 2:
                                            return e1.next = 4, this.startServices();
                                        case 4:
                                            this.started = !0;
                                        case 5:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return l.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: (s = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.next = 2, this.stopServices();
                                        case 2:
                                            this.started = !1;
                                        case 3:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return s.apply(this, arguments);
                            })
                        },
                        {
                            key: "getService",
                            value: function(e1) {
                                return this.services.get(e1);
                            }
                        },
                        {
                            key: "startServices",
                            value: (n = (0, i.Z)(f().mark(function e1() {
                                var t, n, o, i, a;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            t = fe(this.services.entries()), e1.prev = 1, t.s();
                                        case 3:
                                            if ((n = t.n()).done) {
                                                e1.next = 10;
                                                break;
                                            }
                                            if (o = (0, r.Z)(n.value, 2), i = o[0], a = o[1], !this.canStartService(i, a)) {
                                                e1.next = 8;
                                                break;
                                            }
                                            return e1.next = 8, a.start();
                                        case 8:
                                            e1.next = 3;
                                            break;
                                        case 10:
                                            e1.next = 15;
                                            break;
                                        case 12:
                                            e1.prev = 12, e1.t0 = e1.catch(1), t.e(e1.t0);
                                        case 15:
                                            return e1.prev = 15, t.f(), e1.finish(15);
                                        case 18:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this, [
                                    [
                                        1,
                                        12,
                                        15,
                                        18
                                    ]
                                ]);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stopServices",
                            value: (t = (0, i.Z)(f().mark(function e1() {
                                var t, n, r;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            t = fe(this.services.values()), e1.prev = 1, t.s();
                                        case 3:
                                            if ((n = t.n()).done) {
                                                e1.next = 9;
                                                break;
                                            }
                                            return r = n.value, e1.next = 7, r.stop();
                                        case 7:
                                            e1.next = 3;
                                            break;
                                        case 9:
                                            e1.next = 14;
                                            break;
                                        case 11:
                                            e1.prev = 11, e1.t0 = e1.catch(1), t.e(e1.t0);
                                        case 14:
                                            return e1.prev = 14, t.f(), e1.finish(14);
                                        case 17:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this, [
                                    [
                                        1,
                                        11,
                                        14,
                                        17
                                    ]
                                ]);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "canStartService",
                            value: function(e1, t) {
                                var n = t.canStart() && !t.isStarted();
                                return e1 === he ? n && (n = this.isLeaderRequired()) : t.requiresLeadership() && n && (n = this.isLeader()), n;
                            }
                        },
                        {
                            key: "createService",
                            value: function(e1) {
                                var t, n = this.sdk.tokenManager;
                                switch(e1){
                                    case he:
                                        t = new $(se(se({}, this.options), {}, {
                                            onLeader: this.onLeader
                                        }));
                                        break;
                                    case pe:
                                        t = new re(n, se({}, this.options));
                                        break;
                                    case de:
                                        t = new oe(n, se({}, this.options));
                                        break;
                                    case ve:
                                        t = new ae(n, se({}, this.options));
                                        break;
                                    default:
                                        throw new Error("Unknown service ".concat(e1));
                                }
                                return t;
                            }
                        }
                    ]), e1;
                }();
                (0, c.Z)(ye, "knownServices", [
                    pe,
                    de,
                    he,
                    ve
                ]), (0, c.Z)(ye, "defaultOptions", {
                    autoRenew: !0,
                    autoRemove: !0,
                    syncStorage: !0,
                    renewOnTabActivation: !0,
                    tabInactivityDuration: 1800
                });
            },
            6599: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    W: function() {
                        return r.W;
                    }
                });
                var r = n(4376);
            },
            1578: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    K: function() {
                        return s;
                    }
                });
                var r = n(9893), o = n(265), i = n(279), a = n(2724), u = n(8386), c = n(3980);
                function s(e1, t, n) {
                    var s = (0, r.a)(t), f = (0, o.H)(s, e1), l = (0, i.A)(f), p = (0, c.Z)(l), d = (0, a.J)(p, n);
                    return (0, u.i)(d);
                }
            },
            3961: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    AuthStateManager: function() {
                        return r.E;
                    },
                    INITIAL_AUTH_STATE: function() {
                        return r.a;
                    },
                    ServiceManager: function() {
                        return l.W;
                    },
                    createCoreOptionsConstructor: function() {
                        return o.n;
                    },
                    createCoreStorageManager: function() {
                        return u.a;
                    },
                    createOktaAuthCore: function() {
                        return i.K;
                    },
                    mixinCore: function() {
                        return a.i;
                    }
                });
                var r = n(1018), o = n(9133), i = n(1578), a = n(8386), u = n(2647), c = n(8553), s = {};
                for(var f in c)[
                    "default",
                    "AuthStateManager",
                    "INITIAL_AUTH_STATE",
                    "createCoreOptionsConstructor",
                    "createOktaAuthCore",
                    "mixinCore",
                    "createCoreStorageManager"
                ].indexOf(f) < 0 && (s[f] = (function(e1) {
                    return c[e1];
                }).bind(0, f));
                n.d(t, s);
                var l = n(6599);
            },
            8386: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    i: function() {
                        return y;
                    }
                });
                var r = n(5861), o = n(5671), i = n(3144), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(4687), p = n.n(l), d = n(5372), h = n(1018), v = n(4376);
                function y(e1) {
                    return function(e1) {
                        (0, u.Z)(k, e1);
                        var t, n, l, y, g, m, b = (g = k, m = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, t = (0, s.Z)(g);
                            if (m) {
                                var n = (0, s.Z)(this).constructor;
                                e1 = Reflect.construct(t, arguments, n);
                            } else e1 = t.apply(this, arguments);
                            return (0, c.Z)(this, e1);
                        });
                        function k() {
                            var e1;
                            (0, o.Z)(this, k);
                            for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                            return e1 = b.call.apply(b, [
                                this
                            ].concat(n)), (0, f.Z)((0, a.Z)(e1), "authStateManager", void 0), (0, f.Z)((0, a.Z)(e1), "serviceManager", void 0), e1.authStateManager = new h.E((0, a.Z)(e1)), e1.serviceManager = new v.W((0, a.Z)(e1), e1.options.services), e1;
                        }
                        return (0, i.Z)(k, [
                            {
                                key: "start",
                                value: (y = (0, r.Z)(p().mark(function e1() {
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.next = 2, this.serviceManager.start();
                                            case 2:
                                                if (this.tokenManager.start(), this.token.isLoginRedirect()) {
                                                    e1.next = 6;
                                                    break;
                                                }
                                                return e1.next = 6, this.authStateManager.updateAuthState();
                                            case 6:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function() {
                                    return y.apply(this, arguments);
                                })
                            },
                            {
                                key: "stop",
                                value: (l = (0, r.Z)(p().mark(function e1() {
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return this.tokenManager.stop(), e1.next = 3, this.serviceManager.stop();
                                            case 3:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function() {
                                    return l.apply(this, arguments);
                                })
                            },
                            {
                                key: "handleRedirect",
                                value: (n = (0, r.Z)(p().mark(function e1(t) {
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.next = 2, this.handleLoginRedirect(void 0, t);
                                            case 2:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return n.apply(this, arguments);
                                })
                            },
                            {
                                key: "handleLoginRedirect",
                                value: (t = (0, r.Z)(p().mark(function e1(t, n) {
                                    var r, o, i;
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (r = this.options.state, !t) {
                                                    e1.next = 6;
                                                    break;
                                                }
                                                this.tokenManager.setTokens(t), n = n || this.getOriginalUri(this.options.state), e1.next = 25;
                                                break;
                                            case 6:
                                                if (!this.isLoginRedirect()) {
                                                    e1.next = 24;
                                                    break;
                                                }
                                                return e1.prev = 7, e1.next = 10, (0, d.Tp)(this, {});
                                            case 10:
                                                return o = e1.sent, r = o.state, n = n || this.getOriginalUri(r), e1.next = 15, this.storeTokensFromRedirect();
                                            case 15:
                                                e1.next = 22;
                                                break;
                                            case 17:
                                                return e1.prev = 17, e1.t0 = e1.catch(7), e1.next = 21, this.authStateManager.updateAuthState();
                                            case 21:
                                                throw e1.t0;
                                            case 22:
                                                e1.next = 25;
                                                break;
                                            case 24:
                                                return e1.abrupt("return");
                                            case 25:
                                                return e1.next = 27, this.authStateManager.updateAuthState();
                                            case 27:
                                                if (this.removeOriginalUri(r), !(i = this.options.restoreOriginalUri)) {
                                                    e1.next = 34;
                                                    break;
                                                }
                                                return e1.next = 32, i(this, n);
                                            case 32:
                                                e1.next = 35;
                                                break;
                                            case 34:
                                                n && window.location.replace(n);
                                            case 35:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this, [
                                        [
                                            7,
                                            17
                                        ]
                                    ]);
                                })), function(e1, n) {
                                    return t.apply(this, arguments);
                                })
                            }
                        ]), k;
                    }(e1);
                }
            },
            9133: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    n: function() {
                        return l;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(9453);
                function l() {
                    return function(e1) {
                        (0, a.Z)(l, e1);
                        var t, n, f = (t = l, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function l(e1) {
                            var t;
                            return (0, o.Z)(this, l), t = f.call(this, e1), (0, s.Z)((0, i.Z)(t), "services", void 0), (0, s.Z)((0, i.Z)(t), "transformAuthState", void 0), t.services = e1.services, t.transformAuthState = e1.transformAuthState, t;
                        }
                        return (0, r.Z)(l);
                    }((0, f.m)());
                }
            },
            2647: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return o;
                    }
                });
                var r = n(2333);
                function o() {
                    return (0, r.a)();
                }
            },
            5675: function() {},
            8553: function(e1, t, n) {
                "use strict";
                n.r(t);
                var r = n(5675), o = {};
                for(var i in r)"default" !== i && (o[i] = (function(e1) {
                    return r[e1];
                }).bind(0, i));
                n.d(t, o);
            },
            7987: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Df: function() {
                        return u;
                    },
                    EL: function() {
                        return f;
                    },
                    NL: function() {
                        return i;
                    },
                    Wy: function() {
                        return c;
                    },
                    aR: function() {
                        return a;
                    },
                    dX: function() {
                        return l;
                    },
                    k8: function() {
                        return s;
                    },
                    kQ: function() {
                        return p;
                    }
                });
                var r = n(9123), o = n(7594);
                function i(e1) {
                    return a((0, o.r3)(e1));
                }
                function a(e1) {
                    return e1.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
                }
                function u(e1) {
                    return e1.replace(/-/g, "+").replace(/_/g, "/");
                }
                function c(e1) {
                    var t = u(e1);
                    switch(t.length % 4){
                        case 0:
                            break;
                        case 2:
                            t += "==";
                            break;
                        case 3:
                            t += "=";
                            break;
                        default:
                            throw new r.Z("Not a valid Base64Url");
                    }
                    var n = (0, o.ty)(t);
                    try {
                        return decodeURIComponent(escape(n));
                    } catch (e1) {
                        return n;
                    }
                }
                function s(e1) {
                    for(var t = new Uint8Array(e1.length), n = 0; n < e1.length; n++)t[n] = e1.charCodeAt(n);
                    return t;
                }
                function f(e1) {
                    return (0, o.ty)(u(e1));
                }
                function l(e1) {
                    return Uint8Array.from(f(e1), function(e1) {
                        return e1.charCodeAt(0);
                    });
                }
                function p(e1) {
                    return (0, o.r3)(new Uint8Array(e1).reduce(function(e1, t) {
                        return e1 + String.fromCharCode(t);
                    }, ""));
                }
            },
            7594: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    KP: function() {
                        return i;
                    },
                    r3: function() {
                        return o;
                    },
                    ty: function() {
                        return r;
                    }
                });
                var r = function(e1) {
                    return atob(e1);
                }, o = function(e1) {
                    return btoa(e1);
                }, i = "undefined" == typeof crypto ? null : crypto;
            },
            9718: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    atob: function() {
                        return s.ty;
                    },
                    base64ToBase64Url: function() {
                        return r.aR;
                    },
                    base64UrlDecode: function() {
                        return r.EL;
                    },
                    base64UrlToBase64: function() {
                        return r.Df;
                    },
                    base64UrlToBuffer: function() {
                        return r.dX;
                    },
                    base64UrlToString: function() {
                        return r.Wy;
                    },
                    btoa: function() {
                        return s.r3;
                    },
                    bufferToBase64Url: function() {
                        return r.kQ;
                    },
                    getOidcHash: function() {
                        return o.X;
                    },
                    stringToBase64Url: function() {
                        return r.NL;
                    },
                    stringToBuffer: function() {
                        return r.k8;
                    },
                    verifyToken: function() {
                        return c.W;
                    },
                    webcrypto: function() {
                        return s.KP;
                    }
                });
                var r = n(7987), o = n(5698), i = n(6332), a = {};
                for(var u in i)[
                    "default",
                    "base64ToBase64Url",
                    "base64UrlDecode",
                    "base64UrlToBase64",
                    "base64UrlToBuffer",
                    "base64UrlToString",
                    "bufferToBase64Url",
                    "stringToBase64Url",
                    "stringToBuffer",
                    "getOidcHash"
                ].indexOf(u) < 0 && (a[u] = (function(e1) {
                    return i[e1];
                }).bind(0, u));
                n.d(t, a);
                var c = n(3154), s = n(1);
            },
            5698: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return i;
                    }
                });
                var r = n(7987), o = n(7594);
                function i(e1) {
                    var t = (new TextEncoder).encode(e1);
                    return o.KP.subtle.digest("SHA-256", t).then(function(e1) {
                        var t = new Uint8Array(e1).slice(0, 16), n = String.fromCharCode.apply(null, t);
                        return (0, r.NL)(n);
                    });
                }
            },
            6332: function() {},
            3154: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    W: function() {
                        return a;
                    }
                });
                var r = n(3193), o = n(7987), i = n(7594);
                function a(e1, t) {
                    t = (0, r.d9)(t);
                    var n = {
                        name: "RSASSA-PKCS1-v1_5",
                        hash: {
                            name: "SHA-256"
                        }
                    };
                    return delete t.use, i.KP.subtle.importKey("jwk", t, n, !0, [
                        "verify"
                    ]).then(function(t) {
                        var r = e1.split("."), a = (0, o.k8)(r[0] + "." + r[1]), u = (0, o.EL)(r[2]), c = (0, o.k8)(u);
                        return i.KP.subtle.verify(n, t, c, a);
                    });
                }
            },
            1: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    KP: function() {
                        return r.KP;
                    },
                    r3: function() {
                        return r.r3;
                    },
                    ty: function() {
                        return r.ty;
                    }
                });
                var r = n(7594);
            },
            3983: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return f;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                var f = function(e1) {
                    (0, a.Z)(l, e1);
                    var t, n, f = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function l(e1, t, n) {
                        var r;
                        (0, o.Z)(this, l);
                        var a = e1.errorSummary;
                        return r = f.call(this, a), (0, s.Z)((0, i.Z)(r), "errorSummary", void 0), (0, s.Z)((0, i.Z)(r), "errorCode", void 0), (0, s.Z)((0, i.Z)(r), "errorLink", void 0), (0, s.Z)((0, i.Z)(r), "errorId", void 0), (0, s.Z)((0, i.Z)(r), "errorCauses", void 0), (0, s.Z)((0, i.Z)(r), "xhr", void 0), (0, s.Z)((0, i.Z)(r), "meta", void 0), r.name = "AuthApiError", r.errorSummary = e1.errorSummary, r.errorCode = e1.errorCode, r.errorLink = e1.errorLink, r.errorId = e1.errorId, r.errorCauses = e1.errorCauses, t && (r.xhr = t), n && (r.meta = n), r;
                    }
                    return (0, r.Z)(l);
                }(n(6245).Z);
            },
            6573: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return c;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120);
                var c = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.call(this, "The poll was stopped by the sdk");
                    }
                    return (0, r.Z)(s);
                }(n(6245).Z);
            },
            9123: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return f;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                var f = function(e1) {
                    (0, a.Z)(l, e1);
                    var t, n, f = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function l(e1, t) {
                        var n;
                        return (0, o.Z)(this, l), n = f.call(this, e1), (0, s.Z)((0, i.Z)(n), "errorSummary", void 0), (0, s.Z)((0, i.Z)(n), "errorCode", void 0), (0, s.Z)((0, i.Z)(n), "errorLink", void 0), (0, s.Z)((0, i.Z)(n), "errorId", void 0), (0, s.Z)((0, i.Z)(n), "errorCauses", void 0), (0, s.Z)((0, i.Z)(n), "xhr", void 0), n.name = "AuthSdkError", n.errorCode = "INTERNAL", n.errorSummary = e1, n.errorLink = "INTERNAL", n.errorId = "INTERNAL", n.errorCauses = [], t && (n.xhr = t), n;
                    }
                    return (0, r.Z)(l);
                }(n(6245).Z);
            },
            6245: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return p;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(9611);
                function f() {
                    try {
                        var e1 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e1) {}
                    return (f = function() {
                        return !!e1;
                    })();
                }
                function l(e1) {
                    var t = "function" == typeof Map ? new Map : void 0;
                    return l = function(e1) {
                        if (null === e1 || !function(e1) {
                            try {
                                return -1 !== Function.toString.call(e1).indexOf("[native code]");
                            } catch (t) {
                                return "function" == typeof e1;
                            }
                        }(e1)) return e1;
                        if ("function" != typeof e1) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== t) {
                            if (t.has(e1)) return t.get(e1);
                            t.set(e1, n);
                        }
                        function n() {
                            return function(e1, t, n) {
                                if (f()) return Reflect.construct.apply(null, arguments);
                                var r = [
                                    null
                                ];
                                r.push.apply(r, t);
                                var o = new (e1.bind.apply(e1, r));
                                return n && (0, s.Z)(o, n.prototype), o;
                            }(e1, arguments, (0, c.Z)(this).constructor);
                        }
                        return n.prototype = Object.create(e1.prototype, {
                            constructor: {
                                value: n,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), (0, s.Z)(n, e1);
                    }, l(e1);
                }
                var p = function(e1) {
                    (0, a.Z)(f, e1);
                    var t, n, s = (t = f, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function f(e1) {
                        var t;
                        return (0, o.Z)(this, f), t = s.call(this, e1), Object.setPrototypeOf((0, i.Z)(t), (this instanceof f ? this.constructor : void 0).prototype), t;
                    }
                    return (0, r.Z)(f);
                }(l(Error));
            },
            2886: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return f;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                var f = function(e1) {
                    (0, a.Z)(l, e1);
                    var t, n, f = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function l(e1, t, n) {
                        var r;
                        return (0, o.Z)(this, l), r = f.call(this, t), (0, s.Z)((0, i.Z)(r), "errorCode", void 0), (0, s.Z)((0, i.Z)(r), "errorSummary", void 0), (0, s.Z)((0, i.Z)(r), "error", void 0), (0, s.Z)((0, i.Z)(r), "error_description", void 0), (0, s.Z)((0, i.Z)(r), "resp", null), r.name = "OAuthError", r.errorCode = e1, r.errorSummary = t, r.error = e1, r.error_description = t, n && (r.resp = n), r;
                    }
                    return (0, r.Z)(l);
                }(n(6245).Z);
            },
            3114: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(6245), l = n(4771);
                var p = function(e1) {
                    (0, a.Z)(p, e1);
                    var t, n, f = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function p(e1, t, n) {
                        var o, a;
                        return (0, r.Z)(this, p), a = f.call(this, null !== (o = t.error) && void 0 !== o ? o : p.UNKNOWN_ERROR), (0, s.Z)((0, i.Z)(a), "scheme", void 0), (0, s.Z)((0, i.Z)(a), "parameters", void 0), (0, s.Z)((0, i.Z)(a), "name", "WWWAuthError"), (0, s.Z)((0, i.Z)(a), "resp", null), a.scheme = e1, a.parameters = t, n && (a.resp = n), a;
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "error",
                            get: function() {
                                return this.parameters.error;
                            }
                        },
                        {
                            key: "errorCode",
                            get: function() {
                                return this.error;
                            }
                        },
                        {
                            key: "error_description",
                            get: function() {
                                return this.parameters.error_description;
                            }
                        },
                        {
                            key: "errorDescription",
                            get: function() {
                                return this.error_description;
                            }
                        },
                        {
                            key: "errorSummary",
                            get: function() {
                                return this.errorDescription;
                            }
                        },
                        {
                            key: "realm",
                            get: function() {
                                return this.parameters.realm;
                            }
                        }
                    ], [
                        {
                            key: "parseHeader",
                            value: function(e1) {
                                if (!e1) return null;
                                for(var t, n = /(?:,|, )?([a-zA-Z0-9!#$%&'*+\-.^_`|~]+)=(?:"([a-zA-Z0-9!#$%&'*+\-.,^_`|~ /:]+)"|([a-zA-Z0-9!#$%&'*+\-.^_`|~/:]+))/g, r = e1.indexOf(" "), o = e1.slice(0, r), i = e1.slice(r + 1), a = {}; null !== (t = n.exec(i));){
                                    var u;
                                    a[t[1]] = null !== (u = t[2]) && void 0 !== u ? u : t[3];
                                }
                                return new p(o, a);
                            }
                        },
                        {
                            key: "getWWWAuthenticateHeader",
                            value: function() {
                                var e1, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                return (0, l.mf)(null == t ? void 0 : t.get) ? t.get("WWW-Authenticate") : null !== (e1 = t["www-authenticate"]) && void 0 !== e1 ? e1 : t["WWW-Authenticate"];
                            }
                        }
                    ]), p;
                }(f.Z);
                (0, s.Z)(p, "UNKNOWN_ERROR", "UNKNOWN_WWW_AUTH_ERROR");
            },
            5728: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    AuthApiError: function() {
                        return r.Z;
                    },
                    AuthPollStopError: function() {
                        return o.Z;
                    },
                    AuthSdkError: function() {
                        return i.Z;
                    },
                    OAuthError: function() {
                        return a.Z;
                    },
                    WWWAuthError: function() {
                        return u.Z;
                    },
                    isAuthApiError: function() {
                        return l;
                    },
                    isOAuthError: function() {
                        return p;
                    },
                    isWWWAuthError: function() {
                        return d;
                    }
                });
                var r = n(3983), o = n(6573), i = n(9123), a = n(2886), u = n(3114), c = n(1243), s = {};
                for(var f in c)[
                    "default",
                    "isAuthApiError",
                    "isOAuthError",
                    "isWWWAuthError",
                    "AuthApiError",
                    "AuthPollStopError",
                    "AuthSdkError",
                    "OAuthError",
                    "WWWAuthError"
                ].indexOf(f) < 0 && (s[f] = (function(e1) {
                    return c[e1];
                }).bind(0, f));
                function l(e1) {
                    return e1 instanceof r.Z;
                }
                function p(e1) {
                    return e1 instanceof a.Z;
                }
                function d(e1) {
                    return e1 instanceof u.Z;
                }
                n.d(t, s);
            },
            1243: function() {},
            6736: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    ACCESS_TOKEN_STORAGE_KEY: function() {
                        return i.ACCESS_TOKEN_STORAGE_KEY;
                    },
                    BaseStorageManager: function() {
                        return d.W8;
                    },
                    CACHE_STORAGE_NAME: function() {
                        return i.CACHE_STORAGE_NAME;
                    },
                    DEFAULT_CACHE_DURATION: function() {
                        return i.DEFAULT_CACHE_DURATION;
                    },
                    DEFAULT_CODE_CHALLENGE_METHOD: function() {
                        return i.DEFAULT_CODE_CHALLENGE_METHOD;
                    },
                    DEFAULT_MAX_CLOCK_SKEW: function() {
                        return i.DEFAULT_MAX_CLOCK_SKEW;
                    },
                    DEFAULT_POLLING_DELAY: function() {
                        return i.DEFAULT_POLLING_DELAY;
                    },
                    IDX_API_VERSION: function() {
                        return i.IDX_API_VERSION;
                    },
                    IDX_RESPONSE_STORAGE_NAME: function() {
                        return i.IDX_RESPONSE_STORAGE_NAME;
                    },
                    ID_TOKEN_STORAGE_KEY: function() {
                        return i.ID_TOKEN_STORAGE_KEY;
                    },
                    IOS_MAX_RETRY_COUNT: function() {
                        return i.IOS_MAX_RETRY_COUNT;
                    },
                    MAX_VERIFIER_LENGTH: function() {
                        return i.MAX_VERIFIER_LENGTH;
                    },
                    MIN_VERIFIER_LENGTH: function() {
                        return i.MIN_VERIFIER_LENGTH;
                    },
                    ORIGINAL_URI_STORAGE_NAME: function() {
                        return i.ORIGINAL_URI_STORAGE_NAME;
                    },
                    OktaUserAgent: function() {
                        return f.ed;
                    },
                    PKCE_STORAGE_NAME: function() {
                        return i.PKCE_STORAGE_NAME;
                    },
                    PromiseQueue: function() {
                        return h.bo;
                    },
                    REFERRER_PATH_STORAGE_KEY: function() {
                        return i.REFERRER_PATH_STORAGE_KEY;
                    },
                    REFRESH_TOKEN_STORAGE_KEY: function() {
                        return i.REFRESH_TOKEN_STORAGE_KEY;
                    },
                    SHARED_TRANSACTION_STORAGE_NAME: function() {
                        return i.SHARED_TRANSACTION_STORAGE_NAME;
                    },
                    STATE_TOKEN_KEY_NAME: function() {
                        return i.STATE_TOKEN_KEY_NAME;
                    },
                    SavedObject: function() {
                        return d._e;
                    },
                    TOKEN_STORAGE_NAME: function() {
                        return i.TOKEN_STORAGE_NAME;
                    },
                    TRANSACTION_STORAGE_NAME: function() {
                        return i.TRANSACTION_STORAGE_NAME;
                    },
                    bind: function() {
                        return h.ak;
                    },
                    clone: function() {
                        return h.d9;
                    },
                    closeSession: function() {
                        return p.RJ;
                    },
                    createBaseOptionsConstructor: function() {
                        return o.X;
                    },
                    createHttpOptionsConstructor: function() {
                        return f.ZM;
                    },
                    createOktaAuthBase: function() {
                        return o.a;
                    },
                    createSessionApi: function() {
                        return p.MG;
                    },
                    createStorageOptionsConstructor: function() {
                        return d.Tp;
                    },
                    crypto: function() {
                        return r;
                    },
                    delay: function() {
                        return h.gw;
                    },
                    deprecate: function() {
                        return h.Rn;
                    },
                    deprecateWrap: function() {
                        return h.VA;
                    },
                    extend: function() {
                        return h.l7;
                    },
                    find: function() {
                        return h.sE;
                    },
                    genRandomString: function() {
                        return h.uh;
                    },
                    get: function() {
                        return f.U2;
                    },
                    getConsole: function() {
                        return h.dr;
                    },
                    getLink: function() {
                        return h.Rg;
                    },
                    getNativeConsole: function() {
                        return h.sW;
                    },
                    getSession: function() {
                        return p.Gg;
                    },
                    httpRequest: function() {
                        return f.c3;
                    },
                    isAbsoluteUrl: function() {
                        return h.sD;
                    },
                    isFunction: function() {
                        return h.mf;
                    },
                    isNumber: function() {
                        return h.hj;
                    },
                    isObject: function() {
                        return h.Kn;
                    },
                    isPromise: function() {
                        return h.tI;
                    },
                    isString: function() {
                        return h.HD;
                    },
                    isoToUTCString: function() {
                        return h.ng;
                    },
                    logServerSideMemoryStorageWarning: function() {
                        return d.Vp;
                    },
                    mixinHttp: function() {
                        return f.Am;
                    },
                    mixinSession: function() {
                        return p.Zg;
                    },
                    mixinStorage: function() {
                        return d.Ho;
                    },
                    omit: function() {
                        return h.CE;
                    },
                    post: function() {
                        return f.v_;
                    },
                    refreshSession: function() {
                        return p.dx;
                    },
                    removeNils: function() {
                        return h.YY;
                    },
                    removeTrailingSlash: function() {
                        return h.Qj;
                    },
                    sessionExists: function() {
                        return p.sH;
                    },
                    setCookieAndRedirect: function() {
                        return p.OT;
                    },
                    setRequestHeader: function() {
                        return f.rn;
                    },
                    split2: function() {
                        return h.YQ;
                    },
                    toAbsoluteUrl: function() {
                        return h.BY;
                    },
                    toQueryString: function() {
                        return h.UK;
                    },
                    toRelativeUrl: function() {
                        return h.QN;
                    },
                    warn: function() {
                        return h.ZK;
                    }
                });
                var r = n(9718), o = n(3306), i = n(1971), a = n(3961), u = {};
                for(var c in a)[
                    "default",
                    "crypto",
                    "createBaseOptionsConstructor",
                    "createOktaAuthBase",
                    "ACCESS_TOKEN_STORAGE_KEY",
                    "CACHE_STORAGE_NAME",
                    "DEFAULT_CACHE_DURATION",
                    "DEFAULT_CODE_CHALLENGE_METHOD",
                    "DEFAULT_MAX_CLOCK_SKEW",
                    "DEFAULT_POLLING_DELAY",
                    "IDX_API_VERSION",
                    "IDX_RESPONSE_STORAGE_NAME",
                    "ID_TOKEN_STORAGE_KEY",
                    "IOS_MAX_RETRY_COUNT",
                    "MAX_VERIFIER_LENGTH",
                    "MIN_VERIFIER_LENGTH",
                    "ORIGINAL_URI_STORAGE_NAME",
                    "PKCE_STORAGE_NAME",
                    "REFERRER_PATH_STORAGE_KEY",
                    "REFRESH_TOKEN_STORAGE_KEY",
                    "SHARED_TRANSACTION_STORAGE_NAME",
                    "STATE_TOKEN_KEY_NAME",
                    "TOKEN_STORAGE_NAME",
                    "TRANSACTION_STORAGE_NAME"
                ].indexOf(c) < 0 && (u[c] = (function(e1) {
                    return a[e1];
                }).bind(0, c));
                n.d(t, u);
                var s = n(5728);
                for(var c in u = {}, s)[
                    "default",
                    "crypto",
                    "createBaseOptionsConstructor",
                    "createOktaAuthBase",
                    "ACCESS_TOKEN_STORAGE_KEY",
                    "CACHE_STORAGE_NAME",
                    "DEFAULT_CACHE_DURATION",
                    "DEFAULT_CODE_CHALLENGE_METHOD",
                    "DEFAULT_MAX_CLOCK_SKEW",
                    "DEFAULT_POLLING_DELAY",
                    "IDX_API_VERSION",
                    "IDX_RESPONSE_STORAGE_NAME",
                    "ID_TOKEN_STORAGE_KEY",
                    "IOS_MAX_RETRY_COUNT",
                    "MAX_VERIFIER_LENGTH",
                    "MIN_VERIFIER_LENGTH",
                    "ORIGINAL_URI_STORAGE_NAME",
                    "PKCE_STORAGE_NAME",
                    "REFERRER_PATH_STORAGE_KEY",
                    "REFRESH_TOKEN_STORAGE_KEY",
                    "SHARED_TRANSACTION_STORAGE_NAME",
                    "STATE_TOKEN_KEY_NAME",
                    "TOKEN_STORAGE_NAME",
                    "TRANSACTION_STORAGE_NAME",
                    "AuthStateManager",
                    "INITIAL_AUTH_STATE",
                    "ServiceManager",
                    "createCoreOptionsConstructor",
                    "createCoreStorageManager",
                    "createOktaAuthCore",
                    "mixinCore"
                ].indexOf(c) < 0 && (u[c] = (function(e1) {
                    return s[e1];
                }).bind(0, c));
                n.d(t, u);
                var f = n(4777), l = n(9443);
                for(var c in u = {}, l)[
                    "default",
                    "crypto",
                    "createBaseOptionsConstructor",
                    "createOktaAuthBase",
                    "ACCESS_TOKEN_STORAGE_KEY",
                    "CACHE_STORAGE_NAME",
                    "DEFAULT_CACHE_DURATION",
                    "DEFAULT_CODE_CHALLENGE_METHOD",
                    "DEFAULT_MAX_CLOCK_SKEW",
                    "DEFAULT_POLLING_DELAY",
                    "IDX_API_VERSION",
                    "IDX_RESPONSE_STORAGE_NAME",
                    "ID_TOKEN_STORAGE_KEY",
                    "IOS_MAX_RETRY_COUNT",
                    "MAX_VERIFIER_LENGTH",
                    "MIN_VERIFIER_LENGTH",
                    "ORIGINAL_URI_STORAGE_NAME",
                    "PKCE_STORAGE_NAME",
                    "REFERRER_PATH_STORAGE_KEY",
                    "REFRESH_TOKEN_STORAGE_KEY",
                    "SHARED_TRANSACTION_STORAGE_NAME",
                    "STATE_TOKEN_KEY_NAME",
                    "TOKEN_STORAGE_NAME",
                    "TRANSACTION_STORAGE_NAME",
                    "AuthStateManager",
                    "INITIAL_AUTH_STATE",
                    "ServiceManager",
                    "createCoreOptionsConstructor",
                    "createCoreStorageManager",
                    "createOktaAuthCore",
                    "mixinCore",
                    "AuthApiError",
                    "AuthPollStopError",
                    "AuthSdkError",
                    "OAuthError",
                    "WWWAuthError",
                    "isAuthApiError",
                    "isOAuthError",
                    "isWWWAuthError",
                    "OktaUserAgent",
                    "createHttpOptionsConstructor",
                    "get",
                    "httpRequest",
                    "mixinHttp",
                    "post",
                    "setRequestHeader"
                ].indexOf(c) < 0 && (u[c] = (function(e1) {
                    return l[e1];
                }).bind(0, c));
                n.d(t, u);
                var p = n(8041), d = n(9927), h = n(305);
            },
            415: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    getUserAgent: function() {
                        return u;
                    },
                    hasTextEncoder: function() {
                        return p;
                    },
                    isBrowser: function() {
                        return i;
                    },
                    isDPoPSupported: function() {
                        return y;
                    },
                    isFingerprintSupported: function() {
                        return c;
                    },
                    isHTTPS: function() {
                        return h;
                    },
                    isIE11OrLess: function() {
                        return a;
                    },
                    isIOS: function() {
                        return g;
                    },
                    isLocalhost: function() {
                        return v;
                    },
                    isPKCESupported: function() {
                        return d;
                    },
                    isPopupPostMessageSupported: function() {
                        return s;
                    },
                    isTokenVerifySupported: function() {
                        return l;
                    }
                });
                var r = n(7594), o = /windows phone|iemobile|wpdesktop/i;
                function i() {
                    return "undefined" != typeof document && "undefined" != typeof window;
                }
                function a() {
                    if (!i()) return !1;
                    var e1 = document.documentMode;
                    return !!e1 && e1 <= 11;
                }
                function u() {
                    return navigator.userAgent;
                }
                function c() {
                    var e1 = u();
                    return e1 && !o.test(e1);
                }
                function s() {
                    if (!i()) return !1;
                    var e1 = document.documentMode, t = e1 && e1 < 10;
                    return void 0 !== window.postMessage && !t;
                }
                function f() {
                    return void 0 !== r.KP && null !== r.KP && void 0 !== r.KP.subtle && "undefined" != typeof Uint8Array;
                }
                function l() {
                    return f();
                }
                function p() {
                    return "undefined" != typeof TextEncoder;
                }
                function d() {
                    return l() && p();
                }
                function h() {
                    return !!i() && "https:" === window.location.protocol;
                }
                function v() {
                    return i() && "localhost" === window.location.hostname;
                }
                function y() {
                    return !a() && void 0 !== window.indexedDB && p() && f();
                }
                function g() {
                    return i() && "undefined" != typeof navigator && void 0 !== navigator.userAgent && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
                }
            },
            287: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    e: function() {
                        return u;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(415), u = function() {
                    function e1() {
                        (0, r.Z)(this, e1), (0, i.Z)(this, "environments", void 0), this.environments = [
                            "okta-auth-js/".concat("7.11.3")
                        ], this.maybeAddNodeEnvironment();
                    }
                    return (0, o.Z)(e1, [
                        {
                            key: "addEnvironment",
                            value: function(e1) {
                                this.environments.push(e1);
                            }
                        },
                        {
                            key: "getHttpHeader",
                            value: function() {
                                return {
                                    "X-Okta-User-Agent-Extended": this.environments.join(" ")
                                };
                            }
                        },
                        {
                            key: "getVersion",
                            value: function() {
                                return "7.11.3";
                            }
                        },
                        {
                            key: "maybeAddNodeEnvironment",
                            value: function() {
                                if (!(0, a.isBrowser)() && $fcfa90861d16c270$exports && $fcfa90861d16c270$exports.versions) {
                                    var e1 = $fcfa90861d16c270$exports.versions.node;
                                    this.environments.push("nodejs/".concat(e1));
                                }
                            }
                        }
                    ]), e1;
                }();
            },
            2281: function(e1, t, n) {
                "use strict";
                function r(e1, t, n) {
                    e1.options.headers = e1.options.headers || {}, e1.options.headers[t] = n;
                }
                n.d(t, {
                    r: function() {
                        return r;
                    }
                });
            },
            4777: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Am: function() {
                        return a.A;
                    },
                    U2: function() {
                        return i.U2;
                    },
                    ZM: function() {
                        return u.Z;
                    },
                    c3: function() {
                        return i.c3;
                    },
                    ed: function() {
                        return o.e;
                    },
                    rn: function() {
                        return r.r;
                    },
                    v_: function() {
                        return i.v_;
                    }
                });
                var r = n(2281), o = n(287), i = n(5385), a = n(279), u = n(8817);
            },
            279: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    A: function() {
                        return h;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(287), l = n(2281), p = n(6718), d = n(5385);
                function h(e1) {
                    return function(e1) {
                        (0, a.Z)(v, e1);
                        var t, n, h = (t = v, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function v() {
                            var e1;
                            (0, r.Z)(this, v);
                            for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                            return e1 = h.call.apply(h, [
                                this
                            ].concat(n)), (0, s.Z)((0, i.Z)(e1), "_oktaUserAgent", void 0), (0, s.Z)((0, i.Z)(e1), "http", void 0), e1._oktaUserAgent = new f.e, e1.http = {
                                setRequestHeader: l.r.bind(null, (0, i.Z)(e1))
                            }, e1;
                        }
                        return (0, o.Z)(v, [
                            {
                                key: "setHeaders",
                                value: function(e1) {
                                    this.options.headers = Object.assign({}, this.options.headers, e1);
                                }
                            },
                            {
                                key: "getIssuerOrigin",
                                value: function() {
                                    return this.options.issuer.split("/oauth2/")[0];
                                }
                            },
                            {
                                key: "webfinger",
                                value: function(e1) {
                                    var t = "/.well-known/webfinger" + (0, p.UK)(e1);
                                    return (0, d.U2)(this, t, {
                                        headers: {
                                            Accept: "application/jrd+json"
                                        }
                                    });
                                }
                            }
                        ]), v;
                    }(e1);
                }
            },
            8817: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return m;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(3849), l = n(885), p = n(1002), d = n(4098), h = n.n(d);
                function v(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var y = /application\/\w*\+?json/, g = function(e1, t, r) {
                    var o = r.data, i = r.headers || {}, a = i["Content-Type"] || i["content-type"] || "";
                    o && "string" != typeof o && (y.test(a) ? o = JSON.stringify(o) : "application/x-www-form-urlencoded" === a && (o = Object.entries(o).map(function(e1) {
                        var t = (0, l.Z)(e1, 2), n = t[0], r = t[1];
                        return "".concat(n, "=").concat(encodeURIComponent(r));
                    }).join("&")));
                    var u = (n.g.fetch || h())(t, {
                        method: e1,
                        headers: r.headers,
                        body: o,
                        credentials: r.withCredentials ? "include" : "omit"
                    });
                    return u.finally || (u = Promise.resolve(u)), u.then(function(e1) {
                        var t = !e1.ok, n = e1.status;
                        return (function(e1) {
                            return e1.headers.get("Content-Type") && e1.headers.get("Content-Type").toLowerCase().indexOf("application/json") >= 0 ? e1.json().catch(function(e1) {
                                return {
                                    error: e1,
                                    errorSummary: "Could not parse server response"
                                };
                            }) : e1.text();
                        })(e1).then(function(t) {
                            return function(e1, t, n) {
                                var r, o = "object" === (0, p.Z)(t), i = {}, a = function(e1, t) {
                                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                    if (!n) {
                                        if (Array.isArray(e1) || (n = function(e1, t) {
                                            if (e1) {
                                                if ("string" == typeof e1) return v(e1, t);
                                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? v(e1, t) : void 0;
                                            }
                                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                                            n && (e1 = n);
                                            var r = 0, o = function() {};
                                            return {
                                                s: o,
                                                n: function() {
                                                    return r >= e1.length ? {
                                                        done: !0
                                                    } : {
                                                        done: !1,
                                                        value: e1[r++]
                                                    };
                                                },
                                                e: function(e1) {
                                                    throw e1;
                                                },
                                                f: o
                                            };
                                        }
                                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                    }
                                    var i, a = !0, u = !1;
                                    return {
                                        s: function() {
                                            n = n.call(e1);
                                        },
                                        n: function() {
                                            var e1 = n.next();
                                            return a = e1.done, e1;
                                        },
                                        e: function(e1) {
                                            u = !0, i = e1;
                                        },
                                        f: function() {
                                            try {
                                                a || null == n.return || n.return();
                                            } finally{
                                                if (u) throw i;
                                            }
                                        }
                                    };
                                }(n.headers.entries());
                                try {
                                    for(a.s(); !(r = a.n()).done;){
                                        var u = r.value;
                                        i[u[0]] = u[1];
                                    }
                                } catch (e1) {
                                    a.e(e1);
                                } finally{
                                    a.f();
                                }
                                var c = {
                                    responseText: o ? JSON.stringify(t) : t,
                                    status: e1,
                                    headers: i
                                };
                                return o && (c.responseType = "json", c.responseJSON = t), c;
                            }(n, t, e1);
                        }).then(function(e1) {
                            var n;
                            if (t || null !== (n = e1.responseJSON) && void 0 !== n && n.error) throw e1;
                            return e1;
                        });
                    });
                };
                function m() {
                    return function(e1) {
                        (0, a.Z)(l, e1);
                        var t, n, f = (t = l, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function l(e1) {
                            var t;
                            return (0, o.Z)(this, l), t = f.call(this, e1), (0, s.Z)((0, i.Z)(t), "issuer", void 0), (0, s.Z)((0, i.Z)(t), "transformErrorXHR", void 0), (0, s.Z)((0, i.Z)(t), "headers", void 0), (0, s.Z)((0, i.Z)(t), "httpRequestClient", void 0), (0, s.Z)((0, i.Z)(t), "httpRequestInterceptors", void 0), (0, s.Z)((0, i.Z)(t), "pollDelay", void 0), t.issuer = e1.issuer, t.transformErrorXHR = e1.transformErrorXHR, t.headers = e1.headers, t.httpRequestClient = e1.httpRequestClient || g, t.httpRequestInterceptors = e1.httpRequestInterceptors, t.pollDelay = e1.pollDelay, t;
                        }
                        return (0, r.Z)(l);
                    }((0, f.T)());
                }
            },
            5385: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    U2: function() {
                        return k;
                    },
                    c3: function() {
                        return b;
                    },
                    v_: function() {
                        return w;
                    }
                });
                var r = n(1002), o = n(4942), i = n(4771), a = n(3193), u = n(6718), c = n(1971), s = n(3983), f = n(3114), l = n(2886), p = n(415);
                function d(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                function h(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function v(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? h(Object(n), !0).forEach(function(t) {
                            (0, o.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var y, g = 0;
                (0, p.isBrowser)() && (g = Date.now(), y = function() {
                    document.hidden || (g = Date.now());
                }, document.addEventListener("visibilitychange", y));
                var m = function(e1, t) {
                    var n, r, o, u;
                    if (t instanceof Error) return new s.Z({
                        errorSummary: t.message
                    });
                    var c, p = t, d = {};
                    if (p.responseText && (0, i.HD)(p.responseText)) try {
                        d = JSON.parse(p.responseText);
                    } catch (e1) {
                        d = {
                            errorSummary: "Unknown error"
                        };
                    }
                    p.status >= 500 && (d.errorSummary = "Unknown error"), e1.options.transformErrorXHR && (p = e1.options.transformErrorXHR((0, a.d9)(p)));
                    var h = null !== (n = f.Z.getWWWAuthenticateHeader(null === (r = p) || void 0 === r ? void 0 : r.headers)) && void 0 !== n ? n : "";
                    if (c = d.error && d.error_description ? new l.Z(d.error, d.error_description, p) : new s.Z(d, p, {
                        wwwAuthHeader: h
                    }), h && (null === (o = p) || void 0 === o ? void 0 : o.status) >= 400 && (null === (u = p) || void 0 === u ? void 0 : u.status) < 500) {
                        var y = f.Z.parseHeader(h);
                        if (403 === p.status && "insufficient_authentication_context" === (null == y ? void 0 : y.error)) {
                            var g = y.parameters, m = g.max_age, b = g.acr_values;
                            c = new s.Z({
                                errorSummary: y.error,
                                errorCauses: [
                                    {
                                        errorSummary: y.errorDescription
                                    }
                                ]
                            }, p, v({
                                max_age: +m
                            }, b && {
                                acr_values: b
                            }));
                        } else "DPoP" === (null == y ? void 0 : y.scheme) && (c = y);
                    }
                    return c;
                };
                function b(e1, t) {
                    var n;
                    if (t = t || {}, e1.options.httpRequestInterceptors) {
                        var o, u = function(e1, t) {
                            var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                            if (!n) {
                                if (Array.isArray(e1) || (n = function(e1, t) {
                                    if (e1) {
                                        if ("string" == typeof e1) return d(e1, t);
                                        var n = Object.prototype.toString.call(e1).slice(8, -1);
                                        return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? d(e1, t) : void 0;
                                    }
                                }(e1)) || t && e1 && "number" == typeof e1.length) {
                                    n && (e1 = n);
                                    var r = 0, o = function() {};
                                    return {
                                        s: o,
                                        n: function() {
                                            return r >= e1.length ? {
                                                done: !0
                                            } : {
                                                done: !1,
                                                value: e1[r++]
                                            };
                                        },
                                        e: function(e1) {
                                            throw e1;
                                        },
                                        f: o
                                    };
                                }
                                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                            }
                            var i, a = !0, u = !1;
                            return {
                                s: function() {
                                    n = n.call(e1);
                                },
                                n: function() {
                                    var e1 = n.next();
                                    return a = e1.done, e1;
                                },
                                e: function(e1) {
                                    u = !0, i = e1;
                                },
                                f: function() {
                                    try {
                                        a || null == n.return || n.return();
                                    } finally{
                                        if (u) throw i;
                                    }
                                }
                            };
                        }(e1.options.httpRequestInterceptors);
                        try {
                            for(u.s(); !(o = u.n()).done;)(0, o.value)(t);
                        } catch (S) {
                            u.e(S);
                        } finally{
                            u.f();
                        }
                    }
                    var s = t.url, f = t.method, l = t.args, h = t.saveAuthnState, y = t.accessToken, b = !0 === t.withCredentials, k = e1.options.storageUtil.storage, w = e1.storageManager.getHttpCache(e1.options.cookies), O = t.pollingIntent, Z = null !== (n = e1.options.pollDelay) && void 0 !== n ? n : 0;
                    if (t.cacheResponse) {
                        var T = w.getStorage()[s];
                        if (T && Date.now() / 1e3 < T.expiresAt) return Promise.resolve(T.response);
                    }
                    var E = v({
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    }, e1._oktaUserAgent.getHttpHeader());
                    Object.assign(E, e1.options.headers, t.headers), E = (0, a.YY)(E), y && (0, i.HD)(y) && (E.Authorization = "Bearer " + y);
                    var S, P, x, A = {
                        headers: E,
                        data: l || void 0,
                        withCredentials: b
                    };
                    if (O && (0, p.isBrowser)() && Z > 0) {
                        var R, _, j, C = 0;
                        _ = function() {
                            var e1 = Date.now() - g;
                            return e1 < Z ? new Promise(function(t) {
                                return setTimeout(function() {
                                    document.hidden ? t(R()) : t();
                                }, Z - e1);
                            }) : Promise.resolve();
                        }, R = function() {
                            var e1;
                            return document.hidden ? new Promise(function(t) {
                                e1 = function() {
                                    document.hidden || (document.removeEventListener("visibilitychange", e1), t(_()));
                                }, document.addEventListener("visibilitychange", e1);
                            }) : _();
                        };
                        var I = function() {
                            return e1.options.httpRequestClient(f, s, A).catch(function(e1) {
                                if ("Load failed" === (null == e1 ? void 0 : e1.message) && C < c.IOS_MAX_RETRY_COUNT) return C++, j();
                                throw e1;
                            });
                        };
                        x = (j = function() {
                            return R().then(I);
                        })();
                    } else x = e1.options.httpRequestClient(f, s, A);
                    return x.then(function(n) {
                        return (P = n.responseText) && (0, i.HD)(P) && (P = JSON.parse(P)) && "object" === (0, r.Z)(P) && !P.headers && (Array.isArray(P) ? P.forEach(function(e1) {
                            e1.headers = n.headers;
                        }) : P.headers = n.headers), h && (P.stateToken || k.delete(c.STATE_TOKEN_KEY_NAME)), P && P.stateToken && P.expiresAt && k.set(c.STATE_TOKEN_KEY_NAME, P.stateToken, P.expiresAt, e1.options.cookies), P && t.cacheResponse && w.updateStorage(s, {
                            expiresAt: Math.floor(Date.now() / 1e3) + c.DEFAULT_CACHE_DURATION,
                            response: P
                        }), P;
                    }).catch(function(t) {
                        throw "E0000011" === (S = m(e1, t)).errorCode && k.delete(c.STATE_TOKEN_KEY_NAME), S;
                    });
                }
                function k(e1, t, n) {
                    var r = {
                        url: t = (0, u.sD)(t) ? t : e1.getIssuerOrigin() + t,
                        method: "GET"
                    };
                    return Object.assign(r, n), b(e1, r);
                }
                function w(e1, t, n, r) {
                    var o = {
                        url: t = (0, u.sD)(t) ? t : e1.getIssuerOrigin() + t,
                        method: "POST",
                        args: n,
                        saveAuthnState: !0
                    };
                    return Object.assign(o, r), b(e1, o);
                }
            },
            3334: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    v: function() {
                        return l;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(1646), f = n(480);
                function l() {
                    return function(e1) {
                        (0, a.Z)(l, e1);
                        var t, n, s = (t = l, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function l(e1) {
                            return (0, r.Z)(this, l), s.call(this, e1);
                        }
                        return (0, o.Z)(l, [
                            {
                                key: "clear",
                                value: function() {
                                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    (0, i.Z)((0, c.Z)(l.prototype), "clear", this).call(this, e1), !1 !== e1.clearIdxResponse && this.clearIdxResponse();
                                }
                            },
                            {
                                key: "saveIdxResponse",
                                value: function(e1) {
                                    if (this.saveLastResponse) {
                                        var t = this.storageManager.getIdxResponseStorage();
                                        t && t.setStorage(e1);
                                    }
                                }
                            },
                            {
                                key: "loadIdxResponse",
                                value: function(e1) {
                                    if (!this.saveLastResponse) return null;
                                    var t = this.storageManager.getIdxResponseStorage();
                                    if (!t) return null;
                                    var n = t.getStorage();
                                    if (!n || !(0, f.P)(n.rawIdxResponse)) return null;
                                    if (e1) {
                                        var r = e1.stateHandle, o = e1.interactionHandle;
                                        if (!e1.useGenericRemediator && r && n.stateHandle !== r) return null;
                                        if (o && n.interactionHandle !== o) return null;
                                    }
                                    return n;
                                }
                            },
                            {
                                key: "clearIdxResponse",
                                value: function() {
                                    if (this.saveLastResponse) {
                                        var e1 = this.storageManager.getIdxResponseStorage();
                                        null == e1 || e1.clearStorage();
                                    }
                                }
                            }
                        ]), l;
                    }((0, s.P)());
                }
            },
            1286: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Y: function() {
                        return l;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(7595), c = n(3377);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function l(e1) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return p = (0, o.Z)(a().mark(function e1(t) {
                        var n, r = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return (n = r.length > 1 && void 0 !== r[1] ? r[1] : {}).password && !n.authenticator && (n.authenticator = u.pc.OKTA_PASSWORD), e1.abrupt("return", (0, c.K)(t, f(f({}, n), {}, {
                                        flow: "authenticate"
                                    })));
                                case 3:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), p.apply(this, arguments);
                }
            },
            7644: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    _: function() {
                        return a;
                    }
                });
                var r = n(3144), o = n(5671), i = n(4942), a = (0, r.Z)(function e1(t) {
                    (0, o.Z)(this, e1), (0, i.Z)(this, "meta", void 0), this.meta = t;
                });
            },
            9582: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return l;
                    }
                });
                var r = n(4942), o = n(5671), i = n(3144), a = n(136), u = n(2963), c = n(1120);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var l = function(e1) {
                    (0, a.Z)(s, e1);
                    var t, n, r = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), r.apply(this, arguments);
                    }
                    return (0, i.Z)(s, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                return !!(e1.credentials || e1.password || e1.passcode);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.credentials, n = e1.password, r = e1.passcode, o = e1.revokeSessions;
                                if (t || n || r) return t || {
                                    passcode: r || n,
                                    revokeSessions: o
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function(e1) {
                                var t, n, r = [
                                    f(f({}, null === (t = e1.form) || void 0 === t ? void 0 : t.value[0]), {}, {
                                        name: "password",
                                        type: "string",
                                        required: e1.required
                                    })
                                ];
                                return (null === (n = e1.form) || void 0 === n ? void 0 : n.value.find(function(e1) {
                                    return "revokeSessions" === e1.name;
                                })) && r.push({
                                    name: "revokeSessions",
                                    type: "boolean",
                                    label: "Sign me out of all other devices",
                                    required: !1
                                }), r;
                            }
                        }
                    ]), s;
                }(n(7644)._);
            },
            9344: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    LL: function() {
                        return i;
                    },
                    PN: function() {
                        return a;
                    },
                    h_: function() {
                        return u;
                    }
                });
                var r = n(7595);
                function o(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                function i(e1) {
                    var t;
                    if ((0, r.H)(e1)) t = e1;
                    else {
                        if ("string" != typeof e1) throw new Error("Invalid format for authenticator");
                        t = {
                            key: e1
                        };
                    }
                    return t;
                }
                function a(e1, t) {
                    return !!(e1 && t && (e1.id && t.id ? e1.id === t.id : e1.key && t.key && e1.key === t.key));
                }
                function u(e1, t) {
                    var n, r, i = function(e1, t) {
                        var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                        if (!n) {
                            if (Array.isArray(e1) || (n = function(e1, t) {
                                if (e1) {
                                    if ("string" == typeof e1) return o(e1, t);
                                    var n = Object.prototype.toString.call(e1).slice(8, -1);
                                    return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? o(e1, t) : void 0;
                                }
                            }(e1)) || t && e1 && "number" == typeof e1.length) {
                                n && (e1 = n);
                                var r = 0, i = function() {};
                                return {
                                    s: i,
                                    n: function() {
                                        return r >= e1.length ? {
                                            done: !0
                                        } : {
                                            done: !1,
                                            value: e1[r++]
                                        };
                                    },
                                    e: function(e1) {
                                        throw e1;
                                    },
                                    f: i
                                };
                            }
                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }
                        var a, u = !0, c = !1;
                        return {
                            s: function() {
                                n = n.call(e1);
                            },
                            n: function() {
                                var e1 = n.next();
                                return u = e1.done, e1;
                            },
                            e: function(e1) {
                                c = !0, a = e1;
                            },
                            f: function() {
                                try {
                                    u || null == n.return || n.return();
                                } finally{
                                    if (c) throw a;
                                }
                            }
                        };
                    }(e1);
                    try {
                        var a = function() {
                            var e1 = r.value;
                            if (n = t.find(function(t) {
                                var n = t.relatesTo;
                                return n.key && n.key === e1.key;
                            })) return "break";
                        };
                        for(i.s(); !(r = i.n()).done && "break" !== a(););
                    } catch (e1) {
                        i.e(e1);
                    } finally{
                        i.f();
                    }
                    return n;
                }
            },
            9192: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return l;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3377), c = n(7738);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function l(e1, t) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return (p = (0, o.Z)(a().mark(function e1(t, n) {
                        var r, o;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return r = t.transactionManager.load(), o = (0, c.s)(t, r.flow), e1.abrupt("return", (0, u.K)(t, f(f(f({}, n), o), {}, {
                                        actions: [
                                            "cancel"
                                        ]
                                    })));
                                case 3:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            7985: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    GA: function() {
                        return g;
                    },
                    Jn: function() {
                        return b;
                    },
                    gc: function() {
                        return y;
                    },
                    mo: function() {
                        return m;
                    }
                });
                var r = n(5861), o = n(3144), i = n(5671), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(4687), p = n.n(l), d = n(6245), h = n(1969);
                var v = function(e1) {
                    (0, u.Z)(l, e1);
                    var t, n, r = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function l(e1, t) {
                        var n;
                        return (0, i.Z)(this, l), n = r.call(this, "Enter the OTP code in the originating client: ".concat(t)), (0, f.Z)((0, a.Z)(n), "state", void 0), (0, f.Z)((0, a.Z)(n), "otp", void 0), n.name = "EmailVerifyCallbackError", n.state = e1, n.otp = t, n;
                    }
                    return (0, o.Z)(l);
                }(d.Z);
                function y(e1) {
                    return "EmailVerifyCallbackError" === e1.name;
                }
                function g(e1) {
                    return /(otp=)/i.test(e1) && /(state=)/i.test(e1);
                }
                function m(e1) {
                    return (0, h.v)(e1);
                }
                function b(e1, t) {
                    return k.apply(this, arguments);
                }
                function k() {
                    return (k = (0, r.Z)(p().mark(function e1(t, n) {
                        var r, o, i;
                        return p().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (!g(n)) {
                                        e1.next = 9;
                                        break;
                                    }
                                    if (r = m(n), o = r.state, i = r.otp, !t.idx.canProceed({
                                        state: o
                                    })) {
                                        e1.next = 8;
                                        break;
                                    }
                                    return e1.next = 5, t.idx.proceed({
                                        state: o,
                                        otp: i
                                    });
                                case 5:
                                    return e1.abrupt("return", e1.sent);
                                case 8:
                                    throw new v(o, i);
                                case 9:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            2144: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Y: function() {
                        return i;
                    }
                });
                var r = n(1578), o = n(8137);
                function i(e1, t, n) {
                    var i = (0, r.K)(e1, t, n);
                    return (0, o.B)(i);
                }
            },
            8717: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    F: function() {
                        return F;
                    }
                });
                var r = {};
                n.r(r), n.d(r, {
                    AuthenticatorEnrollmentData: function() {
                        return U.q;
                    },
                    AuthenticatorVerificationData: function() {
                        return N.q;
                    },
                    ChallengeAuthenticator: function() {
                        return E.J;
                    },
                    ChallengePoll: function() {
                        return S.U;
                    },
                    EnrollAuthenticator: function() {
                        return w.q;
                    },
                    EnrollPoll: function() {
                        return O.T;
                    },
                    EnrollProfile: function() {
                        return x.w;
                    },
                    EnrollmentChannelData: function() {
                        return T.t;
                    },
                    GenericRemediator: function() {
                        return H.P;
                    },
                    Identify: function() {
                        return A.h;
                    },
                    ReEnrollAuthenticator: function() {
                        return R.j;
                    },
                    ReEnrollAuthenticatorWarning: function() {
                        return _.i;
                    },
                    RedirectIdp: function() {
                        return j.O;
                    },
                    Remediator: function() {
                        return k.n;
                    },
                    ResetAuthenticator: function() {
                        return P.G;
                    },
                    SelectAuthenticatorAuthenticate: function() {
                        return C.X;
                    },
                    SelectAuthenticatorEnroll: function() {
                        return I.j;
                    },
                    SelectAuthenticatorUnlockAccount: function() {
                        return D.G;
                    },
                    SelectEnrollProfile: function() {
                        return M.j;
                    },
                    SelectEnrollmentChannel: function() {
                        return Z.V;
                    },
                    Skip: function() {
                        return L.h;
                    }
                });
                var o = n(8221), i = n(9912), a = n(1286), u = n(9192), c = n(7985), s = n(5021), f = n(5923), l = n(6131), p = n(2660), d = n(9310), h = n(2845), v = n(9214), y = n(8826), g = n(2473), m = n(2620), b = n(8277), k = n(3118), w = n(3857), O = n(2288), Z = n(3403), T = n(3679), E = n(4560), S = n(1104), P = n(1019), x = n(7522), A = n(8628), R = n(9024), _ = n(8107), j = n(8490), C = n(7311), I = n(9865), D = n(5272), M = n(4713), N = n(5278), U = n(2541), L = n(8443), H = n(9732), B = n(7738), K = n(5031);
                function F(e1) {
                    (0, K.TC)({
                        remediators: r,
                        getFlowSpecification: B.s
                    });
                    var t = g.Y.bind(null, e1);
                    return {
                        interact: l.E.bind(null, e1),
                        introspect: p.L.bind(null, e1),
                        makeIdxResponse: f._T.bind(null, e1),
                        authenticate: a.Y.bind(null, e1),
                        register: y.z.bind(null, e1),
                        start: t,
                        startTransaction: t,
                        poll: d.$.bind(null, e1),
                        proceed: h.x.bind(null, e1),
                        cancel: u.a.bind(null, e1),
                        recoverPassword: v.M.bind(null, e1),
                        handleInteractionCodeRedirect: s.X.bind(null, e1),
                        isInteractionRequired: o.wc.bind(null, e1),
                        isInteractionRequiredError: i.Cf,
                        handleEmailVerifyCallback: c.Jn.bind(null, e1),
                        isEmailVerifyCallback: c.GA,
                        parseEmailVerifyCallback: c.mo,
                        isEmailVerifyCallbackError: c.gc,
                        getSavedTransactionMeta: m.uN.bind(null, e1),
                        createTransactionMeta: m.Xc.bind(null, e1),
                        getTransactionMeta: m.Co.bind(null, e1),
                        saveTransactionMeta: m.r0.bind(null, e1),
                        clearTransactionMeta: m.Jm.bind(null, e1),
                        isTransactionMetaValid: m.Wf,
                        setFlow: function(t) {
                            e1.options.flow = t;
                        },
                        getFlow: function() {
                            return e1.options.flow;
                        },
                        canProceed: h.C.bind(null, e1),
                        unlockAccount: b.l.bind(null, e1)
                    };
                }
            },
            7738: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    s: function() {
                        return S;
                    }
                });
                var r = n(8628), o = n(7311), i = n(9865), a = n(2541), u = n(5278), c = n(3857), s = n(4560), f = n(1104), l = n(9024), p = n(8107), d = n(2288), h = n(3403), v = n(3679), y = n(8490), g = n(8443), m = {
                    identify: r.h,
                    "select-authenticator-authenticate": o.X,
                    "select-authenticator-enroll": i.j,
                    "authenticator-enrollment-data": a.q,
                    "authenticator-verification-data": u.q,
                    "enroll-authenticator": c.q,
                    "challenge-authenticator": s.J,
                    "challenge-poll": f.U,
                    "reenroll-authenticator": l.j,
                    "reenroll-authenticator-warning": p.i,
                    "enroll-poll": d.T,
                    "select-enrollment-channel": h.V,
                    "enrollment-channel-data": v.t,
                    "redirect-idp": y.O,
                    skip: g.h
                }, b = n(1019), k = {
                    identify: r.h,
                    "identify-recovery": r.h,
                    "select-authenticator-authenticate": o.X,
                    "select-authenticator-enroll": i.j,
                    "challenge-authenticator": s.J,
                    "authenticator-verification-data": u.q,
                    "authenticator-enrollment-data": a.q,
                    "reset-authenticator": b.G,
                    "reenroll-authenticator": l.j,
                    "reenroll-authenticator-warning": p.i,
                    "enroll-poll": d.T
                }, w = n(4713), O = n(7522), Z = {
                    "select-enroll-profile": w.j,
                    "enroll-profile": O.w,
                    "authenticator-enrollment-data": a.q,
                    "select-authenticator-enroll": i.j,
                    "enroll-poll": d.T,
                    "select-enrollment-channel": h.V,
                    "enrollment-channel-data": v.t,
                    "enroll-authenticator": c.q,
                    skip: g.h
                }, T = n(5272), E = {
                    identify: r.h,
                    "select-authenticator-unlock-account": T.G,
                    "select-authenticator-authenticate": o.X,
                    "challenge-authenticator": s.J,
                    "challenge-poll": f.U,
                    "authenticator-verification-data": u.q,
                    "reenroll-authenticator-warning": p.i
                };
                function S(e1) {
                    var t, n, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default", o = !0;
                    switch(r){
                        case "register":
                        case "signup":
                        case "enrollProfile":
                            t = Z, o = !1;
                            break;
                        case "recoverPassword":
                        case "resetPassword":
                            t = k, n = [
                                "currentAuthenticator-recover",
                                "currentAuthenticatorEnrollment-recover"
                            ], o = !1;
                            break;
                        case "unlockAccount":
                            t = E, o = !1, n = [
                                "unlock-account"
                            ];
                            break;
                        default:
                            t = m;
                    }
                    return {
                        flow: r,
                        remediators: t,
                        actions: n,
                        withCredentials: o
                    };
                }
            },
            5021: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return c;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(2886);
                function c(e1, t) {
                    return s.apply(this, arguments);
                }
                function s() {
                    return (s = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, c, s, f, l, p, d, h, v;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = t.transactionManager.load()) {
                                        e1.next = 3;
                                        break;
                                    }
                                    throw new a.Z("No transaction data was found in storage");
                                case 3:
                                    if (o = r.codeVerifier, c = r.state, s = new URL(n), f = s.searchParams, l = f.get("state"), p = f.get("interaction_code"), !(d = f.get("error"))) {
                                        e1.next = 10;
                                        break;
                                    }
                                    throw new u.Z(d, f.get("error_description"));
                                case 10:
                                    if (l === c) {
                                        e1.next = 12;
                                        break;
                                    }
                                    throw new a.Z("State in redirect uri does not match with transaction state");
                                case 12:
                                    if (p) {
                                        e1.next = 14;
                                        break;
                                    }
                                    throw new a.Z("Unable to parse interaction_code from the url");
                                case 14:
                                    return e1.next = 16, t.token.exchangeCodeForTokens({
                                        interactionCode: p,
                                        codeVerifier: o
                                    });
                                case 16:
                                    h = e1.sent, v = h.tokens, t.tokenManager.setTokens(v);
                                case 19:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            5923: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    _T: function() {
                        return U;
                    },
                    A0: function() {
                        return N;
                    }
                });
                var r = n(1971), o = n(5861), i = n(2982), a = n(4687), u = n.n(a), c = n(885), s = n(4942), f = n(4925), l = n(1002), p = n(5385);
                function d(e1, t) {
                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e1) || (n = function(e1, t) {
                            if (e1) {
                                if ("string" == typeof e1) return h(e1, t);
                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? h(e1, t) : void 0;
                            }
                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                            n && (e1 = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e1.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e1[r++]
                                    };
                                },
                                e: function(e1) {
                                    throw e1;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, u = !1;
                    return {
                        s: function() {
                            n = n.call(e1);
                        },
                        n: function() {
                            var e1 = n.next();
                            return a = e1.done, e1;
                        },
                        e: function(e1) {
                            u = !0, i = e1;
                        },
                        f: function() {
                            try {
                                a || null == n.return || n.return();
                            } finally{
                                if (u) throw i;
                            }
                        }
                    };
                }
                function h(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var v = function(e1) {
                    return !1 !== e1.mutable;
                }, y = function(e1) {
                    var t = {}, n = [], r = {};
                    if (!e1.value) return n.push(e1), {
                        defaultParamsForAction: t,
                        neededParamsForAction: n,
                        immutableParamsForAction: r
                    };
                    var o, i = d(e1.value);
                    try {
                        for(i.s(); !(o = i.n()).done;){
                            var a, u, c = o.value;
                            v(c) ? (n.push(c), null !== (a = c.value) && void 0 !== a && a && (t[c.name] = c.value)) : r[c.name] = null !== (u = c.value) && void 0 !== u ? u : "";
                        }
                    } catch (e1) {
                        i.e(e1);
                    } finally{
                        i.f();
                    }
                    return {
                        defaultParamsForAction: t,
                        neededParamsForAction: n,
                        immutableParamsForAction: r
                    };
                }, g = n(3983);
                function m(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function b(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? m(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var k = function(e1, t) {
                    var n = t.actionDefinition, r = t.defaultParamsForAction, i = void 0 === r ? {} : r, a = t.immutableParamsForAction, c = void 0 === a ? {} : a, s = t.toPersist, f = void 0 === s ? {} : s, l = n.href;
                    return (0, o.Z)(u().mark(function t() {
                        var r, o, a, s, d, h, v, y, m, k, w, O = arguments;
                        return u().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return r = O.length > 0 && void 0 !== O[0] ? O[0] : {}, o = {
                                        "Content-Type": "application/json",
                                        Accept: n.accepts || "application/ion+json"
                                    }, a = JSON.stringify(b(b(b({}, i), r), c)), t.prev = 3, h = {
                                        url: l,
                                        method: n.method,
                                        headers: o,
                                        args: a,
                                        withCredentials: null === (s = null == f ? void 0 : f.withCredentials) || void 0 === s || s
                                    }, ("poll" === n.name || (null === (d = n.name) || void 0 === d ? void 0 : d.endsWith("-poll"))) && (h.pollingIntent = !0), t.next = 9, (0, p.c3)(e1, h);
                                case 9:
                                    return v = t.sent, t.abrupt("return", e1.idx.makeIdxResponse(b({}, v), f, !0));
                                case 13:
                                    if (t.prev = 13, t.t0 = t.catch(3), t.t0 instanceof g.Z && null !== t.t0 && void 0 !== t.t0 && t.t0.xhr) {
                                        t.next = 17;
                                        break;
                                    }
                                    throw t.t0;
                                case 17:
                                    return y = t.t0.xhr, m = y.responseJSON || JSON.parse(y.responseText), k = y.headers["WWW-Authenticate"] || y.headers["www-authenticate"], w = e1.idx.makeIdxResponse(b({}, m), f, !1), 401 === y.status && 'Oktadevicejwt realm="Okta Device"' === k && (w.stepUp = !0), t.abrupt("return", w);
                                case 23:
                                case "end":
                                    return t.stop();
                            }
                        }, t, null, [
                            [
                                3,
                                13
                            ]
                        ]);
                    }));
                }, w = function(e1, t, n) {
                    var r = k, o = function(e1) {
                        var t, n = [], r = {}, o = {}, i = d(e1 = Array.isArray(e1) ? e1 : [
                            e1
                        ]);
                        try {
                            for(i.s(); !(t = i.n()).done;){
                                var a = t.value, u = y(a), c = u.defaultParamsForAction, s = u.neededParamsForAction, f = u.immutableParamsForAction;
                                n.push(s), r[a.name] = c, o[a.name] = f;
                            }
                        } catch (e1) {
                            i.e(e1);
                        } finally{
                            i.f();
                        }
                        return {
                            defaultParams: r,
                            neededParams: n,
                            immutableParams: o
                        };
                    }(t), i = o.defaultParams, a = o.neededParams, u = o.immutableParams, c = r(e1, {
                        actionDefinition: t,
                        defaultParamsForAction: i[t.name],
                        immutableParamsForAction: u[t.name],
                        toPersist: n
                    });
                    return c.neededParams = a, c;
                };
                function O(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function Z(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? O(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : O(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var T = n(136), E = n(9611);
                function S() {
                    S = function(e1, t) {
                        return new n(e1, void 0, t);
                    };
                    var e1 = RegExp.prototype, t = new WeakMap;
                    function n(e1, r, o) {
                        var i = new RegExp(e1, r);
                        return t.set(i, o || t.get(e1)), (0, E.Z)(i, n.prototype);
                    }
                    function r(e1, n) {
                        var r = t.get(n);
                        return Object.keys(r).reduce(function(t, n) {
                            var o = r[n];
                            if ("number" == typeof o) t[n] = e1[o];
                            else {
                                for(var i = 0; void 0 === e1[o[i]] && i + 1 < o.length;)i++;
                                t[n] = e1[o[i]];
                            }
                            return t;
                        }, Object.create(null));
                    }
                    return (0, T.Z)(n, RegExp), n.prototype.exec = function(t) {
                        var n = e1.exec.call(this, t);
                        return n && (n.groups = r(n, this)), n;
                    }, n.prototype[Symbol.replace] = function(n, o) {
                        if ("string" == typeof o) {
                            var i = t.get(this);
                            return e1[Symbol.replace].call(this, n, o.replace(/\$<([^>]+)>/g, function(e1, t) {
                                return "$" + i[t];
                            }));
                        }
                        if ("function" == typeof o) {
                            var a = this;
                            return e1[Symbol.replace].call(this, n, function() {
                                var e1 = arguments;
                                return "object" != (0, l.Z)(e1[e1.length - 1]) && (e1 = [].slice.call(e1)).push(r(e1, a)), o.apply(this, e1);
                            });
                        }
                        return e1[Symbol.replace].call(this, n, o);
                    }, S.apply(this, arguments);
                }
                var P = S(/\$?(\w+)|(?:\[(\d+)\])/g, {
                    step: 1,
                    index: 2
                }), x = n(9123), A = [
                    "value",
                    "type"
                ];
                function R(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function _(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? R(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : R(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var j = {
                    remediation: !0,
                    context: !0
                }, C = function e1(t, n) {
                    Object.keys(n).forEach(function(r) {
                        if ("relatesTo" === r) {
                            var o = Array.isArray(n[r]) ? n[r][0] : n[r];
                            if ("string" == typeof o) {
                                var i = function(e1) {
                                    for(var t, n = e1.path, r = e1.json, o = []; null !== (t = P.exec(n));){
                                        var i, a, u, c, s, f = null !== (i = null === (a = t) || void 0 === a || null === (u = a.groups) || void 0 === u ? void 0 : u.step) && void 0 !== i ? i : null === (c = t) || void 0 === c || null === (s = c.groups) || void 0 === s ? void 0 : s.index;
                                        f && o.push(f);
                                    }
                                    if (!(o.length < 1)) {
                                        for(var p = o.pop(), d = r, h = 0, v = o; h < v.length; h++){
                                            var y = v[h];
                                            if (Object.prototype.hasOwnProperty.call(d, y)) {
                                                if ("object" !== (0, l.Z)(d[y])) return;
                                                d = d[y];
                                            }
                                        }
                                        return d[p];
                                    }
                                }({
                                    path: o,
                                    json: t
                                });
                                if (i) return void (n[r] = i);
                                throw new x.Z("Cannot resolve relatesTo: ".concat(o));
                            }
                        }
                        Array.isArray(n[r]) && n[r].forEach(function(n) {
                            return e1(t, n);
                        });
                    });
                }, I = function(e1, t) {
                    var n, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, o = (null === (n = t.remediation) || void 0 === n ? void 0 : n.value) || [];
                    o.forEach(function(e1) {
                        var n;
                        if ("launch-authenticator" !== e1.name || "authenticatorChallenge" !== (null == e1 || null === (n = e1.relatesTo) || void 0 === n ? void 0 : n[0]) || null != t && t.authenticatorChallenge) return C(t, e1);
                        delete e1.relatesTo;
                    });
                    var i = o.map(function(t) {
                        return function(e1, t, n) {
                            if (t.rel) {
                                var r = function(e1, t) {
                                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                                    return t.reduce(function(t, r) {
                                        return Z(Z({}, t), {}, (0, s.Z)({}, r.name, w(e1, r, n)));
                                    }, {});
                                }(e1, [
                                    t
                                ], n), o = r[t.name];
                                return _(_({}, t), {}, {
                                    action: o
                                });
                            }
                            return t;
                        }(e1, t, r);
                    }), a = function(e1, t) {
                        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = {}, o = {};
                        return Object.keys(t).filter(function(e1) {
                            return !j[e1];
                        }).forEach(function(i) {
                            if ("object" === (0, l.Z)(t[i]) && t[i]) {
                                if (t[i].rel) r[t[i].name] = w(e1, t[i], n);
                                else {
                                    var a = t[i], u = a.value, s = a.type, p = (0, f.Z)(a, A);
                                    o[i] = _({
                                        type: s
                                    }, p), "object" === s ? (o[i].value = {}, Object.entries(u).forEach(function(t) {
                                        var a = (0, c.Z)(t, 2), u = a[0], s = a[1];
                                        s.rel ? r["".concat(i, "-").concat(u.name || u)] = w(e1, s, n) : o[i].value[u] = s;
                                    })) : o[i].value = u;
                                }
                            } else o[i] = t[i];
                        }), {
                            context: o,
                            actions: r
                        };
                    }(e1, t, r);
                    return {
                        remediations: i,
                        context: a.context,
                        actions: a.actions
                    };
                }, D = {
                    makeIdxState: function(e1, t, n, r) {
                        var a, c, s, f, l = t, p = I(e1, t, n), d = p.remediations, h = p.context, v = p.actions, y = (0, i.Z)(d), g = (f = (0, o.Z)(u().mark(function e1(t) {
                            var n, r, o = arguments;
                            return u().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        if (n = o.length > 1 && void 0 !== o[1] ? o[1] : {}, r = d.find(function(e1) {
                                            return e1.name === t;
                                        })) {
                                            e1.next = 4;
                                            break;
                                        }
                                        return e1.abrupt("return", Promise.reject("Unknown remediation choice: [".concat(t, "]")));
                                    case 4:
                                        if ("function" == typeof r.action) {
                                            e1.next = 7;
                                            break;
                                        }
                                        return e1.abrupt("return", Promise.reject("Current remediation cannot make form submit action: [".concat(t, "]")));
                                    case 7:
                                        return e1.abrupt("return", r.action(n));
                                    case 8:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        })), function(e1) {
                            return f.apply(this, arguments);
                        });
                        return {
                            proceed: g,
                            neededToProceed: y,
                            actions: v,
                            context: h,
                            rawIdxState: l,
                            interactionCode: null === (a = l.successWithInteractionCode) || void 0 === a || null === (c = a.value) || void 0 === c || null === (s = c.find(function(e1) {
                                return "interaction_code" === e1.name;
                            })) || void 0 === s ? void 0 : s.value,
                            toPersist: n,
                            requestDidSucceed: r
                        };
                    }
                }, M = function(e1) {
                    switch(e1){
                        case "1.0.0":
                            return D;
                        case void 0:
                        case null:
                            throw new Error("Api version is required");
                        default:
                            throw new Error("Unknown api version: ".concat(e1, ".  Use an exact semver version."));
                    }
                };
                function N(e1) {
                    if (!e1) throw new Error("version is required");
                    if ((null != e1 ? e1 : "").replace(/[^0-9a-zA-Z._-]/, "") !== e1 || !e1) throw new Error("invalid version supplied - version is required and uses semver syntax");
                    M(e1);
                }
                function U(e1, t, n, o) {
                    var i, a = null !== (i = null == t ? void 0 : t.version) && void 0 !== i ? i : r.IDX_API_VERSION;
                    return N(a), (0, M(a).makeIdxState)(e1, t, n, o);
                }
            },
            9999: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    pc: function() {
                        return K.pc;
                    },
                    Fw: function() {
                        return K.Fw;
                    },
                    Qd: function() {
                        return K.Qd;
                    },
                    YR: function() {
                        return r.Y;
                    },
                    Ch: function() {
                        return s.C;
                    },
                    al: function() {
                        return o.a;
                    },
                    Jm: function() {
                        return v.Jm;
                    },
                    F4: function() {
                        return y.F;
                    },
                    SL: function() {
                        return H.S;
                    },
                    aT: function() {
                        return B.a;
                    },
                    vK: function() {
                        return F.v;
                    },
                    UB: function() {
                        return U;
                    },
                    Yn: function() {
                        return g.Y;
                    },
                    Xc: function() {
                        return v.Xc;
                    },
                    uN: function() {
                        return v.uN;
                    },
                    Co: function() {
                        return v.Co;
                    },
                    Jn: function() {
                        return i.Jn;
                    },
                    Xx: function() {
                        return p.X;
                    },
                    $0: function() {
                        return v.$0;
                    },
                    EW: function() {
                        return a.E;
                    },
                    L8: function() {
                        return u.L;
                    },
                    H: function() {
                        return K.H;
                    },
                    GA: function() {
                        return i.GA;
                    },
                    gc: function() {
                        return i.gc;
                    },
                    Wf: function() {
                        return v.Wf;
                    },
                    bl: function() {
                        return v.bl;
                    },
                    UC: function() {
                        return v.UC;
                    },
                    B_: function() {
                        return L.B;
                    },
                    mo: function() {
                        return i.mo;
                    },
                    $l: function() {
                        return c.$;
                    },
                    xc: function() {
                        return s.x;
                    },
                    M4: function() {
                        return l.M;
                    },
                    z2: function() {
                        return f.z;
                    },
                    r0: function() {
                        return v.r0;
                    },
                    Yr: function() {
                        return d.Y;
                    },
                    le: function() {
                        return h.l;
                    }
                });
                var r = n(1286), o = n(9192), i = n(7985), a = n(6131), u = n(2660), c = n(9310), s = n(2845), f = n(8826), l = n(9214), p = n(5021), d = n(2473), h = n(8277), v = n(2620), y = n(8717), g = n(2144), m = n(3144), b = n(5671), k = n(7326), w = n(136), O = n(2963), Z = n(1120), T = n(4942), E = n(5923), S = n(8719), P = n(8716);
                function x(e1) {
                    var t;
                    return t = function(e1) {
                        (0, w.Z)(o, e1);
                        var t, n, r = (t = o, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, Z.Z)(t);
                            if (n) {
                                var o = (0, Z.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, O.Z)(this, e1);
                        });
                        function o() {
                            var e1, t, n;
                            (0, b.Z)(this, o);
                            for(var i = arguments.length, a = new Array(i), u = 0; u < i; u++)a[u] = arguments[u];
                            return e1 = r.call.apply(r, [
                                this
                            ].concat(a)), (0, T.Z)((0, k.Z)(e1), "idx", void 0), (0, T.Z)((0, k.Z)(e1), "fingerprint", void 0), e1.idx = (t = (0, k.Z)(e1), n = d.Y.bind(null, t), {
                                makeIdxResponse: E._T.bind(null, t),
                                start: n,
                                startTransaction: n,
                                proceed: s.x.bind(null, t),
                                canProceed: s.C.bind(null, t),
                                getSavedTransactionMeta: v.uN.bind(null, t),
                                createTransactionMeta: v.Xc.bind(null, t),
                                getTransactionMeta: v.Co.bind(null, t),
                                saveTransactionMeta: v.r0.bind(null, t),
                                clearTransactionMeta: v.Jm.bind(null, t),
                                isTransactionMetaValid: v.Wf
                            }), e1.fingerprint = S.Z.bind(null, (0, k.Z)(e1)), e1;
                        }
                        return (0, m.Z)(o);
                    }(e1), (0, T.Z)(t, "webauthn", P), t;
                }
                var A = n(9893), R = n(265), _ = n(279), j = n(3980), C = n(1237), I = n(8707), D = n(6898), M = n(8221);
                function N(e1, t) {
                    return function(e1) {
                        (0, w.Z)(i, e1);
                        var n, r, o = (n = i, r = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, t = (0, Z.Z)(n);
                            if (r) {
                                var o = (0, Z.Z)(this).constructor;
                                e1 = Reflect.construct(t, arguments, o);
                            } else e1 = t.apply(this, arguments);
                            return (0, O.Z)(this, e1);
                        });
                        function i() {
                            var e1, n;
                            (0, b.Z)(this, i);
                            for(var r = arguments.length, a = new Array(r), u = 0; u < r; u++)a[u] = arguments[u];
                            return e1 = o.call.apply(o, [
                                this
                            ].concat(a)), (0, T.Z)((0, k.Z)(e1), "token", void 0), (0, T.Z)((0, k.Z)(e1), "transactionManager", void 0), e1.transactionManager = new t(Object.assign({
                                storageManager: e1.storageManager
                            }, e1.options.transactionManager)), e1.token = (n = (0, k.Z)(e1), {
                                prepareTokenParams: D.wu.bind(null, n),
                                exchangeCodeForTokens: I.r.bind(null, n),
                                decode: C.T
                            }), e1;
                        }
                        return (0, m.Z)(i, [
                            {
                                key: "isLoginRedirect",
                                value: function() {
                                    return (0, M.gM)(this);
                                }
                            },
                            {
                                key: "isPKCE",
                                value: function() {
                                    return !!this.options.pkce;
                                }
                            },
                            {
                                key: "hasResponseType",
                                value: function(e1) {
                                    return (0, M.wV)(e1, this.options);
                                }
                            },
                            {
                                key: "isAuthorizationCodeFlow",
                                value: function() {
                                    return this.hasResponseType("code");
                                }
                            }
                        ]), i;
                    }(e1);
                }
                function U(e1, t, n) {
                    var r = (0, A.a)(t), o = (0, R.H)(r, e1), i = (0, _.A)(o);
                    return x(N((0, j.Z)(i), n));
                }
                var L = n(8137), H = n(4602), B = n(4143), K = n(7595), F = n(3334);
            },
            6131: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    E: function() {
                        return h;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(2620), c = n(7599), s = n(3193), f = n(5385);
                function l(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function p(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? l(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function d(e1) {
                    return {
                        meta: e1,
                        interactionHandle: e1.interactionHandle,
                        state: e1.state
                    };
                }
                function h(e1) {
                    return v.apply(this, arguments);
                }
                function v() {
                    return v = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, l, h, v, y, g, m, b, k, w, O, Z, T, E, S, P, x, A, R, _, j, C, I = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (o = I.length > 1 && void 0 !== I[1] ? I[1] : {}, o = (0, s.YY)(o), i = (0, u.uN)(t, o), null === (n = i) || void 0 === n || !n.interactionHandle) {
                                        e1.next = 5;
                                        break;
                                    }
                                    return e1.abrupt("return", d(i));
                                case 5:
                                    return e1.next = 7, (0, u.Xc)(t, p(p({}, i), o));
                                case 7:
                                    return i = e1.sent, l = (0, c.zf)(t), v = (h = i).clientId, y = h.redirectUri, g = h.state, m = h.scopes, b = h.withCredentials, k = h.codeChallenge, w = h.codeChallengeMethod, O = h.activationToken, Z = h.recoveryToken, T = h.maxAge, E = h.acrValues, S = h.nonce, P = o.clientSecret || t.options.clientSecret, b = null === (r = b) || void 0 === r || r, x = "".concat(l, "/v1/interact"), A = p(p(p(p(p(p({
                                        client_id: v,
                                        scope: m.join(" "),
                                        redirect_uri: y,
                                        code_challenge: k,
                                        code_challenge_method: w,
                                        state: g
                                    }, O && {
                                        activation_token: O
                                    }), Z && {
                                        recovery_token: Z
                                    }), P && {
                                        client_secret: P
                                    }), T && {
                                        max_age: T
                                    }), E && {
                                        acr_values: E
                                    }), S && {
                                        nonce: S
                                    }), R = {
                                        "Content-Type": "application/x-www-form-urlencoded"
                                    }, e1.next = 17, (0, f.c3)(t, {
                                        method: "POST",
                                        url: x,
                                        headers: R,
                                        withCredentials: b,
                                        args: A
                                    });
                                case 17:
                                    return _ = e1.sent, j = _.interaction_handle, C = p(p({}, i), {}, {
                                        interactionHandle: j,
                                        withCredentials: b,
                                        state: g,
                                        scopes: m,
                                        recoveryToken: Z,
                                        activationToken: O
                                    }), (0, u.r0)(t, C), e1.abrupt("return", d(C));
                                case 22:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), v.apply(this, arguments);
                }
            },
            2660: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    L: function() {
                        return p;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(5923), u = n(480), c = n(7599), s = n(1971), f = n(5385), l = n(5728);
                function p(e1) {
                    return d.apply(this, arguments);
                }
                function d() {
                    return d = (0, r.Z)(i().mark(function e1(t) {
                        var n, r, o, p, d, h, v, y, g, m, b, k, w, O, Z = arguments;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = Z.length > 1 && void 0 !== Z[1] ? Z[1] : {}, (p = t.transactionManager.loadIdxResponse(n)) && (r = p.rawIdxResponse, o = p.requestDidSucceed), r) {
                                        e1.next = 27;
                                        break;
                                    }
                                    return h = n.version || s.IDX_API_VERSION, v = (0, c.Xp)(t), y = n.interactionHandle, g = n.stateHandle, m = null === (d = n.withCredentials) || void 0 === d || d, e1.prev = 8, o = !0, (0, a.A0)(h), b = "".concat(v, "/idp/idx/introspect"), k = g ? {
                                        stateToken: g
                                    } : {
                                        interactionHandle: y
                                    }, w = {
                                        "Content-Type": "application/ion+json; okta-version=".concat(h),
                                        Accept: "application/ion+json; okta-version=".concat(h)
                                    }, e1.next = 16, (0, f.c3)(t, {
                                        method: "POST",
                                        url: b,
                                        headers: w,
                                        withCredentials: m,
                                        args: k
                                    });
                                case 16:
                                    r = e1.sent, e1.next = 27;
                                    break;
                                case 19:
                                    if (e1.prev = 19, e1.t0 = e1.catch(8), !((0, l.isAuthApiError)(e1.t0) && e1.t0.xhr && (0, u.P)(e1.t0.xhr.responseJSON))) {
                                        e1.next = 26;
                                        break;
                                    }
                                    r = e1.t0.xhr.responseJSON, o = !1, e1.next = 27;
                                    break;
                                case 26:
                                    throw e1.t0;
                                case 27:
                                    return O = n.withCredentials, e1.abrupt("return", (0, a._T)(t, r, {
                                        withCredentials: O
                                    }, o));
                                case 29:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                8,
                                19
                            ]
                        ]);
                    })), d.apply(this, arguments);
                }
            },
            8137: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    B: function() {
                        return d;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(8717), l = n(8719), p = n(8716);
                function d(e1) {
                    var t;
                    return t = function(e1) {
                        (0, a.Z)(d, e1);
                        var t, n, p = (t = d, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function d() {
                            var e1;
                            (0, o.Z)(this, d);
                            for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                            return e1 = p.call.apply(p, [
                                this
                            ].concat(n)), (0, s.Z)((0, i.Z)(e1), "idx", void 0), (0, s.Z)((0, i.Z)(e1), "fingerprint", void 0), e1.idx = (0, f.F)((0, i.Z)(e1)), e1.fingerprint = l.Z.bind(null, (0, i.Z)(e1)), e1;
                        }
                        return (0, r.Z)(d);
                    }(e1), (0, s.Z)(t, "webauthn", p), t;
                }
            },
            4602: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    S: function() {
                        return l;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(9133);
                function l() {
                    return function(e1) {
                        (0, a.Z)(l, e1);
                        var t, n, f = (t = l, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function l(e1) {
                            var t;
                            return (0, o.Z)(this, l), t = f.call(this, e1), (0, s.Z)((0, i.Z)(t), "flow", void 0), (0, s.Z)((0, i.Z)(t), "activationToken", void 0), (0, s.Z)((0, i.Z)(t), "recoveryToken", void 0), (0, s.Z)((0, i.Z)(t), "idx", void 0), t.flow = e1.flow, t.activationToken = e1.activationToken, t.recoveryToken = e1.recoveryToken, t.idx = e1.idx, t;
                        }
                        return (0, r.Z)(l);
                    }((0, f.n)());
                }
            },
            9310: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $: function() {
                        return s;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(2845), u = n(2620), c = n(146);
                function s(e1) {
                    return f.apply(this, arguments);
                }
                function f() {
                    return f = (0, r.Z)(i().mark(function e1(t) {
                        var n, o, f, l, p, d = arguments;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = d.length > 1 && void 0 !== d[1] ? d[1] : {}, e1.next = 3, (0, a.x)(t, {
                                        startPolling: !0
                                    });
                                case 3:
                                    if (f = e1.sent, l = (0, u.uN)(t), null != (p = null == l || null === (n = l.remediations) || void 0 === n ? void 0 : n.find(function(e1) {
                                        return e1.includes("poll");
                                    })) && p.length || (0, c.ZK)("No polling remediations available at the current IDX flow stage"), !Number.isInteger(o.refresh)) {
                                        e1.next = 9;
                                        break;
                                    }
                                    return e1.abrupt("return", new Promise(function(e1, n) {
                                        setTimeout((0, r.Z)(i().mark(function r() {
                                            var o, a, u;
                                            return i().wrap(function(r) {
                                                for(;;)switch(r.prev = r.next){
                                                    case 0:
                                                        try {
                                                            u = null === (o = f.nextStep) || void 0 === o || null === (a = o.poll) || void 0 === a ? void 0 : a.refresh, e1(u ? s(t, {
                                                                refresh: u
                                                            }) : f);
                                                        } catch (e1) {
                                                            n(e1);
                                                        }
                                                    case 1:
                                                    case "end":
                                                        return r.stop();
                                                }
                                            }, r);
                                        })), o.refresh);
                                    }));
                                case 9:
                                    return e1.abrupt("return", f);
                                case 10:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), f.apply(this, arguments);
                }
            },
            2845: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    C: function() {
                        return p;
                    },
                    x: function() {
                        return d;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3377), c = n(2620), s = n(9123);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function p(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return !(!(0, c.uN)(e1, t) && !t.stateHandle);
                }
                function d(e1) {
                    return h.apply(this, arguments);
                }
                function h() {
                    return h = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, f = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (p(t, n = f.length > 1 && void 0 !== f[1] ? f[1] : {})) {
                                        e1.next = 3;
                                        break;
                                    }
                                    throw new s.Z("Unable to proceed: saved transaction could not be loaded");
                                case 3:
                                    return r = n.flow, o = n.state, r || (i = (0, c.uN)(t, {
                                        state: o
                                    }), r = null == i ? void 0 : i.flow), e1.abrupt("return", (0, u.K)(t, l(l({}, n), {}, {
                                        flow: r
                                    })));
                                case 6:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), h.apply(this, arguments);
                }
            },
            9214: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    M: function() {
                        return l;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3377), c = n(7738);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function l(e1) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return p = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = o.length > 1 && void 0 !== o[1] ? o[1] : {}, r = (0, c.s)(t, "recoverPassword"), e1.abrupt("return", (0, u.K)(t, f(f({}, n), r)));
                                case 3:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), p.apply(this, arguments);
                }
            },
            8826: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    z: function() {
                        return h;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3377), c = n(2620), s = n(2473), f = n(9123), l = n(7595);
                function p(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function d(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? p(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function h(e1) {
                    return v.apply(this, arguments);
                }
                function v() {
                    return v = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = i.length > 1 && void 0 !== i[1] ? i[1] : {}, (0, c.$0)(t)) {
                                        e1.next = 8;
                                        break;
                                    }
                                    return e1.next = 4, (0, s.Y)(t, d(d({}, n), {}, {
                                        flow: "register",
                                        autoRemediate: !1
                                    }));
                                case 4:
                                    if (r = e1.sent, o = r.enabledFeatures, n.activationToken || !o || o.includes(l.Fw.REGISTRATION)) {
                                        e1.next = 8;
                                        break;
                                    }
                                    throw new f.Z("Registration is not supported based on your current org configuration.");
                                case 8:
                                    return e1.abrupt("return", (0, u.K)(t, d(d({}, n), {}, {
                                        flow: "register"
                                    })));
                                case 9:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), v.apply(this, arguments);
                }
            },
            2541: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    q: function() {
                        return h;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(4794), l = n(6064);
                function p(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function d(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? p(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var h = function(e1) {
                    (0, a.Z)(f, e1);
                    var t, n, s = (t = f, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function f() {
                        return (0, r.Z)(this, f), s.apply(this, arguments);
                    }
                    return (0, o.Z)(f, [
                        {
                            key: "mapAuthenticator",
                            value: function() {
                                var e1 = this.getAuthenticatorData();
                                return {
                                    id: (0, l.zg)(this.remediation).form.value.find(function(e1) {
                                        return "id" === e1.name;
                                    }).value,
                                    methodType: e1.methodType,
                                    phoneNumber: e1.phoneNumber
                                };
                            }
                        },
                        {
                            key: "getInputAuthenticator",
                            value: function(e1) {
                                return [
                                    {
                                        name: "methodType",
                                        type: "string"
                                    },
                                    {
                                        name: "phoneNumber",
                                        label: "Phone Number",
                                        type: "string"
                                    }
                                ].map(function(t) {
                                    return d(d({}, e1.form.value.find(function(e1) {
                                        return e1.name === t.name;
                                    })), t);
                                });
                            }
                        },
                        {
                            key: "mapAuthenticatorDataFromValues",
                            value: function(e1) {
                                e1 = (0, i.Z)((0, c.Z)(f.prototype), "mapAuthenticatorDataFromValues", this).call(this, e1);
                                var t = this.values.phoneNumber;
                                if (e1 || t) return d(d({}, e1 && e1), t && {
                                    phoneNumber: t
                                });
                            }
                        }
                    ]), f;
                }(f.a);
                (0, s.Z)(h, "remediationName", "authenticator-enrollment-data");
            },
            5278: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    q: function() {
                        return d;
                    }
                });
                var r = n(2982), o = n(5671), i = n(3144), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942);
                function l(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function p(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? l(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var d = function(e1) {
                    (0, u.Z)(d, e1);
                    var t, n, l = (t = d, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function d() {
                        return (0, o.Z)(this, d), l.apply(this, arguments);
                    }
                    return (0, i.Z)(d, [
                        {
                            key: "mapAuthenticator",
                            value: function() {
                                return this.getAuthenticatorData();
                            }
                        },
                        {
                            key: "getInputAuthenticator",
                            value: function() {
                                var e1 = this.getAuthenticatorFromRemediation(), t = e1.form.value.find(function(e1) {
                                    return "methodType" === e1.name;
                                });
                                return t && t.options ? {
                                    name: "methodType",
                                    type: "string",
                                    required: !0,
                                    options: t.options
                                } : (0, r.Z)(e1.form.value);
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                return this.values = (0, a.Z)((0, s.Z)(d.prototype), "getValuesAfterProceed", this).call(this), Object.keys(this.values).filter(function(e1) {
                                    return "authenticator" !== e1;
                                }).reduce(function(t, n) {
                                    return p(p({}, t), {}, (0, f.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), d;
                }(n(4794).a);
                (0, f.Z)(d, "remediationName", "authenticator-verification-data");
            },
            4794: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return y;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(3118), p = n(7595), d = n(9344);
                function h(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function v(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? h(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var y = function(e1) {
                    (0, u.Z)(h, e1);
                    var t, n, l = (t = h, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function h(e1) {
                        var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        return (0, r.Z)(this, h), t = l.call(this, e1, n), (0, f.Z)((0, i.Z)(t), "authenticator", void 0), t.authenticator = t.getAuthenticator(), t.formatAuthenticatorData(), t;
                    }
                    return (0, o.Z)(h, [
                        {
                            key: "formatAuthenticatorData",
                            value: function() {
                                var e1 = this;
                                if (this.getAuthenticatorData()) this.values.authenticatorsData = this.values.authenticatorsData.map(function(t) {
                                    return (0, d.PN)(e1.authenticator, t) ? e1.mapAuthenticatorDataFromValues(t) : t;
                                });
                                else {
                                    var t = this.mapAuthenticatorDataFromValues();
                                    t && this.values.authenticatorsData.push(t);
                                }
                            }
                        },
                        {
                            key: "getAuthenticatorData",
                            value: function() {
                                var e1 = this;
                                return this.values.authenticatorsData.find(function(t) {
                                    return (0, d.PN)(e1.authenticator, t);
                                });
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function() {
                                var e1 = this;
                                return this.values.authenticatorsData.some(function(t) {
                                    return (0, d.PN)(e1.authenticator, t);
                                });
                            }
                        },
                        {
                            key: "mapAuthenticatorDataFromValues",
                            value: function(e1) {
                                var t = this.values, n = t.methodType, r = t.authenticator;
                                !n && (0, p.H)(r) && (n = null == r ? void 0 : r.methodType);
                                var o = this.authenticator, i = v(v({
                                    id: o.id,
                                    enrollmentId: o.enrollmentId
                                }, e1 && e1), n && {
                                    methodType: n
                                });
                                return i.methodType ? i : null;
                            }
                        },
                        {
                            key: "getAuthenticatorFromRemediation",
                            value: function() {
                                return this.remediation.value.find(function(e1) {
                                    return "authenticator" === e1.name;
                                });
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                this.values = (0, a.Z)((0, s.Z)(h.prototype), "getValuesAfterProceed", this).call(this);
                                var t = this.values.authenticatorsData.filter(function(t) {
                                    return !0 !== (0, d.PN)(e1.authenticator, t);
                                });
                                return v(v({}, this.values), {}, {
                                    authenticatorsData: t
                                });
                            }
                        }
                    ]), h;
                }(l.n);
            },
            3118: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    n: function() {
                        return d;
                    }
                });
                var r = n(2982), o = n(1002), i = n(5671), a = n(3144), u = n(4942), c = n(6064), s = n(9344);
                function f(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                function l(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function p(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? l(Object(n), !0).forEach(function(t) {
                            (0, u.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var d = function() {
                    function e1(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        (0, i.Z)(this, e1), (0, u.Z)(this, "remediation", void 0), (0, u.Z)(this, "values", void 0), (0, u.Z)(this, "options", void 0), (0, u.Z)(this, "map", void 0), this.values = p({}, n), this.options = p({}, r), this.formatAuthenticators(), this.remediation = t;
                    }
                    return (0, a.Z)(e1, [
                        {
                            key: "formatAuthenticators",
                            value: function() {
                                if (this.values.authenticators = this.values.authenticators || [], this.values.authenticators = this.values.authenticators.map(function(e1) {
                                    return (0, s.LL)(e1);
                                }), this.values.authenticator) {
                                    var e1 = (0, s.LL)(this.values.authenticator);
                                    this.values.authenticators.some(function(t) {
                                        return (0, s.PN)(e1, t);
                                    }) || this.values.authenticators.push(e1);
                                }
                                this.values.authenticatorsData = this.values.authenticators.reduce(function(e1, t) {
                                    return "object" === (0, o.Z)(t) && Object.keys(t).length > 1 && e1.push(t), e1;
                                }, this.values.authenticatorsData || []);
                            }
                        },
                        {
                            key: "getName",
                            value: function() {
                                return this.remediation.name;
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function(e1) {
                                var t = this;
                                return !(0, c.QG)(this.remediation).find(function(e1) {
                                    return !t.hasData(e1);
                                });
                            }
                        },
                        {
                            key: "getData",
                            value: function(e1) {
                                var t = this;
                                if (!e1) {
                                    var n = (0, c.ix)(this.remediation).reduce(function(e1, n) {
                                        return e1[n] = t.getData(n), e1;
                                    }, {});
                                    return n;
                                }
                                if ("function" == typeof this["map".concat((0, c.Qs)(e1))]) {
                                    var r = this["map".concat((0, c.Qs)(e1))](this.remediation.value.find(function(t) {
                                        return t.name === e1;
                                    }));
                                    if (r) return r;
                                }
                                if (this.map && this.map[e1]) for(var o = this.map[e1], i = 0; i < o.length; i++){
                                    var a = this.values[o[i]];
                                    if (a) return a;
                                }
                                return this.values[e1];
                            }
                        },
                        {
                            key: "hasData",
                            value: function(e1) {
                                return !!this.getData(e1);
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n = this.getName(), r = this.getInputs(), o = this.getAuthenticator(), i = null == o ? void 0 : o.type;
                                return p(p({
                                    name: n,
                                    inputs: r
                                }, i && {
                                    type: i
                                }), o && {
                                    authenticator: o
                                });
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                var e1 = this, t = [];
                                return (this.remediation.value || []).forEach(function(n) {
                                    var r, o = n.name, i = n.type, a = n.visible, u = n.messages;
                                    if (!1 !== a) {
                                        if ("function" == typeof e1["getInput".concat((0, c.Qs)(o))]) r = e1["getInput".concat((0, c.Qs)(o))](n);
                                        else if ("object" !== i) {
                                            var s, f = (e1.map ? e1.map[o] : null) || [];
                                            s = 1 === f.length ? f[0] : f.find(function(t) {
                                                return Object.keys(e1.values).includes(t);
                                            }), s && (r = p(p({}, n), {}, {
                                                name: s
                                            }));
                                        }
                                        r || (r = n), Array.isArray(r) ? r.forEach(function(e1) {
                                            return t.push(e1);
                                        }) : (u && (r.messages = u), t.push(r));
                                    }
                                }), t;
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1, t = this.remediation.value || [], n = this.getInputs(), o = function(e1, t) {
                                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                    if (!n) {
                                        if (Array.isArray(e1) || (n = function(e1, t) {
                                            if (e1) {
                                                if ("string" == typeof e1) return f(e1, t);
                                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? f(e1, t) : void 0;
                                            }
                                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                                            n && (e1 = n);
                                            var r = 0, o = function() {};
                                            return {
                                                s: o,
                                                n: function() {
                                                    return r >= e1.length ? {
                                                        done: !0
                                                    } : {
                                                        done: !1,
                                                        value: e1[r++]
                                                    };
                                                },
                                                e: function(e1) {
                                                    throw e1;
                                                },
                                                f: o
                                            };
                                        }
                                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                    }
                                    var i, a = !0, u = !1;
                                    return {
                                        s: function() {
                                            n = n.call(e1);
                                        },
                                        n: function() {
                                            var e1 = n.next();
                                            return a = e1.done, e1;
                                        },
                                        e: function(e1) {
                                            u = !0, i = e1;
                                        },
                                        f: function() {
                                            try {
                                                a || null == n.return || n.return();
                                            } finally{
                                                if (u) throw i;
                                            }
                                        }
                                    };
                                }([].concat((0, r.Z)(t), (0, r.Z)(n)));
                                try {
                                    for(o.s(); !(e1 = o.n()).done;){
                                        var i = e1.value;
                                        delete this.values[i.name];
                                    }
                                } catch (e1) {
                                    o.e(e1);
                                } finally{
                                    o.f();
                                }
                                return this.values;
                            }
                        },
                        {
                            key: "getAuthenticator",
                            value: function() {
                                var e1, t, n = null === (e1 = this.remediation.relatesTo) || void 0 === e1 ? void 0 : e1.value;
                                if (n) {
                                    var r = (0, c.zg)(this.remediation);
                                    if (!r) return n;
                                    var o = r.form.value.find(function(e1) {
                                        return "id" === e1.name;
                                    }).value, i = null === (t = r.form.value.find(function(e1) {
                                        return "enrollmentId" === e1.name;
                                    })) || void 0 === t ? void 0 : t.value;
                                    return p(p({}, n), {}, {
                                        id: o,
                                        enrollmentId: i
                                    });
                                }
                            }
                        }
                    ], [
                        {
                            key: "getMessages",
                            value: function(e1) {
                                var t, n;
                                if (e1.value) return null === (t = e1.value[0]) || void 0 === t || null === (n = t.form) || void 0 === n ? void 0 : n.value.reduce(function(e1, t) {
                                    return t.messages && (e1 = [].concat((0, r.Z)(e1), (0, r.Z)(t.messages.value))), e1;
                                }, []);
                            }
                        }
                    ]), e1;
                }();
                (0, u.Z)(d, "remediationName", void 0);
            },
            9164: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    n: function() {
                        return m;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(3118), p = n(6064), d = n(7595), h = n(9344);
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function g(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var m = function(e1) {
                    (0, u.Z)(v, e1);
                    var t, n, l = (t = v, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function v() {
                        var e1;
                        (0, r.Z)(this, v);
                        for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                        return e1 = l.call.apply(l, [
                            this
                        ].concat(n)), (0, f.Z)((0, i.Z)(e1), "selectedAuthenticator", void 0), (0, f.Z)((0, i.Z)(e1), "selectedOption", void 0), e1;
                    }
                    return (0, o.Z)(v, [
                        {
                            key: "findMatchedOption",
                            value: function(e1, t) {
                                var n, r, o = function(e1, t) {
                                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                    if (!n) {
                                        if (Array.isArray(e1) || (n = function(e1, t) {
                                            if (e1) {
                                                if ("string" == typeof e1) return g(e1, t);
                                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? g(e1, t) : void 0;
                                            }
                                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                                            n && (e1 = n);
                                            var r = 0, o = function() {};
                                            return {
                                                s: o,
                                                n: function() {
                                                    return r >= e1.length ? {
                                                        done: !0
                                                    } : {
                                                        done: !1,
                                                        value: e1[r++]
                                                    };
                                                },
                                                e: function(e1) {
                                                    throw e1;
                                                },
                                                f: o
                                            };
                                        }
                                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                    }
                                    var i, a = !0, u = !1;
                                    return {
                                        s: function() {
                                            n = n.call(e1);
                                        },
                                        n: function() {
                                            var e1 = n.next();
                                            return a = e1.done, e1;
                                        },
                                        e: function(e1) {
                                            u = !0, i = e1;
                                        },
                                        f: function() {
                                            try {
                                                a || null == n.return || n.return();
                                            } finally{
                                                if (u) throw i;
                                            }
                                        }
                                    };
                                }(e1);
                                try {
                                    var i = function() {
                                        var e1 = r.value;
                                        if (n = t.find(function(t) {
                                            var n = t.relatesTo;
                                            return n.key && n.key === e1.key;
                                        })) return "break";
                                    };
                                    for(o.s(); !(r = o.n()).done && "break" !== i(););
                                } catch (e1) {
                                    o.e(e1);
                                } finally{
                                    o.f();
                                }
                                return n;
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function(e1) {
                                var t = this.values, n = t.authenticators, r = t.authenticator, o = (0, p.zg)(this.remediation).options;
                                if (!n || !n.length) return !1;
                                if ((0, d.H)(r) && r.id) return !0;
                                var i = this.findMatchedOption(n, o);
                                if (i) {
                                    var a, u, c = (null == e1 ? void 0 : e1.currentAuthenticator) && (null == e1 ? void 0 : e1.currentAuthenticator.value.id) === (null === (a = i.relatesTo) || void 0 === a ? void 0 : a.id), s = (null == e1 ? void 0 : e1.currentAuthenticatorEnrollment) && (null == e1 ? void 0 : e1.currentAuthenticatorEnrollment.value.id) === (null === (u = i.relatesTo) || void 0 === u ? void 0 : u.id);
                                    return !c && !s;
                                }
                                return !1;
                            }
                        },
                        {
                            key: "mapAuthenticator",
                            value: function(e1) {
                                var t = this.values, n = t.authenticators, r = t.authenticator;
                                if ((0, d.H)(r) && r.id) return this.selectedAuthenticator = r, r;
                                var o = e1.options, i = (0, h.h_)(n, o);
                                return this.selectedAuthenticator = i.relatesTo, this.selectedOption = i, {
                                    id: null == i ? void 0 : i.value.form.value.find(function(e1) {
                                        return "id" === e1.name;
                                    }).value
                                };
                            }
                        },
                        {
                            key: "getInputAuthenticator",
                            value: function(e1) {
                                return {
                                    name: "authenticator",
                                    type: "string",
                                    options: e1.options.map(function(e1) {
                                        return {
                                            label: e1.label,
                                            value: e1.relatesTo.key
                                        };
                                    })
                                };
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                this.values = (0, a.Z)((0, s.Z)(v.prototype), "getValuesAfterProceed", this).call(this);
                                var t = this.values.authenticators.filter(function(t) {
                                    return !0 !== (0, h.PN)(t, e1.selectedAuthenticator);
                                });
                                return y(y({}, this.values), {}, {
                                    authenticators: t
                                });
                            }
                        }
                    ]), v;
                }(l.n);
            },
            9883: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Q: function() {
                        return E;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(3118), p = n(7644);
                function d(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function h(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? d(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var v = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                return !!(e1.credentials || e1.verificationCode || e1.otp);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.credentials, n = e1.verificationCode, r = e1.otp;
                                if (t || n || r) return t || {
                                    passcode: n || r
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function(e1) {
                                var t;
                                return h(h({}, null === (t = e1.form) || void 0 === t ? void 0 : t.value[0]), {}, {
                                    name: "verificationCode",
                                    type: "string",
                                    required: e1.required
                                });
                            }
                        }
                    ]), a;
                }(p._);
                var y = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.verificationCode;
                                if (t) return {
                                    totp: t
                                };
                            }
                        }
                    ]), a;
                }(v), g = n(9582);
                var m = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                var t = e1.credentials;
                                if (t && t.questionKey && t.answer) return !0;
                                var n = e1.questionKey, r = e1.question, o = e1.answer;
                                return !(!n || !o) || !(!r || !o);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.questionKey, n = e1.question, r = e1.answer;
                                if (r && (t || n)) return {
                                    questionKey: n ? "custom" : t,
                                    question: n,
                                    answer: r
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return [
                                    {
                                        name: "questionKey",
                                        type: "string",
                                        required: !0
                                    },
                                    {
                                        name: "question",
                                        type: "string",
                                        label: "Create a security question"
                                    },
                                    {
                                        name: "answer",
                                        type: "string",
                                        label: "Answer",
                                        required: !0
                                    }
                                ];
                            }
                        }
                    ]), a;
                }(p._);
                var b = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                var t = e1.credentials;
                                return !(!t || !t.answer) || !!e1.answer;
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.answer;
                                if (t) return {
                                    questionKey: this.meta.contextualData.enrolledQuestion.questionKey,
                                    answer: t
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return [
                                    {
                                        name: "answer",
                                        type: "string",
                                        label: "Answer",
                                        required: !0
                                    }
                                ];
                            }
                        }
                    ]), a;
                }(p._);
                var k = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                var t = e1.credentials || e1, n = t.clientData, r = t.attestation;
                                return !(!n || !r);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.credentials, n = e1.clientData, r = e1.attestation;
                                if (t || n || r) return t || {
                                    clientData: n,
                                    attestation: r
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return [
                                    {
                                        name: "clientData",
                                        type: "string",
                                        required: !0,
                                        visible: !1,
                                        label: "Client Data"
                                    },
                                    {
                                        name: "attestation",
                                        type: "string",
                                        required: !0,
                                        visible: !1,
                                        label: "Attestation"
                                    }
                                ];
                            }
                        }
                    ]), a;
                }(p._);
                var w = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                var t = e1.credentials || e1, n = t.clientData, r = t.authenticatorData, o = t.signatureData;
                                return !!(n && r && o);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.credentials, n = e1.authenticatorData, r = e1.clientData, o = e1.signatureData;
                                if (t || n || r || o) return t || {
                                    authenticatorData: n,
                                    clientData: r,
                                    signatureData: o
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return [
                                    {
                                        name: "authenticatorData",
                                        type: "string",
                                        label: "Authenticator Data",
                                        required: !0,
                                        visible: !1
                                    },
                                    {
                                        name: "clientData",
                                        type: "string",
                                        label: "Client Data",
                                        required: !0,
                                        visible: !1
                                    },
                                    {
                                        name: "signatureData",
                                        type: "string",
                                        label: "Signature Data",
                                        required: !0,
                                        visible: !1
                                    }
                                ];
                            }
                        }
                    ]), a;
                }(p._), O = n(7595);
                function Z(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function T(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? Z(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : Z(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var E = function(e1) {
                    (0, u.Z)(p, e1);
                    var t, n, l = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function p(e1) {
                        var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        return (0, r.Z)(this, p), t = l.call(this, e1, n), (0, f.Z)((0, i.Z)(t), "authenticator", void 0), t.authenticator = function(e1) {
                            var t, n, r = e1.relatesTo, o = (null == r ? void 0 : r.value) || {};
                            switch(o.key){
                                case O.pc.OKTA_PASSWORD:
                                    return new g.a(o);
                                case O.pc.SECURITY_QUESTION:
                                    return null !== (t = o.contextualData) && void 0 !== t && t.enrolledQuestion ? new b(o) : new m(o);
                                case O.pc.OKTA_VERIFY:
                                    return new y(o);
                                case O.pc.WEBAUTHN:
                                    return null !== (n = o.contextualData) && void 0 !== n && n.challengeData ? new w(o) : new k(o);
                                default:
                                    return new v(o);
                            }
                        }(e1), t;
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n, r = (0, a.Z)((0, s.Z)(p.prototype), "getNextStep", this).call(this, e1, t), o = null == t || null === (n = t.authenticatorEnrollments) || void 0 === n ? void 0 : n.value;
                                return T(T({}, r), {}, {
                                    authenticatorEnrollments: o
                                });
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function() {
                                return this.authenticator.canVerify(this.values);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function() {
                                return this.authenticator.mapCredentials(this.values);
                            }
                        },
                        {
                            key: "getInputCredentials",
                            value: function(e1) {
                                return this.authenticator.getInputs(e1);
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                return this.values = (0, a.Z)((0, s.Z)(p.prototype), "getValuesAfterProceed", this).call(this), Object.keys(this.values).filter(function(e1) {
                                    return "credentials" !== e1;
                                }).reduce(function(t, n) {
                                    return T(T({}, t), {}, (0, f.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), p;
                }(l.n);
            },
            4560: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    J: function() {
                        return s;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, r.Z)(s);
                }(n(9883).Q);
                (0, c.Z)(s, "remediationName", "challenge-authenticator");
            },
            1104: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    U: function() {
                        return s;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.values.startPolling || "challenge-poll" === this.options.step;
                            }
                        }
                    ]), s;
                }(n(2288).T);
                (0, c.Z)(s, "remediationName", "challenge-poll");
            },
            3857: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    q: function() {
                        return s;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, r.Z)(s);
                }(n(9883).Q);
                (0, c.Z)(s, "remediationName", "enroll-authenticator");
            },
            2288: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    T: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var p = function(e1) {
                    (0, a.Z)(p, e1);
                    var t, n, f = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function p() {
                        return (0, r.Z)(this, p), f.apply(this, arguments);
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.values.startPolling || "enroll-poll" === this.options.step;
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n = (0, i.Z)((0, c.Z)(p.prototype), "getNextStep", this).call(this, e1, t), r = this.getAuthenticator();
                                return !r && null != t && t.currentAuthenticator && (r = t.currentAuthenticator.value), l(l({}, n), {}, {
                                    authenticator: r,
                                    poll: {
                                        required: !0,
                                        refresh: this.remediation.refresh
                                    }
                                });
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                return Object.keys(this.values).filter(function(e1) {
                                    return "startPolling" !== e1;
                                }).reduce(function(t, n) {
                                    return l(l({}, t), {}, (0, s.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), p;
                }(n(3118).n);
                (0, s.Z)(p, "remediationName", "enroll-poll");
            },
            7522: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    w: function() {
                        return v;
                    }
                });
                var r = n(2982), o = n(5671), i = n(3144), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(3118), p = n(9582);
                function d(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function h(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? d(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var v = function(e1) {
                    (0, u.Z)(d, e1);
                    var t, n, l = (t = d, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function d(e1) {
                        var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        return (0, o.Z)(this, d), t = l.call(this, e1, n, r), (0, f.Z)((0, a.Z)(t), "authenticator", null), t.getCredentialsFromRemediation() && (t.authenticator = t.authenticator = new p.a({})), t;
                    }
                    return (0, i.Z)(d, [
                        {
                            key: "canRemediate",
                            value: function() {
                                if (this.authenticator && !this.authenticator.canVerify(this.values)) return !1;
                                var e1 = this.getData().userProfile;
                                return !!e1 && this.remediation.value.find(function(e1) {
                                    return "userProfile" === e1.name;
                                }).form.value.reduce(function(t, n) {
                                    return n.required && (t = t && !!e1[n.name]), t;
                                }, !0);
                            }
                        },
                        {
                            key: "getCredentialsFromRemediation",
                            value: function() {
                                return this.remediation.value.find(function(e1) {
                                    return "credentials" === e1.name;
                                });
                            }
                        },
                        {
                            key: "mapUserProfile",
                            value: function(e1) {
                                var t = this, n = e1.form.value.map(function(e1) {
                                    return e1.name;
                                }).reduce(function(e1, n) {
                                    return t.values[n] ? h(h({}, e1), {}, (0, f.Z)({}, n, t.values[n])) : e1;
                                }, {});
                                if (0 !== Object.keys(n).length) return n;
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function() {
                                var e1 = this.authenticator && this.authenticator.mapCredentials(this.values);
                                if (e1) return e1;
                            }
                        },
                        {
                            key: "getInputUserProfile",
                            value: function(e1) {
                                return (0, r.Z)(e1.form.value);
                            }
                        },
                        {
                            key: "getInputCredentials",
                            value: function(e1) {
                                return (0, r.Z)(e1.form.value);
                            }
                        },
                        {
                            key: "getErrorMessages",
                            value: function(e1) {
                                return e1.value[0].form.value.reduce(function(e1, t) {
                                    return t.messages && e1.push(t.messages.value[0].message), e1;
                                }, []);
                            }
                        }
                    ]), d;
                }(l.n);
                (0, f.Z)(v, "remediationName", "enroll-profile");
            },
            3679: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    t: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var p = function(e1) {
                    (0, a.Z)(p, e1);
                    var t, n, f = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function p() {
                        return (0, r.Z)(this, p), f.apply(this, arguments);
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "getInputEmail",
                            value: function() {
                                return [
                                    {
                                        name: "email",
                                        type: "string",
                                        required: !0,
                                        label: "Email"
                                    }
                                ];
                            }
                        },
                        {
                            key: "getInputPhoneNumber",
                            value: function() {
                                return [
                                    {
                                        name: "phoneNumber",
                                        type: "string",
                                        required: !0,
                                        label: "Phone Number"
                                    }
                                ];
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function() {
                                return Boolean(this.values.email || this.values.phoneNumber);
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n = (0, i.Z)((0, c.Z)(p.prototype), "getNextStep", this).call(this, e1, t), r = t.currentAuthenticator.value;
                                return l(l({}, n), {}, {
                                    authenticator: r
                                });
                            }
                        },
                        {
                            key: "getData",
                            value: function() {
                                return {
                                    stateHandle: this.values.stateHandle,
                                    email: this.values.email,
                                    phoneNumber: this.values.phoneNumber
                                };
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                return Object.keys(this.values).filter(function(e1) {
                                    return ![
                                        "email",
                                        "phoneNumber"
                                    ].includes(e1);
                                }).reduce(function(t, n) {
                                    return l(l({}, t), {}, (0, s.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), p;
                }(n(3118).n);
                (0, s.Z)(p, "remediationName", "enrollment-channel-data");
            },
            9732: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    P: function() {
                        return k;
                    }
                });
                var r = n(5861), o = n(4942), i = n(4925), a = n(5671), u = n(3144), c = n(136), s = n(2963), f = n(1120), l = n(4687), p = n.n(l), d = n(3118), h = n(1002), v = n(885);
                function y(e1) {
                    if (Array.isArray(e1)) return e1.map(function(e1) {
                        return "string" == typeof e1 || "number" == typeof e1 || "boolean" == typeof e1 ? e1 : y(e1);
                    });
                    for(var t = {}, n = 0, r = Object.entries(e1); n < r.length; n++){
                        var o = (0, v.Z)(r[n], 2), i = o[0], a = o[1];
                        if (null != a) {
                            if ("object" === (0, h.Z)(a)) {
                                var u = Object.keys(a);
                                if ([
                                    "value",
                                    "form"
                                ].includes(i) && 1 === u.length && [
                                    "value",
                                    "form"
                                ].includes(u[0])) {
                                    var c = y(a);
                                    Object.entries(c).forEach(function(e1) {
                                        var n = (0, v.Z)(e1, 2), r = n[0], o = n[1];
                                        t[r] = o;
                                    });
                                } else t[i] = y(a);
                            } else t[i] = a;
                        }
                    }
                    return t;
                }
                var g = [
                    "href",
                    "method",
                    "rel",
                    "accepts",
                    "produces",
                    "value",
                    "action"
                ];
                function m(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function b(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? m(Object(n), !0).forEach(function(t) {
                            (0, o.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var k = function(e1) {
                    (0, c.Z)(l, e1);
                    var t, n, o = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, f.Z)(t);
                        if (n) {
                            var o = (0, f.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, s.Z)(this, e1);
                    });
                    function l() {
                        return (0, a.Z)(this, l), o.apply(this, arguments);
                    }
                    return (0, u.Z)(l, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !("function" != typeof this.remediation.action || "poll" !== this.remediation.name && !this.remediation.name.endsWith("-poll") && !this.options.step);
                            }
                        },
                        {
                            key: "getData",
                            value: function() {
                                var e1 = this;
                                return this.getInputs().reduce(function(t, n) {
                                    var r = n.name;
                                    return t[r] = e1.values[r], t;
                                }, {});
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n, o = this.getName(), a = this.getInputs(), u = this.remediation, c = (u.href, u.method, u.rel, u.accepts, u.produces, u.value, u.action), s = (0, i.Z)(u, g);
                                return c ? b(b(b({}, s), !!a.length && {
                                    inputs: a
                                }), {}, {
                                    action: (n = (0, r.Z)(p().mark(function t(n) {
                                        return p().wrap(function(t) {
                                            for(;;)switch(t.prev = t.next){
                                                case 0:
                                                    return t.abrupt("return", e1.idx.proceed(b({
                                                        step: o
                                                    }, n)));
                                                case 1:
                                                case "end":
                                                    return t.stop();
                                            }
                                        }, t);
                                    })), function(e1) {
                                        return n.apply(this, arguments);
                                    })
                                }) : b({}, this.remediation);
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return (this.remediation.value || []).filter(function(e1) {
                                    return "stateHandle" !== e1.name;
                                }).map(y).map(function(e1) {
                                    return e1.type = e1.type || "string", e1;
                                });
                            }
                        }
                    ]), l;
                }(d.n);
            },
            8628: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    h: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var p = function(e1) {
                    (0, a.Z)(p, e1);
                    var t, n, f = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function p() {
                        var e1;
                        (0, r.Z)(this, p);
                        for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                        return e1 = f.call.apply(f, [
                            this
                        ].concat(n)), (0, s.Z)((0, i.Z)(e1), "map", {
                            identifier: [
                                "username"
                            ]
                        }), e1;
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.getData().identifier;
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function() {
                                var e1 = this.values, t = e1.credentials, n = e1.password;
                                if (t || n) return t || {
                                    passcode: n
                                };
                            }
                        },
                        {
                            key: "getInputCredentials",
                            value: function(e1) {
                                return l(l({}, e1.form.value[0]), {}, {
                                    name: "password",
                                    required: e1.required
                                });
                            }
                        }
                    ]), p;
                }(n(3118).n);
                (0, s.Z)(p, "remediationName", "identify");
            },
            9024: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    j: function() {
                        return l;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, c.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var l = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "mapCredentials",
                            value: function() {
                                var e1 = this.values.newPassword;
                                if (e1) return {
                                    passcode: e1
                                };
                            }
                        },
                        {
                            key: "getInputCredentials",
                            value: function(e1) {
                                var t = "password" === this.getAuthenticator().type ? "newPassword" : "verificationCode";
                                return f(f({}, e1.form.value[0]), {}, {
                                    name: t
                                });
                            }
                        }
                    ]), s;
                }(n(3118).n);
                (0, c.Z)(l, "remediationName", "reenroll-authenticator");
            },
            8107: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    i: function() {
                        return s;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, r.Z)(s);
                }(n(9024).j);
                (0, c.Z)(s, "remediationName", "reenroll-authenticator-warning");
            },
            8490: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    O: function() {
                        return s;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !1;
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function() {
                                var e1 = this.remediation;
                                return {
                                    name: e1.name,
                                    type: e1.type,
                                    idp: e1.idp,
                                    href: e1.href
                                };
                            }
                        }
                    ]), s;
                }(n(3118).n);
                (0, c.Z)(s, "remediationName", "redirect-idp");
            },
            1019: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    G: function() {
                        return s;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, r.Z)(s);
                }(n(9883).Q);
                (0, c.Z)(s, "remediationName", "reset-authenticator");
            },
            7311: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return d;
                    }
                });
                var r = n(2982), o = n(3144), i = n(5671), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(9164), l = n(6064), p = n(7595);
                var d = function(e1) {
                    (0, a.Z)(f, e1);
                    var t, n, s = (t = f, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function f(e1) {
                        var t, n, o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        (0, i.Z)(this, f);
                        var u = "recoverPassword" === (n = s.call(this, e1, o, a)).options.flow;
                        return (null === (t = (0, l.zg)(e1).options) || void 0 === t ? void 0 : t.some(function(e1) {
                            var t = e1.relatesTo;
                            return (null == t ? void 0 : t.key) === p.pc.OKTA_PASSWORD;
                        })) && (u || n.values.password) && (n.values.authenticators = [].concat((0, r.Z)(n.values.authenticators || []), [
                            {
                                key: p.pc.OKTA_PASSWORD
                            }
                        ])), n;
                    }
                    return (0, o.Z)(f);
                }(f.n);
                (0, s.Z)(d, "remediationName", "select-authenticator-authenticate");
            },
            9865: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    j: function() {
                        return s;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, r.Z)(s);
                }(n(9164).n);
                (0, c.Z)(s, "remediationName", "select-authenticator-enroll");
            },
            5272: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    G: function() {
                        return d;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942);
                function l(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function p(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? l(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var d = function(e1) {
                    (0, u.Z)(d, e1);
                    var t, n, l = (t = d, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function d() {
                        var e1;
                        (0, r.Z)(this, d);
                        for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                        return e1 = l.call.apply(l, [
                            this
                        ].concat(n)), (0, f.Z)((0, i.Z)(e1), "authenticator", void 0), (0, f.Z)((0, i.Z)(e1), "map", {
                            identifier: [
                                "username"
                            ]
                        }), e1;
                    }
                    return (0, o.Z)(d, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.getData("identifier") && (0, a.Z)((0, s.Z)(d.prototype), "canRemediate", this).call(this);
                            }
                        },
                        {
                            key: "mapAuthenticator",
                            value: function(e1) {
                                var t, n, r, o = (0, a.Z)((0, s.Z)(d.prototype), "mapAuthenticator", this).call(this, e1), i = null === (t = this.selectedOption) || void 0 === t ? void 0 : t.value.form.value.find(function(e1) {
                                    return "methodType" === e1.name;
                                }), u = this.values.methodType || (null == i ? void 0 : i.value) || (null == i || null === (n = i.options) || void 0 === n || null === (r = n[0]) || void 0 === r ? void 0 : r.value);
                                return u ? p(p({}, o), {}, {
                                    methodType: u
                                }) : o;
                            }
                        },
                        {
                            key: "getInputUsername",
                            value: function() {
                                return {
                                    name: "username",
                                    type: "string"
                                };
                            }
                        }
                    ]), d;
                }(n(9164).n);
                (0, f.Z)(d, "remediationName", "select-authenticator-unlock-account");
            },
            4713: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    j: function() {
                        return s;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !0;
                            }
                        }
                    ]), s;
                }(n(3118).n);
                (0, c.Z)(s, "remediationName", "select-enroll-profile");
            },
            3403: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    V: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var p = function(e1) {
                    (0, a.Z)(p, e1);
                    var t, n, f = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function p() {
                        return (0, r.Z)(this, p), f.apply(this, arguments);
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "canRemediate",
                            value: function() {
                                if (this.values.channel) return !0;
                                if (this.values.authenticator) {
                                    var e1 = this.values.authenticator, t = e1.id, n = e1.channel;
                                    if (t && n) return !0;
                                }
                                return !1;
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n = (0, i.Z)((0, c.Z)(p.prototype), "getNextStep", this).call(this, e1, t), r = t.currentAuthenticator.value;
                                return l(l({}, n), {}, {
                                    authenticator: r
                                });
                            }
                        },
                        {
                            key: "getData",
                            value: function() {
                                var e1;
                                return {
                                    authenticator: {
                                        id: this.remediation.value[0].value.form.value[0].value,
                                        channel: (null === (e1 = this.values.authenticator) || void 0 === e1 ? void 0 : e1.channel) || this.values.channel
                                    },
                                    stateHandle: this.values.stateHandle
                                };
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                this.values = (0, i.Z)((0, c.Z)(p.prototype), "getValuesAfterProceed", this).call(this), delete this.values.authenticators;
                                var t = this.values.channel ? "channel" : "authenticator";
                                return Object.keys(this.values).filter(function(e1) {
                                    return e1 !== t;
                                }).reduce(function(t, n) {
                                    return l(l({}, t), {}, (0, s.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), p;
                }(n(3118).n);
                (0, s.Z)(p, "remediationName", "select-enrollment-channel");
            },
            8443: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    h: function() {
                        return s;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.values.skip || "skip" === this.options.step;
                            }
                        }
                    ]), s;
                }(n(3118).n);
                (0, c.Z)(s, "remediationName", "skip");
            },
            6064: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    var t;
                    return null === (t = e1.value) || void 0 === t ? void 0 : t.map(function(e1) {
                        return e1.name;
                    });
                }
                function o(e1) {
                    var t;
                    return null === (t = e1.value) || void 0 === t ? void 0 : t.reduce(function(e1, t) {
                        return t.required && e1.push(t.name), e1;
                    }, []);
                }
                function i(e1) {
                    return e1.charAt(0).toUpperCase() + e1.substring(1);
                }
                function a(e1) {
                    return e1.value.find(function(e1) {
                        return "authenticator" === e1.name;
                    });
                }
                n.d(t, {
                    QG: function() {
                        return o;
                    },
                    Qs: function() {
                        return i;
                    },
                    ix: function() {
                        return r;
                    },
                    zg: function() {
                        return a;
                    }
                });
            },
            3377: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    K: function() {
                        return M;
                    }
                });
                var r = n(5861), o = n(4942), i = n(4687), a = n.n(i), u = n(6131), c = n(2660), s = n(1002), f = n(2982), l = n(9123), p = n(5031);
                function d(e1, t) {
                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e1) || (n = function(e1, t) {
                            if (e1) {
                                if ("string" == typeof e1) return h(e1, t);
                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? h(e1, t) : void 0;
                            }
                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                            n && (e1 = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e1.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e1[r++]
                                    };
                                },
                                e: function(e1) {
                                    throw e1;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, u = !1;
                    return {
                        s: function() {
                            n = n.call(e1);
                        },
                        n: function() {
                            var e1 = n.next();
                            return a = e1.done, e1;
                        },
                        e: function(e1) {
                            u = !0, i = e1;
                        },
                        f: function() {
                            try {
                                a || null == n.return || n.return();
                            } finally{
                                if (u) throw i;
                            }
                        }
                    };
                }
                function h(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, o.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function g(e1, t) {
                    return Object.keys(t.actions).find(function(t) {
                        return !!e1.resend && t.includes("-resend");
                    });
                }
                function m(e1) {
                    return y(y({}, e1), {}, {
                        resend: void 0
                    });
                }
                function b(e1, t) {
                    var n = e1.actions || [];
                    return n = n.filter(function(e1) {
                        return "string" == typeof e1 ? e1 !== t : e1.name !== t;
                    }), y(y({}, e1), {}, {
                        actions: n
                    });
                }
                function k(e1, t, n, r) {
                    return w.apply(this, arguments);
                }
                function w() {
                    return (w = (0, r.Z)(a().mark(function e1(t, n, r, o) {
                        var i, u, c, h, v, w, O, Z, T, E, S, P, x, A, R, _, j, C;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (u = (i = n).neededToProceed, c = i.interactionCode, h = o.flow, !c) {
                                        e1.next = 4;
                                        break;
                                    }
                                    return e1.abrupt("return", {
                                        idxResponse: n
                                    });
                                case 4:
                                    if (v = (0, p.l6)(n, r, o), w = g(r, n), O = o.actions || [], !(Z = [].concat((0, f.Z)(O), (0, f.Z)(w && [
                                        w
                                    ] || [])))) {
                                        e1.next = 28;
                                        break;
                                    }
                                    T = d(Z), e1.prev = 10, S = a().mark(function e1() {
                                        var i, c, s, f;
                                        return a().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    if (i = E.value, c = {}, "string" != typeof i && (c = i.params || {}, i = i.name), s = m(r), f = b(o, i), "function" != typeof n.actions[i]) {
                                                        e1.next = 14;
                                                        break;
                                                    }
                                                    return e1.next = 8, n.actions[i](c);
                                                case 8:
                                                    if (!1 !== (n = e1.sent).requestDidSucceed) {
                                                        e1.next = 11;
                                                        break;
                                                    }
                                                    return e1.abrupt("return", {
                                                        v: (0, p.Tc)(t, n, o)
                                                    });
                                                case 11:
                                                    if ("cancel" !== i) {
                                                        e1.next = 13;
                                                        break;
                                                    }
                                                    return e1.abrupt("return", {
                                                        v: {
                                                            idxResponse: n,
                                                            canceled: !0
                                                        }
                                                    });
                                                case 13:
                                                    return e1.abrupt("return", {
                                                        v: k(t, n, s, f)
                                                    });
                                                case 14:
                                                    if (!u.find(function(e1) {
                                                        return e1.name === i;
                                                    })) {
                                                        e1.next = 22;
                                                        break;
                                                    }
                                                    return e1.next = 18, n.proceed(i, c);
                                                case 18:
                                                    if (!1 !== (n = e1.sent).requestDidSucceed) {
                                                        e1.next = 21;
                                                        break;
                                                    }
                                                    return e1.abrupt("return", {
                                                        v: (0, p.Tc)(t, n, o)
                                                    });
                                                case 21:
                                                    return e1.abrupt("return", {
                                                        v: k(t, n, r, f)
                                                    });
                                                case 22:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }), T.s();
                                case 13:
                                    if ((E = T.n()).done) {
                                        e1.next = 20;
                                        break;
                                    }
                                    return e1.delegateYield(S(), "t0", 15);
                                case 15:
                                    if (P = e1.t0, "object" !== (0, s.Z)(P)) {
                                        e1.next = 18;
                                        break;
                                    }
                                    return e1.abrupt("return", P.v);
                                case 18:
                                    e1.next = 13;
                                    break;
                                case 20:
                                    e1.next = 25;
                                    break;
                                case 22:
                                    e1.prev = 22, e1.t1 = e1.catch(10), T.e(e1.t1);
                                case 25:
                                    return e1.prev = 25, T.f(), e1.finish(25);
                                case 28:
                                    if (!(x = (0, p.xn)(n))) {
                                        e1.next = 31;
                                        break;
                                    }
                                    return e1.abrupt("return", {
                                        idxResponse: n,
                                        terminal: x
                                    });
                                case 31:
                                    if (v) {
                                        e1.next = 43;
                                        break;
                                    }
                                    if (!o.step) {
                                        e1.next = 40;
                                        break;
                                    }
                                    return r = (0, p.Ax)(n, o.step, r), e1.next = 36, n.proceed(o.step, r);
                                case 36:
                                    if (!1 !== (n = e1.sent).requestDidSucceed) {
                                        e1.next = 39;
                                        break;
                                    }
                                    return e1.abrupt("return", (0, p.Tc)(t, n, o));
                                case 39:
                                    return e1.abrupt("return", {
                                        idxResponse: n
                                    });
                                case 40:
                                    if ("default" !== h) {
                                        e1.next = 42;
                                        break;
                                    }
                                    return e1.abrupt("return", {
                                        idxResponse: n
                                    });
                                case 42:
                                    throw new l.Z("\n      No remediation can match current flow, check policy settings in your org.\n      Remediations: [".concat(u.reduce(function(e1, t) {
                                        return e1 ? e1 + " ," + t.name : t.name;
                                    }, ""), "]\n    "));
                                case 43:
                                    if (v.canRemediate()) {
                                        e1.next = 46;
                                        break;
                                    }
                                    return A = (0, p.TR)(t, v, n), e1.abrupt("return", {
                                        idxResponse: n,
                                        nextStep: A
                                    });
                                case 46:
                                    return R = v.getName(), _ = v.getData(), e1.next = 50, n.proceed(R, _);
                                case 50:
                                    if (!1 !== (n = e1.sent).requestDidSucceed) {
                                        e1.next = 53;
                                        break;
                                    }
                                    return e1.abrupt("return", (0, p.Tc)(t, n, o));
                                case 53:
                                    if (r = v.getValuesAfterProceed(), !(o = y(y({}, o), {}, {
                                        step: void 0
                                    })).useGenericRemediator || n.interactionCode || (0, p.xn)(n)) {
                                        e1.next = 59;
                                        break;
                                    }
                                    return j = (0, p.l6)(n, r, o), C = (0, p.TR)(t, j, n), e1.abrupt("return", {
                                        idxResponse: n,
                                        nextStep: C
                                    });
                                case 59:
                                    return e1.abrupt("return", k(t, n, r, o));
                                case 60:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                10,
                                22,
                                25,
                                28
                            ]
                        ]);
                    }))).apply(this, arguments);
                }
                var O = n(7595), Z = n(2620);
                function T(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function E(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? T(Object(n), !0).forEach(function(t) {
                            (0, o.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : T(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function S(e1) {
                    var t = E({}, e1);
                    return [
                        "flow",
                        "remediators",
                        "actions",
                        "withCredentials",
                        "step",
                        "useGenericRemediator",
                        "exchangeCodeForTokens"
                    ].forEach(function(e1) {
                        delete t[e1];
                    }), t;
                }
                function P(e1, t) {
                    var n, r, o = t.options, i = o = E(E({}, e1.options.idx), o), a = i.flow, u = i.withCredentials, c = i.remediators, s = i.actions, f = O.Qd.PENDING;
                    a = a || (null === (n = (r = e1.idx).getFlow) || void 0 === n ? void 0 : n.call(r)) || "default";
                    var l, d;
                    null === (l = (d = e1.idx).setFlow) || void 0 === l || l.call(d, a);
                    var h = (0, p.sH)(e1, a);
                    u = void 0 !== u ? u : h.withCredentials, c = c || h.remediators, s = s || h.actions;
                    return E(E({}, t), {}, {
                        options: E(E({}, o), {}, {
                            flow: a,
                            withCredentials: u,
                            remediators: c,
                            actions: s
                        }),
                        status: f
                    });
                }
                function x(e1, t) {
                    return A.apply(this, arguments);
                }
                function A() {
                    return (A = (0, r.Z)(a().mark(function e1(t, n) {
                        var r, o, i, s, f, l, p, d, h, v, y, g, m, b, k, w, O;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = n.options, o = r.stateHandle, i = r.withCredentials, s = r.version, f = r.state, l = r.scopes, p = r.recoveryToken, d = r.activationToken, h = r.maxAge, v = r.acrValues, y = r.nonce, g = r.useGenericRemediator, b = (0, Z.uN)(t, {
                                        state: f,
                                        recoveryToken: p,
                                        activationToken: d
                                    }), !o) {
                                        e1.next = 9;
                                        break;
                                    }
                                    return e1.next = 6, (0, c.L)(t, {
                                        withCredentials: i,
                                        version: s,
                                        stateHandle: o,
                                        useGenericRemediator: g
                                    });
                                case 6:
                                    m = e1.sent, e1.next = 20;
                                    break;
                                case 9:
                                    if (w = null === (k = b) || void 0 === k ? void 0 : k.interactionHandle) {
                                        e1.next = 17;
                                        break;
                                    }
                                    return t.transactionManager.clear(), e1.next = 14, (0, u.E)(t, {
                                        withCredentials: i,
                                        state: f,
                                        scopes: l,
                                        activationToken: d,
                                        recoveryToken: p,
                                        maxAge: h,
                                        acrValues: v,
                                        nonce: y
                                    });
                                case 14:
                                    O = e1.sent, w = O.interactionHandle, b = O.meta;
                                case 17:
                                    return e1.next = 19, (0, c.L)(t, {
                                        withCredentials: i,
                                        version: s,
                                        interactionHandle: w,
                                        useGenericRemediator: g
                                    });
                                case 19:
                                    m = e1.sent;
                                case 20:
                                    return e1.abrupt("return", E(E({}, n), {}, {
                                        idxResponse: m,
                                        meta: b
                                    }));
                                case 21:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function R(e1, t) {
                    return _.apply(this, arguments);
                }
                function _() {
                    return (_ = (0, r.Z)(a().mark(function e1(t, n) {
                        var r, o, i, u, c, s, f, l, p, d, h, v, y;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = n.idxResponse, o = n.options, i = n.values, u = o.autoRemediate, c = o.remediators, s = o.actions, f = o.flow, l = o.step, p = o.useGenericRemediator, !1 !== u && (c || s || l)) {
                                        e1.next = 5;
                                        break;
                                    }
                                    return e1.abrupt("return", n);
                                case 5:
                                    return i = E(E({}, i), {}, {
                                        stateHandle: r.rawIdxState.stateHandle
                                    }), e1.next = 8, k(t, r, i, {
                                        remediators: c,
                                        actions: s,
                                        flow: f,
                                        step: l,
                                        useGenericRemediator: p
                                    });
                                case 8:
                                    return d = e1.sent, h = d.idxResponse, v = d.nextStep, y = d.canceled, r = h, e1.abrupt("return", E(E({}, n), {}, {
                                        idxResponse: r,
                                        nextStep: v,
                                        canceled: y
                                    }));
                                case 14:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function j(e1, t) {
                    return C.apply(this, arguments);
                }
                function C() {
                    return (C = (0, r.Z)(a().mark(function e1(t, n) {
                        var r, o, i, u, c, s, f, l, p, d, h;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return r = n.meta, o = n.idxResponse, i = o.interactionCode, c = (u = r).clientId, s = u.codeVerifier, f = u.ignoreSignature, l = u.redirectUri, p = u.urls, d = u.scopes, e1.next = 5, t.token.exchangeCodeForTokens({
                                        interactionCode: i,
                                        clientId: c,
                                        codeVerifier: s,
                                        ignoreSignature: f,
                                        redirectUri: l,
                                        scopes: d
                                    }, p);
                                case 5:
                                    return h = e1.sent, e1.abrupt("return", h.tokens);
                                case 7:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function I(e1, t) {
                    return D.apply(this, arguments);
                }
                function D() {
                    return (D = (0, r.Z)(a().mark(function e1(t, n) {
                        var r, o, i, u, c, s, f, l, d, h, v, y, g, m, b, k;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = n.options, o = n.idxResponse, i = n.canceled, u = n.status, c = r.exchangeCodeForTokens, s = !1, f = !1, l = !0, o && (s = !(!o.requestDidSucceed && !o.stepUp), v = (0, p.KM)(o), y = (0, p.kw)(t, o, r.useGenericRemediator), g = (0, p.lx)(o, r), m = (0, p.xn)(o)), !m) {
                                        e1.next = 15;
                                        break;
                                    }
                                    u = O.Qd.TERMINAL, b = Object.keys(o.actions).length > 0, k = !!g.find(function(e1) {
                                        return "ERROR" === e1.class;
                                    }), b || k || !0 !== o.requestDidSucceed ? s = !!b : f = !0, l = !1, e1.next = 32;
                                    break;
                                case 15:
                                    if (!i) {
                                        e1.next = 20;
                                        break;
                                    }
                                    u = O.Qd.CANCELED, f = !0, e1.next = 32;
                                    break;
                                case 20:
                                    if (null == o || !o.interactionCode) {
                                        e1.next = 32;
                                        break;
                                    }
                                    if (d = o.interactionCode, !1 !== c) {
                                        e1.next = 27;
                                        break;
                                    }
                                    u = O.Qd.SUCCESS, f = !1, e1.next = 32;
                                    break;
                                case 27:
                                    return e1.next = 29, j(t, n);
                                case 29:
                                    h = e1.sent, u = O.Qd.SUCCESS, f = !0;
                                case 32:
                                    return e1.abrupt("return", E(E({}, n), {}, {
                                        status: u,
                                        interactionCode: d,
                                        tokens: h,
                                        shouldSaveResponse: s,
                                        shouldClearTransaction: f,
                                        clearSharedStorage: l,
                                        enabledFeatures: v,
                                        availableSteps: y,
                                        messages: g,
                                        terminal: m
                                    }));
                                case 33:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function M(e1) {
                    return N.apply(this, arguments);
                }
                function N() {
                    return N = (0, r.Z)(a().mark(function e1(t) {
                        var n, r, o, i, u, c, s, f, l, p, d, h, v, y, g, m, b, k, w, O, T, A, _, j, C, D, M, N, U = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return r = {
                                        options: n = U.length > 1 && void 0 !== U[1] ? U[1] : {},
                                        values: S(n)
                                    }, r = P(t, r), e1.next = 5, x(t, r);
                                case 5:
                                    return r = e1.sent, e1.next = 8, R(t, r);
                                case 8:
                                    return r = e1.sent, e1.next = 11, I(t, r);
                                case 11:
                                    return r = e1.sent, i = (o = r).idxResponse, u = o.meta, c = o.shouldSaveResponse, s = o.shouldClearTransaction, f = o.clearSharedStorage, l = o.status, p = o.enabledFeatures, d = o.availableSteps, h = o.tokens, v = o.nextStep, y = o.messages, g = o.error, m = o.interactionCode, s ? t.transactionManager.clear({
                                        clearSharedStorage: f
                                    }) : ((0, Z.r0)(t, E({}, u)), c && (w = (k = i).rawIdxState, O = k.requestDidSucceed, t.transactionManager.saveIdxResponse({
                                        rawIdxResponse: w,
                                        requestDidSucceed: O,
                                        stateHandle: null === (b = i.context) || void 0 === b ? void 0 : b.stateHandle,
                                        interactionHandle: null == u ? void 0 : u.interactionHandle
                                    }))), A = (T = i || {}).actions, _ = T.context, j = T.neededToProceed, C = T.proceed, D = T.rawIdxState, M = T.requestDidSucceed, N = T.stepUp, e1.abrupt("return", E(E(E(E(E(E(E(E(E({
                                        status: l
                                    }, u && {
                                        meta: u
                                    }), p && {
                                        enabledFeatures: p
                                    }), d && {
                                        availableSteps: d
                                    }), h && {
                                        tokens: h
                                    }), v && {
                                        nextStep: v
                                    }), y && y.length && {
                                        messages: y
                                    }), g && {
                                        error: g
                                    }), N && {
                                        stepUp: N
                                    }), {}, {
                                        interactionCode: m,
                                        actions: A,
                                        context: _,
                                        neededToProceed: j,
                                        proceed: C,
                                        rawIdxState: D,
                                        requestDidSucceed: M
                                    }));
                                case 16:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), N.apply(this, arguments);
                }
            },
            2473: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Y: function() {
                        return f;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3377);
                function c(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function s(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? c(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function f(e1) {
                    return l.apply(this, arguments);
                }
                function l() {
                    return l = (0, o.Z)(a().mark(function e1(t) {
                        var n, r = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = r.length > 1 && void 0 !== r[1] ? r[1] : {}, t.transactionManager.clear(), e1.abrupt("return", (0, u.K)(t, s({
                                        exchangeCodeForTokens: !1
                                    }, n)));
                                case 3:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), l.apply(this, arguments);
                }
            },
            4143: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return h;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(5763), s = n(1971), f = n(2647), l = n(415), p = n(146), d = n(9123);
                function h() {
                    return function(e1) {
                        (0, i.Z)(h, e1);
                        var t, n, f = (t = h, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, u.Z)(t);
                            if (n) {
                                var o = (0, u.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, a.Z)(this, e1);
                        });
                        function h(e1, t, n) {
                            return (0, r.Z)(this, h), f.call(this, e1, t, n);
                        }
                        return (0, o.Z)(h, [
                            {
                                key: "getIdxResponseStorage",
                                value: function(e1) {
                                    var t;
                                    if ((0, l.isBrowser)()) try {
                                        t = this.storageUtil.getStorageByType("memory", e1);
                                    } catch (e1) {
                                        (0, p.ZK)("No response storage found, you may want to provide custom implementation for intermediate idx responses to optimize the network traffic");
                                    }
                                    else {
                                        var n = this.getTransactionStorage(e1);
                                        n && (t = {
                                            getItem: function(e1) {
                                                var t = n.getStorage();
                                                return t && t[e1] ? t[e1] : null;
                                            },
                                            setItem: function(e1, t) {
                                                var r = n.getStorage();
                                                if (!r) throw new d.Z("Transaction has been cleared, failed to save idxState");
                                                r[e1] = t, n.setStorage(r);
                                            },
                                            removeItem: function(e1) {
                                                var t = n.getStorage();
                                                t && (delete t[e1], n.setStorage(t));
                                            }
                                        });
                                    }
                                    return t ? new c._(t, s.IDX_RESPONSE_STORAGE_NAME) : null;
                                }
                            }
                        ]), h;
                    }((0, f.a)());
                }
            },
            2620: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $0: function() {
                        return h;
                    },
                    Co: function() {
                        return y;
                    },
                    Jm: function() {
                        return b;
                    },
                    UC: function() {
                        return O;
                    },
                    Wf: function() {
                        return k;
                    },
                    Xc: function() {
                        return p;
                    },
                    bl: function() {
                        return w;
                    },
                    r0: function() {
                        return m;
                    },
                    uN: function() {
                        return v;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3193), c = n(146), s = n(2865);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function p(e1) {
                    return d.apply(this, arguments);
                }
                function d() {
                    return d = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, u, c, f, p, d, h, v, y, g, m, b, k, w, O = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = O.length > 1 && void 0 !== O[1] ? O[1] : {}, e1.next = 3, t.token.prepareTokenParams(n);
                                case 3:
                                    return r = e1.sent, o = (0, s.H)(t, r), i = l(l({}, t.options), n), u = i.flow, c = void 0 === u ? "default" : u, f = i.withCredentials, p = void 0 === f || f, d = i.activationToken, h = void 0 === d ? void 0 : d, v = i.recoveryToken, y = void 0 === v ? void 0 : v, g = i.maxAge, m = void 0 === g ? void 0 : g, b = i.acrValues, k = void 0 === b ? void 0 : b, w = l(l({}, o), {}, {
                                        flow: c,
                                        withCredentials: p,
                                        activationToken: h,
                                        recoveryToken: y,
                                        maxAge: m,
                                        acrValues: k
                                    }), e1.abrupt("return", w);
                                case 8:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), d.apply(this, arguments);
                }
                function h(e1, t) {
                    var n = v(e1, t);
                    return !(null == n || !n.interactionHandle);
                }
                function v(e1, t) {
                    var n;
                    t = (0, u.YY)(t), t = l(l({}, e1.options), t);
                    try {
                        n = e1.transactionManager.load(t);
                    } catch (e1) {}
                    if (n) return k(n, t) ? n : void (0, c.ZK)("Saved transaction meta does not match the current configuration. This may indicate that two apps are sharing a storage key.");
                }
                function y(e1, t) {
                    return g.apply(this, arguments);
                }
                function g() {
                    return (g = (0, o.Z)(a().mark(function e1(t, n) {
                        var r;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = (0, u.YY)(n), n = l(l({}, t.options), n), !(r = v(t, n))) {
                                        e1.next = 5;
                                        break;
                                    }
                                    return e1.abrupt("return", r);
                                case 5:
                                    return e1.abrupt("return", p(t, n));
                                case 6:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function m(e1, t) {
                    e1.transactionManager.save(t, {
                        muteWarning: !0
                    });
                }
                function b(e1) {
                    e1.transactionManager.clear();
                }
                function k(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return !1 !== O(e1, t, [
                        "issuer",
                        "clientId",
                        "redirectUri",
                        "state",
                        "codeChallenge",
                        "codeChallengeMethod",
                        "activationToken",
                        "recoveryToken"
                    ]) && !1 !== w(e1, t.flow);
                }
                function w(e1, t) {
                    return !(t && "default" !== t && "proceed" !== t) || t === e1.flow;
                }
                function O(e1, t, n) {
                    return !n.some(function(n) {
                        var r = t[n];
                        if (r && r !== e1[n]) return !0;
                    });
                }
            },
            7595: function(e1, t, n) {
                "use strict";
                var r, o, i;
                function a(e1) {
                    return e1 && (e1.key || e1.id);
                }
                n.d(t, {
                    Fw: function() {
                        return i;
                    },
                    H: function() {
                        return a;
                    },
                    Qd: function() {
                        return r;
                    },
                    pc: function() {
                        return o;
                    }
                }), function(e1) {
                    e1.SUCCESS = "SUCCESS", e1.PENDING = "PENDING", e1.FAILURE = "FAILURE", e1.TERMINAL = "TERMINAL", e1.CANCELED = "CANCELED";
                }(r || (r = {})), function(e1) {
                    e1.OKTA_PASSWORD = "okta_password", e1.OKTA_EMAIL = "okta_email", e1.PHONE_NUMBER = "phone_number", e1.GOOGLE_AUTHENTICATOR = "google_otp", e1.SECURITY_QUESTION = "security_question", e1.OKTA_VERIFY = "okta_verify", e1.WEBAUTHN = "webauthn";
                }(o || (o = {})), function(e1) {
                    e1.PASSWORD_RECOVERY = "recover-password", e1.REGISTRATION = "enroll-profile", e1.SOCIAL_IDP = "redirect-idp", e1.ACCOUNT_UNLOCK = "unlock-account";
                }(i || (i = {}));
            },
            480: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return e1 && e1.version;
                }
                n.d(t, {
                    P: function() {
                        return r;
                    }
                });
            },
            8277: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    l: function() {
                        return h;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3377), c = n(2620), s = n(2473), f = n(9123), l = n(7595);
                function p(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function d(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? p(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function h(e1) {
                    return v.apply(this, arguments);
                }
                function v() {
                    return v = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if ((n = i.length > 1 && void 0 !== i[1] ? i[1] : {}).flow = "unlockAccount", (0, c.$0)(t)) {
                                        e1.next = 9;
                                        break;
                                    }
                                    return e1.next = 5, (0, s.Y)(t, d(d({}, n), {}, {
                                        autoRemediate: !1
                                    }));
                                case 5:
                                    if (r = e1.sent, !(o = r.enabledFeatures) || o.includes(l.Fw.ACCOUNT_UNLOCK)) {
                                        e1.next = 9;
                                        break;
                                    }
                                    throw new f.Z("Self Service Account Unlock is not supported based on your current org configuration.");
                                case 9:
                                    return e1.abrupt("return", (0, u.K)(t, d({}, n)));
                                case 10:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), v.apply(this, arguments);
                }
            },
            5031: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Ax: function() {
                        return P;
                    },
                    KM: function() {
                        return E;
                    },
                    TC: function() {
                        return k;
                    },
                    TR: function() {
                        return R;
                    },
                    Tc: function() {
                        return _;
                    },
                    kw: function() {
                        return S;
                    },
                    l6: function() {
                        return A;
                    },
                    lx: function() {
                        return T;
                    },
                    sH: function() {
                        return w;
                    },
                    xn: function() {
                        return O;
                    }
                });
                var r = n(4942), o = n(4925), i = n(5861), a = n(885), u = n(2982), c = n(4687), s = n.n(c), f = n(8750), l = n(146), p = n(9732), d = n(7595), h = [
                    "href",
                    "method",
                    "rel",
                    "accepts",
                    "produces"
                ];
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function g(e1, t) {
                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e1) || (n = function(e1, t) {
                            if (e1) {
                                if ("string" == typeof e1) return m(e1, t);
                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? m(e1, t) : void 0;
                            }
                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                            n && (e1 = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e1.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e1[r++]
                                    };
                                },
                                e: function(e1) {
                                    throw e1;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, u = !1;
                    return {
                        s: function() {
                            n = n.call(e1);
                        },
                        n: function() {
                            var e1 = n.next();
                            return a = e1.done, e1;
                        },
                        e: function(e1) {
                            u = !0, i = e1;
                        },
                        f: function() {
                            try {
                                a || null == n.return || n.return();
                            } finally{
                                if (u) throw i;
                            }
                        }
                    };
                }
                function m(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var b = {
                    remediators: {},
                    getFlowSpecification: function(e1) {
                        return {
                            remediators: {}
                        };
                    }
                };
                function k(e1) {
                    Object.assign(b, e1);
                }
                function w(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default";
                    return b.getFlowSpecification(e1, t);
                }
                function O(e1) {
                    var t = e1.neededToProceed, n = e1.interactionCode;
                    return !t.length && !n;
                }
                function Z(e1) {
                    if (e1 && Array.isArray(e1)) return e1.reduce(function(e1, t) {
                        if (t.messages && (e1 = [].concat((0, u.Z)(e1), (0, u.Z)(t.messages.value))), t.form) {
                            var n = Z(t.form.value) || [];
                            e1 = [].concat((0, u.Z)(e1), (0, u.Z)(n));
                        }
                        if (t.options) {
                            var r = [];
                            t.options.forEach(function(e1) {
                                e1.value && "string" != typeof e1.value && (r = [].concat((0, u.Z)(r), [
                                    e1.value
                                ]));
                            });
                            var o = Z(r) || [];
                            e1 = [].concat((0, u.Z)(e1), (0, u.Z)(o));
                        }
                        return e1;
                    }, []);
                }
                function T(e1, t) {
                    var n, r = [], o = e1.rawIdxState, i = e1.neededToProceed, a = null === (n = o.messages) || void 0 === n ? void 0 : n.value.map(function(e1) {
                        return e1;
                    });
                    if (a && (r = [].concat((0, u.Z)(r), (0, u.Z)(a))), !t.useGenericRemediator) {
                        var c, s = g(i);
                        try {
                            for(s.s(); !(c = s.n()).done;){
                                var f = Z(c.value.value);
                                f && (r = [].concat((0, u.Z)(r), (0, u.Z)(f)));
                            }
                        } catch (e1) {
                            s.e(e1);
                        } finally{
                            s.f();
                        }
                    }
                    var l = {};
                    return r.reduce(function(e1, t) {
                        var n, r = null === (n = t.i18n) || void 0 === n ? void 0 : n.key;
                        return r && l[r] && t.message === l[r].message ? e1 : (l[r] = t, e1 = [].concat((0, u.Z)(e1), [
                            t
                        ]));
                    }, []);
                }
                function E(e1) {
                    var t = [], n = e1.actions, r = e1.neededToProceed;
                    return n["currentAuthenticator-recover"] && t.push(d.Fw.PASSWORD_RECOVERY), r.some(function(e1) {
                        return "select-enroll-profile" === e1.name;
                    }) && t.push(d.Fw.REGISTRATION), r.some(function(e1) {
                        return "redirect-idp" === e1.name;
                    }) && t.push(d.Fw.SOCIAL_IDP), r.some(function(e1) {
                        return "unlock-account" === e1.name;
                    }) && t.push(d.Fw.ACCOUNT_UNLOCK), t;
                }
                function S(e1, t, n) {
                    var r, u = [], c = Object.values(b.remediators).reduce(function(e1, t) {
                        return t.remediationName && (e1[t.remediationName] = t), e1;
                    }, {}), l = g(t.neededToProceed);
                    try {
                        for(l.s(); !(r = l.n()).done;){
                            var p = r.value, d = x(p, {
                                useGenericRemediator: n,
                                remediators: c
                            });
                            if (d) {
                                var v = new d(p);
                                u.push(v.getNextStep(e1, t.context));
                            }
                        }
                    } catch (e1) {
                        l.e(e1);
                    } finally{
                        l.f();
                    }
                    for(var m = function() {
                        var n, r = (0, a.Z)(w[k], 1)[0], c = {
                            name: r,
                            action: (n = (0, i.Z)(s().mark(function t(n) {
                                return s().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            return t.abrupt("return", e1.idx.proceed({
                                                actions: [
                                                    {
                                                        name: r,
                                                        params: n
                                                    }
                                                ]
                                            }));
                                        case 1:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t);
                            })), function(e1) {
                                return n.apply(this, arguments);
                            })
                        };
                        if (r.startsWith("currentAuthenticator")) {
                            var l, p = (0, f.YQ)(r, "-"), d = (0, a.Z)(p, 2), v = d[0], g = d[1], m = t.rawIdxState[v].value[g], b = (m.href, m.method, m.rel, m.accepts, m.produces, (0, o.Z)(m, h)), O = null === (l = m.value) || void 0 === l ? void 0 : l.filter(function(e1) {
                                return "stateHandle" !== e1.name;
                            });
                            c = y(y(y({}, b), O && {
                                value: O
                            }), c);
                        }
                        u.push(c);
                    }, k = 0, w = Object.entries(t.actions || {}); k < w.length; k++)m();
                    return u;
                }
                function P(e1, t, n) {
                    var r = (e1.neededToProceed || []).find(function(e1) {
                        return e1.name === t;
                    });
                    return r ? r.value.reduce(function(e1, t) {
                        var r = t.name, o = t.value;
                        return e1[r] = "stateHandle" === r ? o : n[r], e1;
                    }, {}) : ((0, l.ZK)('filterValuesForRemediation: "'.concat(t, '" did not match any remediations')), n);
                }
                function x(e1, t) {
                    var n = t.useGenericRemediator, r = t.remediators;
                    if (e1) return n ? p.P : r[e1.name];
                }
                function A(e1, t, n) {
                    var r, o = n.remediators, i = n.useGenericRemediator, a = e1.neededToProceed, u = e1.context;
                    if (!n.step) {
                        var c = [];
                        if (i) c.push(new p.P(a[0], t, n));
                        else {
                            var s, f = g(a);
                            try {
                                for(f.s(); !(s = f.n()).done;){
                                    var d = s.value;
                                    if (Object.keys(o).includes(d.name)) {
                                        if ((r = new (x(d, n))(d, t, n)).canRemediate(u)) return r;
                                        c.push(r);
                                    }
                                }
                            } catch (e1) {
                                f.e(e1);
                            } finally{
                                f.f();
                            }
                        }
                        return c[0];
                    }
                    var h = a.find(function(e1) {
                        return e1.name === n.step;
                    });
                    if (h) {
                        var v = x(h, n);
                        return v ? new v(h, t, n) : void 0;
                    }
                    (0, l.ZK)('step "'.concat(n.step, '" did not match any remediations'));
                }
                function R(e1, t, n) {
                    var r = t.getNextStep(e1, n.context), o = function(e1) {
                        return e1.neededToProceed.some(function(e1) {
                            return "skip" === e1.name;
                        });
                    }(n), i = function(e1) {
                        return Object.keys(e1.actions).some(function(e1) {
                            return e1.includes("resend");
                        });
                    }(n);
                    return y(y(y({}, r), o && {
                        canSkip: o
                    }), i && {
                        canResend: i
                    });
                }
                function _(e1, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = O(t), o = T(t, n);
                    if (r) return {
                        idxResponse: t,
                        terminal: r,
                        messages: o
                    };
                    var i = A(t, {}, n), a = i && R(e1, i, t);
                    return y({
                        idxResponse: t,
                        messages: o
                    }, a && {
                        nextStep: a
                    });
                }
            },
            8716: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    buildCredentialCreationOptions: function() {
                        return i;
                    },
                    buildCredentialRequestOptions: function() {
                        return a;
                    },
                    getAssertion: function() {
                        return c;
                    },
                    getAttestation: function() {
                        return u;
                    }
                });
                var r = n(7987), o = function() {
                    var e1 = [];
                    return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : []).forEach(function(t) {
                        "webauthn" === t.key && e1.push({
                            type: "public-key",
                            id: (0, r.dX)(t.credentialId)
                        });
                    }), e1;
                }, i = function(e1, t) {
                    return {
                        publicKey: {
                            rp: e1.rp,
                            user: {
                                id: (0, r.dX)(e1.user.id),
                                name: e1.user.name,
                                displayName: e1.user.displayName
                            },
                            challenge: (0, r.dX)(e1.challenge),
                            pubKeyCredParams: e1.pubKeyCredParams,
                            attestation: e1.attestation,
                            authenticatorSelection: e1.authenticatorSelection,
                            excludeCredentials: o(t)
                        }
                    };
                }, a = function(e1, t) {
                    return {
                        publicKey: {
                            challenge: (0, r.dX)(e1.challenge),
                            userVerification: e1.userVerification,
                            allowCredentials: o(t)
                        }
                    };
                }, u = function(e1) {
                    var t = e1.response;
                    return {
                        id: e1.id,
                        clientData: (0, r.kQ)(t.clientDataJSON),
                        attestation: (0, r.kQ)(t.attestationObject)
                    };
                }, c = function(e1) {
                    var t = e1.response;
                    return {
                        id: e1.id,
                        clientData: (0, r.kQ)(t.clientDataJSON),
                        authenticatorData: (0, r.kQ)(t.authenticatorData),
                        signatureData: (0, r.kQ)(t.signature)
                    };
                };
            },
            9108: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    addEmail: function() {
                        return B;
                    },
                    addPhone: function() {
                        return z;
                    },
                    deleteEmail: function() {
                        return K;
                    },
                    deletePassword: function() {
                        return oe;
                    },
                    deletePhone: function() {
                        return Q;
                    },
                    enrollPassword: function() {
                        return ne;
                    },
                    getEmail: function() {
                        return H;
                    },
                    getEmailChallenge: function() {
                        return G;
                    },
                    getEmails: function() {
                        return L;
                    },
                    getPassword: function() {
                        return te;
                    },
                    getPhone: function() {
                        return Y;
                    },
                    getPhones: function() {
                        return W;
                    },
                    getProfile: function() {
                        return A;
                    },
                    getProfileSchema: function() {
                        return _;
                    },
                    sendEmailChallenge: function() {
                        return F;
                    },
                    sendPhoneChallenge: function() {
                        return X;
                    },
                    updatePassword: function() {
                        return re;
                    },
                    updateProfile: function() {
                        return R;
                    },
                    verifyEmailChallenge: function() {
                        return V;
                    },
                    verifyPhoneChallenge: function() {
                        return J;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(4942), u = n(1002), c = n(4925), s = n(3144), f = n(5671), l = [
                    "headers"
                ], p = (0, s.Z)(function e1(t, n) {
                    var r = this;
                    (0, f.Z)(this, e1), (0, a.Z)(this, "headers", void 0);
                    var o = n.res, i = o.headers, u = (0, c.Z)(o, l);
                    i && (this.headers = i), Object.keys(u).forEach(function(e1) {
                        "_links" !== e1 && (r[e1] = u[e1]);
                    });
                }), d = n(5385), h = n(9123);
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, a.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function g(e1, t) {
                    return m.apply(this, arguments);
                }
                function m() {
                    return m = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u, c, s, f, l, v, g, m, b, k, w, O, Z, T = arguments;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = T.length > 2 && void 0 !== T[2] ? T[2] : p, o = t.tokenManager.getTokensSync(), a = o.accessToken, u = n.accessToken || a, c = t.getIssuerOrigin(), s = n.url, f = n.method, l = n.payload, v = s.startsWith(c) ? s : "".concat(c).concat(s), u) {
                                        e1.next = 8;
                                        break;
                                    }
                                    throw new h.Z("AccessToken is required to request MyAccount API endpoints.");
                                case 8:
                                    if (g = u, m = y({
                                        headers: {
                                            Accept: "*/*;okta-version=1.0.0"
                                        },
                                        url: v,
                                        method: f
                                    }, l && {
                                        args: l
                                    }), !t.options.dpop) {
                                        e1.next = 22;
                                        break;
                                    }
                                    if ("string" != typeof g) {
                                        e1.next = 13;
                                        break;
                                    }
                                    throw new h.Z("AccessToken object must be provided when using dpop");
                                case 13:
                                    return e1.next = 15, t.getDPoPAuthorizationHeaders({
                                        method: f,
                                        url: v,
                                        accessToken: g
                                    });
                                case 15:
                                    b = e1.sent, k = b.Authorization, w = b.Dpop, m.headers.Authorization = k, m.headers.Dpop = w, e1.next = 24;
                                    break;
                                case 22:
                                    g = "string" == typeof g ? g : g.accessToken, m.accessToken = g;
                                case 24:
                                    return e1.next = 26, (0, d.c3)(t, m);
                                case 26:
                                    return O = e1.sent, Z = Array.isArray(O) ? O.map(function(e1) {
                                        return new r(t, {
                                            res: e1,
                                            accessToken: g
                                        });
                                    }) : new r(t, {
                                        res: O,
                                        accessToken: g
                                    }), e1.abrupt("return", Z);
                                case 29:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), m.apply(this, arguments);
                }
                function b(e1) {
                    for(var t = e1.oktaAuth, n = e1.accessToken, o = e1.methodName, a = e1.links, c = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : p, s = function() {
                        var e1, u = l[f];
                        if (u.toLowerCase() === o) {
                            var s = a.self;
                            return {
                                v: (e1 = (0, r.Z)(i().mark(function e1(r) {
                                    return i().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.abrupt("return", g(t, {
                                                    accessToken: n,
                                                    url: s.href,
                                                    method: u,
                                                    payload: r
                                                }, c));
                                            case 1:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1);
                                })), function(t) {
                                    return e1.apply(this, arguments);
                                })
                            };
                        }
                    }, f = 0, l = [
                        "GET",
                        "POST",
                        "PUT",
                        "DELETE"
                    ]; f < l.length; f++){
                        var d = s();
                        if ("object" === (0, u.Z)(d)) return d.v;
                    }
                    var v, y = a[o];
                    if (!y) throw new h.Z("No link is found with methodName: ".concat(o));
                    return v = (0, r.Z)(i().mark(function e1(r) {
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.abrupt("return", g(t, {
                                        accessToken: n,
                                        url: y.href,
                                        method: y.hints.allow[0],
                                        payload: r
                                    }, c));
                                case 1:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), function(e1) {
                        return v.apply(this, arguments);
                    };
                }
                var k = n(7326), w = n(136), O = n(2963), Z = n(1120);
                var T = function(e1) {
                    (0, w.Z)(o, e1);
                    var t, n, r = (t = o, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function o(e1, t) {
                        var n;
                        (0, f.Z)(this, o), n = r.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "createdAt", void 0), (0, a.Z)((0, k.Z)(n), "modifiedAt", void 0), (0, a.Z)((0, k.Z)(n), "profile", void 0);
                        var i = t.res, u = i.createdAt, c = i.modifiedAt, s = i.profile;
                        return n.createdAt = u, n.modifiedAt = c, n.profile = s, n;
                    }
                    return (0, s.Z)(o);
                }(p);
                var E, S, P, x = function(e1) {
                    (0, w.Z)(o, e1);
                    var t, n, r = (t = o, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function o(e1, t) {
                        var n;
                        return (0, f.Z)(this, o), n = r.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "properties", void 0), n.properties = t.res.properties, n;
                    }
                    return (0, s.Z)(o);
                }(p), A = (E = (0, r.Z)(i().mark(function e1(t, n) {
                    var r;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return e1.next = 2, g(t, {
                                    url: "/idp/myaccount/profile",
                                    method: "GET",
                                    accessToken: null == n ? void 0 : n.accessToken
                                }, T);
                            case 2:
                                return r = e1.sent, e1.abrupt("return", r);
                            case 4:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return E.apply(this, arguments);
                }), R = (S = (0, r.Z)(i().mark(function e1(t, n) {
                    var r, o, a, u;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).payload, a = r.accessToken, e1.next = 3, g(t, {
                                    url: "/idp/myaccount/profile",
                                    method: "PUT",
                                    payload: o,
                                    accessToken: a
                                }, T);
                            case 3:
                                return u = e1.sent, e1.abrupt("return", u);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return S.apply(this, arguments);
                }), _ = (P = (0, r.Z)(i().mark(function e1(t, n) {
                    var r;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return e1.next = 2, g(t, {
                                    url: "/idp/myaccount/profile/schema",
                                    method: "GET",
                                    accessToken: null == n ? void 0 : n.accessToken
                                }, x);
                            case 2:
                                return r = e1.sent, e1.abrupt("return", r);
                            case 4:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return P.apply(this, arguments);
                });
                var j = function(e1) {
                    (0, w.Z)(o, e1);
                    var t, n, r = (t = o, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function o(e1, t) {
                        var n;
                        (0, f.Z)(this, o), n = r.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "id", void 0), (0, a.Z)((0, k.Z)(n), "expiresAt", void 0), (0, a.Z)((0, k.Z)(n), "profile", void 0), (0, a.Z)((0, k.Z)(n), "status", void 0);
                        var i = t.res, u = i.id, c = i.profile, s = i.expiresAt, l = i.status;
                        return n.id = u, n.expiresAt = s, n.profile = c, n.status = l, n;
                    }
                    return (0, s.Z)(o);
                }(p);
                var C = function(e1) {
                    (0, w.Z)(u, e1);
                    var t, n, o = (t = u, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function u(e1, t) {
                        var n;
                        (0, f.Z)(this, u), n = o.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "id", void 0), (0, a.Z)((0, k.Z)(n), "expiresAt", void 0), (0, a.Z)((0, k.Z)(n), "profile", void 0), (0, a.Z)((0, k.Z)(n), "status", void 0), (0, a.Z)((0, k.Z)(n), "poll", void 0), (0, a.Z)((0, k.Z)(n), "verify", void 0);
                        var c = t.accessToken, s = t.res, l = s.id, p = s.expiresAt, d = s.profile, h = s.status, v = s._links;
                        return n.id = l, n.expiresAt = p, n.profile = d, n.status = h, n.poll = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: c,
                                            methodName: "poll",
                                            links: v
                                        }, j), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.verify = function() {
                            var t = (0, r.Z)(i().mark(function t(n) {
                                var r;
                                return i().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            return r = b({
                                                oktaAuth: e1,
                                                accessToken: c,
                                                methodName: "verify",
                                                links: v
                                            }, u), t.next = 3, r(n);
                                        case 3:
                                            return t.abrupt("return", t.sent);
                                        case 4:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t);
                            }));
                            return function(e1) {
                                return t.apply(this, arguments);
                            };
                        }(), n;
                    }
                    return (0, s.Z)(u);
                }(p);
                var I, D, M, N, U = function(e1) {
                    (0, w.Z)(u, e1);
                    var t, n, o = (t = u, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function u(e1, t) {
                        var n;
                        (0, f.Z)(this, u), n = o.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "id", void 0), (0, a.Z)((0, k.Z)(n), "profile", void 0), (0, a.Z)((0, k.Z)(n), "roles", void 0), (0, a.Z)((0, k.Z)(n), "status", void 0), (0, a.Z)((0, k.Z)(n), "get", void 0), (0, a.Z)((0, k.Z)(n), "delete", void 0), (0, a.Z)((0, k.Z)(n), "challenge", void 0), (0, a.Z)((0, k.Z)(n), "poll", void 0), (0, a.Z)((0, k.Z)(n), "verify", void 0);
                        var c, s = t.accessToken, l = t.res, p = l.id, d = l.profile, h = l.roles, v = l.status, y = l._links;
                        return n.id = p, n.profile = d, n.roles = h, n.status = v, n.get = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "get",
                                            links: y
                                        }, u), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.delete = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "delete",
                                            links: y
                                        }), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.challenge = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "challenge",
                                            links: y
                                        }, C), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), y.poll && (n.poll = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "poll",
                                            links: y
                                        }, j), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        }))), y.verify && (n.verify = (c = (0, r.Z)(i().mark(function t(n) {
                            var r;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return r = b({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "verify",
                                            links: y
                                        }), t.next = 3, r(n);
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), function(e1) {
                            return c.apply(this, arguments);
                        })), n;
                    }
                    return (0, s.Z)(u);
                }(p), L = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, g(t, {
                                        url: "/idp/myaccount/emails",
                                        method: "GET",
                                        accessToken: null == n ? void 0 : n.accessToken
                                    }, U);
                                case 2:
                                    return r = e1.sent, e1.abrupt("return", r);
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), H = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).id, a = r.accessToken, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/emails/".concat(o),
                                        method: "GET",
                                        accessToken: a
                                    }, U);
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), B = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, a = r.payload, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/emails",
                                        method: "POST",
                                        payload: a,
                                        accessToken: o
                                    }, U);
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), K = (I = (0, r.Z)(i().mark(function e1(t, n) {
                    var r, o, a, u;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).id, a = r.accessToken, e1.next = 3, g(t, {
                                    url: "/idp/myaccount/emails/".concat(o),
                                    method: "DELETE",
                                    accessToken: a
                                });
                            case 3:
                                return u = e1.sent, e1.abrupt("return", u);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return I.apply(this, arguments);
                }), F = (D = (0, r.Z)(i().mark(function e1(t, n) {
                    var r, o, a, u;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).id, a = r.accessToken, e1.next = 3, g(t, {
                                    url: "/idp/myaccount/emails/".concat(o, "/challenge"),
                                    method: "POST",
                                    accessToken: a
                                }, C);
                            case 3:
                                return u = e1.sent, e1.abrupt("return", u);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return D.apply(this, arguments);
                }), G = (M = (0, r.Z)(i().mark(function e1(t, n) {
                    var r, o, a, u, c;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).emailId, a = r.challengeId, u = r.accessToken, e1.next = 3, g(t, {
                                    url: "/idp/myaccount/emails/".concat(o, "/challenge/").concat(a),
                                    method: "POST",
                                    accessToken: u
                                }, C);
                            case 3:
                                return c = e1.sent, e1.abrupt("return", c);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return M.apply(this, arguments);
                }), V = (N = (0, r.Z)(i().mark(function e1(t, n) {
                    var r, o, a, u, c, s;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).emailId, a = r.challengeId, u = r.payload, c = r.accessToken, e1.next = 3, g(t, {
                                    url: "/idp/myaccount/emails/".concat(o, "/challenge/").concat(a, "/verify"),
                                    method: "POST",
                                    payload: u,
                                    accessToken: c
                                });
                            case 3:
                                return s = e1.sent, e1.abrupt("return", s);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return N.apply(this, arguments);
                });
                var q = function(e1) {
                    (0, w.Z)(u, e1);
                    var t, n, o = (t = u, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function u(e1, t) {
                        var n;
                        (0, f.Z)(this, u), n = o.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "id", void 0), (0, a.Z)((0, k.Z)(n), "profile", void 0), (0, a.Z)((0, k.Z)(n), "status", void 0), (0, a.Z)((0, k.Z)(n), "get", void 0), (0, a.Z)((0, k.Z)(n), "delete", void 0), (0, a.Z)((0, k.Z)(n), "challenge", void 0), (0, a.Z)((0, k.Z)(n), "verify", void 0);
                        var c, s = t.res, l = t.accessToken, p = s.id, d = s.profile, h = s.status, v = s._links;
                        return n.id = p, n.profile = d, n.status = h, n.get = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: l,
                                            methodName: "get",
                                            links: v
                                        }, u), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.delete = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: l,
                                            methodName: "delete",
                                            links: v
                                        }), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.challenge = (c = (0, r.Z)(i().mark(function t(n) {
                            var r;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return r = b({
                                            oktaAuth: e1,
                                            accessToken: l,
                                            methodName: "challenge",
                                            links: v
                                        }), t.next = 3, r(n);
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), function(e1) {
                            return c.apply(this, arguments);
                        }), v.verify && (n.verify = function() {
                            var t = (0, r.Z)(i().mark(function t(n) {
                                var r;
                                return i().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            return r = b({
                                                oktaAuth: e1,
                                                accessToken: l,
                                                methodName: "verify",
                                                links: v
                                            }), t.next = 3, r(n);
                                        case 3:
                                            return t.abrupt("return", t.sent);
                                        case 4:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t);
                            }));
                            return function(e1) {
                                return t.apply(this, arguments);
                            };
                        }()), n;
                    }
                    return (0, s.Z)(u);
                }(p), W = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, g(t, {
                                        url: "/idp/myaccount/phones",
                                        method: "GET",
                                        accessToken: null == n ? void 0 : n.accessToken
                                    }, q);
                                case 2:
                                    return r = e1.sent, e1.abrupt("return", r);
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), Y = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, a = r.id, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/phones/".concat(a),
                                        method: "GET",
                                        accessToken: o
                                    }, q);
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), z = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, a = r.payload, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/phones",
                                        method: "POST",
                                        payload: a,
                                        accessToken: o
                                    }, q);
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), Q = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).id, a = r.accessToken, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/phones/".concat(o),
                                        method: "DELETE",
                                        accessToken: a
                                    });
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), X = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u, c;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, a = r.id, u = r.payload, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/phones/".concat(a, "/challenge"),
                                        method: "POST",
                                        payload: u,
                                        accessToken: o
                                    });
                                case 3:
                                    return c = e1.sent, e1.abrupt("return", c);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), J = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u, c;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).id, a = r.payload, u = r.accessToken, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/phones/".concat(o, "/verify"),
                                        method: "POST",
                                        payload: a,
                                        accessToken: u
                                    });
                                case 3:
                                    return c = e1.sent, e1.abrupt("return", c);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), $ = n(8008);
                var ee = function(e1) {
                    (0, w.Z)(u, e1);
                    var t, n, o = (t = u, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function u(e1, t) {
                        var n;
                        (0, f.Z)(this, u), n = o.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "id", void 0), (0, a.Z)((0, k.Z)(n), "created", void 0), (0, a.Z)((0, k.Z)(n), "lastUpdated", void 0), (0, a.Z)((0, k.Z)(n), "status", void 0), (0, a.Z)((0, k.Z)(n), "get", void 0), (0, a.Z)((0, k.Z)(n), "enroll", void 0), (0, a.Z)((0, k.Z)(n), "update", void 0), (0, a.Z)((0, k.Z)(n), "delete", void 0);
                        var c, s = t.res, l = t.accessToken, p = s.id, d = s.status, h = s.created, v = s.lastUpdated, y = s._links;
                        return n.id = p, n.status = d, n.created = h, n.lastUpdated = v, n.status == $.Fn.NOT_ENROLLED ? n.enroll = function() {
                            var t = (0, r.Z)(i().mark(function t(n) {
                                var r;
                                return i().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            return r = b({
                                                oktaAuth: e1,
                                                accessToken: l,
                                                methodName: "enroll",
                                                links: y
                                            }, u), t.next = 3, r(n);
                                        case 3:
                                            return t.abrupt("return", t.sent);
                                        case 4:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t);
                            }));
                            return function(e1) {
                                return t.apply(this, arguments);
                            };
                        }() : (n.get = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: l,
                                            methodName: "get",
                                            links: y
                                        }, u), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.update = (c = (0, r.Z)(i().mark(function t(n) {
                            var r;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return r = b({
                                            oktaAuth: e1,
                                            accessToken: l,
                                            methodName: "put",
                                            links: y
                                        }, u), t.next = 3, r(n);
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), function(e1) {
                            return c.apply(this, arguments);
                        }), n.delete = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: l,
                                            methodName: "delete",
                                            links: y
                                        }), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        }))), n;
                    }
                    return (0, s.Z)(u);
                }(p), te = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, g(t, {
                                        url: "/idp/myaccount/password",
                                        method: "GET",
                                        accessToken: null == n ? void 0 : n.accessToken
                                    }, ee);
                                case 2:
                                    return r = e1.sent, e1.abrupt("return", r);
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), ne = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, a = r.payload, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/password",
                                        method: "POST",
                                        payload: a,
                                        accessToken: o
                                    }, ee);
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), re = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, a = r.payload, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/password",
                                        method: "PUT",
                                        payload: a,
                                        accessToken: o
                                    }, ee);
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), oe = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, g(t, {
                                        url: "/idp/myaccount/password",
                                        method: "DELETE",
                                        accessToken: null == n ? void 0 : n.accessToken
                                    });
                                case 2:
                                    return r = e1.sent, e1.abrupt("return", r);
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }();
            },
            1132: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    aw: function() {
                        return u.aw;
                    },
                    Fn: function() {
                        return u.Fn;
                    },
                    qb: function() {
                        return u.qb;
                    },
                    no: function() {
                        return r.addEmail;
                    },
                    Z1: function() {
                        return r.addPhone;
                    },
                    Xc: function() {
                        return a;
                    },
                    nd: function() {
                        return r.deleteEmail;
                    },
                    QN: function() {
                        return r.deletePassword;
                    },
                    qj: function() {
                        return r.deletePhone;
                    },
                    xg: function() {
                        return r.enrollPassword;
                    },
                    OD: function() {
                        return r.getEmail;
                    },
                    hG: function() {
                        return r.getEmailChallenge;
                    },
                    G5: function() {
                        return r.getEmails;
                    },
                    Ij: function() {
                        return r.getPassword;
                    },
                    u_: function() {
                        return r.getPhone;
                    },
                    Po: function() {
                        return r.getPhones;
                    },
                    Ai: function() {
                        return r.getProfile;
                    },
                    aF: function() {
                        return r.getProfileSchema;
                    },
                    HT: function() {
                        return i.H;
                    },
                    ME: function() {
                        return r.sendEmailChallenge;
                    },
                    dv: function() {
                        return r.sendPhoneChallenge;
                    },
                    gQ: function() {
                        return r.updatePassword;
                    },
                    ck: function() {
                        return r.updateProfile;
                    },
                    T8: function() {
                        return r.verifyEmailChallenge;
                    },
                    Lo: function() {
                        return r.verifyPhoneChallenge;
                    }
                });
                var r = n(9108), o = n(1578), i = n(6794);
                function a(e1, t, n) {
                    var r = (0, o.K)(e1, t, n);
                    return (0, i.H)(r);
                }
                var u = n(8008);
            },
            6794: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    H: function() {
                        return p;
                    }
                });
                var r = n(885), o = n(3144), i = n(5671), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(9108);
                function p(e1) {
                    return function(e1) {
                        (0, u.Z)(d, e1);
                        var t, n, p = (t = d, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, s.Z)(t);
                            if (n) {
                                var o = (0, s.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, c.Z)(this, e1);
                        });
                        function d() {
                            var e1;
                            (0, i.Z)(this, d);
                            for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                            return e1 = p.call.apply(p, [
                                this
                            ].concat(n)), (0, f.Z)((0, a.Z)(e1), "myaccount", void 0), e1.myaccount = Object.entries(l).filter(function(e1) {
                                return "default" !== (0, r.Z)(e1, 1)[0];
                            }).reduce(function(t, n) {
                                var o = (0, r.Z)(n, 2), i = o[0], u = o[1];
                                return t[i] = u.bind(null, (0, a.Z)(e1)), t;
                            }, {}), e1;
                        }
                        return (0, o.Z)(d);
                    }(e1);
                }
            },
            8008: function(e1, t, n) {
                "use strict";
                var r, o, i;
                n.d(t, {
                    Fn: function() {
                        return i;
                    },
                    aw: function() {
                        return r;
                    },
                    qb: function() {
                        return o;
                    }
                }), function(e1) {
                    e1.PRIMARY = "PRIMARY", e1.SECONDARY = "SECONDARY";
                }(r || (r = {})), function(e1) {
                    e1.VERIFIED = "VERIFIED", e1.UNVERIFIED = "UNVERIFIED";
                }(o || (o = {})), function(e1) {
                    e1.NOT_ENROLLED = "NOT_ENROLLED", e1.ACTIVE = "ACTIVE";
                }(i || (i = {}));
            },
            2427: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    M: function() {
                        return w;
                    }
                });
                var r = n(5861), o = n(1002), i = n(5671), a = n(3144), u = n(4942), c = n(4687), s = n.n(c), f = n(3193), l = n(9123), p = n(2482), d = n(415), h = function() {
                    function e1(t) {
                        (0, i.Z)(this, e1), (0, u.Z)(this, "localOffset", void 0), this.localOffset = parseInt(t || 0);
                    }
                    return (0, a.Z)(e1, [
                        {
                            key: "now",
                            value: function() {
                                return (Date.now() + this.localOffset) / 1e3;
                            }
                        }
                    ], [
                        {
                            key: "create",
                            value: function() {
                                return new e1(0);
                            }
                        }
                    ]), e1;
                }(), v = n(7088), y = n(6488), g = n(1971);
                function m(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function b(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? m(Object(n), !0).forEach(function(t) {
                            (0, u.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var k = {
                    autoRenew: !0,
                    autoRemove: !0,
                    syncStorage: !0,
                    clearPendingRemoveTokens: !0,
                    storage: void 0,
                    expireEarlySeconds: 30,
                    storageKey: g.TOKEN_STORAGE_NAME
                }, w = function() {
                    function e1(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        if ((0, i.Z)(this, e1), (0, u.Z)(this, "sdk", void 0), (0, u.Z)(this, "clock", void 0), (0, u.Z)(this, "emitter", void 0), (0, u.Z)(this, "storage", void 0), (0, u.Z)(this, "state", void 0), (0, u.Z)(this, "options", void 0), this.sdk = t, this.emitter = t.emitter, !this.emitter) throw new l.Z("Emitter should be initialized before TokenManager");
                        n = Object.assign({}, k, (0, f.YY)(n)), (0, d.isLocalhost)() || (n.expireEarlySeconds = k.expireEarlySeconds), this.options = n;
                        var r = (0, f.YY)({
                            storageKey: n.storageKey,
                            secure: n.secure
                        });
                        "object" === (0, o.Z)(n.storage) ? r.storageProvider = n.storage : n.storage && (r.storageType = n.storage), this.storage = t.storageManager.getTokenStorage(b(b({}, r), {}, {
                            useSeparateCookies: !0
                        })), this.clock = h.create(), this.state = {
                            expireTimeouts: {},
                            renewPromise: null
                        };
                    }
                    var t, n, c;
                    return (0, a.Z)(e1, [
                        {
                            key: "on",
                            value: function(e1, t, n) {
                                n ? this.emitter.on(e1, t, n) : this.emitter.on(e1, t);
                            }
                        },
                        {
                            key: "off",
                            value: function(e1, t) {
                                t ? this.emitter.off(e1, t) : this.emitter.off(e1);
                            }
                        },
                        {
                            key: "start",
                            value: function() {
                                this.options.clearPendingRemoveTokens && this.clearPendingRemoveTokens(), this.setExpireEventTimeoutAll(), this.state.started = !0;
                            }
                        },
                        {
                            key: "stop",
                            value: function() {
                                this.clearExpireEventTimeoutAll(), this.state.started = !1;
                            }
                        },
                        {
                            key: "isStarted",
                            value: function() {
                                return !!this.state.started;
                            }
                        },
                        {
                            key: "getOptions",
                            value: function() {
                                return (0, f.d9)(this.options);
                            }
                        },
                        {
                            key: "getExpireTime",
                            value: function(e1) {
                                var t = this.options.expireEarlySeconds || 0;
                                return e1.expiresAt - t;
                            }
                        },
                        {
                            key: "hasExpired",
                            value: function(e1) {
                                return this.getExpireTime(e1) <= this.clock.now();
                            }
                        },
                        {
                            key: "emitExpired",
                            value: function(e1, t) {
                                this.emitter.emit(v.$Y, e1, t);
                            }
                        },
                        {
                            key: "emitRenewed",
                            value: function(e1, t, n) {
                                this.emitter.emit(v.E, e1, t, n);
                            }
                        },
                        {
                            key: "emitAdded",
                            value: function(e1, t) {
                                this.emitter.emit(v.O3, e1, t);
                            }
                        },
                        {
                            key: "emitRemoved",
                            value: function(e1, t) {
                                this.emitter.emit(v.FT, e1, t);
                            }
                        },
                        {
                            key: "emitError",
                            value: function(e1) {
                                this.emitter.emit(v.$I, e1);
                            }
                        },
                        {
                            key: "clearExpireEventTimeout",
                            value: function(e1) {
                                clearTimeout(this.state.expireTimeouts[e1]), delete this.state.expireTimeouts[e1], this.state.renewPromise = null;
                            }
                        },
                        {
                            key: "clearExpireEventTimeoutAll",
                            value: function() {
                                var e1 = this.state.expireTimeouts;
                                for(var t in e1)Object.prototype.hasOwnProperty.call(e1, t) && this.clearExpireEventTimeout(t);
                            }
                        },
                        {
                            key: "setExpireEventTimeout",
                            value: function(e1, t) {
                                var n = this;
                                if (!(0, y.z9)(t)) {
                                    var r = this.getExpireTime(t), o = 1e3 * Math.max(r - this.clock.now(), 0);
                                    this.clearExpireEventTimeout(e1);
                                    var i = setTimeout(function() {
                                        n.emitExpired(e1, t);
                                    }, o);
                                    this.state.expireTimeouts[e1] = i;
                                }
                            }
                        },
                        {
                            key: "setExpireEventTimeoutAll",
                            value: function() {
                                var e1 = this.storage.getStorage();
                                for(var t in e1)if (Object.prototype.hasOwnProperty.call(e1, t)) {
                                    var n = e1[t];
                                    this.setExpireEventTimeout(t, n);
                                }
                            }
                        },
                        {
                            key: "resetExpireEventTimeoutAll",
                            value: function() {
                                this.clearExpireEventTimeoutAll(), this.setExpireEventTimeoutAll();
                            }
                        },
                        {
                            key: "add",
                            value: function(e1, t) {
                                var n = this.storage.getStorage();
                                (0, p.R)(t), n[e1] = t, this.storage.setStorage(n), this.emitSetStorageEvent(), this.emitAdded(e1, t), this.setExpireEventTimeout(e1, t);
                            }
                        },
                        {
                            key: "getSync",
                            value: function(e1) {
                                return this.storage.getStorage()[e1];
                            }
                        },
                        {
                            key: "get",
                            value: (c = (0, r.Z)(s().mark(function e1(t) {
                                return s().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.abrupt("return", this.getSync(t));
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function(e1) {
                                return c.apply(this, arguments);
                            })
                        },
                        {
                            key: "getTokensSync",
                            value: function() {
                                var e1 = {}, t = this.storage.getStorage();
                                return Object.keys(t).forEach(function(n) {
                                    var r = t[n];
                                    (0, y.hv)(r) ? e1.accessToken = r : (0, y.sI)(r) ? e1.idToken = r : (0, y.z9)(r) && (e1.refreshToken = r);
                                }), e1;
                            }
                        },
                        {
                            key: "getTokens",
                            value: (n = (0, r.Z)(s().mark(function e1() {
                                return s().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.abrupt("return", this.getTokensSync());
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "getStorageKeyByType",
                            value: function(e1) {
                                var t = this.storage.getStorage();
                                return Object.keys(t).filter(function(n) {
                                    var r = t[n];
                                    return (0, y.hv)(r) && "accessToken" === e1 || (0, y.sI)(r) && "idToken" === e1 || (0, y.z9)(r) && "refreshToken" === e1;
                                })[0];
                            }
                        },
                        {
                            key: "getTokenType",
                            value: function(e1) {
                                if ((0, y.hv)(e1)) return "accessToken";
                                if ((0, y.sI)(e1)) return "idToken";
                                if ((0, y.z9)(e1)) return "refreshToken";
                                throw new l.Z("Unknown token type");
                            }
                        },
                        {
                            key: "emitSetStorageEvent",
                            value: function() {
                                if ((0, d.isIE11OrLess)()) {
                                    var e1 = this.storage.getStorage();
                                    this.emitter.emit(v.zr, e1);
                                }
                            }
                        },
                        {
                            key: "getStorage",
                            value: function() {
                                return this.storage;
                            }
                        },
                        {
                            key: "setTokens",
                            value: function(e1, t, n, r) {
                                var o = this, i = function(e1, i) {
                                    var a = o.getTokenType(i);
                                    "accessToken" === a ? t && t(e1, i) : "idToken" === a ? n && n(e1, i) : "refreshToken" === a && r && r(e1, i);
                                }, a = function(e1, t) {
                                    o.emitAdded(e1, t), o.setExpireEventTimeout(e1, t), i(e1, t);
                                }, u = function(e1, t) {
                                    o.clearExpireEventTimeout(e1), o.emitRemoved(e1, t), i(e1, t);
                                }, c = [
                                    "idToken",
                                    "accessToken",
                                    "refreshToken"
                                ], s = this.getTokensSync();
                                c.forEach(function(t) {
                                    var n = e1[t];
                                    n && (0, p.R)(n, t);
                                });
                                var f = c.reduce(function(t, n) {
                                    var r = e1[n];
                                    return r && (t[o.getStorageKeyByType(n) || n] = r), t;
                                }, {});
                                this.storage.setStorage(f), this.emitSetStorageEvent(), c.forEach(function(t) {
                                    var n, r, c, f = e1[t], l = s[t], p = o.getStorageKeyByType(t) || t;
                                    f && l ? (u(p, l), a(p, f), n = p, r = f, c = l, o.emitRenewed(n, r, c), o.clearExpireEventTimeout(n), o.setExpireEventTimeout(n, r), i(n, r)) : f ? a(p, f) : l && u(p, l);
                                });
                            }
                        },
                        {
                            key: "remove",
                            value: function(e1) {
                                this.clearExpireEventTimeout(e1);
                                var t = this.storage.getStorage(), n = t[e1];
                                delete t[e1], this.storage.setStorage(t), this.emitSetStorageEvent(), this.emitRemoved(e1, n);
                            }
                        },
                        {
                            key: "renewToken",
                            value: (t = (0, r.Z)(s().mark(function e1(t) {
                                var n;
                                return s().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.abrupt("return", null === (n = this.sdk.token) || void 0 === n ? void 0 : n.renew(t));
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function(e1) {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "validateToken",
                            value: function(e1) {
                                return (0, p.R)(e1);
                            }
                        },
                        {
                            key: "renew",
                            value: function(e1) {
                                var t = this;
                                if (this.state.renewPromise) return this.state.renewPromise;
                                try {
                                    var n = this.getSync(e1), r = void 0 !== n;
                                    if (!n && "accessToken" === e1) {
                                        var o = this.getStorageKeyByType("refreshToken");
                                        r = void 0 !== this.getSync(o);
                                    }
                                    if (!r) throw new l.Z("The tokenManager has no token for the key: " + e1);
                                } catch (e1) {
                                    return this.emitError(e1), Promise.reject(e1);
                                }
                                return this.clearExpireEventTimeout(e1), this.state.renewPromise = this.sdk.token.renewTokens().then(function(r) {
                                    if (t.setTokens(r), !n && "accessToken" === e1) {
                                        var o = r.accessToken;
                                        return t.emitRenewed(e1, o, null), o;
                                    }
                                    return r[t.getTokenType(n)];
                                }).catch(function(n) {
                                    throw t.remove(e1), n.tokenKey = e1, t.emitError(n), n;
                                }).finally(function() {
                                    t.state.renewPromise = null;
                                });
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                var e1 = this, t = this.getTokensSync();
                                this.clearExpireEventTimeoutAll(), this.storage.clearStorage(), this.emitSetStorageEvent(), Object.keys(t).forEach(function(n) {
                                    e1.emitRemoved(n, t[n]);
                                });
                            }
                        },
                        {
                            key: "clearPendingRemoveTokens",
                            value: function() {
                                var e1 = this, t = this.storage.getStorage(), n = {};
                                Object.keys(t).forEach(function(e1) {
                                    t[e1].pendingRemove && (n[e1] = t[e1], delete t[e1]);
                                }), this.storage.setStorage(t), this.emitSetStorageEvent(), Object.keys(n).forEach(function(t) {
                                    e1.clearExpireEventTimeout(t), e1.emitRemoved(t, n[t]);
                                });
                            }
                        },
                        {
                            key: "updateRefreshToken",
                            value: function(e1) {
                                var t = this.getStorageKeyByType("refreshToken") || g.REFRESH_TOKEN_STORAGE_KEY, n = this.storage.getStorage();
                                (0, p.R)(e1), n[t] = e1, this.storage.setStorage(n), this.emitSetStorageEvent();
                            }
                        },
                        {
                            key: "removeRefreshToken",
                            value: function() {
                                var e1 = this.getStorageKeyByType("refreshToken") || g.REFRESH_TOKEN_STORAGE_KEY;
                                this.remove(e1);
                            }
                        },
                        {
                            key: "addPendingRemoveFlags",
                            value: function() {
                                var e1 = this.getTokensSync();
                                Object.keys(e1).forEach(function(t) {
                                    e1[t].pendingRemove = !0;
                                }), this.setTokens(e1);
                            }
                        }
                    ]), e1;
                }();
            },
            1646: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    P: function() {
                        return s;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(4319), u = n(146), c = 18e5;
                function s() {
                    return function() {
                        function e1(t) {
                            (0, r.Z)(this, e1), (0, i.Z)(this, "options", void 0), (0, i.Z)(this, "storageManager", void 0), (0, i.Z)(this, "enableSharedStorage", void 0), (0, i.Z)(this, "saveLastResponse", void 0), this.storageManager = t.storageManager, this.enableSharedStorage = !1 !== t.enableSharedStorage, this.saveLastResponse = !1 !== t.saveLastResponse, this.options = t;
                        }
                        return (0, o.Z)(e1, [
                            {
                                key: "clear",
                                value: function() {
                                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = this.storageManager.getTransactionStorage(), n = t.getStorage();
                                    if (t.clearStorage(), this.enableSharedStorage && !1 !== e1.clearSharedStorage) {
                                        var r = e1.state || (null == n ? void 0 : n.state);
                                        r && function(e1, t) {
                                            var n = e1.getSharedTansactionStorage(), r = n.getStorage();
                                            delete r[t], n.setStorage(r);
                                        }(this.storageManager, r);
                                    }
                                }
                            },
                            {
                                key: "save",
                                value: function(e1) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = this.storageManager.getTransactionStorage(), r = n.getStorage();
                                    (0, a.mH)(r) && !t.muteWarning && (0, u.ZK)("a saved auth transaction exists in storage. This may indicate another auth flow is already in progress."), n.setStorage(e1), this.enableSharedStorage && e1.state && function(e1, t, n) {
                                        var r = e1.getSharedTansactionStorage(), o = r.getStorage();
                                        o[t] = {
                                            dateCreated: Date.now(),
                                            transaction: n
                                        }, r.setStorage(o);
                                    }(this.storageManager, e1.state, e1);
                                }
                            },
                            {
                                key: "exists",
                                value: function() {
                                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    try {
                                        return !!this.load(e1);
                                    } catch (e1) {
                                        return !1;
                                    }
                                }
                            },
                            {
                                key: "load",
                                value: function() {
                                    var e1, t, n, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    return this.enableSharedStorage && r.state && (t = this.storageManager.getSharedTansactionStorage(), n = t.getStorage(), Object.keys(n).forEach(function(e1) {
                                        var t = n[e1];
                                        Date.now() - t.dateCreated > c && delete n[e1];
                                    }), t.setStorage(n), e1 = function(e1, t) {
                                        var n = e1.getSharedTansactionStorage().getStorage()[t];
                                        return n && n.transaction && (0, a.mH)(n.transaction) ? n.transaction : null;
                                    }(this.storageManager, r.state), (0, a.mH)(e1)) ? e1 : (e1 = this.storageManager.getTransactionStorage().getStorage(), (0, a.mH)(e1) ? e1 : null);
                                }
                            }
                        ]), e1;
                    }();
                }
            },
            1237: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    T: function() {
                        return i;
                    }
                });
                var r = n(9123), o = n(7987);
                function i(e1) {
                    var t, n = e1.split(".");
                    try {
                        t = {
                            header: JSON.parse((0, o.Wy)(n[0])),
                            payload: JSON.parse((0, o.Wy)(n[1])),
                            signature: n[2]
                        };
                    } catch (e1) {
                        throw new r.Z("Malformed token");
                    }
                    return t;
                }
            },
            7659: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    SO: function() {
                        return d;
                    },
                    V7: function() {
                        return A;
                    },
                    aW: function() {
                        return D;
                    },
                    ao: function() {
                        return C;
                    },
                    cE: function() {
                        return N;
                    },
                    lk: function() {
                        return E;
                    },
                    sd: function() {
                        return P;
                    },
                    vX: function() {
                        return _;
                    }
                });
                var r = n(2982), o = n(5861), i = n(4687), a = n.n(i), u = n(7987), c = n(7594), s = n(5728), f = n(9123), l = "OktaAuthJs", p = "DPoPKeys";
                function d(e1) {
                    return ((0, s.isOAuthError)(e1) || (0, s.isWWWAuthError)(e1)) && "use_dpop_nonce" === e1.errorCode;
                }
                function h(e1, t, n) {
                    return v.apply(this, arguments);
                }
                function v() {
                    return (v = (0, o.Z)(a().mark(function e1(t, n, r) {
                        var o, i, s;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (0, u.NL)(JSON.stringify(t)), i = (0, u.NL)(JSON.stringify(n)), e1.next = 4, c.KP.subtle.sign({
                                        name: r.algorithm.name
                                    }, r, (0, u.k8)("".concat(o, ".").concat(i)));
                                case 4:
                                    return s = e1.sent, e1.abrupt("return", "".concat(o, ".").concat(i, ".").concat((0, u.aR)((0, u.kQ)(s))));
                                case 6:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function y() {
                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 32;
                    return (0, r.Z)(c.KP.getRandomValues(new Uint8Array(e1))).map(function(e1) {
                        return e1.toString(16);
                    }).join("");
                }
                function g() {
                    return m.apply(this, arguments);
                }
                function m() {
                    return (m = (0, o.Z)(a().mark(function e1() {
                        var t;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return t = {
                                        name: "RSASSA-PKCS1-v1_5",
                                        hash: "SHA-256",
                                        modulusLength: 2048,
                                        publicExponent: new Uint8Array([
                                            1,
                                            0,
                                            1
                                        ])
                                    }, e1.abrupt("return", c.KP.subtle.generateKey(t, !1, [
                                        "sign",
                                        "verify"
                                    ]));
                                case 2:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function b(e1) {
                    return k.apply(this, arguments);
                }
                function k() {
                    return (k = (0, o.Z)(a().mark(function e1(t) {
                        var n, r;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = (new TextEncoder).encode(t), e1.next = 3, c.KP.subtle.digest("SHA-256", n);
                                case 3:
                                    return r = e1.sent, e1.abrupt("return", (0, c.r3)(String.fromCharCode.apply(null, new Uint8Array(r))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, ""));
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function w(e1) {
                    return O.apply(this, arguments);
                }
                function O() {
                    return O = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, u = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    for(n = u.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)r[o - 1] = u[o];
                                    return e1.next = 3, new Promise(function(e1, t) {
                                        try {
                                            var n = window.indexedDB.open(l, 1);
                                            n.onerror = function() {
                                                t(n.error);
                                            }, n.onupgradeneeded = function() {
                                                n.result.createObjectStore(p);
                                            }, n.onsuccess = function() {
                                                var r = n.result, o = r.transaction(p, "readwrite");
                                                o.onerror = function() {
                                                    t(o.error);
                                                };
                                                var i = o.objectStore(p);
                                                e1(i), o.oncomplete = function() {
                                                    r.close();
                                                };
                                            };
                                        } catch (e1) {
                                            t(e1);
                                        }
                                    });
                                case 3:
                                    return i = e1.sent, e1.abrupt("return", new Promise(function(e1, n) {
                                        var o = i[t].apply(i, r);
                                        o.onsuccess = function() {
                                            e1(o);
                                        }, o.onerror = function() {
                                            n(o.error);
                                        };
                                    }));
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), O.apply(this, arguments);
                }
                function Z(e1, t) {
                    return T.apply(this, arguments);
                }
                function T() {
                    return (T = (0, o.Z)(a().mark(function e1(t, n) {
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, w("add", n, t);
                                case 2:
                                    return e1.abrupt("return", n);
                                case 3:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function E(e1) {
                    return S.apply(this, arguments);
                }
                function S() {
                    return (S = (0, o.Z)(a().mark(function e1(t) {
                        var n;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (!t) {
                                        e1.next = 6;
                                        break;
                                    }
                                    return e1.next = 3, w("get", t);
                                case 3:
                                    if (!(n = e1.sent).result) {
                                        e1.next = 6;
                                        break;
                                    }
                                    return e1.abrupt("return", n.result);
                                case 6:
                                    throw new f.Z("Unable to locate dpop key pair required for refresh".concat(t ? " (".concat(t, ")") : ""));
                                case 7:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function P(e1) {
                    return x.apply(this, arguments);
                }
                function x() {
                    return (x = (0, o.Z)(a().mark(function e1(t) {
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, w("delete", t);
                                case 2:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function A() {
                    return R.apply(this, arguments);
                }
                function R() {
                    return (R = (0, o.Z)(a().mark(function e1() {
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, w("clear");
                                case 2:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function _() {
                    return j.apply(this, arguments);
                }
                function j() {
                    return (j = (0, o.Z)(a().mark(function e1() {
                        var t, n;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return t = y(4), e1.next = 3, g();
                                case 3:
                                    return n = e1.sent, e1.next = 6, Z(t, n);
                                case 6:
                                    return e1.abrupt("return", {
                                        keyPair: n,
                                        keyPairId: t
                                    });
                                case 7:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function C(e1, t) {
                    return I.apply(this, arguments);
                }
                function I() {
                    return (I = (0, o.Z)(a().mark(function e1(t, n) {
                        var r, o, i, u, c;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (o = !1, i = n.accessToken, u = n.refreshToken, "access" === t && i && "DPoP" === i.tokenType && !u && (o = !0), "refresh" === t && u && !i && (o = !0), c = null !== (r = null == i ? void 0 : i.dpopPairId) && void 0 !== r ? r : null == u ? void 0 : u.dpopPairId, !o || !c) {
                                        e1.next = 8;
                                        break;
                                    }
                                    return e1.next = 8, P(c);
                                case 8:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function D(e1) {
                    return M.apply(this, arguments);
                }
                function M() {
                    return (M = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, u, s, f, l, p, d, v, g, m, k;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = t.keyPair, r = t.url, o = t.method, i = t.nonce, u = t.accessToken, e1.next = 3, c.KP.subtle.exportKey("jwk", n.publicKey);
                                case 3:
                                    if (s = e1.sent, f = s.kty, l = s.crv, p = s.e, d = s.n, v = s.x, g = s.y, m = {
                                        alg: "RS256",
                                        typ: "dpop+jwt",
                                        jwk: {
                                            kty: f,
                                            crv: l,
                                            e: p,
                                            n: d,
                                            x: v,
                                            y: g
                                        }
                                    }, k = {
                                        htm: o,
                                        htu: r,
                                        iat: Math.floor(Date.now() / 1e3),
                                        jti: y()
                                    }, i && (k.nonce = i), !u) {
                                        e1.next = 17;
                                        break;
                                    }
                                    return e1.next = 16, b(u);
                                case 16:
                                    k.ath = e1.sent;
                                case 17:
                                    return e1.abrupt("return", h(m, k, n.privateKey));
                                case 18:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function N(e1) {
                    return U.apply(this, arguments);
                }
                function U() {
                    return (U = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, u;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = t.keyPair, r = t.url, o = t.method, i = t.nonce, u = {
                                        keyPair: n,
                                        url: r,
                                        method: o
                                    }, i && (u.nonce = i), e1.abrupt("return", D(u));
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            2206: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    R: function() {
                        return l;
                    },
                    _: function() {
                        return f;
                    }
                });
                var r = n(4942), o = n(4771), i = n(3193), a = n(6718), u = n(9123);
                function c(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function s(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? c(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function f(e1) {
                    if (!e1.clientId) throw new u.Z("A clientId must be specified in the OktaAuth constructor to get a token");
                    if ((0, o.HD)(e1.responseType) && -1 !== e1.responseType.indexOf(" ")) throw new u.Z("Multiple OAuth responseTypes must be defined as an array");
                    var t = {
                        client_id: e1.clientId,
                        code_challenge: e1.codeChallenge,
                        code_challenge_method: e1.codeChallengeMethod,
                        display: e1.display,
                        idp: e1.idp,
                        idp_scope: e1.idpScope,
                        login_hint: e1.loginHint,
                        max_age: e1.maxAge,
                        nonce: e1.nonce,
                        prompt: e1.prompt,
                        redirect_uri: e1.redirectUri,
                        response_mode: e1.responseMode,
                        response_type: e1.responseType,
                        sessionToken: e1.sessionToken,
                        state: e1.state,
                        acr_values: e1.acrValues,
                        enroll_amr_values: e1.enrollAmrValues
                    };
                    if (t = (0, i.YY)(t), [
                        "idp_scope",
                        "response_type",
                        "enroll_amr_values"
                    ].forEach(function(e1) {
                        Array.isArray(t[e1]) && (t[e1] = t[e1].join(" "));
                    }), -1 !== e1.responseType.indexOf("id_token") && -1 === e1.scopes.indexOf("openid")) throw new u.Z("openid scope must be specified in the scopes argument when requesting an id_token");
                    return e1.scopes && (t.scope = e1.scopes.join(" ")), t;
                }
                function l(e1) {
                    var t = f(e1);
                    return (0, a.UK)(s(s({}, t), e1.extraParams && s({}, e1.extraParams)));
                }
            },
            2642: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Dp: function() {
                        return o.D;
                    },
                    ES: function() {
                        return i.E;
                    },
                    R0: function() {
                        return r.R;
                    },
                    _6: function() {
                        return r._;
                    },
                    km: function() {
                        return i.k;
                    },
                    ti: function() {
                        return o.t;
                    }
                });
                var r = n(2206), o = n(9231), i = n(52);
            },
            9231: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    D: function() {
                        return b;
                    },
                    t: function() {
                        return g;
                    }
                });
                var r = n(885), o = n(5861), i = n(4687), a = n.n(i), u = n(9123), c = n(3983), s = n(3193), f = n(6718), l = n(5385), p = n(7659);
                function d(e1) {
                    if (!e1.clientId) throw new u.Z("A clientId must be specified in the OktaAuth constructor to get a token");
                    if (!e1.redirectUri) throw new u.Z("The redirectUri passed to /authorize must also be passed to /token");
                    if (!e1.authorizationCode && !e1.interactionCode) throw new u.Z("An authorization code (returned from /authorize) must be passed to /token");
                    if (!e1.codeVerifier) throw new u.Z('The "codeVerifier" (generated and saved by your app) must be passed to /token');
                }
                function h(e1, t) {
                    var n = (0, s.YY)({
                        client_id: t.clientId,
                        redirect_uri: t.redirectUri,
                        grant_type: t.interactionCode ? "interaction_code" : "authorization_code",
                        code_verifier: t.codeVerifier
                    });
                    t.interactionCode ? n.interaction_code = t.interactionCode : t.authorizationCode && (n.code = t.authorizationCode);
                    var r = e1.options.clientSecret;
                    return r && (n.client_secret = r), (0, f.UK)(n).slice(1);
                }
                function v(e1, t) {
                    return y.apply(this, arguments);
                }
                function y() {
                    return (y = (0, o.Z)(a().mark(function e1(t, n) {
                        var r, o, i, s, f, d, h, y, g, m, b;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = n.url, o = n.data, i = n.nonce, s = n.dpopKeyPair, f = "POST", d = {
                                        "Content-Type": "application/x-www-form-urlencoded"
                                    }, !t.options.dpop) {
                                        e1.next = 10;
                                        break;
                                    }
                                    if (s) {
                                        e1.next = 6;
                                        break;
                                    }
                                    throw new u.Z("DPoP is configured but no key pair was provided");
                                case 6:
                                    return e1.next = 8, (0, p.cE)({
                                        url: r,
                                        method: f,
                                        nonce: i,
                                        keyPair: s
                                    });
                                case 8:
                                    h = e1.sent, d.DPoP = h;
                                case 10:
                                    return e1.prev = 10, e1.next = 13, (0, l.c3)(t, {
                                        url: r,
                                        method: f,
                                        args: o,
                                        headers: d
                                    });
                                case 13:
                                    return y = e1.sent, e1.abrupt("return", y);
                                case 17:
                                    if (e1.prev = 17, e1.t0 = e1.catch(10), !(0, p.SO)(e1.t0) || i) {
                                        e1.next = 24;
                                        break;
                                    }
                                    if (m = null === (g = e1.t0.resp) || void 0 === g ? void 0 : g.headers["dpop-nonce"]) {
                                        e1.next = 23;
                                        break;
                                    }
                                    throw new c.Z({
                                        errorSummary: "No `dpop-nonce` header found when required"
                                    }, null !== (b = e1.t0.resp) && void 0 !== b ? b : void 0);
                                case 23:
                                    return e1.abrupt("return", v(t, {
                                        url: r,
                                        data: o,
                                        dpopKeyPair: s,
                                        nonce: m
                                    }));
                                case 24:
                                    throw e1.t0;
                                case 25:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                10,
                                17
                            ]
                        ]);
                    }))).apply(this, arguments);
                }
                function g(e1, t, n) {
                    return m.apply(this, arguments);
                }
                function m() {
                    return (m = (0, o.Z)(a().mark(function e1(t, n, r) {
                        var o, i;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return d(n), o = h(t, n), i = {
                                        url: r.tokenUrl,
                                        data: o,
                                        dpopKeyPair: null == n ? void 0 : n.dpopKeyPair
                                    }, e1.abrupt("return", v(t, i));
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function b(e1, t, n) {
                    return k.apply(this, arguments);
                }
                function k() {
                    return (k = (0, o.Z)(a().mark(function e1(t, n, o) {
                        var i, u, c;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return i = Object.entries({
                                        client_id: n.clientId,
                                        grant_type: "refresh_token",
                                        scope: o.scopes.join(" "),
                                        refresh_token: o.refreshToken
                                    }).map(function(e1) {
                                        var t = (0, r.Z)(e1, 2), n = t[0], o = t[1];
                                        return n + "=" + encodeURIComponent(o);
                                    }).join("&"), u = o.tokenUrl, n.extraParams && Object.keys(n.extraParams).length >= 1 && (u += (0, f.UK)(n.extraParams)), c = {
                                        url: u,
                                        data: i,
                                        dpopKeyPair: null == n ? void 0 : n.dpopKeyPair
                                    }, e1.abrupt("return", v(t, c));
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            52: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    E: function() {
                        return a;
                    },
                    k: function() {
                        return u;
                    }
                });
                var r = n(5385), o = n(3193), i = n(9123);
                function a(e1, t) {
                    var n = t || e1.options.issuer;
                    return (0, r.U2)(e1, n + "/.well-known/openid-configuration", {
                        cacheResponse: !0
                    });
                }
                function u(e1, t, n) {
                    var u = e1.storageManager.getHttpCache(e1.options.cookies);
                    return a(e1, t).then(function(t) {
                        var a = t.jwks_uri, c = u.getStorage()[a];
                        if (c && Date.now() / 1e3 < c.expiresAt) {
                            var s = (0, o.sE)(c.response.keys, {
                                kid: n
                            });
                            if (s) return s;
                        }
                        return u.clearStorage(a), (0, r.U2)(e1, a, {
                            cacheResponse: !0
                        }).then(function(e1) {
                            var t = (0, o.sE)(e1.keys, {
                                kid: n
                            });
                            if (t) return t;
                            throw new i.Z("The key id, " + n + ", was not found in the server's keys");
                        });
                    });
                }
            },
            8707: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    r: function() {
                        return p;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(7599), u = n(7756), c = n(3193), s = n(9231), f = n(8676), l = n(7659);
                function p(e1, t, n) {
                    return d.apply(this, arguments);
                }
                function d() {
                    return (d = (0, r.Z)(i().mark(function e1(t, n, r) {
                        var o, p, d, h, v, y, g, m, b, k, w, O, Z, T, E, S, P, x, A, R, _, j;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = r || (0, a.Fc)(t, n), n = Object.assign({}, (0, u.D)(t), (0, c.d9)(n)), p = (o = n).authorizationCode, d = o.interactionCode, h = o.codeVerifier, v = o.clientId, y = o.redirectUri, g = o.scopes, m = o.ignoreSignature, b = o.state, k = o.acrValues, w = o.dpop, O = o.dpopPairId, Z = o.extraParams, T = {
                                        clientId: v,
                                        redirectUri: y,
                                        authorizationCode: p,
                                        interactionCode: d,
                                        codeVerifier: h,
                                        dpop: w
                                    }, E = [
                                        "token"
                                    ], -1 !== g.indexOf("openid") && E.push("id_token"), S = {
                                        clientId: v,
                                        redirectUri: y,
                                        scopes: g,
                                        responseType: E,
                                        ignoreSignature: m,
                                        acrValues: k,
                                        extraParams: Z
                                    }, e1.prev = 7, !w) {
                                        e1.next = 26;
                                        break;
                                    }
                                    if (!O) {
                                        e1.next = 18;
                                        break;
                                    }
                                    return e1.next = 12, (0, l.lk)(O);
                                case 12:
                                    P = e1.sent, T.dpopKeyPair = P, S.dpop = w, S.dpopPairId = O, e1.next = 26;
                                    break;
                                case 18:
                                    return e1.next = 20, (0, l.vX)();
                                case 20:
                                    x = e1.sent, A = x.keyPair, R = x.keyPairId, T.dpopKeyPair = A, S.dpop = w, S.dpopPairId = R;
                                case 26:
                                    return e1.next = 28, (0, s.t)(t, T, r);
                                case 28:
                                    return _ = e1.sent, e1.next = 31, (0, f.s)(t, S, _, r);
                                case 31:
                                    return (j = e1.sent).code = p, j.state = b, e1.abrupt("return", j);
                                case 35:
                                    return e1.prev = 35, t.transactionManager.clear(), e1.finish(35);
                                case 38:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                7,
                                ,
                                35,
                                38
                            ]
                        ]);
                    }))).apply(this, arguments);
                }
            },
            5324: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $: function() {
                        return E;
                    },
                    o: function() {
                        return T;
                    }
                });
                var r = n(3548), o = n(1237), i = n(8707), a = n(6844), u = n(7625), c = n(9770), s = n(6803), f = n(5372), l = n(2476), p = n(6268), d = n(781), h = n(6466), v = n(8113), y = n(6898), g = n(8221), m = n(1260), b = n(3193), k = n(6757), w = n(8080), O = n(2206);
                function Z(e1, t) {
                    t = (0, b.d9)(t) || {};
                    var n = (0, k.U)(e1, t), r = (0, w.A)(e1, n), o = r.urls.authorizeUrl + (0, O.R)(n);
                    e1.transactionManager.save(r), e1.options.setLocation ? e1.options.setLocation(o) : window.location.assign(o);
                }
                function T(e1, t) {
                    var n = function(e1) {
                        return r.b.prototype.push.bind(t, e1, null);
                    }, b = n(s.H.bind(null, e1)), k = n(f.ko.bind(null, e1)), w = Object.assign(k, {
                        _getHistory: function() {
                            return window.history;
                        },
                        _getLocation: function() {
                            return window.location;
                        },
                        _getDocument: function() {
                            return window.document;
                        }
                    }), O = {
                        prepareTokenParams: y.wu.bind(null, e1),
                        exchangeCodeForTokens: i.r.bind(null, e1),
                        getWithoutPrompt: u.y.bind(null, e1),
                        getWithPopup: c.d.bind(null, e1),
                        getWithRedirect: b,
                        parseFromUrl: w,
                        decode: o.T,
                        revoke: h.P.bind(null, e1),
                        renew: l.$.bind(null, e1),
                        renewTokensWithRefresh: d.R.bind(null, e1),
                        renewTokens: p.I.bind(null, e1),
                        getUserInfo: function(t, n) {
                            return (0, a.b)(e1, t, n);
                        },
                        verify: m.W.bind(null, e1),
                        isLoginRedirect: g.gM.bind(null, e1),
                        introspect: v.j.bind(null, e1)
                    };
                    return [
                        "getWithoutPrompt",
                        "getWithPopup",
                        "revoke",
                        "renew",
                        "renewTokensWithRefresh",
                        "renewTokens"
                    ].forEach(function(e1) {
                        O[e1] = n(O[e1]);
                    }), O;
                }
                function E(e1) {
                    return {
                        authorize: {
                            enrollAuthenticator: Z.bind(null, e1)
                        }
                    };
                }
            },
            231: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $V: function() {
                        return r.$;
                    },
                    zr: function() {
                        return s;
                    },
                    o5: function() {
                        return r.o;
                    }
                });
                var r = n(5324), o = n(9893), i = n(265), a = n(3980), u = n(279), c = n(2724);
                function s(e1, t, n) {
                    var r = (0, o.a)(t), s = (0, i.H)(r, e1), f = (0, u.A)(s), l = (0, a.Z)(f);
                    return (0, c.J)(l, n);
                }
            },
            3253: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    L: function() {
                        return s;
                    }
                });
                var r = n(7599), o = n(4970), i = n(9123), a = n(6898), u = n(2206), c = n(8676);
                function s(e1, t) {
                    if (arguments.length > 2) return Promise.reject(new i.Z('As of version 3.0, "getToken" takes only a single set of options'));
                    var n = (t = t || {}).popupWindow;
                    return t.popupWindow = void 0, (0, a.wu)(e1, t).then(function(a) {
                        var s, f;
                        switch(t.sessionToken ? Object.assign(a, {
                            prompt: "none",
                            responseMode: "okta_post_message",
                            display: null
                        }) : t.idp && Object.assign(a, {
                            display: "popup"
                        }), f = (0, r.Fc)(e1, a), s = (t.codeVerifier ? f.tokenUrl : f.authorizeUrl) + (0, u.R)(a), a.sessionToken || null === a.display ? "IFRAME" : "popup" === a.display ? "POPUP" : "IMPLICIT"){
                            case "IFRAME":
                                var l = (0, o.iC)(e1, t.timeout, a.state), p = (0, o.Rl)(s);
                                return l.then(function(t) {
                                    return (0, c.s)(e1, a, t, f);
                                }).finally(function() {
                                    var e1;
                                    document.body.contains(p) && (null === (e1 = p.parentElement) || void 0 === e1 || e1.removeChild(p));
                                });
                            case "POPUP":
                                var d;
                                if ("okta_post_message" === a.responseMode) {
                                    if (!e1.features.isPopupPostMessageSupported()) throw new i.Z("This browser doesn't have full postMessage support");
                                    d = (0, o.iC)(e1, t.timeout, a.state);
                                }
                                return n && n.location.assign(s), new Promise(function(e1, t) {
                                    var r = setInterval(function() {
                                        n && !n.closed || (clearInterval(r), t(new i.Z("Unable to parse OAuth flow response")));
                                    }, 100);
                                    d.then(function(t) {
                                        clearInterval(r), e1(t);
                                    }).catch(function(e1) {
                                        clearInterval(r), t(e1);
                                    });
                                }).then(function(t) {
                                    return (0, c.s)(e1, a, t, f);
                                }).finally(function() {
                                    n && !n.closed && n.close();
                                });
                            default:
                                throw new i.Z("The full page redirect flow is not supported");
                        }
                    });
                }
            },
            6844: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    b: function() {
                        return v;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(9123), c = n(3114), s = n(2886), f = n(3983), l = n(5385), p = n(6488);
                function d(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function h(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? d(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function v(e1, t, n) {
                    return y.apply(this, arguments);
                }
                function y() {
                    return (y = (0, o.Z)(a().mark(function e1(t, n, r) {
                        var o, i;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n) {
                                        e1.next = 4;
                                        break;
                                    }
                                    return e1.next = 3, t.tokenManager.getTokens();
                                case 3:
                                    n = e1.sent.accessToken;
                                case 4:
                                    if (r) {
                                        e1.next = 8;
                                        break;
                                    }
                                    return e1.next = 7, t.tokenManager.getTokens();
                                case 7:
                                    r = e1.sent.idToken;
                                case 8:
                                    if (n && (0, p.hv)(n)) {
                                        e1.next = 10;
                                        break;
                                    }
                                    return e1.abrupt("return", Promise.reject(new u.Z("getUserInfo requires an access token object")));
                                case 10:
                                    if (r && (0, p.sI)(r)) {
                                        e1.next = 12;
                                        break;
                                    }
                                    return e1.abrupt("return", Promise.reject(new u.Z("getUserInfo requires an ID token object")));
                                case 12:
                                    if (o = {
                                        url: n.userinfoUrl,
                                        method: "GET",
                                        accessToken: n.accessToken
                                    }, !t.options.dpop) {
                                        e1.next = 19;
                                        break;
                                    }
                                    return e1.next = 16, t.getDPoPAuthorizationHeaders(h(h({}, o), {}, {
                                        accessToken: n
                                    }));
                                case 16:
                                    i = e1.sent, o.headers = i, delete o.accessToken;
                                case 19:
                                    return e1.abrupt("return", (0, l.c3)(t, o).then(function(e1) {
                                        return e1.sub === r.claims.sub ? e1 : Promise.reject(new u.Z("getUserInfo request was rejected due to token mismatch"));
                                    }).catch(function(e1) {
                                        if (e1 instanceof c.Z && !t.options.dpop) {
                                            var n = e1.error, r = e1.errorDescription;
                                            throw new s.Z(n, r);
                                        }
                                        if (!t.options.dpop) {
                                            var o, i = e1;
                                            if (e1 instanceof f.Z && null != e1 && null !== (o = e1.meta) && void 0 !== o && o.wwwAuthHeader && (i = c.Z.parseHeader(e1.meta.wwwAuthHeader)), i instanceof c.Z) {
                                                var a = i, u = a.error, l = a.errorDescription;
                                                throw new s.Z(u, l);
                                            }
                                        }
                                        throw e1;
                                    }));
                                case 20:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            9770: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    d: function() {
                        return u;
                    }
                });
                var r = n(9123), o = n(3193), i = n(3253), a = n(4970);
                function u(e1, t) {
                    if (arguments.length > 2) return Promise.reject(new r.Z('As of version 3.0, "getWithPopup" takes only a single set of options'));
                    var n = (0, a.pU)("/", t);
                    return t = (0, o.d9)(t) || {}, Object.assign(t, {
                        display: "popup",
                        responseMode: "okta_post_message",
                        popupWindow: n
                    }), (0, i.L)(e1, t);
                }
            },
            6803: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    H: function() {
                        return l;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(3193), c = n(6898), s = n(2865), f = n(2206);
                function l(e1, t) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return p = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, l, p = arguments;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (!(p.length > 2)) {
                                        e1.next = 2;
                                        break;
                                    }
                                    return e1.abrupt("return", Promise.reject(new a.Z('As of version 3.0, "getWithRedirect" takes only a single set of options')));
                                case 2:
                                    return n = (0, u.d9)(n) || {}, e1.next = 5, (0, c.wu)(t, n);
                                case 5:
                                    r = e1.sent, o = (0, s.H)(t, r), l = o.urls.authorizeUrl + (0, f.R)(r), t.transactionManager.save(o), t.options.setLocation ? t.options.setLocation(l) : window.location.assign(l);
                                case 10:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), p.apply(this, arguments);
                }
            },
            7625: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    y: function() {
                        return a;
                    }
                });
                var r = n(9123), o = n(3193), i = n(3253);
                function a(e1, t) {
                    return arguments.length > 2 ? Promise.reject(new r.Z('As of version 3.0, "getWithoutPrompt" takes only a single set of options')) : (t = (0, o.d9)(t) || {}, Object.assign(t, {
                        prompt: "none",
                        responseMode: "okta_post_message",
                        display: null
                    }), (0, i.L)(e1, t));
                }
            },
            8676: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    s: function() {
                        return d;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(3193), u = n(7599), c = n(2886), s = n(9123), f = n(1260), l = n(7756);
                function p(e1, t) {
                    if (e1.error && e1.error_description) throw new c.Z(e1.error, e1.error_description);
                    if (e1.state !== t.state) throw new s.Z("OAuth flow response state doesn't match request state");
                    if (t.dpop && "DPoP" !== e1.token_type) throw new s.Z('Unable to parse OAuth flow response: DPoP was configured but "token_type" was not DPoP');
                }
                function d(e1, t, n, r) {
                    return h.apply(this, arguments);
                }
                function h() {
                    return (h = (0, r.Z)(i().mark(function e1(t, n, r, o) {
                        var c, d, h, v, y, g, m, b, k, w, O, Z, T, E;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (!1 === t.options.pkce || !r.code && !r.interaction_code) {
                                        e1.next = 3;
                                        break;
                                    }
                                    return e1.abrupt("return", t.token.exchangeCodeForTokens(Object.assign({}, n, {
                                        authorizationCode: r.code,
                                        interactionCode: r.interaction_code
                                    }), o));
                                case 3:
                                    if (n = n || (0, l.D)(t), o = o || (0, u.Fc)(t, n), c = n.responseType || [], Array.isArray(c) || "none" === c || (c = [
                                        c
                                    ]), d = r.scope ? r.scope.split(" ") : (0, a.d9)(n.scopes), h = n.clientId || t.options.clientId, p(r, n), v = {}, y = r.expires_in, g = r.token_type, m = r.access_token, b = r.id_token, k = r.refresh_token, w = Math.floor(Date.now() / 1e3), m && (O = t.token.decode(m), v.accessToken = {
                                        accessToken: m,
                                        claims: O.payload,
                                        expiresAt: Number(y) + w,
                                        tokenType: g,
                                        scopes: d,
                                        authorizeUrl: o.authorizeUrl,
                                        userinfoUrl: o.userinfoUrl
                                    }, n.dpopPairId && (v.accessToken.dpopPairId = n.dpopPairId), n.extraParams && (v.accessToken.extraParams = n.extraParams)), k && (v.refreshToken = {
                                        refreshToken: k,
                                        expiresAt: Number(y) + w,
                                        scopes: d,
                                        tokenUrl: o.tokenUrl,
                                        authorizeUrl: o.authorizeUrl,
                                        issuer: o.issuer
                                    }, n.dpopPairId && (v.refreshToken.dpopPairId = n.dpopPairId), n.extraParams && (v.refreshToken.extraParams = n.extraParams)), !b) {
                                        e1.next = 28;
                                        break;
                                    }
                                    return Z = t.token.decode(b), T = {
                                        idToken: b,
                                        claims: Z.payload,
                                        expiresAt: Z.payload.exp - Z.payload.iat + w,
                                        scopes: d,
                                        authorizeUrl: o.authorizeUrl,
                                        issuer: o.issuer,
                                        clientId: h
                                    }, n.extraParams && (T.extraParams = n.extraParams), E = {
                                        clientId: h,
                                        issuer: o.issuer,
                                        nonce: n.nonce,
                                        accessToken: m,
                                        acrValues: n.acrValues
                                    }, void 0 !== n.ignoreSignature && (E.ignoreSignature = n.ignoreSignature), e1.next = 27, (0, f.W)(t, T, E);
                                case 27:
                                    v.idToken = T;
                                case 28:
                                    if (-1 === c.indexOf("token") || v.accessToken) {
                                        e1.next = 30;
                                        break;
                                    }
                                    throw new s.Z('Unable to parse OAuth flow response: response type "token" was requested but "access_token" was not returned.');
                                case 30:
                                    if (-1 === c.indexOf("id_token") || v.idToken) {
                                        e1.next = 32;
                                        break;
                                    }
                                    throw new s.Z('Unable to parse OAuth flow response: response type "id_token" was requested but "id_token" was not returned.');
                                case 32:
                                    return e1.abrupt("return", {
                                        tokens: v,
                                        state: r.state,
                                        code: r.code,
                                        responseType: c
                                    });
                                case 33:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            9443: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    TokenManager: function() {
                        return l.M;
                    },
                    addListener: function() {
                        return d.NH;
                    },
                    addPostMessageListener: function() {
                        return d.iC;
                    },
                    assertPKCESupport: function() {
                        return d.vz;
                    },
                    buildAuthorizeParams: function() {
                        return a.R0;
                    },
                    convertTokenParamsToOAuthParams: function() {
                        return a._6;
                    },
                    createEndpoints: function() {
                        return r.$V;
                    },
                    createEnrollAuthenticatorMeta: function() {
                        return d.AW;
                    },
                    createOAuthMeta: function() {
                        return d.H;
                    },
                    createOAuthOptionsConstructor: function() {
                        return u.m;
                    },
                    createOAuthStorageManager: function() {
                        return i.a;
                    },
                    createOktaAuthOAuth: function() {
                        return r.zr;
                    },
                    createTokenAPI: function() {
                        return r.o5;
                    },
                    createTransactionManager: function() {
                        return p.P;
                    },
                    decodeToken: function() {
                        return h.T;
                    },
                    exchangeCodeForTokens: function() {
                        return O.r;
                    },
                    generateNonce: function() {
                        return d.PY;
                    },
                    generateState: function() {
                        return d.aV;
                    },
                    getDefaultEnrollAuthenticatorParams: function() {
                        return d.cE;
                    },
                    getDefaultTokenParams: function() {
                        return d.Dx;
                    },
                    getHashOrSearch: function() {
                        return d.O2;
                    },
                    getKey: function() {
                        return a.km;
                    },
                    getOAuthBaseUrl: function() {
                        return d.zf;
                    },
                    getOAuthDomain: function() {
                        return d.Xp;
                    },
                    getOAuthUrls: function() {
                        return d.Fc;
                    },
                    getToken: function() {
                        return Z.L;
                    },
                    getUserInfo: function() {
                        return k.b;
                    },
                    getWellKnown: function() {
                        return a.ES;
                    },
                    getWithPopup: function() {
                        return E.d;
                    },
                    getWithRedirect: function() {
                        return S.H;
                    },
                    getWithoutPrompt: function() {
                        return T.y;
                    },
                    handleOAuthResponse: function() {
                        return w.s;
                    },
                    hasAuthorizationCode: function() {
                        return d.ZP;
                    },
                    hasErrorInUrl: function() {
                        return d.hg;
                    },
                    hasInteractionCode: function() {
                        return d.d_;
                    },
                    hasResponseType: function() {
                        return d.wV;
                    },
                    hasTokensInHash: function() {
                        return d.kU;
                    },
                    isAuthorizationCodeError: function() {
                        return d.tC;
                    },
                    isCodeFlow: function() {
                        return d.Ik;
                    },
                    isInteractionRequired: function() {
                        return d.wc;
                    },
                    isInteractionRequiredError: function() {
                        return d.Cf;
                    },
                    isLoginRedirect: function() {
                        return d.gM;
                    },
                    isRedirectUri: function() {
                        return d.Qs;
                    },
                    isRefreshTokenError: function() {
                        return d.Yo;
                    },
                    isRefreshTokenInvalidError: function() {
                        return d.$E;
                    },
                    isSameRefreshToken: function() {
                        return d.q0;
                    },
                    loadFrame: function() {
                        return d.Rl;
                    },
                    loadPopup: function() {
                        return d.pU;
                    },
                    mixinOAuth: function() {
                        return o.J;
                    },
                    oidcIntrospect: function() {
                        return x.j;
                    },
                    parseFromUrl: function() {
                        return P.ko;
                    },
                    pkce: function() {
                        return d.U5;
                    },
                    postRefreshToken: function() {
                        return a.Dp;
                    },
                    postToTokenEndpoint: function() {
                        return a.ti;
                    },
                    prepareEnrollAuthenticatorParams: function() {
                        return d.Uc;
                    },
                    preparePKCE: function() {
                        return d.mi;
                    },
                    prepareTokenParams: function() {
                        return d.wu;
                    },
                    removeListener: function() {
                        return d.ys;
                    },
                    renewToken: function() {
                        return y.$;
                    },
                    renewTokens: function() {
                        return m.I;
                    },
                    renewTokensWithRefresh: function() {
                        return g.R;
                    },
                    revokeToken: function() {
                        return v.P;
                    },
                    urlParamsToObject: function() {
                        return d.vL;
                    },
                    validateClaims: function() {
                        return d.pj;
                    },
                    validateCodeChallengeMethod: function() {
                        return d.br;
                    },
                    validateToken: function() {
                        return d.Rp;
                    },
                    verifyToken: function() {
                        return b.W;
                    }
                });
                var r = n(231), o = n(2724), i = n(2333), a = n(2642), u = n(3775), c = n(8927), s = {};
                for(var f in c)[
                    "default",
                    "decodeToken",
                    "revokeToken",
                    "renewToken",
                    "renewTokensWithRefresh",
                    "renewTokens",
                    "verifyToken",
                    "getUserInfo",
                    "handleOAuthResponse",
                    "exchangeCodeForTokens",
                    "getToken",
                    "getWithoutPrompt",
                    "getWithPopup",
                    "getWithRedirect",
                    "parseFromUrl",
                    "oidcIntrospect",
                    "createEndpoints",
                    "createOktaAuthOAuth",
                    "createTokenAPI",
                    "mixinOAuth",
                    "createOAuthStorageManager",
                    "buildAuthorizeParams",
                    "convertTokenParamsToOAuthParams",
                    "getKey",
                    "getWellKnown",
                    "postRefreshToken",
                    "postToTokenEndpoint",
                    "createOAuthOptionsConstructor"
                ].indexOf(f) < 0 && (s[f] = (function(e1) {
                    return c[e1];
                }).bind(0, f));
                n.d(t, s);
                var l = n(2427), p = n(1646), d = n(8785), h = n(1237), v = n(6466), y = n(2476), g = n(781), m = n(6268), b = n(1260), k = n(6844), w = n(8676), O = n(8707), Z = n(3253), T = n(7625), E = n(9770), S = n(6803), P = n(5372), x = n(8113);
            },
            8113: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    j: function() {
                        return d;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(52), c = n(5385), s = n(6718), f = n(7594), l = n(6488), p = {
                    accessToken: "access_token",
                    idToken: "id_token",
                    refreshToken: "refresh_token"
                };
                function d(e1, t, n) {
                    return h.apply(this, arguments);
                }
                function h() {
                    return (h = (0, r.Z)(i().mark(function e1(t, n, r) {
                        var o, d, h, v, y, g, m, b, k, w;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (d = t.options.clientId, h = t.options.clientSecret, r || (r = t.tokenManager.getTokens()[n]), r) {
                                        e1.next = 5;
                                        break;
                                    }
                                    throw new a.Z("unable to find ".concat(n, " in storage or fn params"));
                                case 5:
                                    if (o = (o = n !== l.T6.ACCESS ? null === (v = r) || void 0 === v ? void 0 : v.issuer : null === (y = r) || void 0 === y || null === (g = y.claims) || void 0 === g ? void 0 : g.iss) || t.options.issuer, d) {
                                        e1.next = 9;
                                        break;
                                    }
                                    throw new a.Z("A clientId must be specified in the OktaAuth constructor to introspect a token");
                                case 9:
                                    if (o) {
                                        e1.next = 11;
                                        break;
                                    }
                                    throw new a.Z("Unable to find issuer");
                                case 11:
                                    return e1.next = 13, (0, u.E)(t, o);
                                case 13:
                                    return m = e1.sent, b = m.introspection_endpoint, k = h ? (0, f.r3)("".concat(d, ":").concat(h)) : (0, f.r3)(d), w = (0, s.UK)({
                                        token_type_hint: p[n],
                                        token: r[n]
                                    }).slice(1), e1.abrupt("return", (0, c.v_)(t, b, w, {
                                        headers: {
                                            "Content-Type": "application/x-www-form-urlencoded",
                                            Authorization: "Basic " + k
                                        }
                                    }));
                                case 18:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            2724: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    J: function() {
                        return j;
                    }
                });
                var r = n(4925), o = n(5861), i = n(5671), a = n(3144), u = n(7326), c = n(1752), s = n(136), f = n(2963), l = n(1120), p = n(4942), d = n(4687), h = n.n(d), v = n(5385), y = n(3548), g = n(4771), m = n(9718), b = n(3611), k = n(5324), w = n(2427), O = n(8221), Z = n(7599), T = n(7659), E = n(9123), S = n(3114), P = n(1971), x = n(4858);
                var A = [
                    "originalUri"
                ];
                function R(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function _(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? R(Object(n), !0).forEach(function(t) {
                            (0, p.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : R(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function j(e1, t) {
                    var n, d = function(e1) {
                        (0, s.Z)(o, e1);
                        var t, n, r = (t = o, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, l.Z)(t);
                            if (n) {
                                var o = (0, l.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, f.Z)(this, e1);
                        });
                        function o() {
                            return (0, i.Z)(this, o), r.apply(this, arguments);
                        }
                        return (0, a.Z)(o, [
                            {
                                key: "setOriginalUri",
                                value: function(e1, t) {
                                    x.Z.getSessionStorage().setItem(P.REFERRER_PATH_STORAGE_KEY, e1), (t = t || this.options.state) && this.storageManager.getOriginalUriStorage().setItem(t, e1);
                                }
                            },
                            {
                                key: "getOriginalUri",
                                value: function(e1) {
                                    if (e1 = e1 || this.options.state) {
                                        var t = this.storageManager.getOriginalUriStorage().getItem(e1);
                                        if (t) return t;
                                    }
                                    var n = x.Z.getSessionStorage();
                                    return n && n.getItem(P.REFERRER_PATH_STORAGE_KEY) || void 0;
                                }
                            },
                            {
                                key: "removeOriginalUri",
                                value: function(e1) {
                                    if (x.Z.getSessionStorage().removeItem(P.REFERRER_PATH_STORAGE_KEY), e1 = e1 || this.options.state) {
                                        var t = this.storageManager.getOriginalUriStorage();
                                        t.removeItem && t.removeItem(e1);
                                    }
                                }
                            }
                        ]), o;
                    }(e1);
                    return n = function(e1) {
                        (0, s.Z)(H, e1);
                        var n, d, m, P, x, R, j, C, I, D, M, N, U, L = (N = H, U = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, t = (0, l.Z)(N);
                            if (U) {
                                var n = (0, l.Z)(this).constructor;
                                e1 = Reflect.construct(t, arguments, n);
                            } else e1 = t.apply(this, arguments);
                            return (0, f.Z)(this, e1);
                        });
                        function H() {
                            var e1;
                            (0, i.Z)(this, H);
                            for(var n = arguments.length, r = new Array(n), o = 0; o < n; o++)r[o] = arguments[o];
                            return e1 = L.call.apply(L, [
                                this
                            ].concat(r)), (0, p.Z)((0, u.Z)(e1), "token", void 0), (0, p.Z)((0, u.Z)(e1), "tokenManager", void 0), (0, p.Z)((0, u.Z)(e1), "transactionManager", void 0), (0, p.Z)((0, u.Z)(e1), "pkce", void 0), (0, p.Z)((0, u.Z)(e1), "endpoints", void 0), (0, p.Z)((0, u.Z)(e1), "_pending", void 0), (0, p.Z)((0, u.Z)(e1), "_tokenQueue", void 0), e1.transactionManager = new t(Object.assign({
                                storageManager: e1.storageManager
                            }, e1.options.transactionManager)), e1.pkce = {
                                DEFAULT_CODE_CHALLENGE_METHOD: b.Z.DEFAULT_CODE_CHALLENGE_METHOD,
                                generateVerifier: b.Z.generateVerifier,
                                computeChallenge: b.Z.computeChallenge
                            }, e1._pending = {
                                handleLogin: !1
                            }, e1._tokenQueue = new y.b, e1.token = (0, k.o)((0, u.Z)(e1), e1._tokenQueue), e1.tokenManager = new w.M((0, u.Z)(e1), e1.options.tokenManager), e1.endpoints = (0, k.$)((0, u.Z)(e1)), e1;
                        }
                        return (0, a.Z)(H, [
                            {
                                key: "clearStorage",
                                value: function() {
                                    (0, c.Z)((0, l.Z)(H.prototype), "clearStorage", this).call(this), this.tokenManager.clear();
                                }
                            },
                            {
                                key: "isAuthenticated",
                                value: (M = (0, o.Z)(h().mark(function e1() {
                                    var t, n, r, o, i, a, u, c, s, f, l = arguments;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t = l.length > 0 && void 0 !== l[0] ? l[0] : {}, n = this.tokenManager.getOptions(), r = n.autoRenew, o = n.autoRemove, i = t.onExpiredToken ? "renew" === t.onExpiredToken : r, a = t.onExpiredToken ? "remove" === t.onExpiredToken : o, u = this.tokenManager.getTokensSync(), !(c = u.accessToken) || !this.tokenManager.hasExpired(c)) {
                                                    e1.next = 19;
                                                    break;
                                                }
                                                if (c = void 0, !i) {
                                                    e1.next = 18;
                                                    break;
                                                }
                                                return e1.prev = 8, e1.next = 11, this.tokenManager.renew("accessToken");
                                            case 11:
                                                c = e1.sent, e1.next = 16;
                                                break;
                                            case 14:
                                                e1.prev = 14, e1.t0 = e1.catch(8);
                                            case 16:
                                                e1.next = 19;
                                                break;
                                            case 18:
                                                a && this.tokenManager.remove("accessToken");
                                            case 19:
                                                if (s = this.tokenManager.getTokensSync(), !(f = s.idToken) || !this.tokenManager.hasExpired(f)) {
                                                    e1.next = 34;
                                                    break;
                                                }
                                                if (f = void 0, !i) {
                                                    e1.next = 33;
                                                    break;
                                                }
                                                return e1.prev = 23, e1.next = 26, this.tokenManager.renew("idToken");
                                            case 26:
                                                f = e1.sent, e1.next = 31;
                                                break;
                                            case 29:
                                                e1.prev = 29, e1.t1 = e1.catch(23);
                                            case 31:
                                                e1.next = 34;
                                                break;
                                            case 33:
                                                a && this.tokenManager.remove("idToken");
                                            case 34:
                                                return e1.abrupt("return", !(!c || !f));
                                            case 35:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this, [
                                        [
                                            8,
                                            14
                                        ],
                                        [
                                            23,
                                            29
                                        ]
                                    ]);
                                })), function() {
                                    return M.apply(this, arguments);
                                })
                            },
                            {
                                key: "signInWithRedirect",
                                value: (D = (0, o.Z)(h().mark(function e1() {
                                    var t, n, o, i, a = arguments;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (n = (t = a.length > 0 && void 0 !== a[0] ? a[0] : {}).originalUri, o = (0, r.Z)(t, A), !this._pending.handleLogin) {
                                                    e1.next = 4;
                                                    break;
                                                }
                                                return e1.abrupt("return");
                                            case 4:
                                                return this._pending.handleLogin = !0, e1.prev = 5, n && this.setOriginalUri(n), i = Object.assign({
                                                    scopes: this.options.scopes || [
                                                        "openid",
                                                        "email",
                                                        "profile"
                                                    ]
                                                }, o), e1.next = 10, this.token.getWithRedirect(i);
                                            case 10:
                                                return e1.prev = 10, this._pending.handleLogin = !1, e1.finish(10);
                                            case 13:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this, [
                                        [
                                            5,
                                            ,
                                            10,
                                            13
                                        ]
                                    ]);
                                })), function() {
                                    return D.apply(this, arguments);
                                })
                            },
                            {
                                key: "getUser",
                                value: (I = (0, o.Z)(h().mark(function e1() {
                                    var t, n, r;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return t = this.tokenManager.getTokensSync(), n = t.idToken, r = t.accessToken, e1.abrupt("return", this.token.getUserInfo(r, n));
                                            case 2:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function() {
                                    return I.apply(this, arguments);
                                })
                            },
                            {
                                key: "getIdToken",
                                value: function() {
                                    var e1 = this.tokenManager.getTokensSync().idToken;
                                    return e1 ? e1.idToken : void 0;
                                }
                            },
                            {
                                key: "getAccessToken",
                                value: function() {
                                    var e1 = this.tokenManager.getTokensSync().accessToken;
                                    return e1 ? e1.accessToken : void 0;
                                }
                            },
                            {
                                key: "getRefreshToken",
                                value: function() {
                                    var e1 = this.tokenManager.getTokensSync().refreshToken;
                                    return e1 ? e1.refreshToken : void 0;
                                }
                            },
                            {
                                key: "getOrRenewAccessToken",
                                value: (C = (0, o.Z)(h().mark(function e1() {
                                    var t, n, r, o, i;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t = this.tokenManager.getTokensSync(), !(n = t.accessToken) || this.tokenManager.hasExpired(n)) {
                                                    e1.next = 3;
                                                    break;
                                                }
                                                return e1.abrupt("return", n.accessToken);
                                            case 3:
                                                return e1.prev = 3, o = this.tokenManager.getStorageKeyByType("accessToken"), e1.next = 7, this.tokenManager.renew(null != o ? o : "accessToken");
                                            case 7:
                                                return i = e1.sent, e1.abrupt("return", null !== (r = null == i ? void 0 : i.accessToken) && void 0 !== r ? r : null);
                                            case 11:
                                                return e1.prev = 11, e1.t0 = e1.catch(3), this.emitter.emit("error", e1.t0), e1.abrupt("return", null);
                                            case 15:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this, [
                                        [
                                            3,
                                            11
                                        ]
                                    ]);
                                })), function() {
                                    return C.apply(this, arguments);
                                })
                            },
                            {
                                key: "storeTokensFromRedirect",
                                value: (j = (0, o.Z)(h().mark(function e1() {
                                    var t, n;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.next = 2, this.token.parseFromUrl();
                                            case 2:
                                                t = e1.sent, n = t.tokens, "none" !== t.responseType && this.tokenManager.setTokens(n);
                                            case 6:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function() {
                                    return j.apply(this, arguments);
                                })
                            },
                            {
                                key: "isLoginRedirect",
                                value: function() {
                                    return (0, O.gM)(this);
                                }
                            },
                            {
                                key: "isPKCE",
                                value: function() {
                                    return !!this.options.pkce;
                                }
                            },
                            {
                                key: "hasResponseType",
                                value: function(e1) {
                                    return (0, O.wV)(e1, this.options);
                                }
                            },
                            {
                                key: "isAuthorizationCodeFlow",
                                value: function() {
                                    return this.hasResponseType("code");
                                }
                            },
                            {
                                key: "invokeApiMethod",
                                value: (R = (0, o.Z)(h().mark(function e1(t) {
                                    var n;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t.accessToken) {
                                                    e1.next = 5;
                                                    break;
                                                }
                                                return e1.next = 3, this.tokenManager.getTokens();
                                            case 3:
                                                n = e1.sent.accessToken, t.accessToken = null == n ? void 0 : n.accessToken;
                                            case 5:
                                                return e1.abrupt("return", (0, v.c3)(this, t));
                                            case 6:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return R.apply(this, arguments);
                                })
                            },
                            {
                                key: "revokeAccessToken",
                                value: (x = (0, o.Z)(h().mark(function e1(t) {
                                    var n, r;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t) {
                                                    e1.next = 10;
                                                    break;
                                                }
                                                return e1.next = 3, this.tokenManager.getTokens();
                                            case 3:
                                                if (n = e1.sent, t = n.accessToken, r = this.tokenManager.getStorageKeyByType("accessToken"), this.tokenManager.remove(r), !this.options.dpop) {
                                                    e1.next = 10;
                                                    break;
                                                }
                                                return e1.next = 10, (0, T.ao)("access", n);
                                            case 10:
                                                if (t) {
                                                    e1.next = 12;
                                                    break;
                                                }
                                                return e1.abrupt("return", Promise.resolve(null));
                                            case 12:
                                                return e1.abrupt("return", this.token.revoke(t));
                                            case 13:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return x.apply(this, arguments);
                                })
                            },
                            {
                                key: "revokeRefreshToken",
                                value: (P = (0, o.Z)(h().mark(function e1(t) {
                                    var n, r;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t) {
                                                    e1.next = 10;
                                                    break;
                                                }
                                                return e1.next = 3, this.tokenManager.getTokens();
                                            case 3:
                                                if (n = e1.sent, t = n.refreshToken, r = this.tokenManager.getStorageKeyByType("refreshToken"), this.tokenManager.remove(r), !this.options.dpop) {
                                                    e1.next = 10;
                                                    break;
                                                }
                                                return e1.next = 10, (0, T.ao)("refresh", n);
                                            case 10:
                                                if (t) {
                                                    e1.next = 12;
                                                    break;
                                                }
                                                return e1.abrupt("return", Promise.resolve(null));
                                            case 12:
                                                return e1.abrupt("return", this.token.revoke(t));
                                            case 13:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return P.apply(this, arguments);
                                })
                            },
                            {
                                key: "getSignOutRedirectUrl",
                                value: function() {
                                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e1.idToken, n = e1.postLogoutRedirectUri, r = e1.state;
                                    if (t || (t = this.tokenManager.getTokensSync().idToken), !t) return "";
                                    void 0 === n && (n = this.options.postLogoutRedirectUri);
                                    var o = (0, Z.Fc)(this).logoutUrl, i = t.idToken, a = o + "?id_token_hint=" + encodeURIComponent(i);
                                    return n && (a += "&post_logout_redirect_uri=" + encodeURIComponent(n)), r && (a += "&state=" + encodeURIComponent(r)), a;
                                }
                            },
                            {
                                key: "signOut",
                                value: (m = (0, o.Z)(h().mark(function e1(t) {
                                    var n, r, o, i, a, u, c, s, f, l, p, d, v, y, g, m;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t = Object.assign({}, t), a = window.location.origin, u = window.location.href, c = null === t.postLogoutRedirectUri ? null : t.postLogoutRedirectUri || this.options.postLogoutRedirectUri || a, s = null === (n = t) || void 0 === n ? void 0 : n.state, f = t.accessToken, l = t.refreshToken, p = !1 !== t.revokeAccessToken, (d = !1 !== t.revokeRefreshToken) && void 0 === l && (l = this.tokenManager.getTokensSync().refreshToken), p && void 0 === f && (f = this.tokenManager.getTokensSync().accessToken), t.idToken || (t.idToken = this.tokenManager.getTokensSync().idToken), !d || !l) {
                                                    e1.next = 15;
                                                    break;
                                                }
                                                return e1.next = 15, this.revokeRefreshToken(l);
                                            case 15:
                                                if (!p || !f) {
                                                    e1.next = 18;
                                                    break;
                                                }
                                                return e1.next = 18, this.revokeAccessToken(f);
                                            case 18:
                                                if (v = null !== (r = null === (o = f) || void 0 === o ? void 0 : o.dpopPairId) && void 0 !== r ? r : null === (i = l) || void 0 === i ? void 0 : i.dpopPairId, !this.options.dpop || !v) {
                                                    e1.next = 22;
                                                    break;
                                                }
                                                return e1.next = 22, (0, T.sd)(v);
                                            case 22:
                                                if (y = this.getSignOutRedirectUrl(_(_({}, t), {}, {
                                                    postLogoutRedirectUri: c
                                                }))) {
                                                    e1.next = 33;
                                                    break;
                                                }
                                                return e1.next = 26, this.closeSession();
                                            case 26:
                                                return g = e1.sent, m = new URL(c || a), s && m.searchParams.append("state", s), c === u ? window.location.href = m.href : window.location.assign(m.href), e1.abrupt("return", g);
                                            case 33:
                                                return t.clearTokensBeforeRedirect ? this.tokenManager.clear() : this.tokenManager.addPendingRemoveFlags(), window.location.assign(y), e1.abrupt("return", !0);
                                            case 36:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return m.apply(this, arguments);
                                })
                            },
                            {
                                key: "getDPoPAuthorizationHeaders",
                                value: (d = (0, o.Z)(h().mark(function e1(t) {
                                    var n, r, o, i;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (this.options.dpop) {
                                                    e1.next = 2;
                                                    break;
                                                }
                                                throw new E.Z("DPoP is not configured for this client instance");
                                            case 2:
                                                if ((r = t.accessToken) || (r = this.tokenManager.getTokensSync().accessToken), r) {
                                                    e1.next = 6;
                                                    break;
                                                }
                                                throw new E.Z("AccessToken is required to generate a DPoP Proof");
                                            case 6:
                                                return e1.next = 8, (0, T.lk)(null === (n = r) || void 0 === n ? void 0 : n.dpopPairId);
                                            case 8:
                                                return o = e1.sent, e1.next = 11, (0, T.aW)(_(_({}, t), {}, {
                                                    keyPair: o,
                                                    accessToken: r.accessToken
                                                }));
                                            case 11:
                                                return i = e1.sent, e1.abrupt("return", {
                                                    Authorization: "DPoP ".concat(r.accessToken),
                                                    Dpop: i
                                                });
                                            case 13:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return d.apply(this, arguments);
                                })
                            },
                            {
                                key: "clearDPoPStorage",
                                value: (n = (0, o.Z)(h().mark(function e1() {
                                    var t, n, r, o, i = arguments;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (!(i.length > 0 && void 0 !== i[0] && i[0])) {
                                                    e1.next = 3;
                                                    break;
                                                }
                                                return e1.abrupt("return", (0, T.V7)());
                                            case 3:
                                                return e1.next = 5, this.tokenManager.getTokens();
                                            case 5:
                                                if (r = e1.sent, !(o = (null === (t = r.accessToken) || void 0 === t ? void 0 : t.dpopPairId) || (null === (n = r.refreshToken) || void 0 === n ? void 0 : n.dpopPairId))) {
                                                    e1.next = 10;
                                                    break;
                                                }
                                                return e1.next = 10, (0, T.sd)(o);
                                            case 10:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function() {
                                    return n.apply(this, arguments);
                                })
                            },
                            {
                                key: "parseUseDPoPNonceError",
                                value: function(e1) {
                                    var t = S.Z.getWWWAuthenticateHeader(e1), n = S.Z.parseHeader(null != t ? t : "");
                                    if ((0, T.SO)(n)) {
                                        var r, o, i = null;
                                        return (0, g.mf)(null == e1 ? void 0 : e1.get) && (i = e1.get("DPoP-Nonce")), null !== (r = null !== (o = i) && void 0 !== o ? o : e1["dpop-nonce"]) && void 0 !== r ? r : e1["DPoP-Nonce"];
                                    }
                                    return null;
                                }
                            }
                        ]), H;
                    }(d), (0, p.Z)(n, "crypto", m), n;
                }
            },
            9453: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    m: function() {
                        return g;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(1971), l = n(6718), p = n(415), d = n(8817), h = !0, v = n(9123);
                function y(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function g() {
                    return function(e1) {
                        (0, a.Z)(g, e1);
                        var t, n, d = (t = g, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function g(e1) {
                            var t;
                            return (0, o.Z)(this, g), t = d.call(this, e1), (0, s.Z)((0, i.Z)(t), "issuer", void 0), (0, s.Z)((0, i.Z)(t), "authorizeUrl", void 0), (0, s.Z)((0, i.Z)(t), "userinfoUrl", void 0), (0, s.Z)((0, i.Z)(t), "tokenUrl", void 0), (0, s.Z)((0, i.Z)(t), "revokeUrl", void 0), (0, s.Z)((0, i.Z)(t), "logoutUrl", void 0), (0, s.Z)((0, i.Z)(t), "pkce", void 0), (0, s.Z)((0, i.Z)(t), "clientId", void 0), (0, s.Z)((0, i.Z)(t), "redirectUri", void 0), (0, s.Z)((0, i.Z)(t), "responseType", void 0), (0, s.Z)((0, i.Z)(t), "responseMode", void 0), (0, s.Z)((0, i.Z)(t), "state", void 0), (0, s.Z)((0, i.Z)(t), "scopes", void 0), (0, s.Z)((0, i.Z)(t), "ignoreSignature", void 0), (0, s.Z)((0, i.Z)(t), "codeChallenge", void 0), (0, s.Z)((0, i.Z)(t), "codeChallengeMethod", void 0), (0, s.Z)((0, i.Z)(t), "acrValues", void 0), (0, s.Z)((0, i.Z)(t), "maxAge", void 0), (0, s.Z)((0, i.Z)(t), "dpop", void 0), (0, s.Z)((0, i.Z)(t), "tokenManager", void 0), (0, s.Z)((0, i.Z)(t), "postLogoutRedirectUri", void 0), (0, s.Z)((0, i.Z)(t), "restoreOriginalUri", void 0), (0, s.Z)((0, i.Z)(t), "transactionManager", void 0), (0, s.Z)((0, i.Z)(t), "clientSecret", void 0), (0, s.Z)((0, i.Z)(t), "setLocation", void 0), (0, s.Z)((0, i.Z)(t), "ignoreLifetime", void 0), (0, s.Z)((0, i.Z)(t), "maxClockSkew", void 0), function(e1) {
                                var t = (e1 = e1 || {}).scopes;
                                if (t && !Array.isArray(t)) throw new v.Z('scopes must be a array of strings. Required usage: new OktaAuth({scopes: ["openid", "email"]})');
                                var n = e1.issuer;
                                if (!n) throw new v.Z('No issuer passed to constructor. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
                                if (!new RegExp("^http?s?://.+").test(n)) throw new v.Z('Issuer must be a valid URL. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
                                if (-1 !== n.indexOf("-admin.okta")) throw new v.Z('Issuer URL passed to constructor contains "-admin" in subdomain. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com})');
                            }(e1), t.issuer = (0, l.Qj)(e1.issuer), t.tokenUrl = (0, l.Qj)(e1.tokenUrl), t.authorizeUrl = (0, l.Qj)(e1.authorizeUrl), t.userinfoUrl = (0, l.Qj)(e1.userinfoUrl), t.revokeUrl = (0, l.Qj)(e1.revokeUrl), t.logoutUrl = (0, l.Qj)(e1.logoutUrl), t.pkce = !1 !== e1.pkce, t.clientId = e1.clientId, t.redirectUri = e1.redirectUri, (0, p.isBrowser)() && (t.redirectUri = (0, l.BY)(e1.redirectUri, window.location.origin)), t.responseType = e1.responseType, t.responseMode = e1.responseMode, t.state = e1.state, t.scopes = e1.scopes, t.ignoreSignature = !!e1.ignoreSignature, t.codeChallenge = e1.codeChallenge, t.codeChallengeMethod = e1.codeChallengeMethod, t.acrValues = e1.acrValues, t.maxAge = e1.maxAge, t.dpop = !0 === e1.dpop, t.tokenManager = e1.tokenManager, t.postLogoutRedirectUri = e1.postLogoutRedirectUri, t.restoreOriginalUri = e1.restoreOriginalUri, t.transactionManager = function(e1) {
                                for(var t = 1; t < arguments.length; t++){
                                    var n = null != arguments[t] ? arguments[t] : {};
                                    t % 2 ? y(Object(n), !0).forEach(function(t) {
                                        (0, s.Z)(e1, t, n[t]);
                                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function(t) {
                                        Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                                    });
                                }
                                return e1;
                            }({
                                enableSharedStorage: h
                            }, e1.transactionManager), t.clientSecret = e1.clientSecret, t.setLocation = e1.setLocation, t.ignoreLifetime = !!e1.ignoreLifetime, e1.maxClockSkew || 0 === e1.maxClockSkew ? t.maxClockSkew = e1.maxClockSkew : t.maxClockSkew = f.DEFAULT_MAX_CLOCK_SKEW, t;
                        }
                        return (0, r.Z)(g);
                    }((0, d.Z)());
                }
            },
            3775: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    m: function() {
                        return r.m;
                    }
                });
                var r = n(9453);
            },
            5372: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Tp: function() {
                        return p;
                    },
                    ko: function() {
                        return h;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(1969), c = n(9912), s = n(4771), f = n(8676);
                function l(e1) {
                    var t = e1.options.pkce ? "query" : "fragment";
                    return e1.options.responseMode || t;
                }
                function p(e1, t) {
                    t = t || {}, (0, s.HD)(t) && (t = {
                        url: t
                    });
                    var n, r = t.url, o = t.responseMode || l(e1), i = e1.token.parseFromUrl._getLocation();
                    if (!(n = "query" === o ? r ? r.substring(r.indexOf("?")) : i.search : r ? r.substring(r.indexOf("#")) : i.hash)) throw new a.Z("Unable to parse a token from the url");
                    return (0, u.v)(n);
                }
                function d(e1, t) {
                    "query" === (t.responseMode || l(e1)) ? function(e1) {
                        var t = e1.token.parseFromUrl._getHistory(), n = e1.token.parseFromUrl._getDocument(), r = e1.token.parseFromUrl._getLocation();
                        t && t.replaceState ? t.replaceState(null, n.title, r.pathname + r.hash) : r.search = "";
                    }(e1) : function(e1) {
                        var t = e1.token.parseFromUrl._getHistory(), n = e1.token.parseFromUrl._getDocument(), r = e1.token.parseFromUrl._getLocation();
                        t && t.replaceState ? t.replaceState(null, n.title, r.pathname + r.search) : r.hash = "";
                    }(e1);
                }
                function h(e1, t) {
                    return v.apply(this, arguments);
                }
                function v() {
                    return (v = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, u, l;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = n || {}, (0, s.HD)(n) && (n = {
                                        url: n
                                    }), r = p(t, n), o = r.state, u = t.transactionManager.load({
                                        state: o
                                    })) {
                                        e1.next = 9;
                                        break;
                                    }
                                    if (!t.options.pkce) {
                                        e1.next = 8;
                                        break;
                                    }
                                    throw new a.Z("Could not load PKCE codeVerifier from storage. This may indicate the auth flow has already completed or multiple auth flows are executing concurrently.", void 0);
                                case 8:
                                    throw new a.Z("Unable to retrieve OAuth redirect params from storage");
                                case 9:
                                    return l = u.urls, delete u.urls, n.url || d(t, n), e1.abrupt("return", (0, f.s)(t, u, r, l).catch(function(e1) {
                                        throw (0, c.Cf)(e1) || t.transactionManager.clear({
                                            state: o
                                        }), e1;
                                    }).then(function(e1) {
                                        return t.transactionManager.clear({
                                            state: o
                                        }), e1;
                                    }));
                                case 13:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            2476: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $: function() {
                        return p;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(6488), c = n(7625), s = n(781);
                function f() {
                    throw new a.Z("Renew must be passed a token with an array of scopes and an accessToken or idToken");
                }
                function l(e1, t) {
                    return (0, u.sI)(e1) ? t.idToken : (0, u.hv)(e1) ? t.accessToken : void f();
                }
                function p(e1, t) {
                    return d.apply(this, arguments);
                }
                function d() {
                    return (d = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, p, d, h, v, y, g;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if ((0, u.sI)(n) || (0, u.hv)(n) || f(), !(r = t.tokenManager.getTokensSync()).refreshToken) {
                                        e1.next = 7;
                                        break;
                                    }
                                    return e1.next = 5, (0, s.R)(t, {
                                        scopes: n.scopes
                                    }, r.refreshToken);
                                case 5:
                                    return r = e1.sent, e1.abrupt("return", l(n, r));
                                case 7:
                                    return o = t.options.pkce ? "code" : (0, u.hv)(n) ? "token" : "id_token", p = (a = n).scopes, d = a.authorizeUrl, h = a.userinfoUrl, v = a.issuer, y = a.dpopPairId, g = a.extraParams, e1.abrupt("return", (0, c.y)(t, {
                                        responseType: o,
                                        scopes: p,
                                        authorizeUrl: d,
                                        userinfoUrl: h,
                                        issuer: v,
                                        dpopPairId: y,
                                        extraParams: g
                                    }).then(function(e1) {
                                        return l(n, e1.tokens);
                                    }));
                                case 10:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            6268: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    I: function() {
                        return f;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(7625), c = n(781), s = n(7756);
                function f(e1, t) {
                    return l.apply(this, arguments);
                }
                function l() {
                    return (l = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, f, l, p, d, h, v, y, g, m, b, k;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (!(f = null !== (r = null === (o = n) || void 0 === o ? void 0 : o.tokens) && void 0 !== r ? r : t.tokenManager.getTokensSync()).refreshToken) {
                                        e1.next = 3;
                                        break;
                                    }
                                    return e1.abrupt("return", (0, c.R)(t, n || {}, f.refreshToken));
                                case 3:
                                    if (f.accessToken || f.idToken) {
                                        e1.next = 5;
                                        break;
                                    }
                                    throw new a.Z("renewTokens() was called but there is no existing token");
                                case 5:
                                    if (l = f.accessToken || {}, p = f.idToken || {}, d = l.scopes || p.scopes) {
                                        e1.next = 10;
                                        break;
                                    }
                                    throw new a.Z("renewTokens: invalid tokens: could not read scopes");
                                case 10:
                                    if (h = l.authorizeUrl || p.authorizeUrl) {
                                        e1.next = 13;
                                        break;
                                    }
                                    throw new a.Z("renewTokens: invalid tokens: could not read authorizeUrl");
                                case 13:
                                    return v = l.userinfoUrl || t.options.userinfoUrl, y = p.issuer || t.options.issuer, g = null == l ? void 0 : l.dpopPairId, m = (null == l ? void 0 : l.extraParams) || (null == p ? void 0 : p.extraParams), n = Object.assign({
                                        scopes: d,
                                        authorizeUrl: h,
                                        userinfoUrl: v,
                                        issuer: y,
                                        dpopPairId: g,
                                        extraParams: m
                                    }, n), t.options.pkce ? n.responseType = "code" : (b = (0, s.D)(t), k = b.responseType, n.responseType = k), e1.abrupt("return", (0, u.y)(t, n).then(function(e1) {
                                        return e1.tokens;
                                    }));
                                case 20:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            781: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    R: function() {
                        return y;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(9123), c = n(7599), s = n(6635), f = n(8676), l = n(9231), p = n(7659), d = n(9912);
                function h(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function v(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? h(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function y(e1, t, n) {
                    return g.apply(this, arguments);
                }
                function g() {
                    return (g = (0, o.Z)(a().mark(function e1(t, n, r) {
                        var o, i, h, y, g, m, b, k, w, O, Z;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (o = t.options, i = o.clientId, h = o.dpop, i) {
                                        e1.next = 3;
                                        break;
                                    }
                                    throw new u.Z("A clientId must be specified in the OktaAuth constructor to renew tokens");
                                case 3:
                                    if (e1.prev = 3, y = Object.assign({}, n, {
                                        clientId: i
                                    }), r.extraParams && (y.extraParams = r.extraParams), g = v({}, y), !h) {
                                        e1.next = 14;
                                        break;
                                    }
                                    return e1.next = 10, (0, p.lk)(null == r ? void 0 : r.dpopPairId);
                                case 10:
                                    m = e1.sent, g.dpopKeyPair = m, y.dpop = h, y.dpopPairId = r.dpopPairId;
                                case 14:
                                    return e1.next = 16, (0, l.D)(t, g, r);
                                case 16:
                                    return b = e1.sent, k = (0, c.Fc)(t, n), e1.next = 20, (0, f.s)(t, y, b, k);
                                case 20:
                                    return w = e1.sent, O = w.tokens, (Z = O.refreshToken) && !(0, s.q)(Z, r) && t.tokenManager.updateRefreshToken(Z), e1.abrupt("return", O);
                                case 27:
                                    throw e1.prev = 27, e1.t0 = e1.catch(3), (0, d.$E)(e1.t0) && t.tokenManager.removeRefreshToken(), e1.t0;
                                case 31:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                3,
                                27
                            ]
                        ]);
                    }))).apply(this, arguments);
                }
            },
            6466: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    P: function() {
                        return l;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(5385), u = n(6718), c = n(7599), s = n(7594), f = n(9123);
                function l(e1, t) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return (p = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, l, p, d, h, v;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = "", o = "", n && (r = n.accessToken, o = n.refreshToken), r || o) {
                                        e1.next = 5;
                                        break;
                                    }
                                    throw new f.Z("A valid access or refresh token object is required");
                                case 5:
                                    if (l = t.options.clientId, p = t.options.clientSecret, l) {
                                        e1.next = 9;
                                        break;
                                    }
                                    throw new f.Z("A clientId must be specified in the OktaAuth constructor to revoke a token");
                                case 9:
                                    return d = (0, c.Fc)(t).revokeUrl, h = (0, u.UK)({
                                        token_type_hint: o ? "refresh_token" : "access_token",
                                        token: o || r
                                    }).slice(1), v = p ? (0, s.r3)("".concat(l, ":").concat(p)) : (0, s.r3)(l), e1.abrupt("return", (0, a.v_)(t, d, h, {
                                        headers: {
                                            "Content-Type": "application/x-www-form-urlencoded",
                                            Authorization: "Basic " + v
                                        }
                                    }));
                                case 13:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            2333: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return l;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(5437), s = n(5763), f = n(1971);
                function l() {
                    return function(e1) {
                        (0, i.Z)(p, e1);
                        var t, n, l = (t = p, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, u.Z)(t);
                            if (n) {
                                var o = (0, u.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, a.Z)(this, e1);
                        });
                        function p(e1, t, n) {
                            return (0, r.Z)(this, p), l.call(this, e1, t, n);
                        }
                        return (0, o.Z)(p, [
                            {
                                key: "getTransactionStorage",
                                value: function(e1) {
                                    e1 = this.getOptionsForSection("transaction", e1), (0, c.V)(e1);
                                    var t = this.getStorage(e1), n = e1.storageKey || f.TRANSACTION_STORAGE_NAME;
                                    return new s._(t, n);
                                }
                            },
                            {
                                key: "getSharedTansactionStorage",
                                value: function(e1) {
                                    e1 = this.getOptionsForSection("shared-transaction", e1), (0, c.V)(e1);
                                    var t = this.getStorage(e1), n = e1.storageKey || f.SHARED_TRANSACTION_STORAGE_NAME;
                                    return new s._(t, n);
                                }
                            },
                            {
                                key: "getOriginalUriStorage",
                                value: function(e1) {
                                    e1 = this.getOptionsForSection("original-uri", e1), (0, c.V)(e1);
                                    var t = this.getStorage(e1), n = e1.storageKey || f.ORIGINAL_URI_STORAGE_NAME;
                                    return new s._(t, n);
                                }
                            }
                        ]), p;
                    }(c.W);
                }
            },
            6488: function(e1, t, n) {
                "use strict";
                var r;
                function o(e1) {
                    return !!(e1 && (e1.accessToken || e1.idToken || e1.refreshToken) && Array.isArray(e1.scopes));
                }
                function i(e1) {
                    return e1 && e1.accessToken;
                }
                function a(e1) {
                    return e1 && e1.idToken;
                }
                function u(e1) {
                    return e1 && e1.refreshToken;
                }
                n.d(t, {
                    T6: function() {
                        return r;
                    },
                    hD: function() {
                        return o;
                    },
                    hv: function() {
                        return i;
                    },
                    sI: function() {
                        return a;
                    },
                    z9: function() {
                        return u;
                    }
                }), function(e1) {
                    e1.ACCESS = "accessToken", e1.ID = "idToken", e1.REFRESH = "refreshToken";
                }(r || (r = {}));
            },
            7088: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $I: function() {
                        return u;
                    },
                    $Y: function() {
                        return r;
                    },
                    E: function() {
                        return o;
                    },
                    FT: function() {
                        return a;
                    },
                    O3: function() {
                        return i;
                    },
                    zr: function() {
                        return c;
                    }
                });
                var r = "expired", o = "renewed", i = "added", a = "removed", u = "error", c = "set_storage";
            },
            4319: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    G5: function() {
                        return i;
                    },
                    ZT: function() {
                        return a;
                    },
                    mH: function() {
                        return s;
                    },
                    rZ: function() {
                        return c;
                    },
                    sG: function() {
                        return u;
                    }
                });
                var r = n(1002);
                function o(e1) {
                    return !(!e1 || "object" !== (0, r.Z)(e1) || 0 === Object.values(e1).length);
                }
                function i(e1) {
                    return !(!o(e1) || !e1.redirectUri && !e1.responseType);
                }
                function a(e1) {
                    return !!i(e1) && !!e1.codeVerifier;
                }
                function u(e1) {
                    return !!a(e1) && !!e1.interactionHandle;
                }
                function c(e1) {
                    return !!o(e1) && void 0 === Object.values(e1).find(function(e1) {
                        return "string" != typeof e1;
                    });
                }
                function s(e1) {
                    return !(!i(e1) && !c(e1));
                }
            },
            7615: function() {},
            8927: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    EVENT_ADDED: function() {
                        return u.O3;
                    },
                    EVENT_ERROR: function() {
                        return u.$I;
                    },
                    EVENT_EXPIRED: function() {
                        return u.$Y;
                    },
                    EVENT_REMOVED: function() {
                        return u.FT;
                    },
                    EVENT_RENEWED: function() {
                        return u.E;
                    },
                    EVENT_SET_STORAGE: function() {
                        return u.zr;
                    },
                    TokenKind: function() {
                        return a.T6;
                    },
                    isAccessToken: function() {
                        return a.hv;
                    },
                    isCustomAuthTransactionMeta: function() {
                        return c.rZ;
                    },
                    isIDToken: function() {
                        return a.sI;
                    },
                    isIdxTransactionMeta: function() {
                        return c.sG;
                    },
                    isOAuthTransactionMeta: function() {
                        return c.G5;
                    },
                    isPKCETransactionMeta: function() {
                        return c.ZT;
                    },
                    isRefreshToken: function() {
                        return a.z9;
                    },
                    isToken: function() {
                        return a.hD;
                    },
                    isTransactionMeta: function() {
                        return c.mH;
                    }
                });
                var r = n(9263), o = {};
                for(var i in r)"default" !== i && (o[i] = (function(e1) {
                    return r[e1];
                }).bind(0, i));
                n.d(t, o);
                var a = n(6488), u = n(7088), c = n(4319), s = n(7615);
                for(var i in o = {}, s)[
                    "default",
                    "TokenKind",
                    "isAccessToken",
                    "isIDToken",
                    "isRefreshToken",
                    "isToken",
                    "EVENT_ADDED",
                    "EVENT_ERROR",
                    "EVENT_EXPIRED",
                    "EVENT_REMOVED",
                    "EVENT_RENEWED",
                    "EVENT_SET_STORAGE",
                    "isCustomAuthTransactionMeta",
                    "isIdxTransactionMeta",
                    "isOAuthTransactionMeta",
                    "isPKCETransactionMeta",
                    "isTransactionMeta"
                ].indexOf(i) < 0 && (o[i] = (function(e1) {
                    return s[e1];
                }).bind(0, i));
                n.d(t, o);
            },
            9263: function() {},
            4970: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    NH: function() {
                        return o;
                    },
                    Rl: function() {
                        return a;
                    },
                    iC: function() {
                        return c;
                    },
                    pU: function() {
                        return u;
                    },
                    ys: function() {
                        return i;
                    }
                });
                var r = n(9123);
                function o(e1, t, n) {
                    e1.addEventListener ? e1.addEventListener(t, n) : e1.attachEvent("on" + t, n);
                }
                function i(e1, t, n) {
                    e1.removeEventListener ? e1.removeEventListener(t, n) : e1.detachEvent("on" + t, n);
                }
                function a(e1) {
                    var t = document.createElement("iframe");
                    return t.style.display = "none", t.src = e1, document.body.appendChild(t);
                }
                function u(e1, t) {
                    var n = t.popupTitle || "External Identity Provider User Authentication";
                    return window.open(e1, n, "toolbar=no, scrollbars=yes, resizable=yes, top=100, left=500, width=600, height=600");
                }
                function c(e1, t, n) {
                    var a, u;
                    return new Promise(function(i, c) {
                        a = function(t) {
                            if (t.data && t.data.state === n) return t.origin !== e1.getIssuerOrigin() ? c(new r.Z("The request does not match client configuration")) : void i(t.data);
                        }, o(window, "message", a), u = setTimeout(function() {
                            c(new r.Z("OAuth flow timed out"));
                        }, t || 12e4);
                    }).finally(function() {
                        clearTimeout(u), i(window, "message", a);
                    });
                }
            },
            5078: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    c: function() {
                        return a;
                    }
                });
                var r = n(7599), o = n(415), i = n(3193);
                function a(e1) {
                    var t = e1.options, n = t.clientId, a = t.redirectUri, u = t.responseMode, c = t.state, s = (0, o.isBrowser)() ? window.location.href : void 0;
                    return (0, i.YY)({
                        clientId: n,
                        redirectUri: a || s,
                        responseMode: u,
                        state: c || (0, r.aV)(),
                        responseType: "none",
                        prompt: "enroll_authenticator"
                    });
                }
            },
            7756: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    D: function() {
                        return a;
                    }
                });
                var r = n(7599), o = n(415), i = n(3193);
                function a(e1) {
                    var t = e1.options, n = t.pkce, a = t.clientId, u = t.redirectUri, c = t.responseType, s = t.responseMode, f = t.scopes, l = t.acrValues, p = t.maxAge, d = t.state, h = t.ignoreSignature, v = t.dpop, y = (0, o.isBrowser)() ? window.location.href : void 0;
                    return (0, i.YY)({
                        pkce: n,
                        clientId: a,
                        redirectUri: u || y,
                        responseType: c || [
                            "token",
                            "id_token"
                        ],
                        responseMode: s,
                        state: d || (0, r.aV)(),
                        nonce: (0, r.NH)(),
                        scopes: f || [
                            "openid",
                            "email"
                        ],
                        acrValues: l,
                        maxAge: p,
                        ignoreSignature: h,
                        dpop: v
                    });
                }
            },
            8080: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    A: function() {
                        return o;
                    }
                });
                var r = n(7599);
                function o(e1, t) {
                    return {
                        issuer: e1.options.issuer,
                        urls: (0, r.Fc)(e1, t),
                        clientId: t.clientId,
                        redirectUri: t.redirectUri,
                        responseType: t.responseType,
                        responseMode: t.responseMode,
                        state: t.state,
                        acrValues: t.acrValues,
                        enrollAmrValues: t.enrollAmrValues
                    };
                }
            },
            9912: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $E: function() {
                        return a;
                    },
                    Cf: function() {
                        return o;
                    },
                    tC: function() {
                        return i;
                    }
                });
                var r = n(5728);
                function o(e1) {
                    return "OAuthError" === e1.name && "interaction_required" === e1.errorCode;
                }
                function i(e1, t) {
                    if ("AuthApiError" !== t.name) return !1;
                    var n = t.xhr, r = null == n ? void 0 : n.responseJSON;
                    return e1.options.pkce && "invalid_grant" === (null == r ? void 0 : r.error);
                }
                function a(e1) {
                    return (0, r.isOAuthError)(e1) && "invalid_grant" === e1.errorCode && "The refresh token is invalid or expired." === e1.errorSummary;
                }
            },
            8785: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $E: function() {
                        return a.$E;
                    },
                    AW: function() {
                        return f.A;
                    },
                    Cf: function() {
                        return a.Cf;
                    },
                    Dx: function() {
                        return o.D;
                    },
                    Fc: function() {
                        return c.Fc;
                    },
                    H: function() {
                        return s.H;
                    },
                    Ik: function() {
                        return u.Ik;
                    },
                    NH: function() {
                        return r.NH;
                    },
                    O2: function() {
                        return u.O2;
                    },
                    PY: function() {
                        return c.NH;
                    },
                    Qs: function() {
                        return u.Qs;
                    },
                    Rl: function() {
                        return r.Rl;
                    },
                    Rp: function() {
                        return g.R;
                    },
                    U5: function() {
                        return l.Z;
                    },
                    Uc: function() {
                        return d.U;
                    },
                    Xp: function() {
                        return c.Xp;
                    },
                    Yo: function() {
                        return h.Y;
                    },
                    ZP: function() {
                        return u.ZP;
                    },
                    aV: function() {
                        return c.aV;
                    },
                    br: function() {
                        return p.br;
                    },
                    cE: function() {
                        return i.c;
                    },
                    d_: function() {
                        return u.d_;
                    },
                    gM: function() {
                        return u.gM;
                    },
                    hg: function() {
                        return u.hg;
                    },
                    iC: function() {
                        return r.iC;
                    },
                    kU: function() {
                        return u.kU;
                    },
                    mi: function() {
                        return p.mi;
                    },
                    pU: function() {
                        return r.pU;
                    },
                    pj: function() {
                        return y.p;
                    },
                    q0: function() {
                        return h.q;
                    },
                    tC: function() {
                        return a.tC;
                    },
                    vL: function() {
                        return v.v;
                    },
                    vz: function() {
                        return p.vz;
                    },
                    wV: function() {
                        return u.wV;
                    },
                    wc: function() {
                        return u.wc;
                    },
                    wu: function() {
                        return p.wu;
                    },
                    ys: function() {
                        return r.ys;
                    },
                    zf: function() {
                        return c.zf;
                    }
                });
                var r = n(4970), o = n(7756), i = n(5078), a = n(9912), u = n(8221), c = n(7599), s = n(2865), f = n(8080), l = n(3611), p = n(6898), d = n(6757), h = n(6635), v = n(1969), y = n(6003), g = n(2482);
            },
            8221: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return /((id|access)_token=)/i.test(e1);
                }
                function o(e1) {
                    return /(code=)/i.test(e1);
                }
                function i(e1) {
                    return /(interaction_code=)/i.test(e1);
                }
                function a(e1) {
                    return /(error=)/i.test(e1) || /(error_description)/i.test(e1);
                }
                function u(e1, t) {
                    var n = t.options;
                    return !(!e1 || !n.redirectUri) && 0 === e1.indexOf(n.redirectUri);
                }
                function c(e1) {
                    return e1.pkce || "code" === e1.responseType || "query" === e1.responseMode;
                }
                function s(e1, t) {
                    return Array.isArray(t.responseType) && t.responseType.length ? t.responseType.indexOf(e1) >= 0 : t.responseType === e1;
                }
                function f(e1) {
                    return c(e1) && "fragment" !== e1.responseMode ? window.location.search : window.location.hash;
                }
                function l(e1) {
                    if (!u(window.location.href, e1)) return !1;
                    var t = c(e1.options), n = f(e1.options);
                    return !!a(n) || (t ? o(n) || i(n) : r(window.location.hash));
                }
                function p(e1, t) {
                    if (!t) {
                        if (!l(e1)) return !1;
                        t = f(e1.options);
                    }
                    return /(error=interaction_required)/i.test(t);
                }
                n.d(t, {
                    Ik: function() {
                        return c;
                    },
                    O2: function() {
                        return f;
                    },
                    Qs: function() {
                        return u;
                    },
                    ZP: function() {
                        return o;
                    },
                    d_: function() {
                        return i;
                    },
                    gM: function() {
                        return l;
                    },
                    hg: function() {
                        return a;
                    },
                    kU: function() {
                        return r;
                    },
                    wV: function() {
                        return s;
                    },
                    wc: function() {
                        return p;
                    }
                });
            },
            7599: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Fc: function() {
                        return l;
                    },
                    NH: function() {
                        return u;
                    },
                    Xp: function() {
                        return f;
                    },
                    aV: function() {
                        return a;
                    },
                    zf: function() {
                        return s;
                    }
                });
                var r = n(8750), o = n(6718), i = n(9123);
                function a() {
                    return (0, r.uh)(64);
                }
                function u() {
                    return (0, r.uh)(64);
                }
                function c(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return (0, o.Qj)(t.issuer) || e1.options.issuer;
                }
                function s(e1) {
                    var t = c(e1, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {});
                    return t.indexOf("/oauth2") > 0 ? t : t + "/oauth2";
                }
                function f(e1) {
                    return c(e1, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).split("/oauth2")[0];
                }
                function l(e1, t) {
                    if (arguments.length > 2) throw new i.Z('As of version 3.0, "getOAuthUrls" takes only a single set of options');
                    t = t || {};
                    var n = (0, o.Qj)(t.authorizeUrl) || e1.options.authorizeUrl, r = c(e1, t), a = (0, o.Qj)(t.userinfoUrl) || e1.options.userinfoUrl, u = (0, o.Qj)(t.tokenUrl) || e1.options.tokenUrl, f = (0, o.Qj)(t.logoutUrl) || e1.options.logoutUrl, l = (0, o.Qj)(t.revokeUrl) || e1.options.revokeUrl, p = s(e1, t);
                    return {
                        issuer: r,
                        authorizeUrl: n = n || p + "/v1/authorize",
                        userinfoUrl: a = a || p + "/v1/userinfo",
                        tokenUrl: u = u || p + "/v1/token",
                        revokeUrl: l = l || p + "/v1/revoke",
                        logoutUrl: f = f || p + "/v1/logout"
                    };
                }
            },
            2865: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    H: function() {
                        return u;
                    }
                });
                var r = n(4942), o = n(7599);
                function i(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function a(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? i(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function u(e1, t) {
                    var n = {
                        issuer: e1.options.issuer,
                        urls: (0, o.Fc)(e1, t),
                        clientId: t.clientId,
                        redirectUri: t.redirectUri,
                        responseType: t.responseType,
                        responseMode: t.responseMode,
                        scopes: t.scopes,
                        state: t.state,
                        nonce: t.nonce,
                        ignoreSignature: t.ignoreSignature,
                        acrValues: t.acrValues,
                        extraParams: t.extraParams
                    };
                    return !1 === t.pkce ? n : a(a({}, n), {}, {
                        codeVerifier: t.codeVerifier,
                        codeChallengeMethod: t.codeChallengeMethod,
                        codeChallenge: t.codeChallenge
                    });
                }
            },
            3611: function(e1, t, n) {
                "use strict";
                var r = n(7594), o = n(7987), i = n(1971);
                function a(e1) {
                    return ("0" + e1.toString(16)).substr(-2);
                }
                t.Z = {
                    DEFAULT_CODE_CHALLENGE_METHOD: i.DEFAULT_CODE_CHALLENGE_METHOD,
                    generateVerifier: function(e1) {
                        var t, n, o = e1 || "";
                        return o.length < i.MIN_VERIFIER_LENGTH && (o += (t = i.MIN_VERIFIER_LENGTH - o.length, n = new Uint8Array(Math.ceil(t / 2)), r.KP.getRandomValues(n), Array.from(n, a).join("").slice(0, t))), encodeURIComponent(o).slice(0, i.MAX_VERIFIER_LENGTH);
                    },
                    computeChallenge: function(e1) {
                        var t = (new TextEncoder).encode(e1);
                        return r.KP.subtle.digest("SHA-256", t).then(function(e1) {
                            var t = String.fromCharCode.apply(null, new Uint8Array(e1));
                            return (0, o.NL)(t);
                        });
                    }
                };
            },
            6757: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    U: function() {
                        return c;
                    }
                });
                var r = n(4942), o = n(9123), i = n(5078);
                function a(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function u(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? a(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : a(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function c(e1, t) {
                    return function(e1) {
                        if (!(e1 = u(u({}, e1), {}, {
                            responseType: "none",
                            prompt: "enroll_authenticator",
                            maxAge: 0
                        })).enrollAmrValues) throw new o.Z("enroll_amr_values must be specified");
                        if (!e1.acrValues) throw new o.Z("acr_values must be specified");
                        return delete e1.scopes, delete e1.nonce, e1;
                    }(u(u({}, (0, i.c)(e1)), t));
                }
            },
            6898: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    br: function() {
                        return v;
                    },
                    mi: function() {
                        return g;
                    },
                    vz: function() {
                        return h;
                    },
                    wu: function() {
                        return b;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(52), c = n(9123), s = n(7756), f = n(1971), l = n(3611);
                function p(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function d(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? p(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function h(e1) {
                    if (!e1.features.isPKCESupported()) {
                        var t = "PKCE requires a modern browser with encryption support running in a secure context.";
                        throw e1.features.isHTTPS() || (t += "\nThe current page is not being served with HTTPS protocol. PKCE requires secure HTTPS protocol."), e1.features.hasTextEncoder() || (t += '\n"TextEncoder" is not defined. To use PKCE, you may need to include a polyfill/shim for this browser.'), new c.Z(t);
                    }
                }
                function v(e1, t) {
                    return y.apply(this, arguments);
                }
                function y() {
                    return (y = (0, o.Z)(a().mark(function e1(t, n) {
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = n || t.options.codeChallengeMethod || f.DEFAULT_CODE_CHALLENGE_METHOD, e1.next = 3, (0, u.E)(t);
                                case 3:
                                    if (-1 !== (e1.sent.code_challenge_methods_supported || []).indexOf(n)) {
                                        e1.next = 7;
                                        break;
                                    }
                                    throw new c.Z("Invalid code_challenge_method");
                                case 7:
                                    return e1.abrupt("return", n);
                                case 8:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function g(e1, t) {
                    return m.apply(this, arguments);
                }
                function m() {
                    return (m = (0, o.Z)(a().mark(function e1(t, n) {
                        var r, o, i, u;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (o = (r = n).codeVerifier, i = r.codeChallenge, u = r.codeChallengeMethod, i = i || t.options.codeChallenge) {
                                        e1.next = 8;
                                        break;
                                    }
                                    return h(t), o = o || l.Z.generateVerifier(), e1.next = 7, l.Z.computeChallenge(o);
                                case 7:
                                    i = e1.sent;
                                case 8:
                                    return e1.next = 10, v(t, u);
                                case 10:
                                    return u = e1.sent, n = d(d({}, n), {}, {
                                        responseType: "code",
                                        codeVerifier: o,
                                        codeChallenge: i,
                                        codeChallengeMethod: u
                                    }), e1.abrupt("return", n);
                                case 13:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function b(e1) {
                    return k.apply(this, arguments);
                }
                function k() {
                    return k = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = o.length > 1 && void 0 !== o[1] ? o[1] : {}, r = (0, s.D)(t), !(n = d(d({}, r), n)).dpop || t.features.isDPoPSupported()) {
                                        e1.next = 5;
                                        break;
                                    }
                                    throw new c.Z("DPoP has been configured, but is not supported by browser");
                                case 5:
                                    if (!1 !== n.pkce) {
                                        e1.next = 7;
                                        break;
                                    }
                                    return e1.abrupt("return", n);
                                case 7:
                                    return e1.abrupt("return", g(t, n));
                                case 8:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), k.apply(this, arguments);
                }
            },
            6635: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Y: function() {
                        return i;
                    },
                    q: function() {
                        return o;
                    }
                });
                var r = n(5728);
                function o(e1, t) {
                    return e1.refreshToken === t.refreshToken;
                }
                function i(e1) {
                    return !(!(0, r.isAuthApiError)(e1) || !e1.xhr || !e1.xhr.responseJSON || "invalid_grant" !== e1.xhr.responseJSON.error);
                }
            },
            1969: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    var t = /\+/g, n = /([^&=]+)=?([^&]*)/g, r = e1 || "";
                    "#" === r.charAt(0) && "/" === r.charAt(1) && (r = r.substring(2)), "#" !== r.charAt(0) && "?" !== r.charAt(0) || (r = r.substring(1));
                    for(var o, i = {}; o = n.exec(r);){
                        var a = o[1], u = o[2];
                        i[a] = "id_token" === a || "access_token" === a || "code" === a ? u : decodeURIComponent(u.replace(t, " "));
                    }
                    return i;
                }
                n.d(t, {
                    v: function() {
                        return r;
                    }
                });
            },
            6003: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    p: function() {
                        return o;
                    }
                });
                var r = n(9123);
                function o(e1, t, n) {
                    var o = n.clientId, i = n.issuer, a = n.nonce, u = n.acrValues;
                    if (!t || !i || !o) throw new r.Z("The jwt, iss, and aud arguments are all required");
                    if (a && t.nonce !== a) throw new r.Z("OAuth flow response nonce doesn't match request nonce");
                    var c = Math.floor(Date.now() / 1e3);
                    if (t.iss !== i) throw new r.Z("The issuer [" + t.iss + "] does not match [" + i + "]");
                    if (Array.isArray(t.aud) && t.aud.indexOf(o) < 0 || !Array.isArray(t.aud) && t.aud !== o) throw new r.Z("The audience [" + t.aud + "] does not match [" + o + "]");
                    if (u && t.acr !== u) throw new r.Z("The acr [" + t.acr + "] does not match acr_values [" + u + "]");
                    if (t.iat > t.exp) throw new r.Z("The JWT expired before it was issued");
                    if (!e1.options.ignoreLifetime) {
                        if (c - e1.options.maxClockSkew > t.exp) throw new r.Z("The JWT expired and is no longer valid");
                        if (t.iat > c + e1.options.maxClockSkew) throw new r.Z("The JWT was issued in the future");
                    }
                }
            },
            2482: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    R: function() {
                        return i;
                    }
                });
                var r = n(9123), o = n(6488);
                function i(e1, t) {
                    if (!(0, o.sI)(e1) && !(0, o.hv)(e1) && !(0, o.z9)(e1)) throw new r.Z("Token must be an Object with scopes, expiresAt, and one of: an idToken, accessToken, or refreshToken property");
                    if ("accessToken" === t && !(0, o.hv)(e1)) throw new r.Z("invalid accessToken");
                    if ("idToken" === t && !(0, o.sI)(e1)) throw new r.Z("invalid idToken");
                    if ("refreshToken" === t && !(0, o.z9)(e1)) throw new r.Z("invalid refreshToken");
                }
            },
            1260: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    W: function() {
                        return p;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(52), u = n(6003), c = n(9123), s = n(1237), f = n(3154), l = n(5698);
                function p(e1, t, n) {
                    return d.apply(this, arguments);
                }
                function d() {
                    return (d = (0, r.Z)(i().mark(function e1(t, n, r) {
                        var o, p, d, h, v, y;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n && n.idToken) {
                                        e1.next = 2;
                                        break;
                                    }
                                    throw new c.Z("Only idTokens may be verified");
                                case 2:
                                    return o = (0, s.T)(n.idToken), p = (null == r ? void 0 : r.issuer) || t.options.issuer, e1.next = 6, (0, a.E)(t, p);
                                case 6:
                                    if (d = e1.sent, h = d.issuer, v = Object.assign({
                                        clientId: t.options.clientId,
                                        ignoreSignature: t.options.ignoreSignature
                                    }, r, {
                                        issuer: h
                                    }), (0, u.p)(t, o.payload, v), 1 != v.ignoreSignature && t.features.isTokenVerifySupported()) {
                                        e1.next = 12;
                                        break;
                                    }
                                    return e1.abrupt("return", n);
                                case 12:
                                    return e1.next = 14, (0, a.k)(t, n.issuer, o.header.kid);
                                case 14:
                                    return y = e1.sent, e1.next = 17, f.W(n.idToken, y);
                                case 17:
                                    if (e1.sent) {
                                        e1.next = 20;
                                        break;
                                    }
                                    throw new c.Z("The token signature is not valid");
                                case 20:
                                    if (!(r && r.accessToken && n.claims.at_hash)) {
                                        e1.next = 26;
                                        break;
                                    }
                                    return e1.next = 23, l.X(r.accessToken);
                                case 23:
                                    if (e1.sent === n.claims.at_hash) {
                                        e1.next = 26;
                                        break;
                                    }
                                    throw new c.Z("Token hash verification failed");
                                case 26:
                                    return e1.abrupt("return", n);
                                case 27:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            3719: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Gg: function() {
                        return u;
                    },
                    OT: function() {
                        return f;
                    },
                    RJ: function() {
                        return c;
                    },
                    dx: function() {
                        return s;
                    },
                    sH: function() {
                        return a;
                    }
                });
                var r = n(3193), o = n(6718), i = n(5385);
                function a(e1) {
                    return e1.session.get().then(function(e1) {
                        return "ACTIVE" === e1.status;
                    }).catch(function() {
                        return !1;
                    });
                }
                function u(e1) {
                    return (0, i.U2)(e1, "/api/v1/sessions/me", {
                        withCredentials: !0
                    }).then(function(t) {
                        var n = (0, r.CE)(t, "_links");
                        return n.refresh = function() {
                            return (0, i.v_)(e1, (0, r.Rg)(t, "refresh").href, {}, {
                                withCredentials: !0
                            });
                        }, n.user = function() {
                            return (0, i.U2)(e1, (0, r.Rg)(t, "user").href, {
                                withCredentials: !0
                            });
                        }, n;
                    }).catch(function() {
                        return {
                            status: "INACTIVE"
                        };
                    });
                }
                function c(e1) {
                    return (0, i.c3)(e1, {
                        url: e1.getIssuerOrigin() + "/api/v1/sessions/me",
                        method: "DELETE",
                        withCredentials: !0
                    });
                }
                function s(e1) {
                    return (0, i.v_)(e1, "/api/v1/sessions/me/lifecycle/refresh", {}, {
                        withCredentials: !0
                    });
                }
                function f(e1, t, n) {
                    n = n || window.location.href, window.location.assign(e1.getIssuerOrigin() + "/login/sessionCookieRedirect" + (0, o.UK)({
                        checkAccountSetupComplete: !0,
                        token: t,
                        redirectUrl: n
                    }));
                }
            },
            2815: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    M: function() {
                        return o;
                    }
                });
                var r = n(3719);
                function o(e1) {
                    return {
                        close: r.RJ.bind(null, e1),
                        exists: r.sH.bind(null, e1),
                        get: r.Gg.bind(null, e1),
                        refresh: r.dx.bind(null, e1),
                        setCookieAndRedirect: r.OT.bind(null, e1)
                    };
                }
            },
            8041: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Gg: function() {
                        return r.Gg;
                    },
                    MG: function() {
                        return o.M;
                    },
                    OT: function() {
                        return r.OT;
                    },
                    RJ: function() {
                        return r.RJ;
                    },
                    Zg: function() {
                        return i.Z;
                    },
                    dx: function() {
                        return r.dx;
                    },
                    sH: function() {
                        return r.sH;
                    }
                });
                var r = n(3719), o = n(2815), i = n(3980);
            },
            3980: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return h;
                    }
                });
                var r = n(5861), o = n(5671), i = n(3144), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(4687), p = n.n(l), d = n(2815);
                function h(e1) {
                    return function(e1) {
                        (0, u.Z)(h, e1);
                        var t, n, l = (t = h, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, s.Z)(t);
                            if (n) {
                                var o = (0, s.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, c.Z)(this, e1);
                        });
                        function h() {
                            var e1;
                            (0, o.Z)(this, h);
                            for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                            return e1 = l.call.apply(l, [
                                this
                            ].concat(n)), (0, f.Z)((0, a.Z)(e1), "session", void 0), e1.session = (0, d.M)((0, a.Z)(e1)), e1;
                        }
                        return (0, i.Z)(h, [
                            {
                                key: "closeSession",
                                value: function() {
                                    var e1 = this;
                                    return this.session.close().then((0, r.Z)(p().mark(function t() {
                                        return p().wrap(function(t) {
                                            for(;;)switch(t.prev = t.next){
                                                case 0:
                                                    return e1.clearStorage(), t.abrupt("return", !0);
                                                case 2:
                                                case "end":
                                                    return t.stop();
                                            }
                                        }, t);
                                    }))).catch(function(e1) {
                                        if ("AuthApiError" === e1.name && "E0000007" === e1.errorCode) return !1;
                                        throw e1;
                                    });
                                }
                            }
                        ]), h;
                    }(e1);
                }
            },
            5437: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    V: function() {
                        return f;
                    },
                    W: function() {
                        return l;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(1971), u = n(5763), c = n(415), s = n(146);
                function f(e1) {
                    (0, c.isBrowser)() || e1.storageProvider || e1.storageKey || (0, s.ZK)("Memory storage can only support simple single user use case on server side, please provide custom storageProvider or storageKey if advanced scenarios need to be supported.");
                }
                var l = function() {
                    function e1(t, n, o) {
                        (0, r.Z)(this, e1), (0, i.Z)(this, "storageManagerOptions", void 0), (0, i.Z)(this, "cookieOptions", void 0), (0, i.Z)(this, "storageUtil", void 0), this.storageManagerOptions = t, this.cookieOptions = n, this.storageUtil = o;
                    }
                    return (0, o.Z)(e1, [
                        {
                            key: "getOptionsForSection",
                            value: function(e1, t) {
                                return Object.assign({}, this.storageManagerOptions[e1], t);
                            }
                        },
                        {
                            key: "getStorage",
                            value: function(e1) {
                                if ((e1 = Object.assign({}, this.cookieOptions, e1)).storageProvider) return e1.storageProvider;
                                var t = e1, n = t.storageType, r = t.storageTypes;
                                if ("sessionStorage" === n && (e1.sessionCookie = !0), n && r) {
                                    var o = r.indexOf(n);
                                    o >= 0 && (r = r.slice(o), n = void 0);
                                }
                                return n || (n = this.storageUtil.findStorageType(r)), this.storageUtil.getStorageByType(n, e1);
                            }
                        },
                        {
                            key: "getTokenStorage",
                            value: function(e1) {
                                f(e1 = this.getOptionsForSection("token", e1));
                                var t = this.getStorage(e1), n = e1.storageKey || a.TOKEN_STORAGE_NAME;
                                return new u._(t, n);
                            }
                        },
                        {
                            key: "getHttpCache",
                            value: function(e1) {
                                e1 = this.getOptionsForSection("cache", e1);
                                var t = this.getStorage(e1), n = e1.storageKey || a.CACHE_STORAGE_NAME;
                                return new u._(t, n);
                            }
                        }
                    ]), e1;
                }();
            },
            5763: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    _: function() {
                        return u;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(9123), u = function() {
                    function e1(t, n) {
                        if ((0, r.Z)(this, e1), (0, i.Z)(this, "storageProvider", void 0), (0, i.Z)(this, "storageName", void 0), !t) throw new a.Z('"storage" is required');
                        if ("string" != typeof n || !n.length) throw new a.Z('"storageName" is required');
                        this.storageName = n, this.storageProvider = t;
                    }
                    return (0, o.Z)(e1, [
                        {
                            key: "getItem",
                            value: function(e1) {
                                return this.getStorage()[e1];
                            }
                        },
                        {
                            key: "setItem",
                            value: function(e1, t) {
                                return this.updateStorage(e1, t);
                            }
                        },
                        {
                            key: "removeItem",
                            value: function(e1) {
                                return this.clearStorage(e1);
                            }
                        },
                        {
                            key: "getStorage",
                            value: function() {
                                var e1 = this.storageProvider.getItem(this.storageName);
                                e1 = e1 || "{}";
                                try {
                                    return JSON.parse(e1);
                                } catch (e1) {
                                    throw new a.Z("Unable to parse storage string: " + this.storageName);
                                }
                            }
                        },
                        {
                            key: "setStorage",
                            value: function(e1) {
                                try {
                                    var t = e1 ? JSON.stringify(e1) : "{}";
                                    this.storageProvider.setItem(this.storageName, t);
                                } catch (e1) {
                                    throw new a.Z("Unable to set storage: " + this.storageName);
                                }
                            }
                        },
                        {
                            key: "clearStorage",
                            value: function(e1) {
                                if (e1) {
                                    var t = this.getStorage();
                                    delete t[e1], this.setStorage(t);
                                } else this.storageProvider.removeItem ? this.storageProvider.removeItem(this.storageName) : this.setStorage();
                            }
                        },
                        {
                            key: "updateStorage",
                            value: function(e1, t) {
                                var n = this.getStorage();
                                n[e1] = t, this.setStorage(n);
                            }
                        }
                    ]), e1;
                }();
            },
            9927: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Ho: function() {
                        return i.H;
                    },
                    Tp: function() {
                        return r.T;
                    },
                    Vp: function() {
                        return o.V;
                    },
                    W8: function() {
                        return o.W;
                    },
                    _e: function() {
                        return a._;
                    }
                });
                var r = n(3849), o = n(5437), i = n(265), a = n(5763);
            },
            265: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    H: function() {
                        return f;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    return function(e1) {
                        (0, a.Z)(p, e1);
                        var n, f, l = (n = p, f = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, t = (0, c.Z)(n);
                            if (f) {
                                var r = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(t, arguments, r);
                            } else e1 = t.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function p() {
                            var e1;
                            (0, r.Z)(this, p);
                            for(var n = arguments.length, o = new Array(n), a = 0; a < n; a++)o[a] = arguments[a];
                            e1 = l.call.apply(l, [
                                this
                            ].concat(o)), (0, s.Z)((0, i.Z)(e1), "storageManager", void 0);
                            var u = e1.options, c = u.storageManager, f = u.cookies, d = u.storageUtil;
                            return e1.storageManager = new t(c, f, d), e1;
                        }
                        return (0, o.Z)(p, [
                            {
                                key: "clearStorage",
                                value: function() {}
                            }
                        ]), p;
                    }(e1);
                }
            },
            3849: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    T: function() {
                        return g;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(5093), l = n(146), p = n(4858), d = {
                    token: {
                        storageTypes: [
                            "localStorage",
                            "sessionStorage",
                            "cookie"
                        ]
                    },
                    cache: {
                        storageTypes: [
                            "localStorage",
                            "sessionStorage",
                            "cookie"
                        ]
                    },
                    transaction: {
                        storageTypes: [
                            "sessionStorage",
                            "localStorage",
                            "cookie"
                        ]
                    },
                    "shared-transaction": {
                        storageTypes: [
                            "localStorage"
                        ]
                    },
                    "original-uri": {
                        storageTypes: [
                            "localStorage"
                        ]
                    }
                }, h = n(415);
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function g() {
                    return function(e1) {
                        (0, a.Z)(v, e1);
                        var t, n, f = (t = v, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function v(e1) {
                            var t;
                            return (0, o.Z)(this, v), t = f.call(this, e1), (0, s.Z)((0, i.Z)(t), "cookies", void 0), (0, s.Z)((0, i.Z)(t), "storageUtil", void 0), (0, s.Z)((0, i.Z)(t), "storageManager", void 0), t.cookies = function() {
                                var e1 = arguments.length > 1 ? arguments[1] : void 0, t = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).cookies || {};
                                return void 0 === t.secure && (t.secure = e1), void 0 === t.sameSite && (t.sameSite = t.secure ? "none" : "lax"), t.secure && !e1 && ((0, l.ZK)('The current page is not being served with the HTTPS protocol.\nFor security reasons, we strongly recommend using HTTPS.\nIf you cannot use HTTPS, set "cookies.secure" option to false.'), t.secure = !1), "none" !== t.sameSite || t.secure || (t.sameSite = "lax"), t;
                            }(e1, (0, h.isHTTPS)()), t.storageUtil = e1.storageUtil || Object.assign({}, p.Z, {
                                inMemoryStore: {}
                            }), t.storageManager = y(y({}, d), e1.storageManager), t;
                        }
                        return (0, r.Z)(v);
                    }((0, f.X)());
                }
            },
            3548: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    b: function() {
                        return c;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(4771), u = n(146), c = function() {
                    function e1() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
                            quiet: !1
                        };
                        (0, r.Z)(this, e1), (0, i.Z)(this, "queue", void 0), (0, i.Z)(this, "running", void 0), (0, i.Z)(this, "options", void 0), this.queue = [], this.running = !1, this.options = t;
                    }
                    return (0, o.Z)(e1, [
                        {
                            key: "push",
                            value: function(e1, t) {
                                for(var n = this, r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++)o[i - 2] = arguments[i];
                                return new Promise(function(r, i) {
                                    n.queue.length > 0 && !1 !== n.options.quiet && (0, u.ZK)("Async method is being called but another async method is already running. The new method will be delayed until the previous method completes."), n.queue.push({
                                        method: e1,
                                        thisObject: t,
                                        args: o,
                                        resolve: r,
                                        reject: i
                                    }), n.run();
                                });
                            }
                        },
                        {
                            key: "run",
                            value: function() {
                                var e1 = this;
                                if (!this.running && 0 !== this.queue.length) {
                                    this.running = !0;
                                    var t = this.queue.shift(), n = t.method.apply(t.thisObject, t.args);
                                    (0, a.tI)(n) ? n.then(t.resolve, t.reject).finally(function() {
                                        e1.running = !1, e1.run();
                                    }) : (t.resolve(n), this.running = !1, this.run());
                                }
                            }
                        }
                    ]), e1;
                }();
            },
            146: function(e1, t, n) {
                "use strict";
                function r() {
                    return "undefined" != typeof window ? window.console : "undefined" != typeof console ? console : void 0;
                }
                function o() {
                    var e1 = r();
                    return e1 && e1.log ? e1 : {
                        log: function() {},
                        warn: function() {},
                        group: function() {},
                        groupEnd: function() {}
                    };
                }
                function i(e1) {
                    o().warn("[okta-auth-sdk] WARN: " + e1);
                }
                function a(e1) {
                    o().warn("[okta-auth-sdk] DEPRECATION: " + e1);
                }
                function u(e1, t) {
                    return function() {
                        return a(e1), t.apply(null, arguments);
                    };
                }
                n.d(t, {
                    Rn: function() {
                        return a;
                    },
                    VA: function() {
                        return u;
                    },
                    ZK: function() {
                        return i;
                    },
                    dr: function() {
                        return o;
                    },
                    sW: function() {
                        return r;
                    }
                });
            },
            305: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    BY: function() {
                        return c.BY;
                    },
                    CE: function() {
                        return i.CE;
                    },
                    HD: function() {
                        return u.HD;
                    },
                    Kn: function() {
                        return u.Kn;
                    },
                    QN: function() {
                        return c.QN;
                    },
                    Qj: function() {
                        return c.Qj;
                    },
                    Rg: function() {
                        return i.Rg;
                    },
                    Rn: function() {
                        return r.Rn;
                    },
                    UK: function() {
                        return c.UK;
                    },
                    VA: function() {
                        return r.VA;
                    },
                    YQ: function() {
                        return o.YQ;
                    },
                    YY: function() {
                        return i.YY;
                    },
                    ZK: function() {
                        return r.ZK;
                    },
                    ak: function() {
                        return i.ak;
                    },
                    bo: function() {
                        return a.b;
                    },
                    d9: function() {
                        return i.d9;
                    },
                    dr: function() {
                        return r.dr;
                    },
                    gw: function() {
                        return o.gw;
                    },
                    hj: function() {
                        return u.hj;
                    },
                    l7: function() {
                        return i.l7;
                    },
                    mf: function() {
                        return u.mf;
                    },
                    ng: function() {
                        return o.ng;
                    },
                    sD: function() {
                        return c.sD;
                    },
                    sE: function() {
                        return i.sE;
                    },
                    sW: function() {
                        return r.sW;
                    },
                    tI: function() {
                        return u.tI;
                    },
                    uh: function() {
                        return o.uh;
                    }
                });
                var r = n(146), o = n(8750), i = n(3193), a = n(3548), u = n(4771), c = n(6718);
            },
            8750: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    var t = e1.match(/\d+/g), n = Date.UTC(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
                    return new Date(n).toUTCString();
                }
                function o(e1) {
                    for(var t = "", n = 0; n < e1; ++n)t += "abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"[Math.floor(61 * Math.random())];
                    return t;
                }
                function i(e1) {
                    return new Promise(function(t) {
                        setTimeout(t, e1);
                    });
                }
                function a(e1, t) {
                    var n = e1.split(t);
                    return [
                        n[0],
                        n.splice(1, n.length).join(t)
                    ];
                }
                n.d(t, {
                    YQ: function() {
                        return a;
                    },
                    gw: function() {
                        return i;
                    },
                    ng: function() {
                        return r;
                    },
                    uh: function() {
                        return o;
                    }
                });
            },
            3193: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    var n = Array.prototype.slice.call(arguments, 2);
                    return function() {
                        var r = Array.prototype.slice.call(arguments);
                        return r = n.concat(r), e1.apply(t, r);
                    };
                }
                function o() {
                    var e1 = arguments[0];
                    return [].slice.call(arguments, 1).forEach(function(t) {
                        for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && void 0 !== t[n] && (e1[n] = t[n]);
                    }), e1;
                }
                function i(e1) {
                    var t = {};
                    for(var n in e1)if (Object.prototype.hasOwnProperty.call(e1, n)) {
                        var r = e1[n];
                        null != r && (t[n] = r);
                    }
                    return t;
                }
                function a(e1) {
                    if (e1) {
                        var t = JSON.stringify(e1);
                        if (t) return JSON.parse(t);
                    }
                    return e1;
                }
                function u(e1) {
                    for(var t = {}, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)r[o - 1] = arguments[o];
                    for(var i in e1)Object.prototype.hasOwnProperty.call(e1, i) && -1 == r.indexOf(i) && (t[i] = e1[i]);
                    return a(t);
                }
                function c(e1, t) {
                    for(var n = e1.length; n--;){
                        var r = e1[n], o = !0;
                        for(var i in t)if (Object.prototype.hasOwnProperty.call(t, i) && r[i] !== t[i]) {
                            o = !1;
                            break;
                        }
                        if (o) return r;
                    }
                }
                function s(e1, t, n) {
                    if (e1 && e1._links) {
                        var r = a(e1._links[t]);
                        return r && r.name && n ? r.name === n ? r : void 0 : r;
                    }
                }
                n.d(t, {
                    CE: function() {
                        return u;
                    },
                    Rg: function() {
                        return s;
                    },
                    YY: function() {
                        return i;
                    },
                    ak: function() {
                        return r;
                    },
                    d9: function() {
                        return a;
                    },
                    l7: function() {
                        return o;
                    },
                    sE: function() {
                        return c;
                    }
                });
            },
            4771: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return "[object String]" === Object.prototype.toString.call(e1);
                }
                function o(e1) {
                    return "[object Object]" === Object.prototype.toString.call(e1);
                }
                function i(e1) {
                    return "[object Number]" === Object.prototype.toString.call(e1);
                }
                function a(e1) {
                    return !!e1 && "[object Function]" === ({}).toString.call(e1);
                }
                function u(e1) {
                    return e1 && e1.finally && "function" == typeof e1.finally;
                }
                n.d(t, {
                    HD: function() {
                        return r;
                    },
                    Kn: function() {
                        return o;
                    },
                    hj: function() {
                        return i;
                    },
                    mf: function() {
                        return a;
                    },
                    tI: function() {
                        return u;
                    }
                });
            },
            6718: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return /^[a-z][a-z0-9+.-]*:/i.test(e1);
                }
                function o() {
                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t = arguments.length > 1 ? arguments[1] : void 0;
                    return r(e1) ? e1 : (t = u(t), "/" === e1[0] ? "".concat(t).concat(e1) : "".concat(t, "/").concat(e1));
                }
                function i() {
                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t = arguments.length > 1 ? arguments[1] : void 0;
                    return r(e1) && (e1 = e1.substring(t.length)), "/" === e1[0] ? e1 : "/".concat(e1);
                }
                function a(e1) {
                    var t = [];
                    if (null !== e1) for(var n in e1)Object.prototype.hasOwnProperty.call(e1, n) && void 0 !== e1[n] && null !== e1[n] && t.push(n + "=" + encodeURIComponent(e1[n]));
                    return t.length ? "?" + t.join("&") : "";
                }
                function u(e1) {
                    if (e1) {
                        var t = e1.replace(/^\s+|\s+$/gm, "");
                        return t.replace(/\/+$/, "");
                    }
                }
                n.d(t, {
                    BY: function() {
                        return o;
                    },
                    QN: function() {
                        return i;
                    },
                    Qj: function() {
                        return u;
                    },
                    UK: function() {
                        return a;
                    },
                    sD: function() {
                        return r;
                    }
                });
            },
            3615: function(e1, t, n) {
                "use strict";
                var r = n(6690), o = n(9728), i = n(1655), a = n(4993), u = n(3808);
                function c(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var s = function(e1) {
                    i(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = u(t);
                        if (n) {
                            var o = u(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return a(this, e1);
                    });
                    function s(e1) {
                        var t;
                        return r(this, s), (t = c.call(this, e1 || "Promise was canceled")).name = "CancelError", t;
                    }
                    return o(s, [
                        {
                            key: "isCanceled",
                            get: function() {
                                return !0;
                            }
                        }
                    ]), s;
                }(n(3496)(Error)), f = function() {
                    function e1(t) {
                        var n = this;
                        r(this, e1), this._cancelHandlers = [], this._isPending = !0, this._isCanceled = !1, this._rejectOnCancel = !0, this._promise = new Promise(function(e1, r) {
                            n._reject = r;
                            var o = function(e1) {
                                if (!n._isPending) throw new Error("The `onCancel` handler was attached after the promise settled.");
                                n._cancelHandlers.push(e1);
                            };
                            return Object.defineProperties(o, {
                                shouldReject: {
                                    get: function() {
                                        return n._rejectOnCancel;
                                    },
                                    set: function(e1) {
                                        n._rejectOnCancel = e1;
                                    }
                                }
                            }), t(function(t) {
                                n._isCanceled && o.shouldReject || (n._isPending = !1, e1(t));
                            }, function(e1) {
                                n._isPending = !1, r(e1);
                            }, o);
                        });
                    }
                    return o(e1, [
                        {
                            key: "then",
                            value: function(e1, t) {
                                return this._promise.then(e1, t);
                            }
                        },
                        {
                            key: "catch",
                            value: function(e1) {
                                return this._promise.catch(e1);
                            }
                        },
                        {
                            key: "finally",
                            value: function(e1) {
                                return this._promise.finally(e1);
                            }
                        },
                        {
                            key: "cancel",
                            value: function(e1) {
                                if (this._isPending && !this._isCanceled) {
                                    if (this._isCanceled = !0, this._cancelHandlers.length > 0) try {
                                        var t, n = function(e1, t) {
                                            var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                            if (!n) {
                                                if (Array.isArray(e1) || (n = function(e1, t) {
                                                    if (e1) {
                                                        if ("string" == typeof e1) return c(e1, t);
                                                        var n = Object.prototype.toString.call(e1).slice(8, -1);
                                                        return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? c(e1, t) : void 0;
                                                    }
                                                }(e1)) || t && e1 && "number" == typeof e1.length) {
                                                    n && (e1 = n);
                                                    var r = 0, o = function() {};
                                                    return {
                                                        s: o,
                                                        n: function() {
                                                            return r >= e1.length ? {
                                                                done: !0
                                                            } : {
                                                                done: !1,
                                                                value: e1[r++]
                                                            };
                                                        },
                                                        e: function(e1) {
                                                            throw e1;
                                                        },
                                                        f: o
                                                    };
                                                }
                                                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                            }
                                            var i, a = !0, u = !1;
                                            return {
                                                s: function() {
                                                    n = n.call(e1);
                                                },
                                                n: function() {
                                                    var e1 = n.next();
                                                    return a = e1.done, e1;
                                                },
                                                e: function(e1) {
                                                    u = !0, i = e1;
                                                },
                                                f: function() {
                                                    try {
                                                        a || null == n.return || n.return();
                                                    } finally{
                                                        if (u) throw i;
                                                    }
                                                }
                                            };
                                        }(this._cancelHandlers);
                                        try {
                                            for(n.s(); !(t = n.n()).done;)(0, t.value)();
                                        } catch (e1) {
                                            n.e(e1);
                                        } finally{
                                            n.f();
                                        }
                                    } catch (e1) {
                                        return void this._reject(e1);
                                    }
                                    this._rejectOnCancel && this._reject(new s(e1));
                                }
                            }
                        },
                        {
                            key: "isCanceled",
                            get: function() {
                                return this._isCanceled;
                            }
                        }
                    ], [
                        {
                            key: "fn",
                            value: function(t) {
                                return function() {
                                    for(var n = arguments.length, r = new Array(n), o = 0; o < n; o++)r[o] = arguments[o];
                                    return new e1(function(e1, n, o) {
                                        r.push(o), t.apply(void 0, r).then(e1, n);
                                    });
                                };
                            }
                        }
                    ]), e1;
                }();
                Object.setPrototypeOf(f.prototype, Promise.prototype), e1.exports = f, e1.exports.CancelError = s;
            },
            4098: function(e1, t) {
                var n = "undefined" != typeof self ? self : this, r = function() {
                    function e1() {
                        this.fetch = !1, this.DOMException = n.DOMException;
                    }
                    return e1.prototype = n, new e1;
                }();
                !function(e1) {
                    !function(t) {
                        var n = {
                            searchParams: "URLSearchParams" in e1,
                            iterable: "Symbol" in e1 && "iterator" in Symbol,
                            blob: "FileReader" in e1 && "Blob" in e1 && function() {
                                try {
                                    return new Blob, !0;
                                } catch (e1) {
                                    return !1;
                                }
                            }(),
                            formData: "FormData" in e1,
                            arrayBuffer: "ArrayBuffer" in e1
                        };
                        if (n.arrayBuffer) var r = [
                            "[object Int8Array]",
                            "[object Uint8Array]",
                            "[object Uint8ClampedArray]",
                            "[object Int16Array]",
                            "[object Uint16Array]",
                            "[object Int32Array]",
                            "[object Uint32Array]",
                            "[object Float32Array]",
                            "[object Float64Array]"
                        ], o = ArrayBuffer.isView || function(e1) {
                            return e1 && r.indexOf(Object.prototype.toString.call(e1)) > -1;
                        };
                        function i(e1) {
                            if ("string" != typeof e1 && (e1 = String(e1)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e1)) throw new TypeError("Invalid character in header field name");
                            return e1.toLowerCase();
                        }
                        function a(e1) {
                            return "string" != typeof e1 && (e1 = String(e1)), e1;
                        }
                        function u(e1) {
                            var t = {
                                next: function() {
                                    var t = e1.shift();
                                    return {
                                        done: void 0 === t,
                                        value: t
                                    };
                                }
                            };
                            return n.iterable && (t[Symbol.iterator] = function() {
                                return t;
                            }), t;
                        }
                        function c(e1) {
                            this.map = {}, e1 instanceof c ? e1.forEach(function(e1, t) {
                                this.append(t, e1);
                            }, this) : Array.isArray(e1) ? e1.forEach(function(e1) {
                                this.append(e1[0], e1[1]);
                            }, this) : e1 && Object.getOwnPropertyNames(e1).forEach(function(t) {
                                this.append(t, e1[t]);
                            }, this);
                        }
                        function s(e1) {
                            if (e1.bodyUsed) return Promise.reject(new TypeError("Already read"));
                            e1.bodyUsed = !0;
                        }
                        function f(e1) {
                            return new Promise(function(t, n) {
                                e1.onload = function() {
                                    t(e1.result);
                                }, e1.onerror = function() {
                                    n(e1.error);
                                };
                            });
                        }
                        function l(e1) {
                            var t = new FileReader, n = f(t);
                            return t.readAsArrayBuffer(e1), n;
                        }
                        function p(e1) {
                            if (e1.slice) return e1.slice(0);
                            var t = new Uint8Array(e1.byteLength);
                            return t.set(new Uint8Array(e1)), t.buffer;
                        }
                        function d() {
                            return this.bodyUsed = !1, this._initBody = function(e1) {
                                var t;
                                this._bodyInit = e1, e1 ? "string" == typeof e1 ? this._bodyText = e1 : n.blob && Blob.prototype.isPrototypeOf(e1) ? this._bodyBlob = e1 : n.formData && FormData.prototype.isPrototypeOf(e1) ? this._bodyFormData = e1 : n.searchParams && URLSearchParams.prototype.isPrototypeOf(e1) ? this._bodyText = e1.toString() : n.arrayBuffer && n.blob && (t = e1) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = p(e1.buffer), this._bodyInit = new Blob([
                                    this._bodyArrayBuffer
                                ])) : n.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(e1) || o(e1)) ? this._bodyArrayBuffer = p(e1) : this._bodyText = e1 = Object.prototype.toString.call(e1) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e1 ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : n.searchParams && URLSearchParams.prototype.isPrototypeOf(e1) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
                            }, n.blob && (this.blob = function() {
                                var e1 = s(this);
                                if (e1) return e1;
                                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                                if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                                    this._bodyArrayBuffer
                                ]));
                                if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                                return Promise.resolve(new Blob([
                                    this._bodyText
                                ]));
                            }, this.arrayBuffer = function() {
                                return this._bodyArrayBuffer ? s(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(l);
                            }), this.text = function() {
                                var e1, t, n, r = s(this);
                                if (r) return r;
                                if (this._bodyBlob) return e1 = this._bodyBlob, n = f(t = new FileReader), t.readAsText(e1), n;
                                if (this._bodyArrayBuffer) return Promise.resolve(function(e1) {
                                    for(var t = new Uint8Array(e1), n = new Array(t.length), r = 0; r < t.length; r++)n[r] = String.fromCharCode(t[r]);
                                    return n.join("");
                                }(this._bodyArrayBuffer));
                                if (this._bodyFormData) throw new Error("could not read FormData body as text");
                                return Promise.resolve(this._bodyText);
                            }, n.formData && (this.formData = function() {
                                return this.text().then(y);
                            }), this.json = function() {
                                return this.text().then(JSON.parse);
                            }, this;
                        }
                        c.prototype.append = function(e1, t) {
                            e1 = i(e1), t = a(t);
                            var n = this.map[e1];
                            this.map[e1] = n ? n + ", " + t : t;
                        }, c.prototype.delete = function(e1) {
                            delete this.map[i(e1)];
                        }, c.prototype.get = function(e1) {
                            return e1 = i(e1), this.has(e1) ? this.map[e1] : null;
                        }, c.prototype.has = function(e1) {
                            return this.map.hasOwnProperty(i(e1));
                        }, c.prototype.set = function(e1, t) {
                            this.map[i(e1)] = a(t);
                        }, c.prototype.forEach = function(e1, t) {
                            for(var n in this.map)this.map.hasOwnProperty(n) && e1.call(t, this.map[n], n, this);
                        }, c.prototype.keys = function() {
                            var e1 = [];
                            return this.forEach(function(t, n) {
                                e1.push(n);
                            }), u(e1);
                        }, c.prototype.values = function() {
                            var e1 = [];
                            return this.forEach(function(t) {
                                e1.push(t);
                            }), u(e1);
                        }, c.prototype.entries = function() {
                            var e1 = [];
                            return this.forEach(function(t, n) {
                                e1.push([
                                    n,
                                    t
                                ]);
                            }), u(e1);
                        }, n.iterable && (c.prototype[Symbol.iterator] = c.prototype.entries);
                        var h = [
                            "DELETE",
                            "GET",
                            "HEAD",
                            "OPTIONS",
                            "POST",
                            "PUT"
                        ];
                        function v(e1, t) {
                            var n, r, o = (t = t || {}).body;
                            if (e1 instanceof v) {
                                if (e1.bodyUsed) throw new TypeError("Already read");
                                this.url = e1.url, this.credentials = e1.credentials, t.headers || (this.headers = new c(e1.headers)), this.method = e1.method, this.mode = e1.mode, this.signal = e1.signal, o || null == e1._bodyInit || (o = e1._bodyInit, e1.bodyUsed = !0);
                            } else this.url = String(e1);
                            if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new c(t.headers)), this.method = (r = (n = t.method || this.method || "GET").toUpperCase(), h.indexOf(r) > -1 ? r : n), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && o) throw new TypeError("Body not allowed for GET or HEAD requests");
                            this._initBody(o);
                        }
                        function y(e1) {
                            var t = new FormData;
                            return e1.trim().split("&").forEach(function(e1) {
                                if (e1) {
                                    var n = e1.split("="), r = n.shift().replace(/\+/g, " "), o = n.join("=").replace(/\+/g, " ");
                                    t.append(decodeURIComponent(r), decodeURIComponent(o));
                                }
                            }), t;
                        }
                        function g(e1, t) {
                            t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new c(t.headers), this.url = t.url || "", this._initBody(e1);
                        }
                        v.prototype.clone = function() {
                            return new v(this, {
                                body: this._bodyInit
                            });
                        }, d.call(v.prototype), d.call(g.prototype), g.prototype.clone = function() {
                            return new g(this._bodyInit, {
                                status: this.status,
                                statusText: this.statusText,
                                headers: new c(this.headers),
                                url: this.url
                            });
                        }, g.error = function() {
                            var e1 = new g(null, {
                                status: 0,
                                statusText: ""
                            });
                            return e1.type = "error", e1;
                        };
                        var m = [
                            301,
                            302,
                            303,
                            307,
                            308
                        ];
                        g.redirect = function(e1, t) {
                            if (-1 === m.indexOf(t)) throw new RangeError("Invalid status code");
                            return new g(null, {
                                status: t,
                                headers: {
                                    location: e1
                                }
                            });
                        }, t.DOMException = e1.DOMException;
                        try {
                            new t.DOMException;
                        } catch (e1) {
                            t.DOMException = function(e1, t) {
                                this.message = e1, this.name = t;
                                var n = Error(e1);
                                this.stack = n.stack;
                            }, t.DOMException.prototype = Object.create(Error.prototype), t.DOMException.prototype.constructor = t.DOMException;
                        }
                        function b(e1, r) {
                            return new Promise(function(o, i) {
                                var a = new v(e1, r);
                                if (a.signal && a.signal.aborted) return i(new t.DOMException("Aborted", "AbortError"));
                                var u = new XMLHttpRequest;
                                function s() {
                                    u.abort();
                                }
                                u.onload = function() {
                                    var e1, t, n = {
                                        status: u.status,
                                        statusText: u.statusText,
                                        headers: (e1 = u.getAllResponseHeaders() || "", t = new c, e1.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function(e1) {
                                            var n = e1.split(":"), r = n.shift().trim();
                                            if (r) {
                                                var o = n.join(":").trim();
                                                t.append(r, o);
                                            }
                                        }), t)
                                    };
                                    n.url = "responseURL" in u ? u.responseURL : n.headers.get("X-Request-URL");
                                    var r = "response" in u ? u.response : u.responseText;
                                    o(new g(r, n));
                                }, u.onerror = function() {
                                    i(new TypeError("Network request failed"));
                                }, u.ontimeout = function() {
                                    i(new TypeError("Network request failed"));
                                }, u.onabort = function() {
                                    i(new t.DOMException("Aborted", "AbortError"));
                                }, u.open(a.method, a.url, !0), "include" === a.credentials ? u.withCredentials = !0 : "omit" === a.credentials && (u.withCredentials = !1), "responseType" in u && n.blob && (u.responseType = "blob"), a.headers.forEach(function(e1, t) {
                                    u.setRequestHeader(t, e1);
                                }), a.signal && (a.signal.addEventListener("abort", s), u.onreadystatechange = function() {
                                    4 === u.readyState && a.signal.removeEventListener("abort", s);
                                }), u.send(void 0 === a._bodyInit ? null : a._bodyInit);
                            });
                        }
                        b.polyfill = !0, e1.fetch || (e1.fetch = b, e1.Headers = c, e1.Request = v, e1.Response = g), t.Headers = c, t.Request = v, t.Response = g, t.fetch = b, Object.defineProperty(t, "__esModule", {
                            value: !0
                        });
                    }({});
                }(r), r.fetch.ponyfill = !0, delete r.fetch.polyfill;
                var o = r;
                (t = o.fetch).default = o.fetch, t.fetch = o.fetch, t.Headers = o.Headers, t.Request = o.Request, t.Response = o.Response, e1.exports = t;
            },
            4279: function(e1) {
                function t() {}
                t.prototype = {
                    on: function(e1, t, n) {
                        var r = this.e || (this.e = {});
                        return (r[e1] || (r[e1] = [])).push({
                            fn: t,
                            ctx: n
                        }), this;
                    },
                    once: function(e1, t, n) {
                        var r = this;
                        function o() {
                            r.off(e1, o), t.apply(n, arguments);
                        }
                        return o._ = t, this.on(e1, o, n);
                    },
                    emit: function(e1) {
                        for(var t = [].slice.call(arguments, 1), n = ((this.e || (this.e = {}))[e1] || []).slice(), r = 0, o = n.length; r < o; r++)n[r].fn.apply(n[r].ctx, t);
                        return this;
                    },
                    off: function(e1, t) {
                        var n = this.e || (this.e = {}), r = n[e1], o = [];
                        if (r && t) for(var i = 0, a = r.length; i < a; i++)r[i].fn !== t && r[i].fn._ !== t && o.push(r[i]);
                        return o.length ? n[e1] = o : delete n[e1], this;
                    }
                }, e1.exports = t;
            },
            6115: function(e1) {
                e1.exports = function(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            6690: function(e1) {
                e1.exports = function(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            3515: function(e1, t, n) {
                var r = n(9617), o = n(6015);
                e1.exports = function(e1, t, n) {
                    if (r()) return Reflect.construct.apply(null, arguments);
                    var i = [
                        null
                    ];
                    i.push.apply(i, t);
                    var a = new (e1.bind.apply(e1, i));
                    return n && o(a, n.prototype), a;
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            9728: function(e1, t, n) {
                var r = n(4062);
                function o(e1, t) {
                    for(var n = 0; n < t.length; n++){
                        var o = t[n];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, r(o.key), o);
                    }
                }
                e1.exports = function(e1, t, n) {
                    return t && o(e1.prototype, t), n && o(e1, n), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            3808: function(e1) {
                function t(n) {
                    return e1.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports, t(n);
                }
                e1.exports = t, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            1655: function(e1, t, n) {
                var r = n(6015);
                e1.exports = function(e1, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e1.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e1,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), t && r(e1, t);
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            6035: function(e1) {
                e1.exports = function(e1) {
                    try {
                        return -1 !== Function.toString.call(e1).indexOf("[native code]");
                    } catch (t) {
                        return "function" == typeof e1;
                    }
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            9617: function(e1) {
                function t() {
                    try {
                        var n = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (n) {}
                    return (e1.exports = t = function() {
                        return !!n;
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports)();
                }
                e1.exports = t, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            4993: function(e1, t, n) {
                var r = n(8698).default, o = n(6115);
                e1.exports = function(e1, t) {
                    if (t && ("object" == r(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return o(e1);
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            7061: function(e1, t, n) {
                var r = n(8698).default;
                function o() {
                    "use strict";
                    e1.exports = o = function() {
                        return n;
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
                    var t, n = {}, i = Object.prototype, a = i.hasOwnProperty, u = Object.defineProperty || function(e1, t, n) {
                        e1[t] = n.value;
                    }, c = "function" == typeof Symbol ? Symbol : {}, s = c.iterator || "@@iterator", f = c.asyncIterator || "@@asyncIterator", l = c.toStringTag || "@@toStringTag";
                    function p(e1, t, n) {
                        return Object.defineProperty(e1, t, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e1[t];
                    }
                    try {
                        p({}, "");
                    } catch (t) {
                        p = function(e1, t, n) {
                            return e1[t] = n;
                        };
                    }
                    function d(e1, t, n, r) {
                        var o = t && t.prototype instanceof k ? t : k, i = Object.create(o.prototype), a = new C(r || []);
                        return u(i, "_invoke", {
                            value: A(e1, n, a)
                        }), i;
                    }
                    function h(e1, t, n) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, n)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    n.wrap = d;
                    var v = "suspendedStart", y = "suspendedYield", g = "executing", m = "completed", b = {};
                    function k() {}
                    function w() {}
                    function O() {}
                    var Z = {};
                    p(Z, s, function() {
                        return this;
                    });
                    var T = Object.getPrototypeOf, E = T && T(T(I([])));
                    E && E !== i && a.call(E, s) && (Z = E);
                    var S = O.prototype = k.prototype = Object.create(Z);
                    function P(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            p(e1, t, function(e1) {
                                return this._invoke(t, e1);
                            });
                        });
                    }
                    function x(e1, t) {
                        function n(o, i, u, c) {
                            var s = h(e1[o], e1, i);
                            if ("throw" !== s.type) {
                                var f = s.arg, l = f.value;
                                return l && "object" == r(l) && a.call(l, "__await") ? t.resolve(l.__await).then(function(e1) {
                                    n("next", e1, u, c);
                                }, function(e1) {
                                    n("throw", e1, u, c);
                                }) : t.resolve(l).then(function(e1) {
                                    f.value = e1, u(f);
                                }, function(e1) {
                                    return n("throw", e1, u, c);
                                });
                            }
                            c(s.arg);
                        }
                        var o;
                        u(this, "_invoke", {
                            value: function(e1, r) {
                                function i() {
                                    return new t(function(t, o) {
                                        n(e1, r, t, o);
                                    });
                                }
                                return o = o ? o.then(i, i) : i();
                            }
                        });
                    }
                    function A(e1, n, r) {
                        var o = v;
                        return function(i, a) {
                            if (o === g) throw Error("Generator is already running");
                            if (o === m) {
                                if ("throw" === i) throw a;
                                return {
                                    value: t,
                                    done: !0
                                };
                            }
                            for(r.method = i, r.arg = a;;){
                                var u = r.delegate;
                                if (u) {
                                    var c = R(u, r);
                                    if (c) {
                                        if (c === b) continue;
                                        return c;
                                    }
                                }
                                if ("next" === r.method) r.sent = r._sent = r.arg;
                                else if ("throw" === r.method) {
                                    if (o === v) throw o = m, r.arg;
                                    r.dispatchException(r.arg);
                                } else "return" === r.method && r.abrupt("return", r.arg);
                                o = g;
                                var s = h(e1, n, r);
                                if ("normal" === s.type) {
                                    if (o = r.done ? m : y, s.arg === b) continue;
                                    return {
                                        value: s.arg,
                                        done: r.done
                                    };
                                }
                                "throw" === s.type && (o = m, r.method = "throw", r.arg = s.arg);
                            }
                        };
                    }
                    function R(e1, n) {
                        var r = n.method, o = e1.iterator[r];
                        if (o === t) return n.delegate = null, "throw" === r && e1.iterator.return && (n.method = "return", n.arg = t, R(e1, n), "throw" === n.method) || "return" !== r && (n.method = "throw", n.arg = new TypeError("The iterator does not provide a '" + r + "' method")), b;
                        var i = h(o, e1.iterator, n.arg);
                        if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, b;
                        var a = i.arg;
                        return a ? a.done ? (n[e1.resultName] = a.value, n.next = e1.nextLoc, "return" !== n.method && (n.method = "next", n.arg = t), n.delegate = null, b) : a : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, b);
                    }
                    function _(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function j(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function C(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(_, this), this.reset(!0);
                    }
                    function I(e1) {
                        if (e1 || "" === e1) {
                            var n = e1[s];
                            if (n) return n.call(e1);
                            if ("function" == typeof e1.next) return e1;
                            if (!isNaN(e1.length)) {
                                var o = -1, i = function n() {
                                    for(; ++o < e1.length;)if (a.call(e1, o)) return n.value = e1[o], n.done = !1, n;
                                    return n.value = t, n.done = !0, n;
                                };
                                return i.next = i;
                            }
                        }
                        throw new TypeError(r(e1) + " is not iterable");
                    }
                    return w.prototype = O, u(S, "constructor", {
                        value: O,
                        configurable: !0
                    }), u(O, "constructor", {
                        value: w,
                        configurable: !0
                    }), w.displayName = p(O, l, "GeneratorFunction"), n.isGeneratorFunction = function(e1) {
                        var t = "function" == typeof e1 && e1.constructor;
                        return !!t && (t === w || "GeneratorFunction" === (t.displayName || t.name));
                    }, n.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, O) : (e1.__proto__ = O, p(e1, l, "GeneratorFunction")), e1.prototype = Object.create(S), e1;
                    }, n.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, P(x.prototype), p(x.prototype, f, function() {
                        return this;
                    }), n.AsyncIterator = x, n.async = function(e1, t, r, o, i) {
                        void 0 === i && (i = Promise);
                        var a = new x(d(e1, t, r, o), i);
                        return n.isGeneratorFunction(t) ? a : a.next().then(function(e1) {
                            return e1.done ? e1.value : a.next();
                        });
                    }, P(S), p(S, l, "Generator"), p(S, s, function() {
                        return this;
                    }), p(S, "toString", function() {
                        return "[object Generator]";
                    }), n.keys = function(e1) {
                        var t = Object(e1), n = [];
                        for(var r in t)n.push(r);
                        return n.reverse(), function e1() {
                            for(; n.length;){
                                var r = n.pop();
                                if (r in t) return e1.value = r, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, n.values = I, C.prototype = {
                        constructor: C,
                        reset: function(e1) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(j), !e1) for(var n in this)"t" === n.charAt(0) && a.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(e1) {
                            if (this.done) throw e1;
                            var n = this;
                            function r(r, o) {
                                return u.type = "throw", u.arg = e1, n.next = r, o && (n.method = "next", n.arg = t), !!o;
                            }
                            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                                var i = this.tryEntries[o], u = i.completion;
                                if ("root" === i.tryLoc) return r("end");
                                if (i.tryLoc <= this.prev) {
                                    var c = a.call(i, "catchLoc"), s = a.call(i, "finallyLoc");
                                    if (c && s) {
                                        if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                                        if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                                    } else if (c) {
                                        if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                                    } else {
                                        if (!s) throw Error("try statement without catch or finally");
                                        if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var n = this.tryEntries.length - 1; n >= 0; --n){
                                var r = this.tryEntries[n];
                                if (r.tryLoc <= this.prev && a.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                                    var o = r;
                                    break;
                                }
                            }
                            o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var i = o ? o.completion : {};
                            return i.type = e1, i.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, b) : this.complete(i);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), b;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var n = this.tryEntries[t];
                                if (n.finallyLoc === e1) return this.complete(n.completion, n.afterLoc), j(n), b;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var n = this.tryEntries[t];
                                if (n.tryLoc === e1) {
                                    var r = n.completion;
                                    if ("throw" === r.type) {
                                        var o = r.arg;
                                        j(n);
                                    }
                                    return o;
                                }
                            }
                            throw Error("illegal catch attempt");
                        },
                        delegateYield: function(e1, n, r) {
                            return this.delegate = {
                                iterator: I(e1),
                                resultName: n,
                                nextLoc: r
                            }, "next" === this.method && (this.arg = t), b;
                        }
                    }, n;
                }
                e1.exports = o, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            6015: function(e1) {
                function t(n, r) {
                    return e1.exports = t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e1, t) {
                        return e1.__proto__ = t, e1;
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports, t(n, r);
                }
                e1.exports = t, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            5036: function(e1, t, n) {
                var r = n(8698).default;
                e1.exports = function(e1, t) {
                    if ("object" != r(e1) || !e1) return e1;
                    var n = e1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var o = n.call(e1, t || "default");
                        if ("object" != r(o)) return o;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === t ? String : Number)(e1);
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            4062: function(e1, t, n) {
                var r = n(8698).default, o = n(5036);
                e1.exports = function(e1) {
                    var t = o(e1, "string");
                    return "symbol" == r(t) ? t : t + "";
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            8698: function(e1) {
                function t(n) {
                    return e1.exports = t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports, t(n);
                }
                e1.exports = t, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            3496: function(e1, t, n) {
                var r = n(3808), o = n(6015), i = n(6035), a = n(3515);
                function u(t) {
                    var n = "function" == typeof Map ? new Map : void 0;
                    return e1.exports = u = function(e1) {
                        if (null === e1 || !i(e1)) return e1;
                        if ("function" != typeof e1) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== n) {
                            if (n.has(e1)) return n.get(e1);
                            n.set(e1, t);
                        }
                        function t() {
                            return a(e1, arguments, r(this).constructor);
                        }
                        return t.prototype = Object.create(e1.prototype, {
                            constructor: {
                                value: t,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), o(t, e1);
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports, u(t);
                }
                e1.exports = u, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            4687: function(e1, t, n) {
                var r = n(7061)();
                e1.exports = r;
                try {
                    regeneratorRuntime = r;
                } catch (e1) {
                    "object" == typeof globalThis ? globalThis.regeneratorRuntime = r : Function("r", "regeneratorRuntime = r")(r);
                }
            },
            907: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            7326: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            5861: function(e1, t, n) {
                "use strict";
                function r(e1, t, n, r, o, i, a) {
                    try {
                        var u = e1[i](a), c = u.value;
                    } catch (e1) {
                        return void n(e1);
                    }
                    u.done ? t(c) : Promise.resolve(c).then(r, o);
                }
                function o(e1) {
                    return function() {
                        var t = this, n = arguments;
                        return new Promise(function(o, i) {
                            var a = e1.apply(t, n);
                            function u(e1) {
                                r(a, o, i, u, c, "next", e1);
                            }
                            function c(e1) {
                                r(a, o, i, u, c, "throw", e1);
                            }
                            u(void 0);
                        });
                    };
                }
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
            },
            5671: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            3144: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return i;
                    }
                });
                var r = n(9142);
                function o(e1, t) {
                    for(var n = 0; n < t.length; n++){
                        var o = t[n];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, (0, r.Z)(o.key), o);
                    }
                }
                function i(e1, t, n) {
                    return t && o(e1.prototype, t), n && o(e1, n), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }
            },
            4942: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(9142);
                function o(e1, t, n) {
                    return (t = (0, r.Z)(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = n, e1;
                }
            },
            1752: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(1120);
                function o() {
                    return o = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e1, t, n) {
                        var o = function(e1, t) {
                            for(; !({}).hasOwnProperty.call(e1, t) && null !== (e1 = (0, r.Z)(e1)););
                            return e1;
                        }(e1, t);
                        if (o) {
                            var i = Object.getOwnPropertyDescriptor(o, t);
                            return i.get ? i.get.call(arguments.length < 3 ? e1 : n) : i.value;
                        }
                    }, o.apply(null, arguments);
                }
            },
            1120: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return r = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    }, r(e1);
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            136: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(9611);
                function o(e1, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e1.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e1,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), t && (0, r.Z)(e1, t);
                }
            },
            4925: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    if (null == e1) return {};
                    var n, r, o = function(e1, t) {
                        if (null == e1) return {};
                        var n = {};
                        for(var r in e1)if (({}).hasOwnProperty.call(e1, r)) {
                            if (-1 !== t.indexOf(r)) continue;
                            n[r] = e1[r];
                        }
                        return n;
                    }(e1, t);
                    if (Object.getOwnPropertySymbols) {
                        var i = Object.getOwnPropertySymbols(e1);
                        for(r = 0; r < i.length; r++)n = i[r], -1 === t.indexOf(n) && ({}).propertyIsEnumerable.call(e1, n) && (o[n] = e1[n]);
                    }
                    return o;
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            2963: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return i;
                    }
                });
                var r = n(1002), o = n(7326);
                function i(e1, t) {
                    if (t && ("object" == (0, r.Z)(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return (0, o.Z)(e1);
                }
            },
            9611: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    return r = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e1, t) {
                        return e1.__proto__ = t, e1;
                    }, r(e1, t);
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            885: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(181);
                function o(e1, t) {
                    return function(e1) {
                        if (Array.isArray(e1)) return e1;
                    }(e1) || function(e1, t) {
                        var n = null == e1 ? null : "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                        if (null != n) {
                            var r, o, i, a, u = [], c = !0, s = !1;
                            try {
                                if (i = (n = n.call(e1)).next, 0 === t) {
                                    if (Object(n) !== n) return;
                                    c = !1;
                                } else for(; !(c = (r = i.call(n)).done) && (u.push(r.value), u.length !== t); c = !0);
                            } catch (e1) {
                                s = !0, o = e1;
                            } finally{
                                try {
                                    if (!c && null != n.return && (a = n.return(), Object(a) !== a)) return;
                                } finally{
                                    if (s) throw o;
                                }
                            }
                            return u;
                        }
                    }(e1, t) || (0, r.Z)(e1, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
            },
            2982: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return i;
                    }
                });
                var r = n(907), o = n(181);
                function i(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) return (0, r.Z)(e1);
                    }(e1) || function(e1) {
                        if ("undefined" != typeof Symbol && null != e1[Symbol.iterator] || null != e1["@@iterator"]) return Array.from(e1);
                    }(e1) || (0, o.Z)(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
            },
            9142: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(1002);
                function o(e1) {
                    var t = function(e1, t) {
                        if ("object" != (0, r.Z)(e1) || !e1) return e1;
                        var n = e1[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var o = n.call(e1, "string");
                            if ("object" != (0, r.Z)(o)) return o;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" == (0, r.Z)(t) ? t : t + "";
                }
            },
            1002: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, r(e1);
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            181: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(907);
                function o(e1, t) {
                    if (e1) {
                        if ("string" == typeof e1) return (0, r.Z)(e1, t);
                        var n = ({}).toString.call(e1).slice(8, -1);
                        return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? (0, r.Z)(e1, t) : void 0;
                    }
                }
            }
        }, t = {};
        function n(r) {
            var o = t[r];
            if (void 0 !== o) return o.exports;
            var i = t[r] = {
                exports: {}
            };
            return e1[r].call(i.exports, i, i.exports, n), i.exports;
        }
        n.n = function(e1) {
            var t = e1 && e1.__esModule ? function() {
                return e1.default;
            } : function() {
                return e1;
            };
            return n.d(t, {
                a: t
            }), t;
        }, n.d = function(e1, t) {
            for(var r in t)n.o(t, r) && !n.o(e1, r) && Object.defineProperty(e1, r, {
                enumerable: !0,
                get: t[r]
            });
        }, n.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e1) {
                if ("object" == typeof window) return window;
            }
        }(), n.o = function(e1, t) {
            return Object.prototype.hasOwnProperty.call(e1, t);
        }, n.r = function(e1) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e1, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e1, "__esModule", {
                value: !0
            });
        };
        var r = {};
        return function() {
            "use strict";
            n.r(r), n.d(r, {
                AuthenticatorKey: function() {
                    return y.pc;
                },
                EmailRole: function() {
                    return g.aw;
                },
                IdxFeature: function() {
                    return y.Fw;
                },
                IdxStatus: function() {
                    return y.Qd;
                },
                OktaAuth: function() {
                    return T;
                },
                PasswordStatus: function() {
                    return g.Fn;
                },
                Status: function() {
                    return g.qb;
                },
                addEmail: function() {
                    return g.no;
                },
                addPhone: function() {
                    return g.Z1;
                },
                authenticate: function() {
                    return y.YR;
                },
                canProceed: function() {
                    return y.Ch;
                },
                cancel: function() {
                    return y.al;
                },
                clearTransactionMeta: function() {
                    return y.Jm;
                },
                createAuthnTransactionAPI: function() {
                    return m.b;
                },
                createIdxAPI: function() {
                    return y.F4;
                },
                createIdxOptionsConstructor: function() {
                    return y.SL;
                },
                createIdxStorageManager: function() {
                    return y.aT;
                },
                createIdxTransactionManager: function() {
                    return y.vK;
                },
                createMinimalOktaAuthIdx: function() {
                    return y.UB;
                },
                createOktaAuthIdx: function() {
                    return y.Yn;
                },
                createOktaAuthMyAccount: function() {
                    return g.Xc;
                },
                createTransactionMeta: function() {
                    return y.Xc;
                },
                deleteEmail: function() {
                    return g.nd;
                },
                deletePassword: function() {
                    return g.QN;
                },
                deletePhone: function() {
                    return g.qj;
                },
                enrollPassword: function() {
                    return g.xg;
                },
                getEmail: function() {
                    return g.OD;
                },
                getEmailChallenge: function() {
                    return g.hG;
                },
                getEmails: function() {
                    return g.G5;
                },
                getPassword: function() {
                    return g.Ij;
                },
                getPhone: function() {
                    return g.u_;
                },
                getPhones: function() {
                    return g.Po;
                },
                getProfile: function() {
                    return g.Ai;
                },
                getProfileSchema: function() {
                    return g.aF;
                },
                getSavedTransactionMeta: function() {
                    return y.uN;
                },
                getTransactionMeta: function() {
                    return y.Co;
                },
                handleEmailVerifyCallback: function() {
                    return y.Jn;
                },
                handleInteractionCodeRedirect: function() {
                    return y.Xx;
                },
                hasSavedInteractionHandle: function() {
                    return y.$0;
                },
                interact: function() {
                    return y.EW;
                },
                introspect: function() {
                    return y.L8;
                },
                isAuthenticator: function() {
                    return y.H;
                },
                isEmailVerifyCallback: function() {
                    return y.GA;
                },
                isEmailVerifyCallbackError: function() {
                    return y.gc;
                },
                isTransactionMetaValid: function() {
                    return y.Wf;
                },
                isTransactionMetaValidForFlow: function() {
                    return y.bl;
                },
                isTransactionMetaValidForOptions: function() {
                    return y.UC;
                },
                mixinAuthn: function() {
                    return m.t;
                },
                mixinIdx: function() {
                    return y.B_;
                },
                mixinMyAccount: function() {
                    return g.HT;
                },
                parseEmailVerifyCallback: function() {
                    return y.mo;
                },
                poll: function() {
                    return y.$l;
                },
                proceed: function() {
                    return y.xc;
                },
                recoverPassword: function() {
                    return y.M4;
                },
                register: function() {
                    return y.z2;
                },
                saveTransactionMeta: function() {
                    return y.r0;
                },
                sendEmailChallenge: function() {
                    return g.ME;
                },
                sendPhoneChallenge: function() {
                    return g.dv;
                },
                startTransaction: function() {
                    return y.Yr;
                },
                unlockAccount: function() {
                    return y.le;
                },
                updatePassword: function() {
                    return g.gQ;
                },
                updateProfile: function() {
                    return g.ck;
                },
                verifyEmailChallenge: function() {
                    return g.T8;
                },
                verifyPhoneChallenge: function() {
                    return g.Lo;
                }
            });
            var e1 = n(3144), t = n(5671), o = n(136), i = n(2963), a = n(1120), u = n(4602), c = n(4143), s = n(3334), f = n(2144), l = n(6794), p = n(3164), d = n(6736), h = {};
            for(var v in d)[
                "default",
                "OktaAuth"
            ].indexOf(v) < 0 && (h[v] = (function(e1) {
                return d[e1];
            }).bind(0, v));
            n.d(r, h);
            var y = n(9999), g = n(1132), m = n(3398);
            var b = (0, u.S)(), k = (0, c.a)(), w = (0, s.v)(), O = (0, f.Y)(k, b, w), Z = (0, l.H)(O), T = function(n) {
                (0, o.Z)(s, n);
                var r, u, c = (r = s, u = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e1) {
                        return !1;
                    }
                }(), function() {
                    var e1, t = (0, a.Z)(r);
                    if (u) {
                        var n = (0, a.Z)(this).constructor;
                        e1 = Reflect.construct(t, arguments, n);
                    } else e1 = t.apply(this, arguments);
                    return (0, i.Z)(this, e1);
                });
                function s(e1) {
                    return (0, t.Z)(this, s), c.call(this, e1);
                }
                return (0, e1.Z)(s);
            }((0, p.t)(Z));
            r.default = T;
        }(), r;
    }();
});


function $fbd5e24ff0a9301a$export$2e2bcd8739ae039(v1, v2) {
    // validate input and split into segments
    const n1 = $fbd5e24ff0a9301a$var$validateAndParse(v1);
    const n2 = $fbd5e24ff0a9301a$var$validateAndParse(v2);
    // pop off the patch
    const p1 = n1.pop();
    const p2 = n2.pop();
    // validate numbers
    const r = $fbd5e24ff0a9301a$var$compareSegments(n1, n2);
    if (r !== 0) return r;
    // validate pre-release
    if (p1 && p2) return $fbd5e24ff0a9301a$var$compareSegments(p1.split('.'), p2.split('.'));
    else if (p1 || p2) return p1 ? -1 : 1;
    return 0;
}
const $fbd5e24ff0a9301a$export$a22775fa5e2eebd9 = (v)=>typeof v === 'string' && /^[v\d]/.test(v) && $fbd5e24ff0a9301a$var$semver.test(v);
const $fbd5e24ff0a9301a$export$398604a469f7de9a = (v1, v2, operator)=>{
    // validate input operator
    $fbd5e24ff0a9301a$var$assertValidOperator(operator);
    // since result of compareVersions can only be -1 or 0 or 1
    // a simple map can be used to replace switch
    const res = $fbd5e24ff0a9301a$export$2e2bcd8739ae039(v1, v2);
    return $fbd5e24ff0a9301a$var$operatorResMap[operator].includes(res);
};
const $fbd5e24ff0a9301a$export$b8fab89fe6d5d7da = (v, r)=>{
    // if no range operator then "="
    const m = r.match(/^([<>=~^]+)/);
    const op = m ? m[1] : '=';
    // if gt/lt/eq then operator compare
    if (op !== '^' && op !== '~') return $fbd5e24ff0a9301a$export$398604a469f7de9a(v, r, op);
    // else range of either "~" or "^" is assumed
    const [v1, v2, v3] = $fbd5e24ff0a9301a$var$validateAndParse(v);
    const [r1, r2, r3] = $fbd5e24ff0a9301a$var$validateAndParse(r);
    if ($fbd5e24ff0a9301a$var$compareStrings(v1, r1) !== 0) return false;
    if (op === '^') return $fbd5e24ff0a9301a$var$compareSegments([
        v2,
        v3
    ], [
        r2,
        r3
    ]) >= 0;
    if ($fbd5e24ff0a9301a$var$compareStrings(v2, r2) !== 0) return false;
    return $fbd5e24ff0a9301a$var$compareStrings(v3, r3) >= 0;
};
// export CJS style for parity
$fbd5e24ff0a9301a$export$2e2bcd8739ae039.validate = $fbd5e24ff0a9301a$export$a22775fa5e2eebd9;
$fbd5e24ff0a9301a$export$2e2bcd8739ae039.compare = $fbd5e24ff0a9301a$export$398604a469f7de9a;
$fbd5e24ff0a9301a$export$2e2bcd8739ae039.satisfies = $fbd5e24ff0a9301a$export$b8fab89fe6d5d7da;
const $fbd5e24ff0a9301a$var$semver = /^[v^~<>=]*?(\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+))?(?:-([\da-z\-]+(?:\.[\da-z\-]+)*))?(?:\+[\da-z\-]+(?:\.[\da-z\-]+)*)?)?)?$/i;
const $fbd5e24ff0a9301a$var$validateAndParse = (v)=>{
    if (typeof v !== 'string') throw new TypeError('Invalid argument expected string');
    const match = v.match($fbd5e24ff0a9301a$var$semver);
    if (!match) throw new Error(`Invalid argument not valid semver ('${v}' received)`);
    match.shift();
    return match;
};
const $fbd5e24ff0a9301a$var$isWildcard = (s)=>s === '*' || s === 'x' || s === 'X';
const $fbd5e24ff0a9301a$var$tryParse = (v)=>{
    const n = parseInt(v, 10);
    return isNaN(n) ? v : n;
};
const $fbd5e24ff0a9301a$var$forceType = (a, b)=>typeof a !== typeof b ? [
        String(a),
        String(b)
    ] : [
        a,
        b
    ];
const $fbd5e24ff0a9301a$var$compareStrings = (a, b)=>{
    if ($fbd5e24ff0a9301a$var$isWildcard(a) || $fbd5e24ff0a9301a$var$isWildcard(b)) return 0;
    const [ap, bp] = $fbd5e24ff0a9301a$var$forceType($fbd5e24ff0a9301a$var$tryParse(a), $fbd5e24ff0a9301a$var$tryParse(b));
    if (ap > bp) return 1;
    if (ap < bp) return -1;
    return 0;
};
const $fbd5e24ff0a9301a$var$compareSegments = (a, b)=>{
    for(let i = 0; i < Math.max(a.length, b.length); i++){
        const r = $fbd5e24ff0a9301a$var$compareStrings(a[i] || 0, b[i] || 0);
        if (r !== 0) return r;
    }
    return 0;
};
const $fbd5e24ff0a9301a$var$operatorResMap = {
    '>': [
        1
    ],
    '>=': [
        0,
        1
    ],
    '=': [
        0
    ],
    '<=': [
        -1,
        0
    ],
    '<': [
        -1
    ]
};
const $fbd5e24ff0a9301a$var$allowedOperators = Object.keys($fbd5e24ff0a9301a$var$operatorResMap);
const $fbd5e24ff0a9301a$var$assertValidOperator = (op)=>{
    if (typeof op !== 'string') throw new TypeError(`Invalid operator type, expected string but got ${typeof op}`);
    if ($fbd5e24ff0a9301a$var$allowedOperators.indexOf(op) === -1) throw new Error(`Invalid operator, expected one of ${$fbd5e24ff0a9301a$var$allowedOperators.join('|')}`);
};


var $1601eaa94f23093c$exports = {};
var $62b3522078ca1220$exports = {};

var $f7sIv = parcelRequire("f7sIv");
var $62b3522078ca1220$var$_typeof = $f7sIv.default;
var $40a29ba0a5571f92$exports = {};

var $f7sIv = parcelRequire("f7sIv");
var $40a29ba0a5571f92$var$_typeof = $f7sIv.default;
function $40a29ba0a5571f92$var$toPrimitive(t, r) {
    if ("object" != $40a29ba0a5571f92$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $40a29ba0a5571f92$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$40a29ba0a5571f92$exports = $40a29ba0a5571f92$var$toPrimitive, $40a29ba0a5571f92$exports.__esModule = true, $40a29ba0a5571f92$exports["default"] = $40a29ba0a5571f92$exports;


function $62b3522078ca1220$var$toPropertyKey(t) {
    var i = $40a29ba0a5571f92$exports(t, "string");
    return "symbol" == $62b3522078ca1220$var$_typeof(i) ? i : i + "";
}
$62b3522078ca1220$exports = $62b3522078ca1220$var$toPropertyKey, $62b3522078ca1220$exports.__esModule = true, $62b3522078ca1220$exports["default"] = $62b3522078ca1220$exports;


function $1601eaa94f23093c$var$_defineProperty(e, r, t) {
    return (r = $62b3522078ca1220$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$1601eaa94f23093c$exports = $1601eaa94f23093c$var$_defineProperty, $1601eaa94f23093c$exports.__esModule = true, $1601eaa94f23093c$exports["default"] = $1601eaa94f23093c$exports;


var $64cb28f478a17aa0$exports = {};
var $497c0a290ba24a51$exports = {};
function $497c0a290ba24a51$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
$497c0a290ba24a51$exports = $497c0a290ba24a51$var$_objectWithoutPropertiesLoose, $497c0a290ba24a51$exports.__esModule = true, $497c0a290ba24a51$exports["default"] = $497c0a290ba24a51$exports;


function $64cb28f478a17aa0$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $497c0a290ba24a51$exports(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$64cb28f478a17aa0$exports = $64cb28f478a17aa0$var$_objectWithoutProperties, $64cb28f478a17aa0$exports.__esModule = true, $64cb28f478a17aa0$exports["default"] = $64cb28f478a17aa0$exports;



var $6mt9R = parcelRequire("6mt9R");
var $4df32aa15a91038c$export$df9a5fb346e7c0bb = /*#__PURE__*/ $ieT14.createContext(null);
var $4df32aa15a91038c$export$2ae4a19e09ca9a00 = function useOktaAuth() {
    return $ieT14.useContext($4df32aa15a91038c$export$df9a5fb346e7c0bb);
};
var $4df32aa15a91038c$var$OktaError = function OktaError(_ref) {
    var error = _ref.error;
    if (error.name && error.message) return /*#__PURE__*/ $ieT14.createElement("p", null, error.name, ": ", error.message);
    return /*#__PURE__*/ $ieT14.createElement("p", null, "Error: ", error.toString());
};
var $4df32aa15a91038c$export$9fb697de7778c436 = function Security(_ref) {
    var oktaAuth = _ref.oktaAuth, restoreOriginalUri = _ref.restoreOriginalUri, onAuthRequired = _ref.onAuthRequired, children = _ref.children;
    var _React$useState = $ieT14.useState(function() {
        if (!oktaAuth) return null;
        return oktaAuth.authStateManager.getAuthState();
    }), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($bc640ab0637076b3$exports)))(_React$useState, 2), authState = _React$useState2[0], setAuthState = _React$useState2[1];
    $ieT14.useEffect(function() {
        if (!oktaAuth || !restoreOriginalUri) return;
        if (oktaAuth.options.restoreOriginalUri) console.warn('Two custom restoreOriginalUri callbacks are detected. The one from the OktaAuth configuration will be overridden by the provided restoreOriginalUri prop from the Security component.');
        oktaAuth.options.restoreOriginalUri = /*#__PURE__*/ function() {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($a4a11e297e121f39$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($afbd3bca675d3652$exports))).mark(function _callee(oktaAuth, originalUri) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($afbd3bca675d3652$exports))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            return _context.abrupt("return", restoreOriginalUri(oktaAuth, originalUri));
                        case 1:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x, _x2) {
                return _ref2.apply(this, arguments);
            };
        }();
    }, []);
    $ieT14.useEffect(function() {
        if (!oktaAuth) return;
        if (oktaAuth._oktaUserAgent) oktaAuth._oktaUserAgent.addEnvironment("@okta/okta-react".concat("/", "6.11.0"));
        else console.warn('_oktaUserAgent is not available on auth SDK instance. Please use okta-auth-js@^5.3.1 .');
        var currentAuthState = oktaAuth.authStateManager.getAuthState();
        if (currentAuthState !== authState) setAuthState(currentAuthState);
        var handler = function handler(authState) {
            setAuthState(authState);
        };
        oktaAuth.authStateManager.subscribe(handler);
        oktaAuth.start();
        return function() {
            oktaAuth.authStateManager.unsubscribe(handler);
        };
    }, [
        oktaAuth
    ]);
    var oktaContextValue = $ieT14.useMemo(function() {
        return {
            oktaAuth: oktaAuth,
            authState: authState,
            _onAuthRequired: onAuthRequired
        };
    }, [
        oktaAuth,
        authState,
        onAuthRequired
    ]);
    if (!oktaAuth) {
        var err = new (0, $c54b3d2ef9f9e60a$exports.AuthSdkError)('No oktaAuth instance passed to Security Component.');
        return /*#__PURE__*/ $ieT14.createElement($4df32aa15a91038c$var$OktaError, {
            error: err
        });
    }
    if (!restoreOriginalUri) {
        var _err = new (0, $c54b3d2ef9f9e60a$exports.AuthSdkError)('No restoreOriginalUri callback passed to Security Component.');
        return /*#__PURE__*/ $ieT14.createElement($4df32aa15a91038c$var$OktaError, {
            error: _err
        });
    }
    if (!oktaAuth._oktaUserAgent) console.warn('_oktaUserAgent is not available on auth SDK instance. Please use okta-auth-js@^5.3.1 .');
    else {
        var isAuthJsSupported = (0, $fbd5e24ff0a9301a$export$398604a469f7de9a)(oktaAuth._oktaUserAgent.getVersion(), "5.3.1", '>=');
        if (!isAuthJsSupported) {
            var _err2 = new (0, $c54b3d2ef9f9e60a$exports.AuthSdkError)("\n        Passed in oktaAuth is not compatible with the SDK,\n        minimum supported okta-auth-js version is ".concat("5.3.1", ".\n      "));
            return /*#__PURE__*/ $ieT14.createElement($4df32aa15a91038c$var$OktaError, {
                error: _err2
            });
        }
    }
    return /*#__PURE__*/ $ieT14.createElement($4df32aa15a91038c$export$df9a5fb346e7c0bb.Provider, {
        value: oktaContextValue
    }, children);
};
function $4df32aa15a91038c$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4df32aa15a91038c$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4df32aa15a91038c$var$ownKeys$1(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($1601eaa94f23093c$exports)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4df32aa15a91038c$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $4df32aa15a91038c$export$683729e5315f529b = function withOktaAuth(ComponentToWrap) {
    var WrappedComponent = function WrappedComponent(props) {
        var oktaAuthProps = $4df32aa15a91038c$export$2ae4a19e09ca9a00();
        return /*#__PURE__*/ $ieT14.createElement(ComponentToWrap, $4df32aa15a91038c$var$_objectSpread$1($4df32aa15a91038c$var$_objectSpread$1({}, oktaAuthProps), props));
    };
    WrappedComponent.displayName = 'withOktaAuth_' + (ComponentToWrap.displayName || ComponentToWrap.name);
    return WrappedComponent;
};
var $4df32aa15a91038c$var$handledRedirect = false;
var $4df32aa15a91038c$export$8f938467209eea73 = function LoginCallback(_ref) {
    var errorComponent = _ref.errorComponent, _ref$loadingElement = _ref.loadingElement, loadingElement = _ref$loadingElement === void 0 ? null : _ref$loadingElement, onAuthResume = _ref.onAuthResume;
    var _useOktaAuth = $4df32aa15a91038c$export$2ae4a19e09ca9a00(), oktaAuth = _useOktaAuth.oktaAuth, authState = _useOktaAuth.authState;
    var _React$useState = $ieT14.useState(null), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($bc640ab0637076b3$exports)))(_React$useState, 2), callbackError = _React$useState2[0], setCallbackError = _React$useState2[1];
    var ErrorReporter = errorComponent || $4df32aa15a91038c$var$OktaError;
    $ieT14.useEffect(function() {
        var isInteractionRequired = oktaAuth.idx.isInteractionRequired || oktaAuth.isInteractionRequired.bind(oktaAuth);
        if (onAuthResume && isInteractionRequired()) {
            onAuthResume();
            return;
        }
        if (!$4df32aa15a91038c$var$handledRedirect) {
            oktaAuth.handleLoginRedirect()["catch"](function(e) {
                setCallbackError(e);
            });
            $4df32aa15a91038c$var$handledRedirect = true;
        }
    }, [
        oktaAuth
    ]);
    var authError = authState === null || authState === void 0 ? void 0 : authState.error;
    var displayError = callbackError || authError;
    if (displayError) return /*#__PURE__*/ $ieT14.createElement(ErrorReporter, {
        error: displayError
    });
    return loadingElement;
};
var $4df32aa15a91038c$var$_excluded = [
    "onAuthRequired",
    "errorComponent"
];
function $4df32aa15a91038c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4df32aa15a91038c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4df32aa15a91038c$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($1601eaa94f23093c$exports)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4df32aa15a91038c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $4df32aa15a91038c$var$useMatch;
if ('useRouteMatch' in $6mt9R) $4df32aa15a91038c$var$useMatch = $6mt9R['useRouteMatch' in $6mt9R ? 'useRouteMatch' : ''];
else $4df32aa15a91038c$var$useMatch = function useMatch() {
    throw new (0, $c54b3d2ef9f9e60a$exports.AuthSdkError)('Unsupported: SecureRoute only works with react-router-dom v5 or any router library with compatible APIs. See examples under the "samples" folder for how to implement your own custom SecureRoute Component.');
};
var $4df32aa15a91038c$export$d93cdd50e579241c = function SecureRoute(_ref) {
    var onAuthRequired = _ref.onAuthRequired, errorComponent = _ref.errorComponent, routeProps = (0, (/*@__PURE__*/$parcel$interopDefault($64cb28f478a17aa0$exports)))(_ref, $4df32aa15a91038c$var$_excluded);
    var _useOktaAuth = $4df32aa15a91038c$export$2ae4a19e09ca9a00(), oktaAuth = _useOktaAuth.oktaAuth, authState = _useOktaAuth.authState, _onAuthRequired = _useOktaAuth._onAuthRequired;
    var match = $4df32aa15a91038c$var$useMatch(routeProps);
    var pendingLogin = $ieT14.useRef(false);
    var _React$useState = $ieT14.useState(null), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($bc640ab0637076b3$exports)))(_React$useState, 2), handleLoginError = _React$useState2[0], setHandleLoginError = _React$useState2[1];
    var ErrorReporter = errorComponent || $4df32aa15a91038c$var$OktaError;
    $ieT14.useEffect(function() {
        var handleLogin = /*#__PURE__*/ function() {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($a4a11e297e121f39$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($afbd3bca675d3652$exports))).mark(function _callee() {
                var originalUri, onAuthRequiredFn;
                return (0, (/*@__PURE__*/$parcel$interopDefault($afbd3bca675d3652$exports))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!pendingLogin.current) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return");
                        case 2:
                            pendingLogin.current = true;
                            originalUri = (0, $c54b3d2ef9f9e60a$exports.toRelativeUrl)(window.location.href, window.location.origin);
                            oktaAuth.setOriginalUri(originalUri);
                            onAuthRequiredFn = onAuthRequired || _onAuthRequired;
                            if (!onAuthRequiredFn) {
                                _context.next = 11;
                                break;
                            }
                            _context.next = 9;
                            return onAuthRequiredFn(oktaAuth);
                        case 9:
                            _context.next = 13;
                            break;
                        case 11:
                            _context.next = 13;
                            return oktaAuth.signInWithRedirect();
                        case 13:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function handleLogin() {
                return _ref2.apply(this, arguments);
            };
        }();
        if (!match) return;
        if (!authState) return;
        if (authState.isAuthenticated) {
            pendingLogin.current = false;
            return;
        }
        if (!authState.isAuthenticated) handleLogin()["catch"](function(err) {
            setHandleLoginError(err);
        });
    }, [
        authState,
        oktaAuth,
        match,
        onAuthRequired,
        _onAuthRequired
    ]);
    if (handleLoginError) return /*#__PURE__*/ $ieT14.createElement(ErrorReporter, {
        error: handleLoginError
    });
    if (!authState || !authState.isAuthenticated) return null;
    return /*#__PURE__*/ $ieT14.createElement($6mt9R.Route, $4df32aa15a91038c$var$_objectSpread({}, routeProps));
};


var $714174fa38b8e4a1$exports = {};
/*! For license information please see default.js.LICENSE.txt */ 
!function(e1, t) {
    $714174fa38b8e4a1$exports = t();
}(self, function() {
    return function() {
        var e1 = {
            9748: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    b: function() {
                        return Z;
                    }
                });
                var r = n(5385), o = n(9123), i = n(1971);
                function a(e1, t) {
                    var n = {};
                    return Object.assign(n, t), !n.stateToken && e1.stateToken && (n.stateToken = e1.stateToken), n;
                }
                function u(e1, t) {
                    return t = a(e1, t), (0, r.v_)(e1, e1.getIssuerOrigin() + "/api/v1/authn", t, {
                        withCredentials: !0
                    });
                }
                function c(e1) {
                    return !!f(e1);
                }
                function s(e1, t, n, o, i) {
                    return i = Object.assign({
                        withCredentials: !0
                    }, i), (0, r.v_)(e1, n, o, i).then(function(e1) {
                        return t.createTransaction(e1);
                    });
                }
                function f(e1) {
                    return e1.options.storageUtil.storage.get(i.STATE_TOKEN_KEY_NAME);
                }
                var l = n(3144), p = n(5671), d = n(4942), h = n(3193), v = n(4771), y = n(6718);
                function g(e1, t, n, i, u, c) {
                    if (Array.isArray(u)) return function(r, a) {
                        if (!r) throw new o.Z("Must provide a link name");
                        var s = (0, h.sE)(u, {
                            name: r
                        });
                        if (!s) throw new o.Z("No link found for that name");
                        return g(e1, t, n, i, s, c)(a);
                    };
                    if (u.hints && u.hints.allow && 1 === u.hints.allow.length) switch(u.hints.allow[0]){
                        case "GET":
                            return function() {
                                return (0, r.U2)(e1, u.href, {
                                    withCredentials: !0
                                });
                            };
                        case "POST":
                            return function(r) {
                                c && c.isPolling && (c.isPolling = !1);
                                var f = a(n, r);
                                "MFA_ENROLL" !== n.status && "FACTOR_ENROLL" !== n.status || Object.assign(f, {
                                    factorType: i.factorType,
                                    provider: i.provider
                                });
                                var l = {}, p = f.autoPush;
                                if (void 0 !== p) {
                                    if ("function" == typeof p) try {
                                        l.autoPush = !!p();
                                    } catch (e1) {
                                        return Promise.reject(new o.Z("AutoPush resulted in an error."));
                                    }
                                    else null !== p && (l.autoPush = !!p);
                                    f = (0, h.CE)(f, "autoPush");
                                }
                                var d = f.rememberDevice;
                                if (void 0 !== d) {
                                    if ("function" == typeof d) try {
                                        l.rememberDevice = !!d();
                                    } catch (e1) {
                                        return Promise.reject(new o.Z("RememberDevice resulted in an error."));
                                    }
                                    else null !== d && (l.rememberDevice = !!d);
                                    f = (0, h.CE)(f, "rememberDevice");
                                } else f.profile && void 0 !== f.profile.updatePhone && (f.profile.updatePhone && (l.updatePhone = !0), f.profile = (0, h.CE)(f.profile, "updatePhone"));
                                var v = u.href + (0, y.UK)(l);
                                return s(e1, t, v, f);
                            };
                    }
                }
                var m = n(8750), b = n(6573);
                function k(e1, t, n) {
                    return function(u) {
                        var c, s, f, l;
                        (0, v.hj)(u) ? c = u : (0, v.Kn)(u) && (c = u.delay, s = u.rememberDevice, f = u.autoPush, l = u.transactionCallBack), c || 0 === c || (c = i.DEFAULT_POLLING_DELAY);
                        var p = (0, h.Rg)(t, "next", "poll");
                        n.isPolling = !0;
                        var d = 0;
                        return (function i() {
                            return n.isPolling ? (function() {
                                var n = {};
                                if ("function" == typeof f) try {
                                    n.autoPush = !!f();
                                } catch (e1) {
                                    return Promise.reject(new o.Z("AutoPush resulted in an error."));
                                }
                                else null != f && (n.autoPush = !!f);
                                if ("function" == typeof s) try {
                                    n.rememberDevice = !!s();
                                } catch (e1) {
                                    return Promise.reject(new o.Z("RememberDevice resulted in an error."));
                                }
                                else null != s && (n.rememberDevice = !!s);
                                var i = p.href + (0, y.UK)(n);
                                return (0, r.v_)(e1, i, function(e1) {
                                    return a(e1);
                                }(t), {
                                    saveAuthnState: !1,
                                    withCredentials: !0,
                                    pollingIntent: !0
                                });
                            })().then(function(t) {
                                if (d = 0, t.factorResult && "WAITING" === t.factorResult) {
                                    if (!n.isPolling) throw new b.Z;
                                    return "function" == typeof l && l(t), (0, m.gw)(c).then(i);
                                }
                                return n.isPolling = !1, e1.tx.createTransaction(t);
                            }).catch(function(e1) {
                                if (e1.xhr && (0 === e1.xhr.status || 429 === e1.xhr.status) && d <= 4) {
                                    var t = 1e3 * Math.pow(2, d);
                                    return d++, (0, m.gw)(t).then(i);
                                }
                                throw e1;
                            }) : Promise.reject(new b.Z);
                        })().catch(function(e1) {
                            throw n.isPolling = !1, e1;
                        });
                    };
                }
                function w(e1, t, n, r, o) {
                    if (r = r || n, r = (0, h.d9)(r), Array.isArray(r)) {
                        for(var i = [], a = 0, u = r.length; a < u; a++)i.push(w(e1, t, n, r[a], o));
                        return i;
                    }
                    var c = r._embedded || {};
                    for(var s in c)Object.prototype.hasOwnProperty.call(c, s) && ((0, v.Kn)(c[s]) || Array.isArray(c[s])) && (c[s] = w(e1, t, n, c[s], o));
                    var f = function(e1, t, n, r, o) {
                        var i = {};
                        for(var a in r._links)if (Object.prototype.hasOwnProperty.call(r._links, a)) {
                            var u = r._links[a];
                            if ("next" === a && (a = u.name), u.type) i[a] = u;
                            else if ("poll" === a) i.poll = k(e1, n, o);
                            else {
                                var c = g(e1, t, n, r, u, o);
                                c && (i[a] = c);
                            }
                        }
                        return i;
                    }(e1, t, n, r, o);
                    return Object.assign(c, f), r = (0, h.CE)(r, "_embedded", "_links"), Object.assign(r, c), r;
                }
                var O = (0, l.Z)(function e1(t, n) {
                    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                    (0, p.Z)(this, e1), (0, d.Z)(this, "next", void 0), (0, d.Z)(this, "cancel", void 0), (0, d.Z)(this, "skip", void 0), (0, d.Z)(this, "unlock", void 0), (0, d.Z)(this, "changePassword", void 0), (0, d.Z)(this, "resetPassword", void 0), (0, d.Z)(this, "answer", void 0), (0, d.Z)(this, "recovery", void 0), (0, d.Z)(this, "verify", void 0), (0, d.Z)(this, "resend", void 0), (0, d.Z)(this, "activate", void 0), (0, d.Z)(this, "poll", void 0), (0, d.Z)(this, "prev", void 0), (0, d.Z)(this, "data", void 0), (0, d.Z)(this, "stateToken", void 0), (0, d.Z)(this, "sessionToken", void 0), (0, d.Z)(this, "status", void 0), (0, d.Z)(this, "user", void 0), (0, d.Z)(this, "factor", void 0), (0, d.Z)(this, "factors", void 0), (0, d.Z)(this, "policy", void 0), (0, d.Z)(this, "scopes", void 0), (0, d.Z)(this, "target", void 0), (0, d.Z)(this, "authentication", void 0), this.data = void 0, this.status = void 0, r && (this.data = r, Object.assign(this, w(t, n, r, r, {})), delete this.stateToken, "RECOVERY_CHALLENGE" !== r.status || r._links || (this.cancel = function() {
                        return Promise.resolve(n.createTransaction());
                    }));
                });
                function Z(e1) {
                    var t = {
                        status: u.bind(null, e1),
                        resume: function(n) {
                            return function(e1, t, n) {
                                if (!n || !n.stateToken) {
                                    var r = f(e1);
                                    if (!r) return Promise.reject(new o.Z("No transaction to resume"));
                                    n = {
                                        stateToken: r
                                    };
                                }
                                return u(e1, n).then(function(e1) {
                                    return t.createTransaction(e1);
                                });
                            }(e1, t, n);
                        },
                        exists: c.bind(null, e1),
                        introspect: function(n) {
                            return function(e1, t, n) {
                                if (!n || !n.stateToken) {
                                    var i = f(e1);
                                    if (!i) return Promise.reject(new o.Z("No transaction to evaluate"));
                                    n = {
                                        stateToken: i
                                    };
                                }
                                return (function(e1, t) {
                                    return t = a(e1, t), (0, r.v_)(e1, e1.getIssuerOrigin() + "/api/v1/authn/introspect", t, {
                                        withCredentials: !0
                                    });
                                })(e1, n).then(function(e1) {
                                    return t.createTransaction(e1);
                                });
                            }(e1, t, n);
                        },
                        createTransaction: function(n) {
                            return new O(e1, t, n);
                        },
                        postToTransaction: function(n, r, o) {
                            return s(e1, t, n, r, o);
                        }
                    };
                    return t;
                }
            },
            3398: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    b: function() {
                        return r.b;
                    },
                    t: function() {
                        return o.t;
                    }
                });
                var r = n(9748), o = n(3164);
            },
            3164: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    t: function() {
                        return m;
                    }
                });
                var r = n(4925), o = n(5861), i = n(5671), a = n(3144), u = n(7326), c = n(136), s = n(2963), f = n(1120), l = n(4942), p = n(4687), d = n.n(p), h = n(3193), v = n(8719), y = n(9748), g = [
                    "multiOptionalFactorEnroll"
                ];
                function m(e1) {
                    return function(e1) {
                        (0, c.Z)(k, e1);
                        var t, n, p, m, b = (p = k, m = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, t = (0, f.Z)(p);
                            if (m) {
                                var n = (0, f.Z)(this).constructor;
                                e1 = Reflect.construct(t, arguments, n);
                            } else e1 = t.apply(this, arguments);
                            return (0, s.Z)(this, e1);
                        });
                        function k() {
                            var e1;
                            (0, i.Z)(this, k);
                            for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                            return e1 = b.call.apply(b, [
                                this
                            ].concat(n)), (0, l.Z)((0, u.Z)(e1), "tx", void 0), (0, l.Z)((0, u.Z)(e1), "authn", void 0), (0, l.Z)((0, u.Z)(e1), "fingerprint", void 0), e1.authn = e1.tx = (0, y.b)((0, u.Z)(e1)), e1.fingerprint = v.Z.bind(null, (0, u.Z)(e1)), e1;
                        }
                        return (0, a.Z)(k, [
                            {
                                key: "signIn",
                                value: (n = (0, o.Z)(d().mark(function e1(t) {
                                    var n, r = this;
                                    return d().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t = (0, h.d9)(t || {}), n = function(e1) {
                                                    return delete t.sendFingerprint, r.tx.postToTransaction("/api/v1/authn", t, e1);
                                                }, t.sendFingerprint) {
                                                    e1.next = 4;
                                                    break;
                                                }
                                                return e1.abrupt("return", n());
                                            case 4:
                                                return e1.abrupt("return", this.fingerprint().then(function(e1) {
                                                    return n({
                                                        headers: {
                                                            "X-Device-Fingerprint": e1
                                                        }
                                                    });
                                                }));
                                            case 5:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return n.apply(this, arguments);
                                })
                            },
                            {
                                key: "signInWithCredentials",
                                value: (t = (0, o.Z)(d().mark(function e1(t) {
                                    return d().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.abrupt("return", this.signIn(t));
                                            case 1:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return t.apply(this, arguments);
                                })
                            },
                            {
                                key: "forgotPassword",
                                value: function(e1) {
                                    return this.tx.postToTransaction("/api/v1/authn/recovery/password", e1);
                                }
                            },
                            {
                                key: "unlockAccount",
                                value: function(e1) {
                                    return this.tx.postToTransaction("/api/v1/authn/recovery/unlock", e1);
                                }
                            },
                            {
                                key: "verifyRecoveryToken",
                                value: function(e1) {
                                    var t = e1.multiOptionalFactorEnroll, n = (0, r.Z)(e1, g);
                                    return t && (n.options = {
                                        multiOptionalFactorEnroll: t
                                    }), this.tx.postToTransaction("/api/v1/authn/recovery/token", n);
                                }
                            }
                        ]), k;
                    }(e1);
                }
            },
            9893: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return l;
                    }
                });
                var r = n(3144), o = n(5671), i = n(4942), a = n(3193), u = n(415), c = n(1971), s = n(4279), f = n.n(s);
                function l(e1) {
                    var t = (0, r.Z)(function t() {
                        (0, o.Z)(this, t), (0, i.Z)(this, "options", void 0), (0, i.Z)(this, "emitter", void 0), (0, i.Z)(this, "features", void 0);
                        var n = new e1(arguments.length && (arguments.length <= 0 ? void 0 : arguments[0]) || {});
                        this.options = (0, a.YY)(n), this.emitter = new (f()), this.features = u;
                    });
                    return (0, i.Z)(t, "features", u), (0, i.Z)(t, "constants", c), t.features = t.prototype.features = u, Object.assign(t, {
                        constants: c
                    }), t;
                }
            },
            3306: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return o.X;
                    },
                    a: function() {
                        return r.a;
                    }
                });
                var r = n(9893), o = n(5093);
            },
            5093: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return a;
                    }
                });
                var r = n(3144), o = n(5671), i = n(4942);
                function a() {
                    return (0, r.Z)(function e1(t) {
                        (0, o.Z)(this, e1), (0, i.Z)(this, "devMode", void 0), this.devMode = !!t.devMode;
                    });
                }
            },
            4858: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = arguments[t];
                        for(var r in n)e1[r] = n[r];
                    }
                    return e1;
                }
                n.d(t, {
                    Z: function() {
                        return f;
                    }
                });
                var o = function e1(t, n) {
                    function o(e1, o, i) {
                        if ("undefined" != typeof document) {
                            "number" == typeof (i = r({}, n, i)).expires && (i.expires = new Date(Date.now() + 864e5 * i.expires)), i.expires && (i.expires = i.expires.toUTCString()), e1 = encodeURIComponent(e1).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
                            var a = "";
                            for(var u in i)i[u] && (a += "; " + u, !0 !== i[u] && (a += "=" + i[u].split(";")[0]));
                            return document.cookie = e1 + "=" + t.write(o, e1) + a;
                        }
                    }
                    return Object.create({
                        set: o,
                        get: function(e1) {
                            if ("undefined" != typeof document && (!arguments.length || e1)) {
                                for(var n = document.cookie ? document.cookie.split("; ") : [], r = {}, o = 0; o < n.length; o++){
                                    var i = n[o].split("="), a = i.slice(1).join("=");
                                    try {
                                        var u = decodeURIComponent(i[0]);
                                        if (r[u] = t.read(a, u), e1 === u) break;
                                    } catch (e1) {}
                                }
                                return e1 ? r[e1] : r;
                            }
                        },
                        remove: function(e1, t) {
                            o(e1, "", r({}, t, {
                                expires: -1
                            }));
                        },
                        withAttributes: function(t) {
                            return e1(this.converter, r({}, this.attributes, t));
                        },
                        withConverter: function(t) {
                            return e1(r({}, this.converter, t), this.attributes);
                        }
                    }, {
                        attributes: {
                            value: Object.freeze(n)
                        },
                        converter: {
                            value: Object.freeze(t)
                        }
                    });
                }({
                    read: function(e1) {
                        return '"' === e1[0] && (e1 = e1.slice(1, -1)), e1.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
                    },
                    write: function(e1) {
                        return encodeURIComponent(e1).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
                    }
                }, {
                    path: "/"
                }), i = o, a = n(9123), u = n(146), c = n(415), s = {
                    browserHasLocalStorage: function() {
                        try {
                            var e1 = this.getLocalStorage();
                            return this.testStorage(e1);
                        } catch (e1) {
                            return !1;
                        }
                    },
                    browserHasSessionStorage: function() {
                        try {
                            var e1 = this.getSessionStorage();
                            return this.testStorage(e1);
                        } catch (e1) {
                            return !1;
                        }
                    },
                    testStorageType: function(e1) {
                        var t = !1;
                        switch(e1){
                            case "sessionStorage":
                                t = this.browserHasSessionStorage();
                                break;
                            case "localStorage":
                                t = this.browserHasLocalStorage();
                                break;
                            case "cookie":
                            case "memory":
                                t = !0;
                                break;
                            default:
                                t = !1;
                        }
                        return t;
                    },
                    getStorageByType: function(e1, t) {
                        var n;
                        switch(e1){
                            case "sessionStorage":
                                n = this.getSessionStorage();
                                break;
                            case "localStorage":
                                n = this.getLocalStorage();
                                break;
                            case "cookie":
                                n = this.getCookieStorage(t);
                                break;
                            case "memory":
                                n = this.getInMemoryStorage();
                                break;
                            default:
                                throw new a.Z("Unrecognized storage option: ".concat(e1));
                        }
                        return n;
                    },
                    findStorageType: function(e1) {
                        var t, n;
                        return t = (e1 = e1.slice()).shift(), (n = e1.length ? e1[0] : null) ? this.testStorageType(t) ? t : ((0, u.ZK)("This browser doesn't support ".concat(t, ". Switching to ").concat(n, ".")), this.findStorageType(e1)) : t;
                    },
                    getLocalStorage: function() {
                        return (0, c.isIE11OrLess)() && !window.onstorage && (window.onstorage = function() {}), localStorage;
                    },
                    getSessionStorage: function() {
                        return sessionStorage;
                    },
                    getCookieStorage: function(e1) {
                        var t = this, n = e1.secure, r = e1.sameSite, o = e1.sessionCookie;
                        if (void 0 === n || void 0 === r) throw new a.Z('getCookieStorage: "secure" and "sameSite" options must be provided');
                        var i = {
                            getItem: this.storage.get,
                            setItem: function(e1, i) {
                                var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "2200-01-01T00:00:00.000Z";
                                a = o ? null : a, t.storage.set(e1, i, a, {
                                    secure: n,
                                    sameSite: r
                                });
                            },
                            removeItem: function(e1) {
                                t.storage.delete(e1);
                            }
                        };
                        return e1.useSeparateCookies ? {
                            getItem: function(e1) {
                                var t = i.getItem(), n = {};
                                return Object.keys(t).forEach(function(r) {
                                    0 === r.indexOf(e1) && (n[r.replace("".concat(e1, "_"), "")] = JSON.parse(t[r]));
                                }), JSON.stringify(n);
                            },
                            setItem: function(e1, t) {
                                var n = JSON.parse(this.getItem(e1));
                                t = JSON.parse(t), Object.keys(t).forEach(function(r) {
                                    var o = e1 + "_" + r, a = JSON.stringify(t[r]);
                                    i.setItem(o, a), delete n[r];
                                }), Object.keys(n).forEach(function(t) {
                                    i.removeItem(e1 + "_" + t);
                                });
                            },
                            removeItem: function(e1) {
                                var t = JSON.parse(this.getItem(e1));
                                Object.keys(t).forEach(function(t) {
                                    i.removeItem(e1 + "_" + t);
                                });
                            }
                        } : i;
                    },
                    inMemoryStore: {},
                    getInMemoryStorage: function() {
                        var e1 = this;
                        return {
                            getItem: function(t) {
                                return e1.inMemoryStore[t];
                            },
                            setItem: function(t, n) {
                                e1.inMemoryStore[t] = n;
                            }
                        };
                    },
                    testStorage: function(e1) {
                        var t = "okta-test-storage";
                        try {
                            return e1.setItem(t, t), e1.removeItem(t), !0;
                        } catch (e1) {
                            return !1;
                        }
                    },
                    storage: {
                        set: function(e1, t, n, r) {
                            var o = r.sameSite, u = r.secure;
                            if (void 0 === u || void 0 === o) throw new a.Z('storage.set: "secure" and "sameSite" options must be provided');
                            var c = {
                                path: r.path || "/",
                                secure: u,
                                sameSite: o
                            };
                            return Date.parse(n) && (c.expires = new Date(n)), i.set(e1, t, c), this.get(e1);
                        },
                        get: function(e1) {
                            return arguments.length ? i.get(e1) : i.get();
                        },
                        delete: function(e1) {
                            return i.remove(e1, {
                                path: "/"
                            });
                        }
                    }
                }, f = s;
            },
            8719: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return u;
                    }
                });
                var r = n(9123), o = n(415), i = n(4970), a = function(e1, t) {
                    return t.source === e1.contentWindow;
                };
                function u(e1, t) {
                    var n;
                    if (!(0, o.isFingerprintSupported)()) return Promise.reject(new r.Z("Fingerprinting is not supported on this device"));
                    var u, c, s, f = null !== (n = null == t ? void 0 : t.container) && void 0 !== n ? n : document.body;
                    return new Promise(function(n, o) {
                        (c = document.createElement("iframe")).style.display = "none", s = function(t) {
                            if (a(c, t) && t && t.data && t.origin === e1.getIssuerOrigin()) {
                                var i, u, s;
                                try {
                                    i = JSON.parse(t.data);
                                } catch (e1) {
                                    return;
                                }
                                if (i) return "FingerprintAvailable" === i.type ? n(i.fingerprint) : "FingerprintServiceReady" !== i.type ? o(new r.Z("No data")) : void (null === (u = c) || void 0 === u || null === (s = u.contentWindow) || void 0 === s || s.postMessage(JSON.stringify({
                                    type: "GetFingerprint"
                                }), t.origin));
                            }
                        }, (0, i.NH)(window, "message", s), c.src = e1.getIssuerOrigin() + "/auth/services/devicefingerprint", f.appendChild(c), u = setTimeout(function() {
                            o(new r.Z("Fingerprinting timed out"));
                        }, (null == t ? void 0 : t.timeout) || 15e3);
                    }).finally(function() {
                        var e1;
                        clearTimeout(u), (0, i.ys)(window, "message", s), f.contains(c) && (null === (e1 = c.parentElement) || void 0 === e1 || e1.removeChild(c));
                    });
                }
            },
            1971: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    ACCESS_TOKEN_STORAGE_KEY: function() {
                        return v;
                    },
                    CACHE_STORAGE_NAME: function() {
                        return s;
                    },
                    DEFAULT_CACHE_DURATION: function() {
                        return u;
                    },
                    DEFAULT_CODE_CHALLENGE_METHOD: function() {
                        return w;
                    },
                    DEFAULT_MAX_CLOCK_SKEW: function() {
                        return a;
                    },
                    DEFAULT_POLLING_DELAY: function() {
                        return o;
                    },
                    IDX_API_VERSION: function() {
                        return O;
                    },
                    IDX_RESPONSE_STORAGE_NAME: function() {
                        return h;
                    },
                    ID_TOKEN_STORAGE_KEY: function() {
                        return y;
                    },
                    IOS_MAX_RETRY_COUNT: function() {
                        return i;
                    },
                    MAX_VERIFIER_LENGTH: function() {
                        return k;
                    },
                    MIN_VERIFIER_LENGTH: function() {
                        return b;
                    },
                    ORIGINAL_URI_STORAGE_NAME: function() {
                        return d;
                    },
                    PKCE_STORAGE_NAME: function() {
                        return f;
                    },
                    REFERRER_PATH_STORAGE_KEY: function() {
                        return m;
                    },
                    REFRESH_TOKEN_STORAGE_KEY: function() {
                        return g;
                    },
                    SHARED_TRANSACTION_STORAGE_NAME: function() {
                        return p;
                    },
                    STATE_TOKEN_KEY_NAME: function() {
                        return r;
                    },
                    TOKEN_STORAGE_NAME: function() {
                        return c;
                    },
                    TRANSACTION_STORAGE_NAME: function() {
                        return l;
                    }
                });
                var r = "oktaStateToken", o = 500, i = 3, a = 300, u = 86400, c = "okta-token-storage", s = "okta-cache-storage", f = "okta-pkce-storage", l = "okta-transaction-storage", p = "okta-shared-transaction-storage", d = "okta-original-uri-storage", h = "okta-idx-response-storage", v = "accessToken", y = "idToken", g = "refreshToken", m = "referrerPath", b = 43, k = 128, w = "S256", O = "1.0.0";
            },
            1018: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    E: function() {
                        return k;
                    },
                    a: function() {
                        return g;
                    }
                });
                var r = n(5861), o = n(5671), i = n(3144), a = n(4942), u = n(4687), c = n.n(u), s = n(3615), f = n.n(s), l = n(9123), p = n(7088), d = n(3548), h = n(146);
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, a.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var g = null, m = {
                    updateAuthStatePromise: null,
                    canceledTimes: 0
                }, b = "authStateChange", k = function() {
                    function e1(t) {
                        var n = this;
                        if ((0, o.Z)(this, e1), (0, a.Z)(this, "_sdk", void 0), (0, a.Z)(this, "_pending", void 0), (0, a.Z)(this, "_authState", void 0), (0, a.Z)(this, "_prevAuthState", void 0), (0, a.Z)(this, "_logOptions", void 0), (0, a.Z)(this, "_transformQueue", void 0), !t.emitter) throw new l.Z("Emitter should be initialized before AuthStateManager");
                        this._sdk = t, this._pending = y({}, m), this._authState = g, this._logOptions = {}, this._prevAuthState = null, this._transformQueue = new d.b({
                            quiet: !0
                        }), t.tokenManager.on(p.O3, function(e1, t) {
                            n._setLogOptions({
                                event: p.O3,
                                key: e1,
                                token: t
                            }), n.updateAuthState();
                        }), t.tokenManager.on(p.FT, function(e1, t) {
                            n._setLogOptions({
                                event: p.FT,
                                key: e1,
                                token: t
                            }), n.updateAuthState();
                        });
                    }
                    var t;
                    return (0, i.Z)(e1, [
                        {
                            key: "_setLogOptions",
                            value: function(e1) {
                                this._logOptions = e1;
                            }
                        },
                        {
                            key: "getAuthState",
                            value: function() {
                                return this._authState;
                            }
                        },
                        {
                            key: "getPreviousAuthState",
                            value: function() {
                                return this._prevAuthState;
                            }
                        },
                        {
                            key: "updateAuthState",
                            value: (t = (0, r.Z)(c().mark(function e1() {
                                var t, n, r, o, i, a, u, s = this;
                                return c().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (t = this._sdk.options, n = t.transformAuthState, r = t.devMode, o = function(e1) {
                                                var t = s._logOptions, n = t.event, r = t.key, o = t.token;
                                                (0, h.dr)().group("OKTA-AUTH-JS:updateAuthState: Event:".concat(n, " Status:").concat(e1)), (0, h.dr)().log(r, o), (0, h.dr)().log("Current authState", s._authState), (0, h.dr)().groupEnd(), s._logOptions = {};
                                            }, i = function(e1) {
                                                var t, n;
                                                n = e1, (t = s._authState) && t.isAuthenticated === n.isAuthenticated && JSON.stringify(t.idToken) === JSON.stringify(n.idToken) && JSON.stringify(t.accessToken) === JSON.stringify(n.accessToken) && t.error === n.error ? r && o("unchanged") : (s._prevAuthState = s._authState, s._authState = e1, s._sdk.emitter.emit(b, y({}, e1)), r && o("emitted"));
                                            }, a = function e1(t) {
                                                return s._pending.updateAuthStatePromise.then(function() {
                                                    var n = s._pending.updateAuthStatePromise;
                                                    return n && n !== t ? e1(n) : s.getAuthState();
                                                });
                                            }, !this._pending.updateAuthStatePromise) {
                                                e1.next = 11;
                                                break;
                                            }
                                            if (!(this._pending.canceledTimes >= 10)) {
                                                e1.next = 10;
                                                break;
                                            }
                                            return r && o("terminated"), e1.abrupt("return", a(this._pending.updateAuthStatePromise));
                                        case 10:
                                            this._pending.updateAuthStatePromise.cancel();
                                        case 11:
                                            return u = new (f())(function(e1, t, a) {
                                                a.shouldReject = !1, a(function() {
                                                    s._pending.updateAuthStatePromise = null, s._pending.canceledTimes = s._pending.canceledTimes + 1, r && o("canceled");
                                                });
                                                var c = function(t) {
                                                    u.isCanceled ? e1() : (i(t), e1(), s._pending = y({}, m));
                                                };
                                                s._sdk.isAuthenticated().then(function() {
                                                    if (u.isCanceled) e1();
                                                    else {
                                                        var t = s._sdk.tokenManager.getTokensSync(), r = t.accessToken, o = t.idToken, i = t.refreshToken, a = {
                                                            accessToken: r,
                                                            idToken: o,
                                                            refreshToken: i,
                                                            isAuthenticated: !(!r || !o)
                                                        };
                                                        (n ? s._transformQueue.push(n, null, s._sdk, a) : Promise.resolve(a)).then(function(e1) {
                                                            return c(e1);
                                                        }).catch(function(e1) {
                                                            return c({
                                                                accessToken: r,
                                                                idToken: o,
                                                                refreshToken: i,
                                                                isAuthenticated: !1,
                                                                error: e1
                                                            });
                                                        });
                                                    }
                                                });
                                            }), this._pending.updateAuthStatePromise = u, e1.abrupt("return", a(u));
                                        case 14:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "subscribe",
                            value: function(e1) {
                                this._sdk.emitter.on(b, e1);
                            }
                        },
                        {
                            key: "unsubscribe",
                            value: function(e1) {
                                this._sdk.emitter.off(b, e1);
                            }
                        }
                    ]), e1;
                }();
            },
            9046: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    W: function() {
                        return ge;
                    }
                });
                var r = n(885), o = n(2982), i = n(5861), a = n(5671), u = n(3144), c = n(4942), s = n(4687), f = n.n(s);
                Promise.resolve(!1);
                var l = Promise.resolve(!0), p = Promise.resolve();
                function d(e1, t) {
                    return e1 || (e1 = 0), new Promise(function(n) {
                        return setTimeout(function() {
                            return n(t);
                        }, e1);
                    });
                }
                function h() {
                    return Math.random().toString(36).substring(2);
                }
                var v = 0, y = 0;
                function g() {
                    var e1 = (new Date).getTime();
                    return e1 === v ? 1e3 * e1 + ++y : (v = e1, y = 0, 1e3 * e1);
                }
                var m = {
                    create: function(e1) {
                        var t = {
                            messagesCallback: null,
                            bc: new BroadcastChannel(e1),
                            subFns: []
                        };
                        return t.bc.onmessage = function(e1) {
                            t.messagesCallback && t.messagesCallback(e1.data);
                        }, t;
                    },
                    close: function(e1) {
                        e1.bc.close(), e1.subFns = [];
                    },
                    onMessage: function(e1, t) {
                        e1.messagesCallback = t;
                    },
                    postMessage: function(e1, t) {
                        try {
                            return e1.bc.postMessage(t, !1), p;
                        } catch (e1) {
                            return Promise.reject(e1);
                        }
                    },
                    canBeUsed: function() {
                        if ("undefined" == typeof window && "undefined" == typeof self || "function" != typeof BroadcastChannel) return !1;
                        if (BroadcastChannel._pubkey) throw new Error("BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill");
                        return !0;
                    },
                    type: "native",
                    averageResponseTime: function() {
                        return 150;
                    },
                    microSeconds: g
                }, b = function() {
                    function e1(e1) {
                        this.ttl = e1, this.map = new Map, this._to = !1;
                    }
                    return e1.prototype.has = function(e1) {
                        return this.map.has(e1);
                    }, e1.prototype.add = function(e1) {
                        var t = this;
                        this.map.set(e1, k()), this._to || (this._to = !0, setTimeout(function() {
                            t._to = !1, function(e1) {
                                for(var t = k() - e1.ttl, n = e1.map[Symbol.iterator]();;){
                                    var r = n.next().value;
                                    if (!r) return;
                                    var o = r[0];
                                    if (!(r[1] < t)) return;
                                    e1.map.delete(o);
                                }
                            }(t);
                        }, 0));
                    }, e1.prototype.clear = function() {
                        this.map.clear();
                    }, e1;
                }();
                function k() {
                    return (new Date).getTime();
                }
                function w() {
                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = JSON.parse(JSON.stringify(e1));
                    return void 0 === t.webWorkerSupport && (t.webWorkerSupport = !0), t.idb || (t.idb = {}), t.idb.ttl || (t.idb.ttl = 45e3), t.idb.fallbackInterval || (t.idb.fallbackInterval = 150), e1.idb && "function" == typeof e1.idb.onclose && (t.idb.onclose = e1.idb.onclose), t.localstorage || (t.localstorage = {}), t.localstorage.removeTimeout || (t.localstorage.removeTimeout = 6e4), e1.methods && (t.methods = e1.methods), t.node || (t.node = {}), t.node.ttl || (t.node.ttl = 12e4), t.node.maxParallelWrites || (t.node.maxParallelWrites = 2048), void 0 === t.node.useFastPath && (t.node.useFastPath = !0), t;
                }
                var O = "messages", Z = {
                    durability: "relaxed"
                };
                function T() {
                    if ("undefined" != typeof indexedDB) return indexedDB;
                    if ("undefined" != typeof window) {
                        if (void 0 !== window.mozIndexedDB) return window.mozIndexedDB;
                        if (void 0 !== window.webkitIndexedDB) return window.webkitIndexedDB;
                        if (void 0 !== window.msIndexedDB) return window.msIndexedDB;
                    }
                    return !1;
                }
                function E(e1) {
                    e1.commit && e1.commit();
                }
                function P(e1) {
                    e1.closed || S(e1).then(function() {
                        return d(e1.options.idb.fallbackInterval);
                    }).then(function() {
                        return P(e1);
                    });
                }
                function S(e1) {
                    return e1.closed ? p : e1.messagesCallback ? (function(e1, t) {
                        var n = e1.transaction(O, "readonly", Z), r = n.objectStore(O), o = [], i = IDBKeyRange.bound(t + 1, 1 / 0);
                        if (r.getAll) {
                            var a = r.getAll(i);
                            return new Promise(function(e1, t) {
                                a.onerror = function(e1) {
                                    return t(e1);
                                }, a.onsuccess = function(t) {
                                    e1(t.target.result);
                                };
                            });
                        }
                        return new Promise(function(e1, a) {
                            var u = function() {
                                try {
                                    return i = IDBKeyRange.bound(t + 1, 1 / 0), r.openCursor(i);
                                } catch (e1) {
                                    return r.openCursor();
                                }
                            }();
                            u.onerror = function(e1) {
                                return a(e1);
                            }, u.onsuccess = function(r) {
                                var i = r.target.result;
                                i ? i.value.id < t + 1 ? i.continue(t + 1) : (o.push(i.value), i.continue()) : (E(n), e1(o));
                            };
                        });
                    })(e1.db, e1.lastCursorId).then(function(t) {
                        var n = t.filter(function(e1) {
                            return !!e1;
                        }).map(function(t) {
                            return t.id > e1.lastCursorId && (e1.lastCursorId = t.id), t;
                        }).filter(function(t) {
                            return function(e1, t) {
                                return !(e1.uuid === t.uuid || t.eMIs.has(e1.id) || e1.data.time < t.messagesCallbackTime);
                            }(t, e1);
                        }).sort(function(e1, t) {
                            return e1.time - t.time;
                        });
                        return n.forEach(function(t) {
                            e1.messagesCallback && (e1.eMIs.add(t.id), e1.messagesCallback(t.data));
                        }), p;
                    }) : p;
                }
                var x = {
                    create: function(e1, t) {
                        return t = w(t), (function(e1) {
                            var t = "pubkey.broadcast-channel-0-" + e1, n = T().open(t);
                            return n.onupgradeneeded = function(e1) {
                                e1.target.result.createObjectStore(O, {
                                    keyPath: "id",
                                    autoIncrement: !0
                                });
                            }, new Promise(function(e1, t) {
                                n.onerror = function(e1) {
                                    return t(e1);
                                }, n.onsuccess = function() {
                                    e1(n.result);
                                };
                            });
                        })(e1).then(function(n) {
                            var r = {
                                closed: !1,
                                lastCursorId: 0,
                                channelName: e1,
                                options: t,
                                uuid: h(),
                                eMIs: new b(2 * t.idb.ttl),
                                writeBlockPromise: p,
                                messagesCallback: null,
                                readQueuePromises: [],
                                db: n
                            };
                            return n.onclose = function() {
                                r.closed = !0, t.idb.onclose && t.idb.onclose();
                            }, P(r), r;
                        });
                    },
                    close: function(e1) {
                        e1.closed = !0, e1.db.close();
                    },
                    onMessage: function(e1, t, n) {
                        e1.messagesCallbackTime = n, e1.messagesCallback = t, S(e1);
                    },
                    postMessage: function(e1, t) {
                        return e1.writeBlockPromise = e1.writeBlockPromise.then(function() {
                            return function(e1, t, n) {
                                var r = {
                                    uuid: t,
                                    time: (new Date).getTime(),
                                    data: n
                                }, o = e1.transaction([
                                    O
                                ], "readwrite", Z);
                                return new Promise(function(e1, t) {
                                    o.oncomplete = function() {
                                        return e1();
                                    }, o.onerror = function(e1) {
                                        return t(e1);
                                    }, o.objectStore(O).add(r), E(o);
                                });
                            }(e1.db, e1.uuid, t);
                        }).then(function() {
                            0 === Math.floor(11 * Math.random() + 0) && function(e1) {
                                var t, n, r, o, i, a;
                                return (t = e1.db, n = e1.options.idb.ttl, r = (new Date).getTime() - n, o = t.transaction(O, "readonly", Z), i = o.objectStore(O), a = [], new Promise(function(e1) {
                                    i.openCursor().onsuccess = function(t) {
                                        var n = t.target.result;
                                        if (n) {
                                            var i = n.value;
                                            i.time < r ? (a.push(i), n.continue()) : (E(o), e1(a));
                                        } else e1(a);
                                    };
                                })).then(function(t) {
                                    return function(e1, t) {
                                        if (e1.closed) return Promise.resolve([]);
                                        var n = e1.db.transaction(O, "readwrite", Z).objectStore(O);
                                        return Promise.all(t.map(function(e1) {
                                            var t = n.delete(e1);
                                            return new Promise(function(e1) {
                                                t.onsuccess = function() {
                                                    return e1();
                                                };
                                            });
                                        }));
                                    }(e1, t.map(function(e1) {
                                        return e1.id;
                                    }));
                                });
                            }(e1);
                        }), e1.writeBlockPromise;
                    },
                    canBeUsed: function() {
                        return !!T();
                    },
                    type: "idb",
                    averageResponseTime: function(e1) {
                        return 2 * e1.idb.fallbackInterval;
                    },
                    microSeconds: g
                };
                function A() {
                    var e1;
                    if ("undefined" == typeof window) return null;
                    try {
                        e1 = window.localStorage, e1 = window["ie8-eventlistener/storage"] || window.localStorage;
                    } catch (e1) {}
                    return e1;
                }
                function R(e1) {
                    return "pubkey.broadcastChannel-" + e1;
                }
                function _() {
                    var e1 = A();
                    if (!e1) return !1;
                    try {
                        var t = "__broadcastchannel_check";
                        e1.setItem(t, "works"), e1.removeItem(t);
                    } catch (e1) {
                        return !1;
                    }
                    return !0;
                }
                var j = {
                    create: function(e1, t) {
                        if (t = w(t), !_()) throw new Error("BroadcastChannel: localstorage cannot be used");
                        var n = h(), r = new b(t.localstorage.removeTimeout), o = {
                            channelName: e1,
                            uuid: n,
                            eMIs: r
                        };
                        return o.listener = function(e1, t) {
                            var i = R(e1), a = function(e1) {
                                var t;
                                e1.key === i && (t = JSON.parse(e1.newValue), o.messagesCallback && t.uuid !== n && t.token && !r.has(t.token) && (t.data.time && t.data.time < o.messagesCallbackTime || (r.add(t.token), o.messagesCallback(t.data))));
                            };
                            return window.addEventListener("storage", a), a;
                        }(e1), o;
                    },
                    close: function(e1) {
                        var t;
                        t = e1.listener, window.removeEventListener("storage", t);
                    },
                    onMessage: function(e1, t, n) {
                        e1.messagesCallbackTime = n, e1.messagesCallback = t;
                    },
                    postMessage: function(e1, t) {
                        return new Promise(function(n) {
                            d().then(function() {
                                var r = R(e1.channelName), o = {
                                    token: h(),
                                    time: (new Date).getTime(),
                                    data: t,
                                    uuid: e1.uuid
                                }, i = JSON.stringify(o);
                                A().setItem(r, i);
                                var a = document.createEvent("Event");
                                a.initEvent("storage", !0, !0), a.key = r, a.newValue = i, window.dispatchEvent(a), n();
                            });
                        });
                    },
                    canBeUsed: _,
                    type: "localstorage",
                    averageResponseTime: function() {
                        var e1 = navigator.userAgent.toLowerCase();
                        return e1.includes("safari") && !e1.includes("chrome") ? 240 : 120;
                    },
                    microSeconds: g
                }, C = g, I = new Set, D = {
                    create: function(e1) {
                        var t = {
                            name: e1,
                            messagesCallback: null
                        };
                        return I.add(t), t;
                    },
                    close: function(e1) {
                        I.delete(e1);
                    },
                    onMessage: function(e1, t) {
                        e1.messagesCallback = t;
                    },
                    postMessage: function(e1, t) {
                        return new Promise(function(n) {
                            return setTimeout(function() {
                                Array.from(I).filter(function(t) {
                                    return t.name === e1.name;
                                }).filter(function(t) {
                                    return t !== e1;
                                }).filter(function(e1) {
                                    return !!e1.messagesCallback;
                                }).forEach(function(e1) {
                                    return e1.messagesCallback(t);
                                }), n();
                            }, 5);
                        });
                    },
                    canBeUsed: function() {
                        return !0;
                    },
                    type: "simulate",
                    averageResponseTime: function() {
                        return 5;
                    },
                    microSeconds: C
                }, M = [
                    m,
                    x,
                    j
                ], N = new Set, U = 0, L = function(e1, t) {
                    var n, r, o;
                    this.id = U++, N.add(this), this.name = e1, this.options = w(t), this.method = function(e1) {
                        var t = [].concat(e1.methods, M).filter(Boolean);
                        if (e1.type) {
                            if ("simulate" === e1.type) return D;
                            var n = t.find(function(t) {
                                return t.type === e1.type;
                            });
                            if (n) return n;
                            throw new Error("method-type " + e1.type + " not found");
                        }
                        e1.webWorkerSupport || (t = t.filter(function(e1) {
                            return "idb" !== e1.type;
                        }));
                        var r = t.find(function(e1) {
                            return e1.canBeUsed();
                        });
                        if (r) return r;
                        throw new Error("No usable method found in " + JSON.stringify(M.map(function(e1) {
                            return e1.type;
                        })));
                    }(this.options), this._iL = !1, this._onML = null, this._addEL = {
                        message: [],
                        internal: []
                    }, this._uMP = new Set, this._befC = [], this._prepP = null, (o = r = (n = this).method.create(n.name, n.options)) && "function" == typeof o.then ? (n._prepP = r, r.then(function(e1) {
                        n._state = e1;
                    })) : n._state = r;
                };
                function H(e1, t, n) {
                    var r = {
                        time: e1.method.microSeconds(),
                        type: t,
                        data: n
                    };
                    return (e1._prepP ? e1._prepP : p).then(function() {
                        var t = e1.method.postMessage(e1._state, r);
                        return e1._uMP.add(t), t.catch().then(function() {
                            return e1._uMP.delete(t);
                        }), t;
                    });
                }
                function B(e1) {
                    return e1._addEL.message.length > 0 || e1._addEL.internal.length > 0;
                }
                function K(e1, t, n) {
                    e1._addEL[t].push(n), function(e1) {
                        if (!e1._iL && B(e1)) {
                            var t = function(t) {
                                e1._addEL[t.type].forEach(function(e1) {
                                    var n = e1.time - 1e5;
                                    t.time >= n && e1.fn(t.data);
                                });
                            }, n = e1.method.microSeconds();
                            e1._prepP ? e1._prepP.then(function() {
                                e1._iL = !0, e1.method.onMessage(e1._state, t, n);
                            }) : (e1._iL = !0, e1.method.onMessage(e1._state, t, n));
                        }
                    }(e1);
                }
                function F(e1, t, n) {
                    e1._addEL[t] = e1._addEL[t].filter(function(e1) {
                        return e1 !== n;
                    }), function(e1) {
                        if (e1._iL && !B(e1)) {
                            e1._iL = !1;
                            var t = e1.method.microSeconds();
                            e1.method.onMessage(e1._state, null, t);
                        }
                    }(e1);
                }
                L._pubkey = !0, L.prototype = {
                    postMessage: function(e1) {
                        if (this.closed) throw new Error("BroadcastChannel.postMessage(): Cannot post message after channel has closed " + JSON.stringify(e1));
                        return H(this, "message", e1);
                    },
                    postInternal: function(e1) {
                        return H(this, "internal", e1);
                    },
                    set onmessage (e){
                        var t1 = {
                            time: this.method.microSeconds(),
                            fn: e
                        };
                        F(this, "message", this._onML), e && "function" == typeof e ? (this._onML = t1, K(this, "message", t1)) : this._onML = null;
                    },
                    addEventListener: function(e1, t) {
                        K(this, e1, {
                            time: this.method.microSeconds(),
                            fn: t
                        });
                    },
                    removeEventListener: function(e1, t) {
                        F(this, e1, this._addEL[e1].find(function(e1) {
                            return e1.fn === t;
                        }));
                    },
                    close: function() {
                        var e1 = this;
                        if (!this.closed) {
                            N.delete(this), this.closed = !0;
                            var t = this._prepP ? this._prepP : p;
                            return this._onML = null, this._addEL.message = [], t.then(function() {
                                return Promise.all(Array.from(e1._uMP));
                            }).then(function() {
                                return Promise.all(e1._befC.map(function(e1) {
                                    return e1();
                                }));
                            }).then(function() {
                                return e1.method.close(e1._state);
                            });
                        }
                    },
                    get type () {
                        return this.method.type;
                    },
                    get isClosed () {
                        return this.closed;
                    }
                };
                var G = "[object process]" === Object.prototype.toString.call(0) ? function(e1) {
                    $fcfa90861d16c270$exports.on("exit", function() {
                        return e1();
                    }), $fcfa90861d16c270$exports.on("beforeExit", function() {
                        return e1().then(function() {
                            return $fcfa90861d16c270$exports.exit();
                        });
                    }), $fcfa90861d16c270$exports.on("SIGINT", function() {
                        return e1().then(function() {
                            return $fcfa90861d16c270$exports.exit();
                        });
                    }), $fcfa90861d16c270$exports.on("uncaughtException", function(t) {
                        return e1().then(function() {
                            console.trace(t), $fcfa90861d16c270$exports.exit(101);
                        });
                    });
                } : function(e1) {
                    if ("function" == typeof WorkerGlobalScope && self instanceof WorkerGlobalScope) {
                        var t = self.close.bind(self);
                        self.close = function() {
                            return e1(), t();
                        };
                    } else {
                        if ("function" != typeof window.addEventListener) return;
                        window.addEventListener("beforeunload", function() {
                            e1();
                        }, !0), window.addEventListener("unload", function() {
                            e1();
                        }, !0);
                    }
                }, V = new Set, q = !1;
                function W() {
                    var e1 = [];
                    return V.forEach(function(t) {
                        e1.push(t()), V.delete(t);
                    }), Promise.all(e1);
                }
                function Y(e1, t) {
                    var n = {
                        context: "leader",
                        action: t,
                        token: e1.token
                    };
                    return e1.broadcastChannel.postInternal(n);
                }
                function z(e1) {
                    e1.isLeader = !0, e1._hasLeader = !0;
                    var t = function(e1) {
                        if (q || (q = !0, G(W)), "function" != typeof e1) throw new Error("Listener is no function");
                        return V.add(e1), {
                            remove: function() {
                                return V.delete(e1);
                            },
                            run: function() {
                                return V.delete(e1), e1();
                            }
                        };
                    }(function() {
                        return e1.die();
                    });
                    e1._unl.push(t);
                    var n = function(t) {
                        "leader" === t.context && "apply" === t.action && Y(e1, "tell"), "leader" !== t.context || "tell" !== t.action || e1._dpLC || (e1._dpLC = !0, e1._dpL(), Y(e1, "tell"));
                    };
                    return e1.broadcastChannel.addEventListener("internal", n), e1._lstns.push(n), Y(e1, "tell");
                }
                var Q = function(e1, t) {
                    var n = this;
                    this.broadcastChannel = e1, e1._befC.push(function() {
                        return n.die();
                    }), this._options = t, this.isLeader = !1, this.isDead = !1, this.token = h(), this._lstns = [], this._unl = [], this._dpL = function() {}, this._dpLC = !1, this._wKMC = {}, this.lN = "pubkey-bc||" + e1.method.type + "||" + e1.name;
                };
                Q.prototype = {
                    hasLeader: function() {
                        var e1 = this;
                        return navigator.locks.query().then(function(t) {
                            var n = t.held ? t.held.filter(function(t) {
                                return t.name === e1.lN;
                            }) : [];
                            return !!(n && n.length > 0);
                        });
                    },
                    awaitLeadership: function() {
                        var e1 = this;
                        if (!this._wLMP) {
                            this._wKMC.c = new AbortController;
                            var t = new Promise(function(t, n) {
                                e1._wKMC.res = t, e1._wKMC.rej = n;
                            });
                            this._wLMP = new Promise(function(n) {
                                navigator.locks.request(e1.lN, {
                                    signal: e1._wKMC.c.signal
                                }, function() {
                                    return e1._wKMC.c = void 0, z(e1), n(), t;
                                }).catch(function() {});
                            });
                        }
                        return this._wLMP;
                    },
                    set onduplicate (e){},
                    die: function() {
                        var e1 = this;
                        return this._lstns.forEach(function(t) {
                            return e1.broadcastChannel.removeEventListener("internal", t);
                        }), this._lstns = [], this._unl.forEach(function(e1) {
                            return e1.remove();
                        }), this._unl = [], this.isLeader && (this.isLeader = !1), this.isDead = !0, this._wKMC.res && this._wKMC.res(), this._wKMC.c && this._wKMC.c.abort("LeaderElectionWebLock.die() called"), Y(this, "death");
                    }
                };
                var X = function(e1, t) {
                    var n = this;
                    this.broadcastChannel = e1, this._options = t, this.isLeader = !1, this._hasLeader = !1, this.isDead = !1, this.token = h(), this._aplQ = p, this._aplQC = 0, this._unl = [], this._lstns = [], this._dpL = function() {}, this._dpLC = !1;
                    var r = function(e1) {
                        "leader" === e1.context && ("death" === e1.action && (n._hasLeader = !1), "tell" === e1.action && (n._hasLeader = !0));
                    };
                    this.broadcastChannel.addEventListener("internal", r), this._lstns.push(r);
                };
                function J(e1, t) {
                    if (e1._leaderElector) throw new Error("BroadcastChannel already has a leader-elector");
                    t = function(e1, t) {
                        return e1 || (e1 = {}), (e1 = JSON.parse(JSON.stringify(e1))).fallbackInterval || (e1.fallbackInterval = 3e3), e1.responseTime || (e1.responseTime = t.method.averageResponseTime(t.options)), e1;
                    }(t, e1);
                    var n = "undefined" != typeof navigator && void 0 !== navigator.locks && "function" == typeof navigator.locks.request ? new Q(e1, t) : new X(e1, t);
                    return e1._befC.push(function() {
                        return n.die();
                    }), e1._leaderElector = n, n;
                }
                X.prototype = {
                    hasLeader: function() {
                        return Promise.resolve(this._hasLeader);
                    },
                    applyOnce: function(e1) {
                        var t = this;
                        return this.isLeader ? d(0, !0) : this.isDead ? d(0, !1) : this._aplQC > 1 ? this._aplQ : (this._aplQC = this._aplQC + 1, this._aplQ = this._aplQ.then(function() {
                            return function() {
                                if (t.isLeader) return l;
                                var n, r = !1, o = new Promise(function(e1) {
                                    n = function() {
                                        r = !0, e1();
                                    };
                                }), i = function(e1) {
                                    "leader" === e1.context && e1.token != t.token && ("apply" === e1.action && e1.token > t.token && n(), "tell" === e1.action && (n(), t._hasLeader = !0));
                                };
                                t.broadcastChannel.addEventListener("internal", i);
                                var a = e1 ? 4 * t._options.responseTime : t._options.responseTime;
                                return Y(t, "apply").then(function() {
                                    return Promise.race([
                                        d(a),
                                        o.then(function() {
                                            return Promise.reject(new Error);
                                        })
                                    ]);
                                }).then(function() {
                                    return Y(t, "apply");
                                }).then(function() {
                                    return Promise.race([
                                        d(a),
                                        o.then(function() {
                                            return Promise.reject(new Error);
                                        })
                                    ]);
                                }).catch(function() {}).then(function() {
                                    return t.broadcastChannel.removeEventListener("internal", i), !r && z(t).then(function() {
                                        return !0;
                                    });
                                });
                            }();
                        }).then(function() {
                            t._aplQC = t._aplQC - 1;
                        }), this._aplQ.then(function() {
                            return t.isLeader;
                        }));
                    },
                    awaitLeadership: function() {
                        var e1;
                        return this._aLP || (this._aLP = (e1 = this).isLeader ? p : new Promise(function(t) {
                            var n = !1;
                            function r() {
                                n || (n = !0, e1.broadcastChannel.removeEventListener("internal", o), t(!0));
                            }
                            e1.applyOnce().then(function() {
                                e1.isLeader && r();
                            }), function t() {
                                return d(e1._options.fallbackInterval).then(function() {
                                    if (!e1.isDead && !n) return e1.isLeader ? void r() : e1.applyOnce(!0).then(function() {
                                        e1.isLeader ? r() : t();
                                    });
                                });
                            }();
                            var o = function(t) {
                                "leader" === t.context && "death" === t.action && (e1._hasLeader = !1, e1.applyOnce().then(function() {
                                    e1.isLeader && r();
                                }));
                            };
                            e1.broadcastChannel.addEventListener("internal", o), e1._lstns.push(o);
                        })), this._aLP;
                    },
                    set onduplicate (e){
                        this._dpL = e;
                    },
                    die: function() {
                        var e1 = this;
                        return this._lstns.forEach(function(t) {
                            return e1.broadcastChannel.removeEventListener("internal", t);
                        }), this._lstns = [], this._unl.forEach(function(e1) {
                            return e1.remove();
                        }), this._unl = [], this.isLeader && (this._hasLeader = !1, this.isLeader = !1), this.isDead = !0, Y(this, "death");
                    }
                };
                var $ = n(415), ee = function() {
                    function e1() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        (0, a.Z)(this, e1), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "channel", void 0), (0, c.Z)(this, "elector", void 0), (0, c.Z)(this, "started", !1), this.options = t, this.onLeaderDuplicate = this.onLeaderDuplicate.bind(this), this.onLeader = this.onLeader.bind(this);
                    }
                    var t, n, r;
                    return (0, u.Z)(e1, [
                        {
                            key: "onLeaderDuplicate",
                            value: function() {}
                        },
                        {
                            key: "onLeader",
                            value: (r = (0, i.Z)(f().mark(function e1() {
                                var t, n;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.next = 2, null === (t = (n = this.options).onLeader) || void 0 === t ? void 0 : t.call(n);
                                        case 2:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return r.apply(this, arguments);
                            })
                        },
                        {
                            key: "isLeader",
                            value: function() {
                                var e1;
                                return !(null === (e1 = this.elector) || void 0 === e1 || !e1.isLeader);
                            }
                        },
                        {
                            key: "hasLeader",
                            value: function() {
                                var e1;
                                return !(null === (e1 = this.elector) || void 0 === e1 || !e1.hasLeader);
                            }
                        },
                        {
                            key: "start",
                            value: (n = (0, i.Z)(f().mark(function e1() {
                                var t;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            this.canStart() && (t = this.options.electionChannelName, this.channel = new L(t), this.elector = J(this.channel), this.elector.onduplicate = this.onLeaderDuplicate, this.elector.awaitLeadership().then(this.onLeader), this.started = !0);
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: (t = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (!this.started) {
                                                e1.next = 11;
                                                break;
                                            }
                                            if (!this.elector) {
                                                e1.next = 5;
                                                break;
                                            }
                                            return e1.next = 4, this.elector.die();
                                        case 4:
                                            this.elector = void 0;
                                        case 5:
                                            if (!this.channel) {
                                                e1.next = 10;
                                                break;
                                            }
                                            return this.channel.postInternal = function() {
                                                return Promise.resolve();
                                            }, e1.next = 9, this.channel.close();
                                        case 9:
                                            this.channel = void 0;
                                        case 10:
                                            this.started = !1;
                                        case 11:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "requiresLeadership",
                            value: function() {
                                return !1;
                            }
                        },
                        {
                            key: "isStarted",
                            value: function() {
                                return this.started;
                            }
                        },
                        {
                            key: "canStart",
                            value: function() {
                                return (0, $.isBrowser)() && !this.started;
                            }
                        }
                    ]), e1;
                }(), te = n(9123), ne = n(6488), re = n(7088), oe = function() {
                    function e1(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        (0, a.Z)(this, e1), (0, c.Z)(this, "tokenManager", void 0), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "renewTimeQueue", void 0), (0, c.Z)(this, "started", !1), this.tokenManager = t, this.options = n, this.renewTimeQueue = [], this.onTokenExpiredHandler = this.onTokenExpiredHandler.bind(this);
                    }
                    var t, n;
                    return (0, u.Z)(e1, [
                        {
                            key: "shouldThrottleRenew",
                            value: function() {
                                var e1 = !1;
                                if (this.renewTimeQueue.push(Date.now()), this.renewTimeQueue.length >= 10) {
                                    var t = this.renewTimeQueue.shift();
                                    e1 = this.renewTimeQueue[this.renewTimeQueue.length - 1] - t < 3e4;
                                }
                                return e1;
                            }
                        },
                        {
                            key: "requiresLeadership",
                            value: function() {
                                return !!this.options.syncStorage && (0, $.isBrowser)();
                            }
                        },
                        {
                            key: "processExpiredTokens",
                            value: function() {
                                var e1 = this, t = this.tokenManager.getStorage().getStorage();
                                Object.keys(t).forEach(function(n) {
                                    var r = t[n];
                                    !(0, ne.z9)(r) && e1.tokenManager.hasExpired(r) && e1.onTokenExpiredHandler(n);
                                });
                            }
                        },
                        {
                            key: "onTokenExpiredHandler",
                            value: function(e1) {
                                if (this.options.autoRenew) {
                                    if (this.shouldThrottleRenew()) {
                                        var t = new te.Z("Too many token renew requests");
                                        this.tokenManager.emitError(t);
                                    } else this.tokenManager.renew(e1).catch(function() {});
                                } else this.options.autoRemove && this.tokenManager.remove(e1);
                            }
                        },
                        {
                            key: "canStart",
                            value: function() {
                                return !(!this.options.autoRenew && !this.options.autoRemove || this.started);
                            }
                        },
                        {
                            key: "start",
                            value: (n = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            this.canStart() && (this.tokenManager.on(re.$Y, this.onTokenExpiredHandler), this.tokenManager.isStarted() && this.processExpiredTokens(), this.started = !0);
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: (t = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            this.started && (this.tokenManager.off(re.$Y, this.onTokenExpiredHandler), this.renewTimeQueue = [], this.started = !1);
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "isStarted",
                            value: function() {
                                return this.started;
                            }
                        }
                    ]), e1;
                }(), ie = function() {
                    function e1(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        (0, a.Z)(this, e1), (0, c.Z)(this, "tokenManager", void 0), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "channel", void 0), (0, c.Z)(this, "started", !1), (0, c.Z)(this, "enablePostMessage", !0), this.tokenManager = t, this.options = n, this.onTokenAddedHandler = this.onTokenAddedHandler.bind(this), this.onTokenRemovedHandler = this.onTokenRemovedHandler.bind(this), this.onTokenRenewedHandler = this.onTokenRenewedHandler.bind(this), this.onSetStorageHandler = this.onSetStorageHandler.bind(this), this.onSyncMessageHandler = this.onSyncMessageHandler.bind(this);
                    }
                    var t, n;
                    return (0, u.Z)(e1, [
                        {
                            key: "requiresLeadership",
                            value: function() {
                                return !1;
                            }
                        },
                        {
                            key: "isStarted",
                            value: function() {
                                return this.started;
                            }
                        },
                        {
                            key: "canStart",
                            value: function() {
                                return !!this.options.syncStorage && (0, $.isBrowser)() && !this.started;
                            }
                        },
                        {
                            key: "start",
                            value: (n = (0, i.Z)(f().mark(function e1() {
                                var t;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (this.canStart()) {
                                                e1.next = 2;
                                                break;
                                            }
                                            return e1.abrupt("return");
                                        case 2:
                                            t = this.options.syncChannelName, e1.prev = 3, this.channel = new L(t), e1.next = 10;
                                            break;
                                        case 7:
                                            throw e1.prev = 7, e1.t0 = e1.catch(3), new te.Z("SyncStorageService is not supported in current browser.");
                                        case 10:
                                            this.tokenManager.on(re.O3, this.onTokenAddedHandler), this.tokenManager.on(re.FT, this.onTokenRemovedHandler), this.tokenManager.on(re.E, this.onTokenRenewedHandler), this.tokenManager.on(re.zr, this.onSetStorageHandler), this.channel.addEventListener("message", this.onSyncMessageHandler), this.started = !0;
                                        case 16:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this, [
                                    [
                                        3,
                                        7
                                    ]
                                ]);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: (t = (0, i.Z)(f().mark(function e1() {
                                var t, n;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (!this.started) {
                                                e1.next = 10;
                                                break;
                                            }
                                            return this.tokenManager.off(re.O3, this.onTokenAddedHandler), this.tokenManager.off(re.FT, this.onTokenRemovedHandler), this.tokenManager.off(re.E, this.onTokenRenewedHandler), this.tokenManager.off(re.zr, this.onSetStorageHandler), null === (t = this.channel) || void 0 === t || t.removeEventListener("message", this.onSyncMessageHandler), e1.next = 8, null === (n = this.channel) || void 0 === n ? void 0 : n.close();
                                        case 8:
                                            this.channel = void 0, this.started = !1;
                                        case 10:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "onTokenAddedHandler",
                            value: function(e1, t) {
                                var n;
                                this.enablePostMessage && (null === (n = this.channel) || void 0 === n || n.postMessage({
                                    type: re.O3,
                                    key: e1,
                                    token: t
                                }));
                            }
                        },
                        {
                            key: "onTokenRemovedHandler",
                            value: function(e1, t) {
                                var n;
                                this.enablePostMessage && (null === (n = this.channel) || void 0 === n || n.postMessage({
                                    type: re.FT,
                                    key: e1,
                                    token: t
                                }));
                            }
                        },
                        {
                            key: "onTokenRenewedHandler",
                            value: function(e1, t, n) {
                                var r;
                                this.enablePostMessage && (null === (r = this.channel) || void 0 === r || r.postMessage({
                                    type: re.E,
                                    key: e1,
                                    token: t,
                                    oldToken: n
                                }));
                            }
                        },
                        {
                            key: "onSetStorageHandler",
                            value: function(e1) {
                                var t;
                                null === (t = this.channel) || void 0 === t || t.postMessage({
                                    type: re.zr,
                                    storage: e1
                                });
                            }
                        },
                        {
                            key: "onSyncMessageHandler",
                            value: function(e1) {
                                switch(this.enablePostMessage = !1, e1.type){
                                    case re.zr:
                                        this.tokenManager.getStorage().setStorage(e1.storage);
                                        break;
                                    case re.O3:
                                        this.tokenManager.emitAdded(e1.key, e1.token), this.tokenManager.setExpireEventTimeout(e1.key, e1.token);
                                        break;
                                    case re.FT:
                                        this.tokenManager.clearExpireEventTimeout(e1.key), this.tokenManager.emitRemoved(e1.key, e1.token);
                                        break;
                                    case re.E:
                                        this.tokenManager.emitRenewed(e1.key, e1.token, e1.oldToken);
                                }
                                this.enablePostMessage = !0;
                            }
                        }
                    ]), e1;
                }(), ae = function() {
                    return Math.floor(Date.now() / 1e3);
                }, ue = function() {
                    function e1(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        (0, a.Z)(this, e1), (0, c.Z)(this, "tokenManager", void 0), (0, c.Z)(this, "started", !1), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "lastHidden", -1), (0, c.Z)(this, "onPageVisbilityChange", void 0), this.tokenManager = t, this.options = n, this.onPageVisbilityChange = this._onPageVisbilityChange.bind(this);
                    }
                    var t, n;
                    return (0, u.Z)(e1, [
                        {
                            key: "_onPageVisbilityChange",
                            value: function() {
                                if (document.hidden) this.lastHidden = ae();
                                else if (this.lastHidden > 0 && ae() - this.lastHidden >= this.options.tabInactivityDuration) {
                                    var e1 = this.tokenManager.getTokensSync(), t = e1.accessToken, n = e1.idToken;
                                    if (t && this.tokenManager.hasExpired(t)) {
                                        var r = this.tokenManager.getStorageKeyByType("accessToken");
                                        this.tokenManager.renew(r).catch(function() {});
                                    } else if (n && this.tokenManager.hasExpired(n)) {
                                        var o = this.tokenManager.getStorageKeyByType("idToken");
                                        this.tokenManager.renew(o).catch(function() {});
                                    }
                                }
                            }
                        },
                        {
                            key: "start",
                            value: (n = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            this.canStart() && document && (document.addEventListener("visibilitychange", this.onPageVisbilityChange), this.started = !0);
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: (t = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            document && (document.removeEventListener("visibilitychange", this.onPageVisbilityChange), this.started = !1);
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "canStart",
                            value: function() {
                                return (0, $.isBrowser)() && !!this.options.autoRenew && !!this.options.renewOnTabActivation && !this.started;
                            }
                        },
                        {
                            key: "requiresLeadership",
                            value: function() {
                                return !1;
                            }
                        },
                        {
                            key: "isStarted",
                            value: function() {
                                return this.started;
                            }
                        }
                    ]), e1;
                }(), ce = n(3193);
                function se(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function fe(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? se(Object(n), !0).forEach(function(t) {
                            (0, c.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : se(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function le(e1, t) {
                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e1) || (n = function(e1, t) {
                            if (e1) {
                                if ("string" == typeof e1) return pe(e1, t);
                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? pe(e1, t) : void 0;
                            }
                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                            n && (e1 = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e1.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e1[r++]
                                    };
                                },
                                e: function(e1) {
                                    throw e1;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, u = !1;
                    return {
                        s: function() {
                            n = n.call(e1);
                        },
                        n: function() {
                            var e1 = n.next();
                            return a = e1.done, e1;
                        },
                        e: function(e1) {
                            u = !0, i = e1;
                        },
                        f: function() {
                            try {
                                a || null == n.return || n.return();
                            } finally{
                                if (u) throw i;
                            }
                        }
                    };
                }
                function pe(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var de = "autoRenew", he = "syncStorage", ve = "leaderElection", ye = "renewOnTabActivation", ge = function() {
                    function e1(t) {
                        var n = this, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        (0, a.Z)(this, e1), (0, c.Z)(this, "sdk", void 0), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "services", void 0), (0, c.Z)(this, "started", void 0), this.sdk = t, this.onLeader = this.onLeader.bind(this);
                        var o = t.tokenManager.getOptions(), i = o.autoRenew, u = o.autoRemove, s = o.syncStorage;
                        r.electionChannelName = r.electionChannelName || r.broadcastChannelName, this.options = Object.assign({}, e1.defaultOptions, {
                            autoRenew: i,
                            autoRemove: u,
                            syncStorage: s
                        }, {
                            electionChannelName: "".concat(t.options.clientId, "-election"),
                            syncChannelName: "".concat(t.options.clientId, "-sync")
                        }, (0, ce.YY)(r)), this.started = !1, this.services = new Map, e1.knownServices.forEach(function(e1) {
                            var t = n.createService(e1);
                            t && n.services.set(e1, t);
                        });
                    }
                    var t, n, s, l, p;
                    return (0, u.Z)(e1, [
                        {
                            key: "onLeader",
                            value: (p = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (!this.started) {
                                                e1.next = 3;
                                                break;
                                            }
                                            return e1.next = 3, this.startServices();
                                        case 3:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return p.apply(this, arguments);
                            })
                        },
                        {
                            key: "isLeader",
                            value: function() {
                                var e1;
                                return null === (e1 = this.getService(ve)) || void 0 === e1 ? void 0 : e1.isLeader();
                            }
                        },
                        {
                            key: "isLeaderRequired",
                            value: function() {
                                return (0, o.Z)(this.services.values()).some(function(e1) {
                                    return e1.canStart() && e1.requiresLeadership();
                                });
                            }
                        },
                        {
                            key: "start",
                            value: (l = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            if (!this.started) {
                                                e1.next = 2;
                                                break;
                                            }
                                            return e1.abrupt("return");
                                        case 2:
                                            return e1.next = 4, this.startServices();
                                        case 4:
                                            this.started = !0;
                                        case 5:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return l.apply(this, arguments);
                            })
                        },
                        {
                            key: "stop",
                            value: (s = (0, i.Z)(f().mark(function e1() {
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.next = 2, this.stopServices();
                                        case 2:
                                            this.started = !1;
                                        case 3:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return s.apply(this, arguments);
                            })
                        },
                        {
                            key: "getService",
                            value: function(e1) {
                                return this.services.get(e1);
                            }
                        },
                        {
                            key: "startServices",
                            value: (n = (0, i.Z)(f().mark(function e1() {
                                var t, n, o, i, a;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            t = le(this.services.entries()), e1.prev = 1, t.s();
                                        case 3:
                                            if ((n = t.n()).done) {
                                                e1.next = 10;
                                                break;
                                            }
                                            if (o = (0, r.Z)(n.value, 2), i = o[0], a = o[1], !this.canStartService(i, a)) {
                                                e1.next = 8;
                                                break;
                                            }
                                            return e1.next = 8, a.start();
                                        case 8:
                                            e1.next = 3;
                                            break;
                                        case 10:
                                            e1.next = 15;
                                            break;
                                        case 12:
                                            e1.prev = 12, e1.t0 = e1.catch(1), t.e(e1.t0);
                                        case 15:
                                            return e1.prev = 15, t.f(), e1.finish(15);
                                        case 18:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this, [
                                    [
                                        1,
                                        12,
                                        15,
                                        18
                                    ]
                                ]);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "stopServices",
                            value: (t = (0, i.Z)(f().mark(function e1() {
                                var t, n, r;
                                return f().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            t = le(this.services.values()), e1.prev = 1, t.s();
                                        case 3:
                                            if ((n = t.n()).done) {
                                                e1.next = 9;
                                                break;
                                            }
                                            return r = n.value, e1.next = 7, r.stop();
                                        case 7:
                                            e1.next = 3;
                                            break;
                                        case 9:
                                            e1.next = 14;
                                            break;
                                        case 11:
                                            e1.prev = 11, e1.t0 = e1.catch(1), t.e(e1.t0);
                                        case 14:
                                            return e1.prev = 14, t.f(), e1.finish(14);
                                        case 17:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this, [
                                    [
                                        1,
                                        11,
                                        14,
                                        17
                                    ]
                                ]);
                            })), function() {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "canStartService",
                            value: function(e1, t) {
                                var n = t.canStart() && !t.isStarted();
                                return e1 === ve ? n && (n = this.isLeaderRequired()) : t.requiresLeadership() && n && (n = this.isLeader()), n;
                            }
                        },
                        {
                            key: "createService",
                            value: function(e1) {
                                var t, n = this.sdk.tokenManager;
                                switch(e1){
                                    case ve:
                                        t = new ee(fe(fe({}, this.options), {}, {
                                            onLeader: this.onLeader
                                        }));
                                        break;
                                    case de:
                                        t = new oe(n, fe({}, this.options));
                                        break;
                                    case he:
                                        t = new ie(n, fe({}, this.options));
                                        break;
                                    case ye:
                                        t = new ue(n, fe({}, this.options));
                                        break;
                                    default:
                                        throw new Error("Unknown service ".concat(e1));
                                }
                                return t;
                            }
                        }
                    ]), e1;
                }();
                (0, c.Z)(ge, "knownServices", [
                    de,
                    he,
                    ve,
                    ye
                ]), (0, c.Z)(ge, "defaultOptions", {
                    autoRenew: !0,
                    autoRemove: !0,
                    syncStorage: !0,
                    renewOnTabActivation: !0,
                    tabInactivityDuration: 1800
                });
            },
            6599: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    W: function() {
                        return r.W;
                    }
                });
                var r = n(9046);
            },
            1578: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    K: function() {
                        return s;
                    }
                });
                var r = n(9893), o = n(265), i = n(279), a = n(2724), u = n(8386), c = n(3980);
                function s(e1, t, n) {
                    var s = (0, r.a)(t), f = (0, o.H)(s, e1), l = (0, i.A)(f), p = (0, c.Z)(l), d = (0, a.J)(p, n);
                    return (0, u.i)(d);
                }
            },
            3961: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    AuthStateManager: function() {
                        return r.E;
                    },
                    INITIAL_AUTH_STATE: function() {
                        return r.a;
                    },
                    ServiceManager: function() {
                        return l.W;
                    },
                    createCoreOptionsConstructor: function() {
                        return o.n;
                    },
                    createCoreStorageManager: function() {
                        return u.a;
                    },
                    createOktaAuthCore: function() {
                        return i.K;
                    },
                    mixinCore: function() {
                        return a.i;
                    }
                });
                var r = n(1018), o = n(9133), i = n(1578), a = n(8386), u = n(2647), c = n(8553), s = {};
                for(var f in c)[
                    "default",
                    "AuthStateManager",
                    "INITIAL_AUTH_STATE",
                    "createCoreOptionsConstructor",
                    "createOktaAuthCore",
                    "mixinCore",
                    "createCoreStorageManager"
                ].indexOf(f) < 0 && (s[f] = (function(e1) {
                    return c[e1];
                }).bind(0, f));
                n.d(t, s);
                var l = n(6599);
            },
            8386: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    i: function() {
                        return g;
                    }
                });
                var r = n(5861), o = n(5671), i = n(3144), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(4687), p = n.n(l), d = n(5372), h = n(1018), v = n(9046), y = n(9123);
                function g(e1) {
                    return function(e1) {
                        (0, u.Z)(w, e1);
                        var t, n, l, g, m, b, k = (m = w, b = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, t = (0, s.Z)(m);
                            if (b) {
                                var n = (0, s.Z)(this).constructor;
                                e1 = Reflect.construct(t, arguments, n);
                            } else e1 = t.apply(this, arguments);
                            return (0, c.Z)(this, e1);
                        });
                        function w() {
                            var e1;
                            (0, o.Z)(this, w);
                            for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                            return e1 = k.call.apply(k, [
                                this
                            ].concat(n)), (0, f.Z)((0, a.Z)(e1), "authStateManager", void 0), (0, f.Z)((0, a.Z)(e1), "serviceManager", void 0), e1.authStateManager = new h.E((0, a.Z)(e1)), e1.serviceManager = new v.W((0, a.Z)(e1), e1.options.services), e1;
                        }
                        return (0, i.Z)(w, [
                            {
                                key: "start",
                                value: (g = (0, r.Z)(p().mark(function e1() {
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.next = 2, this.serviceManager.start();
                                            case 2:
                                                if (this.tokenManager.start(), this.token.isLoginRedirect()) {
                                                    e1.next = 6;
                                                    break;
                                                }
                                                return e1.next = 6, this.authStateManager.updateAuthState();
                                            case 6:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function() {
                                    return g.apply(this, arguments);
                                })
                            },
                            {
                                key: "stop",
                                value: (l = (0, r.Z)(p().mark(function e1() {
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return this.tokenManager.stop(), e1.next = 3, this.serviceManager.stop();
                                            case 3:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function() {
                                    return l.apply(this, arguments);
                                })
                            },
                            {
                                key: "handleRedirect",
                                value: (n = (0, r.Z)(p().mark(function e1(t) {
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.next = 2, this.handleLoginRedirect(void 0, t);
                                            case 2:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return n.apply(this, arguments);
                                })
                            },
                            {
                                key: "handleLoginRedirect",
                                value: (t = (0, r.Z)(p().mark(function e1(t, n) {
                                    var r, o, i;
                                    return p().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (r = this.options.state, !t) {
                                                    e1.next = 6;
                                                    break;
                                                }
                                                this.tokenManager.setTokens(t), n = n || this.getOriginalUri(this.options.state), e1.next = 25;
                                                break;
                                            case 6:
                                                if (!this.isLoginRedirect()) {
                                                    e1.next = 24;
                                                    break;
                                                }
                                                return e1.prev = 7, e1.next = 10, (0, d.Tp)(this, {});
                                            case 10:
                                                return o = e1.sent, r = o.state, n = n || this.getOriginalUri(r), e1.next = 15, this.storeTokensFromRedirect();
                                            case 15:
                                                e1.next = 22;
                                                break;
                                            case 17:
                                                return e1.prev = 17, e1.t0 = e1.catch(7), e1.next = 21, this.authStateManager.updateAuthState();
                                            case 21:
                                                throw e1.t0;
                                            case 22:
                                                e1.next = 25;
                                                break;
                                            case 24:
                                                return e1.abrupt("return");
                                            case 25:
                                                return e1.next = 27, this.authStateManager.updateAuthState();
                                            case 27:
                                                if (this.removeOriginalUri(r), !(i = this.options.restoreOriginalUri)) {
                                                    e1.next = 34;
                                                    break;
                                                }
                                                return e1.next = 32, i(this, n);
                                            case 32:
                                                e1.next = 35;
                                                break;
                                            case 34:
                                                n && window.location.replace(n);
                                            case 35:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this, [
                                        [
                                            7,
                                            17
                                        ]
                                    ]);
                                })), function(e1, n) {
                                    return t.apply(this, arguments);
                                })
                            },
                            {
                                key: "handleIDPPopupRedirect",
                                value: function() {
                                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window.location.href, t = (0, d.Tp)(this, {
                                        responseMode: "query",
                                        url: e1
                                    });
                                    if (!t.state) throw new y.Z("Unable to parse auth code params");
                                    var n = new BroadcastChannel("popup-callback:".concat(t.state));
                                    n.postMessage(t), n.close();
                                }
                            }
                        ]), w;
                    }(e1);
                }
            },
            9133: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    n: function() {
                        return l;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(9453);
                function l() {
                    return function(e1) {
                        (0, a.Z)(l, e1);
                        var t, n, f = (t = l, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function l(e1) {
                            var t;
                            return (0, o.Z)(this, l), t = f.call(this, e1), (0, s.Z)((0, i.Z)(t), "services", void 0), (0, s.Z)((0, i.Z)(t), "transformAuthState", void 0), t.services = e1.services, t.transformAuthState = e1.transformAuthState, t;
                        }
                        return (0, r.Z)(l);
                    }((0, f.m)());
                }
            },
            2647: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return o;
                    }
                });
                var r = n(2333);
                function o() {
                    return (0, r.a)();
                }
            },
            5675: function() {},
            8553: function(e1, t, n) {
                "use strict";
                n.r(t);
                var r = n(5675), o = {};
                for(var i in r)"default" !== i && (o[i] = (function(e1) {
                    return r[e1];
                }).bind(0, i));
                n.d(t, o);
            },
            7987: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Df: function() {
                        return u;
                    },
                    EL: function() {
                        return f;
                    },
                    NL: function() {
                        return i;
                    },
                    Wy: function() {
                        return c;
                    },
                    aR: function() {
                        return a;
                    },
                    dX: function() {
                        return l;
                    },
                    k8: function() {
                        return s;
                    },
                    kQ: function() {
                        return p;
                    }
                });
                var r = n(9123), o = n(7594);
                function i(e1) {
                    return a((0, o.r3)(e1));
                }
                function a(e1) {
                    return e1.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
                }
                function u(e1) {
                    return e1.replace(/-/g, "+").replace(/_/g, "/");
                }
                function c(e1) {
                    var t = u(e1);
                    switch(t.length % 4){
                        case 0:
                            break;
                        case 2:
                            t += "==";
                            break;
                        case 3:
                            t += "=";
                            break;
                        default:
                            throw new r.Z("Not a valid Base64Url");
                    }
                    var n = (0, o.ty)(t);
                    try {
                        return decodeURIComponent(escape(n));
                    } catch (e1) {
                        return n;
                    }
                }
                function s(e1) {
                    for(var t = new Uint8Array(e1.length), n = 0; n < e1.length; n++)t[n] = e1.charCodeAt(n);
                    return t;
                }
                function f(e1) {
                    return (0, o.ty)(u(e1));
                }
                function l(e1) {
                    return Uint8Array.from(f(e1), function(e1) {
                        return e1.charCodeAt(0);
                    });
                }
                function p(e1) {
                    return (0, o.r3)(new Uint8Array(e1).reduce(function(e1, t) {
                        return e1 + String.fromCharCode(t);
                    }, ""));
                }
            },
            7594: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    KP: function() {
                        return i;
                    },
                    r3: function() {
                        return o;
                    },
                    ty: function() {
                        return r;
                    }
                });
                var r = function(e1) {
                    return atob(e1);
                }, o = function(e1) {
                    return btoa(e1);
                }, i = "undefined" == typeof crypto ? null : crypto;
            },
            9718: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    atob: function() {
                        return s.ty;
                    },
                    base64ToBase64Url: function() {
                        return r.aR;
                    },
                    base64UrlDecode: function() {
                        return r.EL;
                    },
                    base64UrlToBase64: function() {
                        return r.Df;
                    },
                    base64UrlToBuffer: function() {
                        return r.dX;
                    },
                    base64UrlToString: function() {
                        return r.Wy;
                    },
                    btoa: function() {
                        return s.r3;
                    },
                    bufferToBase64Url: function() {
                        return r.kQ;
                    },
                    getOidcHash: function() {
                        return o.X;
                    },
                    stringToBase64Url: function() {
                        return r.NL;
                    },
                    stringToBuffer: function() {
                        return r.k8;
                    },
                    verifyToken: function() {
                        return c.W;
                    },
                    webcrypto: function() {
                        return s.KP;
                    }
                });
                var r = n(7987), o = n(5698), i = n(6332), a = {};
                for(var u in i)[
                    "default",
                    "base64ToBase64Url",
                    "base64UrlDecode",
                    "base64UrlToBase64",
                    "base64UrlToBuffer",
                    "base64UrlToString",
                    "bufferToBase64Url",
                    "stringToBase64Url",
                    "stringToBuffer",
                    "getOidcHash"
                ].indexOf(u) < 0 && (a[u] = (function(e1) {
                    return i[e1];
                }).bind(0, u));
                n.d(t, a);
                var c = n(3154), s = n(1);
            },
            5698: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return i;
                    }
                });
                var r = n(7987), o = n(7594);
                function i(e1) {
                    var t = (new TextEncoder).encode(e1);
                    return o.KP.subtle.digest("SHA-256", t).then(function(e1) {
                        var t = new Uint8Array(e1).slice(0, 16), n = String.fromCharCode.apply(null, t);
                        return (0, r.NL)(n);
                    });
                }
            },
            6332: function() {},
            3154: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    W: function() {
                        return a;
                    }
                });
                var r = n(3193), o = n(7987), i = n(7594);
                function a(e1, t) {
                    t = (0, r.d9)(t);
                    var n = {
                        name: "RSASSA-PKCS1-v1_5",
                        hash: {
                            name: "SHA-256"
                        }
                    };
                    return delete t.use, i.KP.subtle.importKey("jwk", t, n, !0, [
                        "verify"
                    ]).then(function(t) {
                        var r = e1.split("."), a = (0, o.k8)(r[0] + "." + r[1]), u = (0, o.EL)(r[2]), c = (0, o.k8)(u);
                        return i.KP.subtle.verify(n, t, c, a);
                    });
                }
            },
            1: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    KP: function() {
                        return r.KP;
                    },
                    r3: function() {
                        return r.r3;
                    },
                    ty: function() {
                        return r.ty;
                    }
                });
                var r = n(7594);
            },
            3983: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return f;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                var f = function(e1) {
                    (0, a.Z)(l, e1);
                    var t, n, f = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function l(e1, t, n) {
                        var r;
                        (0, o.Z)(this, l);
                        var a = e1.errorSummary;
                        return r = f.call(this, a), (0, s.Z)((0, i.Z)(r), "errorSummary", void 0), (0, s.Z)((0, i.Z)(r), "errorCode", void 0), (0, s.Z)((0, i.Z)(r), "errorLink", void 0), (0, s.Z)((0, i.Z)(r), "errorId", void 0), (0, s.Z)((0, i.Z)(r), "errorCauses", void 0), (0, s.Z)((0, i.Z)(r), "xhr", void 0), (0, s.Z)((0, i.Z)(r), "meta", void 0), r.name = "AuthApiError", r.errorSummary = e1.errorSummary, r.errorCode = e1.errorCode, r.errorLink = e1.errorLink, r.errorId = e1.errorId, r.errorCauses = e1.errorCauses, t && (r.xhr = t), n && (r.meta = n), r;
                    }
                    return (0, r.Z)(l);
                }(n(6245).Z);
            },
            6573: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return c;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120);
                var c = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.call(this, "The poll was stopped by the sdk");
                    }
                    return (0, r.Z)(s);
                }(n(6245).Z);
            },
            9123: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return f;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                var f = function(e1) {
                    (0, a.Z)(l, e1);
                    var t, n, f = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function l(e1, t) {
                        var n;
                        return (0, o.Z)(this, l), n = f.call(this, e1), (0, s.Z)((0, i.Z)(n), "errorSummary", void 0), (0, s.Z)((0, i.Z)(n), "errorCode", void 0), (0, s.Z)((0, i.Z)(n), "errorLink", void 0), (0, s.Z)((0, i.Z)(n), "errorId", void 0), (0, s.Z)((0, i.Z)(n), "errorCauses", void 0), (0, s.Z)((0, i.Z)(n), "xhr", void 0), n.name = "AuthSdkError", n.errorCode = "INTERNAL", n.errorSummary = e1, n.errorLink = "INTERNAL", n.errorId = "INTERNAL", n.errorCauses = [], t && (n.xhr = t), n;
                    }
                    return (0, r.Z)(l);
                }(n(6245).Z);
            },
            6245: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return p;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(9611);
                function f() {
                    try {
                        var e1 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (e1) {}
                    return (f = function() {
                        return !!e1;
                    })();
                }
                function l(e1) {
                    var t = "function" == typeof Map ? new Map : void 0;
                    return l = function(e1) {
                        if (null === e1 || !function(e1) {
                            try {
                                return -1 !== Function.toString.call(e1).indexOf("[native code]");
                            } catch (t) {
                                return "function" == typeof e1;
                            }
                        }(e1)) return e1;
                        if ("function" != typeof e1) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== t) {
                            if (t.has(e1)) return t.get(e1);
                            t.set(e1, n);
                        }
                        function n() {
                            return function(e1, t, n) {
                                if (f()) return Reflect.construct.apply(null, arguments);
                                var r = [
                                    null
                                ];
                                r.push.apply(r, t);
                                var o = new (e1.bind.apply(e1, r));
                                return n && (0, s.Z)(o, n.prototype), o;
                            }(e1, arguments, (0, c.Z)(this).constructor);
                        }
                        return n.prototype = Object.create(e1.prototype, {
                            constructor: {
                                value: n,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), (0, s.Z)(n, e1);
                    }, l(e1);
                }
                var p = function(e1) {
                    (0, a.Z)(f, e1);
                    var t, n, s = (t = f, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function f(e1) {
                        var t;
                        return (0, o.Z)(this, f), t = s.call(this, e1), Object.setPrototypeOf((0, i.Z)(t), (this instanceof f ? this.constructor : void 0).prototype), t;
                    }
                    return (0, r.Z)(f);
                }(l(Error));
            },
            2886: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return f;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                var f = function(e1) {
                    (0, a.Z)(l, e1);
                    var t, n, f = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function l(e1, t, n) {
                        var r;
                        return (0, o.Z)(this, l), r = f.call(this, t), (0, s.Z)((0, i.Z)(r), "errorCode", void 0), (0, s.Z)((0, i.Z)(r), "errorSummary", void 0), (0, s.Z)((0, i.Z)(r), "error", void 0), (0, s.Z)((0, i.Z)(r), "error_description", void 0), (0, s.Z)((0, i.Z)(r), "resp", null), r.name = "OAuthError", r.errorCode = e1, r.errorSummary = t, r.error = e1, r.error_description = t, n && (r.resp = n), r;
                    }
                    return (0, r.Z)(l);
                }(n(6245).Z);
            },
            3114: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(6245), l = n(4771);
                var p = function(e1) {
                    (0, a.Z)(p, e1);
                    var t, n, f = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function p(e1, t, n) {
                        var o, a;
                        return (0, r.Z)(this, p), a = f.call(this, null !== (o = t.error) && void 0 !== o ? o : p.UNKNOWN_ERROR), (0, s.Z)((0, i.Z)(a), "scheme", void 0), (0, s.Z)((0, i.Z)(a), "parameters", void 0), (0, s.Z)((0, i.Z)(a), "name", "WWWAuthError"), (0, s.Z)((0, i.Z)(a), "resp", null), a.scheme = e1, a.parameters = t, n && (a.resp = n), a;
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "error",
                            get: function() {
                                return this.parameters.error;
                            }
                        },
                        {
                            key: "errorCode",
                            get: function() {
                                return this.error;
                            }
                        },
                        {
                            key: "error_description",
                            get: function() {
                                return this.parameters.error_description;
                            }
                        },
                        {
                            key: "errorDescription",
                            get: function() {
                                return this.error_description;
                            }
                        },
                        {
                            key: "errorSummary",
                            get: function() {
                                return this.errorDescription;
                            }
                        },
                        {
                            key: "realm",
                            get: function() {
                                return this.parameters.realm;
                            }
                        }
                    ], [
                        {
                            key: "parseHeader",
                            value: function(e1) {
                                if (!e1) return null;
                                for(var t, n = /(?:,|, )?([a-zA-Z0-9!#$%&'*+\-.^_`|~]+)=(?:"([a-zA-Z0-9!#$%&'*+\-.,^_`|~ /:]+)"|([a-zA-Z0-9!#$%&'*+\-.^_`|~/:]+))/g, r = e1.indexOf(" "), o = e1.slice(0, r), i = e1.slice(r + 1), a = {}; null !== (t = n.exec(i));){
                                    var u;
                                    a[t[1]] = null !== (u = t[2]) && void 0 !== u ? u : t[3];
                                }
                                return new p(o, a);
                            }
                        },
                        {
                            key: "getWWWAuthenticateHeader",
                            value: function() {
                                var e1, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                return (0, l.mf)(null == t ? void 0 : t.get) ? t.get("WWW-Authenticate") : null !== (e1 = t["www-authenticate"]) && void 0 !== e1 ? e1 : t["WWW-Authenticate"];
                            }
                        }
                    ]), p;
                }(f.Z);
                (0, s.Z)(p, "UNKNOWN_ERROR", "UNKNOWN_WWW_AUTH_ERROR");
            },
            5728: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    AuthApiError: function() {
                        return r.Z;
                    },
                    AuthPollStopError: function() {
                        return o.Z;
                    },
                    AuthSdkError: function() {
                        return i.Z;
                    },
                    OAuthError: function() {
                        return a.Z;
                    },
                    WWWAuthError: function() {
                        return u.Z;
                    },
                    isAuthApiError: function() {
                        return l;
                    },
                    isOAuthError: function() {
                        return p;
                    },
                    isWWWAuthError: function() {
                        return d;
                    }
                });
                var r = n(3983), o = n(6573), i = n(9123), a = n(2886), u = n(3114), c = n(1243), s = {};
                for(var f in c)[
                    "default",
                    "isAuthApiError",
                    "isOAuthError",
                    "isWWWAuthError",
                    "AuthApiError",
                    "AuthPollStopError",
                    "AuthSdkError",
                    "OAuthError",
                    "WWWAuthError"
                ].indexOf(f) < 0 && (s[f] = (function(e1) {
                    return c[e1];
                }).bind(0, f));
                function l(e1) {
                    return e1 instanceof r.Z;
                }
                function p(e1) {
                    return e1 instanceof a.Z;
                }
                function d(e1) {
                    return e1 instanceof u.Z;
                }
                n.d(t, s);
            },
            1243: function() {},
            6736: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    ACCESS_TOKEN_STORAGE_KEY: function() {
                        return i.ACCESS_TOKEN_STORAGE_KEY;
                    },
                    BaseStorageManager: function() {
                        return d.W8;
                    },
                    CACHE_STORAGE_NAME: function() {
                        return i.CACHE_STORAGE_NAME;
                    },
                    DEFAULT_CACHE_DURATION: function() {
                        return i.DEFAULT_CACHE_DURATION;
                    },
                    DEFAULT_CODE_CHALLENGE_METHOD: function() {
                        return i.DEFAULT_CODE_CHALLENGE_METHOD;
                    },
                    DEFAULT_MAX_CLOCK_SKEW: function() {
                        return i.DEFAULT_MAX_CLOCK_SKEW;
                    },
                    DEFAULT_POLLING_DELAY: function() {
                        return i.DEFAULT_POLLING_DELAY;
                    },
                    IDX_API_VERSION: function() {
                        return i.IDX_API_VERSION;
                    },
                    IDX_RESPONSE_STORAGE_NAME: function() {
                        return i.IDX_RESPONSE_STORAGE_NAME;
                    },
                    ID_TOKEN_STORAGE_KEY: function() {
                        return i.ID_TOKEN_STORAGE_KEY;
                    },
                    IOS_MAX_RETRY_COUNT: function() {
                        return i.IOS_MAX_RETRY_COUNT;
                    },
                    MAX_VERIFIER_LENGTH: function() {
                        return i.MAX_VERIFIER_LENGTH;
                    },
                    MIN_VERIFIER_LENGTH: function() {
                        return i.MIN_VERIFIER_LENGTH;
                    },
                    ORIGINAL_URI_STORAGE_NAME: function() {
                        return i.ORIGINAL_URI_STORAGE_NAME;
                    },
                    OktaUserAgent: function() {
                        return f.ed;
                    },
                    PKCE_STORAGE_NAME: function() {
                        return i.PKCE_STORAGE_NAME;
                    },
                    PromiseQueue: function() {
                        return h.bo;
                    },
                    REFERRER_PATH_STORAGE_KEY: function() {
                        return i.REFERRER_PATH_STORAGE_KEY;
                    },
                    REFRESH_TOKEN_STORAGE_KEY: function() {
                        return i.REFRESH_TOKEN_STORAGE_KEY;
                    },
                    SHARED_TRANSACTION_STORAGE_NAME: function() {
                        return i.SHARED_TRANSACTION_STORAGE_NAME;
                    },
                    STATE_TOKEN_KEY_NAME: function() {
                        return i.STATE_TOKEN_KEY_NAME;
                    },
                    SavedObject: function() {
                        return d._e;
                    },
                    TOKEN_STORAGE_NAME: function() {
                        return i.TOKEN_STORAGE_NAME;
                    },
                    TRANSACTION_STORAGE_NAME: function() {
                        return i.TRANSACTION_STORAGE_NAME;
                    },
                    bind: function() {
                        return h.ak;
                    },
                    clone: function() {
                        return h.d9;
                    },
                    closeSession: function() {
                        return p.RJ;
                    },
                    createBaseOptionsConstructor: function() {
                        return o.X;
                    },
                    createHttpOptionsConstructor: function() {
                        return f.ZM;
                    },
                    createOktaAuthBase: function() {
                        return o.a;
                    },
                    createSessionApi: function() {
                        return p.MG;
                    },
                    createStorageOptionsConstructor: function() {
                        return d.Tp;
                    },
                    crypto: function() {
                        return r;
                    },
                    delay: function() {
                        return h.gw;
                    },
                    deprecate: function() {
                        return h.Rn;
                    },
                    deprecateWrap: function() {
                        return h.VA;
                    },
                    extend: function() {
                        return h.l7;
                    },
                    find: function() {
                        return h.sE;
                    },
                    genRandomString: function() {
                        return h.uh;
                    },
                    get: function() {
                        return f.U2;
                    },
                    getConsole: function() {
                        return h.dr;
                    },
                    getLink: function() {
                        return h.Rg;
                    },
                    getNativeConsole: function() {
                        return h.sW;
                    },
                    getSession: function() {
                        return p.Gg;
                    },
                    httpRequest: function() {
                        return f.c3;
                    },
                    isAbsoluteUrl: function() {
                        return h.sD;
                    },
                    isFunction: function() {
                        return h.mf;
                    },
                    isNumber: function() {
                        return h.hj;
                    },
                    isObject: function() {
                        return h.Kn;
                    },
                    isPromise: function() {
                        return h.tI;
                    },
                    isString: function() {
                        return h.HD;
                    },
                    isoToUTCString: function() {
                        return h.ng;
                    },
                    logServerSideMemoryStorageWarning: function() {
                        return d.Vp;
                    },
                    mixinHttp: function() {
                        return f.Am;
                    },
                    mixinSession: function() {
                        return p.Zg;
                    },
                    mixinStorage: function() {
                        return d.Ho;
                    },
                    omit: function() {
                        return h.CE;
                    },
                    post: function() {
                        return f.v_;
                    },
                    refreshSession: function() {
                        return p.dx;
                    },
                    removeNils: function() {
                        return h.YY;
                    },
                    removeTrailingSlash: function() {
                        return h.Qj;
                    },
                    sessionExists: function() {
                        return p.sH;
                    },
                    setCookieAndRedirect: function() {
                        return p.OT;
                    },
                    setRequestHeader: function() {
                        return f.rn;
                    },
                    split2: function() {
                        return h.YQ;
                    },
                    toAbsoluteUrl: function() {
                        return h.BY;
                    },
                    toQueryString: function() {
                        return h.UK;
                    },
                    toRelativeUrl: function() {
                        return h.QN;
                    },
                    warn: function() {
                        return h.ZK;
                    }
                });
                var r = n(9718), o = n(3306), i = n(1971), a = n(3961), u = {};
                for(var c in a)[
                    "default",
                    "crypto",
                    "createBaseOptionsConstructor",
                    "createOktaAuthBase",
                    "ACCESS_TOKEN_STORAGE_KEY",
                    "CACHE_STORAGE_NAME",
                    "DEFAULT_CACHE_DURATION",
                    "DEFAULT_CODE_CHALLENGE_METHOD",
                    "DEFAULT_MAX_CLOCK_SKEW",
                    "DEFAULT_POLLING_DELAY",
                    "IDX_API_VERSION",
                    "IDX_RESPONSE_STORAGE_NAME",
                    "ID_TOKEN_STORAGE_KEY",
                    "IOS_MAX_RETRY_COUNT",
                    "MAX_VERIFIER_LENGTH",
                    "MIN_VERIFIER_LENGTH",
                    "ORIGINAL_URI_STORAGE_NAME",
                    "PKCE_STORAGE_NAME",
                    "REFERRER_PATH_STORAGE_KEY",
                    "REFRESH_TOKEN_STORAGE_KEY",
                    "SHARED_TRANSACTION_STORAGE_NAME",
                    "STATE_TOKEN_KEY_NAME",
                    "TOKEN_STORAGE_NAME",
                    "TRANSACTION_STORAGE_NAME"
                ].indexOf(c) < 0 && (u[c] = (function(e1) {
                    return a[e1];
                }).bind(0, c));
                n.d(t, u);
                var s = n(5728);
                for(var c in u = {}, s)[
                    "default",
                    "crypto",
                    "createBaseOptionsConstructor",
                    "createOktaAuthBase",
                    "ACCESS_TOKEN_STORAGE_KEY",
                    "CACHE_STORAGE_NAME",
                    "DEFAULT_CACHE_DURATION",
                    "DEFAULT_CODE_CHALLENGE_METHOD",
                    "DEFAULT_MAX_CLOCK_SKEW",
                    "DEFAULT_POLLING_DELAY",
                    "IDX_API_VERSION",
                    "IDX_RESPONSE_STORAGE_NAME",
                    "ID_TOKEN_STORAGE_KEY",
                    "IOS_MAX_RETRY_COUNT",
                    "MAX_VERIFIER_LENGTH",
                    "MIN_VERIFIER_LENGTH",
                    "ORIGINAL_URI_STORAGE_NAME",
                    "PKCE_STORAGE_NAME",
                    "REFERRER_PATH_STORAGE_KEY",
                    "REFRESH_TOKEN_STORAGE_KEY",
                    "SHARED_TRANSACTION_STORAGE_NAME",
                    "STATE_TOKEN_KEY_NAME",
                    "TOKEN_STORAGE_NAME",
                    "TRANSACTION_STORAGE_NAME",
                    "AuthStateManager",
                    "INITIAL_AUTH_STATE",
                    "ServiceManager",
                    "createCoreOptionsConstructor",
                    "createCoreStorageManager",
                    "createOktaAuthCore",
                    "mixinCore"
                ].indexOf(c) < 0 && (u[c] = (function(e1) {
                    return s[e1];
                }).bind(0, c));
                n.d(t, u);
                var f = n(4777), l = n(9443);
                for(var c in u = {}, l)[
                    "default",
                    "crypto",
                    "createBaseOptionsConstructor",
                    "createOktaAuthBase",
                    "ACCESS_TOKEN_STORAGE_KEY",
                    "CACHE_STORAGE_NAME",
                    "DEFAULT_CACHE_DURATION",
                    "DEFAULT_CODE_CHALLENGE_METHOD",
                    "DEFAULT_MAX_CLOCK_SKEW",
                    "DEFAULT_POLLING_DELAY",
                    "IDX_API_VERSION",
                    "IDX_RESPONSE_STORAGE_NAME",
                    "ID_TOKEN_STORAGE_KEY",
                    "IOS_MAX_RETRY_COUNT",
                    "MAX_VERIFIER_LENGTH",
                    "MIN_VERIFIER_LENGTH",
                    "ORIGINAL_URI_STORAGE_NAME",
                    "PKCE_STORAGE_NAME",
                    "REFERRER_PATH_STORAGE_KEY",
                    "REFRESH_TOKEN_STORAGE_KEY",
                    "SHARED_TRANSACTION_STORAGE_NAME",
                    "STATE_TOKEN_KEY_NAME",
                    "TOKEN_STORAGE_NAME",
                    "TRANSACTION_STORAGE_NAME",
                    "AuthStateManager",
                    "INITIAL_AUTH_STATE",
                    "ServiceManager",
                    "createCoreOptionsConstructor",
                    "createCoreStorageManager",
                    "createOktaAuthCore",
                    "mixinCore",
                    "AuthApiError",
                    "AuthPollStopError",
                    "AuthSdkError",
                    "OAuthError",
                    "WWWAuthError",
                    "isAuthApiError",
                    "isOAuthError",
                    "isWWWAuthError",
                    "OktaUserAgent",
                    "createHttpOptionsConstructor",
                    "get",
                    "httpRequest",
                    "mixinHttp",
                    "post",
                    "setRequestHeader"
                ].indexOf(c) < 0 && (u[c] = (function(e1) {
                    return l[e1];
                }).bind(0, c));
                n.d(t, u);
                var p = n(8041), d = n(9927), h = n(305);
            },
            415: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    getUserAgent: function() {
                        return u;
                    },
                    hasTextEncoder: function() {
                        return p;
                    },
                    isBrowser: function() {
                        return i;
                    },
                    isDPoPSupported: function() {
                        return y;
                    },
                    isFingerprintSupported: function() {
                        return c;
                    },
                    isHTTPS: function() {
                        return h;
                    },
                    isIE11OrLess: function() {
                        return a;
                    },
                    isIOS: function() {
                        return g;
                    },
                    isLocalhost: function() {
                        return v;
                    },
                    isPKCESupported: function() {
                        return d;
                    },
                    isPopupPostMessageSupported: function() {
                        return s;
                    },
                    isTokenVerifySupported: function() {
                        return l;
                    }
                });
                var r = n(7594), o = /windows phone|iemobile|wpdesktop/i;
                function i() {
                    return "undefined" != typeof document && "undefined" != typeof window;
                }
                function a() {
                    if (!i()) return !1;
                    var e1 = document.documentMode;
                    return !!e1 && e1 <= 11;
                }
                function u() {
                    return navigator.userAgent;
                }
                function c() {
                    var e1 = u();
                    return e1 && !o.test(e1);
                }
                function s() {
                    if (!i()) return !1;
                    var e1 = document.documentMode, t = e1 && e1 < 10;
                    return void 0 !== window.postMessage && !t;
                }
                function f() {
                    return void 0 !== r.KP && null !== r.KP && void 0 !== r.KP.subtle && "undefined" != typeof Uint8Array;
                }
                function l() {
                    return f();
                }
                function p() {
                    return "undefined" != typeof TextEncoder;
                }
                function d() {
                    return l() && p();
                }
                function h() {
                    return !!i() && "https:" === window.location.protocol;
                }
                function v() {
                    return i() && "localhost" === window.location.hostname;
                }
                function y() {
                    return !a() && void 0 !== window.indexedDB && p() && f();
                }
                function g() {
                    return i() && "undefined" != typeof navigator && void 0 !== navigator.userAgent && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
                }
            },
            287: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    e: function() {
                        return u;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(415), u = function() {
                    function e1() {
                        (0, r.Z)(this, e1), (0, i.Z)(this, "environments", void 0), this.environments = [
                            "okta-auth-js/".concat("7.14.5")
                        ], this.maybeAddNodeEnvironment();
                    }
                    return (0, o.Z)(e1, [
                        {
                            key: "addEnvironment",
                            value: function(e1) {
                                this.environments.push(e1);
                            }
                        },
                        {
                            key: "getHttpHeader",
                            value: function() {
                                return {
                                    "X-Okta-User-Agent-Extended": this.environments.join(" ")
                                };
                            }
                        },
                        {
                            key: "getVersion",
                            value: function() {
                                return "7.14.5";
                            }
                        },
                        {
                            key: "maybeAddNodeEnvironment",
                            value: function() {
                                if (!(0, a.isBrowser)() && $fcfa90861d16c270$exports && $fcfa90861d16c270$exports.versions) {
                                    var e1 = $fcfa90861d16c270$exports.versions.node;
                                    this.environments.push("nodejs/".concat(e1));
                                }
                            }
                        }
                    ]), e1;
                }();
            },
            2281: function(e1, t, n) {
                "use strict";
                function r(e1, t, n) {
                    e1.options.headers = e1.options.headers || {}, e1.options.headers[t] = n;
                }
                n.d(t, {
                    r: function() {
                        return r;
                    }
                });
            },
            4777: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Am: function() {
                        return a.A;
                    },
                    U2: function() {
                        return i.U2;
                    },
                    ZM: function() {
                        return u.Z;
                    },
                    c3: function() {
                        return i.c3;
                    },
                    ed: function() {
                        return o.e;
                    },
                    rn: function() {
                        return r.r;
                    },
                    v_: function() {
                        return i.v_;
                    }
                });
                var r = n(2281), o = n(287), i = n(5385), a = n(279), u = n(8817);
            },
            279: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    A: function() {
                        return h;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(287), l = n(2281), p = n(6718), d = n(5385);
                function h(e1) {
                    return function(e1) {
                        (0, a.Z)(v, e1);
                        var t, n, h = (t = v, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function v() {
                            var e1;
                            (0, r.Z)(this, v);
                            for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                            return e1 = h.call.apply(h, [
                                this
                            ].concat(n)), (0, s.Z)((0, i.Z)(e1), "_oktaUserAgent", void 0), (0, s.Z)((0, i.Z)(e1), "http", void 0), e1._oktaUserAgent = new f.e, e1.http = {
                                setRequestHeader: l.r.bind(null, (0, i.Z)(e1))
                            }, e1;
                        }
                        return (0, o.Z)(v, [
                            {
                                key: "setHeaders",
                                value: function(e1) {
                                    this.options.headers = Object.assign({}, this.options.headers, e1);
                                }
                            },
                            {
                                key: "getIssuerOrigin",
                                value: function() {
                                    return this.options.issuer.split("/oauth2/")[0];
                                }
                            },
                            {
                                key: "webfinger",
                                value: function(e1) {
                                    var t = "/.well-known/webfinger" + (0, p.UK)(e1);
                                    return (0, d.U2)(this, t, {
                                        headers: {
                                            Accept: "application/jrd+json"
                                        }
                                    });
                                }
                            }
                        ]), v;
                    }(e1);
                }
            },
            8817: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return m;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(3849), l = n(885), p = n(1002), d = n(4098), h = n.n(d);
                function v(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var y = /application\/\w*\+?json/, g = function(e1, t, r) {
                    var o = r.data, i = r.headers || {}, a = i["Content-Type"] || i["content-type"] || "";
                    o && "string" != typeof o && (y.test(a) ? o = JSON.stringify(o) : "application/x-www-form-urlencoded" === a && (o = Object.entries(o).map(function(e1) {
                        var t = (0, l.Z)(e1, 2), n = t[0], r = t[1];
                        return "".concat(n, "=").concat(encodeURIComponent(r));
                    }).join("&")));
                    var u = (n.g.fetch || h())(t, {
                        method: e1,
                        headers: r.headers,
                        body: o,
                        credentials: r.withCredentials ? "include" : "omit"
                    });
                    return u.finally || (u = Promise.resolve(u)), u.then(function(e1) {
                        var t = !e1.ok, n = e1.status;
                        return (function(e1) {
                            return e1.headers.get("Content-Type") && e1.headers.get("Content-Type").toLowerCase().indexOf("application/json") >= 0 ? e1.json().catch(function(e1) {
                                return {
                                    error: e1,
                                    errorSummary: "Could not parse server response"
                                };
                            }) : e1.text();
                        })(e1).then(function(t) {
                            return function(e1, t, n) {
                                var r, o = "object" === (0, p.Z)(t), i = {}, a = function(e1, t) {
                                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                    if (!n) {
                                        if (Array.isArray(e1) || (n = function(e1, t) {
                                            if (e1) {
                                                if ("string" == typeof e1) return v(e1, t);
                                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? v(e1, t) : void 0;
                                            }
                                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                                            n && (e1 = n);
                                            var r = 0, o = function() {};
                                            return {
                                                s: o,
                                                n: function() {
                                                    return r >= e1.length ? {
                                                        done: !0
                                                    } : {
                                                        done: !1,
                                                        value: e1[r++]
                                                    };
                                                },
                                                e: function(e1) {
                                                    throw e1;
                                                },
                                                f: o
                                            };
                                        }
                                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                    }
                                    var i, a = !0, u = !1;
                                    return {
                                        s: function() {
                                            n = n.call(e1);
                                        },
                                        n: function() {
                                            var e1 = n.next();
                                            return a = e1.done, e1;
                                        },
                                        e: function(e1) {
                                            u = !0, i = e1;
                                        },
                                        f: function() {
                                            try {
                                                a || null == n.return || n.return();
                                            } finally{
                                                if (u) throw i;
                                            }
                                        }
                                    };
                                }(n.headers.entries());
                                try {
                                    for(a.s(); !(r = a.n()).done;){
                                        var u = r.value;
                                        i[u[0]] = u[1];
                                    }
                                } catch (e1) {
                                    a.e(e1);
                                } finally{
                                    a.f();
                                }
                                var c = {
                                    responseText: o ? JSON.stringify(t) : t,
                                    status: e1,
                                    headers: i
                                };
                                return o && (c.responseType = "json", c.responseJSON = t), c;
                            }(n, t, e1);
                        }).then(function(e1) {
                            var n;
                            if (t || null !== (n = e1.responseJSON) && void 0 !== n && n.error) throw e1;
                            return e1;
                        });
                    });
                };
                function m() {
                    return function(e1) {
                        (0, a.Z)(l, e1);
                        var t, n, f = (t = l, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function l(e1) {
                            var t;
                            return (0, o.Z)(this, l), t = f.call(this, e1), (0, s.Z)((0, i.Z)(t), "issuer", void 0), (0, s.Z)((0, i.Z)(t), "transformErrorXHR", void 0), (0, s.Z)((0, i.Z)(t), "headers", void 0), (0, s.Z)((0, i.Z)(t), "httpRequestClient", void 0), (0, s.Z)((0, i.Z)(t), "httpRequestInterceptors", void 0), (0, s.Z)((0, i.Z)(t), "pollDelay", void 0), t.issuer = e1.issuer, t.transformErrorXHR = e1.transformErrorXHR, t.headers = e1.headers, t.httpRequestClient = e1.httpRequestClient || g, t.httpRequestInterceptors = e1.httpRequestInterceptors, t.pollDelay = e1.pollDelay, t;
                        }
                        return (0, r.Z)(l);
                    }((0, f.T)());
                }
            },
            5385: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    U2: function() {
                        return k;
                    },
                    c3: function() {
                        return b;
                    },
                    v_: function() {
                        return w;
                    }
                });
                var r = n(1002), o = n(4942), i = n(4771), a = n(3193), u = n(6718), c = n(1971), s = n(3983), f = n(3114), l = n(2886), p = n(415);
                function d(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                function h(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function v(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? h(Object(n), !0).forEach(function(t) {
                            (0, o.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var y, g = 0;
                (0, p.isBrowser)() && (g = Date.now(), y = function() {
                    document.hidden || (g = Date.now());
                }, document.addEventListener("visibilitychange", y));
                var m = function(e1, t) {
                    var n, r, o, u;
                    if (t instanceof Error) return new s.Z({
                        errorSummary: t.message
                    });
                    var c, p = t, d = {};
                    if (p.responseText && (0, i.HD)(p.responseText)) try {
                        d = JSON.parse(p.responseText);
                    } catch (e1) {
                        d = {
                            errorSummary: "Unknown error"
                        };
                    }
                    p.status >= 500 && (d.errorSummary = "Unknown error"), e1.options.transformErrorXHR && (p = e1.options.transformErrorXHR((0, a.d9)(p)));
                    var h = null !== (n = f.Z.getWWWAuthenticateHeader(null === (r = p) || void 0 === r ? void 0 : r.headers)) && void 0 !== n ? n : "";
                    if (c = d.error && d.error_description ? new l.Z(d.error, d.error_description, p) : new s.Z(d, p, {
                        wwwAuthHeader: h
                    }), h && (null === (o = p) || void 0 === o ? void 0 : o.status) >= 400 && (null === (u = p) || void 0 === u ? void 0 : u.status) < 500) {
                        var y = f.Z.parseHeader(h);
                        if (403 === p.status && "insufficient_authentication_context" === (null == y ? void 0 : y.error)) {
                            var g = y.parameters, m = g.max_age, b = g.acr_values;
                            c = new s.Z({
                                errorSummary: y.error,
                                errorCauses: [
                                    {
                                        errorSummary: y.errorDescription
                                    }
                                ]
                            }, p, v({
                                max_age: +m
                            }, b && {
                                acr_values: b
                            }));
                        } else "DPoP" === (null == y ? void 0 : y.scheme) && (c = y);
                    }
                    return c;
                };
                function b(e1, t) {
                    var n;
                    if (t = t || {}, e1.options.httpRequestInterceptors) {
                        var o, u = function(e1, t) {
                            var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                            if (!n) {
                                if (Array.isArray(e1) || (n = function(e1, t) {
                                    if (e1) {
                                        if ("string" == typeof e1) return d(e1, t);
                                        var n = Object.prototype.toString.call(e1).slice(8, -1);
                                        return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? d(e1, t) : void 0;
                                    }
                                }(e1)) || t && e1 && "number" == typeof e1.length) {
                                    n && (e1 = n);
                                    var r = 0, o = function() {};
                                    return {
                                        s: o,
                                        n: function() {
                                            return r >= e1.length ? {
                                                done: !0
                                            } : {
                                                done: !1,
                                                value: e1[r++]
                                            };
                                        },
                                        e: function(e1) {
                                            throw e1;
                                        },
                                        f: o
                                    };
                                }
                                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                            }
                            var i, a = !0, u = !1;
                            return {
                                s: function() {
                                    n = n.call(e1);
                                },
                                n: function() {
                                    var e1 = n.next();
                                    return a = e1.done, e1;
                                },
                                e: function(e1) {
                                    u = !0, i = e1;
                                },
                                f: function() {
                                    try {
                                        a || null == n.return || n.return();
                                    } finally{
                                        if (u) throw i;
                                    }
                                }
                            };
                        }(e1.options.httpRequestInterceptors);
                        try {
                            for(u.s(); !(o = u.n()).done;)(0, o.value)(t);
                        } catch (P) {
                            u.e(P);
                        } finally{
                            u.f();
                        }
                    }
                    var s = t.url, f = t.method, l = t.args, h = t.saveAuthnState, y = t.accessToken, b = !0 === t.withCredentials, k = e1.options.storageUtil.storage, w = e1.storageManager.getHttpCache(e1.options.cookies), O = t.pollingIntent, Z = null !== (n = e1.options.pollDelay) && void 0 !== n ? n : 0;
                    if (t.cacheResponse) {
                        var T = w.getStorage()[s];
                        if (T && Date.now() / 1e3 < T.expiresAt) return Promise.resolve(T.response);
                    }
                    var E = v({
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    }, e1._oktaUserAgent.getHttpHeader());
                    Object.assign(E, e1.options.headers, t.headers), E = (0, a.YY)(E), y && (0, i.HD)(y) && (E.Authorization = "Bearer " + y);
                    var P, S, x, A = {
                        headers: E,
                        data: l || void 0,
                        withCredentials: b
                    };
                    if (O && (0, p.isBrowser)() && Z > 0) {
                        var R, _, j, C = 0;
                        _ = function() {
                            var e1 = Date.now() - g;
                            return e1 < Z ? new Promise(function(t) {
                                return setTimeout(function() {
                                    document.hidden ? t(R()) : t();
                                }, Z - e1);
                            }) : Promise.resolve();
                        }, R = function() {
                            var e1;
                            return document.hidden ? new Promise(function(t) {
                                e1 = function() {
                                    document.hidden || (document.removeEventListener("visibilitychange", e1), t(_()));
                                }, document.addEventListener("visibilitychange", e1);
                            }) : _();
                        };
                        var I = function() {
                            return e1.options.httpRequestClient(f, s, A).catch(function(e1) {
                                if ("Load failed" === (null == e1 ? void 0 : e1.message) && C < c.IOS_MAX_RETRY_COUNT) return C++, j();
                                throw e1;
                            });
                        };
                        x = (j = function() {
                            return R().then(I);
                        })();
                    } else x = e1.options.httpRequestClient(f, s, A);
                    return x.then(function(n) {
                        return (S = n.responseText) && (0, i.HD)(S) && (S = JSON.parse(S)) && "object" === (0, r.Z)(S) && !S.headers && (Array.isArray(S) ? S.forEach(function(e1) {
                            e1.headers = n.headers;
                        }) : S.headers = n.headers), h && (S.stateToken || k.delete(c.STATE_TOKEN_KEY_NAME)), S && S.stateToken && S.expiresAt && k.set(c.STATE_TOKEN_KEY_NAME, S.stateToken, S.expiresAt, e1.options.cookies), S && t.cacheResponse && w.updateStorage(s, {
                            expiresAt: Math.floor(Date.now() / 1e3) + c.DEFAULT_CACHE_DURATION,
                            response: S
                        }), S;
                    }).catch(function(t) {
                        throw "E0000011" === (P = m(e1, t)).errorCode && k.delete(c.STATE_TOKEN_KEY_NAME), P;
                    });
                }
                function k(e1, t, n) {
                    var r = {
                        url: t = (0, u.sD)(t) ? t : e1.getIssuerOrigin() + t,
                        method: "GET"
                    };
                    return Object.assign(r, n), b(e1, r);
                }
                function w(e1, t, n, r) {
                    var o = {
                        url: t = (0, u.sD)(t) ? t : e1.getIssuerOrigin() + t,
                        method: "POST",
                        args: n,
                        saveAuthnState: !0
                    };
                    return Object.assign(o, r), b(e1, o);
                }
            },
            3334: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    v: function() {
                        return l;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(1646), f = n(480);
                function l() {
                    return function(e1) {
                        (0, a.Z)(l, e1);
                        var t, n, s = (t = l, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function l(e1) {
                            return (0, r.Z)(this, l), s.call(this, e1);
                        }
                        return (0, o.Z)(l, [
                            {
                                key: "clear",
                                value: function() {
                                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    (0, i.Z)((0, c.Z)(l.prototype), "clear", this).call(this, e1), !1 !== e1.clearIdxResponse && this.clearIdxResponse();
                                }
                            },
                            {
                                key: "saveIdxResponse",
                                value: function(e1) {
                                    if (this.saveLastResponse) {
                                        var t = this.storageManager.getIdxResponseStorage();
                                        t && t.setStorage(e1);
                                    }
                                }
                            },
                            {
                                key: "loadIdxResponse",
                                value: function(e1) {
                                    if (!this.saveLastResponse) return null;
                                    var t = this.storageManager.getIdxResponseStorage();
                                    if (!t) return null;
                                    var n = t.getStorage();
                                    if (!n || !(0, f.P)(n.rawIdxResponse)) return null;
                                    if (e1) {
                                        var r = e1.stateHandle, o = e1.interactionHandle;
                                        if (!e1.useGenericRemediator && r && n.stateHandle !== r) return null;
                                        if (o && n.interactionHandle !== o) return null;
                                    }
                                    return n;
                                }
                            },
                            {
                                key: "clearIdxResponse",
                                value: function() {
                                    if (this.saveLastResponse) {
                                        var e1 = this.storageManager.getIdxResponseStorage();
                                        null == e1 || e1.clearStorage();
                                    }
                                }
                            }
                        ]), l;
                    }((0, s.P)());
                }
            },
            1286: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Y: function() {
                        return l;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(7595), c = n(3377);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function l(e1) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return p = (0, o.Z)(a().mark(function e1(t) {
                        var n, r = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return (n = r.length > 1 && void 0 !== r[1] ? r[1] : {}).password && !n.authenticator && (n.authenticator = u.pc.OKTA_PASSWORD), e1.abrupt("return", (0, c.K)(t, f(f({}, n), {}, {
                                        flow: "authenticate"
                                    })));
                                case 3:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), p.apply(this, arguments);
                }
            },
            7644: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    _: function() {
                        return a;
                    }
                });
                var r = n(3144), o = n(5671), i = n(4942), a = (0, r.Z)(function e1(t) {
                    (0, o.Z)(this, e1), (0, i.Z)(this, "meta", void 0), this.meta = t;
                });
            },
            9582: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return l;
                    }
                });
                var r = n(4942), o = n(5671), i = n(3144), a = n(136), u = n(2963), c = n(1120);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var l = function(e1) {
                    (0, a.Z)(s, e1);
                    var t, n, r = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), r.apply(this, arguments);
                    }
                    return (0, i.Z)(s, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                return !!(e1.credentials || e1.password || e1.passcode);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.credentials, n = e1.password, r = e1.passcode, o = e1.revokeSessions;
                                if (t || n || r) return t || {
                                    passcode: r || n,
                                    revokeSessions: o
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function(e1) {
                                var t, n, r = [
                                    f(f({}, null === (t = e1.form) || void 0 === t ? void 0 : t.value[0]), {}, {
                                        name: "password",
                                        type: "string",
                                        required: e1.required
                                    })
                                ];
                                return (null === (n = e1.form) || void 0 === n ? void 0 : n.value.find(function(e1) {
                                    return "revokeSessions" === e1.name;
                                })) && r.push({
                                    name: "revokeSessions",
                                    type: "boolean",
                                    label: "Sign me out of all other devices",
                                    required: !1
                                }), r;
                            }
                        }
                    ]), s;
                }(n(7644)._);
            },
            9344: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    LL: function() {
                        return i;
                    },
                    PN: function() {
                        return a;
                    },
                    h_: function() {
                        return u;
                    }
                });
                var r = n(7595);
                function o(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                function i(e1) {
                    var t;
                    if ((0, r.H)(e1)) t = e1;
                    else {
                        if ("string" != typeof e1) throw new Error("Invalid format for authenticator");
                        t = {
                            key: e1
                        };
                    }
                    return t;
                }
                function a(e1, t) {
                    return !!(e1 && t && (e1.id && t.id ? e1.id === t.id : e1.key && t.key && e1.key === t.key));
                }
                function u(e1, t) {
                    var n, r, i = function(e1, t) {
                        var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                        if (!n) {
                            if (Array.isArray(e1) || (n = function(e1, t) {
                                if (e1) {
                                    if ("string" == typeof e1) return o(e1, t);
                                    var n = Object.prototype.toString.call(e1).slice(8, -1);
                                    return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? o(e1, t) : void 0;
                                }
                            }(e1)) || t && e1 && "number" == typeof e1.length) {
                                n && (e1 = n);
                                var r = 0, i = function() {};
                                return {
                                    s: i,
                                    n: function() {
                                        return r >= e1.length ? {
                                            done: !0
                                        } : {
                                            done: !1,
                                            value: e1[r++]
                                        };
                                    },
                                    e: function(e1) {
                                        throw e1;
                                    },
                                    f: i
                                };
                            }
                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }
                        var a, u = !0, c = !1;
                        return {
                            s: function() {
                                n = n.call(e1);
                            },
                            n: function() {
                                var e1 = n.next();
                                return u = e1.done, e1;
                            },
                            e: function(e1) {
                                c = !0, a = e1;
                            },
                            f: function() {
                                try {
                                    u || null == n.return || n.return();
                                } finally{
                                    if (c) throw a;
                                }
                            }
                        };
                    }(e1);
                    try {
                        var a = function() {
                            var e1 = r.value;
                            if (n = t.find(function(t) {
                                var n = t.relatesTo;
                                return n.key && n.key === e1.key;
                            })) return "break";
                        };
                        for(i.s(); !(r = i.n()).done && "break" !== a(););
                    } catch (e1) {
                        i.e(e1);
                    } finally{
                        i.f();
                    }
                    return n;
                }
            },
            9192: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return l;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3377), c = n(7738);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function l(e1, t) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return (p = (0, o.Z)(a().mark(function e1(t, n) {
                        var r, o;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return r = t.transactionManager.load(), o = (0, c.s)(t, r.flow), e1.abrupt("return", (0, u.K)(t, f(f(f({}, n), o), {}, {
                                        actions: [
                                            "cancel"
                                        ]
                                    })));
                                case 3:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            7985: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    GA: function() {
                        return g;
                    },
                    Jn: function() {
                        return b;
                    },
                    gc: function() {
                        return y;
                    },
                    mo: function() {
                        return m;
                    }
                });
                var r = n(5861), o = n(3144), i = n(5671), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(4687), p = n.n(l), d = n(6245), h = n(1969);
                var v = function(e1) {
                    (0, u.Z)(l, e1);
                    var t, n, r = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function l(e1, t) {
                        var n;
                        return (0, i.Z)(this, l), n = r.call(this, "Enter the OTP code in the originating client: ".concat(t)), (0, f.Z)((0, a.Z)(n), "state", void 0), (0, f.Z)((0, a.Z)(n), "otp", void 0), n.name = "EmailVerifyCallbackError", n.state = e1, n.otp = t, n;
                    }
                    return (0, o.Z)(l);
                }(d.Z);
                function y(e1) {
                    return "EmailVerifyCallbackError" === e1.name;
                }
                function g(e1) {
                    return /(otp=)/i.test(e1) && /(state=)/i.test(e1);
                }
                function m(e1) {
                    return (0, h.v)(e1);
                }
                function b(e1, t) {
                    return k.apply(this, arguments);
                }
                function k() {
                    return (k = (0, r.Z)(p().mark(function e1(t, n) {
                        var r, o, i;
                        return p().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (!g(n)) {
                                        e1.next = 9;
                                        break;
                                    }
                                    if (r = m(n), o = r.state, i = r.otp, !t.idx.canProceed({
                                        state: o
                                    })) {
                                        e1.next = 8;
                                        break;
                                    }
                                    return e1.next = 5, t.idx.proceed({
                                        state: o,
                                        otp: i
                                    });
                                case 5:
                                    return e1.abrupt("return", e1.sent);
                                case 8:
                                    throw new v(o, i);
                                case 9:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            2144: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Y: function() {
                        return i;
                    }
                });
                var r = n(1578), o = n(8137);
                function i(e1, t, n) {
                    var i = (0, r.K)(e1, t, n);
                    return (0, o.B)(i);
                }
            },
            8717: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    F: function() {
                        return F;
                    }
                });
                var r = {};
                n.r(r), n.d(r, {
                    AuthenticatorEnrollmentData: function() {
                        return U.q;
                    },
                    AuthenticatorVerificationData: function() {
                        return N.q;
                    },
                    ChallengeAuthenticator: function() {
                        return E.J;
                    },
                    ChallengePoll: function() {
                        return P.U;
                    },
                    EnrollAuthenticator: function() {
                        return w.q;
                    },
                    EnrollPoll: function() {
                        return O.T;
                    },
                    EnrollProfile: function() {
                        return x.w;
                    },
                    EnrollmentChannelData: function() {
                        return T.t;
                    },
                    GenericRemediator: function() {
                        return H.P;
                    },
                    Identify: function() {
                        return A.h;
                    },
                    ReEnrollAuthenticator: function() {
                        return R.j;
                    },
                    ReEnrollAuthenticatorWarning: function() {
                        return _.i;
                    },
                    RedirectIdp: function() {
                        return j.O;
                    },
                    Remediator: function() {
                        return k.n;
                    },
                    ResetAuthenticator: function() {
                        return S.G;
                    },
                    SelectAuthenticatorAuthenticate: function() {
                        return C.X;
                    },
                    SelectAuthenticatorEnroll: function() {
                        return I.j;
                    },
                    SelectAuthenticatorUnlockAccount: function() {
                        return D.G;
                    },
                    SelectEnrollProfile: function() {
                        return M.j;
                    },
                    SelectEnrollmentChannel: function() {
                        return Z.V;
                    },
                    Skip: function() {
                        return L.h;
                    }
                });
                var o = n(8221), i = n(9912), a = n(1286), u = n(9192), c = n(7985), s = n(5021), f = n(5923), l = n(6131), p = n(2660), d = n(9310), h = n(2845), v = n(9214), y = n(8826), g = n(2473), m = n(2620), b = n(8277), k = n(3118), w = n(3857), O = n(2288), Z = n(3403), T = n(3679), E = n(4560), P = n(1104), S = n(1019), x = n(7522), A = n(8628), R = n(9024), _ = n(8107), j = n(8490), C = n(7311), I = n(9865), D = n(5272), M = n(4713), N = n(5278), U = n(2541), L = n(8443), H = n(9732), B = n(7738), K = n(5031);
                function F(e1) {
                    (0, K.TC)({
                        remediators: r,
                        getFlowSpecification: B.s
                    });
                    var t = g.Y.bind(null, e1);
                    return {
                        interact: l.E.bind(null, e1),
                        introspect: p.L.bind(null, e1),
                        makeIdxResponse: f._T.bind(null, e1),
                        authenticate: a.Y.bind(null, e1),
                        register: y.z.bind(null, e1),
                        start: t,
                        startTransaction: t,
                        poll: d.$.bind(null, e1),
                        proceed: h.x.bind(null, e1),
                        cancel: u.a.bind(null, e1),
                        recoverPassword: v.M.bind(null, e1),
                        handleInteractionCodeRedirect: s.X.bind(null, e1),
                        isInteractionRequired: o.wc.bind(null, e1),
                        isInteractionRequiredError: i.Cf,
                        handleEmailVerifyCallback: c.Jn.bind(null, e1),
                        isEmailVerifyCallback: c.GA,
                        parseEmailVerifyCallback: c.mo,
                        isEmailVerifyCallbackError: c.gc,
                        getSavedTransactionMeta: m.uN.bind(null, e1),
                        createTransactionMeta: m.Xc.bind(null, e1),
                        getTransactionMeta: m.Co.bind(null, e1),
                        saveTransactionMeta: m.r0.bind(null, e1),
                        clearTransactionMeta: m.Jm.bind(null, e1),
                        isTransactionMetaValid: m.Wf,
                        setFlow: function(t) {
                            e1.options.flow = t;
                        },
                        getFlow: function() {
                            return e1.options.flow;
                        },
                        canProceed: h.C.bind(null, e1),
                        unlockAccount: b.l.bind(null, e1)
                    };
                }
            },
            7738: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    s: function() {
                        return P;
                    }
                });
                var r = n(8628), o = n(7311), i = n(9865), a = n(2541), u = n(5278), c = n(3857), s = n(4560), f = n(1104), l = n(9024), p = n(8107), d = n(2288), h = n(3403), v = n(3679), y = n(8490), g = n(8443), m = {
                    identify: r.h,
                    "select-authenticator-authenticate": o.X,
                    "select-authenticator-enroll": i.j,
                    "authenticator-enrollment-data": a.q,
                    "authenticator-verification-data": u.q,
                    "enroll-authenticator": c.q,
                    "challenge-authenticator": s.J,
                    "challenge-poll": f.U,
                    "reenroll-authenticator": l.j,
                    "reenroll-authenticator-warning": p.i,
                    "enroll-poll": d.T,
                    "select-enrollment-channel": h.V,
                    "enrollment-channel-data": v.t,
                    "redirect-idp": y.O,
                    skip: g.h
                }, b = n(1019), k = {
                    identify: r.h,
                    "identify-recovery": r.h,
                    "select-authenticator-authenticate": o.X,
                    "select-authenticator-enroll": i.j,
                    "challenge-authenticator": s.J,
                    "authenticator-verification-data": u.q,
                    "authenticator-enrollment-data": a.q,
                    "reset-authenticator": b.G,
                    "reenroll-authenticator": l.j,
                    "reenroll-authenticator-warning": p.i,
                    "enroll-poll": d.T
                }, w = n(4713), O = n(7522), Z = {
                    "select-enroll-profile": w.j,
                    "enroll-profile": O.w,
                    "authenticator-enrollment-data": a.q,
                    "select-authenticator-enroll": i.j,
                    "select-authenticator-authenticate": o.X,
                    "enroll-poll": d.T,
                    "select-enrollment-channel": h.V,
                    "enrollment-channel-data": v.t,
                    "enroll-authenticator": c.q,
                    "authenticator-verification-data": u.q,
                    "challenge-authenticator": s.J,
                    "challenge-poll": f.U,
                    skip: g.h
                }, T = n(5272), E = {
                    identify: r.h,
                    "select-authenticator-unlock-account": T.G,
                    "select-authenticator-authenticate": o.X,
                    "challenge-authenticator": s.J,
                    "challenge-poll": f.U,
                    "authenticator-verification-data": u.q,
                    "reenroll-authenticator-warning": p.i
                };
                function P(e1) {
                    var t, n, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default", o = !0;
                    switch(r){
                        case "register":
                        case "signup":
                        case "enrollProfile":
                            t = Z, o = !1;
                            break;
                        case "recoverPassword":
                        case "resetPassword":
                            t = k, n = [
                                "currentAuthenticator-recover",
                                "currentAuthenticatorEnrollment-recover"
                            ], o = !1;
                            break;
                        case "unlockAccount":
                            t = E, o = !1, n = [
                                "unlock-account"
                            ];
                            break;
                        default:
                            t = m;
                    }
                    return {
                        flow: r,
                        remediators: t,
                        actions: n,
                        withCredentials: o
                    };
                }
            },
            5021: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return c;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(2886);
                function c(e1, t) {
                    return s.apply(this, arguments);
                }
                function s() {
                    return (s = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, c, s, f, l, p, d, h, v;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = t.transactionManager.load()) {
                                        e1.next = 3;
                                        break;
                                    }
                                    throw new a.Z("No transaction data was found in storage");
                                case 3:
                                    if (o = r.codeVerifier, c = r.state, s = new URL(n), f = s.searchParams, l = f.get("state"), p = f.get("interaction_code"), !(d = f.get("error"))) {
                                        e1.next = 10;
                                        break;
                                    }
                                    throw new u.Z(d, f.get("error_description"));
                                case 10:
                                    if (l === c) {
                                        e1.next = 12;
                                        break;
                                    }
                                    throw new a.Z("State in redirect uri does not match with transaction state");
                                case 12:
                                    if (p) {
                                        e1.next = 14;
                                        break;
                                    }
                                    throw new a.Z("Unable to parse interaction_code from the url");
                                case 14:
                                    return e1.next = 16, t.token.exchangeCodeForTokens({
                                        interactionCode: p,
                                        codeVerifier: o
                                    });
                                case 16:
                                    h = e1.sent, v = h.tokens, t.tokenManager.setTokens(v);
                                case 19:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            5923: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    _T: function() {
                        return U;
                    },
                    A0: function() {
                        return N;
                    }
                });
                var r = n(1971), o = n(5861), i = n(2982), a = n(4687), u = n.n(a), c = n(885), s = n(4942), f = n(4925), l = n(1002), p = n(5385);
                function d(e1, t) {
                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e1) || (n = function(e1, t) {
                            if (e1) {
                                if ("string" == typeof e1) return h(e1, t);
                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? h(e1, t) : void 0;
                            }
                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                            n && (e1 = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e1.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e1[r++]
                                    };
                                },
                                e: function(e1) {
                                    throw e1;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, u = !1;
                    return {
                        s: function() {
                            n = n.call(e1);
                        },
                        n: function() {
                            var e1 = n.next();
                            return a = e1.done, e1;
                        },
                        e: function(e1) {
                            u = !0, i = e1;
                        },
                        f: function() {
                            try {
                                a || null == n.return || n.return();
                            } finally{
                                if (u) throw i;
                            }
                        }
                    };
                }
                function h(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var v = function(e1) {
                    return !1 !== e1.mutable;
                }, y = function(e1) {
                    var t = {}, n = [], r = {};
                    if (!e1.value) return n.push(e1), {
                        defaultParamsForAction: t,
                        neededParamsForAction: n,
                        immutableParamsForAction: r
                    };
                    var o, i = d(e1.value);
                    try {
                        for(i.s(); !(o = i.n()).done;){
                            var a, u, c = o.value;
                            v(c) ? (n.push(c), null !== (a = c.value) && void 0 !== a && a && (t[c.name] = c.value)) : r[c.name] = null !== (u = c.value) && void 0 !== u ? u : "";
                        }
                    } catch (e1) {
                        i.e(e1);
                    } finally{
                        i.f();
                    }
                    return {
                        defaultParamsForAction: t,
                        neededParamsForAction: n,
                        immutableParamsForAction: r
                    };
                }, g = n(3983);
                function m(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function b(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? m(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var k = function(e1, t) {
                    var n = t.actionDefinition, r = t.defaultParamsForAction, i = void 0 === r ? {} : r, a = t.immutableParamsForAction, c = void 0 === a ? {} : a, s = t.toPersist, f = void 0 === s ? {} : s, l = n.href;
                    return (0, o.Z)(u().mark(function t() {
                        var r, o, a, s, d, h, v, y, m, k, w, O = arguments;
                        return u().wrap(function(t) {
                            for(;;)switch(t.prev = t.next){
                                case 0:
                                    return r = O.length > 0 && void 0 !== O[0] ? O[0] : {}, o = {
                                        "Content-Type": "application/json",
                                        Accept: n.accepts || "application/ion+json"
                                    }, a = JSON.stringify(b(b(b({}, i), r), c)), t.prev = 3, h = {
                                        url: l,
                                        method: n.method,
                                        headers: o,
                                        args: a,
                                        withCredentials: null === (s = null == f ? void 0 : f.withCredentials) || void 0 === s || s
                                    }, ("poll" === n.name || (null === (d = n.name) || void 0 === d ? void 0 : d.endsWith("-poll"))) && (h.pollingIntent = !0), t.next = 9, (0, p.c3)(e1, h);
                                case 9:
                                    return v = t.sent, t.abrupt("return", e1.idx.makeIdxResponse(b({}, v), f, !0));
                                case 13:
                                    if (t.prev = 13, t.t0 = t.catch(3), t.t0 instanceof g.Z && null !== t.t0 && void 0 !== t.t0 && t.t0.xhr) {
                                        t.next = 17;
                                        break;
                                    }
                                    throw t.t0;
                                case 17:
                                    return y = t.t0.xhr, m = y.responseJSON || JSON.parse(y.responseText), k = y.headers["WWW-Authenticate"] || y.headers["www-authenticate"], w = e1.idx.makeIdxResponse(b({}, m), f, !1), 401 === y.status && 'Oktadevicejwt realm="Okta Device"' === k && (w.stepUp = !0), t.abrupt("return", w);
                                case 23:
                                case "end":
                                    return t.stop();
                            }
                        }, t, null, [
                            [
                                3,
                                13
                            ]
                        ]);
                    }));
                }, w = function(e1, t, n) {
                    var r = k, o = function(e1) {
                        var t, n = [], r = {}, o = {}, i = d(e1 = Array.isArray(e1) ? e1 : [
                            e1
                        ]);
                        try {
                            for(i.s(); !(t = i.n()).done;){
                                var a = t.value, u = y(a), c = u.defaultParamsForAction, s = u.neededParamsForAction, f = u.immutableParamsForAction;
                                n.push(s), r[a.name] = c, o[a.name] = f;
                            }
                        } catch (e1) {
                            i.e(e1);
                        } finally{
                            i.f();
                        }
                        return {
                            defaultParams: r,
                            neededParams: n,
                            immutableParams: o
                        };
                    }(t), i = o.defaultParams, a = o.neededParams, u = o.immutableParams, c = r(e1, {
                        actionDefinition: t,
                        defaultParamsForAction: i[t.name],
                        immutableParamsForAction: u[t.name],
                        toPersist: n
                    });
                    return c.neededParams = a, c;
                };
                function O(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function Z(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? O(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : O(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var T = n(136), E = n(9611);
                function P() {
                    P = function(e1, t) {
                        return new n(e1, void 0, t);
                    };
                    var e1 = RegExp.prototype, t = new WeakMap;
                    function n(e1, r, o) {
                        var i = new RegExp(e1, r);
                        return t.set(i, o || t.get(e1)), (0, E.Z)(i, n.prototype);
                    }
                    function r(e1, n) {
                        var r = t.get(n);
                        return Object.keys(r).reduce(function(t, n) {
                            var o = r[n];
                            if ("number" == typeof o) t[n] = e1[o];
                            else {
                                for(var i = 0; void 0 === e1[o[i]] && i + 1 < o.length;)i++;
                                t[n] = e1[o[i]];
                            }
                            return t;
                        }, Object.create(null));
                    }
                    return (0, T.Z)(n, RegExp), n.prototype.exec = function(t) {
                        var n = e1.exec.call(this, t);
                        return n && (n.groups = r(n, this)), n;
                    }, n.prototype[Symbol.replace] = function(n, o) {
                        if ("string" == typeof o) {
                            var i = t.get(this);
                            return e1[Symbol.replace].call(this, n, o.replace(/\$<([^>]+)>/g, function(e1, t) {
                                return "$" + i[t];
                            }));
                        }
                        if ("function" == typeof o) {
                            var a = this;
                            return e1[Symbol.replace].call(this, n, function() {
                                var e1 = arguments;
                                return "object" != (0, l.Z)(e1[e1.length - 1]) && (e1 = [].slice.call(e1)).push(r(e1, a)), o.apply(this, e1);
                            });
                        }
                        return e1[Symbol.replace].call(this, n, o);
                    }, P.apply(this, arguments);
                }
                var S = P(/\$?(\w+)|(?:\[(\d+)\])/g, {
                    step: 1,
                    index: 2
                }), x = n(9123), A = [
                    "value",
                    "type"
                ];
                function R(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function _(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? R(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : R(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var j = {
                    remediation: !0,
                    context: !0
                }, C = function e1(t, n) {
                    Object.keys(n).forEach(function(r) {
                        if ("relatesTo" === r) {
                            var o = Array.isArray(n[r]) ? n[r][0] : n[r];
                            if ("string" == typeof o) {
                                var i = function(e1) {
                                    for(var t, n = e1.path, r = e1.json, o = []; null !== (t = S.exec(n));){
                                        var i, a, u, c, s, f = null !== (i = null === (a = t) || void 0 === a || null === (u = a.groups) || void 0 === u ? void 0 : u.step) && void 0 !== i ? i : null === (c = t) || void 0 === c || null === (s = c.groups) || void 0 === s ? void 0 : s.index;
                                        f && o.push(f);
                                    }
                                    if (!(o.length < 1)) {
                                        for(var p = o.pop(), d = r, h = 0, v = o; h < v.length; h++){
                                            var y = v[h];
                                            if (Object.prototype.hasOwnProperty.call(d, y)) {
                                                if ("object" !== (0, l.Z)(d[y])) return;
                                                d = d[y];
                                            }
                                        }
                                        return d[p];
                                    }
                                }({
                                    path: o,
                                    json: t
                                });
                                if (i) return void (n[r] = i);
                                throw new x.Z("Cannot resolve relatesTo: ".concat(o));
                            }
                        }
                        Array.isArray(n[r]) && n[r].forEach(function(n) {
                            return e1(t, n);
                        });
                    });
                }, I = function(e1, t) {
                    var n, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, o = (null === (n = t.remediation) || void 0 === n ? void 0 : n.value) || [];
                    o.forEach(function(e1) {
                        var n;
                        if ("launch-authenticator" !== e1.name || "authenticatorChallenge" !== (null == e1 || null === (n = e1.relatesTo) || void 0 === n ? void 0 : n[0]) || null != t && t.authenticatorChallenge) return C(t, e1);
                        delete e1.relatesTo;
                    });
                    var i = o.map(function(t) {
                        return function(e1, t, n) {
                            if (t.rel) {
                                var r = function(e1, t) {
                                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                                    return t.reduce(function(t, r) {
                                        return Z(Z({}, t), {}, (0, s.Z)({}, r.name, w(e1, r, n)));
                                    }, {});
                                }(e1, [
                                    t
                                ], n), o = r[t.name];
                                return _(_({}, t), {}, {
                                    action: o
                                });
                            }
                            return t;
                        }(e1, t, r);
                    }), a = function(e1, t) {
                        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = {}, o = {};
                        return Object.keys(t).filter(function(e1) {
                            return !j[e1];
                        }).forEach(function(i) {
                            if ("object" === (0, l.Z)(t[i]) && t[i]) {
                                if (t[i].rel) r[t[i].name] = w(e1, t[i], n);
                                else {
                                    var a = t[i], u = a.value, s = a.type, p = (0, f.Z)(a, A);
                                    o[i] = _({
                                        type: s
                                    }, p), "object" === s ? (o[i].value = {}, Object.entries(u).forEach(function(t) {
                                        var a = (0, c.Z)(t, 2), u = a[0], s = a[1];
                                        s.rel ? r["".concat(i, "-").concat(u.name || u)] = w(e1, s, n) : o[i].value[u] = s;
                                    })) : o[i].value = u;
                                }
                            } else o[i] = t[i];
                        }), {
                            context: o,
                            actions: r
                        };
                    }(e1, t, r);
                    return {
                        remediations: i,
                        context: a.context,
                        actions: a.actions
                    };
                }, D = {
                    makeIdxState: function(e1, t, n, r) {
                        var a, c, s, f, l = t, p = I(e1, t, n), d = p.remediations, h = p.context, v = p.actions, y = (0, i.Z)(d), g = (f = (0, o.Z)(u().mark(function e1(t) {
                            var n, r, o = arguments;
                            return u().wrap(function(e1) {
                                for(;;)switch(e1.prev = e1.next){
                                    case 0:
                                        if (n = o.length > 1 && void 0 !== o[1] ? o[1] : {}, r = d.find(function(e1) {
                                            return e1.name === t;
                                        })) {
                                            e1.next = 4;
                                            break;
                                        }
                                        return e1.abrupt("return", Promise.reject("Unknown remediation choice: [".concat(t, "]")));
                                    case 4:
                                        if ("function" == typeof r.action) {
                                            e1.next = 7;
                                            break;
                                        }
                                        return e1.abrupt("return", Promise.reject("Current remediation cannot make form submit action: [".concat(t, "]")));
                                    case 7:
                                        return e1.abrupt("return", r.action(n));
                                    case 8:
                                    case "end":
                                        return e1.stop();
                                }
                            }, e1);
                        })), function(e1) {
                            return f.apply(this, arguments);
                        });
                        return {
                            proceed: g,
                            neededToProceed: y,
                            actions: v,
                            context: h,
                            rawIdxState: l,
                            interactionCode: null === (a = l.successWithInteractionCode) || void 0 === a || null === (c = a.value) || void 0 === c || null === (s = c.find(function(e1) {
                                return "interaction_code" === e1.name;
                            })) || void 0 === s ? void 0 : s.value,
                            toPersist: n,
                            requestDidSucceed: r
                        };
                    }
                }, M = function(e1) {
                    switch(e1){
                        case "1.0.0":
                            return D;
                        case void 0:
                        case null:
                            throw new Error("Api version is required");
                        default:
                            throw new Error("Unknown api version: ".concat(e1, ".  Use an exact semver version."));
                    }
                };
                function N(e1) {
                    if (!e1) throw new Error("version is required");
                    if ((null != e1 ? e1 : "").replace(/[^0-9a-zA-Z._-]/, "") !== e1 || !e1) throw new Error("invalid version supplied - version is required and uses semver syntax");
                    M(e1);
                }
                function U(e1, t, n, o) {
                    var i, a = null !== (i = null == t ? void 0 : t.version) && void 0 !== i ? i : r.IDX_API_VERSION;
                    return N(a), (0, M(a).makeIdxState)(e1, t, n, o);
                }
            },
            9999: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    pc: function() {
                        return K.pc;
                    },
                    Fw: function() {
                        return K.Fw;
                    },
                    Qd: function() {
                        return K.Qd;
                    },
                    YR: function() {
                        return r.Y;
                    },
                    Ch: function() {
                        return s.C;
                    },
                    al: function() {
                        return o.a;
                    },
                    Jm: function() {
                        return v.Jm;
                    },
                    F4: function() {
                        return y.F;
                    },
                    SL: function() {
                        return H.S;
                    },
                    aT: function() {
                        return B.a;
                    },
                    vK: function() {
                        return F.v;
                    },
                    UB: function() {
                        return U;
                    },
                    Yn: function() {
                        return g.Y;
                    },
                    Xc: function() {
                        return v.Xc;
                    },
                    uN: function() {
                        return v.uN;
                    },
                    Co: function() {
                        return v.Co;
                    },
                    Jn: function() {
                        return i.Jn;
                    },
                    Xx: function() {
                        return p.X;
                    },
                    $0: function() {
                        return v.$0;
                    },
                    EW: function() {
                        return a.E;
                    },
                    L8: function() {
                        return u.L;
                    },
                    H: function() {
                        return K.H;
                    },
                    GA: function() {
                        return i.GA;
                    },
                    gc: function() {
                        return i.gc;
                    },
                    Wf: function() {
                        return v.Wf;
                    },
                    bl: function() {
                        return v.bl;
                    },
                    UC: function() {
                        return v.UC;
                    },
                    B_: function() {
                        return L.B;
                    },
                    mo: function() {
                        return i.mo;
                    },
                    $l: function() {
                        return c.$;
                    },
                    xc: function() {
                        return s.x;
                    },
                    M4: function() {
                        return l.M;
                    },
                    z2: function() {
                        return f.z;
                    },
                    r0: function() {
                        return v.r0;
                    },
                    Yr: function() {
                        return d.Y;
                    },
                    le: function() {
                        return h.l;
                    }
                });
                var r = n(1286), o = n(9192), i = n(7985), a = n(6131), u = n(2660), c = n(9310), s = n(2845), f = n(8826), l = n(9214), p = n(5021), d = n(2473), h = n(8277), v = n(2620), y = n(8717), g = n(2144), m = n(3144), b = n(5671), k = n(7326), w = n(136), O = n(2963), Z = n(1120), T = n(4942), E = n(5923), P = n(8719), S = n(8716);
                function x(e1) {
                    var t;
                    return t = function(e1) {
                        (0, w.Z)(o, e1);
                        var t, n, r = (t = o, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, Z.Z)(t);
                            if (n) {
                                var o = (0, Z.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, O.Z)(this, e1);
                        });
                        function o() {
                            var e1, t, n;
                            (0, b.Z)(this, o);
                            for(var i = arguments.length, a = new Array(i), u = 0; u < i; u++)a[u] = arguments[u];
                            return e1 = r.call.apply(r, [
                                this
                            ].concat(a)), (0, T.Z)((0, k.Z)(e1), "idx", void 0), (0, T.Z)((0, k.Z)(e1), "fingerprint", void 0), e1.idx = (t = (0, k.Z)(e1), n = d.Y.bind(null, t), {
                                makeIdxResponse: E._T.bind(null, t),
                                start: n,
                                startTransaction: n,
                                proceed: s.x.bind(null, t),
                                canProceed: s.C.bind(null, t),
                                getSavedTransactionMeta: v.uN.bind(null, t),
                                createTransactionMeta: v.Xc.bind(null, t),
                                getTransactionMeta: v.Co.bind(null, t),
                                saveTransactionMeta: v.r0.bind(null, t),
                                clearTransactionMeta: v.Jm.bind(null, t),
                                isTransactionMetaValid: v.Wf
                            }), e1.fingerprint = P.Z.bind(null, (0, k.Z)(e1)), e1;
                        }
                        return (0, m.Z)(o);
                    }(e1), (0, T.Z)(t, "webauthn", S), t;
                }
                var A = n(9893), R = n(265), _ = n(279), j = n(3980), C = n(1237), I = n(8707), D = n(6898), M = n(8221);
                function N(e1, t) {
                    return function(e1) {
                        (0, w.Z)(i, e1);
                        var n, r, o = (n = i, r = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, t = (0, Z.Z)(n);
                            if (r) {
                                var o = (0, Z.Z)(this).constructor;
                                e1 = Reflect.construct(t, arguments, o);
                            } else e1 = t.apply(this, arguments);
                            return (0, O.Z)(this, e1);
                        });
                        function i() {
                            var e1, n;
                            (0, b.Z)(this, i);
                            for(var r = arguments.length, a = new Array(r), u = 0; u < r; u++)a[u] = arguments[u];
                            return e1 = o.call.apply(o, [
                                this
                            ].concat(a)), (0, T.Z)((0, k.Z)(e1), "token", void 0), (0, T.Z)((0, k.Z)(e1), "transactionManager", void 0), e1.transactionManager = new t(Object.assign({
                                storageManager: e1.storageManager
                            }, e1.options.transactionManager)), e1.token = (n = (0, k.Z)(e1), {
                                prepareTokenParams: D.wu.bind(null, n),
                                exchangeCodeForTokens: I.r.bind(null, n),
                                decode: C.T
                            }), e1;
                        }
                        return (0, m.Z)(i, [
                            {
                                key: "isLoginRedirect",
                                value: function() {
                                    return (0, M.gM)(this);
                                }
                            },
                            {
                                key: "isPKCE",
                                value: function() {
                                    return !!this.options.pkce;
                                }
                            },
                            {
                                key: "hasResponseType",
                                value: function(e1) {
                                    return (0, M.wV)(e1, this.options);
                                }
                            },
                            {
                                key: "isAuthorizationCodeFlow",
                                value: function() {
                                    return this.hasResponseType("code");
                                }
                            }
                        ]), i;
                    }(e1);
                }
                function U(e1, t, n) {
                    var r = (0, A.a)(t), o = (0, R.H)(r, e1), i = (0, _.A)(o);
                    return x(N((0, j.Z)(i), n));
                }
                var L = n(8137), H = n(4602), B = n(4143), K = n(7595), F = n(3334);
            },
            6131: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    E: function() {
                        return h;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(2620), c = n(7599), s = n(3193), f = n(5385);
                function l(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function p(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? l(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function d(e1) {
                    return {
                        meta: e1,
                        interactionHandle: e1.interactionHandle,
                        state: e1.state
                    };
                }
                function h(e1) {
                    return v.apply(this, arguments);
                }
                function v() {
                    return v = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, l, h, v, y, g, m, b, k, w, O, Z, T, E, P, S, x, A, R, _, j, C, I = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (o = I.length > 1 && void 0 !== I[1] ? I[1] : {}, o = (0, s.YY)(o), i = (0, u.uN)(t, o), null === (n = i) || void 0 === n || !n.interactionHandle) {
                                        e1.next = 5;
                                        break;
                                    }
                                    return e1.abrupt("return", d(i));
                                case 5:
                                    return e1.next = 7, (0, u.Xc)(t, p(p({}, i), o));
                                case 7:
                                    return i = e1.sent, l = (0, c.zf)(t), v = (h = i).clientId, y = h.redirectUri, g = h.state, m = h.scopes, b = h.withCredentials, k = h.codeChallenge, w = h.codeChallengeMethod, O = h.activationToken, Z = h.recoveryToken, T = h.maxAge, E = h.acrValues, P = h.nonce, S = o.clientSecret || t.options.clientSecret, b = null === (r = b) || void 0 === r || r, x = "".concat(l, "/v1/interact"), A = p(p(p(p(p(p({
                                        client_id: v,
                                        scope: m.join(" "),
                                        redirect_uri: y,
                                        code_challenge: k,
                                        code_challenge_method: w,
                                        state: g
                                    }, O && {
                                        activation_token: O
                                    }), Z && {
                                        recovery_token: Z
                                    }), S && {
                                        client_secret: S
                                    }), T && {
                                        max_age: T
                                    }), E && {
                                        acr_values: E
                                    }), P && {
                                        nonce: P
                                    }), R = {
                                        "Content-Type": "application/x-www-form-urlencoded"
                                    }, e1.next = 17, (0, f.c3)(t, {
                                        method: "POST",
                                        url: x,
                                        headers: R,
                                        withCredentials: b,
                                        args: A
                                    });
                                case 17:
                                    return _ = e1.sent, j = _.interaction_handle, C = p(p({}, i), {}, {
                                        interactionHandle: j,
                                        withCredentials: b,
                                        state: g,
                                        scopes: m,
                                        recoveryToken: Z,
                                        activationToken: O
                                    }), (0, u.r0)(t, C), e1.abrupt("return", d(C));
                                case 22:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), v.apply(this, arguments);
                }
            },
            2660: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    L: function() {
                        return p;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(5923), u = n(480), c = n(7599), s = n(1971), f = n(5385), l = n(5728);
                function p(e1) {
                    return d.apply(this, arguments);
                }
                function d() {
                    return d = (0, r.Z)(i().mark(function e1(t) {
                        var n, r, o, p, d, h, v, y, g, m, b, k, w, O, Z = arguments;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = Z.length > 1 && void 0 !== Z[1] ? Z[1] : {}, (p = t.transactionManager.loadIdxResponse(n)) && (r = p.rawIdxResponse, o = p.requestDidSucceed), r) {
                                        e1.next = 27;
                                        break;
                                    }
                                    return h = n.version || s.IDX_API_VERSION, v = (0, c.Xp)(t), y = n.interactionHandle, g = n.stateHandle, m = null === (d = n.withCredentials) || void 0 === d || d, e1.prev = 8, o = !0, (0, a.A0)(h), b = "".concat(v, "/idp/idx/introspect"), k = g ? {
                                        stateToken: g
                                    } : {
                                        interactionHandle: y
                                    }, w = {
                                        "Content-Type": "application/ion+json; okta-version=".concat(h),
                                        Accept: "application/ion+json; okta-version=".concat(h)
                                    }, e1.next = 16, (0, f.c3)(t, {
                                        method: "POST",
                                        url: b,
                                        headers: w,
                                        withCredentials: m,
                                        args: k
                                    });
                                case 16:
                                    r = e1.sent, e1.next = 27;
                                    break;
                                case 19:
                                    if (e1.prev = 19, e1.t0 = e1.catch(8), !((0, l.isAuthApiError)(e1.t0) && e1.t0.xhr && (0, u.P)(e1.t0.xhr.responseJSON))) {
                                        e1.next = 26;
                                        break;
                                    }
                                    r = e1.t0.xhr.responseJSON, o = !1, e1.next = 27;
                                    break;
                                case 26:
                                    throw e1.t0;
                                case 27:
                                    return O = n.withCredentials, e1.abrupt("return", (0, a._T)(t, r, {
                                        withCredentials: O
                                    }, o));
                                case 29:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                8,
                                19
                            ]
                        ]);
                    })), d.apply(this, arguments);
                }
            },
            8137: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    B: function() {
                        return d;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(8717), l = n(8719), p = n(8716);
                function d(e1) {
                    var t;
                    return t = function(e1) {
                        (0, a.Z)(d, e1);
                        var t, n, p = (t = d, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function d() {
                            var e1;
                            (0, o.Z)(this, d);
                            for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                            return e1 = p.call.apply(p, [
                                this
                            ].concat(n)), (0, s.Z)((0, i.Z)(e1), "idx", void 0), (0, s.Z)((0, i.Z)(e1), "fingerprint", void 0), e1.idx = (0, f.F)((0, i.Z)(e1)), e1.fingerprint = l.Z.bind(null, (0, i.Z)(e1)), e1;
                        }
                        return (0, r.Z)(d);
                    }(e1), (0, s.Z)(t, "webauthn", p), t;
                }
            },
            4602: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    S: function() {
                        return l;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(9133);
                function l() {
                    return function(e1) {
                        (0, a.Z)(l, e1);
                        var t, n, f = (t = l, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function l(e1) {
                            var t;
                            return (0, o.Z)(this, l), t = f.call(this, e1), (0, s.Z)((0, i.Z)(t), "flow", void 0), (0, s.Z)((0, i.Z)(t), "activationToken", void 0), (0, s.Z)((0, i.Z)(t), "recoveryToken", void 0), (0, s.Z)((0, i.Z)(t), "idx", void 0), t.flow = e1.flow, t.activationToken = e1.activationToken, t.recoveryToken = e1.recoveryToken, t.idx = e1.idx, t;
                        }
                        return (0, r.Z)(l);
                    }((0, f.n)());
                }
            },
            9310: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $: function() {
                        return s;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(2845), u = n(2620), c = n(146);
                function s(e1) {
                    return f.apply(this, arguments);
                }
                function f() {
                    return f = (0, r.Z)(i().mark(function e1(t) {
                        var n, o, f, l, p, d, h, v = arguments;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return f = (o = v.length > 1 && void 0 !== v[1] ? v[1] : {}).withCredentials, l = o.exchangeCodeForTokens, e1.next = 4, (0, a.x)(t, {
                                        startPolling: !0,
                                        withCredentials: f,
                                        exchangeCodeForTokens: l
                                    });
                                case 4:
                                    if (p = e1.sent, d = (0, u.uN)(t), null != (h = null == d || null === (n = d.remediations) || void 0 === n ? void 0 : n.find(function(e1) {
                                        return e1.includes("poll");
                                    })) && h.length || (0, c.ZK)("No polling remediations available at the current IDX flow stage"), !Number.isInteger(o.refresh)) {
                                        e1.next = 10;
                                        break;
                                    }
                                    return e1.abrupt("return", new Promise(function(e1, n) {
                                        setTimeout((0, r.Z)(i().mark(function r() {
                                            var o, a, u;
                                            return i().wrap(function(r) {
                                                for(;;)switch(r.prev = r.next){
                                                    case 0:
                                                        try {
                                                            u = null === (o = p.nextStep) || void 0 === o || null === (a = o.poll) || void 0 === a ? void 0 : a.refresh, e1(u ? s(t, {
                                                                refresh: u
                                                            }) : p);
                                                        } catch (e1) {
                                                            n(e1);
                                                        }
                                                    case 1:
                                                    case "end":
                                                        return r.stop();
                                                }
                                            }, r);
                                        })), o.refresh);
                                    }));
                                case 10:
                                    return e1.abrupt("return", p);
                                case 11:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), f.apply(this, arguments);
                }
            },
            2845: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    C: function() {
                        return p;
                    },
                    x: function() {
                        return d;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3377), c = n(2620), s = n(9123);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function p(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return !(!(0, c.uN)(e1, t) && !t.stateHandle);
                }
                function d(e1) {
                    return h.apply(this, arguments);
                }
                function h() {
                    return h = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, f = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (p(t, n = f.length > 1 && void 0 !== f[1] ? f[1] : {})) {
                                        e1.next = 3;
                                        break;
                                    }
                                    throw new s.Z("Unable to proceed: saved transaction could not be loaded");
                                case 3:
                                    return r = n.flow, o = n.state, r || (i = (0, c.uN)(t, {
                                        state: o
                                    }), r = null == i ? void 0 : i.flow), e1.abrupt("return", (0, u.K)(t, l(l({}, n), {}, {
                                        flow: r
                                    })));
                                case 6:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), h.apply(this, arguments);
                }
            },
            9214: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    M: function() {
                        return l;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3377), c = n(7738);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function l(e1) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return p = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = o.length > 1 && void 0 !== o[1] ? o[1] : {}, r = (0, c.s)(t, "recoverPassword"), e1.abrupt("return", (0, u.K)(t, f(f({}, n), r)));
                                case 3:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), p.apply(this, arguments);
                }
            },
            8826: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    z: function() {
                        return h;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3377), c = n(2620), s = n(2473), f = n(9123), l = n(7595);
                function p(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function d(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? p(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function h(e1) {
                    return v.apply(this, arguments);
                }
                function v() {
                    return v = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = i.length > 1 && void 0 !== i[1] ? i[1] : {}, (0, c.$0)(t)) {
                                        e1.next = 8;
                                        break;
                                    }
                                    return e1.next = 4, (0, s.Y)(t, d(d({}, n), {}, {
                                        flow: "register",
                                        autoRemediate: !1
                                    }));
                                case 4:
                                    if (r = e1.sent, o = r.enabledFeatures, n.activationToken || !o || o.includes(l.Fw.REGISTRATION)) {
                                        e1.next = 8;
                                        break;
                                    }
                                    throw new f.Z("Registration is not supported based on your current org configuration.");
                                case 8:
                                    return e1.abrupt("return", (0, u.K)(t, d(d({}, n), {}, {
                                        flow: "register"
                                    })));
                                case 9:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), v.apply(this, arguments);
                }
            },
            2541: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    q: function() {
                        return h;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(4794), l = n(6064);
                function p(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function d(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? p(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var h = function(e1) {
                    (0, a.Z)(f, e1);
                    var t, n, s = (t = f, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function f() {
                        return (0, r.Z)(this, f), s.apply(this, arguments);
                    }
                    return (0, o.Z)(f, [
                        {
                            key: "mapAuthenticator",
                            value: function() {
                                var e1 = this.getAuthenticatorData();
                                return {
                                    id: (0, l.zg)(this.remediation).form.value.find(function(e1) {
                                        return "id" === e1.name;
                                    }).value,
                                    methodType: e1.methodType,
                                    phoneNumber: e1.phoneNumber
                                };
                            }
                        },
                        {
                            key: "getInputAuthenticator",
                            value: function(e1) {
                                return [
                                    {
                                        name: "methodType",
                                        type: "string"
                                    },
                                    {
                                        name: "phoneNumber",
                                        label: "Phone Number",
                                        type: "string"
                                    }
                                ].map(function(t) {
                                    return d(d({}, e1.form.value.find(function(e1) {
                                        return e1.name === t.name;
                                    })), t);
                                });
                            }
                        },
                        {
                            key: "mapAuthenticatorDataFromValues",
                            value: function(e1) {
                                e1 = (0, i.Z)((0, c.Z)(f.prototype), "mapAuthenticatorDataFromValues", this).call(this, e1);
                                var t = this.values.phoneNumber;
                                if (e1 || t) return d(d({}, e1 && e1), t && {
                                    phoneNumber: t
                                });
                            }
                        }
                    ]), f;
                }(f.a);
                (0, s.Z)(h, "remediationName", "authenticator-enrollment-data");
            },
            5278: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    q: function() {
                        return d;
                    }
                });
                var r = n(2982), o = n(5671), i = n(3144), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942);
                function l(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function p(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? l(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var d = function(e1) {
                    (0, u.Z)(d, e1);
                    var t, n, l = (t = d, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function d() {
                        return (0, o.Z)(this, d), l.apply(this, arguments);
                    }
                    return (0, i.Z)(d, [
                        {
                            key: "mapAuthenticator",
                            value: function() {
                                return this.getAuthenticatorData();
                            }
                        },
                        {
                            key: "getInputAuthenticator",
                            value: function() {
                                var e1 = this.getAuthenticatorFromRemediation(), t = e1.form.value.find(function(e1) {
                                    return "methodType" === e1.name;
                                });
                                return t && t.options ? {
                                    name: "methodType",
                                    type: "string",
                                    required: !0,
                                    options: t.options
                                } : (0, r.Z)(e1.form.value);
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                return this.values = (0, a.Z)((0, s.Z)(d.prototype), "getValuesAfterProceed", this).call(this), Object.keys(this.values).filter(function(e1) {
                                    return "authenticator" !== e1;
                                }).reduce(function(t, n) {
                                    return p(p({}, t), {}, (0, f.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), d;
                }(n(4794).a);
                (0, f.Z)(d, "remediationName", "authenticator-verification-data");
            },
            4794: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return y;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(3118), p = n(7595), d = n(9344);
                function h(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function v(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? h(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var y = function(e1) {
                    (0, u.Z)(h, e1);
                    var t, n, l = (t = h, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function h(e1) {
                        var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        return (0, r.Z)(this, h), t = l.call(this, e1, n), (0, f.Z)((0, i.Z)(t), "authenticator", void 0), t.authenticator = t.getAuthenticator(), t.formatAuthenticatorData(), t;
                    }
                    return (0, o.Z)(h, [
                        {
                            key: "formatAuthenticatorData",
                            value: function() {
                                var e1 = this;
                                if (this.getAuthenticatorData()) this.values.authenticatorsData = this.values.authenticatorsData.map(function(t) {
                                    return (0, d.PN)(e1.authenticator, t) ? e1.mapAuthenticatorDataFromValues(t) : t;
                                });
                                else {
                                    var t = this.mapAuthenticatorDataFromValues();
                                    t && this.values.authenticatorsData.push(t);
                                }
                            }
                        },
                        {
                            key: "getAuthenticatorData",
                            value: function() {
                                var e1 = this;
                                return this.values.authenticatorsData.find(function(t) {
                                    return (0, d.PN)(e1.authenticator, t);
                                });
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function() {
                                var e1 = this;
                                return this.values.authenticatorsData.some(function(t) {
                                    return (0, d.PN)(e1.authenticator, t);
                                });
                            }
                        },
                        {
                            key: "mapAuthenticatorDataFromValues",
                            value: function(e1) {
                                var t = this.values, n = t.methodType, r = t.authenticator;
                                !n && (0, p.H)(r) && (n = null == r ? void 0 : r.methodType);
                                var o = this.authenticator, i = v(v({
                                    id: o.id,
                                    enrollmentId: o.enrollmentId
                                }, e1 && e1), n && {
                                    methodType: n
                                });
                                return i.methodType ? i : null;
                            }
                        },
                        {
                            key: "getAuthenticatorFromRemediation",
                            value: function() {
                                return this.remediation.value.find(function(e1) {
                                    return "authenticator" === e1.name;
                                });
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                this.values = (0, a.Z)((0, s.Z)(h.prototype), "getValuesAfterProceed", this).call(this);
                                var t = this.values.authenticatorsData.filter(function(t) {
                                    return !0 !== (0, d.PN)(e1.authenticator, t);
                                });
                                return v(v({}, this.values), {}, {
                                    authenticatorsData: t
                                });
                            }
                        }
                    ]), h;
                }(l.n);
            },
            3118: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    n: function() {
                        return d;
                    }
                });
                var r = n(2982), o = n(1002), i = n(5671), a = n(3144), u = n(4942), c = n(6064), s = n(9344);
                function f(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                function l(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function p(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? l(Object(n), !0).forEach(function(t) {
                            (0, u.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var d = function() {
                    function e1(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        (0, i.Z)(this, e1), (0, u.Z)(this, "remediation", void 0), (0, u.Z)(this, "values", void 0), (0, u.Z)(this, "options", void 0), (0, u.Z)(this, "map", void 0), this.values = p({}, n), this.options = p({}, r), this.formatAuthenticators(), this.remediation = t;
                    }
                    return (0, a.Z)(e1, [
                        {
                            key: "formatAuthenticators",
                            value: function() {
                                if (this.values.authenticators = this.values.authenticators || [], this.values.authenticators = this.values.authenticators.map(function(e1) {
                                    return (0, s.LL)(e1);
                                }), this.values.authenticator) {
                                    var e1 = (0, s.LL)(this.values.authenticator);
                                    this.values.authenticators.some(function(t) {
                                        return (0, s.PN)(e1, t);
                                    }) || this.values.authenticators.push(e1);
                                }
                                this.values.authenticatorsData = this.values.authenticators.reduce(function(e1, t) {
                                    return "object" === (0, o.Z)(t) && Object.keys(t).length > 1 && e1.push(t), e1;
                                }, this.values.authenticatorsData || []);
                            }
                        },
                        {
                            key: "getName",
                            value: function() {
                                return this.remediation.name;
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function(e1) {
                                var t = this;
                                return !(0, c.QG)(this.remediation).find(function(e1) {
                                    return !t.hasData(e1);
                                });
                            }
                        },
                        {
                            key: "getData",
                            value: function(e1) {
                                var t = this;
                                if (!e1) {
                                    var n = (0, c.ix)(this.remediation).reduce(function(e1, n) {
                                        return e1[n] = t.getData(n), e1;
                                    }, {});
                                    return n;
                                }
                                if ("function" == typeof this["map".concat((0, c.Qs)(e1))]) {
                                    var r = this["map".concat((0, c.Qs)(e1))](this.remediation.value.find(function(t) {
                                        return t.name === e1;
                                    }));
                                    if (r) return r;
                                }
                                if (this.map && this.map[e1]) for(var o = this.map[e1], i = 0; i < o.length; i++){
                                    var a = this.values[o[i]];
                                    if (a) return a;
                                }
                                return this.values[e1];
                            }
                        },
                        {
                            key: "hasData",
                            value: function(e1) {
                                return !!this.getData(e1);
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n = this.getName(), r = this.getInputs(), o = this.getAuthenticator(), i = null == o ? void 0 : o.type;
                                return p(p({
                                    name: n,
                                    inputs: r
                                }, i && {
                                    type: i
                                }), o && {
                                    authenticator: o
                                });
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                var e1 = this, t = [];
                                return (this.remediation.value || []).forEach(function(n) {
                                    var r, o = n.name, i = n.type, a = n.visible, u = n.messages;
                                    if (!1 !== a) {
                                        if ("function" == typeof e1["getInput".concat((0, c.Qs)(o))]) r = e1["getInput".concat((0, c.Qs)(o))](n);
                                        else if ("object" !== i) {
                                            var s, f = (e1.map ? e1.map[o] : null) || [];
                                            s = 1 === f.length ? f[0] : f.find(function(t) {
                                                return Object.keys(e1.values).includes(t);
                                            }), s && (r = p(p({}, n), {}, {
                                                name: s
                                            }));
                                        }
                                        r || (r = n), Array.isArray(r) ? r.forEach(function(e1) {
                                            return t.push(e1);
                                        }) : (u && (r.messages = u), t.push(r));
                                    }
                                }), t;
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1, t = this.remediation.value || [], n = this.getInputs(), o = function(e1, t) {
                                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                    if (!n) {
                                        if (Array.isArray(e1) || (n = function(e1, t) {
                                            if (e1) {
                                                if ("string" == typeof e1) return f(e1, t);
                                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? f(e1, t) : void 0;
                                            }
                                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                                            n && (e1 = n);
                                            var r = 0, o = function() {};
                                            return {
                                                s: o,
                                                n: function() {
                                                    return r >= e1.length ? {
                                                        done: !0
                                                    } : {
                                                        done: !1,
                                                        value: e1[r++]
                                                    };
                                                },
                                                e: function(e1) {
                                                    throw e1;
                                                },
                                                f: o
                                            };
                                        }
                                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                    }
                                    var i, a = !0, u = !1;
                                    return {
                                        s: function() {
                                            n = n.call(e1);
                                        },
                                        n: function() {
                                            var e1 = n.next();
                                            return a = e1.done, e1;
                                        },
                                        e: function(e1) {
                                            u = !0, i = e1;
                                        },
                                        f: function() {
                                            try {
                                                a || null == n.return || n.return();
                                            } finally{
                                                if (u) throw i;
                                            }
                                        }
                                    };
                                }([].concat((0, r.Z)(t), (0, r.Z)(n)));
                                try {
                                    for(o.s(); !(e1 = o.n()).done;){
                                        var i = e1.value;
                                        delete this.values[i.name];
                                    }
                                } catch (e1) {
                                    o.e(e1);
                                } finally{
                                    o.f();
                                }
                                return this.values;
                            }
                        },
                        {
                            key: "getAuthenticator",
                            value: function() {
                                var e1, t, n = null === (e1 = this.remediation.relatesTo) || void 0 === e1 ? void 0 : e1.value;
                                if (n) {
                                    var r = (0, c.zg)(this.remediation);
                                    if (!r) return n;
                                    var o = r.form.value.find(function(e1) {
                                        return "id" === e1.name;
                                    }).value, i = null === (t = r.form.value.find(function(e1) {
                                        return "enrollmentId" === e1.name;
                                    })) || void 0 === t ? void 0 : t.value;
                                    return p(p({}, n), {}, {
                                        id: o,
                                        enrollmentId: i
                                    });
                                }
                            }
                        }
                    ], [
                        {
                            key: "getMessages",
                            value: function(e1) {
                                var t, n;
                                if (e1.value) return null === (t = e1.value[0]) || void 0 === t || null === (n = t.form) || void 0 === n ? void 0 : n.value.reduce(function(e1, t) {
                                    return t.messages && (e1 = [].concat((0, r.Z)(e1), (0, r.Z)(t.messages.value))), e1;
                                }, []);
                            }
                        }
                    ]), e1;
                }();
                (0, u.Z)(d, "remediationName", void 0);
            },
            9164: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    n: function() {
                        return m;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(3118), p = n(6064), d = n(7595), h = n(9344);
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function g(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var m = function(e1) {
                    (0, u.Z)(v, e1);
                    var t, n, l = (t = v, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function v() {
                        var e1;
                        (0, r.Z)(this, v);
                        for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                        return e1 = l.call.apply(l, [
                            this
                        ].concat(n)), (0, f.Z)((0, i.Z)(e1), "selectedAuthenticator", void 0), (0, f.Z)((0, i.Z)(e1), "selectedOption", void 0), e1;
                    }
                    return (0, o.Z)(v, [
                        {
                            key: "findMatchedOption",
                            value: function(e1, t) {
                                var n, r, o = function(e1, t) {
                                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                    if (!n) {
                                        if (Array.isArray(e1) || (n = function(e1, t) {
                                            if (e1) {
                                                if ("string" == typeof e1) return g(e1, t);
                                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? g(e1, t) : void 0;
                                            }
                                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                                            n && (e1 = n);
                                            var r = 0, o = function() {};
                                            return {
                                                s: o,
                                                n: function() {
                                                    return r >= e1.length ? {
                                                        done: !0
                                                    } : {
                                                        done: !1,
                                                        value: e1[r++]
                                                    };
                                                },
                                                e: function(e1) {
                                                    throw e1;
                                                },
                                                f: o
                                            };
                                        }
                                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                    }
                                    var i, a = !0, u = !1;
                                    return {
                                        s: function() {
                                            n = n.call(e1);
                                        },
                                        n: function() {
                                            var e1 = n.next();
                                            return a = e1.done, e1;
                                        },
                                        e: function(e1) {
                                            u = !0, i = e1;
                                        },
                                        f: function() {
                                            try {
                                                a || null == n.return || n.return();
                                            } finally{
                                                if (u) throw i;
                                            }
                                        }
                                    };
                                }(e1);
                                try {
                                    var i = function() {
                                        var e1 = r.value;
                                        if (n = t.find(function(t) {
                                            var n = t.relatesTo;
                                            return n.key && n.key === e1.key;
                                        })) return "break";
                                    };
                                    for(o.s(); !(r = o.n()).done && "break" !== i(););
                                } catch (e1) {
                                    o.e(e1);
                                } finally{
                                    o.f();
                                }
                                return n;
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function(e1) {
                                var t = this.values, n = t.authenticators, r = t.authenticator, o = (0, p.zg)(this.remediation).options;
                                if (!n || !n.length) return !1;
                                if ((0, d.H)(r) && r.id) return !0;
                                var i = this.findMatchedOption(n, o);
                                if (i) {
                                    var a, u, c = (null == e1 ? void 0 : e1.currentAuthenticator) && (null == e1 ? void 0 : e1.currentAuthenticator.value.id) === (null === (a = i.relatesTo) || void 0 === a ? void 0 : a.id), s = (null == e1 ? void 0 : e1.currentAuthenticatorEnrollment) && (null == e1 ? void 0 : e1.currentAuthenticatorEnrollment.value.id) === (null === (u = i.relatesTo) || void 0 === u ? void 0 : u.id);
                                    return !c && !s;
                                }
                                return !1;
                            }
                        },
                        {
                            key: "mapAuthenticator",
                            value: function(e1) {
                                var t = this.values, n = t.authenticators, r = t.authenticator;
                                if ((0, d.H)(r) && r.id) return this.selectedAuthenticator = r, r;
                                var o = e1.options, i = (0, h.h_)(n, o);
                                return this.selectedAuthenticator = i.relatesTo, this.selectedOption = i, {
                                    id: null == i ? void 0 : i.value.form.value.find(function(e1) {
                                        return "id" === e1.name;
                                    }).value
                                };
                            }
                        },
                        {
                            key: "getInputAuthenticator",
                            value: function(e1) {
                                return {
                                    name: "authenticator",
                                    type: "string",
                                    options: e1.options.map(function(e1) {
                                        return {
                                            label: e1.label,
                                            value: e1.relatesTo.key
                                        };
                                    })
                                };
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                this.values = (0, a.Z)((0, s.Z)(v.prototype), "getValuesAfterProceed", this).call(this);
                                var t = this.values.authenticators.filter(function(t) {
                                    return !0 !== (0, h.PN)(t, e1.selectedAuthenticator);
                                });
                                return y(y({}, this.values), {}, {
                                    authenticators: t
                                });
                            }
                        }
                    ]), v;
                }(l.n);
            },
            9883: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Q: function() {
                        return P;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(3118), p = n(7644);
                function d(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function h(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? d(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var v = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                return !!(e1.credentials || e1.verificationCode || e1.otp);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.credentials, n = e1.verificationCode, r = e1.otp;
                                if (t || n || r) return t || {
                                    passcode: n || r
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function(e1) {
                                var t;
                                return h(h({}, null === (t = e1.form) || void 0 === t ? void 0 : t.value[0]), {}, {
                                    name: "verificationCode",
                                    type: "string",
                                    required: e1.required
                                });
                            }
                        }
                    ]), a;
                }(p._);
                var y = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.verificationCode;
                                if (t) return {
                                    totp: t
                                };
                            }
                        }
                    ]), a;
                }(v), g = n(9582);
                var m = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                var t = e1.credentials;
                                if (t && t.questionKey && t.answer) return !0;
                                var n = e1.questionKey, r = e1.question, o = e1.answer;
                                return !(!n || !o) || !(!r || !o);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.questionKey, n = e1.question, r = e1.answer;
                                if (r && (t || n)) return {
                                    questionKey: n ? "custom" : t,
                                    question: n,
                                    answer: r
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return [
                                    {
                                        name: "questionKey",
                                        type: "string",
                                        required: !0
                                    },
                                    {
                                        name: "question",
                                        type: "string",
                                        label: "Create a security question"
                                    },
                                    {
                                        name: "answer",
                                        type: "string",
                                        label: "Answer",
                                        required: !0
                                    }
                                ];
                            }
                        }
                    ]), a;
                }(p._);
                var b = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                var t = e1.credentials;
                                return !(!t || !t.answer) || !!e1.answer;
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.answer;
                                if (t) return {
                                    questionKey: this.meta.contextualData.enrolledQuestion.questionKey,
                                    answer: t
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return [
                                    {
                                        name: "answer",
                                        type: "string",
                                        label: "Answer",
                                        required: !0
                                    }
                                ];
                            }
                        }
                    ]), a;
                }(p._);
                function k(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                var w = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                var t = e1.credentials || e1, n = t.clientData, r = t.attestation;
                                return !(!n || !r);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.credentials, n = e1.clientData, r = e1.attestation, o = e1.transports;
                                if (t || n || r) return t || function(e1) {
                                    for(var t = 1; t < arguments.length; t++){
                                        var n = null != arguments[t] ? arguments[t] : {};
                                        t % 2 ? k(Object(n), !0).forEach(function(t) {
                                            (0, f.Z)(e1, t, n[t]);
                                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : k(Object(n)).forEach(function(t) {
                                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                                        });
                                    }
                                    return e1;
                                }({
                                    clientData: n,
                                    attestation: r
                                }, o && {
                                    transports: o
                                });
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return [
                                    {
                                        name: "clientData",
                                        type: "string",
                                        required: !0,
                                        visible: !1,
                                        label: "Client Data"
                                    },
                                    {
                                        name: "attestation",
                                        type: "string",
                                        required: !0,
                                        visible: !1,
                                        label: "Attestation"
                                    }
                                ];
                            }
                        }
                    ]), a;
                }(p._);
                var O = function(e1) {
                    (0, u.Z)(a, e1);
                    var t, n, i = (t = a, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function a() {
                        return (0, r.Z)(this, a), i.apply(this, arguments);
                    }
                    return (0, o.Z)(a, [
                        {
                            key: "canVerify",
                            value: function(e1) {
                                var t = e1.credentials || e1, n = t.clientData, r = t.authenticatorData, o = t.signatureData;
                                return !!(n && r && o);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function(e1) {
                                var t = e1.credentials, n = e1.authenticatorData, r = e1.clientData, o = e1.signatureData;
                                if (t || n || r || o) return t || {
                                    authenticatorData: n,
                                    clientData: r,
                                    signatureData: o
                                };
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return [
                                    {
                                        name: "authenticatorData",
                                        type: "string",
                                        label: "Authenticator Data",
                                        required: !0,
                                        visible: !1
                                    },
                                    {
                                        name: "clientData",
                                        type: "string",
                                        label: "Client Data",
                                        required: !0,
                                        visible: !1
                                    },
                                    {
                                        name: "signatureData",
                                        type: "string",
                                        label: "Signature Data",
                                        required: !0,
                                        visible: !1
                                    }
                                ];
                            }
                        }
                    ]), a;
                }(p._), Z = n(7595);
                function T(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function E(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? T(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : T(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var P = function(e1) {
                    (0, u.Z)(p, e1);
                    var t, n, l = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function p(e1) {
                        var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        return (0, r.Z)(this, p), t = l.call(this, e1, n), (0, f.Z)((0, i.Z)(t), "authenticator", void 0), t.authenticator = function(e1) {
                            var t, n, r = e1.relatesTo, o = (null == r ? void 0 : r.value) || {};
                            switch(o.key){
                                case Z.pc.OKTA_PASSWORD:
                                    return new g.a(o);
                                case Z.pc.SECURITY_QUESTION:
                                    return null !== (t = o.contextualData) && void 0 !== t && t.enrolledQuestion ? new b(o) : new m(o);
                                case Z.pc.OKTA_VERIFY:
                                    return new y(o);
                                case Z.pc.WEBAUTHN:
                                    return null !== (n = o.contextualData) && void 0 !== n && n.challengeData ? new O(o) : new w(o);
                                default:
                                    return new v(o);
                            }
                        }(e1), t;
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n, r = (0, a.Z)((0, s.Z)(p.prototype), "getNextStep", this).call(this, e1, t), o = null == t || null === (n = t.authenticatorEnrollments) || void 0 === n ? void 0 : n.value;
                                return E(E({}, r), {}, {
                                    authenticatorEnrollments: o
                                });
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function() {
                                return this.authenticator.canVerify(this.values);
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function() {
                                return this.authenticator.mapCredentials(this.values);
                            }
                        },
                        {
                            key: "getInputCredentials",
                            value: function(e1) {
                                return this.authenticator.getInputs(e1);
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                return this.values = (0, a.Z)((0, s.Z)(p.prototype), "getValuesAfterProceed", this).call(this), Object.keys(this.values).filter(function(e1) {
                                    return "credentials" !== e1;
                                }).reduce(function(t, n) {
                                    return E(E({}, t), {}, (0, f.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), p;
                }(l.n);
            },
            4560: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    J: function() {
                        return s;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, r.Z)(s);
                }(n(9883).Q);
                (0, c.Z)(s, "remediationName", "challenge-authenticator");
            },
            1104: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    U: function() {
                        return s;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.values.startPolling || "challenge-poll" === this.options.step;
                            }
                        }
                    ]), s;
                }(n(2288).T);
                (0, c.Z)(s, "remediationName", "challenge-poll");
            },
            3857: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    q: function() {
                        return s;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, r.Z)(s);
                }(n(9883).Q);
                (0, c.Z)(s, "remediationName", "enroll-authenticator");
            },
            2288: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    T: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var p = function(e1) {
                    (0, a.Z)(p, e1);
                    var t, n, f = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function p() {
                        return (0, r.Z)(this, p), f.apply(this, arguments);
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.values.startPolling || "enroll-poll" === this.options.step;
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n = (0, i.Z)((0, c.Z)(p.prototype), "getNextStep", this).call(this, e1, t), r = this.getAuthenticator();
                                return !r && null != t && t.currentAuthenticator && (r = t.currentAuthenticator.value), l(l({}, n), {}, {
                                    authenticator: r,
                                    poll: {
                                        required: !0,
                                        refresh: this.remediation.refresh
                                    }
                                });
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                return Object.keys(this.values).filter(function(e1) {
                                    return "startPolling" !== e1;
                                }).reduce(function(t, n) {
                                    return l(l({}, t), {}, (0, s.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), p;
                }(n(3118).n);
                (0, s.Z)(p, "remediationName", "enroll-poll");
            },
            7522: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    w: function() {
                        return v;
                    }
                });
                var r = n(2982), o = n(5671), i = n(3144), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(3118), p = n(9582);
                function d(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function h(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? d(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var v = function(e1) {
                    (0, u.Z)(d, e1);
                    var t, n, l = (t = d, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function d(e1) {
                        var t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        return (0, o.Z)(this, d), t = l.call(this, e1, n, r), (0, f.Z)((0, a.Z)(t), "authenticator", null), t.getCredentialsFromRemediation() && (t.authenticator = t.authenticator = new p.a({})), t;
                    }
                    return (0, i.Z)(d, [
                        {
                            key: "canRemediate",
                            value: function() {
                                if (this.authenticator && !this.authenticator.canVerify(this.values)) return !1;
                                var e1 = this.getData().userProfile;
                                return !!e1 && this.remediation.value.find(function(e1) {
                                    return "userProfile" === e1.name;
                                }).form.value.reduce(function(t, n) {
                                    return n.required && (t = t && !!e1[n.name]), t;
                                }, !0);
                            }
                        },
                        {
                            key: "getCredentialsFromRemediation",
                            value: function() {
                                return this.remediation.value.find(function(e1) {
                                    return "credentials" === e1.name;
                                });
                            }
                        },
                        {
                            key: "mapUserProfile",
                            value: function(e1) {
                                var t = this, n = e1.form.value.map(function(e1) {
                                    return e1.name;
                                }).reduce(function(e1, n) {
                                    return t.values[n] ? h(h({}, e1), {}, (0, f.Z)({}, n, t.values[n])) : e1;
                                }, {});
                                if (0 !== Object.keys(n).length) return n;
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function() {
                                var e1 = this.authenticator && this.authenticator.mapCredentials(this.values);
                                if (e1) return e1;
                            }
                        },
                        {
                            key: "getInputUserProfile",
                            value: function(e1) {
                                return (0, r.Z)(e1.form.value);
                            }
                        },
                        {
                            key: "getInputCredentials",
                            value: function(e1) {
                                return (0, r.Z)(e1.form.value);
                            }
                        },
                        {
                            key: "getErrorMessages",
                            value: function(e1) {
                                return e1.value[0].form.value.reduce(function(e1, t) {
                                    return t.messages && e1.push(t.messages.value[0].message), e1;
                                }, []);
                            }
                        }
                    ]), d;
                }(l.n);
                (0, f.Z)(v, "remediationName", "enroll-profile");
            },
            3679: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    t: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var p = function(e1) {
                    (0, a.Z)(p, e1);
                    var t, n, f = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function p() {
                        return (0, r.Z)(this, p), f.apply(this, arguments);
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "getInputEmail",
                            value: function() {
                                return [
                                    {
                                        name: "email",
                                        type: "string",
                                        required: !0,
                                        label: "Email"
                                    }
                                ];
                            }
                        },
                        {
                            key: "getInputPhoneNumber",
                            value: function() {
                                return [
                                    {
                                        name: "phoneNumber",
                                        type: "string",
                                        required: !0,
                                        label: "Phone Number"
                                    }
                                ];
                            }
                        },
                        {
                            key: "canRemediate",
                            value: function() {
                                return Boolean(this.values.email || this.values.phoneNumber);
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n = (0, i.Z)((0, c.Z)(p.prototype), "getNextStep", this).call(this, e1, t), r = t.currentAuthenticator.value;
                                return l(l({}, n), {}, {
                                    authenticator: r
                                });
                            }
                        },
                        {
                            key: "getData",
                            value: function() {
                                return {
                                    stateHandle: this.values.stateHandle,
                                    email: this.values.email,
                                    phoneNumber: this.values.phoneNumber
                                };
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                return Object.keys(this.values).filter(function(e1) {
                                    return ![
                                        "email",
                                        "phoneNumber"
                                    ].includes(e1);
                                }).reduce(function(t, n) {
                                    return l(l({}, t), {}, (0, s.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), p;
                }(n(3118).n);
                (0, s.Z)(p, "remediationName", "enrollment-channel-data");
            },
            9732: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    P: function() {
                        return k;
                    }
                });
                var r = n(5861), o = n(4942), i = n(4925), a = n(5671), u = n(3144), c = n(136), s = n(2963), f = n(1120), l = n(4687), p = n.n(l), d = n(3118), h = n(1002), v = n(885);
                function y(e1) {
                    if (Array.isArray(e1)) return e1.map(function(e1) {
                        return "string" == typeof e1 || "number" == typeof e1 || "boolean" == typeof e1 ? e1 : y(e1);
                    });
                    for(var t = {}, n = 0, r = Object.entries(e1); n < r.length; n++){
                        var o = (0, v.Z)(r[n], 2), i = o[0], a = o[1];
                        if (null != a) {
                            if ("object" === (0, h.Z)(a)) {
                                var u = Object.keys(a);
                                if ([
                                    "value",
                                    "form"
                                ].includes(i) && 1 === u.length && [
                                    "value",
                                    "form"
                                ].includes(u[0])) {
                                    var c = y(a);
                                    Object.entries(c).forEach(function(e1) {
                                        var n = (0, v.Z)(e1, 2), r = n[0], o = n[1];
                                        t[r] = o;
                                    });
                                } else t[i] = y(a);
                            } else t[i] = a;
                        }
                    }
                    return t;
                }
                var g = [
                    "href",
                    "method",
                    "rel",
                    "accepts",
                    "produces",
                    "value",
                    "action"
                ];
                function m(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function b(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? m(Object(n), !0).forEach(function(t) {
                            (0, o.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var k = function(e1) {
                    (0, c.Z)(l, e1);
                    var t, n, o = (t = l, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, f.Z)(t);
                        if (n) {
                            var o = (0, f.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, s.Z)(this, e1);
                    });
                    function l() {
                        return (0, a.Z)(this, l), o.apply(this, arguments);
                    }
                    return (0, u.Z)(l, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !("function" != typeof this.remediation.action || "poll" !== this.remediation.name && !this.remediation.name.endsWith("-poll") && !this.options.step);
                            }
                        },
                        {
                            key: "getData",
                            value: function() {
                                var e1 = this;
                                return this.getInputs().reduce(function(t, n) {
                                    var r = n.name;
                                    return t[r] = e1.values[r], t;
                                }, {});
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n, o = this.getName(), a = this.getInputs(), u = this.remediation, c = (u.href, u.method, u.rel, u.accepts, u.produces, u.value, u.action), s = (0, i.Z)(u, g);
                                return c ? b(b(b({}, s), !!a.length && {
                                    inputs: a
                                }), {}, {
                                    action: (n = (0, r.Z)(p().mark(function t(n) {
                                        return p().wrap(function(t) {
                                            for(;;)switch(t.prev = t.next){
                                                case 0:
                                                    return t.abrupt("return", e1.idx.proceed(b({
                                                        step: o
                                                    }, n)));
                                                case 1:
                                                case "end":
                                                    return t.stop();
                                            }
                                        }, t);
                                    })), function(e1) {
                                        return n.apply(this, arguments);
                                    })
                                }) : b({}, this.remediation);
                            }
                        },
                        {
                            key: "getInputs",
                            value: function() {
                                return (this.remediation.value || []).filter(function(e1) {
                                    return "stateHandle" !== e1.name;
                                }).map(y).map(function(e1) {
                                    return e1.type = e1.type || "string", e1;
                                });
                            }
                        }
                    ]), l;
                }(d.n);
            },
            8628: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    h: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var p = function(e1) {
                    (0, a.Z)(p, e1);
                    var t, n, f = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function p() {
                        var e1;
                        (0, r.Z)(this, p);
                        for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                        return e1 = f.call.apply(f, [
                            this
                        ].concat(n)), (0, s.Z)((0, i.Z)(e1), "map", {
                            identifier: [
                                "username"
                            ]
                        }), e1;
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.getData().identifier;
                            }
                        },
                        {
                            key: "mapCredentials",
                            value: function() {
                                var e1 = this.values, t = e1.credentials, n = e1.password;
                                if (t || n) return t || {
                                    passcode: n
                                };
                            }
                        },
                        {
                            key: "getInputCredentials",
                            value: function(e1) {
                                return l(l({}, e1.form.value[0]), {}, {
                                    name: "password",
                                    required: e1.required
                                });
                            }
                        }
                    ]), p;
                }(n(3118).n);
                (0, s.Z)(p, "remediationName", "identify");
            },
            9024: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    j: function() {
                        return l;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                function s(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function f(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? s(Object(n), !0).forEach(function(t) {
                            (0, c.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var l = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "mapCredentials",
                            value: function() {
                                var e1 = this.values.newPassword;
                                if (e1) return {
                                    passcode: e1
                                };
                            }
                        },
                        {
                            key: "getInputCredentials",
                            value: function(e1) {
                                var t = "password" === this.getAuthenticator().type ? "newPassword" : "verificationCode";
                                return f(f({}, e1.form.value[0]), {}, {
                                    name: t
                                });
                            }
                        }
                    ]), s;
                }(n(3118).n);
                (0, c.Z)(l, "remediationName", "reenroll-authenticator");
            },
            8107: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    i: function() {
                        return s;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, r.Z)(s);
                }(n(9024).j);
                (0, c.Z)(s, "remediationName", "reenroll-authenticator-warning");
            },
            8490: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    O: function() {
                        return s;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !1;
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function() {
                                var e1 = this.remediation;
                                return {
                                    name: e1.name,
                                    type: e1.type,
                                    idp: e1.idp,
                                    href: e1.href
                                };
                            }
                        }
                    ]), s;
                }(n(3118).n);
                (0, c.Z)(s, "remediationName", "redirect-idp");
            },
            1019: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    G: function() {
                        return s;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, r.Z)(s);
                }(n(9883).Q);
                (0, c.Z)(s, "remediationName", "reset-authenticator");
            },
            7311: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    X: function() {
                        return d;
                    }
                });
                var r = n(2982), o = n(3144), i = n(5671), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(9164), l = n(6064), p = n(7595);
                var d = function(e1) {
                    (0, a.Z)(f, e1);
                    var t, n, s = (t = f, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function f(e1) {
                        var t, n, o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        (0, i.Z)(this, f);
                        var u = "recoverPassword" === (n = s.call(this, e1, o, a)).options.flow;
                        return (null === (t = (0, l.zg)(e1).options) || void 0 === t ? void 0 : t.some(function(e1) {
                            var t = e1.relatesTo;
                            return (null == t ? void 0 : t.key) === p.pc.OKTA_PASSWORD;
                        })) && (u || n.values.password) && (n.values.authenticators = [].concat((0, r.Z)(n.values.authenticators || []), [
                            {
                                key: p.pc.OKTA_PASSWORD
                            }
                        ])), n;
                    }
                    return (0, o.Z)(f);
                }(f.n);
                (0, s.Z)(d, "remediationName", "select-authenticator-authenticate");
            },
            9865: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    j: function() {
                        return s;
                    }
                });
                var r = n(3144), o = n(5671), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, o.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, r.Z)(s);
                }(n(9164).n);
                (0, c.Z)(s, "remediationName", "select-authenticator-enroll");
            },
            5272: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    G: function() {
                        return d;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(1752), u = n(136), c = n(2963), s = n(1120), f = n(4942);
                function l(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function p(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? l(Object(n), !0).forEach(function(t) {
                            (0, f.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var d = function(e1) {
                    (0, u.Z)(d, e1);
                    var t, n, l = (t = d, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, s.Z)(t);
                        if (n) {
                            var o = (0, s.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, c.Z)(this, e1);
                    });
                    function d() {
                        var e1;
                        (0, r.Z)(this, d);
                        for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                        return e1 = l.call.apply(l, [
                            this
                        ].concat(n)), (0, f.Z)((0, i.Z)(e1), "authenticator", void 0), (0, f.Z)((0, i.Z)(e1), "map", {
                            identifier: [
                                "username"
                            ]
                        }), e1;
                    }
                    return (0, o.Z)(d, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.getData("identifier") && (0, a.Z)((0, s.Z)(d.prototype), "canRemediate", this).call(this);
                            }
                        },
                        {
                            key: "mapAuthenticator",
                            value: function(e1) {
                                var t, n, r, o = (0, a.Z)((0, s.Z)(d.prototype), "mapAuthenticator", this).call(this, e1), i = null === (t = this.selectedOption) || void 0 === t ? void 0 : t.value.form.value.find(function(e1) {
                                    return "methodType" === e1.name;
                                }), u = this.values.methodType || (null == i ? void 0 : i.value) || (null == i || null === (n = i.options) || void 0 === n || null === (r = n[0]) || void 0 === r ? void 0 : r.value);
                                return u ? p(p({}, o), {}, {
                                    methodType: u
                                }) : o;
                            }
                        },
                        {
                            key: "getInputUsername",
                            value: function() {
                                return {
                                    name: "username",
                                    type: "string"
                                };
                            }
                        }
                    ]), d;
                }(n(9164).n);
                (0, f.Z)(d, "remediationName", "select-authenticator-unlock-account");
            },
            4713: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    j: function() {
                        return s;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !0;
                            }
                        }
                    ]), s;
                }(n(3118).n);
                (0, c.Z)(s, "remediationName", "select-enroll-profile");
            },
            3403: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    V: function() {
                        return p;
                    }
                });
                var r = n(5671), o = n(3144), i = n(1752), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var p = function(e1) {
                    (0, a.Z)(p, e1);
                    var t, n, f = (t = p, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, c.Z)(t);
                        if (n) {
                            var o = (0, c.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, u.Z)(this, e1);
                    });
                    function p() {
                        return (0, r.Z)(this, p), f.apply(this, arguments);
                    }
                    return (0, o.Z)(p, [
                        {
                            key: "canRemediate",
                            value: function() {
                                if (this.values.channel) return !0;
                                if (this.values.authenticator) {
                                    var e1 = this.values.authenticator, t = e1.id, n = e1.channel;
                                    if (t && n) return !0;
                                }
                                return !1;
                            }
                        },
                        {
                            key: "getNextStep",
                            value: function(e1, t) {
                                var n = (0, i.Z)((0, c.Z)(p.prototype), "getNextStep", this).call(this, e1, t), r = t.currentAuthenticator.value;
                                return l(l({}, n), {}, {
                                    authenticator: r
                                });
                            }
                        },
                        {
                            key: "getData",
                            value: function() {
                                var e1;
                                return {
                                    authenticator: {
                                        id: this.remediation.value[0].value.form.value[0].value,
                                        channel: (null === (e1 = this.values.authenticator) || void 0 === e1 ? void 0 : e1.channel) || this.values.channel
                                    },
                                    stateHandle: this.values.stateHandle
                                };
                            }
                        },
                        {
                            key: "getValuesAfterProceed",
                            value: function() {
                                var e1 = this;
                                this.values = (0, i.Z)((0, c.Z)(p.prototype), "getValuesAfterProceed", this).call(this), delete this.values.authenticators;
                                var t = this.values.channel ? "channel" : "authenticator";
                                return Object.keys(this.values).filter(function(e1) {
                                    return e1 !== t;
                                }).reduce(function(t, n) {
                                    return l(l({}, t), {}, (0, s.Z)({}, n, e1.values[n]));
                                }, {});
                            }
                        }
                    ]), p;
                }(n(3118).n);
                (0, s.Z)(p, "remediationName", "select-enrollment-channel");
            },
            8443: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    h: function() {
                        return s;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(4942);
                var s = function(e1) {
                    (0, i.Z)(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, u.Z)(t);
                        if (n) {
                            var o = (0, u.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, a.Z)(this, e1);
                    });
                    function s() {
                        return (0, r.Z)(this, s), c.apply(this, arguments);
                    }
                    return (0, o.Z)(s, [
                        {
                            key: "canRemediate",
                            value: function() {
                                return !!this.values.skip || "skip" === this.options.step;
                            }
                        }
                    ]), s;
                }(n(3118).n);
                (0, c.Z)(s, "remediationName", "skip");
            },
            6064: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    var t;
                    return null === (t = e1.value) || void 0 === t ? void 0 : t.map(function(e1) {
                        return e1.name;
                    });
                }
                function o(e1) {
                    var t;
                    return null === (t = e1.value) || void 0 === t ? void 0 : t.reduce(function(e1, t) {
                        return t.required && e1.push(t.name), e1;
                    }, []);
                }
                function i(e1) {
                    return e1.charAt(0).toUpperCase() + e1.substring(1);
                }
                function a(e1) {
                    return e1.value.find(function(e1) {
                        return "authenticator" === e1.name;
                    });
                }
                n.d(t, {
                    QG: function() {
                        return o;
                    },
                    Qs: function() {
                        return i;
                    },
                    ix: function() {
                        return r;
                    },
                    zg: function() {
                        return a;
                    }
                });
            },
            3377: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    K: function() {
                        return M;
                    }
                });
                var r = n(5861), o = n(4942), i = n(4687), a = n.n(i), u = n(6131), c = n(2660), s = n(1002), f = n(2982), l = n(9123), p = n(5031);
                function d(e1, t) {
                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e1) || (n = function(e1, t) {
                            if (e1) {
                                if ("string" == typeof e1) return h(e1, t);
                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? h(e1, t) : void 0;
                            }
                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                            n && (e1 = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e1.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e1[r++]
                                    };
                                },
                                e: function(e1) {
                                    throw e1;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, u = !1;
                    return {
                        s: function() {
                            n = n.call(e1);
                        },
                        n: function() {
                            var e1 = n.next();
                            return a = e1.done, e1;
                        },
                        e: function(e1) {
                            u = !0, i = e1;
                        },
                        f: function() {
                            try {
                                a || null == n.return || n.return();
                            } finally{
                                if (u) throw i;
                            }
                        }
                    };
                }
                function h(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, o.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function g(e1, t) {
                    return Object.keys(t.actions).find(function(t) {
                        return !!e1.resend && t.includes("-resend");
                    });
                }
                function m(e1) {
                    return y(y({}, e1), {}, {
                        resend: void 0
                    });
                }
                function b(e1, t) {
                    var n = e1.actions || [];
                    return n = n.filter(function(e1) {
                        return "string" == typeof e1 ? e1 !== t : e1.name !== t;
                    }), y(y({}, e1), {}, {
                        actions: n
                    });
                }
                function k(e1, t, n, r) {
                    return w.apply(this, arguments);
                }
                function w() {
                    return (w = (0, r.Z)(a().mark(function e1(t, n, r, o) {
                        var i, u, c, h, v, w, O, Z, T, E, P, S, x, A, R, _, j, C;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (u = (i = n).neededToProceed, c = i.interactionCode, h = o.flow, !c) {
                                        e1.next = 4;
                                        break;
                                    }
                                    return e1.abrupt("return", {
                                        idxResponse: n
                                    });
                                case 4:
                                    if (v = (0, p.l6)(n, r, o), w = g(r, n), O = o.actions || [], !(Z = [].concat((0, f.Z)(O), (0, f.Z)(w && [
                                        w
                                    ] || [])))) {
                                        e1.next = 28;
                                        break;
                                    }
                                    T = d(Z), e1.prev = 10, P = a().mark(function e1() {
                                        var i, c, s, f;
                                        return a().wrap(function(e1) {
                                            for(;;)switch(e1.prev = e1.next){
                                                case 0:
                                                    if (i = E.value, c = {}, "string" != typeof i && (c = i.params || {}, i = i.name), s = m(r), f = b(o, i), "function" != typeof n.actions[i]) {
                                                        e1.next = 14;
                                                        break;
                                                    }
                                                    return e1.next = 8, n.actions[i](c);
                                                case 8:
                                                    if (!1 !== (n = e1.sent).requestDidSucceed) {
                                                        e1.next = 11;
                                                        break;
                                                    }
                                                    return e1.abrupt("return", {
                                                        v: (0, p.Tc)(t, n, o)
                                                    });
                                                case 11:
                                                    if ("cancel" !== i) {
                                                        e1.next = 13;
                                                        break;
                                                    }
                                                    return e1.abrupt("return", {
                                                        v: {
                                                            idxResponse: n,
                                                            canceled: !0
                                                        }
                                                    });
                                                case 13:
                                                    return e1.abrupt("return", {
                                                        v: k(t, n, s, f)
                                                    });
                                                case 14:
                                                    if (!u.find(function(e1) {
                                                        return e1.name === i;
                                                    })) {
                                                        e1.next = 22;
                                                        break;
                                                    }
                                                    return e1.next = 18, n.proceed(i, c);
                                                case 18:
                                                    if (!1 !== (n = e1.sent).requestDidSucceed) {
                                                        e1.next = 21;
                                                        break;
                                                    }
                                                    return e1.abrupt("return", {
                                                        v: (0, p.Tc)(t, n, o)
                                                    });
                                                case 21:
                                                    return e1.abrupt("return", {
                                                        v: k(t, n, r, f)
                                                    });
                                                case 22:
                                                case "end":
                                                    return e1.stop();
                                            }
                                        }, e1);
                                    }), T.s();
                                case 13:
                                    if ((E = T.n()).done) {
                                        e1.next = 20;
                                        break;
                                    }
                                    return e1.delegateYield(P(), "t0", 15);
                                case 15:
                                    if (S = e1.t0, "object" !== (0, s.Z)(S)) {
                                        e1.next = 18;
                                        break;
                                    }
                                    return e1.abrupt("return", S.v);
                                case 18:
                                    e1.next = 13;
                                    break;
                                case 20:
                                    e1.next = 25;
                                    break;
                                case 22:
                                    e1.prev = 22, e1.t1 = e1.catch(10), T.e(e1.t1);
                                case 25:
                                    return e1.prev = 25, T.f(), e1.finish(25);
                                case 28:
                                    if (!(x = (0, p.xn)(n))) {
                                        e1.next = 31;
                                        break;
                                    }
                                    return e1.abrupt("return", {
                                        idxResponse: n,
                                        terminal: x
                                    });
                                case 31:
                                    if (v) {
                                        e1.next = 43;
                                        break;
                                    }
                                    if (!o.step) {
                                        e1.next = 40;
                                        break;
                                    }
                                    return r = (0, p.Ax)(n, o.step, r), e1.next = 36, n.proceed(o.step, r);
                                case 36:
                                    if (!1 !== (n = e1.sent).requestDidSucceed) {
                                        e1.next = 39;
                                        break;
                                    }
                                    return e1.abrupt("return", (0, p.Tc)(t, n, o));
                                case 39:
                                    return e1.abrupt("return", {
                                        idxResponse: n
                                    });
                                case 40:
                                    if ("default" !== h) {
                                        e1.next = 42;
                                        break;
                                    }
                                    return e1.abrupt("return", {
                                        idxResponse: n
                                    });
                                case 42:
                                    throw new l.Z("\n      No remediation can match current flow, check policy settings in your org.\n      Remediations: [".concat(u.reduce(function(e1, t) {
                                        return e1 ? e1 + " ," + t.name : t.name;
                                    }, ""), "]\n    "));
                                case 43:
                                    if (v.canRemediate()) {
                                        e1.next = 46;
                                        break;
                                    }
                                    return A = (0, p.TR)(t, v, n), e1.abrupt("return", {
                                        idxResponse: n,
                                        nextStep: A
                                    });
                                case 46:
                                    return R = v.getName(), _ = v.getData(), e1.next = 50, n.proceed(R, _);
                                case 50:
                                    if (!1 !== (n = e1.sent).requestDidSucceed) {
                                        e1.next = 53;
                                        break;
                                    }
                                    return e1.abrupt("return", (0, p.Tc)(t, n, o));
                                case 53:
                                    if (r = v.getValuesAfterProceed(), !(o = y(y({}, o), {}, {
                                        step: void 0
                                    })).useGenericRemediator || n.interactionCode || (0, p.xn)(n)) {
                                        e1.next = 59;
                                        break;
                                    }
                                    return j = (0, p.l6)(n, r, o), C = (0, p.TR)(t, j, n), e1.abrupt("return", {
                                        idxResponse: n,
                                        nextStep: C
                                    });
                                case 59:
                                    return e1.abrupt("return", k(t, n, r, o));
                                case 60:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                10,
                                22,
                                25,
                                28
                            ]
                        ]);
                    }))).apply(this, arguments);
                }
                var O = n(7595), Z = n(2620);
                function T(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function E(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? T(Object(n), !0).forEach(function(t) {
                            (0, o.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : T(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function P(e1) {
                    var t = E({}, e1);
                    return [
                        "flow",
                        "remediators",
                        "actions",
                        "withCredentials",
                        "step",
                        "useGenericRemediator",
                        "exchangeCodeForTokens"
                    ].forEach(function(e1) {
                        delete t[e1];
                    }), t;
                }
                function S(e1, t) {
                    var n, r, o = t.options, i = o = E(E({}, e1.options.idx), o), a = i.flow, u = i.withCredentials, c = i.remediators, s = i.actions, f = O.Qd.PENDING;
                    a = a || (null === (n = (r = e1.idx).getFlow) || void 0 === n ? void 0 : n.call(r)) || "default";
                    var l, d;
                    null === (l = (d = e1.idx).setFlow) || void 0 === l || l.call(d, a);
                    var h = (0, p.sH)(e1, a);
                    u = void 0 !== u ? u : h.withCredentials, c = c || h.remediators, s = s || h.actions;
                    return E(E({}, t), {}, {
                        options: E(E({}, o), {}, {
                            flow: a,
                            withCredentials: u,
                            remediators: c,
                            actions: s
                        }),
                        status: f
                    });
                }
                function x(e1, t) {
                    return A.apply(this, arguments);
                }
                function A() {
                    return (A = (0, r.Z)(a().mark(function e1(t, n) {
                        var r, o, i, s, f, l, p, d, h, v, y, g, m, b, k, w, O;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = n.options, o = r.stateHandle, i = r.withCredentials, s = r.version, f = r.state, l = r.scopes, p = r.recoveryToken, d = r.activationToken, h = r.maxAge, v = r.acrValues, y = r.nonce, g = r.useGenericRemediator, b = (0, Z.uN)(t, {
                                        state: f,
                                        recoveryToken: p,
                                        activationToken: d
                                    }), !o) {
                                        e1.next = 9;
                                        break;
                                    }
                                    return e1.next = 6, (0, c.L)(t, {
                                        withCredentials: i,
                                        version: s,
                                        stateHandle: o,
                                        useGenericRemediator: g
                                    });
                                case 6:
                                    m = e1.sent, e1.next = 20;
                                    break;
                                case 9:
                                    if (w = null === (k = b) || void 0 === k ? void 0 : k.interactionHandle) {
                                        e1.next = 17;
                                        break;
                                    }
                                    return t.transactionManager.clear(), e1.next = 14, (0, u.E)(t, {
                                        withCredentials: i,
                                        state: f,
                                        scopes: l,
                                        activationToken: d,
                                        recoveryToken: p,
                                        maxAge: h,
                                        acrValues: v,
                                        nonce: y
                                    });
                                case 14:
                                    O = e1.sent, w = O.interactionHandle, b = O.meta;
                                case 17:
                                    return e1.next = 19, (0, c.L)(t, {
                                        withCredentials: i,
                                        version: s,
                                        interactionHandle: w,
                                        useGenericRemediator: g
                                    });
                                case 19:
                                    m = e1.sent;
                                case 20:
                                    return e1.abrupt("return", E(E({}, n), {}, {
                                        idxResponse: m,
                                        meta: b
                                    }));
                                case 21:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function R(e1, t) {
                    return _.apply(this, arguments);
                }
                function _() {
                    return (_ = (0, r.Z)(a().mark(function e1(t, n) {
                        var r, o, i, u, c, s, f, l, p, d, h, v, y;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = n.idxResponse, o = n.options, i = n.values, u = o.autoRemediate, c = o.remediators, s = o.actions, f = o.flow, l = o.step, p = o.useGenericRemediator, !1 !== u && (c || s || l)) {
                                        e1.next = 5;
                                        break;
                                    }
                                    return e1.abrupt("return", n);
                                case 5:
                                    return i = E(E({}, i), {}, {
                                        stateHandle: r.rawIdxState.stateHandle
                                    }), e1.next = 8, k(t, r, i, {
                                        remediators: c,
                                        actions: s,
                                        flow: f,
                                        step: l,
                                        useGenericRemediator: p
                                    });
                                case 8:
                                    return d = e1.sent, h = d.idxResponse, v = d.nextStep, y = d.canceled, r = h, e1.abrupt("return", E(E({}, n), {}, {
                                        idxResponse: r,
                                        nextStep: v,
                                        canceled: y
                                    }));
                                case 14:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function j(e1, t) {
                    return C.apply(this, arguments);
                }
                function C() {
                    return (C = (0, r.Z)(a().mark(function e1(t, n) {
                        var r, o, i, u, c, s, f, l, p, d, h;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return r = n.meta, o = n.idxResponse, i = o.interactionCode, c = (u = r).clientId, s = u.codeVerifier, f = u.ignoreSignature, l = u.redirectUri, p = u.urls, d = u.scopes, e1.next = 5, t.token.exchangeCodeForTokens({
                                        interactionCode: i,
                                        clientId: c,
                                        codeVerifier: s,
                                        ignoreSignature: f,
                                        redirectUri: l,
                                        scopes: d
                                    }, p);
                                case 5:
                                    return h = e1.sent, e1.abrupt("return", h.tokens);
                                case 7:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function I(e1, t) {
                    return D.apply(this, arguments);
                }
                function D() {
                    return (D = (0, r.Z)(a().mark(function e1(t, n) {
                        var r, o, i, u, c, s, f, l, d, h, v, y, g, m, b, k;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = n.options, o = n.idxResponse, i = n.canceled, u = n.status, c = r.exchangeCodeForTokens, s = !1, f = !1, l = !0, o && (s = !(!o.requestDidSucceed && !o.stepUp), v = (0, p.KM)(o), y = (0, p.kw)(t, o, r.useGenericRemediator), g = (0, p.lx)(o, r), m = (0, p.xn)(o)), !m) {
                                        e1.next = 15;
                                        break;
                                    }
                                    u = O.Qd.TERMINAL, b = Object.keys(o.actions).length > 0, k = !!g.find(function(e1) {
                                        return "ERROR" === e1.class;
                                    }), b || k || !0 !== o.requestDidSucceed ? s = !!b : f = !0, l = !1, e1.next = 32;
                                    break;
                                case 15:
                                    if (!i) {
                                        e1.next = 20;
                                        break;
                                    }
                                    u = O.Qd.CANCELED, f = !0, e1.next = 32;
                                    break;
                                case 20:
                                    if (null == o || !o.interactionCode) {
                                        e1.next = 32;
                                        break;
                                    }
                                    if (d = o.interactionCode, !1 !== c) {
                                        e1.next = 27;
                                        break;
                                    }
                                    u = O.Qd.SUCCESS, f = !1, e1.next = 32;
                                    break;
                                case 27:
                                    return e1.next = 29, j(t, n);
                                case 29:
                                    h = e1.sent, u = O.Qd.SUCCESS, f = !0;
                                case 32:
                                    return e1.abrupt("return", E(E({}, n), {}, {
                                        status: u,
                                        interactionCode: d,
                                        tokens: h,
                                        shouldSaveResponse: s,
                                        shouldClearTransaction: f,
                                        clearSharedStorage: l,
                                        enabledFeatures: v,
                                        availableSteps: y,
                                        messages: g,
                                        terminal: m
                                    }));
                                case 33:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function M(e1) {
                    return N.apply(this, arguments);
                }
                function N() {
                    return N = (0, r.Z)(a().mark(function e1(t) {
                        var n, r, o, i, u, c, s, f, l, p, d, h, v, y, g, m, b, k, w, O, T, A, _, j, C, D, M, N, U = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return r = {
                                        options: n = U.length > 1 && void 0 !== U[1] ? U[1] : {},
                                        values: P(n)
                                    }, r = S(t, r), e1.next = 5, x(t, r);
                                case 5:
                                    return r = e1.sent, e1.next = 8, R(t, r);
                                case 8:
                                    return r = e1.sent, e1.next = 11, I(t, r);
                                case 11:
                                    return r = e1.sent, i = (o = r).idxResponse, u = o.meta, c = o.shouldSaveResponse, s = o.shouldClearTransaction, f = o.clearSharedStorage, l = o.status, p = o.enabledFeatures, d = o.availableSteps, h = o.tokens, v = o.nextStep, y = o.messages, g = o.error, m = o.interactionCode, s ? t.transactionManager.clear({
                                        clearSharedStorage: f
                                    }) : ((0, Z.r0)(t, E({}, u)), c && (w = (k = i).rawIdxState, O = k.requestDidSucceed, t.transactionManager.saveIdxResponse({
                                        rawIdxResponse: w,
                                        requestDidSucceed: O,
                                        stateHandle: null === (b = i.context) || void 0 === b ? void 0 : b.stateHandle,
                                        interactionHandle: null == u ? void 0 : u.interactionHandle
                                    }))), A = (T = i || {}).actions, _ = T.context, j = T.neededToProceed, C = T.proceed, D = T.rawIdxState, M = T.requestDidSucceed, N = T.stepUp, e1.abrupt("return", E(E(E(E(E(E(E(E(E({
                                        status: l
                                    }, u && {
                                        meta: u
                                    }), p && {
                                        enabledFeatures: p
                                    }), d && {
                                        availableSteps: d
                                    }), h && {
                                        tokens: h
                                    }), v && {
                                        nextStep: v
                                    }), y && y.length && {
                                        messages: y
                                    }), g && {
                                        error: g
                                    }), N && {
                                        stepUp: N
                                    }), {}, {
                                        interactionCode: m,
                                        actions: A,
                                        context: _,
                                        neededToProceed: j,
                                        proceed: C,
                                        rawIdxState: D,
                                        requestDidSucceed: M
                                    }));
                                case 16:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), N.apply(this, arguments);
                }
            },
            2473: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Y: function() {
                        return f;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3377);
                function c(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function s(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? c(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function f(e1) {
                    return l.apply(this, arguments);
                }
                function l() {
                    return l = (0, o.Z)(a().mark(function e1(t) {
                        var n, r = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = r.length > 1 && void 0 !== r[1] ? r[1] : {}, t.transactionManager.clear(), e1.abrupt("return", (0, u.K)(t, s({
                                        exchangeCodeForTokens: !1
                                    }, n)));
                                case 3:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), l.apply(this, arguments);
                }
            },
            4143: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return h;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(5763), s = n(1971), f = n(2647), l = n(415), p = n(146), d = n(9123);
                function h() {
                    return function(e1) {
                        (0, i.Z)(h, e1);
                        var t, n, f = (t = h, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, u.Z)(t);
                            if (n) {
                                var o = (0, u.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, a.Z)(this, e1);
                        });
                        function h(e1, t, n) {
                            return (0, r.Z)(this, h), f.call(this, e1, t, n);
                        }
                        return (0, o.Z)(h, [
                            {
                                key: "getIdxResponseStorage",
                                value: function(e1) {
                                    var t;
                                    if ((0, l.isBrowser)()) try {
                                        t = this.storageUtil.getStorageByType("memory", e1);
                                    } catch (e1) {
                                        (0, p.ZK)("No response storage found, you may want to provide custom implementation for intermediate idx responses to optimize the network traffic");
                                    }
                                    else {
                                        var n = this.getTransactionStorage(e1);
                                        n && (t = {
                                            getItem: function(e1) {
                                                var t = n.getStorage();
                                                return t && t[e1] ? t[e1] : null;
                                            },
                                            setItem: function(e1, t) {
                                                var r = n.getStorage();
                                                if (!r) throw new d.Z("Transaction has been cleared, failed to save idxState");
                                                r[e1] = t, n.setStorage(r);
                                            },
                                            removeItem: function(e1) {
                                                var t = n.getStorage();
                                                t && (delete t[e1], n.setStorage(t));
                                            }
                                        });
                                    }
                                    return t ? new c._(t, s.IDX_RESPONSE_STORAGE_NAME) : null;
                                }
                            }
                        ]), h;
                    }((0, f.a)());
                }
            },
            2620: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $0: function() {
                        return h;
                    },
                    Co: function() {
                        return y;
                    },
                    Jm: function() {
                        return b;
                    },
                    UC: function() {
                        return O;
                    },
                    Wf: function() {
                        return k;
                    },
                    Xc: function() {
                        return p;
                    },
                    bl: function() {
                        return w;
                    },
                    r0: function() {
                        return m;
                    },
                    uN: function() {
                        return v;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3193), c = n(146), s = n(2865);
                function f(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function l(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? f(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function p(e1) {
                    return d.apply(this, arguments);
                }
                function d() {
                    return d = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, u, c, f, p, d, h, v, y, g, m, b, k, w, O = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = O.length > 1 && void 0 !== O[1] ? O[1] : {}, e1.next = 3, t.token.prepareTokenParams(n);
                                case 3:
                                    return r = e1.sent, o = (0, s.H)(t, r), i = l(l({}, t.options), n), u = i.flow, c = void 0 === u ? "default" : u, f = i.withCredentials, p = void 0 === f || f, d = i.activationToken, h = void 0 === d ? void 0 : d, v = i.recoveryToken, y = void 0 === v ? void 0 : v, g = i.maxAge, m = void 0 === g ? void 0 : g, b = i.acrValues, k = void 0 === b ? void 0 : b, w = l(l({}, o), {}, {
                                        flow: c,
                                        withCredentials: p,
                                        activationToken: h,
                                        recoveryToken: y,
                                        maxAge: m,
                                        acrValues: k
                                    }), e1.abrupt("return", w);
                                case 8:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), d.apply(this, arguments);
                }
                function h(e1, t) {
                    var n = v(e1, t);
                    return !(null == n || !n.interactionHandle);
                }
                function v(e1, t) {
                    var n;
                    t = (0, u.YY)(t), t = l(l({}, e1.options), t);
                    try {
                        n = e1.transactionManager.load(t);
                    } catch (e1) {}
                    if (n) return k(n, t) ? n : void (0, c.ZK)("Saved transaction meta does not match the current configuration. This may indicate that two apps are sharing a storage key.");
                }
                function y(e1, t) {
                    return g.apply(this, arguments);
                }
                function g() {
                    return (g = (0, o.Z)(a().mark(function e1(t, n) {
                        var r;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = (0, u.YY)(n), n = l(l({}, t.options), n), !(r = v(t, n))) {
                                        e1.next = 5;
                                        break;
                                    }
                                    return e1.abrupt("return", r);
                                case 5:
                                    return e1.abrupt("return", p(t, n));
                                case 6:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function m(e1, t) {
                    e1.transactionManager.save(t, {
                        muteWarning: !0
                    });
                }
                function b(e1) {
                    e1.transactionManager.clear();
                }
                function k(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return !1 !== O(e1, t, [
                        "issuer",
                        "clientId",
                        "redirectUri",
                        "state",
                        "codeChallenge",
                        "codeChallengeMethod",
                        "activationToken",
                        "recoveryToken"
                    ]) && !1 !== w(e1, t.flow);
                }
                function w(e1, t) {
                    return !(t && "default" !== t && "proceed" !== t) || t === e1.flow;
                }
                function O(e1, t, n) {
                    return !n.some(function(n) {
                        var r = t[n];
                        if (r && r !== e1[n]) return !0;
                    });
                }
            },
            7595: function(e1, t, n) {
                "use strict";
                var r, o, i;
                function a(e1) {
                    return e1 && (e1.key || e1.id);
                }
                n.d(t, {
                    Fw: function() {
                        return i;
                    },
                    H: function() {
                        return a;
                    },
                    Qd: function() {
                        return r;
                    },
                    pc: function() {
                        return o;
                    }
                }), function(e1) {
                    e1.SUCCESS = "SUCCESS", e1.PENDING = "PENDING", e1.FAILURE = "FAILURE", e1.TERMINAL = "TERMINAL", e1.CANCELED = "CANCELED";
                }(r || (r = {})), function(e1) {
                    e1.OKTA_PASSWORD = "okta_password", e1.OKTA_EMAIL = "okta_email", e1.PHONE_NUMBER = "phone_number", e1.GOOGLE_AUTHENTICATOR = "google_otp", e1.SECURITY_QUESTION = "security_question", e1.OKTA_VERIFY = "okta_verify", e1.WEBAUTHN = "webauthn";
                }(o || (o = {})), function(e1) {
                    e1.PASSWORD_RECOVERY = "recover-password", e1.REGISTRATION = "enroll-profile", e1.SOCIAL_IDP = "redirect-idp", e1.ACCOUNT_UNLOCK = "unlock-account";
                }(i || (i = {}));
            },
            480: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return e1 && e1.version;
                }
                n.d(t, {
                    P: function() {
                        return r;
                    }
                });
            },
            8277: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    l: function() {
                        return h;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(3377), c = n(2620), s = n(2473), f = n(9123), l = n(7595);
                function p(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function d(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? p(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function h(e1) {
                    return v.apply(this, arguments);
                }
                function v() {
                    return v = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if ((n = i.length > 1 && void 0 !== i[1] ? i[1] : {}).flow = "unlockAccount", (0, c.$0)(t)) {
                                        e1.next = 9;
                                        break;
                                    }
                                    return e1.next = 5, (0, s.Y)(t, d(d({}, n), {}, {
                                        autoRemediate: !1
                                    }));
                                case 5:
                                    if (r = e1.sent, !(o = r.enabledFeatures) || o.includes(l.Fw.ACCOUNT_UNLOCK)) {
                                        e1.next = 9;
                                        break;
                                    }
                                    throw new f.Z("Self Service Account Unlock is not supported based on your current org configuration.");
                                case 9:
                                    return e1.abrupt("return", (0, u.K)(t, d({}, n)));
                                case 10:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), v.apply(this, arguments);
                }
            },
            5031: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Ax: function() {
                        return S;
                    },
                    KM: function() {
                        return E;
                    },
                    TC: function() {
                        return k;
                    },
                    TR: function() {
                        return R;
                    },
                    Tc: function() {
                        return _;
                    },
                    kw: function() {
                        return P;
                    },
                    l6: function() {
                        return A;
                    },
                    lx: function() {
                        return T;
                    },
                    sH: function() {
                        return w;
                    },
                    xn: function() {
                        return O;
                    }
                });
                var r = n(4942), o = n(4925), i = n(5861), a = n(885), u = n(2982), c = n(4687), s = n.n(c), f = n(8750), l = n(146), p = n(9732), d = n(7595), h = [
                    "href",
                    "method",
                    "rel",
                    "accepts",
                    "produces"
                ];
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function g(e1, t) {
                    var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e1) || (n = function(e1, t) {
                            if (e1) {
                                if ("string" == typeof e1) return m(e1, t);
                                var n = Object.prototype.toString.call(e1).slice(8, -1);
                                return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? m(e1, t) : void 0;
                            }
                        }(e1)) || t && e1 && "number" == typeof e1.length) {
                            n && (e1 = n);
                            var r = 0, o = function() {};
                            return {
                                s: o,
                                n: function() {
                                    return r >= e1.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e1[r++]
                                    };
                                },
                                e: function(e1) {
                                    throw e1;
                                },
                                f: o
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i, a = !0, u = !1;
                    return {
                        s: function() {
                            n = n.call(e1);
                        },
                        n: function() {
                            var e1 = n.next();
                            return a = e1.done, e1;
                        },
                        e: function(e1) {
                            u = !0, i = e1;
                        },
                        f: function() {
                            try {
                                a || null == n.return || n.return();
                            } finally{
                                if (u) throw i;
                            }
                        }
                    };
                }
                function m(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var b = {
                    remediators: {},
                    getFlowSpecification: function(e1) {
                        return {
                            remediators: {}
                        };
                    }
                };
                function k(e1) {
                    Object.assign(b, e1);
                }
                function w(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default";
                    return b.getFlowSpecification(e1, t);
                }
                function O(e1) {
                    var t = e1.neededToProceed, n = e1.interactionCode;
                    return !t.length && !n;
                }
                function Z(e1) {
                    if (e1 && Array.isArray(e1)) return e1.reduce(function(e1, t) {
                        if (t.messages && (e1 = [].concat((0, u.Z)(e1), (0, u.Z)(t.messages.value))), t.form) {
                            var n = Z(t.form.value) || [];
                            e1 = [].concat((0, u.Z)(e1), (0, u.Z)(n));
                        }
                        if (t.options) {
                            var r = [];
                            t.options.forEach(function(e1) {
                                e1.value && "string" != typeof e1.value && (r = [].concat((0, u.Z)(r), [
                                    e1.value
                                ]));
                            });
                            var o = Z(r) || [];
                            e1 = [].concat((0, u.Z)(e1), (0, u.Z)(o));
                        }
                        return e1;
                    }, []);
                }
                function T(e1, t) {
                    var n, r = [], o = e1.rawIdxState, i = e1.neededToProceed, a = null === (n = o.messages) || void 0 === n ? void 0 : n.value.map(function(e1) {
                        return e1;
                    });
                    if (a && (r = [].concat((0, u.Z)(r), (0, u.Z)(a))), !t.useGenericRemediator) {
                        var c, s = g(i);
                        try {
                            for(s.s(); !(c = s.n()).done;){
                                var f = Z(c.value.value);
                                f && (r = [].concat((0, u.Z)(r), (0, u.Z)(f)));
                            }
                        } catch (e1) {
                            s.e(e1);
                        } finally{
                            s.f();
                        }
                    }
                    var l = {};
                    return r.reduce(function(e1, t) {
                        var n, r = null === (n = t.i18n) || void 0 === n ? void 0 : n.key;
                        return r && l[r] && t.message === l[r].message ? e1 : (l[r] = t, e1 = [].concat((0, u.Z)(e1), [
                            t
                        ]));
                    }, []);
                }
                function E(e1) {
                    var t = [], n = e1.actions, r = e1.neededToProceed;
                    return n["currentAuthenticator-recover"] && t.push(d.Fw.PASSWORD_RECOVERY), r.some(function(e1) {
                        return "select-enroll-profile" === e1.name;
                    }) && t.push(d.Fw.REGISTRATION), r.some(function(e1) {
                        return "redirect-idp" === e1.name;
                    }) && t.push(d.Fw.SOCIAL_IDP), r.some(function(e1) {
                        return "unlock-account" === e1.name;
                    }) && t.push(d.Fw.ACCOUNT_UNLOCK), t;
                }
                function P(e1, t, n) {
                    var r, u = [], c = Object.values(b.remediators).reduce(function(e1, t) {
                        return t.remediationName && (e1[t.remediationName] = t), e1;
                    }, {}), l = g(t.neededToProceed);
                    try {
                        for(l.s(); !(r = l.n()).done;){
                            var p = r.value, d = x(p, {
                                useGenericRemediator: n,
                                remediators: c
                            });
                            if (d) {
                                var v = new d(p);
                                u.push(v.getNextStep(e1, t.context));
                            }
                        }
                    } catch (e1) {
                        l.e(e1);
                    } finally{
                        l.f();
                    }
                    for(var m = function() {
                        var n, r = (0, a.Z)(w[k], 1)[0], c = {
                            name: r,
                            action: (n = (0, i.Z)(s().mark(function t(n) {
                                return s().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            return t.abrupt("return", e1.idx.proceed({
                                                actions: [
                                                    {
                                                        name: r,
                                                        params: n
                                                    }
                                                ]
                                            }));
                                        case 1:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t);
                            })), function(e1) {
                                return n.apply(this, arguments);
                            })
                        };
                        if (r.startsWith("currentAuthenticator")) {
                            var l, p = (0, f.YQ)(r, "-"), d = (0, a.Z)(p, 2), v = d[0], g = d[1], m = t.rawIdxState[v].value[g], b = (m.href, m.method, m.rel, m.accepts, m.produces, (0, o.Z)(m, h)), O = null === (l = m.value) || void 0 === l ? void 0 : l.filter(function(e1) {
                                return "stateHandle" !== e1.name;
                            });
                            c = y(y(y({}, b), O && {
                                value: O
                            }), c);
                        }
                        u.push(c);
                    }, k = 0, w = Object.entries(t.actions || {}); k < w.length; k++)m();
                    return u;
                }
                function S(e1, t, n) {
                    var r = (e1.neededToProceed || []).find(function(e1) {
                        return e1.name === t;
                    });
                    return r ? r.value.reduce(function(e1, t) {
                        var r = t.name, o = t.value;
                        return e1[r] = "stateHandle" === r ? o : n[r], e1;
                    }, {}) : ((0, l.ZK)('filterValuesForRemediation: "'.concat(t, '" did not match any remediations')), n);
                }
                function x(e1, t) {
                    var n = t.useGenericRemediator, r = t.remediators;
                    if (e1) return n ? p.P : r[e1.name];
                }
                function A(e1, t, n) {
                    var r, o = n.remediators, i = n.useGenericRemediator, a = e1.neededToProceed, u = e1.context;
                    if (!n.step) {
                        var c = [];
                        if (i) c.push(new p.P(a[0], t, n));
                        else {
                            var s, f = g(a);
                            try {
                                for(f.s(); !(s = f.n()).done;){
                                    var d = s.value;
                                    if (Object.keys(o).includes(d.name)) {
                                        if ((r = new (x(d, n))(d, t, n)).canRemediate(u)) return r;
                                        c.push(r);
                                    }
                                }
                            } catch (e1) {
                                f.e(e1);
                            } finally{
                                f.f();
                            }
                        }
                        return c[0];
                    }
                    var h = a.find(function(e1) {
                        return e1.name === n.step;
                    });
                    if (h) {
                        var v = x(h, n);
                        return v ? new v(h, t, n) : void 0;
                    }
                    (0, l.ZK)('step "'.concat(n.step, '" did not match any remediations'));
                }
                function R(e1, t, n) {
                    var r = t.getNextStep(e1, n.context), o = function(e1) {
                        return e1.neededToProceed.some(function(e1) {
                            return "skip" === e1.name;
                        });
                    }(n), i = function(e1) {
                        return Object.keys(e1.actions).some(function(e1) {
                            return e1.includes("resend");
                        });
                    }(n);
                    return y(y(y({}, r), o && {
                        canSkip: o
                    }), i && {
                        canResend: i
                    });
                }
                function _(e1, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = O(t), o = T(t, n);
                    if (r) return {
                        idxResponse: t,
                        terminal: r,
                        messages: o
                    };
                    var i = A(t, {}, n), a = i && R(e1, i, t);
                    return y({
                        idxResponse: t,
                        messages: o
                    }, a && {
                        nextStep: a
                    });
                }
            },
            8716: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    buildCredentialCreationOptions: function() {
                        return s;
                    },
                    buildCredentialRequestOptions: function() {
                        return f;
                    },
                    getAssertion: function() {
                        return p;
                    },
                    getAttestation: function() {
                        return l;
                    }
                });
                var r = n(4942), o = n(7987);
                function i(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function a(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? i(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var u = function(e1) {
                    var t = e1;
                    if ("string" == typeof t) try {
                        t = t.split(",");
                    } catch (e1) {
                        return;
                    }
                    return Array.isArray(t) ? t : void 0;
                }, c = function() {
                    var e1 = [];
                    return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : []).forEach(function(t) {
                        if ("webauthn" === t.key) {
                            var n, r, i = {
                                type: "public-key",
                                id: (0, o.dX)(t.credentialId)
                            }, a = null !== (n = u(t.transports)) && void 0 !== n ? n : u(null === (r = t.profile) || void 0 === r ? void 0 : r.transports);
                            a && (i.transports = a), e1.push(i);
                        }
                    }), e1;
                }, s = function(e1, t) {
                    return {
                        publicKey: a({
                            rp: e1.rp,
                            user: {
                                id: (0, o.dX)(e1.user.id),
                                name: e1.user.name,
                                displayName: e1.user.displayName
                            },
                            challenge: (0, o.dX)(e1.challenge),
                            pubKeyCredParams: e1.pubKeyCredParams,
                            attestation: e1.attestation,
                            authenticatorSelection: e1.authenticatorSelection,
                            excludeCredentials: c(t)
                        }, e1.hints && {
                            hints: e1.hints
                        })
                    };
                }, f = function(e1, t) {
                    return {
                        publicKey: a(a({
                            challenge: (0, o.dX)(e1.challenge),
                            userVerification: e1.userVerification,
                            allowCredentials: c(t)
                        }, e1.rpId && {
                            rpId: e1.rpId
                        }), e1.hints && {
                            hints: e1.hints
                        })
                    };
                }, l = function(e1) {
                    var t = e1.response, n = e1.id, r = (0, o.kQ)(t.clientDataJSON), i = (0, o.kQ)(t.attestationObject), a = t.getTransports, u = {
                        id: n,
                        clientData: r,
                        attestation: i
                    };
                    return "function" == typeof a && (u.transports = JSON.stringify(a.call(t))), u;
                }, p = function(e1) {
                    var t = e1.response;
                    return {
                        id: e1.id,
                        clientData: (0, o.kQ)(t.clientDataJSON),
                        authenticatorData: (0, o.kQ)(t.authenticatorData),
                        signatureData: (0, o.kQ)(t.signature)
                    };
                };
            },
            9108: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    addEmail: function() {
                        return B;
                    },
                    addPhone: function() {
                        return z;
                    },
                    deleteEmail: function() {
                        return K;
                    },
                    deletePassword: function() {
                        return oe;
                    },
                    deletePhone: function() {
                        return Q;
                    },
                    enrollPassword: function() {
                        return ne;
                    },
                    getEmail: function() {
                        return H;
                    },
                    getEmailChallenge: function() {
                        return G;
                    },
                    getEmails: function() {
                        return L;
                    },
                    getPassword: function() {
                        return te;
                    },
                    getPhone: function() {
                        return Y;
                    },
                    getPhones: function() {
                        return W;
                    },
                    getProfile: function() {
                        return A;
                    },
                    getProfileSchema: function() {
                        return _;
                    },
                    sendEmailChallenge: function() {
                        return F;
                    },
                    sendPhoneChallenge: function() {
                        return X;
                    },
                    updatePassword: function() {
                        return re;
                    },
                    updateProfile: function() {
                        return R;
                    },
                    verifyEmailChallenge: function() {
                        return V;
                    },
                    verifyPhoneChallenge: function() {
                        return J;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(4942), u = n(1002), c = n(4925), s = n(3144), f = n(5671), l = [
                    "headers"
                ], p = (0, s.Z)(function e1(t, n) {
                    var r = this;
                    (0, f.Z)(this, e1), (0, a.Z)(this, "headers", void 0);
                    var o = n.res, i = o.headers, u = (0, c.Z)(o, l);
                    i && (this.headers = i), Object.keys(u).forEach(function(e1) {
                        "_links" !== e1 && (r[e1] = u[e1]);
                    });
                }), d = n(5385), h = n(9123);
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, a.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function g(e1, t) {
                    return m.apply(this, arguments);
                }
                function m() {
                    return m = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u, c, s, f, l, v, g, m, b, k, w, O, Z, T = arguments;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = T.length > 2 && void 0 !== T[2] ? T[2] : p, o = t.tokenManager.getTokensSync(), a = o.accessToken, u = n.accessToken || a, c = t.getIssuerOrigin(), s = n.url, f = n.method, l = n.payload, v = s.startsWith(c) ? s : "".concat(c).concat(s), u) {
                                        e1.next = 8;
                                        break;
                                    }
                                    throw new h.Z("AccessToken is required to request MyAccount API endpoints.");
                                case 8:
                                    if (g = u, m = y({
                                        headers: {
                                            Accept: "*/*;okta-version=1.0.0"
                                        },
                                        url: v,
                                        method: f
                                    }, l && {
                                        args: l
                                    }), !t.options.dpop) {
                                        e1.next = 22;
                                        break;
                                    }
                                    if ("string" != typeof g) {
                                        e1.next = 13;
                                        break;
                                    }
                                    throw new h.Z("AccessToken object must be provided when using dpop");
                                case 13:
                                    return e1.next = 15, t.getDPoPAuthorizationHeaders({
                                        method: f,
                                        url: v,
                                        accessToken: g
                                    });
                                case 15:
                                    b = e1.sent, k = b.Authorization, w = b.Dpop, m.headers.Authorization = k, m.headers.Dpop = w, e1.next = 24;
                                    break;
                                case 22:
                                    g = "string" == typeof g ? g : g.accessToken, m.accessToken = g;
                                case 24:
                                    return e1.next = 26, (0, d.c3)(t, m);
                                case 26:
                                    return O = e1.sent, Z = Array.isArray(O) ? O.map(function(e1) {
                                        return new r(t, {
                                            res: e1,
                                            accessToken: g
                                        });
                                    }) : new r(t, {
                                        res: O,
                                        accessToken: g
                                    }), e1.abrupt("return", Z);
                                case 29:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), m.apply(this, arguments);
                }
                function b(e1) {
                    for(var t = e1.oktaAuth, n = e1.accessToken, o = e1.methodName, a = e1.links, c = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : p, s = function() {
                        var e1, u = l[f];
                        if (u.toLowerCase() === o) {
                            var s = a.self;
                            return {
                                v: (e1 = (0, r.Z)(i().mark(function e1(r) {
                                    return i().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.abrupt("return", g(t, {
                                                    accessToken: n,
                                                    url: s.href,
                                                    method: u,
                                                    payload: r
                                                }, c));
                                            case 1:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1);
                                })), function(t) {
                                    return e1.apply(this, arguments);
                                })
                            };
                        }
                    }, f = 0, l = [
                        "GET",
                        "POST",
                        "PUT",
                        "DELETE"
                    ]; f < l.length; f++){
                        var d = s();
                        if ("object" === (0, u.Z)(d)) return d.v;
                    }
                    var v, y = a[o];
                    if (!y) throw new h.Z("No link is found with methodName: ".concat(o));
                    return v = (0, r.Z)(i().mark(function e1(r) {
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.abrupt("return", g(t, {
                                        accessToken: n,
                                        url: y.href,
                                        method: y.hints.allow[0],
                                        payload: r
                                    }, c));
                                case 1:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), function(e1) {
                        return v.apply(this, arguments);
                    };
                }
                var k = n(7326), w = n(136), O = n(2963), Z = n(1120);
                var T = function(e1) {
                    (0, w.Z)(o, e1);
                    var t, n, r = (t = o, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function o(e1, t) {
                        var n;
                        (0, f.Z)(this, o), n = r.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "createdAt", void 0), (0, a.Z)((0, k.Z)(n), "modifiedAt", void 0), (0, a.Z)((0, k.Z)(n), "profile", void 0);
                        var i = t.res, u = i.createdAt, c = i.modifiedAt, s = i.profile;
                        return n.createdAt = u, n.modifiedAt = c, n.profile = s, n;
                    }
                    return (0, s.Z)(o);
                }(p);
                var E, P, S, x = function(e1) {
                    (0, w.Z)(o, e1);
                    var t, n, r = (t = o, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function o(e1, t) {
                        var n;
                        return (0, f.Z)(this, o), n = r.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "properties", void 0), n.properties = t.res.properties, n;
                    }
                    return (0, s.Z)(o);
                }(p), A = (E = (0, r.Z)(i().mark(function e1(t, n) {
                    var r;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return e1.next = 2, g(t, {
                                    url: "/idp/myaccount/profile",
                                    method: "GET",
                                    accessToken: null == n ? void 0 : n.accessToken
                                }, T);
                            case 2:
                                return r = e1.sent, e1.abrupt("return", r);
                            case 4:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return E.apply(this, arguments);
                }), R = (P = (0, r.Z)(i().mark(function e1(t, n) {
                    var r, o, a, u;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).payload, a = r.accessToken, e1.next = 3, g(t, {
                                    url: "/idp/myaccount/profile",
                                    method: "PUT",
                                    payload: o,
                                    accessToken: a
                                }, T);
                            case 3:
                                return u = e1.sent, e1.abrupt("return", u);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return P.apply(this, arguments);
                }), _ = (S = (0, r.Z)(i().mark(function e1(t, n) {
                    var r;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return e1.next = 2, g(t, {
                                    url: "/idp/myaccount/profile/schema",
                                    method: "GET",
                                    accessToken: null == n ? void 0 : n.accessToken
                                }, x);
                            case 2:
                                return r = e1.sent, e1.abrupt("return", r);
                            case 4:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return S.apply(this, arguments);
                });
                var j = function(e1) {
                    (0, w.Z)(o, e1);
                    var t, n, r = (t = o, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function o(e1, t) {
                        var n;
                        (0, f.Z)(this, o), n = r.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "id", void 0), (0, a.Z)((0, k.Z)(n), "expiresAt", void 0), (0, a.Z)((0, k.Z)(n), "profile", void 0), (0, a.Z)((0, k.Z)(n), "status", void 0);
                        var i = t.res, u = i.id, c = i.profile, s = i.expiresAt, l = i.status;
                        return n.id = u, n.expiresAt = s, n.profile = c, n.status = l, n;
                    }
                    return (0, s.Z)(o);
                }(p);
                var C = function(e1) {
                    (0, w.Z)(u, e1);
                    var t, n, o = (t = u, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function u(e1, t) {
                        var n;
                        (0, f.Z)(this, u), n = o.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "id", void 0), (0, a.Z)((0, k.Z)(n), "expiresAt", void 0), (0, a.Z)((0, k.Z)(n), "profile", void 0), (0, a.Z)((0, k.Z)(n), "status", void 0), (0, a.Z)((0, k.Z)(n), "poll", void 0), (0, a.Z)((0, k.Z)(n), "verify", void 0);
                        var c = t.accessToken, s = t.res, l = s.id, p = s.expiresAt, d = s.profile, h = s.status, v = s._links;
                        return n.id = l, n.expiresAt = p, n.profile = d, n.status = h, n.poll = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: c,
                                            methodName: "poll",
                                            links: v
                                        }, j), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.verify = function() {
                            var t = (0, r.Z)(i().mark(function t(n) {
                                var r;
                                return i().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            return r = b({
                                                oktaAuth: e1,
                                                accessToken: c,
                                                methodName: "verify",
                                                links: v
                                            }, u), t.next = 3, r(n);
                                        case 3:
                                            return t.abrupt("return", t.sent);
                                        case 4:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t);
                            }));
                            return function(e1) {
                                return t.apply(this, arguments);
                            };
                        }(), n;
                    }
                    return (0, s.Z)(u);
                }(p);
                var I, D, M, N, U = function(e1) {
                    (0, w.Z)(u, e1);
                    var t, n, o = (t = u, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function u(e1, t) {
                        var n;
                        (0, f.Z)(this, u), n = o.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "id", void 0), (0, a.Z)((0, k.Z)(n), "profile", void 0), (0, a.Z)((0, k.Z)(n), "roles", void 0), (0, a.Z)((0, k.Z)(n), "status", void 0), (0, a.Z)((0, k.Z)(n), "get", void 0), (0, a.Z)((0, k.Z)(n), "delete", void 0), (0, a.Z)((0, k.Z)(n), "challenge", void 0), (0, a.Z)((0, k.Z)(n), "poll", void 0), (0, a.Z)((0, k.Z)(n), "verify", void 0);
                        var c, s = t.accessToken, l = t.res, p = l.id, d = l.profile, h = l.roles, v = l.status, y = l._links;
                        return n.id = p, n.profile = d, n.roles = h, n.status = v, n.get = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "get",
                                            links: y
                                        }, u), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.delete = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "delete",
                                            links: y
                                        }), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.challenge = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "challenge",
                                            links: y
                                        }, C), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), y.poll && (n.poll = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "poll",
                                            links: y
                                        }, j), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        }))), y.verify && (n.verify = (c = (0, r.Z)(i().mark(function t(n) {
                            var r;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return r = b({
                                            oktaAuth: e1,
                                            accessToken: s,
                                            methodName: "verify",
                                            links: y
                                        }), t.next = 3, r(n);
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), function(e1) {
                            return c.apply(this, arguments);
                        })), n;
                    }
                    return (0, s.Z)(u);
                }(p), L = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, g(t, {
                                        url: "/idp/myaccount/emails",
                                        method: "GET",
                                        accessToken: null == n ? void 0 : n.accessToken
                                    }, U);
                                case 2:
                                    return r = e1.sent, e1.abrupt("return", r);
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), H = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).id, a = r.accessToken, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/emails/".concat(o),
                                        method: "GET",
                                        accessToken: a
                                    }, U);
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), B = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, a = r.payload, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/emails",
                                        method: "POST",
                                        payload: a,
                                        accessToken: o
                                    }, U);
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), K = (I = (0, r.Z)(i().mark(function e1(t, n) {
                    var r, o, a, u;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).id, a = r.accessToken, e1.next = 3, g(t, {
                                    url: "/idp/myaccount/emails/".concat(o),
                                    method: "DELETE",
                                    accessToken: a
                                });
                            case 3:
                                return u = e1.sent, e1.abrupt("return", u);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return I.apply(this, arguments);
                }), F = (D = (0, r.Z)(i().mark(function e1(t, n) {
                    var r, o, a, u;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).id, a = r.accessToken, e1.next = 3, g(t, {
                                    url: "/idp/myaccount/emails/".concat(o, "/challenge"),
                                    method: "POST",
                                    accessToken: a
                                }, C);
                            case 3:
                                return u = e1.sent, e1.abrupt("return", u);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return D.apply(this, arguments);
                }), G = (M = (0, r.Z)(i().mark(function e1(t, n) {
                    var r, o, a, u, c;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).emailId, a = r.challengeId, u = r.accessToken, e1.next = 3, g(t, {
                                    url: "/idp/myaccount/emails/".concat(o, "/challenge/").concat(a),
                                    method: "POST",
                                    accessToken: u
                                }, C);
                            case 3:
                                return c = e1.sent, e1.abrupt("return", c);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return M.apply(this, arguments);
                }), V = (N = (0, r.Z)(i().mark(function e1(t, n) {
                    var r, o, a, u, c, s;
                    return i().wrap(function(e1) {
                        for(;;)switch(e1.prev = e1.next){
                            case 0:
                                return o = (r = n).emailId, a = r.challengeId, u = r.payload, c = r.accessToken, e1.next = 3, g(t, {
                                    url: "/idp/myaccount/emails/".concat(o, "/challenge/").concat(a, "/verify"),
                                    method: "POST",
                                    payload: u,
                                    accessToken: c
                                });
                            case 3:
                                return s = e1.sent, e1.abrupt("return", s);
                            case 5:
                            case "end":
                                return e1.stop();
                        }
                    }, e1);
                })), function(e1, t) {
                    return N.apply(this, arguments);
                });
                var q = function(e1) {
                    (0, w.Z)(u, e1);
                    var t, n, o = (t = u, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function u(e1, t) {
                        var n;
                        (0, f.Z)(this, u), n = o.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "id", void 0), (0, a.Z)((0, k.Z)(n), "profile", void 0), (0, a.Z)((0, k.Z)(n), "status", void 0), (0, a.Z)((0, k.Z)(n), "get", void 0), (0, a.Z)((0, k.Z)(n), "delete", void 0), (0, a.Z)((0, k.Z)(n), "challenge", void 0), (0, a.Z)((0, k.Z)(n), "verify", void 0);
                        var c, s = t.res, l = t.accessToken, p = s.id, d = s.profile, h = s.status, v = s._links;
                        return n.id = p, n.profile = d, n.status = h, n.get = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: l,
                                            methodName: "get",
                                            links: v
                                        }, u), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.delete = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: l,
                                            methodName: "delete",
                                            links: v
                                        }), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.challenge = (c = (0, r.Z)(i().mark(function t(n) {
                            var r;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return r = b({
                                            oktaAuth: e1,
                                            accessToken: l,
                                            methodName: "challenge",
                                            links: v
                                        }), t.next = 3, r(n);
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), function(e1) {
                            return c.apply(this, arguments);
                        }), v.verify && (n.verify = function() {
                            var t = (0, r.Z)(i().mark(function t(n) {
                                var r;
                                return i().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            return r = b({
                                                oktaAuth: e1,
                                                accessToken: l,
                                                methodName: "verify",
                                                links: v
                                            }), t.next = 3, r(n);
                                        case 3:
                                            return t.abrupt("return", t.sent);
                                        case 4:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t);
                            }));
                            return function(e1) {
                                return t.apply(this, arguments);
                            };
                        }()), n;
                    }
                    return (0, s.Z)(u);
                }(p), W = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, g(t, {
                                        url: "/idp/myaccount/phones",
                                        method: "GET",
                                        accessToken: null == n ? void 0 : n.accessToken
                                    }, q);
                                case 2:
                                    return r = e1.sent, e1.abrupt("return", r);
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), Y = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, a = r.id, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/phones/".concat(a),
                                        method: "GET",
                                        accessToken: o
                                    }, q);
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), z = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, a = r.payload, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/phones",
                                        method: "POST",
                                        payload: a,
                                        accessToken: o
                                    }, q);
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), Q = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).id, a = r.accessToken, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/phones/".concat(o),
                                        method: "DELETE",
                                        accessToken: a
                                    });
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), X = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u, c;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, a = r.id, u = r.payload, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/phones/".concat(a, "/challenge"),
                                        method: "POST",
                                        payload: u,
                                        accessToken: o
                                    });
                                case 3:
                                    return c = e1.sent, e1.abrupt("return", c);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), J = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u, c;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).id, a = r.payload, u = r.accessToken, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/phones/".concat(o, "/verify"),
                                        method: "POST",
                                        payload: a,
                                        accessToken: u
                                    });
                                case 3:
                                    return c = e1.sent, e1.abrupt("return", c);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), $ = n(8008);
                var ee = function(e1) {
                    (0, w.Z)(u, e1);
                    var t, n, o = (t = u, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = (0, Z.Z)(t);
                        if (n) {
                            var o = (0, Z.Z)(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return (0, O.Z)(this, e1);
                    });
                    function u(e1, t) {
                        var n;
                        (0, f.Z)(this, u), n = o.call(this, e1, t), (0, a.Z)((0, k.Z)(n), "id", void 0), (0, a.Z)((0, k.Z)(n), "created", void 0), (0, a.Z)((0, k.Z)(n), "lastUpdated", void 0), (0, a.Z)((0, k.Z)(n), "status", void 0), (0, a.Z)((0, k.Z)(n), "get", void 0), (0, a.Z)((0, k.Z)(n), "enroll", void 0), (0, a.Z)((0, k.Z)(n), "update", void 0), (0, a.Z)((0, k.Z)(n), "delete", void 0);
                        var c, s = t.res, l = t.accessToken, p = s.id, d = s.status, h = s.created, v = s.lastUpdated, y = s._links;
                        return n.id = p, n.status = d, n.created = h, n.lastUpdated = v, n.status == $.Fn.NOT_ENROLLED ? n.enroll = function() {
                            var t = (0, r.Z)(i().mark(function t(n) {
                                var r;
                                return i().wrap(function(t) {
                                    for(;;)switch(t.prev = t.next){
                                        case 0:
                                            return r = b({
                                                oktaAuth: e1,
                                                accessToken: l,
                                                methodName: "enroll",
                                                links: y
                                            }, u), t.next = 3, r(n);
                                        case 3:
                                            return t.abrupt("return", t.sent);
                                        case 4:
                                        case "end":
                                            return t.stop();
                                    }
                                }, t);
                            }));
                            return function(e1) {
                                return t.apply(this, arguments);
                            };
                        }() : (n.get = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: l,
                                            methodName: "get",
                                            links: y
                                        }, u), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), n.update = (c = (0, r.Z)(i().mark(function t(n) {
                            var r;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return r = b({
                                            oktaAuth: e1,
                                            accessToken: l,
                                            methodName: "put",
                                            links: y
                                        }, u), t.next = 3, r(n);
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        })), function(e1) {
                            return c.apply(this, arguments);
                        }), n.delete = (0, r.Z)(i().mark(function t() {
                            var n;
                            return i().wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        return n = b({
                                            oktaAuth: e1,
                                            accessToken: l,
                                            methodName: "delete",
                                            links: y
                                        }), t.next = 3, n();
                                    case 3:
                                        return t.abrupt("return", t.sent);
                                    case 4:
                                    case "end":
                                        return t.stop();
                                }
                            }, t);
                        }))), n;
                    }
                    return (0, s.Z)(u);
                }(p), te = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, g(t, {
                                        url: "/idp/myaccount/password",
                                        method: "GET",
                                        accessToken: null == n ? void 0 : n.accessToken
                                    }, ee);
                                case 2:
                                    return r = e1.sent, e1.abrupt("return", r);
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), ne = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, a = r.payload, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/password",
                                        method: "POST",
                                        payload: a,
                                        accessToken: o
                                    }, ee);
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), re = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, u;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (r = n).accessToken, a = r.payload, e1.next = 3, g(t, {
                                        url: "/idp/myaccount/password",
                                        method: "PUT",
                                        payload: a,
                                        accessToken: o
                                    }, ee);
                                case 3:
                                    return u = e1.sent, e1.abrupt("return", u);
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }(), oe = function() {
                    var e1 = (0, r.Z)(i().mark(function e1(t, n) {
                        var r;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, g(t, {
                                        url: "/idp/myaccount/password",
                                        method: "DELETE",
                                        accessToken: null == n ? void 0 : n.accessToken
                                    });
                                case 2:
                                    return r = e1.sent, e1.abrupt("return", r);
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }));
                    return function(t, n) {
                        return e1.apply(this, arguments);
                    };
                }();
            },
            1132: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    aw: function() {
                        return u.aw;
                    },
                    Fn: function() {
                        return u.Fn;
                    },
                    qb: function() {
                        return u.qb;
                    },
                    no: function() {
                        return r.addEmail;
                    },
                    Z1: function() {
                        return r.addPhone;
                    },
                    Xc: function() {
                        return a;
                    },
                    nd: function() {
                        return r.deleteEmail;
                    },
                    QN: function() {
                        return r.deletePassword;
                    },
                    qj: function() {
                        return r.deletePhone;
                    },
                    xg: function() {
                        return r.enrollPassword;
                    },
                    OD: function() {
                        return r.getEmail;
                    },
                    hG: function() {
                        return r.getEmailChallenge;
                    },
                    G5: function() {
                        return r.getEmails;
                    },
                    Ij: function() {
                        return r.getPassword;
                    },
                    u_: function() {
                        return r.getPhone;
                    },
                    Po: function() {
                        return r.getPhones;
                    },
                    Ai: function() {
                        return r.getProfile;
                    },
                    aF: function() {
                        return r.getProfileSchema;
                    },
                    HT: function() {
                        return i.H;
                    },
                    ME: function() {
                        return r.sendEmailChallenge;
                    },
                    dv: function() {
                        return r.sendPhoneChallenge;
                    },
                    gQ: function() {
                        return r.updatePassword;
                    },
                    ck: function() {
                        return r.updateProfile;
                    },
                    T8: function() {
                        return r.verifyEmailChallenge;
                    },
                    Lo: function() {
                        return r.verifyPhoneChallenge;
                    }
                });
                var r = n(9108), o = n(1578), i = n(6794);
                function a(e1, t, n) {
                    var r = (0, o.K)(e1, t, n);
                    return (0, i.H)(r);
                }
                var u = n(8008);
            },
            6794: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    H: function() {
                        return p;
                    }
                });
                var r = n(885), o = n(3144), i = n(5671), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(9108);
                function p(e1) {
                    return function(e1) {
                        (0, u.Z)(d, e1);
                        var t, n, p = (t = d, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, s.Z)(t);
                            if (n) {
                                var o = (0, s.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, c.Z)(this, e1);
                        });
                        function d() {
                            var e1;
                            (0, i.Z)(this, d);
                            for(var t = arguments.length, n = new Array(t), o = 0; o < t; o++)n[o] = arguments[o];
                            return e1 = p.call.apply(p, [
                                this
                            ].concat(n)), (0, f.Z)((0, a.Z)(e1), "myaccount", void 0), e1.myaccount = Object.entries(l).filter(function(e1) {
                                return "default" !== (0, r.Z)(e1, 1)[0];
                            }).reduce(function(t, n) {
                                var o = (0, r.Z)(n, 2), i = o[0], u = o[1];
                                return t[i] = u.bind(null, (0, a.Z)(e1)), t;
                            }, {}), e1;
                        }
                        return (0, o.Z)(d);
                    }(e1);
                }
            },
            8008: function(e1, t, n) {
                "use strict";
                var r, o, i;
                n.d(t, {
                    Fn: function() {
                        return i;
                    },
                    aw: function() {
                        return r;
                    },
                    qb: function() {
                        return o;
                    }
                }), function(e1) {
                    e1.PRIMARY = "PRIMARY", e1.SECONDARY = "SECONDARY";
                }(r || (r = {})), function(e1) {
                    e1.VERIFIED = "VERIFIED", e1.UNVERIFIED = "UNVERIFIED";
                }(o || (o = {})), function(e1) {
                    e1.NOT_ENROLLED = "NOT_ENROLLED", e1.ACTIVE = "ACTIVE";
                }(i || (i = {}));
            },
            2427: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    M: function() {
                        return w;
                    }
                });
                var r = n(5861), o = n(1002), i = n(5671), a = n(3144), u = n(4942), c = n(4687), s = n.n(c), f = n(3193), l = n(9123), p = n(2482), d = n(415), h = function() {
                    function e1(t) {
                        (0, i.Z)(this, e1), (0, u.Z)(this, "localOffset", void 0), this.localOffset = parseInt(t || 0);
                    }
                    return (0, a.Z)(e1, [
                        {
                            key: "now",
                            value: function() {
                                return (Date.now() + this.localOffset) / 1e3;
                            }
                        }
                    ], [
                        {
                            key: "create",
                            value: function() {
                                return new e1(0);
                            }
                        }
                    ]), e1;
                }(), v = n(7088), y = n(6488), g = n(1971);
                function m(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function b(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? m(Object(n), !0).forEach(function(t) {
                            (0, u.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                var k = {
                    autoRenew: !0,
                    autoRemove: !0,
                    syncStorage: !0,
                    clearPendingRemoveTokens: !0,
                    storage: void 0,
                    expireEarlySeconds: 30,
                    storageKey: g.TOKEN_STORAGE_NAME
                }, w = function() {
                    function e1(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        if ((0, i.Z)(this, e1), (0, u.Z)(this, "sdk", void 0), (0, u.Z)(this, "clock", void 0), (0, u.Z)(this, "emitter", void 0), (0, u.Z)(this, "storage", void 0), (0, u.Z)(this, "state", void 0), (0, u.Z)(this, "options", void 0), this.sdk = t, this.emitter = t.emitter, !this.emitter) throw new l.Z("Emitter should be initialized before TokenManager");
                        n = Object.assign({}, k, (0, f.YY)(n)), (0, d.isLocalhost)() || (n.expireEarlySeconds = k.expireEarlySeconds), this.options = n;
                        var r = (0, f.YY)({
                            storageKey: n.storageKey,
                            secure: n.secure
                        });
                        "object" === (0, o.Z)(n.storage) ? r.storageProvider = n.storage : n.storage && (r.storageType = n.storage), this.storage = t.storageManager.getTokenStorage(b(b({}, r), {}, {
                            useSeparateCookies: !0
                        })), this.clock = h.create(), this.state = {
                            expireTimeouts: {},
                            renewPromise: null
                        };
                    }
                    var t, n, c;
                    return (0, a.Z)(e1, [
                        {
                            key: "on",
                            value: function(e1, t, n) {
                                n ? this.emitter.on(e1, t, n) : this.emitter.on(e1, t);
                            }
                        },
                        {
                            key: "off",
                            value: function(e1, t) {
                                t ? this.emitter.off(e1, t) : this.emitter.off(e1);
                            }
                        },
                        {
                            key: "start",
                            value: function() {
                                this.options.clearPendingRemoveTokens && this.clearPendingRemoveTokens(), this.setExpireEventTimeoutAll(), this.state.started = !0;
                            }
                        },
                        {
                            key: "stop",
                            value: function() {
                                this.clearExpireEventTimeoutAll(), this.state.started = !1;
                            }
                        },
                        {
                            key: "isStarted",
                            value: function() {
                                return !!this.state.started;
                            }
                        },
                        {
                            key: "getOptions",
                            value: function() {
                                return (0, f.d9)(this.options);
                            }
                        },
                        {
                            key: "getExpireTime",
                            value: function(e1) {
                                var t = this.options.expireEarlySeconds || 0;
                                return e1.expiresAt - t;
                            }
                        },
                        {
                            key: "hasExpired",
                            value: function(e1) {
                                return this.getExpireTime(e1) <= this.clock.now();
                            }
                        },
                        {
                            key: "emitExpired",
                            value: function(e1, t) {
                                this.emitter.emit(v.$Y, e1, t);
                            }
                        },
                        {
                            key: "emitRenewed",
                            value: function(e1, t, n) {
                                this.emitter.emit(v.E, e1, t, n);
                            }
                        },
                        {
                            key: "emitAdded",
                            value: function(e1, t) {
                                this.emitter.emit(v.O3, e1, t);
                            }
                        },
                        {
                            key: "emitRemoved",
                            value: function(e1, t) {
                                this.emitter.emit(v.FT, e1, t);
                            }
                        },
                        {
                            key: "emitError",
                            value: function(e1) {
                                this.emitter.emit(v.$I, e1);
                            }
                        },
                        {
                            key: "clearExpireEventTimeout",
                            value: function(e1) {
                                clearTimeout(this.state.expireTimeouts[e1]), delete this.state.expireTimeouts[e1], this.state.renewPromise = null;
                            }
                        },
                        {
                            key: "clearExpireEventTimeoutAll",
                            value: function() {
                                var e1 = this.state.expireTimeouts;
                                for(var t in e1)Object.prototype.hasOwnProperty.call(e1, t) && this.clearExpireEventTimeout(t);
                            }
                        },
                        {
                            key: "setExpireEventTimeout",
                            value: function(e1, t) {
                                var n = this;
                                if (!(0, y.z9)(t)) {
                                    var r = this.getExpireTime(t), o = 1e3 * Math.max(r - this.clock.now(), 0);
                                    this.clearExpireEventTimeout(e1);
                                    var i = setTimeout(function() {
                                        n.emitExpired(e1, t);
                                    }, o);
                                    this.state.expireTimeouts[e1] = i;
                                }
                            }
                        },
                        {
                            key: "setExpireEventTimeoutAll",
                            value: function() {
                                var e1 = this.storage.getStorage();
                                for(var t in e1)if (Object.prototype.hasOwnProperty.call(e1, t)) {
                                    var n = e1[t];
                                    this.setExpireEventTimeout(t, n);
                                }
                            }
                        },
                        {
                            key: "resetExpireEventTimeoutAll",
                            value: function() {
                                this.clearExpireEventTimeoutAll(), this.setExpireEventTimeoutAll();
                            }
                        },
                        {
                            key: "add",
                            value: function(e1, t) {
                                var n = this.storage.getStorage();
                                (0, p.R)(t), n[e1] = t, this.storage.setStorage(n), this.emitSetStorageEvent(), this.emitAdded(e1, t), this.setExpireEventTimeout(e1, t);
                            }
                        },
                        {
                            key: "getSync",
                            value: function(e1) {
                                return this.storage.getStorage()[e1];
                            }
                        },
                        {
                            key: "get",
                            value: (c = (0, r.Z)(s().mark(function e1(t) {
                                return s().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.abrupt("return", this.getSync(t));
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function(e1) {
                                return c.apply(this, arguments);
                            })
                        },
                        {
                            key: "getTokensSync",
                            value: function() {
                                var e1 = {}, t = this.storage.getStorage();
                                return Object.keys(t).forEach(function(n) {
                                    var r = t[n];
                                    (0, y.hv)(r) ? e1.accessToken = r : (0, y.sI)(r) ? e1.idToken = r : (0, y.z9)(r) && (e1.refreshToken = r);
                                }), e1;
                            }
                        },
                        {
                            key: "getTokens",
                            value: (n = (0, r.Z)(s().mark(function e1() {
                                return s().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.abrupt("return", this.getTokensSync());
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function() {
                                return n.apply(this, arguments);
                            })
                        },
                        {
                            key: "getStorageKeyByType",
                            value: function(e1) {
                                var t = this.storage.getStorage();
                                return Object.keys(t).filter(function(n) {
                                    var r = t[n];
                                    return (0, y.hv)(r) && "accessToken" === e1 || (0, y.sI)(r) && "idToken" === e1 || (0, y.z9)(r) && "refreshToken" === e1;
                                })[0];
                            }
                        },
                        {
                            key: "getTokenType",
                            value: function(e1) {
                                if ((0, y.hv)(e1)) return "accessToken";
                                if ((0, y.sI)(e1)) return "idToken";
                                if ((0, y.z9)(e1)) return "refreshToken";
                                throw new l.Z("Unknown token type");
                            }
                        },
                        {
                            key: "emitSetStorageEvent",
                            value: function() {
                                if ((0, d.isIE11OrLess)()) {
                                    var e1 = this.storage.getStorage();
                                    this.emitter.emit(v.zr, e1);
                                }
                            }
                        },
                        {
                            key: "getStorage",
                            value: function() {
                                return this.storage;
                            }
                        },
                        {
                            key: "setTokens",
                            value: function(e1, t, n, r) {
                                var o = this, i = function(e1, i) {
                                    var a = o.getTokenType(i);
                                    "accessToken" === a ? t && t(e1, i) : "idToken" === a ? n && n(e1, i) : "refreshToken" === a && r && r(e1, i);
                                }, a = function(e1, t) {
                                    o.emitAdded(e1, t), o.setExpireEventTimeout(e1, t), i(e1, t);
                                }, u = function(e1, t) {
                                    o.clearExpireEventTimeout(e1), o.emitRemoved(e1, t), i(e1, t);
                                }, c = [
                                    "idToken",
                                    "accessToken",
                                    "refreshToken"
                                ], s = this.getTokensSync();
                                c.forEach(function(t) {
                                    var n = e1[t];
                                    n && (0, p.R)(n, t);
                                });
                                var f = c.reduce(function(t, n) {
                                    var r = e1[n];
                                    return r && (t[o.getStorageKeyByType(n) || n] = r), t;
                                }, {});
                                this.storage.setStorage(f), this.emitSetStorageEvent(), c.forEach(function(t) {
                                    var n, r, c, f = e1[t], l = s[t], p = o.getStorageKeyByType(t) || t;
                                    f && l ? (u(p, l), a(p, f), n = p, r = f, c = l, o.emitRenewed(n, r, c), o.clearExpireEventTimeout(n), o.setExpireEventTimeout(n, r), i(n, r)) : f ? a(p, f) : l && u(p, l);
                                });
                            }
                        },
                        {
                            key: "remove",
                            value: function(e1) {
                                this.clearExpireEventTimeout(e1);
                                var t = this.storage.getStorage(), n = t[e1];
                                delete t[e1], this.storage.setStorage(t), this.emitSetStorageEvent(), this.emitRemoved(e1, n);
                            }
                        },
                        {
                            key: "renewToken",
                            value: (t = (0, r.Z)(s().mark(function e1(t) {
                                var n;
                                return s().wrap(function(e1) {
                                    for(;;)switch(e1.prev = e1.next){
                                        case 0:
                                            return e1.abrupt("return", null === (n = this.sdk.token) || void 0 === n ? void 0 : n.renew(t));
                                        case 1:
                                        case "end":
                                            return e1.stop();
                                    }
                                }, e1, this);
                            })), function(e1) {
                                return t.apply(this, arguments);
                            })
                        },
                        {
                            key: "validateToken",
                            value: function(e1) {
                                return (0, p.R)(e1);
                            }
                        },
                        {
                            key: "renew",
                            value: function(e1) {
                                var t = this;
                                if (this.state.renewPromise) return this.state.renewPromise;
                                try {
                                    var n = this.getSync(e1), r = void 0 !== n;
                                    if (!n && "accessToken" === e1) {
                                        var o = this.getStorageKeyByType("refreshToken");
                                        r = void 0 !== this.getSync(o);
                                    }
                                    if (!r) throw new l.Z("The tokenManager has no token for the key: " + e1);
                                } catch (e1) {
                                    return this.emitError(e1), Promise.reject(e1);
                                }
                                return this.clearExpireEventTimeout(e1), this.state.renewPromise = this.sdk.token.renewTokens().then(function(r) {
                                    if (t.setTokens(r), !n && "accessToken" === e1) {
                                        var o = r.accessToken;
                                        return t.emitRenewed(e1, o, null), o;
                                    }
                                    return r[t.getTokenType(n)];
                                }).catch(function(n) {
                                    throw t.remove(e1), n.tokenKey = e1, t.emitError(n), n;
                                }).finally(function() {
                                    t.state.renewPromise = null;
                                });
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                var e1 = this, t = this.getTokensSync();
                                this.clearExpireEventTimeoutAll(), this.storage.clearStorage(), this.emitSetStorageEvent(), Object.keys(t).forEach(function(n) {
                                    e1.emitRemoved(n, t[n]);
                                });
                            }
                        },
                        {
                            key: "clearPendingRemoveTokens",
                            value: function() {
                                var e1 = this, t = this.storage.getStorage(), n = {};
                                Object.keys(t).forEach(function(e1) {
                                    t[e1].pendingRemove && (n[e1] = t[e1], delete t[e1]);
                                }), this.storage.setStorage(t), this.emitSetStorageEvent(), Object.keys(n).forEach(function(t) {
                                    e1.clearExpireEventTimeout(t), e1.emitRemoved(t, n[t]);
                                });
                            }
                        },
                        {
                            key: "updateRefreshToken",
                            value: function(e1) {
                                var t = this.getStorageKeyByType("refreshToken") || g.REFRESH_TOKEN_STORAGE_KEY, n = this.storage.getStorage();
                                (0, p.R)(e1), n[t] = e1, this.storage.setStorage(n), this.emitSetStorageEvent();
                            }
                        },
                        {
                            key: "removeRefreshToken",
                            value: function() {
                                var e1 = this.getStorageKeyByType("refreshToken") || g.REFRESH_TOKEN_STORAGE_KEY;
                                this.remove(e1);
                            }
                        },
                        {
                            key: "addPendingRemoveFlags",
                            value: function() {
                                var e1 = this.getTokensSync();
                                Object.keys(e1).forEach(function(t) {
                                    e1[t].pendingRemove = !0;
                                }), this.setTokens(e1);
                            }
                        }
                    ]), e1;
                }();
            },
            1646: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    P: function() {
                        return s;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(4319), u = n(146), c = 18e5;
                function s() {
                    return function() {
                        function e1(t) {
                            (0, r.Z)(this, e1), (0, i.Z)(this, "options", void 0), (0, i.Z)(this, "storageManager", void 0), (0, i.Z)(this, "enableSharedStorage", void 0), (0, i.Z)(this, "saveLastResponse", void 0), this.storageManager = t.storageManager, this.enableSharedStorage = !1 !== t.enableSharedStorage, this.saveLastResponse = !1 !== t.saveLastResponse, this.options = t;
                        }
                        return (0, o.Z)(e1, [
                            {
                                key: "clear",
                                value: function() {
                                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = this.storageManager.getTransactionStorage(), n = t.getStorage();
                                    if (t.clearStorage(), this.enableSharedStorage && !1 !== e1.clearSharedStorage) {
                                        var r = e1.state || (null == n ? void 0 : n.state);
                                        r && function(e1, t) {
                                            var n = e1.getSharedTansactionStorage(), r = n.getStorage();
                                            delete r[t], n.setStorage(r);
                                        }(this.storageManager, r);
                                    }
                                }
                            },
                            {
                                key: "save",
                                value: function(e1) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = this.storageManager.getTransactionStorage(), r = n.getStorage();
                                    (0, a.mH)(r) && !t.muteWarning && (0, u.ZK)("a saved auth transaction exists in storage. This may indicate another auth flow is already in progress."), n.setStorage(e1), this.enableSharedStorage && e1.state && function(e1, t, n) {
                                        var r = e1.getSharedTansactionStorage(), o = r.getStorage();
                                        o[t] = {
                                            dateCreated: Date.now(),
                                            transaction: n
                                        }, r.setStorage(o);
                                    }(this.storageManager, e1.state, e1);
                                }
                            },
                            {
                                key: "exists",
                                value: function() {
                                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    try {
                                        return !!this.load(e1);
                                    } catch (e1) {
                                        return !1;
                                    }
                                }
                            },
                            {
                                key: "load",
                                value: function() {
                                    var e1, t, n, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                                    return this.enableSharedStorage && r.state && (t = this.storageManager.getSharedTansactionStorage(), n = t.getStorage(), Object.keys(n).forEach(function(e1) {
                                        var t = n[e1];
                                        Date.now() - t.dateCreated > c && delete n[e1];
                                    }), t.setStorage(n), e1 = function(e1, t) {
                                        var n = e1.getSharedTansactionStorage().getStorage()[t];
                                        return n && n.transaction && (0, a.mH)(n.transaction) ? n.transaction : null;
                                    }(this.storageManager, r.state), (0, a.mH)(e1)) ? e1 : (e1 = this.storageManager.getTransactionStorage().getStorage(), (0, a.mH)(e1) ? e1 : null);
                                }
                            }
                        ]), e1;
                    }();
                }
            },
            1237: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    T: function() {
                        return i;
                    }
                });
                var r = n(9123), o = n(7987);
                function i(e1) {
                    var t, n = e1.split(".");
                    try {
                        t = {
                            header: JSON.parse((0, o.Wy)(n[0])),
                            payload: JSON.parse((0, o.Wy)(n[1])),
                            signature: n[2]
                        };
                    } catch (e1) {
                        throw new r.Z("Malformed token");
                    }
                    return t;
                }
            },
            7659: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    SO: function() {
                        return d;
                    },
                    V7: function() {
                        return A;
                    },
                    aW: function() {
                        return D;
                    },
                    ao: function() {
                        return C;
                    },
                    cE: function() {
                        return N;
                    },
                    lk: function() {
                        return E;
                    },
                    sd: function() {
                        return S;
                    },
                    vX: function() {
                        return _;
                    }
                });
                var r = n(2982), o = n(5861), i = n(4687), a = n.n(i), u = n(7987), c = n(7594), s = n(5728), f = n(9123), l = "OktaAuthJs", p = "DPoPKeys";
                function d(e1) {
                    return ((0, s.isOAuthError)(e1) || (0, s.isWWWAuthError)(e1)) && "use_dpop_nonce" === e1.errorCode;
                }
                function h(e1, t, n) {
                    return v.apply(this, arguments);
                }
                function v() {
                    return (v = (0, o.Z)(a().mark(function e1(t, n, r) {
                        var o, i, s;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return o = (0, u.NL)(JSON.stringify(t)), i = (0, u.NL)(JSON.stringify(n)), e1.next = 4, c.KP.subtle.sign({
                                        name: r.algorithm.name
                                    }, r, (0, u.k8)("".concat(o, ".").concat(i)));
                                case 4:
                                    return s = e1.sent, e1.abrupt("return", "".concat(o, ".").concat(i, ".").concat((0, u.aR)((0, u.kQ)(s))));
                                case 6:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function y() {
                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 32;
                    return (0, r.Z)(c.KP.getRandomValues(new Uint8Array(e1))).map(function(e1) {
                        return e1.toString(16);
                    }).join("");
                }
                function g() {
                    return m.apply(this, arguments);
                }
                function m() {
                    return (m = (0, o.Z)(a().mark(function e1() {
                        var t;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return t = {
                                        name: "RSASSA-PKCS1-v1_5",
                                        hash: "SHA-256",
                                        modulusLength: 2048,
                                        publicExponent: new Uint8Array([
                                            1,
                                            0,
                                            1
                                        ])
                                    }, e1.abrupt("return", c.KP.subtle.generateKey(t, !1, [
                                        "sign",
                                        "verify"
                                    ]));
                                case 2:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function b(e1) {
                    return k.apply(this, arguments);
                }
                function k() {
                    return (k = (0, o.Z)(a().mark(function e1(t) {
                        var n, r;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = (new TextEncoder).encode(t), e1.next = 3, c.KP.subtle.digest("SHA-256", n);
                                case 3:
                                    return r = e1.sent, e1.abrupt("return", (0, c.r3)(String.fromCharCode.apply(null, new Uint8Array(r))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, ""));
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function w(e1) {
                    return O.apply(this, arguments);
                }
                function O() {
                    return O = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, u = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    for(n = u.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)r[o - 1] = u[o];
                                    return e1.next = 3, new Promise(function(e1, t) {
                                        try {
                                            var n = window.indexedDB.open(l, 1);
                                            n.onerror = function() {
                                                t(n.error);
                                            }, n.onupgradeneeded = function() {
                                                n.result.createObjectStore(p);
                                            }, n.onsuccess = function() {
                                                var r = n.result, o = r.transaction(p, "readwrite");
                                                o.onerror = function() {
                                                    t(o.error);
                                                };
                                                var i = o.objectStore(p);
                                                e1(i), o.oncomplete = function() {
                                                    r.close();
                                                };
                                            };
                                        } catch (e1) {
                                            t(e1);
                                        }
                                    });
                                case 3:
                                    return i = e1.sent, e1.abrupt("return", new Promise(function(e1, n) {
                                        var o = i[t].apply(i, r);
                                        o.onsuccess = function() {
                                            e1(o);
                                        }, o.onerror = function() {
                                            n(o.error);
                                        };
                                    }));
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), O.apply(this, arguments);
                }
                function Z(e1, t) {
                    return T.apply(this, arguments);
                }
                function T() {
                    return (T = (0, o.Z)(a().mark(function e1(t, n) {
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, w("add", n, t);
                                case 2:
                                    return e1.abrupt("return", n);
                                case 3:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function E(e1) {
                    return P.apply(this, arguments);
                }
                function P() {
                    return (P = (0, o.Z)(a().mark(function e1(t) {
                        var n;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (!t) {
                                        e1.next = 6;
                                        break;
                                    }
                                    return e1.next = 3, w("get", t);
                                case 3:
                                    if (!(n = e1.sent).result) {
                                        e1.next = 6;
                                        break;
                                    }
                                    return e1.abrupt("return", n.result);
                                case 6:
                                    throw new f.Z("Unable to locate dpop key pair required for refresh".concat(t ? " (".concat(t, ")") : ""));
                                case 7:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function S(e1) {
                    return x.apply(this, arguments);
                }
                function x() {
                    return (x = (0, o.Z)(a().mark(function e1(t) {
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, w("delete", t);
                                case 2:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function A() {
                    return R.apply(this, arguments);
                }
                function R() {
                    return (R = (0, o.Z)(a().mark(function e1() {
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return e1.next = 2, w("clear");
                                case 2:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function _() {
                    return j.apply(this, arguments);
                }
                function j() {
                    return (j = (0, o.Z)(a().mark(function e1() {
                        var t, n;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return t = y(4), e1.next = 3, g();
                                case 3:
                                    return n = e1.sent, e1.next = 6, Z(t, n);
                                case 6:
                                    return e1.abrupt("return", {
                                        keyPair: n,
                                        keyPairId: t
                                    });
                                case 7:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function C(e1, t) {
                    return I.apply(this, arguments);
                }
                function I() {
                    return (I = (0, o.Z)(a().mark(function e1(t, n) {
                        var r, o, i, u, c;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (o = !1, i = n.accessToken, u = n.refreshToken, "access" === t && i && "DPoP" === i.tokenType && !u && (o = !0), "refresh" === t && u && !i && (o = !0), c = null !== (r = null == i ? void 0 : i.dpopPairId) && void 0 !== r ? r : null == u ? void 0 : u.dpopPairId, !o || !c) {
                                        e1.next = 8;
                                        break;
                                    }
                                    return e1.next = 8, S(c);
                                case 8:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function D(e1) {
                    return M.apply(this, arguments);
                }
                function M() {
                    return (M = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, u, s, f, l, p, d, v, g, m, k;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = t.keyPair, r = t.url, o = t.method, i = t.nonce, u = t.accessToken, e1.next = 3, c.KP.subtle.exportKey("jwk", n.publicKey);
                                case 3:
                                    if (s = e1.sent, f = s.kty, l = s.crv, p = s.e, d = s.n, v = s.x, g = s.y, m = {
                                        alg: "RS256",
                                        typ: "dpop+jwt",
                                        jwk: {
                                            kty: f,
                                            crv: l,
                                            e: p,
                                            n: d,
                                            x: v,
                                            y: g
                                        }
                                    }, k = {
                                        htm: o,
                                        htu: r,
                                        iat: Math.floor(Date.now() / 1e3),
                                        jti: y()
                                    }, i && (k.nonce = i), !u) {
                                        e1.next = 17;
                                        break;
                                    }
                                    return e1.next = 16, b(u);
                                case 16:
                                    k.ath = e1.sent;
                                case 17:
                                    return e1.abrupt("return", h(m, k, n.privateKey));
                                case 18:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function N(e1) {
                    return U.apply(this, arguments);
                }
                function U() {
                    return (U = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o, i, u;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = t.keyPair, r = t.url, o = t.method, i = t.nonce, u = {
                                        keyPair: n,
                                        url: r,
                                        method: o
                                    }, i && (u.nonce = i), e1.abrupt("return", D(u));
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            2206: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    R: function() {
                        return l;
                    },
                    _: function() {
                        return f;
                    }
                });
                var r = n(4942), o = n(4771), i = n(3193), a = n(6718), u = n(9123);
                function c(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function s(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? c(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function f(e1) {
                    if (!e1.clientId) throw new u.Z("A clientId must be specified in the OktaAuth constructor to get a token");
                    if ((0, o.HD)(e1.responseType) && -1 !== e1.responseType.indexOf(" ")) throw new u.Z("Multiple OAuth responseTypes must be defined as an array");
                    var t = {
                        client_id: e1.clientId,
                        code_challenge: e1.codeChallenge,
                        code_challenge_method: e1.codeChallengeMethod,
                        display: e1.display,
                        idp: e1.idp,
                        idp_scope: e1.idpScope,
                        login_hint: e1.loginHint,
                        max_age: e1.maxAge,
                        nonce: e1.nonce,
                        prompt: e1.prompt,
                        redirect_uri: e1.redirectUri,
                        response_mode: e1.responseMode,
                        response_type: e1.responseType,
                        sessionToken: e1.sessionToken,
                        state: e1.state,
                        acr_values: e1.acrValues,
                        enroll_amr_values: e1.enrollAmrValues
                    };
                    if (t = (0, i.YY)(t), [
                        "idp_scope",
                        "response_type",
                        "enroll_amr_values"
                    ].forEach(function(e1) {
                        Array.isArray(t[e1]) && (t[e1] = t[e1].join(" "));
                    }), -1 !== e1.responseType.indexOf("id_token") && -1 === e1.scopes.indexOf("openid")) throw new u.Z("openid scope must be specified in the scopes argument when requesting an id_token");
                    return e1.scopes && (t.scope = e1.scopes.join(" ")), t;
                }
                function l(e1) {
                    var t = f(e1);
                    return (0, a.UK)(s(s({}, t), e1.extraParams && s({}, e1.extraParams)));
                }
            },
            2642: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Dp: function() {
                        return o.D;
                    },
                    ES: function() {
                        return i.E;
                    },
                    R0: function() {
                        return r.R;
                    },
                    _6: function() {
                        return r._;
                    },
                    km: function() {
                        return i.k;
                    },
                    ti: function() {
                        return o.t;
                    }
                });
                var r = n(2206), o = n(9231), i = n(52);
            },
            9231: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    D: function() {
                        return b;
                    },
                    t: function() {
                        return g;
                    }
                });
                var r = n(885), o = n(5861), i = n(4687), a = n.n(i), u = n(9123), c = n(3983), s = n(3193), f = n(6718), l = n(5385), p = n(7659);
                function d(e1) {
                    if (!e1.clientId) throw new u.Z("A clientId must be specified in the OktaAuth constructor to get a token");
                    if (!e1.redirectUri) throw new u.Z("The redirectUri passed to /authorize must also be passed to /token");
                    if (!e1.authorizationCode && !e1.interactionCode) throw new u.Z("An authorization code (returned from /authorize) must be passed to /token");
                    if (!e1.codeVerifier) throw new u.Z('The "codeVerifier" (generated and saved by your app) must be passed to /token');
                }
                function h(e1, t) {
                    var n = (0, s.YY)({
                        client_id: t.clientId,
                        redirect_uri: t.redirectUri,
                        grant_type: t.interactionCode ? "interaction_code" : "authorization_code",
                        code_verifier: t.codeVerifier
                    });
                    t.interactionCode ? n.interaction_code = t.interactionCode : t.authorizationCode && (n.code = t.authorizationCode);
                    var r = e1.options.clientSecret;
                    return r && (n.client_secret = r), (0, f.UK)(n).slice(1);
                }
                function v(e1, t) {
                    return y.apply(this, arguments);
                }
                function y() {
                    return (y = (0, o.Z)(a().mark(function e1(t, n) {
                        var r, o, i, s, f, d, h, y, g, m, b;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = n.url, o = n.data, i = n.nonce, s = n.dpopKeyPair, f = "POST", d = {
                                        "Content-Type": "application/x-www-form-urlencoded"
                                    }, !t.options.dpop) {
                                        e1.next = 10;
                                        break;
                                    }
                                    if (s) {
                                        e1.next = 6;
                                        break;
                                    }
                                    throw new u.Z("DPoP is configured but no key pair was provided");
                                case 6:
                                    return e1.next = 8, (0, p.cE)({
                                        url: r,
                                        method: f,
                                        nonce: i,
                                        keyPair: s
                                    });
                                case 8:
                                    h = e1.sent, d.DPoP = h;
                                case 10:
                                    return e1.prev = 10, e1.next = 13, (0, l.c3)(t, {
                                        url: r,
                                        method: f,
                                        args: o,
                                        headers: d
                                    });
                                case 13:
                                    return y = e1.sent, e1.abrupt("return", y);
                                case 17:
                                    if (e1.prev = 17, e1.t0 = e1.catch(10), !(0, p.SO)(e1.t0) || i) {
                                        e1.next = 24;
                                        break;
                                    }
                                    if (m = null === (g = e1.t0.resp) || void 0 === g ? void 0 : g.headers["dpop-nonce"]) {
                                        e1.next = 23;
                                        break;
                                    }
                                    throw new c.Z({
                                        errorSummary: "No `dpop-nonce` header found when required"
                                    }, null !== (b = e1.t0.resp) && void 0 !== b ? b : void 0);
                                case 23:
                                    return e1.abrupt("return", v(t, {
                                        url: r,
                                        data: o,
                                        dpopKeyPair: s,
                                        nonce: m
                                    }));
                                case 24:
                                    throw e1.t0;
                                case 25:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                10,
                                17
                            ]
                        ]);
                    }))).apply(this, arguments);
                }
                function g(e1, t, n) {
                    return m.apply(this, arguments);
                }
                function m() {
                    return (m = (0, o.Z)(a().mark(function e1(t, n, r) {
                        var o, i;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return d(n), o = h(t, n), i = {
                                        url: r.tokenUrl,
                                        data: o,
                                        dpopKeyPair: null == n ? void 0 : n.dpopKeyPair
                                    }, e1.abrupt("return", v(t, i));
                                case 4:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function b(e1, t, n) {
                    return k.apply(this, arguments);
                }
                function k() {
                    return (k = (0, o.Z)(a().mark(function e1(t, n, o) {
                        var i, u, c;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return i = Object.entries({
                                        client_id: n.clientId,
                                        grant_type: "refresh_token",
                                        scope: o.scopes.join(" "),
                                        refresh_token: o.refreshToken
                                    }).map(function(e1) {
                                        var t = (0, r.Z)(e1, 2), n = t[0], o = t[1];
                                        return n + "=" + encodeURIComponent(o);
                                    }).join("&"), u = o.tokenUrl, n.extraParams && Object.keys(n.extraParams).length >= 1 && (u += (0, f.UK)(n.extraParams)), c = {
                                        url: u,
                                        data: i,
                                        dpopKeyPair: null == n ? void 0 : n.dpopKeyPair
                                    }, e1.abrupt("return", v(t, c));
                                case 5:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            52: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    E: function() {
                        return a;
                    },
                    k: function() {
                        return u;
                    }
                });
                var r = n(5385), o = n(3193), i = n(9123);
                function a(e1, t) {
                    var n = t || e1.options.issuer;
                    return (0, r.U2)(e1, n + "/.well-known/openid-configuration", {
                        cacheResponse: !0
                    });
                }
                function u(e1, t, n) {
                    var u = e1.storageManager.getHttpCache(e1.options.cookies);
                    return a(e1, t).then(function(t) {
                        var a = t.jwks_uri, c = u.getStorage()[a];
                        if (c && Date.now() / 1e3 < c.expiresAt) {
                            var s = (0, o.sE)(c.response.keys, {
                                kid: n
                            });
                            if (s) return s;
                        }
                        return u.clearStorage(a), (0, r.U2)(e1, a, {
                            cacheResponse: !0
                        }).then(function(e1) {
                            var t = (0, o.sE)(e1.keys, {
                                kid: n
                            });
                            if (t) return t;
                            throw new i.Z("The key id, " + n + ", was not found in the server's keys");
                        });
                    });
                }
            },
            8707: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    r: function() {
                        return p;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(7599), u = n(7756), c = n(3193), s = n(9231), f = n(8676), l = n(7659);
                function p(e1, t, n) {
                    return d.apply(this, arguments);
                }
                function d() {
                    return (d = (0, r.Z)(i().mark(function e1(t, n, r) {
                        var o, p, d, h, v, y, g, m, b, k, w, O, Z, T, E, P, S, x, A, R, _, j;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = r || (0, a.Fc)(t, n), n = Object.assign({}, (0, u.D)(t), (0, c.d9)(n)), p = (o = n).authorizationCode, d = o.interactionCode, h = o.codeVerifier, v = o.clientId, y = o.redirectUri, g = o.scopes, m = o.ignoreSignature, b = o.state, k = o.acrValues, w = o.dpop, O = o.dpopPairId, Z = o.extraParams, T = {
                                        clientId: v,
                                        redirectUri: y,
                                        authorizationCode: p,
                                        interactionCode: d,
                                        codeVerifier: h,
                                        dpop: w
                                    }, E = [
                                        "token"
                                    ], -1 !== g.indexOf("openid") && E.push("id_token"), P = {
                                        clientId: v,
                                        redirectUri: y,
                                        scopes: g,
                                        responseType: E,
                                        ignoreSignature: m,
                                        acrValues: k,
                                        extraParams: Z
                                    }, e1.prev = 7, !w) {
                                        e1.next = 26;
                                        break;
                                    }
                                    if (!O) {
                                        e1.next = 18;
                                        break;
                                    }
                                    return e1.next = 12, (0, l.lk)(O);
                                case 12:
                                    S = e1.sent, T.dpopKeyPair = S, P.dpop = w, P.dpopPairId = O, e1.next = 26;
                                    break;
                                case 18:
                                    return e1.next = 20, (0, l.vX)();
                                case 20:
                                    x = e1.sent, A = x.keyPair, R = x.keyPairId, T.dpopKeyPair = A, P.dpop = w, P.dpopPairId = R;
                                case 26:
                                    return e1.next = 28, (0, s.t)(t, T, r);
                                case 28:
                                    return _ = e1.sent, e1.next = 31, (0, f.s)(t, P, _, r);
                                case 31:
                                    return (j = e1.sent).code = p, j.state = b, e1.abrupt("return", j);
                                case 35:
                                    return e1.prev = 35, t.transactionManager.clear(), e1.finish(35);
                                case 38:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                7,
                                ,
                                35,
                                38
                            ]
                        ]);
                    }))).apply(this, arguments);
                }
            },
            5324: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $: function() {
                        return E;
                    },
                    o: function() {
                        return T;
                    }
                });
                var r = n(3548), o = n(1237), i = n(8707), a = n(6844), u = n(7625), c = n(9770), s = n(6803), f = n(5372), l = n(2476), p = n(6268), d = n(781), h = n(6466), v = n(8113), y = n(6898), g = n(8221), m = n(1260), b = n(3193), k = n(6757), w = n(8080), O = n(2206);
                function Z(e1, t) {
                    t = (0, b.d9)(t) || {};
                    var n = (0, k.U)(e1, t), r = (0, w.A)(e1, n), o = r.urls.authorizeUrl + (0, O.R)(n);
                    e1.transactionManager.save(r), e1.options.setLocation ? e1.options.setLocation(o) : window.location.assign(o);
                }
                function T(e1, t) {
                    var n = function(e1) {
                        return r.b.prototype.push.bind(t, e1, null);
                    }, b = n(s.H.bind(null, e1)), k = n(f.ko.bind(null, e1)), w = Object.assign(k, {
                        _getHistory: function() {
                            return window.history;
                        },
                        _getLocation: function() {
                            return window.location;
                        },
                        _getDocument: function() {
                            return window.document;
                        }
                    }), O = {
                        prepareTokenParams: y.wu.bind(null, e1),
                        exchangeCodeForTokens: i.r.bind(null, e1),
                        getWithoutPrompt: u.y.bind(null, e1),
                        getWithPopup: c.d.bind(null, e1),
                        getWithIDPPopup: c.y.bind(null, e1),
                        getWithRedirect: b,
                        parseFromUrl: w,
                        decode: o.T,
                        revoke: h.P.bind(null, e1),
                        renew: l.$.bind(null, e1),
                        renewTokensWithRefresh: d.R.bind(null, e1),
                        renewTokens: p.I.bind(null, e1),
                        getUserInfo: function(t, n) {
                            return (0, a.b)(e1, t, n);
                        },
                        verify: m.W.bind(null, e1),
                        isLoginRedirect: g.gM.bind(null, e1),
                        introspect: v.j.bind(null, e1)
                    };
                    return [
                        "getWithoutPrompt",
                        "getWithPopup",
                        "revoke",
                        "renew",
                        "renewTokensWithRefresh",
                        "renewTokens"
                    ].forEach(function(e1) {
                        O[e1] = n(O[e1]);
                    }), O;
                }
                function E(e1) {
                    return {
                        authorize: {
                            enrollAuthenticator: Z.bind(null, e1)
                        }
                    };
                }
            },
            231: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $V: function() {
                        return r.$;
                    },
                    zr: function() {
                        return s;
                    },
                    o5: function() {
                        return r.o;
                    }
                });
                var r = n(5324), o = n(9893), i = n(265), a = n(3980), u = n(279), c = n(2724);
                function s(e1, t, n) {
                    var r = (0, o.a)(t), s = (0, i.H)(r, e1), f = (0, u.A)(s), l = (0, a.Z)(f);
                    return (0, c.J)(l, n);
                }
            },
            3253: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    L: function() {
                        return s;
                    }
                });
                var r = n(7599), o = n(4970), i = n(9123), a = n(6898), u = n(2206), c = n(8676);
                function s(e1, t) {
                    if (arguments.length > 2) return Promise.reject(new i.Z('As of version 3.0, "getToken" takes only a single set of options'));
                    var n = (t = t || {}).popupWindow;
                    return t.popupWindow = void 0, (0, a.wu)(e1, t).then(function(a) {
                        var s, f;
                        switch(t.sessionToken ? Object.assign(a, {
                            prompt: "none",
                            responseMode: "okta_post_message",
                            display: null
                        }) : t.idp && Object.assign(a, {
                            display: "popup"
                        }), f = (0, r.Fc)(e1, a), s = (t.codeVerifier ? f.tokenUrl : f.authorizeUrl) + (0, u.R)(a), a.sessionToken || null === a.display ? "IFRAME" : "popup" === a.display ? t.idpPopup ? "IDP_POPUP" : "POPUP" : "IMPLICIT"){
                            case "IFRAME":
                                var l = (0, o.iC)(e1, t.timeout, a.state), p = (0, o.Rl)(s);
                                return l.then(function(t) {
                                    return (0, c.s)(e1, a, t, f);
                                }).finally(function() {
                                    var e1;
                                    document.body.contains(p) && (null === (e1 = p.parentElement) || void 0 === e1 || e1.removeChild(p));
                                });
                            case "POPUP":
                                var d;
                                if ("okta_post_message" === a.responseMode) {
                                    if (!e1.features.isPopupPostMessageSupported()) throw new i.Z("This browser doesn't have full postMessage support");
                                    d = (0, o.iC)(e1, t.timeout, a.state);
                                }
                                return n && n.location.assign(s), new Promise(function(e1, t) {
                                    var r = setInterval(function() {
                                        n && !n.closed || (clearInterval(r), t(new i.Z("Unable to parse OAuth flow response")));
                                    }, 100);
                                    d.then(function(t) {
                                        clearInterval(r), e1(t);
                                    }).catch(function(e1) {
                                        clearInterval(r), t(e1);
                                    });
                                }).then(function(t) {
                                    return (0, c.s)(e1, a, t, f);
                                }).finally(function() {
                                    n && !n.closed && n.close();
                                });
                            case "IDP_POPUP":
                                var h = (0, o.It)(e1, t.timeout, t.channel, a.state);
                                if (!n) throw new i.Z("Unable to open popup window");
                                return n.location.assign(s), h.then(function(t) {
                                    return (0, c.s)(e1, a, t, f);
                                });
                            default:
                                throw new i.Z("The full page redirect flow is not supported");
                        }
                    });
                }
            },
            6844: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    b: function() {
                        return v;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(9123), c = n(3114), s = n(2886), f = n(3983), l = n(5385), p = n(6488);
                function d(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function h(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? d(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function v(e1, t, n) {
                    return y.apply(this, arguments);
                }
                function y() {
                    return (y = (0, o.Z)(a().mark(function e1(t, n, r) {
                        var o, i;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n) {
                                        e1.next = 4;
                                        break;
                                    }
                                    return e1.next = 3, t.tokenManager.getTokens();
                                case 3:
                                    n = e1.sent.accessToken;
                                case 4:
                                    if (r) {
                                        e1.next = 8;
                                        break;
                                    }
                                    return e1.next = 7, t.tokenManager.getTokens();
                                case 7:
                                    r = e1.sent.idToken;
                                case 8:
                                    if (n && (0, p.hv)(n)) {
                                        e1.next = 10;
                                        break;
                                    }
                                    return e1.abrupt("return", Promise.reject(new u.Z("getUserInfo requires an access token object")));
                                case 10:
                                    if (r && (0, p.sI)(r)) {
                                        e1.next = 12;
                                        break;
                                    }
                                    return e1.abrupt("return", Promise.reject(new u.Z("getUserInfo requires an ID token object")));
                                case 12:
                                    if (o = {
                                        url: n.userinfoUrl,
                                        method: "GET",
                                        accessToken: n.accessToken
                                    }, !t.options.dpop) {
                                        e1.next = 19;
                                        break;
                                    }
                                    return e1.next = 16, t.getDPoPAuthorizationHeaders(h(h({}, o), {}, {
                                        accessToken: n
                                    }));
                                case 16:
                                    i = e1.sent, o.headers = i, delete o.accessToken;
                                case 19:
                                    return e1.abrupt("return", (0, l.c3)(t, o).then(function(e1) {
                                        return e1.sub === r.claims.sub ? e1 : Promise.reject(new u.Z("getUserInfo request was rejected due to token mismatch"));
                                    }).catch(function(e1) {
                                        if (e1 instanceof c.Z && !t.options.dpop) {
                                            var n = e1.error, r = e1.errorDescription;
                                            throw new s.Z(n, r);
                                        }
                                        if (!t.options.dpop) {
                                            var o, i = e1;
                                            if (e1 instanceof f.Z && null != e1 && null !== (o = e1.meta) && void 0 !== o && o.wwwAuthHeader && (i = c.Z.parseHeader(e1.meta.wwwAuthHeader)), i instanceof c.Z) {
                                                var a = i, u = a.error, l = a.errorDescription;
                                                throw new s.Z(u, l);
                                            }
                                        }
                                        throw e1;
                                    }));
                                case 20:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            9770: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    d: function() {
                        return f;
                    },
                    y: function() {
                        return l;
                    }
                });
                var r = n(4925), o = n(9123), i = n(3193), a = n(3253), u = n(4970), c = n(7599), s = [
                    "initialPath"
                ];
                function f(e1, t) {
                    if (arguments.length > 2) return Promise.reject(new o.Z('As of version 3.0, "getWithPopup" takes only a single set of options'));
                    var n = t, c = n.initialPath, f = (0, r.Z)(n, s), l = (0, u.pU)(null != c ? c : "/", f);
                    return t = (0, i.d9)(f) || {}, Object.assign(f, {
                        display: "popup",
                        responseMode: "okta_post_message",
                        popupWindow: l
                    }), (0, a.L)(e1, f);
                }
                function l(e1, t) {
                    try {
                        if (!BroadcastChannel) throw new o.Z("Modern browser with `BroadcastChannel` support is required to use this method");
                        if (!t.redirectUri) throw new o.Z("`redirectUri` is a required param for `getWithIDPPopup`");
                        t.state || (t.state = (0, c.aV)());
                        var n, r = (0, u.pU)("/", t), s = new BroadcastChannel("popup-callback:".concat(t.state));
                        return t = (0, i.d9)(t) || {}, Object.assign(t, {
                            display: "popup",
                            responseMode: "query",
                            popupWindow: r,
                            idpPopup: !0,
                            channel: s
                        }), {
                            promise: new Promise(function(r, o) {
                                return n = o, (0, a.L)(e1, t).then(function(e1) {
                                    return r(e1);
                                }).catch(function(e1) {
                                    return o(e1);
                                });
                            }),
                            cancel: function() {
                                s.close(), n(new o.Z("Popup flow canceled"));
                            }
                        };
                    } catch (e1) {
                        return {
                            promise: Promise.reject(e1),
                            cancel: function() {}
                        };
                    }
                }
            },
            6803: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    H: function() {
                        return l;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(3193), c = n(6898), s = n(2865), f = n(2206);
                function l(e1, t) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return p = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, l, p = arguments;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (!(p.length > 2)) {
                                        e1.next = 2;
                                        break;
                                    }
                                    return e1.abrupt("return", Promise.reject(new a.Z('As of version 3.0, "getWithRedirect" takes only a single set of options')));
                                case 2:
                                    return n = (0, u.d9)(n) || {}, e1.next = 5, (0, c.wu)(t, n);
                                case 5:
                                    r = e1.sent, o = (0, s.H)(t, r), l = o.urls.authorizeUrl + (0, f.R)(r), t.transactionManager.save(o), t.options.setLocation ? t.options.setLocation(l) : window.location.assign(l);
                                case 10:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), p.apply(this, arguments);
                }
            },
            7625: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    y: function() {
                        return a;
                    }
                });
                var r = n(9123), o = n(3193), i = n(3253);
                function a(e1, t) {
                    return arguments.length > 2 ? Promise.reject(new r.Z('As of version 3.0, "getWithoutPrompt" takes only a single set of options')) : (t = (0, o.d9)(t) || {}, Object.assign(t, {
                        prompt: "none",
                        responseMode: "okta_post_message",
                        display: null
                    }), (0, i.L)(e1, t));
                }
            },
            8676: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    s: function() {
                        return d;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(3193), u = n(7599), c = n(2886), s = n(9123), f = n(1260), l = n(7756);
                function p(e1, t) {
                    if (e1.error && e1.error_description) throw new c.Z(e1.error, e1.error_description);
                    if (e1.state !== t.state) throw new s.Z("OAuth flow response state doesn't match request state");
                }
                function d(e1, t, n, r) {
                    return h.apply(this, arguments);
                }
                function h() {
                    return (h = (0, r.Z)(i().mark(function e1(t, n, r, o) {
                        var c, d, h, v, y, g, m, b, k, w, O, Z, T, E, P, S, x;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (c = !1 !== t.options.pkce, n = n || (0, l.D)(t), p(r, n), !c || !r.code && !r.interaction_code) {
                                        e1.next = 5;
                                        break;
                                    }
                                    return e1.abrupt("return", t.token.exchangeCodeForTokens(Object.assign({}, n, {
                                        authorizationCode: r.code,
                                        interactionCode: r.interaction_code
                                    }), o));
                                case 5:
                                    if (o = o || (0, u.Fc)(t, n), d = n.responseType || [], Array.isArray(d) || "none" === d || (d = [
                                        d
                                    ]), h = r.scope ? r.scope.split(" ") : (0, a.d9)(n.scopes), v = n.clientId || t.options.clientId, !n.dpop) {
                                        e1.next = 14;
                                        break;
                                    }
                                    if ((null !== (y = null === (g = t.options) || void 0 === g ? void 0 : g.dpopOptions) && void 0 !== y ? y : {
                                        allowBearerTokens: !1
                                    }).allowBearerTokens || "DPoP" === r.token_type) {
                                        e1.next = 14;
                                        break;
                                    }
                                    throw new s.Z('Unable to parse OAuth flow response: DPoP was configured but "token_type" was not DPoP');
                                case 14:
                                    if (m = {}, b = r.expires_in, k = r.token_type, w = r.access_token, O = r.id_token, Z = r.refresh_token, T = Math.floor(Date.now() / 1e3), w && (E = t.token.decode(w), m.accessToken = {
                                        accessToken: w,
                                        claims: E.payload,
                                        expiresAt: Number(b) + T,
                                        tokenType: k,
                                        scopes: h,
                                        authorizeUrl: o.authorizeUrl,
                                        userinfoUrl: o.userinfoUrl
                                    }, n.dpopPairId && (m.accessToken.dpopPairId = n.dpopPairId), n.extraParams && (m.accessToken.extraParams = n.extraParams)), Z && (m.refreshToken = {
                                        refreshToken: Z,
                                        expiresAt: Number(b) + T,
                                        scopes: h,
                                        tokenUrl: o.tokenUrl,
                                        authorizeUrl: o.authorizeUrl,
                                        issuer: o.issuer
                                    }, n.dpopPairId && (m.refreshToken.dpopPairId = n.dpopPairId), n.extraParams && (m.refreshToken.extraParams = n.extraParams)), !O) {
                                        e1.next = 32;
                                        break;
                                    }
                                    return P = t.token.decode(O), S = {
                                        idToken: O,
                                        claims: P.payload,
                                        expiresAt: P.payload.exp - P.payload.iat + T,
                                        scopes: h,
                                        authorizeUrl: o.authorizeUrl,
                                        issuer: o.issuer,
                                        clientId: v
                                    }, n.extraParams && (S.extraParams = n.extraParams), x = {
                                        clientId: v,
                                        issuer: o.issuer,
                                        nonce: n.nonce,
                                        accessToken: w,
                                        acrValues: n.acrValues
                                    }, void 0 !== n.ignoreSignature && (x.ignoreSignature = n.ignoreSignature), e1.next = 31, (0, f.W)(t, S, x);
                                case 31:
                                    m.idToken = S;
                                case 32:
                                    if (-1 === d.indexOf("token") || m.accessToken) {
                                        e1.next = 34;
                                        break;
                                    }
                                    throw new s.Z('Unable to parse OAuth flow response: response type "token" was requested but "access_token" was not returned.');
                                case 34:
                                    if (-1 === d.indexOf("id_token") || m.idToken) {
                                        e1.next = 36;
                                        break;
                                    }
                                    throw new s.Z('Unable to parse OAuth flow response: response type "id_token" was requested but "id_token" was not returned.');
                                case 36:
                                    return e1.abrupt("return", {
                                        tokens: m,
                                        state: r.state,
                                        code: r.code,
                                        responseType: d
                                    });
                                case 37:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            9443: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    TokenManager: function() {
                        return l.M;
                    },
                    addIDPPopupLisenter: function() {
                        return d.It;
                    },
                    addListener: function() {
                        return d.NH;
                    },
                    addPostMessageListener: function() {
                        return d.iC;
                    },
                    assertPKCESupport: function() {
                        return d.vz;
                    },
                    buildAuthorizeParams: function() {
                        return a.R0;
                    },
                    convertTokenParamsToOAuthParams: function() {
                        return a._6;
                    },
                    createEndpoints: function() {
                        return r.$V;
                    },
                    createEnrollAuthenticatorMeta: function() {
                        return d.AW;
                    },
                    createOAuthMeta: function() {
                        return d.H;
                    },
                    createOAuthOptionsConstructor: function() {
                        return u.m;
                    },
                    createOAuthStorageManager: function() {
                        return i.a;
                    },
                    createOktaAuthOAuth: function() {
                        return r.zr;
                    },
                    createTokenAPI: function() {
                        return r.o5;
                    },
                    createTransactionManager: function() {
                        return p.P;
                    },
                    decodeToken: function() {
                        return h.T;
                    },
                    exchangeCodeForTokens: function() {
                        return O.r;
                    },
                    generateNonce: function() {
                        return d.PY;
                    },
                    generateState: function() {
                        return d.aV;
                    },
                    getDefaultEnrollAuthenticatorParams: function() {
                        return d.cE;
                    },
                    getDefaultTokenParams: function() {
                        return d.Dx;
                    },
                    getHashOrSearch: function() {
                        return d.O2;
                    },
                    getKey: function() {
                        return a.km;
                    },
                    getOAuthBaseUrl: function() {
                        return d.zf;
                    },
                    getOAuthDomain: function() {
                        return d.Xp;
                    },
                    getOAuthUrls: function() {
                        return d.Fc;
                    },
                    getToken: function() {
                        return Z.L;
                    },
                    getUserInfo: function() {
                        return k.b;
                    },
                    getWellKnown: function() {
                        return a.ES;
                    },
                    getWithIDPPopup: function() {
                        return E.y;
                    },
                    getWithPopup: function() {
                        return E.d;
                    },
                    getWithRedirect: function() {
                        return P.H;
                    },
                    getWithoutPrompt: function() {
                        return T.y;
                    },
                    handleOAuthResponse: function() {
                        return w.s;
                    },
                    hasAuthorizationCode: function() {
                        return d.ZP;
                    },
                    hasErrorInUrl: function() {
                        return d.hg;
                    },
                    hasInteractionCode: function() {
                        return d.d_;
                    },
                    hasResponseType: function() {
                        return d.wV;
                    },
                    hasTokensInHash: function() {
                        return d.kU;
                    },
                    isAuthorizationCodeError: function() {
                        return d.tC;
                    },
                    isCodeFlow: function() {
                        return d.Ik;
                    },
                    isInteractionRequired: function() {
                        return d.wc;
                    },
                    isInteractionRequiredError: function() {
                        return d.Cf;
                    },
                    isLoginRedirect: function() {
                        return d.gM;
                    },
                    isRedirectUri: function() {
                        return d.Qs;
                    },
                    isRefreshTokenError: function() {
                        return d.Yo;
                    },
                    isRefreshTokenInvalidError: function() {
                        return d.$E;
                    },
                    isSameRefreshToken: function() {
                        return d.q0;
                    },
                    loadFrame: function() {
                        return d.Rl;
                    },
                    loadPopup: function() {
                        return d.pU;
                    },
                    mixinOAuth: function() {
                        return o.J;
                    },
                    oidcIntrospect: function() {
                        return x.j;
                    },
                    parseFromUrl: function() {
                        return S.ko;
                    },
                    pkce: function() {
                        return d.U5;
                    },
                    postRefreshToken: function() {
                        return a.Dp;
                    },
                    postToTokenEndpoint: function() {
                        return a.ti;
                    },
                    prepareEnrollAuthenticatorParams: function() {
                        return d.Uc;
                    },
                    preparePKCE: function() {
                        return d.mi;
                    },
                    prepareTokenParams: function() {
                        return d.wu;
                    },
                    removeListener: function() {
                        return d.ys;
                    },
                    renewToken: function() {
                        return y.$;
                    },
                    renewTokens: function() {
                        return m.I;
                    },
                    renewTokensWithRefresh: function() {
                        return g.R;
                    },
                    revokeToken: function() {
                        return v.P;
                    },
                    urlParamsToObject: function() {
                        return d.vL;
                    },
                    validateClaims: function() {
                        return d.pj;
                    },
                    validateCodeChallengeMethod: function() {
                        return d.br;
                    },
                    validateToken: function() {
                        return d.Rp;
                    },
                    verifyToken: function() {
                        return b.W;
                    }
                });
                var r = n(231), o = n(2724), i = n(2333), a = n(2642), u = n(3775), c = n(8927), s = {};
                for(var f in c)[
                    "default",
                    "decodeToken",
                    "revokeToken",
                    "renewToken",
                    "renewTokensWithRefresh",
                    "renewTokens",
                    "verifyToken",
                    "getUserInfo",
                    "handleOAuthResponse",
                    "exchangeCodeForTokens",
                    "getToken",
                    "getWithoutPrompt",
                    "getWithPopup",
                    "getWithIDPPopup",
                    "getWithRedirect",
                    "parseFromUrl",
                    "oidcIntrospect",
                    "createEndpoints",
                    "createOktaAuthOAuth",
                    "createTokenAPI",
                    "mixinOAuth",
                    "createOAuthStorageManager",
                    "buildAuthorizeParams",
                    "convertTokenParamsToOAuthParams",
                    "getKey",
                    "getWellKnown",
                    "postRefreshToken",
                    "postToTokenEndpoint",
                    "createOAuthOptionsConstructor"
                ].indexOf(f) < 0 && (s[f] = (function(e1) {
                    return c[e1];
                }).bind(0, f));
                n.d(t, s);
                var l = n(2427), p = n(1646), d = n(8785), h = n(1237), v = n(6466), y = n(2476), g = n(781), m = n(6268), b = n(1260), k = n(6844), w = n(8676), O = n(8707), Z = n(3253), T = n(7625), E = n(9770), P = n(6803), S = n(5372), x = n(8113);
            },
            8113: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    j: function() {
                        return d;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(52), c = n(5385), s = n(6718), f = n(7594), l = n(6488), p = {
                    accessToken: "access_token",
                    idToken: "id_token",
                    refreshToken: "refresh_token"
                };
                function d(e1, t, n) {
                    return h.apply(this, arguments);
                }
                function h() {
                    return (h = (0, r.Z)(i().mark(function e1(t, n, r) {
                        var o, d, h, v, y, g, m, b, k, w;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (d = t.options.clientId, h = t.options.clientSecret, r || (r = t.tokenManager.getTokens()[n]), r) {
                                        e1.next = 5;
                                        break;
                                    }
                                    throw new a.Z("unable to find ".concat(n, " in storage or fn params"));
                                case 5:
                                    if (o = (o = n !== l.T6.ACCESS ? null === (v = r) || void 0 === v ? void 0 : v.issuer : null === (y = r) || void 0 === y || null === (g = y.claims) || void 0 === g ? void 0 : g.iss) || t.options.issuer, d) {
                                        e1.next = 9;
                                        break;
                                    }
                                    throw new a.Z("A clientId must be specified in the OktaAuth constructor to introspect a token");
                                case 9:
                                    if (o) {
                                        e1.next = 11;
                                        break;
                                    }
                                    throw new a.Z("Unable to find issuer");
                                case 11:
                                    return e1.next = 13, (0, u.E)(t, o);
                                case 13:
                                    return m = e1.sent, b = m.introspection_endpoint, k = h ? (0, f.r3)("".concat(d, ":").concat(h)) : (0, f.r3)(d), w = (0, s.UK)({
                                        token_type_hint: p[n],
                                        token: r[n]
                                    }).slice(1), e1.abrupt("return", (0, c.v_)(t, b, w, {
                                        headers: {
                                            "Content-Type": "application/x-www-form-urlencoded",
                                            Authorization: "Basic " + k
                                        }
                                    }));
                                case 18:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            2724: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    J: function() {
                        return j;
                    }
                });
                var r = n(4925), o = n(5861), i = n(5671), a = n(3144), u = n(7326), c = n(1752), s = n(136), f = n(2963), l = n(1120), p = n(4942), d = n(4687), h = n.n(d), v = n(5385), y = n(3548), g = n(4771), m = n(9718), b = n(3611), k = n(5324), w = n(2427), O = n(8221), Z = n(7599), T = n(7659), E = n(9123), P = n(3114), S = n(1971), x = n(4858);
                var A = [
                    "originalUri"
                ];
                function R(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function _(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? R(Object(n), !0).forEach(function(t) {
                            (0, p.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : R(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function j(e1, t) {
                    var n, d = function(e1) {
                        (0, s.Z)(o, e1);
                        var t, n, r = (t = o, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, l.Z)(t);
                            if (n) {
                                var o = (0, l.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, f.Z)(this, e1);
                        });
                        function o() {
                            return (0, i.Z)(this, o), r.apply(this, arguments);
                        }
                        return (0, a.Z)(o, [
                            {
                                key: "setOriginalUri",
                                value: function(e1, t) {
                                    x.Z.getSessionStorage().setItem(S.REFERRER_PATH_STORAGE_KEY, e1), (t = t || this.options.state) && this.storageManager.getOriginalUriStorage().setItem(t, e1);
                                }
                            },
                            {
                                key: "getOriginalUri",
                                value: function(e1) {
                                    if (e1 = e1 || this.options.state) {
                                        var t = this.storageManager.getOriginalUriStorage().getItem(e1);
                                        if (t) return t;
                                    }
                                    var n = x.Z.getSessionStorage();
                                    return n && n.getItem(S.REFERRER_PATH_STORAGE_KEY) || void 0;
                                }
                            },
                            {
                                key: "removeOriginalUri",
                                value: function(e1) {
                                    if (x.Z.getSessionStorage().removeItem(S.REFERRER_PATH_STORAGE_KEY), e1 = e1 || this.options.state) {
                                        var t = this.storageManager.getOriginalUriStorage();
                                        t.removeItem && t.removeItem(e1);
                                    }
                                }
                            }
                        ]), o;
                    }(e1);
                    return n = function(e1) {
                        (0, s.Z)(H, e1);
                        var n, d, m, S, x, R, j, C, I, D, M, N, U, L = (N = H, U = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, t = (0, l.Z)(N);
                            if (U) {
                                var n = (0, l.Z)(this).constructor;
                                e1 = Reflect.construct(t, arguments, n);
                            } else e1 = t.apply(this, arguments);
                            return (0, f.Z)(this, e1);
                        });
                        function H() {
                            var e1;
                            (0, i.Z)(this, H);
                            for(var n = arguments.length, r = new Array(n), o = 0; o < n; o++)r[o] = arguments[o];
                            return e1 = L.call.apply(L, [
                                this
                            ].concat(r)), (0, p.Z)((0, u.Z)(e1), "token", void 0), (0, p.Z)((0, u.Z)(e1), "tokenManager", void 0), (0, p.Z)((0, u.Z)(e1), "transactionManager", void 0), (0, p.Z)((0, u.Z)(e1), "pkce", void 0), (0, p.Z)((0, u.Z)(e1), "endpoints", void 0), (0, p.Z)((0, u.Z)(e1), "_pending", void 0), (0, p.Z)((0, u.Z)(e1), "_tokenQueue", void 0), e1.transactionManager = new t(Object.assign({
                                storageManager: e1.storageManager
                            }, e1.options.transactionManager)), e1.pkce = {
                                DEFAULT_CODE_CHALLENGE_METHOD: b.Z.DEFAULT_CODE_CHALLENGE_METHOD,
                                generateVerifier: b.Z.generateVerifier,
                                computeChallenge: b.Z.computeChallenge
                            }, e1._pending = {
                                handleLogin: !1
                            }, e1._tokenQueue = new y.b, e1.token = (0, k.o)((0, u.Z)(e1), e1._tokenQueue), e1.tokenManager = new w.M((0, u.Z)(e1), e1.options.tokenManager), e1.endpoints = (0, k.$)((0, u.Z)(e1)), e1;
                        }
                        return (0, a.Z)(H, [
                            {
                                key: "clearStorage",
                                value: function() {
                                    (0, c.Z)((0, l.Z)(H.prototype), "clearStorage", this).call(this), this.tokenManager.clear();
                                }
                            },
                            {
                                key: "isAuthenticated",
                                value: (M = (0, o.Z)(h().mark(function e1() {
                                    var t, n, r, o, i, a, u, c, s, f, l = arguments;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t = l.length > 0 && void 0 !== l[0] ? l[0] : {}, n = this.tokenManager.getOptions(), r = n.autoRenew, o = n.autoRemove, i = t.onExpiredToken ? "renew" === t.onExpiredToken : r, a = t.onExpiredToken ? "remove" === t.onExpiredToken : o, u = this.tokenManager.getTokensSync(), !(c = u.accessToken) || !this.tokenManager.hasExpired(c)) {
                                                    e1.next = 19;
                                                    break;
                                                }
                                                if (c = void 0, !i) {
                                                    e1.next = 18;
                                                    break;
                                                }
                                                return e1.prev = 8, e1.next = 11, this.tokenManager.renew("accessToken");
                                            case 11:
                                                c = e1.sent, e1.next = 16;
                                                break;
                                            case 14:
                                                e1.prev = 14, e1.t0 = e1.catch(8);
                                            case 16:
                                                e1.next = 19;
                                                break;
                                            case 18:
                                                a && this.tokenManager.remove("accessToken");
                                            case 19:
                                                if (s = this.tokenManager.getTokensSync(), !(f = s.idToken) || !this.tokenManager.hasExpired(f)) {
                                                    e1.next = 34;
                                                    break;
                                                }
                                                if (f = void 0, !i) {
                                                    e1.next = 33;
                                                    break;
                                                }
                                                return e1.prev = 23, e1.next = 26, this.tokenManager.renew("idToken");
                                            case 26:
                                                f = e1.sent, e1.next = 31;
                                                break;
                                            case 29:
                                                e1.prev = 29, e1.t1 = e1.catch(23);
                                            case 31:
                                                e1.next = 34;
                                                break;
                                            case 33:
                                                a && this.tokenManager.remove("idToken");
                                            case 34:
                                                return e1.abrupt("return", !(!c || !f));
                                            case 35:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this, [
                                        [
                                            8,
                                            14
                                        ],
                                        [
                                            23,
                                            29
                                        ]
                                    ]);
                                })), function() {
                                    return M.apply(this, arguments);
                                })
                            },
                            {
                                key: "signInWithRedirect",
                                value: (D = (0, o.Z)(h().mark(function e1() {
                                    var t, n, o, i, a = arguments;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (n = (t = a.length > 0 && void 0 !== a[0] ? a[0] : {}).originalUri, o = (0, r.Z)(t, A), !this._pending.handleLogin) {
                                                    e1.next = 4;
                                                    break;
                                                }
                                                return e1.abrupt("return");
                                            case 4:
                                                return this._pending.handleLogin = !0, e1.prev = 5, n && this.setOriginalUri(n), i = Object.assign({
                                                    scopes: this.options.scopes || [
                                                        "openid",
                                                        "email",
                                                        "profile"
                                                    ]
                                                }, o), e1.next = 10, this.token.getWithRedirect(i);
                                            case 10:
                                                return e1.prev = 10, this._pending.handleLogin = !1, e1.finish(10);
                                            case 13:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this, [
                                        [
                                            5,
                                            ,
                                            10,
                                            13
                                        ]
                                    ]);
                                })), function() {
                                    return D.apply(this, arguments);
                                })
                            },
                            {
                                key: "getUser",
                                value: (I = (0, o.Z)(h().mark(function e1() {
                                    var t, n, r;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return t = this.tokenManager.getTokensSync(), n = t.idToken, r = t.accessToken, e1.abrupt("return", this.token.getUserInfo(r, n));
                                            case 2:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function() {
                                    return I.apply(this, arguments);
                                })
                            },
                            {
                                key: "getIdToken",
                                value: function() {
                                    var e1 = this.tokenManager.getTokensSync().idToken;
                                    return e1 ? e1.idToken : void 0;
                                }
                            },
                            {
                                key: "getAccessToken",
                                value: function() {
                                    var e1 = this.tokenManager.getTokensSync().accessToken;
                                    return e1 ? e1.accessToken : void 0;
                                }
                            },
                            {
                                key: "getRefreshToken",
                                value: function() {
                                    var e1 = this.tokenManager.getTokensSync().refreshToken;
                                    return e1 ? e1.refreshToken : void 0;
                                }
                            },
                            {
                                key: "getOrRenewAccessToken",
                                value: (C = (0, o.Z)(h().mark(function e1() {
                                    var t, n, r, o, i;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t = this.tokenManager.getTokensSync(), !(n = t.accessToken) || this.tokenManager.hasExpired(n)) {
                                                    e1.next = 3;
                                                    break;
                                                }
                                                return e1.abrupt("return", n.accessToken);
                                            case 3:
                                                return e1.prev = 3, o = this.tokenManager.getStorageKeyByType("accessToken"), e1.next = 7, this.tokenManager.renew(null != o ? o : "accessToken");
                                            case 7:
                                                return i = e1.sent, e1.abrupt("return", null !== (r = null == i ? void 0 : i.accessToken) && void 0 !== r ? r : null);
                                            case 11:
                                                return e1.prev = 11, e1.t0 = e1.catch(3), this.emitter.emit("error", e1.t0), e1.abrupt("return", null);
                                            case 15:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this, [
                                        [
                                            3,
                                            11
                                        ]
                                    ]);
                                })), function() {
                                    return C.apply(this, arguments);
                                })
                            },
                            {
                                key: "storeTokensFromRedirect",
                                value: (j = (0, o.Z)(h().mark(function e1() {
                                    var t, n;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                return e1.next = 2, this.token.parseFromUrl();
                                            case 2:
                                                t = e1.sent, n = t.tokens, "none" !== t.responseType && this.tokenManager.setTokens(n);
                                            case 6:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function() {
                                    return j.apply(this, arguments);
                                })
                            },
                            {
                                key: "isLoginRedirect",
                                value: function() {
                                    return (0, O.gM)(this);
                                }
                            },
                            {
                                key: "isPKCE",
                                value: function() {
                                    return !!this.options.pkce;
                                }
                            },
                            {
                                key: "hasResponseType",
                                value: function(e1) {
                                    return (0, O.wV)(e1, this.options);
                                }
                            },
                            {
                                key: "isAuthorizationCodeFlow",
                                value: function() {
                                    return this.hasResponseType("code");
                                }
                            },
                            {
                                key: "invokeApiMethod",
                                value: (R = (0, o.Z)(h().mark(function e1(t) {
                                    var n;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t.accessToken) {
                                                    e1.next = 5;
                                                    break;
                                                }
                                                return e1.next = 3, this.tokenManager.getTokens();
                                            case 3:
                                                n = e1.sent.accessToken, t.accessToken = null == n ? void 0 : n.accessToken;
                                            case 5:
                                                return e1.abrupt("return", (0, v.c3)(this, t));
                                            case 6:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return R.apply(this, arguments);
                                })
                            },
                            {
                                key: "revokeAccessToken",
                                value: (x = (0, o.Z)(h().mark(function e1(t) {
                                    var n, r;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t) {
                                                    e1.next = 10;
                                                    break;
                                                }
                                                return e1.next = 3, this.tokenManager.getTokens();
                                            case 3:
                                                if (n = e1.sent, t = n.accessToken, r = this.tokenManager.getStorageKeyByType("accessToken"), this.tokenManager.remove(r), !this.options.dpop) {
                                                    e1.next = 10;
                                                    break;
                                                }
                                                return e1.next = 10, (0, T.ao)("access", n);
                                            case 10:
                                                if (t) {
                                                    e1.next = 12;
                                                    break;
                                                }
                                                return e1.abrupt("return", Promise.resolve(null));
                                            case 12:
                                                return e1.abrupt("return", this.token.revoke(t));
                                            case 13:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return x.apply(this, arguments);
                                })
                            },
                            {
                                key: "revokeRefreshToken",
                                value: (S = (0, o.Z)(h().mark(function e1(t) {
                                    var n, r;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t) {
                                                    e1.next = 10;
                                                    break;
                                                }
                                                return e1.next = 3, this.tokenManager.getTokens();
                                            case 3:
                                                if (n = e1.sent, t = n.refreshToken, r = this.tokenManager.getStorageKeyByType("refreshToken"), this.tokenManager.remove(r), !this.options.dpop) {
                                                    e1.next = 10;
                                                    break;
                                                }
                                                return e1.next = 10, (0, T.ao)("refresh", n);
                                            case 10:
                                                if (t) {
                                                    e1.next = 12;
                                                    break;
                                                }
                                                return e1.abrupt("return", Promise.resolve(null));
                                            case 12:
                                                return e1.abrupt("return", this.token.revoke(t));
                                            case 13:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return S.apply(this, arguments);
                                })
                            },
                            {
                                key: "getSignOutRedirectUrl",
                                value: function() {
                                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e1.idToken, n = e1.postLogoutRedirectUri, r = e1.state;
                                    if (t || (t = this.tokenManager.getTokensSync().idToken), !t) return "";
                                    void 0 === n && (n = this.options.postLogoutRedirectUri);
                                    var o = (0, Z.Fc)(this).logoutUrl, i = t.idToken, a = o + "?id_token_hint=" + encodeURIComponent(i);
                                    return n && (a += "&post_logout_redirect_uri=" + encodeURIComponent(n)), r && (a += "&state=" + encodeURIComponent(r)), a;
                                }
                            },
                            {
                                key: "signOut",
                                value: (m = (0, o.Z)(h().mark(function e1(t) {
                                    var n, r, o, i, a, u, c, s, f, l, p, d, v, y, g, m;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (t = Object.assign({}, t), a = window.location.origin, u = window.location.href, c = null === t.postLogoutRedirectUri ? null : t.postLogoutRedirectUri || this.options.postLogoutRedirectUri || a, s = null === (n = t) || void 0 === n ? void 0 : n.state, f = t.accessToken, l = t.refreshToken, p = !1 !== t.revokeAccessToken, (d = !1 !== t.revokeRefreshToken) && void 0 === l && (l = this.tokenManager.getTokensSync().refreshToken), p && void 0 === f && (f = this.tokenManager.getTokensSync().accessToken), t.idToken || (t.idToken = this.tokenManager.getTokensSync().idToken), !d || !l) {
                                                    e1.next = 15;
                                                    break;
                                                }
                                                return e1.next = 15, this.revokeRefreshToken(l);
                                            case 15:
                                                if (!p || !f) {
                                                    e1.next = 18;
                                                    break;
                                                }
                                                return e1.next = 18, this.revokeAccessToken(f);
                                            case 18:
                                                if (v = null !== (r = null === (o = f) || void 0 === o ? void 0 : o.dpopPairId) && void 0 !== r ? r : null === (i = l) || void 0 === i ? void 0 : i.dpopPairId, !this.options.dpop || !v) {
                                                    e1.next = 22;
                                                    break;
                                                }
                                                return e1.next = 22, (0, T.sd)(v);
                                            case 22:
                                                if (y = this.getSignOutRedirectUrl(_(_({}, t), {}, {
                                                    postLogoutRedirectUri: c
                                                }))) {
                                                    e1.next = 33;
                                                    break;
                                                }
                                                return e1.next = 26, this.closeSession();
                                            case 26:
                                                return g = e1.sent, m = new URL(c || a), s && m.searchParams.append("state", s), c === u ? window.location.href = m.href : window.location.assign(m.href), e1.abrupt("return", g);
                                            case 33:
                                                return t.clearTokensBeforeRedirect ? this.tokenManager.clear() : this.tokenManager.addPendingRemoveFlags(), window.location.assign(y), e1.abrupt("return", !0);
                                            case 36:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return m.apply(this, arguments);
                                })
                            },
                            {
                                key: "getDPoPAuthorizationHeaders",
                                value: (d = (0, o.Z)(h().mark(function e1(t) {
                                    var n, r, o, i;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (this.options.dpop) {
                                                    e1.next = 2;
                                                    break;
                                                }
                                                throw new E.Z("DPoP is not configured for this client instance");
                                            case 2:
                                                if ((r = t.accessToken) || (r = this.tokenManager.getTokensSync().accessToken), r) {
                                                    e1.next = 6;
                                                    break;
                                                }
                                                throw new E.Z("AccessToken is required to generate a DPoP Proof");
                                            case 6:
                                                return e1.next = 8, (0, T.lk)(null === (n = r) || void 0 === n ? void 0 : n.dpopPairId);
                                            case 8:
                                                return o = e1.sent, e1.next = 11, (0, T.aW)(_(_({}, t), {}, {
                                                    keyPair: o,
                                                    accessToken: r.accessToken
                                                }));
                                            case 11:
                                                return i = e1.sent, e1.abrupt("return", {
                                                    Authorization: "DPoP ".concat(r.accessToken),
                                                    Dpop: i
                                                });
                                            case 13:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function(e1) {
                                    return d.apply(this, arguments);
                                })
                            },
                            {
                                key: "clearDPoPStorage",
                                value: (n = (0, o.Z)(h().mark(function e1() {
                                    var t, n, r, o, i = arguments;
                                    return h().wrap(function(e1) {
                                        for(;;)switch(e1.prev = e1.next){
                                            case 0:
                                                if (!(i.length > 0 && void 0 !== i[0] && i[0])) {
                                                    e1.next = 3;
                                                    break;
                                                }
                                                return e1.abrupt("return", (0, T.V7)());
                                            case 3:
                                                return e1.next = 5, this.tokenManager.getTokens();
                                            case 5:
                                                if (r = e1.sent, !(o = (null === (t = r.accessToken) || void 0 === t ? void 0 : t.dpopPairId) || (null === (n = r.refreshToken) || void 0 === n ? void 0 : n.dpopPairId))) {
                                                    e1.next = 10;
                                                    break;
                                                }
                                                return e1.next = 10, (0, T.sd)(o);
                                            case 10:
                                            case "end":
                                                return e1.stop();
                                        }
                                    }, e1, this);
                                })), function() {
                                    return n.apply(this, arguments);
                                })
                            },
                            {
                                key: "parseUseDPoPNonceError",
                                value: function(e1) {
                                    var t = P.Z.getWWWAuthenticateHeader(e1), n = P.Z.parseHeader(null != t ? t : "");
                                    if ((0, T.SO)(n)) {
                                        var r, o, i = null;
                                        return (0, g.mf)(null == e1 ? void 0 : e1.get) && (i = e1.get("DPoP-Nonce")), null !== (r = null !== (o = i) && void 0 !== o ? o : e1["dpop-nonce"]) && void 0 !== r ? r : e1["DPoP-Nonce"];
                                    }
                                    return null;
                                }
                            }
                        ]), H;
                    }(d), (0, p.Z)(n, "crypto", m), n;
                }
            },
            9453: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    m: function() {
                        return m;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(1971), l = n(6718), p = n(415), d = n(8817), h = !0, v = n(9123);
                function y(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function g(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? y(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function m() {
                    return function(e1) {
                        (0, a.Z)(y, e1);
                        var t, n, d = (t = y, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function y(e1) {
                            var t;
                            return (0, o.Z)(this, y), t = d.call(this, e1), (0, s.Z)((0, i.Z)(t), "issuer", void 0), (0, s.Z)((0, i.Z)(t), "authorizeUrl", void 0), (0, s.Z)((0, i.Z)(t), "userinfoUrl", void 0), (0, s.Z)((0, i.Z)(t), "tokenUrl", void 0), (0, s.Z)((0, i.Z)(t), "revokeUrl", void 0), (0, s.Z)((0, i.Z)(t), "logoutUrl", void 0), (0, s.Z)((0, i.Z)(t), "pkce", void 0), (0, s.Z)((0, i.Z)(t), "clientId", void 0), (0, s.Z)((0, i.Z)(t), "redirectUri", void 0), (0, s.Z)((0, i.Z)(t), "responseType", void 0), (0, s.Z)((0, i.Z)(t), "responseMode", void 0), (0, s.Z)((0, i.Z)(t), "state", void 0), (0, s.Z)((0, i.Z)(t), "scopes", void 0), (0, s.Z)((0, i.Z)(t), "ignoreSignature", void 0), (0, s.Z)((0, i.Z)(t), "codeChallenge", void 0), (0, s.Z)((0, i.Z)(t), "codeChallengeMethod", void 0), (0, s.Z)((0, i.Z)(t), "acrValues", void 0), (0, s.Z)((0, i.Z)(t), "maxAge", void 0), (0, s.Z)((0, i.Z)(t), "dpop", void 0), (0, s.Z)((0, i.Z)(t), "dpopOptions", void 0), (0, s.Z)((0, i.Z)(t), "tokenManager", void 0), (0, s.Z)((0, i.Z)(t), "postLogoutRedirectUri", void 0), (0, s.Z)((0, i.Z)(t), "restoreOriginalUri", void 0), (0, s.Z)((0, i.Z)(t), "transactionManager", void 0), (0, s.Z)((0, i.Z)(t), "clientSecret", void 0), (0, s.Z)((0, i.Z)(t), "setLocation", void 0), (0, s.Z)((0, i.Z)(t), "ignoreLifetime", void 0), (0, s.Z)((0, i.Z)(t), "maxClockSkew", void 0), function(e1) {
                                var t = (e1 = e1 || {}).scopes;
                                if (t && !Array.isArray(t)) throw new v.Z('scopes must be a array of strings. Required usage: new OktaAuth({scopes: ["openid", "email"]})');
                                var n = e1.issuer;
                                if (!n) throw new v.Z('No issuer passed to constructor. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
                                if (!new RegExp("^http?s?://.+").test(n)) throw new v.Z('Issuer must be a valid URL. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
                                if (-1 !== n.indexOf("-admin.okta")) throw new v.Z('Issuer URL passed to constructor contains "-admin" in subdomain. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com})');
                            }(e1), t.issuer = (0, l.Qj)(e1.issuer), t.tokenUrl = (0, l.Qj)(e1.tokenUrl), t.authorizeUrl = (0, l.Qj)(e1.authorizeUrl), t.userinfoUrl = (0, l.Qj)(e1.userinfoUrl), t.revokeUrl = (0, l.Qj)(e1.revokeUrl), t.logoutUrl = (0, l.Qj)(e1.logoutUrl), t.pkce = !1 !== e1.pkce, t.clientId = e1.clientId, t.redirectUri = e1.redirectUri, (0, p.isBrowser)() && (t.redirectUri = (0, l.BY)(e1.redirectUri, window.location.origin)), t.responseType = e1.responseType, t.responseMode = e1.responseMode, t.state = e1.state, t.scopes = e1.scopes, t.ignoreSignature = !!e1.ignoreSignature, t.codeChallenge = e1.codeChallenge, t.codeChallengeMethod = e1.codeChallengeMethod, t.acrValues = e1.acrValues, t.maxAge = e1.maxAge, t.dpop = !0 === e1.dpop, t.dpopOptions = g({
                                allowBearerTokens: !1
                            }, e1.dpopOptions), t.tokenManager = e1.tokenManager, t.postLogoutRedirectUri = e1.postLogoutRedirectUri, t.restoreOriginalUri = e1.restoreOriginalUri, t.transactionManager = g({
                                enableSharedStorage: h
                            }, e1.transactionManager), t.clientSecret = e1.clientSecret, t.setLocation = e1.setLocation, t.ignoreLifetime = !!e1.ignoreLifetime, e1.maxClockSkew || 0 === e1.maxClockSkew ? t.maxClockSkew = e1.maxClockSkew : t.maxClockSkew = f.DEFAULT_MAX_CLOCK_SKEW, t;
                        }
                        return (0, r.Z)(y);
                    }((0, d.Z)());
                }
            },
            3775: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    m: function() {
                        return r.m;
                    }
                });
                var r = n(9453);
            },
            5372: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Tp: function() {
                        return p;
                    },
                    ko: function() {
                        return h;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(1969), c = n(9912), s = n(4771), f = n(8676);
                function l(e1) {
                    var t = e1.options.pkce ? "query" : "fragment";
                    return e1.options.responseMode || t;
                }
                function p(e1, t) {
                    t = t || {}, (0, s.HD)(t) && (t = {
                        url: t
                    });
                    var n, r = t.url, o = t.responseMode || l(e1), i = e1.token.parseFromUrl._getLocation();
                    if (!(n = "query" === o ? r ? r.substring(r.indexOf("?")) : i.search : r ? r.substring(r.indexOf("#")) : i.hash)) throw new a.Z("Unable to parse a token from the url");
                    return (0, u.v)(n);
                }
                function d(e1, t) {
                    "query" === (t.responseMode || l(e1)) ? function(e1) {
                        var t = e1.token.parseFromUrl._getHistory(), n = e1.token.parseFromUrl._getDocument(), r = e1.token.parseFromUrl._getLocation();
                        t && t.replaceState ? t.replaceState(null, n.title, r.pathname + r.hash) : r.search = "";
                    }(e1) : function(e1) {
                        var t = e1.token.parseFromUrl._getHistory(), n = e1.token.parseFromUrl._getDocument(), r = e1.token.parseFromUrl._getLocation();
                        t && t.replaceState ? t.replaceState(null, n.title, r.pathname + r.search) : r.hash = "";
                    }(e1);
                }
                function h(e1, t) {
                    return v.apply(this, arguments);
                }
                function v() {
                    return (v = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, u, l;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = n || {}, (0, s.HD)(n) && (n = {
                                        url: n
                                    }), r = p(t, n), o = r.state, u = t.transactionManager.load({
                                        state: o
                                    })) {
                                        e1.next = 9;
                                        break;
                                    }
                                    if (!t.options.pkce) {
                                        e1.next = 8;
                                        break;
                                    }
                                    throw new a.Z("Could not load PKCE codeVerifier from storage. This may indicate the auth flow has already completed or multiple auth flows are executing concurrently.", void 0);
                                case 8:
                                    throw new a.Z("Unable to retrieve OAuth redirect params from storage");
                                case 9:
                                    return l = u.urls, delete u.urls, n.url || d(t, n), e1.abrupt("return", (0, f.s)(t, u, r, l).catch(function(e1) {
                                        throw (0, c.Cf)(e1) || t.transactionManager.clear({
                                            state: o
                                        }), e1;
                                    }).then(function(e1) {
                                        return t.transactionManager.clear({
                                            state: o
                                        }), e1;
                                    }));
                                case 13:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            2476: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $: function() {
                        return p;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(6488), c = n(7625), s = n(781);
                function f() {
                    throw new a.Z("Renew must be passed a token with an array of scopes and an accessToken or idToken");
                }
                function l(e1, t) {
                    return (0, u.sI)(e1) ? t.idToken : (0, u.hv)(e1) ? t.accessToken : void f();
                }
                function p(e1, t) {
                    return d.apply(this, arguments);
                }
                function d() {
                    return (d = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, a, p, d, h, v, y, g;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if ((0, u.sI)(n) || (0, u.hv)(n) || f(), !(r = t.tokenManager.getTokensSync()).refreshToken) {
                                        e1.next = 7;
                                        break;
                                    }
                                    return e1.next = 5, (0, s.R)(t, {
                                        scopes: n.scopes
                                    }, r.refreshToken);
                                case 5:
                                    return r = e1.sent, e1.abrupt("return", l(n, r));
                                case 7:
                                    return o = t.options.pkce ? "code" : (0, u.hv)(n) ? "token" : "id_token", p = (a = n).scopes, d = a.authorizeUrl, h = a.userinfoUrl, v = a.issuer, y = a.dpopPairId, g = a.extraParams, e1.abrupt("return", (0, c.y)(t, {
                                        responseType: o,
                                        scopes: p,
                                        authorizeUrl: d,
                                        userinfoUrl: h,
                                        issuer: v,
                                        dpopPairId: y,
                                        extraParams: g
                                    }).then(function(e1) {
                                        return l(n, e1.tokens);
                                    }));
                                case 10:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            6268: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    I: function() {
                        return f;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(9123), u = n(7625), c = n(781), s = n(7756);
                function f(e1, t) {
                    return l.apply(this, arguments);
                }
                function l() {
                    return (l = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, f, l, p, d, h, v, y, g, m, b, k;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (!(f = null !== (r = null === (o = n) || void 0 === o ? void 0 : o.tokens) && void 0 !== r ? r : t.tokenManager.getTokensSync()).refreshToken) {
                                        e1.next = 3;
                                        break;
                                    }
                                    return e1.abrupt("return", (0, c.R)(t, n || {}, f.refreshToken));
                                case 3:
                                    if (f.accessToken || f.idToken) {
                                        e1.next = 5;
                                        break;
                                    }
                                    throw new a.Z("renewTokens() was called but there is no existing token");
                                case 5:
                                    if (l = f.accessToken || {}, p = f.idToken || {}, d = l.scopes || p.scopes) {
                                        e1.next = 10;
                                        break;
                                    }
                                    throw new a.Z("renewTokens: invalid tokens: could not read scopes");
                                case 10:
                                    if (h = l.authorizeUrl || p.authorizeUrl) {
                                        e1.next = 13;
                                        break;
                                    }
                                    throw new a.Z("renewTokens: invalid tokens: could not read authorizeUrl");
                                case 13:
                                    return v = l.userinfoUrl || t.options.userinfoUrl, y = p.issuer || t.options.issuer, g = null == l ? void 0 : l.dpopPairId, m = (null == l ? void 0 : l.extraParams) || (null == p ? void 0 : p.extraParams), n = Object.assign({
                                        scopes: d,
                                        authorizeUrl: h,
                                        userinfoUrl: v,
                                        issuer: y,
                                        dpopPairId: g,
                                        extraParams: m
                                    }, n), t.options.pkce ? n.responseType = "code" : (b = (0, s.D)(t), k = b.responseType, n.responseType = k), e1.abrupt("return", (0, u.y)(t, n).then(function(e1) {
                                        return e1.tokens;
                                    }));
                                case 20:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            781: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    R: function() {
                        return y;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(9123), c = n(7599), s = n(6635), f = n(8676), l = n(9231), p = n(7659), d = n(9912);
                function h(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function v(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? h(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function y(e1, t, n) {
                    return g.apply(this, arguments);
                }
                function g() {
                    return (g = (0, o.Z)(a().mark(function e1(t, n, r) {
                        var o, i, h, y, g, m, b, k, w, O, Z;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (o = t.options, i = o.clientId, h = o.dpop, i) {
                                        e1.next = 3;
                                        break;
                                    }
                                    throw new u.Z("A clientId must be specified in the OktaAuth constructor to renew tokens");
                                case 3:
                                    if (e1.prev = 3, y = Object.assign({}, n, {
                                        clientId: i
                                    }), r.extraParams && (y.extraParams = r.extraParams), g = v({}, y), !h) {
                                        e1.next = 14;
                                        break;
                                    }
                                    return e1.next = 10, (0, p.lk)(null == r ? void 0 : r.dpopPairId);
                                case 10:
                                    m = e1.sent, g.dpopKeyPair = m, y.dpop = h, y.dpopPairId = r.dpopPairId;
                                case 14:
                                    return e1.next = 16, (0, l.D)(t, g, r);
                                case 16:
                                    return b = e1.sent, k = (0, c.Fc)(t, n), e1.next = 20, (0, f.s)(t, y, b, k);
                                case 20:
                                    return w = e1.sent, O = w.tokens, (Z = O.refreshToken) && !(0, s.q)(Z, r) && t.tokenManager.updateRefreshToken(Z), e1.abrupt("return", O);
                                case 27:
                                    throw e1.prev = 27, e1.t0 = e1.catch(3), (0, d.$E)(e1.t0) && t.tokenManager.removeRefreshToken(), e1.t0;
                                case 31:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1, null, [
                            [
                                3,
                                27
                            ]
                        ]);
                    }))).apply(this, arguments);
                }
            },
            6466: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    P: function() {
                        return l;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(5385), u = n(6718), c = n(7599), s = n(7594), f = n(9123);
                function l(e1, t) {
                    return p.apply(this, arguments);
                }
                function p() {
                    return (p = (0, r.Z)(i().mark(function e1(t, n) {
                        var r, o, l, p, d, h, v;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (r = "", o = "", n && (r = n.accessToken, o = n.refreshToken), r || o) {
                                        e1.next = 5;
                                        break;
                                    }
                                    throw new f.Z("A valid access or refresh token object is required");
                                case 5:
                                    if (l = t.options.clientId, p = t.options.clientSecret, l) {
                                        e1.next = 9;
                                        break;
                                    }
                                    throw new f.Z("A clientId must be specified in the OktaAuth constructor to revoke a token");
                                case 9:
                                    return d = (0, c.Fc)(t).revokeUrl, h = (0, u.UK)({
                                        token_type_hint: o ? "refresh_token" : "access_token",
                                        token: o || r
                                    }).slice(1), v = p ? (0, s.r3)("".concat(l, ":").concat(p)) : (0, s.r3)(l), e1.abrupt("return", (0, a.v_)(t, d, h, {
                                        headers: {
                                            "Content-Type": "application/x-www-form-urlencoded",
                                            Authorization: "Basic " + v
                                        }
                                    }));
                                case 13:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            2333: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    a: function() {
                        return l;
                    }
                });
                var r = n(5671), o = n(3144), i = n(136), a = n(2963), u = n(1120), c = n(5437), s = n(5763), f = n(1971);
                function l() {
                    return function(e1) {
                        (0, i.Z)(p, e1);
                        var t, n, l = (t = p, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, u.Z)(t);
                            if (n) {
                                var o = (0, u.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, a.Z)(this, e1);
                        });
                        function p(e1, t, n) {
                            return (0, r.Z)(this, p), l.call(this, e1, t, n);
                        }
                        return (0, o.Z)(p, [
                            {
                                key: "getTransactionStorage",
                                value: function(e1) {
                                    e1 = this.getOptionsForSection("transaction", e1), (0, c.V)(e1);
                                    var t = this.getStorage(e1), n = e1.storageKey || f.TRANSACTION_STORAGE_NAME;
                                    return new s._(t, n);
                                }
                            },
                            {
                                key: "getSharedTansactionStorage",
                                value: function(e1) {
                                    e1 = this.getOptionsForSection("shared-transaction", e1), (0, c.V)(e1);
                                    var t = this.getStorage(e1), n = e1.storageKey || f.SHARED_TRANSACTION_STORAGE_NAME;
                                    return new s._(t, n);
                                }
                            },
                            {
                                key: "getOriginalUriStorage",
                                value: function(e1) {
                                    e1 = this.getOptionsForSection("original-uri", e1), (0, c.V)(e1);
                                    var t = this.getStorage(e1), n = e1.storageKey || f.ORIGINAL_URI_STORAGE_NAME;
                                    return new s._(t, n);
                                }
                            }
                        ]), p;
                    }(c.W);
                }
            },
            6488: function(e1, t, n) {
                "use strict";
                var r;
                function o(e1) {
                    return !!(e1 && (e1.accessToken || e1.idToken || e1.refreshToken) && Array.isArray(e1.scopes));
                }
                function i(e1) {
                    return e1 && e1.accessToken;
                }
                function a(e1) {
                    return e1 && e1.idToken;
                }
                function u(e1) {
                    return e1 && e1.refreshToken;
                }
                n.d(t, {
                    T6: function() {
                        return r;
                    },
                    hD: function() {
                        return o;
                    },
                    hv: function() {
                        return i;
                    },
                    sI: function() {
                        return a;
                    },
                    z9: function() {
                        return u;
                    }
                }), function(e1) {
                    e1.ACCESS = "accessToken", e1.ID = "idToken", e1.REFRESH = "refreshToken";
                }(r || (r = {}));
            },
            7088: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $I: function() {
                        return u;
                    },
                    $Y: function() {
                        return r;
                    },
                    E: function() {
                        return o;
                    },
                    FT: function() {
                        return a;
                    },
                    O3: function() {
                        return i;
                    },
                    zr: function() {
                        return c;
                    }
                });
                var r = "expired", o = "renewed", i = "added", a = "removed", u = "error", c = "set_storage";
            },
            4319: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    G5: function() {
                        return i;
                    },
                    ZT: function() {
                        return a;
                    },
                    mH: function() {
                        return s;
                    },
                    rZ: function() {
                        return c;
                    },
                    sG: function() {
                        return u;
                    }
                });
                var r = n(1002);
                function o(e1) {
                    return !(!e1 || "object" !== (0, r.Z)(e1) || 0 === Object.values(e1).length);
                }
                function i(e1) {
                    return !(!o(e1) || !e1.redirectUri && !e1.responseType);
                }
                function a(e1) {
                    return !!i(e1) && !!e1.codeVerifier;
                }
                function u(e1) {
                    return !!a(e1) && !!e1.interactionHandle;
                }
                function c(e1) {
                    return !!o(e1) && void 0 === Object.values(e1).find(function(e1) {
                        return "string" != typeof e1;
                    });
                }
                function s(e1) {
                    return !(!i(e1) && !c(e1));
                }
            },
            7615: function() {},
            8927: function(e1, t, n) {
                "use strict";
                n.r(t), n.d(t, {
                    EVENT_ADDED: function() {
                        return u.O3;
                    },
                    EVENT_ERROR: function() {
                        return u.$I;
                    },
                    EVENT_EXPIRED: function() {
                        return u.$Y;
                    },
                    EVENT_REMOVED: function() {
                        return u.FT;
                    },
                    EVENT_RENEWED: function() {
                        return u.E;
                    },
                    EVENT_SET_STORAGE: function() {
                        return u.zr;
                    },
                    TokenKind: function() {
                        return a.T6;
                    },
                    isAccessToken: function() {
                        return a.hv;
                    },
                    isCustomAuthTransactionMeta: function() {
                        return c.rZ;
                    },
                    isIDToken: function() {
                        return a.sI;
                    },
                    isIdxTransactionMeta: function() {
                        return c.sG;
                    },
                    isOAuthTransactionMeta: function() {
                        return c.G5;
                    },
                    isPKCETransactionMeta: function() {
                        return c.ZT;
                    },
                    isRefreshToken: function() {
                        return a.z9;
                    },
                    isToken: function() {
                        return a.hD;
                    },
                    isTransactionMeta: function() {
                        return c.mH;
                    }
                });
                var r = n(9263), o = {};
                for(var i in r)"default" !== i && (o[i] = (function(e1) {
                    return r[e1];
                }).bind(0, i));
                n.d(t, o);
                var a = n(6488), u = n(7088), c = n(4319), s = n(7615);
                for(var i in o = {}, s)[
                    "default",
                    "TokenKind",
                    "isAccessToken",
                    "isIDToken",
                    "isRefreshToken",
                    "isToken",
                    "EVENT_ADDED",
                    "EVENT_ERROR",
                    "EVENT_EXPIRED",
                    "EVENT_REMOVED",
                    "EVENT_RENEWED",
                    "EVENT_SET_STORAGE",
                    "isCustomAuthTransactionMeta",
                    "isIdxTransactionMeta",
                    "isOAuthTransactionMeta",
                    "isPKCETransactionMeta",
                    "isTransactionMeta"
                ].indexOf(i) < 0 && (o[i] = (function(e1) {
                    return s[e1];
                }).bind(0, i));
                n.d(t, o);
            },
            9263: function() {},
            4970: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    It: function() {
                        return d;
                    },
                    NH: function() {
                        return c;
                    },
                    Rl: function() {
                        return f;
                    },
                    iC: function() {
                        return p;
                    },
                    pU: function() {
                        return l;
                    },
                    ys: function() {
                        return s;
                    }
                });
                var r = n(4942), o = n(1002), i = n(9123);
                function a(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                var u = 12e4;
                function c(e1, t, n) {
                    e1.addEventListener ? e1.addEventListener(t, n) : e1.attachEvent("on" + t, n);
                }
                function s(e1, t, n) {
                    e1.removeEventListener ? e1.removeEventListener(t, n) : e1.detachEvent("on" + t, n);
                }
                function f(e1) {
                    var t = document.createElement("iframe");
                    return t.style.display = "none", t.src = e1, document.body.appendChild(t);
                }
                function l(e1, t) {
                    var n = t.popupTitle || "External Identity Provider User Authentication";
                    return window.open(e1, n, "toolbar=no, scrollbars=yes, resizable=yes, top=100, left=500, width=600, height=600");
                }
                function p(e1, t, n) {
                    var r, o;
                    return new Promise(function(a, s) {
                        r = function(t) {
                            if (t.data && t.data.state === n) return t.origin !== e1.getIssuerOrigin() ? s(new i.Z("The request does not match client configuration")) : void a(t.data);
                        }, c(window, "message", r), o = setTimeout(function() {
                            s(new i.Z("OAuth flow timed out"));
                        }, t || u);
                    }).finally(function() {
                        clearTimeout(o), s(window, "message", r);
                    });
                }
                function d(e1, t, n, c) {
                    var s, f = new Promise(function(e1, f) {
                        n.onmessage = function(t) {
                            if (t.isTrusted && t.data) return "object" === (0, o.Z)(t.data) && c === t.data.state ? e1(function(e1) {
                                for(var t = 1; t < arguments.length; t++){
                                    var n = null != arguments[t] ? arguments[t] : {};
                                    t % 2 ? a(Object(n), !0).forEach(function(t) {
                                        (0, r.Z)(e1, t, n[t]);
                                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : a(Object(n)).forEach(function(t) {
                                        Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                                    });
                                }
                                return e1;
                            }({}, t.data)) : void f(new i.Z("Unable to complete auth code exchange"));
                        }, s = setTimeout(function() {
                            f(new i.Z("OAuth flow timed out"));
                        }, t || u);
                    });
                    return f.finally(function() {
                        clearTimeout(s), n.close();
                    });
                }
            },
            5078: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    c: function() {
                        return a;
                    }
                });
                var r = n(7599), o = n(415), i = n(3193);
                function a(e1) {
                    var t = e1.options, n = t.clientId, a = t.redirectUri, u = t.responseMode, c = t.state, s = (0, o.isBrowser)() ? window.location.href : void 0;
                    return (0, i.YY)({
                        clientId: n,
                        redirectUri: a || s,
                        responseMode: u,
                        state: c || (0, r.aV)(),
                        responseType: "none",
                        prompt: "enroll_authenticator"
                    });
                }
            },
            7756: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    D: function() {
                        return a;
                    }
                });
                var r = n(7599), o = n(415), i = n(3193);
                function a(e1) {
                    var t = e1.options, n = t.pkce, a = t.clientId, u = t.redirectUri, c = t.responseType, s = t.responseMode, f = t.scopes, l = t.acrValues, p = t.maxAge, d = t.state, h = t.ignoreSignature, v = t.dpop, y = (0, o.isBrowser)() ? window.location.href : void 0;
                    return (0, i.YY)({
                        pkce: n,
                        clientId: a,
                        redirectUri: u || y,
                        responseType: c || [
                            "token",
                            "id_token"
                        ],
                        responseMode: s,
                        state: d || (0, r.aV)(),
                        nonce: (0, r.NH)(),
                        scopes: f || [
                            "openid",
                            "email"
                        ],
                        acrValues: l,
                        maxAge: p,
                        ignoreSignature: h,
                        dpop: v
                    });
                }
            },
            8080: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    A: function() {
                        return o;
                    }
                });
                var r = n(7599);
                function o(e1, t) {
                    return {
                        issuer: e1.options.issuer,
                        urls: (0, r.Fc)(e1, t),
                        clientId: t.clientId,
                        redirectUri: t.redirectUri,
                        responseType: t.responseType,
                        responseMode: t.responseMode,
                        state: t.state,
                        acrValues: t.acrValues,
                        enrollAmrValues: t.enrollAmrValues
                    };
                }
            },
            9912: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $E: function() {
                        return a;
                    },
                    Cf: function() {
                        return o;
                    },
                    tC: function() {
                        return i;
                    }
                });
                var r = n(5728);
                function o(e1) {
                    return "OAuthError" === e1.name && "interaction_required" === e1.errorCode;
                }
                function i(e1, t) {
                    if ("AuthApiError" !== t.name) return !1;
                    var n = t.xhr, r = null == n ? void 0 : n.responseJSON;
                    return e1.options.pkce && "invalid_grant" === (null == r ? void 0 : r.error);
                }
                function a(e1) {
                    return (0, r.isOAuthError)(e1) && "invalid_grant" === e1.errorCode && "The refresh token is invalid or expired." === e1.errorSummary;
                }
            },
            8785: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    $E: function() {
                        return a.$E;
                    },
                    AW: function() {
                        return f.A;
                    },
                    Cf: function() {
                        return a.Cf;
                    },
                    Dx: function() {
                        return o.D;
                    },
                    Fc: function() {
                        return c.Fc;
                    },
                    H: function() {
                        return s.H;
                    },
                    Ik: function() {
                        return u.Ik;
                    },
                    It: function() {
                        return r.It;
                    },
                    NH: function() {
                        return r.NH;
                    },
                    O2: function() {
                        return u.O2;
                    },
                    PY: function() {
                        return c.NH;
                    },
                    Qs: function() {
                        return u.Qs;
                    },
                    Rl: function() {
                        return r.Rl;
                    },
                    Rp: function() {
                        return g.R;
                    },
                    U5: function() {
                        return l.Z;
                    },
                    Uc: function() {
                        return d.U;
                    },
                    Xp: function() {
                        return c.Xp;
                    },
                    Yo: function() {
                        return h.Y;
                    },
                    ZP: function() {
                        return u.ZP;
                    },
                    aV: function() {
                        return c.aV;
                    },
                    br: function() {
                        return p.br;
                    },
                    cE: function() {
                        return i.c;
                    },
                    d_: function() {
                        return u.d_;
                    },
                    gM: function() {
                        return u.gM;
                    },
                    hg: function() {
                        return u.hg;
                    },
                    iC: function() {
                        return r.iC;
                    },
                    kU: function() {
                        return u.kU;
                    },
                    mi: function() {
                        return p.mi;
                    },
                    pU: function() {
                        return r.pU;
                    },
                    pj: function() {
                        return y.p;
                    },
                    q0: function() {
                        return h.q;
                    },
                    tC: function() {
                        return a.tC;
                    },
                    vL: function() {
                        return v.v;
                    },
                    vz: function() {
                        return p.vz;
                    },
                    wV: function() {
                        return u.wV;
                    },
                    wc: function() {
                        return u.wc;
                    },
                    wu: function() {
                        return p.wu;
                    },
                    ys: function() {
                        return r.ys;
                    },
                    zf: function() {
                        return c.zf;
                    }
                });
                var r = n(4970), o = n(7756), i = n(5078), a = n(9912), u = n(8221), c = n(7599), s = n(2865), f = n(8080), l = n(3611), p = n(6898), d = n(6757), h = n(6635), v = n(1969), y = n(6003), g = n(2482);
            },
            8221: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return /[?&#](id|access)_token=/.test(e1);
                }
                function o(e1) {
                    return /[?&#]code=/.test(e1);
                }
                function i(e1) {
                    return /[?&#]interaction_code=/.test(e1);
                }
                function a(e1) {
                    return /[?&#]error=/.test(e1) || /[?&#]error_description/.test(e1);
                }
                function u(e1, t) {
                    var n = t.options;
                    return !(!e1 || !n.redirectUri) && 0 === e1.indexOf(n.redirectUri);
                }
                function c(e1) {
                    return e1.pkce || "code" === e1.responseType || "query" === e1.responseMode;
                }
                function s(e1, t) {
                    return Array.isArray(t.responseType) && t.responseType.length ? t.responseType.indexOf(e1) >= 0 : t.responseType === e1;
                }
                function f(e1) {
                    return c(e1) && "fragment" !== e1.responseMode ? window.location.search : window.location.hash;
                }
                function l(e1) {
                    if (!u(window.location.href, e1)) return !1;
                    var t = c(e1.options), n = f(e1.options);
                    return !!a(n) || (t ? o(n) || i(n) : r(window.location.hash));
                }
                function p(e1, t) {
                    if (!t) {
                        if (!l(e1)) return !1;
                        t = f(e1.options);
                    }
                    return /(error=interaction_required)/i.test(t);
                }
                n.d(t, {
                    Ik: function() {
                        return c;
                    },
                    O2: function() {
                        return f;
                    },
                    Qs: function() {
                        return u;
                    },
                    ZP: function() {
                        return o;
                    },
                    d_: function() {
                        return i;
                    },
                    gM: function() {
                        return l;
                    },
                    hg: function() {
                        return a;
                    },
                    kU: function() {
                        return r;
                    },
                    wV: function() {
                        return s;
                    },
                    wc: function() {
                        return p;
                    }
                });
            },
            7599: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Fc: function() {
                        return l;
                    },
                    NH: function() {
                        return u;
                    },
                    Xp: function() {
                        return f;
                    },
                    aV: function() {
                        return a;
                    },
                    zf: function() {
                        return s;
                    }
                });
                var r = n(8750), o = n(6718), i = n(9123);
                function a() {
                    return (0, r.uh)(64);
                }
                function u() {
                    return (0, r.uh)(64);
                }
                function c(e1) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return (0, o.Qj)(t.issuer) || e1.options.issuer;
                }
                function s(e1) {
                    var t = c(e1, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {});
                    return t.indexOf("/oauth2") > 0 ? t : t + "/oauth2";
                }
                function f(e1) {
                    return c(e1, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).split("/oauth2")[0];
                }
                function l(e1, t) {
                    if (arguments.length > 2) throw new i.Z('As of version 3.0, "getOAuthUrls" takes only a single set of options');
                    t = t || {};
                    var n = (0, o.Qj)(t.authorizeUrl) || e1.options.authorizeUrl, r = c(e1, t), a = (0, o.Qj)(t.userinfoUrl) || e1.options.userinfoUrl, u = (0, o.Qj)(t.tokenUrl) || e1.options.tokenUrl, f = (0, o.Qj)(t.logoutUrl) || e1.options.logoutUrl, l = (0, o.Qj)(t.revokeUrl) || e1.options.revokeUrl, p = s(e1, t);
                    return {
                        issuer: r,
                        authorizeUrl: n = n || p + "/v1/authorize",
                        userinfoUrl: a = a || p + "/v1/userinfo",
                        tokenUrl: u = u || p + "/v1/token",
                        revokeUrl: l = l || p + "/v1/revoke",
                        logoutUrl: f = f || p + "/v1/logout"
                    };
                }
            },
            2865: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    H: function() {
                        return u;
                    }
                });
                var r = n(4942), o = n(7599);
                function i(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function a(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? i(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function u(e1, t) {
                    var n = {
                        issuer: e1.options.issuer,
                        urls: (0, o.Fc)(e1, t),
                        clientId: t.clientId,
                        redirectUri: t.redirectUri,
                        responseType: t.responseType,
                        responseMode: t.responseMode,
                        scopes: t.scopes,
                        state: t.state,
                        nonce: t.nonce,
                        ignoreSignature: t.ignoreSignature,
                        acrValues: t.acrValues,
                        extraParams: t.extraParams
                    };
                    return !1 === t.pkce ? n : a(a({}, n), {}, {
                        codeVerifier: t.codeVerifier,
                        codeChallengeMethod: t.codeChallengeMethod,
                        codeChallenge: t.codeChallenge
                    });
                }
            },
            3611: function(e1, t, n) {
                "use strict";
                var r = n(7594), o = n(7987), i = n(1971);
                function a(e1) {
                    return ("0" + e1.toString(16)).substr(-2);
                }
                t.Z = {
                    DEFAULT_CODE_CHALLENGE_METHOD: i.DEFAULT_CODE_CHALLENGE_METHOD,
                    generateVerifier: function(e1) {
                        var t, n, o = e1 || "";
                        return o.length < i.MIN_VERIFIER_LENGTH && (o += (t = i.MIN_VERIFIER_LENGTH - o.length, n = new Uint8Array(Math.ceil(t / 2)), r.KP.getRandomValues(n), Array.from(n, a).join("").slice(0, t))), encodeURIComponent(o).slice(0, i.MAX_VERIFIER_LENGTH);
                    },
                    computeChallenge: function(e1) {
                        var t = (new TextEncoder).encode(e1);
                        return r.KP.subtle.digest("SHA-256", t).then(function(e1) {
                            var t = String.fromCharCode.apply(null, new Uint8Array(e1));
                            return (0, o.NL)(t);
                        });
                    }
                };
            },
            6757: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    U: function() {
                        return c;
                    }
                });
                var r = n(4942), o = n(9123), i = n(5078);
                function a(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function u(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? a(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : a(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function c(e1, t) {
                    return function(e1) {
                        if (!(e1 = u(u({}, e1), {}, {
                            responseType: "none",
                            prompt: "enroll_authenticator",
                            maxAge: 0
                        })).enrollAmrValues) throw new o.Z("enroll_amr_values must be specified");
                        if (!e1.acrValues) throw new o.Z("acr_values must be specified");
                        return delete e1.scopes, delete e1.nonce, e1;
                    }(u(u({}, (0, i.c)(e1)), t));
                }
            },
            6898: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    br: function() {
                        return v;
                    },
                    mi: function() {
                        return g;
                    },
                    vz: function() {
                        return h;
                    },
                    wu: function() {
                        return b;
                    }
                });
                var r = n(4942), o = n(5861), i = n(4687), a = n.n(i), u = n(52), c = n(9123), s = n(7756), f = n(1971), l = n(3611);
                function p(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function d(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? p(Object(n), !0).forEach(function(t) {
                            (0, r.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function h(e1) {
                    if (!e1.features.isPKCESupported()) {
                        var t = "PKCE requires a modern browser with encryption support running in a secure context.";
                        throw e1.features.isHTTPS() || (t += "\nThe current page is not being served with HTTPS protocol. PKCE requires secure HTTPS protocol."), e1.features.hasTextEncoder() || (t += '\n"TextEncoder" is not defined. To use PKCE, you may need to include a polyfill/shim for this browser.'), new c.Z(t);
                    }
                }
                function v(e1, t) {
                    return y.apply(this, arguments);
                }
                function y() {
                    return (y = (0, o.Z)(a().mark(function e1(t, n) {
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    return n = n || t.options.codeChallengeMethod || f.DEFAULT_CODE_CHALLENGE_METHOD, e1.next = 3, (0, u.E)(t);
                                case 3:
                                    if (-1 !== (e1.sent.code_challenge_methods_supported || []).indexOf(n)) {
                                        e1.next = 7;
                                        break;
                                    }
                                    throw new c.Z("Invalid code_challenge_method");
                                case 7:
                                    return e1.abrupt("return", n);
                                case 8:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function g(e1, t) {
                    return m.apply(this, arguments);
                }
                function m() {
                    return (m = (0, o.Z)(a().mark(function e1(t, n) {
                        var r, o, i, u;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (o = (r = n).codeVerifier, i = r.codeChallenge, u = r.codeChallengeMethod, i = i || t.options.codeChallenge) {
                                        e1.next = 8;
                                        break;
                                    }
                                    return h(t), o = o || l.Z.generateVerifier(), e1.next = 7, l.Z.computeChallenge(o);
                                case 7:
                                    i = e1.sent;
                                case 8:
                                    return e1.next = 10, v(t, u);
                                case 10:
                                    return u = e1.sent, n = d(d({}, n), {}, {
                                        responseType: "code",
                                        codeVerifier: o,
                                        codeChallenge: i,
                                        codeChallengeMethod: u
                                    }), e1.abrupt("return", n);
                                case 13:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
                function b(e1) {
                    return k.apply(this, arguments);
                }
                function k() {
                    return k = (0, o.Z)(a().mark(function e1(t) {
                        var n, r, o = arguments;
                        return a().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n = o.length > 1 && void 0 !== o[1] ? o[1] : {}, r = (0, s.D)(t), !(n = d(d({}, r), n)).dpop || t.features.isDPoPSupported()) {
                                        e1.next = 5;
                                        break;
                                    }
                                    throw new c.Z("DPoP has been configured, but is not supported by browser");
                                case 5:
                                    if (!1 !== n.pkce) {
                                        e1.next = 7;
                                        break;
                                    }
                                    return e1.abrupt("return", n);
                                case 7:
                                    return e1.abrupt("return", g(t, n));
                                case 8:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    })), k.apply(this, arguments);
                }
            },
            6635: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Y: function() {
                        return i;
                    },
                    q: function() {
                        return o;
                    }
                });
                var r = n(5728);
                function o(e1, t) {
                    return e1.refreshToken === t.refreshToken;
                }
                function i(e1) {
                    return !(!(0, r.isAuthApiError)(e1) || !e1.xhr || !e1.xhr.responseJSON || "invalid_grant" !== e1.xhr.responseJSON.error);
                }
            },
            1969: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    var t = /\+/g, n = /([^&=]+)=?([^&]*)/g, r = e1 || "";
                    "#" === r.charAt(0) && "/" === r.charAt(1) && (r = r.substring(2)), "#" !== r.charAt(0) && "?" !== r.charAt(0) || (r = r.substring(1));
                    for(var o, i = {}; o = n.exec(r);){
                        var a = o[1], u = o[2];
                        i[a] = "id_token" === a || "access_token" === a || "code" === a ? u : decodeURIComponent(u.replace(t, " "));
                    }
                    return i;
                }
                n.d(t, {
                    v: function() {
                        return r;
                    }
                });
            },
            6003: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    p: function() {
                        return o;
                    }
                });
                var r = n(9123);
                function o(e1, t, n) {
                    var o = n.clientId, i = n.issuer, a = n.nonce, u = n.acrValues;
                    if (!t || !i || !o) throw new r.Z("The jwt, iss, and aud arguments are all required");
                    if (a && t.nonce !== a) throw new r.Z("OAuth flow response nonce doesn't match request nonce");
                    var c = Math.floor(Date.now() / 1e3);
                    if (t.iss !== i) throw new r.Z("The issuer [" + t.iss + "] does not match [" + i + "]");
                    if (Array.isArray(t.aud) && t.aud.indexOf(o) < 0 || !Array.isArray(t.aud) && t.aud !== o) throw new r.Z("The audience [" + t.aud + "] does not match [" + o + "]");
                    if (u && t.acr !== u) throw new r.Z("The acr [" + t.acr + "] does not match acr_values [" + u + "]");
                    if (t.iat > t.exp) throw new r.Z("The JWT expired before it was issued");
                    if (!e1.options.ignoreLifetime) {
                        if (c - e1.options.maxClockSkew > t.exp) throw new r.Z("The JWT expired and is no longer valid");
                        if (t.iat > c + e1.options.maxClockSkew) throw new r.Z("The JWT was issued in the future");
                    }
                }
            },
            2482: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    R: function() {
                        return i;
                    }
                });
                var r = n(9123), o = n(6488);
                function i(e1, t) {
                    if (!(0, o.sI)(e1) && !(0, o.hv)(e1) && !(0, o.z9)(e1)) throw new r.Z("Token must be an Object with scopes, expiresAt, and one of: an idToken, accessToken, or refreshToken property");
                    if ("accessToken" === t && !(0, o.hv)(e1)) throw new r.Z("invalid accessToken");
                    if ("idToken" === t && !(0, o.sI)(e1)) throw new r.Z("invalid idToken");
                    if ("refreshToken" === t && !(0, o.z9)(e1)) throw new r.Z("invalid refreshToken");
                }
            },
            1260: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    W: function() {
                        return p;
                    }
                });
                var r = n(5861), o = n(4687), i = n.n(o), a = n(52), u = n(6003), c = n(9123), s = n(1237), f = n(3154), l = n(5698);
                function p(e1, t, n) {
                    return d.apply(this, arguments);
                }
                function d() {
                    return (d = (0, r.Z)(i().mark(function e1(t, n, r) {
                        var o, p, d, h, v, y;
                        return i().wrap(function(e1) {
                            for(;;)switch(e1.prev = e1.next){
                                case 0:
                                    if (n && n.idToken) {
                                        e1.next = 2;
                                        break;
                                    }
                                    throw new c.Z("Only idTokens may be verified");
                                case 2:
                                    return o = (0, s.T)(n.idToken), p = (null == r ? void 0 : r.issuer) || t.options.issuer, e1.next = 6, (0, a.E)(t, p);
                                case 6:
                                    if (d = e1.sent, h = d.issuer, v = Object.assign({
                                        clientId: t.options.clientId,
                                        ignoreSignature: t.options.ignoreSignature
                                    }, r, {
                                        issuer: h
                                    }), (0, u.p)(t, o.payload, v), 1 != v.ignoreSignature && t.features.isTokenVerifySupported()) {
                                        e1.next = 12;
                                        break;
                                    }
                                    return e1.abrupt("return", n);
                                case 12:
                                    return e1.next = 14, (0, a.k)(t, n.issuer, o.header.kid);
                                case 14:
                                    return y = e1.sent, e1.next = 17, f.W(n.idToken, y);
                                case 17:
                                    if (e1.sent) {
                                        e1.next = 20;
                                        break;
                                    }
                                    throw new c.Z("The token signature is not valid");
                                case 20:
                                    if (!(r && r.accessToken && n.claims.at_hash)) {
                                        e1.next = 26;
                                        break;
                                    }
                                    return e1.next = 23, l.X(r.accessToken);
                                case 23:
                                    if (e1.sent === n.claims.at_hash) {
                                        e1.next = 26;
                                        break;
                                    }
                                    throw new c.Z("Token hash verification failed");
                                case 26:
                                    return e1.abrupt("return", n);
                                case 27:
                                case "end":
                                    return e1.stop();
                            }
                        }, e1);
                    }))).apply(this, arguments);
                }
            },
            3719: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Gg: function() {
                        return u;
                    },
                    OT: function() {
                        return f;
                    },
                    RJ: function() {
                        return c;
                    },
                    dx: function() {
                        return s;
                    },
                    sH: function() {
                        return a;
                    }
                });
                var r = n(3193), o = n(6718), i = n(5385);
                function a(e1) {
                    return e1.session.get().then(function(e1) {
                        return "ACTIVE" === e1.status;
                    }).catch(function() {
                        return !1;
                    });
                }
                function u(e1) {
                    return (0, i.U2)(e1, "/api/v1/sessions/me", {
                        withCredentials: !0
                    }).then(function(t) {
                        var n = (0, r.CE)(t, "_links");
                        return n.refresh = function() {
                            return (0, i.v_)(e1, (0, r.Rg)(t, "refresh").href, {}, {
                                withCredentials: !0
                            });
                        }, n.user = function() {
                            return (0, i.U2)(e1, (0, r.Rg)(t, "user").href, {
                                withCredentials: !0
                            });
                        }, n;
                    }).catch(function() {
                        return {
                            status: "INACTIVE"
                        };
                    });
                }
                function c(e1) {
                    return (0, i.c3)(e1, {
                        url: e1.getIssuerOrigin() + "/api/v1/sessions/me",
                        method: "DELETE",
                        withCredentials: !0
                    });
                }
                function s(e1) {
                    return (0, i.v_)(e1, "/api/v1/sessions/me/lifecycle/refresh", {}, {
                        withCredentials: !0
                    });
                }
                function f(e1, t, n) {
                    n = n || window.location.href, window.location.assign(e1.getIssuerOrigin() + "/login/sessionCookieRedirect" + (0, o.UK)({
                        checkAccountSetupComplete: !0,
                        token: t,
                        redirectUrl: n
                    }));
                }
            },
            2815: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    M: function() {
                        return o;
                    }
                });
                var r = n(3719);
                function o(e1) {
                    return {
                        close: r.RJ.bind(null, e1),
                        exists: r.sH.bind(null, e1),
                        get: r.Gg.bind(null, e1),
                        refresh: r.dx.bind(null, e1),
                        setCookieAndRedirect: r.OT.bind(null, e1)
                    };
                }
            },
            8041: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Gg: function() {
                        return r.Gg;
                    },
                    MG: function() {
                        return o.M;
                    },
                    OT: function() {
                        return r.OT;
                    },
                    RJ: function() {
                        return r.RJ;
                    },
                    Zg: function() {
                        return i.Z;
                    },
                    dx: function() {
                        return r.dx;
                    },
                    sH: function() {
                        return r.sH;
                    }
                });
                var r = n(3719), o = n(2815), i = n(3980);
            },
            3980: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return h;
                    }
                });
                var r = n(5861), o = n(5671), i = n(3144), a = n(7326), u = n(136), c = n(2963), s = n(1120), f = n(4942), l = n(4687), p = n.n(l), d = n(2815);
                function h(e1) {
                    return function(e1) {
                        (0, u.Z)(h, e1);
                        var t, n, l = (t = h, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, s.Z)(t);
                            if (n) {
                                var o = (0, s.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, c.Z)(this, e1);
                        });
                        function h() {
                            var e1;
                            (0, o.Z)(this, h);
                            for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                            return e1 = l.call.apply(l, [
                                this
                            ].concat(n)), (0, f.Z)((0, a.Z)(e1), "session", void 0), e1.session = (0, d.M)((0, a.Z)(e1)), e1;
                        }
                        return (0, i.Z)(h, [
                            {
                                key: "closeSession",
                                value: function() {
                                    var e1 = this;
                                    return this.session.close().then((0, r.Z)(p().mark(function t() {
                                        return p().wrap(function(t) {
                                            for(;;)switch(t.prev = t.next){
                                                case 0:
                                                    return e1.clearStorage(), t.abrupt("return", !0);
                                                case 2:
                                                case "end":
                                                    return t.stop();
                                            }
                                        }, t);
                                    }))).catch(function(e1) {
                                        if ("AuthApiError" === e1.name && "E0000007" === e1.errorCode) return !1;
                                        throw e1;
                                    });
                                }
                            }
                        ]), h;
                    }(e1);
                }
            },
            5437: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    V: function() {
                        return f;
                    },
                    W: function() {
                        return l;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(1971), u = n(5763), c = n(415), s = n(146);
                function f(e1) {
                    (0, c.isBrowser)() || e1.storageProvider || e1.storageKey || (0, s.ZK)("Memory storage can only support simple single user use case on server side, please provide custom storageProvider or storageKey if advanced scenarios need to be supported.");
                }
                var l = function() {
                    function e1(t, n, o) {
                        (0, r.Z)(this, e1), (0, i.Z)(this, "storageManagerOptions", void 0), (0, i.Z)(this, "cookieOptions", void 0), (0, i.Z)(this, "storageUtil", void 0), this.storageManagerOptions = t, this.cookieOptions = n, this.storageUtil = o;
                    }
                    return (0, o.Z)(e1, [
                        {
                            key: "getOptionsForSection",
                            value: function(e1, t) {
                                return Object.assign({}, this.storageManagerOptions[e1], t);
                            }
                        },
                        {
                            key: "getStorage",
                            value: function(e1) {
                                if ((e1 = Object.assign({}, this.cookieOptions, e1)).storageProvider) return e1.storageProvider;
                                var t = e1, n = t.storageType, r = t.storageTypes;
                                if ("sessionStorage" === n && (e1.sessionCookie = !0), n && r) {
                                    var o = r.indexOf(n);
                                    o >= 0 && (r = r.slice(o), n = void 0);
                                }
                                return n || (n = this.storageUtil.findStorageType(r)), this.storageUtil.getStorageByType(n, e1);
                            }
                        },
                        {
                            key: "getTokenStorage",
                            value: function(e1) {
                                f(e1 = this.getOptionsForSection("token", e1));
                                var t = this.getStorage(e1), n = e1.storageKey || a.TOKEN_STORAGE_NAME;
                                return new u._(t, n);
                            }
                        },
                        {
                            key: "getHttpCache",
                            value: function(e1) {
                                e1 = this.getOptionsForSection("cache", e1);
                                var t = this.getStorage(e1), n = e1.storageKey || a.CACHE_STORAGE_NAME;
                                return new u._(t, n);
                            }
                        }
                    ]), e1;
                }();
            },
            5763: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    _: function() {
                        return u;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(9123), u = function() {
                    function e1(t, n) {
                        if ((0, r.Z)(this, e1), (0, i.Z)(this, "storageProvider", void 0), (0, i.Z)(this, "storageName", void 0), !t) throw new a.Z('"storage" is required');
                        if ("string" != typeof n || !n.length) throw new a.Z('"storageName" is required');
                        this.storageName = n, this.storageProvider = t;
                    }
                    return (0, o.Z)(e1, [
                        {
                            key: "getItem",
                            value: function(e1) {
                                return this.getStorage()[e1];
                            }
                        },
                        {
                            key: "setItem",
                            value: function(e1, t) {
                                return this.updateStorage(e1, t);
                            }
                        },
                        {
                            key: "removeItem",
                            value: function(e1) {
                                return this.clearStorage(e1);
                            }
                        },
                        {
                            key: "getStorage",
                            value: function() {
                                var e1 = this.storageProvider.getItem(this.storageName);
                                e1 = e1 || "{}";
                                try {
                                    return JSON.parse(e1);
                                } catch (e1) {
                                    throw new a.Z("Unable to parse storage string: " + this.storageName);
                                }
                            }
                        },
                        {
                            key: "setStorage",
                            value: function(e1) {
                                try {
                                    var t = e1 ? JSON.stringify(e1) : "{}";
                                    this.storageProvider.setItem(this.storageName, t);
                                } catch (e1) {
                                    throw new a.Z("Unable to set storage: " + this.storageName);
                                }
                            }
                        },
                        {
                            key: "clearStorage",
                            value: function(e1) {
                                if (e1) {
                                    var t = this.getStorage();
                                    delete t[e1], this.setStorage(t);
                                } else this.storageProvider.removeItem ? this.storageProvider.removeItem(this.storageName) : this.setStorage();
                            }
                        },
                        {
                            key: "updateStorage",
                            value: function(e1, t) {
                                var n = this.getStorage();
                                n[e1] = t, this.setStorage(n);
                            }
                        }
                    ]), e1;
                }();
            },
            9927: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Ho: function() {
                        return i.H;
                    },
                    Tp: function() {
                        return r.T;
                    },
                    Vp: function() {
                        return o.V;
                    },
                    W8: function() {
                        return o.W;
                    },
                    _e: function() {
                        return a._;
                    }
                });
                var r = n(3849), o = n(5437), i = n(265), a = n(5763);
            },
            265: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    H: function() {
                        return f;
                    }
                });
                var r = n(5671), o = n(3144), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942);
                function f(e1, t) {
                    return function(e1) {
                        (0, a.Z)(p, e1);
                        var n, f, l = (n = p, f = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, t = (0, c.Z)(n);
                            if (f) {
                                var r = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(t, arguments, r);
                            } else e1 = t.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function p() {
                            var e1;
                            (0, r.Z)(this, p);
                            for(var n = arguments.length, o = new Array(n), a = 0; a < n; a++)o[a] = arguments[a];
                            e1 = l.call.apply(l, [
                                this
                            ].concat(o)), (0, s.Z)((0, i.Z)(e1), "storageManager", void 0);
                            var u = e1.options, c = u.storageManager, f = u.cookies, d = u.storageUtil;
                            return e1.storageManager = new t(c, f, d), e1;
                        }
                        return (0, o.Z)(p, [
                            {
                                key: "clearStorage",
                                value: function() {}
                            }
                        ]), p;
                    }(e1);
                }
            },
            3849: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    T: function() {
                        return g;
                    }
                });
                var r = n(3144), o = n(5671), i = n(7326), a = n(136), u = n(2963), c = n(1120), s = n(4942), f = n(5093), l = n(146), p = n(4858), d = {
                    token: {
                        storageTypes: [
                            "localStorage",
                            "sessionStorage",
                            "cookie"
                        ]
                    },
                    cache: {
                        storageTypes: [
                            "localStorage",
                            "sessionStorage",
                            "cookie"
                        ]
                    },
                    transaction: {
                        storageTypes: [
                            "sessionStorage",
                            "localStorage",
                            "cookie"
                        ]
                    },
                    "shared-transaction": {
                        storageTypes: [
                            "localStorage"
                        ]
                    },
                    "original-uri": {
                        storageTypes: [
                            "localStorage"
                        ]
                    }
                }, h = n(415);
                function v(e1, t) {
                    var n = Object.keys(e1);
                    if (Object.getOwnPropertySymbols) {
                        var r = Object.getOwnPropertySymbols(e1);
                        t && (r = r.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
                        })), n.push.apply(n, r);
                    }
                    return n;
                }
                function y(e1) {
                    for(var t = 1; t < arguments.length; t++){
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? v(Object(n), !0).forEach(function(t) {
                            (0, s.Z)(e1, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function(t) {
                            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                    }
                    return e1;
                }
                function g() {
                    return function(e1) {
                        (0, a.Z)(v, e1);
                        var t, n, f = (t = v, n = function() {
                            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                            if (Reflect.construct.sham) return !1;
                            if ("function" == typeof Proxy) return !0;
                            try {
                                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                            } catch (e1) {
                                return !1;
                            }
                        }(), function() {
                            var e1, r = (0, c.Z)(t);
                            if (n) {
                                var o = (0, c.Z)(this).constructor;
                                e1 = Reflect.construct(r, arguments, o);
                            } else e1 = r.apply(this, arguments);
                            return (0, u.Z)(this, e1);
                        });
                        function v(e1) {
                            var t;
                            return (0, o.Z)(this, v), t = f.call(this, e1), (0, s.Z)((0, i.Z)(t), "cookies", void 0), (0, s.Z)((0, i.Z)(t), "storageUtil", void 0), (0, s.Z)((0, i.Z)(t), "storageManager", void 0), t.cookies = function() {
                                var e1 = arguments.length > 1 ? arguments[1] : void 0, t = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).cookies || {};
                                return void 0 === t.secure && (t.secure = e1), void 0 === t.sameSite && (t.sameSite = t.secure ? "none" : "lax"), t.secure && !e1 && ((0, l.ZK)('The current page is not being served with the HTTPS protocol.\nFor security reasons, we strongly recommend using HTTPS.\nIf you cannot use HTTPS, set "cookies.secure" option to false.'), t.secure = !1), "none" !== t.sameSite || t.secure || (t.sameSite = "lax"), t;
                            }(e1, (0, h.isHTTPS)()), t.storageUtil = e1.storageUtil || Object.assign({}, p.Z, {
                                inMemoryStore: {}
                            }), t.storageManager = y(y({}, d), e1.storageManager), t;
                        }
                        return (0, r.Z)(v);
                    }((0, f.X)());
                }
            },
            3548: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    b: function() {
                        return c;
                    }
                });
                var r = n(5671), o = n(3144), i = n(4942), a = n(4771), u = n(146), c = function() {
                    function e1() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
                            quiet: !1
                        };
                        (0, r.Z)(this, e1), (0, i.Z)(this, "queue", void 0), (0, i.Z)(this, "running", void 0), (0, i.Z)(this, "options", void 0), this.queue = [], this.running = !1, this.options = t;
                    }
                    return (0, o.Z)(e1, [
                        {
                            key: "push",
                            value: function(e1, t) {
                                for(var n = this, r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++)o[i - 2] = arguments[i];
                                return new Promise(function(r, i) {
                                    n.queue.length > 0 && !1 !== n.options.quiet && (0, u.ZK)("Async method is being called but another async method is already running. The new method will be delayed until the previous method completes."), n.queue.push({
                                        method: e1,
                                        thisObject: t,
                                        args: o,
                                        resolve: r,
                                        reject: i
                                    }), n.run();
                                });
                            }
                        },
                        {
                            key: "run",
                            value: function() {
                                var e1 = this;
                                if (!this.running && 0 !== this.queue.length) {
                                    this.running = !0;
                                    var t = this.queue.shift(), n = t.method.apply(t.thisObject, t.args);
                                    (0, a.tI)(n) ? n.then(t.resolve, t.reject).finally(function() {
                                        e1.running = !1, e1.run();
                                    }) : (t.resolve(n), this.running = !1, this.run());
                                }
                            }
                        }
                    ]), e1;
                }();
            },
            146: function(e1, t, n) {
                "use strict";
                function r() {
                    return "undefined" != typeof window ? window.console : "undefined" != typeof console ? console : void 0;
                }
                function o() {
                    var e1 = r();
                    return e1 && e1.log ? e1 : {
                        log: function() {},
                        warn: function() {},
                        group: function() {},
                        groupEnd: function() {}
                    };
                }
                function i(e1) {
                    o().warn("[okta-auth-sdk] WARN: " + e1);
                }
                function a(e1) {
                    o().warn("[okta-auth-sdk] DEPRECATION: " + e1);
                }
                function u(e1, t) {
                    return function() {
                        return a(e1), t.apply(null, arguments);
                    };
                }
                n.d(t, {
                    Rn: function() {
                        return a;
                    },
                    VA: function() {
                        return u;
                    },
                    ZK: function() {
                        return i;
                    },
                    dr: function() {
                        return o;
                    },
                    sW: function() {
                        return r;
                    }
                });
            },
            305: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    BY: function() {
                        return c.BY;
                    },
                    CE: function() {
                        return i.CE;
                    },
                    HD: function() {
                        return u.HD;
                    },
                    Kn: function() {
                        return u.Kn;
                    },
                    QN: function() {
                        return c.QN;
                    },
                    Qj: function() {
                        return c.Qj;
                    },
                    Rg: function() {
                        return i.Rg;
                    },
                    Rn: function() {
                        return r.Rn;
                    },
                    UK: function() {
                        return c.UK;
                    },
                    VA: function() {
                        return r.VA;
                    },
                    YQ: function() {
                        return o.YQ;
                    },
                    YY: function() {
                        return i.YY;
                    },
                    ZK: function() {
                        return r.ZK;
                    },
                    ak: function() {
                        return i.ak;
                    },
                    bo: function() {
                        return a.b;
                    },
                    d9: function() {
                        return i.d9;
                    },
                    dr: function() {
                        return r.dr;
                    },
                    gw: function() {
                        return o.gw;
                    },
                    hj: function() {
                        return u.hj;
                    },
                    l7: function() {
                        return i.l7;
                    },
                    mf: function() {
                        return u.mf;
                    },
                    ng: function() {
                        return o.ng;
                    },
                    sD: function() {
                        return c.sD;
                    },
                    sE: function() {
                        return i.sE;
                    },
                    sW: function() {
                        return r.sW;
                    },
                    tI: function() {
                        return u.tI;
                    },
                    uh: function() {
                        return o.uh;
                    }
                });
                var r = n(146), o = n(8750), i = n(3193), a = n(3548), u = n(4771), c = n(6718);
            },
            8750: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    var t = e1.match(/\d+/g), n = Date.UTC(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
                    return new Date(n).toUTCString();
                }
                function o(e1) {
                    for(var t = "", n = 0; n < e1; ++n)t += "abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"[Math.floor(61 * Math.random())];
                    return t;
                }
                function i(e1) {
                    return new Promise(function(t) {
                        setTimeout(t, e1);
                    });
                }
                function a(e1, t) {
                    var n = e1.split(t);
                    return [
                        n[0],
                        n.splice(1, n.length).join(t)
                    ];
                }
                n.d(t, {
                    YQ: function() {
                        return a;
                    },
                    gw: function() {
                        return i;
                    },
                    ng: function() {
                        return r;
                    },
                    uh: function() {
                        return o;
                    }
                });
            },
            3193: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    var n = Array.prototype.slice.call(arguments, 2);
                    return function() {
                        var r = Array.prototype.slice.call(arguments);
                        return r = n.concat(r), e1.apply(t, r);
                    };
                }
                function o() {
                    var e1 = arguments[0];
                    return [].slice.call(arguments, 1).forEach(function(t) {
                        for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && void 0 !== t[n] && (e1[n] = t[n]);
                    }), e1;
                }
                function i(e1) {
                    var t = {};
                    for(var n in e1)if (Object.prototype.hasOwnProperty.call(e1, n)) {
                        var r = e1[n];
                        null != r && (t[n] = r);
                    }
                    return t;
                }
                function a(e1) {
                    if (e1) {
                        var t = JSON.stringify(e1);
                        if (t) return JSON.parse(t);
                    }
                    return e1;
                }
                function u(e1) {
                    for(var t = {}, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)r[o - 1] = arguments[o];
                    for(var i in e1)Object.prototype.hasOwnProperty.call(e1, i) && -1 == r.indexOf(i) && (t[i] = e1[i]);
                    return a(t);
                }
                function c(e1, t) {
                    for(var n = e1.length; n--;){
                        var r = e1[n], o = !0;
                        for(var i in t)if (Object.prototype.hasOwnProperty.call(t, i) && r[i] !== t[i]) {
                            o = !1;
                            break;
                        }
                        if (o) return r;
                    }
                }
                function s(e1, t, n) {
                    if (e1 && e1._links) {
                        var r = a(e1._links[t]);
                        return r && r.name && n ? r.name === n ? r : void 0 : r;
                    }
                }
                n.d(t, {
                    CE: function() {
                        return u;
                    },
                    Rg: function() {
                        return s;
                    },
                    YY: function() {
                        return i;
                    },
                    ak: function() {
                        return r;
                    },
                    d9: function() {
                        return a;
                    },
                    l7: function() {
                        return o;
                    },
                    sE: function() {
                        return c;
                    }
                });
            },
            4771: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return "[object String]" === Object.prototype.toString.call(e1);
                }
                function o(e1) {
                    return "[object Object]" === Object.prototype.toString.call(e1);
                }
                function i(e1) {
                    return "[object Number]" === Object.prototype.toString.call(e1);
                }
                function a(e1) {
                    return !!e1 && "[object Function]" === ({}).toString.call(e1);
                }
                function u(e1) {
                    return e1 && e1.finally && "function" == typeof e1.finally;
                }
                n.d(t, {
                    HD: function() {
                        return r;
                    },
                    Kn: function() {
                        return o;
                    },
                    hj: function() {
                        return i;
                    },
                    mf: function() {
                        return a;
                    },
                    tI: function() {
                        return u;
                    }
                });
            },
            6718: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return /^[a-z][a-z0-9+.-]*:/i.test(e1);
                }
                function o() {
                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t = arguments.length > 1 ? arguments[1] : void 0;
                    return r(e1) ? e1 : (t = u(t), "/" === e1[0] ? "".concat(t).concat(e1) : "".concat(t, "/").concat(e1));
                }
                function i() {
                    var e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t = arguments.length > 1 ? arguments[1] : void 0;
                    return r(e1) && (e1 = e1.substring(t.length)), "/" === e1[0] ? e1 : "/".concat(e1);
                }
                function a(e1) {
                    var t = [];
                    if (null !== e1) for(var n in e1)Object.prototype.hasOwnProperty.call(e1, n) && void 0 !== e1[n] && null !== e1[n] && t.push(n + "=" + encodeURIComponent(e1[n]));
                    return t.length ? "?" + t.join("&") : "";
                }
                function u(e1) {
                    if (e1) {
                        var t = e1.replace(/^\s+|\s+$/gm, "");
                        return t.replace(/\/+$/, "");
                    }
                }
                n.d(t, {
                    BY: function() {
                        return o;
                    },
                    QN: function() {
                        return i;
                    },
                    Qj: function() {
                        return u;
                    },
                    UK: function() {
                        return a;
                    },
                    sD: function() {
                        return r;
                    }
                });
            },
            3615: function(e1, t, n) {
                "use strict";
                var r = n(6690), o = n(9728), i = n(1655), a = n(4993), u = n(3808);
                function c(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = new Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                var s = function(e1) {
                    i(s, e1);
                    var t, n, c = (t = s, n = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), function() {
                        var e1, r = u(t);
                        if (n) {
                            var o = u(this).constructor;
                            e1 = Reflect.construct(r, arguments, o);
                        } else e1 = r.apply(this, arguments);
                        return a(this, e1);
                    });
                    function s(e1) {
                        var t;
                        return r(this, s), (t = c.call(this, e1 || "Promise was canceled")).name = "CancelError", t;
                    }
                    return o(s, [
                        {
                            key: "isCanceled",
                            get: function() {
                                return !0;
                            }
                        }
                    ]), s;
                }(n(3496)(Error)), f = function() {
                    function e1(t) {
                        var n = this;
                        r(this, e1), this._cancelHandlers = [], this._isPending = !0, this._isCanceled = !1, this._rejectOnCancel = !0, this._promise = new Promise(function(e1, r) {
                            n._reject = r;
                            var o = function(e1) {
                                if (!n._isPending) throw new Error("The `onCancel` handler was attached after the promise settled.");
                                n._cancelHandlers.push(e1);
                            };
                            return Object.defineProperties(o, {
                                shouldReject: {
                                    get: function() {
                                        return n._rejectOnCancel;
                                    },
                                    set: function(e1) {
                                        n._rejectOnCancel = e1;
                                    }
                                }
                            }), t(function(t) {
                                n._isCanceled && o.shouldReject || (n._isPending = !1, e1(t));
                            }, function(e1) {
                                n._isPending = !1, r(e1);
                            }, o);
                        });
                    }
                    return o(e1, [
                        {
                            key: "then",
                            value: function(e1, t) {
                                return this._promise.then(e1, t);
                            }
                        },
                        {
                            key: "catch",
                            value: function(e1) {
                                return this._promise.catch(e1);
                            }
                        },
                        {
                            key: "finally",
                            value: function(e1) {
                                return this._promise.finally(e1);
                            }
                        },
                        {
                            key: "cancel",
                            value: function(e1) {
                                if (this._isPending && !this._isCanceled) {
                                    if (this._isCanceled = !0, this._cancelHandlers.length > 0) try {
                                        var t, n = function(e1, t) {
                                            var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                                            if (!n) {
                                                if (Array.isArray(e1) || (n = function(e1, t) {
                                                    if (e1) {
                                                        if ("string" == typeof e1) return c(e1, t);
                                                        var n = Object.prototype.toString.call(e1).slice(8, -1);
                                                        return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? c(e1, t) : void 0;
                                                    }
                                                }(e1)) || t && e1 && "number" == typeof e1.length) {
                                                    n && (e1 = n);
                                                    var r = 0, o = function() {};
                                                    return {
                                                        s: o,
                                                        n: function() {
                                                            return r >= e1.length ? {
                                                                done: !0
                                                            } : {
                                                                done: !1,
                                                                value: e1[r++]
                                                            };
                                                        },
                                                        e: function(e1) {
                                                            throw e1;
                                                        },
                                                        f: o
                                                    };
                                                }
                                                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                                            }
                                            var i, a = !0, u = !1;
                                            return {
                                                s: function() {
                                                    n = n.call(e1);
                                                },
                                                n: function() {
                                                    var e1 = n.next();
                                                    return a = e1.done, e1;
                                                },
                                                e: function(e1) {
                                                    u = !0, i = e1;
                                                },
                                                f: function() {
                                                    try {
                                                        a || null == n.return || n.return();
                                                    } finally{
                                                        if (u) throw i;
                                                    }
                                                }
                                            };
                                        }(this._cancelHandlers);
                                        try {
                                            for(n.s(); !(t = n.n()).done;)(0, t.value)();
                                        } catch (e1) {
                                            n.e(e1);
                                        } finally{
                                            n.f();
                                        }
                                    } catch (e1) {
                                        return void this._reject(e1);
                                    }
                                    this._rejectOnCancel && this._reject(new s(e1));
                                }
                            }
                        },
                        {
                            key: "isCanceled",
                            get: function() {
                                return this._isCanceled;
                            }
                        }
                    ], [
                        {
                            key: "fn",
                            value: function(t) {
                                return function() {
                                    for(var n = arguments.length, r = new Array(n), o = 0; o < n; o++)r[o] = arguments[o];
                                    return new e1(function(e1, n, o) {
                                        r.push(o), t.apply(void 0, r).then(e1, n);
                                    });
                                };
                            }
                        }
                    ]), e1;
                }();
                Object.setPrototypeOf(f.prototype, Promise.prototype), e1.exports = f, e1.exports.CancelError = s;
            },
            4098: function(e1, t) {
                var n = "undefined" != typeof self ? self : this, r = function() {
                    function e1() {
                        this.fetch = !1, this.DOMException = n.DOMException;
                    }
                    return e1.prototype = n, new e1;
                }();
                !function(e1) {
                    !function(t) {
                        var n = {
                            searchParams: "URLSearchParams" in e1,
                            iterable: "Symbol" in e1 && "iterator" in Symbol,
                            blob: "FileReader" in e1 && "Blob" in e1 && function() {
                                try {
                                    return new Blob, !0;
                                } catch (e1) {
                                    return !1;
                                }
                            }(),
                            formData: "FormData" in e1,
                            arrayBuffer: "ArrayBuffer" in e1
                        };
                        if (n.arrayBuffer) var r = [
                            "[object Int8Array]",
                            "[object Uint8Array]",
                            "[object Uint8ClampedArray]",
                            "[object Int16Array]",
                            "[object Uint16Array]",
                            "[object Int32Array]",
                            "[object Uint32Array]",
                            "[object Float32Array]",
                            "[object Float64Array]"
                        ], o = ArrayBuffer.isView || function(e1) {
                            return e1 && r.indexOf(Object.prototype.toString.call(e1)) > -1;
                        };
                        function i(e1) {
                            if ("string" != typeof e1 && (e1 = String(e1)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e1)) throw new TypeError("Invalid character in header field name");
                            return e1.toLowerCase();
                        }
                        function a(e1) {
                            return "string" != typeof e1 && (e1 = String(e1)), e1;
                        }
                        function u(e1) {
                            var t = {
                                next: function() {
                                    var t = e1.shift();
                                    return {
                                        done: void 0 === t,
                                        value: t
                                    };
                                }
                            };
                            return n.iterable && (t[Symbol.iterator] = function() {
                                return t;
                            }), t;
                        }
                        function c(e1) {
                            this.map = {}, e1 instanceof c ? e1.forEach(function(e1, t) {
                                this.append(t, e1);
                            }, this) : Array.isArray(e1) ? e1.forEach(function(e1) {
                                this.append(e1[0], e1[1]);
                            }, this) : e1 && Object.getOwnPropertyNames(e1).forEach(function(t) {
                                this.append(t, e1[t]);
                            }, this);
                        }
                        function s(e1) {
                            if (e1.bodyUsed) return Promise.reject(new TypeError("Already read"));
                            e1.bodyUsed = !0;
                        }
                        function f(e1) {
                            return new Promise(function(t, n) {
                                e1.onload = function() {
                                    t(e1.result);
                                }, e1.onerror = function() {
                                    n(e1.error);
                                };
                            });
                        }
                        function l(e1) {
                            var t = new FileReader, n = f(t);
                            return t.readAsArrayBuffer(e1), n;
                        }
                        function p(e1) {
                            if (e1.slice) return e1.slice(0);
                            var t = new Uint8Array(e1.byteLength);
                            return t.set(new Uint8Array(e1)), t.buffer;
                        }
                        function d() {
                            return this.bodyUsed = !1, this._initBody = function(e1) {
                                var t;
                                this._bodyInit = e1, e1 ? "string" == typeof e1 ? this._bodyText = e1 : n.blob && Blob.prototype.isPrototypeOf(e1) ? this._bodyBlob = e1 : n.formData && FormData.prototype.isPrototypeOf(e1) ? this._bodyFormData = e1 : n.searchParams && URLSearchParams.prototype.isPrototypeOf(e1) ? this._bodyText = e1.toString() : n.arrayBuffer && n.blob && (t = e1) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = p(e1.buffer), this._bodyInit = new Blob([
                                    this._bodyArrayBuffer
                                ])) : n.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(e1) || o(e1)) ? this._bodyArrayBuffer = p(e1) : this._bodyText = e1 = Object.prototype.toString.call(e1) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e1 ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : n.searchParams && URLSearchParams.prototype.isPrototypeOf(e1) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
                            }, n.blob && (this.blob = function() {
                                var e1 = s(this);
                                if (e1) return e1;
                                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                                if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                                    this._bodyArrayBuffer
                                ]));
                                if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                                return Promise.resolve(new Blob([
                                    this._bodyText
                                ]));
                            }, this.arrayBuffer = function() {
                                return this._bodyArrayBuffer ? s(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(l);
                            }), this.text = function() {
                                var e1, t, n, r = s(this);
                                if (r) return r;
                                if (this._bodyBlob) return e1 = this._bodyBlob, n = f(t = new FileReader), t.readAsText(e1), n;
                                if (this._bodyArrayBuffer) return Promise.resolve(function(e1) {
                                    for(var t = new Uint8Array(e1), n = new Array(t.length), r = 0; r < t.length; r++)n[r] = String.fromCharCode(t[r]);
                                    return n.join("");
                                }(this._bodyArrayBuffer));
                                if (this._bodyFormData) throw new Error("could not read FormData body as text");
                                return Promise.resolve(this._bodyText);
                            }, n.formData && (this.formData = function() {
                                return this.text().then(y);
                            }), this.json = function() {
                                return this.text().then(JSON.parse);
                            }, this;
                        }
                        c.prototype.append = function(e1, t) {
                            e1 = i(e1), t = a(t);
                            var n = this.map[e1];
                            this.map[e1] = n ? n + ", " + t : t;
                        }, c.prototype.delete = function(e1) {
                            delete this.map[i(e1)];
                        }, c.prototype.get = function(e1) {
                            return e1 = i(e1), this.has(e1) ? this.map[e1] : null;
                        }, c.prototype.has = function(e1) {
                            return this.map.hasOwnProperty(i(e1));
                        }, c.prototype.set = function(e1, t) {
                            this.map[i(e1)] = a(t);
                        }, c.prototype.forEach = function(e1, t) {
                            for(var n in this.map)this.map.hasOwnProperty(n) && e1.call(t, this.map[n], n, this);
                        }, c.prototype.keys = function() {
                            var e1 = [];
                            return this.forEach(function(t, n) {
                                e1.push(n);
                            }), u(e1);
                        }, c.prototype.values = function() {
                            var e1 = [];
                            return this.forEach(function(t) {
                                e1.push(t);
                            }), u(e1);
                        }, c.prototype.entries = function() {
                            var e1 = [];
                            return this.forEach(function(t, n) {
                                e1.push([
                                    n,
                                    t
                                ]);
                            }), u(e1);
                        }, n.iterable && (c.prototype[Symbol.iterator] = c.prototype.entries);
                        var h = [
                            "DELETE",
                            "GET",
                            "HEAD",
                            "OPTIONS",
                            "POST",
                            "PUT"
                        ];
                        function v(e1, t) {
                            var n, r, o = (t = t || {}).body;
                            if (e1 instanceof v) {
                                if (e1.bodyUsed) throw new TypeError("Already read");
                                this.url = e1.url, this.credentials = e1.credentials, t.headers || (this.headers = new c(e1.headers)), this.method = e1.method, this.mode = e1.mode, this.signal = e1.signal, o || null == e1._bodyInit || (o = e1._bodyInit, e1.bodyUsed = !0);
                            } else this.url = String(e1);
                            if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new c(t.headers)), this.method = (r = (n = t.method || this.method || "GET").toUpperCase(), h.indexOf(r) > -1 ? r : n), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && o) throw new TypeError("Body not allowed for GET or HEAD requests");
                            this._initBody(o);
                        }
                        function y(e1) {
                            var t = new FormData;
                            return e1.trim().split("&").forEach(function(e1) {
                                if (e1) {
                                    var n = e1.split("="), r = n.shift().replace(/\+/g, " "), o = n.join("=").replace(/\+/g, " ");
                                    t.append(decodeURIComponent(r), decodeURIComponent(o));
                                }
                            }), t;
                        }
                        function g(e1, t) {
                            t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new c(t.headers), this.url = t.url || "", this._initBody(e1);
                        }
                        v.prototype.clone = function() {
                            return new v(this, {
                                body: this._bodyInit
                            });
                        }, d.call(v.prototype), d.call(g.prototype), g.prototype.clone = function() {
                            return new g(this._bodyInit, {
                                status: this.status,
                                statusText: this.statusText,
                                headers: new c(this.headers),
                                url: this.url
                            });
                        }, g.error = function() {
                            var e1 = new g(null, {
                                status: 0,
                                statusText: ""
                            });
                            return e1.type = "error", e1;
                        };
                        var m = [
                            301,
                            302,
                            303,
                            307,
                            308
                        ];
                        g.redirect = function(e1, t) {
                            if (-1 === m.indexOf(t)) throw new RangeError("Invalid status code");
                            return new g(null, {
                                status: t,
                                headers: {
                                    location: e1
                                }
                            });
                        }, t.DOMException = e1.DOMException;
                        try {
                            new t.DOMException;
                        } catch (e1) {
                            t.DOMException = function(e1, t) {
                                this.message = e1, this.name = t;
                                var n = Error(e1);
                                this.stack = n.stack;
                            }, t.DOMException.prototype = Object.create(Error.prototype), t.DOMException.prototype.constructor = t.DOMException;
                        }
                        function b(e1, r) {
                            return new Promise(function(o, i) {
                                var a = new v(e1, r);
                                if (a.signal && a.signal.aborted) return i(new t.DOMException("Aborted", "AbortError"));
                                var u = new XMLHttpRequest;
                                function s() {
                                    u.abort();
                                }
                                u.onload = function() {
                                    var e1, t, n = {
                                        status: u.status,
                                        statusText: u.statusText,
                                        headers: (e1 = u.getAllResponseHeaders() || "", t = new c, e1.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function(e1) {
                                            var n = e1.split(":"), r = n.shift().trim();
                                            if (r) {
                                                var o = n.join(":").trim();
                                                t.append(r, o);
                                            }
                                        }), t)
                                    };
                                    n.url = "responseURL" in u ? u.responseURL : n.headers.get("X-Request-URL");
                                    var r = "response" in u ? u.response : u.responseText;
                                    o(new g(r, n));
                                }, u.onerror = function() {
                                    i(new TypeError("Network request failed"));
                                }, u.ontimeout = function() {
                                    i(new TypeError("Network request failed"));
                                }, u.onabort = function() {
                                    i(new t.DOMException("Aborted", "AbortError"));
                                }, u.open(a.method, a.url, !0), "include" === a.credentials ? u.withCredentials = !0 : "omit" === a.credentials && (u.withCredentials = !1), "responseType" in u && n.blob && (u.responseType = "blob"), a.headers.forEach(function(e1, t) {
                                    u.setRequestHeader(t, e1);
                                }), a.signal && (a.signal.addEventListener("abort", s), u.onreadystatechange = function() {
                                    4 === u.readyState && a.signal.removeEventListener("abort", s);
                                }), u.send(void 0 === a._bodyInit ? null : a._bodyInit);
                            });
                        }
                        b.polyfill = !0, e1.fetch || (e1.fetch = b, e1.Headers = c, e1.Request = v, e1.Response = g), t.Headers = c, t.Request = v, t.Response = g, t.fetch = b, Object.defineProperty(t, "__esModule", {
                            value: !0
                        });
                    }({});
                }(r), r.fetch.ponyfill = !0, delete r.fetch.polyfill;
                var o = r;
                (t = o.fetch).default = o.fetch, t.fetch = o.fetch, t.Headers = o.Headers, t.Request = o.Request, t.Response = o.Response, e1.exports = t;
            },
            4279: function(e1) {
                function t() {}
                t.prototype = {
                    on: function(e1, t, n) {
                        var r = this.e || (this.e = {});
                        return (r[e1] || (r[e1] = [])).push({
                            fn: t,
                            ctx: n
                        }), this;
                    },
                    once: function(e1, t, n) {
                        var r = this;
                        function o() {
                            r.off(e1, o), t.apply(n, arguments);
                        }
                        return o._ = t, this.on(e1, o, n);
                    },
                    emit: function(e1) {
                        for(var t = [].slice.call(arguments, 1), n = ((this.e || (this.e = {}))[e1] || []).slice(), r = 0, o = n.length; r < o; r++)n[r].fn.apply(n[r].ctx, t);
                        return this;
                    },
                    off: function(e1, t) {
                        var n = this.e || (this.e = {}), r = n[e1], o = [];
                        if (r && t) for(var i = 0, a = r.length; i < a; i++)r[i].fn !== t && r[i].fn._ !== t && o.push(r[i]);
                        return o.length ? n[e1] = o : delete n[e1], this;
                    }
                }, e1.exports = t;
            },
            6115: function(e1) {
                e1.exports = function(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            6690: function(e1) {
                e1.exports = function(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            3515: function(e1, t, n) {
                var r = n(9617), o = n(6015);
                e1.exports = function(e1, t, n) {
                    if (r()) return Reflect.construct.apply(null, arguments);
                    var i = [
                        null
                    ];
                    i.push.apply(i, t);
                    var a = new (e1.bind.apply(e1, i));
                    return n && o(a, n.prototype), a;
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            9728: function(e1, t, n) {
                var r = n(4062);
                function o(e1, t) {
                    for(var n = 0; n < t.length; n++){
                        var o = t[n];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, r(o.key), o);
                    }
                }
                e1.exports = function(e1, t, n) {
                    return t && o(e1.prototype, t), n && o(e1, n), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            3808: function(e1) {
                function t(n) {
                    return e1.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports, t(n);
                }
                e1.exports = t, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            1655: function(e1, t, n) {
                var r = n(6015);
                e1.exports = function(e1, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e1.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e1,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), t && r(e1, t);
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            6035: function(e1) {
                e1.exports = function(e1) {
                    try {
                        return -1 !== Function.toString.call(e1).indexOf("[native code]");
                    } catch (t) {
                        return "function" == typeof e1;
                    }
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            9617: function(e1) {
                function t() {
                    try {
                        var n = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    } catch (n) {}
                    return (e1.exports = t = function() {
                        return !!n;
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports)();
                }
                e1.exports = t, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            4993: function(e1, t, n) {
                var r = n(8698).default, o = n(6115);
                e1.exports = function(e1, t) {
                    if (t && ("object" == r(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return o(e1);
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            7061: function(e1, t, n) {
                var r = n(8698).default;
                function o() {
                    "use strict";
                    e1.exports = o = function() {
                        return n;
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
                    var t, n = {}, i = Object.prototype, a = i.hasOwnProperty, u = Object.defineProperty || function(e1, t, n) {
                        e1[t] = n.value;
                    }, c = "function" == typeof Symbol ? Symbol : {}, s = c.iterator || "@@iterator", f = c.asyncIterator || "@@asyncIterator", l = c.toStringTag || "@@toStringTag";
                    function p(e1, t, n) {
                        return Object.defineProperty(e1, t, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e1[t];
                    }
                    try {
                        p({}, "");
                    } catch (t) {
                        p = function(e1, t, n) {
                            return e1[t] = n;
                        };
                    }
                    function d(e1, t, n, r) {
                        var o = t && t.prototype instanceof k ? t : k, i = Object.create(o.prototype), a = new C(r || []);
                        return u(i, "_invoke", {
                            value: A(e1, n, a)
                        }), i;
                    }
                    function h(e1, t, n) {
                        try {
                            return {
                                type: "normal",
                                arg: e1.call(t, n)
                            };
                        } catch (e1) {
                            return {
                                type: "throw",
                                arg: e1
                            };
                        }
                    }
                    n.wrap = d;
                    var v = "suspendedStart", y = "suspendedYield", g = "executing", m = "completed", b = {};
                    function k() {}
                    function w() {}
                    function O() {}
                    var Z = {};
                    p(Z, s, function() {
                        return this;
                    });
                    var T = Object.getPrototypeOf, E = T && T(T(I([])));
                    E && E !== i && a.call(E, s) && (Z = E);
                    var P = O.prototype = k.prototype = Object.create(Z);
                    function S(e1) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            p(e1, t, function(e1) {
                                return this._invoke(t, e1);
                            });
                        });
                    }
                    function x(e1, t) {
                        function n(o, i, u, c) {
                            var s = h(e1[o], e1, i);
                            if ("throw" !== s.type) {
                                var f = s.arg, l = f.value;
                                return l && "object" == r(l) && a.call(l, "__await") ? t.resolve(l.__await).then(function(e1) {
                                    n("next", e1, u, c);
                                }, function(e1) {
                                    n("throw", e1, u, c);
                                }) : t.resolve(l).then(function(e1) {
                                    f.value = e1, u(f);
                                }, function(e1) {
                                    return n("throw", e1, u, c);
                                });
                            }
                            c(s.arg);
                        }
                        var o;
                        u(this, "_invoke", {
                            value: function(e1, r) {
                                function i() {
                                    return new t(function(t, o) {
                                        n(e1, r, t, o);
                                    });
                                }
                                return o = o ? o.then(i, i) : i();
                            }
                        });
                    }
                    function A(e1, n, r) {
                        var o = v;
                        return function(i, a) {
                            if (o === g) throw Error("Generator is already running");
                            if (o === m) {
                                if ("throw" === i) throw a;
                                return {
                                    value: t,
                                    done: !0
                                };
                            }
                            for(r.method = i, r.arg = a;;){
                                var u = r.delegate;
                                if (u) {
                                    var c = R(u, r);
                                    if (c) {
                                        if (c === b) continue;
                                        return c;
                                    }
                                }
                                if ("next" === r.method) r.sent = r._sent = r.arg;
                                else if ("throw" === r.method) {
                                    if (o === v) throw o = m, r.arg;
                                    r.dispatchException(r.arg);
                                } else "return" === r.method && r.abrupt("return", r.arg);
                                o = g;
                                var s = h(e1, n, r);
                                if ("normal" === s.type) {
                                    if (o = r.done ? m : y, s.arg === b) continue;
                                    return {
                                        value: s.arg,
                                        done: r.done
                                    };
                                }
                                "throw" === s.type && (o = m, r.method = "throw", r.arg = s.arg);
                            }
                        };
                    }
                    function R(e1, n) {
                        var r = n.method, o = e1.iterator[r];
                        if (o === t) return n.delegate = null, "throw" === r && e1.iterator.return && (n.method = "return", n.arg = t, R(e1, n), "throw" === n.method) || "return" !== r && (n.method = "throw", n.arg = new TypeError("The iterator does not provide a '" + r + "' method")), b;
                        var i = h(o, e1.iterator, n.arg);
                        if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, b;
                        var a = i.arg;
                        return a ? a.done ? (n[e1.resultName] = a.value, n.next = e1.nextLoc, "return" !== n.method && (n.method = "next", n.arg = t), n.delegate = null, b) : a : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, b);
                    }
                    function _(e1) {
                        var t = {
                            tryLoc: e1[0]
                        };
                        1 in e1 && (t.catchLoc = e1[1]), 2 in e1 && (t.finallyLoc = e1[2], t.afterLoc = e1[3]), this.tryEntries.push(t);
                    }
                    function j(e1) {
                        var t = e1.completion || {};
                        t.type = "normal", delete t.arg, e1.completion = t;
                    }
                    function C(e1) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e1.forEach(_, this), this.reset(!0);
                    }
                    function I(e1) {
                        if (e1 || "" === e1) {
                            var n = e1[s];
                            if (n) return n.call(e1);
                            if ("function" == typeof e1.next) return e1;
                            if (!isNaN(e1.length)) {
                                var o = -1, i = function n() {
                                    for(; ++o < e1.length;)if (a.call(e1, o)) return n.value = e1[o], n.done = !1, n;
                                    return n.value = t, n.done = !0, n;
                                };
                                return i.next = i;
                            }
                        }
                        throw new TypeError(r(e1) + " is not iterable");
                    }
                    return w.prototype = O, u(P, "constructor", {
                        value: O,
                        configurable: !0
                    }), u(O, "constructor", {
                        value: w,
                        configurable: !0
                    }), w.displayName = p(O, l, "GeneratorFunction"), n.isGeneratorFunction = function(e1) {
                        var t = "function" == typeof e1 && e1.constructor;
                        return !!t && (t === w || "GeneratorFunction" === (t.displayName || t.name));
                    }, n.mark = function(e1) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e1, O) : (e1.__proto__ = O, p(e1, l, "GeneratorFunction")), e1.prototype = Object.create(P), e1;
                    }, n.awrap = function(e1) {
                        return {
                            __await: e1
                        };
                    }, S(x.prototype), p(x.prototype, f, function() {
                        return this;
                    }), n.AsyncIterator = x, n.async = function(e1, t, r, o, i) {
                        void 0 === i && (i = Promise);
                        var a = new x(d(e1, t, r, o), i);
                        return n.isGeneratorFunction(t) ? a : a.next().then(function(e1) {
                            return e1.done ? e1.value : a.next();
                        });
                    }, S(P), p(P, l, "Generator"), p(P, s, function() {
                        return this;
                    }), p(P, "toString", function() {
                        return "[object Generator]";
                    }), n.keys = function(e1) {
                        var t = Object(e1), n = [];
                        for(var r in t)n.push(r);
                        return n.reverse(), function e1() {
                            for(; n.length;){
                                var r = n.pop();
                                if (r in t) return e1.value = r, e1.done = !1, e1;
                            }
                            return e1.done = !0, e1;
                        };
                    }, n.values = I, C.prototype = {
                        constructor: C,
                        reset: function(e1) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(j), !e1) for(var n in this)"t" === n.charAt(0) && a.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t);
                        },
                        stop: function() {
                            this.done = !0;
                            var e1 = this.tryEntries[0].completion;
                            if ("throw" === e1.type) throw e1.arg;
                            return this.rval;
                        },
                        dispatchException: function(e1) {
                            if (this.done) throw e1;
                            var n = this;
                            function r(r, o) {
                                return u.type = "throw", u.arg = e1, n.next = r, o && (n.method = "next", n.arg = t), !!o;
                            }
                            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                                var i = this.tryEntries[o], u = i.completion;
                                if ("root" === i.tryLoc) return r("end");
                                if (i.tryLoc <= this.prev) {
                                    var c = a.call(i, "catchLoc"), s = a.call(i, "finallyLoc");
                                    if (c && s) {
                                        if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                                        if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                                    } else if (c) {
                                        if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                                    } else {
                                        if (!s) throw Error("try statement without catch or finally");
                                        if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e1, t) {
                            for(var n = this.tryEntries.length - 1; n >= 0; --n){
                                var r = this.tryEntries[n];
                                if (r.tryLoc <= this.prev && a.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                                    var o = r;
                                    break;
                                }
                            }
                            o && ("break" === e1 || "continue" === e1) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                            var i = o ? o.completion : {};
                            return i.type = e1, i.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, b) : this.complete(i);
                        },
                        complete: function(e1, t) {
                            if ("throw" === e1.type) throw e1.arg;
                            return "break" === e1.type || "continue" === e1.type ? this.next = e1.arg : "return" === e1.type ? (this.rval = this.arg = e1.arg, this.method = "return", this.next = "end") : "normal" === e1.type && t && (this.next = t), b;
                        },
                        finish: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var n = this.tryEntries[t];
                                if (n.finallyLoc === e1) return this.complete(n.completion, n.afterLoc), j(n), b;
                            }
                        },
                        catch: function(e1) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var n = this.tryEntries[t];
                                if (n.tryLoc === e1) {
                                    var r = n.completion;
                                    if ("throw" === r.type) {
                                        var o = r.arg;
                                        j(n);
                                    }
                                    return o;
                                }
                            }
                            throw Error("illegal catch attempt");
                        },
                        delegateYield: function(e1, n, r) {
                            return this.delegate = {
                                iterator: I(e1),
                                resultName: n,
                                nextLoc: r
                            }, "next" === this.method && (this.arg = t), b;
                        }
                    }, n;
                }
                e1.exports = o, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            6015: function(e1) {
                function t(n, r) {
                    return e1.exports = t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e1, t) {
                        return e1.__proto__ = t, e1;
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports, t(n, r);
                }
                e1.exports = t, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            5036: function(e1, t, n) {
                var r = n(8698).default;
                e1.exports = function(e1, t) {
                    if ("object" != r(e1) || !e1) return e1;
                    var n = e1[Symbol.toPrimitive];
                    if (void 0 !== n) {
                        var o = n.call(e1, t || "default");
                        if ("object" != r(o)) return o;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === t ? String : Number)(e1);
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            4062: function(e1, t, n) {
                var r = n(8698).default, o = n(5036);
                e1.exports = function(e1) {
                    var t = o(e1, "string");
                    return "symbol" == r(t) ? t : t + "";
                }, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            8698: function(e1) {
                function t(n) {
                    return e1.exports = t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports, t(n);
                }
                e1.exports = t, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            3496: function(e1, t, n) {
                var r = n(3808), o = n(6015), i = n(6035), a = n(3515);
                function u(t) {
                    var n = "function" == typeof Map ? new Map : void 0;
                    return e1.exports = u = function(e1) {
                        if (null === e1 || !i(e1)) return e1;
                        if ("function" != typeof e1) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== n) {
                            if (n.has(e1)) return n.get(e1);
                            n.set(e1, t);
                        }
                        function t() {
                            return a(e1, arguments, r(this).constructor);
                        }
                        return t.prototype = Object.create(e1.prototype, {
                            constructor: {
                                value: t,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), o(t, e1);
                    }, e1.exports.__esModule = !0, e1.exports.default = e1.exports, u(t);
                }
                e1.exports = u, e1.exports.__esModule = !0, e1.exports.default = e1.exports;
            },
            4687: function(e1, t, n) {
                var r = n(7061)();
                e1.exports = r;
                try {
                    regeneratorRuntime = r;
                } catch (e1) {
                    "object" == typeof globalThis ? globalThis.regeneratorRuntime = r : Function("r", "regeneratorRuntime = r")(r);
                }
            },
            907: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    (null == t || t > e1.length) && (t = e1.length);
                    for(var n = 0, r = Array(t); n < t; n++)r[n] = e1[n];
                    return r;
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            7326: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e1;
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            5861: function(e1, t, n) {
                "use strict";
                function r(e1, t, n, r, o, i, a) {
                    try {
                        var u = e1[i](a), c = u.value;
                    } catch (e1) {
                        return void n(e1);
                    }
                    u.done ? t(c) : Promise.resolve(c).then(r, o);
                }
                function o(e1) {
                    return function() {
                        var t = this, n = arguments;
                        return new Promise(function(o, i) {
                            var a = e1.apply(t, n);
                            function u(e1) {
                                r(a, o, i, u, c, "next", e1);
                            }
                            function c(e1) {
                                r(a, o, i, u, c, "throw", e1);
                            }
                            u(void 0);
                        });
                    };
                }
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
            },
            5671: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    if (!(e1 instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            3144: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return i;
                    }
                });
                var r = n(9142);
                function o(e1, t) {
                    for(var n = 0; n < t.length; n++){
                        var o = t[n];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e1, (0, r.Z)(o.key), o);
                    }
                }
                function i(e1, t, n) {
                    return t && o(e1.prototype, t), n && o(e1, n), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), e1;
                }
            },
            4942: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(9142);
                function o(e1, t, n) {
                    return (t = (0, r.Z)(t)) in e1 ? Object.defineProperty(e1, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e1[t] = n, e1;
                }
            },
            1752: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(1120);
                function o() {
                    return o = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e1, t, n) {
                        var o = function(e1, t) {
                            for(; !({}).hasOwnProperty.call(e1, t) && null !== (e1 = (0, r.Z)(e1)););
                            return e1;
                        }(e1, t);
                        if (o) {
                            var i = Object.getOwnPropertyDescriptor(o, t);
                            return i.get ? i.get.call(arguments.length < 3 ? e1 : n) : i.value;
                        }
                    }, o.apply(null, arguments);
                }
            },
            1120: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return r = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e1) {
                        return e1.__proto__ || Object.getPrototypeOf(e1);
                    }, r(e1);
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            136: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(9611);
                function o(e1, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e1.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e1,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e1, "prototype", {
                        writable: !1
                    }), t && (0, r.Z)(e1, t);
                }
            },
            4925: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    if (null == e1) return {};
                    var n, r, o = function(e1, t) {
                        if (null == e1) return {};
                        var n = {};
                        for(var r in e1)if (({}).hasOwnProperty.call(e1, r)) {
                            if (-1 !== t.indexOf(r)) continue;
                            n[r] = e1[r];
                        }
                        return n;
                    }(e1, t);
                    if (Object.getOwnPropertySymbols) {
                        var i = Object.getOwnPropertySymbols(e1);
                        for(r = 0; r < i.length; r++)n = i[r], -1 === t.indexOf(n) && ({}).propertyIsEnumerable.call(e1, n) && (o[n] = e1[n]);
                    }
                    return o;
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            2963: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return i;
                    }
                });
                var r = n(1002), o = n(7326);
                function i(e1, t) {
                    if (t && ("object" == (0, r.Z)(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return (0, o.Z)(e1);
                }
            },
            9611: function(e1, t, n) {
                "use strict";
                function r(e1, t) {
                    return r = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e1, t) {
                        return e1.__proto__ = t, e1;
                    }, r(e1, t);
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            885: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(181);
                function o(e1, t) {
                    return function(e1) {
                        if (Array.isArray(e1)) return e1;
                    }(e1) || function(e1, t) {
                        var n = null == e1 ? null : "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
                        if (null != n) {
                            var r, o, i, a, u = [], c = !0, s = !1;
                            try {
                                if (i = (n = n.call(e1)).next, 0 === t) {
                                    if (Object(n) !== n) return;
                                    c = !1;
                                } else for(; !(c = (r = i.call(n)).done) && (u.push(r.value), u.length !== t); c = !0);
                            } catch (e1) {
                                s = !0, o = e1;
                            } finally{
                                try {
                                    if (!c && null != n.return && (a = n.return(), Object(a) !== a)) return;
                                } finally{
                                    if (s) throw o;
                                }
                            }
                            return u;
                        }
                    }(e1, t) || (0, r.Z)(e1, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
            },
            2982: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return i;
                    }
                });
                var r = n(907), o = n(181);
                function i(e1) {
                    return function(e1) {
                        if (Array.isArray(e1)) return (0, r.Z)(e1);
                    }(e1) || function(e1) {
                        if ("undefined" != typeof Symbol && null != e1[Symbol.iterator] || null != e1["@@iterator"]) return Array.from(e1);
                    }(e1) || (0, o.Z)(e1) || function() {
                        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
            },
            9142: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(1002);
                function o(e1) {
                    var t = function(e1, t) {
                        if ("object" != (0, r.Z)(e1) || !e1) return e1;
                        var n = e1[Symbol.toPrimitive];
                        if (void 0 !== n) {
                            var o = n.call(e1, "string");
                            if ("object" != (0, r.Z)(o)) return o;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" == (0, r.Z)(t) ? t : t + "";
                }
            },
            1002: function(e1, t, n) {
                "use strict";
                function r(e1) {
                    return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                        return typeof e1;
                    } : function(e1) {
                        return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
                    }, r(e1);
                }
                n.d(t, {
                    Z: function() {
                        return r;
                    }
                });
            },
            181: function(e1, t, n) {
                "use strict";
                n.d(t, {
                    Z: function() {
                        return o;
                    }
                });
                var r = n(907);
                function o(e1, t) {
                    if (e1) {
                        if ("string" == typeof e1) return (0, r.Z)(e1, t);
                        var n = ({}).toString.call(e1).slice(8, -1);
                        return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? (0, r.Z)(e1, t) : void 0;
                    }
                }
            }
        }, t = {};
        function n(r) {
            var o = t[r];
            if (void 0 !== o) return o.exports;
            var i = t[r] = {
                exports: {}
            };
            return e1[r].call(i.exports, i, i.exports, n), i.exports;
        }
        n.n = function(e1) {
            var t = e1 && e1.__esModule ? function() {
                return e1.default;
            } : function() {
                return e1;
            };
            return n.d(t, {
                a: t
            }), t;
        }, n.d = function(e1, t) {
            for(var r in t)n.o(t, r) && !n.o(e1, r) && Object.defineProperty(e1, r, {
                enumerable: !0,
                get: t[r]
            });
        }, n.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e1) {
                if ("object" == typeof window) return window;
            }
        }(), n.o = function(e1, t) {
            return Object.prototype.hasOwnProperty.call(e1, t);
        }, n.r = function(e1) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e1, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e1, "__esModule", {
                value: !0
            });
        };
        var r = {};
        return function() {
            "use strict";
            n.r(r), n.d(r, {
                AuthenticatorKey: function() {
                    return y.pc;
                },
                EmailRole: function() {
                    return g.aw;
                },
                IdxFeature: function() {
                    return y.Fw;
                },
                IdxStatus: function() {
                    return y.Qd;
                },
                OktaAuth: function() {
                    return T;
                },
                PasswordStatus: function() {
                    return g.Fn;
                },
                Status: function() {
                    return g.qb;
                },
                addEmail: function() {
                    return g.no;
                },
                addPhone: function() {
                    return g.Z1;
                },
                authenticate: function() {
                    return y.YR;
                },
                canProceed: function() {
                    return y.Ch;
                },
                cancel: function() {
                    return y.al;
                },
                clearTransactionMeta: function() {
                    return y.Jm;
                },
                createAuthnTransactionAPI: function() {
                    return m.b;
                },
                createIdxAPI: function() {
                    return y.F4;
                },
                createIdxOptionsConstructor: function() {
                    return y.SL;
                },
                createIdxStorageManager: function() {
                    return y.aT;
                },
                createIdxTransactionManager: function() {
                    return y.vK;
                },
                createMinimalOktaAuthIdx: function() {
                    return y.UB;
                },
                createOktaAuthIdx: function() {
                    return y.Yn;
                },
                createOktaAuthMyAccount: function() {
                    return g.Xc;
                },
                createTransactionMeta: function() {
                    return y.Xc;
                },
                deleteEmail: function() {
                    return g.nd;
                },
                deletePassword: function() {
                    return g.QN;
                },
                deletePhone: function() {
                    return g.qj;
                },
                enrollPassword: function() {
                    return g.xg;
                },
                getEmail: function() {
                    return g.OD;
                },
                getEmailChallenge: function() {
                    return g.hG;
                },
                getEmails: function() {
                    return g.G5;
                },
                getPassword: function() {
                    return g.Ij;
                },
                getPhone: function() {
                    return g.u_;
                },
                getPhones: function() {
                    return g.Po;
                },
                getProfile: function() {
                    return g.Ai;
                },
                getProfileSchema: function() {
                    return g.aF;
                },
                getSavedTransactionMeta: function() {
                    return y.uN;
                },
                getTransactionMeta: function() {
                    return y.Co;
                },
                handleEmailVerifyCallback: function() {
                    return y.Jn;
                },
                handleInteractionCodeRedirect: function() {
                    return y.Xx;
                },
                hasSavedInteractionHandle: function() {
                    return y.$0;
                },
                interact: function() {
                    return y.EW;
                },
                introspect: function() {
                    return y.L8;
                },
                isAuthenticator: function() {
                    return y.H;
                },
                isEmailVerifyCallback: function() {
                    return y.GA;
                },
                isEmailVerifyCallbackError: function() {
                    return y.gc;
                },
                isTransactionMetaValid: function() {
                    return y.Wf;
                },
                isTransactionMetaValidForFlow: function() {
                    return y.bl;
                },
                isTransactionMetaValidForOptions: function() {
                    return y.UC;
                },
                mixinAuthn: function() {
                    return m.t;
                },
                mixinIdx: function() {
                    return y.B_;
                },
                mixinMyAccount: function() {
                    return g.HT;
                },
                parseEmailVerifyCallback: function() {
                    return y.mo;
                },
                poll: function() {
                    return y.$l;
                },
                proceed: function() {
                    return y.xc;
                },
                recoverPassword: function() {
                    return y.M4;
                },
                register: function() {
                    return y.z2;
                },
                saveTransactionMeta: function() {
                    return y.r0;
                },
                sendEmailChallenge: function() {
                    return g.ME;
                },
                sendPhoneChallenge: function() {
                    return g.dv;
                },
                startTransaction: function() {
                    return y.Yr;
                },
                unlockAccount: function() {
                    return y.le;
                },
                updatePassword: function() {
                    return g.gQ;
                },
                updateProfile: function() {
                    return g.ck;
                },
                verifyEmailChallenge: function() {
                    return g.T8;
                },
                verifyPhoneChallenge: function() {
                    return g.Lo;
                }
            });
            var e1 = n(3144), t = n(5671), o = n(136), i = n(2963), a = n(1120), u = n(4602), c = n(4143), s = n(3334), f = n(2144), l = n(6794), p = n(3164), d = n(6736), h = {};
            for(var v in d)[
                "default",
                "OktaAuth"
            ].indexOf(v) < 0 && (h[v] = (function(e1) {
                return d[e1];
            }).bind(0, v));
            n.d(r, h);
            var y = n(9999), g = n(1132), m = n(3398);
            var b = (0, u.S)(), k = (0, c.a)(), w = (0, s.v)(), O = (0, f.Y)(k, b, w), Z = (0, l.H)(O), T = function(n) {
                (0, o.Z)(s, n);
                var r, u, c = (r = s, u = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e1) {
                        return !1;
                    }
                }(), function() {
                    var e1, t = (0, a.Z)(r);
                    if (u) {
                        var n = (0, a.Z)(this).constructor;
                        e1 = Reflect.construct(t, arguments, n);
                    } else e1 = t.apply(this, arguments);
                    return (0, i.Z)(this, e1);
                });
                function s(e1) {
                    return (0, t.Z)(this, s), c.call(this, e1);
                }
                return (0, e1.Z)(s);
            }((0, p.t)(Z));
            r.default = T;
        }(), r;
    }();
});



// OIE supports only IDX pipeline
// okta-auth-js supports a mixin pattern that allows us to compose a custom version containing only the code we need
// build an AuthJS client that supports only the OIE engine
const $ce4306d3b4f085bb$var$OptionsConstructor = (0, $714174fa38b8e4a1$exports.createIdxOptionsConstructor)();
const $ce4306d3b4f085bb$var$StorageManager = (0, $714174fa38b8e4a1$exports.createIdxStorageManager)();
const $ce4306d3b4f085bb$var$IdxTransactionManager = (0, $714174fa38b8e4a1$exports.createIdxTransactionManager)();
// Start with OAuth as base
const $ce4306d3b4f085bb$var$OktaAuthOAuth = (0, $714174fa38b8e4a1$exports.createOktaAuthOAuth)($ce4306d3b4f085bb$var$StorageManager, $ce4306d3b4f085bb$var$OptionsConstructor, $ce4306d3b4f085bb$var$IdxTransactionManager);
// Mixin IDX support
const $ce4306d3b4f085bb$export$c998d4cdbfb7af8 = (0, $714174fa38b8e4a1$exports.mixinIdx)($ce4306d3b4f085bb$var$OktaAuthOAuth);


// Default supports both Authn and IDX pipelines
// okta-auth-js supports a mixin pattern that allows us to compose a custom version containing only the code we need
// build an AuthJS client that supports both the Classic and OIE engines
// Simply add Authn support to the IDX client
const $4ef1d20df6e6f403$export$c998d4cdbfb7af8 = (0, $714174fa38b8e4a1$exports.mixinAuthn)((0, $ce4306d3b4f085bb$export$c998d4cdbfb7af8));


var $9b5d33d856ec9f32$export$a441d440b06e3168 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function $9b5d33d856ec9f32$export$22b09f878622677a(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}


var $d3be9eebbc8f28b8$export$3b14a55fb2447963 = {
    exports: {}
};


(function(module, exports) {
    !function(n, r) {
        module.exports = r();
    }((0, $9b5d33d856ec9f32$export$a441d440b06e3168), function() {
        //     Underscore.js 1.13.8
        //     https://underscorejs.org
        //     (c) 2009-2026 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
        //     Underscore may be freely distributed under the MIT license.
        var n = "1.13.8", r = "object" == typeof self && self.self === self && self || "object" == typeof (0, $9b5d33d856ec9f32$export$a441d440b06e3168) && (0, $9b5d33d856ec9f32$export$a441d440b06e3168).global === (0, $9b5d33d856ec9f32$export$a441d440b06e3168) && (0, $9b5d33d856ec9f32$export$a441d440b06e3168) || Function("return this")() || {}, t = Array.prototype, e = Object.prototype, u = "undefined" != typeof Symbol ? Symbol.prototype : null, i = t.push, o = t.slice, a = e.toString, f = e.hasOwnProperty, c = "undefined" != typeof ArrayBuffer, l = "undefined" != typeof DataView, s = Array.isArray, p = Object.keys, v = Object.create, h = c && ArrayBuffer.isView, y = isNaN, d = isFinite, g = !({
            toString: null
        }).propertyIsEnumerable("toString"), b = [
            "valueOf",
            "isPrototypeOf",
            "toString",
            "propertyIsEnumerable",
            "hasOwnProperty",
            "toLocaleString"
        ], m = Math.pow(2, 53) - 1;
        function j(n, r) {
            return r = null == r ? n.length - 1 : +r, function() {
                for(var t = Math.max(arguments.length - r, 0), e = Array(t), u = 0; u < t; u++)e[u] = arguments[u + r];
                switch(r){
                    case 0:
                        return n.call(this, e);
                    case 1:
                        return n.call(this, arguments[0], e);
                    case 2:
                        return n.call(this, arguments[0], arguments[1], e);
                }
                var i = Array(r + 1);
                for(u = 0; u < r; u++)i[u] = arguments[u];
                return i[r] = e, n.apply(this, i);
            };
        }
        function w(n) {
            var r = typeof n;
            return "function" === r || "object" === r && !!n;
        }
        function _(n) {
            return void 0 === n;
        }
        function A(n) {
            return !0 === n || !1 === n || "[object Boolean]" === a.call(n);
        }
        function x(n) {
            var r = "[object " + n + "]";
            return function(n) {
                return a.call(n) === r;
            };
        }
        var S = x("String"), O = x("Number"), M = x("Date"), E = x("RegExp"), B = x("Error"), N = x("Symbol"), k = x("ArrayBuffer"), I = x("Function"), T = r.document && r.document.childNodes;
        "function" != typeof /./ && "object" != typeof Int8Array && "function" != typeof T && (I = function(n) {
            return "function" == typeof n || !1;
        });
        var D = I, R = x("Object"), V = l && (!/\[native code\]/.test(String(DataView)) || R(new DataView(new ArrayBuffer(8)))), F = "undefined" != typeof Map && R(new Map()), P = x("DataView");
        var q = V ? function(n) {
            return null != n && D(n.getInt8) && k(n.buffer);
        } : P, U = s || x("Array");
        function W(n, r) {
            return null != n && f.call(n, r);
        }
        var z = x("Arguments");
        !function() {
            z(arguments) || (z = function(n) {
                return W(n, "callee");
            });
        }();
        var L = z;
        function $(n) {
            return O(n) && y(n);
        }
        function C(n) {
            return function() {
                return n;
            };
        }
        function K(n) {
            return function(r) {
                var t = n(r);
                return "number" == typeof t && t >= 0 && t <= m;
            };
        }
        function J(n) {
            return function(r) {
                return null == r ? void 0 : r[n];
            };
        }
        var G = J("byteLength"), H = K(G), Q = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
        var X = c ? function(n) {
            return h ? h(n) && !q(n) : H(n) && Q.test(a.call(n));
        } : C(!1), Y = J("length");
        function Z(n, r) {
            r = function(n) {
                for(var r = {}, t = n.length, e = 0; e < t; ++e)r[n[e]] = !0;
                return {
                    contains: function(n) {
                        return !0 === r[n];
                    },
                    push: function(t) {
                        return r[t] = !0, n.push(t);
                    }
                };
            }(r);
            var t = b.length, u = n.constructor, i = D(u) && u.prototype || e, o = "constructor";
            for(W(n, o) && !r.contains(o) && r.push(o); t--;)(o = b[t]) in n && n[o] !== i[o] && !r.contains(o) && r.push(o);
        }
        function nn(n) {
            if (!w(n)) return [];
            if (p) return p(n);
            var r = [];
            for(var t in n)W(n, t) && r.push(t);
            return g && Z(n, r), r;
        }
        function rn(n, r) {
            var t = nn(r), e = t.length;
            if (null == n) return !e;
            for(var u = Object(n), i = 0; i < e; i++){
                var o = t[i];
                if (r[o] !== u[o] || !(o in u)) return !1;
            }
            return !0;
        }
        function tn(n) {
            return n instanceof tn ? n : this instanceof tn ? void (this._wrapped = n) : new tn(n);
        }
        function en(n) {
            return new Uint8Array(n.buffer || n, n.byteOffset || 0, G(n));
        }
        tn.VERSION = n, tn.prototype.value = function() {
            return this._wrapped;
        }, tn.prototype.valueOf = tn.prototype.toJSON = tn.prototype.value, tn.prototype.toString = function() {
            return String(this._wrapped);
        };
        var un = "[object DataView]";
        function on(n) {
            if (!w(n)) return [];
            var r = [];
            for(var t in n)r.push(t);
            return g && Z(n, r), r;
        }
        function an(n) {
            var r = Y(n);
            return function(t) {
                if (null == t) return !1;
                var e = on(t);
                if (Y(e)) return !1;
                for(var u = 0; u < r; u++)if (!D(t[n[u]])) return !1;
                return n !== vn || !D(t[fn]);
            };
        }
        var fn = "forEach", cn = "has", ln = [
            "clear",
            "delete"
        ], sn = [
            "get",
            cn,
            "set"
        ], pn = ln.concat(fn, sn), vn = ln.concat(sn), hn = [
            "add"
        ].concat(ln, fn, cn), yn = F ? an(pn) : x("Map"), dn = F ? an(vn) : x("WeakMap"), gn = F ? an(hn) : x("Set"), bn = x("WeakSet");
        function mn(n) {
            for(var r = nn(n), t = r.length, e = Array(t), u = 0; u < t; u++)e[u] = n[r[u]];
            return e;
        }
        function jn(n) {
            for(var r = {}, t = nn(n), e = 0, u = t.length; e < u; e++)r[n[t[e]]] = t[e];
            return r;
        }
        function wn(n) {
            var r = [];
            for(var t in n)D(n[t]) && r.push(t);
            return r.sort();
        }
        function _n(n, r) {
            return function(t) {
                var e = arguments.length;
                if (r && (t = Object(t)), e < 2 || null == t) return t;
                for(var u = 1; u < e; u++)for(var i = arguments[u], o = n(i), a = o.length, f = 0; f < a; f++){
                    var c = o[f];
                    r && void 0 !== t[c] || (t[c] = i[c]);
                }
                return t;
            };
        }
        var An = _n(on), xn = _n(nn), Sn = _n(on, !0);
        function On(n) {
            if (!w(n)) return {};
            if (v) return v(n);
            var r = function() {};
            r.prototype = n;
            var t = new r();
            return r.prototype = null, t;
        }
        function Mn(n) {
            return U(n) ? n : [
                n
            ];
        }
        function En(n) {
            return tn.toPath(n);
        }
        function Bn(n, r) {
            for(var t = r.length, e = 0; e < t; e++){
                if (null == n) return;
                n = n[r[e]];
            }
            return t ? n : void 0;
        }
        function Nn(n, r, t) {
            var e = Bn(n, En(r));
            return _(e) ? t : e;
        }
        function kn(n) {
            return n;
        }
        function In(n) {
            return n = xn({}, n), function(r) {
                return rn(r, n);
            };
        }
        function Tn(n) {
            return n = En(n), function(r) {
                return Bn(r, n);
            };
        }
        function Dn(n, r, t) {
            if (void 0 === r) return n;
            switch(null == t ? 3 : t){
                case 1:
                    return function(t) {
                        return n.call(r, t);
                    };
                case 3:
                    return function(t, e, u) {
                        return n.call(r, t, e, u);
                    };
                case 4:
                    return function(t, e, u, i) {
                        return n.call(r, t, e, u, i);
                    };
            }
            return function() {
                return n.apply(r, arguments);
            };
        }
        function Rn(n, r, t) {
            return null == n ? kn : D(n) ? Dn(n, r, t) : w(n) && !U(n) ? In(n) : Tn(n);
        }
        function Vn(n, r) {
            return Rn(n, r, 1 / 0);
        }
        function Fn(n, r, t) {
            return tn.iteratee !== Vn ? tn.iteratee(n, r) : Rn(n, r, t);
        }
        function Pn() {}
        function qn(n, r) {
            return null == r && (r = n, n = 0), n + Math.floor(Math.random() * (r - n + 1));
        }
        tn.toPath = Mn, tn.iteratee = Vn;
        var Un = Date.now || function() {
            return new Date().getTime();
        };
        function Wn(n) {
            var r = function(r) {
                return n[r];
            }, t = "(?:" + nn(n).join("|") + ")", e = RegExp(t), u = RegExp(t, "g");
            return function(n) {
                return n = null == n ? "" : "" + n, e.test(n) ? n.replace(u, r) : n;
            };
        }
        var zn = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#x27;",
            "`": "&#x60;"
        }, Ln = Wn(zn), $n = Wn(jn(zn)), Cn = tn.templateSettings = {
            evaluate: /<%([\s\S]+?)%>/g,
            interpolate: /<%=([\s\S]+?)%>/g,
            escape: /<%-([\s\S]+?)%>/g
        }, Kn = /(.)^/, Jn = {
            "'": "'",
            "\\": "\\",
            "\r": "r",
            "\n": "n",
            "\u2028": "u2028",
            "\u2029": "u2029"
        }, Gn = /\\|'|\r|\n|\u2028|\u2029/g;
        function Hn(n) {
            return "\\" + Jn[n];
        }
        var Qn = /^\s*(\w|\$)+\s*$/;
        var Xn = 0;
        function Yn(n, r, t, e, u) {
            if (!(e instanceof r)) return n.apply(t, u);
            var i = On(n.prototype), o = n.apply(i, u);
            return w(o) ? o : i;
        }
        var Zn = j(function(n, r) {
            var t = Zn.placeholder, e = function() {
                for(var u = 0, i = r.length, o = Array(i), a = 0; a < i; a++)o[a] = r[a] === t ? arguments[u++] : r[a];
                for(; u < arguments.length;)o.push(arguments[u++]);
                return Yn(n, e, this, this, o);
            };
            return e;
        });
        Zn.placeholder = tn;
        var nr = j(function(n, r, t) {
            if (!D(n)) throw new TypeError("Bind must be called on a function");
            var e = j(function(u) {
                return Yn(n, e, r, this, t.concat(u));
            });
            return e;
        }), rr = K(Y);
        function tr(n, r, t) {
            r || 0 === r || (r = 1 / 0);
            for(var e = [], u = 0, i = 0, o = Y(n) || 0, a = [];;)if (i >= o) {
                if (!a.length) break;
                var f = a.pop();
                i = f.i, n = f.v, o = Y(n);
            } else {
                var c = n[i++];
                a.length >= r ? e[u++] = c : rr(c) && (U(c) || L(c)) ? (a.push({
                    i: i,
                    v: n
                }), i = 0, o = Y(n = c)) : t || (e[u++] = c);
            }
            return e;
        }
        var er = j(function(n, r) {
            var t = (r = tr(r, !1, !1)).length;
            if (t < 1) throw new Error("bindAll must be passed function names");
            for(; t--;){
                var e = r[t];
                n[e] = nr(n[e], n);
            }
            return n;
        });
        var ur = j(function(n, r, t) {
            return setTimeout(function() {
                return n.apply(null, t);
            }, r);
        }), ir = Zn(ur, tn, 1);
        function or(n) {
            return function() {
                return !n.apply(this, arguments);
            };
        }
        function ar(n, r) {
            var t;
            return function() {
                return --n > 0 && (t = r.apply(this, arguments)), n <= 1 && (r = null), t;
            };
        }
        var fr = Zn(ar, 2);
        function cr(n, r, t) {
            r = Fn(r, t);
            for(var e, u = nn(n), i = 0, o = u.length; i < o; i++)if (r(n[e = u[i]], e, n)) return e;
        }
        function lr(n) {
            return function(r, t, e) {
                t = Fn(t, e);
                for(var u = Y(r), i = n > 0 ? 0 : u - 1; i >= 0 && i < u; i += n)if (t(r[i], i, r)) return i;
                return -1;
            };
        }
        var sr = lr(1), pr = lr(-1);
        function vr(n, r, t, e) {
            for(var u = (t = Fn(t, e, 1))(r), i = 0, o = Y(n); i < o;){
                var a = Math.floor((i + o) / 2);
                t(n[a]) < u ? i = a + 1 : o = a;
            }
            return i;
        }
        function hr(n, r, t) {
            return function(e, u, i) {
                var a = 0, f = Y(e);
                if ("number" == typeof i) n > 0 ? a = i >= 0 ? i : Math.max(i + f, a) : f = i >= 0 ? Math.min(i + 1, f) : i + f + 1;
                else if (t && i && f) return e[i = t(e, u)] === u ? i : -1;
                if (u != u) return (i = r(o.call(e, a, f), $)) >= 0 ? i + a : -1;
                for(i = n > 0 ? a : f - 1; i >= 0 && i < f; i += n)if (e[i] === u) return i;
                return -1;
            };
        }
        var yr = hr(1, sr, vr), dr = hr(-1, pr);
        function gr(n, r, t) {
            var e = (rr(n) ? sr : cr)(n, r, t);
            if (void 0 !== e && -1 !== e) return n[e];
        }
        function br(n, r, t) {
            var e, u;
            if (r = Dn(r, t), rr(n)) for(e = 0, u = n.length; e < u; e++)r(n[e], e, n);
            else {
                var i = nn(n);
                for(e = 0, u = i.length; e < u; e++)r(n[i[e]], i[e], n);
            }
            return n;
        }
        function mr(n, r, t) {
            r = Fn(r, t);
            for(var e = !rr(n) && nn(n), u = (e || n).length, i = Array(u), o = 0; o < u; o++){
                var a = e ? e[o] : o;
                i[o] = r(n[a], a, n);
            }
            return i;
        }
        function jr(n) {
            var r = function(r, t, e, u) {
                var i = !rr(r) && nn(r), o = (i || r).length, a = n > 0 ? 0 : o - 1;
                for(u || (e = r[i ? i[a] : a], a += n); a >= 0 && a < o; a += n){
                    var f = i ? i[a] : a;
                    e = t(e, r[f], f, r);
                }
                return e;
            };
            return function(n, t, e, u) {
                var i = arguments.length >= 3;
                return r(n, Dn(t, u, 4), e, i);
            };
        }
        var wr = jr(1), _r = jr(-1);
        function Ar(n, r, t) {
            var e = [];
            return r = Fn(r, t), br(n, function(n, t, u) {
                r(n, t, u) && e.push(n);
            }), e;
        }
        function xr(n, r, t) {
            r = Fn(r, t);
            for(var e = !rr(n) && nn(n), u = (e || n).length, i = 0; i < u; i++){
                var o = e ? e[i] : i;
                if (!r(n[o], o, n)) return !1;
            }
            return !0;
        }
        function Sr(n, r, t) {
            r = Fn(r, t);
            for(var e = !rr(n) && nn(n), u = (e || n).length, i = 0; i < u; i++){
                var o = e ? e[i] : i;
                if (r(n[o], o, n)) return !0;
            }
            return !1;
        }
        function Or(n, r, t, e) {
            return rr(n) || (n = mn(n)), ("number" != typeof t || e) && (t = 0), yr(n, r, t) >= 0;
        }
        var Mr = j(function(n, r, t) {
            var e, u;
            return D(r) ? u = r : (r = En(r), e = r.slice(0, -1), r = r[r.length - 1]), mr(n, function(n) {
                var i = u;
                if (!i) {
                    if (e && e.length && (n = Bn(n, e)), null == n) return;
                    i = n[r];
                }
                return null == i ? i : i.apply(n, t);
            });
        });
        function Er(n, r) {
            return mr(n, Tn(r));
        }
        function Br(n, r, t) {
            var e, u, i = -1 / 0, o = -1 / 0;
            if (null == r || "number" == typeof r && "object" != typeof n[0] && null != n) for(var a = 0, f = (n = rr(n) ? n : mn(n)).length; a < f; a++)null != (e = n[a]) && e > i && (i = e);
            else r = Fn(r, t), br(n, function(n, t, e) {
                ((u = r(n, t, e)) > o || u === -1 / 0 && i === -1 / 0) && (i = n, o = u);
            });
            return i;
        }
        var Nr = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
        function kr(n) {
            return n ? U(n) ? o.call(n) : S(n) ? n.match(Nr) : rr(n) ? mr(n, kn) : mn(n) : [];
        }
        function Ir(n, r, t) {
            if (null == r || t) return rr(n) || (n = mn(n)), n[qn(n.length - 1)];
            var e = kr(n), u = Y(e);
            r = Math.max(Math.min(r, u), 0);
            for(var i = u - 1, o = 0; o < r; o++){
                var a = qn(o, i), f = e[o];
                e[o] = e[a], e[a] = f;
            }
            return e.slice(0, r);
        }
        function Tr(n, r) {
            return function(t, e, u) {
                var i = r ? [
                    [],
                    []
                ] : {};
                return e = Fn(e, u), br(t, function(r, u) {
                    var o = e(r, u, t);
                    n(i, r, o);
                }), i;
            };
        }
        var Dr = Tr(function(n, r, t) {
            W(n, t) ? n[t].push(r) : n[t] = [
                r
            ];
        }), Rr = Tr(function(n, r, t) {
            n[t] = r;
        }), Vr = Tr(function(n, r, t) {
            W(n, t) ? n[t]++ : n[t] = 1;
        }), Fr = Tr(function(n, r, t) {
            n[t ? 0 : 1].push(r);
        }, !0);
        function Pr(n, r, t) {
            return r in t;
        }
        var qr = j(function(n, r) {
            var t = {}, e = r[0];
            if (null == n) return t;
            D(e) ? (r.length > 1 && (e = Dn(e, r[1])), r = on(n)) : (e = Pr, r = tr(r, !1, !1), n = Object(n));
            for(var u = 0, i = r.length; u < i; u++){
                var o = r[u], a = n[o];
                e(a, o, n) && (t[o] = a);
            }
            return t;
        }), Ur = j(function(n, r) {
            var t, e = r[0];
            return D(e) ? (e = or(e), r.length > 1 && (t = r[1])) : (r = mr(tr(r, !1, !1), String), e = function(n, t) {
                return !Or(r, t);
            }), qr(n, e, t);
        });
        function Wr(n, r, t) {
            return o.call(n, 0, Math.max(0, n.length - (null == r || t ? 1 : r)));
        }
        function zr(n, r, t) {
            return null == n || n.length < 1 ? null == r || t ? void 0 : [] : null == r || t ? n[0] : Wr(n, n.length - r);
        }
        function Lr(n, r, t) {
            return o.call(n, null == r || t ? 1 : r);
        }
        var $r = j(function(n, r) {
            return r = tr(r, !0, !0), Ar(n, function(n) {
                return !Or(r, n);
            });
        }), Cr = j(function(n, r) {
            return $r(n, r);
        });
        function Kr(n, r, t, e) {
            A(r) || (e = t, t = r, r = !1), null != t && (t = Fn(t, e));
            for(var u = [], i = [], o = 0, a = Y(n); o < a; o++){
                var f = n[o], c = t ? t(f, o, n) : f;
                r && !t ? (o && i === c || u.push(f), i = c) : t ? Or(i, c) || (i.push(c), u.push(f)) : Or(u, f) || u.push(f);
            }
            return u;
        }
        var Jr = j(function(n) {
            return Kr(tr(n, !0, !0));
        });
        function Gr(n) {
            for(var r = n && Br(n, Y).length || 0, t = Array(r), e = 0; e < r; e++)t[e] = Er(n, e);
            return t;
        }
        var Hr = j(Gr);
        function Qr(n, r) {
            return n._chain ? tn(r).chain() : r;
        }
        function Xr(n) {
            return br(wn(n), function(r) {
                var t = tn[r] = n[r];
                tn.prototype[r] = function() {
                    var n = [
                        this._wrapped
                    ];
                    return i.apply(n, arguments), Qr(this, t.apply(tn, n));
                };
            }), tn;
        }
        br([
            "pop",
            "push",
            "reverse",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(n) {
            var r = t[n];
            tn.prototype[n] = function() {
                var t = this._wrapped;
                return null != t && (r.apply(t, arguments), "shift" !== n && "splice" !== n || 0 !== t.length || delete t[0]), Qr(this, t);
            };
        }), br([
            "concat",
            "join",
            "slice"
        ], function(n) {
            var r = t[n];
            tn.prototype[n] = function() {
                var n = this._wrapped;
                return null != n && (n = r.apply(n, arguments)), Qr(this, n);
            };
        });
        var Yr = Xr({
            __proto__: null,
            VERSION: n,
            restArguments: j,
            isObject: w,
            isNull: function(n) {
                return null === n;
            },
            isUndefined: _,
            isBoolean: A,
            isElement: function(n) {
                return !(!n || 1 !== n.nodeType);
            },
            isString: S,
            isNumber: O,
            isDate: M,
            isRegExp: E,
            isError: B,
            isSymbol: N,
            isArrayBuffer: k,
            isDataView: q,
            isArray: U,
            isFunction: D,
            isArguments: L,
            isFinite: function(n) {
                return !N(n) && d(n) && !isNaN(parseFloat(n));
            },
            isNaN: $,
            isTypedArray: X,
            isEmpty: function(n) {
                if (null == n) return !0;
                var r = Y(n);
                return "number" == typeof r && (U(n) || S(n) || L(n)) ? 0 === r : 0 === Y(nn(n));
            },
            isMatch: rn,
            isEqual: function(n, r) {
                for(var t = [
                    {
                        a: n,
                        b: r
                    }
                ], e = [], i = []; t.length;){
                    var o = t.pop();
                    if (!0 !== o) {
                        if ((n = o.a) === (r = o.b)) {
                            if (0 !== n || 1 / n == 1 / r) continue;
                            return !1;
                        }
                        if (null == n || null == r) return !1;
                        if (n != n) {
                            if (r != r) continue;
                            return !1;
                        }
                        var f = typeof n;
                        if ("function" !== f && "object" !== f && "object" != typeof r) return !1;
                        n instanceof tn && (n = n._wrapped), r instanceof tn && (r = r._wrapped);
                        var c = a.call(n);
                        if (c !== a.call(r)) return !1;
                        if (V && "[object Object]" == c && q(n)) {
                            if (!q(r)) return !1;
                            c = un;
                        }
                        switch(c){
                            case "[object RegExp]":
                            case "[object String]":
                                if ("" + n == "" + r) continue;
                                return !1;
                            case "[object Number]":
                                t.push({
                                    a: +n,
                                    b: +r
                                });
                                continue;
                            case "[object Date]":
                            case "[object Boolean]":
                                if (+n == +r) continue;
                                return !1;
                            case "[object Symbol]":
                                if (u.valueOf.call(n) === u.valueOf.call(r)) continue;
                                return !1;
                            case "[object ArrayBuffer]":
                            case un:
                                t.push({
                                    a: en(n),
                                    b: en(r)
                                });
                                continue;
                        }
                        var l = "[object Array]" === c;
                        if (!l && X(n)) {
                            if (G(n) !== G(r)) return !1;
                            if (n.buffer === r.buffer && n.byteOffset === r.byteOffset) continue;
                            l = !0;
                        }
                        if (!l) {
                            if ("object" != typeof n || "object" != typeof r) return !1;
                            var s = n.constructor, p = r.constructor;
                            if (s !== p && !(D(s) && s instanceof s && D(p) && p instanceof p) && "constructor" in n && "constructor" in r) return !1;
                        }
                        for(var v = e.length; v--;)if (e[v] === n) {
                            if (i[v] === r) break;
                            return !1;
                        }
                        if (!(v >= 0)) {
                            if (e.push(n), i.push(r), t.push(!0), l) {
                                if ((v = n.length) !== r.length) return !1;
                                for(; v--;)t.push({
                                    a: n[v],
                                    b: r[v]
                                });
                            } else {
                                var h, y = nn(n);
                                if (v = y.length, nn(r).length !== v) return !1;
                                for(; v--;){
                                    if (!W(r, h = y[v])) return !1;
                                    t.push({
                                        a: n[h],
                                        b: r[h]
                                    });
                                }
                            }
                        }
                    } else e.pop(), i.pop();
                }
                return !0;
            },
            isMap: yn,
            isWeakMap: dn,
            isSet: gn,
            isWeakSet: bn,
            keys: nn,
            allKeys: on,
            values: mn,
            pairs: function(n) {
                for(var r = nn(n), t = r.length, e = Array(t), u = 0; u < t; u++)e[u] = [
                    r[u],
                    n[r[u]]
                ];
                return e;
            },
            invert: jn,
            functions: wn,
            methods: wn,
            extend: An,
            extendOwn: xn,
            assign: xn,
            defaults: Sn,
            create: function(n, r) {
                var t = On(n);
                return r && xn(t, r), t;
            },
            clone: function(n) {
                return w(n) ? U(n) ? n.slice() : An({}, n) : n;
            },
            tap: function(n, r) {
                return r(n), n;
            },
            get: Nn,
            has: function(n, r) {
                for(var t = (r = En(r)).length, e = 0; e < t; e++){
                    var u = r[e];
                    if (!W(n, u)) return !1;
                    n = n[u];
                }
                return !!t;
            },
            mapObject: function(n, r, t) {
                r = Fn(r, t);
                for(var e = nn(n), u = e.length, i = {}, o = 0; o < u; o++){
                    var a = e[o];
                    i[a] = r(n[a], a, n);
                }
                return i;
            },
            identity: kn,
            constant: C,
            noop: Pn,
            toPath: Mn,
            property: Tn,
            propertyOf: function(n) {
                return null == n ? Pn : function(r) {
                    return Nn(n, r);
                };
            },
            matcher: In,
            matches: In,
            times: function(n, r, t) {
                var e = Array(Math.max(0, n));
                r = Dn(r, t, 1);
                for(var u = 0; u < n; u++)e[u] = r(u);
                return e;
            },
            random: qn,
            now: Un,
            escape: Ln,
            unescape: $n,
            templateSettings: Cn,
            template: function(n, r, t) {
                !r && t && (r = t), r = Sn({}, r, tn.templateSettings);
                var e = RegExp([
                    (r.escape || Kn).source,
                    (r.interpolate || Kn).source,
                    (r.evaluate || Kn).source
                ].join("|") + "|$", "g"), u = 0, i = "__p+='";
                n.replace(e, function(r, t, e, o, a) {
                    return i += n.slice(u, a).replace(Gn, Hn), u = a + r.length, t ? i += "'+\n((__t=(" + t + "))==null?'':_.escape(__t))+\n'" : e ? i += "'+\n((__t=(" + e + "))==null?'':__t)+\n'" : o && (i += "';\n" + o + "\n__p+='"), r;
                }), i += "';\n";
                var o, a = r.variable;
                if (a) {
                    if (!Qn.test(a)) throw new Error("variable is not a bare identifier: " + a);
                } else i = "with(obj||{}){\n" + i + "}\n", a = "obj";
                i = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + i + "return __p;\n";
                try {
                    o = new Function(a, "_", i);
                } catch (n) {
                    throw n.source = i, n;
                }
                var f = function(n) {
                    return o.call(this, n, tn);
                };
                return f.source = "function(" + a + "){\n" + i + "}", f;
            },
            result: function(n, r, t) {
                var e = (r = En(r)).length;
                if (!e) return D(t) ? t.call(n) : t;
                for(var u = 0; u < e; u++){
                    var i = null == n ? void 0 : n[r[u]];
                    void 0 === i && (i = t, u = e), n = D(i) ? i.call(n) : i;
                }
                return n;
            },
            uniqueId: function(n) {
                var r = ++Xn + "";
                return n ? n + r : r;
            },
            chain: function(n) {
                var r = tn(n);
                return r._chain = !0, r;
            },
            iteratee: Vn,
            partial: Zn,
            bind: nr,
            bindAll: er,
            memoize: function(n, r) {
                var t = function(e) {
                    var u = t.cache, i = "" + (r ? r.apply(this, arguments) : e);
                    return W(u, i) || (u[i] = n.apply(this, arguments)), u[i];
                };
                return t.cache = {}, t;
            },
            delay: ur,
            defer: ir,
            throttle: function(n, r, t) {
                var e, u, i, o, a = 0;
                t || (t = {});
                var f = function() {
                    a = !1 === t.leading ? 0 : Un(), e = null, o = n.apply(u, i), e || (u = i = null);
                }, c = function() {
                    var c = Un();
                    a || !1 !== t.leading || (a = c);
                    var l = r - (c - a);
                    return u = this, i = arguments, l <= 0 || l > r ? (e && (clearTimeout(e), e = null), a = c, o = n.apply(u, i), e || (u = i = null)) : e || !1 === t.trailing || (e = setTimeout(f, l)), o;
                };
                return c.cancel = function() {
                    clearTimeout(e), a = 0, e = u = i = null;
                }, c;
            },
            debounce: function(n, r, t) {
                var e, u, i, o, a, f = function() {
                    var c = Un() - u;
                    r > c ? e = setTimeout(f, r - c) : (e = null, t || (o = n.apply(a, i)), e || (i = a = null));
                }, c = j(function(c) {
                    return a = this, i = c, u = Un(), e || (e = setTimeout(f, r), t && (o = n.apply(a, i))), o;
                });
                return c.cancel = function() {
                    clearTimeout(e), e = i = a = null;
                }, c;
            },
            wrap: function(n, r) {
                return Zn(r, n);
            },
            negate: or,
            compose: function() {
                var n = arguments, r = n.length - 1;
                return function() {
                    for(var t = r, e = n[r].apply(this, arguments); t--;)e = n[t].call(this, e);
                    return e;
                };
            },
            after: function(n, r) {
                return function() {
                    if (--n < 1) return r.apply(this, arguments);
                };
            },
            before: ar,
            once: fr,
            findKey: cr,
            findIndex: sr,
            findLastIndex: pr,
            sortedIndex: vr,
            indexOf: yr,
            lastIndexOf: dr,
            find: gr,
            detect: gr,
            findWhere: function(n, r) {
                return gr(n, In(r));
            },
            each: br,
            forEach: br,
            map: mr,
            collect: mr,
            reduce: wr,
            foldl: wr,
            inject: wr,
            reduceRight: _r,
            foldr: _r,
            filter: Ar,
            select: Ar,
            reject: function(n, r, t) {
                return Ar(n, or(Fn(r)), t);
            },
            every: xr,
            all: xr,
            some: Sr,
            any: Sr,
            contains: Or,
            includes: Or,
            include: Or,
            invoke: Mr,
            pluck: Er,
            where: function(n, r) {
                return Ar(n, In(r));
            },
            max: Br,
            min: function(n, r, t) {
                var e, u, i = 1 / 0, o = 1 / 0;
                if (null == r || "number" == typeof r && "object" != typeof n[0] && null != n) for(var a = 0, f = (n = rr(n) ? n : mn(n)).length; a < f; a++)null != (e = n[a]) && e < i && (i = e);
                else r = Fn(r, t), br(n, function(n, t, e) {
                    ((u = r(n, t, e)) < o || u === 1 / 0 && i === 1 / 0) && (i = n, o = u);
                });
                return i;
            },
            shuffle: function(n) {
                return Ir(n, 1 / 0);
            },
            sample: Ir,
            sortBy: function(n, r, t) {
                var e = 0;
                return r = Fn(r, t), Er(mr(n, function(n, t, u) {
                    return {
                        value: n,
                        index: e++,
                        criteria: r(n, t, u)
                    };
                }).sort(function(n, r) {
                    var t = n.criteria, e = r.criteria;
                    if (t !== e) {
                        if (t > e || void 0 === t) return 1;
                        if (t < e || void 0 === e) return -1;
                    }
                    return n.index - r.index;
                }), "value");
            },
            groupBy: Dr,
            indexBy: Rr,
            countBy: Vr,
            partition: Fr,
            toArray: kr,
            size: function(n) {
                return null == n ? 0 : rr(n) ? n.length : nn(n).length;
            },
            pick: qr,
            omit: Ur,
            first: zr,
            head: zr,
            take: zr,
            initial: Wr,
            last: function(n, r, t) {
                return null == n || n.length < 1 ? null == r || t ? void 0 : [] : null == r || t ? n[n.length - 1] : Lr(n, Math.max(0, n.length - r));
            },
            rest: Lr,
            tail: Lr,
            drop: Lr,
            compact: function(n) {
                return Ar(n, Boolean);
            },
            flatten: function(n, r) {
                return tr(n, r, !1);
            },
            without: Cr,
            uniq: Kr,
            unique: Kr,
            union: Jr,
            intersection: function(n) {
                for(var r = [], t = arguments.length, e = 0, u = Y(n); e < u; e++){
                    var i = n[e];
                    if (!Or(r, i)) {
                        var o;
                        for(o = 1; o < t && Or(arguments[o], i); o++);
                        o === t && r.push(i);
                    }
                }
                return r;
            },
            difference: $r,
            unzip: Gr,
            transpose: Gr,
            zip: Hr,
            object: function(n, r) {
                for(var t = {}, e = 0, u = Y(n); e < u; e++)r ? t[n[e]] = r[e] : t[n[e][0]] = n[e][1];
                return t;
            },
            range: function(n, r, t) {
                null == r && (r = n || 0, n = 0), t || (t = r < n ? -1 : 1);
                for(var e = Math.max(Math.ceil((r - n) / t), 0), u = Array(e), i = 0; i < e; i++, n += t)u[i] = n;
                return u;
            },
            chunk: function(n, r) {
                if (null == r || r < 1) return [];
                for(var t = [], e = 0, u = n.length; e < u;)t.push(o.call(n, e, e += r));
                return t;
            },
            mixin: Xr,
            default: tn
        });
        return Yr._ = Yr, Yr;
    });
})((0, $d3be9eebbc8f28b8$export$3b14a55fb2447963));
var $187365f460a6e3ed$export$2e2bcd8739ae039 = (0, $d3be9eebbc8f28b8$export$3b14a55fb2447963).exports;


var $9ab2e0ac5722e186$export$42940898df819940 = "en";
var $9ab2e0ac5722e186$export$83d89fbfd8236492 = "7.51.0";
var $9ab2e0ac5722e186$export$1c2c8674a5fbafd = [
    "en",
    "cs",
    "da",
    "de",
    "el",
    "es",
    "eu",
    "fi",
    "fr",
    "ht",
    "hu",
    "id",
    "in",
    "it",
    "ja",
    "ko",
    "ms",
    "nb",
    "nl-NL",
    "ok-PL",
    "ok-SK",
    "pl",
    "pt-BR",
    "ro",
    "ru",
    "sv",
    "th",
    "tr",
    "uk",
    "vi",
    "zh-CN",
    "zh-TW"
];
var $9ab2e0ac5722e186$export$2e2bcd8739ae039 = {
    defaultLanguage: $9ab2e0ac5722e186$export$42940898df819940,
    version: $9ab2e0ac5722e186$export$83d89fbfd8236492,
    supportedLanguages: $9ab2e0ac5722e186$export$1c2c8674a5fbafd
};



var $3ZxP0 = parcelRequire("3ZxP0");
var $a955fad7595f7a80$export$515692adc069839f = "Afghanistan";
var $a955fad7595f7a80$export$f5cd1d288a5591fb = "\xc5land Islands";
var $a955fad7595f7a80$export$1bb1140fe1358b00 = "Albania";
var $a955fad7595f7a80$export$d2309a4fc782a0d1 = "Algeria";
var $a955fad7595f7a80$export$33f07343a4b8be1f = "American Samoa";
var $a955fad7595f7a80$export$132ea4ffd82bf2b2 = "Andorra";
var $a955fad7595f7a80$export$98cc8105f49bb278 = "Angola";
var $a955fad7595f7a80$export$d710c5f50fc7496a = "Anguilla";
var $a955fad7595f7a80$export$123513653fa883e4 = "Antarctica";
var $a955fad7595f7a80$export$9b1a14e161c718eb = "Antigua and Barbuda";
var $a955fad7595f7a80$export$1cd25c0dace0921a = "Argentina";
var $a955fad7595f7a80$export$1507e1869e034170 = "Armenia";
var $a955fad7595f7a80$export$d170d5872abbd45 = "Aruba";
var $a955fad7595f7a80$export$24f205cbfb89b8fc = "Australia";
var $a955fad7595f7a80$export$537de78b98ba1ef0 = "Austria";
var $a955fad7595f7a80$export$16cde7da05f651a = "Azerbaijan";
var $a955fad7595f7a80$export$66ea4a98fa009686 = "Bahamas";
var $a955fad7595f7a80$export$873be2d0c4c0f90f = "Bahrain";
var $a955fad7595f7a80$export$2672079d1ac1dedf = "Bangladesh";
var $a955fad7595f7a80$export$921068d8846a1559 = "Barbados";
var $a955fad7595f7a80$export$558af6901b7fc79a = "Belarus";
var $a955fad7595f7a80$export$69784246352913ed = "Belgium";
var $a955fad7595f7a80$export$8af59566cb38fe85 = "Belize";
var $a955fad7595f7a80$export$289e628e47fc68d4 = "Benin";
var $a955fad7595f7a80$export$f063c90a7fd94f53 = "Bermuda";
var $a955fad7595f7a80$export$433b53d451a98e6d = "Bhutan";
var $a955fad7595f7a80$export$cd6527c992e4b6fe = "Bolivia, Plurinational State of";
var $a955fad7595f7a80$export$a73c4d14459b698d = "Bosnia and Herzegovina";
var $a955fad7595f7a80$export$cd7b90d76addb66a = "Botswana";
var $a955fad7595f7a80$export$8ba1594c72a88684 = "Bouvet Island";
var $a955fad7595f7a80$export$b3e0c086157e0a90 = "Brazil";
var $a955fad7595f7a80$export$8f8422ac5947a789 = "British Indian Ocean Territory";
var $a955fad7595f7a80$export$42769a1039364fc6 = "Virgin Islands, British";
var $a955fad7595f7a80$export$ed16643e9b9e3dfe = "Brunei Darussalam";
var $a955fad7595f7a80$export$7ecc97c3ec9172d0 = "Bulgaria";
var $a955fad7595f7a80$export$5d7d56d6166de861 = "Burkina Faso";
var $a955fad7595f7a80$export$2601bd2ab73f6dbe = "Burundi";
var $a955fad7595f7a80$export$96381358fb12b492 = "Cambodia";
var $a955fad7595f7a80$export$dcd191669c0a595f = "Cameroon";
var $a955fad7595f7a80$export$8de6180416dff1fc = "Canada";
var $a955fad7595f7a80$export$9c7a4b602f1ee953 = "Cape Verde";
var $a955fad7595f7a80$export$ea257f329676e0aa = "Cayman Islands";
var $a955fad7595f7a80$export$ba26f2d80491fb47 = "Central African Republic";
var $a955fad7595f7a80$export$9cf5b401f969f5e3 = "Chad";
var $a955fad7595f7a80$export$9bf3043cb7503aa1 = "Chile";
var $a955fad7595f7a80$export$f175668af5171efd = "China";
var $a955fad7595f7a80$export$ef748afa94c5c5f9 = "Christmas Island";
var $a955fad7595f7a80$export$423e5ab65bdedcb8 = "Colombia";
var $a955fad7595f7a80$export$7ca86d88f982585b = "Comoros";
var $a955fad7595f7a80$export$9e8da9070f3c2e68 = "Congo";
var $a955fad7595f7a80$export$2779adff9720d9c9 = "Cook Islands";
var $a955fad7595f7a80$export$de92be486109a1df = "Costa Rica";
var $a955fad7595f7a80$export$ddcf9efc80efb978 = "C\xf4te d'Ivoire";
var $a955fad7595f7a80$export$41dbabafe943a3bc = "Croatia";
var $a955fad7595f7a80$export$6f478fc577ffffe3 = "Cuba";
var $a955fad7595f7a80$export$e5e7583d5d9c5f7b = "Cyprus";
var $a955fad7595f7a80$export$3aa7db55ae20a642 = "Czech Republic";
var $a955fad7595f7a80$export$6ede307faf7aaec4 = "Congo, the Democratic Republic of the";
var $a955fad7595f7a80$export$861a3271cad515fc = "Denmark";
var $a955fad7595f7a80$export$b116121769fff50f = "Djibouti";
var $a955fad7595f7a80$export$c63caaa7a05b64da = "Dominica";
var $a955fad7595f7a80$export$fe81c0b6cf107daf = "Dominican Republic";
var $a955fad7595f7a80$export$28666a74ae2b9cff = "Timor-Leste";
var $a955fad7595f7a80$export$129fe12d32abc311 = "Ecuador";
var $a955fad7595f7a80$export$e107e11ec3489258 = "Egypt";
var $a955fad7595f7a80$export$8fc936c6ebd916b3 = "El Salvador";
var $a955fad7595f7a80$export$64532cc081f88b3a = "Equatorial Guinea";
var $a955fad7595f7a80$export$20e28a5cfb7c13df = "Eritrea";
var $a955fad7595f7a80$export$3f443bcc5237c742 = "Estonia";
var $a955fad7595f7a80$export$404386694049c788 = "Ethiopia";
var $a955fad7595f7a80$export$58f4e3559034e3ed = "Falkland Islands (Malvinas)";
var $a955fad7595f7a80$export$3117889032a11ab0 = "Faroe Islands";
var $a955fad7595f7a80$export$4cd493ed69e3bc18 = "Fiji";
var $a955fad7595f7a80$export$b742dc37108d5cac = "Finland";
var $a955fad7595f7a80$export$b0bfe88d8be86eef = "France";
var $a955fad7595f7a80$export$a1c692af90f0ad93 = "French Guiana";
var $a955fad7595f7a80$export$7d19ebf018caa9aa = "French Polynesia";
var $a955fad7595f7a80$export$4014e91f2965d3df = "French Southern Territories";
var $a955fad7595f7a80$export$2c816677949efbbf = "Gabon";
var $a955fad7595f7a80$export$af02b8e3ecf08df4 = "Gambia";
var $a955fad7595f7a80$export$64f1adb8dced2c27 = "Georgia";
var $a955fad7595f7a80$export$b2bfc53cef5629f5 = "Germany";
var $a955fad7595f7a80$export$2063236980199869 = "Ghana";
var $a955fad7595f7a80$export$b3b059666b470a4 = "Gibraltar";
var $a955fad7595f7a80$export$be3bb2d6fb94aa6 = "Greece";
var $a955fad7595f7a80$export$bad2a840ccda93b6 = "Greenland";
var $a955fad7595f7a80$export$44132903afebf574 = "Grenada";
var $a955fad7595f7a80$export$a1e9daa76fd80d91 = "Guadeloupe";
var $a955fad7595f7a80$export$875a05f1afdc3a63 = "Guam";
var $a955fad7595f7a80$export$b023c82b48e70453 = "Guatemala";
var $a955fad7595f7a80$export$ffd553dab4f92f72 = "Guernsey";
var $a955fad7595f7a80$export$49b768d2cda4fc68 = "Guinea";
var $a955fad7595f7a80$export$4f7b2a18b14c6e6 = "Guinea-Bissau";
var $a955fad7595f7a80$export$f433acc20da515b9 = "Guyana";
var $a955fad7595f7a80$export$3927bce5ead7457e = "Haiti";
var $a955fad7595f7a80$export$e8ae668e70e7a813 = "Heard Island and McDonald Islands";
var $a955fad7595f7a80$export$d654914ee99e1b51 = "Honduras";
var $a955fad7595f7a80$export$7bf8e436292b0d9 = "Hong Kong";
var $a955fad7595f7a80$export$2cba20fb7b4c6fda = "Hungary";
var $a955fad7595f7a80$export$bfe27467c1de9413 = "Iceland";
var $a955fad7595f7a80$export$70824c8942178d60 = "India";
var $a955fad7595f7a80$export$8be180ec26319f9f = "Indonesia";
var $a955fad7595f7a80$export$35f3e3f7e3ce71e0 = "Iran, Islamic Republic of";
var $a955fad7595f7a80$export$776a9becd139230f = "Iraq";
var $a955fad7595f7a80$export$5056f4df3c1a040a = "Ireland";
var $a955fad7595f7a80$export$747f5b589ac90db = "Israel";
var $a955fad7595f7a80$export$c8c4756768edc1be = "Italy";
var $a955fad7595f7a80$export$62925b2b1d8826f = "Jamaica";
var $a955fad7595f7a80$export$4165087edc6149ea = "Japan";
var $a955fad7595f7a80$export$7300d7e65520d9c0 = "Jersey";
var $a955fad7595f7a80$export$4ff8ba3b6e78910e = "Jordan";
var $a955fad7595f7a80$export$45edc2c6b51c02b3 = "Kazakhstan";
var $a955fad7595f7a80$export$ebf06250eda1662e = "Kenya";
var $a955fad7595f7a80$export$8aa7bcd4299a59b9 = "Kiribati";
var $a955fad7595f7a80$export$ced591d2396bbc3f = "Korea, Republic of";
var $a955fad7595f7a80$export$ba5d28d969e41cd5 = "Kosovo, Republic of";
var $a955fad7595f7a80$export$867391011d376267 = "Kuwait";
var $a955fad7595f7a80$export$32f37961c13d8178 = "Kyrgyzstan";
var $a955fad7595f7a80$export$64f943d6c6d62030 = "Lao People's Democratic Republic";
var $a955fad7595f7a80$export$feea9fafc15a0118 = "Latvia";
var $a955fad7595f7a80$export$1dd3e96947fb44fc = "Lebanon";
var $a955fad7595f7a80$export$c6944423ed371873 = "Lesotho";
var $a955fad7595f7a80$export$9e0d336de5ae0eb3 = "Liberia";
var $a955fad7595f7a80$export$4eb7334fca20385f = "Libya";
var $a955fad7595f7a80$export$2e3013aac067a692 = "Liechtenstein";
var $a955fad7595f7a80$export$7158f0ceb70f54c7 = "Lithuania";
var $a955fad7595f7a80$export$b6a2dd8a7c2d6cd5 = "Luxembourg";
var $a955fad7595f7a80$export$511fbc18fa6ca984 = "Macao";
var $a955fad7595f7a80$export$9391ff7d7f7d79ce = "Macedonia, the former Yugoslav Republic of";
var $a955fad7595f7a80$export$d7c1ae0cf4ef5274 = "Madagascar";
var $a955fad7595f7a80$export$a3772f6eb527275b = "Malawi";
var $a955fad7595f7a80$export$655dc88003efaac0 = "Malaysia";
var $a955fad7595f7a80$export$20138591ba7d4d60 = "Maldives";
var $a955fad7595f7a80$export$670dad092b145ea = "Mali";
var $a955fad7595f7a80$export$b900a375df2ae552 = "Malta";
var $a955fad7595f7a80$export$61a81a4b59098e0c = "Marshall Islands";
var $a955fad7595f7a80$export$451b471c9c9066b = "Martinique";
var $a955fad7595f7a80$export$c4e38e98e3fb5f60 = "Mauritania";
var $a955fad7595f7a80$export$c5764e4399dad848 = "Mauritius";
var $a955fad7595f7a80$export$8c2e794969bbe829 = "Mayotte";
var $a955fad7595f7a80$export$80b36494c451f15f = "Mexico";
var $a955fad7595f7a80$export$ae39d226e90e08ef = "Micronesia, Federated States of";
var $a955fad7595f7a80$export$3c37c3bdb860ae1e = "Moldova, Republic of";
var $a955fad7595f7a80$export$cd68417dc2ec295d = "Monaco";
var $a955fad7595f7a80$export$30e7c6589c527eef = "Mongolia";
var $a955fad7595f7a80$export$4898541b722d275d = "Montenegro";
var $a955fad7595f7a80$export$71ad59f2e432cfe8 = "Montserrat";
var $a955fad7595f7a80$export$d88940c21edc1e8e = "Morocco";
var $a955fad7595f7a80$export$b5030f3cedb7f384 = "Mozambique";
var $a955fad7595f7a80$export$eefdfd8a735ff143 = "Myanmar";
var $a955fad7595f7a80$export$dbd1925f4fe9ec65 = "Namibia";
var $a955fad7595f7a80$export$8885480fb36cb8cc = "Nauru";
var $a955fad7595f7a80$export$575bf2af220888ee = "Nepal";
var $a955fad7595f7a80$export$e51d3c675bb0140d = "Netherlands";
var $a955fad7595f7a80$export$d4e96247cd57e163 = "Netherlands Antilles";
var $a955fad7595f7a80$export$fbcebdb931d67ac9 = "New Caledonia";
var $a955fad7595f7a80$export$b6db8d689596ccb0 = "New Zealand";
var $a955fad7595f7a80$export$2128ddd8b6e5cc05 = "Nicaragua";
var $a955fad7595f7a80$export$8719acbfb72c829 = "Niger";
var $a955fad7595f7a80$export$d9501190a8cd7a46 = "Nigeria";
var $a955fad7595f7a80$export$8227ca023eb0daaa = "Niue";
var $a955fad7595f7a80$export$ebe65a9e9fde641f = "Norfolk Island";
var $a955fad7595f7a80$export$171643e72dc5e91 = "Korea, Democratic People's Republic of";
var $a955fad7595f7a80$export$15b7d6cdd29b06a0 = "Northern Mariana Islands";
var $a955fad7595f7a80$export$c01351c0af048e39 = "Norway";
var $a955fad7595f7a80$export$1ed389bd9cb529 = "Oman";
var $a955fad7595f7a80$export$73910688e185534c = "Pakistan";
var $a955fad7595f7a80$export$5f5211c171c1b47a = "Palau";
var $a955fad7595f7a80$export$5adddb0645f34b2 = "Palestine, State of";
var $a955fad7595f7a80$export$ff7e3d480d313da2 = "Panama";
var $a955fad7595f7a80$export$c56943b7b8ffea21 = "Papua New Guinea";
var $a955fad7595f7a80$export$21b6e0fb60b525ae = "Paraguay";
var $a955fad7595f7a80$export$d5e55eb9565ea8d5 = "Peru";
var $a955fad7595f7a80$export$38ea63fabb2c685f = "Philippines";
var $a955fad7595f7a80$export$6bc8c38c416ebf89 = "Pitcairn";
var $a955fad7595f7a80$export$9e95f02561f2d9f9 = "Poland";
var $a955fad7595f7a80$export$3961bdb9130b90e7 = "Portugal";
var $a955fad7595f7a80$export$af5f8d68aad3cd3a = "Puerto Rico";
var $a955fad7595f7a80$export$a7078eadaecd4b6f = "Qatar";
var $a955fad7595f7a80$export$ded96516917cab2a = "R\xe9union";
var $a955fad7595f7a80$export$993ec495e78d530d = "Romania";
var $a955fad7595f7a80$export$6c2517b5e52f01cc = "Russian Federation";
var $a955fad7595f7a80$export$ef5ca6a08aac8ca5 = "Rwanda";
var $a955fad7595f7a80$export$c713cf928ffb5e8e = "Saint Helena, Ascension and Tristan da Cunha";
var $a955fad7595f7a80$export$fd8f06eb7ce62883 = "Saint Kitts and Nevis";
var $a955fad7595f7a80$export$3cb73e0e841fe17f = "Saint Lucia";
var $a955fad7595f7a80$export$164607a37e7daeba = "Saint Pierre and Miquelon";
var $a955fad7595f7a80$export$c3ea4fdfa4d8ecb7 = "Saint Vincent and the Grenadines";
var $a955fad7595f7a80$export$911baa0677ac404c = "Samoa";
var $a955fad7595f7a80$export$59096964bd9627ef = "San Marino";
var $a955fad7595f7a80$export$80980ed6b6f31397 = "S\xe3o Tom\xe9 and Pr\xedncipe";
var $a955fad7595f7a80$export$da51c6332ad11d7b = "Saudi Arabia";
var $a955fad7595f7a80$export$b70f9dd36a734be4 = "Senegal";
var $a955fad7595f7a80$export$e9d8d46fbf5f29f6 = "Serbia";
var $a955fad7595f7a80$export$f49cccbff6374af4 = "Seychelles";
var $a955fad7595f7a80$export$b49d6918df199090 = "Sierra Leone";
var $a955fad7595f7a80$export$bea437c40441867d = "Singapore";
var $a955fad7595f7a80$export$5f584391ee0d99b4 = "Slovakia";
var $a955fad7595f7a80$export$e6702cab675b095 = "Slovenia";
var $a955fad7595f7a80$export$279f8048cbf05e80 = "Solomon Islands";
var $a955fad7595f7a80$export$f6311706676f39f2 = "Somalia";
var $a955fad7595f7a80$export$b2eccbdcd109dde0 = "South Africa";
var $a955fad7595f7a80$export$f7fbe7cb90eabcb4 = "South Georgia and the South Sandwich Islands";
var $a955fad7595f7a80$export$8cda4cf3f4deb8c2 = "South Sudan";
var $a955fad7595f7a80$export$a723e6e41cced9bd = "Spain";
var $a955fad7595f7a80$export$782aca1f2c103f6b = "Sri Lanka";
var $a955fad7595f7a80$export$5b088def975a652b = "Sudan";
var $a955fad7595f7a80$export$13acf42283a26926 = "Suriname";
var $a955fad7595f7a80$export$e9f025fd23256930 = "Svalbard and Jan Mayen";
var $a955fad7595f7a80$export$988c8b3cfeed3531 = "Swaziland";
var $a955fad7595f7a80$export$88d2e60d4be28663 = "Sweden";
var $a955fad7595f7a80$export$31ff2235b44019b8 = "Switzerland";
var $a955fad7595f7a80$export$2e8caadc521d7cbb = "Syrian Arab Republic";
var $a955fad7595f7a80$export$1d1fd77441e66de6 = "Taiwan";
var $a955fad7595f7a80$export$f5448d52a2727e70 = "Tajikistan";
var $a955fad7595f7a80$export$786aa6dc686c7fa2 = "Tanzania, United Republic of";
var $a955fad7595f7a80$export$2b39a3648955dd09 = "Thailand";
var $a955fad7595f7a80$export$3909ee2d70cce411 = "Togo";
var $a955fad7595f7a80$export$73184284939cbbe8 = "Tokelau";
var $a955fad7595f7a80$export$ee525e60afffec7b = "Tonga";
var $a955fad7595f7a80$export$c506431d6b27243b = "Trinidad and Tobago";
var $a955fad7595f7a80$export$82039c5ab5b44a72 = "Tunisia";
var $a955fad7595f7a80$export$5582bd7183a5e873 = "Turkey";
var $a955fad7595f7a80$export$e3227e6e5fca8775 = "Turkmenistan";
var $a955fad7595f7a80$export$bf91931db7b40921 = "Turks and Caicos Islands";
var $a955fad7595f7a80$export$9e799ed47e538f9d = "Tuvalu";
var $a955fad7595f7a80$export$ae144c30ed7463e6 = "Virgin Islands, U.S.";
var $a955fad7595f7a80$export$c5b3cc9fdc52ea1d = "Uganda";
var $a955fad7595f7a80$export$4b88e746e0f81154 = "Ukraine";
var $a955fad7595f7a80$export$2b2c8e343c91a153 = "United Arab Emirates";
var $a955fad7595f7a80$export$5c1daad85ece4f0d = "United Kingdom";
var $a955fad7595f7a80$export$6137fb82cd5996e9 = "United States";
var $a955fad7595f7a80$export$a0e1852ae1fae17b = "United States Minor Outlying Islands";
var $a955fad7595f7a80$export$3f448fbd9cc8b25f = "Uruguay";
var $a955fad7595f7a80$export$6553e0f362fae356 = "Uzbekistan";
var $a955fad7595f7a80$export$e4fcd53a919210fd = "Vanuatu";
var $a955fad7595f7a80$export$8f976c058e984810 = "Holy See (Vatican City State)";
var $a955fad7595f7a80$export$d7d2699f2b01bb80 = "Venezuela, Bolivarian Republic of";
var $a955fad7595f7a80$export$4ef9166b5b9f8bef = "Viet Nam";
var $a955fad7595f7a80$export$2791da67db7afdb6 = "Wallis and Futuna";
var $a955fad7595f7a80$export$8e048a19e03780a2 = "Western Sahara";
var $a955fad7595f7a80$export$5c4a0ca5352789e5 = "Yemen";
var $a955fad7595f7a80$export$8b0f08115411339f = "Zambia";
var $a955fad7595f7a80$export$b2fd9c01d360241f = "Zimbabwe";
var $a955fad7595f7a80$export$2e2bcd8739ae039 = {
    AF: $a955fad7595f7a80$export$515692adc069839f,
    AX: $a955fad7595f7a80$export$f5cd1d288a5591fb,
    AL: $a955fad7595f7a80$export$1bb1140fe1358b00,
    DZ: $a955fad7595f7a80$export$d2309a4fc782a0d1,
    AS: $a955fad7595f7a80$export$33f07343a4b8be1f,
    AD: $a955fad7595f7a80$export$132ea4ffd82bf2b2,
    AO: $a955fad7595f7a80$export$98cc8105f49bb278,
    AI: $a955fad7595f7a80$export$d710c5f50fc7496a,
    AQ: $a955fad7595f7a80$export$123513653fa883e4,
    AG: $a955fad7595f7a80$export$9b1a14e161c718eb,
    AR: $a955fad7595f7a80$export$1cd25c0dace0921a,
    AM: $a955fad7595f7a80$export$1507e1869e034170,
    AW: $a955fad7595f7a80$export$d170d5872abbd45,
    AU: $a955fad7595f7a80$export$24f205cbfb89b8fc,
    AT: $a955fad7595f7a80$export$537de78b98ba1ef0,
    AZ: $a955fad7595f7a80$export$16cde7da05f651a,
    BS: $a955fad7595f7a80$export$66ea4a98fa009686,
    BH: $a955fad7595f7a80$export$873be2d0c4c0f90f,
    BD: $a955fad7595f7a80$export$2672079d1ac1dedf,
    BB: $a955fad7595f7a80$export$921068d8846a1559,
    BY: $a955fad7595f7a80$export$558af6901b7fc79a,
    BE: $a955fad7595f7a80$export$69784246352913ed,
    BZ: $a955fad7595f7a80$export$8af59566cb38fe85,
    BJ: $a955fad7595f7a80$export$289e628e47fc68d4,
    BM: $a955fad7595f7a80$export$f063c90a7fd94f53,
    BT: $a955fad7595f7a80$export$433b53d451a98e6d,
    BO: $a955fad7595f7a80$export$cd6527c992e4b6fe,
    BA: $a955fad7595f7a80$export$a73c4d14459b698d,
    BW: $a955fad7595f7a80$export$cd7b90d76addb66a,
    BV: $a955fad7595f7a80$export$8ba1594c72a88684,
    BR: $a955fad7595f7a80$export$b3e0c086157e0a90,
    IO: $a955fad7595f7a80$export$8f8422ac5947a789,
    VG: $a955fad7595f7a80$export$42769a1039364fc6,
    BN: $a955fad7595f7a80$export$ed16643e9b9e3dfe,
    BG: $a955fad7595f7a80$export$7ecc97c3ec9172d0,
    BF: $a955fad7595f7a80$export$5d7d56d6166de861,
    BI: $a955fad7595f7a80$export$2601bd2ab73f6dbe,
    KH: $a955fad7595f7a80$export$96381358fb12b492,
    CM: $a955fad7595f7a80$export$dcd191669c0a595f,
    CA: $a955fad7595f7a80$export$8de6180416dff1fc,
    CV: $a955fad7595f7a80$export$9c7a4b602f1ee953,
    KY: $a955fad7595f7a80$export$ea257f329676e0aa,
    CF: $a955fad7595f7a80$export$ba26f2d80491fb47,
    TD: $a955fad7595f7a80$export$9cf5b401f969f5e3,
    CL: $a955fad7595f7a80$export$9bf3043cb7503aa1,
    CN: $a955fad7595f7a80$export$f175668af5171efd,
    CX: $a955fad7595f7a80$export$ef748afa94c5c5f9,
    CO: $a955fad7595f7a80$export$423e5ab65bdedcb8,
    KM: $a955fad7595f7a80$export$7ca86d88f982585b,
    CG: $a955fad7595f7a80$export$9e8da9070f3c2e68,
    CK: $a955fad7595f7a80$export$2779adff9720d9c9,
    CR: $a955fad7595f7a80$export$de92be486109a1df,
    CI: $a955fad7595f7a80$export$ddcf9efc80efb978,
    HR: $a955fad7595f7a80$export$41dbabafe943a3bc,
    CU: $a955fad7595f7a80$export$6f478fc577ffffe3,
    CY: $a955fad7595f7a80$export$e5e7583d5d9c5f7b,
    CZ: $a955fad7595f7a80$export$3aa7db55ae20a642,
    CD: $a955fad7595f7a80$export$6ede307faf7aaec4,
    DK: $a955fad7595f7a80$export$861a3271cad515fc,
    DJ: $a955fad7595f7a80$export$b116121769fff50f,
    DM: $a955fad7595f7a80$export$c63caaa7a05b64da,
    DO: $a955fad7595f7a80$export$fe81c0b6cf107daf,
    TL: $a955fad7595f7a80$export$28666a74ae2b9cff,
    EC: $a955fad7595f7a80$export$129fe12d32abc311,
    EG: $a955fad7595f7a80$export$e107e11ec3489258,
    SV: $a955fad7595f7a80$export$8fc936c6ebd916b3,
    GQ: $a955fad7595f7a80$export$64532cc081f88b3a,
    ER: $a955fad7595f7a80$export$20e28a5cfb7c13df,
    EE: $a955fad7595f7a80$export$3f443bcc5237c742,
    ET: $a955fad7595f7a80$export$404386694049c788,
    FK: $a955fad7595f7a80$export$58f4e3559034e3ed,
    FO: $a955fad7595f7a80$export$3117889032a11ab0,
    FJ: $a955fad7595f7a80$export$4cd493ed69e3bc18,
    FI: $a955fad7595f7a80$export$b742dc37108d5cac,
    FR: $a955fad7595f7a80$export$b0bfe88d8be86eef,
    GF: $a955fad7595f7a80$export$a1c692af90f0ad93,
    PF: $a955fad7595f7a80$export$7d19ebf018caa9aa,
    TF: $a955fad7595f7a80$export$4014e91f2965d3df,
    GA: $a955fad7595f7a80$export$2c816677949efbbf,
    GM: $a955fad7595f7a80$export$af02b8e3ecf08df4,
    GE: $a955fad7595f7a80$export$64f1adb8dced2c27,
    DE: $a955fad7595f7a80$export$b2bfc53cef5629f5,
    GH: $a955fad7595f7a80$export$2063236980199869,
    GI: $a955fad7595f7a80$export$b3b059666b470a4,
    GR: $a955fad7595f7a80$export$be3bb2d6fb94aa6,
    GL: $a955fad7595f7a80$export$bad2a840ccda93b6,
    GD: $a955fad7595f7a80$export$44132903afebf574,
    GP: $a955fad7595f7a80$export$a1e9daa76fd80d91,
    GU: $a955fad7595f7a80$export$875a05f1afdc3a63,
    GT: $a955fad7595f7a80$export$b023c82b48e70453,
    GG: $a955fad7595f7a80$export$ffd553dab4f92f72,
    GN: $a955fad7595f7a80$export$49b768d2cda4fc68,
    GW: $a955fad7595f7a80$export$4f7b2a18b14c6e6,
    GY: $a955fad7595f7a80$export$f433acc20da515b9,
    HT: $a955fad7595f7a80$export$3927bce5ead7457e,
    HM: $a955fad7595f7a80$export$e8ae668e70e7a813,
    HN: $a955fad7595f7a80$export$d654914ee99e1b51,
    HK: $a955fad7595f7a80$export$7bf8e436292b0d9,
    HU: $a955fad7595f7a80$export$2cba20fb7b4c6fda,
    IS: $a955fad7595f7a80$export$bfe27467c1de9413,
    IN: $a955fad7595f7a80$export$70824c8942178d60,
    ID: $a955fad7595f7a80$export$8be180ec26319f9f,
    IR: $a955fad7595f7a80$export$35f3e3f7e3ce71e0,
    IQ: $a955fad7595f7a80$export$776a9becd139230f,
    IE: $a955fad7595f7a80$export$5056f4df3c1a040a,
    IL: $a955fad7595f7a80$export$747f5b589ac90db,
    IT: $a955fad7595f7a80$export$c8c4756768edc1be,
    JM: $a955fad7595f7a80$export$62925b2b1d8826f,
    JP: $a955fad7595f7a80$export$4165087edc6149ea,
    JE: $a955fad7595f7a80$export$7300d7e65520d9c0,
    JO: $a955fad7595f7a80$export$4ff8ba3b6e78910e,
    KZ: $a955fad7595f7a80$export$45edc2c6b51c02b3,
    KE: $a955fad7595f7a80$export$ebf06250eda1662e,
    KI: $a955fad7595f7a80$export$8aa7bcd4299a59b9,
    KR: $a955fad7595f7a80$export$ced591d2396bbc3f,
    XK: $a955fad7595f7a80$export$ba5d28d969e41cd5,
    KW: $a955fad7595f7a80$export$867391011d376267,
    KG: $a955fad7595f7a80$export$32f37961c13d8178,
    LA: $a955fad7595f7a80$export$64f943d6c6d62030,
    LV: $a955fad7595f7a80$export$feea9fafc15a0118,
    LB: $a955fad7595f7a80$export$1dd3e96947fb44fc,
    LS: $a955fad7595f7a80$export$c6944423ed371873,
    LR: $a955fad7595f7a80$export$9e0d336de5ae0eb3,
    LY: $a955fad7595f7a80$export$4eb7334fca20385f,
    LI: $a955fad7595f7a80$export$2e3013aac067a692,
    LT: $a955fad7595f7a80$export$7158f0ceb70f54c7,
    LU: $a955fad7595f7a80$export$b6a2dd8a7c2d6cd5,
    MO: $a955fad7595f7a80$export$511fbc18fa6ca984,
    MK: $a955fad7595f7a80$export$9391ff7d7f7d79ce,
    MG: $a955fad7595f7a80$export$d7c1ae0cf4ef5274,
    MW: $a955fad7595f7a80$export$a3772f6eb527275b,
    MY: $a955fad7595f7a80$export$655dc88003efaac0,
    MV: $a955fad7595f7a80$export$20138591ba7d4d60,
    ML: $a955fad7595f7a80$export$670dad092b145ea,
    MT: $a955fad7595f7a80$export$b900a375df2ae552,
    MH: $a955fad7595f7a80$export$61a81a4b59098e0c,
    MQ: $a955fad7595f7a80$export$451b471c9c9066b,
    MR: $a955fad7595f7a80$export$c4e38e98e3fb5f60,
    MU: $a955fad7595f7a80$export$c5764e4399dad848,
    YT: $a955fad7595f7a80$export$8c2e794969bbe829,
    MX: $a955fad7595f7a80$export$80b36494c451f15f,
    FM: $a955fad7595f7a80$export$ae39d226e90e08ef,
    MD: $a955fad7595f7a80$export$3c37c3bdb860ae1e,
    MC: $a955fad7595f7a80$export$cd68417dc2ec295d,
    MN: $a955fad7595f7a80$export$30e7c6589c527eef,
    ME: $a955fad7595f7a80$export$4898541b722d275d,
    MS: $a955fad7595f7a80$export$71ad59f2e432cfe8,
    MA: $a955fad7595f7a80$export$d88940c21edc1e8e,
    MZ: $a955fad7595f7a80$export$b5030f3cedb7f384,
    MM: $a955fad7595f7a80$export$eefdfd8a735ff143,
    NA: $a955fad7595f7a80$export$dbd1925f4fe9ec65,
    NR: $a955fad7595f7a80$export$8885480fb36cb8cc,
    NP: $a955fad7595f7a80$export$575bf2af220888ee,
    NL: $a955fad7595f7a80$export$e51d3c675bb0140d,
    AN: $a955fad7595f7a80$export$d4e96247cd57e163,
    NC: $a955fad7595f7a80$export$fbcebdb931d67ac9,
    NZ: $a955fad7595f7a80$export$b6db8d689596ccb0,
    NI: $a955fad7595f7a80$export$2128ddd8b6e5cc05,
    NE: $a955fad7595f7a80$export$8719acbfb72c829,
    NG: $a955fad7595f7a80$export$d9501190a8cd7a46,
    NU: $a955fad7595f7a80$export$8227ca023eb0daaa,
    NF: $a955fad7595f7a80$export$ebe65a9e9fde641f,
    KP: $a955fad7595f7a80$export$171643e72dc5e91,
    MP: $a955fad7595f7a80$export$15b7d6cdd29b06a0,
    NO: $a955fad7595f7a80$export$c01351c0af048e39,
    OM: $a955fad7595f7a80$export$1ed389bd9cb529,
    PK: $a955fad7595f7a80$export$73910688e185534c,
    PW: $a955fad7595f7a80$export$5f5211c171c1b47a,
    PS: $a955fad7595f7a80$export$5adddb0645f34b2,
    PA: $a955fad7595f7a80$export$ff7e3d480d313da2,
    PG: $a955fad7595f7a80$export$c56943b7b8ffea21,
    PY: $a955fad7595f7a80$export$21b6e0fb60b525ae,
    PE: $a955fad7595f7a80$export$d5e55eb9565ea8d5,
    PH: $a955fad7595f7a80$export$38ea63fabb2c685f,
    PN: $a955fad7595f7a80$export$6bc8c38c416ebf89,
    PL: $a955fad7595f7a80$export$9e95f02561f2d9f9,
    PT: $a955fad7595f7a80$export$3961bdb9130b90e7,
    PR: $a955fad7595f7a80$export$af5f8d68aad3cd3a,
    QA: $a955fad7595f7a80$export$a7078eadaecd4b6f,
    RE: $a955fad7595f7a80$export$ded96516917cab2a,
    RO: $a955fad7595f7a80$export$993ec495e78d530d,
    RU: $a955fad7595f7a80$export$6c2517b5e52f01cc,
    RW: $a955fad7595f7a80$export$ef5ca6a08aac8ca5,
    SH: $a955fad7595f7a80$export$c713cf928ffb5e8e,
    KN: $a955fad7595f7a80$export$fd8f06eb7ce62883,
    LC: $a955fad7595f7a80$export$3cb73e0e841fe17f,
    PM: $a955fad7595f7a80$export$164607a37e7daeba,
    VC: $a955fad7595f7a80$export$c3ea4fdfa4d8ecb7,
    WS: $a955fad7595f7a80$export$911baa0677ac404c,
    SM: $a955fad7595f7a80$export$59096964bd9627ef,
    ST: $a955fad7595f7a80$export$80980ed6b6f31397,
    SA: $a955fad7595f7a80$export$da51c6332ad11d7b,
    SN: $a955fad7595f7a80$export$b70f9dd36a734be4,
    RS: $a955fad7595f7a80$export$e9d8d46fbf5f29f6,
    SC: $a955fad7595f7a80$export$f49cccbff6374af4,
    SL: $a955fad7595f7a80$export$b49d6918df199090,
    SG: $a955fad7595f7a80$export$bea437c40441867d,
    SK: $a955fad7595f7a80$export$5f584391ee0d99b4,
    SI: $a955fad7595f7a80$export$e6702cab675b095,
    SB: $a955fad7595f7a80$export$279f8048cbf05e80,
    SO: $a955fad7595f7a80$export$f6311706676f39f2,
    ZA: $a955fad7595f7a80$export$b2eccbdcd109dde0,
    GS: $a955fad7595f7a80$export$f7fbe7cb90eabcb4,
    SS: $a955fad7595f7a80$export$8cda4cf3f4deb8c2,
    ES: $a955fad7595f7a80$export$a723e6e41cced9bd,
    LK: $a955fad7595f7a80$export$782aca1f2c103f6b,
    SD: $a955fad7595f7a80$export$5b088def975a652b,
    SR: $a955fad7595f7a80$export$13acf42283a26926,
    SJ: $a955fad7595f7a80$export$e9f025fd23256930,
    SZ: $a955fad7595f7a80$export$988c8b3cfeed3531,
    SE: $a955fad7595f7a80$export$88d2e60d4be28663,
    CH: $a955fad7595f7a80$export$31ff2235b44019b8,
    SY: $a955fad7595f7a80$export$2e8caadc521d7cbb,
    TW: $a955fad7595f7a80$export$1d1fd77441e66de6,
    TJ: $a955fad7595f7a80$export$f5448d52a2727e70,
    TZ: $a955fad7595f7a80$export$786aa6dc686c7fa2,
    TH: $a955fad7595f7a80$export$2b39a3648955dd09,
    TG: $a955fad7595f7a80$export$3909ee2d70cce411,
    TK: $a955fad7595f7a80$export$73184284939cbbe8,
    TO: $a955fad7595f7a80$export$ee525e60afffec7b,
    TT: $a955fad7595f7a80$export$c506431d6b27243b,
    TN: $a955fad7595f7a80$export$82039c5ab5b44a72,
    TR: $a955fad7595f7a80$export$5582bd7183a5e873,
    TM: $a955fad7595f7a80$export$e3227e6e5fca8775,
    TC: $a955fad7595f7a80$export$bf91931db7b40921,
    TV: $a955fad7595f7a80$export$9e799ed47e538f9d,
    VI: $a955fad7595f7a80$export$ae144c30ed7463e6,
    UG: $a955fad7595f7a80$export$c5b3cc9fdc52ea1d,
    UA: $a955fad7595f7a80$export$4b88e746e0f81154,
    AE: $a955fad7595f7a80$export$2b2c8e343c91a153,
    GB: $a955fad7595f7a80$export$5c1daad85ece4f0d,
    US: $a955fad7595f7a80$export$6137fb82cd5996e9,
    UM: $a955fad7595f7a80$export$a0e1852ae1fae17b,
    UY: $a955fad7595f7a80$export$3f448fbd9cc8b25f,
    UZ: $a955fad7595f7a80$export$6553e0f362fae356,
    VU: $a955fad7595f7a80$export$e4fcd53a919210fd,
    VA: $a955fad7595f7a80$export$8f976c058e984810,
    VE: $a955fad7595f7a80$export$d7d2699f2b01bb80,
    VN: $a955fad7595f7a80$export$4ef9166b5b9f8bef,
    WF: $a955fad7595f7a80$export$2791da67db7afdb6,
    EH: $a955fad7595f7a80$export$8e048a19e03780a2,
    YE: $a955fad7595f7a80$export$5c4a0ca5352789e5,
    ZM: $a955fad7595f7a80$export$8b0f08115411339f,
    ZW: $a955fad7595f7a80$export$b2fd9c01d360241f
};


var $d9da1151f2dab40a$export$eb9bb22e6a16b416 = "Sign Out";
var $d9da1151f2dab40a$export$54f63e0bb65a6adc = "Sign In";
var $d9da1151f2dab40a$export$7200a869094fec36 = "Sign Up";
var $d9da1151f2dab40a$export$81b4caf1f4c1d04 = "Remember me";
var $d9da1151f2dab40a$export$4f16b20ba493189 = "Trust this device";
var $d9da1151f2dab40a$export$62dfc46afd566c81 = "Send push automatically";
var $d9da1151f2dab40a$export$9652d839878b1b1e = "Unlock account?";
var $d9da1151f2dab40a$export$eeee2529ed0682a = "Already have an account?";
var $d9da1151f2dab40a$export$44bc8287893556e = "Need help signing in?";
var $d9da1151f2dab40a$export$f4f5914c99131f05 = "Forgot password?";
var $d9da1151f2dab40a$export$34512e3b2db52a4e = "Help";
var $d9da1151f2dab40a$export$9369b12211e1fce4 = "Retry";
var $d9da1151f2dab40a$export$7b9cec868e3a0e = "iPhone";
var $d9da1151f2dab40a$export$49aa0afaaf9db9cb = "Android";
var $d9da1151f2dab40a$export$109b94763b9cda07 = "Back to sign in";
var $d9da1151f2dab40a$export$76d80e17ab66a7c = "You can close this window";
var $d9da1151f2dab40a$export$666252b437cce0c7 = "{0} minutes";
var $d9da1151f2dab40a$export$8d468796d69cdad1 = "{0} hours";
var $d9da1151f2dab40a$export$3cf5dda4201cc0f2 = "{0} days";
var $d9da1151f2dab40a$export$3dc543664767d449 = "The field must not contain HTML tags";
var $d9da1151f2dab40a$export$4646b3e49fc977de = "Server is unable to respond at the moment.";
var $d9da1151f2dab40a$export$2e2bcd8739ae039 = {
    signout: $d9da1151f2dab40a$export$eb9bb22e6a16b416,
    signin: $d9da1151f2dab40a$export$54f63e0bb65a6adc,
    signup: $d9da1151f2dab40a$export$7200a869094fec36,
    remember: $d9da1151f2dab40a$export$81b4caf1f4c1d04,
    rememberDevice: $d9da1151f2dab40a$export$4f16b20ba493189,
    "rememberDevice.timebased": "Do not challenge me on this device for the next {0}",
    "rememberDevice.devicebased": "Do not challenge me on this device again",
    autoPush: $d9da1151f2dab40a$export$62dfc46afd566c81,
    unlockaccount: $d9da1151f2dab40a$export$9652d839878b1b1e,
    haveaccount: $d9da1151f2dab40a$export$eeee2529ed0682a,
    needhelp: $d9da1151f2dab40a$export$44bc8287893556e,
    forgotpassword: $d9da1151f2dab40a$export$f4f5914c99131f05,
    help: $d9da1151f2dab40a$export$34512e3b2db52a4e,
    retry: $d9da1151f2dab40a$export$9369b12211e1fce4,
    iphone: $d9da1151f2dab40a$export$7b9cec868e3a0e,
    android: $d9da1151f2dab40a$export$49aa0afaaf9db9cb,
    goback: $d9da1151f2dab40a$export$109b94763b9cda07,
    closeWindow: $d9da1151f2dab40a$export$76d80e17ab66a7c,
    "country.option.label": "{0} ({1})",
    "phone.extention.label": "Extension",
    "select.default_value": "Select an option",
    "select.filter.no_match": "No results found for \"{0}\"",
    "sensitive.input.show": "Show",
    "sensitive.input.hide": "Hide",
    "processing.alt.text": "Processing...",
    "logo.default.alt.text": "Logo",
    "identifier.icon.alt.text": "User",
    "external.link.aria": "Opens in a new tab",
    "icon.title.application": "Application",
    "icon.title.browser": "Browser",
    "icon.title.mobileBrowser": "Mobile browser",
    "icon.title.location": "Location",
    "icon.title.mobileDevice": "Mobile Device",
    "skip.to.main.content": "Skip to main content",
    "minutes.oneMinute": "minute",
    minutes: $d9da1151f2dab40a$export$666252b437cce0c7,
    hours: $d9da1151f2dab40a$export$8d468796d69cdad1,
    days: $d9da1151f2dab40a$export$3cf5dda4201cc0f2,
    "error.config": "There was a configuration error",
    "error.required.authParams": "Missing parameters for the configured authentication scheme - \"OAUTH2\"",
    "error.required.baseUrl": "\"baseUrl\" is a required widget parameter",
    "error.required.success": "A success handler is required",
    "error.required.el": "\"el\" is a required widget parameter",
    "error.invalid.colors.brand": "\"colors.brand\" must be in six-digit hex format",
    "error.unsupported.browser": "Unsupported browser",
    "error.unsupported.cors": "Unsupported browser - missing CORS support",
    "error.unsupported.localStorage": "Unsupported browser - missing localStorage support",
    "error.enabled.cors": "There was an error sending the request - have you enabled CORS?",
    "error.expired.session": "Your session has expired. Please try to sign in again.",
    "error.mfa.only.expired.session": "Unable to authenticate at this time.",
    "error.auth.lockedOut": "Your account is locked. Please contact your administrator.",
    "error.oauth.idToken": "There was a problem generating the id_token for the user. Please try again.",
    "error.network.connection": "Unable to connect to the server. Please check your network connection.",
    "error.network.policy": "Access was blocked by a network policy. Please ensure your VPN is connected and try again.",
    "error.username.required": "Please enter a username",
    "error.password.required": "Please enter a password",
    "error.mfa.required": "The current sign on policy requires this client to redirect for re-authentication or MFA. Please contact your administrator.",
    "error.unsupported.response": "There was an unsupported response from server.",
    "error.request.timeout": "The request timed out. Please refresh the page and try again.",
    "error.server.internal": "The server encountered an error. Please refresh the page and try again.",
    "error.server.parse": "The server returned an unexpected response. Please refresh the page and try again.",
    "error.jit_failure": "Unable to sign in, please try another sign in method.",
    "error.unsynced.clock": "Unable to sign in. Please check that your device's clock is accurate and try again.",
    "errors.E0000004": "Unable to sign in",
    "errors.E0000069": "Your account is locked because of too many authentication attempts.",
    "errors.E0000047": "You exceeded the maximum number of requests. Try again in a while.",
    "errors.E0000079": "The operation is not allowed. Please refresh the page to proceed.",
    "errors.E0000001": "Api validation failed: {0}",
    "errors.E0000002": "The request was not valid: {0}",
    "errors.E0000003": "The request body was not well-formed.",
    "errors.E0000005": "Invalid session",
    "errors.E0000006": "You do not have permission to perform the requested action",
    "errors.E0000007": "Not found: {0}",
    "errors.E0000008": "The requested path was not found",
    "errors.E0000009": "Internal Server Error",
    "errors.E0000010": "Service is in read only mode",
    "errors.E0000011": "Invalid token provided",
    "errors.E0000012": "Unsupported media type",
    "errors.E0000013": "Invalid client app id",
    "errors.E0000015": "You do not have permission to access the feature you are requesting",
    "errors.E0000016": "Activation failed because the user is already active",
    "errors.E0000017": "Password reset failed",
    "errors.E0000018": "Bad request.  Accept and/or Content-Type headers are likely not set.",
    "errors.E0000019": "Bad request.  Accept and/or Content-Type headers likely do not match supported values.",
    "errors.E0000020": "Bad request.",
    "errors.E0000021": "Bad request.  Accept and/or Content-Type headers likely do not match supported values.",
    "errors.E0000022": "The endpoint does not support the provided HTTP method",
    "errors.E0000023": "Operation failed because user profile is mastered under another system",
    "errors.E0000024": "Bad request.  This operation on app metadata is not yet supported.",
    "errors.E0000025": "App version assignment failed.",
    "errors.E0000026": "This endpoint has been deprecated.",
    "errors.E0000027": "Group push bad request : {0}",
    "errors.E0000028": "The request is missing a required parameter.",
    "errors.E0000029": "Invalid paging request.",
    "errors.E0000030": "Bad request. Invalid date. Dates must be of the form yyyy-MM-dd''T''HH:mm:ss.SSSZZ, e.g. 2013-01-01T12:00:00.000-07:00.",
    "errors.E0000031": "Invalid search criteria.",
    "errors.E0000032": "Unlock is not allowed for this user.",
    "errors.E0000033": "Bad request. Can't specify a search query and filter in the same request.",
    "errors.E0000034": "Forgot password not allowed on specified user.",
    "errors.E0000035": "Change password not allowed on specified user.",
    "errors.E0000036": "Change recovery question not allowed on specified user.",
    "errors.E0000037": "Type mismatch exception.",
    "errors.E0000038": "This operation is not allowed in the user''s current status.",
    "errors.E0000039": "Operation on application settings failed.",
    "errors.E0000040": "Application label must not be the same as an existing application label.",
    "errors.E0000041": "Credentials should not be set on this resource based on the scheme.",
    "errors.E0000042": "Setting the error page redirect URL failed.",
    "errors.E0000043": "Self service application assignment is not enabled.",
    "errors.E0000044": "Self service application assignment is not supported.",
    "errors.E0000045": "Field mapping bad request.",
    "errors.E0000046": "Deactivate application for user forbidden.",
    "errors.E0000048": "Entity not found exception.",
    "errors.E0000049": "Invalid SCIM data from SCIM implementation.",
    "errors.E0000050": "Invalid SCIM data from client.",
    "errors.E0000051": "No response from SCIM implementation.",
    "errors.E0000052": "Endpoint not implemented.",
    "errors.E0000053": "Invalid SCIM filter.",
    "errors.E0000054": "Invalid pagination properties.",
    "errors.E0000055": "Duplicate group.",
    "errors.E0000056": "Delete application forbidden.",
    "errors.E0000057": "Access to this application is denied due to a policy.",
    "errors.E0000058": "Access to this application requires MFA: {0}",
    "errors.E0000059": "The connector configuration could not be tested. Make sure that the URL, Authentication Parameters are correct and that there is an implementation available at the URL provided.",
    "errors.E0000060": "Unsupported operation.",
    "errors.E0000061": "Tab error: {0}",
    "errors.E0000062": "The specified user is already assigned to the application.",
    "errors.E0000063": "Invalid combination of parameters specified.",
    "errors.E0000064": "Password is expired and must be changed.",
    "errors.E0000065": "Internal error processing app metadata.",
    "errors.E0000066": "APNS is not configured, contact your admin",
    "errors.E0000067": "Factors Service Error.",
    "errors.E0000070": "Waiting for ACK",
    "errors.E0000071": "Unsupported OS Version: {0}",
    "errors.E0000072": "MIM policy settings have disallowed enrollment for this user",
    "errors.E0000073": "User rejected authentication",
    "errors.E0000074": "Factor Service Error",
    "errors.E0000075": "Cannot modify the {0} attribute because it has a field mapping and profile push is enabled.",
    "errors.E0000076": "Cannot modify the app user because it is mastered by an external app.",
    "errors.E0000077": "Cannot modify the {0} attribute because it is read-only.",
    "errors.E0000078": "Cannot modify the {0} attribute because it is immutable.",
    "errors.E0000081": "Cannot modify the {0} attribute because it is a reserved attribute for this application.",
    "errors.E0000082": "Each code can only be used once. Please wait for a new code and try again.",
    "errors.E0000083": "PassCode is valid but exceeded time window.",
    "errors.E0000084": "App evaluation error.",
    "errors.E0000085": "You do not have permission to access your account at this time.",
    "errors.E0000086": "This policy cannot be activated at this time.",
    "errors.E0000087": "The recovery question answer did not match our records.",
    "errors.E0000090": "The role specified is already assigned to the user.",
    "errors.E0000091": "The provided role type was not the same as required role type.",
    "errors.E0000092": "Access to this application requires re-authentication: {0}",
    "errors.E0000093": "Target count limit exceeded",
    "errors.E0000094": "The provided filter is unsupported.",
    "errors.E0000095": "Recovery not allowed for unknown user.",
    "errors.E0000096": "This certificate has already been uploaded with kid={0}.",
    "errors.E0000097": "There is no verified phone number on file.",
    "errors.E0000098": "This phone number is invalid.",
    "errors.E0000099": "Only numbers located in US and Canada are allowed.  Contact your administrator if this is a problem.",
    "errors.E0000100": "Unable to perform search query.",
    "errors.E0000101": "Upload failed because of a problem with your ipa file, {0}",
    "errors.E0000102": "YubiKey cannot be deleted while assigned to an user. Please deactivate YubiKey using reset MFA and try again",
    "errors.E0000103": "Action on device already in queue or in progress",
    "errors.E0000104": "Device is already locked and cannot be locked again",
    "errors.E0000105": "You have accessed an account recovery link that has expired or been previously used.",
    "errors.E0000106": "Wait for token to change, then enter the new tokencode.",
    "errors.E0000107": "The entity is not in the expected state for the requested transition.",
    "errors.E0000109": "An SMS message was recently sent. Please wait 30 seconds before trying again.",
    "errors.E0000110": "You have accessed a link that has expired or has been previously used.",
    "errors.E0000111": "Cannot modify the {0} object because it is read-only.",
    "errors.E0000112": "Cannot update this user because they are still being activated. Please try again in a few minutes.",
    "errors.E0000113": "{0}.",
    "errors.E0000114": "A user with this login already exists in the current organization.",
    "errors.E0000115": "Upload failed, {0}",
    "errors.E0000116": "{0}",
    "errors.E0000119": "Your account is locked. Please contact your administrator.",
    "errors.E0000124": "Could not create user. To create a user and expire their password immediately, a password must be specified",
    "errors.E0000125": "Could not create user. To create a user and expire their password immediately, \"activate\" must be true",
    "errors.E0000133": "A phone call was recently made. Please wait 30 seconds before trying again.",
    "errors.E0000207": "The username and/or the password you entered is incorrect. Please try again.",
    "oform.next": "Next",
    "oform.verify": "Verify",
    "oform.send": "Send",
    "oform.back": "Back",
    "oform.title.authenticate": "Authenticate",
    "oform.save": "Save",
    "oform.cancel": "Cancel",
    "oform.edit": "Edit",
    "oform.previous": "Previous",
    "oform.error.icon.ariaLabel": "Error",
    "oform.errorbanner.title": "We found some errors. Please review the form and make corrections.",
    "oform.errormsg.title": "Please review the form to correct the following errors:",
    "oform.error.unexpected": "There was an unexpected internal error. Please try again.",
    "oform.error.webfinger": "Unable to determine user identification method. Please contact your administrator for assistance.",
    "oform.selectInput.country": "{0} selected",
    "model.validation.field.blank": "This field cannot be left blank",
    "model.validation.field.blank.label": "{0} cannot be left blank",
    "model.validation.field.wrong.type": "This field is of the wrong type",
    "model.validation.field.invalid": "This field has an invalid value",
    "model.validation.field.value.not.allowed": "This field value is not allowed",
    "model.validation.field.array.minItems": "This array does not have enough items",
    "model.validation.field.array.maxItems": "This array contains too many items",
    "model.validation.field.array.unique": "This array can only have unique values",
    "model.validation.field.string.minLength": "This field cannot be less than the minimum required characters",
    "model.validation.field.string.maxLength": "This field cannot exceed the maximum allowed characters",
    "model.validation.field.invalid.format.email": "This value is not a valid email address",
    "model.validation.field.invalid.format.uri": "This value is not a valid URI",
    "model.validation.field.invalid.format.ipv4": "This value is not a valid IPv4 address",
    "model.validation.field.invalid.format.hostname": "This value is not a valid hostname",
    "model.validation.field.username": "Please check your username",
    "schema.validation.field.value.must.string": "Value must be a string",
    "schema.validation.field.value.must.number": "Value must be a number",
    "schema.validation.field.value.must.integer": "Value must be an integer",
    "schema.validation.field.value.must.object": "Value must be an object",
    "universal-directory.profiles.attribute.source.oktamastered": "Inherit from Okta",
    "universal-directory.profiles.attribute.source.override": "Override profile source",
    "universal-directory.profiles.attribute.form.union.disable.display": "Combine values across groups",
    "universal-directory.profiles.attribute.source.inherit": "Inherit from profile source",
    "universal-directory.profiles.attribute.enduser.permission.readonly": "Read Only",
    "universal-directory.profiles.attribute.enduser.permission.hide": "Hide",
    "universal-directory.profiles.attribute.enduser.permission.readwrite": "Read-Write",
    "universal-directory.profiles.attribute.form.union.enable.display": "Use Group Priority",
    "factor.totpSoft.oktaVerify": "Okta Verify",
    "factor.totpSoft.googleAuthenticator": "Google Authenticator",
    "factor.totpSoft.description": "Enter single-use code from the mobile app.",
    "factor.totpHard.rsaSecurId": "RSA SecurID",
    "factor.totpHard.symantecVip": "Symantec VIP",
    "factor.totpHard.description": "Enter a single-use code from a hardware token.",
    "factor.totpHard.yubikey": "YubiKey",
    "factor.totpHard.yubikey.description": "Insert your YubiKey and tap it to get a verification code.",
    "factor.totpHard.yubikey.placeholder": "Click here, then tap your YubiKey",
    "factor.oktaVerifyPush": "Okta Verify",
    "factor.push.description": "Use a push notification sent to the mobile app.",
    "factor.duo": "Duo Security",
    "factor.duo.description": "Use Push Notification, SMS, or Voice call to authenticate.",
    "factor.sms": "SMS Authentication",
    "factor.sms.description": "Enter a single-use code sent to your mobile phone.",
    "factor.sms.time.warning": "Haven't received an SMS? To try again, click <$1>Re-send code</$1>.",
    "factor.call": "Voice Call Authentication",
    "factor.call.description": "Use a phone to authenticate by following voice instructions.",
    "factor.call.time.warning": "Haven't received a voice call? To try again, click <$1>Redial</$1>.",
    "factor.securityQuestion": "Security Question",
    "factor.securityQuestion.description": "Use the answer to a security question to authenticate.",
    "factor.windowsHello": "Windows Hello",
    "factor.windowsHello.signin.description": "Sign in to Okta using Windows Hello.",
    "factor.windowsHello.signin.description.generic": "Sign in using Windows Hello.",
    "factor.windowsHello.signin.description.specific": "Sign in to {0} using Windows Hello.",
    "factor.u2f": "Security Key (U2F)",
    "factor.u2f.description": "Use a Universal 2nd Factor (U2F) security key to sign on to Okta.",
    "factor.u2f.description.generic": "Use a Universal 2nd Factor (U2F) security key to sign in.",
    "factor.u2f.description.specific": "Use a Universal 2nd Factor (U2F) security key to sign in to {0}.",
    "factor.email": "Email Authentication",
    "factor.email.description": "Enter a verification code sent to your email.",
    "factor.password": "Password",
    "factor.customFactor.description": "Redirect to a third party MFA provider to sign in to Okta.",
    "factor.customFactor.description.generic": "Redirect to a third party MFA provider to sign in.",
    "factor.customFactor.description.specific": "Redirect to a third party MFA provider to sign in to {0}.",
    "factor.webauthn.biometric": "Security Key or Biometric Authenticator",
    "factor.webauthn.biometric.description": "Use a security key (USB or bluetooth) or a biometric authenticator (Windows Hello, Touch ID, etc.)",
    "factor.hotp.description": "Enter a single-use code from an authenticator.",
    "mfa.challenge.verify": "Verify",
    "mfa.challenge.answer.placeholder": "Answer",
    "mfa.challenge.answer.tooltip": "Answer",
    "mfa.challenge.answer.showAnswer": "Show",
    "mfa.challenge.answer.hideAnswer": "Hide",
    "mfa.challenge.enterCode.placeholder": "Enter Code",
    "mfa.challenge.enterCode.tooltip": "Enter Code",
    "mfa.challenge.password.placeholder": "Password",
    "mfa.backToFactors": "Back to factor list",
    "mfa.enroll": "Enroll",
    "mfa.setupOptions": "Setup Options",
    "mfa.country": "Country/region",
    "mfa.phoneNumber.placeholder": "Phone number",
    "mfa.phoneNumber.ext.placeholder": "Extension",
    "mfa.sendCode": "Send code",
    "mfa.sent": "Sent",
    "mfa.resendCode": "Re-send code",
    "mfa.call": "Call",
    "mfa.calling": "Calling",
    "mfa.redial": "Redial",
    "mfa.sendEmail": "Send email",
    "mfa.resendEmail": "Re-send email",
    "mfa.scanBarcode": "Scan QR code",
    "mfa.altQrCode": "QR code. If you can't scan, click on the link below to select an alternative activation method",
    "mfa.noAccessToEmail": "Can't access email",
    "password.reset": "Reset Password",
    "password.oldPassword.placeholder": "Old password",
    "password.oldPassword.tooltip": "Old password",
    "password.newPassword.placeholder": "New password",
    "password.newPassword.tooltip": "New password",
    "password.confirmPassword.placeholder": "Repeat password",
    "password.confirmPassword.tooltip": "Repeat password",
    "password.error.match": "New passwords must match",
    "password.enroll.error.match": "Passwords must match",
    "recovery.sms.hint": "SMS can only be used if a mobile phone number has been configured.",
    "recovery.mobile.hint": "{0} can only be used if a mobile phone number has been configured.",
    "recovery.sms": "SMS",
    "recovery.call": "Voice Call",
    "recovery.smsOrCall": "SMS or Voice Call",
    "verify.choices.description": "Verify with one of the following factors.",
    "email.button.send": "Send me the code",
    "email.button.resend": "Send again",
    "email.code.label": "Verification code",
    "email.code.not.received": "Haven't received an email?",
    "email.enroll.title": "Set up Email Authentication",
    "email.enroll.description": "Send a verification code to your registered email.",
    "email.enroll.enterCode": "Enter code",
    "email.link.terminal.msg": "To finish signing in, return to the screen where you requested the email link.",
    "email.mfa.title": "Verify with Email Authentication",
    "email.mfa.description": "Send a verification code to {0}.",
    "email.mfa.email.sent.description": "A verification code was sent to {0}. Check your email and enter the code below.",
    "email.mfa.email.sent.description.sentText": "A verification code was sent to",
    "email.mfa.email.sent.description.emailCodeText": "Check your email and enter the code below.",
    "email.unregistered_email.error": "Enter the email where you received the Welcome instructions from your administrator.",
    "enroll.choices.title": "Set up multifactor authentication",
    "enroll.choices.description": "Your company requires multifactor authentication to add an additional layer of security when signing in to your Okta account",
    "enroll.choices.description.generic": "Your company requires multifactor authentication to add an additional layer of security when signing in to your account",
    "enroll.choices.description.specific": "Your company requires multifactor authentication to add an additional layer of security when signing in to your {0} account",
    "enroll.choices.description.gracePeriod.bold": "Your company recommends setting up additional factors for authentication. Set up will be required in: <b>{0} day(s)</b>.",
    "enroll.choices.description.gracePeriod.oneDay.bold": "Your company recommends setting up additional factors for authentication. Set up will be required in: <b>less than 1 day</b>.",
    "enroll.choices.optional": "You can configure any additional optional factor or click finish",
    "enroll.choices.list.setup": "Setup required",
    "enroll.choices.list.enrolled": "Enrolled factors",
    "enroll.choices.list.optional": "Additional optional factors",
    "enroll.choices.setup": "Setup",
    "enroll.choices.setup.another": "Set up another",
    "enroll.choices.submit.finish": "Finish",
    "enroll.choices.submit.configure": "Configure factor",
    "enroll.choices.submit.next": "Configure next factor",
    "enroll.choices.cardinality.setup": "({0} set up)",
    "enroll.choices.cardinality.setup.remaining": "({0} of {1} set up)",
    "enroll.choices.setup.skip": "Skip set up",
    "enroll.securityQuestion.setup": "Setup secret question authentication",
    "security.disliked_food": "What is the food you least liked as a child?",
    "security.name_of_first_plush_toy": "What is the name of your first stuffed animal?",
    "security.first_award": "What did you earn your first medal or award for?",
    "security.favorite_security_question": "What is your favorite security question?",
    "security.favorite_toy": "What is the toy/stuffed animal you liked the most as a kid?",
    "security.first_computer_game": "What was the first computer game you played?",
    "security.favorite_movie_quote": "What is your favorite movie quote?",
    "security.first_sports_team_mascot": "What was the mascot of the first sports team you played on?",
    "security.first_music_purchase": "What music album or song did you first purchase?",
    "security.favorite_art_piece": "What is your favorite piece of art?",
    "security.grandmother_favorite_desert": "What was your grandmother's favorite dessert?",
    "security.first_thing_cooked": "What was the first thing you learned to cook?",
    "security.childhood_dream_job": "What was your dream job as a child?",
    "security.first_kiss_location": "Where did you have your first kiss?",
    "security.place_where_significant_other_was_met": "Where did you meet your spouse/significant other?",
    "security.favorite_vacation_location": "Where did you go for your favorite vacation?",
    "security.new_years_two_thousand": "Where were you on New Year's Eve in the year 2000?",
    "security.favorite_speaker_actor": "Who is your favorite speaker/orator?",
    "security.favorite_book_movie_character": "Who is your favorite book/movie character?",
    "security.favorite_sports_player": "Who is your favorite sports player?",
    "enroll.password.setup": "Select a password",
    "save.password": "Save password",
    "enroll.sms.setup": "Receive a code via SMS to authenticate",
    "enroll.sms.try_again": "The number you entered seems invalid. If the number is correct, please try again.",
    "enroll.call.setup": "Follow phone call instructions to authenticate",
    "enroll.onprem.username.placeholder": "Enter {0} username",
    "enroll.onprem.username.tooltip": "Enter {0} username",
    "enroll.onprem.passcode.placeholder": "Enter {0} passcode",
    "enroll.onprem.passcode.tooltip": "Enter {0} passcode",
    "enroll.symantecVip.subtitle": "Enter Credential ID and two consecutive generated codes",
    "enroll.symantecVip.credentialId.placeholder": "Enter credential ID",
    "enroll.symantecVip.credentialId.tooltip": "Enter credential ID",
    "enroll.symantecVip.passcode1.placeholder": "Security code 1",
    "enroll.symantecVip.passcode1.tooltip": "Security code 1",
    "enroll.symantecVip.passcode2.placeholder": "Security code 2",
    "enroll.symantecVip.passcode2.tooltip": "Security code 2",
    "enroll.yubikey.title": "Setup YubiKey",
    "enroll.yubikey.subtitle": "Insert your YubiKey into a USB port and tap it to generate a verification code",
    "enroll.totp.title": "Setup {0}",
    "enroll.totp.selectDevice": "Select your device type",
    "enroll.totp.downloadApp": "Download <a href=\"{0}\" class=\"inline-link\">{1} from the {2}</a> onto your mobile device.",
    "enroll.hotp.restricted": "Contact your administrator to continue enrollment.",
    "enroll.duo.title": "Setup Duo Security",
    "enroll.windowsHello.title": "Enroll Windows Hello",
    "enroll.windowsHello.subtitle": "Click below to enroll Windows Hello as a second form of authentication",
    "enroll.windowsHello.subtitle.loading": "Please wait while Windows Hello is loading...",
    "enroll.windowsHello.save": "Enroll Windows Hello",
    "enroll.windowsHello.error.notWindows": "Windows Hello can only be used on Windows Edge with Windows 10. Contact your admin for assistance.",
    "enroll.windowsHello.error.notConfiguredHtml": "Windows Hello is not configured. Select the <b>Start</b> button, then select <b>Settings</b> - <b>Accounts</b> - <b>Sign-in</b> to configure Windows Hello.",
    "verify.windowsHello.subtitle": "Verify your identity with Windows Hello",
    "verify.windowsHello.subtitle.loading": "Please wait while Windows Hello is loading...",
    "verify.windowsHello.subtitle.signingIn": "Signing in to Okta...",
    "verify.windowsHello.subtitle.signingIn.generic": "Signing in...",
    "verify.windowsHello.subtitle.signingIn.specific": "Signing in to {0}...",
    "verify.windowsHello.save": "Verify with Windows Hello",
    "verify.windowsHello.error.notFound": "Your Windows Hello enrollment does not match our records. Contact your administrator for assistance.",
    "verify.windowsHello.error.notFound.selectAnother": "Your Windows Hello enrollment does not match our records. Select another factor or contact your administrator for assistance.",
    "enroll.u2f.title": "Setup Security Key (U2F)",
    "enroll.u2f.save": "Register Security Key",
    "enroll.u2f.general2": "Make sure you have a Security Key. If already inserted, remove it now.<br>If you have a Bluetooth Security Key, turn on your computer's Bluetooth.",
    "enroll.u2f.general3": "Click the button below to register",
    "enroll.u2f.instructions": "Insert your Security Key into a USB port on this computer. If it has a button or gold disk, tap it.",
    "enroll.u2f.instructionsBluetooth": "If you are using a Bluetooth Security Key, press the button.",
    "u2f.error.factorNotSupported": "Security Key (U2F) is not supported on this browser. Select another factor or contact your admin for assistance.",
    "u2f.error.factorNotSupported.oneFactor": "Security Key (U2F) is not supported on this browser. Contact your admin for assistance.",
    "u2f.error.other": "An unknown error has occured. Try again or select another factor.",
    "u2f.error.other.oneFactor": "An unknown error has occured. Try again or contact your admin for assistance.",
    "u2f.error.badRequest": "There was an error with the U2F request. Try again or select another factor.",
    "u2f.error.badRequest.oneFactor": "There was an error with the U2F request. Try again or contact your admin for assistance.",
    "u2f.error.unsupported": "The security key is unsupported. Select another factor.",
    "u2f.error.unsupported.oneFactor": "The security key is unsupported. Contact your admin for assistance.",
    "u2f.error.timeout": "You have timed out of the authentication period. Please try again.",
    "verify.u2f.instructions": "Insert your Security Key. If it has a button or gold disk, tap\xa0it.",
    "verify.u2f.instructionsBluetooth": "If you are using a Bluetooth Security Key, turn on your computer's Bluetooth and press the button.",
    "verify.u2f.retry": "Retry",
    "enroll.customFactor.subtitle": "Clicking below will redirect to MFA enrollment with {0}",
    "enroll.customFactor.save": "Enroll",
    "verify.customFactor.subtitle": "Clicking below will redirect to verification with {0}",
    "verify.customFactor.subtitle.redirect": "Redirecting to {0}...",
    "enroll.webauthn.biometric.title": "Set up security key or biometric authenticator",
    "enroll.webauthn.save": "Enroll",
    "enroll.webauthn.biometric.instructions": "Your browser will prompt to register a security key or biometric authenticator (Windows Hello, Touch ID, etc.). Follow the instructions to complete enrollment.",
    "enroll.webauthn.biometric.instructions.edge": "Note: If you are enrolling a security key and Windows Hello or PIN is enabled, you will need to select '<b>Cancel</b>' in the prompt before continuing.",
    "verify.webauthn.biometric.instructions": "Your browser or device will prompt you to verify with a security key or biometric authenticator. Follow the instructions to complete authentication.",
    "webauthn.biometric.error.factorNotSupported": "Security key or biometric authenticator is not supported on this browser. Select another factor or contact your admin for assistance.",
    "webauthn.biometric.error.factorNotSupported.oneFactor": "Security key or biometric authenticator is not supported on this browser. Contact your admin for assistance.",
    "enroll.webauthn.instructions.noSupportForBiometric": "Note: Some browsers may not support biometric authenticators.",
    "authfactor.webauthn.error": "You are currently unable to use a Security key or biometric authenticator. Try again.",
    "passkeys.authfactor.webauthn.error": "You are currently unable to use a passkey. Try again.",
    "enroll.totp.enterCode": "Enter code displayed from the application",
    "enroll.totp.setupApp": "Launch {0} on your mobile device and select \u201CAdd an account\u201D. Scan the QR code to continue.",
    "enroll.totp.setupGoogleAuthApp": "Launch {0}, tap the \"+\" icon, then select \"Scan a QR code\".",
    "enroll.totp.cannotScan": "Can't scan?",
    "enroll.totp.aria.cannotScan": "Setup without scanning a QR code.",
    "enroll.totp.refreshBarcode": "Refresh code",
    "enroll.totp.cannotScanBarcode": "Can't scan QR code?",
    "enroll.totp.manualSetupInstructions": "To set up manually enter your Okta Account username and then input the following in the Secret Key Field",
    "enroll.totp.manualSetupInstructions.generic": "To set up manually enter your Account username and then input the following in the Secret Key Field",
    "enroll.totp.manualSetupInstructions.specific": "To set up manually enter your {0} Account username and then input the following in the Secret Key Field",
    "enroll.totp.sharedSecretInstructions": "Enter your Okta Account username and enter the following in the Secret Key Field",
    "enroll.totp.sharedSecretInstructions.generic": "Enter your Account username and enter the following in the Secret Key Field",
    "enroll.totp.sharedSecretInstructions.specific": "Enter your {0} Account username and enter the following in the Secret Key Field",
    "enroll.totp.sendSms": "Send activation link via SMS",
    "enroll.totp.sendEmail": "Send activation link via email",
    "enroll.totp.setupManually": "Setup manually without push notification",
    "enroll.totp.sharedSecretInstructions.aria.secretKey": "setup key {0}",
    "enroll.totp.enrollViaEmail.title": "Activation email sent!",
    "enroll.totp.enrollViaEmail.msg": "Open the email from your mobile device.",
    "enroll.totp.enrollViaSms.title": "SMS sent!",
    "enroll.totp.enrollViaSms.msg": "View the SMS on your mobile device.",
    "recoveryChallenge.sms.title": "Enter verification code sent via SMS",
    "recoveryChallenge.call.title": "Enter verification code received via Voice Call",
    "mfa.factors.dropdown.title": "Select an authentication factor",
    "mfa.factors.dropdown.sr.text": "Select Authentication Factor - {0} Factor Selected",
    "mfa.duoSecurity.push": "Push \u2014 {0}",
    "mfa.duoSecurity.sms": "SMS \u2014 {0}",
    "mfa.duoSecurity.call": "Call \u2014 {0}",
    "mfa.switch": "Switch Factor",
    "mfa.challenge.title": "Enter your {0} passcode",
    "mfa.challenge.orEnterCode": "Or enter code",
    "mfa.challenge.totp.subtitle.multiple": "Enter code from any registered {0} device.",
    "mfa.emailVerification.checkEmail": "To finish signing in, click the link in your email.",
    "mfa.emailVerification.title": "Sign in using a link sent to your email.",
    "mfa.emailVerification.subtitle": "Emails will be sent to {0}",
    "mfa.emailVerification.otc.finish": "To finish signing in, enter the code which was emailed to you.",
    "oktaverify.send": "Send Push",
    "oktaverify.resend": "Re-send Push",
    "oktaverify.sent": "Push sent!",
    "oktaverify.rejected": "You have chosen to reject this login.",
    "oktaverify.rejected.upgradeRequired.ios": "Verification failed because your Okta Verify version is no longer supported. To sign in, please update Okta Verify on the App Store, then try again.",
    "oktaverify.rejected.upgradeRequired.android": "Verification failed because your Okta Verify version is no longer supported. To sign in, please update Okta Verify on Google Play, then try again.",
    "oktaverify.timeout": "Your push notification has expired.",
    "oktaverify.warning": "Haven't received a push notification yet? Try opening the Okta Verify App on your phone.",
    "oktaverify.numberchallenge.instruction": "On your phone, tap <span class=\"challenge-number\">{0}</span> on Okta Verify prompt to continue.",
    "oktaverify.numberchallenge.explain": "This extra step helps us make sure it's really you signing in.",
    "primaryauth.title": "Sign In",
    "primaryauth.username.placeholder": "Username",
    "primaryauth.username.tooltip": "Username",
    "primaryauth.password.placeholder": "Password",
    "primaryauth.password.tooltip": "Password",
    "primaryauth.submit": "Sign In",
    "primaryauth.newUser.tooltip": "This is the first time you are connecting to {0} from this browser",
    "primaryauth.newUser.tooltip.close": "Close",
    "oktaVerify.description": "To access this resource, your organization requires you to sign in with Okta FastPass.",
    "oktaVerify.appDescription": "To access {0}, your organization requires you to sign in with Okta FastPass.",
    "oktaVerify.button": "Sign in with Okta FastPass",
    "signinWithWebAuthn.button": "Sign in with security key or biometrics",
    "idpDiscovery.email.placeholder": "Email",
    "password.forgot.email.or.username.placeholder": "Email or Username",
    "password.forgot.email.or.username.tooltip": "Email or Username",
    "password.forgot.sendText": "Reset via SMS",
    "password.forgot.sendEmail": "Reset via Email",
    "password.forgot.call": "Reset via Voice Call",
    "password.forgot.emailSent.title": "Email sent!",
    "password.forgot.emailSent.desc": "Email has been sent to {0} with instructions on resetting your password.",
    "password.forgot.question.title": "Answer Forgotten Password Challenge",
    "password.forgot.question.submit": "Reset Password",
    "password.forgot.code.notReceived": "Didn't receive a code? Reset via email",
    "password.forgot.noFactorsEnabled": "No password reset options available. Please contact your administrator.",
    "password.reset.title": "Reset your Okta password",
    "password.reset.title.generic": "Reset your password",
    "password.reset.title.specific": "Reset your {0} password",
    "password.complexity.requirements": "Password requirements: {0}.",
    "password.complexity.history": "Your password cannot be any of your last {0} password(s).",
    "password.complexity.minAgeMinutes": "At least {0} minute(s) must have elapsed since you last changed your password.",
    "password.complexity.minAgeHours": "At least {0} hour(s) must have elapsed since you last changed your password.",
    "password.complexity.minAgeDays": "At least {0} day(s) must have elapsed since you last changed your password.",
    "password.reset.verification": "Verify with one of the following factors to reset your password.",
    "password.reset.revokeSessions": "Sign me out of all other devices.",
    "password.complexity.length": "at least {0} characters",
    "password.complexity.list.element": ", {0}",
    "password.complexity.lowercase": "a lowercase letter",
    "password.complexity.uppercase": "an uppercase letter",
    "password.complexity.number": "a number",
    "password.complexity.symbol": "a symbol",
    "password.complexity.no_username": "no parts of your username",
    "password.complexity.no_first_name": "does not include your first name",
    "password.complexity.no_last_name": "does not include your last name",
    "password.complexity.adRequirements": "at least 3 of the following: lowercase letter, uppercase letter, number, symbol",
    "password.complexity.maxConsecutiveRepeatingCharacters": "maximum {0} consecutive repeating characters",
    "password.complexity.requirements.header": "Password requirements:",
    "password.complexity.length.description": "At least {0} characters",
    "password.complexity.lowercase.description": "A lowercase letter",
    "password.complexity.uppercase.description": "An uppercase letter",
    "password.complexity.number.description": "A number",
    "password.complexity.symbol.description": "A symbol",
    "password.complexity.no_username.description": "No parts of your username",
    "password.complexity.no_first_name.description": "Does not include your first name",
    "password.complexity.no_last_name.description": "Does not include your last name",
    "password.complexity.history.one.description": "Password can't be the same as your last password",
    "password.complexity.adRequirements.description": "At least 3 of the following: lowercase letter, uppercase letter, number, symbol",
    "password.complexity.maxConsecutiveRepeatingCharacters.description": "Maximum {0} consecutive repeating characters",
    "password.complexity.history.description": "Password can't be the same as your last {0} passwords",
    "password.complexity.minAgeMinutes.description": "At least {0} minute(s) must have elapsed since you last changed your password",
    "password.complexity.minAgeHours.description": "At least {0} hour(s) must have elapsed since you last changed your password",
    "password.complexity.minAgeDays.description": "At least {0} day(s) must have elapsed since you last changed your password",
    "password.complexity.status.allMet": "All password requirements met",
    "password.complexity.status.notMetPrefix": "{0} password requirement(s) not met: {1}",
    "password.complexity.status.met": "Requirement met",
    "password.complexity.status.notMet": "Requirement not met",
    "password.complexity.status.info": "Information",
    "password.expired.submit": "Change Password",
    "password.expired.title": "Your Okta password has expired",
    "password.expired.title.generic": "Your password has expired",
    "password.expired.title.specific": "Your {0} password has expired",
    "password.expiring.later": "Remind me later",
    "password.expiring.title": "Your password will expire in {0} days",
    "password.expiring.today": "Your password will expire later today",
    "password.expiring.soon": "Your password is expiring soon",
    "password.expiring.subtitle": "When password expires you may be locked out of Okta Mobile, mobile email, and other services.",
    "password.expiring.subtitle.generic": "When password expires you will be locked out of your account.",
    "password.expiring.subtitle.specific": "When password expires you will be locked out of your {0} account.",
    "password.expired.custom.submit": "Go to {0}",
    "password.expired.custom.subtitle": "This password is set on another website. Click the button below to go there and set a new password.",
    "password.expiring.soon.subtitle.generic": "When password expires you will be locked out of your account. This password is set on another website. Click the button below to go there and set a new password.",
    "password.expiring.soon.subtitle.specific": "When password expires you will be locked out of your {0} account. This password is set on another website. Click the button below to go there and set a new password.",
    "hcaptcha.footer.label": "This site is protected by hCaptcha and its <$1>Privacy Policy</$1> and <$2>Terms of Service</$2> apply.",
    "altcha.error.label": "Verification failed. Try again later.",
    "altcha.expired.label": "Verification expired. Try again.",
    "altcha.label.label": "I'm not a robot",
    "altcha.loading.label": "Loading...",
    "altcha.reload.label": "Reload",
    "altcha.verify.label": "Verify",
    "altcha.verificationRequired.label": "Verification required!",
    "altcha.verified.label": "Verified",
    "altcha.verifying.label": "Verifying...",
    "altcha.waitAlert.label": "Verifying... please wait.",
    "account.unlock.title": "Unlock account",
    "account.unlock.email.or.username.placeholder": "Email or username",
    "account.unlock.email.or.username.tooltip": "Email or username",
    "account.unlock.sendText": "Send SMS",
    "account.unlock.voiceCall": "Voice Call",
    "account.unlock.sendEmail": "Send Email",
    "account.unlock.emailSent.title": "Email sent!",
    "account.unlock.emailSent.desc": "Email has been sent to {0} with instructions on unlocking your account.",
    "account.unlock.question.title": "Answer Unlock Account Challenge",
    "account.unlock.question.submit": "Unlock Account",
    "account.unlock.unlocked.title": "Account successfully unlocked!",
    "account.unlock.unlocked.desc": "You can log in using your existing username and password.",
    "account.unlock.code.notReceived": "Didn't receive a code? Unlock via email",
    "account.unlock.noFactorsEnabled": "No unlock options available. Please contact your administrator.",
    "account.unlock.authenticatorRequired.single": "To unlock your account, select the following authenticator.",
    "account.unlock.authenticatorRequired.multiple": "To unlock your account, select one of the following authenticators.",
    "contact.support": "If you didn't provide a secondary email address or don't have access to email, please contact your administrator at {0}",
    "customauth.sign.in.with.label": "Sign in with {0}",
    "socialauth.divider.text": "OR",
    "socialauth.facebook.label": "Sign in with Facebook",
    "socialauth.google.label": "Sign in with Google",
    "socialauth.linkedin.label": "Sign in with LinkedIn",
    "socialauth.microsoft.label": "Sign in with Microsoft",
    "socialauth.apple.label": "Sign in with Apple",
    "socialauth.github.label": "Sign in with GitHub",
    "socialauth.gitlab.label": "Sign in with GitLab",
    "socialauth.yahoo.label": "Sign in with Yahoo",
    "socialauth.line.label": "Sign in with LINE",
    "socialauth.paypal.label": "Sign in with PayPal",
    "socialauth.paypal_sandbox.label": "Sign in with PayPal Sandbox",
    "socialauth.salesforce.label": "Sign in with Salesforce",
    "socialauth.amazon.label": "Sign in with Amazon",
    "socialauth.yahoojp.label": "Sign in with Yahoo Japan",
    "socialauth.discord.label": "Sign in with Discord",
    "socialauth.adobe.label": "Sign in with Adobe",
    "socialauth.orcid.label": "Sign in with ORCiD",
    "socialauth.spotify.label": "Sign in with Spotify",
    "socialauth.xero.label": "Sign in with Xero",
    "socialauth.quickbooks.label": "Sign in with Quickbooks",
    "socialauth.popup.title": "External Identity Provider User Authentication",
    "idps.search.label": "Search for sign in",
    "idps.search.no.results": "No results found",
    "idps.search.typeahead.placeholder": "Type to search",
    "idps.search.results.count": "{0} results found",
    "authbutton.divider.text": "or",
    "registration.signup.label": "Don't have an account?",
    "registration.signup.text": "Sign up",
    "registration.complete.title": "Verification email sent",
    "registration.complete.confirm.text": "To finish signing in, check your email.",
    "registration.form.title": "Create Account",
    "registration.form.submit": "Register",
    "registration.passwordComplexity.minLength": "At least {0} character(s)",
    "registration.passwordComplexity.minLower": "At least {0} lowercase letter(s)",
    "registration.passwordComplexity.minUpper": "At least {0} uppercase letter(s)",
    "registration.passwordComplexity.minNumber": "At least {0} number(s)",
    "registration.passwordComplexity.minSymbol": "At least {0} symbol(s)",
    "registration.passwordComplexity.excludeUsername": "Does not contain part of username",
    "registration.passwordComplexity.excludeAttribute": "Does not contain '{0}'",
    "registration.required.fields.label": "* indicates required field",
    "registration.default.callbackhook.error": "We could not process your registration at this time. Please try again later.",
    "registration.error.userName.invalidEmail": "Invalid email address",
    "registration.error.password.passwordRequirementsNotMet": "Password requirements were not met",
    "registration.error.password.passwordRequirementsNotMet.prefix": "Password requirements were not met:",
    "registration.error.userName.notUniqueWithinOrg": "An account with that {0} already exists",
    "registration.error.notUniqueWithinOrg.Email": "A user with this Email already exists",
    "registration.error.notUniqueWithinOrg.custom": "A user with this {0} already exists",
    "registration.error.invalidLoginEmail.Email": "'Email' must be in the form of an email address",
    "registration.error.invalidLoginEmail.custom": "'{0}' must be in the form of an email address",
    "registration.error.doesNotMatchPattern.Email": "Provided value for property 'Email' does not match required pattern",
    "registration.error.doesNotMatchPattern.custom": "Provided value for property '{0}' does not match required pattern",
    "registration.error.generic": "There was an error creating your account. Please try registering again.",
    "registration.error.request.not.completed": "Your request could not be completed. Try again later.",
    "registration.model.validation.field.string.too.short": "Please enter something at least {0} characters long",
    "registration.model.validation.field.string.too.long": "Please enter something shorter than {0} characters",
    "piv.card": "PIV Card",
    "piv.card.insert": "Please insert your PIV card and select the user certificate.",
    "piv.card.error": "Certificate authentication failed. Contact your admin.",
    "piv.card.error.empty": "No certificate selected. Choose a certificate and try again.",
    "piv.card.error.invalid": "Certificate validation failed. Choose another certificate and try again.",
    "piv.cac.card": "Sign in with PIV / CAC card",
    "piv.cac.title": "PIV / CAC card",
    "piv.cac.card.insert": "Please insert your PIV / CAC card and select the user certificate.",
    "piv.cac.error": "There was an error signing in. Click the button below to try again.",
    "unsupported.oneDrive.title": "Your OneDrive version is not supported",
    "unsupported.oneDrive.desc": "Upgrade now by installing the OneDrive for Business Next Generation Sync Client to login to Okta",
    "unsupported.oneDrive.action": "Learn how to upgrade",
    "unsupported.cookies.title": "Cookies are required",
    "unsupported.cookies.desc": "Cookies are disabled on your browser. Please enable Cookies and refresh this page.",
    "unsupported.cookies.action": "Refresh",
    "deviceTrust.sso.text": "Sign in to access company resources",
    "deviceTrust.sso.subtitle.2": "Your company uses Okta Mobile to get you approved to access this app.",
    "deviceTrust.sso.button": "Sign in with Okta Mobile",
    "deviceTrust.sso.expire.title": "Oops let's get you back on track",
    "deviceTrust.sso.redirectText": "Verifying your identity",
    "deviceTrust.sso.expire.subtitle": "Unfortunately the steps required to sign in took longer than expected and your attempt timed out.",
    "deviceTrust.sso.expire.button": "Sign in using Okta Mobile",
    "deviceTrust.universalLink.fallback.getOktaMobile.title": "Get Okta Mobile",
    "deviceTrust.universalLink.fallback.getOktaMobile.subtitle": "Go to the {0}AppStore{1}, {0}search{1} for {0}Okta Mobile{1} and tap on {0}GET{1} Okta Mobile. Once installed, sign in to Okta Mobile and follow the instructions to secure your device.",
    "core.auth.factor.signedNonce.error.invalidDevice": "Your device or account was invalidated. If this is unexpected, contact your administrator for help.",
    "core.auth.factor.signedNonce.error": "Your device or account was invalidated. Re-enroll your account on Okta Verify and try again.",
    "user.fail.verifyIdentity": "Couldn\u2019t verify your identity",
    "loopback.polling.cancel.link": "Cancel and take me to sign in",
    "loopback.polling.cancel.link.with.form.error": "Take me to sign in",
    "customUri.subtitle": "Launching Okta Verify...",
    "customUri.content": "<div class=\"skinny-content\"> If nothing prompts from the browser, <a href=\"#\" id=\"launch-ov\" class=\"link\">click here</a> to launch Okta Verify, or make sure Okta Verify is installed.</div>",
    "customUri.title": "Click \"Open Okta Verify\" on the browser prompt",
    "customUri.required.content.prompt": "Didn\u2019t get a prompt?",
    "customUri.required.content.download.title": "Don\u2019t have Okta Verify?",
    "customUri.required.content.download.linkText": "Download here",
    "customUri.required.content.button": "Launch Okta Verify",
    "universalLink.title": "Sign in with Okta FastPass",
    "universalLink.content": "If Okta Verify did not open automatically, tap Open Okta Verify.",
    "appLink.title": "Sign in with Okta FastPass",
    "appLink.content": "If Okta Verify did not open automatically, tap Open Okta Verify.",
    "oktaVerify.open.button": "Open Okta Verify",
    "oktaVerify.reopen.button": "Reopen Okta Verify",
    "consent.required.text": "<b>{0}</b> would like to access:",
    "consent.required.description": "By clicking Allow Access, you allow the actions listed above.",
    "consent.required.termsOfService": "Terms of Service",
    "consent.required.privacyPolicy": "Privacy Policy",
    "consent.required.consentButton": "Allow Access",
    "consent.required.cancelButton": "Don't Allow",
    "granular.consent.scopes.title": "<$1>{0}</$1> <$2>wants to access your account</$2>",
    "granular.consent.scopes.description": "Allowing access will share",
    "admin.consent.group.user.group": "User and groups",
    "admin.consent.group.resource.policy": "Resource and policies",
    "admin.consent.group.hook": "Hooks",
    "admin.consent.group.system": "System",
    "polling.title": "There are too many users trying to sign in right now. We will automatically retry in {0} seconds.",
    "poll.form.title": "Unable to complete your request",
    "poll.form.message": "We will automatically retry in <$1>{0}</$1> seconds.",
    "cert.authentication.title": "Certificate authentication",
    "common.logo.alt": "aria logo",
    "oie.authenticator.enroll.error.fail": "Unable to enroll authenticator. Try again.",
    "oie.authenticator.verify.error.fail": "Unable to verify authenticator. Try again.",
    "oie.configuration.error": "Something went wrong. Potential misconfiguration detected. Please contact support.",
    "oie.auth.logo.aria.label": "Authenticator logo",
    "oie.challenge.answer.showAnswer": "Show answer",
    "oie.challenge.answer.hideAnswer": "Hide answer",
    "oie.form.field.optional": "Optional",
    "oie.form.field.optional.description": "Fields are required unless marked optional.",
    "oie.password.label": "Password",
    "oie.password.newPasswordLabel": "New password",
    "oie.password.authenticator.description": "Choose a password for your account",
    "oie.password.challenge.title": "Verify with your password",
    "oie.password.enroll.title": "Set up password",
    "oie.password.passwordLabel": "Enter password",
    "oie.password.confirmPasswordLabel": "Re-enter password",
    "oie.password.showPassword": "Show password",
    "oie.password.showNewPassword": "Show new password",
    "oie.password.showConfirmPassword": "Show re-entered password",
    "oie.password.hidePassword": "Hide password",
    "oie.password.hideConfirmPassword": "Hide re-entered password",
    "oie.password.reset.verification": "Verify with one of the following security methods to reset your password.",
    "idx.password.expiring.message": "When your password expires, you will have to change your password before you can login to your {0} account.",
    "oie.password.incorrect.message": "Password is incorrect",
    "oie.selfservice.reset.password.not.allowed": "Reset password is not allowed at this time. Please contact support for assistance.",
    "password.common": "This password was found in a list of commonly used passwords. Please try another password.",
    "idx.recovery.completed": "You can now sign in with your existing username and new password.",
    "oie.phone.label": "Phone",
    "oie.phone.authenticator.description": "Verify with a code sent to your phone",
    "oie.phone.enroll.sms.label": "SMS",
    "oie.phone.enroll.voice.label": "Voice call",
    "oie.phone.enroll.title": "Set up phone authentication",
    "oie.phone.enroll.call.subtitle": "Enter your phone number to receive a verification code via voice call.",
    "oie.phone.enroll.sms.subtitle": "Enter your phone number to receive a verification code via SMS.",
    "oie.phone.sms.primaryButton": "Receive a code via SMS",
    "oie.phone.sms.secondaryButton": "Receive an SMS instead",
    "oie.phone.call.primaryButton": "Receive a code via voice call",
    "oie.phone.call.secondaryButton": "Receive a voice call instead",
    "oie.phone.verify.sms.resendText": "Haven't received an SMS?",
    "oie.phone.verify.sms.codeSentText": "A code was sent to",
    "oie.phone.verify.sms.sendText": "Send a code via SMS to",
    "oie.phone.verify.call.sendText": "Send a code via voice call to",
    "oie.phone.verify.call.resendText": "Haven't received a call?",
    "oie.phone.verify.call.resendLinkText": "Call again",
    "oie.phone.verify.sms.resendLinkText": "Send again",
    "oie.phone.verify.enterCodeText": "Enter the code below to verify.",
    "oie.phone.verify.title": "Verify with your phone",
    "oie.phone.alternate.title": "your phone",
    "oie.phone.carrier.charges": "Carrier messaging charges may apply",
    "oie.phone.invalid": "Invalid Phone Number.",
    "oie.phone.verify.sms.sendText.with.phone.with.nickname": "Send a code via SMS to <$1>{0}</$1> <$2>({1})</$2>.",
    "oie.phone.verify.call.sendText.with.phone.with.nickname": "Send a code via voice call to <$1>{0}</$1> <$2>({1})</$2>.",
    "oie.phone.verify.sms.sendText.with.phone.without.nickname": "Send a code via SMS to <$1>{0}</$1>.",
    "oie.phone.verify.call.sendText.with.phone.without.nickname": "Send a code via voice call to <$1>{0}</$1>.",
    "oie.phone.verify.sms.sendText.without.phone": "Send a code via SMS to your phone.",
    "oie.phone.verify.call.sendText.without.phone": "Send a code via voice call to your phone.",
    "oie.phone.verify.sms.codeSentText.with.phone.with.nickname": "A code was sent to <$1>{0}</$1> <$2>({1})</$2>. Enter the code below to verify.",
    "oie.phone.verify.mfa.calling.with.phone.with.nickname": "Calling <$1>{0}</$1> <$2>({1})</$2>. Enter the code below to verify.",
    "oie.phone.verify.sms.codeSentText.with.phone.without.nickname": "A code was sent to <$1>{0}</$1>. Enter the code below to verify.",
    "oie.phone.verify.mfa.calling.with.phone.without.nickname": "Calling <$1>{0}</$1>. Enter the code below to verify.",
    "oie.phone.verify.sms.codeSentText.without.phone": "A code was sent to your phone. Enter the code below to verify.",
    "oie.phone.verify.mfa.calling.without.phone": "Calling your phone. Enter the code below to verify.",
    "oie.email.label": "Email",
    "oie.email.authenticator.description": "Verify with a link or code sent to your email",
    "oie.email.mfa.title": "Verify with your email",
    "oie.email.challenge.mfa.title": "Get a verification email",
    "oie.email.verify.primaryButton": "Send me an email",
    "oie.email.verify.subtitle.text.with.email": "Send a verification email to <$1>{0}</$1> by clicking on \"Send me an email\".",
    "oie.email.verify.subtitle.text.with.email.and.secondary.email": "Send a verification email to <$1>{0}</$1> and <$2>{1}</$2> by clicking on \"Send me an email\".",
    "oie.email.verify.subtitle.text.without.email": "Send a verification email by clicking on \"Send me an email\".",
    "oie.email.verify.alternate.magicLinkToEmailAddress": "We sent an email to <$1>{0}</$1>. ",
    "oie.email.verify.alternate.magicLinkToEmailAddress.with.secondary.email": "We sent an email to <$1>{0}</$1> and <$2>{1}</$2>. ",
    "oie.email.verify.alternate.magicLinkToYourEmail": "We sent you a verification email. ",
    "oie.email.verify.alternate.instructions": "Click the verification link in your email to continue or enter the code below.",
    "oie.email.verify.alternate.show.verificationCode.text": "Enter a verification code instead",
    "oie.email.verify.alternate.verificationCode.instructions": "Enter the verification code in the text box.",
    "oie.email.enroll.subtitle": "Please check your email and enter the code below.",
    "oie.email.return.link.expired.title": "Verify with your email",
    "oie.profile.additional.title": "Additional Profile information",
    "oie.profile.additional.secondemail.subtitle": "Use a second email to <$1> recover your account </$1> in case you become locked out. This email must be verified after setup.",
    "signinWithPasskeys.button": "Sign in with a passkey",
    "signin.passkeys.error": "Could not sign in with a passkey. Try again, or sign in another way to add a passkey to your account.",
    "signin.passkeys.error.NotSupportedError": "This browser doesn't support passkeys. Use a supported browser or sign in another way.",
    "signin.passkeys.error.SecurityError": "The relying party ID is not a registrable domain suffix of, nor equal to the current domain. Subsequently, an attempt to fetch the .well-known/webauthn resource of the claimed RP ID failed.",
    "signin.passkeys.error.rpIdMismatch": "Could not sign in with a passkey. The RP ID {0} is invalid for this domain.",
    "oie.webauthn.label": "Security Key or Biometric Authenticator",
    "oie.webauthn.passkeysRebrand.passkeys.label": "Passkey",
    "oie.webauthn.description": "Use a security key or a biometric authenticator to sign in",
    "oie.webauthn.passkeysRebrand.passkeys.description": "Use a passkey to sign in with biometrics or a security key.",
    "oie.enroll.webauthn.title": "Set up security key or biometric authenticator",
    "oie.enroll.webauthn.passkeysRebrand.passkeys.title": "Set up a passkey",
    "oie.enroll.webauthn.passkeysRebrand.custom.title": "Set up {0}",
    "oie.enroll.webauthn.instructions": "You will be prompted to register a security key or biometric authenticator (Windows Hello, Touch ID, Face ID, etc.). Follow the instructions to complete set up.",
    "oie.enroll.webauthn.passkeysRebrand.instructions": "You will be prompted to register a passkey. Follow the instructions to complete set up.",
    "oie.enroll.webauthn.uv.required.instructions": "Biometric verification or a PIN is required to setup this authenticator.",
    "oie.enroll.webauthn.instructions.edge": "Note: If you are enrolling a security key and Windows Hello or PIN is enabled, you will need to select 'Cancel' in the prompt before continuing.",
    "oie.enroll.webauthn.save": "Set up",
    "oie.webauthn.error.not.supported": "Security key or biometric authenticator is not supported on this browser. Contact your admin for assistance.",
    "oie.webauthn.passkeysRebrand.error.not.supported": "Passkeys are not supported on this browser. Contact your admin for assistance.",
    "oie.webauthn.error.invalidPasskey": "Invalid passkey.",
    "oie.verify.webauth.title": "Verify with Security Key or Biometric Authenticator",
    "oie.verify.webauth.passkeysRebrand.passkeys.title": "Verify with a passkey",
    "oie.verify.webauth.passkeysRebrand.custom.title": "Verify with {0}",
    "oie.verify.webauthn.instructions": "You will be prompted to use a security key or biometric verification (Windows Hello, Touch ID, etc.). Follow the instructions to complete verification.",
    "oie.verify.webauthn.passkeysRebrand.instructions": "You will be prompted to use a passkey. Follow the instructions to complete verification.",
    "oie.verify.webauthn.instructions.additional": "Additional instructions from your administrator:",
    "oie.verify.webauthn.uv.required.instructions": "Biometric verification or a PIN is required to sign in with this authenticator.",
    "oie.verify.webauthn.cant.verify": "Can't verify?",
    "oie.verify.webauthn.cant.verify.biometric.authenticator.title": "Are you trying to use a biometric authenticator?",
    "oie.verify.webauthn.cant.verify.biometric.authenticator.description1": "Biometric authenticators (fingerprint, face recognition, PIN) will only work on the same device on which they were set up.",
    "oie.verify.webauthn.cant.verify.biometric.authenticator.description2": "If available, set up another security method on the device you used to set up your biometric authenticator.",
    "oie.verify.webauthn.cant.verify.security.key.title": "Are you trying to use a security key?",
    "oie.verify.webauthn.cant.verify.security.key.description": "If you have set up a security key, insert it in a USB port when prompted by the browser and tap on the button or gold disk. Security keys can work on multiple devices.",
    "oie.verify.webauthn.cant.verify.enrollment.step1": "Open your Okta Dashboard (e.g. yourcompany.okta.com) on the device you used to setup your security key or biometric authenticator",
    "oie.verify.webauthn.passkeysRebrand.cant.verify.enrollment.step1": "Open your Okta Dashboard (e.g. yourcompany.okta.com) on the device you used to setup your passkey",
    "oie.verify.webauthn.cant.verify.enrollment.step2": "Go to Settings > Security Methods",
    "oie.verify.webauthn.cant.verify.enrollment.step3": "On Okta Verify, click \"Set up\"",
    "oie.verify.webauthn.cant.verify.enrollment.step4": "Scan the QR code using Okta Verify and follow instructions to finish enrolling your account",
    "oie.enroll.webauthn.rk.link": "If you haven't set up your security key or biometric authentication, you can complete the process after you sign in using <a href=\"#\" class=\"setup-webauthn-residentkey-link\">this link</a>.",
    "oie.enroll.authenticator.promotion.title": "Set up a passkey: more secure, easier to use.",
    "oie.enroll.authenticator.promotion.faq.benefit.title": "Why should I use passkeys?",
    "oie.enroll.authenticator.promotion.faq.benefit.description": "With passkeys, you don't need to remember complex passwords, and they're more secure.",
    "oie.enroll.authenticator.promotion.faq.definition.title": "What are passkeys?",
    "oie.enroll.authenticator.promotion.faq.definition.description": "Passkeys are encrypted digital keys you create using your fingerprint, face, or screen lock.",
    "oie.enroll.authenticator.promotion.faq.storage.title": "Where are passkeys saved?",
    "oie.enroll.authenticator.promotion.faq.storage.description": "Passkeys are most commonly saved in your password manager or browser profile.",
    "oie.enroll.authenticator.promotion.learnMore": "Learn more",
    "oie.enroll.authenticator.promotion.cta": "Set up",
    "oie.enroll.authenticator.promotion.cta.createPasskey": "Create a passkey",
    "oie.enroll.authenticator.promotion.skip": "Maybe later",
    "oie.select.authenticator.verify.email.label": "Select Email.",
    "oie.select.authenticator.verify.email.with.email.label": "Select Email - {0}.",
    "oie.select.authenticator.verify.password.label": "Select Password.",
    "oie.select.authenticator.verify.phone.label": "Select Phone.",
    "oie.select.authenticator.verify.phone.with.phone.label": "Select Phone - {0}.",
    "oie.select.authenticator.verify.webauthn.label": "Select Security Key or Biometric Authenticator.",
    "oie.select.authenticator.verify.webauthn.passkeysRebrand.passkeys.label": "Select a passkey.",
    "oie.select.authenticator.verify.webauthn.passkeysRebrand.custom.label": "Select {0}.",
    "oie.select.authenticator.verify.security.question.label": "Select Security Question.",
    "oie.select.authenticator.okta_verify.totp.label": "Select to enter a code from the Okta Verify app.",
    "oie.select.authenticator.okta_verify.push.label": "Select to get a push notification to the Okta Verify app.",
    "oie.select.authenticator.okta_verify.signed_nonce.label": "Select Okta Verify.",
    "oie.select.authenticator.verify.okta_verify.label": "Select Okta Verify.",
    "oie.select.authenticator.verify.named.authenticator.label": "Select {0}.",
    "oie.select.authenticator.enroll.email.label": "Set up Email.",
    "oie.select.authenticator.enroll.password.label": "Set up Password.",
    "oie.select.authenticator.enroll.phone.label": "Set up Phone.",
    "oie.select.authenticator.enroll.webauthn.label": "Set up Security Key or Biometric Authenticator.",
    "oie.select.authenticator.enroll.webauthn.passkeysRebrand.passkeys.label": "Set up a passkey.",
    "oie.select.authenticator.enroll.webauthn.passkeysRebrand.custom.label": "Set up {0}.",
    "oie.select.authenticator.enroll.security.question.label": "Set up Security Question.",
    "oie.select.authenticator.enroll.okta_verify.authenticator.label": "Set up Okta Verify.",
    "oie.select.authenticator.enroll.named.authenticator.label": "Set up {0}.",
    "oie.security.question.label": "Security Question",
    "oie.security.question.enroll.title": "Set up security question",
    "oie.security.question.challenge.title": "Verify with your Security Question",
    "oie.security.question.questionKey.label": "Choose a security question",
    "oie.security.question.createQuestion.label": "Create my own security question",
    "oie.security.question.authenticator.description": "Choose a security question and answer that will be used for signing in",
    "securityQuestion.answer.tooShort.arg": "The security question answer must be at least {0} characters in length",
    "oie.okta_verify.label": "Okta Verify",
    "oie.enroll.okta_verify.setup.subtitle": "To continue, you'll need an Okta Verify account on this device.",
    "oie.enroll.okta_verify.setup.download": "If you don't have Okta Verify installed, <$1>download the app</$1>.",
    "oie.enroll.okta_verify.setup.openOv": "Open Okta Verify and follow the steps to add your account.",
    "oie.enroll.okta_verify.setup.signInUrl": "When prompted, choose Sign In, then enter the sign-in URL:",
    "oie.enroll.okta_verify.setup.instructions": "Follow the instructions to set up Okta Verify on this device, then return here and refresh this page.",
    "oie.okta_verify.authenticator.description": "Okta Verify is an authenticator app, installed on your phone or computer, used to prove your identity",
    "oie.enroll.okta_verify.setup.title": "Set up Okta Verify",
    "oie.enroll.okta_verify.setup.email.title": "Check your email",
    "oie.enroll.okta_verify.setup.sms.title": "Check your text messages",
    "oie.enroll.okta_verify.setup.skipAuth.subtitle": "To set up Okta Verify on additional devices, you can add an existing Okta Verify account to another device.",
    "oie.enroll.okta_verify.setup.skipAuth.openOv": "Open Okta Verify on any of your other Okta Verify devices (<$1>{0}</$1>).",
    "oie.enroll.okta_verify.setup.skipAuth.openOv.suchAs": "Open Okta Verify on any of your other Okta Verify devices (Such as your <$1>{0}</$1>).",
    "oie.enroll.okta_verify.setup.skipAuth.selectAccount": "In the app, select your account.",
    "oie.enroll.okta_verify.setup.skipAuth.addAccount": "Choose <$1>Export account.</$1>",
    "oie.enroll.okta_verify.setup.skipAuth.followInstruction": "Follow the rest of the instructions shown in Okta Verify.",
    "oie.enroll.okta_verify.setup.skipAuth.canBeClosed": "This screen can be closed at any time.",
    "oie.enroll.okta_verify.setup.customUri.makeSureHaveOVToContinue": "To continue, make sure you have the Okta Verify app.",
    "oie.enroll.okta_verify.setup.customUri.setup": "Once Okta Verify is installed, return to this page and tap <$1>Set up Okta Verify</$1>.",
    "oie.enroll.okta_verify.setup.customUri.return.mobile": "Once installed, return here and tap Set up Okta Verify.",
    "oie.enroll.okta_verify.setup.customUri.return.desktop": "Once installed, return here and click Set up Okta Verify.",
    "oie.enroll.okta_verify.setup.customUri.prompt": "Click <$1>\"Open Okta Verify\"</$1> on the browser prompt to set up Okta Verify.",
    "oie.enroll.okta_verify.setup.customUri.noPrompt": "<$1>Didn't see the prompt?</$1>",
    "oie.enroll.okta_verify.setup.customUri.makeSureHaveOV": "Make sure you have Okta Verify installed.",
    "oie.enroll.okta_verify.setup.customUri.orMobile": "Or <$1>set up Okta Verify on another mobile device</$1>",
    "oie.enroll.okta_verify.setup.customUri.orOnMobile": "Or <$1>set up Okta Verify on a mobile device</$1>",
    "oie.enroll.okta_verify.select.channel.description": "Which option do you want to try?",
    "oie.enroll.okta_verify.select.channel.qrcode.label": "Scan a QR code",
    "oie.enroll.okta_verify.select.channel.subtitle": "How would you like to set up Okta Verify?",
    "oie.enroll.okta_verify.select.channel.email.label": "Email me a setup link",
    "oie.enroll.okta_verify.select.channel.sms.label": "Text me a setup link",
    "oie.enroll.okta_verify.select.channel.ovOnThisDevice": "Or <$1>set up Okta Verify on this device</$1>",
    "oie.enroll.okta_verify.select.channel.title": "More options",
    "oie.enroll.okta_verify.select.channel.title.updated": "Set up Okta Verify on another mobile device",
    "oie.enroll.okta_verify.channel.email.label": "Email",
    "oie.enroll.okta_verify.enroll.channel.email.title": "Set up Okta Verify via email link",
    "oie.enroll.okta_verify.enroll.channel.email.subtitle": "Make sure you can access the email on the receiving device",
    "oie.enroll.okta_verify.enroll.channel.sms.title": "Set up Okta Verify via SMS",
    "oie.enroll.okta_verify.channel.email.description": "Make sure you can access the email on your mobile device.",
    "oie.enroll.okta_verify.channel.sms.description": "Make sure you can access the text on your mobile device.",
    "oie.enroll.okta_verify.channel.sms.description.updated": "Make sure you can access the text on the receiving device",
    "oie.enroll.okta_verify.qrcode.title": "Set up Okta Verify via QR code",
    "oie.enroll.okta_verify.qrcode.step1": "On your mobile device, download the Okta Verify app from the App Store (iPhone and iPad) or Google Play (Android devices).",
    "oie.enroll.okta_verify.qrcode.step1.updated": "On your other device, download the Okta Verify app from the App Store\xae (iPhone\xae and iPad\xae) or on Google Play (Android\xae devices).",
    "oie.enroll.okta_verify.qrcode.step2": "Open the app and follow the instructions to add your account",
    "oie.enroll.okta_verify.qrcode.step3.updated": "When prompted, tap <$1>Scan a QR code</$1>, then scan the QR code below:",
    "oie.enroll.okta_verify.qrcode.step3": "When prompted, tap Scan a QR code, then scan the QR code below:",
    "oie.enroll.okta_verify.qrcode.cannotScan": "Can't scan?",
    "oie.enroll.okta_verify.switch.channel.link.text": "Or <a href=\"#\" class=\"switch-channel-link\">try a different way</a> to set up Okta Verify.",
    "oie.enroll.okta_verify.email.info": "We sent an email to <span class=\"strong\">{0}</span> with an Okta Verify setup link. To continue, open the link on your mobile device.",
    "oie.enroll.okta_verify.email.info.updated": "We sent an email to <$1>{0}</$1> with an Okta Verify setup link. To continue, open the link on your receiving device.",
    "oie.enroll.okta_verify.email.notReceived": 'Haven\u2019t received an email? Check your spam folder or <a href="#" class="resend-link">send again</a>',
    "oie.enroll.okta_verify.sms.info": "We sent an SMS to <span class=\"strong\">{0}</span> with an Okta Verify setup link. To continue, open the link on your mobile device.",
    "oie.enroll.okta_verify.sms.info.updated": "We sent an SMS to <$1>{0}</$1> with an Okta Verify setup link. To continue, open the link on your receiving device.",
    "oie.enroll.okta_verify.sms.notReceived": 'Haven\u2019t received an SMS? <a href="#" class="resend-link">Send again</a>',
    "oie.enroll.okta_verify.setupLink": "Send me the setup link",
    "oie.okta_verify.totp.title": "Enter a code",
    "oie.okta_verify.totp.enterCodeText": "Enter code from Okta Verify app",
    "oie.okta_verify.push.title": "Get a push notification",
    "oie.okta_verify.push.sent": "Push notification sent",
    "oie.okta_verify.push.sent.respond_to_continue": "Respond on your mobile device to continue.",
    "oie.okta_verify.push.resend": "Resend push notification",
    "oie.okta_verify.sendPushButton": "Send push",
    "oie.okta_verify.signed_nonce.label": "Use Okta FastPass",
    "oie.okta_verify.enroll.force.upgrade.title": "Update Okta Verify",
    "oie.authenticator.app.non_fips_compliant_enrollment_device_incompatible": "The device used to set up Okta Verify does not meet your organization\u2019s security requirements because it is not FIPS compliant. Contact your administrator for help.",
    "oie.authenticator.app.non_fips_compliant_enrollment_app_update_required": "The Okta Verify version on the device used does not meet your organization\u2019s security requirements. To add your account, update Okta Verify to the latest version, then try again.",
    "oie.authenticator.app.method.push.verify.enable.biometrics": "Your response was received, but your organization requires biometrics. Make sure your device supports biometrics, Okta Verify is up-to-date and biometrics are enabled for your account in Okta Verify, then try again.",
    "oie.authenticator.app.method.push.verify.enable.biometrics.title": "Enable biometrics in Okta Verify",
    "oie.authenticator.app.method.push.verify.enable.biometrics.description": "Your response was received, but your organization requires biometrics. Make sure you meet the following requirements, then try again:",
    "oie.authenticator.app.method.push.verify.enable.biometrics.point1": "Your device supports biometrics",
    "oie.authenticator.app.method.push.verify.enable.biometrics.point2": "Okta Verify is up-to-date",
    "oie.authenticator.app.method.push.verify.enable.biometrics.point3": "In Okta Verify, biometrics are enabled for your account",
    "oie.authenticator.app.method.push.verify.enable.biometrics_or_pin": "Your response was received, but your org requires biometrics or a device screen lock. Ensure that Okta Verify is up to date and screen lock confirmation is enabled for your account in Okta Verify, then try again.",
    "oie.authenticator.app.method.push.verify.enable.biometrics_or_pin.title": "Enable screen lock confirmation in Okta Verify",
    "oie.authenticator.app.method.push.verify.enable.biometrics_or_pin.description": "Your response was received, but your org requires biometrics or a device screen lock. Ensure that you meet the following requirements and try again:",
    "oie.authenticator.app.method.push.verify.enable.biometrics_or_pin.point1": "Okta Verify is up to date.",
    "oie.authenticator.app.method.push.verify.enable.biometrics_or_pin.point2": "Screen lock confirmation is enabled for your account in Okta Verify.",
    "oie.authenticator.app.method.push.enroll.enable.biometrics": "Your organization requires biometrics. To proceed, ensure your device supports biometrics, then add your account and enable biometrics when prompted.",
    "oie.authenticator.app.method.push.enroll.enable.biometrics.title": "Enable biometrics to add an account in Okta Verify",
    "oie.authenticator.app.method.push.enroll.enable.biometrics_or_pin": "Your org requires biometrics or a device screen lock. To proceed, add your account in Okta Verify and enable screen lock confirmation when prompted.",
    "oie.authenticator.app.method.push.enroll.enable.biometrics_or_pin.title": "Enable screen lock confirmation in Okta Verify",
    "oie.authenticator.oktaverify.method.totp.verify.enable.biometrics": "Your response was received, but your organization requires biometrics. Make sure your device supports biometrics, Okta Verify is up-to-date and biometrics are enabled for your account in Okta Verify, then try again.",
    "oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.title": "Enable biometrics in Okta Verify",
    "oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.description": "Your response was received, but your organization requires biometrics. Make sure you meet the following requirements, then try again:",
    "oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.point1": "Your device supports biometrics",
    "oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.point2": "Okta Verify is up-to-date",
    "oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.point3": "In Okta Verify, biometrics are enabled for your account",
    "oie.authenticator.oktaverify.method.totp.verify.enable.biometrics_or_pin": "Your response was received, but your org requires biometrics or a device screen lock. Ensure that Okta Verify is up to date and screen lock confirmation is enabled for your account in Okta Verify, then try again.",
    "oie.authenticator.oktaverify.method.totp.verify.enable.biometrics_or_pin.title": "Enable screen lock confirmation in Okta Verify",
    "oie.authenticator.oktaverify.method.totp.verify.enable.biometrics_or_pin.description": "Your response was received, but your org requires biometrics or a device screen lock. Ensure that you meet the following requirements and try again:",
    "oie.authenticator.oktaverify.method.totp.verify.enable.biometrics_or_pin.point1": "Okta Verify is up to date.",
    "oie.authenticator.oktaverify.method.totp.verify.enable.biometrics_or_pin.point2": "Screen lock confirmation is enabled for your account in Okta Verify.",
    "oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.mobile": "Your response was received, but your organization requires biometrics. Make sure your device supports biometrics, Okta Verify is up-to-date and biometrics are enabled for your account in Okta Verify, then try again.",
    "oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.desktop": "Your response was received, but your organization requires biometrics. Make sure your device supports biometrics, Okta Verify is up-to-date, biometrics are enabled for your account in Okta Verify and your device's biometric sensors are accessible, then try again.",
    "oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.title": "Biometrics needed for Okta Verify",
    "oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.description": "Your response was received, but your organization requires biometrics. Make sure you meet the following requirements, then try again:",
    "oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point1": "Your device supports biometrics",
    "oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point2": "Okta Verify is up-to-date",
    "oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point3": "In Okta Verify, biometrics are enabled for your account",
    "oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point4": "Your device's biometric sensors are accessible",
    "oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics_or_pin.mobile": "Your response was received, but your org requires biometrics or a device screen lock. Ensure that Okta Verify is up to date and screen lock confirmation is enabled for your account in Okta Verify, then try again.",
    "oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics_or_pin.desktop": "Your response was received, but your org requires biometrics or a device screen lock. Ensure that Okta Verify is up to date and screen lock confirmation is enabled for your account in Okta Verify, then try again.",
    "oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics_or_pin.title": "Enable screen lock confirmation in Okta Verify",
    "oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics_or_pin.description": "Your response was received, but your org requires biometrics or a device screen lock. Ensure that you meet the following requirements and try again:",
    "oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics_or_pin.point1": "Okta Verify is up to date.",
    "oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics_or_pin.point2": "Screen lock confirmation is enabled for your account in Okta Verify.",
    "oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.windows": "Your response was received, but your organization requires Windows Hello confirmation. Make sure Okta Verify is up-to-date and enable Windows Hello confirmation in Okta Verify, then try again.",
    "oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.windows.title": "Enable Windows Hello or passcode confirmation in Okta Verify",
    "oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.windows.description": "To meet your organization's requirements, try the following, then return here and sign in again:",
    "oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.windows.point1": "Make sure Okta Verify is up-to-date",
    "oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.windows.point2": "In Okta Verify, enable Windows Hello or passcode confirmation for your account",
    "oie.google_authenticator.label": "Google Authenticator",
    "oie.google_authenticator.authenticator.description": "Enter a temporary code generated from the Google Authenticator app.",
    "oie.enroll.google_authenticator.setup.title": "Set up Google Authenticator",
    "oie.enroll.google_authenticator.scanBarcode.title": "Scan QR code",
    "oie.enroll.google_authenticator.scanBarcode.description": "Launch Google Authenticator, tap the \"+\" icon, then select \"Scan a QR code\".",
    "oie.enroll.google_authenticator.scanBarcode.cannotScan": "Can't scan?",
    "oie.enroll.google_authenticator.cannotScanBarcode.title": "Can't scan QR code?",
    "oie.enroll.google_authenticator.manualSetupInstructions": "To set up manually enter your Okta Account username and then input the following in the Secret Key Field",
    "oie.enroll.google_authenticator.sharedSecret.ariaLabel": "Secret key: {0}",
    "oie.enroll.google_authenticator.enterCode.title": "Enter code displayed from application",
    "oie.verify.google_authenticator.otp.title": "Verify with Google Authenticator",
    "oie.verify.google_authenticator.otp.description": "Enter the temporary code generated in your Google Authenticator app",
    "oie.google_authenticator.otp.enterCodeText": "Enter code",
    "oie.verify.custom_otp.title": "Verify with {0}",
    "oie.verify.custom_otp.description": "Enter the code generated on your authenticator and verify.",
    "oie.custom_otp.description": "Enter a temporary code generated from an authenticator device.",
    "oie.custom_otp.authenticator.default.vendorName": "Custom OTP Authenticator",
    "oie.custom_otp.verify.passcode.label": "Enter code",
    "oie.verify.custom_app.title": "Verify with {0}",
    "oie.custom_app.push.sent": "Push notification sent",
    "oie.custom_app.push.resend": "Resend push notification",
    "oie.custom_app.push.warning": "Haven't received a push notification yet? Try opening {0} on your phone.",
    "oie.authenticator.custom_app.method.push.verify.enable.biometrics": "Your response was received, but your organization requires biometrics\u2014like a fingerprint or facial scan\u2014for access. Make sure your device meets the following requirements, then try again:",
    "oie.authenticator.custom_app.method.push.verify.enable.biometrics.title": "Enable biometrics in {0}",
    "oie.authenticator.custom_app.method.push.verify.enable.biometrics.description": "Your response was received, but your organization requires biometrics\u2014like a fingerprint or facial scan\u2014for access. Make sure your device meets the following requirements, then try again:",
    "oie.authenticator.custom_app.method.push.verify.enable.biometrics.point1": "Your device supports biometrics",
    "oie.authenticator.custom_app.method.push.verify.enable.biometrics.point2": "{0} is up-to-date",
    "oie.authenticator.custom_app.method.push.verify.enable.biometrics.point3": "In {0}, biometrics are enabled for your account",
    "oie.custom_app.sendPushButton": "Send push",
    "oie.custom_app.push.title": "Get a push notification",
    "oie.on_prem.authenticator.description": "Verify by entering a code generated by {0}.",
    "oie.on_prem.authenticator.default.vendorName": "Custom On-prem Authenticator",
    "oie.on_prem.enroll.title": "Set up {0}",
    "oie.on_prem.verify.title": "Verify with {0}",
    "oie.numberchallenge.warning": "Haven't received a push notification yet? Try opening the Okta Verify app on your device, or <$1>resend the push notification</$1>.",
    "oie.numberchallenge.instruction": "On your mobile device, open the Okta Verify prompt, then tap <$1>{0}</$1> in Okta Verify to continue.",
    "oie.numberchallenge.force.upgrade.title": "Update Okta Verify",
    "oie.authenticator.app.method.push.force.upgrade.number_challenge": "Your response was received, but your Okta Verify version is no longer supported by your organization. To verify your identity with push notifications, update Okta Verify to the latest version, then try again.",
    "oie.rsa.authenticator.description": "Verify by entering a code generated by RSA SecurID",
    "oie.duo.authenticator.description": "Verify your identity using Duo Security.",
    "oie.duo.enroll.title": "Set up Duo Security",
    "oie.duo.verify.title": "Verify with Duo Security",
    "oie.duo.iFrameError": "Error loading Duo. Try again or contact your admin for assistance.",
    "oie.authenticator.duo.error": "We were unable to verify with Duo. Try again.",
    "oie.idp.authenticator.description": "Redirect to verify with {0}.",
    "oie.idp.enroll.title": "Set up {0}",
    "oie.idp.enroll.description": "You will be redirected to enroll in {0}",
    "oie.idp.challenge.title": "Verify with {0}",
    "oie.idp.challenge.description": "You will be redirected to verify with {0}",
    "idx.identity.provider.auth.error": "There was a problem signing you into your identity provider. Please contact your administrator for help.",
    "oie.idv.idp.title": "Verify your identity with {0}",
    "oie.idv.idp.desc": "Verify your identity with {0} to continue and share your verification results with Okta. You may need a valid government-issued ID.",
    "oie.idv.idp.desc.termsOfUse": "{0}'s <$1>Terms of Use</$1> and <$2>Privacy Policy</$2> will apply to {0}'s verification of your identity. ",
    "oie.idv.idp.desc.agreement": "By clicking \"Continue\", I agree that {0} will share my verification results with Okta.",
    "oie.idv.persona": "Persona",
    "oie.idv.clear": "Clear",
    "oie.idv.incode": "Incode",
    "oie.idv.customIDV": "Custom IDV",
    "oie.symantecVip.authenticator.description": "Verify by entering a temporary code from the {0} app.",
    "oie.symantecVip.enroll.title": "Set up {0}",
    "oie.symantecVip.enroll.description": "From the {0} app, enter your credential ID and two consecutive generated codes",
    "oie.symantecVip.challenge.title": "Verify with {0}",
    "oie.symantecVip.challenge.description": "Enter the generated security code from the {0} app.",
    "oie.symantecVip.verify.passcode.label": "Enter security code",
    "oie.yubikey.label": "YubiKey Authenticator",
    "oie.yubikey.authenticator.description": "Verify your identity using YubiKey",
    "oie.yubikey.enroll.title": "Set up YubiKey",
    "oie.yubikey.challenge.title": "Verify with YubiKey",
    "oie.yubikey.description": "Use your YubiKey to insert a verification code.",
    "oie.yubikey.passcode.label": "Insert then tap your YubiKey",
    "oie.yubikey.passcode.show": "Show YubiKey verification code",
    "oie.yubikey.passcode.hide": "Hide YubiKey verification code",
    "oie.custom.app.authenticator.title": "Get a push notification",
    "oie.custom.app.authenticator.description": "{0} is an authenticator app, installed on your phone, used to prove your identity",
    "oie.smartcard.authenticator.description": "Use a physical smart card, such as PIV or CAC, to sign in",
    "oie.tac.label": "Temporary Access Code",
    "oie.verify.tac.title": "Verify with Temporary Access Code",
    "oie.verify.tac.description": "Enter the code provided by your administrator. Contact your administrator if you need a new code.",
    "oie.tac.authenticator.description": "Enter a code provided by your administrator to sign in",
    "oie.nfc_pin.authenticator.description": "Add your NFC device and create a PIN.",
    "oie.nfc_pin.launch.button": "Sign in with NFC",
    "oie.nfc_pin.challenge.verify.title": "Verify with NFC",
    "oie.nfc_pin.challenge.verify.description": "Open Okta Verify and scan your NFC device. Then, enter your PIN.",
    "oie.nfc_pin.verify.title": "Verify with your PIN",
    "oie.nfc_pin.verify.description": "Tap your NFC device and enter your PIN",
    "oie.nfc_pin.verify.pinLabel": "Enter PIN",
    "oie.nfc_pin.forgot.pin": "Forgot PIN?",
    "oie.enroll.nfc_pin.title": "Set up NFC",
    "oie.enroll.nfc_pin.instructions": "Open Okta Verify and add your NFC device, then return here to set your PIN.",
    "oie.enroll.nfc_pin.openOktaVerify": "Open Okta Verify",
    "oie.enroll.nfc_pin.create.title": "Choose a PIN",
    "oie.enroll.nfc_pin.create.description": "When you sign in with NFC, you will also enter your PIN.",
    "oie.enroll.nfc_pin.create.pinLabel": "PIN",
    "oie.enroll.nfc_pin.create.confirmPinLabel": "Re-enter PIN",
    "oie.enroll.nfc_pin.create.error.match": "Your PINs must match.",
    "oie.enroll.nfc_pin.create.requirements.header": "Requirements:",
    "oie.enroll.nfc_pin.create.requirement.length": "Enter a {0}-digit PIN.",
    "oie.enroll.nfc_pin.create.error.numeric": "Your PIN can contain numbers only.",
    "oie.enroll.nfc_pin.create.error.requirementsNotMet.prefix": "PIN requirements were not met:",
    "oie.nfc_pin.sign_in_to_enroll.title": "Sign in to enroll your NFC device",
    "oie.nfc_pin.unavailable.title": "Sign in with NFC is unavailable",
    "oie.okta_verify.fastpass.blocked.title": "FastPass is blocked on this device",
    "oie.select.authenticators.enroll.title": "Set up security methods",
    "oie.select.authenticators.enroll.subtitle": "Security methods help protect your account by ensuring only you have access.",
    "oie.select.authenticators.enroll.subtitle.custom": "Security methods help protect your {0} account by ensuring only you have access.",
    "oie.setup.required": "Set up required",
    "oie.setup.optional": "Set up optional",
    "oie.setup.required.now": "Required now",
    "oie.setup.required.soon": "Required soon",
    "oie.setup.optional.short": "Optional",
    "oie.setup.required.soon.description": "When the deadline passes, you won\u2019t be able to sign in until you complete setup.",
    "oie.setup.remind.me.later": "Remind me later",
    "oie.optional.authenticator.button.title": "Continue",
    "oie.verify.authenticator.button.text": "Select",
    "oie.enroll.authenticator.button.text": "Set up",
    "oie.enroll.authenticator.usage.text.access.recovery": "Used for access or recovery",
    "oie.enroll.authenticator.usage.text.recovery": "Used for recovery",
    "oie.enroll.authenticator.usage.text.access": "Used for access",
    "oie.select.authenticators.verify.title": "Verify it's you with a security method",
    "oie.select.authenticators.verify.subtitle": "Select from the following options",
    "oie.success.text.signingIn": "Signing in",
    "oie.success.text.signingIn.with.ellipsis": "Signing in...",
    "oie.success.text.signingIn.with.appName": "Signing in to {0}",
    "oie.success.text.signingIn.with.appName.android.ov.enrollment": "To continue, tap \"Open Okta Verify\"",
    "oie.success.text.signingIn.with.appName.and.identifier": "Signing in to {0} as {1}",
    "oie.go.back": "Go back",
    "oie.enroll.switch.authenticator": "Return to authenticator list",
    "oie.enroll.skip.setup": "Skip set up",
    "oie.enroll.skip.profile": "Skip Profile",
    "oie.verification.switch.authenticator": "Verify with something else",
    "oie.remember": "Keep me signed in",
    "oie.try.again": "Try again",
    "enroll.title.oda": "Download Okta Verify",
    "enroll.title.oda.with.account": "Additional setup required to use Okta FastPass",
    "enroll.title.oda.without.account": "Set up an Okta Verify account",
    "enroll.title.mdm": "Additional setup required",
    "enroll.subtitle.fastpass": "On this device, do you already have an Okta Verify account for {0}?",
    "enroll.option.noaccount.fastpass": "No, I don\u2019t have an account",
    "enroll.option.account.fastpass": "Yes, I already have an account",
    "enroll.explanation.p1": "To sign in using Okta Verify, you will need to set up Okta Verify on this device.",
    "enroll.explanation.p2": "In the app, follow the instructions to add an organizational account. When prompted, choose <span class=\"semi-strong\">Sign In</span>, then enter the <span class=\"semi-strong\">sign-in URL</span>:",
    "enroll.oda.android.step1": "On Google Play, download the Okta Verify app.",
    "enroll.oda.step1": "Open Okta Verify and follow the steps to add your account.",
    "enroll.oda.step2": "When prompted, choose Sign In, then enter the sign-in URL:",
    "enroll.oda.step3": "Download the Okta Verify app.",
    "enroll.oda.download.ios": "Download on the App Store",
    "enroll.oda.download.android": "Get it on Google Play",
    "enroll.oda.download.windows": "Download 64-bit",
    "enroll.oda.download.osx": "Download on the Mac App Store",
    "enroll.oda.step6": "Finish setting up your account in Okta Verify, then try accessing this app again.",
    "enroll.oda.with.account.explanation": "Okta FastPass is a security method that can sign you in without needing your username.",
    "enroll.oda.with.account.subtitile1": "Already have Okta FastPass enabled for your account?",
    "enroll.oda.with.account.subtitile2": "Need to set up Okta FastPass for your account?",
    "enroll.oda.with.account.step1": "Make sure your Okta Verify is up-to-date, then try signing in again.",
    "enroll.oda.with.account.step2": "If your device has a work profile, make sure you are signing in from the same profile that Okta Verify is installed in.",
    "enroll.oda.with.account.step3": "On certain browsers and applications, Okta FastPass is not supported.",
    "enroll.oda.with.account.step4": "On this device, open the Okta Verify app.",
    "enroll.oda.with.account.step5": "On the list of accounts, tap your account for {0}.",
    "enroll.oda.with.account.step6": "Under the \u201COkta FastPass\u201D section, tap Setup, then follow the instructions.",
    "enroll.oda.with.account.step7": "After your setup is complete, return here to try signing in again.",
    "enroll.oda.without.account.explanation": "To sign in with Okta FastPass, you\u2019ll need to set up Okta Verify on this device.",
    "enroll.oda.without.account.step1": 'If you don\u2019t have Okta Verify installed, <a href="{0}" target="_blank" class="download-ov-link" id="download-ov">download the app.</a>',
    "enroll.oda.without.account.step4": "Finish setting up your account in Okta Verify, then try signing in again.",
    "enroll.appleStore": "the App Store",
    "enroll.googleStore": "Google Play",
    "enroll.copy.ios": "Apple\xae, App Store, and the Apple logo are trademarks of Apple Inc.",
    "enroll.copy.android": "Google Play and the Google Play logo are trademarks of Google LLC.",
    "enroll.explanation.mdm": "To access this app, your device needs to meet your organization's security requirements. Follow the instructions below to continue.",
    "enroll.oda.org.copyLink": "Copy sign-in URL to clipboard",
    "enroll.oda.org.copyLink.success": "Sign-in URL copied.",
    "enroll.mdm.copyLink": "Copy link to clipboard",
    "enroll.mdm.copyLink.success": "Link copied.",
    "enroll.mdm.step.copyLink": "Tap the Copy Link button below.",
    "enroll.mdm.step.pasteLink": "On this device, open your browser, then paste the copied link into the address bar.",
    "enroll.mdm.step.followInstructions": "Follow the instructions in your browser to set up <$1>{0}</$1>.",
    "enroll.mdm.step.relogin": "Logout and re-login and then try accessing the app again.",
    "oie.safe.mode.title": "Authenticator set up unavailable",
    "idx.error.server.safe.mode.enrollment.unavailable": "Set up is temporarily unavailable due to server maintenance. Try again later.",
    "oie.primaryauth.submit": "Sign in",
    "oie.registration.form.title": "Sign up",
    "oie.registration.form.submit": "Sign Up",
    "oie.registration.form.update.submit": "Submit",
    "oie.registration.form.customize.label": "{0}",
    "oie.registration.form.customize.buttonLabel": "{0}",
    "oie.user.profile.login": "Username",
    "oie.user.profile.lastname": "Last name",
    "oie.user.profile.firstname": "First name",
    "oie.user.profile.primary.email": "Email",
    "oie.user.profile.secondary.email": "Secondary email",
    "oie.user.profile.middleName": "Middle name",
    "oie.user.profile.honorificPrefix": "Honorific prefix",
    "oie.user.profile.honorificSuffix": "Honorific suffix",
    "oie.user.profile.primaryEmail": "Primary email",
    "oie.user.profile.title": "Title",
    "oie.user.profile.displayName": "Display name",
    "oie.user.profile.nickName": "Nickname",
    "oie.user.profile.profileUrl": "Profile URL",
    "oie.user.profile.mobilePhone": "Mobile phone",
    "oie.user.profile.primaryPhone": "Primary phone",
    "oie.user.profile.streetAddress": "Street address",
    "oie.user.profile.city": "City",
    "oie.user.profile.state": "State",
    "oie.user.profile.zipCode": "ZIP Code",
    "oie.user.profile.postalCode": "Postal code",
    "oie.user.profile.countryCode": "Country code",
    "oie.user.profile.postalAddress": "Postal address",
    "oie.user.profile.preferredLanguage": "Preferred language",
    "oie.user.profile.locale": "Locale",
    "oie.user.profile.timezone": "Time zone",
    "oie.user.profile.userType": "User type",
    "oie.user.profile.employeeNumber": "Employee number",
    "oie.user.profile.costCenter": "Cost center",
    "oie.user.profile.organization": "Organization",
    "oie.user.profile.division": "Division",
    "oie.user.profile.department": "Department",
    "oie.user.profile.managerId": "Manager ID",
    "oie.user.profile.manager": "Manager",
    "oie.selfservice.unlock_user.landing.to.app.success.message": "Account successfully unlocked! Verify your account with a security method to continue.",
    "oie.selfservice.unlock_user.landing.to.app.signing.in.message": "Account successfully unlocked!",
    "oie.selfservice.unlock_user.success.message": "You can log in using your existing username and password.",
    "oie.selfservice.unlock_user.failed.message": "We are unable to unlock your account at this time, please contact your administrator",
    "oie.selfservice.user.unlock.not.allowed": "Self Service Unlock is not allowed at this time. Please contact support for assistance.",
    "oie.kmsi.title": "Keep me signed in",
    "oie.kmsi.subtitle": "Sign in and enter security methods less frequently.",
    "oie.kmsi.accept": "Stay signed in",
    "oie.kmsi.reject": "Don't stay signed in",
    "idx.session.expired": "You have been logged out due to inactivity. Refresh or return to the sign in screen.",
    "oie.registration.is.not.enabled": "Sign up is not enabled for this organization.",
    "oie.forgot.password.is.not.enabled": "Forgot password is not enabled for this organization.",
    "idx.return.error": "Could not process this email link. Return to the screen where you requested it.",
    "idx.return.stale": "This email link is out of date. Return to the screen where you requested it.",
    "idx.invalid.forgot.password.token": "Your reset password token is no longer valid.",
    "idx.invalid.reset.password.token": "Your reset password token is no longer valid. Contact your administrator to obtain a new token.",
    "idx.reset.password.activating.user": "Reset password cannot be performed while the user is activating. Contact your administrator to obtain a new token.",
    "core.system.transaction_resource_not_found": "Verification timed out. Please try again",
    tagsNotAllowed: $d9da1151f2dab40a$export$3dc543664767d449,
    "api.authn.error.PASSCODE_INVALID": "Invalid code. Try again.",
    "api.authenticator.error.nfc.pin_incorrect": "Incorrect PIN. Please try again.",
    "api.authenticator.error.nfc.sign_in_to_use": "Sign in with another method to finish enrolling your NFC device.",
    "api.authenticator.error.nfc.unavailable": "Try a different sign-in method or contact your administrator for help.",
    "api.authenticator.error.fastpass.blocked_shared_device": "Try a different sign-in method or contact your administrator for help.",
    "oie.feature.disabled": "The requested feature is not enabled in this environment.",
    "authfactor.challenge.suspended_factor": "This factor is suspended for your account due to too many failed attempts",
    "oie.post.password.update.auth.failure.error": "Your password has been updated but there was a problem signing you in. Please try again or contact your administrator.",
    "oie.assurance.unsatisfiable": "Unable to login to \"{0}\" at this time. For assistance, please contact your administrator.",
    "errors.E0000150": "You have reached the limit of sms requests, please try again later.",
    "errors.E0000151": "You have reached the limit of call requests, please try again later.",
    "oie.invalid.recovery.token": "The recovery token is invalid.",
    "oie.consent.scopes.admin.title": "would like to access:",
    "oie.consent.scopes.enduser.title": "would like to:",
    "oie.consent.scopes.granular.title": "<$1>{0}</$1> <$2>wants to access</$2>",
    "oie.consent.scopes.granular.description": "Allowing access will share",
    "oie.consent.enduser.accept.label": "Yes, it's me",
    "oie.consent.enduser.deny.label": "No, it's not me",
    "oie.consent.enduser.title": "Did you just try to sign in?",
    "oie.consent.enduser.email.allow.title": "Success! Return to the original tab or window",
    "oie.consent.enduser.email.allow.description": "To continue, please return to the original browser tab or window you used to verify.",
    "oie.consent.enduser.deny.description": "Close this window anytime.",
    "oie.return.to.original.tab": "Close this window anytime.",
    "idx.operation.cancelled.by.user": "Operation cancelled by user.",
    "idx.transferred.to.new.tab": "Flow continued in a new tab.",
    "idx.return.link.expired": "This email link has expired. To resend it, return to the screen where you requested it.",
    "idx.return.link.otponly.your.verification.code": "Your verification code",
    "idx.return.link.otponly.enter.code.on.page": "Enter this code on the {0} page.",
    "idx.return.link.otponly.enter.code.on.page.sign.in": "sign-in",
    "idx.return.link.otponly.enter.code.on.page.password.reset": "password reset",
    "idx.return.link.otponly.enter.code.on.page.account.unlock": "account unlock",
    "idx.return.link.otponly.enter.code.on.page.registration": "sign up",
    "idx.return.link.otponly.enter.code.on.sign.in.page": "Enter this code on the sign-in page.",
    "idx.return.link.otponly.enter.code.on.password.reset.page": "Enter this code on the password reset page.",
    "idx.return.link.otponly.enter.code.on.account.unlock.page": "Enter this code on the account unlock page.",
    "idx.return.link.otponly.enter.code.on.sign.up.page": "Enter this code on the sign up page.",
    "idx.return.link.otponly.request": "Request from:",
    "idx.return.link.otponly.warning.text": "If you didn\u2019t request this code, you can ignore this message. Your account is safe and can only be accessed with this code.",
    "idx.enter.otp.in.original.tab": "Enter the OTP in your original authentication location.",
    "idx.return.link.otponly.app": "{0}",
    "idx.return.link.otponly.browser.on.os": "{0} on {1}",
    "geolocation.formatting.all": "{0}, {1}, {2}",
    "geolocation.formatting.partial": "{0}, {1}",
    "consent.scopes.email.label": "View your email address.",
    "consent.scopes.profile.label": "View your profile information.",
    "consent.scopes.phone.label": "View your phone number.",
    "consent.scopes.address.label": "View your address.",
    "consent.scopes.offlineAccess.label": "Keep you signed in to the app.",
    "consent.scopes.onlineAccess.label": "Keep you signed in to the app.",
    "consent.scopes.deviceSSO.label": "Request device secret.",
    "consent.scopes.openid.desc": "Signals that a request is an OpenID request.",
    "consent.scopes.profile.desc": "The exact data varies based on what profile information you have provided, such as: name, time zone, picture, or birthday.",
    "consent.scopes.email.desc": "This allows the app to view your email address.",
    "consent.scopes.address.desc": "This allows the app to view your address, such as: street address, city, state, and zip code.",
    "consent.scopes.phone.desc": "This allows the app to view your phone number.",
    "consent.scopes.offlineAccess.desc": "This keeps you signed in to the app, even when you are not using it.",
    "consent.scopes.onlineAccess.desc": "This allows the app to access your data only when you are logged in to the application.",
    "consent.scopes.deviceSSO.desc": "This allows you to single sign on between native client applications on your device.",
    "consent.scopes.okta.users.manage.desc": "Allows the app to create new users and to manage all users'' profile and credentials information.",
    "consent.scopes.okta.users.manage.self.desc": "Allows the app to manage the signed-in user''s profile and credentials.",
    "consent.scopes.okta.users.read.desc": "Allows the app to read the existing users'' profiles and credentials.",
    "consent.scopes.okta.users.read.self.desc": "Allows the app to read the signed-in user''s profile and credentials.",
    "consent.scopes.okta.linkedObjects.manage.desc": "Allows the app to manage linked object definitions in your Okta organization.",
    "consent.scopes.okta.linkedObjects.read.desc": "Allows the app to read linked object definitions in your Okta organization.",
    "consent.scopes.okta.myAccount.manage.desc": "Allows the end-user to manage their account profile.",
    "consent.scopes.okta.myAccount.read.desc": "Allows the end-user to read their account profile.",
    "consent.scopes.okta.riskEvents.manage.desc": "Allows the app to publish risk events to your Okta organization.",
    "consent.scopes.okta.clients.manage.desc": "Allows the app to manage clients in your Okta organization.",
    "consent.scopes.okta.clients.read.desc": "Allows the app to read information about clients in your Okta organization.",
    "consent.scopes.okta.clients.register.desc": "Allows the app to create new clients in your Okta organization.",
    "consent.scopes.okta.authorizationServers.manage.desc": "Allows the app to create and manage Authorization Servers in your Okta organization.",
    "consent.scopes.okta.authorizationServers.read.desc": "Allows the app to read information about Authorization Servers in your Okta organization.",
    "consent.scopes.okta.groups.manage.desc": "Allows the app to manage existing groups in your Okta organization.",
    "consent.scopes.okta.groups.read.desc": "Allows the app to read information about groups and their members in your Okta organization.",
    "consent.scopes.okta.groups.register.desc": "Allows the app to create new groups in your Okta organization.",
    "consent.scopes.okta.events.read.desc": "Allows the app to read information about deprecated Events v1 API entries in your Okta organization.",
    "consent.scopes.okta.logs.read.desc": "Allows the app to read information about System Log entries in your Okta organization.",
    "consent.scopes.okta.inlineHooks.manage.desc": "Allows the app to create and manage Inline Hooks in your Okta organization.",
    "consent.scopes.okta.inlineHooks.read.desc": "Allows the app to read information about Inline Hooks in your Okta organization.",
    "consent.scopes.okta.eventHooks.manage.desc": "Allows the app to create and manage Event Hooks in your Okta organization.",
    "consent.scopes.okta.eventHooks.read.desc": "Allows the app to read information about Event Hooks in your Okta organization.",
    "consent.scopes.okta.apps.manage.desc": "Allows the app to create and manage Apps in your Okta organization.",
    "consent.scopes.okta.apps.read.desc": "Allows the app to read information about Apps in your Okta organization.",
    "consent.scopes.okta.schemas.manage.desc": "Allows the app to create and manage Schemas in your Okta organization.",
    "consent.scopes.okta.schemas.read.desc": "Allows the app to read information about Schemas in your Okta organization.",
    "consent.scopes.okta.idps.manage.desc": "Allows the app to create and manage Identity Providers in your Okta organization.",
    "consent.scopes.okta.idps.read.desc": "Allows the app to read information about Identity Providers in your Okta organization.",
    "consent.scopes.okta.roles.manage.desc": "Allows the app to manage administrative role assignments for users in your Okta organization.",
    "consent.scopes.okta.roles.read.desc": "Allows the app to read administrative role assignments for users in your Okta organization.",
    "consent.scopes.okta.policies.manage.desc": "Allows the app to manage policies in your Okta organization.",
    "consent.scopes.okta.policies.read.desc": "Allows the app to read information about policies in your Okta organization.",
    "consent.scopes.okta.orgs.manage.desc": "Allows the app to manage organization-specific details for your Okta organization.",
    "consent.scopes.okta.orgs.read.desc": "Allows the app to read organization-specific details about your Okta organization.",
    "consent.scopes.okta.captchas.manage.desc": "Allows the app to create and manage CAPTCHAs in your Okta organization.",
    "consent.scopes.okta.captchas.read.desc": "Allows the app to read information about CAPTCHAs in your Okta organization.",
    "consent.scopes.okta.sessions.manage.desc": "Allows the app to manage all sessions in your Okta organization.",
    "consent.scopes.okta.sessions.read.desc": "Allows the app to read all sessions in your Okta organization.",
    "consent.scopes.okta.trustedOrigins.manage.desc": "Allows the app to manage all Trusted Origins in your Okta organization.",
    "consent.scopes.okta.trustedOrigins.read.desc": "Allows the app to read all Trusted Origins in your Okta organization.",
    "consent.scopes.okta.templates.manage.desc": "Allows the app to manage all custom templates in your Okta organization.",
    "consent.scopes.okta.templates.read.desc": "Allows the app to read all custom templates in your Okta organization.",
    "consent.scopes.okta.factors.manage.desc": "Allows the app to manage all admin operations for org factors (e.g. activate, deactivate, read).",
    "consent.scopes.okta.factors.read.desc": "Allows the app to read org factors information.",
    "consent.scopes.okta.authenticators.manage.desc": "Allows the app to manage all security methods (e.g. enrollments, reset).",
    "consent.scopes.okta.authenticators.read.desc": "Allows the app to read org security method information.",
    "consent.scopes.okta.authenticators.manage.self.desc": "Allows the app to manage users own security methods (e.g. enrollments, reset).",
    "consent.scopes.idSnapshot.read.desc": "Allows the app to read your identity snapshot attestation.",
    "consent.scopes.idSnapshot.manage.desc": "Allows the app to create and manage your identity snapshot attestation.",
    "logo.for.the.app.alt.text": "Logo for the app",
    "device.code.activate.title": "Activate your device",
    "device.code.activate.subtitle": "Follow the instructions on your device to get an activation code",
    "device.code.activate.label": "Activation Code",
    "device.code.activated.success.title": "Device activated",
    "device.code.activated.error.title": "Device not activated",
    "idx.device.activated": "Follow the instructions on your device for next steps",
    "idx.device.not.activated.consent.denied": "Your device cannot be activated because you did not allow access",
    "idx.device.not.activated.internal.error": "Your device cannot be activated because of an internal error",
    "idx.invalid.device.code": "Invalid code. Try again.",
    "idx.operation.cancelled.on.other.device": "Access denied on other device.",
    "idx.expired.activation.token": "Your account activation link is no longer valid. Request a new activation email below.",
    "idx.missing.activation.token": "This can happen if you have already activated your account, or if the URL you are trying to use is invalid. Contact your administrator for further assistance.",
    "idx.activating.inactive.user": "Your account has been temporarily suspended. Contact your administrator for further assistance.",
    "idx.request.activation.email": "New activation link requested. If your information matches our records, you will receive a new activation link in your inbox soon.",
    "oie.activation.request.email.title.expire": "Activation link has expired",
    "oie.activation.request.email.title.invalid": "Activation link no longer valid",
    "oie.activation.request.email.title.suspended": "Account suspended",
    "oie.activation.request.email.title.submitted": "Request submitted",
    "oie.activation.request.email.button": "Request activation email",
    "oie.browser.error.NotAllowedError": "The operation either timed out or was not allowed.",
    "authfactor.challenge.soft_token.invalid_passcode": "Your code doesn't match our records. Please try again.",
    "authfactor.challenge.soft_token.used_passcode": "Each code can only be used once. Please wait for a new code and try again.",
    "oie.tooManyRequests": "Too many attempts. Try again later.",
    E0000010: $d9da1151f2dab40a$export$4646b3e49fc977de,
    "idx.error.registration.unavailable": "Registration is currently unavailable.",
    "idx.error.user.not.assigned.to.app": "User is not assigned to this application.",
    "idx.error.code.user_not_assigned": "You are not allowed to access this app. To request access, contact an admin.",
    "idx.error.code.access_denied.device_assurance.remediation.title": "Your device doesn't meet the security requirements",
    "idx.error.code.access_denied.device_assurance.remediation.explanation_one_rule": "To sign in, make the following updates. Then, access the app again.",
    "idx.error.code.access_denied.device_assurance.remediation.explanation_multiple_rules": "To sign in, pick an option and make the updates. Then, access the app again.",
    "idx.error.code.access_denied.device_assurance.remediation.option_index": "Option {0}:",
    "idx.error.code.access_denied.device_assurance.remediation.android.upgrade_os_version": "Update to Android {0}",
    "idx.error.code.access_denied.device_assurance.remediation.android.upgrade_os_version.at_least": "Update to at least Android {0}",
    "idx.error.code.access_denied.device_assurance.remediation.android.upgrade_os_version.exactly": "Update to exactly Android {0}",
    "idx.error.code.access_denied.device_assurance.remediation.android.upgrade_os_version.one_of_the_following": "Update to one of the following: Android {0}",
    "idx.error.code.access_denied.device_assurance.remediation.android.upgrade_os_version.exactly_one_of_the_following": "Update to exactly one of the following: Android {0}",
    "idx.error.code.access_denied.device_assurance.remediation.android.device_disk_encrypted": "Encrypt your device",
    "idx.error.code.access_denied.device_assurance.remediation.android.use_lock_screen": "Enable lock screen",
    "idx.error.code.access_denied.device_assurance.remediation.android.use_biometric_lock_screen": "Enable lock screen and biometrics",
    "idx.error.code.access_denied.device_assurance.remediation.ios.upgrade_os_version": "Update to iOS {0}",
    "idx.error.code.access_denied.device_assurance.remediation.ios.upgrade_os_version.at_least": "Update to at least iOS {0}",
    "idx.error.code.access_denied.device_assurance.remediation.ios.upgrade_os_version.exactly": "Update to exactly iOS {0}",
    "idx.error.code.access_denied.device_assurance.remediation.ios.upgrade_os_version.one_of_the_following": "Update to one of the following: iOS {0}",
    "idx.error.code.access_denied.device_assurance.remediation.ios.upgrade_os_version.exactly_one_of_the_following": "Update to exactly one of the following: iOS {0}",
    "idx.error.code.access_denied.device_assurance.remediation.ios.use_lock_screen": "Set a passcode for the lock screen",
    "idx.error.code.access_denied.device_assurance.remediation.ios.use_biometric_lock_screen": "Set a passcode for the lock screen and enable Touch ID or Face ID",
    "idx.error.code.access_denied.device_assurance.remediation.macos.upgrade_os_version": "Update to macOS {0}",
    "idx.error.code.access_denied.device_assurance.remediation.macos.upgrade_os_version.at_least": "Update to at least macOS {0}",
    "idx.error.code.access_denied.device_assurance.remediation.macos.upgrade_os_version.exactly": "Update to exactly macOS {0}",
    "idx.error.code.access_denied.device_assurance.remediation.macos.upgrade_os_version.one_of_the_following": "Update to one of the following: macOS {0}",
    "idx.error.code.access_denied.device_assurance.remediation.macos.upgrade_os_version.exactly_one_of_the_following": "Update to exactly one of the following: macOS {0}",
    "idx.error.code.access_denied.device_assurance.remediation.macos.use_lock_screen": "Set a passcode for the lock screen",
    "idx.error.code.access_denied.device_assurance.remediation.macos.device_disk_encrypted": "Turn on FileVault",
    "idx.error.code.access_denied.device_assurance.remediation.windows.upgrade_os_version": "Update to Windows {0}",
    "idx.error.code.access_denied.device_assurance.remediation.windows.upgrade_os_version.at_least": "Update to at least Windows {0}",
    "idx.error.code.access_denied.device_assurance.remediation.windows.upgrade_os_version.exactly": "Update to exactly Windows {0}",
    "idx.error.code.access_denied.device_assurance.remediation.windows.upgrade_os_version.one_of_the_following": "Update to one of the following: Windows {0}",
    "idx.error.code.access_denied.device_assurance.remediation.windows.upgrade_os_version.exactly_one_of_the_following": "Update to exactly one of the following: Windows {0}",
    "idx.error.code.access_denied.device_assurance.remediation.windows.device_disk_encrypted": "Encrypt all internal disks with BitLocker",
    "idx.error.code.access_denied.device_assurance.remediation.windows.use_biometric_lock_screen": "Enable Windows Hello for the lock screen",
    "idx.error.code.access_denied.device_assurance.remediation.device.must.be.managed": "Use a device managed by your organization",
    "idx.error.code.access_denied.device_assurance.remediation.additional_help_default": "For more information, follow the instructions on <$1>the help page</$1> or contact your administrator for help",
    "idx.error.code.access_denied.device_assurance.remediation.additional_help_custom": "For more information, follow the instructions on <$1>your organization's help page</$1> or contact your administrator for help",
    "idx.error.code.access_denied.device_assurance.remediation.chrome.antivirus": "Enable antivirus software",
    "idx.error.code.access_denied.device_assurance.remediation.chrome.disk_encrypted": "Turn on disk encryption",
    "idx.error.code.access_denied.device_assurance.remediation.chrome.os_firewall": "Turn on your device's firewall",
    "idx.error.code.access_denied.device_assurance.remediation.chrome.screen_lock_secured": "Turn on automatic screen saver and screen locking when idle",
    "idx.error.code.access_denied.device_assurance.remediation.chrome.upgrade_browser_version": "Update Chrome browser to {0}",
    "idx.error.code.access_denied.device_assurance.remediation.chrome.chromeos.upgrade_os_version": "Update to ChromeOS {0}",
    "idx.error.code.access_denied.device_assurance.remediation.chrome.chromeos.key_trust_level.verified_mode": "Switch your device to verified mode",
    "idx.error.code.access_denied.device_assurance.remediation.chrome.chromeos.key_trust_level.developer_mode": "Switch your device to developer mode",
    "idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.play_protect_required": "Please ensure Google Play Protect is enabled and that a scan has been performed, then try accessing this application again",
    "idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.play_protect_scan_threshold": "There is a problem with your Google Play Protect system scan. Please open Google Play and take action on the warnings displayed",
    "idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.version_update_available": "Your device has an OS update available. Please update your device then log in again",
    "idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.disable_usb_debugging": "Turn off USB debugging from Developer Options",
    "idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.lock_screen_complexity": "Your lock screen doesn't meet complexity requirements",
    "idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.disable_network_proxy": "Your device is using a network proxy. Please disable it then try again",
    "idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.unsecured_wifi_network": "Your WiFi network isn't secure. Please disconnect and try again from your phone's mobile cellular connection",
    "idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.android_device_policy_app_required": "Install the Android Device Policy app on this device",
    "idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.android_device_policy_app_required_manual_install": "Go to <$1>Settings in Okta Verify</$1> and follow the instructions to install the Android Device Policy app",
    "idx.error.code.access_denied.device_assurance.remediation.osquery.background_activity_disabled": "Enable background activity for Okta Verify",
    "idx.error.code.access_denied.device_assurance.remediation.osquery.sip_disabled": "Enable System Integrity Protection",
    "idx.error.code.access_denied.device_assurance.remediation.osquery.timeout": "A temporary issue occurred while checking your device. Please try signing in again",
    "idx.error.code.access_denied.device_assurance.remediation.android.caller_context.managed_app": "Use a managed application from the Work Profile",
    "idx.device_assurance.grace_period.title": "Device assurance reminder",
    "idx.device_assurance.grace_period.warning.title.due_by_date": "Your device doesn't meet the security requirements. Fix the issue by {0} to prevent lockout.",
    "idx.device_assurance.grace_period.continue_to_app": "Continue to app",
    "oie.enrollment.policy.grace.period.required.today": "Required today",
    "oie.enrollment.policy.grace.period.required.in.days": "Required in {0} days",
    "oie.enrollment.policy.grace.period.required.in.one.day": "Required in 1 day",
    "oie.enrollment.policy.grace.period.required.in.number.of.skips": "{0} skips remaining",
    "oie.enrollment.policy.grace.period.required.in.one.skip": "1 skip remaining",
    "oie.enrollment.group.choose.n.of": "Choose {0} of:",
    "api.policy.okta.account.management.insufficient.authenticators.unable.to.sign.in": "Unable to sign in. Contact support for assistance.",
    "chrome.lna.fastpass.requires.permission.title": "Okta FastPass requires network permission",
    "chrome.lna.okta-verify.requires.permission.title": "Okta Verify requires network permission",
    "chrome.lna.error.title": "Unable to sign in",
    "chrome.lna.error.description.intro": "The browser is blocking communication with Okta Verify.",
    "chrome.lna.error.description.step1": "Go to your browser's site settings",
    "chrome.lna.error.description.step2": "Find \u201CLocal network access\u201D or \u201CApps on device\u201D",
    "chrome.lna.error.description.step3": "Change the permission from \u201CBlock\u201D to \u201CAllow\u201D and reload this page",
    "chrome.lna.error.description.more.information": "For more information, follow the instructions on the <$1>Local app access</$1> page or contact your administrator for help."
};




/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $e48c043f6d2d382d$export$2e2bcd8739ae039 = {
    API_RATE_LIMIT: 30000,
    //milliseconds
    WIDGET_LOGIN_CONTAINER_ID: 'signin-container',
    WIDGET_CONTAINER_ID: 'okta-sign-in',
    WIDGET_CONFIG_COLORS_ID: 'okta-sign-in-config-colors',
    DIRECTION_BACK: 'DIRECTION_BACK',
    RECOVERY_TYPE_PASSWORD: 'PASSWORD',
    RECOVERY_TYPE_UNLOCK: 'UNLOCK',
    RECOVERY_FACTOR_TYPE_SMS: 'SMS',
    RECOVERY_FACTOR_TYPE_EMAIL: 'EMAIL',
    RECOVERY_FACTOR_TYPE_CALL: 'CALL',
    IOS: 'ios',
    ANDROID: 'android',
    ODA: 'oda',
    MDM: 'mdm',
    WS1: 'ws1',
    // Global success messages
    SUCCESS: 'SUCCESS',
    FORGOT_PASSWORD_EMAIL_SENT: 'FORGOT_PASSWORD_EMAIL_SENT',
    UNLOCK_ACCOUNT_EMAIL_SENT: 'UNLOCK_ACCOUNT_EMAIL_SENT',
    // Global error messages
    CONFIG_ERROR: 'CONFIG_ERROR',
    UNSUPPORTED_BROWSER_ERROR: 'UNSUPPORTED_BROWSER_ERROR',
    OAUTH_ERROR: 'OAUTH_ERROR',
    AUTH_STOP_POLL_INITIATION_ERROR: 'AUTH_STOP_POLL_INITIATION_ERROR',
    U2F_ERROR: 'U2F_ERROR',
    WEB_AUTHN_ERROR: 'WEB_AUTHN_ERROR',
    WEBAUTHN_ABORT_ERROR: 'WEBAUTHN_ABORT_ERROR',
    CONFIGURED_FLOW_ERROR: 'CONFIGURED_FLOW_ERROR',
    CHROME_LOCAL_NETWORK_ACCESS_DENIED_ERROR: 'CHROME_LOCAL_NETWORK_ACCESS_DENIED_ERROR',
    // Enroll choice page types
    ALL_OPTIONAL_NONE_ENROLLED: 'ALL_OPTIONAL_NONE_ENROLLED',
    ALL_OPTIONAL_SOME_ENROLLED: 'ALL_OPTIONAL_SOME_ENROLLED',
    HAS_REQUIRED_NONE_ENROLLED: 'HAS_REQUIRED_NONE_ENROLLED',
    HAS_REQUIRED_SOME_REQUIRED_ENROLLED: 'HAS_REQUIRED_SOME_REQUIRED_ENROLLED',
    HAS_REQUIRED_ALL_REQUIRED_ENROLLED: 'HAS_REQUIRED_ALL_REQUIRED_ENROLLED',
    // Operations
    PRIMARY_AUTH: 'PRIMARY_AUTH',
    FORGOT_PASSWORD: 'FORGOT_PASSWORD',
    UNLOCK_ACCOUNT: 'UNLOCK_ACCOUNT',
    // Auth Types
    SESSION_SSO: 'SESSION_SSO',
    SESSION_STEP_UP: 'SESSION_STEP_UP',
    //Registration
    ACTIVATION_EMAIL_SENT: 'ACTIVATION_EMAIL_SENT',
    REGISTRATION_COMPLETE: 'REGISTRATION_COMPLETE',
    REGISTRATION_FAILED: 'REGISTRATION_FAILED',
    //IDP Discovery
    IDP_DISCOVERY: 'IDP_DISCOVERY',
    //App Store Links
    OKTA_VERIFY_APPLE_APP_STORE_URL: 'https://apps.apple.com/us/app/okta-verify/id490179405',
    OKTA_VERIFY_GOOGLE_PLAY_STORE_URL: 'https://play.google.com/store/apps/details?id=com.okta.android.auth',
    // Device Challenge Method
    LOOPBACK_CHALLENGE: 'LOOPBACK',
    CUSTOM_URI_CHALLENGE: 'CUSTOM_URI',
    UNIVERSAL_LINK_CHALLENGE: 'UNIVERSAL_LINK',
    APP_LINK_CHALLENGE: 'APP_LINK',
    CHROME_DTC: 'CHROME_DTC'
};


/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ class $3fe6932680e7ea64$var$CustomError extends Error {
    constructor(message){
        super(message);
        // 'Error' breaks prototype chain. Need to restore it for ES5.
        // https://github.com/microsoft/TypeScript/wiki/FAQ#why-doesnt-extending-built-ins-like-error-array-and-map-work
        // Note: no need to adjust prototype in subclasses of 'CustomError'.
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class $3fe6932680e7ea64$export$c5fb415882705cf4 extends $3fe6932680e7ea64$var$CustomError {
    constructor(message){
        super(message || (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('error.config'));
        this.name = (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).CONFIG_ERROR;
    }
}
class $3fe6932680e7ea64$export$58cbd1fe407fb242 extends $3fe6932680e7ea64$var$CustomError {
    constructor(message){
        super(message || (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('error.unsupported.browser'));
        this.name = (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).UNSUPPORTED_BROWSER_ERROR;
    }
}
class $3fe6932680e7ea64$export$bdc0f363b754b88f extends $3fe6932680e7ea64$var$CustomError {
    constructor(...args){
        super(...args);
        this.name = (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).OAUTH_ERROR;
    }
}
class $3fe6932680e7ea64$export$c14277b34f51b283 extends $3fe6932680e7ea64$var$CustomError {
    constructor(...args){
        super(...args);
        this.name = (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).REGISTRATION_FAILED;
    }
}
// Thrown when initiation of poll was cancelled.
class $3fe6932680e7ea64$export$57d5450750549f48 extends $3fe6932680e7ea64$var$CustomError {
    constructor(...args){
        super(...args);
        this.name = (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).AUTH_STOP_POLL_INITIATION_ERROR;
    }
}
class $3fe6932680e7ea64$export$846acd7e1702fb3f extends $3fe6932680e7ea64$var$CustomError {
    constructor(err){
        var _err$xhr, _err$xhr$responseJSON;
        super((_err$xhr = err.xhr) === null || _err$xhr === void 0 ? void 0 : (_err$xhr$responseJSON = _err$xhr.responseJSON) === null || _err$xhr$responseJSON === void 0 ? void 0 : _err$xhr$responseJSON.errorSummary);
        this.xhr = void 0;
        this.name = (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).U2F_ERROR;
        this.xhr = err.xhr;
    }
}
class $3fe6932680e7ea64$export$90f0c14a652de832 extends $3fe6932680e7ea64$var$CustomError {
    constructor(err){
        var _err$xhr2, _err$xhr2$responseJSO;
        super((_err$xhr2 = err.xhr) === null || _err$xhr2 === void 0 ? void 0 : (_err$xhr2$responseJSO = _err$xhr2.responseJSON) === null || _err$xhr2$responseJSO === void 0 ? void 0 : _err$xhr2$responseJSO.errorSummary);
        this.xhr = void 0;
        this.name = (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).WEB_AUTHN_ERROR;
        this.xhr = err.xhr;
    }
}
// This is triggered only when code aborts webauthn browser prompt.
class $3fe6932680e7ea64$export$810d59b58d691639 extends $3fe6932680e7ea64$var$CustomError {
    constructor(...args){
        super(...args);
        this.name = (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).WEBAUTHN_ABORT_ERROR;
    }
}
class $3fe6932680e7ea64$export$faf57ee6e26cb1b0 extends $3fe6932680e7ea64$var$CustomError {
    constructor(message, flowSetting){
        super(message);
        this.flowSetting = void 0;
        this.name = (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).CONFIGURED_FLOW_ERROR;
        this.flowSetting = flowSetting;
    }
}
// Triggered when a user denies Local Network Access permission in Chrome, used to monitor LNA denials.
class $3fe6932680e7ea64$export$595ec2a9d48f1ef8 extends $3fe6932680e7ea64$var$CustomError {
    constructor(...args){
        super(...args);
        this.name = (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).CHROME_LOCAL_NETWORK_ACCESS_DENIED_ERROR;
    }
}


/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
const $22893d6dea78fc87$export$2e2bcd8739ae039 = {};
const $22893d6dea78fc87$var$hasFullCorsSupport = 'withCredentials' in new window.XMLHttpRequest();
const $22893d6dea78fc87$var$hasXDomainRequest = typeof window.XDomainRequest !== 'undefined';
$22893d6dea78fc87$export$2e2bcd8739ae039.corsIsNotSupported = function() {
    return !($22893d6dea78fc87$var$hasFullCorsSupport || $22893d6dea78fc87$var$hasXDomainRequest);
};
$22893d6dea78fc87$export$2e2bcd8739ae039.corsIsNotEnabled = function(jqXhr) {
    // Not a definitive check, but it's the best we've got.
    // Note: This will change when OktaAuth is updated
    return jqXhr.status === 0;
};
// This is currently not being used, but we'll keep it around for when we
// want a fallback mechanism - i.e. use localStorage if it exists, else fall
// back to cookies.
$22893d6dea78fc87$export$2e2bcd8739ae039.localStorageIsNotSupported = function() {
    const test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return false;
    } catch (e) {
        return true;
    }
};
$22893d6dea78fc87$export$2e2bcd8739ae039.supportsPushState = function(win) {
    win = win || window;
    return !!(win.history && win.history.pushState);
};
$22893d6dea78fc87$export$2e2bcd8739ae039.isIE = function() {
    return /(msie|trident)/i.test(navigator.userAgent);
};
$22893d6dea78fc87$export$2e2bcd8739ae039.isFirefox = function() {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
};
$22893d6dea78fc87$export$2e2bcd8739ae039.isEdge = function() {
    // This is to just check for windows edge. Mac edge - chromium based's UA is 'edg'.
    return navigator.userAgent.toLowerCase().indexOf('edge') > -1;
};
$22893d6dea78fc87$export$2e2bcd8739ae039.isSafari = function() {
    // Chrome has safari in its useragent string so adding this extra check.
    return navigator.userAgent.toLowerCase().indexOf('safari') > -1 && navigator.userAgent.toLowerCase().indexOf('chrome') === -1;
};
$22893d6dea78fc87$export$2e2bcd8739ae039.isMac = function() {
    return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
};
$22893d6dea78fc87$export$2e2bcd8739ae039.isAndroid = function() {
    // Windows Phone also contains "Android"
    return /android/i.test(navigator.userAgent) && !/windows phone/i.test(navigator.userAgent);
};
$22893d6dea78fc87$export$2e2bcd8739ae039.isIOS = function() {
    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};
/* eslint-disable compat/compat */ $22893d6dea78fc87$export$2e2bcd8739ae039.getChromeLNAPermissionState = async function(handlePermissionState) {
    if (!navigator.permissions || typeof navigator.permissions.query !== 'function') {
        handlePermissionState(undefined);
        return;
    }
    try {
        let result;
        try {
            // Query for the new granular `loopback-network` permission only available on Chromium 145+
            result = await navigator.permissions.query({
                name: 'loopback-network'
            });
        } catch (e) {
            // Fallback to the legacy `local-network-access` aggregate permission on < Chromium 145
            result = await navigator.permissions.query({
                name: 'local-network-access'
            });
        }
        handlePermissionState(result.state);
    } catch (error) {
        if (error instanceof (0, $3fe6932680e7ea64$export$595ec2a9d48f1ef8)) throw error; // Rethrow custom Chrome LNA denied error so Sentry can capture it for monitoring
        // Fallback if queries fail or browser blocks the API entirely
        handlePermissionState(undefined);
    }
};
/* eslint-enable compat/compat */ // Returns a list of languages the user has configured for their browser, in
// order of preference.
$22893d6dea78fc87$export$2e2bcd8739ae039.getUserLanguages = function() {
    // Chrome, Firefox
    if (navigator.languages) return [
        ...navigator.languages
    ];
    const languages = [];
    const properties = [
        'language',
        // Safari, IE11
        'userLanguage',
        // IE
        'browserLanguage',
        // IE
        'systemLanguage' // IE
    ];
    properties.forEach(function(property) {
        if (navigator[property]) languages.push(navigator[property]);
    });
    return languages;
};


/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $c95ce7ada2e60396$var$log(level, args) {
    var _window, _window$OktaSignInDeb, _window$OktaSignInDeb2;
    // Only log statements in development mode
    //  or if throwing an error through console.error
    //  or if debugger is enabled
    if (level === 'error' || (_window = window) !== null && _window !== void 0 && (_window$OktaSignInDeb = _window.OktaSignInDebug) !== null && _window$OktaSignInDeb !== void 0 && (_window$OktaSignInDeb2 = _window$OktaSignInDeb.isEnabled) !== null && _window$OktaSignInDeb2 !== void 0 && _window$OktaSignInDeb2.call(_window$OktaSignInDeb)) window.console[level].apply(window.console, args);
}
/**
 * Utility library of logging functions.
 */ var $c95ce7ada2e60396$export$2e2bcd8739ae039 = {
    trace: function() {
        return $c95ce7ada2e60396$var$log('trace', arguments);
    },
    dir: function() {
        return $c95ce7ada2e60396$var$log('dir', arguments);
    },
    time: function() {
        return $c95ce7ada2e60396$var$log('time', arguments);
    },
    timeEnd: function() {
        return $c95ce7ada2e60396$var$log('timeEnd', arguments);
    },
    group: function() {
        return $c95ce7ada2e60396$var$log('group', arguments);
    },
    groupEnd: function() {
        return $c95ce7ada2e60396$var$log('groupEnd', arguments);
    },
    assert: function() {
        return $c95ce7ada2e60396$var$log('assert', arguments);
    },
    log: function() {
        return $c95ce7ada2e60396$var$log('log', arguments);
    },
    info: function() {
        return $c95ce7ada2e60396$var$log('info', arguments);
    },
    warn: function() {
        return $c95ce7ada2e60396$var$log('warn', arguments);
    },
    error: function() {
        return $c95ce7ada2e60396$var$log('error', arguments);
    },
    deprecate: function(msg) {
        return $c95ce7ada2e60396$var$log('warn', [
            '[okta-signin-widget] DEPRECATED:',
            msg
        ]);
    }
};


/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $ae370136150d080c$var$STORAGE_KEY = 'osw.languages';
/**
 * Converts options to our internal format, which distinguishes between
 * login and country bundles.
 *
 * Example options.i18n passed in by the developer:
 * {
 *   'en': {
 *     'needhelp': 'need help override',
 *     'primaryauth.title': 'new sign in text',
 *     'country.JP' = 'Japan, Japan'
 *   }
 * }
 *
 * Parsed:
 * {
 *  'en': {
 *    'login': {
 *      'needhelp': 'need help override',
 *      'primaryauth.title': 'new sign in text',
 *    },
 *    'country': {
 *      'JP': 'Japan, Japan'
 *    }
 *  }
 * }
 */ function $ae370136150d080c$var$parseOverrides(i18n) {
    if (!i18n) return {};
    const i18nWithLowerCaseKeys = {};
    (0, $187365f460a6e3ed$export$2e2bcd8739ae039).each((0, $187365f460a6e3ed$export$2e2bcd8739ae039).keys(i18n), function(key) {
        i18nWithLowerCaseKeys[key.toLowerCase()] = i18n[key];
    });
    return (0, $187365f460a6e3ed$export$2e2bcd8739ae039).mapObject(i18nWithLowerCaseKeys, function(props) {
        const mapped = {
            login: {},
            country: {}
        };
        if (!(0, $187365f460a6e3ed$export$2e2bcd8739ae039).isObject(props)) throw new Error('Invalid format for "i18n"');
        (0, $187365f460a6e3ed$export$2e2bcd8739ae039).each(props, function(val, key) {
            const split = key.split(/^country\./);
            if (split.length > 1) mapped.country[split[1]] = val;
            else mapped.login[split[0]] = val;
        });
        return mapped;
    });
}
// Caching: We only bundle English by default in the Sign-In Widget. Other
// languages are loaded on demand and cached in localStorage. These languages
// are tied to the version of the widget - when it bumps, we reset the cache.
function $ae370136150d080c$var$getCachedLanguages() {
    let storage = JSON.parse(localStorage.getItem($ae370136150d080c$var$STORAGE_KEY));
    if (!storage || storage.version !== (0, $9ab2e0ac5722e186$export$2e2bcd8739ae039).version) storage = {
        version: (0, $9ab2e0ac5722e186$export$2e2bcd8739ae039).version
    };
    return storage;
}
function $ae370136150d080c$var$addLanguageToCache(language, loginJson, countryJson) {
    const current = $ae370136150d080c$var$getCachedLanguages();
    current[language] = {
        login: loginJson,
        country: countryJson
    };
    localStorage.setItem($ae370136150d080c$var$STORAGE_KEY, JSON.stringify(current));
}
// By default, the assets.bundleUrl is tied to the Okta CDN.
//
// There are two overrides available for modifying where we load the asset
// bundles from:
//
// 1. assets.baseUrl
//
//    This is the base path the OSW pulls assets from, which in this case is
//    the Okta CDN. Override this config option if you want to host the
//    files on your own domain, or if you're using a new version of the
//    widget whose language files haven't been published to the CDN yet.
//
// 2. assets.rewrite
//
//    This is a function that can be used to modify the path + fileName of
//    the bundle we're loading, relative to the baseUrl. When called, it
//    will pass the current path, and expect the new path to be returned.
//    This is useful, for example, if your build process has an extra
//    cachebusting step, i.e:
//
//    function rewrite(file) {
//      // file: /labels/json/login_ja.json
//      return file.replace('.json', '.' + md5file(file) + '.json');
//    }
//
// Note: Most developers will not need to use these overrides - the default
// is to use the Okta CDN and to use the same path + file structure the
// widget module publishes by default.
function $ae370136150d080c$var$fetchJson(bundle, language, assets) {
    // Our bundles use _ to separate country and region, i.e:
    // zh-CN -> zh_CN
    const languageCode = language.replace('-', '_');
    const path = assets.rewrite(encodeURI(`/labels/json/${bundle}_${languageCode}.json`));
    const headers = {
        Accept: 'application/json'
    };
    // Specify `mode: 'cors'` explicitly.
    //
    // Browsers allow specific types of requests to considered "simple" requests,
    // even if we set `mode: 'no-cors'` and event if the request header `Content-Type` is
    // set to `'text/plain'` for a GET request. This allows the normally opaque response
    // to be readable when it would otherwise not be able to _as long as_ the server sends
    // `Access-Control-Allow-Origin: *` (or a list that includes the origin of the document).
    //
    // On localhost, special browser security rules seem to disallow reading the response
    // even under the above conditions when 'mode: 'no-cors'` is set. This means that we need
    // to explicitly set the `mode` to `cors` in order to get a readable response.
    //
    // We are always actually making a CORS request anyways, so explicitly setting the mode
    // to `cors` should not have any negative impact and is actually just a more accurate
    // representation of what is happening.
    const mode = 'cors';
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZxP0)))(assets.baseUrl + path, {
        method: 'GET',
        headers: headers,
        mode: mode
    }).then((res)=>res.text()).then((txt)=>JSON.parse(txt));
}
async function $ae370136150d080c$var$getBundles(language, assets, supportedLanguages) {
    // Two special cases:
    // 1. Default language is already bundled with the widget
    // 2. If the language is not in our config file, it means that they've
    //    probably defined it on their own.
    if (language === (0, $9ab2e0ac5722e186$export$2e2bcd8739ae039).defaultLanguage || !(0, $187365f460a6e3ed$export$2e2bcd8739ae039).contains(supportedLanguages, language)) return {};
    //local storage does not work correctly with android web views (embeded browers)
    //so skip the caching and just make the request to get the local info
    const localStorageIsSupported = !(0, $22893d6dea78fc87$export$2e2bcd8739ae039).localStorageIsNotSupported();
    if (localStorageIsSupported) {
        const cached = $ae370136150d080c$var$getCachedLanguages();
        if (cached[language]) return cached[language];
    }
    try {
        const [loginJson, countryJson] = await Promise.all([
            $ae370136150d080c$var$fetchJson('login', language, assets),
            $ae370136150d080c$var$fetchJson('country', language, assets)
        ]);
        if (localStorageIsSupported) $ae370136150d080c$var$addLanguageToCache(language, loginJson, countryJson);
        return {
            login: loginJson,
            country: countryJson
        };
    } catch (_e) {
        // If there is an error, this will default to the bundled language and
        // we will no longer try to load the language this session.
        (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).warn('Unable to load language: ' + language);
        return {};
    }
}
var $ae370136150d080c$export$2e2bcd8739ae039 = {
    login: (0, $d9da1151f2dab40a$export$2e2bcd8739ae039),
    country: (0, $a955fad7595f7a80$export$2e2bcd8739ae039),
    // Courage components within the sign in widget point to courage bundle to look
    // up i18nkeys. Since we dont have courage.properties inside the sign in widget
    // we are pointing courage bundle to login.
    courage: (0, $d9da1151f2dab40a$export$2e2bcd8739ae039),
    currentLanguage: null,
    isLoaded: function(language) {
        return this.currentLanguage === language;
    },
    remove: function() {
        this.currentLanguage = null;
    },
    loadLanguage: async function(language, overrides, assets, supportedLanguages) {
        const parsedOverrides = $ae370136150d080c$var$parseOverrides(overrides);
        const lowerCaseLanguage = language.toLowerCase();
        const bundles = await $ae370136150d080c$var$getBundles(language, assets, supportedLanguages);
        // Always extend from the built in defaults in the event that some
        // properties are not translated
        this.login = (0, $187365f460a6e3ed$export$2e2bcd8739ae039).extend({}, (0, $d9da1151f2dab40a$export$2e2bcd8739ae039), bundles.login);
        this.country = (0, $187365f460a6e3ed$export$2e2bcd8739ae039).extend({}, (0, $a955fad7595f7a80$export$2e2bcd8739ae039), bundles.country);
        this.courage = (0, $187365f460a6e3ed$export$2e2bcd8739ae039).extend({}, (0, $d9da1151f2dab40a$export$2e2bcd8739ae039), bundles.login);
        if (parsedOverrides[lowerCaseLanguage]) {
            (0, $187365f460a6e3ed$export$2e2bcd8739ae039).extend(this.login, parsedOverrides[lowerCaseLanguage]['login']);
            (0, $187365f460a6e3ed$export$2e2bcd8739ae039).extend(this.country, parsedOverrides[lowerCaseLanguage]['country']);
            (0, $187365f460a6e3ed$export$2e2bcd8739ae039).extend(this.courage, parsedOverrides[lowerCaseLanguage]['login']);
        }
        this.currentLanguage = language;
    }
};


/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ /**
 * Checks whether a translation for key exists in the bundle
 * @param  {String} key The key
 * @param  {String} [bundle="login"] The name of the i18n bundle. Defaults to "login".
 * @return {Boolean}
 */ const $27511669ac136cf6$export$46c4402413f2d675 = (key, bundleName = 'login')=>{
    const bundle = $27511669ac136cf6$var$getBundle(bundleName);
    return !!(bundle !== null && bundle !== void 0 && bundle[key]);
};
/**
 * Translate a key to the localized value
 * @param  {String} key The key
 * @param  {String} [bundle="login"] The name of the i18n bundle. Defaults to "login".
 * @param  {Array} [params] A list of parameters to apply as tokens to the i18n value
 * @param  {Boolean} [ignoreIncorrectParams] If true, a custom 'okta-i18n-error' event would not be dispatched
 * @return {String} The localized value
 */ const $27511669ac136cf6$export$ebcbd32ce8d4cff = function(key, bundleName = 'login', params = [], ignoreIncorrectParams = false) {
    const bundle = $27511669ac136cf6$var$getBundle(bundleName);
    /* eslint complexity: [2, 7] */ if (!bundle) {
        $27511669ac136cf6$var$emitL10nError(key, bundleName, 'bundle');
        return 'L10N_ERROR[' + bundleName + ']';
    }
    let value = bundle[key];
    try {
        params = params && params.slice ? params.slice(0) : [];
        value = $27511669ac136cf6$var$sprintf(value, params);
        if (value) return value;
        else {
            $27511669ac136cf6$var$emitL10nError(key, bundleName, 'key');
            return 'L10N_ERROR[' + key + ']';
        }
    } catch (e) {
        if (!ignoreIncorrectParams) $27511669ac136cf6$var$emitL10nError(key, bundleName, 'parameters');
        return 'L10N_ERROR[' + key + ']';
    }
};
/**
* Converts the locale code identifier from "${languageCode}-${countryCode}" to "${languageCode}_${countryCode}"
* Follows the ISO-639-1 language code and 2-letter ISO-3166-1-alpha-2 country code structure.
* @param {String} locale code identifier
* @return {String} converted locale code identifier
*/ const $27511669ac136cf6$var$parseLocale = (locale)=>{
    if (/-/.test(locale)) {
        const parts = locale.split('-');
        parts[1] = parts[1].toUpperCase();
        return parts.join('_');
    }
    return locale;
};
/**
 * Returns the language bundle based on the current locale.
 * - If a locale is not provided, default to English ('en')
 * - Legacy Support: If the named language bundle does not exist, fall back to the default named bundle.
 *
 * @param {*} bundleName
 */ function $27511669ac136cf6$var$getBundle(bundleName) {
    if (!bundleName) {
        const key = Object.keys((0, $ae370136150d080c$export$2e2bcd8739ae039)).filter((k)=>typeof k === 'object')[0];
        return (0, $ae370136150d080c$export$2e2bcd8739ae039)[key];
    }
    const locale = $27511669ac136cf6$var$parseLocale($27511669ac136cf6$var$getRawLocale());
    return (0, $ae370136150d080c$export$2e2bcd8739ae039)[`${bundleName}_${locale}`] || (0, $ae370136150d080c$export$2e2bcd8739ae039)[bundleName];
}
/**
 * Returns the user's locale as defined by window.okta.locale
 */ function $27511669ac136cf6$var$getRawLocale() {
    var _window, _window$okta;
    return ((_window = window) === null || _window === void 0 ? void 0 : (_window$okta = _window.okta) === null || _window$okta === void 0 ? void 0 : _window$okta.locale) || 'en';
}
/**
 * Dispatch custom 'okta-i18n-error' event
 * @param {String} key The i18n key
 * @param {String} bundleName The i18n bundle name
 * @param {String} reason Could be 'bundle' (Bundle not found), 'key' (Key not found) or 'parameters' (Parameters mismatch).
 */ function $27511669ac136cf6$var$emitL10nError(key, bundleName, reason) {
    const event = $27511669ac136cf6$var$createCustomEvent('okta-i18n-error', {
        detail: {
            type: 'l10n-error',
            key: key,
            bundleName: bundleName,
            reason: reason
        }
    });
    if (event) document.dispatchEvent(event);
}
const $27511669ac136cf6$var$createCustomEvent = function(event, params) {
    if (typeof window.CustomEvent === 'function') return new CustomEvent(event, params);
    else if (!window.CustomEvent) {
        /**
     * CustomEvent polyfill for IE
     * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#polyfill
     */ params = params || {
            bubbles: false,
            cancelable: false,
            detail: null
        };
        const evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }
};
/**
 * Format tempalte string with parameters
 * @param {String} value Template string, eg. "Reset via {0}"
 * @param  {Array} [params] A list of parameters to apply as tokens to the template string, eg. ["SMS"]
 * @return {String} Formatted string value, eg. "Reset via SMS"
 */ function $27511669ac136cf6$var$sprintf(value, params) {
    /* eslint max-statements: [2, 15] */ function triggerError() {
        throw new Error('Mismatch number of variables: ' + value + ', ' + JSON.stringify(params));
    }
    let oldValue = value, newValue = value;
    for(let i = 0, l = params.length; i < l; i++){
        const entity = String(params[i]);
        const regex = new RegExp('\\{' + i + '\\}', 'g');
        newValue = newValue.replace(regex, entity);
        if (entity === undefined || entity === null || newValue === oldValue) triggerError();
        oldValue = newValue;
    }
    if (/\{[\d+]\}/.test(newValue)) triggerError();
    return newValue;
}





/* eslint-disable max-statements */ const $e10ed35bf8cfc4ab$export$2e2bcd8739ae039 = {};
const $e10ed35bf8cfc4ab$var$buildInputForParameter = function(name, value) {
    const input = document.createElement('input');
    input.name = name;
    input.value = decodeURIComponent(value);
    input.type = 'hidden';
    return input;
};
const $e10ed35bf8cfc4ab$var$buildSubmitInput = function() {
    const input = document.createElement('input');
    input.type = 'submit';
    return input;
};
const $e10ed35bf8cfc4ab$var$buildDynamicForm = function(url = '', method) {
    const splitOnFragment = url.split('#');
    const fragment = splitOnFragment[1];
    const splitOnQuery = (splitOnFragment[0] || '').split('?');
    const query = splitOnQuery[1];
    let targetUrl = splitOnQuery[0];
    if (fragment) targetUrl += '#' + fragment;
    const form = document.createElement('form');
    form.method = method;
    form.style.display = 'none';
    form.action = targetUrl;
    if (query && query.length) {
        const queryParts = query.split('&');
        queryParts.forEach((queryPart)=>{
            const parameterParts = queryPart.split('=');
            const input = $e10ed35bf8cfc4ab$var$buildInputForParameter(parameterParts[0], parameterParts[1]);
            form.appendChild(input);
        });
    }
    form.appendChild($e10ed35bf8cfc4ab$var$buildSubmitInput());
    return form;
};
// eslint-disable-next-line complexity
$e10ed35bf8cfc4ab$export$2e2bcd8739ae039.transformErrorXHR = function(xhr) {
    // Handle network connection error
    if (xhr.status === 0 && (0, $187365f460a6e3ed$export$2e2bcd8739ae039).isEmpty(xhr.responseJSON)) {
        xhr.responseJSON = {
            errorSummary: (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('error.network.connection', 'login')
        };
        return xhr;
    }
    if (!xhr.responseJSON) {
        if (!xhr.responseText) {
            // Empty server response
            xhr.responseJSON = {
                errorSummary: (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('error.unsupported.response', 'login')
            };
            return xhr;
        }
        if (typeof xhr.responseText === 'string') try {
            xhr.responseJSON = JSON.parse(xhr.responseText);
        } catch (e) {
            // Malformed server response
            xhr.responseJSON = {
                errorSummary: (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('error.unsupported.response', 'login')
            };
            return xhr;
        }
        else if (typeof xhr.responseText === 'object') xhr.responseJSON = xhr.responseText;
    }
    // Temporary solution to display field errors
    // Assuming there is only one field error in a response
    if (xhr.responseJSON && xhr.responseJSON.errorCauses && xhr.responseJSON.errorCauses.length) xhr.responseJSON.errorSummary = xhr.responseJSON.errorCauses[0].errorSummary;
    // Replace error messages
    if (!(0, $187365f460a6e3ed$export$2e2bcd8739ae039).isEmpty(xhr.responseJSON)) {
        const { errorCode: errorCode } = xhr.responseJSON;
        const errorMsg = errorCode && (0, $27511669ac136cf6$export$46c4402413f2d675)('errors.' + errorCode, 'login') ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('errors.' + errorCode, 'login', [], true) : undefined;
        if ((errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.indexOf('L10N_ERROR[')) === -1) {
            xhr.responseJSON.errorSummary = errorMsg;
            if (xhr.responseJSON && xhr.responseJSON.errorCauses && xhr.responseJSON.errorCauses.length) // BaseForm will consume errorCauses before errorSummary if it is an array,
            // so, we have to make sure to remove it when we have a valid error code
            delete xhr.responseJSON.errorCauses;
        }
    }
    return xhr;
};
// Simple helper function to lowercase all strings in the given array
$e10ed35bf8cfc4ab$export$2e2bcd8739ae039.toLower = function(strings) {
    return (0, $187365f460a6e3ed$export$2e2bcd8739ae039).map(strings, function(str) {
        return str.toLowerCase();
    });
};
// A languageCode can be composed of multiple parts, i.e:
// {{language}}-{{region}}-{{dialect}}
//
// In these cases, it's necessary to generate a list of other possible
// combinations that we might support (in preferred order).
//
// For example:
// en-US -> [en-US, en]
// de-DE-bavarian -> [de-DE-bavarian, de-DE, de]
function $e10ed35bf8cfc4ab$var$expandLanguage(language) {
    const expanded = [
        language
    ];
    const parts = language.split('-');
    while(parts.pop() && parts.length > 0)expanded.push(parts.join('-'));
    return expanded;
}
// Following the rules of expanding one language, this will generate
// all potential languages in the given order (where higher priority is
// given to expanded languages over other downstream languages).
$e10ed35bf8cfc4ab$export$2e2bcd8739ae039.expandLanguages = function(languages) {
    return (0, $187365f460a6e3ed$export$2e2bcd8739ae039).chain(languages).map($e10ed35bf8cfc4ab$var$expandLanguage).flatten().uniq().value();
};
//helper to call setTimeout
$e10ed35bf8cfc4ab$export$2e2bcd8739ae039.callAfterTimeout = function(callback, time) {
    return setTimeout(callback, time);
};
// Invokes the callback after a delay, if the window remains in focus
// If the window becomes unfocused, the callback execution is delayed until
// focus has been returned to the window
$e10ed35bf8cfc4ab$export$2e2bcd8739ae039.callAfterTimeoutOrWindowRefocus = function(callback, time, delayAfterRefocus = false) {
    let timeoutId;
    let visHandler;
    const invokeCallbackFn = ()=>{
        document.removeEventListener('visibilitychange', visHandler);
        if (!delayAfterRefocus) return callback();
        setTimeout(callback, time);
    };
    visHandler = ()=>{
        if (document.hidden) clearTimeout(timeoutId);
        else invokeCallbackFn();
    };
    document.addEventListener('visibilitychange', visHandler);
    timeoutId = setTimeout(invokeCallbackFn, time);
    // returns a "cancel" function, so the execution of the callback can be prevented
    return ()=>{
        clearTimeout(timeoutId);
        document.removeEventListener('visibilitychange', visHandler);
    };
};
// Helper function to provide consistent formatting of template literals
// that are logged when in development mode.
$e10ed35bf8cfc4ab$export$2e2bcd8739ae039.debugMessage = function(message) {
    (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).warn(`\n${message.replace(/^(\s)+/gm, '')}`);
};
$e10ed35bf8cfc4ab$export$2e2bcd8739ae039.logConsoleError = function(message) {
    (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).error(message);
};
// Trigger an afterError event
$e10ed35bf8cfc4ab$export$2e2bcd8739ae039.triggerAfterError = function(controller, err = {}) {
    if (!err.statusCode && err.xhr && err.xhr.status) // Bring the statusCode to the top-level of the Error
    err.statusCode = err.xhr.status;
    // Some controllers return the className as a function - process it here:
    const className = (0, $187365f460a6e3ed$export$2e2bcd8739ae039).isFunction(controller.className) ? controller.className() : controller.className;
    const error = (0, $187365f460a6e3ed$export$2e2bcd8739ae039).pick(err, 'name', 'message', 'statusCode', 'xhr');
    controller.trigger('afterError', {
        controller: className
    }, error);
    // Logs to console only in dev mode
    (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).warn('controller: ' + className + ', error: ' + error);
};
$e10ed35bf8cfc4ab$export$2e2bcd8739ae039.redirect = function(url, win = window, isAppLink = false) {
    if ((0, $22893d6dea78fc87$export$2e2bcd8739ae039).isAndroid() && !isAppLink) $e10ed35bf8cfc4ab$export$2e2bcd8739ae039.redirectWithFormGet(url);
    else $e10ed35bf8cfc4ab$export$2e2bcd8739ae039.changeLocation(url, win);
};
$e10ed35bf8cfc4ab$export$2e2bcd8739ae039.changeLocation = function(url, win = window) {
    if (!url) {
        (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).error(`Cannot redirect to empty URL: (${url})`);
        return;
    }
    win.location.href = url;
};
$e10ed35bf8cfc4ab$export$2e2bcd8739ae039.executeOnVisiblePage = function(cb) {
    if (document.visibilityState === 'hidden') {
        const visibilityChangeHandler = ()=>{
            if (document.visibilityState === 'visible') {
                document.removeEventListener('visibilitychange', visibilityChangeHandler);
                cb();
            }
        };
        document.addEventListener('visibilitychange', visibilityChangeHandler);
    } else cb();
};
// OKTA-1182955: backend may attach a priorVerification descriptor to the success-redirect remediation
// indicating the prior step was a successful Android AppLink (FastPass) verification. In that case the
// SIW must not auto-redirect — the page can be `visible` before the window has regained focus and the
// redirect lands on login.okta.com. The view renders a button instead; the user click guarantees focus
// before the redirect fires.
$e10ed35bf8cfc4ab$export$2e2bcd8739ae039.isPostAppLinkVerification = function(viewStateOrLink) {
    const pv = viewStateOrLink && viewStateOrLink.priorVerification;
    return !!pv && pv.method === 'APP_LINK' && pv.success === true;
};
/**
 * Why redirect via Form get rather using `window.location.href`?
 * At the time of writing, Chrome (<72) in Android would block window location change
 * at following case
 * 1. An AJAX is trigger because of user action.
 * 2. 5+ seconds passed without any further user interaction.
 * 3. User takes an action results in window location change.
 *
 * Luckily we discovered that uses Form submit would work around this problem
 * even though it changed window location.
 *
 * Check the commit history for more details.
 */ $e10ed35bf8cfc4ab$export$2e2bcd8739ae039.redirectWithFormGet = function(url) {
    $e10ed35bf8cfc4ab$export$2e2bcd8739ae039.redirectWithForm(url, 'get');
};
/**
 * Ensure the redirect form is only submitted once in case the method is
 * is invoked multiple times before the page navigation occurs.
 *
 * This singleton serves as a mutex to be used only by `Util.redirectWithForm`.
 */ {
    // Enclose the variable in a closure to prevent direct external access.
    let redirectWithFormLock = false;
    $e10ed35bf8cfc4ab$export$2e2bcd8739ae039.getRedirectWithFormLock = function() {
        return redirectWithFormLock;
    };
    // Intentionally do not provide a way to release the lock.
    // There's no need to release the lock later because the page should
    // be unloaded after the form is submitted.
    $e10ed35bf8cfc4ab$export$2e2bcd8739ae039.setRedirectWithFormLock = function() {
        redirectWithFormLock = true;
    };
}$e10ed35bf8cfc4ab$export$2e2bcd8739ae039.redirectWithForm = function(url, method = 'post') {
    if (!url) {
        (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).error(`Cannot redirect to empty URL: (${url})`);
        return;
    }
    if ($e10ed35bf8cfc4ab$export$2e2bcd8739ae039.getRedirectWithFormLock() === true) {
        (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).error('Cannot redirect with form, already in progress');
        return;
    }
    const mainContainer = document.getElementById((0, $e48c043f6d2d382d$export$2e2bcd8739ae039).WIDGET_CONTAINER_ID);
    if (!mainContainer) {
        (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).error('Cannot find okta-sign-in container append to which a form');
        return;
    }
    // Set the lock as we are now about to submit the form.
    $e10ed35bf8cfc4ab$export$2e2bcd8739ae039.setRedirectWithFormLock();
    const form = $e10ed35bf8cfc4ab$var$buildDynamicForm(url, method);
    mainContainer.appendChild(form);
    form.querySelector('input[type="submit"]').click();
};
/**
 * When we want to show an explain text, we need to check if this is different from
 * the label text, to not have an explain that look like a duplicated label.
 * okta-signin-widget gives the possibility to customize every i18n, so we cannot
 * know ahead if these two are equal or different, we need to call this function everytime.
 */ $e10ed35bf8cfc4ab$export$2e2bcd8739ae039.createInputExplain = function(explainKey, labelKey, bundleName, explainParams, labelParams) {
    const explain = explainParams ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)(explainKey, bundleName, explainParams) : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)(explainKey, bundleName);
    const label = labelParams ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)(labelKey, bundleName, labelParams) : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)(labelKey, bundleName);
    if (explain === label) return false;
    return explain;
};
$e10ed35bf8cfc4ab$export$2e2bcd8739ae039.isV1StateToken = function(token) {
    return !!(token && (0, $187365f460a6e3ed$export$2e2bcd8739ae039).isString(token) && token.startsWith('00'));
};
$e10ed35bf8cfc4ab$export$2e2bcd8739ae039.getAutocompleteValue = function(settings, defaultValue) {
    const shouldDisableAutocomplete = settings === null || settings === void 0 ? void 0 : settings.get('features.disableAutocomplete');
    if (shouldDisableAutocomplete) return 'off';
    return defaultValue;
};
/**
 * Equivalent of `new URLSearchParams(params).toString()` with broadest browser support.
 * Does not include params with nullish values.
 */ $e10ed35bf8cfc4ab$export$2e2bcd8739ae039.searchParamsToString = function(params) {
    return Object.keys(params).filter((key)=>{
        const val = params[key];
        return val !== undefined && val !== null;
    }).map((key)=>{
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
};



var $bada51c9203af1df$export$dda1d9f60106f0e9 = {
    exports: {}
};


var $237ee74882543fb6$export$362abb7de8d8bb41 = {};


var $0a99dcdc4fa35da4$export$362abb7de8d8bb41 = {};


(0, $0a99dcdc4fa35da4$export$362abb7de8d8bb41).__esModule = true;
(0, $0a99dcdc4fa35da4$export$362abb7de8d8bb41).extend = $e5159421f8ee73ec$var$extend;
(0, $0a99dcdc4fa35da4$export$362abb7de8d8bb41).indexOf = $e5159421f8ee73ec$var$indexOf;
(0, $0a99dcdc4fa35da4$export$362abb7de8d8bb41).escapeExpression = $e5159421f8ee73ec$var$escapeExpression;
(0, $0a99dcdc4fa35da4$export$362abb7de8d8bb41).isEmpty = $e5159421f8ee73ec$var$isEmpty;
(0, $0a99dcdc4fa35da4$export$362abb7de8d8bb41).createFrame = $e5159421f8ee73ec$var$createFrame;
(0, $0a99dcdc4fa35da4$export$362abb7de8d8bb41).blockParams = $e5159421f8ee73ec$var$blockParams;
(0, $0a99dcdc4fa35da4$export$362abb7de8d8bb41).appendContextPath = $e5159421f8ee73ec$var$appendContextPath;
var $e5159421f8ee73ec$var$escape = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;',
    '=': '&#x3D;'
};
var $e5159421f8ee73ec$var$badChars = /[&<>"'`=]/g, $e5159421f8ee73ec$var$possible = /[&<>"'`=]/;
function $e5159421f8ee73ec$var$escapeChar(chr) {
    return $e5159421f8ee73ec$var$escape[chr];
}
function $e5159421f8ee73ec$var$extend(obj) {
    for(var i = 1; i < arguments.length; i++){
        for(var key in arguments[i])if (Object.prototype.hasOwnProperty.call(arguments[i], key)) obj[key] = arguments[i][key];
    }
    return obj;
}
var $e5159421f8ee73ec$var$toString = Object.prototype.toString;
(0, $0a99dcdc4fa35da4$export$362abb7de8d8bb41).toString = $e5159421f8ee73ec$var$toString; // Sourced from lodash
// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
/* eslint-disable func-style */ var $e5159421f8ee73ec$var$isFunction = function isFunction(value) {
    return typeof value === 'function';
}; // fallback for older versions of Chrome and Safari
/* istanbul ignore next */ if ($e5159421f8ee73ec$var$isFunction(/x/)) (0, $0a99dcdc4fa35da4$export$362abb7de8d8bb41).isFunction = $e5159421f8ee73ec$var$isFunction = function(value) {
    return typeof value === 'function' && $e5159421f8ee73ec$var$toString.call(value) === '[object Function]';
};
(0, $0a99dcdc4fa35da4$export$362abb7de8d8bb41).isFunction = $e5159421f8ee73ec$var$isFunction;
/* eslint-enable func-style */ /* istanbul ignore next */ var $e5159421f8ee73ec$var$isArray = Array.isArray || function(value) {
    return value && typeof value === 'object' ? $e5159421f8ee73ec$var$toString.call(value) === '[object Array]' : false;
};
(0, $0a99dcdc4fa35da4$export$362abb7de8d8bb41).isArray = $e5159421f8ee73ec$var$isArray; // Older IE versions do not directly support indexOf so we must implement our own, sadly.
function $e5159421f8ee73ec$var$indexOf(array, value) {
    for(var i = 0, len = array.length; i < len; i++){
        if (array[i] === value) return i;
    }
    return -1;
}
function $e5159421f8ee73ec$var$escapeExpression(string) {
    if (typeof string !== 'string') {
        // don't escape SafeStrings, since they're already safe. Other values with a
        // "toHTML" key, e.g. from JSON context data, are escaped like any object.
        if (string && typeof string.toHTML === 'function') return string.toHTML();
        else if (string == null) return '';
        else if (!string) return string + '';
         // Force a string conversion as this will be done by the append regardless and
        // the regex test will do this transparently behind the scenes, causing issues if
        // an object's to string has escaped characters in it.
        string = '' + string;
    }
    if (!$e5159421f8ee73ec$var$possible.test(string)) return string;
    return string.replace($e5159421f8ee73ec$var$badChars, $e5159421f8ee73ec$var$escapeChar);
}
function $e5159421f8ee73ec$var$isEmpty(value) {
    if (!value && value !== 0) return true;
    else if ($e5159421f8ee73ec$var$isArray(value) && value.length === 0) return true;
    else return false;
}
function $e5159421f8ee73ec$var$createFrame(object) {
    var frame = $e5159421f8ee73ec$var$extend({}, object);
    frame._parent = object;
    return frame;
}
function $e5159421f8ee73ec$var$blockParams(params, ids) {
    params.path = ids;
    return params;
}
function $e5159421f8ee73ec$var$appendContextPath(contextPath, id) {
    return (contextPath ? contextPath + '.' : '') + id;
}


var $749d74e0218783f2$export$f1e1789686576879 = {
    exports: {}
};


(function(module, exports) {
    exports.__esModule = true;
    var errorProps = [
        'description',
        'fileName',
        'lineNumber',
        'endLineNumber',
        'message',
        'name',
        'number',
        'stack'
    ];
    function Exception(message, node) {
        var loc = node && node.loc, line = undefined, endLineNumber = undefined, column = undefined, endColumn = undefined; // Hand-built ASTs may carry a partial loc; never let the location
        // bookkeeping mask the actual error message.
        if (loc && loc.start) {
            line = loc.start.line;
            column = loc.start.column;
            if (loc.end) {
                endLineNumber = loc.end.line;
                endColumn = loc.end.column;
            }
            message += ' - ' + line + ':' + column;
        }
        var tmp = Error.prototype.constructor.call(this, message); // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
        for(var idx = 0; idx < errorProps.length; idx++)this[errorProps[idx]] = tmp[errorProps[idx]];
        /* istanbul ignore else */ if (Error.captureStackTrace) Error.captureStackTrace(this, Exception);
        try {
            if (loc) {
                this.lineNumber = line;
                this.endLineNumber = endLineNumber; // Work around issue under safari where we can't directly set the column value
                /* istanbul ignore next */ if (Object.defineProperty) {
                    Object.defineProperty(this, 'column', {
                        value: column,
                        enumerable: true
                    });
                    Object.defineProperty(this, 'endColumn', {
                        value: endColumn,
                        enumerable: true
                    });
                } else {
                    this.column = column;
                    this.endColumn = endColumn;
                }
            }
        } catch (nop) {
        /* Ignore if the browser is very particular */ }
    }
    Exception.prototype = new Error();
    exports['default'] = Exception;
    module.exports = exports['default'];
})((0, $749d74e0218783f2$export$f1e1789686576879), (0, $749d74e0218783f2$export$f1e1789686576879).exports);


var $6ddc776215b9a654$export$362abb7de8d8bb41 = {};


var $d3b7e43c599df6ef$export$8b22cf2602fb60ce = {
    exports: {}
};




(function(module, exports) {
    exports.__esModule = true;
    var _utils = (0, $0a99dcdc4fa35da4$export$362abb7de8d8bb41);
    exports['default'] = function(instance) {
        instance.registerHelper('blockHelperMissing', function(context, options) {
            var inverse = options.inverse, fn = options.fn;
            if (context === true) return fn(this);
            else if (context === false || context == null) return inverse(this);
            else if (_utils.isArray(context)) {
                if (context.length > 0) {
                    if (options.ids) options.ids = [
                        options.name
                    ];
                    return instance.helpers.each(context, options);
                } else return inverse(this);
            } else {
                if (options.data && options.ids) {
                    var data = _utils.createFrame(options.data);
                    data.contextPath = _utils.appendContextPath(options.data.contextPath, options.name);
                    options = {
                        data: data
                    };
                }
                return fn(context, options);
            }
        });
    };
    module.exports = exports['default'];
})((0, $d3b7e43c599df6ef$export$8b22cf2602fb60ce), (0, $d3b7e43c599df6ef$export$8b22cf2602fb60ce).exports);


var $13a34c3c195de739$export$f1e1789686576879 = {
    exports: {}
};






(function(module, exports) {
    exports.__esModule = true; // istanbul ignore next
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            'default': obj
        };
    }
    var _utils = (0, $0a99dcdc4fa35da4$export$362abb7de8d8bb41);
    var _exception = (0, $749d74e0218783f2$export$f1e1789686576879).exports;
    var _exception2 = _interopRequireDefault(_exception);
    /**
   * Close an unfinished iterator after the block body threw, like for...of does,
   * so that generators can run their cleanup code.
   *
   * Errors thrown while closing, including by a `return` getter, are ignored:
   * the block's error is the cause and is the one the caller must see.
   *
   * @param {Iterator} iterator the iterator that was being consumed
   */ function closeIterator(iterator) {
        try {
            var _close = iterator['return'];
            if (_utils.isFunction(_close)) _close.call(iterator);
        } catch (closeError) {}
    }
    exports['default'] = function(instance) {
        instance.registerHelper('each', function(context, options) {
            if (!options) throw new _exception2['default']('Must pass iterator to #each');
            var fn = options.fn, inverse = options.inverse, i = 0, ret = '', data = undefined, contextPath = undefined;
            if (options.data && options.ids) contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
            if (_utils.isFunction(context)) context = context.call(this);
            if (options.data) data = _utils.createFrame(options.data);
            function execIteration(field, index, last, value) {
                if (data) {
                    data.key = field;
                    data.index = index;
                    data.first = index === 0;
                    data.last = !!last;
                    if (contextPath) data.contextPath = contextPath + field;
                }
                ret = ret + fn(value, {
                    data: data,
                    blockParams: _utils.blockParams([
                        value,
                        field
                    ], [
                        contextPath + field,
                        null
                    ])
                });
            }
            if (context && typeof context === 'object') {
                if (_utils.isArray(context)) {
                    for(var j = context.length; i < j; i++)if (i in context) execIteration(i, i, i === context.length - 1, context[i]);
                } else if (typeof Symbol === 'function' && context[Symbol.iterator]) {
                    var iterator = context[Symbol.iterator]();
                    var current = iterator.next();
                    while(!current.done){
                        var next = iterator.next();
                        try {
                            execIteration(i, i, next.done, current.value);
                        } catch (e) {
                            if (!next.done) closeIterator(iterator);
                            throw e;
                        }
                        current = next;
                        i++;
                    }
                } else (function() {
                    var priorKey = undefined;
                    Object.keys(context).forEach(function(key) {
                        // We're running the iterations one step out of sync so we can detect
                        // the last iteration without have to scan the object twice and create
                        // an itermediate keys array.
                        if (priorKey !== undefined) execIteration(priorKey, i - 1, false, context[priorKey]);
                        priorKey = key;
                        i++;
                    });
                    if (priorKey !== undefined) execIteration(priorKey, i - 1, true, context[priorKey]);
                })();
            }
            if (i === 0) ret = inverse(this);
            return ret;
        });
    };
    module.exports = exports['default'];
})((0, $13a34c3c195de739$export$f1e1789686576879), (0, $13a34c3c195de739$export$f1e1789686576879).exports);


var $89f5a7462ce5a24b$export$dda1d9f60106f0e9 = {
    exports: {}
};




(function(module, exports) {
    exports.__esModule = true; // istanbul ignore next
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            'default': obj
        };
    }
    var _exception = (0, $749d74e0218783f2$export$f1e1789686576879).exports;
    var _exception2 = _interopRequireDefault(_exception);
    exports['default'] = function(instance) {
        instance.registerHelper('helperMissing', function() /* [args, ]options */ {
            if (arguments.length === 1) // A missing field in a {{foo}} construct.
            return undefined;
            else // Someone is actually trying to call something, blow up.
            throw new _exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
        });
    };
    module.exports = exports['default'];
})((0, $89f5a7462ce5a24b$export$dda1d9f60106f0e9), (0, $89f5a7462ce5a24b$export$dda1d9f60106f0e9).exports);


var $1457a2e0a6ee4bbe$export$71511d61b312f219 = {
    exports: {}
};






(function(module, exports) {
    exports.__esModule = true; // istanbul ignore next
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            'default': obj
        };
    }
    var _utils = (0, $0a99dcdc4fa35da4$export$362abb7de8d8bb41);
    var _exception = (0, $749d74e0218783f2$export$f1e1789686576879).exports;
    var _exception2 = _interopRequireDefault(_exception);
    exports['default'] = function(instance) {
        instance.registerHelper('if', function(conditional, options) {
            if (arguments.length != 2) throw new _exception2['default']('#if requires exactly one argument');
            if (_utils.isFunction(conditional)) conditional = conditional.call(this);
             // Default behavior is to render the positive path if the value is truthy and not empty.
            // The `includeZero` option may be set to treat the condtional as purely not empty based on the
            // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
            if (!options.hash.includeZero && !conditional || _utils.isEmpty(conditional)) return options.inverse(this);
            else return options.fn(this);
        });
        instance.registerHelper('unless', function(conditional, options) {
            if (arguments.length != 2) throw new _exception2['default']('#unless requires exactly one argument');
            return instance.helpers['if'].call(this, conditional, {
                fn: options.inverse,
                inverse: options.fn,
                hash: options.hash
            });
        });
    };
    module.exports = exports['default'];
})((0, $1457a2e0a6ee4bbe$export$71511d61b312f219), (0, $1457a2e0a6ee4bbe$export$71511d61b312f219).exports);


var $ed533eec60dcd13d$export$882b5998b3b9117c = {
    exports: {}
};


(function(module, exports) {
    exports.__esModule = true;
    exports['default'] = function(instance) {
        instance.registerHelper('log', function() /* message, options */ {
            var args = [
                undefined
            ], options = arguments[arguments.length - 1];
            for(var i = 0; i < arguments.length - 1; i++)args.push(arguments[i]);
            var level = 1;
            if (options.hash.level != null) level = options.hash.level;
            else if (options.data && options.data.level != null) level = options.data.level;
            args[0] = level;
            instance.log.apply(instance, args);
        });
    };
    module.exports = exports['default'];
})((0, $ed533eec60dcd13d$export$882b5998b3b9117c), (0, $ed533eec60dcd13d$export$882b5998b3b9117c).exports);


var $351976a957e60985$export$882b5998b3b9117c = {
    exports: {}
};


(function(module, exports) {
    exports.__esModule = true;
    exports['default'] = function(instance) {
        instance.registerHelper('lookup', function(obj, field, options) {
            if (!obj) // Note for 5.0: Change to "obj == null" in 5.0
            return obj;
            return options.lookupProperty(obj, field);
        });
    };
    module.exports = exports['default'];
})((0, $351976a957e60985$export$882b5998b3b9117c), (0, $351976a957e60985$export$882b5998b3b9117c).exports);


var $bc1efa1936ff257a$export$71511d61b312f219 = {
    exports: {}
};






(function(module, exports) {
    exports.__esModule = true; // istanbul ignore next
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            'default': obj
        };
    }
    var _utils = (0, $0a99dcdc4fa35da4$export$362abb7de8d8bb41);
    var _exception = (0, $749d74e0218783f2$export$f1e1789686576879).exports;
    var _exception2 = _interopRequireDefault(_exception);
    exports['default'] = function(instance) {
        instance.registerHelper('with', function(context, options) {
            if (arguments.length != 2) throw new _exception2['default']('#with requires exactly one argument');
            if (_utils.isFunction(context)) context = context.call(this);
            var fn = options.fn;
            if (!_utils.isEmpty(context)) {
                var data = options.data;
                if (options.data && options.ids) {
                    data = _utils.createFrame(options.data);
                    data.contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]);
                }
                return fn(context, {
                    data: data,
                    blockParams: _utils.blockParams([
                        context
                    ], [
                        data && data.contextPath
                    ])
                });
            } else return options.inverse(this);
        });
    };
    module.exports = exports['default'];
})((0, $bc1efa1936ff257a$export$71511d61b312f219), (0, $bc1efa1936ff257a$export$71511d61b312f219).exports);









(0, $6ddc776215b9a654$export$362abb7de8d8bb41).__esModule = true;
(0, $6ddc776215b9a654$export$362abb7de8d8bb41).registerDefaultHelpers = $b6aebabbc42f7af6$var$registerDefaultHelpers;
(0, $6ddc776215b9a654$export$362abb7de8d8bb41).moveHelperToHooks = $b6aebabbc42f7af6$var$moveHelperToHooks; // istanbul ignore next
function $b6aebabbc42f7af6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $b6aebabbc42f7af6$var$_helpersBlockHelperMissing = (0, $d3b7e43c599df6ef$export$8b22cf2602fb60ce).exports;
var $b6aebabbc42f7af6$var$_helpersBlockHelperMissing2 = $b6aebabbc42f7af6$var$_interopRequireDefault($b6aebabbc42f7af6$var$_helpersBlockHelperMissing);
var $b6aebabbc42f7af6$var$_helpersEach = (0, $13a34c3c195de739$export$f1e1789686576879).exports;
var $b6aebabbc42f7af6$var$_helpersEach2 = $b6aebabbc42f7af6$var$_interopRequireDefault($b6aebabbc42f7af6$var$_helpersEach);
var $b6aebabbc42f7af6$var$_helpersHelperMissing = (0, $89f5a7462ce5a24b$export$dda1d9f60106f0e9).exports;
var $b6aebabbc42f7af6$var$_helpersHelperMissing2 = $b6aebabbc42f7af6$var$_interopRequireDefault($b6aebabbc42f7af6$var$_helpersHelperMissing);
var $b6aebabbc42f7af6$var$_helpersIf = (0, $1457a2e0a6ee4bbe$export$71511d61b312f219).exports;
var $b6aebabbc42f7af6$var$_helpersIf2 = $b6aebabbc42f7af6$var$_interopRequireDefault($b6aebabbc42f7af6$var$_helpersIf);
var $b6aebabbc42f7af6$var$_helpersLog = (0, $ed533eec60dcd13d$export$882b5998b3b9117c).exports;
var $b6aebabbc42f7af6$var$_helpersLog2 = $b6aebabbc42f7af6$var$_interopRequireDefault($b6aebabbc42f7af6$var$_helpersLog);
var $b6aebabbc42f7af6$var$_helpersLookup = (0, $351976a957e60985$export$882b5998b3b9117c).exports;
var $b6aebabbc42f7af6$var$_helpersLookup2 = $b6aebabbc42f7af6$var$_interopRequireDefault($b6aebabbc42f7af6$var$_helpersLookup);
var $b6aebabbc42f7af6$var$_helpersWith = (0, $bc1efa1936ff257a$export$71511d61b312f219).exports;
var $b6aebabbc42f7af6$var$_helpersWith2 = $b6aebabbc42f7af6$var$_interopRequireDefault($b6aebabbc42f7af6$var$_helpersWith);
function $b6aebabbc42f7af6$var$registerDefaultHelpers(instance) {
    $b6aebabbc42f7af6$var$_helpersBlockHelperMissing2['default'](instance);
    $b6aebabbc42f7af6$var$_helpersEach2['default'](instance);
    $b6aebabbc42f7af6$var$_helpersHelperMissing2['default'](instance);
    $b6aebabbc42f7af6$var$_helpersIf2['default'](instance);
    $b6aebabbc42f7af6$var$_helpersLog2['default'](instance);
    $b6aebabbc42f7af6$var$_helpersLookup2['default'](instance);
    $b6aebabbc42f7af6$var$_helpersWith2['default'](instance);
}
function $b6aebabbc42f7af6$var$moveHelperToHooks(instance, helperName, keepHelper) {
    if (instance.helpers[helperName]) {
        instance.hooks[helperName] = instance.helpers[helperName];
        if (!keepHelper) // Using delete is slow
        instance.helpers[helperName] = undefined;
    }
}


var $70c54c2245883e19$export$362abb7de8d8bb41 = {};


var $bf02d240d638bb29$export$23f2a1d2818174ef = {
    exports: {}
};




(function(module, exports) {
    exports.__esModule = true;
    var _utils = (0, $0a99dcdc4fa35da4$export$362abb7de8d8bb41);
    exports['default'] = function(instance) {
        instance.registerDecorator('inline', function(fn, props, container, options) {
            var ret = fn;
            if (!props.partials) {
                props.partials = {};
                ret = function(context, options) {
                    // Create a new partials stack frame prior to exec.
                    var original = container.partials;
                    container.partials = _utils.extend({}, original, props.partials);
                    var ret = fn(context, options);
                    container.partials = original;
                    return ret;
                };
            }
            props.partials[options.args[0]] = options.fn;
            return ret;
        });
    };
    module.exports = exports['default'];
})((0, $bf02d240d638bb29$export$23f2a1d2818174ef), (0, $bf02d240d638bb29$export$23f2a1d2818174ef).exports);



(0, $70c54c2245883e19$export$362abb7de8d8bb41).__esModule = true;
(0, $70c54c2245883e19$export$362abb7de8d8bb41).registerDefaultDecorators = $a3c09e20aebfbf9a$var$registerDefaultDecorators; // istanbul ignore next
function $a3c09e20aebfbf9a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $a3c09e20aebfbf9a$var$_decoratorsInline = (0, $bf02d240d638bb29$export$23f2a1d2818174ef).exports;
var $a3c09e20aebfbf9a$var$_decoratorsInline2 = $a3c09e20aebfbf9a$var$_interopRequireDefault($a3c09e20aebfbf9a$var$_decoratorsInline);
function $a3c09e20aebfbf9a$var$registerDefaultDecorators(instance) {
    $a3c09e20aebfbf9a$var$_decoratorsInline2['default'](instance);
}


var $923079a4e6fb9dec$export$882b5998b3b9117c = {
    exports: {}
};




(function(module, exports) {
    exports.__esModule = true;
    var _utils = (0, $0a99dcdc4fa35da4$export$362abb7de8d8bb41);
    var logger = {
        methodMap: [
            'debug',
            'info',
            'warn',
            'error'
        ],
        level: 'info',
        // Maps a given level value to the `methodMap` indexes above.
        lookupLevel: function lookupLevel(level) {
            if (typeof level === 'string') {
                var levelMap = _utils.indexOf(logger.methodMap, level.toLowerCase());
                if (levelMap >= 0) level = levelMap;
                else level = parseInt(level, 10);
            }
            return level;
        },
        // Can be overridden in the host environment
        log: function log(level) {
            level = logger.lookupLevel(level);
            if (typeof console !== 'undefined' && logger.lookupLevel(logger.level) <= level) {
                var method = logger.methodMap[level]; // eslint-disable-next-line no-console
                if (!console[method]) method = 'log';
                for(var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)message[_key - 1] = arguments[_key];
                console[method].apply(console, message); // eslint-disable-line no-console
            }
        }
    };
    exports['default'] = logger;
    module.exports = exports['default'];
})((0, $923079a4e6fb9dec$export$882b5998b3b9117c), (0, $923079a4e6fb9dec$export$882b5998b3b9117c).exports);


var $a30dd0a33ddb19eb$export$362abb7de8d8bb41 = {};






(0, $a30dd0a33ddb19eb$export$362abb7de8d8bb41).__esModule = true;
(0, $a30dd0a33ddb19eb$export$362abb7de8d8bb41).createProtoAccessControl = $c5a3ef9b095220f8$var$createProtoAccessControl;
(0, $a30dd0a33ddb19eb$export$362abb7de8d8bb41).resultIsAllowed = $c5a3ef9b095220f8$var$resultIsAllowed;
(0, $a30dd0a33ddb19eb$export$362abb7de8d8bb41).isPrototypeConstructor = $c5a3ef9b095220f8$var$isPrototypeConstructor;
(0, $a30dd0a33ddb19eb$export$362abb7de8d8bb41).resetLoggedProperties = $c5a3ef9b095220f8$var$resetLoggedProperties; // istanbul ignore next
function $c5a3ef9b095220f8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $c5a3ef9b095220f8$var$_utils = (0, $0a99dcdc4fa35da4$export$362abb7de8d8bb41);
var $c5a3ef9b095220f8$var$_logger = (0, $923079a4e6fb9dec$export$882b5998b3b9117c).exports;
var $c5a3ef9b095220f8$var$_logger2 = $c5a3ef9b095220f8$var$_interopRequireDefault($c5a3ef9b095220f8$var$_logger);
var $c5a3ef9b095220f8$var$loggedProperties = Object.create(null);
function $c5a3ef9b095220f8$var$createProtoAccessControl(runtimeOptions) {
    // Create an object with "null"-prototype to avoid truthy results on
    // prototype properties.
    var propertyWhiteList = Object.create(null); // eslint-disable-next-line no-proto
    propertyWhiteList['__proto__'] = false;
    $c5a3ef9b095220f8$var$_utils.extend(propertyWhiteList, runtimeOptions.allowedProtoProperties);
    var methodWhiteList = Object.create(null);
    methodWhiteList['constructor'] = false;
    methodWhiteList['__defineGetter__'] = false;
    methodWhiteList['__defineSetter__'] = false;
    methodWhiteList['__lookupGetter__'] = false;
    methodWhiteList['__lookupSetter__'] = false;
    $c5a3ef9b095220f8$var$_utils.extend(methodWhiteList, runtimeOptions.allowedProtoMethods);
    return {
        properties: {
            whitelist: propertyWhiteList,
            defaultValue: runtimeOptions.allowProtoPropertiesByDefault
        },
        methods: {
            whitelist: methodWhiteList,
            defaultValue: runtimeOptions.allowProtoMethodsByDefault
        }
    };
}
function $c5a3ef9b095220f8$var$resultIsAllowed(result, protoAccessControl, propertyName) {
    if (typeof result === 'function') return $c5a3ef9b095220f8$var$checkWhiteList(protoAccessControl.methods, propertyName);
    else return $c5a3ef9b095220f8$var$checkWhiteList(protoAccessControl.properties, propertyName);
}
/**
 * Detect a prototype object's own "constructor" back-reference, e.g.
 * `Function.prototype.constructor === Function`. Because "constructor" is an
 * "own" property of such objects, it would otherwise bypass the prototype-access
 * checks and expose dangerous constructors (allowing arbitrary code execution).
 *
 * Only functions can be constructors, so other values are never treated as one
 * and their `prototype` is never read.
 *
 * @param {*} parent the object the property is being read from
 * @param {string} propertyName the property being looked up
 * @param {*} result the already-resolved value of `parent[propertyName]`
 * @returns {boolean} true if the lookup resolves `parent`'s own constructor
 */ function $c5a3ef9b095220f8$var$isPrototypeConstructor(parent, propertyName, result) {
    return propertyName === 'constructor' && typeof result === 'function' && parent === result.prototype;
}
function $c5a3ef9b095220f8$var$checkWhiteList(protoAccessControlForType, propertyName) {
    if (protoAccessControlForType.whitelist[propertyName] !== undefined) return protoAccessControlForType.whitelist[propertyName] === true;
    if (protoAccessControlForType.defaultValue !== undefined) return protoAccessControlForType.defaultValue;
    $c5a3ef9b095220f8$var$logUnexpecedPropertyAccessOnce(propertyName);
    return false;
}
function $c5a3ef9b095220f8$var$logUnexpecedPropertyAccessOnce(propertyName) {
    if ($c5a3ef9b095220f8$var$loggedProperties[propertyName] !== true) {
        $c5a3ef9b095220f8$var$loggedProperties[propertyName] = true;
        $c5a3ef9b095220f8$var$_logger2['default'].log('error', 'Handlebars: Access has been denied to resolve the property "' + propertyName + '" because it is not an "own property" of its parent.\n' + 'You can add a runtime option to disable the check or this warning:\n' + 'See https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details');
    }
}
function $c5a3ef9b095220f8$var$resetLoggedProperties() {
    Object.keys($c5a3ef9b095220f8$var$loggedProperties).forEach(function(propertyName) {
        delete $c5a3ef9b095220f8$var$loggedProperties[propertyName];
    });
}








(0, $237ee74882543fb6$export$362abb7de8d8bb41).__esModule = true;
(0, $237ee74882543fb6$export$362abb7de8d8bb41).HandlebarsEnvironment = $3b0696b866be83bc$var$HandlebarsEnvironment; // istanbul ignore next
function $3b0696b866be83bc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $3b0696b866be83bc$var$_utils = (0, $0a99dcdc4fa35da4$export$362abb7de8d8bb41);
var $3b0696b866be83bc$var$_exception = (0, $749d74e0218783f2$export$f1e1789686576879).exports;
var $3b0696b866be83bc$var$_exception2 = $3b0696b866be83bc$var$_interopRequireDefault($3b0696b866be83bc$var$_exception);
var $3b0696b866be83bc$var$_helpers = (0, $6ddc776215b9a654$export$362abb7de8d8bb41);
var $3b0696b866be83bc$var$_decorators = (0, $70c54c2245883e19$export$362abb7de8d8bb41);
var $3b0696b866be83bc$var$_logger = (0, $923079a4e6fb9dec$export$882b5998b3b9117c).exports;
var $3b0696b866be83bc$var$_logger2 = $3b0696b866be83bc$var$_interopRequireDefault($3b0696b866be83bc$var$_logger);
var $3b0696b866be83bc$var$_internalProtoAccess = (0, $a30dd0a33ddb19eb$export$362abb7de8d8bb41);
var $3b0696b866be83bc$var$VERSION = '4.7.10';
(0, $237ee74882543fb6$export$362abb7de8d8bb41).VERSION = $3b0696b866be83bc$var$VERSION;
var $3b0696b866be83bc$var$COMPILER_REVISION = 8;
(0, $237ee74882543fb6$export$362abb7de8d8bb41).COMPILER_REVISION = $3b0696b866be83bc$var$COMPILER_REVISION;
var $3b0696b866be83bc$var$LAST_COMPATIBLE_COMPILER_REVISION = 7;
(0, $237ee74882543fb6$export$362abb7de8d8bb41).LAST_COMPATIBLE_COMPILER_REVISION = $3b0696b866be83bc$var$LAST_COMPATIBLE_COMPILER_REVISION;
var $3b0696b866be83bc$var$REVISION_CHANGES = {
    1: '<= 1.0.rc.2',
    // 1.0.rc.2 is actually rev2 but doesn't report it
    2: '== 1.0.0-rc.3',
    3: '== 1.0.0-rc.4',
    4: '== 1.x.x',
    5: '== 2.0.0-alpha.x',
    6: '>= 2.0.0-beta.1',
    7: '>= 4.0.0 <4.3.0',
    8: '>= 4.3.0'
};
(0, $237ee74882543fb6$export$362abb7de8d8bb41).REVISION_CHANGES = $3b0696b866be83bc$var$REVISION_CHANGES;
var $3b0696b866be83bc$var$objectType = '[object Object]';
function $3b0696b866be83bc$var$HandlebarsEnvironment(helpers, partials, decorators) {
    this.helpers = helpers || {};
    this.partials = partials || {};
    this.decorators = decorators || {};
    $3b0696b866be83bc$var$_helpers.registerDefaultHelpers(this);
    $3b0696b866be83bc$var$_decorators.registerDefaultDecorators(this);
}
$3b0696b866be83bc$var$HandlebarsEnvironment.prototype = {
    constructor: $3b0696b866be83bc$var$HandlebarsEnvironment,
    logger: $3b0696b866be83bc$var$_logger2['default'],
    log: $3b0696b866be83bc$var$_logger2['default'].log,
    registerHelper: function registerHelper(name, fn) {
        if ($3b0696b866be83bc$var$_utils.toString.call(name) === $3b0696b866be83bc$var$objectType) {
            if (fn) throw new $3b0696b866be83bc$var$_exception2['default']('Arg not supported with multiple helpers');
            $3b0696b866be83bc$var$_utils.extend(this.helpers, name);
        } else this.helpers[name] = fn;
    },
    unregisterHelper: function unregisterHelper(name) {
        delete this.helpers[name];
    },
    registerPartial: function registerPartial(name, partial) {
        if ($3b0696b866be83bc$var$_utils.toString.call(name) === $3b0696b866be83bc$var$objectType) $3b0696b866be83bc$var$_utils.extend(this.partials, name);
        else {
            if (typeof partial === 'undefined') throw new $3b0696b866be83bc$var$_exception2['default']('Attempting to register a partial called "' + name + '" as undefined');
            this.partials[name] = partial;
        }
    },
    unregisterPartial: function unregisterPartial(name) {
        delete this.partials[name];
    },
    registerDecorator: function registerDecorator(name, fn) {
        if ($3b0696b866be83bc$var$_utils.toString.call(name) === $3b0696b866be83bc$var$objectType) {
            if (fn) throw new $3b0696b866be83bc$var$_exception2['default']('Arg not supported with multiple decorators');
            $3b0696b866be83bc$var$_utils.extend(this.decorators, name);
        } else this.decorators[name] = fn;
    },
    unregisterDecorator: function unregisterDecorator(name) {
        delete this.decorators[name];
    },
    /**
   * Reset the memory of illegal property accesses that have already been logged.
   * @deprecated should only be used in handlebars test-cases
   */ resetLoggedPropertyAccesses: function resetLoggedPropertyAccesses() {
        $3b0696b866be83bc$var$_internalProtoAccess.resetLoggedProperties();
    }
};
var $3b0696b866be83bc$var$log = $3b0696b866be83bc$var$_logger2['default'].log;
(0, $237ee74882543fb6$export$362abb7de8d8bb41).log = $3b0696b866be83bc$var$log;
(0, $237ee74882543fb6$export$362abb7de8d8bb41).createFrame = $3b0696b866be83bc$var$_utils.createFrame;
(0, $237ee74882543fb6$export$362abb7de8d8bb41).logger = $3b0696b866be83bc$var$_logger2['default'];


var $633809d0dfceefa7$export$2408f22a0fab9ae5 = {
    exports: {}
};


(function(module, exports) {
    exports.__esModule = true;
    function SafeString(string) {
        this.string = string;
    }
    SafeString.prototype.toString = SafeString.prototype.toHTML = function() {
        return '' + this.string;
    };
    exports['default'] = SafeString;
    module.exports = exports['default'];
})((0, $633809d0dfceefa7$export$2408f22a0fab9ae5), (0, $633809d0dfceefa7$export$2408f22a0fab9ae5).exports);




var $f4eb0c3e60c2b467$export$362abb7de8d8bb41 = {};






var $6166f72bff3b2502$export$362abb7de8d8bb41 = {};


(0, $6166f72bff3b2502$export$362abb7de8d8bb41).__esModule = true;
(0, $6166f72bff3b2502$export$362abb7de8d8bb41).wrapHelper = $d7b45ed4fa81e250$var$wrapHelper;
function $d7b45ed4fa81e250$var$wrapHelper(helper, transformOptionsFn) {
    if (typeof helper !== 'function') // This should not happen, but apparently it does in https://github.com/wycats/handlebars.js/issues/1639
    // We try to make the wrapper least-invasive by not wrapping it, if the helper is not a function.
    return helper;
    var wrapper = function wrapper() /* dynamic arguments */ {
        var options = arguments[arguments.length - 1];
        arguments[arguments.length - 1] = transformOptionsFn(options);
        return helper.apply(this, arguments);
    };
    return wrapper;
}









(0, $f4eb0c3e60c2b467$export$362abb7de8d8bb41).__esModule = true;
(0, $f4eb0c3e60c2b467$export$362abb7de8d8bb41).checkRevision = $59681cdd2055c984$var$checkRevision;
(0, $f4eb0c3e60c2b467$export$362abb7de8d8bb41).template = $59681cdd2055c984$var$template;
(0, $f4eb0c3e60c2b467$export$362abb7de8d8bb41).wrapProgram = $59681cdd2055c984$var$wrapProgram;
(0, $f4eb0c3e60c2b467$export$362abb7de8d8bb41).resolvePartial = $59681cdd2055c984$var$resolvePartial;
(0, $f4eb0c3e60c2b467$export$362abb7de8d8bb41).invokePartial = $59681cdd2055c984$var$invokePartial;
(0, $f4eb0c3e60c2b467$export$362abb7de8d8bb41).noop = $59681cdd2055c984$var$noop; // istanbul ignore next
function $59681cdd2055c984$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
} // istanbul ignore next
function $59681cdd2055c984$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj['default'] = obj;
        return newObj;
    }
}
var $59681cdd2055c984$var$_utils = (0, $0a99dcdc4fa35da4$export$362abb7de8d8bb41);
var $59681cdd2055c984$var$Utils = $59681cdd2055c984$var$_interopRequireWildcard($59681cdd2055c984$var$_utils);
var $59681cdd2055c984$var$_exception = (0, $749d74e0218783f2$export$f1e1789686576879).exports;
var $59681cdd2055c984$var$_exception2 = $59681cdd2055c984$var$_interopRequireDefault($59681cdd2055c984$var$_exception);
var $59681cdd2055c984$var$_base = (0, $237ee74882543fb6$export$362abb7de8d8bb41);
var $59681cdd2055c984$var$_helpers = (0, $6ddc776215b9a654$export$362abb7de8d8bb41);
var $59681cdd2055c984$var$_internalWrapHelper = (0, $6166f72bff3b2502$export$362abb7de8d8bb41);
var $59681cdd2055c984$var$_internalProtoAccess = (0, $a30dd0a33ddb19eb$export$362abb7de8d8bb41);
function $59681cdd2055c984$var$checkRevision(compilerInfo) {
    var compilerRevision = compilerInfo && compilerInfo[0] || 1, currentRevision = $59681cdd2055c984$var$_base.COMPILER_REVISION;
    if (compilerRevision >= $59681cdd2055c984$var$_base.LAST_COMPATIBLE_COMPILER_REVISION && compilerRevision <= $59681cdd2055c984$var$_base.COMPILER_REVISION) return;
    if (compilerRevision < $59681cdd2055c984$var$_base.LAST_COMPATIBLE_COMPILER_REVISION) {
        var runtimeVersions = $59681cdd2055c984$var$_base.REVISION_CHANGES[currentRevision], compilerVersions = $59681cdd2055c984$var$_base.REVISION_CHANGES[compilerRevision];
        throw new $59681cdd2055c984$var$_exception2['default']("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
    } else // Use the embedded version info since the runtime doesn't know about this revision yet
    throw new $59681cdd2055c984$var$_exception2['default']("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + compilerInfo[1] + ').');
}
function $59681cdd2055c984$var$template(templateSpec, env) {
    /* istanbul ignore next */ if (!env) throw new $59681cdd2055c984$var$_exception2['default']('No environment passed to template');
    if (!templateSpec || !templateSpec.main) throw new $59681cdd2055c984$var$_exception2['default']('Unknown template object: ' + typeof templateSpec);
    templateSpec.main.decorator = templateSpec.main_d; // Note: Using env.VM references rather than local var references throughout this section to allow
    // for external users to override these as pseudo-supported APIs.
    env.VM.checkRevision(templateSpec.compiler); // backwards compatibility for precompiled templates with compiler-version 7 (<4.3.0)
    var templateWasPrecompiledWithCompilerV7 = templateSpec.compiler && templateSpec.compiler[0] === 7;
    function invokePartialWrapper(partial, context, options) {
        if (options.hash) {
            context = $59681cdd2055c984$var$Utils.extend({}, context, options.hash);
            if (options.ids) options.ids[0] = true;
        }
        partial = env.VM.resolvePartial.call(this, partial, context, options);
        options.hooks = this.hooks;
        options.protoAccessControl = this.protoAccessControl;
        var result = env.VM.invokePartial.call(this, partial, context, options); // An empty result normally means the partial is template source that still
        // has to be compiled. A function partial has already been invoked, so an
        // empty result from it is a bug in that partial.
        if (result == null && $59681cdd2055c984$var$Utils.isFunction(partial)) throw new $59681cdd2055c984$var$_exception2['default']('The partial ' + options.name + ' returned no output: partials must return a string');
        if (result == null && env.compile) {
            // Only template source registered as a partial may be compiled here.
            // Anything else (e.g. an AST-shaped object) must not become code.
            if (typeof partial !== 'string') throw new $59681cdd2055c984$var$_exception2['default']('The partial ' + options.name + ' could not be compiled: partials must be strings or functions returning strings');
            options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
            result = options.partials[options.name](context, options);
        }
        if (result != null) {
            if (options.indent) {
                var lines = result.split('\n');
                for(var i = 0, l = lines.length; i < l; i++){
                    if (!lines[i] && i + 1 === l) break;
                    lines[i] = options.indent + lines[i];
                }
                result = lines.join('\n');
            }
            return result;
        } else throw new $59681cdd2055c984$var$_exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
    } // Just add water
    var container = {
        strict: function strict(obj, name, loc) {
            if (!obj || !(name in obj)) throw new $59681cdd2055c984$var$_exception2['default']('"' + name + '" not defined in ' + obj, {
                loc: loc
            });
            return container.lookupProperty(obj, name);
        },
        lookupProperty: function lookupProperty(parent, propertyName) {
            var result = parent[propertyName];
            if (result == null) return result;
             // Own properties are trusted context data and returned as-is, except for
            // a prototype's own "constructor" back-reference (e.g.
            // Function.prototype.constructor === Function): that must still pass the
            // prototype-access deny list, otherwise the Function constructor becomes
            // reachable and arbitrary code can be executed.
            if (Object.prototype.hasOwnProperty.call(parent, propertyName) && !$59681cdd2055c984$var$_internalProtoAccess.isPrototypeConstructor(parent, propertyName, result)) return result;
            if ($59681cdd2055c984$var$_internalProtoAccess.resultIsAllowed(result, container.protoAccessControl, propertyName)) return result;
            return undefined;
        },
        lookup: function lookup(depths, name) {
            var len = depths.length;
            for(var i = 0; i < len; i++){
                var result = depths[i] && container.lookupProperty(depths[i], name);
                if (result != null) return result;
            }
        },
        lambda: function lambda(current, context) {
            return typeof current === 'function' ? current.call(context) : current;
        },
        escapeExpression: $59681cdd2055c984$var$Utils.escapeExpression,
        invokePartial: invokePartialWrapper,
        fn: function fn(i) {
            var ret = templateSpec[i];
            ret.decorator = templateSpec[i + '_d'];
            return ret;
        },
        programs: [],
        program: function program(i, data, declaredBlockParams, blockParams, depths) {
            var programWrapper = this.programs[i], fn = this.fn(i);
            if (data || depths || blockParams || declaredBlockParams) programWrapper = $59681cdd2055c984$var$wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
            else if (!programWrapper) programWrapper = this.programs[i] = $59681cdd2055c984$var$wrapProgram(this, i, fn);
            return programWrapper;
        },
        data: function data(value, depth) {
            while(value && depth--)value = value._parent;
            return value;
        },
        mergeIfNeeded: function mergeIfNeeded(param, common) {
            var obj = param || common;
            if (param && common && param !== common) obj = $59681cdd2055c984$var$Utils.extend({}, common, param);
            return obj;
        },
        // An empty object to use as replacement for null-contexts
        nullContext: Object.seal({}),
        noop: env.VM.noop,
        compilerInfo: templateSpec.compiler
    };
    function ret(context) {
        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
        var data = options.data;
        ret._setup(options);
        if (!options.partial && templateSpec.useData) data = $59681cdd2055c984$var$initData(context, data);
        var depths = undefined, blockParams = templateSpec.useBlockParams ? [] : undefined;
        if (templateSpec.useDepths) {
            if (options.depths) depths = context != options.depths[0] ? [
                context
            ].concat(options.depths) : options.depths;
            else depths = [
                context
            ];
        }
        function main(context) {
            return '' + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
        }
        main = $59681cdd2055c984$var$executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
        return main(context, options);
    }
    ret.isTop = true;
    ret._setup = function(options) {
        if (!options.partial) {
            var mergedHelpers = {};
            $59681cdd2055c984$var$addHelpers(mergedHelpers, env.helpers, container);
            $59681cdd2055c984$var$addHelpers(mergedHelpers, options.helpers, container);
            container.helpers = mergedHelpers;
            if (templateSpec.usePartial) // Use mergeIfNeeded here to prevent compiling global partials multiple times
            container.partials = container.mergeIfNeeded(options.partials, env.partials);
            if (templateSpec.usePartial || templateSpec.useDecorators) container.decorators = $59681cdd2055c984$var$Utils.extend({}, env.decorators, options.decorators);
            container.hooks = {};
            container.protoAccessControl = $59681cdd2055c984$var$_internalProtoAccess.createProtoAccessControl(options);
            var keepHelperInHelpers = options.allowCallsToHelperMissing || templateWasPrecompiledWithCompilerV7;
            $59681cdd2055c984$var$_helpers.moveHelperToHooks(container, 'helperMissing', keepHelperInHelpers);
            $59681cdd2055c984$var$_helpers.moveHelperToHooks(container, 'blockHelperMissing', keepHelperInHelpers);
        } else {
            container.protoAccessControl = options.protoAccessControl; // internal option
            container.helpers = options.helpers;
            container.partials = options.partials;
            container.decorators = options.decorators;
            container.hooks = options.hooks;
        }
    };
    ret._child = function(i, data, blockParams, depths) {
        if (templateSpec.useBlockParams && !blockParams) throw new $59681cdd2055c984$var$_exception2['default']('must pass block params');
        if (templateSpec.useDepths && !depths) throw new $59681cdd2055c984$var$_exception2['default']('must pass parent depths');
        return $59681cdd2055c984$var$wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
    };
    return ret;
}
function $59681cdd2055c984$var$wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
    function prog(context) {
        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
        var currentDepths = depths;
        if (depths && context != depths[0] && !(context === container.nullContext && depths[0] === null)) currentDepths = [
            context
        ].concat(depths);
        return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [
            options.blockParams
        ].concat(blockParams), currentDepths);
    }
    prog = $59681cdd2055c984$var$executeDecorators(fn, prog, container, depths, data, blockParams);
    prog.program = i;
    prog.depth = depths ? depths.length : 0;
    prog.blockParams = declaredBlockParams || 0;
    return prog;
}
/**
 * This is currently part of the official API, therefore implementation details should not be changed.
 */ function $59681cdd2055c984$var$resolvePartial(partial, context, options) {
    if (!partial) {
        if (options.name === '@partial-block') partial = $59681cdd2055c984$var$lookupOwnProperty(options.data, 'partial-block');
        else partial = $59681cdd2055c984$var$lookupOwnProperty(options.partials, options.name);
    } else if (typeof partial !== 'function' && !options.name) {
        // This is a dynamic partial that returned a name rather than a compiled
        // partial. Only functions are accepted as partials here; any other value
        // (including an object with a "call" property) is treated as a name, so
        // that context data can never be compiled as a template.
        options.name = partial;
        partial = $59681cdd2055c984$var$lookupOwnProperty(options.partials, partial);
    }
    return partial;
}
function $59681cdd2055c984$var$invokePartial(partial, context, options) {
    // Use the current closure context to save the partial-block if this partial
    var currentPartialBlock = $59681cdd2055c984$var$lookupOwnProperty(options.data, 'partial-block');
    options.partial = true;
    if (options.ids) options.data.contextPath = options.ids[0] || options.data.contextPath;
    var partialBlock = undefined;
    if (options.fn && options.fn !== $59681cdd2055c984$var$noop) (function() {
        options.data = $59681cdd2055c984$var$_base.createFrame(options.data); // Wrapper function to get access to currentPartialBlock from the closure
        var fn = options.fn;
        partialBlock = options.data['partial-block'] = function partialBlockWrapper(context) {
            var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1]; // Restore the partial-block from the closure for the execution of the block
            // i.e. the part inside the block of the partial call.
            options.data = $59681cdd2055c984$var$_base.createFrame(options.data);
            options.data['partial-block'] = currentPartialBlock;
            return fn(context, options);
        };
        if (fn.partials) options.partials = $59681cdd2055c984$var$Utils.extend({}, options.partials, fn.partials);
    })();
    if (partial === undefined && partialBlock) partial = partialBlock;
    if (partial === undefined) throw new $59681cdd2055c984$var$_exception2['default']('The partial ' + options.name + ' could not be found');
    else if (partial instanceof Function) return partial(context, options);
}
function $59681cdd2055c984$var$noop() {
    return '';
}
function $59681cdd2055c984$var$lookupOwnProperty(obj, name) {
    if (obj && Object.prototype.hasOwnProperty.call(obj, name)) return obj[name];
}
function $59681cdd2055c984$var$initData(context, data) {
    if (!data || !('root' in data)) {
        data = data ? $59681cdd2055c984$var$_base.createFrame(data) : {};
        data.root = context;
    }
    return data;
}
function $59681cdd2055c984$var$executeDecorators(fn, prog, container, depths, data, blockParams) {
    if (fn.decorator) {
        var props = {};
        prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
        $59681cdd2055c984$var$Utils.extend(prog, props);
    }
    return prog;
}
function $59681cdd2055c984$var$addHelpers(mergedHelpers, helpers, container) {
    if (!helpers) return;
    Object.keys(helpers).forEach(function(helperName) {
        var helper = helpers[helperName];
        mergedHelpers[helperName] = $59681cdd2055c984$var$passLookupPropertyOption(helper, container);
    });
}
function $59681cdd2055c984$var$passLookupPropertyOption(helper, container) {
    var lookupProperty = container.lookupProperty;
    return $59681cdd2055c984$var$_internalWrapHelper.wrapHelper(helper, function(options) {
        options.lookupProperty = lookupProperty;
        return options;
    });
}


var $467125da0348237a$export$7ccc53e8f1e7dfc5 = {
    exports: {}
};


/* global globalThis */ (function(module, exports) {
    exports.__esModule = true;
    exports['default'] = function(Handlebars) {
        /* istanbul ignore next */ // https://mathiasbynens.be/notes/globalthis
        (function() {
            if (typeof globalThis === 'object') return;
            Object.prototype.__defineGetter__('__magic__', function() {
                return this;
            });
            __magic__.globalThis = __magic__; // eslint-disable-line no-undef
            delete Object.prototype.__magic__;
        })();
        var $Handlebars = globalThis.Handlebars;
        /* istanbul ignore next */ Handlebars.noConflict = function() {
            if (globalThis.Handlebars === Handlebars) globalThis.Handlebars = $Handlebars;
            return Handlebars;
        };
    };
    module.exports = exports['default'];
})((0, $467125da0348237a$export$7ccc53e8f1e7dfc5), (0, $467125da0348237a$export$7ccc53e8f1e7dfc5).exports);








(function(module, exports) {
    exports.__esModule = true; // istanbul ignore next
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            'default': obj
        };
    } // istanbul ignore next
    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj['default'] = obj;
            return newObj;
        }
    }
    var _handlebarsBase = (0, $237ee74882543fb6$export$362abb7de8d8bb41);
    var base$1 = _interopRequireWildcard(_handlebarsBase); // Each of these augment the Handlebars object. No need to setup here.
    // (This is done to easily share code between commonjs and browse envs)
    var _handlebarsSafeString = (0, $633809d0dfceefa7$export$2408f22a0fab9ae5).exports;
    var _handlebarsSafeString2 = _interopRequireDefault(_handlebarsSafeString);
    var _handlebarsException = (0, $749d74e0218783f2$export$f1e1789686576879).exports;
    var _handlebarsException2 = _interopRequireDefault(_handlebarsException);
    var _handlebarsUtils = (0, $0a99dcdc4fa35da4$export$362abb7de8d8bb41);
    var Utils = _interopRequireWildcard(_handlebarsUtils);
    var _handlebarsRuntime = (0, $f4eb0c3e60c2b467$export$362abb7de8d8bb41);
    var runtime$1 = _interopRequireWildcard(_handlebarsRuntime);
    var _handlebarsNoConflict = (0, $467125da0348237a$export$7ccc53e8f1e7dfc5).exports;
    var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict); // For compatibility and usage outside of module systems, make the Handlebars object a namespace
    function create() {
        var hb = new base$1.HandlebarsEnvironment();
        Utils.extend(hb, base$1);
        hb.SafeString = _handlebarsSafeString2['default'];
        hb.Exception = _handlebarsException2['default'];
        hb.Utils = Utils;
        hb.escapeExpression = Utils.escapeExpression;
        hb.VM = runtime$1;
        hb.template = function(spec) {
            return runtime$1.template(spec, hb);
        };
        return hb;
    }
    var inst = create();
    inst.create = create;
    _handlebarsNoConflict2['default'](inst);
    inst['default'] = inst;
    exports['default'] = inst;
    module.exports = exports['default'];
})((0, $bada51c9203af1df$export$dda1d9f60106f0e9), (0, $bada51c9203af1df$export$dda1d9f60106f0e9).exports);
var $d30415a7ae055e38$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $9b5d33d856ec9f32$export$22b09f878622677a)((0, $bada51c9203af1df$export$dda1d9f60106f0e9).exports);



/* eslint @okta/okta-ui/no-specific-methods: 0, @okta/okta-ui/no-specific-modules: 0 */ const $3e490973b7383cc4$export$61051857ea442b7f = (0, $187365f460a6e3ed$export$2e2bcd8739ae039).memoize(function(template) {
    window.okta && window.okta.isLogCourageTemplateUtilUsage && (0, $187365f460a6e3ed$export$2e2bcd8739ae039).isString(template);
});
const $3e490973b7383cc4$export$e0b1c073ce210f17 = (0, $187365f460a6e3ed$export$2e2bcd8739ae039).memoize(function(template) {
    const ast = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).parseWithoutProcessing(template); // Only skip compilation if the template contains exclusively static content
    // (ContentStatement nodes only, or empty body)
    return !ast.body.every(({ type: type })=>type === 'ContentStatement');
});
(0, $187365f460a6e3ed$export$2e2bcd8739ae039).mixin({
    resultCtx: function(object, property, context, defaultValue) {
        let value = (0, $187365f460a6e3ed$export$2e2bcd8739ae039).isObject(object) ? object[property] : void 0;
        if ((0, $187365f460a6e3ed$export$2e2bcd8739ae039).isFunction(value)) value = value.call(context || object);
        if (value) return value;
        else return !(0, $187365f460a6e3ed$export$2e2bcd8739ae039).isUndefined(defaultValue) ? defaultValue : value;
    },
    isInteger: function(x) {
        return (0, $187365f460a6e3ed$export$2e2bcd8739ae039).isNumber(x) && x % 1 === 0;
    },
    // TODO: This will be deprecated at some point. Views should use precompiled templates
    // eslint-disable-next-line @okta/okta-ui/no-bare-templates
    template: function(source, data) {
        // If the passed template has no Handlebars syntax,
        // we can simply return a simple function that returns the input template string
        if (!$3e490973b7383cc4$export$e0b1c073ce210f17(source)) {
            const fn = ()=>source;
            fn.source = ''; // to conform with "CompiledTemplate" type definition
            return fn;
        }
        $3e490973b7383cc4$export$61051857ea442b7f(source);
        const template = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).compile(source);
        if (data) return template(data);
        const fn = function(data) {
            return template(data);
        };
        fn.source = ''; // to conform with "CompiledTemplate" type definition
        return fn;
    }
});
const $3e490973b7383cc4$export$2e2bcd8739ae039 = (0, $187365f460a6e3ed$export$2e2bcd8739ae039);




var $4f25ada457d3f624$export$8b22cf2602fb60ce = {
    exports: {}
};


var $f26807820ae216d3$exports = {};
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof $f26807820ae216d3$exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    $f26807820ae216d3$exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : $f26807820ae216d3$exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});




(function(module, exports) {
    //     Backbone.js 1.4.0
    //     (c) 2010-2019 Jeremy Ashkenas and DocumentCloud
    //     Backbone may be freely distributed under the MIT license.
    //     For all details and documentation:
    //     http://backbonejs.org
    const jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports)));
    (function(factory) {
        // Establish the root object, `window` (`self`) in the browser, or `global` on the server.
        // We use `self` instead of `window` for `WebWorker` support.
        var root = typeof self == 'object' && self.self === self && self || typeof (0, $9b5d33d856ec9f32$export$a441d440b06e3168) == 'object' && (0, $9b5d33d856ec9f32$export$a441d440b06e3168).global === (0, $9b5d33d856ec9f32$export$a441d440b06e3168) && (0, $9b5d33d856ec9f32$export$a441d440b06e3168); // Set up Backbone appropriately for the environment. Start with AMD.
        var _ = (0, $d3be9eebbc8f28b8$export$3b14a55fb2447963).exports, $;
        try {
            $ = jQuery;
        } catch (e) {}
        factory(root, exports, _, $); // Finally, as a browser global.
    })(function(root, Backbone, _, $) {
        // Initial Setup
        // -------------
        // Save the previous value of the `Backbone` variable, so that it can be
        // restored later on, if `noConflict` is used.
        var previousBackbone = root.Backbone; // Create a local reference to a common array method we'll want to use later.
        var slice = Array.prototype.slice; // Current version of the library. Keep in sync with `package.json`.
        Backbone.VERSION = '1.4.0'; // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
        // the `$` variable.
        Backbone.$ = $; // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
        // to its previous owner. Returns a reference to this Backbone object.
        Backbone.noConflict = function() {
            root.Backbone = previousBackbone;
            return this;
        }; // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
        // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
        // set a `X-Http-Method-Override` header.
        Backbone.emulateHTTP = false; // Turn on `emulateJSON` to support legacy servers that can't deal with direct
        // `application/json` requests ... this will encode the body as
        // `application/x-www-form-urlencoded` instead and will send the model in a
        // form param named `model`.
        Backbone.emulateJSON = false; // Backbone.Events
        // ---------------
        // A module that can be mixed in to *any object* in order to provide it with
        // a custom event channel. You may bind a callback to an event with `on` or
        // remove with `off`; `trigger`-ing an event fires all callbacks in
        // succession.
        //
        //     var object = {};
        //     _.extend(object, Backbone.Events);
        //     object.on('expand', function(){ alert('expanded'); });
        //     object.trigger('expand');
        //
        var Events = Backbone.Events = {}; // Regular expression used to split event strings.
        var eventSplitter = /\s+/; // A private global variable to share between listeners and listenees.
        var _listening; // Iterates over the standard `event, callback` (as well as the fancy multiple
        // space-separated events `"change blur", callback` and jQuery-style event
        // maps `{event: callback}`).
        var eventsApi = function(iteratee, events, name, callback, opts) {
            var i = 0, names;
            if (name && typeof name === 'object') {
                // Handle event maps.
                if (callback !== void 0 && 'context' in opts && opts.context === void 0) opts.context = callback;
                for(names = _.keys(name); i < names.length; i++)events = eventsApi(iteratee, events, names[i], name[names[i]], opts);
            } else if (name && eventSplitter.test(name)) // Handle space-separated event names by delegating them individually.
            for(names = name.split(eventSplitter); i < names.length; i++)events = iteratee(events, names[i], callback, opts);
            else // Finally, standard events.
            events = iteratee(events, name, callback, opts);
            return events;
        }; // Bind an event to a `callback` function. Passing `"all"` will bind
        // the callback to all events fired.
        Events.on = function(name, callback, context) {
            this._events = eventsApi(onApi, this._events || {}, name, callback, {
                context: context,
                ctx: this,
                listening: _listening
            });
            if (_listening) {
                var listeners = this._listeners || (this._listeners = {});
                listeners[_listening.id] = _listening; // Allow the listening to use a counter, instead of tracking
                // callbacks for library interop
                _listening.interop = false;
            }
            return this;
        }; // Inversion-of-control versions of `on`. Tell *this* object to listen to
        // an event in another object... keeping track of what it's listening to
        // for easier unbinding later.
        Events.listenTo = function(obj, name, callback) {
            if (!obj) return this;
            var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
            var listeningTo = this._listeningTo || (this._listeningTo = {});
            var listening = _listening = listeningTo[id]; // This object is not listening to any other events on `obj` yet.
            // Setup the necessary references to track the listening callbacks.
            if (!listening) {
                this._listenId || (this._listenId = _.uniqueId('l'));
                listening = _listening = listeningTo[id] = new Listening(this, obj);
            } // Bind callbacks on obj.
            var error = tryCatchOn(obj, name, callback, this);
            _listening = void 0;
            if (error) throw error; // If the target obj is not Backbone.Events, track events manually.
            if (listening.interop) listening.on(name, callback);
            return this;
        }; // The reducing API that adds a callback to the `events` object.
        var onApi = function(events, name, callback, options) {
            if (callback) {
                var handlers = events[name] || (events[name] = []);
                var context = options.context, ctx = options.ctx, listening = options.listening;
                if (listening) listening.count++;
                handlers.push({
                    callback: callback,
                    context: context,
                    ctx: context || ctx,
                    listening: listening
                });
            }
            return events;
        }; // An try-catch guarded #on function, to prevent poisoning the global
        // `_listening` variable.
        var tryCatchOn = function(obj, name, callback, context) {
            try {
                obj.on(name, callback, context);
            } catch (e) {
                return e;
            }
        }; // Remove one or many callbacks. If `context` is null, removes all
        // callbacks with that function. If `callback` is null, removes all
        // callbacks for the event. If `name` is null, removes all bound
        // callbacks for all events.
        Events.off = function(name, callback, context) {
            if (!this._events) return this;
            this._events = eventsApi(offApi, this._events, name, callback, {
                context: context,
                listeners: this._listeners
            });
            return this;
        }; // Tell this object to stop listening to either specific events ... or
        // to every object it's currently listening to.
        Events.stopListening = function(obj, name, callback) {
            var listeningTo = this._listeningTo;
            if (!listeningTo) return this;
            var ids = obj ? [
                obj._listenId
            ] : _.keys(listeningTo);
            for(var i = 0; i < ids.length; i++){
                var listening = listeningTo[ids[i]]; // If listening doesn't exist, this object is not currently
                // listening to obj. Break out early.
                if (!listening) break;
                listening.obj.off(name, callback, this);
                if (listening.interop) listening.off(name, callback);
            }
            if (_.isEmpty(listeningTo)) this._listeningTo = void 0;
            return this;
        }; // The reducing API that removes a callback from the `events` object.
        var offApi = function(events, name, callback, options) {
            if (!events) return;
            var context = options.context, listeners = options.listeners;
            var i = 0, names; // Delete all event listeners and "drop" events.
            if (!name && !context && !callback) {
                for(names = _.keys(listeners); i < names.length; i++)listeners[names[i]].cleanup();
                return;
            }
            names = name ? [
                name
            ] : _.keys(events);
            for(; i < names.length; i++){
                name = names[i];
                var handlers = events[name]; // Bail out if there are no events stored.
                if (!handlers) break; // Find any remaining events.
                var remaining = [];
                for(var j = 0; j < handlers.length; j++){
                    var handler = handlers[j];
                    if (callback && callback !== handler.callback && callback !== handler.callback._callback || context && context !== handler.context) remaining.push(handler);
                    else {
                        var listening = handler.listening;
                        if (listening) listening.off(name, callback);
                    }
                } // Replace events if there are any remaining.  Otherwise, clean up.
                if (remaining.length) events[name] = remaining;
                else delete events[name];
            }
            return events;
        }; // Bind an event to only be triggered a single time. After the first time
        // the callback is invoked, its listener will be removed. If multiple events
        // are passed in using the space-separated syntax, the handler will fire
        // once for each event, not once for a combination of all events.
        Events.once = function(name, callback, context) {
            // Map the event into a `{event: once}` object.
            var events = eventsApi(onceMap, {}, name, callback, this.off.bind(this));
            if (typeof name === 'string' && context == null) callback = void 0;
            return this.on(events, callback, context);
        }; // Inversion-of-control versions of `once`.
        Events.listenToOnce = function(obj, name, callback) {
            // Map the event into a `{event: once}` object.
            var events = eventsApi(onceMap, {}, name, callback, this.stopListening.bind(this, obj));
            return this.listenTo(obj, events);
        }; // Reduces the event callbacks into a map of `{event: onceWrapper}`.
        // `offer` unbinds the `onceWrapper` after it has been called.
        var onceMap = function(map, name, callback, offer) {
            if (callback) {
                var once = map[name] = _.once(function() {
                    offer(name, once);
                    callback.apply(this, arguments);
                });
                once._callback = callback;
            }
            return map;
        }; // Trigger one or many events, firing all bound callbacks. Callbacks are
        // passed the same arguments as `trigger` is, apart from the event name
        // (unless you're listening on `"all"`, which will cause your callback to
        // receive the true name of the event as the first argument).
        Events.trigger = function(name) {
            if (!this._events) return this;
            var length = Math.max(0, arguments.length - 1);
            var args = Array(length);
            for(var i = 0; i < length; i++)args[i] = arguments[i + 1];
            eventsApi(triggerApi, this._events, name, void 0, args);
            return this;
        }; // Handles triggering the appropriate event callbacks.
        var triggerApi = function(objEvents, name, callback, args) {
            if (objEvents) {
                var events = objEvents[name];
                var allEvents = objEvents.all;
                if (events && allEvents) allEvents = allEvents.slice();
                if (events) triggerEvents(events, args);
                if (allEvents) triggerEvents(allEvents, [
                    name
                ].concat(args));
            }
            return objEvents;
        }; // A difficult-to-believe, but optimized internal dispatch function for
        // triggering events. Tries to keep the usual cases speedy (most internal
        // Backbone events have 3 arguments).
        var triggerEvents = function(events, args) {
            var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
            switch(args.length){
                case 0:
                    while(++i < l)(ev = events[i]).callback.call(ev.ctx);
                    return;
                case 1:
                    while(++i < l)(ev = events[i]).callback.call(ev.ctx, a1);
                    return;
                case 2:
                    while(++i < l)(ev = events[i]).callback.call(ev.ctx, a1, a2);
                    return;
                case 3:
                    while(++i < l)(ev = events[i]).callback.call(ev.ctx, a1, a2, a3);
                    return;
                default:
                    while(++i < l)(ev = events[i]).callback.apply(ev.ctx, args);
                    return;
            }
        }; // A listening class that tracks and cleans up memory bindings
        // when all callbacks have been offed.
        var Listening = function(listener, obj) {
            this.id = listener._listenId;
            this.listener = listener;
            this.obj = obj;
            this.interop = true;
            this.count = 0;
            this._events = void 0;
        };
        Listening.prototype.on = Events.on; // Offs a callback (or several).
        // Uses an optimized counter if the listenee uses Backbone.Events.
        // Otherwise, falls back to manual tracking to support events
        // library interop.
        Listening.prototype.off = function(name, callback) {
            var cleanup;
            if (this.interop) {
                this._events = eventsApi(offApi, this._events, name, callback, {
                    context: void 0,
                    listeners: void 0
                });
                cleanup = !this._events;
            } else {
                this.count--;
                cleanup = this.count === 0;
            }
            if (cleanup) this.cleanup();
        }; // Cleans up memory bindings between the listener and the listenee.
        Listening.prototype.cleanup = function() {
            delete this.listener._listeningTo[this.obj._listenId];
            if (!this.interop) delete this.obj._listeners[this.id];
        }; // Aliases for backwards compatibility.
        Events.bind = Events.on;
        Events.unbind = Events.off; // Allow the `Backbone` object to serve as a global event bus, for folks who
        // want global "pubsub" in a convenient place.
        _.extend(Backbone, Events); // Backbone.Model
        // --------------
        // Backbone **Models** are the basic data object in the framework --
        // frequently representing a row in a table in a database on your server.
        // A discrete chunk of data and a bunch of useful, related methods for
        // performing computations and transformations on that data.
        // Create a new model with the specified attributes. A client id (`cid`)
        // is automatically generated and assigned for you.
        var Model = Backbone.Model = function(attributes, options) {
            var attrs = attributes || {};
            options || (options = {});
            this.preinitialize.apply(this, arguments);
            this.cid = _.uniqueId(this.cidPrefix);
            this.attributes = {};
            if (options.collection) this.collection = options.collection;
            if (options.parse) attrs = this.parse(attrs, options) || {};
            var defaults = _.result(this, 'defaults');
            attrs = _.defaults(_.extend({}, defaults, attrs), defaults);
            this.set(attrs, options);
            this.changed = {};
            this.initialize.apply(this, arguments);
        }; // Attach all inheritable methods to the Model prototype.
        _.extend(Model.prototype, Events, {
            // A hash of attributes whose current and previous value differ.
            changed: null,
            // The value returned during the last failed validation.
            validationError: null,
            // The default name for the JSON `id` attribute is `"id"`. MongoDB and
            // CouchDB users may want to set this to `"_id"`.
            idAttribute: 'id',
            // The prefix is used to create the client id which is used to identify models locally.
            // You may want to override this if you're experiencing name clashes with model ids.
            cidPrefix: 'c',
            // preinitialize is an empty function by default. You can override it with a function
            // or object.  preinitialize will run before any instantiation logic is run in the Model.
            preinitialize: function() {},
            // Initialize is an empty function by default. Override it with your own
            // initialization logic.
            initialize: function() {},
            // Return a copy of the model's `attributes` object.
            toJSON: function(options) {
                return _.clone(this.attributes);
            },
            // Proxy `Backbone.sync` by default -- but override this if you need
            // custom syncing semantics for *this* particular model.
            sync: function() {
                return Backbone.sync.apply(this, arguments);
            },
            // Get the value of an attribute.
            get: function(attr) {
                return this.attributes[attr];
            },
            // Get the HTML-escaped value of an attribute.
            escape: function(attr) {
                return _.escape(this.get(attr));
            },
            // Returns `true` if the attribute contains a value that is not null
            // or undefined.
            has: function(attr) {
                return this.get(attr) != null;
            },
            // Special-cased proxy to underscore's `_.matches` method.
            matches: function(attrs) {
                return !!_.iteratee(attrs, this)(this.attributes);
            },
            // Set a hash of model attributes on the object, firing `"change"`. This is
            // the core primitive operation of a model, updating the data and notifying
            // anyone who needs to know about the change in state. The heart of the beast.
            set: function(key, val, options) {
                if (key == null) return this; // Handle both `"key", value` and `{key: value}` -style arguments.
                var attrs;
                if (typeof key === 'object') {
                    attrs = key;
                    options = val;
                } else (attrs = {})[key] = val;
                options || (options = {}); // Run validation.
                if (!this._validate(attrs, options)) return false; // Extract attributes and options.
                var unset = options.unset;
                var silent = options.silent;
                var changes = [];
                var changing = this._changing;
                this._changing = true;
                if (!changing) {
                    this._previousAttributes = _.clone(this.attributes);
                    this.changed = {};
                }
                var current = this.attributes;
                var changed = this.changed;
                var prev = this._previousAttributes; // For each `set` attribute, update or delete the current value.
                for(var attr in attrs){
                    val = attrs[attr];
                    if (!_.isEqual(current[attr], val)) changes.push(attr);
                    if (!_.isEqual(prev[attr], val)) changed[attr] = val;
                    else delete changed[attr];
                    unset ? delete current[attr] : current[attr] = val;
                } // Update the `id`.
                if (this.idAttribute in attrs) this.id = this.get(this.idAttribute); // Trigger all relevant attribute changes.
                if (!silent) {
                    if (changes.length) this._pending = options;
                    for(var i = 0; i < changes.length; i++)this.trigger('change:' + changes[i], this, current[changes[i]], options);
                } // You might be wondering why there's a `while` loop here. Changes can
                // be recursively nested within `"change"` events.
                if (changing) return this;
                if (!silent) while(this._pending){
                    options = this._pending;
                    this._pending = false;
                    this.trigger('change', this, options);
                }
                this._pending = false;
                this._changing = false;
                return this;
            },
            // Remove an attribute from the model, firing `"change"`. `unset` is a noop
            // if the attribute doesn't exist.
            unset: function(attr, options) {
                return this.set(attr, void 0, _.extend({}, options, {
                    unset: true
                }));
            },
            // Clear all attributes on the model, firing `"change"`.
            clear: function(options) {
                var attrs = {};
                for(var key in this.attributes)attrs[key] = void 0;
                return this.set(attrs, _.extend({}, options, {
                    unset: true
                }));
            },
            // Determine if the model has changed since the last `"change"` event.
            // If you specify an attribute name, determine if that attribute has changed.
            hasChanged: function(attr) {
                if (attr == null) return !_.isEmpty(this.changed);
                return _.has(this.changed, attr);
            },
            // Return an object containing all the attributes that have changed, or
            // false if there are no changed attributes. Useful for determining what
            // parts of a view need to be updated and/or what attributes need to be
            // persisted to the server. Unset attributes will be set to undefined.
            // You can also pass an attributes object to diff against the model,
            // determining if there *would be* a change.
            changedAttributes: function(diff) {
                if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
                var old = this._changing ? this._previousAttributes : this.attributes;
                var changed = {};
                var hasChanged;
                for(var attr in diff){
                    var val = diff[attr];
                    if (_.isEqual(old[attr], val)) continue;
                    changed[attr] = val;
                    hasChanged = true;
                }
                return hasChanged ? changed : false;
            },
            // Get the previous value of an attribute, recorded at the time the last
            // `"change"` event was fired.
            previous: function(attr) {
                if (attr == null || !this._previousAttributes) return null;
                return this._previousAttributes[attr];
            },
            // Get all of the attributes of the model at the time of the previous
            // `"change"` event.
            previousAttributes: function() {
                return _.clone(this._previousAttributes);
            },
            // Fetch the model from the server, merging the response with the model's
            // local attributes. Any changed attributes will trigger a "change" event.
            fetch: function(options) {
                options = _.extend({
                    parse: true
                }, options);
                var model = this;
                var success = options.success;
                options.success = function(resp) {
                    var serverAttrs = options.parse ? model.parse(resp, options) : resp;
                    if (!model.set(serverAttrs, options)) return false;
                    if (success) success.call(options.context, model, resp, options);
                    model.trigger('sync', model, resp, options);
                };
                wrapError(this, options);
                return this.sync('read', this, options);
            },
            // Set a hash of model attributes, and sync the model to the server.
            // If the server returns an attributes hash that differs, the model's
            // state will be `set` again.
            save: function(key, val, options) {
                // Handle both `"key", value` and `{key: value}` -style arguments.
                var attrs;
                if (key == null || typeof key === 'object') {
                    attrs = key;
                    options = val;
                } else (attrs = {})[key] = val;
                options = _.extend({
                    validate: true,
                    parse: true
                }, options);
                var wait = options.wait; // If we're not waiting and attributes exist, save acts as
                // `set(attr).save(null, opts)` with validation. Otherwise, check if
                // the model will be valid when the attributes, if any, are set.
                if (attrs && !wait) {
                    if (!this.set(attrs, options)) return false;
                } else if (!this._validate(attrs, options)) return false;
                 // After a successful server-side save, the client is (optionally)
                // updated with the server-side state.
                var model = this;
                var success = options.success;
                var attributes = this.attributes;
                options.success = function(resp) {
                    // Ensure attributes are restored during synchronous saves.
                    model.attributes = attributes;
                    var serverAttrs = options.parse ? model.parse(resp, options) : resp;
                    if (wait) serverAttrs = _.extend({}, attrs, serverAttrs);
                    if (serverAttrs && !model.set(serverAttrs, options)) return false;
                    if (success) success.call(options.context, model, resp, options);
                    model.trigger('sync', model, resp, options);
                };
                wrapError(this, options); // Set temporary attributes if `{wait: true}` to properly find new ids.
                if (attrs && wait) this.attributes = _.extend({}, attributes, attrs);
                var method = this.isNew() ? 'create' : options.patch ? 'patch' : 'update';
                if (method === 'patch' && !options.attrs) options.attrs = attrs;
                var xhr = this.sync(method, this, options); // Restore attributes.
                this.attributes = attributes;
                return xhr;
            },
            // Destroy this model on the server if it was already persisted.
            // Optimistically removes the model from its collection, if it has one.
            // If `wait: true` is passed, waits for the server to respond before removal.
            destroy: function(options) {
                options = options ? _.clone(options) : {};
                var model = this;
                var success = options.success;
                var wait = options.wait;
                var destroy = function() {
                    model.stopListening();
                    model.trigger('destroy', model, model.collection, options);
                };
                options.success = function(resp) {
                    if (wait) destroy();
                    if (success) success.call(options.context, model, resp, options);
                    if (!model.isNew()) model.trigger('sync', model, resp, options);
                };
                var xhr = false;
                if (this.isNew()) _.defer(options.success);
                else {
                    wrapError(this, options);
                    xhr = this.sync('delete', this, options);
                }
                if (!wait) destroy();
                return xhr;
            },
            // Default URL for the model's representation on the server -- if you're
            // using Backbone's restful methods, override this to change the endpoint
            // that will be called.
            url: function() {
                var base = _.result(this, 'urlRoot') || _.result(this.collection, 'url') || urlError();
                if (this.isNew()) return base;
                var id = this.get(this.idAttribute);
                return base.replace(/[^\/]$/, '$&/') + encodeURIComponent(id);
            },
            // **parse** converts a response into the hash of attributes to be `set` on
            // the model. The default implementation is just to pass the response along.
            parse: function(resp, options) {
                return resp;
            },
            // Create a new model with identical attributes to this one.
            clone: function() {
                return new this.constructor(this.attributes);
            },
            // A model is new if it has never been saved to the server, and lacks an id.
            isNew: function() {
                return !this.has(this.idAttribute);
            },
            // Check if the model is currently in a valid state.
            isValid: function(options) {
                return this._validate({}, _.extend({}, options, {
                    validate: true
                }));
            },
            // Run validation against the next complete set of model attributes,
            // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
            _validate: function(attrs, options) {
                if (!options.validate || !this.validate) return true;
                attrs = _.extend({}, this.attributes, attrs);
                var error = this.validationError = this.validate(attrs, options) || null;
                if (!error) return true;
                this.trigger('invalid', this, error, _.extend(options, {
                    validationError: error
                }));
                return false;
            }
        }); // Backbone.Collection
        // -------------------
        // If models tend to represent a single row of data, a Backbone Collection is
        // more analogous to a table full of data ... or a small slice or page of that
        // table, or a collection of rows that belong together for a particular reason
        // -- all of the messages in this particular folder, all of the documents
        // belonging to this particular author, and so on. Collections maintain
        // indexes of their models, both in order, and for lookup by `id`.
        // Create a new **Collection**, perhaps to contain a specific type of `model`.
        // If a `comparator` is specified, the Collection will maintain
        // its models in sort order, as they're added and removed.
        var Collection = Backbone.Collection = function(models, options) {
            options || (options = {});
            this.preinitialize.apply(this, arguments);
            if (options.model) this.model = options.model;
            if (options.comparator !== void 0) this.comparator = options.comparator;
            this._reset();
            this.initialize.apply(this, arguments);
            if (models) this.reset(models, _.extend({
                silent: true
            }, options));
        }; // Default options for `Collection#set`.
        var setOptions = {
            add: true,
            remove: true,
            merge: true
        };
        var addOptions = {
            add: true,
            remove: false
        }; // Splices `insert` into `array` at index `at`.
        var splice = function(array, insert, at) {
            at = Math.min(Math.max(at, 0), array.length);
            var tail = Array(array.length - at);
            var length = insert.length;
            var i;
            for(i = 0; i < tail.length; i++)tail[i] = array[i + at];
            for(i = 0; i < length; i++)array[i + at] = insert[i];
            for(i = 0; i < tail.length; i++)array[i + length + at] = tail[i];
        }; // Define the Collection's inheritable methods.
        _.extend(Collection.prototype, Events, {
            // The default model for a collection is just a **Backbone.Model**.
            // This should be overridden in most cases.
            model: Model,
            // preinitialize is an empty function by default. You can override it with a function
            // or object.  preinitialize will run before any instantiation logic is run in the Collection.
            preinitialize: function() {},
            // Initialize is an empty function by default. Override it with your own
            // initialization logic.
            initialize: function() {},
            // The JSON representation of a Collection is an array of the
            // models' attributes.
            toJSON: function(options) {
                return this.map(function(model) {
                    return model.toJSON(options);
                });
            },
            // Proxy `Backbone.sync` by default.
            sync: function() {
                return Backbone.sync.apply(this, arguments);
            },
            // Add a model, or list of models to the set. `models` may be Backbone
            // Models or raw JavaScript objects to be converted to Models, or any
            // combination of the two.
            add: function(models, options) {
                return this.set(models, _.extend({
                    merge: false
                }, options, addOptions));
            },
            // Remove a model, or a list of models from the set.
            remove: function(models, options) {
                options = _.extend({}, options);
                var singular = !_.isArray(models);
                models = singular ? [
                    models
                ] : models.slice();
                var removed = this._removeModels(models, options);
                if (!options.silent && removed.length) {
                    options.changes = {
                        added: [],
                        merged: [],
                        removed: removed
                    };
                    this.trigger('update', this, options);
                }
                return singular ? removed[0] : removed;
            },
            // Update a collection by `set`-ing a new list of models, adding new ones,
            // removing models that are no longer present, and merging models that
            // already exist in the collection, as necessary. Similar to **Model#set**,
            // the core operation for updating the data contained by the collection.
            set: function(models, options) {
                if (models == null) return;
                options = _.extend({}, setOptions, options);
                if (options.parse && !this._isModel(models)) models = this.parse(models, options) || [];
                var singular = !_.isArray(models);
                models = singular ? [
                    models
                ] : models.slice();
                var at = options.at;
                if (at != null) at = +at;
                if (at > this.length) at = this.length;
                if (at < 0) at += this.length + 1;
                var set = [];
                var toAdd = [];
                var toMerge = [];
                var toRemove = [];
                var modelMap = {};
                var add = options.add;
                var merge = options.merge;
                var remove = options.remove;
                var sort = false;
                var sortable = this.comparator && at == null && options.sort !== false;
                var sortAttr = _.isString(this.comparator) ? this.comparator : null; // Turn bare objects into model references, and prevent invalid models
                // from being added.
                var model, i;
                for(i = 0; i < models.length; i++){
                    model = models[i]; // If a duplicate is found, prevent it from being added and
                    // optionally merge it into the existing model.
                    var existing = this.get(model);
                    if (existing) {
                        if (merge && model !== existing) {
                            var attrs = this._isModel(model) ? model.attributes : model;
                            if (options.parse) attrs = existing.parse(attrs, options);
                            existing.set(attrs, options);
                            toMerge.push(existing);
                            if (sortable && !sort) sort = existing.hasChanged(sortAttr);
                        }
                        if (!modelMap[existing.cid]) {
                            modelMap[existing.cid] = true;
                            set.push(existing);
                        }
                        models[i] = existing; // If this is a new, valid model, push it to the `toAdd` list.
                    } else if (add) {
                        model = models[i] = this._prepareModel(model, options);
                        if (model) {
                            toAdd.push(model);
                            this._addReference(model, options);
                            modelMap[model.cid] = true;
                            set.push(model);
                        }
                    }
                } // Remove stale models.
                if (remove) {
                    for(i = 0; i < this.length; i++){
                        model = this.models[i];
                        if (!modelMap[model.cid]) toRemove.push(model);
                    }
                    if (toRemove.length) this._removeModels(toRemove, options);
                } // See if sorting is needed, update `length` and splice in new models.
                var orderChanged = false;
                var replace = !sortable && add && remove;
                if (set.length && replace) {
                    orderChanged = this.length !== set.length || _.some(this.models, function(m, index) {
                        return m !== set[index];
                    });
                    this.models.length = 0;
                    splice(this.models, set, 0);
                    this.length = this.models.length;
                } else if (toAdd.length) {
                    if (sortable) sort = true;
                    splice(this.models, toAdd, at == null ? this.length : at);
                    this.length = this.models.length;
                } // Silently sort the collection if appropriate.
                if (sort) this.sort({
                    silent: true
                }); // Unless silenced, it's time to fire all appropriate add/sort/update events.
                if (!options.silent) {
                    for(i = 0; i < toAdd.length; i++){
                        if (at != null) options.index = at + i;
                        model = toAdd[i];
                        model.trigger('add', model, this, options);
                    }
                    if (sort || orderChanged) this.trigger('sort', this, options);
                    if (toAdd.length || toRemove.length || toMerge.length) {
                        options.changes = {
                            added: toAdd,
                            removed: toRemove,
                            merged: toMerge
                        };
                        this.trigger('update', this, options);
                    }
                } // Return the added (or merged) model (or models).
                return singular ? models[0] : models;
            },
            // When you have more items than you want to add or remove individually,
            // you can reset the entire set with a new list of models, without firing
            // any granular `add` or `remove` events. Fires `reset` when finished.
            // Useful for bulk operations and optimizations.
            reset: function(models, options) {
                options = options ? _.clone(options) : {};
                for(var i = 0; i < this.models.length; i++)this._removeReference(this.models[i], options);
                options.previousModels = this.models;
                this._reset();
                models = this.add(models, _.extend({
                    silent: true
                }, options));
                if (!options.silent) this.trigger('reset', this, options);
                return models;
            },
            // Add a model to the end of the collection.
            push: function(model, options) {
                return this.add(model, _.extend({
                    at: this.length
                }, options));
            },
            // Remove a model from the end of the collection.
            pop: function(options) {
                var model = this.at(this.length - 1);
                return this.remove(model, options);
            },
            // Add a model to the beginning of the collection.
            unshift: function(model, options) {
                return this.add(model, _.extend({
                    at: 0
                }, options));
            },
            // Remove a model from the beginning of the collection.
            shift: function(options) {
                var model = this.at(0);
                return this.remove(model, options);
            },
            // Slice out a sub-array of models from the collection.
            slice: function() {
                return slice.apply(this.models, arguments);
            },
            // Get a model from the set by id, cid, model object with id or cid
            // properties, or an attributes object that is transformed through modelId.
            get: function(obj) {
                if (obj == null) return void 0;
                return this._byId[obj] || this._byId[this.modelId(this._isModel(obj) ? obj.attributes : obj)] || obj.cid && this._byId[obj.cid];
            },
            // Returns `true` if the model is in the collection.
            has: function(obj) {
                return this.get(obj) != null;
            },
            // Get the model at the given index.
            at: function(index) {
                if (index < 0) index += this.length;
                return this.models[index];
            },
            // Return models with matching attributes. Useful for simple cases of
            // `filter`.
            where: function(attrs, first) {
                return this[first ? 'find' : 'filter'](attrs);
            },
            // Return the first model with matching attributes. Useful for simple cases
            // of `find`.
            findWhere: function(attrs) {
                return this.where(attrs, true);
            },
            // Force the collection to re-sort itself. You don't need to call this under
            // normal circumstances, as the set will maintain sort order as each item
            // is added.
            sort: function(options) {
                var comparator = this.comparator;
                if (!comparator) throw new Error('Cannot sort a set without a comparator');
                options || (options = {});
                var length = comparator.length;
                if (_.isFunction(comparator)) comparator = comparator.bind(this); // Run sort based on type of `comparator`.
                if (length === 1 || _.isString(comparator)) this.models = this.sortBy(comparator);
                else this.models.sort(comparator);
                if (!options.silent) this.trigger('sort', this, options);
                return this;
            },
            // Pluck an attribute from each model in the collection.
            pluck: function(attr) {
                return this.map(attr + '');
            },
            // Fetch the default set of models for this collection, resetting the
            // collection when they arrive. If `reset: true` is passed, the response
            // data will be passed through the `reset` method instead of `set`.
            fetch: function(options) {
                options = _.extend({
                    parse: true
                }, options);
                var success = options.success;
                var collection = this;
                options.success = function(resp) {
                    var method = options.reset ? 'reset' : 'set';
                    collection[method](resp, options);
                    if (success) success.call(options.context, collection, resp, options);
                    collection.trigger('sync', collection, resp, options);
                };
                wrapError(this, options);
                return this.sync('read', this, options);
            },
            // Create a new instance of a model in this collection. Add the model to the
            // collection immediately, unless `wait: true` is passed, in which case we
            // wait for the server to agree.
            create: function(model, options) {
                options = options ? _.clone(options) : {};
                var wait = options.wait;
                model = this._prepareModel(model, options);
                if (!model) return false;
                if (!wait) this.add(model, options);
                var collection = this;
                var success = options.success;
                options.success = function(m, resp, callbackOpts) {
                    if (wait) collection.add(m, callbackOpts);
                    if (success) success.call(callbackOpts.context, m, resp, callbackOpts);
                };
                model.save(null, options);
                return model;
            },
            // **parse** converts a response into a list of models to be added to the
            // collection. The default implementation is just to pass it through.
            parse: function(resp, options) {
                return resp;
            },
            // Create a new collection with an identical list of models as this one.
            clone: function() {
                return new this.constructor(this.models, {
                    model: this.model,
                    comparator: this.comparator
                });
            },
            // Define how to uniquely identify models in the collection.
            modelId: function(attrs) {
                return attrs[this.model.prototype.idAttribute || 'id'];
            },
            // Get an iterator of all models in this collection.
            values: function() {
                return new CollectionIterator(this, ITERATOR_VALUES);
            },
            // Get an iterator of all model IDs in this collection.
            keys: function() {
                return new CollectionIterator(this, ITERATOR_KEYS);
            },
            // Get an iterator of all [ID, model] tuples in this collection.
            entries: function() {
                return new CollectionIterator(this, ITERATOR_KEYSVALUES);
            },
            // Private method to reset all internal state. Called when the collection
            // is first initialized or reset.
            _reset: function() {
                this.length = 0;
                this.models = [];
                this._byId = {};
            },
            // Prepare a hash of attributes (or other model) to be added to this
            // collection.
            _prepareModel: function(attrs, options) {
                if (this._isModel(attrs)) {
                    if (!attrs.collection) attrs.collection = this;
                    return attrs;
                }
                options = options ? _.clone(options) : {};
                options.collection = this;
                var model = new this.model(attrs, options);
                if (!model.validationError) return model;
                this.trigger('invalid', this, model.validationError, options);
                return false;
            },
            // Internal method called by both remove and set.
            _removeModels: function(models, options) {
                var removed = [];
                for(var i = 0; i < models.length; i++){
                    var model = this.get(models[i]);
                    if (!model) continue;
                    var index = this.indexOf(model);
                    this.models.splice(index, 1);
                    this.length--; // Remove references before triggering 'remove' event to prevent an
                    // infinite loop. #3693
                    delete this._byId[model.cid];
                    var id = this.modelId(model.attributes);
                    if (id != null) delete this._byId[id];
                    if (!options.silent) {
                        options.index = index;
                        model.trigger('remove', model, this, options);
                    }
                    removed.push(model);
                    this._removeReference(model, options);
                }
                return removed;
            },
            // Method for checking whether an object should be considered a model for
            // the purposes of adding to the collection.
            _isModel: function(model) {
                return model instanceof Model;
            },
            // Internal method to create a model's ties to a collection.
            _addReference: function(model, options) {
                this._byId[model.cid] = model;
                var id = this.modelId(model.attributes);
                if (id != null) this._byId[id] = model;
                model.on('all', this._onModelEvent, this);
            },
            // Internal method to sever a model's ties to a collection.
            _removeReference: function(model, options) {
                delete this._byId[model.cid];
                var id = this.modelId(model.attributes);
                if (id != null) delete this._byId[id];
                if (this === model.collection) delete model.collection;
                model.off('all', this._onModelEvent, this);
            },
            // Internal method called every time a model in the set fires an event.
            // Sets need to update their indexes when models change ids. All other
            // events simply proxy through. "add" and "remove" events that originate
            // in other collections are ignored.
            _onModelEvent: function(event, model, collection, options) {
                if (model) {
                    if ((event === 'add' || event === 'remove') && collection !== this) return;
                    if (event === 'destroy') this.remove(model, options);
                    if (event === 'change') {
                        var prevId = this.modelId(model.previousAttributes());
                        var id = this.modelId(model.attributes);
                        if (prevId !== id) {
                            if (prevId != null) delete this._byId[prevId];
                            if (id != null) this._byId[id] = model;
                        }
                    }
                }
                this.trigger.apply(this, arguments);
            }
        }); // Defining an @@iterator method implements JavaScript's Iterable protocol.
        // In modern ES2015 browsers, this value is found at Symbol.iterator.
        /* global Symbol */ var $$iterator = typeof Symbol === 'function' && Symbol.iterator;
        if ($$iterator) Collection.prototype[$$iterator] = Collection.prototype.values;
         // CollectionIterator
        // ------------------
        // A CollectionIterator implements JavaScript's Iterator protocol, allowing the
        // use of `for of` loops in modern browsers and interoperation between
        // Backbone.Collection and other JavaScript functions and third-party libraries
        // which can operate on Iterables.
        var CollectionIterator = function(collection, kind) {
            this._collection = collection;
            this._kind = kind;
            this._index = 0;
        }; // This "enum" defines the three possible kinds of values which can be emitted
        // by a CollectionIterator that correspond to the values(), keys() and entries()
        // methods on Collection, respectively.
        var ITERATOR_VALUES = 1;
        var ITERATOR_KEYS = 2;
        var ITERATOR_KEYSVALUES = 3; // All Iterators should themselves be Iterable.
        if ($$iterator) CollectionIterator.prototype[$$iterator] = function() {
            return this;
        };
        CollectionIterator.prototype.next = function() {
            if (this._collection) {
                // Only continue iterating if the iterated collection is long enough.
                if (this._index < this._collection.length) {
                    var model = this._collection.at(this._index);
                    this._index++; // Construct a value depending on what kind of values should be iterated.
                    var value;
                    if (this._kind === ITERATOR_VALUES) value = model;
                    else {
                        var id = this._collection.modelId(model.attributes);
                        if (this._kind === ITERATOR_KEYS) value = id;
                        else // ITERATOR_KEYSVALUES
                        value = [
                            id,
                            model
                        ];
                    }
                    return {
                        value: value,
                        done: false
                    };
                } // Once exhausted, remove the reference to the collection so future
                // calls to the next method always return done.
                this._collection = void 0;
            }
            return {
                value: void 0,
                done: true
            };
        }; // Backbone.View
        // -------------
        // Backbone Views are almost more convention than they are actual code. A View
        // is simply a JavaScript object that represents a logical chunk of UI in the
        // DOM. This might be a single item, an entire list, a sidebar or panel, or
        // even the surrounding frame which wraps your whole app. Defining a chunk of
        // UI as a **View** allows you to define your DOM events declaratively, without
        // having to worry about render order ... and makes it easy for the view to
        // react to specific changes in the state of your models.
        // Creating a Backbone.View creates its initial element outside of the DOM,
        // if an existing element is not provided...
        var View = Backbone.View = function(options) {
            this.cid = _.uniqueId('view');
            this.preinitialize.apply(this, arguments);
            _.extend(this, _.pick(options, viewOptions));
            this._ensureElement();
            this.initialize.apply(this, arguments);
        }; // Cached regex to split keys for `delegate`.
        var delegateEventSplitter = /^(\S+)\s*(.*)$/; // List of view options to be set as properties.
        var viewOptions = [
            'model',
            'collection',
            'el',
            'id',
            'attributes',
            'className',
            'tagName',
            'events'
        ]; // Set up all inheritable **Backbone.View** properties and methods.
        _.extend(View.prototype, Events, {
            // The default `tagName` of a View's element is `"div"`.
            tagName: 'div',
            // jQuery delegate for element lookup, scoped to DOM elements within the
            // current view. This should be preferred to global lookups where possible.
            $: function(selector) {
                return this.$el.find(selector);
            },
            // preinitialize is an empty function by default. You can override it with a function
            // or object.  preinitialize will run before any instantiation logic is run in the View
            preinitialize: function() {},
            // Initialize is an empty function by default. Override it with your own
            // initialization logic.
            initialize: function() {},
            // **render** is the core function that your view should override, in order
            // to populate its element (`this.el`), with the appropriate HTML. The
            // convention is for **render** to always return `this`.
            render: function() {
                return this;
            },
            // Remove this view by taking the element out of the DOM, and removing any
            // applicable Backbone.Events listeners.
            remove: function() {
                this._removeElement();
                this.stopListening();
                return this;
            },
            // Remove this view's element from the document and all event listeners
            // attached to it. Exposed for subclasses using an alternative DOM
            // manipulation API.
            _removeElement: function() {
                this.$el.remove();
            },
            // Change the view's element (`this.el` property) and re-delegate the
            // view's events on the new element.
            setElement: function(element) {
                this.undelegateEvents();
                this._setElement(element);
                this.delegateEvents();
                return this;
            },
            // Creates the `this.el` and `this.$el` references for this view using the
            // given `el`. `el` can be a CSS selector or an HTML string, a jQuery
            // context or an element. Subclasses can override this to utilize an
            // alternative DOM manipulation API and are only required to set the
            // `this.el` property.
            _setElement: function(el) {
                this.$el = el instanceof Backbone.$ ? el : Backbone.$(el);
                this.el = this.$el[0];
            },
            // Set callbacks, where `this.events` is a hash of
            //
            // *{"event selector": "callback"}*
            //
            //     {
            //       'mousedown .title':  'edit',
            //       'click .button':     'save',
            //       'click .open':       function(e) { ... }
            //     }
            //
            // pairs. Callbacks will be bound to the view, with `this` set properly.
            // Uses event delegation for efficiency.
            // Omitting the selector binds the event to `this.el`.
            delegateEvents: function(events) {
                events || (events = _.result(this, 'events'));
                if (!events) return this;
                this.undelegateEvents();
                for(var key in events){
                    var method = events[key];
                    if (!_.isFunction(method)) method = this[method];
                    if (!method) continue;
                    var match = key.match(delegateEventSplitter);
                    this.delegate(match[1], match[2], method.bind(this));
                }
                return this;
            },
            // Add a single event listener to the view's element (or a child element
            // using `selector`). This only works for delegate-able events: not `focus`,
            // `blur`, and not `change`, `submit`, and `reset` in Internet Explorer.
            delegate: function(eventName, selector, listener) {
                this.$el.on(eventName + '.delegateEvents' + this.cid, selector, listener);
                return this;
            },
            // Clears all callbacks previously bound to the view by `delegateEvents`.
            // You usually don't need to use this, but may wish to if you have multiple
            // Backbone views attached to the same DOM element.
            undelegateEvents: function() {
                if (this.$el) this.$el.off('.delegateEvents' + this.cid);
                return this;
            },
            // A finer-grained `undelegateEvents` for removing a single delegated event.
            // `selector` and `listener` are both optional.
            undelegate: function(eventName, selector, listener) {
                this.$el.off(eventName + '.delegateEvents' + this.cid, selector, listener);
                return this;
            },
            // Produces a DOM element to be assigned to your view. Exposed for
            // subclasses using an alternative DOM manipulation API.
            _createElement: function(tagName) {
                return document.createElement(tagName);
            },
            // Ensure that the View has a DOM element to render into.
            // If `this.el` is a string, pass it through `$()`, take the first
            // matching element, and re-assign it to `el`. Otherwise, create
            // an element from the `id`, `className` and `tagName` properties.
            _ensureElement: function() {
                if (!this.el) {
                    var attrs = _.extend({}, _.result(this, 'attributes'));
                    if (this.id) attrs.id = _.result(this, 'id');
                    if (this.className) attrs['class'] = _.result(this, 'className');
                    this.setElement(this._createElement(_.result(this, 'tagName')));
                    this._setAttributes(attrs);
                } else this.setElement(_.result(this, 'el'));
            },
            // Set attributes from a hash on this view's element.  Exposed for
            // subclasses using an alternative DOM manipulation API.
            _setAttributes: function(attributes) {
                this.$el.attr(attributes);
            }
        }); // Proxy Backbone class methods to Underscore functions, wrapping the model's
        // `attributes` object or collection's `models` array behind the scenes.
        //
        // collection.filter(function(model) { return model.get('age') > 10 });
        // collection.each(this.addView);
        //
        // `Function#apply` can be slow so we use the method's arg count, if we know it.
        var addMethod = function(base, length, method, attribute) {
            switch(length){
                case 1:
                    return function() {
                        return base[method](this[attribute]);
                    };
                case 2:
                    return function(value) {
                        return base[method](this[attribute], value);
                    };
                case 3:
                    return function(iteratee, context) {
                        return base[method](this[attribute], cb(iteratee, this), context);
                    };
                case 4:
                    return function(iteratee, defaultVal, context) {
                        return base[method](this[attribute], cb(iteratee, this), defaultVal, context);
                    };
                default:
                    return function() {
                        var args = slice.call(arguments);
                        args.unshift(this[attribute]);
                        return base[method].apply(base, args);
                    };
            }
        };
        var addUnderscoreMethods = function(Class, base, methods, attribute) {
            _.each(methods, function(length, method) {
                if (base[method]) Class.prototype[method] = addMethod(base, length, method, attribute);
            });
        }; // Support `collection.sortBy('attr')` and `collection.findWhere({id: 1})`.
        var cb = function(iteratee, instance) {
            if (_.isFunction(iteratee)) return iteratee;
            if (_.isObject(iteratee) && !instance._isModel(iteratee)) return modelMatcher(iteratee);
            if (_.isString(iteratee)) return function(model) {
                return model.get(iteratee);
            };
            return iteratee;
        };
        var modelMatcher = function(attrs) {
            var matcher = _.matches(attrs);
            return function(model) {
                return matcher(model.attributes);
            };
        }; // Underscore methods that we want to implement on the Collection.
        // 90% of the core usefulness of Backbone Collections is actually implemented
        // right here:
        var collectionMethods = {
            forEach: 3,
            each: 3,
            map: 3,
            collect: 3,
            reduce: 0,
            foldl: 0,
            inject: 0,
            reduceRight: 0,
            foldr: 0,
            find: 3,
            detect: 3,
            filter: 3,
            select: 3,
            reject: 3,
            every: 3,
            all: 3,
            some: 3,
            any: 3,
            include: 3,
            includes: 3,
            contains: 3,
            invoke: 0,
            max: 3,
            min: 3,
            toArray: 1,
            size: 1,
            first: 3,
            head: 3,
            take: 3,
            initial: 3,
            rest: 3,
            tail: 3,
            drop: 3,
            last: 3,
            without: 0,
            difference: 0,
            indexOf: 3,
            shuffle: 1,
            lastIndexOf: 3,
            isEmpty: 1,
            chain: 1,
            sample: 3,
            partition: 3,
            groupBy: 3,
            countBy: 3,
            sortBy: 3,
            indexBy: 3,
            findIndex: 3,
            findLastIndex: 3
        }; // Underscore methods that we want to implement on the Model, mapped to the
        // number of arguments they take.
        var modelMethods = {
            keys: 1,
            values: 1,
            pairs: 1,
            invert: 1,
            pick: 0,
            omit: 0,
            chain: 1,
            isEmpty: 1
        }; // Mix in each Underscore method as a proxy to `Collection#models`.
        _.each([
            [
                Collection,
                collectionMethods,
                'models'
            ],
            [
                Model,
                modelMethods,
                'attributes'
            ]
        ], function(config) {
            var Base = config[0], methods = config[1], attribute = config[2];
            Base.mixin = function(obj) {
                var mappings = _.reduce(_.functions(obj), function(memo, name) {
                    memo[name] = 0;
                    return memo;
                }, {});
                addUnderscoreMethods(Base, obj, mappings, attribute);
            };
            addUnderscoreMethods(Base, _, methods, attribute);
        }); // Backbone.sync
        // -------------
        // Override this function to change the manner in which Backbone persists
        // models to the server. You will be passed the type of request, and the
        // model in question. By default, makes a RESTful Ajax request
        // to the model's `url()`. Some possible customizations could be:
        //
        // * Use `setTimeout` to batch rapid-fire updates into a single request.
        // * Send up the models as XML instead of JSON.
        // * Persist models via WebSockets instead of Ajax.
        //
        // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
        // as `POST`, with a `_method` parameter containing the true HTTP method,
        // as well as all requests with the body as `application/x-www-form-urlencoded`
        // instead of `application/json` with the model in a param named `model`.
        // Useful when interfacing with server-side languages like **PHP** that make
        // it difficult to read the body of `PUT` requests.
        Backbone.sync = function(method, model, options) {
            var type = methodMap[method]; // Default options, unless specified.
            _.defaults(options || (options = {}), {
                emulateHTTP: Backbone.emulateHTTP,
                emulateJSON: Backbone.emulateJSON
            }); // Default JSON-request options.
            var params = {
                type: type,
                dataType: 'json'
            }; // Ensure that we have a URL.
            if (!options.url) params.url = _.result(model, 'url') || urlError();
             // Ensure that we have the appropriate request data.
            if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
                params.contentType = 'application/json';
                params.data = JSON.stringify(options.attrs || model.toJSON(options));
            } // For older servers, emulate JSON by encoding the request into an HTML-form.
            if (options.emulateJSON) {
                params.contentType = 'application/x-www-form-urlencoded';
                params.data = params.data ? {
                    model: params.data
                } : {};
            } // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
            // And an `X-HTTP-Method-Override` header.
            if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
                params.type = 'POST';
                if (options.emulateJSON) params.data._method = type;
                var beforeSend = options.beforeSend;
                options.beforeSend = function(xhr) {
                    xhr.setRequestHeader('X-HTTP-Method-Override', type);
                    if (beforeSend) return beforeSend.apply(this, arguments);
                };
            } // Don't process data on a non-GET request.
            if (params.type !== 'GET' && !options.emulateJSON) params.processData = false;
             // Pass along `textStatus` and `errorThrown` from jQuery.
            var error = options.error;
            options.error = function(xhr, textStatus, errorThrown) {
                options.textStatus = textStatus;
                options.errorThrown = errorThrown;
                if (error) error.call(options.context, xhr, textStatus, errorThrown);
            }; // Make the request, allowing the user to override any Ajax options.
            var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
            model.trigger('request', model, xhr, options);
            return xhr;
        }; // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
        var methodMap = {
            create: 'POST',
            update: 'PUT',
            patch: 'PATCH',
            delete: 'DELETE',
            read: 'GET'
        }; // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
        // Override this if you'd like to use a different library.
        Backbone.ajax = function() {
            return Backbone.$.ajax.apply(Backbone.$, arguments);
        }; // Backbone.Router
        // ---------------
        // Routers map faux-URLs to actions, and fire events when routes are
        // matched. Creating a new one sets its `routes` hash, if not set statically.
        var Router = Backbone.Router = function(options) {
            options || (options = {});
            this.preinitialize.apply(this, arguments);
            if (options.routes) this.routes = options.routes;
            this._bindRoutes();
            this.initialize.apply(this, arguments);
        }; // Cached regular expressions for matching named param parts and splatted
        // parts of route strings.
        var optionalParam = /\((.*?)\)/g;
        var namedParam = /(\(\?)?:\w+/g;
        var splatParam = /\*\w+/g;
        var escapeRegExp = /[\-{}\[\]+?.,\\\^$|#\s]/g; // Set up all inheritable **Backbone.Router** properties and methods.
        _.extend(Router.prototype, Events, {
            // preinitialize is an empty function by default. You can override it with a function
            // or object.  preinitialize will run before any instantiation logic is run in the Router.
            preinitialize: function() {},
            // Initialize is an empty function by default. Override it with your own
            // initialization logic.
            initialize: function() {},
            // Manually bind a single named route to a callback. For example:
            //
            //     this.route('search/:query/p:num', 'search', function(query, num) {
            //       ...
            //     });
            //
            route: function(route, name, callback) {
                if (!_.isRegExp(route)) route = this._routeToRegExp(route);
                if (_.isFunction(name)) {
                    callback = name;
                    name = '';
                }
                if (!callback) callback = this[name];
                var router = this;
                Backbone.history.route(route, function(fragment) {
                    var args = router._extractParameters(route, fragment);
                    if (router.execute(callback, args, name) !== false) {
                        router.trigger.apply(router, [
                            'route:' + name
                        ].concat(args));
                        router.trigger('route', name, args);
                        Backbone.history.trigger('route', router, name, args);
                    }
                });
                return this;
            },
            // Execute a route handler with the provided parameters.  This is an
            // excellent place to do pre-route setup or post-route cleanup.
            execute: function(callback, args, name) {
                if (callback) callback.apply(this, args);
            },
            // Simple proxy to `Backbone.history` to save a fragment into the history.
            navigate: function(fragment, options) {
                Backbone.history.navigate(fragment, options);
                return this;
            },
            // Bind all defined routes to `Backbone.history`. We have to reverse the
            // order of the routes here to support behavior where the most general
            // routes can be defined at the bottom of the route map.
            _bindRoutes: function() {
                if (!this.routes) return;
                this.routes = _.result(this, 'routes');
                var route, routes = _.keys(this.routes);
                while((route = routes.pop()) != null)this.route(route, this.routes[route]);
            },
            // Convert a route string into a regular expression, suitable for matching
            // against the current location hash.
            _routeToRegExp: function(route) {
                route = route.replace(escapeRegExp, '\\$&').replace(optionalParam, '(?:$1)?').replace(namedParam, function(match, optional) {
                    return optional ? match : '([^/?]+)';
                }).replace(splatParam, '([^?]*?)');
                return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
            },
            // Given a route, and a URL fragment that it matches, return the array of
            // extracted decoded parameters. Empty or unmatched parameters will be
            // treated as `null` to normalize cross-browser behavior.
            _extractParameters: function(route, fragment) {
                var params = route.exec(fragment).slice(1);
                return _.map(params, function(param, i) {
                    // Don't decode the search params.
                    if (i === params.length - 1) return param || null;
                    return param ? decodeURIComponent(param) : null;
                });
            }
        }); // Backbone.History
        // ----------------
        // Handles cross-browser history management, based on either
        // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
        // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
        // and URL fragments. If the browser supports neither (old IE, natch),
        // falls back to polling.
        var History = Backbone.History = function() {
            this.handlers = [];
            this.checkUrl = this.checkUrl.bind(this); // Ensure that `History` can be used outside of the browser.
            if (typeof window !== 'undefined') {
                this.location = window.location;
                this.history = window.history;
            }
        }; // Cached regex for stripping a leading hash/slash and trailing space.
        var routeStripper = /^[#\/]|\s+$/g; // Cached regex for stripping leading and trailing slashes.
        var rootStripper = /^\/+|\/+$/g; // Cached regex for stripping urls of hash.
        var pathStripper = /#.*$/; // Has the history handling already been started?
        History.started = false; // Set up all inheritable **Backbone.History** properties and methods.
        _.extend(History.prototype, Events, {
            // The default interval to poll for hash changes, if necessary, is
            // twenty times a second.
            interval: 50,
            // Are we at the app root?
            atRoot: function() {
                var path = this.location.pathname.replace(/[^\/]$/, '$&/');
                return path === this.root && !this.getSearch();
            },
            // Does the pathname match the root?
            matchRoot: function() {
                var path = this.decodeFragment(this.location.pathname);
                var rootPath = path.slice(0, this.root.length - 1) + '/';
                return rootPath === this.root;
            },
            // Unicode characters in `location.pathname` are percent encoded so they're
            // decoded for comparison. `%25` should not be decoded since it may be part
            // of an encoded parameter.
            decodeFragment: function(fragment) {
                return decodeURI(fragment.replace(/%25/g, '%2525'));
            },
            // In IE6, the hash fragment and search params are incorrect if the
            // fragment contains `?`.
            getSearch: function() {
                var match = this.location.href.replace(/#.*/, '').match(/\?.+/);
                return match ? match[0] : '';
            },
            // Gets the true hash value. Cannot use location.hash directly due to bug
            // in Firefox where location.hash will always be decoded.
            getHash: function(window1) {
                var match = (window1 || this).location.href.match(/#(.*)$/);
                return match ? match[1] : '';
            },
            // Get the pathname and search params, without the root.
            getPath: function() {
                var path = this.decodeFragment(this.location.pathname + this.getSearch()).slice(this.root.length - 1);
                return path.charAt(0) === '/' ? path.slice(1) : path;
            },
            // Get the cross-browser normalized URL fragment from the path or hash.
            getFragment: function(fragment) {
                if (fragment == null) {
                    if (this._usePushState || !this._wantsHashChange) fragment = this.getPath();
                    else fragment = this.getHash();
                }
                return fragment.replace(routeStripper, '');
            },
            // Start the hash change handling, returning `true` if the current URL matches
            // an existing route, and `false` otherwise.
            start: function(options) {
                if (History.started) throw new Error('Backbone.history has already been started');
                History.started = true; // Figure out the initial configuration. Do we need an iframe?
                // Is pushState desired ... is it available?
                this.options = _.extend({
                    root: '/'
                }, this.options, options);
                this.root = this.options.root;
                this._wantsHashChange = this.options.hashChange !== false;
                this._hasHashChange = 'onhashchange' in window && (document.documentMode === void 0 || document.documentMode > 7);
                this._useHashChange = this._wantsHashChange && this._hasHashChange;
                this._wantsPushState = !!this.options.pushState;
                this._hasPushState = !!(this.history && this.history.pushState);
                this._usePushState = this._wantsPushState && this._hasPushState;
                this.fragment = this.getFragment(); // Normalize root to always include a leading and trailing slash.
                this.root = ('/' + this.root + '/').replace(rootStripper, '/'); // Transition from hashChange to pushState or vice versa if both are
                // requested.
                if (this._wantsHashChange && this._wantsPushState) {
                    // If we've started off with a route from a `pushState`-enabled
                    // browser, but we're currently in a browser that doesn't support it...
                    if (!this._hasPushState && !this.atRoot()) {
                        var rootPath = this.root.slice(0, -1) || '/';
                        this.location.replace(rootPath + '#' + this.getPath()); // Return immediately as browser will do redirect to new url
                        return true; // Or if we've started out with a hash-based route, but we're currently
                    // in a browser where it could be `pushState`-based instead...
                    } else if (this._hasPushState && this.atRoot()) this.navigate(this.getHash(), {
                        replace: true
                    });
                } // Proxy an iframe to handle location events if the browser doesn't
                // support the `hashchange` event, HTML5 history, or the user wants
                // `hashChange` but not `pushState`.
                if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
                    this.iframe = document.createElement('iframe');
                    this.iframe.src = 'javascript:0';
                    this.iframe.style.display = 'none';
                    this.iframe.tabIndex = -1;
                    var body = document.body; // Using `appendChild` will throw on IE < 9 if the document is not ready.
                    var iWindow = body.insertBefore(this.iframe, body.firstChild).contentWindow;
                    iWindow.document.open();
                    iWindow.document.close();
                    iWindow.location.hash = '#' + this.fragment;
                } // Add a cross-platform `addEventListener` shim for older browsers.
                var addEventListener = window.addEventListener || function(eventName, listener) {
                    return attachEvent('on' + eventName, listener);
                }; // Depending on whether we're using pushState or hashes, and whether
                // 'onhashchange' is supported, determine how we check the URL state.
                if (this._usePushState) addEventListener('popstate', this.checkUrl, false);
                else if (this._useHashChange && !this.iframe) addEventListener('hashchange', this.checkUrl, false);
                else if (this._wantsHashChange) this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
                if (!this.options.silent) return this.loadUrl();
            },
            // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
            // but possibly useful for unit testing Routers.
            stop: function() {
                // Add a cross-platform `removeEventListener` shim for older browsers.
                var removeEventListener = window.removeEventListener || function(eventName, listener) {
                    return detachEvent('on' + eventName, listener);
                }; // Remove window listeners.
                if (this._usePushState) removeEventListener('popstate', this.checkUrl, false);
                else if (this._useHashChange && !this.iframe) removeEventListener('hashchange', this.checkUrl, false);
                 // Clean up the iframe if necessary.
                if (this.iframe) {
                    document.body.removeChild(this.iframe);
                    this.iframe = null;
                } // Some environments will throw when clearing an undefined interval.
                if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
                History.started = false;
            },
            // Add a route to be tested when the fragment changes. Routes added later
            // may override previous routes.
            route: function(route, callback) {
                this.handlers.unshift({
                    route: route,
                    callback: callback
                });
            },
            // Checks the current URL to see if it has changed, and if it has,
            // calls `loadUrl`, normalizing across the hidden iframe.
            checkUrl: function(e) {
                var current = this.getFragment(); // If the user pressed the back button, the iframe's hash will have
                // changed and we should use that for comparison.
                if (current === this.fragment && this.iframe) current = this.getHash(this.iframe.contentWindow);
                if (current === this.fragment) return false;
                if (this.iframe) this.navigate(current);
                this.loadUrl();
            },
            // Attempt to load the current URL fragment. If a route succeeds with a
            // match, returns `true`. If no defined routes matches the fragment,
            // returns `false`.
            loadUrl: function(fragment) {
                // If the root doesn't match, no routes can match either.
                if (!this.matchRoot()) return false;
                fragment = this.fragment = this.getFragment(fragment);
                return _.some(this.handlers, function(handler) {
                    if (handler.route.test(fragment)) {
                        handler.callback(fragment);
                        return true;
                    }
                });
            },
            // Save a fragment into the hash history, or replace the URL state if the
            // 'replace' option is passed. You are responsible for properly URL-encoding
            // the fragment in advance.
            //
            // The options object can contain `trigger: true` if you wish to have the
            // route callback be fired (not usually desirable), or `replace: true`, if
            // you wish to modify the current URL without adding an entry to the history.
            navigate: function(fragment, options) {
                if (!History.started) return false;
                if (!options || options === true) options = {
                    trigger: !!options
                }; // Normalize the fragment.
                fragment = this.getFragment(fragment || ''); // Don't include a trailing slash on the root.
                var rootPath = this.root;
                if (fragment === '' || fragment.charAt(0) === '?') rootPath = rootPath.slice(0, -1) || '/';
                var url = rootPath + fragment; // Strip the fragment of the query and hash for matching.
                fragment = fragment.replace(pathStripper, ''); // Decode for matching.
                var decodedFragment = this.decodeFragment(fragment);
                if (this.fragment === decodedFragment) return;
                this.fragment = decodedFragment; // If pushState is available, we use it to set the fragment as a real URL.
                if (this._usePushState) this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url); // If hash changes haven't been explicitly disabled, update the hash
                else if (this._wantsHashChange) {
                    this._updateHash(this.location, fragment, options.replace);
                    if (this.iframe && fragment !== this.getHash(this.iframe.contentWindow)) {
                        var iWindow = this.iframe.contentWindow; // Opening and closing the iframe tricks IE7 and earlier to push a
                        // history entry on hash-tag change.  When replace is true, we don't
                        // want this.
                        if (!options.replace) {
                            iWindow.document.open();
                            iWindow.document.close();
                        }
                        this._updateHash(iWindow.location, fragment, options.replace);
                    } // If you've told us that you explicitly don't want fallback hashchange-
                // based history, then `navigate` becomes a page refresh.
                } else return this.location.assign(url);
                if (options.trigger) return this.loadUrl(fragment);
            },
            // Update the hash location, either replacing the current entry, or adding
            // a new one to the browser history.
            _updateHash: function(location, fragment, replace) {
                if (replace) {
                    var href = location.href.replace(/(javascript:|#).*$/, '');
                    location.replace(href + '#' + fragment);
                } else // Some browsers require that `hash` contains a leading #.
                location.hash = '#' + fragment;
            }
        }); // Create the default Backbone.history.
        Backbone.history = new History(); // Helpers
        // -------
        // Helper function to correctly set up the prototype chain for subclasses.
        // Similar to `goog.inherits`, but uses a hash of prototype properties and
        // class properties to be extended.
        var extend = function(protoProps, staticProps) {
            var parent = this;
            var child; // The constructor function for the new subclass is either defined by you
            // (the "constructor" property in your `extend` definition), or defaulted
            // by us to simply call the parent constructor.
            if (protoProps && _.has(protoProps, 'constructor')) child = protoProps.constructor;
            else child = function() {
                return parent.apply(this, arguments);
            };
             // Add static properties to the constructor function, if supplied.
            _.extend(child, parent, staticProps); // Set the prototype chain to inherit from `parent`, without calling
            // `parent`'s constructor function and add the prototype properties.
            child.prototype = _.create(parent.prototype, protoProps);
            child.prototype.constructor = child; // Set a convenience property in case the parent's prototype is needed
            // later.
            child.__super__ = parent.prototype;
            return child;
        }; // Set up inheritance for the model, collection, router, view and history.
        Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend; // Throw an error when a URL is needed, and none is supplied.
        var urlError = function() {
            throw new Error('A "url" property or function must be specified');
        }; // Wrap an optional error callback with a fallback error event.
        var wrapError = function(model, options) {
            var error = options.error;
            options.error = function(resp) {
                if (error) error.call(options.context, model, resp, options);
                model.trigger('error', model, resp, options);
            };
        };
        return Backbone;
    });
})((0, $4f25ada457d3f624$export$8b22cf2602fb60ce), (0, $4f25ada457d3f624$export$8b22cf2602fb60ce).exports);
var $0be6c25dba7b6ea4$export$2e2bcd8739ae039 = (0, $4f25ada457d3f624$export$8b22cf2602fb60ce).exports;


var $9503954e0739fd37$var$STATE = '__STATE__';
var $9503954e0739fd37$var$FETCH_DATA = 'FETCH_DATA';
var $9503954e0739fd37$var$PAGINATION_DATA = 'PAGINATION_DATA';
var $9503954e0739fd37$var$DEFAULT_PARAMS = 'DEFAULT_PARAMS';
var $9503954e0739fd37$var$LINK_BY_HEADER = 'LINK_BY_HEADER';
var $9503954e0739fd37$var$XHR = 'XHR'; // ################################################
// # Source: https://gist.github.com/deiu/9335803
// ################################################
// unquote string (utility)
function $9503954e0739fd37$var$unquote(value) {
    if (value.charAt(0) === '"' && value.charAt(value.length - 1) === '"') return value.substring(1, value.length - 1);
    return value;
}
/*
parse a Link header
Link:<https://example.org/.meta>; rel=meta
var r = parseLinkHeader(xhr.getResponseHeader('Link');
r['meta']['href'] outputs https://example.org/.meta
*/ function $9503954e0739fd37$var$parseLinkHeader(header) {
    /* eslint max-statements: 0 */ var linkexp = /<[^>]*>\s*(\s*;\s*[^()<>@,;:"/[\]?={} \t]+=(([^()<>@,;:"/[\]?={} \t]+)|("[^"]*")))*(,|$)/g;
    var paramexp = /[^()<>@,;:"/[\]?={} \t]+=(([^()<>@,;:"/[\]?={} \t]+)|("[^"]*"))/g;
    var matches = header.match(linkexp);
    var rels = {};
    for(var i = 0; i < matches.length; i++){
        var split = matches[i].split('>');
        var href = split[0].substring(1);
        var link = {
            href: undefined,
            rel: undefined
        };
        link.href = href;
        var s = split[1].match(paramexp);
        for(var j = 0; j < s.length; j++){
            var paramsplit = s[j].split('=');
            var name = paramsplit[0];
            link[name] = $9503954e0739fd37$var$unquote(paramsplit[1]);
        }
        if (link.rel !== undefined) rels[link.rel] = link;
    }
    return rels;
}
/*
 * Sets the next page URL on the collection from link headers
 * See: http://www.rfc-editor.org/rfc/rfc5988.txt
 *
 * This method is looking for a link header with `rel="next"`
 * An set's it as the next page's URL.
 *
 * If it doesn't find a next page, and current page is set by a link header
 * it assumes we are at the last page and deletes the current `next`
 */ function $9503954e0739fd37$var$setLinkHeadersPagination(collection, xhr) {
    try {
        var links = $9503954e0739fd37$var$parseLinkHeader(xhr.getResponseHeader('link'));
        collection[$9503954e0739fd37$var$STATE].set($9503954e0739fd37$var$LINK_BY_HEADER, true);
        collection.setPagination(links['next'].href);
    } catch (e) {
        if (collection[$9503954e0739fd37$var$STATE].get($9503954e0739fd37$var$LINK_BY_HEADER)) collection.setPagination(null);
    }
}
function $9503954e0739fd37$var$parseQuery(url) {
    var params = {};
    var rawQueryStr = url && url.split('?')[1];
    var queryString = rawQueryStr && rawQueryStr.split('#')[0]; // Do not decode queryString before split by '&' because '&' can be found in value
    var props = queryString ? queryString.split('&') : [];
    for(var i = 0; i < props.length; i++){
        var decode = decodeURIComponent(props[i]).replace(/\+/g, ' ');
        var parts = decode.split('=');
        params[parts.shift()] = parts.join('=');
    }
    return params;
} // ################################################
// # /Source
// ################################################
//
const $9503954e0739fd37$var$collectionProps = /** @lends src/framework/Collection.prototype */ {
    /**
   * Default fetch parameters
   * @type {Object|Function}
   */ params: {},
    preinitialize: function(models, options) {
        const state = new (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Model();
        const defaultParams = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults(options && options.params || {}, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'params') || {});
        state.set($9503954e0739fd37$var$DEFAULT_PARAMS, defaultParams);
        this[$9503954e0739fd37$var$STATE] = state; // Adds support for child class to convert to ES6 Class.
        // After conversion, `this.model` has to be a pure function to return Model Class.
        // The changes below is trying to distinguish the ambiguity between a Class and normal function,
        // as both are JavaScript function essentially.
        // There are three ways to define class for `this.model`
        // 1. Object properties: `model: BaseModel.extend({..})`
        // 2. Function constructor:
        // See example from
        // - appversions/src/models/CustomType.js
        // - appversions/src/models/EnumType.js
        // - appversions/src/models/SignOnMode.js
        // - shared/src/models/SamlAttribute.js
        // 3. Function that returns a class.
        //    model: function() { return BaseModel.extend({..}); }
        //
        // option 1 and 2 exists in code base today
        // option 3 is introduced to support child class to convert to ES6 class.
        // TODO: think of remove following check
        // The reason for `this.model !== Backbone.Model` is because `this.model` is default to `Backbone.Model`
        // set at Backbone.Collection.
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(this.model) && this.model.length === 0 && this.model.isCourageModel !== true) this.model = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'model');
        (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Collection.prototype.preinitialize.apply(this, arguments);
    },
    /**
   * See [Backbone Collection.sync](http://backbonejs.org/#Collection-sync).
   */ sync: function(method, collection, options) {
        var self = this;
        var success = options.success;
        options.success = function(resp, status, xhr) {
            // its important to set the pagination data *before* we call the success callback
            // because we want the pagination data to be ready when the collection triggers the `sync` event
            $9503954e0739fd37$var$setLinkHeadersPagination(self, xhr);
            success.apply(null, arguments);
        };
        return (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Collection.prototype.sync.call(this, method, collection, options);
    },
    /**
   * See [Backbone Collection.fetch](http://backbonejs.org/#Collection-fetch).
   */ fetch: function(options) {
        options || (options = {});
        var state = this[$9503954e0739fd37$var$STATE];
        var xhr = state.get($9503954e0739fd37$var$XHR);
        options.data = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({}, state.get($9503954e0739fd37$var$DEFAULT_PARAMS), options.data || {});
        options.fromFetch = true;
        state.set($9503954e0739fd37$var$FETCH_DATA, options.data);
        if (xhr && xhr.abort && options.abort !== false) xhr.abort();
        xhr = (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Collection.prototype.fetch.call(this, options);
        state.set($9503954e0739fd37$var$XHR, xhr);
        return xhr;
    },
    /**
   * Set pagination data to get to the next page
   * @param {Mixed} params
   * @param {Object} [options]
   * @param {Boolean} [options.fromFetch] should we include data from the previous fetch call in this object
   * @example
   * collection.setPagination({q: 'foo', page: '2'}); //=> {q: 'foo', page: '2'}
   *
   * collection.setPagination('/path/to/resource?q=baz&page=4'); //=> {q: 'baz', page: '4'}
   *
   * collection.setPagination('/path/to/resource'); //=> {}
   *
   * collection.fetch({data: {q: 'foo'}});
   * collection.setPagination({page: 2}, {fromFetch: true}); //=> {q: 'foo', page: 2}
   *
   * any "falsy" value resets pagination
   * collection.setPagination(); //=> {}
   * collection.setPagination(null); //=> {}
   * collection.setPagination(false); //=> {}
   * collection.setPagination(''); //=> {}
   * collection.setPagination(0); //=> {}
   * @protected
   */ setPagination: function(params, options) {
        /* eslint complexity: [2, 8] */ if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isString(params) && params) params = $9503954e0739fd37$var$parseQuery(params);
        if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isObject(params) || (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(params) || !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).size(params)) params = null;
        else if (options && options.fromFetch) params = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({}, this.getFetchData(), params);
        this[$9503954e0739fd37$var$STATE].set($9503954e0739fd37$var$PAGINATION_DATA, params);
    },
    /**
   * Returns the `data` parameters applied in th most recent `fetch` call
   * It will include parameters set by {@link #params} and optios.params passed to the constructor
   * @return {Object}
   * @protected
   */ getFetchData: function() {
        return this[$9503954e0739fd37$var$STATE].get($9503954e0739fd37$var$FETCH_DATA) || {};
    },
    /**
   * Data object for constructing a request to fetch the next page
   * @return {Object}
   * @protected
   */ getPaginationData: function() {
        return this[$9503954e0739fd37$var$STATE].get($9503954e0739fd37$var$PAGINATION_DATA) || {};
    },
    /**
   * Does this collection have more data on the server (e.g is there a next "page")
   * @return {Boolean}
   */ hasMore: function() {
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).size(this.getPaginationData()) > 0;
    },
    /**
   * Get the next page from the server
   * @return {Object} xhr returned by {@link #fetch}
   */ fetchMore: function() {
        if (!this.hasMore()) throw new Error('Invalid Request');
        return this.fetch({
            data: this.getPaginationData(),
            add: true,
            remove: false,
            update: true
        });
    },
    /**
   * See [Backbone Collection.reset](http://backbonejs.org/#Collection-reset).
   */ reset: function(models, options) {
        options || (options = {}); // only reset the pagination when reset is being called explicitly.
        // this is to avoid link headers pagination being overriden and reset when
        // fetching the collection using `collection.fetch({reset: true})`
        if (!options.fromFetch) this.setPagination(null);
        return (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Collection.prototype.reset.apply(this, arguments);
    },
    // we want "where" to be able to search through derived properties as well
    where: function(attrs, first) {
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(attrs)) return first ? void 0 : [];
        return this[first ? 'find' : 'filter'](function(model) {
            for(var key in attrs){
                if (attrs[key] !== model.get(key)) return false;
            }
            return true;
        });
    },
    /**
   * See [Backbone Collection.create](http://backbonejs.org/#Collection-create).
   */ create: function(model, options) {
        options || (options = {});
        if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(model, 'urlRoot')) options.url = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'url');
        return (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Collection.prototype.create.call(this, model, options);
    },
    // Use Object.create instead of {} on _byId to avoid __proto__ functions to return
    // This can be removed once the issue has addressed in backbone framework
    // https://github.com/jashkenas/backbone/pull/4225
    _reset: function() {
        (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Collection.prototype['_reset'].call(this);
        this._byId = Object.create(null);
    }
};
/**
 *
 * Archer.Collection is a standard [Backbone.Collection](http://backbonejs.org/#Collection) with pre-set `data`
 * parameters and built in pagination - works with [http link headers](https://tools.ietf.org/html/rfc5988)
 * out of the box:
 *
 * @class src/framework/Collection
 * @extends external:Backbone.Collection
 * @example
 * var Users = Archer.Collection.extend({
 *   url: '/api/v1/users'
 *   params: {expand: true}
 * });
 * var users = new Users(null, {params: {type: 'new'}}),
 *     $button = this.$('a.fetch-more');
 *
 * $button.click(function () {
 *   users.fetchMore();
 * });
 *
 * this.listenTo(users, 'sync', function () {
 *   $button.toggle(users.hasMore());
 * });
 *
 * collection.fetch(); //=> '/api/v1/users?expand=true&type=new'
 */ const $9503954e0739fd37$export$2e2bcd8739ae039 = (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Collection.extend($9503954e0739fd37$var$collectionProps);
/**
 * It's used for distinguishing the ambiguity from _.isFunction()
 * which returns True for both a JavaScript Class constructor function
 * and normal function. With this flag, we can tell a function is actually
 * a Collection Class.
 * This flag is added in order to support the type of a parameter can be
 * either a Class or pure function that returns a Class.
 */ $9503954e0739fd37$export$2e2bcd8739ae039.isCourageCollection = true;


const $e9e519c40171c3aa$var$baseCollectionProps = /** @lends module:Okta.Collection.prototype */ {
    /**
   * Is the end point using the legacy "secureJSON" format
   * @type {Function|Boolean}
   */ secureJSON: false,
    // TODO: may not be simplily moved to initialize as
    // child class override initialize but didn't invoke parent.initialize.
    // need to refactor child classes first.
    constructor: function() {
        (0, $9503954e0739fd37$export$2e2bcd8739ae039).apply(this, arguments);
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'secureJSON')) this.sync = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).wrap(this.sync, function(sync, method, collection, options) {
            return sync.call(this, method, collection, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({
                dataType: 'secureJSON'
            }, options));
        });
    },
    sync: function(method, collection, options) {
        const { scopes: scopes = [], authParams: authParams } = collection;
        options ??= {};
        options.scopes = scopes;
        options.authParams = authParams;
        return (0, $9503954e0739fd37$export$2e2bcd8739ae039).prototype.sync.call(this, method, collection, options);
    }
};
/**
 * Wrapper around the more generic {@link src/framework/Collection} that
 * contains Okta-specific logic.
 * @class module:Okta.Collection
 * @extends src/framework/Collection
 */ var $e9e519c40171c3aa$export$2e2bcd8739ae039 = (0, $9503954e0739fd37$export$2e2bcd8739ae039).extend($e9e519c40171c3aa$var$baseCollectionProps);






function $0a955689ee70463b$export$bd5f4dbbf4074d23(obj) {
    return obj && obj.type || obj.deps;
}
/**
   * Archer.Model is a standard [Backbone.Model](http://backbonejs.org/#Model) with a few additions:
   *
   * - {@link src/framework/Model#derived Derived properties}
   * - {@link src/framework/Model#props Built in schema validation}
   * - {@link src/framework/Model#local Private properties (with schema validation)}
   * - {@link src/framework/Model#flat Flattening of nested objects}
   *
   * Both derived and private properties are filtered out when sending the data to the server.
   *
   * See [Backbone.Model](http://backbonejs.org/#Model-constructor).
   *
   * @class src/framework/Model
   * @extends external:Backbone.Model
   * @param {Object} [attributes] - Initial model attributes (data)
   * @param {Object} [options] - Options hash
   * @example
   * var Person = Archer.Model.extend({
   *   props: {
   *     'fname': 'string',
   *     'lname': 'string'
   *   },
   *   local: {
   *     isLoggedIn: 'boolean'
   *   },
   *   derived: {
   *     name: {
   *       deps: ['fname', 'lname'],
   *       fn: function (fname, lname) {
   *         return fname + ' ' + lname;
   *       }
   *     }
   *   }
   * });
   * var model = new Person({fname: 'Joe', lname: 'Doe'});
   * model.get('name'); //=> "Joe Doe"
   * model.toJSON(); //=> {fname: 'Joe', lname: 'Doe'}
   *
   * model.set('isLoggedIn', true);
   * model.get('isLoggedIn'); //=> true
   * model.toJSON(); //=> {fname: 'Joe', lname: 'Doe'}
   */ let $0a955689ee70463b$var$Model;
const $0a955689ee70463b$var$statics = {
    ERROR_BLANK: 'model.validation.field.blank',
    ERROR_WRONG_TYPE: 'model.validation.field.wrong.type',
    ERROR_NOT_ALLOWED: 'model.validation.field.value.not.allowed',
    ERROR_INVALID: 'model.validation.field.invalid',
    ERROR_IARRAY_UNIQUE: 'model.validation.field.array.unique',
    ERROR_INVALID_FORMAT_EMAIL: 'model.validation.field.invalid.format.email',
    ERROR_INVALID_FORMAT_URI: 'model.validation.field.invalid.format.uri',
    ERROR_INVALID_FORMAT_IPV4: 'model.validation.field.invalid.format.ipv4',
    ERROR_INVALID_FORMAT_HOSTNAME: 'model.validation.field.invalid.format.hostname',
    ERROR_STRING_STRING_MIN_LENGTH: 'model.validation.field.string.minLength',
    ERROR_STRING_STRING_MAX_LENGTH: 'model.validation.field.string.maxLength'
};
function $0a955689ee70463b$var$flatten(value, objectTypeFields, key, target) {
    var filter = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains(objectTypeFields, key);
    target || (target = {});
    if (!filter && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isObject(value) && !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(value) && !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(value)) (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(value, function(val, i) {
        $0a955689ee70463b$var$flatten(val, objectTypeFields, key ? key + '.' + i : i, target);
    });
    else if (key !== undefined) target[key] = value;
    return target;
}
function $0a955689ee70463b$var$unflatten(data) {
    (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(data, function(value, key, data) {
        if (key.indexOf('.') === -1) return;
        var part;
        var ref = data;
        var parts = key.split('.');
        while((part = parts.shift()) !== undefined){
            if (!ref[part]) ref[part] = parts.length ? {} : value;
            ref = ref[part];
        }
        delete data[key];
    });
    return data;
}
function $0a955689ee70463b$var$createMessage(field, msg) {
    var obj = {};
    obj[field.name] = msg;
    return obj;
}
function $0a955689ee70463b$var$normalizeSchemaDef(field, name) {
    var target;
    if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isString(field)) target = {
        type: field
    };
    else if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(field)) target = {
        type: field[0],
        required: field[1],
        value: field[2]
    };
    else target = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone(field);
    (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults(target, {
        required: false,
        name: name
    });
    return target;
}
function $0a955689ee70463b$var$capitalize(string) {
    return string.toLowerCase().replace(/\b[a-z]/g, function(letter) {
        return letter.toUpperCase();
    });
}
function $0a955689ee70463b$var$_validateRegex(value, pattern, error) {
    if (!pattern.test(value)) return error;
}
var $0a955689ee70463b$var$StringFormatValidators = {
    /*eslint max-len: 0 */ email: function(value) {
        // Taken from  http://emailregex.com/ on 2017-03-06.
        var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return $0a955689ee70463b$var$_validateRegex(value, pattern, $0a955689ee70463b$var$Model.ERROR_INVALID_FORMAT_EMAIL);
    },
    uri: function(value) {
        // source: https://mathiasbynens.be/demo/url-regex
        var pattern = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;
        return $0a955689ee70463b$var$_validateRegex(value, pattern, $0a955689ee70463b$var$Model.ERROR_INVALID_FORMAT_URI);
    },
    ipv4: function(value) {
        // source: https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
        var pattern = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        return $0a955689ee70463b$var$_validateRegex(value, pattern, $0a955689ee70463b$var$Model.ERROR_INVALID_FORMAT_IPV4);
    },
    hostname: function(value) {
        // source: http://www.regextester.com/23
        var pattern = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$/;
        return $0a955689ee70463b$var$_validateRegex(value, pattern, $0a955689ee70463b$var$Model.ERROR_INVALID_FORMAT_HOSTNAME);
    }
};
function $0a955689ee70463b$var$validateStringFormat(field, value) {
    var validator = $0a955689ee70463b$var$StringFormatValidators[field.format];
    if (field.format && !validator) throw new TypeError(field.format + ' is not a supported string format');
    return validator && validator(value);
}
function $0a955689ee70463b$var$validateString(field, value) {
    var createMessageWith = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial($0a955689ee70463b$var$createMessage, field);
    var invalidFormat = $0a955689ee70463b$var$validateStringFormat(field, value);
    if (invalidFormat) return createMessageWith(invalidFormat);
    if (value && field.minLength && value.length < field.minLength) return createMessageWith($0a955689ee70463b$var$Model.ERROR_STRING_STRING_MIN_LENGTH);
    if (value && field.maxLength && value.length > field.maxLength) return createMessageWith($0a955689ee70463b$var$Model.ERROR_STRING_STRING_MAX_LENGTH);
}
function $0a955689ee70463b$var$validateField(field, value) {
    /* eslint complexity: [2, 25], max-statements: [2, 30] */ var createMessageWith = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial($0a955689ee70463b$var$createMessage, field);
    var isDefined = !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isUndefined(value) && !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isNull(value);
    var checkType;
    var errorMessage; // If using an array validator, perform the validation
    if (Array.isArray(field.validate)) {
        const output = [];
        let foundError = false;
        let result;
        field.validate.forEach((item)=>{
            if (!value) result = false;
            else switch(item.type.toLowerCase()){
                case 'regex':
                    result = new RegExp(item.value.pattern, item.value.flags || '').test(value);
                    break;
                default:
                    result = false;
            }
             // Append the result.
            foundError = foundError || !result;
            output.push({
                // eslint-disable-next-line no-prototype-builtins
                message: item.hasOwnProperty('message') ? item.message : '',
                passed: result
            });
        });
        if (foundError) return createMessageWith(output);
        return;
    } // check required fields
    if (field.required && (!isDefined || (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isNull(value) || value === '')) return createMessageWith($0a955689ee70463b$var$Model.ERROR_BLANK);
     // check type
    checkType = (0, $3e490973b7383cc4$export$2e2bcd8739ae039)['is' + $0a955689ee70463b$var$capitalize(field.type)];
    if (isDefined && field.type !== 'any' && (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(checkType) || !checkType(value))) return createMessageWith($0a955689ee70463b$var$Model.ERROR_WRONG_TYPE);
     // validate string format
    if (value && field.type === 'string') {
        var error = $0a955689ee70463b$var$validateString(field, value);
        if (error) return error;
    } // check pre set values (enum)
    if (isDefined && field.values && !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains(field.values, value)) return createMessageWith($0a955689ee70463b$var$Model.ERROR_NOT_ALLOWED);
     // check validate method
    if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(field.validate)) {
        var result = field.validate(value);
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isString(result) && result) return createMessageWith(result);
        else if (result === false) return createMessageWith($0a955689ee70463b$var$Model.ERROR_INVALID);
    } // check array items
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    if (isDefined && field.type === 'array' && (errorMessage = $0a955689ee70463b$var$validateArrayField(field, value))) return createMessageWith(errorMessage);
}
function $0a955689ee70463b$var$validateArrayField(field, arr) {
    if (field.minItems && arr.length < field.minItems) return 'model.validation.field.array.minItems';
    else if (field.maxItems && arr.length > field.maxItems) return 'model.validation.field.array.maxItems';
    else if (field.uniqueItems && arr.length > (0, $3e490973b7383cc4$export$2e2bcd8739ae039).uniq(arr).length) return $0a955689ee70463b$var$Model.ERROR_IARRAY_UNIQUE;
    else if (field.items) {
        /* eslint max-depth: [2, 3] */ var arrayField = $0a955689ee70463b$var$normalizeSchemaDef(field.items, 'placeholder');
        for(var i = 0; i < arr.length; i++){
            var value = arr[i];
            var error = $0a955689ee70463b$var$validateField(arrayField, value);
            if (error) return error['placeholder'];
        }
    }
}
const $0a955689ee70463b$var$props = /** @lends src/framework/Model.prototype */ {
    /**
     * Pass props as an object to extend, describing the observable properties of your model. The props
     * properties should not be set on an instance, as this won't define new properties, they should only be passed to
     * extend.
     * Properties can be defined in three different ways:
     *
     * - As a string with the expected dataType. One of string, number, boolean, array, object, date, or any.
     * Eg: `name: 'string'`.
     * - An array of `[dataType, required, default]`
     * - An object `{type: 'string', format: '', required: true, value: '', values: [], validate: function() {}`
     *   - `value` will be the value that the property will be set to if it is undefined, either by not being set during
     *   initialization, or by being explicitly set to undefined.
     *   - `format` is a json-schame derived string format. Supported formats are: `email`, `uri`, `hostname` and `ipv4`.
     *   - If `required` is true, one of two things will happen. If a default is set for the property, the property will
     *   start with that value. If a default is not set for the property, validation will fail
     *   - If `values` array is passed, then you'll be able to change a property to one of those values only.
     *   - If `validate` is defined, it should return false or a custom message string when the validation fails.
     *   - If the type is defined as `array`, the array elements could be defined by `minItems` (Number),
     *   `uniqueItems` (Boolean) and `items` (a field definition such as this one that will validate each array member)
     *   To the `validate` method
     *   - Trying to set a property to an invalid type will raise an exception.
     *
     * @type {Mixed|Function}
     * @example
     * var Person = Model.extend({
     *   props: {
     *     name: 'string',
     *     age: 'number',
     *     paying: ['boolean', true, false], //required attribute, defaulted to false
     *     type: {
     *       type: 'string',
     *       values: ['regular-hero', 'super-hero', 'mega-hero']
     *     },
     *     likes: {
     *       type: 'string',
     *       validate: function (value) {
     *         return /^[\w]+ing$/.test(value)
     *       }
     *     }
     *   }
     * });
     */ props: {},
    /**
     * Derived properties (also known as computed properties) are properties of the model that depend on the
     * other (props, local or even derived properties to determine their value. Best demonstrated with an example:
     *
     * Each derived property, is defined as an object with the current properties:
     *
     * - `deps` {Array} - An array of property names which the derived property depends on.
     * - `fn` {Function} - A function which returns the value of the computed property. It is called in the context of
     * the current object, so that this is set correctly.
     * - `cache` {Boolean} -  - Whether to cache the property. Uncached properties are computed every time they are
     * accessed. Useful if it depends on the current time for example. Defaults to `true`.
     *
     * Derived properties are retrieved and fire change events just like any other property. They cannot be set
     * directly.
     * @type {Object|Function}
     * @example
     * var Person = Model.extend({
     *   props: {
     *     firstName: 'string',
     *     lastName: 'string'
     *   },
     *   derived: {
     *     fullName: {
     *       deps: ['firstName', 'lastName'],
     *       fn: function (firstName, lastName) {
     *         return firstName + ' ' + lastName;
     *       }
     *     }
     *   }
     * });
     *
     * var person = new Person({ firstName: 'Phil', lastName: 'Roberts' })
     * console.log(person.get('fullName')) //=> "Phil Roberts"
     *
     * person.set('firstName', 'Bob');
     * console.log(person.get('fullName')) //=> "Bob Roberts"
     */ derived: {},
    /**
     * local properties are defined and work in exactly the same way as {@link src/framework/Model#props|props}, but generally only exist for
     * the lifetime of the page.
     * They would not typically be persisted to the server, and are not returned by calls to {@link src/framework/Model#toJSON|toJSON}.
     *
     * @type {Object|Function}
     * @example
     * var Person = Model.extend({
     *   props: {
     *     name: 'string',
     *   },
     *   local: {
     *     isLoggedIn: 'boolean'
     *   }
     * );
     */ local: {},
    /**
     * Flatten the payload into dot notation string keys:
     *
     * @type {Boolean|Function}
     * @example
     * var Person = Model.extend({
     *   props: {
     *     'profile.fname': 'string',
     *     'profile.lname': 'string',
     *     'profile.languages': 'object'
     *   },
     *   flat: true
     * });
     * var person = new Person({'profile': {
     *                            'fname': 'John',
     *                            'lname': 'Doe',
     *                            'languages': {name: "English", value: "EN"}
     *                         }}, {parse: true});
     * person.get('profile'); //=> undefined
     * person.get('profile.fname'); //=> 'John'
     * person.get('profile.lname'); //=> 'Doe'
     * person.get('profile.languages'); //=> {name: "English", value: "EN"}
     * person.get('profile.languages.name'); //=> undefined
     * person.toJSON(); //=> {'profile': {'fname': 'John'} }
     */ flat: true,
    /**
     * @deprecated
     * @alias Backbone.Model#defaults
     */ defaults: {},
    // FIXME: preinitialize takes parameter `attributes` and `options`, which inherit from constructor.
    preinitialize: function(options, ...rest) {
        this.options = options || {};
        var schema = this['__schema__'] = {};
        var objectTypeFields = [];
        schema.computedProperties = {};
        schema.props = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone((0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'props') || {});
        schema.derived = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone((0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'derived') || {});
        schema.local = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone((0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'local') || {});
        var defaults = {};
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each((0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({}, schema.props, schema.local), function(options, name) {
            var schemaDef = $0a955689ee70463b$var$normalizeSchemaDef(options, name);
            if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isUndefined(schemaDef.value)) defaults[name] = schemaDef.value;
            if (schemaDef.type === 'object') objectTypeFields.push(name);
        }, this);
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).size(defaults)) {
            var localDefaults = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'defaults');
            this.defaults = function() {
                return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults({}, defaults, localDefaults);
            };
        } // override `validate`
        this.validate = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).wrap(this.validate, function(validate) {
            var args = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).rest(arguments);
            var res = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend(this._validateSchema.apply(this, args), validate.apply(this, args));
            return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).size(res) && res || undefined;
        }); // override `parse`
        this.parse = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).wrap(this.parse, function(parse) {
            var target = parse.apply(this, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).rest(arguments));
            if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'flat')) target = $0a955689ee70463b$var$flatten(target, objectTypeFields);
            return target;
        });
        (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Model.prototype.preinitialize.call(this, options, ...rest);
    },
    // FIXME:
    // constructor takes parameter `attributes` and `options`.
    constructor: function() {
        (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Model.apply(this, arguments);
        var schema = this['__schema__'];
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(schema.derived, function(options, name) {
            schema.computedProperties[name] = this.__getDerivedValue(name); // set initial value;
            var deps = $0a955689ee70463b$export$bd5f4dbbf4074d23(options) ? options.deps || [] : [];
            if (deps.length) this.on('cache:clear change:' + deps.join(' change:'), function() {
                var value = this.__getDerivedValue(name);
                if (value !== schema.computedProperties[name]) {
                    schema.computedProperties[name] = value;
                    this.trigger('change:' + name, this, value);
                }
            }, this);
        }, this);
        this.on('sync', function() {
            this.__syncedData = this.toJSON();
        }, this);
    },
    validate: function() {},
    /**
     * Check if the schema settings allow this field to exist in the model
    */ allows: function() {
        return true;
    },
    /**
     * Returns the schema for the specific property
     *
     * @param propName - The name of the property
     * @returns {*} | null
     */ getPropertySchema: function(propName) {
        var schema = this['__schema__'];
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).reduce([
            schema.props,
            schema.local
        ], function(result, options) {
            return result || $0a955689ee70463b$var$normalizeSchemaDef(options[propName], propName);
        }, null);
    },
    set: function(key, val) {
        var attrs;
        if (typeof key === 'object') attrs = key;
        else (attrs = {})[key] = val;
         // Don't override a computed properties
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(attrs, function(value, key) {
            if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).has(this['__schema__'].derived, key)) throw new Error(`overriding derived properties is not supported: ${key}`);
        }, this); // Schema validation
        var errorFields = [];
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(attrs, function(value, key) {
            this.allows(key) || errorFields.push(key);
        }, this);
        if (errorFields.length) throw new Error(`field not allowed: ${errorFields.join(', ')}`);
        return (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Model.prototype.set.apply(this, arguments);
    },
    get: function(attr) {
        var schema = this['__schema__'];
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).has(schema.derived, attr)) {
            if (schema.derived[attr].cache !== false) return schema.computedProperties[attr];
            else return this.__getDerivedValue(attr);
        }
        return (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Model.prototype.get.apply(this, arguments);
    },
    /**
     * Return a shallow copy of the model's attributes for JSON stringification.
     * This can be used for persistence, serialization, or for augmentation before being sent to the server.
     * The name of this method is a bit confusing, as it doesn't actually return a JSON string —
     * but I'm afraid that it's the way that the JavaScript API for JSON.stringify works.
     *
     * See [Backbone.Model.toJSON](http://backbonejs.org/#Model-toJSON)
     *
     * @param  {Object} options
     * @return {Object}
     * @example
     * var artist = new Model({
     *   firstName: 'Wassily',
     *   lastName: 'Kandinsky'
     * });
     *
     * artist.set({birthday: 'December 16, 1866'});
     * JSON.stringify(artist); //=> {'firstName':'Wassily','lastName':'Kandinsky','birthday':'December 16, 1866'}
     */ toJSON: function(options) {
        options || (options = {});
        var res = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone((0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Model.prototype.toJSON.apply(this, arguments));
        var schema = this['__schema__']; // cleanup local properties
        if (!options.verbose) res = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(res, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).keys(schema.local));
        else // add derived properties
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(schema.derived, function(options, name) {
            res[name] = this.get(name);
        }, this);
        if (this.flat) res = $0a955689ee70463b$var$unflatten(res);
        return res;
    },
    /**
     * Removes all attributes from the model, including the id attribute.
     * Fires a `"change"` event unless `silent` is passed as an option.
     * Sets the default values to the model
     * @param {Object} [options]
     */ reset: function(options) {
        this.clear(options);
        this.set((0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'defaults'), options);
    },
    /**
     * Is the data on the model has local modifications since the last sync event?
     * @return {Boolean} is the model in sync with the server
     */ isSynced: function() {
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEqual(this.__syncedData, this.toJSON());
    },
    /**
     * validate a specific field in the model.
     * @param  {String} key
     * @return {Object} returns `{fieldName: errorMessage}` if invalid, otherwise undefined.
     * @readonly
     */ validateField: function(key) {
        var schema = key && this.getPropertySchema(key);
        return schema && $0a955689ee70463b$var$validateField(schema, this.get(key));
    },
    /**
     * Runs local schema validation. Invoked internally by {@link src/framework/Model#validate|validate}.
     * @return {Object}
     * @protected
     */ _validateSchema: function() {
        var schema = this['__schema__'];
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).reduce((0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({}, schema.props, schema.local), function(memo, options, name) {
            return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend(memo, this.validateField(name) || {});
        }, {}, this);
    },
    __getDerivedValue: function(name) {
        var options = this['__schema__'].derived[name];
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isString(options)) {
            var key = options;
            options = {
                deps: [
                    key
                ],
                fn: function() {
                    return this.get(key);
                }
            };
        }
        var deps = options.deps || [];
        return options.fn.apply(this, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).map(deps, this.get, this));
    }
};
$0a955689ee70463b$var$Model = (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Model.extend($0a955689ee70463b$var$props, $0a955689ee70463b$var$statics);
/**
 * It's used for distinguishing the ambiguity from _.isFunction()
 * which returns True for both a JavaScript Class constructor function
 * and normal function. With this flag, we can tell a function is actually
 * a Model Class.
 * This flag is added in order to support the type of a parameter can be
 * either a Class or pure function that returns a Class.
 */ $0a955689ee70463b$var$Model.isCourageModel = true;
var $0a955689ee70463b$export$2e2bcd8739ae039 = $0a955689ee70463b$var$Model;


/**
 * Wrapper around the more generic {@link src/framework/Model} that
 * contains Okta-specific logic.
 * @class module:Okta.Model
 * @extends src/framework/Model
 */ var $5ff5548bf63df3e3$export$2e2bcd8739ae039 = (0, $0a955689ee70463b$export$2e2bcd8739ae039).extend(/** @lends module:Okta.Model.prototype */ {
    /**
   * Is the end point using the legacy "secureJSON" format
   * @type {Function|Boolean}
   */ secureJSON: false,
    _builtInLocalProps: {
        __edit__: 'boolean',
        __pending__: 'boolean'
    },
    preinitialize: function() {
        this.local = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults({}, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'local'), this._builtInLocalProps);
        (0, $0a955689ee70463b$export$2e2bcd8739ae039).prototype.preinitialize.apply(this, arguments);
    },
    constructor: function() {
        (0, $0a955689ee70463b$export$2e2bcd8739ae039).apply(this, arguments);
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'secureJSON')) this.sync = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).wrap(this.sync, function(sync, method, model, options) {
            return sync.call(this, method, model, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({
                dataType: 'secureJSON'
            }, options));
        });
    },
    sync: function(method, model, options) {
        options ??= {};
        const { scopes: scopes = [], authParams: authParams } = model;
        options.scopes = scopes;
        options.authParams = authParams;
        return (0, $0a955689ee70463b$export$2e2bcd8739ae039).prototype.sync.apply(this, [
            method,
            model,
            options
        ]);
    }
});


const $82ddb6bf367b57ea$var$hasProps = function(model) {
    const local = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(model.local, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).keys(model._builtInLocalProps));
    return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).size(model.props) + (0, $3e490973b7383cc4$export$2e2bcd8739ae039).size(local) > 0;
};
const $82ddb6bf367b57ea$var$props = /** @lends module:Okta.BaseModel.prototype */ {
    /**
   * @type {Boolean}
   */ flat: false,
    constructor: function() {
        (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039).apply(this, arguments);
        this.on('sync', this._setSynced);
    },
    allows: function() {
        if ($82ddb6bf367b57ea$var$hasProps(this)) return (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039).prototype.allows.apply(this, arguments);
        else return true;
    },
    // bw compatibility support for old computed properties
    set: function(key, val) {
        let attrs;
        if (typeof key === 'object') attrs = key;
        else (attrs = {})[key] = val;
         // computed properties
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039)(attrs).each(function(fn, attr) {
            if (!fn || !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(fn.__attributes)) return;
            this.on('change:' + fn.__attributes.join(' change:'), function() {
                const val = this.get(attr);
                if (val !== this['__schema__'].computedProperties[attr]) {
                    this['__schema__'].computedProperties[attr] = val;
                    this.trigger('change:' + attr, val);
                }
            }, this);
        }, this);
        return (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039).prototype.set.apply(this, arguments);
    },
    /**
   * Get the current value of an attribute from the model. For example: `note.get("title")`
   *
   * See [Model.get](http://backbonejs.org/#Model-get)
   * @param {String} attribute
   * @return {Mixed} The value of the model attribute
   */ get: function() {
        const value = (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039).prototype.get.apply(this, arguments);
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(value)) return value.apply(this, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).map(value.__attributes || [], this.get, this));
        return value;
    },
    /**
   * Return a shallow copy of the model's attributes for JSON stringification.
   * This can be used for persistence, serialization, or for augmentation before being sent to the server.
   * The name of this method is a bit confusing, as it doesn't actually return a JSON string —
   *  but I'm afraid that it's the way that the JavaScript API for JSON.stringify works.
   *
   * ```javascript
   * var artist = new Model({
   *   firstName: "Wassily",
   *   lastName: "Kandinsky"
   * });
   *
   * artist.set({birthday: "December 16, 1866"});
   * alert(JSON.stringify(artist)); // {"firstName":"Wassily","lastName":"Kandinsky","birthday":"December 16, 1866"}
   * ```
   * See [Model.toJSON](http://backbonejs.org/#Model-toJSON)
   * @param  {Object} options
   * @return {Object}
   */ toJSON: function(options) {
        options || (options = {});
        const res = (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039).prototype.toJSON.apply(this, arguments); // cleanup computed properties
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039)(res).each(function(value, key) {
            if (typeof value === 'function') {
                if (options.verbose) res[key] = this.get(key);
                else delete res[key];
            }
        }, this); // cleanup private properties
        if (!options.verbose) (0, $3e490973b7383cc4$export$2e2bcd8739ae039)(res).each(function(value, key) {
            if (/^__\w+__$/.test(key)) delete res[key];
        });
        return res;
    },
    sanitizeAttributes: function(attributes) {
        const attrs = {};
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(attributes, function(value, key) {
            if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(value)) attrs[key] = value;
        });
        return attrs;
    },
    reset: function(options) {
        this.clear(options);
        this.set(this.sanitizeAttributes(this.defaults), options);
    },
    clear: function(options) {
        const attrs = {};
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(this.sanitizeAttributes(this.attributes), function(value, key) {
            attrs[key] = void 0;
        });
        return this.set(attrs, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({}, options, {
            unset: true
        }));
    },
    /**
   * @private
   */ _setSynced: function(newModel) {
        this._syncedData = newModel && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(newModel.toJSON) ? newModel.toJSON() : {};
    },
    /**
   * @private
   */ _getSynced: function() {
        return this._syncedData;
    },
    isSynced: function() {
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEqual(this._getSynced(), this.toJSON());
    }
};
const $82ddb6bf367b57ea$var$statics = /** @lends module:Okta.BaseModel.prototype */ {
    /**
   * @static
   *
   * Example:
   *
   * ```javascript
   * var Model = BaseModel.extend({
   *   defaults: {
   *     name: BaseModel.ComputedProperty(['fname', 'lname'], function (fname, lname) {
   *       return fname + ' ' + lname;
   *     })
   *   }
   * });
   * var model = new Model({fname: 'Joe', lname: 'Doe'});
   * model.get('name'); // Joe Doe
   * model.toJSON(); // {fname: 'Joe', lname: 'Doe'}
   * ```
   *
   * @param {Array} attributes (optional) - an array of the attribute names this method depends on
   * @param {Function} callback the function that computes the value of the property
   *
   * @deprecated Use {@link #derived} instead
   */ ComputedProperty: function(attributes, fn) {
        // First parameter is optional
        if (!fn && typeof attributes === 'function') fn = attributes;
        else fn.__attributes = attributes;
        return fn;
    }
};
/**
 * @class module:Okta.BaseModel
 * @extends module:Okta.Model
 * @deprecated Use {@link module:Okta.Model|Okta.Model} instead
 * @example
 * var Model = BaseModel.extend({
 *   defaults: {
 *     name: BaseModel.ComputedProperty(['fname', 'lname'], function (fname, lname) {
 *       return fname + ' ' + lname;
 *     })
 *   }
 * });
 * var model = new Model({fname: 'Joe', lname: 'Doe'});
 * model.get('name'); //=> "Joe Doe"
 * model.toJSON(); //=> {fname: 'Joe', lname: 'Doe'}
 *
 * model.set('__private__', 'private property');
 * model.get('__private__'); //=> "private property"
 * model.toJSON(); //=> {fname: 'Joe', lname: 'Doe'}
 */ var $82ddb6bf367b57ea$export$2e2bcd8739ae039 = (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039).extend($82ddb6bf367b57ea$var$props, $82ddb6bf367b57ea$var$statics);






/* eslint-env es6 */ // Stub for @okta/ui-libraries-oidc-auth-headers (not used by the sign-in widget)
const $12766a6c1802f795$export$9f547442e50aca8d = {};
const $12766a6c1802f795$export$ce8695ab1ead477d = ()=>({
        getOAuth2Headers: ()=>({} // no-op
            )
    });


// Stub for @okta/ui-libraries-monolith (not used by the sign-in widget)
class $540a5ca75132fd12$export$58c609d64f6e52c5 {
    constructor(){}
    get() {
        return undefined;
    }
    getAll() {
        return undefined;
    }
}


var $3e4b625076b3bc3c$var$PageDataEnum;
(function(PageDataEnum) {
    PageDataEnum[PageDataEnum["hostAppName"] = 0] = "hostAppName";
    PageDataEnum[PageDataEnum["isOidcEnabled"] = 1] = "isOidcEnabled";
})($3e4b625076b3bc3c$var$PageDataEnum || ($3e4b625076b3bc3c$var$PageDataEnum = {}));
/**
 * Namespace for page data used by Courage to retrieve OIDC request headers.
 * This namespace is used to store and retrieve data related to the host application
 * and whether OIDC is enabled.
 * This namespace was chosen because courage is the library itself that provides the method
 * below that is used within the Collection and Model sync methods to retrieve OIDC request headers.
 */ const $3e4b625076b3bc3c$var$PAGE_DATA_NAMESPACE = '@okta/courage';
const $3e4b625076b3bc3c$var$pageData = new (0, $540a5ca75132fd12$export$58c609d64f6e52c5)($3e4b625076b3bc3c$var$PAGE_DATA_NAMESPACE, $3e4b625076b3bc3c$var$PageDataEnum);
$3e4b625076b3bc3c$var$pageData.get($3e4b625076b3bc3c$var$PageDataEnum.hostAppName);
$3e4b625076b3bc3c$var$pageData.get($3e4b625076b3bc3c$var$PageDataEnum.isOidcEnabled);
let $3e4b625076b3bc3c$var$provider; // eslint-disable-next-line import/prefer-default-export
const $3e4b625076b3bc3c$export$8b077027d394b861 = async (scopes, url, method, authParams)=>{
    if (!$3e4b625076b3bc3c$var$provider) $3e4b625076b3bc3c$var$provider = (0, $12766a6c1802f795$export$ce8695ab1ead477d)();
    return $3e4b625076b3bc3c$var$provider.getOAuth2Headers(scopes, url, method, authParams);
};




function $cbf92b1807f0afdb$var$log(level, ...args) {
    if (window.console && window.okta && window.okta.debug) window.console[level](...args);
}
/**
 * Utility library of logging functions.
 * @class module:Okta.Logger
 */ var $cbf92b1807f0afdb$export$2e2bcd8739ae039 = /** @lends module:Okta.Logger */ {
    /**
   * See [console.trace](https://developer.mozilla.org/en-US/docs/Web/API/Console.trace)
   * @static
   */ trace: function(...args) {
        return $cbf92b1807f0afdb$var$log('trace', ...args);
    },
    /**
   * See [console.dir](https://developer.mozilla.org/en-US/docs/Web/API/Console.dir)
   * @static
   */ dir: function(...args) {
        return $cbf92b1807f0afdb$var$log('dir', ...args);
    },
    /**
   * See [console.time](https://developer.mozilla.org/en-US/docs/Web/API/Console.time)
   * @static
   */ time: function(...args) {
        return $cbf92b1807f0afdb$var$log('time', ...args);
    },
    /**
   * See [console.timeEnd](https://developer.mozilla.org/en-US/docs/Web/API/Console.timeEnd)
   * @static
   */ timeEnd: function(...args) {
        return $cbf92b1807f0afdb$var$log('timeEnd', ...args);
    },
    /**
   * See [console.group](https://developer.mozilla.org/en-US/docs/Web/API/Console.group)
   * @static
   */ group: function(...args) {
        return $cbf92b1807f0afdb$var$log('group', ...args);
    },
    /**
   * See [console.groupEnd](https://developer.mozilla.org/en-US/docs/Web/API/Console.groupEnd)
   * @static
   */ groupEnd: function(...args) {
        return $cbf92b1807f0afdb$var$log('groupEnd', ...args);
    },
    /**
   * See [console.assert](https://developer.mozilla.org/en-US/docs/Web/API/Console.assert)
   * @static
   */ assert: function(...args) {
        return $cbf92b1807f0afdb$var$log('assert', ...args);
    },
    /**
   * See [console.log](https://developer.mozilla.org/en-US/docs/Web/API/Console.log)
   * @static
   */ log: function(...args) {
        return $cbf92b1807f0afdb$var$log('log', ...args);
    },
    /**
   * See [console.info](https://developer.mozilla.org/en-US/docs/Web/API/Console.info)
   * @static
   */ info: function(...args) {
        return $cbf92b1807f0afdb$var$log('info', ...args);
    },
    /**
   * See [console.warn](https://developer.mozilla.org/en-US/docs/Web/API/Console.warn)
   * @static
   */ warn: function(...args) {
        return $cbf92b1807f0afdb$var$log('warn', ...args);
    },
    /**
   * See [console.error](https://developer.mozilla.org/en-US/docs/Web/API/Console.error)
   * @static
   */ error: function(...args) {
        return $cbf92b1807f0afdb$var$log('error', ...args);
    }
};


/* eslint-disable @okta/okta-ui/enforce-requirejs-names, @okta/okta-ui/no-specific-modules */ var $b51a961f9fe28c76$var$PageDataEnum;
(function(PageDataEnum) {
    PageDataEnum[PageDataEnum["isJqueryOidcEnabled"] = 0] = "isJqueryOidcEnabled";
})($b51a961f9fe28c76$var$PageDataEnum || ($b51a961f9fe28c76$var$PageDataEnum = {}));
const $b51a961f9fe28c76$var$PAGE_DATA_NAMESPACE = '@okta/dll-common';
const $b51a961f9fe28c76$var$pageData = new (0, $540a5ca75132fd12$export$58c609d64f6e52c5)($b51a961f9fe28c76$var$PAGE_DATA_NAMESPACE, $b51a961f9fe28c76$var$PageDataEnum);
// keep a handle on the original ajax object so we can call it when the async call to 
// getOidcRequestHeaders resolves
const $b51a961f9fe28c76$var$originalAjax = (0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports))).ajax;
(0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports))).ajax = function(url, options) {
    // If the feature flag is not enabled, just call the original ajax method
    // Expectation is that we will remove this code path in the future if this fallback isn't needed anymore
    const isJqueryOidcEnabled = $b51a961f9fe28c76$var$pageData.get($b51a961f9fe28c76$var$PageDataEnum.isJqueryOidcEnabled) || false;
    if (!isJqueryOidcEnabled) // If the feature flag is not enabled, just call the original ajax method
    return $b51a961f9fe28c76$var$originalAjax.call((0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports))), url, options);
     // default values
    let isAsync = true;
    let originalUrl = url;
    let scopes = [];
    let authParams;
    let httpMethod = 'GET'; // Default to GET if not specified
    // the jquery ajax API allows for the first parameter to be a string (url) or object, so we need
    // to handle it accordingly to get the right params we need out of the parameters
    if (url && typeof url === 'object' && options === undefined) {
        isAsync = url.async !== undefined ? url.async : isAsync;
        originalUrl = url.url; // url.type is the http method in legacy versions of jquery, url.method in modern versions
        httpMethod = url.type || url.method || httpMethod;
        scopes = url.scopes || scopes;
        authParams = url.authParams || authParams;
    } else if (options && typeof options === 'object') {
        if (typeof url !== 'string' && options.url) originalUrl = options.url;
        isAsync = options.async !== undefined ? options.async : isAsync; // options.type is the http method in legacy versions of jquery, options.method in modern versions
        httpMethod = options.type || options.method || httpMethod;
        scopes = options.scopes || scopes;
        authParams = options.authParams || authParams;
    } // If the request is not async or there are no scopes, just call the original ajax
    // If the request is async and there are scopes, we need to fetch the OIDC request headers first
    // before calling the original ajax method
    // We cannot fetch OIDC request headers for synchronous requests, so if the request is synchronous
    // and there are scopes, we will log a warning
    // If there are no scopes, we will log a warning and proceed without the headers
    if (isAsync === false || scopes.length === 0) {
        if (scopes.length === 0) (0, $cbf92b1807f0afdb$export$2e2bcd8739ae039).warn('No scopes provided for OIDC request headers. Proceeding without Authorization headers.');
        if (isAsync === false) {
            if (scopes.length > 0) // eslint-disable-next-line max-len
            (0, $cbf92b1807f0afdb$export$2e2bcd8739ae039).warn('Cannot fetch OIDC request headers for synchronous requests. Please make the request asynchronous (async: true) to use OIDC scopes.');
             // eslint-disable-next-line max-len
            (0, $cbf92b1807f0afdb$export$2e2bcd8739ae039).warn('Cannot fetch OIDC request headers for synchronous requests. Proceeding without Authorization headers.');
        } // If the request is not async or there are no scopes, just call the original ajax
        return $b51a961f9fe28c76$var$originalAjax.call((0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports))), url, options);
    }
    const deferred = (0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports))).Deferred(); // We need to return a jqXHR object, which is a superset of a Promise
    // We can achieve this by creating a Deferred object and returning it as a jqXHR
    // However, we need to make sure to call the resolve/reject methods of the Deferred
    // object when the original jqXHR object resolves/rejects
    // We also need to handle the abort method, which is not part of the Promise interface
    // so we will create a proxy abort method that will call the abort method of the original
    // jqXHR object when it is available
    // We also need to handle the case where the abort method is called before the original
    // jqXHR object is created, so we will set a flag and check it after the original
    // jqXHR object is created
    let realJqXHR = null;
    let abortRequested = false; // Attach abort immediately
    deferred.abort = function() {
        abortRequested = true;
        if (realJqXHR && typeof realJqXHR.abort === 'function') realJqXHR.abort();
        else // If abort is called before realJqXHR exists, reject with 'abort'
        deferred.reject(null, 'abort');
    }; // Perform async logic before jquery ajax
    (0, $3e4b625076b3bc3c$export$8b077027d394b861)(scopes, originalUrl, httpMethod, authParams).then((authHeaders)=>{
        const additionalHeaders = {};
        for(const key in authHeaders)// The enum has the header names as lowercase. It doesn't matter what case we use for setting the header
        // (the next line), but we want to properly match against the enum, so use `key.toLowerCase()`.
        if (Object.hasOwn((0, $12766a6c1802f795$export$9f547442e50aca8d), key.toLowerCase())) additionalHeaders[key] = authHeaders[key];
        if (options) options.headers = {
            ...options.headers || {},
            ...additionalHeaders
        };
        else if (typeof url === 'object') url.headers = {
            ...url.headers || {},
            ...additionalHeaders
        };
         // Call the original $.ajax method with the updated options
        // and return its jqXHR object
        realJqXHR = typeof url === 'object' && options === undefined ? $b51a961f9fe28c76$var$originalAjax.call((0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports))), url) : $b51a961f9fe28c76$var$originalAjax.call((0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports))), url, options); // Proxy abort
        deferred.abort = function() {
            if (realJqXHR && typeof realJqXHR.abort === 'function') realJqXHR.abort();
        }; // If abort was requested before realJqXHR was created, abort now
        if (abortRequested && typeof realJqXHR.abort === 'function') realJqXHR.abort();
         // Pipe the original jqXHR object to our deferred object
        // This links the new deferred's state to the original jqXHR's state
        realJqXHR.pipe(deferred.resolve, deferred.reject);
    }).catch((err)=>{
        deferred.reject(null, 'Failed to fetch OIDC request headers', err);
        if (options && typeof options.error === 'function') options.error(null, 'Failed to fetch OIDC request headers', err);
    }); // Return the jqXHR-like promise immediately
    return deferred;
};
(0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports))).ajaxSetup({
    beforeSend: function(xhr) {
        xhr.setRequestHeader('X-Okta-XsrfToken', (0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports)))('#_xsrfToken').text());
    },
    converters: {
        'text secureJSON': function(str) {
            if (str.substring(0, 11) === 'while(1){};') str = str.substring(11);
            return JSON.parse(str);
        }
    }
}); // Selenium Hook
// Widget such as autocomplete and autosuggest needs to be triggered from the running version of jQuery.
// We have 2 versions of jQuery running in parallel and they don't share the same events bus
const $b51a961f9fe28c76$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports)));
window.jQueryCourage = $b51a961f9fe28c76$export$2e2bcd8739ae039;










const $afa609341e14c39e$var$entityMap = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': '\'',
    '&#039;': '\'',
    '&#x2F;': '/'
};
const $afa609341e14c39e$var$emailValidator = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(?!-)((\[?[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\]?)|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
/**
* Converts the locale code identifier from "${languageCode}-${countryCode}" to "${languageCode}_${countryCode}"
* Follows the ISO-639-1 language code and 2-letter ISO-3166-1-alpha-2 country code structure.
* @param {String} locale code identifier
* @return {String} converted locale code identifier
*/ const $afa609341e14c39e$var$parseLocale = (locale)=>{
    if (/-/.test(locale)) {
        const parts = locale.split('-');
        parts[1] = parts[1].toUpperCase();
        return parts.join('_');
    }
    return locale;
};
/* eslint max-len: 0*/ /**
 * Returns the user's locale as defined by window.okta.locale
 */ function $afa609341e14c39e$var$getRawLocale() {
    if (window && window.okta && window.okta.locale) {
        const isEnableBcp47OktaUi = window.okta.isEnableBcp47OktaUi;
        return isEnableBcp47OktaUi ? window.okta.locale : window.okta.locale.toLowerCase();
    }
    return 'en';
}
/**
 * Returns the language bundle based on the current locale.
 * - If a locale is not provided, default to English ('en')
 * - Legacy Support: If the named language bundle does not exist, fall back to the default named bundle.
 *
 * @param {*} bundleName
 */ function $afa609341e14c39e$var$getBundle(bundleName) {
    if (!bundleName) return (0, $ae370136150d080c$export$2e2bcd8739ae039)[(0, $3e490973b7383cc4$export$2e2bcd8739ae039).keys((0, $ae370136150d080c$export$2e2bcd8739ae039))[0]];
    const locale = $afa609341e14c39e$var$parseLocale($afa609341e14c39e$var$getRawLocale());
    return (0, $ae370136150d080c$export$2e2bcd8739ae039)[`${bundleName}_${locale}`] || (0, $ae370136150d080c$export$2e2bcd8739ae039)[bundleName];
}
/**
 *
 * CustomEvent polyfill for IE
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#polyfill
 */ function $afa609341e14c39e$var$IECustomEvent(event, params) {
    params = params || {
        bubbles: false,
        cancelable: false,
        detail: null
    };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
}
/**
 * Call the window.okta.emitL10nError function if it is defined
 * @param {String} key The i18n key
 * @param {String} bundleName The i18n bundle name
 * @param {String} reason Could be 'bundle' (Bundle not found), 'key' (Key not found) or 'parameters' (Parameters mismatch).
 */ function $afa609341e14c39e$var$emitL10nError(key, bundleName, reason) {
    // CustomEvent polyfill for IE
    if (!window.CustomEvent) window.CustomEvent = $afa609341e14c39e$var$IECustomEvent;
     // dispatchEvent for sentry
    if (typeof window.CustomEvent === 'function') {
        const event = new CustomEvent('okta-i18n-error', {
            detail: {
                type: 'l10n-error',
                key: key,
                bundleName: bundleName,
                reason: reason
            }
        });
        document.dispatchEvent(event);
    }
}
const $afa609341e14c39e$export$2e2bcd8739ae039 = /** @lends module:Okta.internal.util.StringUtil */ {
    /** @static */ getRawLocale: function() {
        return $afa609341e14c39e$var$getRawLocale();
    },
    /** @static */ getParsedLocale: function() {
        return $afa609341e14c39e$var$parseLocale($afa609341e14c39e$var$getRawLocale());
    },
    /** @static */ isLocaleBundleExist: function(bundleName, locale) {
        const parsedLocale = $afa609341e14c39e$var$parseLocale(locale);
        return !!(0, $ae370136150d080c$export$2e2bcd8739ae039)[`${bundleName}_${parsedLocale}`];
    },
    /** @static */ sprintf: function() {
        const args = Array.prototype.slice.apply(arguments);
        let value = args.shift();
        let oldValue = value;
        /* eslint max-statements: [2, 15] */ function triggerError() {
            throw new Error('Mismatch number of variables: ' + arguments[0] + ', ' + JSON.stringify(args));
        }
        for(var i = 0, l = args.length; i < l; i++){
            const entity = args[i];
            const regex = new RegExp('\\{' + i + '\\}', 'g');
            value = value.replace(regex, entity);
            if (entity === undefined || entity === null || value === oldValue) triggerError();
            oldValue = value;
        }
        if (/\{[\d+]\}/.test(value)) triggerError();
        return value;
    },
    /**
   * Converts a URI encoded query string into a hash map
   * @param  {String} query The query string
   * @return {Object} The map
   * @static
   * @example
   * StringUtil.parseQuery('foo=bar&baz=qux') // {foo: 'bar', baz: 'qux'}
   */ parseQuery: function(query) {
        const params = {};
        const pairs = decodeURIComponent(query.replace(/\+/g, ' ')).split('&');
        for(var i = 0; i < pairs.length; i++){
            const pair = pairs[i];
            const data = pair.split('=');
            params[data.shift()] = data.join('=');
        }
        return params;
    },
    /** @static */ encodeJSObject: function(jsObj) {
        return encodeURIComponent(JSON.stringify(jsObj));
    },
    /** @static */ decodeJSObject: function(jsObj) {
        try {
            return JSON.parse(decodeURIComponent(jsObj));
        } catch (e) {
            return null;
        }
    },
    /** @static */ unescapeHtml: function(string) {
        return String(string).replace(/&[\w#\d]{2,};/g, function(s) {
            return $afa609341e14c39e$var$entityMap[s] || s;
        });
    },
    /**
   * Get the original i18n template directly without string format with parameters
   * @param {String} key The key
   * @param {String} bundle="messages"] The name of the i18n bundle. Defaults to the first bundle in the list.
   */ getTemplate: function(key, bundleName) {
        const bundle = $afa609341e14c39e$var$getBundle(bundleName);
        if (!bundle) {
            $afa609341e14c39e$var$emitL10nError(key, bundleName, 'bundle');
            return 'L10N_ERROR[' + bundleName + ']';
        }
        if (bundle[key]) return bundle[key];
        else {
            $afa609341e14c39e$var$emitL10nError(key, bundleName, 'key');
            return 'L10N_ERROR[' + key + ']';
        }
    },
    /**
   * Translate a key to the localized value
   * @static
   * @param  {String} key The key
   * @param  {String} [bundle="messages"] The name of the i18n bundle. Defaults to the first bundle in the list.
   * @param  {Array} [params] A list of parameters to apply as tokens to the i18n value
   * @return {String} The localized value
   */ localize: function(key, bundleName, params) {
        const bundle = $afa609341e14c39e$var$getBundle(bundleName);
        /* eslint complexity: [2, 6] */ if (!bundle) {
            $afa609341e14c39e$var$emitL10nError(key, bundleName, 'bundle');
            return 'L10N_ERROR[' + bundleName + ']';
        }
        let value = bundle[key];
        try {
            params = params && params.slice ? params.slice(0) : [];
            params.unshift(value);
            value = $afa609341e14c39e$export$2e2bcd8739ae039.sprintf.apply(null, params);
            if (value) return value;
            else {
                $afa609341e14c39e$var$emitL10nError(key, bundleName, 'key');
                return 'L10N_ERROR[' + key + ']';
            }
        } catch (e) {
            $afa609341e14c39e$var$emitL10nError(key, bundleName, 'parameters');
            return 'L10N_ERROR[' + key + ']';
        }
    },
    /**
   * Convert a string to a float if valid, otherwise return the string.
   * Valid numbers may contain a negative sign and a decimal point.
   * @static
   * @param {String} string The string to convert to a number
   * @return {String|Number} Returns a number if the string can be casted, otherwise returns the original string
   */ parseFloat: function(string) {
        const number = +string;
        return typeof string === 'string' && number === parseFloat(string) ? number : string;
    },
    /**
   * Convert a string to an integer if valid, otherwise return the string
   * @static
   * @param {String} string The string to convert to an integer
   * @return {String|integer} Returns an integer if the string can be casted, otherwise, returns the original string
   */ parseInt: function(string) {
        const int = +string;
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isString(string) && int === parseInt(string, 10) ? int : string;
    },
    /**
   * Convert a string to an object if valid, otherwise return the string
   * @static
   * @param {String} string The string to convert to an object
   * @return {String|object} Returns an object if the string can be casted, otherwise, returns the original string
   */ parseObject: function(string) {
        if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isString(string)) return string;
        try {
            const object = JSON.parse(string);
            return (0, $b51a961f9fe28c76$export$2e2bcd8739ae039).isPlainObject(object) ? object : string;
        } catch (e) {
            return string;
        }
    },
    /**
   * Returns a random string from [a-z][A-Z][0-9] of a given length
   * @static
   * @param {Number} length The length of the random string.
   * @return {String} Returns a random string from [a-z][A-Z][0-9] of a given length
   */ randomString: function(length) {
        const characters = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz';
        if (length === undefined) length = (window.crypto || window.msCrypto).getRandomValues(new Uint32Array(1))[0] % (characters.length + 1);
        else if (length === 0) return '';
        const stringArray = [];
        while(length--)stringArray.push(characters[(window.crypto || window.msCrypto).getRandomValues(new Uint32Array(1))[0] % characters.length]);
        return stringArray.join('');
    },
    /**
   * Returns if a str ends with another string
   * @static
   * @param {String} str The string to search
   * @param {String} ends The string it should end with
   *
   * @return {Boolean} Returns if the str ends with ends
   */ endsWith: function(str, ends) {
        str += '';
        ends += '';
        return str.length >= ends.length && str.substring(str.length - ends.length) === ends;
    },
    /** @static */ isEmail: function(str) {
        const target = (0, $b51a961f9fe28c76$export$2e2bcd8739ae039).trim(str);
        return !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(target) && $afa609341e14c39e$var$emailValidator.test(target);
    }
};


const $723c4f009c64492a$var$loc = (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize;
const $723c4f009c64492a$export$2e2bcd8739ae039 = {
    STRING: 'string',
    NUMBER: 'number',
    INTEGER: 'integer',
    BOOLEAN: 'boolean',
    OBJECT: 'object',
    FORMATDISPLAYTYPE: {
        'date-time': 'date',
        uri: 'uri',
        email: 'email',
        // TODO: settle on using EITHER underscores OR hyphens --- not both (OKTA-202818)
        'country-code': 'country-code',
        'language-code': 'language-code',
        'country_code': 'country_code',
        'language_code': 'language_code',
        locale: 'locale',
        timezone: 'timezone',
        'ref-id': 'reference'
    },
    ARRAYDISPLAYTYPE: {
        arrayofobject: 'arrayofobject',
        arrayofstring: 'arrayofstring',
        arrayofnumber: 'arrayofnumber',
        arrayofinteger: 'arrayofinteger',
        'arrayofref-id': 'arrayofref-id'
    },
    DISPLAYTYPES: {
        date: {
            type: 'string',
            format: 'date-time'
        },
        uri: {
            type: 'string',
            format: 'uri'
        },
        email: {
            type: 'string',
            format: 'email'
        },
        // TODO: Resolve inconsistencies in hyphens vs. underscores for these properties (OKTA-202818)
        // use country-code if attribute should be restricted to country code type
        'country-code': {
            type: 'string',
            format: 'country-code'
        },
        'language-code': {
            type: 'string',
            format: 'language-code'
        },
        'country_code': {
            type: 'string'
        },
        'language_code': {
            type: 'string'
        },
        locale: {
            type: 'string',
            format: 'locale'
        },
        timezone: {
            type: 'string',
            format: 'timezone'
        },
        string: {
            type: 'string'
        },
        number: {
            type: 'number'
        },
        boolean: {
            type: 'boolean'
        },
        integer: {
            type: 'integer'
        },
        reference: {
            type: 'string',
            format: 'ref-id'
        },
        arrayofobject: {
            type: 'array',
            items: {
                type: 'object'
            }
        },
        arrayofstring: {
            type: 'array',
            items: {
                type: 'string'
            }
        },
        arrayofnumber: {
            type: 'array',
            items: {
                type: 'number'
            }
        },
        arrayofinteger: {
            type: 'array',
            items: {
                type: 'integer'
            }
        },
        'arrayofref-id': {
            type: 'array',
            items: {
                type: 'string',
                format: 'ref-id'
            }
        },
        image: {
            type: 'image'
        },
        password: {
            type: 'string'
        }
    },
    SUPPORTSMINMAX: [
        'string',
        'number',
        'integer',
        'password'
    ],
    SUPPORTENUM: [
        'string',
        'number',
        'integer',
        'object',
        'arrayofstring',
        'arrayofnumber',
        'arrayofinteger',
        'arrayofobject'
    ],
    DATATYPE: {
        string: 'string',
        number: 'number',
        boolean: 'boolean',
        integer: 'integer',
        date: 'datetime',
        object: 'object',
        arrayofobject: 'object array',
        arrayofstring: 'string array',
        arrayofnumber: 'number array',
        arrayofinteger: 'integer array',
        'arrayofref-id': 'reference array',
        // TODO: settle on using EITHER underscores OR hyphens --- not both (OKTA-202818)
        'country-code': 'country code',
        'language-code': 'language code',
        'country_code': 'country code',
        'language_code': 'language code',
        reference: 'reference',
        timezone: 'timezone',
        image: 'image'
    },
    MUTABILITY: {
        READONLY: 'READ_ONLY',
        WRITEONLY: 'WRITE_ONLY',
        READWRITE: 'READ_WRITE',
        IMMUTABLE: 'IMMUTABLE'
    },
    SCOPE: {
        NONE: 'NONE',
        SELF: 'SELF',
        SYSTEM: 'SYSTEM'
    },
    DISPLAYSCOPE: {
        SELF: 'User personal',
        SYSTEM: 'System',
        NA: 'None'
    },
    UNION: {
        DISABLE: 'DISABLE',
        ENABLE: 'ENABLE'
    },
    UNION_OPTIONS: {
        DISABLE: $723c4f009c64492a$var$loc('universal-directory.profiles.attribute.form.union.enable.display', 'courage'),
        ENABLE: $723c4f009c64492a$var$loc('universal-directory.profiles.attribute.form.union.disable.display', 'courage')
    },
    PERMISSION: {
        HIDE: 'HIDE',
        READ_ONLY: 'READ_ONLY',
        WRITE_ONLY: 'WRITE_ONLY',
        READ_WRITE: 'READ_WRITE'
    },
    ENDUSER_ATTRIBUTE_PERMISSION_OPTIONS: {
        HIDE: $723c4f009c64492a$var$loc('universal-directory.profiles.attribute.enduser.permission.hide', 'courage'),
        READ_ONLY: $723c4f009c64492a$var$loc('universal-directory.profiles.attribute.enduser.permission.readonly', 'courage'),
        READ_WRITE: $723c4f009c64492a$var$loc('universal-directory.profiles.attribute.enduser.permission.readwrite', 'courage')
    },
    // eslint-disable-next-line inclusive-language/use-inclusive-words
    ATTRIBUTE_LEVEL_MASTERING_OPTIONS: {
        INHERIT: $723c4f009c64492a$var$loc('universal-directory.profiles.attribute.source.inherit', 'courage'),
        // eslint-disable-next-line inclusive-language/use-inclusive-words
        OKTA_MASTERED: $723c4f009c64492a$var$loc('universal-directory.profiles.attribute.source.oktamastered', 'courage'),
        OVERRIDE: $723c4f009c64492a$var$loc('universal-directory.profiles.attribute.source.override', 'courage')
    },
    USERNAMETYPE: {
        NONE: 'non-username',
        OKTA_TO_APP: 'okta-to-app-username',
        OKTA_TO_AD: 'okta-to-ad-username',
        APP_TO_OKTA: 'app-to-okta-username',
        IDP_TO_OKTA: 'idp-to-okta-username'
    },
    LOGINPATTERNFORMAT: {
        EMAIL: 'EMAIL',
        CUSTOM: 'CUSTOM',
        NONE: 'NONE'
    },
    UNIQUENESS: {
        NOT_UNIQUE: 'NOT_UNIQUE',
        PENDING_UNIQUENESS: 'PENDING_UNIQUENESS',
        UNIQUE_VALIDATED: 'UNIQUE_VALIDATED'
    },
    /*
   * Get a display string for a schema attribute type.
   * @param {String} type Type of an attribute
   * @param {String} format Format of an attribute
   * @param {String} itemType Item type of an attribute if an array
   * @param {String} defaultValue The default value if an attribute type is undefined
   * @return {String} the display value
   */ getDisplayType: function(type, format, itemType, defaultValue) {
        let displayType; // type is undefined for
        // - an un-mapped source attribute from mapping
        // - an source attribute which is mapped to username target attribute
        if (type) {
            // format is only defined for complicated types (ex. reference, date time, array)
            // not for simple types (ex. string, integer, boolean)
            if (format) displayType = this.FORMATDISPLAYTYPE[format];
            else // itemType is only defined for array type
            // to specify an array element type (ex. string, integer, number)
            displayType = itemType ? this.ARRAYDISPLAYTYPE[type + 'of' + itemType] : type;
        }
        if (!displayType) displayType = typeof defaultValue === 'undefined' ? '' : defaultValue;
        return displayType;
    },
    /*
   * Get attribute mapping source attribute username type
   * @param {String} mappingDirection
   * @param {String} targetName The mapping target attribute name
   * @param {String} appName The app name that's mapped to/from Okta
   * @return {String} the source attribute username type value
   */ getSourceUsernameType: function(mappingDirection, targetName, appName) {
        let sourceUsernameType = this.USERNAMETYPE.NONE;
        /* eslint complexity: [2, 7] */ if (mappingDirection === 'oktaToApp') {
            if (targetName === 'userName') sourceUsernameType = this.USERNAMETYPE.OKTA_TO_APP;
            else if (targetName === 'cn') sourceUsernameType = this.USERNAMETYPE.OKTA_TO_AD;
        } else if (mappingDirection === 'appToOkta' && targetName === 'login') {
            if (appName === 'saml_idp') sourceUsernameType = this.USERNAMETYPE.IDP_TO_OKTA;
            else sourceUsernameType = this.USERNAMETYPE.APP_TO_OKTA;
        }
        return sourceUsernameType;
    },
    isArrayDataType: function(type) {
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains((0, $3e490973b7383cc4$export$2e2bcd8739ae039).values(this.ARRAYDISPLAYTYPE), type);
    },
    isObjectDataType: function(type) {
        return this.DATATYPE.object === type;
    }
};







/* eslint max-statements: 0 */ const $012d4a2affe19c61$var$NAME = 'name';
const $012d4a2affe19c61$var$ENUM_KEY_PREFIX = '_enum_';
/**
 * Generate Input Options in order to create an input in an Form for Enum type attribute.
 * @param {Object} config informations for creating input options
 *   config.name        schema property name
 *   config.title       schema property title
 *   config.readOnly    create an read only input?
 *   config.explain     sub-title to the input
 *   config.enumValues  list of enum values for creating input options (Dropdown/SimpleCheckBoxSet)
 *   config.displayType display type of schema property
 *
 * @return {Object} inputOptions options for create an Input view. (Dropdown/SimpleCheckBoxSet)
 *
 */ function $012d4a2affe19c61$var$getEnumInputOptions(config) {
    const enumOneOf = $012d4a2affe19c61$var$convertToOneOf(config.enumValues);
    const inputOptions = {
        name: config.name,
        label: config.title,
        readOnly: config.readOnly,
        customExplain: config.explain,
        params: {
            enumOneOf: enumOneOf
        },
        options: $012d4a2affe19c61$var$getDropdownOptionsFromOneOf(enumOneOf)
    }; // input type
    if ((0, $723c4f009c64492a$export$2e2bcd8739ae039).isArrayDataType(config.displayType)) {
        inputOptions.type = 'checkboxset';
        inputOptions.to = $012d4a2affe19c61$var$valuesToEnumObjects;
        inputOptions.from = $012d4a2affe19c61$var$enumObjectsToValues;
    } else {
        inputOptions.type = 'select';
        inputOptions.to = $012d4a2affe19c61$var$valueToEnumObject;
        inputOptions.from = $012d4a2affe19c61$var$enumObjectToValue;
    }
    inputOptions.input = null;
    return inputOptions;
}
function $012d4a2affe19c61$var$getDropdownOptions(values) {
    return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(values) ? $012d4a2affe19c61$var$getDropdownOptionsFromOneOf($012d4a2affe19c61$var$convertToOneOf(values)) : {};
}
function $012d4a2affe19c61$var$getDropdownOptionsFromOneOf(values) {
    if (!$012d4a2affe19c61$var$isOneOfEnumObject(values)) return {};
    return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).reduce(values, function(options, value, index) {
        options[$012d4a2affe19c61$var$convertIndexToEnumIndex(index)] = value.title;
        return options;
    }, {});
}
function $012d4a2affe19c61$var$convertToOneOf(values) {
    // assume this is a legacy enum array and convert to oneOf object
    if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).all(values, (0, $b51a961f9fe28c76$export$2e2bcd8739ae039).isPlainObject)) return $012d4a2affe19c61$var$convertEnumToOneOf(values); // we assume object without const and title is an enum object which need special conversion
    else if (!$012d4a2affe19c61$var$isOneOfEnumObject(values)) return $012d4a2affe19c61$var$convertEnumObjectToOneOf(values);
    return values;
}
function $012d4a2affe19c61$var$isOneOfEnumObject(values) {
    return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(values) && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).all(values, function(value) {
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).has(value, 'const') && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).has(value, 'title');
    });
}
function $012d4a2affe19c61$var$convertEnumToOneOf(values) {
    return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).map(values, function(value) {
        return {
            const: value,
            title: $012d4a2affe19c61$var$valueToTitle(value)
        };
    });
}
function $012d4a2affe19c61$var$valueToTitle(value) {
    if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isObject(value)) return JSON.stringify(value);
    if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isNumber(value)) return value + '';
    return value;
}
function $012d4a2affe19c61$var$convertEnumObjectToOneOf(values) {
    const findKey = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $3e490973b7383cc4$export$2e2bcd8739ae039).has, (0, $3e490973b7383cc4$export$2e2bcd8739ae039), $012d4a2affe19c61$var$NAME); // If all object found the key NAME, use the NAME's value as display name
    if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).all(values, findKey)) return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).chain(values).filter(function(value) {
        return (0, $b51a961f9fe28c76$export$2e2bcd8739ae039).isPlainObject(value) && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).has(value, $012d4a2affe19c61$var$NAME);
    }).map(function(value) {
        return {
            const: value,
            title: value[$012d4a2affe19c61$var$NAME]
        };
    }).value();
     // Assume a legacy object array does not need special handling and just convert to const/title enum
    return $012d4a2affe19c61$var$convertEnumToOneOf(values);
}
function $012d4a2affe19c61$var$convertIndexToEnumIndex(index) {
    return `${$012d4a2affe19c61$var$ENUM_KEY_PREFIX}${index}`;
}
function $012d4a2affe19c61$var$enumObjectToValue(obj) {
    const index = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findIndex(this.options.params.enumOneOf, function(oneOfObj) {
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isObject(obj) ? (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEqual(oneOfObj.const, obj) : oneOfObj.const === obj;
    }); // Cannot rely on comparator in findIndex when compare objects so need special handling
    return index > -1 ? $012d4a2affe19c61$var$convertIndexToEnumIndex(index) : obj;
}
function $012d4a2affe19c61$var$valueToEnumObject(val) {
    if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isString(val) || val.indexOf($012d4a2affe19c61$var$ENUM_KEY_PREFIX) !== 0) return val;
    const index = val.replace($012d4a2affe19c61$var$ENUM_KEY_PREFIX, '');
    const enumValue = this.options.params && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(this.options.params.enumOneOf) ? this.options.params.enumOneOf[index] : null; // @see `getEnumInputOptions` how enumValues has been set.
    return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).has(enumValue, 'const') ? enumValue.const : enumValue;
}
function $012d4a2affe19c61$var$valuesToEnumObjects(values) {
    return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).map(values, $012d4a2affe19c61$var$valueToEnumObject.bind(this));
}
function $012d4a2affe19c61$var$enumObjectsToValues(values) {
    return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).map(values, $012d4a2affe19c61$var$enumObjectToValue.bind(this));
}
function $012d4a2affe19c61$var$isStringConstraint(value) {
    return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isString(value);
}
function $012d4a2affe19c61$var$isNumberConstraint(value) {
    return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isNumber(value) || (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isNumber((0, $afa609341e14c39e$export$2e2bcd8739ae039).parseFloat((0, $b51a961f9fe28c76$export$2e2bcd8739ae039).trim(value)));
}
function $012d4a2affe19c61$var$isIntegerConstraint(value) {
    const integer = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isNumber(value) ? value : (0, $afa609341e14c39e$export$2e2bcd8739ae039).parseInt((0, $b51a961f9fe28c76$export$2e2bcd8739ae039).trim(value));
    return typeof integer === 'number' && isFinite(integer) && Math.floor(integer) === integer;
}
function $012d4a2affe19c61$var$isObjectConstraint(value) {
    if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isObject(value) && !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(value)) return true;
    const object = (0, $afa609341e14c39e$export$2e2bcd8739ae039).parseObject((0, $b51a961f9fe28c76$export$2e2bcd8739ae039).trim(value));
    return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isObject(object) && !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(object);
}
function $012d4a2affe19c61$var$isConstraintValueMatchType(value, type) {
    switch(type){
        case (0, $723c4f009c64492a$export$2e2bcd8739ae039).STRING:
            return $012d4a2affe19c61$var$isStringConstraint(value);
        case (0, $723c4f009c64492a$export$2e2bcd8739ae039).NUMBER:
            return $012d4a2affe19c61$var$isNumberConstraint(value);
        case (0, $723c4f009c64492a$export$2e2bcd8739ae039).INTEGER:
            return $012d4a2affe19c61$var$isIntegerConstraint(value);
        case (0, $723c4f009c64492a$export$2e2bcd8739ae039).OBJECT:
            return $012d4a2affe19c61$var$isObjectConstraint(value);
    }
}
var $012d4a2affe19c61$export$2e2bcd8739ae039 = {
    getEnumInputOptions: $012d4a2affe19c61$var$getEnumInputOptions,
    getDropdownOptions: $012d4a2affe19c61$var$getDropdownOptions,
    convertToOneOf: $012d4a2affe19c61$var$convertToOneOf,
    isConstraintValueMatchType: $012d4a2affe19c61$var$isConstraintValueMatchType
};


/* eslint-disable inclusive-language/use-inclusive-words */ const $2f2ccccc756c1fbe$var$loc = (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize;
const $2f2ccccc756c1fbe$var$STRING = (0, $723c4f009c64492a$export$2e2bcd8739ae039).STRING;
const $2f2ccccc756c1fbe$var$NUMBER = (0, $723c4f009c64492a$export$2e2bcd8739ae039).NUMBER;
const $2f2ccccc756c1fbe$var$INTEGER = (0, $723c4f009c64492a$export$2e2bcd8739ae039).INTEGER;
const $2f2ccccc756c1fbe$var$OBJECT = (0, $723c4f009c64492a$export$2e2bcd8739ae039).OBJECT;
const $2f2ccccc756c1fbe$var$getArrayTypeName = function(type, elementType) {
    return type + 'of' + elementType;
};
const $2f2ccccc756c1fbe$var$SchemaPropertySubSchema = (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).extend({
    defaults: {
        description: undefined,
        minLength: undefined,
        maxLength: undefined,
        format: undefined
    },
    parse: function(resp) {
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isString(resp.format)) {
            const matcher = /^\/(.+)\/$/.exec(resp.format);
            if (matcher) resp.format = matcher[1];
        }
        return resp;
    }
});
const $2f2ccccc756c1fbe$var$SchemaPropertySubSchemaCollection = (0, $e9e519c40171c3aa$export$2e2bcd8739ae039).extend({
    model: $2f2ccccc756c1fbe$var$SchemaPropertySubSchema
});
const $2f2ccccc756c1fbe$var$SchemaPropertySubSchemaAllOfCollection = $2f2ccccc756c1fbe$var$SchemaPropertySubSchemaCollection.extend({
    _type: 'allOf'
});
const $2f2ccccc756c1fbe$var$SchemaPropertySubSchemaOneOfCollection = $2f2ccccc756c1fbe$var$SchemaPropertySubSchemaCollection.extend({
    _type: 'oneOf'
});
const $2f2ccccc756c1fbe$var$SchemaPropertySubSchemaNoneOfCollection = $2f2ccccc756c1fbe$var$SchemaPropertySubSchemaCollection.extend({
    _type: 'noneOf'
});
const $2f2ccccc756c1fbe$var$constraintTypeErrorMessages = {
    string: $2f2ccccc756c1fbe$var$loc('schema.validation.field.value.must.string', 'courage'),
    number: $2f2ccccc756c1fbe$var$loc('schema.validation.field.value.must.number', 'courage'),
    integer: $2f2ccccc756c1fbe$var$loc('schema.validation.field.value.must.integer', 'courage'),
    object: $2f2ccccc756c1fbe$var$loc('schema.validation.field.value.must.object', 'courage')
};
const $2f2ccccc756c1fbe$var$loginFormatNonePattern = '.+';
const $2f2ccccc756c1fbe$var$escapedLoginCharsRe = /[^a-zA-Z0-9-]/;
const $2f2ccccc756c1fbe$var$constraintHandlers = {
    between: '_checkBetweenConstraints',
    greaterThan: '_checkGreaterThanConstraint',
    lessThan: '_checkLessThanConstraint',
    equals: '_checkEqualsConstraint'
};
const $2f2ccccc756c1fbe$var$SchemaPropertySchemaProperty = (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).extend({
    idAttribute: 'name',
    local: {
        __oneOf__: {
            type: 'array',
            minItems: 1
        }
    },
    defaults: {
        // OKTA-28445, set empty string by default as the key for each property when syncing with server
        // so that server can respond with error when a name is not provided
        name: '',
        title: undefined,
        type: undefined,
        description: undefined,
        required: false,
        format: undefined,
        // choose disable option be default.
        union: undefined,
        subSchemas: undefined,
        settings: {
            permissions: {
                SELF: (0, $723c4f009c64492a$export$2e2bcd8739ae039).PERMISSION.READ_ONLY
            }
        },
        unique: undefined,
        __metadata__: undefined,
        __isSensitive__: (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).ComputedProperty([
            'settings'
        ], function(settings) {
            return !!(settings && settings.sensitive);
        }),
        __unique__: false,
        __isUniqueValidated__: (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).ComputedProperty([
            'unique'
        ], function(unique) {
            return unique === (0, $723c4f009c64492a$export$2e2bcd8739ae039).UNIQUENESS.UNIQUE_VALIDATED;
        }),
        __isPendingUniqueness__: (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).ComputedProperty([
            'unique'
        ], function(unique) {
            return unique === (0, $723c4f009c64492a$export$2e2bcd8739ae039).UNIQUENESS.PENDING_UNIQUENESS;
        }),
        __isUniqueness__: (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).ComputedProperty([
            '__isUniqueValidated__',
            '__isPendingUniqueness__'
        ], function(isValidated, isPending) {
            return isValidated || isPending;
        }),
        __canBeSensitive__: (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).ComputedProperty([
            '__metadata__'
        ], function(metadata) {
            return !!(metadata && metadata.sensitivizable);
        }),
        __userPermission__: (0, $723c4f009c64492a$export$2e2bcd8739ae039).PERMISSION.READ_ONLY,
        __displayType__: undefined,
        __displayTypeLabel__: (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).ComputedProperty([
            '__displayType__'
        ], function(displayType) {
            return (0, $723c4f009c64492a$export$2e2bcd8739ae039).DATATYPE[displayType] || displayType;
        }),
        __supportsMinMax__: false,
        // use the private naming convention for these computed properties,
        // to deal with the complexity in cloning schema with properties (toJSON({verbose: true})),
        // to make sure these attributes are being excluded from api request
        __isReadOnly__: (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).ComputedProperty([
            'mutability'
        ], function(mutability) {
            return mutability === (0, $723c4f009c64492a$export$2e2bcd8739ae039).MUTABILITY.READONLY;
        }),
        __isWriteOnly__: (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).ComputedProperty([
            'mutability'
        ], function(mutability) {
            return mutability === (0, $723c4f009c64492a$export$2e2bcd8739ae039).MUTABILITY.WRITEONLY;
        }),
        __displayScope__: undefined,
        __isScopeSelf__: (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).ComputedProperty([
            'scope'
        ], function(scope) {
            return scope === (0, $723c4f009c64492a$export$2e2bcd8739ae039).SCOPE.SELF;
        }),
        __isNoneScopeArrayType__: (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).ComputedProperty([
            '__isScopeSelf__',
            '__displayType__'
        ], function(isScopeSelf, displayType) {
            return !isScopeSelf && (0, $723c4f009c64492a$export$2e2bcd8739ae039).isArrayDataType(displayType);
        }),
        __isImported__: (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).ComputedProperty([
            'externalName'
        ], function(externalName) {
            return !!externalName;
        }),
        __isFromBaseSchema__: (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).ComputedProperty([
            '__schemaMeta__'
        ], function(schemaMeta) {
            return schemaMeta && schemaMeta.name === 'base';
        }),
        // Only UI can turn on __enumDefined__ and reprocess the enum/oneOf value; otherwise,
        // it should leave existing value untouch
        __enumDefined__: false,
        __supportEnum__: (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).ComputedProperty([
            '__displayType__'
        ], function(displayType) {
            return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains((0, $723c4f009c64492a$export$2e2bcd8739ae039).SUPPORTENUM, displayType);
        }),
        __isNumberTypeEnum__: (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).ComputedProperty([
            '__displayType__'
        ], function(displayType) {
            return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains([
                (0, $723c4f009c64492a$export$2e2bcd8739ae039).NUMBER,
                (0, $723c4f009c64492a$export$2e2bcd8739ae039).ARRAYDISPLAYTYPE.arrayofnumber
            ], displayType);
        }),
        __isIntegerTypeEnum__: (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).ComputedProperty([
            '__displayType__'
        ], function(displayType) {
            return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains([
                (0, $723c4f009c64492a$export$2e2bcd8739ae039).INTEGER,
                (0, $723c4f009c64492a$export$2e2bcd8739ae039).ARRAYDISPLAYTYPE.arrayofinteger
            ], displayType);
        }),
        __isObjectTypeEnum__: (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).ComputedProperty([
            '__displayType__'
        ], function(displayType) {
            return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains([
                (0, $723c4f009c64492a$export$2e2bcd8739ae039).OBJECT,
                (0, $723c4f009c64492a$export$2e2bcd8739ae039).ARRAYDISPLAYTYPE.arrayofobject
            ], displayType);
        }),
        __isStringTypeEnum__: (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).ComputedProperty([
            '__displayType__'
        ], function(displayType) {
            return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains([
                (0, $723c4f009c64492a$export$2e2bcd8739ae039).STRING,
                (0, $723c4f009c64492a$export$2e2bcd8739ae039).ARRAYDISPLAYTYPE.arrayofstring
            ], displayType);
        }),
        __enumConstraintType__: (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).ComputedProperty([
            '__isStringTypeEnum__',
            '__isNumberTypeEnum__',
            '__isIntegerTypeEnum__',
            '__isObjectTypeEnum__'
        ], function(isStringType, isNumberType, isIntegerType, isObjectType) {
            if (isStringType) return $2f2ccccc756c1fbe$var$STRING;
            if (isNumberType) return $2f2ccccc756c1fbe$var$NUMBER;
            if (isIntegerType) return $2f2ccccc756c1fbe$var$INTEGER;
            if (isObjectType) return $2f2ccccc756c1fbe$var$OBJECT;
        }),
        __isEnumDefinedAndSupported__: (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).ComputedProperty([
            '__enumDefined__',
            '__supportEnum__'
        ], function(enumDefined, supportEnum) {
            return enumDefined && supportEnum;
        }),
        __isLoginOfBaseSchema__: (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).ComputedProperty([
            '__isFromBaseSchema__',
            'name'
        ], function(isFromBaseSchema, name) {
            return isFromBaseSchema && name === 'login';
        }),
        __isLoginFormatRestrictionToEmail__: (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).ComputedProperty([
            '__loginFormatRestriction__'
        ], function(loginFormatRestriction) {
            return loginFormatRestriction === (0, $723c4f009c64492a$export$2e2bcd8739ae039).LOGINPATTERNFORMAT.EMAIL;
        })
    },
    initialize: function() {
        (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        this.listenTo(this, 'change:__displayType__', this._updateTypeFormatConstraints);
        this.listenTo(this, 'change:type change:format change:items', this._updateDisplayType);
        this.listenTo(this, 'change:__minVal__ change:__maxVal__', this._updateMinMax);
        this.listenTo(this, 'change:__equals__', this._convertEqualsToMinMax);
        this.listenTo(this, 'change:__constraint__', this._setConstraintText);
        this._setConstraintText();
        this._setLoginPattern();
    },
    parse: function(resp) {
        /* eslint complexity: [2, 9] */ resp = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone(resp);
        if (resp.type === 'object' && resp.extendedType === 'image') resp.type = 'image';
        resp['__displayType__'] = (0, $723c4f009c64492a$export$2e2bcd8739ae039).getDisplayType(resp.type, resp.format, resp.items ? resp.items.format ? resp.items.format : resp.items.type : undefined);
        this._setRangeConstraints(resp);
        resp['__supportsMinMax__'] = (0, $723c4f009c64492a$export$2e2bcd8739ae039).SUPPORTSMINMAX.indexOf(resp['__displayType__']) !== -1;
        resp['__displayScope__'] = (0, $723c4f009c64492a$export$2e2bcd8739ae039).DISPLAYSCOPE[resp.scope] || (0, $723c4f009c64492a$export$2e2bcd8739ae039).DISPLAYSCOPE.NA;
        if (resp.settings && resp.settings.permissions && resp.settings.permissions.SELF) resp['__userPermission__'] = resp.settings.permissions.SELF;
        this._setMasterOverride(resp);
        this._setSubSchemas(resp);
        this._setUniqueness(resp);
        return resp;
    },
    validate: function() {
        const loginFormatRestrictionError = this._validateLoginFormatRestriction();
        if (loginFormatRestrictionError) return loginFormatRestrictionError;
        const enumValidationError = this._validateEnumOneOf();
        if (enumValidationError) return enumValidationError;
        if (!this.get('__supportsMinMax__') || !this.get('__constraint__')) return undefined;
        const constraitType = this.get('__constraint__');
        const constraitHandler = this[$2f2ccccc756c1fbe$var$constraintHandlers[constraitType]];
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(constraitHandler)) return constraitHandler.call(this);
        else {
            (0, $cbf92b1807f0afdb$export$2e2bcd8739ae039).warn('No constraint handler found for: ' + constraitType);
            return undefined;
        }
    },
    _checkBetweenConstraints: function() {
        const minVal = this.get('__minVal__');
        const maxVal = this.get('__maxVal__');
        if (!minVal && !maxVal) return;
        if (!minVal) return {
            __minVal__: $2f2ccccc756c1fbe$var$loc('schema.validation.field.enter.minimum.number', 'courage')
        };
        if (!maxVal) return {
            __maxVal__: $2f2ccccc756c1fbe$var$loc('schema.validation.field.enter.maximum.number', 'courage')
        };
        let val = this._checkIntegerConstraints('__minVal__', 'Min value');
        if (val) return val;
        val = this._checkIntegerConstraints('__maxVal__', 'Max value');
        if (val) return val;
        if (+minVal >= +maxVal) return {
            __maxVal__: $2f2ccccc756c1fbe$var$loc('schema.validation.field.maximum.must.be.greater.than.minimum', 'courage')
        };
    },
    _checkGreaterThanConstraint: function() {
        const minVal = this.get('__minVal__');
        if (!minVal) return;
        const val = this._checkIntegerConstraints('__minVal__', 'Constraint');
        if (val) return val;
    },
    _checkLessThanConstraint: function() {
        const maxVal = this.get('__maxVal__');
        if (!maxVal) return;
        const val = this._checkIntegerConstraints('__maxVal__', 'Constraint');
        if (val) return val;
    },
    _checkEqualsConstraint: function() {
        const equals = this.get('__equals__');
        if (!equals) return;
        const val = this._checkIntegerConstraints('__equals__', 'Constraint');
        if (val) return val;
    },
    _checkIntegerConstraints: function(field, name) {
        const val = this.get(field);
        const error = {}; // eslint-disable-next-line no-restricted-globals
        if (isNaN(val)) {
            if (name === 'Min value') error[field] = $2f2ccccc756c1fbe$var$loc('schema.validation.field.minimum.value.must.be.number', 'courage');
            else if (name === 'Max value') error[field] = $2f2ccccc756c1fbe$var$loc('schema.validation.field.maximum.value.must.be.number', 'courage');
            else if (name === 'Constraint') error[field] = $2f2ccccc756c1fbe$var$loc('schema.validation.field.constraint.must.be.number', 'courage');
            return error;
        }
        if (+val < 0) {
            if (name === 'Min value') error[field] = $2f2ccccc756c1fbe$var$loc('schema.validation.field.minimum.number.must.be.greater.than.zero', 'courage');
            else if (name === 'Max value') error[field] = $2f2ccccc756c1fbe$var$loc('schema.validation.field.maximum.number.must.be.greater.than.zero', 'courage');
            else if (name === 'Constraint') error[field] = $2f2ccccc756c1fbe$var$loc('schema.validation.field.number.must.be.greater.than.zero', 'courage');
            return error;
        }
    },
    _setMasterOverride: function(resp) {
        if (resp.settings && resp.settings.masterOverride && resp.settings.masterOverride) {
            const masterOverrideValue = resp.settings.masterOverride.value;
            if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(masterOverrideValue) && !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(masterOverrideValue)) {
                resp['__masterOverrideType__'] = 'OVERRIDE';
                resp['__masterOverrideValue__'] = masterOverrideValue || [];
            } else resp['__masterOverrideType__'] = resp.settings.masterOverride.type;
        } else resp['__masterOverrideType__'] = 'INHERIT';
    },
    _setRangeConstraints: function(resp) {
        /* eslint complexity: [2, 11] */ if (resp['__displayType__'] === $2f2ccccc756c1fbe$var$STRING) {
            resp['__minVal__'] = resp.minLength;
            resp['__maxVal__'] = resp.maxLength;
        } else if (resp['__displayType__'] === $2f2ccccc756c1fbe$var$INTEGER || resp['__displayType__'] === $2f2ccccc756c1fbe$var$NUMBER) {
            resp['__minVal__'] = resp.minimum;
            resp['__maxVal__'] = resp.maximum;
        }
        if (resp['__minVal__'] && resp['__maxVal__']) {
            if (resp['__minVal__'] === resp['__maxVal__']) {
                resp['__constraint__'] = 'equals';
                resp['__equals__'] = resp['__minVal__'];
            } else resp['__constraint__'] = 'between';
        } else if (!resp['__minVal__'] && resp['__maxVal__']) resp['__constraint__'] = 'lessThan';
        else if (!resp['__maxVal__'] && resp['__minVal__']) resp['__constraint__'] = 'greaterThan';
    },
    _setSubSchemas: function(resp) {
        if (resp.allOf) resp['subSchemas'] = new $2f2ccccc756c1fbe$var$SchemaPropertySubSchemaAllOfCollection(resp.allOf, {
            parse: true
        });
        else if (resp.oneOf) resp['subSchemas'] = new $2f2ccccc756c1fbe$var$SchemaPropertySubSchemaOneOfCollection(resp.oneOf, {
            parse: true
        });
        else if (resp.noneOf) resp['subSchemas'] = new $2f2ccccc756c1fbe$var$SchemaPropertySubSchemaNoneOfCollection(resp.noneOf, {
            parse: true
        });
    },
    _setUniqueness: function(resp) {
        const unique = resp && resp.unique;
        resp['__unique__'] = !!(unique && (unique === (0, $723c4f009c64492a$export$2e2bcd8739ae039).UNIQUENESS.UNIQUE_VALIDATED || unique === (0, $723c4f009c64492a$export$2e2bcd8739ae039).UNIQUENESS.PENDING_UNIQUENESS));
    },
    _setLoginPattern: function() {
        if (!this.get('__isLoginOfBaseSchema__')) return;
        const pattern = this.get('pattern');
        if (pattern === $2f2ccccc756c1fbe$var$loginFormatNonePattern) this.set('__loginFormatRestriction__', (0, $723c4f009c64492a$export$2e2bcd8739ae039).LOGINPATTERNFORMAT.NONE);
        else if (pattern) {
            this.set('__loginFormatRestriction__', (0, $723c4f009c64492a$export$2e2bcd8739ae039).LOGINPATTERNFORMAT.CUSTOM);
            this.set('__loginFormatRestrictionCustom__', this._extractLoginPattern(pattern));
        } else this.set('__loginFormatRestriction__', (0, $723c4f009c64492a$export$2e2bcd8739ae039).LOGINPATTERNFORMAT.EMAIL);
    },
    _updateDisplayType: function() {
        const type = this.get('type');
        if (type === $2f2ccccc756c1fbe$var$STRING && this.get('format')) this.set('__displayType__', (0, $723c4f009c64492a$export$2e2bcd8739ae039).FORMATDISPLAYTYPE[this.get('format')]);
        else {
            const items = this.get('items');
            const arraytype = items && (items.format ? items.format : items.type);
            if (type && arraytype) this.set('__displayType__', (0, $723c4f009c64492a$export$2e2bcd8739ae039).ARRAYDISPLAYTYPE[$2f2ccccc756c1fbe$var$getArrayTypeName(type, arraytype)]);
            else this.set('__displayType__', type);
        }
    },
    _validateEnumOneOf: function() {
        if (!this.get('__isEnumDefinedAndSupported__')) return;
        const enumOneOf = this.get('__oneOf__') || [];
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(enumOneOf)) return {
            __oneOf__: $2f2ccccc756c1fbe$var$loc('model.validation.field.blank', 'courage')
        };
        if (!this._isValidateOneOfConstraint(enumOneOf)) {
            const constraintType = this.get('__enumConstraintType__');
            const errorTypeMsg = $2f2ccccc756c1fbe$var$constraintTypeErrorMessages[constraintType];
            return {
                __oneOf__: errorTypeMsg
            };
        }
    },
    _isValidateOneOfConstraint: function(values) {
        const constraintType = this.get('__enumConstraintType__');
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).all(values, function(value) {
            return (0, $012d4a2affe19c61$export$2e2bcd8739ae039).isConstraintValueMatchType(value.const, constraintType);
        });
    },
    _validateLoginFormatRestriction: function() {
        if (!this.get('__isLoginOfBaseSchema__')) return;
        const loginFormat = this.get('__loginFormatRestriction__');
        const loginFormatCustom = this.get('__loginFormatRestrictionCustom__') || '';
        if (loginFormat === (0, $723c4f009c64492a$export$2e2bcd8739ae039).LOGINPATTERNFORMAT.CUSTOM && loginFormatCustom.trim() === '') return {
            __loginFormatRestrictionCustom__: $2f2ccccc756c1fbe$var$loc('model.validation.field.blank', 'courage')
        };
    },
    toJSON: function() {
        let json = (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).prototype.toJSON.apply(this, arguments);
        json.settings = {
            permissions: {}
        };
        json.settings.permissions['SELF'] = this.get('__userPermission__'); // omit "sensitive" filed will have default it value to false.
        if (this.get('__isSensitive__')) json.settings.sensitive = this.get('__isSensitive__');
        if (this.get('type') === 'image') {
            json.type = 'object';
            json.extendedType = 'image';
        }
        json = this._enumAssignment(json);
        json = this._attributeOverrideToJson(json);
        json = this._normalizeUnionValue(json);
        json = this._patternAssignment(json);
        json = this._uniquenessAssignment(json);
        return json;
    },
    _attributeOverrideToJson: function(json) {
        const masterOverrideType = this.get('__masterOverrideType__');
        const masterOverrideValue = this.get('__masterOverrideValue__');
        if (masterOverrideType === 'OKTA_MASTERED') json.settings.masterOverride = {
            type: 'OKTA_MASTERED'
        };
        else if (masterOverrideType === 'OVERRIDE') {
            json.settings.masterOverride = {
                type: 'ORDERED_LIST',
                value: []
            };
            if (masterOverrideValue instanceof (0, $e9e519c40171c3aa$export$2e2bcd8739ae039)) (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(masterOverrideValue.toJSON(), function(overrideProfile) {
                json.settings.masterOverride.value.push(overrideProfile.id);
            });
            else if (masterOverrideValue instanceof Array) json.settings.masterOverride.value = masterOverrideValue;
            if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(json.settings.masterOverride.value)) delete json.settings.masterOverride;
        }
        if (masterOverrideType === 'INHERIT') delete json.settings.masterOverride;
        return json;
    },
    /**
   * Only allow set "union" value when isScopeSelf is NONE and displayType is
   * array of (string/number/integer), otherwise reset to default.
   *
   * @see /universal-directory/shared/views/components/UnionGroupValuesRadio.js
   */ _normalizeUnionValue: function(json) {
        if (!this.get('__isNoneScopeArrayType__')) json['union'] = undefined;
        return json;
    },
    _enumAssignment: function(json) {
        if (!this.get('__isEnumDefinedAndSupported__')) return json;
         // backfill empty title by constraint
        const enumOneOf = this._getEnumOneOfWithTitleCheck();
        if (this.get('type') === 'array') {
            delete json.items.enum;
            json.items.oneOf = enumOneOf;
        } else {
            delete json.enum;
            json.oneOf = enumOneOf;
        }
        return json;
    },
    _patternAssignment: function(json) {
        if (!this.get('__isLoginOfBaseSchema__') || !this.get('__loginFormatRestriction__')) return json;
        switch(this.get('__loginFormatRestriction__')){
            case (0, $723c4f009c64492a$export$2e2bcd8739ae039).LOGINPATTERNFORMAT.EMAIL:
                delete json.pattern;
                break;
            case (0, $723c4f009c64492a$export$2e2bcd8739ae039).LOGINPATTERNFORMAT.CUSTOM:
                json.pattern = this._buildLoginPattern(this.get('__loginFormatRestrictionCustom__'));
                break;
            case (0, $723c4f009c64492a$export$2e2bcd8739ae039).LOGINPATTERNFORMAT.NONE:
                json.pattern = $2f2ccccc756c1fbe$var$loginFormatNonePattern;
                break;
        }
        return json;
    },
    _uniquenessAssignment: function(json) {
        if (!this.get('__unique__')) delete json.unique;
        else if (!this.get('__isUniqueness__')) json.unique = (0, $723c4f009c64492a$export$2e2bcd8739ae039).UNIQUENESS.UNIQUE_VALIDATED;
        return json;
    },
    /**
   * Character should be escaped except letters, digits and hyphen
   */ _escapedRegexChar: function(pattern, index) {
        const char = pattern.charAt(index);
        if ($2f2ccccc756c1fbe$var$escapedLoginCharsRe.test(char)) return '\\' + char;
        return char;
    },
    _buildLoginPattern: function(pattern) {
        let result = '';
        for(var i = 0; i < pattern.length; i++)result += this._escapedRegexChar(pattern, i);
        return '[' + result + ']+';
    },
    _extractLoginPattern: function(pattern) {
        const re = /^\[(.*)\]\+/;
        const matches = pattern.match(re);
        return matches ? matches[1].replace(/\\(.)/g, '$1') : pattern;
    },
    _getEnumOneOfWithTitleCheck: function() {
        const enumOneOf = this.get('__oneOf__');
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).map(enumOneOf, function(value) {
            if ((0, $b51a961f9fe28c76$export$2e2bcd8739ae039).trim(value.title) !== '') return value;
            value.title = !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isString(value.const) ? JSON.stringify(value.const) : value.const;
            return value;
        });
    },
    _updateTypeFormatConstraints: function() {
        const displayType = this.get('__displayType__'); // OKTA-31952 reset format according to its displayType
        this.unset('format', {
            silent: true
        });
        this.unset('items', {
            silent: true
        });
        this.set((0, $723c4f009c64492a$export$2e2bcd8739ae039).DISPLAYTYPES[displayType]);
        if (displayType !== $2f2ccccc756c1fbe$var$NUMBER && displayType !== $2f2ccccc756c1fbe$var$INTEGER) {
            this.unset('minimum');
            this.unset('maximum');
        }
        if (displayType !== $2f2ccccc756c1fbe$var$STRING) {
            this.unset('minLength');
            this.unset('maxLength');
        }
        this.unset('__minVal__');
        this.unset('__maxVal__');
        this.unset('__equals__');
        this.set('__supportsMinMax__', (0, $723c4f009c64492a$export$2e2bcd8739ae039).SUPPORTSMINMAX.indexOf(this.get('__displayType__')) !== -1);
    },
    _updateMinMax: function() {
        let min;
        let max;
        const displayType = this.get('__displayType__');
        if (displayType === $2f2ccccc756c1fbe$var$STRING) {
            min = 'minLength';
            max = 'maxLength';
        } else if (displayType === $2f2ccccc756c1fbe$var$INTEGER || displayType === $2f2ccccc756c1fbe$var$NUMBER) {
            min = 'minimum';
            max = 'maximum';
        }
        if (this.get('__minVal__')) this.set(min, parseInt(this.get('__minVal__'), 10));
        else this.unset(min);
        if (this.get('__maxVal__')) this.set(max, parseInt(this.get('__maxVal__'), 10));
        else this.unset(max);
    },
    _convertEqualsToMinMax: function() {
        const equals = this.get('__equals__');
        if (equals) {
            this.set('__minVal__', equals);
            this.set('__maxVal__', equals);
        }
    },
    /*
   Normally we would use a derived property here but derived properties do not work with the model Clone function
   so we use this workaround instead.
   */ _setConstraintText: function() {
        const constraint = this.get('__constraint__');
        const min = this.get('__minVal__');
        const max = this.get('__maxVal__');
        const equals = this.get('__equals__');
        switch(constraint){
            case 'between':
                this.set('__constraintText__', 'Between ' + min + ' and ' + max);
                break;
            case 'greaterThan':
                this.set('__constraintText__', 'Greater than ' + min);
                break;
            case 'lessThan':
                this.set('__constraintText__', 'Less than ' + max);
                break;
            case 'equals':
                this.set('__constraintText__', 'Equals ' + equals);
                break;
            default:
                this.set('__constraintText__', '');
                break;
        }
    },
    cleanup: function() {
        if (this.get('__constraint__') === 'lessThan') this.unset('__minVal__');
        else if (this.get('__constraint__') === 'greaterThan') this.unset('__maxVal__');
        if (this.get('scope') !== (0, $723c4f009c64492a$export$2e2bcd8739ae039).SCOPE.SYSTEM) {
            if (this.get('__isScopeSelf__') === true) this.set({
                scope: (0, $723c4f009c64492a$export$2e2bcd8739ae039).SCOPE.SELF
            }, {
                silent: true
            });
            else this.unset('scope');
        }
        if (!this.get('__unique__')) this.unset('unique');
    },
    /**
   * Since there is not an dedicated attribute to flag enum type,
   * use enum values to determine whether the property is enum type or not.
   */ isEnumType: function() {
        return !!this.getEnumValues();
    },
    getEnumValues: function() {
        return this.get('oneOf') || this.get('enum') || this.get('items') && this.get('items')['oneOf'] || this.get('items') && this.get('items')['enum'];
    },
    detectHasEnumDefined: function() {
        const enumValues = this.getEnumValues();
        if (!enumValues) return;
        this.set('__oneOf__', (0, $012d4a2affe19c61$export$2e2bcd8739ae039).convertToOneOf(enumValues));
        this.set('__enumDefined__', true);
    }
});
const $2f2ccccc756c1fbe$var$SchemaPropertySchemaProperties = (0, $e9e519c40171c3aa$export$2e2bcd8739ae039).extend({
    model: $2f2ccccc756c1fbe$var$SchemaPropertySchemaProperty,
    clone: function() {
        return new this.constructor(this.toJSON({
            verbose: true
        }), {
            parse: true
        });
    },
    areAllReadOnly: function() {
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).all(this.pluck('__isReadOnly__'));
    },
    createModelProperties: function() {
        return this.reduce(function(p, schemaProperty) {
            const type = schemaProperty.get('type');
            p[schemaProperty.id] = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone((0, $723c4f009c64492a$export$2e2bcd8739ae039).DISPLAYTYPES[type]);
            if ((0, $723c4f009c64492a$export$2e2bcd8739ae039).SUPPORTSMINMAX.indexOf(type) !== -1) {
                p[schemaProperty.id].minLength = schemaProperty.get('minLength');
                p[schemaProperty.id].maxLength = schemaProperty.get('maxLength');
            }
            if (type === 'string') p[schemaProperty.id].format = schemaProperty.get('format');
            return p;
        }, {});
    }
});
var $2f2ccccc756c1fbe$export$2e2bcd8739ae039 = {
    Model: $2f2ccccc756c1fbe$var$SchemaPropertySchemaProperty,
    Collection: $2f2ccccc756c1fbe$var$SchemaPropertySchemaProperties
};


const $9d7fc9d381913345$var$parseProperties = function(resp) {
    const schemaMeta = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).pick(resp, 'id', 'name', 'displayName');
    const properties = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).map(resp.schema.properties, function(property, name) {
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({
            name: name
        }, property);
    });
    (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(properties, function(property) {
        property['__schemaMeta__'] = schemaMeta;
        if (property.__metadata) {
            property['__metadata__'] = property.__metadata;
            delete property.__metadata;
        }
    });
    return properties;
};
const $9d7fc9d381913345$var$BaseSchemaSchema = (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).extend({
    defaults: {
        id: undefined,
        displayName: undefined,
        name: undefined
    },
    constructor: function() {
        this.properties = new (0, $2f2ccccc756c1fbe$export$2e2bcd8739ae039).Collection();
        (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).apply(this, arguments);
    },
    getProperties: function() {
        return this.properties;
    },
    clone: function() {
        const model = (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).prototype.clone.apply(this, arguments);
        model.getProperties().set(this.getProperties().toJSON({
            verbose: true
        }));
        return model;
    },
    parse: function(resp) {
        const properties = $9d7fc9d381913345$var$parseProperties(resp);
        this.properties.set(properties, {
            parse: true
        });
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(resp, 'schema');
    },
    trimProperty: function(property) {
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(property, 'name');
    },
    toJSON: function() {
        const json = (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).prototype.toJSON.apply(this, arguments);
        json.schema = {
            properties: {}
        };
        this.getProperties().each(function(model) {
            const property = model.toJSON();
            json.schema.properties[property.name] = this.trimProperty(property);
        }, this);
        return json;
    },
    save: function() {
        this.getProperties().each(function(model) {
            model.cleanup();
        });
        return (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).prototype.save.apply(this, arguments);
    }
});
const $9d7fc9d381913345$var$BaseSchemaSchemas = (0, $e9e519c40171c3aa$export$2e2bcd8739ae039).extend({
    model: $9d7fc9d381913345$var$BaseSchemaSchema
});
var $9d7fc9d381913345$export$2e2bcd8739ae039 = {
    parseProperties: $9d7fc9d381913345$var$parseProperties,
    Model: $9d7fc9d381913345$var$BaseSchemaSchema,
    Collection: $9d7fc9d381913345$var$BaseSchemaSchemas
};







// TODO: maybe replaced by
// https://github.com/Calvein/empty-module
// https://github.com/crimx/empty-module-loader
var $84906a29a70de1fc$export$2e2bcd8739ae039 = {
    extend: ()=>{}
};







/**
 * @class SettingsModel
 * @extends {Okta.Model}
 * @private
 */ const $877ed51558e25423$var$props = {
    local: function() {
        const settings = window.okta && window.okta.settings || {};
        const theme = window.okta && window.okta.theme || '';
        return {
            orgId: [
                'string',
                false,
                settings.orgId
            ],
            orgName: [
                'string',
                false,
                settings.orgName
            ],
            serverStatus: [
                'string',
                false,
                settings.serverStatus
            ],
            persona: [
                'string',
                false,
                settings.persona
            ],
            isDeveloperConsole: [
                'boolean',
                false,
                settings.isDeveloperConsole
            ],
            isPreview: [
                'boolean',
                false,
                settings.isPreview
            ],
            permissions: [
                'array',
                true,
                settings.permissions || []
            ],
            theme: [
                'string',
                false,
                theme
            ]
        };
    },
    constructor: function() {
        (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039).apply(this, arguments);
        this.features = window._features || [];
    },
    /**
   * Checks if the user have a feature flag enabled (Based of the org level feature flag)
   * @param  {String}  feature Feature name
   * @return {Boolean}
   */ hasFeature: function(feature) {
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains(this.features, feature);
    },
    /**
   * Checks if any of the given feature flags are enabled (Based of the org level feature flags)
   * @param  {Array}  featureArray Features names
   * @return {Boolean} true if any of the give features are enabled. False otherwise
   */ hasAnyFeature: function(featureArray) {
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).some(featureArray, this.hasFeature, this);
    },
    /**
   * Checks if the user have a specific permission (based on data passed from JSP)
   * @param  {String}  permission Permission name
   * @return {Boolean}
   */ hasPermission: function(permission) {
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains(this.get('permissions'), permission);
    },
    /**
   * Checks if the org has ds theme set
   * @return {Boolean}
   */ isDsTheme: function() {
        return this.get('theme') === 'dstheme';
    }
};
var $877ed51558e25423$export$2e2bcd8739ae039 = (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039).extend($877ed51558e25423$var$props);








var $b17abb91ef0c7ac1$var$CHILDREN = '__children__';
var $b17abb91ef0c7ac1$var$RENDERED = '__rendered__';
var $b17abb91ef0c7ac1$var$PARENT = '__parent__';
var $b17abb91ef0c7ac1$var$CHILD_DEFINITIONS = '__children_definitions__';
var $b17abb91ef0c7ac1$var$ADD_TO_CONTAINER = '__add_to_container__';
function $b17abb91ef0c7ac1$var$getIndex(container, view) {
    for(var i = 0; i < container[$b17abb91ef0c7ac1$var$CHILDREN].length; i++){
        if (view.cid === container[$b17abb91ef0c7ac1$var$CHILDREN][i].cid) return i;
    }
}
function $b17abb91ef0c7ac1$var$noop() {}
function $b17abb91ef0c7ac1$var$doRender(view) {
    view[$b17abb91ef0c7ac1$var$RENDERED] = true;
    var html = view.renderTemplate(view.template);
    if (html) view.$el.html(html);
    else if (view.length) view.$el.empty();
    view.each(function(view) {
        view[$b17abb91ef0c7ac1$var$ADD_TO_CONTAINER]();
    });
}
function $b17abb91ef0c7ac1$var$subscribeEvents(view) {
    var isEventPropertyRe = /^(?!(?:delegate|undelegate|_))([a-zA-Z0-9]+)(?:Events)$/;
    (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each((0, $3e490973b7383cc4$export$2e2bcd8739ae039).allKeys(view), function(key) {
        var matchKeys = key.match(isEventPropertyRe);
        if (!matchKeys) return;
        var bindings = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(view, key);
        var entity = view.options[matchKeys[1]] || view[matchKeys[1]];
        if (!entity || !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isObject(bindings) || !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(entity.trigger)) return;
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(bindings, function(callback, event) {
            var callbacks = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(callback) ? [
                callback
            ] : (0, $3e490973b7383cc4$export$2e2bcd8739ae039).reduce(callback.split(/\s+/), (arr, name)=>{
                if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(view[name])) arr.push(view[name]);
                return arr;
            }, []);
            (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(callbacks, function(cb) {
                view.listenTo(entity, event, cb);
            });
        });
    });
}
/**
   * A View operates on a string template, an token based template, or a model based template, with a few added hooks.
   * It provides a collection of child views, when a child view could be a View or another View.
   * Conceptually, if we were in a file system, the View is a folder, when the concrete child views are files,
   * and the child Views are sub folders.
   *
   * *Technically, when using a View as a container, it could have its own concrete logic,
   * but conceptually we like to keep it separated so a view is either a concrete view or a collection of child views.*
   *
   * In addition to the standard backbone options, we added `settings` and `state` as first class options.
   * it will automatically assign `options` to `this.options` as an instance member.
   *
   * See [Backbone.View](http://backbonejs.org/#View).
   *
   * @class src/framework/View
   * @extends external:Backbone.View
   * @param {Object} [options] options hash
   * @example
   * var DocumentView = Archer.View.extend({
   *   template: [
   *     '<header></header>',
   *     '<article></article>',
   *     '<footer></footer>'
   *   ].join(''),
   *   children: [[HeaderView, 'header'], [ContentView, 'article'], [FooterView, 'footer']]
   * });
   */ let $b17abb91ef0c7ac1$var$View;
const $b17abb91ef0c7ac1$var$proto = {
    /**
     * An object listing events and callback bind to this.{entity}
     * @name *Events
     * @memberof src/framework/View
     * @type {(Object|Function)}
     * @instance
     * @example
     * var FooView = View.extend({
     *   modelEvents: {
     *     'change:name': 'render'
     *   }
     * })
     * //equivalent to ==>
     * var FooView = View.extend({
     *   initialize: function() {
     *     this.listenTo(this.model, 'change:name', this.render);
     *   }
     * });
     *
     *
     * //Multiple callbacks:
     * var FooView = View.extend({
     *   modelEvents: {
     *     'change:name': 'render foo'
     *   },
     *   foo: function() {}
     * });
     *
     * //Callbacks As Function:
     * var FooView = View.extend({
     *   stateEvents: {
     *     'change': function() {
     *   }
     * });
     *
     * //Event Configuration As Function
     * var FooView = View.extend({
     *   collectionEvents: function() {
     *     var events = { 'change:name deleteItem': 'render' };
     *     events['changeItem'] = 'spin';
     *     events['addItem'] = function() {};
     *     return events;
     *   }
     * });
     */ preinitialize: function(options) {
        /* eslint max-statements: [2, 17] */ this.options = options || {};
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend(this, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).pick(this.options, 'state', 'settings')); // init per-instance children collection
        this[$b17abb91ef0c7ac1$var$CHILDREN] = [];
        this[$b17abb91ef0c7ac1$var$RENDERED] = false;
        this[$b17abb91ef0c7ac1$var$PARENT] = null;
        this[$b17abb91ef0c7ac1$var$CHILD_DEFINITIONS] = this.children; // we want to make sure initialize is triggered *after* we append the views from the `this.views` array
        // FIXME:
        // It's actually can be done by override initialize method
        //  initialize() { run extra login; super.initialize(); }
        // BUT the problem is child classes would override initialize without invoke super.
        // hence we have to also looking into (refactoring) ALL child classes.
        this.__original_initialize__ = this.initialize;
        this.initialize = $b17abb91ef0c7ac1$var$noop;
    },
    constructor: function(options, ...rest) {
        (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).View.call(this, options);
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each((0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, $b17abb91ef0c7ac1$var$CHILD_DEFINITIONS), function(childDefinition) {
            this.add.apply(this, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(childDefinition) ? childDefinition : [
                childDefinition
            ]);
        }, this);
        delete this[$b17abb91ef0c7ac1$var$CHILD_DEFINITIONS];
        const autoRender = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'autoRender');
        if (autoRender && this.model) {
            var event = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(autoRender) ? (0, $3e490973b7383cc4$export$2e2bcd8739ae039).map(autoRender, function(field) {
                return 'change:' + field;
            }).join(' ') : 'change';
            this.listenTo(this.model, event, function() {
                this.render();
            });
        }
        this.initialize = this.__original_initialize__;
        this.initialize.call(this, options, ...rest); // initialize in child class may have any number of parameters
        $b17abb91ef0c7ac1$var$subscribeEvents(this);
    },
    /**
     * Unregister view from container
     * Note: this will not remove the view from the dom
     * and will not call the `remove` method on the view
     *
     * @param {src/framework/View} view the view to unregister
     * @private
     */ unregister: function(view) {
        this.stopListening(view);
        var viewIndex = $b17abb91ef0c7ac1$var$getIndex(this, view); // viewIndex is undefined when the view is not found (may have been removed)
        // check if it is undefined to prevent unexpected thing to happen
        // array.splice(undefined, x) removes the first x element(s) from the array
        // this protects us against issues when calling `remove` on a child view multiple times
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isNumber(viewIndex)) this[$b17abb91ef0c7ac1$var$CHILDREN].splice(viewIndex, 1);
    },
    /**
     * Should we auto render the view upon model change. Boolean or array of field names to listen to.
     * @type {Boolean|Array}
     * @deprecated Instead, please use modelEvents
     * @example
     * modelEvents: {
     *   change:name: 'render'
     * }
     */ autoRender: false,
    /**
     *
     * When the template is an underscore template, the render method will pass the options has to the template
     * And the associated model, if exists, when it will prefer the model over the options in case of a conflict.
     * {@link #render View.render}
     * @type {(String|Function)}
     * @example
     * var View = View.extend({
     *   template: '<p class="name">{{name}}</p>'
     * };
     */ template: null,
    /**
     * A list of child view definitions to be passed to {@link #add this.add()}.
     * Note: these definitions will be added **before** the {@link #constructor initiliaze} method invokes.
     * @type {(Array|Function)}
     * @example
     * var Container = View.extend({
     *    template: '<p class="content"></p>',
     *    children: [
     *      [ContentView, '.content'],
     *      [OtherContentView, '.content'],
     *      OtherView
     *    ]
     *  })
     *
     * var Container = View.extend({
     *    template: '<dov class="form-wrap"></div>',
     *    children: function () {
     *      return [
     *        [FormView, '.form-wrap', {options: {model: this.optiosn.otherModel}}]
     *      ]
     *    }
     *  })
     */ children: [],
    /**
     * Add a child view to the container.
     * If the container is already rendered, will also render the view  and append it to the DOM.
     * Otherwise will render and append once the container is rendered.
     *
     * *We believe that for the sake of encapsulation, a view should control its own chilren, so we treat this method as
     * protected and even though technically you can call `view.add` externally we strongly discourage it.*
     *
     * @param {(src/framework/View|String)} view A class (or an instance which is discouraged) of a View - or an HTML
     * string/template
     * @param {String} [selector] selector in the view's template on which the view will be added to
     * @param {Object} [options]
     * @param {Boolean} [options.bubble=false] Bubble (proxy) events from this view up the chain
     * @param {Boolean} [options.prepend=false] Prepend the view instend of appending
     * @param {String} [options.selector] Selector in the view's template on which the view will be added to
     * @param {Object} [options.options] Extra options to pass to the child constructor
     * @protected
     * @returns {src/framework/View} - The instance of itself for the sake of chaining
     * @example
     * var Container = View.extend({
     *
     *   template: [
     *     '<h1></h1>',
     *     '<section></section>',
     *   ].join(''),
     *
     *   initalize: function () {
     *
     *     this.add(TitleView, 'h1'); // will be added to <h1>
     *
     *     this.add(ContentView1, 'section'); // will be added to <section>
     *
     *     this.add(ContentView2, 'section', {prepend: true}); // will be add into <section> **before** ContentView1
     *
     *     this.add(OtherView, {
     *       options: {
     *         model: new Model()
     *       }
     *     }); // will be added **after** the <section> element
     *
     *     this.add('<p class="name">some html</p>'); //=> "<p class="name">some html</p>"
     *     this.add('<p class="name">{{name}}</p>'); //=> "<p class="name">John Doe</p>"
     *     this.add('{{name}}') //=> "<div>John Doe</div>"
     *     this.add('<span>{{name}}</span> w00t') //=> "<div><span>John Doe</span> w00t</div>"
     *   }
     *
     * });
     *
     * var container - new View({name: 'John Doe'});
     */ add: function(view, selector, bubble, prepend, extraOptions) {
        /* eslint max-statements: [2, 30], complexity: [2, 12] */ var options = {};
        var args = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).toArray(arguments); // This will throw if a compiled template function is passed accidentally
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(view) && (!view.prototype || !view.prototype.render)) throw new Error('Type passed to add() is not a View');
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isObject(selector)) {
            options = selector;
            selector = options.selector;
            bubble = options.bubble;
            prepend = options.prepend;
            extraOptions = options.options;
        } else if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isObject(bubble)) {
            options = bubble;
            bubble = options.bubble;
            prepend = options.prepend;
            extraOptions = options.options;
        } // TODO: This will be deprecated at some point. Views should use precompiled templates
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isString(view)) view = function(template) {
            return $b17abb91ef0c7ac1$var$View.extend({
                constructor: function() {
                    try {
                        var $el = (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).$(template);
                        if ($el.length !== 1) throw new Error('invalid Element');
                        var unescapingRexExp = /&(\w+|#x\d+);/g;
                        var elementUnescapedOuterHTMLLength = $el.prop('outerHTML').replace(unescapingRexExp, ' ').length;
                        var templateUnescapedLength = template.replace(unescapingRexExp, ' ').length;
                        if (elementUnescapedOuterHTMLLength !== templateUnescapedLength) throw new Error('invalid Element');
                        this.template = $el.html(); // Template string will be compiled by handlebars
                        this.el = $el.empty()[0];
                    } catch (e) {
                        // not a valid html tag.
                        this.template = template;
                    }
                    $b17abb91ef0c7ac1$var$View.apply(this, arguments);
                }
            });
        }(view);
        if (view.prototype && view.prototype instanceof $b17abb91ef0c7ac1$var$View) {
            /* eslint new-cap: 0 */ var viewOptions = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit((0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({}, this.options, extraOptions), 'el');
            args[0] = new view(viewOptions);
            return this.add.apply(this, args);
        } // prevent dups
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isNumber($b17abb91ef0c7ac1$var$getIndex(this, view))) throw new Error('Duplicate child');
        view[$b17abb91ef0c7ac1$var$PARENT] = this; // make the view responsible for adding itself to the parent:
        // * register the selector in the closure
        // * register a reference the parent in the closure
        view[$b17abb91ef0c7ac1$var$ADD_TO_CONTAINER] = (function(selector) {
            return function() {
                if (selector && view[$b17abb91ef0c7ac1$var$PARENT].$(selector).length !== 1) throw new Error('Invalid selector: ' + selector);
                var $el = selector ? this[$b17abb91ef0c7ac1$var$PARENT].$(selector) : this[$b17abb91ef0c7ac1$var$PARENT].$el;
                this.render(); // we need to delegate events in case
                // the view was added and removed before
                this.delegateEvents(); // this[PARENT].at(index).$el.before(this.el);
                prepend ? $el.prepend(this.el) : $el.append(this.el);
            };
        }).call(view, selector); // if flag to bubble events is set
        // proxy all child view events
        if (bubble) this.listenTo(view, 'all', function() {
            this.trigger.apply(this, arguments);
        });
         // add to the dom if `render` has been called
        if (this.rendered()) view[$b17abb91ef0c7ac1$var$ADD_TO_CONTAINER]();
         // add view to child views collection
        this[$b17abb91ef0c7ac1$var$CHILDREN].push(view);
        return this;
    },
    /**
     * Remove all children from container
     */ removeChildren: function() {
        this.each(function(view) {
            view.remove();
        });
        return this;
    },
    /**
     *  Removes a view from the DOM, and calls stopListening to remove any bound events that the view has listenTo'd.
     *  Also removes all childern of the view if any, and removes itself from its parent view(s)
     */ remove: function() {
        this.removeChildren();
        if (this[$b17abb91ef0c7ac1$var$PARENT]) this[$b17abb91ef0c7ac1$var$PARENT].unregister(this);
        return (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).View.prototype.remove.apply(this, arguments);
    },
    /**
     * Compile the template to function you can apply tokens on on render time.
     * Uses the underscore tempalting engine by default
     * @protected
     * @param  {String} template
     * @return {Function} a compiled template
     */ // TODO: This will be deprecated at some point. Views should use precompiled templates
    compileTemplate: function(template) {
        /* eslint  @okta/okta-ui/no-specific-methods: 0*/ return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).template(template, undefined);
    },
    /**
     * Render a template with `this.model` and `this.options` as parameters
     * preferring the model over the options.
     *
     * @param  {(String|Function)} template The template to build
     * @return {String} An HTML string
     * @protected
     */ renderTemplate: function(template) {
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isString(template)) // TODO: This will be deprecated at some point. Views should use precompiled templates
        template = this.compileTemplate(template);
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(template)) return template(this.getTemplateData());
    },
    /**
     * The data hash passed to the compiled template
     * @return {Object}
     * @protected
     */ getTemplateData: function() {
        var modelData = this.model && this.model.toJSON({
            verbose: true
        }) || {};
        var options = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(this.options, [
            'state',
            'settings',
            'model',
            'collection'
        ]);
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults({}, modelData, options);
    },
    /**
     * Renders the template to `$el` and append all children in order
     * {@link #template View.template}
     */ render: function() {
        this.preRender();
        $b17abb91ef0c7ac1$var$doRender(this);
        this.postRender();
        return this;
    },
    /**
     * Pre render routine. Will be called right *before* the logic in {@link #render} is executed
     * @method
     */ preRender: $b17abb91ef0c7ac1$var$noop,
    /**
     * Post render routine. Will be called right *after* the logic in {@link #render} is executed
     * @method
     */ postRender: $b17abb91ef0c7ac1$var$noop,
    /**
     * Was this instance rendered
     */ rendered: function() {
        return this[$b17abb91ef0c7ac1$var$RENDERED];
    },
    /**
     * Get all direct child views.
     * @returns {src/framework/View[]}
     * @example
     * var container = View.extend({
     *   children: [View1, View2]
     * }).render();
     * container.getChildren() //=> [view1, view2];
     */ getChildren: function() {
        return this.toArray();
    },
    /**
     * Get a child by index
     * @param {number} index
     * @returns {src/framework/View} The child view
     */ at: function(index) {
        return this.getChildren()[index];
    },
    /**
     * Invokes a method on all children down the tree
     *
     * @param {String} method The method to invoke
     */ invoke: function(methodName) {
        var args = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).toArray(arguments);
        this.each(function(child) {
            // if child has children, bubble down the tree
            if (child.size()) child.invoke.apply(child, args);
             // run the function on the child
            if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(child[methodName])) child[methodName].apply(child, args.slice(1));
        });
        return this;
    }
};
$b17abb91ef0c7ac1$var$View = (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).View.extend(/** @lends src/framework/View.prototype */ $b17abb91ef0c7ac1$var$proto); // Code borrowed from Backbone.js source
// Underscore methods that we want to implement on the Container.
var $b17abb91ef0c7ac1$var$methods = [
    'each',
    'map',
    'reduce',
    'reduceRight',
    'find',
    'filter',
    'reject',
    'every',
    'some',
    'contains',
    'toArray',
    'size',
    'first',
    'initial',
    'rest',
    'last',
    'without',
    'indexOf',
    'shuffle',
    'lastIndexOf',
    'isEmpty',
    'chain',
    'where',
    'findWhere'
];
(0, $3e490973b7383cc4$export$2e2bcd8739ae039).each($b17abb91ef0c7ac1$var$methods, function(method) {
    $b17abb91ef0c7ac1$var$View.prototype[method] = function() {
        var args = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).toArray(arguments);
        args.unshift((0, $3e490973b7383cc4$export$2e2bcd8739ae039).toArray(this[$b17abb91ef0c7ac1$var$CHILDREN]));
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039)[method].apply((0, $3e490973b7383cc4$export$2e2bcd8739ae039), args);
    };
});
/**
   * See [_.each](http://underscorejs.org/#each)
   * @name each
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Function} iterator
   * @param {Object} [context]
   */ /**
   * See [_.map](http://underscorejs.org/#map)
   * @name map
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Function} iterator
   * @param {Object} [context]
   */ /**
   * See [_.reduce](http://underscorejs.org/#reduce)
   * @name reduce
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Function} iterator
   * @param {Mixed} memo
   * @param {Object} [context]
   */ /**
   * See [_.reduceRight](http://underscorejs.org/#reduceRight)
   * @name reduceRight
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Function} iterator
   * @param {Mixed} memo
   * @param {Object} [context]
   */ /**
   * See [_.find](http://underscorejs.org/#find)
   * @name find
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Function} predicate
   * @param {Object} [context]
   */ /**
   * See [_.filter](http://underscorejs.org/#filter)
   * @name filter
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Function} predicate
   * @param {Object} [context]
   */ /**
   * See [_.reject](http://underscorejs.org/#reject)
   * @name reject
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Function} predicate
   * @param {Object} [context]
   */ /**
   * See [_.every](http://underscorejs.org/#every)
   * @name every
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Function} [predicate]
   * @param {Object} [context]
   */ /**
   * See [_.some](http://underscorejs.org/#some)
   * @name some
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Function} [predicate]
   * @param {Object} [context]
   */ /**
   * See [_.contains](http://underscorejs.org/#contains)
   * @name contains
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Mixed} value
   */ /**
   * See [_.toArray](http://underscorejs.org/#toArray)
   * @name toArray
   * @memberof src/framework/View
   * @method
   * @instance
   */ /**
   * See [_.size](http://underscorejs.org/#size)
   * @name size
   * @memberof src/framework/View
   * @method
   * @instance
   */ /**
   * See [_.first](http://underscorejs.org/#first)
   * @name first
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Number} [n]
   */ /**
   * See [_.initial](http://underscorejs.org/#initial)
   * @name initial
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Number} [n]
   */ /**
   * See [_.last](http://underscorejs.org/#last)
   * @name last
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Number} [n]
   */ /**
   * See [_.rest](http://underscorejs.org/#rest)
   * @name rest
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Number} [index]
   */ /**
   * See [_.without](http://underscorejs.org/#without)
   * @name without
   * @memberof src/framework/View
   * @method
   * @instance
   */ /**
   * See [_.indexOf](http://underscorejs.org/#indexOf)
   * @name indexOf
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Mixed} value
   * @param {Boolean} [isSorted]
   */ /**
   * See [_.shuffle](http://underscorejs.org/#shuffle)
   * @name shuffle
   * @memberof src/framework/View
   * @method
   * @instance
   */ /**
   * See [_.shuffle](http://underscorejs.org/#lastIndexOf)
   * @name lastIndexOf
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Mixed} value
   * @param {Number} [fromIndex]
   */ /**
   * See [_.isEmpty](http://underscorejs.org/#isEmpty)
   * @name isEmpty
   * @memberof src/framework/View
   * @method
   * @instance
   */ /**
   * See [_.chain](http://underscorejs.org/#chain)
   * @name chain
   * @memberof src/framework/View
   * @method
   * @instance
   */ /**
   * See [_.where](http://underscorejs.org/#where)
   * @name where
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Object} properties
   */ /**
   * See [_.findWhere](http://underscorejs.org/#findWhere)
   * @name findWhere
   * @memberof src/framework/View
   * @method
   * @instance
   * @param {Object} properties
   */ /**
 * It's used for distinguishing the ambiguity from _.isFunction()
 * which returns True for both a JavaScript Class constructor function
 * and normal function. With this flag, we can tell a function is actually
 * a View Class.
 * This flag is added in order to support the type of a parameter can be
 * either a Class or pure function that returns a Class.
 */ $b17abb91ef0c7ac1$var$View.isCourageView = true;
var $b17abb91ef0c7ac1$export$2e2bcd8739ae039 = $b17abb91ef0c7ac1$var$View;




/* eslint @okta/okta-ui/no-specific-methods: 0 */ /**
 * @class module:Okta.internal.util.TemplateUtil
 * @hideconstructor
 */ var $29621c73903f768b$export$2e2bcd8739ae039 = /** @lends module:Okta.internal.util.TemplateUtil */ {
    /**
   * Compiles a Handlebars template
   * @static
   * @method
   */ // TODO: This will be deprecated at some point. Views should use pre-compiled templates
    tpl: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).memoize(function(tpl) {
        // If the passed template has no Handlebars syntax,
        // we can simply return a simple function that returns the input template string
        if (!(0, $3e490973b7383cc4$export$e0b1c073ce210f17)(tpl)) return ()=>tpl;
        (0, $3e490973b7383cc4$export$61051857ea442b7f)(tpl);
        /* eslint @okta/okta-ui/no-specific-methods: 0 */ return function(context) {
            return (0, $d30415a7ae055e38$export$2e2bcd8739ae039).compile(tpl)(context);
        };
    }),
    /**
   * Checks whether the given template is a string and logs appropriately if so.
   * String templates should be avoided in favor of precompiled templates. OKTA-997448
   * @static
   * @method
   */ logIfStringTemplate: (0, $3e490973b7383cc4$export$61051857ea442b7f)
};


const $5f539c045973220f$var$eventBus = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone((0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Events); // add `broadcast` and `listen` functionality to all views
// We use one event emitter per all views
// This means we need to be very careful with event names
const $5f539c045973220f$var$proto = {
    constructor: function(options, ...rest) {
        (0, $b17abb91ef0c7ac1$export$2e2bcd8739ae039).call(this, options, ...rest);
        this.module && this.$el.attr('data-view', this.module.id);
    },
    /**
   * @deprecated Use {@link #removeChildren}
   */ empty: function() {
        return this.removeChildren();
    },
    compileTemplate: (0, $29621c73903f768b$export$2e2bcd8739ae039).tpl,
    /**
   *
   * Broadcasts a global event that all views and controllers can subscribe to
   * for framework use only - prefer using a shared model
   *
   * @param {String} eventName A unique identifier for the event
   * @param {...String} param Parameter to pass with the event (can pass more than one parameter)
   * @deprecated For internal use only
   * @private
   */ broadcast: function() {
        $5f539c045973220f$var$eventBus.trigger.apply($5f539c045973220f$var$eventBus, arguments);
        return this;
    },
    /**
   * Subscribe to broadcast events
   * for framework use only - prefer using a shared model
   *
   * @param {String} eventName The event identifier to subscribe
   * @param {Function} fn The callback function to invoke
   * @deprecated For internal use only
   * @private
   */ listen: function(name, fn) {
        $5f539c045973220f$var$eventBus.off(name, fn);
        this.listenTo($5f539c045973220f$var$eventBus, name, fn);
        return this;
    },
    /**
   * Shows a notification box
   * @param {String} level success / warning / error
   * @param {String} message The message to display
   * @param {Object} [options]
   * @param {Number} [options.width] Set a custom width
   * @param {String} [options.title] Set a custom title
   * @param {Boolean} [options.hide=true] Do we want to auto-hide this notification?
   * @param {Boolean} [options.dismissable] Show a dismiss button
   * @example
   * view.notify('success', 'Group created successfully');
   */ notify: function(level, message, options) {
        this.broadcast('notification', (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults({
            message: message,
            level: level
        }, options));
        return this;
    },
    /**
   * Shows a confirmation dialog
   *
   * Uses https://www.ericmmartin.com/projects/simplemodal/.
   * If you want to configure the simplemodal options use ConfirmationDialog instead.
   *
   * The main difference between this and the native javascript `confirm` method
   * Is this method is non blocking (note the callback pattern).
   *
   * The callback function will run in the context (`this`) of the invoking view.
   *
   * @param {String} [title] The title of the confirmation dialog
   * @param {String} [message] The message of the confirmation dialog
   * @param {Function} [okfn] The callback to run when the user hits "OK" (runs in the context of the invoking view)
   * @param {Function} [cancelfn] The callback to run when the user hits "Cancel"
   *        (runs in the context of the invoking view)
   * @example
   * view.confirm('Delete Group', 'Are you sure you want to delete the selected group?', function () {
   *   model.destroy();
   * });
   *
   * // title will be auto-set to "Okta"
   * view.confirm('Are you sure you want to delete the selected group?', function () {
   *   model.destroy();
   * });
   *
   * view.confirm({
   *   title: 'Delete Group', //=> Modal title
   *   subtitle: 'Are you sure you want to delete the selected group?', //=> Modal subtitle
   *   content: '<h3 color="red">THIS WILL DELETE THE GROUP!</h3>', //=> A template or a view to add to the modal
   *   save: 'Delete Group', //=> Button label
   *   ok: _.bind(model.save, model) // Callback function on hitting "ok" button
   *   cancel: 'Cancel', //=> Button label
   *   cancelFn: _.bind(model.destroy, model) // Callback function on hitting "cancel" button
   * });
   */ confirm: function(title, message, okfn, cancelfn) {
        let options;
        /* eslint max-statements: [2, 12] */ if (typeof title === 'object') options = title;
        else // eslint-disable-next-line no-lonely-if
        if (arguments.length === 2 && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(message)) options = {
            title: 'Okta',
            // eslint-disable-line @okta/okta/no-unlocalized-text
            subtitle: title,
            ok: message
        };
        else options = {
            title: title,
            subtitle: message,
            ok: okfn,
            cancelFn: cancelfn
        };
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(options.ok)) options.ok = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(options.ok, this);
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(options.cancelFn)) options.cancelFn = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(options.cancelFn, this);
        this.broadcast('confirmation', options);
        return this;
    },
    /**
   * Shows an alert box
   *
   * The main difference between this and the native javascript `alert` method
   * Is this method is non blocking.
   *
   * @param {String} message The message
   * @example
   * view.alert('Mission complete');
   */ alert: function(params) {
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isString(params)) params = {
            subtitle: params
        };
        this.confirm((0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({}, params, {
            noCancelButton: true
        }));
        return this;
    }
};
/**
 * See {@link src/framework/View} for more detail and examples from the base class.
 * @class module:Okta.View
 * @extends src/framework/View
 */ /** @lends module:Okta.View.prototype */ var $5f539c045973220f$export$2e2bcd8739ae039 = (0, $b17abb91ef0c7ac1$export$2e2bcd8739ae039).extend($5f539c045973220f$var$proto, /** @lends View.prototype */ {
    /** @method */ decorate: function(TargetView) {
        const BaseViewView = TargetView.extend({});
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults(BaseViewView.prototype, $5f539c045973220f$var$proto);
        return BaseViewView;
    }
});



const $fc9f6cfa7e0f744f$var$defaults = {
    level: 'success',
    hide: true,
    fade: 400,
    delay: 3000,
    width: 0,
    dismissable: false
};
var $fc9f6cfa7e0f744f$export$2e2bcd8739ae039 = (0, $5f539c045973220f$export$2e2bcd8739ae039).extend({
    className: 'infobox infobox-confirm infobox-confirm-fixed',
    events: {
        'click .infobox-dismiss-link': function(e) {
            e.preventDefault();
            this.fadeOut();
        }
    },
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a class=\"infobox-dismiss-link\" title=\"" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "courage",
                    "code": "component.dismiss"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 58
                    },
                    "end": {
                        "line": 1,
                        "column": 108
                    }
                }
            })) + "\" href=\"#\"><span class=\"dismiss-icon\"></span></a>";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<h3>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "title",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 220
                    },
                    "end": {
                        "line": 1,
                        "column": 229
                    }
                }
            }) : helper)) + "</h3>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "dismissable") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 164
                    }
                }
            })) != null ? stack1 : "") + "<span class=\"icon " + alias4((helper = (helper = lookupProperty(helpers, "level") || (depth0 != null ? lookupProperty(depth0, "level") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "level",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 182
                    },
                    "end": {
                        "line": 1,
                        "column": 191
                    }
                }
            }) : helper)) + "-16\"></span>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "title") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 203
                    },
                    "end": {
                        "line": 1,
                        "column": 241
                    }
                }
            })) != null ? stack1 : "") + "<p>" + alias4((helper = (helper = lookupProperty(helpers, "message") || (depth0 != null ? lookupProperty(depth0, "message") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "message",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 244
                    },
                    "end": {
                        "line": 1,
                        "column": 255
                    }
                }
            }) : helper)) + "</p>";
        },
        "useData": true
    }),
    getNotificationOffsetTop: function() {
        const ADMIN_TOP_NAV_HEIGHT = 64;
        const ADDITIONAL_TOP_OFFSET = 20;
        const defaultOffset = ADDITIONAL_TOP_OFFSET + ADMIN_TOP_NAV_HEIGHT; // 20px margin + 64px top nav header height
        // Check if there are any banners present that would push the notification down further
        const bannersSlotEl = document.querySelector('div[slot="banners"]');
        if (bannersSlotEl) // Add the total height of the banners slot to the default offset
        return defaultOffset + bannersSlotEl.offsetHeight;
        return defaultOffset;
    },
    initialize: function() {
        this.options = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults({}, this.options, $fc9f6cfa7e0f744f$var$defaults);
        if (!this.options.message) switch(this.options.level){
            case 'success':
                this.options.message = (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize('notification.default.message.success', 'courage');
                break;
            case 'error':
                this.options.message = (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize('notification.default.message.error', 'courage');
                break;
            case 'warning':
                this.options.message = (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize('notification.default.message.warning', 'courage');
                break;
        }
        this.$el.addClass('infobox-' + this.options.level); // Override the top position value set in CSS with one calculated at runtime
        this.$el.css('top', this.getNotificationOffsetTop() + 'px');
        if (this.options.width) this.$el.width(this.options.width);
    },
    getTemplateData: function() {
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend((0, $3e490973b7383cc4$export$2e2bcd8739ae039).pick(this.options, 'level', 'message', 'title'), {
            dismissable: this.options.hide === false || this.options.dismissable === true
        });
    },
    postRender: function() {
        if (this.options.hide) (0, $3e490973b7383cc4$export$2e2bcd8739ae039).delay((0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(this.fadeOut, this), this.options.delay);
    },
    fadeOut: function() {
        this.$el.fadeOut(this.options.fade, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(this.remove, this));
    }
});


function $ebb4e572c564df7e$var$getRoute(router, route) {
    const root = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(router, 'root') || '';
    if (root && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isString(route)) return [
        root,
        route
    ].join('/').replace(/\/{2,}/g, '/');
    return route;
}
/**
 * BaseRouter is a standard [Backbone.Router](http://backbonejs.org/#Router)
 * with a few additions:
 * - Explicit mapping between routes and controllers
 * - Support for rendering notification and confirmation dialogs
 *
 * Checkout the [Hello World Tutorial](https://github.com/okta/courage/wiki/Hello-World)
 * for a step-by-step guide to using this.
 *
 * @class module:Okta.Router
 * @extends external:Backbone.Router
 * @param {Object} options options hash
 * @param {String} options.el a jQuery selector string stating where to attach the controller in the DOM
 */ const $ebb4e572c564df7e$var$props = /** @lends module:Okta.Router.prototype */ {
    /**
   * The root URL for the router. When setting {@link http://backbonejs.org/#Router-routes|routes},
   * it will be prepended to each route.
   * @type {String|Function}
   */ root: '',
    listen: (0, $fc9f6cfa7e0f744f$export$2e2bcd8739ae039).prototype.listen,
    constructor: function(options = {}) {
        this.el = options.el;
        /**
     * Make sure `this.settings` has been set before invoke super - `Backbone.Router.apply`,
     * which will invoke `this.initialize`, which could use `this.settings`.
     *
     * In theory we can set `this.settings` in `this.initialize` and assume `child.initialize`
     * will invoke `super.initialize` first. But in reality, `child.initialize` doesn't call
     * `super.initialize` at all.
     */ this.settings = new (0, $877ed51558e25423$export$2e2bcd8739ae039)((0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(options, 'el'));
        if (options.root) this.root = options.root;
        (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Router.apply(this, arguments);
        this.listen('notification', this._notify);
        this.listen('confirmation', this._confirm);
    },
    /**
   * Fires up a confirmation dialog
   *
   * @param  {Object} options Options Hash
   * @param  {String} options.title The title
   * @param  {Array<string>} buttonOrder The order of the buttons
   * @param  {String} options.subtitle The explain text
   * @param  {String} options.save The text for the save button
   * @param  {Function} options.ok The callback function to run when hitting "OK"
   * @param  {String} options.cancel The text for the cancel button
   * @param  {Function} options.cancelFn The callback function to run when hitting "Cancel"
   * @param  {Boolean} options.noCancelButton Don't render the cancel button (useful for alert dialogs)
   * @param  {Boolean} options.noSubmitButton Don't render the primary button (useful for alert dialogs)
   * @private
   *
   * @return {Okta.View} the dialog view
   */ _confirm: function(options = {}) {
        const Dialog = (0, $84906a29a70de1fc$export$2e2bcd8739ae039).extend((0, $3e490973b7383cc4$export$2e2bcd8739ae039).pick(options, 'title', 'subtitle', 'save', 'ok', 'cancel', 'cancelFn', 'noCancelButton', 'noSubmitButton', 'content', 'danger', 'type', 'closeOnOverlayClick', 'buttonOrder'));
        const dialog = new Dialog({
            model: this.settings
        }); // The model is here because itsa part of the BaseForm paradigm.
        // It will be ignored in the context of a confirmation dialog.
        dialog.render();
        return dialog; // test hook
    },
    /**
   * Fires up a notification banner
   *
   * @param  {Object} options Options Hash
   * @return {Okta.View} the notification view
   * @private
   */ _notify: function(options) {
        const notification = new (0, $fc9f6cfa7e0f744f$export$2e2bcd8739ae039)(options);
        (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)('#content').prepend(notification.render().el);
        return notification; // test hook
    },
    /**
   * Renders a Controller
   * This will initialize new instance of a controller and call render on it
   *
   * @param  {Okta.Controller} Controller The controller Class we which to render
   * @param  {Object} [options] Extra options to the controller constructor
   */ render: function(Controller, options) {
        this.unload();
        options = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend((0, $3e490973b7383cc4$export$2e2bcd8739ae039).pick(this, 'settings', 'el'), options || {});
        this.controller = new Controller(options);
        this.controller.render();
    },
    /**
   * Starts the backbone history object
   *
   * Waits for the dom to be ready before calling `Backbone.history.start()` (IE issue).
   *
   * See [Backbone History](http://backbonejs.org/#History) for more information.
   */ start: function(...args) {
        (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(function() {
            if ((0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).History.started) {
                (0, $cbf92b1807f0afdb$export$2e2bcd8739ae039).error('History has already been started');
                return;
            }
            (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).history.start(...args);
        });
    },
    /**
   * Removes active controller and frees up event listeners
   */ unload: function() {
        if (this.controller) {
            this.stopListening(this.controller);
            this.stopListening(this.controller.state);
            this.controller.remove();
        }
    },
    route: function(route, name, callback) {
        return (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Router.prototype.route.call(this, $ebb4e572c564df7e$var$getRoute(this, route), name, callback);
    },
    navigate: function(fragment, options) {
        return (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Router.prototype.navigate.call(this, $ebb4e572c564df7e$var$getRoute(this, fragment), options);
    }
};
var $ebb4e572c564df7e$export$2e2bcd8739ae039 = (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Router.extend($ebb4e572c564df7e$var$props);





/**
 * @class StateMachine
 * @extends Okta.Model
 * @private
 *
 * A state object that holds the applciation state
 */ var $0ee3941b32c0f6e5$export$2e2bcd8739ae039 = (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039).extend({
    /**
   * Invokes a method on the applicable {@link Okta.Controller}
   *
   * ```javascript
   * state.invoke('methodName', 'param1', 'param2')
   * // Will call
   * contoller.methodName('param1', 'param2')
   * ```
   * @param {String} methodName the name of the controller method to invoke on the controller
   */ invoke: function() {
        const args = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).toArray(arguments);
        args.unshift('__invoke__');
        this.trigger.apply(this, args);
    }
});



function $fd8e23e9341bb61f$var$clean(obj) {
    const res = {};
    (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(obj, function(value, key) {
        if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isNull(value)) res[key] = value;
    });
    return res;
}
const $fd8e23e9341bb61f$var$proto = /** @lends module:Okta.Controller.prototype */ {
    preinitialize: function(options = {}) {
        // If 'state' is passed down as options, use it, else create a 'new StateMachine()'
        this.state = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'state');
        const hasStateBeenInitialized = this.state instanceof (0, $0ee3941b32c0f6e5$export$2e2bcd8739ae039) || options.state instanceof (0, $0ee3941b32c0f6e5$export$2e2bcd8739ae039);
        if (!hasStateBeenInitialized) {
            const stateData = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults($fd8e23e9341bb61f$var$clean(options.state), this.state || {}); // TODO:
            // `framework/View.js set `this.state = options.state.`.
            // Therefore we could consider to do
            // 1. `options.state = new StateMachine()`
            // 2. remove `delete options.state`
            this.state = new (0, $0ee3941b32c0f6e5$export$2e2bcd8739ae039)(stateData);
            delete options.state;
        }
        if (!options.settings) {
            // allow the controller to live without a router
            options.settings = new (0, $877ed51558e25423$export$2e2bcd8739ae039)((0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(options || {}, 'el'));
            this.listen('notification', (0, $ebb4e572c564df7e$export$2e2bcd8739ae039).prototype._notify);
            this.listen('confirmation', (0, $ebb4e572c564df7e$export$2e2bcd8739ae039).prototype._confirm);
        }
        (0, $5f539c045973220f$export$2e2bcd8739ae039).prototype.preinitialize.call(this, options);
    },
    constructor: function(options = {}) {
        (0, $5f539c045973220f$export$2e2bcd8739ae039).call(this, options);
        this.listenTo(this.state, '__invoke__', function() {
            const args = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).toArray(arguments);
            const method = args.shift();
            if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(this[method])) this[method].apply(this, args);
        });
        let MainView; // if `this.View` is already a Backbone View
        if (this.View && this.View.isCourageView) MainView = this.View;
        else if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'View') && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'View').isCourageView) MainView = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'View');
        if (MainView) this.add(new MainView(this.toJSON()));
    },
    /**
   * The default values of our application state
   * @type {Object}
   * @default {}
   */ state: {},
    /**
   * The main view this controller operate on
   * @type {module:Okta.View}
   * @default null
   */ View: null,
    /**
   * Renders the {@link module:Okta.Controller#View|main view} after the DOM is ready
   * in case the controller is the root component of the page (e.g there's no router)
   */ render: function() {
        const args = arguments;
        const self = this;
        (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(function() {
            (0, $5f539c045973220f$export$2e2bcd8739ae039).prototype.render.apply(self, args);
        });
        return this;
    },
    /**
   * Creates the view constructor options
   * @param {Object} [options] Extra options
   * @return {Object} The view constructor options
   */ toJSON: function(options) {
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend((0, $3e490973b7383cc4$export$2e2bcd8739ae039).pick(this, 'state', 'settings', 'collection', 'model'), options || {});
    },
    /**
   * Removes the child views, empty the DOM element and stop listening to events
   */ remove: function() {
        this.removeChildren();
        this.stopListening();
        this.$el.empty();
        return this;
    }
}; // eslint-disable-next-line inclusive-language/use-inclusive-words
/**
 * A Controller is our application control flow component.
 *
 * Typically it will:
 * - Initialize the models, controller and main views
 * - Listen to events
 * - Create, read, update and delete models
 * - Create modal dialogs, confirmation dialogs and alert dialogs
 * - Control the application flow
 *
 * The constructor is responsible for:
 * - Create the application state object
 * - Assign or creates the application settings object
 * - Create an instance of the main view with the relevant parameters
 *
 * See:
 * [Hello World Tutorial](https://github.com/okta/courage/wiki/Hello-World),
 * [Test Spec](https://github.com/atko-eng/okta-ui/blob/master/packages/courage/test/spec/util/BaseController_spec.js)
 *
 * @class module:Okta.Controller
 * @param {Object} options Options Hash
 * @param {SettingsModel} [options.settings] Application Settings Model
 * @param {String} options.el a jQuery selector string stating where to attach the controller in the DOM
 */ var $fd8e23e9341bb61f$export$2e2bcd8739ae039 = (0, $5f539c045973220f$export$2e2bcd8739ae039).extend($fd8e23e9341bb61f$var$proto);







function $e66db5f75ac7378d$var$changeEventString(doWhen) {
    return 'change:' + (0, $3e490973b7383cc4$export$2e2bcd8739ae039).keys(doWhen).join(' change:');
}
function $e66db5f75ac7378d$var$calcDoWhen(value, key) {
    const modelValue = this.model.get(key);
    if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(value)) return value.call(this, modelValue);
    else return value === modelValue;
}
function $e66db5f75ac7378d$var$_doWhen(view, doWhen, fn) {
    const toggle = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(fn, view, view, doWhen);
    view.render = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).wrap(view.render, function(render) {
        const val = render.call(view);
        toggle({
            animate: false
        });
        return val;
    });
    view.listenTo(view.model, $e66db5f75ac7378d$var$changeEventString(doWhen), function() {
        toggle({
            animate: true
        });
    });
}
var $e66db5f75ac7378d$export$2e2bcd8739ae039 = {
    applyDoWhen: function(view, doWhen, fn) {
        if (!(view.model && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isObject(doWhen) && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).size(doWhen) && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(fn))) return;
        $e66db5f75ac7378d$var$_doWhen(view, doWhen, function(view, doWhen, options) {
            const result = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).every((0, $3e490973b7383cc4$export$2e2bcd8739ae039).map(doWhen, $e66db5f75ac7378d$var$calcDoWhen, view));
            fn.call(view, result, options);
        });
    }
};



const $daf1b010ac6efbc6$var$disabledEvents = {
    click: function(e) {
        e.preventDefault();
        e.stopPropagation();
    }
};
/**
 * A configurable button
 * @class module:Okta.internal.views.components.BaseButtonLink
 * @extends module:Okta.View
 * @example
 * var View = BaseButtonLink.extend({
 *   title: 'Click Me',
 *   icon: 'help-text'
 * })
 */ var $daf1b010ac6efbc6$export$2e2bcd8739ae039 = (0, $5f539c045973220f$export$2e2bcd8739ae039).extend(/** @lends module:Okta.internal.views.components.BaseButtonLink.prototype */ {
    attributes: function() {
        const defaultAttrs = {
            'data-se': 'button'
        };
        const additionalAttr = this.__getAttribute('attrs');
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend(defaultAttrs, additionalAttr);
    },
    /**
   * The main text for the button
   * @name title
   * @memberof module:Okta.internal.views.components.BaseButtonLink
   * @type {(String|Function)}
   * @instance
   */ /**
   * The link for the button
   * @name href
   * @memberof module:Okta.internal.views.components.BaseButtonLink
   * @type {(String|Function)}
   * @instance
   */ /**
   * CSS class for the icon to display. See [Style guide](http://rain.okta1.com:1802/su/dev/style-guide#icons)
   * @name icon
   * @memberof module:Okta.internal.views.components.BaseButtonLink
   * @type {(String|Function)}
   * @instance
   */ /**
   * A [Backbone events](http://backbonejs.org/#View-delegateEvents) hash
   * @name events
   * @memberof module:Okta.internal.views.components.BaseButtonLink
   * @type {Object}
   * @instance
   */ tagName: 'a',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<span class=\"icon " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "icon") || (depth0 != null ? lookupProperty(depth0, "icon") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "icon",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 30
                    },
                    "end": {
                        "line": 1,
                        "column": 38
                    }
                }
            }) : helper)) + "\"></span>";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "title",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 67
                    },
                    "end": {
                        "line": 1,
                        "column": 76
                    }
                }
            }) : helper));
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "icon") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 54
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "title") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 54
                    },
                    "end": {
                        "line": 1,
                        "column": 83
                    }
                }
            })) != null ? stack1 : "");
        },
        "useData": true
    }),
    /**
   * Make this button visible, default to true.
   * @type {(Boolean|Function)}
   * @default true
   */ visible: true,
    /**
   * Make this button enabled, default to true.
   * @type {(Boolean|Function)}
   * @default true
   */ enabled: true,
    /**
   * The setting to determine when the button is enabled, default to {} and
   * enabled takes a higher priority.
   * @type {(Object|Function)}
   * @default {}
   */ enableWhen: {},
    /**
   * The setting to determine when the button is visible, default to {} and
   * visible takes a higher priority.
   * @type {(Object|Function)}
   * @default {}
   */ showWhen: {},
    constructor: function(options) {
        this.options = options || {};
        const data = this.getTemplateData();
        this.disabled = false;
        (0, $5f539c045973220f$export$2e2bcd8739ae039).apply(this, arguments);
        this.$el.addClass('link-button');
        if (data.icon) {
            this.$el.addClass('link-button-icon');
            if (!data.title) this.$el.addClass('icon-only');
        }
    },
    getTemplateData: function() {
        return {
            href: this.__getAttribute('href'),
            title: this.__getAttribute('title'),
            icon: this.__getAttribute('icon')
        };
    },
    initialize: function() {
        (0, $e66db5f75ac7378d$export$2e2bcd8739ae039).applyDoWhen(this, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).resultCtx(this, 'enableWhen', this), this.toggle);
        (0, $e66db5f75ac7378d$export$2e2bcd8739ae039).applyDoWhen(this, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).resultCtx(this, 'showWhen', this), this.toggleVisible);
    },
    render: function() {
        (0, $5f539c045973220f$export$2e2bcd8739ae039).prototype.render.apply(this, arguments);
        if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'enabled')) this.toggle(false);
        if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'visible')) this.toggleVisible(false);
        const data = this.getTemplateData();
        this.$el.attr('href', data.href || '#');
        return this;
    },
    __getAttribute: function(name, defaultValue) {
        let value = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).resultCtx(this.options, name, this);
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isUndefined(value)) value = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, name);
        return !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isUndefined(value) ? value : defaultValue;
    },
    enable: function() {
        this.toggle(true);
    },
    disable: function() {
        this.toggle(false);
    },
    show: function() {
        this.toggleVisible(true);
    },
    hide: function() {
        this.toggleVisible(false);
    },
    toggle: function(enable) {
        const bool = !!enable && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'enabled'); //this is to toggle the enability
        this.disabled = !bool;
        this.$el.toggleClass('link-button-disabled btn-disabled disabled', this.disabled);
        this.delegateEvents(this.disabled ? $daf1b010ac6efbc6$var$disabledEvents : null);
    },
    toggleVisible: function(visible) {
        const hidden = !visible || !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'visible');
        this.$el.toggleClass('hide', hidden);
    }
});


/* eslint '@okta/okta-ui/no-deprecated-methods': [0, [{ name: 'BaseButtonLink.extend', use: 'Okta.createButton'}, ]] */ /**
 * A factory method wrapper for {@link BaseButtonLink} creation
 * @class module:Okta.internal.util.ButtonFactory
 */ function $914e49a88f52f235$var$normalizeEvents(options) {
    const events = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend(options.click ? {
        click: options.click
    } : {}, options.events || {});
    const target = {};
    (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(events, function(fn, eventName) {
        target[eventName] = function(e) {
            if (!options.href) {
                e.preventDefault();
                e.stopPropagation();
            }
            if (!(this.disabled && eventName === 'click')) fn.apply(this, arguments);
        };
    });
    return target;
}
var $914e49a88f52f235$export$2e2bcd8739ae039 = /** @lends module:Okta.internal.util.ButtonFactory */ {
    /**
   * Creates a {@link module:Okta.internal.views.components.BaseButtonLink|BaseButtonLink}.
   * @param  {Object} options Options hash
   * @param  {String} [options.title] The button text
   * @param  {String} [options.icon]
   * CSS class for the icon to display. See [Style guide](http://rain.okta1.com:1802/su/dev/style-guide#icons)
   * @param {String} [options.href] The button link
   * @param {Function} [options.click] On click callback
   * @param {Object} [options.events] a [Backbone events](http://backbonejs.org/#View-delegateEvents) hash
   * @returns {module:Okta.internal.views.components.BaseButtonLink} BaseButtonLink prototype ("class")
   */ create: function(options) {
        options = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone(options);
        options.attrs = options.attributes;
        delete options.attributes;
        return (0, $daf1b010ac6efbc6$export$2e2bcd8739ae039).extend((0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend(options, {
            events: $914e49a88f52f235$var$normalizeEvents(options)
        }));
    }
};




function $ea2d4afe987f356a$export$2e2bcd8739ae039(options) {
    this.options = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone(options || {});
    this.cid = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).uniqueId('class');
    this.initialize.apply(this, arguments);
}
(0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend($ea2d4afe987f356a$export$2e2bcd8739ae039.prototype, (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Events, {
    initialize: function() {}
});
$ea2d4afe987f356a$export$2e2bcd8739ae039.extend = (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Model.extend;



var $0834c3ef5676adf5$export$35e795649ee09318 = {
    exports: {}
};


/*!
 * JavaScript Cookie v2.1.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */ (function(module, exports) {
    (function(factory) {
        module.exports = factory();
    })(function() {
        function extend() {
            var i = 0;
            var result = {};
            for(; i < arguments.length; i++){
                var attributes = arguments[i];
                for(var key in attributes)result[key] = attributes[key];
            }
            return result;
        }
        function init(converter) {
            function api(key, value, attributes) {
                var result; // Write
                if (arguments.length > 1) {
                    attributes = extend({
                        path: '/'
                    }, api.defaults, attributes);
                    if (typeof attributes.expires === 'number') {
                        var expires = new Date();
                        expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
                        attributes.expires = expires;
                    }
                    try {
                        result = JSON.stringify(value);
                        if (/^[\{\[]/.test(result)) value = result;
                    } catch (e) {}
                    if (!converter.write) value = encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
                    else value = converter.write(value, key);
                    key = encodeURIComponent(String(key));
                    key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
                    key = key.replace(/[\(\)]/g, escape);
                    return document.cookie = [
                        key,
                        '=',
                        value,
                        attributes.expires && '; expires=' + attributes.expires.toUTCString(),
                        // use expires attribute, max-age is not supported by IE
                        attributes.path && '; path=' + attributes.path,
                        attributes.domain && '; domain=' + attributes.domain,
                        attributes.secure ? '; secure' : ''
                    ].join('');
                } // Read
                if (!key) result = {};
                 // To prevent the for loop in the first place assign an empty array
                // in case there are no cookies at all. Also prevents odd result when
                // calling "get()"
                var cookies = document.cookie ? document.cookie.split('; ') : [];
                var rdecode = /(%[0-9A-Z]{2})+/g;
                var i = 0;
                for(; i < cookies.length; i++){
                    var parts = cookies[i].split('=');
                    var name = parts[0].replace(rdecode, decodeURIComponent);
                    var cookie = parts.slice(1).join('=');
                    if (cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                    try {
                        cookie = converter.read ? converter.read(cookie, name) : converter(cookie, name) || cookie.replace(rdecode, decodeURIComponent);
                        if (this.json) try {
                            cookie = JSON.parse(cookie);
                        } catch (e) {}
                        if (key === name) {
                            result = cookie;
                            break;
                        }
                        if (!key) result[name] = cookie;
                    } catch (e) {}
                }
                return result;
            }
            api.get = api.set = api;
            api.getJSON = function() {
                return api.apply({
                    json: true
                }, [].slice.call(arguments));
            };
            api.defaults = {};
            api.remove = function(key, attributes) {
                api(key, '', extend(attributes, {
                    expires: -1
                }));
            };
            api.withConverter = init;
            return api;
        }
        return init(function() {});
    });
})((0, $0834c3ef5676adf5$export$35e795649ee09318));
var $720620749991cd3d$export$2e2bcd8739ae039 = (0, $0834c3ef5676adf5$export$35e795649ee09318).exports;


const $703c7c10c69d13cf$var$SECURED_COOKIE = /^https/.test(window.location.href);
var $703c7c10c69d13cf$export$2e2bcd8739ae039 = {
    setCookie: function(name, value, options) {
        (0, $720620749991cd3d$export$2e2bcd8739ae039).set(name, value, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults(options || {}, {
            secure: $703c7c10c69d13cf$var$SECURED_COOKIE,
            path: '/'
        }));
    },
    getCookie: function() {
        return (0, $720620749991cd3d$export$2e2bcd8739ae039).get.apply((0, $720620749991cd3d$export$2e2bcd8739ae039), arguments);
    },
    removeCookie: function() {
        return (0, $720620749991cd3d$export$2e2bcd8739ae039).remove.apply((0, $720620749991cd3d$export$2e2bcd8739ae039), arguments);
    }
};



var $k5HZY = parcelRequire("k5HZY");




const $f7ddc352ffbc2dec$var$Clipboard = (0, (/*@__PURE__*/$parcel$interopDefault($k5HZY)));
const $f7ddc352ffbc2dec$var$OPTIONS = [
    'success',
    'error',
    'target',
    'text'
];
const $f7ddc352ffbc2dec$var$ClipboardClipboardWrapper = (0, $ea2d4afe987f356a$export$2e2bcd8739ae039).extend({
    initialize: function(el, options) {
        /* eslint complexity:0, max-statements: [2, 24] */ options = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).pick(options || {}, $f7ddc352ffbc2dec$var$OPTIONS);
        let trigger;
        let target;
        let text;
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isString(el)) trigger = el;
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isElement(el)) trigger = el;
        if (el instanceof (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)) trigger = el.selector; // TODO: use stronger type
        if (el instanceof (0, $b17abb91ef0c7ac1$export$2e2bcd8739ae039)) trigger = el.el;
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(options.target)) target = options.target;
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isElement(options.target)) target = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).constant(options.target);
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isString(options.text)) text = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).constant(options.text);
        else if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(options.text)) text = options.text;
        this.__instance = new $f7ddc352ffbc2dec$var$Clipboard(trigger, {
            target: target,
            text: text
        });
        this.done = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial(this.__setCallback, 'success');
        this.error = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial(this.__setCallback, 'error');
        this.done(options.success);
        this.error(options.error);
    },
    __setCallback: function(event, callback) {
        if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(callback)) return;
        this.__instance.on(event, callback);
        return this.__instance;
    }
});
/**
 * @class Clipboard
 * @abstract
 *
 * Abstract class that initializes a Clipboard
 *   https://clipboardjs.com/
 *
 * ### Example:
 *
 *  ```javascript
 *  //attach a selector
 *  Clipboard.attach('.copy-button');
 *
 *  //attach a node, and set a constant string
 *  Clipboard.attach(buttonView.el, {
 *    text: 'this is the content'
 *  });
 *
 *  //attach a view, set text dynamically, and set callback
 *  Clipboard.attach(buttonView, {
 *    text: function (triggerNode) {
 *      return $(triggerNode).attr('foo') + model.get('userName');
 *    }
 *  }).done(function (targetNode) {
 *    var msg = ['"', targetNode.text, '" is copied'].join('');
 *    view.notify('success', msg);
 *  });
 *
 *  //attach a jquery object, set the target node, and set callback
 *  Clipboard.attach($('.customizeTarget'), {
 *    target: function (triggerNode) {
 *      return triggerNode;
 *    },
 *    success: function (targetNode) {
 *      view.notify('success', 'copied!');
 *    }
 *  });
 *
 * ```
 */ var $f7ddc352ffbc2dec$export$2e2bcd8739ae039 = {
    /**
   * @param {String|Node|View|jQuery} [el] el could be a selector (recommended),
   *           a dom node, a view or a jquery object
   * @param {Object} [options] Options hash
   * @param  {Node|Function} [options.target] a static dom node
   *           or a function that takes trigger node and returns a target node
   * @param {String|Function} [options.text] a static string or a function that returns a string dynamically
   * @param {Function} [options.success] success callback
   * @param {Function} [options.error] error callback
   * @return {Object} The clipboard object
   */ attach: function(el, options) {
        return new $f7ddc352ffbc2dec$var$ClipboardClipboardWrapper(el, options);
    }
};


var $23690f1a19c585a1$export$2e2bcd8739ae039 = {
    UP: 38,
    DOWN: 40,
    DEL: 46,
    TAB: 9,
    RETURN: 13,
    ENTER: 13,
    ESC: 27,
    COMMA: 188,
    PAGEUP: 33,
    PAGEDOWN: 34,
    SPACE: 32,
    BACKSPACE: 8,
    __isKey: function(e, key) {
        return (e.which || e.keyCode) === this[key];
    },
    isEnter: function(e) {
        return this.__isKey(e, 'ENTER');
    },
    isEsc: function(e) {
        return this.__isKey(e, 'ESC');
    },
    isSpaceBar: function(e) {
        return this.__isKey(e, 'SPACE');
    }
};






var $1d054e2973c83a0b$export$2e2bcd8739ae039 = {
    redirect: function(url) {
        window.location = url;
    },
    reloadPage: function() {
        window.location.reload();
    },
    constantError: function(errorMessage) {
        return function() {
            throw new Error(errorMessage);
        };
    },
    /**
   * Simply convert an URL query key value pair object into an URL query string.
   * Remember NOT to escape the query string when using this util.
   * example:
   * input: {userId: 123, instanceId: undefined, expand: 'schema,app'}
   * output: '?userId=123&expand=schema,app'
   */ getUrlQueryString: function(queries) {
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isObject(queries) || (queries = {});
        const queriesString = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).without((0, $3e490973b7383cc4$export$2e2bcd8739ae039).map(queries, function(value, key) {
            if (value !== undefined && value !== null) return key + '=' + encodeURIComponent(value);
        }), undefined).join('&');
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(queriesString) ? '' : '?' + queriesString;
    },
    isABaseView: function(obj) {
        return obj instanceof (0, $5f539c045973220f$export$2e2bcd8739ae039) || obj.prototype instanceof (0, $5f539c045973220f$export$2e2bcd8739ae039) || obj === (0, $5f539c045973220f$export$2e2bcd8739ae039);
    },
    isSafari: function() {
        // All native, android and iOS chrome browsers has "Safari" in their userAgent string, so this regex should
        // evaluate to true for only Safari browser and not any chrome browsers.
        // https://stackoverflow.com/questions/7944460/detect-safari-browser
        // https://stackoverflow.com/questions/13807810/ios-chrome-detection/13808053#13808053
        return /^((?!chrome|android|crios).)*safari/i.test(navigator.userAgent);
    }
};




const $088fab4bf3969f6f$var$clonedEscapeExpression = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).Utils.escapeExpression;
(0, $d30415a7ae055e38$export$2e2bcd8739ae039).Utils.escapeExpression = function(string) {
    return $088fab4bf3969f6f$var$clonedEscapeExpression(string).replace(/&#x3D;/g, '=');
};






/* eslint @okta/okta-ui/no-specific-modules: 0 */ const $1164b33e9c8b38bd$var$hbsEscape = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).Utils.escapeExpression;
function $1164b33e9c8b38bd$var$trim(str) {
    return str && str.replace(/^\s+|\s+$/g, '');
}
function $1164b33e9c8b38bd$var$replaceTagsWithPlaceholders(source, tag, tagValue) {
    const escapedBeginningTag = $1164b33e9c8b38bd$var$hbsEscape(`<${tag}>`);
    const escapedEndTag = $1164b33e9c8b38bd$var$hbsEscape(`</${tag}>`);
    const [beginningTag, endTag] = tagValue.split(tag);
    if (!source.includes(escapedBeginningTag) && !source.includes(escapedEndTag)) throw Error(`Parsed tag "${tag}" is not present in "${source}"`);
    else if (!tagValue.includes(tag)) throw Error(`Parsed tag "${tag}" is not present in "${tagValue}"`);
    else if (!beginningTag || !endTag) throw Error(`Template value "${tagValue}" must contain beginning and closing tags`);
    return source.replace(escapedBeginningTag, beginningTag).replace(escapedEndTag, endTag);
}
/* eslint max-statements: [2, 18] */ (0, $d30415a7ae055e38$export$2e2bcd8739ae039).registerHelper('i18n', function i18n(options) {
    let params;
    const key = $1164b33e9c8b38bd$var$trim(options.hash.code);
    const bundle = $1164b33e9c8b38bd$var$trim(options.hash.bundle);
    const args = $1164b33e9c8b38bd$var$trim(options.hash.arguments);
    const tags = Object.keys(options.hash).filter((prop)=>prop.match(/^\$\d+/)).map((prop)=>({
            tag: prop,
            value: options.hash[prop]
        }));
    if (args) params = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).map($1164b33e9c8b38bd$var$trim(args).split(';'), function mapParam(param) {
        param = $1164b33e9c8b38bd$var$trim(param);
        let val;
        /*
       * the context(data) may be a deep object, ex {user: {name: 'John', gender: 'M'}}
       * arguments may be 'user.name'
       * return data['user']['name']
       */ (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(param.split('.'), (p)=>{
            val = val ? val[p] : this[p];
        });
        return val;
    }, this);
    const localizedValue = (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize(key, bundle, params);
    if (tags.length < 1) // No HTML tags provided - return the localized and escaped string
    return localizedValue;
    let escapedString = $1164b33e9c8b38bd$var$hbsEscape(localizedValue);
    try {
        tags.forEach((tag)=>{
            escapedString = $1164b33e9c8b38bd$var$replaceTagsWithPlaceholders(escapedString, tag.tag, tag.value);
        });
        return new (0, $d30415a7ae055e38$export$2e2bcd8739ae039).SafeString(escapedString);
    } catch (err) {
        (0, $cbf92b1807f0afdb$export$2e2bcd8739ae039).error(err.toString());
        return localizedValue;
    }
});






/* eslint-disable max-statements */ /**
   * Archer.ListView is a {@link src/framework/View} that operates on a
   * collection and builds a list of "things" of the same type.
   *
   * Automagically adds, removes and sorts upon standard collection events.
   *
   * Listen to collection events so the ListView will do the right thing when
   * a model is added or the collection is reset or sorted.
   *
   * @class src/framework/ListView
   * @extends src/framework/View
   * @param {Object} options options hash
   * @param {Object} options.collection The collection which this view operates on
   * @example
   * var UserList = Archer.ListView.extend({
   *   tagName: 'ul',
   *   item: '<li>{{fname}} {{lname}}</li>'
   * });
   *
   * var users = new Archer.Collection([
   *   {fname: 'John', lname: 'Doe'},
   *   {fname: 'Jane', lname: 'Doe'}
   * ]);
   *
   * var userList = new UserList({collection: users}).render();
   * userList.el; //=> "<ul><li>John Doe</li><li>Jane Doe</li></ul>"
   *
   * users.push({fname: 'Jim', lname: 'Doe'});
   * userList.el; //=> "<ul><li>John Doe</li><li>Jane Doe</li><li>Jim Doe</li></ul>"
   *
   * users.first().destroy();
   * userList.el; //=> "<ul><li>Jane Doe</li><li>Jim Doe</li></ul>"
   */ var $70c1f23ebf6a982f$export$2e2bcd8739ae039 = (0, $b17abb91ef0c7ac1$export$2e2bcd8739ae039).extend(/** @lends src/framework/ListView.prototype */ {
    constructor: function() {
        (0, $b17abb91ef0c7ac1$export$2e2bcd8739ae039).apply(this, arguments);
        if (!this.collection) throw new Error('Missing collection');
        this.listenTo(this.collection, 'reset sort', this.reset);
        this.listenTo(this.collection, 'add', this.addItem);
        if (this.fetchCollection) this.collection.fetch();
        else this.collection.each(this.addItem, this);
    },
    /**
     * The view/template we will use to render each model in the collection.
     * @type {String|module:Okta.View}
     */ item: null,
    /**
     * A selector in the local template where to append each item
     * @type {String}
     */ itemSelector: null,
    /**
     * Empty the list and re-add everything from the collection.
     * Usefull for handling `collection.reset()` or for handling the initial load
     * @protected
     */ reset: function() {
        this.removeChildren();
        this.collection.each((model, index)=>{
            this.addItem(model, index);
        });
        return this;
    },
    /**
     * Add an item view to the list that will represent one model from the collection
     *
     * Listen to the model so when it is destoyed or removed from the collection
     * this item will remove itself from the list
     *
     * @param {Backbone.Model} model The model this row operates on
     * @protected
     */ addItem: function(model) {
        var view = this.add(this.item, this.itemSelector, {
            options: {
                model: model
            }
        }).last();
        if (this.state && this.state.get('trackItemAdded')) this.state.trigger('itemAdded', view);
        view.listenTo(model, 'destroy remove', view.remove);
        return this;
    },
    addShowMore: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).noop
});



/**
 * See {@link src/framework/ListView} for more detail and examples from the base class.
 * @class module:Okta.ListView
 * @extends src/framework/ListView
 * @mixes module:Okta.View
 */ var $20176b5b9767e868$export$2e2bcd8739ae039 = (0, $5f539c045973220f$export$2e2bcd8739ae039).decorate((0, $70c1f23ebf6a982f$export$2e2bcd8739ae039));







const $5d09a4a736220f7b$var$optionsTemplate = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "0": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<span class=\"icon " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "icon") || (depth0 != null ? lookupProperty(depth0, "icon") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "icon",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 96
                },
                "end": {
                    "line": 1,
                    "column": 104
                }
            }
        }) : helper)) + "\"></span>";
    },
    "1": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "title",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 133
                },
                "end": {
                    "line": 1,
                    "column": 142
                }
            }
        }) : helper));
    },
    "2": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<p class=\"option-subtitle\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "subtitle") || (depth0 != null ? lookupProperty(depth0, "subtitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "subtitle",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 192
                },
                "end": {
                    "line": 1,
                    "column": 204
                }
            }
        }) : helper)) + "</p>";
    },
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<a href=\"\" class=\"icon-16 " + alias4((helper = (helper = lookupProperty(helpers, "className") || (depth0 != null ? lookupProperty(depth0, "className") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "className",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 26
                },
                "end": {
                    "line": 1,
                    "column": 39
                }
            }
        }) : helper)) + "\" data-se=\"" + alias4((helper = (helper = lookupProperty(helpers, "seleniumId") || (depth0 != null ? lookupProperty(depth0, "seleniumId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "seleniumId",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 50
                },
                "end": {
                    "line": 1,
                    "column": 64
                }
            }
        }) : helper)) + "\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "icon") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(0, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 66
                },
                "end": {
                    "line": 1,
                    "column": 120
                }
            }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "title") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(1, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 120
                },
                "end": {
                    "line": 1,
                    "column": 149
                }
            }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "subtitle") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(2, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 149
                },
                "end": {
                    "line": 1,
                    "column": 215
                }
            }
        })) != null ? stack1 : "") + "</a>";
    },
    "useData": true
});
const $5d09a4a736220f7b$var$BaseDropDownDropDownOption = (0, $5f539c045973220f$export$2e2bcd8739ae039).extend({
    tagName: 'li',
    events: {
        click: function(e) {
            e.preventDefault();
            this.action && this.action.call(this);
        }
    },
    constructor: function() {
        (0, $5f539c045973220f$export$2e2bcd8739ae039).apply(this, arguments);
        this.$el.addClass('okta-dropdown-option option');
    },
    render: function() {
        this.$el.html($5d09a4a736220f7b$var$optionsTemplate({
            icon: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'icon'),
            className: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'className') || '',
            title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'title'),
            subtitle: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'subtitle'),
            seleniumId: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'seleniumId')
        }));
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'disabled')) this.disable();
        return this;
    },
    disable: function() {
        this.$el.addClass('option-disabled');
        this.$el.find('a').attr('tabindex', '-1');
    }
});
var $5d09a4a736220f7b$export$2e2bcd8739ae039 = (0, $5f539c045973220f$export$2e2bcd8739ae039).extend({
    events: {
        'click a.option-selected': function(e) {
            e.preventDefault();
            if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'disabled')) e.stopPropagation();
        },
        'click .dropdown-disabled': function(e) {
            e.preventDefault();
            e.stopPropagation();
        }
    },
    items: [],
    constructor: function() {
        const className = this.className; // In this very specific case we want to NOT append className to $el
        // but to the <a> tag in the template
        // so we want to disable backbone default functionality.
        this.className = null;
        (0, $5f539c045973220f$export$2e2bcd8739ae039).apply(this, arguments);
        this.className = className;
        this.$el.addClass('dropdown more-actions float-l');
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each((0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'items'), function(option) {
            this.addOption(option, this.options);
        }, this);
    },
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<span class=\"icon " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "icon") || (depth0 != null ? lookupProperty(depth0, "icon") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "icon",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 176
                    },
                    "end": {
                        "line": 1,
                        "column": 184
                    }
                }
            }) : helper)) + "\"></span>";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<span class=\"off-screen\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "screenReaderText") || (depth0 != null ? lookupProperty(depth0, "screenReaderText") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "screenReaderText",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 249
                    },
                    "end": {
                        "line": 1,
                        "column": 269
                    }
                }
            }) : helper)) + "</span>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a href=\"#\" class=\"link-button " + alias4((helper = (helper = lookupProperty(helpers, "className") || (depth0 != null ? lookupProperty(depth0, "className") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "className",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 31
                    },
                    "end": {
                        "line": 1,
                        "column": 44
                    }
                }
            }) : helper)) + " link-button-icon option-selected center\" aria-expanded=\"false\" aria-controls=\"okta-dropdown-options\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "icon") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 146
                    },
                    "end": {
                        "line": 1,
                        "column": 200
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "screenReaderText") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 200
                    },
                    "end": {
                        "line": 1,
                        "column": 283
                    }
                }
            })) != null ? stack1 : "") + "<span class=\"option-selected-text\">" + alias4((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "title",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 318
                    },
                    "end": {
                        "line": 1,
                        "column": 327
                    }
                }
            }) : helper)) + "</span><span class=\"icon-dm\"></span></a><div id=\"okta-dropdown-options\" class=\"options clearfix\"><ul class=\"okta-dropdown-list options-wrap clearfix\"></ul></div>";
        },
        "useData": true
    }),
    getTemplateData: function() {
        const className = [
            (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'className') || '',
            (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'disabled') ? 'dropdown-disabled' : ''
        ];
        return {
            icon: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'icon'),
            className: (0, $b51a961f9fe28c76$export$2e2bcd8739ae039).trim(className.join(' ')),
            title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'title'),
            screenReaderText: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'screenReaderText')
        };
    },
    addOption: function(proto, options) {
        this.add($5d09a4a736220f7b$var$BaseDropDownDropDownOption.extend(proto), 'ul.options-wrap', {
            options: options || {}
        });
    }
});















/* eslint max-params: [2, 6] */ const $a6671880aee1fa70$var$LABEL_OPTIONS = [
    'model',
    'id',
    'inputId',
    'type',
    'label',
    'sublabel',
    'tooltip',
    'name',
    'group'
];
const $a6671880aee1fa70$var$CONTAINER_OPTIONS = [
    'wide',
    'multi',
    'input',
    'label-top',
    'explain',
    'explain-top',
    'customExplain',
    'model',
    'name',
    'type',
    'autoRender',
    'multirowError'
];
const $a6671880aee1fa70$var$WRAPPER_OPTIONS = [
    'model',
    'name',
    'label-top',
    'readOnly',
    'events',
    'initialize',
    'showWhen',
    'bindings',
    'render',
    'className',
    'data-se',
    'toggleWhen',
    'group'
];
const $a6671880aee1fa70$var$INPUT_OPTIONS = [
    'model',
    'name',
    'inputId',
    'type',
    // base options
    'input',
    // custom input
    'placeholder',
    'label',
    // labels
    'readOnly',
    'read',
    'disabled',
    'readModeString',
    // modes
    'options',
    // select/radio
    'deps',
    // used to specify inputs that have dependencies and show a callout to user on select
    'from',
    'to',
    // model transformers,
    'autoRender',
    // model attributes change event to trigger rerendering of the input
    'inlineValidation',
    // control inline validating against the model on focus lost
    'validateOnlyIfDirty',
    // check if field has been interacted with and then validate
    'ariaLabel',
    // 508 compliance for inputs that do not have label associated with them
    'params',
    'autoComplete',
    // autocomplete attribute
    'sortByKey'
];
const $a6671880aee1fa70$var$OTHER_OPTIONS = [
    'errorField' // widgets params - for input specific widgets
];
const $a6671880aee1fa70$var$ALL_OPTIONS = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).uniq((0, $3e490973b7383cc4$export$2e2bcd8739ae039).union($a6671880aee1fa70$var$LABEL_OPTIONS, $a6671880aee1fa70$var$CONTAINER_OPTIONS, $a6671880aee1fa70$var$WRAPPER_OPTIONS, $a6671880aee1fa70$var$INPUT_OPTIONS, $a6671880aee1fa70$var$OTHER_OPTIONS));
const $a6671880aee1fa70$var$SAVE_BUTTON_PHASES = [
    "\u2022         ",
    "\u2022  \u2022      ",
    "\u2022  \u2022  \u2022   ",
    "\u2022  \u2022  \u2022  \u2022",
    "   \u2022  \u2022  \u2022",
    "      \u2022  \u2022",
    "         \u2022",
    '          ',
    '          ',
    '          '
];
function $a6671880aee1fa70$var$decorateDoWhen(doWhen) {
    if (doWhen && !doWhen['__edit__']) return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({
        __edit__: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).constant(true)
    }, doWhen);
}
function $a6671880aee1fa70$var$createButton(options) {
    options = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).pick(options || {}, 'action', 'id', 'className', 'text', 'type');
    let timeoutId;
    let intervalId;
    let phaseCount;
    return (0, $5f539c045973220f$export$2e2bcd8739ae039).extend({
        tagName: 'input',
        className: 'button',
        events: {
            click: function() {
                if (options.action && !this.disabled()) options.action.call(this);
            },
            keyup: function(e) {
                if ((0, $23690f1a19c585a1$export$2e2bcd8739ae039).isEnter(e) && options.action && !this.disabled()) options.action.call(this);
            }
        },
        disabled: function() {
            return this.$el.prop('disabled') === true;
        },
        disable: function() {
            this.$el.prop('disabled', true);
            this.$el.addClass('btn-disabled');
        },
        enable: function() {
            this.$el.prop('disabled', false);
            this.$el.removeClass('btn-disabled');
        },
        initialize: function() {
            const self = this;
            this.$el.attr('type', options.type === 'save' ? 'submit' : 'button');
            this.$el.val(options.text);
            if (options.id) this.$el.attr('id', options.id);
            if (options.className) this.$el.addClass(options.className);
            if (options.type) this.$el.attr('data-type', options.type);
            this.$el.mousedown(function() {
                self.model.set('__pending__', true);
            });
            this.$el.mouseup(function() {
                self.model.set('__pending__', false);
            });
            this.listenTo(this.model, 'form:set-saving-state', function() {
                this.disable();
                if (options.type === 'save') {
                    clearTimeout(timeoutId);
                    timeoutId = setTimeout((0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(this.__changeSaveText, this), 1000);
                }
            });
            this.listenTo(this.model, 'form:clear-saving-state', function() {
                this.enable();
                if (options.type === 'save') {
                    clearTimeout(timeoutId);
                    clearInterval(intervalId);
                    this.$el.val(options.text);
                }
            });
        },
        __changeSaveText: function() {
            phaseCount = 0;
            clearInterval(intervalId);
            intervalId = setInterval((0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(this.__showLoadingText, this), 200);
        },
        __showLoadingText: function() {
            this.$el.val($a6671880aee1fa70$var$SAVE_BUTTON_PHASES[phaseCount++ % $a6671880aee1fa70$var$SAVE_BUTTON_PHASES.length]);
        }
    });
}
function $a6671880aee1fa70$var$validateInput(options, model) {
    /* eslint max-statements: 0, complexity: 0 */ options || (options = {});
    if (options.type === 'label') {
        if (!options.label) (0, $cbf92b1807f0afdb$export$2e2bcd8739ae039).warn('A label input must have a "label" parameter', options);
        return;
    }
    if (options.type === 'button') {
        if (!options.title && !options.icon) (0, $cbf92b1807f0afdb$export$2e2bcd8739ae039).warn('A button input must have a "title" and/or an "icon" parameter', options);
        if (!options.click && !options.href) (0, $cbf92b1807f0afdb$export$2e2bcd8739ae039).warn('A button input must have a "click" and/or an "href" parameter', options);
        return;
    }
    if (!options.name && !options.input) (0, $cbf92b1807f0afdb$export$2e2bcd8739ae039).warn('Missing "name" or "input" parameters', options);
    if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(options.name) && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(options.input)) throw new Error('Not allowed to have both "name" and "input" defined as array.');
    if (options.type !== 'list' && options.name && model && model.allows) {
        let names = [];
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(options.name)) names = options.name;
        else names.push(options.name);
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(names, function(name) {
            if (!model.allows(name)) throw new Error('field not allowed: ' + options.name);
        });
    }
    if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(options.input) && options.type !== 'list') (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(options.input, function(input) {
        $a6671880aee1fa70$var$validateInput(input, model);
    });
    const keys = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).keys(options);
    const intersection = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).intersection(keys, $a6671880aee1fa70$var$ALL_OPTIONS);
    if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).size(intersection) !== (0, $3e490973b7383cc4$export$2e2bcd8739ae039).size(options)) {
        const fields = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone($a6671880aee1fa70$var$ALL_OPTIONS);
        (0, $cbf92b1807f0afdb$export$2e2bcd8739ae039).warn('Invalid input parameters', (0, $3e490973b7383cc4$export$2e2bcd8739ae039).without(keys, ...fields), options);
    }
}
function $a6671880aee1fa70$var$generateInputOptions(options, form, createFn) {
    options = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone(options);
    if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains([
        'list',
        'group'
    ], options.type)) {
        options.params = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults({
            create: createFn,
            inputs: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).map((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(options.input) ? options.input : [
                options.input
            ], function(input) {
                return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).first($a6671880aee1fa70$var$generateInputOptions(input, form, createFn));
            })
        }, options.params || {});
        delete options.input;
    }
    const inputs = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(options.input) ? (0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone(options.input) : [
        options
    ];
    return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).map(inputs, function(input) {
        const target = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults({
            model: form.model
        }, input, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(options, 'input', 'inputs'), form.options, {
            id: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).uniqueId('input'),
            readOnly: form.isReadOnly(),
            read: form.hasReadMode()
        });
        if (form.isReadOnly()) target.read = target.readOnly = true;
        return target;
    });
}
var $a6671880aee1fa70$export$2e2bcd8739ae039 = {
    LABEL_OPTIONS: $a6671880aee1fa70$var$LABEL_OPTIONS,
    CONTAINER_OPTIONS: $a6671880aee1fa70$var$CONTAINER_OPTIONS,
    WRAPPER_OPTIONS: $a6671880aee1fa70$var$WRAPPER_OPTIONS,
    INPUT_OPTIONS: $a6671880aee1fa70$var$INPUT_OPTIONS,
    generateInputOptions: $a6671880aee1fa70$var$generateInputOptions,
    changeEventString: function(fieldNames) {
        return 'change:' + fieldNames.join(' change:');
    },
    createReadFormButton: function(options) {
        let action;
        let text;
        let ariaLabel;
        if (options.type === 'cancel') {
            text = ariaLabel = (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize('oform.cancel', 'courage');
            action = function() {
                this.model.trigger('form:cancel');
            };
        } else {
            text = (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize('oform.edit', 'courage');
            ariaLabel = text + ' ' + options.formTitle;
            action = function() {
                this.model.set('__edit__', true);
            };
        }
        return (0, $5f539c045973220f$export$2e2bcd8739ae039).extend({
            tagName: 'a',
            className: options.className,
            attributes: {
                href: '#',
                'aria-label': ariaLabel
            },
            template: function() {
                return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).escape(text);
            },
            events: {
                click: function(e) {
                    e.preventDefault();
                    action.call(this);
                }
            }
        });
    },
    createButton: function(options) {
        options = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone(options);
        switch(options.type){
            case 'save':
                (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults(options, {
                    className: 'button-primary'
                });
                break;
            case 'cancel':
                (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults(options, {
                    className: 'button-clear',
                    text: (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize('oform.cancel', 'courage'),
                    action: function() {
                        this.model.trigger('form:cancel');
                    }
                });
                break;
            case 'previous':
                (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults(options, {
                    text: (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize('oform.previous', 'courage'),
                    action: function() {
                        this.model.trigger('form:previous');
                    }
                });
                break;
        }
        return $a6671880aee1fa70$var$createButton(options);
    },
    validateInput: $a6671880aee1fa70$var$validateInput,
    /**
   * Applies a show-when logic on a view instance.
   * The show-when is a map of a model field name -> a boolean or a function that returns a boolean.
   * The view will toggle based on the field value.
   *
   * @param  {Okta.View} view a view instance that has a this.model attached to it
   * @param  {Object} showWhen
   */ applyShowWhen: function(view, showWhen) {
        const toggleAndResize = function(bool) {
            return function() {
                // The `toggle` is here since an event may be triggered before the el is in the DOM
                // and in that case slide events may not function as expected.
                view.$el.toggle(bool);
                view.model.trigger('form:resize');
            };
        };
        (0, $e66db5f75ac7378d$export$2e2bcd8739ae039).applyDoWhen(view, $a6671880aee1fa70$var$decorateDoWhen(showWhen), function(bool, options) {
            if (!options.animate) view.$el.toggle(bool);
            else view.$el['slide' + (bool ? 'Down' : 'Up')](200, toggleAndResize(bool));
        });
    },
    applyToggleWhen: function(view, toggleWhen) {
        (0, $e66db5f75ac7378d$export$2e2bcd8739ae039).applyDoWhen(view, $a6671880aee1fa70$var$decorateDoWhen(toggleWhen), function(bool, options) {
            view.$el.toggle(bool);
            view.model.trigger('form:resize');
            if (options.animate) view.render();
        });
    }
};


var $83282d01860c52eb$export$2e2bcd8739ae039 = (0, $5f539c045973220f$export$2e2bcd8739ae039).extend({
    el: '<span class="o-form-toggle" data-type="header-btn"></span>',
    formTitle: '',
    modelEvents: {
        'change:__edit__': 'toggle'
    },
    initialize: function() {
        this.addButton();
    },
    addButton: function() {
        if (this.model.get('__edit__')) this.add((0, $a6671880aee1fa70$export$2e2bcd8739ae039).createReadFormButton({
            type: 'cancel'
        }));
        else this.add((0, $a6671880aee1fa70$export$2e2bcd8739ae039).createReadFormButton({
            type: 'edit',
            formTitle: this.formTitle,
            className: 'disable-in-read-only'
        }));
    },
    toggle: function() {
        this.removeChildren();
        this.addButton();
    }
});





const $eb85f03955072115$var$proto = {
    className: function() {
        return 'o-form-button-bar';
    },
    buttonOrder: [
        'previous',
        'save',
        'cancel'
    ],
    initialize: function(options) {
        const buttonConfigs = {
            previous: {
                type: 'previous'
            },
            save: {
                type: 'save',
                text: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).resultCtx(options, 'save', this),
                id: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).resultCtx(options, 'saveId', this),
                className: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).resultCtx(options, 'saveClassName', this)
            },
            cancel: {
                type: 'cancel',
                text: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).resultCtx(options, 'cancel', this)
            }
        };
        this.__getButtonOrder(options).forEach((buttonName)=>{
            this.addButton(buttonConfigs[buttonName]);
        });
    },
    /**
   * Adds a buttomn to the toolbar
   * @param {Object} params button parameters
   * @param {Object} options {@link Okta.View#add} options
   */ addButton: function(params, options) {
        return this.add((0, $a6671880aee1fa70$export$2e2bcd8739ae039).createButton(params), options);
    },
    __getButtonOrder: function(options) {
        const buttonOrder = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).resultCtx(options, 'buttonOrder', this, this.buttonOrder);
        const buttonsToSkip = [];
        if (options.noSubmitButton) buttonsToSkip.push('save');
        if (options.noCancelButton) buttonsToSkip.push('cancel');
        if (!options.hasPrevStep) buttonsToSkip.push('previous');
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).without(buttonOrder, ...buttonsToSkip);
    }
};
var $eb85f03955072115$export$2e2bcd8739ae039 = (0, $5f539c045973220f$export$2e2bcd8739ae039).extend($eb85f03955072115$var$proto);




var $a24efd35b2ab2666$export$2e2bcd8739ae039 = (0, $5f539c045973220f$export$2e2bcd8739ae039).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "errorSummary") || (depth0 != null ? lookupProperty(depth0, "errorSummary") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "errorSummary",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 130
                    },
                    "end": {
                        "line": 1,
                        "column": 146
                    }
                }
            }) : helper)) + "</p>";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "courage",
                    "code": "oform.errorbanner.title"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 161
                    },
                    "end": {
                        "line": 1,
                        "column": 217
                    }
                }
            })) + "</p>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"okta-form-infobox-error infobox infobox-error\" role=\"alert\"><span class=\"icon error-16\"></span>" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "errorSummary") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.program(1, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 107
                    },
                    "end": {
                        "line": 1,
                        "column": 228
                    }
                }
            })) != null ? stack1 : "") + "</div>";
        },
        "useData": true
    }),
    modelEvents: {
        'form:clear-errors': 'remove'
    }
});




const $ae20611821b07f77$var$FIELD_REGEX = /^([\S]+): (.+)$/;
var $ae20611821b07f77$export$2e2bcd8739ae039 = {
    /**
   * Helper function that returns the json output of an xhr objext
   * @param  {jqXhr} xhr
   * @return {Object}
   */ getResponseJSON: function(xhr) {
        try {
            return xhr.responseJSON || JSON.parse(xhr.responseText);
        } catch (e) {}
    },
    /**
   * Parses an error summary to extract a field name and an error message
   * @param  {String} errorSummary The raw error summary
   * @return {String[]} An array with two members: [field name, error message]
   */ parseErrorSummary: function(errorSummary) {
        const matches = errorSummary.match($ae20611821b07f77$var$FIELD_REGEX); // error format is: `fieldName: The field cannot be left blank`
        if (matches) return [
            matches[1],
            matches[2]
        ];
    },
    /**
   * Parses an error cause object to extract a field name from property attribute
   * and an error message form errorSummary attribute. It looks to see if there is
   * a custom override/translation for the erorrCause.reason before using the errorSummary
   * @param  {Object} errorCause object
   * @return {String[]} An array with two members: [field name, error message]
   */ parseErrorCauseObject: function(errorCause) {
        if (errorCause.property && errorCause.errorSummary) {
            // avoid triggering sentry log for error event with no cause reason
            const localizedMsg = errorCause.reason ? (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize(errorCause.reason) : undefined;
            const apiMsg = errorCause.errorSummary;
            const field = errorCause.property;
            const errorMessage = (localizedMsg === null || localizedMsg === void 0 ? void 0 : localizedMsg.indexOf('L10N_ERROR[')) === -1 ? localizedMsg : apiMsg;
            return [
                field,
                errorMessage
            ];
        }
    },
    parseErrors: function(resp) {
        const responseJSON = this.getResponseJSON(resp);
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).map(responseJSON && responseJSON.errorCauses || [], function(errorCause) {
            return ('' + errorCause.errorSummary).replace($ae20611821b07f77$var$FIELD_REGEX, '$2');
        });
    },
    /**
   * Parses the response for errors
   * Returns a map of field names > array or error messages
   * Example:
   * ```javascript
   * {
   *   url: ['The field cannot be left blank', 'The field has to be a valid URI'],
   *   name: ['The field cannot be left blank']
   * }
   * ```
   * @param  {Object} resp
   * @return {Object}
   */ parseFieldErrors: function(resp) {
        const responseJSON = this.getResponseJSON(resp);
        const errors = {}; // xhr error object
        if (responseJSON) /* eslint complexity: [2, 9] */ (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(responseJSON.errorCauses || [], function(cause) {
            let res = [];
            if (cause.property && cause.errorSummary) res = this.parseErrorCauseObject(cause);
            else if (cause.location && cause.errorSummary) // To handle new api error format for field level errors.
            // Ignoring the reason attribute as the translation happens in the API layer and not in the client any more.
            res = [
                cause.location,
                cause.errorSummary
            ];
            else res = this.parseErrorSummary(cause && cause.errorSummary || '');
            if (res) {
                const fieldName = res[0];
                const message = res[1];
                errors[fieldName] || (errors[fieldName] = []);
                errors[fieldName].push(message);
            }
        }, this);
        else if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isObject(resp) && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).size(resp)) (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(resp, function(msg, field) {
            errors[field] = [
                msg
            ];
        });
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).size(errors) ? errors : undefined;
    }
};









const $96ed0788ab09b8e9$var$isABaseView = (0, $1d054e2973c83a0b$export$2e2bcd8739ae039).isABaseView;
/**
 * @class InputContainer
 * @private
 *
 * TODO: OKTA-80796
 * Attention: Please change with caution since this is used in other places
 */ var $96ed0788ab09b8e9$export$2e2bcd8739ae039 = (0, $5f539c045973220f$export$2e2bcd8739ae039).extend({
    attributes: function() {
        return {
            'data-se': 'o-form-input-container'
        };
    },
    className: function() {
        let className = 'o-form-input';
        if (this.options.wide) className += ' o-form-wide';
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains([
            1,
            2,
            3,
            4
        ], this.options.multi)) {
            className += ' o-form-multi-input-' + this.options.multi;
            if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(this.options.input)) {
                const inputGroup = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).find(this.options.input, function(input) {
                    return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains([
                        'text+select',
                        'select+text'
                    ], input.options.type);
                });
                inputGroup && (className += ' o-form-multi-input-group-' + this.options.multi);
            }
        }
        return className;
    },
    _getNames: function() {
        const names = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(this.options.name) ? this.options.name : [
            this.options.name
        ];
        /*eslint complexity: 0 */ if (this.options.type === 'group') names.push.apply(names, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).pluck(this.options.input[0].options.params.inputs, 'name'));
        else if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(this.options.name)) {
            if (this.options.input && this.options.input.options && this.options.input.options.name) names.push(this.options.input.options.name);
        } else if (this.options.input) {
            if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(this.options.input)) (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(this.options.input, function(inputItem) {
                names.push(inputItem.options.name);
            });
            else names.push(this.options.input.options.name);
        }
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).uniq((0, $3e490973b7383cc4$export$2e2bcd8739ae039).compact(names));
    },
    _getInputElement: function() {
        // NOTE: this.options.input is sometimes not an array under test
        const lastInput = Array.isArray(this.options.input) ? (0, $3e490973b7383cc4$export$2e2bcd8739ae039).last(this.options.input) : this.options.input; // FIXME: replace with _.get
        const id = lastInput && lastInput.options && lastInput.options.inputId;
        const el = id ? this.$('#' + id) : null;
        return el && el.length ? el : null;
    },
    constructor: function() {
        /* eslint max-statements: [2, 18] */ (0, $5f539c045973220f$export$2e2bcd8739ae039).apply(this, arguments);
        const explainTop = this.options['explain-top'] && this.options['label-top'];
        if (this.options.input) {
            if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(this.options.input)) (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(this.options.input, function(inputItem) {
                this.add(inputItem, {
                    prepend: !explainTop
                });
            }, this);
            else this.add(this.options.input, {
                prepend: !explainTop
            });
        }
        this.__setExplain(this.options);
        const names = this._getNames();
        this.listenTo(this.model, 'form:field-error', function(name, errors) {
            if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains(names, name)) this.__setError(errors, explainTop);
        });
        this.listenTo(this.model, 'form:clear-errors change:' + names.join(' change:'), this.__clearError);
        this.listenTo(this.model, 'form:clear-error:' + names.join(' form:clear-error:'), this.__clearError);
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).resultCtx(this.options, 'autoRender', this)) this.listenTo(this.model, 'change:' + this.options.name, this.render);
        this.__errorState = false;
    },
    /**
   * Populates the explain on the input container (if it exists). There are
   * two ways to use this:
   * 1. Raw text - wraps in the correct html template
   * 2. Custom html
   *    - pass in a View class (preferred)
   *    - pass in an instance of a View
   * Some additional notes:
   * - You can pass a function that returns any of the above
   * - This maintains support for the deprecated "customExplain" property
   *   that was used before. This pattern is superseded by explain, so use
   *   that instead.
   * @private
   */ __setExplain: function(options) {
        let explain; // Deprecated - if you need custom html, use explain instead
        if (options.customExplain) {
            (0, $cbf92b1807f0afdb$export$2e2bcd8739ae039).warn('Deprecated - use explain instead of customExplain');
            this.add(this.options.customExplain);
            return;
        }
        explain = options.explain;
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(explain) && !$96ed0788ab09b8e9$var$isABaseView(explain)) explain = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).resultCtx(this.options, 'explain', this);
        if (!explain) return;
        if ($96ed0788ab09b8e9$var$isABaseView(explain)) {
            this.template = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                "compiler": [
                    8,
                    ">= 4.3.0"
                ],
                "main": function(container, depth0, helpers, partials, data) {
                    return "<p class=\"o-form-explain\"></p>";
                },
                "useData": true
            });
            this.add(explain, ' > .o-form-explain');
        } else this.template = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
            "compiler": [
                8,
                ">= 4.3.0"
            ],
            "main": function(container, depth0, helpers, partials, data) {
                var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                    return undefined;
                };
                return "<p class=\"o-form-explain\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "explain") || (depth0 != null ? lookupProperty(depth0, "explain") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                    "name": "explain",
                    "hash": {},
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 26
                        },
                        "end": {
                            "line": 1,
                            "column": 37
                        }
                    }
                }) : helper)) + "</p>";
            },
            "useData": true
        });
    },
    /**
   * Highlight the input as invalid (validation failed)
   * Adds an explaination message of the error
   * @private
   */ __setError: function(errors, explainTop) {
        this.__errorState = true;
        this.$el.addClass('o-form-has-errors');
        const errorId = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).uniqueId('input-container-error');
        const html = this.__getHTMLForError((0, $3e490973b7383cc4$export$2e2bcd8739ae039).flatten(errors), errorId);
        const $elExplain = this.$('.o-form-explain').not('.o-form-input-error').first();
        if ($elExplain.length && !explainTop) $elExplain.before(html);
        else this.$el.append(html);
        const target = this._getInputElement() || this.$el;
        target.attr('aria-describedby', errorId);
        target.attr('aria-invalid', true);
    },
    __getHTMLForError: function(errors, errorId) {
        const tmpl = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
            "compiler": [
                8,
                ">= 4.3.0"
            ],
            "main": function(container, depth0, helpers, partials, data) {
                var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                    return undefined;
                };
                return "<p id=\"" + alias4((helper = (helper = lookupProperty(helpers, "errorId") || (depth0 != null ? lookupProperty(depth0, "errorId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                    "name": "errorId",
                    "hash": {},
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 7
                        },
                        "end": {
                            "line": 1,
                            "column": 18
                        }
                    }
                }) : helper)) + "\" class=\"okta-form-input-error o-form-input-error o-form-explain\" role=\"alert\"><span class=\"icon icon-16 error-16-small\" role=\"img\" aria-label=\"" + alias4((helper = (helper = lookupProperty(helpers, "iconLabel") || (depth0 != null ? lookupProperty(depth0, "iconLabel") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                    "name": "iconLabel",
                    "hash": {},
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 162
                        },
                        "end": {
                            "line": 1,
                            "column": 175
                        }
                    }
                }) : helper)) + "\"></span>" + alias4((helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                    "name": "text",
                    "hash": {},
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 184
                        },
                        "end": {
                            "line": 1,
                            "column": 192
                        }
                    }
                }) : helper)) + "</p>";
            },
            "useData": true
        });
        const iconLabel = (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize('oform.error.icon.ariaLabel', 'courage'); // 'Error'
        if (this.options.multirowError) {
            let html = '';
            errors.forEach((error)=>{
                html = html + tmpl({
                    errorId: errorId,
                    iconLabel: iconLabel,
                    text: error
                });
            });
            return html;
        }
        return tmpl({
            errorId: errorId,
            iconLabel: iconLabel,
            text: errors.join(', ')
        });
    },
    /**
   * Un-highlight the input and remove explaination text
   * @private
   */ __clearError: function() {
        if (this.__errorState) {
            this.$('.o-form-input-error').remove();
            const target = this._getInputElement() || this.$el;
            target.attr('aria-describedby', null);
            target.attr('aria-invalid', null);
            this.$el.removeClass('o-form-has-errors');
            this.__errorState = false;
            (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defer(()=>{
                this.model.trigger('form:resize');
            });
        }
    },
    focus: function() {
        this.each(function(view) {
            if (view.focus) return view.focus();
        });
        return this;
    }
});




const $52a08da877666121$var$registry = {};
function $52a08da877666121$var$isBaseInput(input) {
    if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(input)) return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(input.prototype.editMode) && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(input.prototype.readMode);
    else return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isObject(input) && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(input.editMode) && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(input.readMode);
}
/**
 * @class module:Okta.internal.views.forms.helpers.InputRegistry
 */ var $52a08da877666121$export$2e2bcd8739ae039 = /** @lends module:Okta.internal.views.forms.helpers.InputRegistry */ {
    isBaseInput: $52a08da877666121$var$isBaseInput,
    /**
   * Register a form input
   * @param {String} type string identifier for the input
   * @param {BaseInput} input the input to register
   * @return {void}
   */ register: function(type, input) {
        $52a08da877666121$var$registry[type] = input;
    },
    /**
   * Get a form input by type
   * @param {Object} options input definition
   * @param {String} options.type string identifier for the input
   * @return {BaseInput} a matching input
   */ get: function(options) {
        const input = $52a08da877666121$var$registry[options.type];
        return input && ($52a08da877666121$var$isBaseInput(input) ? input : input(options));
    },
    /**
   * Unregister an input type
   * @param {String} type
   */ unregister: function(type) {
        delete $52a08da877666121$var$registry[type];
    }
};


/* eslint complexity: 0, max-statements: 0 */ function $a9b2696677feee1f$var$createInput(Input, options) {
    if ((0, $52a08da877666121$export$2e2bcd8739ae039).isBaseInput(Input)) return Input.prototype ? new Input((0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(options, 'input')) : Input;
    else return Input;
}
function $a9b2696677feee1f$var$create(options) {
    options = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone(options);
    if (options.input) return $a9b2696677feee1f$var$createInput(options.input, options);
    const Input = (0, $52a08da877666121$export$2e2bcd8739ae039).get(options);
    if (!Input) throw new Error('unknown input: ' + options.type);
    return $a9b2696677feee1f$var$createInput(Input, options);
}
function $a9b2696677feee1f$var$supports(options) {
    return !!options.input || !!(0, $52a08da877666121$export$2e2bcd8739ae039).get(options);
}
var $a9b2696677feee1f$export$2e2bcd8739ae039 = {
    create: $a9b2696677feee1f$var$create,
    supports: $a9b2696677feee1f$var$supports
};





/*
 * qTip2 - Pretty powerful tooltips - v3.0.3-5-g
 * http://qtip2.com
 *
 * Copyright (c) 2017 
 * Released under the MIT licenses
 * http://jquery.org/license
 *
 * Date: Wed May 24 2017 01:22 UTC+0000
 * Plugins: tips modal viewport svg imagemap ie6
 * Styles: core basic css3
 */ /* Cache window, document, undefined */ (function(window1, document1, undefined$1) {
    (function(factory) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports))).fn.qtip) factory((0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports))));
    })(function($) {
        var TRUE = true, FALSE = false, NULL = null, // Common variables
        X = 'x', Y = 'y', WIDTH = 'width', HEIGHT = 'height', // Positioning sides
        TOP = 'top', LEFT = 'left', BOTTOM = 'bottom', RIGHT = 'right', CENTER = 'center', FLIPINVERT = 'flipinvert', SHIFT = 'shift', // Shortcut vars
        QTIP, PROTOTYPE, CORNER, CHECKS, PLUGINS = {}, NAMESPACE = 'qtip', ATTR_HAS = 'data-hasqtip', ATTR_ID = 'data-qtip-id', WIDGET = [
            'ui-widget',
            'ui-tooltip'
        ], SELECTOR = '.' + NAMESPACE, INACTIVE_EVENTS = 'click dblclick mousedown mouseup mousemove mouseleave mouseenter'.split(' '), CLASS_FIXED = NAMESPACE + '-fixed', CLASS_DEFAULT = NAMESPACE + '-default', CLASS_FOCUS = NAMESPACE + '-focus', CLASS_HOVER = NAMESPACE + '-hover', CLASS_DISABLED = NAMESPACE + '-disabled', replaceSuffix = '_replacedByqTip', oldtitle = 'oldtitle', trackingBound, // Browser detection
        BROWSER = {
            /*
         * IE version detection
         *
         * Adapted from: http://ajaxian.com/archives/attack-of-the-ie-conditional-comment
         * Credit to James Padolsey for the original implemntation!
         */ ie: function() {
                /* eslint-disable no-empty */ var v, i;
                for(v = 4, i = document1.createElement('div'); i.innerHTML = '<!--[if gt IE ' + v + ']><i></i><![endif]-->', i.getElementsByTagName('i')[0]; v += 1);
                return v > 4 ? v : NaN;
            /* eslint-enable no-empty */ }(),
            /*
         * iOS version detection
         */ iOS: parseFloat(('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [
                0,
                ''
            ])[1]).replace('undefined', '3_2').replace('_', '.').replace('_', '')) || FALSE
        };
        function QTip(target, options, id, attr) {
            // Elements and ID
            this.id = id;
            this.target = target;
            this.tooltip = NULL;
            this.elements = {
                target: target
            };
            // Internal constructs
            this._id = NAMESPACE + '-' + id;
            this.timers = {
                img: {}
            };
            this.options = options;
            this.plugins = {};
            // Cache object
            this.cache = {
                event: {},
                target: $(),
                disabled: FALSE,
                attr: attr,
                onTooltip: FALSE,
                lastClass: ''
            };
            // Set the initial flags
            this.rendered = this.destroyed = this.disabled = this.waiting = this.hiddenDuringWait = this.positioning = this.triggering = FALSE;
        }
        PROTOTYPE = QTip.prototype;
        PROTOTYPE._when = function(deferreds) {
            return $.when.apply($, deferreds);
        };
        PROTOTYPE.render = function(show) {
            if (this.rendered || this.destroyed) return this;
             // If tooltip has already been rendered, exit
            var self = this, options = this.options, cache = this.cache, elements = this.elements, text = options.content.text, title = options.content.title, button = options.content.button, posOptions = options.position, deferreds = [];
            // Add ARIA attributes to target
            $.attr(this.target[0], 'aria-describedby', this._id);
            // Create public position object that tracks current position corners
            cache.posClass = this._createPosClass((this.position = {
                my: posOptions.my,
                at: posOptions.at
            }).my);
            // Create tooltip element
            this.tooltip = elements.tooltip = $('<div/>', {
                'id': this._id,
                'class': [
                    NAMESPACE,
                    CLASS_DEFAULT,
                    options.style.classes,
                    cache.posClass
                ].join(' '),
                'width': options.style.width || '',
                'height': options.style.height || '',
                'tracking': posOptions.target === 'mouse' && posOptions.adjust.mouse,
                /* ARIA specific attributes */ 'role': 'alert',
                'aria-live': 'polite',
                'aria-atomic': FALSE,
                'aria-describedby': this._id + '-content',
                'aria-hidden': TRUE
            }).toggleClass(CLASS_DISABLED, this.disabled).attr(ATTR_ID, this.id).data(NAMESPACE, this).appendTo(posOptions.container).append(// Create content element
            elements.content = $('<div />', {
                'class': NAMESPACE + '-content',
                'id': this._id + '-content',
                'aria-atomic': TRUE
            }));
            // Set rendered flag and prevent redundant reposition calls for now
            this.rendered = -1;
            this.positioning = TRUE;
            // Create title...
            if (title) {
                this._createTitle();
                // Update title only if its not a callback (called in toggle if so)
                if (!$.isFunction(title)) deferreds.push(this._updateTitle(title, FALSE));
            }
            // Create button
            if (button) this._createButton();
            // Set proper rendered flag and update content if not a callback function (called in toggle)
            if (!$.isFunction(text)) deferreds.push(this._updateContent(text, FALSE));
            this.rendered = TRUE;
            // Setup widget classes
            this._setWidget();
            // Initialize 'render' plugins
            $.each(PLUGINS, function(name) {
                var instance;
                if (this.initialize === 'render' && (instance = this(self))) self.plugins[name] = instance;
            });
            // Unassign initial events and assign proper events
            this._unassignEvents();
            this._assignEvents();
            // When deferreds have completed
            this._when(deferreds).then(function() {
                // tooltiprender event
                self._trigger('render');
                // Reset flags
                self.positioning = FALSE;
                // Show tooltip if not hidden during wait period
                if (!self.hiddenDuringWait && (options.show.ready || show)) self.toggle(TRUE, cache.event, FALSE);
                self.hiddenDuringWait = FALSE;
            });
            // Expose API
            QTIP.api[this.id] = this;
            return this;
        };
        PROTOTYPE.destroy = function(immediate) {
            // Set flag the signify destroy is taking place to plugins
            // and ensure it only gets destroyed once!
            if (this.destroyed) return this.target;
            function process() {
                if (this.destroyed) return;
                this.destroyed = TRUE;
                var target = this.target, title = target.attr(oldtitle), timer;
                // Destroy tooltip if rendered
                if (this.rendered) this.tooltip.stop(1, 0).find('*').remove().end().remove();
                // Destroy all plugins
                $.each(this.plugins, function() {
                    this.destroy && this.destroy();
                });
                // Clear timers
                for(timer in this.timers)if (this.timers.hasOwnProperty(timer)) clearTimeout(this.timers[timer]);
                // Remove api object and ARIA attributes
                target.removeData(NAMESPACE).removeAttr(ATTR_ID).removeAttr(ATTR_HAS).removeAttr('aria-describedby');
                // Reset old title attribute if removed
                if (this.options.suppress && title) target.attr('title', title).removeAttr(oldtitle);
                // Remove qTip events associated with this API
                this._unassignEvents();
                // Remove ID from used id objects, and delete object references
                // for better garbage collection and leak protection
                this.options = this.elements = this.cache = this.timers = this.plugins = this.mouse = NULL;
                // Delete epoxsed API object
                delete QTIP.api[this.id];
            }
            // If an immediate destroy is needed
            if ((immediate !== TRUE || this.triggering === 'hide') && this.rendered) {
                this.tooltip.one('tooltiphidden', $.proxy(process, this));
                !this.triggering && this.hide();
            } else process.call(this);
            return this.target;
        };
        function invalidOpt(a) {
            return a === NULL || $.type(a) !== 'object';
        }
        function invalidContent(c) {
            return !($.isFunction(c) || c && c.attr || c.length || $.type(c) === 'object' && (c.jquery || c.then));
        }
        // Option object sanitizer
        function sanitizeOptions(opts) {
            var content, text, ajax, once;
            if (invalidOpt(opts)) return FALSE;
            if (invalidOpt(opts.metadata)) opts.metadata = {
                type: opts.metadata
            };
            if ('content' in opts) {
                content = opts.content;
                if (invalidOpt(content) || content.jquery || content.done) {
                    text = invalidContent(content) ? FALSE : content;
                    content = opts.content = {
                        text: text
                    };
                } else text = content.text;
                // DEPRECATED - Old content.ajax plugin functionality
                // Converts it into the proper Deferred syntax
                if ('ajax' in content) {
                    ajax = content.ajax;
                    once = ajax && ajax.once !== FALSE;
                    delete content.ajax;
                    content.text = function(event, api) {
                        var loading = text || $(this).attr(api.options.content.attr) || 'Loading...', deferred = $.ajax($.extend({}, ajax, {
                            context: api
                        })).then(ajax.success, NULL, ajax.error).then(function(newContent) {
                            if (newContent && once) api.set('content.text', newContent);
                            return newContent;
                        }, function(xhr, status, error) {
                            if (api.destroyed || xhr.status === 0) return;
                            api.set('content.text', status + ': ' + error);
                        });
                        return !once ? (api.set('content.text', loading), deferred) : loading;
                    };
                }
                if ('title' in content) {
                    if ($.isPlainObject(content.title)) {
                        content.button = content.title.button;
                        content.title = content.title.text;
                    }
                    if (invalidContent(content.title || FALSE)) content.title = FALSE;
                }
            }
            if ('position' in opts && invalidOpt(opts.position)) opts.position = {
                my: opts.position,
                at: opts.position
            };
            if ('show' in opts && invalidOpt(opts.show)) opts.show = opts.show.jquery ? {
                target: opts.show
            } : opts.show === TRUE ? {
                ready: TRUE
            } : {
                event: opts.show
            };
            if ('hide' in opts && invalidOpt(opts.hide)) opts.hide = opts.hide.jquery ? {
                target: opts.hide
            } : {
                event: opts.hide
            };
            if ('style' in opts && invalidOpt(opts.style)) opts.style = {
                classes: opts.style
            };
            // Sanitize plugin options
            $.each(PLUGINS, function() {
                this.sanitize && this.sanitize(opts);
            });
            return opts;
        }
        // Setup builtin .set() option checks
        CHECKS = PROTOTYPE.checks = {
            builtin: {
                // Core checks
                '^id$': function(obj, o, v, prev) {
                    var id = v === TRUE ? QTIP.nextid : v, newId = NAMESPACE + '-' + id;
                    if (id !== FALSE && id.length > 0 && !$('#' + newId).length) {
                        this._id = newId;
                        if (this.rendered) {
                            this.tooltip[0].id = this._id;
                            this.elements.content[0].id = this._id + '-content';
                            this.elements.title[0].id = this._id + '-title';
                        }
                    } else obj[o] = prev;
                },
                '^prerender': function(obj, o, v) {
                    v && !this.rendered && this.render(this.options.show.ready);
                },
                // Content checks
                '^content.text$': function(obj, o, v) {
                    this._updateContent(v);
                },
                '^content.attr$': function(obj, o, v, prev) {
                    if (this.options.content.text === this.target.attr(prev)) this._updateContent(this.target.attr(v));
                },
                '^content.title$': function(obj, o, v) {
                    // Remove title if content is null
                    if (!v) return this._removeTitle();
                    // If title isn't already created, create it now and update
                    v && !this.elements.title && this._createTitle();
                    this._updateTitle(v);
                },
                '^content.button$': function(obj, o, v) {
                    this._updateButton(v);
                },
                '^content.title.(text|button)$': function(obj, o, v) {
                    this.set('content.' + o, v); // Backwards title.text/button compat
                },
                // Position checks
                '^position.(my|at)$': function(obj, o, v) {
                    if ('string' === typeof v) this.position[o] = obj[o] = new CORNER(v, o === 'at');
                },
                '^position.container$': function(obj, o, v) {
                    this.rendered && this.tooltip.appendTo(v);
                },
                // Show checks
                '^show.ready$': function(obj, o, v) {
                    v && (!this.rendered && this.render(TRUE) || this.toggle(TRUE));
                },
                // Style checks
                '^style.classes$': function(obj, o, v, p) {
                    this.rendered && this.tooltip.removeClass(p).addClass(v);
                },
                '^style.(width|height)': function(obj, o, v) {
                    this.rendered && this.tooltip.css(o, v);
                },
                '^style.widget|content.title': function() {
                    this.rendered && this._setWidget();
                },
                '^style.def': function(obj, o, v) {
                    this.rendered && this.tooltip.toggleClass(CLASS_DEFAULT, !!v);
                },
                // Events check
                '^events.(render|show|move|hide|focus|blur)$': function(obj, o, v) {
                    this.rendered && this.tooltip[($.isFunction(v) ? '' : 'un') + 'bind']('tooltip' + o, v);
                },
                // Properties which require event reassignment
                '^(show|hide|position).(event|target|fixed|inactive|leave|distance|viewport|adjust)': function() {
                    if (!this.rendered) return;
                    // Set tracking flag
                    var posOptions = this.options.position;
                    this.tooltip.attr('tracking', posOptions.target === 'mouse' && posOptions.adjust.mouse);
                    // Reassign events
                    this._unassignEvents();
                    this._assignEvents();
                }
            }
        };
        // Dot notation converter
        function convertNotation(options, notation) {
            var i = 0, obj, option = options, // Split notation into array
            levels = notation.split('.');
            // Loop through
            while(option = option[levels[i++]])if (i < levels.length) obj = option;
            return [
                obj || options,
                levels.pop()
            ];
        }
        PROTOTYPE.get = function(notation) {
            if (this.destroyed) return this;
            var o = convertNotation(this.options, notation.toLowerCase()), result = o[0][o[1]];
            return result.precedance ? result.string() : result;
        };
        function setCallback(notation, args) {
            var category, rule, match;
            for(category in this.checks){
                if (!this.checks.hasOwnProperty(category)) continue;
                for(rule in this.checks[category]){
                    if (!this.checks[category].hasOwnProperty(rule)) continue;
                    if (match = new RegExp(rule, 'i').exec(notation)) {
                        args.push(match);
                        if (category === 'builtin' || this.plugins[category]) this.checks[category][rule].apply(this.plugins[category] || this, args);
                    }
                }
            }
        }
        var rmove = /^position\.(my|at|adjust|target|container|viewport)|style|content|show\.ready/i, rrender = /^prerender|show\.ready/i;
        PROTOTYPE.set = function(option, value) {
            if (this.destroyed) return this;
            var rendered = this.rendered, reposition = FALSE, options = this.options, name;
            // Convert singular option/value pair into object form
            if ('string' === typeof option) {
                name = option;
                option = {};
                option[name] = value;
            } else option = $.extend({}, option);
            // Set all of the defined options to their new values
            $.each(option, function(notation, val) {
                if (rendered && rrender.test(notation)) {
                    delete option[notation];
                    return;
                }
                // Set new obj value
                var obj = convertNotation(options, notation.toLowerCase()), previous;
                previous = obj[0][obj[1]];
                obj[0][obj[1]] = val && val.nodeType ? $(val) : val;
                // Also check if we need to reposition
                reposition = rmove.test(notation) || reposition;
                // Set the new params for the callback
                option[notation] = [
                    obj[0],
                    obj[1],
                    val,
                    previous
                ];
            });
            // Re-sanitize options
            sanitizeOptions(options);
            /*
       * Execute any valid callbacks for the set options
       * Also set positioning flag so we don't get loads of redundant repositioning calls.
       */ this.positioning = TRUE;
            $.each(option, $.proxy(setCallback, this));
            this.positioning = FALSE;
            // Update position if needed
            if (this.rendered && this.tooltip[0].offsetWidth > 0 && reposition) this.reposition(options.position.target === 'mouse' ? NULL : this.cache.event);
            return this;
        };
        PROTOTYPE._update = function(content, element) {
            var self = this, cache = this.cache;
            // Make sure tooltip is rendered and content is defined. If not return
            if (!this.rendered || !content) return FALSE;
            // Use function to parse content
            if ($.isFunction(content)) content = content.call(this.elements.target, cache.event, this) || '';
            // Handle deferred content
            if ($.isFunction(content.then)) {
                cache.waiting = TRUE;
                return content.then(function(c) {
                    cache.waiting = FALSE;
                    return self._update(c, element);
                }, NULL, function(e) {
                    return self._update(e, element);
                });
            }
            // If content is null... return false
            if (content === FALSE || !content && content !== '') return FALSE;
            // Append new content if its a DOM array and show it if hidden
            if (content.jquery && content.length > 0) element.empty().append(content.css({
                display: 'block',
                visibility: 'visible'
            }));
            else element.html(content);
            // Wait for content to be loaded, and reposition
            return this._waitForContent(element).then(function(images) {
                if (self.rendered && self.tooltip[0].offsetWidth > 0) self.reposition(cache.event, !images.length);
            });
        };
        PROTOTYPE._waitForContent = function(element) {
            var cache = this.cache;
            // Set flag
            cache.waiting = TRUE;
            // If imagesLoaded is included, ensure images have loaded and return promise
            return ($.fn.imagesLoaded ? element.imagesLoaded() : new $.Deferred().resolve([])).done(function() {
                cache.waiting = FALSE;
            }).promise();
        };
        PROTOTYPE._updateContent = function(content, reposition) {
            this._update(content, this.elements.content, reposition);
        };
        PROTOTYPE._updateTitle = function(content, reposition) {
            if (this._update(content, this.elements.title, reposition) === FALSE) this._removeTitle(FALSE);
        };
        PROTOTYPE._createTitle = function() {
            var elements = this.elements, id = this._id + '-title';
            // Destroy previous title element, if present
            if (elements.titlebar) this._removeTitle();
            // Create title bar and title elements
            elements.titlebar = $('<div />', {
                'class': NAMESPACE + '-titlebar ' + (this.options.style.widget ? createWidgetClass('header') : '')
            }).append(elements.title = $('<div />', {
                'id': id,
                'class': NAMESPACE + '-title',
                'aria-atomic': TRUE
            })).insertBefore(elements.content)// Button-specific events
            .delegate('.qtip-close', 'mousedown keydown mouseup keyup mouseout', function(event) {
                $(this).toggleClass('ui-state-active ui-state-focus', event.type.substr(-4) === 'down');
            }).delegate('.qtip-close', 'mouseover mouseout', function(event) {
                $(this).toggleClass('ui-state-hover', event.type === 'mouseover');
            });
            // Create button if enabled
            if (this.options.content.button) this._createButton();
        };
        PROTOTYPE._removeTitle = function(reposition) {
            var elements = this.elements;
            if (elements.title) {
                elements.titlebar.remove();
                elements.titlebar = elements.title = elements.button = NULL;
                // Reposition if enabled
                if (reposition !== FALSE) this.reposition();
            }
        };
        PROTOTYPE._createPosClass = function(my) {
            return NAMESPACE + '-pos-' + (my || this.options.position.my).abbrev();
        };
        PROTOTYPE.reposition = function(event, effect) {
            if (!this.rendered || this.positioning || this.destroyed) return this;
            // Set positioning flag
            this.positioning = TRUE;
            var cache = this.cache, tooltip = this.tooltip, posOptions = this.options.position, target = posOptions.target, my = posOptions.my, at = posOptions.at, viewport = posOptions.viewport, container = posOptions.container, adjust = posOptions.adjust, method = adjust.method.split(' '), tooltipWidth = tooltip.outerWidth(FALSE), tooltipHeight = tooltip.outerHeight(FALSE), targetWidth = 0, targetHeight = 0, type = tooltip.css('position'), position = {
                left: 0,
                top: 0
            }, visible = tooltip[0].offsetWidth > 0, isScroll = event && event.type === 'scroll', win = $(window1), doc = container[0].ownerDocument, mouse = this.mouse, pluginCalculations, offset, adjusted, newClass;
            // Check if absolute position was passed
            if ($.isArray(target) && target.length === 2) {
                // Force left top and set position
                at = {
                    x: LEFT,
                    y: TOP
                };
                position = {
                    left: target[0],
                    top: target[1]
                };
            } else if (target === 'mouse') {
                // Force left top to allow flipping
                at = {
                    x: LEFT,
                    y: TOP
                };
                // Use the mouse origin that caused the show event, if distance hiding is enabled
                if ((!adjust.mouse || this.options.hide.distance) && cache.origin && cache.origin.pageX) event = cache.origin;
                else if (!event || event && (event.type === 'resize' || event.type === 'scroll')) event = cache.event;
                else if (mouse && mouse.pageX) event = mouse;
                // Calculate body and container offset and take them into account below
                if (type !== 'static') position = container.offset();
                if (doc.body.offsetWidth !== (window1.innerWidth || doc.documentElement.clientWidth)) offset = $(document1.body).offset();
                // Use event coordinates for position
                position = {
                    left: event.pageX - position.left + (offset && offset.left || 0),
                    top: event.pageY - position.top + (offset && offset.top || 0)
                };
                // Scroll events are a pain, some browsers
                if (adjust.mouse && isScroll && mouse) {
                    position.left -= (mouse.scrollX || 0) - win.scrollLeft();
                    position.top -= (mouse.scrollY || 0) - win.scrollTop();
                }
            } else {
                // Check if event targetting is being used
                if (target === 'event') {
                    if (event && event.target && event.type !== 'scroll' && event.type !== 'resize') cache.target = $(event.target);
                    else if (!event.target) cache.target = this.elements.target;
                } else if (target !== 'event') cache.target = $(target.jquery ? target : this.elements.target);
                target = cache.target;
                // Parse the target into a jQuery object and make sure there's an element present
                target = $(target).eq(0);
                if (target.length === 0) return this;
                else if (target[0] === document1 || target[0] === window1) {
                    targetWidth = BROWSER.iOS ? window1.innerWidth : target.width();
                    targetHeight = BROWSER.iOS ? window1.innerHeight : target.height();
                    if (target[0] === window1) position = {
                        top: (viewport || target).scrollTop(),
                        left: (viewport || target).scrollLeft()
                    };
                } else if (PLUGINS.imagemap && target.is('area')) pluginCalculations = PLUGINS.imagemap(this, target, at, PLUGINS.viewport ? method : FALSE);
                else if (PLUGINS.svg && target && target[0].ownerSVGElement) pluginCalculations = PLUGINS.svg(this, target, at, PLUGINS.viewport ? method : FALSE);
                else {
                    targetWidth = target.outerWidth(FALSE);
                    targetHeight = target.outerHeight(FALSE);
                    position = target.offset();
                }
                // Parse returned plugin values into proper variables
                if (pluginCalculations) {
                    targetWidth = pluginCalculations.width;
                    targetHeight = pluginCalculations.height;
                    offset = pluginCalculations.offset;
                    position = pluginCalculations.position;
                }
                // Adjust position to take into account offset parents
                position = this.reposition.offset(target, position, container);
                // Adjust for position.fixed tooltips (and also iOS scroll bug in v3.2-4.0 & v4.3-4.3.2)
                if (BROWSER.iOS > 3.1 && BROWSER.iOS < 4.1 || BROWSER.iOS >= 4.3 && BROWSER.iOS < 4.33 || !BROWSER.iOS && type === 'fixed') {
                    position.left -= win.scrollLeft();
                    position.top -= win.scrollTop();
                }
                // Adjust position relative to target
                if (!pluginCalculations || pluginCalculations && pluginCalculations.adjustable !== FALSE) {
                    position.left += at.x === RIGHT ? targetWidth : at.x === CENTER ? targetWidth / 2 : 0;
                    position.top += at.y === BOTTOM ? targetHeight : at.y === CENTER ? targetHeight / 2 : 0;
                }
            }
            // Adjust position relative to tooltip
            position.left += adjust.x + (my.x === RIGHT ? -tooltipWidth : my.x === CENTER ? -tooltipWidth / 2 : 0);
            position.top += adjust.y + (my.y === BOTTOM ? -tooltipHeight : my.y === CENTER ? -tooltipHeight / 2 : 0);
            // Use viewport adjustment plugin if enabled
            if (PLUGINS.viewport) {
                adjusted = position.adjusted = PLUGINS.viewport(this, position, posOptions, targetWidth, targetHeight, tooltipWidth, tooltipHeight);
                // Apply offsets supplied by positioning plugin (if used)
                if (offset && adjusted.left) position.left += offset.left;
                if (offset && adjusted.top) position.top += offset.top;
                // Apply any new 'my' position
                if (adjusted.my) this.position.my = adjusted.my;
            } else position.adjusted = {
                left: 0,
                top: 0
            };
            // Set tooltip position class if it's changed
            if (cache.posClass !== (newClass = this._createPosClass(this.position.my))) {
                cache.posClass = newClass;
                tooltip.removeClass(cache.posClass).addClass(newClass);
            }
            // tooltipmove event
            if (!this._trigger('move', [
                position,
                viewport.elem || viewport
            ], event)) return this;
            delete position.adjusted;
            // If effect is disabled, target it mouse, no animation is defined or positioning gives NaN out, set CSS directly
            if (effect === FALSE || !visible || isNaN(position.left) || isNaN(position.top) || target === 'mouse' || !$.isFunction(posOptions.effect)) tooltip.css(position);
            else if ($.isFunction(posOptions.effect)) {
                posOptions.effect.call(tooltip, this, $.extend({}, position));
                tooltip.queue(function(next) {
                    // Reset attributes to avoid cross-browser rendering bugs
                    $(this).css({
                        opacity: '',
                        height: ''
                    });
                    if (BROWSER.ie) this.style.removeAttribute('filter');
                    next();
                });
            }
            // Set positioning flag
            this.positioning = FALSE;
            return this;
        };
        // Custom (more correct for qTip!) offset calculator
        PROTOTYPE.reposition.offset = function(elem, pos, container) {
            if (!container[0]) return pos;
            var ownerDocument = $(elem[0].ownerDocument), quirks = !!BROWSER.ie && document1.compatMode !== 'CSS1Compat', parent = container[0], scrolled, position, parentOffset, overflow;
            function scroll(e, i) {
                pos.left += i * e.scrollLeft();
                pos.top += i * e.scrollTop();
            }
            // Compensate for non-static containers offset
            do if ((position = $.css(parent, 'position')) !== 'static') {
                if (position === 'fixed') {
                    parentOffset = parent.getBoundingClientRect();
                    scroll(ownerDocument, -1);
                } else {
                    parentOffset = $(parent).position();
                    parentOffset.left += parseFloat($.css(parent, 'borderLeftWidth')) || 0;
                    parentOffset.top += parseFloat($.css(parent, 'borderTopWidth')) || 0;
                }
                pos.left -= parentOffset.left + (parseFloat($.css(parent, 'marginLeft')) || 0);
                pos.top -= parentOffset.top + (parseFloat($.css(parent, 'marginTop')) || 0);
                // If this is the first parent element with an overflow of "scroll" or "auto", store it
                if (!scrolled && (overflow = $.css(parent, 'overflow')) !== 'hidden' && overflow !== 'visible' && $.prop(parent, 'tagName') !== 'BODY') scrolled = $(parent);
            }
            while (parent = parent.offsetParent);
            // Compensate for containers scroll if it also has an offsetParent (or in IE quirks mode)
            if (scrolled && (scrolled[0] !== ownerDocument[0] || quirks)) scroll(scrolled, 1);
            return pos;
        };
        // Corner class
        var C = (CORNER = PROTOTYPE.reposition.Corner = function(corner, forceY) {
            corner = ('' + corner).replace(/([A-Z])/, ' $1').replace(/middle/gi, CENTER).toLowerCase();
            this.x = (corner.match(/left|right/i) || corner.match(/center/) || [
                'inherit'
            ])[0].toLowerCase();
            this.y = (corner.match(/top|bottom|center/i) || [
                'inherit'
            ])[0].toLowerCase();
            this.forceY = !!forceY;
            var f = corner.charAt(0);
            this.precedance = f === 't' || f === 'b' ? Y : X;
        }).prototype;
        C.invert = function(z, center) {
            this[z] = this[z] === LEFT ? RIGHT : this[z] === RIGHT ? LEFT : center || this[z];
        };
        C.string = function(join) {
            var x = this.x, y = this.y;
            var result = x !== y ? x === 'center' || y !== 'center' && (this.precedance === Y || this.forceY) ? [
                y,
                x
            ] : [
                x,
                y
            ] : [
                x
            ];
            return join !== false ? result.join(' ') : result;
        };
        C.abbrev = function() {
            var result = this.string(false);
            return result[0].charAt(0) + (result[1] && result[1].charAt(0) || '');
        };
        C.clone = function() {
            return new CORNER(this.string(), this.forceY);
        };
        PROTOTYPE.toggle = function(state, event) {
            var cache = this.cache, options = this.options, tooltip = this.tooltip;
            // Try to prevent flickering when tooltip overlaps show element
            if (event) {
                if (/over|enter/.test(event.type) && cache.event && /out|leave/.test(cache.event.type) && options.show.target.add(event.target).length === options.show.target.length && tooltip.has(event.relatedTarget).length) return this;
                // Cache event
                cache.event = $.event.fix(event);
            }
            // If we're currently waiting and we've just hidden... stop it
            this.waiting && !state && (this.hiddenDuringWait = TRUE);
            // Render the tooltip if showing and it isn't already
            if (!this.rendered) return state ? this.render(1) : this;
            else if (this.destroyed || this.disabled) return this;
            var type = state ? 'show' : 'hide', opts = this.options[type], posOptions = this.options.position, contentOptions = this.options.content, width = this.tooltip.css('width'), visible = this.tooltip.is(':visible'), animate = state || opts.target.length === 1, sameTarget = !event || opts.target.length < 2 || cache.target[0] === event.target, identicalState, allow, after;
            // Detect state if valid one isn't provided
            if ((typeof state).search('boolean|number')) state = !visible;
            // Check if the tooltip is in an identical state to the new would-be state
            identicalState = !tooltip.is(':animated') && visible === state && sameTarget;
            // Fire tooltip(show/hide) event and check if destroyed
            allow = !identicalState ? !!this._trigger(type, [
                90
            ]) : NULL;
            // Check to make sure the tooltip wasn't destroyed in the callback
            if (this.destroyed) return this;
            // If the user didn't stop the method prematurely and we're showing the tooltip, focus it
            if (allow !== FALSE && state) this.focus(event);
            // If the state hasn't changed or the user stopped it, return early
            if (!allow || identicalState) return this;
            // Set ARIA hidden attribute
            $.attr(tooltip[0], 'aria-hidden', !!!state);
            // Execute state specific properties
            if (state) {
                // Store show origin coordinates
                this.mouse && (cache.origin = $.event.fix(this.mouse));
                // Update tooltip content & title if it's a dynamic function
                if ($.isFunction(contentOptions.text)) this._updateContent(contentOptions.text, FALSE);
                if ($.isFunction(contentOptions.title)) this._updateTitle(contentOptions.title, FALSE);
                // Cache mousemove events for positioning purposes (if not already tracking)
                if (!trackingBound && posOptions.target === 'mouse' && posOptions.adjust.mouse) {
                    $(document1).bind('mousemove.' + NAMESPACE, this._storeMouse);
                    trackingBound = TRUE;
                }
                // Update the tooltip position (set width first to prevent viewport/max-width issues)
                if (!width) tooltip.css('width', tooltip.outerWidth(FALSE));
                this.reposition(event, arguments[2]);
                if (!width) tooltip.css('width', '');
                // Hide other tooltips if tooltip is solo
                if (!!opts.solo) (typeof opts.solo === 'string' ? $(opts.solo) : $(SELECTOR, opts.solo)).not(tooltip).not(opts.target).qtip('hide', new $.Event('tooltipsolo'));
            } else {
                // Clear show timer if we're hiding
                clearTimeout(this.timers.show);
                // Remove cached origin on hide
                delete cache.origin;
                // Remove mouse tracking event if not needed (all tracking qTips are hidden)
                if (trackingBound && !$(SELECTOR + '[tracking="true"]:visible', opts.solo).not(tooltip).length) {
                    $(document1).unbind('mousemove.' + NAMESPACE);
                    trackingBound = FALSE;
                }
                // Blur the tooltip
                this.blur(event);
            }
            // Define post-animation, state specific properties
            after = $.proxy(function() {
                if (state) {
                    // Prevent antialias from disappearing in IE by removing filter
                    if (BROWSER.ie) tooltip[0].style.removeAttribute('filter');
                    // Remove overflow setting to prevent tip bugs
                    tooltip.css('overflow', '');
                    // Autofocus elements if enabled
                    if ('string' === typeof opts.autofocus) $(this.options.show.autofocus, tooltip).focus();
                    // If set, hide tooltip when inactive for delay period
                    this.options.show.target.trigger('qtip-' + this.id + '-inactive');
                } else // Reset CSS states
                tooltip.css({
                    display: '',
                    visibility: '',
                    opacity: '',
                    left: '',
                    top: ''
                });
                // tooltipvisible/tooltiphidden events
                this._trigger(state ? 'visible' : 'hidden');
            }, this);
            // If no effect type is supplied, use a simple toggle
            if (opts.effect === FALSE || animate === FALSE) {
                tooltip[type]();
                after();
            } else if ($.isFunction(opts.effect)) {
                tooltip.stop(1, 1);
                opts.effect.call(tooltip, this);
                tooltip.queue('fx', function(n) {
                    after();
                    n();
                });
            } else tooltip.fadeTo(90, state ? 1 : 0, after);
            // If inactive hide method is set, active it
            if (state) opts.target.trigger('qtip-' + this.id + '-inactive');
            return this;
        };
        PROTOTYPE.show = function(event) {
            return this.toggle(TRUE, event);
        };
        PROTOTYPE.hide = function(event) {
            return this.toggle(FALSE, event);
        };
        PROTOTYPE.focus = function(event) {
            if (!this.rendered || this.destroyed) return this;
            var qtips = $(SELECTOR), tooltip = this.tooltip, curIndex = parseInt(tooltip[0].style.zIndex, 10), newIndex = QTIP.zindex + qtips.length;
            // Only update the z-index if it has changed and tooltip is not already focused
            if (!tooltip.hasClass(CLASS_FOCUS)) // tooltipfocus event
            {
                if (this._trigger('focus', [
                    newIndex
                ], event)) {
                    // Only update z-index's if they've changed
                    if (curIndex !== newIndex) {
                        // Reduce our z-index's and keep them properly ordered
                        qtips.each(function() {
                            if (this.style.zIndex > curIndex) this.style.zIndex = this.style.zIndex - 1;
                        });
                        // Fire blur event for focused tooltip
                        qtips.filter('.' + CLASS_FOCUS).qtip('blur', event);
                    }
                    // Set the new z-index
                    tooltip.addClass(CLASS_FOCUS)[0].style.zIndex = newIndex;
                }
            }
            return this;
        };
        PROTOTYPE.blur = function(event) {
            if (!this.rendered || this.destroyed) return this;
            // Set focused status to FALSE
            this.tooltip.removeClass(CLASS_FOCUS);
            // tooltipblur event
            this._trigger('blur', [
                this.tooltip.css('zIndex')
            ], event);
            return this;
        };
        PROTOTYPE.disable = function(state) {
            if (this.destroyed) return this;
            // If 'toggle' is passed, toggle the current state
            if (state === 'toggle') state = !(this.rendered ? this.tooltip.hasClass(CLASS_DISABLED) : this.disabled);
            else if ('boolean' !== typeof state) state = TRUE;
            if (this.rendered) this.tooltip.toggleClass(CLASS_DISABLED, state).attr('aria-disabled', state);
            this.disabled = !!state;
            return this;
        };
        PROTOTYPE.enable = function() {
            return this.disable(FALSE);
        };
        PROTOTYPE._createButton = function() {
            var self = this, elements = this.elements, tooltip = elements.tooltip, button = this.options.content.button, isString = typeof button === 'string', close = isString ? button : 'Close tooltip';
            if (elements.button) elements.button.remove();
            // Use custom button if one was supplied by user, else use default
            if (button.jquery) elements.button = button;
            else elements.button = $('<a />', {
                'class': 'qtip-close ' + (this.options.style.widget ? '' : NAMESPACE + '-icon'),
                'title': close,
                'aria-label': close
            }).prepend($('<span />', {
                'class': 'ui-icon ui-icon-close',
                'html': '&times;'
            }));
            // Create button and setup attributes
            elements.button.appendTo(elements.titlebar || tooltip).attr('role', 'button').click(function(event) {
                if (!tooltip.hasClass(CLASS_DISABLED)) self.hide(event);
                return FALSE;
            });
        };
        PROTOTYPE._updateButton = function(button) {
            // Make sure tooltip is rendered and if not, return
            if (!this.rendered) return FALSE;
            var elem = this.elements.button;
            if (button) this._createButton();
            else elem.remove();
        };
        function createWidgetClass(cls) {
            return WIDGET.concat('').join(cls ? '-' + cls + ' ' : ' ');
        }
        // Widget class setter method
        PROTOTYPE._setWidget = function() {
            var on = this.options.style.widget, elements = this.elements, tooltip = elements.tooltip, disabled = tooltip.hasClass(CLASS_DISABLED);
            tooltip.removeClass(CLASS_DISABLED);
            CLASS_DISABLED = on ? 'ui-state-disabled' : 'qtip-disabled';
            tooltip.toggleClass(CLASS_DISABLED, disabled);
            tooltip.toggleClass('ui-helper-reset ' + createWidgetClass(), on).toggleClass(CLASS_DEFAULT, this.options.style.def && !on);
            if (elements.content) elements.content.toggleClass(createWidgetClass('content'), on);
            if (elements.titlebar) elements.titlebar.toggleClass(createWidgetClass('header'), on);
            if (elements.button) elements.button.toggleClass(NAMESPACE + '-icon', !on);
        };
        function delay(callback, duration) {
            // If tooltip has displayed, start hide timer
            if (duration > 0) return setTimeout($.proxy(callback, this), duration);
            else callback.call(this);
        }
        function showMethod(event) {
            if (this.tooltip.hasClass(CLASS_DISABLED)) return;
            // Clear hide timers
            clearTimeout(this.timers.show);
            clearTimeout(this.timers.hide);
            // Start show timer
            this.timers.show = delay.call(this, function() {
                this.toggle(TRUE, event);
            }, this.options.show.delay);
        }
        function hideMethod(event) {
            if (this.tooltip.hasClass(CLASS_DISABLED) || this.destroyed) return;
            // Check if new target was actually the tooltip element
            var relatedTarget = $(event.relatedTarget), ontoTooltip = relatedTarget.closest(SELECTOR)[0] === this.tooltip[0], ontoTarget = relatedTarget[0] === this.options.show.target[0];
            // Clear timers and stop animation queue
            clearTimeout(this.timers.show);
            clearTimeout(this.timers.hide);
            // Prevent hiding if tooltip is fixed and event target is the tooltip.
            // Or if mouse positioning is enabled and cursor momentarily overlaps
            if (this !== relatedTarget[0] && this.options.position.target === 'mouse' && ontoTooltip || this.options.hide.fixed && /mouse(out|leave|move)/.test(event.type) && (ontoTooltip || ontoTarget)) {
                /* eslint-disable no-empty */ try {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                } catch (e) {}
                /* eslint-enable no-empty */ return;
            }
            // If tooltip has displayed, start hide timer
            this.timers.hide = delay.call(this, function() {
                this.toggle(FALSE, event);
            }, this.options.hide.delay, this);
        }
        function inactiveMethod(event) {
            if (this.tooltip.hasClass(CLASS_DISABLED) || !this.options.hide.inactive) return;
            // Clear timer
            clearTimeout(this.timers.inactive);
            this.timers.inactive = delay.call(this, function() {
                this.hide(event);
            }, this.options.hide.inactive);
        }
        function repositionMethod(event) {
            if (this.rendered && this.tooltip[0].offsetWidth > 0) this.reposition(event);
        }
        // Store mouse coordinates
        PROTOTYPE._storeMouse = function(event) {
            (this.mouse = $.event.fix(event)).type = 'mousemove';
            return this;
        };
        // Bind events
        PROTOTYPE._bind = function(targets, events, method, suffix, context) {
            if (!targets || !method || !events.length) return;
            var ns = '.' + this._id + (suffix ? '-' + suffix : '');
            $(targets).bind((events.split ? events : events.join(ns + ' ')) + ns, $.proxy(method, context || this));
            return this;
        };
        PROTOTYPE._unbind = function(targets, suffix) {
            targets && $(targets).unbind('.' + this._id + (suffix ? '-' + suffix : ''));
            return this;
        };
        // Global delegation helper
        function delegate(selector, events, method) {
            $(document1.body).delegate(selector, (events.split ? events : events.join('.' + NAMESPACE + ' ')) + '.' + NAMESPACE, function() {
                var api = QTIP.api[$.attr(this, ATTR_ID)];
                api && !api.disabled && method.apply(api, arguments);
            });
        }
        // Event trigger
        PROTOTYPE._trigger = function(type, args, event) {
            var callback = new $.Event('tooltip' + type);
            callback.originalEvent = event && $.extend({}, event) || this.cache.event || NULL;
            this.triggering = type;
            this.tooltip.trigger(callback, [
                this
            ].concat(args || []));
            this.triggering = FALSE;
            return !callback.isDefaultPrevented();
        };
        PROTOTYPE._bindEvents = function(showEvents, hideEvents, showTargets, hideTargets, showCallback, hideCallback) {
            // Get tasrgets that lye within both
            var similarTargets = showTargets.filter(hideTargets).add(hideTargets.filter(showTargets)), toggleEvents = [];
            // If hide and show targets are the same...
            if (similarTargets.length) {
                // Filter identical show/hide events
                $.each(hideEvents, function(i, type) {
                    var showIndex = $.inArray(type, showEvents);
                    // Both events are identical, remove from both hide and show events
                    // and append to toggleEvents
                    showIndex > -1 && toggleEvents.push(showEvents.splice(showIndex, 1)[0]);
                });
                // Toggle events are special case of identical show/hide events, which happen in sequence
                if (toggleEvents.length) {
                    // Bind toggle events to the similar targets
                    this._bind(similarTargets, toggleEvents, function(event) {
                        var state = this.rendered ? this.tooltip[0].offsetWidth > 0 : false;
                        (state ? hideCallback : showCallback).call(this, event);
                    });
                    // Remove the similar targets from the regular show/hide bindings
                    showTargets = showTargets.not(similarTargets);
                    hideTargets = hideTargets.not(similarTargets);
                }
            }
            // Apply show/hide/toggle events
            this._bind(showTargets, showEvents, showCallback);
            this._bind(hideTargets, hideEvents, hideCallback);
        };
        PROTOTYPE._assignInitialEvents = function(event) {
            var options = this.options, showTarget = options.show.target, hideTarget = options.hide.target, showEvents = options.show.event ? $.trim('' + options.show.event).split(' ') : [], hideEvents = options.hide.event ? $.trim('' + options.hide.event).split(' ') : [];
            // Catch remove/removeqtip events on target element to destroy redundant tooltips
            this._bind(this.elements.target, [
                'remove',
                'removeqtip'
            ], function() {
                this.destroy(true);
            }, 'destroy');
            /*
       * Make sure hoverIntent functions properly by using mouseleave as a hide event if
       * mouseenter/mouseout is used for show.event, even if it isn't in the users options.
       */ if (/mouse(over|enter)/i.test(options.show.event) && !/mouse(out|leave)/i.test(options.hide.event)) hideEvents.push('mouseleave');
            /*
       * Also make sure initial mouse targetting works correctly by caching mousemove coords
       * on show targets before the tooltip has rendered. Also set onTarget when triggered to
       * keep mouse tracking working.
       */ this._bind(showTarget, 'mousemove', function(moveEvent) {
                this._storeMouse(moveEvent);
                this.cache.onTarget = TRUE;
            });
            // Define hoverIntent function
            function hoverIntent(hoverEvent) {
                // Only continue if tooltip isn't disabled
                if (this.disabled || this.destroyed) return FALSE;
                // Cache the event data
                this.cache.event = hoverEvent && $.event.fix(hoverEvent);
                this.cache.target = hoverEvent && $(hoverEvent.target);
                // Start the event sequence
                clearTimeout(this.timers.show);
                this.timers.show = delay.call(this, function() {
                    this.render(typeof hoverEvent === 'object' || options.show.ready);
                }, options.prerender ? 0 : options.show.delay);
            }
            // Filter and bind events
            this._bindEvents(showEvents, hideEvents, showTarget, hideTarget, hoverIntent, function() {
                if (!this.timers) return FALSE;
                clearTimeout(this.timers.show);
            });
            // Prerendering is enabled, create tooltip now
            if (options.show.ready || options.prerender) hoverIntent.call(this, event);
        };
        // Event assignment method
        PROTOTYPE._assignEvents = function() {
            var self = this, options = this.options, posOptions = options.position, tooltip = this.tooltip, showTarget = options.show.target, hideTarget = options.hide.target, containerTarget = posOptions.container, viewportTarget = posOptions.viewport, documentTarget = $(document1), windowTarget = $(window1), showEvents = options.show.event ? $.trim('' + options.show.event).split(' ') : [], hideEvents = options.hide.event ? $.trim('' + options.hide.event).split(' ') : [];
            // Assign passed event callbacks
            $.each(options.events, function(name, callback) {
                self._bind(tooltip, name === 'toggle' ? [
                    'tooltipshow',
                    'tooltiphide'
                ] : [
                    'tooltip' + name
                ], callback, null, tooltip);
            });
            // Hide tooltips when leaving current window/frame (but not select/option elements)
            if (/mouse(out|leave)/i.test(options.hide.event) && options.hide.leave === 'window') this._bind(documentTarget, [
                'mouseout',
                'blur'
            ], function(event) {
                if (!/select|option/.test(event.target.nodeName) && !event.relatedTarget) this.hide(event);
            });
            // Enable hide.fixed by adding appropriate class
            if (options.hide.fixed) hideTarget = hideTarget.add(tooltip.addClass(CLASS_FIXED));
            else if (/mouse(over|enter)/i.test(options.show.event)) this._bind(hideTarget, 'mouseleave', function() {
                clearTimeout(this.timers.show);
            });
            // Hide tooltip on document mousedown if unfocus events are enabled
            if (('' + options.hide.event).indexOf('unfocus') > -1) this._bind(containerTarget.closest('html'), [
                'mousedown',
                'touchstart'
            ], function(event) {
                var elem = $(event.target), enabled = this.rendered && !this.tooltip.hasClass(CLASS_DISABLED) && this.tooltip[0].offsetWidth > 0, isAncestor = elem.parents(SELECTOR).filter(this.tooltip[0]).length > 0;
                if (elem[0] !== this.target[0] && elem[0] !== this.tooltip[0] && !isAncestor && !this.target.has(elem[0]).length && enabled) this.hide(event);
            });
            // Check if the tooltip hides when inactive
            if ('number' === typeof options.hide.inactive) {
                // Bind inactive method to show target(s) as a custom event
                this._bind(showTarget, 'qtip-' + this.id + '-inactive', inactiveMethod, 'inactive');
                // Define events which reset the 'inactive' event handler
                this._bind(hideTarget.add(tooltip), QTIP.inactiveEvents, inactiveMethod);
            }
            // Filter and bind events
            this._bindEvents(showEvents, hideEvents, showTarget, hideTarget, showMethod, hideMethod);
            // Mouse movement bindings
            this._bind(showTarget.add(tooltip), 'mousemove', function(event) {
                // Check if the tooltip hides when mouse is moved a certain distance
                if ('number' === typeof options.hide.distance) {
                    var origin = this.cache.origin || {}, limit = this.options.hide.distance, abs = Math.abs;
                    // Check if the movement has gone beyond the limit, and hide it if so
                    if (abs(event.pageX - origin.pageX) >= limit || abs(event.pageY - origin.pageY) >= limit) this.hide(event);
                }
                // Cache mousemove coords on show targets
                this._storeMouse(event);
            });
            // Mouse positioning events
            if (posOptions.target === 'mouse') // If mouse adjustment is on...
            {
                if (posOptions.adjust.mouse) {
                    // Apply a mouseleave event so we don't get problems with overlapping
                    if (options.hide.event) // Track if we're on the target or not
                    this._bind(showTarget, [
                        'mouseenter',
                        'mouseleave'
                    ], function(event) {
                        if (!this.cache) return FALSE;
                        this.cache.onTarget = event.type === 'mouseenter';
                    });
                    // Update tooltip position on mousemove
                    this._bind(documentTarget, 'mousemove', function(event) {
                        // Update the tooltip position only if the tooltip is visible and adjustment is enabled
                        if (this.rendered && this.cache.onTarget && !this.tooltip.hasClass(CLASS_DISABLED) && this.tooltip[0].offsetWidth > 0) this.reposition(event);
                    });
                }
            }
            // Adjust positions of the tooltip on window resize if enabled
            if (posOptions.adjust.resize || viewportTarget.length) this._bind($.event.special.resize ? viewportTarget : windowTarget, 'resize', repositionMethod);
            // Adjust tooltip position on scroll of the window or viewport element if present
            if (posOptions.adjust.scroll) this._bind(windowTarget.add(posOptions.container), 'scroll', repositionMethod);
        };
        // Un-assignment method
        PROTOTYPE._unassignEvents = function() {
            var options = this.options, showTargets = options.show.target, hideTargets = options.hide.target, targets = $.grep([
                this.elements.target[0],
                this.rendered && this.tooltip[0],
                options.position.container[0],
                options.position.viewport[0],
                options.position.container.closest('html')[0],
                // unfocus
                window1,
                document1
            ], function(i) {
                return typeof i === 'object';
            });
            // Add show and hide targets if they're valid
            if (showTargets && showTargets.toArray) targets = targets.concat(showTargets.toArray());
            if (hideTargets && hideTargets.toArray) targets = targets.concat(hideTargets.toArray());
            // Unbind the events
            this._unbind(targets)._unbind(targets, 'destroy')._unbind(targets, 'inactive');
        };
        // Apply common event handlers using delegate (avoids excessive .bind calls!)
        $(function() {
            delegate(SELECTOR, [
                'mouseenter',
                'mouseleave'
            ], function(event) {
                var state = event.type === 'mouseenter', tooltip = $(event.currentTarget), target = $(event.relatedTarget || event.target), options = this.options;
                // On mouseenter...
                if (state) {
                    // Focus the tooltip on mouseenter (z-index stacking)
                    this.focus(event);
                    // Clear hide timer on tooltip hover to prevent it from closing
                    tooltip.hasClass(CLASS_FIXED) && !tooltip.hasClass(CLASS_DISABLED) && clearTimeout(this.timers.hide);
                } else // When mouse tracking is enabled, hide when we leave the tooltip and not onto the show target (if a hide event is set)
                if (options.position.target === 'mouse' && options.position.adjust.mouse && options.hide.event && options.show.target && !target.closest(options.show.target[0]).length) this.hide(event);
                // Add hover class
                tooltip.toggleClass(CLASS_HOVER, state);
            });
            // Define events which reset the 'inactive' event handler
            delegate('[' + ATTR_ID + ']', INACTIVE_EVENTS, inactiveMethod);
        });
        function init(elem, id, opts) {
            var obj, posOptions, attr, config, title, // Setup element references
            docBody = $(document1.body), // Use document body instead of document element if needed
            newTarget = elem[0] === document1 ? docBody : elem, // Grab metadata from element if plugin is present
            metadata = elem.metadata ? elem.metadata(opts.metadata) : NULL, // If metadata type if HTML5, grab 'name' from the object instead, or use the regular data object otherwise
            metadata5 = opts.metadata.type === 'html5' && metadata ? metadata[opts.metadata.name] : NULL, // Grab data from metadata.name (or data-qtipopts as fallback) using .data() method,
            html5 = elem.data(opts.metadata.name || 'qtipopts');
            // If we don't get an object returned attempt to parse it manualyl without parseJSON
            /* eslint-disable no-empty */ try {
                html5 = typeof html5 === 'string' ? $.parseJSON(html5) : html5;
            } catch (e) {}
            /* eslint-enable no-empty */ // Merge in and sanitize metadata
            config = $.extend(TRUE, {}, QTIP.defaults, opts, typeof html5 === 'object' ? sanitizeOptions(html5) : NULL, sanitizeOptions(metadata5 || metadata));
            // Re-grab our positioning options now we've merged our metadata and set id to passed value
            posOptions = config.position;
            config.id = id;
            // Setup missing content if none is detected
            if ('boolean' === typeof config.content.text) {
                attr = elem.attr(config.content.attr);
                // Grab from supplied attribute if available
                if (config.content.attr !== FALSE && attr) config.content.text = attr;
                else return FALSE;
            }
            // Setup target options
            if (!posOptions.container.length) posOptions.container = docBody;
            if (posOptions.target === FALSE) posOptions.target = newTarget;
            if (config.show.target === FALSE) config.show.target = newTarget;
            if (config.show.solo === TRUE) config.show.solo = posOptions.container.closest('body');
            if (config.hide.target === FALSE) config.hide.target = newTarget;
            if (config.position.viewport === TRUE) config.position.viewport = posOptions.container;
            // Ensure we only use a single container
            posOptions.container = posOptions.container.eq(0);
            // Convert position corner values into x and y strings
            posOptions.at = new CORNER(posOptions.at, TRUE);
            posOptions.my = new CORNER(posOptions.my);
            // Destroy previous tooltip if overwrite is enabled, or skip element if not
            if (elem.data(NAMESPACE)) {
                if (config.overwrite) elem.qtip('destroy', true);
                else if (config.overwrite === FALSE) return FALSE;
            }
            // Add has-qtip attribute
            elem.attr(ATTR_HAS, id);
            // Remove title attribute and store it if present
            if (config.suppress && (title = elem.attr('title'))) // Final attr call fixes event delegation and IE default tooltip showing problem
            elem.removeAttr('title').attr(oldtitle, title).attr('title', '');
            // Initialize the tooltip and add API reference
            obj = new QTip(elem, config, id, !!attr);
            elem.data(NAMESPACE, obj);
            return obj;
        }
        // jQuery $.fn extension method
        QTIP = $.fn.qtip = function(options, notation, newValue) {
            var command = ('' + options).toLowerCase(), // Parse command
            returned = NULL, args = $.makeArray(arguments).slice(1), event = args[args.length - 1], opts = this[0] ? $.data(this[0], NAMESPACE) : NULL;
            // Check for API request
            if (!arguments.length && opts || command === 'api') return opts;
            else if ('string' === typeof options) {
                this.each(function() {
                    var api = $.data(this, NAMESPACE);
                    if (!api) return TRUE;
                    // Cache the event if possible
                    if (event && event.timeStamp) api.cache.event = event;
                    // Check for specific API commands
                    if (notation && (command === 'option' || command === 'options')) {
                        if (newValue !== undefined$1 || $.isPlainObject(notation)) api.set(notation, newValue);
                        else {
                            returned = api.get(notation);
                            return FALSE;
                        }
                    } else if (api[command]) api[command].apply(api, args);
                });
                return returned !== NULL ? returned : this;
            } else if ('object' === typeof options || !arguments.length) {
                // Sanitize options first
                opts = sanitizeOptions($.extend(TRUE, {}, options));
                return this.each(function(i) {
                    var api, id;
                    // Find next available ID, or use custom ID if provided
                    id = $.isArray(opts.id) ? opts.id[i] : opts.id;
                    id = !id || id === FALSE || id.length < 1 || QTIP.api[id] ? QTIP.nextid++ : id;
                    // Initialize the qTip and re-grab newly sanitized options
                    api = init($(this), id, opts);
                    if (api === FALSE) return TRUE;
                    else QTIP.api[id] = api;
                    // Initialize plugins
                    $.each(PLUGINS, function() {
                        if (this.initialize === 'initialize') this(api);
                    });
                    // Assign initial pre-render events
                    api._assignInitialEvents(event);
                });
            }
        };
        // Expose class
        $.qtip = QTip;
        // Populated in render method
        QTIP.api = {};
        $.each({
            /* Allow other plugins to successfully retrieve the title of an element with a qTip applied */ attr: function(attr, val) {
                if (this.length) {
                    var self = this[0], title = 'title', api = $.data(self, 'qtip');
                    if (attr === title && api && api.options && 'object' === typeof api && 'object' === typeof api.options && api.options.suppress) {
                        if (arguments.length < 2) return $.attr(self, oldtitle);
                        // If qTip is rendered and title was originally used as content, update it
                        if (api && api.options.content.attr === title && api.cache.attr) api.set('content.text', val);
                        // Use the regular attr method to set, then cache the result
                        return this.attr(oldtitle, val);
                    }
                }
                return $.fn['attr' + replaceSuffix].apply(this, arguments);
            },
            /* Allow clone to correctly retrieve cached title attributes */ clone: function(keepData) {
                // Clone our element using the real clone method
                var elems = $.fn['clone' + replaceSuffix].apply(this, arguments);
                // Grab all elements with an oldtitle set, and change it to regular title attribute, if keepData is false
                if (!keepData) elems.filter('[' + oldtitle + ']').attr('title', function() {
                    return $.attr(this, oldtitle);
                }).removeAttr(oldtitle);
                return elems;
            }
        }, function(name, func) {
            if (!func || $.fn[name + replaceSuffix]) return TRUE;
            var old = $.fn[name + replaceSuffix] = $.fn[name];
            $.fn[name] = function() {
                return func.apply(this, arguments) || old.apply(this, arguments);
            };
        });
        /* Fire off 'removeqtip' handler in $.cleanData if jQuery UI not present (it already does similar).
     * This snippet is taken directly from jQuery UI source code found here:
     *     http://code.jquery.com/ui/jquery-ui-git.js
     */ if (!$.ui) {
            $['cleanData' + replaceSuffix] = $.cleanData;
            $.cleanData = function(elems) {
                for(var i = 0, elem; (elem = $(elems[i])).length; i++){
                    if (elem.attr(ATTR_HAS)) /* eslint-disable no-empty */ try {
                        elem.triggerHandler('removeqtip');
                    } catch (e) {}
                }
                $['cleanData' + replaceSuffix].apply(this, arguments);
            };
        }
        QTIP.version = '3.0.3-5-g';
        // Base ID for all qTips
        QTIP.nextid = 0;
        // Inactive events array
        QTIP.inactiveEvents = INACTIVE_EVENTS;
        // Base z-index for all qTips
        QTIP.zindex = 15000;
        // Define configuration defaults
        QTIP.defaults = {
            prerender: FALSE,
            id: FALSE,
            overwrite: TRUE,
            suppress: TRUE,
            content: {
                text: TRUE,
                attr: 'title',
                title: FALSE,
                button: FALSE
            },
            position: {
                my: 'top left',
                at: 'bottom right',
                target: FALSE,
                container: FALSE,
                viewport: FALSE,
                adjust: {
                    x: 0,
                    y: 0,
                    mouse: TRUE,
                    scroll: TRUE,
                    resize: TRUE,
                    method: 'flipinvert flipinvert'
                },
                effect: function(api, pos) {
                    $(this).animate(pos, {
                        duration: 200,
                        queue: FALSE
                    });
                }
            },
            show: {
                target: FALSE,
                event: 'mouseenter',
                effect: TRUE,
                delay: 90,
                solo: FALSE,
                ready: FALSE,
                autofocus: FALSE
            },
            hide: {
                target: FALSE,
                event: 'mouseleave',
                effect: TRUE,
                delay: 0,
                fixed: FALSE,
                inactive: FALSE,
                leave: 'window',
                distance: FALSE
            },
            style: {
                classes: '',
                widget: FALSE,
                width: FALSE,
                height: FALSE,
                def: TRUE
            },
            events: {
                render: NULL,
                move: NULL,
                show: NULL,
                hide: NULL,
                toggle: NULL,
                visible: NULL,
                hidden: NULL,
                focus: NULL,
                blur: NULL
            }
        };
        var TIP, createVML, SCALE, PIXEL_RATIO, BACKING_STORE_RATIO, // Common CSS strings
        MARGIN = 'margin', BORDER = 'border', COLOR = 'color', BG_COLOR = 'background-color', TRANSPARENT = 'transparent', IMPORTANT = ' !important', // Check if the browser supports <canvas/> elements
        HASCANVAS = !!document1.createElement('canvas').getContext, // Invalid colour values used in parseColours()
        INVALID = /rgba?\(0, 0, 0(, 0)?\)|transparent|#123456/i;
        // Camel-case method, taken from jQuery source
        // http://code.jquery.com/jquery-1.8.0.js
        function camel(s) {
            return s.charAt(0).toUpperCase() + s.slice(1);
        }
        /*
     * Modified from Modernizr's testPropsAll()
     * http://modernizr.com/downloads/modernizr-latest.js
     */ var cssProps = {}, cssPrefixes = [
            'Webkit',
            'O',
            'Moz',
            'ms'
        ];
        function vendorCss(elem, prop) {
            var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1), props = (prop + ' ' + cssPrefixes.join(ucProp + ' ') + ucProp).split(' '), cur, val, i = 0;
            // If the property has already been mapped...
            if (cssProps[prop]) return elem.css(cssProps[prop]);
            while(cur = props[i++])if ((val = elem.css(cur)) !== undefined$1) {
                cssProps[prop] = cur;
                return val;
            }
        }
        // Parse a given elements CSS property into an int
        function intCss(elem, prop) {
            return Math.ceil(parseFloat(vendorCss(elem, prop)));
        }
        // VML creation (for IE only)
        if (!HASCANVAS) createVML = function(tag, props, style) {
            return '<qtipvml:' + tag + ' xmlns="urn:schemas-microsoft.com:vml" class="qtip-vml" ' + (props || '') + ' style="behavior: url(#default#VML); ' + (style || '') + '" />';
        };
        else {
            PIXEL_RATIO = window1.devicePixelRatio || 1;
            BACKING_STORE_RATIO = function() {
                var context = document1.createElement('canvas').getContext('2d');
                return context.backingStorePixelRatio || context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || 1;
            }();
            SCALE = PIXEL_RATIO / BACKING_STORE_RATIO;
        }
        function Tip(qtip, options) {
            this._ns = 'tip';
            this.options = options;
            this.offset = options.offset;
            this.size = [
                options.width,
                options.height
            ];
            // Initialize
            this.qtip = qtip;
            this.init(qtip);
        }
        $.extend(Tip.prototype, {
            init: function(qtip) {
                var context, tip;
                // Create tip element and prepend to the tooltip
                tip = this.element = qtip.elements.tip = $('<div />', {
                    'class': NAMESPACE + '-tip'
                }).prependTo(qtip.tooltip);
                // Create tip drawing element(s)
                if (HASCANVAS) {
                    // save() as soon as we create the canvas element so FF2 doesn't bork on our first restore()!
                    context = $('<canvas />').appendTo(this.element)[0].getContext('2d');
                    // Setup constant parameters
                    context.lineJoin = 'miter';
                    context.miterLimit = 100000;
                    context.save();
                } else {
                    context = createVML('shape', 'coordorigin="0,0"', 'position:absolute;');
                    this.element.html(context + context);
                    // Prevent mousing down on the tip since it causes problems with .live() handling in IE due to VML
                    qtip._bind($('*', tip).add(tip), [
                        'click',
                        'mousedown'
                    ], function(event) {
                        event.stopPropagation();
                    }, this._ns);
                }
                // Bind update events
                qtip._bind(qtip.tooltip, 'tooltipmove', this.reposition, this._ns, this);
                // Create it
                this.create();
            },
            _swapDimensions: function() {
                this.size[0] = this.options.height;
                this.size[1] = this.options.width;
            },
            _resetDimensions: function() {
                this.size[0] = this.options.width;
                this.size[1] = this.options.height;
            },
            _useTitle: function(corner) {
                var titlebar = this.qtip.elements.titlebar;
                return titlebar && (corner.y === TOP || corner.y === CENTER && this.element.position().top + this.size[1] / 2 + this.options.offset < titlebar.outerHeight(TRUE));
            },
            _parseCorner: function(corner) {
                var my = this.qtip.options.position.my;
                // Detect corner and mimic properties
                if (corner === FALSE || my === FALSE) corner = FALSE;
                else if (corner === TRUE) corner = new CORNER(my.string());
                else if (!corner.string) {
                    corner = new CORNER(corner);
                    corner.fixed = TRUE;
                }
                return corner;
            },
            _parseWidth: function(corner, side, use) {
                var elements = this.qtip.elements, prop = BORDER + camel(side) + 'Width';
                return (use ? intCss(use, prop) : intCss(elements.content, prop) || intCss(this._useTitle(corner) && elements.titlebar || elements.content, prop) || intCss(elements.tooltip, prop)) || 0;
            },
            _parseRadius: function(corner) {
                var elements = this.qtip.elements, prop = BORDER + camel(corner.y) + camel(corner.x) + 'Radius';
                return BROWSER.ie < 9 ? 0 : intCss(this._useTitle(corner) && elements.titlebar || elements.content, prop) || intCss(elements.tooltip, prop) || 0;
            },
            _invalidColour: function(elem, prop, compare) {
                var val = elem.css(prop);
                return !val || compare && val === elem.css(compare) || INVALID.test(val) ? FALSE : val;
            },
            _parseColours: function(corner) {
                var elements = this.qtip.elements, tip = this.element.css('cssText', ''), borderSide = BORDER + camel(corner[corner.precedance]) + camel(COLOR), colorElem = this._useTitle(corner) && elements.titlebar || elements.content, css = this._invalidColour, color = [];
                // Attempt to detect the background colour from various elements, left-to-right precedance
                color[0] = css(tip, BG_COLOR) || css(colorElem, BG_COLOR) || css(elements.content, BG_COLOR) || css(elements.tooltip, BG_COLOR) || tip.css(BG_COLOR);
                // Attempt to detect the correct border side colour from various elements, left-to-right precedance
                color[1] = css(tip, borderSide, COLOR) || css(colorElem, borderSide, COLOR) || css(elements.content, borderSide, COLOR) || css(elements.tooltip, borderSide, COLOR) || elements.tooltip.css(borderSide);
                // Reset background and border colours
                $('*', tip).add(tip).css('cssText', BG_COLOR + ':' + TRANSPARENT + IMPORTANT + ';' + BORDER + ':0' + IMPORTANT + ';');
                return color;
            },
            _calculateSize: function(corner) {
                var y = corner.precedance === Y, width = this.options.width, height = this.options.height, isCenter = corner.abbrev() === 'c', base = (y ? width : height) * (isCenter ? 0.5 : 1), pow = Math.pow, round = Math.round, bigHyp, ratio, result, smallHyp = Math.sqrt(pow(base, 2) + pow(height, 2)), hyp = [
                    this.border / base * smallHyp,
                    this.border / height * smallHyp
                ];
                hyp[2] = Math.sqrt(pow(hyp[0], 2) - pow(this.border, 2));
                hyp[3] = Math.sqrt(pow(hyp[1], 2) - pow(this.border, 2));
                bigHyp = smallHyp + hyp[2] + hyp[3] + (isCenter ? 0 : hyp[0]);
                ratio = bigHyp / smallHyp;
                result = [
                    round(ratio * width),
                    round(ratio * height)
                ];
                return y ? result : result.reverse();
            },
            // Tip coordinates calculator
            _calculateTip: function(corner, size, scale) {
                scale = scale || 1;
                size = size || this.size;
                var width = size[0] * scale, height = size[1] * scale, width2 = Math.ceil(width / 2), height2 = Math.ceil(height / 2), // Define tip coordinates in terms of height and width values
                tips = {
                    br: [
                        0,
                        0,
                        width,
                        height,
                        width,
                        0
                    ],
                    bl: [
                        0,
                        0,
                        width,
                        0,
                        0,
                        height
                    ],
                    tr: [
                        0,
                        height,
                        width,
                        0,
                        width,
                        height
                    ],
                    tl: [
                        0,
                        0,
                        0,
                        height,
                        width,
                        height
                    ],
                    tc: [
                        0,
                        height,
                        width2,
                        0,
                        width,
                        height
                    ],
                    bc: [
                        0,
                        0,
                        width,
                        0,
                        width2,
                        height
                    ],
                    rc: [
                        0,
                        0,
                        width,
                        height2,
                        0,
                        height
                    ],
                    lc: [
                        width,
                        0,
                        width,
                        height,
                        0,
                        height2
                    ]
                };
                // Set common side shapes
                tips.lt = tips.br;
                tips.rt = tips.bl;
                tips.lb = tips.tr;
                tips.rb = tips.tl;
                return tips[corner.abbrev()];
            },
            // Tip coordinates drawer (canvas)
            _drawCoords: function(context, coords) {
                context.beginPath();
                context.moveTo(coords[0], coords[1]);
                context.lineTo(coords[2], coords[3]);
                context.lineTo(coords[4], coords[5]);
                context.closePath();
            },
            create: function() {
                // Determine tip corner
                var c = this.corner = (HASCANVAS || BROWSER.ie) && this._parseCorner(this.options.corner);
                // If we have a tip corner...
                this.enabled = !!this.corner && this.corner.abbrev() !== 'c';
                if (this.enabled) {
                    // Cache it
                    this.qtip.cache.corner = c.clone();
                    // Create it
                    this.update();
                }
                // Toggle tip element
                this.element.toggle(this.enabled);
                return this.corner;
            },
            update: function(corner, position) {
                if (!this.enabled) return this;
                var elements = this.qtip.elements, tip = this.element, inner = tip.children(), options = this.options, curSize = this.size, mimic = options.mimic, round = Math.round, color, precedance, context, coords, bigCoords, translate, newSize, border;
                // Re-determine tip if not already set
                if (!corner) corner = this.qtip.cache.corner || this.corner;
                // Use corner property if we detect an invalid mimic value
                if (mimic === FALSE) mimic = corner;
                else {
                    mimic = new CORNER(mimic);
                    mimic.precedance = corner.precedance;
                    if (mimic.x === 'inherit') mimic.x = corner.x;
                    else if (mimic.y === 'inherit') mimic.y = corner.y;
                    else if (mimic.x === mimic.y) mimic[corner.precedance] = corner[corner.precedance];
                }
                precedance = mimic.precedance;
                // Ensure the tip width.height are relative to the tip position
                if (corner.precedance === X) this._swapDimensions();
                else this._resetDimensions();
                // Update our colours
                color = this.color = this._parseColours(corner);
                // Detect border width, taking into account colours
                if (color[1] !== TRANSPARENT) {
                    // Grab border width
                    border = this.border = this._parseWidth(corner, corner[corner.precedance]);
                    // If border width isn't zero, use border color as fill if it's not invalid (1.0 style tips)
                    if (options.border && border < 1 && !INVALID.test(color[1])) color[0] = color[1];
                    // Set border width (use detected border width if options.border is true)
                    this.border = border = options.border !== TRUE ? options.border : border;
                } else this.border = border = 0;
                // Determine tip size
                newSize = this.size = this._calculateSize(corner);
                tip.css({
                    width: newSize[0],
                    height: newSize[1],
                    lineHeight: newSize[1] + 'px'
                });
                // Calculate tip translation
                if (corner.precedance === Y) translate = [
                    round(mimic.x === LEFT ? border : mimic.x === RIGHT ? newSize[0] - curSize[0] - border : (newSize[0] - curSize[0]) / 2),
                    round(mimic.y === TOP ? newSize[1] - curSize[1] : 0)
                ];
                else translate = [
                    round(mimic.x === LEFT ? newSize[0] - curSize[0] : 0),
                    round(mimic.y === TOP ? border : mimic.y === BOTTOM ? newSize[1] - curSize[1] - border : (newSize[1] - curSize[1]) / 2)
                ];
                // Canvas drawing implementation
                if (HASCANVAS) {
                    // Grab canvas context and clear/save it
                    context = inner[0].getContext('2d');
                    context.restore();
                    context.save();
                    context.clearRect(0, 0, 6000, 6000);
                    // Calculate coordinates
                    coords = this._calculateTip(mimic, curSize, SCALE);
                    bigCoords = this._calculateTip(mimic, this.size, SCALE);
                    // Set the canvas size using calculated size
                    inner.attr(WIDTH, newSize[0] * SCALE).attr(HEIGHT, newSize[1] * SCALE);
                    inner.css(WIDTH, newSize[0]).css(HEIGHT, newSize[1]);
                    // Draw the outer-stroke tip
                    this._drawCoords(context, bigCoords);
                    context.fillStyle = color[1];
                    context.fill();
                    // Draw the actual tip
                    context.translate(translate[0] * SCALE, translate[1] * SCALE);
                    this._drawCoords(context, coords);
                    context.fillStyle = color[0];
                    context.fill();
                } else {
                    // Calculate coordinates
                    coords = this._calculateTip(mimic);
                    // Setup coordinates string
                    coords = 'm' + coords[0] + ',' + coords[1] + ' l' + coords[2] + ',' + coords[3] + ' ' + coords[4] + ',' + coords[5] + ' xe';
                    // Setup VML-specific offset for pixel-perfection
                    translate[2] = border && /^(r|b)/i.test(corner.string()) ? BROWSER.ie === 8 ? 2 : 1 : 0;
                    // Set initial CSS
                    inner.css({
                        coordsize: newSize[0] + border + ' ' + newSize[1] + border,
                        antialias: '' + (mimic.string().indexOf(CENTER) > -1),
                        left: translate[0] - translate[2] * Number(precedance === X),
                        top: translate[1] - translate[2] * Number(precedance === Y),
                        width: newSize[0] + border,
                        height: newSize[1] + border
                    }).each(function(i) {
                        var $this = $(this);
                        // Set shape specific attributes
                        $this[$this.prop ? 'prop' : 'attr']({
                            coordsize: newSize[0] + border + ' ' + newSize[1] + border,
                            path: coords,
                            fillcolor: color[0],
                            filled: !!i,
                            stroked: !i
                        }).toggle(!!(border || i));
                        // Check if border is enabled and add stroke element
                        !i && $this.html(createVML('stroke', 'weight="' + border * 2 + 'px" color="' + color[1] + '" miterlimit="1000" joinstyle="miter"'));
                    });
                }
                // Opera bug #357 - Incorrect tip position
                // https://github.com/Craga89/qTip2/issues/367
                window1.opera && setTimeout(function() {
                    elements.tip.css({
                        display: 'inline-block',
                        visibility: 'visible'
                    });
                }, 1);
                // Position if needed
                if (position !== FALSE) this.calculate(corner, newSize);
            },
            calculate: function(corner, size) {
                if (!this.enabled) return FALSE;
                var self = this, elements = this.qtip.elements, tip = this.element, userOffset = this.options.offset, position = {}, precedance, corners;
                // Inherit corner if not provided
                corner = corner || this.corner;
                precedance = corner.precedance;
                // Determine which tip dimension to use for adjustment
                size = size || this._calculateSize(corner);
                // Setup corners and offset array
                corners = [
                    corner.x,
                    corner.y
                ];
                if (precedance === X) corners.reverse();
                // Calculate tip position
                $.each(corners, function(i, side) {
                    var b, bc, br;
                    if (side === CENTER) {
                        b = precedance === Y ? LEFT : TOP;
                        position[b] = '50%';
                        position[MARGIN + '-' + b] = -Math.round(size[precedance === Y ? 0 : 1] / 2) + userOffset;
                    } else {
                        b = self._parseWidth(corner, side, elements.tooltip);
                        bc = self._parseWidth(corner, side, elements.content);
                        br = self._parseRadius(corner);
                        position[side] = Math.max(-self.border, i ? bc : userOffset + (br > b ? br : -b));
                    }
                });
                // Adjust for tip size
                position[corner[precedance]] -= size[precedance === X ? 0 : 1];
                // Set and return new position
                tip.css({
                    margin: '',
                    top: '',
                    bottom: '',
                    left: '',
                    right: ''
                }).css(position);
                return position;
            },
            reposition: function(event, api, pos) {
                if (!this.enabled) return;
                var cache = api.cache, newCorner = this.corner.clone(), adjust = pos.adjusted, method = api.options.position.adjust.method.split(' '), horizontal = method[0], vertical = method[1] || method[0], shift = {
                    left: FALSE,
                    top: FALSE,
                    x: 0,
                    y: 0
                }, offset, css = {}, props;
                function shiftflip(direction, precedance, popposite, side, opposite) {
                    // Horizontal - Shift or flip method
                    if (direction === SHIFT && newCorner.precedance === precedance && adjust[side] && newCorner[popposite] !== CENTER) newCorner.precedance = newCorner.precedance === X ? Y : X;
                    else if (direction !== SHIFT && adjust[side]) newCorner[precedance] = newCorner[precedance] === CENTER ? adjust[side] > 0 ? side : opposite : newCorner[precedance] === side ? opposite : side;
                }
                function shiftonly(xy, side, opposite) {
                    if (newCorner[xy] === CENTER) css[MARGIN + '-' + side] = shift[xy] = offset[MARGIN + '-' + side] - adjust[side];
                    else {
                        props = offset[opposite] !== undefined$1 ? [
                            adjust[side],
                            -offset[side]
                        ] : [
                            -adjust[side],
                            offset[side]
                        ];
                        if ((shift[xy] = Math.max(props[0], props[1])) > props[0]) {
                            pos[side] -= adjust[side];
                            shift[side] = FALSE;
                        }
                        css[offset[opposite] !== undefined$1 ? opposite : side] = shift[xy];
                    }
                }
                // If our tip position isn't fixed e.g. doesn't adjust with viewport...
                if (this.corner.fixed !== TRUE) {
                    // Perform shift/flip adjustments
                    shiftflip(horizontal, X, Y, LEFT, RIGHT);
                    shiftflip(vertical, Y, X, TOP, BOTTOM);
                    // Update and redraw the tip if needed (check cached details of last drawn tip)
                    if (newCorner.string() !== cache.corner.string() || cache.cornerTop !== adjust.top || cache.cornerLeft !== adjust.left) this.update(newCorner, FALSE);
                }
                // Setup tip offset properties
                offset = this.calculate(newCorner);
                // Readjust offset object to make it left/top
                if (offset.right !== undefined$1) offset.left = -offset.right;
                if (offset.bottom !== undefined$1) offset.top = -offset.bottom;
                offset.user = this.offset;
                // Perform shift adjustments
                shift.left = horizontal === SHIFT && !!adjust.left;
                if (shift.left) shiftonly(X, LEFT, RIGHT);
                shift.top = vertical === SHIFT && !!adjust.top;
                if (shift.top) shiftonly(Y, TOP, BOTTOM);
                /*
        * If the tip is adjusted in both dimensions, or in a
        * direction that would cause it to be anywhere but the
        * outer border, hide it!
        */ this.element.css(css).toggle(!(shift.x && shift.y || newCorner.x === CENTER && shift.y || newCorner.y === CENTER && shift.x));
                // Adjust position to accomodate tip dimensions
                pos.left -= offset.left.charAt ? offset.user : horizontal !== SHIFT || shift.top || !shift.left && !shift.top ? offset.left + this.border : 0;
                pos.top -= offset.top.charAt ? offset.user : vertical !== SHIFT || shift.left || !shift.left && !shift.top ? offset.top + this.border : 0;
                // Cache details
                cache.cornerLeft = adjust.left;
                cache.cornerTop = adjust.top;
                cache.corner = newCorner.clone();
            },
            destroy: function() {
                // Unbind events
                this.qtip._unbind(this.qtip.tooltip, this._ns);
                // Remove the tip element(s)
                if (this.qtip.elements.tip) this.qtip.elements.tip.find('*').remove().end().remove();
            }
        });
        TIP = PLUGINS.tip = function(api) {
            return new Tip(api, api.options.style.tip);
        };
        // Initialize tip on render
        TIP.initialize = 'render';
        // Setup plugin sanitization options
        TIP.sanitize = function(options) {
            if (options.style && 'tip' in options.style) {
                var opts = options.style.tip;
                if (typeof opts !== 'object') opts = options.style.tip = {
                    corner: opts
                };
                if (!/string|boolean/i.test(typeof opts.corner)) opts.corner = TRUE;
            }
        };
        // Add new option checks for the plugin
        CHECKS.tip = {
            '^position.my|style.tip.(corner|mimic|border)$': function() {
                // Make sure a tip can be drawn
                this.create();
                // Reposition the tooltip
                this.qtip.reposition();
            },
            '^style.tip.(height|width)$': function(obj) {
                // Re-set dimensions and redraw the tip
                this.size = [
                    obj.width,
                    obj.height
                ];
                this.update();
                // Reposition the tooltip
                this.qtip.reposition();
            },
            '^content.title|style.(classes|widget)$': function() {
                this.update();
            }
        };
        // Extend original qTip defaults
        $.extend(TRUE, QTIP.defaults, {
            style: {
                tip: {
                    corner: TRUE,
                    mimic: FALSE,
                    width: 6,
                    height: 6,
                    border: TRUE,
                    offset: 0
                }
            }
        });
        var MODAL, OVERLAY, MODALCLASS = 'qtip-modal', MODALSELECTOR = '.' + MODALCLASS;
        OVERLAY = function() {
            var self = this, focusableElems = {}, current, prevState, elem;
            // Modified code from jQuery UI 1.10.0 source
            // http://code.jquery.com/ui/1.10.0/jquery-ui.js
            function focusable(element) {
                // Use the defined focusable checker when possible
                if ($.expr[':'].focusable) return $.expr[':'].focusable;
                var isTabIndexNotNaN = !isNaN($.attr(element, 'tabindex')), nodeName = element.nodeName && element.nodeName.toLowerCase(), map, mapName, img;
                if ('area' === nodeName) {
                    map = element.parentNode;
                    mapName = map.name;
                    if (!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') return false;
                    img = $('img[usemap=#' + mapName + ']')[0];
                    return !!img && img.is(':visible');
                }
                return /input|select|textarea|button|object/.test(nodeName) ? !element.disabled : 'a' === nodeName ? element.href || isTabIndexNotNaN : isTabIndexNotNaN;
            }
            // Focus inputs using cached focusable elements (see update())
            function focusInputs(blurElems) {
                // Blurring body element in IE causes window.open windows to unfocus!
                if (focusableElems.length < 1 && blurElems.length) blurElems.not('body').blur();
                else focusableElems.first().focus();
            }
            // Steal focus from elements outside tooltip
            function stealFocus(event) {
                if (!elem.is(':visible')) return;
                var target = $(event.target), tooltip = current.tooltip, container = target.closest(SELECTOR), targetOnTop;
                // Determine if input container target is above this
                targetOnTop = container.length < 1 ? FALSE : parseInt(container[0].style.zIndex, 10) > parseInt(tooltip[0].style.zIndex, 10);
                // If we're showing a modal, but focus has landed on an input below
                // this modal, divert focus to the first visible input in this modal
                // or if we can't find one... the tooltip itself
                if (!targetOnTop && target.closest(SELECTOR)[0] !== tooltip[0]) focusInputs(target);
            }
            $.extend(self, {
                init: function() {
                    // Create document overlay
                    elem = self.elem = $('<div />', {
                        id: 'qtip-overlay',
                        html: '<div></div>',
                        mousedown: function() {
                            return FALSE;
                        }
                    }).hide();
                    // Make sure we can't focus anything outside the tooltip
                    $(document1.body).bind('focusin' + MODALSELECTOR, stealFocus);
                    // Apply keyboard "Escape key" close handler
                    $(document1).bind('keydown' + MODALSELECTOR, function(event) {
                        if (current && current.options.show.modal.escape && event.keyCode === 27) current.hide(event);
                    });
                    // Apply click handler for blur option
                    elem.bind('click' + MODALSELECTOR, function(event) {
                        if (current && current.options.show.modal.blur) current.hide(event);
                    });
                    return self;
                },
                update: function(api) {
                    // Update current API reference
                    current = api;
                    // Update focusable elements if enabled
                    if (api.options.show.modal.stealfocus !== FALSE) focusableElems = api.tooltip.find('*').filter(function() {
                        return focusable(this);
                    });
                    else focusableElems = [];
                },
                toggle: function(api, state, duration) {
                    var tooltip = api.tooltip, options = api.options.show.modal, effect = options.effect, type = state ? 'show' : 'hide', visible = elem.is(':visible'), visibleModals = $(MODALSELECTOR).filter(':visible:not(:animated)').not(tooltip);
                    // Set active tooltip API reference
                    self.update(api);
                    // If the modal can steal the focus...
                    // Blur the current item and focus anything in the modal we an
                    if (state && options.stealfocus !== FALSE) focusInputs($(':focus'));
                    // Toggle backdrop cursor style on show
                    elem.toggleClass('blurs', options.blur);
                    // Append to body on show
                    if (state) elem.appendTo(document1.body);
                    // Prevent modal from conflicting with show.solo, and don't hide backdrop is other modals are visible
                    if (elem.is(':animated') && visible === state && prevState !== FALSE || !state && visibleModals.length) return self;
                    // Stop all animations
                    elem.stop(TRUE, FALSE);
                    // Use custom function if provided
                    if ($.isFunction(effect)) effect.call(elem, state);
                    else if (effect === FALSE) elem[type]();
                    else elem.fadeTo(parseInt(duration, 10) || 90, state ? 1 : 0, function() {
                        if (!state) elem.hide();
                    });
                    // Reset position and detach from body on hide
                    if (!state) elem.queue(function(next) {
                        elem.css({
                            left: '',
                            top: ''
                        });
                        if (!$(MODALSELECTOR).length) elem.detach();
                        next();
                    });
                    // Cache the state
                    prevState = state;
                    // If the tooltip is destroyed, set reference to null
                    if (current.destroyed) current = NULL;
                    return self;
                }
            });
            self.init();
        };
        OVERLAY = new OVERLAY();
        function Modal(api, options) {
            this.options = options;
            this._ns = '-modal';
            this.qtip = api;
            this.init(api);
        }
        $.extend(Modal.prototype, {
            init: function(qtip) {
                var tooltip = qtip.tooltip;
                // If modal is disabled... return
                if (!this.options.on) return this;
                // Set overlay reference
                qtip.elements.overlay = OVERLAY.elem;
                // Add unique attribute so we can grab modal tooltips easily via a SELECTOR, and set z-index
                tooltip.addClass(MODALCLASS).css('z-index', QTIP.modal_zindex + $(MODALSELECTOR).length);
                // Apply our show/hide/focus modal events
                qtip._bind(tooltip, [
                    'tooltipshow',
                    'tooltiphide'
                ], function(event, api, duration) {
                    var oEvent = event.originalEvent;
                    // Make sure mouseout doesn't trigger a hide when showing the modal and mousing onto backdrop
                    if (event.target === tooltip[0]) {
                        if (oEvent && event.type === 'tooltiphide' && /mouse(leave|enter)/.test(oEvent.type) && $(oEvent.relatedTarget).closest(OVERLAY.elem[0]).length) /* eslint-disable no-empty */ try {
                            event.preventDefault();
                        } catch (e) {}
                        else if (!oEvent || oEvent && oEvent.type !== 'tooltipsolo') this.toggle(event, event.type === 'tooltipshow', duration);
                    }
                }, this._ns, this);
                // Adjust modal z-index on tooltip focus
                qtip._bind(tooltip, 'tooltipfocus', function(event, api) {
                    // If focus was cancelled before it reached us, don't do anything
                    if (event.isDefaultPrevented() || event.target !== tooltip[0]) return;
                    var qtips = $(MODALSELECTOR), // Keep the modal's lower than other, regular qtips
                    newIndex = QTIP.modal_zindex + qtips.length, curIndex = parseInt(tooltip[0].style.zIndex, 10);
                    // Set overlay z-index
                    OVERLAY.elem[0].style.zIndex = newIndex - 1;
                    // Reduce modal z-index's and keep them properly ordered
                    qtips.each(function() {
                        if (this.style.zIndex > curIndex) this.style.zIndex -= 1;
                    });
                    // Fire blur event for focused tooltip
                    qtips.filter('.' + CLASS_FOCUS).qtip('blur', event.originalEvent);
                    // Set the new z-index
                    tooltip.addClass(CLASS_FOCUS)[0].style.zIndex = newIndex;
                    // Set current
                    OVERLAY.update(api);
                    // Prevent default handling
                    /* eslint-disable no-empty */ try {
                        event.preventDefault();
                    } catch (e) {}
                /* eslint-enable no-empty */ }, this._ns, this);
                // Focus any other visible modals when this one hides
                qtip._bind(tooltip, 'tooltiphide', function(event) {
                    if (event.target === tooltip[0]) $(MODALSELECTOR).filter(':visible').not(tooltip).last().qtip('focus', event);
                }, this._ns, this);
            },
            toggle: function(event, state, duration) {
                // Make sure default event hasn't been prevented
                if (event && event.isDefaultPrevented()) return this;
                // Toggle it
                OVERLAY.toggle(this.qtip, !!state, duration);
            },
            destroy: function() {
                // Remove modal class
                this.qtip.tooltip.removeClass(MODALCLASS);
                // Remove bound events
                this.qtip._unbind(this.qtip.tooltip, this._ns);
                // Delete element reference
                OVERLAY.toggle(this.qtip, FALSE);
                delete this.qtip.elements.overlay;
            }
        });
        MODAL = PLUGINS.modal = function(api) {
            return new Modal(api, api.options.show.modal);
        };
        // Setup sanitiztion rules
        MODAL.sanitize = function(opts) {
            if (opts.show) {
                if (typeof opts.show.modal !== 'object') opts.show.modal = {
                    on: !!opts.show.modal
                };
                else if (typeof opts.show.modal.on === 'undefined') opts.show.modal.on = TRUE;
            }
        };
        // Base z-index for all modal tooltips (use qTip core z-index as a base)
        /* eslint-disable camelcase */ QTIP.modal_zindex = QTIP.zindex - 200;
        /* eslint-enable camelcase */ // Plugin needs to be initialized on render
        MODAL.initialize = 'render';
        // Setup option set checks
        CHECKS.modal = {
            '^show.modal.(on|blur)$': function() {
                // Initialise
                this.destroy();
                this.init();
                // Show the modal if not visible already and tooltip is visible
                this.qtip.elems.overlay.toggle(this.qtip.tooltip[0].offsetWidth > 0);
            }
        };
        // Extend original api defaults
        $.extend(TRUE, QTIP.defaults, {
            show: {
                modal: {
                    on: FALSE,
                    effect: TRUE,
                    blur: TRUE,
                    stealfocus: TRUE,
                    escape: TRUE
                }
            }
        });
        PLUGINS.viewport = function(api, position, posOptions, targetWidth, targetHeight, elemWidth, elemHeight) {
            var target = posOptions.target, tooltip = api.elements.tooltip, my = posOptions.my, at = posOptions.at, adjust = posOptions.adjust, method = adjust.method.split(' '), methodX = method[0], methodY = method[1] || method[0], viewport = posOptions.viewport, container = posOptions.container, adjusted = {
                left: 0,
                top: 0
            }, fixed, newMy, containerOffset, containerStatic, viewportWidth, viewportHeight, viewportScroll, viewportOffset;
            // If viewport is not a jQuery element, or it's the window/document, or no adjustment method is used... return
            if (!viewport.jquery || target[0] === window1 || target[0] === document1.body || adjust.method === 'none') return adjusted;
            // Cach container details
            containerOffset = container.offset() || adjusted;
            containerStatic = container.css('position') === 'static';
            // Cache our viewport details
            fixed = tooltip.css('position') === 'fixed';
            viewportWidth = viewport[0] === window1 ? viewport.width() : viewport.outerWidth(FALSE);
            viewportHeight = viewport[0] === window1 ? viewport.height() : viewport.outerHeight(FALSE);
            viewportScroll = {
                left: fixed ? 0 : viewport.scrollLeft(),
                top: fixed ? 0 : viewport.scrollTop()
            };
            viewportOffset = viewport.offset() || adjusted;
            // Generic calculation method
            function calculate(side, otherSide, type, adjustment, side1, side2, lengthName, targetLength, elemLength) {
                var initialPos = position[side1], mySide = my[side], atSide = at[side], isShift = type === SHIFT, myLength = mySide === side1 ? elemLength : mySide === side2 ? -elemLength : -elemLength / 2, atLength = atSide === side1 ? targetLength : atSide === side2 ? -targetLength : -targetLength / 2, sideOffset = viewportScroll[side1] + viewportOffset[side1] - (containerStatic ? 0 : containerOffset[side1]), overflow1 = sideOffset - initialPos, overflow2 = initialPos + elemLength - (lengthName === WIDTH ? viewportWidth : viewportHeight) - sideOffset, offset = myLength - (my.precedance === side || mySide === my[otherSide] ? atLength : 0) - (atSide === CENTER ? targetLength / 2 : 0);
                // shift
                if (isShift) {
                    offset = (mySide === side1 ? 1 : -1) * myLength;
                    // Adjust position but keep it within viewport dimensions
                    position[side1] += overflow1 > 0 ? overflow1 : overflow2 > 0 ? -overflow2 : 0;
                    position[side1] = Math.max(-containerOffset[side1] + viewportOffset[side1], initialPos - offset, Math.min(Math.max(-containerOffset[side1] + viewportOffset[side1] + (lengthName === WIDTH ? viewportWidth : viewportHeight), initialPos + offset), position[side1], // Make sure we don't adjust complete off the element when using 'center'
                    mySide === 'center' ? initialPos - myLength : 1E9));
                } else {
                    // Update adjustment amount depending on if using flipinvert or flip
                    adjustment *= type === FLIPINVERT ? 2 : 0;
                    // Check for overflow on the left/top
                    if (overflow1 > 0 && (mySide !== side1 || overflow2 > 0)) {
                        position[side1] -= offset + adjustment;
                        newMy.invert(side, side1);
                    } else if (overflow2 > 0 && (mySide !== side2 || overflow1 > 0)) {
                        position[side1] -= (mySide === CENTER ? -offset : offset) + adjustment;
                        newMy.invert(side, side2);
                    }
                    // Make sure we haven't made things worse with the adjustment and reset if so
                    if (position[side1] < viewportScroll[side1] && -position[side1] > overflow2) {
                        position[side1] = initialPos;
                        newMy = my.clone();
                    }
                }
                return position[side1] - initialPos;
            }
            // Set newMy if using flip or flipinvert methods
            if (methodX !== 'shift' || methodY !== 'shift') newMy = my.clone();
            // Adjust position based onviewport and adjustment options
            adjusted = {
                left: methodX !== 'none' ? calculate(X, Y, methodX, adjust.x, LEFT, RIGHT, WIDTH, targetWidth, elemWidth) : 0,
                top: methodY !== 'none' ? calculate(Y, X, methodY, adjust.y, TOP, BOTTOM, HEIGHT, targetHeight, elemHeight) : 0,
                my: newMy
            };
            return adjusted;
        };
        PLUGINS.polys = {
            // POLY area coordinate calculator
            //	Special thanks to Ed Cradock for helping out with this.
            //	Uses a binary search algorithm to find suitable coordinates.
            polygon: function(baseCoords, corner) {
                var result = {
                    width: 0,
                    height: 0,
                    position: {
                        top: 1e10,
                        right: 0,
                        bottom: 0,
                        left: 1e10
                    },
                    adjustable: FALSE
                }, i = 0, next, coords = [], compareX = 1, compareY = 1, realX = 0, realY = 0, newWidth, newHeight;
                // First pass, sanitize coords and determine outer edges
                i = baseCoords.length;
                while(i--){
                    next = [
                        parseInt(baseCoords[--i], 10),
                        parseInt(baseCoords[i + 1], 10)
                    ];
                    if (next[0] > result.position.right) result.position.right = next[0];
                    if (next[0] < result.position.left) result.position.left = next[0];
                    if (next[1] > result.position.bottom) result.position.bottom = next[1];
                    if (next[1] < result.position.top) result.position.top = next[1];
                    coords.push(next);
                }
                // Calculate height and width from outer edges
                newWidth = result.width = Math.abs(result.position.right - result.position.left);
                newHeight = result.height = Math.abs(result.position.bottom - result.position.top);
                // If it's the center corner...
                if (corner.abbrev() === 'c') result.position = {
                    left: result.position.left + result.width / 2,
                    top: result.position.top + result.height / 2
                };
                else {
                    // Second pass, use a binary search algorithm to locate most suitable coordinate
                    while(newWidth > 0 && newHeight > 0 && compareX > 0 && compareY > 0){
                        newWidth = Math.floor(newWidth / 2);
                        newHeight = Math.floor(newHeight / 2);
                        if (corner.x === LEFT) compareX = newWidth;
                        else if (corner.x === RIGHT) compareX = result.width - newWidth;
                        else compareX += Math.floor(newWidth / 2);
                        if (corner.y === TOP) compareY = newHeight;
                        else if (corner.y === BOTTOM) compareY = result.height - newHeight;
                        else compareY += Math.floor(newHeight / 2);
                        i = coords.length;
                        while(i--){
                            if (coords.length < 2) break;
                            realX = coords[i][0] - result.position.left;
                            realY = coords[i][1] - result.position.top;
                            if (corner.x === LEFT && realX >= compareX || corner.x === RIGHT && realX <= compareX || corner.x === CENTER && (realX < compareX || realX > result.width - compareX) || corner.y === TOP && realY >= compareY || corner.y === BOTTOM && realY <= compareY || corner.y === CENTER && (realY < compareY || realY > result.height - compareY)) coords.splice(i, 1);
                        }
                    }
                    result.position = {
                        left: coords[0][0],
                        top: coords[0][1]
                    };
                }
                return result;
            },
            rect: function(ax, ay, bx, by) {
                return {
                    width: Math.abs(bx - ax),
                    height: Math.abs(by - ay),
                    position: {
                        left: Math.min(ax, bx),
                        top: Math.min(ay, by)
                    }
                };
            },
            _angles: {
                tc: 1.5,
                tr: 7 / 4,
                tl: 5 / 4,
                bc: 0.5,
                br: 1 / 4,
                bl: 3 / 4,
                rc: 2,
                lc: 1,
                c: 0
            },
            ellipse: function(cx, cy, rx, ry, corner) {
                var c = PLUGINS.polys._angles[corner.abbrev()], rxc = c === 0 ? 0 : rx * Math.cos(c * Math.PI), rys = ry * Math.sin(c * Math.PI);
                return {
                    width: rx * 2 - Math.abs(rxc),
                    height: ry * 2 - Math.abs(rys),
                    position: {
                        left: cx + rxc,
                        top: cy + rys
                    },
                    adjustable: FALSE
                };
            },
            circle: function(cx, cy, r, corner) {
                return PLUGINS.polys.ellipse(cx, cy, r, r, corner);
            }
        };
        PLUGINS.svg = function(api, svg, corner) {
            var elem = svg[0], root = $(elem.ownerSVGElement), ownerDocument = elem.ownerDocument, strokeWidth2 = (parseInt(svg.css('stroke-width'), 10) || 0) / 2, frameOffset, mtx, transformed, len, next, i, points, result, position;
            // Ascend the parentNode chain until we find an element with getBBox()
            while(!elem.getBBox)elem = elem.parentNode;
            if (!elem.getBBox || !elem.parentNode) return FALSE;
            // Determine which shape calculation to use
            switch(elem.nodeName){
                case 'ellipse':
                case 'circle':
                    result = PLUGINS.polys.ellipse(elem.cx.baseVal.value, elem.cy.baseVal.value, (elem.rx || elem.r).baseVal.value + strokeWidth2, (elem.ry || elem.r).baseVal.value + strokeWidth2, corner);
                    break;
                case 'line':
                case 'polygon':
                case 'polyline':
                    // Determine points object (line has none, so mimic using array)
                    points = elem.points || [
                        {
                            x: elem.x1.baseVal.value,
                            y: elem.y1.baseVal.value
                        },
                        {
                            x: elem.x2.baseVal.value,
                            y: elem.y2.baseVal.value
                        }
                    ];
                    for(result = [], i = -1, len = points.numberOfItems || points.length; ++i < len;){
                        next = points.getItem ? points.getItem(i) : points[i];
                        result.push.apply(result, [
                            next.x,
                            next.y
                        ]);
                    }
                    result = PLUGINS.polys.polygon(result, corner);
                    break;
                // Unknown shape or rectangle? Use bounding box
                default:
                    result = elem.getBBox();
                    result = {
                        width: result.width,
                        height: result.height,
                        position: {
                            left: result.x,
                            top: result.y
                        }
                    };
                    break;
            }
            // Shortcut assignments
            position = result.position;
            root = root[0];
            // Convert position into a pixel value
            if (root.createSVGPoint) {
                mtx = elem.getScreenCTM();
                points = root.createSVGPoint();
                points.x = position.left;
                points.y = position.top;
                transformed = points.matrixTransform(mtx);
                position.left = transformed.x;
                position.top = transformed.y;
            }
            // Check the element is not in a child document, and if so, adjust for frame elements offset
            if (ownerDocument !== document1 && api.position.target !== 'mouse') {
                frameOffset = $((ownerDocument.defaultView || ownerDocument.parentWindow).frameElement).offset();
                if (frameOffset) {
                    position.left += frameOffset.left;
                    position.top += frameOffset.top;
                }
            }
            // Adjust by scroll offset of owner document
            ownerDocument = $(ownerDocument);
            position.left += ownerDocument.scrollLeft();
            position.top += ownerDocument.scrollTop();
            return result;
        };
        PLUGINS.imagemap = function(api, area, corner) {
            if (!area.jquery) area = $(area);
            var shape = (area.attr('shape') || 'rect').toLowerCase().replace('poly', 'polygon'), image = $('img[usemap="#' + area.parent('map').attr('name') + '"]'), coordsString = $.trim(area.attr('coords')), coordsArray = coordsString.replace(/,$/, '').split(','), imageOffset, coords, i, result, len;
            // If we can't find the image using the map...
            if (!image.length) return FALSE;
            // Pass coordinates string if polygon
            if (shape === 'polygon') result = PLUGINS.polys.polygon(coordsArray, corner);
            else if (PLUGINS.polys[shape]) {
                for(i = -1, len = coordsArray.length, coords = []; ++i < len;)coords.push(parseInt(coordsArray[i], 10));
                result = PLUGINS.polys[shape].apply(this, coords.concat(corner));
            } else return FALSE;
            // Make sure we account for padding and borders on the image
            imageOffset = image.offset();
            imageOffset.left += Math.ceil((image.outerWidth(FALSE) - image.width()) / 2);
            imageOffset.top += Math.ceil((image.outerHeight(FALSE) - image.height()) / 2);
            // Add image position to offset coordinates
            result.position.left += imageOffset.left;
            result.position.top += imageOffset.top;
            return result;
        };
        var IE6, /*
       * BGIFrame adaption (http://plugins.jquery.com/project/bgiframe)
       * Special thanks to Brandon Aaron
       */ BGIFRAME = '<iframe class="qtip-bgiframe" frameborder="0" tabindex="-1" src="javascript:\'\';"  style="display:block; position:absolute; z-index:-1; filter:alpha(opacity=0); -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";"></iframe>';
        function Ie6(api) {
            this._ns = 'ie6';
            this.qtip = api;
            this.init(api);
        }
        $.extend(Ie6.prototype, {
            _scroll: function() {
                var overlay = this.qtip.elements.overlay;
                overlay && (overlay[0].style.top = $(window1).scrollTop() + 'px');
            },
            init: function(qtip) {
                var tooltip = qtip.tooltip;
                // Create the BGIFrame element if needed
                if ($('select, object').length < 1) {
                    this.bgiframe = qtip.elements.bgiframe = $(BGIFRAME).appendTo(tooltip);
                    // Update BGIFrame on tooltip move
                    qtip._bind(tooltip, 'tooltipmove', this.adjustBGIFrame, this._ns, this);
                }
                // redraw() container for width/height calculations
                this.redrawContainer = $('<div/>', {
                    id: NAMESPACE + '-rcontainer'
                }).appendTo(document1.body);
                // Fixup modal plugin if present too
                if (qtip.elements.overlay && qtip.elements.overlay.addClass('qtipmodal-ie6fix')) {
                    qtip._bind(window1, [
                        'scroll',
                        'resize'
                    ], this._scroll, this._ns, this);
                    qtip._bind(tooltip, [
                        'tooltipshow'
                    ], this._scroll, this._ns, this);
                }
                // Set dimensions
                this.redraw();
            },
            adjustBGIFrame: function() {
                var tooltip = this.qtip.tooltip, dimensions = {
                    height: tooltip.outerHeight(FALSE),
                    width: tooltip.outerWidth(FALSE)
                }, plugin = this.qtip.plugins.tip, tip = this.qtip.elements.tip, tipAdjust, offset;
                // Adjust border offset
                offset = parseInt(tooltip.css('borderLeftWidth'), 10) || 0;
                offset = {
                    left: -offset,
                    top: -offset
                };
                // Adjust for tips plugin
                if (plugin && tip) {
                    tipAdjust = plugin.corner.precedance === 'x' ? [
                        WIDTH,
                        LEFT
                    ] : [
                        HEIGHT,
                        TOP
                    ];
                    offset[tipAdjust[1]] -= tip[tipAdjust[0]]();
                }
                // Update bgiframe
                this.bgiframe.css(offset).css(dimensions);
            },
            // Max/min width simulator function
            redraw: function() {
                if (this.qtip.rendered < 1 || this.drawing) return this;
                var tooltip = this.qtip.tooltip, style = this.qtip.options.style, container = this.qtip.options.position.container, perc, width, max, min;
                // Set drawing flag
                this.qtip.drawing = 1;
                // If tooltip has a set height/width, just set it... like a boss!
                if (style.height) tooltip.css(HEIGHT, style.height);
                if (style.width) tooltip.css(WIDTH, style.width);
                else {
                    // Reset width and add fluid class
                    tooltip.css(WIDTH, '').appendTo(this.redrawContainer);
                    // Grab our tooltip width (add 1 if odd so we don't get wrapping problems.. huzzah!)
                    width = tooltip.width();
                    if (width % 2 < 1) width += 1;
                    // Grab our max/min properties
                    max = tooltip.css('maxWidth') || '';
                    min = tooltip.css('minWidth') || '';
                    // Parse into proper pixel values
                    perc = (max + min).indexOf('%') > -1 ? container.width() / 100 : 0;
                    max = (max.indexOf('%') > -1 ? perc : 1 * parseInt(max, 10)) || width;
                    min = (min.indexOf('%') > -1 ? perc : 1 * parseInt(min, 10)) || 0;
                    // Determine new dimension size based on max/min/current values
                    width = max + min ? Math.min(Math.max(width, min), max) : width;
                    // Set the newly calculated width and remvoe fluid class
                    tooltip.css(WIDTH, Math.round(width)).appendTo(container);
                }
                // Set drawing flag
                this.drawing = 0;
                return this;
            },
            destroy: function() {
                // Remove iframe
                this.bgiframe && this.bgiframe.remove();
                // Remove bound events
                this.qtip._unbind([
                    window1,
                    this.qtip.tooltip
                ], this._ns);
            }
        });
        IE6 = PLUGINS.ie6 = function(api) {
            // Proceed only if the browser is IE6
            return BROWSER.ie === 6 ? new Ie6(api) : FALSE;
        };
        IE6.initialize = 'render';
        CHECKS.ie6 = {
            '^content|style$': function() {
                this.redraw();
            }
        };
    });
})(window, document);



/**
 * @class InputLabel
 * @extends {Okta.View}
 * @private
 * The input's label.
 */ var $539689c737fd4b6f$export$2e2bcd8739ae039 = (0, $5f539c045973220f$export$2e2bcd8739ae039).extend({
    className: 'okta-form-label o-form-label',
    attributes: {
        'data-se': 'o-form-label'
    },
    /**
   * @constructor
   * @param  {Object} options options hash
   * @param  {String} [options.type] Input type
   * @param  {String|Function} [options.label] Label text
   * @param  {String|Function} [options.sublabel] Sub label text
   * @param  {String|Function} [options.tooltip] Tooltip text
   * @param  {String|Function} [options.inputId] Id of the inputs
   * @param  {String|Function} [options.id] Id of the inputs
   */ constructor: function(options) {
        /* eslint max-statements: [2, 16] complexity: [2, 7]*/ (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults(options, {
            inputId: options.id
        });
        delete options.id;
        (0, $5f539c045973220f$export$2e2bcd8739ae039).apply(this, arguments);
    },
    // standardLabel: space added in the end of the label to avoid selecting label text with double click in read mode
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            return "<legend>";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<label for=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "inputId",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 61
                    },
                    "end": {
                        "line": 1,
                        "column": 72
                    }
                }
            }) : helper)) + "\"></label>";
        },
        "2": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return container.escapeExpression((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "label",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 116
                    },
                    "end": {
                        "line": 1,
                        "column": 125
                    }
                }
            }) : helper));
        },
        "3": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<label for=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "inputId",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 167
                    },
                    "end": {
                        "line": 1,
                        "column": 178
                    }
                }
            }) : helper)) + "\">" + alias4((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "label",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 180
                    },
                    "end": {
                        "line": 1,
                        "column": 189
                    }
                }
            }) : helper)) + "&nbsp;</label>";
        },
        "4": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<span class=\"o-form-explain\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "sublabel") || (depth0 != null ? lookupProperty(depth0, "sublabel") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "sublabel",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 256
                    },
                    "end": {
                        "line": 1,
                        "column": 268
                    }
                }
            }) : helper)) + "</span>";
        },
        "5": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<span class=\"o-form-tooltip icon-16 icon-only form-help-16\" title=\"" + container.escapeExpression(container.lambda((stack1 = depth0 != null ? lookupProperty(depth0, "tooltip") : depth0) != null ? lookupProperty(stack1, "text") : stack1, depth0)) + "\"></span>";
        },
        "6": function(container, depth0, helpers, partials, data) {
            return "</legend>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "group") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 28
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "_isLabelView") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 28
                    },
                    "end": {
                        "line": 1,
                        "column": 89
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "_isRadioOrCheckbox") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(2, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 89
                    },
                    "end": {
                        "line": 1,
                        "column": 132
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "_standardLabel") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(3, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 132
                    },
                    "end": {
                        "line": 1,
                        "column": 210
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "sublabel") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(4, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 210
                    },
                    "end": {
                        "line": 1,
                        "column": 282
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "tooltip") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(5, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 282
                    },
                    "end": {
                        "line": 1,
                        "column": 397
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "group") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(6, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 397
                    },
                    "end": {
                        "line": 1,
                        "column": 426
                    }
                }
            })) != null ? stack1 : "");
        },
        "useData": true
    }),
    getTemplateData: function() {
        const options = {
            label: ''
        };
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each([
            'inputId',
            'label',
            'sublabel',
            'tooltip',
            'group'
        ], function(option) {
            options[option] = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).resultCtx(this.options, option, this);
        }, this);
        if (this._isLabelView(options.label)) options._isLabelView = true;
        else if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains([
            'radio',
            'checkbox'
        ], this.options.type) || !options.label) options._isRadioOrCheckbox = true;
        else options._standardLabel = true;
        if (options.tooltip) {
            if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isString(options.tooltip)) options.tooltip = {
                text: options.tooltip
            };
        }
        return options;
    },
    _isLabelView: function(label) {
        return !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isUndefined(label) && label instanceof (0, $5f539c045973220f$export$2e2bcd8739ae039);
    },
    postRender: function() {
        const options = this.getTemplateData();
        if (this._isLabelView(options.label)) {
            this.removeChildren();
            this.add(options.label, 'label');
        }
        if (options.tooltip) this.$('.o-form-tooltip').qtip((0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({
            style: {
                classes: 'qtip-custom qtip-shadow'
            },
            position: {
                my: window.okta && window.okta.theme === 'dstheme' ? 'bottom center' : 'bottom left',
                at: 'top center'
            },
            hide: {
                fixed: true
            },
            show: {
                delay: 0
            }
        }, options.tooltip.options));
    }
});





function $f5bf630fc9eb39d5$var$runCallback(callback, field) {
    callback.apply(this, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).map(field.split(/\s+/), function(field) {
        return this.model.get(field);
    }, this));
}
function $f5bf630fc9eb39d5$var$runIf(fn, ctx) {
    if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(fn)) fn.call(ctx);
}
/**
 * @class InputWrapper
 * @extends Okta.View
 * @private
 * The outer wrapper that warps the label and the input container
 */ var $f5bf630fc9eb39d5$export$2e2bcd8739ae039 = (0, $5f539c045973220f$export$2e2bcd8739ae039).extend({
    tagName: function() {
        if (this.options.group) return 'fieldset';
        return 'div';
    },
    className: function() {
        let className = 'o-form-fieldset';
        if (this.options['label-top']) className += ' o-form-label-top';
        if (this.options.readOnly) className += ' o-form-read-mode';
        return className;
    },
    attributes: function() {
        return {
            'data-se': this.options['data-se'] || 'o-form-fieldset'
        };
    },
    /**
   * @constructor
   * @param  {Object} options options hash
   * @param  {Object} [options.events]
   * @param  {Object} [options.bindings]
   * @param  {Object} [options.showWhen]
   * @param  {Function} [options.initialize] post initialize callback
   * @param  {Function} [options.render] post render callback
   */ constructor: function(options) {
        if (options.className) {
            this.inputWrapperClassName = this.className;
            this.optionsClassName = options.className;
            options.className = function() {
                return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'inputWrapperClassName', '') + ' ' + (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'optionsClassName');
            };
        }
        (0, $5f539c045973220f$export$2e2bcd8739ae039).apply(this, arguments);
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(options.events || {}, function(callback, event) {
            this.listenTo(this.model, event, callback);
        }, this);
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(options.bindings || {}, function(callback, field) {
            this.listenTo(this.model, (0, $a6671880aee1fa70$export$2e2bcd8739ae039).changeEventString(field.split(/\s+/)), (0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind($f5bf630fc9eb39d5$var$runCallback, this, callback, field));
        }, this);
        (0, $a6671880aee1fa70$export$2e2bcd8739ae039).applyShowWhen(this, options.showWhen);
        (0, $a6671880aee1fa70$export$2e2bcd8739ae039).applyToggleWhen(this, options.toggleWhen);
        $f5bf630fc9eb39d5$var$runIf(options.initialize, this);
    },
    postRender: function() {
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(this.options.bindings || {}, $f5bf630fc9eb39d5$var$runCallback, this);
        $f5bf630fc9eb39d5$var$runIf(this.options.render, this);
    },
    /**
   * @return {InputLabel}
   */ getLabel: function() {
        return this.size() > 1 ? this.at(0) : null;
    },
    /**
   * @deprecated ambiguous naming, use {@link #getInputContainer}
   */ getInput: function() {
        return this.getInputContainer();
    },
    /**
   * @return {InputContainer}
   */ getInputContainer: function() {
        return this.at(this.size() > 1 ? 1 : 0);
    },
    /**
   * @return {BaseInput[]}
   */ getInputs: function() {
        return this.getInputContainer().toArray();
    },
    focus: function() {
        return this.getInput().focus();
    }
});



const $1b4071d45909ff1b$var$template = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "0": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<h2 class=\"o-form-title-bar\" data-se=\"o-form-title-bar\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "title",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 75
                },
                "end": {
                    "line": 1,
                    "column": 84
                }
            }
        }) : helper)) + "</h2>";
    },
    "1": function(container, depth0, helpers, partials, data) {
        var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "title") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(2, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 192
                },
                "end": {
                    "line": 1,
                    "column": 288
                }
            }
        })) != null ? stack1 : "";
    },
    "2": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<h2 data-se=\"o-form-head\" class=\"okta-form-title o-form-head\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "title",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 267
                },
                "end": {
                    "line": 1,
                    "column": 276
                }
            }
        }) : helper)) + "</h2>";
    },
    "3": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<p class=\"okta-form-subtitle o-form-explain\" data-se=\"o-form-explain\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "subtitle") || (depth0 != null ? lookupProperty(depth0, "subtitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "subtitle",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 385
                },
                "end": {
                    "line": 1,
                    "column": 397
                }
            }
        }) : helper)) + "</p>";
    },
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "hasReadMode") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(0, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 0
                },
                "end": {
                    "line": 1,
                    "column": 96
                }
            }
        })) != null ? stack1 : "") + "<div data-se=\"o-form-content\" class=\"o-form-content " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "layout") || (depth0 != null ? lookupProperty(depth0, "layout") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
            "name": "layout",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 148
                },
                "end": {
                    "line": 1,
                    "column": 158
                }
            }
        }) : helper)) + " clearfix\">" + ((stack1 = lookupProperty(helpers, "unless").call(alias1, depth0 != null ? lookupProperty(depth0, "hasReadMode") : depth0, {
            "name": "unless",
            "hash": {},
            "fn": container.program(1, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 169
                },
                "end": {
                    "line": 1,
                    "column": 299
                }
            }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "subtitle") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(3, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 299
                },
                "end": {
                    "line": 1,
                    "column": 408
                }
            }
        })) != null ? stack1 : "") + "<div class=\"o-form-error-container\" data-se=\"o-form-error-container\"></div><div class=\"o-form-fieldset-container\" data-se=\"o-form-fieldset-container\"></div></div>";
    },
    "useData": true
});
const $1b4071d45909ff1b$var$sectionTitleTemplate = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<h2 class=\"o-form-head\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "title",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 24
                },
                "end": {
                    "line": 1,
                    "column": 33
                }
            }
        }) : helper)) + "</h2>";
    },
    "useData": true
});
const $1b4071d45909ff1b$var$pointerEventsSupported = (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)('<div>').css({
    'pointer-events': 'auto'
})[0].style.pointerEvents === 'auto'; // polyfill for `pointer-events: none;` in IE < 11
// Logic borrowed from https://github.com/kmewhort/pointer_events_polyfill (BSD)
function $1b4071d45909ff1b$var$pointerEventsPolyfill(e) {
    if (!$1b4071d45909ff1b$var$pointerEventsSupported && this.$el.hasClass('o-form-saving')) {
        const $el = (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(e.currentTarget);
        $el.css('display', 'none');
        const underneathElem = document.elementFromPoint(e.clientX, e.clientY);
        $el.css('display', 'block');
        e.target = underneathElem;
        (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(underneathElem).trigger(e);
        return false;
    }
}
const $1b4071d45909ff1b$var$events = {
    submit: function(e) {
        e.preventDefault();
        this.__save();
    }
};
(0, $3e490973b7383cc4$export$2e2bcd8739ae039).each([
    'click',
    'dblclick',
    'mousedown',
    'mouseup'
], function(event) {
    $1b4071d45909ff1b$var$events[event + ' .o-form-input'] = $1b4071d45909ff1b$var$pointerEventsPolyfill;
});
const $1b4071d45909ff1b$var$attributes = function(model) {
    model || (model = {});
    const collection = model && model.collection || {};
    return {
        method: 'POST',
        action: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(model, 'urlRoot') || (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(collection, 'url') || window.location.pathname,
        'data-se': 'o-form',
        slot: 'content'
    };
};
const $1b4071d45909ff1b$var$convertSavingState = function(rawSavingStateEvent, defaultEvent) {
    rawSavingStateEvent || (rawSavingStateEvent = '');
    let savingStateEvent = [];
    if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isString(rawSavingStateEvent)) savingStateEvent = rawSavingStateEvent.split(' ');
    savingStateEvent = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).union(savingStateEvent, defaultEvent);
    return savingStateEvent.join(' ');
};
const $1b4071d45909ff1b$var$getErrorSummary = function(responseJSON = {}) {
    if (Array.isArray(responseJSON.errorCauses) && responseJSON.errorCauses.length > 0) //set errorSummary from first errorCause which is not field specific error
    return responseJSON.errorCauses[0].errorSummary;
    else //set errorSummary from top level errorSummary
    return responseJSON.errorSummary;
};
/**
 * A Form utility framework
 *
 * Okta.Form is a form that operates on one flat model
 * It exposes one main factory method, {@link module:Okta.Form#addInput|addInput}, which add inputs to the form,
 * and each input operates on one field in the model, identified by the `name` field.
 *
 * See:
 * [Basic O-Form Tutorial](https://github.com/okta/courage/wiki/Basic-O-Form)
 *
 * @class module:Okta.Form
 * @extends module:Okta.View
 * @param {Object} options options hash (See {@link module:Okta.View|View})
 * @param {Object} options.model the model this form operates on
 * @param {Boolean} [options.label-top=false] position label on top of inputs
 * @param {Boolean} [options.wide=false] Use a wide input layout for all input
 */ /**
 * Fired when the "Save" button is clicked
 * @event module:Okta.Form#save
 * @param {module:Okta.Model} model Model used in the form
 */ /**
 * Fired after the model is successfully saved - applies when {@link module:Okta.Form#autoSave|autoSave}
 * is set to true
 * @event module:Okta.Form#saved
 * @param {module:Okta.Model} model Model used in the form
 */ /**
 * Fired when the model fires an invalid event or an error event;
 * @event module:Okta.Form#error
 * @param {module:Okta.Model} model Model used in the form
 */ /**
 * Fired when the form layout is likely to be resized
 * @event module:Okta.Form#resize
 * @param {module:Okta.Model} model Model used in the form
 */ /**
 * Fired when the "Cancel" button is clicked
 * @event module:Okta.Form#cancel
 */ var $1b4071d45909ff1b$export$2e2bcd8739ae039 = (0, $5f539c045973220f$export$2e2bcd8739ae039).extend(/** @lends module:Okta.Form.prototype */ {
    /**
   * Specifies how to validate form:
   * - In case "local" string provided as a value of the property,
   * the form will validate only fields added as inputs to the form;
   * - In case array is provided, the validation will be performed only for fields specified in array;
   * - In case function is provided, provided function will be used as a validation function,
   * it must return an error object with the format {fieldName: 'error text'} with as many fields as you need.
   * @name validate
   * @memberof module:Okta.Form
   * @type {String|Array|Function}
   * @instance
   */ constructor: function(options) {
        /* eslint max-statements: 0, complexity: 0 */ options || (options = {});
        this.options = options;
        if (options.settings) this.settings = options.settings;
        else this.settings = options.settings = new (0, $877ed51558e25423$export$2e2bcd8739ae039)();
        this.id = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).uniqueId('form');
        this.tagName = 'form';
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults(this.events, $1b4071d45909ff1b$var$events);
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults(this.attributes, $1b4071d45909ff1b$var$attributes(options.model));
        this.__buttons = [];
        this.__errorFields = {};
        this.__saveModelState(options.model);
        const step = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'step');
        if (step) {
            // checking exists of `this.save` hence don't have to change to
            // `_.result(this, 'save')` which will execute the function and
            // is not the intent.
            if (!this.save) {
                const totalStep = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'totalSteps');
                this.save = !totalStep || step === totalStep ? (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize('oform.button.finish', 'courage') : (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize('oform.button.next', 'courage');
            }
            this.className = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'className') + ' wizard';
        }
        this.className = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'className') + ' o-form';
        this.__toolbar = this.__createToolbar(options);
        (0, $5f539c045973220f$export$2e2bcd8739ae039).call(this, options);
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each((0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'inputs') || [], function(input) {
            // to ingore extra argumests from `each` iteratee function
            // http://underscorejs.org/#each
            this.__addLayoutItem(input);
        }, this);
        this.add(this.__toolbar, ''); // NOTES: this.model shall be initialized after calling
        // super (BaseView.call(this, options)) above.
        //
        this.listenTo(this.model, 'change:__edit__', this.__applyMode);
        this.listenTo(this.model, 'invalid error', (0, $3e490973b7383cc4$export$2e2bcd8739ae039).throttle(function(model, resp, showBanner) {
            this.__showErrors(model, resp, showBanner !== false);
        }, 100, {
            trailing: false
        }));
        this.listenTo(this.model, 'form:resize', function() {
            this.trigger('resize');
        });
        this.listenTo(this.model, 'form:cancel', (0, $3e490973b7383cc4$export$2e2bcd8739ae039).throttle(this.__cancel, 100, {
            trailing: false
        }));
        this.listenTo(this.model, 'form:previous', (0, $3e490973b7383cc4$export$2e2bcd8739ae039).throttle(this.__previous, 100, {
            trailing: false
        }));
        this.__save = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).throttle(this.__save, 200, {
            trailing: false
        });
        this.listenTo(this.model, 'form:save', function() {
            this.$el.submit();
        });
        this.listenTo(this.model, 'sync', function() {
            if (this.model.get('__edit__')) this.model.set('__edit__', false, {
                silent: true
            });
            this.__saveModelState(this.model);
            this.render();
        });
        let hasSavingState = this.getAttribute('hasSavingState');
        if (this.getAttribute('autoSave')) {
            this.listenTo(this, 'save', function(model) {
                const xhr = model.save();
                if (xhr && xhr.done) xhr.done(()=>{
                    this.trigger('saved', model);
                });
            });
            if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isUndefined(hasSavingState)) hasSavingState = true;
        } else if (this.getAttribute('autoFetchAndSave')) this.listenTo(this, 'save', function(model) {
            if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isUndefined(hasSavingState)) hasSavingState = true;
            this.fetchAndSave(model);
        });
        /*
    * Attach model event listeners
    * by default, model's request event starts the form saving state,
    * error and sync event stops it
    * you can define customized saving start and stop state, like
    * customSavingState: {start: 'requestingAdditionalInfo', stop: 'retrievedAdditionalInfo'}
    * doing this does not override the default events
    */ if (hasSavingState) {
            const customSavingState = this.getAttribute('customSavingState', {});
            this.listenTo(this.model, $1b4071d45909ff1b$var$convertSavingState(customSavingState.start || '', [
                'request'
            ]), this.__setSavingState);
            this.listenTo(this.model, $1b4071d45909ff1b$var$convertSavingState(customSavingState.stop || '', [
                'error',
                'sync'
            ]), this.__clearSavingState);
        }
    },
    /*
  * Does a model.save, but first fetches the model to ensure that we
  * don't overwrite unrelated properties that have been changed
  * since the form was rendered. This fixes a bug that occurs when multiple
  * forms are rendered on the same page which hit the same endpoint.
  * You can optionally pass in a different model for fetching to avoid
  * flickering in the form as the fetch temporarily undos some attributes
  */ fetchAndSave: async function(formModel = this.model, otherModel = this.model) {
        // This is set when the form is first rendered, and may be stale
        const attrsOnInitialRender = this.__originalModel;
        const attrsFromCurrentFormState = {
            ...formModel.attributes
        }; // Fetch the model on the server so we know if anything has changed
        // since the form was rendered.
        await otherModel.fetch(); // Figure out what the user has changed on the form, so we know
        // what new changes to persist on the server
        const attrsFreshlyFetchedFromServer = otherModel.attributes;
        const possibleChangedKeys = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).uniq([
            ...Object.keys(attrsOnInitialRender),
            ...Object.keys(attrsFromCurrentFormState)
        ]);
        const attrsWhichHaveBeenChangedSinceFormRender = {};
        possibleChangedKeys.forEach((key)=>{
            if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEqual(attrsOnInitialRender[key], attrsFromCurrentFormState[key])) attrsWhichHaveBeenChangedSinceFormRender[key] = attrsFromCurrentFormState[key];
        }); // Get the fresh version of the model attributes from the fetch,
        // only overwriting the ones the user modified on this form
        const newAttrs = {
            ...attrsFreshlyFetchedFromServer,
            ...attrsWhichHaveBeenChangedSinceFormRender
        };
        formModel.set(newAttrs); // this.model.set('__edit__', attrsFromCurrentFormState.__edit__);
        const xhr = formModel.save();
        if (xhr && xhr.done) xhr.done(()=>{
            this.trigger('saved', formModel);
        });
        return xhr;
    },
    /**
   * Create the bottom button bar
   * @param  {Object} options options h
   * @return {Okta.View} The toolbar
   * @private
   */ __createToolbar: function(options) {
        const danger = this.getAttribute('danger');
        const saveBtnClassName = danger === true ? 'button-error' : 'button-primary';
        const step = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'step');
        const toolbar = new (0, $eb85f03955072115$export$2e2bcd8739ae039)((0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({
            save: this.save || (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize('oform.save', 'courage'),
            saveId: this.saveId,
            saveClassName: saveBtnClassName,
            cancel: this.cancel || (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize('oform.cancel', 'courage'),
            noCancelButton: this.noCancelButton || false,
            noSubmitButton: this.noSubmitButton || false,
            buttonOrder: this.buttonOrder,
            hasPrevStep: step && step > 1
        }, options || this.options));
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(this.__buttons, function(args) {
            toolbar.addButton.apply(toolbar, args);
        });
        return toolbar;
    },
    className: '',
    attributes: {},
    events: {},
    /**
   * An array of input configurations to render in the form
   * @type {Array}
   */ inputs: [],
    template: null,
    /**
   * Does the form support read/edit toggle.
   * @type {Boolean|Function}
   * @default false
   */ read: false,
    /**
   * Is the form in readOnly mode.
   * @type {Boolean|Function}
   * @default false
   */ readOnly: false,
    /**
   * Should we not render the button bar
   * @type {Boolean|Function}
   * @default false
   */ noButtonBar: false,
    /**
   * Should we not render a cancel button
   * @type {Boolean|Function}
   * @default false
   */ noCancelButton: false,
    /**
   * Should we not render a save button
   * @type {Boolean}
   * @default false
   */ noSubmitButton: false,
    /**
   * Set the order of the save, cancel and previous buttons (left to right).
   * @type {Array.<string>}
   * @default ['previous', 'save', 'cancel']
   */ buttonOrder: [
        'previous',
        'save',
        'cancel'
    ],
    /**
   * The text on the save button
   * @type {String}
   * @default "Save"
   */ save: null,
    /**
   * The text on the cancel button
   * @type {String}
   * @default "Cancel"
   */ cancel: null,
    /**
   * To use button-error to style the submit button instead of button-primary.
   * @type {Boolean|Function}
   * @default false
   */ danger: false,
    /**
   * A layout CSS class to add to the form
   * @type {String|Function}
   * @default ""
   */ layout: '',
    /**
   * The step this form is in the context of a wizard
   * @type {Number}
   */ step: undefined,
    /**
   * The total numbers of steps the wizard this form is a part of has
   * @type {Number}
   */ totalSteps: undefined,
    /**
   * The form's title
   * @type {String|Function}
   */ title: null,
    /**
   * The form's subtitle
   * @type {String|Function}
   */ subtitle: null,
    /**
   * Auto-save the model when hitting save. Triggers a `saved` event when done
   * @type {Boolean}
   * @default false
   */ autoSave: false,
    /**
   * Like auto-save, but does a fetch first to avoid overwriting unrelated properties
   * that have been changed since the form was rendered.
   * @type {Boolean}
   * @default false
   */ autoFetchAndSave: false,
    /**
   * Scroll to the top of the form on error
   * @type {Boolean|Function}
   * @default true
   */ scrollOnError: true,
    /**
   * Show the error banner upon error
   * @type {Boolean|Function}
   * @default true
   */ showErrors: true,
    /**
   * The form's scrollable area
   * @type {String}
   * @default ".o-form-content"
   */ resizeSelector: '.o-form-content',
    /**
   * Sets whether or not the form shows the saving state when
   * the model is saved.  Has no effect on setSavingState and clearSavingState as those are manual calls
   * to trigger/clear the saving state.
   * @name hasSavingState
   * @memberof module:Okta.Form
   * @type {Boolean}
   * @default false
   * @instance
   */ /**
   * Get an attribute value from options or instance.
   * Prefer options value over instance value
   * @param  {String} name Name of the attribute
   * @param  {Object} defaultValue the default value to return if the attribute is not found
   * @return {Object} The value
   */ getAttribute: function(name, defaultValue) {
        let value = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).resultCtx(this.options, name, this);
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isUndefined(value)) value = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, name);
        return !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isUndefined(value) ? value : defaultValue;
    },
    /**
   * Does this form have a "read" mode
   * @return {Boolean}
   */ hasReadMode: function() {
        return !!this.getAttribute('read');
    },
    /**
   * Is this form in "read only" mode
   * @return {Boolean}
   */ isReadOnly: function() {
        return !!this.getAttribute('readOnly');
    },
    /**
   * Does this form have a button bar
   * @return {Boolean}
   */ hasButtonBar: function() {
        return !(this.getAttribute('noButtonBar') || this.isReadOnly());
    },
    render: function() {
        this.__readModeBar && this.__readModeBar.remove();
        if (this.hasReadMode() && !this.isReadOnly()) {
            const readModeBar = (0, $83282d01860c52eb$export$2e2bcd8739ae039).extend({
                formTitle: this.getAttribute('title', '')
            });
            this.__readModeBar = this.add(readModeBar, '.o-form-title-bar').last();
        }
        const html = $1b4071d45909ff1b$var$template({
            layout: this.getAttribute('layout', ''),
            title: this.getAttribute('title', '', true),
            subtitle: this.getAttribute('subtitle', '', true),
            hasReadMode: this.hasReadMode()
        });
        this.$el.html(html);
        delete this.template;
        (0, $5f539c045973220f$export$2e2bcd8739ae039).prototype.render.apply(this, arguments);
        this.__applyMode();
        return this;
    },
    /**
   * Changes form UI to indicate saving.  Disables all inputs and buttons.  Use this function if you have set
   * hasSavingState to false on the the form
   * @private
   */ __setSavingState: function() {
        this.model.trigger('form:set-saving-state');
        this.$el.addClass('o-form-saving');
    },
    /**
   * Changes form UI back to normal from the saving state.  Use this function if you are have set hasSavingState
   * to false on the form
   * @private
   */ __clearSavingState: function() {
        this.model.trigger('form:clear-saving-state');
        this.$el.removeClass('o-form-saving');
    },
    /**
   * Toggles the visibility of the bottom button bar
   * @private
   */ __toggleToolbar: function() {
        this.__toolbar && this.__toolbar.remove();
        if (this.hasButtonBar() && this._editMode()) {
            this.__toolbar = this.__createToolbar();
            this.add(this.__toolbar, '');
        }
        this.trigger('resize');
    },
    /**
   * Cancels this form
   * - Reset the model to the previous state
   * - Clears all errors
   * - Triggers a `cancel` event
   * - Sets the model to read mode (if applicable)
   * @private
   * @fires cancel
   */ __cancel: function() {
        const edit = this.model.get('__edit__');
        /* eslint max-statements: [2, 12] */ this.model.clear({
            silent: true
        });
        let data;
        if (this.model.sanitizeAttributes) data = this.model.sanitizeAttributes(this.__originalModel);
        else data = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone(this.__originalModel);
        this.model.set(data, {
            silent: true
        });
        this.trigger('cancel', this.model);
        this.model.trigger('cache:clear');
        if (edit) {
            this.model.set('__edit__', false, {
                silent: true
            });
            this.model.trigger('change:__edit__', this.model, false);
        }
        this.clearErrors();
    },
    /**
   * Runs {@link module:Okta.Form#validate|validate} to check the model state.
   * Triggers an "invalid" event on the model if validation fails
   * @returns {Boolean}
   */ isValid: function() {
        let res;
        const self = this;
        function validateArray(arr) {
            return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).reduce(arr, function(memo, fieldName) {
                return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend(memo, self.model.validateField(fieldName));
            }, {});
        }
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isUndefined(this.validate)) return this.model.isValid();
        else if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(this.validate)) res = this.validate();
        else if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(this.validate)) res = validateArray(this.validate);
        else if (this.validate === 'local') res = validateArray(this.getInputs().map(function(input) {
            return input.options.name;
        }));
        if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(res)) {
            this.model.trigger('invalid', this.model, res);
            return false;
        } else return true;
    },
    /**
   * A throttled function that saves the form not more than once every 100 ms
   * Basically all this method does is trigger a `save` event
   * @fires save
   * @private
   */ __save: function() {
        this.clearErrors();
        if (this.isValid()) this.trigger('save', this.model);
    },
    /**
   * In the context of a wizard, go to previous state
   * Technically all this method does is trigger a `previous` event
   * @param  {Event} e
   * @private
   */ __previous: function() {
        this.trigger('previous', this.model);
    },
    /**
   * Renders the form in the correct mode based on the model.
   * @private
   */ __applyMode: function() {
        this.clearErrors();
        this.__toggleToolbar();
        if (this._editMode()) {
            this.$el.addClass('o-form-edit-mode');
            this.$el.removeClass('o-form-read-mode');
            this.$('.o-form-content').removeClass('rounded-btm-4');
            this.focus();
        } else {
            this.$el.removeClass('o-form-edit-mode');
            this.$el.addClass('o-form-read-mode');
            this.$('.o-form-content').addClass('rounded-btm-4');
        }
    },
    /**
   * Is the form in edit mode
   * @return {Boolean}
   * @private
   */ _editMode: function() {
        return this.model.get('__edit__') || !this.hasReadMode();
    },
    /**
   * Function can be overridden to alter top level error summary.
   * @param {Object} responseJSON
   *
   * @example
   * // responseJSON object
   * {
   *  errorCauses: [{errorSummary: "At least one of Proxy Status, Location, or ASN should be configured."}]
   *  errorSummary: "At least one of Proxy Status, Location, or ASN should be configured."
   *  errorCode: "E0000001"
   *  errorId: "oaepsrTCHrhT-eIi8XTm6KWWg"
   *  errorLink: "E0000001"
   *  errorSummary: "Api validation failed: networkZone"
   * }
   *
   * @method
   * @default _.identity
   */ parseErrorMessage: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).identity,
    _handleErrorScroll: function() {
        if (!this.getAttribute('scrollOnError')) return;
        const $el = (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)('#' + this.id + ' .o-form-error-container');
        if ($el.length) {
            let $scrollContext = $el.scrollParent();
            let scrollTop; // scrollParent was almost awesome...
            // but it returns document if there are no other scrollable parents
            // document does not have offset, so here we have to replace with html, body
            // Additionally when the scroll context is html, body, $el.offset().top is fixed
            // versus when it has a different scroll context it's dynamic and requires the
            // calculation below.
            if ($scrollContext[0] === document) {
                $scrollContext = (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)('html, body');
                scrollTop = $el.offset().top;
            } else scrollTop = $scrollContext.scrollTop() + $el.offset().top - $scrollContext.offset().top;
            $scrollContext.animate({
                scrollTop: scrollTop
            }, 400);
        }
    },
    /**
   * Show an error message based on an XHR error
   * @param  {Okta.BaseModel} model the model
   * @param  {jqXHR} xhr The jQuery XmlHttpRequest Object
   * @private
   */ __showErrors: function(model, resp, showBanner) {
        this.trigger('error', model);
        /* eslint max-statements: 0 */ if (!this.getAttribute('showErrors')) return;
        let errorSummary;
        let responseJSON = (0, $ae20611821b07f77$export$2e2bcd8739ae039).getResponseJSON(resp);
        const validationErrors = (0, $ae20611821b07f77$export$2e2bcd8739ae039).parseFieldErrors(resp); // trigger events for field validation errors
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).size(validationErrors)) (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(validationErrors, function(errors, field) {
            this.model.trigger('form:field-error', this.__errorFields[field] || field, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).map(errors, function(error) {
                return /^model\.validation/.test(error) ? (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize(error, 'courage') : error;
            }));
        }, this);
        else {
            responseJSON = this.parseErrorMessage(responseJSON);
            errorSummary = $1b4071d45909ff1b$var$getErrorSummary(responseJSON);
        } // show the error message
        if (showBanner) {
            this.$('.o-form-error-container').addClass('o-form-has-errors');
            this.add((0, $a24efd35b2ab2666$export$2e2bcd8739ae039), '.o-form-error-container', {
                options: {
                    errorSummary: errorSummary
                }
            });
        } // slide to and focus on the error message
        this._handleErrorScroll();
        this.model.trigger('form:resize');
    },
    /**
   * Clears the error banner
   * @private
   */ clearErrors: function() {
        this.$('.o-form-error-container').removeClass('o-form-has-errors');
        this.model.trigger('form:clear-errors');
        this.model.trigger('form:resize');
    },
    /**
   * Toggles between edit and read mode
   */ toggle: function() {
        this.model.set('__edit__', !this.hasReadMode() || !this.model.get('__edit__'));
        return this;
    },
    __addLayoutItem: function(input) {
        if ((0, $a9b2696677feee1f$export$2e2bcd8739ae039).supports(input)) this.addInput(input);
        else this.__addNonInputLayoutItem(input);
    },
    __addNonInputLayoutItem: function(item) {
        const itemOptions = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(item, 'type');
        switch(item.type){
            case 'sectionTitle':
                this.addSectionTitle(item.title, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(itemOptions, 'title'));
                break;
            case 'divider':
                this.addDivider(itemOptions);
                break;
            default:
                throw new Error('unknown input: ' + item.type);
        }
    },
    /**
   * Adds a view to the buttons tool bar
   * @param {Object} params parameterized button options
   * @param {Object} options options to send to {@link module:Okta.View#add|View.add}
   */ addButton: function(params, options) {
        this.__toolbar && this.__toolbar.addButton(params, options);
        this.__buttons.push([
            params,
            options
        ]);
    },
    /**
   * Adds a divider
   */ addDivider: function(options) {
        this.add('<div class="okta-form-divider form-divider"></div>');
        (0, $a6671880aee1fa70$export$2e2bcd8739ae039).applyShowWhen(this.last(), options && options.showWhen);
        (0, $a6671880aee1fa70$export$2e2bcd8739ae039).applyToggleWhen(this.last(), options && options.toggleWhen);
        return this;
    },
    /**
   * Adds section header
   * @param {String} title
   */ addSectionTitle: function(title, options) {
        this.add($1b4071d45909ff1b$var$sectionTitleTemplate({
            title: title
        }));
        (0, $a6671880aee1fa70$export$2e2bcd8739ae039).applyShowWhen(this.last(), options && options.showWhen);
        (0, $a6671880aee1fa70$export$2e2bcd8739ae039).applyToggleWhen(this.last(), options && options.toggleWhen);
        return this;
    },
    /**
   * Add a form input
   * @param {Object} options Options to describe the input
   * @param {String} options.type The input type.
   * The options are: `text`, `textarea`, `select`, `checkbox`, `radio`, `switch`,
   * `password`, `number`, `textselect`, `date`, `grouppicker`, `admingrouppicker`, `su-orgspicker`
   * `file/image`, `file/cert`, `checkboxset`, `list`, `group`, `zonepicker`
   * @param {String} options.name The name of the model field this input mutates
   * @param {String|Function} [options.label]
   * The input label text.
   * When passed as a function, will invoke the function (in the context of the {@link InputLabel})
   * on render time, and use the returned value.
   * @param {String} [options.sublabel] The input sub label text
   * @param {String} [options.tooltip] A popover tooltip to be displayed next to the label
   * @param {String} [options.placeholder] Placeholder text.
   * @param {String} [options.explain] Explanation text to render below the input
   * @param {Okta.View} [options.customExplain] A custom view to render below the input (deprecated)
   * @param {Boolean} [options.disabled=false] Make this input disabled
   * @param {Boolean} [options.wide=false] Use a wide input layout
   * @param {Boolean} [options.label-top=false] position label on top of an input
   * @param {Boolean} [options.explain-top=false] position explain on top of an input (requires label-top=true)
   * @param {Number} [options.multi] have multiple in-line inputs. useful when `input` is passed as an array of inputs
   * @param {String} [options.errorField] The API error field here that maps to this input
   * @param {Boolean} [options.inlineValidation=true] Validate input on focusout
   * @param {String} [options.ariaLabel] Used to add aria-label attribute to the input when label is not present.
   * @param {Boolean} [options.group=false] Grouping set of inputs using fieldset and legend. Mainly for radio
   * @param {Object} [options.options]
   * In the context of `radio` and `select`, a key/value set of options
   *
   * @param {Object} [options.params]
   * Widget specific parameters. Varies per input.
   *
   * @param {BaseInput|Object[]} [options.input]
   * - A custom input "class" or instance - preferably a **class**, so we can automagically assign the right
   * parameters when initializing it
   * - An array of input definition object literals (such as this one)
   *
   * @param {Object} [options.showWhen]
   * Setting to define when to show (or hide) the input. The input is visible by default.
   *
   * @param {Object} [options.bindings]
   * Bind a certain model attribute to a callback function, so the function is being called on render,
   * and any time this model field changes.
   * This is similar to `showWhen` but is not limited to toggling.
   *
   * @param {Function} [options.render]
   * A post-render hook that will run upon render on InputWrapper
   *
   * @param {String|Function} className   A className to apply on the {@link InputWrapper}
   *
   * @param {Function} [options.initialize]
   * An `initialize` function to run when initializing the {@link InputWrapper}
   * Useful for state mutation on start time, and complex state logic
   *
   * @example
   * // showhen: the field will be visible when `advanced` is set to `true`
   * // and `mode` is set to `"ON"`.
   * showWhen: {
   *   'advanced': true,
   *   'mode': function (value) {
   *     return value == 'ON'; // this is identical to this.model.get('mode') == 'ON'
   *   }
   * }
   *
   * @example
   * // bindings
   * bindings: {
   *   'status mode': function (status, mode) {
   *      var labelView = this.getLabel();
   *      if (status == 1) {
   *        labelView.options.label = 'Something';
   *      }
   *      else {
   *        labelView.options.label = mode;
   *      }
   *      labelView.render();
   *   }
   * }
   */ addInput: function(_options) {
        _options = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone(_options);
        (0, $a6671880aee1fa70$export$2e2bcd8739ae039).validateInput(_options, this.model);
        const inputsOptions = (0, $a6671880aee1fa70$export$2e2bcd8739ae039).generateInputOptions(_options, this, this.__createInput).reverse(); // We need a local variable here to keep track
        // as addInput can be called either directy or through the inputs array.
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(this.getInputs().toArray())) (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend(inputsOptions[0], {
            validateOnlyIfDirty: true
        });
        const inputs = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).map(inputsOptions, this.__createInput, this);
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(inputsOptions, function(input) {
            if (input.errorField) this.__errorFields[input.errorField] = input.name;
        }, this);
        const options = {
            inputId: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).last(inputs).options.inputId,
            input: inputs,
            multi: inputsOptions.length > 1 ? inputsOptions.length : undefined
        };
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend(options, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(this.options, 'input'), (0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(_options, 'input'));
        const inputWrapper = this.__createWrapper(options);
        if (options.label !== false) inputWrapper.add(this.__createLabel(options));
        inputWrapper.add(this._createContainer(options)); // TODO: there may be a bug here.
        // options.input will always be an array, so options.input.type will always be undefined
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        /// @ts-ignore
        inputWrapper.type = options.type || options.input.type || 'custom';
        const args = [
            inputWrapper
        ].concat((0, $3e490973b7383cc4$export$2e2bcd8739ae039).rest(arguments));
        return this.add.apply(this, args);
    },
    /**
   * @private
   */ __createInput: function(options) {
        options = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).pick(options, (0, $a6671880aee1fa70$export$2e2bcd8739ae039).INPUT_OPTIONS);
        return (0, $a9b2696677feee1f$export$2e2bcd8739ae039).create(options);
    },
    /**
   * @private
   */ __createWrapper: function(options) {
        options = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).pick(options, (0, $a6671880aee1fa70$export$2e2bcd8739ae039).WRAPPER_OPTIONS);
        return new (0, $f5bf630fc9eb39d5$export$2e2bcd8739ae039)(options);
    },
    /**
   * @private
   */ __createLabel: function(options) {
        options = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).pick(options, (0, $a6671880aee1fa70$export$2e2bcd8739ae039).LABEL_OPTIONS);
        return new (0, $539689c737fd4b6f$export$2e2bcd8739ae039)(options);
    },
    /**
   * @private
   */ _createContainer: function(options) {
        options = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).pick(options, (0, $a6671880aee1fa70$export$2e2bcd8739ae039).CONTAINER_OPTIONS);
        return new (0, $96ed0788ab09b8e9$export$2e2bcd8739ae039)(options);
    },
    /**
   * Stores the current attributes of the model to a private property
   * @param  {Okta.BaseModel} model The model
   * @private
   */ __saveModelState: function(model) {
        this.__originalModel = (0, $b51a961f9fe28c76$export$2e2bcd8739ae039).extend(true, {}, model.attributes);
    },
    /**
   * @override
   * @ignore
   */ add: function(...args) {
        // sets a default element selector
        typeof args[1] === 'undefined' && (args[1] = '> div.o-form-content > .o-form-fieldset-container');
        return (0, $5f539c045973220f$export$2e2bcd8739ae039).prototype.add.apply(this, args);
    },
    /**
   * Set the focus on the first input in the form
   */ focus: function() {
        const first = this.getInputs().first();
        if (first && first.focus) first.focus();
        return this;
    },
    /**
   * Disable all inputs in the form
   * @deprecated not currently in use
   */ disable: function() {
        this.invoke('disable');
        return this;
    },
    /**
   * Enable all inputs in the form
   * @deprecated not currently in use
   */ enable: function() {
        this.invoke('enable');
    },
    /**
   * Set the max-height for o-form-content class container within the form if a height is provided,
   * otherwise, get its computed inner height
   * @param {Number} the height in pixel to set for class o-form-content
   * @return {Number}
   */ contentHeight: function(height) {
        const content = this.$('.o-form-content');
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isNumber(height)) content.css('max-height', height);
        else return content.height();
    },
    /**
   * Get only the input children
   * @return {InputWrapper[]} An underscore wrapped array of {@link InputWrapper} instances
   */ getInputs: function() {
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039)(this.filter(function(view) {
            return view instanceof (0, $f5bf630fc9eb39d5$export$2e2bcd8739ae039);
        }));
    }
});












// Chosen, a Select Box Enhancer for jQuery and Prototype
// by Patrick Filler for Harvest, http://getharvest.com
//
// Version 0.11.1
// Full source at https://github.com/harvesthq/chosen
// Copyright (c) 2011 Harvest http://getharvest.com
// MIT License, https://github.com/harvesthq/chosen/blob/master/LICENSE.md
// This file is generated by `grunt build`, do not edit it by hand.
(function() {
    var jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports)));
    (function() {
        var SelectParser;
        SelectParser = function() {
            function SelectParser() {
                this.options_index = 0;
                this.parsed = [];
            }
            SelectParser.prototype.add_node = function(child) {
                if (child.nodeName.toUpperCase() === "OPTGROUP") return this.add_group(child);
                else return this.add_option(child);
            };
            SelectParser.prototype.add_group = function(group) {
                var group_position, option, _i, _len, _ref, _results;
                group_position = this.parsed.length;
                this.parsed.push({
                    array_index: group_position,
                    group: true,
                    label: group.label,
                    children: 0,
                    disabled: group.disabled
                });
                _ref = group.childNodes;
                _results = [];
                for(_i = 0, _len = _ref.length; _i < _len; _i++){
                    option = _ref[_i];
                    _results.push(this.add_option(option, group_position, group.disabled));
                }
                return _results;
            };
            SelectParser.prototype.add_option = function(option, group_position, group_disabled) {
                if (option.nodeName.toUpperCase() === "OPTION") {
                    if (option.text !== "") {
                        if (group_position != null) this.parsed[group_position].children += 1;
                        this.parsed.push({
                            array_index: this.parsed.length,
                            options_index: this.options_index,
                            value: option.value,
                            text: option.text,
                            html: option.innerHTML,
                            selected: option.selected,
                            disabled: group_disabled === true ? group_disabled : option.disabled,
                            group_array_index: group_position,
                            classes: option.className,
                            style: option.style.cssText
                        });
                    } else this.parsed.push({
                        array_index: this.parsed.length,
                        options_index: this.options_index,
                        empty: true
                    });
                    return this.options_index += 1;
                }
            };
            return SelectParser;
        }();
        SelectParser.select_to_array = function(select) {
            var child, parser, _i, _len, _ref;
            parser = new SelectParser();
            _ref = select.childNodes;
            for(_i = 0, _len = _ref.length; _i < _len; _i++){
                child = _ref[_i];
                parser.add_node(child);
            }
            return parser.parsed;
        };
        this.SelectParser = SelectParser;
    }).call(window);
    (function() {
        var AbstractChosen, root;
        root = this;
        AbstractChosen = function() {
            function AbstractChosen(form_field, options) {
                this.form_field = form_field;
                this.options = options != null ? options : {};
                if (!AbstractChosen.browser_is_supported()) return;
                this.is_multiple = this.form_field.multiple;
                this.set_default_text();
                this.set_default_values();
                this.setup();
                this.set_up_html();
                this.register_observers();
                this.finish_setup();
            }
            AbstractChosen.prototype.set_default_values = function() {
                var _this = this;
                this.click_test_action = function(evt) {
                    return _this.test_active_click(evt);
                };
                this.activate_action = function(evt) {
                    return _this.activate_field(evt);
                };
                this.active_field = false;
                this.mouse_on_container = false;
                this.results_showing = false;
                this.result_highlighted = null;
                this.result_single_selected = null;
                this.allow_single_deselect = this.options.allow_single_deselect != null && this.form_field.options[0] != null && this.form_field.options[0].text === "" ? this.options.allow_single_deselect : false;
                this.disable_search_threshold = this.options.disable_search_threshold || 0;
                this.disable_search = this.options.disable_search || false;
                this.enable_split_word_search = this.options.enable_split_word_search != null ? this.options.enable_split_word_search : true;
                this.search_contains = this.options.search_contains || false;
                this.single_backstroke_delete = this.options.single_backstroke_delete || false;
                this.max_selected_options = this.options.max_selected_options || Infinity;
                return this.inherit_select_classes = this.options.inherit_select_classes || false;
            };
            AbstractChosen.prototype.set_default_text = function() {
                if (this.form_field.getAttribute("data-placeholder")) this.default_text = this.form_field.getAttribute("data-placeholder");
                else if (this.is_multiple) this.default_text = this.options.placeholder_text_multiple || this.options.placeholder_text || AbstractChosen.default_multiple_text;
                else this.default_text = this.options.placeholder_text_single || this.options.placeholder_text || AbstractChosen.default_single_text;
                return this.results_none_found = this.form_field.getAttribute("data-no_results_text") || this.options.no_results_text || AbstractChosen.default_no_result_text;
            };
            AbstractChosen.prototype.mouse_enter = function() {
                return this.mouse_on_container = true;
            };
            AbstractChosen.prototype.mouse_leave = function() {
                return this.mouse_on_container = false;
            };
            AbstractChosen.prototype.input_focus = function(evt) {
                var _this = this;
                if (this.is_multiple) {
                    if (!this.active_field) return setTimeout(function() {
                        return _this.container_mousedown();
                    }, 50);
                } else {
                    if (!this.active_field) return this.activate_field();
                }
            };
            AbstractChosen.prototype.input_blur = function(evt) {
                var _this = this;
                if (!this.mouse_on_container) {
                    this.active_field = false;
                    return setTimeout(function() {
                        return _this.blur_test();
                    }, 100);
                }
            };
            AbstractChosen.prototype.result_add_option = function(option) {
                var classes, style;
                option.dom_id = this.container_id + "_o_" + option.array_index;
                classes = [];
                if (!option.disabled && !(option.selected && this.is_multiple)) classes.push("active-result");
                if (option.disabled && !(option.selected && this.is_multiple)) classes.push("disabled-result");
                if (option.selected) classes.push("result-selected");
                if (option.group_array_index != null) classes.push("group-option");
                if (option.classes !== "") classes.push(option.classes);
                 // OKTA-541263 custom code here
                // We want to avoid use a style attribute for empty style so we don't violate CSP
                style = option.style.cssText !== "" && option.style !== "" ? " style=\"" + option.style + "\"" : "";
                return '<li id="' + option.dom_id + '" class="' + classes.join(' ') + '"' + style + '>' + option.html + '</li>';
            };
            AbstractChosen.prototype.results_update_field = function() {
                this.set_default_text();
                if (!this.is_multiple) this.results_reset_cleanup();
                this.result_clear_highlight();
                this.result_single_selected = null;
                return this.results_build();
            };
            AbstractChosen.prototype.results_toggle = function() {
                if (this.results_showing) return this.results_hide();
                else return this.results_show();
            };
            AbstractChosen.prototype.results_search = function(evt) {
                if (this.results_showing) return this.winnow_results();
                else return this.results_show();
            };
            AbstractChosen.prototype.choices_count = function() {
                var option, _i, _len, _ref;
                if (this.selected_option_count != null) return this.selected_option_count;
                this.selected_option_count = 0;
                _ref = this.form_field.options;
                for(_i = 0, _len = _ref.length; _i < _len; _i++){
                    option = _ref[_i];
                    if (option.selected) this.selected_option_count += 1;
                }
                return this.selected_option_count;
            };
            AbstractChosen.prototype.choices_click = function(evt) {
                evt.preventDefault();
                if (!(this.results_showing || this.is_disabled)) return this.results_show();
            };
            AbstractChosen.prototype.keyup_checker = function(evt) {
                var stroke, _ref;
                stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
                this.search_field_scale();
                switch(stroke){
                    case 8:
                        if (this.is_multiple && this.backstroke_length < 1 && this.choices_count() > 0) return this.keydown_backstroke();
                        else if (!this.pending_backstroke) {
                            this.result_clear_highlight();
                            return this.results_search();
                        }
                        break;
                    case 13:
                        evt.preventDefault();
                        if (this.results_showing) return this.result_select(evt);
                        break;
                    case 27:
                        if (this.results_showing) this.results_hide();
                        return true;
                    case 9:
                    case 38:
                    case 40:
                    case 16:
                    case 91:
                    case 17:
                        break;
                    default:
                        return this.results_search();
                }
            };
            AbstractChosen.prototype.generate_field_id = function() {
                var new_id;
                new_id = this.generate_random_id();
                this.form_field.id = new_id;
                return new_id;
            };
            AbstractChosen.prototype.generate_random_char = function() {
                var chars, rand;
                chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
                rand = Math.floor(Math.random() * chars.length);
                return chars.substring(rand, rand + 1);
            };
            AbstractChosen.prototype.container_width = function() {
                if (this.options.width != null) return this.options.width;
                else return "" + this.form_field.offsetWidth + "px";
            };
            AbstractChosen.browser_is_supported = function() {
                var _ref;
                if (window.navigator.appName === "Microsoft Internet Explorer") return null !== (_ref = document.documentMode) && _ref >= 8;
                return true;
            };
            AbstractChosen.default_multiple_text = "Select Some Options";
            AbstractChosen.default_single_text = "Select an Option";
            AbstractChosen.default_no_result_text = "No results match";
            return AbstractChosen;
        }();
        root.AbstractChosen = AbstractChosen;
    }).call(window);
    (function() {
        var $, Chosen, root, _ref, __hasProp = {}.hasOwnProperty, __extends = function(child, parent) {
            for(var key in parent)if (__hasProp.call(parent, key)) child[key] = parent[key];
            function ctor() {
                this.constructor = child;
            }
            ctor.prototype = parent.prototype;
            child.prototype = new ctor();
            child.__super__ = parent.prototype;
            return child;
        };
        root = this; // OKTA-93521 - plugin assumes root is global scope
        var AbstractChosen = root.AbstractChosen;
        $ = jQuery;
        $.fn.extend({
            chosen: function(options) {
                if (!AbstractChosen.browser_is_supported()) return this;
                return this.each(function(input_field) {
                    var $this;
                    $this = $(this);
                    if (!$this.hasClass("chzn-done")) return $this.data('chosen', new Chosen(this, options));
                });
            }
        });
        Chosen = function(_super) {
            __extends(Chosen, _super);
            function Chosen() {
                _ref = Chosen.__super__.constructor.apply(this, arguments);
                return _ref;
            }
            Chosen.prototype.setup = function() {
                this.form_field_jq = $(this.form_field);
                this.current_selectedIndex = this.form_field.selectedIndex;
                return this.is_rtl = this.form_field_jq.hasClass("chzn-rtl");
            };
            Chosen.prototype.finish_setup = function() {
                return this.form_field_jq.addClass("chzn-done");
            };
            Chosen.prototype.set_up_html = function() {
                var container_classes, container_props;
                this.container_id = this.form_field.id.length ? this.form_field.id.replace(/[^\w]/g, '_') : this.generate_field_id();
                this.container_id += "_chzn";
                container_classes = [
                    "chzn-container"
                ];
                container_classes.push("chzn-container-" + (this.is_multiple ? "multi" : "single"));
                if (this.inherit_select_classes && this.form_field.className) container_classes.push(this.form_field.className);
                if (this.is_rtl) container_classes.push("chzn-rtl");
                container_props = {
                    'id': this.container_id,
                    'class': container_classes.join(' '),
                    'title': this.form_field.title
                };
                this.container = $("<div></div>", container_props);
                this.container[0].style.width = this.container_width();
                if (this.is_multiple) this.container.html('<ul class="chzn-choices"><li class="search-field"><input type="text" value="' + this.default_text + '" class="default" autocomplete="off" style="width:25px;" /></li></ul><div class="chzn-drop"><ul class="chzn-results"></ul></div>');
                else this.container.html('<a href="#" class="chzn-single chzn-default" tabindex="-1"><span>' + this.default_text + '</span><div><b></b></div></a><div class="chzn-drop"><div class="chzn-search"><input type="text" autocomplete="off" /></div><ul class="chzn-results"></ul></div>');
                this.form_field_jq.hide().after(this.container);
                this.dropdown = this.container.find('div.chzn-drop').first();
                this.search_field = this.container.find('input').first();
                this.search_results = this.container.find('ul.chzn-results').first();
                this.search_field_scale();
                this.search_no_results = this.container.find('li.no-results').first();
                if (this.is_multiple) {
                    this.search_choices = this.container.find('ul.chzn-choices').first();
                    this.search_container = this.container.find('li.search-field').first();
                } else {
                    this.search_container = this.container.find('div.chzn-search').first();
                    this.selected_item = this.container.find('.chzn-single').first();
                }
                this.results_build();
                this.set_tab_index();
                this.set_label_behavior();
                return this.form_field_jq.trigger("liszt:ready", {
                    chosen: this
                });
            };
            Chosen.prototype.register_observers = function() {
                var _this = this;
                this.container.mousedown(function(evt) {
                    _this.container_mousedown(evt);
                });
                this.container.mouseup(function(evt) {
                    _this.container_mouseup(evt);
                });
                this.container.mouseenter(function(evt) {
                    _this.mouse_enter(evt);
                });
                this.container.mouseleave(function(evt) {
                    _this.mouse_leave(evt);
                });
                this.search_results.mouseup(function(evt) {
                    _this.search_results_mouseup(evt);
                });
                this.search_results.mouseover(function(evt) {
                    _this.search_results_mouseover(evt);
                });
                this.search_results.mouseout(function(evt) {
                    _this.search_results_mouseout(evt);
                });
                this.search_results.bind('mousewheel DOMMouseScroll', function(evt) {
                    _this.search_results_mousewheel(evt);
                });
                this.form_field_jq.bind("liszt:updated", function(evt) {
                    _this.results_update_field(evt);
                });
                this.form_field_jq.bind("liszt:activate", function(evt) {
                    _this.activate_field(evt);
                });
                this.form_field_jq.bind("liszt:open", function(evt) {
                    _this.container_mousedown(evt);
                });
                this.search_field.blur(function(evt) {
                    _this.input_blur(evt);
                });
                this.search_field.keyup(function(evt) {
                    _this.keyup_checker(evt);
                });
                this.search_field.keydown(function(evt) {
                    _this.keydown_checker(evt);
                });
                this.search_field.focus(function(evt) {
                    _this.input_focus(evt);
                });
                if (this.is_multiple) return this.search_choices.click(function(evt) {
                    _this.choices_click(evt);
                });
                else return this.container.click(function(evt) {
                    evt.preventDefault();
                });
            };
            Chosen.prototype.search_field_disabled = function() {
                this.is_disabled = this.form_field_jq[0].disabled;
                if (this.is_disabled) {
                    this.container.addClass('chzn-disabled');
                    this.search_field[0].disabled = true;
                    if (!this.is_multiple) this.selected_item.unbind("focus", this.activate_action);
                    return this.close_field();
                } else {
                    this.container.removeClass('chzn-disabled');
                    this.search_field[0].disabled = false;
                    if (!this.is_multiple) return this.selected_item.bind("focus", this.activate_action);
                }
            };
            Chosen.prototype.container_mousedown = function(evt) {
                if (!this.is_disabled) {
                    if (evt && evt.type === "mousedown" && !this.results_showing) evt.preventDefault();
                    if (!(evt != null && $(evt.target).hasClass("search-choice-close"))) {
                        if (!this.active_field) {
                            if (this.is_multiple) this.search_field.val("");
                            $(document).click(this.click_test_action);
                            this.results_show();
                        } else if (!this.is_multiple && evt && ($(evt.target)[0] === this.selected_item[0] || $(evt.target).parents("a.chzn-single").length)) {
                            evt.preventDefault();
                            this.results_toggle();
                        }
                        return this.activate_field();
                    }
                }
            };
            Chosen.prototype.container_mouseup = function(evt) {
                if (evt.target.nodeName === "ABBR" && !this.is_disabled) return this.results_reset(evt);
            };
            Chosen.prototype.search_results_mousewheel = function(evt) {
                var delta, _ref1, _ref2;
                delta = -((_ref1 = evt.originalEvent) != null ? _ref1.wheelDelta : void 0) || ((_ref2 = evt.originialEvent) != null ? _ref2.detail : void 0);
                if (delta != null) {
                    evt.preventDefault();
                    if (evt.type === 'DOMMouseScroll') delta = delta * 40;
                    return this.search_results.scrollTop(delta + this.search_results.scrollTop());
                }
            };
            Chosen.prototype.blur_test = function(evt) {
                if (!this.active_field && this.container.hasClass("chzn-container-active")) return this.close_field();
            };
            Chosen.prototype.close_field = function() {
                $(document).unbind("click", this.click_test_action);
                this.active_field = false;
                this.results_hide();
                this.container.removeClass("chzn-container-active");
                this.clear_backstroke();
                this.show_search_field_default();
                return this.search_field_scale();
            };
            Chosen.prototype.activate_field = function() {
                this.container.addClass("chzn-container-active");
                this.active_field = true;
                this.search_field.val(this.search_field.val());
                return this.search_field.focus();
            };
            Chosen.prototype.test_active_click = function(evt) {
                if ($(evt.target).parents('#' + this.container_id).length) return this.active_field = true;
                else return this.close_field();
            };
            Chosen.prototype.results_build = function() {
                var content, data, _i, _len, _ref1;
                this.parsing = true;
                this.selected_option_count = null;
                this.results_data = root.SelectParser.select_to_array(this.form_field);
                if (this.is_multiple) this.search_choices.find("li.search-choice").remove();
                else if (!this.is_multiple) {
                    this.selected_item.addClass("chzn-default").find("span").text(this.default_text);
                    if (this.disable_search || this.form_field.options.length <= this.disable_search_threshold) {
                        this.search_field[0].readOnly = true;
                        this.container.addClass("chzn-container-single-nosearch");
                    } else {
                        this.search_field[0].readOnly = false;
                        this.container.removeClass("chzn-container-single-nosearch");
                    }
                }
                content = '';
                _ref1 = this.results_data;
                for(_i = 0, _len = _ref1.length; _i < _len; _i++){
                    data = _ref1[_i];
                    if (data.group) content += this.result_add_group(data);
                    else if (!data.empty) {
                        content += this.result_add_option(data);
                        if (data.selected && this.is_multiple) this.choice_build(data);
                        else if (data.selected && !this.is_multiple) {
                            this.selected_item.removeClass("chzn-default").find("span").text(data.text);
                            if (this.allow_single_deselect) this.single_deselect_control_build();
                        }
                    }
                }
                this.search_field_disabled();
                this.show_search_field_default();
                this.search_field_scale();
                this.search_results.html(content);
                return this.parsing = false;
            };
            Chosen.prototype.result_add_group = function(group) {
                group.dom_id = this.container_id + "_g_" + group.array_index;
                return '<li id="' + group.dom_id + '" class="group-result">' + $("<div></div>").text(group.label).html() + '</li>';
            };
            Chosen.prototype.result_do_highlight = function(el) {
                var high_bottom, high_top, maxHeight, visible_bottom, visible_top;
                if (el.length) {
                    this.result_clear_highlight();
                    this.result_highlight = el;
                    this.result_highlight.addClass("highlighted");
                    maxHeight = parseInt(this.search_results.css("maxHeight"), 10);
                    visible_top = this.search_results.scrollTop();
                    visible_bottom = maxHeight + visible_top;
                    high_top = this.result_highlight.position().top + this.search_results.scrollTop();
                    high_bottom = high_top + this.result_highlight.outerHeight();
                    if (high_bottom >= visible_bottom) return this.search_results.scrollTop(high_bottom - maxHeight > 0 ? high_bottom - maxHeight : 0);
                    else if (high_top < visible_top) return this.search_results.scrollTop(high_top);
                }
            };
            Chosen.prototype.result_clear_highlight = function() {
                if (this.result_highlight) this.result_highlight.removeClass("highlighted");
                return this.result_highlight = null;
            };
            Chosen.prototype.results_show = function() {
                if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
                    this.form_field_jq.trigger("liszt:maxselected", {
                        chosen: this
                    });
                    return false;
                }
                this.container.addClass("chzn-with-drop");
                this.form_field_jq.trigger("liszt:showing_dropdown", {
                    chosen: this
                });
                this.results_showing = true;
                this.search_field.focus();
                this.search_field.val(this.search_field.val());
                return this.winnow_results();
            };
            Chosen.prototype.results_hide = function() {
                if (this.results_showing) {
                    this.result_clear_highlight();
                    this.container.removeClass("chzn-with-drop");
                    this.form_field_jq.trigger("liszt:hiding_dropdown", {
                        chosen: this
                    });
                }
                return this.results_showing = false;
            };
            Chosen.prototype.set_tab_index = function(el) {
                var ti;
                if (this.form_field_jq.attr("tabindex")) {
                    ti = this.form_field_jq.attr("tabindex");
                    this.form_field_jq.attr("tabindex", -1);
                    return this.search_field.attr("tabindex", ti);
                }
            };
            Chosen.prototype.set_label_behavior = function() {
                var _this = this;
                this.form_field_label = this.form_field_jq.parents("label");
                if (!this.form_field_label.length && this.form_field.id.length) this.form_field_label = $("label[for='" + this.form_field.id + "']");
                if (this.form_field_label.length > 0) return this.form_field_label.click(function(evt) {
                    if (_this.is_multiple) return _this.container_mousedown(evt);
                    else return _this.activate_field();
                });
            };
            Chosen.prototype.show_search_field_default = function() {
                if (this.is_multiple && this.choices_count() < 1 && !this.active_field) {
                    this.search_field.val(this.default_text);
                    return this.search_field.addClass("default");
                } else {
                    this.search_field.val("");
                    return this.search_field.removeClass("default");
                }
            };
            Chosen.prototype.search_results_mouseup = function(evt) {
                var target;
                target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
                if (target.length) {
                    this.result_highlight = target;
                    this.result_select(evt);
                    return this.search_field.focus();
                }
            };
            Chosen.prototype.search_results_mouseover = function(evt) {
                var target;
                target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
                if (target) return this.result_do_highlight(target);
            };
            Chosen.prototype.search_results_mouseout = function(evt) {
                if ($(evt.target).hasClass("active-result")) return this.result_clear_highlight();
            };
            Chosen.prototype.choice_build = function(item) {
                var choice, close_link, _this = this;
                choice = $('<li></li>', {
                    "class": "search-choice"
                }).html("<span>" + item.html + "</span>");
                if (item.disabled) choice.addClass('search-choice-disabled');
                else {
                    close_link = $('<a></a>', {
                        href: '#',
                        "class": 'search-choice-close',
                        rel: item.array_index
                    });
                    close_link.click(function(evt) {
                        return _this.choice_destroy_link_click(evt);
                    });
                    choice.append(close_link);
                }
                return this.search_container.before(choice);
            };
            Chosen.prototype.choice_destroy_link_click = function(evt) {
                evt.preventDefault();
                evt.stopPropagation();
                if (!this.is_disabled) return this.choice_destroy($(evt.target));
            };
            Chosen.prototype.choice_destroy = function(link) {
                if (this.result_deselect(link.attr("rel"))) {
                    this.show_search_field_default();
                    if (this.is_multiple && this.choices_count() > 0 && this.search_field.val().length < 1) this.results_hide();
                    link.parents('li').first().remove();
                    return this.search_field_scale();
                }
            };
            Chosen.prototype.results_reset = function() {
                this.form_field.options[0].selected = true;
                this.selected_option_count = null;
                this.selected_item.find("span").text(this.default_text);
                if (!this.is_multiple) this.selected_item.addClass("chzn-default");
                this.show_search_field_default();
                this.results_reset_cleanup();
                this.form_field_jq.trigger("change");
                if (this.active_field) return this.results_hide();
            };
            Chosen.prototype.results_reset_cleanup = function() {
                this.current_selectedIndex = this.form_field.selectedIndex;
                return this.selected_item.find("abbr").remove();
            };
            Chosen.prototype.result_select = function(evt) {
                var high, high_id, item, position;
                if (this.result_highlight) {
                    high = this.result_highlight;
                    high_id = high.attr("id");
                    this.result_clear_highlight();
                    if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
                        this.form_field_jq.trigger("liszt:maxselected", {
                            chosen: this
                        });
                        return false;
                    }
                    if (this.is_multiple) high.removeClass("active-result");
                    else {
                        this.search_results.find(".result-selected").removeClass("result-selected");
                        this.result_single_selected = high;
                        this.selected_item.removeClass("chzn-default");
                    }
                    high.addClass("result-selected");
                    position = high_id.substr(high_id.lastIndexOf("_") + 1);
                    item = this.results_data[position];
                    item.selected = true;
                    this.form_field.options[item.options_index].selected = true;
                    this.selected_option_count = null;
                    if (this.is_multiple) this.choice_build(item);
                    else {
                        this.selected_item.find("span").first().text(item.text);
                        if (this.allow_single_deselect) this.single_deselect_control_build();
                    }
                    if (!((evt.metaKey || evt.ctrlKey) && this.is_multiple)) this.results_hide();
                    this.search_field.val("");
                    if (this.is_multiple || this.form_field.selectedIndex !== this.current_selectedIndex) this.form_field_jq.trigger("change", {
                        'selected': this.form_field.options[item.options_index].value
                    });
                    this.current_selectedIndex = this.form_field.selectedIndex;
                    return this.search_field_scale();
                }
            };
            Chosen.prototype.result_activate = function(el, option) {
                if (option.disabled) return el.addClass("disabled-result");
                else if (this.is_multiple && option.selected) return el.addClass("result-selected");
                else return el.addClass("active-result");
            };
            Chosen.prototype.result_deactivate = function(el) {
                return el.removeClass("active-result result-selected disabled-result");
            };
            Chosen.prototype.result_deselect = function(pos) {
                var result, result_data;
                result_data = this.results_data[pos];
                if (!this.form_field.options[result_data.options_index].disabled) {
                    result_data.selected = false;
                    this.form_field.options[result_data.options_index].selected = false;
                    this.selected_option_count = null;
                    result = $("#" + this.container_id + "_o_" + pos);
                    result.removeClass("result-selected").addClass("active-result").show();
                    this.result_clear_highlight();
                    this.winnow_results();
                    this.form_field_jq.trigger("change", {
                        deselected: this.form_field.options[result_data.options_index].value
                    });
                    this.search_field_scale();
                    return true;
                } else return false;
            };
            Chosen.prototype.single_deselect_control_build = function() {
                if (!this.allow_single_deselect) return;
                if (!this.selected_item.find("abbr").length) this.selected_item.find("span").first().after("<abbr class=\"search-choice-close\"></abbr>");
                return this.selected_item.addClass("chzn-single-with-deselect");
            };
            Chosen.prototype.winnow_results = function() {
                var found, option, part, parts, regex, regexAnchor, result, result_id, results, searchText, startpos, text, zregex, _i, _j, _len, _len1, _ref1;
                this.no_results_clear();
                results = 0;
                searchText = this.search_field.val() === this.default_text ? "" : $('<div></div>').text($.trim(this.search_field.val())).html();
                regexAnchor = this.search_contains ? "" : "^";
                regex = new RegExp(regexAnchor + searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), 'i');
                zregex = new RegExp(searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), 'i');
                _ref1 = this.results_data;
                for(_i = 0, _len = _ref1.length; _i < _len; _i++){
                    option = _ref1[_i];
                    if (!option.empty) {
                        if (option.group) $('#' + option.dom_id).css('display', 'none');
                        else {
                            found = false;
                            result_id = option.dom_id;
                            result = $("#" + result_id);
                            if (regex.test(option.html)) {
                                found = true;
                                results += 1;
                            } else if (this.enable_split_word_search && (option.html.indexOf(" ") >= 0 || option.html.indexOf("[") === 0)) {
                                parts = option.html.replace(/\[|\]/g, "").split(" ");
                                if (parts.length) for(_j = 0, _len1 = parts.length; _j < _len1; _j++){
                                    part = parts[_j];
                                    if (regex.test(part)) {
                                        found = true;
                                        results += 1;
                                    }
                                }
                            }
                            if (found) {
                                if (searchText.length) {
                                    startpos = option.html.search(zregex);
                                    text = option.html.substr(0, startpos + searchText.length) + '</em>' + option.html.substr(startpos + searchText.length);
                                    text = text.substr(0, startpos) + '<em>' + text.substr(startpos);
                                } else text = option.html;
                                result.html(text);
                                this.result_activate(result, option);
                                if (option.group_array_index != null) $("#" + this.results_data[option.group_array_index].dom_id).css('display', 'list-item');
                            } else {
                                if (this.result_highlight && result_id === this.result_highlight.attr('id')) this.result_clear_highlight();
                                this.result_deactivate(result);
                            }
                        }
                    }
                }
                if (results < 1 && searchText.length) return this.no_results(searchText);
                else return this.winnow_results_set_highlight();
            };
            Chosen.prototype.winnow_results_set_highlight = function() {
                var do_high, selected_results;
                if (!this.result_highlight) {
                    selected_results = !this.is_multiple ? this.search_results.find(".result-selected.active-result") : [];
                    do_high = selected_results.length ? selected_results.first() : this.search_results.find(".active-result").first();
                    if (do_high != null) return this.result_do_highlight(do_high);
                }
            };
            Chosen.prototype.no_results = function(terms) {
                var no_results_html;
                no_results_html = $('<li class="no-results">' + this.results_none_found + ' "<span></span>"</li>');
                no_results_html.find("span").first().html(terms);
                return this.search_results.append(no_results_html);
            };
            Chosen.prototype.no_results_clear = function() {
                return this.search_results.find(".no-results").remove();
            };
            Chosen.prototype.keydown_arrow = function() {
                var next_sib;
                if (this.results_showing && this.result_highlight) {
                    next_sib = this.result_highlight.nextAll("li.active-result").first();
                    if (next_sib) return this.result_do_highlight(next_sib);
                } else return this.results_show();
            };
            Chosen.prototype.keyup_arrow = function() {
                var prev_sibs;
                if (!this.results_showing && !this.is_multiple) return this.results_show();
                else if (this.result_highlight) {
                    prev_sibs = this.result_highlight.prevAll("li.active-result");
                    if (prev_sibs.length) return this.result_do_highlight(prev_sibs.first());
                    else {
                        if (this.choices_count() > 0) this.results_hide();
                        return this.result_clear_highlight();
                    }
                }
            };
            Chosen.prototype.keydown_backstroke = function() {
                var next_available_destroy;
                if (this.pending_backstroke) {
                    this.choice_destroy(this.pending_backstroke.find("a").first());
                    return this.clear_backstroke();
                } else {
                    next_available_destroy = this.search_container.siblings("li.search-choice").last();
                    if (next_available_destroy.length && !next_available_destroy.hasClass("search-choice-disabled")) {
                        this.pending_backstroke = next_available_destroy;
                        if (this.single_backstroke_delete) return this.keydown_backstroke();
                        else return this.pending_backstroke.addClass("search-choice-focus");
                    }
                }
            };
            Chosen.prototype.clear_backstroke = function() {
                if (this.pending_backstroke) this.pending_backstroke.removeClass("search-choice-focus");
                return this.pending_backstroke = null;
            };
            Chosen.prototype.keydown_checker = function(evt) {
                var stroke, _ref1;
                stroke = (_ref1 = evt.which) != null ? _ref1 : evt.keyCode;
                this.search_field_scale();
                if (stroke !== 8 && this.pending_backstroke) this.clear_backstroke();
                switch(stroke){
                    case 8:
                        this.backstroke_length = this.search_field.val().length;
                        break;
                    case 9:
                        if (this.results_showing && !this.is_multiple) this.result_select(evt);
                        this.mouse_on_container = false;
                        break;
                    case 13:
                        evt.preventDefault();
                        break;
                    case 38:
                        evt.preventDefault();
                        this.keyup_arrow();
                        break;
                    case 40:
                        evt.preventDefault();
                        this.keydown_arrow();
                        break;
                }
            };
            Chosen.prototype.search_field_scale = function() {
                var div, style, style_block, styles, w, _i, _len;
                if (this.is_multiple) {
                    w = 0;
                    style_block = "position:absolute; left: -1000px; top: -1000px; display:none;";
                    styles = [
                        'font-size',
                        'font-style',
                        'font-weight',
                        'font-family',
                        'line-height',
                        'text-transform',
                        'letter-spacing'
                    ];
                    for(_i = 0, _len = styles.length; _i < _len; _i++){
                        style = styles[_i];
                        style_block += style + ":" + this.search_field.css(style) + ";";
                    }
                    div = $('<div></div>', {
                        'style': style_block
                    });
                    div.text(this.search_field.val());
                    $('body').append(div);
                    w = div.width() + 25;
                    div.remove();
                    if (!this.f_width) this.f_width = this.container.outerWidth();
                    if (w > this.f_width - 10) w = this.f_width - 10;
                    return this.search_field.css({
                        'width': w + 'px'
                    });
                }
            };
            Chosen.prototype.generate_random_id = function() {
                var string;
                string = "sel" + this.generate_random_char() + this.generate_random_char() + this.generate_random_char();
                while($("#" + string).length > 0)string += this.generate_random_char();
                return string;
            };
            return Chosen;
        }(AbstractChosen);
        root.Chosen = Chosen;
    }).call(window);
})();










var $893f8a6b0b7a3602$export$2e2bcd8739ae039 = {
    DEBOUNCE_DELAY: 200,
    LOADING_FADE: 400,
    UNLOADING_FADE: 400,
    ROW_EXPANDER_TRANSITION: 150,
    HIDE_ADD_MAPPING_FORM: 300
};



function $a564d16b1ff800f7$var$getOption(callout, option) {
    return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).resultCtx(callout.options, option, callout) || (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(callout, option);
}
function $a564d16b1ff800f7$var$getTopClass(callout) {
    let klass = 'infobox clearfix infobox-' + $a564d16b1ff800f7$var$getOption(callout, 'type');
    switch($a564d16b1ff800f7$var$getOption(callout, 'size')){
        case 'standard':
            klass += '';
            break;
        case 'slim':
            klass += ' infobox-slim';
            break;
        case 'compact':
            klass += ' infobox-compact';
            break;
        case 'large':
            klass += ' infobox-md';
            break;
    }
    if ($a564d16b1ff800f7$var$getOption(callout, 'dismissible')) klass += ' infobox-dismiss';
    return klass;
}
const $a564d16b1ff800f7$var$events = {
    'click .infobox-dismiss-link': function(e) {
        e.preventDefault();
        this.$el.fadeOut((0, $893f8a6b0b7a3602$export$2e2bcd8739ae039).UNLOADING_FADE, ()=>{
            this.trigger('dismissed');
            this.remove();
        });
    }
};
const $a564d16b1ff800f7$var$template = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "0": function(container, depth0, helpers, partials, data) {
        var lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<a data-se=\"dismiss-link\" class=\"infobox-dismiss-link\" title=\"" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "i18n",
            "hash": {
                "bundle": "courage",
                "code": "component.dismiss"
            },
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 81
                },
                "end": {
                    "line": 1,
                    "column": 131
                }
            }
        })) + "\" href=\"#\"><span data-se=\"icon\" class=\"dismiss-icon\"></span></a>";
    },
    "1": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<h3 data-se=\"header\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "title",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 286
                },
                "end": {
                    "line": 1,
                    "column": 295
                }
            }
        }) : helper)) + "</h3>";
    },
    "2": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<p data-se=\"sub-header\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "subtitle") || (depth0 != null ? lookupProperty(depth0, "subtitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "subtitle",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 347
                },
                "end": {
                    "line": 1,
                    "column": 359
                }
            }
        }) : helper)) + "</p>";
    },
    "3": function(container, depth0, helpers, partials, data) {
        var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<ul data-se=\"list\" class=\"bullets\">" + ((stack1 = lookupProperty(helpers, "each").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "bullets") : depth0, {
            "name": "each",
            "hash": {},
            "fn": container.program(4, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 420
                },
                "end": {
                    "line": 1,
                    "column": 483
                }
            }
        })) != null ? stack1 : "") + "</ul>";
    },
    "4": function(container, depth0, helpers, partials, data) {
        return "<li data-se=\"list-item\">" + container.escapeExpression(container.lambda(depth0, depth0)) + "</li>";
    },
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "dismissible") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(0, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 0
                },
                "end": {
                    "line": 1,
                    "column": 202
                }
            }
        })) != null ? stack1 : "") + "<span data-se=\"icon\" class=\"icon " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "icon") || (depth0 != null ? lookupProperty(depth0, "icon") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
            "name": "icon",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 235
                },
                "end": {
                    "line": 1,
                    "column": 243
                }
            }
        }) : helper)) + "\"></span>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "title") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(1, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 252
                },
                "end": {
                    "line": 1,
                    "column": 307
                }
            }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "subtitle") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(2, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 307
                },
                "end": {
                    "line": 1,
                    "column": 370
                }
            }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "bullets") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(3, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 370
                },
                "end": {
                    "line": 1,
                    "column": 495
                }
            }
        })) != null ? stack1 : "");
    },
    "useData": true
});
const $a564d16b1ff800f7$var$CalloutCallout = (0, $5f539c045973220f$export$2e2bcd8739ae039).extend(/** @lends src/views/components/Callout.prototype */ {
    attributes: {
        'data-se': 'callout'
    },
    /**
   * Custom HTML or view to inject to the callout
   * @type {String|Okta.View}
   */ content: null,
    /**
   * Size of icon. options are standard, large, compact
   * @type {String}
   */ size: 'standard',
    /**
   * Type of the callout. Valid values are: info, success, warning, error, tip
   * @type {String}
   */ type: 'info',
    /**
   * Can the callout be dismissed
   * @type {Boolean}
   */ dismissible: false,
    /**
   * Callout title
   * @type {String}
   */ title: null,
    /**
   * Callout subtitle
   * @type {String}
   */ subtitle: null,
    /**
   * Array of strings to render as bullet points
   * @type {Array}
   */ bullets: null,
    /**
   * Fired after the callout is dismised - applies when
   * {@link module:Okta.internal.views.components.Callout|dismissible} is set to true
   * @event src/views/components/Callout#dismissed
   */ constructor: function() {
        this.events = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults(this.events || {}, $a564d16b1ff800f7$var$events);
        (0, $5f539c045973220f$export$2e2bcd8739ae039).apply(this, arguments);
        this.$el.addClass($a564d16b1ff800f7$var$getTopClass(this));
        this.template = $a564d16b1ff800f7$var$template;
        const content = $a564d16b1ff800f7$var$getOption(this, 'content');
        if (content) this.add(content);
    },
    getTemplateData: function() {
        let icon = $a564d16b1ff800f7$var$getOption(this, 'type');
        const size = $a564d16b1ff800f7$var$getOption(this, 'size');
        if (icon === 'tip') // css is inconsistent
        icon = 'light-bulb';
        switch(size){
            case 'slim':
                icon = '';
                break;
            case 'large':
                icon = [
                    icon,
                    '-',
                    '24'
                ].join('');
                break;
            default:
                icon = [
                    icon,
                    '-',
                    '16'
                ].join('');
        }
        return {
            icon: icon,
            title: $a564d16b1ff800f7$var$getOption(this, 'title'),
            subtitle: $a564d16b1ff800f7$var$getOption(this, 'subtitle'),
            bullets: $a564d16b1ff800f7$var$getOption(this, 'bullets'),
            dismissible: $a564d16b1ff800f7$var$getOption(this, 'dismissible')
        };
    }
});
/**
 * @class src/views/components/Callout
 * @extends module:Okta.View
 */ /**
 * @class module:Okta.internal.views.components.Callout
 */ var $a564d16b1ff800f7$export$2e2bcd8739ae039 = /** @lends module:Okta.internal.views.components.Callout */ {
    /**
   * Creates a {@link src/views/components/Callout|Callout}.
   * @static
   * @param {Object} options
   * @param {String|Function} [options.size] Size of icon. options are standard, large, compact, slim
   * @param {String|Okta.View} [options.content] Custom HTML or view to inject to the callout
   * @param {String|Function} [options.title] Callout title
   * @param {String|Function} [options.subtitle] Callout subtitle
   * @param {Array|Function} [options.bullets] Array of strings to render as bullet points
   * @param {Boolean|Function} [options.dismissible] Can the callout be dismissed
   * @param {String|Function} [options.type] Callout type. Valid values are: info, success, warning, error, tip
   *
   * @return {src/views/components/Callout}
   */ create: function(options) {
        return new $a564d16b1ff800f7$var$CalloutCallout(options);
    }
};



const $853386a4fe574f49$var$props = {
    tagName: 'span',
    attributes: function() {
        return {
            'data-se': 'o-form-input-' + this.getNameString()
        };
    },
    /**
   * default placeholder text when options.placeholder is not defined
   */ defaultPlaceholder: '',
    constructor: function(options) {
        /* eslint complexity: [2, 9] */ options = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults(options || {}, {
            inputId: options.id || (0, $3e490973b7383cc4$export$2e2bcd8739ae039).uniqueId('input'),
            placeholder: this.defaultPlaceholder,
            inlineValidation: true,
            validateOnlyIfDirty: false
        });
        delete options.id; // decorate the `enable` and `disable` and toggle the `o-form-disabled` class.
        // so we wont need to worry about this when overriding the methods
        const self = this;
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each({
            enable: 'removeClass',
            disable: 'addClass'
        }, function(method, action) {
            self[action] = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).wrap(self[action], function(fn) {
                fn.apply(self, arguments);
                self.$el[method]('o-form-disabled');
            });
        });
        (0, $5f539c045973220f$export$2e2bcd8739ae039).call(this, options);
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(options, 'readOnly') !== true && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(options, 'read') === true) this.listenTo(this.model, 'change:__edit__', this.render);
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(this.focus)) this.focus = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).debounce((0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(this.focus, this), 50);
         // Enable inline validation if this is not the first field in the form.
        if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(options, 'validateOnlyIfDirty')) this.addInlineValidation();
        this.addModelListeners();
        this.$el.addClass('o-form-input-name-' + this.getNameString());
    },
    addAriaLabel: function() {
        const ariaLabel = this.options.ariaLabel;
        if (ariaLabel) this.$(':input').attr('aria-label', ariaLabel);
    },
    addInlineValidation: function() {
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this.options, 'inlineValidation')) this.$el.on('focusout', ':input', (0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(this.validate, this));
    },
    toModelValue: function() {
        let value = this.val();
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(this.to)) value = this.to.call(this, value);
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(this.options.to)) value = this.options.to.call(this, value);
        return value;
    },
    __getDependencyCalloutBtn: function(btnConfig) {
        const self = this;
        const btnOptions = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone(btnConfig);
        const originalClick = btnOptions.click || function() {}; // add onfocus listener to re-evaluate depedency when callout button is clicked
        btnOptions.click = function() {
            (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(window).one('focus.dependency', function() {
                self.__showInputDependencies();
            });
            originalClick.call(self);
        };
        const BaseInputCalloutBtn = (0, $5f539c045973220f$export$2e2bcd8739ae039).extend({
            children: [
                (0, $914e49a88f52f235$export$2e2bcd8739ae039).create(btnOptions)
            ]
        });
        return new BaseInputCalloutBtn();
    },
    getCalloutParent: function() {
        return this.$('input[value="' + this.getModelValue() + '"]').parent();
    },
    __getCalloutMsgContainer: function(calloutMsg) {
        return (0, $5f539c045973220f$export$2e2bcd8739ae039).extend({
            template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                "compiler": [
                    8,
                    ">= 4.3.0"
                ],
                "main": function(container, depth0, helpers, partials, data) {
                    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                        return undefined;
                    };
                    return "<span class=\"o-form-explain\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "msg") || (depth0 != null ? lookupProperty(depth0, "msg") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                        "name": "msg",
                        "hash": {},
                        "data": data,
                        "loc": {
                            "start": {
                                "line": 1,
                                "column": 29
                            },
                            "end": {
                                "line": 1,
                                "column": 36
                            }
                        }
                    }) : helper)) + "</span>";
                },
                "useData": true
            }),
            getTemplateData: function() {
                return {
                    msg: calloutMsg
                };
            }
        });
    },
    showCallout: function(calloutConfig, dependencyResolved) {
        const callout = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone(calloutConfig);
        callout.className = 'dependency-callout';
        if (callout.btn) {
            callout.content = this.__getDependencyCalloutBtn(callout.btn);
            delete callout.btn;
        }
        const dependencyCallout = (0, $a564d16b1ff800f7$export$2e2bcd8739ae039).create(callout);
        if (!dependencyResolved) dependencyCallout.add(this.__getCalloutMsgContainer((0, $afa609341e14c39e$export$2e2bcd8739ae039).localize('dependency.callout.msg', 'courage')));
        const calloutParent = this.getCalloutParent();
        calloutParent.append(dependencyCallout.render().el);
        if (callout.type === 'success') (0, $3e490973b7383cc4$export$2e2bcd8739ae039).delay(function() {
            // fade out success callout
            dependencyCallout.$el.fadeOut(800);
        }, 1000);
    },
    removeCallout: function() {
        this.$el.find('.dependency-callout').remove();
    },
    __evaluateCalloutObject: function(dependencyResolved, calloutTitle) {
        let defaultCallout;
        if (dependencyResolved) defaultCallout = {
            title: (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize('dependency.action.completed', 'courage'),
            size: 'large',
            type: 'success'
        };
        else defaultCallout = {
            title: (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize('dependency.action.required', 'courage', [
                calloutTitle
            ]),
            size: 'large',
            type: 'warning'
        };
        return defaultCallout;
    },
    __handleDependency: function(result, callout) {
        const self = this;
        const calloutConfig = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(callout) ? callout(result) : (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({}, callout, self.__evaluateCalloutObject(result.resolved, callout.title)); // remove existing callouts if any
        self.removeCallout();
        self.showCallout(calloutConfig, result.resolved);
    },
    __showInputDependencies: function() {
        const self = this;
        const fieldDependency = self.options.deps[self.getModelValue()];
        if (fieldDependency && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(fieldDependency.func)) fieldDependency.func().done(function(data) {
            self.__handleDependency({
                resolved: true,
                data: data
            }, fieldDependency.callout);
        }).fail(function(data) {
            self.__handleDependency({
                resolved: false,
                data: data
            }, fieldDependency.callout);
        });
        else self.removeCallout();
    },
    _isEdited: false,
    hasIMESupport: false,
    /**
   * updates the model with the input's value
   */ update: function(e) {
        var _window, _window$okta;
        if (!this._isEdited && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this.options, 'validateOnlyIfDirty')) {
            this._isEdited = true;
            this.addInlineValidation();
        }
        this.model.set(this.options.name, this.toModelValue());
        if (this.options.deps) // check for dependencies
        this.__showInputDependencies();
        /*
      To add IME support for more components
      - Add hasIMESupport boolean flag and compositionend and compositionstart event listeners to the component
      - Supported components: TextBox.js, TextSelect.js
      - Additionally window.okta.enableIMESupport is an org level FF to toggle IME support
    */ if (this.hasIMESupport && (_window = window) !== null && _window !== void 0 && (_window$okta = _window.okta) !== null && _window$okta !== void 0 && _window$okta.enableIMESupport) {
            if (this.isComposing) return;
            if (e && (0, $23690f1a19c585a1$export$2e2bcd8739ae039).isEnter(e)) this.model.trigger('form:save');
        }
    },
    /**
   * Is the input in edit mode
   * @return {Boolean}
   */ isEditMode: function() {
        const ret = !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this.options, 'readOnly') && ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this.options, 'read') !== true || this.model.get('__edit__') === true);
        return ret;
    },
    /**
   * Renders the input
   * @readonly
   */ render: function() {
        this.preRender();
        const params = this.options.params;
        this.options.params = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).resultCtx(this.options, 'params', this);
        if (this.isEditMode()) {
            this.editMode();
            this.applyEnabledState();
        } else this.readMode();
        this.options.params = params;
        this.addAriaLabel();
        this.postRender();
        return this;
    },
    applyEnabledState: function() {
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).resultCtx(this.options, 'disabled', this)) this.disable();
        else this.enable();
    },
    /**
   * checks if the current value in the model is valid for this field
   */ validate: function() {
        if (!this.model.get('__pending__') && this.isEditMode() && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(this.model.validateField)) {
            const validationError = this.model.validateField(this.options.name);
            if (validationError) (0, $3e490973b7383cc4$export$2e2bcd8739ae039).delay((function() {
                this.model.trigger('form:clear-error:' + this.options.name);
                this.model.trigger('invalid', this.model, validationError, false);
            }).bind(this), 100);
        }
    },
    /**
   * Add model event listeners
   */ addModelListeners: function() {
        this.listenTo(this.model, 'form:field-error', function(name) {
            if (this.options.name === name) this.__markError();
        });
        this.listenTo(this.model, 'form:clear-errors change:' + this.options.name, this.__clearError);
        this.listenTo(this.model, 'form:clear-error:' + this.options.name, this.__clearError);
    },
    /**
   * The value of the input
   * @return {Mixed}
   */ val: function() {
        throw new Error('val() is an abstract method');
    },
    /**
   * Set focus on the input
   */ focus: function() {
        throw new Error('focus() is an abstract method');
    },
    /**
   * Default value in read mode
   * When model has no value for the field
   */ defaultValue: function() {
        return '';
    },
    /**
   * Renders the input in edit mode
   */ editMode: function() {
        const options = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({}, this.options, {
            value: this.getModelValue()
        });
        this.$el.html(this.template(options));
        this.options.multi && this.$el.removeClass('margin-r');
        return this;
    },
    /**
   * Renders the readable value of the input in read mode
   */ readMode: function() {
        this.$el.text(this.getReadModeString());
        this.$el.removeClass('error-field');
        this.options.multi && this.$el.addClass('margin-r');
        return this;
    },
    getReadModeString: function() {
        const readModeStr = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).resultCtx(this.options, 'readModeString', this);
        if (readModeStr) return readModeStr;
        return this.toStringValue();
    },
    /**
   * The model value off the field associated with the input
   * @return {Mixed}
   */ getModelValue: function() {
        let value = this.model.get(this.options.name);
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(this.from)) value = this.from.call(this, value);
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(this.options.from)) value = this.options.from.call(this, value);
        return value;
    },
    /*
  * convenience method to get the textual value from the model
  * will return the textual label rather than value in case of select/radio
  * @return {String}
  */ toStringValue: function() {
        let value = this.getModelValue();
        if (this.options.options) // dropdown or radio
        value = this.options.options[value];
        if (Number.isInteger(value) || typeof value === 'boolean') value = String(value);
        return value || this.defaultValue();
    },
    /**
   * Triggers a form:resize event in order to tell dialogs content size has changed
   */ resize: function() {
        this.model.trigger('form:resize');
    },
    /**
   * Disable the input
   */ disable: function() {
        this.$(':input').prop('disabled', true);
    },
    /**
   * Enable the input
   */ enable: function() {
        this.$(':input').prop('disabled', false);
    },
    /**
   * Change the type of the input field. (e.g., text <--> password)
   * @param type
   */ changeType: function(type) {
        this.$(':input').prop('type', type); // Update the options so that it keeps the uptodate state
        this.options.type = type;
    },
    getNameString: function() {
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(this.options.name)) return this.options.name.join('-');
        return this.options.name;
    },
    /**
   * Get parameters, computing _.result
   * @param  {[type]} options alternative options
   * @return {Object} the params
   */ getParams: function(options) {
        const opts = options || this.options || {};
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone((0, $3e490973b7383cc4$export$2e2bcd8739ae039).resultCtx(opts, 'params', this) || {});
    },
    /**
   * get a parameter from options.params, compute _.result when needed.
   * @param  {String} key
   * @param  {Object} defaultValue
   * @return {Object} the params
   */ getParam: function(key, defaultValue) {
        const result = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).resultCtx(this.getParams(), key, this);
        return !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isUndefined(result) ? result : defaultValue;
    },
    /**
   * Get a parameter from options.params or if empty, object attribute.
   *
   * @param  {String} key
   * @return {Object} the param or attribute
   */ getParamOrAttribute: function(key) {
        return this.getParam(key) || (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, key);
    },
    __markError: function() {
        this.$el.addClass('o-form-has-errors');
    },
    __clearError: function() {
        this.$el.removeClass('o-form-has-errors');
    }
};
/**
 * @class BaseInput
 * @private
 * An abstract object that defines an input for {@link Okta.Form}
 *
 * BaseInputs are typically not created directly, but being passed to {@link Okta.Form#addInput}
 * @extends Okta.View
 */ var $853386a4fe574f49$export$2e2bcd8739ae039 = (0, $5f539c045973220f$export$2e2bcd8739ae039).extend($853386a4fe574f49$var$props);




const $0f3a0a5abb008421$var$template = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<select id=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "inputId",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 12
                },
                "end": {
                    "line": 1,
                    "column": 23
                }
            }
        }) : helper)) + "\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "name",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 31
                },
                "end": {
                    "line": 1,
                    "column": 39
                }
            }
        }) : helper)) + "\"></select>";
    },
    "useData": true
});
const $0f3a0a5abb008421$var$option = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<option value=\"" + alias4((helper = (helper = lookupProperty(helpers, "key") || (depth0 != null ? lookupProperty(depth0, "key") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "key",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 15
                },
                "end": {
                    "line": 1,
                    "column": 22
                }
            }
        }) : helper)) + "\">" + alias4((helper = (helper = lookupProperty(helpers, "value") || (depth0 != null ? lookupProperty(depth0, "value") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "value",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 24
                },
                "end": {
                    "line": 1,
                    "column": 33
                }
            }
        }) : helper)) + "</option>";
    },
    "useData": true
});
const $0f3a0a5abb008421$var$CHOSEN_WINDOW_MARGIN = 20;
const $0f3a0a5abb008421$var$isSafari = (0, $1d054e2973c83a0b$export$2e2bcd8739ae039).isSafari; // Chosen has known problems when it's at the bottom of a container that has
// overflow:hidden set. Because it attaches to the parent container, its
// dropdown will be cut off in the UI. Any modal with a chosen select element
// at the bottom will manifest this behavior.
//
// The fix (aside from replacing Chosen) is to change Chosen's behavior -
// use the existing styles, but attach it to 'body' and position it correctly
// so that it is not affected by a parent overflow.
//
// More details can be found in OKTA-46489, OKTA-83570
const $0f3a0a5abb008421$var$CHOSEN_MAX_HEIGHT = 240;
const $0f3a0a5abb008421$var$CHOSEN_Z_INDEX = 50000;
function $0f3a0a5abb008421$var$defer(fn) {
    if (this.params.autoWidth) return fn.call(this);
    else return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defer((0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(fn, this));
}
function $0f3a0a5abb008421$var$findSelectWidth(self) {
    self.$select.hide();
    const select = (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(self.$select[0]).hide();
    (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)('body').append(select);
    const width = self.params.width = select.width() * 1.2 + 'px';
    self.$el.append(select.show());
    return width;
}
function $0f3a0a5abb008421$var$recalculateChosen($chosen, $results, $clone) {
    const offset = $clone.offset();
    $chosen.css({
        left: offset.left,
        top: offset.top
    }); // Update the max-height to fit within the constraints of the window. This
    // is especially important for modals because page scrolling is disabled.
    const $win = (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(window);
    const rHeight = $results.outerHeight();
    const rBottom = rHeight + $results.offset().top - $win.scrollTop();
    const wHeight = $win.height() - $0f3a0a5abb008421$var$CHOSEN_WINDOW_MARGIN;
    const maxHeight = Math.min(rHeight + wHeight - rBottom, $0f3a0a5abb008421$var$CHOSEN_MAX_HEIGHT);
    $results.css('max-height', maxHeight);
}
function $0f3a0a5abb008421$var$handleKeyUpEvent($select, $chosen, $results) {
    const $highlightedOption = $results.find('.active-result.highlighted');
    $chosen.find('#' + $select.attr('id') + '_txt').attr('aria-activedescendant', $highlightedOption.attr('id')); // change the old selected item aria-selected to false
    // and add add it to new item.
    $results.find('[aria-selected=true]').attr('aria-selected', 'false');
    $highlightedOption.attr('aria-selected', 'true'); // In case of Safari, add message to aria-live node to be read by screenreader.
    // We need to do this special handling for Safari due to falkiness with aria-activedescendant
    // handling. https://bit.ly/3z45IZF
    if ($0f3a0a5abb008421$var$isSafari()) {
        // message read by screenReader i.e optionValue selected(United States selected)
        const message = (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize('oform.selectInput.country', 'courage', [
            $highlightedOption.text()
        ]);
        const elementId = $select.attr('id');
        if (message !== '') (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(`#${elementId}_aria_div_id`).text(message);
    }
    const noResult = $results.find('li.no-results');
    if (noResult.length) noResult.attr('role', 'alert');
}
function $0f3a0a5abb008421$var$fixChosenModal($select, textPlaceholder) {
    const $chosen = $select.next('.chzn-container');
    const $clone = $chosen.clone();
    const $results = $chosen.find('.chzn-results');
    const $searchInput = $chosen.find('.chzn-search input[type=text]');
    $searchInput.on('keyup', ()=>{
        $0f3a0a5abb008421$var$handleKeyUpEvent($select, $chosen, $results);
    });
    $chosen.addClass('closed'); // Will be used in SIW to fix screen reader focus.
    // Use a hidden clone to maintain layout and calculate offset. This is
    // necessary for more complex layouts (like adding a group rule) where
    // the chosen element is floated.
    $clone.css('visibility', 'hidden');
    $clone.removeAttr('id');
    $clone.find('li').removeAttr('id'); // Save the original styles - we'll revert to them when the select closes
    const baseStyles = {
        left: $chosen.css('left'),
        top: $chosen.css('top'),
        position: $chosen.css('position'),
        float: $chosen.css('float'),
        'z-index': $chosen.css('z-index')
    };
    $results.hide(); // Handler for any resize events that happen when the results list is open
    const resizeHandler = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).debounce(function() {
        $0f3a0a5abb008421$var$recalculateChosen($chosen, $results, $clone);
    }, 10); // When the dropdown opens, attach it to body, with the correct absolute
    // position coordinates
    $select.off('.fixChosen'); // Remove events we could have added before
    $select.on('liszt:showing_dropdown.fixChosen', function() {
        $chosen.width($chosen.width());
        $select.after($clone); // .chzn-container can trigger the vertical scrollbar if it causes scrollHeight > window height after append to
        // the body. Force top -999999 to avoid the scrollbar so $chosen can find the right offset for relocation.
        $chosen.css({
            position: 'absolute',
            float: 'none',
            'z-index': $0f3a0a5abb008421$var$CHOSEN_Z_INDEX,
            top: -999999
        });
        (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)('body').append($chosen);
        (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)('.chzn-search > :text').prop('placeholder', textPlaceholder);
        $results.show();
        $0f3a0a5abb008421$var$recalculateChosen($chosen, $results, $clone); // Capture scroll events:
        // - for forms that use fixed positioning (like editing attributes in
        //   Profile Editor) - window scroll
        // - for forms that are too long for the modal - o-form-content scroll
        $select.parents().scroll(resizeHandler);
        (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(window).on('resize scroll', resizeHandler);
    });
    $select.on('liszt:showing_dropdown', function() {
        $chosen.removeClass('closed');
    }); // When the dropdown closes or the element is removed, revert to the
    // original styles and reattach it to its original placement in the dom.
    $select.on('liszt:hiding_dropdown.fixChosen remove.fixChosen', function() {
        $select.parents().off('scroll', resizeHandler);
        (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(window).off('resize scroll', resizeHandler);
        $chosen.css(baseStyles);
        $results.hide();
        $chosen.addClass('closed');
        $results.css('max-height', $0f3a0a5abb008421$var$CHOSEN_MAX_HEIGHT);
        $clone.remove();
        $select.after($chosen);
    }); // Do not change the order of event listeners. This event must execute after 
    // "liszt:hiding_dropdown.fixChosen remove.fixChosen"
    $select.on('liszt:hiding_dropdown.fixChosen', function() {
        $searchInput.focus(); // set focus back to input only when the dropdown is closed
    });
}
var $0f3a0a5abb008421$export$2e2bcd8739ae039 = (0, $853386a4fe574f49$export$2e2bcd8739ae039).extend({
    className: 'o-form-select',
    /**
   * @Override
   */ events: {
        'change select': 'update',
        'keyup .chzn-search > :text': function(e) {
            if ((0, $23690f1a19c585a1$export$2e2bcd8739ae039).isEsc(e)) {
                this.$('.chzn-search > :text').val('');
                e.stopPropagation();
            }
        }
    },
    constructor: function() {
        this.template = $0f3a0a5abb008421$var$template;
        this.option = this.option || $0f3a0a5abb008421$var$option;
        (0, $853386a4fe574f49$export$2e2bcd8739ae039).apply(this, arguments);
        this.params = this.options.params || {};
    },
    /**
   * @Override
   */ editMode: function() {
        /* eslint max-statements: [2, 17] */ this.$el.html($0f3a0a5abb008421$var$template(this.options));
        this.$select = this.$('select');
        this.appendOptions(); // Fix a regression in jQuery 1.x on Firefox
        // jQuery.val(value) prepends an empty option to the dropdown
        // if value doesnt exist in the dropdown.
        // http://bugs.jquery.com/ticket/13514
        const value = this.getModelValue();
        if (value) this.$select.val(value);
        else this.$('option:first-child').prop('selected', true);
        this.$el.addClass('o-form-control');
        if (this.params.chosen !== false) this.__applyChosen();
        return this;
    },
    appendOptions: function() {
        if (!this.getOptions()) return;
        const options = this.getOptions();
        const keys = Object.keys(options);
        this.applySortByKey(keys);
        keys.forEach((key)=>{
            this.$select.append(this.option({
                key: key,
                value: options[key]
            }));
        });
    },
    applySortByKey: function(keys) {
        const sortByKey = this.options.sortByKey;
        if (!sortByKey) return;
        if (sortByKey instanceof Function) keys.sort(sortByKey);
        if (sortByKey === 'asc') keys.sort();
        if (sortByKey === 'desc') {
            keys.sort();
            keys.reverse();
        }
    },
    __applyChosen: function(update) {
        let width = this.options.wide ? '100%' : this.params.width || '62%';
        if (this.params.autoWidth) width = $0f3a0a5abb008421$var$findSelectWidth(this);
        $0f3a0a5abb008421$var$defer.call(this, function() {
            const searchThreshold = this.getParam('searchThreshold', 10);
            if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this.options, 'autoRender') && update !== false) this.update();
            this.$select.chosen({
                width: width,
                disable_search_threshold: searchThreshold,
                //eslint-disable-line camelcase
                placeholder_text: this.options['placeholder'],
                //eslint-disable-line camelcase
                search_contains: true,
                //eslint-disable-line camelcase
                no_results_text: this.params.noResultsText //eslint-disable-line camelcase
            }); //if options are more than search threshold, consider it as a combobox
            const isComboBox = this.options && this.options.options && Object.keys(this.options.options).length > searchThreshold;
            this.accessibilityUpdate(isComboBox, this.params);
            $0f3a0a5abb008421$var$fixChosenModal(this.$select, this.searchPlaceholder);
            if (this.params.autoWidth) // fix a chosen css bug
            this.$el.width(0);
            this.model.trigger('form:resize');
        });
    },
    /**
   * @Override
   */ val: function() {
        return this.$select && this.$select.val();
    },
    /**
   * @Override
   */ focus: function() {
        if (this.$select) return this.$select.focus();
    },
    /**
   * @Override
   */ toStringValue: function() {
        const selectedOption = this.getModelValue();
        let displayString = selectedOption;
        const options = this.getOptions();
        if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(options)) displayString = options[selectedOption];
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isUndefined(displayString)) displayString = this.defaultValue();
        return displayString || '';
    },
    /**
   * Convert options to an object
   * support input options that is a
   * 1. a static object such as {key1: val1, key2: val2...}
   * 2. a function to be called to return a static object
   * will return an object with key-value pairs or with empty content
   * @return {Object} The value
   */ getOptions: function() {
        let options = this.options.options;
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(options)) options = options.call(this);
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isObject(options) ? options : {};
    },
    remove: function() {
        if (this.$select) this.$select.trigger('remove');
        return (0, $853386a4fe574f49$export$2e2bcd8739ae039).prototype.remove.apply(this, arguments);
    },
    /**
   * @param ariaDivId id for div element
   * Create a div element and add it to chosen container.
   */ createAriaLiveNode: function(ariaDivId) {
        const $chosen = this.$select.next('.chzn-container'); // set this to off-screen such that no user will see this and only screenReaders will pick this up.
        // we should announce to user only on additions and not on removals.
        const $node = (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)('<div></div>').attr('role', 'log').attr('aria-live', 'polite').attr('id', ariaDivId).attr('aria-relevant', 'additions').attr('aria-atomic', 'false').attr('class', 'off-screen');
        $node.insertAfter($chosen);
    },
    /**
   * Code to make the select/combobox component accessible with screen readers.
   *
   * @param {boolean} isComboBox - Is the select a combobox?
   * @param {object} params - params like aria label
   */ // eslint-disable-next-line max-statements
    accessibilityUpdate: function(isComboBox, params) {
        const txtBoxId = this.$select.attr('id') + '_txt';
        const ariaDivId = this.$select.attr('id') + '_aria_div_id';
        const ulTagId = this.$select.attr('id') + '_ul'; // this is to fix(OKTA-506711) the accessibility issue due to partial support of aria-activedescendant
        // by Safari. Make use of aria-live to make screenReader announce the option selected by user as a workaround.
        if ($0f3a0a5abb008421$var$isSafari()) this.createAriaLiveNode(ariaDivId);
        this.$('ul[class=chzn-results]').attr('role', 'listbox').attr('id', ulTagId);
        if (isComboBox) this.$('input[type=text]').attr('id', txtBoxId).attr('aria-autocomplete', 'list').attr('aria-activedescendant', '').attr('role', 'combobox').attr('aria-expanded', 'true').attr('aria-controls', ulTagId);
        else this.$('input[type=text]').attr('id', txtBoxId).attr('role', 'listbox');
        if (params && params.aria && params.aria.label) {
            const ariaLabel = params.aria.label.trim();
            this.$('input[type=text]').attr('id', txtBoxId).attr('aria-label', ariaLabel);
            this.$('ul[class=chzn-results]').attr('aria-label', ariaLabel);
        } else {
            const ariaLabel = this.$el.parent().prev('.o-form-label').find('label').text().trim();
            this.$('input[type=text]').attr('id', txtBoxId).attr('aria-label', ariaLabel);
            this.$('ul[class=chzn-results]').attr('aria-label', ariaLabel);
        }
        this.$('.chzn-results .active-result').attr('role', 'option').attr('aria-selected', 'false');
    }
});


const $948848089f093970$var$options = {
    undefined: 'undefined',
    true: 'true',
    false: 'false'
};
const $948848089f093970$var$from = function(val) {
    if (val) return 'true';
    if (val === false) return 'false';
    return 'undefined';
};
const $948848089f093970$var$to = function(val) {
    switch(val){
        case 'undefined':
            return null;
        case 'true':
            return true;
        case 'false':
            return false;
        default:
            return null;
    }
};
var $948848089f093970$export$2e2bcd8739ae039 = (0, $0f3a0a5abb008421$export$2e2bcd8739ae039).extend({
    initialize: function() {
        this.options.options = $948848089f093970$var$options;
        this.options.from = $948848089f093970$var$from;
        this.options.to = $948848089f093970$var$to;
    }
});












const $1fb9802efe8d7df1$var$template = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<div class=\"o-form-input-group-controls\"><span class=\"input-fix o-form-control\"><input type=\"text\" class=\"o-form-text\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "key") || (depth0 != null ? lookupProperty(depth0, "key") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "key",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 125
                },
                "end": {
                    "line": 1,
                    "column": 132
                }
            }
        }) : helper)) + "\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "key") || (depth0 != null ? lookupProperty(depth0, "key") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "key",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 138
                },
                "end": {
                    "line": 1,
                    "column": 145
                }
            }
        }) : helper)) + "\" value=\"" + alias4((helper = (helper = lookupProperty(helpers, "value") || (depth0 != null ? lookupProperty(depth0, "value") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "value",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 154
                },
                "end": {
                    "line": 1,
                    "column": 163
                }
            }
        }) : helper)) + "\" placeholder=\"" + alias4((helper = (helper = lookupProperty(helpers, "placeholder") || (depth0 != null ? lookupProperty(depth0, "placeholder") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "placeholder",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 178
                },
                "end": {
                    "line": 1,
                    "column": 193
                }
            }
        }) : helper)) + "\"/></span><a href=\"#\" class=\"link-button link-button-icon icon-only\"><span class=\"icon clear-input-16 \"></span></a></div><p class=\"o-form-input-error o-form-explain\"><span class=\"icon icon-16 error-16-small\"></span>" + alias4((helper = (helper = lookupProperty(helpers, "errorExplain") || (depth0 != null ? lookupProperty(depth0, "errorExplain") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "errorExplain",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 408
                },
                "end": {
                    "line": 1,
                    "column": 424
                }
            }
        }) : helper)) + "</p>";
    },
    "useData": true
});
const $1fb9802efe8d7df1$var$errorClass = 'o-form-has-errors';
const $1fb9802efe8d7df1$var$updateArrayEvent = 'updateArray';
var $1fb9802efe8d7df1$export$2e2bcd8739ae039 = (0, $5f539c045973220f$export$2e2bcd8739ae039).extend({
    tagName: 'div',
    className: 'o-form-input-group',
    events: {
        'click a': function(e) {
            e.preventDefault();
            this.remove();
        },
        'keyup input': function() {
            this.update();
        }
    },
    isEditMode: function() {
        return !this.options.readOnly && (this.options.read !== true || this.model.get('__edit__') === true);
    },
    initialize: function() {
        this.template = $1fb9802efe8d7df1$var$template((0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend(this.options, {
            placeholder: this.getPlaceholderText(),
            errorExplain: this.getErrorExplainText()
        }));
        this.update = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).debounce(this.update, this.options.debounceDelay || (0, $893f8a6b0b7a3602$export$2e2bcd8739ae039).DEBOUNCE_DELAY);
    },
    render: function() {
        if (this.isEditMode()) this.$el.html(this.template);
        else {
            this.$el.text(this.options.value);
            this.$('a').hide();
        }
        return this;
    },
    remove: function() {
        this.trigger($1fb9802efe8d7df1$var$updateArrayEvent, null);
        this.$el.slideUp(()=>{
            (0, $5f539c045973220f$export$2e2bcd8739ae039).prototype.remove.call(this, arguments);
        });
    },
    update: function() {
        let updatedValue = this.$('input').val();
        const parseFunc = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).object([
            (0, $723c4f009c64492a$export$2e2bcd8739ae039).DATATYPE.number,
            (0, $723c4f009c64492a$export$2e2bcd8739ae039).DATATYPE.integer
        ], [
            (0, $afa609341e14c39e$export$2e2bcd8739ae039).parseFloat,
            this.parseInt
        ]);
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).has(parseFunc, this.options.itemType)) {
            updatedValue = parseFunc[this.options.itemType](updatedValue);
            !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isNumber(updatedValue) ? this.markInvalid() : this.clearInvalid();
        }
        this.trigger($1fb9802efe8d7df1$var$updateArrayEvent, updatedValue);
    },
    markInvalid: function() {
        this.$el.addClass($1fb9802efe8d7df1$var$errorClass);
    },
    clearInvalid: function() {
        this.$el.removeClass($1fb9802efe8d7df1$var$errorClass);
    },
    getPlaceholderText: function() {
        let placeholderText;
        switch(this.options.itemType.toLowerCase()){
            // TODO fix lint and add the spaces/indent
            case 'string':
                placeholderText = (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize('placeholder.text.string', 'courage');
                break;
            case 'number':
                placeholderText = (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize('placeholder.text.number', 'courage');
                break;
            case 'integer':
                placeholderText = (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize('placeholder.text.integer', 'courage');
                break;
            default:
                placeholderText = '';
        }
        return placeholderText;
    },
    getErrorExplainText: function() {
        let itemTypeMismatchMessages;
        switch(this.options.itemType.toLowerCase()){
            // TODO fix lint and add the spaces/indent
            case 'string':
                itemTypeMismatchMessages = (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize('string.item.type.error.message', 'courage');
                break;
            case 'number':
                itemTypeMismatchMessages = (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize('number.item.type.error.message', 'courage');
                break;
            case 'integer':
                itemTypeMismatchMessages = (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize('integer.item.type.error.message', 'courage');
                break;
            default:
                itemTypeMismatchMessages = '';
        }
        return itemTypeMismatchMessages;
    },
    parseInt: function(string) {
        // native javascript parseInt is aggressive
        // there're cases we don't want a string to be parsed even though it is convertable
        // so that we don't convert a string silently before warning a user the potential error
        // this is to make sure the string is in an integer format before we parse it
        if (/^-?\d+$/.test(string)) {
            const num = parseInt(string, 10);
            return !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isNaN(num) ? num : string;
        }
        return string;
    }
});


var $0776e97d9cb6f78a$export$2e2bcd8739ae039 = (0, $853386a4fe574f49$export$2e2bcd8739ae039).extend({
    className: 'array-input',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a href=\"#\" class=\"array-inputs-button link-button\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "courage",
                    "code": "oform.add.another"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 52
                    },
                    "end": {
                        "line": 1,
                        "column": 102
                    }
                }
            })) + "</a>";
        },
        "useData": true
    }),
    params: {
        itemType: 'string'
    },
    events: {
        'click .array-inputs-button': function(e) {
            e.preventDefault();
            if (this.isEditMode()) this.addNewElement();
        }
    },
    initialize: function(options) {
        options || (options = {});
        this.params = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults(options.params || {}, this.params);
        this.uniqueIdPrefix = 'array';
    },
    // api returns null for an array that does not have value
    // convert it to an empty array
    from: function(val) {
        if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(val)) return [];
        return val;
    },
    // @Override
    editMode: function() {
        this._setArrayObject();
        this.$el.html(this.template);
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(this.arrayObject, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(this._addDeletableBox, this));
        return this;
    },
    // @Override
    readMode: function() {
        this.editMode();
        this.$('.array-inputs-button').addClass('link-button-disabled');
    },
    // @Override
    // converts arrayObject to a plain array
    // for string type array, returns all values
    // for number/integer type array, returns values in number type
    val: function() {
        let values = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).values(this.arrayObject);
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains([
            (0, $723c4f009c64492a$export$2e2bcd8739ae039).DATATYPE.number,
            (0, $723c4f009c64492a$export$2e2bcd8739ae039).DATATYPE.integer
        ], this.params.itemType)) values = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).filter(values, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isNumber);
        return values;
    },
    focus: function() {},
    addNewElement: function() {
        const value = '';
        const key = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).uniqueId(this.uniqueIdPrefix);
        this.arrayObject[key] = value;
        this._addDeletableBox(value, key); // update is called to make sure an empty string value is added for string type array
        this.update();
    },
    _addDeletableBox: function(value, key) {
        const deletableBox = new (0, $1fb9802efe8d7df1$export$2e2bcd8739ae039)((0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend((0, $3e490973b7383cc4$export$2e2bcd8739ae039).pick(this.options, 'read', 'readOnly', 'model'), {
            key: key,
            value: value,
            itemType: this.params.itemType
        }));
        this.listenTo(deletableBox, 'updateArray', function(updatedValue) {
            if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isNull(updatedValue)) {
                delete this.arrayObject[key];
                this.stopListening(deletableBox);
            } else this.arrayObject[key] = updatedValue;
            this.update();
        });
        deletableBox.render().$el.hide();
        this.$('.array-inputs-button').before(deletableBox.el);
        deletableBox.$el.slideDown();
        return deletableBox;
    },
    _setArrayObject: function() {
        const array = this.model.get(this.options.name);
        this.arrayObject = {};
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(array) && !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(array)) {
            const keys = [];
            const self = this;
            (0, $3e490973b7383cc4$export$2e2bcd8739ae039)(array.length).times(function() {
                keys.push((0, $3e490973b7383cc4$export$2e2bcd8739ae039).uniqueId(self.uniqueIdPrefix));
            });
            this.arrayObject = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).object(keys, array);
        }
    }
});



/* eslint max-statements: 0, max-params: 0 */ function $36bee8103fa4f4f5$var$convertStringToNumber(string) {
    const number = (0, $afa609341e14c39e$export$2e2bcd8739ae039).parseFloat(string);
    return string === '' ? null : number;
} // converts possibleValues to choices
// [a, b, c] => {a: a, b: b, c: c}
function $36bee8103fa4f4f5$var$getChoices(values) {
    return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).object(values, values);
}
function $36bee8103fa4f4f5$var$isArray(type) {
    return type && type.indexOf('array') >= 0;
} // A schema property may have an objectName either
// at the root level or nested in the items object
function $36bee8103fa4f4f5$var$getObjectName(schemaProp) {
    const items = schemaProp.get('items');
    if (items) return items.objectName;
    return schemaProp.get('objectName');
}
/**
 * Checks the validity of a schema property.
 *
 * @param {SchemaProperty} [schemaProp] A schema property backbone model
 * @param {Object} [values] An object of the form { key: [value1, value2]}
 * @return {Boolean} true/false
 * @private
 */ function $36bee8103fa4f4f5$var$isValidSchemaProp(schemaProp, values) {
    const objectName = $36bee8103fa4f4f5$var$getObjectName(schemaProp);
    const results = values[objectName]; // a schema property that references an empty list of values
    // Im looking at you, google apps.
    if (objectName && (0, $3e490973b7383cc4$export$2e2bcd8739ae039)(results).isEmpty()) return false;
    return true;
} // Maps each __displayType__ to a basic set of inputOptions.
function $36bee8103fa4f4f5$var$defaultOptions(property) {
    const type = property.get('__displayType__');
    const values = property.get('__possibleValues__');
    const name = property.get('name');
    const title = property.get('title');
    /* eslint complexity: [2, 24] */ const inputOptions = {
        type: 'text',
        name: name,
        label: title || name
    }; // @see customOptions for enum complex "object" type,
    // a.k.a "object" or "arrayofobject" type has enum values defined.
    // Other cases (e.g., nested object type) are not support yet.
    switch(type){
        case 'arrayofstring':
            inputOptions.input = (0, $0776e97d9cb6f78a$export$2e2bcd8739ae039);
            inputOptions.params = {
                itemType: 'string'
            };
            break;
        case 'arrayofnumber':
            inputOptions.input = (0, $0776e97d9cb6f78a$export$2e2bcd8739ae039);
            inputOptions.params = {
                itemType: 'number'
            };
            break;
        case 'arrayofinteger':
            inputOptions.input = (0, $0776e97d9cb6f78a$export$2e2bcd8739ae039);
            inputOptions.params = {
                itemType: 'integer'
            };
            break;
        case 'arrayofobject':
            inputOptions.input = (0, $0776e97d9cb6f78a$export$2e2bcd8739ae039);
            inputOptions.params = {
                itemType: property.get('items').type
            };
            break;
        case 'arrayofref-id':
            inputOptions.input = (0, $0776e97d9cb6f78a$export$2e2bcd8739ae039);
            inputOptions.params = {
                itemType: property.get('items').format
            };
            break;
        case 'boolean':
            inputOptions.input = (0, $948848089f093970$export$2e2bcd8739ae039);
            break;
        case 'integer':
        case 'number':
            inputOptions.to = $36bee8103fa4f4f5$var$convertStringToNumber;
            break;
        case 'reference':
            inputOptions.type = 'select';
            inputOptions.options = $36bee8103fa4f4f5$var$getChoices(values);
            break;
        case 'image':
            inputOptions.readOnly = true;
            inputOptions.from = function(value) {
                return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(value) ? '' : (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize('user.profile.image.image_set', 'courage'); // TODO
            };
            break;
        case 'password':
            inputOptions.type = 'password';
            break;
        case 'date':
            inputOptions.type = 'date';
            break;
        case 'uri':
        case 'country-code':
        case 'country_code':
        case 'language-code':
        case 'language_code':
        case 'email':
        case 'locale':
        case 'timezone':
        case 'string':
        case 'object':
            break;
        default:
            throw new Error(`unknown type: ${type}`);
    }
    return inputOptions;
} // Sets nonbasic inputOptions, such as an array with possible values
function $36bee8103fa4f4f5$var$customOptions(property) {
    let inputOptions = {};
    const name = property.get('name');
    const type = property.get('__displayType__');
    const values = property.get('__possibleValues__');
    const prefix = property.get('__fieldNamePrefix__');
    if (prefix) {
        inputOptions.name = prefix + name;
        inputOptions.errorField = name;
    }
    if (property.isEnumType()) {
        const configs = {
            displayType: type,
            title: property.get('title'),
            enumValues: property.getEnumValues()
        };
        inputOptions = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({}, (0, $012d4a2affe19c61$export$2e2bcd8739ae039).getEnumInputOptions(configs), inputOptions);
    } else if ($36bee8103fa4f4f5$var$isArray(type) && values) {
        inputOptions.type = 'checkboxset';
        inputOptions.input = null;
        inputOptions.options = $36bee8103fa4f4f5$var$getChoices(values);
    }
    return inputOptions;
}
function $36bee8103fa4f4f5$var$augmentSchemaProp(schemaProp, possibleValues, profile) {
    const name = schemaProp.get('name');
    const prefix = profile.__nestedProperty__;
    let defaultValues = possibleValues[name];
    const userValues = profile.get(name);
    let values; // If API responds with a field name that differs from the form-field name
    // example: Model's 'profile.username' vs. server's 'username'
    if (prefix) schemaProp.set('__fieldNamePrefix__', prefix);
     // case 1: objectName - fixed list of values are set for the input
    const fixedValues = possibleValues[$36bee8103fa4f4f5$var$getObjectName(schemaProp)]; // case 2: name only - default list of values are provided, user can add more
    // TODO: this case does not yet exist, so it is not tested
    if (defaultValues && userValues) defaultValues = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).union(defaultValues, userValues);
     // If both fixed and default values exist,
    // take the fixed values unless they are empty
    if (fixedValues && fixedValues.length) values = fixedValues;
    else if (defaultValues && defaultValues.length) values = defaultValues;
    schemaProp.set('__possibleValues__', values);
}
function $36bee8103fa4f4f5$var$augmentSchemaProps(schemaProps, possibleValues, profile) {
    schemaProps.each(function(schemaProp) {
        $36bee8103fa4f4f5$var$augmentSchemaProp(schemaProp, possibleValues, profile);
    });
    return schemaProps;
}
/**
 * Remove invalid schema properties from a collection
 *
 * @param {SchemaProperties Collection} [properties] A collection of schema properties
 * @param {Object} [values] An object of the form { key: [value1, value2]}
 * @return {Array} An array of valid schema models, this can be used to reset
 * a schema properties collection for example.
 * @private
 */ function $36bee8103fa4f4f5$var$cleanSchema(properties, values) {
    return properties.filter(function(schema) {
        return $36bee8103fa4f4f5$var$isValidSchemaProp(schema, values);
    });
}
var $36bee8103fa4f4f5$export$2e2bcd8739ae039 = {
    /**
   * Creates the options hash for BaseForm.addInput from a prepared schema
   * property.
   *
   * @param {Okta.Model} [preparedSchemaProp] A schema property backbone model
   * that has been standardized by the prepareSchema method.
   * @return {Object} An object containing all of the options needed by
   * BaseForm's addInput()
   */ createInputOptions: function(preparedSchemaProp) {
        const custom = $36bee8103fa4f4f5$var$customOptions(preparedSchemaProp);
        const standard = $36bee8103fa4f4f5$var$defaultOptions(preparedSchemaProp); // underscore did not support nested extend
        // https://github.com/jashkenas/underscore/issues/162
        if (custom.params && standard.params) custom.params = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults(custom.params, standard.params);
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults(custom, standard);
    },
    hasValidSchemaProps: function(schemaProps, possibleValues) {
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(schemaProps)) return false;
        const validSchema = $36bee8103fa4f4f5$var$cleanSchema(schemaProps, possibleValues);
        return !!validSchema.length;
    },
    /**
   * This method is responsible for preparing a collection for the form
   * factory to use by putting all of the information to create an input
   * into the schema property and removing invalid properties.
   * The typical UD form takes 3 models:
   * The data model has the input values.
   * The schema model describes which input to use, such as a textbox or a checkbox.
   * The possible values model provide a list of default options to display, for example in a drop down menu.
   *
   * @param {SchemaProperty Collection} [schemaProps] A schema property backbone model.
   * @param {Object} [possibleValues] An object of the form { key: [value1, value2]}
   * @param {Okta.Model} [profile] A backbone model containing the property described by the schema property.
   * @return {SchemaProperty Collection} A schema property collection with standardized models.
   * The standard schema model adds a couple of additional private properties to
   * allow the form factory to reference lookup values or name prefixes without going to a second model.
   */ prepareSchema: function(schemaProps, possibleValues, profile) {
        schemaProps.reset($36bee8103fa4f4f5$var$cleanSchema(schemaProps, possibleValues));
        return $36bee8103fa4f4f5$var$augmentSchemaProps(schemaProps, possibleValues, profile);
    },
    /**
   * `prepareSchema` will reset the property list which may not be necessary at some case.
   * like when setting default value for schema properties.
   * (more detail about such case @see wiki UX, App+Entitlements+for+Provisioning)
   *
   * @param { }
   * @return {String}
   */ augmentSchemaProps: $36bee8103fa4f4f5$var$augmentSchemaProps,
    augmentSchemaProp: $36bee8103fa4f4f5$var$augmentSchemaProp
};







/**
 * There are following local modifications:
 * - Author: Uzi Kilon ukilon@okta.com
 *   Bug: OKTA-20830 - solves the conflict when there are multiple labels
 */ /**
 * --------------------------------------------------------------------
 * jQuery customInput plugin
 * Author: Maggie Costello Wachs maggie@filamentgroup.com, Scott Jehl, scott@filamentgroup.com
 * Copyright (c) 2009 Filament Group
 * licensed under MIT (filamentgroup.com/examples/mit-license.txt)
 * --------------------------------------------------------------------
*/ (function() {
    var jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports)));
    var $$1 = jQuery;
    jQuery.fn.customInput = function() {
        return $$1(this).each(function() {
            if ($$1(this).is('[type=checkbox],[type=radio]')) {
                var input = $$1(this); // get the associated label using the input's id
                var label = input.siblings('label[for="' + input.attr('id') + '"]:first');
                if (!label.length) label = input.closest('label[for="' + input.attr('id') + '"]:first');
                 // wrap the input + label in a div
                input.add(label).wrapAll('<div class="custom-' + input.attr('type') + '"></div>'); // necessary for browsers that don't support the :hover pseudo class on labels
                label.hover(function() {
                    $$1(this).addClass('hover');
                }, function() {
                    $$1(this).removeClass('hover');
                }); //bind custom event, trigger it, bind click,focus,blur events
                input.bind('updateState', function() {
                    input.is(':checked') ? label.addClass('checked') : label.removeClass('checked checkedHover checkedFocus');
                }).trigger('updateState').click(function() {
                    $$1('input[name="' + $$1(this).attr('name') + '"]').trigger('updateState');
                }).focus(function() {
                    label.addClass('focus');
                    if (input.is(':checked')) $$1(this).addClass('checkedFocus');
                }).blur(function() {
                    label.removeClass('focus checkedFocus');
                });
            }
        });
    };
})();



var $4536824db5c003b5$export$2e2bcd8739ae039 = (0, $853386a4fe574f49$export$2e2bcd8739ae039).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<input type=\"checkbox\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "name",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 29
                    },
                    "end": {
                        "line": 1,
                        "column": 37
                    }
                }
            }) : helper)) + "\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "inputId",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 43
                    },
                    "end": {
                        "line": 1,
                        "column": 54
                    }
                }
            }) : helper)) + "\"/><label for=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "inputId",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 69
                    },
                    "end": {
                        "line": 1,
                        "column": 80
                    }
                }
            }) : helper)) + "\" data-se-for-name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "name",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 100
                    },
                    "end": {
                        "line": 1,
                        "column": 108
                    }
                }
            }) : helper)) + "\">" + alias4((helper = (helper = lookupProperty(helpers, "placeholder") || (depth0 != null ? lookupProperty(depth0, "placeholder") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "placeholder",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 110
                    },
                    "end": {
                        "line": 1,
                        "column": 125
                    }
                }
            }) : helper)) + "</label>";
        },
        "useData": true
    }),
    /**
   * @Override
   */ events: {
        'change :checkbox': 'update',
        keyup: function(e) {
            e.preventDefault();
            if ((0, $23690f1a19c585a1$export$2e2bcd8739ae039).isSpaceBar(e)) this.$(':checkbox').click();
            else if ((0, $23690f1a19c585a1$export$2e2bcd8739ae039).isEnter(e)) this.model.trigger('form:save');
        }
    },
    /**
   * @Override
   */ editMode: function() {
        let placeholder = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).resultCtx(this.options, 'placeholder', this);
        if (placeholder === '') placeholder = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).resultCtx(this.options, 'label', this);
        else if (placeholder === false) placeholder = '';
        this.$el.html(this.template((0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend((0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(this.options, 'placeholder'), {
            placeholder: placeholder
        })));
        const $input = this.$(':checkbox');
        $input.prop('checked', this.getModelValue() || false);
        this.$('input').customInput();
        this.model.trigger('form:resize');
        return this;
    },
    /**
   * @Override
   */ readMode: function() {
        this.editMode();
        this.$(':checkbox').prop('disabled', true);
        return this;
    },
    /**
   * @Override
   */ val: function() {
        return this.$(':checkbox').prop('checked');
    },
    /**
   * @Override
   */ focus: function() {
        return this.$(':checkbox').focus();
    }
});









/*! http://mths.be/placeholder v2.0.7 by @mathias */ (function() {
    var $$1 = (0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports)));
    var isInputSupported = 'placeholder' in document.createElement('input'), isTextareaSupported = 'placeholder' in document.createElement('textarea'), prototype = $$1.fn, valHooks = $$1.valHooks, hooks, placeholder;
    if (isInputSupported && isTextareaSupported) {
        placeholder = prototype.placeholder = function() {
            return this;
        };
        placeholder.input = placeholder.textarea = true;
    } else {
        placeholder = prototype.placeholder = function() {
            var $this = this;
            $this.filter((isInputSupported ? 'textarea' : ':input') + '[placeholder]').not('.placeholder').bind({
                'focus.placeholder': clearPlaceholder,
                'blur.placeholder': setPlaceholder
            }).data('placeholder-enabled', true).trigger('blur.placeholder');
            return $this;
        };
        placeholder.input = isInputSupported;
        placeholder.textarea = isTextareaSupported;
        hooks = {
            'get': function(element) {
                var $element = $$1(element);
                return $element.data('placeholder-enabled') && $element.hasClass('placeholder') ? '' : element.value;
            },
            'set': function(element, value) {
                var $element = $$1(element);
                if (!$element.data('placeholder-enabled')) return element.value = value;
                if (value == '') {
                    element.value = value; // Issue #56: Setting the placeholder causes problems if the element continues to have focus.
                    if (element != document.activeElement) // We can't use `triggerHandler` here because of dummy text/password inputs :(
                    setPlaceholder.call(element);
                } else if ($element.hasClass('placeholder')) clearPlaceholder.call(element, true, value) || (element.value = value);
                else element.value = value;
                 // `set` can not return `undefined`; see http://jsapi.info/jquery/1.7.1/val#L2363
                return $element;
            }
        };
        isInputSupported || (valHooks.input = hooks);
        isTextareaSupported || (valHooks.textarea = hooks);
        $$1(function() {
            // Look for forms
            $$1(document).delegate('form', 'submit.placeholder', function() {
                // Clear the placeholder values so they don't get submitted
                var $inputs = $$1('.placeholder', this).each(clearPlaceholder);
                setTimeout(function() {
                    $inputs.each(setPlaceholder);
                }, 10);
            });
        }); // Clear placeholder values upon page reload
        $$1(window).bind('beforeunload.placeholder', function() {
            $$1('.placeholder').each(function() {
                this.value = '';
            });
        });
    }
    function args(elem) {
        // Return an object of element attributes
        var newAttrs = {}, rinlinejQuery = /^jQuery\d+$/;
        $$1.each(elem.attributes, function(i, attr) {
            if (attr.specified && !rinlinejQuery.test(attr.name)) newAttrs[attr.name] = attr.value;
        });
        return newAttrs;
    }
    function clearPlaceholder(event, value) {
        var input = this, $input = $$1(input);
        if (input.value == $input.attr('placeholder') && $input.hasClass('placeholder')) {
            if ($input.data('placeholder-password')) {
                $input = $input.hide().next().show().attr('id', $input.removeAttr('id').data('placeholder-id')); // If `clearPlaceholder` was called from `$.valHooks.input.set`
                if (event === true) return $input[0].value = value;
                $input.focus();
            } else {
                input.value = '';
                $input.removeClass('placeholder');
                input == document.activeElement && input.select();
            }
        }
    }
    function setPlaceholder() {
        var $replacement, input = this, $input = $$1(input), id = this.id;
        if (input.value == '') {
            if (input.type == 'password') {
                if (!$input.data('placeholder-textinput')) {
                    try {
                        $replacement = $input.clone().attr({
                            'type': 'text'
                        });
                    } catch (e) {
                        $replacement = $$1('<input>').attr($$1.extend(args(this), {
                            'type': 'text'
                        }));
                    }
                    $replacement.removeAttr('name').data({
                        'placeholder-password': true,
                        'placeholder-id': id
                    }).bind('focus.placeholder', clearPlaceholder);
                    $input.data({
                        'placeholder-textinput': $replacement,
                        'placeholder-id': id
                    }).before($replacement);
                }
                $input = $input.removeAttr('id').hide().prev().attr('id', id).show(); // Note: `$input[0] != input` now!
            }
            $input.addClass('placeholder');
            $input[0].value = $input.attr('placeholder');
        } else $input.removeClass('placeholder');
    }
})();



const $e393c22dcb7dea0b$var$className = 'okta-form-input-field input-fix';
function $e393c22dcb7dea0b$var$hasTitleAndText(options) {
    const title = options.title;
    const text = options.text;
    return title && text && title !== text;
} // options may be a string or an object.
function $e393c22dcb7dea0b$var$createQtipContent(options) {
    if ($e393c22dcb7dea0b$var$hasTitleAndText(options)) return options;
    return {
        text: options.text || options
    };
}
var $e393c22dcb7dea0b$export$2e2bcd8739ae039 = (0, $853386a4fe574f49$export$2e2bcd8739ae039).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            return "<span class=\"input-tooltip icon form-help-16\"></span>";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<span class=\"icon input-icon " + container.escapeExpression(container.lambda((stack1 = depth0 != null ? lookupProperty(depth0, "params") : depth0) != null ? lookupProperty(stack1, "icon") : stack1, depth0)) + "\"></span>";
        },
        "2": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return container.escapeExpression((helper = (helper = lookupProperty(helpers, "autoComplete") || (depth0 != null ? lookupProperty(depth0, "autoComplete") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "autoComplete",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 333
                    },
                    "end": {
                        "line": 1,
                        "column": 349
                    }
                }
            }) : helper));
        },
        "3": function(container, depth0, helpers, partials, data) {
            return "off";
        },
        "4": function(container, depth0, helpers, partials, data) {
            return "<span class=\"input-icon-divider\"></span>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "params") : depth0) != null ? lookupProperty(stack1, "innerTooltip") : stack1, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 87
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "params") : depth0) != null ? lookupProperty(stack1, "icon") : stack1, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 87
                    },
                    "end": {
                        "line": 1,
                        "column": 166
                    }
                }
            })) != null ? stack1 : "") + "<input type=\"" + alias4((helper = (helper = lookupProperty(helpers, "type") || (depth0 != null ? lookupProperty(depth0, "type") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "type",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 179
                    },
                    "end": {
                        "line": 1,
                        "column": 187
                    }
                }
            }) : helper)) + "\" placeholder=\"" + alias4((helper = (helper = lookupProperty(helpers, "placeholder") || (depth0 != null ? lookupProperty(depth0, "placeholder") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "placeholder",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 202
                    },
                    "end": {
                        "line": 1,
                        "column": 217
                    }
                }
            }) : helper)) + "\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "name",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 225
                    },
                    "end": {
                        "line": 1,
                        "column": 233
                    }
                }
            }) : helper)) + "\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "inputId",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 239
                    },
                    "end": {
                        "line": 1,
                        "column": 250
                    }
                }
            }) : helper)) + "\" value=\"" + alias4((helper = (helper = lookupProperty(helpers, "value") || (depth0 != null ? lookupProperty(depth0, "value") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "value",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 259
                    },
                    "end": {
                        "line": 1,
                        "column": 268
                    }
                }
            }) : helper)) + "\" aria-label=\"" + alias4((helper = (helper = lookupProperty(helpers, "placeholder") || (depth0 != null ? lookupProperty(depth0, "placeholder") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "placeholder",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 282
                    },
                    "end": {
                        "line": 1,
                        "column": 297
                    }
                }
            }) : helper)) + "\" autocomplete=\"" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "autoComplete") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(2, data, 0),
                "inverse": container.program(3, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 313
                    },
                    "end": {
                        "line": 1,
                        "column": 367
                    }
                }
            })) != null ? stack1 : "") + "\" />" + ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "params") : depth0) != null ? lookupProperty(stack1, "iconDivider") : stack1, {
                "name": "if",
                "hash": {},
                "fn": container.program(4, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 371
                    },
                    "end": {
                        "line": 1,
                        "column": 444
                    }
                }
            })) != null ? stack1 : "");
        },
        "useData": true
    }),
    /**
   * @Override
   */ events: {
        'input input': 'update',
        'change input': 'update',
        'keydown input': 'update',
        'compositionend input': function() {
            this.isComposing = false;
        },
        'compositionstart input': function() {
            this.isComposing = true;
        },
        'keyup input': function(e) {
            if ((0, $23690f1a19c585a1$export$2e2bcd8739ae039).isEnter(e) && !(window.okta && window.okta.enableIMESupport)) this.model.trigger('form:save');
            else if ((0, $23690f1a19c585a1$export$2e2bcd8739ae039).isEsc(e)) this.model.trigger('form:cancel');
        }
    },
    hasIMESupport: true,
    constructor: function() {
        (0, $853386a4fe574f49$export$2e2bcd8739ae039).apply(this, arguments);
        this.$el.addClass('o-form-control');
    },
    /**
   * @Override
   */ editMode: function() {
        this.$el.addClass($e393c22dcb7dea0b$var$className);
        (0, $853386a4fe574f49$export$2e2bcd8739ae039).prototype.editMode.apply(this, arguments);
        this.$('input').placeholder();
    },
    /**
   * @Override
   */ readMode: function() {
        (0, $853386a4fe574f49$export$2e2bcd8739ae039).prototype.readMode.apply(this, arguments);
        this.$el.addClass('no-translate');
        if (this.options.type === 'password') this.$el.text('********');
        this.$el.removeClass($e393c22dcb7dea0b$var$className);
    },
    /**
   * @Override
   */ val: function() {
        let inputValue = this.$('input[type="' + this.options.type + '"]').val(); //IE will only read clear text pw if type="password" is explicitly in selector
        if (this.options.type !== 'password') inputValue = (0, $b51a961f9fe28c76$export$2e2bcd8739ae039).trim(inputValue);
        return inputValue;
    },
    /**
   * @Override
   */ focus: function() {
        return this.$('input').focus();
    },
    postRender: function() {
        const { params: params } = this.options;
        if (params && params.innerTooltip) {
            const content = $e393c22dcb7dea0b$var$createQtipContent(params.innerTooltip);
            this.$('.input-tooltip').qtip({
                content: content,
                style: {
                    classes: 'okta-tooltip qtip-custom qtip-shadow'
                },
                position: {
                    my: 'bottom left',
                    // Note: qTip2 has a known issue calculating the tooltip offset when:
                    // 1. A container element has both:
                    //    a) position: relative/absolute
                    //    b) overlay: value other than 'visible'
                    // 2. The page is scrolled
                    //
                    // We set position:relative and overlay:auto on the body element,
                    // where both are required for:
                    // - Positioning the footer correctly
                    // - Displaying long pages in embedded browsers
                    //
                    // The original design called for a fixed position relative to the
                    // tooltip icon - this has been switched to "relative to mouse, and
                    // update position when mouse moves" because of this constraint.
                    target: 'mouse',
                    adjust: {
                        method: 'flip',
                        mouse: true,
                        y: -5,
                        x: 5
                    },
                    viewport: (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)('body')
                }
            });
        }
    }
});


const $9dbaf9efc1d573a0$var$toggleTemplate = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        return "<span class=\"password-toggle\"><span class=\"eyeicon visibility-16 button-show\"></span><span class=\"eyeicon visibility-off-16 button-hide\"></span></span>";
    },
    "useData": true
});
const $9dbaf9efc1d573a0$var$toggleTimeout = 30000;
var $9dbaf9efc1d573a0$export$2e2bcd8739ae039 = (0, $e393c22dcb7dea0b$export$2e2bcd8739ae039).extend({
    initialize: function() {
        if (this.__showPasswordToggle()) {
            this.events['click .password-toggle .button-show'] = '__showPassword';
            this.events['click .password-toggle .button-hide'] = '__hidePassword';
        }
        this.delegateEvents();
    },
    postRender: function() {
        if (this.isEditMode() && this.__showPasswordToggle()) {
            this.$el.append($9dbaf9efc1d573a0$var$toggleTemplate);
            this.$el.find('input[type="password"]').addClass('password-with-toggle');
        }
        (0, $e393c22dcb7dea0b$export$2e2bcd8739ae039).prototype.postRender.apply(this, arguments);
    },
    /**
   * @Override
   * Overrides the default val method in order to avoid whitespace trimming
   */ val: function() {
        return this.$('input[type="' + this.options.type + '"]').val();
    },
    __showPasswordToggle: function() {
        return this.options.params && this.options.params.showPasswordToggle;
    },
    __showPassword: function() {
        // Turn off the spellcheck if the user decides to switch to regular input
        // in order to prevent sending passwords to third party spellcheckers
        this.$('input').attr('spellcheck', false);
        (0, $e393c22dcb7dea0b$export$2e2bcd8739ae039).prototype.changeType.apply(this, [
            'text'
        ]);
        this.$('.password-toggle .button-show').hide();
        this.$('.password-toggle .button-hide').show();
        this.passwordToggleTimer = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).delay(()=>{
            this.__hidePassword();
        }, $9dbaf9efc1d573a0$var$toggleTimeout);
    },
    __hidePassword: function() {
        (0, $e393c22dcb7dea0b$export$2e2bcd8739ae039).prototype.changeType.apply(this, [
            'password'
        ]);
        this.$('.password-toggle .button-show').show();
        this.$('.password-toggle .button-hide').hide(); // clear timeout
        if (this.passwordToggleTimer) clearTimeout(this.passwordToggleTimer);
    }
});










const $cb1a8d566a16fba4$var$isABaseView = (0, $1d054e2973c83a0b$export$2e2bcd8739ae039).isABaseView;
const $cb1a8d566a16fba4$var$RadioRadioOption = (0, $5f539c045973220f$export$2e2bcd8739ae039).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<input type=\"radio\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "name",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 26
                    },
                    "end": {
                        "line": 1,
                        "column": 34
                    }
                }
            }) : helper)) + "\" data-se-name=\"" + alias4((helper = (helper = lookupProperty(helpers, "realName") || (depth0 != null ? lookupProperty(depth0, "realName") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "realName",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 50
                    },
                    "end": {
                        "line": 1,
                        "column": 62
                    }
                }
            }) : helper)) + "\" value=\"" + alias4((helper = (helper = lookupProperty(helpers, "value") || (depth0 != null ? lookupProperty(depth0, "value") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "value",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 71
                    },
                    "end": {
                        "line": 1,
                        "column": 80
                    }
                }
            }) : helper)) + "\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "optionId") || (depth0 != null ? lookupProperty(depth0, "optionId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "optionId",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 86
                    },
                    "end": {
                        "line": 1,
                        "column": 98
                    }
                }
            }) : helper)) + "\"><label for=\"" + alias4((helper = (helper = lookupProperty(helpers, "optionId") || (depth0 != null ? lookupProperty(depth0, "optionId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "optionId",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 112
                    },
                    "end": {
                        "line": 1,
                        "column": 124
                    }
                }
            }) : helper)) + "\" data-se-for-name=\"" + alias4((helper = (helper = lookupProperty(helpers, "realName") || (depth0 != null ? lookupProperty(depth0, "realName") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "realName",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 144
                    },
                    "end": {
                        "line": 1,
                        "column": 156
                    }
                }
            }) : helper)) + "\" class=\"radio-label\">" + alias4((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "label",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 178
                    },
                    "end": {
                        "line": 1,
                        "column": 187
                    }
                }
            }) : helper)) + "</label>";
        },
        "useData": true
    }),
    initialize: function(options) {
        let explain;
        explain = options.explain;
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(explain) && !$cb1a8d566a16fba4$var$isABaseView(explain)) explain = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).resultCtx(this.options, 'explain', this);
        if (!explain) return;
        if ($cb1a8d566a16fba4$var$isABaseView(explain)) {
            this.add('<p class="o-form-explain"></p>', '.radio-label');
            this.add(explain, '.o-form-explain');
        } else this.add((0, $5f539c045973220f$export$2e2bcd8739ae039).extend({
            className: 'o-form-explain',
            tagName: 'p',
            template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                "compiler": [
                    8,
                    ">= 4.3.0"
                ],
                "main": function(container, depth0, helpers, partials, data) {
                    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                        return undefined;
                    };
                    return container.escapeExpression((helper = (helper = lookupProperty(helpers, "explain") || (depth0 != null ? lookupProperty(depth0, "explain") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                        "name": "explain",
                        "hash": {},
                        "data": data,
                        "loc": {
                            "start": {
                                "line": 1,
                                "column": 0
                            },
                            "end": {
                                "line": 1,
                                "column": 11
                            }
                        }
                    }) : helper));
                },
                "useData": true
            })
        }), '.radio-label');
    }
});
var $cb1a8d566a16fba4$export$2e2bcd8739ae039 = (0, $853386a4fe574f49$export$2e2bcd8739ae039).extend({
    /**
   * @Override
   */ events: {
        'change :radio': 'update',
        keyup: function(e) {
            if ((0, $23690f1a19c585a1$export$2e2bcd8739ae039).isSpaceBar(e)) (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(e.target).click();
            else if ((0, $23690f1a19c585a1$export$2e2bcd8739ae039).isEnter(e)) this.model.trigger('form:save');
        }
    },
    /**
   * @Override
   */ editMode: function() {
        const templates = [];
        this.$el.empty();
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(this.options.options, function(value, key) {
            const options = {
                optionId: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).uniqueId('option'),
                name: this.options.inputId,
                realName: this.options.name,
                value: key
            };
            if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isObject(value)) value = {
                label: value
            };
            (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend(options, value);
            templates.push(new $cb1a8d566a16fba4$var$RadioRadioOption(options).render().el);
        }, this);
        this.$el.append(templates);
        let value = this.getModelValue();
        if (value) this.$(':radio[value=' + value + ']').prop('checked', true);
        this.$('input').customInput();
        this.model.trigger('form:resize');
        if (this.getParam('inline') === true) this.$('div.custom-radio').addClass('inline');
        return this;
    },
    /**
   * @Override
   */ readMode: function() {
        this.editMode();
        this.$(':radio').prop('disabled', true);
        return this;
    },
    /**
   * @Override
   */ val: function() {
        return this.$(':radio:checked').val();
    },
    /**
   * @Override
   */ focus: function() {
        return this.$('label:eq(0)').focus();
    }
});







function $69c19c9ef6a0e28d$var$countInputs(inputs) {
    return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).filter(inputs || [], function(input) {
        return !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains([
            'label',
            'button',
            'select'
        ], input.type);
    }).length;
}
const $69c19c9ef6a0e28d$var$InputGroupLabelInput = (0, $853386a4fe574f49$export$2e2bcd8739ae039).extend({
    tagName: 'span',
    initialize: function() {
        this.$el.text(this.getModelValue());
    },
    editMode: function() {
        this.toggle(true);
    },
    readMode: function() {
        this.toggle(false);
    },
    getModelValue: function() {
        return this.options.label;
    },
    toggle: function(isEditMode) {
        this.$el.toggleClass('o-form-label-inline', isEditMode);
        this.$el.toggleClass('o-form-control', !isEditMode);
    },
    focus: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).noop
});
function $69c19c9ef6a0e28d$var$createButtonInput(options) {
    return (0, $914e49a88f52f235$export$2e2bcd8739ae039).create((0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults({
        getReadModeString: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).constant(' '),
        focus: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).noop
    }, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).pick(options, 'click', 'title', 'href', 'icon')));
}
const $69c19c9ef6a0e28d$var$InputGroupInputGroupView = (0, $5f539c045973220f$export$2e2bcd8739ae039).extend({
    getParams: (0, $853386a4fe574f49$export$2e2bcd8739ae039).prototype.getParams,
    getParam: (0, $853386a4fe574f49$export$2e2bcd8739ae039).prototype.getParam,
    className: function() {
        let className; // Allows views to group multiple inputs under one label without any of the other
        // styling/rendering changes that come with using a group input
        if (this.getParam('noBaseClasses')) return '';
        if (this.getParam('display') === 'text') className = 'o-form-input-group-subtle';
        else className = 'o-form-input-group';
        if ($69c19c9ef6a0e28d$var$countInputs(this.getParam('inputs')) > 1) className += ' o-form-input-group-2';
        return className;
    },
    initialize: function() {
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(this.getParam('inputs'), function(input) {
            switch(input.type){
                case 'label':
                    this.add($69c19c9ef6a0e28d$var$InputGroupLabelInput, {
                        options: input
                    });
                    break;
                case 'button':
                    this.add($69c19c9ef6a0e28d$var$createButtonInput(input));
                    break;
                default:
                    input = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defaults({
                        model: this.model,
                        params: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({
                            autoWidth: true
                        }, input.params || {})
                    }, input);
                    this.add(this.getParams().create(input));
            }
        }, this);
    },
    focus: function() {
        this.first().focus();
    }
});
var $69c19c9ef6a0e28d$export$2e2bcd8739ae039 = (0, $853386a4fe574f49$export$2e2bcd8739ae039).extend({
    constructor: function(options) {
        this.inputGroupView = new $69c19c9ef6a0e28d$var$InputGroupInputGroupView(options);
        (0, $853386a4fe574f49$export$2e2bcd8739ae039).apply(this, arguments);
    },
    editMode: function() {
        this.inputGroupView.remove();
        this.inputGroupView = new $69c19c9ef6a0e28d$var$InputGroupInputGroupView(this.options);
        this.$el.html(this.inputGroupView.render().el);
    },
    readMode: function() {
        // Allows the user to use to the default "read mode" of the child inputs instead of
        // rendering a single read mode string for all the child inputs
        if (this.getParam('useChildInputsReadMode')) this.editMode();
        else (0, $853386a4fe574f49$export$2e2bcd8739ae039).prototype.readMode.apply(this, arguments);
    },
    toStringValue: function() {
        const strings = this.inputGroupView.map(function(input) {
            return input.getReadModeString();
        });
        return strings.length && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).every(strings) ? strings.join(' ') : ' ';
    },
    focus: function() {
        this.inputGroupView.focus();
    }
}, {
    // test hooks
    LabelInput: $69c19c9ef6a0e28d$var$InputGroupLabelInput,
    InputGroupView: $69c19c9ef6a0e28d$var$InputGroupInputGroupView
});







/*!
 * jQuery UI Scroll Parent @VERSION
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * Modifications Copyright 2021 Okta, Inc.
 */ // This is required because SIW doesn't want to include jqueryui even though it's an external dependency of courage
(0, $b51a961f9fe28c76$export$2e2bcd8739ae039).fn.scrollParent = function(includeHidden) {
    const position = this.css("position"), excludeStaticParent = position === "absolute", overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/, scrollParent = this.parents().filter(function() {
        const parent = (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(this);
        if (excludeStaticParent && parent.css("position") === "static") return false;
        return overflowRegex.test(parent.css("overflow") + parent.css("overflow-y") + parent.css("overflow-x"));
    }).eq(0);
    return position === "fixed" || !scrollParent.length ? (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(this[0].ownerDocument || document) : scrollParent;
};




const $5d64eb84267ab4e8$export$bd0bf19f25da8474 = (0, $fd8e23e9341bb61f$export$2e2bcd8739ae039).extend({
    // The courage BaseController renders asynchronously in current versions of jQuery
    // https://github.com/okta/okta-ui/blob/master/packages/courage/src/util/BaseController.ts#L117-L119
    // https://api.jquery.com/jquery/#jQuery-callback
    // Override so that render is synchronous
    render: function(...args) {
        (0, $5f539c045973220f$export$2e2bcd8739ae039).prototype.render.apply(this, args);
        return this;
    }
}); // Disable the Chosen jQuery plugin for the SIW — the SIW does not bundle Chosen CSS,
// so applying Chosen produces an unstyled dropdown. Use native <select> instead.
// Also restore placeholder localization for empty-key options removed in the upgrade.
const $5d64eb84267ab4e8$var$SelectForSigninWidget = (0, $0f3a0a5abb008421$export$2e2bcd8739ae039).extend({
    editMode: function() {
        this.params = Object.assign({
            chosen: false
        }, this.params);
        return (0, $0f3a0a5abb008421$export$2e2bcd8739ae039).prototype.editMode.apply(this, arguments);
    },
    // Upstream appendOptions no longer localizes empty-key placeholder options
    // and removed the deferred update() call that syncs the DOM value to the model.
    // Restore both: localized placeholder for empty keys and deferred model sync.
    appendOptions: function() {
        if (!this.getOptions()) return;
        const options = this.getOptions();
        const keys = Object.keys(options);
        this.applySortByKey(keys);
        keys.forEach((key)=>{
            if (!key) this.$select.prepend(this.option({
                key: '',
                value: (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize('select.default_value', 'login')
            }));
            else this.$select.append(this.option({
                key: key,
                value: options[key]
            }));
        }); // Sync the initial selected value to the model (removed in upstream upgrade)
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defer((0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(this.update, this));
    },
    // Patched to remove unneeded call to
    // this.$select.trigger('remove');
    // which causes error on IE11
    remove: function() {
        return (0, $853386a4fe574f49$export$2e2bcd8739ae039).prototype.remove.apply(this, arguments);
    }
}); // The string will be returned unchanged. All templates should be precompiled.
(0, $b17abb91ef0c7ac1$export$2e2bcd8739ae039).prototype.compileTemplate = function(str) {
    const compiledTmpl = function fakeTemplate() {
        return str;
    };
    compiledTmpl.source = ''; // to satisfy TS
    return compiledTmpl;
}; // Override events to not support `Enter` submitting the form twice - OKTA-321999 and OKTA-317629
const $5d64eb84267ab4e8$var$events = {
    'input input': 'update',
    'change input': 'update',
    'keydown input': 'update',
    'keyup input': function(e) {
        if ((0, $23690f1a19c585a1$export$2e2bcd8739ae039).isEsc(e)) this.model.trigger('form:cancel');
    }
};
const $5d64eb84267ab4e8$var$TextBoxForSigninWidget = (0, $e393c22dcb7dea0b$export$2e2bcd8739ae039).extend({
    events: $5d64eb84267ab4e8$var$events
});
const $5d64eb84267ab4e8$var$PasswordBoxForSigninWidget = (0, $9dbaf9efc1d573a0$export$2e2bcd8739ae039).extend({
    events: $5d64eb84267ab4e8$var$events
});
const $5d64eb84267ab4e8$export$a7fed597f4b8afd8 = (0, $1b4071d45909ff1b$export$2e2bcd8739ae039).extend({
    scrollOnError: function() {
        const { settings: settings } = this.options; // OKTA-1104008 diagnostics: log every scroll-on-error gate evaluation so we can
        // confirm whether iPadOS is firing this per keystroke. iOS-only (covers iPadOS 13+
        // which reports as Mac). Wrapped in try/catch so a property-access failure never
        // breaks the widget. Volume is bounded by the 100ms throttle on the underlying
        // 'invalid error' listener. Remove together with PR #3974's behavioral fix.
        try {
            const ua = navigator.userAgent;
            const isIOS = /iPad|iPhone|iPod/i.test(ua) || ua.includes('Mac') && 'ontouchend' in document;
            if (isIOS) {
                var _window$visualViewpor;
                const active = document.activeElement || null;
            }
        } catch (_e) {
        /* diagnostics must never break the form */ } // scrollOnError is true by default. Override to false if `scrollOnError` has been set to false in widget settings.
        if (settings.get('features.scrollOnError') === false) return false;
        return true;
    }
});
const $5d64eb84267ab4e8$export$ebcbd32ce8d4cff = (0, $afa609341e14c39e$export$2e2bcd8739ae039).localize;
const $5d64eb84267ab4e8$export$9b6d6ca62970729f = (0, $914e49a88f52f235$export$2e2bcd8739ae039).create;
const $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7 = (0, $a564d16b1ff800f7$export$2e2bcd8739ae039).create;
const $5d64eb84267ab4e8$export$2d6b0bdb309bbeb1 = (0, $52a08da877666121$export$2e2bcd8739ae039).register;
const $5d64eb84267ab4e8$export$fb8073518f34e6ec = (0, $e9e519c40171c3aa$export$2e2bcd8739ae039);
const $5d64eb84267ab4e8$export$27a5bd065ad55220 = (0, $5f539c045973220f$export$2e2bcd8739ae039);
const $5d64eb84267ab4e8$export$55185c17a0fcbe46 = (0, $ebb4e572c564df7e$export$2e2bcd8739ae039);
const $5d64eb84267ab4e8$export$454b5eaffc99ebf6 = {
    util: {
        Util: (0, $1d054e2973c83a0b$export$2e2bcd8739ae039),
        Cookie: (0, $703c7c10c69d13cf$export$2e2bcd8739ae039),
        Clipboard: (0, $f7ddc352ffbc2dec$export$2e2bcd8739ae039),
        Logger: (0, $cbf92b1807f0afdb$export$2e2bcd8739ae039),
        Class: (0, $ea2d4afe987f356a$export$2e2bcd8739ae039),
        Keys: (0, $23690f1a19c585a1$export$2e2bcd8739ae039)
    },
    views: {
        components: {
            BaseDropDown: (0, $5d09a4a736220f7b$export$2e2bcd8739ae039),
            Notification: (0, $fc9f6cfa7e0f744f$export$2e2bcd8739ae039)
        },
        forms: {
            helpers: {
                FormUtil: (0, $a6671880aee1fa70$export$2e2bcd8739ae039),
                SchemaFormFactory: (0, $36bee8103fa4f4f5$export$2e2bcd8739ae039)
            },
            components: {
                Toolbar: (0, $eb85f03955072115$export$2e2bcd8739ae039)
            },
            inputs: {
                TextBox: $5d64eb84267ab4e8$var$TextBoxForSigninWidget,
                PasswordBox: $5d64eb84267ab4e8$var$PasswordBoxForSigninWidget,
                CheckBox: (0, $4536824db5c003b5$export$2e2bcd8739ae039),
                Radio: (0, $cb1a8d566a16fba4$export$2e2bcd8739ae039),
                Select: $5d64eb84267ab4e8$var$SelectForSigninWidget,
                InputGroup: (0, $69c19c9ef6a0e28d$export$2e2bcd8739ae039)
            }
        }
    },
    models: {
        BaseSchema: (0, $9d7fc9d381913345$export$2e2bcd8739ae039),
        SchemaProperty: (0, $2f2ccccc756c1fbe$export$2e2bcd8739ae039)
    }
};
$5d64eb84267ab4e8$export$2d6b0bdb309bbeb1('text', $5d64eb84267ab4e8$var$TextBoxForSigninWidget);
$5d64eb84267ab4e8$export$2d6b0bdb309bbeb1('password', $5d64eb84267ab4e8$var$PasswordBoxForSigninWidget);
$5d64eb84267ab4e8$export$2d6b0bdb309bbeb1('checkbox', (0, $4536824db5c003b5$export$2e2bcd8739ae039));
$5d64eb84267ab4e8$export$2d6b0bdb309bbeb1('radio', (0, $cb1a8d566a16fba4$export$2e2bcd8739ae039));
$5d64eb84267ab4e8$export$2d6b0bdb309bbeb1('select', $5d64eb84267ab4e8$var$SelectForSigninWidget);
$5d64eb84267ab4e8$export$2d6b0bdb309bbeb1('group', (0, $69c19c9ef6a0e28d$export$2e2bcd8739ae039));

































/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $f24ef70ebb57d1e8$var$KNOWN_ERRORS = [
    'OAuthError',
    'AuthSdkError',
    'AuthPollStopError',
    'AuthApiError'
];
var $f24ef70ebb57d1e8$export$2e2bcd8739ae039 = (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039).extend({
    // May return either a "standard" promise or a Q promise
    doTransaction: function(fn, rethrow) {
        const self = this;
        return fn.call(this, this.appState.get('transaction')).then(function(trans) {
            self.trigger('setTransaction', trans);
            return trans;
        }).catch(function(err) {
            // These are expected control-flow errors - swallow them instead of surfacing as failures
            if (err.name === 'AuthPollStopError' || err.name === (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).AUTH_STOP_POLL_INITIATION_ERROR || err.name === (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).WEBAUTHN_ABORT_ERROR) return;
            self.trigger('error', self, err.xhr);
            self.trigger('setTransactionError', err);
            if (rethrow || (0, $3e490973b7383cc4$export$2e2bcd8739ae039).indexOf($f24ef70ebb57d1e8$var$KNOWN_ERRORS, err.name) === -1) throw err;
        });
    },
    manageTransaction: function(fn) {
        const self = this;
        const res = fn.call(this, this.appState.get('transaction'), (0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(this.setTransaction, this));
        // If it's a promise, listen for failures
        if (res && typeof res.then === 'function') return res.catch(function(err) {
            if (err.name === 'AuthPollStopError' || err.name === (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).AUTH_STOP_POLL_INITIATION_ERROR || err.name === (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).WEBAUTHN_ABORT_ERROR) return;
            self.trigger('error', self, err.xhr);
            self.trigger('setTransactionError', err);
        });
        return Promise.resolve(res);
    },
    startTransaction: function(fn) {
        const self = this;
        const res = fn.call(this, this.settings.getAuthClient());
        // If it's a promise, then chain to it
        if (res && typeof res.then === 'function') return res.then(function(trans) {
            self.trigger('setTransaction', trans);
            return trans;
        }).catch(function(err) {
            self.trigger('error', self, err.xhr);
            self.trigger('setTransactionError', err);
            throw err;
        });
        return Promise.resolve(res);
    },
    setTransaction: function(trans) {
        this.appState.set('transaction', trans);
    }
});












/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $6887ec4c502ac936$var$getForm(controller) {
    return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).find(controller.getChildren(), function(item) {
        return item instanceof (0, $5d64eb84267ab4e8$export$a7fed597f4b8afd8);
    });
}
var $6887ec4c502ac936$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$bd0bf19f25da8474).extend({
    // Ideally we should be attaching the listeners in the constructor, but because of the way
    // we construct the FormController (this.model is generated after the BaseLoginController's
    // constructor is called), this.model is undefined in when try to attach the events and
    // therefore we don't listen to events for such forms. And changing the order in which we call
    // the constructor doesn't help either (JS errors etc.). This at least guarantees that we
    // are listening to the model events.
    // Note - Figure out a way to call the constructor in the right order.
    addListeners: function() {
        // Events to enable/disable the primary button on the forms
        this.listenTo(this.model, 'save', function() {
            const form = $6887ec4c502ac936$var$getForm(this);
            //disable the submit button on forms while making the request
            //to prevent users from hitting rate limiting exceptions of
            //1 per second on the auth api
            const disableSubmitButton = form.disableSubmitButton;
            if (disableSubmitButton && !form.disableSubmitButton()) return;
            this.toggleButtonState(true);
        });
        this.listenTo(this.model, 'error', function() {
            this.toggleButtonState(false);
        });
        this.addModelListeners(this.model);
    },
    addModelListeners: function(model) {
        const setTransactionHandler = (transaction)=>{
            this.options.appState.set('transaction', transaction);
        };
        const transactionErrorHandler = (err)=>{
            this.options.appState.set('transactionError', err);
        };
        // Events to set the transaction attributes on the app state.
        this.listenTo(model, 'setTransaction', setTransactionHandler);
        this.listenTo(model, 'setTransactionError', transactionErrorHandler);
        // For TOTP factor model
        // TOTP model is special, its model will not be attached to a controller, but will
        // tag along with the push factor model. We need to listen to the transaction
        // changes on this as well (in case of the push+totp form).
        const totpModel = model.get('backupFactor');
        if (totpModel) {
            this.listenTo(totpModel, 'setTransaction', setTransactionHandler);
            this.listenTo(totpModel, 'setTransactionError', transactionErrorHandler);
        }
    },
    // Override this method to delay switching to this screen until return
    // promise is resolved. This is useful for cases like enrolling a security
    // question, which requires an additional request to fetch the question
    // list.
    fetchInitialData: function() {
        return Promise.resolve();
    },
    // Override this method to prevent route navigation. This is useful for
    // intermediate status changes that do not trigger a full refresh of the
    // page, like MFA_ENROLL_ACTIVATE and MFA_CHALLENGE.
    trapAuthResponse: function() {
        return false;
    },
    toJSON: function() {
        const data = (0, $5d64eb84267ab4e8$export$bd0bf19f25da8474).prototype.toJSON.apply(this, arguments);
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend((0, $3e490973b7383cc4$export$2e2bcd8739ae039).pick(this.options, 'appState'), data);
    },
    toggleButtonState: function(state) {
        const button = this.$el.find('.button');
        button.toggleClass('link-button-disabled', state).prop('disabled', state);
    },
    postRenderAnimation: function() {
        // Event triggered after a page is rendered along with the classname to identify the page
        // TODO: Deprecate this event in the next major version in favor of 'afterRender'
        this.trigger('pageRendered', {
            page: this.className
        });
        this.trigger('afterRender', {
            controller: this.className
        });
    }
});


/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $d2909dd0ad7c17ab$var$INPUT = 'INPUT';
// Syntactic sugar to provide some structure to SimpleForm inputs - Just
// wraps options with { type: type, viewOptions: viewOptions, addOptions: addOptions }
const $d2909dd0ad7c17ab$var$BUTTON = 'BUTTON';
const $d2909dd0ad7c17ab$var$DIVIDER = 'DIVIDER';
const $d2909dd0ad7c17ab$var$TOOLBAR = 'TOOLBAR';
const $d2909dd0ad7c17ab$var$VIEW = 'VIEW';
function $d2909dd0ad7c17ab$var$wrap(type) {
    return function(viewOptions, addOptions) {
        return {
            type: type,
            viewOptions: viewOptions,
            addOptions: addOptions
        };
    };
}
var $d2909dd0ad7c17ab$export$2e2bcd8739ae039 = {
    Input: $d2909dd0ad7c17ab$var$wrap($d2909dd0ad7c17ab$var$INPUT),
    Button: $d2909dd0ad7c17ab$var$wrap($d2909dd0ad7c17ab$var$BUTTON),
    Divider: $d2909dd0ad7c17ab$var$wrap($d2909dd0ad7c17ab$var$DIVIDER),
    Toolbar: $d2909dd0ad7c17ab$var$wrap($d2909dd0ad7c17ab$var$TOOLBAR),
    View: $d2909dd0ad7c17ab$var$wrap($d2909dd0ad7c17ab$var$VIEW),
    INPUT: $d2909dd0ad7c17ab$var$INPUT,
    BUTTON: $d2909dd0ad7c17ab$var$BUTTON,
    DIVIDER: $d2909dd0ad7c17ab$var$DIVIDER,
    TOOLBAR: $d2909dd0ad7c17ab$var$TOOLBAR,
    VIEW: $d2909dd0ad7c17ab$var$VIEW
};


/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ let { Toolbar: $735c6d0521558dcb$var$Toolbar } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).views.forms.components;
let { FormUtil: $735c6d0521558dcb$var$FormUtil } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).views.forms.helpers;
const $735c6d0521558dcb$var$FormControllerSimpleForm = (0, $5d64eb84267ab4e8$export$a7fed597f4b8afd8).extend({
    layout: 'o-form-theme',
    noCancelButton: true,
    constructor: function(options) {
        (0, $5d64eb84267ab4e8$export$a7fed597f4b8afd8).call(this, options);
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each((0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'formChildren') || [], function(child) {
            switch(child.type){
                case (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).INPUT:
                    this.addInput((0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({
                        label: false,
                        'label-top': true
                    }, child.viewOptions));
                    break;
                case (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).BUTTON:
                    this.add((0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)((0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({
                        model: this.model
                    }, child.viewOptions)), child.addOptions);
                    $735c6d0521558dcb$var$FormUtil.applyShowWhen(this.last(), child.viewOptions && child.viewOptions.showWhen);
                    break;
                case (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).DIVIDER:
                    this.addDivider(child.viewOptions);
                    break;
                case (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).TOOLBAR:
                    this.add($735c6d0521558dcb$var$Toolbar, {
                        options: child.viewOptions
                    });
                    $735c6d0521558dcb$var$FormUtil.applyShowWhen(this.last(), child.viewOptions && child.viewOptions.showWhen);
                    break;
                case (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).VIEW:
                    this.add(child.viewOptions.View, child.addOptions);
                    $735c6d0521558dcb$var$FormUtil.applyShowWhen(this.last(), child.viewOptions.showWhen);
                    break;
                default:
                    throw new Error('Unrecognized child type: ' + child.type);
            }
        }, this);
    }
});
var $735c6d0521558dcb$export$2e2bcd8739ae039 = (0, $6887ec4c502ac936$export$2e2bcd8739ae039).extend({
    constructor: function() {
        const initialize = this.initialize;
        this.initialize = function() {};
        (0, $6887ec4c502ac936$export$2e2bcd8739ae039).apply(this, arguments);
        if (this.Model && this.Form) {
            const Model = (0, $f24ef70ebb57d1e8$export$2e2bcd8739ae039).extend((0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({
                parse: function(attributes) {
                    this.settings = attributes.settings;
                    this.appState = attributes.appState;
                    return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(attributes, [
                        'settings',
                        'appState'
                    ]);
                }
            }, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'Model')));
            this.model = new Model({
                settings: this.settings,
                appState: this.options.appState
            }, {
                parse: true
            });
            const Form = $735c6d0521558dcb$var$FormControllerSimpleForm.extend((0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'Form', this));
            this.form = new Form(this.toJSON());
            this.add(this.form);
        }
        if (this.Footer) this.addFooter(this.Footer);
        this.addListeners();
        initialize.apply(this, arguments);
    },
    addFooter: function(Footer, args) {
        this.footer = new Footer((0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend(this.toJSON(), args || {}));
        this.add(this.footer);
    },
    toJSON: function() {
        const data = (0, $6887ec4c502ac936$export$2e2bcd8739ae039).prototype.toJSON.apply(this, arguments);
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend((0, $3e490973b7383cc4$export$2e2bcd8739ae039).pick(this.options, 'appState'), data);
    },
    back: function() {
        if (this.footer && this.footer.back) this.footer.back();
    }
});



/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $8b90797548581db5$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'account-unlocked',
    Model: function() {
        return {
            local: {
                userFullName: [
                    'string',
                    false,
                    this.options.appState.get('userFullName')
                ]
            }
        };
    },
    Form: {
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'account.unlock.unlocked.title', 'login'),
        subtitle: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'account.unlock.unlocked.desc', 'login'),
        noButtonBar: true,
        attributes: {
            'data-se': 'account-unlocked'
        },
        formChildren: function() {
            return [
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Button({
                    title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('goback', 'login'),
                    className: 'button button-primary button-wide',
                    attributes: {
                        'data-se': 'back-button'
                    },
                    click: function() {
                        this.state.set('navigateDir', (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).DIRECTION_BACK);
                        this.options.appState.trigger('navigate', '');
                    }
                })
            ];
        }
    }
});















var $758ad6a1b1c6c376$exports = {};
'use strict';
const $758ad6a1b1c6c376$var$converters = {
    days: (value)=>value * 864e5,
    hours: (value)=>value * 36e5,
    minutes: (value)=>value * 6e4,
    seconds: (value)=>value * 1e3,
    milliseconds: (value)=>value,
    microseconds: (value)=>value / 1e3,
    nanoseconds: (value)=>value / 1e6
};
const $758ad6a1b1c6c376$var$toMilliseconds = (object)=>Object.entries(object).reduce((milliseconds, [key, value])=>{
        if (typeof value !== 'number') throw new TypeError(`Expected a \`number\` for key \`${key}\`, got \`${value}\` (${typeof value})`);
        if (!$758ad6a1b1c6c376$var$converters[key]) throw new Error('Unsupported time key');
        return milliseconds + $758ad6a1b1c6c376$var$converters[key](value);
    }, 0);
$758ad6a1b1c6c376$exports = $758ad6a1b1c6c376$var$toMilliseconds;
// TODO: remove this for next major version
$758ad6a1b1c6c376$exports.default = $758ad6a1b1c6c376$var$toMilliseconds;


var $d94bc124775c5f91$exports = {};
'use strict';
$d94bc124775c5f91$exports = (milliseconds)=>{
    if (typeof milliseconds !== 'number') throw new TypeError('Expected a number');
    const roundTowardsZero = milliseconds > 0 ? Math.floor : Math.ceil;
    return {
        days: roundTowardsZero(milliseconds / 86400000),
        hours: roundTowardsZero(milliseconds / 3600000) % 24,
        minutes: roundTowardsZero(milliseconds / 60000) % 60,
        seconds: roundTowardsZero(milliseconds / 1000) % 60,
        milliseconds: roundTowardsZero(milliseconds) % 1000,
        microseconds: roundTowardsZero(milliseconds * 1000) % 1000,
        nanoseconds: roundTowardsZero(milliseconds * 1e6) % 1000
    };
};


const $40aeee952775c03c$var$MS_PER_DAY = 86400000;
const $40aeee952775c03c$var$MOMENT_UNIT = {
    MILLISECOND: 'milliseconds',
    SECOND: 'seconds',
    MINUTE: 'minutes',
    HOUR: 'hours',
    DAY: 'days'
};
const $40aeee952775c03c$var$MOMENT_UNIT_KEYS = Object.keys($40aeee952775c03c$var$MOMENT_UNIT);
/**
 * @method convertMomentUnits
 * Conversion between moment's units and our units internally
 *
 * @param {String} momentUnit The units that val is in
 * @return {String} The key in the MOMENT_UNIT hash
 */ const $40aeee952775c03c$var$convertMomentUnits = function(momentUnit) {
    const entry = $40aeee952775c03c$var$MOMENT_UNIT_KEYS.filter((k)=>$40aeee952775c03c$var$MOMENT_UNIT[k] === momentUnit);
    return entry.length === 1 ? entry[0] : momentUnit;
};
var $40aeee952775c03c$export$2e2bcd8739ae039 = {
    /**
   * @method getTimeInHighestRelevantUnit
   * Will return a number in the units of the highest relevant time unit.
   * Only checks milliseconds, seconds, minutes, hours, and days.
   * E.g.
   *   15 MINUTE  -> 15 MINUTE
   *   15 minutes -> 15 MINUTE
   *   60 minutes ->  1 HOUR
   *   90 minutes -> 90 MINUTE
   *   24 HOUR    ->  1 DAY
   *   24 hours   ->  1 DAY
   *   30 DAY     -> 30 DAY
   *
   * @typedef { "MILLISECOND" | "SECOND" | "MINUTE" | "HOUR" | "DAY" } TimeUnit
   *
   * @typedef { "MILLISECOND" | "SECOND" | "MINUTE" | "HOUR" | "DAY" |
   *            "milliseconds" | "seconds" | "minutes" | "hours" | "days"
   *          } FlexibleTimeUnit
   *
   * @typedef TimeAndUnit
   * @property {number} time the consolidated time
   * @property {TimeUnit} unit the unit of the time
   *
   * @param {FlexibleTimeUnit} unit The time unit
   * @return {TimeAndUnit} An object containing the amount of time and the unit
   */ getTimeInHighestRelevantUnit: function(val, unit) {
        const defaultTimeObj = {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
            milliseconds: 0
        };
        const normalizedUnit = $40aeee952775c03c$var$MOMENT_UNIT[unit] || unit;
        let timeObj;
        try {
            const ms = (0, (/*@__PURE__*/$parcel$interopDefault($758ad6a1b1c6c376$exports)))(Object.assign(defaultTimeObj, {
                [normalizedUnit]: val
            }));
            timeObj = (0, (/*@__PURE__*/$parcel$interopDefault($d94bc124775c5f91$exports)))(ms);
        } catch (error) {
            timeObj = {};
        }
        const duration = Object.keys(timeObj).reduce((init, k)=>{
            if (timeObj[k] !== 0) init[k] = timeObj[k];
            return init;
        }, {});
        let highestUnit;
        let time;
        if (Object.keys(duration).length === 1) Object.keys(duration).forEach((k)=>{
            time = duration[k];
            highestUnit = k;
        });
        else {
            time = val;
            highestUnit = normalizedUnit;
        }
        return {
            time: time,
            unit: $40aeee952775c03c$var$convertMomentUnits(highestUnit)
        };
    },
    /**
   * @method formatDateToDeviceAssuranceGracePeriodExpiryLocaleString
   * Conversion from a Date object to a locale string that mimics Okta's `short-with-timezone` format
   * but rounded down to the nearest hour
   * e.g. new Date(2024-09-05T00:00:00.000Z) -> 09/05/2024, 8:00 PM EDT
   * 
   * @param {Date} date The Date object for the grace period expiry
   * @param {string[] | string | null | undefined} languageTags The user's language tags, ordered by preference
   * @param {RoundDownToNearestHour} boolean Whether to round down to nearest hour. Defaults to true
   * @return {string | null} The formatted `short-with-timezone` local string
   */ formatDateToDeviceAssuranceGracePeriodExpiryLocaleString: (date, languageTags, roundDownToNearestHour = true)=>{
        try {
            // Invalid Date objects will return NaN for valueOf()
            if (!(date instanceof Date) || isNaN(date.valueOf())) return null;
            if (languageTags === null) return null;
            if (roundDownToNearestHour) // Round down the date to the nearest hour
            date.setMinutes(0, 0, 0);
            const formatOptions = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                timeZoneName: 'short'
            };
            return date.toLocaleString(languageTags, formatOptions);
        } catch (e) {
            // If `languageCode` isn't in a valid format `toLocaleString()` will throw a `RangeError`
            return null;
        }
    },
    /**
   * @method calculateDaysBetween
   * Calculate the number of days between two epoch milliseconds timestamps
   * rounded down to the nearest day
   *
   * @param {Integer} epoch1 epoch timestamp in milliseconds as an integer
   * @param {Integer} epoch2 epoch timestamp in milliseconds as an integer
   * @return {Integer} The number of days between the two epoch timestamps
   */ calculateDaysBetween: function(epoch1, epoch2) {
        try {
            if (typeof epoch1 === 'number' && typeof epoch2 === 'number') {
                const diffInMs = Math.abs(epoch2 - epoch1);
                const days = Math.floor(diffInMs / $40aeee952775c03c$var$MS_PER_DAY);
                return days;
            }
        } catch (e) {
        // continue even with error
        }
        return null;
    }
};


/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $020a58caf88b7504$export$2e2bcd8739ae039 = {};
const $020a58caf88b7504$var$factorData = {
    OKTA_VERIFY: {
        /* eslint-disable-next-line @okta/okta/no-unlocalized-text */ label: 'factor.totpSoft.oktaVerify',
        description: 'factor.totpSoft.description',
        iconClassName: 'mfa-okta-verify',
        sortOrder: 1
    },
    OKTA_VERIFY_PUSH: {
        /* eslint-disable-next-line @okta/okta/no-unlocalized-text */ label: 'factor.oktaVerifyPush',
        description: 'factor.push.description',
        iconClassName: 'mfa-okta-verify',
        sortOrder: 1
    },
    U2F: {
        /* eslint-disable-next-line @okta/okta/no-unlocalized-text */ label: 'factor.u2f',
        description: (brandName)=>{
            return brandName ? 'factor.u2f.description.specific' : 'factor.u2f.description.generic';
        },
        iconClassName: 'mfa-u2f',
        sortOrder: 2
    },
    WEBAUTHN: {
        /* eslint-disable-next-line @okta/okta/no-unlocalized-text */ label: 'factor.webauthn.biometric',
        description: 'factor.webauthn.biometric.description',
        iconClassName: 'mfa-webauthn',
        sortOrder: 2
    },
    WINDOWS_HELLO: {
        /* eslint-disable-next-line @okta/okta/no-unlocalized-text */ label: 'factor.windowsHello',
        description: (brandName)=>{
            return brandName ? 'factor.windowsHello.signin.description.specific' : 'factor.windowsHello.signin.description.generic';
        },
        iconClassName: 'mfa-windows-hello',
        sortOrder: 3
    },
    YUBIKEY: {
        /* eslint-disable-next-line @okta/okta/no-unlocalized-text */ label: 'factor.totpHard.yubikey',
        description: 'factor.totpHard.yubikey.description',
        iconClassName: 'mfa-yubikey',
        sortOrder: 4
    },
    GOOGLE_AUTH: {
        /* eslint-disable-next-line @okta/okta/no-unlocalized-text */ label: 'factor.totpSoft.googleAuthenticator',
        description: 'factor.totpSoft.description',
        iconClassName: 'mfa-google-auth',
        sortOrder: 5
    },
    CUSTOM_HOTP: {
        /* eslint-disable-next-line @okta/okta/no-unlocalized-text */ label: '',
        description: 'factor.hotp.description',
        iconClassName: 'mfa-hotp',
        sortOrder: 6
    },
    SMS: {
        /* eslint-disable-next-line @okta/okta/no-unlocalized-text */ label: 'factor.sms',
        description: 'factor.sms.description',
        iconClassName: 'mfa-okta-sms',
        sortOrder: 7
    },
    CALL: {
        /* eslint-disable-next-line @okta/okta/no-unlocalized-text */ label: 'factor.call',
        description: 'factor.call.description',
        iconClassName: 'mfa-okta-call',
        sortOrder: 8
    },
    EMAIL: {
        /* eslint-disable-next-line @okta/okta/no-unlocalized-text */ label: 'factor.email',
        description: 'factor.email.description',
        iconClassName: 'mfa-okta-email',
        sortOrder: 9
    },
    QUESTION: {
        /* eslint-disable-next-line @okta/okta/no-unlocalized-text */ label: 'factor.securityQuestion',
        description: 'factor.securityQuestion.description',
        iconClassName: 'mfa-okta-security-question',
        sortOrder: 10
    },
    DUO: {
        /* eslint-disable-next-line @okta/okta/no-unlocalized-text */ label: 'factor.duo',
        description: 'factor.duo.description',
        iconClassName: 'mfa-duo',
        sortOrder: 11
    },
    SYMANTEC_VIP: {
        /* eslint-disable-next-line @okta/okta/no-unlocalized-text */ label: 'factor.totpHard.symantecVip',
        description: 'factor.totpHard.description',
        iconClassName: 'mfa-symantec',
        sortOrder: 12
    },
    RSA_SECURID: {
        /* eslint-disable-next-line @okta/okta/no-unlocalized-text */ label: 'factor.totpHard.rsaSecurId',
        description: 'factor.totpHard.description',
        iconClassName: 'mfa-rsa',
        sortOrder: 13
    },
    ON_PREM: {
        /* eslint-disable-next-line @okta/okta/no-unlocalized-text */ label: '',
        description: 'factor.totpHard.description',
        iconClassName: 'mfa-onprem',
        sortOrder: 14
    },
    PASSWORD: {
        /* eslint-disable-next-line @okta/okta/no-unlocalized-text */ label: 'factor.password',
        description: '',
        iconClassName: 'mfa-okta-password',
        sortOrder: 15
    },
    CUSTOM_CLAIMS: {
        /* eslint-disable-next-line @okta/okta/no-unlocalized-text */ label: '',
        description: 'factor.customFactor.description',
        iconClassName: 'mfa-custom-factor',
        sortOrder: 16
    },
    GENERIC_SAML: {
        /* eslint-disable-next-line @okta/okta/no-unlocalized-text */ label: '',
        description: (brandName)=>{
            return brandName ? 'factor.customFactor.description.specific' : 'factor.customFactor.description.generic';
        },
        iconClassName: 'mfa-custom-factor',
        sortOrder: 17
    },
    GENERIC_OIDC: {
        /* eslint-disable-next-line @okta/okta/no-unlocalized-text */ label: '',
        description: (brandName)=>{
            return brandName ? 'factor.customFactor.description.specific' : 'factor.customFactor.description.generic';
        },
        iconClassName: 'mfa-custom-factor',
        sortOrder: 18
    }
};
const $020a58caf88b7504$var$getPasswordComplexityRequirementsAsArray = function(policy, i18nKeys) {
    const setExcludeAttributes = function(policyComplexity) {
        const excludeAttributes = policyComplexity.excludeAttributes;
        policyComplexity.excludeFirstName = (0, $187365f460a6e3ed$export$2e2bcd8739ae039).contains(excludeAttributes, 'firstName');
        policyComplexity.excludeLastName = (0, $187365f460a6e3ed$export$2e2bcd8739ae039).contains(excludeAttributes, 'lastName');
        return (0, $187365f460a6e3ed$export$2e2bcd8739ae039).omit(policyComplexity, 'excludeAttributes');
    };
    if (policy.complexity) {
        const complexityFields = i18nKeys.complexity;
        const policyComplexity = setExcludeAttributes(policy.complexity);
        let filteredPolicyComplexity = policyComplexity;
        // If useADComplexityRequirements is true, ignore casing, number, and symbol rules since
        // AD validator handles those requirements
        if (policyComplexity.useADComplexityRequirements) {
            const allowed = [
                'minLength',
                'useADComplexityRequirements',
                'excludeUsername',
                'excludeFirstName',
                'excludeLastName',
                'excludeAttributes'
            ];
            filteredPolicyComplexity = (0, $187365f460a6e3ed$export$2e2bcd8739ae039).pick(policyComplexity, allowed);
        }
        const requirements = (0, $187365f460a6e3ed$export$2e2bcd8739ae039).map(filteredPolicyComplexity, function(complexityValue, complexityType) {
            if (complexityValue <= 0) // to skip 0 and -1
            return;
            const params = complexityFields[complexityType];
            return params.args ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)(params.i18n, 'login', [
                complexityValue
            ]) : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)(params.i18n, 'login');
        });
        return (0, $187365f460a6e3ed$export$2e2bcd8739ae039).compact(requirements);
    }
    return [];
};
const $020a58caf88b7504$var$getPasswordHistoryRequirementDescription = function(policy, i18nKeys, isUpdatedPasswordRequirementsText) {
    if (policy.age && policy.age.historyCount > 0) {
        if (isUpdatedPasswordRequirementsText) return policy.age.historyCount === 1 ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)(i18nKeys.history.one.i18n, 'login') : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)(i18nKeys.history.many.i18n, 'login', [
            policy.age.historyCount
        ]);
        else return (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)(i18nKeys.history.i18n, 'login', [
            policy.age.historyCount
        ]);
    }
    return null;
};
const $020a58caf88b7504$var$getPasswordAgeRequirementDescription = function(policy, i18nKeys) {
    const getPasswordAgeRequirement = function(displayableTime) {
        let propertiesString;
        switch(displayableTime.unit){
            case 'DAY':
                propertiesString = i18nKeys.age.days.i18n;
                break;
            case 'HOUR':
                propertiesString = i18nKeys.age.hours.i18n;
                break;
            case 'MINUTE':
                propertiesString = i18nKeys.age.minutes.i18n;
        }
        return (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)(propertiesString, 'login', [
            displayableTime.time
        ]);
    };
    if (policy.age && policy.age.minAgeMinutes > 0) {
        const displayableTime = (0, $40aeee952775c03c$export$2e2bcd8739ae039).getTimeInHighestRelevantUnit(policy.age.minAgeMinutes, 'MINUTE');
        return getPasswordAgeRequirement(displayableTime);
    }
    return null;
};
const $020a58caf88b7504$var$getPasswordRequirements = function(policy, i18nKeys, isUpdatedPasswordRequirementsText) {
    const passwordRequirements = {
        complexity: [],
        history: [],
        age: []
    };
    passwordRequirements.complexity = $020a58caf88b7504$var$getPasswordComplexityRequirementsAsArray(policy, i18nKeys);
    const historyRequirement = $020a58caf88b7504$var$getPasswordHistoryRequirementDescription(policy, i18nKeys, isUpdatedPasswordRequirementsText);
    if (historyRequirement) passwordRequirements.history.push(historyRequirement);
    const ageRequirement = $020a58caf88b7504$var$getPasswordAgeRequirementDescription(policy, i18nKeys);
    if (ageRequirement) passwordRequirements.age.push(ageRequirement);
    return passwordRequirements;
};
$020a58caf88b7504$export$2e2bcd8739ae039.getFactorName = function(provider, factorType) {
    if (provider === 'OKTA' && factorType === 'token:software:totp') return 'OKTA_VERIFY';
    if (provider === 'OKTA' && factorType === 'push') return 'OKTA_VERIFY_PUSH';
    if (provider === 'GOOGLE') return 'GOOGLE_AUTH';
    if (provider === 'SYMANTEC' && factorType === 'token') return 'SYMANTEC_VIP';
    if (provider === 'RSA' && factorType === 'token') return 'RSA_SECURID';
    if (provider === 'DEL_OATH' && factorType === 'token') return 'ON_PREM';
    if (provider === 'DUO' && factorType === 'web') return 'DUO';
    if (provider === 'YUBICO' && factorType === 'token:hardware') return 'YUBIKEY';
    if (provider === 'OKTA' && factorType === 'sms') return 'SMS';
    if (provider === 'OKTA' && factorType === 'call') return 'CALL';
    if (provider === 'OKTA' && factorType === 'question') return 'QUESTION';
    if (provider === 'OKTA' && factorType === 'email') return 'EMAIL';
    if (provider === 'OKTA' && factorType === 'password') return 'PASSWORD';
    if (provider === 'GENERIC_SAML' && factorType === 'assertion:saml2') return 'GENERIC_SAML';
    if (provider === 'GENERIC_OIDC' && factorType === 'assertion:oidc') return 'GENERIC_OIDC';
    return $020a58caf88b7504$export$2e2bcd8739ae039.getFactorNameForFactorType.call(this, factorType);
};
$020a58caf88b7504$export$2e2bcd8739ae039.getFactorNameForFactorType = function(factorType) {
    if (factorType === 'u2f') return 'U2F';
    if (factorType === 'token:software:totp') return 'OKTA_VERIFY';
    if (factorType === 'webauthn') {
        if (this.settings.get('features.webauthn')) return 'WEBAUTHN';
        else return 'WINDOWS_HELLO';
    }
    if (factorType === 'token:hotp') return 'CUSTOM_HOTP';
    if (factorType === 'claims_provider') return 'CUSTOM_CLAIMS';
};
$020a58caf88b7504$export$2e2bcd8739ae039.isOktaVerify = function(provider, factorType) {
    return provider === 'OKTA' && (factorType === 'token:software:totp' || factorType === 'push');
};
$020a58caf88b7504$export$2e2bcd8739ae039.getFactorLabel = function(provider, factorType) {
    const key = $020a58caf88b7504$var$factorData[$020a58caf88b7504$export$2e2bcd8739ae039.getFactorName.apply(this, [
        provider,
        factorType
    ])].label;
    return (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)(key, 'login');
};
$020a58caf88b7504$export$2e2bcd8739ae039.getFactorDescription = function(provider, factorType) {
    const descriptionKey = $020a58caf88b7504$var$factorData[$020a58caf88b7504$export$2e2bcd8739ae039.getFactorName.apply(this, [
        provider,
        factorType
    ])].description;
    if ((0, $187365f460a6e3ed$export$2e2bcd8739ae039).isFunction(descriptionKey)) {
        const brandName = this.settings.get('brandName');
        const key = descriptionKey(brandName);
        return brandName ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)(key, 'login', [
            brandName
        ]) : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)(key, 'login');
    } else return descriptionKey ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)(descriptionKey, 'login') : '';
};
$020a58caf88b7504$export$2e2bcd8739ae039.getFactorIconClassName = function(provider, factorType) {
    return $020a58caf88b7504$var$factorData[$020a58caf88b7504$export$2e2bcd8739ae039.getFactorName.apply(this, [
        provider,
        factorType
    ])].iconClassName;
};
$020a58caf88b7504$export$2e2bcd8739ae039.getFactorSortOrder = function(provider, factorType) {
    return $020a58caf88b7504$var$factorData[$020a58caf88b7504$export$2e2bcd8739ae039.getFactorName.apply(this, [
        provider,
        factorType
    ])].sortOrder;
};
$020a58caf88b7504$export$2e2bcd8739ae039.getRememberDeviceValue = function(appState) {
    return appState && appState.get('rememberDeviceByDefault');
};
$020a58caf88b7504$export$2e2bcd8739ae039.getSecurityQuestionLabel = function(questionObj) {
    const localizedQuestion = (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('security.' + questionObj.question);
    return localizedQuestion.indexOf('L10N_ERROR') < 0 ? localizedQuestion : questionObj.questionText;
};
$020a58caf88b7504$export$2e2bcd8739ae039.removeRequirementsFromError = function(responseJSON, policy) {
    const passwordRequirementsAsString = this.getPasswordComplexityDescription(policy);
    if (responseJSON.errorCauses && responseJSON.errorCauses.length > 0 && (0, $187365f460a6e3ed$export$2e2bcd8739ae039).isString(responseJSON.errorCauses[0].errorSummary)) responseJSON.errorCauses[0].errorSummary = responseJSON.errorCauses[0].errorSummary.replace(passwordRequirementsAsString, '').trim();
    return responseJSON;
};
$020a58caf88b7504$export$2e2bcd8739ae039.getPasswordComplexityDescriptionForHtmlList = function(policy) {
    const passwordRequirementHtmlI18nKeys = {
        complexity: {
            minLength: {
                i18n: 'password.complexity.length.description',
                args: true
            },
            minLowerCase: {
                i18n: 'password.complexity.lowercase.description'
            },
            minUpperCase: {
                i18n: 'password.complexity.uppercase.description'
            },
            minNumber: {
                i18n: 'password.complexity.number.description'
            },
            minSymbol: {
                i18n: 'password.complexity.symbol.description'
            },
            excludeUsername: {
                i18n: 'password.complexity.no_username.description'
            },
            excludeFirstName: {
                i18n: 'password.complexity.no_first_name.description'
            },
            excludeLastName: {
                i18n: 'password.complexity.no_last_name.description'
            },
            useADComplexityRequirements: {
                i18n: 'password.complexity.adRequirements.description'
            },
            maxConsecutiveRepeatingCharacters: {
                i18n: 'password.complexity.maxConsecutiveRepeatingCharacters.description',
                args: true
            }
        },
        history: {
            one: {
                i18n: 'password.complexity.history.one.description'
            },
            many: {
                i18n: 'password.complexity.history.description'
            }
        },
        age: {
            minutes: {
                i18n: 'password.complexity.minAgeMinutes.description'
            },
            hours: {
                i18n: 'password.complexity.minAgeHours.description'
            },
            days: {
                i18n: 'password.complexity.minAgeDays.description'
            }
        }
    };
    const passwordRequirements = $020a58caf88b7504$var$getPasswordRequirements(policy, passwordRequirementHtmlI18nKeys, true);
    return (0, $187365f460a6e3ed$export$2e2bcd8739ae039).union(passwordRequirements.complexity, passwordRequirements.history, passwordRequirements.age);
};
$020a58caf88b7504$export$2e2bcd8739ae039.getPasswordComplexityDescription = function(policy) {
    const passwordRequirementI18nKeys = {
        complexity: {
            minLength: {
                i18n: 'password.complexity.length',
                args: true
            },
            minLowerCase: {
                i18n: 'password.complexity.lowercase'
            },
            minUpperCase: {
                i18n: 'password.complexity.uppercase'
            },
            minNumber: {
                i18n: 'password.complexity.number'
            },
            minSymbol: {
                i18n: 'password.complexity.symbol'
            },
            excludeUsername: {
                i18n: 'password.complexity.no_username'
            },
            excludeFirstName: {
                i18n: 'password.complexity.no_first_name'
            },
            excludeLastName: {
                i18n: 'password.complexity.no_last_name'
            },
            useADComplexityRequirements: {
                i18n: 'password.complexity.adRequirements'
            },
            maxConsecutiveRepeatingCharacters: {
                i18n: 'password.complexity.maxConsecutiveRepeatingCharacters',
                args: true
            }
        },
        history: {
            i18n: 'password.complexity.history'
        },
        age: {
            minutes: {
                i18n: 'password.complexity.minAgeMinutes'
            },
            hours: {
                i18n: 'password.complexity.minAgeHours'
            },
            days: {
                i18n: 'password.complexity.minAgeDays'
            }
        }
    };
    const result = [];
    const passwordRequirements = $020a58caf88b7504$var$getPasswordRequirements(policy, passwordRequirementI18nKeys, false);
    let requirements = passwordRequirements.complexity;
    // Generate and add complexity string to result
    if (requirements.length > 0) {
        requirements = (0, $187365f460a6e3ed$export$2e2bcd8739ae039).reduce(requirements, function(result, requirement) {
            return result ? result + (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('password.complexity.list.element', 'login', [
                requirement
            ]) : requirement;
        });
        result.push((0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('password.complexity.requirements', 'login', [
            requirements
        ]));
    }
    // Only 1 value expected in history and age for now
    result.push(passwordRequirements.history[0]);
    result.push(passwordRequirements.age[0]);
    return (0, $187365f460a6e3ed$export$2e2bcd8739ae039).compact(result).join(' ');
};
$020a58caf88b7504$export$2e2bcd8739ae039.getCardinalityText = function(enrolled, required, cardinality) {
    if (cardinality) {
        if (enrolled) return cardinality.enrolled === 1 ? '' : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('enroll.choices.cardinality.setup', 'login', [
            cardinality.enrolled
        ]);
        else if (required && cardinality.maximum > 1) return (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('enroll.choices.cardinality.setup.remaining', 'login', [
            cardinality.enrolled,
            cardinality.minimum
        ]);
    }
    return '';
};
$020a58caf88b7504$export$2e2bcd8739ae039.findFactorInFactorsArray = function(factors, provider, factorType) {
    let factor = factors.findWhere({
        provider: provider,
        factorType: factorType
    });
    if (factor === undefined) //for factors that support cardinality and only have factorType
    factor = factors.findWhere({
        factorType: factorType
    });
    return factor;
};
















/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const { TextBox: $063de20ba11c0f5c$var$TextBox } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).views.forms.inputs;
var $063de20ba11c0f5c$export$2e2bcd8739ae039 = $063de20ba11c0f5c$var$TextBox.extend({
    postRender: function() {
        if (this.options.type === 'number') {
            const input = this.$('input');
            input.attr({
                pattern: '[0-9]*',
                inputmode: 'numeric'
            });
        }
        $063de20ba11c0f5c$var$TextBox.prototype.postRender.apply(this, arguments);
    },
    // Override the focus() to ignore focus in IE. IE (8-11) has a known bug where
    // the placeholder text disappears when the input field is focused.
    focus: function() {
        if ((0, $22893d6dea78fc87$export$2e2bcd8739ae039).isIE()) return;
        return $063de20ba11c0f5c$var$TextBox.prototype.focus.apply(this, arguments);
    }
});


/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $f79ddf3172172fca$export$2e2bcd8739ae039 = {
    title: function() {
        const factorName = (0, $020a58caf88b7504$export$2e2bcd8739ae039).getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.totp.title', 'login', [
            factorName
        ]);
    },
    subtitle: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'enroll.totp.enterCode', 'login'),
    autoSave: true,
    noButtonBar: true,
    attributes: {
        'data-se': 'step-sendcode'
    },
    formChildren: function() {
        return [
            (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.enterCode.placeholder', 'login'),
                'label-top': true,
                explain: (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).createInputExplain('mfa.challenge.enterCode.tooltip', 'mfa.challenge.enterCode.placeholder', 'login'),
                'explain-top': true,
                name: 'passCode',
                input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
                type: 'tel'
            }),
            (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Toolbar({
                noCancelButton: true,
                save: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oform.verify', 'login') // TODO: deprecated by mfa.challenge.verify
            })
        ];
    }
};













var $84975a54a18f1ea8$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "mfa.backToFactors"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 58
                    },
                    "end": {
                        "line": 1,
                        "column": 106
                    }
                }
            })) + "</a>";
        },
        "useData": true
    }),
    className: 'auth-footer',
    events: {
        'click .js-back': function(e) {
            e.preventDefault();
            this.options.appState.trigger('backToFactors');
            this.back();
        }
    },
    back: function() {
        this.state.set('navigateDir', (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).DIRECTION_BACK);
        if (this.options.appState.get('prevLink')) // Once we are in the MFA_ENROLL_ACTIVATE, we need to reset to the
        // correct state. Fortunately, this means that the router will
        // handle navigation once the request is finished.
        this.model.doTransaction(function(transaction) {
            return transaction.prev();
        });
        else this.options.appState.trigger('navigate', 'signin/enroll');
    }
});


/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $79604dba0f9306ba$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'activate-totp',
    Model: function() {
        return {
            props: {
                factorId: [
                    'string',
                    true,
                    this.options.appState.get('activatedFactorId')
                ],
                passCode: [
                    'string',
                    true
                ]
            },
            local: {
                __factorType__: [
                    'string',
                    false,
                    this.options.factorType
                ],
                __provider__: [
                    'string',
                    false,
                    this.options.provider
                ]
            },
            save: function() {
                return this.doTransaction(function(transaction) {
                    return transaction.activate({
                        passCode: this.get('passCode')
                    });
                });
            }
        };
    },
    Form: (0, $f79ddf3172172fca$export$2e2bcd8739ae039),
    Footer: (0, $84975a54a18f1ea8$export$2e2bcd8739ae039)
});



































var $373702671b7f0d06$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'scope-item',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            return "<span class=\"scope-item-tooltip icon form-help-16\" />";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p class=\"scope-item-text no-translate\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
                "name": "name",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 40
                    },
                    "end": {
                        "line": 1,
                        "column": 48
                    }
                }
            }) : helper)) + "</p>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 52
                    },
                    "end": {
                        "line": 1,
                        "column": 131
                    }
                }
            })) != null ? stack1 : "");
        },
        "useData": true
    }),
    postRender: function() {
        this.$('.scope-item-tooltip').qtip({
            content: {
                text: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).escape(this.options.description)
            },
            style: {
                classes: 'okta-tooltip qtip-custom qtip-shadow'
            },
            position: {
                my: 'bottom left',
                target: 'mouse'
            }
        });
    }
});


const $e5403bac0188cec8$var$SCOPE_N_GROUP_CONFIG = {
    groups: 'user',
    myAccount: 'user',
    users: 'user',
    apps: 'resource',
    authenticators: 'resource',
    authorizationServers: 'resource',
    clients: 'resource',
    domains: 'resource',
    factors: 'resource',
    idps: 'resource',
    linkedObjects: 'resource',
    policies: 'resource',
    templates: 'resource',
    eventHooks: 'hook',
    inlineHooks: 'hook',
    events: 'system',
    logs: 'system',
    orgs: 'system',
    roles: 'system',
    schemas: 'system',
    sessions: 'system',
    trustedOrigins: 'system'
};
const $e5403bac0188cec8$var$DEFAULT_GROUP = 'system';
const $e5403bac0188cec8$var$findScopeGroupKey = ({ name: name = '' })=>{
    const xs = name.split('.');
    const groupType = xs[1];
    return $e5403bac0188cec8$var$SCOPE_N_GROUP_CONFIG[groupType] || $e5403bac0188cec8$var$DEFAULT_GROUP;
};
const $e5403bac0188cec8$var$ScopeGroupHeaderView = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'scope-group',
    events: {
        'click': 'expandScopes'
    },
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"scope-group--header\"><h3>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "groupName") || (depth0 != null ? lookupProperty(depth0, "groupName") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "groupName",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 37
                    },
                    "end": {
                        "line": 1,
                        "column": 50
                    }
                }
            }) : helper)) + "</h3><span class=\"scope-group--toggle\"><svg class=\"caret\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path class=\"path\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.99967 4.66663L10.2663 8.66663L11.333 7.66663L5.99967 2.66663L0.666342 7.73636L1.73301 8.66663L5.99967 4.66663Z\" fill=\"#A0A7AC\"></path></svg></span></div>";
        },
        "useData": true
    }),
    expandScopes: function() {
        this.$el.toggleClass('scope-group--is-expanded');
        this.$('.caret').toggleClass('caret--is-rotated');
    },
    preRender: function() {
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).chain(this.options.scopes).sortBy(({ name: name })=>name).each(({ name: name, displayName: displayName, description: description })=>{
            this.add((0, $373702671b7f0d06$export$2e2bcd8739ae039), {
                options: {
                    name: displayName || name,
                    description: description
                }
            });
        });
    }
});
var $e5403bac0188cec8$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'scope-list detail-row',
    postRender: function() {
        const allScopes = this.model.get('scopes');
        const scopesWithGroup = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).groupBy(allScopes, $e5403bac0188cec8$var$findScopeGroupKey);
        const SCOPE_GROUP_NAMES_CONFIG = {
            'user': (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('admin.consent.group.user.group', 'login'),
            'resource': (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('admin.consent.group.resource.policy', 'login'),
            'hook': (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('admin.consent.group.hook', 'login'),
            'system': (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('admin.consent.group.system', 'login')
        };
        // loop through SCOPE_GROUP_NAMES_CONFIG to keep group order consistent in UI.
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(SCOPE_GROUP_NAMES_CONFIG, (groupName, groupKey)=>{
            const scopes = scopesWithGroup[groupKey];
            if (!Array.isArray(scopes)) return;
            // add scope group header and scopes
            this.add($e5403bac0188cec8$var$ScopeGroupHeaderView, {
                options: {
                    groupName: groupName,
                    scopes: scopes
                }
            });
        });
    }
});



const $62892d1a6641656b$export$2e2bcd8739ae039 = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "0": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<a href=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "clientURI") || (depth0 != null ? lookupProperty(depth0, "clientURI") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "clientURI",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 26
                },
                "end": {
                    "line": 1,
                    "column": 39
                }
            }
        }) : helper)) + "\" class=\"client-logo-link\" target=\"_blank\">";
    },
    "1": function(container, depth0, helpers, partials, data) {
        var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<img class=\"client-logo custom-logo\" src=\"" + alias3((helper = (helper = lookupProperty(helpers, "customLogo") || (depth0 != null ? lookupProperty(depth0, "customLogo") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
            "name": "customLogo",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 149
                },
                "end": {
                    "line": 1,
                    "column": 163
                }
            }
        }) : helper)) + "\" alt=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
            "name": "i18n",
            "hash": {
                "bundle": "login",
                "code": "common.logo.alt"
            },
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 170
                },
                "end": {
                    "line": 1,
                    "column": 216
                }
            }
        })) + "\" aria-hidden=\"true\" />";
    },
    "2": function(container, depth0, helpers, partials, data) {
        var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<img class=\"client-logo default-logo\" src=\"" + alias3((helper = (helper = lookupProperty(helpers, "defaultLogo") || (depth0 != null ? lookupProperty(depth0, "defaultLogo") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
            "name": "defaultLogo",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 290
                },
                "end": {
                    "line": 1,
                    "column": 305
                }
            }
        }) : helper)) + "\" alt=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
            "name": "i18n",
            "hash": {
                "bundle": "login",
                "code": "common.logo.alt"
            },
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 312
                },
                "end": {
                    "line": 1,
                    "column": 358
                }
            }
        })) + "\" aria-hidden=\"true\" />";
    },
    "3": function(container, depth0, helpers, partials, data) {
        return "</a>";
    },
    "4": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<div class=\"issuer\"><span>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "issuer") || (depth0 != null ? lookupProperty(depth0, "issuer") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "issuer",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 566
                },
                "end": {
                    "line": 1,
                    "column": 576
                }
            }
        }) : helper)) + "</span></div>";
    },
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "clientURI") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(0, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 0
                },
                "end": {
                    "line": 1,
                    "column": 89
                }
            }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "customLogo") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(1, data, 0),
            "inverse": container.program(2, data, 0),
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 89
                },
                "end": {
                    "line": 1,
                    "column": 388
                }
            }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "clientURI") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(3, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 388
                },
                "end": {
                    "line": 1,
                    "column": 416
                }
            }
        })) != null ? stack1 : "") + "<h1><span class=\"title-text\">" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
            "name": "i18n",
            "hash": {
                "arguments": "appName",
                "bundle": "login",
                "code": "consent.required.text"
            },
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 445
                },
                "end": {
                    "line": 1,
                    "column": 519
                }
            }
        })) != null ? stack1 : "") + "</span>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "issuer") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(4, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 526
                },
                "end": {
                    "line": 1,
                    "column": 596
                }
            }
        })) != null ? stack1 : "") + "</h1>";
    },
    "useData": true
});


/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $c42465bf8c63c685$var$ConsentModel = {
    props: {
        scopes: [
            'array',
            true
        ]
    },
    save: function() {
        return this.doTransaction(function(transaction) {
            return transaction.consent({
                consent: {
                    scopes: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).pluck(this.get('scopes'), 'name')
                }
            });
        });
    },
    cancel: function() {
        var self = this;
        return this.doTransaction(function(transaction) {
            return transaction.cancel();
        }).then(function() {
            var consentCancelFn = self.settings.get('consent.cancel');
            if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(consentCancelFn)) consentCancelFn();
        });
    }
};
const $c42465bf8c63c685$var$ConsentHeader = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'consent-title detail-row',
    template: (0, $62892d1a6641656b$export$2e2bcd8739ae039),
    getTemplateData: function() {
        var appState = this.options.appState;
        return {
            appName: appState.escape('targetLabel'),
            customLogo: appState.get('targetLogo') && appState.get('targetLogo').href,
            defaultLogo: appState.get('defaultAppLogo'),
            clientURI: appState.get('targetClientURI') && appState.get('targetClientURI').href,
            issuer: appState.get('issuer')
        };
    }
});
const $c42465bf8c63c685$var$ConsentForm = {
    noCancelButton: false,
    buttonOrder: [
        'cancel',
        'save'
    ],
    autoSave: true,
    save: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'consent.required.consentButton', 'login'),
    cancel: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'consent.required.cancelButton', 'login'),
    formChildren: [
        (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
            View: $c42465bf8c63c685$var$ConsentHeader
        }),
        (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
            View: (0, $e5403bac0188cec8$export$2e2bcd8739ae039)
        })
    ]
};
const $c42465bf8c63c685$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    Model: $c42465bf8c63c685$var$ConsentModel,
    Form: $c42465bf8c63c685$var$ConsentForm,
    className: 'admin-consent-required',
    initialize: function() {
        this.model.set('scopes', this.options.appState.get('scopes'));
        this.listenTo(this.form, 'cancel', ()=>{
            this.model.cancel();
        });
    }
});






































/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $da289f4aadbacd56$export$2e2bcd8739ae039 = {
    INVALID_TOKEN_EXCEPTION: 'E0000011'
};








class $c5998cb91d464d17$var$InlineErrorType {
    constructor(){
        this.inline = true;
    }
}
class $c5998cb91d464d17$var$TerminalErrorType {
    constructor(){
        this.terminal = true;
    }
}
class $c5998cb91d464d17$export$8c0f9e65211c3428 extends (0, $3fe6932680e7ea64$export$bdc0f363b754b88f) {
    constructor(originalError, errorTypeCtor){
        super(originalError.message);
        this.errorType = void 0;
        this.orginalError = void 0;
        this.errorDetails = void 0;
        this.errorType = new errorTypeCtor();
        this.orginalError = originalError;
        this.errorDetails = {
            errorSummary: this.getErrorSummary(),
            errorCode: originalError.errorCode,
            errorCauses: 'errorCauses' in originalError ? originalError.errorCauses : undefined
        };
    }
    getErrorSummary() {
        return this.orginalError.errorSummary;
    }
    is(errorTrait) {
        var _Object$getOwnPropert;
        return Boolean((_Object$getOwnPropert = Object.getOwnPropertyDescriptor(this.errorType, errorTrait)) === null || _Object$getOwnPropert === void 0 ? void 0 : _Object$getOwnPropert.value);
    }
}
class $c5998cb91d464d17$export$4dab270a958fec91 extends $c5998cb91d464d17$export$8c0f9e65211c3428 {
}
class $c5998cb91d464d17$export$15047ea091c3ed08 extends $c5998cb91d464d17$export$8c0f9e65211c3428 {
}
class $c5998cb91d464d17$export$7797b6d0d33d4565 extends $c5998cb91d464d17$export$4dab270a958fec91 {
    constructor(error){
        super(error, $c5998cb91d464d17$var$TerminalErrorType);
    }
    getErrorSummary() {
        return (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('error.unsynced.clock', 'login');
    }
}
class $c5998cb91d464d17$export$f47ac96d68ef3171 extends $c5998cb91d464d17$export$4dab270a958fec91 {
    constructor(error){
        super(error, $c5998cb91d464d17$var$InlineErrorType);
    }
}
class $c5998cb91d464d17$export$7ea9ac005b25e174 extends $c5998cb91d464d17$export$4dab270a958fec91 {
    constructor(error){
        super(error, $c5998cb91d464d17$var$InlineErrorType);
    }
    getErrorSummary() {
        return (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('error.jit_failure', 'login');
    }
}
class $c5998cb91d464d17$export$c59494f4dae44ada extends $c5998cb91d464d17$export$15047ea091c3ed08 {
    constructor(error){
        super(error, $c5998cb91d464d17$var$InlineErrorType);
    }
    getErrorSummary() {
        return (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('error.mfa.required', 'login');
    }
}
function $c5998cb91d464d17$export$f1b5849350c3fa45(error) {
    switch(error.errorCode){
        case 'access_denied':
            return new $c5998cb91d464d17$export$f47ac96d68ef3171(error);
        case 'jit_failure_missing_fields':
        case 'jit_failure_invalid_login_format':
        case 'jit_failure_values_not_match_pattern':
        case 'jit_failure_values_too_long':
        case 'jit_failure_invalid_locale':
            return new $c5998cb91d464d17$export$7ea9ac005b25e174(error);
        case 'login_required':
            const mfaRequiredMsg = 'The client specified not to prompt, but the client app requires re-authentication or MFA.';
            if (error.message === mfaRequiredMsg) return new $c5998cb91d464d17$export$c59494f4dae44ada(error);
        case 'INTERNAL':
            const clockDriftMsg = 'The JWT was issued in the future';
            if (error.message === clockDriftMsg) return new $c5998cb91d464d17$export$7797b6d0d33d4565(error);
        default:
            return new $c5998cb91d464d17$export$4dab270a958fec91(error, Object);
    }
}



/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $5eccc61229d1b47f$export$2e2bcd8739ae039 = {};
// https://github.com/okta/okta-auth-js#authorize-options
const $5eccc61229d1b47f$var$AUTH_PARAMS = [
    'responseType',
    'scopes',
    'state',
    'nonce',
    'idp',
    'idpScope',
    'display',
    'prompt',
    'maxAge',
    'loginHint'
];
$5eccc61229d1b47f$export$2e2bcd8739ae039.AUTH_PARAMS = $5eccc61229d1b47f$var$AUTH_PARAMS;
/**
 * Get the tokens in the OIDC/OAUTH flows
 *
 * @param settings - settings model object
 * @param params - {idp: 'xxx'} for social auth
 *                 {sessionToken: 'xxx'} for okta idp
 */ $5eccc61229d1b47f$export$2e2bcd8739ae039.getTokens = function(settings, params, controller) {
    function success(result) {
        settings.callGlobalSuccess((0, $e48c043f6d2d382d$export$2e2bcd8739ae039).SUCCESS, result);
    }
    function error(error) {
        const typedError = (0, $c5998cb91d464d17$export$f1b5849350c3fa45)(error);
        if (typedError.is('terminal')) {
            controller.model.appState.set('flashError', typedError);
            controller.model.appState.trigger('navigate', 'signin/error');
        } else if (typedError.is('inline')) {
            controller.model.trigger('error', controller.model, {
                responseJSON: {
                    errorSummary: typedError.errorDetails.errorSummary
                }
            });
            controller.model.appState.trigger('removeLoading');
        }
        if (!typedError.is('terminal')) (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).triggerAfterError(controller, typedError, settings);
        if (typedError instanceof (0, $c5998cb91d464d17$export$15047ea091c3ed08)) settings.callGlobalError(typedError);
    }
    const authClient = settings.getAuthClient();
    const isAuthorizationCodeFlow = authClient.isAuthorizationCodeFlow() && !authClient.isPKCE();
    const options = settings.toJSON({
        verbose: true
    });
    const getTokenOptions = {};
    (0, $187365f460a6e3ed$export$2e2bcd8739ae039).extend(getTokenOptions, (0, $187365f460a6e3ed$export$2e2bcd8739ae039).pick(options, 'clientId', 'redirectUri'), (0, $187365f460a6e3ed$export$2e2bcd8739ae039).pick(options.authParams, $5eccc61229d1b47f$var$AUTH_PARAMS), params);
    // Extra Options for Social Idp popup window title and id_token response timeout
    getTokenOptions.popupTitle = (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('socialauth.popup.title', 'login');
    getTokenOptions.timeout = options.oAuthTimeout;
    // Redirect flow - this can be used when logging into an external IDP, or
    // converting the Okta sessionToken to an access_token, id_token, and/or
    // authorization code. Note: The authorization code flow will always redirect.
    if (options.redirect === 'always' || isAuthorizationCodeFlow) authClient.token.getWithRedirect(getTokenOptions).catch(error);
    else if (getTokenOptions.sessionToken) // Default flow if logging in with Okta as the IDP - convert sessionToken to
    // tokens in a hidden iframe. Used in Single Page Apps where the app does
    // not want to redirect away from the page to convert the token.
    authClient.token.getWithoutPrompt(getTokenOptions).then(success).catch(error);
    else {
        // Default flow if logging in with an external IDP - opens a popup and
        // gets the token from a postMessage response.
        if (options.initialPopupPath) getTokenOptions.initialPath = options.initialPopupPath;
        authClient.token.getWithPopup(getTokenOptions).then(success).catch(error);
    }
};



const $ec545c48aa9cf055$export$2e2bcd8739ae039 = {};
const $ec545c48aa9cf055$var$verifyUrlTpl = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "signin/verify/" + alias4((helper = (helper = lookupProperty(helpers, "provider") || (depth0 != null ? lookupProperty(depth0, "provider") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "provider",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 14
                },
                "end": {
                    "line": 1,
                    "column": 26
                }
            }
        }) : helper)) + "/" + alias4((helper = (helper = lookupProperty(helpers, "factorType") || (depth0 != null ? lookupProperty(depth0, "factorType") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "factorType",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 27
                },
                "end": {
                    "line": 1,
                    "column": 41
                }
            }
        }) : helper));
    },
    "useData": true
});
const $ec545c48aa9cf055$var$verifyUrlMultipleTpl = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "signin/verify/" + alias4((helper = (helper = lookupProperty(helpers, "provider") || (depth0 != null ? lookupProperty(depth0, "provider") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "provider",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 14
                },
                "end": {
                    "line": 1,
                    "column": 26
                }
            }
        }) : helper)) + "/" + alias4((helper = (helper = lookupProperty(helpers, "factorType") || (depth0 != null ? lookupProperty(depth0, "factorType") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "factorType",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 27
                },
                "end": {
                    "line": 1,
                    "column": 41
                }
            }
        }) : helper)) + "/" + alias4((helper = (helper = lookupProperty(helpers, "factorIndex") || (depth0 != null ? lookupProperty(depth0, "factorIndex") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "factorIndex",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 42
                },
                "end": {
                    "line": 1,
                    "column": 57
                }
            }
        }) : helper));
    },
    "useData": true
});
const $ec545c48aa9cf055$var$verifyUrlNoProviderTpl = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "signin/verify/" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "factorType") || (depth0 != null ? lookupProperty(depth0, "factorType") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "factorType",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 14
                },
                "end": {
                    "line": 1,
                    "column": 28
                }
            }
        }) : helper));
    },
    "useData": true
});
const $ec545c48aa9cf055$var$enrollFactorUrlTpl = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "signin/enroll/" + alias4((helper = (helper = lookupProperty(helpers, "provider") || (depth0 != null ? lookupProperty(depth0, "provider") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "provider",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 14
                },
                "end": {
                    "line": 1,
                    "column": 26
                }
            }
        }) : helper)) + "/" + alias4((helper = (helper = lookupProperty(helpers, "factorType") || (depth0 != null ? lookupProperty(depth0, "factorType") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "factorType",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 27
                },
                "end": {
                    "line": 1,
                    "column": 41
                }
            }
        }) : helper));
    },
    "useData": true
});
const $ec545c48aa9cf055$var$activateFactorUrlTpl = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "0": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "/" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "step") || (depth0 != null ? lookupProperty(depth0, "step") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "step",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 63
                },
                "end": {
                    "line": 1,
                    "column": 71
                }
            }
        }) : helper));
    },
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "signin/enroll-activate/" + alias4((helper = (helper = lookupProperty(helpers, "provider") || (depth0 != null ? lookupProperty(depth0, "provider") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "provider",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 23
                },
                "end": {
                    "line": 1,
                    "column": 35
                }
            }
        }) : helper)) + "/" + alias4((helper = (helper = lookupProperty(helpers, "factorType") || (depth0 != null ? lookupProperty(depth0, "factorType") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "factorType",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 36
                },
                "end": {
                    "line": 1,
                    "column": 50
                }
            }
        }) : helper)) + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "step") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(0, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 50
                },
                "end": {
                    "line": 1,
                    "column": 78
                }
            }
        })) != null ? stack1 : "");
    },
    "useData": true
});
const $ec545c48aa9cf055$var$recoveryUrlTpl = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "signin/recovery/" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "recoveryToken") || (depth0 != null ? lookupProperty(depth0, "recoveryToken") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "recoveryToken",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 16
                },
                "end": {
                    "line": 1,
                    "column": 33
                }
            }
        }) : helper));
    },
    "useData": true
});
const $ec545c48aa9cf055$var$refreshUrlTpl = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "0": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "/" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "token") || (depth0 != null ? lookupProperty(depth0, "token") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "token",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 39
                },
                "end": {
                    "line": 1,
                    "column": 48
                }
            }
        }) : helper));
    },
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "signin/refresh-auth-state" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "token") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(0, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 25
                },
                "end": {
                    "line": 1,
                    "column": 55
                }
            }
        })) != null ? stack1 : "");
    },
    "useData": true
});
const $ec545c48aa9cf055$var$signinWithUsernameUrlTpl = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "signin/okta/" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "username") || (depth0 != null ? lookupProperty(depth0, "username") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "username",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 12
                },
                "end": {
                    "line": 1,
                    "column": 24
                }
            }
        }) : helper));
    },
    "useData": true
});
const $ec545c48aa9cf055$var$sessionCookieRedirectTpl = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return container.escapeExpression((helper = (helper = lookupProperty(helpers, "baseUrl") || (depth0 != null ? lookupProperty(depth0, "baseUrl") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "baseUrl",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 0
                },
                "end": {
                    "line": 1,
                    "column": 11
                }
            }
        }) : helper)) + "/login/sessionCookieRedirect?checkAccountSetupComplete=true&token=" + ((stack1 = (helper = (helper = lookupProperty(helpers, "token") || (depth0 != null ? lookupProperty(depth0, "token") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "token",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 77
                },
                "end": {
                    "line": 1,
                    "column": 88
                }
            }
        }) : helper)) != null ? stack1 : "") + "&redirectUrl=" + ((stack1 = (helper = (helper = lookupProperty(helpers, "redirectUrl") || (depth0 != null ? lookupProperty(depth0, "redirectUrl") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
            "name": "redirectUrl",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 101
                },
                "end": {
                    "line": 1,
                    "column": 118
                }
            }
        }) : helper)) != null ? stack1 : "");
    },
    "useData": true
});
const $ec545c48aa9cf055$var$deviceActivationStatuses = [
    'DEVICE_ACTIVATED',
    'DEVICE_NOT_ACTIVATED_CONSENT_DENIED',
    'DEVICE_NOT_ACTIVATED'
];
$ec545c48aa9cf055$export$2e2bcd8739ae039.isHostBackgroundChromeTab = function() {
    // Checks if the SIW is loaded in a chrome webview and
    // it is in an app that is in background.
    if (navigator.userAgent.match(/Android/) && navigator.userAgent.match(/Chrome/) && document.hidden) return true;
    else return false;
};
$ec545c48aa9cf055$export$2e2bcd8739ae039.isDocumentVisible = function() {
    return document.visibilityState === 'visible';
};
$ec545c48aa9cf055$export$2e2bcd8739ae039.createVerifyUrl = function(provider, factorType, factorIndex) {
    if (provider && factorIndex) return $ec545c48aa9cf055$var$verifyUrlMultipleTpl({
        provider: encodeURIComponent(provider.toLowerCase()),
        factorType: encodeURIComponent(factorType),
        factorIndex: encodeURIComponent(factorIndex)
    });
    else if (provider) return $ec545c48aa9cf055$var$verifyUrlTpl({
        provider: encodeURIComponent(provider.toLowerCase()),
        factorType: encodeURIComponent(factorType)
    });
    else return $ec545c48aa9cf055$var$verifyUrlNoProviderTpl({
        factorType: encodeURIComponent(factorType)
    });
};
$ec545c48aa9cf055$export$2e2bcd8739ae039.createEnrollFactorUrl = function(provider, factorType) {
    return $ec545c48aa9cf055$var$enrollFactorUrlTpl({
        provider: encodeURIComponent(provider.toLowerCase()),
        factorType: encodeURIComponent(factorType)
    });
};
$ec545c48aa9cf055$export$2e2bcd8739ae039.createActivateFactorUrl = function(provider, factorType, step) {
    return $ec545c48aa9cf055$var$activateFactorUrlTpl({
        provider: encodeURIComponent(provider.toLowerCase()),
        factorType: encodeURIComponent(factorType),
        step: step ? encodeURIComponent(step) : false
    });
};
$ec545c48aa9cf055$export$2e2bcd8739ae039.createRecoveryUrl = function(recoveryToken) {
    return $ec545c48aa9cf055$var$recoveryUrlTpl({
        recoveryToken: encodeURIComponent(recoveryToken)
    });
};
$ec545c48aa9cf055$export$2e2bcd8739ae039.createRefreshUrl = function(stateToken) {
    const token = stateToken ? encodeURIComponent(stateToken) : null;
    return $ec545c48aa9cf055$var$refreshUrlTpl({
        token: token
    });
};
$ec545c48aa9cf055$export$2e2bcd8739ae039.createSigninUrl = function(username) {
    return username ? $ec545c48aa9cf055$var$signinWithUsernameUrlTpl({
        username: encodeURIComponent(username)
    }) : 'signin';
};
$ec545c48aa9cf055$export$2e2bcd8739ae039.routeAfterAuthStatusChangeError = function(router, err) {
    if (!err) return;
    // Global error handling for CORS enabled errors
    if (err.xhr && (0, $22893d6dea78fc87$export$2e2bcd8739ae039).corsIsNotEnabled(err.xhr)) {
        router.settings.callGlobalError(new (0, $3fe6932680e7ea64$export$58cbd1fe407fb242)((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('error.enabled.cors')));
        return;
    }
    // Token has expired - no longer valid. Navigate back to primary auth.
    if (err.errorCode === (0, $da289f4aadbacd56$export$2e2bcd8739ae039).INVALID_TOKEN_EXCEPTION) {
        router.appState.set('flashError', err);
        router.controller.state.set('navigateDir', (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).DIRECTION_BACK);
        if (router.settings.get('features.mfaOnlyFlow')) router.navigate('signin/error', {
            trigger: true
        });
        else router.navigate('', {
            trigger: true
        });
        return;
    }
    (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).triggerAfterError(router.controller, err);
};
$ec545c48aa9cf055$export$2e2bcd8739ae039.routeAfterAuthStatusChange = function(router, res) {
    // Other errors are handled by the function making the authClient request
    if (!res || !res.status) {
        router.appState.clearLastAuthResponse();
        return;
    }
    router.appState.setAuthResponse(res);
    if (router.controller && router.controller.trapAuthResponse(res)) return;
    $ec545c48aa9cf055$export$2e2bcd8739ae039.handleResponseStatus(router, res);
};
$ec545c48aa9cf055$export$2e2bcd8739ae039.handleResponseStatus = function(router, res) {
    switch(res.status){
        case 'SUCCESS':
            $ec545c48aa9cf055$var$handleSuccessResponseStatus(router, res);
            return;
        case 'ADMIN_CONSENT_REQUIRED':
            router.navigate('signin/admin-consent', {
                trigger: true
            });
            return;
        case 'CONSENT_REQUIRED':
            router.navigate('signin/consent', {
                trigger: true
            });
            return;
        case 'DEVICE_ACTIVATE':
            router.navigate('signin/device-activate', {
                trigger: true
            });
            return;
        // We want the same view for FACTOR_REQUIRED & FACTOR_CHALLENGE
        // In the new idx pipeline FACTOR_CHALLENGE API response does not contain a prev link
        case 'FACTOR_REQUIRED':
        case 'FACTOR_CHALLENGE':
        case 'MFA_REQUIRED':
            {
                const lastFailedChallengeFactorData = router.appState.get('lastFailedChallengeFactorData');
                // When the widget is bootstrapped with an error in MFA_CHALLENGE state, we pass the
                // lastFailedChallengeFactorData to MFA_REQUIRED, in order to show the error message
                // on the correct factor view
                if (lastFailedChallengeFactorData && lastFailedChallengeFactorData.factor) router.appState.get('factors').lastUsedFactor = lastFailedChallengeFactorData.factor;
                const factor = router.appState.get('factors').getDefaultFactor();
                const url = $ec545c48aa9cf055$export$2e2bcd8739ae039.createVerifyUrl(factor.get('provider'), factor.get('factorType'));
                router.navigate(url, {
                    trigger: true
                });
                router.appState.clearLastFailedChallengeFactorData();
                return;
            }
        case 'POLL':
            {
                const pollUrl = 'signin/poll';
                router.navigate(pollUrl, {
                    trigger: true
                });
                return;
            }
        case 'MFA_CHALLENGE':
            // Since we normally trap MFA_CHALLENGE, this will only get called on a
            // page refresh or when an error is returned on verification with an IdP.
            // We need to return to MFA_REQUIRED to initialize the
            // page correctly (i.e. factors dropdown, etc)
            if (router.appState.get('isFactorResultFailed')) router.appState.setLastFailedChallengeFactorData();
            router.appState.get('transaction').prev().then(function(trans) {
                router.appState.set('transaction', trans);
            });
            // TODO: catch/handle error here?
            return;
        case 'MFA_ENROLL':
        case 'FACTOR_ENROLL':
            router.navigate('signin/enroll', {
                trigger: true
            });
            return;
        case 'MFA_ENROLL_ACTIVATE':
        case 'FACTOR_ENROLL_ACTIVATE':
            {
                const activateUrl = $ec545c48aa9cf055$export$2e2bcd8739ae039.createActivateFactorUrl(router.appState.get('activatedFactorProvider'), router.appState.get('activatedFactorType'));
                router.navigate(activateUrl, {
                    trigger: true
                });
                return;
            }
        case 'PASSWORD_WARN':
        case 'PASSWORD_EXPIRED':
            if (router.settings.get('features.customExpiredPassword') && !router.appState.get('isPwdManagedByOkta')) router.navigate('signin/custom-password-expired', {
                trigger: true
            });
            else router.navigate('signin/password-expired', {
                trigger: true
            });
            return;
        case 'RECOVERY_CHALLENGE':
            {
                const fromEmail = res.factorType.toLowerCase() === (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).RECOVERY_FACTOR_TYPE_EMAIL.toLowerCase();
                const isForgotPassword = res.recoveryType === (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).RECOVERY_TYPE_PASSWORD;
                const isUnlock = res.recoveryType === (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).RECOVERY_TYPE_UNLOCK;
                // Will use this workaround (lowercasing response) until OKTA-69083 is resolved
                if (isForgotPassword && fromEmail) router.navigate('signin/recovery-emailed', {
                    trigger: true
                });
                else if (isUnlock && fromEmail) router.navigate('signin/unlock-emailed', {
                    trigger: true
                });
                else router.navigate('signin/recovery-challenge', {
                    trigger: true
                });
                return;
            }
        case 'RECOVERY':
            router.navigate('signin/recovery-question', {
                trigger: true
            });
            return;
        case 'PASSWORD_RESET':
            router.navigate('signin/password-reset', {
                trigger: true
            });
            return;
        case 'LOCKED_OUT':
            if (router.settings.get('features.selfServiceUnlock')) router.navigate('signin/unlock', {
                trigger: true
            });
            else {
                const errorMessage = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('error.auth.lockedOut', 'login');
                const resError = {
                    responseJSON: {
                        errorCauses: [],
                        errorSummary: errorMessage,
                        errorCode: 'E0000119'
                    }
                };
                const err = {
                    name: 'AuthApiError',
                    message: errorMessage,
                    xhr: resError
                };
                router.controller.model.appState.trigger('removeLoading');
                router.controller.model.trigger('error', router.controller.model, resError);
                (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).triggerAfterError(router.controller, err);
            }
            return;
        case 'PROFILE_REQUIRED':
            router.navigate('signin/enroll-user', {
                trigger: true
            });
            return;
        case 'UNAUTHENTICATED':
            // Either we have factors and we are in passwordlessAuth mode
            if (router.appState.get('promptForFactorInUnauthenticated')) {
                const defaultFactor = router.appState.get('factors').getDefaultFactor();
                const factorURL = $ec545c48aa9cf055$export$2e2bcd8739ae039.createVerifyUrl(defaultFactor.get('provider'), defaultFactor.get('factorType'));
                router.navigate(factorURL, {
                    trigger: true
                });
                return;
            }
            // Or we're in device flow and we need to force idp discovery check
            if (router.appState.get('usingDeviceFlow')) {
                router.navigate('signin/idp-discovery-check', {
                    trigger: true
                });
                return;
            }
            // Or we don't have anything and we need to show the login page
            router.navigate('', {
                trigger: true
            });
            return;
        default:
            throw new Error('Unknown status: ' + res.status);
    }
};
function $ec545c48aa9cf055$var$handleSuccessResponseStatus(router, res) {
    var _res$_embedded, _res$_links, _res$_links$original, _res$_links2, _res$_links2$next;
    if (res.recoveryType === (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).RECOVERY_TYPE_UNLOCK) {
        router.navigate('signin/account-unlocked', {
            trigger: true
        });
        return;
    }
    if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains($ec545c48aa9cf055$var$deviceActivationStatuses, (_res$_embedded = res._embedded) === null || _res$_embedded === void 0 ? void 0 : _res$_embedded.deviceActivationStatus)) {
        router.navigate('signin/device-activate-complete', {
            trigger: true
        });
        return;
    }
    // If the desired end result object needs to have idToken (and not sessionToken),
    // get the id token from session token before calling the global success function.
    if (router.settings.get('oauth2Enabled')) {
        (0, $5eccc61229d1b47f$export$2e2bcd8739ae039).getTokens(router.settings, {
            sessionToken: res.sessionToken
        }, router.controller);
        return;
    }
    const successData = {
        user: res._embedded.user,
        type: res.type || (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).SESSION_SSO
    };
    if (res.relayState) successData.relayState = res.relayState;
    const redirectFn = router.settings.get('redirectUtilFn');
    const nextUrl = (res === null || res === void 0 ? void 0 : (_res$_links = res._links) === null || _res$_links === void 0 ? void 0 : (_res$_links$original = _res$_links.original) === null || _res$_links$original === void 0 ? void 0 : _res$_links$original.href) || (res === null || res === void 0 ? void 0 : (_res$_links2 = res._links) === null || _res$_links2 === void 0 ? void 0 : (_res$_links2$next = _res$_links2.next) === null || _res$_links2$next === void 0 ? void 0 : _res$_links2$next.href);
    if (res.type === (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).SESSION_STEP_UP) {
        var _res$_links3, _res$_links3$next;
        const targetUrl = res === null || res === void 0 ? void 0 : (_res$_links3 = res._links) === null || _res$_links3 === void 0 ? void 0 : (_res$_links3$next = _res$_links3.next) === null || _res$_links3$next === void 0 ? void 0 : _res$_links3$next.href;
        successData.stepUp = {
            url: targetUrl,
            finish: function() {
                redirectFn(targetUrl);
            }
        };
    } else {
        if (nextUrl) successData.next = function() {
            redirectFn(nextUrl);
        };
        else // Add the type for now until the API returns it.
        successData.type = (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).SESSION_SSO;
        if (res.sessionToken) successData.session = {
            token: res.sessionToken,
            setCookieAndRedirect: function(redirectUri) {
                if (redirectUri) (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).debugMessage(`
              Passing a "redirectUri" to "setCookieAndRedirect" is strongly discouraged.
              It is recommended to set a "redirectUri" option in the config object passed to the widget constructor.
            `);
                redirectUri = redirectUri || router.settings.get('redirectUri');
                if (!redirectUri) throw new (0, $3fe6932680e7ea64$export$c5fb415882705cf4)('"redirectUri" is required');
                redirectFn($ec545c48aa9cf055$var$sessionCookieRedirectTpl({
                    baseUrl: router.settings.get('baseUrl'),
                    token: encodeURIComponent(res.sessionToken),
                    redirectUrl: encodeURIComponent(redirectUri)
                }));
            }
        };
    }
    // Check if we need to wait for redirect based on host.
    if ($ec545c48aa9cf055$export$2e2bcd8739ae039.isHostBackgroundChromeTab()) document.addEventListener('visibilitychange', function checkVisibilityAndCallSuccess() {
        if ($ec545c48aa9cf055$export$2e2bcd8739ae039.isDocumentVisible()) {
            document.removeEventListener('visibilitychange', checkVisibilityAndCallSuccess);
            router.settings.callGlobalSuccess((0, $e48c043f6d2d382d$export$2e2bcd8739ae039).SUCCESS, successData);
        }
    });
    else router.settings.callGlobalSuccess((0, $e48c043f6d2d382d$export$2e2bcd8739ae039).SUCCESS, successData);
}


var $72274cae7e50bf84$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'scan-instructions clearfix',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"scan-instructions-details-wrapper\"><div class=\"scan-instructions-details\"><p>" + alias4((helper = (helper = lookupProperty(helpers, "instructions") || (depth0 != null ? lookupProperty(depth0, "instructions") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "instructions",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 89
                    },
                    "end": {
                        "line": 1,
                        "column": 105
                    }
                }
            }) : helper)) + "</p></div></div><div class=\"scan-instructions-qrcode-wrapper\"><div class=\"qrcode-wrap\"><img data-se=\"qrcode\" alt=\"" + alias4((helper = (helper = lookupProperty(helpers, "altQRCode") || (depth0 != null ? lookupProperty(depth0, "altQRCode") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "altQRCode",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 219
                    },
                    "end": {
                        "line": 1,
                        "column": 232
                    }
                }
            }) : helper)) + "\" class=\"qrcode-image\" src=\"" + alias4((helper = (helper = lookupProperty(helpers, "qrcode") || (depth0 != null ? lookupProperty(depth0, "qrcode") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "qrcode",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 260
                    },
                    "end": {
                        "line": 1,
                        "column": 270
                    }
                }
            }) : helper)) + "\"><div data-se=\"qrcode-success\" class=\"qrcode-success\"></div><div data-se=\"qrcode-error\" class=\"qrcode-error\"></div></div><a href=\"#\" data-type=\"manual-setup\" data-se=\"manual-setup\" class=\"link manual-setup\" aria-label=\"" + alias4((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.totp.aria.cannotScan"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 490
                    },
                    "end": {
                        "line": 1,
                        "column": 549
                    }
                }
            })) + "\">" + alias4((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.totp.cannotScan"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 551
                    },
                    "end": {
                        "line": 1,
                        "column": 604
                    }
                }
            })) + "</a><a href=\"#\" data-type=\"refresh-qrcode\" data-se=\"refresh-qrcode\" class=\"link refresh-qrcode\">" + alias4((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.totp.refreshBarcode"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 700
                    },
                    "end": {
                        "line": 1,
                        "column": 757
                    }
                }
            })) + "</a></div>";
        },
        "useData": true
    }),
    events: {
        'click [data-type="manual-setup"]': function(e) {
            e.preventDefault();
            const url = (0, $ec545c48aa9cf055$export$2e2bcd8739ae039).createActivateFactorUrl(this.model.get('__provider__'), this.model.get('__factorType__'), 'manual');
            if (this.model.get('__factorType__') === 'push') // cancel the poll and navigate to manual setup.
            this.model.doTransaction(function(transaction) {
                return transaction.prev().then(function(trans) {
                    const factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(trans.factors, {
                        factorType: 'push',
                        provider: 'OKTA'
                    });
                    return factor.enroll();
                });
            }).then(()=>{
                this.options.appState.trigger('navigate', url);
            });
            else this.options.appState.trigger('navigate', url);
        },
        'click [data-type="refresh-qrcode"]': function(e) {
            e.preventDefault();
            this.model.trigger('errors:clear');
            const self = this;
            this.model.doTransaction(function(transaction) {
                if (this.appState.get('isWaitingForActivation')) return transaction.poll();
                else return transaction.activate();
            }).then(function(trans) {
                const res = trans.data;
                if ((res.status === 'MFA_ENROLL_ACTIVATE' || res.status === 'FACTOR_ENROLL_ACTIVATE') && res.factorResult === 'WAITING') // defer the render here to have a lastResponse set in AppState
                // so that we get new QRcode rendered
                (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defer((0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(self.render, self));
            });
        }
    },
    initialize: function() {
        this.listenTo(this.options.appState, 'change:lastAuthResponse', function() {
            if (this.options.appState.get('isMfaEnrollActivate')) this.$el.toggleClass('qrcode-expired', !this.options.appState.get('isWaitingForActivation'));
            else if (this.options.appState.get('isSuccessResponse')) this.$el.addClass('qrcode-success');
        });
        this.listenTo(this.model, 'error', function() {
            if (this.options.appState.get('isMfaEnrollActivate')) this.$el.toggleClass('qrcode-expired', true);
        });
    },
    getTemplateData: function() {
        const factorName = (0, $020a58caf88b7504$export$2e2bcd8739ae039).getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
        let instructions;
        if (this.model.get('__provider__') === 'GOOGLE') instructions = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.totp.setupGoogleAuthApp', 'login', [
            factorName
        ]);
        else instructions = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.totp.setupApp', 'login', [
            factorName
        ]);
        return {
            instructions: instructions,
            qrcode: this.options.appState.get('qrcode'),
            altQRCode: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.altQrCode', 'login')
        };
    }
});



/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $349095b9a5a2623c$var$PUSH_INTERVAL = 6000;
// Note: Keep-alive is set to 5 seconds - using 5 seconds here will result
// in network connection lost errors in Safari and IE.
var $349095b9a5a2623c$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'barcode-push',
    Model: function() {
        return {
            local: {
                __factorType__: [
                    'string',
                    false,
                    this.options.factorType
                ],
                __provider__: [
                    'string',
                    false,
                    this.options.provider
                ]
            }
        };
    },
    Form: {
        title: function() {
            const factorName = (0, $020a58caf88b7504$export$2e2bcd8739ae039).getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
            return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.totp.title', 'login', [
                factorName
            ]);
        },
        noButtonBar: true,
        attributes: {
            'data-se': 'step-scan'
        },
        className: 'barcode-scan',
        initialize: function() {
            this.listenTo(this.model, 'error errors:clear', function() {
                this.clearErrors();
            });
        },
        formChildren: [
            (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                View: (0, $72274cae7e50bf84$export$2e2bcd8739ae039)
            })
        ]
    },
    Footer: (0, $84975a54a18f1ea8$export$2e2bcd8739ae039),
    initialize: function() {
        this.pollForEnrollment().catch(()=>{
        // Ignoring the errors for now. 
        // clean up will be done based on OKTA-324849
        });
    },
    pollForEnrollment: function() {
        return this.model.doTransaction(function(transaction) {
            return transaction.poll($349095b9a5a2623c$var$PUSH_INTERVAL);
        });
    },
    trapAuthResponse: function() {
        if (this.options.appState.get('isMfaEnrollActivate')) return true;
    }
});


















/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $133fc2818bcbfed0$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'barcode-totp',
    Model: function() {
        return {
            local: {
                __factorType__: [
                    'string',
                    false,
                    this.options.factorType
                ],
                __provider__: [
                    'string',
                    false,
                    this.options.provider
                ]
            }
        };
    },
    Form: {
        title: function() {
            const factorName = (0, $020a58caf88b7504$export$2e2bcd8739ae039).getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
            return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.totp.title', 'login', [
                factorName
            ]);
        },
        save: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'oform.next', 'login'),
        noCancelButton: true,
        attributes: {
            'data-se': 'step-scan'
        },
        className: 'barcode-scan',
        formChildren: [
            (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                View: (0, $72274cae7e50bf84$export$2e2bcd8739ae039)
            })
        ]
    },
    Footer: (0, $84975a54a18f1ea8$export$2e2bcd8739ae039),
    initialize: function() {
        this.listenTo(this.form, 'save', function() {
            const url = (0, $ec545c48aa9cf055$export$2e2bcd8739ae039).createActivateFactorUrl(this.model.get('__provider__'), this.model.get('__factorType__'), 'activate');
            this.options.appState.trigger('navigate', url);
        });
    }
});




































var $23041bf10a81b2a7$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'scope-item',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            return "<span class=\"scope-item-tooltip icon form-help-16\"></span>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"" + alias4((helper = (helper = lookupProperty(helpers, "classNames") || (depth0 != null ? lookupProperty(depth0, "classNames") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "classNames",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 12
                    },
                    "end": {
                        "line": 1,
                        "column": 26
                    }
                }
            }) : helper)) + "\"><p>" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "name",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 31
                    },
                    "end": {
                        "line": 1,
                        "column": 39
                    }
                }
            }) : helper)) + "</p></div>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 49
                    },
                    "end": {
                        "line": 1,
                        "column": 133
                    }
                }
            })) != null ? stack1 : "");
        },
        "useData": true
    }),
    getTemplateData: function() {
        const { name: name, description: description, isCustomized: isCustomized } = this.options;
        const baseClass = 'scope-item-text';
        const classNames = name === 'openid' || isCustomized ? `${baseClass} no-translate` : baseClass;
        return {
            classNames: classNames,
            name: name,
            description: description
        };
    },
    postRender: function() {
        this.$('.scope-item-tooltip').qtip({
            content: {
                text: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).escape(this.options.description)
            },
            style: {
                classes: 'okta-tooltip qtip-custom qtip-shadow'
            },
            position: {
                my: 'bottom right',
                target: 'mouse'
            }
        });
    }
});


/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $876c6f9715951231$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'scope-list detail-row',
    postRender: function() {
        this.model.get('scopes').forEach((scope)=>{
            this.add((0, $23041bf10a81b2a7$export$2e2bcd8739ae039), {
                options: {
                    name: scope.displayName || scope.name,
                    description: scope.description,
                    isCustomized: scope.isCustomized
                }
            });
        });
    }
});












const $f19dca526ef2cd68$var$CheckBox = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).views.forms.inputs.CheckBox;
var $f19dca526ef2cd68$export$2e2bcd8739ae039 = $f19dca526ef2cd68$var$CheckBox.extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<input type=\"checkbox\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "name",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 29
                    },
                    "end": {
                        "line": 1,
                        "column": 37
                    }
                }
            }) : helper)) + "\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "inputId",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 43
                    },
                    "end": {
                        "line": 1,
                        "column": 54
                    }
                }
            }) : helper)) + "\"/><label for=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "inputId",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 69
                    },
                    "end": {
                        "line": 1,
                        "column": 80
                    }
                }
            }) : helper)) + "\" data-se-for-name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "name",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 100
                    },
                    "end": {
                        "line": 1,
                        "column": 108
                    }
                }
            }) : helper)) + "\"><b>" + alias4((helper = (helper = lookupProperty(helpers, "placeholder") || (depth0 != null ? lookupProperty(depth0, "placeholder") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "placeholder",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 113
                    },
                    "end": {
                        "line": 1,
                        "column": 128
                    }
                }
            }) : helper)) + "</b><p>" + alias4((helper = (helper = lookupProperty(helpers, "desc") || (depth0 != null ? lookupProperty(depth0, "desc") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "desc",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 135
                    },
                    "end": {
                        "line": 1,
                        "column": 143
                    }
                }
            }) : helper)) + "</p></label>";
        },
        "useData": true
    }),
    /**
     * @Override
     */ enable: function() {
        if (this.options.options.optional) this.$(':input').prop('disabled', false);
    },
    /**
     * @Override
     */ editMode: function() {
        this.$el.html(this.template((0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend((0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(this.options, 'placeholder'), {
            placeholder: this.options.placeholder || this.options.name,
            desc: this.options.options.description
        })));
        this.$(':checkbox').prop('checked', this.getModelValue() || false);
        this.$('input').customInput();
        this.model.trigger('form:resize');
        if (!this.options.options.optional) {
            const input = this.$('input').get(0);
            this.$(input.parentElement).addClass('o-form-read-mode');
            this.$(':checkbox').prop('disabled', true);
        }
        if (this.options.name === 'openid' || this.options.options.isCustomized) {
            this.$('label > b').addClass('no-translate');
            if (this.options.options.isCustomized) this.$('label > p').addClass('no-translate');
        }
        return this;
    }
});













var $25d1130e5656d397$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    tagName: 'a',
    className: 'skip-to-content-link',
    attributes: {
        href: `#${(0, $e48c043f6d2d382d$export$2e2bcd8739ae039).WIDGET_CONTAINER_ID}`
    },
    initialize: function initialize() {
        this.$el.append((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('skip.to.main.content', 'login'));
    }
});



const $f2ae6428e6e53a68$var$granularConsentHeaderTemplate = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "0": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<a href=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "clientURI") || (depth0 != null ? lookupProperty(depth0, "clientURI") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "clientURI",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 26
                },
                "end": {
                    "line": 1,
                    "column": 39
                }
            }
        }) : helper)) + "\" class=\"client-logo-link\" target=\"_blank\">";
    },
    "1": function(container, depth0, helpers, partials, data) {
        var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<img class=\"client-logo custom-logo\" src=\"" + alias3((helper = (helper = lookupProperty(helpers, "customLogo") || (depth0 != null ? lookupProperty(depth0, "customLogo") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
            "name": "customLogo",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 149
                },
                "end": {
                    "line": 1,
                    "column": 163
                }
            }
        }) : helper)) + "\" alt=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
            "name": "i18n",
            "hash": {
                "bundle": "login",
                "code": "common.logo.alt"
            },
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 170
                },
                "end": {
                    "line": 1,
                    "column": 216
                }
            }
        })) + "\" aria-hidden=\"true\" />";
    },
    "2": function(container, depth0, helpers, partials, data) {
        var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<img class=\"client-logo default-logo\" src=\"" + alias3((helper = (helper = lookupProperty(helpers, "defaultLogo") || (depth0 != null ? lookupProperty(depth0, "defaultLogo") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
            "name": "defaultLogo",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 290
                },
                "end": {
                    "line": 1,
                    "column": 305
                }
            }
        }) : helper)) + "\" alt=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
            "name": "i18n",
            "hash": {
                "bundle": "login",
                "code": "common.logo.alt"
            },
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 312
                },
                "end": {
                    "line": 1,
                    "column": 358
                }
            }
        })) + "\" aria-hidden=\"true\" />";
    },
    "3": function(container, depth0, helpers, partials, data) {
        return "</a>";
    },
    "4": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<div class=\"issuer\"><span>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "issuer") || (depth0 != null ? lookupProperty(depth0, "issuer") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "issuer",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 624
                },
                "end": {
                    "line": 1,
                    "column": 634
                }
            }
        }) : helper)) + "</span></div>";
    },
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "clientURI") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(0, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 0
                },
                "end": {
                    "line": 1,
                    "column": 89
                }
            }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "customLogo") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(1, data, 0),
            "inverse": container.program(2, data, 0),
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 89
                },
                "end": {
                    "line": 1,
                    "column": 388
                }
            }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "clientURI") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(3, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 388
                },
                "end": {
                    "line": 1,
                    "column": 416
                }
            }
        })) != null ? stack1 : "") + "<h1><span class=\"title-text\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
            "name": "i18n",
            "hash": {
                "$2": "<p>$2</p>",
                "$1": "<b class='no-translate'>$1</b>",
                "arguments": "appName",
                "bundle": "login",
                "code": "granular.consent.scopes.title"
            },
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 445
                },
                "end": {
                    "line": 1,
                    "column": 577
                }
            }
        })) + "</span>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "issuer") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(4, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 584
                },
                "end": {
                    "line": 1,
                    "column": 654
                }
            }
        })) != null ? stack1 : "") + "</h1>";
    },
    "useData": true
});
const $f2ae6428e6e53a68$var$getConsentHeader = (template)=>(0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
        View: (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
            className: 'consent-title detail-row',
            template: template,
            getTemplateData: function() {
                const appState = this.options.appState;
                return {
                    appName: appState.escape('targetLabel'),
                    customLogo: appState.get('targetLogo') && appState.get('targetLogo').href,
                    defaultLogo: appState.get('defaultAppLogo'),
                    clientURI: appState.get('targetClientURI') && appState.get('targetClientURI').href
                };
            }
        })
    });
const $f2ae6428e6e53a68$var$consentRequiredDescription = (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
    View: (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
        className: 'consent-description detail-row',
        template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
            "compiler": [
                8,
                ">= 4.3.0"
            ],
            "main": function(container, depth0, helpers, partials, data) {
                var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                    return undefined;
                };
                return "<p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                    "name": "i18n",
                    "hash": {
                        "bundle": "login",
                        "code": "consent.required.description"
                    },
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 3
                        },
                        "end": {
                            "line": 1,
                            "column": 62
                        }
                    }
                })) + "</p>";
            },
            "useData": true
        })
    })
});
const $f2ae6428e6e53a68$var$granularConsentDescription = (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
    View: (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
        className: 'consent-description',
        template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
            "compiler": [
                8,
                ">= 4.3.0"
            ],
            "main": function(container, depth0, helpers, partials, data) {
                var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                    return undefined;
                };
                return "<p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                    "name": "i18n",
                    "hash": {
                        "bundle": "login",
                        "code": "granular.consent.scopes.description"
                    },
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 3
                        },
                        "end": {
                            "line": 1,
                            "column": 69
                        }
                    }
                })) + "</p>";
            },
            "useData": true
        })
    })
});
const $f2ae6428e6e53a68$var$getScopeCheckBoxes = (scopes)=>{
    const sortedScopes = scopes.slice().sort((scope1, scope2)=>scope2.optional - scope1.optional);
    return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).map(sortedScopes, ({ name: name, displayName: displayName, description: description, optional: optional, isCustomized: isCustomized })=>(0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
            name: name,
            input: (0, $f19dca526ef2cd68$export$2e2bcd8739ae039),
            placeholder: displayName,
            label: false,
            modelType: 'boolean',
            required: true,
            options: {
                description: description,
                optional: optional,
                isCustomized: isCustomized
            }
        }));
};
const $f2ae6428e6e53a68$var$isGranularConsent = (appState)=>{
    return 'optional' in appState.get('scopes')[0];
};
var $f2ae6428e6e53a68$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'consent-required',
    initialize: function() {
        this.model.set('expiresAt', this.options.appState.get('expiresAt'));
        this.model.set('scopes', this.options.appState.get('scopes'));
        this.listenTo(this.form, 'cancel', (0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(this.model.cancel, this.model));
        // add Skip to main content link
        const skipLink = new (0, $25d1130e5656d397$export$2e2bcd8739ae039)();
        (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(`#${(0, $e48c043f6d2d382d$export$2e2bcd8739ae039).WIDGET_LOGIN_CONTAINER_ID}`).prepend(skipLink.render().$el);
        if ($f2ae6428e6e53a68$var$isGranularConsent(this.options.appState)) {
            this.$el.addClass('granular-consent').removeClass('consent-required');
            this.form.cancel = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'oform.cancel', 'login');
            (0, $3e490973b7383cc4$export$2e2bcd8739ae039).forEach(this.options.appState.get('scopes'), (scope)=>{
                this.model.set(scope.name, true);
            });
        }
    },
    postRender: function() {
        (0, $735c6d0521558dcb$export$2e2bcd8739ae039).prototype.postRender.apply(this, arguments);
        // Update the "don't allow" and "allow access" buttons to be neutral by changing "allow button" to be gray.
        this.$('.o-form-button-bar .button-primary').removeClass('button-primary');
    },
    Model: {
        props: {
            expiresAt: [
                'string',
                true
            ],
            scopes: [
                'array',
                true
            ]
        },
        save: function() {
            return this.doTransaction(function(transaction) {
                let scopeNames = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).pluck(this.get('scopes'), 'name');
                let consent = {
                    expiresAt: this.get('expiresAt')
                };
                if ($f2ae6428e6e53a68$var$isGranularConsent(this)) consent['optedScopes'] = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).reduce(scopeNames, (optedScopes, scope)=>{
                    optedScopes[scope] = this.get(scope);
                    return optedScopes;
                }, {});
                else consent['scopes'] = scopeNames;
                return transaction.consent({
                    consent: consent
                });
            });
        },
        cancel: function() {
            const self = this;
            return this.doTransaction(function(transaction) {
                return transaction.cancel();
            }).then(function() {
                const consentCancelFn = self.settings.get('consent.cancel');
                if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(consentCancelFn)) consentCancelFn();
            });
        }
    },
    Form: {
        noCancelButton: false,
        buttonOrder: [
            'cancel',
            'save'
        ],
        autoSave: true,
        save: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'consent.required.consentButton', 'login'),
        cancel: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'consent.required.cancelButton', 'login'),
        formChildren: function() {
            if ($f2ae6428e6e53a68$var$isGranularConsent(this.options.appState)) return [
                $f2ae6428e6e53a68$var$getConsentHeader($f2ae6428e6e53a68$var$granularConsentHeaderTemplate),
                $f2ae6428e6e53a68$var$granularConsentDescription
            ].concat($f2ae6428e6e53a68$var$getScopeCheckBoxes(this.options.appState.get('scopes')));
            else return [
                $f2ae6428e6e53a68$var$getConsentHeader((0, $62892d1a6641656b$export$2e2bcd8739ae039)),
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                    View: new (0, $876c6f9715951231$export$2e2bcd8739ae039)({
                        model: this.model
                    })
                }),
                $f2ae6428e6e53a68$var$consentRequiredDescription
            ];
        }
    },
    Footer: (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
        className: 'consent-footer',
        template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
            "0": function(container, depth0, helpers, partials, data) {
                var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                    return undefined;
                };
                return "<a class=\"terms-of-service\" href=\"" + alias3((helper = (helper = lookupProperty(helpers, "termsOfService") || (depth0 != null ? lookupProperty(depth0, "termsOfService") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
                    "name": "termsOfService",
                    "hash": {},
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 56
                        },
                        "end": {
                            "line": 1,
                            "column": 74
                        }
                    }
                }) : helper)) + "\" target=\"_blank\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                    "name": "i18n",
                    "hash": {
                        "bundle": "login",
                        "code": "consent.required.termsOfService"
                    },
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 92
                        },
                        "end": {
                            "line": 1,
                            "column": 154
                        }
                    }
                })) + "</a>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "privacyPolicy") : depth0, {
                    "name": "if",
                    "hash": {},
                    "fn": container.program(1, data, 0),
                    "inverse": container.noop,
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 158
                        },
                        "end": {
                            "line": 1,
                            "column": 194
                        }
                    }
                })) != null ? stack1 : "");
            },
            "1": function(container, depth0, helpers, partials, data) {
                return " &#8226 ";
            },
            "2": function(container, depth0, helpers, partials, data) {
                var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                    return undefined;
                };
                return "<a class=\"privacy-policy\" href=\"" + alias3((helper = (helper = lookupProperty(helpers, "privacyPolicy") || (depth0 != null ? lookupProperty(depth0, "privacyPolicy") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
                    "name": "privacyPolicy",
                    "hash": {},
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 254
                        },
                        "end": {
                            "line": 1,
                            "column": 271
                        }
                    }
                }) : helper)) + "\" target=\"_blank\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                    "name": "i18n",
                    "hash": {
                        "bundle": "login",
                        "code": "consent.required.privacyPolicy"
                    },
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 289
                        },
                        "end": {
                            "line": 1,
                            "column": 350
                        }
                    }
                })) + "</a>";
            },
            "compiler": [
                8,
                ">= 4.3.0"
            ],
            "main": function(container, depth0, helpers, partials, data) {
                var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                    return undefined;
                };
                return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "termsOfService") : depth0, {
                    "name": "if",
                    "hash": {},
                    "fn": container.program(0, data, 0),
                    "inverse": container.noop,
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 0
                        },
                        "end": {
                            "line": 1,
                            "column": 201
                        }
                    }
                })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "privacyPolicy") : depth0, {
                    "name": "if",
                    "hash": {},
                    "fn": container.program(2, data, 0),
                    "inverse": container.noop,
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 201
                        },
                        "end": {
                            "line": 1,
                            "column": 361
                        }
                    }
                })) != null ? stack1 : "");
            },
            "useData": true
        }),
        getTemplateData: function() {
            const appState = this.options.appState;
            return {
                termsOfService: appState.get('targetTermsOfService') && appState.get('targetTermsOfService').href,
                privacyPolicy: appState.get('targetPrivacyPolicy') && appState.get('targetPrivacyPolicy').href
            };
        }
    })
});

























const { Util: $a5591884dc309b8c$var$Util } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).util;
var $a5591884dc309b8c$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a href=\"#\" class=\"link help js-skip\" data-se=\"skip-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "password.expiring.later"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 78
                    },
                    "end": {
                        "line": 1,
                        "column": 132
                    }
                }
            })) + "</a>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "passwordWarn") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 143
                    }
                }
            })) != null ? stack1 : "") + "<a href=\"#\" class=\"link help goto js-signout\" data-se=\"signout-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "signout"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 212
                    },
                    "end": {
                        "line": 1,
                        "column": 250
                    }
                }
            })) + "</a>";
        },
        "useData": true
    }),
    className: 'auth-footer clearfix',
    events: {
        'click .js-signout': function(e) {
            e.preventDefault();
            const self = this;
            const authClient = self.settings.getAuthClient();
            this.model.doTransaction(function(transaction) {
                return transaction.cancel();
            }).then(function() {
                return authClient.session.exists();
            }).then(function(sessionExists) {
                if (sessionExists) return authClient.closeSession().catch(()=>{});
            }).then(function() {
                if (self.settings.get('backToSignInUri')) $a5591884dc309b8c$var$Util.redirect(self.settings.get('backToSignInUri'));
                else {
                    self.state.set('navigateDir', (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).DIRECTION_BACK);
                    self.options.appState.trigger('navigate', '');
                }
            });
        },
        'click .js-skip': function(e) {
            e.preventDefault();
            this.model.doTransaction(function(transaction) {
                return transaction.skip();
            });
        }
    },
    getTemplateData: function() {
        return {
            passwordWarn: this.options.appState.get('isPwdExpiringSoon')
        };
    }
});


/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const { Util: $a07f1e1028c3cedb$var$Util } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).util;
var $a07f1e1028c3cedb$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'custom-password-expired',
    Model: {},
    Form: {
        noButtonBar: true,
        title: function() {
            const expiringSoon = this.options.appState.get('isPwdExpiringSoon');
            const numDays = this.options.appState.get('passwordExpireDays');
            if (expiringSoon && numDays > 0) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expiring.title', 'login', [
                numDays
            ]);
            else if (expiringSoon && numDays === 0) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expiring.today', 'login');
            else if (expiringSoon) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expiring.soon', 'login');
            else return this.settings.get('brandName') ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expired.title.specific', 'login', [
                this.settings.get('brandName')
            ]) : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expired.title.generic', 'login');
        },
        subtitle: function() {
            if (this.options.appState.get('isPwdExpiringSoon')) return this.settings.get('brandName') ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expiring.soon.subtitle.specific', 'login', [
                this.settings.get('brandName')
            ]) : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expiring.soon.subtitle.generic', 'login');
            return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expired.custom.subtitle', 'login');
        },
        formChildren: function() {
            return [
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Button({
                    title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'password.expired.custom.submit', 'login', [
                        this.options.appState.get('passwordExpiredWebsiteName')
                    ]),
                    className: 'button button-primary button-wide',
                    attributes: {
                        'data-se': 'custom-button'
                    },
                    click: function() {
                        $a07f1e1028c3cedb$var$Util.redirect(this.options.appState.get('passwordExpiredLinkUrl'));
                    }
                })
            ];
        }
    },
    Footer: (0, $a5591884dc309b8c$export$2e2bcd8739ae039)
});















const $56c1d17b1df40c00$var$InvalidUserCodeErrorView = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"okta-form-infobox-error infobox infobox-error\" role=\"alert\"><span class=\"icon error-16\"></span><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "api.authn.error.PASSCODE_INVALID"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 110
                    },
                    "end": {
                        "line": 1,
                        "column": 173
                    }
                }
            })) + "</p></div>";
        },
        "useData": true
    })
});
var $56c1d17b1df40c00$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'device-code-activate',
    Model: function() {
        var _this$options, _this$options$appStat;
        return {
            props: {
                userCode: [
                    'string',
                    true,
                    (_this$options = this.options) === null || _this$options === void 0 ? void 0 : (_this$options$appStat = _this$options.appState) === null || _this$options$appStat === void 0 ? void 0 : _this$options$appStat.get('userCode')
                ],
                stateToken: 'string'
            },
            save: function() {
                const self = this;
                return this.doTransaction(function(transaction) {
                    return transaction.deviceActivate({
                        userCode: self.get('userCode')
                    });
                });
            }
        };
    },
    Form: {
        noCancelButton: true,
        autoSave: true,
        save: function() {
            return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oform.next', 'login');
        },
        title: function() {
            return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('device.code.activate.title', 'login');
        },
        subtitle: function() {
            return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('device.code.activate.subtitle', 'login');
        },
        formChildren: function() {
            if (this.options.appState.get('deviceActivationStatus') === 'INVALID_USER_CODE') this.add($56c1d17b1df40c00$var$InvalidUserCodeErrorView, '.o-form-error-container');
            return [
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                    label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('device.code.activate.label', 'login'),
                    'label-top': true,
                    name: 'userCode',
                    input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
                    inputId: 'user-code',
                    type: 'text',
                    inlineValidation: false
                })
            ];
        },
        events: {
            'keyup input[name="userCode"]': function(e) {
                e.preventDefault();
                this.addHyphen(e);
            }
        },
        addHyphen: function(evt) {
            const currentVal = evt.target.value;
            // add hyphen after 4th character
            if (currentVal && currentVal.length === 4 && ![
                'Backspace',
                'Delete',
                '-'
            ].includes(evt.key)) evt.target.value = currentVal.concat('-');
        }
    }
});














const $429c1e562a7720eb$var$DEVICE_ACTIVATED = 'DEVICE_ACTIVATED';
const $429c1e562a7720eb$var$DEVICE_NOT_ACTIVATED_CONSENT_DENIED = 'DEVICE_NOT_ACTIVATED_CONSENT_DENIED';
const $429c1e562a7720eb$var$DEVICE_NOT_ACTIVATED = 'DEVICE_NOT_ACTIVATED';
const $429c1e562a7720eb$var$DEVICE_CODE_ERROR_KEYS = [
    $429c1e562a7720eb$var$DEVICE_NOT_ACTIVATED_CONSENT_DENIED,
    $429c1e562a7720eb$var$DEVICE_NOT_ACTIVATED
];
var $429c1e562a7720eb$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'device-code-terminal',
    postRender: function() {
        (0, $735c6d0521558dcb$export$2e2bcd8739ae039).prototype.postRender.apply(this, arguments);
        // show device code terminal icons
        const iconClass = this.options.appState.get('deviceActivationStatus') === $429c1e562a7720eb$var$DEVICE_ACTIVATED ? 'success-24-green' : 'error-24-red';
        this.$('.o-form-head').before('<div class="device-code-terminal--icon-container"><span class="device-code-terminal--icon ' + iconClass + '"></span>' + '</div>');
    },
    Model: {},
    Form: {
        noCancelButton: true,
        noButtonBar: true,
        title: function() {
            const deviceActivationStatus = this.options.appState.get('deviceActivationStatus');
            if (deviceActivationStatus === $429c1e562a7720eb$var$DEVICE_ACTIVATED) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('device.code.activated.success.title', 'login');
            if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains($429c1e562a7720eb$var$DEVICE_CODE_ERROR_KEYS, deviceActivationStatus)) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('device.code.activated.error.title', 'login');
        },
        subtitle: function() {
            const deviceActivationStatus = this.options.appState.get('deviceActivationStatus');
            if (deviceActivationStatus === $429c1e562a7720eb$var$DEVICE_ACTIVATED) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('idx.device.activated', 'login');
            if (deviceActivationStatus === $429c1e562a7720eb$var$DEVICE_NOT_ACTIVATED_CONSENT_DENIED) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('idx.device.not.activated.consent.denied', 'login');
            if (deviceActivationStatus === $429c1e562a7720eb$var$DEVICE_NOT_ACTIVATED) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('idx.device.not.activated.internal.error', 'login');
        },
        formChildren: function() {
            return [
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                    View: (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                        template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                            "0": function(container, depth0, helpers, partials, data) {
                                var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                                    return undefined;
                                };
                                return "<a href=\"/activate\" class=\"button button-primary text-align-c retry-button\" data-se=\"try-again\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                                    "name": "i18n",
                                    "hash": {
                                        "bundle": "login",
                                        "code": "oie.try.again"
                                    },
                                    "data": data,
                                    "loc": {
                                        "start": {
                                            "line": 1,
                                            "column": 121
                                        },
                                        "end": {
                                            "line": 1,
                                            "column": 165
                                        }
                                    }
                                })) + "</a>";
                            },
                            "compiler": [
                                8,
                                ">= 4.3.0"
                            ],
                            "main": function(container, depth0, helpers, partials, data) {
                                var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                                    return undefined;
                                };
                                return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "isDeviceCodeError") : depth0, {
                                    "name": "if",
                                    "hash": {},
                                    "fn": container.program(0, data, 0),
                                    "inverse": container.noop,
                                    "data": data,
                                    "loc": {
                                        "start": {
                                            "line": 1,
                                            "column": 0
                                        },
                                        "end": {
                                            "line": 1,
                                            "column": 176
                                        }
                                    }
                                })) != null ? stack1 : "";
                            },
                            "useData": true
                        }),
                        getTemplateData: function() {
                            return {
                                isDeviceCodeError: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains($429c1e562a7720eb$var$DEVICE_CODE_ERROR_KEYS, this.options.appState.get('deviceActivationStatus'))
                            };
                        }
                    })
                })
            ];
        }
    }
});
























/*!
 * Copyright (c) 2018-2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const { Util: $b4f6437a72effa5a$var$Util } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).util;
var $b4f6437a72effa5a$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'enroll-custom-factor',
    Model: {
        local: {
            provider: 'string',
            factorType: 'string'
        },
        save: function() {
            return this.manageTransaction((transaction, setTransaction)=>{
                const factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(transaction.factors, {
                    provider: this.get('provider'),
                    factorType: this.get('factorType')
                });
                return factor.enroll().then((trans)=>{
                    setTransaction(trans);
                    const url = this.appState.get('enrollCustomFactorRedirectUrl');
                    if (url !== null) $b4f6437a72effa5a$var$Util.redirect(url);
                }).catch(function(err) {
                    throw err;
                });
            });
        }
    },
    Form: function() {
        const factors = this.options.appState.get('factors');
        const factor = factors.findWhere({
            provider: this.options.provider,
            factorType: this.options.factorType
        });
        const vendorName = factor.get('vendorName');
        const subtitle = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.customFactor.subtitle', 'login', [
            vendorName
        ]);
        const saveText = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.customFactor.save', 'login');
        return {
            autoSave: true,
            title: vendorName,
            subtitle: subtitle,
            save: saveText
        };
    },
    trapAuthResponse: function() {
        if (this.options.appState.get('isMfaEnrollActivate')) return true;
    },
    initialize: function() {
        this.model.set('provider', this.options.provider);
        this.model.set('factorType', this.options.factorType);
    },
    Footer: (0, $84975a54a18f1ea8$export$2e2bcd8739ae039)
});












/*!
 * Copyright (c) 2025, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ /**
 * Creates a "deferred" - a promise together with its resolve/reject functions
 * exposed externally. This replaces the deprecated `Q.defer()` for the cases
 * where the promise is settled from an outside callback (jQuery animations,
 * u2f callbacks, timeouts, etc.) and a `new Promise(executor)` wrapper would be
 * awkward.
 */ function $6d3dd6c38b8802c0$export$e673efccd97e4223() {
    let resolve;
    let reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}







/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $004803a44bfc2c0c$var$PUSH_INTERVAL = 4000;
// Avoid setting interval to same value as keep-alive time (5 seconds) because it
// caused an occasional issue with network connection lost errors in Safari and IE
const $004803a44bfc2c0c$var$FactorFactor = (0, $f24ef70ebb57d1e8$export$2e2bcd8739ae039).extend({
    extraProperties: true,
    flat: false,
    props: {
        id: 'string',
        factorType: {
            type: 'string',
            values: [
                'sms',
                'call',
                'email',
                'token',
                'token:software:totp',
                'token:hotp',
                'token:hardware',
                'question',
                'push',
                'u2f',
                'password',
                'assertion:saml2',
                'assertion:oidc',
                'claims_provider',
                'webauthn'
            ]
        },
        provider: {
            type: 'string',
            values: [
                'OKTA',
                'RSA',
                'DEL_OATH',
                'SYMANTEC',
                'GOOGLE',
                'YUBICO',
                'FIDO',
                'CUSTOM',
                'GENERIC_SAML',
                'GENERIC_OIDC'
            ]
        },
        enrollment: {
            type: 'string',
            values: [
                'OPTIONAL',
                'REQUIRED'
            ]
        },
        status: {
            type: 'string',
            values: [
                'NOT_SETUP',
                'ACTIVE'
            ]
        },
        profile: [
            'object'
        ],
        vendorName: 'string',
        policy: [
            'object'
        ],
        profiles: [
            'object'
        ]
    },
    local: {
        answer: 'string',
        password: 'string',
        backupFactor: 'object',
        showAnswer: 'boolean',
        rememberDevice: 'boolean',
        autoPush: [
            'boolean',
            true,
            false
        ]
    },
    derived: {
        isOktaFactor: {
            deps: [
                'provider'
            ],
            fn: function(provider) {
                return provider === 'OKTA';
            }
        },
        factorName: {
            deps: [
                'provider',
                'factorType'
            ],
            fn: (0, $020a58caf88b7504$export$2e2bcd8739ae039).getFactorName
        },
        factorLabel: {
            deps: [
                'provider',
                'factorType',
                'vendorName'
            ],
            fn: function(provider, factorType, vendorName) {
                if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains([
                    'DEL_OATH',
                    'GENERIC_SAML',
                    'GENERIC_OIDC',
                    'CUSTOM'
                ], provider)) return vendorName;
                return (0, $020a58caf88b7504$export$2e2bcd8739ae039).getFactorLabel.apply(this, [
                    provider,
                    factorType
                ]);
            }
        },
        factorDescription: {
            deps: [
                'provider',
                'factorType'
            ],
            fn: (0, $020a58caf88b7504$export$2e2bcd8739ae039).getFactorDescription
        },
        sortOrder: {
            deps: [
                'provider',
                'factorType'
            ],
            fn: (0, $020a58caf88b7504$export$2e2bcd8739ae039).getFactorSortOrder
        },
        iconClassName: {
            deps: [
                'provider',
                'factorType'
            ],
            fn: (0, $020a58caf88b7504$export$2e2bcd8739ae039).getFactorIconClassName
        },
        securityQuestion: {
            deps: [
                'profile',
                'factorType'
            ],
            fn: function(profile, factorType) {
                if (factorType !== 'question') return null;
                return profile && (0, $020a58caf88b7504$export$2e2bcd8739ae039).getSecurityQuestionLabel(profile);
            }
        },
        phoneNumber: {
            deps: [
                'profile',
                'factorType'
            ],
            fn: function(profile, factorType) {
                if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains([
                    'sms',
                    'call'
                ], factorType)) return profile && profile.phoneNumber;
                return null;
            }
        },
        email: {
            deps: [
                'profile',
                'factorType'
            ],
            fn: function(profile, factorType) {
                if (factorType === 'email') return profile && profile.email;
                return null;
            }
        },
        deviceName: {
            deps: [
                'profile',
                'factorType'
            ],
            fn: function(profile, factorType) {
                if (factorType !== 'push') return null;
                return profile && profile.name;
            }
        },
        enrolled: {
            deps: [
                'status'
            ],
            fn: function(status) {
                return status === 'ACTIVE';
            }
        },
        cardinality: {
            deps: [
                'policy',
                'profiles'
            ],
            fn: function(policy, profiles) {
                if (profiles && profiles.length > 0) {
                    const profile = profiles[0];
                    //assume for now we only get one profile (multiple profiles are not supported yet)
                    const enrolled = profile._embedded.enrolledFactors.length;
                    const adoption = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(profile._embedded.features, {
                        type: 'adoption'
                    });
                    if (adoption && adoption.cardinality) return {
                        enrolled: enrolled,
                        minimum: adoption.cardinality.min,
                        maximum: adoption.cardinality.max
                    };
                    return false;
                } else if (policy && policy.enrollment) return policy.enrollment;
                else return false;
            }
        },
        additionalEnrollment: {
            deps: [
                'cardinality'
            ],
            fn: function(cardinality) {
                if (cardinality) return cardinality.enrolled !== 0 && cardinality.enrolled < cardinality.maximum;
                else return false;
            }
        },
        required: {
            deps: [
                'enrollment'
            ],
            fn: function(enrollment) {
                return enrollment === 'REQUIRED';
            }
        },
        canUseResend: {
            deps: [
                'provider',
                'factorType'
            ],
            fn: function(provider, factorType) {
                // Only push, sms and call have resend links.
                return provider === 'OKTA' && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains([
                    'push',
                    'sms',
                    'call',
                    'email'
                ], factorType);
            }
        },
        isAnswerRequired: {
            deps: [
                'factorType'
            ],
            fn: function(factorType) {
                return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains([
                    'sms',
                    'call',
                    'email',
                    'token',
                    'token:software:totp',
                    'question'
                ], factorType);
            }
        },
        isFactorTypeVerification: {
            deps: [
                'provider',
                'id'
            ],
            fn: function(provider, id) {
                return provider === undefined && id === undefined;
            }
        }
    },
    parse: function(attributes) {
        this.settings = attributes.settings;
        this.appState = attributes.appState;
        // set the initial value for remember device.
        attributes.rememberDevice = (0, $020a58caf88b7504$export$2e2bcd8739ae039).getRememberDeviceValue(this.appState);
        // Add vendorname for custom totp enroll
        this.setCustomHotpVendorName(attributes);
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(attributes, [
            'settings',
            'appState'
        ]);
    },
    validate: function() {
        if (this.get('isAnswerRequired') && !this.get('answer')) return {
            answer: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('model.validation.field.blank')
        };
        else if (this.get('factorType') === 'password' && !this.get('password')) return {
            password: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('error.password.required')
        };
    },
    needsPasscode: function() {
        // we don't need passcode for email with magic link flow
        return !(this.options.appState.get('isIdxStateToken') && this.get('factorType') === 'email');
    },
    resend: function() {
        this.trigger('form:clear-errors');
        return this.manageTransaction(function(transaction) {
            const firstLink = transaction.data._links.resend[0];
            return transaction.resend(firstLink.name);
        });
    },
    save: function() {
        const rememberDevice = !!this.get('rememberDevice');
        const self = this;
        // Set/Remove the remember device cookie based on the remember device input.
        return this.manageTransaction(function(transaction, setTransaction) {
            const data = {
                rememberDevice: rememberDevice
            };
            if (this.get('factorType') === 'question') data.answer = this.get('answer');
            else if (this.get('factorType') === 'password') data.password = this.get('password');
            else if (this.needsPasscode()) data.passCode = this.get('answer');
            if (this.pushFactorHasAutoPush()) data.autoPush = this.get('autoPush');
            let promise;
            // MFA_REQUIRED, FACTOR_REQUIRED or UNAUTHENTICATED with factors (passwordlessAuth)
            if (transaction.status === 'MFA_REQUIRED' || transaction.status === 'FACTOR_REQUIRED' || this.appState.get('promptForFactorInUnauthenticated')) {
                const factor = this._findFactor(transaction);
                promise = factor.verify(data);
            } else if (this.get('canUseResend') && !this.get('answer') && transaction.resend) {
                // MFA_CHALLENGE/ FACTOR_CHALLENGE
                const firstLink = transaction.data._links.resend[0];
                promise = transaction.resend(firstLink.name);
            } else promise = transaction.verify(data);
            //the 'save' event here is triggered and used in the BaseLoginController
            //to disable the primary button on the factor form
            this.trigger('save');
            return promise.then(function(trans) {
                let pollingHasStarted = false;
                const options = {
                    delay: $004803a44bfc2c0c$var$PUSH_INTERVAL,
                    transactionCallBack: (transaction)=>{
                        pollingHasStarted = true;
                        self.options.appState.set('lastAuthResponse', transaction);
                    }
                };
                setTransaction(trans);
                // In Okta verify case we initiate poll.
                if (trans.status === 'MFA_CHALLENGE' && trans.poll || trans.status === 'FACTOR_CHALLENGE' && trans.poll) {
                    const deferred = (0, $6d3dd6c38b8802c0$export$e673efccd97e4223)();
                    const cancelPollInitiation = (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).callAfterTimeoutOrWindowRefocus(deferred.resolve, $004803a44bfc2c0c$var$PUSH_INTERVAL);
                    self.listenToOnce(self.options.appState, 'factorSwitched', ()=>{
                        cancelPollInitiation();
                        deferred.reject(new (0, $3fe6932680e7ea64$export$57d5450750549f48)());
                    });
                    return deferred.promise.then(function() {
                        // Stop listening if factor was not switched before poll.
                        self.stopListening(self.options.appState, 'factorSwitched');
                        if (self.pushFactorHasAutoPush()) {
                            options.autoPush = function() {
                                return self.get('autoPush');
                            };
                            options.rememberDevice = function() {
                                return self.get('rememberDevice');
                            };
                        }
                        let innerPromise;
                        if ((0, $22893d6dea78fc87$export$2e2bcd8739ae039).isIOS()) {
                            let cancelRedundantPoll;
                            innerPromise = Promise.race([
                                trans.poll(options),
                                (()=>{
                                    const _deferred = (0, $6d3dd6c38b8802c0$export$e673efccd97e4223)();
                                    cancelRedundantPoll = (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).callAfterTimeoutOrWindowRefocus(_deferred.resolve, 2000, true);
                                    return _deferred.promise.then(()=>{
                                        if (!pollingHasStarted) return trans.poll(options);
                                        return new Promise(()=>{}); // never resolve this promise
                                    });
                                })()
                            ]).then((result)=>{
                                cancelRedundantPoll();
                                return result;
                            });
                        } else innerPromise = trans.poll(options);
                        return innerPromise.then(function(trans) {
                            self.options.appState.set('lastAuthResponse', trans.data);
                            setTransaction(trans);
                        });
                    });
                }
            });
        });
    },
    _findFactor: function(transaction) {
        let factor;
        if (transaction.factorTypes) factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(transaction.factorTypes, {
            factorType: this.get('factorType')
        });
        if (!factor) factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(transaction.factors, {
            id: this.get('id')
        });
        return factor;
    },
    pushFactorHasAutoPush: function() {
        return this.settings.get('features.autoPush') && this.get('factorType') === 'push';
    },
    setCustomHotpVendorName: function(attributes) {
        // If factor is token:hotp and not enrolled, we assume the first profile is the default.
        // If factor is enrolled, we only support one profile to be enrolled, so find that one
        // and display as enrolled profile. We do this by populating profile name in vendorName.
        if (attributes.factorType === 'token:hotp' && attributes.profiles) {
            if (attributes.status === 'NOT_SETUP') attributes.vendorName = attributes.profiles[0].name;
            else if (attributes.status === 'ACTIVE') {
                const enrolledProfiles = attributes.profiles.filter((profile)=>{
                    return profile._embedded.enrolledFactors.length > 0;
                });
                attributes.vendorName = enrolledProfiles[0].name;
            }
        }
        return attributes;
    }
});
const $004803a44bfc2c0c$var$FactorFactors = (0, $5d64eb84267ab4e8$export$fb8073518f34e6ec).extend({
    model: $004803a44bfc2c0c$var$FactorFactor,
    comparator: 'sortOrder',
    // One override necessary here - When Okta Verify OTP and Push are in the list,
    // they are presented in the view as one factor - in the beacon menu,
    // there's only one option (Okta Verify), and we show a form with Push
    // with an inline totp option. What we need to do is to add totp
    // as a "backupFactor" for push
    parse: function(factors) {
        // Keep a track of the last used factor, since
        // we need it to determine the default factor.
        this.lastUsedFactor = factors[0];
        const oktaPushFactor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(factors, {
            provider: 'OKTA',
            factorType: 'push'
        });
        let totpFactor;
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).where(factors, {
            factorType: 'push'
        }).length > 1) totpFactor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(factors, {
            factorType: 'token:software:totp'
        });
        else totpFactor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(factors, {
            provider: 'OKTA',
            factorType: 'token:software:totp'
        });
        if (!oktaPushFactor || !totpFactor) return factors;
        const isTotpFirst = totpFactor === factors[0];
        const parsedFactors = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).reduce(factors, function(memo, factor) {
            const isOkta = factor.provider === 'OKTA';
            const isOktaTotp = isOkta && factor.factorType === 'token:software:totp';
            const isOktaPush = isOkta && factor.factorType === 'push';
            const notEnrolled = factor.status !== 'ACTIVE';
            const hideOktaTotp = isOktaTotp && (notEnrolled || oktaPushFactor.status === 'ACTIVE');
            const hideOktaPush = isOktaPush && notEnrolled && totpFactor.status === 'ACTIVE';
            if (hideOktaTotp || hideOktaPush) return memo;
            if (isOktaPush) factor.backupFactor = new $004803a44bfc2c0c$var$FactorFactor(totpFactor, {
                parse: true
            });
            memo.push(factor);
            return memo;
        }, []);
        // Use push factor instead of TOTP, if TOTP is first in the list
        // (since it is stored as backupFactor for push).
        if (isTotpFirst) this.lastUsedFactor = oktaPushFactor;
        return parsedFactors;
    },
    // Will need to update this to use HAL link to get last used factor:
    // https://oktainc.atlassian.net/browse/OKTA-58380
    // However, current code returns last used factor as first factor in list.
    // Also, will need to add priority - i.e. if they do not have a last used
    // factor, should try Okta Verify, then Okta SMS, etc.
    getDefaultFactor: function() {
        const factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).pick(this.lastUsedFactor, 'factorType', 'provider');
        return this.findWhere(factor);
    },
    getFirstUnenrolledRequiredFactor: function() {
        return this.findWhere({
            required: true,
            enrolled: false
        });
    },
    _getFactorsOfType: function(factorType) {
        return this.where({
            factorType: factorType
        });
    },
    getFactorIndex: function(factorType, factorId) {
        return this._getFactorsOfType(factorType).findIndex(function(factor) {
            return factor.get('id') === factorId;
        });
    },
    hasMultipleFactorsOfSameType: function(factorType) {
        return this._getFactorsOfType(factorType).length > 1;
    },
    getFactorByTypeAndIndex: function(factorType, factorIndex) {
        return this._getFactorsOfType(factorType)[factorIndex];
    }
});
var $004803a44bfc2c0c$export$2e2bcd8739ae039 = {
    Model: $004803a44bfc2c0c$var$FactorFactor,
    Collection: $004803a44bfc2c0c$var$FactorFactors
};













const $b717de154cd703a4$var$template = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<span class=\"icon error-24\"></span><h4><strong>" + ((stack1 = (helper = (helper = lookupProperty(helpers, "message") || (depth0 != null ? lookupProperty(depth0, "message") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "message",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 47
                },
                "end": {
                    "line": 1,
                    "column": 60
                }
            }
        }) : helper)) != null ? stack1 : "") + "</strong></h4>";
    },
    "useData": true
});
// Have to be unescaped for the html in enroll.windowsHello.error.notConfiguredHtml
var $b717de154cd703a4$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: $b717de154cd703a4$var$template,
    className: 'okta-infobox-error infobox infobox-error infobox-md margin-btm-25',
    attributes: {
        'data-se': 'o-form-error-html'
    },
    message: '',
    initialize: function(options) {
        if (options && options.message) this.message = options.message;
    },
    getTemplateData: function() {
        return {
            message: this.message
        };
    }
});


/*!
 * Copyright (c) 2019-2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const { Util: $d8b19b19af3e80be$var$Util } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).util;
var $d8b19b19af3e80be$export$2e2bcd8739ae039 = (0, $b4f6437a72effa5a$export$2e2bcd8739ae039).extend({
    Model: {
        local: {
            provider: 'string',
            factorType: 'string'
        },
        save: function() {
            return this.manageTransaction(()=>{
                const url = this.appState.get('enrollCustomFactorRedirectUrl');
                if (url !== null) $d8b19b19af3e80be$var$Util.redirect(url);
            });
        }
    },
    Form: function() {
        const factor = new (0, $004803a44bfc2c0c$export$2e2bcd8739ae039).Model(this.options.appState.get('factor'), this.toJSON());
        const vendorName = factor.get('vendorName');
        const subtitle = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.customFactor.subtitle', 'login', [
            vendorName
        ]);
        const saveText = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.customFactor.save', 'login');
        return {
            autoSave: true,
            title: vendorName,
            subtitle: subtitle,
            save: saveText,
            formChildren: function() {
                const result = [];
                if (this.options.appState.get('isFactorResultFailed')) result.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                    View: new (0, $b717de154cd703a4$export$2e2bcd8739ae039)({
                        message: this.options.appState.get('factorResultErrorMessage')
                    })
                }, {
                    selector: '.o-form-error-container'
                }));
                return result;
            }
        };
    }
});

























var $07fb0b040b68e1c2$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'hide resend-email-infobox',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"infobox infobox-warning\" aria-live=\"polite\"><span class=\"icon warning-16\"></span><p><span>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "email.code.not.received"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 102
                    },
                    "end": {
                        "line": 1,
                        "column": 156
                    }
                }
            })) + "</span><a href=\"#\" class=\"resend-email-btn\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "email.button.resend"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 200
                    },
                    "end": {
                        "line": 1,
                        "column": 250
                    }
                }
            })) + "</a></p></div>";
        },
        "useData": true
    }),
    events: {
        'click .resend-email-btn': 'resendEmail'
    },
    postRender: function() {
        this.showResendCallout();
    },
    showResendCallout: function() {
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).delay(()=>{
            this.$el.removeClass('hide');
        }, (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).API_RATE_LIMIT);
    },
    hideResendCallout: function() {
        this.$el.addClass('hide');
    },
    resendEmail: function(e) {
        e.preventDefault();
        this.hideResendCallout();
        this.model.resend().finally(this.showResendCallout.bind(this));
    }
});



const $cc187b957bd25eac$var$Model = {
    props: {
        passCode: 'string'
    },
    resend: function() {
        this.trigger('form:clear-errors');
        return this.doTransaction(function(transaction) {
            // authn support multiple `resend` hence has to specify name.
            return transaction.resend('email');
        });
    },
    save: function() {
        this.trigger('save');
        const formData = this.toJSON();
        return this.doTransaction(function(transaction) {
            return transaction.activate(formData);
        });
    }
};
const $cc187b957bd25eac$var$Form = function() {
    return {
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'email.enroll.title', 'login'),
        noButtonBar: false,
        autoSave: true,
        save: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'oform.verify', 'login'),
        // TODO: deprecated by mfa.challenge.verify
        formChildren: [
            // message
            (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                View: (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                    className: 'enroll-activate-email-content',
                    attributes: {
                        'data-se': 'enroll-activate-email-content'
                    },
                    // Why use `{{{` for the description?
                    // - factorEmail is actually an HTML fragment which
                    //   is created via another handlebar template and used for bold the email address.
                    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                        "compiler": [
                            8,
                            ">= 4.3.0"
                        ],
                        "main": function(container, depth0, helpers, partials, data) {
                            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                                return undefined;
                            };
                            return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                                "name": "i18n",
                                "hash": {
                                    "arguments": "factorEmail",
                                    "bundle": "login",
                                    "code": "email.mfa.email.sent.description"
                                },
                                "data": data,
                                "loc": {
                                    "start": {
                                        "line": 1,
                                        "column": 0
                                    },
                                    "end": {
                                        "line": 1,
                                        "column": 89
                                    }
                                }
                            })) != null ? stack1 : "";
                        },
                        "useData": true
                    }),
                    getTemplateData: function() {
                        const factor = this.options.appState.get('factor');
                        const factorEmailVal = factor && factor.profile ? factor.profile.email : '';
                        const factorEmail = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                            "compiler": [
                                8,
                                ">= 4.3.0"
                            ],
                            "main": function(container, depth0, helpers, partials, data) {
                                var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                                    return undefined;
                                };
                                return "<span class=\"mask-email\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "email") || (depth0 != null ? lookupProperty(depth0, "email") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                                    "name": "email",
                                    "hash": {},
                                    "data": data,
                                    "loc": {
                                        "start": {
                                            "line": 1,
                                            "column": 25
                                        },
                                        "end": {
                                            "line": 1,
                                            "column": 34
                                        }
                                    }
                                }) : helper)) + "</span>";
                            },
                            "useData": true
                        })({
                            email: factorEmailVal
                        });
                        return {
                            factorEmail: factorEmail
                        };
                    }
                })
            }),
            // send again callout message and link button
            (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                View: (0, $07fb0b040b68e1c2$export$2e2bcd8739ae039)
            }),
            // passcode input
            (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('email.code.label', 'login'),
                'label-top': true,
                name: 'passCode',
                type: 'text',
                wide: true
            })
        ]
    };
};
var $cc187b957bd25eac$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'enroll-activate-email',
    Model: $cc187b957bd25eac$var$Model,
    Form: $cc187b957bd25eac$var$Form,
    Footer: (0, $84975a54a18f1ea8$export$2e2bcd8739ae039)
});















/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ /* eslint max-len:0 */ var $41d65ad38216e7a1$export$2e2bcd8739ae039 = {
    US: '1',
    AG: '1',
    AI: '1',
    AS: '1',
    BB: '1',
    BM: '1',
    BS: '1',
    CA: '1',
    DM: '1',
    DO: '1',
    GD: '1',
    GU: '1',
    JM: '1',
    KN: '1',
    KY: '1',
    LC: '1',
    MP: '1',
    MS: '1',
    PR: '1',
    SX: '1',
    TC: '1',
    TT: '1',
    VC: '1',
    VG: '1',
    VI: '1',
    RU: '7',
    KZ: '7',
    EG: '20',
    ZA: '27',
    GR: '30',
    NL: '31',
    BE: '32',
    FR: '33',
    ES: '34',
    HU: '36',
    IT: '39',
    VA: '39',
    RO: '40',
    CH: '41',
    AT: '43',
    GB: '44',
    GG: '44',
    IM: '44',
    JE: '44',
    DK: '45',
    SE: '46',
    NO: '47',
    SJ: '47',
    PL: '48',
    DE: '49',
    PE: '51',
    MX: '52',
    CU: '53',
    AR: '54',
    BR: '55',
    CL: '56',
    CO: '57',
    VE: '58',
    MY: '60',
    AU: '61',
    CC: '61',
    CX: '61',
    ID: '62',
    PH: '63',
    NZ: '64',
    SG: '65',
    TH: '66',
    JP: '81',
    KR: '82',
    VN: '84',
    CN: '86',
    TR: '90',
    IN: '91',
    PK: '92',
    AF: '93',
    LK: '94',
    MM: '95',
    IR: '98',
    SS: '211',
    MA: '212',
    EH: '212',
    DZ: '213',
    TN: '216',
    LY: '218',
    GM: '220',
    SN: '221',
    MR: '222',
    ML: '223',
    GN: '224',
    CI: '225',
    BF: '226',
    NE: '227',
    TG: '228',
    BJ: '229',
    MU: '230',
    LR: '231',
    SL: '232',
    GH: '233',
    NG: '234',
    TD: '235',
    CF: '236',
    CM: '237',
    CV: '238',
    ST: '239',
    GQ: '240',
    GA: '241',
    CG: '242',
    CD: '243',
    AO: '244',
    GW: '245',
    IO: '246',
    AC: '247',
    SC: '248',
    SD: '249',
    RW: '250',
    ET: '251',
    SO: '252',
    DJ: '253',
    KE: '254',
    TZ: '255',
    UG: '256',
    BI: '257',
    MZ: '258',
    ZM: '260',
    MG: '261',
    RE: '262',
    YT: '262',
    ZW: '263',
    NA: '264',
    MW: '265',
    LS: '266',
    BW: '267',
    SZ: '268',
    KM: '269',
    SH: '290',
    TA: '290',
    ER: '291',
    AW: '297',
    FO: '298',
    GL: '299',
    GI: '350',
    PT: '351',
    LU: '352',
    IE: '353',
    IS: '354',
    AL: '355',
    MT: '356',
    CY: '357',
    FI: '358',
    AX: '358',
    BG: '359',
    LT: '370',
    LV: '371',
    EE: '372',
    MD: '373',
    AM: '374',
    BY: '375',
    AD: '376',
    MC: '377',
    SM: '378',
    UA: '380',
    RS: '381',
    ME: '382',
    XK: '383',
    HR: '385',
    SI: '386',
    BA: '387',
    MK: '389',
    CZ: '420',
    SK: '421',
    LI: '423',
    FK: '500',
    BZ: '501',
    GT: '502',
    SV: '503',
    HN: '504',
    NI: '505',
    CR: '506',
    PA: '507',
    PM: '508',
    HT: '509',
    GP: '590',
    BL: '590',
    MF: '590',
    BO: '591',
    GY: '592',
    EC: '593',
    GF: '594',
    PY: '595',
    MQ: '596',
    SR: '597',
    UY: '598',
    CW: '599',
    BQ: '599',
    TL: '670',
    NF: '672',
    BN: '673',
    NR: '674',
    PG: '675',
    TO: '676',
    SB: '677',
    VU: '678',
    FJ: '679',
    PW: '680',
    WF: '681',
    CK: '682',
    NU: '683',
    WS: '685',
    KI: '686',
    NC: '687',
    TV: '688',
    PF: '689',
    TK: '690',
    FM: '691',
    MH: '692',
    '001': '979',
    KP: '850',
    HK: '852',
    MO: '853',
    KH: '855',
    LA: '856',
    BD: '880',
    TW: '886',
    MV: '960',
    LB: '961',
    JO: '962',
    SY: '963',
    IQ: '964',
    KW: '965',
    SA: '966',
    YE: '967',
    OM: '968',
    PS: '970',
    AE: '971',
    IL: '972',
    BH: '973',
    QA: '974',
    BT: '975',
    MN: '976',
    NP: '977',
    TJ: '992',
    TM: '993',
    AZ: '994',
    GE: '995',
    KG: '996',
    UZ: '998',
    GS: '500',
    PN: '64',
    AQ: '672',
    UM: '1',
    AN: '599'
};


/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $bfbf136e55dbe393$export$2e2bcd8739ae039 = {};
// () => [{ countryCode: countryName }], sorted by countryName
$bfbf136e55dbe393$export$2e2bcd8739ae039.getCountries = function() {
    const countries = (0, $187365f460a6e3ed$export$2e2bcd8739ae039).omit((0, $ae370136150d080c$export$2e2bcd8739ae039).country, 'HM', 'BV', 'TF');
    // HM, BV, and TF do not have phone prefixes, so don't give the
    // user the option to choose these countries. FYI it appears that these
    // countries do not have calling codes because they are ~~uninhabited~~
    let collection = (0, $187365f460a6e3ed$export$2e2bcd8739ae039).map(countries, function(name, code) {
        return {
            name: name,
            code: code
        };
    });
    // Sort it; figure out if there is a better way to do this (best would
    // be to sort it in the properties file!!)
    collection = (0, $187365f460a6e3ed$export$2e2bcd8739ae039).sortBy(collection, 'name');
    const sorted = {};
    (0, $187365f460a6e3ed$export$2e2bcd8739ae039).each(collection, function(country) {
        sorted[country.code] = country.name;
    });
    return sorted;
};
$bfbf136e55dbe393$export$2e2bcd8739ae039.getCountryCode = function() {
    const countries = (0, $187365f460a6e3ed$export$2e2bcd8739ae039).omit((0, $ae370136150d080c$export$2e2bcd8739ae039).country, 'HM', 'BV', 'TF');
    // HM, BV, and TF do not have phone prefixes, so don't give the
    // user the option to choose these countries. FYI it appears that these
    // countries do not have calling codes because they are ~~uninhabited~~
    let collection = (0, $187365f460a6e3ed$export$2e2bcd8739ae039).map(countries, function(name, code) {
        return {
            name: name,
            code: code
        };
    });
    collection = (0, $187365f460a6e3ed$export$2e2bcd8739ae039).sortBy(collection, 'name');
    const sorted = {};
    (0, $187365f460a6e3ed$export$2e2bcd8739ae039).each(collection, function(country) {
        sorted[country.code] = (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('country.option.label', 'login', [
            country.name,
            country.code
        ]);
    });
    return sorted;
};
$bfbf136e55dbe393$export$2e2bcd8739ae039.getCallingCodeForCountry = function(countryCode) {
    return (0, $41d65ad38216e7a1$export$2e2bcd8739ae039)[countryCode];
};


















let { TextBox: $9dc0b52102d9ebff$var$TextBox } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).views.forms.inputs;
var $9dc0b52102d9ebff$export$2e2bcd8739ae039 = $9dc0b52102d9ebff$var$TextBox.extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<span class=\"okta-form-label-inline o-form-label-inline\">" + alias4((helper = (helper = lookupProperty(helpers, "countryCallingCode") || (depth0 != null ? lookupProperty(depth0, "countryCallingCode") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "countryCallingCode",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 57
                    },
                    "end": {
                        "line": 1,
                        "column": 79
                    }
                }
            }) : helper)) + "</span><span class=\"okta-form-input-field input-fix o-form-control\"><input type=\"" + alias4((helper = (helper = lookupProperty(helpers, "type") || (depth0 != null ? lookupProperty(depth0, "type") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "type",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 160
                    },
                    "end": {
                        "line": 1,
                        "column": 168
                    }
                }
            }) : helper)) + "\" placeholder=\"" + alias4((helper = (helper = lookupProperty(helpers, "placeholder") || (depth0 != null ? lookupProperty(depth0, "placeholder") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "placeholder",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 183
                    },
                    "end": {
                        "line": 1,
                        "column": 198
                    }
                }
            }) : helper)) + "\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "name",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 206
                    },
                    "end": {
                        "line": 1,
                        "column": 214
                    }
                }
            }) : helper)) + "\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "inputId",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 220
                    },
                    "end": {
                        "line": 1,
                        "column": 231
                    }
                }
            }) : helper)) + "\" value=\"" + alias4((helper = (helper = lookupProperty(helpers, "value") || (depth0 != null ? lookupProperty(depth0, "value") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "value",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 240
                    },
                    "end": {
                        "line": 1,
                        "column": 249
                    }
                }
            }) : helper)) + "\" autocomplete=\"" + alias4((helper = (helper = lookupProperty(helpers, "autocomplete") || (depth0 != null ? lookupProperty(depth0, "autocomplete") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "autocomplete",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 265
                    },
                    "end": {
                        "line": 1,
                        "column": 281
                    }
                }
            }) : helper)) + "\"></span>";
        },
        "useData": true
    }),
    initialize: function() {
        this.listenTo(this.model, 'change:countryCallingCode', function() {
            this.$('.o-form-label-inline').text(this.model.get('countryCallingCode'));
        });
    },
    preRender: function() {
        this.options.countryCallingCode = this.model.get('countryCallingCode');
        this.options.autocomplete = (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).getAutocompleteValue(this.options.model.settings, 'tel');
    },
    postRender: function() {
        // This is a hack - once inputGroups are done, get rid of it!!
        this.$el.removeClass('input-fix o-form-control');
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defer(()=>{
            this.$el.parent().addClass('o-form-input-group');
        });
    }
});



let { Keys: $83de8ccc23eb85f0$var$Keys } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).util;
const $83de8ccc23eb85f0$var$EnrollCallAndSmsControllerwarningTemplate = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'okta-form-infobox-warning infobox infobox-warning login-timeout-warning',
    attributes: {
        'aria-live': 'polite'
    },
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<span class=\"icon warning-16\"></span><p>" + ((stack1 = (helper = (helper = lookupProperty(helpers, "warning") || (depth0 != null ? lookupProperty(depth0, "warning") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "warning",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 40
                    },
                    "end": {
                        "line": 1,
                        "column": 53
                    }
                }
            }) : helper)) != null ? stack1 : "") + "</p>";
        },
        "useData": true
    })
});
const $83de8ccc23eb85f0$var$factorIdIsDefined = {
    factorId: function(val) {
        return !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isUndefined(val);
    }
};
function $83de8ccc23eb85f0$var$isCallFactor(factorType) {
    return factorType === 'call';
}
function $83de8ccc23eb85f0$var$getClassName(factorType) {
    return $83de8ccc23eb85f0$var$isCallFactor(factorType) ? 'enroll-call' : 'enroll-sms';
}
function $83de8ccc23eb85f0$var$sendCode(e) {
    if ($83de8ccc23eb85f0$var$Keys.isEnter(e)) {
        e.stopPropagation();
        e.preventDefault();
        if (e.type === 'keyup' && e.data && e.data.model) e.data.model.sendCode();
    }
}
var $83de8ccc23eb85f0$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: function() {
        return $83de8ccc23eb85f0$var$getClassName(this.options.factorType);
    },
    Model: function() {
        return {
            props: {
                phoneNumber: [
                    'string',
                    true
                ],
                phoneExtension: [
                    'string',
                    false
                ],
                lastEnrolledPhoneNumber: 'string',
                passCode: [
                    'string',
                    true
                ],
                factorId: 'string'
            },
            local: {
                countryCode: [
                    'string',
                    false,
                    this.options.appState.get('userCountryCode')
                ],
                hasExistingPhones: 'boolean',
                trapEnrollment: 'boolean',
                ableToResend: 'boolean',
                factorType: 'string',
                skipPhoneValidation: 'boolean'
            },
            derived: {
                countryCallingCode: {
                    deps: [
                        'countryCode'
                    ],
                    fn: function(countryCode) {
                        return '+' + (0, $bfbf136e55dbe393$export$2e2bcd8739ae039).getCallingCodeForCountry(countryCode);
                    }
                },
                fullPhoneNumber: {
                    deps: [
                        'countryCallingCode',
                        'phoneNumber'
                    ],
                    fn: function(countryCallingCode, phoneNumber) {
                        return phoneNumber ? countryCallingCode + phoneNumber : '';
                    }
                },
                enrolled: {
                    deps: [
                        'lastEnrolledPhoneNumber',
                        'fullPhoneNumber'
                    ],
                    fn: function(lastEnrolled, current) {
                        return lastEnrolled === current;
                    }
                }
            },
            limitResending: function() {
                this.set({
                    ableToResend: false
                });
                (0, $3e490973b7383cc4$export$2e2bcd8739ae039).delay((0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(this.set, this), (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).API_RATE_LIMIT, {
                    ableToResend: true
                });
            },
            sendCode: function() {
                const self = this;
                const phoneNumber = this.get('fullPhoneNumber');
                const phoneExtension = this.get('phoneExtension');
                self.trigger('errors:clear');
                if (!phoneNumber.length) {
                    self.trigger('invalid', self, {
                        phoneNumber: 'model.validation.field.blank'
                    });
                    return;
                }
                return this.doTransaction(function(transaction) {
                    const isMfaEnroll = transaction.status === 'MFA_ENROLL' || transaction.status === 'FACTOR_ENROLL';
                    const profileData = {
                        phoneNumber: phoneNumber,
                        updatePhone: isMfaEnroll ? self.get('hasExistingPhones') : true
                    };
                    if ($83de8ccc23eb85f0$var$isCallFactor(self.get('factorType'))) profileData['phoneExtension'] = phoneExtension;
                    if (self.get('skipPhoneValidation')) profileData['validatePhone'] = false;
                    const doEnroll = function(trans) {
                        const factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(trans.factors, {
                            factorType: self.get('factorType'),
                            provider: 'OKTA'
                        });
                        return factor.enroll({
                            profile: profileData
                        }).catch(function(error) {
                            if (error.errorCode === 'E0000098') {
                                // E0000098: "This phone number is invalid."
                                self.set('skipPhoneValidation', true);
                                error.xhr.responseJSON.errorSummary = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.sms.try_again', 'login');
                            }
                            throw error;
                        });
                    };
                    if (isMfaEnroll) return doEnroll(transaction);
                    else {
                        // We must transition to MfaEnroll before updating the phone number
                        self.set('trapEnrollment', true);
                        return transaction.prev().then(doEnroll).then(function(trans) {
                            self.set('trapEnrollment', false);
                            return trans;
                        });
                    }
                // Rethrow errors so we can change state
                // AFTER setting the new transaction
                }, true).then(function() {
                    self.set('lastEnrolledPhoneNumber', phoneNumber);
                    self.limitResending();
                }).catch(function() {
                    self.set('trapEnrollment', false);
                });
            },
            resendCode: function() {
                this.trigger('errors:clear');
                this.limitResending();
                return this.doTransaction(function(transaction) {
                    return transaction.resend(this.get('factorType'));
                });
            },
            save: function() {
                return this.doTransaction(function(transaction) {
                    return transaction.activate({
                        passCode: this.get('passCode')
                    });
                });
            }
        };
    },
    Form: function() {
        const factorType = this.options.factorType;
        const isCall = $83de8ccc23eb85f0$var$isCallFactor(factorType);
        const formTitle = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(isCall ? 'enroll.call.setup' : 'enroll.sms.setup', 'login');
        const formSubmit = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(isCall ? 'mfa.call' : 'mfa.sendCode', 'login');
        const formRetry = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(isCall ? 'mfa.redial' : 'mfa.resendCode', 'login');
        const formSubmitted = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(isCall ? 'mfa.calling' : 'mfa.sent', 'login');
        const numberFieldClassName = isCall ? 'enroll-call-phone' : 'enroll-sms-phone';
        const buttonClassName = isCall ? 'call-request-button' : 'sms-request-button';
        const formChildren = [
            (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                name: 'countryCode',
                type: 'select',
                wide: true,
                options: (0, $bfbf136e55dbe393$export$2e2bcd8739ae039).getCountries()
            }),
            (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.phoneNumber.placeholder', 'login'),
                'label-top': true,
                className: numberFieldClassName,
                name: 'phoneNumber',
                input: (0, $9dc0b52102d9ebff$export$2e2bcd8739ae039),
                type: 'text',
                render: function() {
                    this.$('input[name="phoneNumber"]').off('keydown keyup', $83de8ccc23eb85f0$var$sendCode).keydown($83de8ccc23eb85f0$var$sendCode).keyup({
                        model: this.model
                    }, $83de8ccc23eb85f0$var$sendCode);
                }
            })
        ];
        if (isCall) formChildren.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
            label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.phoneNumber.ext.placeholder', 'login'),
            'label-top': true,
            className: 'enroll-call-extension',
            name: 'phoneExtension',
            input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
            type: 'text'
        }));
        formChildren.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Button({
            title: formSubmit,
            attributes: {
                'data-se': buttonClassName
            },
            className: 'button button-primary js-enroll-phone margin-top-30 ' + buttonClassName,
            click: function() {
                this.model.sendCode();
            }
        }), (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Button({
            title: formRetry,
            attributes: {
                'data-se': buttonClassName
            },
            className: 'button js-enroll-phone margin-top-30 ' + buttonClassName,
            click: function() {
                this.model.resendCode();
            },
            initialize: function() {
                this.$el.css({
                    display: 'none'
                });
                this.listenTo(this.model, 'change:ableToResend', function(model, ableToResend) {
                    if (ableToResend) {
                        this.options.title = formRetry;
                        this.enable();
                    } else {
                        this.options.title = formSubmitted;
                        this.disable();
                    }
                    this.render();
                });
            }
        }), (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Divider({
            showWhen: $83de8ccc23eb85f0$var$factorIdIsDefined
        }), (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
            label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.enterCode.placeholder', 'login'),
            'label-top': true,
            explain: (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).createInputExplain('mfa.challenge.enterCode.tooltip', 'mfa.challenge.enterCode.placeholder', 'login'),
            'explain-top': true,
            name: 'passCode',
            input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
            type: 'tel',
            showWhen: $83de8ccc23eb85f0$var$factorIdIsDefined
        }), (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Toolbar({
            noCancelButton: true,
            save: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.verify', 'login'),
            showWhen: $83de8ccc23eb85f0$var$factorIdIsDefined
        }));
        return {
            title: formTitle,
            noButtonBar: true,
            autoSave: true,
            className: $83de8ccc23eb85f0$var$getClassName(factorType),
            showWarning: function(msg) {
                this.clearWarnings();
                this.add($83de8ccc23eb85f0$var$EnrollCallAndSmsControllerwarningTemplate, '.o-form-error-container', {
                    options: {
                        warning: msg
                    }
                });
            },
            clearWarnings: function() {
                this.$('.okta-form-infobox-warning').remove();
            },
            initialize: function() {
                const callTimeWarning = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                    "compiler": [
                        8,
                        ">= 4.3.0"
                    ],
                    "main": function(container, depth0, helpers, partials, data) {
                        var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                            return undefined;
                        };
                        return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                            "name": "i18n",
                            "hash": {
                                "$1": "<b>$1</b>",
                                "bundle": "login",
                                "code": "factor.call.time.warning"
                            },
                            "data": data,
                            "loc": {
                                "start": {
                                    "line": 1,
                                    "column": 0
                                },
                                "end": {
                                    "line": 1,
                                    "column": 71
                                }
                            }
                        }));
                    },
                    "useData": true
                });
                const smsTimeWarning = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                    "compiler": [
                        8,
                        ">= 4.3.0"
                    ],
                    "main": function(container, depth0, helpers, partials, data) {
                        var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                            return undefined;
                        };
                        return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                            "name": "i18n",
                            "hash": {
                                "$1": "<b>$1</b>",
                                "bundle": "login",
                                "code": "factor.sms.time.warning"
                            },
                            "data": data,
                            "loc": {
                                "start": {
                                    "line": 1,
                                    "column": 0
                                },
                                "end": {
                                    "line": 1,
                                    "column": 70
                                }
                            }
                        }));
                    },
                    "useData": true
                });
                this.listenTo(this.model, 'change:ableToResend', function(model, ableToResend) {
                    if (ableToResend) this.showWarning(isCall ? callTimeWarning : smsTimeWarning);
                    else this.clearWarnings();
                });
                this.listenTo(this.model, 'error errors:clear', function() {
                    this.clearWarnings();
                    this.clearErrors();
                });
                this.listenTo(this.model, 'change:enrolled', function() {
                    this.$('.js-enroll-phone').toggle();
                });
            },
            formChildren: formChildren
        };
    },
    Footer: (0, $84975a54a18f1ea8$export$2e2bcd8739ae039),
    trapAuthResponse: function() {
        if (this.options.appState.get('isMfaEnrollActivate')) {
            this.model.set('factorId', this.options.appState.get('activatedFactorId'));
            return true;
        }
        if (this.options.appState.get('isMfaEnroll') && this.model.get('trapEnrollment')) return true;
    },
    initialize: function() {
        if ($83de8ccc23eb85f0$var$isCallFactor(this.options.factorType)) this.model.set('hasExistingPhones', this.options.appState.get('hasExistingPhonesForCall'));
        else this.model.set('hasExistingPhones', this.options.appState.get('hasExistingPhones'));
        this.model.set('factorType', this.options.factorType);
    }
});
























const $812bb17ab26ae781$var$cardinalityTextTpl = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<span class=\"factor-cardinality\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "cardinalityText") || (depth0 != null ? lookupProperty(depth0, "cardinalityText") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "cardinalityText",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 33
                },
                "end": {
                    "line": 1,
                    "column": 52
                }
            }
        }) : helper)) + "</span>";
    },
    "useData": true
});
const $812bb17ab26ae781$var$FactorListFactorRow = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    tagName: 'li',
    className: 'enroll-factor-row clearfix',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "factorDescription") || (depth0 != null ? lookupProperty(depth0, "factorDescription") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "factorDescription",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 235
                    },
                    "end": {
                        "line": 1,
                        "column": 256
                    }
                }
            }) : helper)) + "</p>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"enroll-factor-icon-container\"><div class=\"factor-icon enroll-factor-icon " + alias4((helper = (helper = lookupProperty(helpers, "iconClassName") || (depth0 != null ? lookupProperty(depth0, "iconClassName") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "iconClassName",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 85
                    },
                    "end": {
                        "line": 1,
                        "column": 102
                    }
                }
            }) : helper)) + "\"></div></div><div class=\"enroll-factor-description\"><h3 class=\"enroll-factor-label\">" + alias4((helper = (helper = lookupProperty(helpers, "factorLabel") || (depth0 != null ? lookupProperty(depth0, "factorLabel") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "factorLabel",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 187
                    },
                    "end": {
                        "line": 1,
                        "column": 202
                    }
                }
            }) : helper)) + "</h3>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "factorDescription") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 207
                    },
                    "end": {
                        "line": 1,
                        "column": 267
                    }
                }
            })) != null ? stack1 : "") + "<div class=\"enroll-factor-button\"></div></div>";
        },
        "useData": true
    }),
    attributes: function() {
        return {
            'data-se': this.model.get('factorName')
        };
    },
    children: function() {
        const children = [];
        const enrolled = this.model.get('enrolled');
        const required = this.model.get('required');
        const cardinality = this.model.get('cardinality');
        if (this.options.showInlineSetupButton) return [
            [
                (0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
                    className: 'button',
                    title: this.getSetupButtonText(),
                    click: function() {
                        this.options.appState.trigger('navigate', (0, $ec545c48aa9cf055$export$2e2bcd8739ae039).createEnrollFactorUrl(this.model.get('provider'), this.model.get('factorType')));
                    }
                }),
                '.enroll-factor-button'
            ]
        ];
        else if (enrolled) children.push([
            '<span class="icon success-16-green"></span>',
            '.enroll-factor-label'
        ]);
        else if (required) children.push([
            '<span class="icon success-16-gray"></span>',
            '.enroll-factor-label'
        ]);
        const cardinalityText = (0, $020a58caf88b7504$export$2e2bcd8739ae039).getCardinalityText(enrolled, required, cardinality);
        if (cardinalityText) children.push([
            $812bb17ab26ae781$var$cardinalityTextTpl({
                cardinalityText: cardinalityText
            }),
            '.enroll-factor-description'
        ]);
        return children;
    },
    minimize: function() {
        this.$el.addClass('enroll-factor-row-min');
    },
    maximize: function() {
        this.$el.removeClass('enroll-factor-row-min');
    },
    getSetupButtonText: function() {
        return this.model.get('additionalEnrollment') ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.choices.setup.another', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.choices.setup', 'login');
    }
});
var $812bb17ab26ae781$export$2e2bcd8739ae039 = (0, $20176b5b9767e868$export$2e2bcd8739ae039).extend({
    className: 'enroll-factor-list',
    item: $812bb17ab26ae781$var$FactorListFactorRow,
    itemSelector: '.list-content',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<h3 class=\"list-title\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "listTitle") || (depth0 != null ? lookupProperty(depth0, "listTitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "listTitle",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 40
                    },
                    "end": {
                        "line": 1,
                        "column": 53
                    }
                }
            }) : helper)) + "</h3>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "listTitle") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 65
                    }
                }
            })) != null ? stack1 : "") + "<ul class=\"list-content\"></ul>";
        },
        "useData": true
    }),
    getTemplateData: function() {
        const json = (0, $20176b5b9767e868$export$2e2bcd8739ae039).prototype.getTemplateData.call(this);
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend(json, this);
        return json;
    },
    postRender: function() {
        if (this.options.minimize) this.invoke('minimize');
    }
});












var $0c5faa4e4c116c2c$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a href=\"#\" class=\"link goto js-skip\" data-se=\"skip-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.choices.setup.skip"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 58
                    },
                    "end": {
                        "line": 1,
                        "column": 114
                    }
                }
            })) + "</a>";
        },
        "useData": true
    }),
    className: 'auth-footer clearfix',
    events: {
        'click .js-skip': function(e) {
            e.preventDefault();
            this.model.doTransaction(function(transaction) {
                return transaction.skip();
            });
        }
    }
});













/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $912f94cfdd288303$export$2e2bcd8739ae039 = (0, $812bb17ab26ae781$export$2e2bcd8739ae039).extend({
    listTitle: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'enroll.choices.list.setup', 'login'),
    className: function() {
        return (0, $812bb17ab26ae781$export$2e2bcd8739ae039).prototype.className + ' enroll-required-factor-list';
    },
    postRender: function() {
        let currentModel;
        let currentRow;
        (0, $812bb17ab26ae781$export$2e2bcd8739ae039).prototype.postRender.apply(this, arguments);
        currentModel = this.options.appState.get('factors').getFirstUnenrolledRequiredFactor();
        currentRow = this.find(function(view) {
            return view.model === currentModel;
        });
        currentRow.maximize();
    }
});





const $5486982f5705af91$var$subtitleTpl = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<span>" + ((stack1 = (helper = (helper = lookupProperty(helpers, "subtitle") || (depth0 != null ? lookupProperty(depth0, "subtitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "subtitle",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 6
                },
                "end": {
                    "line": 1,
                    "column": 20
                }
            }
        }) : helper)) != null ? stack1 : "") + "</span>";
    },
    "useData": true
});
var $5486982f5705af91$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'enroll-choices',
    state: {
        pageType: null
    },
    Model: {},
    Form: {
        noCancelButton: true,
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'enroll.choices.title', 'login'),
        noButtonBar: function() {
            return this.state.get('pageType') === (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).ALL_OPTIONAL_NONE_ENROLLED;
        },
        subtitle: ' ',
        getSubtitle: function() {
            switch(this.state.get('pageType')){
                case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).ALL_OPTIONAL_SOME_ENROLLED:
                case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).HAS_REQUIRED_ALL_REQUIRED_ENROLLED:
                    return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.choices.optional', 'login');
                case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
                    {
                        const remainingDays = this.options.appState.get('gracePeriodRemainingDays');
                        // remainingDays is null if there is no grace period, 0 if we are still in grace period
                        return remainingDays !== null && remainingDays >= 0 ? this.getGracePeriodSubtitle(remainingDays) : this.getDefaultSubtitle();
                    }
                default:
                    return this.getDefaultSubtitle();
            }
        },
        getDefaultSubtitle: function() {
            return this.settings.get('brandName') ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.choices.description.specific', 'login', [
                this.settings.get('brandName')
            ]) : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.choices.description.generic', 'login');
        },
        getGracePeriodSubtitle: function(remainingDays) {
            return remainingDays >= 1 ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.choices.description.gracePeriod.bold', 'login', [
                remainingDays
            ]) : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.choices.description.gracePeriod.oneDay.bold', 'login');
        },
        save: function() {
            switch(this.state.get('pageType')){
                case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).ALL_OPTIONAL_SOME_ENROLLED:
                case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).HAS_REQUIRED_ALL_REQUIRED_ENROLLED:
                    return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.choices.submit.finish', 'login');
                case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).HAS_REQUIRED_NONE_ENROLLED:
                    return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.choices.submit.configure', 'login');
                case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
                    return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.choices.submit.next', 'login');
                default:
                    return '';
            }
        },
        initialize: function(options) {
            this.listenTo(this, 'save', function() {
                let current;
                switch(this.state.get('pageType')){
                    case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).HAS_REQUIRED_NONE_ENROLLED:
                    case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
                        current = options.appState.get('factors').getFirstUnenrolledRequiredFactor();
                        options.appState.trigger('navigate', (0, $ec545c48aa9cf055$export$2e2bcd8739ae039).createEnrollFactorUrl(current.get('provider'), current.get('factorType')));
                        break;
                    default:
                        return this.model.doTransaction(function(transaction) {
                            return transaction.skip();
                        });
                }
            });
        },
        preRender: function() {
            // form subtitle does not support unescaped strings, and we need some html elements
            // in the subtitle for this form. So instead of a regular subtitle, we add a <span>
            // with the text we need
            this.add($5486982f5705af91$var$subtitleTpl({
                subtitle: this.getSubtitle()
            }), 'p.okta-form-subtitle');
            const factors = this.options.appState.get('factors');
            switch(this.state.get('pageType')){
                case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).HAS_REQUIRED_NONE_ENROLLED:
                case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
                    this.add(new (0, $912f94cfdd288303$export$2e2bcd8739ae039)({
                        minimize: true,
                        collection: new (0, $5d64eb84267ab4e8$export$fb8073518f34e6ec)(factors.where({
                            required: true
                        })),
                        appState: this.options.appState
                    }));
                    break;
                case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).HAS_REQUIRED_ALL_REQUIRED_ENROLLED:
                case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).ALL_OPTIONAL_SOME_ENROLLED:
                case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).ALL_OPTIONAL_NONE_ENROLLED:
                    {
                        const enrolled = factors.where({
                            enrolled: true
                        });
                        const notEnrolled = factors.filter(function(factor) {
                            // pick factors that are not enrolled or have additional enrollments
                            return !factor.get('enrolled') || factor.get('additionalEnrollment');
                        });
                        let notEnrolledListTitle;
                        if (enrolled.length > 0) {
                            notEnrolledListTitle = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.choices.list.optional', 'login');
                            this.add(new (0, $812bb17ab26ae781$export$2e2bcd8739ae039)({
                                listTitle: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.choices.list.enrolled', 'login'),
                                minimize: true,
                                collection: new (0, $5d64eb84267ab4e8$export$fb8073518f34e6ec)(enrolled),
                                appState: this.options.appState
                            }));
                        }
                        this.add(new (0, $812bb17ab26ae781$export$2e2bcd8739ae039)({
                            listTitle: notEnrolledListTitle,
                            collection: new (0, $5d64eb84267ab4e8$export$fb8073518f34e6ec)(notEnrolled),
                            appState: this.options.appState,
                            showInlineSetupButton: true
                        }));
                        break;
                    }
            }
        }
    },
    initialize: function(options) {
        let numRequiredEnrolled = 0;
        let numRequiredNotEnrolled = 0;
        let numOptionalEnrolled = 0;
        let numOptionalNotEnrolled = 0;
        let hasRequired;
        let pageType;
        options.appState.get('factors').each(function(factor) {
            const required = factor.get('required');
            const enrolled = factor.get('enrolled');
            const additionalEnrollment = factor.get('additionalEnrollment');
            if (required && enrolled) numRequiredEnrolled++;
            else if (required && !enrolled) numRequiredNotEnrolled++;
            else if (!required && enrolled) numOptionalEnrolled++;
            else if (!required && !enrolled) numOptionalNotEnrolled++;
            // If a factor has multiple instances and
            // additional optional enrollments
            if (enrolled && additionalEnrollment) numOptionalNotEnrolled++;
        });
        hasRequired = numRequiredEnrolled > 0 || numRequiredNotEnrolled > 0;
        // There are 5 possible states this screen can be in:
        // 1. Has required, but none have been enrolled. Wizard start page.
        if (hasRequired && numRequiredEnrolled === 0) pageType = (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).HAS_REQUIRED_NONE_ENROLLED;
        else if (hasRequired && numRequiredNotEnrolled > 0) // 2. Has required, and have enrolled at least one. The page layout
        //    to configure the remaining required factors.
        pageType = (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).HAS_REQUIRED_SOME_REQUIRED_ENROLLED;
        else if (hasRequired && numOptionalNotEnrolled > 0) // 3. Has required, and finished enrolling all required factors. The
        //    page layout you see to configure any optional factors or skip.
        pageType = (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).HAS_REQUIRED_ALL_REQUIRED_ENROLLED;
        else if (numOptionalEnrolled === 0 && numOptionalNotEnrolled > 0) // 4. Factors are all optional, no factors enrolled.
        pageType = (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).ALL_OPTIONAL_NONE_ENROLLED;
        else if (numOptionalNotEnrolled > 0) // 5. Factors are all optional, some factors have already been
        //    enrolled (can either enroll more or skip).
        pageType = (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).ALL_OPTIONAL_SOME_ENROLLED;
        else // 6. Factors are all optional, all factors have already been
        //    enrolled, among them there is OktaVerify with Push enrolled as totp
        //    (API return OktaVerify push factor as unenrolled in this case and as we always merge
        //    push and totp in UI so we redirect to skip link here).
        this.model.doTransaction(function(transaction) {
            return transaction.skip();
        });
        this.state.set('pageType', pageType);
        if (this.options.appState.get('skipLink') && pageType === (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).HAS_REQUIRED_SOME_REQUIRED_ENROLLED) this.add(new (0, $0c5faa4e4c116c2c$export$2e2bcd8739ae039)(this.toJSON()));
    }
});













var $f103d065b3b3bbb0$export$a441d440b06e3168 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};


var $253746e3963664b9$export$4368d992c4eafac0 = {
    exports: {}
};


/**
 * 
 * This file has been modified to override doPostBack
 * Check out the doPostBack function below for more details.
 * Override the doPostBack function when upgrading.
 * Unable to make a wrapper because it is invoked using an internal name within 
 * this library.
 * 
 * Current Verison = https://github.com/duosecurity/duo_web_sdk/blob/7aec8dd895ea4bd4549069e76076850eccfe07f2/index.js
 * PS: they dont seem to version correctly hence using commit.
 */ /**
 * Duo Web SDK v2
 * Copyright 2019, Duo Security
 */ // Modified to remove AMD and support ESM transform - OKTA-369648
(function(root, factory) {
    (0, $253746e3963664b9$export$4368d992c4eafac0).exports = factory();
})((0, $f103d065b3b3bbb0$export$a441d440b06e3168), function() {
    var DUO_MESSAGE_FORMAT = /^(?:AUTH|ENROLL)+\|[A-Za-z0-9\+\/=]+\|[A-Za-z0-9\+\/=]+$/;
    var DUO_ERROR_FORMAT = /^ERR\|[\w\s\.\(\)]+$/;
    var DUO_OPEN_WINDOW_FORMAT = /^DUO_OPEN_WINDOW\|/;
    var VALID_OPEN_WINDOW_DOMAINS = [
        'duo.com',
        'duosecurity.com',
        'duomobile.s3-us-west-1.amazonaws.com'
    ];
    var postAction, postArgument, host, duoSig, appSig, iframe;
    // We use this function instead of setting initial values in the var
    // declarations to make sure the initial values and subsequent
    // re-initializations are always the same.
    initializeStatefulVariables();
    /**
   * Set local variables to whatever they should be before you call init().
   */ function initializeStatefulVariables() {
        postAction = '';
        postArgument = 'sig_response';
        host = undefined;
        duoSig = undefined;
        appSig = undefined;
        iframe = undefined;
    }
    function throwError(message, givenUrl) {
        var url = givenUrl || 'https://www.duosecurity.com/docs/duoweb#3.-show-the-iframe';
        throw new Error('Duo Web SDK error: ' + message + (url ? "\nSee " + url + ' for more information' : ''));
    }
    function hyphenize(str) {
        return str.replace(/([a-z])([A-Z])/, '$1-$2').toLowerCase();
    }
    // cross-browser data attributes
    function getDataAttribute(element, name) {
        if ('dataset' in element) return element.dataset[name];
        else return element.getAttribute('data-' + hyphenize(name));
    }
    // cross-browser event binding/unbinding
    function on(context, event, fallbackEvent, callback) {
        if ('addEventListener' in window) context.addEventListener(event, callback, false);
        else context.attachEvent(fallbackEvent, callback);
    }
    function off(context, event, fallbackEvent, callback) {
        if ('removeEventListener' in window) context.removeEventListener(event, callback, false);
        else context.detachEvent(fallbackEvent, callback);
    }
    function onReady(callback) {
        on(document, 'DOMContentLoaded', 'onreadystatechange', callback);
    }
    function offReady(callback) {
        off(document, 'DOMContentLoaded', 'onreadystatechange', callback);
    }
    function onMessage(callback) {
        on(window, 'message', 'onmessage', callback);
    }
    function offMessage(callback) {
        off(window, 'message', 'onmessage', callback);
    }
    /**
   * Parse the sig_request parameter, throwing errors if the token contains
   * a server error or if the token is invalid.
   *
   * @param {String} sig Request token
   */ function parseSigRequest(sig) {
        if (!sig) // nothing to do
        return;
        // see if the token contains an error, throwing it if it does
        if (sig.indexOf('ERR|') === 0) throwError(sig.split('|')[1]);
        // validate the token
        if (sig.indexOf(':') === -1 || sig.split(':').length !== 2) throwError("Duo was given a bad token.  This might indicate a configuration problem with one of Duo's client libraries.");
        var sigParts = sig.split(':');
        duoSig = sigParts[0];
        appSig = sigParts[1];
        return {
            sigRequest: sig,
            duoSig: sigParts[0],
            appSig: sigParts[1]
        };
    }
    /**
   * Validate that a MessageEvent came from the Duo service, and that it
   * is a properly formatted payload.
   *
   * The Google Chrome sign-in page injects some JS into pages that also
   * make use of postMessage, so we need to do additional validation above
   * and beyond the origin.
   *
   * @param {MessageEvent} event Message received via postMessage
   */ function isDuoMessage(event) {
        return Boolean(event.origin === 'https://' + host && typeof event.data === 'string' && (event.data.match(DUO_MESSAGE_FORMAT) || event.data.match(DUO_ERROR_FORMAT) || event.data.match(DUO_OPEN_WINDOW_FORMAT)));
    }
    /**
   * Validate the request token and prepare for the iframe to become ready.
   *
   * All options below can be passed into an options hash to `Duo.init`, or
   * specified on the iframe using `data-` attributes.
   *
   * Options specified using the options hash will take precedence over
   * `data-` attributes.
   *
   * Example using options hash:
   * ```javascript
   * Duo.init({
   *     iframe: "some_other_id",
   *     host: "api-main.duo.test",
   *     sig_request: "...",
   *     post_action: "/auth",
   *     post_argument: "resp"
   * });
   * ```
   *
   * Example using `data-` attributes:
   * ```html
   * <iframe id="duo_iframe"
   *         data-host="api-main.duo.test"
   *         data-sig-request="..."
   *         data-post-action="/auth"
   *         data-post-argument="resp"
   *         >
   * </iframe>
   * ```
   *
   * Some browsers (especially embedded browsers) don't like it when the Duo
   * Web SDK changes the `src` attribute on the iframe. To prevent this, there
   * is an alternative way to use the Duo Web SDK:
   *
   * Add a div (or any other container element) instead of an iframe to the
   * DOM with an id of "duo_iframe", or pass that element to the
   * `iframeContainer` parameter of `Duo.init`. An iframe will be created and
   * inserted into that container element, preventing `src` change related
   * bugs. WARNING: All other elements in the container will be deleted.
   *
   * The `iframeAttributes` parameter of `Duo.init` is available to set any
   * attributes on the inserted iframe if the Duo Web SDK is inserting the
   * iframe. For details, see the parameter documentation below.
   *
   * @param {Object} options
   * @param {String} options.host - Hostname for the Duo Prompt.
   * @param {String} options.sig_request - Request token.
   * @param {String|HTMLElement} [options.iframe] - The iframe, or id of an
   *     iframe that will be used for the Duo Prompt. If you don't provide
   *     this or the `iframeContainer` parameter the Duo Web SDK will default
   *     to using whatever element has an id of "duo_iframe".
   * @param {String|HTMLElement} [options.iframeContainer] - The element you
   *     want the Duo Prompt inserted into, or the id of that element.
   *     Anything inside this element will be deleted and replaced with an
   *     iframe hosting the Duo prompt. If you don't provide this or the
   *     `iframe` parameter the Duo Web SDK will default to using whatever
   *     element has an id of "duo_iframe".
   * @param {Object} [options.iframeAttributes] - Object with  names and
   *     values coresponding to attributes you want added to the  Duo Prompt
   *     iframe, like `title`, `width` and `allow`. WARNING: this parameter
   *     only works if you use the `iframeContainer` parameter or add an id
   *     of "duo_iframe" to an element that isn't an iframe. If you have
   *     added an iframe to the DOM yourself, you should set those attributes
   *     directly on the iframe.
   * @param {String} [options.post_action=''] - URL to POST back to after a
   *     successful auth.
   * @param {String} [options.post_argument='sig_response'] - Parameter name
   *     to use for response token.
   * @param {Function} [options.submit_callback] - If provided, the Duo Web
   *     SDK will not submit the form. Instead it will execute this callback
   *     function passing in a reference to the "duo_form" form object.
   *     `submit_callback`` can be used to prevent the webpage from reloading.
   */ function init(options) {
        // If init() is called more than once we have to reset all the local
        // variables to ensure init() will work the same way every time. This
        // helps people making single page applications. SPAs may periodically
        // remove the iframe and add a new one that has to be initialized.
        initializeStatefulVariables();
        if (options) {
            if (options.host) host = options.host;
            if (options.sig_request) parseSigRequest(options.sig_request);
            if (options.post_action) postAction = options.post_action;
            if (options.post_argument) postArgument = options.post_argument;
            if (typeof options.submit_callback === 'function') options.submit_callback;
        }
        var promptElement = getPromptElement(options);
        if (promptElement) // If we can get the element that will host the prompt, set it.
        ready(promptElement, options.iframeAttributes || {});
        else // If the element that will host the prompt isn't available yet, set
        // it up after the DOM finishes loading.
        asyncReady(options);
        // always clean up after yourself!
        offReady(init);
    }
    /**
   * Given the options from init(), get the iframe or iframe container that
   * should be used for the Duo Prompt. Returns `null` if nothing was found.
   */ function getPromptElement(options) {
        var result;
        if (options.iframe && options.iframeContainer) throwError("Passing both `iframe` and `iframeContainer` arguments at the same time is not allowed.");
        else if (options.iframe) {
            // If we are getting an iframe, try to get it and raise if the
            // element we find is NOT an iframe.
            result = getUserDefinedElement(options.iframe);
            validateIframe(result);
        } else if (options.iframeContainer) {
            result = getUserDefinedElement(options.iframeContainer);
            validateIframeContainer(result);
        } else result = document.getElementById('duo_iframe');
        return result;
    }
    /**
   * When given an HTMLElement, return it. When given a string, get an element
   * with that id, else return null.
   */ function getUserDefinedElement(object) {
        if (object.tagName) return object;
        else if (typeof object == 'string') return document.getElementById(object);
        return null;
    }
    /**
   * Check if the given thing is an iframe.
   */ function isIframe(element) {
        return element && element.tagName && element.tagName.toLowerCase() === 'iframe';
    }
    /**
   * Throw an error if we are given an element that is NOT an iframe.
   */ function validateIframe(element) {
        if (element && !isIframe(element)) throwError("`iframe` only accepts an iframe element or the id of an iframe. To use a non-iframe element, use the `iframeContainer` argument.");
    }
    /**
   * Throw an error if we are given an element that IS an iframe instead of an
   * element that we can insert an iframe into.
   */ function validateIframeContainer(element) {
        if (element && isIframe(element)) throwError("`iframeContainer` only accepts a non-iframe element or the id of a non-iframe. To use a non-iframe element, use the `iframeContainer` argument on Duo.init().");
    }
    /**
   * Generate the URL that goes to the Duo Prompt.
   */ function generateIframeSrc() {
        return [
            'https://',
            host,
            '/frame/web/v1/auth?tx=',
            duoSig,
            '&parent=',
            encodeURIComponent(document.location.href),
            '&v=2.8'
        ].join('');
    }
    /**
   * This function is called when a message was received from another domain
   * using the `postMessage` API.  Check that the event came from the Duo
   * service domain, and that the message is a properly formatted payload,
   * then perform the post back to the primary service.
   *
   * @param event Event object (contains origin and data)
   */ function onReceivedMessage(event) {
        if (isDuoMessage(event)) {
            if (event.data.match(DUO_OPEN_WINDOW_FORMAT)) {
                var url = event.data.substring(16);
                if (isValidUrlToOpen(url)) // Open the URL that comes after the DUO_WINDOW_OPEN token.
                window.open(url, "_self");
            } else {
                // the event came from duo, do the post back
                doPostBack(event.data);
                // always clean up after yourself!
                offMessage(onReceivedMessage);
            }
        }
    }
    /**
   * Validate that this passed in URL is one that we will actually allow to
   * be opened.
   * @param url String URL that the message poster wants to open
   * @returns {boolean} true if we allow this url to be opened in the window
   */ function isValidUrlToOpen(url) {
        if (!url) return false;
        var parser = document.createElement('a');
        parser.href = url;
        if (parser.protocol === "duotrustedendpoints:") return true;
        else if (parser.protocol !== "https:") return false;
        for(var i = 0; i < VALID_OPEN_WINDOW_DOMAINS.length; i++){
            if (parser.hostname.endsWith("." + VALID_OPEN_WINDOW_DOMAINS[i]) || parser.hostname === VALID_OPEN_WINDOW_DOMAINS[i]) return true;
        }
        return false;
    }
    /**
   * Register a callback to call ready() after the DOM has loaded.
   */ function asyncReady(options) {
        var callback = function() {
            var promptElement = getPromptElement(options);
            if (!promptElement) throwError('This page does not contain an iframe for Duo to use. Add an element like <iframe id="duo_iframe"></iframe> to this page.');
            ready(promptElement, options.iframeAttributes || {});
            // Always clean up after yourself.
            offReady(callback);
        };
        onReady(callback);
    }
    /**
   * Point the iframe at Duo, then wait for it to postMessage back to us.
   */ function ready(promptElement, iframeAttributes) {
        if (!host) {
            host = getDataAttribute(promptElement, 'host');
            if (!host) throwError("No API hostname is given for Duo to use.  Be sure to pass a `host` parameter to Duo.init, or through the `data-host` attribute on the iframe element.");
        }
        if (!duoSig || !appSig) {
            parseSigRequest(getDataAttribute(promptElement, 'sigRequest'));
            if (!duoSig || !appSig) throwError("No valid signed request is given.  Be sure to give the `sig_request` parameter to Duo.init, or use the `data-sig-request` attribute on the iframe element.");
        }
        // if postAction/Argument are defaults, see if they are specified
        // as data attributes on the iframe
        if (postAction === '') postAction = getDataAttribute(promptElement, 'postAction') || postAction;
        if (postArgument === 'sig_response') postArgument = getDataAttribute(promptElement, 'postArgument') || postArgument;
        if (isIframe(promptElement)) {
            iframe = promptElement;
            iframe.src = generateIframeSrc();
        } else {
            // If given a container to put an iframe in, clean out any children
            // child elements in case `init()` was called more than once.
            while(promptElement.firstChild)// We call `removeChild()` instead of doing `innerHTML = ""`
            // to make sure we unbind any events.
            promptElement.removeChild(promptElement.firstChild);
            iframe = document.createElement('iframe');
            // Set the src and all other attributes on the new iframe.
            iframeAttributes['src'] = generateIframeSrc();
            for(var name in iframeAttributes)iframe.setAttribute(name, iframeAttributes[name]);
            promptElement.appendChild(iframe);
        }
        // listen for the 'message' event
        onMessage(onReceivedMessage);
    }
    /**
   * We received a postMessage from Duo.  POST back to the primary service
   * with the response token, and any additional user-supplied parameters
   * given in form#duo_form.
   */ // function doPostBack(response) {
    //     // create a hidden input to contain the response token
    //     var input = document.createElement('input');
    //     input.type = 'hidden';
    //     input.name = postArgument;
    //     input.value = response + ':' + appSig;
    //     // user may supply their own form with additional inputs
    //     var form = document.getElementById('duo_form');
    //     // if the form doesn't exist, create one
    //     if (!form) {
    //         form = document.createElement('form');
    //         // insert the new form after the iframe
    //         iframe.parentElement.insertBefore(form, iframe.nextSibling);
    //     }
    //     // make sure we are actually posting to the right place
    //     form.method = 'POST';
    //     form.action = postAction;
    //     // add the response token input to the form
    //     form.appendChild(input);
    //     // away we go!
    //     if (typeof submitCallback === "function") {
    //         submitCallback.call(null, form);
    //     } else {
    //         form.submit();
    //     }
    // }
    // OKTA: Overriding their doPostBack logic because we want to submit this
    // through ajax, not a postBack
    function doPostBack(response) {
        postAction(response + ':' + appSig);
    }
    return {
        init: init,
        _onReady: onReady,
        _parseSigRequest: parseSigRequest,
        _isDuoMessage: isDuoMessage,
        _doPostBack: doPostBack
    };
});
var $d925b3b89d4ae911$export$2e2bcd8739ae039 = (0, $253746e3963664b9$export$4368d992c4eafac0).exports;




/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $332eb3a52ab859cf$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'enroll-duo duo-form',
    Model: {
        props: {
            host: 'string',
            signature: 'string',
            postAction: 'string',
            factorId: 'string',
            stateToken: 'string'
        },
        getInitOptions: function() {
            return this.doTransaction(function(transaction) {
                const factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(transaction.factors, {
                    factorType: 'web',
                    provider: 'DUO'
                });
                return factor.enroll();
            });
        },
        activate: function(signedResponse) {
            const url = this.get('postAction');
            const factorId = this.get('factorId');
            const self = this;
            const data = {
                id: factorId,
                stateToken: this.get('stateToken'),
                sig_response: signedResponse
            };
            // Note: We should be doing this in OktaAuth! Fix when it's updated.
            // We don't actually use authClient.post() here (unlike all the other cases in the
            // sign-in widget) since the endpoint is wired to accept serialized form post instead
            // of a JSON post ($.post() is different from authClient.post() in that in $.post(),
            // jquery decides the Content-Type instead of it being a JSON type). Enroll/Verify DUO
            // are the only two places where we actually do this.
            // NOTE - If we ever decide to change this, we should test this very carefully.
            return Promise.resolve((0, $b51a961f9fe28c76$export$2e2bcd8739ae039).post(url, data)).then(function() {
                return self.doTransaction(function(transaction) {
                    return transaction.poll();
                });
            }).catch(function(err) {
                self.trigger('error', self, err.xhr);
            });
        }
    },
    Form: {
        autoSave: true,
        noButtonBar: true,
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'enroll.duo.title', 'login'),
        postRender: function() {
            this.add('<iframe frameborder="0" title="' + this.title() + '"></iframe>');
            (0, $d925b3b89d4ae911$export$2e2bcd8739ae039).init({
                host: this.model.get('host'),
                sig_request: this.model.get('signature'),
                iframe: this.$('iframe').get(0),
                post_action: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(this.model.activate, this.model)
            });
        }
    },
    Footer: (0, $84975a54a18f1ea8$export$2e2bcd8739ae039),
    fetchInitialData: function() {
        const self = this;
        return this.model.getInitOptions(this.options.appState).then(function(trans) {
            const res = trans.data;
            if (!res || !res._embedded || !res._embedded.factor || !res._embedded.factor._embedded || !res._embedded.factor._embedded.activation) throw new Error('Response does not have duo activation options');
            const factor = res._embedded.factor;
            const activation = factor._embedded.activation;
            self.model.set({
                host: activation.host,
                signature: activation.signature,
                postAction: activation._links.complete.href,
                factorId: factor.id,
                stateToken: res.stateToken
            });
        });
    },
    trapAuthResponse: function() {
        if (this.options.appState.get('isMfaEnrollActivate')) return true;
    }
});















const $5708478ccbee4e8f$var$Model = {
    local: {
        factorType: 'string',
        provider: 'string'
    },
    save: function() {
        this.trigger('save');
        const factorOpt = this.pick('factorType', 'provider');
        return this.doTransaction(function(transaction) {
            const factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(transaction.factors, factorOpt);
            return factor.enroll();
        });
    }
};
const $5708478ccbee4e8f$var$Form = function() {
    return {
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'email.enroll.title', 'login'),
        noButtonBar: false,
        autoSave: true,
        save: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'email.button.send', 'login'),
        formChildren: [
            (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                View: (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                    attributes: {
                        'data-se': 'enroll-email-content'
                    },
                    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                        "compiler": [
                            8,
                            ">= 4.3.0"
                        ],
                        "main": function(container, depth0, helpers, partials, data) {
                            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                                return undefined;
                            };
                            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                                "name": "i18n",
                                "hash": {
                                    "bundle": "login",
                                    "code": "email.enroll.description"
                                },
                                "data": data,
                                "loc": {
                                    "start": {
                                        "line": 1,
                                        "column": 0
                                    },
                                    "end": {
                                        "line": 1,
                                        "column": 55
                                    }
                                }
                            }));
                        },
                        "useData": true
                    })
                })
            })
        ]
    };
};
var $5708478ccbee4e8f$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'enroll-email',
    Model: $5708478ccbee4e8f$var$Model,
    Form: $5708478ccbee4e8f$var$Form,
    Footer: (0, $84975a54a18f1ea8$export$2e2bcd8739ae039),
    initialize: function() {
        this.model.set((0, $3e490973b7383cc4$export$2e2bcd8739ae039).pick(this.options, 'factorType', 'provider'));
    }
});
















/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $0c204f6759392460$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'enroll-hotp',
    Model: function() {
        return {
            local: {
                __factorType__: [
                    'string',
                    false,
                    this.options.factorType
                ],
                __provider__: [
                    'string',
                    false,
                    this.options.provider
                ]
            }
        };
    },
    Form: {
        title: function() {
            const factors = this.options.appState.get('factors');
            const hotpFactor = factors.findWhere({
                provider: this.model.get('__provider__'),
                factorType: this.model.get('__factorType__')
            });
            return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.totp.title', 'login', [
                hotpFactor.get('factorLabel')
            ]);
        },
        noButtonBar: true,
        attributes: {
            'data-se': 'restrict-enroll'
        },
        formChildren: function() {
            const children = [
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                    View: new (0, $b717de154cd703a4$export$2e2bcd8739ae039)({
                        message: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.hotp.restricted', 'login')
                    })
                })
            ];
            return children;
        }
    },
    Footer: (0, $84975a54a18f1ea8$export$2e2bcd8739ae039)
});

















/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $09c5783bba5f3baf$var$isRSA(provider) {
    return provider === 'RSA';
}
function $09c5783bba5f3baf$var$getClassName(provider) {
    return $09c5783bba5f3baf$var$isRSA(provider) ? 'enroll-rsa' : 'enroll-onprem';
}
var $09c5783bba5f3baf$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: function() {
        return $09c5783bba5f3baf$var$getClassName(this.options.provider);
    },
    Model: function() {
        const provider = this.options.provider;
        const factors = this.options.appState.get('factors');
        const factor = factors.findWhere((0, $3e490973b7383cc4$export$2e2bcd8739ae039).pick(this.options, 'provider', 'factorType'));
        const profile = factor.get('profile');
        const credentialId = profile && profile.credentialId ? profile.credentialId : '';
        return {
            props: {
                credentialId: [
                    'string',
                    true,
                    credentialId
                ],
                passCode: [
                    'string',
                    true
                ],
                factorId: 'string'
            },
            save: function() {
                return this.doTransaction(function(transaction) {
                    const factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(transaction.factors, {
                        factorType: 'token',
                        provider: provider
                    });
                    return factor.enroll({
                        passCode: this.get('passCode'),
                        profile: {
                            credentialId: this.get('credentialId')
                        }
                    });
                });
            }
        };
    },
    Form: function() {
        const provider = this.options.provider;
        const factors = this.options.appState.get('factors');
        const factor = factors.findWhere((0, $3e490973b7383cc4$export$2e2bcd8739ae039).pick(this.options, 'provider', 'factorType'));
        const vendorName = factor.get('vendorName');
        const title = $09c5783bba5f3baf$var$isRSA(provider) ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('factor.totpHard.rsaSecurId', 'login') : vendorName;
        return {
            title: title,
            noButtonBar: true,
            autoSave: true,
            className: $09c5783bba5f3baf$var$getClassName(provider),
            initialize: function() {
                this.listenTo(this.model, 'error', (source, error)=>{
                    if (error && error.status === 409) {
                        // 409 means we are in change pin, so we should clear out answer input
                        this.$('.o-form-input-name-passCode input').val('');
                        this.$('.o-form-input-name-passCode input').trigger('change');
                        this.$('.o-form-input-name-passCode input').focus();
                    }
                });
            },
            formChildren: [
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                    label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.onprem.username.placeholder', 'login', [
                        vendorName
                    ]),
                    'label-top': true,
                    explain: (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).createInputExplain('enroll.onprem.username.tooltip', 'enroll.onprem.username.placeholder', 'login', [
                        vendorName
                    ], [
                        vendorName
                    ]),
                    'explain-top': true,
                    name: 'credentialId',
                    input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
                    type: 'text'
                }),
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                    label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.onprem.passcode.placeholder', 'login', [
                        vendorName
                    ]),
                    'label-top': true,
                    explain: (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).createInputExplain('enroll.onprem.passcode.tooltip', 'enroll.onprem.passcode.placeholder', 'login', [
                        vendorName
                    ], [
                        vendorName
                    ]),
                    'explain-top': true,
                    name: 'passCode',
                    input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
                    type: 'password'
                }),
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Toolbar({
                    noCancelButton: true,
                    save: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.verify', 'login')
                })
            ]
        };
    },
    Footer: (0, $84975a54a18f1ea8$export$2e2bcd8739ae039)
});























/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $925fe56dc05ff4ab$export$2e2bcd8739ae039 = {};
// Validate the 'username' field on the model.
$925fe56dc05ff4ab$export$2e2bcd8739ae039.validateUsername = function(model) {
    const username = model.get('username');
    if (username && username.length > 256) return {
        username: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('model.validation.field.username', 'login')
    };
};
// Validate that the field1 and field2 fields on the model are a match.
$925fe56dc05ff4ab$export$2e2bcd8739ae039.validateFieldsMatch = function(model, field1, field2, message) {
    if (model.get(field1) !== model.get(field2)) {
        const ret = {};
        ret[field2] = message;
        return ret;
    }
};
// Validate that the 'newPassword' and 'confirmPassword' fields on the model are a match.
$925fe56dc05ff4ab$export$2e2bcd8739ae039.validatePasswordMatch = function(model) {
    return $925fe56dc05ff4ab$export$2e2bcd8739ae039.validateFieldsMatch(model, 'newPassword', 'confirmPassword', (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.error.match', 'login'));
};




/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $e391b3f17ddf99ff$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'enroll-password',
    Model: {
        props: {
            password: [
                'string',
                true
            ],
            confirmPassword: [
                'string',
                true
            ]
        },
        validate: function() {
            return (0, $925fe56dc05ff4ab$export$2e2bcd8739ae039).validateFieldsMatch(this, 'password', 'confirmPassword', (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.enroll.error.match', 'login'));
        },
        save: function() {
            return this.doTransaction(function(transaction) {
                const factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(transaction.factors, {
                    factorType: 'password',
                    provider: 'OKTA'
                });
                return factor.enroll({
                    profile: {
                        password: this.get('password')
                    }
                });
            });
        }
    },
    Form: {
        autoSave: true,
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'enroll.password.setup', 'login'),
        inputs: function() {
            return [
                {
                    label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.password.placeholder', 'login'),
                    'label-top': true,
                    className: 'o-form-fieldset o-form-label-top auth-passcode',
                    name: 'password',
                    input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
                    type: 'password'
                },
                {
                    label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.confirmPassword.placeholder', 'login'),
                    'label-top': true,
                    className: 'o-form-fieldset o-form-label-top auth-passcode',
                    name: 'confirmPassword',
                    input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
                    type: 'password'
                }
            ];
        }
    },
    Footer: (0, $84975a54a18f1ea8$export$2e2bcd8739ae039)
});

















/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $23b0da624770d3a4$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'enroll-question',
    Model: {
        props: {
            question: 'string',
            answer: [
                'string',
                true
            ]
        },
        local: {
            securityQuestions: 'object'
        },
        save: function() {
            return this.doTransaction(function(transaction) {
                const factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(transaction.factors, {
                    factorType: 'question',
                    provider: 'OKTA'
                });
                return factor.enroll({
                    profile: {
                        question: this.get('question'),
                        answer: this.get('answer')
                    }
                });
            });
        }
    },
    Form: {
        autoSave: true,
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'enroll.securityQuestion.setup', 'login'),
        inputs: function() {
            return [
                {
                    label: false,
                    'label-top': true,
                    name: 'question',
                    type: 'select',
                    wide: true,
                    options: function() {
                        return this.model.get('securityQuestions');
                    },
                    params: {
                        searchThreshold: 25
                    }
                },
                {
                    label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.answer.placeholder', 'login'),
                    'label-top': true,
                    explain: (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).createInputExplain('mfa.challenge.answer.tooltip', 'mfa.challenge.answer.placeholder', 'login'),
                    'explain-top': true,
                    className: 'o-form-fieldset o-form-label-top auth-passcode',
                    name: 'answer',
                    input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
                    type: 'text'
                }
            ];
        }
    },
    Footer: (0, $84975a54a18f1ea8$export$2e2bcd8739ae039),
    fetchInitialData: function() {
        const self = this;
        return this.model.manageTransaction(function(transaction) {
            const factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(transaction.factors, {
                factorType: 'question',
                provider: 'OKTA'
            });
            return factor.questions();
        }).then(function(questionsRes) {
            const questions = {};
            (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(questionsRes, function(question) {
                questions[question.question] = (0, $020a58caf88b7504$export$2e2bcd8739ae039).getSecurityQuestionLabel(question);
            });
            self.model.set('securityQuestions', questions);
        });
    }
});

















/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $93a5b7168c29c446$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'enroll-symantec',
    Model: {
        props: {
            credentialId: [
                'string',
                true
            ],
            passCode: [
                'string',
                true
            ],
            nextPassCode: [
                'string',
                true
            ],
            factorId: 'string'
        },
        save: function() {
            return this.doTransaction(function(transaction) {
                const factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(transaction.factors, {
                    factorType: 'token',
                    provider: 'SYMANTEC'
                });
                return factor.enroll({
                    passCode: this.get('passCode'),
                    nextPassCode: this.get('nextPassCode'),
                    profile: {
                        credentialId: this.get('credentialId')
                    }
                });
            });
        }
    },
    Form: {
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'factor.totpHard.symantecVip', 'login'),
        subtitle: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'enroll.symantecVip.subtitle', 'login'),
        noButtonBar: true,
        autoSave: true,
        className: 'enroll-symantec',
        formChildren: function() {
            return [
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                    label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.symantecVip.credentialId.placeholder', 'login'),
                    'label-top': true,
                    explain: (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).createInputExplain('enroll.symantecVip.credentialId.tooltip', 'enroll.symantecVip.credentialId.placeholder', 'login'),
                    'explain-top': true,
                    name: 'credentialId',
                    input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
                    type: 'text'
                }),
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                    label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.symantecVip.passcode1.placeholder', 'login'),
                    'label-top': true,
                    explain: (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).createInputExplain('enroll.symantecVip.passcode1.tooltip', 'enroll.symantecVip.passcode1.placeholder', 'login'),
                    'explain-top': true,
                    name: 'passCode',
                    input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
                    type: 'text'
                }),
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                    label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.symantecVip.passcode2.placeholder', 'login'),
                    'label-top': true,
                    explain: (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).createInputExplain('enroll.symantecVip.passcode2.tooltip', 'enroll.symantecVip.passcode2.placeholder', 'login'),
                    'explain-top': true,
                    name: 'nextPassCode',
                    input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
                    type: 'text'
                }),
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Toolbar({
                    noCancelButton: true,
                    save: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.verify', 'login')
                })
            ];
        }
    },
    Footer: (0, $84975a54a18f1ea8$export$2e2bcd8739ae039)
});















/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $b657833d9b14e0f2$export$2e2bcd8739ae039 = {
    OKTA: {
        APPLE: 'https://itunes.apple.com/us/app/okta-verify/id490179405',
        ANDROID: 'https://play.google.com/store/apps/details?id=com.okta.android.auth'
    },
    GOOGLE: {
        APPLE: 'https://itunes.apple.com/us/app/google-authenticator/id388497605',
        ANDROID: 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2'
    },
    STORE: {
        APPLE: 'App Store',
        ANDROID: 'Google Play Store'
    }
};



const $2304fafdb9bf0140$var$showWhenDeviceTypeSelected = {
    __deviceType__: function(val) {
        return val !== undefined;
    }
};
const $2304fafdb9bf0140$var$EnrollTotpControllerAppDownloadInstructionsView = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    attributes: {
        'data-se': 'app-download-instructions'
    },
    className: 'app-download-instructions',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<span class=\"app-logo " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "appIcon") || (depth0 != null ? lookupProperty(depth0, "appIcon") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "appIcon",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 22
                    },
                    "end": {
                        "line": 1,
                        "column": 33
                    }
                }
            }) : helper)) + "\"></span><p class=\"instructions\">" + ((stack1 = (helper = (helper = lookupProperty(helpers, "appStoreLinkText") || (depth0 != null ? lookupProperty(depth0, "appStoreLinkText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "appStoreLinkText",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 66
                    },
                    "end": {
                        "line": 1,
                        "column": 88
                    }
                }
            }) : helper)) != null ? stack1 : "") + "</p>";
        },
        "useData": true
    }),
    initialize: function() {
        this.listenTo(this.model, 'change:__deviceType__', this.render);
    },
    postRender: function() {
        const link = this.$el.find('.instructions a');
        if (link.length) {
            link[0].setAttribute('target', '_blank');
            link[0].setAttribute('rel', 'noreferer noopener');
        }
    },
    getTemplateData: function() {
        let appStoreLink;
        let appIcon;
        let appStoreName;
        const factorName = (0, $020a58caf88b7504$export$2e2bcd8739ae039).getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
        appStoreName = (0, $b657833d9b14e0f2$export$2e2bcd8739ae039).STORE[this.model.get('__deviceType__')];
        if (this.model.get('__provider__') === 'GOOGLE') {
            appStoreLink = (0, $b657833d9b14e0f2$export$2e2bcd8739ae039).GOOGLE[this.model.get('__deviceType__')];
            appIcon = 'google-auth-38';
        } else {
            appStoreLink = (0, $b657833d9b14e0f2$export$2e2bcd8739ae039).OKTA[this.model.get('__deviceType__')];
            appIcon = 'okta-verify-download-icon';
        }
        const appStoreLinkText = appStoreName ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.totp.downloadApp', 'login', [
            appStoreLink,
            factorName,
            appStoreName
        ]) : null;
        return {
            appStoreLinkText: appStoreLinkText,
            appIcon: appIcon
        };
    }
});
const $2304fafdb9bf0140$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'enroll-totp',
    Model: function() {
        return {
            local: {
                __deviceType__: 'string',
                __factorType__: [
                    'string',
                    false,
                    this.options.factorType
                ],
                __provider__: [
                    'string',
                    false,
                    this.options.provider
                ]
            },
            save: function() {
                return this.doTransaction(function(transaction) {
                    const factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(transaction.factors, {
                        factorType: this.get('__factorType__'),
                        provider: this.get('__provider__')
                    });
                    return factor.enroll();
                });
            }
        };
    },
    Form: {
        title: function() {
            const factorName = (0, $020a58caf88b7504$export$2e2bcd8739ae039).getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
            return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.totp.title', 'login', [
                factorName
            ]);
        },
        noButtonBar: true,
        attributes: {
            'data-se': 'step-device-type'
        },
        formChildren: function() {
            const inputOptions = {
                APPLE: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('iphone', 'login'),
                ANDROID: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('android', 'login')
            };
            const children = [
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                    name: '__deviceType__',
                    type: 'radio',
                    options: inputOptions,
                    group: true,
                    label: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'enroll.totp.selectDevice', 'login')
                }),
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Divider({
                    showWhen: $2304fafdb9bf0140$var$showWhenDeviceTypeSelected
                }),
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                    View: $2304fafdb9bf0140$var$EnrollTotpControllerAppDownloadInstructionsView,
                    showWhen: $2304fafdb9bf0140$var$showWhenDeviceTypeSelected
                }),
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Button({
                    title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oform.next', 'login'),
                    attributes: {
                        'data-type': 'save'
                    },
                    className: 'button button-primary default-custom-button',
                    click: function() {
                        this.model.save();
                    },
                    showWhen: $2304fafdb9bf0140$var$showWhenDeviceTypeSelected
                })
            ];
            return children;
        }
    },
    Footer: (0, $84975a54a18f1ea8$export$2e2bcd8739ae039)
});













//Copyright 2014-2015 Google Inc. All rights reserved.
//Use of this source code is governed by a BSD-style
//license that can be found in the LICENSE file or at
//https://developers.google.com/open-source/licenses/bsd
/**
 * @fileoverview The U2F api.
 */ 'use strict';
(function() {
    var isChrome = 'chrome' in window && window.navigator.userAgent.indexOf('Edge') < 0;
    if ('u2f' in window || !isChrome) return;
    /** Namespace for the U2F api.
   * @type {Object}
   */ var u2f = window.u2f = {};
    /**
   * FIDO U2F Javascript API Version
   * @number
   */ var js_api_version;
    /**
   * The U2F extension id
   * @const {string}
   */ // The Chrome packaged app extension ID.
    // Uncomment this if you want to deploy a server instance that uses
    // the package Chrome app and does not require installing the U2F Chrome extension.
    u2f.EXTENSION_ID = 'kmendfapggjehodndflmmgagdbamhnfd';
    // The U2F Chrome extension ID.
    // Uncomment this if you want to deploy a server instance that uses
    // the U2F Chrome extension to authenticate.
    // u2f.EXTENSION_ID = 'pfboblefjcgdjicmnffhdgionmgcdmne';
    /**
   * Message types for messsages to/from the extension
   * @const
   * @enum {string}
   */ u2f.MessageTypes = {
        'U2F_REGISTER_REQUEST': 'u2f_register_request',
        'U2F_REGISTER_RESPONSE': 'u2f_register_response',
        'U2F_SIGN_REQUEST': 'u2f_sign_request',
        'U2F_SIGN_RESPONSE': 'u2f_sign_response',
        'U2F_GET_API_VERSION_REQUEST': 'u2f_get_api_version_request',
        'U2F_GET_API_VERSION_RESPONSE': 'u2f_get_api_version_response'
    };
    /**
   * Response status codes
   * @const
   * @enum {number}
   */ u2f.ErrorCodes = {
        'OK': 0,
        'OTHER_ERROR': 1,
        'BAD_REQUEST': 2,
        'CONFIGURATION_UNSUPPORTED': 3,
        'DEVICE_INELIGIBLE': 4,
        'TIMEOUT': 5
    };
    /**
   * A message for registration requests
   * @typedef {{
   *   type: u2f.MessageTypes,
   *   appId: ?string,
   *   timeoutSeconds: ?number,
   *   requestId: ?number
   * }}
   */ u2f.U2fRequest;
    /**
   * A message for registration responses
   * @typedef {{
   *   type: u2f.MessageTypes,
   *   responseData: (u2f.Error | u2f.RegisterResponse | u2f.SignResponse),
   *   requestId: ?number
   * }}
   */ u2f.U2fResponse;
    /**
   * An error object for responses
   * @typedef {{
   *   errorCode: u2f.ErrorCodes,
   *   errorMessage: ?string
   * }}
   */ u2f.Error;
    /**
   * Data object for a single sign request.
   * @typedef {enum {BLUETOOTH_RADIO, BLUETOOTH_LOW_ENERGY, USB, NFC}}
   */ u2f.Transport;
    /**
   * Data object for a single sign request.
   * @typedef {Array<u2f.Transport>}
   */ u2f.Transports;
    /**
   * Data object for a single sign request.
   * @typedef {{
   *   version: string,
   *   challenge: string,
   *   keyHandle: string,
   *   appId: string
   * }}
   */ u2f.SignRequest;
    /**
   * Data object for a sign response.
   * @typedef {{
   *   keyHandle: string,
   *   signatureData: string,
   *   clientData: string
   * }}
   */ u2f.SignResponse;
    /**
   * Data object for a registration request.
   * @typedef {{
   *   version: string,
   *   challenge: string
   * }}
   */ u2f.RegisterRequest;
    /**
   * Data object for a registration response.
   * @typedef {{
   *   version: string,
   *   keyHandle: string,
   *   transports: Transports,
   *   appId: string
   * }}
   */ u2f.RegisterResponse;
    /**
   * Data object for a registered key.
   * @typedef {{
   *   version: string,
   *   keyHandle: string,
   *   transports: ?Transports,
   *   appId: ?string
   * }}
   */ u2f.RegisteredKey;
    /**
   * Data object for a get API register response.
   * @typedef {{
   *   js_api_version: number
   * }}
   */ u2f.GetJsApiVersionResponse;
    //Low level MessagePort API support
    /**
   * Sets up a MessagePort to the U2F extension using the
   * available mechanisms.
   * @param {function((MessagePort|u2f.WrappedChromeRuntimePort_))} callback
   */ u2f.getMessagePort = function(callback) {
        if (typeof chrome != 'undefined' && chrome.runtime) {
            // The actual message here does not matter, but we need to get a reply
            // for the callback to run. Thus, send an empty signature request
            // in order to get a failure response.
            var msg = {
                type: u2f.MessageTypes.U2F_SIGN_REQUEST,
                signRequests: []
            };
            chrome.runtime.sendMessage(u2f.EXTENSION_ID, msg, function() {
                if (!chrome.runtime.lastError) // We are on a whitelisted origin and can talk directly
                // with the extension.
                u2f.getChromeRuntimePort_(callback);
                else // chrome.runtime was available, but we couldn't message
                // the extension directly, use iframe
                u2f.getIframePort_(callback);
            });
        } else if (u2f.isAndroidChrome_()) u2f.getAuthenticatorPort_(callback);
        else if (u2f.isIosChrome_()) u2f.getIosPort_(callback);
        else // chrome.runtime was not available at all, which is normal
        // when this origin doesn't have access to any extensions.
        u2f.getIframePort_(callback);
    };
    /**
   * Detect chrome running on android based on the browser's useragent.
   * @private
   */ u2f.isAndroidChrome_ = function() {
        var userAgent = navigator.userAgent;
        return userAgent.indexOf('Chrome') != -1 && userAgent.indexOf('Android') != -1;
    };
    /**
   * Detect chrome running on iOS based on the browser's platform.
   * @private
   */ u2f.isIosChrome_ = function() {
        return [
            "iPhone",
            "iPad",
            "iPod"
        ].indexOf(navigator.platform) > -1;
    };
    /**
   * Connects directly to the extension via chrome.runtime.connect.
   * @param {function(u2f.WrappedChromeRuntimePort_)} callback
   * @private
   */ u2f.getChromeRuntimePort_ = function(callback) {
        var port = chrome.runtime.connect(u2f.EXTENSION_ID, {
            'includeTlsChannelId': true
        });
        setTimeout(function() {
            callback(new u2f.WrappedChromeRuntimePort_(port));
        }, 0);
    };
    /**
   * Return a 'port' abstraction to the Authenticator app.
   * @param {function(u2f.WrappedAuthenticatorPort_)} callback
   * @private
   */ u2f.getAuthenticatorPort_ = function(callback) {
        setTimeout(function() {
            callback(new u2f.WrappedAuthenticatorPort_());
        }, 0);
    };
    /**
   * Return a 'port' abstraction to the iOS client app.
   * @param {function(u2f.WrappedIosPort_)} callback
   * @private
   */ u2f.getIosPort_ = function(callback) {
        setTimeout(function() {
            callback(new u2f.WrappedIosPort_());
        }, 0);
    };
    /**
   * A wrapper for chrome.runtime.Port that is compatible with MessagePort.
   * @param {Port} port
   * @constructor
   * @private
   */ u2f.WrappedChromeRuntimePort_ = function(port) {
        this.port_ = port;
    };
    /**
   * Format and return a sign request compliant with the JS API version supported by the extension.
   * @param {Array<u2f.SignRequest>} signRequests
   * @param {number} timeoutSeconds
   * @param {number} reqId
   * @return {Object}
   */ u2f.formatSignRequest_ = function(appId, challenge, registeredKeys, timeoutSeconds, reqId) {
        if (js_api_version === undefined || js_api_version < 1.1) {
            // Adapt request to the 1.0 JS API
            var signRequests = [];
            for(var i = 0; i < registeredKeys.length; i++)signRequests[i] = {
                version: registeredKeys[i].version,
                challenge: challenge,
                keyHandle: registeredKeys[i].keyHandle,
                appId: appId
            };
            return {
                type: u2f.MessageTypes.U2F_SIGN_REQUEST,
                signRequests: signRequests,
                timeoutSeconds: timeoutSeconds,
                requestId: reqId
            };
        }
        // JS 1.1 API
        return {
            type: u2f.MessageTypes.U2F_SIGN_REQUEST,
            appId: appId,
            challenge: challenge,
            registeredKeys: registeredKeys,
            timeoutSeconds: timeoutSeconds,
            requestId: reqId
        };
    };
    /**
   * Format and return a register request compliant with the JS API version supported by the extension..
   * @param {Array<u2f.SignRequest>} signRequests
   * @param {Array<u2f.RegisterRequest>} signRequests
   * @param {number} timeoutSeconds
   * @param {number} reqId
   * @return {Object}
   */ u2f.formatRegisterRequest_ = function(appId, registeredKeys, registerRequests, timeoutSeconds, reqId) {
        if (js_api_version === undefined || js_api_version < 1.1) {
            // Adapt request to the 1.0 JS API
            for(var i = 0; i < registerRequests.length; i++)registerRequests[i].appId = appId;
            var signRequests = [];
            for(var i = 0; i < registeredKeys.length; i++)signRequests[i] = {
                version: registeredKeys[i].version,
                challenge: registerRequests[0],
                keyHandle: registeredKeys[i].keyHandle,
                appId: appId
            };
            return {
                type: u2f.MessageTypes.U2F_REGISTER_REQUEST,
                signRequests: signRequests,
                registerRequests: registerRequests,
                timeoutSeconds: timeoutSeconds,
                requestId: reqId
            };
        }
        // JS 1.1 API
        return {
            type: u2f.MessageTypes.U2F_REGISTER_REQUEST,
            appId: appId,
            registerRequests: registerRequests,
            registeredKeys: registeredKeys,
            timeoutSeconds: timeoutSeconds,
            requestId: reqId
        };
    };
    /**
   * Posts a message on the underlying channel.
   * @param {Object} message
   */ u2f.WrappedChromeRuntimePort_.prototype.postMessage = function(message) {
        this.port_.postMessage(message);
    };
    /**
   * Emulates the HTML 5 addEventListener interface. Works only for the
   * onmessage event, which is hooked up to the chrome.runtime.Port.onMessage.
   * @param {string} eventName
   * @param {function({data: Object})} handler
   */ u2f.WrappedChromeRuntimePort_.prototype.addEventListener = function(eventName, handler) {
        var name = eventName.toLowerCase();
        if (name == 'message' || name == 'onmessage') this.port_.onMessage.addListener(function(message) {
            // Emulate a minimal MessageEvent object
            handler({
                'data': message
            });
        });
        else console.error('WrappedChromeRuntimePort only supports onMessage');
    };
    /**
   * Wrap the Authenticator app with a MessagePort interface.
   * @constructor
   * @private
   */ u2f.WrappedAuthenticatorPort_ = function() {
        this.requestId_ = -1;
        this.requestObject_ = null;
    };
    /**
   * Launch the Authenticator intent.
   * @param {Object} message
   */ u2f.WrappedAuthenticatorPort_.prototype.postMessage = function(message) {
        var intentUrl = u2f.WrappedAuthenticatorPort_.INTENT_URL_BASE_ + ';S.request=' + encodeURIComponent(JSON.stringify(message)) + ';end';
        document.location = intentUrl;
    };
    /**
   * Tells what type of port this is.
   * @return {String} port type
   */ u2f.WrappedAuthenticatorPort_.prototype.getPortType = function() {
        return "WrappedAuthenticatorPort_";
    };
    /**
   * Emulates the HTML 5 addEventListener interface.
   * @param {string} eventName
   * @param {function({data: Object})} handler
   */ u2f.WrappedAuthenticatorPort_.prototype.addEventListener = function(eventName, handler) {
        var name = eventName.toLowerCase();
        if (name == 'message') {
            var self = this;
            /* Register a callback to that executes when
       * chrome injects the response. */ window.addEventListener('message', self.onRequestUpdate_.bind(self, handler), false);
        } else console.error('WrappedAuthenticatorPort only supports message');
    };
    /**
   * Callback invoked  when a response is received from the Authenticator.
   * @param function({data: Object}) callback
   * @param {Object} message message Object
   */ u2f.WrappedAuthenticatorPort_.prototype.onRequestUpdate_ = function(callback, message) {
        var messageObject = JSON.parse(message.data);
        var intentUrl = messageObject['intentURL'];
        var errorCode = messageObject['errorCode'];
        var responseObject = null;
        if (messageObject.hasOwnProperty('data')) responseObject = /** @type {Object} */ JSON.parse(messageObject['data']);
        callback({
            'data': responseObject
        });
    };
    /**
   * Base URL for intents to Authenticator.
   * @const
   * @private
   */ u2f.WrappedAuthenticatorPort_.INTENT_URL_BASE_ = 'intent:#Intent;action=com.google.android.apps.authenticator.AUTHENTICATE';
    /**
   * Wrap the iOS client app with a MessagePort interface.
   * @constructor
   * @private
   */ u2f.WrappedIosPort_ = function() {};
    /**
   * Launch the iOS client app request
   * @param {Object} message
   */ u2f.WrappedIosPort_.prototype.postMessage = function(message) {
        var str = JSON.stringify(message);
        var url = "u2f://auth?" + encodeURI(str);
        location.replace(url);
    };
    /**
   * Tells what type of port this is.
   * @return {String} port type
   */ u2f.WrappedIosPort_.prototype.getPortType = function() {
        return "WrappedIosPort_";
    };
    /**
   * Emulates the HTML 5 addEventListener interface.
   * @param {string} eventName
   * @param {function({data: Object})} handler
   */ u2f.WrappedIosPort_.prototype.addEventListener = function(eventName, handler) {
        var name = eventName.toLowerCase();
        if (name !== 'message') console.error('WrappedIosPort only supports message');
    };
    /**
   * Sets up an embedded trampoline iframe, sourced from the extension.
   * @param {function(MessagePort)} callback
   * @private
   */ u2f.getIframePort_ = function(callback) {
        // Create the iframe
        var iframeOrigin = 'chrome-extension://' + u2f.EXTENSION_ID;
        var iframe = document.createElement('iframe');
        iframe.src = iframeOrigin + '/u2f-comms.html';
        iframe.setAttribute('style', 'display:none');
        document.body.appendChild(iframe);
        var channel = new MessageChannel();
        var ready = function(message) {
            if (message.data == 'ready') {
                channel.port1.removeEventListener('message', ready);
                callback(channel.port1);
            } else console.error('First event on iframe port was not "ready"');
        };
        channel.port1.addEventListener('message', ready);
        channel.port1.start();
        iframe.addEventListener('load', function() {
            // Deliver the port to the iframe and initialize
            iframe.contentWindow.postMessage('init', iframeOrigin, [
                channel.port2
            ]);
        });
    };
    //High-level JS API
    /**
   * Default extension response timeout in seconds.
   * @const
   */ u2f.EXTENSION_TIMEOUT_SEC = 30;
    /**
   * A singleton instance for a MessagePort to the extension.
   * @type {MessagePort|u2f.WrappedChromeRuntimePort_}
   * @private
   */ u2f.port_ = null;
    /**
   * Callbacks waiting for a port
   * @type {Array<function((MessagePort|u2f.WrappedChromeRuntimePort_))>}
   * @private
   */ u2f.waitingForPort_ = [];
    /**
   * A counter for requestIds.
   * @type {number}
   * @private
   */ u2f.reqCounter_ = 0;
    /**
   * A map from requestIds to client callbacks
   * @type {Object.<number,(function((u2f.Error|u2f.RegisterResponse))
   *                       |function((u2f.Error|u2f.SignResponse)))>}
   * @private
   */ u2f.callbackMap_ = {};
    /**
   * Creates or retrieves the MessagePort singleton to use.
   * @param {function((MessagePort|u2f.WrappedChromeRuntimePort_))} callback
   * @private
   */ u2f.getPortSingleton_ = function(callback) {
        if (u2f.port_) callback(u2f.port_);
        else {
            if (u2f.waitingForPort_.length == 0) u2f.getMessagePort(function(port) {
                u2f.port_ = port;
                u2f.port_.addEventListener('message', /** @type {function(Event)} */ u2f.responseHandler_);
                // Careful, here be async callbacks. Maybe.
                while(u2f.waitingForPort_.length)u2f.waitingForPort_.shift()(u2f.port_);
            });
            u2f.waitingForPort_.push(callback);
        }
    };
    /**
   * Handles response messages from the extension.
   * @param {MessageEvent.<u2f.Response>} message
   * @private
   */ u2f.responseHandler_ = function(message) {
        var response = message.data;
        var reqId = response['requestId'];
        if (!reqId || !u2f.callbackMap_[reqId]) {
            console.error('Unknown or missing requestId in response.');
            return;
        }
        var cb = u2f.callbackMap_[reqId];
        delete u2f.callbackMap_[reqId];
        cb(response['responseData']);
    };
    /**
   * Dispatches an array of sign requests to available U2F tokens.
   * If the JS API version supported by the extension is unknown, it first sends a
   * message to the extension to find out the supported API version and then it sends
   * the sign request.
   * @param {string=} appId
   * @param {string=} challenge
   * @param {Array<u2f.RegisteredKey>} registeredKeys
   * @param {function((u2f.Error|u2f.SignResponse))} callback
   * @param {number=} opt_timeoutSeconds
   */ u2f.sign = function(appId, challenge, registeredKeys, callback, opt_timeoutSeconds) {
        if (js_api_version === undefined) // Send a message to get the extension to JS API version, then send the actual sign request.
        u2f.getApiVersion(function(response) {
            js_api_version = response['js_api_version'] === undefined ? 0 : response['js_api_version'];
            console.log("Extension JS API Version: ", js_api_version);
            u2f.sendSignRequest(appId, challenge, registeredKeys, callback, opt_timeoutSeconds);
        });
        else // We know the JS API version. Send the actual sign request in the supported API version.
        u2f.sendSignRequest(appId, challenge, registeredKeys, callback, opt_timeoutSeconds);
    };
    /**
   * Dispatches an array of sign requests to available U2F tokens.
   * @param {string=} appId
   * @param {string=} challenge
   * @param {Array<u2f.RegisteredKey>} registeredKeys
   * @param {function((u2f.Error|u2f.SignResponse))} callback
   * @param {number=} opt_timeoutSeconds
   */ u2f.sendSignRequest = function(appId, challenge, registeredKeys, callback, opt_timeoutSeconds) {
        u2f.getPortSingleton_(function(port) {
            var reqId = ++u2f.reqCounter_;
            u2f.callbackMap_[reqId] = callback;
            var timeoutSeconds = typeof opt_timeoutSeconds !== 'undefined' ? opt_timeoutSeconds : u2f.EXTENSION_TIMEOUT_SEC;
            var req = u2f.formatSignRequest_(appId, challenge, registeredKeys, timeoutSeconds, reqId);
            port.postMessage(req);
        });
    };
    /**
   * Dispatches register requests to available U2F tokens. An array of sign
   * requests identifies already registered tokens.
   * If the JS API version supported by the extension is unknown, it first sends a
   * message to the extension to find out the supported API version and then it sends
   * the register request.
   * @param {string=} appId
   * @param {Array<u2f.RegisterRequest>} registerRequests
   * @param {Array<u2f.RegisteredKey>} registeredKeys
   * @param {function((u2f.Error|u2f.RegisterResponse))} callback
   * @param {number=} opt_timeoutSeconds
   */ u2f.register = function(appId, registerRequests, registeredKeys, callback, opt_timeoutSeconds) {
        if (js_api_version === undefined) // Send a message to get the extension to JS API version, then send the actual register request.
        u2f.getApiVersion(function(response) {
            js_api_version = response['js_api_version'] === undefined ? 0 : response['js_api_version'];
            console.log("Extension JS API Version: ", js_api_version);
            u2f.sendRegisterRequest(appId, registerRequests, registeredKeys, callback, opt_timeoutSeconds);
        });
        else // We know the JS API version. Send the actual register request in the supported API version.
        u2f.sendRegisterRequest(appId, registerRequests, registeredKeys, callback, opt_timeoutSeconds);
    };
    /**
   * Dispatches register requests to available U2F tokens. An array of sign
   * requests identifies already registered tokens.
   * @param {string=} appId
   * @param {Array<u2f.RegisterRequest>} registerRequests
   * @param {Array<u2f.RegisteredKey>} registeredKeys
   * @param {function((u2f.Error|u2f.RegisterResponse))} callback
   * @param {number=} opt_timeoutSeconds
   */ u2f.sendRegisterRequest = function(appId, registerRequests, registeredKeys, callback, opt_timeoutSeconds) {
        u2f.getPortSingleton_(function(port) {
            var reqId = ++u2f.reqCounter_;
            u2f.callbackMap_[reqId] = callback;
            var timeoutSeconds = typeof opt_timeoutSeconds !== 'undefined' ? opt_timeoutSeconds : u2f.EXTENSION_TIMEOUT_SEC;
            var req = u2f.formatRegisterRequest_(appId, registeredKeys, registerRequests, timeoutSeconds, reqId);
            port.postMessage(req);
        });
    };
    /**
   * Dispatches a message to the extension to find out the supported
   * JS API version.
   * If the user is on a mobile phone and is thus using Google Authenticator instead
   * of the Chrome extension, don't send the request and simply return 0.
   * @param {function((u2f.Error|u2f.GetJsApiVersionResponse))} callback
   * @param {number=} opt_timeoutSeconds
   */ u2f.getApiVersion = function(callback, opt_timeoutSeconds) {
        u2f.getPortSingleton_(function(port) {
            // If we are using Android Google Authenticator or iOS client app,
            // do not fire an intent to ask which JS API version to use.
            if (port.getPortType) {
                var apiVersion;
                switch(port.getPortType()){
                    case 'WrappedIosPort_':
                    case 'WrappedAuthenticatorPort_':
                        apiVersion = 1.1;
                        break;
                    default:
                        apiVersion = 0;
                        break;
                }
                callback({
                    'js_api_version': apiVersion
                });
                return;
            }
            var reqId = ++u2f.reqCounter_;
            u2f.callbackMap_[reqId] = callback;
            var req = {
                type: u2f.MessageTypes.U2F_GET_API_VERSION_REQUEST,
                timeoutSeconds: typeof opt_timeoutSeconds !== 'undefined' ? opt_timeoutSeconds : u2f.EXTENSION_TIMEOUT_SEC,
                requestId: reqId
            };
            port.postMessage(req);
        });
    };
})();




/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $f16de62271c4c5b1$export$2e2bcd8739ae039 = {};
$f16de62271c4c5b1$export$2e2bcd8739ae039.getU2fEnrollErrorMessageKeyByCode = function(errorCode) {
    switch(errorCode){
        default:
        case 1:
            return 'u2f.error.other';
        case 2:
        case 3:
            return 'u2f.error.badRequest';
        case 4:
            return 'u2f.error.unsupported';
        case 5:
            return 'u2f.error.timeout';
    }
};
$f16de62271c4c5b1$export$2e2bcd8739ae039.getU2fVerifyErrorMessageKeyByCode = function(errorCode, isOneFactor) {
    switch(errorCode){
        case 1:
            // OTHER_ERROR
            return isOneFactor ? 'u2f.error.other.oneFactor' : 'u2f.error.other';
        case 2:
        case 3:
            // CONFIGURATION_UNSUPPORTED
            return isOneFactor ? 'u2f.error.badRequest.oneFactor' : 'u2f.error.badRequest';
        case 4:
            // DEVICE_INELIGIBLE
            return isOneFactor ? 'u2f.error.unsupported.oneFactor' : 'u2f.error.unsupported';
        case 5:
            // TIMEOUT
            return 'u2f.error.timeout';
    }
};
$f16de62271c4c5b1$export$2e2bcd8739ae039.getU2fEnrollErrorMessageByCode = function(errorCode) {
    return (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)($f16de62271c4c5b1$export$2e2bcd8739ae039.getU2fEnrollErrorMessageKeyByCode(errorCode), 'login');
};
$f16de62271c4c5b1$export$2e2bcd8739ae039.getU2fVerifyErrorMessageByCode = function(errorCode, isOneFactor) {
    return (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)($f16de62271c4c5b1$export$2e2bcd8739ae039.getU2fVerifyErrorMessageKeyByCode(errorCode, isOneFactor), 'login');
};
$f16de62271c4c5b1$export$2e2bcd8739ae039.getU2fVersion = function() {
    return 'U2F_V2';
};
$f16de62271c4c5b1$export$2e2bcd8739ae039.isU2fAvailable = function() {
    return Object.prototype.hasOwnProperty.call(window, 'u2f');
};






var $c3339c1f7ae4eb34$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'enroll-u2f',
    Model: {
        local: {
            __enrolled__: 'boolean'
        },
        save: function() {
            this.trigger('request');
            if (this.get('__enrolled__')) return this.activate();
            return this.doTransaction(function(transaction) {
                const factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(transaction.factors, {
                    factorType: 'u2f',
                    provider: 'FIDO'
                });
                return factor.enroll();
            });
        },
        activate: function() {
            this.set('__enrolled__', true);
            this.trigger('errors:clear');
            return this.doTransaction(function(transaction) {
                const activation = transaction.factor.activation;
                const appId = activation.appId;
                const registerRequests = [
                    {
                        version: (0, $f16de62271c4c5b1$export$2e2bcd8739ae039).getU2fVersion(),
                        challenge: activation.nonce
                    }
                ];
                const self = this;
                const deferred = (0, $6d3dd6c38b8802c0$export$e673efccd97e4223)();
                u2f.register(appId, registerRequests, [], function(data) {
                    self.trigger('errors:clear');
                    if (data.errorCode && data.errorCode !== 0) deferred.reject(new (0, $3fe6932680e7ea64$export$846acd7e1702fb3f)({
                        xhr: {
                            responseJSON: {
                                errorSummary: (0, $f16de62271c4c5b1$export$2e2bcd8739ae039).getU2fEnrollErrorMessageByCode(data.errorCode)
                            }
                        }
                    }));
                    else deferred.resolve(transaction.activate({
                        registrationData: data.registrationData,
                        version: data.version,
                        challenge: data.challenge,
                        clientData: data.clientData
                    }));
                });
                return deferred.promise;
            }).catch(()=>{});
        }
    },
    Form: {
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'enroll.u2f.title', 'login'),
        save: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'enroll.u2f.save', 'login'),
        noCancelButton: true,
        hasSavingState: false,
        autoSave: true,
        className: 'enroll-u2f-form',
        noButtonBar: function() {
            return !(0, $f16de62271c4c5b1$export$2e2bcd8739ae039).isU2fAvailable();
        },
        modelEvents: {
            request: '_startEnrollment',
            error: '_stopEnrollment'
        },
        formChildren: function() {
            const result = [];
            if (!(0, $f16de62271c4c5b1$export$2e2bcd8739ae039).isU2fAvailable()) {
                let errorMessageKey = 'u2f.error.factorNotSupported';
                if (this.options.appState.get('factors').length === 1) errorMessageKey = 'u2f.error.factorNotSupported.oneFactor';
                result.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                    View: new (0, $b717de154cd703a4$export$2e2bcd8739ae039)({
                        message: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(errorMessageKey, 'login')
                    })
                }, {
                    selector: '.o-form-error-container'
                }));
            } else {
                //There is html in enroll.u2f.general2 in our properties file, reason why is unescaped
                result.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                    View: (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                        template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                            "compiler": [
                                8,
                                ">= 4.3.0"
                            ],
                            "main": function(container, depth0, helpers, partials, data) {
                                var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                                    return undefined;
                                };
                                return "<div class=\"u2f-instructions\"><ol><li>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                                    "name": "i18n",
                                    "hash": {
                                        "bundle": "login",
                                        "code": "enroll.u2f.general2"
                                    },
                                    "data": data,
                                    "loc": {
                                        "start": {
                                            "line": 1,
                                            "column": 38
                                        },
                                        "end": {
                                            "line": 1,
                                            "column": 90
                                        }
                                    }
                                })) != null ? stack1 : "") + "</li><li>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                                    "name": "i18n",
                                    "hash": {
                                        "bundle": "login",
                                        "code": "enroll.u2f.general3"
                                    },
                                    "data": data,
                                    "loc": {
                                        "start": {
                                            "line": 1,
                                            "column": 99
                                        },
                                        "end": {
                                            "line": 1,
                                            "column": 149
                                        }
                                    }
                                })) + "</li></ol></div>";
                            },
                            "useData": true
                        })
                    })
                }));
                result.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                    View: (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                        template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                            "compiler": [
                                8,
                                ">= 4.3.0"
                            ],
                            "main": function(container, depth0, helpers, partials, data) {
                                var alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                                    return undefined;
                                };
                                return "<div class=\"u2f-enroll-text hide\"><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                                    "name": "i18n",
                                    "hash": {
                                        "bundle": "login",
                                        "code": "enroll.u2f.instructions"
                                    },
                                    "data": data,
                                    "loc": {
                                        "start": {
                                            "line": 1,
                                            "column": 37
                                        },
                                        "end": {
                                            "line": 1,
                                            "column": 91
                                        }
                                    }
                                })) + "</p><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                                    "name": "i18n",
                                    "hash": {
                                        "bundle": "login",
                                        "code": "enroll.u2f.instructionsBluetooth"
                                    },
                                    "data": data,
                                    "loc": {
                                        "start": {
                                            "line": 1,
                                            "column": 98
                                        },
                                        "end": {
                                            "line": 1,
                                            "column": 161
                                        }
                                    }
                                })) + "</p><div data-se=\"u2f-devices\" class=\"u2f-devices-images\"><div class=\"u2f-usb\"></div><div class=\"u2f-bluetooth\"></div></div><div data-se=\"u2f-waiting\" class=\"okta-waiting-spinner\"></div></div>";
                            },
                            "useData": true
                        })
                    })
                }));
            }
            return result;
        },
        _startEnrollment: function() {
            this.$('.u2f-instructions').addClass('hide');
            this.$('.u2f-enroll-text').removeClass('hide');
            this.$('.o-form-button-bar').hide();
        },
        _stopEnrollment: function() {
            this.$('.u2f-instructions').removeClass('hide');
            this.$('.u2f-enroll-text').addClass('hide');
            this.$('.o-form-button-bar').show();
        }
    },
    Footer: (0, $84975a54a18f1ea8$export$2e2bcd8739ae039),
    trapAuthResponse: function() {
        if (this.options.appState.get('isMfaEnrollActivate')) {
            this.model.activate();
            return true;
        }
    }
});













/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the 'License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $4d1e22931783f788$export$2e2bcd8739ae039 = (0, $f24ef70ebb57d1e8$export$2e2bcd8739ae039).extend({
    initialize: function(options) {
        this.options = options || {};
        this.appState = this.options.appState;
    },
    constructPostData: function(profileAttributes) {
        const postData = {
            registration: {
                profile: profileAttributes
            }
        };
        // send createNewAccount flag for new user creation
        if (this.appState.get('policy').registration.createNewAccount) postData.registration['createNewAccount'] = true;
        return postData;
    },
    getEnrollFormData: function() {
        return this.manageTransaction(function(transaction, setTransaction) {
            return transaction.enroll().then(function(trans) {
                setTransaction(trans);
            });
        });
    },
    save: function() {
        let data = (0, $f24ef70ebb57d1e8$export$2e2bcd8739ae039).prototype.toJSON.apply(this, arguments);
        data = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(data, [
            'appState',
            'settings',
            'createNewAccount'
        ]);
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(data)) {
            const error = {
                errorSummary: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oform.errorbanner.title', 'login')
            };
            this.trigger('error', this, {
                responseJSON: error
            });
        } else return this.manageTransaction(function(transaction, setTransaction) {
            transaction.enroll(this.constructPostData(data)).then(function(trans) {
                setTransaction(trans);
            });
        });
    }
});























/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ let { BaseSchema: $26a91863400c4f93$var$BaseSchema } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).models;
var $26a91863400c4f93$export$2e2bcd8739ae039 = $26a91863400c4f93$var$BaseSchema.Model.extend({
    expand: [
        'schema'
    ],
    setFieldPlaceholder: function(formFields) {
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(formFields, function(formField) {
            formField.title = formField.label;
        });
        return formFields;
    },
    initialize: function(options) {
        let profileAttributes = options.profileSchemaAttributes;
        profileAttributes = this.setFieldPlaceholder(profileAttributes);
        if (profileAttributes) {
            const userProfileSchema = {
                properties: {}
            };
            for(var i = 0; i < profileAttributes.length; i++){
                const profileAttributeObject = profileAttributes[i];
                userProfileSchema.properties[profileAttributeObject.name] = profileAttributeObject;
            }
            this.parse.apply(this, [
                {
                    schema: userProfileSchema
                }
            ]);
        }
    }
});













/* eslint max-statements: [2, 23],  max-depth: [2, 3], complexity: [2, 13] */ let { SchemaFormFactory: $aa64e1b90972a64e$var$SchemaFormFactory } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).views.forms.helpers;
let { CheckBox: $aa64e1b90972a64e$var$CheckBox } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).views.forms.inputs;
const $aa64e1b90972a64e$var$getParts = function(username) {
    const usernameArr = username.split('');
    const minPartsLength = 4;
    const userNameParts = [];
    const delimiters = [
        ',',
        '.',
        '-',
        '_',
        '#',
        '@'
    ];
    let userNamePart = '';
    (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(usernameArr, function(part) {
        if (delimiters.indexOf(part) === -1) userNamePart += part;
        else {
            if (userNamePart.length >= minPartsLength) userNameParts.push((0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone(userNamePart));
            userNamePart = '';
        }
    });
    if (userNamePart.length >= minPartsLength) userNameParts.push((0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone(userNamePart));
    return userNameParts.filter(Boolean);
};
const $aa64e1b90972a64e$var$passwordContainsFormField = function(formField, password) {
    if (!formField) return false;
    formField = formField.toLowerCase();
    password = password.toLowerCase();
    const formFieldArr = $aa64e1b90972a64e$var$getParts(formField);
    //check if each formField part contains password
    for(var i = 0; i < formFieldArr.length; i++){
        const formFieldPart = formFieldArr[i];
        if (password.indexOf(formFieldPart) !== -1) return true;
    }
    return false;
};
const $aa64e1b90972a64e$var$checkSubSchema = function(subSchema, value, model) {
    const minLength = subSchema.get('minLength');
    const maxLength = subSchema.get('maxLength');
    const regex = subSchema.get('format');
    if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isNumber(minLength)) {
        if (value.length < minLength) return false;
    }
    if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isNumber(maxLength)) {
        if (value.length > maxLength) return false;
    }
    const password = value;
    if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isString(regex)) {
        // call passwordContainsFormField if regex is userName, firstName, lastName
        if (regex === '^[#/userName]' || regex === '^[#/firstName]' || regex === '^[#/lastName]') {
            const fieldName = regex.split('^[#/')[1].split(']')[0];
            let fieldValue = model.get(fieldName);
            if (fieldName === 'userName') {
                // with email as login enabled, we only have email populated
                // Therefore we fallback and run validation with email attribute.
                fieldValue = model.has('userName') ? model.get('userName') : model.get('email');
                return !$aa64e1b90972a64e$var$passwordContainsFormField(fieldValue, password);
            } else return !fieldValue || password.indexOf(fieldValue) === -1;
        } else {
            if (!new RegExp(regex).test(value)) return false;
        }
    }
    return true;
};
const $aa64e1b90972a64e$var$checkSubSchemas = function(fieldName, model, subSchemas, showError) {
    const value = model.get(fieldName);
    if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isString(value)) return;
    subSchemas.each(function(subSchema, index) {
        const ele = (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)('#subschemas-' + fieldName + ' .subschema-' + index);
        //hide password complexity if no password
        if (value) ele.children('p').removeClass('default-schema');
        else ele.children('p').addClass('default-schema');
        // clear aria role and live-region for re-validation
        ele.children('p').removeAttr('role').removeAttr('aria-live');
        // reset errors
        ele.removeClass('subschema-satisfied subschema-unsatisfied subschema-error');
        // validate
        if ($aa64e1b90972a64e$var$checkSubSchema(subSchema, value, model)) {
            // passed
            ele.addClass('subschema-satisfied');
            ele.find('p span').removeClass('error error-16-small');
            ele.find('p span').addClass('confirm-16');
        } else // failed
        if (showError) {
            ele.find('p span').removeClass('confirm-16');
            ele.find('p span').addClass('error error-16-small');
            ele.addClass('subschema-error subschema-unsatisfied');
            ele.find('p')// set role="alert" so the password requirement is read by
            // screen-readers
            .attr('role', 'alert')// set aria-live="polite" so it will "debounce" and wait to read the
            // message between keystrokes
            .attr('aria-live', 'polite');
        }
    });
};
const $aa64e1b90972a64e$var$fnCreateInputOptions = function(schemaProperty) {
    var _schemaProperty$optio;
    let inputOptions = $aa64e1b90972a64e$var$SchemaFormFactory.createInputOptions(schemaProperty);
    if (((_schemaProperty$optio = schemaProperty.options) === null || _schemaProperty$optio === void 0 ? void 0 : _schemaProperty$optio.type) === 'boolean') // change BooleanSelect to CheckBox
    inputOptions.input = $aa64e1b90972a64e$var$CheckBox;
    if (inputOptions.type === 'select') inputOptions = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend(inputOptions, {
        label: schemaProperty.get('title')
    });
    else {
        let placeholder = schemaProperty.get('title');
        if (schemaProperty.get('required')) placeholder += ' *';
        inputOptions = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend(inputOptions, {
            label: false,
            'label-top': true,
            placeholder: placeholder
        });
    }
    const fieldName = schemaProperty.get('name');
    switch(fieldName){
        case 'userName':
            inputOptions.input = (0, $063de20ba11c0f5c$export$2e2bcd8739ae039);
            inputOptions.params = {
                icon: 'person-16-gray'
            };
            break;
        case 'password':
            inputOptions.type = 'password';
            inputOptions.input = (0, $063de20ba11c0f5c$export$2e2bcd8739ae039);
            inputOptions.params = {
                icon: 'remote-lock-16'
            };
    }
    const subSchemas = schemaProperty.get('subSchemas');
    if (subSchemas) inputOptions.events = {
        input: function() {
            $aa64e1b90972a64e$var$checkSubSchemas(fieldName, this.model, subSchemas, true);
        },
        focusout: function() {
            $aa64e1b90972a64e$var$checkSubSchemas(fieldName, this.model, subSchemas, true);
        },
        'change:userName': function() {
            $aa64e1b90972a64e$var$checkSubSchemas(fieldName, this.model, subSchemas, true);
        },
        'change:firstName': function() {
            $aa64e1b90972a64e$var$checkSubSchemas(fieldName, this.model, subSchemas, true);
        },
        'change:lastName': function() {
            $aa64e1b90972a64e$var$checkSubSchemas(fieldName, this.model, subSchemas, true);
        },
        'change:email': function() {
            $aa64e1b90972a64e$var$checkSubSchemas(fieldName, this.model, subSchemas, true);
        }
    };
    return inputOptions;
};
var $aa64e1b90972a64e$export$2e2bcd8739ae039 = {
    createInputOptions: $aa64e1b90972a64e$var$fnCreateInputOptions,
    getUsernameParts: $aa64e1b90972a64e$var$getParts,
    passwordContainsFormField: $aa64e1b90972a64e$var$passwordContainsFormField,
    checkSubSchema: $aa64e1b90972a64e$var$checkSubSchema
};


var $07dd7de09ef8435f$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$a7fed597f4b8afd8).extend({
    layout: 'o-form-theme',
    autoSave: true,
    noCancelButton: true,
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('registration.form.title', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('registration.form.submit', 'login');
    },
    initialize: function(options) {
        this.options = options || {};
        this.schema = new (0, $26a91863400c4f93$export$2e2bcd8739ae039)({
            profileSchemaAttributes: this.options.appState.get('policy').registration.profile
        });
        this.schema.properties.each((schemaProperty)=>{
            const inputOptions = (0, $aa64e1b90972a64e$export$2e2bcd8739ae039).createInputOptions(schemaProperty);
            this.addInput(inputOptions);
        });
        const requiredFieldsLabel = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
            "compiler": [
                8,
                ">= 4.3.0"
            ],
            "main": function(container, depth0, helpers, partials, data) {
                var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                    return undefined;
                };
                return "<span class=\"required-fields-label\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                    "name": "label",
                    "hash": {},
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 36
                        },
                        "end": {
                            "line": 1,
                            "column": 45
                        }
                    }
                }) : helper)) + "</span>";
            },
            "useData": true
        })({
            label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('registration.required.fields.label', 'login')
        });
        this.add(requiredFieldsLabel);
    }
});













var $724391db7f3cb295$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a href=\"#\" class=\"link help\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "goback"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 50
                    },
                    "end": {
                        "line": 1,
                        "column": 87
                    }
                }
            })) + "</a>";
        },
        "useData": true
    }),
    className: 'auth-footer',
    events: {
        'click .help': function(e) {
            e.preventDefault();
            this.back();
        }
    },
    back: function() {
        this.state.set('navigateDir', (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).DIRECTION_BACK);
        this.options.appState.trigger('navigate', '');
    }
});


/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $d234d4f2449a410d$export$2e2bcd8739ae039 = (0, $6887ec4c502ac936$export$2e2bcd8739ae039).extend({
    className: 'enroll-user',
    initialize: function(options) {
        this.options = options || {};
        // create model
        this.model = new (0, $4d1e22931783f788$export$2e2bcd8739ae039)(this.options);
    },
    fetchInitialData: function() {
        // If user is unauthenticated and starts enroll flow make a post call to transition state to PROFILE_REQUIRED
        if (this.options.appState.get('isUnauthenticated')) return this.model.getEnrollFormData();
        else return (0, $6887ec4c502ac936$export$2e2bcd8739ae039).prototype.fetchInitialData.call();
    },
    trapAuthResponse: function() {
        if (this.options.appState.get('isProfileRequired')) return true;
    },
    postRender: function() {
        const form = new (0, $07dd7de09ef8435f$export$2e2bcd8739ae039)(this.toJSON());
        this.add(form);
        this.add(new (0, $724391db7f3cb295$export$2e2bcd8739ae039)(this.toJSON()));
        this.addListeners();
    }
});













/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ /* global Uint8Array, atob, btoa */ const $36d38737859019f5$export$2e2bcd8739ae039 = {};
/**
 * Light weight hashing algorithm that hashes string into an integer between 0 and 4294967295
 * Not recommended for data set of size greater than 10000
 * https://www.npmjs.com/package/string-hash
 *
 * @param str the string to be hashed
 * @returns string hash of integer type
 */ $36d38737859019f5$export$2e2bcd8739ae039.getStringHash = function(str) {
    let hash = 5381;
    let i = str.length;
    while(i)hash = hash * 33 ^ str.charCodeAt(--i);
    return hash >>> 0;
};
/**
 * Converts any url safe characters in a base64 string to regular base64 characters
 * @param str base64 string that might contain url safe characters
 * @returns base64 formatted string
 */ $36d38737859019f5$export$2e2bcd8739ae039.base64UrlSafeToBase64 = function(str) {
    return str.replace(new RegExp('_', 'g'), '/').replace(new RegExp('-', 'g'), '+');
};
/**
 * Converts an ArrayBuffer object that contains binary data to base64 encoded string
 * @param bin ArrayBuffer object
 * @returns base64 encoded string
 */ $36d38737859019f5$export$2e2bcd8739ae039.binToStr = function(bin) {
    return btoa(new Uint8Array(bin).reduce((s, byte)=>s + String.fromCharCode(byte), ''));
};
/**
 * Converts base64 string to binary data view
 * @param str in base64 or base64UrlSafe format
 * @returns converted Uint8Array view of binary data
 */ $36d38737859019f5$export$2e2bcd8739ae039.strToBin = function(str) {
    return Uint8Array.from(atob(this.base64UrlSafeToBase64(str)), (c)=>c.charCodeAt(0));
};






/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $bd053cd6fe43765a$var$adaptToOkta(promise) {
    return Promise.resolve(promise);
}
function $bd053cd6fe43765a$var$makeCredential(accountInfo, cryptoParams, challenge) {
    cryptoParams = cryptoParams.map(function(param) {
        return {
            type: 'FIDO_2_0',
            algorithm: param.algorithm
        };
    });
    const promise = window.msCredentials.makeCredential(accountInfo, cryptoParams, challenge).then(function(cred) {
        return Object.freeze({
            credential: {
                id: cred.id
            },
            publicKey: JSON.parse(cred.publicKey),
            attestation: cred.attestation
        });
    });
    return $bd053cd6fe43765a$var$adaptToOkta(promise);
}
function $bd053cd6fe43765a$var$getAssertion(challenge, allowList) {
    const accept = allowList.map(function(item) {
        return {
            type: 'FIDO_2_0',
            id: item.id
        };
    });
    const filters = {
        accept: accept
    };
    const promise = window.msCredentials.getAssertion(challenge, filters).then(function(attestation) {
        const signature = attestation.signature;
        return Object.freeze({
            credential: {
                id: attestation.id
            },
            clientData: signature.clientData,
            authenticatorData: signature.authnrData,
            signature: signature.signature
        });
    });
    return $bd053cd6fe43765a$var$adaptToOkta(promise);
}
function $bd053cd6fe43765a$var$processWebAuthnResponse(inputFunction, context) {
    if (typeof inputFunction === 'undefined') return null;
    const responseValue = inputFunction.apply(context);
    if (responseValue === undefined || responseValue === null) return null;
    return JSON.stringify(responseValue);
}
var $bd053cd6fe43765a$export$2e2bcd8739ae039 = {
    makeCredential: $bd053cd6fe43765a$var$makeCredential,
    getAssertion: $bd053cd6fe43765a$var$getAssertion,
    processWebAuthnResponse: $bd053cd6fe43765a$var$processWebAuthnResponse,
    isAvailable: function() {
        return Object.prototype.hasOwnProperty.call(window, 'msCredentials');
    },
    isNewApiAvailable: function() {
        // navigator.credentials is not supported in IE11
        // eslint-disable-next-line compat/compat
        return navigator && navigator.credentials && navigator.credentials.create;
    },
    isWebauthnOrU2fAvailable: function() {
        return this.isNewApiAvailable() || (0, $f16de62271c4c5b1$export$2e2bcd8739ae039).isU2fAvailable();
    },
    isConditionalMediationAvailable: function() {
        // eslint-disable-next-line compat/compat, no-undef
        return typeof PublicKeyCredential !== 'undefined' && typeof PublicKeyCredential.isConditionalMediationAvailable !== 'undefined';
    },
    // checks if the browser supports passkey autofill by making sure it supports conditional mediation
    // https://passkeys.dev/docs/reference/terms/#autofill-ui
    isPasskeyAutofillAvailable: async function() {
        let isAvailable = false;
        if (this.isConditionalMediationAvailable()) // eslint-disable-next-line compat/compat, no-undef
        isAvailable = await PublicKeyCredential.isConditionalMediationAvailable();
        return isAvailable;
    },
    isPasskeyAvailable: function() {
        var _navigator;
        // eslint-disable-next-line compat/compat
        const credentials = ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.credentials) || {};
        return typeof PublicKeyCredential !== 'undefined' && typeof credentials.get === 'function' && typeof credentials.create === 'function';
    },
    isRelyingPartyIdMismatchError: function(error) {
        return (error === null || error === void 0 ? void 0 : error.name) === 'SecurityError' && (error === null || error === void 0 ? void 0 : error.code) === 18;
    },
    isAbortError: function(error) {
        return (error === null || error === void 0 ? void 0 : error.name) === 'AbortError' && (error === null || error === void 0 ? void 0 : error.code) === 20;
    },
    isNotAllowedError: function(error) {
        return (error === null || error === void 0 ? void 0 : error.name) === 'NotAllowedError' && (error === null || error === void 0 ? void 0 : error.code) === 0;
    }
};




function $d0ee074a6a35232e$var$getExcludeCredentials(credentials) {
    const excludeCredentials = [];
    (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(credentials, function(credential) {
        excludeCredentials.push({
            type: 'public-key',
            id: (0, $36d38737859019f5$export$2e2bcd8739ae039).strToBin(credential.id)
        });
    });
    return excludeCredentials;
}
var $d0ee074a6a35232e$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'enroll-webauthn',
    Model: {
        local: {
            __enrolled__: 'boolean'
        },
        save: function() {
            this.trigger('request');
            if (this.get('__enrolled__')) return this.activate();
            return this.doTransaction(function(transaction) {
                const factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(transaction.factors, {
                    factorType: 'webauthn',
                    provider: 'FIDO'
                });
                return factor.enroll();
            });
        },
        activate: function() {
            this.set('__enrolled__', true);
            this.trigger('errors:clear');
            this.appState.on('backToFactors', ()=>{
                if (this.webauthnAbortController) {
                    this.webauthnAbortController.abort();
                    this.webauthnAbortController = null;
                }
            });
            return this.doTransaction(function(transaction) {
                const activation = transaction.factor.activation;
                // enroll via browser webauthn js
                const self = this;
                if ((0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isNewApiAvailable()) {
                    const options = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({}, activation, {
                        challenge: (0, $36d38737859019f5$export$2e2bcd8739ae039).strToBin(activation.challenge),
                        user: {
                            id: (0, $36d38737859019f5$export$2e2bcd8739ae039).strToBin(activation.user.id),
                            name: activation.user.name,
                            displayName: activation.user.displayName
                        },
                        excludeCredentials: $d0ee074a6a35232e$var$getExcludeCredentials(activation.excludeCredentials)
                    });
                    // AbortController is not supported in IE11
                    if (typeof AbortController !== 'undefined') self.webauthnAbortController = new AbortController();
                    return Promise.resolve(navigator.credentials.create({
                        publicKey: options,
                        signal: self.webauthnAbortController && self.webauthnAbortController.signal
                    })).then(function(newCredential) {
                        return transaction.activate({
                            attestation: (0, $36d38737859019f5$export$2e2bcd8739ae039).binToStr(newCredential.response.attestationObject),
                            clientData: (0, $36d38737859019f5$export$2e2bcd8739ae039).binToStr(newCredential.response.clientDataJSON),
                            // example data: ["nfc", "usb"]
                            transports: (0, $bd053cd6fe43765a$export$2e2bcd8739ae039).processWebAuthnResponse(newCredential.response.getTransports, newCredential.response),
                            // example data: {"credProps":{"rk":true}}
                            clientExtensions: (0, $bd053cd6fe43765a$export$2e2bcd8739ae039).processWebAuthnResponse(newCredential.getClientExtensionResults, newCredential)
                        });
                    }).catch(function(error) {
                        self.trigger('errors:clear');
                        // Do not display if it is abort error triggered by code when switching.
                        // self.webauthnAbortController would be null if abort was triggered by code.
                        if (!self.webauthnAbortController) throw new (0, $3fe6932680e7ea64$export$810d59b58d691639)();
                        else throw new (0, $3fe6932680e7ea64$export$90f0c14a652de832)({
                            xhr: {
                                responseJSON: {
                                    errorSummary: error.message
                                }
                            }
                        });
                    }).finally(function() {
                        // unset webauthnAbortController on successful authentication or error
                        self.webauthnAbortController = null;
                    });
                }
            }).catch(()=>{});
        }
    },
    Form: {
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'enroll.webauthn.biometric.title', 'login'),
        save: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'enroll.webauthn.save', 'login'),
        noCancelButton: true,
        hasSavingState: false,
        autoSave: true,
        className: 'enroll-webauthn-form',
        noButtonBar: function() {
            return !(0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isNewApiAvailable();
        },
        modelEvents: {
            request: '_startEnrollment',
            error: '_stopEnrollment'
        },
        formChildren: function() {
            const children = [];
            if ((0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isNewApiAvailable()) //enroll.webauthn.biometric.instructions.edge is unescaped because it contains html
            children.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                View: (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                    className: 'webauthn-enroll-text',
                    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                        "0": function(container, depth0, helpers, partials, data) {
                            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                                return undefined;
                            };
                            return "<div class=\"webauthn-edge-text\"><p>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                                "name": "i18n",
                                "hash": {
                                    "bundle": "login",
                                    "code": "enroll.webauthn.biometric.instructions.edge"
                                },
                                "data": data,
                                "loc": {
                                    "start": {
                                        "line": 1,
                                        "column": 173
                                    },
                                    "end": {
                                        "line": 1,
                                        "column": 249
                                    }
                                }
                            })) != null ? stack1 : "") + "</p></div>";
                        },
                        "1": function(container, depth0, helpers, partials, data) {
                            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                                return undefined;
                            };
                            return "<div class=\"webauthn-restrictions-text\"><p>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                                "name": "i18n",
                                "hash": {
                                    "bundle": "login",
                                    "code": "enroll.webauthn.instructions.noSupportForBiometric"
                                },
                                "data": data,
                                "loc": {
                                    "start": {
                                        "line": 1,
                                        "column": 340
                                    },
                                    "end": {
                                        "line": 1,
                                        "column": 423
                                    }
                                }
                            })) != null ? stack1 : "") + "</p></div>";
                        },
                        "compiler": [
                            8,
                            ">= 4.3.0"
                        ],
                        "main": function(container, depth0, helpers, partials, data) {
                            var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                                return undefined;
                            };
                            return "<div class=\"webauthn-enroll-instructions\"><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
                                "name": "i18n",
                                "hash": {
                                    "bundle": "login",
                                    "code": "enroll.webauthn.biometric.instructions"
                                },
                                "data": data,
                                "loc": {
                                    "start": {
                                        "line": 1,
                                        "column": 45
                                    },
                                    "end": {
                                        "line": 1,
                                        "column": 114
                                    }
                                }
                            })) + "</p></div>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "isEdge") : depth0, {
                                "name": "if",
                                "hash": {},
                                "fn": container.program(0, data, 0),
                                "inverse": container.noop,
                                "data": data,
                                "loc": {
                                    "start": {
                                        "line": 1,
                                        "column": 124
                                    },
                                    "end": {
                                        "line": 1,
                                        "column": 266
                                    }
                                }
                            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "onlySupportsSecurityKey") : depth0, {
                                "name": "if",
                                "hash": {},
                                "fn": container.program(1, data, 0),
                                "inverse": container.noop,
                                "data": data,
                                "loc": {
                                    "start": {
                                        "line": 1,
                                        "column": 266
                                    },
                                    "end": {
                                        "line": 1,
                                        "column": 440
                                    }
                                }
                            })) != null ? stack1 : "") + "<div data-se=\"webauthn-waiting\" class=\"okta-waiting-spinner hide\"></div>";
                        },
                        "useData": true
                    }),
                    getTemplateData: function() {
                        return {
                            isEdge: (0, $22893d6dea78fc87$export$2e2bcd8739ae039).isEdge(),
                            onlySupportsSecurityKey: ((0, $22893d6dea78fc87$export$2e2bcd8739ae039).isFirefox() || (0, $22893d6dea78fc87$export$2e2bcd8739ae039).isSafari()) && (0, $22893d6dea78fc87$export$2e2bcd8739ae039).isMac()
                        };
                    }
                })
            }));
            else {
                let errorMessageKey = 'webauthn.biometric.error.factorNotSupported';
                if (this.options.appState.get('factors').length === 1) errorMessageKey = 'webauthn.biometric.error.factorNotSupported.oneFactor';
                children.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                    View: new (0, $b717de154cd703a4$export$2e2bcd8739ae039)({
                        message: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(errorMessageKey, 'login')
                    })
                }, {
                    selector: '.o-form-error-container'
                }));
            }
            return children;
        },
        _startEnrollment: function() {
            this.$('.okta-waiting-spinner').show();
            this.$('.o-form-button-bar').hide();
        },
        _stopEnrollment: function() {
            this.$('.okta-waiting-spinner').hide();
            this.$('.o-form-button-bar').show();
        }
    },
    Footer: (0, $84975a54a18f1ea8$export$2e2bcd8739ae039),
    trapAuthResponse: function() {
        if (this.options.appState.get('isMfaEnrollActivate')) {
            this.model.activate();
            return true;
        }
    }
});



























/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $e166679abbcff2df$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'okta-waiting-spinner',
    attributes: {
        'data-se': 'o-form-okta-waiting-spinner'
    },
    modelEvents: {
        'spinner:show': 'show',
        'spinner:hide': 'hide'
    },
    initialize: function(options) {
        if (options && options.visible === false) this.hide();
    },
    show: function() {
        this.$el.removeClass('hide');
    },
    hide: function() {
        this.$el.addClass('hide');
    }
});


/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $db2ad7e14a32059c$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'enroll-windows-hello',
    Model: {
        local: {
            __isEnrolled__: 'boolean'
        },
        save: function() {
            if (!(0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isAvailable()) return;
            this.trigger('request');
            if (this.get('__isEnrolled__')) return this.activate();
            return this.doTransaction(function(transaction) {
                return this._enroll(transaction);
            });
        },
        _enroll: function(transaction) {
            const factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(transaction.factors, {
                factorType: 'webauthn',
                provider: 'FIDO'
            });
            return factor.enroll();
        },
        activate: function() {
            this.set('__isEnrolled__', true);
            return this.doTransaction(function(transaction) {
                const activation = transaction.factor.activation;
                const user = transaction.user;
                const model = this;
                const accountInfo = {
                    rpDisplayName: activation.rpDisplayName,
                    userDisplayName: user.profile.displayName,
                    accountName: user.profile.login,
                    userId: user.id
                };
                const cryptoParams = [
                    {
                        algorithm: activation.algorithm
                    }
                ];
                const challenge = activation.nonce;
                return (0, $bd053cd6fe43765a$export$2e2bcd8739ae039).makeCredential(accountInfo, cryptoParams, challenge).then(function(creds) {
                    return transaction.activate({
                        credentialId: creds.credential.id,
                        publicKey: creds.publicKey,
                        attestation: null
                    });
                }).catch(function(error) {
                    switch(error.message){
                        case 'AbortError':
                        case 'NotFoundError':
                        case 'NotSupportedError':
                            model.trigger('abort', error.message);
                            return transaction;
                    }
                    throw error;
                });
            });
        }
    },
    Form: {
        autoSave: true,
        hasSavingState: false,
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'enroll.windowsHello.title', 'login'),
        subtitle: function() {
            return (0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isAvailable() ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.windowsHello.subtitle', 'login') : '';
        },
        save: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'enroll.windowsHello.save', 'login'),
        customSavingState: {
            stop: 'abort'
        },
        modelEvents: function() {
            if (!(0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isAvailable()) return {};
            return {
                request: '_startEnrollment',
                error: '_stopEnrollment',
                abort: '_stopEnrollment'
            };
        },
        noButtonBar: function() {
            return !(0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isAvailable();
        },
        formChildren: function() {
            const result = [];
            if (!(0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isAvailable()) result.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                View: new (0, $b717de154cd703a4$export$2e2bcd8739ae039)({
                    message: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.windowsHello.error.notWindows', 'login')
                })
            }, {
                selector: '.o-form-error-container'
            }));
            result.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                View: new (0, $e166679abbcff2df$export$2e2bcd8739ae039)({
                    model: this.model,
                    visible: false
                })
            }));
            return result;
        },
        _startEnrollment: function() {
            this.subtitle = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.windowsHello.subtitle.loading', 'login');
            this.model.trigger('spinner:show');
            this._resetErrorMessage();
            this.render();
            this.$('.o-form-button-bar').addClass('hide');
        },
        _stopEnrollment: function(errorMessage) {
            this.subtitle = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.windowsHello.subtitle', 'login');
            this.model.trigger('spinner:hide');
            let message;
            switch(errorMessage){
                case 'NotSupportedError':
                    message = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.windowsHello.error.notConfiguredHtml', 'login');
                    break;
            }
            this._resetErrorMessage();
            if (message) {
                const messageView = new (0, $b717de154cd703a4$export$2e2bcd8739ae039)({
                    message: message
                });
                this.$('.o-form-error-container').addClass('o-form-has-errors');
                this.add(messageView, {
                    selector: '.o-form-error-container'
                });
                this._errorMessageView = this.last();
            }
            this.render();
            this.$('.o-form-button-bar').removeClass('hide');
        },
        _resetErrorMessage: function() {
            this._errorMessageView && this._errorMessageView.remove();
            this._errorMessageView = undefined;
            this.clearErrors();
        }
    },
    Footer: (0, $84975a54a18f1ea8$export$2e2bcd8739ae039),
    trapAuthResponse: function() {
        if (this.options.appState.get('isMfaEnrollActivate')) {
            this.model.activate();
            return true;
        }
    }
});
















/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $7e3c3db353f11be6$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'enroll-yubikey',
    Model: {
        props: {
            passCode: [
                'string',
                true
            ],
            factorId: 'string'
        },
        save: function() {
            return this.doTransaction(function(transaction) {
                const factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(transaction.factors, {
                    factorType: 'token:hardware',
                    provider: 'YUBICO'
                });
                return factor.enroll({
                    passCode: this.get('passCode')
                });
            });
        }
    },
    Form: {
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'enroll.yubikey.title', 'login'),
        subtitle: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'enroll.yubikey.subtitle', 'login'),
        noCancelButton: true,
        save: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'mfa.challenge.verify', 'login'),
        autoSave: true,
        className: 'enroll-yubikey',
        formChildren: [
            (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                View: '<div class="yubikey-demo" data-type="yubikey-example"></div>'
            }),
            (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                name: 'passCode',
                input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
                type: 'password'
            })
        ]
    },
    Footer: (0, $84975a54a18f1ea8$export$2e2bcd8739ae039)
});
















const $c739760b2c46fd01$var$PUSH_INTERVAL = 6000;
// Note: Keep-alive is set to 5 seconds - using 5 seconds here will result
// in network connection lost errors in Safari and IE.
const $c739760b2c46fd01$var$EnrollmentLinkSentControllerFooter = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oform.back"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 58
                    },
                    "end": {
                        "line": 1,
                        "column": 99
                    }
                }
            })) + "</a>";
        },
        "useData": true
    }),
    className: 'auth-footer',
    events: {
        'click .js-back': function(e) {
            e.preventDefault();
            this.back();
        }
    },
    back: function() {
        const url = (0, $ec545c48aa9cf055$export$2e2bcd8739ae039).createActivateFactorUrl(this.options.appState.get('activatedFactorProvider'), this.options.appState.get('activatedFactorType'), 'manual');
        this.options.appState.trigger('navigate', url);
    }
});
const $c739760b2c46fd01$var$emailSentForm = {
    title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'enroll.totp.enrollViaEmail.title', 'login'),
    noButtonBar: true,
    attributes: {
        'data-se': 'sent-email-activation-link'
    },
    formChildren: [
        (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
            View: (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                    "compiler": [
                        8,
                        ">= 4.3.0"
                    ],
                    "main": function(container, depth0, helpers, partials, data) {
                        var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                            return undefined;
                        };
                        return "<p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                            "name": "i18n",
                            "hash": {
                                "bundle": "login",
                                "code": "enroll.totp.enrollViaEmail.msg"
                            },
                            "data": data,
                            "loc": {
                                "start": {
                                    "line": 1,
                                    "column": 3
                                },
                                "end": {
                                    "line": 1,
                                    "column": 64
                                }
                            }
                        })) + "</p><p class=\"email-address\">" + alias3((helper = (helper = lookupProperty(helpers, "email") || (depth0 != null ? lookupProperty(depth0, "email") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
                            "name": "email",
                            "hash": {},
                            "data": data,
                            "loc": {
                                "start": {
                                    "line": 1,
                                    "column": 93
                                },
                                "end": {
                                    "line": 1,
                                    "column": 102
                                }
                            }
                        }) : helper)) + "</p>";
                    },
                    "useData": true
                }),
                getTemplateData: function() {
                    return {
                        email: this.options.appState.get('userEmail')
                    };
                }
            })
        })
    ]
};
const $c739760b2c46fd01$var$smsSentForm = {
    title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'enroll.totp.enrollViaSms.title', 'login'),
    noButtonBar: true,
    attributes: {
        'data-se': 'sent-sms-activation-link'
    },
    formChildren: [
        (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
            View: (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                    "compiler": [
                        8,
                        ">= 4.3.0"
                    ],
                    "main": function(container, depth0, helpers, partials, data) {
                        var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                            return undefined;
                        };
                        return "<p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                            "name": "i18n",
                            "hash": {
                                "bundle": "login",
                                "code": "enroll.totp.enrollViaSms.msg"
                            },
                            "data": data,
                            "loc": {
                                "start": {
                                    "line": 1,
                                    "column": 3
                                },
                                "end": {
                                    "line": 1,
                                    "column": 62
                                }
                            }
                        })) + "</p><p class=\"phone-number\">" + alias3((helper = (helper = lookupProperty(helpers, "phoneNumber") || (depth0 != null ? lookupProperty(depth0, "phoneNumber") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
                            "name": "phoneNumber",
                            "hash": {},
                            "data": data,
                            "loc": {
                                "start": {
                                    "line": 1,
                                    "column": 90
                                },
                                "end": {
                                    "line": 1,
                                    "column": 105
                                }
                            }
                        }) : helper)) + "</p>";
                    },
                    "useData": true
                }),
                getTemplateData: function() {
                    return {
                        phoneNumber: this.model.get('fullPhoneNumber')
                    };
                }
            })
        })
    ]
};
var $c739760b2c46fd01$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'enroll-activation-link-sent',
    Model: function() {
        return {
            local: {
                countryCode: [
                    'string',
                    false,
                    this.options.appState.get('userCountryCode')
                ],
                phoneNumber: [
                    'string',
                    false,
                    this.options.appState.get('userPhoneNumber')
                ],
                __factorType__: [
                    'string',
                    false,
                    this.options.factorType
                ],
                __provider__: [
                    'string',
                    false,
                    this.options.provider
                ]
            },
            derived: {
                countryCallingCode: {
                    deps: [
                        'countryCode'
                    ],
                    fn: function(countryCode) {
                        return '+' + (0, $bfbf136e55dbe393$export$2e2bcd8739ae039).getCallingCodeForCountry(countryCode);
                    }
                },
                fullPhoneNumber: {
                    deps: [
                        'countryCallingCode',
                        'phoneNumber'
                    ],
                    fn: function(countryCallingCode, phoneNumber) {
                        return countryCallingCode + phoneNumber;
                    }
                }
            }
        };
    },
    Form: function() {
        const activationType = this.options.appState.get('factorActivationType');
        switch(activationType){
            case 'SMS':
                return $c739760b2c46fd01$var$smsSentForm;
            case 'EMAIL':
                return $c739760b2c46fd01$var$emailSentForm;
            default:
                throw new Error('Unknown activation option: ' + activationType);
        }
    },
    Footer: $c739760b2c46fd01$var$EnrollmentLinkSentControllerFooter,
    initialize: function() {
        this.pollForEnrollment();
    },
    remove: function() {
        return (0, $735c6d0521558dcb$export$2e2bcd8739ae039).prototype.remove.apply(this, arguments);
    },
    pollForEnrollment: function() {
        return this.model.doTransaction(function(transaction) {
            return transaction.poll($c739760b2c46fd01$var$PUSH_INTERVAL);
        });
    },
    trapAuthResponse: function() {
        if (this.options.appState.get('isWaitingForActivation')) {
            this.pollForEnrollment();
            return true;
        }
    }
});















const $f3164ad050821c09$var$EnterPasscodePushFlowControllerFooter = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oform.back"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 58
                    },
                    "end": {
                        "line": 1,
                        "column": 99
                    }
                }
            })) + "</a>";
        },
        "useData": true
    }),
    className: 'auth-footer',
    events: {
        'click .js-back': function(e) {
            e.preventDefault();
            this.back();
        }
    },
    back: function() {
        const url = (0, $ec545c48aa9cf055$export$2e2bcd8739ae039).createActivateFactorUrl(this.options.appState.get('activatedFactorProvider'), 'push', 'manual');
        this.options.appState.trigger('navigate', url);
    }
});
var $f3164ad050821c09$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'activate-push',
    Model: function() {
        return {
            props: {
                factorId: [
                    'string',
                    true,
                    this.options.appState.get('activatedFactorId')
                ],
                passCode: [
                    'string',
                    true
                ]
            },
            local: {
                __factorType__: [
                    'string',
                    false,
                    this.options.factorType
                ],
                __provider__: [
                    'string',
                    false,
                    this.options.provider
                ]
            },
            save: function() {
                return this.doTransaction(function(transaction) {
                    return transaction.activate({
                        passCode: this.get('passCode')
                    });
                });
            }
        };
    },
    Form: (0, $f79ddf3172172fca$export$2e2bcd8739ae039),
    Footer: $f3164ad050821c09$var$EnterPasscodePushFlowControllerFooter
});



























var $ea80dae0b72181e6$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"infobox\"><span class=\"icon info-16\"></span><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "arguments": "helpSupportNumber",
                    "bundle": "login",
                    "code": "contact.support"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 58
                    },
                    "end": {
                        "line": 1,
                        "column": 134
                    }
                }
            })) + "</p></div>";
        },
        "useData": true
    }),
    className: 'contact-support',
    getTemplateData: function() {
        return this.settings.pick('helpSupportNumber');
    }
});



const $58f9ab8c8f9b3995$var$ForgotPasswordControllernoFactorsError = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"okta-form-infobox-error infobox infobox-error\" role=\"alert\"><span class=\"icon error-16\"></span><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "password.forgot.noFactorsEnabled"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 110
                    },
                    "end": {
                        "line": 1,
                        "column": 173
                    }
                }
            })) + "</p></div>";
        },
        "useData": true
    })
});
const $58f9ab8c8f9b3995$var$ForgotPasswordControllerFooter = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "goback"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 94
                    },
                    "end": {
                        "line": 1,
                        "column": 131
                    }
                }
            })) + "</a>";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a href=\"#\" class=\"link goto js-contact-support\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "mfa.noAccessToEmail"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 220
                    },
                    "end": {
                        "line": 1,
                        "column": 270
                    }
                }
            })) + "</a>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return ((stack1 = lookupProperty(helpers, "unless").call(alias1, depth0 != null ? lookupProperty(depth0, "hideBackToSignInForReset") : depth0, {
                "name": "unless",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 146
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "helpSupportNumber") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 146
                    },
                    "end": {
                        "line": 1,
                        "column": 281
                    }
                }
            })) != null ? stack1 : "");
        },
        "useData": true
    }),
    className: 'auth-footer',
    events: {
        'click .js-back': function(e) {
            e.preventDefault();
            this.back();
        },
        'click .js-contact-support': function(e) {
            e.preventDefault();
            this.state.trigger('contactSupport');
            this.$('.js-contact-support').hide();
        }
    },
    getTemplateData: function() {
        return {
            hideBackToSignInForReset: this.settings.get('features.hideBackToSignInForReset'),
            helpSupportNumber: this.settings.get('helpSupportNumber')
        };
    },
    back: function() {
        this.state.set('navigateDir', (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).DIRECTION_BACK);
        this.options.appState.trigger('navigate', '');
    }
});
var $58f9ab8c8f9b3995$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'forgot-password',
    Model: {
        props: {
            username: [
                'string',
                true
            ],
            factorType: [
                'string',
                true
            ]
        },
        validate: function() {
            return (0, $925fe56dc05ff4ab$export$2e2bcd8739ae039).validateUsername(this);
        },
        save: function() {
            const self = this;
            const relayState = this.settings.get('relayState');
            this.startTransaction(function(authClient) {
                return authClient.forgotPassword({
                    username: self.settings.transformUsername(self.get('username'), (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).FORGOT_PASSWORD),
                    factorType: self.get('factorType'),
                    relayState: relayState
                });
            }).catch(function() {
            //need empty fail handler on model to display errors on form
            });
        }
    },
    Form: {
        noButtonBar: true,
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'password.reset', 'login'),
        formChildren: function() {
            const smsEnabled = this.settings.get('features.smsRecovery');
            /*eslint complexity: [2, 9] max-statements: [2, 23] */ const callEnabled = this.settings.get('features.callRecovery');
            const emailEnabled = this.settings.get('features.emailRecovery');
            const noFactorsEnabled = !(smsEnabled || callEnabled || emailEnabled);
            const formChildren = [];
            if (noFactorsEnabled) this.add($58f9ab8c8f9b3995$var$ForgotPasswordControllernoFactorsError, '.o-form-error-container');
            else {
                formChildren.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                    label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.forgot.email.or.username.placeholder', 'login'),
                    'label-top': true,
                    explain: (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).createInputExplain('password.forgot.email.or.username.tooltip', 'password.forgot.email.or.username.placeholder', 'login'),
                    'explain-top': true,
                    name: 'username',
                    input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
                    inputId: 'account-recovery-username',
                    autoComplete: (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).getAutocompleteValue(this.settings, 'username'),
                    type: 'text',
                    inlineValidation: false
                }));
                if (smsEnabled || callEnabled) formChildren.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                    View: (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                        template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                            "compiler": [
                                8,
                                ">= 4.3.0"
                            ],
                            "main": function(container, depth0, helpers, partials, data) {
                                var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                                    return undefined;
                                };
                                return "<p class=\"mobile-recovery-hint\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                                    "name": "i18n",
                                    "hash": {
                                        "arguments": "mobileFactors",
                                        "bundle": "login",
                                        "code": "recovery.mobile.hint"
                                    },
                                    "data": data,
                                    "loc": {
                                        "start": {
                                            "line": 1,
                                            "column": 32
                                        },
                                        "end": {
                                            "line": 1,
                                            "column": 109
                                        }
                                    }
                                })) + "</p>";
                            },
                            "useData": true
                        }),
                        getTemplateData: function() {
                            let mobileFactors;
                            if (smsEnabled && callEnabled) mobileFactors = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('recovery.smsOrCall');
                            else if (callEnabled) mobileFactors = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('recovery.call');
                            else mobileFactors = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('recovery.sms');
                            return {
                                mobileFactors: mobileFactors
                            };
                        }
                    })
                }));
                if (smsEnabled) {
                    this.$el.addClass('forgot-password-sms-enabled');
                    formChildren.push(this.createRecoveryFactorButton('sms-button', 'password.forgot.sendText', (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).RECOVERY_FACTOR_TYPE_SMS, this));
                    this.setDefaultFactorType((0, $e48c043f6d2d382d$export$2e2bcd8739ae039).RECOVERY_FACTOR_TYPE_SMS);
                }
                if (callEnabled) {
                    this.$el.addClass('forgot-password-call-enabled');
                    formChildren.push(this.createRecoveryFactorButton('call-button', 'password.forgot.call', (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).RECOVERY_FACTOR_TYPE_CALL, this));
                    this.setDefaultFactorType((0, $e48c043f6d2d382d$export$2e2bcd8739ae039).RECOVERY_FACTOR_TYPE_CALL);
                }
                if (emailEnabled) {
                    this.$el.addClass('forgot-password-email-enabled');
                    formChildren.push(this.createRecoveryFactorButton('email-button', 'password.forgot.sendEmail', (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).RECOVERY_FACTOR_TYPE_EMAIL, this));
                    this.setDefaultFactorType((0, $e48c043f6d2d382d$export$2e2bcd8739ae039).RECOVERY_FACTOR_TYPE_EMAIL);
                }
            }
            return formChildren;
        },
        initialize: function() {
            this.listenTo(this.state, 'contactSupport', function() {
                this.add((0, $ea80dae0b72181e6$export$2e2bcd8739ae039), '.o-form-error-container');
            });
            this.listenTo(this, 'save', function() {
                this.options.appState.set('username', this.model.get('username'));
                this.model.save();
            });
        },
        setDefaultFactorType: function(factorType) {
            if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(this.model.get('factorType'))) this.model.set('factorType', factorType);
        },
        createRecoveryFactorButton: function(className, labelCode, factorType, form) {
            return (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Button({
                attributes: {
                    'data-se': className
                },
                className: 'button button-primary button-wide ' + className,
                title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(labelCode, 'login'),
                click: function() {
                    form.clearErrors();
                    if (this.model.isValid()) {
                        this.model.set('factorType', factorType);
                        form.trigger('save', this.model);
                    }
                }
            });
        }
    },
    Footer: $58f9ab8c8f9b3995$var$ForgotPasswordControllerFooter,
    initialize: function() {
        this.options.appState.unset('username');
    }
});
































/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $0077b4018f3faaa0$var$Cookie = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).util.Cookie;
const $0077b4018f3faaa0$var$LAST_USERNAME_COOKIE_NAME = 'ln';
const $0077b4018f3faaa0$var$DAYS_SAVE_REMEMBER = 365;
const $0077b4018f3faaa0$export$2e2bcd8739ae039 = {};
$0077b4018f3faaa0$export$2e2bcd8739ae039.getCookieUsername = function() {
    return $0077b4018f3faaa0$var$Cookie.getCookie($0077b4018f3faaa0$var$LAST_USERNAME_COOKIE_NAME);
};
$0077b4018f3faaa0$export$2e2bcd8739ae039.setUsernameCookie = function(username) {
    $0077b4018f3faaa0$var$Cookie.setCookie($0077b4018f3faaa0$var$LAST_USERNAME_COOKIE_NAME, username, {
        expires: $0077b4018f3faaa0$var$DAYS_SAVE_REMEMBER,
        path: '/'
    });
};
$0077b4018f3faaa0$export$2e2bcd8739ae039.removeUsernameCookie = function() {
    $0077b4018f3faaa0$var$Cookie.removeCookie($0077b4018f3faaa0$var$LAST_USERNAME_COOKIE_NAME, {
        path: '/'
    });
};




/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $c182a29be5a2d495$export$2e2bcd8739ae039 = (0, $f24ef70ebb57d1e8$export$2e2bcd8739ae039).extend({
    props: function() {
        const cookieUsername = (0, $0077b4018f3faaa0$export$2e2bcd8739ae039).getCookieUsername();
        const properties = this.getUsernameAndRemember(cookieUsername);
        const props = {
            username: {
                type: 'string',
                validate: function(value) {
                    if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(value)) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('error.username.required', 'login');
                },
                value: properties.username
            },
            lastUsername: [
                'string',
                false,
                cookieUsername
            ],
            context: [
                'object',
                false
            ],
            remember: [
                'boolean',
                true,
                properties.remember
            ],
            multiOptionalFactorEnroll: [
                'boolean',
                true
            ]
        };
        if (!(this.settings && this.settings.get('features.passwordlessAuth'))) props.password = {
            type: 'string',
            validate: function(value) {
                if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(value)) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('error.password.required', 'login');
            }
        };
        return props;
    },
    getUsernameAndRemember: function(cookieUsername) {
        const settingsUsername = this.settings && this.settings.get('username');
        const rememberMeEnabled = this.settings && this.settings.get('features.rememberMe');
        let remember = false;
        let username;
        if (settingsUsername) {
            username = settingsUsername;
            remember = rememberMeEnabled && username === cookieUsername;
        } else if (rememberMeEnabled && cookieUsername) {
            // Only respect the cookie if the feature is enabled.
            // Allows us to force prompting when necessary, e.g. SAML ForceAuthn
            username = cookieUsername;
            remember = true;
        }
        return {
            username: username,
            remember: remember
        };
    },
    constructor: function(options) {
        this.settings = options && options.settings;
        this.appState = options && options.appState;
        (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039).apply(this, arguments);
        this.listenTo(this, 'change:username', function(model, username) {
            this.set({
                remember: username === this.get('lastUsername')
            });
        });
    },
    parse: function(options) {
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(options, [
            'settings',
            'appState'
        ]);
    },
    save: function() {
        const username = this.settings.transformUsername(this.get('username'), (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).PRIMARY_AUTH);
        const remember = this.get('remember');
        const lastUsername = this.get('lastUsername');
        this.setUsernameCookie(username, remember, lastUsername);
        //the 'save' event here is triggered and used in the BaseLoginController
        //to disable the primary button on the primary auth form
        this.trigger('save');
        this.appState.trigger('loading', true);
        const signInArgs = this.getSignInArgs(username);
        let primaryAuthPromise;
        if (this.appState.get('isUnauthenticated')) {
            const authClient = this.appState.settings.getAuthClient();
            // bootstrapped with stateToken
            if (this.appState.get('isIdxStateToken')) // if its an idx stateToken, we send the parameter as identifier to login API
            primaryAuthPromise = this.doTransaction(function(transaction) {
                return this.doPrimaryAuth(authClient, signInArgs, transaction.login);
            });
            else primaryAuthPromise = this.doTransaction(function(transaction) {
                return this.doPrimaryAuth(authClient, signInArgs, transaction.authenticate);
            }, true);
        } else //normal username/password flow without stateToken
        primaryAuthPromise = this.startTransaction(function(authClient) {
            return this.doPrimaryAuth(authClient, signInArgs, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(authClient.signInWithCredentials, authClient));
        });
        return primaryAuthPromise.catch(()=>{
            // Specific event handled by the Header for the case where the security image is not
            // enabled and we want to show a spinner. (Triggered only here and handled only by Header).
            this.appState.trigger('removeLoading');
            (0, $0077b4018f3faaa0$export$2e2bcd8739ae039).removeUsernameCookie();
        }).finally(()=>{
            this.appState.trigger('loading', false);
        });
    },
    getSignInArgs: function(username) {
        const multiOptionalFactorEnroll = this.get('multiOptionalFactorEnroll');
        const signInArgs = {};
        if (!this.settings.get('features.passwordlessAuth')) signInArgs.password = this.get('password');
        // if its an idx stateToken, we send the parameter as identifier to login API
        if (this.appState.get('isIdxStateToken')) signInArgs.identifier = username;
        else {
            //only post options param for non-idx flows
            signInArgs.username = username;
            signInArgs.options = {
                warnBeforePasswordExpired: true,
                multiOptionalFactorEnroll: multiOptionalFactorEnroll
            };
        }
        return signInArgs;
    },
    setUsernameCookie: function(username, remember, lastUsername) {
        // Do not modify the cookie when feature is disabled, relevant for SAML ForceAuthn prompts
        if (this.settings.get('features.rememberMe')) {
            // Only delete the cookie if its owner says so. This allows other
            // users to log in on a one-off basis.
            if (!remember && lastUsername === username) (0, $0077b4018f3faaa0$export$2e2bcd8739ae039).removeUsernameCookie();
            else if (remember) (0, $0077b4018f3faaa0$export$2e2bcd8739ae039).setUsernameCookie(username);
        }
    },
    doPrimaryAuth: function(authClient, signInArgs, func) {
        const deviceFingerprintEnabled = this.settings.get('features.deviceFingerprinting');
        const typingPatternEnabled = this.settings.get('features.trackTypingPattern');
        // Add the custom header for fingerprint, typing pattern if needed, and then remove it afterwards
        // Since we only need to send it for primary auth
        if (deviceFingerprintEnabled && this.appState.get('deviceFingerprint')) authClient.http.setRequestHeader('X-Device-Fingerprint', this.appState.get('deviceFingerprint'));
        if (typingPatternEnabled && this.appState.get('typingPattern')) authClient.http.setRequestHeader('X-Typing-Pattern', this.appState.get('typingPattern'));
        const self = this;
        return func(signInArgs).finally(function() {
            if (deviceFingerprintEnabled) {
                authClient.http.setRequestHeader('X-Device-Fingerprint', undefined);
                self.appState.unset('deviceFingerprint'); //Fingerprint can only be used once
            }
            if (typingPatternEnabled) {
                authClient.http.setRequestHeader('X-Typing-Pattern', undefined);
                self.appState.unset('typingPattern');
            }
        });
    }
});



/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $407c6069bc873ee6$export$2e2bcd8739ae039 = {
    generateDeviceFingerprint: function(authClient, container) {
        return authClient.fingerprint({
            timeout: 2000,
            container: container
        });
    }
};













const $29dcc243ce658051$var$SharedUtil = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).util.Util;
const $29dcc243ce658051$var$dividerTpl = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<div class=\"auth-divider\"><span class=\"auth-divider-text\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "text",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 58
                },
                "end": {
                    "line": 1,
                    "column": 66
                }
            }
        }) : helper)) + "</span></div>";
    },
    "useData": true
});
const $29dcc243ce658051$var$formTitleTpl = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<h2 data-se=\"o-form-head\" class=\"okta-form-title o-form-head\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "title",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 62
                },
                "end": {
                    "line": 1,
                    "column": 71
                }
            }
        }) : helper)) + "</h2>";
    },
    "useData": true
});
var $29dcc243ce658051$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'primary-auth-container',
    children: function() {
        const children = [];
        const socialIdpButtons = this.settings.get('configuredSocialIdps');
        const pivButton = this.settings.get('piv');
        const customButtons = this.settings.get('customButtons');
        const divider = $29dcc243ce658051$var$dividerTpl({
            text: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('socialauth.divider.text', 'login')
        });
        if (this.settings.get('hasPivCard')) children.push(this._createPivButton(pivButton));
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(socialIdpButtons, function(button) {
            children.push(this._createSocialIdpButton(button));
        }, this);
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(customButtons, function(button) {
            children.push(this._createCustomButton(button));
        }, this);
        // If the social auth buttons have to be above the Okta form, the title moves from
        // primary auth form to the social auth (above the buttons) and the divider goes below
        // the buttons (in between social auth and primary auth). If social auth needs to go below
        // Okta form, just add the divider at the top of the social auth container. The title still
        // lives in primary auth form.
        if (this.settings.get('socialAuthPositionTop')) {
            children.unshift($29dcc243ce658051$var$formTitleTpl({
                title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('primaryauth.title', 'login')
            }));
            // Divider between Primary Auth and the Social Auth
            children.push(divider);
        } else children.unshift(divider);
        return children;
    },
    _createSocialIdpButton: function(options) {
        return (0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
            attributes: {
                'data-se': options.dataAttr
            },
            className: options.className,
            title: function() {
                return options.text || (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(options.i18nKey);
            },
            click: function(e) {
                e.preventDefault();
                if (this.settings.get('oauth2Enabled')) (0, $5eccc61229d1b47f$export$2e2bcd8739ae039).getTokens(this.settings, {
                    idp: options.id
                }, this.options.currentController);
                else {
                    const baseUrl = this.settings.get('baseUrl');
                    let params;
                    const lastAuthResponse = this.options.appState.get('lastAuthResponse');
                    if (this.options.appState.get('usingDeviceFlow')) params = (0, $b51a961f9fe28c76$export$2e2bcd8739ae039).param({
                        stateToken: lastAuthResponse === null || lastAuthResponse === void 0 ? void 0 : lastAuthResponse.stateToken
                    });
                    else params = (0, $b51a961f9fe28c76$export$2e2bcd8739ae039).param({
                        fromURI: this.settings.get('relayState')
                    });
                    const targetUri = `${baseUrl}/sso/idps/${options.id}?${params}`;
                    $29dcc243ce658051$var$SharedUtil.redirect(targetUri);
                }
            }
        });
    },
    _createPivButton: function(options) {
        let className = options.className || '';
        return (0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
            attributes: {
                'data-se': 'piv-card-button'
            },
            className: className + ' piv-button',
            title: options.text || (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('piv.cac.card', 'login'),
            click: function(e) {
                e.preventDefault();
                this.options.appState.trigger('navigate', 'signin/verify/piv');
            }
        });
    },
    _createCustomButton: function(options) {
        return (0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
            attributes: {
                'data-se': options.dataAttr
            },
            className: options.className + ' default-custom-button',
            title: function() {
                return options.title || (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(options.i18nKey);
            },
            click: options.click
        });
    }
});













/*
 * Checking in as there is no npm module to consume. 
 * Current version is 2.15.
 * Repo - https://github.com/TypingDNA/TypingDnaRecorder-JavaScript
 */ /**
 * TypingDNA - Typing Biometrics JavaScript API
 * https://api.typingdna.com/scripts/typingdna.js
 * https://typingdna.com/scripts/typingdna.js (alternative)
 *
 * @version 2.15
 * @author Raul Popa
 * @copyright SC TypingDNA SRL, http://typingdna.com
 * @license http://www.apache.org/licenses/LICENSE-2.0
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Typical usage:
 * var tdna = new TypingDNA(); // creates a new TypingDNA object and starts recording
 * var typingPattern = tdna.getTypingPattern({type=1, text="Hello5g21?*"});
 * returns a type 1 typing pattern (and continues recording afterwards)
 *
 * Optional:
 * tdna.stop(); // ends recording and clears history stack (returns recording flag: false)
 * tdna.start(); // restarts the recording after a stop (returns recording flag: true)
 * tdna.reset(); // restarts the recording anytime, clears history stack and starts from scratch (returns nothing)
 * var typingPatternQuality = TypingDNA.getQuality(typingPattern); //returns the quality/strength of any typing pattern
 * (there is no need to initialize the class to do pattern quality checking)
 */ /**
 * Creates a single instance (or a reference) of the TypingDNA class
 * @return {Object} Returns the single instance of the TypingDNA class.
 * @example var tdna = new TypingDNA();
 */ var $3e5e1dad790d442b$export$2e2bcd8739ae039 = function TypingDNA() {
    if (TypingDNA.initialized != true) {
        TypingDNA.prototype.start = function() {
            return TypingDNA.start.apply(this, arguments);
        };
        TypingDNA.prototype.stop = function() {
            return TypingDNA.stop.apply(this, arguments);
        };
        TypingDNA.prototype.reset = function() {
            return TypingDNA.reset.apply(this, arguments);
        };
        TypingDNA.prototype.addTarget = function() {
            return TypingDNA.addTarget.apply(this, arguments);
        };
        TypingDNA.prototype.removeTarget = function() {
            return TypingDNA.removeTarget.apply(this, arguments);
        };
        TypingDNA.prototype.getTypingPattern = function() {
            return TypingDNA.getTypingPattern.apply(this, arguments);
        };
        TypingDNA.prototype.get = function() {
            // still works but will be deprecated in favor of getTypignPattern()
            return TypingDNA.get.apply(this, arguments);
        };
        TypingDNA.prototype.startDiagram = function() {
        // deprecated in favor of start()
        //return TypingDNA.startDiagram.apply(this, arguments);
        };
        TypingDNA.prototype.stopDiagram = function() {
        // deprecated in favor of stop()
        //return TypingDNA.stopDiagram.apply(this, arguments);
        };
        TypingDNA.prototype.getDiagram = function() {
            // still works but will be deprecated in favor of getTypignPattern()
            return TypingDNA.getDiagram.apply(this, arguments);
        };
        TypingDNA.prototype.getExtendedDiagram = function() {
            // still works but will be deprecated in favor of getTypignPattern()
            return TypingDNA.getExtendedDiagram.apply(this, arguments);
        };
        TypingDNA.prototype.getMouseDiagram = function() {
            return TypingDNA.getMouseDiagram.apply(this, arguments);
        };
        TypingDNA.prototype.startMouse = function() {
            return TypingDNA.startMouse.apply(this, arguments);
        };
        TypingDNA.prototype.stopMouse = function() {
            return TypingDNA.stopMouse.apply(this, arguments);
        };
        TypingDNA.prototype.getQuality = function() {
            return TypingDNA.getQuality.apply(this, arguments);
        };
        TypingDNA.prototype.getLength = function() {
            return TypingDNA.getLength.apply(this, arguments);
        };
        TypingDNA.prototype.isMobile = function() {
            return TypingDNA.isMobile.apply(this, arguments);
        };
        TypingDNA.prototype.getTextId = function() {
            return TypingDNA.getTextId.apply(this, arguments);
        };
        TypingDNA.initialized = true;
        TypingDNA.prototype.maxHistoryLength = TypingDNA.maxHistoryLength;
        TypingDNA.prototype.defaultHistoryLength = TypingDNA.defaultHistoryLength;
        TypingDNA.prototype.maxSeekTime = TypingDNA.maxSeekTime;
        TypingDNA.prototype.maxPressTime = TypingDNA.maxPressTime;
        TypingDNA.version = 2.15;
        TypingDNA.flags = 0;
        TypingDNA.instance = this;
        TypingDNA.document = document;
        TypingDNA.maxHistoryLength = 2000;
        TypingDNA.maxSeekTime = 1500;
        TypingDNA.maxPressTime = 300;
        TypingDNA.defaultHistoryLength = 160;
        TypingDNA.spKeyCodes = [
            8,
            13,
            32
        ];
        TypingDNA.spKeyCodesObj = {
            8: 1,
            13: 1,
            32: 1
        };
        TypingDNA.keyCodes = [
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            32,
            222,
            188,
            190,
            186,
            187,
            189,
            191,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57
        ];
        TypingDNA.keyCodesObj = {};
        for(var i in TypingDNA.keyCodes)TypingDNA.keyCodesObj[TypingDNA.keyCodes[i]] = 1;
        TypingDNA.pt1 = TypingDNA.ut1 = new Date().getTime();
        TypingDNA.wfk = [];
        TypingDNA.sti = [];
        TypingDNA.skt = [];
        TypingDNA.recording = true;
        TypingDNA.mouseRecording = true;
        TypingDNA.mouseMoveRecording = false;
        TypingDNA.spKeyRecording = true;
        TypingDNA.diagramRecording = true;
        TypingDNA.dwfk = [];
        TypingDNA.dsti = [];
        TypingDNA.dskt = [];
        TypingDNA.drkc = [];
        TypingDNA.dlastDownKey;
        TypingDNA.prevKeyCode = 0;
        TypingDNA.maxMoveDeltaTime = 600;
        TypingDNA.maxScrollDeltaTime = 800;
        TypingDNA.maxStopTime = 1500;
        TypingDNA.maxClickTime = 600;
        TypingDNA.maxMouseHistoryLength = 500;
        TypingDNA.lastMouseMoveTime = TypingDNA.lastMouseDownTime = new Date().getTime();
        TypingDNA.stopTimes = [];
        TypingDNA.clickTimes = [];
        TypingDNA.lastMouseStop = true;
        TypingDNA.zl = 0.0000001;
        TypingDNA.isAndroidChrome = false;
        TypingDNA.ACLastTime = new Date().getTime();
        TypingDNA.ACSeekTime = 0;
        TypingDNA.ACPressTime = 0;
        TypingDNA.ACLastCharCode = 0;
        TypingDNA.ACLastKeyCode = 0;
        TypingDNA.ACInputLengths = {
            inputs: [],
            lastLength: []
        };
        TypingDNA.ACPreviousKeyCode = 0;
        TypingDNA.targetIds = [];
        TypingDNA.lastTarget = "";
        TypingDNA.lastTargetFound = false;
        TypingDNA.replaceMissingKeys = true;
        TypingDNA.replaceMissingKeysPerc = 7;
        TypingDNA.keyDown = function(e) {
            if (!TypingDNA.recording && !TypingDNA.diagramRecording) return;
            if (!TypingDNA.isTarget(e.target.id)) return;
            var keyCode = e.keyCode;
            TypingDNA.wfk[keyCode] == 1 || TypingDNA.dwfk[keyCode];
            if (keyCode == 229 && TypingDNA.isMobile() && !TypingDNA.isAndroidChrome) {
                TypingDNA.isAndroidChrome = true;
                TypingDNA.ACSeekTime = new Date().getTime() - TypingDNA.ACLastTime;
                TypingDNA.ACLastTime = new Date().getTime();
                TypingDNA.document.removeEventListener("keydown", TypingDNA.keyDown);
                TypingDNA.document.removeEventListener("keyup", TypingDNA.keyUp);
                TypingDNA.document.removeEventListener("keypress", TypingDNA.keyPress);
                // if android
                TypingDNA.document.addEventListener("keydown", TypingDNA.ACKeyDown);
                TypingDNA.document.addEventListener("keyup", TypingDNA.ACKeyUp);
            } else {
                var t0 = TypingDNA.pt1;
                TypingDNA.pt1 = new Date().getTime();
                var seekTotal = TypingDNA.pt1 - t0;
                var startTime = TypingDNA.pt1;
                if (TypingDNA.recording == true || TypingDNA.spKeyCodesObj[keyCode] && TypingDNA.spKeyRecording == true) {
                    if (!e.shiftKey || TypingDNA.isMobile()) {
                        TypingDNA.wfk[keyCode] = 1;
                        TypingDNA.skt[keyCode] = seekTotal;
                        TypingDNA.sti[keyCode] = startTime;
                    }
                }
                if (TypingDNA.diagramRecording == true) {
                    TypingDNA.dwfk[keyCode] = 1;
                    TypingDNA.dskt[keyCode] = seekTotal;
                    TypingDNA.dsti[keyCode] = startTime;
                    TypingDNA.dlastDownKey = keyCode;
                }
            }
        };
        TypingDNA.keyPress = function(e) {
            if (!TypingDNA.recording && !TypingDNA.diagramRecording) return;
            if (!TypingDNA.isTarget(e.target.id)) return;
            if (TypingDNA.diagramRecording == true) {
                var keyCode = TypingDNA.dlastDownKey;
                TypingDNA.drkc[keyCode] = e.charCode;
            }
        };
        TypingDNA.keyUp = function(e) {
            if (!TypingDNA.recording && !TypingDNA.diagramRecording) return;
            if (!TypingDNA.isTarget(e.target.id)) return;
            var ut = new Date().getTime();
            var keyCode = e.keyCode;
            if (TypingDNA.recording == true || TypingDNA.spKeyCodesObj[keyCode] && TypingDNA.spKeyRecording == true) {
                if (!e.shiftKey || TypingDNA.isMobile()) {
                    if (TypingDNA.wfk[keyCode] == 1) {
                        var pressTime = ut - TypingDNA.sti[keyCode];
                        var seekTime = TypingDNA.skt[keyCode];
                        var arr = [
                            keyCode,
                            seekTime,
                            pressTime,
                            TypingDNA.prevKeyCode,
                            ut,
                            e.target.id
                        ];
                        TypingDNA.history.add(arr);
                        TypingDNA.prevKeyCode = keyCode;
                    }
                }
                TypingDNA.wfk[keyCode] = 0;
            }
            if (TypingDNA.diagramRecording == true) {
                if (TypingDNA.drkc[keyCode] != undefined && TypingDNA.drkc[keyCode] != 0) {
                    if (TypingDNA.dwfk[keyCode] == 1) {
                        var pressTime = ut - TypingDNA.dsti[keyCode];
                        var seekTime = TypingDNA.dskt[keyCode];
                        var realKeyCode = TypingDNA.drkc[keyCode];
                        var arrD = [
                            keyCode,
                            seekTime,
                            pressTime,
                            realKeyCode,
                            ut,
                            e.target.id
                        ];
                        TypingDNA.history.addDiagram(arrD);
                    }
                }
                TypingDNA.dwfk[keyCode] = 0;
            }
        };
        TypingDNA.mouseScroll = function(e) {
            if (TypingDNA.mouseRecording == true) {
                if (TypingDNA.mouseMoveRecording == true) {
                    if (TypingDNA.mouse.scrollStarted == true) {
                        var currentTime = new Date().getTime();
                        TypingDNA.mouse.scrollTimes.push(currentTime);
                        TypingDNA.mouse.scrollTopArr.push(TypingDNA.document.body.scrollTop);
                        clearInterval(TypingDNA.scrollInterval);
                        TypingDNA.scrollInterval = setInterval(TypingDNA.mouse.checkScroll, TypingDNA.maxScrollDeltaTime);
                    } else TypingDNA.mouse.scrollStarted = true;
                }
            }
        };
        TypingDNA.mouseMove = function(e) {
            if (TypingDNA.mouseRecording == true) {
                var currentTime = new Date().getTime();
                if (TypingDNA.mouseMoveRecording == true) {
                    if (TypingDNA.mouse.started == true) {
                        TypingDNA.mouse.times.push(currentTime);
                        TypingDNA.mouse.xPositions.push(e.screenX);
                        TypingDNA.mouse.yPositions.push(e.screenY);
                        clearInterval(TypingDNA.moveInterval);
                        TypingDNA.moveInterval = setInterval(TypingDNA.mouse.checkMove, TypingDNA.maxMoveDeltaTime);
                    } else TypingDNA.mouse.started = true;
                }
                TypingDNA.lastMouseMoveTime = currentTime;
            }
        };
        TypingDNA.mouseDown = function(e) {
            if (TypingDNA.mouseRecording == true) {
                TypingDNA.mouse.checkMove();
                TypingDNA.mouse.checkScroll();
                if (e.which == 1) {
                    TypingDNA.lastMouseDownTime = new Date().getTime();
                    var stopTime = TypingDNA.lastMouseDownTime - TypingDNA.lastMouseMoveTime;
                    if (stopTime < TypingDNA.maxStopTime && TypingDNA.lastMouseStop == false) {
                        TypingDNA.stopTimes.push(stopTime);
                        if (TypingDNA.mouseMoveRecording == true) {
                            var eventType = 3;
                            var arr = [
                                eventType,
                                stopTime
                            ];
                            TypingDNA.mouse.history.add(arr);
                            TypingDNA.lastMouseStop = true;
                        }
                    }
                }
            }
        };
        TypingDNA.mouseUp = function(e) {
            if (TypingDNA.mouseRecording == true) {
                if (e.which == 1) {
                    var clickTime = new Date().getTime() - TypingDNA.lastMouseDownTime;
                    if (clickTime < TypingDNA.maxClickTime && TypingDNA.lastMouseDownTime > TypingDNA.lastMouseMoveTime) {
                        TypingDNA.clickTimes.push(clickTime);
                        if (TypingDNA.mouseMoveRecording == true) {
                            var eventType = 4;
                            var arr = [
                                eventType,
                                clickTime
                            ];
                            TypingDNA.mouse.history.add(arr);
                        }
                    }
                }
            }
        };
        TypingDNA.ACKeyDown = function(e) {
            if (!TypingDNA.recording && !TypingDNA.diagramRecording) return;
            TypingDNA.ACSeekTime = new Date().getTime() - TypingDNA.ACLastTime;
            TypingDNA.ACLastTime = new Date().getTime();
            if (!TypingDNA.isTarget(e.target.id)) return;
            if (TypingDNA.ACInputLengths.inputs.indexOf(e.target) === -1) {
                TypingDNA.ACInputLengths.inputs.push(e.target);
                TypingDNA.ACInputLengths.lastLength.push(0);
            }
        };
        TypingDNA.ACKeyUp = function(e) {
            if (!TypingDNA.recording && !TypingDNA.diagramRecording) return;
            TypingDNA.ACPressTime = new Date().getTime() - TypingDNA.ACLastTime;
            TypingDNA.ACLastTime = new Date().getTime();
            if (!TypingDNA.isTarget(e.target.id)) return;
            var keyCode = e.keyCode;
            var targetIndex = TypingDNA.ACInputLengths.inputs.indexOf(e.target);
            if (targetIndex === -1) {
                TypingDNA.ACInputLengths.inputs.push(e.target);
                TypingDNA.ACInputLengths.lastLength.push(0);
                targetIndex = TypingDNA.ACInputLengths.inputs.indexOf(e.target);
            }
            if (keyCode == 229 && e.target.value.length >= TypingDNA.ACInputLengths.lastLength[targetIndex]) {
                var char = e.target.value.substr(e.target.selectionStart - 1 || 0, 1);
                keyCode = char.toUpperCase().charCodeAt(0);
                TypingDNA.ACLastCharCode = char.charCodeAt(0);
                TypingDNA.ACLastKeyCode = char.toUpperCase().charCodeAt(0);
            }
            TypingDNA.ACInputLengths.lastLength[targetIndex] = e.target.value.length;
            var arr = [
                keyCode,
                TypingDNA.ACSeekTime,
                TypingDNA.ACPressTime,
                TypingDNA.ACPreviousKeyCode,
                TypingDNA.ACLastTime
            ];
            TypingDNA.history.add(arr);
            TypingDNA.ACPreviousKeyCode = keyCode;
            if (TypingDNA.diagramRecording == true) {
                var arrD = [
                    keyCode,
                    TypingDNA.ACSeekTime,
                    TypingDNA.ACPressTime,
                    TypingDNA.ACLastCharCode
                ];
                TypingDNA.history.addDiagram(arrD);
            }
        };
        TypingDNA.isTarget = function(target) {
            if (TypingDNA.lastTarget == target && TypingDNA.lastTargetFound) return true;
            else {
                var targetLength1 = TypingDNA.targetIds.length;
                var targetFound = false;
                if (targetLength1 > 0) {
                    for(var i = 0; i < targetLength1; i++)if (TypingDNA.targetIds[i] == target) {
                        targetFound = true;
                        break;
                    }
                    TypingDNA.lastTarget = target;
                    TypingDNA.lastTargetFound = targetFound;
                    return targetFound;
                } else {
                    TypingDNA.lastTarget = target;
                    TypingDNA.lastTargetFound = true;
                    return true;
                }
            }
        };
        if (TypingDNA.document.addEventListener) {
            TypingDNA.document.addEventListener("keydown", TypingDNA.keyDown);
            TypingDNA.document.addEventListener("keyup", TypingDNA.keyUp);
            TypingDNA.document.addEventListener("keypress", TypingDNA.keyPress);
            TypingDNA.document.addEventListener("mousemove", TypingDNA.mouseMove);
            TypingDNA.document.addEventListener("mousedown", TypingDNA.mouseDown);
            TypingDNA.document.addEventListener("mouseup", TypingDNA.mouseUp);
            TypingDNA.document.addEventListener("scroll", TypingDNA.mouseScroll);
        } else if (TypingDNA.document.attachEvent) {
            TypingDNA.document.attachEvent("onkeydown", TypingDNA.keyDown);
            TypingDNA.document.attachEvent("onkeyup", TypingDNA.keyUp);
            TypingDNA.document.attachEvent("onkeypress", TypingDNA.keyPress);
            TypingDNA.document.attachEvent("onmousemove", TypingDNA.mouseMove);
            TypingDNA.document.attachEvent("onmousedown", TypingDNA.mouseDown);
            TypingDNA.document.attachEvent("onmouseup", TypingDNA.mouseUp);
            TypingDNA.document.attachEvent("onscroll", TypingDNA.mouseScroll);
        }
        TypingDNA.mouse = {};
        TypingDNA.mouse.times = [];
        TypingDNA.mouse.xPositions = [];
        TypingDNA.mouse.yPositions = [];
        TypingDNA.mouse.scrollTimes = [];
        TypingDNA.mouse.scrollTopArr = [];
        TypingDNA.mouse.history = {};
        TypingDNA.mouse.history.stack = [];
        TypingDNA.mouse.getDistance = function(a, b) {
            return Math.sqrt(a * a + b * b);
        };
        TypingDNA.mouse.getTotalDistance = function(xPositions, yPositions) {
            var totalDistance = 0;
            var length = xPositions.length;
            for(i = 1; i < length - 1; i++){
                var a = xPositions[i] - xPositions[i - 1];
                var b = yPositions[i] - yPositions[i - 1];
                totalDistance += TypingDNA.mouse.getDistance(a, b);
            }
            return totalDistance;
        };
        TypingDNA.mouse.getAngle = function(xPosDelta, yPosDelta) {
            var angle = 0;
            var leftRight = xPosDelta >= 0; // 1 if left, 0 if right
            var downUp = yPosDelta < 0; // 1 if down, 0 if up
            if (leftRight) {
                if (downUp) angle = 180 + Math.round(Math.atan(Math.abs(xPosDelta) / (Math.abs(yPosDelta) + 0.0000001)) / 0.01745329251); // 0.01745329251 = pi/180
                else angle = 270 + (90 - Math.round(Math.atan(Math.abs(xPosDelta) / (Math.abs(yPosDelta) + 0.0000001)) / 0.01745329251));
            } else if (downUp) angle = 90 + (90 - Math.round(Math.atan(Math.abs(xPosDelta) / (Math.abs(yPosDelta) + 0.0000001)) / 0.01745329251));
            else angle = Math.round(Math.atan(Math.abs(xPosDelta) / (Math.abs(yPosDelta) + 0.0000001)) / 0.01745329251);
            return angle;
        };
        TypingDNA.mouse.recordMoveAction = function() {
            var length = TypingDNA.mouse.times.length;
            if (length < 3) return;
            var deltaTime = TypingDNA.mouse.times[length - 1] - TypingDNA.mouse.times[0];
            var xPosDelta = TypingDNA.mouse.xPositions[length - 1] - TypingDNA.mouse.xPositions[0];
            var yPosDelta = TypingDNA.mouse.yPositions[length - 1] - TypingDNA.mouse.yPositions[0];
            var directDistance = Math.round(TypingDNA.mouse.getDistance(xPosDelta, yPosDelta));
            var totalDistance = Math.round(TypingDNA.mouse.getTotalDistance(TypingDNA.mouse.xPositions, TypingDNA.mouse.yPositions));
            var ratioDistance = Math.round(totalDistance * 100 / directDistance);
            var speed = Math.round(directDistance * 100 / deltaTime);
            var angle = TypingDNA.mouse.getAngle(xPosDelta, yPosDelta);
            var eventType = 1;
            var arr = [
                eventType,
                deltaTime,
                directDistance,
                speed,
                angle,
                ratioDistance
            ];
            for(i in arr){
                if (isNaN(arr[i])) return;
            }
            TypingDNA.mouse.history.add(arr);
            TypingDNA.lastMouseStop = false;
        };
        TypingDNA.mouse.recordScrollAction = function() {
            var length = TypingDNA.mouse.scrollTimes.length;
            if (length < 2) return;
            var deltaTime = TypingDNA.mouse.scrollTimes[length - 1] - TypingDNA.mouse.scrollTimes[0];
            var directDistance = TypingDNA.mouse.scrollTopArr[length - 1] - TypingDNA.mouse.scrollTopArr[0];
            var speed = Math.round(directDistance * 100 / deltaTime);
            var eventType = 2;
            var arr = [
                eventType,
                deltaTime,
                directDistance,
                speed
            ];
            for(i in arr){
                if (isNaN(arr[i]) && !isFinite(arr[i])) return;
            }
            TypingDNA.mouse.history.add(arr);
        };
        TypingDNA.mouse.history.add = function(arr) {
            this.stack.push(arr);
            if (this.stack.length > TypingDNA.maxMouseHistoryLength) this.stack.shift();
        };
        TypingDNA.mouse.history.getDiagram = function() {
            var mouseDiagram = this.stack.join("|");
            return [
                String(TypingDNA.isMobile()) + "," + String(TypingDNA.version),
                mouseDiagram
            ].join("|");
        };
        TypingDNA.mouse.clearLastMove = function() {
            TypingDNA.mouse.times = [];
            TypingDNA.mouse.xPositions = [];
            TypingDNA.mouse.yPositions = [];
        };
        TypingDNA.mouse.checkMove = function() {
            clearInterval(TypingDNA.moveInterval);
            if (TypingDNA.mouse.started == true) {
                TypingDNA.mouse.started = false;
                TypingDNA.mouse.recordMoveAction();
                TypingDNA.mouse.clearLastMove();
            }
        };
        TypingDNA.mouse.clearLastScroll = function() {
            TypingDNA.mouse.scrollTimes = [];
            TypingDNA.mouse.scrollTopArr = [];
        };
        TypingDNA.mouse.checkScroll = function() {
            clearInterval(TypingDNA.scrollInterval);
            if (TypingDNA.mouse.scrollStarted == true) {
                TypingDNA.mouse.scrollStarted = false;
                TypingDNA.mouse.recordScrollAction();
                TypingDNA.mouse.clearLastScroll();
            }
        };
        /**
     * Adds a target to the targetIds array.
     */ TypingDNA.addTarget = function(target) {
            var targetLength1 = TypingDNA.targetIds.length;
            var targetFound = false;
            if (targetLength1 > 0) {
                for(var i = 0; i < targetLength1; i++)if (TypingDNA.targetIds[i] == target) {
                    targetFound = true;
                    break;
                }
                if (!targetFound) TypingDNA.targetIds.push(target);
            } else TypingDNA.targetIds.push(target);
        };
        /**
     * Adds a target to the targetIds array.
     */ TypingDNA.removeTarget = function(target) {
            var targetLength1 = TypingDNA.targetIds.length;
            if (targetLength1 > 0) {
                for(var i = 0; i < targetLength1; i++)if (TypingDNA.targetIds[i] == target) {
                    TypingDNA.targetIds.splice(i, 1);
                    break;
                }
            }
        };
        /**
     * Resets the history stack
     */ TypingDNA.reset = function(all) {
            TypingDNA.history.stack = [];
            TypingDNA.history.stackDiagram = [];
            TypingDNA.clickTimes = [];
            TypingDNA.stopTimes = [];
            TypingDNA.ACInputLengths = {
                inputs: [],
                lastLength: []
            };
            if (all == true) TypingDNA.mouse.history.stack = [];
        };
        /**
     * Automatically called at initilization. It starts the recording of keystrokes.
     */ TypingDNA.start = function() {
            TypingDNA.diagramRecording = true;
            return TypingDNA.recording = true;
        };
        /**
     * Ends the recording of further keystrokes. To restart recording afterwards you can
     * either call TypingDNA.start() or create a new TypingDNA object again, not recommended.
     */ TypingDNA.stop = function() {
            TypingDNA.diagramRecording = false;
            return TypingDNA.recording = false;
        };
        /**
     * Starts the recording of mouse activity.
     */ TypingDNA.startMouse = function() {
            return TypingDNA.mouseRecording = TypingDNA.mouseMoveRecording = true;
        };
        /**
     * Stops the recording of mouse activity.
     */ TypingDNA.stopMouse = function() {
            return TypingDNA.mouseRecording = TypingDNA.mouseMoveRecording = false;
        };
        /**
     * This is the main function that outputs the typing pattern as a String
     * {type:Number, text:String, textId:Number, length: Number, targetId:String, caseSensitive:Boolean}
     * @param {Object} obj an object with the following properties
     * * * @param {String} type 0 for anytext pattern, 1 for sametext pattern (also called diagram pattern)
     * * * and 2 for extended pattern (most versatile, can replace both anytext and sametext patterns)
     * * * @param {Number} length (Optional) the length of the text in the history for which you want
     * * * the typing pattern. length is ignored when text or targetId is set (or both).
     * * * @param {String} text  (Only for type 1 and type 2) a typed string that you want the typing pattern for
     * * * @param {Number} textId (Optional, only for type 1 and type 2) a personalized id for the typed text
     * * * @param {String} targetId (Optional) specifies if pattern is obtain only from text typed in a certain target
     * * * @param {Boolean} caseSensitive (Optional, default: false) Used if you pass a text for type 1 or type 2
     * * * DEPRECATED * * * in favor of type = 2 * * *
     * * * @param {Boolean} extended (Only for type 1) specifies if full information about what was typed is produced,
     * * * including the actual key pressed, if false, only the order of pressed keys is kept (no actual content)
     * @return {String} A typing pattern in string form
     * @example var typingPattern = tdna.getTypingPattern({type=0, length=180});
     * @example var typingPattern = tdna.getTypingPattern({type=1, text="Hello5g21?*"});
     * @example var typingPattern = tdna.getTypingPattern({type=2, text="example@mail.com"});
     */ TypingDNA.getTypingPattern = function(obj) {
            if (typeof obj === 'object') switch(obj.type){
                case 0:
                    return TypingDNA.get(obj.length, obj.targetId);
                case 1:
                    var str = obj.text != undefined ? obj.text : obj.length;
                    return TypingDNA.history.getDiagram(obj.extended, str, obj.textId, obj.targetId, obj.caseSensitive);
                case 2:
                    var str = obj.text != undefined ? obj.text : obj.length;
                    return TypingDNA.history.getDiagram(true, str, obj.textId, obj.targetId, obj.caseSensitive);
                default:
                    return TypingDNA.get(obj.length);
            }
            else return TypingDNA.get();
        };
        TypingDNA.getDiagram = function(str, textId) {
            return TypingDNA.history.getDiagram(false, str, textId, undefined, false);
        };
        TypingDNA.getExtendedDiagram = function(str, textId) {
            return TypingDNA.history.getDiagram(true, str, textId, undefined, false);
        };
        TypingDNA.getMouseDiagram = function() {
            return TypingDNA.mouse.history.getDiagram();
        };
        TypingDNA.get = function(length, targetId) {
            var historyTotalLength = TypingDNA.history.stack.length;
            if (length == undefined || length == 0) length = TypingDNA.defaultHistoryLength;
            if (length > historyTotalLength) length = historyTotalLength;
            var obj = {};
            [obj.arr, targetLength] = TypingDNA.history.get(length, "", targetId);
            if (targetId != undefined && targetId != "") length = targetLength;
            var zl = TypingDNA.zl;
            var histRev = length;
            var histSktF = TypingDNA.math.fo(TypingDNA.history.get(length, "seek", targetId));
            var histPrtF = TypingDNA.math.fo(TypingDNA.history.get(length, "press", targetId));
            var pressHistMean = Math.round(TypingDNA.math.avg(histPrtF));
            var seekHistMean = Math.round(TypingDNA.math.avg(histSktF));
            var pressHistSD = Math.round(TypingDNA.math.sd(histPrtF));
            var seekHistSD = Math.round(TypingDNA.math.sd(histSktF));
            var charMeanTime = seekHistMean + pressHistMean;
            var pressRatio = TypingDNA.math.rd((pressHistMean + zl) / (charMeanTime + zl), 4);
            var seekToPressRatio = TypingDNA.math.rd((1 - pressRatio) / pressRatio, 4);
            var pressSDToPressRatio = TypingDNA.math.rd((pressHistSD + zl) / (pressHistMean + zl), 4);
            var seekSDToPressRatio = TypingDNA.math.rd((seekHistSD + zl) / (pressHistMean + zl), 4);
            var cpm = Math.round(6E4 / (charMeanTime + zl));
            if (histRev == 0) cpm = 0;
            for(var i in obj.arr){
                var rev = obj.arr[i][1].length;
                var seekMean = 0;
                var pressMean = 0;
                var postMean = 0;
                var seekSD = 0;
                var pressSD = 0;
                var postSD = 0;
                switch(obj.arr[i][0].length){
                    case 0:
                        break;
                    case 1:
                        var seekMean = TypingDNA.math.rd((obj.arr[i][0][0] + zl) / (seekHistMean + zl), 4);
                        break;
                    default:
                        var arr = TypingDNA.math.fo(obj.arr[i][0]);
                        seekMean = TypingDNA.math.rd((TypingDNA.math.avg(arr) + zl) / (seekHistMean + zl), 4);
                        seekSD = TypingDNA.math.rd((TypingDNA.math.sd(arr) + zl) / (seekHistSD + zl), 4);
                }
                switch(obj.arr[i][1].length){
                    case 0:
                        break;
                    case 1:
                        var pressMean = TypingDNA.math.rd((obj.arr[i][1][0] + zl) / (pressHistMean + zl), 4);
                        break;
                    default:
                        var arr = TypingDNA.math.fo(obj.arr[i][1]);
                        pressMean = TypingDNA.math.rd((TypingDNA.math.avg(arr) + zl) / (pressHistMean + zl), 4);
                        pressSD = TypingDNA.math.rd((TypingDNA.math.sd(arr) + zl) / (pressHistSD + zl), 4);
                }
                switch(obj.arr[i][2].length){
                    case 0:
                        break;
                    case 1:
                        var postMean = TypingDNA.math.rd((obj.arr[i][2][0] + zl) / (seekHistMean + zl), 4);
                        break;
                    default:
                        var arr = TypingDNA.math.fo(obj.arr[i][2]);
                        postMean = TypingDNA.math.rd((TypingDNA.math.avg(arr) + zl) / (seekHistMean + zl), 4);
                        postSD = TypingDNA.math.rd((TypingDNA.math.sd(arr) + zl) / (seekHistSD + zl), 4);
                }
                delete obj.arr[i][2];
                delete obj.arr[i][1];
                delete obj.arr[i][0];
                obj.arr[i][0] = rev;
                obj.arr[i][1] = seekMean;
                obj.arr[i][2] = pressMean;
                obj.arr[i][3] = postMean;
                obj.arr[i][4] = seekSD;
                obj.arr[i][5] = pressSD;
                obj.arr[i][6] = postSD;
            }
            var arr = [];
            TypingDNA.apu(arr, histRev);
            TypingDNA.apu(arr, cpm);
            TypingDNA.apu(arr, charMeanTime);
            TypingDNA.apu(arr, pressRatio);
            TypingDNA.apu(arr, seekToPressRatio);
            TypingDNA.apu(arr, pressSDToPressRatio);
            TypingDNA.apu(arr, seekSDToPressRatio);
            TypingDNA.apu(arr, pressHistMean);
            TypingDNA.apu(arr, seekHistMean);
            TypingDNA.apu(arr, pressHistSD);
            TypingDNA.apu(arr, seekHistSD);
            for(var c = 0; c <= 6; c++)for(var i = 0; i < 44; i++){
                var keyCode = TypingDNA.keyCodes[i];
                var val = obj.arr[keyCode][c];
                if (val == 0 && c > 0) val = 1;
                TypingDNA.apu(arr, val);
            }
            TypingDNA.apu(arr, TypingDNA.isMobile());
            TypingDNA.apu(arr, TypingDNA.version);
            TypingDNA.apu(arr, TypingDNA.flags);
            arr.push(TypingDNA.history.getSpecialKeys());
            return arr.join(",");
        };
        TypingDNA.apu = function(arr, val) {
            "NaN" == String(val) && (val = 0);
            arr.push(val);
        };
        TypingDNA.math = {};
        TypingDNA.math.rd = function(val, dec) {
            return Number(val.toFixed(dec));
        };
        TypingDNA.math.avg = function(arr) {
            var len = arr.length;
            if (len > 0) {
                var sum = 0;
                for(var i = 0; i < len; i++)sum += arr[i];
                return this.rd(sum / len, 4);
            } else return 0;
        };
        TypingDNA.math.sd = function(arr) {
            var len = arr.length;
            if (len < 2) return 0;
            else {
                var sumVS = 0;
                var mean = this.avg(arr);
                for(var i = 0; i < len; i++)sumVS += (arr[i] - mean) * (arr[i] - mean);
                var sd = Math.sqrt(sumVS / len);
                return sd;
            }
        };
        TypingDNA.math.fo = function(arr) {
            if (arr.length > 1) {
                var values = arr.concat();
                var len = arr.length;
                values.sort(function(a, b) {
                    return a - b;
                });
                var asd = this.sd(values);
                var aMean = values[Math.ceil(arr.length / 2)];
                var multiplier = 2;
                var maxVal = aMean + multiplier * asd;
                var minVal = aMean - multiplier * asd;
                if (len < 20) minVal = 0;
                var fVal = [];
                for(var i = 0; i < len; i++){
                    var tempval = values[i];
                    if (tempval < maxVal && tempval > minVal) fVal.push(tempval);
                }
                return fVal;
            } else return arr;
        };
        // Calculate a 32 bit FNV-1a hash
        TypingDNA.math.fnv1aHash = function(str) {
            if (str == undefined && typeof str !== 'string') return 0;
            str = str.toLowerCase();
            var i, l;
            var hval = 0x721b5ad4;
            for(i = 0, l = str.length; i < l; i++){
                hval ^= str.charCodeAt(i);
                hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
            }
            return hval >>> 0;
        };
        TypingDNA.history = {};
        TypingDNA.history.stack = [];
        TypingDNA.history.stackDiagram = [];
        TypingDNA.history.add = function(arr) {
            this.stack.push(arr);
            if (this.stack.length > TypingDNA.maxHistoryLength) this.stack.shift();
        };
        TypingDNA.history.addDiagram = function(arr) {
            this.stackDiagram.push(arr);
        };
        TypingDNA.history.getDiagram = function(extended, str, textId, targetId, caseSensitive) {
            var caseSensitive = caseSensitive != undefined ? caseSensitive : str == undefined || str == "";
            var returnArr = [];
            var diagramType = extended == true ? 1 : 0;
            var stackDiagram = this.stackDiagram;
            if (targetId != undefined && targetId != "" && stackDiagram.length > 0) {
                stackDiagram = TypingDNA.sliceStackByTargetId(stackDiagram, targetId);
                if (str == undefined || str == "") {
                    var element = TypingDNA.document.getElementById(targetId);
                    if (element != null) str = element.value;
                }
            } else {
                var targetLength1 = TypingDNA.targetIds.length;
                if (str == undefined || str == "") {
                    if (targetLength1 > 0) {
                        str = "";
                        for(var i = 0; i < targetLength1; i++){
                            var element = TypingDNA.document.getElementById(TypingDNA.targetIds[i]);
                            if (element != null) str += element.value;
                        }
                    }
                }
            }
            var missingCount = 0;
            var diagramHistoryLength = stackDiagram.length;
            var strLength = diagramHistoryLength;
            if (typeof str === 'string') strLength = str.length;
            else if (typeof str === 'number' && str < diagramHistoryLength) strLength = str;
            var returnTextId = 0;
            if (textId != undefined) {
                if (isNaN(parseInt(textId))) returnTextId = TypingDNA.math.fnv1aHash(textId);
                else returnTextId = parseInt(textId);
            } else if (typeof str === 'string') returnTextId = TypingDNA.math.fnv1aHash(str);
            returnArr.push([
                TypingDNA.isMobile(),
                TypingDNA.version,
                TypingDNA.flags,
                diagramType,
                strLength,
                returnTextId,
                TypingDNA.history.getSpecialKeys()
            ]);
            if (str != undefined && str.length > 0 && typeof str === 'string') {
                var strLower = str.toLowerCase();
                var strUpper = str.toUpperCase();
                var lastFoundPos = [];
                var lastPos = 0;
                var strUpperCharCode;
                var currentSensitiveCharCode;
                for(var i = 0; i < str.length; i++){
                    var currentCharCode = str.charCodeAt(i);
                    if (!caseSensitive) {
                        strUpperCharCode = strUpper.charCodeAt(i);
                        currentSensitiveCharCode = strUpperCharCode != currentCharCode ? strUpperCharCode : strLower.charCodeAt(i);
                    }
                    var startPos = lastPos;
                    var finishPos = diagramHistoryLength;
                    var found = false;
                    while(found == false){
                        for(var j = startPos; j < finishPos; j++){
                            var arr = stackDiagram[j];
                            var charCode = arr[3];
                            if (charCode == currentCharCode || !caseSensitive && charCode == currentSensitiveCharCode) {
                                found = true;
                                if (j == lastPos) {
                                    lastPos++;
                                    lastFoundPos = [];
                                } else {
                                    lastFoundPos.push(j);
                                    var len = lastFoundPos.length;
                                    if (len > 1 && lastFoundPos[len - 1] == lastFoundPos[len - 2] + 1) {
                                        lastPos = j + 1;
                                        lastFoundPos = [];
                                    }
                                }
                                var keyCode = arr[0];
                                var seekTime = arr[1];
                                var pressTime = arr[2];
                                if (extended) returnArr.push([
                                    charCode,
                                    seekTime,
                                    pressTime,
                                    keyCode
                                ]);
                                else returnArr.push([
                                    seekTime,
                                    pressTime
                                ]);
                                break;
                            }
                        }
                        if (found == false) {
                            if (startPos != 0) {
                                startPos = 0;
                                finishPos = lastPos;
                            } else {
                                found = true;
                                if (TypingDNA.replaceMissingKeys) {
                                    missingCount++;
                                    if (typeof TypingDNA.savedMissingAvgValues !== 'object' || TypingDNA.savedMissingAvgValues.historyLength != diagramHistoryLength) {
                                        var histSktF = TypingDNA.math.fo(TypingDNA.history.get(0, "seek"));
                                        var histPrtF = TypingDNA.math.fo(TypingDNA.history.get(0, "press"));
                                        var seekTime = Math.round(TypingDNA.math.avg(histSktF));
                                        var pressTime = Math.round(TypingDNA.math.avg(histPrtF));
                                        TypingDNA.savedMissingAvgValues = {
                                            seekTime: seekTime,
                                            pressTime: pressTime,
                                            historyLength: diagramHistoryLength
                                        };
                                    } else {
                                        var seekTime = TypingDNA.savedMissingAvgValues.seekTime;
                                        var pressTime = TypingDNA.savedMissingAvgValues.pressTime;
                                    }
                                    var missing = 1;
                                    if (extended) returnArr.push([
                                        currentCharCode,
                                        seekTime,
                                        pressTime,
                                        currentCharCode,
                                        missing
                                    ]);
                                    else returnArr.push([
                                        seekTime,
                                        pressTime,
                                        missing
                                    ]);
                                    break;
                                }
                            }
                        }
                    }
                    if (TypingDNA.replaceMissingKeysPerc < missingCount * 100 / strLength) return null;
                }
            } else {
                var startCount = 0;
                if (typeof str === 'number') startCount = diagramHistoryLength - str;
                if (startCount < 0) startCount = 0;
                for(var i = startCount; i < diagramHistoryLength; i++){
                    var arr = stackDiagram[i];
                    var keyCode = arr[0];
                    var seekTime = arr[1];
                    var pressTime = arr[2];
                    if (extended) {
                        var charCode = arr[3];
                        returnArr.push([
                            charCode,
                            seekTime,
                            pressTime,
                            keyCode
                        ]);
                    } else returnArr.push([
                        seekTime,
                        pressTime
                    ]);
                }
            }
            return returnArr.join("|");
        };
        TypingDNA.sliceStackByTargetId = function(stack, targetId) {
            var length = stack.length;
            var newStack = [];
            for(i = 0; i < length; i++){
                var arr = stack[i];
                if (arr[5] == targetId) newStack.push(arr);
            }
            return newStack;
        };
        TypingDNA.history.get = function(length, type, targetId) {
            var stack = this.stack;
            if (targetId != undefined && targetId != "" && stack.length > 0) stack = TypingDNA.sliceStackByTargetId(stack, targetId);
            var historyTotalLength = stack.length;
            if (length == 0 || length == undefined) length = TypingDNA.defaultHistoryLength;
            if (length > historyTotalLength) length = historyTotalLength;
            switch(type){
                case "seek":
                    var seekArr = [];
                    for(i = 1; i <= length; i++){
                        var seekTime = stack[historyTotalLength - i][1];
                        if (seekTime <= TypingDNA.maxSeekTime) seekArr.push(seekTime);
                    }
                    return seekArr;
                case "press":
                    var pressArr = [];
                    for(i = 1; i <= length; i++){
                        var pressTime = stack[historyTotalLength - i][2];
                        if (pressTime <= TypingDNA.maxPressTime) pressArr.push(pressTime);
                    }
                    return pressArr;
                default:
                    var historyStackObj = {};
                    for(var i in TypingDNA.keyCodes)historyStackObj[TypingDNA.keyCodes[i]] = [
                        [],
                        [],
                        []
                    ];
                    for(i = 1; i <= length; i++){
                        var arr = stack[historyTotalLength - i];
                        var keyCode = arr[0];
                        var seekTime = arr[1];
                        var pressTime = arr[2];
                        var prevKeyCode = arr[3];
                        if (TypingDNA.keyCodesObj[keyCode]) {
                            if (seekTime <= TypingDNA.maxSeekTime) {
                                historyStackObj[keyCode][0].push(seekTime);
                                if (prevKeyCode != 0 && TypingDNA.keyCodesObj[prevKeyCode]) historyStackObj[prevKeyCode][2].push(seekTime);
                            }
                            if (pressTime <= TypingDNA.maxPressTime) historyStackObj[keyCode][1].push(pressTime);
                        }
                    }
                    return [
                        historyStackObj,
                        length
                    ];
            }
        };
        TypingDNA.history.getSpecialKeys = function() {
            var returnArr = [];
            var length = this.stack.length;
            var historyStackObj = {};
            for(var i in TypingDNA.spKeyCodes)historyStackObj[TypingDNA.spKeyCodes[i]] = [
                []
            ];
            for(i = 1; i <= length; i++){
                var arr = this.stack[length - i];
                if (TypingDNA.spKeyCodesObj[arr[0]]) {
                    var keyCode = arr[0];
                    var pressTime = arr[2];
                    if (pressTime <= TypingDNA.maxPressTime) historyStackObj[keyCode][0].push(pressTime);
                }
            }
            for(var i in TypingDNA.spKeyCodes){
                var arr = TypingDNA.math.fo(historyStackObj[TypingDNA.spKeyCodes[i]][0]);
                var arrLen = arr.length;
                returnArr.push(arrLen);
                if (arrLen > 1) {
                    returnArr.push(Math.round(TypingDNA.math.avg(arr)));
                    returnArr.push(Math.round(TypingDNA.math.sd(arr)));
                } else if (arrLen == 1) returnArr.push([
                    arr[0],
                    -1
                ]);
                else returnArr.push([
                    -1,
                    -1
                ]);
            }
            var clicksArrLen = TypingDNA.clickTimes.length;
            returnArr.push(clicksArrLen);
            if (clicksArrLen > 1) {
                returnArr.push(Math.round(TypingDNA.math.avg(TypingDNA.clickTimes)));
                returnArr.push(Math.round(TypingDNA.math.sd(TypingDNA.clickTimes)));
            } else if (clicksArrLen == 1) returnArr.push(TypingDNA.clickTimes[0], -1);
            else returnArr.push([
                -1,
                -1
            ]);
            var stopArrLen = TypingDNA.stopTimes.length;
            returnArr.push(stopArrLen);
            if (stopArrLen > 1) {
                returnArr.push(Math.round(TypingDNA.math.avg(TypingDNA.stopTimes)));
                returnArr.push(Math.round(TypingDNA.math.sd(TypingDNA.stopTimes)));
            } else if (stopArrLen == 1) returnArr.push(TypingDNA.stopTimes[0], -1);
            else returnArr.push([
                -1,
                -1
            ]);
            return returnArr;
        };
        /**
     * Checks the quality of a typing pattern, how well it is revelated, how useful the
     * information will be for matching applications. It returns a value between 0 and 1.
     * Values over 0.3 are acceptable, however a value over 0.7 shows good pattern strength.
     * @param  {String} typingPattern The typing pattern string returned by the get() function.
     * @return {Number} A real number between 0 and 1. A close to 1 value means a stronger pattern.
     * @example var quality = tdna.getQuality(typingPattern);
     */ TypingDNA.getQuality = function(typingPattern) {
            var obj = typingPattern.split(",");
            for(i = 0; i < obj.length; i++)obj[i] = Number(obj[i]);
            obj[0];
            var acc = rec = avgAcc = 0;
            var avg = TypingDNA.math.avg(obj);
            var revs = obj.slice(11, 55);
            for(var i in revs){
                rec += Number(revs[i] > 0);
                acc += Number(revs[i] > 4);
                avgAcc += Number(revs[i] > avg);
            }
            var tReturn = Math.sqrt(rec * acc * avgAcc) / 80;
            return tReturn > 1 ? 1 : tReturn;
        };
        /**
     * Checks the validity of a typing pattern if recorded on mobile.
     * @param  {String} typingPattern The typing pattern string returned by the get() function.
     * @return {Number} A real number between 0 and 1. A number larger than 0.7 usually means a valid pattern.
     * @example var quality = tdna.checkMobileValidity(typingPattern);
     */ TypingDNA.checkMobileValidity = function(typingPattern) {
            var obj = typingPattern.split(",");
            var totalEvents = obj[0];
            if (totalEvents == 0) return 0;
            var rec1 = 0;
            var revs = obj.slice(11, 55);
            for(var i in revs)rec1 += Number(revs[i]);
            return rec1 / totalEvents;
        };
        TypingDNA.getLength = function(typingPattern) {
            return Number(typingPattern.split(",")[1]);
        };
        TypingDNA.isMobile = function() {
            if (TypingDNA.mobile != undefined) return TypingDNA.mobile;
            else {
                var check = 0;
                (function(a) {
                    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = 1;
                })(navigator.userAgent || navigator.vendor || window.opera);
                TypingDNA.mobile = check;
                return check;
            }
        };
        TypingDNA.getTextId = function(str) {
            return TypingDNA.math.fnv1aHash(str);
        };
    } else // TypingDNA is a static class, currently doesn't support actual multiple instances (Singleton implementation)
    return TypingDNA.instance;
};


/*!
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ let $042c84134c48f838$var$tdna;
var $042c84134c48f838$export$2e2bcd8739ae039 = {
    track: function(selectorId) {
        try {
            $042c84134c48f838$var$tdna = new (0, $3e5e1dad790d442b$export$2e2bcd8739ae039)();
            $042c84134c48f838$var$tdna.addTarget(selectorId);
            $042c84134c48f838$var$tdna.start();
        } catch (e) {
        // Issues in typing should not stop Primary auth.
        }
    },
    getTypingPattern: function() {
        try {
            return $042c84134c48f838$var$tdna.getTypingPattern({
                type: 1
            });
        } catch (e) {
            return null;
        }
    }
};




/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $bcf72ad9de12b4c1$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$a7fed597f4b8afd8).extend({
    className: 'primary-auth-form',
    noCancelButton: true,
    attributes: {
        novalidate: 'novalidate'
    },
    save: function() {
        if (this.settings.get('features.passwordlessAuth')) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oform.next', 'login');
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('primaryauth.submit', 'login');
    },
    saveId: 'okta-signin-submit',
    layout: 'o-form-theme',
    // If socialAuth is configured, the title moves from the form to
    // the top of the container (and is rendered in socialAuth).
    title: function() {
        let formTitle = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('primaryauth.title', 'login');
        if (this.settings.get('socialAuthPositionTop')) formTitle = '';
        return formTitle;
    },
    initialize: function() {
        const trackTypingPattern = this.settings.get('features.trackTypingPattern');
        this.listenTo(this, 'save', async function() {
            const { appState: appState } = this.options;
            if (trackTypingPattern) {
                const typingPattern = (0, $042c84134c48f838$export$2e2bcd8739ae039).getTypingPattern();
                appState.set('typingPattern', typingPattern);
            }
            const creds = {
                username: this.model.get('username')
            };
            if (!this.settings.get('features.passwordlessAuth')) creds.password = this.model.get('password');
            // show loading spinner and disable submit button before processCreds hook runs
            appState.trigger('loading', true);
            this.state.trigger('togglePrimaryAuthButton', true);
            await this.settings.processCreds(creds);
            if (this.settings.get('features.deviceFingerprinting')) try {
                const fingerprint = await (0, $407c6069bc873ee6$export$2e2bcd8739ae039).generateDeviceFingerprint(this.settings.getAuthClient(), this.$el[0]);
                appState.set('deviceFingerprint', fingerprint);
            } catch  {
            // Keep going even if device fingerprint fails
            }
            this.model.save();
        });
        this.stateEnableChange();
        this.stateUsernameChange();
    },
    stateEnableChange: function() {
        this.listenTo(this.state, 'change:enabled', function(model, enable) {
            if (enable) this.enable();
            else this.disable();
        });
    },
    stateUsernameChange: function() {
        this.listenTo(this.state, 'change:disableUsername', function(model, disable) {
            if (disable) this.$el.find('#okta-signin-username').attr('disabled', true);
            else this.$el.find('#okta-signin-username').removeAttr('disabled');
        });
    },
    inputs: function() {
        const inputs = [];
        inputs.push(this.getUsernameField());
        if (!this.settings.get('features.passwordlessAuth')) inputs.push(this.getPasswordField());
        if (this.settings.get('features.rememberMe')) inputs.push(this.getRemeberMeCheckbox());
        return inputs;
    },
    getUsernameField: function() {
        const userNameFieldObject = {
            className: 'margin-btm-5',
            label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('primaryauth.username.placeholder', 'login'),
            'label-top': true,
            explain: ()=>{
                if (!this.isCustomized('primaryauth.username.tooltip')) return false;
                return (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).createInputExplain('primaryauth.username.tooltip', 'primaryauth.username.placeholder', 'login');
            },
            'explain-top': true,
            name: 'username',
            input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
            inputId: 'okta-signin-username',
            type: 'text',
            disabled: this.options.appState.get('disableUsername'),
            autoComplete: (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).getAutocompleteValue(this.settings, 'username'),
            // TODO: support a11y attrs in Courage - OKTA-279025
            render: function() {
                const that = this;
                function clearAriaInvalid() {
                    that.$(this).removeAttr('aria-invalid').off('focusout', clearAriaInvalid).off('change', clearAriaInvalid);
                }
                this.$(`input[name=${this.options.name}]`)// OKTA-430928: to prevent NVDA and JAWS screen readers from
                // announcing "required invalid entry" before the user has a chance to
                // complete the field, aria-invalid is set to "false" initially and
                // removed on focusout or change using clearAriaInvalid()
                .attr({
                    'aria-invalid': 'false',
                    'aria-required': 'true'
                }).prop({
                    required: true
                }).focusout(clearAriaInvalid).change(clearAriaInvalid);
            }
        };
        return userNameFieldObject;
    },
    getPasswordField: function() {
        const passwordFieldObject = {
            className: 'margin-btm-30',
            label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('primaryauth.password.placeholder', 'login'),
            'label-top': true,
            explain: ()=>{
                if (!this.isCustomized('primaryauth.password.tooltip')) return false;
                return (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).createInputExplain('primaryauth.password.tooltip', 'primaryauth.password.placeholder', 'login');
            },
            'explain-top': true,
            name: 'password',
            inputId: 'okta-signin-password',
            validateOnlyIfDirty: true,
            type: 'password',
            autoComplete: (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).getAutocompleteValue(this.settings, 'current-password'),
            // TODO: support a11y attrs in Courage - OKTA-279025
            render: function() {
                const that = this;
                function clearAriaInvalid() {
                    that.$(this).removeAttr('aria-invalid').off('focusout', clearAriaInvalid).off('change', clearAriaInvalid);
                }
                this.$(`input[name=${this.options.name}]`)// OKTA-430928: to prevent NVDA and JAWS screen readers from
                // announcing "required invalid entry" before the user has a chance to
                // complete the field, aria-invalid is set to "false" initially and
                // removed on focusout or change using clearAriaInvalid()
                .attr({
                    'aria-invalid': 'false',
                    'aria-required': 'true'
                }).prop({
                    required: true
                }).focusout(clearAriaInvalid).change(clearAriaInvalid);
            }
        };
        if (this.settings.get('features.showPasswordToggleOnSignInPage')) {
            passwordFieldObject.params = {};
            passwordFieldObject.params.showPasswordToggle = true;
        }
        return passwordFieldObject;
    },
    isCustomized: function(property) {
        const language = this.settings.get('language');
        const i18n = this.settings.get('i18n');
        const customizedProperty = i18n && i18n[language] && i18n[language][property];
        return !!customizedProperty;
    },
    // TODO fix method name typo
    getRemeberMeCheckbox: function() {
        return {
            label: false,
            placeholder: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('remember', 'login'),
            name: 'remember',
            type: 'checkbox',
            'label-top': true,
            className: 'margin-btm-0',
            initialize: function() {
                this.listenTo(this.model, 'change:remember', function(model, val) {
                    // OKTA-98946: We normally re-render on changes to model values,
                    // but in this case we will manually update the checkbox due to
                    // iOS Safari and how it handles autofill - it will autofill the
                    // form anytime the dom elements are re-rendered, which prevents
                    // the user from editing their username.
                    this.$(':checkbox').prop('checked', val).trigger('updateState');
                });
            }
        };
    },
    focus: function() {
        if (!this.model.get('username')) this.getInputs().first().focus();
        else if (!this.settings.get('features.passwordlessAuth')) this.getInputs().toArray()[1].focus();
        if (this.settings.get('features.trackTypingPattern')) (0, $042c84134c48f838$export$2e2bcd8739ae039).track('okta-signin-username');
    }
});












const { Util: $9a69d199e6b8e739$var$Util } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).util;
var $9a69d199e6b8e739$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<li><a href=\"#\" data-se=\"unlock\" class=\"link js-unlock\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "unlockaccount"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 440
                    },
                    "end": {
                        "line": 1,
                        "column": 484
                    }
                }
            })) + "</a></li>";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<li><a href=\"" + alias4((helper = (helper = lookupProperty(helpers, "href") || (depth0 != null ? lookupProperty(depth0, "href") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "href",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 539
                    },
                    "end": {
                        "line": 1,
                        "column": 547
                    }
                }
            }) : helper)) + "\" class=\"link js-custom\" rel=\"noopener noreferrer\" " + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "target") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(2, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 598
                    },
                    "end": {
                        "line": 1,
                        "column": 638
                    }
                }
            })) != null ? stack1 : "") + ">" + alias4((helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "text",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 639
                    },
                    "end": {
                        "line": 1,
                        "column": 647
                    }
                }
            }) : helper)) + "</a></li>";
        },
        "2": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "target=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "target") || (depth0 != null ? lookupProperty(depth0, "target") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "target",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 620
                    },
                    "end": {
                        "line": 1,
                        "column": 630
                    }
                }
            }) : helper)) + "\"";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a href=\"#\" data-se=\"needhelp\" aria-expanded=\"false\" aria-controls=\"help-links-container\" class=\"link help js-help\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "needhelp"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 116
                    },
                    "end": {
                        "line": 1,
                        "column": 155
                    }
                }
            })) + "</a><ul class=\"help-links js-help-links\" id=\"help-links-container\"><li><a href=\"#\" data-se=\"forgot-password\" class=\"link js-forgot-password\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "forgotpassword"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 296
                    },
                    "end": {
                        "line": 1,
                        "column": 341
                    }
                }
            })) + "</a></li>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "features") : depth0) != null ? lookupProperty(stack1, "selfServiceUnlock") : stack1, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 350
                    },
                    "end": {
                        "line": 1,
                        "column": 500
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "each").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "helpLinks") : depth0) != null ? lookupProperty(stack1, "custom") : stack1, {
                "name": "each",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 500
                    },
                    "end": {
                        "line": 1,
                        "column": 665
                    }
                }
            })) != null ? stack1 : "") + "<li><a href=\"" + alias3((helper = (helper = lookupProperty(helpers, "helpLinkUrl") || (depth0 != null ? lookupProperty(depth0, "helpLinkUrl") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
                "name": "helpLinkUrl",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 678
                    },
                    "end": {
                        "line": 1,
                        "column": 693
                    }
                }
            }) : helper)) + "\" data-se=\"help-link\" class=\"link js-help-link\" rel=\"noopener noreferrer\" target=\"_blank\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "help"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 783
                    },
                    "end": {
                        "line": 1,
                        "column": 818
                    }
                }
            })) + "</a></li></ul>";
        },
        "useData": true
    }),
    className: 'auth-footer',
    initialize: function() {
        this.listenTo(this.state, 'change:enabled', function(model, enable) {
            this.$('.link').toggleClass('o-form-disabled', !enable);
        });
    },
    getTemplateData: function() {
        let helpLinkUrl;
        const customHelpPage = this.settings.get('helpLinks.help');
        if (customHelpPage) helpLinkUrl = customHelpPage;
        else helpLinkUrl = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
            "compiler": [
                8,
                ">= 4.3.0"
            ],
            "main": function(container, depth0, helpers, partials, data) {
                var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                    return undefined;
                };
                return container.escapeExpression((helper = (helper = lookupProperty(helpers, "baseUrl") || (depth0 != null ? lookupProperty(depth0, "baseUrl") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                    "name": "baseUrl",
                    "hash": {},
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 0
                        },
                        "end": {
                            "line": 1,
                            "column": 11
                        }
                    }
                }) : helper)) + "/help/login";
            },
            "useData": true
        })({
            baseUrl: this.settings.get('baseUrl')
        });
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend(this.settings.toJSON({
            verbose: true
        }), {
            helpLinkUrl: helpLinkUrl
        });
    },
    postRender: function() {
        this.$('.js-help-links').hide();
    },
    toggleLinks: function(e) {
        e.preventDefault();
        this.$('.js-help-links').slideToggle(200, ()=>{
            this.$('.js-help').attr('aria-expanded', this.$('.js-help-links').is(':visible'));
        });
    },
    events: {
        'click .js-help': function(e) {
            e.preventDefault();
            if (!this.state.get('enabled')) return;
            this.toggleLinks(e);
        },
        'click .js-forgot-password': function(e) {
            e.preventDefault();
            if (!this.state.get('enabled')) return;
            const customResetPasswordPage = this.settings.get('helpLinks.forgotPassword');
            if (customResetPasswordPage) $9a69d199e6b8e739$var$Util.redirect(customResetPasswordPage);
            else this.options.appState.trigger('navigate', 'signin/forgot-password');
        },
        'click .js-unlock': function(e) {
            e.preventDefault();
            if (!this.state.get('enabled')) return;
            const customUnlockPage = this.settings.get('helpLinks.unlock');
            if (customUnlockPage) $9a69d199e6b8e739$var$Util.redirect(customUnlockPage);
            else this.options.appState.trigger('navigate', 'signin/unlock');
        }
    }
});












var $1c1efde264a39f89$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"content-container\"><span class=\"registration-label\">" + alias4((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "label",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 64
                    },
                    "end": {
                        "line": 1,
                        "column": 73
                    }
                }
            }) : helper)) + "</span><a title=\"" + alias4((helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "text",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 90
                    },
                    "end": {
                        "line": 1,
                        "column": 98
                    }
                }
            }) : helper)) + "\" aria-label=\"" + alias4((helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "text",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 112
                    },
                    "end": {
                        "line": 1,
                        "column": 120
                    }
                }
            }) : helper)) + "\" class=\"registration-link\" href=\"#\">" + alias4((helper = (helper = lookupProperty(helpers, "text") || (depth0 != null ? lookupProperty(depth0, "text") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "text",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 157
                    },
                    "end": {
                        "line": 1,
                        "column": 165
                    }
                }
            }) : helper)) + "</a></div>";
        },
        "useData": true
    }),
    className: 'registration-container',
    events: {
        'click a.registration-link': 'handleClickEvent'
    },
    handleClickEvent: function(e) {
        e.preventDefault();
        const clickHandler = this.settings.get('registration.click');
        if (clickHandler) clickHandler();
        else if (this.options.appState.get('isIdxStateToken')) this.options.appState.trigger('navigate', 'signin/enroll-user');
        else this.options.appState.trigger('navigate', 'signin/register');
    },
    getTemplateData: function() {
        const templateData = {
            label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('registration.signup.label', 'login'),
            text: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('registration.signup.text', 'login')
        };
        return templateData;
    }
});



/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $6e97c0d7c1dd8871$export$2e2bcd8739ae039 = (0, $6887ec4c502ac936$export$2e2bcd8739ae039).extend({
    className: 'primary-auth',
    state: {
        enabled: true
    },
    View: (0, $bcf72ad9de12b4c1$export$2e2bcd8739ae039),
    constructor: function(options) {
        options.appState.unset('username');
        this.model = new (0, $c182a29be5a2d495$export$2e2bcd8739ae039)({
            multiOptionalFactorEnroll: options.settings.get('features.multiOptionalFactorEnroll'),
            settings: options.settings,
            appState: options.appState
        }, {
            parse: true
        });
        (0, $6887ec4c502ac936$export$2e2bcd8739ae039).apply(this, arguments);
        this.addListeners();
        // If social auth is configured, 'socialAuthPositionTop' will determine
        // the order in which the social auth and primary auth are shown on the screen.
        if (options.settings.get('hasConfiguredButtons')) this.add((0, $29dcc243ce658051$export$2e2bcd8739ae039), {
            prepend: options.settings.get('socialAuthPositionTop'),
            options: {
                // To trigger an afterError event, we require the current controller
                currentController: this
            }
        });
        this.addFooter(options);
        if (this.options.appState.get('disableUsername')) this.addFooterWithBackLink(this.options);
        this.setUsername();
    },
    addFooter: function(options) {
        this.add(new (0, $9a69d199e6b8e739$export$2e2bcd8739ae039)(this.toJSON({
            appState: options.appState
        })));
        if (options.settings.get('features.registration') || options.appState.get('isIdxStateToken')) this.add(new (0, $1c1efde264a39f89$export$2e2bcd8739ae039)({
            settings: this.settings,
            appState: options.appState
        }));
    },
    addFooterWithBackLink: function(options) {
        if (!this.$el.find('.footer-back-link').length) this.add(new (0, $724391db7f3cb295$export$2e2bcd8739ae039)(this.toJSON({
            appState: options.appState,
            className: 'auth-footer footer-back-link'
        })));
    },
    setUsername: function() {
        const username = this.model.get('username');
        if (username) this.options.appState.set('username', username);
    },
    setUsernameFromIdpDiscovery: function() {
        const username = this.options.username;
        if (username) {
            this.model.set('username', username);
            this.options.appState.set('disableUsername', true);
        }
    },
    events: {
        'focusout input[name=username]': function() {
            if (this.shouldComputeDeviceFingerprint() && this.model.get('username')) {
                const self = this;
                this.options.appState.trigger('loading', true);
                (0, $407c6069bc873ee6$export$2e2bcd8739ae039).generateDeviceFingerprint(this.settings.getAuthClient(), this.$el[0]).then(function(fingerprint) {
                    self.options.appState.set('deviceFingerprint', fingerprint);
                    self.options.appState.set('username', self.model.get('username'));
                }).catch(function() {
                    // Keep going even if device fingerprint fails
                    self.options.appState.set('username', self.model.get('username'));
                }).finally(function() {
                    self.options.appState.trigger('loading', false);
                });
            } else this.options.appState.set('username', this.model.get('username'));
        },
        'focusin input': function(e) {
            (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(e.target.parentElement).addClass('focused-input');
        },
        'focusout input': function(e) {
            (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(e.target.parentElement).removeClass('focused-input');
        }
    },
    // This model and the AppState both have a username property.
    // The controller updates the AppState's username when the user is
    // done editing (on blur) or deletes the username (see below).
    initialize: function() {
        this.options.appState.unset('deviceFingerprint');
        if (this.settings.get('features.prefillUsernameFromIdpDiscovery')) this.setUsernameFromIdpDiscovery();
        this.listenTo(this.model, 'change:username', function(model, value) {
            if (!value) // reset AppState to an undefined user.
            this.options.appState.set('username', '');
        });
        this.listenTo(this.model, 'save', function() {
            this.state.set('enabled', false);
        });
        this.listenTo(this.model, 'error', function() {
            this.state.set('enabled', true);
            if (this.options.appState.get('disableUsername')) {
                this.state.set('disableUsername', true);
                this.addFooterWithBackLink(this.options);
            }
        });
        this.listenTo(this.state, 'togglePrimaryAuthButton', function(buttonState) {
            this.toggleButtonState(buttonState);
        });
    },
    shouldComputeDeviceFingerprint: function() {
        return this.settings.get('features.securityImage') && this.settings.get('features.deviceFingerprinting') && this.settings.get('features.useDeviceFingerprintForSecurityImage');
    }
});
















/*!
 * Copyright (c) 2015-2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $83b4700a60135a5a$export$2e2bcd8739ae039 = (0, $c182a29be5a2d495$export$2e2bcd8739ae039).extend({
    props: function() {
        const cookieUsername = (0, $0077b4018f3faaa0$export$2e2bcd8739ae039).getCookieUsername();
        const properties = this.getUsernameAndRemember(cookieUsername);
        return {
            username: [
                'string',
                true,
                properties.username
            ],
            lastUsername: [
                'string',
                false,
                cookieUsername
            ],
            context: [
                'object',
                false
            ],
            remember: [
                'boolean',
                true,
                properties.remember
            ]
        };
    },
    local: {},
    save: function() {
        const username = this.settings.transformUsername(this.get('username'), (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).IDP_DISCOVERY);
        const remember = this.get('remember');
        const lastUsername = this.get('lastUsername');
        const resource = 'okta:acct:' + username;
        const requestContext = this.get('requestContext');
        this.setUsernameCookie(username, remember, lastUsername);
        //the 'save' event here is triggered and used in the BaseLoginController
        //to disable the primary button
        this.trigger('save');
        this.appState.trigger('loading', true);
        const webfingerArgs = {
            resource: resource,
            requestContext: requestContext
        };
        const authClient = this.appState.settings.getAuthClient();
        authClient.webfinger(webfingerArgs).then((res)=>{
            if (res && res.links && res.links[0]) {
                if (res.links[0].properties['okta:idp:type'] === 'OKTA') this.trigger('goToPrimaryAuth');
                else if (res.links[0].href) {
                    const redirectFn = res.links[0].href.includes('OKTA_INVALID_SESSION_REPOST%3Dtrue') ? (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).redirectWithFormGet.bind((0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039)) : this.settings.get('redirectUtilFn');
                    //override redirectFn to only use Util.redirectWithFormGet if OKTA_INVALID_SESSION_REPOST is included
                    //it will be encoded since it will be included in the encoded fromURI
                    redirectFn(res.links[0].href);
                }
            }
        }).catch(()=>{
            // webfinger request might fail when corporate proxy checks if request is 'authenticated' using cookies
            const error = {
                errorSummary: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oform.error.webfinger', 'login')
            };
            this.trigger('error', this, {
                responseJSON: error
            });
            // Specific event handled by the Header for the case where the security image is not
            // enabled and we want to show a spinner. (Triggered only here and handled only by Header).
            this.appState.trigger('removeLoading');
            (0, $0077b4018f3faaa0$export$2e2bcd8739ae039).removeUsernameCookie();
        }).finally(()=>{
            this.appState.trigger('loading', false);
        });
    }
});















/*!
 * Copyright (c) 2015-2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $c717a457403219be$export$2e2bcd8739ae039 = (0, $bcf72ad9de12b4c1$export$2e2bcd8739ae039).extend({
    className: 'idp-discovery-form',
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oform.next', 'login');
    },
    saveId: 'idp-discovery-submit',
    initialize: function() {
        this.listenTo(this, 'save', (0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(this.model.save, this.model));
        this.stateEnableChange();
    },
    inputs: function() {
        const inputs = [];
        const usernameProps = {
            className: 'margin-btm-30',
            label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('primaryauth.username.placeholder', 'login'),
            inputId: 'idp-discovery-username',
            disabled: false
        };
        inputs.push((0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend(this.getUsernameField(), usernameProps));
        if (this.settings.get('features.rememberMe')) inputs.push(this.getRemeberMeCheckbox());
        return inputs;
    },
    focus: function() {
        if (!this.model.get('username')) this.getInputs().first().focus();
        else if (this.getInputs().toArray()[1]) this.getInputs().toArray()[1].focus();
    }
});






/*!
 * Copyright (c) 2015-2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $c55ecccdf1ee9c35$export$2e2bcd8739ae039 = (0, $6e97c0d7c1dd8871$export$2e2bcd8739ae039).extend({
    className: 'idp-discovery',
    View: (0, $c717a457403219be$export$2e2bcd8739ae039),
    constructor: function(options) {
        options.appState.unset('username');
        let requestContext = options.settings.get('idpDiscovery.requestContext');
        const lastAuthResponse = options.appState.get('lastAuthResponse');
        const stateToken = lastAuthResponse && (lastAuthResponse === null || lastAuthResponse === void 0 ? void 0 : lastAuthResponse.stateToken);
        //Update requestContext with last stateToken, if the context was stateToken and not a fromUri
        if ((0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).isV1StateToken(requestContext)) requestContext = stateToken;
        this.model = new (0, $83b4700a60135a5a$export$2e2bcd8739ae039)({
            requestContext: requestContext,
            settings: options.settings,
            appState: options.appState
        }, {
            parse: true
        });
        (0, $6887ec4c502ac936$export$2e2bcd8739ae039).apply(this, arguments);
        this.addListeners();
        // If social auth is configured, 'socialAuthPositionTop' will determine
        // the order in which the social auth and primary auth are shown on the screen.
        if (options.settings.get('hasConfiguredButtons')) this.add((0, $29dcc243ce658051$export$2e2bcd8739ae039), {
            prepend: options.settings.get('socialAuthPositionTop'),
            options: {
                // To trigger an afterError event, we require the current controller
                currentController: this
            }
        });
        this.addFooter(options);
        this.setUsername();
    },
    initialize: function() {
        (0, $6e97c0d7c1dd8871$export$2e2bcd8739ae039).prototype.initialize.apply(this);
        this.listenTo(this.model, 'goToPrimaryAuth', function() {
            this.settings.set('username', this.model.get('username'));
            const self = this;
            if (this.settings.get('features.deviceFingerprinting')) (0, $407c6069bc873ee6$export$2e2bcd8739ae039).generateDeviceFingerprint(this.settings.getAuthClient(), this.$el[0]).then(function(fingerprint) {
                self.options.appState.set('deviceFingerprint', fingerprint);
                self.options.appState.set('username', self.model.get('username'));
            }).catch(function() {
                // Keep going even if device fingerprint fails
                self.options.appState.set('username', self.model.get('username'));
            }).finally(function() {
                self.doPrimaryAuth();
            });
            else self.doPrimaryAuth();
        });
    },
    doPrimaryAuth: function() {
        if (this.settings.get('features.passwordlessAuth')) {
            const primaryAuthModel = new (0, $c182a29be5a2d495$export$2e2bcd8739ae039)({
                username: this.model.get('username'),
                multiOptionalFactorEnroll: this.options.settings.get('features.multiOptionalFactorEnroll'),
                settings: this.options.settings,
                appState: this.options.appState
            }, {
                parse: true
            });
            // Events to set the transaction attributes on the app state.
            this.listenTo(primaryAuthModel, 'error', function(src, errObj) {
                this.toggleButtonState(false);
                this.model.trigger('error', this.model, errObj);
            });
            this.addModelListeners(primaryAuthModel);
            // Make the primary auth request
            primaryAuthModel.save();
        } else {
            this.options.appState.set('disableUsername', true);
            const url = (0, $ec545c48aa9cf055$export$2e2bcd8739ae039).createSigninUrl(this.settings.get('features.prefillUsernameFromIdpDiscovery') && this.model.get('username'));
            this.options.appState.trigger('navigate', url);
        }
    }
});





/*!
 * Copyright (c) 2015-2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $3beaada32e4aee8e$export$2e2bcd8739ae039 = (0, $6887ec4c502ac936$export$2e2bcd8739ae039).extend({
    className: 'force-idp-discovery',
    View: (0, $e166679abbcff2df$export$2e2bcd8739ae039),
    Model: {},
    initialize: function() {
        const OKTA_IDP_TYPE = 'OKTA';
        const RESOURCE = 'okta:acct:';
        const options = this.options;
        const lastAuthResponse = options.appState.get('lastAuthResponse');
        const stateToken = lastAuthResponse && (lastAuthResponse === null || lastAuthResponse === void 0 ? void 0 : lastAuthResponse.stateToken);
        const webfingerArgs = {
            resource: RESOURCE,
            requestContext: stateToken
        };
        options.appState.settings.getAuthClient().webfinger(webfingerArgs).then((res)=>{
            if (res !== null && res !== void 0 && res.links && res.links[0]) {
                if (res.links[0].properties['okta:idp:type'] !== OKTA_IDP_TYPE && res.links[0].href) {
                    const redirectFn = res.links[0].href.includes('OKTA_INVALID_SESSION_REPOST%3Dtrue') ? (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).redirectWithFormGet.bind((0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039)) : this.settings.get('redirectUtilFn');
                    //override redirectFn to only use Util.redirectWithFormGet if OKTA_INVALID_SESSION_REPOST is included
                    //it will be encoded since it will be included in the encoded fromURI
                    redirectFn(res.links[0].href);
                    return;
                }
            }
            options.appState.trigger('navigate', '');
        }).catch(()=>{
            // TODO: OKTA-436775 Show error instead of navigating to default route
            options.appState.trigger('navigate', '');
        });
    }
});




























function $49e5e5bb707a08be$var$goToFactorActivation(appState) {
    const url = (0, $ec545c48aa9cf055$export$2e2bcd8739ae039).createActivateFactorUrl(appState.get('activatedFactorProvider'), appState.get('activatedFactorType'));
    appState.trigger('navigate', url);
}
var $49e5e5bb707a08be$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "mfa.backToFactors"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 58
                    },
                    "end": {
                        "line": 1,
                        "column": 106
                    }
                }
            })) + "</a><a href=\"#\" class=\"link help goto js-goto\" data-se=\"goto-link\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "mfa.scanBarcode"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 173
                    },
                    "end": {
                        "line": 1,
                        "column": 219
                    }
                }
            })) + "</a>";
        },
        "useData": true
    }),
    className: 'auth-footer',
    events: {
        'click .js-back': function(e) {
            e.preventDefault();
            this.back();
        },
        'click .js-goto': function(e) {
            e.preventDefault();
            const goToFactor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial($49e5e5bb707a08be$var$goToFactorActivation, this.options.appState);
            this.options.appState.unset('factorActivationType');
            this.model.doTransaction(function(transaction) {
                return transaction.prev().then(function(trans) {
                    const factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(trans.factors, {
                        factorType: 'push',
                        provider: 'OKTA'
                    });
                    return factor.enroll();
                });
            }).then(goToFactor);
        }
    },
    back: function() {
        const self = this;
        self.options.appState.unset('factorActivationType');
        if (self.options.appState.get('prevLink')) this.model.doTransaction(function(transaction) {
            return transaction.prev();
        }).then(function() {
            // we trap 'MFA_ENROLL' response that's why we need to trigger navigation from here
            self.options.appState.trigger('navigate', 'signin/enroll');
        });
        else self.options.appState.trigger('navigate', 'signin/enroll');
    }
});



function $17c0799a01338ad1$var$goToFactorActivation(view, step) {
    const url = (0, $ec545c48aa9cf055$export$2e2bcd8739ae039).createActivateFactorUrl(view.options.appState.get('activatedFactorProvider'), view.options.appState.get('activatedFactorType'), step);
    view.options.appState.trigger('navigate', url);
}
const $17c0799a01338ad1$var$sharedSecretIsDefined = {
    sharedSecret: function(val) {
        return !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isUndefined(val);
    },
    activationType: 'MANUAL'
};
function $17c0799a01338ad1$var$setStateValues(view) {
    let userPhoneNumber;
    let userCountryCode;
    if (view.model.get('activationType') === 'SMS') {
        userCountryCode = view.model.get('countryCode');
        userPhoneNumber = view.model.get('phoneNumber');
    }
    view.options.appState.set({
        factorActivationType: view.model.get('activationType'),
        userCountryCode: userCountryCode,
        userPhoneNumber: userPhoneNumber
    });
}
function $17c0799a01338ad1$var$enrollFactor(view, factorType) {
    return view.model.doTransaction(function(transaction) {
        return transaction.prev().then(function(trans) {
            const factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(trans.factors, {
                factorType: factorType,
                provider: 'OKTA'
            });
            return factor.enroll();
        }).then(function(trans) {
            let textActivationLinkUrl;
            let emailActivationLinkUrl;
            let sharedSecret;
            const res = trans.data;
            if (res && res._embedded && res._embedded.factor && res._embedded.factor._embedded && res._embedded.factor._embedded.activation) {
                const factor = res._embedded.factor;
                // Shared secret
                sharedSecret = factor._embedded.activation.sharedSecret;
                if (factor._embedded.activation._links && factor._embedded.activation._links.send) {
                    const activationSendLinks = factor._embedded.activation._links.send;
                    const smsItem = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(activationSendLinks, {
                        name: 'sms'
                    });
                    // SMS activation url
                    textActivationLinkUrl = smsItem ? smsItem.href : null;
                    // Email activation url
                    const emailItem = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(activationSendLinks, {
                        name: 'email'
                    });
                    emailActivationLinkUrl = emailItem ? emailItem.href : null;
                }
            }
            view.model.set({
                SMS: textActivationLinkUrl,
                EMAIL: emailActivationLinkUrl,
                sharedSecret: sharedSecret
            });
            return trans;
        });
    });
}
var $17c0799a01338ad1$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'enroll-manual-push',
    Model: function() {
        return {
            local: {
                activationType: [
                    'string',
                    true,
                    this.options.appState.get('factorActivationType') || 'SMS'
                ],
                countryCode: [
                    'string',
                    false,
                    this.options.appState.get('userCountryCode')
                ],
                phoneNumber: 'string',
                SMS: [
                    'string',
                    false,
                    this.options.appState.get('textActivationLinkUrl')
                ],
                EMAIL: [
                    'string',
                    false,
                    this.options.appState.get('emailActivationLinkUrl')
                ],
                sharedSecret: [
                    'string',
                    false,
                    this.options.appState.get('sharedSecret')
                ],
                __factorType__: [
                    'string',
                    false,
                    this.options.factorType
                ],
                __provider__: [
                    'string',
                    false,
                    this.options.provider
                ]
            },
            derived: {
                countryCallingCode: {
                    deps: [
                        'countryCode'
                    ],
                    fn: function(countryCode) {
                        return '+' + (0, $bfbf136e55dbe393$export$2e2bcd8739ae039).getCallingCodeForCountry(countryCode);
                    }
                },
                fullPhoneNumber: {
                    deps: [
                        'countryCallingCode',
                        'phoneNumber'
                    ],
                    fn: function(countryCallingCode, phoneNumber) {
                        return countryCallingCode + phoneNumber;
                    }
                }
            }
        };
    },
    Form: {
        title: function() {
            const factorName = (0, $020a58caf88b7504$export$2e2bcd8739ae039).getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
            return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.totp.title', 'login', [
                factorName
            ]);
        },
        subtitle: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'enroll.totp.cannotScanBarcode', 'login'),
        noButtonBar: true,
        attributes: {
            'data-se': 'step-manual-setup'
        },
        formChildren: function() {
            const instructions = this.settings.get('brandName') ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.totp.sharedSecretInstructions.specific', 'login', [
                this.settings.get('brandName')
            ]) : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.totp.sharedSecretInstructions.generic', 'login');
            const children = [
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                    name: 'activationType',
                    label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.setupOptions', 'login'),
                    type: 'select',
                    wide: true,
                    options: {
                        SMS: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.totp.sendSms', 'login'),
                        EMAIL: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.totp.sendEmail', 'login'),
                        MANUAL: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.totp.setupManually', 'login')
                    }
                }),
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                    label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.country', 'login'),
                    name: 'countryCode',
                    type: 'select',
                    wide: true,
                    options: (0, $bfbf136e55dbe393$export$2e2bcd8739ae039).getCountries(),
                    showWhen: {
                        activationType: 'SMS'
                    }
                }),
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                    label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.phoneNumber.placeholder', 'login'),
                    'label-top': true,
                    className: 'enroll-sms-phone',
                    name: 'phoneNumber',
                    input: (0, $9dc0b52102d9ebff$export$2e2bcd8739ae039),
                    type: 'text',
                    showWhen: {
                        activationType: 'SMS'
                    }
                }),
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                    View: (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                        className: 'secret-key-instructions',
                        attributes: {
                            'data-se': 'secret-key-instructions'
                        },
                        template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                            "compiler": [
                                8,
                                ">= 4.3.0"
                            ],
                            "main": function(container, depth0, helpers, partials, data) {
                                var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                                    return undefined;
                                };
                                return "<section aria-live=\"assertive\"><p class=\"okta-form-subtitle o-form-explain text-align-c\">" + alias4((helper = (helper = lookupProperty(helpers, "instructions") || (depth0 != null ? lookupProperty(depth0, "instructions") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                                    "name": "instructions",
                                    "hash": {},
                                    "data": data,
                                    "loc": {
                                        "start": {
                                            "line": 1,
                                            "column": 89
                                        },
                                        "end": {
                                            "line": 1,
                                            "column": 105
                                        }
                                    }
                                }) : helper)) + "</p><p class=\"shared-key margin-top-10\" tabindex=0 aria-label=\"" + alias4((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                                    "name": "i18n",
                                    "hash": {
                                        "arguments": "sharedSecretKey",
                                        "bundle": "login",
                                        "code": "enroll.totp.sharedSecretInstructions.aria.secretKey"
                                    },
                                    "data": data,
                                    "loc": {
                                        "start": {
                                            "line": 1,
                                            "column": 168
                                        },
                                        "end": {
                                            "line": 1,
                                            "column": 278
                                        }
                                    }
                                })) + "\">" + alias4((helper = (helper = lookupProperty(helpers, "sharedSecretKey") || (depth0 != null ? lookupProperty(depth0, "sharedSecretKey") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                                    "name": "sharedSecretKey",
                                    "hash": {},
                                    "data": data,
                                    "loc": {
                                        "start": {
                                            "line": 1,
                                            "column": 280
                                        },
                                        "end": {
                                            "line": 1,
                                            "column": 299
                                        }
                                    }
                                }) : helper)) + "</p></section>";
                            },
                            "useData": true
                        }),
                        initialize: function() {
                            this.listenTo(this.model, 'change:sharedSecret', this.render);
                        },
                        getTemplateData: function() {
                            return {
                                instructions: instructions,
                                sharedSecretKey: this.model.get('sharedSecret')
                            };
                        }
                    }),
                    showWhen: {
                        activationType: 'MANUAL'
                    }
                }),
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                    View: (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                        template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                            "compiler": [
                                8,
                                ">= 4.3.0"
                            ],
                            "main": function(container, depth0, helpers, partials, data) {
                                return "<div data-type=\"next-button-wrap\"></div>";
                            },
                            "useData": true
                        })
                    }),
                    showWhen: $17c0799a01338ad1$var$sharedSecretIsDefined
                }),
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Button({
                    title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oform.next', 'login'),
                    className: 'button button-primary button-wide button-next',
                    attributes: {
                        'data-se': 'next-button'
                    },
                    click: ()=>{
                        $17c0799a01338ad1$var$setStateValues(this);
                        $17c0799a01338ad1$var$goToFactorActivation(this, 'passcode');
                    }
                }, '[data-type="next-button-wrap"]'),
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Toolbar({
                    noCancelButton: true,
                    save: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oform.send', 'login'),
                    showWhen: {
                        activationType: function(val) {
                            return val === 'SMS' || val === 'EMAIL';
                        }
                    }
                })
            ];
            return children;
        }
    },
    Footer: (0, $49e5e5bb707a08be$export$2e2bcd8739ae039),
    initialize: function() {
        this.setInitialModel();
        // Move this logic to a model when AuthClient supports sending email and sms
        this.listenTo(this.form, 'save', function() {
            const self = this;
            this.model.doTransaction(function(transaction) {
                const activationType = this.get('activationType').toLowerCase();
                const opts = {};
                if (activationType === 'sms') opts.profile = {
                    phoneNumber: this.get('fullPhoneNumber')
                };
                return transaction.factor.activation.send(activationType, opts).then(function(trans) {
                    $17c0799a01338ad1$var$setStateValues(self);
                    // Note: Need to defer because OktaAuth calls our router success
                    // handler on the next tick - if we immediately called, appState would
                    // still be populated with the last response
                    (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defer(function() {
                        $17c0799a01338ad1$var$goToFactorActivation(self, 'sent');
                    });
                    return trans;
                });
            });
        });
        this.listenTo(this.model, 'change:activationType', function(model, value) {
            this.form.clearErrors();
            if (value === 'MANUAL' && this.options.appState.get('activatedFactorType') !== 'token:software:totp') $17c0799a01338ad1$var$enrollFactor(this, 'token:software:totp');
            else if (this.options.appState.get('activatedFactorType') !== 'push') $17c0799a01338ad1$var$enrollFactor(this, 'push');
        });
    },
    setInitialModel: function() {
        if (this.options.appState.get('factorActivationType') === 'SMS') this.model.set({
            countryCode: this.options.appState.get('userCountryCode') || 'US',
            phoneNumber: this.options.appState.get('userPhoneNumber')
        });
    },
    trapAuthResponse: function() {
        if (this.options.appState.get('isMfaEnrollActivate') || this.options.appState.get('isMfaEnroll')) return true;
    }
});



























var $3b4af8d6b6bab004$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "mfa.backToFactors"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 58
                    },
                    "end": {
                        "line": 1,
                        "column": 106
                    }
                }
            })) + "</a><a href=\"#\" class=\"link help goto js-goto\" data-se=\"goto-link\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "mfa.scanBarcode"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 173
                    },
                    "end": {
                        "line": 1,
                        "column": 219
                    }
                }
            })) + "</a>";
        },
        "useData": true
    }),
    className: 'auth-footer',
    events: {
        'click .js-back': function(e) {
            e.preventDefault();
            this.back();
        },
        'click .js-goto': function(e) {
            e.preventDefault();
            // go to a different screen with current auth status:
            // refresh the latest response
            this.model.startTransaction(function(authClient) {
                return authClient.tx.resume();
            });
        }
    },
    back: function() {
        this.state.set('navigateDir', (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).DIRECTION_BACK);
        if (this.options.appState.get('prevLink')) // Once we are in the MFA_ENROLL_ACTIVATE, we need to reset to the
        // correct state. Fortunately, this means that the router will
        // handle navigation once the request is finished.
        this.model.doTransaction(function(transaction) {
            return transaction.prev();
        });
        else this.options.appState.trigger('navigate', 'signin/enroll');
    }
});


var $8e3c489124846a35$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'enroll-manual-totp',
    Model: function() {
        return {
            local: {
                sharedSecret: [
                    'string',
                    false,
                    this.options.appState.get('sharedSecret')
                ],
                __factorType__: [
                    'string',
                    false,
                    this.options.factorType
                ],
                __provider__: [
                    'string',
                    false,
                    this.options.provider
                ]
            }
        };
    },
    Form: {
        title: function() {
            const factorName = (0, $020a58caf88b7504$export$2e2bcd8739ae039).getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
            return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.totp.title', 'login', [
                factorName
            ]);
        },
        subtitle: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'enroll.totp.cannotScanBarcode', 'login'),
        noButtonBar: true,
        attributes: {
            'data-se': 'step-manual-setup'
        },
        formChildren: function() {
            const instructions = this.settings.get('brandName') ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.totp.manualSetupInstructions.specific', 'login', [
                this.settings.get('brandName')
            ]) : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.totp.manualSetupInstructions.generic', 'login');
            return [
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                    View: (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                        className: 'secret-key-instructions',
                        attributes: {
                            'data-se': 'secret-key-instructions'
                        },
                        template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                            "compiler": [
                                8,
                                ">= 4.3.0"
                            ],
                            "main": function(container, depth0, helpers, partials, data) {
                                var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                                    return undefined;
                                };
                                return "<section aria-live=\"assertive\"><p class=\"okta-form-subtitle o-form-explain text-align-c\">" + alias4((helper = (helper = lookupProperty(helpers, "instructions") || (depth0 != null ? lookupProperty(depth0, "instructions") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                                    "name": "instructions",
                                    "hash": {},
                                    "data": data,
                                    "loc": {
                                        "start": {
                                            "line": 1,
                                            "column": 89
                                        },
                                        "end": {
                                            "line": 1,
                                            "column": 105
                                        }
                                    }
                                }) : helper)) + "</p><p class=\"shared-key margin-top-10\" tabindex=0 aria-label=\"" + alias4((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                                    "name": "i18n",
                                    "hash": {
                                        "arguments": "sharedSecretKey",
                                        "bundle": "login",
                                        "code": "enroll.totp.sharedSecretInstructions.aria.secretKey"
                                    },
                                    "data": data,
                                    "loc": {
                                        "start": {
                                            "line": 1,
                                            "column": 168
                                        },
                                        "end": {
                                            "line": 1,
                                            "column": 278
                                        }
                                    }
                                })) + "\">" + alias4((helper = (helper = lookupProperty(helpers, "sharedSecretKey") || (depth0 != null ? lookupProperty(depth0, "sharedSecretKey") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                                    "name": "sharedSecretKey",
                                    "hash": {},
                                    "data": data,
                                    "loc": {
                                        "start": {
                                            "line": 1,
                                            "column": 280
                                        },
                                        "end": {
                                            "line": 1,
                                            "column": 299
                                        }
                                    }
                                }) : helper)) + "</p></section>";
                            },
                            "useData": true
                        }),
                        initialize: function() {
                            this.listenTo(this.model, 'change:sharedSecret', this.render);
                        },
                        getTemplateData: function() {
                            return {
                                instructions: instructions,
                                sharedSecretKey: this.model.get('sharedSecret')
                            };
                        }
                    })
                }),
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Toolbar({
                    noCancelButton: true,
                    save: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oform.next', 'login')
                })
            ];
        }
    },
    Footer: (0, $3b4af8d6b6bab004$export$2e2bcd8739ae039),
    initialize: function() {
        this.listenTo(this.form, 'save', function() {
            const url = (0, $ec545c48aa9cf055$export$2e2bcd8739ae039).createActivateFactorUrl(this.model.get('__provider__'), this.model.get('__factorType__'), 'activate');
            this.options.appState.trigger('navigate', url);
        });
    }
});
























/*!
 * Copyright (c) 2025, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ /**
 * Resolves after `ms` milliseconds. Native replacement for the deprecated
 * `Q.delay`. Exposed as a method on a default-exported object (rather than a
 * bare named export) so tests can `spyOn(DelayUtil, 'delay')` to fast-forward
 * timing - mirroring how `Q.delay` used to be mocked.
 */ function $61c691f7f355fbc3$var$delay(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
var $61c691f7f355fbc3$export$2e2bcd8739ae039 = {
    delay: $61c691f7f355fbc3$var$delay
};


/*!
 * Copyright (c) 2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $c7e5e1cbabd7d102$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$a7fed597f4b8afd8).extend({
    layout: 'o-form-theme',
    className: 'factor-verify-magiclink',
    autoSave: true,
    noCancelButton: true,
    initialize: function() {
        const form = this;
        // for FACTOR_REQUIRED with email magic link we dont need to show otp code input field and verify button
        this.title = this.model.get('factorLabel');
        //TODO: OKTA-211618 Temp fix for demo. FACTOR_REQUIRED after sign up is missing the profile object in API response
        const email = this.model.get('email') || this.options.appState.get('lastAuthResponse')._embedded.user.profile.login;
        this.subtitle = '(' + email + ')';
        this.add((0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
            attributes: {
                'data-se': 'email-send-code'
            },
            className: 'button email-request-button',
            title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.sendEmail', 'login'),
            click: function() {
                form.clearErrors();
                this.disable();
                this.options.title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.sent', 'login');
                this.render();
                this.model.save().then(()=>{
                    return (0, $61c691f7f355fbc3$export$2e2bcd8739ae039).delay((0, $e48c043f6d2d382d$export$2e2bcd8739ae039).API_RATE_LIMIT);
                }).then(()=>{
                    this.options.title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.resendEmail', 'login');
                    this.enable();
                    this.render();
                });
            }
        }));
    }
});













/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $5c3db85c82993395$var$addInlineTotp(form) {
    form.addDivider();
    form.addInput({
        label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.enterCode.placeholder', 'login'),
        'label-top': true,
        className: 'o-form-fieldset o-form-label-top inline-input auth-passcode',
        name: 'answer',
        input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
        type: 'tel'
    });
    form.add((0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
        attributes: {
            'data-se': 'inline-totp-verify'
        },
        className: 'button inline-totp-verify margin-top-30',
        title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.verify', 'login'),
        click: function() {
            form.clearErrors();
            if (!form.isValid()) return;
            form.model.manageTransaction(function(transaction, setTransaction) {
                // This is the case where we enter the TOTP code and verify while there is an
                // active Push request (or polling) running. We need to invoke previous() on authClient
                // and then call model.save(). If not, we would still be in MFA_CHALLENGE state and
                // verify would result in a wrong request (push verify instead of a TOTP verify).
                if (transaction.status === 'MFA_CHALLENGE' && transaction.prev) {
                    form.options.appState.set('trapMfaRequiredResponse', true);
                    return transaction.prev().then(function(trans) {
                        setTransaction(trans);
                        form.model.save();
                    });
                } else // Push is not active and we enter the code to verify.
                form.model.save();
            });
        }
    }));
    form.at(1).focus();
}
var $5c3db85c82993395$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$a7fed597f4b8afd8).extend({
    autoSave: true,
    noButtonBar: true,
    scrollOnError: false,
    layout: 'o-form-theme',
    className: 'mfa-verify-totp-inline',
    attributes: {
        'data-se': 'factor-inline-totp'
    },
    initialize: function() {
        const form = this;
        this.listenTo(this.model, 'error', function() {
            this.clearErrors();
        });
        this.add((0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
            className: 'link',
            attributes: {
                'data-se': 'inline-totp-add'
            },
            title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.orEnterCode', 'login'),
            click: function() {
                this.remove();
                $5c3db85c82993395$var$addInlineTotp(form);
            }
        }));
    }
});















const $892f6cf7a96513e2$var$subtitleTpl = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "(" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "subtitle") || (depth0 != null ? lookupProperty(depth0, "subtitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "subtitle",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 1
                },
                "end": {
                    "line": 1,
                    "column": 13
                }
            }
        }) : helper)) + ")";
    },
    "useData": true
});
const $892f6cf7a96513e2$var$PassCodeFormwarningTemplate = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'okta-form-infobox-warning infobox infobox-warning login-timeout-warning',
    attributes: {
        'aria-live': 'polite'
    },
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<span class=\"icon warning-16\"></span><p>" + ((stack1 = (helper = (helper = lookupProperty(helpers, "warning") || (depth0 != null ? lookupProperty(depth0, "warning") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "warning",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 40
                    },
                    "end": {
                        "line": 1,
                        "column": 53
                    }
                }
            }) : helper)) != null ? stack1 : "") + "</p>";
        },
        "useData": true
    })
});
function $892f6cf7a96513e2$var$getFormAndButtonDetails(factorType) {
    switch(factorType){
        case 'sms':
            return {
                buttonDataSe: 'sms-send-code',
                buttonClassName: 'sms-request-button',
                formSubmit: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.sendCode', 'login'),
                formRetry: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.resendCode', 'login'),
                formSubmitted: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.sent', 'login'),
                subtitle: $892f6cf7a96513e2$var$subtitleTpl({
                    subtitle: this.model.get('phoneNumber')
                }),
                warning: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                    "compiler": [
                        8,
                        ">= 4.3.0"
                    ],
                    "main": function(container, depth0, helpers, partials, data) {
                        var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                            return undefined;
                        };
                        return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                            "name": "i18n",
                            "hash": {
                                "$1": "<b>$1</b>",
                                "bundle": "login",
                                "code": "factor.sms.time.warning"
                            },
                            "data": data,
                            "loc": {
                                "start": {
                                    "line": 1,
                                    "column": 0
                                },
                                "end": {
                                    "line": 1,
                                    "column": 70
                                }
                            }
                        }));
                    },
                    "useData": true
                })
            };
        case 'call':
            return {
                buttonDataSe: 'make-call',
                buttonClassName: 'call-request-button',
                formSubmit: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.call', 'login'),
                formRetry: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.redial', 'login'),
                formSubmitted: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.calling', 'login'),
                subtitle: $892f6cf7a96513e2$var$subtitleTpl({
                    subtitle: this.model.get('phoneNumber')
                }),
                warning: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                    "compiler": [
                        8,
                        ">= 4.3.0"
                    ],
                    "main": function(container, depth0, helpers, partials, data) {
                        var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                            return undefined;
                        };
                        return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                            "name": "i18n",
                            "hash": {
                                "$1": "<b>$1</b>",
                                "bundle": "login",
                                "code": "factor.call.time.warning"
                            },
                            "data": data,
                            "loc": {
                                "start": {
                                    "line": 1,
                                    "column": 0
                                },
                                "end": {
                                    "line": 1,
                                    "column": 71
                                }
                            }
                        }));
                    },
                    "useData": true
                })
            };
        case 'email':
            return {
                buttonDataSe: 'email-send-code',
                buttonClassName: 'email-request-button',
                formSubmit: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.sendEmail', 'login'),
                formRetry: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.resendEmail', 'login'),
                formSubmitted: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.sent', 'login'),
                subtitle: $892f6cf7a96513e2$var$subtitleTpl({
                    subtitle: this.model.get('email')
                })
            };
        default:
            return {
                buttonDataSe: '',
                buttonClassName: '',
                formSubmit: '',
                formRetry: '',
                formSubmitted: ''
            };
    }
}
var $892f6cf7a96513e2$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$a7fed597f4b8afd8).extend({
    className: 'mfa-verify-passcode',
    autoSave: true,
    noCancelButton: true,
    save: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'mfa.challenge.verify', 'login'),
    scrollOnError: false,
    layout: 'o-form-theme',
    disableSubmitButton: function() {
        return this.model.appState.get('isMfaChallenge') && this.model.get('answer');
    },
    showWarning: function(msg) {
        this.clearWarnings();
        this.add($892f6cf7a96513e2$var$PassCodeFormwarningTemplate, '.o-form-error-container', {
            options: {
                warning: msg
            }
        });
    },
    clearWarnings: function() {
        this.$('.okta-form-infobox-warning').remove();
    },
    initialize: function() {
        const form = this;
        this.title = this.model.get('factorLabel');
        const factorType = this.model.get('factorType');
        const formAndButtonDetails = $892f6cf7a96513e2$var$getFormAndButtonDetails.call(this, factorType);
        const warningDetails = formAndButtonDetails.warning;
        this.$el.attr('data-se', 'factor-' + factorType);
        this.subtitle = formAndButtonDetails.subtitle;
        this.listenTo(this.model, 'error', function() {
            this.clearErrors();
        });
        this.addInput({
            label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.enterCode.placeholder', 'login'),
            'label-top': true,
            className: 'o-form-fieldset o-form-label-top auth-passcode',
            name: 'answer',
            input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
            type: 'tel'
        });
        this.add((0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
            attributes: {
                'data-se': formAndButtonDetails.buttonDataSe
            },
            className: 'button ' + formAndButtonDetails.buttonClassName,
            title: formAndButtonDetails.formSubmit,
            click: function() {
                form.clearErrors();
                this.disable();
                form.clearWarnings();
                this.options.title = formAndButtonDetails.formSubmitted;
                this.render();
                // To send an OTP to the device, make the same request but use
                // an empty passCode
                this.model.set('answer', '');
                this.model.save().then(function() {
                    // render and focus on the passcode input field.
                    form.getInputs().first().render().focus();
                    return (0, $61c691f7f355fbc3$export$2e2bcd8739ae039).delay((0, $e48c043f6d2d382d$export$2e2bcd8739ae039).API_RATE_LIMIT);
                }).then(()=>{
                    this.options.title = formAndButtonDetails.formRetry;
                    this.enable();
                    if (factorType === 'call' || factorType === 'sms') form.showWarning(warningDetails);
                    this.render();
                });
            }
        }));
        if (this.options.appState.get('allowRememberDevice')) this.addInput({
            label: false,
            'label-top': true,
            placeholder: this.options.appState.get('rememberDeviceLabel'),
            className: 'margin-btm-0',
            name: 'rememberDevice',
            type: 'checkbox'
        });
    }
});












/*!
 * Copyright (c) 2016-2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $38ce3c2db76d4f70$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$a7fed597f4b8afd8).extend({
    className: 'mfa-verify-password',
    autoSave: true,
    noCancelButton: true,
    save: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'mfa.challenge.verify', 'login'),
    scrollOnError: false,
    layout: 'o-form-theme',
    attributes: {
        'data-se': 'factor-password'
    },
    initialize: function() {
        this.title = this.model.get('factorLabel');
        this.addInput({
            label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.password.placeholder', 'login'),
            'label-top': true,
            className: 'auth-passcode',
            name: 'password',
            type: 'password',
            params: {
                showPasswordToggle: true
            }
        });
        if (this.options.appState.get('allowRememberDevice')) this.addInput({
            label: false,
            'label-top': true,
            placeholder: this.options.appState.get('rememberDeviceLabel'),
            className: 'margin-btm-0',
            name: 'rememberDevice',
            type: 'checkbox'
        });
    }
});























var $50c8a8a37763a66d$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'number-challenge-view',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p data-se=\"number-challenge-instruction\">" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "arguments": "number",
                    "bundle": "login",
                    "code": "oktaverify.numberchallenge.instruction"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 73
                    },
                    "end": {
                        "line": 1,
                        "column": 163
                    }
                }
            })) != null ? stack1 : "") + "</p>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "number") : depth0, {
                "name": "if",
                "hash": {
                    "includeZero": true
                },
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 174
                    }
                }
            })) != null ? stack1 : "") + "<div class=\"phone\"><div class=\"phone--body\"><div class=\"phone--screen\"><span class=\"phone--number\" data-se=\"challenge-number\">" + alias3((helper = (helper = lookupProperty(helpers, "number") || (depth0 != null ? lookupProperty(depth0, "number") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
                "name": "number",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 300
                    },
                    "end": {
                        "line": 1,
                        "column": 310
                    }
                }
            }) : helper)) + "</span></div><div class=\"phone--home-button\"></div></div></div><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oktaverify.numberchallenge.explain"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 376
                    },
                    "end": {
                        "line": 1,
                        "column": 441
                    }
                }
            })) + "</p>";
        },
        "useData": true
    }),
    initialize: function() {
        this.listenTo(this.options.appState, 'change:isWaitingForNumberChallenge', ()=>{
            if (this.options.appState.get('lastAuthResponse').status !== 'SUCCESS') this.render();
        });
    },
    getTemplateData: function() {
        const lastAuthResponse = this.options.appState.get('lastAuthResponse');
        if (!this.options.appState.get('isWaitingForNumberChallenge')) return {
            number: null
        };
        return {
            number: lastAuthResponse._embedded.factor._embedded.challenge.correctAnswer
        };
    }
});


const $db0dbbe5eb73edc1$var$titleTpl = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "0": function(container, depth0, helpers, partials, data) {
        var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return " (" + ((stack1 = (helper = (helper = lookupProperty(helpers, "deviceName") || (depth0 != null ? lookupProperty(depth0, "deviceName") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "deviceName",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 34
                },
                "end": {
                    "line": 1,
                    "column": 50
                }
            }
        }) : helper)) != null ? stack1 : "") + ")";
    },
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return container.escapeExpression((helper = (helper = lookupProperty(helpers, "factorName") || (depth0 != null ? lookupProperty(depth0, "factorName") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
            "name": "factorName",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 0
                },
                "end": {
                    "line": 1,
                    "column": 14
                }
            }
        }) : helper)) + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "deviceName") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(0, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 14
                },
                "end": {
                    "line": 1,
                    "column": 58
                }
            }
        })) != null ? stack1 : "");
    },
    "useData": true
});
// deviceName is escaped on BaseForm (see BaseForm's template)
const $db0dbbe5eb73edc1$var$WARNING_TIMEOUT = 30000; // milliseconds
const $db0dbbe5eb73edc1$var$PushFormwarningTemplate = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'okta-form-infobox-warning infobox infobox-warning',
    attributes: {
        'aria-live': 'polite'
    },
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<span class=\"icon warning-16\"></span><p>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "warning") || (depth0 != null ? lookupProperty(depth0, "warning") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "warning",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 40
                    },
                    "end": {
                        "line": 1,
                        "column": 51
                    }
                }
            }) : helper)) + "</p>";
        },
        "useData": true
    })
});
var $db0dbbe5eb73edc1$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$a7fed597f4b8afd8).extend({
    className: 'mfa-verify-push',
    autoSave: true,
    noCancelButton: true,
    save: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'oktaverify.send', 'login'),
    scrollOnError: false,
    layout: 'o-form-theme',
    attributes: {
        'data-se': 'factor-push'
    },
    events: {
        submit: 'submit'
    },
    initialize: function() {
        this.enabled = true;
        this.listenTo(this.options.appState, 'change:isMfaRejected', this.handleRejectStateChange);
        this.numberChallengeView = this.add((0, $50c8a8a37763a66d$export$2e2bcd8739ae039)).last();
        this.listenTo(this.options.appState, 'change:isWaitingForNumberChallenge', function(state, isWaitingForNumberChallenge) {
            if (isWaitingForNumberChallenge || this.options.appState.get('lastAuthResponse').status === 'SUCCESS') {
                this.clearWarnings();
                this.$el.find('.button').hide();
                this.numberChallengeView.$el.show();
            } else {
                this.numberChallengeView.$el.hide();
                this.$el.find('.button').show();
            }
        });
        this.listenTo(this.options.appState, 'change:isMfaTimeout', function(state, isMfaTimeout) {
            this.setSubmitState(isMfaTimeout);
            if (isMfaTimeout) this.showError((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oktaverify.timeout', 'login'));
        });
        this.listenTo(this.options.appState, 'change:isMfaRequired', function(state, isMfaRequired) {
            if (isMfaRequired) {
                this.clearErrors();
                this.clearWarnings();
            }
        });
        this.title = $db0dbbe5eb73edc1$var$titleTpl({
            factorName: this.model.get('factorLabel'),
            deviceName: this.model.get('deviceName')
        });
    },
    setSubmitState: function(ableToSubmit) {
        const button = this.$el.find('.button');
        const a11ySpan = this.$el.find('.accessibility-text');
        this.enabled = ableToSubmit;
        if (ableToSubmit) {
            button.removeClass('link-button-disabled');
            button.prop('value', (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oktaverify.send', 'login'));
            button.prop('disabled', false);
            if (a11ySpan) a11ySpan.remove();
        } else {
            button.addClass('link-button-disabled');
            button.prop('value', (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oktaverify.sent', 'login'));
            button.prop('disabled', true);
            this.add(`<span class='accessibility-text' role='alert'>${(0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oktaverify.sent', 'login')}</span>`);
        }
    },
    submit: function(e) {
        if (e !== undefined) e.preventDefault();
        if (this.enabled) {
            this.setSubmitState(false);
            this.doSave();
        }
    },
    postRender: function() {
        const factorsPolicyInfo = this.options.appState.get('factorsPolicyInfo');
        const id = this.model.get('id');
        const isAutoPushEnabled = this.settings.get('features.autoPush') && factorsPolicyInfo && factorsPolicyInfo[id] ? factorsPolicyInfo[id]['autoPushEnabled'] : false;
        if (isAutoPushEnabled) {
            this.model.set('autoPush', true);
            // bind after $el has been rendered, and trigger push once DOM is fully loaded
            (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defer((0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(this.submit, this));
        }
    },
    doSave: function() {
        let warningTimeout;
        this.clearErrors();
        this.clearWarnings();
        if (this.model.isValid()) {
            this.listenToOnce(this.model, 'error', function() {
                this.setSubmitState(true);
                this.clearWarnings();
                clearTimeout(warningTimeout);
            });
            this.trigger('save', this.model);
            warningTimeout = (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).callAfterTimeout(()=>{
                if (!this.options.appState.get('isWaitingForNumberChallenge')) this.showWarning((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oktaverify.warning', 'login'));
            }, $db0dbbe5eb73edc1$var$WARNING_TIMEOUT);
        }
    },
    showError: function(msg) {
        this.clearWarnings();
        this.model.trigger('error', this.model, {
            responseJSON: {
                errorSummary: msg
            }
        });
    },
    showWarning: function(msg) {
        this.clearWarnings();
        this.add($db0dbbe5eb73edc1$var$PushFormwarningTemplate, '.o-form-error-container', {
            options: {
                warning: msg
            }
        });
    },
    clearWarnings: function() {
        this.$('.okta-form-infobox-warning').remove();
    },
    handleRejectStateChange: function(state, isMfaRejected) {
        if (isMfaRejected) {
            this.setSubmitState(isMfaRejected);
            this.setRejectedErrorMessage();
        }
    },
    setRejectedErrorMessage: function() {
        // If rejection is due to outdated app, show error message per platform
        // else show user rejected message.
        if (this.options.appState.get('lastAuthResponse').factorResultMessage === 'OKTA_VERIFY_UPGRADE_REQUIRED') {
            if (this.options.appState.get('factor').profile.platform === 'IOS') this.showError((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oktaverify.rejected.upgradeRequired.ios', 'login'));
            else this.showError((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oktaverify.rejected.upgradeRequired.android', 'login'));
        } else this.showError((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oktaverify.rejected', 'login'));
    }
});












/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $a744d01751f795ea$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$a7fed597f4b8afd8).extend({
    className: 'mfa-verify-question',
    autoSave: true,
    noCancelButton: true,
    save: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'mfa.challenge.verify', 'login'),
    scrollOnError: false,
    layout: 'o-form-theme',
    attributes: {
        'data-se': 'factor-question'
    },
    initialize: function() {
        this.title = this.model.get('factorLabel');
        this.addInput({
            label: this.model.get('securityQuestion'),
            'label-top': true,
            placeholder: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.answer.placeholder', 'login'),
            className: 'auth-passcode',
            name: 'answer',
            type: 'password',
            params: {
                showPasswordToggle: true
            }
        });
        if (this.options.appState.get('allowRememberDevice')) this.addInput({
            label: false,
            'label-top': true,
            placeholder: this.options.appState.get('rememberDeviceLabel'),
            className: 'margin-btm-0',
            name: 'rememberDevice',
            type: 'checkbox'
        });
    }
});














const $f87b5b7bfac6bf79$var$createEmailMaskElement = function() {
    const email = this.model.get('email');
    const emailTpl = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<span class=\"mask-email\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "email") || (depth0 != null ? lookupProperty(depth0, "email") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "email",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 25
                    },
                    "end": {
                        "line": 1,
                        "column": 34
                    }
                }
            }) : helper)) + "</span>";
        },
        "useData": true
    });
    return {
        factorEmail: emailTpl({
            email: email
        })
    };
};
const $f87b5b7bfac6bf79$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$a7fed597f4b8afd8).extend({
    layout: 'o-form-theme',
    className: 'mfa-verify-email',
    title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'email.mfa.title', 'login'),
    noButtonBar: false,
    autoSave: true,
    noCancelButton: true,
    attributes: {
        'data-se': 'factor-email'
    },
    save: function() {
        return this.options.appState.get('isMfaChallenge') ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.verify', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('email.button.send', 'login');
    },
    events: Object.assign({}, (0, $5d64eb84267ab4e8$export$a7fed597f4b8afd8).prototype.events, {
        submit: function(e) {
            e.preventDefault();
            this.handleSubmit();
        }
    }),
    handleSubmit: function() {
        this.clearErrors();
        if (this.options.appState.get('isMfaChallenge')) {
            if (this.isValid()) this.model.save();
        } else {
            // Send email and switch to verification view
            this.model.set('answer', '');
            this.model.save().then(this.renderChallengView.bind(this));
        }
    },
    initialize: function() {
        (0, $5d64eb84267ab4e8$export$a7fed597f4b8afd8).prototype.initialize.apply(this, arguments);
        // render 'Send Email' page at first place
        this.add((0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
            attributes: {
                'data-se': 'mfa-send-email-content'
            },
            className: 'mfa-send-email-content',
            template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                "compiler": [
                    8,
                    ">= 4.3.0"
                ],
                "main": function(container, depth0, helpers, partials, data) {
                    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                        return undefined;
                    };
                    return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                        "name": "i18n",
                        "hash": {
                            "arguments": "factorEmail",
                            "bundle": "login",
                            "code": "email.mfa.description"
                        },
                        "data": data,
                        "loc": {
                            "start": {
                                "line": 1,
                                "column": 0
                            },
                            "end": {
                                "line": 1,
                                "column": 78
                            }
                        }
                    })) != null ? stack1 : "";
                },
                "useData": true
            }),
            getTemplateData: $f87b5b7bfac6bf79$var$createEmailMaskElement
        }));
    },
    renderChallengView: function() {
        this.removeChildren();
        this.add((0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
            className: 'mfa-email-sent-content',
            attributes: {
                'data-se': 'mfa-email-sent-content'
            },
            // Why use `{{{` for the description?
            // - factorEmail is actually an HTML fragment which
            //   is created via another handlebar template and used for bold the email address.
            template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                "compiler": [
                    8,
                    ">= 4.3.0"
                ],
                "main": function(container, depth0, helpers, partials, data) {
                    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                        return undefined;
                    };
                    return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                        "name": "i18n",
                        "hash": {
                            "arguments": "factorEmail",
                            "bundle": "login",
                            "code": "email.mfa.email.sent.description"
                        },
                        "data": data,
                        "loc": {
                            "start": {
                                "line": 1,
                                "column": 0
                            },
                            "end": {
                                "line": 1,
                                "column": 89
                            }
                        }
                    })) != null ? stack1 : "";
                },
                "useData": true
            }),
            getTemplateData: $f87b5b7bfac6bf79$var$createEmailMaskElement
        }));
        this.add((0, $07fb0b040b68e1c2$export$2e2bcd8739ae039));
        this.addInput({
            label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('email.code.label', 'login'),
            'label-top': true,
            name: 'answer',
            input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
            wide: true,
            type: 'tel'
        });
        if (this.options.appState.get('allowRememberDevice')) this.addInput({
            label: false,
            'label-top': true,
            placeholder: this.options.appState.get('rememberDeviceLabel'),
            className: 'margin-btm-0',
            name: 'rememberDevice',
            type: 'checkbox'
        });
        this.render();
    }
});













/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $1b71d59f615d9b1e$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$a7fed597f4b8afd8).extend({
    className: 'mfa-verify-totp',
    autoSave: true,
    noCancelButton: true,
    save: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'mfa.challenge.verify', 'login'),
    scrollOnError: false,
    layout: 'o-form-theme',
    attributes: {
        'data-se': 'factor-totp'
    },
    initialize: function() {
        const factorName = this.model.get('factorLabel');
        const maskPasswordField = this.model.get('provider') === 'RSA' || this.model.get('provider') === 'DEL_OATH';
        this.title = factorName;
        if (this.model.get('isFactorTypeVerification')) this.subtitle = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.totp.subtitle.multiple', 'login', [
            factorName
        ]);
        else this.subtitle = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.title', 'login', [
            factorName
        ]);
        this.addInput({
            label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.enterCode.placeholder', 'login'),
            'label-top': true,
            className: 'o-form-fieldset o-form-label-top auth-passcode',
            name: 'answer',
            input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
            type: maskPasswordField ? 'password' : 'tel'
        });
        if (this.options.appState.get('allowRememberDevice')) this.addInput({
            label: false,
            'label-top': true,
            placeholder: this.options.appState.get('rememberDeviceLabel'),
            className: 'margin-btm-0',
            name: 'rememberDevice',
            type: 'checkbox'
        });
        if (this.model.get('provider') === 'RSA' || this.model.get('provider') === 'DEL_OATH') this.listenTo(this.model, 'error', (source, error)=>{
            if (error && error.status === 409) {
                // 409 means we are in change pin, so we should clear out answer input
                this.$('.auth-passcode input').val('');
                this.$('.auth-passcode input').trigger('change');
                this.$('.auth-passcode input').focus();
            }
        });
    }
});













/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $2db87d9bfc5a285a$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$a7fed597f4b8afd8).extend({
    className: 'mfa-verify-yubikey',
    autoSave: true,
    noCancelButton: true,
    save: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'mfa.challenge.verify', 'login'),
    scrollOnError: false,
    layout: 'o-form-theme',
    attributes: {
        'data-se': 'factor-yubikey'
    },
    initialize: function() {
        const factorName = this.model.get('factorLabel');
        this.title = factorName;
        this.subtitle = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('factor.totpHard.yubikey.description', 'login');
        this.addInput({
            label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('factor.totpHard.yubikey.placeholder', 'login'),
            'label-top': true,
            className: 'o-form-fieldset o-form-label-top auth-passcode',
            name: 'answer',
            input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
            inputId: 'mfa-answer',
            type: 'password'
        });
        if (this.options.appState.get('allowRememberDevice')) this.addInput({
            label: false,
            'label-top': true,
            className: 'margin-btm-0',
            placeholder: this.options.appState.get('rememberDeviceLabel'),
            name: 'rememberDevice',
            type: 'checkbox'
        });
    }
});














const { Util: $3b6768ac3357a97d$var$Util } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).util;
var $3b6768ac3357a97d$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a href=\"#\" class=\"link " + alias4((helper = (helper = lookupProperty(helpers, "linkClassName") || (depth0 != null ? lookupProperty(depth0, "linkClassName") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "linkClassName",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 24
                    },
                    "end": {
                        "line": 1,
                        "column": 41
                    }
                }
            }) : helper)) + "\" data-se=\"signout-link\">" + alias4((helper = (helper = lookupProperty(helpers, "linkText") || (depth0 != null ? lookupProperty(depth0, "linkText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "linkText",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 66
                    },
                    "end": {
                        "line": 1,
                        "column": 78
                    }
                }
            }) : helper)) + "</a>";
        },
        "useData": true
    }),
    className: 'auth-footer clearfix',
    events: {
        'click a[data-se="signout-link"]': 'handleSignout'
    },
    handleSignout: function(e) {
        e.preventDefault();
        const appState = this.options.appState;
        appState.trigger('signOut');
        const isSMSPasswordRecovery = appState.get('isSMSPasswordRecovery');
        this.model.doTransaction(function(transaction) {
            // `clearTransactionData` was added as a temporary fix for the issue reported in OKTA-487220
            // OKTA-515889 was created to address the underlying issue on the `transaction.cancel` level
            // and this temporary fix will be removed after that ticket is done
            return transaction.cancel().then($3b6768ac3357a97d$var$clearTransactionData);
        }).then(()=>{
            if (this.settings.get('backToSignInUri') && !isSMSPasswordRecovery) $3b6768ac3357a97d$var$Util.redirect(this.settings.get('backToSignInUri'));
            else {
                this.state.set('navigateDir', (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).DIRECTION_BACK);
                appState.trigger('navigate', '');
            }
        });
    },
    getTemplateData: function() {
        return {
            linkClassName: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isUndefined(this.options.linkClassName) ? 'goto' : this.options.linkClassName,
            linkText: this.options.linkText || (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('goback', 'login')
        };
    }
});
// TODO: remove after OKTA-515889 is done
function $3b6768ac3357a97d$var$clearTransactionData(transaction) {
    return {
        ...transaction,
        data: null
    };
}


var $88b800c63cc9d9e3$export$2e2bcd8739ae039 = (0, $3b6768ac3357a97d$export$2e2bcd8739ae039).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a href=\"" + alias4((helper = (helper = lookupProperty(helpers, "factorPageCustomLinkHref") || (depth0 != null ? lookupProperty(depth0, "factorPageCustomLinkHref") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "factorPageCustomLinkHref",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 40
                    },
                    "end": {
                        "line": 1,
                        "column": 68
                    }
                }
            }) : helper)) + "\" data-se=\"factor-page-custom-link\" class=\"link js-factor-page-custom-link\" rel=\"noopener noreferrer\" target=\"_blank\">" + alias4((helper = (helper = lookupProperty(helpers, "factorPageCustomLinkText") || (depth0 != null ? lookupProperty(depth0, "factorPageCustomLinkText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "factorPageCustomLinkText",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 186
                    },
                    "end": {
                        "line": 1,
                        "column": 214
                    }
                }
            }) : helper)) + "</a>";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a href=\"#\" class=\"link " + alias4((helper = (helper = lookupProperty(helpers, "linkClassName") || (depth0 != null ? lookupProperty(depth0, "linkClassName") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "linkClassName",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 265
                    },
                    "end": {
                        "line": 1,
                        "column": 282
                    }
                }
            }) : helper)) + "\" data-se=\"signout-link\">" + alias4((helper = (helper = lookupProperty(helpers, "linkText") || (depth0 != null ? lookupProperty(depth0, "linkText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "linkText",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 307
                    },
                    "end": {
                        "line": 1,
                        "column": 319
                    }
                }
            }) : helper)) + "</a>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "hasFactorPageCustomLink") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 225
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "showLink") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 225
                    },
                    "end": {
                        "line": 1,
                        "column": 330
                    }
                }
            })) != null ? stack1 : "");
        },
        "useData": true
    }),
    className: 'auth-footer clearfix',
    getTemplateData: function() {
        const signoutTemplateData = (0, $3b6768ac3357a97d$export$2e2bcd8739ae039).prototype.getTemplateData.apply(this, arguments);
        const factorPageCustomLinkHref = this.settings.get('helpLinks.factorPage.href');
        const factorPageCustomLinkText = this.settings.get('helpLinks.factorPage.text');
        const showLink = !this.settings.get('features.hideSignOutLinkInMFA') && !this.settings.get('features.mfaOnlyFlow');
        return Object.assign({}, signoutTemplateData, {
            hasFactorPageCustomLink: factorPageCustomLinkText && factorPageCustomLinkHref,
            factorPageCustomLinkHref: factorPageCustomLinkHref,
            factorPageCustomLinkText: factorPageCustomLinkText,
            showLink: showLink
        });
    }
});


/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ let { CheckBox: $fe89ce6972cd452f$var$CheckBox } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).views.forms.inputs;
var $fe89ce6972cd452f$export$2e2bcd8739ae039 = (0, $6887ec4c502ac936$export$2e2bcd8739ae039).extend({
    className: 'mfa-verify',
    initialize: function(options) {
        const factorType = options.factorType;
        let View;
        switch(factorType){
            case 'question':
                View = (0, $a744d01751f795ea$export$2e2bcd8739ae039);
                break;
            case 'email':
                if (this.options.appState.get('isIdxStateToken')) View = (0, $c7e5e1cbabd7d102$export$2e2bcd8739ae039);
                else View = (0, $f87b5b7bfac6bf79$export$2e2bcd8739ae039);
                break;
            case 'sms':
            case 'call':
                View = (0, $892f6cf7a96513e2$export$2e2bcd8739ae039);
                break;
            case 'token':
            case 'token:software:totp':
            case 'token:hotp':
                View = (0, $1b71d59f615d9b1e$export$2e2bcd8739ae039);
                break;
            case 'token:hardware':
                View = (0, $2db87d9bfc5a285a$export$2e2bcd8739ae039);
                break;
            case 'push':
                View = (0, $db0dbbe5eb73edc1$export$2e2bcd8739ae039);
                break;
            case 'password':
                View = (0, $38ce3c2db76d4f70$export$2e2bcd8739ae039);
                break;
            default:
                throw new Error('Unrecognized factor type');
        }
        this.model = this.findModel(factorType, options);
        if (!this.model) // TODO: recover from this more gracefully - probably to redirect
        // to default factor
        throw new Error('Unrecognized factor/provider');
        this.addListeners();
        this.add(new View(this.toJSON()));
        // If Okta Verify Push and Okta Verify totp are both enabled,
        // then we show Push first, and totp is the "backup" factor,
        // which is rendered in an additional InlineTOTPForm
        if (factorType === 'push' && this.model.get('isOktaFactor')) {
            if (this.model.get('backupFactor')) this.inlineTotpForm = this.add((0, $5c3db85c82993395$export$2e2bcd8739ae039), {
                options: {
                    model: this.model.get('backupFactor')
                }
            }).last();
            if (this.settings.get('features.autoPush')) this.autoPushCheckBox = this.add($fe89ce6972cd452f$var$CheckBox, {
                options: {
                    model: this.model,
                    name: 'autoPush',
                    placeholder: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('autoPush', 'login'),
                    label: false,
                    'label-top': false,
                    className: 'margin-btm-0'
                }
            }).last();
            // Remember Device checkbox resides outside of the Push and TOTP forms.
            if (this.options.appState.get('allowRememberDevice')) this.rememberDeviceCheckbox = this.add($fe89ce6972cd452f$var$CheckBox, {
                options: {
                    model: this.model,
                    name: 'rememberDevice',
                    placeholder: this.options.appState.get('rememberDeviceLabel'),
                    label: false,
                    'label-top': true,
                    className: 'margin-btm-0'
                }
            }).last();
            // Set rememberDevice on the backup factor (totp) if available
            if (this.model.get('backupFactor')) this.listenTo(this.model, 'change:rememberDevice', function(model, rememberDevice) {
                model.get('backupFactor').set('rememberDevice', rememberDevice);
            });
        }
        this.listenTo(this.options.appState, 'change:isWaitingForNumberChallenge', function(state, isWaitingForNumberChallenge) {
            if (isWaitingForNumberChallenge || this.options.appState.get('lastAuthResponse').status === 'SUCCESS') {
                this.autoPushCheckBox && this.autoPushCheckBox.$el.hide();
                this.rememberDeviceCheckbox && this.rememberDeviceCheckbox.$el.hide();
                this.inlineTotpForm && this.inlineTotpForm.$el.hide();
            } else {
                this.autoPushCheckBox && this.autoPushCheckBox.$el.show();
                this.rememberDeviceCheckbox && this.rememberDeviceCheckbox.$el.show();
                this.inlineTotpForm && this.inlineTotpForm.$el.show();
            }
        });
        this.add(new (0, $88b800c63cc9d9e3$export$2e2bcd8739ae039)(this.toJSON()));
    },
    findModel: function(factorType, options) {
        const factors = options.appState.get('factors');
        const provider = options.provider;
        const factorIndex = options.factorIndex;
        if (!provider) return factors.findWhere({
            factorType: factorType,
            isFactorTypeVerification: true
        });
        else if (factors.hasMultipleFactorsOfSameType(factorType) && factorIndex) return factors.getFactorByTypeAndIndex(factorType, factorIndex);
        else return factors.findWhere({
            provider: provider,
            factorType: factorType
        });
    },
    trapAuthResponse: function() {
        if (this.options.appState.get('isMfaRequired') && this.options.appState.get('trapMfaRequiredResponse') || this.options.appState.get('isMfaChallenge')) {
            this.options.appState.set('trapMfaRequiredResponse', false);
            return true;
        }
        return false;
    },
    back: function() {
    // Empty function on verify controllers to prevent users
    // from navigating back during 'verify' using the browser's
    // back button. The URL will still change, but the view will not
    // More details in OKTA-135060.
    }
});





























var $77137e835f54c8b5$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"password-requirements--header\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "password.complexity.requirements.header"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 63
                    },
                    "end": {
                        "line": 1,
                        "column": 133
                    }
                }
            })) + "</div><ul class=\"password-requirements--list\">" + ((stack1 = lookupProperty(helpers, "each").call(alias1, depth0 != null ? lookupProperty(depth0, "requirements") : depth0, {
                "name": "each",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 179
                    },
                    "end": {
                        "line": 1,
                        "column": 268
                    }
                }
            })) != null ? stack1 : "") + "</ul>";
        },
        "1": function(container, depth0, helpers, partials, data) {
            return "<li class=\"password-requirements--list-item\">" + container.escapeExpression(container.lambda(depth0, depth0)) + "</li>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "requirements") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 280
                    }
                }
            })) != null ? stack1 : "";
        },
        "useData": true
    }),
    attributes: {
        'data-se': 'password-requirements-html'
    },
    allRequirements: [],
    initialize: function(options) {
        const policy = options.policy;
        if (!policy) return;
        this.allRequirements = (0, $020a58caf88b7504$export$2e2bcd8739ae039).getPasswordComplexityDescriptionForHtmlList(policy);
    },
    getTemplateData: function() {
        return {
            requirements: this.allRequirements
        };
    }
});



/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $0e4cef0364ccc4b2$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'password-expired',
    Model: {
        props: {
            oldPassword: [
                'string',
                true
            ],
            newPassword: [
                'string',
                true
            ],
            confirmPassword: [
                'string',
                true
            ]
        },
        validate: function() {
            return (0, $925fe56dc05ff4ab$export$2e2bcd8739ae039).validatePasswordMatch(this);
        },
        save: function() {
            this.trigger('save');
            return this.doTransaction(function(transaction) {
                return transaction.changePassword({
                    oldPassword: this.get('oldPassword'),
                    newPassword: this.get('newPassword')
                });
            });
        }
    },
    Form: {
        save: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'password.expired.submit', 'login'),
        title: function() {
            const expiringSoon = this.options.appState.get('isPwdExpiringSoon');
            const numDays = this.options.appState.get('passwordExpireDays');
            if (expiringSoon && numDays > 0) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expiring.title', 'login', [
                numDays
            ]);
            else if (expiringSoon && numDays === 0) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expiring.today', 'login');
            else if (expiringSoon) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expiring.soon', 'login');
            else return this.settings.get('brandName') ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expired.title.specific', 'login', [
                this.settings.get('brandName')
            ]) : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expired.title.generic', 'login');
        },
        subtitle: function() {
            if (this.options.appState.get('isPwdExpiringSoon')) return this.settings.get('brandName') ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expiring.subtitle.specific', 'login', [
                this.settings.get('brandName')
            ]) : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expiring.subtitle.generic', 'login');
            const policy = this.options.appState.get('policy');
            if (!policy || this.settings.get('features.showPasswordRequirementsAsHtmlList')) return;
            return (0, $020a58caf88b7504$export$2e2bcd8739ae039).getPasswordComplexityDescription(policy);
        },
        parseErrorMessage: function(responseJSON) {
            const policy = this.options.appState.get('policy');
            if (!!policy && this.settings.get('features.showPasswordRequirementsAsHtmlList')) /*
          - This is a specific case where don't want to repeat the requirements again in the error message, since this
            is already shown in the description. The description as bullet-points itself should give an indication
            of the requirements.
          - We cannot check for error code this in this case, as the error code is shared between
            requirements not met message, common password message, etc. So error summary is the only differentiating
            factor. Replace the password requirements string with empty string in this case.
        */ responseJSON = (0, $020a58caf88b7504$export$2e2bcd8739ae039).removeRequirementsFromError(responseJSON, policy);
            return responseJSON;
        },
        formChildren: function() {
            let children = [];
            if (this.settings.get('features.showPasswordRequirementsAsHtmlList')) children.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                View: new (0, $77137e835f54c8b5$export$2e2bcd8739ae039)({
                    policy: this.options.appState.get('policy')
                })
            }));
            children = children.concat([
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                    'label-top': true,
                    label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.oldPassword.placeholder', 'login'),
                    explain: (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).createInputExplain('password.oldPassword.tooltip', 'password.oldPassword.placeholder', 'login'),
                    'explain-top': true,
                    name: 'oldPassword',
                    input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
                    type: 'password'
                }),
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Divider(),
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                    className: 'margin-btm-5',
                    'label-top': true,
                    label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.newPassword.placeholder', 'login'),
                    explain: (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).createInputExplain('password.newPassword.tooltip', 'password.newPassword.placeholder', 'login'),
                    'explain-top': true,
                    name: 'newPassword',
                    input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
                    type: 'password'
                }),
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                    'label-top': true,
                    label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.confirmPassword.placeholder', 'login'),
                    explain: (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).createInputExplain('password.confirmPassword.tooltip', 'password.confirmPassword.placeholder', 'login'),
                    'explain-top': true,
                    name: 'confirmPassword',
                    input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
                    type: 'password'
                })
            ]);
            return children;
        }
    },
    Footer: (0, $a5591884dc309b8c$export$2e2bcd8739ae039),
    initialize: function() {
        this.listenTo(this.form, 'save', function() {
            const creds = {
                username: this.options.appState.get('userEmail'),
                password: this.model.get('newPassword')
            };
            this.settings.processCreds(creds).then((0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(this.model.save, this.model));
        });
    }
});




















/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ let { CheckBox: $7b7df0c713d659d3$var$CheckBox } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).views.forms.inputs;
var $7b7df0c713d659d3$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'password-reset',
    Model: {
        props: {
            newPassword: [
                'string',
                true
            ],
            confirmPassword: [
                'string',
                true
            ],
            revokeSessions: [
                'boolean',
                false
            ]
        },
        validate: function() {
            return (0, $925fe56dc05ff4ab$export$2e2bcd8739ae039).validatePasswordMatch(this);
        },
        save: function() {
            this.trigger('save');
            const self = this;
            return this.doTransaction(function(transaction) {
                const payload = {
                    newPassword: self.get('newPassword')
                };
                if (self.settings.get('features.showSessionRevocation')) payload.revokeSessions = self.get('revokeSessions');
                return transaction.resetPassword(payload);
            });
        }
    },
    Form: {
        save: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'password.reset', 'login'),
        title: function() {
            return this.settings.get('brandName') ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.reset.title.specific', 'login', [
                this.settings.get('brandName')
            ]) : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.reset.title.generic', 'login');
        },
        subtitle: function() {
            const policy = this.options.appState.get('policy');
            if (!policy || this.settings.get('features.showPasswordRequirementsAsHtmlList')) return;
            return (0, $020a58caf88b7504$export$2e2bcd8739ae039).getPasswordComplexityDescription(policy);
        },
        parseErrorMessage: function(responseJSON) {
            const policy = this.options.appState.get('policy');
            if (!!policy && this.settings.get('features.showPasswordRequirementsAsHtmlList')) /*
          - This is a specific case where don't want to repeat the requirements again in the error message, since this
            is already shown in the description. The description as bullet-points itself should give an indication
            of the requirements.
          - We cannot check for error code this in this case, as the error code is shared between
            requirements not met message, common password message, etc. So error summary is the only differentiating
            factor. Replace the password requirements string with empty string in this case.
        */ responseJSON = (0, $020a58caf88b7504$export$2e2bcd8739ae039).removeRequirementsFromError(responseJSON, policy);
            return responseJSON;
        },
        formChildren: function() {
            let children = [];
            if (this.settings.get('features.showPasswordRequirementsAsHtmlList')) children.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                View: new (0, $77137e835f54c8b5$export$2e2bcd8739ae039)({
                    policy: this.options.appState.get('policy')
                })
            }));
            children = children.concat([
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                    className: 'margin-btm-5',
                    label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.newPassword.placeholder', 'login'),
                    'label-top': true,
                    explain: (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).createInputExplain('password.newPassword.tooltip', 'password.newPassword.placeholder', 'login'),
                    'explain-top': true,
                    name: 'newPassword',
                    input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
                    type: 'password',
                    autoComplete: (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).getAutocompleteValue(this.settings, 'new-password')
                }),
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                    label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.confirmPassword.placeholder', 'login'),
                    'label-top': true,
                    explain: (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).createInputExplain('password.confirmPassword.tooltip', 'password.confirmPassword.placeholder', 'login'),
                    'explain-top': true,
                    name: 'confirmPassword',
                    input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
                    type: 'password',
                    autoComplete: (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).getAutocompleteValue(this.settings, 'new-password')
                })
            ]);
            if (this.settings.get('features.showSessionRevocation')) children = children.concat([
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                    placeholder: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.reset.revokeSessions', 'login'),
                    name: 'revokeSessions',
                    input: $7b7df0c713d659d3$var$CheckBox,
                    type: 'checkbox'
                })
            ]);
            return children;
        }
    },
    initialize: function() {
        this.listenTo(this.form, 'save', function() {
            const creds = {
                username: this.options.appState.get('userEmail'),
                password: this.model.get('newPassword')
            };
            this.settings.processCreds(creds).then((0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(this.model.save, this.model));
        });
        if (!this.settings.get('features.hideBackToSignInForReset')) this.addFooter((0, $3b6768ac3357a97d$export$2e2bcd8739ae039));
    }
});














/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $e9bf78d14c010834$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'poll',
    Model: {
        save: function() {
            this.trigger('cancelRequest');
            return this.appState.get('transaction').cancel().then(()=>{
                this.options.appState.trigger('navigate', '');
            }).catch(()=>{
                this._stopCountDown();
            });
        }
    },
    Form: {
        autoSave: true,
        hasSavingState: false,
        title: function() {
            return this.title;
        },
        className: 'poll-controller',
        noCancelButton: true,
        save: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oform.cancel', 'login'),
        modelEvents: {
            cancelRequest: '_stopCountDown'
        },
        formChildren: [
            (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                View: '<div >\
               <div data-se="poll-waiting" class="hide okta-waiting-spinner"></div>\
             </div>'
            })
        ],
        _checkStatus: function() {
            // start polling request
            this.transactionObject.poll().then((resp)=>{
                if (resp.data && resp.status !== 'POLL') {
                    this.options.appState.set('transaction', resp);
                    return;
                }
                this.$('.okta-waiting-spinner').hide();
                let factorPollingIntervalSeconds = Math.ceil(resp.transaction.profile.refresh / 1000);
                this._startCountDown(factorPollingIntervalSeconds);
            }).catch(()=>{
                this._stopCountDown();
            });
        },
        _startCountDown: function(factorPollingIntervalSeconds) {
            // start one second countdown for next poll request
            this.countDown = setInterval(()=>{
                // update title after every second and check if countdown == 1 to poll again
                this._updateTitle(factorPollingIntervalSeconds);
                if (factorPollingIntervalSeconds === 0) {
                    /* when countdown hits 0
                       - stop current poll
                       - show spinner
                       - check status
                      */ this._stopCountDown();
                    this.$('.okta-waiting-spinner').show();
                    // start after a small delay so that the spinner does not get hidden too soon
                    this.checkStatusTimeout = setTimeout(()=>{
                        this._checkStatus();
                    }, 200);
                } else // reduce countdown after every second
                factorPollingIntervalSeconds = factorPollingIntervalSeconds - 1;
            }, 1000);
        },
        _updateTitle: function(factorPollingIntervalSeconds) {
            this.title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('polling.title', 'login', [
                factorPollingIntervalSeconds
            ]);
            this.$el.find('.okta-form-title').text(this.title);
        },
        _stopCountDown: function() {
            // clear countdown setInterval
            if (this.countDown) clearInterval(this.countDown);
            // clear checkstatus setTimeout
            if (this.checkStatusTimeout) clearInterval(this.checkStatusTimeout);
        },
        initialize: function(options) {
            this.transactionObject = options.appState.get('transaction');
            this.factorPollingIntervalSeconds = Math.ceil(this.transactionObject.transaction.profile.refresh / 1000);
            this._updateTitle(this.factorPollingIntervalSeconds);
            this._startCountDown(this.factorPollingIntervalSeconds);
        }
    },
    back: function() {
    // Empty function on verify controllers to prevent users
    // from navigating back during 'verify' using the browser's
    // back button. The URL will still change, but the view will not
    // More details in OKTA-135060.
    },
    remove: function() {
        this.form._stopCountDown();
    }
});
















var $a0a7bb80dd446175$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'password-reset-email-sent',
    Model: function() {
        return {
            local: {
                userFullName: [
                    'string',
                    false,
                    this.options.appState.get('userFullName')
                ]
            }
        };
    },
    Form: {
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'password.forgot.emailSent.title', 'login'),
        subtitle: function() {
            const username = this.options.appState.get('username');
            return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.forgot.emailSent.desc', 'login', [
                username
            ]);
        },
        noButtonBar: true,
        attributes: {
            'data-se': 'pwd-reset-email-sent'
        },
        formChildren: function() {
            let children = [
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                    View: (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                        template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                            "compiler": [
                                8,
                                ">= 4.3.0"
                            ],
                            "main": function(container, depth0, helpers, partials, data) {
                                var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                                    return undefined;
                                };
                                return "<span class=\"accessibility-text\" role=\"status\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "alert") || (depth0 != null ? lookupProperty(depth0, "alert") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                                    "name": "alert",
                                    "hash": {},
                                    "data": data,
                                    "loc": {
                                        "start": {
                                            "line": 1,
                                            "column": 47
                                        },
                                        "end": {
                                            "line": 1,
                                            "column": 56
                                        }
                                    }
                                }) : helper)) + "</span>";
                            },
                            "useData": true
                        }),
                        getTemplateData: function() {
                            return {
                                alert: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.forgot.emailSent.title', 'login')
                            };
                        }
                    })
                })
            ];
            if (!this.settings.get('features.hideBackToSignInForReset')) children.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Button({
                title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('goback', 'login'),
                className: 'button button-primary button-wide',
                attributes: {
                    'data-se': 'back-button'
                },
                click: function() {
                    const self = this;
                    return this.model.doTransaction(function(transaction) {
                        return transaction.cancel();
                    }).then(function() {
                        self.state.set('navigateDir', (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).DIRECTION_BACK);
                        self.options.appState.trigger('navigate', '');
                    });
                }
            }));
            return children;
        }
    },
    initialize: function(options) {
        this.settings.callGlobalSuccess((0, $e48c043f6d2d382d$export$2e2bcd8739ae039).FORGOT_PASSWORD_EMAIL_SENT, {
            username: options.appState.get('username')
        });
    }
});

















var $fe93fdd3fd387c42$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'recovery-challenge',
    Model: {
        props: {
            passCode: [
                'string',
                true
            ]
        },
        local: {
            ableToResend: 'boolean'
        },
        resendCode: function() {
            // Note: This does not require a trapAuthResponse because Backbone's
            // router will not navigate if the url path is the same
            this.limitResending();
            return this.doTransaction(function(transaction) {
                return transaction.resend();
            });
        },
        limitResending: function() {
            this.set({
                ableToResend: false
            });
            (0, $3e490973b7383cc4$export$2e2bcd8739ae039).delay((0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(this.set, this), (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).API_RATE_LIMIT, {
                ableToResend: true
            });
        },
        save: function() {
            return this.doTransaction(function(transaction) {
                return transaction.verify({
                    passCode: this.get('passCode')
                });
            });
        }
    },
    Form: {
        autoSave: true,
        save: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'mfa.challenge.verify', 'login'),
        title: function() {
            if (this.options.appState.get('factorType') === (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).RECOVERY_FACTOR_TYPE_CALL) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('recoveryChallenge.call.title', 'login');
            else return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('recoveryChallenge.sms.title', 'login');
        },
        className: 'recovery-challenge',
        initialize: function() {
            this.listenTo(this.model, 'error', function() {
                this.clearErrors();
            });
        },
        formChildren: function() {
            return [
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Button({
                    title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.resendCode', 'login'),
                    attributes: {
                        'data-se': 'resend-button'
                    },
                    className: 'button sms-request-button margin-top-30',
                    click: function() {
                        this.model.resendCode();
                    },
                    initialize: function() {
                        this.listenTo(this.model, 'change:ableToResend', function(model, ableToResend) {
                            if (ableToResend) {
                                this.options.title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.resendCode', 'login');
                                this.enable();
                                this.render();
                            } else {
                                this.options.title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.sent', 'login');
                                this.disable();
                                this.render();
                            }
                        });
                    }
                }),
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                    label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.enterCode.placeholder', 'login'),
                    'label-top': true,
                    className: 'enroll-sms-phone',
                    name: 'passCode',
                    input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
                    type: 'text'
                })
            ];
        }
    },
    events: {
        'click .send-email-link': function(e) {
            e.preventDefault();
            const settings = this.model.settings;
            const username = this.options.appState.get('username');
            const recoveryType = this.options.appState.get('recoveryType');
            this.model.startTransaction(function(authClient) {
                // The user could have landed here via the Forgot Password/Unlock Account flow
                switch(recoveryType){
                    case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).RECOVERY_TYPE_PASSWORD:
                        return authClient.forgotPassword({
                            username: settings.transformUsername(username, (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).FORGOT_PASSWORD),
                            factorType: (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).RECOVERY_FACTOR_TYPE_EMAIL
                        });
                    case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).RECOVERY_TYPE_UNLOCK:
                        return authClient.unlockAccount({
                            username: settings.transformUsername(username, (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).UNLOCK_ACCOUNT),
                            factorType: (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).RECOVERY_FACTOR_TYPE_EMAIL
                        });
                    default:
                        return;
                }
            }).catch(()=>{});
        }
    },
    initialize: function() {
        const recoveryType = this.options.appState.get('recoveryType');
        let sendEmailLink;
        switch(recoveryType){
            case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).RECOVERY_TYPE_PASSWORD:
                sendEmailLink = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                    "compiler": [
                        8,
                        ">= 4.3.0"
                    ],
                    "main": function(container, depth0, helpers, partials, data) {
                        var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                            return undefined;
                        };
                        return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                            "name": "i18n",
                            "hash": {
                                "bundle": "login",
                                "code": "password.forgot.code.notReceived"
                            },
                            "data": data,
                            "loc": {
                                "start": {
                                    "line": 1,
                                    "column": 0
                                },
                                "end": {
                                    "line": 1,
                                    "column": 63
                                }
                            }
                        }));
                    },
                    "useData": true
                });
                break;
            case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).RECOVERY_TYPE_UNLOCK:
                sendEmailLink = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                    "compiler": [
                        8,
                        ">= 4.3.0"
                    ],
                    "main": function(container, depth0, helpers, partials, data) {
                        var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                            return undefined;
                        };
                        return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                            "name": "i18n",
                            "hash": {
                                "bundle": "login",
                                "code": "account.unlock.code.notReceived"
                            },
                            "data": data,
                            "loc": {
                                "start": {
                                    "line": 1,
                                    "column": 0
                                },
                                "end": {
                                    "line": 1,
                                    "column": 62
                                }
                            }
                        }));
                    },
                    "useData": true
                });
                break;
        }
        if (sendEmailLink && this.settings.get('features.emailRecovery')) this.add((0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
            className: 'link send-email-link',
            tagName: 'a',
            attributes: {
                href: '#',
                'data-se': 'send-email-link'
            },
            template: sendEmailLink
        }));
        if (!this.settings.get('features.hideBackToSignInForReset')) this.addFooter((0, $3b6768ac3357a97d$export$2e2bcd8739ae039));
    },
    postRender: function() {
        this.model.limitResending();
    }
});



/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $f3697ac887a293ed$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'recovery-loading',
    Model: {},
    Form: {
        noButtonBar: true
    },
    initialize: function(options) {
        const self = this;
        const factorEnroll = this.options.settings.get('features.multiOptionalFactorEnroll');
        return this.model.startTransaction(function(authClient) {
            return authClient.verifyRecoveryToken({
                recoveryToken: options.token,
                ...factorEnroll && {
                    multiOptionalFactorEnroll: factorEnroll
                }
            });
        }).catch(function() {
            self.options.appState.trigger('loading', false);
            self.options.appState.trigger('removeLoading');
        });
    },
    preRender: function() {
        this.options.appState.trigger('loading', true);
    },
    trapAuthResponse: function() {
        this.options.appState.trigger('loading', false);
        return false;
    }
});
















/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $72af1de338e371b3$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'recovery-question',
    Model: {
        props: {
            answer: [
                'string',
                true
            ],
            showAnswer: 'boolean'
        },
        save: function() {
            return this.doTransaction(function(transaction) {
                return transaction.answer({
                    answer: this.get('answer')
                });
            });
        }
    },
    Form: {
        autoSave: true,
        save: function() {
            switch(this.options.appState.get('recoveryType')){
                case 'PASSWORD':
                    return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.forgot.question.submit', 'login');
                case 'UNLOCK':
                    return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('account.unlock.question.submit', 'login');
                default:
                    return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.verify', 'login');
            }
        },
        title: function() {
            switch(this.options.appState.get('recoveryType')){
                case 'PASSWORD':
                    return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.forgot.question.title', 'login');
                case 'UNLOCK':
                    return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('account.unlock.question.title', 'login');
                default:
                    return '';
            }
        },
        formChildren: function() {
            return [
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                    label: this.options.appState.get('recoveryQuestion'),
                    placeholder: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.answer.placeholder', 'login'),
                    name: 'answer',
                    input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
                    type: 'password',
                    initialize: function() {
                        this.listenTo(this.model, 'change:showAnswer', function() {
                            const type = this.model.get('showAnswer') ? 'text' : 'password';
                            this.getInputs()[0].changeType(type);
                        });
                    }
                }),
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                    label: false,
                    'label-top': true,
                    placeholder: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.answer.showAnswer', 'login'),
                    className: 'recovery-question-show margin-btm-0',
                    name: 'showAnswer',
                    type: 'checkbox'
                })
            ];
        }
    },
    initialize: function() {
        if (!this.settings.get('features.hideBackToSignInForReset')) this.addFooter((0, $3b6768ac3357a97d$export$2e2bcd8739ae039));
    }
});



/* eslint-disable max-depth */ var $e80118e4fca8f865$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'refresh-auth-state',
    Model: {},
    Form: {
        noButtonBar: true
    },
    preRender: function() {
        const appState = this.options.appState;
        const token = this.options.token;
        this.model.startTransaction(function(authClient) {
            appState.trigger('loading', true);
            if (token) return authClient.tx.introspect({
                stateToken: token
            });
            // get stateToken from cookie
            // currently only applies to old pipeline
            if (authClient.tx.exists()) return authClient.tx.resume();
            appState.trigger('navigate', '');
        })// startTransaction already surfaces failures via the 'error' event; swallow
        // the rejection it re-throws so it does not become an unhandled rejection.
        .catch(()=>{});
    },
    remove: function() {
        this.options.appState.trigger('loading', false);
        return (0, $735c6d0521558dcb$export$2e2bcd8739ae039).prototype.remove.apply(this, arguments);
    }
});















var $0a4a7c3d7a3af0b5$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    events: {
        'click .back-btn': function(e) {
            e.preventDefault();
            this.back();
        }
    },
    back: function() {
        this.state.set('navigateDir', (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).DIRECTION_BACK);
        this.options.appState.trigger('navigate', '');
    },
    className: 'registration-complete',
    Model: function() {},
    initialize: function() {
        this.settings.callGlobalSuccess((0, $e48c043f6d2d382d$export$2e2bcd8739ae039).ACTIVATION_EMAIL_SENT, {
            username: this.options.appState.get('username')
        });
    },
    Form: {
        noButtonBar: true,
        formChildren: function() {
            return [
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                    View: (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                        template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                            "compiler": [
                                8,
                                ">= 4.3.0"
                            ],
                            "main": function(container, depth0, helpers, partials, data) {
                                var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                                    return undefined;
                                };
                                return "<div class=\"container\"><span class=\"title-icon icon icon-16 confirm-16-green\"></span><h2 class=\"title\">" + alias4((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                                    "name": "title",
                                    "hash": {},
                                    "data": data,
                                    "loc": {
                                        "start": {
                                            "line": 1,
                                            "column": 103
                                        },
                                        "end": {
                                            "line": 1,
                                            "column": 112
                                        }
                                    }
                                }) : helper)) + "</h2><div class=\"desc\">" + alias4((helper = (helper = lookupProperty(helpers, "desc") || (depth0 != null ? lookupProperty(depth0, "desc") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                                    "name": "desc",
                                    "hash": {},
                                    "data": data,
                                    "loc": {
                                        "start": {
                                            "line": 1,
                                            "column": 135
                                        },
                                        "end": {
                                            "line": 1,
                                            "column": 143
                                        }
                                    }
                                }) : helper)) + "</div></div><a href=\"#\" class=\"back-btn\" data-se=\"back-link\">" + alias4((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                                    "name": "i18n",
                                    "hash": {
                                        "bundle": "login",
                                        "code": "goback"
                                    },
                                    "data": data,
                                    "loc": {
                                        "start": {
                                            "line": 1,
                                            "column": 204
                                        },
                                        "end": {
                                            "line": 1,
                                            "column": 241
                                        }
                                    }
                                })) + "</a>";
                            },
                            "useData": true
                        }),
                        getTemplateData: function() {
                            return {
                                desc: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('registration.complete.confirm.text', 'login'),
                                title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('registration.complete.title', 'login')
                            };
                        }
                    })
                })
            ];
        }
    }
});























/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $6848f4a165d17d5a$export$2e2bcd8739ae039 = (0, $f24ef70ebb57d1e8$export$2e2bcd8739ae039).extend({
    constructor: function(options) {
        this.settings = options && options.settings;
        (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039).apply(this, arguments);
    },
    loginWithActivationToken: function(activationToken) {
        return this.startTransaction(function(authClient) {
            return authClient.signInWithCredentials({
                token: activationToken
            });
        });
    }
});












/*!
 * Copyright (c) 2017, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ let { BaseSchema: $0dbfd42e79e243a6$var$BaseSchema, SchemaProperty: $0dbfd42e79e243a6$var$SchemaProperty } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).models;
const $0dbfd42e79e243a6$var$RegistrationSchemaRegistrationSchemaPropertyCollection = $0dbfd42e79e243a6$var$SchemaProperty.Collection.extend({
    createModelProperties: function() {
        const modelProperties = $0dbfd42e79e243a6$var$SchemaProperty.Collection.prototype.createModelProperties.apply(this);
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(modelProperties, function(modelProperty, name) {
            modelProperty.required = !!this.get(name).get('required');
        }, this);
        return modelProperties;
    }
});
var $0dbfd42e79e243a6$export$2e2bcd8739ae039 = $0dbfd42e79e243a6$var$BaseSchema.Model.extend({
    expand: [
        'schema'
    ],
    constructor: function() {
        this.properties = new $0dbfd42e79e243a6$var$RegistrationSchemaRegistrationSchemaPropertyCollection();
        (0, $82ddb6bf367b57ea$export$2e2bcd8739ae039).apply(this, arguments);
    },
    parse: function(resp) {
        const parseResponseData = (resp)=>{
            const requireFields = resp.schema.required;
            if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(requireFields)) (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(requireFields, function(requireField) {
                const field = this.properties.get(requireField);
                if (field) field.set('required', true);
            }, this);
            const fieldOrderIds = resp.schema.fieldOrder;
            if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isArray(fieldOrderIds)) {
                (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(fieldOrderIds, function(fieldOrderId, sortOrder) {
                    const field = this.properties.get(fieldOrderId);
                    if (field) field.set('sortOrder', sortOrder);
                }, this);
                this.properties.comparator = 'sortOrder';
                this.properties.sort();
            }
            this.properties.defaultPolicyId = resp.policyId;
            return resp;
        };
        const self = this;
        this.settings.parseRegistrationSchema(resp, function(resp) {
            if (resp.profileSchema) {
                resp.schema = resp.profileSchema;
                $0dbfd42e79e243a6$var$BaseSchema.Model.prototype.parse.apply(self, [
                    resp
                ]);
                resp = parseResponseData(resp);
            }
            self.trigger('parseComplete', {
                properties: self.properties
            });
        }, function(error) {
            self.trigger('parseComplete', {
                properties: self.properties,
                error: error
            });
        });
    }
});

















const $4a1268331c0106aa$var$SubSchemaSubSchema = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    index: '',
    message: '',
    class: function() {
        return;
    },
    className: function() {
        return 'subschema-unsatisfied subschema-' + this.index;
    },
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p class=\"default-schema\"><span class=\"icon icon-16\"></span>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "message") || (depth0 != null ? lookupProperty(depth0, "message") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "message",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 60
                    },
                    "end": {
                        "line": 1,
                        "column": 71
                    }
                }
            }) : helper)) + "</p>";
        },
        "useData": true
    }),
    getTemplateData: function() {
        return {
            message: this.message
        };
    }
});
var $4a1268331c0106aa$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'subschema',
    children: function() {
        return this.subSchemas.map(function(subSchema, index) {
            const description = subSchema.get('description');
            const message = description;
            // TODO API should send translated strings instead of i18n code inside description
            // or send param with i18n code
            return $4a1268331c0106aa$var$SubSchemaSubSchema.extend({
                index: index,
                message: message
            });
        });
    }
});


const $49ec60c8878cee4a$var$RegistrationControllerFooter = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a href=\"#\" class=\"link help\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "goback"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 50
                    },
                    "end": {
                        "line": 1,
                        "column": 87
                    }
                }
            })) + "</a>";
        },
        "useData": true
    }),
    className: 'auth-footer',
    events: {
        'click .help': function(e) {
            e.preventDefault();
            this.back();
        }
    },
    back: function() {
        this.state.set('navigateDir', (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).DIRECTION_BACK);
        this.options.appState.trigger('navigate', '');
    }
});
var $49ec60c8878cee4a$export$2e2bcd8739ae039 = (0, $6887ec4c502ac936$export$2e2bcd8739ae039).extend({
    className: 'registration',
    initialize: function() {
        const RegistrationControllerSchema = (0, $0dbfd42e79e243a6$export$2e2bcd8739ae039).extend({
            settings: this.options.settings,
            url: this.options.settings.get('baseUrl') + '/api/v1/registration/form'
        });
        // setup schema
        const schema = new RegistrationControllerSchema();
        this.state.set('schema', schema);
    },
    getRegistrationApiUrl: function() {
        const defaultPolicyId = this.settings.get('defaultPolicyId');
        // default policyId
        const orgPolicyId = this.options.settings.get('policyId');
        // org policyId
        const apiUrl = defaultPolicyId ? this.getRegistrationPolicyApi(defaultPolicyId) : this.getRegistrationPolicyApi(orgPolicyId);
        return apiUrl;
    },
    getRegistrationPolicyApi: function(policyId) {
        return this.options.settings.get('baseUrl') + '/api/v1/registration/' + policyId;
    },
    doPostSubmit: function() {
        if (this.model.get('activationToken')) {
            const self = this;
            // register via activation token
            self.settings.callGlobalSuccess((0, $e48c043f6d2d382d$export$2e2bcd8739ae039).REGISTRATION_COMPLETE, {
                activationToken: this.model.get('activationToken')
            });
            const loginModel = new (0, $6848f4a165d17d5a$export$2e2bcd8739ae039)({
                settings: self.model.appState.settings
            });
            loginModel.loginWithActivationToken(this.model.get('activationToken')).then(function(transaction) {
                self.model.trigger('setTransaction', transaction);
            });
        } else {
            // register via activation email
            this.model.appState.set('username', this.model.get('email'));
            this.model.appState.trigger('navigate', 'signin/register-complete');
        }
    },
    registerUser: function(postData) {
        const self = this;
        Object.keys(postData).forEach((k)=>((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isNull(postData[k]) || (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isUndefined(postData[k]) || postData[k] === '') && delete postData[k]);
        this.model.attributes = postData;
        // Model.save returns a jqXHR
        (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Model.prototype.save.call(this.model).then(function() {
            self.model.trigger('startSaving');
            const activationToken = self.model.get('activationToken');
            const postSubmitData = activationToken ? activationToken : self.model.get('email');
            self.settings.postRegistrationSubmit(postSubmitData, function() {
                self.doPostSubmit();
            }, function(errors) {
                self.showErrors(errors);
            });
        }).fail((err)=>{
            const responseJSON = err.responseJSON;
            if (responseJSON && responseJSON.errorCauses.length) {
                const { errorCode: errorCode, errorCauses: errorCauses } = responseJSON;
                const { errorSummary: errorSummary, reason: reason, location: location } = errorCauses[0];
                const isNotUniqueValue = errorCode === 'E0000001' && reason === 'UNIQUE_CONSTRAINT';
                if (isNotUniqueValue) this.renderIsNotUniqueError(responseJSON);
                this.renderLegacyLocationErrorIfNeeded(location, errorSummary);
                (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).triggerAfterError(this, new (0, $3fe6932680e7ea64$export$c14277b34f51b283)(errorSummary));
            }
        });
    },
    renderIsNotUniqueError: function(error) {
        const { location: location } = error.errorCauses[0];
        const errorSummary = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('registration.error.userName.notUniqueWithinOrg', 'login', [
            location
        ]);
        // replace generic error message with more specific one
        // without using backbone events because there was a race condition
        // between clearing and triggering errors
        this.$el.find('.okta-form-infobox-error p').text(errorSummary);
    },
    renderLegacyLocationErrorIfNeeded: function(location, errorSummary) {
        // replace generic error message with errorSummary for v1 SIW
        // this makes sure that with legacy location that starts with `data.userProfile`
        // we still see the errorSummary in the error banner instead of only a generic error
        // See example in https://developer.okta.com/docs/reference/registration-hook/#sample-json-payload-of-request
        if (location && /^data\.userProfile.*/.test(location)) this.$el.find('.okta-form-infobox-error p').text(errorSummary);
    },
    createRegistrationModel: function(modelProperties) {
        const self = this;
        const RegistrationControllerModel = (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039).extend({
            url: self.getRegistrationApiUrl() + '/register',
            settings: this.settings,
            appState: this.options.appState,
            props: modelProperties,
            local: {
                activationToken: 'string'
            },
            toJSON: function() {
                const data = (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039).prototype.toJSON.apply(this, arguments);
                return {
                    userProfile: data,
                    relayState: this.settings.get('relayState')
                };
            },
            parse: function(resp) {
                this.set('activationToken', resp.activationToken);
                delete resp.activationToken;
                return resp;
            },
            save: function() {
                this.settings.preRegistrationSubmit(this.attributes, function(postData) {
                    self.registerUser(postData);
                }, function(errors) {
                    self.showErrors(errors);
                });
            }
        });
        return new RegistrationControllerModel();
    },
    showErrors: function(error, hideRegisterButton) {
        //for parseSchema error hide form and show error at form level
        if (error.callback === 'parseRegistrationSchema' && error.errorCauses) {
            error.errorSummary = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone(error.errorCauses[0].errorSummary);
            delete error.errorCauses;
        }
        //show error on form
        this.model.trigger('error', this.model, {
            responseJSON: error
        });
        //throw registration error
        const errMsg = error.callback ? error.callback + ':' + error.errorSummary : error.errorSummary;
        (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).triggerAfterError(this, new (0, $3fe6932680e7ea64$export$c14277b34f51b283)(errMsg));
        if (hideRegisterButton) this.$el.find('.button-primary').hide();
    },
    fetchInitialData: function() {
        const self = this;
        // register parse complete event listener
        self.state.get('schema').on('parseComplete', function(updatedSchema) {
            const modelProperties = updatedSchema.properties.createModelProperties();
            self.settings.set('defaultPolicyId', updatedSchema.properties.defaultPolicyId);
            // create model
            self.model = self.createRegistrationModel(modelProperties);
            // create form
            const RegistrationControllerForm = (0, $5d64eb84267ab4e8$export$a7fed597f4b8afd8).extend({
                layout: 'o-form-theme',
                autoSave: true,
                noCancelButton: true,
                title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('registration.form.title', 'login'),
                save: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('registration.form.submit', 'login'),
                modelEvents: {
                    'invalid': 'modifyErrors'
                },
                hasSavingState: true,
                customSavingState: {
                    start: 'startSaving',
                    stop: 'stopSaving'
                },
                modifyErrors: function(model, errorResp) {
                    // overwrite courage errorResp object to show custom error message
                    for(let formFieldName in errorResp){
                        if (errorResp[formFieldName] === 'model.validation.field.string.minLength') errorResp[formFieldName] = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('registration.model.validation.field.string.too.short', 'login', [
                            model.props[formFieldName].minLength
                        ]);
                        else if (errorResp[formFieldName] === 'model.validation.field.string.maxLength') errorResp[formFieldName] = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('registration.model.validation.field.string.too.long', 'login', [
                            model.props[formFieldName].maxLength + 1
                        ]);
                    }
                }
            });
            const form = new RegistrationControllerForm(self.toJSON());
            // add form
            self.add(form);
            // add footer
            self.footer = new self.Footer(self.toJSON());
            self.add(self.footer);
            self.addListeners();
            if (updatedSchema.error) self.showErrors(updatedSchema.error, true);
            else {
                // add fields
                updatedSchema.properties.each(function(schemaProperty) {
                    const inputOptions = (0, $aa64e1b90972a64e$export$2e2bcd8739ae039).createInputOptions(schemaProperty);
                    const subSchemas = schemaProperty.get('subSchemas');
                    const name = schemaProperty.get('name');
                    form.addInput(inputOptions);
                    if (name === 'password' && subSchemas) form.add((0, $4a1268331c0106aa$export$2e2bcd8739ae039).extend({
                        id: 'subschemas-' + name,
                        subSchemas: subSchemas
                    }));
                });
                const requiredFieldsLabel = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                    "compiler": [
                        8,
                        ">= 4.3.0"
                    ],
                    "main": function(container, depth0, helpers, partials, data) {
                        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                            return undefined;
                        };
                        return "<span class=\"required-fields-label\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                            "name": "label",
                            "hash": {},
                            "data": data,
                            "loc": {
                                "start": {
                                    "line": 1,
                                    "column": 36
                                },
                                "end": {
                                    "line": 1,
                                    "column": 45
                                }
                            }
                        }) : helper)) + "</span>";
                    },
                    "useData": true
                })({
                    label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('registration.required.fields.label', 'login')
                });
                form.add(requiredFieldsLabel);
            }
        });
        // fetch schema from API, returns a jqXHR. Wrap it in a native Promise
        return Promise.resolve(this.state.get('schema').fetch());
    },
    Footer: $49ec60c8878cee4a$var$RegistrationControllerFooter
});



















const $268061122cf4617d$var$UnlockAccountControllernoFactorsError = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"okta-form-infobox-error infobox infobox-error\" role=\"alert\"><span class=\"icon error-16\"></span><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "account.unlock.noFactorsEnabled"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 110
                    },
                    "end": {
                        "line": 1,
                        "column": 172
                    }
                }
            })) + "</p></div>";
        },
        "useData": true
    })
});
const $268061122cf4617d$var$UnlockAccountControllerFooter = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a href=\"#\" class=\"link goto js-contact-support\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "mfa.noAccessToEmail"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 173
                    },
                    "end": {
                        "line": 1,
                        "column": 223
                    }
                }
            })) + "</a>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a href=\"#\" class=\"link help js-back\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "goback"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 58
                    },
                    "end": {
                        "line": 1,
                        "column": 95
                    }
                }
            })) + "</a>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "helpSupportNumber") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 99
                    },
                    "end": {
                        "line": 1,
                        "column": 234
                    }
                }
            })) != null ? stack1 : "");
        },
        "useData": true
    }),
    className: 'auth-footer',
    events: {
        'click .js-back': function(e) {
            e.preventDefault();
            this.back();
        },
        'click .js-contact-support': function(e) {
            e.preventDefault();
            this.state.trigger('contactSupport');
            this.$('.js-contact-support').hide();
        }
    },
    getTemplateData: function() {
        return this.settings.pick('helpSupportNumber');
    },
    back: function() {
        this.state.set('navigateDir', (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).DIRECTION_BACK);
        this.options.appState.trigger('navigate', '');
    }
});
var $268061122cf4617d$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'account-unlock',
    Model: {
        props: {
            username: [
                'string',
                true
            ],
            factorType: [
                'string',
                true
            ]
        },
        validate: function() {
            return (0, $925fe56dc05ff4ab$export$2e2bcd8739ae039).validateUsername(this);
        },
        save: function() {
            const self = this;
            return this.startTransaction(function(authClient) {
                return authClient.unlockAccount({
                    username: self.settings.transformUsername(self.get('username'), (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).UNLOCK_ACCOUNT),
                    factorType: self.get('factorType')
                });
            }).catch(function() {
            //need empty fail handler on model to display errors on form
            });
        }
    },
    Form: {
        noButtonBar: true,
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'account.unlock.title', 'login'),
        formChildren: function() {
            const smsEnabled = this.settings.get('features.smsRecovery');
            /*eslint complexity: [2, 9] max-statements: [2, 24] */ const callEnabled = this.settings.get('features.callRecovery');
            const emailEnabled = this.settings.get('features.emailRecovery');
            const noFactorsEnabled = !(smsEnabled || callEnabled || emailEnabled);
            const formChildren = [];
            const form = this;
            if (noFactorsEnabled) this.add($268061122cf4617d$var$UnlockAccountControllernoFactorsError, '.o-form-error-container');
            else {
                formChildren.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                    label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('account.unlock.email.or.username.placeholder', 'login'),
                    'label-top': true,
                    explain: (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).createInputExplain('account.unlock.email.or.username.tooltip', 'account.unlock.email.or.username.placeholder', 'login'),
                    'explain-top': true,
                    name: 'username',
                    input: (0, $063de20ba11c0f5c$export$2e2bcd8739ae039),
                    inputId: 'account-recovery-username',
                    type: 'text',
                    inlineValidation: false
                }));
                if (smsEnabled || callEnabled) formChildren.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                    View: (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                        template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                            "compiler": [
                                8,
                                ">= 4.3.0"
                            ],
                            "main": function(container, depth0, helpers, partials, data) {
                                var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                                    return undefined;
                                };
                                return "<p class=\"mobile-recovery-hint\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                                    "name": "i18n",
                                    "hash": {
                                        "arguments": "mobileFactors",
                                        "bundle": "login",
                                        "code": "recovery.mobile.hint"
                                    },
                                    "data": data,
                                    "loc": {
                                        "start": {
                                            "line": 1,
                                            "column": 32
                                        },
                                        "end": {
                                            "line": 1,
                                            "column": 109
                                        }
                                    }
                                })) + "</p>";
                            },
                            "useData": true
                        }),
                        getTemplateData: function() {
                            let mobileFactors;
                            if (smsEnabled && callEnabled) mobileFactors = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('recovery.smsOrCall');
                            else if (callEnabled) mobileFactors = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('recovery.call');
                            else mobileFactors = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('recovery.sms');
                            return {
                                mobileFactors: mobileFactors
                            };
                        }
                    })
                }));
                if (smsEnabled) {
                    this.$el.addClass('forgot-password-sms-enabled');
                    formChildren.push(this.createRecoveryFactorButton('sms-button', 'account.unlock.sendText', (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).RECOVERY_FACTOR_TYPE_SMS, form));
                    this.setDefaultFactorType((0, $e48c043f6d2d382d$export$2e2bcd8739ae039).RECOVERY_FACTOR_TYPE_SMS);
                }
                if (callEnabled) {
                    this.$el.addClass('forgot-password-call-enabled');
                    formChildren.push(this.createRecoveryFactorButton('call-button', 'account.unlock.voiceCall', (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).RECOVERY_FACTOR_TYPE_CALL, form));
                    this.setDefaultFactorType((0, $e48c043f6d2d382d$export$2e2bcd8739ae039).RECOVERY_FACTOR_TYPE_CALL);
                }
                if (emailEnabled) {
                    this.$el.addClass('forgot-password-email-enabled');
                    formChildren.push(this.createRecoveryFactorButton('email-button', 'account.unlock.sendEmail', (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).RECOVERY_FACTOR_TYPE_EMAIL, form));
                    this.setDefaultFactorType((0, $e48c043f6d2d382d$export$2e2bcd8739ae039).RECOVERY_FACTOR_TYPE_EMAIL);
                }
            }
            return formChildren;
        },
        initialize: function() {
            this.listenTo(this, 'save', function() {
                this.options.appState.set('username', this.model.get('username'));
                this.model.save();
            });
            this.listenTo(this.state, 'contactSupport', function() {
                this.add((0, $ea80dae0b72181e6$export$2e2bcd8739ae039), '.o-form-error-container');
            });
        },
        setDefaultFactorType: function(factorType) {
            if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(this.model.get('factorType'))) this.model.set('factorType', factorType);
        },
        createRecoveryFactorButton: function(className, labelCode, factorType, form) {
            return (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Button({
                attributes: {
                    'data-se': className
                },
                className: 'button button-primary button-wide ' + className,
                title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(labelCode, 'login'),
                click: function() {
                    form.clearErrors();
                    if (this.model.isValid()) {
                        this.model.set('factorType', factorType);
                        form.trigger('save', this.model);
                    }
                }
            });
        }
    },
    Footer: $268061122cf4617d$var$UnlockAccountControllerFooter
});















/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $9ca5d3e3949f8917$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'account-unlock-email-sent',
    Model: function() {
        return {
            local: {
                userFullName: [
                    'string',
                    false,
                    this.options.appState.get('userFullName')
                ]
            }
        };
    },
    Form: {
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'account.unlock.emailSent.title', 'login'),
        subtitle: function() {
            const username = this.options.appState.get('username');
            return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('account.unlock.emailSent.desc', 'login', [
                username
            ]);
        },
        noButtonBar: true,
        attributes: {
            'data-se': 'unlock-email-sent'
        },
        formChildren: function() {
            return [
                (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Button({
                    title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('goback', 'login'),
                    className: 'button button-primary button-wide',
                    attributes: {
                        'data-se': 'back-button'
                    },
                    click: function() {
                        this.state.set('navigateDir', (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).DIRECTION_BACK);
                        this.options.appState.trigger('navigate', '');
                    }
                })
            ];
        }
    },
    initialize: function(options) {
        this.settings.callGlobalSuccess((0, $e48c043f6d2d382d$export$2e2bcd8739ae039).UNLOCK_ACCOUNT_EMAIL_SENT, {
            username: options.appState.get('username')
        });
    }
});

















/*!
 * Copyright (c) 2018-2019, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const { Util: $00487d2a08f8c909$var$Util } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).util;
var $00487d2a08f8c909$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'verify-custom-factor custom-factor-form',
    Model: {
        props: {
            rememberDevice: 'boolean'
        },
        initialize: function() {
            const rememberDevice = (0, $020a58caf88b7504$export$2e2bcd8739ae039).getRememberDeviceValue(this.appState);
            // set the initial value for remember device (Cannot do this while defining the
            // local property because this.settings would not be initialized there yet).
            this.set('rememberDevice', rememberDevice);
            if (this.settings.get('features.skipIdpFactorVerificationBtn') && !this.appState.get('lastFailedChallengeFactorData')) {
                this.set('provider', 'CUSTOM');
                this.set('factorType', 'claims_provider');
                this.save();
            }
        },
        save: function() {
            const rememberDevice = !!this.get('rememberDevice');
            return this.manageTransaction((transaction, setTransaction)=>{
                const data = {
                    rememberDevice: rememberDevice
                };
                const factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(transaction.factors, {
                    provider: this.get('provider'),
                    factorType: this.get('factorType')
                });
                return factor.verify(data).then((trans)=>{
                    setTransaction(trans);
                    const url = this.appState.get('verifyCustomFactorRedirectUrl');
                    if (url !== null) $00487d2a08f8c909$var$Util.redirect(url);
                }).catch(function(err) {
                    throw err;
                });
            });
        }
    },
    Form: function() {
        const factors = this.options.appState.get('factors');
        const factor = factors.findWhere({
            provider: this.options.provider,
            factorType: this.options.factorType
        });
        const vendorName = factor.get('vendorName');
        const saveText = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.verify', 'login');
        const lastFailedChallengeFactorData = this.options.appState.get('lastFailedChallengeFactorData');
        let subtitle = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('verify.customFactor.subtitle', 'login', [
            vendorName
        ]);
        if (this.settings.get('features.skipIdpFactorVerificationBtn') && !lastFailedChallengeFactorData) {
            subtitle = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('verify.customFactor.subtitle.redirect', 'login', [
                vendorName
            ]);
            this.listenTo(this.model, 'error', ()=>{
                subtitle = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('verify.customFactor.subtitle', 'login', [
                    vendorName
                ]);
                this.$('.o-form-explain').text(subtitle);
            });
        }
        return {
            autoSave: true,
            title: vendorName,
            save: saveText,
            subtitle: subtitle,
            attributes: {
                'data-se': 'factor-custom'
            },
            initialize: function() {
                if (this.options.appState.get('allowRememberDevice')) this.addInput({
                    label: false,
                    'label-top': true,
                    placeholder: this.options.appState.get('rememberDeviceLabel'),
                    className: 'margin-btm-0',
                    name: 'rememberDevice',
                    type: 'checkbox'
                });
            },
            formChildren: function() {
                const result = [];
                const lastFailedChallengeFactorData = this.options.appState.get('lastFailedChallengeFactorData');
                if (this.settings.get('features.skipIdpFactorVerificationBtn') && !lastFailedChallengeFactorData) result.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                    View: '<div data-se="custom-factor-waiting" class="okta-waiting-spinner"></div>'
                }));
                if (lastFailedChallengeFactorData) result.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                    View: new (0, $b717de154cd703a4$export$2e2bcd8739ae039)({
                        message: lastFailedChallengeFactorData.errorMessage
                    })
                }, {
                    selector: '.o-form-error-container'
                }));
                return result;
            }
        };
    },
    postRender: function() {
        if (this.settings.get('features.skipIdpFactorVerificationBtn') && !this.options.appState.get('lastFailedChallengeFactorData')) {
            this.$('.o-form-button-bar').hide();
            this.$('.okta-waiting-spinner').show();
        }
    },
    trapAuthResponse: function() {
        if (this.options.appState.get('isMfaChallenge')) return true;
    },
    back: function() {
    // Empty function on verify controllers to prevent users
    // from navigating back during 'verify' using the browser's
    // back button. The URL will still change, but the view will not
    // More details in OKTA-135060.
    },
    initialize: function() {
        this.model.set('provider', this.options.provider);
        this.model.set('factorType', this.options.factorType);
        if (this.settings.get('features.skipIdpFactorVerificationBtn')) this.listenTo(this.model, 'error', ()=>{
            this.$('.okta-waiting-spinner').hide();
            this.$('.o-form-button-bar').show();
        });
        this.addFooter((0, $88b800c63cc9d9e3$export$2e2bcd8739ae039));
    }
});
















/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $ef6d256dae36e3cc$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'mfa-verify-duo duo-form',
    Model: {
        props: {
            host: 'string',
            signature: 'string',
            postAction: 'string',
            factorId: 'string',
            stateToken: 'string',
            rememberDevice: 'boolean'
        },
        initialize: function() {
            const rememberDevice = (0, $020a58caf88b7504$export$2e2bcd8739ae039).getRememberDeviceValue(this.appState);
            // set the initial value for remember device (Cannot do this while defining the
            // local property because this.settings would not be initialized there yet).
            this.set('rememberDevice', rememberDevice);
        },
        getInitOptions: function() {
            const rememberDevice = !!this.get('rememberDevice');
            return this.doTransaction(function(transaction) {
                const data = {
                    rememberDevice: rememberDevice
                };
                const factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(transaction.factors, {
                    provider: 'DUO',
                    factorType: 'web'
                });
                return factor.verify(data).catch(function(err) {
                    // Clean up the cookie on failure.
                    throw err;
                });
            }, true);
        },
        verify: function(signedResponse) {
            const url = this.get('postAction');
            const factorId = this.get('factorId');
            const self = this;
            let data = {
                id: factorId,
                stateToken: this.get('stateToken'),
                sig_response: signedResponse
            };
            // Note: We should be doing this in OktaAuth! Fix when it's updated.
            const rememberDevice = this.get('rememberDevice');
            // We don't actually use authClient.post() here (unlike all the other cases in the
            // sign-in widget) since the endpoint is wired to accept serialized form post instead
            // of a JSON post ($.post() is different from authClient.post() in that in $.post(),
            // jquery decides the Content-Type instead of it being a JSON type). Enroll/Verify DUO
            // are the only two places where we actually do this.
            // NOTE - If we ever decide to change this, we should test this very carefully.
            return Promise.resolve((0, $b51a961f9fe28c76$export$2e2bcd8739ae039).post(url, data)).then(function() {
                return self.doTransaction(function(transaction) {
                    let data;
                    if (rememberDevice) data = {
                        rememberDevice: rememberDevice
                    };
                    return transaction.poll(data);
                });
            }).catch(function(err) {
                self.trigger('error', self, err.xhr);
            });
        }
    },
    Form: {
        autoSave: true,
        noButtonBar: true,
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'factor.duo'),
        attributes: {
            'data-se': 'factor-duo'
        },
        postRender: function() {
            this.add('<iframe frameborder="0" title="' + this.title() + '"></iframe>');
            if (this.options.appState.get('allowRememberDevice')) this.addInput({
                label: false,
                'label-top': true,
                placeholder: this.options.appState.get('rememberDeviceLabel'),
                className: 'margin-btm-0',
                name: 'rememberDevice',
                type: 'checkbox'
            });
            (0, $d925b3b89d4ae911$export$2e2bcd8739ae039).init({
                host: this.model.get('host'),
                sig_request: this.model.get('signature'),
                iframe: this.$('iframe').get(0),
                post_action: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(this.model.verify, this.model)
            });
        }
    },
    fetchInitialData: function() {
        const self = this;
        return this.model.getInitOptions().then(function(trans) {
            const res = trans.data;
            if (!res._embedded || !res._embedded.factor || !res._embedded.factor._embedded || !res._embedded.factor._embedded.verification) throw new Error('Response does not have duo verification options');
            const verification = res._embedded.factor._embedded.verification;
            self.model.set({
                host: verification.host,
                signature: verification.signature,
                postAction: verification._links.complete.href,
                factorId: res._embedded.factor.id,
                stateToken: res.stateToken
            });
        });
    },
    trapAuthResponse: function() {
        if (this.options.appState.get('isMfaChallenge')) return true;
    },
    back: function() {
    // Empty function on verify controllers to prevent users
    // from navigating back during 'verify' using the browser's
    // back button. The URL will still change, but the view will not
    // More details in OKTA-135060.
    },
    Footer: (0, $88b800c63cc9d9e3$export$2e2bcd8739ae039)
});















let { Util: $d6138eaa4ac7a9c7$var$Util } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).util;
var $d6138eaa4ac7a9c7$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'piv-cac-card',
    Model: {
        save: async function() {
            this.trigger('request');
            const self = this;
            const pivConfig = this.settings.get('piv');
            const data = {
                fromURI: this.settings.get('relayState'),
                isCustomDomain: pivConfig.isCustomDomain,
                customDomain: pivConfig.customDomain
            };
            try {
                await this.getCert(pivConfig.certAuthUrl);
                const res = await this.postCert(pivConfig.certAuthUrl, data);
                $d6138eaa4ac7a9c7$var$Util.redirect(res.redirectUrl);
            } catch (err) {
                if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(err.responseJSON) && !err.responseText) err.responseJSON = {
                    errorSummary: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('piv.cac.error', 'login')
                };
                self.trigger('error', self, err);
            }
        },
        getCert: function(certAuthUrl) {
            return (0, $b51a961f9fe28c76$export$2e2bcd8739ae039).get({
                url: certAuthUrl,
                xhrFields: {
                    withCredentials: true
                },
                beforeSend: function() {
                // overriding this function to prevent our jquery-wrapper from
                // setting headers. Need to keep this a simple request in order for
                // PIV / CAC to work in IE.
                }
            });
        },
        postCert: function(certAuthUrl, data) {
            return (0, $b51a961f9fe28c76$export$2e2bcd8739ae039).post({
                url: certAuthUrl,
                xhrFields: {
                    withCredentials: true
                },
                data: JSON.stringify(data),
                contentType: 'text/plain',
                beforeSend: function() {
                // overriding this function to prevent our jquery-wrapper from
                // setting headers. Need to keep this a simple request in order for
                // PIV / CAC to work in IE.
                }
            });
        }
    },
    Form: {
        autoSave: true,
        hasSavingState: false,
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'piv.cac.title', 'login'),
        className: 'piv-cac-card',
        noCancelButton: true,
        save: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'retry', 'login'),
        modelEvents: {
            request: '_startEnrollment',
            error: '_stopEnrollment'
        },
        formChildren: [
            (0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                View: (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                        "compiler": [
                            8,
                            ">= 4.3.0"
                        ],
                        "main": function(container, depth0, helpers, partials, data) {
                            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                                return undefined;
                            };
                            return "<div class=\"piv-verify-text\"><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                                "name": "i18n",
                                "hash": {
                                    "bundle": "login",
                                    "code": "piv.cac.card.insert"
                                },
                                "data": data,
                                "loc": {
                                    "start": {
                                        "line": 1,
                                        "column": 32
                                    },
                                    "end": {
                                        "line": 1,
                                        "column": 82
                                    }
                                }
                            })) + "</p><div data-se=\"piv-waiting\" class=\"okta-waiting-spinner\"></div></div>";
                        },
                        "useData": true
                    })
                })
            })
        ],
        _startEnrollment: function() {
            this.$('.okta-waiting-spinner').show();
            this.$('.o-form-button-bar').hide();
        },
        _stopEnrollment: function() {
            this.$('.okta-waiting-spinner').hide();
            this.$('.o-form-button-bar').show();
        },
        postRender: function() {
            (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defer(()=>{
                this.model.save();
            });
        }
    },
    back: function() {
    // Empty function on verify controllers to prevent users
    // from navigating back during 'verify' using the browser's
    // back button. The URL will still change, but the view will not
    // More details in OKTA-135060.
    },
    Footer: (0, $724391db7f3cb295$export$2e2bcd8739ae039)
});





















function $02e856b26edffd37$var$getRegisteredKeysSequence(factors) {
    const keys = [];
    (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(factors, function(factor) {
        keys.push({
            version: factor.profile.version,
            keyHandle: factor.profile.credentialId
        });
    });
    return keys;
}
var $02e856b26edffd37$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'mfa-verify verify-u2f',
    Model: {
        props: {
            rememberDevice: 'boolean'
        },
        initialize: function() {
            const rememberDevice = (0, $020a58caf88b7504$export$2e2bcd8739ae039).getRememberDeviceValue(this.appState);
            // set the initial value for remember device (Cannot do this while defining the
            // local property because this.settings would not be initialized there yet).
            this.set('rememberDevice', rememberDevice);
        },
        save: function() {
            this.trigger('request');
            return this.doTransaction(function(transaction) {
                let factor;
                if (transaction.factorTypes) factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(transaction.factorTypes, {
                    factorType: 'u2f'
                });
                else factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(transaction.factors, {
                    factorType: 'u2f',
                    provider: 'FIDO'
                });
                const self = this;
                return factor.verify().then(function(transaction) {
                    let registeredKeys;
                    let appId;
                    let nonce;
                    if (transaction.factors) {
                        const factors = transaction.factors;
                        appId = factors[0]['profile']['appId'];
                        nonce = transaction.challenge.nonce;
                        registeredKeys = $02e856b26edffd37$var$getRegisteredKeysSequence(factors);
                    } else {
                        const factorData = transaction.factor;
                        appId = factorData.profile.appId;
                        nonce = factorData.challenge.nonce;
                        registeredKeys = [
                            {
                                version: (0, $f16de62271c4c5b1$export$2e2bcd8739ae039).getU2fVersion(),
                                keyHandle: factorData.profile.credentialId
                            }
                        ];
                    }
                    self.trigger('request');
                    const deferred = (0, $6d3dd6c38b8802c0$export$e673efccd97e4223)();
                    u2f.sign(appId, nonce, registeredKeys, function(data) {
                        self.trigger('errors:clear');
                        if (data.errorCode && data.errorCode !== 0) {
                            const isOneFactor = self.options.appState.get('factors').length === 1;
                            deferred.reject(new (0, $3fe6932680e7ea64$export$846acd7e1702fb3f)({
                                xhr: {
                                    responseJSON: {
                                        errorSummary: (0, $f16de62271c4c5b1$export$2e2bcd8739ae039).getU2fVerifyErrorMessageByCode(data.errorCode, isOneFactor)
                                    }
                                }
                            }));
                        } else {
                            const rememberDevice = !!self.get('rememberDevice');
                            return factor.verify({
                                clientData: data.clientData,
                                signatureData: data.signatureData,
                                rememberDevice: rememberDevice
                            }).then(deferred.resolve);
                        }
                    });
                    return deferred.promise;
                });
            }).catch(()=>{});
        }
    },
    Form: {
        autoSave: true,
        hasSavingState: false,
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'factor.u2f', 'login'),
        className: 'verify-u2f-form',
        noCancelButton: true,
        save: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'verify.u2f.retry', 'login'),
        noButtonBar: function() {
            return !(0, $f16de62271c4c5b1$export$2e2bcd8739ae039).isU2fAvailable();
        },
        modelEvents: {
            request: '_startEnrollment',
            error: '_stopEnrollment'
        },
        formChildren: function() {
            const result = [];
            if (!(0, $f16de62271c4c5b1$export$2e2bcd8739ae039).isU2fAvailable()) {
                let errorMessageKey = 'u2f.error.factorNotSupported';
                if (this.options.appState.get('factors').length === 1) errorMessageKey = 'u2f.error.factorNotSupported.oneFactor';
                result.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                    View: new (0, $b717de154cd703a4$export$2e2bcd8739ae039)({
                        message: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(errorMessageKey, 'login')
                    })
                }, {
                    selector: '.o-form-error-container'
                }));
            } else result.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                View: (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                        "compiler": [
                            8,
                            ">= 4.3.0"
                        ],
                        "main": function(container, depth0, helpers, partials, data) {
                            var alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                                return undefined;
                            };
                            return "<div class=\"u2f-verify-text\"><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                                "name": "i18n",
                                "hash": {
                                    "bundle": "login",
                                    "code": "verify.u2f.instructions"
                                },
                                "data": data,
                                "loc": {
                                    "start": {
                                        "line": 1,
                                        "column": 32
                                    },
                                    "end": {
                                        "line": 1,
                                        "column": 86
                                    }
                                }
                            })) + "</p><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                                "name": "i18n",
                                "hash": {
                                    "bundle": "login",
                                    "code": "verify.u2f.instructionsBluetooth"
                                },
                                "data": data,
                                "loc": {
                                    "start": {
                                        "line": 1,
                                        "column": 93
                                    },
                                    "end": {
                                        "line": 1,
                                        "column": 156
                                    }
                                }
                            })) + "</p><div data-se=\"u2f-waiting\" class=\"okta-waiting-spinner\"></div></div>";
                        },
                        "useData": true
                    })
                })
            }));
            if (this.options.appState.get('allowRememberDevice')) result.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                label: false,
                'label-top': true,
                placeholder: this.options.appState.get('rememberDeviceLabel'),
                className: 'margin-btm-0',
                name: 'rememberDevice',
                type: 'checkbox'
            }));
            return result;
        },
        postRender: function() {
            (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defer(()=>{
                if ((0, $f16de62271c4c5b1$export$2e2bcd8739ae039).isU2fAvailable()) this.model.save();
                else this.$('[data-se="u2f-waiting"]').addClass('hide');
            });
        },
        _startEnrollment: function() {
            this.$('.okta-waiting-spinner').removeClass('hide');
            this.$('.o-form-button-bar').hide();
        },
        _stopEnrollment: function() {
            this.$('.okta-waiting-spinner').addClass('hide');
            this.$('.o-form-button-bar').show();
        }
    },
    back: function() {
    // Empty function on verify controllers to prevent users
    // from navigating back during 'verify' using the browser's
    // back button. The URL will still change, but the view will not
    // More details in OKTA-135060.
    },
    Footer: (0, $88b800c63cc9d9e3$export$2e2bcd8739ae039)
});





















function $c8f7d23c7815260a$var$getAllowCredentials(factors) {
    const allowCredentials = [];
    (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(factors, function(factor) {
        allowCredentials.push({
            type: 'public-key',
            id: (0, $36d38737859019f5$export$2e2bcd8739ae039).strToBin(factor.profile.credentialId)
        });
    });
    return allowCredentials;
}
var $c8f7d23c7815260a$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'mfa-verify verify-webauthn',
    Model: {
        props: {
            rememberDevice: 'boolean'
        },
        initialize: function() {
            const rememberDevice = (0, $020a58caf88b7504$export$2e2bcd8739ae039).getRememberDeviceValue(this.appState);
            // set the initial value for remember device (Cannot do this while defining the
            // local property because this.settings would not be initialized there yet).
            this.set('rememberDevice', rememberDevice);
            this.appState.on('factorSwitched signOut', ()=>{
                if (this.webauthnAbortController) {
                    this.webauthnAbortController.abort();
                    this.webauthnAbortController = null;
                }
            });
        },
        save: function() {
            this.trigger('request');
            return this.doTransaction(function(transaction) {
                let factor;
                if (transaction.factorTypes) factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(transaction.factorTypes, {
                    factorType: 'webauthn'
                });
                else factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(transaction.factors, {
                    factorType: 'webauthn',
                    provider: 'FIDO'
                });
                const self = this;
                return factor.verify().then(function(transaction) {
                    let allowCredentials;
                    let challenge;
                    if (transaction.factors) {
                        const factors = transaction.factors;
                        challenge = transaction.challenge;
                        allowCredentials = $c8f7d23c7815260a$var$getAllowCredentials(factors);
                    } else {
                        const factorData = transaction.factor;
                        challenge = factorData.challenge;
                        allowCredentials = $c8f7d23c7815260a$var$getAllowCredentials([
                            factorData
                        ]);
                    }
                    self.trigger('request');
                    // verify via browser webauthn js
                    const options = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({}, challenge, {
                        allowCredentials: allowCredentials,
                        challenge: (0, $36d38737859019f5$export$2e2bcd8739ae039).strToBin(challenge.challenge)
                    });
                    // AbortController is not supported in IE11
                    if (typeof AbortController !== 'undefined') self.webauthnAbortController = new AbortController();
                    return Promise.resolve(// navigator.credentials is not supported in IE11
                    // eslint-disable-next-line compat/compat
                    navigator.credentials.get({
                        publicKey: options,
                        signal: self.webauthnAbortController && self.webauthnAbortController.signal
                    })).then(function(assertion) {
                        const rememberDevice = !!self.get('rememberDevice');
                        return factor.verify({
                            clientData: (0, $36d38737859019f5$export$2e2bcd8739ae039).binToStr(assertion.response.clientDataJSON),
                            authenticatorData: (0, $36d38737859019f5$export$2e2bcd8739ae039).binToStr(assertion.response.authenticatorData),
                            signatureData: (0, $36d38737859019f5$export$2e2bcd8739ae039).binToStr(assertion.response.signature),
                            rememberDevice: rememberDevice
                        });
                    }).catch(function(error) {
                        self.trigger('errors:clear');
                        // Do not display if it is abort error triggered by code when switching.
                        // self.webauthnAbortController would be null if abort was triggered by code.
                        if (!self.webauthnAbortController) throw new (0, $3fe6932680e7ea64$export$810d59b58d691639)();
                        else throw new (0, $3fe6932680e7ea64$export$90f0c14a652de832)({
                            xhr: {
                                responseJSON: {
                                    errorSummary: error.message
                                }
                            }
                        });
                    }).finally(function() {
                        // unset webauthnAbortController on successful authentication or error
                        self.webauthnAbortController = null;
                    });
                });
            }).catch(()=>{});
        }
    },
    Form: {
        autoSave: true,
        hasSavingState: false,
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'factor.webauthn.biometric', 'login'),
        className: 'verify-webauthn-form',
        noCancelButton: true,
        save: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'mfa.challenge.verify', 'login'),
        noButtonBar: function() {
            return !(0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isNewApiAvailable();
        },
        modelEvents: {
            request: '_startEnrollment',
            error: '_stopEnrollment'
        },
        formChildren: function() {
            const children = [];
            if ((0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isNewApiAvailable()) children.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                View: (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                        "compiler": [
                            8,
                            ">= 4.3.0"
                        ],
                        "main": function(container, depth0, helpers, partials, data) {
                            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                                return undefined;
                            };
                            return "<div class=\"webauthn-verify-text\"><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                                "name": "i18n",
                                "hash": {
                                    "bundle": "login",
                                    "code": "verify.webauthn.biometric.instructions"
                                },
                                "data": data,
                                "loc": {
                                    "start": {
                                        "line": 1,
                                        "column": 37
                                    },
                                    "end": {
                                        "line": 1,
                                        "column": 106
                                    }
                                }
                            })) + "</p><div data-se=\"webauthn-waiting\" class=\"okta-waiting-spinner\"></div></div>";
                        },
                        "useData": true
                    })
                })
            }));
            else {
                let errorMessageKey = 'webauthn.biometric.error.factorNotSupported';
                if (this.options.appState.get('factors').length === 1) errorMessageKey = 'webauthn.biometric.error.factorNotSupported.oneFactor';
                children.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                    View: new (0, $b717de154cd703a4$export$2e2bcd8739ae039)({
                        message: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(errorMessageKey, 'login')
                    })
                }, {
                    selector: '.o-form-error-container'
                }));
            }
            if (this.options.appState.get('allowRememberDevice')) children.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).Input({
                label: false,
                'label-top': true,
                placeholder: this.options.appState.get('rememberDeviceLabel'),
                className: 'margin-btm-0',
                name: 'rememberDevice',
                type: 'checkbox'
            }));
            return children;
        },
        _startEnrollment: function() {
            this.$('.okta-waiting-spinner').show();
            this.$('.o-form-button-bar').hide();
        },
        _stopEnrollment: function() {
            this.$('.okta-waiting-spinner').hide();
            this.$('.o-form-button-bar [type="submit"]')[0].value = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('verify.u2f.retry', 'login');
            this.$('.o-form-button-bar').show();
        }
    },
    postRender: function() {
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defer(()=>{
            // Trigger browser prompt automatically for other browsers for better UX.
            if ((0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isNewApiAvailable() && !(0, $22893d6dea78fc87$export$2e2bcd8739ae039).isSafari()) this.model.save();
        });
    },
    back: function() {
    // Empty function on verify controllers to prevent users
    // from navigating back during 'verify' using the browser's
    // back button. The URL will still change, but the view will not
    // More details in OKTA-135060.
    },
    Footer: (0, $88b800c63cc9d9e3$export$2e2bcd8739ae039)
});


















/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $9060b0ddf7d4c3a9$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'mfa-verify verify-windows-hello',
    Model: {
        local: {
            __autoTriggered__: 'boolean'
        },
        save: function() {
            if (!(0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isAvailable()) return;
            this.trigger('request');
            const model = this;
            return this.doTransaction(function(transaction) {
                const factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(transaction.factors, {
                    factorType: 'webauthn',
                    provider: 'FIDO'
                });
                return factor.verify().then(function(verifyData) {
                    const factorData = verifyData.factor;
                    return (0, $bd053cd6fe43765a$export$2e2bcd8739ae039).getAssertion(factorData.challenge.nonce, [
                        {
                            id: factorData.profile.credentialId
                        }
                    ]).then(function(assertion) {
                        return factor.verify({
                            authenticatorData: assertion.authenticatorData,
                            clientData: assertion.clientData,
                            signatureData: assertion.signature
                        });
                    }).then(function(data) {
                        model.trigger('sync');
                        model.trigger('signIn');
                        return data;
                    }).catch(function(error) {
                        switch(error.message){
                            case 'AbortError':
                            case 'NotFoundError':
                            case 'NotSupportedError':
                                model.trigger('abort', error.message);
                                return transaction;
                        }
                        throw error;
                    });
                });
            });
        }
    },
    Form: {
        autoSave: true,
        hasSavingState: false,
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'factor.windowsHello', 'login'),
        subtitle: function() {
            return (0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isAvailable() ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('verify.windowsHello.subtitle', 'login') : '';
        },
        save: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'verify.windowsHello.save', 'login'),
        customSavingState: {
            stop: 'abort'
        },
        modelEvents: function() {
            if (!(0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isAvailable()) return {};
            return {
                request: '_startEnrollment',
                error: '_stopEnrollment',
                abort: '_stopEnrollment',
                signIn: '_successEnrollment'
            };
        },
        noButtonBar: function() {
            return !(0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isAvailable();
        },
        formChildren: function() {
            const result = [];
            if (!(0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isAvailable()) result.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                View: new (0, $b717de154cd703a4$export$2e2bcd8739ae039)({
                    message: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.windowsHello.error.notWindows', 'login')
                })
            }, {
                selector: '.o-form-error-container'
            }));
            result.push((0, $d2909dd0ad7c17ab$export$2e2bcd8739ae039).View({
                View: new (0, $e166679abbcff2df$export$2e2bcd8739ae039)({
                    model: this.model,
                    visible: false
                })
            }));
            return result;
        },
        postRender: function() {
            if (this.options.appState.get('factors').length === 1 && !this.model.get('__autoTriggered__')) {
                this.model.set('__autoTriggered__', true);
                this.model.save();
            }
        },
        _startEnrollment: function() {
            this.subtitle = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('verify.windowsHello.subtitle.loading', 'login');
            this.model.trigger('spinner:show');
            this._resetErrorMessage();
            this.render();
            this.$('.o-form-button-bar').addClass('hide');
        },
        _stopEnrollment: function(errorMessage) {
            this.subtitle = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('verify.windowsHello.subtitle', 'login');
            this.model.trigger('spinner:hide');
            this.$('.o-form-button-bar').removeClass('hide');
            let message;
            switch(errorMessage){
                case 'NotFoundError':
                    message = this.options.appState.get('factors').length > 1 ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('verify.windowsHello.error.notFound.selectAnother', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('verify.windowsHello.error.notFound', 'login');
                    break;
                case 'NotSupportedError':
                    message = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.windowsHello.error.notConfiguredHtml', 'login');
                    break;
            }
            this._resetErrorMessage();
            if (message) {
                const messageView = new (0, $b717de154cd703a4$export$2e2bcd8739ae039)({
                    message: message
                });
                this.$('.o-form-error-container').addClass('o-form-has-errors');
                this.add(messageView, {
                    selector: '.o-form-error-container'
                });
                this._errorMessageView = this.last();
            }
            this.render();
        },
        _successEnrollment: function() {
            this.subtitle = this.settings.get('brandName') ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('verify.windowsHello.subtitle.signingIn.specific', 'login', [
                this.settings.get('brandName')
            ]) : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('verify.windowsHello.subtitle.signingIn.generic', 'login');
            this.render();
            this.$('.o-form-button-bar').addClass('hide');
        },
        _resetErrorMessage: function() {
            this._errorMessageView && this._errorMessageView.remove();
            this._errorMessageView = undefined;
            this.clearErrors();
        }
    },
    back: function() {
    // Empty function on verify controllers to prevent users
    // from navigating back during 'verify' using the browser's
    // back button. The URL will still change, but the view will not
    // More details in OKTA-135060.
    },
    Footer: (0, $88b800c63cc9d9e3$export$2e2bcd8739ae039)
});














var $aca7ed2282771b11$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a href=\"#\" class=\"link help\" data-se=\"back-link\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "goback"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 66
                    },
                    "end": {
                        "line": 1,
                        "column": 103
                    }
                }
            })) + "</a>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "showLink") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 114
                    }
                }
            })) != null ? stack1 : "";
        },
        "useData": true
    }),
    className: 'auth-footer',
    events: {
        'click .help': function(e) {
            e.preventDefault();
            this.back();
        }
    },
    back: function() {
        this.state.set('navigateDir', (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).DIRECTION_BACK);
        this.options.appState.trigger('navigate', '');
    },
    getTemplateData: function() {
        const error = this.model.appState.get('flashError');
        const showLink = error.is && error.is('terminal');
        return {
            showLink: showLink
        };
    }
});


/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $38805fa0bbfc7b7e$export$2e2bcd8739ae039 = (0, $735c6d0521558dcb$export$2e2bcd8739ae039).extend({
    className: 'error-state',
    Model: {},
    Form: {
        noButtonBar: true
    },
    Footer: (0, $aca7ed2282771b11$export$2e2bcd8739ae039)
});

























/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $01723b7b49f45ec6$var$DEFAULT_APP_LOGO = '/img/logos/default.png';
// Keep track of stateMachine with this special model. Some reasons to not
// keep it generic:
// 1. We know exactly what we're using appState for by requiring props
// 2. Can have some derived functions to help us translate the lastAuthRes
const $01723b7b49f45ec6$var$USER_NOT_SEEN_ON_DEVICE = '/img/security/unknown.png';
const $01723b7b49f45ec6$var$UNDEFINED_USER = '/img/security/default.png';
const $01723b7b49f45ec6$var$NEW_USER = '/img/security/unknown-device.png';
const $01723b7b49f45ec6$var$NEW_USER_IMAGE_DESCRIPTION = '';
const $01723b7b49f45ec6$var$UNDEFINED_USER_IMAGE_DESCRIPTION = '';
const $01723b7b49f45ec6$var$UNKNOWN_IMAGE_DESCRIPTION = '';
function $01723b7b49f45ec6$export$23d7acf42148dbd8(baseUrl, username) {
    const encodedUsername = encodeURIComponent(username);
    const url = `${baseUrl}/login/getimage?username=${encodedUsername}`;
    return url;
}
function $01723b7b49f45ec6$var$getSecurityImage(baseUrl, username, deviceFingerprint) {
    // When the username is empty, we want to show the default image.
    if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(username) || (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isUndefined(username)) return Promise.resolve({
        securityImage: $01723b7b49f45ec6$var$UNDEFINED_USER,
        securityImageDescription: $01723b7b49f45ec6$var$UNDEFINED_USER_IMAGE_DESCRIPTION
    });
    // Reserved characters in the username must be escaped before the query can be safely executed
    const url = $01723b7b49f45ec6$export$23d7acf42148dbd8(baseUrl, username);
    const data = {
        url: url,
        dataType: 'json'
    };
    if (deviceFingerprint) data['headers'] = {
        'X-Device-Fingerprint': deviceFingerprint
    };
    return Promise.resolve((0, $b51a961f9fe28c76$export$2e2bcd8739ae039).ajax(data)).then(function(res) {
        if (res.pwdImg === $01723b7b49f45ec6$var$USER_NOT_SEEN_ON_DEVICE) // When we get an unknown.png security image from OKTA,
        // we want to show the unknown-device security image.
        // We are mapping the server's img url to a new one because
        // we still need to support the original login page.
        return {
            securityImage: $01723b7b49f45ec6$var$NEW_USER,
            securityImageDescription: $01723b7b49f45ec6$var$NEW_USER_IMAGE_DESCRIPTION
        };
        return {
            securityImage: res.pwdImg,
            securityImageDescription: res.imageDescription || $01723b7b49f45ec6$var$UNKNOWN_IMAGE_DESCRIPTION
        };
    });
}
function $01723b7b49f45ec6$var$getMinutesString(factorLifetimeInMinutes) {
    if (factorLifetimeInMinutes > 60 && factorLifetimeInMinutes <= 1440) {
        const lifetimeInHours = factorLifetimeInMinutes / 60;
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('hours', 'login', [
            lifetimeInHours
        ]);
    } else if (factorLifetimeInMinutes > 1440) {
        const lifetimeInDays = factorLifetimeInMinutes / 1440;
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('days', 'login', [
            lifetimeInDays
        ]);
    }
    //Use minutes as the time unit by default
    if (factorLifetimeInMinutes === 1) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('minutes.oneMinute', 'login');
    return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('minutes', 'login', [
        factorLifetimeInMinutes
    ]);
}
function $01723b7b49f45ec6$var$getGracePeriodRemainingDays(gracePeriodEndDate) {
    const endDate = new Date(gracePeriodEndDate).getTime();
    const remainingDays = Math.floor((endDate - new Date().getTime()) / 86400000);
    return remainingDays;
}
function $01723b7b49f45ec6$var$combineFactorsObjects(factorTypes, factors) {
    const addedFactorTypes = [];
    const combinedFactors = [];
    (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(factors, function(factor) {
        const factorType = factor.factorType;
        if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains(addedFactorTypes, factorType)) {
            const factorTypeObj = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(factorTypes, {
                factorType: factorType
            });
            if (factorTypeObj) {
                addedFactorTypes.push(factorType);
                combinedFactors.push(factorTypeObj);
            } else combinedFactors.push(factor);
        }
    });
    return combinedFactors;
}
var $01723b7b49f45ec6$export$2e2bcd8739ae039 = (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039).extend({
    initialize: function() {
        // Handle this in initialize (as opposed to a derived property) because
        // the operation is asynchronous
        if (this.settings.get('features.securityImage')) {
            const self = this;
            this.listenTo(this, 'change:username', function(model, username) {
                $01723b7b49f45ec6$var$getSecurityImage(this.get('baseUrl'), username, this.get('deviceFingerprint')).then(function(image) {
                    model.set('securityImage', image.securityImage);
                    model.set('securityImageDescription', image.securityImageDescription);
                    model.unset('deviceFingerprint'); //Fingerprint can only be used once
                }).catch(function(jqXhr) {
                    // Only notify the consumer on a CORS error
                    if ((0, $22893d6dea78fc87$export$2e2bcd8739ae039).corsIsNotEnabled(jqXhr)) self.settings.callGlobalError(new (0, $3fe6932680e7ea64$export$58cbd1fe407fb242)((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('error.enabled.cors')));
                    else self.settings.callGlobalError(new Error(`Failed to fetch security image: ${jqXhr.statusText}`));
                });
            });
        }
    },
    local: {
        baseUrl: 'string',
        lastAuthResponse: [
            'object',
            true,
            {}
        ],
        transaction: 'object',
        transactionError: 'object',
        username: 'string',
        factors: 'object',
        policy: 'object',
        securityImage: [
            'string',
            true,
            $01723b7b49f45ec6$var$UNDEFINED_USER
        ],
        securityImageDescription: [
            'string',
            true,
            $01723b7b49f45ec6$var$UNDEFINED_USER_IMAGE_DESCRIPTION
        ],
        userCountryCode: 'string',
        userPhoneNumber: 'string',
        factorActivationType: 'string',
        flashError: 'object',
        beaconType: 'string',
        deviceFingerprint: 'string',
        // valid only once
        typingPattern: 'string',
        // Note: languageCode is special in that it is shared between Settings
        // and AppState. Settings is the *configured* language, and is static.
        // AppState is the dynamic language state - it can be changed via a
        // language picker, etc.
        // Note: this is conceptial feasible but not yet being implemented.
        languageCode: [
            'string',
            true
        ],
        disableUsername: [
            'boolean',
            false,
            false
        ],
        trapMfaRequiredResponse: [
            'boolean',
            false,
            false
        ],
        lastFailedChallengeFactorData: [
            'object',
            false
        ]
    },
    setAuthResponse: function(res) {
        // Because of MFA_CHALLENGE (i.e. DUO), we need to remember factors
        // across auth responses. Not doing this, for example, results in being
        // unable to switch away from the duo factor dropdown.
        if (res._embedded && res._embedded.policy) this.set('policy', res._embedded.policy);
        if (res._embedded && res._embedded.factors) {
            let factors = res._embedded.factors;
            if (res._embedded.factorTypes) factors = $01723b7b49f45ec6$var$combineFactorsObjects(res._embedded.factorTypes, factors);
            const factorsObject = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).map(factors, (factor)=>{
                factor.settings = this.settings;
                factor.appState = this;
                return factor;
            });
            this.set('factors', new (0, $004803a44bfc2c0c$export$2e2bcd8739ae039).Collection(factorsObject, {
                parse: true
            }));
        }
        this.set('lastAuthResponse', res);
    },
    clearLastAuthResponse: function() {
        this.set('lastAuthResponse', {});
    },
    setLastFailedChallengeFactorData: function() {
        this.set('lastFailedChallengeFactorData', {
            factor: this.get('factor'),
            errorMessage: this.get('factorResultErrorMessage')
        });
    },
    clearLastFailedChallengeFactorData: function() {
        this.unset('lastFailedChallengeFactorData');
    },
    getUser: function() {
        return this.get('user');
    },
    derived: {
        isSuccessResponse: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                return res.status === 'SUCCESS';
            }
        },
        isMfaRequired: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                return res.status === 'MFA_REQUIRED' || res.status === 'FACTOR_REQUIRED';
            }
        },
        isProfileRequired: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                return res.status === 'PROFILE_REQUIRED';
            }
        },
        isMfaEnroll: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                return res.status === 'MFA_ENROLL' || res.status === 'FACTOR_ENROLL';
            }
        },
        isMfaChallenge: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                return res.status === 'MFA_CHALLENGE' || res.status === 'FACTOR_CHALLENGE';
            }
        },
        isSMSPasswordRecovery: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function({ status: status, factorType: factorType, recoveryType: recoveryType }) {
                return status === 'RECOVERY_CHALLENGE' && (factorType === null || factorType === void 0 ? void 0 : factorType.toLowerCase()) === 'sms' && (recoveryType === null || recoveryType === void 0 ? void 0 : recoveryType.toLowerCase()) === 'password';
            }
        },
        isUnauthenticated: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                return res.status === 'UNAUTHENTICATED';
            }
        },
        isMfaRejected: {
            // MFA failures are usually error responses
            // except in the case of Okta Push, when a
            // user clicks 'deny' on his phone or OV app
            // version is below a required version no.
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                return res.factorResult === 'REJECTED';
            }
        },
        isMfaTimeout: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                return res.factorResult === 'TIMEOUT';
            }
        },
        isMfaEnrollActivate: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                return res.status === 'MFA_ENROLL_ACTIVATE' || res.status === 'FACTOR_ENROLL_ACTIVATE';
            }
        },
        isWaitingForActivation: {
            deps: [
                'isMfaEnrollActivate',
                'lastAuthResponse'
            ],
            fn: function(isMfaEnrollActivate, res) {
                return isMfaEnrollActivate && res.factorResult === 'WAITING';
            }
        },
        isWaitingForNumberChallenge: {
            deps: [
                'lastAuthResponse',
                'isMfaChallenge'
            ],
            fn: function(res, isMfaChallenge) {
                if (isMfaChallenge && res && res.factorResult === 'WAITING' && res._embedded && res._embedded.factor && res._embedded.factor._embedded && res._embedded.factor._embedded.challenge) return true;
                return false;
            }
        },
        hasMultipleFactorsAvailable: {
            deps: [
                'factors',
                'isMfaRequired',
                'isMfaChallenge',
                'isUnauthenticated'
            ],
            fn: function(factors, isMfaRequired, isMfaChallenge, isUnauthenticated) {
                if (!isMfaRequired && !isMfaChallenge && !isUnauthenticated) return false;
                return factors && factors.length > 1;
            }
        },
        promptForFactorInUnauthenticated: {
            deps: [
                'lastAuthResponse',
                'factors'
            ],
            fn: function(res, factors) {
                if (res.status !== 'UNAUTHENTICATED') return false;
                return factors && factors.length > 0;
            }
        },
        userId: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                if (!res._embedded || !res._embedded.user) return null;
                return res._embedded.user.id;
            }
        },
        isIdxStateToken: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                return res && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isString(res.stateToken) && res.stateToken.startsWith('01');
            }
        },
        isPwdExpiringSoon: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                return res.status === 'PASSWORD_WARN';
            }
        },
        passwordExpireDays: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                if (!res._embedded || !res._embedded.policy || !res._embedded.policy.expiration) return null;
                return res._embedded.policy.expiration.passwordExpireDays;
            }
        },
        isPwdManagedByOkta: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                if (!res._links || !res._links.next || !res._links.next.title) return true;
                return false;
            }
        },
        passwordExpiredWebsiteName: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                if (!res._links || !res._links.next || !res._links.next.title) return null;
                return res._links.next.title;
            }
        },
        passwordExpiredLinkUrl: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                if (!res._links || !res._links.next || !res._links.next.title || !res._links.next.href) return null;
                return res._links.next.href;
            }
        },
        recoveryType: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                return res.recoveryType;
            }
        },
        factorType: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                return res.factorType;
            }
        },
        factor: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                if (!res._embedded || !res._embedded.factor) return null;
                return res._embedded.factor;
            }
        },
        activatedFactorId: {
            deps: [
                'factor'
            ],
            fn: function(factor) {
                return factor ? factor.id : null;
            }
        },
        activatedFactorType: {
            deps: [
                'factor'
            ],
            fn: function(factor) {
                return factor ? factor.factorType : null;
            }
        },
        activatedFactorProvider: {
            deps: [
                'factor'
            ],
            fn: function(factor) {
                return factor ? factor.provider : null;
            }
        },
        qrcode: {
            deps: [
                'factor'
            ],
            fn: function(factor) {
                try {
                    return factor._embedded.activation._links.qrcode.href;
                } catch (err) {
                    return null;
                }
            }
        },
        activationSendLinks: {
            deps: [
                'factor'
            ],
            fn: function(factor) {
                let sendLinks;
                try {
                    sendLinks = factor._embedded.activation._links.send;
                } catch (err) {
                    sendLinks = [];
                }
                return sendLinks;
            }
        },
        textActivationLinkUrl: {
            deps: [
                'activationSendLinks'
            ],
            fn: function(activationSendLinks) {
                const item = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(activationSendLinks, {
                    name: 'sms'
                });
                return item ? item.href : null;
            }
        },
        emailActivationLinkUrl: {
            deps: [
                'activationSendLinks'
            ],
            fn: function(activationSendLinks) {
                const item = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(activationSendLinks, {
                    name: 'email'
                });
                return item ? item.href : null;
            }
        },
        sharedSecret: {
            deps: [
                'factor'
            ],
            fn: function(factor) {
                try {
                    return factor._embedded.activation.sharedSecret;
                } catch (err) {
                    return null;
                }
            }
        },
        duoEnrollActivation: {
            deps: [
                'factor'
            ],
            fn: function(factor) {
                if (!factor || !factor._embedded || !factor._embedded.activation) return null;
                return factor._embedded.activation;
            }
        },
        prevLink: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                if (res._links && res._links.prev) return res._links.prev.href;
                return null;
            }
        },
        skipLink: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                if (res._links && res._links.skip) return res._links.skip.href;
                return null;
            }
        },
        gracePeriodRemainingDays: {
            deps: [
                'policy'
            ],
            fn: function(policy) {
                if (policy && policy.gracePeriod && policy.gracePeriod.endDate) return $01723b7b49f45ec6$var$getGracePeriodRemainingDays(policy.gracePeriod.endDate);
                return null;
            }
        },
        user: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                if (!res._embedded || !res._embedded.user) return null;
                return res._embedded.user;
            }
        },
        recoveryQuestion: {
            deps: [
                'user'
            ],
            fn: function(user) {
                if (!user || !user.recovery_question) return null;
                return user.recovery_question.question;
            }
        },
        userProfile: {
            deps: [
                'user'
            ],
            fn: function(user) {
                if (!user || !user.profile) return null;
                return user.profile;
            }
        },
        userConsentName: {
            deps: [
                'userProfile',
                'username'
            ],
            fn: function(userProfile, username) {
                if (!userProfile || (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(userProfile.firstName)) return username;
                if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(userProfile.lastName)) return userProfile.firstName;
                return userProfile.firstName + ' ' + userProfile.lastName.charAt(0) + '.';
            }
        },
        userEmail: {
            deps: [
                'userProfile'
            ],
            fn: function(userProfile) {
                if (!userProfile || !userProfile.login) return null;
                return userProfile.login;
            }
        },
        userFullName: {
            deps: [
                'userProfile'
            ],
            fn: function(userProfile) {
                if (!userProfile || !userProfile.firstName && !userProfile.lastName) return '';
                return userProfile.firstName + ' ' + userProfile.lastName;
            }
        },
        defaultAppLogo: {
            deps: [
                'baseUrl'
            ],
            fn: function(baseUrl) {
                return baseUrl + $01723b7b49f45ec6$var$DEFAULT_APP_LOGO;
            }
        },
        expiresAt: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                return res.expiresAt;
            }
        },
        target: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                if (!res._embedded) return null;
                return res._embedded.target;
            }
        },
        targetLabel: {
            deps: [
                'target'
            ],
            fn: function(target) {
                if (!target) return null;
                return target.label;
            }
        },
        targetLogo: {
            deps: [
                'target'
            ],
            fn: function(target) {
                if (!target || !target._links) return null;
                return target._links.logo;
            }
        },
        targetTermsOfService: {
            deps: [
                'target'
            ],
            fn: function(target) {
                if (!target || !target._links) return null;
                return target._links['terms-of-service'];
            }
        },
        targetPrivacyPolicy: {
            deps: [
                'target'
            ],
            fn: function(target) {
                if (!target || !target._links) return null;
                return target._links['privacy-policy'];
            }
        },
        targetClientURI: {
            deps: [
                'target'
            ],
            fn: function(target) {
                if (!target || !target._links) return null;
                return target._links['client-uri'];
            }
        },
        scopes: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                if (!res._embedded) return null;
                return res._embedded.scopes;
            }
        },
        issuer: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                var _res$_embedded, _res$_embedded$authen, _res$_embedded$authen2;
                return res === null || res === void 0 ? void 0 : (_res$_embedded = res._embedded) === null || _res$_embedded === void 0 ? void 0 : (_res$_embedded$authen = _res$_embedded.authentication) === null || _res$_embedded$authen === void 0 ? void 0 : (_res$_embedded$authen2 = _res$_embedded$authen.issuer) === null || _res$_embedded$authen2 === void 0 ? void 0 : _res$_embedded$authen2.uri;
            }
        },
        hasExistingPhones: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                if (!res._embedded || !res._embedded.factors) return false;
                const factors = res._embedded.factors;
                const factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(factors, {
                    factorType: 'sms',
                    provider: 'OKTA'
                });
                if (!factor || !factor._embedded) return false;
                return !!factor._embedded.phones.length;
            }
        },
        hasExistingPhonesForCall: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                if (!res._embedded || !res._embedded.factors) return false;
                const factors = res._embedded.factors;
                const factor = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findWhere(factors, {
                    factorType: 'call',
                    provider: 'OKTA'
                });
                if (!factor || !factor._embedded) return false;
                return !!factor._embedded.phones.length;
            }
        },
        isUndefinedUser: {
            deps: [
                'securityImage'
            ],
            fn: function(securityImage) {
                return securityImage === $01723b7b49f45ec6$var$UNDEFINED_USER;
            }
        },
        isNewUser: {
            deps: [
                'securityImage'
            ],
            fn: function(securityImage) {
                return securityImage === $01723b7b49f45ec6$var$NEW_USER;
            }
        },
        allowRememberDevice: {
            deps: [
                'policy'
            ],
            fn: function(policy) {
                return policy && policy.allowRememberDevice;
            }
        },
        rememberDeviceLabel: {
            deps: [
                'policy'
            ],
            fn: function(policy) {
                if (policy && policy.rememberDeviceLifetimeInMinutes > 0) {
                    const timeString = $01723b7b49f45ec6$var$getMinutesString(policy.rememberDeviceLifetimeInMinutes);
                    return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('rememberDevice.timebased', 'login', [
                        timeString
                    ]);
                } else if (policy && policy.rememberDeviceLifetimeInMinutes === 0) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('rememberDevice.devicebased', 'login');
                return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('rememberDevice', 'login');
            }
        },
        rememberDeviceByDefault: {
            deps: [
                'policy'
            ],
            fn: function(policy) {
                return policy && policy.rememberDeviceByDefault;
            }
        },
        factorsPolicyInfo: {
            deps: [
                'policy'
            ],
            fn: function(policy) {
                return policy && policy.factorsPolicyInfo ? policy.factorsPolicyInfo : null;
            }
        },
        verifyCustomFactorRedirectUrl: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                if (!res._links || !res._links.next || res._links.next.name !== 'redirect' || !res._links.next.href) return null;
                return res._links.next.href;
            }
        },
        enrollCustomFactorRedirectUrl: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                if (!res._links || !res._links.next || res._links.next.name !== 'activate' || !res._links.next.href) return null;
                return res._links.next.href;
            }
        },
        isFactorResultFailed: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                return res.factorResult === 'FAILED';
            }
        },
        factorResultErrorMessage: {
            deps: [
                'lastAuthResponse',
                'isFactorResultFailed'
            ],
            fn: function(res, isFactorResultFailed) {
                if (isFactorResultFailed) return res.factorResultMessage || (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oform.error.unexpected', 'login');
                return null;
            }
        },
        deviceActivationStatus: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                if (!res._embedded) return null;
                return res._embedded.deviceActivationStatus;
            }
        },
        usingDeviceFlow: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                return !!(res._embedded && res._embedded.usingDeviceFlow);
            }
        },
        userCode: {
            deps: [
                'lastAuthResponse'
            ],
            fn: function(res) {
                var _res$_embedded2;
                return res === null || res === void 0 ? void 0 : (_res$_embedded2 = res._embedded) === null || _res$_embedded2 === void 0 ? void 0 : _res$_embedded2.userCode;
            }
        }
    },
    parse: function(options) {
        this.settings = options.settings;
        return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend((0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(options, 'settings'), {
            languageCode: this.settings.get('languageCode'),
            userCountryCode: this.settings.get('countryCode')
        });
    }
});















const $9d4da218102d472c$var$SUPPORTED_SOCIAL_IDPS = [
    'facebook',
    'google',
    'linkedin',
    'microsoft',
    'apple',
    'github',
    'gitlab',
    'yahoo',
    'line',
    'paypal',
    'paypal_sandbox',
    'salesforce',
    'amazon',
    'yahoojp',
    'discord',
    'adobe',
    'orcid',
    'spotify',
    'xero',
    'quickbooks'
];
var $9d4da218102d472c$export$2e2bcd8739ae039 = {
    SUPPORTED_SOCIAL_IDPS: $9d4da218102d472c$var$SUPPORTED_SOCIAL_IDPS
};









/**
 * Utility that gets a list of language tag preferences based on the widget properties
 * and browser settings.
 * 
 * NOTE: The language tag and language are related but not necessarilty the same.
 * The language tag specifies the language and region, and may be used for formatting dates
 * and currency, while the language is just the language code used for translations.
 * 
 * @see https://en.wikipedia.org/wiki/IETF_language_tag
 * 
 * @param {string | LanguageCallback | undefined} language 
 * @param {string[]} supportedLanguages
 * @returns {string[]}
 */ const $f4fd804aa49210df$export$cb8511503180a89f = (language, supportedLanguages)=>{
    // Get the user's preferred languages from the browser API
    const userLanguages = (0, $22893d6dea78fc87$export$2e2bcd8739ae039).getUserLanguages().map((userLanguage)=>{
        // Map "simple" language codes to their full locale equivalents to match the
        // expected format for these specific languages.
        if (userLanguage === 'nl') return 'nl-nl';
        if (userLanguage === 'pt') return 'pt-br';
        return userLanguage.toLowerCase();
    });
    const languagesMap = new Map();
    const addLanguageTag = (languageTag)=>{
        if (!languageTag) return;
        // only get the simple language code, i.e. 'en', 'ja', 'zh'
        const [lang] = languageTag.split('-');
        if (languagesMap.has(lang)) {
            var _languagesMap$get;
            const values = (_languagesMap$get = languagesMap.get(lang)) !== null && _languagesMap$get !== void 0 ? _languagesMap$get : new Set();
            values.add(languageTag);
            languagesMap.set(lang, values);
        } else languagesMap.set(lang, new Set([
            languageTag
        ]));
    };
    const supportedUserLanguages = userLanguages.filter((userLanguage)=>{
        // remove any user languages tags that do not match a supported language
        return supportedLanguages.some((supportedLang)=>userLanguage.startsWith(supportedLang.toLowerCase()));
    });
    supportedUserLanguages.forEach(addLanguageTag);
    (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).expandLanguages(supportedUserLanguages).forEach(addLanguageTag);
    // Any developer defined "language" takes highest priority:
    // As a string, i.e. 'en', 'ja', 'zh-CN'
    let languageFromProps;
    if (typeof language !== 'undefined') {
        if (typeof language === 'string') languageFromProps = language.toLowerCase();
        else if (typeof language === 'function') {
            var _language;
            // As a callback function, which is passed the list of supported
            // languages and detected user languages. This function must return
            // a languageCode, i.e. 'en', 'ja', 'zh-CN'
            languageFromProps = (_language = language(supportedLanguages, userLanguages)) === null || _language === void 0 ? void 0 : _language.toLowerCase();
        }
        // Add the language from widget properties to the languages map
        (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).expandLanguages([
            languageFromProps
        ]).forEach(addLanguageTag);
    }
    // Add default language, and expand to include any language
    // codes that do not include region, dialect, etc.
    (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).expandLanguages([
        (0, $9ab2e0ac5722e186$export$2e2bcd8739ae039).defaultLanguage.toLowerCase()
    ]).forEach(addLanguageTag);
    const languageTags = [];
    // Put languages related to the language from widget properties first if it was specified
    if (languageFromProps) {
        var _languagesMap$get2;
        // Get the simple language code since that's how the languagesMap is keyed
        const [lang] = languageFromProps.split('-');
        // Pull the language tags for the specified language from the map first
        languageTags.push(...(_languagesMap$get2 = languagesMap.get(lang)) !== null && _languagesMap$get2 !== void 0 ? _languagesMap$get2 : []);
        // Then remove the language from the map so it doesn't get added again
        languagesMap.delete(lang);
    }
    // Add any remaining language tags from the map to the returned array
    languagesMap.forEach((values)=>{
        languageTags.push(...values);
    });
    return languageTags;
};
const $f4fd804aa49210df$export$f02cbd868e2f57cf = (appState, settings)=>{
    const languageCode = appState.get('languageCode') || settings.get('languageCode') || (0, $9ab2e0ac5722e186$export$2e2bcd8739ae039).defaultLanguage;
    const i18n = settings.get('i18n');
    const assetBaseUrl = settings.get('assets.baseUrl');
    const assetRewrite = settings.get('assets.rewrite');
    const supportedLanguages = settings.get('supportedLanguages');
    const timeout = setTimeout(function() {
        // Trigger a spinner if we're waiting on a request for a new language.
        appState.trigger('loading', true);
    }, 200);
    return (0, $ae370136150d080c$export$2e2bcd8739ae039).loadLanguage(languageCode, i18n, {
        baseUrl: assetBaseUrl,
        rewrite: assetRewrite
    }, supportedLanguages).then(function() {
        clearTimeout(timeout);
        appState.trigger('loading', false);
        appState.trigger('removeLoading');
    });
// TODO: what if load language error?
};


const $03319d6721601f44$var$SharedUtil = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).util.Util;
const $03319d6721601f44$var$assetBaseUrlTpl = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "https://global.oktacdn.com/okta-signin-widget/" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "version") || (depth0 != null ? lookupProperty(depth0, "version") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "version",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 46
                },
                "end": {
                    "line": 1,
                    "column": 57
                }
            }
        }) : helper));
    },
    "useData": true
});
const $03319d6721601f44$var$local = {
    authClient: [
        'object',
        false,
        undefined
    ],
    baseUrl: [
        'string',
        true
    ],
    recoveryToken: [
        'string',
        false,
        undefined
    ],
    stateToken: [
        'string',
        false,
        undefined
    ],
    username: [
        'string',
        false
    ],
    relayState: [
        'string',
        false
    ],
    // These two settings are aliases. Setting either value will set `backToSignInUri`
    signOutLink: [
        'string',
        false
    ],
    // for backward compatibility
    backToSignInLink: [
        'string',
        false
    ],
    // preferred setting
    redirect: {
        type: 'string',
        values: [
            'never',
            'always',
            'auto'
        ],
        value: 'auto'
    },
    // allows bootstrapping the Widget into a specific view such
    // as register or forgot password
    flow: [
        'string',
        false,
        'default'
    ],
    // Function to transform the username before passing it to the API
    // for Primary Auth, Forgot Password and Unlock Account.
    transformUsername: [
        'function',
        false
    ],
    // CALLBACKS
    globalSuccessFn: 'function',
    globalErrorFn: 'function',
    processCreds: 'function',
    hooks: 'object',
    // IMAGES
    logo: 'string',
    logoText: [
        'string',
        false
    ],
    helpSupportNumber: 'string',
    // <OIE>
    // attribute to hold proxy (fake) idx response
    // to render static pages without initiating idx pipeline
    proxyIdxResponse: [
        'object',
        false
    ],
    // <OIE>
    // By default, state handle will be saved to session storage
    // and will be clear when terminal error or success redirect.
    // Set this flag to true if you want to override this behavior.
    // a.k.a dishonor the state handle stored in session storage.
    overrideExistingStateToken: [
        'boolean',
        false,
        false
    ],
    // FEATURES
    'features.router': [
        'boolean',
        true,
        false
    ],
    'features.securityImage': [
        'boolean',
        true,
        false
    ],
    'features.rememberMe': [
        'boolean',
        true,
        true
    ],
    'features.autoPush': [
        'boolean',
        true,
        false
    ],
    'features.smsRecovery': [
        'boolean',
        true,
        false
    ],
    'features.callRecovery': [
        'boolean',
        true,
        false
    ],
    'features.emailRecovery': [
        'boolean',
        false,
        true
    ],
    'features.webauthn': [
        'boolean',
        true,
        false
    ],
    'features.selfServiceUnlock': [
        'boolean',
        true,
        false
    ],
    'features.multiOptionalFactorEnroll': [
        'boolean',
        true,
        false
    ],
    'features.deviceFingerprinting': [
        'boolean',
        false,
        false
    ],
    'features.hideSignOutLinkInMFA': [
        'boolean',
        false,
        false
    ],
    'features.skipIdpFactorVerificationBtn': [
        'boolean',
        false,
        false
    ],
    'features.hideBackToSignInForReset': [
        'boolean',
        false,
        false
    ],
    'features.customExpiredPassword': [
        'boolean',
        true,
        false
    ],
    'features.registration': [
        'boolean',
        false,
        false
    ],
    'features.idpDiscovery': [
        'boolean',
        false,
        false
    ],
    'features.passwordlessAuth': [
        'boolean',
        false,
        false
    ],
    'features.showPasswordToggleOnSignInPage': [
        'boolean',
        false,
        false
    ],
    'features.trackTypingPattern': [
        'boolean',
        false,
        false
    ],
    'features.redirectByFormSubmit': [
        'boolean',
        false,
        false
    ],
    'features.useDeviceFingerprintForSecurityImage': [
        'boolean',
        false,
        true
    ],
    'features.showPasswordRequirementsAsHtmlList': [
        'boolean',
        false,
        false
    ],
    'features.mfaOnlyFlow': [
        'boolean',
        false,
        false
    ],
    'features.scrollOnError': [
        'boolean',
        false,
        true
    ],
    'features.showKeepMeSignedIn': [
        'boolean',
        false,
        true
    ],
    'features.showIdentifier': [
        'boolean',
        false,
        true
    ],
    'features.autoFocus': [
        'boolean',
        false,
        true
    ],
    'features.sameDeviceOVEnrollmentEnabled': [
        'boolean',
        false,
        false
    ],
    'features.showSessionRevocation': [
        'boolean',
        false,
        false
    ],
    'features.disableAutocomplete': [
        'boolean',
        false,
        false
    ],
    defaultCountryCode: [
        'string',
        false,
        'US'
    ],
    // I18N
    language: [
        'any',
        false
    ],
    // Can be a string or a function
    i18n: [
        'object',
        false
    ],
    // ASSETS
    'assets.baseUrl': [
        'string',
        false
    ],
    'assets.rewrite': {
        type: 'function',
        value: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).identity
    },
    'assets.languages': [
        'array',
        false
    ],
    // OAUTH2
    issuer: 'string',
    clientId: 'string',
    redirectUri: 'string',
    state: 'string',
    nonce: 'string',
    scopes: 'array',
    codeChallenge: 'string',
    codeChallengeMethod: [
        'string',
        false
    ],
    oAuthTimeout: [
        'number',
        false
    ],
    authScheme: [
        'string',
        false,
        'OAUTH2'
    ],
    // External IdPs
    idps: [
        'array',
        false,
        []
    ],
    idpDisplay: {
        type: 'string',
        values: [
            'PRIMARY',
            'SECONDARY'
        ],
        value: 'SECONDARY'
    },
    initialPopupPath: [
        'string',
        false
    ],
    // HELP LINKS
    'helpLinks.help': 'string',
    'helpLinks.forgotPassword': 'string',
    'helpLinks.unlock': 'string',
    'helpLinks.custom': 'array',
    'helpLinks.factorPage.href': 'string',
    'helpLinks.factorPage.text': 'string',
    'helpLinks.gracePeriodRequiredSoon.href': 'string',
    'helpLinks.gracePeriodRequiredSoon.text': 'string',
    //Custom Buttons
    customButtons: [
        'array',
        false,
        []
    ],
    //Registration
    policyId: 'string',
    'registration.click': 'function',
    'registration.parseSchema': 'function',
    'registration.preSubmit': 'function',
    'registration.postSubmit': 'function',
    //Consent
    'consent.cancel': 'function',
    //IDP Discovery
    'idpDiscovery.requestContext': 'string',
    //Colors
    'colors.brand': 'string',
    //cspNonce
    'cspNonce': 'string',
    //Descriptions
    brandName: 'string',
    //PIV
    piv: [
        'object',
        false,
        {}
    ],
    //Email verify callback
    otp: 'string',
    //Support classic engine
    useClassicEngine: [
        'boolean',
        false,
        false
    ],
    //hCaptcha script source URI
    'hcaptcha.scriptSource': [
        'string',
        false
    ],
    //query params for hCaptcha script source URI
    'hcaptcha.scriptParams': [
        'object',
        false,
        {}
    ],
    //reCAPTCHA script source URI
    'recaptcha.scriptSource': [
        'string',
        false
    ]
};
const $03319d6721601f44$var$derived = {
    backToSignInUri: {
        deps: [
            'backToSignInLink',
            'signOutLink'
        ],
        fn: function(backToSignInLink, signOutLink) {
            return backToSignInLink || signOutLink; // prefer backToSignInLink over signOutLink, but they are aliases
        }
    },
    showPasswordToggle: {
        deps: [
            'features.showPasswordToggleOnSignInPage'
        ],
        fn: function() {
            var _this$options$feature, _this$options, _this$options$feature2, _this$options2;
            // showPasswordToggle is for OIE only.
            // Used to default showPasswordToggleOnSignInPage to true.
            const defaultValue = true;
            const customizedValue = (_this$options$feature = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : (_this$options$feature2 = _this$options.features) === null || _this$options$feature2 === void 0 ? void 0 : _this$options$feature2.showPasswordToggleOnSignInPage) !== null && _this$options$feature !== void 0 ? _this$options$feature : (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2['features.showPasswordToggleOnSignInPage'];
            return customizedValue !== null && customizedValue !== void 0 ? customizedValue : defaultValue;
        },
        cache: true
    },
    redirectUtilFn: {
        deps: [
            'features.redirectByFormSubmit'
        ],
        fn: function(redirectByFormSubmit) {
            return redirectByFormSubmit ? (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).redirectWithFormGet.bind((0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039)) : $03319d6721601f44$var$SharedUtil.redirect.bind($03319d6721601f44$var$SharedUtil);
        },
        cache: true
    },
    supportedLanguages: {
        deps: [
            'i18n',
            'language',
            'assets.languages'
        ],
        fn: function(i18n, language, hostedLanguages) {
            // By default, the language be automatically detected from the browser
            // Developers can specify the language. It will be added to the supportedLanguages list.
            // Developers can also provide a list of languages with hosted assets, these replace the default list
            const supportedLanguages = hostedLanguages || (0, $9ab2e0ac5722e186$export$2e2bcd8739ae039).supportedLanguages;
            return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).union(supportedLanguages, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).keys(i18n), (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isString(language) ? [
                language
            ] : []);
        },
        cache: true
    },
    languageCode: {
        deps: [
            'language',
            'supportedLanguages'
        ],
        /*
     * TODO: Consider renaming to `getTranslationLanguageCode` and/or moving to LanguageUtil
     */ fn: function(language, supportedLanguages) {
            const userLanguages = (0, $22893d6dea78fc87$export$2e2bcd8739ae039).getUserLanguages();
            // TODO: revisit this fix - OKTA-491150
            userLanguages.forEach((val, idx)=>{
                if (val === 'nl') userLanguages[idx] = 'nl-NL';
                else if (val === 'pt') userLanguages[idx] = 'pt-BR';
            });
            const preferred = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone(userLanguages);
            const supportedLowerCase = (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).toLower(supportedLanguages);
            // Any developer defined "language" takes highest priority:
            // As a string, i.e. 'en', 'ja', 'zh-CN'
            if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isString(language)) preferred.unshift(language);
            else if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(language)) // As a callback function, which is passed the list of supported
            // languages and detected user languages. This function must return
            // a languageCode, i.e. 'en', 'ja', 'zh-CN'
            preferred.unshift(language(supportedLanguages, userLanguages));
            // Add default language, and expand to include any language
            // codes that do not include region, dialect, etc.
            preferred.push((0, $9ab2e0ac5722e186$export$2e2bcd8739ae039).defaultLanguage);
            const expanded = (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).toLower((0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).expandLanguages(preferred));
            // Perform a case insensitive search - this is necessary in the case
            // of browsers like Safari
            let i;
            let supportedPos;
            for(i = 0; i < expanded.length; i++){
                supportedPos = supportedLowerCase.indexOf(expanded[i]);
                if (supportedPos > -1) return supportedLanguages[supportedPos];
            }
        }
    },
    languageTags: {
        deps: [
            'language',
            'supportedLanguages'
        ],
        fn: (0, $f4fd804aa49210df$export$cb8511503180a89f)
    },
    countryCode: {
        deps: [
            'defaultCountryCode'
        ],
        fn: function(defaultCountryCode) {
            const countries = (0, $bfbf136e55dbe393$export$2e2bcd8739ae039).getCountries();
            return Object.keys(countries).includes(defaultCountryCode) ? defaultCountryCode : 'US';
        }
    },
    mode: {
        deps: [
            'codeChallenge'
        ],
        fn: function(codeChallenge) {
            if (codeChallenge) return 'remediation';
            return 'relying-party';
        }
    },
    oauth2Enabled: {
        deps: [
            'clientId',
            'authScheme',
            'authClient'
        ],
        fn: function(clientId, authScheme, authClient) {
            if (!clientId && authClient) clientId = authClient.options.clientId;
            return !!clientId && authScheme.toLowerCase() === 'oauth2';
        },
        cache: true
    },
    // Redirect Uri to provide in the oauth API
    oauthRedirectUri: {
        deps: [
            'redirectUri'
        ],
        fn: function(redirectUri) {
            if (redirectUri) return redirectUri;
            let origin = window.location.origin;
            // IE8
            if (!origin) {
                const href = window.location.href;
                const path = window.location.pathname;
                if (path !== '') origin = href.substring(0, href.lastIndexOf(path));
            }
            return encodeURI(origin);
        }
    },
    // Adjusts the idps passed into the widget based on if they get explicit support
    configuredSocialIdps: {
        deps: [
            'idps'
        ],
        fn: function(idps) {
            return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).map(idps, function(idpConfig) {
                const idp = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).clone(idpConfig);
                let type = idp.type && idp.type.toLowerCase();
                if (!(type && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains((0, $9d4da218102d472c$export$2e2bcd8739ae039).SUPPORTED_SOCIAL_IDPS, type))) {
                    type = 'general-idp';
                    idp.text = idp.text || '{ Please provide a text value }';
                }
                idp.className = [
                    'social-auth-button',
                    'social-auth-' + type + '-button ',
                    idp.className ? idp.className : ''
                ].join(' ');
                idp.dataAttr = 'social-auth-' + type + '-button';
                idp.i18nKey = 'socialauth.' + type + '.label';
                return idp;
            });
        },
        cache: true
    },
    // Can support piv authentication
    hasPivCard: {
        deps: [
            'piv'
        ],
        fn: function(piv) {
            return piv && piv.certAuthUrl;
        },
        cache: true
    },
    // social auth buttons order - 'above'/'below' the primary auth form (boolean)
    socialAuthPositionTop: {
        deps: [
            'configuredSocialIdps',
            'hasPivCard',
            'idpDisplay'
        ],
        fn: function(configuredSocialIdps, hasPivCard, idpDisplay) {
            return (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(configuredSocialIdps) || hasPivCard) && idpDisplay.toUpperCase() === 'PRIMARY';
        },
        cache: true
    },
    hasConfiguredButtons: {
        deps: [
            'configuredSocialIdps',
            'customButtons',
            'hasPivCard'
        ],
        fn: function(configuredSocialIdps, customButtons, hasPivCard) {
            return !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(configuredSocialIdps) || !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(customButtons) || hasPivCard;
        },
        cache: true
    }
};
class $03319d6721601f44$export$2e2bcd8739ae039 extends (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039) {
    constructor(attributes, options){
        // base class constructor will call preinitialize() and initialize() and compute derived properties
        super(attributes, options);
        // apply languageCode
        this.authClient = void 0;
        const authClient = this.getAuthClient();
        this.setAcceptLanguageHeader(authClient);
    }
    get(attributeName) {
        return (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039).prototype.get.call(this, attributeName);
    }
    preinitialize(...args) {
        this.local = $03319d6721601f44$var$local;
        this.derived = $03319d6721601f44$var$derived;
        (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039).prototype.preinitialize.apply(this, args);
    }
    initialize(options) {
        options = options || {};
        const { colors: colors, authClient: authClient, flow: flow } = options;
        let { baseUrl: baseUrl } = options;
        if (!baseUrl) {
            // infer baseUrl from the issuer
            // favor authClient API first
            if (authClient) baseUrl = authClient.getIssuerOrigin();
            else {
                var _issuer;
                // issuer can also be passed a top-level option or exist in authParams
                const { authParams: authParams } = options;
                let { issuer: issuer } = options;
                issuer = issuer || (authParams === null || authParams === void 0 ? void 0 : authParams.issuer);
                baseUrl = (_issuer = issuer) === null || _issuer === void 0 ? void 0 : _issuer.split('/oauth2/')[0];
            }
            this.set('baseUrl', baseUrl);
        }
        // If `flow` and `authClient` instance are passed to settings, set flow in auth client
        if (authClient && flow) authClient.idx.setFlow(flow);
        if (!baseUrl) this.callGlobalError(new (0, $3fe6932680e7ea64$export$c5fb415882705cf4)((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('error.required.baseUrl')));
        else if (colors && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isString(colors.brand) && !colors.brand.match(/^#[0-9A-Fa-f]{6}$/)) this.callGlobalError(new (0, $3fe6932680e7ea64$export$c5fb415882705cf4)((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('error.invalid.colors.brand')));
        else if ((0, $22893d6dea78fc87$export$2e2bcd8739ae039).corsIsNotSupported()) this.callGlobalError(new (0, $3fe6932680e7ea64$export$58cbd1fe407fb242)((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('error.unsupported.cors')));
    }
    setAcceptLanguageHeader(authClient) {
        if (authClient) authClient.http.setRequestHeader('Accept-Language', this.get('languageCode'));
    }
    setAuthClient(authClient) {
        this.set('authClient', authClient);
        this.setAcceptLanguageHeader(authClient);
    }
    getAuthClient() {
        return this.get('authClient');
    }
    set(...args) {
        try {
            return (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039).prototype.set.apply(this, args);
        } catch (e) {
            const message = e.message ? e.message : e;
            this.callGlobalError(new (0, $3fe6932680e7ea64$export$c5fb415882705cf4)(message));
        }
    }
    // Invokes the global success function. This should only be called on a
    // terminal part of the code (i.e. authStatus SUCCESS or after sending
    // a recovery email)
    callGlobalSuccess(status, data) {
        const res = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend(data, {
            status: status
        });
        // Defer this to ensure that our functions have rendered completely
        // before invoking their function
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).defer((0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial(this.get('globalSuccessFn'), res));
    }
    // Invokes the global error function. This should only be called on non
    // recoverable errors (i.e. configuration errors, browser unsupported
    // errors, etc)
    callGlobalError(err) {
        const globalErrorFn = this.get('globalErrorFn') || this.options.globalErrorFn;
        // Note: Must use "this.options.globalErrorFn" when they've passed invalid
        // arguments - globalErrorFn will not have been set yet
        if (globalErrorFn) globalErrorFn(err);
        else // Only throw the error if they have not registered a globalErrorFn
        throw err;
    }
    // Get the username by applying the transform function if it exists.
    transformUsername(username, operation) {
        const transformFn = this.get('transformUsername');
        if (transformFn && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(transformFn)) return transformFn(username, operation);
        return username;
    }
    processCreds(creds) {
        const processCreds = this.get('processCreds');
        return new Promise(function(resolve) {
            if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(processCreds)) resolve();
            else if (processCreds.length === 2) processCreds(creds, resolve);
            else {
                processCreds(creds);
                resolve();
            }
        });
    }
    parseRegistrationSchema(schema, onSuccess, onFailure) {
        const parseSchema = this.get('registration.parseSchema');
        //check for parseSchema callback
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(parseSchema)) parseSchema(schema, function(schema) {
            onSuccess(schema);
        }, function(error) {
            error = error || {
                errorSummary: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('registration.default.callbackhook.error')
            };
            error['callback'] = 'parseSchema';
            onFailure(error);
        });
        else //no callback
        onSuccess(schema);
    }
    preRegistrationSubmit(postData, onSuccess, onFailure) {
        const preSubmit = this.get('registration.preSubmit');
        //check for preSubmit callback
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(preSubmit)) preSubmit(postData, function(postData) {
            onSuccess(postData);
        }, function(error) {
            error = error || {
                errorSummary: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('registration.default.callbackhook.error')
            };
            error['callback'] = 'preSubmit';
            onFailure(error);
        });
        else //no callback
        onSuccess(postData);
    }
    postRegistrationSubmit(response, onSuccess, onFailure) {
        const postSubmit = this.get('registration.postSubmit');
        //check for postSubmit callback
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(postSubmit)) postSubmit(response, function(response) {
            onSuccess(response);
        }, function(error) {
            error = error || {
                errorSummary: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('registration.default.callbackhook.error')
            };
            error['callback'] = 'postSubmit';
            onFailure(error);
        });
        else //no callback
        onSuccess(response);
    }
    // Use the parse function to transform config options to the standard
    // settings we currently support. This is a good place to deprecate old
    // option formats.
    parse(options) {
        if (options.labels || options.country) {
            (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).deprecate('Use "i18n" instead of "labels" and "country"');
            const overrides = options.labels || {};
            (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(options.country, function(val, key) {
                overrides['country.' + key] = val;
            });
            // Old behavior is to treat the override as a global override, so we
            // need to add these overrides to each language
            options.i18n = {};
            (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each((0, $9ab2e0ac5722e186$export$2e2bcd8739ae039).supportedLanguages, function(language) {
                options.i18n[language] = overrides;
            });
            delete options.labels;
            delete options.country;
        }
        // Default the assets.baseUrl to the cdn, or remove any trailing slashes
        if (!options.assets) options.assets = {};
        const abu = options.assets.baseUrl;
        if (!abu) options.assets.baseUrl = $03319d6721601f44$var$assetBaseUrlTpl({
            version: (0, $9ab2e0ac5722e186$export$2e2bcd8739ae039).version
        });
        else if (abu[abu.length - 1] === '/') options.assets.baseUrl = abu.substring(0, abu.length - 1);
        return options;
    }
    isDsTheme() {
        return false;
    }
}















/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $2298640c0f084892$var$CAN_REMOVE_BEACON_CLS = 'can-remove-beacon';
var $2298640c0f084892$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    tagName: 'main',
    className: 'auth-container main-container',
    id: (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).WIDGET_CONTAINER_ID,
    attributes: {
        'data-se': 'auth-container',
        tabindex: '-1'
    },
    initialize: function(options) {
        this.listenTo(options.appState, 'change:beaconType', function(model, type) {
            this.$el.toggleClass($2298640c0f084892$var$CAN_REMOVE_BEACON_CLS, type === 'security');
        });
    }
});














/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $c6666231eedaafd3$var$SWAP_PAGE_TIME = 200;
const $c6666231eedaafd3$export$2e2bcd8739ae039 = {};
function $c6666231eedaafd3$var$zoom($el, start, finish) {
    const deferred = (0, $6d3dd6c38b8802c0$export$e673efccd97e4223)();
    $el.animate({
        'text-indent': 1
    }, {
        duration: 200,
        easing: 'swing',
        step: function(now, fx) {
            fx.start = start;
            fx.end = finish;
            $el.css('transform', 'scale(' + now + ', ' + now + ')');
        },
        always: function() {
            deferred.resolve($el);
        }
    });
    return deferred.promise;
}
function $c6666231eedaafd3$var$rotate($el, start, finish) {
    const deferred = (0, $6d3dd6c38b8802c0$export$e673efccd97e4223)();
    $el.animate({
        'text-indent': 1
    }, {
        duration: 150,
        easing: 'swing',
        step: function(now, fx) {
            fx.start = start;
            fx.end = finish;
            $el.css('transform', 'rotate(' + now + 'deg)');
        },
        always: function() {
            deferred.resolve($el);
        }
    });
    return deferred.promise;
}
// Note: It is necessary to pass in a success callback because we must
// remove the old dom node (and controller) in the same tick of the event
// loop. Waiting for "then" results in a glitchy animation.
$c6666231eedaafd3$export$2e2bcd8739ae039.swapPages = function(options) {
    const deferred = (0, $6d3dd6c38b8802c0$export$e673efccd97e4223)();
    const $parent = options.$parent;
    const $oldRoot = options.$oldRoot;
    const $newRoot = options.$newRoot;
    const success = options.success;
    const ctx = options.ctx;
    let directionClassName = 'transition-from-right';
    if (options.dir && options.dir === (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).DIRECTION_BACK) directionClassName = 'transition-from-left';
    $newRoot.addClass(directionClassName);
    $parent.append($newRoot);
    $parent.addClass('animation-container-overflow');
    const newRootAnimations = {
        left: '0px',
        top: '0px',
        opacity: 1
    };
    $newRoot.animate(newRootAnimations, $c6666231eedaafd3$var$SWAP_PAGE_TIME, function() {
        $parent.removeClass('animation-container-overflow');
        $newRoot.removeClass(directionClassName);
        const clearStyles = Object.keys(newRootAnimations).reduce((styles, attr)=>({
                ...styles,
                [attr]: ''
            }), {});
        $newRoot.css(clearStyles);
        success.call(ctx);
        deferred.resolve();
    });
    $oldRoot.animate({
        height: $newRoot.height(),
        opacity: 0
    }, $c6666231eedaafd3$var$SWAP_PAGE_TIME * 0.8);
    return deferred.promise;
};
$c6666231eedaafd3$export$2e2bcd8739ae039.swapBeacons = function(options) {
    const $el = options.$el;
    const swap = options.swap;
    const ctx = options.ctx;
    return this.implode($el).then(function() {
        swap.call(ctx);
        return $el;
    }).then(this.explode);
};
$c6666231eedaafd3$export$2e2bcd8739ae039.explode = function($el) {
    return $c6666231eedaafd3$var$zoom($el, 0, 1); //zoom in
};
$c6666231eedaafd3$export$2e2bcd8739ae039.implode = function($el) {
    return $c6666231eedaafd3$var$zoom($el, 1, 0); //zoom out
};
$c6666231eedaafd3$export$2e2bcd8739ae039.radialProgressBar = function(options) {
    const radialProgressBar = options.$el;
    const swap = options.swap;
    const circles = radialProgressBar.children();
    return $c6666231eedaafd3$var$rotate(circles, 0, 180).then(function() {
        radialProgressBar.css({
            clip: 'auto'
        });
    }).then(function() {
        const leftHalf = circles.eq(0);
        swap();
        return $c6666231eedaafd3$var$rotate(leftHalf, 180, 360);
    }).then(function() {
        //reset values to initial state
        radialProgressBar.css({
            clip: 'rect(0px, 96px, 96px, 48px)'
        });
        circles.css({
            transform: 'rotate(0deg)',
            'text-indent': '1px'
        });
    });
};












var $4b1192da661c3e79$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            return "<div class=\"beacon-blank\"></div><div class=\"bg-helper auth-beacon auth-beacon-security\" data-se=\"loading-beacon\"><div class=\"okta-sign-in-beacon-border auth-beacon-border js-auth-beacon-border\"></div></div>";
        },
        "useData": true
    }),
    equals: function(Beacon) {
        return Beacon && this instanceof Beacon;
    }
});


const $8134b3e4c81685fe$var$NO_BEACON_CLS = 'no-beacon';
const $8134b3e4c81685fe$var$LOADING_BEACON_CLS = 'beacon-small beacon-loading';
function $8134b3e4c81685fe$var$isLoadingBeacon(beacon) {
    return beacon && beacon.equals((0, $4b1192da661c3e79$export$2e2bcd8739ae039));
}
function $8134b3e4c81685fe$var$removeBeacon(view) {
    // There are some timing issues with removing beacons (i.e. the case of
    // transitioning from loadingBeacon -> loadingBeacon)
    if (!view.currentBeacon) return;
    view.currentBeacon.remove();
    view.currentBeacon = null;
}
function $8134b3e4c81685fe$var$addBeacon(view, NextBeacon, selector, options) {
    view.add(NextBeacon, {
        selector: selector,
        options: options
    });
    view.currentBeacon = view.first();
}
function $8134b3e4c81685fe$var$typeOfTransition(currentBeacon, NextBeacon, options) {
    if (!currentBeacon && !NextBeacon) return 'none';
    // Show Loading beacon
    if (!currentBeacon && options.loading) return 'load';
    // Swap/Hide Loading beacon
    if (currentBeacon && $8134b3e4c81685fe$var$isLoadingBeacon(currentBeacon)) return NextBeacon ? 'swap' : 'unload';
    if (currentBeacon && currentBeacon.equals(NextBeacon, options)) return 'same';
    if (!currentBeacon && NextBeacon) return 'add';
    if (currentBeacon && !NextBeacon) return 'remove';
    if (currentBeacon instanceof NextBeacon) return 'fade';
    // If none of the above
    // then we are changing the type of beacon
    // ex. from SecurityBeacon to FactorBeacon
    return 'swap';
}
class $8134b3e4c81685fe$export$2e2bcd8739ae039 extends (0, $5d64eb84267ab4e8$export$27a5bd065ad55220) {
    constructor(...args){
        super(...args);
        this.currentBeacon = void 0;
    }
    preinitialize(...args) {
        this.currentBeacon = null;
        /* eslint-disable @okta/okta/no-unlocalized-text-in-templates */ this.template = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
            "0": function(container, depth0, helpers, partials, data) {
                var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                    return undefined;
                };
                return "<h1><img src=\"" + alias4((helper = (helper = lookupProperty(helpers, "logo") || (depth0 != null ? lookupProperty(depth0, "logo") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                    "name": "logo",
                    "hash": {},
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 71
                        },
                        "end": {
                            "line": 1,
                            "column": 79
                        }
                    }
                }) : helper)) + "\" class=\"auth-org-logo\" alt=\"" + alias4((helper = (helper = lookupProperty(helpers, "logoText") || (depth0 != null ? lookupProperty(depth0, "logoText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                    "name": "logoText",
                    "hash": {},
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 108
                        },
                        "end": {
                            "line": 1,
                            "column": 120
                        }
                    }
                }) : helper)) + " logo\" aria-label=\"" + alias4((helper = (helper = lookupProperty(helpers, "logoText") || (depth0 != null ? lookupProperty(depth0, "logoText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                    "name": "logoText",
                    "hash": {},
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 139
                        },
                        "end": {
                            "line": 1,
                            "column": 151
                        }
                    }
                }) : helper)) + " logo\"></h1>";
            },
            "compiler": [
                8,
                ">= 4.3.0"
            ],
            "main": function(container, depth0, helpers, partials, data) {
                var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                    return undefined;
                };
                return "<div class=\"okta-sign-in-header auth-header\">" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "logo") : depth0, {
                    "name": "if",
                    "hash": {},
                    "fn": container.program(0, data, 0),
                    "inverse": container.noop,
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 45
                        },
                        "end": {
                            "line": 1,
                            "column": 170
                        }
                    }
                })) != null ? stack1 : "") + "<div data-type=\"beacon-container\" class=\"beacon-container\"></div></div><div class=\"auth-content\"><div class=\"auth-content-inner\"></div></div>";
            },
            "useData": true
        });
        /* eslint-enable @okta/okta/no-unlocalized-text-in-templates */ (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).prototype.preinitialize.apply(this, args);
    }
    // Attach a 'no-beacon' class if the security image feature
    // is not passed in to prevent the beacon from jumping.
    initialize(options) {
        if (!options.settings.get('features.securityImage')) {
            this.$el.addClass($8134b3e4c81685fe$var$NO_BEACON_CLS);
            // To show/hide the spinner when there is no security image,
            // listen to the appState's loading/removeLoading events.
            this.listenTo(options.appState, 'loading', this.setLoadingBeacon);
            this.listenTo(options.appState, 'removeLoading', this.removeLoadingBeacon);
        }
    }
    /* eslint complexity: 0 */ setBeacon(NextBeacon, options) {
        const selector = '[data-type="beacon-container"]';
        const container = this.$(selector);
        const transition = $8134b3e4c81685fe$var$typeOfTransition(this.currentBeacon, NextBeacon, options);
        switch(transition){
            case 'none':
                this.$el.addClass($8134b3e4c81685fe$var$NO_BEACON_CLS);
                return;
            case 'same':
                return;
            case 'add':
                this.$el.removeClass($8134b3e4c81685fe$var$NO_BEACON_CLS);
                $8134b3e4c81685fe$var$addBeacon(this, NextBeacon, selector, options);
                return (0, $c6666231eedaafd3$export$2e2bcd8739ae039).explode(container);
            case 'remove':
                this.$el.addClass($8134b3e4c81685fe$var$NO_BEACON_CLS);
                return (0, $c6666231eedaafd3$export$2e2bcd8739ae039).implode(container).then(()=>{
                    $8134b3e4c81685fe$var$removeBeacon(this);
                });
            case 'fade':
                // Other transitions are performed on the beacon container,
                // but this transition is on the content inside the beacon.
                // For a SecurityBeacon the username change will update the
                // AppState and trigger an transition to a new Becon
                // Since there is no url change this method is not called.
                // For a FactorBeacon a page refresh has occurred
                // so we execute the beacon's own transition method.
                if (!this.currentBeacon.fadeOut) throw new Error('The current beacon is missing the "fadeOut" method');
                options.animate = true;
                return this.currentBeacon.fadeOut().then(()=>{
                    $8134b3e4c81685fe$var$removeBeacon(this);
                    $8134b3e4c81685fe$var$addBeacon(this, NextBeacon, selector, options);
                });
            case 'swap':
                return (0, $c6666231eedaafd3$export$2e2bcd8739ae039).swapBeacons({
                    $el: container,
                    swap: ()=>{
                        const isLoading = $8134b3e4c81685fe$var$isLoadingBeacon(this.currentBeacon);
                        // Order of these calls is important for -
                        // loader --> security/factor beacon swap.
                        $8134b3e4c81685fe$var$removeBeacon(this);
                        this.$el.removeClass($8134b3e4c81685fe$var$NO_BEACON_CLS);
                        if (isLoading) container.removeClass($8134b3e4c81685fe$var$LOADING_BEACON_CLS);
                        $8134b3e4c81685fe$var$addBeacon(this, NextBeacon, selector, options);
                    }
                });
            case 'load':
                // Show the loading beacon. Add a couple of classes
                // before triggering the add beacon code.
                container.addClass($8134b3e4c81685fe$var$LOADING_BEACON_CLS);
                $8134b3e4c81685fe$var$addBeacon(this, NextBeacon, selector, options);
                return (0, $c6666231eedaafd3$export$2e2bcd8739ae039).explode(container);
            case 'unload':
                // Hide the loading beacon.
                return this.removeLoadingBeacon();
            default:
                throw new Error('the "' + transition + '" is not recognized');
        }
    }
    // Show the loading beacon when the security image feature is not enabled.
    setLoadingBeacon(isLoading) {
        if (!isLoading || $8134b3e4c81685fe$var$isLoadingBeacon(this.currentBeacon)) return;
        this.setBeacon((0, $4b1192da661c3e79$export$2e2bcd8739ae039), {
            loading: true
        });
    }
    // Hide the beacon on primary auth failure. On primary auth success, setBeacon does this job.
    removeLoadingBeacon() {
        if (!$8134b3e4c81685fe$var$isLoadingBeacon(this.currentBeacon)) return;
        const container = this.$('[data-type="beacon-container"]');
        return (0, $c6666231eedaafd3$export$2e2bcd8739ae039).implode(container).then(()=>{
            $8134b3e4c81685fe$var$removeBeacon(this);
            container.removeClass($8134b3e4c81685fe$var$LOADING_BEACON_CLS);
        });
    }
    getTemplateData() {
        return this.settings.toJSON({
            verbose: true
        });
    }
    getContentEl() {
        return this.$('.auth-content-inner');
    }
}













function $e48413bf62a5ffb5$var$setBackgroundImage(el, appState) {
    const imgSrc = appState.get('securityImage');
    const imgDescription = appState.get('securityImageDescription');
    const isUndefinedUser = appState.get('isUndefinedUser');
    const isNewUser = appState.get('isNewUser');
    const isSecurityImage = !isUndefinedUser && !isNewUser;
    // NOTE: The imgSrc is returned by the server so that every
    // user has a unique image. However new and undefined user states
    // are hard coded into the css and the value returned by the server
    // is ignored.
    el.css('background-image', '');
    el.removeClass('new-user undefined-user');
    if (isNewUser) {
        el.addClass('new-user');
        return;
    }
    if (isUndefinedUser) {
        el.addClass('undefined-user');
        return;
    }
    if (isSecurityImage) {
        // TODO: Newer versions of qtip will remove aria-describedby on their own when destroy() is called.
        el.removeAttr('aria-describedby');
        el.find('.accessibility-text').text(imgDescription);
        el.css('background-image', 'url(' + (0, $3e490973b7383cc4$export$2e2bcd8739ae039).escape(imgSrc) + ')');
        return;
    }
}
function $e48413bf62a5ffb5$var$antiPhishingMessage(image, host) {
    (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(window).on('resize.securityBeaconQtip', (0, $3e490973b7383cc4$export$2e2bcd8739ae039).debounce(function() {
        if (image.is(':visible')) image.qtip('show');
    }, 300));
    // Show the message that the user has not logged in from this device before.
    image.qtip({
        prerender: true,
        content: {
            text: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('primaryauth.newUser.tooltip', 'login', [
                (0, $3e490973b7383cc4$export$2e2bcd8739ae039).escape(host)
            ]),
            button: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('primaryauth.newUser.tooltip.close', 'login')
        },
        style: {
            classes: 'okta-security-image-tooltip security-image-qtip qtip-custom qtip-shadow qtip-rounded',
            tip: {
                height: 12,
                width: 16
            }
        },
        position: {
            my: 'top center',
            at: 'center',
            target: (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)('.auth-beacon-security'),
            adjust: {
                method: 'flip',
                scroll: false,
                resize: true
            },
            effect: false
        },
        hide: {
            event: false,
            fixed: true
        },
        show: {
            event: false,
            delay: 200
        },
        events: {
            move: function(event, api) {
                if (!api.elements.target.is(':visible')) {
                    // Have to hide it immediately, with no effect
                    api.set('hide.effect', false);
                    api.hide();
                    api.set('hide.effect', true);
                }
            }
        }
    });
    // It is necessary to delay toggle to the next render cycle, since qtip internally defers some setup tasks.
    setTimeout(()=>{
        image.qtip('toggle', image.is(':visible'));
    }, 0);
}
function $e48413bf62a5ffb5$var$destroyAntiPhishingMessage(image) {
    image.qtip('destroy');
    (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(window).off('resize.securityBeaconQtip');
}
async function $e48413bf62a5ffb5$var$updateSecurityImage($el, appState, animate) {
    const image = $el.find('.auth-beacon-security');
    const border = $el.find('.js-auth-beacon-border');
    const hasBorder = !appState.get('isUndefinedUser');
    const hasAntiPhishing = appState.get('isNewUser');
    const radialProgressBar = $el.find('.radial-progress-bar');
    const host = appState.get('baseUrl').match(/https?:\/\/(.[^/]+)/)[1];
    const duration = 200;
    if (!animate) {
        // Do not animate the security beacon
        // This occurs when initializing the form
        $e48413bf62a5ffb5$var$setBackgroundImage(image, appState);
        border.toggleClass('auth-beacon-border', hasBorder);
        return;
    }
    $e48413bf62a5ffb5$var$destroyAntiPhishingMessage(image);
    // Animate loading the security beacon
    if (!hasBorder) // This occurs when appState username is blank
    // we do not yet know if the user is recognized
    image.fadeOut(duration, function() {
        $e48413bf62a5ffb5$var$setBackgroundImage(image, appState);
        border.removeClass('auth-beacon-border');
        image.fadeIn(duration);
    });
    else {
        // Animate loading the security beacon with a loading bar for the border
        // This occurs when the username has been checked against Okta.
        border.removeClass('auth-beacon-border');
        await (0, $c6666231eedaafd3$export$2e2bcd8739ae039).radialProgressBar({
            $el: radialProgressBar,
            swap: function() {
                image.fadeOut(duration, ()=>{
                    $e48413bf62a5ffb5$var$setBackgroundImage(image, appState);
                    image.fadeIn(duration);
                });
            }
        });
        border.addClass('auth-beacon-border');
        if (hasAntiPhishing) $e48413bf62a5ffb5$var$antiPhishingMessage(image, host);
    }
}
var $e48413bf62a5ffb5$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            return "<div class=\"beacon-blank\"><div class=\"radial-progress-bar\"><div class=\"circle left\"></div><div class=\"circle right\"></div></div></div><div aria-live=\"polite\" role=\"img\" class=\"bg-helper auth-beacon auth-beacon-security\" data-se=\"security-beacon\"><span class=\"accessibility-text\"></span><div class=\"okta-sign-in-beacon-border auth-beacon-border js-auth-beacon-border\"></div></div>";
        },
        "useData": true
    }),
    className: 'js-security-beacon',
    initialize: function(options) {
        this.update = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial($e48413bf62a5ffb5$var$updateSecurityImage, this.$el, options.appState);
        this.listenTo(options.appState, 'change:securityImage', this.update);
        this.listenTo(options.appState, 'loading', function(isLoading) {
            this.$el.toggleClass('beacon-loading', isLoading);
            this.removeAntiPhishingMessage();
        });
        this.options.appState.set('beaconType', 'security');
        this.listenTo(options.appState, 'navigate', this.removeAntiPhishingMessage);
    },
    postRender: function() {
        this.update(false);
    },
    equals: function(Beacon) {
        return Beacon && this instanceof Beacon;
    },
    removeAntiPhishingMessage: function() {
        const image = this.$el.find('.auth-beacon-security');
        image.qtip('destroy');
    }
});





/*!
 * Copyright (c) 2018-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $2816cbe5d674331a$export$2e2bcd8739ae039 = {};
const $2816cbe5d674331a$var$template = function(colors) {
    return `
#okta-sign-in.auth-container .button-primary,
#okta-sign-in.auth-container .button-primary:active,
#okta-sign-in.auth-container .button-primary:focus { background: ${colors.brand}; }
#okta-sign-in.auth-container .button-primary:hover { background: ${$2816cbe5d674331a$export$2e2bcd8739ae039.lighten(colors.brand, 0.05)}; }
#okta-sign-in.auth-container .button.button-primary.link-button-disabled {
  background: ${colors.brand};
  opacity: 0.5;
}
#okta-sign-in.auth-container .passkey-promotion-illustration { color: ${colors.brand}; }
    `;
};
// visible for testing
$2816cbe5d674331a$export$2e2bcd8739ae039.lighten = function(hex, lum) {
    lum = lum || 0;
    hex = hex.substr(1);
    let newHex = '#';
    for(var i = 0; i < 3; i++){
        let c = parseInt(hex.substr(i * 2, 2), 16);
        c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
        newHex += ('00' + c).substr(c.length);
    }
    return newHex;
};
$2816cbe5d674331a$export$2e2bcd8739ae039.addStyle = function(colors, cspNonce) {
    const css = $2816cbe5d674331a$var$template(colors);
    const main = document.getElementById((0, $e48c043f6d2d382d$export$2e2bcd8739ae039).WIDGET_CONTAINER_ID);
    const style = document.createElement('style');
    style.id = (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).WIDGET_CONFIG_COLORS_ID;
    style.type = 'text/css';
    if (cspNonce) style.nonce = cspNonce;
    style.appendChild(document.createTextNode(css));
    main.appendChild(style);
};
$2816cbe5d674331a$export$2e2bcd8739ae039.isLoaded = function() {
    return !!document.getElementById((0, $e48c043f6d2d382d$export$2e2bcd8739ae039).WIDGET_CONFIG_COLORS_ID);
};







/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $0b2a6057818c4339$var$isStateLessRouteHandler(router, fn) {
    return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).find(router.stateLessRouteHandlers, function(routeName) {
        return fn === router[routeName];
    });
}
function $0b2a6057818c4339$var$beaconIsAvailable(Beacon, settings) {
    if (!Beacon) return false;
    if (Beacon === (0, $e48413bf62a5ffb5$export$2e2bcd8739ae039)) return settings.get('features.securityImage');
    return true;
}
var $0b2a6057818c4339$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$55185c17a0fcbe46).extend({
    Events: (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Events,
    initialize: function(options) {
        // Create a default success and/or error handler if
        // one is not provided.
        if (!options.globalSuccessFn) options.globalSuccessFn = function() {};
        if (!options.globalErrorFn) options.globalErrorFn = function(err) {
            (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).error(err);
        };
        this.settings = new (0, $03319d6721601f44$export$2e2bcd8739ae039)((0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(options, 'el'), {
            parse: true
        });
        if (!options.el) this.settings.callGlobalError(new (0, $3fe6932680e7ea64$export$c5fb415882705cf4)((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('error.required.el')));
        (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)('body > div').on('click', function() {
        // OKTA-69769 Tooltip wont close on iPhone/iPad
        // Registering a click handler on the first div
        // allows a tap that falls outside the tooltip
        // to be registered as a tap by iOS
        // and then the open tooltip will lose focus and close.
        });
        this.appState = new (0, $01723b7b49f45ec6$export$2e2bcd8739ae039)({
            baseUrl: this.settings.get('baseUrl'),
            settings: this.settings
        }, {
            parse: true
        });
        const wrapper = new (0, $2298640c0f084892$export$2e2bcd8739ae039)({
            appState: this.appState
        });
        (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(options.el).append(wrapper.render().$el);
        this.el = `#${(0, $e48c043f6d2d382d$export$2e2bcd8739ae039).WIDGET_CONTAINER_ID}`;
        this.header = new (0, $8134b3e4c81685fe$export$2e2bcd8739ae039)({
            el: this.el,
            appState: this.appState,
            settings: this.settings
        });
        // Hide until unitial render
        this.hide();
        this.listenTo(this.appState, 'change:transactionError', function(appState, err) {
            (0, $ec545c48aa9cf055$export$2e2bcd8739ae039).routeAfterAuthStatusChangeError(this, err);
        });
        this.listenTo(this.appState, 'change:transaction', function(appState, trans) {
            (0, $ec545c48aa9cf055$export$2e2bcd8739ae039).routeAfterAuthStatusChange(this, trans.data);
        });
        this.listenTo(this.appState, 'navigate', function(url) {
            this.navigate(url, {
                trigger: true
            });
        });
    },
    execute: function(cb, args) {
        const recoveryToken = this.settings.get('recoveryToken');
        // Recovery flow with a token passed through widget settings
        if (recoveryToken) {
            this.settings.unset('recoveryToken');
            this.navigate((0, $ec545c48aa9cf055$export$2e2bcd8739ae039).createRecoveryUrl(recoveryToken), {
                trigger: true
            });
            return;
        }
        // Refresh flow with a stateToken passed through widget settings
        const stateToken = this.settings.get('stateToken');
        if (stateToken) {
            this.settings.unset('stateToken');
            this.navigate((0, $ec545c48aa9cf055$export$2e2bcd8739ae039).createRefreshUrl(stateToken), {
                trigger: true
            });
            return;
        }
        // Normal flow - we've either navigated to a stateless page, or are
        // in the middle of an auth flow
        const trans = this.appState.get('transaction');
        if (trans && trans.data || $0b2a6057818c4339$var$isStateLessRouteHandler(this, cb)) {
            cb.apply(this, args);
            return;
        }
        // StateToken cookie exists on page load, and we are on a stateful url
        if (this.settings.getAuthClient().tx.exists()) {
            this.navigate((0, $ec545c48aa9cf055$export$2e2bcd8739ae039).createRefreshUrl(), {
                trigger: true
            });
            return;
        }
        // We've hit a page that requires state, but have no stateToken - redirect
        // back to primary auth
        this.navigate('', {
            trigger: true
        });
    },
    // Overriding the default navigate method to allow the widget consumer
    // to "turn off" routing - if features.router is false, the browser
    // location bar will not update when the router navigates
    navigate: function(fragment, options) {
        if (this.settings.get('features.router')) return (0, $5d64eb84267ab4e8$export$55185c17a0fcbe46).prototype.navigate.apply(this, arguments);
        if (options && options.trigger) return (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).history.loadUrl(fragment);
    },
    render: function(Controller, options) {
        options || (options = {});
        let Beacon = options.Beacon;
        const controllerOptions = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({
            settings: this.settings,
            appState: this.appState
        }, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(options, 'Beacon'));
        // Since we have a wrapper view, render our wrapper and use its content
        // element as our new el.
        // Note: Render it here because we know dom is ready at this point
        if (!this.header.rendered()) this.el = this.header.render().getContentEl();
        // If we need to load a language (or apply custom i18n overrides), do
        // this now and re-run render after it's finished.
        if (!(0, $ae370136150d080c$export$2e2bcd8739ae039).isLoaded(this.appState.get('languageCode'))) return (0, $f4fd804aa49210df$export$f02cbd868e2f57cf)(this.appState, this.settings).then((0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(this.render, this, Controller, options));
        // Load the custom colors only on the first render
        if (this.settings.get('colors.brand') && !(0, $2816cbe5d674331a$export$2e2bcd8739ae039).isLoaded()) {
            const colors = {
                brand: this.settings.get('colors.brand')
            };
            const cspNonce = this.settings.get('cspNonce');
            (0, $2816cbe5d674331a$export$2e2bcd8739ae039).addStyle(colors, cspNonce);
        }
        const oldController = this.controller;
        this.controller = new Controller(controllerOptions);
        // Bubble up all controller events
        this.listenTo(this.controller, 'all', this.trigger);
        // First run fetchInitialData, in case the next controller needs data
        // before it's initial render. This will leave the current page in a
        // loading state.
        return this.controller.fetchInitialData().then(()=>{
            // Beacon transition occurs in parallel to page swap
            if (!$0b2a6057818c4339$var$beaconIsAvailable(Beacon, this.settings)) Beacon = null;
            this.header.setBeacon(Beacon, controllerOptions);
            // Show before initial render
            this.show();
            this.controller.render();
            if (!oldController) {
                this.el.append(this.controller.el);
                this.controller.postRenderAnimation();
                return;
            }
            return (0, $c6666231eedaafd3$export$2e2bcd8739ae039).swapPages({
                $parent: this.el,
                $oldRoot: oldController.$el,
                $newRoot: this.controller.$el,
                dir: oldController.state.get('navigateDir'),
                ctx: this,
                success: function() {
                    const flashError = this.appState.get('flashError');
                    const model = this.controller.model;
                    oldController.remove();
                    oldController.$el.remove();
                    this.controller.postRenderAnimation();
                    if (flashError) {
                        let errorSummary;
                        const isTerminalError = flashError.is && flashError.is('terminal');
                        if (isTerminalError) errorSummary = flashError.errorDetails.errorSummary;
                        else errorSummary = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(this.settings.get('features.mfaOnlyFlow') ? 'error.mfa.only.expired.session' : 'error.expired.session');
                        model.trigger('error', model, {
                            responseJSON: {
                                errorSummary: errorSummary
                            }
                        });
                        this.appState.unset('flashError');
                        (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).triggerAfterError(this.controller, flashError);
                    }
                }
            });
        }).catch(function() {
            // OKTA-69665 - if an error occurs in fetchInitialData, we're left in
            // a state with two active controllers. Therefore, we clean up the
            // old one. Note: This explicitly handles the invalid token case -
            // if we get some other type of error which doesn't force a redirect,
            // we will probably be left in a bad state. I.e. old controller is
            // dropped and new controller is not rendered.
            if (oldController) {
                oldController.remove();
                oldController.$el.remove();
            }
        });
    },
    start: function() {
        let pushState = false;
        // Support for browser's back button.
        if (window.addEventListener && this.settings.get('features.router')) {
            window.addEventListener('popstate', (e)=>{
                if (this.controller.back) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    this.controller.back();
                }
            });
            pushState = (0, $22893d6dea78fc87$export$2e2bcd8739ae039).supportsPushState();
        }
        (0, $5d64eb84267ab4e8$export$55185c17a0fcbe46).prototype.start.call(this, {
            pushState: pushState
        });
    },
    hide: function() {
        this.header.$el.hide();
    },
    show: function() {
        this.header.$el.show();
    },
    remove: function() {
        if (this.controller) this.controller.remove();
        this.header.$el.remove();
        (0, $ae370136150d080c$export$2e2bcd8739ae039).remove();
        (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).history.stop();
    }
});






































const $73b5eb0c26708990$var$pushTitleTpl = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "0": function(container, depth0, helpers, partials, data) {
        var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return " (" + ((stack1 = (helper = (helper = lookupProperty(helpers, "deviceName") || (depth0 != null ? lookupProperty(depth0, "deviceName") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "deviceName",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 34
                },
                "end": {
                    "line": 1,
                    "column": 50
                }
            }
        }) : helper)) != null ? stack1 : "") + ")";
    },
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return container.escapeExpression((helper = (helper = lookupProperty(helpers, "factorName") || (depth0 != null ? lookupProperty(depth0, "factorName") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
            "name": "factorName",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 0
                },
                "end": {
                    "line": 1,
                    "column": 14
                }
            }
        }) : helper)) + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "deviceName") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(0, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 14
                },
                "end": {
                    "line": 1,
                    "column": 58
                }
            }
        })) != null ? stack1 : "");
    },
    "useData": true
});
// deviceName is escaped on BaseForm (see BaseForm's template)
const $73b5eb0c26708990$var$action = function(model) {
    let factorIndex;
    const factorType = model.get('factorType');
    const factorsList = this.options.appState.get('factors');
    if (factorsList.hasMultipleFactorsOfSameType(factorType)) factorIndex = factorsList.getFactorIndex(factorType, model.get('id'));
    const url = (0, $ec545c48aa9cf055$export$2e2bcd8739ae039).createVerifyUrl(model.get('provider'), factorType, factorIndex);
    const self = this;
    this.options.appState.trigger('factorSwitched');
    this.model.manageTransaction(function(transaction, setTransaction) {
        // FACTOR_CHALLENGE does not have a prev link
        if (transaction.status === 'FACTOR_CHALLENGE') this.options.appState.set('trapMfaRequiredResponse', true);
        if (transaction.status === 'MFA_CHALLENGE' && transaction.prev) {
            this.options.appState.set('trapMfaRequiredResponse', true);
            return transaction.prev().then(function(trans) {
                self.trigger('options:toggle');
                setTransaction(trans);
                self.options.appState.trigger('navigate', url);
            });
        } else {
            self.trigger('options:toggle');
            self.options.appState.trigger('navigate', url);
        }
    });
};
const $73b5eb0c26708990$var$dropdownOptions = {
    TITLE: {
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'mfa.factors.dropdown.title', 'login'),
        className: 'dropdown-list-title',
        disabled: true
    },
    OKTA_VERIFY: {
        icon: 'factor-icon mfa-okta-verify-30',
        className: 'factor-option',
        title: function() {
            return this.model.get('factorLabel');
        },
        action: function() {
            $73b5eb0c26708990$var$action.call(this, this.model);
        }
    },
    OKTA_VERIFY_PUSH: {
        icon: 'factor-icon mfa-okta-verify-30',
        className: 'factor-option',
        title: function() {
            return $73b5eb0c26708990$var$pushTitleTpl({
                factorName: this.model.get('factorLabel'),
                deviceName: this.model.get('deviceName')
            });
        },
        action: function() {
            $73b5eb0c26708990$var$action.call(this, this.model);
        }
    },
    GOOGLE_AUTH: {
        icon: 'factor-icon mfa-google-auth-30',
        className: 'factor-option',
        title: function() {
            return this.model.get('factorLabel');
        },
        action: function() {
            $73b5eb0c26708990$var$action.call(this, this.model);
        }
    },
    CUSTOM_HOTP: {
        icon: 'factor-icon mfa-hotp-30',
        className: 'factor-option',
        title: function() {
            return this.model.get('factorLabel');
        },
        action: function() {
            $73b5eb0c26708990$var$action.call(this, this.model);
        }
    },
    SYMANTEC_VIP: {
        icon: 'factor-icon mfa-symantec-30',
        className: 'factor-option',
        title: function() {
            return this.model.get('factorLabel');
        },
        action: function() {
            $73b5eb0c26708990$var$action.call(this, this.model);
        }
    },
    RSA_SECURID: {
        icon: 'factor-icon mfa-rsa-30',
        className: 'factor-option',
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'factor.totpHard.rsaSecurId', 'login'),
        action: function() {
            $73b5eb0c26708990$var$action.call(this, this.model);
        }
    },
    ON_PREM: {
        icon: 'factor-icon mfa-onprem-30',
        className: 'factor-option',
        title: function() {
            return this.model.get('factorLabel');
        },
        action: function() {
            $73b5eb0c26708990$var$action.call(this, this.model);
        }
    },
    DUO: {
        icon: 'factor-icon mfa-duo-30',
        className: 'factor-option',
        title: function() {
            return this.model.get('factorLabel');
        },
        action: function() {
            $73b5eb0c26708990$var$action.call(this, this.model);
        }
    },
    DUO_PUSH: {
        icon: 'duo-push-16',
        className: 'suboption factor-option',
        // TODO: add phone number here
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'mfa.duoSecurity.push', 'login', [
            'XXX-XXX-7890'
        ])
    },
    DUO_SMS: {
        icon: 'duo-sms-16',
        className: 'suboption factor-option',
        // TODO: add phone number here
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'mfa.duoSecurity.sms', 'login', [
            'XXX-XXX-7890'
        ])
    },
    DUO_CALL: {
        icon: 'duo-call-16',
        className: 'suboption factor-option',
        // TODO: add phone number here
        title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'mfa.duoSecurity.call', 'login', [
            'XXX-XXX-7890'
        ])
    },
    YUBIKEY: {
        icon: 'factor-icon mfa-yubikey-30',
        className: 'factor-option',
        title: function() {
            return this.model.get('factorLabel');
        },
        action: function() {
            $73b5eb0c26708990$var$action.call(this, this.model);
        }
    },
    SMS: {
        icon: 'factor-icon mfa-sms-30',
        className: 'factor-option',
        title: function() {
            return this.model.get('factorLabel');
        },
        action: function() {
            $73b5eb0c26708990$var$action.call(this, this.model);
        }
    },
    CALL: {
        icon: 'factor-icon mfa-call-30',
        className: 'factor-option',
        title: function() {
            return this.model.get('factorLabel');
        },
        action: function() {
            $73b5eb0c26708990$var$action.call(this, this.model);
        }
    },
    QUESTION: {
        icon: 'factor-icon mfa-question-30',
        className: 'factor-option',
        title: function() {
            return this.model.get('factorLabel');
        },
        action: function() {
            $73b5eb0c26708990$var$action.call(this, this.model);
        }
    },
    PASSWORD: {
        icon: 'factor-icon mfa-password-30',
        className: 'factor-option',
        title: function() {
            return this.model.get('factorLabel');
        },
        action: function() {
            $73b5eb0c26708990$var$action.call(this, this.model);
        }
    },
    WINDOWS_HELLO: {
        icon: 'factor-icon mfa-windows-hello-30',
        className: 'factor-option',
        title: function() {
            return this.model.get('factorLabel');
        },
        action: function() {
            $73b5eb0c26708990$var$action.call(this, this.model);
        }
    },
    U2F: {
        icon: 'factor-icon mfa-u2f-30',
        className: 'factor-option',
        title: function() {
            return this.model.get('factorLabel');
        },
        action: function() {
            $73b5eb0c26708990$var$action.call(this, this.model);
        }
    },
    WEBAUTHN: {
        icon: 'factor-icon mfa-webauthn-30',
        className: 'factor-option',
        title: function() {
            return this.model.get('factorLabel');
        },
        action: function() {
            $73b5eb0c26708990$var$action.call(this, this.model);
        }
    },
    EMAIL: {
        icon: 'factor-icon mfa-email-30',
        className: 'factor-option',
        title: function() {
            return this.model.get('factorLabel');
        },
        action: function() {
            $73b5eb0c26708990$var$action.call(this, this.model);
        }
    },
    GENERIC_SAML: {
        icon: 'factor-icon mfa-custom-factor-30',
        className: 'factor-option',
        title: function() {
            return this.model.get('factorLabel');
        },
        action: function() {
            $73b5eb0c26708990$var$action.call(this, this.model);
        }
    },
    GENERIC_OIDC: {
        icon: 'factor-icon mfa-custom-factor-30',
        className: 'factor-option',
        title: function() {
            return this.model.get('factorLabel');
        },
        action: function() {
            $73b5eb0c26708990$var$action.call(this, this.model);
        }
    },
    CUSTOM_CLAIMS: {
        icon: 'factor-icon mfa-custom-factor-30',
        className: 'factor-option',
        title: function() {
            return this.model.get('factorLabel');
        },
        action: function() {
            $73b5eb0c26708990$var$action.call(this, this.model);
        }
    }
};
var $73b5eb0c26708990$export$2e2bcd8739ae039 = {
    getDropdownOption: function(factorName) {
        return $73b5eb0c26708990$var$dropdownOptions[factorName];
    }
};


/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const { BaseDropDown: $4d9208cd9bcec4e1$var$BaseDropDown } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).views.components;
(0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(document).click(function(e) {
    const $target = (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(e.target);
    const isDropdown = $target.closest('.option-selected').length > 0 && $target.closest('.dropdown').length > 0;
    if (!isDropdown) {
        (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)('.dropdown .options').hide();
        (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)('.dropdown a.option-selected').attr('aria-expanded', false);
    }
});
var $4d9208cd9bcec4e1$export$2e2bcd8739ae039 = $4d9208cd9bcec4e1$var$BaseDropDown.extend({
    className: 'bg-helper icon-button',
    screenReaderText: function() {
        const factors = this.options.appState.get('factors');
        let factor;
        let factorLabel;
        if (factors) factor = (0, $020a58caf88b7504$export$2e2bcd8739ae039).findFactorInFactorsArray(factors, this.options.provider, this.options.factorType);
        else factor = new (0, $004803a44bfc2c0c$export$2e2bcd8739ae039).Model(this.options.appState.get('factor'), this.toJSON());
        factorLabel = factor.get('factorLabel');
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.factors.dropdown.sr.text', 'login', [
            factorLabel
        ]);
    },
    events: {
        'click a.option-selected': function(e) {
            e.preventDefault();
            if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'disabled')) e.stopPropagation();
            else {
                const expanded = this.$('.options').toggle().is(':visible');
                this.$('a.option-selected').attr('aria-expanded', expanded);
                if (expanded) this.$('#okta-dropdown-options').find('li.factor-option:first a').focus();
            }
        },
        'click .dropdown-disabled': function(e) {
            e.preventDefault();
            e.stopPropagation();
        }
    },
    initialize: function() {
        this.addOption((0, $73b5eb0c26708990$export$2e2bcd8739ae039).getDropdownOption('TITLE'));
        const factorsList = this.options.appState.get('factors');
        const multiplePushFactors = factorsList.hasMultipleFactorsOfSameType('push');
        factorsList.each(function(factor) {
            // Do not add okta totp if there are multiple okta push (each push will have an inline totp)
            if (!(factor.get('factorType') === 'token:software:totp' && multiplePushFactors)) {
                this.addOption((0, $73b5eb0c26708990$export$2e2bcd8739ae039).getDropdownOption(factor.get('factorName')), {
                    model: factor
                });
                this.listenTo(this.last(), 'options:toggle', function() {
                    this.$('.options').hide();
                    this.$('a.option-selected').attr('aria-expanded', false);
                });
            }
        }, this);
    }
});


var $3a2039c4a4c65f00$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"beacon-blank auth-beacon\"><div class=\"beacon-blank js-blank-beacon-border auth-beacon-border\"></div></div><div class=\"bg-helper auth-beacon auth-beacon-factor " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "className") || (depth0 != null ? lookupProperty(depth0, "className") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "className",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 171
                    },
                    "end": {
                        "line": 1,
                        "column": 184
                    }
                }
            }) : helper)) + "\" data-se=\"factor-beacon\"><div class=\"okta-sign-in-beacon-border auth-beacon-border\"></div></div><div data-type=\"factor-types-dropdown\" class=\"factors-dropdown-wrap\"></div>";
        },
        "useData": true
    }),
    events: {
        'click .auth-beacon-factor': function(e) {
            e.preventDefault();
            e.stopPropagation();
            const expanded = this.$('.dropdown .options').toggle().is(':visible');
            this.$('a.option-selected').attr('aria-expanded', expanded);
            if (expanded) this.$('#okta-dropdown-options').find('li.factor-option:first a').focus();
        }
    },
    initialize: function() {
        this.options.appState.set('beaconType', 'factor');
    },
    getTemplateData: function() {
        const factors = this.options.appState.get('factors');
        let factor;
        let className;
        if (factors) factor = (0, $020a58caf88b7504$export$2e2bcd8739ae039).findFactorInFactorsArray(factors, this.options.provider, this.options.factorType);
        else factor = new (0, $004803a44bfc2c0c$export$2e2bcd8739ae039).Model(this.options.appState.get('factor'));
        className = factor.get('iconClassName');
        return {
            className: className || ''
        };
    },
    postRender: function() {
        if (this.options.animate) this.$('.auth-beacon-factor').fadeIn(200);
        const appState = this.options.appState;
        if (appState.get('hasMultipleFactorsAvailable')) this.add((0, $4d9208cd9bcec4e1$export$2e2bcd8739ae039), '[data-type="factor-types-dropdown"]');
    },
    fadeOut: function() {
        const deferred = (0, $6d3dd6c38b8802c0$export$e673efccd97e4223)();
        this.$('.auth-beacon-factor').fadeOut(200, function() {
            deferred.resolve();
        });
        return deferred.promise;
    },
    equals: function(Beacon, options) {
        return Beacon && this instanceof Beacon && options.provider === this.options.provider && (options.factorType === this.options.factorType || (0, $020a58caf88b7504$export$2e2bcd8739ae039).isOktaVerify(options.provider, options.factorType) && (0, $020a58caf88b7504$export$2e2bcd8739ae039).isOktaVerify(this.options.provider, this.options.factorType));
    }
});












var $ecb8b9ecdb3d87c1$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'piv-beacon',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            return "<div class=\"beacon-blank auth-beacon\"><div class=\"beacon-blank js-blank-beacon-border auth-beacon-border\"></div></div><div class=\"bg-helper auth-beacon smartcard\" data-se=\"piv-beacon\"><div class=\"okta-sign-in-beacon-border auth-beacon-border\"></div></div>";
        },
        "useData": true
    }),
    equals: function(Beacon) {
        return Beacon && this instanceof Beacon;
    }
});




/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $96fb9c531a580e07$export$2e2bcd8739ae039 = (0, $0b2a6057818c4339$export$2e2bcd8739ae039).extend({
    routes: {
        '': 'defaultAuth',
        signin: 'primaryAuth',
        'signin/okta/:username': 'primaryAuth',
        'signin/verify/duo/web': 'verifyDuo',
        'signin/verify/piv': 'verifyPIV',
        'signin/poll': 'poll',
        'signin/verify/fido/webauthn': 'verifyWebauthn',
        'signin/verify/webauthn': 'verifyWebauthn',
        'signin/verify/fido/u2f': 'verifyU2F',
        'signin/verify/u2f': 'verifyU2F',
        'signin/verify/generic_saml/assertion:saml2': 'verifySAMLFactor',
        'signin/verify/generic_oidc/assertion:oidc': 'verifyOIDCFactor',
        'signin/verify/custom/claims_provider': 'verifyClaimsFactor',
        'signin/verify/:factorType': 'verifyNoProvider',
        'signin/verify/:provider/:factorType(/:factorIndex)': 'verify',
        'signin/enroll': 'enrollChoices',
        'signin/enroll/duo/web': 'enrollDuo',
        'signin/enroll/okta/question': 'enrollQuestion',
        'signin/enroll/okta/password': 'enrollPassword',
        'signin/enroll/okta/sms': 'enrollSms',
        'signin/enroll/okta/call': 'enrollCall',
        'signin/enroll/okta/email': 'enrollEmail',
        'signin/enroll-activate/okta/sms': 'enrollSms',
        'signin/enroll-activate/okta/call': 'enrollCall',
        'signin/enroll/rsa/token': 'enrollRsa',
        'signin/enroll/del_oath/token': 'enrollOnPrem',
        'signin/enroll/symantec/token': 'enrollSymantecVip',
        'signin/enroll/yubico/token:hardware': 'enrollYubikey',
        'signin/enroll/fido/webauthn': 'enrollWebauthn',
        'signin/enroll/fido/u2f': 'enrollU2F',
        'signin/enroll/generic_saml/assertion:saml2': 'enrollSAMLFactor',
        'signin/enroll/generic_oidc/assertion:oidc': 'enrollOIDCFactor',
        'signin/enroll/custom/claims_provider': 'enrollClaimsFactor',
        'signin/enroll/custom/token:hotp': 'enrollHotpFactor',
        'signin/enroll/:provider/:factorType': 'enrollTotpFactor',
        'signin/enroll-activate/okta/email': 'enrollActivateEmail',
        'signin/enroll-activate/okta/push': 'scanBarcodePushFactor',
        'signin/enroll-activate/okta/push/manual': 'manualSetupPushFactor',
        'signin/enroll-activate/okta/push/sent': 'activationLinkSent',
        'signin/enroll-activate/okta/token:software:totp/passcode': 'enterPasscodeInPushEnrollmentFlow',
        'signin/enroll-activate/custom/claims_provider': 'enrollActivateClaimsFactor',
        'signin/enroll-activate/:provider/:factorType': 'scanBarcodeTotpFactor',
        'signin/enroll-activate/:provider/:factorType/activate': 'activateTotpFactor',
        'signin/enroll-activate/:provider/:factorType/manual': 'manualSetupTotpFactor',
        'signin/password-expired': 'passwordExpired',
        'signin/custom-password-expired': 'customPasswordExpired',
        'signin/forgot-password': 'forgotPassword',
        'signin/recovery-challenge': 'recoveryChallenge',
        'signin/recovery-emailed': 'recoveryEmailSent',
        'signin/recovery-question': 'recoveryQuestion',
        'signin/password-reset': 'passwordReset',
        'signin/reset-password/:token': 'recoveryLoading',
        'signin/user-unlock/:token': 'recoveryLoading',
        'signin/recovery/:token': 'recoveryLoading',
        'signin/unlock-emailed': 'unlockEmailSent',
        'signin/unlock': 'unlockAccount',
        'signin/account-unlocked': 'accountUnlocked',
        'signin/refresh-auth-state(/:token)': 'refreshAuthState',
        'signin/register': 'register',
        'signin/register-complete': 'registerComplete',
        'signin/error': 'errorState',
        'signin/consent': 'consentRequired',
        'signin/admin-consent': 'adminConsentRequired',
        'signin/enroll-user': 'enrollUser',
        'signin/device-activate-complete': 'deviceActivateComplete',
        'signin/device-activate': 'deviceActivate',
        'signin/idp-discovery-check': 'idpDiscoveryCheck',
        '*wildcard': 'defaultAuth'
    },
    // Route handlers that do not require a stateToken. If the page is refreshed,
    // these functions will not require a status call to refresh the stateToken.
    stateLessRouteHandlers: [
        'defaultAuth',
        'idpDiscovery',
        'primaryAuth',
        'forgotPassword',
        'recoveryLoading',
        'unlockAccount',
        'refreshAuthState',
        'register',
        'registerComplete',
        'errorState',
        'verifyPIV'
    ],
    defaultAuth: function() {
        if (window.location.hash === `#${(0, $e48c043f6d2d382d$export$2e2bcd8739ae039).WIDGET_CONTAINER_ID}`) {
            document.getElementById((0, $e48c043f6d2d382d$export$2e2bcd8739ae039).WIDGET_CONTAINER_ID).focus();
            return;
        }
        if (this.settings.get('features.idpDiscovery')) this.idpDiscovery();
        else this.primaryAuth();
    },
    idpDiscoveryCheck: function() {
        this.render((0, $3beaada32e4aee8e$export$2e2bcd8739ae039), {
            Beacon: (0, $e48413bf62a5ffb5$export$2e2bcd8739ae039)
        });
    },
    idpDiscovery: function() {
        this.render((0, $c55ecccdf1ee9c35$export$2e2bcd8739ae039), {
            Beacon: (0, $e48413bf62a5ffb5$export$2e2bcd8739ae039)
        });
    },
    primaryAuth: function(username) {
        this.render((0, $6e97c0d7c1dd8871$export$2e2bcd8739ae039), {
            Beacon: (0, $e48413bf62a5ffb5$export$2e2bcd8739ae039),
            username: username
        });
    },
    verifyDuo: function() {
        this.render((0, $ef6d256dae36e3cc$export$2e2bcd8739ae039), {
            provider: 'DUO',
            factorType: 'web',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    verifyPIV: function() {
        this.render((0, $d6138eaa4ac7a9c7$export$2e2bcd8739ae039), {
            Beacon: (0, $ecb8b9ecdb3d87c1$export$2e2bcd8739ae039)
        });
    },
    poll: function() {
        this.render((0, $e9bf78d14c010834$export$2e2bcd8739ae039));
    },
    verifyWebauthn: function() {
        if (this.settings.get('features.webauthn')) this.render((0, $c8f7d23c7815260a$export$2e2bcd8739ae039), {
            provider: 'FIDO',
            factorType: 'webauthn',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
        else this.render((0, $9060b0ddf7d4c3a9$export$2e2bcd8739ae039), {
            provider: 'FIDO',
            factorType: 'webauthn',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    verifyU2F: function() {
        this.render((0, $02e856b26edffd37$export$2e2bcd8739ae039), {
            provider: 'FIDO',
            factorType: 'u2f',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    verifySAMLFactor: function() {
        this.render((0, $00487d2a08f8c909$export$2e2bcd8739ae039), {
            provider: 'GENERIC_SAML',
            factorType: 'assertion:saml2',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    verifyOIDCFactor: function() {
        this.render((0, $00487d2a08f8c909$export$2e2bcd8739ae039), {
            provider: 'GENERIC_OIDC',
            factorType: 'assertion:oidc',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    verifyClaimsFactor: function() {
        this.render((0, $00487d2a08f8c909$export$2e2bcd8739ae039), {
            provider: 'CUSTOM',
            factorType: 'claims_provider',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    verify: function(provider, factorType, factorIndex) {
        this.render((0, $fe89ce6972cd452f$export$2e2bcd8739ae039), {
            provider: provider.toUpperCase(),
            factorType: factorType,
            factorIndex: factorIndex,
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    verifyNoProvider: function(factorType) {
        this.render((0, $fe89ce6972cd452f$export$2e2bcd8739ae039), {
            factorType: factorType,
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    enrollChoices: function() {
        this.render((0, $5486982f5705af91$export$2e2bcd8739ae039), {
            Beacon: (0, $e48413bf62a5ffb5$export$2e2bcd8739ae039)
        });
    },
    enrollDuo: function() {
        this.render((0, $332eb3a52ab859cf$export$2e2bcd8739ae039), {
            provider: 'DUO',
            factorType: 'web',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    enrollQuestion: function() {
        this.render((0, $23b0da624770d3a4$export$2e2bcd8739ae039), {
            provider: 'OKTA',
            factorType: 'question',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    enrollPassword: function() {
        this.render((0, $e391b3f17ddf99ff$export$2e2bcd8739ae039), {
            provider: 'OKTA',
            factorType: 'password',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    enrollSms: function() {
        this.render((0, $83de8ccc23eb85f0$export$2e2bcd8739ae039), {
            provider: 'OKTA',
            factorType: 'sms',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    enrollCall: function() {
        this.render((0, $83de8ccc23eb85f0$export$2e2bcd8739ae039), {
            provider: 'OKTA',
            factorType: 'call',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    enrollEmail: function() {
        this.render((0, $5708478ccbee4e8f$export$2e2bcd8739ae039), {
            provider: 'OKTA',
            factorType: 'email',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    enrollActivateEmail: function() {
        this.render((0, $cc187b957bd25eac$export$2e2bcd8739ae039), {
            provider: 'OKTA',
            factorType: 'email',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    enrollRsa: function() {
        this.render((0, $09c5783bba5f3baf$export$2e2bcd8739ae039), {
            provider: 'RSA',
            factorType: 'token',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    enrollOnPrem: function() {
        this.render((0, $09c5783bba5f3baf$export$2e2bcd8739ae039), {
            provider: 'DEL_OATH',
            factorType: 'token',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    enrollSymantecVip: function() {
        this.render((0, $93a5b7168c29c446$export$2e2bcd8739ae039), {
            provider: 'SYMANTEC',
            factorType: 'token',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    enrollYubikey: function() {
        this.render((0, $7e3c3db353f11be6$export$2e2bcd8739ae039), {
            provider: 'YUBICO',
            factorType: 'token:hardware',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    enrollSAMLFactor: function() {
        this.render((0, $b4f6437a72effa5a$export$2e2bcd8739ae039), {
            provider: 'GENERIC_SAML',
            factorType: 'assertion:saml2',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    enrollOIDCFactor: function() {
        this.render((0, $b4f6437a72effa5a$export$2e2bcd8739ae039), {
            provider: 'GENERIC_OIDC',
            factorType: 'assertion:oidc',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    enrollClaimsFactor: function() {
        this.render((0, $b4f6437a72effa5a$export$2e2bcd8739ae039), {
            provider: 'CUSTOM',
            factorType: 'claims_provider',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    enrollActivateClaimsFactor: function() {
        this.render((0, $d8b19b19af3e80be$export$2e2bcd8739ae039), {
            provider: 'CUSTOM',
            factorType: 'claims_provider',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    enrollTotpFactor: function(provider, factorType) {
        this.render((0, $2304fafdb9bf0140$export$2e2bcd8739ae039), {
            provider: provider.toUpperCase(),
            factorType: factorType,
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    enrollHotpFactor: function() {
        this.render((0, $0c204f6759392460$export$2e2bcd8739ae039), {
            provider: 'CUSTOM',
            factorType: 'token:hotp',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    enrollWebauthn: function() {
        if (this.settings.get('features.webauthn')) this.render((0, $d0ee074a6a35232e$export$2e2bcd8739ae039), {
            provider: 'FIDO',
            factorType: 'webauthn',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
        else this.render((0, $db2ad7e14a32059c$export$2e2bcd8739ae039), {
            provider: 'FIDO',
            factorType: 'webauthn',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    enrollU2F: function() {
        this.render((0, $c3339c1f7ae4eb34$export$2e2bcd8739ae039), {
            provider: 'FIDO',
            factorType: 'u2f',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    scanBarcodeTotpFactor: function(provider, factorType) {
        this.render((0, $133fc2818bcbfed0$export$2e2bcd8739ae039), {
            provider: provider.toUpperCase(),
            factorType: factorType,
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    scanBarcodePushFactor: function() {
        this.render((0, $349095b9a5a2623c$export$2e2bcd8739ae039), {
            provider: 'OKTA',
            factorType: 'push',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    activateTotpFactor: function(provider, factorType) {
        this.render((0, $79604dba0f9306ba$export$2e2bcd8739ae039), {
            provider: provider.toUpperCase(),
            factorType: factorType,
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    manualSetupTotpFactor: function(provider, factorType) {
        this.render((0, $8e3c489124846a35$export$2e2bcd8739ae039), {
            provider: provider.toUpperCase(),
            factorType: factorType,
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    manualSetupPushFactor: function() {
        this.render((0, $17c0799a01338ad1$export$2e2bcd8739ae039), {
            provider: 'OKTA',
            factorType: 'push',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    activationLinkSent: function() {
        this.render((0, $c739760b2c46fd01$export$2e2bcd8739ae039), {
            provider: 'OKTA',
            factorType: 'push',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    enterPasscodeInPushEnrollmentFlow: function() {
        this.render((0, $f3164ad050821c09$export$2e2bcd8739ae039), {
            provider: 'OKTA',
            factorType: 'token:software:totp',
            Beacon: (0, $3a2039c4a4c65f00$export$2e2bcd8739ae039)
        });
    },
    passwordExpired: function() {
        this.render((0, $0e4cef0364ccc4b2$export$2e2bcd8739ae039), {
            Beacon: (0, $e48413bf62a5ffb5$export$2e2bcd8739ae039)
        });
    },
    customPasswordExpired: function() {
        this.render((0, $a07f1e1028c3cedb$export$2e2bcd8739ae039), {
            Beacon: (0, $e48413bf62a5ffb5$export$2e2bcd8739ae039)
        });
    },
    forgotPassword: function() {
        this.render((0, $58f9ab8c8f9b3995$export$2e2bcd8739ae039));
    },
    recoveryChallenge: function() {
        this.render((0, $fe93fdd3fd387c42$export$2e2bcd8739ae039), {
            Beacon: (0, $e48413bf62a5ffb5$export$2e2bcd8739ae039)
        });
    },
    recoveryEmailSent: function() {
        this.render((0, $a0a7bb80dd446175$export$2e2bcd8739ae039), {
            Beacon: (0, $e48413bf62a5ffb5$export$2e2bcd8739ae039)
        });
    },
    unlockEmailSent: function() {
        this.render((0, $9ca5d3e3949f8917$export$2e2bcd8739ae039), {
            Beacon: (0, $e48413bf62a5ffb5$export$2e2bcd8739ae039)
        });
    },
    recoveryQuestion: function() {
        this.render((0, $72af1de338e371b3$export$2e2bcd8739ae039), {
            Beacon: (0, $e48413bf62a5ffb5$export$2e2bcd8739ae039)
        });
    },
    passwordReset: function() {
        this.render((0, $7b7df0c713d659d3$export$2e2bcd8739ae039), {
            Beacon: (0, $e48413bf62a5ffb5$export$2e2bcd8739ae039)
        });
    },
    recoveryLoading: function(token) {
        this.render((0, $f3697ac887a293ed$export$2e2bcd8739ae039), {
            token: token,
            Beacon: (0, $e48413bf62a5ffb5$export$2e2bcd8739ae039)
        });
    },
    unlockAccount: function() {
        this.render((0, $268061122cf4617d$export$2e2bcd8739ae039));
    },
    accountUnlocked: function() {
        this.render((0, $8b90797548581db5$export$2e2bcd8739ae039), {
            Beacon: (0, $e48413bf62a5ffb5$export$2e2bcd8739ae039)
        });
    },
    refreshAuthState: function(token) {
        this.render((0, $e80118e4fca8f865$export$2e2bcd8739ae039), {
            token: token,
            Beacon: (0, $e48413bf62a5ffb5$export$2e2bcd8739ae039)
        });
    },
    register: function() {
        this.render((0, $49ec60c8878cee4a$export$2e2bcd8739ae039));
    },
    registerComplete: function() {
        this.render((0, $0a4a7c3d7a3af0b5$export$2e2bcd8739ae039));
    },
    errorState: function() {
        this.render((0, $38805fa0bbfc7b7e$export$2e2bcd8739ae039), {
            Beacon: (0, $e48413bf62a5ffb5$export$2e2bcd8739ae039)
        });
    },
    consentRequired: function() {
        this.render((0, $f2ae6428e6e53a68$export$2e2bcd8739ae039));
    },
    adminConsentRequired: function() {
        this.render((0, $c42465bf8c63c685$export$2e2bcd8739ae039));
    },
    enrollUser: function() {
        this.render((0, $d234d4f2449a410d$export$2e2bcd8739ae039));
    },
    deviceActivate: function() {
        this.render((0, $56c1d17b1df40c00$export$2e2bcd8739ae039));
    },
    deviceActivateComplete: function() {
        this.render((0, $429c1e562a7720eb$export$2e2bcd8739ae039));
    }
});


































/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ /**
 * Structure of FORMS object:
 * { [CONSTANT]: remediationForm.name }
 */ const $4a07c2817278db15$export$657220afecfe252 = {
    IDENTIFY: 'identify',
    SELECT_IDENTIFY: 'select-identify',
    IDENTIFY_RECOVERY: 'identify-recovery',
    SELECT_ENROLL_PROFILE: 'select-enroll-profile',
    ENROLL_PROFILE: 'enroll-profile',
    ENROLL_PROFILE_UPDATE: 'profile-update',
    UNLOCK_ACCOUNT: 'unlock-account',
    REQUEST_ACTIVATION: 'request-activation-email',
    CONSENT_ADMIN: 'admin-consent',
    CONSENT_ENDUSER: 'consent',
    CONSENT_GRANULAR: 'granular-consent',
    CONSENT_EMAIL_CHALLENGE: 'email-challenge-consent',
    SELECT_AUTHENTICATOR_AUTHENTICATE: 'select-authenticator-authenticate',
    SELECT_AUTHENTICATOR_UNLOCK: 'select-authenticator-unlock-account',
    AUTHENTICATOR_VERIFICATION_DATA: 'authenticator-verification-data',
    CHALLENGE_AUTHENTICATOR: 'challenge-authenticator',
    CHALLENGE_WEBAUTHN_AUTOFILLUI_AUTHENTICATOR: 'challenge-webauthn-autofillui-authenticator',
    CHALLENGE_POLL: 'challenge-poll',
    RESEND: 'resend',
    SELECT_AUTHENTICATOR_ENROLL: 'select-authenticator-enroll',
    SELECT_AUTHENTICATOR_ENROLL_DATA: 'select-authenticator-enroll-data',
    AUTHENTICATOR_ENROLLMENT_DATA: 'authenticator-enrollment-data',
    ENROLL_AUTHENTICATOR: 'enroll-authenticator',
    ENROLL_AUTHENTICATOR_PROMOTION: 'enroll-authenticator-promotion',
    SELECT_ENROLLMENT_CHANNEL: 'select-enrollment-channel',
    ENROLLMENT_CHANNEL_DATA: 'enrollment-channel-data',
    ENROLL_POLL: 'enroll-poll',
    REENROLL_AUTHENTICATOR: 'reenroll-authenticator',
    REENROLL_AUTHENTICATOR_WARNING: 'reenroll-authenticator-warning',
    REENROLL_CUSTOM_PASSWORD_EXPIRY: 'reenroll-custom-password-expiry',
    REENROLL_CUSTOM_PASSWORD_EXPIRY_WARNING: 'reenroll-custom-password-expiry-warning',
    RESET_AUTHENTICATOR: 'reset-authenticator',
    SKIP: 'skip',
    POLL: 'poll',
    FAILURE_REDIRECT: 'failure-redirect',
    SUCCESS_REDIRECT: 'success-redirect',
    REDIRECT_IDP: 'redirect-idp',
    REDIRECT_IDVERIFY: 'redirect-idverify',
    PIV_IDP: 'piv-idp',
    DEVICE_CHALLENGE_POLL: 'device-challenge-poll',
    DEVICE_APPLE_SSO_EXTENSION: 'device-apple-sso-extension',
    CANCEL_TRANSACTION: 'cancel-transaction',
    LAUNCH_AUTHENTICATOR: 'launch-authenticator',
    LAUNCH_NFC_AUTHENTICATOR: 'launch-nfc-authenticator',
    LAUNCH_WEBAUTHN_AUTHENTICATOR: 'launch-webauthn-authenticator',
    ENROLL_WEBAUTHN_RESIDENTKEY: 'enroll-webauthn-residentkey',
    LAUNCH_PASSKEYS_AUTHENTICATOR: 'launch-passkeys-authenticator',
    DEVICE_ENROLLMENT_TERMINAL: 'device-enrollment-terminal',
    USER_CODE: 'user-code',
    KEEP_ME_SIGNED_IN: 'keep-me-signed-in',
    DEVICE_ASSURANCE_GRACE_PERIOD: 'device-assurance-grace-period',
    // 'terminal` is not ION Form name but only coined in widget
    // for rendering a page that user has nothing to remediate.
    TERMINAL: 'terminal'
};
// Forms added here do not show the Sign out link
const $4a07c2817278db15$export$c6f7786ac9d3b8c5 = [
    $4a07c2817278db15$export$657220afecfe252.IDENTIFY,
    $4a07c2817278db15$export$657220afecfe252.SUCCESS_REDIRECT,
    $4a07c2817278db15$export$657220afecfe252.ENROLL_PROFILE,
    $4a07c2817278db15$export$657220afecfe252.DEVICE_ENROLLMENT_TERMINAL,
    $4a07c2817278db15$export$657220afecfe252.CONSENT_ADMIN,
    $4a07c2817278db15$export$657220afecfe252.CONSENT_ENDUSER,
    $4a07c2817278db15$export$657220afecfe252.CONSENT_GRANULAR,
    $4a07c2817278db15$export$657220afecfe252.CONSENT_EMAIL_CHALLENGE,
    $4a07c2817278db15$export$657220afecfe252.USER_CODE,
    $4a07c2817278db15$export$657220afecfe252.KEEP_ME_SIGNED_IN
];
const $4a07c2817278db15$export$9508a612c466a96 = [
    $4a07c2817278db15$export$657220afecfe252.SELECT_AUTHENTICATOR_ENROLL,
    $4a07c2817278db15$export$657220afecfe252.SELECT_AUTHENTICATOR_AUTHENTICATE
];
const $4a07c2817278db15$export$e5c33b4280697991 = [
    $4a07c2817278db15$export$657220afecfe252.SELECT_AUTHENTICATOR_AUTHENTICATE,
    $4a07c2817278db15$export$657220afecfe252.CHALLENGE_AUTHENTICATOR,
    $4a07c2817278db15$export$657220afecfe252.CHALLENGE_POLL,
    $4a07c2817278db15$export$657220afecfe252.RESEND
];
const $4a07c2817278db15$export$a7895cc4b0944d1b = {
    EMAIL: 'okta_email',
    PASSWORD: 'okta_password',
    PHONE: 'phone_number',
    WEBAUTHN: 'webauthn',
    SECURITY_QUESTION: 'security_question',
    OV: 'okta_verify',
    GOOGLE_OTP: 'google_otp',
    ON_PREM: 'onprem_mfa',
    RSA: 'rsa_token',
    DUO: 'duo',
    IDP: 'external_idp',
    CUSTOM_OTP: 'custom_otp',
    SYMANTEC_VIP: 'symantec_vip',
    YUBIKEY: 'yubikey_token',
    CUSTOM_APP: 'custom_app',
    SMARTCARD: 'smart_card_idp',
    TAC: 'tac',
    NFC_PIN: 'nfc_pin'
};
const $4a07c2817278db15$export$2ba9c278cddab44b = {
    PUSH: 'push'
};
const $4a07c2817278db15$export$8e4daa11e9eb0065 = {
    [$4a07c2817278db15$export$657220afecfe252.SELECT_AUTHENTICATOR_UNLOCK]: (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).UNLOCK_ACCOUNT,
    [$4a07c2817278db15$export$657220afecfe252.IDENTIFY]: (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).PRIMARY_AUTH,
    [$4a07c2817278db15$export$657220afecfe252.IDENTIFY_RECOVERY]: (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).FORGOT_PASSWORD
};
const $4a07c2817278db15$var$ENROLLED_PASSWORD_RECOVERY_LINK = 'currentAuthenticatorEnrollment-recover';
const $4a07c2817278db15$export$77b1c349e66d68cb = 'currentAuthenticator-recover';
const $4a07c2817278db15$export$92a1a3b7554e9387 = {
    ENROLLED_PASSWORD_RECOVERY_LINK: $4a07c2817278db15$var$ENROLLED_PASSWORD_RECOVERY_LINK,
    ORG_PASSWORD_RECOVERY_LINK: $4a07c2817278db15$export$77b1c349e66d68cb
};
// Possible Remediation Form Field Hints
const $4a07c2817278db15$export$2a8012a560f62720 = {
    CAPTCHA: 'captcha'
};
const $4a07c2817278db15$export$7412d2738fb17921 = [
    $4a07c2817278db15$export$657220afecfe252.TERMINAL,
    $4a07c2817278db15$export$657220afecfe252.DEVICE_ENROLLMENT_TERMINAL
];
const $4a07c2817278db15$export$a771d6a73ed8e155 = {
    X509: 'X509'
};
// Possible options for the SIW interstitial redirect view
const $4a07c2817278db15$export$5b95bebd73cede29 = {
    DEFAULT: 'DEFAULT',
    NONE: 'NONE'
};
const $4a07c2817278db15$export$9bd38ecac9cbb8d6 = {
    COUNTRY_CODE: 'country-code'
};
const $4a07c2817278db15$export$cd4bf62f61ca5ae1 = {
    IDV_PERSONA: 'IDV_PERSONA',
    IDV_CLEAR: 'IDV_CLEAR',
    IDV_INCODE: 'IDV_INCODE',
    IDV_STANDARD: 'IDV_STANDARD',
    IDV_OIN: 'IDV_OIN'
};













/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ /**
 * Example of the option like
 * @param {AuthenticatorOption[]} options
 * @param {( AuthenticatorEnrollment[] || Authenticator[] )} authenticators
 */ function $899ec74c77d1bd7c$export$7ff2d8daead069f0(options = []) {
    var _ovItem$value, _ovItem$value$form, _ovItem$value$form$va;
    // Split OV into individual entries for verification (one for each method).
    const ovItem = options.find((option)=>option.relatesTo.key === (0, $4a07c2817278db15$export$a7895cc4b0944d1b).OV);
    const methodTypeObj = ovItem === null || ovItem === void 0 ? void 0 : (_ovItem$value = ovItem.value) === null || _ovItem$value === void 0 ? void 0 : (_ovItem$value$form = _ovItem$value.form) === null || _ovItem$value$form === void 0 ? void 0 : (_ovItem$value$form$va = _ovItem$value$form.value) === null || _ovItem$value$form$va === void 0 ? void 0 : _ovItem$value$form$va.find((v)=>v.name === 'methodType');
    const methodOptions = methodTypeObj === null || methodTypeObj === void 0 ? void 0 : methodTypeObj.options;
    let signedNonceOption;
    if (methodOptions) {
        const ovOptions = [];
        methodOptions.forEach((method)=>{
            // get value object from the ov item
            const value = [
                ...ovItem.value.form.value
            ];
            // get index of the methodType object within the value object
            const methodTypeIndex = ovItem.value.form.value.findIndex((v)=>v.name === 'methodType');
            // create a new methodType object that removes the options array and
            // has a value of the current method
            const newMethodTypeObj = Object.assign((0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(methodTypeObj, 'options'), method);
            // set the methodType field to be required and immutable in our UI,
            // so it is always sent to the backend.
            newMethodTypeObj.required = true;
            newMethodTypeObj.mutable = false;
            // replace old methodType object with the new one
            value.splice(methodTypeIndex, 1, newMethodTypeObj);
            // return a new ov item for a specific method
            const newItem = Object.assign({}, ovItem, {
                label: method.label,
                value: {
                    form: {
                        value: value
                    }
                }
            });
            if (method.value === 'signed_nonce') signedNonceOption = newItem;
            else ovOptions.push(newItem);
        });
        const ovIndex = options.findIndex((option)=>option.relatesTo.key === (0, $4a07c2817278db15$export$a7895cc4b0944d1b).OV);
        options.splice(ovIndex, 1, ...ovOptions);
        // ReArrange fastpass in options based on deviceKnown
        if (signedNonceOption) ovItem.relatesTo.deviceKnown ? options.unshift(signedNonceOption) : options.push(signedNonceOption);
    }
}
function $899ec74c77d1bd7c$var$createAuthenticatorOptions(options = [], { isEnroll: isEnroll = false } = {}) {
    $899ec74c77d1bd7c$export$7ff2d8daead069f0(options);
    return options.map((option)=>{
        var _option$value, _option$value$form, _option$relatesTo, _option$relatesTo2;
        const value = ((_option$value = option.value) === null || _option$value === void 0 ? void 0 : (_option$value$form = _option$value.form) === null || _option$value$form === void 0 ? void 0 : _option$value$form.value) || [];
        // Each authenticator option has list of ION field.
        // Currently we only support merely selecting one of options
        // rather than pop up another page to collect extra data
        // (in order to fill value for `mutable: true; value: null` fields).
        // The only reason of such design is to simplify widget implementation
        // but could subject to change in later releases.
        // Thus only surface up fields that are `required: true; mutable: false`
        // which implies it already has `value`.
        const valueObject = value.filter((v)=>v.required === true && v.mutable === false).reduce((init, v)=>{
            return Object.assign(init, {
                [v.name]: v.value
            });
        }, {});
        const surfaced = {
            label: option.label,
            value: valueObject,
            relatesTo: option.relatesTo,
            authenticatorKey: (_option$relatesTo = option.relatesTo) === null || _option$relatesTo === void 0 ? void 0 : _option$relatesTo.key
        };
        // N-of-M authenticator groups: the group affiliation lives on the referenced
        // authenticator entry (option.relatesTo.groupIds). Only surface it for
        // enrollment — the verify flow does not use group partitioning, and the
        // contract states verify responses will not carry groupIds. Restricting the
        // surfacing here keeps the verify option shape untouched.
        if (isEnroll && Array.isArray((_option$relatesTo2 = option.relatesTo) === null || _option$relatesTo2 === void 0 ? void 0 : _option$relatesTo2.groupIds) && option.relatesTo.groupIds.length > 0) surfaced.groupIds = option.relatesTo.groupIds;
        return surfaced;
    });
}
function $899ec74c77d1bd7c$var$getAuthenticatorsEnrollUiSchema({ options: options }) {
    return {
        type: 'authenticatorEnrollSelect',
        options: $899ec74c77d1bd7c$var$createAuthenticatorOptions(options, {
            isEnroll: true
        })
    };
}
function $899ec74c77d1bd7c$var$getAuthenticatorsVerifyUiSchema({ options: options }) {
    return {
        type: 'authenticatorVerifySelect',
        options: $899ec74c77d1bd7c$var$createAuthenticatorOptions(options)
    };
}
/**
  * Create ui schema for ION field that has type 'object'.
  */ function $899ec74c77d1bd7c$export$2e2bcd8739ae039(ionFormField, remediationForm, transformedResp, createUISchema, settings) {
    const uiSchema = {};
    if (ionFormField.name === 'authenticator' && (remediationForm.name === 'select-authenticator-authenticate' || remediationForm.name === 'select-authenticator-unlock-account')) // 1. when `select-authenticator-authenticator`,
    // create customize type so that display authenticator list as selectable list
    Object.assign(uiSchema, $899ec74c77d1bd7c$var$getAuthenticatorsVerifyUiSchema(ionFormField));
    else if (ionFormField.name === 'authenticator' && remediationForm.name === 'select-authenticator-enroll') // 2. when `select-authenticator-enroll`,
    // create customize type so that display authenticator list as selectable list
    Object.assign(uiSchema, $899ec74c77d1bd7c$var$getAuthenticatorsEnrollUiSchema(ionFormField));
    else if (Array.isArray(ionFormField.options)) {
        // 3. For other cases, create ui schema for each `option` in order to render
        // different view for each option.
        //
        // e.g. { "name": "credentials", "type": "object", options: [ {value: {form: value:[]} ]
        uiSchema.optionsUiSchemas = ionFormField.options.map((opt)=>{
            return createUISchema(transformedResp, {
                value: [
                    {
                        name: ionFormField.name,
                        value: opt.value
                    }
                ]
            }, settings);
        });
        uiSchema.options = ionFormField.options.map((opt, index)=>{
            return {
                label: opt.label,
                value: index
            };
        });
        // assume (default to) use radio buttons to switch sub-schema.
        uiSchema.type = 'radio';
        uiSchema.value = '0';
        uiSchema.name = `sub_schema_local_${ionFormField.name}`;
    }
    return uiSchema;
}












(0, $3e490973b7383cc4$export$2e2bcd8739ae039).mixin({
    nestedOmit: function(obj, names) {
        let result = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(obj, names);
        if (names.includes(result.name)) result = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(result, 'value');
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(result, function(val, key) {
            if (Array.isArray(val)) result[key] = val.map((v)=>{
                return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).nestedOmit(v, names);
            });
            else if (typeof val === 'object') result[key] = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).nestedOmit(val, names);
        });
        return result;
    }
});


/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ async function $3187669a11ef20e8$export$74ce132ae97956a2(functions) {
    for(let i = 0; i < functions.length; i++)await functions[i]();
}
async function $3187669a11ef20e8$export$83d14e54e50a1a2a(hook) {
    if (!hook || !hook.before || !hook.before.length) return;
    await $3187669a11ef20e8$export$74ce132ae97956a2(hook.before);
}
async function $3187669a11ef20e8$export$3edd39a83caf9634(hook) {
    if (!hook || !hook.after || !hook.after.length) return;
    await $3187669a11ef20e8$export$74ce132ae97956a2(hook.after);
}
function $3187669a11ef20e8$export$e893ed9fcbab732c(hooks, formName, hookToMerge) {
    const existingHook = hooks[formName] = hooks[formName] || {
        before: [],
        after: []
    };
    if (hookToMerge.before) existingHook.before = (existingHook.before || []).concat(hookToMerge.before);
    if (hookToMerge.after) existingHook.after = (existingHook.after || []).concat(hookToMerge.after);
}



/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $6879cb334c0737c9$var$UNKNOWN_USER_I8N_KEY = "idx.unknown.user";
/**
 * Keep track of stateMachine with this special model. Similar to `src/models/AppState.js`
 */ const $6879cb334c0737c9$var$local = {
    user: 'object',
    // optional
    currentFormName: 'string',
    previousFormName: 'string',
    idx: 'object',
    remediations: 'array',
    dynamicRefreshInterval: 'number',
    deviceFingerprint: 'string',
    hooks: 'object',
    // instance of models/Hooks
    authenticatorGroups: 'array' // N-of-M enrollment groups (optional, present only when policy has groups)
};
const $6879cb334c0737c9$var$derived = {
    authenticatorProfile: {
        deps: [
            'currentAuthenticator',
            'currentAuthenticatorEnrollment'
        ],
        fn: function(currentAuthenticator = {
            profile: undefined
        }, currentAuthenticatorEnrollment = {
            profile: undefined
        }) {
            return currentAuthenticator.profile || currentAuthenticatorEnrollment.profile || {};
        }
    },
    authenticatorKey: {
        deps: [
            'currentAuthenticator',
            'currentAuthenticatorEnrollment'
        ],
        fn: function(currentAuthenticator = {
            key: undefined
        }, currentAuthenticatorEnrollment = {
            key: undefined
        }) {
            return currentAuthenticator.key || currentAuthenticatorEnrollment.key || '';
        }
    },
    authenticatorMethodType: {
        deps: [
            'currentAuthenticator',
            'currentAuthenticatorEnrollment'
        ],
        fn: function(currentAuthenticator = {
            methods: undefined
        }, currentAuthenticatorEnrollment = {
            methods: undefined
        }) {
            return currentAuthenticator.methods && currentAuthenticator.methods[0].type || currentAuthenticatorEnrollment.methods && currentAuthenticatorEnrollment.methods[0].type || '';
        }
    },
    isPasswordRecovery: {
        deps: [
            'recoveryAuthenticator'
        ],
        fn: function(recoveryAuthenticator = {
            type: undefined
        }) {
            return (recoveryAuthenticator === null || recoveryAuthenticator === void 0 ? void 0 : recoveryAuthenticator.type) === 'password';
        }
    }
};
class $6879cb334c0737c9$export$2e2bcd8739ae039 extends (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039) {
    constructor(attributes, options){
        super(attributes, options);
        this.settings = void 0;
        this.hooks = void 0;
        this.settings = options.settings;
        this.hooks = options.hooks;
    }
    get(attributeName) {
        return (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039).prototype.get.call(this, attributeName);
    }
    preinitialize(...args) {
        this.local = $6879cb334c0737c9$var$local;
        this.derived = $6879cb334c0737c9$var$derived;
        (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039).prototype.preinitialize.apply(this, args);
    }
    isIdentifierOnlyView() {
        var _this$get, _this$get$find, _this$get$find$uiSche;
        return !((_this$get = this.get('remediations')) !== null && _this$get !== void 0 && (_this$get$find = _this$get.find(({ name: name })=>name === 'identify')) !== null && _this$get$find !== void 0 && (_this$get$find$uiSche = _this$get$find.uiSchema) !== null && _this$get$find$uiSche !== void 0 && _this$get$find$uiSche.find(({ name: name })=>name === 'credentials.passcode'));
    }
    hasRemediationObject(formName) {
        return this.get('idx').neededToProceed.find((remediation)=>remediation.name === formName);
    }
    hasActionObject(actionName) {
        var _this$get2, _this$get2$actions;
        return !!((_this$get2 = this.get('idx')) !== null && _this$get2 !== void 0 && (_this$get2$actions = _this$get2.actions) !== null && _this$get2$actions !== void 0 && _this$get2$actions[actionName]);
    }
    getRemediationAuthenticationOptions(formName) {
        const form = this.hasRemediationObject(formName);
        if (!form) return [];
        const authenticator = form.value.find((value)=>value.name === 'authenticator');
        let authenticatorOptions = (authenticator === null || authenticator === void 0 ? void 0 : authenticator.options) || [];
        // OV is a special case, so process OV options
        authenticatorOptions = [
            ...authenticatorOptions
        ]; //clone it since we are changing it for OV
        (0, $899ec74c77d1bd7c$export$7ff2d8daead069f0)(authenticatorOptions);
        return authenticatorOptions;
    }
    getActionByPath(actionPath) {
        const paths = actionPath.split('.');
        let targetObject;
        if (paths.length === 1) targetObject = this.get('idx').actions;
        else targetObject = this.get(paths.shift());
        // Limitation
        // At the time of writting, action only lives in first level of state objects.
        const actionName = paths.shift();
        if (targetObject && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(targetObject[actionName])) return targetObject[actionName];
        else return null;
    }
    getCurrentViewState() {
        const currentFormName = this.get('currentFormName');
        if (!currentFormName) return;
        // didn't expect `remediations` is empty. See `setIonResponse`.
        const currentViewState = this.get('remediations').filter((r)=>r.name === currentFormName)[0];
        if (!currentViewState) {
            (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).error('Panic!!');
            (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).error(`\tCannot find view state for form ${currentFormName}.`);
            const allFormNames = this.get('remediations').map((r)=>r.name);
            (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).error(`\tAll available form names: ${allFormNames}`);
        }
        return currentViewState;
    }
    /**
   * Returns ui schema of the form field from current view state
   * @param {string} fieldName
   * @returns {}
   */ getSchemaByName(fieldName) {
        const currentViewState = this.getCurrentViewState();
        if (currentViewState) {
            const uiSchema = currentViewState.uiSchema;
            return uiSchema.find(({ name: name })=>name === fieldName);
        }
    }
    /**
   * Returns the displayName of the authenticator
   * @returns {string}
   */ getAuthenticatorDisplayName() {
        const currentAuthenticator = this.get('currentAuthenticator') || {};
        const currentAuthenticatorEnrollment = this.get('currentAuthenticatorEnrollment') || {};
        // For enrollment and certain verification flows, the currentAuthenticator object will be present.
        // If not, we're likely in a traditional verify/challenge flow.
        return currentAuthenticator.displayName || currentAuthenticatorEnrollment.displayName;
    }
    /**
   * Checks to see if we're in an authenticator challenge flow.
   * @returns {boolean}
   */ isAuthenticatorChallenge() {
        const currentFormName = this.get('currentFormName');
        return (0, $4a07c2817278db15$export$e5c33b4280697991).includes(currentFormName);
    }
    shouldReRenderView(transformedResponse) {
        var _transformedResponse$;
        if (transformedResponse !== null && transformedResponse !== void 0 && (_transformedResponse$ = transformedResponse.idx) !== null && _transformedResponse$ !== void 0 && _transformedResponse$.hasFormError) return false;
        const previousRawState = this.has('idx') ? this.get('idx').rawIdxState : null;
        const identicalResponse = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEqual((0, $3e490973b7383cc4$export$2e2bcd8739ae039).nestedOmit(transformedResponse.idx.rawIdxState, [
            'expiresAt',
            'refresh',
            'stateHandle',
            'headers'
        ]), (0, $3e490973b7383cc4$export$2e2bcd8739ae039).nestedOmit(previousRawState, [
            'expiresAt',
            'refresh',
            'stateHandle',
            'headers'
        ]));
        if (identicalResponse) this.set('dynamicRefreshInterval', this.getRefreshInterval(transformedResponse));
        return this._isReRenderRequired(identicalResponse, transformedResponse, previousRawState);
    }
    getRefreshInterval(transformedResponse) {
        var _transformedResponse$2, _transformedResponse$3, _transformedResponse$4, _transformedResponse$5;
        // Only polling refresh interval has changed in the response,
        // make sure to update the correct poll view's refresh value
        const currentFormName = this.get('currentFormName');
        const currentViewState = transformedResponse.remediations.filter((r)=>r.name === currentFormName)[0];
        // Get new refresh interval for either: remediations, authenticator, or authenticator enrollment
        return currentViewState.refresh || ((_transformedResponse$2 = transformedResponse.currentAuthenticatorEnrollment) === null || _transformedResponse$2 === void 0 ? void 0 : (_transformedResponse$3 = _transformedResponse$2.poll) === null || _transformedResponse$3 === void 0 ? void 0 : _transformedResponse$3.refresh) || ((_transformedResponse$4 = transformedResponse.currentAuthenticator) === null || _transformedResponse$4 === void 0 ? void 0 : (_transformedResponse$5 = _transformedResponse$4.poll) === null || _transformedResponse$5 === void 0 ? void 0 : _transformedResponse$5.refresh);
    }
    // Sign Out link will be displayed in the footer of a form, unless:
    // - widget configuration set hideSignOutLinkInMFA or mfaOnlyFlow to true
    // - cancel remediation form is not present in the response
    // - form is part of our list FORMS_WITHOUT_SIGNOUT
    shouldShowSignOutLinkInCurrentForm(hideSignOutLinkInMFA) {
        const idxActions = this.get('idx') && this.get('idx').actions;
        const currentFormName = this.get('currentFormName');
        return !hideSignOutLinkInMFA && (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(idxActions === null || idxActions === void 0 ? void 0 : idxActions.cancel) && !(0, $4a07c2817278db15$export$c6f7786ac9d3b8c5).includes(currentFormName);
    }
    containsMessageWithI18nKey(keys) {
        if (!Array.isArray(keys)) keys = [
            keys
        ];
        const messagesObjs = this.get('messages');
        return messagesObjs && Array.isArray(messagesObjs.value) && messagesObjs.value.some((messagesObj)=>{
            var _messagesObj$i18n;
            return (0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains(keys, (_messagesObj$i18n = messagesObj.i18n) === null || _messagesObj$i18n === void 0 ? void 0 : _messagesObj$i18n.key);
        });
    }
    containsMessageStartingWithI18nKey(keySubStr) {
        const messagesObjs = this.get('messages');
        return messagesObjs && Array.isArray(messagesObjs.value) && messagesObjs.value.some((messagesObj)=>{
            var _messagesObj$i18n2;
            return (_messagesObj$i18n2 = messagesObj.i18n) === null || _messagesObj$i18n2 === void 0 ? void 0 : _messagesObj$i18n2.key.startsWith(keySubStr);
        });
    }
    clearAppStateCache() {
        // clear appState before setting new values
        const attrs = {};
        for(const key in this.attributes)if (key !== 'currentFormName') attrs[key] = void 0;
        this.set(attrs, Object.assign({}, {
            unset: true,
            silent: true
        }));
        // clear cache for derived props.
        this.trigger('cache:clear');
    }
    chooseRemediation(transformedResponse) {
        var _transformedResponse$6, _transformedResponse$7;
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(transformedResponse.remediations)) return;
        const firstRemediation = transformedResponse.remediations[0];
        // Special case: Okta Verify: show select enrollment channel instead of QR code on mobile
        if (firstRemediation.name === 'enroll-poll' && this.get('authenticatorKey') === (0, $4a07c2817278db15$export$a7895cc4b0944d1b).OV && ((0, $22893d6dea78fc87$export$2e2bcd8739ae039).isAndroid() || (0, $22893d6dea78fc87$export$2e2bcd8739ae039).isIOS()) && ((_transformedResponse$6 = transformedResponse.currentAuthenticator) === null || _transformedResponse$6 === void 0 ? void 0 : (_transformedResponse$7 = _transformedResponse$6.contextualData) === null || _transformedResponse$7 === void 0 ? void 0 : _transformedResponse$7.selectedChannel) === 'qrcode') return transformedResponse.remediations.find((r)=>r.name === 'select-enrollment-channel');
        // Default case: return the first remediation in the list
        return firstRemediation;
    }
    async setIonResponse(transformedResponse) {
        const doRerender = this.shouldReRenderView(transformedResponse);
        this.clearAppStateCache();
        // set new app state properties
        this.set(transformedResponse);
        if (doRerender) {
            var _this$hooks;
            const remediation = this.chooseRemediation(transformedResponse);
            let currentFormName = null;
            if (remediation) currentFormName = remediation.name;
            else {
                (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).error('Panic!!');
                (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).error('\tNo remediation found.');
                (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).error('\tHere is the entire response');
                (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).error(JSON.stringify(transformedResponse, null, 2));
            }
            const hook = (_this$hooks = this.hooks) === null || _this$hooks === void 0 ? void 0 : _this$hooks.getHook(currentFormName); // may be undefined
            await (0, $3187669a11ef20e8$export$83d14e54e50a1a2a)(hook);
            const previousFormName = this.get('currentFormName');
            this.unset('currentFormName', {
                silent: true
            });
            // make sure change `currentFormName` is last step.
            // change `currentFormName` will re-render FormController,
            // which may depend on other derived properties hence
            // those derived properties must be re-computed before
            // re-rendering controller.
            this.set({
                currentFormName: currentFormName,
                previousFormName: previousFormName
            });
            await (0, $3187669a11ef20e8$export$3edd39a83caf9634)(hook);
        }
    }
    setNonIdxError(error) {
        this.set('remediations', [
            {
                name: (0, $4a07c2817278db15$export$657220afecfe252).TERMINAL
            }
        ]);
        this.set('messages', {
            value: [
                {
                    message: error.errorDetails.errorSummary,
                    class: 'ERROR'
                }
            ]
        });
        this.set('currentFormName', (0, $4a07c2817278db15$export$657220afecfe252).TERMINAL);
    }
    getUser() {
        return this.get('user');
    }
    _isReRenderRequired(identicalResponse, transformedResponse, previousRawState) {
        var _this$get3;
        let reRender = true;
        const isPreviousStateError = (_this$get3 = this.get('idx')) === null || _this$get3 === void 0 ? void 0 : _this$get3.hasFormError;
        if (isPreviousStateError && this._isChallengeAuthenticatorPoll(transformedResponse, previousRawState)) reRender = false;
        if (identicalResponse) {
            /**
       * returns false: When new response is same as last.
       * usually happens during polling when pipeline doesn't proceed to next step.
       * expiresAt will be different for each response, hence compare objects without that property
       */ reRender = false;
            if (this.get('currentFormName') === 'poll') /**
         * returns true: We want to force reRender when currentForm is poll because request has to reinitiate
         * based on new refresh and UI has to reflect new timer.
         * We dont technical poll here we just make a request after the specified refresh time each time
         * we get a new response.
         */ reRender = true;
            else if ((0, $4a07c2817278db15$export$9508a612c466a96).includes(this.get('currentFormName'))) /**
         * returns true: We want to force reRender if you go back to selection screen from challenge or enroll screen
         * and re-select the same authenticator for challenge. In this case also new response will be identical
         * to the old response.
         */ reRender = true;
            else if (this.containsMessageWithI18nKey($6879cb334c0737c9$var$UNKNOWN_USER_I8N_KEY)) /**
         * Need to re-render or else form will be stuck in saving mode.
         * This message is a form warning that can result in identical responses if the user enters the same
         * username as the one in the last message warning.
         */ reRender = true;
        }
        return reRender;
    }
    /**
   * This is to account for the edge case introduced by this issue: OKTA-419210. With the current idx remediations,
   * there's no good way to generalize this as the backend handles the authenticators for phone, sms and 
   * email differently. Although not ideal, we have to keep this check in for now until we find a better solution.
   */ _isChallengeAuthenticatorPoll(transformedResponse, previousRawState) {
        var _this$get4;
        const isSameExceptMessages = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEqual((0, $3e490973b7383cc4$export$2e2bcd8739ae039).nestedOmit(transformedResponse.idx.rawIdxState, [
            'expiresAt',
            'refresh',
            'stateHandle',
            'headers'
        ]), (0, $3e490973b7383cc4$export$2e2bcd8739ae039).nestedOmit(previousRawState, [
            'expiresAt',
            'refresh',
            'stateHandle',
            'messages',
            'headers'
        ]));
        const isChallengeAuthenticator = this.get('currentFormName') === 'challenge-authenticator';
        const isCurrentAuthenticatorEmail = ((_this$get4 = this.get('currentAuthenticatorEnrollment')) === null || _this$get4 === void 0 ? void 0 : _this$get4.key) === (0, $4a07c2817278db15$export$a7895cc4b0944d1b).EMAIL;
        return isSameExceptMessages && isChallengeAuthenticator && isCurrentAuthenticatorEmail;
    }
}


/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $64cf5b2d2fb5baf3$var$STATE_HANDLE_SESSION_STORAGE_KEY = 'osw-oie-state-handle';
const $64cf5b2d2fb5baf3$var$LAST_INITIATED_LOGIN_URL_SESSION_STORAGE_KEY = 'osw-oie-last-initiated-login-url';
const $64cf5b2d2fb5baf3$var$RESEND_TIMESTAMP_SESSION_STORAGE_KEY = 'osw-oie-resend-timestamp';
const $64cf5b2d2fb5baf3$var$removeStateHandle = ()=>{
    sessionStorage.removeItem($64cf5b2d2fb5baf3$var$STATE_HANDLE_SESSION_STORAGE_KEY);
    sessionStorage.removeItem($64cf5b2d2fb5baf3$var$LAST_INITIATED_LOGIN_URL_SESSION_STORAGE_KEY);
};
const $64cf5b2d2fb5baf3$var$setStateHandle = (token)=>{
    sessionStorage.setItem($64cf5b2d2fb5baf3$var$STATE_HANDLE_SESSION_STORAGE_KEY, token);
    sessionStorage.setItem($64cf5b2d2fb5baf3$var$LAST_INITIATED_LOGIN_URL_SESSION_STORAGE_KEY, window.location.href);
};
const $64cf5b2d2fb5baf3$var$getStateHandle = ()=>{
    return sessionStorage.getItem($64cf5b2d2fb5baf3$var$STATE_HANDLE_SESSION_STORAGE_KEY);
};
const $64cf5b2d2fb5baf3$var$getLastInitiatedLoginUrl = ()=>{
    return sessionStorage.getItem($64cf5b2d2fb5baf3$var$LAST_INITIATED_LOGIN_URL_SESSION_STORAGE_KEY);
};
const $64cf5b2d2fb5baf3$var$removeResendTimestamp = ()=>{
    sessionStorage.removeItem($64cf5b2d2fb5baf3$var$RESEND_TIMESTAMP_SESSION_STORAGE_KEY);
};
const $64cf5b2d2fb5baf3$var$setResendTimestamp = (token)=>{
    sessionStorage.setItem($64cf5b2d2fb5baf3$var$RESEND_TIMESTAMP_SESSION_STORAGE_KEY, token);
};
const $64cf5b2d2fb5baf3$var$getResendTimestamp = ()=>{
    return sessionStorage.getItem($64cf5b2d2fb5baf3$var$RESEND_TIMESTAMP_SESSION_STORAGE_KEY);
};
var $64cf5b2d2fb5baf3$export$2e2bcd8739ae039 = {
    removeStateHandle: $64cf5b2d2fb5baf3$var$removeStateHandle,
    setStateHandle: $64cf5b2d2fb5baf3$var$setStateHandle,
    getStateHandle: $64cf5b2d2fb5baf3$var$getStateHandle,
    getLastInitiatedLoginUrl: $64cf5b2d2fb5baf3$var$getLastInitiatedLoginUrl,
    removeResendTimestamp: $64cf5b2d2fb5baf3$var$removeResendTimestamp,
    setResendTimestamp: $64cf5b2d2fb5baf3$var$setResendTimestamp,
    getResendTimestamp: $64cf5b2d2fb5baf3$var$getResendTimestamp
};




/*!
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ async function $4954550f906bc72d$export$5689b397ca9d7367(settings) {
    const authClient = settings.getAuthClient();
    const idxOptions = {
        exchangeCodeForTokens: false // we handle this in interactionCodeFlow.js
    };
    const meta = await authClient.idx.getSavedTransactionMeta(); // meta can load in another tab using state if it matches
    if (!meta || !meta.interactionHandle) {
        // Flow can not continue in this tab. Create a synthetic server response and use it to display a message to the user
        const messages = {
            type: 'array',
            value: [
                // terminal-return-otp-only-no-location.json
                {
                    'message': 'Enter the OTP in your original browser or device.',
                    'i18n': {
                        'key': 'idx.enter.otp.in.original.tab'
                    },
                    'class': 'INFO'
                }
            ]
        };
        const resp = {
            neededToProceed: [],
            // OKTA-382410 so bad that has to leverage rawIdxState
            rawIdxState: {
                messages: messages
            },
            context: {
                messages: messages
            }
        };
        return resp;
    }
    // Proceed using the OTP code
    const otp = settings.get('otp');
    const idxResponse = await authClient.idx.proceed({
        ...idxOptions,
        otp: otp
    });
    return idxResponse;
}



/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $12b2542b724eccae$export$ead867ba51e7f9b2 = {
    DEFAULT: 'default',
    PROCEED: 'proceed',
    LOGIN: 'login',
    REGISTRATION: 'signup',
    RESET_PASSWORD: 'resetPassword',
    UNLOCK_ACCOUNT: 'unlockAccount'
};


/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $5c956f54a640b39f$var$handleProxyIdxResponse = async (settings)=>{
    return Promise.resolve({
        rawIdxState: settings.get('proxyIdxResponse'),
        context: settings.get('proxyIdxResponse'),
        neededToProceed: []
    });
};
/* eslint max-depth: [2, 3] */ // eslint-disable-next-line complexity, max-statements
async function $5c956f54a640b39f$export$dbed9b2f15c02c8e(settings) {
    const authClient = settings.getAuthClient();
    // nonce is not a top-level auth-js option, must be passed in manually
    const { authParams: authParams } = settings.toJSON({
        verbose: true
    });
    const nonce = settings.get('nonce') || (authParams === null || authParams === void 0 ? void 0 : authParams.nonce);
    const idxOptions = {
        exchangeCodeForTokens: false,
        // we handle this in interactionCodeFlow.js
        ...nonce && {
            nonce: nonce
        }
    };
    // Return a preset response
    if (settings.get('proxyIdxResponse')) return $5c956f54a640b39f$var$handleProxyIdxResponse(settings);
    if (settings.get('overrideExistingStateToken')) (0, $64cf5b2d2fb5baf3$export$2e2bcd8739ae039).removeStateHandle();
    if (settings.get('otp')) return (0, $4954550f906bc72d$export$5689b397ca9d7367)(settings);
    if (settings.get('oauth2Enabled')) {
        const meta = await authClient.idx.getSavedTransactionMeta();
        if (!meta) {
            // no saved transaction
            // if the configured flow is set to `proceed`, the SIW should only continue an existing idx transaction
            // if the SIW loads from a fresh state (there is no current transaction), throw an error
            const flow = authClient.idx.getFlow();
            if (flow && flow === (0, $12b2542b724eccae$export$ead867ba51e7f9b2).PROCEED) throw new (0, $3fe6932680e7ea64$export$faf57ee6e26cb1b0)('Unable to proceed: saved transaction could not be loaded', flow);
            // start new transaction
            return authClient.idx.start(idxOptions); // calls interact
        }
        // continue saved transaction
        return authClient.idx.proceed(idxOptions); // calls introspect
    }
    // Use stateToken from session storage if exists
    // See more details at ./docs/use-session-token-prior-to-settings.png
    const stateHandleFromSession = (0, $64cf5b2d2fb5baf3$export$2e2bcd8739ae039).getStateHandle();
    if (stateHandleFromSession) try {
        var _idxResp$context, _idxResp$context$mess;
        const idxResp = await authClient.idx.start({
            ...idxOptions,
            stateHandle: stateHandleFromSession
        });
        const hasError = ((_idxResp$context = idxResp.context) === null || _idxResp$context === void 0 ? void 0 : (_idxResp$context$mess = _idxResp$context.messages) === null || _idxResp$context$mess === void 0 ? void 0 : _idxResp$context$mess.value.length) > 0;
        if (hasError) throw new Error('saved stateToken is invalid'); // will be caught in this function
        // 1. abandon the settings.stateHandle given session.stateHandle is still valid
        settings.set('stateToken', stateHandleFromSession);
        // 2. chain the idxResp to next handler
        return idxResp;
    } catch  {
        // 1. remove session.stateHandle
        (0, $64cf5b2d2fb5baf3$export$2e2bcd8739ae039).removeStateHandle();
        // 2. start the login again in order to introspect on settings.stateHandle
        return $5c956f54a640b39f$export$dbed9b2f15c02c8e(settings);
    }
    // Use stateToken from options
    const stateHandle = settings.get('stateToken');
    if (stateHandle) return authClient.idx.start({
        ...idxOptions,
        stateHandle: stateHandle
    });
    throw new (0, $3fe6932680e7ea64$export$c5fb415882705cf4)('Invalid OIDC configuration. Set "clientId" and "redirectUri" in the widget options.');
}






/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ // checks if "desired" remeidation is available before calling `.proceed`
// if not available, returns original idxResponse (and logs warning)
async function $12ff73410cfee270$var$proceedIfAvailable(idxState, remediation, flow) {
    const rem = idxState.neededToProceed.find((item)=>item.name === remediation);
    if (!rem) {
        (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).warn('Expected remediation not found, Org may be misconfigured for this flow');
        return idxState;
    }
    try {
        const nextIdxState = await idxState.proceed(remediation);
        return nextIdxState;
    } catch (err) {
        // catches and handles `Unknown remediation` errors thrown okta-idx-js
        if (typeof err === 'string' && err.startsWith('Unknown remediation choice')) {
            (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).warn(`flow [${flow}] not valid with current Org configurations`);
            return idxState;
        } else // do not catch non-`Unknown remediation` errors here
        throw err;
    }
}
// attempts to "step into" a specific flow by calling `.proceed` with a specific remeidation (or calls an action)
// the "desired" remeidation is not guaranteed to be available, depends upon Org configurations
async function $12ff73410cfee270$var$stepIntoSpecificIdxFlow(idxState, flow = 'default') {
    switch(flow){
        case (0, $12b2542b724eccae$export$ead867ba51e7f9b2).DEFAULT:
        case (0, $12b2542b724eccae$export$ead867ba51e7f9b2).PROCEED:
        case (0, $12b2542b724eccae$export$ead867ba51e7f9b2).LOGIN:
            // default IDX response from interact is "Login" page/flow. Do nothing
            return idxState;
        // step logic is handled by auth-js
        case (0, $12b2542b724eccae$export$ead867ba51e7f9b2).REGISTRATION:
        case (0, $12b2542b724eccae$export$ead867ba51e7f9b2).RESET_PASSWORD:
            return idxState;
        case (0, $12b2542b724eccae$export$ead867ba51e7f9b2).UNLOCK_ACCOUNT:
            // requires: introspect -> identify-recovery -> select-authenticator-unlock-account
            return await $12ff73410cfee270$var$proceedIfAvailable(idxState, (0, $4a07c2817278db15$export$657220afecfe252).UNLOCK_ACCOUNT, flow);
        default:
            (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).warn(`Unknown \`flow\` value: ${flow}`);
            throw new (0, $3fe6932680e7ea64$export$c5fb415882705cf4)('Invalid "flow" configuration');
    }
}
// ensures the `flow` stored in the transaction meta matches the flow configuration
// if they do not match, abandon the current (meta) flow and start a new (configured) flow
async function $12ff73410cfee270$export$472edd06424c2bb7(originalResp, settings) {
    const authClient = settings.getAuthClient();
    const configuredFlow = authClient.idx.getFlow();
    // attempts to step into the desired flow
    const idxState = await $12ff73410cfee270$var$stepIntoSpecificIdxFlow(originalResp, configuredFlow);
    return idxState;
}







/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ // eslint-disable-next-line max-statements
async function $f869579558aab7a0$export$5acf4a4412b19943(settings, idxResponse) {
    const { interactionCode: interactionCode } = idxResponse;
    const authClient = settings.getAuthClient();
    const transactionMeta = await authClient.idx.getSavedTransactionMeta();
    const state = authClient.options.state || (transactionMeta === null || transactionMeta === void 0 ? void 0 : transactionMeta.state);
    // In remediation mode the transaction is owned by another client.
    const isRemediationMode = settings.get('mode') === 'remediation';
    if (isRemediationMode) authClient.idx.clearTransactionMeta();
    // server-side applications will want to received interaction_code as a query parameter
    // this option can also be used to force a redirect for client-side/SPA applications
    const shouldRedirect = settings.get('redirect') === 'always';
    if (shouldRedirect) {
        const redirectUri = settings.get('redirectUri');
        if (!redirectUri) throw new (0, $3fe6932680e7ea64$export$c5fb415882705cf4)('"redirectUri" is required');
        const qs = (0, $714174fa38b8e4a1$exports.toQueryString)({
            'interaction_code': interactionCode,
            state: state
        });
        window.location.assign(redirectUri + qs);
        return;
    }
    // Return a promise (or call success callback) to client-side apps in remediation mode.
    if (isRemediationMode) {
        settings.callGlobalSuccess((0, $e48c043f6d2d382d$export$2e2bcd8739ae039).SUCCESS, {
            'interaction_code': interactionCode,
            state: state
        });
        return;
    }
    // Operating in "relying-party" mode. The widget owns this transaction.
    // Complete the transaction client-side and call success/resolve promise
    if (!transactionMeta) throw new (0, $3fe6932680e7ea64$export$c5fb415882705cf4)('Could not load transaction data from storage');
    const { codeVerifier: codeVerifier } = transactionMeta;
    return authClient.token.exchangeCodeForTokens({
        codeVerifier: codeVerifier,
        interactionCode: interactionCode
    }).then(({ tokens: tokens })=>{
        settings.callGlobalSuccess((0, $e48c043f6d2d382d$export$2e2bcd8739ae039).SUCCESS, {
            tokens: tokens
        });
    }).catch((err)=>{
        const typedError = (0, $c5998cb91d464d17$export$f1b5849350c3fa45)(err);
        if (typedError instanceof (0, $c5998cb91d464d17$export$4dab270a958fec91) && typedError.is('terminal')) throw typedError;
        settings.callGlobalError(err);
    }).finally(()=>{
        // clear all meta related to this transaction
        authClient.idx.clearTransactionMeta();
    });
}
























/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ /**
 * Transform the ion spec response into canonical format.
 */ /**
 * Authn V2 response
 * @typedef {Object} AuthnResponse
 */ /**
 * @typedef {Object} AuthnResult
 * @property {Object=} user
 * @property {Object=} authenticator
 */ const $f333a6abaf10e986$var$isObject = (x)=>(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isObject(x);
const $f333a6abaf10e986$var$isError = (response)=>!!response.messages;
/**
 * Flatten first level objects from response
 */ const $f333a6abaf10e986$var$getFirstLevelObjects = (resp)=>{
    const result = {};
    (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(resp, (val = {}, key)=>{
        // if key is remediation we don't do any transformation
        if (key === 'remediation') return;
        // for arrays we just want it as a top level object
        // Example authenticators array in select-authenticator form
        if (val.type === 'array') result[key] = {
            value: val.value
        };
        // for handling attributes with type object
        if (val.type === 'object') result[key] = val.value;
    });
    return result;
};
const $f333a6abaf10e986$var$getRemediationValues = (idx)=>{
    const remediationValues = [];
    const hasSkipRemediationOnly = idx.neededToProceed.length === 1 && idx.neededToProceed[0].name === 'skip';
    if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(idx.neededToProceed) || hasSkipRemediationOnly) {
        // no remediation or only skip remediation with success
        if (idx.context.success) remediationValues.push({
            name: idx.context.success.name,
            href: idx.context.success.href,
            priorVerification: idx.context.success.priorVerification,
            value: []
        });
        else if (idx.context.messages) // no remediation or only skip remediation with messages
        remediationValues.push({
            name: (0, $4a07c2817278db15$export$657220afecfe252).TERMINAL,
            // Using `value` is unnecessary as `messages` will be display via `TerminalView.showMessages`,
            // even though might sound a little counterintuitive.
            // The reason being is there is `BaseForm.showMessages` that is intended to handle
            // messages generically.
            value: []
        });
        else if (idx.context.deviceEnrollment) // no remediation or only skip remediation with messages for device enrollment state
        // and the state is meant to be terminal state with different UI than the regular terminal view
        remediationValues.push({
            name: (0, $4a07c2817278db15$export$657220afecfe252).DEVICE_ENROLLMENT_TERMINAL,
            value: []
        });
    }
    return {
        remediations: [
            ...remediationValues,
            ...idx.neededToProceed
        ]
    };
};
/**
 * To support `idps` configuration in OIE.
 * https://github.com/okta/okta-signin-widget#openid-connect
 */ const $f333a6abaf10e986$var$injectIdPConfigButtonToRemediation = (settings, idxResp)=>{
    const widgetRemedations = idxResp.remediations;
    const hasIdentifyRemedation = widgetRemedations.filter((r)=>r.name === 'identify');
    if (hasIdentifyRemedation.length === 0) return idxResp;
    const idpsConfig = settings.get('idps');
    if (Array.isArray(idpsConfig)) {
        const existsRedirectIdpIds = {};
        widgetRemedations.forEach((r)=>{
            if (r.name === (0, $4a07c2817278db15$export$657220afecfe252).REDIRECT_IDP && r.idp) existsRedirectIdpIds[r.idp.id] = true;
        });
        const baseUrl = settings.get('baseUrl');
        const stateHandle = idxResp.idx.context.stateHandle;
        const redirectIdpRemedations = idpsConfig.filter((c)=>!existsRedirectIdpIds[c.id]) // omit idps that are already in remediation.
        .map((idpConfig)=>{
            const idp = {
                id: idpConfig.id,
                name: idpConfig.text
            };
            const redirectUri = `${baseUrl}/sso/idps/${idpConfig.id}?stateToken=${stateHandle}`;
            if (idpConfig.className) idp.className = idpConfig.className;
            return {
                name: (0, $4a07c2817278db15$export$657220afecfe252).REDIRECT_IDP,
                type: idpConfig.type,
                idp: idp,
                href: redirectUri
            };
        });
        idxResp.remediations = widgetRemedations.concat(redirectIdpRemedations);
    }
    return idxResp;
};
/**
 * IFF there is one `redirect-idp` remediation form, widget will automatically redirect to `redirect-idp.href`.
 *
 * The idea now is to reuse `success-redirect` thus converts `redirect-idp` to `success-redirect` form.
 */ const $f333a6abaf10e986$var$convertRedirectIdPToSuccessRedirectIffOneIdp = (settings, result, lastResult)=>{
    if (Array.isArray(result.remediations)) {
        const redirectIdpRemediations = result.remediations.filter((idp)=>idp.name === (0, $4a07c2817278db15$export$657220afecfe252).REDIRECT_IDP);
        if (redirectIdpRemediations.length !== 1 || result.remediations.length !== 1) return;
        // Direct auth clients should not redirect on the initial response
        const isDirectAuth = settings.get('oauth2Enabled');
        if (isDirectAuth && !lastResult) return;
        const successRedirect = {
            name: (0, $4a07c2817278db15$export$657220afecfe252).SUCCESS_REDIRECT,
            href: redirectIdpRemediations[0].href,
            value: []
        };
        result.remediations = [
            successRedirect
        ];
    }
};
/**
 * API reuses `redirect-idp` remediation form for PIV IdP and IdP Authenticator.
 * IdP Authenticator becomes outlier comparing with other Authenticators in terms of
 * using `challenge-authenticator` and `enroll-authenticator` remediation form.
 * The UX for PIV IdP is different from other idps in terms of the PIV
 * instructions view that needs to be rendered before we redirect to mtls.
 *
 * This function changes `redirect-idp` to `challenge-authenticator` or `enroll-authenticator`
 * for IdP Authenticator and changes `redirect-idp` to `piv-idp` for PIV IdP.
 */ const $f333a6abaf10e986$var$modifyFormNameForIdP = (result)=>{
    if (Array.isArray(result.remediations)) result.remediations.forEach((remediation)=>{
        var _remediation$relatesT, _remediation$relatesT2;
        if (remediation.name === (0, $4a07c2817278db15$export$657220afecfe252).REDIRECT_IDP && (remediation === null || remediation === void 0 ? void 0 : (_remediation$relatesT = remediation.relatesTo) === null || _remediation$relatesT === void 0 ? void 0 : (_remediation$relatesT2 = _remediation$relatesT.value) === null || _remediation$relatesT2 === void 0 ? void 0 : _remediation$relatesT2.key) === (0, $4a07c2817278db15$export$a7895cc4b0944d1b).IDP) {
            // idp authenticator
            const isVerifyFlow = Object.prototype.hasOwnProperty.call(result, 'currentAuthenticatorEnrollment');
            remediation.name = isVerifyFlow ? 'challenge-authenticator' : 'enroll-authenticator';
        }
        if (remediation.name === (0, $4a07c2817278db15$export$657220afecfe252).REDIRECT_IDP && remediation.type === (0, $4a07c2817278db15$export$a771d6a73ed8e155).X509) // piv idp
        remediation.name = (0, $4a07c2817278db15$export$657220afecfe252).PIV_IDP;
    });
};
const $f333a6abaf10e986$var$isFailureRedirect = (result)=>{
    const context = result.idx.context;
    return context.failure && context.failure.name === 'failure-redirect';
};
const $f333a6abaf10e986$var$handleFailureRedirect = (settings, result)=>{
    const context = result.idx.context;
    // Direct auth clients will usually prefer to display the error instead of redirecting
    const isDirectAuth = settings.get('oauth2Enabled');
    const alwaysRedirect = settings.get('redirect') === 'always'; // redirect option overrides default behavior
    if (isDirectAuth && !alwaysRedirect) return;
    const failureRedirect = {
        name: (0, $4a07c2817278db15$export$657220afecfe252).FAILURE_REDIRECT,
        href: context.failure.href,
        value: []
    };
    result.remediations = [
        failureRedirect
    ];
};
/**
 * @param {Models.Settings} user configuration
 * @param {idx} idx object
 * @returns {} transformed object with flattened firstlevel objects, idx and remediations array
 * Example: {
 *  idx: {
 *    proceed: ƒ(),
 *    neededToProceed: [],
 *    actions: {cancel: ƒ()},
 *    context: {},
 *  },
 *  remediations: [],
 *  authenticators: {},
 *  authenticator: {},
 *  messages: {},
 *  deviceEnrollment: {},
 * }
 */ const $f333a6abaf10e986$export$2e2bcd8739ae039 = (settings, idx = {}, lastResult = null)=>{
    if (!$f333a6abaf10e986$var$isObject(idx.rawIdxState)) return null;
    // build result object
    const firstLevelObjects = $f333a6abaf10e986$var$getFirstLevelObjects(idx.rawIdxState);
    const remediationValues = $f333a6abaf10e986$var$getRemediationValues(idx);
    const result = Object.assign({}, firstLevelObjects, remediationValues, {
        idx: idx
    });
    // `authenticatorGroups` arrives in the ion {type, value}-wrapped form on the
    // wire like every other top-level array in an IDX response. Flatten to a
    // plain array so downstream consumers can treat it as one. Absent when the
    // applicable policy has no N-of-M groups configured.
    const rawGroups = idx.rawIdxState.authenticatorGroups;
    if (rawGroups && rawGroups.type === 'array' && Array.isArray(rawGroups.value)) result.authenticatorGroups = rawGroups.value;
    // transform result object
    if ($f333a6abaf10e986$var$isError(result) && $f333a6abaf10e986$var$isFailureRedirect(result)) $f333a6abaf10e986$var$handleFailureRedirect(settings, result);
    // Override the `result` to handle custom IdP login buttons
    // and update the form for IdP Authenticators.
    $f333a6abaf10e986$var$injectIdPConfigButtonToRemediation(settings, result);
    $f333a6abaf10e986$var$modifyFormNameForIdP(result);
    if (!$f333a6abaf10e986$var$isError(result)) // Only redirect to the IdP if we are not in an error flow
    $f333a6abaf10e986$var$convertRedirectIdPToSuccessRedirectIffOneIdp(settings, result, lastResult);
    return result;
};























/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $17a13147b004a486$var$getCheckboxUiSchema = ({ label: label, type: type, required: required })=>({
        // For Remember Me checkbox, we need the label only on the right side of it.
        placeholder: label,
        label: false,
        // Separating prop type for Backbone.Model
        // from html input type
        modelType: type,
        // uiSchema type is the html input type desired.
        type: 'checkbox',
        required: required || false
    });
const $17a13147b004a486$var$getRadioUiSchema = ({ label: label, required: required, options: options })=>({
        displayName: label,
        type: 'radio',
        required: required,
        options: options[0].value.value.options,
        sublabel: required ? null : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.form.field.optional', 'login')
    });
const $17a13147b004a486$var$getCheckboxUiSchemaWithDefaultValue = ({ label: label, type: type })=>({
        placeholder: label,
        label: false,
        modelType: type,
        type: 'checkbox',
        // set required true so default value can be passed to optional attributes as well
        required: true,
        value: false
    });
const $17a13147b004a486$export$2e2bcd8739ae039 = (ionFormField, remediationForm)=>{
    var _ionFormField$options, _ionFormField$options2, _ionFormField$options3, _ionFormField$options4, _ionFormField$options5, _ionFormField$options6;
    if ([
        (0, $4a07c2817278db15$export$657220afecfe252).CONSENT_ENDUSER,
        (0, $4a07c2817278db15$export$657220afecfe252).CONSENT_ADMIN
    ].includes(remediationForm.name)) {
        const scopes = remediationForm.scopes.map(({ name: name, label: label, desc: desc })=>{
            return {
                name: name,
                displayName: label,
                description: desc
            };
        });
        // setting 'type' here to add a specific View in FormInputFactory.create
        const type = remediationForm.name;
        return {
            type: type,
            scopes: scopes,
            options: ionFormField.options
        };
    } else if (Array.isArray(ionFormField.options) && ((_ionFormField$options = ionFormField.options[0]) === null || _ionFormField$options === void 0 ? void 0 : (_ionFormField$options2 = _ionFormField$options.value) === null || _ionFormField$options2 === void 0 ? void 0 : (_ionFormField$options3 = _ionFormField$options2.value) === null || _ionFormField$options3 === void 0 ? void 0 : _ionFormField$options3.inputType) === 'radio') return $17a13147b004a486$var$getRadioUiSchema(ionFormField);
    else if (Array.isArray(ionFormField.options) && ((_ionFormField$options4 = ionFormField.options[0]) === null || _ionFormField$options4 === void 0 ? void 0 : (_ionFormField$options5 = _ionFormField$options4.value) === null || _ionFormField$options5 === void 0 ? void 0 : (_ionFormField$options6 = _ionFormField$options5.value) === null || _ionFormField$options6 === void 0 ? void 0 : _ionFormField$options6.inputType) === 'checkbox') return $17a13147b004a486$var$getCheckboxUiSchemaWithDefaultValue(ionFormField);
    else return $17a13147b004a486$var$getCheckboxUiSchema(ionFormField);
};















var $e0758ec218de264e$export$2e2bcd8739ae039 = {
    GMT: 'UTC',
    WET: 'WET',
    CET: 'CET',
    MET: 'CET',
    ECT: 'CET',
    EET: 'EET',
    MIT: 'Pacific/Apia',
    HST: 'Pacific/Honolulu',
    AST: 'America/Anchorage',
    PST: 'America/Los_Angeles',
    MST: 'America/Denver',
    PNT: 'America/Phoenix',
    CST: 'America/Chicago',
    EST: 'America/New_York',
    IET: 'America/Indiana/Indianapolis',
    PRT: 'America/Puerto_Rico',
    CNT: 'America/St_Johns',
    AGT: 'America/Argentina/Buenos_Aires',
    BET: 'America/Sao_Paulo',
    ART: 'Africa/Cairo',
    CAT: 'Africa/Harare',
    EAT: 'Africa/Addis_Ababa',
    NET: 'Asia/Yerevan',
    PLT: 'Asia/Karachi',
    IST: 'Asia/Kolkata',
    BST: 'Asia/Dhaka',
    VST: 'Asia/Ho_Chi_Minh',
    CTT: 'Asia/Shanghai',
    JST: 'Asia/Tokyo',
    ACT: 'Australia/Darwin',
    AET: 'Australia/Sydney',
    SST: 'Pacific/Guadalcanal',
    NST: 'Pacific/Auckland'
};


/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $8a1ef845025128c4$var$ionOptionsToUiOptions = (options)=>{
    const result = {};
    options.forEach(({ value: value, label: label })=>{
        result[value] = label;
    });
    return result;
};
const $8a1ef845025128c4$var$getPasswordUiSchema = (settings)=>({
        type: 'password',
        params: {
            showPasswordToggle: settings.get('showPasswordToggle')
        }
    });
const $8a1ef845025128c4$var$getCaptchaUiSchema = ()=>{
    return {
        type: 'captcha'
    };
};
const $8a1ef845025128c4$var$timezoneUISchema = {
    type: 'select',
    wide: true
};
const $8a1ef845025128c4$var$shouldRenderAsRadio = (name)=>name.indexOf('methodType') >= 0 || name.indexOf('channel') >= 0;
const $8a1ef845025128c4$var$optionalType = [
    'text',
    'radio',
    'select'
];
const $8a1ef845025128c4$var$populateUISchemaForDisplay = (uiSchema, ionField)=>{
    var _ionField$value;
    const display = ionField === null || ionField === void 0 ? void 0 : (_ionField$value = ionField.value) === null || _ionField$value === void 0 ? void 0 : _ionField$value.value;
    uiSchema.type = display.inputType;
    if (display.inputType === 'radio') uiSchema.options = display.options;
    else if (display.inputType === 'select') {
        uiSchema.wide = true;
        if (display.format === (0, $4a07c2817278db15$export$9bd38ecac9cbb8d6).COUNTRY_CODE) uiSchema.options = Object.assign({
            '': ''
        }, (0, $bfbf136e55dbe393$export$2e2bcd8739ae039).getCountryCode());
        else //it will create a placeholder for dropdowns, by default it will show 'Select an option'
        uiSchema.options = Object.assign({
            '': ''
        }, $8a1ef845025128c4$var$ionOptionsToUiOptions(display.options));
    }
};
const $8a1ef845025128c4$var$populateUISchemaForRadio = (uiSchema, ionFormField)=>{
    // e.g. { name: 'methodType', options: [ {label: 'sms'} ], type: 'string' | null }
    uiSchema.type = 'radio';
    // set the default value to the first value.
    ionFormField.value = ionFormField.options[0].value;
};
const $8a1ef845025128c4$export$2e2bcd8739ae039 = (ionFormField, remediationForm, transformedResp, createUISchema, settings)=>{
    const uiSchema = {
        type: 'text'
    };
    // e.g. { name: 'password', secret: true }
    if (ionFormField.secret === true) Object.assign(uiSchema, $8a1ef845025128c4$var$getPasswordUiSchema(settings));
    if (ionFormField.hint === (0, $4a07c2817278db15$export$2a8012a560f62720).CAPTCHA) Object.assign(uiSchema, $8a1ef845025128c4$var$getCaptchaUiSchema());
    if (ionFormField.name === 'userProfile.timezone') {
        Object.assign(uiSchema, $8a1ef845025128c4$var$timezoneUISchema);
        uiSchema.options = Object.assign({
            '': ''
        }, (0, $e0758ec218de264e$export$2e2bcd8739ae039));
    }
    if (Array.isArray(ionFormField.options) && ionFormField.options[0] && ionFormField.options[0].value) {
        const ionField = ionFormField.options[0];
        if (ionField.label === 'display') $8a1ef845025128c4$var$populateUISchemaForDisplay(uiSchema, ionField);
        else if ($8a1ef845025128c4$var$shouldRenderAsRadio(ionFormField.name)) $8a1ef845025128c4$var$populateUISchemaForRadio(uiSchema, ionFormField);
        else {
            // default to select (dropdown). no particular reason (certainly can default to radio.)
            // e.g. { name: 'questionKey', options: [], type: 'string' | null }
            uiSchema.type = 'select';
            uiSchema.wide = true;
            uiSchema.options = $8a1ef845025128c4$var$ionOptionsToUiOptions(ionFormField.options);
        }
    }
    // set a label as 'Optional' for supported optional element types
    if (ionFormField.required === false && $8a1ef845025128c4$var$optionalType.includes(uiSchema.type)) uiSchema.sublabel = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.form.field.optional', 'login');
    return uiSchema;
};


/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $ccb0ea18819b8e99$var$UISchemaHandlers = {
    string: (0, $8a1ef845025128c4$export$2e2bcd8739ae039),
    boolean: (0, $17a13147b004a486$export$2e2bcd8739ae039),
    object: (0, $899ec74c77d1bd7c$export$2e2bcd8739ae039)
};
/**
 *
 * @param {AuthResult} transformedResp
 * @param {IONForm} remeditationForm
 */ const $ccb0ea18819b8e99$var$createUISchema = (transformedResp, remediationForm, settings)=>{
    // For cases where field itself is a form, it has a formname and we are appending the formname to each field.
    // Sort of flat the structure in order to align Courage flatten Model. The flatten structure will be converted
    // back to object hierarchy through `Model.toJSON`.
    // For simplicity we are assuming that when field itself is a form its only one level deep.
    const remediationValue = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).chain(remediationForm.value || []).filter((v)=>v.visible !== false).map((v)=>{
        var _v$value;
        let nestedForm;
        if (v.form) nestedForm = v.form;
        else if ((_v$value = v.value) !== null && _v$value !== void 0 && _v$value.form) nestedForm = v.value.form;
        if (nestedForm) {
            const inputGroupName = v.name;
            return nestedForm.value.map((input)=>{
                return Object.assign({}, input, {
                    name: inputGroupName + '.' + input.name
                });
            });
        } else return v;
    }).flatten().value();
    return remediationValue.map((ionFormField)=>{
        const uiSchemaDefaultConfig = {
            'label-top': true,
            'multirowError': true,
            'data-se': `o-form-fieldset-${ionFormField.name}`
        };
        const fieldType = ionFormField.type || 'string';
        const uiSchemaHandler = $ccb0ea18819b8e99$var$UISchemaHandlers[fieldType];
        const uiSchemaResult = uiSchemaHandler(ionFormField, remediationForm, transformedResp, $ccb0ea18819b8e99$var$createUISchema, settings);
        return Object.assign({}, ionFormField, uiSchemaDefaultConfig, uiSchemaResult);
    });
};
/**
 *
 * @param {AuthResult} transformedResp
 */ const $ccb0ea18819b8e99$export$2e2bcd8739ae039 = (settings, transformedResp)=>{
    if (transformedResp) transformedResp.remediations = transformedResp.remediations.map((obj)=>{
        obj.uiSchema = $ccb0ea18819b8e99$var$createUISchema(transformedResp, obj, settings);
        return obj;
    });
    return transformedResp;
};





















/*!
 * Copyright (c) 2022-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ /**
 * WebAuthn displayName constants for passkeys rebranding
 */ const $bdb5e1755e68f0a9$export$cdc5fb53a78b4796 = {
    DEFAULT: 'Security Key or Biometric',
    PASSKEYS: 'Passkeys'
};
// IDX form/step name for the passkey promotion remediation. Defined here (rather
// than only in the engine-specific RemediationConstants / IDX_STEP) so v1, v2, and
// v3 can share promotion checks without cross-engine imports.
const $bdb5e1755e68f0a9$export$ba74cbc4dbc8b026 = 'enroll-authenticator-promotion';
/**
 * Variant key mapping for i18n keys with DEFAULT/PASSKEYS/CUSTOM variants
 */ /**
 * i18n key mappings based on context and displayName
 * Organized by keys that have variants vs static keys
 */ const $bdb5e1755e68f0a9$export$af759845ef57c7cc = {
    // Keys with displayName variants (DEFAULT, PASSKEYS, CUSTOM)
    ENROLL_TITLE: {
        DEFAULT: 'oie.enroll.webauthn.title',
        PASSKEYS: 'oie.enroll.webauthn.passkeysRebrand.passkeys.title',
        CUSTOM: 'oie.enroll.webauthn.passkeysRebrand.custom.title'
    },
    VERIFY_TITLE: {
        DEFAULT: 'oie.verify.webauth.title',
        PASSKEYS: 'oie.verify.webauth.passkeysRebrand.passkeys.title',
        CUSTOM: 'oie.verify.webauth.passkeysRebrand.custom.title'
    },
    DESCRIPTION: {
        DEFAULT: 'oie.webauthn.description',
        PASSKEYS: 'oie.webauthn.passkeysRebrand.passkeys.description',
        CUSTOM: 'oie.webauthn.description' // Falls back to DEFAULT for custom
    },
    SELECT_ENROLL_LABEL: {
        DEFAULT: 'oie.select.authenticator.enroll.webauthn.label',
        PASSKEYS: 'oie.select.authenticator.enroll.webauthn.passkeysRebrand.passkeys.label',
        CUSTOM: 'oie.select.authenticator.enroll.webauthn.passkeysRebrand.custom.label'
    },
    SELECT_VERIFY_LABEL: {
        DEFAULT: 'oie.select.authenticator.verify.webauthn.label',
        PASSKEYS: 'oie.select.authenticator.verify.webauthn.passkeysRebrand.passkeys.label',
        CUSTOM: 'oie.select.authenticator.verify.webauthn.passkeysRebrand.custom.label'
    },
    LABEL: {
        DEFAULT: 'oie.webauthn.label',
        PASSKEYS: 'oie.webauthn.passkeysRebrand.passkeys.label',
        CUSTOM: 'oie.webauthn.label' // Falls back to DEFAULT for custom
    },
    ENROLL_INSTRUCTIONS: {
        DEFAULT: 'oie.enroll.webauthn.instructions',
        PASSKEYS: 'oie.enroll.webauthn.passkeysRebrand.instructions',
        CUSTOM: 'oie.enroll.webauthn.passkeysRebrand.instructions'
    },
    VERIFY_INSTRUCTIONS: {
        DEFAULT: 'oie.verify.webauthn.instructions',
        PASSKEYS: 'oie.verify.webauthn.passkeysRebrand.instructions',
        CUSTOM: 'oie.verify.webauthn.passkeysRebrand.instructions'
    }
};
/**
 * Checks if displayName is a custom value (not DEFAULT, not PASSKEYS)
 */ const $bdb5e1755e68f0a9$export$9d3e336c57817b37 = (displayName)=>{
    return Boolean(displayName && displayName !== $bdb5e1755e68f0a9$export$cdc5fb53a78b4796.DEFAULT && displayName !== $bdb5e1755e68f0a9$export$cdc5fb53a78b4796.PASSKEYS);
};
/**
 * Determines which i18n key to use based on displayName
 * Handles both variant key maps (objects with DEFAULT/PASSKEYS/CUSTOM)
 * and static keys (strings)
 */ const $bdb5e1755e68f0a9$export$9748196cbdf7dd9e = (keyMap, displayName)=>{
    // Handle static string keys (no variant)
    if (typeof keyMap === 'string') return keyMap;
    // Validate keyMap is an object
    if (!keyMap || typeof keyMap !== 'object') return null;
    // Check for exact PASSKEYS match
    if (displayName === $bdb5e1755e68f0a9$export$cdc5fb53a78b4796.PASSKEYS && keyMap.PASSKEYS) return keyMap.PASSKEYS;
    // Check for CUSTOM displayName
    if ($bdb5e1755e68f0a9$export$9d3e336c57817b37(displayName) && keyMap.CUSTOM) return keyMap.CUSTOM;
    // Fallback to DEFAULT
    return keyMap.DEFAULT || null;
};
/**
 * Gets parameters for i18n string replacement (for CUSTOM case)
 */ const $bdb5e1755e68f0a9$export$e9be60f27f2206f9 = (displayName)=>{
    if ($bdb5e1755e68f0a9$export$9d3e336c57817b37(displayName) && displayName) return [
        displayName
    ];
    return [];
};
/**
 * True when the current remediation is `enroll-authenticator-promotion` AND the
 * authenticator displayName is `Passkeys`. Only in this case do the promotion
 * title/CTA/skip overrides apply — Security Key or Biometric (DEFAULT) and
 * Custom displayNames keep their standard copy even when served via promotion.
 */ const $bdb5e1755e68f0a9$export$b2165307d0329b71 = (stepName, displayName)=>stepName === $bdb5e1755e68f0a9$export$ba74cbc4dbc8b026 && displayName === $bdb5e1755e68f0a9$export$cdc5fb53a78b4796.PASSKEYS;
/**
 * True when the enroll UI should render the passkey splash (illustration + FAQ) —
 * for `Passkeys` or any custom displayName on either enroll remediation. The
 * DEFAULT displayName keeps the classic instruction line only.
 */ const $bdb5e1755e68f0a9$export$ee717b9fcb545a37 = (displayName)=>displayName === $bdb5e1755e68f0a9$export$cdc5fb53a78b4796.PASSKEYS || $bdb5e1755e68f0a9$export$9d3e336c57817b37(displayName);


/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const { getPasswordComplexityDescriptionForHtmlList: $3ddabee037f3f019$export$dece28d6748bc497 } = (0, $020a58caf88b7504$export$2e2bcd8739ae039);
/**
 * Gets the WebAuthn title for enroll or verify views
 * @param {Object} currentViewState - The current view state (remediation object)
 * @param {boolean} isVerify - Whether this is a verify (challenge) flow or enroll flow
 * @returns {string} - The localized title
 */ const $3ddabee037f3f019$export$e0dd63b41f3f2431 = (currentViewState, isVerify = false)=>{
    var _currentViewState$rel, _currentViewState$rel2;
    const displayName = currentViewState === null || currentViewState === void 0 ? void 0 : (_currentViewState$rel = currentViewState.relatesTo) === null || _currentViewState$rel === void 0 ? void 0 : (_currentViewState$rel2 = _currentViewState$rel.value) === null || _currentViewState$rel2 === void 0 ? void 0 : _currentViewState$rel2.displayName;
    const params = (0, $bdb5e1755e68f0a9$export$e9be60f27f2206f9)(displayName);
    const keyMap = isVerify ? (0, $bdb5e1755e68f0a9$export$af759845ef57c7cc).VERIFY_TITLE : (0, $bdb5e1755e68f0a9$export$af759845ef57c7cc).ENROLL_TITLE;
    const titleKey = (0, $bdb5e1755e68f0a9$export$9748196cbdf7dd9e)(keyMap, displayName);
    return (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)(titleKey, 'login', params);
};
/**
 * Gets the WebAuthn description configuration for select-authenticator
 * @param {Object} authenticator - The authenticator object
 * @param {string} displayName - The displayName from IDX response
 * @param {boolean} isVerifyAuthenticator - Whether this is verify flow
 * @returns {string} - The localized description
 */ const $3ddabee037f3f019$var$getWebAuthnDescriptionConfig = (authenticator, displayName, isVerifyAuthenticator)=>{
    if (isVerifyAuthenticator) return '';
    if ((0, $bdb5e1755e68f0a9$export$9d3e336c57817b37)(displayName)) {
        var _authenticator$relate;
        const customDescription = (_authenticator$relate = authenticator.relatesTo) === null || _authenticator$relate === void 0 ? void 0 : _authenticator$relate.description;
        if (customDescription) // Use raw custom description from relatesTo if available
        return customDescription;
        // Fall back to DEFAULT description for custom case without custom description
        const descriptionKey = (0, $bdb5e1755e68f0a9$export$9748196cbdf7dd9e)((0, $bdb5e1755e68f0a9$export$af759845ef57c7cc).DESCRIPTION, (0, $bdb5e1755e68f0a9$export$cdc5fb53a78b4796).DEFAULT);
        return (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)(descriptionKey, 'login');
    }
    // For DEFAULT and PASSKEYS cases
    const params = [];
    const descriptionKey = (0, $bdb5e1755e68f0a9$export$9748196cbdf7dd9e)((0, $bdb5e1755e68f0a9$export$af759845ef57c7cc).DESCRIPTION, displayName);
    return (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)(descriptionKey, 'login', params);
};
/**
 * Returns the description to display in the additional instructions if present
 * @param {Object} currentViewState - The current view state (remediation object)
 * @returns {string|null} - Returns the description if should display, null otherwise
 */ const $3ddabee037f3f019$export$d64be9dcd88e405b = (currentViewState)=>{
    var _currentViewState$rel3, _currentViewState$rel4;
    const description = currentViewState === null || currentViewState === void 0 ? void 0 : (_currentViewState$rel3 = currentViewState.relatesTo) === null || _currentViewState$rel3 === void 0 ? void 0 : (_currentViewState$rel4 = _currentViewState$rel3.value) === null || _currentViewState$rel4 === void 0 ? void 0 : _currentViewState$rel4.description;
    return description || null;
};
const $3ddabee037f3f019$var$getButtonDataSeAttr = function(authenticator) {
    if (authenticator.authenticatorKey) {
        var _authenticator$value, _authenticator$value2;
        const method = (_authenticator$value = authenticator.value) !== null && _authenticator$value !== void 0 && _authenticator$value.methodType ? '-' + ((_authenticator$value2 = authenticator.value) === null || _authenticator$value2 === void 0 ? void 0 : _authenticator$value2.methodType) : '';
        return authenticator.authenticatorKey + method;
    }
    return '';
};
/* eslint complexity: [0, 0], max-statements: [2, 34] */ const $3ddabee037f3f019$var$getAuthenticatorData = function(authenticator, isVerifyAuthenticator) {
    var _authenticator$relate2, _authenticator$relate3, _authenticator$relate4, _authenticator$relate5, _authenticator$relate6, _authenticator$relate7, _authenticator$relate8, _authenticator$relate9, _authenticator$relate10, _authenticator$value3;
    const authenticatorKey = authenticator.authenticatorKey;
    const key = (0, $187365f460a6e3ed$export$2e2bcd8739ae039).isString(authenticatorKey) ? authenticatorKey.toLowerCase() : '';
    let authenticatorData = {};
    let nicknameText = isVerifyAuthenticator ? (_authenticator$relate2 = authenticator.relatesTo) === null || _authenticator$relate2 === void 0 ? void 0 : _authenticator$relate2.nickname : undefined;
    switch(key){
        case (0, $4a07c2817278db15$export$a7895cc4b0944d1b).EMAIL:
            Object.assign(authenticatorData, {
                description: isVerifyAuthenticator ? ((_authenticator$relate3 = authenticator.relatesTo) === null || _authenticator$relate3 === void 0 ? void 0 : (_authenticator$relate4 = _authenticator$relate3.profile) === null || _authenticator$relate4 === void 0 ? void 0 : _authenticator$relate4.email) || '' : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.email.authenticator.description', 'login'),
                iconClassName: 'mfa-okta-email',
                noTranslateClassName: isVerifyAuthenticator ? 'no-translate' : '',
                buttonDataSeAttr: $3ddabee037f3f019$var$getButtonDataSeAttr(authenticator),
                ariaLabel: isVerifyAuthenticator ? $3ddabee037f3f019$export$20de5958db75cd61((_authenticator$relate5 = authenticator.relatesTo) === null || _authenticator$relate5 === void 0 ? void 0 : (_authenticator$relate6 = _authenticator$relate5.profile) === null || _authenticator$relate6 === void 0 ? void 0 : _authenticator$relate6.email) : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.enroll.email.label', 'login')
            });
            break;
        case (0, $4a07c2817278db15$export$a7895cc4b0944d1b).PASSWORD:
            Object.assign(authenticatorData, {
                description: isVerifyAuthenticator ? '' : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.password.authenticator.description', 'login'),
                iconClassName: 'mfa-okta-password',
                buttonDataSeAttr: $3ddabee037f3f019$var$getButtonDataSeAttr(authenticator),
                ariaLabel: isVerifyAuthenticator ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.verify.password.label', 'login') : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.enroll.password.label', 'login')
            });
            break;
        case (0, $4a07c2817278db15$export$a7895cc4b0944d1b).PHONE:
            Object.assign(authenticatorData, {
                nickname: nicknameText,
                description: isVerifyAuthenticator ? (_authenticator$relate7 = authenticator.relatesTo) === null || _authenticator$relate7 === void 0 ? void 0 : (_authenticator$relate8 = _authenticator$relate7.profile) === null || _authenticator$relate8 === void 0 ? void 0 : _authenticator$relate8.phoneNumber : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.phone.authenticator.description', 'login'),
                iconClassName: 'mfa-okta-phone',
                noTranslateClassName: isVerifyAuthenticator ? 'no-translate' : '',
                buttonDataSeAttr: $3ddabee037f3f019$var$getButtonDataSeAttr(authenticator),
                ariaLabel: isVerifyAuthenticator ? $3ddabee037f3f019$export$c087f94c0ef43226((_authenticator$relate9 = authenticator.relatesTo) === null || _authenticator$relate9 === void 0 ? void 0 : (_authenticator$relate10 = _authenticator$relate9.profile) === null || _authenticator$relate10 === void 0 ? void 0 : _authenticator$relate10.phoneNumber) : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.enroll.phone.label', 'login')
            });
            break;
        case (0, $4a07c2817278db15$export$a7895cc4b0944d1b).SECURITY_QUESTION:
            Object.assign(authenticatorData, {
                description: isVerifyAuthenticator ? '' : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.security.question.authenticator.description', 'login'),
                iconClassName: 'mfa-okta-security-question',
                buttonDataSeAttr: $3ddabee037f3f019$var$getButtonDataSeAttr(authenticator),
                ariaLabel: isVerifyAuthenticator ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.verify.security.question.label', 'login') : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.enroll.security.question.label', 'login')
            });
            break;
        case (0, $4a07c2817278db15$export$a7895cc4b0944d1b).WEBAUTHN:
            {
                var _authenticator$relate11;
                const displayName = (_authenticator$relate11 = authenticator.relatesTo) === null || _authenticator$relate11 === void 0 ? void 0 : _authenticator$relate11.displayName;
                const params = (0, $bdb5e1755e68f0a9$export$e9be60f27f2206f9)(displayName);
                const description = $3ddabee037f3f019$var$getWebAuthnDescriptionConfig(authenticator, displayName, isVerifyAuthenticator);
                // Use passkeys icon when displayName is "Passkeys"
                const iconClassName = displayName === (0, $bdb5e1755e68f0a9$export$cdc5fb53a78b4796).PASSKEYS ? 'mfa-passkeys' : 'mfa-webauthn';
                const labelKey = isVerifyAuthenticator ? (0, $bdb5e1755e68f0a9$export$9748196cbdf7dd9e)((0, $bdb5e1755e68f0a9$export$af759845ef57c7cc).SELECT_VERIFY_LABEL, displayName) : (0, $bdb5e1755e68f0a9$export$9748196cbdf7dd9e)((0, $bdb5e1755e68f0a9$export$af759845ef57c7cc).SELECT_ENROLL_LABEL, displayName);
                Object.assign(authenticatorData, {
                    description: description,
                    iconClassName: iconClassName,
                    buttonDataSeAttr: $3ddabee037f3f019$var$getButtonDataSeAttr(authenticator),
                    ariaLabel: (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)(labelKey, 'login', params)
                });
                break;
            }
        case (0, $4a07c2817278db15$export$a7895cc4b0944d1b).OV:
            Object.assign(authenticatorData, {
                description: isVerifyAuthenticator ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.okta_verify.label', 'login') : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.okta_verify.authenticator.description', 'login'),
                iconClassName: 'mfa-okta-verify',
                buttonDataSeAttr: $3ddabee037f3f019$var$getButtonDataSeAttr(authenticator),
                ariaLabel: $3ddabee037f3f019$export$ea9db60647b560b2(isVerifyAuthenticator, authenticator === null || authenticator === void 0 ? void 0 : (_authenticator$value3 = authenticator.value) === null || _authenticator$value3 === void 0 ? void 0 : _authenticator$value3.methodType)
            });
            break;
        case (0, $4a07c2817278db15$export$a7895cc4b0944d1b).GOOGLE_OTP:
            Object.assign(authenticatorData, {
                description: isVerifyAuthenticator ? '' : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.google_authenticator.authenticator.description', 'login'),
                iconClassName: 'mfa-google-auth',
                buttonDataSeAttr: $3ddabee037f3f019$var$getButtonDataSeAttr(authenticator),
                ariaLabel: isVerifyAuthenticator ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.verify.named.authenticator.label', 'login', [
                    authenticator.label
                ]) : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [
                    authenticator.label
                ])
            });
            break;
        case (0, $4a07c2817278db15$export$a7895cc4b0944d1b).ON_PREM:
            {
                var _authenticator$relate12;
                const vendorName = ((_authenticator$relate12 = authenticator.relatesTo) === null || _authenticator$relate12 === void 0 ? void 0 : _authenticator$relate12.displayName) || (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.on_prem.authenticator.default.vendorName', 'login');
                Object.assign(authenticatorData, {
                    description: isVerifyAuthenticator ? '' : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.on_prem.authenticator.description', 'login', [
                        vendorName
                    ]),
                    iconClassName: 'mfa-onprem',
                    buttonDataSeAttr: $3ddabee037f3f019$var$getButtonDataSeAttr(authenticator),
                    ariaLabel: isVerifyAuthenticator ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.verify.named.authenticator.label', 'login', [
                        authenticator.label
                    ]) : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [
                        authenticator.label
                    ])
                });
                break;
            }
        case (0, $4a07c2817278db15$export$a7895cc4b0944d1b).RSA:
            Object.assign(authenticatorData, {
                description: isVerifyAuthenticator ? '' : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.rsa.authenticator.description', 'login'),
                iconClassName: 'mfa-rsa',
                buttonDataSeAttr: $3ddabee037f3f019$var$getButtonDataSeAttr(authenticator),
                ariaLabel: isVerifyAuthenticator ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.verify.named.authenticator.label', 'login', [
                    authenticator.label
                ]) : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [
                    authenticator.label
                ])
            });
            break;
        case (0, $4a07c2817278db15$export$a7895cc4b0944d1b).DUO:
            Object.assign(authenticatorData, {
                description: isVerifyAuthenticator ? '' : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.duo.authenticator.description', 'login'),
                iconClassName: 'mfa-duo',
                buttonDataSeAttr: $3ddabee037f3f019$var$getButtonDataSeAttr(authenticator),
                ariaLabel: isVerifyAuthenticator ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.verify.named.authenticator.label', 'login', [
                    authenticator.label
                ]) : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [
                    authenticator.label
                ])
            });
            break;
        case (0, $4a07c2817278db15$export$a7895cc4b0944d1b).IDP:
            {
                var _authenticator$relate13, _authenticator$relate14;
                const idpName = (_authenticator$relate13 = authenticator.relatesTo) === null || _authenticator$relate13 === void 0 ? void 0 : _authenticator$relate13.displayName;
                Object.assign(authenticatorData, {
                    description: isVerifyAuthenticator ? '' : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.idp.authenticator.description', 'login', [
                        idpName
                    ]),
                    iconClassName: 'mfa-custom-factor',
                    buttonDataSeAttr: $3ddabee037f3f019$var$getButtonDataSeAttr(authenticator),
                    logoUri: (authenticator === null || authenticator === void 0 ? void 0 : (_authenticator$relate14 = authenticator.relatesTo) === null || _authenticator$relate14 === void 0 ? void 0 : _authenticator$relate14.logoUri) || '',
                    ariaLabel: isVerifyAuthenticator ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.verify.named.authenticator.label', 'login', [
                        authenticator.label
                    ]) : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [
                        authenticator.label
                    ])
                });
                break;
            }
        case (0, $4a07c2817278db15$export$a7895cc4b0944d1b).CUSTOM_OTP:
            Object.assign(authenticatorData, {
                description: isVerifyAuthenticator ? '' : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.custom_otp.description', 'login'),
                iconClassName: 'mfa-hotp',
                buttonDataSeAttr: $3ddabee037f3f019$var$getButtonDataSeAttr(authenticator),
                ariaLabel: isVerifyAuthenticator ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.verify.named.authenticator.label', 'login', [
                    authenticator.label
                ]) : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [
                    authenticator.label
                ])
            });
            break;
        case (0, $4a07c2817278db15$export$a7895cc4b0944d1b).SYMANTEC_VIP:
            {
                var _authenticator$relate15;
                const appName = (_authenticator$relate15 = authenticator.relatesTo) === null || _authenticator$relate15 === void 0 ? void 0 : _authenticator$relate15.displayName;
                Object.assign(authenticatorData, {
                    description: isVerifyAuthenticator ? '' : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.symantecVip.authenticator.description', 'login', [
                        appName
                    ]),
                    iconClassName: 'mfa-symantec',
                    buttonDataSeAttr: $3ddabee037f3f019$var$getButtonDataSeAttr(authenticator),
                    ariaLabel: isVerifyAuthenticator ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.verify.named.authenticator.label', 'login', [
                        authenticator.label
                    ]) : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [
                        authenticator.label
                    ])
                });
                break;
            }
        case (0, $4a07c2817278db15$export$a7895cc4b0944d1b).YUBIKEY:
            Object.assign(authenticatorData, {
                description: isVerifyAuthenticator ? '' : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.yubikey.authenticator.description', 'login'),
                iconClassName: 'mfa-yubikey',
                buttonDataSeAttr: $3ddabee037f3f019$var$getButtonDataSeAttr(authenticator),
                ariaLabel: isVerifyAuthenticator ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.verify.named.authenticator.label', 'login', [
                    authenticator.label
                ]) : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [
                    authenticator.label
                ])
            });
            break;
        case (0, $4a07c2817278db15$export$a7895cc4b0944d1b).CUSTOM_APP:
            var _authenticator$relate16, _authenticator$relate17, _authenticator$relate18;
            Object.assign(authenticatorData, {
                description: isVerifyAuthenticator ? authenticator === null || authenticator === void 0 ? void 0 : (_authenticator$relate16 = authenticator.relatesTo) === null || _authenticator$relate16 === void 0 ? void 0 : _authenticator$relate16.displayName : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.custom.app.authenticator.description', 'login', [
                    authenticator.label
                ]),
                noTranslateClassName: isVerifyAuthenticator ? 'no-translate' : '',
                buttonDataSeAttr: $3ddabee037f3f019$var$getButtonDataSeAttr(authenticator),
                iconClassName: 'mfa-custom-app-logo',
                logoUri: (authenticator === null || authenticator === void 0 ? void 0 : (_authenticator$relate17 = authenticator.relatesTo) === null || _authenticator$relate17 === void 0 ? void 0 : _authenticator$relate17.logoUri) || '',
                ariaLabel: isVerifyAuthenticator ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.verify.named.authenticator.label', 'login', [
                    authenticator === null || authenticator === void 0 ? void 0 : (_authenticator$relate18 = authenticator.relatesTo) === null || _authenticator$relate18 === void 0 ? void 0 : _authenticator$relate18.displayName
                ]) : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [
                    authenticator.label
                ])
            });
            break;
        case (0, $4a07c2817278db15$export$a7895cc4b0944d1b).SMARTCARD:
            Object.assign(authenticatorData, {
                description: isVerifyAuthenticator ? '' : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.smartcard.authenticator.description', 'login'),
                iconClassName: 'mfa-smartcard',
                buttonDataSeAttr: $3ddabee037f3f019$var$getButtonDataSeAttr(authenticator),
                ariaLabel: isVerifyAuthenticator ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.verify.named.authenticator.label', 'login', [
                    authenticator.label
                ]) : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [
                    authenticator.label
                ])
            });
            break;
        case (0, $4a07c2817278db15$export$a7895cc4b0944d1b).TAC:
            Object.assign(authenticatorData, {
                // we don't expect the description in the else case to be displayed,
                // because TAC is not eligible for inline enrollment
                description: isVerifyAuthenticator ? '' : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.tac.authenticator.description', 'login'),
                iconClassName: 'mfa-tac',
                buttonDataSeAttr: $3ddabee037f3f019$var$getButtonDataSeAttr(authenticator),
                ariaLabel: isVerifyAuthenticator ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.verify.named.authenticator.label', 'login', [
                    authenticator.label
                ]) : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [
                    authenticator.label
                ])
            });
            break;
        case (0, $4a07c2817278db15$export$a7895cc4b0944d1b).NFC_PIN:
            Object.assign(authenticatorData, {
                description: isVerifyAuthenticator ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.nfc_pin.verify.description', 'login') : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.nfc_pin.authenticator.description', 'login'),
                iconClassName: 'mfa-nfc-pin',
                buttonDataSeAttr: $3ddabee037f3f019$var$getButtonDataSeAttr(authenticator),
                ariaLabel: isVerifyAuthenticator ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.verify.named.authenticator.label', 'login', [
                    authenticator.label
                ]) : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [
                    authenticator.label
                ])
            });
            break;
    }
    return authenticatorData;
};
const $3ddabee037f3f019$var$getIDProofingData = function(idvName) {
    let idProofingData = {};
    switch(idvName){
        case (0, $4a07c2817278db15$export$cd4bf62f61ca5ae1).IDV_PERSONA:
            idProofingData = {
                iconClassName: 'mfa-idv-persona'
            };
            break;
        case (0, $4a07c2817278db15$export$cd4bf62f61ca5ae1).IDV_CLEAR:
            idProofingData = {
                iconClassName: 'mfa-idv-clear'
            };
            break;
        case (0, $4a07c2817278db15$export$cd4bf62f61ca5ae1).IDV_INCODE:
            idProofingData = {
                iconClassName: 'mfa-idv-incode'
            };
            break;
        case (0, $4a07c2817278db15$export$cd4bf62f61ca5ae1).IDV_STANDARD:
            idProofingData = {
                iconClassName: 'mfa-idv-standard'
            };
            break;
        case (0, $4a07c2817278db15$export$cd4bf62f61ca5ae1).IDV_OIN:
            idProofingData = {
                iconClassName: 'mfa-idv-oin'
            };
            break;
    }
    return idProofingData;
};
function $3ddabee037f3f019$export$20de5958db75cd61(email) {
    return email ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.verify.email.with.email.label', 'login', [
        email
    ]) : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.verify.email.label', 'login');
}
function $3ddabee037f3f019$export$c087f94c0ef43226(phone) {
    return phone ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.verify.phone.with.phone.label', 'login', [
        phone
    ]) : (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.verify.phone.label', 'login');
}
function $3ddabee037f3f019$export$ea9db60647b560b2(isVerify, methodType) {
    if (!isVerify) return (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.enroll.okta_verify.authenticator.label', 'login');
    const defaultLabel = (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.verify.okta_verify.label', 'login');
    if (typeof methodType === 'undefined') return defaultLabel;
    const methodTypeLabelMap = {
        push: (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.okta_verify.push.label', 'login'),
        totp: (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.okta_verify.totp.label', 'login'),
        'signed_nonce': (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('oie.select.authenticator.okta_verify.signed_nonce.label', 'login')
    };
    return methodTypeLabelMap[methodType] || defaultLabel;
}
function $3ddabee037f3f019$export$62811b8ba2f1ade2(authenticator) {
    return $3ddabee037f3f019$var$getAuthenticatorData(authenticator);
}
function $3ddabee037f3f019$export$1681b06d00e0dc73(authenticator) {
    return $3ddabee037f3f019$var$getAuthenticatorData(authenticator, true);
}
function $3ddabee037f3f019$export$5b04e15b1e5a5626(authenticatorKey, idvName, displayName) {
    // Handle WebAuthn with Passkeys displayName
    if (authenticatorKey === (0, $4a07c2817278db15$export$a7895cc4b0944d1b).WEBAUTHN && displayName === (0, $bdb5e1755e68f0a9$export$cdc5fb53a78b4796).PASSKEYS) return 'mfa-passkeys';
    return $3ddabee037f3f019$var$getAuthenticatorData({
        authenticatorKey: authenticatorKey
    }).iconClassName || $3ddabee037f3f019$var$getIDProofingData(idvName).iconClassName;
}
function $3ddabee037f3f019$export$311594212e8d66ce(errorJSON) {
    var _errorJSON$errorCause;
    if (((_errorJSON$errorCause = errorJSON.errorCauses) === null || _errorJSON$errorCause === void 0 ? void 0 : _errorJSON$errorCause.length) > 0 && Array.isArray(errorJSON.errorCauses[0].errorSummary) && errorJSON.errorCauses[0].errorSummary.length > 0) {
        var _errorJSON$errorCause2;
        // Change from Array to string for all errors.
        errorJSON.errorCauses[0].errorSummary = errorJSON.errorCauses[0].errorSummary[0];
        // Overrides for particular error messages.
        const errorKey = ((_errorJSON$errorCause2 = errorJSON.errorCauses[0].errorKey) === null || _errorJSON$errorCause2 === void 0 ? void 0 : _errorJSON$errorCause2.length) > 0 && errorJSON.errorCauses[0].errorKey[0];
        // Remove the requirements string only if this is requirements were not met error.
        if (errorKey === 'password.passwordRequirementsNotMet') errorJSON.errorCauses[0].errorSummary = (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)('registration.error.password.passwordRequirementsNotMet', 'login');
    }
    return errorJSON;
}
/**
 * Get authenticator display name from {@code remediation}.
 *
 * @param {Object} remediation
 */ function $3ddabee037f3f019$export$c8e5d116c70cd63f(remediation) {
    var _remediation$relatesT, _remediation$relatesT2;
    return (_remediation$relatesT = remediation.relatesTo) === null || _remediation$relatesT === void 0 ? void 0 : (_remediation$relatesT2 = _remediation$relatesT.value) === null || _remediation$relatesT2 === void 0 ? void 0 : _remediation$relatesT2.displayName;
}




const $3f6049cd47f7c928$export$699b8df303cdca6 = {
    /**
   * Mapping fields in the enroll profile remediation form to their i18n label for localization.
   */ 'enroll-profile.userProfile.login': 'oie.user.profile.login',
    'enroll-profile.userProfile.lastName': 'oie.user.profile.lastname',
    'enroll-profile.userProfile.firstName': 'oie.user.profile.firstname',
    'enroll-profile.userProfile.email': 'oie.user.profile.primary.email',
    'enroll-profile.userProfile.secondEmail': 'oie.user.profile.secondary.email',
    'enroll-profile.userProfile.middleName': 'oie.user.profile.middleName',
    'enroll-profile.userProfile.honorificPrefix': 'oie.user.profile.honorificPrefix',
    'enroll-profile.userProfile.honorificSuffix': 'oie.user.profile.honorificSuffix',
    'enroll-profile.userProfile.title': 'oie.user.profile.title',
    'enroll-profile.userProfile.displayName': 'oie.user.profile.displayName',
    'enroll-profile.userProfile.nickName': 'oie.user.profile.nickName',
    'enroll-profile.userProfile.profileUrl': 'oie.user.profile.profileUrl',
    'enroll-profile.userProfile.mobilePhone': 'oie.user.profile.mobilePhone',
    'enroll-profile.userProfile.primaryPhone': 'oie.user.profile.primaryPhone',
    'enroll-profile.userProfile.streetAddress': 'oie.user.profile.streetAddress',
    'enroll-profile.userProfile.city': 'oie.user.profile.city',
    'enroll-profile.userProfile.state': 'oie.user.profile.state',
    'enroll-profile.userProfile.zipCode': 'oie.user.profile.zipCode',
    'enroll-profile.userProfile.postalCode': 'oie.user.profile.postalCode',
    'enroll-profile.userProfile.countryCode': 'oie.user.profile.countryCode',
    'enroll-profile.userProfile.postalAddress': 'oie.user.profile.postalAddress',
    'enroll-profile.userProfile.preferredLanguage': 'oie.user.profile.preferredLanguage',
    'enroll-profile.userProfile.locale': 'oie.user.profile.locale',
    'enroll-profile.userProfile.timezone': 'oie.user.profile.timezone',
    'enroll-profile.userProfile.userType': 'oie.user.profile.userType',
    'enroll-profile.userProfile.employeeNumber': 'oie.user.profile.employeeNumber',
    'enroll-profile.userProfile.costCenter': 'oie.user.profile.costCenter',
    'enroll-profile.userProfile.organization': 'oie.user.profile.organization',
    'enroll-profile.userProfile.division': 'oie.user.profile.division',
    'enroll-profile.userProfile.department': 'oie.user.profile.department',
    'enroll-profile.userProfile.managerId': 'oie.user.profile.managerId',
    'enroll-profile.userProfile.manager': 'oie.user.profile.manager',
    'enroll-profile.credentials.passcode': 'oie.password.label'
};


/* eslint-disable max-len */ const $93a83f6fd41fc21e$var$WEBAUTHN_API_GENERIC_ERROR_KEY = 'authfactor.webauthn.error';
const $93a83f6fd41fc21e$var$PASSKEYS_WEBAUTHN_API_GENERIC_ERROR_KEY = 'passkeys.authfactor.webauthn.error';
const $93a83f6fd41fc21e$var$DEVICE_ASSURANCE_CUSTOM_REMEDIATION_I18N_KEY_PREFIX = 'device.assurance.custom.remediation.';
const $93a83f6fd41fc21e$var$WEBAUTHN_LABEL_KEY = 'oie.webauthn.label';
const $93a83f6fd41fc21e$var$SECURITY_QUESTION_PREFIXES = [
    'enroll-authenticator.security_question.credentials.questionKey.',
    'challenge-authenticator.security_question.credentials.questionKey.'
];
const $93a83f6fd41fc21e$var$I18N_OVERRIDE_MAPPINGS = {
    'identify.identifier': 'primaryauth.username.placeholder',
    'select-authenticator-unlock-account.identifier': 'primaryauth.username.placeholder',
    'unlock-account.identifier': 'primaryauth.username.placeholder',
    'identify.credentials.passcode': 'primaryauth.password.placeholder',
    'identify.rememberMe': 'oie.remember',
    'enroll-profile.userProfile.rememberMe': 'oie.remember',
    'identify-recovery.identifier': 'password.forgot.email.or.username.placeholder',
    'select-authenticator-enroll.authenticator.duo': 'factor.duo',
    'select-authenticator-enroll.authenticator.google_otp': 'oie.google_authenticator.label',
    'select-authenticator-enroll.authenticator.okta_email': 'oie.email.label',
    'select-authenticator-enroll.authenticator.okta_password': 'oie.password.label',
    'select-authenticator-enroll.authenticator.okta_verify': 'oie.okta_verify.label',
    'select-authenticator-enroll.authenticator.phone_number': 'oie.phone.label',
    'select-authenticator-enroll.authenticator.rsa_token': 'factor.totpHard.rsaSecurId',
    'select-authenticator-enroll.authenticator.security_question': 'oie.security.question.label',
    'select-authenticator-enroll.authenticator.symantec_vip': 'factor.totpHard.symantecVip',
    'select-authenticator-enroll.authenticator.webauthn': $93a83f6fd41fc21e$var$WEBAUTHN_LABEL_KEY,
    'select-authenticator-enroll.authenticator.yubikey_token': 'oie.yubikey.label',
    'select-authenticator-authenticate.authenticator.duo': 'factor.duo',
    'select-authenticator-authenticate.authenticator.google_otp': 'oie.google_authenticator.label',
    'select-authenticator-authenticate.authenticator.okta_email': 'oie.email.label',
    'select-authenticator-authenticate.authenticator.okta_password': 'oie.password.label',
    'select-authenticator-authenticate.authenticator.okta_verify.push': 'oie.okta_verify.push.title',
    'select-authenticator-authenticate.authenticator.okta_verify.signed_nonce': 'oie.okta_verify.signed_nonce.label',
    'select-authenticator-authenticate.authenticator.okta_verify.totp': 'oie.okta_verify.totp.title',
    'select-authenticator-authenticate.authenticator.phone_number': 'oie.phone.label',
    'select-authenticator-authenticate.authenticator.rsa_token': 'factor.totpHard.rsaSecurId',
    'select-authenticator-authenticate.authenticator.security_question': 'oie.security.question.label',
    'select-authenticator-authenticate.authenticator.symantec_vip': 'factor.totpHard.symantecVip',
    'select-authenticator-authenticate.authenticator.webauthn': $93a83f6fd41fc21e$var$WEBAUTHN_LABEL_KEY,
    'select-authenticator-authenticate.authenticator.yubikey_token': 'oie.yubikey.label',
    'select-authenticator-authenticate.authenticator.custom_app': 'oie.custom.app.authenticator.title',
    'select-authenticator-authenticate.authenticator.tac': 'oie.tac.label',
    'select-authenticator-unlock-account.authenticator.okta_email': 'oie.email.label',
    'select-authenticator-unlock-account.authenticator.phone_number': 'oie.phone.label',
    'select-authenticator-unlock-account.authenticator.okta_verify.push': 'oie.okta_verify.push.title',
    'authenticator-verification-data.okta_verify.authenticator.methodType.signed_nonce': 'oie.okta_verify.signed_nonce.label',
    'authenticator-verification-data.okta_verify.authenticator.methodType.push': 'oie.okta_verify.push.title',
    'authenticator-verification-data.okta_verify.authenticator.methodType.totp': 'oie.okta_verify.totp.title',
    'authenticator-enrollment-data.phone_number.authenticator.phoneNumber': 'mfa.phoneNumber.placeholder',
    'authenticator-enrollment-data.phone_number.authenticator.methodType.sms': 'oie.phone.enroll.sms.label',
    'authenticator-enrollment-data.phone_number.authenticator.methodType.voice': 'oie.phone.enroll.voice.label',
    'enroll-authenticator.okta_password.credentials.passcode': 'oie.password.passwordLabel',
    'enroll-authenticator.okta_email.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
    'enroll-authenticator.phone_number.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
    'enroll-authenticator.security_question.sub_schema_local_credentials.0': 'oie.security.question.questionKey.label',
    'enroll-authenticator.security_question.sub_schema_local_credentials.1': 'oie.security.question.createQuestion.label',
    'enroll-authenticator.security_question.credentials.answer': 'mfa.challenge.answer.placeholder',
    'enroll-authenticator.security_question.credentials.question': 'oie.security.question.createQuestion.label',
    'enroll-authenticator.security_question.credentials.questionKey': 'oie.security.question.questionKey.label',
    'enroll-authenticator.google_otp.credentials.passcode': 'oie.google_authenticator.otp.enterCodeText',
    'enroll-authenticator.onprem_mfa.credentials.clientData': 'enroll.onprem.username.placeholder',
    'enroll-authenticator.onprem_mfa.credentials.passcode': 'enroll.onprem.passcode.placeholder',
    'enroll-authenticator.rsa_token.credentials.clientData': 'enroll.onprem.username.placeholder',
    'enroll-authenticator.rsa_token.credentials.passcode': 'enroll.onprem.passcode.placeholder',
    'enroll-authenticator.symantec_vip.credentials.credentialId': 'enroll.symantecVip.credentialId.placeholder',
    'enroll-authenticator.symantec_vip.credentials.passcode': 'enroll.symantecVip.passcode1.placeholder',
    'enroll-authenticator.symantec_vip.credentials.nextPasscode': 'enroll.symantecVip.passcode2.placeholder',
    'enroll-authenticator.yubikey_token.credentials.passcode': 'oie.yubikey.passcode.label',
    'enrollment-channel-data.email': 'oie.enroll.okta_verify.channel.email.label',
    'enrollment-channel-data.phoneNumber': 'mfa.phoneNumber.placeholder',
    'select-enrollment-channel.authenticator.channel.qrcode': 'oie.enroll.okta_verify.select.channel.qrcode.label',
    'select-enrollment-channel.authenticator.channel.email': 'oie.enroll.okta_verify.select.channel.email.label',
    'select-enrollment-channel.authenticator.channel.sms': 'oie.enroll.okta_verify.select.channel.sms.label',
    'challenge-authenticator.okta_email.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
    'challenge-authenticator.okta_password.credentials.passcode': 'mfa.challenge.password.placeholder',
    'challenge-authenticator.phone_number.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
    'challenge-authenticator.security_question.credentials.answer': 'mfa.challenge.answer.placeholder',
    'challenge-authenticator.okta_verify.credentials.totp': 'oie.okta_verify.totp.enterCodeText',
    'challenge-authenticator.google_otp.credentials.passcode': 'oie.google_authenticator.otp.enterCodeText',
    'challenge-authenticator.onprem_mfa.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
    'challenge-authenticator.rsa_token.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
    'challenge-authenticator.custom_otp.credentials.passcode': 'oie.custom_otp.verify.passcode.label',
    'challenge-authenticator.symantec_vip.credentials.passcode': 'oie.symantecVip.verify.passcode.label',
    'challenge-authenticator.tac.credentials.passcode': 'oie.custom_otp.verify.passcode.label',
    'challenge-authenticator.yubikey_token.credentials.passcode': 'oie.yubikey.passcode.label',
    'challenge-authenticator.credentials.passcode': 'oie.password.label',
    'reset-authenticator.okta_password.credentials.passcode': 'oie.password.newPasswordLabel',
    'reset-authenticator.okta_password.confirmPassword': 'oie.password.confirmPasswordLabel',
    'reset-authenticator.okta_password.credentials.revokeSessions': 'password.reset.revokeSessions',
    'reenroll-authenticator.okta_password.credentials.passcode': 'oie.password.newPasswordLabel',
    'reenroll-authenticator.okta_password.confirmPassword': 'oie.password.confirmPasswordLabel',
    'reenroll-authenticator.okta_password.credentials.revokeSessions': 'password.reset.revokeSessions',
    'reenroll-authenticator-warning.okta_password.credentials.passcode': 'oie.password.newPasswordLabel',
    'reenroll-authenticator-warning.okta_password.confirmPassword': 'oie.password.confirmPasswordLabel',
    'reenroll-authenticator-warning.okta_password.credentials.revokeSessions': 'password.reset.revokeSessions',
    'enroll-authenticator.okta_password.confirmPassword': 'oie.password.confirmPasswordLabel',
    'enroll-authenticator.okta_password.credentials.revokeSessions': 'password.reset.revokeSessions',
    'incorrectPassword': 'oie.password.incorrect.message',
    'profile-update.userProfile.secondEmail': 'oie.user.profile.secondary.email',
    'user-code.userCode': 'device.code.activate.label',
    // Remap authn API errors to OIE
    'api.authn.poll.error.push_rejected': 'oktaverify.rejected',
    // Remap duo API errors to OIE
    'oie.authenticator.duo.method.duo.verification_timeout': 'oie.authenticator.duo.error',
    'oie.authenticator.duo.method.duo.verification_failed': 'oie.authenticator.duo.error',
    'idx.email.verification.required': 'registration.complete.confirm.text',
    'tooManyRequests': 'oie.tooManyRequests',
    'api.users.auth.error.POST_PASSWORD_UPDATE_AUTH_FAILURE': 'oie.post.password.update.auth.failure.error',
    'security.access_denied': 'errors.E0000006',
    'E0000009': 'errors.E0000009',
    'E0000020': 'errors.E0000020',
    'api.factors.error.sms.invalid_phone': 'oie.phone.invalid',
    'app.ldap.password.reset.failed': 'errors.E0000017',
    'oie.selfservice.unlock_user.challenge.failed.permissions': 'errors.E0000006',
    'core.auth.factor.signedNonce.error.invalidEnrollment': 'core.auth.factor.signedNonce.error',
    'core.auth.factor.signedNonce.error.invalidFactor': 'core.auth.factor.signedNonce.error',
    'core.auth.factor.signedNonce.error.deletedDevice': 'core.auth.factor.signedNonce.error',
    'core.auth.factor.signedNonce.error.invalidDeviceStatus': 'core.auth.factor.signedNonce.error.invalidDevice',
    // re-map autoPush: "Send push automatically"
    'challenge-poll.custom_app.autoChallenge': 'autoPush',
    // authenticator-verification-custom-app-push-autochallenge
    'challenge-poll.okta_verify.autoChallenge': 'autoPush',
    // authenticator-verification-okta-verify-push-autoChallenge-on
    'authenticator-verification-data.authenticator.autoChallenge': 'autoPush',
    // authenticator-verification-data-okta-verify-push-autoChallenge-off.json
    'authenticator-verification-data.okta_verify.authenticator.autoChallenge': 'autoPush',
    'authenticator-verification-data.custom_app.authenticator.autoChallenge': 'autoPush',
    // Existing overrides
    ...(0, $3f6049cd47f7c928$export$699b8df303cdca6 //enroll-profile strings
    )
};
const $93a83f6fd41fc21e$var$I18N_PARAMS_MAPPING = {
    [(0, $4a07c2817278db15$export$657220afecfe252).ENROLL_AUTHENTICATOR]: {
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).ON_PREM]: {
            getParam: (0, $3ddabee037f3f019$export$c8e5d116c70cd63f)
        },
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).RSA]: {
            getParam: (0, $3ddabee037f3f019$export$c8e5d116c70cd63f)
        }
    }
};
/**
 * For i18n keys that require string interpolation using values from "params".
 * {baseKey} : {params}
 */ const $93a83f6fd41fc21e$var$I18N_OVERRIDE_WITH_PARAMS_MAP = {
    'registration.error.invalidLoginEmail': {
        Email: 'Email'
    },
    'registration.error.doesNotMatchPattern': {
        Email: 'Email'
    },
    'registration.error.notUniqueWithinOrg': {
        Email: 'Email',
        // The login field arrives with the English display name 'Primary Key'. Reuse
        // the existing, already-translated 'errors.E0000114' ("A user with this login
        // already exists...") instead of dropping the raw English param into the
        // translated .custom template. Value contains a '.', so it is used verbatim.
        'Primary Key': 'errors.E0000114'
    }
};
/**
 * For messages that need to be interpolated with param values.
 *
 * Enumerate each possible param interpolation and hardcode that into properties file.
 * This is to ensure proper translation.
 *
 * Example - a known param:
 *
 * input =
 *  "i18n": {
      "key": "registration.error.doesNotMatchPattern",
      "params": [
        "Email"
      ]
    }
 * output = registration.error.doesNotMatchPattern.Email
 *
 * Example - an unknown param:
 *
 * input =
 *  "i18n": {
      "key": "registration.error.doesNotMatchPattern",
      "params": [
        "Custom Property"
      ]
    }
 * output = registration.error.doesNotMatchPattern.custom
 *
 * @param {String} key
 * @param {String} param
 * @returns {String}
 */ const $93a83f6fd41fc21e$var$getI8nKeyUsingParams = (key, param)=>{
    const knownParamValue = $93a83f6fd41fc21e$var$I18N_OVERRIDE_WITH_PARAMS_MAP[key][param];
    if (!knownParamValue) return `${key}.custom`;
    // A mapped value that is itself a fully-qualified i18n key (contains a '.') is
    // reused verbatim, letting us point a param at an existing translated string
    // (e.g. 'Primary Key' -> 'errors.E0000114'). Otherwise the value is a suffix
    // appended to the base key (e.g. 'Email' -> '<key>.Email').
    return knownParamValue.includes('.') ? knownParamValue : `${key}.${knownParamValue}`;
};
const $93a83f6fd41fc21e$export$e40ffeea4163b07f = (remediation, authenticatorKey)=>{
    const params = [];
    const formName = remediation.name;
    // Handle WebAuthn custom displayName
    if (authenticatorKey === (0, $4a07c2817278db15$export$a7895cc4b0944d1b).WEBAUTHN) {
        var _remediation$relatesT, _remediation$relatesT2;
        const displayName = remediation === null || remediation === void 0 ? void 0 : (_remediation$relatesT = remediation.relatesTo) === null || _remediation$relatesT === void 0 ? void 0 : (_remediation$relatesT2 = _remediation$relatesT.value) === null || _remediation$relatesT2 === void 0 ? void 0 : _remediation$relatesT2.displayName;
        if ((0, $bdb5e1755e68f0a9$export$9d3e336c57817b37)(displayName)) {
            params.push(displayName);
            return params;
        }
    }
    if ($93a83f6fd41fc21e$var$I18N_PARAMS_MAPPING[formName] && $93a83f6fd41fc21e$var$I18N_PARAMS_MAPPING[formName][authenticatorKey]) {
        const config = $93a83f6fd41fc21e$var$I18N_PARAMS_MAPPING[formName][authenticatorKey];
        const param = config.getParam(remediation);
        params.push(param);
    }
    return params;
};
const $93a83f6fd41fc21e$export$ab33fec751ab19c6 = (i18nPath, remediation = null)=>{
    let i18nKey;
    // Extract security question value from i18nPath
    $93a83f6fd41fc21e$var$SECURITY_QUESTION_PREFIXES.forEach((prefix)=>{
        if (i18nPath.indexOf(prefix) === 0) {
            const securityQuestionValue = i18nPath.replace(prefix, '');
            i18nKey = `security.${securityQuestionValue}`;
        }
    });
    // Handle WebAuthn authenticator dynamically based on displayName
    // Check for WebAuthn paths BEFORE I18N_OVERRIDE_MAPPINGS to properly handle custom displayNames
    if (i18nPath === 'select-authenticator-enroll.authenticator.webauthn' || i18nPath === 'select-authenticator-authenticate.authenticator.webauthn') {
        var _remediation$relatesT3, _remediation$relatesT4;
        const displayName = remediation === null || remediation === void 0 ? void 0 : (_remediation$relatesT3 = remediation.relatesTo) === null || _remediation$relatesT3 === void 0 ? void 0 : (_remediation$relatesT4 = _remediation$relatesT3.value) === null || _remediation$relatesT4 === void 0 ? void 0 : _remediation$relatesT4.displayName;
        // For custom displayName (not DEFAULT, not PASSKEYS), return null to use the displayName itself
        if ((0, $bdb5e1755e68f0a9$export$9d3e336c57817b37)(displayName)) return null;
        // For DEFAULT or PASSKEYS, get the appropriate i18n key
        i18nKey = (0, $bdb5e1755e68f0a9$export$9748196cbdf7dd9e)((0, $bdb5e1755e68f0a9$export$af759845ef57c7cc).LABEL, displayName);
    } else if ($93a83f6fd41fc21e$var$I18N_OVERRIDE_MAPPINGS[i18nPath]) i18nKey = $93a83f6fd41fc21e$var$I18N_OVERRIDE_MAPPINGS[i18nPath];
    if (i18nKey && !(0, $ae370136150d080c$export$2e2bcd8739ae039).login[i18nKey]) {
        (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).warn(`expect i18n key ${i18nKey} for ${i18nPath} but not found in 'login' bundle.`);
        i18nKey = null;
    }
    return i18nKey;
};
const $93a83f6fd41fc21e$export$82a8eacbf3403cb1 = (i18nKey)=>{
    return !!(0, $ae370136150d080c$export$2e2bcd8739ae039).login[i18nKey];
};
/**
 * Find i18n value using {@code i18nPath} if it exists.
 * Otherwise return {@code defaultValue}.
 *
 * @param {string} i18nPath
 * @param {string} defaultValue
 * @param {string[]} params
 * @param {Object} remediation
 */ const $93a83f6fd41fc21e$export$c5c17005ab20455f = (i18nPath, defaultValue, params = [], remediation = null)=>{
    const i18nKey = $93a83f6fd41fc21e$export$ab33fec751ab19c6(i18nPath, remediation);
    if (i18nKey) return (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)(i18nKey, 'login', params);
    else {
        (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).warn(`Avoid rendering unlocalized text sent from the API: ${defaultValue}`);
        return defaultValue;
    }
};
const $93a83f6fd41fc21e$var$isWebAuthnAPIError = (i18nKey)=>i18nKey.startsWith($93a83f6fd41fc21e$var$WEBAUTHN_API_GENERIC_ERROR_KEY);
const $93a83f6fd41fc21e$var$isPasskeysWebAuthnAPIError = (i18nKey)=>i18nKey.startsWith($93a83f6fd41fc21e$var$PASSKEYS_WEBAUTHN_API_GENERIC_ERROR_KEY);
/**
 * @typedef {Object} Message
 * @property {string} message
 * @property {Object=} i18n
 * @property {string} i18n.key
 * @property {string[]} i18n.params
 */ /**
 * - If `message.i18n.key` exists and has a value in 'login.properties'
 *   through the given key or via I18N_OVERRIDE_MAPPINGS, return the value.
 *
 * - returns `message.message` otherwise
 *
 * @param {Message} message
 */ const $93a83f6fd41fc21e$export$2e51780da3c3a61 = (message)=>{
    var _message$i18n;
    if ((_message$i18n = message.i18n) !== null && _message$i18n !== void 0 && _message$i18n.key) {
        var _message$i18n2;
        let i18nKey = message.i18n.key;
        let i18nParams = message.i18n.params || [];
        // TODO - remove this block once API fix is done - OKTA-398080
        // Sometimes API sends params: [""] an array with empty string.
        // example - error-authenticator-enroll-password-common mock
        if (i18nParams.length === 1 && i18nParams[0] === '') i18nParams = [];
        if ($93a83f6fd41fc21e$var$I18N_OVERRIDE_MAPPINGS[(_message$i18n2 = message.i18n) === null || _message$i18n2 === void 0 ? void 0 : _message$i18n2.key]) {
            var _message$i18n3;
            i18nKey = $93a83f6fd41fc21e$var$I18N_OVERRIDE_MAPPINGS[(_message$i18n3 = message.i18n) === null || _message$i18n3 === void 0 ? void 0 : _message$i18n3.key];
        } else if ($93a83f6fd41fc21e$var$I18N_OVERRIDE_WITH_PARAMS_MAP[i18nKey]) {
            var _message$i18n$params;
            const param = (_message$i18n$params = message.i18n.params) === null || _message$i18n$params === void 0 ? void 0 : _message$i18n$params[0];
            i18nKey = $93a83f6fd41fc21e$var$getI8nKeyUsingParams(i18nKey, param);
            i18nParams = i18nKey.endsWith('custom') ? [
                param
            ] : [];
        }
        if ((0, $ae370136150d080c$export$2e2bcd8739ae039).login[i18nKey]) {
            (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).info(`Override messages using i18n key ${i18nKey}`);
            // expect user config i18n properly.
            // e.g. the i18n value shall have placeholders like `{0}`, when params is not empty.
            return (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)(i18nKey, 'login', i18nParams);
        }
        if ($93a83f6fd41fc21e$var$isWebAuthnAPIError(i18nKey)) // The WebAuthn api error doesn't make much sense to a typical end user, but useful for developer.
        // So keep the api message in response, but show a generic error message on UI.
        return (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)($93a83f6fd41fc21e$var$WEBAUTHN_API_GENERIC_ERROR_KEY, 'login');
        else if ($93a83f6fd41fc21e$var$isPasskeysWebAuthnAPIError(i18nKey)) return (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)($93a83f6fd41fc21e$var$PASSKEYS_WEBAUTHN_API_GENERIC_ERROR_KEY, 'login');
        // Return unlocalized IDX `message.message` for admin-defined custom device assurance remediation keys
        if (i18nKey.startsWith($93a83f6fd41fc21e$var$DEVICE_ASSURANCE_CUSTOM_REMEDIATION_I18N_KEY_PREFIX)) return message.message;
    }
    (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).warn(`Avoid rendering unlocalized text sent from the API: ${message.message}`);
    return message.message;
};
/**
 * @param {Object} error
 */ const $93a83f6fd41fc21e$export$6e5b567ae7e48d0c = (error)=>{
    if (error.name) {
        const key = `oie.browser.error.${error.name}`;
        if ((0, $ae370136150d080c$export$2e2bcd8739ae039).login[key]) {
            (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).info(`Override messages using i18n key ${key}`);
            // expect user config i18n properly.
            return (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)(key, 'login');
        }
    }
    return error.message;
};
/**
 * - iff `message.i18n.key` exists return the key.
 *
 * @param {Message} message
 */ const $93a83f6fd41fc21e$export$7cad4c9063025e24 = (message)=>{
    var _message$i18n4;
    return (message === null || message === void 0 ? void 0 : (_message$i18n4 = message.i18n) === null || _message$i18n4 === void 0 ? void 0 : _message$i18n4.key) || '';
};
/**
 * Has this i18n key been overridden for customization?
 * @param {String} i18nKey
 * @param {Object} settings
 * @returns Boolean
 */ const $93a83f6fd41fc21e$export$89d4852ea9ed9572 = (i18nKey, settings)=>{
    var _settings$get;
    const widgetLanguageLowerCase = (_settings$get = settings.get('languageCode')) === null || _settings$get === void 0 ? void 0 : _settings$get.toLowerCase();
    const i18n = settings.get('i18n');
    if (typeof i18n === 'undefined' || i18n === null) return false;
    // Lower case the language codes when searching for i18n key so it is case insensitive
    return Object.entries(i18n).some(([customizedLangCode, customizedI18nKeys])=>customizedLangCode.toLowerCase() === widgetLanguageLowerCase && !!customizedI18nKeys[i18nKey]);
};


/* eslint-disable max-len */ const $dfc37efc4ee208a0$var$updateLabelForUiSchema = (remediation, uiSchema)=>{
    var _remediation$relatesT, _remediation$relatesT2;
    if (uiSchema.mutable === false && uiSchema.name.indexOf('questionKey') < 0) return;
    (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).info('i18n label transformer');
    (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).info('\t remediationName: ', remediation.name);
    (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).info('\t uiSchema: ', JSON.stringify(uiSchema));
    const authenticatorKey = (_remediation$relatesT = remediation.relatesTo) === null || _remediation$relatesT === void 0 ? void 0 : (_remediation$relatesT2 = _remediation$relatesT.value) === null || _remediation$relatesT2 === void 0 ? void 0 : _remediation$relatesT2.key;
    const authenticatorKeyPath = authenticatorKey ? `.${remediation.relatesTo.value.key}` : '';
    const i18nPrefix = `${remediation.name}${authenticatorKeyPath}.`;
    let i18nPath = `${i18nPrefix}${uiSchema.name}`;
    if (uiSchema.type === 'text' && uiSchema.name.indexOf('questionKey') >= 0 && uiSchema.value !== 'custom') i18nPath = `${i18nPath}.${uiSchema.value}`;
    if (uiSchema.type === 'checkbox' && uiSchema.placeholder) {
        (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).info('\t 1: ', i18nPath);
        uiSchema.placeholder = (0, $93a83f6fd41fc21e$export$c5c17005ab20455f)(i18nPath, uiSchema.placeholder);
    }
    if (uiSchema.label) {
        (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).info('\t 2: ', i18nPath);
        const params = (0, $93a83f6fd41fc21e$export$e40ffeea4163b07f)(remediation, authenticatorKey);
        uiSchema.label = uiSchema.customLabel ? uiSchema.label : (0, $93a83f6fd41fc21e$export$c5c17005ab20455f)(i18nPath, uiSchema.label, params, remediation);
    }
    if ((0, $b51a961f9fe28c76$export$2e2bcd8739ae039).isPlainObject(uiSchema.options)) uiSchema.options = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).mapObject(uiSchema.options, (value, key)=>{
        const i18nPathOption = `${i18nPath}.${key}`;
        (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).info('\t 3: ', i18nPathOption);
        return (0, $93a83f6fd41fc21e$export$c5c17005ab20455f)(i18nPathOption, value);
    });
    if (Array.isArray(uiSchema.options)) uiSchema.options.forEach((o)=>{
        if (!o.label) return;
        let i18nPathOption;
        if (o.authenticatorKey) {
            var _o$value;
            i18nPathOption = `${i18nPath}.${o.authenticatorKey}`;
            const methodType = (_o$value = o.value) === null || _o$value === void 0 ? void 0 : _o$value.methodType;
            if (o.authenticatorKey === (0, $4a07c2817278db15$export$a7895cc4b0944d1b).OV && methodType) i18nPathOption = `${i18nPathOption}.${methodType}`;
        } else if (typeof o.value === 'string' || typeof o.value === 'number') // value could be string, number, object or undefined.
        i18nPathOption = `${i18nPath}.${o.value}`;
        else i18nPathOption = i18nPath;
        (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).info('\t 4: ', i18nPathOption);
        // For select-authenticator options, use the option's relatesTo for context
        const optionRemediation = o.relatesTo ? {
            ...remediation,
            relatesTo: {
                value: o.relatesTo
            }
        } : remediation;
        const params = (0, $93a83f6fd41fc21e$export$e40ffeea4163b07f)(optionRemediation, o.authenticatorKey);
        o.label = (0, $93a83f6fd41fc21e$export$c5c17005ab20455f)(i18nPathOption, o.label, params, optionRemediation);
    });
    if (Array.isArray(uiSchema.optionsUiSchemas)) uiSchema.optionsUiSchemas.forEach((optionsUiSchema)=>{
        optionsUiSchema.forEach((uiSchema)=>$dfc37efc4ee208a0$var$updateLabelForUiSchema(remediation, uiSchema));
    });
};
var $dfc37efc4ee208a0$export$2e2bcd8739ae039 = (transformedResp)=>{
    var _transformedResp$mess;
    // Try to override label using i18n value
    if (Array.isArray(transformedResp.remediations)) transformedResp.remediations.filter((remediation)=>Array.isArray(remediation.uiSchema) && remediation.uiSchema.length).forEach((remediation)=>{
        remediation.uiSchema.forEach((uiSchema)=>$dfc37efc4ee208a0$var$updateLabelForUiSchema(remediation, uiSchema));
    });
    // Try to override `messages` using i18n value.
    // 1. This is only handling top level `messages` object when response status is 200.
    // 2. See `IonResponseHelper.js` where handle `messages` object when none 200 response.
    // 3. Handling `messages` in remediation forms on 200 response is not considered yet.
    //    Is that possible?
    if (Array.isArray((_transformedResp$mess = transformedResp.messages) === null || _transformedResp$mess === void 0 ? void 0 : _transformedResp$mess.value)) transformedResp.messages.value.forEach((message)=>{
        message.message = (0, $93a83f6fd41fc21e$export$2e51780da3c3a61)(message);
    });
    return transformedResp;
};


/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ // Transforms an IDX response to an ION response
function $83348077e9292c68$export$2e2bcd8739ae039(settings, curResponse, lastResponse) {
    const ionResponse = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).compose((0, $dfc37efc4ee208a0$export$2e2bcd8739ae039), (0, $ccb0ea18819b8e99$export$2e2bcd8739ae039).bind({}, settings), (0, $f333a6abaf10e986$export$2e2bcd8739ae039).bind({}, settings))(curResponse, lastResponse);
    return ionResponse;
}


async function $160e2fcd71d4ceb8$export$430b76549cd56679(appState, idxResponse) {
    const settings = appState.settings;
    const lastResponse = appState.get('idx');
    const useInteractionCodeFlow = settings.get('oauth2Enabled');
    if (useInteractionCodeFlow) {
        if (idxResponse.interactionCode) {
            // Although session.stateHandle isn't used by interation flow,
            // it's better to clean up at the end of the flow.
            (0, $64cf5b2d2fb5baf3$export$2e2bcd8739ae039).removeStateHandle();
            // This is the end of the IDX flow, now entering OAuth
            const tokens = await (0, $f869579558aab7a0$export$5acf4a4412b19943)(settings, idxResponse);
            // At the successful end of IDX flow `clearAppStateCache` has been called, 
            //  but `setIonResponse` is not called, so `appState` is empty.
            // In such case `FormController` is not able to render any form.
            appState.unset('currentFormName', {
                silent: true
            });
            return tokens;
        }
    } else {
        // Do not save state handle for the first page loads.
        // Because there shall be no difference between following behavior
        // 1. bootstrap widget
        //    -> save state handle to session storage
        //    -> refresh page
        //    -> introspect using sessionStorage.stateHandle
        // 2. bootstrap widget
        //    -> do not save state handle to session storage
        //    -> refresh page
        //    -> introspect using options.stateHandle
        if (lastResponse) {
            var _idxResponse$context;
            (0, $64cf5b2d2fb5baf3$export$2e2bcd8739ae039).setStateHandle(idxResponse === null || idxResponse === void 0 ? void 0 : (_idxResponse$context = idxResponse.context) === null || _idxResponse$context === void 0 ? void 0 : _idxResponse$context.stateHandle);
        }
        // Login flows that mimic step up (moving forward in login pipeline) via internal api calls,
        // need to clear stored stateHandles.
        // This way the flow can maintain the latest state handle. For eg. Device probe calls
        if (appState.get('currentFormName') === (0, $4a07c2817278db15$export$657220afecfe252).CANCEL_TRANSACTION) (0, $64cf5b2d2fb5baf3$export$2e2bcd8739ae039).removeStateHandle();
    }
    // transform response
    const ionResponse = (0, $83348077e9292c68$export$2e2bcd8739ae039)(settings, idxResponse, lastResponse);
    await appState.setIonResponse(ionResponse);
}













/*!
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $e9e72b029d94d1aa$export$db7011ff75e1dba7(error) {
    // special case: error from interact when passing an (invalid) recovery token
    return (error === null || error === void 0 ? void 0 : error.error) === 'invalid_request' && error.error_description === 'The recovery token is invalid';
}
function $e9e72b029d94d1aa$export$c541c46f57b1cd12(error) {
    // special case: error from interact when passing an (invalid) activation token
    return (error === null || error === void 0 ? void 0 : error.error) === 'invalid_request' && error.error_description === 'The activation token is invalid';
}
function $e9e72b029d94d1aa$export$5d373af94ec1a43f(error) {
    // This error comes from `oauth2/interact` so is not an IDX error.
    // simulate an IDX-JS error response
    const idxError = $e9e72b029d94d1aa$export$1abc8122fd0d746c(error);
    const { details: details } = idxError;
    const messages = {
        type: 'array',
        value: [
            {
                message: error.error_description,
                i18n: {
                    key: 'oie.invalid.recovery.token'
                },
                class: 'ERROR'
            }
        ]
    };
    details.rawIdxState.messages = messages;
    details.context.messages = messages;
    return idxError;
}
function $e9e72b029d94d1aa$export$e32966cb2778f523(error) {
    // This error comes from `oauth2/interact` so is not an IDX error.
    // simulate an IDX-JS error response
    const idxError = $e9e72b029d94d1aa$export$1abc8122fd0d746c(error);
    const { details: details } = idxError;
    const messages = {
        type: 'array',
        value: [
            {
                message: error.error_description,
                i18n: {
                    key: 'idx.missing.activation.token'
                },
                class: 'ERROR'
            }
        ]
    };
    details.rawIdxState.messages = messages;
    details.context.messages = messages;
    return idxError;
}
function $e9e72b029d94d1aa$export$26f8f40bfa567041(error) {
    // special case: error from interact when the Org does not have OIE enabled
    // The response is not in IDX format. See playground/mocks/data/oauth2/error-feature-not-enabled.json
    return (error === null || error === void 0 ? void 0 : error.error) === 'access_denied' && error.error_description;
}
function $e9e72b029d94d1aa$export$48d189aad7b434f7(error) {
    // This error comes from `oauth2/interact` so the error is in OAuth format
    // simulate an IDX-JS error response
    const idxError = $e9e72b029d94d1aa$export$1abc8122fd0d746c(error);
    const { details: details } = idxError;
    const messages = {
        type: 'array',
        value: [
            {
                message: error.error_description,
                i18n: {
                    key: 'oie.feature.disabled'
                },
                class: 'ERROR'
            }
        ]
    };
    details.rawIdxState.messages = messages;
    details.context.messages = messages;
    return error;
}
function $e9e72b029d94d1aa$export$183561adcaaa6458(error) {
    return (error === null || error === void 0 ? void 0 : error.error) && error.error_description;
}
function $e9e72b029d94d1aa$export$c4129b1f2df7ff7b(error) {
    // This error comes from `oauth2/interact` so the error is in OAuth format
    // simulate an IDX-JS error response
    const idxError = $e9e72b029d94d1aa$export$1abc8122fd0d746c(error);
    const { details: details } = idxError;
    const messages = {
        type: 'array',
        value: [
            {
                message: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.configuration.error', 'login'),
                class: 'ERROR',
                i18n: undefined
            }
        ]
    };
    details.rawIdxState.messages = messages;
    details.context.messages = messages;
    return error;
}
function $e9e72b029d94d1aa$export$1abc8122fd0d746c(error) {
    // Make the error object resemble an IDX response
    const idxError = error;
    idxError.details = idxError.details || {};
    const { details: details } = idxError;
    details.rawIdxState = details.rawIdxState || {};
    details.context = details.context || {};
    details.neededToProceed = details.neededToProceed || [];
    // Populate generic error message if there isn't any.
    if (!details.rawIdxState.messages) {
        const idxMessage = {
            type: 'array',
            value: [
                {
                    message: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oform.error.unexpected', 'login'),
                    class: 'ERROR',
                    i18n: undefined
                }
            ]
        };
        details.rawIdxState.messages = idxMessage;
        details.context.messages = idxMessage;
    }
    return idxError;
}
function $e9e72b029d94d1aa$export$7b5b869ee98c16ab(error) {
    // If the error is a string, wrap it in an Error object
    if (typeof error === 'string') error = new Error(error);
    // special case error handling
    // invalid reccovery token
    if ($e9e72b029d94d1aa$export$db7011ff75e1dba7(error)) return $e9e72b029d94d1aa$export$5d373af94ec1a43f(error);
    // invalid activation token
    if ($e9e72b029d94d1aa$export$c541c46f57b1cd12(error)) return $e9e72b029d94d1aa$export$e32966cb2778f523(error);
    // OIE is not enabled
    if ($e9e72b029d94d1aa$export$26f8f40bfa567041(error)) return $e9e72b029d94d1aa$export$48d189aad7b434f7(error);
    // Other errors from /interact in OAuth format
    if ($e9e72b029d94d1aa$export$183561adcaaa6458(error)) return $e9e72b029d94d1aa$export$c4129b1f2df7ff7b(error);
    error = $e9e72b029d94d1aa$export$1abc8122fd0d746c(error);
    return error;
}




/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $83b60ca1e8963f3f$var$convertErrorMessageToErrorSummary = (formName, remediationValues = [])=>{
    return (0, $187365f460a6e3ed$export$2e2bcd8739ae039).chain(remediationValues).filter((field)=>{
        var _field$messages;
        return Array.isArray((_field$messages = field.messages) === null || _field$messages === void 0 ? void 0 : _field$messages.value) && field.messages.value.length;
    }).map((field)=>{
        return {
            property: formName ? `${formName}.${field.name}` : field.name,
            errorSummary: field.messages.value.map((0, $93a83f6fd41fc21e$export$2e51780da3c3a61)),
            errorKey: field.messages.value.map((0, $93a83f6fd41fc21e$export$7cad4c9063025e24))
        };
    }).value();
};
/**
 * Although time complexity is O(n^2),
 * the `array` is actually very small (size < 5),
 * hence performance doesn't matter.
 */ const $83b60ca1e8963f3f$var$uniqWith = (array, comparator)=>{
    if (!Array.isArray(array)) return [];
    if (!(0, $187365f460a6e3ed$export$2e2bcd8739ae039).isFunction(comparator) || array.length === 1) return array;
    const result = [];
    for(let i = 0; i < array.length; i++){
        let seen = false;
        for(let j = i + 1; j < array.length; j++)/* eslint max-depth: [2, 3] */ if (comparator(array[i], array[j])) {
            seen = true;
            break;
        }
        if (!seen) result.push(array[i]);
    }
    return result;
};
/**
 * returns errors
 * @example
 * errors = [
 *   {property : fieldName1, errorSummary: [errorMessage1]},
 *   {property : fieldName2, errorSummary: [errorMessage2]}
 *   {property : fieldName3, errorSummary: [errorMessage31, errorMessage32]}
 * ]
 */ const $83b60ca1e8963f3f$var$getRemediationErrors = (res)=>{
    let errors = [];
    if (!res.remediation || !Array.isArray(res.remediation.value) || res.remediation.value.length === 0) return errors;
    let remediationFormFields = res.remediation.value[0].value;
    if (!Array.isArray(remediationFormFields)) return errors;
    // error at field
    errors.push($83b60ca1e8963f3f$var$convertErrorMessageToErrorSummary(null, remediationFormFields));
    (0, $187365f460a6e3ed$export$2e2bcd8739ae039).each(remediationFormFields, (remediationForm)=>{
        var _remediationForm$form;
        const formName = remediationForm.name;
        // error at form.value
        if (Array.isArray((_remediationForm$form = remediationForm.form) === null || _remediationForm$form === void 0 ? void 0 : _remediationForm$form.value)) errors.push($83b60ca1e8963f3f$var$convertErrorMessageToErrorSummary(formName, remediationForm.form.value));
        // error at option.value.form.value
        if (Array.isArray(remediationForm.options)) (0, $187365f460a6e3ed$export$2e2bcd8739ae039).each(remediationForm.options, (option)=>{
            var _option$value, _option$value$form;
            if (Array.isArray((_option$value = option.value) === null || _option$value === void 0 ? void 0 : (_option$value$form = _option$value.form) === null || _option$value$form === void 0 ? void 0 : _option$value$form.value)) errors.push($83b60ca1e8963f3f$var$convertErrorMessageToErrorSummary(formName, option.value.form.value));
        });
    });
    // API may return identical error on same field
    // thus run through `uniqWith`.
    // Check unit test for details.
    return $83b60ca1e8963f3f$var$uniqWith((0, $187365f460a6e3ed$export$2e2bcd8739ae039).flatten(errors), (0, $187365f460a6e3ed$export$2e2bcd8739ae039).isEqual);
};
/**
 * return global error summary combined into one string
 * allErrors = 'error string1. error string2'
 */ const $83b60ca1e8963f3f$var$getGlobalErrors = (res)=>{
    var _res$messages;
    let allErrors = [];
    if (Array.isArray((_res$messages = res.messages) === null || _res$messages === void 0 ? void 0 : _res$messages.value)) allErrors = res.messages.value.map((0, $93a83f6fd41fc21e$export$2e51780da3c3a61));
    return allErrors.join('. ');
};
/**
 * return array of error keys
 */ const $83b60ca1e8963f3f$var$getGlobalErrorKeys = (res)=>{
    var _res$messages2;
    let allKeys = [];
    if (Array.isArray((_res$messages2 = res.messages) === null || _res$messages2 === void 0 ? void 0 : _res$messages2.value)) allKeys = res.messages.value.map((0, $93a83f6fd41fc21e$export$7cad4c9063025e24));
    return allKeys;
};
const $83b60ca1e8963f3f$var$convertFormErrors = (response)=>{
    let errors = {
        errorCauses: $83b60ca1e8963f3f$var$getRemediationErrors(response),
        errorSummary: $83b60ca1e8963f3f$var$getGlobalErrors(response),
        errorSummaryKeys: $83b60ca1e8963f3f$var$getGlobalErrorKeys(response),
        errorIntent: response.intent
    };
    return {
        responseJSON: errors
    };
};
const $83b60ca1e8963f3f$var$isIonErrorResponse = (response = {})=>{
    // check if error format is an ION response by looking for version attribute.
    // a little sloppy.
    return response.version;
};
const $83b60ca1e8963f3f$var$isIdxSessionExpiredError = (response)=>{
    var _response$context, _response$context$mes, _response$context$mes2, _response$context$mes3;
    const errorI18NKey = response === null || response === void 0 ? void 0 : (_response$context = response.context) === null || _response$context === void 0 ? void 0 : (_response$context$mes = _response$context.messages) === null || _response$context$mes === void 0 ? void 0 : (_response$context$mes2 = _response$context$mes.value[0]) === null || _response$context$mes2 === void 0 ? void 0 : (_response$context$mes3 = _response$context$mes2.i18n) === null || _response$context$mes3 === void 0 ? void 0 : _response$context$mes3.key;
    return errorI18NKey && errorI18NKey === 'idx.session.expired';
};
var $83b60ca1e8963f3f$export$2e2bcd8739ae039 = {
    convertFormErrors: $83b60ca1e8963f3f$var$convertFormErrors,
    isIonErrorResponse: $83b60ca1e8963f3f$var$isIonErrorResponse,
    isIdxSessionExpiredError: $83b60ca1e8963f3f$var$isIdxSessionExpiredError
};


/* eslint max-depth: [1,4] */ class $bad5ff2b44526355$export$2e2bcd8739ae039 extends (0, $5d64eb84267ab4e8$export$55185c17a0fcbe46) {
    // also set on prototype
    constructor(options){
        super(options);
        // Create a default success and/or error handler if
        // one is not provided.
        this.Events = (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Events;
        this.hasControllerRendered = false;
        this.settings = void 0;
        this.appState = void 0;
        this.hooks = void 0;
        this.header = void 0;
        if (!options.globalSuccessFn) options.globalSuccessFn = function() {};
        if (!options.globalErrorFn) options.globalErrorFn = function(err) {
            (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).error(err);
        };
        this.settings = new (0, $03319d6721601f44$export$2e2bcd8739ae039)((0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(options, 'el', 'hooks'), {
            parse: true
        });
        if (!options.el) this.settings.callGlobalError(new (0, $3fe6932680e7ea64$export$c5fb415882705cf4)((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('error.required.el')));
        (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)('body > div').on('click', function() {
        // OKTA-69769 Tooltip wont close on iPhone/iPad
        // Registering a click handler on the first div
        // allows a tap that falls outside the tooltip
        // to be registered as a tap by iOS
        // and then the open tooltip will lose focus and close.
        });
        this.hooks = options.hooks;
        this.appState = new (0, $6879cb334c0737c9$export$2e2bcd8739ae039)({}, {
            settings: this.settings,
            hooks: this.hooks
        });
        const wrapper = new (0, $2298640c0f084892$export$2e2bcd8739ae039)({
            appState: this.appState
        });
        (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(options.el).append(wrapper.render().$el);
        this.el = `#${(0, $e48c043f6d2d382d$export$2e2bcd8739ae039).WIDGET_CONTAINER_ID}`;
        this.header = new (0, $8134b3e4c81685fe$export$2e2bcd8739ae039)({
            el: this.el,
            appState: this.appState,
            settings: this.settings
        });
        // Hide until unitial render
        this.hide();
        this.listenTo(this.appState, 'change:deviceFingerprint', this.updateDeviceFingerprint);
        this.listenTo(this.appState, 'restartLoginFlow', this.restartLoginFlow);
    }
    updateDeviceFingerprint() {
        const authClient = this.settings.getAuthClient();
        const fingerprint = this.appState.get('deviceFingerprint');
        if (fingerprint) authClient.http.setRequestHeader('X-Device-Fingerprint', fingerprint);
    }
    async handleIdxResponseFailure(error = {
        error: 'unknown',
        details: undefined
    }) {
        // IDX errors will not call the global error handler
        error = (0, $e9e72b029d94d1aa$export$7b5b869ee98c16ab)(error);
        await (0, $160e2fcd71d4ceb8$export$430b76549cd56679)(this.appState, error.details);
    }
    // Generic error handler for all exceptions
    async handleError(error = {
        error: 'unknown',
        details: undefined
    }) {
        const formattedError = (0, $e9e72b029d94d1aa$export$7b5b869ee98c16ab)({
            ...error
        }); // format the error to resemble an IDX response
        await (0, $160e2fcd71d4ceb8$export$430b76549cd56679)(this.appState, formattedError.details);
    }
    /* eslint max-statements: [2, 36], complexity: [2, 16] */ async render(Controller, options = {}) {
        // If url changes then widget assumes that user's intention was to initiate a new login flow,
        // so clear stored token to use the latest token.
        if ((0, $64cf5b2d2fb5baf3$export$2e2bcd8739ae039).getLastInitiatedLoginUrl() !== window.location.href) (0, $64cf5b2d2fb5baf3$export$2e2bcd8739ae039).removeStateHandle();
        // Since we have a wrapper view, render our wrapper and use its content
        // element as our new el.
        // Note: Render it here because we know dom is ready at this point
        if (!this.header.rendered()) this.el = this.header.render().getContentEl();
        // If we need to load a language (or apply custom i18n overrides), do
        // this now and re-run render after it's finished.
        if (!(0, $ae370136150d080c$export$2e2bcd8739ae039).isLoaded(this.settings.get('languageCode'))) await (0, $f4fd804aa49210df$export$f02cbd868e2f57cf)(this.appState, this.settings);
        let error;
        try {
            let idxResp = await (0, $5c956f54a640b39f$export$dbed9b2f15c02c8e)(this.settings);
            if (idxResp.error) await this.handleIdxResponseFailure(idxResp.error);
            else {
                if (this.settings.get('flow') && !this.hasControllerRendered) idxResp = await (0, $12ff73410cfee270$export$472edd06424c2bb7)(idxResp, this.settings);
                // TODO: OKTA-494979 - temporary fix, remove when auth-js is upgraded to 6.6+
                if (!idxResp.requestDidSucceed && (0, $83b60ca1e8963f3f$export$2e2bcd8739ae039).isIdxSessionExpiredError(idxResp)) {
                    // clear transaction subsequent page loads do not use stale interactionHandle
                    const authClient = this.settings.getAuthClient();
                    authClient.transactionManager.clear();
                }
                await (0, $160e2fcd71d4ceb8$export$430b76549cd56679)(this.appState, idxResp);
            }
        } catch (exception) {
            var _exception$is;
            if ((_exception$is = exception.is) !== null && _exception$is !== void 0 && _exception$is.call(exception, 'terminal')) this.appState.setNonIdxError(exception);
            else {
                error = exception;
                await this.handleError(exception);
            }
        } finally{
            // These settings should only be used one time, for initial render
            this.settings.unset('stateToken');
            this.settings.unset('proxyIdxResponse');
        }
        // Load the custom colors only on the first render
        if (this.settings.get('colors.brand') && !(0, $2816cbe5d674331a$export$2e2bcd8739ae039).isLoaded()) {
            const colors = {
                brand: this.settings.get('colors.brand')
            };
            const cspNonce = this.settings.get('cspNonce');
            (0, $2816cbe5d674331a$export$2e2bcd8739ae039).addStyle(colors, cspNonce);
        }
        // Show before initial render
        this.show();
        // render Controller
        this.unload();
        const controllerOptions = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({
            el: this.el,
            settings: this.settings,
            appState: this.appState
        }, options);
        this.controller = new Controller(controllerOptions);
        // Bubble up all controller events
        this.listenTo(this.controller, 'all', this.trigger);
        this.controller.render();
        this.hasControllerRendered = true;
        // This will reject the promise returned from renderEl
        if (error) this.settings.callGlobalError(error);
    // -- TODO: OKTA-244631 How to surface up the CORS error in IDX?
    // -- The `err` object from idx.js doesn't have XHR object
    // Global error handling for CORS enabled errors
    // if (err.xhr && BrowserFeatures.corsIsNotEnabled(err.xhr)) {
    //   this.settings.callGlobalError(new UnsupportedBrowserError(loc('error.enabled.cors')));
    //   return;
    // }
    }
    /**
    * When "Remember My Username" is enabled, we save the identifier in a cookie
    * so that the next time the user visits the SIW, the identifier field can be 
    * pre-filled with this value.
   */ updateIdentifierCookie(idxResponse) {
        if (this.settings.get('features.rememberMe')) {
            var _idxResponse$context;
            // Update the cookie with the identifier
            const user = idxResponse === null || idxResponse === void 0 ? void 0 : (_idxResponse$context = idxResponse.context) === null || _idxResponse$context === void 0 ? void 0 : _idxResponse$context.user;
            const { identifier: identifier } = (user === null || user === void 0 ? void 0 : user.value) || {};
            if (identifier) (0, $0077b4018f3faaa0$export$2e2bcd8739ae039).setUsernameCookie(identifier);
        } else // We remove the cookie explicitly if this feature is disabled.
        (0, $0077b4018f3faaa0$export$2e2bcd8739ae039).removeUsernameCookie();
    }
    hasAuthenticationSucceeded(idxResponse) {
        var _idxResponse$rawIdxSt, _idxResponse$rawIdxSt2;
        // Check whether authentication has succeeded. This is done by checking the server response
        // and seeing if either the 'success' or 'successWithInteractionCode' objects are present.
        return (idxResponse === null || idxResponse === void 0 ? void 0 : (_idxResponse$rawIdxSt = idxResponse.rawIdxState) === null || _idxResponse$rawIdxSt === void 0 ? void 0 : _idxResponse$rawIdxSt.success) || (idxResponse === null || idxResponse === void 0 ? void 0 : (_idxResponse$rawIdxSt2 = idxResponse.rawIdxState) === null || _idxResponse$rawIdxSt2 === void 0 ? void 0 : _idxResponse$rawIdxSt2.successWithInteractionCode);
    }
    restartLoginFlow(flow) {
        var _ref;
        // clear all transaction data and saved IDX response
        this.settings.getAuthClient().transactionManager.clear();
        this.appState.set('idx', undefined);
        // Clear the recoveryToken, if any
        const authClient = this.settings.getAuthClient();
        delete authClient.options['recoveryToken'];
        this.settings.unset('recoveryToken');
        // clear otp (email magic link), if any
        this.settings.unset('otp');
        // remove all event listeners from current controller instance. A new instance will be created in render().
        this.controller.stopListening();
        authClient.idx.setFlow((_ref = flow !== null && flow !== void 0 ? flow : this.settings.get('flow')) !== null && _ref !== void 0 ? _ref : 'default');
        // Re-render the widget
        this.render(this.controller.constructor);
    }
    start() {
        const pushState = (0, $22893d6dea78fc87$export$2e2bcd8739ae039).supportsPushState();
        (0, $5d64eb84267ab4e8$export$55185c17a0fcbe46).prototype.start.call(this, {
            pushState: pushState
        });
    }
    hide() {
        this.header.$el.hide();
    }
    show() {
        this.header.$el.show();
    }
    remove() {
        this.unload();
        this.header.$el.remove();
        this.stopListening(this.appState);
        this.stopListening(this.settings);
        (0, $ae370136150d080c$export$2e2bcd8739ae039).remove();
        (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).history.stop();
    }
}
// Add "Events" to prototype for compatibility with existing code
$bad5ff2b44526355$export$2e2bcd8739ae039.prototype.Events = (0, $0be6c25dba7b6ea4$export$2e2bcd8739ae039).Events;


























var $4c0f78fce7387c76$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    HeaderBeacon: null,
    initialize: function() {
        if (this.HeaderBeacon) this.add(this.HeaderBeacon);
    },
    postRender: function() {
        const mainContentContainer = (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(`#${(0, $e48c043f6d2d382d$export$2e2bcd8739ae039).WIDGET_CONTAINER_ID}`);
        if (this.HeaderBeacon) {
            mainContentContainer.removeClass('no-beacon');
            // animate beacon
            const beaconContainer = this.$el.find('[data-type="beacon-container"]');
            (0, $c6666231eedaafd3$export$2e2bcd8739ae039).explode(beaconContainer);
        } else mainContentContainer.addClass('no-beacon');
    }
});






















var $15be617e7228d213$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return container.escapeExpression((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "label",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 9
                    }
                }
            }) : helper));
        },
        "useData": true
    }),
    tagName: 'a',
    attributes: function() {
        let href = this.options.href || '#';
        const rel = this.options.target === '_blank' && !this.options.rel ? 'noopener noreferrer' : this.options.rel;
        return {
            'data-se': this.options.name,
            href: href,
            target: this.options.target,
            rel: rel
        };
    },
    className: function() {
        const names = [
            'link'
        ];
        if (this.options.name) {
            const nameToClass = this.options.name.replace(/[ ]/g, '-');
            names.push(`js-${nameToClass}`);
        }
        return names.join(' ');
    },
    postRender: function() {
        // TODO OKTA-245224: create sub class of Link to dispatch following if/else logic.
        if (!this.options.href) this.$el.click((event)=>{
            event.preventDefault();
            const { appState: appState, formName: formName, actionPath: actionPath, clickHandler: clickHandler } = this.options;
            if (clickHandler) clickHandler();
            else if (formName) appState.trigger('switchForm', formName);
            else if (actionPath) appState.trigger('invokeAction', actionPath);
        });
    }
});













/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $f3ed3f584472d1fb$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    initialize: function() {
        (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).prototype.initialize.apply(this, arguments);
        const textViewOptions = this.options.additionalOptions;
        const linkName = this.options.name;
        const linkOptions = Object.assign({}, this.options, {
            'type': 'link',
            'aria-expanded': false,
            'clickHandler': function() {
                (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(textViewOptions.selector).slideToggle(200, ()=>{
                    (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(`.js-${linkName}`).attr('aria-expanded', (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(textViewOptions.selector).is(':visible'));
                });
            }
        });
        this.add((0, $15be617e7228d213$export$2e2bcd8739ae039), {
            options: linkOptions
        });
        this.add(textViewOptions.view);
    },
    postRender: function() {
        const textViewOptions = this.options.additionalOptions;
        this.$(textViewOptions.selector).hide();
    }
});













const { ENROLLED_PASSWORD_RECOVERY_LINK: $aaa5b7e3293b6284$var$ENROLLED_PASSWORD_RECOVERY_LINK, ORG_PASSWORD_RECOVERY_LINK: $aaa5b7e3293b6284$var$ORG_PASSWORD_RECOVERY_LINK } = (0, $4a07c2817278db15$export$92a1a3b7554e9387);
const $aaa5b7e3293b6284$export$e6f8c91470651ac8 = (appState)=>{
    if (appState.getRemediationAuthenticationOptions((0, $4a07c2817278db15$export$657220afecfe252).SELECT_AUTHENTICATOR_AUTHENTICATE).length > 1) return [
        {
            'type': 'link',
            'label': (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.verification.switch.authenticator', 'login'),
            'name': 'switchAuthenticator',
            'formName': (0, $4a07c2817278db15$export$657220afecfe252).SELECT_AUTHENTICATOR_AUTHENTICATE
        }
    ];
    if (appState.getRemediationAuthenticationOptions((0, $4a07c2817278db15$export$657220afecfe252).SELECT_AUTHENTICATOR_ENROLL).length >= 1) return [
        {
            'type': 'link',
            'label': (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.switch.authenticator', 'login'),
            'name': 'switchAuthenticator',
            'formName': (0, $4a07c2817278db15$export$657220afecfe252).SELECT_AUTHENTICATOR_ENROLL
        }
    ];
    return [];
};
const $aaa5b7e3293b6284$export$219f3ecb053dc685 = (appState, settings)=>{
    const forgotPasswordLink = {
        'type': 'link',
        'label': (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('forgotpassword', 'login'),
        'name': 'forgot-password'
    };
    const customForgotPasswordHref = settings.get('helpLinks.forgotPassword');
    if (customForgotPasswordHref) return [
        Object.assign({}, {
            'href': customForgotPasswordHref,
            'label': (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('forgotpassword', 'login'),
            'name': 'forgot-password'
        })
    ];
    else if (appState.getActionByPath($aaa5b7e3293b6284$var$ORG_PASSWORD_RECOVERY_LINK)) return [
        Object.assign({}, forgotPasswordLink, {
            actionPath: $aaa5b7e3293b6284$var$ORG_PASSWORD_RECOVERY_LINK
        })
    ];
    else if (appState.getActionByPath($aaa5b7e3293b6284$var$ENROLLED_PASSWORD_RECOVERY_LINK)) return [
        Object.assign({}, forgotPasswordLink, {
            actionPath: $aaa5b7e3293b6284$var$ENROLLED_PASSWORD_RECOVERY_LINK
        })
    ];
    return [];
};
const $aaa5b7e3293b6284$export$77db2f739f8229cd = (appState, linkName)=>{
    if (appState.hasRemediationObject((0, $4a07c2817278db15$export$657220afecfe252).SKIP)) return [
        {
            'type': 'link',
            'label': linkName !== null && linkName !== void 0 ? linkName : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.skip.setup', 'login'),
            'name': 'skip-setup',
            'actionPath': (0, $4a07c2817278db15$export$657220afecfe252).SKIP
        }
    ];
    return [];
};
// When there is a 'cancel' object in remediation
const $aaa5b7e3293b6284$export$57ec3e9faf8794d = (settings, options = {})=>{
    if (settings !== null && settings !== void 0 && settings.get('backToSignInUri')) return [
        {
            'label': (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('goback', 'login'),
            'name': 'cancel',
            'href': settings.get('backToSignInUri')
        }
    ];
    return [
        {
            'actionPath': 'cancel',
            'label': !options.label ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('goback', 'login') : options.label,
            'name': 'cancel',
            'type': 'link'
        }
    ];
};
// Use it to create a widget configured link in the absence of `cancel` object in remediation
const $aaa5b7e3293b6284$export$27ab946e7ff0ff57 = ({ settings: settings, appState: appState })=>{
    const link = {};
    // If backToSignInLink is set, use this value for all scenarios
    if (settings !== null && settings !== void 0 && settings.get('backToSignInUri')) link.href = settings.get('backToSignInUri');
    else if (settings !== null && settings !== void 0 && settings.get('oauth2Enabled')) link.clickHandler = ()=>{
        appState.trigger('restartLoginFlow');
    };
    else link.href = settings === null || settings === void 0 ? void 0 : settings.get('baseUrl');
    return [
        {
            'type': 'link',
            'label': (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('goback', 'login'),
            'name': 'go-back',
            ...link
        }
    ];
};
const $aaa5b7e3293b6284$export$b976e2cc13a99aa5 = ()=>{
    return [
        {
            'type': 'link',
            'label': (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.try.again', 'login'),
            'name': 'try-again',
            'href': window.location,
            'className': 'button button-primary text-align-c'
        }
    ];
};
const $aaa5b7e3293b6284$export$5bdaff50ccf3164 = (appState, settings)=>{
    const signupLink = [];
    if (appState.hasRemediationObject((0, $4a07c2817278db15$export$657220afecfe252).SELECT_ENROLL_PROFILE)) {
        const signupLinkData = {
            'type': 'link',
            'label': (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.registration.form.title', 'login'),
            'name': 'enroll'
        };
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(settings.get('registration.click'))) signupLinkData.clickHandler = settings.get('registration.click');
        else signupLinkData.actionPath = (0, $4a07c2817278db15$export$657220afecfe252).SELECT_ENROLL_PROFILE;
        signupLink.push(signupLinkData);
    }
    return signupLink;
};
const $aaa5b7e3293b6284$export$27e0c4917f6e596c = (settings)=>{
    let gracePeriodRequiredSoonCustomLink;
    const gracePeriodRequiredSoonCustomLinkLabel = settings.get('helpLinks.gracePeriodRequiredSoon.text');
    const gracePeriodRequiredSoonCustomLinkHref = settings.get('helpLinks.gracePeriodRequiredSoon.href');
    if (gracePeriodRequiredSoonCustomLinkLabel && gracePeriodRequiredSoonCustomLinkHref) gracePeriodRequiredSoonCustomLink = {
        type: 'link',
        label: gracePeriodRequiredSoonCustomLinkLabel,
        name: 'gracePeriodRequiredSoonCustomLink',
        href: gracePeriodRequiredSoonCustomLinkHref,
        target: '_blank'
    };
    return gracePeriodRequiredSoonCustomLink;
};
const $aaa5b7e3293b6284$export$574d56f9df8b837 = (appState, settings)=>{
    const factorPageCustomLink = [];
    const formsNeedFactorPageCustomLink = [
        (0, $4a07c2817278db15$export$657220afecfe252).CHALLENGE_AUTHENTICATOR,
        (0, $4a07c2817278db15$export$657220afecfe252).SELECT_AUTHENTICATOR_AUTHENTICATE,
        (0, $4a07c2817278db15$export$657220afecfe252).CHALLENGE_POLL,
        (0, $4a07c2817278db15$export$657220afecfe252).AUTHENTICATOR_VERIFICATION_DATA
    ];
    if (!appState.get('isPasswordRecovery') && formsNeedFactorPageCustomLink.includes(appState.get('currentFormName'))) {
        const helpLinksFactorPageLabel = settings.get('helpLinks.factorPage.text');
        const helpLinksFactorPageHref = settings.get('helpLinks.factorPage.href');
        if (helpLinksFactorPageLabel && helpLinksFactorPageHref) factorPageCustomLink.push({
            type: 'link',
            label: helpLinksFactorPageLabel,
            name: 'factorPageHelpLink',
            href: helpLinksFactorPageHref,
            target: '_blank'
        });
    }
    return factorPageCustomLink;
};


/**
 * When `href` is present, the Link behaviors as normal link (anchor element).
 * When `actionPath` is present, the Link behaviors as link button
 *   on which user clicks, will trigger the action `actionPath`.
 * When `formName` is present, the link behaviors as link button
 *   on which user clicks, will submit a remediation form.
 *
 * @typedef {Object} Link
 * @property {string} label
 * @property {string} name
 * @property {string=} href
 * @property {string=} actionPath
 * @property {string=} formName
 */ var $31737d9aae112815$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'auth-footer',
    /**
   * {Link[]} links
   */ links: [],
    /**
   * View
   * adds any view to the footer in footer info section
   */ footerInfo: null,
    /**
   * Boolean
   * If false then 'Back to sign in' does not get added to the view
   */ hasBackToSignInLink: true,
    initialize: function() {
        let links = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).resultCtx(this, 'links', this);
        const footerInfo = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).resultCtx(this, 'footerInfo', this);
        const hasBackToSignInLink = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).resultCtx(this, 'hasBackToSignInLink', this);
        // safe check
        // 1. avoid none array from override
        // 2. ignore any none plain object arguments
        if (!Array.isArray(links)) links = [];
        else links = links.filter((l)=>(0, $b51a961f9fe28c76$export$2e2bcd8739ae039).isPlainObject(l));
        // add 'back to sign in' link if the form qualifies for it by default.
        // Previously called cancel/Sign Out links
        if (this.options.appState.shouldShowSignOutLinkInCurrentForm(this.options.settings.get('features.hideSignOutLinkInMFA') || this.settings.get('features.mfaOnlyFlow')) && hasBackToSignInLink) links = links.concat((0, $aaa5b7e3293b6284$export$57ec3e9faf8794d)(this.options.settings));
        links.forEach((link)=>{
            let LinkView = (0, $15be617e7228d213$export$2e2bcd8739ae039);
            if (link.type === 'toggle-text-link') LinkView = (0, $f3ed3f584472d1fb$export$2e2bcd8739ae039);
            this.add(LinkView, {
                options: link
            });
        });
        if (footerInfo) {
            this.add((0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                className: 'footer-info'
            }));
            this.add(footerInfo, '.footer-info');
        }
    }
});













































const $5dcf8c5d7fe7c644$export$7477e4e7a587c9ab = 30000;
const $5dcf8c5d7fe7c644$export$3e280d76ab48f0fb = 30000;
const $5dcf8c5d7fe7c644$export$db5e36ddd4cd4e7c = 300000;
const $5dcf8c5d7fe7c644$export$d31c30443e10a36c = 1000;
const $5dcf8c5d7fe7c644$export$e24cfe30a92f580a = 500;
const $5dcf8c5d7fe7c644$export$8649076611c9e710 = 'authenticatorChallenge-cancel';
const $5dcf8c5d7fe7c644$export$1bcaad93666b7579 = 'currentAuthenticator-cancel';
const $5dcf8c5d7fe7c644$export$781806981de834e0 = 'siw-main-footer';
const $5dcf8c5d7fe7c644$export$f18c34395bdcb9dd = 4000;
const $5dcf8c5d7fe7c644$export$553bba1f918a5420 = 'IDENTIFIER';
const $5dcf8c5d7fe7c644$export$21ec211902d7e608 = 'oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.desktop';
const $5dcf8c5d7fe7c644$export$14b789590758b77b = 'oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.windows';
const $5dcf8c5d7fe7c644$export$17cbe7ebed212941 = 'oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.mobile';
const $5dcf8c5d7fe7c644$export$99760f0e4fa6d0a6 = 'oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics_or_pin.desktop';
const $5dcf8c5d7fe7c644$export$c5d5df2b86b06bbc = 'oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics_or_pin.mobile';
const $5dcf8c5d7fe7c644$export$b13626a8261d10f5 = {
    ANY: 'any',
    SSO: 'sso',
    RECOVERY: 'recovery'
};
const $5dcf8c5d7fe7c644$export$6e7b234bec626d3e = 'reason';
const $5dcf8c5d7fe7c644$export$2941f2d12c9205c = 'statusCode';
const $5dcf8c5d7fe7c644$export$2f37c9233c87243c = {
    LOOPBACK_FAILURE: 'OV_UNREACHABLE_BY_LOOPBACK',
    OV_ERROR: 'OV_RETURNED_ERROR',
    USER_CANCELED: 'USER_CANCELED'
};


const $a998513b4bbeae97$var$AuthenticatorRow = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'authenticator-row clearfix',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"factor-icon authenticator-icon " + alias3((helper = (helper = lookupProperty(helpers, "iconClassName") || (depth0 != null ? lookupProperty(depth0, "iconClassName") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
                "name": "iconClassName",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 100
                    },
                    "end": {
                        "line": 1,
                        "column": 117
                    }
                }
            }) : helper)) + " custom-app-logo\" role=\"img\" aria-label=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.auth.logo.aria.label"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 158
                    },
                    "end": {
                        "line": 1,
                        "column": 213
                    }
                }
            })) + "\"></div>";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"factor-icon authenticator-icon " + alias3((helper = (helper = lookupProperty(helpers, "iconClassName") || (depth0 != null ? lookupProperty(depth0, "iconClassName") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
                "name": "iconClassName",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 272
                    },
                    "end": {
                        "line": 1,
                        "column": 289
                    }
                }
            }) : helper)) + "\" role=\"img\" aria-label=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.auth.logo.aria.label"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 314
                    },
                    "end": {
                        "line": 1,
                        "column": 369
                    }
                }
            })) + "\"></div>";
        },
        "2": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<span class=\"authenticator-grace-period-required-icon\"></span><div class=\"authenticator-grace-period-text-container\"><p class=\"authenticator-grace-period-required-description\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "gracePeriodRequiredDescription") || (depth0 != null ? lookupProperty(depth0, "gracePeriodRequiredDescription") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
                "name": "gracePeriodRequiredDescription",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 702
                    },
                    "end": {
                        "line": 1,
                        "column": 736
                    }
                }
            }) : helper)) + "</p>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "gracePeriodExpiry") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(3, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 740
                    },
                    "end": {
                        "line": 1,
                        "column": 847
                    }
                }
            })) != null ? stack1 : "") + "</div>";
        },
        "3": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p class=\"authenticator-grace-period-expiry-date\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "gracePeriodExpiry") || (depth0 != null ? lookupProperty(depth0, "gracePeriodExpiry") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "gracePeriodExpiry",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 815
                    },
                    "end": {
                        "line": 1,
                        "column": 836
                    }
                }
            }) : helper)) + "</p>";
        },
        "4": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "gracePeriodRemainingSkipsDescription") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(5, data, 0),
                "inverse": container.program(6, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 853
                    },
                    "end": {
                        "line": 1,
                        "column": 1335
                    }
                }
            })) != null ? stack1 : "";
        },
        "5": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<span class=\"authenticator-grace-period-required-icon\"></span><div class=\"authenticator-grace-period-text-container\"><p class=\"authenticator-grace-period-skip-count-description\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "gracePeriodRemainingSkipsDescription") || (depth0 != null ? lookupProperty(depth0, "gracePeriodRemainingSkipsDescription") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "gracePeriodRemainingSkipsDescription",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 1079
                    },
                    "end": {
                        "line": 1,
                        "column": 1119
                    }
                }
            }) : helper)) + "</p></div></span>";
        },
        "6": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(7, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 1144
                    },
                    "end": {
                        "line": 1,
                        "column": 1232
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "authenticatorUsageText") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(8, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 1232
                    },
                    "end": {
                        "line": 1,
                        "column": 1335
                    }
                }
            })) != null ? stack1 : "");
        },
        "7": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p class=\"authenticator-description--text\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "description") || (depth0 != null ? lookupProperty(depth0, "description") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "description",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 1206
                    },
                    "end": {
                        "line": 1,
                        "column": 1221
                    }
                }
            }) : helper)) + "</p>";
        },
        "8": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p class=\"authenticator-usage-text\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "authenticatorUsageText") || (depth0 != null ? lookupProperty(depth0, "authenticatorUsageText") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "authenticatorUsageText",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 1298
                    },
                    "end": {
                        "line": 1,
                        "column": 1324
                    }
                }
            }) : helper)) + "</p>";
        },
        "9": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "data-se=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "buttonDataSeAttr") || (depth0 != null ? lookupProperty(depth0, "buttonDataSeAttr") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "buttonDataSeAttr",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 1409
                    },
                    "end": {
                        "line": 1,
                        "column": 1429
                    }
                }
            }) : helper)) + "\"";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"authenticator-icon-container\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "logoUri") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.program(1, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 42
                    },
                    "end": {
                        "line": 1,
                        "column": 384
                    }
                }
            })) != null ? stack1 : "") + "</div><div class=\"authenticator-description\"><h3 class=\"authenticator-label no-translate\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
                "name": "label",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 474
                    },
                    "end": {
                        "line": 1,
                        "column": 483
                    }
                }
            }) : helper)) + "</h3>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "gracePeriodRequiredDescription") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(2, data, 0),
                "inverse": container.program(4, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 488
                    },
                    "end": {
                        "line": 1,
                        "column": 1342
                    }
                }
            })) != null ? stack1 : "") + "<div class=\"authenticator-button\" " + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "buttonDataSeAttr") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(9, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 1376
                    },
                    "end": {
                        "line": 1,
                        "column": 1437
                    }
                }
            })) != null ? stack1 : "") + "></div></div>";
        },
        "useData": true
    }),
    postRender: function() {
        (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).prototype.postRender.apply(this, arguments);
        if (this.model.get('logoUri')) this.el.querySelector('.custom-app-logo').style.backgroundImage = `url(${this.model.get('logoUri')})`;
    },
    children: function() {
        return [
            [
                (0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
                    className: 'button select-factor',
                    title: function() {
                        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.authenticator.button.text', 'login');
                    },
                    attributes: {
                        'aria-label': this.model.get('ariaLabel')
                    },
                    click: function() {
                        this.model.trigger('selectAuthenticator', this.model.get('value'));
                    }
                }),
                '.authenticator-button'
            ]
        ];
    },
    minimize: function() {
        this.$el.addClass('authenticator-row-min');
    },
    getTemplateData: function() {
        let authenticatorUsageText;
        const allowedFor = this.model.get('relatesTo').allowedFor;
        if (allowedFor) switch(allowedFor){
            case (0, $5dcf8c5d7fe7c644$export$b13626a8261d10f5).ANY:
                authenticatorUsageText = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.authenticator.usage.text.access.recovery', 'login');
                break;
            case (0, $5dcf8c5d7fe7c644$export$b13626a8261d10f5).RECOVERY:
                authenticatorUsageText = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.authenticator.usage.text.recovery', 'login');
                break;
            case (0, $5dcf8c5d7fe7c644$export$b13626a8261d10f5).SSO:
                authenticatorUsageText = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.authenticator.usage.text.access', 'login');
                break;
        }
        const data = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).prototype.getTemplateData.apply(this, arguments);
        data.authenticatorUsageText = authenticatorUsageText;
        const gracePeriodData = this._getGracePeriodData();
        return {
            ...data,
            ...gracePeriodData
        };
    },
    _getGracePeriodData: function() {
        var _this$model$get, _this$model$get$grace, _this$model$get2, _this$model$get2$grac, _this$model$get3, _this$model$get3$grac;
        const data = {};
        const currentTimestampMs = Date.now();
        const gracePeriodEpochTimestampMs = new Date((_this$model$get = this.model.get('relatesTo')) === null || _this$model$get === void 0 ? void 0 : (_this$model$get$grace = _this$model$get.gracePeriod) === null || _this$model$get$grace === void 0 ? void 0 : _this$model$get$grace.expiry).getTime();
        if (!isNaN(gracePeriodEpochTimestampMs) && currentTimestampMs < gracePeriodEpochTimestampMs) {
            const remainingGracePeriodDays = (0, $40aeee952775c03c$export$2e2bcd8739ae039).calculateDaysBetween(currentTimestampMs, gracePeriodEpochTimestampMs);
            if (remainingGracePeriodDays === 1) data.gracePeriodRequiredDescription = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enrollment.policy.grace.period.required.in.one.day', 'login');
            else if (remainingGracePeriodDays > 1) data.gracePeriodRequiredDescription = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enrollment.policy.grace.period.required.in.days', 'login', [
                remainingGracePeriodDays
            ]);
            else data.gracePeriodRequiredDescription = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enrollment.policy.grace.period.required.today', 'login');
            if (gracePeriodEpochTimestampMs) data.gracePeriodExpiry = (0, $40aeee952775c03c$export$2e2bcd8739ae039).formatDateToDeviceAssuranceGracePeriodExpiryLocaleString(new Date(gracePeriodEpochTimestampMs), this.settings.get('languageTags'), false);
        } else if ((_this$model$get2 = this.model.get('relatesTo')) !== null && _this$model$get2 !== void 0 && (_this$model$get2$grac = _this$model$get2.gracePeriod) !== null && _this$model$get2$grac !== void 0 && _this$model$get2$grac.remainingSkips && ((_this$model$get3 = this.model.get('relatesTo')) === null || _this$model$get3 === void 0 ? void 0 : (_this$model$get3$grac = _this$model$get3.gracePeriod) === null || _this$model$get3$grac === void 0 ? void 0 : _this$model$get3$grac.remainingSkips) > 0) {
            var _this$model$get4, _this$model$get4$grac;
            if (((_this$model$get4 = this.model.get('relatesTo')) === null || _this$model$get4 === void 0 ? void 0 : (_this$model$get4$grac = _this$model$get4.gracePeriod) === null || _this$model$get4$grac === void 0 ? void 0 : _this$model$get4$grac.remainingSkips) === 1) data.gracePeriodRemainingSkipsDescription = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enrollment.policy.grace.period.required.in.one.skip', 'login');
            else {
                var _this$model$get5, _this$model$get5$grac;
                data.gracePeriodRemainingSkipsDescription = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enrollment.policy.grace.period.required.in.number.of.skips', 'login', [
                    (_this$model$get5 = this.model.get('relatesTo')) === null || _this$model$get5 === void 0 ? void 0 : (_this$model$get5$grac = _this$model$get5.gracePeriod) === null || _this$model$get5$grac === void 0 ? void 0 : _this$model$get5$grac.remainingSkips
                ]);
            }
        }
        return data;
    }
});
var $a998513b4bbeae97$export$2e2bcd8739ae039 = (0, $20176b5b9767e868$export$2e2bcd8739ae039).extend({
    className: 'authenticator-enroll-list authenticator-list',
    item: $a998513b4bbeae97$var$AuthenticatorRow,
    itemSelector: '.list-content',
    initialize: function() {
        this.listenTo(this.collection, 'selectAuthenticator', function(data) {
            this.model.set(this.options.name, data);
            this.options.appState.trigger('saveForm', this.model);
        });
        this.hasOptionalFactors = this.options.appState.hasRemediationObject((0, $4a07c2817278db15$export$657220afecfe252).SKIP);
    },
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"authenticator-list-title\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
                "name": "title",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 81
                    },
                    "end": {
                        "line": 1,
                        "column": 90
                    }
                }
            }) : helper)) + "</div>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "subtitle") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 96
                    },
                    "end": {
                        "line": 1,
                        "column": 174
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "subtitleLinkOptions") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(2, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 174
                    },
                    "end": {
                        "line": 1,
                        "column": 383
                    }
                }
            })) != null ? stack1 : "");
        },
        "1": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p class=\"authenticator-list-subtitle\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "subtitle") || (depth0 != null ? lookupProperty(depth0, "subtitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "subtitle",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 151
                    },
                    "end": {
                        "line": 1,
                        "column": 163
                    }
                }
            }) : helper)) + "</p>";
        },
        "2": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = container.lambda, alias2 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"authenticator-list-subtitle-link-container\"><a href=" + alias2(alias1((stack1 = depth0 != null ? lookupProperty(depth0, "subtitleLinkOptions") : depth0) != null ? lookupProperty(stack1, "href") : stack1, depth0)) + " target=\"_blank\" rel=\"noopener noreferrer\" >" + alias2(alias1((stack1 = depth0 != null ? lookupProperty(depth0, "subtitleLinkOptions") : depth0) != null ? lookupProperty(stack1, "label") : stack1, depth0)) + "</a></div>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"list-content\">" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "showTitle") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 26
                    },
                    "end": {
                        "line": 1,
                        "column": 390
                    }
                }
            })) != null ? stack1 : "") + "</div>";
        },
        "useData": true
    }),
    getTemplateData: function() {
        // In the legacy (pre-N-of-M) path the presence of a `skip` remediation
        // implies the authenticators are all optional, so we use it as the trigger
        // for the "Optional" title. In the N-of-M grouped path the caller always
        // supplies `listTitle` explicitly (Required now / Required soon), so this
        // fallback is only consulted when a section title wasn't passed in.
        const title = this.hasOptionalFactors ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.setup.optional', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.setup.required', 'login');
        // showTitle defaults to true; N-of-M group cards render an internal member
        // list without a section title (the card supplies its own "Choose N of:" label).
        const showTitle = this.options.showTitle !== false;
        return {
            title: this.options.listTitle || title,
            subtitle: this.options.listSubtitle || null,
            subtitleLinkOptions: this.options.listSubtitleLinkOptions || null,
            showTitle: showTitle
        };
    }
});














/**
 * N-of-M authenticator group card. Renders a bordered container that wraps a
 * group's unenrolled members with:
 *   - an optional group-level grace-period block at the top (BY_DATE_TIME or
 *     BY_SKIP_COUNT — same visual formats as per-authenticator grace period)
 *   - a "Choose {remaining} of:" label chip
 *   - the member rows themselves, rendered by the existing AuthenticatorEnrollOptions
 *     ListView (with its section title suppressed) so per-row DOM matches today's
 *     bare-authenticator rendering exactly
 *
 * `data-se="authenticator-enroll-group-{index}"` on the card wrapper — positional
 * index, never leaks the opaque `groupId` per the contract.
 */ var $d1a7e3d540eb8b43$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'authenticator-enroll-group-card',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"authenticator-grace-period-container\"><span class=\"authenticator-grace-period-required-icon\"></span><div class=\"authenticator-grace-period-text-container\"><p class=\"authenticator-grace-period-required-description\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "gracePeriodRequiredDescription") || (depth0 != null ? lookupProperty(depth0, "gracePeriodRequiredDescription") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
                "name": "gracePeriodRequiredDescription",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 264
                    },
                    "end": {
                        "line": 1,
                        "column": 298
                    }
                }
            }) : helper)) + "</p>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "gracePeriodExpiry") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 302
                    },
                    "end": {
                        "line": 1,
                        "column": 424
                    }
                }
            })) != null ? stack1 : "") + "</div></div>";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p class=\"authenticator-grace-period-expiry-date\" translate=\"no\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "gracePeriodExpiry") || (depth0 != null ? lookupProperty(depth0, "gracePeriodExpiry") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "gracePeriodExpiry",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 392
                    },
                    "end": {
                        "line": 1,
                        "column": 413
                    }
                }
            }) : helper)) + "</p>";
        },
        "2": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "gracePeriodRemainingSkipsDescription") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(3, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 436
                    },
                    "end": {
                        "line": 1,
                        "column": 768
                    }
                }
            })) != null ? stack1 : "";
        },
        "3": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"authenticator-grace-period-container\"><span class=\"authenticator-grace-period-required-icon\"></span><div class=\"authenticator-grace-period-text-container\"><p class=\"authenticator-grace-period-skip-count-description\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "gracePeriodRemainingSkipsDescription") || (depth0 != null ? lookupProperty(depth0, "gracePeriodRemainingSkipsDescription") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "gracePeriodRemainingSkipsDescription",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 712
                    },
                    "end": {
                        "line": 1,
                        "column": 752
                    }
                }
            }) : helper)) + "</p></div></div>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "gracePeriodRequiredDescription") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.program(2, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 775
                    }
                }
            })) != null ? stack1 : "") + "<span class=\"authenticator-enroll-group-card__label\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "labelId") || (depth0 != null ? lookupProperty(depth0, "labelId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "labelId",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 832
                    },
                    "end": {
                        "line": 1,
                        "column": 843
                    }
                }
            }) : helper)) + "\" data-se=\"authenticator-enroll-group-card-label\" >" + alias4((helper = (helper = lookupProperty(helpers, "chooseLabel") || (depth0 != null ? lookupProperty(depth0, "chooseLabel") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "chooseLabel",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 894
                    },
                    "end": {
                        "line": 1,
                        "column": 909
                    }
                }
            }) : helper)) + "</span><div class=\"authenticator-enroll-group-card__members\"></div>";
        },
        "useData": true
    }),
    attributes: function() {
        return {
            'data-se': `authenticator-enroll-group-${this.options.groupIndex}`,
            // role=group + aria-labelledby lets AT users hear the "Choose N of" chip
            // as the region name — critical when the same authenticator (e.g. Okta
            // Verify in two overlapping groups) renders once per card and the button
            // labels alone are identical across cards.
            'role': 'group',
            'aria-labelledby': `authenticator-enroll-group-${this.options.groupIndex}-label`
        };
    },
    initialize: function() {
        // Members inside a card should not render per-authenticator grace period —
        // the group's grace period at the top of the card is authoritative for the
        // whole set. Clone each member to clear its gracePeriod without mutating
        // the shared optionItems array.
        const members = this.options.members.map((member)=>({
                ...member,
                relatesTo: {
                    ...member.relatesTo,
                    gracePeriod: null
                }
            }));
        this.add(new (0, $a998513b4bbeae97$export$2e2bcd8739ae039)({
            ...this.options,
            collection: new (0, $5d64eb84267ab4e8$export$fb8073518f34e6ec)(members),
            optionItems: members,
            showTitle: false
        }), '.authenticator-enroll-group-card__members');
    },
    getTemplateData: function() {
        const { group: group, groupIndex: groupIndex, remaining: remaining } = this.options;
        // `remaining` is passed pre-clamped from the container (min of group.remaining
        // and members.length). Fall back to the raw group value only if omitted, so
        // any future direct instantiation still renders.
        const effectiveRemaining = typeof remaining === 'number' ? remaining : group.remaining;
        const chooseLabel = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enrollment.group.choose.n.of', 'login', [
            effectiveRemaining
        ]);
        const gracePeriodData = this._getGroupGracePeriodData(group.gracePeriod);
        return {
            chooseLabel: chooseLabel,
            labelId: `authenticator-enroll-group-${groupIndex}-label`,
            ...gracePeriodData
        };
    },
    // Same shape / same locale keys as the per-authenticator grace period in
    // AuthenticatorEnrollOptions#_getGracePeriodData — the design intentionally
    // reuses the visual format, so the strings are shared too.
    _getGroupGracePeriodData: function(gracePeriod) {
        if (!gracePeriod) return {};
        const byDateTimeData = this._byDateTimeGracePeriodData(gracePeriod);
        if (byDateTimeData) return byDateTimeData;
        return this._bySkipCountGracePeriodData(gracePeriod);
    },
    // Returns { gracePeriodRequiredDescription, gracePeriodExpiry } iff the
    // grace period's expiry is present and still in the future; otherwise null
    // (caller falls through to BY_SKIP_COUNT).
    _byDateTimeGracePeriodData: function(gracePeriod) {
        var _this$options$setting;
        if (!gracePeriod.expiry) return null;
        const currentTimestampMs = Date.now();
        const gracePeriodEpochTimestampMs = new Date(gracePeriod.expiry).getTime();
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(gracePeriodEpochTimestampMs) || currentTimestampMs >= gracePeriodEpochTimestampMs) return null;
        const remainingDays = (0, $40aeee952775c03c$export$2e2bcd8739ae039).calculateDaysBetween(currentTimestampMs, gracePeriodEpochTimestampMs);
        const gracePeriodExpiry = (0, $40aeee952775c03c$export$2e2bcd8739ae039).formatDateToDeviceAssuranceGracePeriodExpiryLocaleString(new Date(gracePeriodEpochTimestampMs), (_this$options$setting = this.options.settings) === null || _this$options$setting === void 0 ? void 0 : _this$options$setting.get('languageTags'), false);
        return {
            gracePeriodRequiredDescription: this._requiredDescription(remainingDays),
            gracePeriodExpiry: gracePeriodExpiry
        };
    },
    _requiredDescription: function(remainingDays) {
        if (remainingDays === 1) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enrollment.policy.grace.period.required.in.one.day', 'login');
        if (remainingDays > 1) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enrollment.policy.grace.period.required.in.days', 'login', [
            remainingDays
        ]);
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enrollment.policy.grace.period.required.today', 'login');
    },
    _bySkipCountGracePeriodData: function(gracePeriod) {
        if (!(gracePeriod.remainingSkips > 0)) return {};
        if (gracePeriod.remainingSkips === 1) return {
            gracePeriodRemainingSkipsDescription: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enrollment.policy.grace.period.required.in.one.skip', 'login')
        };
        return {
            gracePeriodRemainingSkipsDescription: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enrollment.policy.grace.period.required.in.number.of.skips', 'login', [
                gracePeriod.remainingSkips
            ])
        };
    }
});













const $2e6a2f233afa0ef1$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
    className: 'button-primary button skip-all',
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.setup.remind.me.later', 'login');
    },
    click: function() {
        this.options.appState.trigger('invokeAction', (0, $4a07c2817278db15$export$657220afecfe252).SKIP);
    }
});













const $ca77e283e7a0445a$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
    className: 'button-primary button skip-all',
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.optional.authenticator.button.title', 'login');
    },
    click: function() {
        this.options.appState.trigger('invokeAction', (0, $4a07c2817278db15$export$657220afecfe252).SKIP);
    }
});



// Title-only wrapper for sections that contain nothing but group cards. Emits
// the same .authenticator-list-title / .authenticator-list-subtitle DOM as
// AuthenticatorEnrollOptions#getTemplateData produces, so existing selectors
// (e.g. .authenticator-list .authenticator-list-title in the page objects)
// keep working — but skips the empty ListView shell around zero rows.
// Carries `authenticator-list` on the root so shared page-object selectors like
// `.authenticator-list .authenticator-list-title` still resolve when a section
// has no bare rows (only cards).
const $a4d906b39104eabf$var$AuthenticatorEnrollSectionHeader = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'authenticator-list authenticator-list-header',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p class=\"authenticator-list-subtitle\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "subtitle") || (depth0 != null ? lookupProperty(depth0, "subtitle") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "subtitle",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 134
                    },
                    "end": {
                        "line": 1,
                        "column": 146
                    }
                }
            }) : helper)) + "</p>";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = container.lambda, alias2 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"authenticator-list-subtitle-link-container\"><a href=" + alias2(alias1((stack1 = depth0 != null ? lookupProperty(depth0, "subtitleLinkOptions") : depth0) != null ? lookupProperty(stack1, "href") : stack1, depth0)) + " target=\"_blank\" rel=\"noopener noreferrer\">" + alias2(alias1((stack1 = depth0 != null ? lookupProperty(depth0, "subtitleLinkOptions") : depth0) != null ? lookupProperty(stack1, "label") : stack1, depth0)) + "</a></div>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"list-content\"><div class=\"authenticator-list-title\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
                "name": "title",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 64
                    },
                    "end": {
                        "line": 1,
                        "column": 73
                    }
                }
            }) : helper)) + "</div>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "subtitle") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 79
                    },
                    "end": {
                        "line": 1,
                        "column": 157
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "subtitleLinkOptions") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 157
                    },
                    "end": {
                        "line": 1,
                        "column": 365
                    }
                }
            })) != null ? stack1 : "") + "</div>";
        },
        "useData": true
    }),
    getTemplateData: function() {
        return {
            title: this.options.title,
            subtitle: this.options.subtitle || null,
            subtitleLinkOptions: this.options.subtitleLinkOptions || null
        };
    }
});
const $a4d906b39104eabf$var$isGracePeriodExpiryStillActive = (expiry)=>{
    const currentTimestampMs = Date.now();
    const gracePeriodTimestampMs = new Date(expiry).getTime();
    // using isNaN as ie11 does not support Number.isNaN
    // eslint-disable-next-line no-restricted-globals
    return !isNaN(gracePeriodTimestampMs) && currentTimestampMs < gracePeriodTimestampMs;
};
const $a4d906b39104eabf$var$hasActivePerAuthGracePeriod = (option)=>{
    var _option$relatesTo;
    const gp = option === null || option === void 0 ? void 0 : (_option$relatesTo = option.relatesTo) === null || _option$relatesTo === void 0 ? void 0 : _option$relatesTo.gracePeriod;
    if (!gp) return false;
    return gp.expiry && $a4d906b39104eabf$var$isGracePeriodExpiryStillActive(gp.expiry) || gp.remainingSkips > 0;
};
const $a4d906b39104eabf$var$hasActiveGroupGracePeriod = (group)=>{
    const gp = group === null || group === void 0 ? void 0 : group.gracePeriod;
    if (!gp) return false;
    return gp.expiry && $a4d906b39104eabf$var$isGracePeriodExpiryStillActive(gp.expiry) || gp.remainingSkips > 0;
};
// Rank each group for display order (see OKTA-1283647):
//   tier 0 → active skip-based grace period (fewer remainingSkips first)
//   tier 1 → active date-based grace period (sooner expiry first)
//   tier 2 → no active grace period (goes to "Required now"; wire order preserved)
const $a4d906b39104eabf$var$getGroupUrgencyRank = (group)=>{
    const gp = group === null || group === void 0 ? void 0 : group.gracePeriod;
    if (!gp) return {
        tier: 2,
        value: 0
    };
    if (typeof gp.remainingSkips === 'number' && gp.remainingSkips > 0) return {
        tier: 0,
        value: gp.remainingSkips
    };
    if (gp.expiry && $a4d906b39104eabf$var$isGracePeriodExpiryStillActive(gp.expiry)) return {
        tier: 1,
        value: new Date(gp.expiry).getTime()
    };
    return {
        tier: 2,
        value: 0
    };
};
const $a4d906b39104eabf$var$sortGroupsByUrgency = (groups)=>[
        ...groups
    ].sort((a, b)=>{
        const ra = $a4d906b39104eabf$var$getGroupUrgencyRank(a);
        const rb = $a4d906b39104eabf$var$getGroupUrgencyRank(b);
        if (ra.tier !== rb.tier) return ra.tier - rb.tier;
        if (ra.tier === 2) return 0;
        return ra.value - rb.value;
    });
// Group membership is per authenticator in the current IDX contract, so an OV
// split into per-method options counts once. Revisit if groups become per-method.
const $a4d906b39104eabf$var$countEnrollableAuthenticators = (members)=>members.map((m)=>{
        var _m$relatesTo$id, _m$relatesTo;
        return (_m$relatesTo$id = (_m$relatesTo = m.relatesTo) === null || _m$relatesTo === void 0 ? void 0 : _m$relatesTo.id) !== null && _m$relatesTo$id !== void 0 ? _m$relatesTo$id : m;
    }).filter((id, i, ids)=>ids.indexOf(id) === i).length;
var $a4d906b39104eabf$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'authenticator-enroll-list-container',
    initialize: function() {
        const groups = this.options.appState.get('authenticatorGroups');
        const hasActiveGroup = Array.isArray(groups) && groups.some((g)=>g && g.remaining > 0);
        this.hasSkipRemediation = !!this.options.appState.hasRemediationObject((0, $4a07c2817278db15$export$657220afecfe252) === null || (0, $4a07c2817278db15$export$657220afecfe252) === void 0 ? void 0 : (0, $4a07c2817278db15$export$657220afecfe252).SKIP);
        // Neither flag applies to the N-of-M grouped path (sections are decided by
        // per-group gracePeriod, not by the presence of a skip remediation), but
        // initialize them so the container's public shape stays stable regardless
        // of which branch we take.
        this.hasOnlyOptional = false;
        this.hasOnlyGracePeriod = false;
        if (hasActiveGroup) this._initWithGroups(groups);
        else this._initLegacy();
    },
    // Existing pre-N-of-M behavior. Kept verbatim so any response that does not
    // carry a top-level authenticatorGroups[] array (or has all groups satisfied)
    // renders byte-identically to today.
    _initLegacy: function() {
        var _this$options$optionI;
        const authenticatorsWithGracePeriod = [];
        const authenticators = [];
        this.options.optionItems.forEach((authenticator)=>{
            if ($a4d906b39104eabf$var$hasActivePerAuthGracePeriod(authenticator)) authenticatorsWithGracePeriod.push(authenticator);
            else authenticators.push(authenticator);
        });
        this.hasOnlyOptional = this.hasSkipRemediation && (authenticatorsWithGracePeriod === null || authenticatorsWithGracePeriod === void 0 ? void 0 : authenticatorsWithGracePeriod.length) === 0;
        this.hasOnlyGracePeriod = this.hasSkipRemediation && ((_this$options$optionI = this.options.optionItems) === null || _this$options$optionI === void 0 ? void 0 : _this$options$optionI.length) === (authenticatorsWithGracePeriod === null || authenticatorsWithGracePeriod === void 0 ? void 0 : authenticatorsWithGracePeriod.length);
        if (authenticators.length) this.add(new (0, $a998513b4bbeae97$export$2e2bcd8739ae039)({
            ...this.options,
            collection: new (0, $5d64eb84267ab4e8$export$fb8073518f34e6ec)(authenticators),
            optionItems: authenticators,
            listTitle: this.hasOnlyOptional ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.setup.optional.short', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.setup.required.now', 'login')
        }));
        if (authenticatorsWithGracePeriod.length) this.add(new (0, $a998513b4bbeae97$export$2e2bcd8739ae039)({
            ...this.options,
            collection: new (0, $5d64eb84267ab4e8$export$fb8073518f34e6ec)(authenticatorsWithGracePeriod),
            optionItems: authenticatorsWithGracePeriod,
            listTitle: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.setup.required.soon', 'login'),
            listSubtitle: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.setup.required.soon.description', 'login'),
            listSubtitleLinkOptions: (0, $aaa5b7e3293b6284$export$27e0c4917f6e596c)(this.options.settings)
        }));
        if (this.hasOnlyGracePeriod) this.add((0, $2e6a2f233afa0ef1$export$2e2bcd8739ae039));
        else if (this.hasOnlyOptional) this.add((0, $ca77e283e7a0445a$export$2e2bcd8739ae039));
    },
    // Bucket a single active group into the appropriate section, mutating the
    // requiredNow/requiredSoon/emitted collections in place. Returns nothing.
    _bucketGroup: function(group, requiredNow, requiredSoon, emitted) {
        const members = this.options.optionItems.filter((opt)=>Array.isArray(opt.groupIds) && opt.groupIds.includes(group.groupId));
        if (members.length === 0) return;
        const groupHasGP = $a4d906b39104eabf$var$hasActiveGroupGracePeriod(group);
        const bucket = groupHasGP ? requiredSoon : requiredNow;
        if (members.length === 1) {
            // Group-of-1 → bare individual, no card wrapper. If the group has a GP,
            // inject it onto the option so the existing per-row grace-period markup
            // picks it up automatically (same visual as legacy per-authenticator GP).
            const [single] = members;
            const decorated = groupHasGP ? {
                ...single,
                relatesTo: {
                    ...single.relatesTo,
                    gracePeriod: group.gracePeriod
                }
            } : single;
            bucket.push({
                kind: 'bare',
                option: decorated
            });
            emitted.push(single);
        } else {
            // Group-of-≥2 → card. Members are cloned inside the card to strip any
            // per-row grace period (group GP wins). Clamp remaining so the
            // "Choose N of:" label never asks for more than OAMP-filtered membership
            // actually offers.
            const remaining = Math.min(group.remaining, $a4d906b39104eabf$var$countEnrollableAuthenticators(members));
            bucket.push({
                kind: 'card',
                group: group,
                members: members,
                remaining: remaining
            });
            members.forEach((m)=>emitted.push(m));
        }
    },
    // N-of-M path. Only fires when the response has at least one REQUIRED group
    // with remaining > 0. Preserves the DOM shape of individual authenticator rows.
    _initWithGroups: function(groups) {
        // Section buckets. Each entry is { kind: 'card', group, members } or
        // { kind: 'bare', option }.
        const requiredNow = [];
        const requiredSoon = [];
        // Track options that have already been placed into a section so the
        // ungrouped-remainder pass doesn't double-render them. Using an array +
        // .includes here rather than Set() to sidestep the shared eslint config
        // which does not enumerate Set among the browser globals.
        const emitted = [];
        $a4d906b39104eabf$var$sortGroupsByUrgency(groups).forEach((group)=>{
            if (group && group.remaining > 0) this._bucketGroup(group, requiredNow, requiredSoon, emitted);
        });
        // Ungrouped options and options whose only groups are already satisfied
        // (remaining == 0). Fall through to the legacy per-authenticator GP path
        // and lead each section; grouped items follow in urgency order.
        const ungroupedNow = [];
        const ungroupedSoon = [];
        this.options.optionItems.forEach((opt)=>{
            if (emitted.includes(opt)) return;
            const bucket = $a4d906b39104eabf$var$hasActivePerAuthGracePeriod(opt) ? ungroupedSoon : ungroupedNow;
            bucket.push({
                kind: 'bare',
                option: opt
            });
        });
        requiredNow.unshift(...ungroupedNow);
        requiredSoon.unshift(...ungroupedSoon);
        this._renderGroupedSection(requiredNow, {
            listTitle: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.setup.required.now', 'login'),
            cardIndexOffset: 0
        });
        this._renderGroupedSection(requiredSoon, {
            listTitle: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.setup.required.soon', 'login'),
            listSubtitle: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.setup.required.soon.description', 'login'),
            listSubtitleLinkOptions: (0, $aaa5b7e3293b6284$export$27e0c4917f6e596c)(this.options.settings),
            // Continue positional index counting across sections so every card in the
            // response has a unique data-se, matching TestCafe's usage of positional
            // selectors.
            cardIndexOffset: requiredNow.filter((i)=>i.kind === 'card').length
        });
        // Skip / RemindMeLater button. When the backend allows skipping, it emits a
        // `skip` remediation only if some active group has grace period budget left
        // (see contract). In that case we surface RemindMeLater (matches today's
        // legacy grace-period label). No SkipAll in the required-phase group path.
        if (this.hasSkipRemediation) this.add((0, $2e6a2f233afa0ef1$export$2e2bcd8739ae039));
    },
    _renderGroupedSection: function(items, sectionOptions) {
        if (items.length === 0) return;
        // Items render in order. Consecutive bare rows share one ListView; the
        // section title rides on the first ListView, or on a standalone header
        // when the section opens with a card.
        let bareRows = [];
        let cardIndex = sectionOptions.cardIndexOffset || 0;
        let hasTitle = false;
        const flushBareRows = ()=>{
            if (bareRows.length === 0) return;
            this.add(new (0, $a998513b4bbeae97$export$2e2bcd8739ae039)({
                ...this.options,
                collection: new (0, $5d64eb84267ab4e8$export$fb8073518f34e6ec)(bareRows),
                optionItems: bareRows,
                showTitle: !hasTitle,
                listTitle: sectionOptions.listTitle,
                listSubtitle: sectionOptions.listSubtitle,
                listSubtitleLinkOptions: sectionOptions.listSubtitleLinkOptions
            }));
            hasTitle = true;
            bareRows = [];
        };
        items.forEach((entry)=>{
            if (entry.kind === 'bare') {
                bareRows.push(entry.option);
                return;
            }
            flushBareRows();
            if (!hasTitle) {
                this.add(new $a4d906b39104eabf$var$AuthenticatorEnrollSectionHeader({
                    title: sectionOptions.listTitle,
                    subtitle: sectionOptions.listSubtitle,
                    subtitleLinkOptions: sectionOptions.listSubtitleLinkOptions
                }));
                hasTitle = true;
            }
            this.add(new (0, $d1a7e3d540eb8b43$export$2e2bcd8739ae039)({
                ...this.options,
                group: entry.group,
                members: entry.members,
                remaining: entry.remaining,
                groupIndex: cardIndex
            }));
            cardIndex += 1;
        });
        flushBareRows();
    }
});












const $809978aa9aa4037d$var$AuthenticatorRow = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'authenticator-row clearfix',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"factor-icon authenticator-icon " + alias3((helper = (helper = lookupProperty(helpers, "iconClassName") || (depth0 != null ? lookupProperty(depth0, "iconClassName") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
                "name": "iconClassName",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 100
                    },
                    "end": {
                        "line": 1,
                        "column": 117
                    }
                }
            }) : helper)) + " custom-logo\" role=\"img\" aria-label=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.auth.logo.aria.label"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 154
                    },
                    "end": {
                        "line": 1,
                        "column": 209
                    }
                }
            })) + "\"></div>";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"factor-icon authenticator-icon " + alias3((helper = (helper = lookupProperty(helpers, "iconClassName") || (depth0 != null ? lookupProperty(depth0, "iconClassName") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
                "name": "iconClassName",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 268
                    },
                    "end": {
                        "line": 1,
                        "column": 285
                    }
                }
            }) : helper)) + "\" role=\"img\" aria-label=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.auth.logo.aria.label"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 310
                    },
                    "end": {
                        "line": 1,
                        "column": 365
                    }
                }
            })) + "\"></div>";
        },
        "2": function(container, depth0, helpers, partials, data) {
            return "authenticator-label--small";
        },
        "3": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p class=\"authenticator-description--text " + alias4((helper = (helper = lookupProperty(helpers, "noTranslateClassName") || (depth0 != null ? lookupProperty(depth0, "noTranslateClassName") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "noTranslateClassName",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 603
                    },
                    "end": {
                        "line": 1,
                        "column": 627
                    }
                }
            }) : helper)) + "\">" + alias4((helper = (helper = lookupProperty(helpers, "description") || (depth0 != null ? lookupProperty(depth0, "description") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "description",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 629
                    },
                    "end": {
                        "line": 1,
                        "column": 644
                    }
                }
            }) : helper)) + "</p>";
        },
        "4": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p class=\"authenticator-enrollment-nickname " + alias4((helper = (helper = lookupProperty(helpers, "noTranslateClassName") || (depth0 != null ? lookupProperty(depth0, "noTranslateClassName") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "noTranslateClassName",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 715
                    },
                    "end": {
                        "line": 1,
                        "column": 739
                    }
                }
            }) : helper)) + "\">" + alias4((helper = (helper = lookupProperty(helpers, "nickname") || (depth0 != null ? lookupProperty(depth0, "nickname") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "nickname",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 741
                    },
                    "end": {
                        "line": 1,
                        "column": 753
                    }
                }
            }) : helper)) + "</p>";
        },
        "5": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "data-se=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "buttonDataSeAttr") || (depth0 != null ? lookupProperty(depth0, "buttonDataSeAttr") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "buttonDataSeAttr",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 837
                    },
                    "end": {
                        "line": 1,
                        "column": 857
                    }
                }
            }) : helper)) + "\"";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"authenticator-icon-container\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "logoUri") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.program(1, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 42
                    },
                    "end": {
                        "line": 1,
                        "column": 380
                    }
                }
            })) != null ? stack1 : "") + "</div><div class=\"authenticator-description\"><div><h3 class=\"authenticator-label no-translate " + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(2, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 474
                    },
                    "end": {
                        "line": 1,
                        "column": 526
                    }
                }
            })) != null ? stack1 : "") + "\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
                "name": "label",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 528
                    },
                    "end": {
                        "line": 1,
                        "column": 537
                    }
                }
            }) : helper)) + "</h3>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "description") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(3, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 542
                    },
                    "end": {
                        "line": 1,
                        "column": 655
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "nickname") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(4, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 655
                    },
                    "end": {
                        "line": 1,
                        "column": 764
                    }
                }
            })) != null ? stack1 : "") + "</div><div class=\"authenticator-button\" " + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "buttonDataSeAttr") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(5, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 804
                    },
                    "end": {
                        "line": 1,
                        "column": 865
                    }
                }
            })) != null ? stack1 : "") + "></div></div>";
        },
        "useData": true
    }),
    postRender: function() {
        (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).prototype.postRender.apply(this, arguments);
        const logoUri = this.model.get('logoUri');
        if (logoUri) this.el.querySelector('.custom-logo').style.backgroundImage = `url(${logoUri})`;
    },
    children: function() {
        return [
            [
                (0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
                    className: 'button select-factor',
                    title: function() {
                        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.verify.authenticator.button.text', 'login');
                    },
                    attributes: {
                        'aria-label': this.model.get('ariaLabel')
                    },
                    click: function() {
                        this.model.trigger('selectAuthenticator', this.model.get('value'));
                    }
                }),
                '.authenticator-button'
            ]
        ];
    },
    minimize: function() {
        this.$el.addClass('authenticator-row-min');
    }
});
var $809978aa9aa4037d$export$2e2bcd8739ae039 = (0, $20176b5b9767e868$export$2e2bcd8739ae039).extend({
    className: 'authenticator-verify-list authenticator-list',
    item: $809978aa9aa4037d$var$AuthenticatorRow,
    itemSelector: '.list-content',
    initialize: function() {
        this.listenTo(this.collection, 'selectAuthenticator', this.handleSelect);
        this.listenTo(this.model, 'invalid', this.handleModelInvalid);
    },
    handleModelInvalid: function(data, error) {
        if (this.options.name in error && !this.model.get(this.options.name)) this.showAuthenticatorRequiredError();
    },
    showAuthenticatorRequiredError: function() {
        const errorSummary = this.collection.length > 1 ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('account.unlock.authenticatorRequired.multiple', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('account.unlock.authenticatorRequired.single', 'login');
        this.model.trigger('error', this.model, {
            responseJSON: {
                errorSummary: errorSummary
            }
        });
    },
    handleSelect: function(data) {
        var _this$model$getProper;
        //If schema contains a required identifier to fill first then validate the form
        const validationError = this.model.validateField('identifier');
        this.model.trigger('clearFormError');
        if ((_this$model$getProper = this.model.getPropertySchema('identifier')) !== null && _this$model$getProper !== void 0 && _this$model$getProper.required && validationError) this.model.trigger('invalid', this.model, validationError);
        else {
            this.model.set(this.options.name, data);
            this.options.appState.trigger('saveForm', this.model);
        }
    },
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            return "<div class=\"list-content\"></div>";
        },
        "useData": true
    })
});

















/*!
 * Copyright (c) 2025-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ let $9ff2aed55a86bb2c$var$readyPromise;
// Public entry point. Idempotent via `readyPromise` so widget remounts reuse
// the same load; resets on rejection so retries can succeed.
function $9ff2aed55a86bb2c$export$f288f2fcedbca2ec(baseUrl) {
    if (!$9ff2aed55a86bb2c$var$readyPromise) $9ff2aed55a86bb2c$var$readyPromise = $9ff2aed55a86bb2c$var$load(baseUrl).catch((e)=>{
        $9ff2aed55a86bb2c$var$readyPromise = undefined;
        throw e;
    });
    return $9ff2aed55a86bb2c$var$readyPromise;
}
// The actual work: fetch worker.js in parallel with the altcha.js script
// load, then install a blob-URL factory so all parallel PoW workers share
// one worker.js fetch. Best-effort — resolves even if the worker blob step
// fails (altcha's own per-instance-fetch factory takes over).
async function $9ff2aed55a86bb2c$var$load(baseUrl) {
    // eslint-disable-next-line compat/compat
    const workerPromise = fetch(`${baseUrl}/worker.js`).then((r)=>r.text()).catch(()=>undefined);
    await $9ff2aed55a86bb2c$var$injectModule(`${baseUrl}/altcha.js`);
    const workerSrc = await workerPromise;
    if (workerSrc !== undefined) {
        const blobUrl = URL.createObjectURL(new Blob([
            workerSrc
        ], {
            type: 'application/javascript'
        }));
        window.altchaCreateWorker = ()=>new Worker(blobUrl);
    }
}
// Promise-wraps a <script type="module"> injection. Resolves on onload,
// rejects on onerror. Kept separate so the load flow reads linearly.
function $9ff2aed55a86bb2c$var$injectModule(src) {
    return new Promise((resolve, reject)=>{
        const script = document.createElement('script');
        script.type = 'module';
        script.src = src;
        script.onload = ()=>resolve();
        script.onerror = ()=>reject(new Error(`Failed to load script: ${src}`));
        document.head.appendChild(script);
    });
}






const $281bd42209505670$var$OktaSignInWidgetOnCaptchaLoadedCallback = 'OktaSignInWidgetOnCaptchaLoaded';
const $281bd42209505670$var$OktaSignInWidgetOnCaptchaSolvedCallback = 'OktaSignInWidgetOnCaptchaSolved';
const $281bd42209505670$var$HCAPTCHA_URL = 'https://hcaptcha.com/1/api.js';
const $281bd42209505670$var$RECAPTCHAV2_URL = 'https://www.google.com/recaptcha/api.js';
const $281bd42209505670$var$ALTCHA_CHALLENGE_PATH = '/api/v1/altcha';
var $281bd42209505670$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'captcha-view',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div id =\"captcha-container\" class=\"" + alias4((helper = (helper = lookupProperty(helpers, "className") || (depth0 != null ? lookupProperty(depth0, "className") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "className",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 63
                    },
                    "end": {
                        "line": 1,
                        "column": 76
                    }
                }
            }) : helper)) + "\" data-sitekey=\"" + alias4((helper = (helper = lookupProperty(helpers, "siteKey") || (depth0 != null ? lookupProperty(depth0, "siteKey") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "siteKey",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 92
                    },
                    "end": {
                        "line": 1,
                        "column": 103
                    }
                }
            }) : helper)) + "\" data-callback=\"" + alias4((helper = (helper = lookupProperty(helpers, "onCaptchaSolvedCallback") || (depth0 != null ? lookupProperty(depth0, "onCaptchaSolvedCallback") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "onCaptchaSolvedCallback",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 120
                    },
                    "end": {
                        "line": 1,
                        "column": 147
                    }
                }
            }) : helper)) + "\" data-size=\"invisible\"></div>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "isCaptchaConfigured") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 184
                    }
                }
            })) != null ? stack1 : "";
        },
        "useData": true
    }),
    getTemplateData: function() {
        if (this.captchaConfig) {
            let className;
            if (this.captchaConfig.type === 'ALTCHA') className = 'altcha-captcha';
            else if (this.captchaConfig.type === 'HCAPTCHA') className = 'h-captcha';
            else className = 'g-recaptcha';
            return {
                siteKey: this.captchaConfig.siteKey,
                isCaptchaConfigured: true,
                onCaptchaSolvedCallback: $281bd42209505670$var$OktaSignInWidgetOnCaptchaSolvedCallback,
                className: className
            };
        } else return {};
    },
    initialize: function() {
        if (this.options.appState.get('captcha')) {
            this.captchaConfig = this.options.appState.get('captcha');
            this._addCaptcha();
        }
    },
    remove: function() {
        (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).prototype.remove.apply(this, arguments);
        // Cleanup global Captcha references
        if (this.captchaConfig.type === 'HCAPTCHA') window.hcaptcha = undefined;
        else if (this.captchaConfig.type === 'RECAPTCHA_V2') window.grecaptcha = undefined;
    },
    _getAltchaBase: function() {
        return `${this.options.settings.get('assets.baseUrl')}/altcha`;
    },
    /**
   *  Load the CAPTCHA lib dynamically (either HCAPTCHA or RECAPTCHAV2). Once loaded, trigger an event to inform
   *  the parent form to actually render the CAPTCHA.
  * */ _addCaptcha: function() {
        // Base callback invoked when CAPTCHA is solved.
        const onCaptchaSolvedBase = (token)=>{
            const captchaObject = this._getCaptchaOject();
            // We reset the Captcha. We need to reset because every time the 
            // Captcha resolves back with a token and say we have a server side error, 
            // if we submit the form again it won't work otherwise. The Captcha 
            // has to be reset for it to work again in that scenario.
            const captchaId = this.$el.find('#captcha-container').attr('data-captcha-id');
            captchaObject.reset(captchaId);
            // Set the token in the model
            const fieldName = this.options.name;
            this.model.set(fieldName, token);
        };
        // Callback invoked when reCAPTCHA or HCaptcha is solved.
        const onReCaptchaOrHCaptchaSolved = (token)=>{
            onCaptchaSolvedBase(token);
            // Calls saveForm on the BaseForm to trigger the form submission flow.
            // IdentifierView.saveForm ran BEFORE hCAPTCHA and reCAPTCHA loaded
            this.options.appState.trigger('saveForm', this.model);
        };
        // Callback invoked when ALTCHA is solved.
        const onAltchaSolved = (token)=>{
            onCaptchaSolvedBase(token);
            // Calls saveForm on the parent view (ex. IdentifierView) to trigger the form submission flow.
            // This ensures ParentView.saveForm() runs (for deviceFingerprint, etc. if applicable)
            // and the parent view triggers BaseForm.saveForm().
            this.options.appState.trigger('altchaSolved');
        };
        const setUpTempToken = ()=>{
            // This is just a safeguard to ensure we don't bind Captcha to an already bound element.
            // It shouldn't happen in practice.
            if (this.$el.find('#captcha-container').attr('data-captcha-id')) return;
            // We set a temporary token for Captcha because this is a required field for the form and is normally set
            // at a later time. In order to prevent client-side validation errors because of this, we have to set a 
            // dummy value. We then overwrite this with the proper token in the onCaptchaSolved callback.
            this.model.set(this.options.name, 'tempToken');
        };
        const getAltchaWidgetStrings = ()=>({
                error: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('altcha.error.label', 'login'),
                expired: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('altcha.expired.label', 'login'),
                label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('altcha.label.label', 'login'),
                loading: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('altcha.loading.label', 'login'),
                reload: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('altcha.reload.label', 'login'),
                verify: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('altcha.verify.label', 'login'),
                verificationRequired: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('altcha.verificationRequired.label', 'login'),
                verified: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('altcha.verified.label', 'login'),
                verifying: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('altcha.verifying.label', 'login'),
                waitAlert: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('altcha.waitAlert.label', 'login')
            });
        const altchaCustomFetch = async (url, init)=>{
            const { challengeUrlForm: challengeUrlForm } = this.captchaConfig;
            // If we do not have a challengeUrlForm, we can return window.fetch immediately
            if (!challengeUrlForm) // eslint-disable-next-line compat/compat, no-undef
            return fetch(url, init);
            const { accepts: accepts, method: method, value: value } = challengeUrlForm;
            const newInit = {
                ...init
            };
            if (accepts) newInit.headers = {
                ...newInit.headers,
                'Content-Type': accepts
            };
            if (method) newInit.method = method;
            // Check if the state handle is one of the fields that should be passed in the body
            if (value !== null && value !== void 0 && value.find((field)=>(field === null || field === void 0 ? void 0 : field.name) === 'stateHandle')) newInit.body = JSON.stringify({
                stateHandle: this.options.appState.get('idx').context.stateHandle
            });
            // eslint-disable-next-line compat/compat, no-undef
            return fetch(url, newInit);
        };
        const onAltchaCaptchaLoaded = ()=>{
            var _this$options$setting, _challengeUrlForm$hre;
            setUpTempToken();
            const $container = this.$el.find('#captcha-container');
            const altEl = document.createElement('altcha-widget');
            const challengeUrlFallback = `${(_this$options$setting = this.options.settings.get('baseUrl')) !== null && _this$options$setting !== void 0 ? _this$options$setting : ''}${$281bd42209505670$var$ALTCHA_CHALLENGE_PATH}`;
            const { challengeUrlForm: challengeUrlForm } = this.captchaConfig;
            Object.entries({
                floating: true,
                hidefooter: true,
                hidelogo: true,
                challengeurl: (_challengeUrlForm$hre = challengeUrlForm === null || challengeUrlForm === void 0 ? void 0 : challengeUrlForm.href) !== null && _challengeUrlForm$hre !== void 0 ? _challengeUrlForm$hre : challengeUrlFallback,
                strings: JSON.stringify(getAltchaWidgetStrings())
            }).forEach(([key, value])=>altEl.setAttribute(key, value));
            altEl.customfetch = altchaCustomFetch;
            if (altEl.addEventListener) altEl.addEventListener('verified', (e)=>{
                const token = e && e.detail && e.detail.payload || e;
                onAltchaSolved(token);
                $container.empty();
            });
            window.altcha = altEl;
            $container.empty().append(altEl);
            // mark as bound
            $container.attr('data-captcha-id', 'altcha');
            // notify Baseform
            this.options.appState.trigger('onCaptchaLoaded', altEl);
        };
        // Callback when CAPTCHA lib is loaded
        const onReCaptchaOrHCaptchaLoaded = ()=>{
            setUpTempToken();
            const captchaObject = this._getCaptchaOject();
            const captchaId = captchaObject.render('captcha-container', {
                sitekey: this.captchaConfig.siteKey,
                callback: onReCaptchaOrHCaptchaSolved
            });
            this.$el.find('#captcha-container').attr('data-captcha-id', captchaId);
            // Let the Baseform know that Captcha is loaded.
            this.options.appState.trigger('onCaptchaLoaded', captchaObject);
            // Render the HCAPTCHA footer - we need to do this manually since the HCAPTCHA lib doesn't do it
            if (this.captchaConfig.type === 'HCAPTCHA') this._addHCaptchaFooter();
        };
        // Attaching the callback to the window object so that the CAPTCHA script that we dynamically render
        // can have access to it since it won't have access to this view's scope.
        if (this.captchaConfig.type === 'ALTCHA') window[$281bd42209505670$var$OktaSignInWidgetOnCaptchaLoadedCallback] = onAltchaCaptchaLoaded;
        else window[$281bd42209505670$var$OktaSignInWidgetOnCaptchaLoadedCallback] = onReCaptchaOrHCaptchaLoaded;
        // Attaching the Captcha solved callback to the window object because we reference it in our template under
        // the 'data-callback' attribute which the Captcha library uses to invoke the callback.
        window[$281bd42209505670$var$OktaSignInWidgetOnCaptchaSolvedCallback] = onReCaptchaOrHCaptchaSolved;
        if (this.captchaConfig.type === 'HCAPTCHA') this._loadCaptchaLib(this._getCaptchaUrl($281bd42209505670$var$HCAPTCHA_URL, 'hcaptcha'));
        else if (this.captchaConfig.type === 'RECAPTCHA_V2') this._loadCaptchaLib(this._getCaptchaUrl($281bd42209505670$var$RECAPTCHAV2_URL, 'recaptcha'));
        else if (this.captchaConfig.type === 'ALTCHA') (0, $9ff2aed55a86bb2c$export$f288f2fcedbca2ec)(this._getAltchaBase()).then(onAltchaCaptchaLoaded).catch((e)=>(0, $c95ce7ada2e60396$export$2e2bcd8739ae039).error('Failed to load ALTCHA script', e));
    },
    /**
   *  We dynamically inject <script> tag into our login container because in case the customer is hosting
   *  the SIW, we need to ensure we don't go out of scope when injecting the script.
  * */ _loadCaptchaLib: function(url) {
        let scriptTag = document.createElement('script');
        scriptTag.src = url;
        scriptTag.async = true;
        scriptTag.defer = true;
        document.getElementById((0, $e48c043f6d2d382d$export$2e2bcd8739ae039).WIDGET_CONTAINER_ID).appendChild(scriptTag);
    },
    _addHCaptchaFooter: function() {
        // NOTE: insetAdjacentHTML() is supported in all major browsers: 
        // https://developer.mozilla.org/en-US/docs/Web/API/Element/insertAdjacentHTML#browser_compatibility
        const footerContainer = document.getElementsByClassName((0, $5dcf8c5d7fe7c644$export$781806981de834e0));
        if (footerContainer.length) {
            const template = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                "compiler": [
                    8,
                    ">= 4.3.0"
                ],
                "main": function(container, depth0, helpers, partials, data) {
                    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                        return undefined;
                    };
                    return "<div class=\"captcha-footer\"><span class=\"footer-text\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                        "name": "i18n",
                        "hash": {
                            "$2": "<a href='https://hcaptcha.com/terms' target='_blank'>$2</a>",
                            "$1": "<a href='https://hcaptcha.com/privacy' target='_blank'>$1</a>",
                            "bundle": "login",
                            "code": "hcaptcha.footer.label"
                        },
                        "data": data,
                        "loc": {
                            "start": {
                                "line": 1,
                                "column": 54
                            },
                            "end": {
                                "line": 1,
                                "column": 238
                            }
                        }
                    })) + "</span></div>";
                },
                "useData": true
            });
            footerContainer[0].insertAdjacentHTML('beforeend', template());
        }
    },
    _getCaptchaOject: function() {
        // Return the appropriate global captcha object for the configured type.
        if (this.captchaConfig.type === 'HCAPTCHA') return window.hcaptcha;
        if (this.captchaConfig.type === 'RECAPTCHA_V2') return window.grecaptcha;
        if (this.captchaConfig.type === 'ALTCHA') {
            var _window$altcha;
            // Altcha may expose different globals or be used as a web component.
            return (_window$altcha = window.altcha) !== null && _window$altcha !== void 0 ? _window$altcha : null;
        }
        return null;
    },
    /**
   *  Supported params for hCaptcha script:
   *   https://github.com/hCaptcha/hcaptcha-loader#props
   *   (starting from 'apihost')
   *  Supported params for reCAPTCHA script:
   *   https://developers.google.com/recaptcha/docs/display#javascript_resource_apijs_parameters
  * */ _getCaptchaUrl: function(defaultBaseUrl, settingsKey) {
        const locale = this.options.settings.get('language');
        const scriptSource = this.options.settings.get(`${settingsKey}.scriptSource`);
        const scriptParams = this.options.settings.get(`${settingsKey}.scriptParams`);
        const baseUrl = scriptSource || defaultBaseUrl;
        // Altcha is a web component / module; don't append reCAPTCHA/hCaptcha-specific query params.
        if (settingsKey === 'altcha') return baseUrl;
        const params = {
            ...scriptParams,
            onload: $281bd42209505670$var$OktaSignInWidgetOnCaptchaLoadedCallback,
            render: 'explicit',
            hl: locale || navigator.language
        };
        const query = (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).searchParamsToString(params);
        return baseUrl + '?' + query;
    }
});


const $34fae8eb13c47425$export$b24cdc6a45cb7d17 = (text, maxWidth)=>{
    // Create a temporary element and attach it to the document so we can compare the client width to the 
    // max width allowed.
    const elem = document.createElement('div');
    elem.style.position = 'absolute';
    elem.style.left = '-9999px';
    elem.style.whiteSpace = 'nowrap';
    elem.innerHTML = text;
    document.body.appendChild(elem);
    const result = elem.clientWidth;
    document.body.removeChild(elem);
    return result > maxWidth;
};
const $34fae8eb13c47425$var$createAuthenticatorEnrollSelectView = (opt)=>{
    const optionItems = (opt.options || []).map((opt)=>{
        return Object.assign({}, opt, (0, $3ddabee037f3f019$export$62811b8ba2f1ade2)(opt));
    });
    return {
        View: (0, $a4d906b39104eabf$export$2e2bcd8739ae039),
        options: {
            name: opt.name,
            optionItems: optionItems,
            collection: new (0, $5d64eb84267ab4e8$export$fb8073518f34e6ec)(optionItems)
        }
    };
};
const $34fae8eb13c47425$var$createAuthenticatorVerifySelectView = (opt)=>{
    let optionItems = opt.options || [];
    // If webauthn enrollments > 1 just show one entry with a generic namne (first) so user doesnt have to select which
    // one to pick. eg) If there is yubikey5 and another unknown u2f key, user cannot identify that easily. We need to
    // do this at least  until users can give authenticator enrollments custom names.
    const authSet = new Set();
    optionItems = optionItems.filter((opt)=>{
        let isDuplicate;
        if (opt.authenticatorKey === (0, $4a07c2817278db15$export$a7895cc4b0944d1b).WEBAUTHN) {
            isDuplicate = authSet.has(opt.authenticatorKey);
            authSet.add(opt.authenticatorKey);
        } else if (opt.authenticatorKey === (0, $4a07c2817278db15$export$a7895cc4b0944d1b).CUSTOM_APP) {
            var _opt$value, _opt$value2;
            // Filter the duplicate enrollment by id for custom app. 
            isDuplicate = authSet.has(opt === null || opt === void 0 ? void 0 : (_opt$value = opt.value) === null || _opt$value === void 0 ? void 0 : _opt$value.id);
            authSet.add(opt === null || opt === void 0 ? void 0 : (_opt$value2 = opt.value) === null || _opt$value2 === void 0 ? void 0 : _opt$value2.id);
        }
        return !isDuplicate;
    });
    optionItems = optionItems.map((opt)=>{
        return Object.assign({}, opt, (0, $3ddabee037f3f019$export$1681b06d00e0dc73)(opt));
    });
    return {
        View: (0, $809978aa9aa4037d$export$2e2bcd8739ae039),
        options: {
            name: opt.name,
            collection: new (0, $5d64eb84267ab4e8$export$fb8073518f34e6ec)(optionItems)
        }
    };
};
const $34fae8eb13c47425$var$createAdminScopesView = ()=>{
    return {
        View: (0, $e5403bac0188cec8$export$2e2bcd8739ae039)
    };
};
const $34fae8eb13c47425$var$createEnduserScopesView = ()=>{
    return {
        View: (0, $876c6f9715951231$export$2e2bcd8739ae039)
    };
};
const $34fae8eb13c47425$var$createCaptchaView = (opt)=>{
    return {
        View: (0, $281bd42209505670$export$2e2bcd8739ae039),
        options: {
            name: opt.name
        }
    };
};
const $34fae8eb13c47425$var$inputCreationStrategy = {
    authenticatorEnrollSelect: $34fae8eb13c47425$var$createAuthenticatorEnrollSelectView,
    authenticatorVerifySelect: $34fae8eb13c47425$var$createAuthenticatorVerifySelectView,
    ['admin-consent']: $34fae8eb13c47425$var$createAdminScopesView,
    ['consent']: $34fae8eb13c47425$var$createEnduserScopesView,
    ['captcha']: $34fae8eb13c47425$var$createCaptchaView
};
// TODO: move logic to uiSchemaTransformer
const $34fae8eb13c47425$export$185802fd694ee1f5 = function(uiSchemaObj) {
    const strategyFn = $34fae8eb13c47425$var$inputCreationStrategy[uiSchemaObj.type] || (0, $3e490973b7383cc4$export$2e2bcd8739ae039).identity;
    return strategyFn(uiSchemaObj);
};
const $34fae8eb13c47425$var$createPIVButton = (settings, appState)=>{
    const pivIdp = appState.get('remediations').filter((idp)=>idp.name === (0, $4a07c2817278db15$export$657220afecfe252).PIV_IDP);
    if (pivIdp.length < 1) return [];
    const pivConfig = settings.get('piv');
    const className = pivConfig.className || '';
    return [
        {
            attributes: {
                'data-se': 'piv-card-button'
            },
            className: className + ' piv-button',
            title: pivConfig.text || (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('piv.cac.card', 'login'),
            click: (e)=>{
                e.preventDefault();
                appState.trigger('switchForm', (0, $4a07c2817278db15$export$657220afecfe252).PIV_IDP);
            }
        }
    ];
};
/**
 * Example of `redirect-idp` remediation.
 * {
 *   "name": "redirect-idp",
 *   "type": "MICROSOFT",
 *   "idp": {
 *      "id": "0oa2szc1K1YPgz1pe0g4",
 *      "name": "Microsoft IDP"
 *    },
 *   "href": "http://localhost:3000/sso/idps/0oa2szc1K1YPgz1pe0g4?stateToken=BB...AA",
 *   "method": "GET"
 * }
 *
 */ const $34fae8eb13c47425$export$b76b6826e7ff17cc = ({ settings: settings, appState: appState })=>{
    // This is the max allowable text width that we can display for IDP buttons.
    // Generated by taking the 316px width of button minus padding-left (90 px) and padding-right (50px)
    const MAX_IDP_BUTTON_WIDTH = 186;
    const redirectIdpRemediations = appState.get('remediations').filter((idp)=>idp.name === (0, $4a07c2817278db15$export$657220afecfe252).REDIRECT_IDP);
    if (!Array.isArray(redirectIdpRemediations)) return [];
    // create piv button
    const pivButton = $34fae8eb13c47425$var$createPIVButton(settings, appState);
    //add buttons from idp object
    const idpButtons = redirectIdpRemediations.map((idpObject)=>{
        var _idpObject$type;
        let type = (_idpObject$type = idpObject.type) === null || _idpObject$type === void 0 ? void 0 : _idpObject$type.toLowerCase();
        let displayName;
        if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).contains((0, $9d4da218102d472c$export$2e2bcd8739ae039).SUPPORTED_SOCIAL_IDPS, type)) {
            var _idpObject$idp;
            type = 'general-idp';
            // OKTA-396684 - makes sure that custom idps always have a name
            displayName = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('customauth.sign.in.with.label', 'login', [
                (_idpObject$idp = idpObject.idp) === null || _idpObject$idp === void 0 ? void 0 : _idpObject$idp.name
            ]);
        } else displayName = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(`socialauth.${type}.label`, 'login');
        const classNames = [
            'social-auth-button',
            `social-auth-${type}-button`
        ];
        if (type === 'general-idp') classNames.push('no-translate');
        if (idpObject.idp.className) classNames.push(idpObject.idp.className);
        const button = {
            attributes: {
                'data-se': `social-auth-${type}-button`
            },
            className: classNames.join(' '),
            title: displayName,
            href: idpObject.href
        };
        if ($34fae8eb13c47425$export$b24cdc6a45cb7d17(displayName, MAX_IDP_BUTTON_WIDTH)) // We add a tooltip in case the name gets truncated if too long
        button.attributes.title = displayName;
        return button;
    });
    return [
        ...pivButton,
        ...idpButtons
    ];
};
const $34fae8eb13c47425$export$6b10cc80caac7c62 = (settings)=>{
    const customButtons = settings.get('customButtons');
    return customButtons.map((customButton)=>{
        const button = {
            attributes: {
                'data-se': customButton.dataAttr
            },
            className: customButton.className + ' default-custom-button',
            title: customButton.title || (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(customButton.i18nKey, 'login'),
            click: customButton.click
        };
        return button;
    });
};
const $34fae8eb13c47425$export$4364fcc20473fc30 = (customButtonSettings)=>{
    return (0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
        ...customButtonSettings,
        className: `${customButtonSettings.className} default-custom-button button-primary`
    });
};


const { FormUtil: $990ed38344fe8376$var$FormUtil } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).views.forms.helpers;
const $990ed38344fe8376$var$INFO_MESSAGE_CLASS = 'INFO';
var $990ed38344fe8376$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$a7fed597f4b8afd8).extend({
    layout: 'o-form-theme',
    className: 'ion-form',
    hasSavingState: true,
    autoSave: false,
    noCancelButton: true,
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oform.title.authenticate', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oform.next', 'login');
    },
    modelEvents: {
        'clearFormError': 'handleClearFormError',
        'error': 'triggerAfterError'
    },
    initialize: function() {
        const uiSchemas = this.getUISchema();
        const inputOptions = uiSchemas.map((0, $34fae8eb13c47425$export$185802fd694ee1f5));
        //should be used before adding any other input components
        this.showMessages();
        // Render CAPTCHA if one of the form fields requires us to.
        this.listenTo(this.options.appState, 'onCaptchaLoaded', (captchaObject)=>{
            this.captchaObject = captchaObject;
        });
        // When ALTCHA captcha is solved, trigger the form's save flow
        // This ensures IdentifierView.saveForm() runs (for deviceFingerprint, etc.)
        this.listenTo(this.options.appState, 'altchaSolved', ()=>{
            this.trigger('save', this.model);
        });
        inputOptions.forEach((input)=>{
            this.addInputOrView(input);
        });
        this.listenTo(this, 'save', this.saveForm);
        this.listenTo(this, 'cancel', this.cancelForm);
    },
    focus: function(...args) {
        if (this.settings.get('features.autoFocus')) (0, $5d64eb84267ab4e8$export$a7fed597f4b8afd8).prototype.focus.apply(this, args);
    },
    handleClearFormError: function() {
        const formErrorContainer = this.$('.o-form-error-container');
        formErrorContainer.empty();
        if (formErrorContainer.hasClass('o-form-has-errors')) this.clearErrors();
    },
    triggerAfterError: function(model, error) {
        this.options.appState.trigger('afterError', error);
    },
    saveForm: function(model) {
        //remove any existing warnings or messages before saving form
        this.$el.find('.o-form-error-container').empty();
        // Execute Captcha if enabled for this form.
        if (this.captchaObject && (this.captchaObject.tagName || '').toUpperCase() !== 'ALTCHA-WIDGET') this.captchaObject.execute();
        else this.options.appState.trigger('saveForm', model);
    },
    postRender: function() {
        /**
     * Widget would use infoContainer to display interactive messages that should be persisted during
     * invalid form submissions. For eg resend-warning callout should not be cleared upon invalid form submit.
     * Rerender would clear infoContainer or views classes can clear it explicitly.
     */ let infoContainer = this.$el.find('.o-form-info-container');
        if (!infoContainer.length) {
            this.add('<div class="o-form-info-container"></div>');
            infoContainer = this.$el.find('.o-form-info-container');
        }
        this.$el.find('.o-form-error-container').attr('role', 'alert').before(infoContainer);
        this.addIdentifier();
    },
    /**
   * Render user identifier below title, or if no title, render below message.
   */ addIdentifier: function() {
        const { identifier: identifier } = this.options.appState.get('user') || {};
        if (!identifier) return;
        else if (!this.settings.get('features.showIdentifier')) return;
        const header = this.$el.find('[data-se="o-form-head"]');
        const identifierHTMLString = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
            "compiler": [
                8,
                ">= 4.3.0"
            ],
            "main": function(container, depth0, helpers, partials, data) {
                var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                    return undefined;
                };
                return "<div class=\"identifier-container\"><span class=\"identifier no-translate\" data-se=\"identifier\" title=\"" + alias4((helper = (helper = lookupProperty(helpers, "identifier") || (depth0 != null ? lookupProperty(depth0, "identifier") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                    "name": "identifier",
                    "hash": {},
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 100
                        },
                        "end": {
                            "line": 1,
                            "column": 114
                        }
                    }
                }) : helper)) + "\">" + alias4((helper = (helper = lookupProperty(helpers, "identifier") || (depth0 != null ? lookupProperty(depth0, "identifier") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                    "name": "identifier",
                    "hash": {},
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 116
                        },
                        "end": {
                            "line": 1,
                            "column": 130
                        }
                    }
                }) : helper)) + "</span></div>";
            },
            "useData": true
        })({
            identifier: identifier
        });
        if (header.length) header.after(identifierHTMLString);
        else this.$el.find('.o-form-error-container').after(identifierHTMLString);
    },
    cancelForm: function() {
        this.options.appState.trigger('invokeAction', 'cancel');
    },
    getUISchema: function() {
        if (Array.isArray(this.options.currentViewState.uiSchema)) return this.options.currentViewState.uiSchema;
        else return [];
    },
    addInputOrView: function(input) {
        if (input.visible === false || input.mutable === false && input.visible !== true) return;
        if (input.View) {
            this.add(input.View, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(input, 'View', 'showWhen'));
            if (input.showWhen) $990ed38344fe8376$var$FormUtil.applyShowWhen(this.last(), input.showWhen);
        } else this.addInput(input);
        if (Array.isArray(input.optionsUiSchemas)) {
            if (this.options.optionUiSchemaConfig[input.name]) {
                const optionUiSchemaIndex = Number(this.options.optionUiSchemaConfig[input.name]);
                const optionUiSchemas = input.optionsUiSchemas[optionUiSchemaIndex] || [];
                optionUiSchemas.forEach(this.addInputOrView.bind(this));
            }
        }
    },
    /*
  * Views should override this function to render custom error callouts for invalid form actions.
  * Should return true when callout is customized
  */ showCustomFormErrorCallout: null,
    /*
   * Renders the contents of messages object (if any, on error) during initialize
   * This function is called during Form.initialize, and will display
   * messages when the form reloads.
   * Note: Any user action related form errors handled by FormController.showFormErrors
   */ showMessages: function(options) {
        const messages = this.options.appState.get('messages') || {};
        const errContainer = '.o-form-error-container';
        if (Array.isArray(messages.value) && !(options instanceof (0, $5d64eb84267ab4e8$export$27a5bd065ad55220))) {
            this.add('<div class="ion-messages-container"></div>', errContainer);
            messages.value.forEach((obj)=>{
                if (!(obj !== null && obj !== void 0 && obj.class) || obj.class === $990ed38344fe8376$var$INFO_MESSAGE_CLASS) // add message as plain text
                this.add(`<p>${obj.message}</p>`, '.ion-messages-container');
                else {
                    var _obj$class;
                    const errorObj = {
                        class: (_obj$class = obj === null || obj === void 0 ? void 0 : obj.class) !== null && _obj$class !== void 0 ? _obj$class : '',
                        message: obj === null || obj === void 0 ? void 0 : obj.message,
                        title: '',
                        ...options
                    };
                    this.add((0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)({
                        content: errorObj.message,
                        type: errorObj.class.toLowerCase(),
                        title: errorObj.title
                    }), errContainer);
                    options = null; // prevent repeating first error message
                }
            });
        } else if (options instanceof (0, $5d64eb84267ab4e8$export$27a5bd065ad55220)) // if callee is showCustomFormErrorCallout. show custom error views
        this.add(options, errContainer);
    }
});













var $00a836505a81684a$export$2e2bcd8739ae039 = {
    startPolling: function(newRefreshInterval) {
        this.fixedPollingInterval = this.options.currentViewState.refresh;
        this.dynamicPollingInterval = newRefreshInterval;
        this.countDownCounterValue = Math.ceil(this.pollingInterval / (0, $5dcf8c5d7fe7c644$export$d31c30443e10a36c));
        // Poll is present in remediation form
        if (this.fixedPollingInterval) this._startRemediationPolling();
        else // Poll is present in authenticator/ authenticator Enrollment obj.
        // Authenticator won't co-exists hence it's safe to trigger both.
        this._startAuthenticatorPolling();
    },
    _startAuthenticatorPolling: function() {
        // Authenticator won't co-exists hence it's safe to trigger both.
        [
            'currentAuthenticator',
            'currentAuthenticatorEnrollment'
        ].some((responseKey)=>{
            if (this.options.appState.has(responseKey)) {
                var _authenticator$poll;
                const authenticator = this.options.appState.get(responseKey);
                const authenticatorPollAction = `${responseKey}-poll`;
                const pollInterval = this.dynamicPollingInterval || (authenticator === null || authenticator === void 0 ? void 0 : (_authenticator$poll = authenticator.poll) === null || _authenticator$poll === void 0 ? void 0 : _authenticator$poll.refresh);
                if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isNumber(pollInterval)) this.polling = setTimeout(()=>{
                    this.options.appState.trigger('invokeAction', authenticatorPollAction);
                }, pollInterval);
                return true;
            } else return false;
        });
    },
    _startRemediationPolling: function() {
        const pollInterval = this.dynamicPollingInterval || this.fixedPollingInterval;
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isNumber(pollInterval)) this.polling = setTimeout(()=>{
            this.options.appState.trigger('saveForm', this.model);
        }, pollInterval);
    },
    stopPolling: function() {
        if (this.polling) {
            clearTimeout(this.polling);
            this.polling = null;
        }
    }
};



var $d4b3dcf2c8899dc4$export$2e2bcd8739ae039 = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend(Object.assign({
    initialize: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        this.listenTo(this.options.appState, 'change:dynamicRefreshInterval', this.updateRefreshInterval);
    },
    updateRefreshInterval: function() {
        if (this.polling) {
            this.stopPolling();
            this.startPolling(this.options.appState.get('dynamicRefreshInterval'));
        }
    }
}, (0, $00a836505a81684a$export$2e2bcd8739ae039)));































function $cbe16f34ebe007b2$export$bd982dadfebec6e1(deviceChallengeUrl, loginHint) {
    if (deviceChallengeUrl && loginHint) deviceChallengeUrl += '&login_hint=' + loginHint;
    return deviceChallengeUrl;
}
const $cbe16f34ebe007b2$var$LNAErrorViewContent = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "chrome.lna.error.description.intro"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 65
                    }
                }
            })) + "<ol class=\"chrome-lna-error-steps\"><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "chrome.lna.error.description.step1"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 104
                    },
                    "end": {
                        "line": 1,
                        "column": 169
                    }
                }
            })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "chrome.lna.error.description.step2"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 178
                    },
                    "end": {
                        "line": 1,
                        "column": 243
                    }
                }
            })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "chrome.lna.error.description.step3"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 252
                    },
                    "end": {
                        "line": 1,
                        "column": 317
                    }
                }
            })) + "</li></ol>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "$1": "<a href='#' target='_blank' rel='noopener noreferrer' class='chrome-lna-help-link'>$1</a>",
                    "bundle": "login",
                    "code": "chrome.lna.error.description.more.information"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 327
                    },
                    "end": {
                        "line": 1,
                        "column": 498
                    }
                }
            }));
        },
        "useData": true
    }),
    getTemplateData: function() {
        this.chromeLNAHelpLink = this.options.chromeLNAHelpLink;
    },
    render: function() {
        (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).prototype.render.apply(this, arguments);
        if (this.chromeLNAHelpLink) this.$el.find('.chrome-lna-help-link').attr('href', this.chromeLNAHelpLink);
    }
});
function $cbe16f34ebe007b2$var$addLNAErrorView(view, chromeLNAHelpLink) {
    view.add((0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)({
        title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('chrome.lna.error.title', 'login'),
        content: new $cbe16f34ebe007b2$var$LNAErrorViewContent({
            chromeLNAHelpLink: chromeLNAHelpLink
        }),
        type: 'error'
    }));
}
function $cbe16f34ebe007b2$var$addLoopbackView(view, deviceChallenge) {
    view.add((0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
        className: 'loopback-content',
        template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
            "compiler": [
                8,
                ">= 4.3.0"
            ],
            "main": function(container, depth0, helpers, partials, data) {
                return "<div class=\"spinner\"></div>";
            },
            "useData": true
        })
    }));
    view.doLoopback(deviceChallenge);
}
function $cbe16f34ebe007b2$var$updateChromeLNATitle(view, newTitle) {
    view.title = newTitle;
    if (view.$ && view.$('.okta-form-title').length) view.$('.okta-form-title').text(newTitle);
}
// If there is no previous form name, it is a silent probe triggered by the registered condition.
// Silent probes never surface LNA remediation. Used by the after-probe-failure path
// (BaseOktaVerifyChallengeView) for the WebView2 iframe enhancement. See OKTA-1135857.
function $cbe16f34ebe007b2$export$246ce66868e601e(view) {
    var _view$options, _view$options$appStat;
    return ((_view$options = view.options) === null || _view$options === void 0 ? void 0 : (_view$options$appStat = _view$options.appState) === null || _view$options$appStat === void 0 ? void 0 : _view$options$appStat.get('previousFormName')) === undefined;
}
// Clears the current content and renders the Chrome Local Network Access remediation
// callout, then throws ChromeLNADeniedError for Sentry monitoring. Used by the
// after-probe-failure path (BaseOktaVerifyChallengeView) for the WebView2 iframe
// enhancement. See OKTA-1135857.
function $cbe16f34ebe007b2$export$1f20a7dad73527a1(view, deviceChallenge) {
    var _deviceChallenge$chro;
    $cbe16f34ebe007b2$var$updateChromeLNATitle(view, (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('chrome.lna.fastpass.requires.permission.title', 'login'));
    $cbe16f34ebe007b2$var$addLNAErrorView(view, (_deviceChallenge$chro = deviceChallenge.chromeLocalNetworkAccessDetails) === null || _deviceChallenge$chro === void 0 ? void 0 : _deviceChallenge$chro.chromeLNAHelpLink);
    // Log error for Sentry monitoring
    throw new (0, $3fe6932680e7ea64$export$595ec2a9d48f1ef8)('Chrome Local Network Access permission was denied for FastPass.');
}
function $cbe16f34ebe007b2$var$handlePermissionState(view, currPermissionState, deviceChallenge) {
    view.removeChildren();
    switch(currPermissionState){
        case 'prompt':
        case 'granted':
            $cbe16f34ebe007b2$var$updateChromeLNATitle(view, (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('deviceTrust.sso.redirectText', 'login'));
            $cbe16f34ebe007b2$var$addLoopbackView(view, deviceChallenge);
            break;
        case 'denied':
            // If there is no previous form name, it is a silent probe triggered by the registered condition
            if ($cbe16f34ebe007b2$export$246ce66868e601e(view)) {
                $cbe16f34ebe007b2$var$updateChromeLNATitle(view, (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('deviceTrust.sso.redirectText', 'login'));
                $cbe16f34ebe007b2$var$addLoopbackView(view, deviceChallenge);
            } else $cbe16f34ebe007b2$export$1f20a7dad73527a1(view, deviceChallenge);
            break;
        default:
            $cbe16f34ebe007b2$var$updateChromeLNATitle(view, (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('deviceTrust.sso.redirectText', 'login'));
            $cbe16f34ebe007b2$var$addLoopbackView(view, deviceChallenge);
            break;
    }
}
function $cbe16f34ebe007b2$export$f7c4f163a089df21(view, fromView) {
    var _view$options2, _view$options2$settin;
    const deviceChallenge = view.getDeviceChallengePayload();
    const { chromeLocalNetworkAccessDetails: chromeLocalNetworkAccessDetails } = deviceChallenge || {};
    const loginHint = (_view$options2 = view.options) === null || _view$options2 === void 0 ? void 0 : (_view$options2$settin = _view$options2.settings) === null || _view$options2$settin === void 0 ? void 0 : _view$options2$settin.get('identifier');
    const HIDE_CLASS = 'hide';
    switch(deviceChallenge.challengeMethod){
        case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).LOOPBACK_CHALLENGE:
            view.title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('deviceTrust.sso.redirectText', 'login');
            // WebView2 iframe enhancement (OKTA-1135857): treat the enhancement as enabled
            // unless the flag is explicitly false, so behavior is preserved if the backend
            // later removes the field from the response.
            if (chromeLocalNetworkAccessDetails && chromeLocalNetworkAccessDetails.iframeRenderedInWebView2ContextEnhancementEnabled === false) (0, $22893d6dea78fc87$export$2e2bcd8739ae039).getChromeLNAPermissionState((currPermissionState)=>$cbe16f34ebe007b2$var$handlePermissionState(view, currPermissionState, deviceChallenge));
            else // When enabled, skip the upfront LNA permission check and probe first.
            // Remediation is surfaced only after the probe fails (see
            // BaseOktaVerifyChallengeView.doLoopback).
            $cbe16f34ebe007b2$var$addLoopbackView(view, deviceChallenge);
            break;
        case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).CUSTOM_URI_CHALLENGE:
            view.title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('customUri.title', 'login');
            view.add((0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                className: 'skinny-content',
                template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                    "compiler": [
                        8,
                        ">= 4.3.0"
                    ],
                    "main": function(container, depth0, helpers, partials, data) {
                        var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                            return undefined;
                        };
                        return "<p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                            "name": "i18n",
                            "hash": {
                                "bundle": "login",
                                "code": "customUri.required.content.prompt"
                            },
                            "data": data,
                            "loc": {
                                "start": {
                                    "line": 1,
                                    "column": 3
                                },
                                "end": {
                                    "line": 1,
                                    "column": 67
                                }
                            }
                        })) + "</p>";
                    },
                    "useData": true
                })
            }));
            view.add((0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
                className: 'ul-button button button-wide button-primary',
                title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oktaVerify.open.button', 'login'),
                id: 'launch-ov',
                click: ()=>{
                    view.doCustomURI();
                }
            }));
            view.add((0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                className: 'skinny-content',
                template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                    "compiler": [
                        8,
                        ">= 4.3.0"
                    ],
                    "main": function(container, depth0, helpers, partials, data) {
                        var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                            return undefined;
                        };
                        return "<p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                            "name": "i18n",
                            "hash": {
                                "bundle": "login",
                                "code": "customUri.required.content.download.title"
                            },
                            "data": data,
                            "loc": {
                                "start": {
                                    "line": 1,
                                    "column": 3
                                },
                                "end": {
                                    "line": 1,
                                    "column": 75
                                }
                            }
                        })) + "</p><p><a href=\"" + alias3((helper = (helper = lookupProperty(helpers, "downloadOVLink") || (depth0 != null ? lookupProperty(depth0, "downloadOVLink") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
                            "name": "downloadOVLink",
                            "hash": {},
                            "data": data,
                            "loc": {
                                "start": {
                                    "line": 1,
                                    "column": 91
                                },
                                "end": {
                                    "line": 1,
                                    "column": 109
                                }
                            }
                        }) : helper)) + "\" target=\"_blank\" id=\"download-ov\" class=\"link\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                            "name": "i18n",
                            "hash": {
                                "bundle": "login",
                                "code": "customUri.required.content.download.linkText"
                            },
                            "data": data,
                            "loc": {
                                "start": {
                                    "line": 1,
                                    "column": 157
                                },
                                "end": {
                                    "line": 1,
                                    "column": 232
                                }
                            }
                        })) + "</a></p>";
                    },
                    "useData": true
                }),
                getTemplateData: function() {
                    return {
                        downloadOVLink: deviceChallenge.downloadHref
                    };
                }
            }));
            view.customURI = $cbe16f34ebe007b2$export$bd982dadfebec6e1(deviceChallenge.href, loginHint);
            view.doCustomURI();
            break;
        case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).UNIVERSAL_LINK_CHALLENGE:
            view.title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('universalLink.title', 'login');
            view.add((0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                className: 'universal-link-content',
                template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                    "compiler": [
                        8,
                        ">= 4.3.0"
                    ],
                    "main": function(container, depth0, helpers, partials, data) {
                        var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                            return undefined;
                        };
                        return "<div class=\"spinner\"></div>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                            "name": "i18n",
                            "hash": {
                                "bundle": "login",
                                "code": "universalLink.content"
                            },
                            "data": data,
                            "loc": {
                                "start": {
                                    "line": 1,
                                    "column": 27
                                },
                                "end": {
                                    "line": 1,
                                    "column": 79
                                }
                            }
                        }));
                    },
                    "useData": true
                })
            }));
            view.add((0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
                className: 'ul-button button button-wide button-primary',
                title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oktaVerify.open.button', 'login'),
                click: ()=>{
                    // only window.location.href can open universal link in iOS/MacOS
                    // other methods won't do, ex, AJAX get or form get (Util.redirectWithFormGet)
                    let deviceChallengeUrl = $cbe16f34ebe007b2$export$bd982dadfebec6e1(deviceChallenge.href, loginHint);
                    (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).redirect(deviceChallengeUrl);
                }
            }));
            break;
        case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).APP_LINK_CHALLENGE:
            view.title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('appLink.title', 'login');
            view.add((0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                className: 'app-link-content',
                template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                    "compiler": [
                        8,
                        ">= 4.3.0"
                    ],
                    "main": function(container, depth0, helpers, partials, data) {
                        var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                            return undefined;
                        };
                        return "<div class=\"spinner " + alias4((helper = (helper = lookupProperty(helpers, "hideClass") || (depth0 != null ? lookupProperty(depth0, "hideClass") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                            "name": "hideClass",
                            "hash": {},
                            "data": data,
                            "loc": {
                                "start": {
                                    "line": 1,
                                    "column": 20
                                },
                                "end": {
                                    "line": 1,
                                    "column": 33
                                }
                            }
                        }) : helper)) + "\"></div><div class=\"appLinkContent " + alias4((helper = (helper = lookupProperty(helpers, "hideClass") || (depth0 != null ? lookupProperty(depth0, "hideClass") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                            "name": "hideClass",
                            "hash": {},
                            "data": data,
                            "loc": {
                                "start": {
                                    "line": 1,
                                    "column": 68
                                },
                                "end": {
                                    "line": 1,
                                    "column": 81
                                }
                            }
                        }) : helper)) + "\">" + alias4((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                            "name": "i18n",
                            "hash": {
                                "bundle": "login",
                                "code": "appLink.content"
                            },
                            "data": data,
                            "loc": {
                                "start": {
                                    "line": 1,
                                    "column": 83
                                },
                                "end": {
                                    "line": 1,
                                    "column": 129
                                }
                            }
                        })) + "</div>";
                    },
                    "useData": true
                }),
                getTemplateData: function() {
                    return {
                        hideClass: HIDE_CLASS
                    };
                },
                postRender: function() {
                    if (fromView === (0, $5dcf8c5d7fe7c644$export$553bba1f918a5420)) {
                        this.$('.spinner').removeClass(HIDE_CLASS);
                        setTimeout((0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(()=>{
                            const data = {
                                label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('goback', 'login')
                            };
                            this.options.appState.trigger('updateFooterLink', data);
                            this.$('.spinner').addClass(HIDE_CLASS);
                            this.$('.appLinkContent').removeClass(HIDE_CLASS);
                        }, this), (0, $5dcf8c5d7fe7c644$export$f18c34395bdcb9dd));
                    } else this.$('.appLinkContent').removeClass(HIDE_CLASS);
                }
            }));
            view.add((0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
                className: `${HIDE_CLASS} al-button button button-wide button-primary`,
                title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oktaVerify.open.button', 'login'),
                click: ()=>{
                    // only window.location.href can open app link in Android
                    // other methods won't do, ex, AJAX get or form get (Util.redirectWithFormGet)
                    let deviceChallengeUrl = $cbe16f34ebe007b2$export$bd982dadfebec6e1(deviceChallenge.href, loginHint);
                    (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).redirect(deviceChallengeUrl, window, true);
                },
                postRender: function() {
                    if (fromView === (0, $5dcf8c5d7fe7c644$export$553bba1f918a5420)) setTimeout((0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(()=>{
                        this.$el.removeClass(HIDE_CLASS);
                    }, this), (0, $5dcf8c5d7fe7c644$export$f18c34395bdcb9dd));
                    else this.$el.removeClass(HIDE_CLASS);
                }
            }));
            break;
        case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).CHROME_DTC:
            // reusing the existing message for Chrome DTC
            view.title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('deviceTrust.sso.redirectText', 'login');
            view.add((0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                className: 'chrome-dtc-content',
                template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                    "compiler": [
                        8,
                        ">= 4.3.0"
                    ],
                    "main": function(container, depth0, helpers, partials, data) {
                        return "<div class=\"spinner\"></div>";
                    },
                    "useData": true
                })
            }));
            view.doChromeDTC(deviceChallenge);
            break;
    }
}
function $cbe16f34ebe007b2$export$2620436be5963374(appState, pollingCancelAction, cancelReason, statusCode, showFormErrors) {
    const actionParams = {};
    actionParams[0, $5dcf8c5d7fe7c644$export$6e7b234bec626d3e] = cancelReason;
    actionParams[0, $5dcf8c5d7fe7c644$export$2941f2d12c9205c] = statusCode;
    appState.trigger('invokeAction', pollingCancelAction, actionParams, showFormErrors);
}
function $cbe16f34ebe007b2$var$getBiometricsOrPinCalloutOptions() {
    return {
        type: 'error',
        className: 'okta-verify-uv-callout-content',
        title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics_or_pin.title', 'login'),
        subtitle: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics_or_pin.description', 'login'),
        bullets: [
            (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics_or_pin.point1', 'login'),
            (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics_or_pin.point2', 'login')
        ]
    };
}
function $cbe16f34ebe007b2$var$getWindowsBiometricsCalloutOptions() {
    return {
        type: 'error',
        className: 'okta-verify-uv-callout-content',
        title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.windows.title', 'login'),
        subtitle: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.windows.description', 'login'),
        bullets: [
            (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.windows.point1', 'login'),
            (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.windows.point2', 'login')
        ]
    };
}
function $cbe16f34ebe007b2$var$getBiometricsCalloutOptions(isDesktop) {
    const bulletPoints = [
        (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point1', 'login'),
        (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point2', 'login'),
        (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point3', 'login')
    ];
    // Add an additional bullet point for desktop devices
    if (isDesktop) bulletPoints.push((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point4', 'login'));
    return {
        type: 'error',
        className: 'okta-verify-uv-callout-content',
        title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.title', 'login'),
        subtitle: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.description', 'login'),
        bullets: bulletPoints
    };
}
function $cbe16f34ebe007b2$export$1d274422d455f5b9(error, isMessageObj) {
    var _error$value$, _error$responseJSON;
    const errorSummaryKeys = isMessageObj ? Object.values(error === null || error === void 0 ? void 0 : (_error$value$ = error.value[0]) === null || _error$value$ === void 0 ? void 0 : _error$value$.i18n) : error === null || error === void 0 ? void 0 : (_error$responseJSON = error.responseJSON) === null || _error$responseJSON === void 0 ? void 0 : _error$responseJSON.errorSummaryKeys;
    const hasKey = (key)=>!!errorSummaryKeys && errorSummaryKeys.includes(key);
    if (hasKey((0, $5dcf8c5d7fe7c644$export$14b789590758b77b))) return $cbe16f34ebe007b2$var$getWindowsBiometricsCalloutOptions();
    if (hasKey((0, $5dcf8c5d7fe7c644$export$c5d5df2b86b06bbc)) || hasKey((0, $5dcf8c5d7fe7c644$export$99760f0e4fa6d0a6))) return $cbe16f34ebe007b2$var$getBiometricsOrPinCalloutOptions();
    const isDesktop = hasKey((0, $5dcf8c5d7fe7c644$export$21ec211902d7e608));
    if (hasKey((0, $5dcf8c5d7fe7c644$export$17cbe7ebed212941)) || isDesktop) return $cbe16f34ebe007b2$var$getBiometricsCalloutOptions(isDesktop);
    return null;
}
function $cbe16f34ebe007b2$export$19624797961a54fb(iFrameId, iFrameSrc) {
    const iFrameView = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
        tagName: 'iframe',
        id: iFrameId,
        attributes: {
            src: iFrameSrc
        },
        initialize: function() {
            this.el.style.display = 'none';
        }
    });
    return iFrameView;
}


/* eslint max-statements: [2, 22] */ const $39d1dd94b85d250f$var$request = (opts)=>{
    const ajaxOptions = Object.assign({
        method: 'GET',
        contentType: 'application/json'
    }, opts);
    return (0, $b51a961f9fe28c76$export$2e2bcd8739ae039).ajax(ajaxOptions);
};
const $39d1dd94b85d250f$export$2e2bcd8739ae039 = (0, $d4b3dcf2c8899dc4$export$2e2bcd8739ae039).extend({
    noButtonBar: true,
    className: 'ion-form device-challenge-poll',
    removed: false,
    events: {
        'click #launch-ov': function(e) {
            e.preventDefault();
            this.doCustomURI();
        }
    },
    pollingCancelAction: (0, $5dcf8c5d7fe7c644$export$1bcaad93666b7579),
    initialize: function() {
        (0, $d4b3dcf2c8899dc4$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        this.removed = false;
        this.listenTo(this.model, 'error', this.onPollingFail);
        this.doChallenge();
        this.startPolling();
    },
    doChallenge: function() {
        (0, $cbe16f34ebe007b2$export$f7c4f163a089df21)(this);
    },
    onPollingFail: function() {
        this.$('.spinner').hide();
        this.stopPolling();
    },
    remove: function() {
        (0, $d4b3dcf2c8899dc4$export$2e2bcd8739ae039).prototype.remove.apply(this, arguments);
        this.removed = true;
        this.stopProbing();
        this.stopPolling();
    },
    getDeviceChallengePayload: function() {
        throw new Error('getDeviceChallengePayload needs to be implemented');
    },
    doLoopback: function(deviceChallenge) {
        let authenticatorDomainUrl = deviceChallenge.domain !== undefined ? deviceChallenge.domain : '';
        let authenticatorHttpsDomainUrl = deviceChallenge.httpsDomain !== undefined ? deviceChallenge.httpsDomain : '';
        let ports = deviceChallenge.ports !== undefined ? deviceChallenge.ports : [];
        let maxNumberOfPorts = ports.length;
        let challengeRequest = deviceChallenge.challengeRequest !== undefined ? deviceChallenge.challengeRequest : '';
        let probeTimeoutMillis = deviceChallenge.probeTimeoutMillis !== undefined ? deviceChallenge.probeTimeoutMillis : 100;
        let currentPort;
        let foundPort = false;
        let ovFailed = false;
        let countFailedPorts = 0;
        const getAuthenticatorUrl = (path, domainUrl)=>{
            return `${domainUrl}:${currentPort}/${path}`;
        };
        const checkPort = (url)=>{
            return $39d1dd94b85d250f$var$request({
                url: url,
                /*
        OKTA-278573 in loopback server, SSL handshake sometimes takes more than 100ms and thus needs additional
        timeout however, increasing timeout is a temporary solution since user will need to wait much longer in
        worst case.
        TODO: Android timeout is temporarily set to 3000ms and needs optimization post-Beta.
        OKTA-365427 introduces probeTimeoutMillis; but we should also consider probeTimeoutMillisHTTPS for
        customizing timeouts in the more costly Android and other (keyless) HTTPS scenarios.
        */ timeout: (0, $22893d6dea78fc87$export$2e2bcd8739ae039).isAndroid() ? 3000 : probeTimeoutMillis
            });
        };
        const onPortFound = (url)=>{
            return $39d1dd94b85d250f$var$request({
                url: url,
                method: 'POST',
                data: JSON.stringify({
                    challengeRequest: challengeRequest
                }),
                timeout: (0, $5dcf8c5d7fe7c644$export$db5e36ddd4cd4e7c // authenticator should respond within 5 min (300000ms) for challenge request
                )
            });
        };
        const onFailure = ()=>{
            (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).error(`Something unexpected happened while we were checking port ${currentPort}.`);
            return (0, $b51a961f9fe28c76$export$2e2bcd8739ae039).Deferred().reject();
        };
        const doProbing = (domainUrl)=>{
            return checkPort(getAuthenticatorUrl('probe', domainUrl)).then(()=>{
                return onPortFound(getAuthenticatorUrl('challenge', domainUrl)).then(()=>{
                    foundPort = true;
                    // this way we can gurantee that
                    // 1. the polling is triggered right away (1ms interval)
                    // 2. Only one polling queue
                    // 3. follwoing polling will continue with refresh interval from previous polling response
                    // NOTE: technically, there could still be concurrency issue where when we called stopPolling,
                    // there is already a polling triggered and hasn't completed yet
                    // but the possibility would be much smaller than previous concurrency issue
                    // this is a best effort change
                    this.stopPolling();
                    this.startPolling(1);
                }).catch((xhr)=>{
                    countFailedPorts++;
                    // Windows and MacOS return status code 503 when
                    // there are multiple profiles on the device and
                    // the wrong OS profile responds to the challenge request
                    if (xhr.status !== 503) {
                        // when challenge responds with other errors,
                        // - stop the remaining probing
                        ovFailed = true;
                        // - cancel polling right away
                        (0, $cbe16f34ebe007b2$export$2620436be5963374)(this.options.appState, this.pollingCancelAction, (0, $5dcf8c5d7fe7c644$export$2f37c9233c87243c).OV_ERROR, xhr.status, !this.removed);
                    } else if (countFailedPorts === maxNumberOfPorts) // when challenge is responded by the wrong OS profile and
                    // all the ports are exhausted,
                    // cancel the polling like the probing has failed
                    (0, $cbe16f34ebe007b2$export$2620436be5963374)(this.options.appState, this.pollingCancelAction, (0, $5dcf8c5d7fe7c644$export$2f37c9233c87243c).LOOPBACK_FAILURE, null, !this.removed);
                });
            }).catch(onFailure);
        };
        let probeChain = Promise.resolve();
        const handlePortProbing = (port, baseUrl, checkPortMaxFailure)=>{
            probeChain = probeChain.then(()=>{
                if (!(foundPort || ovFailed)) {
                    currentPort = port;
                    return doProbing(baseUrl);
                }
            }).catch(()=>{
                countFailedPorts++;
                (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).error(`Authenticator is not listening on port ${currentPort}.`);
                if (checkPortMaxFailure && countFailedPorts === maxNumberOfPorts) {
                    (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).error('No available ports. Loopback server failed and polling is cancelled.');
                    // When no port is found, cancel the polling as well
                    // This is to avoid concurrency issue where /poll/cancel takes long time to complete
                    // and SIW will receive 400 error if the polling continues
                    this.stopPolling();
                    const cancelLoopback = ()=>(0, $cbe16f34ebe007b2$export$2620436be5963374)(this.options.appState, this.pollingCancelAction, (0, $5dcf8c5d7fe7c644$export$2f37c9233c87243c).LOOPBACK_FAILURE, null, !this.removed);
                    // WebView2 iframe enhancement (OKTA-1135857): when enabled, probe
                    // first and re-check the LNA permission only now, after the probe
                    // failed — surface remediation instead of cancelling if it is denied
                    // for an interactive (non-silent) flow. Otherwise cancel as before.
                    // Treat the enhancement as enabled unless the flag is explicitly
                    // false, so behavior is preserved if the backend later removes it.
                    const chromeLNADetails = deviceChallenge.chromeLocalNetworkAccessDetails;
                    if (chromeLNADetails && chromeLNADetails.iframeRenderedInWebView2ContextEnhancementEnabled !== false && !(0, $cbe16f34ebe007b2$export$246ce66868e601e)(this)) {
                        (0, $22893d6dea78fc87$export$2e2bcd8739ae039).getChromeLNAPermissionState((currPermissionState)=>{
                            if (currPermissionState === 'denied') {
                                // Clear the loopback spinner before rendering remediation.
                                // TODO: consider cancel with a new reason OV_UNREACHABLE_BY_LOOPBACK_LNA
                                this.removeChildren();
                                (0, $cbe16f34ebe007b2$export$1f20a7dad73527a1)(this, deviceChallenge);
                            } else cancelLoopback();
                        });
                        return;
                    }
                    cancelLoopback();
                }
            });
        };
        // If https domain exists, do https domain probe first
        // This only applies to MacOS for now
        if (authenticatorHttpsDomainUrl) {
            // if https domain are included, max number of ports to be probed should be doubled
            (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).info('httpsDomain enabled, will probe and challenge https first');
            maxNumberOfPorts += maxNumberOfPorts;
            ports.forEach((port)=>{
                handlePortProbing(port, authenticatorHttpsDomainUrl, false);
            });
        }
        // Always do probe on regular domain
        ports.forEach((port)=>{
            handlePortProbing(port, authenticatorDomainUrl, true);
        });
    },
    doCustomURI: function() {
        this.ulDom && this.ulDom.remove();
        const IframeView = (0, $cbe16f34ebe007b2$export$19624797961a54fb)('custom-uri-container', this.customURI);
        this.ulDom = this.add(IframeView).last();
    },
    doChromeDTC: function(deviceChallenge) {
        this.ulDom && this.ulDom.remove();
        const IframeView = (0, $cbe16f34ebe007b2$export$19624797961a54fb)('chrome-dtc-container', deviceChallenge.href);
        this.ulDom = this.add(IframeView).last();
    },
    stopProbing: function() {
        this.checkPortXhr && this.checkPortXhr.abort();
        this.probingXhr && this.probingXhr.abort();
    }
});


































/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $3e4dc6e3ff66dcfd$var$convertUiSchemaFieldToProp = (uiSchemaField)=>{
    const config = Object.assign({}, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).chain(uiSchemaField).pick('minLength', 'maxLength', 'required', 'value').defaults({
        type: 'string',
        required: true
    }).value());
    if (uiSchemaField.modelType) config.type = uiSchemaField.modelType;
    return {
        [uiSchemaField.name]: config
    };
};
const $3e4dc6e3ff66dcfd$var$createPropsAndLocals = function(remediation = {}, optionUiSchemaConfig = {}, props = {}, local = {}) {
    const uiSchemas = remediation.uiSchema || [];
    uiSchemas.forEach((schema)=>{
        if (Array.isArray(schema.optionsUiSchemas)) {
            let optionUiSchemaIndex;
            let optionUiSchemaValue = {};
            if (Number(schema.value) >= 0) optionUiSchemaIndex = schema.value;
            if (optionUiSchemaConfig[schema.name]) {
                optionUiSchemaValue = {
                    value: optionUiSchemaConfig[schema.name]
                };
                optionUiSchemaIndex = Number(optionUiSchemaValue.value);
            }
            Object.assign(local, $3e4dc6e3ff66dcfd$var$convertUiSchemaFieldToProp(Object.assign({}, schema, optionUiSchemaValue)));
            if (optionUiSchemaIndex) $3e4dc6e3ff66dcfd$var$createPropsAndLocals({
                uiSchema: schema.optionsUiSchemas[optionUiSchemaIndex]
            }, optionUiSchemaConfig, props, local);
        } else Object.assign(props, $3e4dc6e3ff66dcfd$var$convertUiSchemaFieldToProp(schema));
    });
};
const $3e4dc6e3ff66dcfd$var$create = function(remediation = {}, optionUiSchemaConfig = {}) {
    const props = {};
    const local = {
        // current remediation form name
        formName: 'string',
        // use full page redirect instead of AJAX
        useRedirect: 'boolean'
    };
    $3e4dc6e3ff66dcfd$var$createPropsAndLocals(remediation, optionUiSchemaConfig, props, local);
    const BaseModel = (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039).extend({
        props: props,
        local: local
    });
    return BaseModel;
};
var $3e4dc6e3ff66dcfd$export$2e2bcd8739ae039 = {
    create: $3e4dc6e3ff66dcfd$var$create
};




/* eslint complexity: [2, 25] */ const $498610e59ec43767$var$FORMNAME_CLASSNAME_MAPPINGS = {
    [(0, $4a07c2817278db15$export$657220afecfe252).IDENTIFY]: {
        [(0, $4a07c2817278db15$export$657220afecfe252).IDENTIFY]: 'primary-auth',
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).PASSWORD]: 'primary-auth'
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).IDENTIFY_RECOVERY]: {
        [(0, $4a07c2817278db15$export$657220afecfe252).IDENTIFY_RECOVERY]: 'forgot-password'
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).ENROLL_PROFILE]: {
        [(0, $4a07c2817278db15$export$657220afecfe252).ENROLL_PROFILE]: 'registration'
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).CHALLENGE_AUTHENTICATOR]: {
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).EMAIL]: 'mfa-verify-passcode',
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).PASSWORD]: 'mfa-verify-password',
        sms: 'mfa-verify-passcode',
        voice: 'mfa-verify-passcode',
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).SECURITY_QUESTION]: 'mfa-verify-question',
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).WEBAUTHN]: 'mfa-verify-webauthn',
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).ON_PREM]: 'mfa-verify-totp',
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).RSA]: 'mfa-verify-totp',
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).OV]: 'mfa-verify',
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).GOOGLE_OTP]: 'mfa-verify',
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).DUO]: 'mfa-verify-duo',
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).SYMANTEC_VIP]: 'mfa-verify',
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).YUBIKEY]: 'mfa-verify',
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).CUSTOM_APP]: 'mfa-verify'
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).CHALLENGE_POLL]: {
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).OV]: 'mfa-verify',
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).CUSTOM_APP]: 'mfa-verify'
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).RESEND_PUSH]: {
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).OV]: 'mfa-verify',
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).CUSTOM_APP]: 'mfa-verify'
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).ENROLL_AUTHENTICATOR]: {
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).EMAIL]: 'enroll-email',
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).PASSWORD]: 'enroll-password',
        sms: 'enroll-sms',
        voice: 'enroll-call',
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).SECURITY_QUESTION]: 'enroll-question',
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).WEBAUTHN]: 'enroll-webauthn',
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).ON_PREM]: 'enroll-onprem',
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).RSA]: 'enroll-rsa',
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).DUO]: 'enroll-duo',
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).SYMANTEC_VIP]: 'enroll-symantec',
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).YUBIKEY]: 'enroll-yubikey'
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).SELECT_AUTHENTICATOR_ENROLL]: {
        'select-authenticator-enroll': 'enroll-choices'
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).SELECT_AUTHENTICATOR_AUTHENTICATE]: {
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).PASSWORD]: 'forgot-password'
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).REENROLL_AUTHENTICATOR]: {
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).PASSWORD]: 'password-expired'
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).REENROLL_CUSTOM_PASSWORD_EXPIRY]: {
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).PASSWORD]: 'custom-password-expired'
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).REENROLL_CUSTOM_PASSWORD_EXPIRY_WARNING]: {
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).PASSWORD]: 'custom-password-expiry-warning'
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).RESET_AUTHENTICATOR]: {
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).PASSWORD]: 'forgot-password'
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).CONSENT_ADMIN]: {
        [(0, $4a07c2817278db15$export$657220afecfe252).CONSENT_ADMIN]: 'admin-consent-required'
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).CONSENT_ENDUSER]: {
        [(0, $4a07c2817278db15$export$657220afecfe252).CONSENT_ENDUSER]: 'consent-required'
    }
};
const $498610e59ec43767$export$9b06fbbb56522c2f = (formName, authenticatorKey, methodType, isPasswordRecoveryFlow)=>{
    // if password reset flow from identifier page with recoveryAuthenticator add forgot-password class
    if (isPasswordRecoveryFlow && formName === (0, $4a07c2817278db15$export$657220afecfe252).IDENTIFY) return 'forgot-password';
    else {
        let key = formName;
        if (authenticatorKey === (0, $4a07c2817278db15$export$a7895cc4b0944d1b).PHONE) // Both sms and call have same type phone
        // currentAuthenticatorEnrollment is during verify and currentAuthenticator during enroll flows
        key = `${methodType}`;
        else if (authenticatorKey) key = `${authenticatorKey}`;
        if ($498610e59ec43767$var$FORMNAME_CLASSNAME_MAPPINGS[formName] && $498610e59ec43767$var$FORMNAME_CLASSNAME_MAPPINGS[formName][key]) return $498610e59ec43767$var$FORMNAME_CLASSNAME_MAPPINGS[formName][key];
        else return null;
    }
};
const $498610e59ec43767$export$e245415c509021a7 = (formName, authenticatorKey, methodType, isPasswordRecoveryFlow)=>{
    // 1. Generates V2 class name
    // If we have a type which is authenticatorType/methodType use that to generate a V2 className
    // Otherwise just use formName
    let v2ClassName = formName;
    if (authenticatorKey) v2ClassName = v2ClassName + '--' + authenticatorKey;
    // 2. do a lookup for any V1 classNames and concat
    let v1ClassName = $498610e59ec43767$export$9b06fbbb56522c2f(formName, authenticatorKey, methodType, isPasswordRecoveryFlow);
    const result = [
        v2ClassName
    ];
    if (v1ClassName) result.push(v1ClassName);
    return result;
};


var $0add9dbd3c6edb9a$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    Header: (0, $4c0f78fce7387c76$export$2e2bcd8739ae039),
    Body: (0, $990ed38344fe8376$export$2e2bcd8739ae039),
    Footer: (0, $31737d9aae112815$export$2e2bcd8739ae039),
    className: function() {
        const appState = this.options.appState;
        const formName = appState.get('currentFormName');
        const authenticatorKey = appState.get('authenticatorKey');
        const methodType = appState.get('authenticatorMethodType');
        const isPasswordRecoveryFlow = appState.get('isPasswordRecoveryFlow');
        const additionalClassNames = (0, $498610e59ec43767$export$e245415c509021a7)(formName, authenticatorKey, methodType, isPasswordRecoveryFlow);
        const classNames = [
            'siw-main-view'
        ].concat(additionalClassNames);
        return classNames.join(' ');
    },
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            return "<div class=\"siw-main-header\"></div><div class=\"siw-main-body\"></div><div class=\"siw-main-footer\"></div>";
        },
        "useData": true
    }),
    preRender: function() {
        (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).prototype.preRender.apply(this, arguments);
        // Add Views
        if (this.Header !== null) this.add(this.Header, {
            selector: '.siw-main-header',
            options: this.options
        });
        this.renderForm();
        this.add(this.Footer, {
            selector: '.siw-main-footer',
            options: this.options
        });
    },
    renderForm: function() {
        let optionUiSchemaConfig;
        if (this.form) {
            this.form.remove();
            optionUiSchemaConfig = this.form.model.toJSON({
                verbose: true
            });
        }
        // Create Model
        const IonModel = this.createModelClass(this.options.currentViewState, optionUiSchemaConfig, this.settings);
        const model = new IonModel({
            formName: this.options.currentViewState.name
        });
        if (!optionUiSchemaConfig) optionUiSchemaConfig = model.toJSON({
            verbose: true
        });
        this.model = model;
        this.form = this.add(this.Body, {
            selector: '.siw-main-body',
            options: Object.assign({}, this.options, {
                model: model,
                optionUiSchemaConfig: optionUiSchemaConfig
            })
        }).last();
        (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(model.attributes, (value, key)=>{
            if (key.match(/sub_schema_local_[^ ]+/)) // in order to render different sub-schema
            this.listenTo(model, `change:${key}`, ()=>{
                this.renderForm();
            });
        });
    },
    createModelClass: function(currentViewState, optionUiSchemaConfig = {}) {
        return (0, $3e4dc6e3ff66dcfd$export$2e2bcd8739ae039).create(currentViewState, optionUiSchemaConfig);
    }
});





parcelRequire("3ZxP0");
























/*!
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $b18c18e659d9c3dc$export$2e2bcd8739ae039 = {
    generateDeviceFingerprint: function(authClient, container) {
        return authClient.fingerprint({
            timeout: 2000,
            container: container
        });
    }
};





















parcelRequire("3ZxP0");








var $f69e256d99f29568$export$2e2bcd8739ae039 = (0, $31737d9aae112815$export$2e2bcd8739ae039).extend({
    showForgotPasswordLink: function() {
        return !this.options.appState.isIdentifierOnlyView();
    },
    footerInfo: function() {
        const signUpLinkData = (0, $aaa5b7e3293b6284$export$5bdaff50ccf3164)(this.options.appState, this.options.settings);
        let SignUpLinkWithText;
        //Build sign up link view appended with a text. Link class can only build anchor tags
        if (signUpLinkData.length) SignUpLinkWithText = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
            className: 'signup-info',
            template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                "compiler": [
                    8,
                    ">= 4.3.0"
                ],
                "main": function(container, depth0, helpers, partials, data) {
                    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                        return undefined;
                    };
                    return "<span>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                        "name": "i18n",
                        "hash": {
                            "bundle": "login",
                            "code": "registration.signup.label"
                        },
                        "data": data,
                        "loc": {
                            "start": {
                                "line": 1,
                                "column": 6
                            },
                            "end": {
                                "line": 1,
                                "column": 62
                            }
                        }
                    })) + "</span><span class=\"signup-link\"></span>";
                },
                "useData": true
            }),
            initialize: function() {
                this.add((0, $15be617e7228d213$export$2e2bcd8739ae039), '.signup-link', {
                    options: signUpLinkData[0]
                });
            }
        });
        return SignUpLinkWithText;
    },
    links: function() {
        const { appState: appState, settings: settings } = this.options;
        let helpLinkHref;
        if (settings.get('helpLinks.help')) helpLinkHref = settings.get('helpLinks.help');
        else {
            const baseUrl = settings.get('baseUrl');
            helpLinkHref = baseUrl + '/help/login';
        }
        const helpLink = [
            {
                'name': 'help',
                'label': (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('help', 'login'),
                'href': helpLinkHref,
                'target': '_blank'
            }
        ];
        let forgotPasswordLink = [];
        if (this.showForgotPasswordLink()) forgotPasswordLink = (0, $aaa5b7e3293b6284$export$219f3ecb053dc685)(appState, settings);
        const customHelpLinks = [];
        if (settings.get('helpLinks.custom')) //add custom helpLinks
        settings.get('helpLinks.custom').forEach((customHelpLink)=>{
            customHelpLink.name = 'custom';
            customHelpLink.label = customHelpLink.text;
            customHelpLinks.push(customHelpLink);
        });
        const unlockAccountLink = [];
        if (settings.get('helpLinks.unlock')) unlockAccountLink.push({
            'type': 'link',
            'label': (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('unlockaccount', 'login'),
            'name': 'unlock',
            'href': settings.get('helpLinks.unlock')
        });
        else if (appState.hasRemediationObject((0, $4a07c2817278db15$export$657220afecfe252).UNLOCK_ACCOUNT)) unlockAccountLink.push({
            'type': 'link',
            'label': (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('unlockaccount', 'login'),
            'name': 'unlock',
            'actionPath': (0, $4a07c2817278db15$export$657220afecfe252).UNLOCK_ACCOUNT
        });
        return forgotPasswordLink.concat(unlockAccountLink).concat(helpLink).concat(customHelpLinks);
    }
});













const $65737c44ec65d75e$var$IDP_SEARCH_THRESHOLD = 10;
var $65737c44ec65d75e$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'sign-in-with-idp',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"separation-line\"><span>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "socialauth.divider.text"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 64
                    },
                    "end": {
                        "line": 1,
                        "column": 118
                    }
                }
            })) + "</span></div>";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"okta-piv-container\"></div><div class=\"idp-discovery-container\"><label class=\"idp-discovery-search-label\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "idps.search.label"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 282
                    },
                    "end": {
                        "line": 1,
                        "column": 330
                    }
                }
            })) + "</label><div class=\"idp-discovery-search-wrapper\"><input type=\"search\" class=\"idp-discovery-search-input\" data-se=\"idp-search-input\" aria-label=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "idps.search.label"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 475
                    },
                    "end": {
                        "line": 1,
                        "column": 523
                    }
                }
            })) + "\" placeholder=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "idps.search.typeahead.placeholder"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 538
                    },
                    "end": {
                        "line": 1,
                        "column": 602
                    }
                }
            })) + "\" autocomplete=\"off\"></div><div class=\"okta-idps-container\" data-se=\"idp-list-container\"></div><div class=\"idp-no-results\" data-se=\"idp-no-results\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "idps.search.no.results"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 750
                    },
                    "end": {
                        "line": 1,
                        "column": 803
                    }
                }
            })) + "</div></div>";
        },
        "2": function(container, depth0, helpers, partials, data) {
            return "<div class=\"okta-idps-container\"></div>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "isSecondaryIdpDisplay") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 138
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "showSearchContainer") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.program(2, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 138
                    },
                    "end": {
                        "line": 1,
                        "column": 869
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "isPrimaryIdpDisplay") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 869
                    },
                    "end": {
                        "line": 1,
                        "column": 1005
                    }
                }
            })) != null ? stack1 : "");
        },
        "useData": true
    }),
    events: {
        'input .idp-discovery-search-input': '_filterIdps'
    },
    initialize: function() {
        const { idpButtons: idpButtons } = this.options;
        const showSearch = idpButtons.length > $65737c44ec65d75e$var$IDP_SEARCH_THRESHOLD;
        idpButtons.forEach((idpButton)=>{
            const isPiv = idpButton.className && idpButton.className.includes('piv-button');
            const selector = showSearch && isPiv ? '.okta-piv-container' : '.okta-idps-container';
            this.add((0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)(idpButton), selector);
        });
    },
    _filterIdps: function(e) {
        const query = e.target.value.toLowerCase().trim();
        let visibleCount = 0;
        this.$('.okta-idps-container .link-button').each((i, btn)=>{
            const text = (btn.textContent || '').toLowerCase().trim();
            const visible = !query || text.includes(query);
            btn.style.display = visible ? '' : 'none';
            if (visible) visibleCount++;
        });
        if (visibleCount > 0) {
            this.$('.okta-idps-container').show();
            this.$('.idp-no-results').hide();
        } else {
            this.$('.okta-idps-container').hide();
            this.$('.idp-no-results').show();
        }
    },
    getTemplateData: function() {
        const jsonData = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).prototype.getTemplateData.apply(this, arguments);
        const { idpButtons: idpButtons } = this.options;
        const addDivider = idpButtons.length > 0;
        return Object.assign(jsonData, {
            isPrimaryIdpDisplay: addDivider && this.options.isPrimaryIdpDisplay,
            isSecondaryIdpDisplay: addDivider && !this.options.isPrimaryIdpDisplay,
            showSearchContainer: idpButtons.length > $65737c44ec65d75e$var$IDP_SEARCH_THRESHOLD
        });
    }
});












var $e334bf4416240404$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'custom-buttons',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"separation-line\"><span>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "socialauth.divider.text"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 58
                    },
                    "end": {
                        "line": 1,
                        "column": 112
                    }
                }
            })) + "</span></div>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "addSeparateLine") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 132
                    }
                }
            })) != null ? stack1 : "") + "<div class=\"okta-custom-buttons-container primary-auth-container\"></div>";
        },
        "useData": true
    }),
    initialize: function(options) {
        options.customButtons.forEach((idpButton)=>{
            this.add((0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)(idpButton), '.okta-custom-buttons-container');
        });
    },
    getTemplateData: function() {
        const jsonData = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).prototype.getTemplateData.apply(this, arguments);
        return Object.assign(jsonData, {
            addSeparateLine: this.options.addSeparateLine
        });
    }
});

















var $7707bc4039c29f4d$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'sign-in-with-device-option',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            return "<div class=\"signin-with-ov-description\"></div>";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"separation-line\"><span>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "authbutton.divider.text"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 201
                    },
                    "end": {
                        "line": 1,
                        "column": 255
                    }
                }
            })) + "</span></div>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"okta-verify-container\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "signInWithDeviceIsRequired") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 35
                    },
                    "end": {
                        "line": 1,
                        "column": 122
                    }
                }
            })) != null ? stack1 : "") + "</div>" + ((stack1 = lookupProperty(helpers, "unless").call(alias1, depth0 != null ? lookupProperty(depth0, "signInWithDeviceIsRequired") : depth0, {
                "name": "unless",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 128
                    },
                    "end": {
                        "line": 1,
                        "column": 279
                    }
                }
            })) != null ? stack1 : "");
        },
        "useData": true
    }),
    initialize: function() {
        var _deviceChallengePollR;
        const appState = this.options.appState;
        const deviceChallengePollRemediation = appState.hasRemediationObject((0, $4a07c2817278db15$export$657220afecfe252).LAUNCH_AUTHENTICATOR);
        const deviceChallenge = deviceChallengePollRemediation === null || deviceChallengePollRemediation === void 0 ? void 0 : (_deviceChallengePollR = deviceChallengePollRemediation.relatesTo) === null || _deviceChallengePollR === void 0 ? void 0 : _deviceChallengePollR.value;
        this.add((0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
            className: 'button',
            icon: 'okta-verify-authenticator',
            title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oktaVerify.button', 'login'),
            click: function() {
                if (this.model.get('identifier')) this.options.settings.set('identifier', encodeURIComponent(this.model.get('identifier')));
                const isUVapproach = (deviceChallenge === null || deviceChallenge === void 0 ? void 0 : deviceChallenge.challengeMethod) === (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).UNIVERSAL_LINK_CHALLENGE;
                if (isUVapproach) {
                    var _this$options, _this$options$setting;
                    // launch the Okta Verify app
                    let deviceChallengeUrl = (0, $cbe16f34ebe007b2$export$bd982dadfebec6e1)(deviceChallenge.href, (_this$options = this.options) === null || _this$options === void 0 ? void 0 : (_this$options$setting = _this$options.settings) === null || _this$options$setting === void 0 ? void 0 : _this$options$setting.get('identifier'));
                    (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).redirect(deviceChallengeUrl);
                }
                const isAppLinkapproach = (deviceChallenge === null || deviceChallenge === void 0 ? void 0 : deviceChallenge.challengeMethod) === (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).APP_LINK_CHALLENGE;
                if (isAppLinkapproach) {
                    var _this$options2, _this$options2$settin;
                    // launch the Okta Verify app
                    let deviceChallengeUrl = (0, $cbe16f34ebe007b2$export$bd982dadfebec6e1)(deviceChallenge.href, (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : (_this$options2$settin = _this$options2.settings) === null || _this$options2$settin === void 0 ? void 0 : _this$options2$settin.get('identifier'));
                    (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).redirect(deviceChallengeUrl, window, true);
                }
                // OKTA-350084
                // For the universal link (iOS) and app link (Android) approach,
                // we need to 1. launch the Okta Verify app
                // and 2. take the enduser to the next step right away
                // In Safari, when Okta Verify app is not installed, step 1 responds with error immediately,
                // then step 2 will respond with error.
                // To avoid showing the error right before switching to the next UI,
                // wait for 500 milliseconds before invoking step 2
                (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).callAfterTimeout(()=>{
                    if (this.options.isRequired) appState.trigger('saveForm', this.model);
                    else appState.trigger('invokeAction', (0, $4a07c2817278db15$export$657220afecfe252).LAUNCH_AUTHENTICATOR, {
                        'rememberMe': this.model.get('rememberMe')
                    });
                }, isUVapproach || isAppLinkapproach ? (0, $5dcf8c5d7fe7c644$export$e24cfe30a92f580a) : 0);
            }
        }), '.okta-verify-container');
    },
    getTemplateData: function() {
        return {
            signInWithDeviceIsRequired: !!this.options.isRequired
        };
    },
    postRender: function() {
        if (this.options.isRequired) {
            var _this$options$appStat, _this$options$appStat2;
            const appLabel = (_this$options$appStat = this.options.appState.attributes) === null || _this$options$appStat === void 0 ? void 0 : (_this$options$appStat2 = _this$options$appStat.app) === null || _this$options$appStat2 === void 0 ? void 0 : _this$options$appStat2.label;
            const resourceLabel = appLabel ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oktaVerify.appDescription', 'login', [
                appLabel
            ]) : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oktaVerify.description', 'login');
            const ovDescContainer = this.$el.find('.signin-with-ov-description');
            ovDescContainer.text(resourceLabel);
        }
    }
});













var $e1739cc8a92b3cce$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'sign-in-with-nfc-option',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"separation-line\"><span>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "authbutton.divider.text"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 95
                    },
                    "end": {
                        "line": 1,
                        "column": 149
                    }
                }
            })) + "</span></div>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"okta-nfc-container\"></div>" + ((stack1 = lookupProperty(helpers, "unless").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "isRequired") : depth0, {
                "name": "unless",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 38
                    },
                    "end": {
                        "line": 1,
                        "column": 173
                    }
                }
            })) != null ? stack1 : "");
        },
        "useData": true
    }),
    initialize: function() {
        const appState = this.options.appState;
        this.add((0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
            className: 'button',
            icon: 'okta-nfc-authenticator',
            title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.nfc_pin.launch.button', 'login'),
            click: function() {
                if (this.model.get('identifier')) this.options.settings.set('identifier', encodeURIComponent(this.model.get('identifier')));
                appState.trigger('invokeAction', (0, $4a07c2817278db15$export$657220afecfe252).LAUNCH_NFC_AUTHENTICATOR, {
                    'rememberMe': this.model.get('rememberMe')
                });
            }
        }), '.okta-nfc-container');
    },
    getTemplateData: function() {
        return {
            isRequired: !!this.options.isRequired
        };
    }
});













var $4ee15c78e928466c$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'sign-in-with-webauthn-option',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"okta-webauthn-container\"></div><div class=\"separation-line\"><span>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "authbutton.divider.text"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 78
                    },
                    "end": {
                        "line": 1,
                        "column": 132
                    }
                }
            })) + "</span></div>";
        },
        "useData": true
    }),
    initialize: function() {
        this.add((0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
            className: 'button',
            icon: 'okta-webauthn-authenticator',
            title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('signinWithWebAuthn.button', 'login'),
            click: ()=>{
                this.options.appState.trigger('invokeAction', (0, $4a07c2817278db15$export$657220afecfe252).LAUNCH_WEBAUTHN_AUTHENTICATOR);
            }
        }), '.okta-webauthn-container');
    }
});












var $8b7f4f67f61dd691$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'sign-in-with-passkeys-option',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"okta-passkeys-container\"></div><div class=\"separation-line\"><span>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "authbutton.divider.text"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 78
                    },
                    "end": {
                        "line": 1,
                        "column": 132
                    }
                }
            })) + "</span></div>";
        },
        "useData": true
    }),
    initialize: function() {
        this.add((0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
            className: 'button',
            icon: 'okta-passkeys-authenticator',
            title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('signinWithPasskeys.button', 'login'),
            click: ()=>{
                this.options.getCredentialsAndInvokeAction.call(this.options.formView);
            }
        }), '.okta-passkeys-container');
    }
});















var $ccb47a661a4098b1$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'custom-access-denied-error-message',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "message") || (depth0 != null ? lookupProperty(depth0, "message") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "message",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 18
                    },
                    "end": {
                        "line": 1,
                        "column": 29
                    }
                }
            }) : helper)) + "</p>";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<ul class=\"custom-links\">" + ((stack1 = lookupProperty(helpers, "each").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "links") : depth0, {
                "name": "each",
                "hash": {},
                "fn": container.program(2, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 78
                    },
                    "end": {
                        "line": 1,
                        "column": 182
                    }
                }
            })) != null ? stack1 : "") + "</ul>";
        },
        "2": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<li><a href=" + alias4((helper = (helper = lookupProperty(helpers, "url") || (depth0 != null ? lookupProperty(depth0, "url") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "url",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 105
                    },
                    "end": {
                        "line": 1,
                        "column": 112
                    }
                }
            }) : helper)) + " target=\"_blank\" rel=\"noopener noreferrer\">" + alias4((helper = (helper = lookupProperty(helpers, "label") || (depth0 != null ? lookupProperty(depth0, "label") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "label",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 155
                    },
                    "end": {
                        "line": 1,
                        "column": 164
                    }
                }
            }) : helper)) + "</a></li>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "message") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 40
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "links") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 40
                    },
                    "end": {
                        "line": 1,
                        "column": 194
                    }
                }
            })) != null ? stack1 : "");
        },
        "useData": true
    }),
    getTemplateData: function() {
        return {
            message: this.options.message,
            links: this.options.links
        };
    }
});




const $f4e1246ab077b34b$var$CUSTOM_ACCESS_DENIED_KEY = 'security.access_denied_custom_message';
const $f4e1246ab077b34b$var$ABORT_REASON_CLEANUP = 'WebAuthNAutofill component cleanup';
// NFC / FastPass error message keys returned alongside the identify remediation.
// These render as a 2-part callout (bold title + body) at the top of the sign-in form.
const $f4e1246ab077b34b$var$NFC_SIGN_IN_TO_ENROLL_KEY = 'api.authenticator.error.nfc.sign_in_to_use';
const $f4e1246ab077b34b$var$NFC_UNAVAILABLE_KEY = 'api.authenticator.error.nfc.unavailable';
const $f4e1246ab077b34b$var$FASTPASS_BLOCKED_SHARED_DEVICE_KEY = 'api.authenticator.error.fastpass.blocked_shared_device';
const $f4e1246ab077b34b$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('primaryauth.title', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oform.next', 'login');
    },
    focus: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.focus.apply(this, arguments);
        // Auto focus to password field when identifier is prefilled
        if (this.settings.get('features.autoFocus')) {
            const identifierInput = this.getInputs().filter((item)=>{
                return item.options.name === 'identifier';
            })[0];
            const passwordInput = this.getInputs().filter((item)=>{
                return item.options.name === 'credentials.passcode';
            })[0];
            if (identifierInput && identifierInput.model.get('identifier') && passwordInput) passwordInput.focus();
        }
    },
    initialize: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        const uiSchema = this.getUISchema();
        if (uiSchema.find((schema)=>schema.name === 'credentials.passcode')) this.save = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.primaryauth.submit', 'login');
        // listen to error:clear
        this.listenTo(this.model, 'errors:clear', function() {
            this.clearErrors();
        });
        // Precedence for pre-filling identifier field:
        // 1. Use username/identifier from the config.
        // 2. Use identifier value returned in remediation response (model will have this attr set if it's there)
        // 3. Use value from the "remember my username" cookie.
        if (this._shouldAddUsername(uiSchema)) // Set username/identifier from the config (i.e. config.username)
        this.model.set('identifier', this.settings.get('username'));
        else if (!this.model.get('identifier') && this._shouldApplyRememberMyUsername(uiSchema)) // Use value from cookie if the remediation did not return identifier value.
        this._applyRememberMyUsername();
    },
    showMessages: function(options) {
        // When called with a pre-built View (e.g. from showCustomFormErrorCallout),
        // pass it through unchanged so the custom callout renders as-is.
        if (options instanceof (0, $5d64eb84267ab4e8$export$27a5bd065ad55220)) {
            (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.showMessages.call(this, options);
            return;
        }
        // Render error messages as a 2-part callout (bold title + body)
        // when returned alongside the identify remediation.
        const calloutOptions = {};
        const { appState: appState } = this.options;
        if (appState.containsMessageWithI18nKey($f4e1246ab077b34b$var$NFC_SIGN_IN_TO_ENROLL_KEY)) calloutOptions.title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.nfc_pin.sign_in_to_enroll.title', 'login');
        else if (appState.containsMessageWithI18nKey($f4e1246ab077b34b$var$NFC_UNAVAILABLE_KEY)) calloutOptions.title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.nfc_pin.unavailable.title', 'login');
        else if (appState.containsMessageWithI18nKey($f4e1246ab077b34b$var$FASTPASS_BLOCKED_SHARED_DEVICE_KEY)) calloutOptions.title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.okta_verify.fastpass.blocked.title', 'login');
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.showMessages.call(this, calloutOptions);
    },
    saveForm: function() {
        // Before the XHR is made for "identify", we'll generate one-time use fingerprint via
        // a hidden-iframe (similar to authn/v1 flows)
        // Ideally this can be added to a "preSaveForm" handler - but keeping this here for now.
        if (!this.settings.get('features.deviceFingerprinting')) {
            (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.saveForm.apply(this, arguments);
            return;
        }
        // Toggle Form saving status (e.g. disabling save button, etc)
        this.model.trigger('request');
        // For certain flows, we need to generate a device fingerprint
        // to determine if we need to send a "New Device Sign-on Notification".
        const authClient = this.settings.getAuthClient();
        (0, $b18c18e659d9c3dc$export$2e2bcd8739ae039).generateDeviceFingerprint(authClient, this.$el[0]).then((fingerprint)=>{
            this.options.appState.set('deviceFingerprint', fingerprint);
        }).catch(()=>{}).finally(()=>{
            (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.saveForm.apply(this, arguments);
        });
    },
    render: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.render.apply(this, arguments);
        // Launch Device Authenticator
        if (this.options.appState.hasRemediationObject((0, $4a07c2817278db15$export$657220afecfe252).LAUNCH_AUTHENTICATOR)) this.add((0, $7707bc4039c29f4d$export$2e2bcd8739ae039), '.o-form-fieldset-container', false, true, {
            isRequired: false
        });
        if (this.options.appState.hasRemediationObject((0, $4a07c2817278db15$export$657220afecfe252).LAUNCH_NFC_AUTHENTICATOR)) this.add((0, $e1739cc8a92b3cce$export$2e2bcd8739ae039), '.o-form-fieldset-container', false, true, {
            isRequired: false
        });
        if (this.options.appState.hasRemediationObject((0, $4a07c2817278db15$export$657220afecfe252).LAUNCH_WEBAUTHN_AUTHENTICATOR)) this.add((0, $4ee15c78e928466c$export$2e2bcd8739ae039), '.o-form-fieldset-container', false, true, {
            isRequired: false
        });
        // Launch Passkeys Authenticator
        if (this.options.appState.hasRemediationObject((0, $4a07c2817278db15$export$657220afecfe252).LAUNCH_PASSKEYS_AUTHENTICATOR)) this.add((0, $8b7f4f67f61dd691$export$2e2bcd8739ae039), {
            selector: '.o-form-fieldset-container',
            options: {
                getCredentialsAndInvokeAction: this.getCredentialsForModalAndInvokeAction,
                formView: this
            },
            prepend: true // Ensures the button is before the input
        });
        // add forgot password link and external idps buttons if needed
        const idpButtons = (0, $34fae8eb13c47425$export$b76b6826e7ff17cc)(this.options);
        if (Array.isArray(idpButtons) && idpButtons.length) {
            // Add the forgot password link before the buttons for multiple IDPs
            this._addForgotPasswordView();
            this._addIdpView(idpButtons);
        }
        const customButtons = (0, $34fae8eb13c47425$export$6b10cc80caac7c62)(this.options.settings);
        if (Array.isArray(customButtons) && customButtons.length) this.add((0, $e334bf4416240404$export$2e2bcd8739ae039), {
            selector: '.o-form-button-bar',
            options: {
                customButtons: customButtons,
                addSeparateLine: true
            }
        });
    },
    postRender: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.postRender.apply(this, arguments);
        // When a user enters invalid credentials, /introspect returns an error,
        // along with a user object containing the identifier entered by the user.
        this.$el.find('.identifier-container').remove();
        // there is no need to invoke the webauthn API unless we have Autofill UI enabled
        if (this._hasAutofillUIChallenge()) this.getCredentialsAndInvokeAction();
    },
    /**
   * Update UI schemas for customization from .widgetrc.js or Admin Customization settings page.
   * @returns Array
   */ getUISchema: function() {
        const schemas = (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.getUISchema.apply(this, arguments);
        const { settings: settings } = this.options;
        const identifierExplainLabeli18nKey = 'primaryauth.username.tooltip';
        const passwordExplainLabeli18nKey = 'primaryauth.password.tooltip';
        let newSchemas = schemas.map((schema)=>{
            let newSchema = {
                ...schema
            };
            if (schema.name === 'identifier') {
                if ((0, $93a83f6fd41fc21e$export$89d4852ea9ed9572)(identifierExplainLabeli18nKey, settings)) newSchema = {
                    ...newSchema,
                    explain: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(identifierExplainLabeli18nKey, 'login'),
                    'explain-top': true
                };
                // Setting the autocomplete value to 'webauthn' allows the browser to list passkeys alongside usernames
                const autoCompleteDefaultValue = this._hasAutofillUIChallenge() && (0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isConditionalMediationAvailable() ? 'username webauthn' : 'username';
                // We enable the browser's autocomplete for the identifier input
                // because we want to allow the user to choose from previously used identifiers.
                newSchema = {
                    ...newSchema,
                    autoComplete: (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).getAutocompleteValue(this.options.settings, autoCompleteDefaultValue)
                };
            } else if (schema.name === 'credentials.passcode') {
                newSchema = {
                    ...newSchema,
                    autoComplete: (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).getAutocompleteValue(this.options.settings, 'current-password')
                };
                if ((0, $93a83f6fd41fc21e$export$89d4852ea9ed9572)(passwordExplainLabeli18nKey, settings)) newSchema = {
                    ...newSchema,
                    explain: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(passwordExplainLabeli18nKey, 'login'),
                    'explain-top': true
                };
            }
            return newSchema;
        });
        // If showKeepMeSignedIn is explicitly set to false, we ensure we don't display
        // the "Keep me signed in" checkbox
        if (this.settings.get('features.showKeepMeSignedIn') === false) newSchemas = newSchemas.filter((schema)=>schema.name !== 'rememberMe');
        return newSchemas;
    },
    showCustomFormErrorCallout: function(error, messages) {
        var _error$responseJSON, _error$responseJSON$e;
        if (!(error !== null && error !== void 0 && (_error$responseJSON = error.responseJSON) !== null && _error$responseJSON !== void 0 && (_error$responseJSON$e = _error$responseJSON.errorSummaryKeys) !== null && _error$responseJSON$e !== void 0 && _error$responseJSON$e.includes($f4e1246ab077b34b$var$CUSTOM_ACCESS_DENIED_KEY))) return false;
        const message = messages === null || messages === void 0 ? void 0 : messages.find((message)=>message.i18n.key === $f4e1246ab077b34b$var$CUSTOM_ACCESS_DENIED_KEY);
        if (!message) return false;
        const { errorSummary: errorSummary } = error.responseJSON;
        const options = {
            type: 'error',
            content: new (0, $ccb47a661a4098b1$export$2e2bcd8739ae039)({
                message: errorSummary,
                links: message.links
            })
        };
        this.showMessages((0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)(options));
        return true;
    },
    remove: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.remove.apply(this, arguments);
        if (this.webauthnAbortController) {
            this.webauthnAbortController.abort();
            this.webauthnAbortController = null;
        }
    },
    remediateWithAssertion: function(assertion, remediation) {
        var _assertion$response$u;
        if (!assertion || !remediation) return;
        const userHandle = (0, $36d38737859019f5$export$2e2bcd8739ae039).binToStr((_assertion$response$u = assertion.response.userHandle) !== null && _assertion$response$u !== void 0 ? _assertion$response$u : '');
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(userHandle)) {
            const errorSummary = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.webauthn.error.invalidPasskey', 'login');
            this.model.trigger('error', this.model, this._generateErrorObject(errorSummary));
            return;
        }
        const credentials = {
            clientData: (0, $36d38737859019f5$export$2e2bcd8739ae039).binToStr(assertion.response.clientDataJSON),
            authenticatorData: (0, $36d38737859019f5$export$2e2bcd8739ae039).binToStr(assertion.response.authenticatorData),
            signatureData: (0, $36d38737859019f5$export$2e2bcd8739ae039).binToStr(assertion.response.signature),
            userHandle: userHandle
        };
        this.options.appState.trigger('invokeAction', remediation, {
            credentials: credentials
        });
    },
    getCredential: async function(mediation) {
        var _this$options$appStat;
        const challengeData = (_this$options$appStat = this.options.appState.get('webauthnAutofillUIChallenge')) === null || _this$options$appStat === void 0 ? void 0 : _this$options$appStat.challengeData;
        if (!challengeData || typeof AbortController === 'undefined') return;
        // Abort any existing ongoing request
        if (this.webauthnAbortController) this.webauthnAbortController.abort($f4e1246ab077b34b$var$ABORT_REASON_CLEANUP);
        // eslint-disable-next-line compat/compat
        this.webauthnAbortController = new AbortController();
        const publicKey = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({}, challengeData, {
            challenge: (0, $36d38737859019f5$export$2e2bcd8739ae039).strToBin(challengeData.challenge)
        });
        // eslint-disable-next-line compat/compat
        return navigator.credentials.get({
            mediation: mediation,
            publicKey: publicKey,
            signal: this.webauthnAbortController.signal
        });
    },
    /**
   * Shared error handler for navigator.credentials.get() rejections.
   * @param {Error} error - The error thrown by navigator.credentials.get()
   */ _handleWebAuthnError: function(error) {
        // Abort error during cleanup, no need to show error to user
        if (error === $f4e1246ab077b34b$var$ABORT_REASON_CLEANUP) return;
        // If one navigator.credentials call is canceled in order to invoke another one
        // (eg. when we have both Autofill UI and Sign in with a passkey button,
        // or the button is pressed rapidly on iOS)
        // we want to suppress the error and let the user continue with authentication.
        if ((0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isAbortError(error)) return;
        if ((0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isNotAllowedError(error)) {
            const errorSummary = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('signin.passkeys.error', 'login');
            this.model.trigger('error', this.model, this._generateErrorObject(errorSummary));
            return;
        }
        // Do not display if it is abort error triggered by code when switching.
        // this.webauthnAbortController would be null if abort was triggered by code.
        if (this.webauthnAbortController) {
            const errorSummary = (0, $93a83f6fd41fc21e$export$6e5b567ae7e48d0c)(error);
            this.model.trigger('error', this.model, this._generateErrorObject(errorSummary));
        }
    },
    getCredentialsAndInvokeAction: async function() {
        // Ignore if autofill is not available in browser
        if (!await (0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isPasskeyAutofillAvailable()) return;
        return this.getCredential('conditional').then((assertion)=>{
            this.remediateWithAssertion(assertion, (0, $4a07c2817278db15$export$657220afecfe252).CHALLENGE_WEBAUTHN_AUTOFILLUI_AUTHENTICATOR);
        }, (error)=>{
            // Suppress the error shown to the enduser in case of the relying party id mismatch.
            // The error message shown was:
            // "The relying party ID is not a registrable domain suffix of, nor equal to the current domain.
            // Subsequently, an attempt to fetch the .well-known/webauthn resource of the claimed RP ID failed."
            // There is no need to show this error, as it was not triggered by a user action,
            // nor is it stopping the user from proceeding.
            if ((0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isRelyingPartyIdMismatchError(error)) return;
            this._handleWebAuthnError(error);
        });
    },
    getCredentialsForModalAndInvokeAction: async function() {
        // Prevent multiple concurrent passkey prompts from rapid button presses
        if (this._isModalPasskeyInFlight) return;
        this._isModalPasskeyInFlight = true;
        // Clear error before starting
        this.model.trigger('errors:clear');
        // because its user action show that passkey is not available in browser
        if (!(0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isPasskeyAvailable()) {
            this._isModalPasskeyInFlight = false;
            const errorSummary = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('signin.passkeys.error.NotSupportedError', 'login');
            this.model.trigger('error', this.model, this._generateErrorObject(errorSummary));
            return;
        }
        return this.getCredential('optional').then((assertion)=>{
            this.remediateWithAssertion(assertion, (0, $4a07c2817278db15$export$657220afecfe252).LAUNCH_PASSKEYS_AUTHENTICATOR);
        }, (error)=>{
            if ((0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isRelyingPartyIdMismatchError(error)) {
                var _this$options$appStat2, _this$options$appStat3;
                const rpId = (_this$options$appStat2 = this.options.appState.get('webauthnAutofillUIChallenge')) === null || _this$options$appStat2 === void 0 ? void 0 : (_this$options$appStat3 = _this$options$appStat2.challengeData) === null || _this$options$appStat3 === void 0 ? void 0 : _this$options$appStat3.rpId;
                const errorSummary = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('signin.passkeys.error.rpIdMismatch', 'login', [
                    rpId
                ]);
                this.model.trigger('error', this.model, this._generateErrorObject(errorSummary));
                return;
            }
            this._handleWebAuthnError(error);
        }).finally(()=>{
            this._isModalPasskeyInFlight = false;
        });
    },
    _generateErrorObject: function(errorSummary) {
        return {
            responseJSON: {
                errorSummary: errorSummary
            }
        };
    },
    _addForgotPasswordView: function() {
        const forgotPasswordLink = (0, $aaa5b7e3293b6284$export$219f3ecb053dc685)(this.options.appState, this.options.settings);
        if (forgotPasswordLink.length) {
            this.add('<div class="links-primary"></div>', {
                selector: '.o-form-button-bar'
            });
            this.add((0, $15be617e7228d213$export$2e2bcd8739ae039), {
                selector: '.links-primary',
                options: forgotPasswordLink[0]
            });
        }
    },
    _addIdpView: function(idpButtons) {
        // We check the 'idpDisplay' option config to determine whether to render the idp buttons
        // above or below the login fields
        const idpDisplay = this.options.settings.get('idpDisplay');
        const isPrimaryIdpDisplay = idpDisplay && idpDisplay.toUpperCase() === 'PRIMARY';
        this.add((0, $65737c44ec65d75e$export$2e2bcd8739ae039), {
            prepend: isPrimaryIdpDisplay,
            selector: isPrimaryIdpDisplay ? '.o-form-fieldset-container' : '.o-form-button-bar',
            options: {
                idpButtons: idpButtons,
                isPrimaryIdpDisplay: isPrimaryIdpDisplay
            }
        });
    },
    _shouldAddUsername: function(uiSchema) {
        // We pre-populate the identifier/username field only if we're in an identifier
        // form and if the option is passed in.
        return uiSchema.find((schema)=>schema.name === 'identifier') && this.settings.get('username');
    },
    _shouldApplyRememberMyUsername: function(uiSchema) {
        return uiSchema.find((schema)=>schema.name === 'identifier') && this.settings.get('features.rememberMe');
    },
    /**
   * When "Remember My Username" is enabled, we pre-fill the identifier
   * field with the saved userName cookie. The cookie would have been originally
   * saved when submitting the form previously.
   */ _applyRememberMyUsername: function() {
        const cookieUsername = (0, $0077b4018f3faaa0$export$2e2bcd8739ae039).getCookieUsername();
        if (cookieUsername) this.model.set('identifier', cookieUsername);
    },
    _hasAutofillUIChallenge: function() {
        return this.options.appState.hasRemediationObject((0, $4a07c2817278db15$export$657220afecfe252).CHALLENGE_WEBAUTHN_AUTOFILLUI_AUTHENTICATOR);
    }
});
var $f4e1246ab077b34b$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    Body: $f4e1246ab077b34b$var$Body,
    createModelClass: function() {
        const ModelClass = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).prototype.createModelClass.apply(this, arguments);
        // customize pre-submit form validation inline error messages
        const identifierRequiredi18nKey = 'error.username.required';
        const passwordRequiredi18nKey = 'error.password.required';
        const props = ModelClass.prototype.props;
        const validate = (attr)=>{
            const inlineErrors = {};
            const isEmptyIdentifier = props['identifier'] && !(attr !== null && attr !== void 0 && attr['identifier']);
            const isEmptyPassword = props['credentials.passcode'] && !(attr !== null && attr !== void 0 && attr['credentials.passcode']);
            if (isEmptyIdentifier && (0, $93a83f6fd41fc21e$export$89d4852ea9ed9572)(identifierRequiredi18nKey, this.settings)) inlineErrors['identifier'] = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(identifierRequiredi18nKey, 'login');
            if (isEmptyPassword && (0, $93a83f6fd41fc21e$export$89d4852ea9ed9572)(passwordRequiredi18nKey, this.settings)) inlineErrors['credentials.passcode'] = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(passwordRequiredi18nKey, 'login');
            return inlineErrors;
        };
        return ModelClass.extend({
            validate: validate
        });
    },
    initialize: function() {
        // Override Footer by overriding showForgotPasswordLink method
        this.Footer = (0, $f69e256d99f29568$export$2e2bcd8739ae039).extend({
            showForgotPasswordLink: ()=>{
                // We don't add the forgot password link in the footer if SIW renders multi IDPs,
                // instead in that case we add it before the IDP buttons in IdentifierView as primary links.
                const idpButtons = (0, $34fae8eb13c47425$export$b76b6826e7ff17cc)(this.options);
                return !this.options.appState.isIdentifierOnlyView() && (!Array.isArray(idpButtons) || idpButtons.length === 0);
            }
        });
    },
    postRender: function() {
        (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).prototype.postRender.apply(this, arguments);
        // If user entered identifier is not found, API sends back a message with a link to sign up
        // This is the click handler for that link
        const appState = this.options.appState;
        this.$el.find('.js-sign-up').click(function() {
            appState.trigger('invokeAction', (0, $4a07c2817278db15$export$657220afecfe252).SELECT_ENROLL_PROFILE);
            return false;
        });
    }
});



var $4ee2930d0d999610$export$2e2bcd8739ae039 = (0, $f4e1246ab077b34b$export$2e2bcd8739ae039).extend({
    render: function() {
        (0, $f4e1246ab077b34b$export$2e2bcd8739ae039).prototype.render.apply(this, arguments);
        this.$el.find('.sign-in-with-idp .separation-line').hide();
        this.$el.find('.button-primary').hide();
    }
});































parcelRequire("3ZxP0");
















































parcelRequire("3ZxP0");







var $8a0b19b4456b71c9$export$2e2bcd8739ae039 = (0, $31737d9aae112815$export$2e2bcd8739ae039).extend({
    links: function() {
        return (0, $aaa5b7e3293b6284$export$574d56f9df8b837)(this.options.appState, this.options.settings).concat((0, $aaa5b7e3293b6284$export$e6f8c91470651ac8)(this.options.appState));
    }
});













function $b2de277601d19336$export$dd951130da3aa31c(remediations) {
    let redirectIDVerifyRemediation = remediations.find((remediation)=>{
        return remediation.name === (0, $4a07c2817278db15$export$657220afecfe252).REDIRECT_IDVERIFY;
    });
    return redirectIDVerifyRemediation.idp.name;
}
function $b2de277601d19336$export$fd0ce679727b333(remediations) {
    var _redirectIDVerifyReme, _redirectIDVerifyReme2;
    const redirectIDVerifyRemediation = remediations.find((r)=>r.name === (0, $4a07c2817278db15$export$657220afecfe252).REDIRECT_IDVERIFY);
    return ((redirectIDVerifyRemediation === null || redirectIDVerifyRemediation === void 0 ? void 0 : (_redirectIDVerifyReme = redirectIDVerifyRemediation.idp) === null || _redirectIDVerifyReme === void 0 ? void 0 : _redirectIDVerifyReme.id) === (0, $4a07c2817278db15$export$cd4bf62f61ca5ae1).IDV_STANDARD || (redirectIDVerifyRemediation === null || redirectIDVerifyRemediation === void 0 ? void 0 : (_redirectIDVerifyReme2 = redirectIDVerifyRemediation.idp) === null || _redirectIDVerifyReme2 === void 0 ? void 0 : _redirectIDVerifyReme2.id) === (0, $4a07c2817278db15$export$cd4bf62f61ca5ae1).IDV_OIN) && (redirectIDVerifyRemediation === null || redirectIDVerifyRemediation === void 0 ? void 0 : redirectIDVerifyRemediation.idvMetadata) || undefined;
}
function $b2de277601d19336$export$8f216913bf011bf0(remediations) {
    const idpName = $b2de277601d19336$export$dd951130da3aa31c(remediations);
    let termsOfUse, privacyPolicy;
    switch(idpName === null || idpName === void 0 ? void 0 : idpName.toUpperCase()){
        case 'PERSONA':
            termsOfUse = 'https://withpersona.com/legal/terms-of-use';
            privacyPolicy = 'https://withpersona.com/legal/privacy-policy';
            break;
        case 'CLEAR':
            termsOfUse = 'https://www.clearme.com/member-terms';
            privacyPolicy = 'https://www.clearme.com/privacy-policy';
            break;
        case 'INCODE':
            termsOfUse = 'https://incode.id/terms';
            privacyPolicy = 'https://incode.id/privacy';
            break;
        default:
            {
                const metaInfoLinks = $b2de277601d19336$export$fd0ce679727b333(remediations);
                termsOfUse = metaInfoLinks === null || metaInfoLinks === void 0 ? void 0 : metaInfoLinks.termsOfUse;
                privacyPolicy = metaInfoLinks === null || metaInfoLinks === void 0 ? void 0 : metaInfoLinks.privacyPolicy;
                break;
            }
    }
    return {
        termsOfUse: termsOfUse,
        privacyPolicy: privacyPolicy
    };
}


var $742766a1bf993738$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"bg-helper auth-beacon auth-beacon-factor " + alias3((helper = (helper = lookupProperty(helpers, "className") || (depth0 != null ? lookupProperty(depth0, "className") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
                "name": "className",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 245
                    },
                    "end": {
                        "line": 1,
                        "column": 258
                    }
                }
            }) : helper)) + " custom-app-logo\" data-se=\"factor-beacon\" role=\"img\" aria-label=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.auth.logo.aria.label"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 323
                    },
                    "end": {
                        "line": 1,
                        "column": 378
                    }
                }
            })) + "\">";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"bg-helper auth-beacon auth-beacon-factor " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "className") || (depth0 != null ? lookupProperty(depth0, "className") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "className",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 441
                    },
                    "end": {
                        "line": 1,
                        "column": 454
                    }
                }
            }) : helper)) + "\" data-se=\"factor-beacon\">";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div data-type=\"beacon-container\" class=\"beacon-container\"><div class=\"beacon-blank auth-beacon\"><div class=\"beacon-blank js-blank-beacon-border auth-beacon-border\"></div></div>" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "logoUri") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.program(1, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 177
                    },
                    "end": {
                        "line": 1,
                        "column": 487
                    }
                }
            })) != null ? stack1 : "") + "<div class=\"okta-sign-in-beacon-border auth-beacon-border\"></div></div></div >";
        },
        "useData": true
    }),
    postRender: function() {
        (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).prototype.postRender.apply(this, arguments);
        const data = this.getTemplateData();
        if (data.logoUri) this.el.querySelector('.custom-app-logo').style.backgroundImage = `url(${data.logoUri})`;
    },
    getTemplateData: function() {
        var _this$options, _appState$get, _appState$get2;
        const appState = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.appState;
        const remediations = appState === null || appState === void 0 ? void 0 : appState.get('remediations');
        let logoUri = (appState === null || appState === void 0 ? void 0 : (_appState$get = appState.get('currentAuthenticator')) === null || _appState$get === void 0 ? void 0 : _appState$get.logoUri) || (appState === null || appState === void 0 ? void 0 : (_appState$get2 = appState.get('currentAuthenticatorEnrollment')) === null || _appState$get2 === void 0 ? void 0 : _appState$get2.logoUri);
        // Fallback to idvMetadata if available
        if (!logoUri && remediations) {
            const idvMetadata = (0, $b2de277601d19336$export$fd0ce679727b333)(remediations);
            logoUri = idvMetadata === null || idvMetadata === void 0 ? void 0 : idvMetadata.logoLink;
        }
        return {
            className: this.getBeaconClassName() || '',
            logoUri: logoUri
        };
    },
    getBeaconClassName: function() {
        return 'undefined-user';
    }
});


const $21a17fd013ef567d$export$55fd27ee2a571226 = (0, $742766a1bf993738$export$2e2bcd8739ae039).extend({
    authenticatorKey: function() {
        return this.options.appState.get('authenticatorKey');
    },
    idvName: function() {
        var _this$options$appStat, _redirectIDVerifyReme;
        const redirectIDVerifyRemediation = (_this$options$appStat = this.options.appState.get('remediations')) === null || _this$options$appStat === void 0 ? void 0 : _this$options$appStat.find((remediation)=>{
            return remediation.name === (0, $4a07c2817278db15$export$657220afecfe252).REDIRECT_IDVERIFY;
        });
        return redirectIDVerifyRemediation === null || redirectIDVerifyRemediation === void 0 ? void 0 : (_redirectIDVerifyReme = redirectIDVerifyRemediation.idp) === null || _redirectIDVerifyReme === void 0 ? void 0 : _redirectIDVerifyReme.id;
    },
    displayName: function() {
        var _this$options$appStat2, _this$options$appStat3;
        return ((_this$options$appStat2 = this.options.appState.get('currentAuthenticator')) === null || _this$options$appStat2 === void 0 ? void 0 : _this$options$appStat2.displayName) || ((_this$options$appStat3 = this.options.appState.get('currentAuthenticatorEnrollment')) === null || _this$options$appStat3 === void 0 ? void 0 : _this$options$appStat3.displayName);
    },
    getBeaconClassName: function() {
        const authenticatorKey = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'authenticatorKey');
        const idvName = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'idvName');
        const displayName = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).result(this, 'displayName');
        return (0, $3ddabee037f3f019$export$5b04e15b1e5a5626)(authenticatorKey, idvName, displayName);
    }
});
var $21a17fd013ef567d$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    Header: (0, $4c0f78fce7387c76$export$2e2bcd8739ae039).extend({
        HeaderBeacon: $21a17fd013ef567d$export$55fd27ee2a571226
    }),
    Footer: (0, $8a0b19b4456b71c9$export$2e2bcd8739ae039)
});



const $b468c9e620d00bc4$export$61a3bb4da51d33da = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    initialize: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        this.model.set('useRedirect', true);
        this.add('<div class="okta-waiting-spinner"></div>');
    }
});
const $b468c9e620d00bc4$export$4f0801ac3c4745b = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    postRender: function() {
        (0, $21a17fd013ef567d$export$2e2bcd8739ae039).prototype.postRender.apply(this, arguments);
        // get the error messages
        const messages = this.options.appState.get('messages') || {};
        // In case of failure, don't auto-redirect which will result in infinite redirects.
        // so catch the error and render to the user.
        if (this.settings.get('features.skipIdpFactorVerificationBtn') && !Array.isArray(messages.value) && this.model.get('formName') !== (0, $4a07c2817278db15$export$657220afecfe252).REDIRECT_IDVERIFY) {
            const appState = this.options.appState;
            const authenticatorKey = appState.get('authenticatorKey');
            const currentAuth = appState.get('currentAuthenticator') || appState.get('currentAuthenticatorEnrollment');
            if ((0, $22893d6dea78fc87$export$2e2bcd8739ae039).isSafari() && authenticatorKey === 'external_idp' && currentAuth !== null && currentAuth !== void 0 && currentAuth.logoUri) {
                const mainContentContainer = (0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(`#${(0, $e48c043f6d2d382d$export$2e2bcd8739ae039).WIDGET_CONTAINER_ID}`);
                mainContentContainer.addClass('no-beacon');
                this.$('.beacon-container').hide();
            }
            this.$('.o-form-button-bar').hide();
            this.$('.okta-waiting-spinner').show();
            this.form.trigger('save', this.model);
        } else {
            this.$('.okta-waiting-spinner').hide();
            this.$('.o-form-button-bar').show();
        }
    }
});











parcelRequire("3ZxP0");







const $a8e9291486611964$var$PrivacyTermsFooterView = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    tagName: 'p',
    className: 'privacy-footer',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "$2": "<a class='inline-link' data-se='privacy-policy' target='_blank' rel='noopener noreferrer'>$2</a>",
                    "$1": "<a class='inline-link' data-se='terms-of-use' target='_blank' rel='noopener noreferrer'>$1</a>",
                    "arguments": "idpName",
                    "bundle": "login",
                    "code": "oie.idv.idp.desc.termsOfUse"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 3
                    },
                    "end": {
                        "line": 1,
                        "column": 283
                    }
                }
            })) + "</p><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "arguments": "idpName",
                    "bundle": "login",
                    "code": "oie.idv.idp.desc.agreement"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 290
                    },
                    "end": {
                        "line": 1,
                        "column": 367
                    }
                }
            })) + "</p>";
        },
        "useData": true
    }),
    getTemplateData: function() {
        const idpName = (0, $b2de277601d19336$export$dd951130da3aa31c)(this.options.appState.get('remediations'));
        return {
            idpName: idpName
        };
    }
});
const $a8e9291486611964$var$Body = (0, $b468c9e620d00bc4$export$61a3bb4da51d33da).extend({
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.idv.idp.title', 'login', [
            (0, $b2de277601d19336$export$dd951130da3aa31c)(this.options.appState.get('remediations'))
        ]);
    },
    subtitle: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.idv.idp.desc', 'login', [
            (0, $b2de277601d19336$export$dd951130da3aa31c)(this.options.appState.get('remediations'))
        ]);
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.optional.authenticator.button.title', 'login');
    }
});
var $a8e9291486611964$export$2e2bcd8739ae039 = (0, $b468c9e620d00bc4$export$4f0801ac3c4745b).extend({
    Body: $a8e9291486611964$var$Body,
    Footer: (0, $31737d9aae112815$export$2e2bcd8739ae039).extend({
        postRender: function() {
            this.add($a8e9291486611964$var$PrivacyTermsFooterView);
            const { termsOfUse: termsOfUse, privacyPolicy: privacyPolicy } = (0, $b2de277601d19336$export$8f216913bf011bf0)(this.options.appState.get('remediations'));
            this.$el.find('[data-se="terms-of-use"]').attr('href', termsOfUse);
            this.$el.find('[data-se="privacy-policy"]').attr('href', privacyPolicy);
        }
    })
});





















parcelRequire("3ZxP0");







const $1e89397f5925e819$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.reset.title.generic', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oform.next', 'login');
    },
    getUISchema: function() {
        const schemas = (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.getUISchema.apply(this, arguments);
        let newSchemas = schemas.map((schema)=>{
            let newSchema = {
                ...schema
            };
            if (schema.name === 'identifier') // We enable the browser's autocomplete for the identifier input
            // because we want to allow the user to choose from previously used identifiers.
            newSchema = {
                ...newSchema,
                autoComplete: (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).getAutocompleteValue(this.options.settings, 'username')
            };
            return newSchema;
        });
        return newSchemas;
    }
});
var $1e89397f5925e819$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    Body: $1e89397f5925e819$var$Body,
    Footer: (0, $31737d9aae112815$export$2e2bcd8739ae039)
});





















parcelRequire("3ZxP0");


























parcelRequire("3ZxP0");







var $36054a289f1cf062$export$2e2bcd8739ae039 = (0, $4c0f78fce7387c76$export$2e2bcd8739ae039).extend({
    HeaderBeacon: (0, $21a17fd013ef567d$export$55fd27ee2a571226).extend({
        authenticatorKey: (0, $4a07c2817278db15$export$a7895cc4b0944d1b).EMAIL
    })
});












const $da090aca05df69a2$var$generateGeolocationString = (location = {})=>{
    if (!location.city && !location.country) return null;
    // Use 1 of 2 formats based on presence of 'state' in response:
    // 1. City, State, Country
    // 2. City, Country
    return location.state ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('geolocation.formatting.all', 'login', [
        location.city,
        location.state,
        location.country
    ]) : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('geolocation.formatting.partial', 'login', [
        location.city,
        location.country
    ]);
};
// A map from FactorTransactionIntent in okta-core to customer-facing flow name
const $da090aca05df69a2$var$challengeIntentToI18nKeyMap = {
    'AUTHENTICATION': 'idx.return.link.otponly.enter.code.on.sign.in.page',
    'RECOVERY': 'idx.return.link.otponly.enter.code.on.password.reset.page',
    'UNLOCK_ACCOUNT': 'idx.return.link.otponly.enter.code.on.account.unlock.page',
    'ENROLLMENT': 'idx.return.link.otponly.enter.code.on.sign.up.page'
};
const $da090aca05df69a2$var$getTerminalOtpEmailMagicLinkContext = (settings, appState)=>{
    var _appState$get, _appState$get$context;
    const app = appState.get('app');
    const client = appState.get('client');
    const challengeIntentContentKey = $da090aca05df69a2$var$challengeIntentToI18nKeyMap[appState.get('idx').context.intent];
    const enterCodeOnFlowPage = challengeIntentContentKey ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(challengeIntentContentKey, 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('idx.enter.otp.in.original.tab', 'login');
    let appName, browserOnOsString, isMobileDevice, geolocation;
    if (app !== null && app !== void 0 && app.label) appName = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('idx.return.link.otponly.app', 'login', [
        app.label
    ]);
    if (client) {
        browserOnOsString = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('idx.return.link.otponly.browser.on.os', 'login', [
            client.browser,
            client.os
        ]);
        isMobileDevice = browserOnOsString.includes('Android') || browserOnOsString.includes('iOS');
        geolocation = $da090aca05df69a2$var$generateGeolocationString(client.location);
    }
    const otp = settings.get('otp') || ((_appState$get = appState.get('currentAuthenticator')) === null || _appState$get === void 0 ? void 0 : (_appState$get$context = _appState$get.contextualData) === null || _appState$get$context === void 0 ? void 0 : _appState$get$context.otp);
    return {
        showRequestInfo: appName || browserOnOsString || geolocation,
        appName: appName,
        browserOnOsString: browserOnOsString,
        isMobileDevice: isMobileDevice,
        geolocation: geolocation,
        otp: otp,
        enterCodeOnFlowPage: enterCodeOnFlowPage
    };
};
const $da090aca05df69a2$var$BaseEmailMagicLinkOTPTerminalView = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    getTemplateData: function() {
        return $da090aca05df69a2$var$getTerminalOtpEmailMagicLinkContext(this.options.settings, this.options.appState);
    }
});
const $da090aca05df69a2$export$f4477d1055e224a6 = $da090aca05df69a2$var$BaseEmailMagicLinkOTPTerminalView.extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"enduser-email-otp-only--info\"><div class=\"okta-form-label\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "idx.return.link.otponly.request"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 198
                    },
                    "end": {
                        "line": 1,
                        "column": 260
                    }
                }
            })) + "</div></div>";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"enduser-email-otp-only--info\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "isMobileDevice") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(2, data, 0),
                "inverse": container.program(3, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 346
                    },
                    "end": {
                        "line": 1,
                        "column": 540
                    }
                }
            })) != null ? stack1 : "") + "<div data-se=\"otp-browser-os\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "browserOnOsString") || (depth0 != null ? lookupProperty(depth0, "browserOnOsString") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
                "name": "browserOnOsString",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 570
                    },
                    "end": {
                        "line": 1,
                        "column": 591
                    }
                }
            }) : helper)) + "</div></div>";
        },
        "2": function(container, depth0, helpers, partials, data) {
            return "<i class=\"enduser-email-otp-only--icon icon--smartphone\" aria-hidden=\"true\"></i>";
        },
        "3": function(container, depth0, helpers, partials, data) {
            return "<i class=\"enduser-email-otp-only--icon icon--desktop\" aria-hidden=\"true\"></i>";
        },
        "4": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"enduser-email-otp-only--info\"><i class=\"enduser-email-otp-only--icon icon--app\" aria-hidden=\"true\"></i><div data-se=\"otp-app\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "appName") || (depth0 != null ? lookupProperty(depth0, "appName") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "appName",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 763
                    },
                    "end": {
                        "line": 1,
                        "column": 774
                    }
                }
            }) : helper)) + "</div></div>";
        },
        "5": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"enduser-email-otp-only--info\"><i class=\"enduser-email-otp-only--icon icon--location\" aria-hidden=\"true\"></i><div data-se=\"otp-geolocation\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "geolocation") || (depth0 != null ? lookupProperty(depth0, "geolocation") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "geolocation",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 963
                    },
                    "end": {
                        "line": 1,
                        "column": 978
                    }
                }
            }) : helper)) + "</div></div>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p class=\"enter-code-on-page\">" + alias4((helper = (helper = lookupProperty(helpers, "enterCodeOnFlowPage") || (depth0 != null ? lookupProperty(depth0, "enterCodeOnFlowPage") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "enterCodeOnFlowPage",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 30
                    },
                    "end": {
                        "line": 1,
                        "column": 53
                    }
                }
            }) : helper)) + "</p><h1 class='otp-value no-translate'>" + alias4((helper = (helper = lookupProperty(helpers, "otp") || (depth0 != null ? lookupProperty(depth0, "otp") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "otp",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 92
                    },
                    "end": {
                        "line": 1,
                        "column": 99
                    }
                }
            }) : helper)) + "</h1>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "showRequestInfo") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 104
                    },
                    "end": {
                        "line": 1,
                        "column": 279
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "browserOnOsString") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 279
                    },
                    "end": {
                        "line": 1,
                        "column": 610
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "appName") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(4, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 610
                    },
                    "end": {
                        "line": 1,
                        "column": 793
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "geolocation") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(5, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 793
                    },
                    "end": {
                        "line": 1,
                        "column": 997
                    }
                }
            })) != null ? stack1 : "") + "<br><p class='otp-warning'>" + alias4((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "idx.return.link.otponly.warning.text"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 1024
                    },
                    "end": {
                        "line": 1,
                        "column": 1091
                    }
                }
            })) + "</p>";
        },
        "useData": true
    })
});
































const $75d8a4747dae25cc$var$PROBE_PATH = 'probe';
// eslint-disable-next-line max-len
const $75d8a4747dae25cc$var$ADP_INSTALL_FALLBACK_REMEDIATION_KEY = 'idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.android_device_policy_app_required_manual_install';
const $75d8a4747dae25cc$var$ajaxRequest = (requestOptions)=>{
    const ajaxOptions = Object.assign({
        method: 'GET',
        contentType: 'application/json'
    }, requestOptions);
    return (0, $b51a961f9fe28c76$export$2e2bcd8739ae039).ajax(ajaxOptions);
};
const $75d8a4747dae25cc$var$checkPort = (url, probeTimeoutMillis)=>{
    return $75d8a4747dae25cc$var$ajaxRequest({
        url: url,
        timeout: probeTimeoutMillis
    });
};
const $75d8a4747dae25cc$var$onPortFound = (url, timeout)=>{
    return $75d8a4747dae25cc$var$ajaxRequest({
        url: url,
        method: 'GET',
        timeout: timeout
    });
};
const $75d8a4747dae25cc$var$getFallbackMessage = (fallbackObj)=>{
    switch(fallbackObj.message.i18n.key){
        case $75d8a4747dae25cc$var$ADP_INSTALL_FALLBACK_REMEDIATION_KEY:
            // ADP fallback message has additional formatting
            // eslint-disable-next-line max-len
            return (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                "compiler": [
                    8,
                    ">= 4.3.0"
                ],
                "main": function(container, depth0, helpers, partials, data) {
                    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                        return undefined;
                    };
                    return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                        "name": "i18n",
                        "hash": {
                            "$1": "<span class='strong'>$1</span>",
                            "bundle": "login",
                            "code": "idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.android_device_policy_app_required_manual_install"
                        },
                        "data": data,
                        "loc": {
                            "start": {
                                "line": 1,
                                "column": 0
                            },
                            "end": {
                                "line": 1,
                                "column": 194
                            }
                        }
                    }));
                },
                "useData": true
            })();
        default:
            return (0, $93a83f6fd41fc21e$export$2e51780da3c3a61)(fallbackObj.message);
    }
};
const $75d8a4747dae25cc$var$executeDeviceRemediationFallback = (fallback, action)=>{
    switch(fallback.type){
        case 'APP_LINK':
            // If/When loopback fails auto launch app link to install
            (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).executeOnVisiblePage(()=>{
                (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).redirect(fallback.href, window, true);
            });
            break;
        case 'MESSAGE':
            {
                // display updated message in place
                const siwContainer = document.getElementById((0, $e48c043f6d2d382d$export$2e2bcd8739ae039).WIDGET_CONTAINER_ID);
                if (!siwContainer) {
                    (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).error('Cannot find okta-sign-in container to display message');
                    return;
                }
                const remediationMsgElements = siwContainer.querySelectorAll(`[data-se="${action}"]`);
                if (remediationMsgElements && remediationMsgElements[0]) remediationMsgElements[0].outerHTML = $75d8a4747dae25cc$var$getFallbackMessage(fallback);
                break;
            }
    }
};
const $75d8a4747dae25cc$var$probe = (baseUrl, probeDetails)=>{
    return $75d8a4747dae25cc$var$checkPort(`${baseUrl}/${$75d8a4747dae25cc$var$PROBE_PATH}`, probeDetails.probeTimeoutMillis).then(()=>{
        const loopbackRemediationPath = `${baseUrl}/${probeDetails.remediationPath}/${probeDetails.actionPath}`;
        return $75d8a4747dae25cc$var$onPortFound(loopbackRemediationPath, probeDetails.probeTimeoutMillis).then(()=>{
            probeDetails.isSuccess = true;
        });
    }).catch(()=>{
        (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).error(`Something unexpected happened while we were checking url: ${baseUrl}.`);
        return (0, $b51a961f9fe28c76$export$2e2bcd8739ae039).Deferred().reject();
    });
};
const $75d8a4747dae25cc$export$fc091508390cd44f = (message)=>{
    return message.deviceRemediation && message.deviceRemediation.value && message.deviceRemediation.value.action;
};
const $75d8a4747dae25cc$export$c4b0d0c4685e160f = (deviceRemediation)=>{
    return deviceRemediation && deviceRemediation.remediationType === 'LOOPBACK';
};
const $75d8a4747dae25cc$export$b33c03c5f10a92e5 = (deviceRemediation)=>{
    const domain = deviceRemediation.domain;
    const ports = deviceRemediation.ports;
    const totalPortCount = ports.length;
    let failedPortCount = 0;
    const probeDetails = {
        remediationPath: deviceRemediation.remediationPath,
        actionPath: deviceRemediation.action,
        probeTimeoutMillis: deviceRemediation.probeTimeoutMillis,
        isSuccess: false
    };
    let probeChain = Promise.resolve();
    const baseUrls = ports.map((port)=>`${domain}:${port}`);
    baseUrls.forEach((baseUrl)=>{
        // no need to continue if we found the port and made a successful request
        if (probeDetails.isSuccess) return;
        probeChain = probeChain.then(()=>$75d8a4747dae25cc$var$probe(baseUrl, probeDetails)).catch(()=>{
            failedPortCount += 1;
            (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).error(`Authenticator is not listening on: ${baseUrl}.`);
            if (failedPortCount >= totalPortCount && !probeDetails.isSuccess) {
                (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).error('No available ports. Loopback server failed and using fallback mechanism.');
                $75d8a4747dae25cc$var$executeDeviceRemediationFallback(deviceRemediation.fallback, deviceRemediation.action);
            }
        });
    });
};


const $128f9dcbe3cf8732$var$I18N_ACCESS_DENIED_KEY_PREFIX = 'idx.error.code.access_denied.device_assurance.remediation';
const $128f9dcbe3cf8732$var$I18N_GRACE_PERIOD_KEY_PREFIX = 'idx.device_assurance.grace_period.warning';
const $128f9dcbe3cf8732$var$HELP_AND_CONTACT_KEY_PREFIX = `${$128f9dcbe3cf8732$var$I18N_ACCESS_DENIED_KEY_PREFIX}.additional_help_`;
const $128f9dcbe3cf8732$var$CUSTOM_URL_ADDITIONAL_HELP_KEY = `${$128f9dcbe3cf8732$var$I18N_ACCESS_DENIED_KEY_PREFIX}.additional_help_custom`;
const $128f9dcbe3cf8732$var$REMEDIATION_OPTION_INDEX_KEY = `${$128f9dcbe3cf8732$var$I18N_ACCESS_DENIED_KEY_PREFIX}.option_index`;
const $128f9dcbe3cf8732$var$ACCESS_DENIED_TITLE_KEY = `${$128f9dcbe3cf8732$var$I18N_ACCESS_DENIED_KEY_PREFIX}.title`;
const $128f9dcbe3cf8732$var$GRACE_PERIOD_TITLE_KEY = `${$128f9dcbe3cf8732$var$I18N_GRACE_PERIOD_KEY_PREFIX}.title`;
const $128f9dcbe3cf8732$var$ACCESS_DENIED_EXPLANATION_KEY_PREFIX = `${$128f9dcbe3cf8732$var$I18N_ACCESS_DENIED_KEY_PREFIX}.explanation_`;
function $128f9dcbe3cf8732$var$buildRemediationOptionBlockMessage(message) {
    let link = null;
    let deviceRemediationAction = null;
    if (message.links && message.links[0] && message.links[0].url) link = message.links[0].url;
    else if ((0, $75d8a4747dae25cc$export$fc091508390cd44f)(message)) deviceRemediationAction = message.deviceRemediation.value.action;
    return {
        message: (0, $93a83f6fd41fc21e$export$2e51780da3c3a61)(message),
        link: link,
        deviceRemediationAction: deviceRemediationAction,
        className: message.i18n.key === $128f9dcbe3cf8732$var$REMEDIATION_OPTION_INDEX_KEY ? 'end-user-remediation-option' : 'end-user-remediation-action'
    };
}
var $128f9dcbe3cf8732$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'end-user-remediation-messages-view',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"end-user-remediation-title\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "title") || (depth0 != null ? lookupProperty(depth0, "title") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "title",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 53
                    },
                    "end": {
                        "line": 1,
                        "column": 62
                    }
                }
            }) : helper)) + "</div>";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"end-user-remediation-explanation\">" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "explanation") || (depth0 != null ? lookupProperty(depth0, "explanation") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "explanation",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 140
                    },
                    "end": {
                        "line": 1,
                        "column": 155
                    }
                }
            }) : helper)) + "</div>";
        },
        "2": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"end-user-remediation-options\">" + ((stack1 = lookupProperty(helpers, "each").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "remediationOptions") : depth0, {
                "name": "each",
                "hash": {},
                "fn": container.program(3, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 236
                    },
                    "end": {
                        "line": 1,
                        "column": 605
                    }
                }
            })) != null ? stack1 : "") + "</div>";
        },
        "3": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "className") || (depth0 != null ? lookupProperty(depth0, "className") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(alias1, {
                "name": "className",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 276
                    },
                    "end": {
                        "line": 1,
                        "column": 289
                    }
                }
            }) : helper)) + "\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "link") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(4, data, 0),
                "inverse": container.program(5, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 291
                    },
                    "end": {
                        "line": 1,
                        "column": 590
                    }
                }
            })) != null ? stack1 : "") + "</div>";
        },
        "4": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a href=\"" + alias4((helper = (helper = lookupProperty(helpers, "link") || (depth0 != null ? lookupProperty(depth0, "link") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "link",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 312
                    },
                    "end": {
                        "line": 1,
                        "column": 320
                    }
                }
            }) : helper)) + "\" target=\"_blank\" rel=\"noopener noreferrer\">" + alias4((helper = (helper = lookupProperty(helpers, "message") || (depth0 != null ? lookupProperty(depth0, "message") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "message",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 364
                    },
                    "end": {
                        "line": 1,
                        "column": 375
                    }
                }
            }) : helper)) + "</a>";
        },
        "5": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "deviceRemediationAction") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(6, data, 0),
                "inverse": container.program(7, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 387
                    },
                    "end": {
                        "line": 1,
                        "column": 583
                    }
                }
            })) != null ? stack1 : "";
        },
        "6": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<button class=\"enduser-remediation-button-link\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "deviceRemediationAction") || (depth0 != null ? lookupProperty(depth0, "deviceRemediationAction") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "deviceRemediationAction",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 470
                    },
                    "end": {
                        "line": 1,
                        "column": 497
                    }
                }
            }) : helper)) + "\" data-se=\"" + alias4((helper = (helper = lookupProperty(helpers, "deviceRemediationAction") || (depth0 != null ? lookupProperty(depth0, "deviceRemediationAction") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "deviceRemediationAction",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 508
                    },
                    "end": {
                        "line": 1,
                        "column": 535
                    }
                }
            }) : helper)) + "\">" + alias4((helper = (helper = lookupProperty(helpers, "message") || (depth0 != null ? lookupProperty(depth0, "message") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "message",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 537
                    },
                    "end": {
                        "line": 1,
                        "column": 548
                    }
                }
            }) : helper)) + "</button>";
        },
        "7": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return container.escapeExpression((helper = (helper = lookupProperty(helpers, "message") || (depth0 != null ? lookupProperty(depth0, "message") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "message",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 565
                    },
                    "end": {
                        "line": 1,
                        "column": 576
                    }
                }
            }) : helper));
        },
        "8": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "$1": "<a href='#' target='_blank' rel='noopener noreferrer' class='additional-help'>$1</a>",
                    "bundle": "login",
                    "code": "idx.error.code.access_denied.device_assurance.remediation.additional_help_custom"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 695
                    },
                    "end": {
                        "line": 1,
                        "column": 897
                    }
                }
            }));
        },
        "9": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "$1": "<a href='#' target='_blank' rel='noopener noreferrer' class='additional-help'>$1</a>",
                    "bundle": "login",
                    "code": "idx.error.code.access_denied.device_assurance.remediation.additional_help_default"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 905
                    },
                    "end": {
                        "line": 1,
                        "column": 1108
                    }
                }
            }));
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "title") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 75
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "explanation") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 75
                    },
                    "end": {
                        "line": 1,
                        "column": 168
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "remediationOptions") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(2, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 168
                    },
                    "end": {
                        "line": 1,
                        "column": 618
                    }
                }
            })) != null ? stack1 : "") + "<div class=\"end-user-remediation-help-and-contact\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "useCustomHelpText") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(8, data, 0),
                "inverse": container.program(9, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 669
                    },
                    "end": {
                        "line": 1,
                        "column": 1115
                    }
                }
            })) != null ? stack1 : "") + "</div>";
        },
        "useData": true
    }),
    getTemplateData: function() {
        const messages = this.options.messages;
        const remediationOptions = [];
        let title = null;
        let explanation = null;
        let useCustomHelpText = false;
        // eslint-disable-next-line complexity
        messages.forEach((msg)=>{
            const { i18n: { key: key, params: params = [] }, links: links, message: message } = msg;
            if (key === $128f9dcbe3cf8732$var$ACCESS_DENIED_TITLE_KEY) title = (0, $93a83f6fd41fc21e$export$2e51780da3c3a61)(msg);
            else if (key.startsWith($128f9dcbe3cf8732$var$GRACE_PERIOD_TITLE_KEY)) {
                if (params.length > 0) {
                    const expiry = params[0];
                    const expiryDate = new Date(expiry);
                    const localizedExpiry = (0, $40aeee952775c03c$export$2e2bcd8739ae039).formatDateToDeviceAssuranceGracePeriodExpiryLocaleString(expiryDate, this.options.languageTags);
                    title = localizedExpiry ? (0, $27511669ac136cf6$export$ebcbd32ce8d4cff)(key, 'login', [
                        localizedExpiry
                    ]) : message;
                }
            } else if (key.startsWith($128f9dcbe3cf8732$var$ACCESS_DENIED_EXPLANATION_KEY_PREFIX)) explanation = (0, $93a83f6fd41fc21e$export$2e51780da3c3a61)(msg);
            else if (key.startsWith($128f9dcbe3cf8732$var$HELP_AND_CONTACT_KEY_PREFIX)) {
                useCustomHelpText = key === $128f9dcbe3cf8732$var$CUSTOM_URL_ADDITIONAL_HELP_KEY;
                if (links && links[0] && links[0].url) this.additionalHelpUrl = links[0].url;
            } else remediationOptions.push($128f9dcbe3cf8732$var$buildRemediationOptionBlockMessage(msg));
        });
        return {
            title: title,
            explanation: explanation,
            remediationOptions: remediationOptions,
            useCustomHelpText: useCustomHelpText
        };
    },
    render: function() {
        (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).prototype.render.apply(this, arguments);
        if (this.additionalHelpUrl) this.$el.find('.additional-help').attr('href', this.additionalHelpUrl);
    },
    postRender: function() {
        if (!Array.isArray(this.options.messages)) return;
        const deviceRemediations = this.options.messages.filter((message)=>(0, $75d8a4747dae25cc$export$fc091508390cd44f)(message)).map((message)=>message.deviceRemediation.value);
        deviceRemediations.forEach((deviceRemediation)=>{
            this.$el.find(`#${deviceRemediation.action}`).click(function(event) {
                event.preventDefault();
                if ((0, $75d8a4747dae25cc$export$c4b0d0c4685e160f)(deviceRemediation)) (0, $75d8a4747dae25cc$export$b33c03c5f10a92e5)(deviceRemediation);
            });
        });
    }
});


const $8c1ba9d0e26d52e7$var$RETURN_LINK_EXPIRED_KEY = 'idx.return.link.expired';
const $8c1ba9d0e26d52e7$var$IDX_RETURN_LINK_OTP_ONLY = 'idx.enter.otp.in.original.tab';
const $8c1ba9d0e26d52e7$var$SAFE_MODE_KEY_PREFIX = 'idx.error.server.safe.mode';
const $8c1ba9d0e26d52e7$var$UNLOCK_ACCOUNT_TERMINAL_KEY = 'oie.selfservice.unlock_user.success.message';
const $8c1ba9d0e26d52e7$var$UNLOCK_ACCOUNT_FAILED_PERMISSIONS = 'oie.selfservice.unlock_user.challenge.failed.permissions';
const $8c1ba9d0e26d52e7$var$RESET_PASSWORD_NOT_ALLOWED = 'oie.selfservice.reset.password.not.allowed';
const $8c1ba9d0e26d52e7$var$RETURN_TO_ORIGINAL_TAB_KEY = 'idx.return.to.original.tab';
const $8c1ba9d0e26d52e7$var$OPERATION_CANCELED_ON_OTHER_DEVICE_KEY = 'idx.operation.cancelled.on.other.device';
const $8c1ba9d0e26d52e7$var$OPERATION_CANCELED_BY_USER_KEY = 'idx.operation.cancelled.by.user';
const $8c1ba9d0e26d52e7$var$DEVICE_ACTIVATED = 'idx.device.activated';
const $8c1ba9d0e26d52e7$var$DEVICE_NOT_ACTIVATED_CONSENT_DENIED = 'idx.device.not.activated.consent.denied';
const $8c1ba9d0e26d52e7$var$DEVICE_NOT_ACTIVATED_INTERNAL_ERROR = 'idx.device.not.activated.internal.error';
const $8c1ba9d0e26d52e7$var$FLOW_CONTINUE_IN_NEW_TAB = 'idx.transferred.to.new.tab';
const $8c1ba9d0e26d52e7$var$EMAIL_LINK_OUT_OF_DATE = 'idx.return.stale';
const $8c1ba9d0e26d52e7$var$EMAIL_LINK_CANT_BE_PROCESSED = 'idx.return.error';
const $8c1ba9d0e26d52e7$var$EMAIL_VERIFICATION_REQUIRED = 'idx.email.verification.required';
const $8c1ba9d0e26d52e7$var$END_USER_REMEDIATION_KEY_PREFIX = 'idx.error.code.access_denied.device_assurance.remediation.';
const $8c1ba9d0e26d52e7$var$EMAIL_ACTIVATION_EMAIL_EXPIRE = 'idx.expired.activation.token';
const $8c1ba9d0e26d52e7$var$EMAIL_ACTIVATION_EMAIL_INVALID = 'idx.missing.activation.token';
const $8c1ba9d0e26d52e7$var$EMAIL_ACTIVATION_EMAIL_SUBMITTED = 'idx.request.activation.email';
const $8c1ba9d0e26d52e7$var$EMAIL_ACTIVATION_EMAIL_SUSPENDED = 'idx.activating.inactive.user';
const $8c1ba9d0e26d52e7$var$CUSTOM_ACCESS_DENIED_KEY = 'security.access_denied_custom_message';
const $8c1ba9d0e26d52e7$export$cbf705b906589880 = 'oie.registration.is.not.enabled';
const $8c1ba9d0e26d52e7$export$5ca2b96ef0f897d6 = 'oie.forgot.password.is.not.enabled';
const $8c1ba9d0e26d52e7$var$EMAIL_AUTHENTICATOR_TERMINAL_KEYS = [
    $8c1ba9d0e26d52e7$var$FLOW_CONTINUE_IN_NEW_TAB,
    $8c1ba9d0e26d52e7$var$EMAIL_LINK_OUT_OF_DATE,
    $8c1ba9d0e26d52e7$var$EMAIL_LINK_CANT_BE_PROCESSED,
    $8c1ba9d0e26d52e7$var$EMAIL_VERIFICATION_REQUIRED,
    $8c1ba9d0e26d52e7$var$RETURN_TO_ORIGINAL_TAB_KEY,
    $8c1ba9d0e26d52e7$var$RETURN_LINK_EXPIRED_KEY,
    $8c1ba9d0e26d52e7$var$OPERATION_CANCELED_ON_OTHER_DEVICE_KEY,
    $8c1ba9d0e26d52e7$var$OPERATION_CANCELED_BY_USER_KEY,
    $8c1ba9d0e26d52e7$var$IDX_RETURN_LINK_OTP_ONLY
];
const $8c1ba9d0e26d52e7$var$DEVICE_CODE_ERROR_KEYS = [
    $8c1ba9d0e26d52e7$var$DEVICE_NOT_ACTIVATED_CONSENT_DENIED,
    $8c1ba9d0e26d52e7$var$DEVICE_NOT_ACTIVATED_INTERNAL_ERROR
];
const $8c1ba9d0e26d52e7$var$DEVICE_CODE_FLOW_TERMINAL_KEYS = [
    $8c1ba9d0e26d52e7$var$DEVICE_ACTIVATED,
    ...$8c1ba9d0e26d52e7$var$DEVICE_CODE_ERROR_KEYS
];
// These terminal views build their own links, basically they have cancel remediation in error response
// Or doesn't require a Back to Sign in link because the flow didn't start from login screen
const $8c1ba9d0e26d52e7$var$NO_BACKTOSIGNIN_LINK_VIEWS = [
    $8c1ba9d0e26d52e7$var$UNLOCK_ACCOUNT_TERMINAL_KEY,
    $8c1ba9d0e26d52e7$var$RETURN_TO_ORIGINAL_TAB_KEY,
    $8c1ba9d0e26d52e7$var$FLOW_CONTINUE_IN_NEW_TAB,
    $8c1ba9d0e26d52e7$var$OPERATION_CANCELED_ON_OTHER_DEVICE_KEY,
    ...$8c1ba9d0e26d52e7$var$DEVICE_CODE_FLOW_TERMINAL_KEYS,
    $8c1ba9d0e26d52e7$var$UNLOCK_ACCOUNT_FAILED_PERMISSIONS,
    $8c1ba9d0e26d52e7$var$RESET_PASSWORD_NOT_ALLOWED,
    $8c1ba9d0e26d52e7$var$IDX_RETURN_LINK_OTP_ONLY
];
// Key map to transform terminal view titles {ApiKey : WidgetKey}  
const $8c1ba9d0e26d52e7$var$terminalViewTitles = {
    [$8c1ba9d0e26d52e7$var$RETURN_LINK_EXPIRED_KEY]: 'oie.email.return.link.expired.title',
    [$8c1ba9d0e26d52e7$var$UNLOCK_ACCOUNT_TERMINAL_KEY]: 'account.unlock.unlocked.title',
    [$8c1ba9d0e26d52e7$var$DEVICE_ACTIVATED]: 'device.code.activated.success.title',
    [$8c1ba9d0e26d52e7$export$cbf705b906589880]: 'oie.registration.form.title',
    [$8c1ba9d0e26d52e7$export$5ca2b96ef0f897d6]: 'password.reset.title.generic',
    [$8c1ba9d0e26d52e7$var$EMAIL_ACTIVATION_EMAIL_EXPIRE]: 'oie.activation.request.email.title.expire',
    [$8c1ba9d0e26d52e7$var$EMAIL_ACTIVATION_EMAIL_SUBMITTED]: 'oie.activation.request.email.title.submitted',
    [$8c1ba9d0e26d52e7$var$EMAIL_ACTIVATION_EMAIL_SUSPENDED]: 'oie.activation.request.email.title.suspended',
    [$8c1ba9d0e26d52e7$var$EMAIL_ACTIVATION_EMAIL_INVALID]: 'oie.activation.request.email.title.invalid',
    [$8c1ba9d0e26d52e7$var$DEVICE_NOT_ACTIVATED_CONSENT_DENIED]: 'device.code.activated.error.title',
    [$8c1ba9d0e26d52e7$var$DEVICE_NOT_ACTIVATED_INTERNAL_ERROR]: 'device.code.activated.error.title',
    [$8c1ba9d0e26d52e7$var$RETURN_TO_ORIGINAL_TAB_KEY]: 'oie.consent.enduser.email.allow.title',
    [$8c1ba9d0e26d52e7$var$IDX_RETURN_LINK_OTP_ONLY]: 'idx.return.link.otponly.your.verification.code'
};
const $8c1ba9d0e26d52e7$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    noButtonBar: true,
    postRender: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.postRender.apply(this, arguments);
        this.$el.addClass('terminal-state');
        // show device code terminal icons
        if (this.options.appState.containsMessageWithI18nKey($8c1ba9d0e26d52e7$var$DEVICE_CODE_FLOW_TERMINAL_KEYS)) {
            const iconClass = this.options.appState.containsMessageWithI18nKey($8c1ba9d0e26d52e7$var$DEVICE_ACTIVATED) ? 'success-24-green' : 'error-24-red';
            this.$('.o-form-head').before('<div class="device-code-terminal--icon-container"><span class="device-code-terminal--icon ' + iconClass + '"></span>' + '</div>');
        }
    },
    title: function() {
        return this.getTerminalViewTitle();
    },
    getTerminalViewTitle: function() {
        if (this.options.appState.containsMessageStartingWithI18nKey($8c1ba9d0e26d52e7$var$SAFE_MODE_KEY_PREFIX)) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.safe.mode.title', 'login');
        const apiKeys = Object.keys($8c1ba9d0e26d52e7$var$terminalViewTitles);
        const key = apiKeys.find((key)=>this.options.appState.containsMessageWithI18nKey(key));
        if (key) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)($8c1ba9d0e26d52e7$var$terminalViewTitles[key], 'login');
    },
    prepareMessageForCustomView: function(messagesObjs) {
        let hasCustomView = false;
        if (this.options.appState.containsMessageWithI18nKey($8c1ba9d0e26d52e7$var$IDX_RETURN_LINK_OTP_ONLY)) {
            this.add((0, $da090aca05df69a2$export$f4477d1055e224a6));
            hasCustomView = true;
        } else if (this.options.appState.containsMessageStartingWithI18nKey($8c1ba9d0e26d52e7$var$CUSTOM_ACCESS_DENIED_KEY)) {
            this.add((0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)({
                type: 'error',
                content: new (0, $ccb47a661a4098b1$export$2e2bcd8739ae039)({
                    message: messagesObjs.value[0].message,
                    links: messagesObjs.value[0].links
                })
            }));
            hasCustomView = true;
        } else if (this.options.appState.containsMessageStartingWithI18nKey($8c1ba9d0e26d52e7$var$END_USER_REMEDIATION_KEY_PREFIX)) {
            this.add((0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)({
                type: 'error',
                content: new (0, $128f9dcbe3cf8732$export$2e2bcd8739ae039)({
                    messages: messagesObjs.value
                })
            }));
            hasCustomView = true;
        }
        return hasCustomView;
    },
    showMessages: function() {
        const messagesObjs = this.options.appState.get('messages');
        let hasCustomView = false;
        let description;
        if (this.options.appState.containsMessageWithI18nKey($8c1ba9d0e26d52e7$var$OPERATION_CANCELED_ON_OTHER_DEVICE_KEY)) {
            description = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('idx.operation.cancelled.on.other.device', 'login');
            messagesObjs.value.push({
                message: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.consent.enduser.deny.description', 'login')
            });
        } else if (this.options.appState.containsMessageWithI18nKey($8c1ba9d0e26d52e7$var$RETURN_TO_ORIGINAL_TAB_KEY)) {
            description = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.consent.enduser.email.allow.description', 'login');
            messagesObjs.value.push({
                message: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.return.to.original.tab', 'login')
            });
        } else if (this.options.appState.containsMessageWithI18nKey('tooManyRequests')) description = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.tooManyRequests', 'login');
        else if (this.options.appState.containsMessageWithI18nKey($8c1ba9d0e26d52e7$var$RETURN_LINK_EXPIRED_KEY)) messagesObjs.value[0].class = 'ERROR';
        else hasCustomView = this.prepareMessageForCustomView(messagesObjs);
        if (description && Array.isArray(messagesObjs === null || messagesObjs === void 0 ? void 0 : messagesObjs.value)) messagesObjs.value[0].message = description;
        this.options.appState.set('messages', messagesObjs);
        if (!hasCustomView) (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.showMessages.call(this);
    }
});
const $8c1ba9d0e26d52e7$var$Footer = (0, $31737d9aae112815$export$2e2bcd8739ae039).extend({
    // All terminal views should have Back to sign in link either widget configured or server configured.
    links: function() {
        if (this.options.appState.containsMessageStartingWithI18nKey($8c1ba9d0e26d52e7$var$SAFE_MODE_KEY_PREFIX)) return (0, $aaa5b7e3293b6284$export$77db2f739f8229cd)(this.options.appState);
        if (this.options.appState.containsMessageWithI18nKey($8c1ba9d0e26d52e7$var$DEVICE_CODE_ERROR_KEYS)) return (0, $aaa5b7e3293b6284$export$b976e2cc13a99aa5)();
        // If cancel object exists idx response then view would take care of rendering back to sign in link
        const shouldShowBackToSignInLink = !this.options.appState.hasActionObject('cancel') && !this.options.appState.containsMessageWithI18nKey($8c1ba9d0e26d52e7$var$NO_BACKTOSIGNIN_LINK_VIEWS) && !this.options.settings.get('features.hideSignOutLinkInMFA') && !this.options.settings.get('features.mfaOnlyFlow');
        if (shouldShowBackToSignInLink) // TODO OKTA-432869 "back to sign in" links to org baseUrl, does not work correctly with embedded widget
        return (0, $aaa5b7e3293b6284$export$27ab946e7ff0ff57)(this.options);
    }
});
var $8c1ba9d0e26d52e7$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    initialize: function() {
        (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        if (this.options.appState.containsMessageWithI18nKey($8c1ba9d0e26d52e7$var$EMAIL_AUTHENTICATOR_TERMINAL_KEYS)) this.Header = (0, $36054a289f1cf062$export$2e2bcd8739ae039);
    },
    Body: $8c1ba9d0e26d52e7$var$Body,
    Footer: $8c1ba9d0e26d52e7$var$Footer
});





















parcelRequire("3ZxP0");








const $fada7d47117f92a9$var$CUSTOM_ACCESS_DENIED_KEY = 'security.access_denied_custom_message';
const $fada7d47117f92a9$var$UNLOCK_USER_SUCCESS_MESSAGE = 'oie.selfservice.unlock_user.landing.to.app.success.message';
const $fada7d47117f92a9$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    /* eslint complexity: [2, 16] */ title: function() {
        let titleString = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.success.text.signingIn', 'login');
        // For more info on the API response available in appState, see IdxResponseBuilder.java
        const app = this.options.appState.get('app');
        const user = this.options.appState.get('user');
        // If the option is not set, we treat that as being the case where we don't render the spinner.
        // This is to account for the customer hosted scenario, because by default okta-core will pass in
        // the correct value as set by the option in the Admin UI (which by default is "DEFAULT").
        if (!this.redirectView || this.redirectView === (0, $4a07c2817278db15$export$5b95bebd73cede29).NONE) {
            titleString = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.success.text.signingIn.with.ellipsis', 'login');
            return titleString;
        }
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(app)) return titleString;
        const { label: appInstanceName, name: appDisplayName } = app;
        const { identifier: userEmail } = user || {};
        const appName = appInstanceName ? appInstanceName : appDisplayName;
        if (appName && userEmail && !this.settings.get('features.showIdentifier')) titleString = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.success.text.signingIn.with.appName.and.identifier', 'login', [
            appName,
            userEmail
        ]);
        else if (appName) titleString = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.success.text.signingIn.with.appName', 'login', [
            appName
        ]);
        return titleString;
    },
    showMessages: function() {
        if (this.isUnlockSuccess()) {
            const container = '.o-form-error-container';
            const text = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.selfservice.unlock_user.landing.to.app.signing.in.message', 'login');
            this.add(`<div class="ion-messages-container"><p>${text}</p></div>`, container);
            return;
        } else if (this.options.appState.containsMessageStartingWithI18nKey($fada7d47117f92a9$var$CUSTOM_ACCESS_DENIED_KEY)) {
            const { message: message, links: links } = this.options.appState.get('messages').value.find((msg)=>msg.i18n.key === $fada7d47117f92a9$var$CUSTOM_ACCESS_DENIED_KEY);
            this.add((0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)({
                type: 'error',
                content: new (0, $ccb47a661a4098b1$export$2e2bcd8739ae039)({
                    message: message,
                    links: links
                })
            }));
            return;
        }
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.showMessages.call(this);
    },
    isUnlockSuccess: function() {
        return this.options.appState.containsMessageWithI18nKey($fada7d47117f92a9$var$UNLOCK_USER_SUCCESS_MESSAGE);
    },
    noButtonBar: true,
    initialize: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        this.redirectView = this.settings.get('interstitialBeforeLoginRedirect');
        this.model.set('useRedirect', true);
        this.trigger('save', this.model);
    },
    render: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.render.apply(this, arguments);
        const currentViewState = this.options.appState.getCurrentViewState();
        // OKTA-1182955: render a Continue button instead of the auto-redirect spinner when the
        // backend signaled a successful prior Android AppLink (FastPass) verification. A user click
        // guarantees window focus before the redirect fires.
        if ((0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).isPostAppLinkVerification(currentViewState)) {
            this.add((0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
                className: 'button button-wide button-primary',
                title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.optional.authenticator.button.title', 'login'),
                id: 'applink-continue-redirect',
                click: ()=>{
                    (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).redirectWithFormGet(currentViewState.href);
                }
            }));
            return;
        }
        if (this.redirectView === (0, $4a07c2817278db15$export$5b95bebd73cede29).DEFAULT) this.add('<div class="okta-waiting-spinner"></div>');
    }
});
var $fada7d47117f92a9$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    Body: $fada7d47117f92a9$var$Body
});





















parcelRequire("3ZxP0");







const $be01c51bf2a47eac$var$PollMessageView = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"ion-messages-container\"><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "$1": "<span class='strong'>$1</span>",
                    "arguments": "countDownCounterValue",
                    "bundle": "login",
                    "code": "poll.form.message"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 39
                    },
                    "end": {
                        "line": 1,
                        "column": 157
                    }
                }
            })) + "</p></div><div class=\"hide okta-waiting-spinner\"></div>";
        },
        "useData": true
    }),
    getTemplateData: function() {
        const countDownCounterValue = this.options;
        return {
            countDownCounterValue: countDownCounterValue
        };
    }
});
const $be01c51bf2a47eac$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend(Object.assign({
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('poll.form.title', 'login');
    },
    noButtonBar: true,
    initialize: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        const refreshInterval = this.options.appState.getCurrentViewState().refresh;
        this.refreshTimeout = setTimeout(()=>{
            this.$el.find('.okta-waiting-spinner').show();
            // start after a small delay so that the spinner does not get hidden too soon
            setTimeout(()=>this.saveForm(this.model), 200);
        }, refreshInterval);
    },
    render: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.render.apply(this, arguments);
        this.countDownCounterValue = Math.ceil(this.options.appState.getCurrentViewState().refresh / (0, $5dcf8c5d7fe7c644$export$d31c30443e10a36c));
        this.add(new $be01c51bf2a47eac$var$PollMessageView(this.countDownCounterValue));
        this.startCountDown('.ion-messages-container span', (0, $5dcf8c5d7fe7c644$export$d31c30443e10a36c));
    },
    remove: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.remove.apply(this, arguments);
        clearTimeout(this.refreshTimeout);
    },
    triggerAfterError: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.triggerAfterError.apply(this, arguments);
        clearTimeout(this.refreshTimeout);
        this.stopCountDown();
        this.$el.find('.o-form-fieldset-container').empty();
    },
    startCountDown: function(selector, interval) {
        if (this.countDown) clearInterval(this.countDown);
        this.counterEl = this.$el.find(selector);
        this.countDown = setInterval(()=>{
            if (this.counterEl.text() !== '0') this.counterEl.text(this.counterEl.text() - 1);
        }, interval, this);
    },
    stopCountDown: function() {
        if (this.countDown) clearInterval(this.countDown);
    }
}));
var $be01c51bf2a47eac$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    Body: $be01c51bf2a47eac$var$Body
});





















parcelRequire("3ZxP0");
















const $ba4f78d75aaf778a$var$defaultLogo = '/img/logos/default.png';
const $ba4f78d75aaf778a$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'consent-title detail-row',
    titleText: ()=>(0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.consent.scopes.admin.title', 'login'),
    hasIssuer: true,
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a href=\"" + alias4((helper = (helper = lookupProperty(helpers, "clientURI") || (depth0 != null ? lookupProperty(depth0, "clientURI") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "clientURI",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 26
                    },
                    "end": {
                        "line": 1,
                        "column": 39
                    }
                }
            }) : helper)) + "\" class=\"client-logo-link\" title=\"" + alias4((helper = (helper = lookupProperty(helpers, "altText") || (depth0 != null ? lookupProperty(depth0, "altText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "altText",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 73
                    },
                    "end": {
                        "line": 1,
                        "column": 84
                    }
                }
            }) : helper)) + "\" target=\"_blank\">";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<img class=\"client-logo custom-logo\" src=\"" + alias4((helper = (helper = lookupProperty(helpers, "customLogo") || (depth0 != null ? lookupProperty(depth0, "customLogo") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "customLogo",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 169
                    },
                    "end": {
                        "line": 1,
                        "column": 183
                    }
                }
            }) : helper)) + "\" alt=\"" + alias4((helper = (helper = lookupProperty(helpers, "altText") || (depth0 != null ? lookupProperty(depth0, "altText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "altText",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 190
                    },
                    "end": {
                        "line": 1,
                        "column": 201
                    }
                }
            }) : helper)) + "\" aria-hidden=\"true\" />";
        },
        "2": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<img class=\"client-logo default-logo\" src=\"" + alias4((helper = (helper = lookupProperty(helpers, "defaultLogo") || (depth0 != null ? lookupProperty(depth0, "defaultLogo") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "defaultLogo",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 275
                    },
                    "end": {
                        "line": 1,
                        "column": 290
                    }
                }
            }) : helper)) + "\" alt=\"" + alias4((helper = (helper = lookupProperty(helpers, "altText") || (depth0 != null ? lookupProperty(depth0, "altText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "altText",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 297
                    },
                    "end": {
                        "line": 1,
                        "column": 308
                    }
                }
            }) : helper)) + "\" aria-hidden=\"true\" />";
        },
        "3": function(container, depth0, helpers, partials, data) {
            return "</a>";
        },
        "4": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"issuer no-translate\"><span>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "issuer") || (depth0 != null ? lookupProperty(depth0, "issuer") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "issuer",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 513
                    },
                    "end": {
                        "line": 1,
                        "column": 523
                    }
                }
            }) : helper)) + "</span></div>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "clientURI") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 109
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "customLogo") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.program(2, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 109
                    },
                    "end": {
                        "line": 1,
                        "column": 338
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "clientURI") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(3, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 338
                    },
                    "end": {
                        "line": 1,
                        "column": 366
                    }
                }
            })) != null ? stack1 : "") + "<h1><span class=\"title-text\"><b class=\"no-translate\">" + alias4((helper = (helper = lookupProperty(helpers, "appName") || (depth0 != null ? lookupProperty(depth0, "appName") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "appName",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 419
                    },
                    "end": {
                        "line": 1,
                        "column": 430
                    }
                }
            }) : helper)) + "</b>&nbsp;" + alias4((helper = (helper = lookupProperty(helpers, "titleText") || (depth0 != null ? lookupProperty(depth0, "titleText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "titleText",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 440
                    },
                    "end": {
                        "line": 1,
                        "column": 453
                    }
                }
            }) : helper)) + "</span>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "issuer") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(4, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 460
                    },
                    "end": {
                        "line": 1,
                        "column": 543
                    }
                }
            })) != null ? stack1 : "") + "</h1>";
        },
        "useData": true
    }),
    getTemplateData: function() {
        const { appState: appState } = this.options;
        const { label: label, clientUri: clientUri, logo: logo } = appState.get('app');
        const { issuer: issuerObj } = appState.get('authentication');
        const customLogo = logo === null || logo === void 0 ? void 0 : logo.href;
        const altText = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('logo.for.the.app.alt.text', 'login');
        const appName = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).escape(label);
        const clientURI = clientUri === null || clientUri === void 0 ? void 0 : clientUri.href;
        const issuer = this.hasIssuer ? issuerObj === null || issuerObj === void 0 ? void 0 : issuerObj.uri : null;
        const titleText = this.titleText();
        return {
            customLogo: customLogo,
            defaultLogo: $ba4f78d75aaf778a$var$defaultLogo,
            clientURI: clientURI,
            issuer: issuer,
            altText: altText,
            appName: appName,
            titleText: titleText
        };
    }
});





















parcelRequire("3ZxP0");






var $9d9af4f90bf6438f$export$2e2bcd8739ae039 = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    noButtonBar: false,
    noCancelButton: false,
    buttonOrder: [
        'cancel',
        'save'
    ],
    save: ()=>(0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('consent.required.consentButton', 'login'),
    cancel: ()=>(0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('consent.required.cancelButton', 'login'),
    title: false,
    events: {
        'click input[data-type="save"]': function() {
            this.setConsent(true);
        }
    },
    setConsent: function(bool) {
        this.model.set('consent', bool);
    },
    cancelForm: function() {
        // override BaseForm.prototype.cancelForm which cancels auth flow
        this.setConsent(false);
        this.options.appState.trigger('saveForm', this.model);
    }
});



var $34bb96a8c398e760$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    Header: (0, $ba4f78d75aaf778a$export$2e2bcd8739ae039),
    Body: (0, $9d9af4f90bf6438f$export$2e2bcd8739ae039),
    createModelClass: function(currentViewState) {
        const ModelClass = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).prototype.createModelClass.apply(this, arguments);
        const { uiSchema: uiSchema } = currentViewState;
        const { scopes: scopes } = uiSchema[0];
        const i18nKeyPrefix = 'consent.scopes';
        const localizedScopes = scopes.map(({ name: name, displayName: displayName, description: description })=>{
            const scopeKey = `${i18nKeyPrefix}.${name}`;
            const labelKey = `${scopeKey}.label`;
            const descKey = `${scopeKey}.desc`;
            const doesLabelExist = (0, $93a83f6fd41fc21e$export$82a8eacbf3403cb1)(labelKey);
            const doesDescExist = (0, $93a83f6fd41fc21e$export$82a8eacbf3403cb1)(descKey);
            const i18nDisplayName = doesLabelExist ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(labelKey, 'login') : displayName;
            const i18nDescription = doesDescExist ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(descKey, 'login') : description;
            return {
                name: name,
                displayName: i18nDisplayName,
                description: i18nDescription,
                isCustomized: !doesLabelExist
            };
        });
        return ModelClass.extend({
            props: {
                scopes: {
                    type: 'array',
                    value: localizedScopes
                }
            },
            local: {
                consent: {
                    type: 'boolean',
                    value: false
                }
            },
            toJSON: function() {
                return {
                    consent: this.get('consent')
                };
            }
        });
    }
});













const $9229b7c95998d90b$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'consent-footer',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a class=\"terms-of-service\" href=\"" + alias3((helper = (helper = lookupProperty(helpers, "termsOfService") || (depth0 != null ? lookupProperty(depth0, "termsOfService") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
                "name": "termsOfService",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 56
                    },
                    "end": {
                        "line": 1,
                        "column": 74
                    }
                }
            }) : helper)) + "\" target=\"_blank\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "consent.required.termsOfService"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 92
                    },
                    "end": {
                        "line": 1,
                        "column": 154
                    }
                }
            })) + "</a>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "privacyPolicy") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 158
                    },
                    "end": {
                        "line": 1,
                        "column": 226
                    }
                }
            })) != null ? stack1 : "");
        },
        "1": function(container, depth0, helpers, partials, data) {
            return "<span class=\"no-translate\">&#8226</span>";
        },
        "2": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a class=\"privacy-policy\" href=\"" + alias3((helper = (helper = lookupProperty(helpers, "privacyPolicy") || (depth0 != null ? lookupProperty(depth0, "privacyPolicy") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
                "name": "privacyPolicy",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 286
                    },
                    "end": {
                        "line": 1,
                        "column": 303
                    }
                }
            }) : helper)) + "\" target=\"_blank\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "consent.required.privacyPolicy"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 321
                    },
                    "end": {
                        "line": 1,
                        "column": 382
                    }
                }
            })) + "</a>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "termsOfService") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 233
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "privacyPolicy") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(2, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 233
                    },
                    "end": {
                        "line": 1,
                        "column": 393
                    }
                }
            })) != null ? stack1 : "");
        },
        "useData": true
    }),
    getTemplateData: function() {
        const appState = this.options.appState;
        const app = appState.get('app');
        return {
            termsOfService: app.termsOfService && app.termsOfService.href,
            privacyPolicy: app.privacyPolicy && app.privacyPolicy.href
        };
    }
});













var $e4aa06806e6bb52c$export$2e2bcd8739ae039 = (0, $ba4f78d75aaf778a$export$2e2bcd8739ae039).extend({
    titleText: ()=>(0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.consent.scopes.enduser.title', 'login'),
    hasIssuer: false
});












var $a2b70e0b8a85902d$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'consent-description detail-row',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "consent.required.description"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 3
                    },
                    "end": {
                        "line": 1,
                        "column": 62
                    }
                }
            })) + "</p>";
        },
        "useData": true
    })
});


var $698e97ff7473bde3$export$2e2bcd8739ae039 = (0, $34bb96a8c398e760$export$2e2bcd8739ae039).extend({
    Header: (0, $e4aa06806e6bb52c$export$2e2bcd8739ae039),
    Footer: (0, $9229b7c95998d90b$export$2e2bcd8739ae039),
    postRender: function() {
        const scopeList = this.$el.find('.scope-list');
        const consentAgreementText = new (0, $a2b70e0b8a85902d$export$2e2bcd8739ae039)().render().el;
        scopeList.after(consentAgreementText);
    }
});





















parcelRequire("3ZxP0");





















const $28b783cc66746c6e$var$CheckBox = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).views.forms.inputs.CheckBox;
var $28b783cc66746c6e$export$2e2bcd8739ae039 = $28b783cc66746c6e$var$CheckBox.extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<input type=\"checkbox\" name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "name",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 29
                    },
                    "end": {
                        "line": 1,
                        "column": 37
                    }
                }
            }) : helper)) + "\" id=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "inputId",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 43
                    },
                    "end": {
                        "line": 1,
                        "column": 54
                    }
                }
            }) : helper)) + "\"/><label for=\"" + alias4((helper = (helper = lookupProperty(helpers, "inputId") || (depth0 != null ? lookupProperty(depth0, "inputId") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "inputId",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 69
                    },
                    "end": {
                        "line": 1,
                        "column": 80
                    }
                }
            }) : helper)) + "\" data-se-for-name=\"" + alias4((helper = (helper = lookupProperty(helpers, "name") || (depth0 != null ? lookupProperty(depth0, "name") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "name",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 100
                    },
                    "end": {
                        "line": 1,
                        "column": 108
                    }
                }
            }) : helper)) + "\"><b>" + alias4((helper = (helper = lookupProperty(helpers, "placeholder") || (depth0 != null ? lookupProperty(depth0, "placeholder") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "placeholder",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 113
                    },
                    "end": {
                        "line": 1,
                        "column": 128
                    }
                }
            }) : helper)) + "</b><p>" + alias4((helper = (helper = lookupProperty(helpers, "desc") || (depth0 != null ? lookupProperty(depth0, "desc") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "desc",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 135
                    },
                    "end": {
                        "line": 1,
                        "column": 143
                    }
                }
            }) : helper)) + "</p></label>";
        },
        "useData": true
    }),
    getLocalizedLabel: function() {
        const key = `consent.scopes.${this.options.options.scopeName}.label`;
        return (0, $93a83f6fd41fc21e$export$82a8eacbf3403cb1)(key) ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(key, 'login') : this.options.placeholder || this.options.options.scopeName;
    },
    getLocalizedDesc: function() {
        const key = `consent.scopes.${this.options.options.scopeName}.desc`;
        return (0, $93a83f6fd41fc21e$export$82a8eacbf3403cb1)(key) ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(key, 'login') : this.options.options.desc;
    },
    isCustomizedScope: function() {
        return !(0, $93a83f6fd41fc21e$export$82a8eacbf3403cb1)(`consent.scopes.${this.options.options.scopeName}.label`);
    },
    /**
   * @Override
   */ enable: function() {
        if (this.options.options.mutable) this.$(':input').prop('disabled', false);
    },
    /**
   * @Override
   */ editMode: function() {
        this.$el.html(this.template((0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend((0, $3e490973b7383cc4$export$2e2bcd8739ae039).omit(this.options, 'placeholder'), {
            placeholder: this.getLocalizedLabel(),
            desc: this.getLocalizedDesc()
        })));
        this.$(':checkbox').prop('checked', this.getModelValue() || false);
        this.$('input').customInput();
        this.model.trigger('form:resize');
        if (!this.options.options.mutable) {
            const input = this.$('input').get(0);
            this.$(input.parentElement).addClass('o-form-read-mode');
            this.$(':checkbox').prop('disabled', true);
        }
        if (this.options.options.scopeName === 'openid' || this.isCustomizedScope()) {
            this.$('label > b').addClass('no-translate');
            if (this.isCustomizedScope()) this.$('label > p').addClass('no-translate');
        }
        return this;
    }
});


const $fa36da08e3523405$var$granularConsentViewHeader = (0, $ba4f78d75aaf778a$export$2e2bcd8739ae039).extend({
    hasIssuer: false,
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a href=\"" + alias4((helper = (helper = lookupProperty(helpers, "clientURI") || (depth0 != null ? lookupProperty(depth0, "clientURI") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "clientURI",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 26
                    },
                    "end": {
                        "line": 1,
                        "column": 39
                    }
                }
            }) : helper)) + "\" class=\"client-logo-link\" title=\"" + alias4((helper = (helper = lookupProperty(helpers, "altText") || (depth0 != null ? lookupProperty(depth0, "altText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "altText",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 73
                    },
                    "end": {
                        "line": 1,
                        "column": 84
                    }
                }
            }) : helper)) + "\" target=\"_blank\">";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<img class=\"client-logo custom-logo\" src=\"" + alias4((helper = (helper = lookupProperty(helpers, "customLogo") || (depth0 != null ? lookupProperty(depth0, "customLogo") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "customLogo",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 169
                    },
                    "end": {
                        "line": 1,
                        "column": 183
                    }
                }
            }) : helper)) + "\" alt=\"" + alias4((helper = (helper = lookupProperty(helpers, "altText") || (depth0 != null ? lookupProperty(depth0, "altText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "altText",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 190
                    },
                    "end": {
                        "line": 1,
                        "column": 201
                    }
                }
            }) : helper)) + "\" aria-hidden />";
        },
        "2": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<img class=\"client-logo default-logo\" src=\"" + alias4((helper = (helper = lookupProperty(helpers, "defaultLogo") || (depth0 != null ? lookupProperty(depth0, "defaultLogo") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "defaultLogo",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 268
                    },
                    "end": {
                        "line": 1,
                        "column": 283
                    }
                }
            }) : helper)) + "\" alt=\"" + alias4((helper = (helper = lookupProperty(helpers, "altText") || (depth0 != null ? lookupProperty(depth0, "altText") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                "name": "altText",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 290
                    },
                    "end": {
                        "line": 1,
                        "column": 301
                    }
                }
            }) : helper)) + "\" aria-hidden />";
        },
        "3": function(container, depth0, helpers, partials, data) {
            return "</a>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "clientURI") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 109
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "customLogo") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.program(2, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 109
                    },
                    "end": {
                        "line": 1,
                        "column": 324
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "clientURI") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(3, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 324
                    },
                    "end": {
                        "line": 1,
                        "column": 352
                    }
                }
            })) != null ? stack1 : "") + "<h1><span class=\"title-text\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
                "name": "i18n",
                "hash": {
                    "$2": "<p>$2</p>",
                    "$1": "<b class='no-translate'>$1</b>",
                    "arguments": "appName",
                    "bundle": "login",
                    "code": "oie.consent.scopes.granular.title"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 381
                    },
                    "end": {
                        "line": 1,
                        "column": 517
                    }
                }
            })) + "</span></h1>";
        },
        "useData": true
    })
});
const $fa36da08e3523405$var$granularConsentViewForm = (0, $9d9af4f90bf6438f$export$2e2bcd8739ae039).extend({
    cancel: (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.cancel,
    getUISchema: function() {
        const uiSchemas = (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.getUISchema.apply(this, arguments);
        uiSchemas.forEach((schema)=>{
            if (schema.type === 'checkbox') (0, $3e490973b7383cc4$export$2e2bcd8739ae039).assign(schema, {
                input: (0, $28b783cc66746c6e$export$2e2bcd8739ae039),
                options: {
                    desc: schema.desc,
                    mutable: schema.mutable,
                    // need to extract scope name because it is in a subform (optedScopes.name)
                    scopeName: schema.name.substring(schema.name.indexOf('.') + 1)
                }
            });
        });
        return uiSchemas;
    }
});
const $fa36da08e3523405$var$GranularConsentAgreementText = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'consent-description',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.consent.scopes.granular.description"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 3
                    },
                    "end": {
                        "line": 1,
                        "column": 73
                    }
                }
            })) + "</p>";
        },
        "useData": true
    })
});
var $fa36da08e3523405$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    Header: $fa36da08e3523405$var$granularConsentViewHeader,
    Body: $fa36da08e3523405$var$granularConsentViewForm,
    Footer: (0, $9229b7c95998d90b$export$2e2bcd8739ae039),
    createModelClass: function() {
        const ModelClass = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).prototype.createModelClass.apply(this, arguments);
        // Disable Courage's flatten/unflatten round-trip for the granular-consent
        // model. Scope names can collide on dotted prefixes (e.g. `custom1` and
        // `custom1.custom2`) and would otherwise crash unflatten in
        // Model.toJSON({verbose:true}) during BaseView.renderForm.
        return ModelClass.extend({
            flat: false
        });
    },
    postRender: function() {
        const scopeList = this.$el.find('.o-form-fieldset-container');
        // Show consent agreement text
        scopeList.before(new $fa36da08e3523405$var$GranularConsentAgreementText().render().el);
        // Re-order scopes so mandatory ones are on bottom
        this.$(':disabled').each(function() {
            scopeList.append((0, $b51a961f9fe28c76$export$2e2bcd8739ae039)(this).closest('.o-form-fieldset'));
        });
    }
});





















parcelRequire("3ZxP0");









const $82e78d10f9c7182e$var$getInfo = (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
    "0": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<div class=\"enduser-email-consent--info no-translate\"><i class=\"enduser-email-consent--icon icon--desktop\"></i><div>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "browser") || (depth0 != null ? lookupProperty(depth0, "browser") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "browser",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 131
                },
                "end": {
                    "line": 1,
                    "column": 142
                }
            }
        }) : helper)) + "</div></div>";
    },
    "1": function(container, depth0, helpers, partials, data) {
        var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return "<div class=\"enduser-email-consent--info no-translate\"><i class=\"enduser-email-consent--icon icon--app\"></i><div>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "app") || (depth0 != null ? lookupProperty(depth0, "app") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
            "name": "app",
            "hash": {},
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 284
                },
                "end": {
                    "line": 1,
                    "column": 291
                }
            }
        }) : helper)) + "</div></div>";
    },
    "compiler": [
        8,
        ">= 4.3.0"
    ],
    "main": function(container, depth0, helpers, partials, data) {
        var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
            return undefined;
        };
        return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "browser") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(0, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 0
                },
                "end": {
                    "line": 1,
                    "column": 161
                }
            }
        })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "app") : depth0, {
            "name": "if",
            "hash": {},
            "fn": container.program(1, data, 0),
            "inverse": container.noop,
            "data": data,
            "loc": {
                "start": {
                    "line": 1,
                    "column": 161
                },
                "end": {
                    "line": 1,
                    "column": 310
                }
            }
        })) != null ? stack1 : "");
    },
    "useData": true
});
const $82e78d10f9c7182e$var$enduserEmailConsentViewBody = (0, $9d9af4f90bf6438f$export$2e2bcd8739ae039).extend({
    className: 'enduser-email-consent',
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.consent.enduser.title', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.consent.enduser.accept.label', 'login');
    },
    cancel: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.consent.enduser.deny.label', 'login');
    },
    initialize: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        const info = $82e78d10f9c7182e$var$getInfo(this.model.pick('browser', 'app'));
        this.add(info);
    },
    getUISchema: function() {
        const uiSchemas = (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.getUISchema.apply(this, arguments);
        return uiSchemas.filter((uiSchema)=>uiSchema.name !== 'consent');
    }
});
var $82e78d10f9c7182e$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Header: (0, $36054a289f1cf062$export$2e2bcd8739ae039),
    buttonOrder: [
        'cancel',
        'save'
    ],
    postRender: function() {
        const buttonContainer = this.$el.find('.o-form-button-bar');
        buttonContainer.find('.button-primary').removeClass('button-primary');
    },
    Body: $82e78d10f9c7182e$var$enduserEmailConsentViewBody,
    createModelClass: function({ requestInfo: requestInfo }) {
        const ModelClass = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).prototype.createModelClass.apply(this, arguments);
        const browser = requestInfo.find(({ name: name })=>name === 'browser');
        const app = requestInfo.find(({ name: name })=>name === 'appName');
        const local = Object.assign({
            browser: {
                type: 'string',
                value: browser === null || browser === void 0 ? void 0 : browser.value
            },
            app: {
                type: 'string',
                value: app === null || app === void 0 ? void 0 : app.value
            }
        }, ModelClass.prototype.local);
        return ModelClass.extend({
            local: local,
            toJSON: function() {
                return {
                    consent: this.get('consent')
                };
            }
        });
    }
});





















parcelRequire("3ZxP0");





























parcelRequire("3ZxP0");







var $230f2403f1b5c7f9$export$2e2bcd8739ae039 = (0, $4c0f78fce7387c76$export$2e2bcd8739ae039).extend({
    HeaderBeacon: (0, $21a17fd013ef567d$export$55fd27ee2a571226).extend({
        authenticatorKey: (0, $4a07c2817278db15$export$a7895cc4b0944d1b).OV
    })
});




const $0570689af6703cd8$var$CUSTOM_ACCESS_DENIED_KEY = 'security.access_denied_custom_message';
const $0570689af6703cd8$var$Body = (0, $39d1dd94b85d250f$export$2e2bcd8739ae039).extend({
    pollingCancelAction: (0, $5dcf8c5d7fe7c644$export$8649076611c9e710),
    getDeviceChallengePayload: function() {
        return this.options.currentViewState.relatesTo.value;
    },
    doChallenge: function() {
        (0, $cbe16f34ebe007b2$export$f7c4f163a089df21)(this, (0, $5dcf8c5d7fe7c644$export$553bba1f918a5420));
    },
    onPollingFail: function() {
        (0, $39d1dd94b85d250f$export$2e2bcd8739ae039).prototype.onPollingFail.apply(this, arguments);
        // When SIW receives form error, polling is already stopped
        // SIW needs to update footer link from /poll/cancel to /idp/idx/cancel
        const data = {
            label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('loopback.polling.cancel.link.with.form.error', 'login')
        };
        this.options.appState.trigger('updateFooterLink', data);
    },
    showCustomFormErrorCallout: function(error, messages) {
        const responseJSON = error.responseJSON;
        let options = {
            type: 'error',
            className: 'okta-verify-uv-callout-content',
            subtitle: responseJSON.errorSummary
        };
        const containsSignedNonceError = responseJSON.errorSummaryKeys && responseJSON.errorSummaryKeys.some((key)=>key.includes('auth.factor.signedNonce.error'));
        if (containsSignedNonceError) options.title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('user.fail.verifyIdentity', 'login');
        const containsCustomAccessDeniedError = responseJSON.errorSummaryKeys && responseJSON.errorSummaryKeys.some((key)=>key.includes('security.access_denied_custom_message'));
        if (containsCustomAccessDeniedError) {
            const message = messages === null || messages === void 0 ? void 0 : messages.find((message)=>message.i18n.key === $0570689af6703cd8$var$CUSTOM_ACCESS_DENIED_KEY);
            if (!message) return false;
            options = {
                type: 'error',
                content: new (0, $ccb47a661a4098b1$export$2e2bcd8739ae039)({
                    message: responseJSON.errorSummary,
                    links: message.links
                })
            };
        }
        this.showMessages((0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)(options));
        return true;
    }
});
const $0570689af6703cd8$var$Footer = (0, $31737d9aae112815$export$2e2bcd8739ae039).extend({
    initialize: function() {
        this.listenTo(this.options.appState, 'updateFooterLink', this.handleUpdateFooterLink);
        if (this.isFallbackApproach() && !this.isFallbackDelayed()) (0, $31737d9aae112815$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        else this.backLink = this.add((0, $15be617e7228d213$export$2e2bcd8739ae039), {
            options: {
                name: 'cancel-authenticator-challenge',
                label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('loopback.polling.cancel.link', 'login'),
                clickHandler: ()=>{
                    (0, $cbe16f34ebe007b2$export$2620436be5963374)(this.options.appState, (0, $5dcf8c5d7fe7c644$export$8649076611c9e710), (0, $5dcf8c5d7fe7c644$export$2f37c9233c87243c).USER_CANCELED, null);
                }
            }
        }).last();
    },
    handleUpdateFooterLink: function(data) {
        // only update link for loopback
        if (!this.isFallbackApproach() || this.isFallbackDelayed()) {
            this.backLink && this.backLink.remove();
            this.backLink = this.add((0, $15be617e7228d213$export$2e2bcd8739ae039), {
                options: (0, $aaa5b7e3293b6284$export$57ec3e9faf8794d)(this.options.settings, data)[0]
            }).last();
        }
    },
    isFallbackApproach: function() {
        return [
            (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).CUSTOM_URI_CHALLENGE,
            (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).UNIVERSAL_LINK_CHALLENGE,
            (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).APP_LINK_CHALLENGE
        ].includes(this.options.currentViewState.relatesTo.value.challengeMethod);
    },
    isFallbackDelayed: function() {
        // only delay showing the reopen Okta Verify button for the app link approach for now
        // until we have more data shows other approaches have the slow cold start problem of the Okta Verify app as well
        return this.options.currentViewState.relatesTo.value.challengeMethod === (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).APP_LINK_CHALLENGE;
    }
});
var $0570689af6703cd8$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    Header: (0, $230f2403f1b5c7f9$export$2e2bcd8739ae039),
    Body: $0570689af6703cd8$var$Body,
    Footer: $0570689af6703cd8$var$Footer
});





















parcelRequire("3ZxP0");






// for BETA,
// redirect is needed for Apple SSO Extension to intercept the request, because
// - XHR request is not interceptable
// - form post is interceptable, but some app (Outlook) closes the app after
// We may have a different approach/UX for EA
const $fbe71fa98a792c9b$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    noButtonBar: true,
    className: 'ion-form device-challenge-poll',
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('deviceTrust.sso.redirectText', 'login');
    },
    initialize: function() {
        var _this$options$current, _this$options$current2;
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        this.listenTo(this.model, 'error', ()=>{
            this.$('.spinner').hide();
        });
        this.add('<div class="spinner"></div>');
        const isGetMethod = ((_this$options$current = this.options.currentViewState) === null || _this$options$current === void 0 ? void 0 : (_this$options$current2 = _this$options$current.method) === null || _this$options$current2 === void 0 ? void 0 : _this$options$current2.toLowerCase()) === 'get';
        this.model.set('useRedirect', isGetMethod);
        this.trigger('save', this.model);
    }
});
var $fbe71fa98a792c9b$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    Body: $fbe71fa98a792c9b$var$Body
});





















parcelRequire("3ZxP0");








const $ae485660e043bac0$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('primaryauth.title', 'login');
    },
    noButtonBar: true,
    initialize: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        this.add((0, $7707bc4039c29f4d$export$2e2bcd8739ae039), {
            selector: '.o-form-fieldset-container',
            bubble: false,
            prepend: true,
            options: {
                isRequired: true
            }
        });
    }
});
// override the footer to add all the supported links except the sign out link
// no session is granted at this point
const $ae485660e043bac0$var$Footer = (0, $f69e256d99f29568$export$2e2bcd8739ae039).extend({
    hasBackToSignInLink: false
});
var $ae485660e043bac0$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    Body: $ae485660e043bac0$var$Body,
    Footer: $ae485660e043bac0$var$Footer
});





















parcelRequire("3ZxP0");

















const { Notification: $a31988f9a65fceac$var$Notification } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).views.components;
const { Clipboard: $a31988f9a65fceac$var$Clipboard } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).util;
const $a31988f9a65fceac$export$332248ce3094b0c5 = (deviceEnrollment)=>{
    const platform = (deviceEnrollment.platform || '').toLowerCase();
    const challengeMethod = deviceEnrollment.challengeMethod;
    const enrollmentType = deviceEnrollment.name;
    const isIOS = platform === (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).IOS;
    const isAndroidAppLink = platform === (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).ANDROID && challengeMethod === 'APP_LINK';
    const isAndroidLoopback = platform === (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).ANDROID && challengeMethod === 'LOOPBACK';
    return {
        signInUrl: deviceEnrollment.signInUrl,
        isIOS: isIOS,
        enrollmentType: enrollmentType,
        isAndroidLoopback: isAndroidLoopback,
        isAndroidAppLink: isAndroidAppLink,
        appStoreLink: isIOS ? (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).OKTA_VERIFY_APPLE_APP_STORE_URL : (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).OKTA_VERIFY_GOOGLE_PLAY_STORE_URL,
        orgName: deviceEnrollment.orgName
    };
};
const $a31988f9a65fceac$var$BaseOdaOktaVerifyTerminalView = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    getTemplateData: function() {
        const deviceEnrollment = this.options.appState.get('deviceEnrollment');
        return $a31988f9a65fceac$export$332248ce3094b0c5(deviceEnrollment);
    }
});
const $a31988f9a65fceac$export$36cc0f482d883542 = $a31988f9a65fceac$var$BaseOdaOktaVerifyTerminalView.extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.mdm.step.copyLink"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 120
                    },
                    "end": {
                        "line": 1,
                        "column": 175
                    }
                }
            })) + "<a data-clipboard-text=\"" + alias3((helper = (helper = lookupProperty(helpers, "appStoreLink") || (depth0 != null ? lookupProperty(depth0, "appStoreLink") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
                "name": "appStoreLink",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 199
                    },
                    "end": {
                        "line": 1,
                        "column": 215
                    }
                }
            }) : helper)) + "\" class=\"button link-button copy-clipboard-button\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.mdm.copyLink"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 266
                    },
                    "end": {
                        "line": 1,
                        "column": 316
                    }
                }
            })) + "</a></li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.mdm.step.pasteLink"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 329
                    },
                    "end": {
                        "line": 1,
                        "column": 385
                    }
                }
            })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.oda.step3"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 394
                    },
                    "end": {
                        "line": 1,
                        "column": 441
                    }
                }
            })) + "</li>";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<li>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.oda.android.step1"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 482
                    },
                    "end": {
                        "line": 1,
                        "column": 537
                    }
                }
            })) + "</li>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, alias4 = "function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p class=\"explanation\" data-se=\"subheader\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.explanation.p1"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 43
                    },
                    "end": {
                        "line": 1,
                        "column": 95
                    }
                }
            })) + "</p><ol>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "isIOS") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 103
                    },
                    "end": {
                        "line": 1,
                        "column": 453
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "isAndroidLoopback") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 453
                    },
                    "end": {
                        "line": 1,
                        "column": 549
                    }
                }
            })) != null ? stack1 : "") + "<li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.oda.step1"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 553
                    },
                    "end": {
                        "line": 1,
                        "column": 600
                    }
                }
            })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.oda.step2"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 609
                    },
                    "end": {
                        "line": 1,
                        "column": 656
                    }
                }
            })) + "<p class=\"org-signin-link\"><span class=\"no-translate\">" + alias3((helper = (helper = lookupProperty(helpers, "signInUrl") || (depth0 != null ? lookupProperty(depth0, "signInUrl") : depth0)) != null ? helper : alias2, typeof helper === alias4 ? helper.call(alias1, {
                "name": "signInUrl",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 710
                    },
                    "end": {
                        "line": 1,
                        "column": 723
                    }
                }
            }) : helper)) + "</span></p><a data-clipboard-text=\"" + alias3((helper = (helper = lookupProperty(helpers, "signInUrl") || (depth0 != null ? lookupProperty(depth0, "signInUrl") : depth0)) != null ? helper : alias2, typeof helper === alias4 ? helper.call(alias1, {
                "name": "signInUrl",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 758
                    },
                    "end": {
                        "line": 1,
                        "column": 771
                    }
                }
            }) : helper)) + "\" class=\"button link-button copy-org-clipboard-button\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.oda.org.copyLink"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 826
                    },
                    "end": {
                        "line": 1,
                        "column": 880
                    }
                }
            })) + "</a></li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.oda.step6"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 893
                    },
                    "end": {
                        "line": 1,
                        "column": 940
                    }
                }
            })) + "</li></ol>";
        },
        "useData": true
    }),
    postRender: function() {
        // Attach each button to the respective 'data-clipboard-text'
        $a31988f9a65fceac$var$Clipboard.attach('.copy-clipboard-button').done(()=>{
            let notification = new $a31988f9a65fceac$var$Notification({
                message: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.mdm.copyLink.success', 'login'),
                level: 'success'
            });
            this.el.prepend(notification.render().el);
            return false;
        });
        $a31988f9a65fceac$var$Clipboard.attach('.copy-org-clipboard-button').done(()=>{
            let notification = new $a31988f9a65fceac$var$Notification({
                message: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.oda.org.copyLink.success', 'login'),
                level: 'success'
            });
            this.el.prepend(notification.render().el);
            return false;
        });
    }
});
const $a31988f9a65fceac$export$54ded387a3b90afb = $a31988f9a65fceac$var$BaseOdaOktaVerifyTerminalView.extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p class=\"explanation\" data-se=\"subheader\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.oda.with.account.explanation"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 43
                    },
                    "end": {
                        "line": 1,
                        "column": 109
                    }
                }
            })) + "</p><p class=\"subtitle\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.oda.with.account.subtitile1 "
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 133
                    },
                    "end": {
                        "line": 1,
                        "column": 199
                    }
                }
            })) + "</p><ul><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.oda.with.account.step1"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 211
                    },
                    "end": {
                        "line": 1,
                        "column": 271
                    }
                }
            })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.oda.with.account.step2"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 280
                    },
                    "end": {
                        "line": 1,
                        "column": 340
                    }
                }
            })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.oda.with.account.step3"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 349
                    },
                    "end": {
                        "line": 1,
                        "column": 409
                    }
                }
            })) + "</li></ul><p class=\"subtitle\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.oda.with.account.subtitile2 "
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 439
                    },
                    "end": {
                        "line": 1,
                        "column": 505
                    }
                }
            })) + "</p><ol><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.oda.with.account.step4"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 517
                    },
                    "end": {
                        "line": 1,
                        "column": 577
                    }
                }
            })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "arguments": "signInUrl",
                    "bundle": "login",
                    "code": "enroll.oda.with.account.step5"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 586
                    },
                    "end": {
                        "line": 1,
                        "column": 668
                    }
                }
            })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.oda.with.account.step6"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 677
                    },
                    "end": {
                        "line": 1,
                        "column": 737
                    }
                }
            })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.oda.with.account.step7"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 746
                    },
                    "end": {
                        "line": 1,
                        "column": 806
                    }
                }
            })) + "</li></ol>";
        },
        "useData": true
    })
});
const $a31988f9a65fceac$export$64abf67c13220a6a = $a31988f9a65fceac$var$BaseOdaOktaVerifyTerminalView.extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, alias4 = "function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p class=\"explanation\" data-se=\"subheader\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.oda.without.account.explanation"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 43
                    },
                    "end": {
                        "line": 1,
                        "column": 112
                    }
                }
            })) + "</p><ol><li>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "arguments": "appStoreLink",
                    "bundle": "login",
                    "code": "enroll.oda.without.account.step1"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 124
                    },
                    "end": {
                        "line": 1,
                        "column": 214
                    }
                }
            })) != null ? stack1 : "") + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.oda.step1"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 223
                    },
                    "end": {
                        "line": 1,
                        "column": 270
                    }
                }
            })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.oda.step2"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 279
                    },
                    "end": {
                        "line": 1,
                        "column": 326
                    }
                }
            })) + "<p class=\"org-signin-link\"><span class=\"no-translate\">" + alias3((helper = (helper = lookupProperty(helpers, "signInUrl") || (depth0 != null ? lookupProperty(depth0, "signInUrl") : depth0)) != null ? helper : alias2, typeof helper === alias4 ? helper.call(alias1, {
                "name": "signInUrl",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 380
                    },
                    "end": {
                        "line": 1,
                        "column": 393
                    }
                }
            }) : helper)) + "</span></p><a data-clipboard-text=\"" + alias3((helper = (helper = lookupProperty(helpers, "signInUrl") || (depth0 != null ? lookupProperty(depth0, "signInUrl") : depth0)) != null ? helper : alias2, typeof helper === alias4 ? helper.call(alias1, {
                "name": "signInUrl",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 428
                    },
                    "end": {
                        "line": 1,
                        "column": 441
                    }
                }
            }) : helper)) + "\" class=\"button link-button copy-org-clipboard-button\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.oda.org.copyLink"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 496
                    },
                    "end": {
                        "line": 1,
                        "column": 550
                    }
                }
            })) + "</a></li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.oda.without.account.step4"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 563
                    },
                    "end": {
                        "line": 1,
                        "column": 626
                    }
                }
            })) + "</li></ol>";
        },
        "useData": true
    }),
    postRender: function() {
        // Attach each button to the respective 'data-clipboard-text'
        $a31988f9a65fceac$var$Clipboard.attach('.copy-org-clipboard-button').done(()=>{
            let notification = new $a31988f9a65fceac$var$Notification({
                message: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.oda.org.copyLink.success', 'login'),
                level: 'success'
            });
            this.el.prepend(notification.render().el);
            return false;
        });
    }
});












const { Notification: $546ff7dad41b1721$var$Notification } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).views.components;
const { Clipboard: $546ff7dad41b1721$var$Clipboard } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).util;
var $546ff7dad41b1721$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.explanation.mdm"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 5
                    },
                    "end": {
                        "line": 1,
                        "column": 58
                    }
                }
            })) + "</div><ol><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.mdm.step.copyLink"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 72
                    },
                    "end": {
                        "line": 1,
                        "column": 127
                    }
                }
            })) + "<a data-clipboard-text=\"" + alias3((helper = (helper = lookupProperty(helpers, "enrollmentLink") || (depth0 != null ? lookupProperty(depth0, "enrollmentLink") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
                "name": "enrollmentLink",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 151
                    },
                    "end": {
                        "line": 1,
                        "column": 169
                    }
                }
            }) : helper)) + "\" class=\"button link-button copy-clipboard-button\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.mdm.copyLink"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 220
                    },
                    "end": {
                        "line": 1,
                        "column": 270
                    }
                }
            })) + "</a></li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.mdm.step.pasteLink"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 283
                    },
                    "end": {
                        "line": 1,
                        "column": 339
                    }
                }
            })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "$1": "<span class='semi-strong'>$1</span>",
                    "arguments": "vendor",
                    "bundle": "login",
                    "code": "enroll.mdm.step.followInstructions"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 348
                    },
                    "end": {
                        "line": 1,
                        "column": 473
                    }
                }
            })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.mdm.step.relogin"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 482
                    },
                    "end": {
                        "line": 1,
                        "column": 536
                    }
                }
            })) + "</li></ol>";
        },
        "useData": true
    }),
    getTemplateData: function() {
        return this.options.appState.get('deviceEnrollment');
    },
    postRender: function() {
        // Attach each button to the respective 'data-clipboard-text'
        $546ff7dad41b1721$var$Clipboard.attach('.copy-clipboard-button').done(()=>{
            let notification = new $546ff7dad41b1721$var$Notification({
                message: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.mdm.copyLink.success', 'login'),
                level: 'success'
            });
            this.el.prepend(notification.render().el);
            return false;
        });
    }
});





const $6b2f4f64193231e1$var$BaseDeviceEnrollTerminalForm = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    noButtonBar: true,
    className: 'device-enrollment-terminal'
});
const $6b2f4f64193231e1$var$AndroidAppLinkPreselectForm = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    attributes: {
        'data-se': 'android-app-link-setup-options-terminal'
    },
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.title.oda.with.account', 'login');
    },
    initialize: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        const deviceEnrollmentContext = (0, $a31988f9a65fceac$export$332248ce3094b0c5)(this.options.appState.get('deviceEnrollment'));
        this.model.set('hasOVAccount', 'no');
        this.addInput({
            label: ()=>(0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.subtitle.fastpass', 'login', [
                    deviceEnrollmentContext.orgName
                ]),
            'label-top': true,
            options: {
                'no': (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.option.noaccount.fastpass', 'login'),
                'yes': (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.option.account.fastpass', 'login')
            },
            name: 'hasOVAccount',
            type: 'radio'
        });
    },
    saveForm: function() {
        //remove any existing warnings or messages before saving form
        this.$el.find('.o-form-error-container').empty();
        this.options.appState.trigger('updateDeviceEnrollmentView', this.model.get('hasOVAccount') === 'yes');
    }
});
const $6b2f4f64193231e1$var$AndroidAppLinkWithAccountOdaTerminalForm = $6b2f4f64193231e1$var$BaseDeviceEnrollTerminalForm.extend({
    attributes: {
        'data-se': 'android-oda-app-link-with-ov-account-terminal'
    },
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.title.oda.with.account', 'login');
    },
    initialize: function() {
        $6b2f4f64193231e1$var$BaseDeviceEnrollTerminalForm.prototype.initialize.apply(this, arguments);
        this.add((0, $a31988f9a65fceac$export$54ded387a3b90afb));
    }
});
const $6b2f4f64193231e1$var$AndroidAppLinkWithoutAccountOdaTerminalForm = $6b2f4f64193231e1$var$BaseDeviceEnrollTerminalForm.extend({
    attributes: {
        'data-se': 'android-oda-app-link-without-ov-account-terminal'
    },
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.title.oda.without.account', 'login');
    },
    initialize: function() {
        $6b2f4f64193231e1$var$BaseDeviceEnrollTerminalForm.prototype.initialize.apply(this, arguments);
        this.add((0, $a31988f9a65fceac$export$64abf67c13220a6a));
    }
});
const $6b2f4f64193231e1$var$IosAndAndroidLoopbackOdaTerminalForm = $6b2f4f64193231e1$var$BaseDeviceEnrollTerminalForm.extend({
    attributes: {
        'data-se': 'loopback-terminal'
    },
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.title.oda', 'login');
    },
    initialize: function() {
        $6b2f4f64193231e1$var$BaseDeviceEnrollTerminalForm.prototype.initialize.apply(this, arguments);
        this.add((0, $a31988f9a65fceac$export$36cc0f482d883542));
    }
});
const $6b2f4f64193231e1$var$MdmTerminalForm = $6b2f4f64193231e1$var$BaseDeviceEnrollTerminalForm.extend({
    attributes: {
        'data-se': 'mdm-terminal'
    },
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.title.mdm', 'login');
    },
    initialize: function() {
        $6b2f4f64193231e1$var$BaseDeviceEnrollTerminalForm.prototype.initialize.apply(this, arguments);
        this.add((0, $546ff7dad41b1721$export$2e2bcd8739ae039));
    }
});
const $6b2f4f64193231e1$var$AndroidAppLinkTerminalViewFooter = (0, $15be617e7228d213$export$2e2bcd8739ae039).extend({
    postRender: function() {
        this.$el.click((event)=>{
            event.preventDefault();
            this.options.appState.trigger('switchBackToPreselect');
        });
    }
});
var $6b2f4f64193231e1$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    initialize: function() {
        (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        this.listenTo(this.options.appState, 'updateDeviceEnrollmentView', this.handleUpdateDeviceEnrollmentView);
        this.listenTo(this.options.appState, 'switchBackToPreselect', this.handleSwitchBackToPreselect);
        const deviceEnrollmentContext = (0, $a31988f9a65fceac$export$332248ce3094b0c5)(this.options.appState.get('deviceEnrollment'));
        this.enrollmentType = (deviceEnrollmentContext.enrollmentType || '').toLowerCase(); // oda/mdm
        switch(this.enrollmentType){
            case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).ODA:
                this.Header = (0, $230f2403f1b5c7f9$export$2e2bcd8739ae039);
                this.Body = deviceEnrollmentContext.isAndroidAppLink ? $6b2f4f64193231e1$var$AndroidAppLinkPreselectForm : $6b2f4f64193231e1$var$IosAndAndroidLoopbackOdaTerminalForm;
                break;
            case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).MDM:
                this.Body = $6b2f4f64193231e1$var$MdmTerminalForm;
                break;
            case (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).WS1:
                this.Body = $6b2f4f64193231e1$var$MdmTerminalForm;
        }
    },
    handleUpdateDeviceEnrollmentView: function(withAccount) {
        this.Body = withAccount ? $6b2f4f64193231e1$var$AndroidAppLinkWithAccountOdaTerminalForm : $6b2f4f64193231e1$var$AndroidAppLinkWithoutAccountOdaTerminalForm;
        this.backLink = this.add($6b2f4f64193231e1$var$AndroidAppLinkTerminalViewFooter, {
            options: {
                name: 'back-to-preselect',
                label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oform.back', 'login')
            }
        }).last();
        this.renderForm();
    },
    handleSwitchBackToPreselect: function() {
        this.Body = $6b2f4f64193231e1$var$AndroidAppLinkPreselectForm;
        this.backLink && this.backLink.remove();
        this.render();
    }
});































const $852629d60ac0b854$export$be0c8adfc3f95911 = function(form, rulesList, prepend) {
    form.add((0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
        tagName: 'section',
        template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
            "0": function(container, depth0, helpers, partials, data) {
                return "<li>" + container.escapeExpression(container.lambda(depth0, depth0)) + "</li>";
            },
            "compiler": [
                8,
                ">= 4.3.0"
            ],
            "main": function(container, depth0, helpers, partials, data) {
                var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                    return undefined;
                };
                return "<div class=\"password-authenticator--heading\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
                    "name": "i18n",
                    "hash": {
                        "bundle": "login",
                        "code": "password.complexity.requirements.header"
                    },
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 45
                        },
                        "end": {
                            "line": 1,
                            "column": 115
                        }
                    }
                })) + "</div><ul class=\"password-authenticator--list\">" + ((stack1 = lookupProperty(helpers, "each").call(alias1, depth0 != null ? lookupProperty(depth0, "rulesList") : depth0, {
                    "name": "each",
                    "hash": {},
                    "fn": container.program(0, data, 0),
                    "inverse": container.noop,
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 162
                        },
                        "end": {
                            "line": 1,
                            "column": 207
                        }
                    }
                })) != null ? stack1 : "") + "</ul>";
            },
            "useData": true
        }),
        getTemplateData: ()=>({
                rulesList: rulesList
            }),
        attributes: {
            'data-se': 'password-authenticator--rules'
        }
    }), {
        prepend: prepend,
        selector: '.o-form-fieldset-container'
    });
};



const $f191d8261c883c0e$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    title: function() {
        if (this.options.appState.getCurrentViewState().href.endsWith('idp/idx/enroll/update')) {
            var _attributes$uiDisplay;
            const attributes = this.options.appState.attributes;
            if (attributes !== null && attributes !== void 0 && (_attributes$uiDisplay = attributes.uiDisplay) !== null && _attributes$uiDisplay !== void 0 && _attributes$uiDisplay.label) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.registration.form.customize.label', 'login', [
                attributes.uiDisplay.label
            ]);
            else return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.primaryauth.submit', 'login');
        }
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.registration.form.title', 'login');
    },
    save: function() {
        if (this.options.appState.getCurrentViewState().href.endsWith('idp/idx/enroll/update')) {
            var _attributes$uiDisplay2;
            const attributes = this.options.appState.attributes;
            if (attributes !== null && attributes !== void 0 && (_attributes$uiDisplay2 = attributes.uiDisplay) !== null && _attributes$uiDisplay2 !== void 0 && _attributes$uiDisplay2.buttonLabel) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.registration.form.customize.buttonLabel', 'login', [
                attributes.uiDisplay.buttonLabel
            ]);
            else return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.registration.form.update.submit', 'login');
        }
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.registration.form.submit', 'login');
    },
    saveForm: function() {
        // SIW customization hook for registration
        this.settings.preRegistrationSubmit(this.model.toJSON(), (postData)=>{
            this.model.attributes = {
                ...this.model.attributes,
                ...this.model.parse(postData)
            };
            (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.saveForm.call(this, this.model);
        }, (error)=>this.model.trigger('error', this.model, {
                responseJSON: error
            }));
    },
    triggerAfterError: function(model, error) {
        var _error$responseJSON;
        // render errors to view
        const hasErrors = (error === null || error === void 0 ? void 0 : (_error$responseJSON = error.responseJSON) === null || _error$responseJSON === void 0 ? void 0 : _error$responseJSON.errorCauses) && Array.isArray(error.responseJSON.errorCauses);
        if (hasErrors) error.responseJSON.errorCauses.forEach((err)=>{
            var _err$errorKey;
            // only do this for invalid password for password with SSR
            if ((_err$errorKey = err.errorKey) !== null && _err$errorKey !== void 0 && _err$errorKey.includes('password.passwordRequirementsNotMet')) err.errorSummary = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('registration.error.password.passwordRequirementsNotMet', 'login');
        });
        this.options.appState.trigger('afterError', error);
    }
});
const $f191d8261c883c0e$var$Footer = (0, $31737d9aae112815$export$2e2bcd8739ae039).extend({
    links: function() {
        const links = [];
        if (this.options.appState.hasRemediationObject((0, $4a07c2817278db15$export$657220afecfe252).SELECT_IDENTIFY)) links.push({
            'type': 'link',
            'label': (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('haveaccount', 'login'),
            'name': 'back',
            'actionPath': (0, $4a07c2817278db15$export$657220afecfe252).SELECT_IDENTIFY
        });
        return links;
    }
});
var $f191d8261c883c0e$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    Body: $f191d8261c883c0e$var$Body,
    Footer: $f191d8261c883c0e$var$Footer,
    createModelClass: function(currentViewState, optionUiSchemaConfig, settings) {
        const currentSchema = JSON.parse(JSON.stringify(currentViewState.uiSchema));
        let ModelClass = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).prototype.createModelClass.apply(this, arguments, currentViewState);
        ModelClass = ModelClass.extend({
            toJSON: function() {
                const modelJSON = (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039).prototype.toJSON.call(this, arguments, currentViewState);
                // delete optional attributes if they are empty and not required
                if (modelJSON.userProfile) {
                    const uiSchema = currentViewState.uiSchema;
                    const userProfile = modelJSON.userProfile;
                    (0, $3e490973b7383cc4$export$2e2bcd8739ae039).each(userProfile, (value, name)=>{
                        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(value)) {
                            const uiSchemaProperty = uiSchema.find((schema)=>schema.name === `userProfile.${name}`);
                            if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isUndefined(uiSchemaProperty) && !uiSchemaProperty.required) delete userProfile[name];
                        }
                    });
                }
                return modelJSON;
            }
        });
        settings.parseRegistrationSchema(currentSchema, (schema)=>{
            if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEqual(schema, currentViewState.uiSchema)) {
                currentViewState.uiSchema = schema;
                ModelClass = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).prototype.createModelClass.call(this, currentViewState, optionUiSchemaConfig);
            }
        }, (error)=>{
            ModelClass = ModelClass.extend({
                local: {
                    parseSchemaError: {
                        value: error,
                        type: 'object'
                    },
                    ...ModelClass.prototype.local
                }
            });
        });
        return ModelClass;
    },
    postRender: function() {
        (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).prototype.postRender.apply(this, arguments);
        const modelError = this.model.get('parseSchemaError');
        if (modelError) this.model.trigger('error', this.model, {
            responseJSON: modelError
        });
        // Prompt for password w/ SSR if enabled (credentials object in remediation)
        this.renderPasswordPolicySettings();
        const idpButtons = (0, $34fae8eb13c47425$export$b76b6826e7ff17cc)(this.options);
        if (Array.isArray(idpButtons) && idpButtons.length) this._addIdpView(idpButtons);
    },
    renderPasswordPolicySettings: function() {
        var _credentials$form;
        // retrieve password policy from "credentials" object in remediation
        const currentViewState = this.options.currentViewState.value;
        const credentials = currentViewState.filter((obj)=>{
            return obj.name === 'credentials';
        })[0];
        // if "passcode" is present in "credentials", render password rules
        const form = credentials === null || credentials === void 0 ? void 0 : (_credentials$form = credentials.form) === null || _credentials$form === void 0 ? void 0 : _credentials$form.value;
        if (form && form.filter((obj)=>{
            return obj.name === 'passcode';
        })) {
            var _credentials$relatesT, _credentials$relatesT2;
            (0, $852629d60ac0b854$export$be0c8adfc3f95911)(this, (0, $3ddabee037f3f019$export$dece28d6748bc497)(credentials === null || credentials === void 0 ? void 0 : (_credentials$relatesT = credentials.relatesTo) === null || _credentials$relatesT === void 0 ? void 0 : (_credentials$relatesT2 = _credentials$relatesT.value) === null || _credentials$relatesT2 === void 0 ? void 0 : _credentials$relatesT2.settings), false);
        }
    },
    _addIdpView: function(idpButtons) {
        // We check the 'idpDisplay' option config to determine whether to render the idp buttons 
        // above or below the login fields
        const idpDisplay = this.options.settings.get('idpDisplay');
        const isPrimaryIdpDisplay = idpDisplay && idpDisplay.toUpperCase() === 'PRIMARY';
        this.add((0, $65737c44ec65d75e$export$2e2bcd8739ae039), {
            prepend: isPrimaryIdpDisplay,
            selector: isPrimaryIdpDisplay ? '.o-form-fieldset-container' : '.o-form-button-bar',
            options: {
                idpButtons: idpButtons,
                isPrimaryIdpDisplay: isPrimaryIdpDisplay
            }
        });
    }
});





















parcelRequire("3ZxP0");







const $e9b34411d9ca2827$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    className: 'profile-update',
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.profile.additional.title', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.choices.submit.finish', 'login');
    },
    getUISchema: function() {
        const uiSchemas = (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.getUISchema.apply(this, arguments);
        uiSchemas.forEach((input)=>{
            if (input.name === 'userProfile.secondEmail') input.explain = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                    "compiler": [
                        8,
                        ">= 4.3.0"
                    ],
                    "main": function(container, depth0, helpers, partials, data) {
                        var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                            return undefined;
                        };
                        return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                            "name": "i18n",
                            "hash": {
                                "$1": "<span class='strong'>$1</span>",
                                "bundle": "login",
                                "code": "oie.profile.additional.secondemail.subtitle"
                            },
                            "data": data,
                            "loc": {
                                "start": {
                                    "line": 1,
                                    "column": 0
                                },
                                "end": {
                                    "line": 1,
                                    "column": 112
                                }
                            }
                        })) != null ? stack1 : "";
                    },
                    "useData": true
                })
            });
        });
        return uiSchemas;
    },
    initialize: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
    }
});
const $e9b34411d9ca2827$var$Footer = (0, $31737d9aae112815$export$2e2bcd8739ae039).extend({
    className: 'auth-footer side-by-side-links',
    links: function() {
        const { uiSchema: uiSchema } = this.options.currentViewState;
        const optionalParams = uiSchema.filter((item)=>item.required === false);
        if (uiSchema.length === optionalParams.length) return (0, $aaa5b7e3293b6284$export$77db2f739f8229cd)(this.options.appState, (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.skip.profile', 'login'));
        else this.$el.removeClass('.side-by-side-links');
    }
});
var $e9b34411d9ca2827$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    Body: $e9b34411d9ca2827$var$Body,
    Footer: $e9b34411d9ca2827$var$Footer,
    postRender: function() {
        (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).prototype.postRender.apply(this, arguments);
        /**
     * As per requirement of this flow set secondEmail default to empty string, if exists in remediation
     * ideally server should have passed default string in remediation
     */ if (this.options.appState.getSchemaByName('userProfile.secondEmail')) this.model.set('userProfile.secondEmail', '');
    }
});





















parcelRequire("3ZxP0");






const $5f7d9f4a095c7c9d$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.activation.request.email.title.expire', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.activation.request.email.button', 'login');
    }
});
var $5f7d9f4a095c7c9d$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    Body: $5f7d9f4a095c7c9d$var$Body
});





















parcelRequire("3ZxP0");






const $0f6a1081fbb98031$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.select.authenticators.enroll.title', 'login');
    },
    subtitle: function() {
        const subtitle = this.options.settings.get('brandName') ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.select.authenticators.enroll.subtitle.custom', 'login', [
            this.options.settings.get('brandName')
        ]) : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.select.authenticators.enroll.subtitle', 'login');
        return subtitle;
    },
    noButtonBar: true
});
var $0f6a1081fbb98031$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    Body: $0f6a1081fbb98031$var$Body
});





















parcelRequire("3ZxP0");







const $499b38ed5a68ebff$var$UNLOCK_USER_SUCCESS_MESSAGE = 'oie.selfservice.unlock_user.landing.to.app.success.message';
const $499b38ed5a68ebff$export$4b2c32e08f77ff18 = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    title: function() {
        if (this.isPasswordRecoveryFlow()) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.reset.title.generic', 'login');
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.select.authenticators.verify.title', 'login');
    },
    subtitle: function() {
        if (this.isPasswordRecoveryFlow()) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.password.reset.verification', 'login');
        if (this.isUnlockSuccess()) {
            const container = '.o-form-error-container';
            const text = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.select.authenticators.verify.subtitle', 'login');
            this.add(`<div class="ion-messages-container"><p>${text}</p></div>`, container);
            return;
        }
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.select.authenticators.verify.subtitle', 'login');
    },
    isPasswordRecoveryFlow: function() {
        return this.options.appState.get('isPasswordRecovery');
    },
    noButtonBar: true,
    showMessages: function() {
        if (this.isUnlockSuccess()) {
            let options = {};
            options.subtitle = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.selfservice.unlock_user.landing.to.app.success.message', 'login');
            options.type = 'success';
            options = (0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)(options);
            (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.showMessages.call(this, options);
            return;
        }
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.showMessages.call(this);
    },
    isUnlockSuccess: function() {
        return this.options.appState.containsMessageWithI18nKey($499b38ed5a68ebff$var$UNLOCK_USER_SUCCESS_MESSAGE);
    }
});
var $499b38ed5a68ebff$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    Body: $499b38ed5a68ebff$export$4b2c32e08f77ff18,
    Footer: (0, $31737d9aae112815$export$2e2bcd8739ae039).extend({
        links: function() {
            return (0, $aaa5b7e3293b6284$export$574d56f9df8b837)(this.options.appState, this.options.settings);
        }
    })
});





















parcelRequire("3ZxP0");






const $a68279c76c3cdcb1$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    noButtonBar: true,
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.select.authenticators.verify.title', 'login');
    },
    subtitle: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.select.authenticators.verify.subtitle', 'login');
    }
});
var $a68279c76c3cdcb1$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    Body: $a68279c76c3cdcb1$var$Body
});



























const $ae39d63fe9cc3295$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.password.enroll.title', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oform.next', 'login');
    },
    initialize: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        const policy = this.getPasswordPolicySettings();
        this.displayPasswordPolicy(policy);
    },
    displayPasswordPolicy: function(policy) {
        if (policy) {
            const rulesList = (0, $3ddabee037f3f019$export$dece28d6748bc497)(policy);
            (0, $852629d60ac0b854$export$be0c8adfc3f95911)(this, rulesList, true);
        }
    },
    triggerAfterError: function(model, error) {
        error.responseJSON = (0, $3ddabee037f3f019$export$311594212e8d66ce)(error.responseJSON);
        this.options.appState.trigger('afterError', error);
    },
    getPasswordPolicySettings: function() {
        var _relatesToObject$valu;
        // This will be overridden by following scenario since the policies could be different for those.
        // - password reset (`ReEnrollAuthenticatorPasswordView.js`)
        //
        const relatesToObject = this.options.currentViewState.relatesTo;
        return relatesToObject === null || relatesToObject === void 0 ? void 0 : (_relatesToObject$valu = relatesToObject.value) === null || _relatesToObject$valu === void 0 ? void 0 : _relatesToObject$valu.settings;
    },
    getUISchema: function() {
        const uiSchemas = (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.getUISchema.apply(this, arguments);
        const confirmPassword = {
            name: 'confirmPassword',
            label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.password.confirmPasswordLabel', 'login'),
            type: 'password',
            'label-top': true,
            params: {
                showPasswordToggle: this.settings.get('showPasswordToggle')
            }
        };
        const updatedSchema = [];
        for (let field of uiSchemas){
            updatedSchema.push(field);
            if (field.name === 'credentials.passcode') updatedSchema.push(confirmPassword);
        }
        return updatedSchema;
    }
});
var $ae39d63fe9cc3295$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $ae39d63fe9cc3295$var$Body,
    createModelClass: function() {
        const ModelClass = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).prototype.createModelClass.apply(this, arguments);
        const local = Object.assign({
            confirmPassword: {
                type: 'string',
                required: true
            }
        }, ModelClass.prototype.local);
        return ModelClass.extend({
            local: local,
            validate: function() {
                if (this.get('credentials.passcode') !== this.get('confirmPassword') && this.get('credential.value') !== this.get('confirmPassword')) {
                    const errors = {
                        'confirmPassword': (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.error.match', 'login')
                    };
                    return errors;
                } else return null;
            }
        });
    }
});





















parcelRequire("3ZxP0");










const $a35806776871a49a$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.password.challenge.title', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.verify', 'login');
    },
    /**
   * Update UI schemas for customization from .widgetrc.js or Admin Customization settings page.
   * @returns Array
   */ getUISchema: function() {
        const schemas = (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.getUISchema.apply(this, arguments);
        const { settings: settings } = this.options;
        const passwordExplainLabeli18nKey = 'primaryauth.password.tooltip';
        const passwordSchema = schemas.find(({ name: name })=>name === 'credentials.passcode');
        if (passwordSchema && (0, $93a83f6fd41fc21e$export$89d4852ea9ed9572)(passwordExplainLabeli18nKey, settings)) {
            passwordSchema.explain = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)(passwordExplainLabeli18nKey, 'login');
            passwordSchema['explain-top'] = true;
        }
        return schemas;
    }
});
const $a35806776871a49a$var$Footer = (0, $8a0b19b4456b71c9$export$2e2bcd8739ae039).extend({
    links: function() {
        let links = (0, $8a0b19b4456b71c9$export$2e2bcd8739ae039).prototype.links.apply(this, arguments);
        links = (0, $aaa5b7e3293b6284$export$219f3ecb053dc685)(this.options.appState, this.options.settings).concat(links);
        return links;
    }
});
var $a35806776871a49a$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $a35806776871a49a$var$Body,
    Footer: $a35806776871a49a$var$Footer
});













const $537c8d8ac53ea3db$var$Body = (0, $ae39d63fe9cc3295$export$2e2bcd8739ae039).prototype.Body.extend({
    className: 'password-authenticator',
    title: function() {
        const title = this.options.settings.get('brandName') ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expired.title.specific', 'login', [
            this.options.settings.get('brandName')
        ]) : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expired.title.generic', 'login');
        return title;
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expired.submit', 'login');
    },
    getPasswordPolicySettings: function() {
        var _this$options$appStat, _this$options$appStat2;
        return ((_this$options$appStat = this.options.appState.get('recoveryAuthenticator')) === null || _this$options$appStat === void 0 ? void 0 : _this$options$appStat.settings) || ((_this$options$appStat2 = this.options.appState.get('enrollmentAuthenticator')) === null || _this$options$appStat2 === void 0 ? void 0 : _this$options$appStat2.settings);
    }
});
var $537c8d8ac53ea3db$export$2e2bcd8739ae039 = (0, $ae39d63fe9cc3295$export$2e2bcd8739ae039).extend({
    Body: $537c8d8ac53ea3db$var$Body
});





















parcelRequire("3ZxP0");







const $950f7264bd90a5db$var$Body = (0, $ae39d63fe9cc3295$export$2e2bcd8739ae039).prototype.Body.extend({
    className: 'password-authenticator',
    subtitle: function() {
        if (this.options.settings.get('brandName')) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expiring.subtitle.specific', 'login', [
            this.options.settings.get('brandName')
        ]);
    },
    title: function() {
        const passwordPolicy = this.getPasswordPolicySettings() || {};
        const daysToExpiry = passwordPolicy.daysToExpiry;
        if (daysToExpiry > 0) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expiring.title', 'login', [
            daysToExpiry
        ]);
        else if (daysToExpiry === 0) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expiring.today', 'login');
        else return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expiring.soon', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expired.submit', 'login');
    },
    showMessages: function() {
        // if brandName is configured and messages is present, render as subtitle with brandName in context
        if (this.options.settings.get('brandName')) return null;
        // else if brandName is not set, render messages object sent from server as text
        (0, $ae39d63fe9cc3295$export$2e2bcd8739ae039).prototype.Body.prototype.showMessages.apply(this, arguments);
    }
});
const $950f7264bd90a5db$var$Footer = (0, $31737d9aae112815$export$2e2bcd8739ae039).extend({
    links: function() {
        const links = [];
        if (this.options.appState.hasRemediationObject('skip')) links.push({
            'type': 'link',
            'label': (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expiring.later', 'login'),
            'name': 'skip',
            'actionPath': 'skip'
        });
        return links;
    }
});
var $950f7264bd90a5db$export$2e2bcd8739ae039 = (0, $ae39d63fe9cc3295$export$2e2bcd8739ae039).extend({
    Body: $950f7264bd90a5db$var$Body,
    Footer: $950f7264bd90a5db$var$Footer
});













const $b89b1c400b2f2a3d$var$Body = (0, $ae39d63fe9cc3295$export$2e2bcd8739ae039).prototype.Body.extend({
    className: 'password-authenticator',
    title: function() {
        const title = this.options.settings.get('brandName') ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.reset.title.specific', 'login', [
            this.options.settings.get('brandName')
        ]) : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.reset.title.generic', 'login');
        return title;
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.reset', 'login');
    }
});
var $b89b1c400b2f2a3d$export$2e2bcd8739ae039 = (0, $ae39d63fe9cc3295$export$2e2bcd8739ae039).extend({
    Body: $b89b1c400b2f2a3d$var$Body
});































parcelRequire("3ZxP0");



















var $cc2732793cf3de83$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    postRender: function() {
        this.showCalloutAfterTimeout();
    },
    showCalloutAfterTimeout: function() {
        const timeStamp = (0, $64cf5b2d2fb5baf3$export$2e2bcd8739ae039).getResendTimestamp();
        if (!timeStamp) (0, $64cf5b2d2fb5baf3$export$2e2bcd8739ae039).setResendTimestamp(Date.now());
        // We keep track of a 'global' timestamp in sessionStorage because if the SIW does a re-render,
        // we don't want to force the user to wait another 30s again to see the resend link. With this
        // the user will wait AT MOST 30s until they see the resend link.
        this.showMeInterval = setInterval(()=>{
            const start = (0, $64cf5b2d2fb5baf3$export$2e2bcd8739ae039).getResendTimestamp();
            const now = Date.now();
            if (now - start >= (0, $5dcf8c5d7fe7c644$export$7477e4e7a587c9ab)) {
                this.$el.removeClass('hide');
                clearInterval(this.showMeInterval);
                (0, $64cf5b2d2fb5baf3$export$2e2bcd8739ae039).removeResendTimestamp();
            }
        }, 250);
    },
    remove: function() {
        var _this$options$appStat, _this$options$appStat2;
        (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).prototype.remove.apply(this, arguments);
        clearInterval(this.showMeInterval);
        const formName = this.options.appState.get('currentFormName');
        const resendContext = ((_this$options$appStat = this.options.appState.get('currentAuthenticator')) === null || _this$options$appStat === void 0 ? void 0 : _this$options$appStat.resend) || ((_this$options$appStat2 = this.options.appState.get('currentAuthenticatorEnrollment')) === null || _this$options$appStat2 === void 0 ? void 0 : _this$options$appStat2.resend);
        const didFormNameChange = this.options.model.get('formName') !== formName;
        // Clear resend timeStamp whenever we change views (this means we're navigating away from the resend view)
        if ((0, $64cf5b2d2fb5baf3$export$2e2bcd8739ae039).getResendTimestamp() && (!resendContext || didFormNameChange)) (0, $64cf5b2d2fb5baf3$export$2e2bcd8739ae039).removeResendTimestamp();
    }
});


const $b18c21dbbff4405e$export$6aaea069a3d97a2b = (0, $cc2732793cf3de83$export$2e2bcd8739ae039).extend({
    // To be shown after a timeout
    className: 'phone-authenticator-challenge__resend-warning hide',
    events: {
        'click a.resend-link': 'handleResendLink'
    },
    modelEvents: {
        'error': 'handleError'
    },
    // Override this to change the resend action location from response
    resendActionKey: 'currentAuthenticatorEnrollment-resend',
    initialize: function() {
        const resendText = this.model.get('mode') === 'sms' ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.verify.sms.resendText', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.verify.call.resendText', 'login');
        const linkText = this.model.get('mode') === 'sms' ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.verify.sms.resendLinkText', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.verify.call.resendLinkText', 'login');
        this.add((0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)({
            content: `${resendText}&nbsp;<a class='resend-link'>${linkText}</a>`,
            type: 'warning'
        }));
    },
    hideResendViewAndShowAfterTimeout: function() {
        // Hide warning, but start a timeout again..
        if (!this.el.classList.contains('hide')) this.el.classList.add('hide');
        this.showCalloutAfterTimeout();
    },
    handleResendLink: function(ev) {
        ev === null || ev === void 0 || ev.preventDefault();
        this.options.appState.trigger('invokeAction', this.resendActionKey);
        this.hideResendViewAndShowAfterTimeout();
    },
    handleError: function() {
        this.hideResendViewAndShowAfterTimeout();
    }
});
const $b18c21dbbff4405e$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend(Object.assign({
    className: 'phone-authenticator-challenge',
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.verify.title', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.verify', 'login');
    },
    initialize: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        const sendText = this.model.get('mode') === 'sms' ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.verify.sms.codeSentText', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.calling', 'login');
        const enterCodeText = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.verify.enterCodeText', 'login');
        const carrierChargesText = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.carrier.charges', 'login');
        const isPhoneNumberAvailable = this.model.get('phoneNumber') !== (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.alternate.title', 'login');
        const strongClass = isPhoneNumberAvailable ? 'strong no-translate nowrap' : '';
        const nickname = isPhoneNumberAvailable ? this.model.get('nickname') : '';
        const nicknameText = nickname ? ` (${nickname})` : '';
        const extraNicknameCssClasses = nicknameText ? 'no-translate authenticator-verify-nickname' : '';
        const nicknameTemplate = nicknameText ? `<span class="${extraNicknameCssClasses || ''}"}>${nicknameText}.</span>` : '<span class="no-translate">.</span>';
        // Courage doesn't support HTML, hence creating a subtitle here.
        this.add('<div class="okta-form-subtitle" data-se="o-form-explain">' + `${sendText} ` + `<span class="${strongClass}">${this.model.escape('phoneNumber')}</span>` + `${nicknameTemplate}` + `&nbsp;${enterCodeText}` + `<p>${carrierChargesText}</p>` + '</div>', {
            prepend: true,
            selector: '.o-form-fieldset-container'
        });
    },
    postRender: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.postRender.apply(this, arguments);
        this.add($b18c21dbbff4405e$export$6aaea069a3d97a2b, {
            selector: '.o-form-info-container',
            prepend: true
        });
    }
}));
var $b18c21dbbff4405e$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $b18c21dbbff4405e$var$Body,
    createModelClass: function() {
        const relatesToObject = this.options.currentViewState.relatesTo;
        const { methods: methods, profile: profile, nickname: nickname } = (relatesToObject === null || relatesToObject === void 0 ? void 0 : relatesToObject.value) || {};
        const ModelClass = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).prototype.createModelClass.apply(this, arguments);
        const local = Object.assign({
            mode: {
                'value': methods[0].type,
                'type': 'string'
            },
            phoneNumber: {
                'value': profile !== null && profile !== void 0 && profile.phoneNumber ? profile.phoneNumber : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.alternate.title', 'login'),
                'type': 'string'
            },
            nickname: {
                'value': nickname ? nickname : '',
                'type': 'string'
            }
        }, ModelClass.prototype.local);
        return ModelClass.extend({
            local: local
        });
    }
});











parcelRequire("3ZxP0");






const $c989c65117b4f26a$var$EnrollResendView = (0, $b18c21dbbff4405e$export$6aaea069a3d97a2b).extend({
    // To be shown after a timeout
    className: 'phone-authenticator-enroll--warning hide',
    resendActionKey: 'currentAuthenticator-resend'
});
const $c989c65117b4f26a$var$Body = (0, $b18c21dbbff4405e$export$2e2bcd8739ae039).prototype.Body.extend({
    className: 'phone-authenticator-enroll',
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.enroll.title', 'login');
    },
    postRender: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.postRender.apply(this, arguments);
        this.add($c989c65117b4f26a$var$EnrollResendView, {
            selector: '.o-form-info-container',
            prepend: true
        });
    }
});
var $c989c65117b4f26a$export$2e2bcd8739ae039 = (0, $b18c21dbbff4405e$export$2e2bcd8739ae039).extend({
    Body: $c989c65117b4f26a$var$Body
});





















parcelRequire("3ZxP0");








const $ef2f1d99c7654289$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    className: 'phone-authenticator-enroll',
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.enroll.title', 'login');
    },
    subtitle: function() {
        return this.model.get('authenticator.methodType') === 'voice' ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.enroll.call.subtitle', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.enroll.sms.subtitle', 'login');
    },
    render: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.render.apply(this, arguments);
        this.el.querySelector('.phone-authenticator-enroll__phone-code').innerText = `+${this.model.get('phoneCode')}`;
    },
    handlePhoneCodeChange: function() {
        const countryCodeField = this.el.querySelector('.phone-authenticator-enroll__phone-code');
        countryCodeField.innerText = `+${this.model.get('phoneCode')}`;
    },
    save: function() {
        return this.model.get('authenticator.methodType') === 'voice' ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.call.primaryButton', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.sms.primaryButton', 'login');
    },
    getUISchema: function() {
        const uiSchemas = (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.getUISchema.apply(this, arguments);
        // TODO: Using underscore to support IE, replace with Array.prototype methods (find, findIndex) when IE
        // support is removed
        const phoneNumberUISchemaIndex = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findIndex(uiSchemas, ({ name: name })=>name === 'authenticator.phoneNumber');
        const countryUISchema = {
            'label-top': true,
            label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.country', 'login'),
            type: 'select',
            options: (0, $bfbf136e55dbe393$export$2e2bcd8739ae039).getCountries(),
            name: 'country',
            wide: true
        };
        const inputId = 'okta-phone-number-input';
        // Create an input group - serves as a display wrapper
        const phoneNumberWithCodeUISchema = {
            label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.phoneNumber.placeholder', 'login'),
            inputId: inputId,
            type: 'group',
            modelType: 'string',
            'label-top': true,
            name: 'phoneCode',
            className: 'phone-authenticator-enroll__phone',
            input: [
                {
                    type: 'label',
                    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */ label: `+${this.model.get('phoneCode')}`,
                    className: 'phone-authenticator-enroll__phone-code no-translate'
                },
                Object.assign({
                    inputId: inputId
                }, uiSchemas[phoneNumberUISchemaIndex])
            ]
        };
        const extensionUISchema = {
            label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('phone.extention.label', 'login'),
            type: 'text',
            className: 'phone-authenticator-enroll__phone-ext',
            'label-top': true,
            name: 'extension',
            showWhen: {
                'authenticator.methodType': 'voice'
            }
        };
        if (phoneNumberUISchemaIndex !== -1) {
            // Replace phoneNumberUISchema..
            uiSchemas.splice(phoneNumberUISchemaIndex, 1, phoneNumberWithCodeUISchema);
            // Add countryUISchema before & extensionUISchema after phone..
            uiSchemas.splice(phoneNumberUISchemaIndex, 0, countryUISchema);
            uiSchemas.splice(phoneNumberUISchemaIndex + 2, 0, extensionUISchema);
        }
        const methodType = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).find(uiSchemas, ({ name: name })=>name === 'authenticator.methodType');
        if (methodType && methodType.options.length === 1) methodType.className = 'hide';
        return uiSchemas;
    },
    updateConditionalText: function() {
        this.el.querySelector('.okta-form-subtitle').innerText = this.subtitle();
        this.el.querySelector('input[type="submit"]').value = this.save();
    },
    initialize: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        this.listenTo(this.model, 'change:authenticator.methodType', this.updateConditionalText);
        this.listenTo(this.model, 'change:phoneCode', this.handlePhoneCodeChange.bind(this));
    }
});
var $ef2f1d99c7654289$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $ef2f1d99c7654289$var$Body,
    createModelClass: function() {
        const ModelClass = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).prototype.createModelClass.apply(this, arguments);
        const local = Object.assign({
            country: {
                'value': this.settings.get('defaultCountryCode'),
                'type': 'string'
            },
            extension: {
                'type': 'string'
            }
        }, ModelClass.prototype.local);
        const derived = Object.assign({
            phoneCode: {
                deps: [
                    'country'
                ],
                fn: function(country) {
                    return (0, $bfbf136e55dbe393$export$2e2bcd8739ae039).getCallingCodeForCountry(country);
                }
            }
        }, ModelClass.prototype.derived);
        return ModelClass.extend({
            local: local,
            derived: derived,
            toJSON: function() {
                const modelJSON = (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039).prototype.toJSON.call(this, arguments);
                const extension = this.get('extension');
                const phoneCode = this.get('phoneCode');
                // Add country code..
                let formattedPhoneNumber = `+${phoneCode}${modelJSON.authenticator.phoneNumber}`;
                // Add extension if present..
                if (modelJSON.authenticator.methodType === 'voice' && extension !== null && extension !== void 0 && extension.trim().length) formattedPhoneNumber = `${formattedPhoneNumber}x${extension}`;
                // Override phone with formatted number..
                modelJSON.authenticator.phoneNumber = formattedPhoneNumber;
                return modelJSON;
            }
        });
    }
});






















parcelRequire("3ZxP0");







const $74dac234e7175180$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    className: 'phone-authenticator-challenge',
    events: {
        'click a.phone-authenticator-challenge__link': 'handleSecondaryLinkClick'
    },
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.verify.title', 'login');
    },
    save: function() {
        return this.model.get('primaryMode') === 'sms' ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.sms.primaryButton', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.call.primaryButton', 'login');
    },
    handleSecondaryLinkClick: function(e) {
        e.preventDefault();
        // Call the API to send a code via secondary mode
        const secondaryMode = this.model.get('secondaryMode');
        this.model.set('authenticator.methodType', secondaryMode);
        this.saveForm(this.model);
    },
    initialize: function() {
        // This is needed when user clicks on secondary (say voice) and call fails with ratelimit server-side error.
        // Then the user clicks primary button (say sms) and right methodType needs to be sent.
        this.model.on('error', ()=>this.model.set('authenticator.methodType', this.model.get('primaryMode')));
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        const sendText = this.model.get('primaryMode') === 'sms' ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.verify.sms.sendText', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.verify.call.sendText', 'login');
        const carrierChargesText = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.carrier.charges', 'login');
        const isPhoneNumberAvailable = this.model.get('phoneNumber') !== (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.alternate.title', 'login');
        const extraCssClasses = isPhoneNumberAvailable ? 'strong no-translate nowrap' : '';
        const nickname = isPhoneNumberAvailable ? this.model.get('nickname') : '';
        const nicknameText = nickname ? ` (${nickname})` : '';
        const extraNicknameCssClasses = nicknameText ? 'no-translate authenticator-verify-nickname' : '';
        const nicknameTemplate = nicknameText ? `<span class="${extraNicknameCssClasses || ''}">${nicknameText}.</span>` : '<span class="no-translate">.</span>';
        // Courage doesn't support HTML, hence creating a subtitle here.
        const content = `${sendText} ` + `<span ${extraCssClasses ? ` class="${extraCssClasses}"` : ''}>${this.model.escape('phoneNumber')}</span>` + `${nicknameTemplate}`;
        this.add('<div class="okta-form-subtitle" data-se="o-form-explain">' + `${content}` + `<p>${carrierChargesText}</p>` + '</div>');
    },
    getUISchema: function() {
        // Change the UI schema to not display radios here.
        const uiSchemas = (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.getUISchema.apply(this, arguments);
        return uiSchemas.filter((schema)=>schema.name !== 'authenticator.methodType');
    },
    render: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.render.apply(this, arguments);
        const secondaryMode = this.model.get('secondaryMode');
        if (secondaryMode) {
            const secondaryButtonTitle = secondaryMode === 'sms' ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.sms.secondaryButton', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.call.secondaryButton', 'login');
            this.add(`<a href="#"
            class="link phone-authenticator-challenge__link"
            data-se="phone-authenticator-challenge__link">${secondaryButtonTitle}</a>`, '.o-form-button-bar');
        }
    }
});
var $74dac234e7175180$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $74dac234e7175180$var$Body,
    createModelClass: function({ uiSchema: uiSchema }) {
        // It is important to get methods from here to maintain single source of truth.
        const { options: methods } = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).find(uiSchema, (schema)=>schema.name === 'authenticator.methodType');
        const relatesToObject = this.options.currentViewState.relatesTo;
        const { profile: profile, nickname: nickname } = (relatesToObject === null || relatesToObject === void 0 ? void 0 : relatesToObject.value) || {};
        const ModelClass = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).prototype.createModelClass.apply(this, arguments);
        const local = Object.assign({
            primaryMode: {
                'value': methods[0].value,
                'type': 'string'
            },
            secondaryMode: {
                'value': methods[1] && methods[1].value,
                'type': 'string'
            },
            phoneNumber: {
                'value': profile !== null && profile !== void 0 && profile.phoneNumber ? profile.phoneNumber : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.phone.alternate.title', 'login'),
                'type': 'string'
            },
            nickname: {
                'value': nickname ? nickname : '',
                'type': 'string'
            }
        }, ModelClass.prototype.local);
        return ModelClass.extend({
            local: local
        });
    }
});





















parcelRequire("3ZxP0");







const $fbc7665bf3288f91$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.security.question.enroll.title', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.verify', 'login');
    }
});
var $fbc7665bf3288f91$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $fbc7665bf3288f91$var$Body
});





















parcelRequire("3ZxP0");







const $552eeec7325cc1eb$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.security.question.challenge.title', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.verify', 'login');
    },
    getUISchema: function() {
        const uiSchemas = (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.getUISchema.apply(this, arguments);
        const questionKey = uiSchemas.filter((s)=>s.name.indexOf('questionKey') >= 0);
        const answer = uiSchemas.filter((s)=>s.name.indexOf('answer') >= 0);
        /**
     * At verify SQ case,
     * 'questionKey' is read-only hence it won't show up in UI anyway.
     * 'answer' has label 'answer' but apparently UI want to display the
     * actual question (label of `questionKey`) as better user experience.
     */ if (questionKey.length === 1 && answer.length === 1) answer[0].label = questionKey[0].label;
        return uiSchemas;
    }
});
var $552eeec7325cc1eb$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $552eeec7325cc1eb$var$Body
});



















































var $600936bcebe65871$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'oie-webauthn-additional-instructions',
    initialize: function() {
        const { description: description } = this.options;
        if (description) {
            this.add((0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                className: 'additional-instructions-title',
                template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                    "compiler": [
                        8,
                        ">= 4.3.0"
                    ],
                    "main": function(container, depth0, helpers, partials, data) {
                        var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                            return undefined;
                        };
                        return "<p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                            "name": "i18n",
                            "hash": {
                                "bundle": "login",
                                "code": "oie.verify.webauthn.instructions.additional"
                            },
                            "data": data,
                            "loc": {
                                "start": {
                                    "line": 1,
                                    "column": 3
                                },
                                "end": {
                                    "line": 1,
                                    "column": 77
                                }
                            }
                        })) + "</p>";
                    },
                    "useData": true
                })
            }));
            this.add((0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)({
                subtitle: description,
                className: 'additional-instructions-callout'
            }));
        }
    }
});



var $e27c890aa4bd1a6b$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "enrollI18nKey") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.program(2, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 28
                    },
                    "end": {
                        "line": 1,
                        "column": 249
                    }
                }
            })) != null ? stack1 : "";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p class=\"idx-webauthn-enroll-text\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": depth0 != null ? lookupProperty(depth0, "enrollI18nKey") : depth0
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 85
                    },
                    "end": {
                        "line": 1,
                        "column": 127
                    }
                }
            })) + "</p>";
        },
        "2": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p class=\"idx-webauthn-enroll-text\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.webauthn.instructions"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 175
                    },
                    "end": {
                        "line": 1,
                        "column": 238
                    }
                }
            })) + "</p>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return (stack1 = lookupProperty(helpers, "unless").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "hideInstructions") : depth0, {
                "name": "unless",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 260
                    }
                }
            })) != null ? stack1 : "";
        },
        "useData": true
    }),
    initialize: function() {
        const relatesToObject = this.options.currentViewState.relatesTo;
        const activationData = relatesToObject === null || relatesToObject === void 0 ? void 0 : relatesToObject.value.contextualData.activationData;
        if ((0, $22893d6dea78fc87$export$2e2bcd8739ae039).isEdge()) this.add((0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
            tagName: 'p',
            className: 'idx-webauthn-enroll-text-edge',
            template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                "compiler": [
                    8,
                    ">= 4.3.0"
                ],
                "main": function(container, depth0, helpers, partials, data) {
                    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                        return undefined;
                    };
                    return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                        "name": "i18n",
                        "hash": {
                            "bundle": "login",
                            "code": "oie.enroll.webauthn.instructions.edge"
                        },
                        "data": data,
                        "loc": {
                            "start": {
                                "line": 1,
                                "column": 0
                            },
                            "end": {
                                "line": 1,
                                "column": 68
                            }
                        }
                    }));
                },
                "useData": true
            })
        }));
        if (activationData.authenticatorSelection.userVerification === 'required') this.add((0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)({
            className: 'uv-required-callout',
            size: 'slim',
            type: 'warning',
            subtitle: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.webauthn.uv.required.instructions', 'login')
        }));
        const description = (0, $3ddabee037f3f019$export$d64be9dcd88e405b)(this.options.currentViewState);
        if (description) this.add((0, $600936bcebe65871$export$2e2bcd8739ae039), {
            options: {
                description: description
            }
        });
        this.add('<div data-se="webauthn-waiting" class="okta-waiting-spinner"></div>');
    },
    getTemplateData: function() {
        var _this$options$current, _this$options$current2;
        return {
            hideInstructions: this.options.hideInstructions,
            enrollI18nKey: (0, $bdb5e1755e68f0a9$export$9748196cbdf7dd9e)({
                DEFAULT: 'oie.enroll.webauthn.instructions',
                PASSKEYS: 'oie.enroll.webauthn.passkeysRebrand.instructions',
                CUSTOM: 'oie.enroll.webauthn.passkeysRebrand.instructions'
            }, (_this$options$current = this.options.currentViewState.relatesTo) === null || _this$options$current === void 0 ? void 0 : (_this$options$current2 = _this$options$current.value) === null || _this$options$current2 === void 0 ? void 0 : _this$options$current2.displayName)
        };
    }
});





/*
 * Copyright (c) 2026-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ /* eslint-disable max-len */ /*
 * Inline SVG for the passkey-promotion splash illustration. Inlined (rather than
 * referenced as a background-image or external asset) so `fill="currentColor"`
 * inherits the widget's brand color when set via `colors.brand` config.
 */ const $7ad45758fbbf73a4$export$8a7d9f50402940a6 = `
<svg viewBox="0 0 350 126" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
<path fill-rule="evenodd" clip-rule="evenodd" d="M339.947 0C345.49 0.000247202 349.983 4.49364 349.983 10.0361V115.412C349.983 120.955 345.49 125.448 339.947 125.448H112.229C106.686 125.448 102.193 120.955 102.193 115.412V78.7012L88.1476 63.5771C87.7009 63.0958 87.7007 62.3513 88.1476 61.8701L102.193 46.7461V10.0361C102.193 4.49359 106.686 0.000166902 112.229 0H339.947Z" fill="currentColor" fill-opacity="0.1"/>
<path d="M241.408 26.6595C238.093 22.1662 232.576 19.4836 226.648 19.4836C223.074 19.4836 219.633 20.4227 216.691 22.199L215.354 19.9839C218.698 17.9642 222.602 16.8962 226.648 16.8962C233.393 16.8962 239.69 19.9721 243.49 25.1233L241.408 26.6595ZM232.305 55.0228L230.132 53.6163C228.036 56.8513 225.276 59.6627 221.925 61.9722L223.394 64.103C227.026 61.599 230.022 58.5442 232.305 55.0228ZM237.431 37.1884C237.431 31.243 232.593 26.406 226.647 26.406C220.69 26.406 215.844 31.243 215.844 37.1884H218.432C218.432 32.6697 222.117 28.9933 226.647 28.9933C231.166 28.9933 234.843 32.6697 234.843 37.1884C234.843 41.6068 233.976 45.8045 232.268 49.6645L234.633 50.7122C236.489 46.5204 237.431 41.9698 237.431 37.1884ZM217.864 41.3836L215.371 40.6929C213.769 46.4682 208.406 50.1665 205.352 51.8568L206.605 54.1208C210.014 52.2342 216.009 48.0701 217.864 41.3836Z" fill="currentColor"/>
<path d="M243.679 57.1184L241.216 56.3233C243.835 48.2066 244.332 42.6849 244.332 35.3346C244.332 33.6872 244.044 32.0583 243.475 30.4934L245.907 29.6091C246.579 31.4586 246.92 33.3848 246.92 35.3346C246.92 42.9485 246.403 48.6749 243.679 57.1184ZM202.756 45.4904C205.232 44.088 208.973 41.969 208.943 35.3287C208.924 31.3769 210.533 27.5995 213.478 24.6921L211.658 22.851C208.217 26.2519 206.334 30.688 206.356 35.3405C206.379 40.4647 203.777 41.9387 201.481 43.2391C201.164 43.4176 200.861 43.5903 200.576 43.763L201.924 45.973C202.185 45.813 202.464 45.6555 202.756 45.4904ZM227.941 37.1884H225.353C225.353 44.6793 220.874 52.4709 213.943 57.04L215.368 59.1995C223.005 54.1655 227.941 45.5257 227.941 37.1884Z" fill="currentColor"/>
<path d="M234.711 89.9435C236.373 89.9436 237.721 91.2911 237.721 92.9532C237.721 94.6153 236.373 95.9629 234.711 95.963C233.049 95.963 231.701 94.6154 231.701 92.9532C231.701 91.2911 233.049 89.9435 234.711 89.9435ZM243.739 89.9435C245.401 89.9435 246.749 91.2911 246.749 92.9532C246.749 94.6154 245.401 95.963 243.739 95.963C242.077 95.9628 240.731 94.6152 240.73 92.9532C240.73 91.2912 242.077 89.9437 243.739 89.9435ZM252.769 89.9435C254.431 89.9435 255.778 91.2911 255.778 92.9532C255.778 94.6154 254.431 95.963 252.769 95.963C251.106 95.963 249.759 94.6153 249.759 92.9532C249.759 91.2911 251.106 89.9435 252.769 89.9435ZM261.798 89.9435C263.46 89.9437 264.808 91.2912 264.808 92.9532C264.808 94.6152 263.46 95.9628 261.798 95.963C260.136 95.963 258.788 94.6154 258.788 92.9532C258.788 91.2911 260.136 89.9435 261.798 89.9435Z" fill="currentColor"/>
<path d="M272.707 86.9339C272.707 85.895 271.865 85.0529 270.826 85.0529H228.691C227.652 85.0529 226.81 85.895 226.81 86.9339V98.9724C226.81 100.011 227.652 100.853 228.691 100.853H270.826C271.865 100.853 272.707 100.011 272.707 98.9724V86.9339ZM274.964 98.9724C274.964 101.258 273.111 103.111 270.826 103.111H228.691C226.405 103.111 224.553 101.258 224.553 98.9724V86.9339C224.553 84.6484 226.405 82.7957 228.691 82.7957H270.826C273.111 82.7957 274.964 84.6484 274.964 86.9339V98.9724Z" fill="currentColor"/>
<path d="M133.419 80.1691C133.419 81.5274 134.52 82.6288 135.878 82.629H143.749V85.5812H135.878C132.889 85.581 130.467 83.1576 130.467 80.1691V72.298H133.419V80.1691ZM180.646 80.1691C180.646 83.1577 178.223 85.5812 175.234 85.5812H167.363V82.629H175.234C176.593 82.629 177.694 81.5276 177.694 80.1691V72.298H180.646V80.1691ZM175.234 35.4015C178.223 35.4015 180.646 37.8241 180.646 40.8126V48.6837H177.694V40.8126C177.694 39.4543 176.593 38.3536 175.234 38.3536H167.363V35.4015H175.234ZM143.749 38.3536H135.878C134.52 38.3538 133.419 39.4544 133.419 40.8126V48.6837H130.467V40.8126C130.467 37.8242 132.89 35.4017 135.878 35.4015H143.749V38.3536Z" fill="currentColor"/>
<path d="M155.911 58.7988C151.503 58.7988 147.902 55.2173 147.902 50.7898C147.902 46.3622 151.503 42.7808 155.911 42.7808C160.319 42.7808 163.92 46.3819 163.92 50.7898C163.92 55.1977 160.339 58.7988 155.911 58.7988ZM155.911 45.7325C153.117 45.7325 150.854 47.9955 150.854 50.7898C150.854 53.5841 153.117 55.847 155.911 55.847C158.705 55.847 160.968 53.5841 160.968 50.7898C160.968 47.9955 158.705 45.7325 155.911 45.7325ZM172.146 77.1781C170.788 71.5305 168.899 66.0206 164.373 63.797C161.933 62.636 159.119 62.026 155.99 62.026C152.861 62.026 150.027 62.6163 147.587 63.797C143.061 66.0009 141.192 71.5305 139.814 77.1781L142.687 77.8669C143.829 73.1638 145.442 68.1262 148.866 66.4535C150.893 65.4696 153.294 64.9777 155.99 64.9777C158.686 64.9777 161.067 65.4696 163.094 66.4535C166.537 68.1262 168.151 73.1638 169.292 77.8669L172.165 77.1781H172.146Z" fill="currentColor"/>
<path d="M309.27 46.3782H322.442V59.5503H309.27M309.27 46.3782V59.5503M309.27 46.3782V41.4387C301.861 41.4387 289.512 41.4387 286.219 41.4387C282.926 41.4387 274.693 43.9084 274.693 52.9642C274.693 62.0199 282.926 64.4898 286.219 64.4898H309.27V59.5503" stroke="currentColor" stroke-width="2.46976"/>
<circle cx="284.655" cy="52.9146" r="4.61974" stroke="currentColor" stroke-width="2.46976"/>
<path d="M54.8014 45.4651C57.3001 45.3876 59.7527 46.1549 61.7623 47.6418C63.7719 49.1289 65.2219 51.2501 65.8785 53.6623C66.535 56.0745 66.3592 58.6374 65.3805 60.9377C64.6315 62.6978 63.445 64.2249 61.9469 65.383V68.2248L61.5025 68.6428L60.0436 70.0129L61.5504 71.5705L61.9469 71.9807V73.6115L61.566 74.0188L59.9918 75.6975L61.5397 77.2649L61.9469 77.677V81.426L61.4322 81.8498L56.2887 86.0764L55.3971 86.8098L54.5016 86.0803L49.3131 81.8537L48.7936 81.4299V65.7121C47.2767 64.6564 46.0372 63.2338 45.2008 61.5637C44.0815 59.3283 43.7476 56.7805 44.2535 54.3322C44.7595 51.884 46.0752 49.6772 47.9889 48.0686C49.9025 46.46 52.3026 45.5426 54.8014 45.4651ZM54.8893 48.2824C53.0237 48.3403 51.2311 49.0249 49.8023 50.2258C48.3736 51.4268 47.3911 53.0747 47.0133 54.9026C46.6356 56.7302 46.8849 58.6322 47.7203 60.301C48.556 61.9698 49.93 63.3092 51.6197 64.1018L51.61 64.1233H51.6158V80.0881L55.3883 83.1613L59.1246 80.092V78.8352L57.0299 76.716L56.0758 75.7502L57.0045 74.759L58.8258 72.8137L57.0201 70.9465L56.024 69.9172L57.068 68.9367L59.1246 67.0041V63.8723H59.1324L59.1305 63.8693C60.7681 62.9737 62.0569 61.5517 62.7877 59.8342C63.4726 58.2242 63.6305 56.4417 63.2438 54.7414L63.1588 54.4026C62.6686 52.6016 61.5859 51.0176 60.0856 49.9074C58.5853 48.7975 56.7546 48.2247 54.8893 48.2824Z" fill="currentColor"/>
<circle cx="55.1439" cy="56.1701" r="2.63109" stroke="#272727" stroke-width="2.82258"/>
<path d="M22.2686 73.7727L23.5869 74.2786C22.6618 76.6897 21.6341 82.0755 21.3037 84.178L19.9092 83.9583L18.5146 83.7395C18.8415 81.6595 19.905 75.9933 20.9512 73.2668L22.2686 73.7727ZM27.1592 59.0696C31.1583 58.1946 35.8373 58.49 41.2656 60.4299L41.793 60.6233L41.8398 60.6409L41.8857 60.6624C41.8507 60.6463 41.8186 60.6347 41.791 60.6272C41.7512 60.6164 41.7196 60.6124 41.7002 60.6116L41.6992 60.6125C41.6967 60.6134 41.6935 60.6144 41.6904 60.6155C41.689 60.616 41.6871 60.6168 41.6855 60.6174L41.6826 60.6184H41.6807C41.6805 60.6185 41.6812 60.6208 41.7363 60.7727C41.795 60.9344 41.9151 61.2666 42.1621 61.9456C42.6095 63.1751 42.6416 63.2651 42.6436 63.2717H42.6426L42.6416 63.2727C42.6406 63.273 42.6388 63.2734 42.6377 63.2737C42.6356 63.2744 42.6331 63.2758 42.6309 63.2766C42.626 63.2783 42.6202 63.2804 42.6143 63.2825C42.602 63.2867 42.5868 63.2918 42.5703 63.2971C42.5373 63.3077 42.4952 63.3201 42.4463 63.3333C42.3493 63.3592 42.214 63.3898 42.0557 63.4104C41.787 63.4453 41.3083 63.4687 40.8047 63.2659V63.2668C35.5605 61.3074 31.2653 61.061 27.7627 61.8274C24.2613 62.5936 21.4403 64.3968 19.1816 66.718C14.6205 71.4059 12.4251 78.1411 11.7891 82.2161L9 81.7805C9.68904 77.3659 12.0483 70.0022 17.1582 64.7502C19.7352 62.1017 23.0301 59.9732 27.1592 59.0696ZM33.9316 33.635C39.6826 33.9265 44.2559 38.6817 44.2559 44.5051L44.2422 45.0647C43.9507 50.8155 39.1953 55.3887 33.3721 55.3889L32.8115 55.3752C27.2462 55.093 22.784 50.63 22.502 45.0647L22.4873 44.5051C22.4873 38.494 27.361 33.6206 33.3721 33.6204L33.9316 33.635ZM33.3721 36.4426C28.9199 36.4428 25.3096 40.0529 25.3096 44.5051C25.3098 48.9572 28.92 52.5665 33.3721 52.5667C37.8241 52.5664 41.4333 48.9571 41.4336 44.5051C41.4336 40.0529 37.8242 36.4429 33.3721 36.4426Z" fill="#272727"/>
<path d="M25.0898 10.0358C25.0898 8.65016 26.2131 7.52686 27.5988 7.52686H46.416C47.8017 7.52686 48.925 8.65016 48.925 10.0358C48.925 11.4215 47.8017 12.5448 46.416 12.5448H27.5988C26.2131 12.5448 25.0898 11.4215 25.0898 10.0358Z" fill="currentColor" fill-opacity="0.5"/>
<path d="M10.0361 1.88184H65.2334C69.7366 1.88207 73.3867 5.53288 73.3867 10.0361V115.412C73.3867 119.915 69.7366 123.566 65.2334 123.566H10.0361C5.53274 123.566 1.88184 119.916 1.88184 115.412V10.0361C1.88184 5.53274 5.53274 1.88184 10.0361 1.88184Z" stroke="currentColor" stroke-opacity="0.5" stroke-width="3.76344"/>
</svg>
`;


const $a8de4608c0ee1d33$var$isPromotionPasskeys = (currentViewState)=>{
    var _currentViewState$rel, _currentViewState$rel2;
    return (0, $bdb5e1755e68f0a9$export$b2165307d0329b71)(currentViewState === null || currentViewState === void 0 ? void 0 : currentViewState.name, currentViewState === null || currentViewState === void 0 ? void 0 : (_currentViewState$rel = currentViewState.relatesTo) === null || _currentViewState$rel === void 0 ? void 0 : (_currentViewState$rel2 = _currentViewState$rel.value) === null || _currentViewState$rel2 === void 0 ? void 0 : _currentViewState$rel2.displayName);
};
// Splash content (illustration + FAQ) shown when the passkey displayName applies.
// Illustration SVG uses `fill="currentColor"` so it inherits from the enclosing
// element's CSS `color`, which ColorsUtil overrides with `colors.brand` when configured.
//
// {{{illustrationSvg}}} renders unescaped. Safe here because `passkeyPromotionIllustration`
// is a compile-time constant defined in this repo — do NOT wire user-controlled input
// through this field or the SVG becomes an XSS vector.
const $a8de4608c0ee1d33$var$PasskeySplashInfoView = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'oie-passkey-splash-content',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"passkey-promotion-illustration\">" + ((stack1 = (helper = (helper = lookupProperty(helpers, "illustrationSvg") || (depth0 != null ? lookupProperty(depth0, "illustrationSvg") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
                "name": "illustrationSvg",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 44
                    },
                    "end": {
                        "line": 1,
                        "column": 65
                    }
                }
            }) : helper)) != null ? stack1 : "") + "</div><div class=\"passkey-promotion-faq\"><h3 class=\"passkey-promotion-faq-title\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.authenticator.promotion.faq.benefit.title"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 146
                    },
                    "end": {
                        "line": 1,
                        "column": 229
                    }
                }
            })) + "</h3><p class=\"passkey-promotion-faq-description\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.authenticator.promotion.faq.benefit.description"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 279
                    },
                    "end": {
                        "line": 1,
                        "column": 368
                    }
                }
            })) + "</p><h3 class=\"passkey-promotion-faq-title\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.authenticator.promotion.faq.definition.title"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 412
                    },
                    "end": {
                        "line": 1,
                        "column": 498
                    }
                }
            })) + "</h3><p class=\"passkey-promotion-faq-description\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.authenticator.promotion.faq.definition.description"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 548
                    },
                    "end": {
                        "line": 1,
                        "column": 640
                    }
                }
            })) + "</p><h3 class=\"passkey-promotion-faq-title\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.authenticator.promotion.faq.storage.title"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 684
                    },
                    "end": {
                        "line": 1,
                        "column": 767
                    }
                }
            })) + "</h3><p class=\"passkey-promotion-faq-description\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.authenticator.promotion.faq.storage.description"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 817
                    },
                    "end": {
                        "line": 1,
                        "column": 906
                    }
                }
            })) + "</p></div>";
        },
        "useData": true
    }),
    getTemplateData: function() {
        return {
            illustrationSvg: (0, $7ad45758fbbf73a4$export$8a7d9f50402940a6)
        };
    }
});
function $a8de4608c0ee1d33$var$getExcludeCredentials(authenticatorEnrollments = []) {
    const credentials = [];
    authenticatorEnrollments.forEach((enrollement)=>{
        if (enrollement.key === 'webauthn') {
            var _enrollement$transpor, _enrollement$profile;
            const credential = {
                type: 'public-key',
                id: (0, $36d38737859019f5$export$2e2bcd8739ae039).strToBin(enrollement.credentialId)
            };
            // okta-core may emit profile.transports as a comma separated string so the entire
            // profile serializes as Map<String,String>; tolerate both array and string shapes.
            let transports = (_enrollement$transpor = enrollement.transports) !== null && _enrollement$transpor !== void 0 ? _enrollement$transpor : (_enrollement$profile = enrollement.profile) === null || _enrollement$profile === void 0 ? void 0 : _enrollement$profile.transports;
            if (typeof transports === 'string') transports = transports.split(',');
            if (Array.isArray(transports)) credential.transports = transports;
            credentials.push(credential);
        }
    });
    return credentials;
}
const $a8de4608c0ee1d33$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    title: function() {
        if ($a8de4608c0ee1d33$var$isPromotionPasskeys(this.options.currentViewState)) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.authenticator.promotion.title', 'login');
        return (0, $3ddabee037f3f019$export$e0dd63b41f3f2431)(this.options.currentViewState, false);
    },
    className: 'oie-enroll-webauthn',
    modelEvents: {
        'error': '_stopEnrollment'
    },
    getUISchema: function() {
        const schema = [];
        // Returning custom array so no input fields are displayed for webauthn
        if ((0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isNewApiAvailable()) {
            var _this$options$current, _this$options$current2, _this$options$current3;
            const displayName = (_this$options$current = this.options.currentViewState) === null || _this$options$current === void 0 ? void 0 : (_this$options$current2 = _this$options$current.relatesTo) === null || _this$options$current2 === void 0 ? void 0 : (_this$options$current3 = _this$options$current2.value) === null || _this$options$current3 === void 0 ? void 0 : _this$options$current3.displayName;
            // The passkey splash (illustration + FAQ) is prepended when the displayName
            // qualifies. When the splash is shown the base instructions paragraph inside
            // EnrollWebauthnInfoView is suppressed via `hideInstructions` — the splash's
            // FAQ replaces it. The conditional pieces (Edge/UV callouts, custom
            // additional-instructions callout, spinner) still render.
            const showSplash = (0, $bdb5e1755e68f0a9$export$ee717b9fcb545a37)(displayName);
            if (showSplash) schema.push({
                View: $a8de4608c0ee1d33$var$PasskeySplashInfoView
            });
            schema.push({
                View: (0, $e27c890aa4bd1a6b$export$2e2bcd8739ae039),
                options: {
                    hideInstructions: showSplash
                }
            });
            const ctaLabel = $a8de4608c0ee1d33$var$isPromotionPasskeys(this.options.currentViewState) ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.authenticator.promotion.cta.createPasskey', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.webauthn.save', 'login');
            schema.push({
                View: (0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
                    className: 'webauthn-setup button button-primary button-wide',
                    title: ctaLabel,
                    click: ()=>{
                        this.triggerWebauthnPrompt();
                    }
                })
            });
        } else {
            var _this$options$current4, _this$options$current5;
            schema.push({
                View: (0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)({
                    className: 'webauthn-not-supported',
                    type: 'error',
                    subtitle: (0, $bdb5e1755e68f0a9$export$9748196cbdf7dd9e)({
                        DEFAULT: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.webauthn.error.not.supported', 'login'),
                        PASSKEYS: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.webauthn.passkeysRebrand.error.not.supported', 'login'),
                        CUSTOM: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.webauthn.passkeysRebrand.error.not.supported', 'login')
                    }, (_this$options$current4 = this.options.currentViewState.relatesTo) === null || _this$options$current4 === void 0 ? void 0 : (_this$options$current5 = _this$options$current4.value) === null || _this$options$current5 === void 0 ? void 0 : _this$options$current5.displayName)
                })
            });
        }
        return schema;
    },
    triggerWebauthnPrompt: function() {
        this.$el.find('.o-form-error-container').empty();
        this._startEnrollment();
        const relatesToObject = this.options.currentViewState.relatesTo;
        const activationData = relatesToObject === null || relatesToObject === void 0 ? void 0 : relatesToObject.value.contextualData.activationData;
        if ((0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isNewApiAvailable()) {
            var _activationData$authe;
            const excludeCredentials = ((_activationData$authe = activationData.authenticatorSelection) === null || _activationData$authe === void 0 ? void 0 : _activationData$authe.requireResidentKey) === true ? [] : $a8de4608c0ee1d33$var$getExcludeCredentials(this.options.appState.get('authenticatorEnrollments').value);
            const options = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({}, activationData, {
                challenge: (0, $36d38737859019f5$export$2e2bcd8739ae039).strToBin(activationData.challenge),
                user: {
                    id: (0, $36d38737859019f5$export$2e2bcd8739ae039).strToBin(activationData.user.id),
                    name: activationData.user.name,
                    displayName: activationData.user.displayName
                },
                excludeCredentials: excludeCredentials
            });
            // AbortController is not supported in IE11
            if (typeof AbortController !== 'undefined') this.webauthnAbortController = new AbortController();
            navigator.credentials.create({
                publicKey: options,
                signal: this.webauthnAbortController && this.webauthnAbortController.signal
            }).then((newCredential)=>{
                // example data: ["nfc", "usb"]
                const transports = (0, $bd053cd6fe43765a$export$2e2bcd8739ae039).processWebAuthnResponse(newCredential.response.getTransports, newCredential.response);
                this.model.set({
                    credentials: {
                        clientData: (0, $36d38737859019f5$export$2e2bcd8739ae039).binToStr(newCredential.response.clientDataJSON),
                        attestation: (0, $36d38737859019f5$export$2e2bcd8739ae039).binToStr(newCredential.response.attestationObject),
                        ...transports !== null && {
                            transports: transports
                        },
                        // example data: {"credProps":{"rk":true}}
                        clientExtensions: (0, $bd053cd6fe43765a$export$2e2bcd8739ae039).processWebAuthnResponse(newCredential.getClientExtensionResults, newCredential)
                    }
                });
                this.saveForm(this.model);
            }).catch((error)=>{
                // Override the default browser RP ID mismatch error in order to provide
                // a more user friendly error and have it localized
                if ((0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isRelyingPartyIdMismatchError(error)) {
                    this.model.trigger('error', this.model, {
                        responseJSON: {
                            errorSummary: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('signin.passkeys.error.SecurityError', 'login')
                        }
                    });
                    return;
                }
                this.model.trigger('error', this.model, {
                    responseJSON: {
                        errorSummary: (0, $93a83f6fd41fc21e$export$6e5b567ae7e48d0c)(error)
                    }
                });
            }).finally(()=>{
                this.webauthnAbortController = null;
            });
        }
    },
    _startEnrollment: function() {
        this.$('.okta-waiting-spinner').show();
        this.$('.webauthn-setup').hide();
    },
    _stopEnrollment: function() {
        this.$('.okta-waiting-spinner').hide();
        this.$('.webauthn-setup').show();
    }
});
// Extend AuthenticatorFooter (rather than BaseFooter) so the switch-authenticator
// link ("Return to authenticator list") and any factor-page custom link keep
// rendering. Append the "Maybe later" skip link on top ONLY when this view is
// serving the `enroll-authenticator-promotion` remediation — the API always
// ships a sibling `skip` on that remediation. Scoping by form name (rather than
// just presence of `skip`) prevents the promotion-specific "Maybe later" label
// from leaking into any standard `enroll-authenticator` response that happens
// to include a skip step.
const $a8de4608c0ee1d33$var$Footer = (0, $8a0b19b4456b71c9$export$2e2bcd8739ae039).extend({
    links: function() {
        const baseLinks = (0, $8a0b19b4456b71c9$export$2e2bcd8739ae039).prototype.links.call(this);
        if (!this.options.appState.hasRemediationObject((0, $4a07c2817278db15$export$657220afecfe252).ENROLL_AUTHENTICATOR_PROMOTION)) return baseLinks;
        return baseLinks.concat((0, $aaa5b7e3293b6284$export$77db2f739f8229cd)(this.options.appState, (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.authenticator.promotion.skip', 'login')));
    }
});
var $a8de4608c0ee1d33$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $a8de4608c0ee1d33$var$Body,
    Footer: $a8de4608c0ee1d33$var$Footer,
    postRender: function() {
        (0, $21a17fd013ef567d$export$2e2bcd8739ae039).prototype.postRender.apply(this, arguments);
        this.$el.find('.o-form-button-bar [type="submit"]').remove();
    }
});










































var $79985c6c5b1530ed$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p class=\"idx-webauthn-verify-text\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": depth0 != null ? lookupProperty(depth0, "verifyI18nKey") : depth0
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 57
                    },
                    "end": {
                        "line": 1,
                        "column": 99
                    }
                }
            })) + "</p>";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p class=\"idx-webauthn-verify-text\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.verify.webauthn.instructions"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 147
                    },
                    "end": {
                        "line": 1,
                        "column": 210
                    }
                }
            })) + "</p>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "verifyI18nKey") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.program(1, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 221
                    }
                }
            })) != null ? stack1 : "";
        },
        "useData": true
    }),
    initialize: function() {
        const relatesToObject = this.options.currentViewState.relatesTo;
        const challengeData = relatesToObject === null || relatesToObject === void 0 ? void 0 : relatesToObject.value.contextualData.challengeData;
        if (challengeData.userVerification === 'required') this.add((0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)({
            className: 'uv-required-callout',
            size: 'slim',
            type: 'warning',
            subtitle: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.verify.webauthn.uv.required.instructions', 'login')
        }));
        const description = (0, $3ddabee037f3f019$export$d64be9dcd88e405b)(this.options.currentViewState);
        if (description) this.add((0, $600936bcebe65871$export$2e2bcd8739ae039), {
            options: {
                description: description
            }
        });
        this.add('<div data-se="webauthn-waiting" class="okta-waiting-spinner"></div>');
    },
    getTemplateData: function() {
        var _this$options$current, _this$options$current2;
        return {
            verifyI18nKey: (0, $bdb5e1755e68f0a9$export$9748196cbdf7dd9e)({
                DEFAULT: 'oie.verify.webauthn.instructions',
                PASSKEYS: 'oie.verify.webauthn.passkeysRebrand.instructions',
                CUSTOM: 'oie.verify.webauthn.passkeysRebrand.instructions'
            }, (_this$options$current = this.options.currentViewState.relatesTo) === null || _this$options$current === void 0 ? void 0 : (_this$options$current2 = _this$options$current.value) === null || _this$options$current2 === void 0 ? void 0 : _this$options$current2.displayName)
        };
    }
});















const $98ec6d438083f79b$var$OKTA_AUTHENTICATOR = 'Okta_Authenticator';
const $98ec6d438083f79b$var$CantVerifyInfoVerifyFlowView = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    id: 'help-description-container',
    className: 'help-description js-help-description',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<h3>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.verify.webauthn.cant.verify.biometric.authenticator.title"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 4
                    },
                    "end": {
                        "line": 1,
                        "column": 96
                    }
                }
            })) + "</h3><br><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.verify.webauthn.cant.verify.biometric.authenticator.description1"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 108
                    },
                    "end": {
                        "line": 1,
                        "column": 207
                    }
                }
            })) + "</p><br><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.verify.webauthn.cant.verify.biometric.authenticator.description2"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 218
                    },
                    "end": {
                        "line": 1,
                        "column": 317
                    }
                }
            })) + "</p><br><h3>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.verify.webauthn.cant.verify.security.key.title"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 329
                    },
                    "end": {
                        "line": 1,
                        "column": 410
                    }
                }
            })) + "</h3><br><p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.verify.webauthn.cant.verify.security.key.description"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 422
                    },
                    "end": {
                        "line": 1,
                        "column": 509
                    }
                }
            })) + "</p><br>";
        },
        "useData": true
    })
});
const $98ec6d438083f79b$var$CantVerifyInfoOVEnrollmentFlowView = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    id: 'help-description-container',
    className: 'help-description js-help-description',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<li>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": depth0 != null ? lookupProperty(depth0, "enrollmentStep1") : depth0
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 58
                    },
                    "end": {
                        "line": 1,
                        "column": 102
                    }
                }
            })) + "</li><br>";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<li>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.verify.webauthn.cant.verify.enrollment.step1"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 123
                    },
                    "end": {
                        "line": 1,
                        "column": 202
                    }
                }
            })) + "</li><br>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<ol class=\"ov-enrollment-info\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "enrollmentStep1") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.program(1, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 31
                    },
                    "end": {
                        "line": 1,
                        "column": 218
                    }
                }
            })) != null ? stack1 : "") + "<li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.verify.webauthn.cant.verify.enrollment.step2"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 222
                    },
                    "end": {
                        "line": 1,
                        "column": 301
                    }
                }
            })) + "</li><br><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.verify.webauthn.cant.verify.enrollment.step3"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 314
                    },
                    "end": {
                        "line": 1,
                        "column": 393
                    }
                }
            })) + "</li><br><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.verify.webauthn.cant.verify.enrollment.step4"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 406
                    },
                    "end": {
                        "line": 1,
                        "column": 485
                    }
                }
            })) + "</><br></ol>";
        },
        "useData": true
    }),
    getTemplateData: function() {
        var _this$options$current, _this$options$current2;
        return {
            enrollmentStep1: (0, $bdb5e1755e68f0a9$export$9748196cbdf7dd9e)({
                DEFAULT: 'oie.verify.webauthn.cant.verify.enrollment.step1',
                PASSKEYS: 'oie.verify.webauthn.passkeysRebrand.cant.verify.enrollment.step1',
                CUSTOM: 'oie.verify.webauthn.passkeysRebrand.cant.verify.enrollment.step1'
            }, (_this$options$current = this.options.currentViewState.relatesTo) === null || _this$options$current === void 0 ? void 0 : (_this$options$current2 = _this$options$current.value) === null || _this$options$current2 === void 0 ? void 0 : _this$options$current2.displayName)
        };
    }
});
var $98ec6d438083f79b$export$2e2bcd8739ae039 = (0, $8a0b19b4456b71c9$export$2e2bcd8739ae039).extend({
    links: function() {
        const links = (0, $8a0b19b4456b71c9$export$2e2bcd8739ae039).prototype.links.apply(this, arguments);
        const cantVerifyInfoView = this.options.appState.get('app') && this.options.appState.get('app').name === $98ec6d438083f79b$var$OKTA_AUTHENTICATOR ? $98ec6d438083f79b$var$CantVerifyInfoOVEnrollmentFlowView : $98ec6d438083f79b$var$CantVerifyInfoVerifyFlowView;
        links.unshift({
            'label': (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.verify.webauthn.cant.verify', 'login'),
            'name': 'cant-verify',
            'aria-controls': 'help-description-container',
            'class': 'link help js-help',
            'type': 'toggle-text-link',
            'additionalOptions': {
                view: cantVerifyInfoView,
                selector: '.js-help-description'
            }
        });
        return links;
    }
});













var $f2b73f5b467da78a$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'setup-webauthn-residentkey-text',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.webauthn.rk.link"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 5
                    },
                    "end": {
                        "line": 1,
                        "column": 65
                    }
                }
            })) != null ? stack1 : "") + "</div>";
        },
        "useData": true
    }),
    events: {
        'click .setup-webauthn-residentkey-link': function(e) {
            e.preventDefault();
            this.options.appState.trigger('invokeAction', (0, $4a07c2817278db15$export$657220afecfe252).ENROLL_WEBAUTHN_RESIDENTKEY);
        }
    }
});



const $1a9f36c52c75480d$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    title: function() {
        return (0, $3ddabee037f3f019$export$e0dd63b41f3f2431)(this.options.currentViewState, true);
    },
    className: 'oie-verify-webauthn',
    getUISchema: function() {
        const schema = [];
        // Returning custom array so no input fields are displayed for webauthn
        if ((0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isNewApiAvailable()) {
            const retryButton = (0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
                className: 'retry-webauthn button-primary default-custom-button',
                title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.verify', 'login'),
                click: ()=>{
                    this.getCredentialsAndSave();
                }
            });
            schema.push({
                View: (0, $79985c6c5b1530ed$export$2e2bcd8739ae039)
            }, {
                View: retryButton
            });
            if (this._canSetupWebAuthnResidentKey()) schema.push({
                View: (0, $f2b73f5b467da78a$export$2e2bcd8739ae039)
            });
        } else {
            var _this$options$current, _this$options$current2;
            schema.push({
                View: (0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)({
                    className: 'webauthn-not-supported',
                    type: 'error',
                    subtitle: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)((0, $bdb5e1755e68f0a9$export$9748196cbdf7dd9e)({
                        DEFAULT: 'oie.webauthn.error.not.supported',
                        PASSKEYS: 'oie.webauthn.passkeysRebrand.error.not.supported',
                        CUSTOM: 'oie.webauthn.passkeysRebrand.error.not.supported'
                    }, (_this$options$current = this.options.currentViewState.relatesTo) === null || _this$options$current === void 0 ? void 0 : (_this$options$current2 = _this$options$current.value) === null || _this$options$current2 === void 0 ? void 0 : _this$options$current2.displayName) || 'oie.webauthn.error.not.supported', 'login')
                })
            });
        }
        return schema;
    },
    remove: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.remove.apply(this, arguments);
        if (this.webauthnAbortController) {
            this.webauthnAbortController.abort();
            this.webauthnAbortController = null;
        }
    },
    noButtonBar: true,
    modelEvents: {
        'error': '_stopVerification'
    },
    getCredentialsAndSave: function() {
        var _this$options$appStat;
        this.clearErrors();
        this._startVerification();
        // AbortController is not supported in IE11
        if (typeof AbortController !== 'undefined') this.webauthnAbortController = new AbortController();
        const relatesToObject = this.options.currentViewState.relatesTo;
        const authenticatorData = (relatesToObject === null || relatesToObject === void 0 ? void 0 : relatesToObject.value) || {};
        const allowCredentials = [];
        const authenticatorEnrollments = ((_this$options$appStat = this.options.appState.get('authenticatorEnrollments')) === null || _this$options$appStat === void 0 ? void 0 : _this$options$appStat.value) || [];
        authenticatorEnrollments.forEach((enrollement)=>{
            if (enrollement.key === 'webauthn') {
                var _enrollement$transpor, _enrollement$profile;
                const credential = {
                    type: 'public-key',
                    id: (0, $36d38737859019f5$export$2e2bcd8739ae039).strToBin(enrollement.credentialId)
                };
                // okta-core may emit profile.transports as a comma separated string so the entire
                // profile serializes as Map<String,String>; tolerate both array and string shapes.
                let transports = (_enrollement$transpor = enrollement.transports) !== null && _enrollement$transpor !== void 0 ? _enrollement$transpor : (_enrollement$profile = enrollement.profile) === null || _enrollement$profile === void 0 ? void 0 : _enrollement$profile.transports;
                if (transports && typeof transports === 'string') transports = transports.split(',');
                if (Array.isArray(transports)) credential.transports = transports;
                allowCredentials.push(credential);
            }
        });
        const challengeData = authenticatorData.contextualData.challengeData;
        const options = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend({}, challengeData, {
            allowCredentials: allowCredentials,
            challenge: (0, $36d38737859019f5$export$2e2bcd8739ae039).strToBin(challengeData.challenge)
        });
        // navigator.credentials() is not supported in IE11
        // eslint-disable-next-line compat/compat
        navigator.credentials.get({
            publicKey: options,
            signal: this.webauthnAbortController && this.webauthnAbortController.signal
        }).then((assertion)=>{
            const credentials = {
                clientData: (0, $36d38737859019f5$export$2e2bcd8739ae039).binToStr(assertion.response.clientDataJSON),
                authenticatorData: (0, $36d38737859019f5$export$2e2bcd8739ae039).binToStr(assertion.response.authenticatorData),
                signatureData: (0, $36d38737859019f5$export$2e2bcd8739ae039).binToStr(assertion.response.signature)
            };
            const hasUserHandleSchema = this.options.appState.getSchemaByName('credentials.userHandle');
            if (hasUserHandleSchema) {
                var _assertion$response$u;
                (0, $3e490973b7383cc4$export$2e2bcd8739ae039).extend(credentials, {
                    userHandle: (0, $36d38737859019f5$export$2e2bcd8739ae039).binToStr((_assertion$response$u = assertion.response.userHandle) !== null && _assertion$response$u !== void 0 ? _assertion$response$u : '')
                });
            }
            this.model.set({
                credentials: credentials
            });
            this.saveForm(this.model);
        }, (error)=>{
            // Override the default browser RP ID mismatch error in order to provide
            // a more user friendly error and have it localized
            if ((0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isRelyingPartyIdMismatchError(error)) {
                this.model.trigger('error', this.model, {
                    responseJSON: {
                        errorSummary: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('signin.passkeys.error.rpIdMismatch', 'login', [
                            authenticatorData.contextualData.challengeData.rpId
                        ])
                    }
                });
                return;
            }
            // Do not display if it is abort error triggered by code when switching.
            // this.webauthnAbortController would be null if abort was triggered by code.
            if (this.webauthnAbortController) this.model.trigger('error', this.model, {
                responseJSON: {
                    errorSummary: (0, $93a83f6fd41fc21e$export$6e5b567ae7e48d0c)(error)
                }
            });
        }).finally(()=>{
            // unset webauthnAbortController on successful authentication or error
            this.webauthnAbortController = null;
        });
    },
    _startVerification: function() {
        this.$('.okta-waiting-spinner').show();
        this.$('.retry-webauthn').hide();
        this.$('.setup-webauthn-residentkey-text').hide();
        this.$('.retry-webauthn')[0].textContent = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('retry', 'login');
    },
    _stopVerification: function() {
        this.$('.okta-waiting-spinner').hide();
        this.$('.retry-webauthn').show();
        this.$('.setup-webauthn-residentkey-text').show();
    },
    _canSetupWebAuthnResidentKey: function() {
        return this.options.appState.hasRemediationObject((0, $4a07c2817278db15$export$657220afecfe252).ENROLL_WEBAUTHN_RESIDENTKEY);
    }
});
var $1a9f36c52c75480d$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $1a9f36c52c75480d$var$Body,
    Footer: (0, $98ec6d438083f79b$export$2e2bcd8739ae039),
    postRender: function() {
        (0, $21a17fd013ef567d$export$2e2bcd8739ae039).prototype.postRender.apply(this, arguments);
        // Trigger browser prompt automatically for other browsers for better UX.
        if ((0, $bd053cd6fe43765a$export$2e2bcd8739ae039).isNewApiAvailable() && !(0, $22893d6dea78fc87$export$2e2bcd8739ae039).isSafari()) this.form.getCredentialsAndSave();
    }
});





















parcelRequire("3ZxP0");
















var $872ad8b526662550$export$2e2bcd8739ae039 = {
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.email.mfa.title', 'login');
    }
};















/*!
 * Copyright (c) 2026, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ /**
 * Build a normalized error object from various error shapes
 * (IDX response, API error, network error, etc.).
 *
 * @param {object} error - the raw error (or rawIdxState if already unwrapped)
 * @param {function} [onUnsupportedError] - optional callback invoked when error is unrecognized
 * @returns {object} errorObj with responseJSON
 */ const $e61f8568dda6e7bb$var$buildErrorObject = (error, onUnsupportedError)=>{
    if ((0, $83b60ca1e8963f3f$export$2e2bcd8739ae039).isIonErrorResponse(error)) return (0, $83b60ca1e8963f3f$export$2e2bcd8739ae039).convertFormErrors(error);
    else if (error.errorSummary) return {
        responseJSON: error
    };
    else {
        if (typeof onUnsupportedError === 'function') onUnsupportedError(error);
        return {
            responseJSON: {
                errorSummary: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('error.unsupported.response', 'login')
            }
        };
    }
};
/**
 * Check if error is a rate limit error (429).
 * Handles both IDX API errors (tooManyRequests key) and standard API errors (E0000047 errorCode).
 */ const $e61f8568dda6e7bb$var$isRateLimitError = (error)=>{
    var _error$responseJSON, _error$responseJSON$e, _error$responseJSON2, _error$responseJSON3;
    return !!((_error$responseJSON = error.responseJSON) !== null && _error$responseJSON !== void 0 && (_error$responseJSON$e = _error$responseJSON.errorSummaryKeys) !== null && _error$responseJSON$e !== void 0 && _error$responseJSON$e.includes('tooManyRequests') || ((_error$responseJSON2 = error.responseJSON) === null || _error$responseJSON2 === void 0 ? void 0 : _error$responseJSON2.errorCode) === 'E0000047' && !((_error$responseJSON3 = error.responseJSON) !== null && _error$responseJSON3 !== void 0 && _error$responseJSON3.errorIntent));
};
var $e61f8568dda6e7bb$export$2e2bcd8739ae039 = {
    buildErrorObject: $e61f8568dda6e7bb$var$buildErrorObject,
    isRateLimitError: $e61f8568dda6e7bb$var$isRateLimitError
};


const $d520165aa7942df9$var$ResendView = (0, $cc2732793cf3de83$export$2e2bcd8739ae039).extend({
    className: 'hide resend-email-view',
    events: {
        'click a.resend-link': 'handleResendLink'
    },
    modelEvents: {
        'error': 'handleError'
    },
    initialize: function() {
        this.add((0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)({
            content: `${(0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('email.code.not.received', 'login')}
        <a class='resend-link'>${(0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('email.button.resend', 'login')}</a>`,
            type: 'warning'
        }));
    },
    hideResendViewAndShowAfterTimeout: function() {
        // Hide warning, but reinitiate to show warning again after some threshold of polling
        if (!this.$el.hasClass('hide')) this.$el.addClass('hide');
        this.showCalloutAfterTimeout();
    },
    handleResendLink: function(ev) {
        ev === null || ev === void 0 || ev.preventDefault();
        this.options.appState.trigger('invokeAction', this.options.resendEmailAction);
        this.hideResendViewAndShowAfterTimeout();
    },
    handleError: function() {
        this.hideResendViewAndShowAfterTimeout();
    }
});
const $d520165aa7942df9$var$Body = (0, $d4b3dcf2c8899dc4$export$2e2bcd8739ae039).extend(Object.assign({
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.verify', 'login');
    },
    initialize: function() {
        (0, $d4b3dcf2c8899dc4$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        this.startPolling();
    },
    postRender: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.postRender.apply(this, arguments);
        // Add 1 instance of resend view
        if (!this.$el.find('.resend-email-view').length) this.add($d520165aa7942df9$var$ResendView, {
            selector: '.o-form-info-container',
            prepend: true,
            options: {
                resendEmailAction: this.resendEmailAction
            }
        });
    },
    saveForm: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.saveForm.apply(this, arguments);
        this.stopPolling();
    },
    remove: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.remove.apply(this, arguments);
        this.stopPolling();
    },
    triggerAfterError: function(model, error) {
        var _error$responseJSON, _error$responseJSON$e;
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.triggerAfterError.apply(this, arguments);
        const isFormPolling = !!this.polling;
        this.stopPolling();
        if ((_error$responseJSON = error.responseJSON) !== null && _error$responseJSON !== void 0 && (_error$responseJSON$e = _error$responseJSON.errorSummaryKeys) !== null && _error$responseJSON$e !== void 0 && _error$responseJSON$e.includes('idx.session.expired')) // Do NOT resume polling since session is invalid and polling is already stopped
        return;
        if ((0, $e61f8568dda6e7bb$export$2e2bcd8739ae039).isRateLimitError(error)) {
            // When polling encounter rate limit error, wait 60 sec for rate limit bucket to reset
            // before polling again & hide error message
            if (isFormPolling) setTimeout(()=>{
                model.trigger('clearFormError');
            }, 0);
            this.startPolling(60000);
        } else this.startPolling(this.options.appState.get('dynamicRefreshInterval'));
    }
}, (0, $872ad8b526662550$export$2e2bcd8739ae039)));
var $d520165aa7942df9$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $d520165aa7942df9$var$Body
});












// Courage doesn't support HTML, hence creating a subtitle here.
const $b4e2a58c45000c5c$var$CheckYourEmailTitle = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'okta-form-subtitle',
    attributes: {
        'data-se': 'o-form-explain'
    },
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "secondaryEmail") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.program(2, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 13
                    },
                    "end": {
                        "line": 1,
                        "column": 433
                    }
                }
            })) != null ? stack1 : "";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "$2": "<span class='strong no-translate'>$2</span>",
                    "$1": "<span class='strong no-translate'>$1</span>",
                    "arguments": "email;secondaryEmail",
                    "bundle": "login",
                    "code": "oie.email.verify.alternate.magicLinkToEmailAddress.with.secondary.email"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 35
                    },
                    "end": {
                        "line": 1,
                        "column": 269
                    }
                }
            }));
        },
        "2": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "$1": "<span class='strong no-translate'>$1</span>",
                    "arguments": "email",
                    "bundle": "login",
                    "code": "oie.email.verify.alternate.magicLinkToEmailAddress"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 277
                    },
                    "end": {
                        "line": 1,
                        "column": 426
                    }
                }
            }));
        },
        "3": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.email.verify.alternate.magicLinkToYourEmail"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 441
                    },
                    "end": {
                        "line": 1,
                        "column": 520
                    }
                }
            }));
        },
        "4": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.email.verify.alternate.instructions"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 557
                    },
                    "end": {
                        "line": 1,
                        "column": 628
                    }
                }
            }));
        },
        "5": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.email.verify.alternate.verificationCode.instructions"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 636
                    },
                    "end": {
                        "line": 1,
                        "column": 724
                    }
                }
            }));
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "email") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.program(3, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 527
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "useEmailMagicLinkValue") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(4, data, 0),
                "inverse": container.program(5, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 527
                    },
                    "end": {
                        "line": 1,
                        "column": 731
                    }
                }
            })) != null ? stack1 : "");
        },
        "useData": true
    }),
    getTemplateData: function() {
        return this.options;
    }
});
const $b4e2a58c45000c5c$var$CheckYourEmailEnrollTitle = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'okta-form-subtitle',
    attributes: {
        'data-se': 'o-form-explain'
    },
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.email.enroll.subtitle"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 56
                    }
                }
            }));
        },
        "useData": true
    })
});
const $b4e2a58c45000c5c$var$EnterCodeLink = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<button class=\"button-link enter-auth-code-instead-link\" >" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "code": "oie.email.verify.alternate.show.verificationCode.text"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 58
                    },
                    "end": {
                        "line": 1,
                        "column": 127
                    }
                }
            })) + "</button>";
        },
        "useData": true
    })
});
function $b4e2a58c45000c5c$export$30ba146270aa7444() {
    return $b4e2a58c45000c5c$var$CheckYourEmailTitle;
}
function $b4e2a58c45000c5c$export$b9b7f1ae950d661d() {
    return $b4e2a58c45000c5c$var$CheckYourEmailEnrollTitle;
}
function $b4e2a58c45000c5c$export$2dc4fa4dad0eed24() {
    return $b4e2a58c45000c5c$var$EnterCodeLink;
}


const $98ac4b7d5b9c74db$var$BaseAuthenticatorEmailForm = (0, $d520165aa7942df9$export$2e2bcd8739ae039).prototype.Body;
const $98ac4b7d5b9c74db$var$Body = $98ac4b7d5b9c74db$var$BaseAuthenticatorEmailForm.extend(Object.assign({
    resendEmailAction: 'currentAuthenticator-resend',
    initialize: function() {
        var _this$options$appStat, _this$options$appStat2, _this$options$appStat3;
        $98ac4b7d5b9c74db$var$BaseAuthenticatorEmailForm.prototype.initialize.apply(this, arguments);
        const email = ((_this$options$appStat = this.options.appState.get('user')) === null || _this$options$appStat === void 0 ? void 0 : (_this$options$appStat2 = _this$options$appStat.profile) === null || _this$options$appStat2 === void 0 ? void 0 : _this$options$appStat2.email) || ((_this$options$appStat3 = this.options.appState.get('user')) === null || _this$options$appStat3 === void 0 ? void 0 : _this$options$appStat3.identifier) || {};
        const useEmailMagicLinkValue = this.isUseEmailMagicLink();
        if (useEmailMagicLinkValue !== undefined) {
            this.noButtonBar = true;
            this.events['click .enter-auth-code-instead-link'] = 'showAuthCodeEntry';
            if (useEmailMagicLinkValue) this.add((0, $b4e2a58c45000c5c$export$2dc4fa4dad0eed24)(), {
                prepend: true,
                selector: '.o-form-error-container'
            });
            this.add((0, $b4e2a58c45000c5c$export$30ba146270aa7444)(), {
                prepend: true,
                selector: '.o-form-error-container',
                options: {
                    email: email,
                    useEmailMagicLinkValue: useEmailMagicLinkValue
                }
            });
        } else this.add((0, $b4e2a58c45000c5c$export$b9b7f1ae950d661d)(), {
            prepend: true,
            selector: '.o-form-error-container'
        });
    },
    postRender: function() {
        $98ac4b7d5b9c74db$var$BaseAuthenticatorEmailForm.prototype.postRender.apply(this, arguments);
        if (this.isUseEmailMagicLink() !== undefined) {
            if (this.isUseEmailMagicLink()) this.showCodeEntryField(false);
            else this.noButtonBar = false;
        }
    },
    isUseEmailMagicLink: function() {
        var _this$options$appStat4, _this$options$appStat5;
        return (_this$options$appStat4 = this.options.appState.get('currentAuthenticator')) === null || _this$options$appStat4 === void 0 ? void 0 : (_this$options$appStat5 = _this$options$appStat4.contextualData) === null || _this$options$appStat5 === void 0 ? void 0 : _this$options$appStat5.useEmailMagicLink;
    },
    showAuthCodeEntry: function() {
        this.noButtonBar = false;
        this.render();
        this.showCodeEntryField(true);
        this.removeEnterAuthCodeInsteadLink();
    },
    showCodeEntryField: function(show = true) {
        const $textField = this.$el.find('.o-form-fieldset-container');
        $textField.toggle(show);
    },
    removeEnterAuthCodeInsteadLink: function() {
        this.$el.find('.enter-auth-code-instead-link').remove();
    }
}));
var $98ac4b7d5b9c74db$export$2e2bcd8739ae039 = (0, $d520165aa7942df9$export$2e2bcd8739ae039).extend({
    Body: $98ac4b7d5b9c74db$var$Body
});




const $f5d8d2d9de2b0708$var$BaseAuthenticatorEmailForm = (0, $d520165aa7942df9$export$2e2bcd8739ae039).prototype.Body;
const $f5d8d2d9de2b0708$var$Body = $f5d8d2d9de2b0708$var$BaseAuthenticatorEmailForm.extend(Object.assign({
    noButtonBar: true,
    resendEmailAction: 'currentAuthenticatorEnrollment-resend',
    events: {
        'click .enter-auth-code-instead-link': 'showAuthCodeEntry'
    },
    initialize: function() {
        var _this$options$current, _this$options$current2;
        $f5d8d2d9de2b0708$var$BaseAuthenticatorEmailForm.prototype.initialize.apply(this, arguments);
        const { email: email, secondaryEmail: secondaryEmail } = ((_this$options$current = this.options.currentViewState.relatesTo) === null || _this$options$current === void 0 ? void 0 : (_this$options$current2 = _this$options$current.value) === null || _this$options$current2 === void 0 ? void 0 : _this$options$current2.profile) || {};
        const useEmailMagicLinkValue = this.isUseEmailMagicLink();
        if (useEmailMagicLinkValue) this.add((0, $b4e2a58c45000c5c$export$2dc4fa4dad0eed24)(), {
            prepend: true,
            selector: '.o-form-error-container'
        });
        this.add((0, $b4e2a58c45000c5c$export$30ba146270aa7444)(), {
            prepend: true,
            selector: '.o-form-error-container',
            options: {
                email: email,
                secondaryEmail: secondaryEmail,
                useEmailMagicLinkValue: useEmailMagicLinkValue
            }
        });
    },
    postRender: function() {
        $f5d8d2d9de2b0708$var$BaseAuthenticatorEmailForm.prototype.postRender.apply(this, arguments);
        if (this.isUseEmailMagicLink()) this.showCodeEntryField(false);
        else this.noButtonBar = false;
    },
    isUseEmailMagicLink: function() {
        var _this$options$appStat, _this$options$appStat2;
        const useEmailMagicLink = (_this$options$appStat = this.options.appState.get('currentAuthenticatorEnrollment')) === null || _this$options$appStat === void 0 ? void 0 : (_this$options$appStat2 = _this$options$appStat.contextualData) === null || _this$options$appStat2 === void 0 ? void 0 : _this$options$appStat2.useEmailMagicLink;
        return useEmailMagicLink !== undefined ? useEmailMagicLink : true;
    },
    showAuthCodeEntry: function() {
        this.noButtonBar = false;
        this.render();
        this.showCodeEntryField(true);
        this.removeEnterAuthCodeInsteadLink();
    },
    showCodeEntryField: function(show = true) {
        const $textField = this.$el.find('.o-form-fieldset-container');
        $textField.toggle(show);
    },
    removeEnterAuthCodeInsteadLink: function() {
        this.$el.find('.enter-auth-code-instead-link').remove();
    }
}));
var $f5d8d2d9de2b0708$export$2e2bcd8739ae039 = (0, $d520165aa7942df9$export$2e2bcd8739ae039).extend({
    Body: $f5d8d2d9de2b0708$var$Body
});













const $1faea61eb85939c2$var$BaseAuthenticatorEmailForm = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).prototype.Body;
const $1faea61eb85939c2$var$SubtitleView = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "secondaryEmail") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.program(2, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 70
                    },
                    "end": {
                        "line": 1,
                        "column": 471
                    }
                }
            })) != null ? stack1 : "";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "$2": "<span class='strong no-translate'>$2</span>",
                    "$1": "<span class='strong no-translate'>$1</span>",
                    "arguments": "email;secondaryEmail",
                    "bundle": "login",
                    "code": "oie.email.verify.subtitle.text.with.email.and.secondary.email"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 92
                    },
                    "end": {
                        "line": 1,
                        "column": 316
                    }
                }
            }));
        },
        "2": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "$1": "<span class='strong no-translate'>$1</span>",
                    "arguments": "email",
                    "bundle": "login",
                    "code": "oie.email.verify.subtitle.text.with.email"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 324
                    },
                    "end": {
                        "line": 1,
                        "column": 464
                    }
                }
            }));
        },
        "3": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.email.verify.subtitle.text.without.email"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 479
                    },
                    "end": {
                        "line": 1,
                        "column": 555
                    }
                }
            }));
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"okta-form-subtitle\" data-se=\"o-form-explain\">" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "email") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.program(3, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 57
                    },
                    "end": {
                        "line": 1,
                        "column": 562
                    }
                }
            })) != null ? stack1 : "") + "</div>";
        },
        "useData": true
    }),
    getTemplateData: function() {
        var _this$options$appStat, _this$options$appStat2, _this$options$appStat3, _this$options$appStat4;
        const email = (_this$options$appStat = this.options.appState.get('currentAuthenticatorEnrollment')) === null || _this$options$appStat === void 0 ? void 0 : (_this$options$appStat2 = _this$options$appStat.profile) === null || _this$options$appStat2 === void 0 ? void 0 : _this$options$appStat2.email;
        const secondaryEmail = (_this$options$appStat3 = this.options.appState.get('currentAuthenticatorEnrollment')) === null || _this$options$appStat3 === void 0 ? void 0 : (_this$options$appStat4 = _this$options$appStat3.profile) === null || _this$options$appStat4 === void 0 ? void 0 : _this$options$appStat4.secondaryEmail;
        return {
            email: email,
            secondaryEmail: secondaryEmail
        };
    }
});
const $1faea61eb85939c2$var$Body = $1faea61eb85939c2$var$BaseAuthenticatorEmailForm.extend({
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.email.challenge.mfa.title', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.email.verify.primaryButton', 'login');
    },
    postRender: function() {
        $1faea61eb85939c2$var$BaseAuthenticatorEmailForm.prototype.postRender.apply(this, arguments);
        this.add($1faea61eb85939c2$var$SubtitleView, {
            prepend: true,
            selector: '.o-form-info-container'
        });
    },
    getUISchema: function() {
        // Prevent from displaying radio buttons on the UI
        const uiSchemas = $1faea61eb85939c2$var$BaseAuthenticatorEmailForm.prototype.getUISchema.apply(this, arguments);
        return uiSchemas.filter((schema)=>schema.name !== 'authenticator.methodType');
    }
});
var $1faea61eb85939c2$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $1faea61eb85939c2$var$Body
});





















parcelRequire("3ZxP0");



















var $e9728a84bdccb4e8$export$2e2bcd8739ae039 = (0, $cc2732793cf3de83$export$2e2bcd8739ae039).extend({
    //only show after certain threshold of polling
    className: 'hide resend-ov-link-view',
    events: {
        'click a.resend-link': 'handelResendLink'
    },
    initialize: function() {
        const selectedChannel = this.options.appState.get('currentAuthenticator').contextualData.selectedChannel;
        this.add((0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)({
            content: selectedChannel === 'email' ? (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                "compiler": [
                    8,
                    ">= 4.3.0"
                ],
                "main": function(container, depth0, helpers, partials, data) {
                    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                        return undefined;
                    };
                    return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                        "name": "i18n",
                        "hash": {
                            "bundle": "login",
                            "code": "oie.enroll.okta_verify.email.notReceived"
                        },
                        "data": data,
                        "loc": {
                            "start": {
                                "line": 1,
                                "column": 0
                            },
                            "end": {
                                "line": 1,
                                "column": 73
                            }
                        }
                    })) != null ? stack1 : "";
                },
                "useData": true
            }) : (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                "compiler": [
                    8,
                    ">= 4.3.0"
                ],
                "main": function(container, depth0, helpers, partials, data) {
                    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                        return undefined;
                    };
                    return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                        "name": "i18n",
                        "hash": {
                            "bundle": "login",
                            "code": "oie.enroll.okta_verify.sms.notReceived"
                        },
                        "data": data,
                        "loc": {
                            "start": {
                                "line": 1,
                                "column": 0
                            },
                            "end": {
                                "line": 1,
                                "column": 71
                            }
                        }
                    })) != null ? stack1 : "";
                },
                "useData": true
            }),
            type: 'warning'
        }));
    },
    handelResendLink: function(ev) {
        ev === null || ev === void 0 || ev.preventDefault();
        this.options.appState.trigger('invokeAction', 'currentAuthenticator-resend');
        //hide warning, but reinitiate to show warning again after some threshold of polling
        this.$el.addClass('hide');
        this.showCalloutAfterTimeout();
    }
});













var $b82f704c4ccaf0b1$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'switch-channel-text',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "sameDeviceOVEnrollmentEnabled") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.program(2, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 23
                    },
                    "end": {
                        "line": 1,
                        "column": 325
                    }
                }
            })) != null ? stack1 : "";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.switch.channel.link.text"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 60
                    },
                    "end": {
                        "line": 1,
                        "column": 140
                    }
                }
            })) != null ? stack1 : "";
        },
        "2": function(container, depth0, helpers, partials, data) {
            var alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<a href=\"#\" class=\"switch-channel-link\" aria-label=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.totp.aria.cannotScan"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 200
                    },
                    "end": {
                        "line": 1,
                        "column": 259
                    }
                }
            })) + "\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.totp.cannotScan"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 261
                    },
                    "end": {
                        "line": 1,
                        "column": 314
                    }
                }
            })) + "</a>";
        },
        "3": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "isSameDeviceChannel") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(4, data, 0),
                "inverse": container.program(5, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 325
                    },
                    "end": {
                        "line": 1,
                        "column": 480
                    }
                }
            })) != null ? stack1 : "";
        },
        "4": function(container, depth0, helpers, partials, data) {
            return "";
        },
        "5": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "isDeviceBootstrapChannel") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(4, data, 0),
                "inverse": container.program(1, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 356
                    },
                    "end": {
                        "line": 1,
                        "column": 480
                    }
                }
            })) != null ? stack1 : "";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "isQRcodeChannel") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.program(3, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 487
                    }
                }
            })) != null ? stack1 : "";
        },
        "useData": true
    }),
    getTemplateData: function() {
        const selectedChannel = this.options.appState.get('currentAuthenticator').contextualData.selectedChannel;
        return {
            sameDeviceOVEnrollmentEnabled: this.settings.get('features.sameDeviceOVEnrollmentEnabled'),
            isQRcodeChannel: selectedChannel === 'qrcode',
            // Do not show switch channel link for sameDevice or deviceBootstrap
            isSameDeviceChannel: selectedChannel === 'samedevice',
            isDeviceBootstrapChannel: selectedChannel === 'devicebootstrap'
        };
    },
    postRender: function() {
        this.$el.find('.switch-channel-link').on('click', (event)=>{
            const appState = this.options.appState;
            event.preventDefault();
            appState.trigger('switchForm', (0, $4a07c2817278db15$export$657220afecfe252).SELECT_ENROLLMENT_CHANNEL);
        });
    }
});














const { Notification: $4b7a06b6ef15bf36$var$Notification } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).views.components;
const { Clipboard: $4b7a06b6ef15bf36$var$Clipboard } = (0, $5d64eb84267ab4e8$export$454b5eaffc99ebf6).util;
var $4b7a06b6ef15bf36$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    initialize: function() {
        let deviceMap = $4b7a06b6ef15bf36$var$getDeviceMap(this.options.appState);
        // automatically trigger the Set up Okta Verify button on same device enrollment view
        if (deviceMap && deviceMap.setupOVUrl && deviceMap.isDesktop) {
            this.ulDom && this.ulDom.remove();
            const IframeView = (0, $cbe16f34ebe007b2$export$19624797961a54fb)('custom-uri-container', deviceMap.setupOVUrl);
            this.ulDom = this.add(IframeView).last();
        }
    },
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<ol class=\"qrcode-info ov-info\"><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.qrcode.step1.updated"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 48
                    },
                    "end": {
                        "line": 1,
                        "column": 122
                    }
                }
            })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.qrcode.step2"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 131
                    },
                    "end": {
                        "line": 1,
                        "column": 197
                    }
                }
            })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "$1": "<span class='strong'>$1</span>",
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.qrcode.step3.updated"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 206
                    },
                    "end": {
                        "line": 1,
                        "column": 316
                    }
                }
            })) + "</li></ol><div class=\"qrcode-container\"><img class=\"qrcode\" src=" + alias3((helper = (helper = lookupProperty(helpers, "href") || (depth0 != null ? lookupProperty(depth0, "href") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
                "name": "href",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 380
                    },
                    "end": {
                        "line": 1,
                        "column": 388
                    }
                }
            }) : helper)) + " alt=\"" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "mfa.altQrCode"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 394
                    },
                    "end": {
                        "line": 1,
                        "column": 439
                    }
                }
            })) + "\"></img></div>";
        },
        "1": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<ul class=\"email-info ov-info\"><li>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "$1": "<span class='strong'>$1</span>",
                    "arguments": "email",
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.email.info.updated"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 508
                    },
                    "end": {
                        "line": 1,
                        "column": 636
                    }
                }
            })) != null ? stack1 : "") + "</li><li class=\"switch-channel-content\"></li></ul>";
        },
        "2": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<ul class=\"sms-info ov-info\"><li>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "$1": "<span class='strong'>$1</span>",
                    "arguments": "phoneNumber",
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.sms.info.updated"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 745
                    },
                    "end": {
                        "line": 1,
                        "column": 877
                    }
                }
            })) != null ? stack1 : "") + "</li><li class=\"switch-channel-content\"></li></ul>";
        },
        "3": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"sameDevice-setup" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "sameDeviceOVEnrollmentEnabled") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(4, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 990
                    },
                    "end": {
                        "line": 1,
                        "column": 1056
                    }
                }
            })) != null ? stack1 : "") + "\"><p class=\"explanation\" data-se=\"subheader\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "deviceMap") : depth0) != null ? lookupProperty(stack1, "isDesktop") : stack1, {
                "name": "if",
                "hash": {},
                "fn": container.program(5, data, 0),
                "inverse": container.program(9, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 1101
                    },
                    "end": {
                        "line": 1,
                        "column": 1874
                    }
                }
            })) != null ? stack1 : "") + "</p><ol class=\"ov-info\">" + ((stack1 = lookupProperty(helpers, "unless").call(alias1, depth0 != null ? lookupProperty(depth0, "sameDeviceOVEnrollmentEnabled") : depth0, {
                "name": "unless",
                "hash": {},
                "fn": container.program(10, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 1898
                    },
                    "end": {
                        "line": 1,
                        "column": 2312
                    }
                }
            })) != null ? stack1 : "") + "<li><a href=\"" + alias2(container.lambda((stack1 = depth0 != null ? lookupProperty(depth0, "deviceMap") : depth0) != null ? lookupProperty(stack1, "setupOVUrl") : stack1, depth0)) + "\" class=\"button button-primary setup-button\">" + alias2((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.setup.title"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 2394
                    },
                    "end": {
                        "line": 1,
                        "column": 2459
                    }
                }
            })) + "</a></li>" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "sameDeviceOVEnrollmentEnabled") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(12, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 2468
                    },
                    "end": {
                        "line": 1,
                        "column": 2786
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "showAnotherDeviceLink") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(13, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 2786
                    },
                    "end": {
                        "line": 1,
                        "column": 3125
                    }
                }
            })) != null ? stack1 : "") + "</ol></div>";
        },
        "4": function(container, depth0, helpers, partials, data) {
            return " ov-enrollment-enabled";
        },
        "5": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"desktop-instructions ov-info\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
                "name": "i18n",
                "hash": {
                    "$1": "<span class='semi-strong'>$1</span>",
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.setup.customUri.prompt"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 1170
                    },
                    "end": {
                        "line": 1,
                        "column": 1287
                    }
                }
            })) + "</div><div class=\"desktop-instructions\">" + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "sameDeviceOVEnrollmentEnabled") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(6, data, 0),
                "inverse": container.program(7, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 1327
                    },
                    "end": {
                        "line": 1,
                        "column": 1583
                    }
                }
            })) != null ? stack1 : "") + "</div>" + ((stack1 = lookupProperty(helpers, "unless").call(alias1, depth0 != null ? lookupProperty(depth0, "sameDeviceOVEnrollmentEnabled") : depth0, {
                "name": "unless",
                "hash": {},
                "fn": container.program(8, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 1589
                    },
                    "end": {
                        "line": 1,
                        "column": 1765
                    }
                }
            })) != null ? stack1 : "");
        },
        "6": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "$1": "<span>$1</span>",
                    "bundle": "login",
                    "code": "customUri.required.content.prompt"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 1364
                    },
                    "end": {
                        "line": 1,
                        "column": 1449
                    }
                }
            }));
        },
        "7": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "$1": "<span class='semi-strong'>$1</span>",
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.setup.customUri.noPrompt"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 1457
                    },
                    "end": {
                        "line": 1,
                        "column": 1576
                    }
                }
            }));
        },
        "8": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"desktop-instructions\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.setup.customUri.makeSureHaveOV"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 1664
                    },
                    "end": {
                        "line": 1,
                        "column": 1748
                    }
                }
            })) + "</div>";
        },
        "9": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.setup.customUri.makeSureHaveOVToContinue"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 1773
                    },
                    "end": {
                        "line": 1,
                        "column": 1867
                    }
                }
            }));
        },
        "10": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "deviceMap") : depth0) != null ? lookupProperty(stack1, "platformLC") : stack1, {
                "name": "if",
                "hash": {},
                "fn": container.program(11, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 1939
                    },
                    "end": {
                        "line": 1,
                        "column": 2176
                    }
                }
            })) != null ? stack1 : "") + "<li>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
                "name": "i18n",
                "hash": {
                    "$1": "<span class='semi-strong'>$1</span>",
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.setup.customUri.setup"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 2180
                    },
                    "end": {
                        "line": 1,
                        "column": 2296
                    }
                }
            })) + "</li>";
        },
        "11": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = container.escapeExpression, alias2 = container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<li><a aria-label='" + alias1((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "customUri.required.content.download.linkText"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 1986
                    },
                    "end": {
                        "line": 1,
                        "column": 2061
                    }
                }
            })) + "' href=\"" + alias1(alias2((stack1 = depth0 != null ? lookupProperty(depth0, "deviceMap") : depth0) != null ? lookupProperty(stack1, "downloadHref") : stack1, depth0)) + "\" class=\"app-store-logo " + alias1(alias2((stack1 = depth0 != null ? lookupProperty(depth0, "deviceMap") : depth0) != null ? lookupProperty(stack1, "platformLC") : stack1, depth0)) + "-app-store-logo\"></a></li>";
        },
        "12": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<li><span>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "customUri.required.content.download.title"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 2515
                    },
                    "end": {
                        "line": 1,
                        "column": 2587
                    }
                }
            })) + "</span>&nbsp;<a href=\"" + alias3(container.lambda((stack1 = depth0 != null ? lookupProperty(depth0, "deviceMap") : depth0) != null ? lookupProperty(stack1, "downloadHref") : stack1, depth0)) + "\" target=\"_blank\" id=\"download-ov\" class=\"download-ov-link\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "customUri.required.content.download.linkText"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 2695
                    },
                    "end": {
                        "line": 1,
                        "column": 2770
                    }
                }
            })) + "</a></li>";
        },
        "13": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<li>" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, (stack1 = depth0 != null ? lookupProperty(depth0, "deviceMap") : depth0) != null ? lookupProperty(stack1, "isDesktop") : stack1, {
                "name": "if",
                "hash": {},
                "fn": container.program(14, data, 0),
                "inverse": container.program(15, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 2819
                    },
                    "end": {
                        "line": 1,
                        "column": 3113
                    }
                }
            })) != null ? stack1 : "") + "</li>";
        },
        "14": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "$1": "<a class='orOnMobileLink' href='#'>$1</a>",
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.setup.customUri.orOnMobile"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 2846
                    },
                    "end": {
                        "line": 1,
                        "column": 2973
                    }
                }
            }));
        },
        "15": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "$1": "<a class='orOnMobileLink' href='#'>$1</a>",
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.setup.customUri.orMobile"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 2981
                    },
                    "end": {
                        "line": 1,
                        "column": 3106
                    }
                }
            }));
        },
        "16": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "sameDevice") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(17, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 3144
                    },
                    "end": {
                        "line": 1,
                        "column": 4021
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "deviceBootstrap") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(18, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 4021
                    },
                    "end": {
                        "line": 1,
                        "column": 4802
                    }
                }
            })) != null ? stack1 : "");
        },
        "17": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, alias4 = container.lambda, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p class=\"explanation\" data-se=\"subheader\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.setup.subtitle "
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 3205
                    },
                    "end": {
                        "line": 1,
                        "column": 3274
                    }
                }
            })) + "</p><ol class=\"sameDevice-info ov-info\"><li>" + ((stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "arguments": "sameDevice.downloadHref",
                    "bundle": "login",
                    "code": "enroll.oda.without.account.step1"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 3318
                    },
                    "end": {
                        "line": 1,
                        "column": 3419
                    }
                }
            })) != null ? stack1 : "") + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.setup.openOv"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 3428
                    },
                    "end": {
                        "line": 1,
                        "column": 3494
                    }
                }
            })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.setup.signInUrl"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 3503
                    },
                    "end": {
                        "line": 1,
                        "column": 3572
                    }
                }
            })) + "<br><br/><span class='semi-strong no-translate'>" + alias3(alias4((stack1 = depth0 != null ? lookupProperty(depth0, "sameDevice") : depth0) != null ? lookupProperty(stack1, "orgUrl") : stack1, depth0)) + "</span><a data-clipboard-text=\"" + alias3(alias4((stack1 = depth0 != null ? lookupProperty(depth0, "sameDevice") : depth0) != null ? lookupProperty(stack1, "orgUrl") : stack1, depth0)) + "\" class=\"button link-button copy-org-clipboard-button\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "enroll.oda.org.copyLink"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 3748
                    },
                    "end": {
                        "line": 1,
                        "column": 3802
                    }
                }
            })) + "</a></li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.setup.skipAuth.followInstruction"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 3815
                    },
                    "end": {
                        "line": 1,
                        "column": 3901
                    }
                }
            })) + "</li></ol><p class=\"closing\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.setup.skipAuth.canBeClosed"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 3930
                    },
                    "end": {
                        "line": 1,
                        "column": 4010
                    }
                }
            })) + "</p>";
        },
        "18": function(container, depth0, helpers, partials, data) {
            var alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p class=\"explanation\" data-se=\"subheader\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.setup.skipAuth.subtitle"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 4087
                    },
                    "end": {
                        "line": 1,
                        "column": 4164
                    }
                }
            })) + "</p><ol class=\"deviceBootstrap-info ov-info\"><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "$1": "<span class='semi-strong'>$1</span>",
                    "arguments": "enrolledDeviceName",
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.setup.skipAuth.openOv.suchAs"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 4213
                    },
                    "end": {
                        "line": 1,
                        "column": 4367
                    }
                }
            })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.setup.skipAuth.selectAccount"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 4376
                    },
                    "end": {
                        "line": 1,
                        "column": 4458
                    }
                }
            })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "$1": "<span class='semi-strong'>$1</span>",
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.setup.skipAuth.addAccount"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 4467
                    },
                    "end": {
                        "line": 1,
                        "column": 4587
                    }
                }
            })) + "</li><li>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.setup.skipAuth.followInstruction"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 4596
                    },
                    "end": {
                        "line": 1,
                        "column": 4682
                    }
                }
            })) + "</li></ol><p class=\"closing\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.setup.skipAuth.canBeClosed"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 4711
                    },
                    "end": {
                        "line": 1,
                        "column": 4791
                    }
                }
            })) + "</p>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "href") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 460
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "email") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(1, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 460
                    },
                    "end": {
                        "line": 1,
                        "column": 693
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, depth0 != null ? lookupProperty(depth0, "phoneNumber") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(2, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 693
                    },
                    "end": {
                        "line": 1,
                        "column": 934
                    }
                }
            })) != null ? stack1 : "") + ((stack1 = lookupProperty(helpers, "if").call(alias1, (stack1 = depth0 != null ? lookupProperty(depth0, "deviceMap") : depth0) != null ? lookupProperty(stack1, "setupOVUrl") : stack1, {
                "name": "if",
                "hash": {},
                "fn": container.program(3, data, 0),
                "inverse": container.program(16, data, 0),
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 934
                    },
                    "end": {
                        "line": 1,
                        "column": 4809
                    }
                }
            })) != null ? stack1 : "");
        },
        "useData": true
    }),
    /* eslint complexity: [2, 20] */ getTemplateData: function() {
        var _contextualData$qrcod;
        const contextualData = this.options.appState.get('currentAuthenticator').contextualData;
        let enrolledDeviceName = '';
        let deviceMap = $4b7a06b6ef15bf36$var$getDeviceMap(this.options.appState);
        let showAnotherDeviceLink = false;
        if (contextualData) {
            if (contextualData !== null && contextualData !== void 0 && contextualData.devicebootstrap && contextualData !== null && contextualData !== void 0 && contextualData.devicebootstrap.enrolledDevices) {
                const enrolledDevices = contextualData === null || contextualData === void 0 ? void 0 : contextualData.devicebootstrap.enrolledDevices;
                enrolledDeviceName = Array.isArray(enrolledDevices) && !(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(enrolledDevices) ? enrolledDevices[0] : enrolledDevices;
            }
        }
        if (deviceMap.securityLevel && deviceMap.securityLevel === 'ANY') showAnotherDeviceLink = true;
        const sameDeviceOVEnrollmentEnabled = this.options.settings.get('features.sameDeviceOVEnrollmentEnabled');
        return {
            href: (_contextualData$qrcod = contextualData.qrcode) === null || _contextualData$qrcod === void 0 ? void 0 : _contextualData$qrcod.href,
            email: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).escape(contextualData === null || contextualData === void 0 ? void 0 : contextualData.email),
            phoneNumber: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).escape(contextualData === null || contextualData === void 0 ? void 0 : contextualData.phoneNumber),
            sameDevice: contextualData === null || contextualData === void 0 ? void 0 : contextualData.samedevice,
            deviceBootstrap: contextualData === null || contextualData === void 0 ? void 0 : contextualData.devicebootstrap,
            enrolledDeviceName: enrolledDeviceName,
            deviceMap: deviceMap,
            showAnotherDeviceLink: showAnotherDeviceLink,
            sameDeviceOVEnrollmentEnabled: sameDeviceOVEnrollmentEnabled
        };
    },
    postRender: function() {
        const appState = this.options && this.options.appState;
        const model = this.model;
        this.$('.orOnMobileLink').click(function() {
            var _qrChannelField$optio;
            if (!appState || !model) return;
            const qrChannel = 'qrcode';
            const remediations = appState.get('remediations');
            const selectEnrollmentChannelRemediation = remediations.find((remediation)=>{
                return remediation.name === (0, $4a07c2817278db15$export$657220afecfe252).SELECT_ENROLLMENT_CHANNEL;
            });
            if (!selectEnrollmentChannelRemediation) return;
            const idField = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).find(selectEnrollmentChannelRemediation.uiSchema, (schema)=>schema.name === 'authenticator.id');
            if (!idField) return;
            // filter selected channel
            const qrChannelField = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).find(selectEnrollmentChannelRemediation.uiSchema, (schema)=>schema.name === 'authenticator.channel');
            if (!qrChannelField) return;
            qrChannelField.options = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).filter(qrChannelField === null || qrChannelField === void 0 ? void 0 : qrChannelField.options, (option)=>option.value === qrChannel);
            qrChannelField.value = ((_qrChannelField$optio = qrChannelField.options[0]) === null || _qrChannelField$optio === void 0 ? void 0 : _qrChannelField$optio.value) || qrChannel;
            qrChannelField.sublabel = null;
            model.set('authenticator.channel', qrChannelField.value);
            model.set('authenticator.id', idField.value);
            model.set('formName', selectEnrollmentChannelRemediation.name);
            appState.trigger('saveForm', model);
        });
        $4b7a06b6ef15bf36$var$Clipboard.attach('.copy-org-clipboard-button').done(()=>{
            let notification = new $4b7a06b6ef15bf36$var$Notification({
                message: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('enroll.oda.org.copyLink.success', 'login'),
                level: 'success'
            });
            this.el.prepend(notification.render().el);
            return false;
        });
    }
});
function $4b7a06b6ef15bf36$var$getDeviceMap(appState) {
    var _contextualData$samed, _contextualData$devic;
    if (!appState) return null;
    const contextualData = appState.get('currentAuthenticator').contextualData;
    let deviceMap = {};
    if ((_contextualData$samed = contextualData.samedevice) !== null && _contextualData$samed !== void 0 && _contextualData$samed.setupOVUrl) deviceMap = {
        ...contextualData.samedevice
    };
    else if ((_contextualData$devic = contextualData.devicebootstrap) !== null && _contextualData$devic !== void 0 && _contextualData$devic.setupOVUrl) deviceMap = {
        ...contextualData.devicebootstrap
    };
    if (deviceMap.platform) {
        deviceMap.platformLC = deviceMap.platform.toLowerCase();
        deviceMap.isDesktop = !(deviceMap.platformLC === 'ios' || deviceMap.platformLC === 'android');
    }
    return deviceMap;
}


const $2771809d0b359020$var$OV_FORCE_FIPS_COMPLIANCE_UPGRAGE_KEY_IOS = 'oie.authenticator.app.non_fips_compliant_enrollment_device_incompatible';
const $2771809d0b359020$var$OV_FORCE_FIPS_COMPLIANCE_UPGRAGE_KEY_NON_IOS = 'oie.authenticator.app.non_fips_compliant_enrollment_app_update_required';
const $2771809d0b359020$var$OV_QR_ENROLL_ENABLE_BIOMETRICS_KEY = 'oie.authenticator.app.method.push.enroll.enable.biometrics';
const $2771809d0b359020$var$OV_QR_ENROLL_ENABLE_BIOMETRICS_OR_PIN_KEY = 'oie.authenticator.app.method.push.enroll.enable.biometrics_or_pin';
let $2771809d0b359020$var$shouldStartPolling = true;
const $2771809d0b359020$var$Body = (0, $d4b3dcf2c8899dc4$export$2e2bcd8739ae039).extend(Object.assign({
    title: function() {
        const selectedChannel = this.options.appState.get('currentAuthenticator').contextualData.selectedChannel;
        let title;
        switch(selectedChannel){
            case 'email':
                title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.okta_verify.setup.email.title', 'login');
                break;
            case 'sms':
                title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.okta_verify.setup.sms.title', 'login');
                break;
            default:
                title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.okta_verify.setup.title', 'login');
        }
        return title;
    },
    className: 'oie-enroll-ov-poll',
    noButtonBar: true,
    initialize: function() {
        (0, $d4b3dcf2c8899dc4$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        this.listenTo(this.model, 'error', this.stopPolling);
        if ($2771809d0b359020$var$shouldStartPolling) this.startPolling();
    },
    showMessages: function() {
        // override showMessages to display custom callout
        const calloutOptions = {};
        if (this.options.appState.containsMessageWithI18nKey($2771809d0b359020$var$OV_FORCE_FIPS_COMPLIANCE_UPGRAGE_KEY_IOS) || this.options.appState.containsMessageWithI18nKey($2771809d0b359020$var$OV_FORCE_FIPS_COMPLIANCE_UPGRAGE_KEY_NON_IOS)) // add a title for ov force upgrade
        calloutOptions.title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.okta_verify.enroll.force.upgrade.title', 'login');
        else if (this.options.appState.containsMessageWithI18nKey($2771809d0b359020$var$OV_QR_ENROLL_ENABLE_BIOMETRICS_OR_PIN_KEY)) // add a title for OV enable screen lock confirmation message during enrollment
        calloutOptions.title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.app.method.push.enroll.enable.biometrics_or_pin.title', 'login');
        else if (this.options.appState.containsMessageWithI18nKey($2771809d0b359020$var$OV_QR_ENROLL_ENABLE_BIOMETRICS_KEY)) // add a title for OV enable biometrics message during enrollment
        calloutOptions.title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.app.method.push.enroll.enable.biometrics.title', 'login');
        (0, $d4b3dcf2c8899dc4$export$2e2bcd8739ae039).prototype.showMessages.call(this, calloutOptions);
    },
    getUISchema: function() {
        const schema = [];
        const contextualData = this.options.appState.get('currentAuthenticator').contextualData;
        const selectedChannel = contextualData.selectedChannel;
        let selector;
        if (selectedChannel === 'qrcode') {
            selector = '.qrcode-container';
            $2771809d0b359020$var$shouldStartPolling = true;
        } else if ([
            'email',
            'sms'
        ].includes(selectedChannel)) {
            selector = '.switch-channel-content';
            $2771809d0b359020$var$shouldStartPolling = true;
        } else if ([
            'samedevice'
        ].includes(selectedChannel)) // no selector if the channel is same device
        $2771809d0b359020$var$shouldStartPolling = true;
        else if ([
            'devicebootstrap'
        ].includes(selectedChannel)) // no selector if the channel is device bootstrap
        $2771809d0b359020$var$shouldStartPolling = false;
        schema.push({
            View: (0, $4b7a06b6ef15bf36$export$2e2bcd8739ae039)
        });
        schema.push({
            View: (0, $b82f704c4ccaf0b1$export$2e2bcd8739ae039),
            options: {
                selectedChannel: selectedChannel
            },
            selector: selector
        });
        if ([
            'email',
            'sms'
        ].includes(selectedChannel)) schema.push({
            View: (0, $e9728a84bdccb4e8$export$2e2bcd8739ae039),
            selector: '.o-form-error-container'
        });
        return schema;
    },
    remove: function() {
        (0, $d4b3dcf2c8899dc4$export$2e2bcd8739ae039).prototype.remove.apply(this, arguments);
        this.stopPolling();
    }
}, (0, $00a836505a81684a$export$2e2bcd8739ae039)));
var $2771809d0b359020$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $2771809d0b359020$var$Body
});





















parcelRequire("3ZxP0");


















var $091161152fc9a80f$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'ov-same-device-enroll-text',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return (stack1 = (lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "$1": "<a class='ov-same-device-enroll-link' href='#'>$1</a>",
                    "bundle": "login",
                    "code": "oie.enroll.okta_verify.select.channel.ovOnThisDevice"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 144
                    }
                }
            })) != null ? stack1 : "";
        },
        "useData": true
    }),
    postRender: function() {
        const appState = this.options && this.options.appState;
        const model = this.model;
        this.$('.ov-same-device-enroll-link').click(function() {
            var _selectEnrollmentChan, _selectEnrollmentChan2, _sameDeviceChannelFie, _sameDeviceChannelFie2;
            if (!appState || !model) return;
            const sameDeviceChannel = 'samedevice';
            const remediations = appState.get('remediations');
            const selectEnrollmentChannelRemediation = remediations.find((remediation)=>{
                return remediation.name === (0, $4a07c2817278db15$export$657220afecfe252).SELECT_ENROLLMENT_CHANNEL;
            });
            if (!selectEnrollmentChannelRemediation) return;
            const idField = (_selectEnrollmentChan = selectEnrollmentChannelRemediation.uiSchema) === null || _selectEnrollmentChan === void 0 ? void 0 : _selectEnrollmentChan.find((schema)=>schema.name === 'authenticator.id');
            if (!idField) return;
            // filter selected channel
            const sameDeviceChannelField = (_selectEnrollmentChan2 = selectEnrollmentChannelRemediation.uiSchema) === null || _selectEnrollmentChan2 === void 0 ? void 0 : _selectEnrollmentChan2.find((schema)=>schema.name === 'authenticator.channel');
            if (!sameDeviceChannelField) return;
            sameDeviceChannelField.options = (_sameDeviceChannelFie = sameDeviceChannelField.options) === null || _sameDeviceChannelFie === void 0 ? void 0 : _sameDeviceChannelFie.filter((option)=>option.value === sameDeviceChannel);
            sameDeviceChannelField.value = ((_sameDeviceChannelFie2 = sameDeviceChannelField.options[0]) === null || _sameDeviceChannelFie2 === void 0 ? void 0 : _sameDeviceChannelFie2.value) || sameDeviceChannel;
            sameDeviceChannelField.sublabel = null;
            model.set('authenticator.channel', sameDeviceChannelField.value);
            model.set('authenticator.id', idField.value);
            model.set('formName', selectEnrollmentChannelRemediation.name);
            appState.trigger('saveForm', model);
        });
    }
});


const $2e2ba33845c38248$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    title: function() {
        return (0, $22893d6dea78fc87$export$2e2bcd8739ae039).isAndroid() || (0, $22893d6dea78fc87$export$2e2bcd8739ae039).isIOS() ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.okta_verify.setup.title', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.okta_verify.select.channel.title.updated', 'login');
    },
    getUISchema: function() {
        var _channelField$options;
        const schemas = (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.getUISchema.apply(this, arguments);
        // filter selected channel
        const channelField = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).find(schemas, (schema)=>schema.name === 'authenticator.channel');
        // do not show the 'samedevice' radio option, that option is displayed as a link instead
        channelField.options = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).filter(channelField === null || channelField === void 0 ? void 0 : channelField.options, (option)=>{
            var _this$options$appStat, _this$options$appStat2;
            return option.value !== ((_this$options$appStat = this.options.appState.get('currentAuthenticator')) === null || _this$options$appStat === void 0 ? void 0 : (_this$options$appStat2 = _this$options$appStat.contextualData) === null || _this$options$appStat2 === void 0 ? void 0 : _this$options$appStat2.selectedChannel) && option.value !== 'samedevice';
        });
        channelField.value = (_channelField$options = channelField.options[0]) === null || _channelField$options === void 0 ? void 0 : _channelField$options.value;
        channelField.sublabel = null;
        this.model.set('authenticator.channel', channelField.value);
        const description = {
            View: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.okta_verify.select.channel.subtitle', 'login'),
            selector: '.o-form-fieldset-container'
        };
        return [
            description,
            ...schemas
        ];
    }
});
var $2e2ba33845c38248$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $2e2ba33845c38248$var$Body,
    postRender: function() {
        var _this$options$current, _authenticatorFormVal;
        const authenticatorFormValues = (_this$options$current = this.options.currentViewState.value) === null || _this$options$current === void 0 ? void 0 : _this$options$current.find((val)=>val.name === 'authenticator').value.form.value;
        const sameDeviceChannelAvailable = authenticatorFormValues === null || authenticatorFormValues === void 0 ? void 0 : (_authenticatorFormVal = authenticatorFormValues.find((val)=>val.name === 'channel').options) === null || _authenticatorFormVal === void 0 ? void 0 : _authenticatorFormVal.find((channel)=>channel.value === 'samedevice');
        // only add this link if the samedevice channel is available in the remediation
        if (sameDeviceChannelAvailable) this.add(new (0, $091161152fc9a80f$export$2e2bcd8739ae039)({
            model: this.model,
            settings: this.settings,
            appState: this.options.appState
        }), 'form');
    }
});





















parcelRequire("3ZxP0");









const $5ea673e0b14644b1$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    className: 'oie-enroll-ov-data',
    title: function() {
        return this.options.appState.get('currentAuthenticator').contextualData.selectedChannel === 'email' ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.okta_verify.enroll.channel.email.title', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.okta_verify.enroll.channel.sms.title', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.okta_verify.setupLink', 'login');
    },
    getUISchema: function() {
        const uiSchemas = (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.getUISchema.apply(this, arguments);
        const phoneNumberUISchema = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).find(uiSchemas, ({ name: name })=>name === 'phoneNumber');
        const phoneNumberUISchemaIndex = (0, $3e490973b7383cc4$export$2e2bcd8739ae039).findIndex(uiSchemas, ({ name: name })=>name === 'phoneNumber');
        const countryUISchema = {
            'label-top': true,
            label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.country', 'login'),
            type: 'select',
            options: (0, $bfbf136e55dbe393$export$2e2bcd8739ae039).getCountries(),
            name: 'country',
            wide: true
        };
        // Create an input group - serves as a display wrapper
        const phoneNumberWithCodeUISchema = {
            label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.phoneNumber.placeholder', 'login'),
            type: 'group',
            modelType: 'string',
            'label-top': true,
            name: 'phoneCode',
            input: [
                {
                    type: 'label',
                    /* eslint-disable-next-line @okta/okta/no-unlocalized-text */ label: `+${this.model.get('phoneCode')}`,
                    className: 'country-code-label no-translate'
                },
                Object.assign({}, phoneNumberUISchema)
            ]
        };
        if (phoneNumberUISchemaIndex !== -1) // Replace phoneNumberUISchema and add countryUISchema before phone.
        uiSchemas.splice(phoneNumberUISchemaIndex, 1, countryUISchema, phoneNumberWithCodeUISchema);
        const description = {
            View: this.options.appState.get('currentAuthenticator').contextualData.selectedChannel === 'email' ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.okta_verify.enroll.channel.email.subtitle', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.okta_verify.channel.sms.description.updated', 'login'),
            selector: '.o-form-fieldset-container'
        };
        uiSchemas.push(description);
        return uiSchemas;
    },
    handlePhoneCodeChange: function() {
        const countryCodeField = this.el.querySelector('.country-code-label');
        countryCodeField.innerText = `+${this.model.get('phoneCode')}`;
    },
    initialize: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        if (this.options.appState.get('currentAuthenticator').contextualData.selectedChannel === 'sms') this.listenTo(this.model, 'change:phoneCode', this.handlePhoneCodeChange.bind(this));
    }
});
var $5ea673e0b14644b1$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $5ea673e0b14644b1$var$Body,
    createModelClass: function() {
        const ModelClass = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).prototype.createModelClass.apply(this, arguments);
        if (this.options.appState.get('currentAuthenticator').contextualData.selectedChannel !== 'sms') return ModelClass;
        const local = Object.assign({
            country: {
                // Set default country to "US"
                'value': this.settings.get('defaultCountryCode'),
                'type': 'string'
            }
        }, ModelClass.prototype.local);
        const derived = Object.assign({
            phoneCode: {
                deps: [
                    'country'
                ],
                fn: function(country) {
                    return (0, $bfbf136e55dbe393$export$2e2bcd8739ae039).getCallingCodeForCountry(country);
                }
            }
        }, ModelClass.prototype.derived);
        return ModelClass.extend({
            local: local,
            derived: derived,
            toJSON: function() {
                const modelJSON = (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039).prototype.toJSON.call(this, arguments);
                const phoneCode = this.get('phoneCode');
                // Add country code..
                let formattedPhoneNumber = `+${phoneCode}${modelJSON.phoneNumber}`;
                // Override phone with formatted number..
                modelJSON.phoneNumber = formattedPhoneNumber;
                return modelJSON;
            }
        });
    },
    postRender: function() {
        this.add((0, $b82f704c4ccaf0b1$export$2e2bcd8739ae039), 'form');
    }
});






















parcelRequire("3ZxP0");









const $90181527605f58eb$var$warningTemplate = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'okta-form-infobox-warning infobox infobox-warning',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<span class=\"icon warning-16\"></span><p>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "warning") || (depth0 != null ? lookupProperty(depth0, "warning") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "warning",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 40
                    },
                    "end": {
                        "line": 1,
                        "column": 51
                    }
                }
            }) : helper)) + "</p>";
        },
        "useData": true
    })
});
const $90181527605f58eb$export$4b2c32e08f77ff18 = (0, $d4b3dcf2c8899dc4$export$2e2bcd8739ae039).extend(Object.assign({
    noButtonBar: true,
    title: function() {
        return this.isOV() ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.okta_verify.push.title', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.verify.custom_app.title', 'login', [
            this.options.appState.getAuthenticatorDisplayName()
        ]);
    },
    initialize: function() {
        (0, $d4b3dcf2c8899dc4$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        // 'hasSavingState' would be true by default.
        // Setting it to false when auth key is okta_verify or custom_app with autochallenge schema
        // So that 'o-form-saving' css class is not added while polling and checkbox remains enabled.
        if ((this.isOV() || this.isCustomApp()) && this.isAutoChallengeSupported()) this.hasSavingState = false;
        this.listenTo(this.model, 'error', this.stopPoll);
        this.addView();
    },
    addView: function() {
        this.add((0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
            className: 'button button-wide button-primary send-push link-button-disabled',
            title: this.isOV() ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.okta_verify.push.sent', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.custom_app.push.sent', 'login'),
            click: (e)=>{
                e.preventDefault();
            }
        }));
        this.add(`<span class='accessibility-text' role='alert'>
        ${this.isOV() ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.okta_verify.push.sent', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.custom_app.push.sent', 'login')}</span>`);
    },
    render: function() {
        (0, $d4b3dcf2c8899dc4$export$2e2bcd8739ae039).prototype.render.apply(this, arguments);
        const checkbox = this.$el.find('[data-se="o-form-fieldset-autoChallenge"]');
        if (!this.isAutoChallengeSupported()) checkbox.length && checkbox.hide();
        else if (this.isOV() || this.isCustomApp()) // Move checkbox below the button
        // Checkbox is rendered by BaseForm using remediation response and
        // hence by default always gets added above buttons.
        checkbox.length && this.$el.find('.o-form-fieldset-container').append(checkbox);
    },
    postRender: function() {
        (0, $d4b3dcf2c8899dc4$export$2e2bcd8739ae039).prototype.postRender.apply(this, arguments);
        const className = this.isOV() ? 'okta-verify-push-challenge' : ' custom-app-push-challenge';
        this.$el.addClass(className);
        this.startPoll();
    },
    startPoll: function() {
        this.startPolling();
        this.warningTimeout = setTimeout(()=>{
            const warningText = this.isOV() ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oktaverify.warning', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.custom_app.push.warning', 'login', [
                this.options.appState.getAuthenticatorDisplayName()
            ]);
            this.showWarning(warningText);
        }, (0, $5dcf8c5d7fe7c644$export$3e280d76ab48f0fb));
    },
    stopPoll: function() {
        this.stopPolling();
        this.clearWarning();
    },
    showWarning: function(msg) {
        this.clearWarning();
        this.add($90181527605f58eb$var$warningTemplate, '.o-form-error-container', {
            options: {
                warning: msg
            }
        });
    },
    clearWarning: function() {
        if (this.$('.o-form-error-container div').hasClass('okta-form-infobox-warning')) this.$('.okta-form-infobox-warning').remove();
        clearTimeout(this.warningTimeout);
    },
    remove: function() {
        (0, $d4b3dcf2c8899dc4$export$2e2bcd8739ae039).prototype.remove.apply(this, arguments);
        this.stopPoll();
    },
    isOV: function() {
        return this.options.appState.get('authenticatorKey') === (0, $4a07c2817278db15$export$a7895cc4b0944d1b).OV;
    },
    isCustomApp: function() {
        return this.options.appState.get('authenticatorKey') === (0, $4a07c2817278db15$export$a7895cc4b0944d1b).CUSTOM_APP;
    },
    isAutoChallengeSupported: function() {
        return this.options.appState.getSchemaByName('autoChallenge') !== null && this.options.appState.getSchemaByName('autoChallenge') !== undefined;
    }
}, (0, $00a836505a81684a$export$2e2bcd8739ae039)));
const $90181527605f58eb$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $90181527605f58eb$export$4b2c32e08f77ff18
});





















parcelRequire("3ZxP0");








const $9d7ab2b14a4b8101$export$2e2bcd8739ae039 = (0, $39d1dd94b85d250f$export$2e2bcd8739ae039).extend({
    getDeviceChallengePayload: function() {
        return this.options.currentViewState.relatesTo.value.contextualData.challenge.value;
    },
    showMessages: function(options) {
        // When called from showCustomFormErrorCallout with a pre-built View, pass through
        // to avoid re-formatting or creating a loop
        if (options instanceof (0, $5d64eb84267ab4e8$export$27a5bd065ad55220)) {
            (0, $39d1dd94b85d250f$export$2e2bcd8739ae039).prototype.showMessages.call(this, options);
            return;
        }
        // Check if global messages contain biometrics error keys
        if (this.options.appState.containsMessageWithI18nKey([
            (0, $5dcf8c5d7fe7c644$export$17cbe7ebed212941),
            (0, $5dcf8c5d7fe7c644$export$21ec211902d7e608),
            (0, $5dcf8c5d7fe7c644$export$14b789590758b77b),
            (0, $5dcf8c5d7fe7c644$export$c5d5df2b86b06bbc),
            (0, $5dcf8c5d7fe7c644$export$99760f0e4fa6d0a6)
        ])) {
            const messages = this.options.appState.get('messages');
            const biometricsOptions = (0, $cbe16f34ebe007b2$export$1d274422d455f5b9)(messages, true);
            if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(biometricsOptions)) options = (0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)(biometricsOptions);
        }
        (0, $39d1dd94b85d250f$export$2e2bcd8739ae039).prototype.showMessages.call(this, options);
    },
    showCustomFormErrorCallout: function(error) {
        const options = (0, $cbe16f34ebe007b2$export$1d274422d455f5b9)(error, false);
        // If not biometrics error, just show the returned error message
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(options)) return false;
        this.showMessages((0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)(options));
        return true;
    }
});





















parcelRequire("3ZxP0");


















const $69bd4935984c0832$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    initialize: function() {
        this.listenTo(this.options.appState, 'showNumberChallengeWarning', ()=>{
            this.startWarningTimeout();
        });
        this.listenTo(this.options.appState, 'hideNumberChallengeWarning', ()=>{
            this.clearWarning();
        });
    },
    className: 'resend-number-challenge-warning hide',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"okta-form-infobox-warning infobox infobox-warning\"><span class=\"icon warning-16\"></span><p>" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                "name": "i18n",
                "hash": {
                    "$1": "<a href='#' class='resend-number-challenge'>$1</a>",
                    "bundle": "login",
                    "code": "oie.numberchallenge.warning"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 103
                    },
                    "end": {
                        "line": 1,
                        "column": 217
                    }
                }
            })) + "</p></div>";
        },
        "useData": true
    }),
    showWarning: function() {
        this.$el.removeClass('hide');
    },
    clearWarning: function() {
        this.$el.addClass('hide');
        clearTimeout(this.warningTimeout);
        this.startWarningTimeout();
    },
    startWarningTimeout: function() {
        this.warningTimeout = setTimeout((0, $3e490973b7383cc4$export$2e2bcd8739ae039).bind(function() {
            this.showWarning();
        }, this), (0, $5dcf8c5d7fe7c644$export$3e280d76ab48f0fb));
    }
});












const $6b7d6e28aab2572f$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'number-challenge-section',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<p>" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "$1": "<span class='strong'>$1</span>",
                    "arguments": "correctAnswer",
                    "bundle": "login",
                    "code": "oie.numberchallenge.instruction"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 3
                    },
                    "end": {
                        "line": 1,
                        "column": 127
                    }
                }
            })) + "</p><div class=\"phone no-translate\"><div class=\"phone--body\"><div class=\"phone--screen\"><span class=\"phone--number\" data-se=\"challenge-number\">" + alias3((helper = (helper = lookupProperty(helpers, "correctAnswer") || (depth0 != null ? lookupProperty(depth0, "correctAnswer") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
                "name": "correctAnswer",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 270
                    },
                    "end": {
                        "line": 1,
                        "column": 287
                    }
                }
            }) : helper)) + "</span></div><div class=\"phone--home-button\"></div></div></div>";
        },
        "useData": true
    }),
    getTemplateData: function() {
        var _this$options$appStat, _this$options$appStat2;
        const correctAnswer = (_this$options$appStat = this.options.appState.get('currentAuthenticator')) === null || _this$options$appStat === void 0 ? void 0 : (_this$options$appStat2 = _this$options$appStat.contextualData) === null || _this$options$appStat2 === void 0 ? void 0 : _this$options$appStat2.correctAnswer;
        return {
            correctAnswer: correctAnswer
        };
    }
});


const $f684b27b1b76b58d$export$2e2bcd8739ae039 = (0, $d4b3dcf2c8899dc4$export$2e2bcd8739ae039).extend(Object.assign({
    noButtonBar: true,
    className: 'okta-verify-number-challenge',
    events: {
        'click a.resend-number-challenge': 'handleResendNumberChallenge'
    },
    handleResendNumberChallenge: function() {
        this.options.appState.trigger('invokeAction', 'currentAuthenticator-resend');
        // hide the warning
        this.options.appState.trigger('hideNumberChallengeWarning');
    },
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.okta_verify.push.sent', 'login');
    },
    initialize: function() {
        (0, $d4b3dcf2c8899dc4$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        this.add((0, $6b7d6e28aab2572f$export$2e2bcd8739ae039));
    },
    triggerAfterError: function() {
        (0, $d4b3dcf2c8899dc4$export$2e2bcd8739ae039).prototype.triggerAfterError.apply(this, arguments);
        this.stopPolling();
        this.$el.find('.o-form-fieldset-container').empty();
    },
    postRender: function() {
        (0, $d4b3dcf2c8899dc4$export$2e2bcd8739ae039).prototype.postRender.apply(this, arguments);
        this.startPoll();
    },
    startPoll: function() {
        this.startPolling();
        this.addWarning();
    },
    stopPoll: function() {
        this.stopPolling();
    },
    addWarning: function() {
        this.add((0, $69bd4935984c0832$export$2e2bcd8739ae039), '.o-form-error-container');
        this.options.appState.trigger('showNumberChallengeWarning');
    },
    remove: function() {
        (0, $d4b3dcf2c8899dc4$export$2e2bcd8739ae039).prototype.remove.apply(this, arguments);
        this.stopPolling();
    }
}, (0, $00a836505a81684a$export$2e2bcd8739ae039)));



var $863b68c643335f66$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    initialize: function() {
        var _this$options, _this$options$appStat, _currentAuthenticator;
        (0, $21a17fd013ef567d$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        const currentAuthenticator = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : (_this$options$appStat = _this$options.appState) === null || _this$options$appStat === void 0 ? void 0 : _this$options$appStat.get('currentAuthenticator');
        const selectedMethod = currentAuthenticator === null || currentAuthenticator === void 0 ? void 0 : currentAuthenticator.methods[0];
        if ((selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.type) === (0, $4a07c2817278db15$export$2ba9c278cddab44b).PUSH && currentAuthenticator !== null && currentAuthenticator !== void 0 && (_currentAuthenticator = currentAuthenticator.contextualData) !== null && _currentAuthenticator !== void 0 && _currentAuthenticator.correctAnswer) this.Body = (0, $f684b27b1b76b58d$export$2e2bcd8739ae039);
        else if ((selectedMethod === null || selectedMethod === void 0 ? void 0 : selectedMethod.type) === (0, $4a07c2817278db15$export$2ba9c278cddab44b).PUSH) this.Body = (0, $90181527605f58eb$export$4b2c32e08f77ff18);
        else this.Body = (0, $9d7ab2b14a4b8101$export$2e2bcd8739ae039);
    }
});





















parcelRequire("3ZxP0");







const $2a2ec495e841bb06$var$OV_UV_ENABLE_BIOMETRIC_SERVER_KEY = 'oie.authenticator.oktaverify.method.totp.verify.enable.biometrics';
const $2a2ec495e841bb06$var$OV_UV_ENABLE_BIOMETRICS_OR_PIN_SERVER_KEY = 'oie.authenticator.oktaverify.method.totp.verify.enable.biometrics_or_pin';
const $2a2ec495e841bb06$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend(Object.assign({
    className: 'okta-verify-totp-challenge',
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.okta_verify.totp.title', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.verify', 'login');
    },
    showCustomFormErrorCallout: function(error) {
        var _error$responseJSON;
        const errorSummaryKeys = error === null || error === void 0 ? void 0 : (_error$responseJSON = error.responseJSON) === null || _error$responseJSON === void 0 ? void 0 : _error$responseJSON.errorSummaryKeys;
        let options;
        if (errorSummaryKeys && errorSummaryKeys.includes($2a2ec495e841bb06$var$OV_UV_ENABLE_BIOMETRICS_OR_PIN_SERVER_KEY)) {
            // Orgs that accept biometrics OR a device screen lock. Intentionally omits the
            // "device supports biometrics" bullet: biometrics is only one of the ways to satisfy
            // the requirement, so it should not be presented as a remediation step.
            options = {
                type: 'error',
                className: 'okta-verify-uv-callout-content',
                title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.oktaverify.method.totp.verify.enable.biometrics_or_pin.title', 'login'),
                subtitle: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.oktaverify.method.totp.verify.enable.biometrics_or_pin.description', 'login'),
                bullets: [
                    (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.oktaverify.method.totp.verify.enable.biometrics_or_pin.point1', 'login'),
                    (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.oktaverify.method.totp.verify.enable.biometrics_or_pin.point2', 'login')
                ]
            };
            this.showMessages((0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)(options));
            return true;
        }
        if (errorSummaryKeys && errorSummaryKeys.includes($2a2ec495e841bb06$var$OV_UV_ENABLE_BIOMETRIC_SERVER_KEY)) {
            options = {
                type: 'error',
                className: 'okta-verify-uv-callout-content',
                title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.app.method.push.verify.enable.biometrics.title', 'login'),
                subtitle: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.app.method.push.verify.enable.biometrics.description', 'login'),
                bullets: [
                    (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.app.method.push.verify.enable.biometrics.point1', 'login'),
                    (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.app.method.push.verify.enable.biometrics.point2', 'login'),
                    (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.app.method.push.verify.enable.biometrics.point3', 'login')
                ]
            };
            this.showMessages((0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)(options));
            return true;
        }
    }
}));
var $2a2ec495e841bb06$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $2a2ec495e841bb06$var$Body
});





















parcelRequire("3ZxP0");







const $76d6497d38589e84$var$OV_NMC_FORCE_UPGRAGE_SERVER_KEY = 'oie.authenticator.app.method.push.force.upgrade.number_challenge';
const $76d6497d38589e84$var$OV_UV_ENABLE_BIOMETRIC_SERVER_KEY = 'oie.authenticator.app.method.push.verify.enable.biometrics';
const $76d6497d38589e84$var$OV_UV_ENABLE_BIOMETRICS_OR_PIN_SERVER_KEY = 'oie.authenticator.app.method.push.verify.enable.biometrics_or_pin';
const $76d6497d38589e84$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend(Object.assign({
    className: 'okta-verify-resend-push',
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.okta_verify.push.title', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.okta_verify.push.resend', 'login');
    },
    showMessages: function() {
        let options = {};
        if (this.options.appState.containsMessageWithI18nKey($76d6497d38589e84$var$OV_NMC_FORCE_UPGRAGE_SERVER_KEY)) // add a title for OV force upgrade
        options.title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.numberchallenge.force.upgrade.title', 'login');
        else if (this.options.appState.containsMessageWithI18nKey($76d6497d38589e84$var$OV_UV_ENABLE_BIOMETRICS_OR_PIN_SERVER_KEY)) {
            // add a title for OV enable screen lock confirmation message during verification.
            // Orgs that accept biometrics OR a device screen lock. Intentionally omits the
            // "device supports biometrics" bullet: biometrics is only one of the ways to satisfy
            // the requirement, so it should not be presented as a remediation step.
            options.content = null;
            options.className = 'okta-verify-uv-callout-content';
            options.title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.app.method.push.verify.enable.biometrics_or_pin.title', 'login');
            options.subtitle = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.app.method.push.verify.enable.biometrics_or_pin.description', 'login');
            options.type = 'error';
            options.bullets = [
                (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.app.method.push.verify.enable.biometrics_or_pin.point1', 'login'),
                (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.app.method.push.verify.enable.biometrics_or_pin.point2', 'login')
            ];
            options = (0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)(options);
        } else if (this.options.appState.containsMessageWithI18nKey($76d6497d38589e84$var$OV_UV_ENABLE_BIOMETRIC_SERVER_KEY)) {
            // add a title for OV enable biometrics message during verification
            options.content = null;
            options.className = 'okta-verify-uv-callout-content';
            options.title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.app.method.push.verify.enable.biometrics.title', 'login');
            options.subtitle = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.app.method.push.verify.enable.biometrics.description', 'login');
            options.type = 'error';
            options.bullets = [
                (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.app.method.push.verify.enable.biometrics.point1', 'login'),
                (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.app.method.push.verify.enable.biometrics.point2', 'login'),
                (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.app.method.push.verify.enable.biometrics.point3', 'login')
            ];
            options = (0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)(options);
        }
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.showMessages.call(this, options);
    }
}));
var $76d6497d38589e84$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $76d6497d38589e84$var$Body
});





















parcelRequire("3ZxP0");


























parcelRequire("3ZxP0");






// Common view for OV push and custom app.
const $c02febce967191bd$export$2e2bcd8739ae039 = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend(Object.assign({
    className: function() {
        return this.isOV() ? 'okta-verify-send-push-form' : 'custom-app-send-push-form';
    },
    save: function() {
        return this.options.appState.get('authenticatorKey') === (0, $4a07c2817278db15$export$a7895cc4b0944d1b).OV ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.okta_verify.sendPushButton', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.custom_app.sendPushButton', 'login');
    },
    title: function() {
        return this.isOV() ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.okta_verify.push.title', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.custom_app.push.title', 'login');
    },
    render: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.render.apply(this, arguments);
        // Move checkbox below the button
        // Checkbox is rendered by BaseForm using remediation response and 
        // hence by default always gets added above buttons.
        const checkbox = this.$el.find('[data-se="o-form-fieldset-authenticator.autoChallenge"]');
        checkbox.length && this.$el.find('.o-form-button-bar').after(checkbox);
    },
    getUISchema: function() {
        const uiSchemas = (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.getUISchema.apply(this, arguments);
        return uiSchemas.filter((schema)=>schema.name !== 'authenticator.methodType');
    },
    isOV: function() {
        return this.options.appState.get('authenticatorKey') === (0, $4a07c2817278db15$export$a7895cc4b0944d1b).OV;
    }
}));


























// Common view for OV push and custom app.
const $9eb996c9801443b3$export$2e2bcd8739ae039 = (0, $499b38ed5a68ebff$export$4b2c32e08f77ff18).extend({
    getUISchema: function() {
        // Change the UI schema to not display radios here.
        const uiSchemas = (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.getUISchema.apply(this, arguments);
        const methodsSchema = uiSchemas.find((schema)=>schema.name === 'authenticator.methodType');
        this._sortMethodOptionsIfDeviceKnown(methodsSchema.options);
        const methodOptions = methodsSchema.options.map((option)=>{
            return Object.assign({}, option, (0, $3ddabee037f3f019$export$1681b06d00e0dc73)({
                authenticatorKey: this.isOV() ? (0, $4a07c2817278db15$export$a7895cc4b0944d1b).OV : (0, $4a07c2817278db15$export$a7895cc4b0944d1b).CUSTOM_APP,
                value: {
                    methodType: option.value
                }
            }));
        });
        return [
            {
                View: (0, $809978aa9aa4037d$export$2e2bcd8739ae039),
                options: {
                    name: methodsSchema.name,
                    collection: new (0, $5d64eb84267ab4e8$export$fb8073518f34e6ec)(methodOptions)
                }
            }
        ];
    },
    // If the `deviceKnown` attribute is true, we should put the signed_nonce method to the top of authenticator list.
    // This is in sync with v2/ion/ui-schema/ion-object-handler.js - createOVOptions
    _sortMethodOptionsIfDeviceKnown: function(methodOptions) {
        var _this$options, _this$options$current, _this$options$current2, _this$options$current3;
        // Check if the `deviceKnown` attribute is true
        const deviceKnown = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : (_this$options$current = _this$options.currentViewState) === null || _this$options$current === void 0 ? void 0 : (_this$options$current2 = _this$options$current.relatesTo) === null || _this$options$current2 === void 0 ? void 0 : (_this$options$current3 = _this$options$current2.value) === null || _this$options$current3 === void 0 ? void 0 : _this$options$current3.deviceKnown;
        if (deviceKnown) {
            const signedNonceIndex = methodOptions.findIndex((e)=>e.value === 'signed_nonce');
            if (signedNonceIndex > 0) {
                const signedNonceModel = methodOptions[signedNonceIndex];
                // Put the 'signed_nonce' option to the top of the list
                methodOptions.splice(signedNonceIndex, 1);
                methodOptions.unshift(signedNonceModel);
            }
        }
    },
    isOV: function() {
        return this.options.appState.get('authenticatorKey') === (0, $4a07c2817278db15$export$a7895cc4b0944d1b).OV;
    }
});


// Common view for OV push and custom app.
var $3eaa075b4d82258f$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    initialize: function() {
        (0, $21a17fd013ef567d$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        if (this.isPushOnlyWithAutoChallengeFlow()) this.Body = (0, $c02febce967191bd$export$2e2bcd8739ae039);
        else {
            this.Body = (0, $9eb996c9801443b3$export$2e2bcd8739ae039);
            this.Footer = (0, $31737d9aae112815$export$2e2bcd8739ae039);
        }
    },
    isPushOnlyWithAutoChallengeFlow: function() {
        const methodType = this.options.appState.getSchemaByName('authenticator.methodType');
        const hasAutoChallengeSchema = this.options.appState.getSchemaByName('authenticator.autoChallenge');
        const methodTypeOptions = methodType === null || methodType === void 0 ? void 0 : methodType.options;
        return hasAutoChallengeSchema && methodTypeOptions.length === 1 && methodTypeOptions[0].value === 'push';
    }
});






















parcelRequire("3ZxP0");








// for EA,
// redirect is needed for Apple SSO Extension to intercept the request, because
// - XHR request is not interceptable
// - form post is interceptable, but some app (Outlook) closes the app after
// We may have a different approach/UX for GA
const $6dd3ba6e45b46e48$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    noButtonBar: true,
    className: 'ion-form device-challenge-poll',
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('deviceTrust.sso.redirectText', 'login');
    },
    initialize: function() {
        var _this$options$current, _this$options$current2;
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        this.listenTo(this.model, 'error', ()=>{
            this.$('.spinner').hide();
        });
        this.add('<div class="credential-sso-extension"><div class="spinner"></div></div>');
        const isGetMethod = ((_this$options$current = this.options.currentViewState) === null || _this$options$current === void 0 ? void 0 : (_this$options$current2 = _this$options$current.method) === null || _this$options$current2 === void 0 ? void 0 : _this$options$current2.toLowerCase()) === 'get';
        this.model.set('useRedirect', isGetMethod);
        this.trigger('save', this.model);
    },
    showMessages: function(options) {
        if (options instanceof (0, $5d64eb84267ab4e8$export$27a5bd065ad55220)) {
            (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.showMessages.call(this, options);
            return;
        }
        if (this.options.appState.containsMessageWithI18nKey([
            (0, $5dcf8c5d7fe7c644$export$17cbe7ebed212941),
            (0, $5dcf8c5d7fe7c644$export$21ec211902d7e608),
            (0, $5dcf8c5d7fe7c644$export$c5d5df2b86b06bbc),
            (0, $5dcf8c5d7fe7c644$export$99760f0e4fa6d0a6)
        ])) {
            const messages = this.options.appState.get('messages');
            const biometricsOptions = (0, $cbe16f34ebe007b2$export$1d274422d455f5b9)(messages, true);
            if (!(0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(biometricsOptions)) options = (0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)(biometricsOptions);
        }
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.showMessages.call(this, options);
    },
    showCustomFormErrorCallout: function(error) {
        const options = (0, $cbe16f34ebe007b2$export$1d274422d455f5b9)(error, false);
        // If not biometrics error, just show the returned error message
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isEmpty(options)) return false;
        this.showMessages((0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)(options));
        return true;
    }
});
var $6dd3ba6e45b46e48$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $6dd3ba6e45b46e48$var$Body
});






























var $0073638f9a8af435$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'oie-enroll-google-authenticator-barcode',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "0": function(container, depth0, helpers, partials, data) {
            var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"google-authenticator-setup-info-title barcode-setup-title\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.google_authenticator.scanBarcode.title"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 83
                    },
                    "end": {
                        "line": 1,
                        "column": 163
                    }
                }
            })) + "</div><div class=\"qrcode-info-container\"><p class=\"google-authenticator-setup-info\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.google_authenticator.scanBarcode.description"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 247
                    },
                    "end": {
                        "line": 1,
                        "column": 333
                    }
                }
            })) + "</p><div class=\"qrcode-container\"><img class=\"qrcode\" src=" + alias3((helper = (helper = lookupProperty(helpers, "href") || (depth0 != null ? lookupProperty(depth0, "href") : depth0)) != null ? helper : alias2, typeof helper === "function" ? helper.call(alias1, {
                "name": "href",
                "hash": {},
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 391
                    },
                    "end": {
                        "line": 1,
                        "column": 399
                    }
                }
            }) : helper)) + " alt=\"qr code\"></img><a href=\"#\" class=\"cannot-scan-link\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.google_authenticator.scanBarcode.cannotScan"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 457
                    },
                    "end": {
                        "line": 1,
                        "column": 542
                    }
                }
            })) + "</a></div></div>";
        },
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "href") : depth0, {
                "name": "if",
                "hash": {},
                "fn": container.program(0, data, 0),
                "inverse": container.noop,
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 0
                    },
                    "end": {
                        "line": 1,
                        "column": 565
                    }
                }
            })) != null ? stack1 : "";
        },
        "useData": true
    }),
    getTemplateData: function() {
        var _contextualData$qrcod;
        const contextualData = this.options.appState.get('currentAuthenticator').contextualData;
        return {
            href: (_contextualData$qrcod = contextualData.qrcode) === null || _contextualData$qrcod === void 0 ? void 0 : _contextualData$qrcod.href
        };
    },
    events: {
        'click .cannot-scan-link': function(e) {
            e.preventDefault();
            this.options.model.set('viewToDisplay', 'manual');
        }
    }
});












var $f28a9d3bd4ba4a88$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'oie-enroll-google-authenticator-manual-setup',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            var alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                return undefined;
            };
            return "<div class=\"google-authenticator-setup-info-title manual-setup-title\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.google_authenticator.cannotScanBarcode.title"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 70
                    },
                    "end": {
                        "line": 1,
                        "column": 156
                    }
                }
            })) + "</div><p class=\"google-authenticator-setup-info\">" + alias3((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || alias2).call(alias1, {
                "name": "i18n",
                "hash": {
                    "bundle": "login",
                    "code": "oie.enroll.google_authenticator.manualSetupInstructions"
                },
                "data": data,
                "loc": {
                    "start": {
                        "line": 1,
                        "column": 205
                    },
                    "end": {
                        "line": 1,
                        "column": 291
                    }
                }
            })) + "</p>";
        },
        "useData": true
    })
});


const $5229ae4c20a3ea6e$var$VIEW_TO_DISPLAY = 'viewToDisplay';
const $5229ae4c20a3ea6e$var$viewToDisplayState = {
    BARCODE: 'barcode',
    MANUAL: 'manual',
    ENTER_CODE: 'enterCode'
};
const $5229ae4c20a3ea6e$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.google_authenticator.setup.title', 'login');
    },
    noButtonBar: true,
    className: 'oie-enroll-google-authenticator',
    enterCodeSubtitle: (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
        template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
            "compiler": [
                8,
                ">= 4.3.0"
            ],
            "main": function(container, depth0, helpers, partials, data) {
                var lookupProperty = container.lookupProperty || function(parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                    return undefined;
                };
                return "<div class=\"google-authenticator-setup-info-title enter-code-title\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, {
                    "name": "i18n",
                    "hash": {
                        "bundle": "login",
                        "code": "oie.enroll.google_authenticator.enterCode.title"
                    },
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 68
                        },
                        "end": {
                            "line": 1,
                            "column": 146
                        }
                    }
                })) + "</div>";
            },
            "useData": true
        })
    }),
    getUISchema: function() {
        const schema = (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.getUISchema.apply(this, arguments);
        // https://oktainc.atlassian.net/browse/OKTA-555191
        const nextButton = (0, $34fae8eb13c47425$export$4364fcc20473fc30)({
            className: 'google-authenticator-next',
            title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oform.next', 'login'),
            click: ()=>{
                this.model.set($5229ae4c20a3ea6e$var$VIEW_TO_DISPLAY, $5229ae4c20a3ea6e$var$viewToDisplayState.ENTER_CODE);
            }
        });
        const verifyButton = (0, $34fae8eb13c47425$export$4364fcc20473fc30)({
            className: 'google-authenticator-verify',
            title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oform.verify', 'login'),
            click: ()=>{
                this.$el.submit();
            }
        });
        schema[0].showWhen = {
            viewToDisplay: $5229ae4c20a3ea6e$var$viewToDisplayState.ENTER_CODE
        };
        // Add Enter Code Subtitle
        schema.unshift({
            View: this.enterCodeSubtitle,
            selector: '.o-form-fieldset-container',
            showWhen: {
                viewToDisplay: $5229ae4c20a3ea6e$var$viewToDisplayState.ENTER_CODE
            }
        });
        schema.push({
            View: (0, $0073638f9a8af435$export$2e2bcd8739ae039),
            selector: '.o-form-fieldset-container',
            showWhen: {
                viewToDisplay: $5229ae4c20a3ea6e$var$viewToDisplayState.BARCODE
            }
        }, {
            View: (0, $f28a9d3bd4ba4a88$export$2e2bcd8739ae039),
            selector: '.o-form-fieldset-container',
            showWhen: {
                viewToDisplay: $5229ae4c20a3ea6e$var$viewToDisplayState.MANUAL
            }
        }, {
            View: (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
                className: 'o-form-fieldset o-form-label-top',
                // Render the secret as plain, selectable text (not a readonly input, which
                // looked disabled and let a double-click selection spill into the Next
                // button). Keeping it a single contiguous string lets a double-click select
                // the whole value; letter-spacing (see SCSS) provides the visual spacing.
                // tabindex="0" keeps the secret in the tab order (as the previous readonly
                // input was), and the aria-label spells out each character so screen readers
                // announce the code one letter at a time on focus.
                // https://oktainc.atlassian.net/browse/OKTA-1185578
                template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                    "compiler": [
                        8,
                        ">= 4.3.0"
                    ],
                    "main": function(container, depth0, helpers, partials, data) {
                        var helper, alias1 = depth0 != null ? depth0 : container.nullContext || {}, alias2 = container.hooks.helperMissing, alias3 = "function", alias4 = container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                            return undefined;
                        };
                        return "<div class=\"o-form-input\"><span class=\"shared-secret no-translate\" tabindex=\"0\" aria-label=\"" + alias4((helper = (helper = lookupProperty(helpers, "sharedSecretAriaLabel") || (depth0 != null ? lookupProperty(depth0, "sharedSecretAriaLabel") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                            "name": "sharedSecretAriaLabel",
                            "hash": {},
                            "data": data,
                            "loc": {
                                "start": {
                                    "line": 1,
                                    "column": 92
                                },
                                "end": {
                                    "line": 1,
                                    "column": 117
                                }
                            }
                        }) : helper)) + "\" >" + alias4((helper = (helper = lookupProperty(helpers, "sharedSecret") || (depth0 != null ? lookupProperty(depth0, "sharedSecret") : depth0)) != null ? helper : alias2, typeof helper === alias3 ? helper.call(alias1, {
                            "name": "sharedSecret",
                            "hash": {},
                            "data": data,
                            "loc": {
                                "start": {
                                    "line": 1,
                                    "column": 120
                                },
                                "end": {
                                    "line": 1,
                                    "column": 136
                                }
                            }
                        }) : helper)) + "</span></div>";
                    },
                    "useData": true
                }),
                getTemplateData: function() {
                    const sharedSecret = this.options.appState.get('currentAuthenticator').contextualData.sharedSecret || '';
                    return {
                        sharedSecret: sharedSecret,
                        sharedSecretAriaLabel: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.google_authenticator.sharedSecret.ariaLabel', 'login', [
                            sharedSecret.split('').join(' ')
                        ])
                    };
                }
            }),
            selector: '.o-form-fieldset-container',
            showWhen: {
                viewToDisplay: $5229ae4c20a3ea6e$var$viewToDisplayState.MANUAL
            }
        }, {
            View: nextButton,
            showWhen: {
                viewToDisplay: (val)=>val === $5229ae4c20a3ea6e$var$viewToDisplayState.BARCODE || val === $5229ae4c20a3ea6e$var$viewToDisplayState.MANUAL
            }
        }, {
            View: verifyButton,
            showWhen: {
                viewToDisplay: (val)=>val === $5229ae4c20a3ea6e$var$viewToDisplayState.ENTER_CODE
            }
        });
        return schema;
    }
});
var $5229ae4c20a3ea6e$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $5229ae4c20a3ea6e$var$Body,
    createModelClass: function() {
        const ModelClass = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).prototype.createModelClass.apply(this, arguments);
        const local = Object.assign({
            viewToDisplay: {
                value: 'barcode',
                type: 'string',
                required: true,
                values: [
                    $5229ae4c20a3ea6e$var$viewToDisplayState.BARCODE,
                    $5229ae4c20a3ea6e$var$viewToDisplayState.MANUAL,
                    $5229ae4c20a3ea6e$var$viewToDisplayState.ENTER_CODE
                ]
            }
        }, ModelClass.prototype.local);
        return ModelClass.extend({
            local: local
        });
    }
});





















parcelRequire("3ZxP0");







const $622d90951bfeb65e$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend(Object.assign({
    className: 'google-authenticator-challenge',
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.verify.google_authenticator.otp.title', 'login');
    },
    subtitle: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.verify.google_authenticator.otp.description', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.verify', 'login');
    }
}));
var $622d90951bfeb65e$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $622d90951bfeb65e$var$Body
});





















parcelRequire("3ZxP0");







const $d29d36cf9a31f36c$var$ON_PREM_TOKEN_CHANGE_KEY = 'errors.E0000113';
const $d29d36cf9a31f36c$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    className: 'on-prem-authenticator-enroll',
    modelEvents: {
        'error': '_checkTokenChange'
    },
    title: function() {
        const vendorName = this.options.appState.getAuthenticatorDisplayName() || (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.on_prem.authenticator.default.vendorName', 'login');
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.on_prem.enroll.title', 'login', [
            vendorName
        ]);
    },
    _checkTokenChange: function(model, convertedErrors) {
        var _convertedErrors$resp;
        const errorSummaryKeys = convertedErrors === null || convertedErrors === void 0 ? void 0 : (_convertedErrors$resp = convertedErrors.responseJSON) === null || _convertedErrors$resp === void 0 ? void 0 : _convertedErrors$resp.errorSummaryKeys;
        if (errorSummaryKeys && errorSummaryKeys.includes($d29d36cf9a31f36c$var$ON_PREM_TOKEN_CHANGE_KEY)) {
            // this means we are in change pin, so we should clear out answer input
            this.model.set('credentials.passcode', '');
            this.render();
        }
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.verify', 'login');
    }
});
var $d29d36cf9a31f36c$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $d29d36cf9a31f36c$var$Body
});





















parcelRequire("3ZxP0");







const $24062157acc84c9e$var$ON_PREM_TOKEN_CHANGE_KEY = 'errors.E0000113';
const $24062157acc84c9e$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    className: 'on-prem-authenticator-verify',
    modelEvents: {
        'error': '_checkTokenChange'
    },
    title: function() {
        const vendorName = this.options.appState.getAuthenticatorDisplayName() || (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.on_prem.authenticator.default.vendorName', 'login');
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.on_prem.verify.title', 'login', [
            vendorName
        ]);
    },
    _checkTokenChange: function(model, convertedErrors) {
        var _convertedErrors$resp;
        const errorSummaryKeys = convertedErrors === null || convertedErrors === void 0 ? void 0 : (_convertedErrors$resp = convertedErrors.responseJSON) === null || _convertedErrors$resp === void 0 ? void 0 : _convertedErrors$resp.errorSummaryKeys;
        if (errorSummaryKeys && errorSummaryKeys.includes($24062157acc84c9e$var$ON_PREM_TOKEN_CHANGE_KEY)) {
            // this means we are in change pin, so we should clear out answer input
            this.model.set('credentials.passcode', '');
            this.render();
        }
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.verify', 'login');
    }
});
var $24062157acc84c9e$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $24062157acc84c9e$var$Body
});
































parcelRequire("3ZxP0");






var $6fbb1d15d3523389$export$2e2bcd8739ae039 = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    noButtonBar: true,
    postRender: function() {
        const contextualData = this.getContextualData();
        // This is the place to check contextualData.integrationType once we support more types
        // Currently we only support IFRAME
        const duoFrame = this.add(`<iframe frameborder="0" title="'${this.title()}'"></iframe>`).last();
        try {
            (0, $d925b3b89d4ae911$export$2e2bcd8739ae039).init({
                host: contextualData.host,
                sig_request: contextualData.signedToken,
                // eslint-disable-line camelcase
                iframe: duoFrame.el,
                post_action: (signedData)=>{
                    // eslint-disable-line camelcase
                    this.model.set('credentials.signatureData', signedData);
                    this.saveForm(this.model);
                }
            });
        } catch (e) {
            duoFrame.remove();
            this.add((0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)({
                type: 'error',
                subtitle: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.duo.iFrameError', 'login')
            }), '.o-form-error-container'); // eslint-disable-line no-console
        }
    },
    getContextualData: function() {
    // to be overriden
    }
});



const $ec71a411d778d412$var$Body = (0, $6fbb1d15d3523389$export$2e2bcd8739ae039).extend({
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.duo.enroll.title', 'login');
    },
    getContextualData: function() {
        return this.options.appState.get('currentAuthenticator').contextualData;
    }
});
var $ec71a411d778d412$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $ec71a411d778d412$var$Body
});














const $ec341c4b71dcbc3d$var$Body = (0, $6fbb1d15d3523389$export$2e2bcd8739ae039).extend({
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.duo.verify.title', 'login');
    },
    getContextualData: function() {
        return this.options.appState.get('currentAuthenticatorEnrollment').contextualData;
    }
});
var $ec341c4b71dcbc3d$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $ec341c4b71dcbc3d$var$Body
});













const $b5ce6a61e407ab51$var$Body = (0, $b468c9e620d00bc4$export$61a3bb4da51d33da).extend({
    title: function() {
        const displayName = this.options.appState.getAuthenticatorDisplayName();
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.idp.challenge.title', 'login', [
            displayName
        ]);
    },
    subtitle: function() {
        const displayName = this.options.appState.getAuthenticatorDisplayName();
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.idp.challenge.description', 'login', [
            displayName
        ]);
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.verify', 'login');
    }
});
var $b5ce6a61e407ab51$export$2e2bcd8739ae039 = (0, $b468c9e620d00bc4$export$4f0801ac3c4745b).extend({
    Body: $b5ce6a61e407ab51$var$Body
});













const $da65ff8be5447f9f$var$Body = (0, $b468c9e620d00bc4$export$61a3bb4da51d33da).extend({
    title: function() {
        const displayName = this.options.appState.getAuthenticatorDisplayName();
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.idp.enroll.title', 'login', [
            displayName
        ]);
    },
    subtitle: function() {
        const displayName = this.options.appState.getAuthenticatorDisplayName();
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.idp.enroll.description', 'login', [
            displayName
        ]);
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.enroll', 'login');
    }
});
var $da65ff8be5447f9f$export$2e2bcd8739ae039 = (0, $b468c9e620d00bc4$export$4f0801ac3c4745b).extend({
    Body: $da65ff8be5447f9f$var$Body
});





















parcelRequire("3ZxP0");







const $ddd9b78a9c50c37f$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend(Object.assign({
    className: 'mfa-verify-custom-otp',
    title: function() {
        const vendorName = this.options.appState.getAuthenticatorDisplayName() || (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.custom_otp.authenticator.default.vendorName', 'login');
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.verify.custom_otp.title', 'login', [
            vendorName
        ]);
    },
    subtitle: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.verify.custom_otp.description', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.verify', 'login');
    }
}));
var $ddd9b78a9c50c37f$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $ddd9b78a9c50c37f$var$Body
});














const $39391e35d7a805b8$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    title: function() {
        const displayName = this.options.appState.getAuthenticatorDisplayName();
        return this.options.appState.isAuthenticatorChallenge() ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.symantecVip.challenge.title', 'login', [
            displayName
        ]) : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.symantecVip.enroll.title', 'login', [
            displayName
        ]);
    },
    subtitle: function() {
        const displayName = this.options.appState.getAuthenticatorDisplayName();
        return this.options.appState.isAuthenticatorChallenge() ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.symantecVip.challenge.description', 'login', [
            displayName
        ]) : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.symantecVip.enroll.description', 'login', [
            displayName
        ]);
    },
    save: function() {
        return this.options.appState.isAuthenticatorChallenge() ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.verify', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.enroll', 'login');
    }
});
var $39391e35d7a805b8$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $39391e35d7a805b8$var$Body
});





















parcelRequire("3ZxP0");






const $4bb3929acceca383$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('device.code.activate.title', 'login');
    },
    subtitle: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('device.code.activate.subtitle', 'login');
    },
    events: {
        'keyup input[name="userCode"]': function(e) {
            e.preventDefault();
            this.addHyphen(e);
        }
    },
    addHyphen: function(evt) {
        const currentVal = evt.target.value;
        // add hyphen after 4th character
        if (currentVal && currentVal.length === 4 && ![
            'Backspace',
            'Delete',
            '-'
        ].includes(evt.key)) evt.target.value = currentVal.concat('-');
    }
});
var $4bb3929acceca383$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    Body: $4bb3929acceca383$var$Body
});





















parcelRequire("3ZxP0");


























parcelRequire("3ZxP0");







var $dde73aa035a17dc8$export$2e2bcd8739ae039 = (0, $4c0f78fce7387c76$export$2e2bcd8739ae039).extend({
    HeaderBeacon: (0, $742766a1bf993738$export$2e2bcd8739ae039).extend({
        getBeaconClassName: function() {
            return 'smartcard';
        }
    })
});


const $40ab12b3d983ea36$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    className: 'piv-cac-card',
    modelEvents: {
        request: 'startAuthentication',
        error: 'stopAuthentication'
    },
    initialize: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        this.model.set('useRedirect', true);
        this.addInstructions();
    },
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('piv.cac.title', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('retry', 'login');
    },
    addInstructions: function() {
        this.add(`<div class='piv-verify-text'>
        <p>${(0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('piv.cac.card.insert', 'login')}</p>
        <div data-se='piv-waiting' class='okta-waiting-spinner'></div>
      </div>`);
    },
    startAuthentication: function() {
        this.$('.okta-waiting-spinner').show();
        this.$('.o-form-button-bar').hide();
    },
    stopAuthentication: function() {
        this.$('.okta-waiting-spinner').hide();
        this.$('.o-form-button-bar').show();
    }
});
var $40ab12b3d983ea36$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Header: (0, $dde73aa035a17dc8$export$2e2bcd8739ae039),
    Body: $40ab12b3d983ea36$var$Body,
    postRender: function() {
        (0, $21a17fd013ef567d$export$2e2bcd8739ae039).prototype.postRender.apply(this, arguments);
        const messages = this.options.appState.get('messages') || {};
        // if piv view has errors, show errors and stop authentication.
        // otherwise trigger authentication on page load
        if (Array.isArray(messages.value)) this.form.stopAuthentication();
        else {
            this.form.startAuthentication();
            this.form.trigger('save', this.model);
        }
    }
});














const $6ea9c7c74d874f48$var$ExampleView = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            return "<div aria-hidden=\"true\" class=\"yubikey-demo\"></div>";
        },
        "useData": true
    })
});
const $6ea9c7c74d874f48$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    title: function() {
        return this.options.appState.isAuthenticatorChallenge() ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.yubikey.challenge.title', 'login') : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.yubikey.enroll.title', 'login');
    },
    subtitle: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.yubikey.description', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.verify', 'login');
    },
    getUISchema: function() {
        const schema = (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.getUISchema.apply(this, arguments);
        schema.unshift({
            View: $6ea9c7c74d874f48$var$ExampleView,
            selector: '.o-form-fieldset-container'
        });
        return schema;
    }
});
var $6ea9c7c74d874f48$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $6ea9c7c74d874f48$var$Body
});






















parcelRequire("3ZxP0");







const $77d4d51509af4f39$var$CUSTOM_APP_UV_ENABLE_BIOMETRIC_SERVER_KEY = 'oie.authenticator.custom_app.method.push.verify.enable.biometrics';
const $77d4d51509af4f39$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend(Object.assign({
    className: 'custom-app-verify-resend-push',
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.verify.custom_app.title', 'login', [
            this.options.appState.getAuthenticatorDisplayName()
        ]);
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.custom_app.push.resend', 'login');
    },
    showMessages: function() {
        let options = {};
        if (this.options.appState.containsMessageWithI18nKey($77d4d51509af4f39$var$CUSTOM_APP_UV_ENABLE_BIOMETRIC_SERVER_KEY)) {
            // add a title, subtitle, and bullet-points for 
            // Custom App enable biometrics message during verification
            options.content = null;
            options.className = 'okta-verify-uv-callout-content';
            options.title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.custom_app.method.push.verify.enable.biometrics.title', 'login', [
                this.options.appState.getAuthenticatorDisplayName()
            ]);
            options.subtitle = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.custom_app.method.push.verify.enable.biometrics.description', 'login');
            options.type = 'error';
            options.bullets = [
                (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.custom_app.method.push.verify.enable.biometrics.point1', 'login'),
                (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.custom_app.method.push.verify.enable.biometrics.point2', 'login', [
                    this.options.appState.getAuthenticatorDisplayName()
                ]),
                (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.authenticator.custom_app.method.push.verify.enable.biometrics.point3', 'login', [
                    this.options.appState.getAuthenticatorDisplayName()
                ])
            ];
            options = (0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)(options);
        }
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.showMessages.call(this, options);
    }
}));
var $77d4d51509af4f39$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $77d4d51509af4f39$var$Body
});





















parcelRequire("3ZxP0");







const $4016f19c0907d6c2$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expired.title.generic', 'login');
    },
    subtitle: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expired.custom.subtitle', 'login');
    },
    noSubmitButton: true,
    initialize: function() {
        const { customExpiredPasswordName: customExpiredPasswordName, customExpiredPasswordURL: customExpiredPasswordURL } = this.options.currentViewState;
        this.add((0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
            className: 'button button-primary button-wide',
            title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'password.expired.custom.submit', 'login', [
                customExpiredPasswordName
            ]),
            click: ()=>{
                (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).redirect(customExpiredPasswordURL);
            }
        }));
    }
});
var $4016f19c0907d6c2$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    Body: $4016f19c0907d6c2$var$Body
});





















parcelRequire("3ZxP0");







const $8781e6dc25fc36fc$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    className: 'password-authenticator',
    subtitle: function() {
        return this.settings.get('brandName') ? (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expiring.soon.subtitle.specific', 'login', [
            this.settings.get('brandName')
        ]) : (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expiring.soon.subtitle.generic', 'login');
    },
    title: function() {
        var _this$options$appStat;
        const passwordPolicy = (_this$options$appStat = this.options.appState.get('currentAuthenticator')) === null || _this$options$appStat === void 0 ? void 0 : _this$options$appStat.settings;
        const daysToExpiry = passwordPolicy.daysToExpiry;
        if (daysToExpiry > 0) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expiring.title', 'login', [
            daysToExpiry
        ]);
        else if (daysToExpiry === 0) return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expiring.today', 'login');
        else return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expiring.soon', 'login');
    },
    noSubmitButton: true,
    initialize: function() {
        const { customExpiredPasswordName: customExpiredPasswordName, customExpiredPasswordURL: customExpiredPasswordURL } = this.options.currentViewState;
        this.add((0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
            className: 'button button-primary button-wide',
            title: (0, $3e490973b7383cc4$export$2e2bcd8739ae039).partial((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff), 'password.expired.custom.submit', 'login', [
                customExpiredPasswordName
            ]),
            click: ()=>{
                (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).redirect(customExpiredPasswordURL);
            }
        }));
    }
});
const $8781e6dc25fc36fc$var$Footer = (0, $31737d9aae112815$export$2e2bcd8739ae039).extend({
    links: function() {
        const links = [];
        if (this.options.appState.hasRemediationObject('skip')) links.push({
            'type': 'link',
            'label': (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('password.expiring.later', 'login'),
            'name': 'skip',
            'actionPath': 'skip'
        });
        return links;
    }
});
var $8781e6dc25fc36fc$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    Body: $8781e6dc25fc36fc$var$Body,
    Footer: $8781e6dc25fc36fc$var$Footer
});





















parcelRequire("3ZxP0");







const $b26216f46f7b4a46$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend(Object.assign({
    className: 'tac-authenticator-challenge',
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.verify.tac.title', 'login');
    },
    subtitle: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.verify.tac.description', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.verify', 'login');
    }
}));
var $b26216f46f7b4a46$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $b26216f46f7b4a46$var$Body
});





















parcelRequire("3ZxP0");









/**
 * Shown when NFC card scan is needed.
 * Matches FastPass CUSTOM_URI behavior: auto-launches OV, shows "Click Open Okta Verify" screen.
 */ const $91b0513857ebe87e$var$DeviceChallengeBody = (0, $39d1dd94b85d250f$export$2e2bcd8739ae039).extend({
    getDeviceChallengePayload: function() {
        var _authenticator$contex, _authenticator$contex2;
        const authenticator = this.options.appState.get('currentAuthenticatorEnrollment') || this.options.appState.get('currentAuthenticator');
        return (authenticator === null || authenticator === void 0 ? void 0 : (_authenticator$contex = authenticator.contextualData) === null || _authenticator$contex === void 0 ? void 0 : (_authenticator$contex2 = _authenticator$contex.challenge) === null || _authenticator$contex2 === void 0 ? void 0 : _authenticator$contex2.value) || {};
    },
    doChallenge: function() {
        (0, $cbe16f34ebe007b2$export$f7c4f163a089df21)(this);
    }
});
/**
 * Shown after NFC card is verified — user enters their PIN.
 */ const $91b0513857ebe87e$var$PinEntryBody = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    className: 'nfc-pin-challenge',
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.nfc_pin.verify.title', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('mfa.challenge.verify', 'login');
    },
    getUISchema: function() {
        const uiSchemas = (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.getUISchema.apply(this, arguments);
        return uiSchemas.map(function(field) {
            if (field.name === 'credentials.passcode') return Object.assign({}, field, {
                label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.nfc_pin.verify.pinLabel', 'login')
            });
            return field;
        });
    }
});
const $91b0513857ebe87e$var$DeviceChallengeFooter = (0, $31737d9aae112815$export$2e2bcd8739ae039).extend({
    links: function() {
        return (0, $aaa5b7e3293b6284$export$e6f8c91470651ac8)(this.options.appState);
    }
});
const $91b0513857ebe87e$var$PinEntryFooter = (0, $31737d9aae112815$export$2e2bcd8739ae039).extend({
    links: function() {
        var _this$options$appStat, _this$options$appStat2;
        const links = [];
        const hasEnrollmentRecover = !!((_this$options$appStat = this.options.appState.get('currentAuthenticatorEnrollment')) !== null && _this$options$appStat !== void 0 && _this$options$appStat.recover);
        const hasAuthenticatorRecover = !!((_this$options$appStat2 = this.options.appState.get('currentAuthenticator')) !== null && _this$options$appStat2 !== void 0 && _this$options$appStat2.recover);
        if (hasEnrollmentRecover || hasAuthenticatorRecover) links.push({
            type: 'link',
            label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.nfc_pin.forgot.pin', 'login'),
            name: 'forgot-pin',
            actionPath: hasEnrollmentRecover ? 'currentAuthenticatorEnrollment-recover' : 'currentAuthenticator-recover'
        });
        return links.concat((0, $aaa5b7e3293b6284$export$574d56f9df8b837)(this.options.appState, this.options.settings)).concat((0, $aaa5b7e3293b6284$export$e6f8c91470651ac8)(this.options.appState));
    }
});
var $91b0513857ebe87e$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    initialize: function() {
        var _authenticator$contex3;
        (0, $21a17fd013ef567d$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        const appState = this.options.appState;
        const authenticator = appState.get('currentAuthenticatorEnrollment') || appState.get('currentAuthenticator');
        if (authenticator !== null && authenticator !== void 0 && (_authenticator$contex3 = authenticator.contextualData) !== null && _authenticator$contex3 !== void 0 && _authenticator$contex3.challenge) {
            this.Body = $91b0513857ebe87e$var$DeviceChallengeBody;
            this.Footer = $91b0513857ebe87e$var$DeviceChallengeFooter;
        } else {
            this.Body = $91b0513857ebe87e$var$PinEntryBody;
            this.Footer = $91b0513857ebe87e$var$PinEntryFooter;
        }
    }
});






















parcelRequire("3ZxP0");









const $bdd927747f1716f2$var$Body = (0, $39d1dd94b85d250f$export$2e2bcd8739ae039).extend({
    getDeviceChallengePayload: function() {
        var _this$options$current, _this$options$current2, _this$options$current3, _this$options$current4;
        return ((_this$options$current = this.options.currentViewState.relatesTo) === null || _this$options$current === void 0 ? void 0 : (_this$options$current2 = _this$options$current.value) === null || _this$options$current2 === void 0 ? void 0 : (_this$options$current3 = _this$options$current2.contextualData) === null || _this$options$current3 === void 0 ? void 0 : (_this$options$current4 = _this$options$current3.challenge) === null || _this$options$current4 === void 0 ? void 0 : _this$options$current4.value) || {};
    },
    doChallenge: function() {
        var _this$options$setting;
        const deviceChallenge = this.getDeviceChallengePayload();
        const loginHint = (_this$options$setting = this.options.settings) === null || _this$options$setting === void 0 ? void 0 : _this$options$setting.get('identifier');
        if (deviceChallenge.challengeMethod === (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).LOOPBACK_CHALLENGE) {
            this.doLoopback(deviceChallenge);
            return;
        }
        // NFC-specific intermediate screen
        this.title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.nfc_pin.challenge.verify.title', 'login');
        this.add((0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
            className: 'skinny-content',
            template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                "compiler": [
                    8,
                    ">= 4.3.0"
                ],
                "main": function(container, depth0, helpers, partials, data) {
                    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                        return undefined;
                    };
                    return "<p>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "description") || (depth0 != null ? lookupProperty(depth0, "description") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                        "name": "description",
                        "hash": {},
                        "data": data,
                        "loc": {
                            "start": {
                                "line": 1,
                                "column": 3
                            },
                            "end": {
                                "line": 1,
                                "column": 18
                            }
                        }
                    }) : helper)) + "</p>";
                },
                "useData": true
            }),
            getTemplateData: ()=>({
                    description: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.nfc_pin.challenge.verify.description', 'login')
                })
        }));
        // "Open Okta Verify" button as manual fallback
        this.add((0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
            className: 'ul-button button button-wide button-primary',
            title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oktaVerify.open.button', 'login'),
            id: 'launch-ov',
            click: ()=>{
                this.doCustomURI();
            }
        }));
        // Launch CUS silently
        if (deviceChallenge.href) {
            this.customURI = (0, $cbe16f34ebe007b2$export$bd982dadfebec6e1)(deviceChallenge.href, loginHint);
            this.doCustomURI();
        }
    }
});
const $bdd927747f1716f2$var$Footer = (0, $31737d9aae112815$export$2e2bcd8739ae039).extend({
    links: function() {
        return (0, $aaa5b7e3293b6284$export$e6f8c91470651ac8)(this.options.appState);
    }
});
var $bdd927747f1716f2$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $bdd927747f1716f2$var$Body,
    Footer: $bdd927747f1716f2$var$Footer
});






















parcelRequire("3ZxP0");




















const $b23a0bacbe84c20a$export$86e75d7aa3ee817c = function(form, rulesList, prepend) {
    form.add((0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
        tagName: 'section',
        template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
            "0": function(container, depth0, helpers, partials, data) {
                return "<li>" + container.escapeExpression(container.lambda(depth0, depth0)) + "</li>";
            },
            "compiler": [
                8,
                ">= 4.3.0"
            ],
            "main": function(container, depth0, helpers, partials, data) {
                var stack1, alias1 = depth0 != null ? depth0 : container.nullContext || {}, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                    return undefined;
                };
                return "<div class=\"password-authenticator--heading\">" + container.escapeExpression((lookupProperty(helpers, "i18n") || depth0 && lookupProperty(depth0, "i18n") || container.hooks.helperMissing).call(alias1, {
                    "name": "i18n",
                    "hash": {
                        "bundle": "login",
                        "code": "oie.enroll.nfc_pin.create.requirements.header"
                    },
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 45
                        },
                        "end": {
                            "line": 1,
                            "column": 121
                        }
                    }
                })) + "</div><ul class=\"password-authenticator--list\">" + ((stack1 = lookupProperty(helpers, "each").call(alias1, depth0 != null ? lookupProperty(depth0, "rulesList") : depth0, {
                    "name": "each",
                    "hash": {},
                    "fn": container.program(0, data, 0),
                    "inverse": container.noop,
                    "data": data,
                    "loc": {
                        "start": {
                            "line": 1,
                            "column": 168
                        },
                        "end": {
                            "line": 1,
                            "column": 213
                        }
                    }
                })) != null ? stack1 : "") + "</ul>";
            },
            "useData": true
        }),
        getTemplateData: ()=>({
                rulesList: rulesList
            }),
        attributes: {
            'data-se': 'password-authenticator--rules'
        }
    }), {
        prepend: prepend,
        selector: '.o-form-fieldset-container'
    });
};


/**
 * Phase 1: Device challenge — launches OV via setupNfcUrl, polls
 */ const $693a6c4ee89e3583$var$DeviceChallengeBody = (0, $39d1dd94b85d250f$export$2e2bcd8739ae039).extend({
    pollingCancelAction: (0, $5dcf8c5d7fe7c644$export$1bcaad93666b7579),
    getDeviceChallengePayload: function() {
        var _authenticator$contex, _authenticator$contex2, _authenticator$contex3;
        const authenticator = this.options.appState.get('currentAuthenticator') || this.options.appState.get('currentAuthenticatorEnrollment');
        const setupNfcUrl = authenticator === null || authenticator === void 0 ? void 0 : (_authenticator$contex = authenticator.contextualData) === null || _authenticator$contex === void 0 ? void 0 : _authenticator$contex.setupNfcUrl;
        if (setupNfcUrl) return {
            challengeMethod: (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).CUSTOM_URI_CHALLENGE,
            href: setupNfcUrl
        };
        return (authenticator === null || authenticator === void 0 ? void 0 : (_authenticator$contex2 = authenticator.contextualData) === null || _authenticator$contex2 === void 0 ? void 0 : (_authenticator$contex3 = _authenticator$contex2.challenge) === null || _authenticator$contex3 === void 0 ? void 0 : _authenticator$contex3.value) || {};
    },
    doChallenge: function() {
        (0, $cbe16f34ebe007b2$export$f7c4f163a089df21)(this);
    }
});
/**
 * Phase 2: PIN creation — same pattern as EnrollAuthenticatorPasswordView
 */ const $693a6c4ee89e3583$var$PinCreateBody = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    className: 'nfc-pin-create',
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.nfc_pin.create.title', 'login');
    },
    subtitle: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.nfc_pin.create.description', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oform.next', 'login');
    },
    initialize: function() {
        var _this$options$current, _this$options$current2, _this$options$current3, _this$options$appStat;
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        // Show PIN requirements (minLength from settings)
        const settings = ((_this$options$current = this.options.currentViewState) === null || _this$options$current === void 0 ? void 0 : (_this$options$current2 = _this$options$current.relatesTo) === null || _this$options$current2 === void 0 ? void 0 : (_this$options$current3 = _this$options$current2.value) === null || _this$options$current3 === void 0 ? void 0 : _this$options$current3.settings) || ((_this$options$appStat = this.options.appState.get('enrollmentAuthenticator')) === null || _this$options$appStat === void 0 ? void 0 : _this$options$appStat.settings);
        if (settings !== null && settings !== void 0 && settings.minLength) {
            const rulesList = [
                (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.nfc_pin.create.requirement.length', 'login', [
                    settings.minLength
                ])
            ];
            (0, $b23a0bacbe84c20a$export$86e75d7aa3ee817c)(this, rulesList, true);
        }
    },
    getUISchema: function() {
        const uiSchemas = (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.getUISchema.apply(this, arguments);
        const confirmPin = {
            name: 'confirmPassword',
            label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.nfc_pin.create.confirmPinLabel', 'login'),
            type: 'password',
            'label-top': true,
            params: {
                showPasswordToggle: this.settings.get('showPasswordToggle')
            }
        };
        const updatedSchema = [];
        for (let field of uiSchemas)// Rename the passcode field label
        if (field.name === 'credentials.passcode') {
            updatedSchema.push(Object.assign({}, field, {
                label: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.nfc_pin.create.pinLabel', 'login')
            }));
            updatedSchema.push(confirmPin);
        } else updatedSchema.push(field);
        return updatedSchema;
    }
});
const $693a6c4ee89e3583$var$DeviceChallengeFooter = (0, $31737d9aae112815$export$2e2bcd8739ae039).extend({
    links: function() {
        return (0, $aaa5b7e3293b6284$export$e6f8c91470651ac8)(this.options.appState);
    }
});
const $693a6c4ee89e3583$var$DefaultFooter = (0, $31737d9aae112815$export$2e2bcd8739ae039).extend({
    links: function() {
        return (0, $aaa5b7e3293b6284$export$574d56f9df8b837)(this.options.appState, this.options.settings).concat((0, $aaa5b7e3293b6284$export$e6f8c91470651ac8)(this.options.appState));
    }
});
/**
 * NFC PIN enrollment view — routes to the correct phase based on IDX response,
 * same as v3's transformNfcPinEnroll router.
 */ var $693a6c4ee89e3583$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    createModelClass: function() {
        var _this$options$current4, _this$options$current5, _this$options$current6, _this$options$appStat2;
        const ModelClass = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).prototype.createModelClass.apply(this, arguments);
        // Capture PIN settings (minLength/maxLength) in closure for use in validate()
        const pinSettings = ((_this$options$current4 = this.options.currentViewState) === null || _this$options$current4 === void 0 ? void 0 : (_this$options$current5 = _this$options$current4.relatesTo) === null || _this$options$current5 === void 0 ? void 0 : (_this$options$current6 = _this$options$current5.value) === null || _this$options$current6 === void 0 ? void 0 : _this$options$current6.settings) || ((_this$options$appStat2 = this.options.appState.get('enrollmentAuthenticator')) === null || _this$options$appStat2 === void 0 ? void 0 : _this$options$appStat2.settings) || {};
        const pinLength = pinSettings.minLength || pinSettings.maxLength || 0;
        const local = Object.assign({
            confirmPassword: {
                type: 'string',
                required: true
            }
        }, ModelClass.prototype.local);
        return ModelClass.extend({
            local: local,
            validate: function() {
                const pin = this.get('credentials.passcode');
                const confirmPin = this.get('confirmPassword');
                const errors = {};
                // Validate exact PIN length
                if (pin && pinLength > 0 && pin.length !== pinLength) errors['credentials.passcode'] = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.nfc_pin.create.requirement.length', 'login', [
                    pinLength
                ]);
                // Validate numeric only
                if (pin && !/^\d+$/.test(pin)) errors['credentials.passcode'] = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.nfc_pin.create.error.numeric', 'login');
                // Validate PINs match
                if (pin && confirmPin && pin !== confirmPin) errors['confirmPassword'] = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.nfc_pin.create.error.match', 'login');
                return Object.keys(errors).length ? errors : null;
            }
        });
    },
    initialize: function() {
        (0, $21a17fd013ef567d$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        const currentViewState = this.options.currentViewState;
        const uiSchema = (currentViewState === null || currentViewState === void 0 ? void 0 : currentViewState.uiSchema) || [];
        const hasPinField = uiSchema.some(function(field) {
            return field.name === 'credentials.passcode';
        });
        if (hasPinField) {
            // Phase 2: PIN creation
            this.Body = $693a6c4ee89e3583$var$PinCreateBody;
            this.Footer = $693a6c4ee89e3583$var$DefaultFooter;
        } else {
            // Phase 1: Device challenge — go directly, no setup instructions screen
            this.Body = $693a6c4ee89e3583$var$DeviceChallengeBody;
            this.Footer = $693a6c4ee89e3583$var$DeviceChallengeFooter;
        }
    }
});






















parcelRequire("3ZxP0");









const $92577f1a8c3b0379$var$Body = (0, $39d1dd94b85d250f$export$2e2bcd8739ae039).extend({
    pollingCancelAction: (0, $5dcf8c5d7fe7c644$export$1bcaad93666b7579),
    getDeviceChallengePayload: function() {
        var _this$options$appStat, _contextualData$chall;
        const contextualData = (_this$options$appStat = this.options.appState.get('currentAuthenticator')) === null || _this$options$appStat === void 0 ? void 0 : _this$options$appStat.contextualData;
        if (contextualData !== null && contextualData !== void 0 && contextualData.setupNfcUrl) return {
            challengeMethod: (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).CUSTOM_URI_CHALLENGE,
            href: contextualData.setupNfcUrl
        };
        return (contextualData === null || contextualData === void 0 ? void 0 : (_contextualData$chall = contextualData.challenge) === null || _contextualData$chall === void 0 ? void 0 : _contextualData$chall.value) || {};
    },
    doChallenge: function() {
        const deviceChallenge = this.getDeviceChallengePayload();
        // NFC-specific intermediate screen for enrollment
        this.title = (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.nfc_pin.title', 'login');
        this.add((0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
            className: 'skinny-content',
            template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
                "compiler": [
                    8,
                    ">= 4.3.0"
                ],
                "main": function(container, depth0, helpers, partials, data) {
                    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
                        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return parent[propertyName];
                        return undefined;
                    };
                    return "<p>" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "description") || (depth0 != null ? lookupProperty(depth0, "description") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                        "name": "description",
                        "hash": {},
                        "data": data,
                        "loc": {
                            "start": {
                                "line": 1,
                                "column": 3
                            },
                            "end": {
                                "line": 1,
                                "column": 18
                            }
                        }
                    }) : helper)) + "</p>";
                },
                "useData": true
            }),
            getTemplateData: ()=>({
                    description: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.nfc_pin.instructions', 'login')
                })
        }));
        // "Open Okta Verify" button as manual fallback
        this.add((0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
            className: 'ul-button button button-wide button-primary',
            title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.enroll.nfc_pin.openOktaVerify', 'login'),
            id: 'launch-ov',
            click: ()=>{
                this.doCustomURI();
            }
        }));
        // Launch CUS silently
        if (deviceChallenge.href) {
            this.customURI = deviceChallenge.href;
            this.doCustomURI();
        }
    }
});
const $92577f1a8c3b0379$var$Footer = (0, $31737d9aae112815$export$2e2bcd8739ae039).extend({
    links: function() {
        return (0, $aaa5b7e3293b6284$export$e6f8c91470651ac8)(this.options.appState);
    }
});
var $92577f1a8c3b0379$export$2e2bcd8739ae039 = (0, $21a17fd013ef567d$export$2e2bcd8739ae039).extend({
    Body: $92577f1a8c3b0379$var$Body,
    Footer: $92577f1a8c3b0379$var$Footer
});






















parcelRequire("3ZxP0");






const $1ff5b8570bb8b1aa$var$SignInWithNfcOption = (0, $5d64eb84267ab4e8$export$27a5bd065ad55220).extend({
    className: 'sign-in-with-nfc-option',
    template: (0, $d30415a7ae055e38$export$2e2bcd8739ae039).template({
        "compiler": [
            8,
            ">= 4.3.0"
        ],
        "main": function(container, depth0, helpers, partials, data) {
            return "<div class=\"nfc-container\"><div class=\"signin-with-nfc-description\"></div></div>";
        },
        "useData": true
    }),
    initialize: function() {
        const appState = this.options.appState;
        this.add((0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
            className: 'button',
            title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.nfc_pin.launch.button', 'login'),
            click: function() {
                if (this.model.get('identifier')) this.options.settings.set('identifier', encodeURIComponent(this.model.get('identifier')));
                appState.trigger('invokeAction', (0, $4a07c2817278db15$export$657220afecfe252).LAUNCH_NFC_AUTHENTICATOR, {
                    'rememberMe': this.model.get('rememberMe')
                });
            }
        }), '.nfc-container');
    },
    postRender: function() {
        const descContainer = this.$el.find('.signin-with-nfc-description');
        descContainer.text((0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.nfc_pin.authenticator.description', 'login'));
    }
});
const $1ff5b8570bb8b1aa$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('primaryauth.title', 'login');
    },
    noButtonBar: true,
    initialize: function() {
        (0, $990ed38344fe8376$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        this.add($1ff5b8570bb8b1aa$var$SignInWithNfcOption, {
            selector: '.o-form-fieldset-container',
            bubble: false,
            prepend: true,
            options: {
                isRequired: true
            }
        });
    }
});
const $1ff5b8570bb8b1aa$var$Footer = (0, $f69e256d99f29568$export$2e2bcd8739ae039).extend({
    hasBackToSignInLink: false
});
var $1ff5b8570bb8b1aa$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    Body: $1ff5b8570bb8b1aa$var$Body,
    Footer: $1ff5b8570bb8b1aa$var$Footer
});





















parcelRequire("3ZxP0");






const $44ec6cdf8c47e0ee$var$Body = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    noSubmitButton: true,
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.kmsi.title', 'login');
    },
    subtitle: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.kmsi.subtitle', 'login');
    },
    saveForm: function(isKeepMeSignedIn) {
        this.model.set('keepMeSignedIn', isKeepMeSignedIn);
        this.options.appState.trigger('saveForm', this.model);
    },
    // Overrides the default getUISchema in order to render 2 buttons instead of a checkbox
    getUISchema: function() {
        const form = this;
        const acceptButton = (0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
            className: 'button button-secondary',
            title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.kmsi.accept', 'login'),
            attributes: {
                'data-se': 'stay-signed-in-btn'
            },
            click: function() {
                form.saveForm(true);
            }
        });
        const rejectButton = (0, $5d64eb84267ab4e8$export$9b6d6ca62970729f)({
            className: 'button button-secondary',
            title: (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('oie.kmsi.reject', 'login'),
            attributes: {
                'data-se': 'do-not-stay-signed-in-btn'
            },
            click: function() {
                form.saveForm(false);
            }
        });
        return [
            {
                View: acceptButton
            },
            {
                View: rejectButton
            }
        ];
    }
});
var $44ec6cdf8c47e0ee$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    Body: $44ec6cdf8c47e0ee$var$Body
});





















parcelRequire("3ZxP0");






const $aa1530942659c0ed$var$UnlockAccountView = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    title: ()=>{
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('account.unlock.title', 'login');
    }
});
var $aa1530942659c0ed$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    initialize: function() {
        (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        this.Body = $aa1530942659c0ed$var$UnlockAccountView;
    }
});





















parcelRequire("3ZxP0");







const $2bd7e702e649bd45$var$DeviceAssuranceGracePeriodView = (0, $990ed38344fe8376$export$2e2bcd8739ae039).extend({
    title: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('idx.device_assurance.grace_period.title', 'login');
    },
    save: function() {
        return (0, $5d64eb84267ab4e8$export$ebcbd32ce8d4cff)('idx.device_assurance.grace_period.continue_to_app', 'login');
    },
    showMessages: function() {
        const messages = this.options.appState.get('messages').value;
        const languageTags = this.settings.get('languageTags');
        if (messages) this.add((0, $5d64eb84267ab4e8$export$9c9c5fdbeb49ed7)({
            content: new (0, $128f9dcbe3cf8732$export$2e2bcd8739ae039)({
                messages: messages,
                languageTags: languageTags
            }),
            type: 'warning'
        }));
    }
});
var $2bd7e702e649bd45$export$2e2bcd8739ae039 = (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).extend({
    initialize: function() {
        (0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039).prototype.initialize.apply(this, arguments);
        this.Body = $2bd7e702e649bd45$var$DeviceAssuranceGracePeriodView;
    }
});


const $f922a4150da58580$var$DEFAULT = '_';
const $f922a4150da58580$var$VIEWS_MAPPING = {
    [(0, $4a07c2817278db15$export$657220afecfe252).IDENTIFY]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $f4e1246ab077b34b$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).IDENTIFY_RECOVERY]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $1e89397f5925e819$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).DEVICE_CHALLENGE_POLL]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $0570689af6703cd8$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).LAUNCH_AUTHENTICATOR]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $ae485660e043bac0$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).LAUNCH_NFC_AUTHENTICATOR]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $1ff5b8570bb8b1aa$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).DEVICE_APPLE_SSO_EXTENSION]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $fbe71fa98a792c9b$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).OV]: (0, $6dd3ba6e45b46e48$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).CANCEL_TRANSACTION]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $fbe71fa98a792c9b$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).ENROLL_PROFILE]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $f191d8261c883c0e$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).ENROLL_PROFILE_UPDATE]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $e9b34411d9ca2827$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).POLL]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $be01c51bf2a47eac$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).REQUEST_ACTIVATION]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $5f7d9f4a095c7c9d$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).SELECT_AUTHENTICATOR_ENROLL]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $0f6a1081fbb98031$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).AUTHENTICATOR_ENROLLMENT_DATA]: {
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).PHONE]: (0, $ef2f1d99c7654289$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).EMAIL]: (0, $1faea61eb85939c2$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).CONSENT_ADMIN]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $34bb96a8c398e760$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).CONSENT_ENDUSER]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $698e97ff7473bde3$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).CONSENT_GRANULAR]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $fa36da08e3523405$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).CONSENT_EMAIL_CHALLENGE]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $82e78d10f9c7182e$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).ENROLL_AUTHENTICATOR]: {
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).DUO]: (0, $ec71a411d778d412$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).EMAIL]: (0, $98ac4b7d5b9c74db$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).GOOGLE_OTP]: (0, $5229ae4c20a3ea6e$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).IDP]: (0, $da65ff8be5447f9f$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).ON_PREM]: (0, $d29d36cf9a31f36c$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).PASSWORD]: (0, $ae39d63fe9cc3295$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).PHONE]: (0, $c989c65117b4f26a$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).RSA]: (0, $d29d36cf9a31f36c$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).SECURITY_QUESTION]: (0, $fbc7665bf3288f91$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).SYMANTEC_VIP]: (0, $39391e35d7a805b8$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).WEBAUTHN]: (0, $a8de4608c0ee1d33$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).YUBIKEY]: (0, $6ea9c7c74d874f48$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).NFC_PIN]: (0, $693a6c4ee89e3583$export$2e2bcd8739ae039)
    },
    // enroll-authenticator-promotion reuses EnrollWebauthnView — same UI/behavior,
    // plus a Skip footer when the response includes a sibling `skip` remediation.
    [(0, $4a07c2817278db15$export$657220afecfe252).ENROLL_AUTHENTICATOR_PROMOTION]: {
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).WEBAUTHN]: (0, $a8de4608c0ee1d33$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).CHALLENGE_AUTHENTICATOR]: {
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).CUSTOM_OTP]: (0, $ddd9b78a9c50c37f$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).DUO]: (0, $ec341c4b71dcbc3d$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).EMAIL]: (0, $f5d8d2d9de2b0708$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).GOOGLE_OTP]: (0, $622d90951bfeb65e$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).IDP]: (0, $b5ce6a61e407ab51$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).ON_PREM]: (0, $24062157acc84c9e$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).OV]: (0, $2a2ec495e841bb06$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).PASSWORD]: (0, $a35806776871a49a$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).PHONE]: (0, $b18c21dbbff4405e$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).RSA]: (0, $24062157acc84c9e$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).SECURITY_QUESTION]: (0, $552eeec7325cc1eb$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).SYMANTEC_VIP]: (0, $39391e35d7a805b8$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).TAC]: (0, $b26216f46f7b4a46$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).NFC_PIN]: (0, $91b0513857ebe87e$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).WEBAUTHN]: (0, $1a9f36c52c75480d$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).YUBIKEY]: (0, $6ea9c7c74d874f48$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).ENROLL_POLL]: {
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).OV]: (0, $2771809d0b359020$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).NFC_PIN]: (0, $92577f1a8c3b0379$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).SELECT_ENROLLMENT_CHANNEL]: {
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).OV]: (0, $2e2ba33845c38248$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).ENROLLMENT_CHANNEL_DATA]: {
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).OV]: (0, $5ea673e0b14644b1$export$2e2bcd8739ae039)
    },
    // Expired scenarios for authenticators..
    [(0, $4a07c2817278db15$export$657220afecfe252).REENROLL_AUTHENTICATOR]: {
        // Password expired scenario..
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).PASSWORD]: (0, $537c8d8ac53ea3db$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).REENROLL_CUSTOM_PASSWORD_EXPIRY]: {
        // Custom password expired scenario
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).PASSWORD]: (0, $4016f19c0907d6c2$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).REENROLL_CUSTOM_PASSWORD_EXPIRY_WARNING]: {
        // Custom password expiry warning scenario
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).PASSWORD]: (0, $8781e6dc25fc36fc$export$2e2bcd8739ae039)
    },
    // Will expire soon warnings for authenticators..
    [(0, $4a07c2817278db15$export$657220afecfe252).REENROLL_AUTHENTICATOR_WARNING]: {
        // Password will expire soon scenario..
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).PASSWORD]: (0, $950f7264bd90a5db$export$2e2bcd8739ae039)
    },
    // Reset forms for authenticators..
    [(0, $4a07c2817278db15$export$657220afecfe252).RESET_AUTHENTICATOR]: {
        // Admin driven password reset..
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).PASSWORD]: (0, $b89b1c400b2f2a3d$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).GOOGLE_OTP]: (0, $5229ae4c20a3ea6e$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).NFC_PIN]: (0, $693a6c4ee89e3583$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).SELECT_AUTHENTICATOR_AUTHENTICATE]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $499b38ed5a68ebff$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).SELECT_AUTHENTICATOR_UNLOCK]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $a68279c76c3cdcb1$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).UNLOCK_ACCOUNT]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $aa1530942659c0ed$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).CHALLENGE_POLL]: {
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).OV]: (0, $863b68c643335f66$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).CUSTOM_APP]: (0, $90181527605f58eb$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).NFC_PIN]: (0, $bdd927747f1716f2$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).RESEND]: {
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).OV]: (0, $76d6497d38589e84$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).CUSTOM_APP]: (0, $77d4d51509af4f39$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).AUTHENTICATOR_VERIFICATION_DATA]: {
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).PHONE]: (0, $74dac234e7175180$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).OV]: (0, $3eaa075b4d82258f$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).EMAIL]: (0, $1faea61eb85939c2$export$2e2bcd8739ae039),
        [(0, $4a07c2817278db15$export$a7895cc4b0944d1b).CUSTOM_APP]: (0, $3eaa075b4d82258f$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).FAILURE_REDIRECT]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $fada7d47117f92a9$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).SUCCESS_REDIRECT]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $fada7d47117f92a9$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).REDIRECT_IDP]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $4ee2930d0d999610$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).REDIRECT_IDVERIFY]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $a8e9291486611964$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).PIV_IDP]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $40ab12b3d983ea36$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).DEVICE_ENROLLMENT_TERMINAL]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $6b2f4f64193231e1$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).USER_CODE]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $4bb3929acceca383$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).KEEP_ME_SIGNED_IN]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $44ec6cdf8c47e0ee$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).TERMINAL]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $8c1ba9d0e26d52e7$export$2e2bcd8739ae039)
    },
    [(0, $4a07c2817278db15$export$657220afecfe252).DEVICE_ASSURANCE_GRACE_PERIOD]: {
        [$f922a4150da58580$var$DEFAULT]: (0, $2bd7e702e649bd45$export$2e2bcd8739ae039)
    }
};
var $f922a4150da58580$export$2e2bcd8739ae039 = {
    create: function(formName, authenticatorKey = $f922a4150da58580$var$DEFAULT) {
        const config = $f922a4150da58580$var$VIEWS_MAPPING[formName];
        if (!config) {
            (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).warn(`Cannot find customized View for ${formName}.`);
            return 0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039;
        }
        const View = config[authenticatorKey] || config[$f922a4150da58580$var$DEFAULT];
        if (!View) {
            (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).warn(`Cannot find customized View for ${formName} + ${authenticatorKey}.`);
            return 0, $0add9dbd3c6edb9a$export$2e2bcd8739ae039;
        }
        return View;
    }
};







/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $64b1f81e57c7816d$var$OPTED_SCOPES_PREFIX = 'optedScopes.';
/**
 * This function is for the Granular Consent remediation. The Granular Consent
 * model uses `flat: false` (see GranularConsentView) so Courage's toJSON does
 * not try to unflatten the optedScopes sub-form — that would crash when scope
 * names share a dotted prefix (e.g. `custom1` and `custom1.custom2`). The
 * flat `optedScopes.<scope>` keys are grouped here into the nested
 * `optedScopes` object that the IDX backend expects, preserving dotted scope
 * names verbatim.
 * i.e. { 'optedScopes.custom1': true, 'optedScopes.custom1.custom2': false }
 *      => { optedScopes: { 'custom1': true, 'custom1.custom2': false } }
 *
 * @param {JSON} modelJSON JSON Equivalent of the Backbone Model's attributes/fields
 * @returns A copy of modelJSON with `optedScopes.*` keys grouped into a single `optedScopes` object.
 */ const $64b1f81e57c7816d$var$transformOptedScopes = (modelJSON)=>{
    const result = {
        ...modelJSON
    };
    const optedScopes = {};
    Object.keys(modelJSON).forEach((key)=>{
        if (key.indexOf($64b1f81e57c7816d$var$OPTED_SCOPES_PREFIX) === 0) {
            optedScopes[key.slice($64b1f81e57c7816d$var$OPTED_SCOPES_PREFIX.length)] = modelJSON[key];
            delete result[key];
        }
    });
    result.optedScopes = optedScopes;
    return result;
};
const $64b1f81e57c7816d$var$FormNameToTransformerHandler = {
    [(0, $4a07c2817278db15$export$657220afecfe252).CONSENT_GRANULAR]: $64b1f81e57c7816d$var$transformOptedScopes
};
/**
 * The purpose of this function is the transform the
 * Backbone Model's attributes/fields into a JSON equivalent before sending to IDX,
 * since the Model fields are all flattend when the UI Schema is transformed on consumption.
 *
 * @param {string} formName Form name of the current remediation
 * @param {Model} model Backbone Model Class
 * @returns JSON equivalent of the Model
 */ const $64b1f81e57c7816d$export$2e2bcd8739ae039 = (formName, model)=>{
    const modelJSON = model.toJSON();
    const transformHandler = $64b1f81e57c7816d$var$FormNameToTransformerHandler[formName];
    if (typeof transformHandler === 'undefined') return modelJSON;
    return transformHandler(modelJSON);
};








parcelRequire("3ZxP0");




/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $f94ce0050ebfcb51$export$2e2bcd8739ae039 = (0, $5d64eb84267ab4e8$export$bd0bf19f25da8474).extend({
    className: 'form-controller',
    appStateEvents: {
        'change:currentFormName': 'handleFormNameChange',
        'afterError': 'handleAfterError',
        'invokeAction': 'handleInvokeAction',
        'saveForm': 'handleSaveForm',
        'switchForm': 'handleSwitchForm'
    },
    preRender: function() {
        this.removeChildren();
    },
    postRender: function() {
        const currentViewState = this.options.appState.getCurrentViewState();
        // TODO: add comments regarding when `currentViewState` would be null?
        if (!currentViewState) return;
        this.clearMetadata();
        let formName = currentViewState.name;
        if (formName === 'identify' && this.options.settings.get('flow') === (0, $12b2542b724eccae$export$ead867ba51e7f9b2).RESET_PASSWORD) formName = 'identify-recovery';
        const TheView = (0, $f922a4150da58580$export$2e2bcd8739ae039).create(formName, this.options.appState.get('authenticatorKey'));
        try {
            this.formView = this.add(TheView, {
                options: {
                    currentViewState: currentViewState
                }
            }).last();
        } catch (error) {
            // This is the place where runtime error (NPE) happens at most of time.
            // It has been swallowed by Q.js hence add try/catch to surface up errors.
            this.options.settings.callGlobalError(error);
            return;
        }
        this.triggerAfterRenderEvent();
    },
    clearMetadata: function() {
        const formName = this.options.appState.get('currentFormName');
        // TODO: OKTA-392835 shall not clear state handle at terminal page
        if ((0, $4a07c2817278db15$export$7412d2738fb17921).includes(formName)) (0, $64cf5b2d2fb5baf3$export$2e2bcd8739ae039).removeStateHandle();
    },
    triggerAfterRenderEvent: function() {
        const contextData = this.createAfterEventContext();
        this.trigger('afterRender', contextData);
    },
    handleFormNameChange: function() {
        // OKTA-803760 - Fix: close opened dropdown
        this.$el.click();
        this.render();
    },
    handleAfterError: function(error) {
        const contextData = this.createAfterEventContext();
        const errorContextData = {
            xhr: error,
            errorSummary: error.responseJSON && error.responseJSON.errorSummary
        };
        // TODO: need some enhancement after https://github.com/okta/okta-idx-js/pull/27
        // OKTA-318062
        this.trigger('afterError', contextData, errorContextData);
    },
    createAfterEventContext: function() {
        const formName = this.options.appState.get('currentFormName');
        const authenticatorKey = this.options.appState.get('authenticatorKey');
        const methodType = this.options.appState.get('authenticatorMethodType');
        const isPasswordRecoveryFlow = this.options.appState.get('isPasswordRecoveryFlow');
        const v1ControllerClassName = (0, $498610e59ec43767$export$9b06fbbb56522c2f)(formName, authenticatorKey, methodType, isPasswordRecoveryFlow);
        const eventData = {
            controller: v1ControllerClassName,
            formName: formName
        };
        if (authenticatorKey) eventData.authenticatorKey = authenticatorKey;
        if (methodType) eventData.methodType = methodType;
        return eventData;
    },
    handleSwitchForm: async function(formName) {
        var _this$options$appStat;
        // trigger formName change to change view
        if (this.options.appState.get('messages')) // Clear messages before calling switch form.
        // If a form has errors sent form API inside messages
        // and user hits back to factors list which triggers switchForm,
        // those error will show up on another screen that gets rendered after switchForm
        this.options.appState.unset('messages');
        // Run customer-registered before/after hooks for the target form. Without this,
        // hooks fire only on renders driven by an IDX response (see AppState.setIonResponse),
        // and any client-side switchForm navigation (e.g. "Verify with something else")
        // would silently skip them.
        const hook = (_this$options$appStat = this.options.appState.hooks) === null || _this$options$appStat === void 0 ? void 0 : _this$options$appStat.getHook(formName);
        await (0, $3187669a11ef20e8$export$83d14e54e50a1a2a)(hook);
        // Backbone fires `change:currentFormName` and re-renders synchronously inside
        // set(), so the DOM is fully updated by the time set() returns — which means
        // executeHooksAfter below runs against the new form, not the old one.
        this.options.appState.set('currentFormName', formName);
        await (0, $3187669a11ef20e8$export$3edd39a83caf9634)(hook);
    },
    // eslint-disable-next-line max-statements
    handleInvokeAction: async function(actionPath = '', actionParams = {}, showFormErrors = true) {
        const { appState: appState, settings: settings } = this.options;
        // For self-hosted scenario we need to start reset flow at identify page from scratch.
        //  (Reusing state handle of transaction after failed sign-in attempt for reset flow is error prone)
        // For Okta-hosted scenario we don't need to cancel/restart flow because SIW receives fresh state token
        //  from backend on page load and doesn't save state handle to session storage after error.
        if (actionPath === (0, $4a07c2817278db15$export$77b1c349e66d68cb) && settings.get('oauth2Enabled')) {
            appState.trigger('restartLoginFlow', 'resetPassword');
            return;
        }
        const idx = appState.get('idx');
        const { stateHandle: stateHandle } = idx.context;
        let invokeOptions = {
            exchangeCodeForTokens: false,
            // we handle this in interactionCodeFlow.js
            stateHandle: stateHandle
        };
        let error;
        // Cancel action is executes synchronously
        if (actionPath === 'cancel') {
            // TODO: resolve race conditions caused by event pattern: OKTA-490220
            settings.getAuthClient().transactionManager.clear({
                clearIdxResponse: false
            });
            (0, $64cf5b2d2fb5baf3$export$2e2bcd8739ae039).removeStateHandle();
            appState.clearAppStateCache();
            if (settings.get('oauth2Enabled')) {
                // In this case we need to restart login flow and recreate transaction meta
                // that will be used in interactionCodeFlow function
                appState.trigger('restartLoginFlow');
                return;
            }
        }
        const invokeableForms = [
            (0, $4a07c2817278db15$export$657220afecfe252).LAUNCH_AUTHENTICATOR,
            (0, $4a07c2817278db15$export$657220afecfe252).CHALLENGE_WEBAUTHN_AUTOFILLUI_AUTHENTICATOR,
            (0, $4a07c2817278db15$export$657220afecfe252).LAUNCH_PASSKEYS_AUTHENTICATOR
        ];
        if (invokeableForms.includes(actionPath) && actionParams) //https://oktainc.atlassian.net/browse/OKTA-562885  a temp solution to send rememberMe when click the launch OV buttion.
        //will redesign to handle FastPass silent probing case where no username and rememberMe opiton at all.
        invokeOptions = {
            ...invokeOptions,
            actions: [
                {
                    name: actionPath,
                    params: actionParams
                }
            ]
        };
        else if (idx['neededToProceed'].find((item)=>item.name === actionPath)) invokeOptions = {
            ...invokeOptions,
            step: actionPath
        };
        else if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(idx['actions'][actionPath])) invokeOptions = {
            ...invokeOptions,
            actions: [
                {
                    name: actionPath,
                    params: actionParams
                }
            ]
        };
        else {
            error = new (0, $3fe6932680e7ea64$export$c5fb415882705cf4)(`Invalid action selected: ${actionPath}`);
            this.options.settings.callGlobalError(error);
            if (showFormErrors) await this.showFormErrors(this.formView.model, error, this.formView.form);
            return;
        }
        // action will be executed asynchronously
        await this.invokeAction(invokeOptions);
    },
    invokeAction: async function(invokeOptions) {
        const authClient = this.options.settings.getAuthClient();
        let resp;
        let error;
        try {
            resp = await authClient.idx.proceed(invokeOptions);
            if (resp.requestDidSucceed === false) error = resp;
        } catch (e) {
            error = e;
        }
        // if request did not succeed, show error on the current form
        if (error) {
            var _invokeOptions$action, _invokeOptions$action2, _invokeOptions$action3, _this$formView, _this$formView$form;
            // OKTA-1083742: For transient network errors during polling, restart polling silently.
            const errorResp = error.rawIdxState || error;
            const errorObj = (0, $e61f8568dda6e7bb$export$2e2bcd8739ae039).buildErrorObject(errorResp);
            const isPollingAction = (_invokeOptions$action = invokeOptions.actions) === null || _invokeOptions$action === void 0 ? void 0 : (_invokeOptions$action2 = _invokeOptions$action[0]) === null || _invokeOptions$action2 === void 0 ? void 0 : (_invokeOptions$action3 = _invokeOptions$action2.name) === null || _invokeOptions$action3 === void 0 ? void 0 : _invokeOptions$action3.endsWith('-poll');
            // Here we only want to restart polling for network errors (non Ion errors) during polling actions
            // As rate limit error is handled in view layer, we skip it here and leave to showFormErrors to decide whether to restart polling or not based on the view logic.
            if (!(0, $83b60ca1e8963f3f$export$2e2bcd8739ae039).isIonErrorResponse(errorResp) && !(0, $e61f8568dda6e7bb$export$2e2bcd8739ae039).isRateLimitError(errorObj) && isPollingAction && typeof ((_this$formView = this.formView) === null || _this$formView === void 0 ? void 0 : (_this$formView$form = _this$formView.form) === null || _this$formView$form === void 0 ? void 0 : _this$formView$form.startPolling) === 'function') {
                // Silently restart polling for transient network failures
                this.formView.form.startPolling();
                return;
            }
            await this.showFormErrors(this.formView.model, error, this.formView.form);
            return;
        }
        // process response, may render a new form
        await this.handleIdxResponse(resp);
    },
    // eslint-disable-next-line max-statements, complexity
    handleSaveForm: async function(model) {
        var _authClient$idx$getFl, _authClient$idx;
        const formName = model.get('formName');
        // Toggle Form saving status (e.g. disabling save button, etc)
        this.toggleFormButtonState(true);
        model.trigger('request');
        // Use full page redirection if necessary
        if (model.get('useRedirect')) {
            // Clear when navigates away from SIW page, e.g. success, IdP Authenticator.
            // Because SIW sort of finished its current /transaction/
            (0, $64cf5b2d2fb5baf3$export$2e2bcd8739ae039).removeStateHandle();
            const currentViewState = this.options.appState.getCurrentViewState();
            // OKTA-1182955: when the backend signals a successful prior Android AppLink (FastPass)
            // verification, do NOT auto-redirect. AutoRedirectView renders a button instead; the
            // user click guarantees window focus before the redirect, avoiding the visible-but-not-
            // focused race that lands on login.okta.com.
            if ((0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).isPostAppLinkVerification(currentViewState)) return;
            // OKTA-702402: redirect only if/when the page is visible
            (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).executeOnVisiblePage(()=>{
                (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).redirectWithFormGet(currentViewState.href);
            });
            return;
        }
        const payload = (0, $64b1f81e57c7816d$export$2e2bcd8739ae039)(formName, model);
        // NOTE: this line should be called before triggering transformIdentifier
        const originalIdentifier = payload.identifier;
        // Run hook: transform the user name (a.k.a identifier)
        const values = this.transformIdentifier(formName, payload);
        // widget rememberMe feature stores the entered identifier in a cookie, to pre-fill the form on subsequent visits to page
        if (this.options.settings.get('features.rememberMe')) {
            if (originalIdentifier) (0, $0077b4018f3faaa0$export$2e2bcd8739ae039).setUsernameCookie(originalIdentifier);
        } else (0, $0077b4018f3faaa0$export$2e2bcd8739ae039).removeUsernameCookie();
        // Error out when this is not a remediation form. Unexpected Exception.
        if (!this.options.appState.hasRemediationObject(formName)) {
            this.options.settings.callGlobalError(`Cannot find http action for "${formName}".`);
            await this.showFormErrors(this.formView.model, 'Cannot find action to proceed.', this.formView.form);
            return;
        }
        // Reset password in identity-first flow needs some help to auto-select password and begin the reset flow
        if (formName === 'identify' && this.options.settings.get('flow') === (0, $12b2542b724eccae$export$ead867ba51e7f9b2).RESET_PASSWORD) values.authenticator = 'okta_password';
        // Submit request to idx endpoint
        const authClient = this.options.settings.getAuthClient();
        const idxOptions = {
            exchangeCodeForTokens: false // we handle this in interactionCodeFlow.js
        };
        // OKTA-1152243: After password reset, the server may return post-auth remediations
        // (e.g. keep-me-signed-in) that are not in PasswordRecoveryFlow. Reset to default flow
        // so auth-js does not throw when it encounters these in the recursive remediate() call.
        // We also persist the change to the saved transaction meta — auth-js' proceed() falls
        // back to meta.flow whenever a proceed call omits the flow option (e.g. the MFA
        // step-up hop between reset-authenticator and post-auth keep-me-signed-in), and
        // without this update it would re-read 'resetPassword' and throw on the KMSI step.
        const shouldResetFlow = formName === (0, $4a07c2817278db15$export$657220afecfe252).RESET_AUTHENTICATOR && ((_authClient$idx$getFl = (_authClient$idx = authClient.idx).getFlow) === null || _authClient$idx$getFl === void 0 ? void 0 : _authClient$idx$getFl.call(_authClient$idx)) === 'resetPassword';
        if (shouldResetFlow) {
            var _authClient$idx$getSa, _authClient$idx2;
            authClient.idx.setFlow('default');
            const savedMeta = (_authClient$idx$getSa = (_authClient$idx2 = authClient.idx).getSavedTransactionMeta) === null || _authClient$idx$getSa === void 0 ? void 0 : _authClient$idx$getSa.call(_authClient$idx2);
            if (savedMeta) {
                var _authClient$idx$saveT, _authClient$idx3;
                (_authClient$idx$saveT = (_authClient$idx3 = authClient.idx).saveTransactionMeta) === null || _authClient$idx$saveT === void 0 || _authClient$idx$saveT.call(_authClient$idx3, {
                    ...savedMeta,
                    flow: 'default'
                });
            }
        }
        try {
            const idx = this.options.appState.get('idx');
            const { stateHandle: stateHandle } = idx.context;
            const resp = await authClient.idx.proceed({
                ...idxOptions,
                step: formName,
                ...shouldResetFlow && {
                    flow: 'default'
                },
                stateHandle: stateHandle,
                ...values
            });
            if (resp.status === (0, $714174fa38b8e4a1$exports.IdxStatus).FAILURE) throw resp.error; // caught and handled in this function
            // follow idx transaction to render terminal view for session expired error
            if ((0, $83b60ca1e8963f3f$export$2e2bcd8739ae039).isIdxSessionExpiredError(resp)) {
                const authClient = this.settings.getAuthClient();
                authClient.transactionManager.clear();
                await this.handleIdxResponse(resp);
                return;
            }
            // If the last request did not succeed, show errors on the current form
            // Special case: Okta server responds 401 status code with WWW-Authenticate header and new remediation
            // so that the iOS/MacOS credential SSO extension (Okta Verify) can intercept
            // the response reaches here when Okta Verify is not installed
            // we need to return an idx object so that
            // the SIW can proceed to the next step without showing error
            if (resp.requestDidSucceed === false && !resp.stepUp) {
                await this.showFormErrors(model, resp, this.formView.form);
                return;
            }
            const onSuccess = this.handleIdxResponse.bind(this, resp);
            if (formName === (0, $4a07c2817278db15$export$657220afecfe252).ENROLL_PROFILE) {
                var _values$userProfile;
                // call registration (aka enroll profile) hook
                this.settings.postRegistrationSubmit(values === null || values === void 0 ? void 0 : (_values$userProfile = values.userProfile) === null || _values$userProfile === void 0 ? void 0 : _values$userProfile.email, onSuccess, (error)=>{
                    model.trigger('error', model, {
                        responseJSON: error
                    });
                });
            } else await onSuccess();
        } catch (error) {
            var _error$is;
            if ((_error$is = error.is) !== null && _error$is !== void 0 && _error$is.call(error, 'terminal')) this.options.appState.setNonIdxError(error);
            else await this.showFormErrors(model, error, this.formView.form);
        } finally{
            this.toggleFormButtonState(false);
        }
    },
    transformIdentifier: function(formName, modelJSON) {
        if (Object.prototype.hasOwnProperty.call(modelJSON, 'identifier')) {
            // The callback function is passed two arguments:
            // 1) username: The name entered by the user
            // 2) operation: The type of operation the user is trying to perform:
            //      - PRIMARY_AUTH
            //      - FORGOT_PASSWORD
            //      - UNLOCK_ACCOUNT
            const operation = (0, $4a07c2817278db15$export$8e4daa11e9eb0065)[formName];
            modelJSON.identifier = this.settings.transformUsername(modelJSON.identifier, operation);
        }
        return modelJSON;
    },
    /**
   * @param model current form model
   * @param error any errors after user action
   * @param form current form
   * Handle errors that get displayed right after any user action. After such form errors widget doesn't
   * reload or re-render, but updates the AppSate with latest remediation.
   */ showFormErrors: async function(model, error, form) {
        var _error;
        /* eslint max-statements: [2, 24] */ let idxStateError;
        let showErrorBanner = true;
        model.trigger('clearFormError');
        if (!error) {
            error = 'FormController - unknown error found';
            this.options.settings.callGlobalError(error);
        }
        if ((_error = error) !== null && _error !== void 0 && _error.rawIdxState) {
            idxStateError = error;
            error = error.rawIdxState;
        }
        const errorObj = (0, $e61f8568dda6e7bb$export$2e2bcd8739ae039).buildErrorObject(error, (unsupported)=>{
            (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).logConsoleError(unsupported);
        });
        if ((0, $3e490973b7383cc4$export$2e2bcd8739ae039).isFunction(form === null || form === void 0 ? void 0 : form.showCustomFormErrorCallout)) {
            var _idxStateError;
            showErrorBanner = !form.showCustomFormErrorCallout(errorObj, (_idxStateError = idxStateError) === null || _idxStateError === void 0 ? void 0 : _idxStateError.messages);
        }
        // show error before updating app state.
        model.trigger('error', model, errorObj, showErrorBanner);
        idxStateError = Object.assign({}, idxStateError, {
            hasFormError: true
        });
    // OKTA-725716: Don't save failed IDX response to state
    },
    handleIdxResponse: async function(idxResp) {
        await (0, $160e2fcd71d4ceb8$export$430b76549cd56679)(this.options.appState, idxResp);
    },
    /**
   * SignIn widget has its own (hacky) way to customize the button disabled state:
   * adding `link-button-disabled` despite the name was intend only to disable
   * `link-button`.
   * Instead of doing decent refactor, we want to follow the convention for now.
   *
   * @param {boolean} disabled whether add extra disable CSS class.
   */ toggleFormButtonState: function(disabled) {
        const button = this.$el.find('.o-form-button-bar .button');
        button.toggleClass('link-button-disabled', disabled);
    }
});


/*!
 * Copyright (c) 2020, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $1e747b560172a544$var$routes = {
    '': 'defaultAuth',
    '*wildcard': 'defaultAuth'
};
class $1e747b560172a544$export$2e2bcd8739ae039 extends (0, $bad5ff2b44526355$export$2e2bcd8739ae039) {
    constructor(options){
        super({
            routes: $1e747b560172a544$var$routes,
            ...options
        });
    }
    defaultAuth() {
        this.render((0, $f94ce0050ebfcb51$export$2e2bcd8739ae039));
    }
}


// Default router factory will detect between classic and OIE pipeline
function $ef1e2eb0ef0e97cb$export$3a14ecf4c287845c(options) {
    let Router;
    // V1 ("classic") flow will load under these conditions:
    const v1DefaultFlow = !options.stateToken && !options.clientId && !options.proxyIdxResponse; // Default entry flow on okta-hosted login page
    const v1StateTokenFlow = options.stateToken && (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).isV1StateToken(options.stateToken); // Resuming a flow on okta-hosted login page
    const v1AuthFlow = options.clientId && options.useClassicEngine === true; // Self hosted widget can set the `useClassicEngine` option to use V1Router
    if (v1DefaultFlow || v1StateTokenFlow || v1AuthFlow) Router = (0, $96fb9c531a580e07$export$2e2bcd8739ae039);
    else Router = (0, $1e747b560172a544$export$2e2bcd8739ae039);
    return Router;
}








function $e9305d2b0ba77afc$export$2e2bcd8739ae039(OktaAuth, options = {}) {
    // if authClient is set, authParams are disregarded
    let { authClient: authClient, authParams: authParams } = options;
    if (!authClient) {
        // Create an authClient using widget options and optional authParams
        const { issuer: issuer, clientId: clientId, redirectUri: redirectUri, state: state, scopes: scopes, flow: flow, codeChallenge: codeChallenge, codeChallengeMethod: codeChallengeMethod, recoveryToken: recoveryToken } = options;
        authParams = {
            issuer: issuer,
            clientId: clientId,
            redirectUri: redirectUri,
            state: state,
            scopes: scopes,
            flow: flow,
            codeChallenge: codeChallenge,
            codeChallengeMethod: codeChallengeMethod,
            transformErrorXHR: (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).transformErrorXHR,
            recoveryToken: recoveryToken,
            pollDelay: 500,
            ...authParams
        };
        if (!authParams.issuer) authParams.issuer = options.baseUrl + '/oauth2/default';
        authClient = new OktaAuth(authParams);
    }
    // Add widget version to extended user agent header
    if (!authClient._oktaUserAgent) throw new (0, $3fe6932680e7ea64$export$c5fb415882705cf4)('The passed in authClient should be version 5.4.0 or above.');
    else authClient._oktaUserAgent.addEnvironment(`okta-signin-widget-${(0, $9ab2e0ac5722e186$export$2e2bcd8739ae039).version}`);
    return authClient;
}














function $dca22c58f9c487f9$export$2e2bcd8739ae039(widgetOptions = {}, options = {}) {
    const authParams = (0, $b51a961f9fe28c76$export$2e2bcd8739ae039).extend(true, {}, widgetOptions.authParams, (0, $3e490973b7383cc4$export$2e2bcd8739ae039).pick(options, (0, $5eccc61229d1b47f$export$2e2bcd8739ae039).AUTH_PARAMS));
    const { el: el, clientId: clientId, redirectUri: redirectUri } = Object.assign({}, widgetOptions, options);
    const renderOptions = Object.assign({}, {
        el: el,
        clientId: clientId,
        redirectUri: redirectUri,
        authParams: authParams
    });
    if (!renderOptions.el) throw new (0, $3fe6932680e7ea64$export$c5fb415882705cf4)('"el" is required');
    if (!renderOptions.clientId) throw new (0, $3fe6932680e7ea64$export$c5fb415882705cf4)('"clientId" is required');
    if (!renderOptions.redirectUri) throw new (0, $3fe6932680e7ea64$export$c5fb415882705cf4)('"redirectUri" is required');
    return renderOptions;
}













function $1d4b1a26ce569028$export$2e2bcd8739ae039(Router, widgetOptions, renderOptions, authClient, successFn, errorFn, hooks) {
    let resolve;
    let reject;
    const promise = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    const routerOptions = (0, $b51a961f9fe28c76$export$2e2bcd8739ae039).extend(true, {}, widgetOptions, renderOptions, {
        authClient: authClient,
        hooks: hooks,
        globalSuccessFn: (res)=>{
            successFn && successFn(res); // call success function if provided
            if (res && res.status === (0, $e48c043f6d2d382d$export$2e2bcd8739ae039).SUCCESS) resolve(res);
        },
        globalErrorFn: (error)=>{
            errorFn && errorFn(error); // call error function if provided
            reject(error);
        }
    });
    const router = new Router(routerOptions);
    router.start();
    return {
        router: router,
        routerOptions: routerOptions,
        promise: promise
    };
}













/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ class $771b349cb33786a0$export$2e2bcd8739ae039 extends (0, $5ff5548bf63df3e3$export$2e2bcd8739ae039) {
    mergeHook(formName, hookToMerge) {
        const hooks = this.get('hooks') || {};
        (0, $3187669a11ef20e8$export$e893ed9fcbab732c)(hooks, formName, hookToMerge);
        this.set('hooks', hooks);
    }
    getHook(formName) {
        const hooks = this.get('hooks') || {};
        return hooks[formName]; // may be undefined
    }
}


/* eslint-disable @typescript-eslint/no-explicit-any */ const $66873eadadfd6b0d$var$EVENTS_LIST = [
    'ready',
    'afterError',
    'afterRender'
];
function $66873eadadfd6b0d$export$cb650c19ea0d1975(authClientConstructor, routerClassFactory) {
    return class OktaSignIn {
        // Map original event handler to wrapped one
        constructor(options){
            this.Router = void 0;
            this.options = void 0;
            this.hooks = void 0;
            this.router = void 0;
            this.authClient = void 0;
            this._eventCallbackMap = void 0;
            (0, $e10ed35bf8cfc4ab$export$2e2bcd8739ae039).debugMessage(`
          The Okta Sign-In Widget is running in development mode.
          When you are ready to publish your app, embed the minified version to turn on production mode.
          See: https://developer.okta.com/code/javascript/okta_sign-in_widget#cdn
        `);
            if (!options.stateToken) {
                var _window, _window$oktaData, _window$oktaData$sign;
                // need to set stateToken here vs in Settings to determine Router.
                // oktaData is only available to SIW on custom domains.
                // set stateToken in case user wipes out stateToken when overriding options.
                options.stateToken = (_window = window) === null || _window === void 0 ? void 0 : (_window$oktaData = _window.oktaData) === null || _window$oktaData === void 0 ? void 0 : (_window$oktaData$sign = _window$oktaData.signIn) === null || _window$oktaData$sign === void 0 ? void 0 : _window$oktaData$sign.stateToken;
            }
            this.options = options;
            this.authClient = (0, $e9305d2b0ba77afc$export$2e2bcd8739ae039)(authClientConstructor, options);
            // validate authClient configuration against widget options
            if (options.useClassicEngine !== true && this.authClient.options.clientId && this.authClient.isPKCE() === false) throw new (0, $3fe6932680e7ea64$export$c5fb415882705cf4)('OAuth2 with interaction code flow requires PKCE to be enabled on the authClient.');
            // Hooks can be modified before or after render
            this.hooks = new (0, $771b349cb33786a0$export$2e2bcd8739ae039)({
                hooks: options.hooks
            });
            this.Router = routerClassFactory(options);
            this._eventCallbackMap = new WeakMap();
            // Triggers the event up the chain so it is available to the consumers of the widget.
            this.Router.prototype.Events.listenTo.call(this, this.Router.prototype, 'all', this.trigger);
            // On the first afterRender event (usually when the Widget is ready) - emit a 'ready' event
            this.once('afterRender', function(context) {
                this.trigger('ready', context);
            });
        }
        /**
     * Render the sign in widget to an element. Returns a promise that will resolve on success or reject on error.
     * @param options - options for the signin widget.
     *        Must have an el or $el property to render the widget to.
     * @param success - success callback function
     * @param error - error callback function
     */ renderEl(renderOptions, successFn, errorFn) {
            if (this.router) throw new Error('An instance of the widget has already been rendered. Call remove() first.');
            const res = (0, $1d4b1a26ce569028$export$2e2bcd8739ae039)(this.Router, this.options, renderOptions, this.authClient, successFn, errorFn, this.hooks);
            this.router = res.router;
            return res.promise;
        }
        hide() {
            if (this.router) this.router.hide();
        }
        show() {
            if (this.router) this.router.show();
        }
        remove() {
            if (this.router) {
                this.router.remove();
                this.router = undefined;
            }
        }
        /**
     * Renders the Widget and returns a promise that resolves to OAuth tokens
     * @param options - options for the signin widget
     */ showSignInToGetTokens(options) {
            const renderOptions = Object.assign((0, $dca22c58f9c487f9$export$2e2bcd8739ae039)(this.options, options), {
                redirect: 'never'
            });
            const promise = this.renderEl(renderOptions).then((res)=>{
                return res.tokens;
            });
            const authClient = this.router.settings.getAuthClient();
            if (authClient.isAuthorizationCodeFlow() && !authClient.isPKCE()) throw new (0, $3fe6932680e7ea64$export$c5fb415882705cf4)('"showSignInToGetTokens()" should not be used for authorization_code flow. Use "showSignInAndRedirect()" instead');
            return promise;
        }
        /**
     * Renders the widget and redirects to the OAuth callback
     * @param options - options for the signin widget
     */ showSignInAndRedirect(options) {
            const renderOptions = Object.assign((0, $dca22c58f9c487f9$export$2e2bcd8739ae039)(this.options, options), {
                redirect: 'always'
            });
            return this.renderEl(renderOptions).then(()=>{
                // This method should never return, it will either redirect or reject with error
                return;
            });
        }
        /**
     * Renders the widget. Either resolves the returned promise, or redirects.
     * @param options - options for the signin widget
     */ showSignIn(options) {
            const renderOptions = Object.assign((0, $dca22c58f9c487f9$export$2e2bcd8739ae039)(this.options, options));
            return this.renderEl(renderOptions);
        }
        // Hook convenience functions
        before(formName, callbackFn) {
            this.hooks.mergeHook(formName, {
                before: [
                    callbackFn
                ]
            });
        }
        after(formName, callbackFn) {
            this.hooks.mergeHook(formName, {
                after: [
                    callbackFn
                ]
            });
        }
        getUser() {
            var _this$router, _this$router$appState;
            return (_this$router = this.router) === null || _this$router === void 0 ? void 0 : (_this$router$appState = _this$router.appState) === null || _this$router$appState === void 0 ? void 0 : _this$router$appState.getUser();
        }
        // Events API
        on(event, callback) {
            // custom events listener on widget instance to trap third-party callback errors
            if ($66873eadadfd6b0d$var$EVENTS_LIST.includes(event)) {
                const origCallback = callback;
                callback = function(...callbackArgs) {
                    try {
                        origCallback.apply(this, callbackArgs);
                    } catch (err) {
                        (0, $c95ce7ada2e60396$export$2e2bcd8739ae039).error(`[okta-signin-widget] "${event}" event handler error:`, err);
                    }
                };
                this._eventCallbackMap.set(origCallback, callback);
            }
            this.Router.prototype.Events.on.call(this, event, callback);
        }
        off(event, callback) {
            if (callback) callback = this._eventCallbackMap.get(callback) || callback;
            this.Router.prototype.Events.off.call(this, event, callback);
        }
        once(event, callback) {
            this.Router.prototype.Events.once.call(this, event, callback);
        }
        stopListening(event, callback) {
            this.Router.prototype.Events.stopListening.call(this, event, callback);
        }
        listenTo(object, event, callback) {
            this.Router.prototype.Events.listenTo.call(this, object, event, callback);
        }
        trigger(event, ...args) {
            this.Router.prototype.Events.trigger.apply(this, [
                event,
                ...args
            ]);
        }
    };
}


// Default supports both IDX and Authn pipelines
class $2e5fd53f383ba808$export$fb8416f1707f84a6 extends (0, $66873eadadfd6b0d$export$cb650c19ea0d1975)((0, $4ef1d20df6e6f403$export$c998d4cdbfb7af8), (0, $ef1e2eb0ef0e97cb$export$3a14ecf4c287845c)) {
    constructor(options){
        super(options);
    }
}



var $a522310ce80f7363$exports = {};
$a522310ce80f7363$exports = $parcel$resolve("3INcZ");


const $0eef21711cc31468$var$OKTA_CLIENT_ID = window.env.OKTA_CLIENT_ID || '0oawt4qsxfwCwohjC0h7';
const $0eef21711cc31468$var$OKTA_ISSUER = window.env.OKTA_ISSUER || 'https://kagr.oktapreview.com/oauth2/default';
const $0eef21711cc31468$var$OKTA_REQUEST_CONTEXT = window.env.OKTA_REQUEST_CONTEXT || '/home/oidc_client/0oawt4qsxfwCwohjC0h7/aln5z7uhkbM6y7bMy0g7';
const $0eef21711cc31468$var$REDIRECT_URI = `${window.location.origin}/login/callback`;
const $0eef21711cc31468$var$POST_LOGOUT_REDIRECT_URI = `${window.location.origin}/login`;
const $0eef21711cc31468$export$54a06e3f4a159ad8 = [
    'openid',
    'profile',
    'email'
];
const $0eef21711cc31468$export$2055a4168038516 = {
    // Note: If your app is configured to use the Implicit flow
    // instead of the Authorization Code with Proof of Code Key Exchange (PKCE)
    // you will need to add `pkce: false`
    issuer: $0eef21711cc31468$var$OKTA_ISSUER,
    clientId: $0eef21711cc31468$var$OKTA_CLIENT_ID,
    redirectUri: $0eef21711cc31468$var$REDIRECT_URI,
    postLogoutRedirectUri: $0eef21711cc31468$var$POST_LOGOUT_REDIRECT_URI
};
const $0eef21711cc31468$export$3766629a36a409c9 = {
    baseUrl: $0eef21711cc31468$var$OKTA_ISSUER.split('/oauth2')[0],
    clientId: $0eef21711cc31468$var$OKTA_CLIENT_ID,
    logo: (0, (/*@__PURE__*/$parcel$interopDefault($a522310ce80f7363$exports))),
    redirectUri: $0eef21711cc31468$var$REDIRECT_URI,
    // In version 7 of @okta/okta-signin-widget it defaults to using their Identity Engine
    // KAGR is still using the classic so this flag needs to be turned on until they switch to Identity Engine 
    // When moved to the Identity engine, remove this flag
    useClassicEngine: true,
    authParams: {
        // If your app is configured to use the Implicit flow
        // instead of the Authorization Code with Proof of Code Key Exchange (PKCE)
        // you will need to uncomment the below line
        pkce: true,
        OKTA_ISSUER: $0eef21711cc31468$var$OKTA_ISSUER,
        scopes: $0eef21711cc31468$export$54a06e3f4a159ad8
    },
    // Remove the features object when updating to use Identity engine
    features: {
        registration: false,
        multiOptionalFactorEnroll: true,
        idpDiscovery: true
    },
    i18n: {
        en: {
            'primaryauth.title': 'Sign in to KAGR'
        }
    },
    idpDiscovery: {
        requestContext: $0eef21711cc31468$var$OKTA_REQUEST_CONTEXT
    }
};


var $74982d8296291a36$export$8d6d009d1f06226e;
var $74982d8296291a36$export$dc57ddd528b7443f;
var $74982d8296291a36$export$c4b0f5819f6a6663;
var $74982d8296291a36$export$a4c9bc12643ea157;
var $74982d8296291a36$export$493b5823483d2c4e;
var $74982d8296291a36$export$ddcee0ea2d92c46f;
var $74982d8296291a36$export$596d806903d1f59e;
var $74982d8296291a36$export$c055de499085ef99;
var $74982d8296291a36$export$7abe78e1eda562aa;
var $74982d8296291a36$export$56c2ba9e13461f38;
var $74982d8296291a36$export$496319b8771deda5;
var $74982d8296291a36$export$f9582ef3c55143f;
$74982d8296291a36$export$8d6d009d1f06226e = `_9HMfgq_backButton`;
$74982d8296291a36$export$dc57ddd528b7443f = `_9HMfgq_buttonContainer`;
$74982d8296291a36$export$c4b0f5819f6a6663 = `_9HMfgq_circularProgress`;
$74982d8296291a36$export$a4c9bc12643ea157 = `_9HMfgq_disabledButton`;
$74982d8296291a36$export$493b5823483d2c4e = `_9HMfgq_errorMessage`;
$74982d8296291a36$export$ddcee0ea2d92c46f = `_9HMfgq_forgotPasswordLink`;
$74982d8296291a36$export$596d806903d1f59e = `_9HMfgq_login`;
$74982d8296291a36$export$c055de499085ef99 = `_9HMfgq_loginBox`;
$74982d8296291a36$export$7abe78e1eda562aa = `_9HMfgq_loginButton`;
$74982d8296291a36$export$56c2ba9e13461f38 = `_9HMfgq_loginForm`;
$74982d8296291a36$export$496319b8771deda5 = `_9HMfgq_passwordSent`;
$74982d8296291a36$export$f9582ef3c55143f = `_9HMfgq_versionInfo`;


const $15519e994ec8144e$var$Login = ()=>{
    const { oktaAuth: oktaAuth } = (0, $4df32aa15a91038c$export$2ae4a19e09ca9a00)();
    const widgetRef = $ieT14.useRef(null);
    $ieT14.useEffect(()=>{
        if (!widgetRef.current) return;
        const widget = new (0, $2e5fd53f383ba808$export$fb8416f1707f84a6)((0, $0eef21711cc31468$export$3766629a36a409c9));
        widget.authClient.session.exists().then(function(sessionExists) {
            if (sessionExists) widget.authClient.token.getWithoutPrompt().then(function(response) {
                localStorage.removeItem('firstName');
                localStorage.removeItem('lastName');
                oktaAuth.handleLoginRedirect(response.tokens);
            });
        });
        widget.showSignInToGetTokens({
            el: widgetRef.current,
            scopes: $0eef21711cc31468$export$54a06e3f4a159ad8
        }).then((tokens)=>{
            // Add tokens to storage
            oktaAuth.handleLoginRedirect(tokens);
        }).catch((err)=>{
            throw err;
        });
        return ()=>widget.remove();
    }, [
        oktaAuth
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $74982d8296291a36$export$596d806903d1f59e,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                ref: widgetRef
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                className: $74982d8296291a36$export$f9582ef3c55143f,
                children: "Version 2.12.0 \xa9 Powered by KAGR - 200 Patriot Place, Foxborough, MA 02035"
            })
        ]
    });
};
var $15519e994ec8144e$export$2e2bcd8739ae039 = $15519e994ec8144e$var$Login;


/*
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

var $ieT14 = parcelRequire("ieT14");





var $fpdl2 = parcelRequire("fpdl2");

const $f2d6d43ad1660b76$var$OktaLoginCallback = ()=>{
    const { oktaAuth: oktaAuth } = (0, $4df32aa15a91038c$export$2ae4a19e09ca9a00)();
    const widgetRef = $ieT14.useRef(null);
    $ieT14.useEffect(()=>{
        if (!widgetRef.current) return;
        const widget = new (0, $2e5fd53f383ba808$export$fb8416f1707f84a6)((0, $0eef21711cc31468$export$3766629a36a409c9));
        widget.authClient.session.exists().then(function(sessionExists) {
            if (sessionExists) widget.authClient.token.getWithoutPrompt().then(function(response) {
                oktaAuth.handleLoginRedirect(response.tokens);
            });
        });
        return ()=>widget.remove();
    }, [
        oktaAuth
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $74982d8296291a36$export$596d806903d1f59e,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                ref: widgetRef
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
            })
        ]
    });
};
var $f2d6d43ad1660b76$export$2e2bcd8739ae039 = $f2d6d43ad1660b76$var$OktaLoginCallback;




var $ieT14 = parcelRequire("ieT14");

var $eYoAG = parcelRequire("eYoAG");


var $ieT14 = parcelRequire("ieT14");

parcelRequire("ieT14");



var $eYoAG = parcelRequire("eYoAG");
(0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports))).ajaxSetup({
    cache: false,
    xhrFields: {
        withCredentials: true
    }
});
const $65ff79d5f12a411e$var$useRestService = ()=>{
    const baseURL = window.env.BASE_API;
    const { oktaAuth: oktaAuth } = (0, $4df32aa15a91038c$export$2ae4a19e09ca9a00)();
    const history = (0, $eYoAG.useHistory)();
    const get = (url)=>{
        const options = {
            headers: {
                'Content-Type': 'application/json'
            },
            crossDomain: true
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports))).ajax(baseURL + url, options);
    };
    const getAuth = (url)=>{
        let token = oktaAuth.getAccessToken();
        if (!token) return (0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports))).Deferred().reject('Access token required');
        const options = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            },
            xhrFields: {
                withCredentials: true
            },
            crossDomain: true
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports))).ajax(baseURL + url, options).catch((error)=>{
            return processError(error, false);
        });
    };
    const postAuth = (url, data)=>{
        let token = oktaAuth.getAccessToken();
        if (!token) return (0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports))).Deferred().reject('Access token required');
        const options = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            },
            type: 'POST',
            data: JSON.stringify(data),
            xhrFields: {
                withCredentials: true
            },
            crossDomain: true
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports))).ajax(baseURL + url, options).catch((error)=>{
            return processError(error, true);
        });
    };
    const postFileAuth = (url, data, file)=>{
        let token = oktaAuth.getAccessToken();
        if (!token) return (0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports))).Deferred().reject('Access token required');
        var formData = new FormData();
        formData.append('file', file);
        formData.append('data', data);
        const options = {
            headers: {
                Authorization: 'Bearer ' + token
            },
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            xhrFields: {
                withCredentials: true
            },
            crossDomain: true
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports))).ajax(baseURL + url, options).catch((error)=>{
            return processError(error, true);
        });
    };
    const post = (url, data)=>{
        const options = {
            type: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            proccessData: false,
            data: JSON.stringify(data),
            xhrFields: {
                withCredentials: true
            },
            crossDomain: true
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports))).ajax(baseURL + url, options).catch((error)=>{
            return processError(error, true);
        });
    };
    const putAuth = (url, data)=>{
        let token = oktaAuth.getAccessToken();
        if (!token) return (0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports))).Deferred().reject('Access token required');
        const options = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            },
            type: 'PUT',
            data: JSON.stringify(data),
            xhrFields: {
                withCredentials: true
            },
            crossDomain: true
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports))).ajax(baseURL + url, options).catch((error)=>{
            return processError(error, true);
        });
    };
    const deleteAuth = (url)=>{
        let token = oktaAuth.getAccessToken();
        if (!token) return (0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports))).Deferred().reject('Access token required');
        const options = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            },
            type: 'DELETE',
            xhrFields: {
                withCredentials: true
            },
            crossDomain: true
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($f26807820ae216d3$exports))).ajax(baseURL + url, options).catch((error)=>{
            return processError(error, true);
        });
    };
    const processError = (error, returnError)=>{
        if (error.status === 401 || error.status === 403) {
            localStorage.removeItem('firstName');
            localStorage.removeItem('lastName');
            oktaAuth.revokeAccessToken();
            oktaAuth.tokenManager.clear();
            oktaAuth.session.close();
            history.push('/login');
        }
        if (returnError) return error;
    };
    /**
   * Wrapper for fetch for use with React Query: throws Error on HTTP issues
   */ const fetchWrapper = async (url, requestInit, responseType)=>{
        const response = await fetch(baseURL + url, {
            headers: {
                Authorization: `Bearer ${oktaAuth.getAccessToken()}`,
                'Content-Type': 'application/json'
            },
            // By default, prevent fetch from using stale browser cache data. Check with server to validate whether the
            // previous response is still valid. Override with requestInit if desired.
            cache: 'no-cache',
            ...requestInit
        });
        if (!response.ok) {
            const isJson = response.headers.get('content-type')?.includes('application/json');
            const data = isJson ? await response.json() : null;
            let message;
            if (data && 'message' in data) message = data.message;
            else message = response.statusText;
            throw new Error(`HTTP ${response.status} Error${message && ': ' + message}`);
        }
        if (responseType === 'text') return response.text();
        if (responseType === 'blob') return response.blob();
        return response.json();
    };
    return {
        get: get,
        getAuth: getAuth,
        postAuth: postAuth,
        postFileAuth: postFileAuth,
        post: post,
        putAuth: putAuth,
        deleteAuth: deleteAuth,
        baseURL: baseURL,
        fetchWrapper: fetchWrapper
    };
};
var $65ff79d5f12a411e$export$2e2bcd8739ae039 = $65ff79d5f12a411e$var$useRestService;


var $8d092a71a781e0c6$export$34e0f9847d4c02dd;
var $8d092a71a781e0c6$export$a5f98448b9315739;
var $8d092a71a781e0c6$export$d99f0801a68bbcf1;
var $8d092a71a781e0c6$export$a95897cd297fe0bc;
var $8d092a71a781e0c6$export$f18d5b0af29128b7;
var $8d092a71a781e0c6$export$7fe7e9dc7567fdb0;
$8d092a71a781e0c6$export$34e0f9847d4c02dd = `rQIWva_container`;
$8d092a71a781e0c6$export$a5f98448b9315739 = `rQIWva_dashboard`;
$8d092a71a781e0c6$export$d99f0801a68bbcf1 = `rQIWva_mask`;
$8d092a71a781e0c6$export$a95897cd297fe0bc = `rQIWva_nameOverlay`;
$8d092a71a781e0c6$export$f18d5b0af29128b7 = `rQIWva_report`;
$8d092a71a781e0c6$export$7fe7e9dc7567fdb0 = `rQIWva_reportList`;



var $6mt9R = parcelRequire("6mt9R");

const $f850402a01591398$var$DashboardEntry = (props)=>{
    const { oktaAuth: oktaAuth } = (0, $4df32aa15a91038c$export$2ae4a19e09ca9a00)();
    const { baseURL: baseURL } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    const accessToken = oktaAuth.getAccessToken();
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $8d092a71a781e0c6$export$a5f98448b9315739,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h5", {
                children: props.dashboard.name
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $8d092a71a781e0c6$export$7fe7e9dc7567fdb0,
                children: props.dashboard.reports.map((report)=>{
                    return report.reportContentViewModels.map((reportContentViewModel)=>{
                        return reportContentViewModel.children.map((childViewModel)=>{
                            if (childViewModel.desktopTableauViewType === null || childViewModel.desktopTableauViewType.workbook === null) return;
                            const workbookId = childViewModel.desktopTableauViewType.workbook.id;
                            const viewId = childViewModel.desktopTableauViewType.id;
                            return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                className: $8d092a71a781e0c6$export$f18d5b0af29128b7,
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $6mt9R.Link), {
                                    to: `/reports/${report.reportId}`,
                                    children: [
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                            className: $8d092a71a781e0c6$export$d99f0801a68bbcf1
                                        }),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                            className: $8d092a71a781e0c6$export$a95897cd297fe0bc,
                                            children: childViewModel.name
                                        }),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("img", {
                                            src: `${baseURL}api/tableauapi/previewviews/${report.clientId}/${workbookId}/${viewId}?accessToken=${accessToken}`
                                        })
                                    ]
                                }, `${report.reportId}`)
                            }, `report-${report.reportId}`);
                        });
                    });
                })
            })
        ]
    });
};
var $f850402a01591398$export$2e2bcd8739ae039 = $f850402a01591398$var$DashboardEntry;




var $ieT14 = parcelRequire("ieT14");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $2859a788dfc21b3e$var$extendStatics = function(d, b) {
    $2859a788dfc21b3e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $2859a788dfc21b3e$var$extendStatics(d, b);
};
function $2859a788dfc21b3e$export$a8ba968b8961cb8a(d, b) {
    $2859a788dfc21b3e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $2859a788dfc21b3e$export$18ce0697a983be9b = function() {
    $2859a788dfc21b3e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2859a788dfc21b3e$export$18ce0697a983be9b.apply(this, arguments);
};
function $2859a788dfc21b3e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $2859a788dfc21b3e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $2859a788dfc21b3e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $2859a788dfc21b3e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $2859a788dfc21b3e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $2859a788dfc21b3e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $2859a788dfc21b3e$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $2859a788dfc21b3e$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $2859a788dfc21b3e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $2859a788dfc21b3e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $2859a788dfc21b3e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($2859a788dfc21b3e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $2859a788dfc21b3e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $2859a788dfc21b3e$export$10c90e4f7922046c(v) {
    return this instanceof $2859a788dfc21b3e$export$10c90e4f7922046c ? (this.v = v, this) : new $2859a788dfc21b3e$export$10c90e4f7922046c(v);
}
function $2859a788dfc21b3e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $2859a788dfc21b3e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $2859a788dfc21b3e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $2859a788dfc21b3e$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $2859a788dfc21b3e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $2859a788dfc21b3e$export$19a8beecd37a4c45 === "function" ? $2859a788dfc21b3e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $2859a788dfc21b3e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $2859a788dfc21b3e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $2859a788dfc21b3e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $2859a788dfc21b3e$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $2859a788dfc21b3e$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}



function $209814571e8229a4$export$3a718a742151bd80(candidate) {
    var result = {};
    Object.keys(candidate).forEach(function(key) {
        result[$209814571e8229a4$export$cc8b315fc368b20a(key)] = $209814571e8229a4$export$1d86e538ef995ad5(candidate[key]);
    });
    return result;
}
function $209814571e8229a4$export$1d86e538ef995ad5(candidate) {
    if (Array.isArray(candidate)) return candidate.map(function(value) {
        return $209814571e8229a4$export$1d86e538ef995ad5(value);
    });
    if (typeof candidate === 'object' && candidate !== null) return $209814571e8229a4$export$3a718a742151bd80(candidate);
    return candidate;
}
function $209814571e8229a4$export$cc8b315fc368b20a(word) {
    return word.replace(/[A-Z]/g, function(uppercaseLetter, index) {
        return "" + (index !== 0 ? '_' : '') + uppercaseLetter.toLowerCase();
    }).replace(/-/g, '_');
}
var $209814571e8229a4$var$isContextArray = function(value) {
    return Array.isArray(value);
};
var $209814571e8229a4$var$isContext = function(value) {
    return !Array.isArray(value) && typeof value === 'object' && value !== null;
};
function $209814571e8229a4$export$1be1fc439b849fdf() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    var destination;
    for(var _a = 0, sources_1 = sources; _a < sources_1.length; _a++){
        var source = sources_1[_a];
        // Ignore any undefined or null sources.
        if (source === undefined || source === null) continue;
        destination = $209814571e8229a4$export$f00f2bc10b5384e6(destination, source, $209814571e8229a4$export$2d4484db78b8baf7());
    }
    return destination;
}
function $209814571e8229a4$export$b7d58db314e0ac27(context) {
    return $209814571e8229a4$export$f00f2bc10b5384e6(undefined, context, $209814571e8229a4$export$2d4484db78b8baf7());
}
function $209814571e8229a4$export$2d4484db78b8baf7() {
    if (typeof WeakSet !== 'undefined') {
        var set_1 = new WeakSet();
        return {
            hasAlreadyBeenSeen: function(value) {
                var has = set_1.has(value);
                if (!has) set_1.add(value);
                return has;
            }
        };
    }
    var array = [];
    return {
        hasAlreadyBeenSeen: function(value) {
            var has = array.indexOf(value) >= 0;
            if (!has) array.push(value);
            return has;
        }
    };
}
function $209814571e8229a4$export$f00f2bc10b5384e6(destination, source, circularReferenceChecker) {
    // Ignore the 'source' if it is undefined
    if (source === undefined) return destination;
    // If the 'source' is not an object or array, it can't be merged with 'destination' in any way, so
    // return it directly.
    if (!$209814571e8229a4$var$isContext(source) && !$209814571e8229a4$var$isContextArray(source)) return source;
    // Return 'undefined' if we already iterated over this 'source' to avoid infinite recursion
    if (circularReferenceChecker.hasAlreadyBeenSeen(source)) return undefined;
    // 'source' and 'destination' are objects, merge them together
    if ($209814571e8229a4$var$isContext(source) && (destination === undefined || $209814571e8229a4$var$isContext(destination))) {
        var finalDestination = destination || {};
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) finalDestination[key] = $209814571e8229a4$export$f00f2bc10b5384e6(finalDestination[key], source[key], circularReferenceChecker);
        return finalDestination;
    }
    // 'source' and 'destination' are arrays, merge them together
    if ($209814571e8229a4$var$isContextArray(source) && (destination === undefined || $209814571e8229a4$var$isContextArray(destination))) {
        var finalDestination = destination || [];
        finalDestination.length = Math.max(finalDestination.length, source.length);
        for(var index = 0; index < source.length; index += 1)finalDestination[index] = $209814571e8229a4$export$f00f2bc10b5384e6(finalDestination[index], source[index], circularReferenceChecker);
        return finalDestination;
    }
    // The destination in not an array nor an object, so we can't merge it
    return source;
}



var $5a0134dee269a95e$export$4f7d2dba9330699b;
(function(ErrorSource) {
    ErrorSource["AGENT"] = "agent";
    ErrorSource["CONSOLE"] = "console";
    ErrorSource["NETWORK"] = "network";
    ErrorSource["SOURCE"] = "source";
    ErrorSource["LOGGER"] = "logger";
    ErrorSource["CUSTOM"] = "custom";
})($5a0134dee269a95e$export$4f7d2dba9330699b || ($5a0134dee269a95e$export$4f7d2dba9330699b = {}));
function $5a0134dee269a95e$export$58b296e18a9447b7(stackTrace, errorObject, nonErrorPrefix) {
    if (!stackTrace || stackTrace.message === undefined && !(errorObject instanceof Error)) return {
        message: nonErrorPrefix + " " + (0, $83a2a4f39556dd51$export$1f8609334739c2b6)(errorObject),
        stack: 'No stack, consider using an instance of Error',
        type: stackTrace && stackTrace.name
    };
    return {
        message: stackTrace.message || 'Empty message',
        stack: $5a0134dee269a95e$export$36ad41d7075a6f2b(stackTrace),
        type: stackTrace.name
    };
}
function $5a0134dee269a95e$export$36ad41d7075a6f2b(stack) {
    var result = (stack.name || 'Error') + ": " + stack.message;
    stack.stack.forEach(function(frame) {
        var func = frame.func === '?' ? '<anonymous>' : frame.func;
        var args = frame.args && frame.args.length > 0 ? "(" + frame.args.join(', ') + ")" : '';
        var line = frame.line ? ":" + frame.line : '';
        var column = frame.line && frame.column ? ":" + frame.column : '';
        result += "\n  at " + func + args + " @ " + frame.url + line + column;
    });
    return result;
}





// https://en.wikipedia.org/wiki/UTF-8
var $c09b4659606d56db$var$HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
/**
 * Use POST request without content type to:
 * - avoid CORS preflight requests
 * - allow usage of sendBeacon
 *
 * multiple elements are sent separated by \n in order
 * to be parsed correctly without content type header
 */ var $c09b4659606d56db$export$7587955500404ec3 = /** @class */ function() {
    function HttpRequest(endpointUrl, bytesLimit, withBatchTime) {
        if (withBatchTime === void 0) withBatchTime = false;
        this.endpointUrl = endpointUrl;
        this.bytesLimit = bytesLimit;
        this.withBatchTime = withBatchTime;
    }
    HttpRequest.prototype.send = function(data, size) {
        var url = this.withBatchTime ? $c09b4659606d56db$var$addBatchTime(this.endpointUrl) : this.endpointUrl;
        if (navigator.sendBeacon && size < this.bytesLimit) {
            var isQueued = navigator.sendBeacon(url, data);
            if (isQueued) return;
        }
        var request = new XMLHttpRequest();
        request.open('POST', url, true);
        request.send(data);
    };
    return HttpRequest;
}();
function $c09b4659606d56db$var$addBatchTime(url) {
    return "" + url + (url.indexOf('?') === -1 ? '?' : '&') + "batch_time=" + new Date().getTime();
}
var $c09b4659606d56db$export$33b107562567fc47 = /** @class */ function() {
    function Batch(request, maxSize, bytesLimit, maxMessageSize, flushTimeout, beforeUnloadCallback) {
        if (beforeUnloadCallback === void 0) beforeUnloadCallback = (0, $83a2a4f39556dd51$export$8793edee2d425525);
        this.request = request;
        this.maxSize = maxSize;
        this.bytesLimit = bytesLimit;
        this.maxMessageSize = maxMessageSize;
        this.flushTimeout = flushTimeout;
        this.beforeUnloadCallback = beforeUnloadCallback;
        this.pushOnlyBuffer = [];
        this.upsertBuffer = {};
        this.bufferBytesSize = 0;
        this.bufferMessageCount = 0;
        this.flushOnVisibilityHidden();
        this.flushPeriodically();
    }
    Batch.prototype.add = function(message) {
        this.addOrUpdate(message);
    };
    Batch.prototype.upsert = function(message, key) {
        this.addOrUpdate(message, key);
    };
    Batch.prototype.flush = function() {
        if (this.bufferMessageCount !== 0) {
            var messages = (0, $2859a788dfc21b3e$export$6388937ca91ccae8)(this.pushOnlyBuffer, (0, $83a2a4f39556dd51$export$ad1854f4a08c15f8)(this.upsertBuffer));
            this.request.send(messages.join('\n'), this.bufferBytesSize);
            this.pushOnlyBuffer = [];
            this.upsertBuffer = {};
            this.bufferBytesSize = 0;
            this.bufferMessageCount = 0;
        }
    };
    Batch.prototype.sizeInBytes = function(candidate) {
        // Accurate byte size computations can degrade performances when there is a lot of events to process
        if (!$c09b4659606d56db$var$HAS_MULTI_BYTES_CHARACTERS.test(candidate)) return candidate.length;
        if (window.TextEncoder !== undefined) return new TextEncoder().encode(candidate).length;
        return new Blob([
            candidate
        ]).size;
    };
    Batch.prototype.addOrUpdate = function(message, key) {
        var _a = this.process(message), processedMessage = _a.processedMessage, messageBytesSize = _a.messageBytesSize;
        if (messageBytesSize >= this.maxMessageSize) {
            console.warn("Discarded a message whose size was bigger than the maximum allowed size " + this.maxMessageSize + "KB.");
            return;
        }
        if (this.hasMessageFor(key)) this.remove(key);
        if (this.willReachedBytesLimitWith(messageBytesSize)) this.flush();
        this.push(processedMessage, messageBytesSize, key);
        if (this.isFull()) this.flush();
    };
    Batch.prototype.process = function(message) {
        var processedMessage = (0, $83a2a4f39556dd51$export$1f8609334739c2b6)(message);
        var messageBytesSize = this.sizeInBytes(processedMessage);
        return {
            processedMessage: processedMessage,
            messageBytesSize: messageBytesSize
        };
    };
    Batch.prototype.push = function(processedMessage, messageBytesSize, key) {
        if (this.bufferMessageCount > 0) // \n separator at serialization
        this.bufferBytesSize += 1;
        if (key !== undefined) this.upsertBuffer[key] = processedMessage;
        else this.pushOnlyBuffer.push(processedMessage);
        this.bufferBytesSize += messageBytesSize;
        this.bufferMessageCount += 1;
    };
    Batch.prototype.remove = function(key) {
        var removedMessage = this.upsertBuffer[key];
        delete this.upsertBuffer[key];
        var messageBytesSize = this.sizeInBytes(removedMessage);
        this.bufferBytesSize -= messageBytesSize;
        this.bufferMessageCount -= 1;
        if (this.bufferMessageCount > 0) this.bufferBytesSize -= 1;
    };
    Batch.prototype.hasMessageFor = function(key) {
        return key !== undefined && this.upsertBuffer[key] !== undefined;
    };
    Batch.prototype.willReachedBytesLimitWith = function(messageBytesSize) {
        // byte of the separator at the end of the message
        return this.bufferBytesSize + messageBytesSize + 1 >= this.bytesLimit;
    };
    Batch.prototype.isFull = function() {
        return this.bufferMessageCount === this.maxSize || this.bufferBytesSize >= this.bytesLimit;
    };
    Batch.prototype.flushPeriodically = function() {
        var _this = this;
        setTimeout(function() {
            _this.flush();
            _this.flushPeriodically();
        }, this.flushTimeout);
    };
    Batch.prototype.flushOnVisibilityHidden = function() {
        var _this = this;
        /**
         * With sendBeacon, requests are guaranteed to be successfully sent during document unload
         */ // @ts-ignore this function is not always defined
        if (navigator.sendBeacon) {
            /**
             * beforeunload is called before visibilitychange
             * register first to be sure to be called before flush on beforeunload
             * caveat: unload can still be canceled by another listener
             */ (0, $83a2a4f39556dd51$export$3f65cefe8380dbea)(window, (0, $83a2a4f39556dd51$export$54664c6599f7afe2).BEFORE_UNLOAD, this.beforeUnloadCallback);
            /**
             * Only event that guarantee to fire on mobile devices when the page transitions to background state
             * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
             */ (0, $83a2a4f39556dd51$export$3f65cefe8380dbea)(document, (0, $83a2a4f39556dd51$export$54664c6599f7afe2).VISIBILITY_CHANGE, function() {
                if (document.visibilityState === 'hidden') _this.flush();
            });
            /**
             * Safari does not support yet to send a request during:
             * - a visibility change during doc unload (cf: https://bugs.webkit.org/show_bug.cgi?id=194897)
             * - a page hide transition (cf: https://bugs.webkit.org/show_bug.cgi?id=188329)
             */ (0, $83a2a4f39556dd51$export$3f65cefe8380dbea)(window, (0, $83a2a4f39556dd51$export$54664c6599f7afe2).BEFORE_UNLOAD, function() {
                return _this.flush();
            });
        }
    };
    return Batch;
}();


// tslint:disable no-unsafe-any

var $970466414c4d6ba5$var$UNKNOWN_FUNCTION = '?';
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
// tslint:disable-next-line max-line-length
var $970466414c4d6ba5$var$ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;
/**
 * A better form of hasOwnProperty<br/>
 * Example: `has(MainHostObject, property) === true/false`
 *
 * @param {Object} object to check property
 * @param {string} key to check
 * @return {Boolean} true if the object has the key and it is not inherited
 */ function $970466414c4d6ba5$var$has(object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
}
/**
 * Returns true if the parameter is undefined<br/>
 * Example: `isUndefined(val) === true/false`
 *
 * @param {*} what Value to check
 * @return {Boolean} true if undefined and false otherwise
 */ function $970466414c4d6ba5$var$isUndefined(what) {
    return typeof what === 'undefined';
}
function $970466414c4d6ba5$export$4997ffc0176396a6(func) {
    function wrapped() {
        try {
            return func.apply(this, arguments);
        } catch (e) {
            $970466414c4d6ba5$export$f18d5b0af29128b7(e);
            throw e;
        }
    }
    return wrapped;
}
var $970466414c4d6ba5$export$f18d5b0af29128b7 = function reportModuleWrapper() {
    var handlers = [];
    var lastException;
    var lastExceptionStack;
    /**
     * Add a crash handler.
     * @param {Function} handler
     * @memberof report
     */ function subscribe(handler) {
        installGlobalHandler();
        installGlobalUnhandledRejectionHandler();
        handlers.push(handler);
    }
    /**
     * Remove a crash handler.
     * @param {Function} handler
     * @memberof report
     */ function unsubscribe(handler) {
        for(var i = handlers.length - 1; i >= 0; i -= 1)if (handlers[i] === handler) handlers.splice(i, 1);
        if (handlers.length === 0) {
            uninstallGlobalHandler();
            uninstallGlobalUnhandledRejectionHandler();
        }
    }
    /**
     * Dispatch stack information to all handlers.
     * @param {StackTrace} stack
     * @param {boolean} isWindowError Is this a top-level window error?
     * @param {Error=} error The error that's being handled (if available, null otherwise)
     * @memberof report
     * @throws An exception if an error occurs while calling an handler.
     */ function notifyHandlers(stack, isWindowError, error) {
        var exception;
        for(var i in handlers){
            if ($970466414c4d6ba5$var$has(handlers, i)) try {
                handlers[i](stack, isWindowError, error);
            } catch (inner) {
                exception = inner;
            }
        }
        if (exception) throw exception;
    }
    var oldOnerrorHandler;
    var onErrorHandlerInstalled;
    var oldOnunhandledrejectionHandler;
    var onUnhandledRejectionHandlerInstalled;
    /**
     * Ensures all global unhandled exceptions are recorded.
     * Supported by Gecko and IE.
     * @param {Event|string} message Error message.
     * @param {string=} url URL of script that generated the exception.
     * @param {(number|string)=} lineNo The line number at which the error occurred.
     * @param {(number|string)=} columnNo The column number at which the error occurred.
     * @param {Error=} errorObj The actual Error object.
     * @memberof report
     */ function traceKitWindowOnError(message, url, lineNo, columnNo, errorObj) {
        var stack;
        if (lastExceptionStack) {
            $970466414c4d6ba5$export$81296eded4f2ac09.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, "" + message);
            processLastException();
        } else if (errorObj) {
            stack = $970466414c4d6ba5$export$81296eded4f2ac09(errorObj);
            notifyHandlers(stack, true, errorObj);
        } else {
            var location_1 = {
                url: url,
                column: columnNo,
                line: lineNo
            };
            var name_1;
            var msg = message;
            if (({}).toString.call(message) === '[object String]') {
                var groups = msg.match($970466414c4d6ba5$var$ERROR_TYPES_RE);
                if (groups) {
                    name_1 = groups[1];
                    msg = groups[2];
                }
            }
            stack = {
                name: name_1,
                message: msg,
                stack: [
                    location_1
                ]
            };
            notifyHandlers(stack, true);
        }
        if (oldOnerrorHandler) return oldOnerrorHandler.apply(this, arguments);
        return false;
    }
    /**
     * Ensures all unhandled rejections are recorded.
     * @param {PromiseRejectionEvent} e event.
     * @memberof report
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onunhandledrejection
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
     */ function traceKitWindowOnUnhandledRejection(e) {
        var reason = e.reason || 'Empty reason';
        var stack = $970466414c4d6ba5$export$81296eded4f2ac09(reason);
        notifyHandlers(stack, true, reason);
    }
    /**
     * Install a global onerror handler
     * @memberof report
     */ function installGlobalHandler() {
        if (onErrorHandlerInstalled) return;
        oldOnerrorHandler = window.onerror;
        window.onerror = (0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(traceKitWindowOnError);
        onErrorHandlerInstalled = true;
    }
    /**
     * Uninstall the global onerror handler
     * @memberof report
     */ function uninstallGlobalHandler() {
        if (onErrorHandlerInstalled) {
            window.onerror = oldOnerrorHandler;
            onErrorHandlerInstalled = false;
        }
    }
    /**
     * Install a global onunhandledrejection handler
     * @memberof report
     */ function installGlobalUnhandledRejectionHandler() {
        if (onUnhandledRejectionHandlerInstalled) return;
        oldOnunhandledrejectionHandler = window.onunhandledrejection !== null ? window.onunhandledrejection : undefined;
        window.onunhandledrejection = (0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(traceKitWindowOnUnhandledRejection);
        onUnhandledRejectionHandlerInstalled = true;
    }
    /**
     * Uninstall the global onunhandledrejection handler
     * @memberof report
     */ function uninstallGlobalUnhandledRejectionHandler() {
        if (onUnhandledRejectionHandlerInstalled) {
            window.onunhandledrejection = oldOnunhandledrejectionHandler;
            onUnhandledRejectionHandlerInstalled = false;
        }
    }
    /**
     * Process the most recent exception
     * @memberof report
     */ function processLastException() {
        var currentLastExceptionStack = lastExceptionStack;
        var currentLastException = lastException;
        lastExceptionStack = undefined;
        lastException = undefined;
        notifyHandlers(currentLastExceptionStack, false, currentLastException);
    }
    /**
     * Reports an unhandled Error.
     * @param {Error} ex
     * @memberof report
     * @throws An exception if an incomplete stack trace is detected (old IE browsers).
     */ function doReport(ex) {
        if (lastExceptionStack) {
            if (lastException === ex) return; // already caught by an inner catch block, ignore
            processLastException();
        }
        var stack = $970466414c4d6ba5$export$81296eded4f2ac09(ex);
        lastExceptionStack = stack;
        lastException = ex;
        // If the stack trace is incomplete, wait for 2 seconds for
        // slow slow IE to see if onerror occurs or not before reporting
        // this exception; otherwise, we will end up with an incomplete
        // stack trace
        setTimeout(function() {
            if (lastException === ex) processLastException();
        }, stack.incomplete ? 2000 : 0);
        throw ex; // re-throw to propagate to the top level (and cause window.onerror)
    }
    doReport.subscribe = subscribe;
    doReport.unsubscribe = unsubscribe;
    doReport.traceKitWindowOnError = traceKitWindowOnError;
    return doReport;
}();
var $970466414c4d6ba5$export$81296eded4f2ac09 = function computeStackTraceWrapper() {
    var debug = false;
    // Contents of Exception in various browsers.
    //
    // SAFARI:
    // ex.message = Can't find variable: qq
    // ex.line = 59
    // ex.sourceId = 580238192
    // ex.sourceURL = http://...
    // ex.expressionBeginOffset = 96
    // ex.expressionCaretOffset = 98
    // ex.expressionEndOffset = 98
    // ex.name = ReferenceError
    //
    // FIREFOX:
    // ex.message = qq is not defined
    // ex.fileName = http://...
    // ex.lineNumber = 59
    // ex.columnNumber = 69
    // ex.stack = ...stack trace... (see the example below)
    // ex.name = ReferenceError
    //
    // CHROME:
    // ex.message = qq is not defined
    // ex.name = ReferenceError
    // ex.type = not_defined
    // ex.arguments = ['aa']
    // ex.stack = ...stack trace...
    //
    // INTERNET EXPLORER:
    // ex.message = ...
    // ex.name = ReferenceError
    //
    // OPERA:
    // ex.message = ...message... (see the example below)
    // ex.name = ReferenceError
    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'
    /**
     * Computes stack trace information from the stack property.
     * Chrome and Gecko use this property.
     * @param {Error} ex
     * @return {?StackTrace} Stack trace information.
     * @memberof computeStackTrace
     */ function computeStackTraceFromStackProp(ex) {
        if (!ex.stack) return;
        // tslint:disable-next-line max-line-length
        var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
        // tslint:disable-next-line max-line-length
        var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
        // tslint:disable-next-line max-line-length
        var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
        // Used to additionally parse URL/line/column from eval frames
        var isEval;
        var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
        var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
        var lines = ex.stack.split('\n');
        var stack = [];
        var submatch;
        var parts;
        var element;
        for(var i = 0, j = lines.length; i < j; i += 1){
            if (chrome.exec(lines[i])) {
                parts = chrome.exec(lines[i]);
                var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
                isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
                submatch = chromeEval.exec(parts[2]);
                if (isEval && submatch) {
                    // throw out eval line/column and use top-most line/column number
                    parts[2] = submatch[1]; // url
                    parts[3] = submatch[2]; // line
                    parts[4] = submatch[3]; // column
                }
                element = {
                    args: isNative ? [
                        parts[2]
                    ] : [],
                    column: parts[4] ? +parts[4] : undefined,
                    func: parts[1] || $970466414c4d6ba5$var$UNKNOWN_FUNCTION,
                    line: parts[3] ? +parts[3] : undefined,
                    url: !isNative ? parts[2] : undefined
                };
            } else if (winjs.exec(lines[i])) {
                parts = winjs.exec(lines[i]);
                element = {
                    args: [],
                    column: parts[4] ? +parts[4] : undefined,
                    func: parts[1] || $970466414c4d6ba5$var$UNKNOWN_FUNCTION,
                    line: +parts[3],
                    url: parts[2]
                };
            } else if (gecko.exec(lines[i])) {
                parts = gecko.exec(lines[i]);
                isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
                submatch = geckoEval.exec(parts[3]);
                if (isEval && submatch) {
                    // throw out eval line/column and use top-most line number
                    parts[3] = submatch[1];
                    parts[4] = submatch[2];
                    parts[5] = undefined; // no column when eval
                } else if (i === 0 && !parts[5] && !$970466414c4d6ba5$var$isUndefined(ex.columnNumber)) // FireFox uses this awesome columnNumber property for its top frame
                // Also note, Firefox's column number is 0-based and everything else expects 1-based,
                // so adding 1
                // NOTE: this hack doesn't work if top-most frame is eval
                stack[0].column = ex.columnNumber + 1;
                element = {
                    args: parts[2] ? parts[2].split(',') : [],
                    column: parts[5] ? +parts[5] : undefined,
                    func: parts[1] || $970466414c4d6ba5$var$UNKNOWN_FUNCTION,
                    line: parts[4] ? +parts[4] : undefined,
                    url: parts[3]
                };
            } else continue;
            if (!element.func && element.line) element.func = $970466414c4d6ba5$var$UNKNOWN_FUNCTION;
            stack.push(element);
        }
        if (!stack.length) return;
        return {
            stack: stack,
            message: ex.message,
            name: ex.name
        };
    }
    /**
     * Computes stack trace information from the stacktrace property.
     * Opera 10+ uses this property.
     * @param {Error} ex
     * @return {?StackTrace} Stack trace information.
     * @memberof computeStackTrace
     */ function computeStackTraceFromStacktraceProp(ex) {
        // Access and store the stacktrace property before doing ANYTHING
        // else to it because Opera is not very good at providing it
        // reliably in other circumstances.
        var stacktrace = ex.stacktrace;
        if (!stacktrace) return;
        var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
        // tslint:disable-next-line max-line-length
        var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\))? in (.*):\s*$/i;
        var lines = stacktrace.split('\n');
        var stack = [];
        var parts;
        for(var line = 0; line < lines.length; line += 2){
            var element = void 0;
            if (opera10Regex.exec(lines[line])) {
                parts = opera10Regex.exec(lines[line]);
                element = {
                    args: [],
                    column: undefined,
                    func: parts[3],
                    line: +parts[1],
                    url: parts[2]
                };
            } else if (opera11Regex.exec(lines[line])) {
                parts = opera11Regex.exec(lines[line]);
                element = {
                    args: parts[5] ? parts[5].split(',') : [],
                    column: +parts[2],
                    func: parts[3] || parts[4],
                    line: +parts[1],
                    url: parts[6]
                };
            }
            if (element) {
                if (!element.func && element.line) element.func = $970466414c4d6ba5$var$UNKNOWN_FUNCTION;
                element.context = [
                    lines[line + 1]
                ];
                stack.push(element);
            }
        }
        if (!stack.length) return;
        return {
            stack: stack,
            message: ex.message,
            name: ex.name
        };
    }
    /**
     * NOT TESTED.
     * Computes stack trace information from an error message that includes
     * the stack trace.
     * Opera 9 and earlier use this method if the option to show stack
     * traces is turned on in opera:config.
     * @param {Error} ex
     * @return {?StackTrace} Stack information.
     * @memberof computeStackTrace
     */ function computeStackTraceFromOperaMultiLineMessage(ex) {
        // TODO: Clean this function up
        // Opera includes a stack trace into the exception message. An example is:
        //
        // Statement on line 3: Undefined variable: undefinedFunc
        // Backtrace:
        //   Line 3 of linked script file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.js:
        //   In function zzz
        //         undefinedFunc(a);
        //   Line 7 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html:
        //   In function yyy
        //           zzz(x, y, z);
        //   Line 3 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html:
        //   In function xxx
        //           yyy(a, a, a);
        //   Line 1 of function script
        //     try { xxx('hi'); return false; } catch(ex) { report(ex); }
        //   ...
        var lines = ex.message.split('\n');
        if (lines.length < 4) return;
        var lineRE1 = /^\s*Line (\d+) of linked script ((?:file|https?|blob)\S+)(?:: in function (\S+))?\s*$/i;
        var lineRE2 = /^\s*Line (\d+) of inline#(\d+) script in ((?:file|https?|blob)\S+)(?:: in function (\S+))?\s*$/i;
        var lineRE3 = /^\s*Line (\d+) of function script\s*$/i;
        var stack = [];
        var scripts = window && window.document && window.document.getElementsByTagName('script');
        var inlineScriptBlocks = [];
        var parts;
        for(var s in scripts)if ($970466414c4d6ba5$var$has(scripts, s) && !scripts[s].src) inlineScriptBlocks.push(scripts[s]);
        for(var line = 2; line < lines.length; line += 2){
            var item = void 0;
            if (lineRE1.exec(lines[line])) {
                parts = lineRE1.exec(lines[line]);
                item = {
                    args: [],
                    column: undefined,
                    func: parts[3],
                    line: +parts[1],
                    url: parts[2]
                };
            } else if (lineRE2.exec(lines[line])) {
                parts = lineRE2.exec(lines[line]);
                item = {
                    args: [],
                    column: undefined,
                    func: parts[4],
                    line: +parts[1],
                    url: parts[3]
                };
            } else if (lineRE3.exec(lines[line])) {
                parts = lineRE3.exec(lines[line]);
                var url = window.location.href.replace(/#.*$/, '');
                item = {
                    url: url,
                    args: [],
                    column: undefined,
                    func: '',
                    line: +parts[1]
                };
            }
            if (item) {
                if (!item.func) item.func = $970466414c4d6ba5$var$UNKNOWN_FUNCTION;
                item.context = [
                    lines[line + 1]
                ];
                stack.push(item);
            }
        }
        if (!stack.length) return; // could not parse multiline exception message as Opera stack trace
        return {
            stack: stack,
            message: lines[0],
            name: ex.name
        };
    }
    /**
     * Adds information about the first frame to incomplete stack traces.
     * Safari and IE require this to get complete data on the first frame.
     * @param {StackTrace} stackInfo Stack trace information from
     * one of the compute* methods.
     * @param {string=} url The URL of the script that caused an error.
     * @param {(number|string)=} lineNo The line number of the script that
     * caused an error.
     * @param {string=} message The error generated by the browser, which
     * hopefully contains the name of the object that caused the error.
     * @return {boolean} Whether or not the stack information was
     * augmented.
     * @memberof computeStackTrace
     */ function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
        var initial = {
            url: url,
            line: lineNo ? +lineNo : undefined
        };
        if (initial.url && initial.line) {
            stackInfo.incomplete = false;
            var stack = stackInfo.stack;
            if (stack.length > 0) {
                if (stack[0].url === initial.url) {
                    if (stack[0].line === initial.line) return false; // already in stack trace
                    if (!stack[0].line && stack[0].func === initial.func) {
                        stack[0].line = initial.line;
                        stack[0].context = initial.context;
                        return false;
                    }
                }
            }
            stack.unshift(initial);
            stackInfo.partial = true;
            return true;
        }
        stackInfo.incomplete = true;
        return false;
    }
    /**
     * Computes stack trace information by walking the arguments.caller
     * chain at the time the exception occurred. This will cause earlier
     * frames to be missed but is the only way to get any stack trace in
     * Safari and IE. The top frame is restored by
     * {@link augmentStackTraceWithInitialElement}.
     * @param {Error} ex
     * @param {number} depth
     * @return {StackTrace} Stack trace information.
     * @memberof computeStackTrace
     */ function computeStackTraceByWalkingCallerChain(ex, depth) {
        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i;
        var stack = [];
        var funcs = {};
        var recursion = false;
        var parts;
        var item;
        for(var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller){
            if (curr === $970466414c4d6ba5$export$81296eded4f2ac09 || curr === $970466414c4d6ba5$export$f18d5b0af29128b7) continue;
            item = {
                args: [],
                column: undefined,
                func: $970466414c4d6ba5$var$UNKNOWN_FUNCTION,
                line: undefined,
                url: undefined
            };
            parts = functionName.exec(curr.toString());
            if (curr.name) item.func = curr.name;
            else if (parts) item.func = parts[1];
            if (typeof item.func === 'undefined') item.func = parts ? parts.input.substring(0, parts.input.indexOf('{')) : undefined;
            if (funcs["" + curr]) recursion = true;
            else funcs["" + curr] = true;
            stack.push(item);
        }
        if (depth) stack.splice(0, depth);
        var result = {
            stack: stack,
            message: ex.message,
            name: ex.name
        };
        augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
        return result;
    }
    /**
     * Computes a stack trace for an exception.
     * @param {Error} ex
     * @param {(string|number)=} depth
     * @memberof computeStackTrace
     */ function doComputeStackTrace(ex, depth) {
        var stack;
        var normalizedDepth = depth === undefined ? 0 : +depth;
        try {
            // This must be tried first because Opera 10 *destroys*
            // its stacktrace property if you try to access the stack
            // property first!!
            stack = computeStackTraceFromStacktraceProp(ex);
            if (stack) return stack;
        } catch (e) {
            if (debug) throw e;
        }
        try {
            stack = computeStackTraceFromStackProp(ex);
            if (stack) return stack;
        } catch (e) {
            if (debug) throw e;
        }
        try {
            stack = computeStackTraceFromOperaMultiLineMessage(ex);
            if (stack) return stack;
        } catch (e) {
            if (debug) throw e;
        }
        try {
            stack = computeStackTraceByWalkingCallerChain(ex, normalizedDepth + 1);
            if (stack) return stack;
        } catch (e) {
            if (debug) throw e;
        }
        return {
            message: ex.message,
            name: ex.name,
            stack: []
        };
    }
    /**
     * Logs a stacktrace starting from the previous call and working down.
     * @param {(number|string)=} depth How many frames deep to trace.
     * @return {StackTrace} Stack trace information.
     * @memberof computeStackTrace
     */ function computeStackTraceOfCaller(depth) {
        var currentDepth = (depth === undefined ? 0 : +depth) + 1; // "+ 1" because "ofCaller" should drop one frame
        try {
            throw new Error();
        } catch (ex) {
            return $970466414c4d6ba5$export$81296eded4f2ac09(ex, currentDepth + 1);
        }
    }
    doComputeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
    doComputeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
    doComputeStackTrace.ofCaller = computeStackTraceOfCaller;
    return doComputeStackTrace;
}();
function $970466414c4d6ba5$export$4accbe35a68387b9() {
    function helper(fnName) {
        var originalFn = window[fnName];
        window[fnName] = function traceKitAsyncExtension() {
            // Make a copy of the arguments
            var args = [].slice.call(arguments);
            var originalCallback = args[0];
            if (typeof originalCallback === 'function') args[0] = $970466414c4d6ba5$export$4997ffc0176396a6(originalCallback);
            // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
            // also only supports 2 argument and doesn't care what "this" is, so we
            // can just call the original function directly.
            if (originalFn.apply) return originalFn.apply(this, args);
            return originalFn(args[0], args[1]);
        };
    }
    helper('setTimeout');
    helper('setInterval');
}


var $09f70ea01c107b30$var$StatusType;
(function(StatusType) {
    StatusType["info"] = "info";
    StatusType["error"] = "error";
})($09f70ea01c107b30$var$StatusType || ($09f70ea01c107b30$var$StatusType = {}));
var $09f70ea01c107b30$var$monitoringConfiguration = {
    maxMessagesPerPage: 0,
    sentMessageCount: 0
};
var $09f70ea01c107b30$var$externalContextProvider;
function $09f70ea01c107b30$export$31fa68b107731c85(configuration) {
    if (configuration.internalMonitoringEndpoint) {
        var batch = $09f70ea01c107b30$var$startMonitoringBatch(configuration);
        $83a2a4f39556dd51$export$e6e34fd1f2686227($09f70ea01c107b30$var$monitoringConfiguration, {
            batch: batch,
            maxMessagesPerPage: configuration.maxInternalMonitoringMessagesPerPage,
            sentMessageCount: 0
        });
    }
    return {
        setExternalContextProvider: function(provider) {
            $09f70ea01c107b30$var$externalContextProvider = provider;
        }
    };
}
function $09f70ea01c107b30$var$startMonitoringBatch(configuration) {
    var primaryBatch = createMonitoringBatch(configuration.internalMonitoringEndpoint);
    var replicaBatch;
    if (configuration.replica !== undefined) replicaBatch = createMonitoringBatch(configuration.replica.internalMonitoringEndpoint);
    function createMonitoringBatch(endpointUrl) {
        return new (0, $c09b4659606d56db$export$33b107562567fc47)(new (0, $c09b4659606d56db$export$7587955500404ec3)(endpointUrl, configuration.batchBytesLimit), configuration.maxBatchSize, configuration.batchBytesLimit, configuration.maxMessageSize, configuration.flushTimeout);
    }
    function withContext(message) {
        return (0, $209814571e8229a4$export$1be1fc439b849fdf)({
            date: new Date().getTime(),
            view: {
                referrer: document.referrer,
                url: window.location.href
            }
        }, $09f70ea01c107b30$var$externalContextProvider !== undefined ? $09f70ea01c107b30$var$externalContextProvider() : {}, message);
    }
    return {
        add: function(message) {
            var contextualizedMessage = withContext(message);
            primaryBatch.add(contextualizedMessage);
            if (replicaBatch) replicaBatch.add(contextualizedMessage);
        }
    };
}
function $09f70ea01c107b30$export$3391fb0aba49e1a4() {
    $09f70ea01c107b30$var$monitoringConfiguration.batch = undefined;
}
function $09f70ea01c107b30$export$efef192ceb8f8a31(_, __, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function() {
        var decorated = $09f70ea01c107b30$var$monitoringConfiguration.batch ? $09f70ea01c107b30$export$ec5b303098bc4b7f(originalMethod) : originalMethod;
        return decorated.apply(this, arguments);
    };
}
function $09f70ea01c107b30$export$ec5b303098bc4b7f(fn) {
    return function() {
        try {
            return fn.apply(this, arguments);
        } catch (e) {
            $09f70ea01c107b30$var$logErrorIfDebug(e);
            try {
                $09f70ea01c107b30$var$addErrorToMonitoringBatch(e);
            } catch (e) {
                $09f70ea01c107b30$var$logErrorIfDebug(e);
            }
        }
    }; // consider output type has input type
}
function $09f70ea01c107b30$export$16846acd4b472b8d(message, context) {
    $09f70ea01c107b30$var$logMessageIfDebug(message);
    $09f70ea01c107b30$var$addToMonitoringBatch((0, $2859a788dfc21b3e$export$18ce0697a983be9b)((0, $2859a788dfc21b3e$export$18ce0697a983be9b)({
        message: message
    }, context), {
        status: $09f70ea01c107b30$var$StatusType.info
    }));
}
function $09f70ea01c107b30$var$addErrorToMonitoringBatch(e) {
    $09f70ea01c107b30$var$addToMonitoringBatch((0, $2859a788dfc21b3e$export$18ce0697a983be9b)((0, $2859a788dfc21b3e$export$18ce0697a983be9b)({}, $09f70ea01c107b30$var$formatError(e)), {
        status: $09f70ea01c107b30$var$StatusType.error
    }));
}
function $09f70ea01c107b30$var$addToMonitoringBatch(message) {
    if ($09f70ea01c107b30$var$monitoringConfiguration.batch && $09f70ea01c107b30$var$monitoringConfiguration.sentMessageCount < $09f70ea01c107b30$var$monitoringConfiguration.maxMessagesPerPage) {
        $09f70ea01c107b30$var$monitoringConfiguration.sentMessageCount += 1;
        $09f70ea01c107b30$var$monitoringConfiguration.batch.add(message);
    }
}
function $09f70ea01c107b30$var$formatError(e) {
    if (e instanceof Error) {
        var stackTrace = (0, $970466414c4d6ba5$export$81296eded4f2ac09)(e);
        return {
            error: {
                kind: stackTrace.name,
                stack: (0, $5a0134dee269a95e$export$36ad41d7075a6f2b)(stackTrace)
            },
            message: stackTrace.message
        };
    }
    return {
        error: {
            stack: 'Not an instance of error'
        },
        message: "Uncaught " + $83a2a4f39556dd51$export$1f8609334739c2b6(e)
    };
}
function $09f70ea01c107b30$export$2be227cb6aa211be(debugMode) {
    $09f70ea01c107b30$var$monitoringConfiguration.debugMode = debugMode;
}
function $09f70ea01c107b30$var$logErrorIfDebug(e) {
    if ($09f70ea01c107b30$var$monitoringConfiguration.debugMode) // Log as warn to not forward the logs.
    console.warn('[INTERNAL ERROR]', e);
}
function $09f70ea01c107b30$var$logMessageIfDebug(message) {
    if ($09f70ea01c107b30$var$monitoringConfiguration.debugMode) console.log('[MONITORING MESSAGE]', message);
}


var $83a2a4f39556dd51$export$32c0454ceff7f92d = 1000;
var $83a2a4f39556dd51$export$35acaebf644db34e = 60 * $83a2a4f39556dd51$export$32c0454ceff7f92d;
var $83a2a4f39556dd51$export$82541edf19e5e3b0 = 60 * $83a2a4f39556dd51$export$35acaebf644db34e;
var $83a2a4f39556dd51$export$7384b1bedb3b9f1d = 1024;
var $83a2a4f39556dd51$export$54664c6599f7afe2;
(function(DOM_EVENT) {
    DOM_EVENT["BEFORE_UNLOAD"] = "beforeunload";
    DOM_EVENT["CLICK"] = "click";
    DOM_EVENT["KEY_DOWN"] = "keydown";
    DOM_EVENT["LOAD"] = "load";
    DOM_EVENT["POP_STATE"] = "popstate";
    DOM_EVENT["SCROLL"] = "scroll";
    DOM_EVENT["TOUCH_START"] = "touchstart";
    DOM_EVENT["VISIBILITY_CHANGE"] = "visibilitychange";
    DOM_EVENT["DOM_CONTENT_LOADED"] = "DOMContentLoaded";
    DOM_EVENT["POINTER_DOWN"] = "pointerdown";
    DOM_EVENT["POINTER_UP"] = "pointerup";
    DOM_EVENT["POINTER_CANCEL"] = "pointercancel";
    DOM_EVENT["HASH_CHANGE"] = "hashchange";
    DOM_EVENT["PAGE_HIDE"] = "pagehide";
    DOM_EVENT["MOUSE_DOWN"] = "mousedown";
})($83a2a4f39556dd51$export$54664c6599f7afe2 || ($83a2a4f39556dd51$export$54664c6599f7afe2 = {}));
var $83a2a4f39556dd51$export$c6f9da6f70cfc2eb;
(function(ResourceType) {
    ResourceType["DOCUMENT"] = "document";
    ResourceType["XHR"] = "xhr";
    ResourceType["BEACON"] = "beacon";
    ResourceType["FETCH"] = "fetch";
    ResourceType["CSS"] = "css";
    ResourceType["JS"] = "js";
    ResourceType["IMAGE"] = "image";
    ResourceType["FONT"] = "font";
    ResourceType["MEDIA"] = "media";
    ResourceType["OTHER"] = "other";
})($83a2a4f39556dd51$export$c6f9da6f70cfc2eb || ($83a2a4f39556dd51$export$c6f9da6f70cfc2eb = {}));
var $83a2a4f39556dd51$export$8d9ecf8a6190d0ad;
(function(RequestType) {
    RequestType["FETCH"] = "fetch";
    RequestType["XHR"] = "xhr";
})($83a2a4f39556dd51$export$8d9ecf8a6190d0ad || ($83a2a4f39556dd51$export$8d9ecf8a6190d0ad = {}));
function $83a2a4f39556dd51$export$de363e709c412c8a(fn, wait, options) {
    var needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
    var needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
    var inWaitPeriod = false;
    var hasPendingExecution = false;
    var pendingTimeoutId;
    return {
        throttled: function() {
            var _this = this;
            if (inWaitPeriod) {
                hasPendingExecution = true;
                return;
            }
            if (needLeadingExecution) fn.apply(this);
            else hasPendingExecution = true;
            inWaitPeriod = true;
            pendingTimeoutId = window.setTimeout(function() {
                if (needTrailingExecution && hasPendingExecution) fn.apply(_this);
                inWaitPeriod = false;
                hasPendingExecution = false;
            }, wait);
        },
        cancel: function() {
            window.clearTimeout(pendingTimeoutId);
            inWaitPeriod = false;
            hasPendingExecution = false;
        }
    };
}
function $83a2a4f39556dd51$export$e6e34fd1f2686227(target) {
    var toAssign = [];
    for(var _i = 1; _i < arguments.length; _i++)toAssign[_i - 1] = arguments[_i];
    toAssign.forEach(function(source) {
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    });
}
function $83a2a4f39556dd51$export$e73c8bd0f20705a(placeholder) {
    return placeholder ? (parseInt(placeholder, 10) ^ Math.random() * 16 >> parseInt(placeholder, 10) / 4).toString(16) : "10000000-1000-4000-8000-100000000000".replace(/[018]/g, $83a2a4f39556dd51$export$e73c8bd0f20705a);
}
function $83a2a4f39556dd51$export$72c7afebfef3b500(threshold) {
    return threshold !== 0 && Math.random() * 100 <= threshold;
}
function $83a2a4f39556dd51$export$2077e0241d6afd3c(num, decimals) {
    return +num.toFixed(decimals);
}
function $83a2a4f39556dd51$export$7f62184c713eab1c(duration) {
    if (typeof duration !== 'number') return duration;
    return $83a2a4f39556dd51$export$2077e0241d6afd3c(duration * 1e6, 0);
}
function $83a2a4f39556dd51$export$8793edee2d425525() {}
function $83a2a4f39556dd51$export$1f8609334739c2b6(value, replacer, space) {
    if (value === null || value === undefined) return JSON.stringify(value);
    var originalToJSON = [
        false,
        undefined
    ];
    if ($83a2a4f39556dd51$var$hasToJSON(value)) {
        // We need to add a flag and not rely on the truthiness of value.toJSON
        // because it can be set but undefined and that's actually significant.
        originalToJSON = [
            true,
            value.toJSON
        ];
        delete value.toJSON;
    }
    var originalProtoToJSON = [
        false,
        undefined
    ];
    var prototype;
    if (typeof value === 'object') {
        prototype = Object.getPrototypeOf(value);
        if ($83a2a4f39556dd51$var$hasToJSON(prototype)) {
            originalProtoToJSON = [
                true,
                prototype.toJSON
            ];
            delete prototype.toJSON;
        }
    }
    var result;
    try {
        result = JSON.stringify(value, undefined, space);
    } catch (_a) {
        result = '<error: unable to serialize object>';
    } finally{
        if (originalToJSON[0]) value.toJSON = originalToJSON[1];
        if (originalProtoToJSON[0]) prototype.toJSON = originalProtoToJSON[1];
    }
    return result;
}
function $83a2a4f39556dd51$var$hasToJSON(value) {
    return typeof value === 'object' && value !== null && value.hasOwnProperty('toJSON');
}
function $83a2a4f39556dd51$export$ee2e0f811dca1807(candidate, search) {
    // tslint:disable-next-line: no-unsafe-any
    return candidate.indexOf(search) !== -1;
}
function $83a2a4f39556dd51$export$71aa6c912b956294(array, predicate) {
    for(var i = 0; i < array.length; i += 1){
        var item = array[i];
        if (predicate(item, i, array)) return item;
    }
    return undefined;
}
function $83a2a4f39556dd51$export$d86432a85610ea90(value) {
    return $83a2a4f39556dd51$export$7e4aa119212bc614(value) && value >= 0 && value <= 100;
}
function $83a2a4f39556dd51$export$7e4aa119212bc614(value) {
    return typeof value === 'number';
}
function $83a2a4f39556dd51$export$493c11ff22f45a24(timestamp) {
    return timestamp - $83a2a4f39556dd51$export$c4afa0b643ef74c9();
}
function $83a2a4f39556dd51$export$3c95c4c8b671ef0(relativeTime) {
    return Math.floor($83a2a4f39556dd51$export$c4afa0b643ef74c9() + relativeTime);
}
/**
 * Navigation start slightly change on some rare cases
 */ var $83a2a4f39556dd51$var$navigationStart;
function $83a2a4f39556dd51$export$c4afa0b643ef74c9() {
    if ($83a2a4f39556dd51$var$navigationStart === undefined) $83a2a4f39556dd51$var$navigationStart = performance.timing.navigationStart;
    return $83a2a4f39556dd51$var$navigationStart;
}
function $83a2a4f39556dd51$export$ad1854f4a08c15f8(object) {
    var values = [];
    Object.keys(object).forEach(function(key) {
        values.push(object[key]);
    });
    return values;
}
function $83a2a4f39556dd51$export$6a29ade99f81ec8a(object) {
    return Object.keys(object).map(function(key) {
        return [
            key,
            object[key]
        ];
    });
}
function $83a2a4f39556dd51$export$83b788b1a3698c03(object) {
    return Object.keys(object).length === 0;
}
function $83a2a4f39556dd51$export$256479dc0cea61c4() {
    if (typeof globalThis === 'object') return globalThis;
    Object.defineProperty(Object.prototype, '_dd_temp_', {
        get: function() {
            return this;
        },
        configurable: true
    });
    // @ts-ignore
    var globalObject = _dd_temp_;
    // @ts-ignore
    delete Object.prototype._dd_temp_;
    if (typeof globalObject !== 'object') {
        // on safari _dd_temp_ is available on window but not globally
        // fallback on other browser globals check
        if (typeof self === 'object') globalObject = self;
        else if (typeof window === 'object') globalObject = window;
        else globalObject = {};
    }
    return globalObject;
}
function $83a2a4f39556dd51$export$4e4972392113943c() {
    return $83a2a4f39556dd51$export$20ce3cd54d7c02b4(window.location);
}
function $83a2a4f39556dd51$export$20ce3cd54d7c02b4(element) {
    if (element.origin) return element.origin;
    var sanitizedHost = element.host.replace(/(:80|:443)$/, '');
    return element.protocol + "//" + sanitizedHost;
}
function $83a2a4f39556dd51$export$fe87bb5193f3e70(rawString, name) {
    var matches = rawString.match("(?:^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
    return matches ? matches[1] : undefined;
}
function $83a2a4f39556dd51$export$b26462d2f74496cd(candidate, length) {
    var lastChar = candidate.charCodeAt(length - 1);
    // check if it is the high part of a surrogate pair
    if (lastChar >= 0xd800 && lastChar <= 0xdbff) return candidate.slice(0, length + 1);
    return candidate.slice(0, length);
}
function $83a2a4f39556dd51$export$3f65cefe8380dbea(emitter, event, listener, options) {
    return $83a2a4f39556dd51$export$40a4ed63e5cb7043(emitter, [
        event
    ], listener, options);
}
function $83a2a4f39556dd51$export$40a4ed63e5cb7043(emitter, events, listener, _a) {
    var _b = _a === void 0 ? {} : _a, once = _b.once, capture = _b.capture, passive = _b.passive;
    var wrapedListener = (0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(once ? function(event) {
        stop();
        listener(event);
    } : listener);
    var options = passive ? {
        capture: capture,
        passive: passive
    } : capture;
    events.forEach(function(event) {
        return emitter.addEventListener(event, wrapedListener, options);
    });
    var stop = function() {
        return events.forEach(function(event) {
            return emitter.removeEventListener(event, wrapedListener, options);
        });
    };
    return {
        stop: stop
    };
}


var $9d292372f5260b87$export$c6202ae3e8db94d1 = (0, $83a2a4f39556dd51$export$32c0454ceff7f92d);
function $9d292372f5260b87$export$ca01dc094798ac57(name, options) {
    var timeout;
    var cache;
    var hasCache = false;
    var cacheAccess = function() {
        hasCache = true;
        window.clearTimeout(timeout);
        timeout = window.setTimeout(function() {
            hasCache = false;
        }, $9d292372f5260b87$export$c6202ae3e8db94d1);
    };
    return {
        get: function() {
            if (hasCache) return cache;
            cache = $9d292372f5260b87$export$4be65e66cfa2648a(name);
            cacheAccess();
            return cache;
        },
        set: function(value, expireDelay) {
            $9d292372f5260b87$export$110700823644f4a6(name, value, expireDelay, options);
            cache = value;
            cacheAccess();
        }
    };
}
function $9d292372f5260b87$export$110700823644f4a6(name, value, expireDelay, options) {
    var date = new Date();
    date.setTime(date.getTime() + expireDelay);
    var expires = "expires=" + date.toUTCString();
    var sameSite = options && options.crossSite ? 'none' : 'strict';
    var domain = options && options.domain ? ";domain=" + options.domain : '';
    var secure = options && options.secure ? ";secure" : '';
    document.cookie = name + "=" + value + ";" + expires + ";path=/;samesite=" + sameSite + domain + secure;
}
function $9d292372f5260b87$export$4be65e66cfa2648a(name) {
    return (0, $83a2a4f39556dd51$export$fe87bb5193f3e70)(document.cookie, name);
}
function $9d292372f5260b87$export$29b13dee24cadcda(options) {
    if (document.cookie === undefined || document.cookie === null) return false;
    try {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_cookie_test_" + (0, $83a2a4f39556dd51$export$e73c8bd0f20705a)();
        var testCookieValue = 'test';
        $9d292372f5260b87$export$110700823644f4a6(testCookieName, testCookieValue, (0, $83a2a4f39556dd51$export$32c0454ceff7f92d), options);
        return $9d292372f5260b87$export$4be65e66cfa2648a(testCookieName) === testCookieValue;
    } catch (error) {
        console.error(error);
        return false;
    }
}
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */ var $9d292372f5260b87$var$getCurrentSiteCache;
function $9d292372f5260b87$export$8d7fb5ac3c42095() {
    if ($9d292372f5260b87$var$getCurrentSiteCache === undefined) {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_site_test_" + (0, $83a2a4f39556dd51$export$e73c8bd0f20705a)();
        var testCookieValue = 'test';
        var domainLevels = window.location.hostname.split('.');
        var candidateDomain = domainLevels.pop();
        while(domainLevels.length && !$9d292372f5260b87$export$4be65e66cfa2648a(testCookieName)){
            candidateDomain = domainLevels.pop() + "." + candidateDomain;
            $9d292372f5260b87$export$110700823644f4a6(testCookieName, testCookieValue, (0, $83a2a4f39556dd51$export$32c0454ceff7f92d), {
                domain: candidateDomain
            });
        }
        $9d292372f5260b87$var$getCurrentSiteCache = candidateDomain;
    }
    return $9d292372f5260b87$var$getCurrentSiteCache;
}






var $94dd796a7c747e79$export$f13334073abcece = {
    allowedTracingOrigins: [],
    maxErrorsByMinute: 3000,
    maxInternalMonitoringMessagesPerPage: 15,
    resourceSampleRate: 100,
    sampleRate: 100,
    silentMultipleInit: false,
    trackInteractions: false,
    /**
     * arbitrary value, byte precision not needed
     */ requestErrorResponseLengthLimit: 32 * (0, $83a2a4f39556dd51$export$7384b1bedb3b9f1d),
    /**
     * flush automatically, aim to be lower than ALB connection timeout
     * to maximize connection reuse.
     */ flushTimeout: 30 * (0, $83a2a4f39556dd51$export$32c0454ceff7f92d),
    /**
     * Logs intake limit
     */ maxBatchSize: 50,
    maxMessageSize: 256 * (0, $83a2a4f39556dd51$export$7384b1bedb3b9f1d),
    /**
     * beacon payload max queue size implementation is 64kb
     * ensure that we leave room for logs, rum and potential other users
     */ batchBytesLimit: 16 * (0, $83a2a4f39556dd51$export$7384b1bedb3b9f1d)
};
var $94dd796a7c747e79$var$ENDPOINTS = {
    alternate: {
        logs: 'logs',
        rum: 'rum',
        trace: 'trace'
    },
    classic: {
        logs: 'browser',
        rum: 'rum',
        trace: 'public-trace'
    }
};
function $94dd796a7c747e79$export$f8352245bee68086(userConfiguration, buildEnv) {
    var transportConfiguration = {
        applicationId: userConfiguration.applicationId,
        buildMode: buildEnv.buildMode,
        clientToken: userConfiguration.clientToken,
        env: userConfiguration.env,
        proxyHost: userConfiguration.proxyHost,
        sdkVersion: buildEnv.sdkVersion,
        service: userConfiguration.service,
        site: userConfiguration.site || (0, $be3c451a0388de8d$export$57427f2ed2871819)[userConfiguration.datacenter || buildEnv.datacenter],
        version: userConfiguration.version
    };
    var enableExperimentalFeatures = Array.isArray(userConfiguration.enableExperimentalFeatures) ? userConfiguration.enableExperimentalFeatures : [];
    var intakeType = userConfiguration.useAlternateIntakeDomains ? 'alternate' : 'classic';
    var intakeUrls = $94dd796a7c747e79$var$getIntakeUrls(intakeType, transportConfiguration, userConfiguration.replica !== undefined);
    var configuration = (0, $2859a788dfc21b3e$export$18ce0697a983be9b)({
        cookieOptions: $94dd796a7c747e79$export$d037e740f60b1dc5(userConfiguration),
        isEnabled: function(feature) {
            return (0, $83a2a4f39556dd51$export$ee2e0f811dca1807)(enableExperimentalFeatures, feature);
        },
        logsEndpoint: $94dd796a7c747e79$var$getEndpoint(intakeType, 'logs', transportConfiguration),
        proxyHost: userConfiguration.proxyHost,
        rumEndpoint: $94dd796a7c747e79$var$getEndpoint(intakeType, 'rum', transportConfiguration),
        service: userConfiguration.service,
        traceEndpoint: $94dd796a7c747e79$var$getEndpoint(intakeType, 'trace', transportConfiguration),
        isIntakeUrl: function(url) {
            return intakeUrls.some(function(intakeUrl) {
                return url.indexOf(intakeUrl) === 0;
            });
        }
    }, $94dd796a7c747e79$export$f13334073abcece);
    if (userConfiguration.internalMonitoringApiKey) configuration.internalMonitoringEndpoint = $94dd796a7c747e79$var$getEndpoint(intakeType, 'logs', transportConfiguration, 'browser-agent-internal-monitoring');
    if ('allowedTracingOrigins' in userConfiguration) configuration.allowedTracingOrigins = userConfiguration.allowedTracingOrigins;
    if ('sampleRate' in userConfiguration) configuration.sampleRate = userConfiguration.sampleRate;
    if ('resourceSampleRate' in userConfiguration) configuration.resourceSampleRate = userConfiguration.resourceSampleRate;
    if ('trackInteractions' in userConfiguration) configuration.trackInteractions = !!userConfiguration.trackInteractions;
    if (transportConfiguration.buildMode === (0, $be3c451a0388de8d$export$4f7785bdd020a830).E2E_TEST) {
        configuration.internalMonitoringEndpoint = '<<< E2E INTERNAL MONITORING ENDPOINT >>>';
        configuration.logsEndpoint = '<<< E2E LOGS ENDPOINT >>>';
        configuration.rumEndpoint = '<<< E2E RUM ENDPOINT >>>';
    }
    if (transportConfiguration.buildMode === (0, $be3c451a0388de8d$export$4f7785bdd020a830).STAGING) {
        if (userConfiguration.replica !== undefined) {
            var replicaTransportConfiguration = (0, $2859a788dfc21b3e$export$18ce0697a983be9b)((0, $2859a788dfc21b3e$export$18ce0697a983be9b)({}, transportConfiguration), {
                applicationId: userConfiguration.replica.applicationId,
                clientToken: userConfiguration.replica.clientToken,
                site: (0, $be3c451a0388de8d$export$57427f2ed2871819)[(0, $be3c451a0388de8d$export$b73954fdb789ff1d).US]
            });
            configuration.replica = {
                applicationId: userConfiguration.replica.applicationId,
                internalMonitoringEndpoint: $94dd796a7c747e79$var$getEndpoint(intakeType, 'logs', replicaTransportConfiguration, 'browser-agent-internal-monitoring'),
                logsEndpoint: $94dd796a7c747e79$var$getEndpoint(intakeType, 'logs', replicaTransportConfiguration),
                rumEndpoint: $94dd796a7c747e79$var$getEndpoint(intakeType, 'rum', replicaTransportConfiguration)
            };
        }
    }
    return configuration;
}
function $94dd796a7c747e79$export$d037e740f60b1dc5(userConfiguration) {
    var cookieOptions = {};
    cookieOptions.secure = $94dd796a7c747e79$var$mustUseSecureCookie(userConfiguration);
    cookieOptions.crossSite = !!userConfiguration.useCrossSiteSessionCookie;
    if (!!userConfiguration.trackSessionAcrossSubdomains) cookieOptions.domain = (0, $9d292372f5260b87$export$8d7fb5ac3c42095)();
    return cookieOptions;
}
function $94dd796a7c747e79$var$getEndpoint(intakeType, endpointType, conf, source) {
    var tags = "sdk_version:" + conf.sdkVersion + ("" + (conf.env ? ",env:" + conf.env : '')) + ("" + (conf.service ? ",service:" + conf.service : '')) + ("" + (conf.version ? ",version:" + conf.version : ''));
    var datadogHost = $94dd796a7c747e79$var$getHost(intakeType, endpointType, conf.site);
    var host = conf.proxyHost ? conf.proxyHost : datadogHost;
    var proxyParameter = conf.proxyHost ? "ddhost=" + datadogHost + "&" : '';
    var applicationIdParameter = conf.applicationId ? "_dd.application_id=" + conf.applicationId + "&" : '';
    var parameters = "" + applicationIdParameter + proxyParameter + "ddsource=" + (source || 'browser') + "&ddtags=" + tags;
    return "https://" + host + "/v1/input/" + conf.clientToken + "?" + parameters;
}
function $94dd796a7c747e79$var$getHost(intakeType, endpointType, site) {
    var endpoint = $94dd796a7c747e79$var$ENDPOINTS[intakeType][endpointType];
    if (intakeType === 'classic') return endpoint + "-http-intake.logs." + site;
    var domainParts = site.split('.');
    var extension = domainParts.pop();
    var suffix = domainParts.join('-') + "." + extension;
    return endpoint + ".browser-intake-" + suffix;
}
function $94dd796a7c747e79$var$getIntakeUrls(intakeType, conf, withReplica) {
    if (conf.proxyHost) return [
        "https://" + conf.proxyHost + "/v1/input/"
    ];
    var sites = [
        conf.site
    ];
    if (conf.buildMode === (0, $be3c451a0388de8d$export$4f7785bdd020a830).STAGING && withReplica) sites.push((0, $be3c451a0388de8d$export$57427f2ed2871819)[(0, $be3c451a0388de8d$export$b73954fdb789ff1d).US]);
    var urls = [];
    var endpointTypes = Object.keys($94dd796a7c747e79$var$ENDPOINTS[intakeType]);
    for(var _i = 0, sites_1 = sites; _i < sites_1.length; _i++){
        var site = sites_1[_i];
        for(var _a = 0, endpointTypes_1 = endpointTypes; _a < endpointTypes_1.length; _a++){
            var endpointType = endpointTypes_1[_a];
            urls.push("https://" + $94dd796a7c747e79$var$getHost(intakeType, endpointType, site) + "/v1/input/");
        }
    }
    return urls;
}
function $94dd796a7c747e79$var$mustUseSecureCookie(userConfiguration) {
    return !!userConfiguration.useSecureSessionCookie || !!userConfiguration.useCrossSiteSessionCookie;
}



var $be3c451a0388de8d$var$_a;
function $be3c451a0388de8d$export$f9cbdb3394538aba(stub) {
    var global = (0, $2859a788dfc21b3e$export$18ce0697a983be9b)((0, $2859a788dfc21b3e$export$18ce0697a983be9b)({}, stub), {
        // This API method is intentionally not monitored, since the only thing executed is the
        // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
        // we don't want to interfer with the user uncaught exceptions.
        onReady: function(callback) {
            callback();
        }
    });
    // Add an "hidden" property to set debug mode. We define it that way to hide it
    // as much as possible but of course it's not a real protection.
    Object.defineProperty(global, '_setDebug', {
        get: function() {
            return 0, $09f70ea01c107b30$export$2be227cb6aa211be;
        },
        enumerable: false
    });
    return global;
}
function $be3c451a0388de8d$export$884b45263866f2b7(global, name, api) {
    var existingGlobalVariable = global[name];
    global[name] = api;
    if (existingGlobalVariable && existingGlobalVariable.q) existingGlobalVariable.q.forEach(function(fn) {
        return fn();
    });
}
var $be3c451a0388de8d$export$b73954fdb789ff1d;
(function(Datacenter) {
    Datacenter["US"] = "us";
    Datacenter["EU"] = "eu";
})($be3c451a0388de8d$export$b73954fdb789ff1d || ($be3c451a0388de8d$export$b73954fdb789ff1d = {}));
var $be3c451a0388de8d$export$57427f2ed2871819 = ($be3c451a0388de8d$var$_a = {}, $be3c451a0388de8d$var$_a[$be3c451a0388de8d$export$b73954fdb789ff1d.EU] = 'datadoghq.eu', $be3c451a0388de8d$var$_a[$be3c451a0388de8d$export$b73954fdb789ff1d.US] = 'datadoghq.com', $be3c451a0388de8d$var$_a);
var $be3c451a0388de8d$export$4f7785bdd020a830;
(function(BuildMode) {
    BuildMode["RELEASE"] = "release";
    BuildMode["STAGING"] = "staging";
    BuildMode["E2E_TEST"] = "e2e-test";
})($be3c451a0388de8d$export$4f7785bdd020a830 || ($be3c451a0388de8d$export$4f7785bdd020a830 = {}));
function $be3c451a0388de8d$export$6f264bb8dad46c3c(userConfiguration, buildEnv) {
    var configuration = (0, $94dd796a7c747e79$export$f8352245bee68086)(userConfiguration, buildEnv);
    var internalMonitoring = (0, $09f70ea01c107b30$export$31fa68b107731c85)(configuration);
    return {
        configuration: configuration,
        internalMonitoring: internalMonitoring
    };
}
function $be3c451a0388de8d$export$f703bde2c3a224fb(options) {
    if (!(0, $9d292372f5260b87$export$29b13dee24cadcda)(options)) {
        console.warn('Cookies are not authorized, we will not send any data.');
        return false;
    }
    return true;
}
function $be3c451a0388de8d$export$cfdc694e5825aaa6() {
    if ($be3c451a0388de8d$var$isLocalFile()) {
        console.error('Execution is not allowed in the current context.');
        return false;
    }
    return true;
}
function $be3c451a0388de8d$var$isLocalFile() {
    return window.location.protocol === 'file:';
}


var $811952fd6645b932$var$DEFAULT_LIMIT = 10000;
var $811952fd6645b932$export$6f427737fb8ce4c5 = /** @class */ function() {
    function BoundedBuffer(limit) {
        if (limit === void 0) limit = $811952fd6645b932$var$DEFAULT_LIMIT;
        this.limit = limit;
        this.buffer = [];
    }
    BoundedBuffer.prototype.add = function(item) {
        var length = this.buffer.push(item);
        if (length > this.limit) this.buffer.splice(0, 1);
    };
    BoundedBuffer.prototype.drain = function(fn) {
        this.buffer.forEach(function(item) {
            return fn(item);
        });
        this.buffer.length = 0;
    };
    return BoundedBuffer;
}();

function $869d81f90661e153$export$fe3149b78a43e1ad() {
    var context = {};
    return {
        get: function() {
            return context;
        },
        add: function(key, value) {
            context[key] = value;
        },
        remove: function(key) {
            delete context[key];
        },
        set: function(newContext) {
            context = newContext;
        }
    };
}



var $9c4fc5ab3856082d$export$b21eaca6c6da9627;
(function(LifeCycleEventType) {
    LifeCycleEventType[LifeCycleEventType["PERFORMANCE_ENTRY_COLLECTED"] = 0] = "PERFORMANCE_ENTRY_COLLECTED";
    LifeCycleEventType[LifeCycleEventType["AUTO_ACTION_CREATED"] = 1] = "AUTO_ACTION_CREATED";
    LifeCycleEventType[LifeCycleEventType["AUTO_ACTION_COMPLETED"] = 2] = "AUTO_ACTION_COMPLETED";
    LifeCycleEventType[LifeCycleEventType["AUTO_ACTION_DISCARDED"] = 3] = "AUTO_ACTION_DISCARDED";
    LifeCycleEventType[LifeCycleEventType["VIEW_CREATED"] = 4] = "VIEW_CREATED";
    LifeCycleEventType[LifeCycleEventType["VIEW_UPDATED"] = 5] = "VIEW_UPDATED";
    LifeCycleEventType[LifeCycleEventType["REQUEST_STARTED"] = 6] = "REQUEST_STARTED";
    LifeCycleEventType[LifeCycleEventType["REQUEST_COMPLETED"] = 7] = "REQUEST_COMPLETED";
    LifeCycleEventType[LifeCycleEventType["SESSION_RENEWED"] = 8] = "SESSION_RENEWED";
    LifeCycleEventType[LifeCycleEventType["DOM_MUTATED"] = 9] = "DOM_MUTATED";
    LifeCycleEventType[LifeCycleEventType["BEFORE_UNLOAD"] = 10] = "BEFORE_UNLOAD";
    LifeCycleEventType[LifeCycleEventType["RAW_RUM_EVENT_COLLECTED"] = 11] = "RAW_RUM_EVENT_COLLECTED";
    LifeCycleEventType[LifeCycleEventType["RAW_RUM_EVENT_V2_COLLECTED"] = 12] = "RAW_RUM_EVENT_V2_COLLECTED";
    LifeCycleEventType[LifeCycleEventType["RUM_EVENT_COLLECTED"] = 13] = "RUM_EVENT_COLLECTED";
    LifeCycleEventType[LifeCycleEventType["RUM_EVENT_V2_COLLECTED"] = 14] = "RUM_EVENT_V2_COLLECTED";
})($9c4fc5ab3856082d$export$b21eaca6c6da9627 || ($9c4fc5ab3856082d$export$b21eaca6c6da9627 = {}));
var $9c4fc5ab3856082d$export$6af70476896cbaec = /** @class */ function() {
    function LifeCycle() {
        this.callbacks = {};
    }
    LifeCycle.prototype.notify = function(eventType, data) {
        var eventCallbacks = this.callbacks[eventType];
        if (eventCallbacks) eventCallbacks.forEach(function(callback) {
            return callback(data);
        });
    };
    LifeCycle.prototype.subscribe = function(eventType, callback) {
        var _this = this;
        if (!this.callbacks[eventType]) this.callbacks[eventType] = [];
        this.callbacks[eventType].push(callback);
        return {
            unsubscribe: function() {
                _this.callbacks[eventType] = _this.callbacks[eventType].filter(function(other) {
                    return callback !== other;
                });
            }
        };
    };
    return LifeCycle;
}();



var $9e3879a7141a94c3$export$1951f08c2d18ec43;
(function(RumEventCategory) {
    RumEventCategory["USER_ACTION"] = "user_action";
    RumEventCategory["ERROR"] = "error";
    RumEventCategory["LONG_TASK"] = "long_task";
    RumEventCategory["VIEW"] = "view";
    RumEventCategory["RESOURCE"] = "resource";
})($9e3879a7141a94c3$export$1951f08c2d18ec43 || ($9e3879a7141a94c3$export$1951f08c2d18ec43 = {}));


var $dfb817fd62da85ed$export$ce36bdd8bcd00f70;
(function(RumEventType) {
    RumEventType["ACTION"] = "action";
    RumEventType["ERROR"] = "error";
    RumEventType["LONG_TASK"] = "long_task";
    RumEventType["VIEW"] = "view";
    RumEventType["RESOURCE"] = "resource";
})($dfb817fd62da85ed$export$ce36bdd8bcd00f70 || ($dfb817fd62da85ed$export$ce36bdd8bcd00f70 = {}));



function $7746d68c83e78bbf$export$a50549f6fbbed49b(lifeCycle, callback) {
    if (callback === void 0) callback = (0, $83a2a4f39556dd51$export$8793edee2d425525);
    var eventCounts = {
        errorCount: 0,
        longTaskCount: 0,
        resourceCount: 0,
        userActionCount: 0
    };
    var subscription = lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).RAW_RUM_EVENT_COLLECTED, function(_a) {
        var rawRumEvent = _a.rawRumEvent;
        switch(rawRumEvent.evt.category){
            case (0, $9e3879a7141a94c3$export$1951f08c2d18ec43).ERROR:
                eventCounts.errorCount += 1;
                callback(eventCounts);
                break;
            case (0, $9e3879a7141a94c3$export$1951f08c2d18ec43).USER_ACTION:
                eventCounts.userActionCount += 1;
                callback(eventCounts);
                break;
            case (0, $9e3879a7141a94c3$export$1951f08c2d18ec43).LONG_TASK:
                eventCounts.longTaskCount += 1;
                callback(eventCounts);
                break;
            case (0, $9e3879a7141a94c3$export$1951f08c2d18ec43).RESOURCE:
                eventCounts.resourceCount += 1;
                callback(eventCounts);
                break;
        }
    });
    var subscriptionV2 = lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).RAW_RUM_EVENT_V2_COLLECTED, function(_a) {
        var rawRumEvent = _a.rawRumEvent;
        switch(rawRumEvent.type){
            case (0, $dfb817fd62da85ed$export$ce36bdd8bcd00f70).ERROR:
                eventCounts.errorCount += 1;
                callback(eventCounts);
                break;
            case (0, $dfb817fd62da85ed$export$ce36bdd8bcd00f70).ACTION:
                eventCounts.userActionCount += 1;
                callback(eventCounts);
                break;
            case (0, $dfb817fd62da85ed$export$ce36bdd8bcd00f70).LONG_TASK:
                eventCounts.longTaskCount += 1;
                callback(eventCounts);
                break;
            case (0, $dfb817fd62da85ed$export$ce36bdd8bcd00f70).RESOURCE:
                eventCounts.resourceCount += 1;
                callback(eventCounts);
                break;
        }
    });
    return {
        stop: function() {
            subscription.unsubscribe();
            subscriptionV2.unsubscribe();
        },
        eventCounts: eventCounts
    };
}


var $94423d3dd781adb9$export$77cea355fa80b5f4 = /** @class */ function() {
    function Observable() {
        this.observers = [];
    }
    Observable.prototype.subscribe = function(f) {
        this.observers.push(f);
    };
    Observable.prototype.notify = function(data) {
        this.observers.forEach(function(observer) {
            return observer(data);
        });
    };
    return Observable;
}();



var $756559e45e643551$export$a59477b089b98865 = 100;
var $756559e45e643551$export$daa5d178ead00ab = 100;
var $756559e45e643551$export$93c561106323bd40 = 10000;
function $756559e45e643551$export$b191740c85d918c5(lifeCycle, completionCallback) {
    var _a = $756559e45e643551$export$e793f371e6778f87(lifeCycle), pageActivitiesObservable = _a.observable, stopPageActivitiesTracking = _a.stop;
    var stopWaitPageActivitiesCompletion = $756559e45e643551$export$f1f8e28b8b3ee6e4(pageActivitiesObservable, stopPageActivitiesTracking, completionCallback).stop;
    function stop() {
        stopWaitPageActivitiesCompletion();
        stopPageActivitiesTracking();
    }
    return {
        stop: stop
    };
}
function $756559e45e643551$export$e793f371e6778f87(lifeCycle) {
    var observable = new (0, $94423d3dd781adb9$export$77cea355fa80b5f4)();
    var subscriptions = [];
    var firstRequestIndex;
    var pendingRequestsCount = 0;
    subscriptions.push(lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).DOM_MUTATED, function() {
        return notifyPageActivity();
    }));
    subscriptions.push(lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).PERFORMANCE_ENTRY_COLLECTED, function(entry) {
        if (entry.entryType !== 'resource') return;
        notifyPageActivity();
    }));
    subscriptions.push(lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).REQUEST_STARTED, function(startEvent) {
        if (firstRequestIndex === undefined) firstRequestIndex = startEvent.requestIndex;
        pendingRequestsCount += 1;
        notifyPageActivity();
    }));
    subscriptions.push(lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).REQUEST_COMPLETED, function(request) {
        // If the request started before the tracking start, ignore it
        if (firstRequestIndex === undefined || request.requestIndex < firstRequestIndex) return;
        pendingRequestsCount -= 1;
        notifyPageActivity();
    }));
    function notifyPageActivity() {
        observable.notify({
            isBusy: pendingRequestsCount > 0
        });
    }
    return {
        observable: observable,
        stop: function() {
            subscriptions.forEach(function(s) {
                return s.unsubscribe();
            });
        }
    };
}
function $756559e45e643551$export$f1f8e28b8b3ee6e4(pageActivitiesObservable, stopPageActivitiesTracking, completionCallback) {
    var idleTimeoutId;
    var hasCompleted = false;
    var validationTimeoutId = setTimeout((0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(function() {
        return complete(false, 0);
    }), $756559e45e643551$export$a59477b089b98865);
    var maxDurationTimeoutId = setTimeout((0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(function() {
        return complete(true, performance.now());
    }), $756559e45e643551$export$93c561106323bd40);
    pageActivitiesObservable.subscribe(function(_a) {
        var isBusy = _a.isBusy;
        clearTimeout(validationTimeoutId);
        clearTimeout(idleTimeoutId);
        var lastChangeTime = performance.now();
        if (!isBusy) idleTimeoutId = setTimeout((0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(function() {
            return complete(true, lastChangeTime);
        }), $756559e45e643551$export$daa5d178ead00ab);
    });
    function stop() {
        hasCompleted = true;
        clearTimeout(validationTimeoutId);
        clearTimeout(idleTimeoutId);
        clearTimeout(maxDurationTimeoutId);
        stopPageActivitiesTracking();
    }
    function complete(hadActivity, endTime) {
        if (hasCompleted) return;
        stop();
        completionCallback(hadActivity, endTime);
    }
    return {
        stop: stop
    };
}



function $c151d097cc3dcc78$export$9c46f8d96b9f088f(element) {
    // Proceed to get the action name in two steps:
    // * first, get the name programmatically, explicitly defined by the user.
    // * then, use strategies that are known to return good results. Those strategies will be used on
    //   the element and a few parents, but it's likely that they won't succeed at all.
    // * if no name is found this way, use strategies returning less accurate names as a fallback.
    //   Those are much likely to succeed.
    return $c151d097cc3dcc78$var$getActionNameFromElementProgrammatically(element) || $c151d097cc3dcc78$var$getActionNameFromElementForStrategies(element, $c151d097cc3dcc78$var$priorityStrategies) || $c151d097cc3dcc78$var$getActionNameFromElementForStrategies(element, $c151d097cc3dcc78$var$fallbackStrategies) || '';
}
/**
 * Get the action name from the attribute 'data-dd-action-name' on the element or any of its parent.
 */ var $c151d097cc3dcc78$var$PROGRAMMATIC_ATTRIBUTE = 'data-dd-action-name';
function $c151d097cc3dcc78$var$getActionNameFromElementProgrammatically(targetElement) {
    var elementWithAttribute;
    // We don't use getActionNameFromElementForStrategies here, because we want to consider all parents,
    // without limit. It is up to the user to declare a relevant naming strategy.
    // If available, use element.closest() to match get the attribute from the element or any of its
    // parent.  Else fallback to a more traditional implementation.
    if ($c151d097cc3dcc78$var$supportsElementClosest()) elementWithAttribute = targetElement.closest("[" + $c151d097cc3dcc78$var$PROGRAMMATIC_ATTRIBUTE + "]");
    else {
        var element = targetElement;
        while(element){
            if (element.hasAttribute($c151d097cc3dcc78$var$PROGRAMMATIC_ATTRIBUTE)) {
                elementWithAttribute = element;
                break;
            }
            element = element.parentElement;
        }
    }
    if (!elementWithAttribute) return;
    var name = elementWithAttribute.getAttribute($c151d097cc3dcc78$var$PROGRAMMATIC_ATTRIBUTE);
    return $c151d097cc3dcc78$var$truncate($c151d097cc3dcc78$var$normalizeWhitespace(name.trim()));
}
var $c151d097cc3dcc78$var$priorityStrategies = [
    // associated LABEL text
    function(element) {
        // IE does not support element.labels, so we fallback to a CSS selector based on the element id
        // instead
        if ($c151d097cc3dcc78$var$supportsLabelProperty()) {
            if ('labels' in element && element.labels && element.labels.length > 0) return $c151d097cc3dcc78$var$getTextualContent(element.labels[0]);
        } else if (element.id) {
            var label = element.ownerDocument && element.ownerDocument.querySelector("label[for=\"" + element.id.replace('"', '\\"') + "\"]");
            return label && $c151d097cc3dcc78$var$getTextualContent(label);
        }
    },
    // INPUT button (and associated) value
    function(element) {
        if (element.nodeName === 'INPUT') {
            var input = element;
            var type = input.getAttribute('type');
            if (type === 'button' || type === 'submit' || type === 'reset') return input.value;
        }
    },
    // BUTTON, LABEL or button-like element text
    function(element) {
        if (element.nodeName === 'BUTTON' || element.nodeName === 'LABEL' || element.getAttribute('role') === 'button') return $c151d097cc3dcc78$var$getTextualContent(element);
    },
    function(element) {
        return element.getAttribute('aria-label');
    },
    // associated element text designated by the aria-labelledby attribute
    function(element) {
        var labelledByAttribute = element.getAttribute('aria-labelledby');
        if (labelledByAttribute) return labelledByAttribute.split(/\s+/).map(function(id) {
            return $c151d097cc3dcc78$var$getElementById(element, id);
        }).filter(function(label) {
            return Boolean(label);
        }).map($c151d097cc3dcc78$var$getTextualContent).join(' ');
    },
    function(element) {
        return element.getAttribute('alt');
    },
    function(element) {
        return element.getAttribute('name');
    },
    function(element) {
        return element.getAttribute('title');
    },
    function(element) {
        return element.getAttribute('placeholder');
    },
    // SELECT first OPTION text
    function(element) {
        if ('options' in element && element.options.length > 0) return $c151d097cc3dcc78$var$getTextualContent(element.options[0]);
    }
];
var $c151d097cc3dcc78$var$fallbackStrategies = [
    function(element) {
        return $c151d097cc3dcc78$var$getTextualContent(element);
    }
];
/**
 * Iterates over the target element and its parent, using the strategies list to get an action name.
 * Each strategies are applied on each element, stopping as soon as a non-empty value is returned.
 */ var $c151d097cc3dcc78$var$MAX_PARENTS_TO_CONSIDER = 10;
function $c151d097cc3dcc78$var$getActionNameFromElementForStrategies(targetElement, strategies) {
    var element = targetElement;
    var recursionCounter = 0;
    while(recursionCounter <= $c151d097cc3dcc78$var$MAX_PARENTS_TO_CONSIDER && element && element.nodeName !== 'BODY' && element.nodeName !== 'HTML' && element.nodeName !== 'HEAD'){
        for(var _i = 0, strategies_1 = strategies; _i < strategies_1.length; _i++){
            var strategy = strategies_1[_i];
            var name_1 = strategy(element);
            if (typeof name_1 === 'string') {
                var trimmedName = name_1.trim();
                if (trimmedName) return $c151d097cc3dcc78$var$truncate($c151d097cc3dcc78$var$normalizeWhitespace(trimmedName));
            }
        }
        // Consider a FORM as a contextual limit to get the action name.  This is experimental and may
        // be reconsidered in the future.
        if (element.nodeName === 'FORM') break;
        element = element.parentElement;
        recursionCounter += 1;
    }
}
function $c151d097cc3dcc78$var$normalizeWhitespace(s) {
    return s.replace(/\s+/g, ' ');
}
function $c151d097cc3dcc78$var$truncate(s) {
    return s.length > 100 ? (0, $83a2a4f39556dd51$export$b26462d2f74496cd)(s, 100) + " [...]" : s;
}
function $c151d097cc3dcc78$var$getElementById(refElement, id) {
    // Use the element ownerDocument here, because tests are executed in an iframe, so
    // document.getElementById won't work.
    // tslint:disable-next-line: no-null-keyword
    return refElement.ownerDocument ? refElement.ownerDocument.getElementById(id) : null;
}
function $c151d097cc3dcc78$var$getTextualContent(element) {
    if (element.isContentEditable) return;
    if ('innerText' in element) {
        var text = element.innerText;
        if (!$c151d097cc3dcc78$var$supportsInnerTextScriptAndStyleRemoval()) {
            // remove the inner text of SCRIPT and STYLES from the result. This is a bit dirty, but should
            // be relatively fast and work in most cases.
            var elementsTextToRemove = element.querySelectorAll('script, style');
            // tslint:disable-next-line: prefer-for-of
            for(var i = 0; i < elementsTextToRemove.length; i += 1){
                var innerText = elementsTextToRemove[i].innerText;
                if (innerText.trim().length > 0) text = text.replace(innerText, '');
            }
        }
        return text;
    }
    return element.textContent;
}
/**
 * Returns true if element.innerText excludes the text from inline SCRIPT and STYLE element.  This
 * should be the case everywhere except on some version of Internet Explorer.
 * See http://perfectionkills.com/the-poor-misunderstood-innerText/#diff-with-textContent
 */ var $c151d097cc3dcc78$var$supportsInnerTextScriptAndStyleRemovalResult;
function $c151d097cc3dcc78$var$supportsInnerTextScriptAndStyleRemoval() {
    if ($c151d097cc3dcc78$var$supportsInnerTextScriptAndStyleRemovalResult === undefined) {
        var style = document.createElement('style');
        style.textContent = '*';
        var div = document.createElement('div');
        div.appendChild(style);
        document.body.appendChild(div);
        $c151d097cc3dcc78$var$supportsInnerTextScriptAndStyleRemovalResult = div.innerText === '';
        document.body.removeChild(div);
    }
    return $c151d097cc3dcc78$var$supportsInnerTextScriptAndStyleRemovalResult;
}
/**
 * Returns true if the browser supports the element.labels property.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */ var $c151d097cc3dcc78$var$supportsLabelPropertyResult;
function $c151d097cc3dcc78$var$supportsLabelProperty() {
    if ($c151d097cc3dcc78$var$supportsLabelPropertyResult === undefined) $c151d097cc3dcc78$var$supportsLabelPropertyResult = 'labels' in HTMLInputElement.prototype;
    return $c151d097cc3dcc78$var$supportsLabelPropertyResult;
}
/**
 * Returns true if the browser supports the element.closest method.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */ var $c151d097cc3dcc78$var$supportsElementClosestResult;
function $c151d097cc3dcc78$var$supportsElementClosest() {
    if ($c151d097cc3dcc78$var$supportsElementClosestResult === undefined) $c151d097cc3dcc78$var$supportsElementClosestResult = 'closest' in HTMLElement.prototype;
    return $c151d097cc3dcc78$var$supportsElementClosestResult;
}


var $8fef60de5a27f899$export$e4a712fff93fb00f;
(function(ActionType) {
    ActionType["CLICK"] = "click";
    ActionType["CUSTOM"] = "custom";
})($8fef60de5a27f899$export$e4a712fff93fb00f || ($8fef60de5a27f899$export$e4a712fff93fb00f = {}));
function $8fef60de5a27f899$export$aefbc69bc18c6c68(lifeCycle) {
    var action = $8fef60de5a27f899$var$startActionManagement(lifeCycle);
    // New views trigger the discard of the current pending Action
    lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).VIEW_CREATED, function() {
        action.discardCurrent();
    });
    var stopListener = (0, $83a2a4f39556dd51$export$3f65cefe8380dbea)(window, (0, $83a2a4f39556dd51$export$54664c6599f7afe2).CLICK, function(event) {
        if (!(event.target instanceof Element)) return;
        var name = (0, $c151d097cc3dcc78$export$9c46f8d96b9f088f)(event.target);
        if (!name) return;
        action.create($8fef60de5a27f899$export$e4a712fff93fb00f.CLICK, name);
    }, {
        capture: true
    }).stop;
    return {
        stop: function() {
            action.discardCurrent();
            stopListener();
        }
    };
}
function $8fef60de5a27f899$var$startActionManagement(lifeCycle) {
    var currentAction;
    var currentIdlePageActivitySubscription;
    return {
        create: function(type, name) {
            if (currentAction) // Ignore any new action if another one is already occurring.
            return;
            var pendingAutoAction = new $8fef60de5a27f899$var$PendingAutoAction(lifeCycle, type, name);
            currentAction = pendingAutoAction;
            currentIdlePageActivitySubscription = (0, $756559e45e643551$export$b191740c85d918c5)(lifeCycle, function(hadActivity, endTime) {
                if (hadActivity) pendingAutoAction.complete(endTime);
                else pendingAutoAction.discard();
                currentAction = undefined;
            });
        },
        discardCurrent: function() {
            if (currentAction) {
                currentIdlePageActivitySubscription.stop();
                currentAction.discard();
                currentAction = undefined;
            }
        }
    };
}
var $8fef60de5a27f899$var$PendingAutoAction = /** @class */ function() {
    function PendingAutoAction(lifeCycle, type, name) {
        this.lifeCycle = lifeCycle;
        this.type = type;
        this.name = name;
        this.id = (0, $83a2a4f39556dd51$export$e73c8bd0f20705a)();
        this.startTime = performance.now();
        this.eventCountsSubscription = (0, $7746d68c83e78bbf$export$a50549f6fbbed49b)(lifeCycle);
        this.lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).AUTO_ACTION_CREATED, {
            id: this.id,
            startTime: this.startTime
        });
    }
    PendingAutoAction.prototype.complete = function(endTime) {
        var eventCounts = this.eventCountsSubscription.eventCounts;
        this.lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).AUTO_ACTION_COMPLETED, {
            counts: {
                errorCount: eventCounts.errorCount,
                longTaskCount: eventCounts.longTaskCount,
                resourceCount: eventCounts.resourceCount
            },
            duration: endTime - this.startTime,
            id: this.id,
            name: this.name,
            startTime: this.startTime,
            type: this.type
        });
        this.eventCountsSubscription.stop();
    };
    PendingAutoAction.prototype.discard = function() {
        this.lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).AUTO_ACTION_DISCARDED);
        this.eventCountsSubscription.stop();
    };
    return PendingAutoAction;
}();





function $62450ddce8fda713$var$getMutationObserverConstructor() {
    var constructor;
    var browserWindow = window;
    // Angular uses Zone.js to provide a context persisting accross async tasks.  Zone.js replaces the
    // global MutationObserver constructor with a patched version to support the context propagation.
    // There is an ongoing issue[1][2] with this setup when using a MutationObserver within a Angular
    // component: on some occasions, the callback is being called in an infinite loop, causing the
    // page to freeze (even if the callback is completely empty).
    //
    // To work around this issue, we are using the Zone __symbol__ API to get the original, unpatched
    // MutationObserver constructor.
    //
    // [1] https://github.com/angular/angular/issues/26948
    // [2] https://github.com/angular/angular/issues/31712
    if (browserWindow.Zone) {
        var symbol = browserWindow.Zone.__symbol__('MutationObserver');
        constructor = browserWindow[symbol];
    }
    if (!constructor) constructor = browserWindow.MutationObserver;
    return constructor;
}
function $62450ddce8fda713$export$d852bada4b1d0eba(lifeCycle) {
    var observer;
    var MutationObserver = $62450ddce8fda713$var$getMutationObserverConstructor();
    if (MutationObserver) {
        observer = new MutationObserver((0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(function() {
            lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).DOM_MUTATED);
        }));
        observer.observe(document.documentElement, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true
        });
    }
    return {
        stop: function() {
            if (observer) observer.disconnect();
        }
    };
}


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $4514c4749dd578e8$var$extendStatics = function(d, b) {
    $4514c4749dd578e8$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $4514c4749dd578e8$var$extendStatics(d, b);
};
function $4514c4749dd578e8$export$a8ba968b8961cb8a(d, b) {
    $4514c4749dd578e8$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $4514c4749dd578e8$export$18ce0697a983be9b = function() {
    $4514c4749dd578e8$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4514c4749dd578e8$export$18ce0697a983be9b.apply(this, arguments);
};
function $4514c4749dd578e8$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $4514c4749dd578e8$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $4514c4749dd578e8$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $4514c4749dd578e8$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $4514c4749dd578e8$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $4514c4749dd578e8$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $4514c4749dd578e8$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $4514c4749dd578e8$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $4514c4749dd578e8$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $4514c4749dd578e8$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $4514c4749dd578e8$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($4514c4749dd578e8$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $4514c4749dd578e8$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $4514c4749dd578e8$export$10c90e4f7922046c(v) {
    return this instanceof $4514c4749dd578e8$export$10c90e4f7922046c ? (this.v = v, this) : new $4514c4749dd578e8$export$10c90e4f7922046c(v);
}
function $4514c4749dd578e8$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $4514c4749dd578e8$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $4514c4749dd578e8$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $4514c4749dd578e8$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $4514c4749dd578e8$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $4514c4749dd578e8$export$19a8beecd37a4c45 === "function" ? $4514c4749dd578e8$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $4514c4749dd578e8$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $4514c4749dd578e8$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $4514c4749dd578e8$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $4514c4749dd578e8$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $4514c4749dd578e8$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}






function $d13c4f85992def64$export$6535eb414fa2c8b6(url) {
    return $d13c4f85992def64$export$b5cd97dee32de81d(url, (0, $83a2a4f39556dd51$export$4e4972392113943c)()).href;
}
function $d13c4f85992def64$export$bef94a5618bf18bf(url) {
    try {
        return !!$d13c4f85992def64$export$b5cd97dee32de81d(url);
    } catch (_a) {
        return false;
    }
}
function $d13c4f85992def64$export$f796530395c15bb4(url1, url2) {
    return $d13c4f85992def64$export$5a759dc7a1cfb72a(url1) === $d13c4f85992def64$export$5a759dc7a1cfb72a(url2);
}
function $d13c4f85992def64$export$5a759dc7a1cfb72a(url) {
    return (0, $83a2a4f39556dd51$export$20ce3cd54d7c02b4)($d13c4f85992def64$export$b5cd97dee32de81d(url));
}
function $d13c4f85992def64$export$ba1b94ff70383687(url) {
    var pathname = $d13c4f85992def64$export$b5cd97dee32de81d(url).pathname;
    return pathname[0] === '/' ? pathname : "/" + pathname;
}
function $d13c4f85992def64$export$786f9a4bc80cc6b0(url) {
    return $d13c4f85992def64$export$b5cd97dee32de81d(url).search;
}
function $d13c4f85992def64$export$adaba664e531641c(url) {
    return $d13c4f85992def64$export$b5cd97dee32de81d(url).hash;
}
function $d13c4f85992def64$export$b5cd97dee32de81d(url, base) {
    if ($d13c4f85992def64$var$checkURLSupported()) return base !== undefined ? new URL(url, base) : new URL(url);
    if (base === undefined && !/:/.test(url)) throw new Error("Invalid URL: '" + url + "'");
    var doc = document;
    var anchorElement = doc.createElement('a');
    if (base !== undefined) {
        doc = document.implementation.createHTMLDocument('');
        var baseElement = doc.createElement('base');
        baseElement.href = base;
        doc.head.appendChild(baseElement);
        doc.body.appendChild(anchorElement);
    }
    anchorElement.href = url;
    return anchorElement;
}
var $d13c4f85992def64$var$isURLSupported;
function $d13c4f85992def64$var$checkURLSupported() {
    if ($d13c4f85992def64$var$isURLSupported !== undefined) return $d13c4f85992def64$var$isURLSupported;
    try {
        var url = new URL('http://test/path');
        $d13c4f85992def64$var$isURLSupported = url.href === 'http://test/path';
        return $d13c4f85992def64$var$isURLSupported;
    } catch (_a) {
        $d13c4f85992def64$var$isURLSupported = false;
    }
    return $d13c4f85992def64$var$isURLSupported;
}


var $0ba15716cf612452$export$dc5d43db6d9a2bce = 'initial_document';
var $0ba15716cf612452$var$RESOURCE_TYPES = [
    [
        (0, $83a2a4f39556dd51$export$c6f9da6f70cfc2eb).DOCUMENT,
        function(initiatorType) {
            return $0ba15716cf612452$export$dc5d43db6d9a2bce === initiatorType;
        }
    ],
    [
        (0, $83a2a4f39556dd51$export$c6f9da6f70cfc2eb).XHR,
        function(initiatorType) {
            return 'xmlhttprequest' === initiatorType;
        }
    ],
    [
        (0, $83a2a4f39556dd51$export$c6f9da6f70cfc2eb).FETCH,
        function(initiatorType) {
            return 'fetch' === initiatorType;
        }
    ],
    [
        (0, $83a2a4f39556dd51$export$c6f9da6f70cfc2eb).BEACON,
        function(initiatorType) {
            return 'beacon' === initiatorType;
        }
    ],
    [
        (0, $83a2a4f39556dd51$export$c6f9da6f70cfc2eb).CSS,
        function(_, path) {
            return path.match(/\.css$/i) !== null;
        }
    ],
    [
        (0, $83a2a4f39556dd51$export$c6f9da6f70cfc2eb).JS,
        function(_, path) {
            return path.match(/\.js$/i) !== null;
        }
    ],
    [
        (0, $83a2a4f39556dd51$export$c6f9da6f70cfc2eb).IMAGE,
        function(initiatorType, path) {
            return (0, $83a2a4f39556dd51$export$ee2e0f811dca1807)([
                'image',
                'img',
                'icon'
            ], initiatorType) || path.match(/\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i) !== null;
        }
    ],
    [
        (0, $83a2a4f39556dd51$export$c6f9da6f70cfc2eb).FONT,
        function(_, path) {
            return path.match(/\.(woff|eot|woff2|ttf)$/i) !== null;
        }
    ],
    [
        (0, $83a2a4f39556dd51$export$c6f9da6f70cfc2eb).MEDIA,
        function(initiatorType, path) {
            return (0, $83a2a4f39556dd51$export$ee2e0f811dca1807)([
                'audio',
                'video'
            ], initiatorType) || path.match(/\.(mp3|mp4)$/i) !== null;
        }
    ]
];
function $0ba15716cf612452$export$5e78e8490e290d1f(timing) {
    var url = timing.name;
    if (!(0, $d13c4f85992def64$export$bef94a5618bf18bf)(url)) {
        (0, $09f70ea01c107b30$export$16846acd4b472b8d)("Failed to construct URL for \"" + timing.name + "\"");
        return (0, $83a2a4f39556dd51$export$c6f9da6f70cfc2eb).OTHER;
    }
    var path = (0, $d13c4f85992def64$export$ba1b94ff70383687)(url);
    for(var _i = 0, RESOURCE_TYPES_1 = $0ba15716cf612452$var$RESOURCE_TYPES; _i < RESOURCE_TYPES_1.length; _i++){
        var _a = RESOURCE_TYPES_1[_i], type = _a[0], isType = _a[1];
        if (isType(timing.initiatorType, path)) return type;
    }
    return (0, $83a2a4f39556dd51$export$c6f9da6f70cfc2eb).OTHER;
}
function $0ba15716cf612452$var$areInOrder() {
    var numbers = [];
    for(var _i = 0; _i < arguments.length; _i++)numbers[_i] = arguments[_i];
    for(var i = 1; i < numbers.length; i += 1){
        if (numbers[i - 1] > numbers[i]) return false;
    }
    return true;
}
function $0ba15716cf612452$export$8bc876d854d05e34(timing) {
    return timing.initiatorType === 'xmlhttprequest' || timing.initiatorType === 'fetch';
}
function $0ba15716cf612452$export$883ce645d410c918(entry) {
    var duration = entry.duration, startTime = entry.startTime, responseEnd = entry.responseEnd;
    // Safari duration is always 0 on timings blocked by cross origin policies.
    if (duration === 0 && startTime < responseEnd) return (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(responseEnd - startTime);
    return (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(duration);
}
function $0ba15716cf612452$export$6833c1608b6b5e2e(entry) {
    var validEntry = $0ba15716cf612452$export$15341232ff5dd6e5(entry);
    if (!validEntry) return undefined;
    var startTime = validEntry.startTime, fetchStart = validEntry.fetchStart, redirectStart = validEntry.redirectStart, redirectEnd = validEntry.redirectEnd, domainLookupStart = validEntry.domainLookupStart, domainLookupEnd = validEntry.domainLookupEnd, connectStart = validEntry.connectStart, secureConnectionStart = validEntry.secureConnectionStart, connectEnd = validEntry.connectEnd, requestStart = validEntry.requestStart, responseStart = validEntry.responseStart, responseEnd = validEntry.responseEnd;
    var details = {
        download: $0ba15716cf612452$var$formatTiming(startTime, responseStart, responseEnd),
        firstByte: $0ba15716cf612452$var$formatTiming(startTime, requestStart, responseStart)
    };
    // Make sure a connection occurred
    if (connectEnd !== fetchStart) {
        details.connect = $0ba15716cf612452$var$formatTiming(startTime, connectStart, connectEnd);
        // Make sure a secure connection occurred
        if ($0ba15716cf612452$var$areInOrder(connectStart, secureConnectionStart, connectEnd)) details.ssl = $0ba15716cf612452$var$formatTiming(startTime, secureConnectionStart, connectEnd);
    }
    // Make sure a domain lookup occurred
    if (domainLookupEnd !== fetchStart) details.dns = $0ba15716cf612452$var$formatTiming(startTime, domainLookupStart, domainLookupEnd);
    if ($0ba15716cf612452$var$hasRedirection(entry)) details.redirect = $0ba15716cf612452$var$formatTiming(startTime, redirectStart, redirectEnd);
    return details;
}
function $0ba15716cf612452$export$15341232ff5dd6e5(entry) {
    // Ensure timings are in the right order. On top of filtering out potential invalid
    // RumPerformanceResourceTiming, it will ignore entries from requests where timings cannot be
    // collected, for example cross origin requests without a "Timing-Allow-Origin" header allowing
    // it.
    if (!$0ba15716cf612452$var$areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd)) return undefined;
    if (!$0ba15716cf612452$var$hasRedirection(entry)) return entry;
    var redirectStart = entry.redirectStart, redirectEnd = entry.redirectEnd;
    // Firefox doesn't provide redirect timings on cross origin requests.
    // Provide a default for those.
    if (redirectStart < entry.startTime) redirectStart = entry.startTime;
    if (redirectEnd < entry.startTime) redirectEnd = entry.fetchStart;
    // Make sure redirect timings are in order
    if (!$0ba15716cf612452$var$areInOrder(entry.startTime, redirectStart, redirectEnd, entry.fetchStart)) return undefined;
    return (0, $4514c4749dd578e8$export$18ce0697a983be9b)((0, $4514c4749dd578e8$export$18ce0697a983be9b)({}, entry), {
        redirectEnd: redirectEnd,
        redirectStart: redirectStart
    });
}
function $0ba15716cf612452$var$hasRedirection(entry) {
    // The only time fetchStart is different than startTime is if a redirection occurred.
    return entry.fetchStart !== entry.startTime;
}
function $0ba15716cf612452$var$formatTiming(origin, start, end) {
    return {
        duration: (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(end - start),
        start: (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(start - origin)
    };
}
function $0ba15716cf612452$export$887c770fbe334306(entry) {
    // Make sure a request actually occurred
    if (entry.startTime < entry.responseStart) return entry.decodedBodySize;
    return undefined;
}
function $0ba15716cf612452$export$c298da523d6ed600(configuration, url) {
    return url && !configuration.isIntakeUrl(url);
}



var $bcd9cd1a5fc24585$export$f1b0e1c95ecb6961 = 2 * (0, $83a2a4f39556dd51$export$35acaebf644db34e);
function $bcd9cd1a5fc24585$export$9600d3c1068ac02c(document) {
    var data = $bcd9cd1a5fc24585$export$cabe353a895a405f(document) || $bcd9cd1a5fc24585$export$70f194456d3a8998(document);
    if (!data || data.traceTime <= Date.now() - $bcd9cd1a5fc24585$export$f1b0e1c95ecb6961) return undefined;
    return data.traceId;
}
function $bcd9cd1a5fc24585$export$cabe353a895a405f(document) {
    var traceIdMeta = document.querySelector('meta[name=dd-trace-id]');
    var traceTimeMeta = document.querySelector('meta[name=dd-trace-time]');
    return $bcd9cd1a5fc24585$export$10b75f215ee15e0e(traceIdMeta && traceIdMeta.content, traceTimeMeta && traceTimeMeta.content);
}
function $bcd9cd1a5fc24585$export$70f194456d3a8998(document) {
    var comment = $bcd9cd1a5fc24585$export$4d376e42fa08c24d(document);
    if (!comment) return undefined;
    return $bcd9cd1a5fc24585$export$10b75f215ee15e0e((0, $83a2a4f39556dd51$export$fe87bb5193f3e70)(comment, 'trace-id'), (0, $83a2a4f39556dd51$export$fe87bb5193f3e70)(comment, 'trace-time'));
}
function $bcd9cd1a5fc24585$export$10b75f215ee15e0e(traceId, rawTraceTime) {
    var traceTime = rawTraceTime && Number(rawTraceTime);
    if (!traceId || !traceTime) return undefined;
    return {
        traceId: traceId,
        traceTime: traceTime
    };
}
function $bcd9cd1a5fc24585$export$4d376e42fa08c24d(document) {
    // 1. Try to find the comment as a direct child of the document
    // Note: TSLint advises to use a 'for of', but TS doesn't allow to use 'for of' if the iterated
    // value is not an array or string (here, a NodeList).
    // tslint:disable-next-line: prefer-for-of
    for(var i = 0; i < document.childNodes.length; i += 1){
        var comment = $bcd9cd1a5fc24585$var$getTraceCommentFromNode(document.childNodes[i]);
        if (comment) return comment;
    }
    // 2. If the comment is placed after the </html> tag, but have some space or new lines before or
    // after, the DOM parser will lift it (and the surrounding text) at the end of the <body> tag.
    // Try to look for the comment at the end of the <body> by by iterating over its child nodes in
    // reverse order, stoping if we come accross a non-text node.
    if (document.body) for(var i = document.body.childNodes.length - 1; i >= 0; i -= 1){
        var node = document.body.childNodes[i];
        var comment = $bcd9cd1a5fc24585$var$getTraceCommentFromNode(node);
        if (comment) return comment;
        if (!$bcd9cd1a5fc24585$var$isTextNode(node)) break;
    }
}
function $bcd9cd1a5fc24585$var$getTraceCommentFromNode(node) {
    if (node && $bcd9cd1a5fc24585$var$isCommentNode(node)) {
        var match = node.data.match(/^\s*DATADOG;(.*?)\s*$/);
        if (match) return match[1];
    }
}
function $bcd9cd1a5fc24585$var$isCommentNode(node) {
    return node.nodeName === '#comment';
}
function $bcd9cd1a5fc24585$var$isTextNode(node) {
    return node.nodeName === '#text';
}


function $128592d80a007ba7$var$supportPerformanceObject() {
    return window.performance !== undefined && 'getEntries' in performance;
}
function $128592d80a007ba7$export$c6967607cdac15e8(entryType) {
    return window.PerformanceObserver && PerformanceObserver.supportedEntryTypes !== undefined && PerformanceObserver.supportedEntryTypes.includes(entryType);
}
function $128592d80a007ba7$export$4f22ae7bb247104c(lifeCycle, configuration) {
    $128592d80a007ba7$export$7eb7526e9416e27a(function(timing) {
        $128592d80a007ba7$var$handleRumPerformanceEntry(lifeCycle, configuration, timing);
    });
    if ($128592d80a007ba7$var$supportPerformanceObject()) $128592d80a007ba7$var$handlePerformanceEntries(lifeCycle, configuration, performance.getEntries());
    if (window.PerformanceObserver) {
        var observer = new PerformanceObserver((0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(function(entries) {
            return $128592d80a007ba7$var$handlePerformanceEntries(lifeCycle, configuration, entries.getEntries());
        }));
        var entryTypes = [
            'resource',
            'navigation',
            'longtask',
            'paint',
            'largest-contentful-paint',
            'first-input',
            'layout-shift'
        ];
        observer.observe({
            entryTypes: entryTypes
        });
        if ($128592d80a007ba7$var$supportPerformanceObject() && 'addEventListener' in performance) // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
        performance.addEventListener('resourcetimingbufferfull', function() {
            performance.clearResourceTimings();
        });
    }
    if (!$128592d80a007ba7$export$c6967607cdac15e8('navigation')) $128592d80a007ba7$var$retrieveNavigationTiming(function(timing) {
        $128592d80a007ba7$var$handleRumPerformanceEntry(lifeCycle, configuration, timing);
    });
    if (!$128592d80a007ba7$export$c6967607cdac15e8('first-input')) $128592d80a007ba7$var$retrieveFirstInputTiming(function(timing) {
        $128592d80a007ba7$var$handleRumPerformanceEntry(lifeCycle, configuration, timing);
    });
}
function $128592d80a007ba7$export$7eb7526e9416e27a(callback) {
    $128592d80a007ba7$var$runOnReadyState('interactive', function() {
        var timing;
        var forcedAttributes = {
            entryType: 'resource',
            initiatorType: (0, $0ba15716cf612452$export$dc5d43db6d9a2bce),
            traceId: (0, $bcd9cd1a5fc24585$export$9600d3c1068ac02c)(document)
        };
        if ($128592d80a007ba7$export$c6967607cdac15e8('navigation') && performance.getEntriesByType('navigation').length > 0) {
            var navigationEntry = performance.getEntriesByType('navigation')[0];
            timing = (0, $4514c4749dd578e8$export$18ce0697a983be9b)((0, $4514c4749dd578e8$export$18ce0697a983be9b)({}, navigationEntry.toJSON()), forcedAttributes);
        } else {
            var relativePerformanceTiming = $128592d80a007ba7$var$computeRelativePerformanceTiming();
            timing = (0, $4514c4749dd578e8$export$18ce0697a983be9b)((0, $4514c4749dd578e8$export$18ce0697a983be9b)((0, $4514c4749dd578e8$export$18ce0697a983be9b)({}, relativePerformanceTiming), {
                decodedBodySize: 0,
                duration: relativePerformanceTiming.responseEnd,
                name: window.location.href,
                startTime: 0
            }), forcedAttributes);
        }
        callback(timing);
    });
}
function $128592d80a007ba7$var$retrieveNavigationTiming(callback) {
    function sendFakeTiming() {
        callback((0, $4514c4749dd578e8$export$18ce0697a983be9b)((0, $4514c4749dd578e8$export$18ce0697a983be9b)({}, $128592d80a007ba7$var$computeRelativePerformanceTiming()), {
            entryType: 'navigation'
        }));
    }
    $128592d80a007ba7$var$runOnReadyState('complete', function() {
        // Send it a bit after the actual load event, so the "loadEventEnd" timing is accurate
        setTimeout((0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(sendFakeTiming));
    });
}
/**
 * first-input timing entry polyfill based on
 * https://github.com/GoogleChrome/web-vitals/blob/master/src/lib/polyfills/firstInputPolyfill.ts
 */ function $128592d80a007ba7$var$retrieveFirstInputTiming(callback) {
    var startTimeStamp = Date.now();
    var timingSent = false;
    var removeEventListeners = (0, $83a2a4f39556dd51$export$40a4ed63e5cb7043)(window, [
        (0, $83a2a4f39556dd51$export$54664c6599f7afe2).CLICK,
        (0, $83a2a4f39556dd51$export$54664c6599f7afe2).MOUSE_DOWN,
        (0, $83a2a4f39556dd51$export$54664c6599f7afe2).KEY_DOWN,
        (0, $83a2a4f39556dd51$export$54664c6599f7afe2).TOUCH_START,
        (0, $83a2a4f39556dd51$export$54664c6599f7afe2).POINTER_DOWN
    ], function(evt) {
        // Only count cancelable events, which should trigger behavior important to the user.
        if (!evt.cancelable) return;
        // This timing will be used to compute the "first Input delay", which is the delta between
        // when the system received the event (e.g. evt.timeStamp) and when it could run the callback
        // (e.g. performance.now()).
        var timing = {
            entryType: 'first-input',
            processingStart: performance.now(),
            startTime: evt.timeStamp
        };
        if (evt.type === (0, $83a2a4f39556dd51$export$54664c6599f7afe2).POINTER_DOWN) sendTimingIfPointerIsNotCancelled(timing);
        else sendTiming(timing);
    }, {
        passive: true,
        capture: true
    }).stop;
    /**
     * Pointer events are a special case, because they can trigger main or compositor thread behavior.
     * We differenciate these cases based on whether or not we see a pointercancel event, which are
     * fired when we scroll. If we're scrolling we don't need to report input delay since FID excludes
     * scrolling and pinch/zooming.
     */ function sendTimingIfPointerIsNotCancelled(timing) {
        (0, $83a2a4f39556dd51$export$40a4ed63e5cb7043)(window, [
            (0, $83a2a4f39556dd51$export$54664c6599f7afe2).POINTER_UP,
            (0, $83a2a4f39556dd51$export$54664c6599f7afe2).POINTER_CANCEL
        ], function(event) {
            if (event.type === (0, $83a2a4f39556dd51$export$54664c6599f7afe2).POINTER_UP) sendTiming(timing);
        }, {
            once: true
        });
    }
    function sendTiming(timing) {
        if (!timingSent) {
            timingSent = true;
            removeEventListeners();
            // In some cases the recorded delay is clearly wrong, e.g. it's negative or it's larger than
            // the time between now and when the page was loaded.
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/4
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/6
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/7
            var delay = timing.processingStart - timing.startTime;
            if (delay >= 0 && delay < Date.now() - startTimeStamp) callback(timing);
        }
    }
}
function $128592d80a007ba7$var$runOnReadyState(expectedReadyState, callback) {
    if (document.readyState === expectedReadyState || document.readyState === 'complete') callback();
    else {
        var eventName = expectedReadyState === 'complete' ? (0, $83a2a4f39556dd51$export$54664c6599f7afe2).LOAD : (0, $83a2a4f39556dd51$export$54664c6599f7afe2).DOM_CONTENT_LOADED;
        (0, $83a2a4f39556dd51$export$3f65cefe8380dbea)(window, eventName, callback, {
            once: true
        });
    }
}
function $128592d80a007ba7$var$computeRelativePerformanceTiming() {
    var result = {};
    var timing = performance.timing;
    for(var key in timing)if ((0, $83a2a4f39556dd51$export$7e4aa119212bc614)(timing[key])) result[key] = timing[key] === 0 ? 0 : (0, $83a2a4f39556dd51$export$493c11ff22f45a24)(timing[key]);
    return result;
}
function $128592d80a007ba7$var$handlePerformanceEntries(lifeCycle, configuration, entries) {
    entries.forEach(function(entry) {
        if (entry.entryType === 'resource' || entry.entryType === 'navigation' || entry.entryType === 'paint' || entry.entryType === 'longtask' || entry.entryType === 'largest-contentful-paint' || entry.entryType === 'first-input' || entry.entryType === 'layout-shift') $128592d80a007ba7$var$handleRumPerformanceEntry(lifeCycle, configuration, entry);
    });
}
function $128592d80a007ba7$var$handleRumPerformanceEntry(lifeCycle, configuration, entry) {
    if ($128592d80a007ba7$var$isIncompleteNavigation(entry) || $128592d80a007ba7$var$isForbiddenResource(configuration, entry)) return;
    lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).PERFORMANCE_ENTRY_COLLECTED, entry);
}
function $128592d80a007ba7$var$isIncompleteNavigation(entry) {
    return entry.entryType === 'navigation' && entry.loadEventEnd <= 0;
}
function $128592d80a007ba7$var$isForbiddenResource(configuration, entry) {
    return entry.entryType === 'resource' && !(0, $0ba15716cf612452$export$c298da523d6ed600)(configuration, entry.name);
}





var $e6e38e64873cf699$var$SessionType;
(function(SessionType) {
    SessionType["SYNTHETICS"] = "synthetics";
    SessionType["USER"] = "user";
})($e6e38e64873cf699$var$SessionType || ($e6e38e64873cf699$var$SessionType = {}));
function $e6e38e64873cf699$export$1a0bc162690d6539(applicationId, configuration, lifeCycle, session, parentContexts, getGlobalContext) {
    lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).RAW_RUM_EVENT_COLLECTED, function(_a) {
        var startTime = _a.startTime, rawRumEvent = _a.rawRumEvent, savedGlobalContext = _a.savedGlobalContext, customerContext = _a.customerContext;
        var viewContext = parentContexts.findView(startTime);
        if (session.isTracked() && viewContext && viewContext.sessionId) {
            var actionContext = parentContexts.findAction(startTime);
            var rumContext = {
                applicationId: applicationId,
                date: new Date().getTime(),
                service: configuration.service,
                session: {
                    // must be computed on each event because synthetics instrumentation can be done after sdk execution
                    // cf https://github.com/puppeteer/puppeteer/issues/3667
                    type: $e6e38e64873cf699$var$getSessionType()
                }
            };
            var rumEvent = $e6e38e64873cf699$var$needToAssembleWithAction(rawRumEvent) ? (0, $209814571e8229a4$export$1be1fc439b849fdf)(rumContext, viewContext, actionContext, rawRumEvent) : (0, $209814571e8229a4$export$1be1fc439b849fdf)(rumContext, viewContext, rawRumEvent);
            var serverRumEvent = (0, $209814571e8229a4$export$1be1fc439b849fdf)(savedGlobalContext || getGlobalContext(), customerContext, (0, $209814571e8229a4$export$3a718a742151bd80)(rumEvent));
            lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).RUM_EVENT_COLLECTED, {
                rumEvent: rumEvent,
                serverRumEvent: serverRumEvent
            });
        }
    });
}
function $e6e38e64873cf699$var$needToAssembleWithAction(event) {
    return [
        (0, $9e3879a7141a94c3$export$1951f08c2d18ec43).ERROR,
        (0, $9e3879a7141a94c3$export$1951f08c2d18ec43).RESOURCE,
        (0, $9e3879a7141a94c3$export$1951f08c2d18ec43).LONG_TASK
    ].indexOf(event.evt.category) !== -1;
}
function $e6e38e64873cf699$var$getSessionType() {
    return window._DATADOG_SYNTHETICS_BROWSER === undefined ? $e6e38e64873cf699$var$SessionType.USER : $e6e38e64873cf699$var$SessionType.SYNTHETICS;
}





var $f541f110cdd65d09$var$SessionType;
(function(SessionType) {
    SessionType["SYNTHETICS"] = "synthetics";
    SessionType["USER"] = "user";
})($f541f110cdd65d09$var$SessionType || ($f541f110cdd65d09$var$SessionType = {}));
function $f541f110cdd65d09$export$1f6a544182411412(applicationId, configuration, lifeCycle, session, parentContexts, getGlobalContext) {
    lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).RAW_RUM_EVENT_V2_COLLECTED, function(_a) {
        var startTime = _a.startTime, rawRumEvent = _a.rawRumEvent, savedGlobalContext = _a.savedGlobalContext, customerContext = _a.customerContext;
        var viewContext = parentContexts.findViewV2(startTime);
        if (session.isTracked() && viewContext && viewContext.session.id) {
            var actionContext = parentContexts.findActionV2(startTime);
            var rumContext = {
                _dd: {
                    formatVersion: 2
                },
                application: {
                    id: applicationId
                },
                date: new Date().getTime(),
                service: configuration.service,
                session: {
                    // must be computed on each event because synthetics instrumentation can be done after sdk execution
                    // cf https://github.com/puppeteer/puppeteer/issues/3667
                    type: $f541f110cdd65d09$var$getSessionType()
                }
            };
            var rumEvent = $f541f110cdd65d09$var$needToAssembleWithAction(rawRumEvent) ? (0, $209814571e8229a4$export$1be1fc439b849fdf)(rumContext, viewContext, actionContext, rawRumEvent) : (0, $209814571e8229a4$export$1be1fc439b849fdf)(rumContext, viewContext, rawRumEvent);
            var serverRumEvent = (0, $209814571e8229a4$export$3a718a742151bd80)(rumEvent);
            serverRumEvent.context = (0, $209814571e8229a4$export$1be1fc439b849fdf)(savedGlobalContext || getGlobalContext(), customerContext);
            lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).RUM_EVENT_V2_COLLECTED, {
                rumEvent: rumEvent,
                serverRumEvent: serverRumEvent
            });
        }
    });
}
function $f541f110cdd65d09$var$needToAssembleWithAction(event) {
    return [
        (0, $dfb817fd62da85ed$export$ce36bdd8bcd00f70).ERROR,
        (0, $dfb817fd62da85ed$export$ce36bdd8bcd00f70).RESOURCE,
        (0, $dfb817fd62da85ed$export$ce36bdd8bcd00f70).LONG_TASK
    ].indexOf(event.type) !== -1;
}
function $f541f110cdd65d09$var$getSessionType() {
    return window._DATADOG_SYNTHETICS_BROWSER === undefined ? $f541f110cdd65d09$var$SessionType.USER : $f541f110cdd65d09$var$SessionType.SYNTHETICS;
}



function $df207bfbe80ee737$export$ee941cf091e8459(applicationId, session, parentContexts, configuration) {
    return {
        get: function(startTime) {
            if (configuration.isEnabled('v2_format')) {
                var viewContext = parentContexts.findViewV2(startTime);
                if (session.isTracked() && viewContext && viewContext.session.id) {
                    var actionContext = parentContexts.findActionV2(startTime);
                    return (0, $209814571e8229a4$export$3a718a742151bd80)((0, $209814571e8229a4$export$1be1fc439b849fdf)({
                        applicationId: applicationId
                    }, {
                        sessionId: viewContext.session.id,
                        view: viewContext.view
                    }, actionContext ? {
                        userAction: {
                            id: actionContext.action.id
                        }
                    } : undefined));
                }
            } else {
                var viewContext = parentContexts.findView(startTime);
                if (session.isTracked() && viewContext && viewContext.sessionId) return (0, $209814571e8229a4$export$3a718a742151bd80)((0, $209814571e8229a4$export$1be1fc439b849fdf)({
                    applicationId: applicationId
                }, viewContext, parentContexts.findAction(startTime)));
            }
        }
    };
}









var $52896d7f7e04f6f6$export$9b0bbb4e1ef88c6d = '_dd';
var $52896d7f7e04f6f6$export$4231281e64250ad5 = '_dd_r';
var $52896d7f7e04f6f6$export$381d62e3ee200c01 = '_dd_l';
var $52896d7f7e04f6f6$export$50ae25e0cd1ada34 = 'rum';
var $52896d7f7e04f6f6$export$c47fdbea9837fd34 = 'logs';
function $52896d7f7e04f6f6$export$308239c26bbf40d4(sessionCookie) {
    var sessionString = sessionCookie.get();
    var oldSessionId = (0, $9d292372f5260b87$export$4be65e66cfa2648a)($52896d7f7e04f6f6$export$9b0bbb4e1ef88c6d);
    var oldRumType = (0, $9d292372f5260b87$export$4be65e66cfa2648a)($52896d7f7e04f6f6$export$4231281e64250ad5);
    var oldLogsType = (0, $9d292372f5260b87$export$4be65e66cfa2648a)($52896d7f7e04f6f6$export$381d62e3ee200c01);
    if (!sessionString) {
        var session = {};
        if (oldSessionId) session.id = oldSessionId;
        if (oldLogsType && /^[01]$/.test(oldLogsType)) session[$52896d7f7e04f6f6$export$c47fdbea9837fd34] = oldLogsType;
        if (oldRumType && /^[012]$/.test(oldRumType)) session[$52896d7f7e04f6f6$export$50ae25e0cd1ada34] = oldRumType;
        (0, $788c0a2db440e2b1$export$1dd215c5e92df4d2)(session, sessionCookie);
    }
}


var $788c0a2db440e2b1$export$63cf0d84d808ffcc = '_dd_s';
var $788c0a2db440e2b1$export$481fdd126dba0912 = 15 * $83a2a4f39556dd51$export$35acaebf644db34e;
var $788c0a2db440e2b1$export$324def7afe89d7e8 = 4 * $83a2a4f39556dd51$export$82541edf19e5e3b0;
var $788c0a2db440e2b1$export$3d1fb0c94cce8478 = $83a2a4f39556dd51$export$35acaebf644db34e;
function $788c0a2db440e2b1$export$b2b88085c51ddc96(options, productKey, computeSessionState) {
    var sessionCookie = (0, $9d292372f5260b87$export$ca01dc094798ac57)($788c0a2db440e2b1$export$63cf0d84d808ffcc, options);
    (0, $52896d7f7e04f6f6$export$308239c26bbf40d4)(sessionCookie);
    var renewObservable = new (0, $94423d3dd781adb9$export$77cea355fa80b5f4)();
    var currentSessionId = $788c0a2db440e2b1$var$retrieveActiveSession(sessionCookie).id;
    var expandOrRenewSession = $83a2a4f39556dd51$export$de363e709c412c8a(function() {
        var session = $788c0a2db440e2b1$var$retrieveActiveSession(sessionCookie);
        var _a = computeSessionState(session[productKey]), trackingType = _a.trackingType, isTracked = _a.isTracked;
        session[productKey] = trackingType;
        if (isTracked && !session.id) {
            session.id = $83a2a4f39556dd51$export$e73c8bd0f20705a();
            session.created = String(Date.now());
        }
        // save changes and expand session duration
        $788c0a2db440e2b1$export$1dd215c5e92df4d2(session, sessionCookie);
        // If the session id has changed, notify that the session has been renewed
        if (isTracked && currentSessionId !== session.id) {
            currentSessionId = session.id;
            renewObservable.notify();
        }
    }, (0, $9d292372f5260b87$export$c6202ae3e8db94d1)).throttled;
    var expandSession = function() {
        var session = $788c0a2db440e2b1$var$retrieveActiveSession(sessionCookie);
        $788c0a2db440e2b1$export$1dd215c5e92df4d2(session, sessionCookie);
    };
    expandOrRenewSession();
    $788c0a2db440e2b1$export$94e7aa83d805584c(expandOrRenewSession);
    $788c0a2db440e2b1$var$trackVisibility(expandSession);
    return {
        getId: function() {
            return $788c0a2db440e2b1$var$retrieveActiveSession(sessionCookie).id;
        },
        getTrackingType: function() {
            return $788c0a2db440e2b1$var$retrieveActiveSession(sessionCookie)[productKey];
        },
        renewObservable: renewObservable
    };
}
var $788c0a2db440e2b1$var$SESSION_ENTRY_REGEXP = /^([a-z]+)=([a-z0-9-]+)$/;
var $788c0a2db440e2b1$var$SESSION_ENTRY_SEPARATOR = '&';
function $788c0a2db440e2b1$export$1a6351cc7f3c5cc8(sessionString) {
    return sessionString !== undefined && (sessionString.indexOf($788c0a2db440e2b1$var$SESSION_ENTRY_SEPARATOR) !== -1 || $788c0a2db440e2b1$var$SESSION_ENTRY_REGEXP.test(sessionString));
}
function $788c0a2db440e2b1$var$retrieveActiveSession(sessionCookie) {
    var session = $788c0a2db440e2b1$var$retrieveSession(sessionCookie);
    if ($788c0a2db440e2b1$var$isActiveSession(session)) return session;
    $788c0a2db440e2b1$var$clearSession(sessionCookie);
    return {};
}
function $788c0a2db440e2b1$var$isActiveSession(session) {
    // created and expire can be undefined for versions which was not storing them
    // these checks could be removed when older versions will not be available/live anymore
    return (session.created === undefined || Date.now() - Number(session.created) < $788c0a2db440e2b1$export$324def7afe89d7e8) && (session.expire === undefined || Date.now() < Number(session.expire));
}
function $788c0a2db440e2b1$var$retrieveSession(sessionCookie) {
    var sessionString = sessionCookie.get();
    var session = {};
    if ($788c0a2db440e2b1$export$1a6351cc7f3c5cc8(sessionString)) sessionString.split($788c0a2db440e2b1$var$SESSION_ENTRY_SEPARATOR).forEach(function(entry) {
        var matches = $788c0a2db440e2b1$var$SESSION_ENTRY_REGEXP.exec(entry);
        if (matches !== null) {
            var key = matches[1], value = matches[2];
            session[key] = value;
        }
    });
    return session;
}
function $788c0a2db440e2b1$export$1dd215c5e92df4d2(session, cookie) {
    if ($83a2a4f39556dd51$export$83b788b1a3698c03(session)) {
        $788c0a2db440e2b1$var$clearSession(cookie);
        return;
    }
    session.expire = String(Date.now() + $788c0a2db440e2b1$export$481fdd126dba0912);
    var cookieString = $83a2a4f39556dd51$export$6a29ade99f81ec8a(session).map(function(_a) {
        var key = _a[0], value = _a[1];
        return key + "=" + value;
    }).join($788c0a2db440e2b1$var$SESSION_ENTRY_SEPARATOR);
    cookie.set(cookieString, $788c0a2db440e2b1$export$481fdd126dba0912);
}
function $788c0a2db440e2b1$var$clearSession(cookie) {
    cookie.set('', 0);
}
function $788c0a2db440e2b1$export$93c09b3c767b22a2() {
    $788c0a2db440e2b1$var$stopCallbacks.forEach(function(e) {
        return e();
    });
    $788c0a2db440e2b1$var$stopCallbacks = [];
}
var $788c0a2db440e2b1$var$stopCallbacks = [];
function $788c0a2db440e2b1$export$94e7aa83d805584c(expandOrRenewSession) {
    var stop = $83a2a4f39556dd51$export$40a4ed63e5cb7043(window, [
        $83a2a4f39556dd51$export$54664c6599f7afe2.CLICK,
        $83a2a4f39556dd51$export$54664c6599f7afe2.TOUCH_START,
        $83a2a4f39556dd51$export$54664c6599f7afe2.KEY_DOWN,
        $83a2a4f39556dd51$export$54664c6599f7afe2.SCROLL
    ], expandOrRenewSession, {
        capture: true,
        passive: true
    }).stop;
    $788c0a2db440e2b1$var$stopCallbacks.push(stop);
}
function $788c0a2db440e2b1$var$trackVisibility(expandSession) {
    var expandSessionWhenVisible = (0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(function() {
        if (document.visibilityState === 'visible') expandSession();
    });
    var stop = $83a2a4f39556dd51$export$3f65cefe8380dbea(document, $83a2a4f39556dd51$export$54664c6599f7afe2.VISIBILITY_CHANGE, expandSessionWhenVisible).stop;
    $788c0a2db440e2b1$var$stopCallbacks.push(stop);
    var visibilityCheckInterval = window.setInterval(expandSessionWhenVisible, $788c0a2db440e2b1$export$3d1fb0c94cce8478);
    $788c0a2db440e2b1$var$stopCallbacks.push(function() {
        clearInterval(visibilityCheckInterval);
    });
}



var $473bb44a80d016b8$export$f12c747a768c817c = (0, $788c0a2db440e2b1$export$324def7afe89d7e8);
var $473bb44a80d016b8$export$403157e9fa778fb6 = 5 * (0, $83a2a4f39556dd51$export$35acaebf644db34e); // arbitrary
var $473bb44a80d016b8$export$8cf7f195e76744bb = (0, $83a2a4f39556dd51$export$35acaebf644db34e);
function $473bb44a80d016b8$export$53602582b7256e1(lifeCycle, session) {
    var currentView;
    var currentAction;
    var currentSessionId;
    var previousViews = [];
    var previousActions = [];
    lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).VIEW_CREATED, function(currentContext) {
        if (currentView) previousViews.unshift({
            context: buildCurrentViewContext(),
            endTime: currentContext.startTime,
            startTime: currentView.startTime
        });
        currentView = currentContext;
        currentSessionId = session.getId();
    });
    lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).VIEW_UPDATED, function(currentContext) {
        // A view can be updated after its end.  We have to ensure that the view being updated is the
        // most recently created.
        if (currentView.id === currentContext.id) currentView = currentContext;
    });
    lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).AUTO_ACTION_CREATED, function(currentContext) {
        currentAction = currentContext;
    });
    lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).AUTO_ACTION_COMPLETED, function(action) {
        if (currentAction) previousActions.unshift({
            context: buildCurrentActionContext(),
            endTime: currentAction.startTime + action.duration,
            startTime: currentAction.startTime
        });
        currentAction = undefined;
    });
    lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).AUTO_ACTION_DISCARDED, function() {
        currentAction = undefined;
    });
    lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).SESSION_RENEWED, function() {
        previousViews = [];
        previousActions = [];
        currentView = undefined;
        currentAction = undefined;
    });
    var clearOldContextsInterval = window.setInterval((0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(function() {
        clearOldContexts(previousViews, $473bb44a80d016b8$export$f12c747a768c817c);
        clearOldContexts(previousActions, $473bb44a80d016b8$export$403157e9fa778fb6);
    }), $473bb44a80d016b8$export$8cf7f195e76744bb);
    function clearOldContexts(previousContexts, timeOutDelay) {
        var oldTimeThreshold = performance.now() - timeOutDelay;
        while(previousContexts.length > 0 && previousContexts[previousContexts.length - 1].startTime < oldTimeThreshold)previousContexts.pop();
    }
    function buildCurrentViewContext() {
        return {
            sessionId: currentSessionId,
            view: {
                id: currentView.id,
                referrer: currentView.referrer,
                url: currentView.location.href
            }
        };
    }
    function buildCurrentActionContext() {
        return {
            userAction: {
                id: currentAction.id
            }
        };
    }
    function findContext(buildContext, previousContexts, currentContext, startTime) {
        if (startTime === undefined) return currentContext ? buildContext() : undefined;
        if (currentContext && startTime >= currentContext.startTime) return buildContext();
        for(var _i = 0, previousContexts_1 = previousContexts; _i < previousContexts_1.length; _i++){
            var previousContext = previousContexts_1[_i];
            if (startTime > previousContext.endTime) break;
            if (startTime >= previousContext.startTime) return previousContext.context;
        }
        return undefined;
    }
    var parentContexts = {
        findAction: function(startTime) {
            return findContext(buildCurrentActionContext, previousActions, currentAction, startTime);
        },
        findActionV2: function(startTime) {
            var actionContext = parentContexts.findAction(startTime);
            if (!actionContext) return;
            return {
                action: {
                    id: actionContext.userAction.id
                }
            };
        },
        findView: function(startTime) {
            return findContext(buildCurrentViewContext, previousViews, currentView, startTime);
        },
        findViewV2: function(startTime) {
            var viewContext = parentContexts.findView(startTime);
            if (!viewContext) return;
            return {
                session: {
                    id: viewContext.sessionId
                },
                view: viewContext.view
            };
        },
        stop: function() {
            window.clearInterval(clearOldContextsInterval);
        }
    };
    return parentContexts;
}







var $f2e70d986afd1fbe$var$fetchProxySingleton;
var $f2e70d986afd1fbe$var$originalFetch;
var $f2e70d986afd1fbe$var$beforeSendCallbacks = [];
var $f2e70d986afd1fbe$var$onRequestCompleteCallbacks = [];
function $f2e70d986afd1fbe$export$1abdee9356a90f04() {
    if (!$f2e70d986afd1fbe$var$fetchProxySingleton) {
        $f2e70d986afd1fbe$var$proxyFetch();
        $f2e70d986afd1fbe$var$fetchProxySingleton = {
            beforeSend: function(callback) {
                $f2e70d986afd1fbe$var$beforeSendCallbacks.push(callback);
            },
            onRequestComplete: function(callback) {
                $f2e70d986afd1fbe$var$onRequestCompleteCallbacks.push(callback);
            }
        };
    }
    return $f2e70d986afd1fbe$var$fetchProxySingleton;
}
function $f2e70d986afd1fbe$export$4ea98215537abe70() {
    if ($f2e70d986afd1fbe$var$fetchProxySingleton) {
        $f2e70d986afd1fbe$var$fetchProxySingleton = undefined;
        $f2e70d986afd1fbe$var$beforeSendCallbacks.splice(0, $f2e70d986afd1fbe$var$beforeSendCallbacks.length);
        $f2e70d986afd1fbe$var$onRequestCompleteCallbacks.splice(0, $f2e70d986afd1fbe$var$onRequestCompleteCallbacks.length);
        window.fetch = $f2e70d986afd1fbe$var$originalFetch;
    }
}
function $f2e70d986afd1fbe$var$proxyFetch() {
    if (!window.fetch) return;
    $f2e70d986afd1fbe$var$originalFetch = window.fetch;
    // tslint:disable promise-function-async
    window.fetch = (0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(function(input, init) {
        var _this = this;
        var method = init && init.method || typeof input === 'object' && input.method || 'GET';
        var url = (0, $d13c4f85992def64$export$6535eb414fa2c8b6)(typeof input === 'object' && input.url || input);
        var startTime = performance.now();
        var context = {
            init: init,
            method: method,
            startTime: startTime,
            url: url
        };
        var reportFetch = function(response) {
            return (0, $2859a788dfc21b3e$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                var text, e_1;
                return (0, $2859a788dfc21b3e$export$67ebef60e6f28a6)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            context.duration = performance.now() - context.startTime;
                            if (!('stack' in response || response instanceof Error)) return [
                                3 /*break*/ ,
                                1
                            ];
                            context.status = 0;
                            context.response = (0, $5a0134dee269a95e$export$36ad41d7075a6f2b)((0, $970466414c4d6ba5$export$81296eded4f2ac09)(response));
                            $f2e70d986afd1fbe$var$onRequestCompleteCallbacks.forEach(function(callback) {
                                return callback(context);
                            });
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case 1:
                            if (!('status' in response)) return [
                                3 /*break*/ ,
                                6
                            ];
                            text = void 0;
                            _a.label = 2;
                        case 2:
                            _a.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4 /*yield*/ ,
                                response.clone().text()
                            ];
                        case 3:
                            text = _a.sent();
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 4:
                            e_1 = _a.sent();
                            text = "Unable to retrieve response: " + e_1;
                            return [
                                3 /*break*/ ,
                                5
                            ];
                        case 5:
                            context.response = text;
                            context.responseType = response.type;
                            context.status = response.status;
                            $f2e70d986afd1fbe$var$onRequestCompleteCallbacks.forEach(function(callback) {
                                return callback(context);
                            });
                            _a.label = 6;
                        case 6:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        $f2e70d986afd1fbe$var$beforeSendCallbacks.forEach(function(callback) {
            return callback(context);
        });
        var responsePromise = $f2e70d986afd1fbe$var$originalFetch.call(this, input, context.init);
        responsePromise.then((0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(reportFetch), (0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(reportFetch));
        return responsePromise;
    });
}



var $8727b470a4a06ca4$var$xhrProxySingleton;
var $8727b470a4a06ca4$var$beforeSendCallbacks = [];
var $8727b470a4a06ca4$var$onRequestCompleteCallbacks = [];
var $8727b470a4a06ca4$var$originalXhrOpen;
var $8727b470a4a06ca4$var$originalXhrSend;
function $8727b470a4a06ca4$export$e0fd5bb3c15407ec() {
    if (!$8727b470a4a06ca4$var$xhrProxySingleton) {
        $8727b470a4a06ca4$var$proxyXhr();
        $8727b470a4a06ca4$var$xhrProxySingleton = {
            beforeSend: function(callback) {
                $8727b470a4a06ca4$var$beforeSendCallbacks.push(callback);
            },
            onRequestComplete: function(callback) {
                $8727b470a4a06ca4$var$onRequestCompleteCallbacks.push(callback);
            }
        };
    }
    return $8727b470a4a06ca4$var$xhrProxySingleton;
}
function $8727b470a4a06ca4$export$d89427a2144a9c92() {
    if ($8727b470a4a06ca4$var$xhrProxySingleton) {
        $8727b470a4a06ca4$var$xhrProxySingleton = undefined;
        $8727b470a4a06ca4$var$beforeSendCallbacks.splice(0, $8727b470a4a06ca4$var$beforeSendCallbacks.length);
        $8727b470a4a06ca4$var$onRequestCompleteCallbacks.splice(0, $8727b470a4a06ca4$var$onRequestCompleteCallbacks.length);
        XMLHttpRequest.prototype.open = $8727b470a4a06ca4$var$originalXhrOpen;
        XMLHttpRequest.prototype.send = $8727b470a4a06ca4$var$originalXhrSend;
    }
}
function $8727b470a4a06ca4$var$proxyXhr() {
    $8727b470a4a06ca4$var$originalXhrOpen = XMLHttpRequest.prototype.open;
    $8727b470a4a06ca4$var$originalXhrSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = (0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(function(method, url) {
        // WARN: since this data structure is tied to the instance, it is shared by both logs and rum
        // and can be used by different code versions depending on customer setup
        // so it should stay compatible with older versions
        this._datadog_xhr = {
            method: method,
            startTime: -1,
            url: (0, $d13c4f85992def64$export$6535eb414fa2c8b6)(url)
        };
        return $8727b470a4a06ca4$var$originalXhrOpen.apply(this, arguments);
    });
    XMLHttpRequest.prototype.send = (0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(function(body) {
        var _this = this;
        if (this._datadog_xhr) {
            this._datadog_xhr.startTime = performance.now();
            var originalOnreadystatechange_1 = this.onreadystatechange;
            this.onreadystatechange = function() {
                if (this.readyState === XMLHttpRequest.DONE) (0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(reportXhr_1)();
                if (originalOnreadystatechange_1) originalOnreadystatechange_1.apply(this, arguments);
            };
            var hasBeenReported_1 = false;
            var reportXhr_1 = function() {
                if (hasBeenReported_1) return;
                hasBeenReported_1 = true;
                _this._datadog_xhr.duration = performance.now() - _this._datadog_xhr.startTime;
                _this._datadog_xhr.response = _this.response;
                _this._datadog_xhr.status = _this.status;
                $8727b470a4a06ca4$var$onRequestCompleteCallbacks.forEach(function(callback) {
                    return callback(_this._datadog_xhr);
                });
            };
            this.addEventListener('loadend', (0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(reportXhr_1));
            $8727b470a4a06ca4$var$beforeSendCallbacks.forEach(function(callback) {
                return callback(_this._datadog_xhr, _this);
            });
        }
        return $8727b470a4a06ca4$var$originalXhrSend.apply(this, arguments);
    });
}






function $763a927b1a086812$export$23010895ae865c96(context) {
    if (context.status === 0) {
        context.traceId = undefined;
        context.spanId = undefined;
    }
}
function $763a927b1a086812$export$faa83af43a19aa4b(configuration) {
    return {
        clearTracingIfCancelled: $763a927b1a086812$export$23010895ae865c96,
        traceFetch: function(context) {
            return $763a927b1a086812$var$injectHeadersIfTracingAllowed(configuration, context, function(tracingHeaders) {
                context.init = (0, $4514c4749dd578e8$export$18ce0697a983be9b)({}, context.init);
                var headers = [];
                if (context.init.headers instanceof Headers) context.init.headers.forEach(function(value, key) {
                    headers.push([
                        key,
                        value
                    ]);
                });
                else if (Array.isArray(context.init.headers)) context.init.headers.forEach(function(header) {
                    headers.push(header);
                });
                else if (context.init.headers) Object.keys(context.init.headers).forEach(function(key) {
                    headers.push([
                        key,
                        context.init.headers[key]
                    ]);
                });
                context.init.headers = headers.concat((0, $83a2a4f39556dd51$export$6a29ade99f81ec8a)(tracingHeaders));
            });
        },
        traceXhr: function(context, xhr) {
            return $763a927b1a086812$var$injectHeadersIfTracingAllowed(configuration, context, function(tracingHeaders) {
                Object.keys(tracingHeaders).forEach(function(name) {
                    xhr.setRequestHeader(name, tracingHeaders[name]);
                });
            });
        }
    };
}
function $763a927b1a086812$var$injectHeadersIfTracingAllowed(configuration, context, inject) {
    if (!$763a927b1a086812$export$fccc3aa05073f942() || !$763a927b1a086812$var$isAllowedUrl(configuration, context.url)) return;
    context.traceId = new $763a927b1a086812$export$37dfda1e537e7e28();
    context.spanId = new $763a927b1a086812$export$37dfda1e537e7e28();
    inject($763a927b1a086812$var$makeTracingHeaders(context.traceId, context.spanId));
}
function $763a927b1a086812$var$isAllowedUrl(configuration, requestUrl) {
    var requestOrigin = (0, $d13c4f85992def64$export$5a759dc7a1cfb72a)(requestUrl);
    for(var _i = 0, _a = configuration.allowedTracingOrigins; _i < _a.length; _i++){
        var allowedOrigin = _a[_i];
        if (requestOrigin === allowedOrigin || allowedOrigin instanceof RegExp && allowedOrigin.test(requestOrigin)) return true;
    }
    return false;
}
function $763a927b1a086812$export$fccc3aa05073f942() {
    return $763a927b1a086812$var$getCrypto() !== undefined;
}
function $763a927b1a086812$var$getCrypto() {
    return window.crypto || window.msCrypto;
}
function $763a927b1a086812$var$makeTracingHeaders(traceId, spanId) {
    return {
        'x-datadog-origin': 'rum',
        'x-datadog-parent-id': spanId.toDecimalString(),
        'x-datadog-sampled': '1',
        'x-datadog-sampling-priority': '1',
        'x-datadog-trace-id': traceId.toDecimalString()
    };
}
/* tslint:disable:no-bitwise */ var $763a927b1a086812$export$37dfda1e537e7e28 = /** @class */ function() {
    function TraceIdentifier() {
        this.buffer = new Uint8Array(8);
        $763a927b1a086812$var$getCrypto().getRandomValues(this.buffer);
        this.buffer[0] = this.buffer[0] & 0x7f; // force 63-bit
    }
    TraceIdentifier.prototype.toString = function(radix) {
        var high = this.readInt32(0);
        var low = this.readInt32(4);
        var str = '';
        while(true){
            var mod = high % radix * 4294967296 + low;
            high = Math.floor(high / radix);
            low = Math.floor(mod / radix);
            str = (mod % radix).toString(radix) + str;
            if (!high && !low) break;
        }
        return str;
    };
    /**
     * Format used everywhere except the trace intake
     */ TraceIdentifier.prototype.toDecimalString = function() {
        return this.toString(10);
    };
    TraceIdentifier.prototype.readInt32 = function(offset) {
        return this.buffer[offset] * 16777216 + (this.buffer[offset + 1] << 16) + (this.buffer[offset + 2] << 8) + this.buffer[offset + 3];
    };
    return TraceIdentifier;
}();
 /* tslint:enable:no-bitwise */ 

var $5d81c8e9eefcc18c$var$nextRequestIndex = 1;
function $5d81c8e9eefcc18c$export$254c90b445eb4949(lifeCycle, configuration) {
    var tracer = (0, $763a927b1a086812$export$faa83af43a19aa4b)(configuration);
    $5d81c8e9eefcc18c$export$cbfd392b1e1a167d(lifeCycle, configuration, tracer);
    $5d81c8e9eefcc18c$export$2862eaaabb376c8d(lifeCycle, configuration, tracer);
}
function $5d81c8e9eefcc18c$export$cbfd392b1e1a167d(lifeCycle, configuration, tracer) {
    var xhrProxy = (0, $8727b470a4a06ca4$export$e0fd5bb3c15407ec)();
    xhrProxy.beforeSend(function(context, xhr) {
        if ((0, $0ba15716cf612452$export$c298da523d6ed600)(configuration, context.url)) {
            tracer.traceXhr(context, xhr);
            context.requestIndex = $5d81c8e9eefcc18c$var$getNextRequestIndex();
            lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).REQUEST_STARTED, {
                requestIndex: context.requestIndex
            });
        }
    });
    xhrProxy.onRequestComplete(function(context) {
        if ((0, $0ba15716cf612452$export$c298da523d6ed600)(configuration, context.url)) {
            tracer.clearTracingIfCancelled(context);
            lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).REQUEST_COMPLETED, {
                duration: context.duration,
                method: context.method,
                requestIndex: context.requestIndex,
                response: context.response,
                spanId: context.spanId,
                startTime: context.startTime,
                status: context.status,
                traceId: context.traceId,
                type: (0, $83a2a4f39556dd51$export$8d9ecf8a6190d0ad).XHR,
                url: context.url
            });
        }
    });
    return xhrProxy;
}
function $5d81c8e9eefcc18c$export$2862eaaabb376c8d(lifeCycle, configuration, tracer) {
    var fetchProxy = (0, $f2e70d986afd1fbe$export$1abdee9356a90f04)();
    fetchProxy.beforeSend(function(context) {
        if ((0, $0ba15716cf612452$export$c298da523d6ed600)(configuration, context.url)) {
            tracer.traceFetch(context);
            context.requestIndex = $5d81c8e9eefcc18c$var$getNextRequestIndex();
            lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).REQUEST_STARTED, {
                requestIndex: context.requestIndex
            });
        }
    });
    fetchProxy.onRequestComplete(function(context) {
        if ((0, $0ba15716cf612452$export$c298da523d6ed600)(configuration, context.url)) {
            tracer.clearTracingIfCancelled(context);
            lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).REQUEST_COMPLETED, {
                duration: context.duration,
                method: context.method,
                requestIndex: context.requestIndex,
                response: context.response,
                responseType: context.responseType,
                spanId: context.spanId,
                startTime: context.startTime,
                status: context.status,
                traceId: context.traceId,
                type: (0, $83a2a4f39556dd51$export$8d9ecf8a6190d0ad).FETCH,
                url: context.url
            });
        }
    });
    return fetchProxy;
}
function $5d81c8e9eefcc18c$var$getNextRequestIndex() {
    var result = $5d81c8e9eefcc18c$var$nextRequestIndex;
    $5d81c8e9eefcc18c$var$nextRequestIndex += 1;
    return result;
}








function $30497b530deba6da$export$195095f773513078(lifeCycle, configuration) {
    lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).AUTO_ACTION_COMPLETED, function(action) {
        configuration.isEnabled('v2_format') ? lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).RAW_RUM_EVENT_V2_COLLECTED, $30497b530deba6da$var$processActionV2(action)) : lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).RAW_RUM_EVENT_COLLECTED, $30497b530deba6da$var$processAction(action));
    });
    if (configuration.trackInteractions) (0, $8fef60de5a27f899$export$aefbc69bc18c6c68)(lifeCycle);
    return {
        addAction: function(action, savedGlobalContext) {
            configuration.isEnabled('v2_format') ? lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).RAW_RUM_EVENT_V2_COLLECTED, (0, $4514c4749dd578e8$export$18ce0697a983be9b)({
                savedGlobalContext: savedGlobalContext
            }, $30497b530deba6da$var$processActionV2(action))) : lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).RAW_RUM_EVENT_COLLECTED, (0, $4514c4749dd578e8$export$18ce0697a983be9b)({
                savedGlobalContext: savedGlobalContext
            }, $30497b530deba6da$var$processAction(action)));
        }
    };
}
function $30497b530deba6da$var$processAction(action) {
    var autoActionProperties = $30497b530deba6da$var$isAutoAction(action) ? {
        duration: (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(action.duration),
        userAction: {
            id: action.id,
            measures: action.counts
        }
    } : undefined;
    var customerContext = !$30497b530deba6da$var$isAutoAction(action) ? action.context : undefined;
    var actionEvent = (0, $209814571e8229a4$export$1be1fc439b849fdf)({
        date: (0, $83a2a4f39556dd51$export$3c95c4c8b671ef0)(action.startTime),
        evt: {
            category: (0, $9e3879a7141a94c3$export$1951f08c2d18ec43).USER_ACTION,
            name: action.name
        },
        userAction: {
            type: action.type
        }
    }, autoActionProperties);
    return {
        customerContext: customerContext,
        rawRumEvent: actionEvent,
        startTime: action.startTime
    };
}
function $30497b530deba6da$var$processActionV2(action) {
    var autoActionProperties = $30497b530deba6da$var$isAutoAction(action) ? {
        action: {
            error: {
                count: action.counts.errorCount
            },
            id: action.id,
            loadingTime: (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(action.duration),
            longTask: {
                count: action.counts.longTaskCount
            },
            resource: {
                count: action.counts.resourceCount
            }
        }
    } : undefined;
    var customerContext = !$30497b530deba6da$var$isAutoAction(action) ? action.context : undefined;
    var actionEvent = (0, $209814571e8229a4$export$1be1fc439b849fdf)({
        action: {
            target: {
                name: action.name
            },
            type: action.type
        },
        date: (0, $83a2a4f39556dd51$export$3c95c4c8b671ef0)(action.startTime),
        type: (0, $dfb817fd62da85ed$export$ce36bdd8bcd00f70).ACTION
    }, autoActionProperties);
    return {
        customerContext: customerContext,
        rawRumEvent: actionEvent,
        startTime: action.startTime
    };
}
function $30497b530deba6da$var$isAutoAction(action) {
    return action.type !== (0, $8fef60de5a27f899$export$e4a712fff93fb00f).CUSTOM;
}











var $d77f27ceaa25118e$var$filteredErrorsObservable;
function $d77f27ceaa25118e$export$8bce50d0835da1e(configuration) {
    if (!$d77f27ceaa25118e$var$filteredErrorsObservable) {
        var errorObservable = new (0, $94423d3dd781adb9$export$77cea355fa80b5f4)();
        $d77f27ceaa25118e$export$bbcf004060b686b5(configuration, errorObservable);
        $d77f27ceaa25118e$export$30002c5a5d4f454a(errorObservable);
        $d77f27ceaa25118e$export$991287c1cf0527fe(errorObservable);
        $d77f27ceaa25118e$var$filteredErrorsObservable = $d77f27ceaa25118e$export$50c01357805887bf(configuration, errorObservable);
    }
    return $d77f27ceaa25118e$var$filteredErrorsObservable;
}
function $d77f27ceaa25118e$export$50c01357805887bf(configuration, errorObservable) {
    var errorCount = 0;
    var filteredErrorObservable = new (0, $94423d3dd781adb9$export$77cea355fa80b5f4)();
    errorObservable.subscribe(function(error) {
        if (errorCount < configuration.maxErrorsByMinute) {
            errorCount += 1;
            filteredErrorObservable.notify(error);
        } else if (errorCount === configuration.maxErrorsByMinute) {
            errorCount += 1;
            filteredErrorObservable.notify({
                message: "Reached max number of errors by minute: " + configuration.maxErrorsByMinute,
                source: (0, $5a0134dee269a95e$export$4f7d2dba9330699b).AGENT,
                startTime: performance.now()
            });
        }
    });
    setInterval(function() {
        return errorCount = 0;
    }, (0, $83a2a4f39556dd51$export$35acaebf644db34e));
    return filteredErrorObservable;
}
var $d77f27ceaa25118e$var$originalConsoleError;
function $d77f27ceaa25118e$export$30002c5a5d4f454a(errorObservable) {
    $d77f27ceaa25118e$var$originalConsoleError = console.error;
    console.error = (0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(function(message) {
        var optionalParams = [];
        for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
        $d77f27ceaa25118e$var$originalConsoleError.apply(console, (0, $2859a788dfc21b3e$export$6388937ca91ccae8)([
            message
        ], optionalParams));
        errorObservable.notify({
            message: (0, $2859a788dfc21b3e$export$6388937ca91ccae8)([
                'console error:',
                message
            ], optionalParams).map($d77f27ceaa25118e$var$formatConsoleParameters).join(' '),
            source: (0, $5a0134dee269a95e$export$4f7d2dba9330699b).CONSOLE,
            startTime: performance.now()
        });
    });
}
function $d77f27ceaa25118e$export$9b5425650bfd147b() {
    console.error = $d77f27ceaa25118e$var$originalConsoleError;
}
function $d77f27ceaa25118e$var$formatConsoleParameters(param) {
    if (typeof param === 'string') return param;
    if (param instanceof Error) return (0, $5a0134dee269a95e$export$36ad41d7075a6f2b)((0, $970466414c4d6ba5$export$81296eded4f2ac09)(param));
    return (0, $83a2a4f39556dd51$export$1f8609334739c2b6)(param, undefined, 2);
}
var $d77f27ceaa25118e$var$traceKitReportHandler;
function $d77f27ceaa25118e$export$991287c1cf0527fe(errorObservable) {
    $d77f27ceaa25118e$var$traceKitReportHandler = function(stackTrace, _, errorObject) {
        var _a = (0, $5a0134dee269a95e$export$58b296e18a9447b7)(stackTrace, errorObject, 'Uncaught'), stack = _a.stack, message = _a.message, type = _a.type;
        errorObservable.notify({
            message: message,
            stack: stack,
            type: type,
            source: (0, $5a0134dee269a95e$export$4f7d2dba9330699b).SOURCE,
            startTime: performance.now()
        });
    };
    (0, $970466414c4d6ba5$export$f18d5b0af29128b7).subscribe($d77f27ceaa25118e$var$traceKitReportHandler);
}
function $d77f27ceaa25118e$export$89d06b1b18ba75c3() {
    (0, $970466414c4d6ba5$export$f18d5b0af29128b7).unsubscribe($d77f27ceaa25118e$var$traceKitReportHandler);
}
function $d77f27ceaa25118e$export$bbcf004060b686b5(configuration, errorObservable) {
    (0, $8727b470a4a06ca4$export$e0fd5bb3c15407ec)().onRequestComplete(function(context) {
        return handleCompleteRequest((0, $83a2a4f39556dd51$export$8d9ecf8a6190d0ad).XHR, context);
    });
    (0, $f2e70d986afd1fbe$export$1abdee9356a90f04)().onRequestComplete(function(context) {
        return handleCompleteRequest((0, $83a2a4f39556dd51$export$8d9ecf8a6190d0ad).FETCH, context);
    });
    function handleCompleteRequest(type, request) {
        if (!configuration.isIntakeUrl(request.url) && ($d77f27ceaa25118e$var$isRejected(request) || $d77f27ceaa25118e$var$isServerError(request))) errorObservable.notify({
            message: $d77f27ceaa25118e$var$format(type) + " error " + request.method + " " + request.url,
            resource: {
                method: request.method,
                statusCode: request.status,
                url: request.url
            },
            source: (0, $5a0134dee269a95e$export$4f7d2dba9330699b).NETWORK,
            stack: $d77f27ceaa25118e$var$truncateResponse(request.response, configuration) || 'Failed to load',
            startTime: request.startTime
        });
    }
    return {
        stop: function() {
            (0, $8727b470a4a06ca4$export$d89427a2144a9c92)();
            (0, $f2e70d986afd1fbe$export$4ea98215537abe70)();
        }
    };
}
function $d77f27ceaa25118e$var$isRejected(request) {
    return request.status === 0 && request.responseType !== 'opaque';
}
function $d77f27ceaa25118e$var$isServerError(request) {
    return request.status >= 500;
}
function $d77f27ceaa25118e$var$truncateResponse(response, configuration) {
    if (response && response.length > configuration.requestErrorResponseLengthLimit) return response.substring(0, configuration.requestErrorResponseLengthLimit) + "...";
    return response;
}
function $d77f27ceaa25118e$var$format(type) {
    if ((0, $83a2a4f39556dd51$export$8d9ecf8a6190d0ad).XHR === type) return 'XHR';
    return 'Fetch';
}





function $84bb060710eacb54$export$243c2bf7ff6b9330(lifeCycle, configuration) {
    return $84bb060710eacb54$export$87a10e29a48f580b(lifeCycle, configuration, (0, $d77f27ceaa25118e$export$8bce50d0835da1e)(configuration));
}
function $84bb060710eacb54$export$87a10e29a48f580b(lifeCycle, configuration, observable) {
    observable.subscribe(function(error) {
        configuration.isEnabled('v2_format') ? lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).RAW_RUM_EVENT_V2_COLLECTED, $84bb060710eacb54$var$processErrorV2(error)) : lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).RAW_RUM_EVENT_COLLECTED, $84bb060710eacb54$var$processError(error));
    });
    return {
        addError: function(_a, savedGlobalContext) {
            var error = _a.error, startTime = _a.startTime, customerContext = _a.context, source = _a.source;
            var rawError = $84bb060710eacb54$var$computeRawError(error, startTime, source);
            configuration.isEnabled('v2_format') ? lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).RAW_RUM_EVENT_V2_COLLECTED, (0, $4514c4749dd578e8$export$18ce0697a983be9b)({
                customerContext: customerContext,
                savedGlobalContext: savedGlobalContext
            }, $84bb060710eacb54$var$processErrorV2(rawError))) : lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).RAW_RUM_EVENT_COLLECTED, (0, $4514c4749dd578e8$export$18ce0697a983be9b)({
                customerContext: customerContext,
                savedGlobalContext: savedGlobalContext
            }, $84bb060710eacb54$var$processError(rawError)));
        }
    };
}
function $84bb060710eacb54$var$computeRawError(error, startTime, source) {
    var stackTrace = error instanceof Error ? (0, $970466414c4d6ba5$export$81296eded4f2ac09)(error) : undefined;
    return (0, $4514c4749dd578e8$export$18ce0697a983be9b)({
        startTime: startTime,
        source: source
    }, (0, $5a0134dee269a95e$export$58b296e18a9447b7)(stackTrace, error, 'Provided'));
}
function $84bb060710eacb54$var$processError(error) {
    var rawRumEvent = (0, $209814571e8229a4$export$1be1fc439b849fdf)({
        date: (0, $83a2a4f39556dd51$export$3c95c4c8b671ef0)(error.startTime),
        error: {
            kind: error.type,
            origin: error.source,
            stack: error.stack
        },
        evt: {
            category: (0, $9e3879a7141a94c3$export$1951f08c2d18ec43).ERROR
        },
        message: error.message
    }, error.resource ? {
        http: {
            method: error.resource.method,
            status_code: error.resource.statusCode,
            url: error.resource.url
        }
    } : undefined);
    return {
        rawRumEvent: rawRumEvent,
        startTime: error.startTime
    };
}
function $84bb060710eacb54$var$processErrorV2(error) {
    var rawRumEvent = {
        date: (0, $83a2a4f39556dd51$export$3c95c4c8b671ef0)(error.startTime),
        error: {
            message: error.message,
            resource: error.resource,
            source: error.source,
            stack: error.stack,
            type: error.type
        },
        type: (0, $dfb817fd62da85ed$export$ce36bdd8bcd00f70).ERROR
    };
    return {
        rawRumEvent: rawRumEvent,
        startTime: error.startTime
    };
}






function $db8edffb12eeb1fa$export$52c09388c428dadc(lifeCycle, configuration) {
    lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).PERFORMANCE_ENTRY_COLLECTED, function(entry) {
        if (entry.entryType !== 'longtask') return;
        if (configuration.isEnabled('v2_format')) {
            var rawRumEvent = {
                date: (0, $83a2a4f39556dd51$export$3c95c4c8b671ef0)(entry.startTime),
                longTask: {
                    duration: (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(entry.duration)
                },
                type: (0, $dfb817fd62da85ed$export$ce36bdd8bcd00f70).LONG_TASK
            };
            lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).RAW_RUM_EVENT_V2_COLLECTED, {
                rawRumEvent: rawRumEvent,
                startTime: entry.startTime
            });
        } else {
            var rawRumEvent = {
                date: (0, $83a2a4f39556dd51$export$3c95c4c8b671ef0)(entry.startTime),
                duration: (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(entry.duration),
                evt: {
                    category: (0, $9e3879a7141a94c3$export$1951f08c2d18ec43).LONG_TASK
                }
            };
            lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).RAW_RUM_EVENT_COLLECTED, {
                rawRumEvent: rawRumEvent,
                startTime: entry.startTime
            });
        }
    });
}








function $776f11d0da6bf656$export$e1e748c1442e0aa(request) {
    if (!performance || !('getEntriesByName' in performance)) return;
    var sameNameEntries = performance.getEntriesByName(request.url, 'resource');
    if (!sameNameEntries.length || !('toJSON' in sameNameEntries[0])) return;
    var candidates = sameNameEntries.map(function(entry) {
        return entry.toJSON();
    }).filter((0, $0ba15716cf612452$export$15341232ff5dd6e5)).filter(function(entry) {
        return $776f11d0da6bf656$var$isBetween(entry, request.startTime, $776f11d0da6bf656$var$endTime(request));
    });
    if (candidates.length === 1) return candidates[0];
    if (candidates.length === 2 && $776f11d0da6bf656$var$firstCanBeOptionRequest(candidates)) return candidates[1];
    return;
}
function $776f11d0da6bf656$var$firstCanBeOptionRequest(correspondingEntries) {
    return $776f11d0da6bf656$var$endTime(correspondingEntries[0]) <= correspondingEntries[1].startTime;
}
function $776f11d0da6bf656$var$endTime(timing) {
    return timing.startTime + timing.duration;
}
function $776f11d0da6bf656$var$isBetween(timing, start, end) {
    return timing.startTime >= start && $776f11d0da6bf656$var$endTime(timing) <= end;
}



function $6f9f9a0b6836eed5$export$7a0c7e0d79d84977(lifeCycle, configuration, session) {
    lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).REQUEST_COMPLETED, function(request) {
        if (session.isTrackedWithResource()) configuration.isEnabled('v2_format') ? lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).RAW_RUM_EVENT_V2_COLLECTED, $6f9f9a0b6836eed5$var$processRequestV2(request)) : lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).RAW_RUM_EVENT_COLLECTED, $6f9f9a0b6836eed5$var$processRequest(request));
    });
    lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).PERFORMANCE_ENTRY_COLLECTED, function(entry) {
        if (session.isTrackedWithResource() && entry.entryType === 'resource' && !(0, $0ba15716cf612452$export$8bc876d854d05e34)(entry)) configuration.isEnabled('v2_format') ? lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).RAW_RUM_EVENT_V2_COLLECTED, $6f9f9a0b6836eed5$var$processResourceEntryV2(entry)) : lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).RAW_RUM_EVENT_COLLECTED, $6f9f9a0b6836eed5$var$processResourceEntry(entry));
    });
}
function $6f9f9a0b6836eed5$var$processRequest(request) {
    var kind = request.type === (0, $83a2a4f39556dd51$export$8d9ecf8a6190d0ad).XHR ? (0, $83a2a4f39556dd51$export$c6f9da6f70cfc2eb).XHR : (0, $83a2a4f39556dd51$export$c6f9da6f70cfc2eb).FETCH;
    var matchingTiming = (0, $776f11d0da6bf656$export$e1e748c1442e0aa)(request);
    var startTime = matchingTiming ? matchingTiming.startTime : request.startTime;
    var correspondingTimingOverrides = matchingTiming ? $6f9f9a0b6836eed5$var$computePerformanceEntryMetrics(matchingTiming) : undefined;
    var tracingInfo = $6f9f9a0b6836eed5$var$computeRequestTracingInfo(request);
    var resourceEvent = (0, $209814571e8229a4$export$1be1fc439b849fdf)({
        date: (0, $83a2a4f39556dd51$export$3c95c4c8b671ef0)(startTime),
        duration: (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(request.duration),
        evt: {
            category: (0, $9e3879a7141a94c3$export$1951f08c2d18ec43).RESOURCE
        },
        http: {
            method: request.method,
            statusCode: request.status,
            url: request.url
        },
        resource: {
            kind: kind
        }
    }, tracingInfo, correspondingTimingOverrides);
    return {
        startTime: startTime,
        rawRumEvent: resourceEvent
    };
}
function $6f9f9a0b6836eed5$var$processRequestV2(request) {
    var type = request.type === (0, $83a2a4f39556dd51$export$8d9ecf8a6190d0ad).XHR ? (0, $83a2a4f39556dd51$export$c6f9da6f70cfc2eb).XHR : (0, $83a2a4f39556dd51$export$c6f9da6f70cfc2eb).FETCH;
    var matchingTiming = (0, $776f11d0da6bf656$export$e1e748c1442e0aa)(request);
    var startTime = matchingTiming ? matchingTiming.startTime : request.startTime;
    var correspondingTimingOverrides = matchingTiming ? $6f9f9a0b6836eed5$var$computePerformanceEntryMetricsV2(matchingTiming) : undefined;
    var tracingInfo = $6f9f9a0b6836eed5$var$computeRequestTracingInfo(request);
    var resourceEvent = (0, $209814571e8229a4$export$1be1fc439b849fdf)({
        date: (0, $83a2a4f39556dd51$export$3c95c4c8b671ef0)(startTime),
        resource: {
            type: type,
            duration: (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(request.duration),
            method: request.method,
            statusCode: request.status,
            url: request.url
        },
        type: (0, $dfb817fd62da85ed$export$ce36bdd8bcd00f70).RESOURCE
    }, tracingInfo, correspondingTimingOverrides);
    return {
        startTime: startTime,
        rawRumEvent: resourceEvent
    };
}
function $6f9f9a0b6836eed5$var$processResourceEntry(entry) {
    var resourceKind = (0, $0ba15716cf612452$export$5e78e8490e290d1f)(entry);
    var entryMetrics = $6f9f9a0b6836eed5$var$computePerformanceEntryMetrics(entry);
    var tracingInfo = $6f9f9a0b6836eed5$var$computeEntryTracingInfo(entry);
    var resourceEvent = (0, $209814571e8229a4$export$1be1fc439b849fdf)({
        date: (0, $83a2a4f39556dd51$export$3c95c4c8b671ef0)(entry.startTime),
        evt: {
            category: (0, $9e3879a7141a94c3$export$1951f08c2d18ec43).RESOURCE
        },
        http: {
            url: entry.name
        },
        resource: {
            kind: resourceKind
        }
    }, tracingInfo, entryMetrics);
    return {
        startTime: entry.startTime,
        rawRumEvent: resourceEvent
    };
}
function $6f9f9a0b6836eed5$var$processResourceEntryV2(entry) {
    var type = (0, $0ba15716cf612452$export$5e78e8490e290d1f)(entry);
    var entryMetrics = $6f9f9a0b6836eed5$var$computePerformanceEntryMetricsV2(entry);
    var tracingInfo = $6f9f9a0b6836eed5$var$computeEntryTracingInfo(entry);
    var resourceEvent = (0, $209814571e8229a4$export$1be1fc439b849fdf)({
        date: (0, $83a2a4f39556dd51$export$3c95c4c8b671ef0)(entry.startTime),
        resource: {
            type: type,
            url: entry.name
        },
        type: (0, $dfb817fd62da85ed$export$ce36bdd8bcd00f70).RESOURCE
    }, tracingInfo, entryMetrics);
    return {
        startTime: entry.startTime,
        rawRumEvent: resourceEvent
    };
}
function $6f9f9a0b6836eed5$var$computePerformanceEntryMetrics(timing) {
    return {
        duration: (0, $0ba15716cf612452$export$883ce645d410c918)(timing),
        http: {
            performance: (0, $0ba15716cf612452$export$6833c1608b6b5e2e)(timing)
        },
        network: {
            bytesWritten: (0, $0ba15716cf612452$export$887c770fbe334306)(timing)
        }
    };
}
function $6f9f9a0b6836eed5$var$computePerformanceEntryMetricsV2(timing) {
    return {
        resource: (0, $4514c4749dd578e8$export$18ce0697a983be9b)({
            duration: (0, $0ba15716cf612452$export$883ce645d410c918)(timing),
            size: (0, $0ba15716cf612452$export$887c770fbe334306)(timing)
        }, (0, $0ba15716cf612452$export$6833c1608b6b5e2e)(timing))
    };
}
function $6f9f9a0b6836eed5$var$computeRequestTracingInfo(request) {
    var hasBeenTraced = request.traceId && request.spanId;
    if (!hasBeenTraced) return undefined;
    return {
        _dd: {
            spanId: request.spanId.toDecimalString(),
            traceId: request.traceId.toDecimalString()
        },
        resource: {
            id: (0, $83a2a4f39556dd51$export$e73c8bd0f20705a)()
        }
    };
}
function $6f9f9a0b6836eed5$var$computeEntryTracingInfo(entry) {
    return entry.traceId ? {
        _dd: {
            traceId: entry.traceId
        }
    } : undefined;
}

















var $4d09d9f560d74770$var$trackFirstHiddenSingleton;
var $4d09d9f560d74770$var$stopListeners;
function $4d09d9f560d74770$export$42b1d249aa2dee14(emitter) {
    if (emitter === void 0) emitter = window;
    if (!$4d09d9f560d74770$var$trackFirstHiddenSingleton) {
        if (document.visibilityState === 'hidden') $4d09d9f560d74770$var$trackFirstHiddenSingleton = {
            timeStamp: 0
        };
        else {
            $4d09d9f560d74770$var$trackFirstHiddenSingleton = {
                timeStamp: Infinity
            };
            $4d09d9f560d74770$var$stopListeners = (0, $83a2a4f39556dd51$export$3f65cefe8380dbea)(emitter, (0, $83a2a4f39556dd51$export$54664c6599f7afe2).PAGE_HIDE, function(_a) {
                var timeStamp = _a.timeStamp;
                $4d09d9f560d74770$var$trackFirstHiddenSingleton.timeStamp = timeStamp;
            }, {
                capture: true,
                once: true
            }).stop;
        }
    }
    return $4d09d9f560d74770$var$trackFirstHiddenSingleton;
}
function $4d09d9f560d74770$export$c8ef0ee97e95e7a9() {
    if ($4d09d9f560d74770$var$stopListeners) $4d09d9f560d74770$var$stopListeners();
    $4d09d9f560d74770$var$trackFirstHiddenSingleton = undefined;
}


function $f0c267c16860cb44$export$3b1634286697be81(lifeCycle, callback) {
    var timings;
    function setTimings(newTimings) {
        timings = (0, $4514c4749dd578e8$export$18ce0697a983be9b)((0, $4514c4749dd578e8$export$18ce0697a983be9b)({}, timings), newTimings);
        callback(timings);
    }
    var stopNavigationTracking = $f0c267c16860cb44$export$8e38110c52840b40(lifeCycle, setTimings).stop;
    var stopFCPTracking = $f0c267c16860cb44$export$a43e15ae3a012adf(lifeCycle, function(firstContentfulPaint) {
        return setTimings({
            firstContentfulPaint: firstContentfulPaint
        });
    }).stop;
    var stopLCPTracking = $f0c267c16860cb44$export$e39d61369fabf03f(lifeCycle, window, function(largestContentfulPaint) {
        setTimings({
            largestContentfulPaint: largestContentfulPaint
        });
    }).stop;
    var stopFIDTracking = $f0c267c16860cb44$export$5f60dc1232b97dd(lifeCycle, function(firstInputDelay) {
        setTimings({
            firstInputDelay: firstInputDelay
        });
    }).stop;
    return {
        stop: function() {
            stopNavigationTracking();
            stopFCPTracking();
            stopLCPTracking();
            stopFIDTracking();
        }
    };
}
function $f0c267c16860cb44$export$8e38110c52840b40(lifeCycle, callback) {
    var stop = lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).PERFORMANCE_ENTRY_COLLECTED, function(entry) {
        if (entry.entryType === 'navigation') callback({
            domComplete: entry.domComplete,
            domContentLoaded: entry.domContentLoadedEventEnd,
            domInteractive: entry.domInteractive,
            loadEventEnd: entry.loadEventEnd
        });
    }).unsubscribe;
    return {
        stop: stop
    };
}
function $f0c267c16860cb44$export$a43e15ae3a012adf(lifeCycle, callback) {
    var firstHidden = (0, $4d09d9f560d74770$export$42b1d249aa2dee14)();
    var stop = lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).PERFORMANCE_ENTRY_COLLECTED, function(entry) {
        if (entry.entryType === 'paint' && entry.name === 'first-contentful-paint' && entry.startTime < firstHidden.timeStamp) callback(entry.startTime);
    }).unsubscribe;
    return {
        stop: stop
    };
}
function $f0c267c16860cb44$export$e39d61369fabf03f(lifeCycle, emitter, callback) {
    var firstHidden = (0, $4d09d9f560d74770$export$42b1d249aa2dee14)();
    // Ignore entries that come after the first user interaction.  According to the documentation, the
    // browser should not send largest-contentful-paint entries after a user interact with the page,
    // but the web-vitals reference implementation uses this as a safeguard.
    var firstInteractionTimestamp = Infinity;
    var stopEventListener = (0, $83a2a4f39556dd51$export$40a4ed63e5cb7043)(emitter, [
        (0, $83a2a4f39556dd51$export$54664c6599f7afe2).POINTER_DOWN,
        (0, $83a2a4f39556dd51$export$54664c6599f7afe2).KEY_DOWN
    ], function(event) {
        firstInteractionTimestamp = event.timeStamp;
    }, {
        capture: true,
        once: true
    }).stop;
    var unsubcribeLifeCycle = lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).PERFORMANCE_ENTRY_COLLECTED, function(entry) {
        if (entry.entryType === 'largest-contentful-paint' && entry.startTime < firstInteractionTimestamp && entry.startTime < firstHidden.timeStamp) callback(entry.startTime);
    }).unsubscribe;
    return {
        stop: function() {
            stopEventListener();
            unsubcribeLifeCycle();
        }
    };
}
function $f0c267c16860cb44$export$5f60dc1232b97dd(lifeCycle, callback) {
    var firstHidden = (0, $4d09d9f560d74770$export$42b1d249aa2dee14)();
    var stop = lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).PERFORMANCE_ENTRY_COLLECTED, function(entry) {
        if (entry.entryType === 'first-input' && entry.startTime < firstHidden.timeStamp) callback(entry.processingStart - entry.startTime);
    }).unsubscribe;
    return {
        stop: stop
    };
}


var $1ab3d331ea4d8b9b$export$82f61b2f79c8be94;
(function(ViewLoadingType) {
    ViewLoadingType["INITIAL_LOAD"] = "initial_load";
    ViewLoadingType["ROUTE_CHANGE"] = "route_change";
})($1ab3d331ea4d8b9b$export$82f61b2f79c8be94 || ($1ab3d331ea4d8b9b$export$82f61b2f79c8be94 = {}));
var $1ab3d331ea4d8b9b$export$547e59d66cff6939 = 3000;
var $1ab3d331ea4d8b9b$export$466344df8256a878 = 5 * (0, $83a2a4f39556dd51$export$35acaebf644db34e);
function $1ab3d331ea4d8b9b$export$a9e93bc2fdba42cf(location, lifeCycle) {
    var startOrigin = 0;
    var initialView = $1ab3d331ea4d8b9b$var$newView(lifeCycle, location, $1ab3d331ea4d8b9b$export$82f61b2f79c8be94.INITIAL_LOAD, document.referrer, startOrigin);
    var currentView = initialView;
    var stopTimingsTracking = (0, $f0c267c16860cb44$export$3b1634286697be81)(lifeCycle, function(timings) {
        initialView.updateTimings(timings);
        initialView.scheduleUpdate();
    }).stop;
    $1ab3d331ea4d8b9b$var$trackHistory(onLocationChange);
    $1ab3d331ea4d8b9b$var$trackHash(onLocationChange);
    function onLocationChange() {
        if (currentView.isDifferentView(location)) {
            // Renew view on location changes
            currentView.triggerUpdate();
            currentView.end();
            currentView = $1ab3d331ea4d8b9b$var$newView(lifeCycle, location, $1ab3d331ea4d8b9b$export$82f61b2f79c8be94.ROUTE_CHANGE, currentView.url);
        } else {
            currentView.updateLocation(location);
            currentView.triggerUpdate();
        }
    }
    // Renew view on session renewal
    lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).SESSION_RENEWED, function() {
        // do not trigger view update to avoid wrong data
        currentView.end();
        currentView = $1ab3d331ea4d8b9b$var$newView(lifeCycle, location, $1ab3d331ea4d8b9b$export$82f61b2f79c8be94.ROUTE_CHANGE, currentView.url);
    });
    // End the current view on page unload
    lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).BEFORE_UNLOAD, function() {
        currentView.triggerUpdate();
        currentView.end();
    });
    // Session keep alive
    var keepAliveInterval = window.setInterval((0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(function() {
        currentView.triggerUpdate();
    }), $1ab3d331ea4d8b9b$export$466344df8256a878);
    return {
        stop: function() {
            stopTimingsTracking();
            currentView.end();
            clearInterval(keepAliveInterval);
        }
    };
}
function $1ab3d331ea4d8b9b$var$newView(lifeCycle, initialLocation, loadingType, referrer, startTime) {
    if (startTime === void 0) startTime = performance.now();
    // Setup initial values
    var id = (0, $83a2a4f39556dd51$export$e73c8bd0f20705a)();
    var eventCounts = {
        errorCount: 0,
        longTaskCount: 0,
        resourceCount: 0,
        userActionCount: 0
    };
    var timings = {};
    var documentVersion = 0;
    var cumulativeLayoutShift;
    var loadingTime;
    var endTime;
    var location = (0, $4514c4749dd578e8$export$18ce0697a983be9b)({}, initialLocation);
    lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).VIEW_CREATED, {
        id: id,
        startTime: startTime,
        location: location,
        referrer: referrer
    });
    // Update the view every time the measures are changing
    var _a = (0, $83a2a4f39556dd51$export$de363e709c412c8a)((0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(triggerViewUpdate), $1ab3d331ea4d8b9b$export$547e59d66cff6939, {
        leading: false
    }), scheduleViewUpdate = _a.throttled, cancelScheduleViewUpdate = _a.cancel;
    var stopEventCountsTracking = (0, $7746d68c83e78bbf$export$a50549f6fbbed49b)(lifeCycle, function(newEventCounts) {
        eventCounts = newEventCounts;
        scheduleViewUpdate();
    }).stop;
    var _b = $1ab3d331ea4d8b9b$var$trackLoadingTime(loadingType, function(newLoadingTime) {
        loadingTime = newLoadingTime;
        scheduleViewUpdate();
    }), setActivityLoadingTime = _b.setActivityLoadingTime, setLoadEventEnd = _b.setLoadEventEnd;
    var stopActivityLoadingTimeTracking = $1ab3d331ea4d8b9b$var$trackActivityLoadingTime(lifeCycle, setActivityLoadingTime).stop;
    var stopCLSTracking;
    if ($1ab3d331ea4d8b9b$var$isLayoutShiftSupported()) {
        cumulativeLayoutShift = 0;
        stopCLSTracking = $1ab3d331ea4d8b9b$var$trackLayoutShift(lifeCycle, function(layoutShift) {
            cumulativeLayoutShift += layoutShift;
            scheduleViewUpdate();
        }).stop;
    } else stopCLSTracking = (0, $83a2a4f39556dd51$export$8793edee2d425525);
    // Initial view update
    triggerViewUpdate();
    function triggerViewUpdate() {
        documentVersion += 1;
        lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).VIEW_UPDATED, {
            cumulativeLayoutShift: cumulativeLayoutShift,
            documentVersion: documentVersion,
            eventCounts: eventCounts,
            id: id,
            loadingTime: loadingTime,
            loadingType: loadingType,
            location: location,
            referrer: referrer,
            startTime: startTime,
            timings: timings,
            duration: (endTime === undefined ? performance.now() : endTime) - startTime
        });
    }
    return {
        scheduleUpdate: scheduleViewUpdate,
        end: function() {
            endTime = performance.now();
            stopEventCountsTracking();
            stopActivityLoadingTimeTracking();
            stopCLSTracking();
        },
        isDifferentView: function(otherLocation) {
            return location.pathname !== otherLocation.pathname || !$1ab3d331ea4d8b9b$var$isHashAnAnchor(otherLocation.hash) && otherLocation.hash !== location.hash;
        },
        triggerUpdate: function() {
            // cancel any pending view updates execution
            cancelScheduleViewUpdate();
            triggerViewUpdate();
        },
        updateTimings: function(newTimings) {
            timings = newTimings;
            if (newTimings.loadEventEnd !== undefined) setLoadEventEnd(newTimings.loadEventEnd);
        },
        updateLocation: function(newLocation) {
            location = (0, $4514c4749dd578e8$export$18ce0697a983be9b)({}, newLocation);
        },
        get url () {
            return location.href;
        }
    };
}
function $1ab3d331ea4d8b9b$var$isHashAnAnchor(hash) {
    var correspondingId = hash.substr(1);
    return !!document.getElementById(correspondingId);
}
function $1ab3d331ea4d8b9b$var$trackHistory(onHistoryChange) {
    var originalPushState = history.pushState;
    history.pushState = (0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(function() {
        originalPushState.apply(this, arguments);
        onHistoryChange();
    });
    var originalReplaceState = history.replaceState;
    history.replaceState = (0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(function() {
        originalReplaceState.apply(this, arguments);
        onHistoryChange();
    });
    (0, $83a2a4f39556dd51$export$3f65cefe8380dbea)(window, (0, $83a2a4f39556dd51$export$54664c6599f7afe2).POP_STATE, onHistoryChange);
}
function $1ab3d331ea4d8b9b$var$trackHash(onHashChange) {
    (0, $83a2a4f39556dd51$export$3f65cefe8380dbea)(window, (0, $83a2a4f39556dd51$export$54664c6599f7afe2).HASH_CHANGE, onHashChange);
}
function $1ab3d331ea4d8b9b$var$trackLoadingTime(loadType, callback) {
    var isWaitingForLoadEventEnd = loadType === $1ab3d331ea4d8b9b$export$82f61b2f79c8be94.INITIAL_LOAD;
    var isWaitingForActivityLoadingTime = true;
    var loadingTimeCandidates = [];
    function invokeCallbackIfAllCandidatesAreReceived() {
        if (!isWaitingForActivityLoadingTime && !isWaitingForLoadEventEnd && loadingTimeCandidates.length > 0) callback(Math.max.apply(Math, loadingTimeCandidates));
    }
    return {
        setLoadEventEnd: function(loadEventEnd) {
            if (isWaitingForLoadEventEnd) {
                isWaitingForLoadEventEnd = false;
                loadingTimeCandidates.push(loadEventEnd);
                invokeCallbackIfAllCandidatesAreReceived();
            }
        },
        setActivityLoadingTime: function(activityLoadingTime) {
            if (isWaitingForActivityLoadingTime) {
                isWaitingForActivityLoadingTime = false;
                if (activityLoadingTime !== undefined) loadingTimeCandidates.push(activityLoadingTime);
                invokeCallbackIfAllCandidatesAreReceived();
            }
        }
    };
}
function $1ab3d331ea4d8b9b$var$trackActivityLoadingTime(lifeCycle, callback) {
    var startTime = performance.now();
    var stopWaitIdlePageActivity = (0, $756559e45e643551$export$b191740c85d918c5)(lifeCycle, function(hadActivity, endTime) {
        if (hadActivity) callback(endTime - startTime);
        else callback(undefined);
    }).stop;
    return {
        stop: stopWaitIdlePageActivity
    };
}
/**
 * Track layout shifts (LS) occuring during the Views.  This yields multiple values that can be
 * added up to compute the cumulated layout shift (CLS).
 *
 * See isLayoutShiftSupported to check for browser support.
 *
 * Documentation: https://web.dev/cls/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getCLS.ts
 */ function $1ab3d331ea4d8b9b$var$trackLayoutShift(lifeCycle, callback) {
    var stop = lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).PERFORMANCE_ENTRY_COLLECTED, function(entry) {
        if (entry.entryType === 'layout-shift' && !entry.hadRecentInput) callback(entry.value);
    }).unsubscribe;
    return {
        stop: stop
    };
}
/**
 * Check whether `layout-shift` is supported by the browser.
 */ function $1ab3d331ea4d8b9b$var$isLayoutShiftSupported() {
    return (0, $128592d80a007ba7$export$c6967607cdac15e8)('layout-shift');
}


function $5ebe628c494f8e36$export$794a32d201ece359(lifeCycle, configuration, location) {
    lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).VIEW_UPDATED, function(view) {
        configuration.isEnabled('v2_format') ? lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).RAW_RUM_EVENT_V2_COLLECTED, $5ebe628c494f8e36$var$processViewUpdateV2(view)) : lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).RAW_RUM_EVENT_COLLECTED, $5ebe628c494f8e36$var$processViewUpdate(view));
    });
    return (0, $1ab3d331ea4d8b9b$export$a9e93bc2fdba42cf)(location, lifeCycle);
}
function $5ebe628c494f8e36$var$processViewUpdate(view) {
    var viewEvent = {
        date: (0, $83a2a4f39556dd51$export$3c95c4c8b671ef0)(view.startTime),
        duration: (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(view.duration),
        evt: {
            category: (0, $9e3879a7141a94c3$export$1951f08c2d18ec43).VIEW
        },
        rum: {
            documentVersion: view.documentVersion
        },
        view: {
            loadingTime: (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(view.loadingTime),
            loadingType: view.loadingType,
            measures: (0, $4514c4749dd578e8$export$18ce0697a983be9b)((0, $4514c4749dd578e8$export$18ce0697a983be9b)({}, view.eventCounts), {
                domComplete: (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(view.timings.domComplete),
                domContentLoaded: (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(view.timings.domContentLoaded),
                domInteractive: (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(view.timings.domInteractive),
                firstContentfulPaint: (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(view.timings.firstContentfulPaint),
                loadEventEnd: (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(view.timings.loadEventEnd)
            })
        }
    };
    return {
        rawRumEvent: viewEvent,
        startTime: view.startTime
    };
}
function $5ebe628c494f8e36$var$processViewUpdateV2(view) {
    var viewEvent = {
        _dd: {
            documentVersion: view.documentVersion
        },
        date: (0, $83a2a4f39556dd51$export$3c95c4c8b671ef0)(view.startTime),
        type: (0, $dfb817fd62da85ed$export$ce36bdd8bcd00f70).VIEW,
        view: {
            action: {
                count: view.eventCounts.userActionCount
            },
            cumulativeLayoutShift: view.cumulativeLayoutShift,
            domComplete: (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(view.timings.domComplete),
            domContentLoaded: (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(view.timings.domContentLoaded),
            domInteractive: (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(view.timings.domInteractive),
            error: {
                count: view.eventCounts.errorCount
            },
            firstContentfulPaint: (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(view.timings.firstContentfulPaint),
            firstInputDelay: (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(view.timings.firstInputDelay),
            largestContentfulPaint: (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(view.timings.largestContentfulPaint),
            loadEventEnd: (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(view.timings.loadEventEnd),
            loadingTime: (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(view.loadingTime),
            loadingType: view.loadingType,
            longTask: {
                count: view.eventCounts.longTaskCount
            },
            resource: {
                count: view.eventCounts.resourceCount
            },
            timeSpent: (0, $83a2a4f39556dd51$export$7f62184c713eab1c)(view.duration)
        }
    };
    return {
        rawRumEvent: viewEvent,
        startTime: view.startTime
    };
}




var $68138f73a013fbe3$export$50ae25e0cd1ada34 = 'rum';
var $68138f73a013fbe3$export$b8f4454dbcd37881;
(function(RumTrackingType) {
    RumTrackingType["NOT_TRACKED"] = "0";
    RumTrackingType["TRACKED_WITH_RESOURCES"] = "1";
    RumTrackingType["TRACKED_WITHOUT_RESOURCES"] = "2";
})($68138f73a013fbe3$export$b8f4454dbcd37881 || ($68138f73a013fbe3$export$b8f4454dbcd37881 = {}));
function $68138f73a013fbe3$export$e1c848977a57ffab(configuration, lifeCycle) {
    var session = (0, $788c0a2db440e2b1$export$b2b88085c51ddc96)(configuration.cookieOptions, $68138f73a013fbe3$export$50ae25e0cd1ada34, function(rawTrackingType) {
        return $68138f73a013fbe3$var$computeSessionState(configuration, rawTrackingType);
    });
    session.renewObservable.subscribe(function() {
        lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).SESSION_RENEWED);
    });
    return {
        getId: session.getId,
        isTracked: function() {
            return session.getId() !== undefined && $68138f73a013fbe3$var$isTracked(session.getTrackingType());
        },
        isTrackedWithResource: function() {
            return session.getId() !== undefined && session.getTrackingType() === $68138f73a013fbe3$export$b8f4454dbcd37881.TRACKED_WITH_RESOURCES;
        }
    };
}
function $68138f73a013fbe3$var$computeSessionState(configuration, rawTrackingType) {
    var trackingType;
    if ($68138f73a013fbe3$var$hasValidRumSession(rawTrackingType)) trackingType = rawTrackingType;
    else if (!(0, $83a2a4f39556dd51$export$72c7afebfef3b500)(configuration.sampleRate)) trackingType = $68138f73a013fbe3$export$b8f4454dbcd37881.NOT_TRACKED;
    else if (!(0, $83a2a4f39556dd51$export$72c7afebfef3b500)(configuration.resourceSampleRate)) trackingType = $68138f73a013fbe3$export$b8f4454dbcd37881.TRACKED_WITHOUT_RESOURCES;
    else trackingType = $68138f73a013fbe3$export$b8f4454dbcd37881.TRACKED_WITH_RESOURCES;
    return {
        trackingType: trackingType,
        isTracked: $68138f73a013fbe3$var$isTracked(trackingType)
    };
}
function $68138f73a013fbe3$var$hasValidRumSession(trackingType) {
    return trackingType === $68138f73a013fbe3$export$b8f4454dbcd37881.NOT_TRACKED || trackingType === $68138f73a013fbe3$export$b8f4454dbcd37881.TRACKED_WITH_RESOURCES || trackingType === $68138f73a013fbe3$export$b8f4454dbcd37881.TRACKED_WITHOUT_RESOURCES;
}
function $68138f73a013fbe3$var$isTracked(rumSessionType) {
    return rumSessionType === $68138f73a013fbe3$export$b8f4454dbcd37881.TRACKED_WITH_RESOURCES || rumSessionType === $68138f73a013fbe3$export$b8f4454dbcd37881.TRACKED_WITHOUT_RESOURCES;
}






function $1391e8dd5095de23$export$33e6a2986ce7483(configuration, lifeCycle) {
    var batch = $1391e8dd5095de23$var$makeRumBatch(configuration, lifeCycle);
    lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).RUM_EVENT_COLLECTED, function(_a) {
        var rumEvent = _a.rumEvent, serverRumEvent = _a.serverRumEvent;
        if (rumEvent.evt.category === (0, $9e3879a7141a94c3$export$1951f08c2d18ec43).VIEW) batch.upsert(serverRumEvent, rumEvent.view.id);
        else batch.add(serverRumEvent);
    });
    lifeCycle.subscribe((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).RUM_EVENT_V2_COLLECTED, function(_a) {
        var rumEvent = _a.rumEvent, serverRumEvent = _a.serverRumEvent;
        if (rumEvent.type === (0, $dfb817fd62da85ed$export$ce36bdd8bcd00f70).VIEW) batch.upsert(serverRumEvent, rumEvent.view.id);
        else batch.add(serverRumEvent);
    });
    return {
        stop: function() {
            batch.stop();
        }
    };
}
function $1391e8dd5095de23$var$makeRumBatch(configuration, lifeCycle) {
    var primaryBatch = createRumBatch(configuration.rumEndpoint, function() {
        return lifeCycle.notify((0, $9c4fc5ab3856082d$export$b21eaca6c6da9627).BEFORE_UNLOAD);
    });
    var replicaBatch;
    var replica = configuration.replica;
    if (replica !== undefined) replicaBatch = createRumBatch(replica.rumEndpoint);
    function createRumBatch(endpointUrl, unloadCallback) {
        return new (0, $c09b4659606d56db$export$33b107562567fc47)(new (0, $c09b4659606d56db$export$7587955500404ec3)(endpointUrl, configuration.batchBytesLimit, true), configuration.maxBatchSize, configuration.batchBytesLimit, configuration.maxMessageSize, configuration.flushTimeout, unloadCallback);
    }
    function withReplicaApplicationId(message) {
        var applicationIdOverwrite = configuration.isEnabled('v2_format') ? {
            application: {
                id: replica.applicationId
            }
        } : {
            application_id: replica.applicationId
        };
        return (0, $209814571e8229a4$export$1be1fc439b849fdf)(message, applicationIdOverwrite);
    }
    var stopped = false;
    return {
        add: function(message) {
            if (stopped) return;
            primaryBatch.add(message);
            if (replicaBatch) replicaBatch.add(withReplicaApplicationId(message));
        },
        stop: function() {
            stopped = true;
        },
        upsert: function(message, key) {
            if (stopped) return;
            primaryBatch.upsert(message, key);
            if (replicaBatch) replicaBatch.upsert(withReplicaApplicationId(message), key);
        }
    };
}


var $c7f35d423ef0f0c2$export$4ed402e2a73dba32 = {
    buildMode: 'release',
    datacenter: 'us',
    sdkVersion: '1.26.3'
};


function $c04ede069f6f610c$export$3215a7cbec5ac3e0(userConfiguration, getGlobalContext) {
    var lifeCycle = new (0, $9c4fc5ab3856082d$export$6af70476896cbaec)();
    var _a = (0, $be3c451a0388de8d$export$6f264bb8dad46c3c)(userConfiguration, (0, $c7f35d423ef0f0c2$export$4ed402e2a73dba32)), configuration = _a.configuration, internalMonitoring = _a.internalMonitoring;
    var session = (0, $68138f73a013fbe3$export$e1c848977a57ffab)(configuration, lifeCycle);
    internalMonitoring.setExternalContextProvider(function() {
        return (0, $209814571e8229a4$export$1be1fc439b849fdf)({
            application_id: userConfiguration.applicationId
        }, parentContexts.findView(), getGlobalContext());
    });
    var _b = $c04ede069f6f610c$export$cd2ea6643dad23e3(userConfiguration.applicationId, location, lifeCycle, configuration, session, getGlobalContext), parentContexts = _b.parentContexts, addError = _b.addError, addAction = _b.addAction;
    (0, $5d81c8e9eefcc18c$export$254c90b445eb4949)(lifeCycle, configuration);
    (0, $128592d80a007ba7$export$4f22ae7bb247104c)(lifeCycle, configuration);
    (0, $62450ddce8fda713$export$d852bada4b1d0eba)(lifeCycle);
    var internalContext = (0, $df207bfbe80ee737$export$ee941cf091e8459)(userConfiguration.applicationId, session, parentContexts, configuration);
    return {
        addAction: addAction,
        addError: addError,
        getInternalContext: internalContext.get
    };
}
function $c04ede069f6f610c$export$cd2ea6643dad23e3(applicationId, location1, lifeCycle, configuration, session, getGlobalContext) {
    var parentContexts = (0, $473bb44a80d016b8$export$53602582b7256e1)(lifeCycle, session);
    var batch = (0, $1391e8dd5095de23$export$33e6a2986ce7483)(configuration, lifeCycle);
    (0, $e6e38e64873cf699$export$1a0bc162690d6539)(applicationId, configuration, lifeCycle, session, parentContexts, getGlobalContext);
    (0, $f541f110cdd65d09$export$1f6a544182411412)(applicationId, configuration, lifeCycle, session, parentContexts, getGlobalContext);
    (0, $db8edffb12eeb1fa$export$52c09388c428dadc)(lifeCycle, configuration);
    (0, $6f9f9a0b6836eed5$export$7a0c7e0d79d84977)(lifeCycle, configuration, session);
    (0, $5ebe628c494f8e36$export$794a32d201ece359)(lifeCycle, configuration, location1);
    var addError = (0, $84bb060710eacb54$export$243c2bf7ff6b9330)(lifeCycle, configuration).addError;
    var addAction = (0, $30497b530deba6da$export$195095f773513078)(lifeCycle, configuration).addAction;
    return {
        addAction: addAction,
        addError: addError,
        parentContexts: parentContexts,
        stop: function() {
            // prevent batch from previous tests to keep running and send unwanted requests
            // could be replaced by stopping all the component when they will all have a stop method
            batch.stop();
        }
    };
}


var $80940237791545d7$export$65cc181beb0d2632 = $80940237791545d7$export$625bea54fd2aa5b5((0, $c04ede069f6f610c$export$3215a7cbec5ac3e0));
(0, $be3c451a0388de8d$export$884b45263866f2b7)((0, $83a2a4f39556dd51$export$256479dc0cea61c4)(), 'DD_RUM', $80940237791545d7$export$65cc181beb0d2632);
function $80940237791545d7$export$625bea54fd2aa5b5(startRumImpl) {
    var isAlreadyInitialized = false;
    var globalContextManager = (0, $869d81f90661e153$export$fe3149b78a43e1ad)();
    var getInternalContextStrategy = function() {
        return undefined;
    };
    var beforeInitAddAction = new (0, $811952fd6645b932$export$6f427737fb8ce4c5)();
    var addActionStrategy = function(action) {
        beforeInitAddAction.add([
            action,
            (0, $209814571e8229a4$export$b7d58db314e0ac27)(globalContextManager.get())
        ]);
    };
    var beforeInitAddError = new (0, $811952fd6645b932$export$6f427737fb8ce4c5)();
    var addErrorStrategy = function(providedError) {
        beforeInitAddError.add([
            providedError,
            (0, $209814571e8229a4$export$b7d58db314e0ac27)(globalContextManager.get())
        ]);
    };
    var rumGlobal = (0, $be3c451a0388de8d$export$f9cbdb3394538aba)({
        init: (0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(function(userConfiguration) {
            var _a;
            if (!(0, $be3c451a0388de8d$export$f703bde2c3a224fb)((0, $94dd796a7c747e79$export$d037e740f60b1dc5)(userConfiguration)) || !(0, $be3c451a0388de8d$export$cfdc694e5825aaa6)() || !canInitRum(userConfiguration)) return;
            if (userConfiguration.publicApiKey) userConfiguration.clientToken = userConfiguration.publicApiKey;
            _a = startRumImpl(userConfiguration, globalContextManager.get), addActionStrategy = _a.addAction, addErrorStrategy = _a.addError, getInternalContextStrategy = _a.getInternalContext;
            beforeInitAddAction.drain(function(_a) {
                var action = _a[0], context = _a[1];
                return addActionStrategy(action, context);
            });
            beforeInitAddError.drain(function(_a) {
                var error = _a[0], context = _a[1];
                return addErrorStrategy(error, context);
            });
            isAlreadyInitialized = true;
        }),
        addRumGlobalContext: (0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(globalContextManager.add),
        removeRumGlobalContext: (0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(globalContextManager.remove),
        getRumGlobalContext: (0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(globalContextManager.get),
        setRumGlobalContext: (0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(globalContextManager.set),
        getInternalContext: (0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(function(startTime) {
            return getInternalContextStrategy(startTime);
        }),
        addAction: (0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(function(name, context) {
            addActionStrategy({
                name: name,
                context: (0, $209814571e8229a4$export$b7d58db314e0ac27)(context),
                startTime: performance.now(),
                type: (0, $8fef60de5a27f899$export$e4a712fff93fb00f).CUSTOM
            });
        }),
        addUserAction: function(name, context) {
            // TODO deprecate in v2
            rumGlobal.addAction(name, context);
        },
        addError: (0, $09f70ea01c107b30$export$ec5b303098bc4b7f)(function(error, context, source) {
            if (source === void 0) source = (0, $5a0134dee269a95e$export$4f7d2dba9330699b).CUSTOM;
            var checkedSource;
            if (source === (0, $5a0134dee269a95e$export$4f7d2dba9330699b).CUSTOM || source === (0, $5a0134dee269a95e$export$4f7d2dba9330699b).NETWORK || source === (0, $5a0134dee269a95e$export$4f7d2dba9330699b).SOURCE) checkedSource = source;
            else {
                console.error("DD_RUM.addError: Invalid source '" + source + "'");
                checkedSource = (0, $5a0134dee269a95e$export$4f7d2dba9330699b).CUSTOM;
            }
            addErrorStrategy({
                error: error,
                context: (0, $209814571e8229a4$export$b7d58db314e0ac27)(context),
                source: checkedSource,
                startTime: performance.now()
            });
        })
    });
    return rumGlobal;
    function canInitRum(userConfiguration) {
        if (isAlreadyInitialized) {
            if (!userConfiguration.silentMultipleInit) console.error('DD_RUM is already initialized.');
            return false;
        }
        if (!userConfiguration || !userConfiguration.clientToken && !userConfiguration.publicApiKey) {
            console.error('Client Token is not configured, we will not send any data.');
            return false;
        }
        if (!userConfiguration.applicationId) {
            console.error('Application ID is not configured, no RUM data will be collected.');
            return false;
        }
        if (userConfiguration.sampleRate !== undefined && !(0, $83a2a4f39556dd51$export$d86432a85610ea90)(userConfiguration.sampleRate)) {
            console.error('Sample Rate should be a number between 0 and 100');
            return false;
        }
        if (userConfiguration.resourceSampleRate !== undefined && !(0, $83a2a4f39556dd51$export$d86432a85610ea90)(userConfiguration.resourceSampleRate)) {
            console.error('Resource Sample Rate should be a number between 0 and 100');
            return false;
        }
        if (Array.isArray(userConfiguration.allowedTracingOrigins) && userConfiguration.allowedTracingOrigins.length !== 0 && userConfiguration.service === undefined) {
            console.error('Service need to be configured when tracing is enabled');
            return false;
        }
        return true;
    }
}





const $04456a55398eabf4$var$isAdmin = localStorage.isAdmin === 'true';
const $04456a55398eabf4$var$enableServiceDesk = localStorage.enableServiceDesk === 'true';
const $04456a55398eabf4$var$defaultState = {
    id: localStorage.id,
    firstName: localStorage.firstName,
    lastName: localStorage.lastName,
    clientName: localStorage.clientName,
    clientId: Number(localStorage.clientId),
    email: localStorage.email,
    supportEmail: localStorage.supportEmail,
    isAdmin: $04456a55398eabf4$var$isAdmin,
    enableServiceDesk: $04456a55398eabf4$var$enableServiceDesk,
    globalAnnouncement: '',
    clientAnnouncement: '',
    clientChanging: false
};
const $04456a55398eabf4$export$122994dc05ba4308 = /*#__PURE__*/ $ieT14.createContext(null);
const $04456a55398eabf4$export$6523bc827434425d = $04456a55398eabf4$export$122994dc05ba4308.Consumer;
const $04456a55398eabf4$var$updateDataDogContext = (state, newValue)=>{
    const ddUserContext = {
        client: state.clientId,
        clientName: state.clientName,
        isAdmin: state.isAdmin,
        type: state.isAdmin ? 'admin' : 'user',
        id: state.id
    };
    // Only update custom datadog context if a property of user state tracked in datadog has changed
    const userkeys = [
        'clientId',
        'clientName',
        'isAdmin',
        'id'
    ];
    if (Object.keys(newValue).filter((key)=>userkeys.includes(key) && newValue[key] != state[key]).length > 0) {
        Object.keys(newValue).filter((key)=>userkeys.includes(key)).forEach((key)=>{
            switch(key){
                case 'clientId':
                    ddUserContext.client = newValue[key];
                    break;
                case 'isAdmin':
                    ddUserContext.type = newValue.isAdmin ? 'admin' : 'user';
                    ddUserContext.isAdmin = newValue.isAdmin;
                    break;
                default:
                    ddUserContext[key] = newValue[key];
                    break;
            }
        });
        (0, $80940237791545d7$export$65cc181beb0d2632).addRumGlobalContext('usr', ddUserContext);
    }
};
/**
 * Developer note: LocalStorage is read to set the default state of the app Context, but updates to Context must be set directly.
 * Be mindful to update both LocalStorage and the state manually when updating values, not just LocalStorage.
 * LocalStorage is used because Context cannot be set outside of a functional component.
 * This can be refactored to only use Context and bypass LocalStorage, but required significant regression testing due to the number of files affected.
 */ const $04456a55398eabf4$export$20d2b7652facc723 = (props)=>{
    const [state, setAppState] = (0, $ieT14.useState)(props.initialState || $04456a55398eabf4$var$defaultState);
    $ieT14.useEffect(()=>{
        (0, $80940237791545d7$export$65cc181beb0d2632).addRumGlobalContext('usr', {
            client: $04456a55398eabf4$var$defaultState.clientId,
            clientName: $04456a55398eabf4$var$defaultState.clientName,
            isAdmin: $04456a55398eabf4$var$defaultState.isAdmin,
            type: $04456a55398eabf4$var$defaultState.isAdmin ? 'admin' : 'user',
            id: $04456a55398eabf4$var$defaultState.id
        });
    }, []);
    const setState = (newValue)=>{
        $04456a55398eabf4$var$updateDataDogContext(state, newValue);
        setAppState((prevState)=>{
            return {
                ...prevState,
                ...newValue
            };
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($04456a55398eabf4$export$122994dc05ba4308.Provider, {
        value: {
            state: state,
            setState: setState
        },
        children: props.children
    });
};



var $ieT14 = parcelRequire("ieT14");


// TYPES
// UTILS
const $18693172d3695360$export$6acf61af03e62db = typeof window === 'undefined' || 'Deno' in window;
function $18693172d3695360$export$8793edee2d425525() {
    return undefined;
}
function $18693172d3695360$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function $18693172d3695360$export$e539f754e934e270(value) {
    return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function $18693172d3695360$export$acaf96a27438246b(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function $18693172d3695360$export$224e3b7078227b8a(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $18693172d3695360$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $18693172d3695360$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$18693172d3695360$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === 'function') return {
        ...arg3,
        queryKey: arg1,
        queryFn: arg2
    };
    return {
        ...arg2,
        queryKey: arg1
    };
}
function $18693172d3695360$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($18693172d3695360$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === 'function') return {
            ...arg3,
            mutationKey: arg1,
            mutationFn: arg2
        };
        return {
            ...arg2,
            mutationKey: arg1
        };
    }
    if (typeof arg1 === 'function') return {
        ...arg2,
        mutationFn: arg1
    };
    return {
        ...arg1
    };
}
function $18693172d3695360$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $18693172d3695360$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            queryKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $18693172d3695360$export$42387eeaac09cf54(arg1, arg2, arg3) {
    return $18693172d3695360$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            mutationKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $18693172d3695360$export$c5d1efe363797780(filters, query) {
    const { type: type = 'all', exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if ($18693172d3695360$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $18693172d3695360$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$18693172d3695360$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== 'all') {
        const isActive = query.isActive();
        if (type === 'active' && !isActive) return false;
        if (type === 'inactive' && isActive) return false;
    }
    if (typeof stale === 'boolean' && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== 'undefined' && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $18693172d3695360$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, fetching: fetching, predicate: predicate, mutationKey: mutationKey } = filters;
    if ($18693172d3695360$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($18693172d3695360$export$5fcb678681417b54(mutation.options.mutationKey) !== $18693172d3695360$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$18693172d3695360$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $18693172d3695360$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $18693172d3695360$export$5fcb678681417b54;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function $18693172d3695360$export$5fcb678681417b54(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$18693172d3695360$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function $18693172d3695360$export$2f07189bb9fa26a7(a, b) {
    return $18693172d3695360$export$3bc9138b70293839(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function $18693172d3695360$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === 'object' && typeof b === 'object') return !Object.keys(b).some((key)=>!$18693172d3695360$export$3bc9138b70293839(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function $18693172d3695360$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $18693172d3695360$export$7a8558113332b71e(a) && $18693172d3695360$export$7a8558113332b71e(b);
    if (array || $18693172d3695360$export$53b83ca8eaab0383(a) && $18693172d3695360$export$53b83ca8eaab0383(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = $18693172d3695360$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function $18693172d3695360$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $18693172d3695360$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $18693172d3695360$export$53b83ca8eaab0383(o) {
    if (!$18693172d3695360$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === 'undefined') return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!$18693172d3695360$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty('isPrototypeOf')) return false;
     // Most likely a plain Object
    return true;
}
function $18693172d3695360$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $18693172d3695360$export$aaae5295ec3351c9(value) {
    return Array.isArray(value);
}
function $18693172d3695360$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $18693172d3695360$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function $18693172d3695360$export$4304cb76768ca134(callback) {
    $18693172d3695360$export$e772c8ff12451969(0).then(callback);
}
function $18693172d3695360$export$382ca5d13a8f252c() {
    if (typeof AbortController === 'function') return new AbortController();
    return;
}
function $18693172d3695360$export$17619bac5b909b23(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === 'function') return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return $18693172d3695360$export$77a71fc411098696(prevData, data);
    return data;
}



function $c92d7790084acd39$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, $18693172d3695360$export$4304cb76768ca134)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, $18693172d3695360$export$4304cb76768ca134)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction
    };
} // SINGLETON
const $c92d7790084acd39$export$520687f44db6e1ab = $c92d7790084acd39$export$316a8efd03cd1458();


class $9cc1a4e40d9960ad$export$d26086b469ecdbcc {
    constructor(){
        this.listeners = new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        const identity = {
            listener: listener
        };
        this.listeners.add(identity);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(identity);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
}



class $57859f5d4fbb2468$export$86f1af424b2ca4de extends (0, $9cc1a4e40d9960ad$export$d26086b469ecdbcc) {
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $18693172d3695360$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener('visibilitychange', listener, false);
                window.addEventListener('focus', listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('visibilitychange', listener);
                    window.removeEventListener('focus', listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === 'boolean') this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.focused !== focused;
        if (changed) {
            this.focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === 'boolean') return this.focused;
         // document global can be unavailable in react native
        if (typeof document === 'undefined') return true;
        return [
            undefined,
            'visible',
            'prerender'
        ].includes(document.visibilityState);
    }
}
const $57859f5d4fbb2468$export$6bf54661be5b02cf = new $57859f5d4fbb2468$export$86f1af424b2ca4de();






const $c5be52d7b8157150$var$onlineEvents = [
    'online',
    'offline'
];
class $c5be52d7b8157150$export$58774fb55d5ff7fc extends (0, $9cc1a4e40d9960ad$export$d26086b469ecdbcc) {
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $18693172d3695360$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                $c5be52d7b8157150$var$onlineEvents.forEach((event)=>{
                    window.addEventListener(event, listener, false);
                });
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    $c5be52d7b8157150$var$onlineEvents.forEach((event)=>{
                        window.removeEventListener(event, listener);
                    });
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === 'boolean') this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        const changed = this.online !== online;
        if (changed) {
            this.online = online;
            this.onOnline();
        }
    }
    onOnline() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === 'boolean') return this.online;
        if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') return true;
        return navigator.onLine;
    }
}
const $c5be52d7b8157150$export$b113e788b2dd3fdc = new $c5be52d7b8157150$export$58774fb55d5ff7fc();



function $984e1698e746a614$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function $984e1698e746a614$export$61b92f63f30245cf(networkMode) {
    return (networkMode != null ? networkMode : 'online') === 'online' ? (0, $c5be52d7b8157150$export$b113e788b2dd3fdc).isOnline() : true;
}
class $984e1698e746a614$export$a8430ed4188f35a9 {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function $984e1698e746a614$export$986cc6445c1d323(value) {
    return value instanceof $984e1698e746a614$export$a8430ed4188f35a9;
}
function $984e1698e746a614$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $984e1698e746a614$export$a8430ed4188f35a9(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $57859f5d4fbb2468$export$6bf54661be5b02cf).isFocused() || config.networkMode !== 'always' && !(0, $c5be52d7b8157150$export$b113e788b2dd3fdc).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $984e1698e746a614$var$defaultRetryDelay;
            const delay = typeof retryDelay === 'function' ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === 'number' && failureCount < retry || typeof retry === 'function' && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, $18693172d3695360$export$e772c8ff12451969)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if ($984e1698e746a614$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}


class $c917427f2c534a20$export$a06cf8c0066f0d4c extends (0, $9cc1a4e40d9960ad$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.client = client;
        this.options = options;
        this.trackedProps = new Set();
        this.selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.currentQuery.addObserver(this);
            if ($c917427f2c534a20$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $c917427f2c534a20$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $c917427f2c534a20$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = new Set();
        this.clearStaleTimeout();
        this.clearRefetchInterval();
        this.currentQuery.removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryOptions(options);
        if (!(0, $18693172d3695360$export$3e67810a3f0e9f1c)(prevOptions, this.options)) this.client.getQueryCache().notify({
            type: 'observerOptionsUpdated',
            query: this.currentQuery,
            observer: this
        });
        if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') throw new Error('Expected enabled to be a boolean');
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        const mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $c917427f2c534a20$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.client.getQueryCache().build(this.client, options);
        const result = this.createResult(query, options);
        if ($c917427f2c534a20$var$shouldAssignObserverCurrentProperties(this, result, options)) {
            // this assigns the optimistic result to the current Observer
            // because if the query function changes, useQuery will be performing
            // an effect where it would fetch again.
            // When the fetch finishes, we perform a deep data cloning in order
            // to reuse objects references. This deep data clone is performed against
            // the `observer.currentResult.data` property
            // When QueryKey changes, we refresh the query and get new `optimistic`
            // result, while we leave the `observer.currentResult`, so when new data
            // arrives, it finds the old `observer.currentResult` which is related
            // to the old QueryKey. Which means that currentResult and selectData are
            // out of sync already.
            // To solve this, we move the cursor of the currentResult everytime
            // an observer reads an optimistic value.
            // When keeping the previous data, the result doesn't change until new
            // data arrives.
            this.currentResult = result;
            this.currentResultOptions = this.options;
            this.currentResultState = this.currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.currentResult;
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackedProps.add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return this.currentQuery;
    }
    remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    }
    refetch({ refetchPage: refetchPage, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                refetchPage: refetchPage
            }
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.client.defaultQueryOptions(options);
        const query = this.client.getQueryCache().build(this.client, defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions$cancelR;
        return this.executeFetch({
            ...fetchOptions,
            cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
        }).then(()=>{
            this.updateResult();
            return this.currentResult;
        });
    }
    executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        let promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions != null && fetchOptions.throwOnError)) promise = promise.catch((0, $18693172d3695360$export$8793edee2d425525));
        return promise;
    }
    updateStaleTimeout() {
        this.clearStaleTimeout();
        if ((0, $18693172d3695360$export$6acf61af03e62db) || this.currentResult.isStale || !(0, $18693172d3695360$export$e539f754e934e270)(this.options.staleTime)) return;
        const time = (0, $18693172d3695360$export$811b83d62bcf47f0)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        const timeout = time + 1;
        this.staleTimeoutId = setTimeout(()=>{
            if (!this.currentResult.isStale) this.updateResult();
        }, timeout);
    }
    computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
    updateRefetchInterval(nextInterval) {
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $18693172d3695360$export$6acf61af03e62db) || this.options.enabled === false || !(0, $18693172d3695360$export$e539f754e934e270)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $57859f5d4fbb2468$export$6bf54661be5b02cf).isFocused()) this.executeFetch();
        }, this.currentRefetchInterval);
    }
    updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    }
    clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    }
    clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    }
    createResult(query, options) {
        const prevQuery = this.currentQuery;
        const prevOptions = this.options;
        const prevResult = this.currentResult;
        const prevResultState = this.currentResultState;
        const prevResultOptions = this.currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        const { state: state } = query;
        let { dataUpdatedAt: dataUpdatedAt, error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPreviousData = false;
        let isPlaceholderData = false;
        let data; // Optimistically set result in fetching state if needed
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $c917427f2c534a20$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $c917427f2c534a20$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $984e1698e746a614$export$61b92f63f30245cf)(query.options.networkMode) ? 'fetching' : 'paused';
                if (!dataUpdatedAt) status = 'loading';
            }
            if (options._optimisticResults === 'isRestoring') fetchStatus = 'idle';
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== 'error') {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== 'undefined') {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                data = (0, $18693172d3695360$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && status === 'loading') {
            let placeholderData; // Memoize placeholder data
            if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== 'undefined') try {
                    placeholderData = options.select(placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== 'undefined') {
                status = 'success';
                data = (0, $18693172d3695360$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = 'error';
        }
        const isFetching = fetchStatus === 'fetching';
        const isLoading = status === 'loading';
        const isError = status === 'error';
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isLoading: isLoading,
            isSuccess: status === 'success',
            isError: isError,
            isInitialLoading: isLoading && isFetching,
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isLoading,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === 'paused',
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $c917427f2c534a20$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = this.currentResult;
        const nextResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify and update result if something has changed
        if ((0, $18693172d3695360$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        this.currentResult = nextResult; // Determine which callbacks to trigger
        const defaultNotifyOptions = {
            cache: true
        };
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === 'function' ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === 'all' || !notifyOnChangePropsValue && !this.trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue != null ? notifyOnChangePropsValue : this.trackedProps);
            if (this.options.useErrorBoundary) includedProps.add('error');
            return Object.keys(this.currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        this.notify({
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    updateQuery() {
        const query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        const prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate(action) {
        const notifyOptions = {};
        if (action.type === 'success') notifyOptions.onSuccess = !action.manual;
        else if (action.type === 'error' && !(0, $984e1698e746a614$export$986cc6445c1d323)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    }
    notify(notifyOptions) {
        (0, $c92d7790084acd39$export$520687f44db6e1ab).batch(()=>{
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
                (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data);
                (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
            } else if (notifyOptions.onError) {
                var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
                (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error);
                (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) this.client.getQueryCache().notify({
                query: this.currentQuery,
                type: 'observerResultsUpdated'
            });
        });
    }
}
function $c917427f2c534a20$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}
function $c917427f2c534a20$var$shouldFetchOnMount(query, options) {
    return $c917427f2c534a20$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $c917427f2c534a20$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $c917427f2c534a20$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === 'function' ? field(query) : field;
        return value === 'always' || value !== false && $c917427f2c534a20$var$isStale(query, options);
    }
    return false;
}
function $c917427f2c534a20$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && $c917427f2c534a20$var$isStale(query, options);
}
function $c917427f2c534a20$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
} // this function would decide if we will update the observer's 'current'
// properties after an optimistic reading via getOptimisticResult
function $c917427f2c534a20$var$shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
    // it is important to keep this condition like this for three reasons:
    // 1. It will get removed in the v5
    // 2. it reads: don't update the properties if we want to keep the previous
    // data.
    // 3. The opposite condition (!options.keepPreviousData) would fallthrough
    // and will result in a bad decision
    if (options.keepPreviousData) return false;
     // this means we want to put some placeholder data when pending and queryKey
    // changed.
    if (options.placeholderData !== undefined) // re-assign properties only if current data is placeholder data
    // which means that data did not arrive yet, so, if there is some cached data
    // we need to "prepare" to receive it
    return optimisticResult.isPlaceholderData;
     // if the newly created result isn't what the observer is holding as current,
    // then we'll need to update the properties as well
    if (!(0, $18693172d3695360$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
     // basically, just keep previous properties if nothing changed
    return false;
}



var $ieT14 = parcelRequire("ieT14");

var $f8376a87b9e366e1$exports = {};
'use strict';

$f8376a87b9e366e1$exports = (parcelRequire("hGSYJ"));


'use client';
const $c6770b5961e89267$export$306c0aa65ff9ec16 = (0, $f8376a87b9e366e1$exports.useSyncExternalStore);



var $ieT14 = parcelRequire("ieT14");
'use client';
function $1fa932fada8c4839$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const $1fa932fada8c4839$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ $ieT14.createContext($1fa932fada8c4839$var$createValue()); // HOOK
const $1fa932fada8c4839$export$50dfac555130cafd = ()=>$ieT14.useContext($1fa932fada8c4839$var$QueryErrorResetBoundaryContext); // COMPONENT
const $1fa932fada8c4839$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $ieT14.useState(()=>$1fa932fada8c4839$var$createValue());
    return /*#__PURE__*/ $ieT14.createElement($1fa932fada8c4839$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === 'function' ? children(value) : children);
};



var $ieT14 = parcelRequire("ieT14");
'use client';
const $7fd0e6909adb481d$export$2fba198b5b2e37fa = /*#__PURE__*/ $ieT14.createContext(undefined);
const $7fd0e6909adb481d$var$QueryClientSharingContext = /*#__PURE__*/ $ieT14.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $7fd0e6909adb481d$var$getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== 'undefined') {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $7fd0e6909adb481d$export$2fba198b5b2e37fa;
        return window.ReactQueryClientContext;
    }
    return $7fd0e6909adb481d$export$2fba198b5b2e37fa;
}
const $7fd0e6909adb481d$export$22e77b9572c4fded = ({ context: context } = {})=>{
    const queryClient = $ieT14.useContext($7fd0e6909adb481d$var$getQueryClientContext(context, $ieT14.useContext($7fd0e6909adb481d$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error('No QueryClient set, use QueryClientProvider to set one');
    return queryClient;
};
const $7fd0e6909adb481d$export$45604f0cc8ae667b = ({ client: client, children: children, context: context, contextSharing: contextSharing = false })=>{
    $ieT14.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = $7fd0e6909adb481d$var$getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ $ieT14.createElement($7fd0e6909adb481d$var$QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ $ieT14.createElement(Context.Provider, {
        value: client
    }, children));
};



var $ieT14 = parcelRequire("ieT14");
'use client';
const $bdaa8a2a3d7c9ed9$var$IsRestoringContext = /*#__PURE__*/ $ieT14.createContext(false);
const $bdaa8a2a3d7c9ed9$export$4da0178d6b5f553 = ()=>$ieT14.useContext($bdaa8a2a3d7c9ed9$var$IsRestoringContext);
const $bdaa8a2a3d7c9ed9$export$593807d4e94f9621 = $bdaa8a2a3d7c9ed9$var$IsRestoringContext.Provider;



var $ieT14 = parcelRequire("ieT14");
function $ed090e6cb168c602$export$2072f68e6c3507cf(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === 'function') return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}


'use client';
const $91a305a04a22c14f$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const $91a305a04a22c14f$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $ieT14.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const $91a305a04a22c14f$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, useErrorBoundary: useErrorBoundary, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $ed090e6cb168c602$export$2072f68e6c3507cf)(useErrorBoundary, [
        result.error,
        query
    ]);
};


const $f405090a0d53802a$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    {
        if (typeof defaultedOptions.staleTime !== 'number') defaultedOptions.staleTime = 1000;
    }
};
const $f405090a0d53802a$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
const $f405090a0d53802a$export$88d3586dfed64df9 = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && $f405090a0d53802a$export$e0a3f29513afe430(result, isRestoring);
const $f405090a0d53802a$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).then(({ data: data })=>{
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });


'use client';
function $10a032f531c312ea$export$fff0865807e996c5(options, Observer) {
    const queryClient = (0, $7fd0e6909adb481d$export$22e77b9572c4fded)({
        context: options.context
    });
    const isRestoring = (0, $bdaa8a2a3d7c9ed9$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $1fa932fada8c4839$export$50dfac555130cafd)();
    const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions._optimisticResults = isRestoring ? 'isRestoring' : 'optimistic'; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $c92d7790084acd39$export$520687f44db6e1ab).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $c92d7790084acd39$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $c92d7790084acd39$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSettled);
    (0, $f405090a0d53802a$export$2c40a591ad2dafb1)(defaultedOptions);
    (0, $91a305a04a22c14f$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $91a305a04a22c14f$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $ieT14.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    (0, $c6770b5961e89267$export$306c0aa65ff9ec16)($ieT14.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>undefined : observer.subscribe((0, $c92d7790084acd39$export$520687f44db6e1ab).batchCalls(onStoreChange)); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $ieT14.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if ((0, $f405090a0d53802a$export$88d3586dfed64df9)(defaultedOptions, result, isRestoring)) throw (0, $f405090a0d53802a$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
     // Handle error boundary
    if ((0, $91a305a04a22c14f$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        useErrorBoundary: defaultedOptions.useErrorBoundary,
        query: observer.getCurrentQuery()
    })) throw result.error;
     // Handle result property usage tracking
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


'use client';
function $137a3b252d598119$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    const parsedOptions = (0, $18693172d3695360$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
    return (0, $10a032f531c312ea$export$fff0865807e996c5)(parsedOptions, (0, $c917427f2c534a20$export$a06cf8c0066f0d4c));
}




function $f54f7d0a50104e94$export$4823a6cc022cca16() {
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    return (0, $137a3b252d598119$export$dd0a697e1782aedd)([
        'clients'
    ], async ()=>{
        return fetchWrapper('api/clients?page=1&pageSize=0');
    });
}


/**
 * useDashboard
 * Custom hook leveraging React Query to cache global API state of currently
 * available clients and dashboards
 */ const $5f62b83faf48ee64$var$useDashboard = ()=>{
    const { state: state, setState: setState } = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    const clientsQuery = (0, $f54f7d0a50104e94$export$4823a6cc022cca16)();
    $ieT14.useEffect(()=>{
        if (clientsQuery.data) {
            const clients = clientsQuery.data.results;
            const currentClientId = state.clientId || clients[0].clientId;
            localStorage.setItem('clientId', currentClientId.toString());
            const activeClient = clients.filter((client)=>client.clientId === Number(currentClientId))[0];
            if (activeClient !== undefined) {
                localStorage.setItem('enableServiceDesk', activeClient.enableServiceDesk.toString());
                localStorage.setItem('supportEmail', activeClient.supportEmail);
            }
            setState({
                clientId: currentClientId,
                clientName: activeClient.name,
                enableServiceDesk: activeClient.enableServiceDesk,
                supportEmail: activeClient.supportEmail
            });
        }
    }, [
        clientsQuery.data
    ]);
    const dashboardsQuery = (0, $137a3b252d598119$export$dd0a697e1782aedd)([
        'dashboards',
        state.clientId
    ], async ()=>{
        return fetchWrapper(`api/${state.clientId}/dashboards/list`);
    }, {
        enabled: Boolean(clientsQuery.data && state.clientId)
    });
    return {
        clientsQuery: clientsQuery,
        dashboardsQuery: dashboardsQuery
    };
};
var $5f62b83faf48ee64$export$2e2bcd8739ae039 = $5f62b83faf48ee64$var$useDashboard;



var $fpdl2 = parcelRequire("fpdl2");


var $ieT14 = parcelRequire("ieT14");
const $dc97b0794e0fd33b$var$useTimedAlerts = ()=>{
    const [errorMessage, setErrorMessage] = $ieT14.useState('');
    const [successMessage, setSuccessMessage] = $ieT14.useState('');
    $ieT14.useEffect(()=>{
        const timer = setTimeout(()=>{
            setSuccessMessage('');
        }, 5000);
        return ()=>clearTimeout(timer);
    }, [
        successMessage
    ]);
    $ieT14.useEffect(()=>{
        const timer = setTimeout(()=>{
            setErrorMessage('');
        }, 5000);
        return ()=>clearTimeout(timer);
    }, [
        errorMessage
    ]);
    return {
        successMessage: successMessage,
        setSuccessMessage: setSuccessMessage,
        errorMessage: errorMessage,
        setErrorMessage: setErrorMessage
    };
};
var $dc97b0794e0fd33b$export$2e2bcd8739ae039 = $dc97b0794e0fd33b$var$useTimedAlerts;



var $fgoQ6 = parcelRequire("fgoQ6");
/**
 * @function Dashboard Outer component for the dashboard page
 */ const $3c58e713e466d62d$var$Dashboard = ({ location: location })=>{
    const appContext = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { clientsQuery: clientsQuery, dashboardsQuery: dashboardsQuery } = (0, $5f62b83faf48ee64$export$2e2bcd8739ae039)();
    const { errorMessage: errorMessage, setErrorMessage: setErrorMessage } = (0, $dc97b0794e0fd33b$export$2e2bcd8739ae039)();
    $ieT14.useEffect(()=>{
        if (!appContext.state.clientChanging) // if redirected from a non-existent report, show accompanying error in location state
        {
            if (location.state && location.state.error) setErrorMessage(location.state.error);
        }
        appContext.setState({
            clientChanging: false
        });
    }, []);
    /**
   * @function renderData - Renders the data to be displayed on the main dashboard
   */ const renderData = ()=>{
        if (dashboardsQuery.data && dashboardsQuery.data.dashboards.length === 0) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
            type: "warning",
            message: "No dashboards available to display"
        });
        if (dashboardsQuery.data) return dashboardsQuery.data.dashboards.map((dashboard)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f850402a01591398$export$2e2bcd8739ae039), {
                dashboard: dashboard
            }, dashboard.id));
        if (dashboardsQuery.isError) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
            type: "error",
            message: dashboardsQuery.error.message
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $8d092a71a781e0c6$export$34e0f9847d4c02dd,
        children: [
            errorMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
                type: "error",
                message: errorMessage
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h1", {
                children: "Dashboards"
            }),
            clientsQuery.isLoading || dashboardsQuery.isLoading ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: "loadingIndicator",
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
            }) : renderData()
        ]
    });
};
var $3c58e713e466d62d$export$2e2bcd8739ae039 = $3c58e713e466d62d$var$Dashboard;




var $ieT14 = parcelRequire("ieT14");


var $ieT14 = parcelRequire("ieT14");

var $6mt9R = parcelRequire("6mt9R");

var $3c470e1da39c10c7$export$38e42c68cf43b5d4;
var $3c470e1da39c10c7$export$b657233bbb33a798;
var $3c470e1da39c10c7$export$161b0580eb953198;
var $3c470e1da39c10c7$export$e54c25dda5bed5e8;
var $3c470e1da39c10c7$export$db3c28d99448dcff;
var $3c470e1da39c10c7$export$b1e5508a851be14d;
$3c470e1da39c10c7$export$38e42c68cf43b5d4 = `Ve6rta_header`;
$3c470e1da39c10c7$export$b657233bbb33a798 = `Ve6rta_headerLink`;
$3c470e1da39c10c7$export$161b0580eb953198 = `Ve6rta_headerLinkActive`;
$3c470e1da39c10c7$export$e54c25dda5bed5e8 = `Ve6rta_linkWrapper`;
$3c470e1da39c10c7$export$db3c28d99448dcff = `Ve6rta_logo`;
$3c470e1da39c10c7$export$b1e5508a851be14d = `Ve6rta_menu`;




var $ieT14 = parcelRequire("ieT14");

var $ekezX = parcelRequire("ekezX");

var $5TjLg = parcelRequire("5TjLg");

var $3mOXj = parcelRequire("3mOXj");

var $iwN3n = parcelRequire("iwN3n");

var $bPjUl = parcelRequire("bPjUl");

var $aIJrd = parcelRequire("aIJrd");

var $bAMo1 = parcelRequire("bAMo1");
var $6BTs4 = parcelRequire("6BTs4");
var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $9fe6f106153ce33f$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
}), 'Lock');


var $a8595904e80f01c6$export$b0859cf5bfecfc75;
var $a8595904e80f01c6$export$5d559278e17df9c5;
$a8595904e80f01c6$export$b0859cf5bfecfc75 = `_8J6j4a_arrowDropDown`;
$a8595904e80f01c6$export$5d559278e17df9c5 = `_8J6j4a_userMenu`;



var $77d97b813128dd85$exports = {};



!function(e, t) {
    var r, n;
    $77d97b813128dd85$exports = t((parcelRequire("ieT14")), (parcelRequire("87yK1")), (parcelRequire("f6MGZ")));
}("undefined" != typeof self ? self : $77d97b813128dd85$exports, function(e, t, r) {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var o = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var o in e)r.d(n, o, (function(t) {
                return e[t];
            }).bind(null, o));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 97);
    }({
        0: function(t, r) {
            t.exports = e;
        },
        1: function(e, r) {
            e.exports = t;
        },
        5: function(e, t) {
            e.exports = r;
        },
        97: function(e, t, r) {
            "use strict";
            var n, o = this && this.__extends || (n = function(e, t) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(e, t) {
                    e.__proto__ = t;
                } || function(e, t) {
                    for(var r in t)t.hasOwnProperty(r) && (e[r] = t[r]);
                })(e, t);
            }, function(e, t) {
                function r() {
                    this.constructor = e;
                }
                n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r);
            }), i = this && this.__assign || function() {
                return (i = Object.assign || function(e) {
                    for(var t, r = 1, n = arguments.length; r < n; r++)for(var o in t = arguments[r])Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                    return e;
                }).apply(this, arguments);
            }, a = this && this.__rest || function(e, t) {
                var r = {};
                for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
                if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                    var o = 0;
                    for(n = Object.getOwnPropertySymbols(e); o < n.length; o++)t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
                }
                return r;
            }, u = this && this.__importDefault || function(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            };
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var p = u(r(0)), l = u(r(1)), s = r(5), c = function(e) {
                var t = e.className, r = e.icon, n = e.initRipple, o = e.hasRipple, u = (e.unbounded, a(e, [
                    "className",
                    "icon",
                    "initRipple",
                    "hasRipple",
                    "unbounded"
                ])), s = l.default("material-icons", t, {
                    "material-icons--ripple-surface": o
                });
                return p.default.createElement("i", i({
                    className: s,
                    ref: n
                }, u), r);
            };
            t.RippleMaterialIcon = s.withRipple(c);
            var f = function(e) {
                function r() {
                    return null !== e && e.apply(this, arguments) || this;
                }
                return o(r, e), r.prototype.render = function() {
                    var e = this.props, r = e.icon, n = e.hasRipple, o = (e.unbounded, a(e, [
                        "icon",
                        "hasRipple",
                        "unbounded"
                    ]));
                    return n ? p.default.createElement(t.RippleMaterialIcon, i({
                        unbounded: !0,
                        hasRipple: !0,
                        icon: r
                    }, o)) : p.default.createElement(c, i({
                        icon: r
                    }, o));
                }, r.defaultProps = {
                    icon: "",
                    className: "",
                    hasRipple: !1,
                    unbounded: !1
                }, r;
            }(p.default.Component);
            t.default = f;
        }
    });
});




var $eYoAG = parcelRequire("eYoAG");
const $c92b4cb493107d67$var$StyledMenu = (0, $aIJrd.default)({
    paper: {
        border: '1px solid #d3d4d5'
    }
})((props)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $5TjLg.default), {
        elevation: 0,
        getContentAnchorEl: null,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'center'
        },
        ...props
    }));
const $c92b4cb493107d67$var$UserMenu = ()=>{
    const [anchorEl, setAnchorEl] = $ieT14.useState(null);
    const [firstName, setFirstName] = $ieT14.useState(null);
    const [lastName, setLastName] = $ieT14.useState(null);
    const { state: state, setState: setState } = (0, $ieT14.useContext)((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { oktaAuth: oktaAuth } = (0, $4df32aa15a91038c$export$2ae4a19e09ca9a00)();
    const history = (0, $eYoAG.useHistory)();
    (0, $ieT14.useEffect)(()=>{
        if (state.firstName !== undefined && state.firstName !== null && state.firstName !== '') {
            setFirstName(state.firstName);
            setLastName(state.lastName);
            return;
        }
        oktaAuth.getUser().then((user)=>{
            localStorage.setItem('firstName', user.given_name);
            localStorage.setItem('lastName', user.family_name);
            localStorage.setItem('email', user.email);
            setFirstName(user.given_name);
            setLastName(user.family_name);
            setState({
                firstName: user.given_name,
                lastName: user.family_name,
                email: user.email
            });
        });
    }, []);
    function handleClick(event) {
        setAnchorEl(event.currentTarget);
    }
    function handleClose() {
        setAnchorEl(null);
    }
    function handleLogout() {
        oktaAuth.signOut().then(()=>{
            setState({
                firstName: '',
                lastName: '',
                email: undefined,
                isAdmin: false,
                globalAnnouncement: '',
                clientAnnouncement: ''
            });
            localStorage.removeItem('firstName');
            localStorage.removeItem('lastName');
            localStorage.removeItem('email');
        });
    }
    function handleChangePassword() {
        history.push('/change-password');
    }
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $a8595904e80f01c6$export$5d559278e17df9c5,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $ekezX.default), {
                    "aria-controls": "customized-menu",
                    "aria-haspopup": "true",
                    onClick: handleClick,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $bAMo1.default), {}),
                        firstName,
                        " ",
                        lastName,
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                            className: $a8595904e80f01c6$export$b0859cf5bfecfc75,
                            icon: "arrow_drop_down"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($c92b4cb493107d67$var$StyledMenu, {
                id: "customized-menu",
                anchorEl: anchorEl,
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: handleClose,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $3mOXj.default), {
                        onClick: handleChangePassword,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $iwN3n.default), {
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $9fe6f106153ce33f$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $bPjUl.default), {
                                primary: "Change Password"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $3mOXj.default), {
                        onClick: handleLogout,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $iwN3n.default), {
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6BTs4.default), {})
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $bPjUl.default), {
                                primary: "Logout"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $c92b4cb493107d67$export$2e2bcd8739ae039 = $c92b4cb493107d67$var$UserMenu;


/**
 * Paths
 * @enum - Paths for router
 */ var $4bbac098dba9d86f$var$Paths = /*#__PURE__*/ function(Paths) {
    /** Home page */ Paths["Home"] = "/";
    /** Login screen */ Paths["Login"] = "/login";
    /** Login callback */ Paths["LoginCallback"] = "/login/callback";
    /** Change password screen */ Paths["ChangePassword"] = "/change-password";
    /** Help screen */ Paths["Help"] = "/help";
    /** Dashboards root */ Paths["Reports"] = "/reports";
    /** Individual Dashboards */ Paths["Report"] = "/reports/:reportId";
    /** Fan Segmentation */ Paths["Segments"] = "/segments";
    /** New Fan Segmentation */ Paths["NewSegment"] = "/segments/create";
    /** Single Fan Segment */ Paths["Segment"] = "/segments/:segmentId";
    /** Segmant Pushes */ Paths["SegmentPushes"] = "/segments/:segmentId/pushes";
    /** Segmant Dependencies */ Paths["SegmantDependencies"] = "/segments/:segmentId/dependencies";
    /** Push Segmant */ Paths["PushSegment"] = "/segments/:segmentId/pushes/push-segment";
    /** Push Details */ Paths["PushDetails"] = "/segments/:segmentId/pushes/:pushId";
    /** Management screen */ Paths["Management"] = "/management";
    /** Support screen */ Paths["Support"] = "/support";
    /** Add Request screen */ Paths["AddRequest"] = "/support/add-request";
    /** Clients Overview */ Paths["Clients"] = "/clients";
    /** Add Client screen */ Paths["AddClient"] = "/clients/create";
    /** Edit Client screen */ Paths["EditClient"] = "/clients/:clientId/edit";
    /** Edit Client Dashboards screen */ Paths["ClientDashboards"] = "/clients/:clientId/edit/dashboards";
    /** Add Dashboard screen */ Paths["AddClientDashboard"] = "/clients/:clientId/edit/dashboards/create";
    /** Edit Dashboard screen */ Paths["EditClientDashboard"] = "/clients/:clientId/edit/dashboards/:dashboardId/edit";
    /** Edit Client Announcements screen */ Paths["ClientAnnouncements"] = "/clients/:clientId/edit/announcements";
    /** Edit Client Tags screen */ Paths["ClientTags"] = "/clients/:clientId/edit/tags";
    /** Edit Client Navigation screen */ Paths["ClientNavigation"] = "/clients/:clientId/edit/navigation";
    /** User Management screen */ Paths["Users"] = "/users";
    /** Add User screen */ Paths["AddUser"] = "/users/create";
    /** Edit User screen */ Paths["EditUser"] = "/users/:userId/edit";
    /** View/Edit global help documents */ Paths["GlobalHelpDocuments"] = "/global-help";
    /** Add global help documents */ Paths["AddGlobalHelpDocument"] = "/global-help/create";
    /** Edit global help documents */ Paths["EditGlobalHelpDocument"] = "/global-help/:snippetId/edit";
    /** View global help documents revisions */ Paths["ViewGlobalHelpDocumentRevisions"] = "/global-help/:snippetGroupId/revisions";
    /** View/Edit client help documents */ Paths["ClientHelpDocuments"] = "/clients/:clientId/edit/help";
    /** Add client help documents */ Paths["AddClientHelpDocument"] = "/clients/:clientId/edit/help/create";
    /** Edit client help documents */ Paths["EditClientHelpDocument"] = "/clients/:clientId/edit/help/:snippetId/edit";
    /** View client help documents revisions */ Paths["ViewClientHelpDocumentRevisions"] = "/clients/:clientId/edit/help/:snippetGroupId/revisions";
    /** Announcements Screen */ Paths["Announcements"] = "/announcements";
    /** Client Users Table */ Paths["ClientUsers"] = "/clients/:clientId/edit/users";
    /** Edit client snowflake configuration */ Paths["SnowflakeConfiguration"] = "/clients/:clientId/edit/snowflake";
    return Paths;
}($4bbac098dba9d86f$var$Paths || {});
var $4bbac098dba9d86f$export$2e2bcd8739ae039 = $4bbac098dba9d86f$var$Paths;




parcelRequire("ieT14");

var $6mt9R = parcelRequire("6mt9R");

/**
 * HeaderLink
 * @function HeaderLink Component for each link in the header
 */ const $8fb39198d6220d5f$var$HeaderLink = ({ title: title, path: path, isExternal: isExternal })=>{
    return !isExternal ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        className: $3c470e1da39c10c7$export$e54c25dda5bed5e8,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6mt9R.NavLink), {
            activeClassName: $3c470e1da39c10c7$export$161b0580eb953198,
            className: $3c470e1da39c10c7$export$b657233bbb33a798,
            to: path,
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                children: title
            })
        })
    }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        className: $3c470e1da39c10c7$export$e54c25dda5bed5e8,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("a", {
            href: path,
            className: $3c470e1da39c10c7$export$b657233bbb33a798,
            target: "_blank",
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                children: title
            })
        })
    });
};
var $8fb39198d6220d5f$export$2e2bcd8739ae039 = $8fb39198d6220d5f$var$HeaderLink;


const $36f8756607a82807$var$Header = ()=>{
    const { state: state } = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const managementUrl = window.env.MANAGEMENT_URL !== null && window.env.MANAGEMENT_URL !== undefined ? window.env.MANAGEMENT_URL : (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Management;
    const userInterface = window.env.USER_INTERFACE !== null && window.env.USER_INTERFACE !== undefined ? window.env.USER_INTERFACE : 'default';
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $3c470e1da39c10c7$export$38e42c68cf43b5d4,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $3c470e1da39c10c7$export$db3c28d99448dcff,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6mt9R.Link), {
                    to: "/",
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a522310ce80f7363$exports))),
                        alt: "Kagr Logo"
                    })
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $3c470e1da39c10c7$export$b1e5508a851be14d,
                children: [
                    state.isAdmin && userInterface !== 'management' && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8fb39198d6220d5f$export$2e2bcd8739ae039), {
                        title: "Management",
                        path: managementUrl,
                        isExternal: managementUrl.indexOf('http') === 0
                    }),
                    state.enableServiceDesk && userInterface !== 'management' && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8fb39198d6220d5f$export$2e2bcd8739ae039), {
                        title: "Support",
                        path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Support,
                        isExternal: false
                    }),
                    userInterface !== 'management' && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8fb39198d6220d5f$export$2e2bcd8739ae039), {
                        title: "Help",
                        path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Help,
                        isExternal: false
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $c92b4cb493107d67$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $36f8756607a82807$export$2e2bcd8739ae039 = $36f8756607a82807$var$Header;


var $cba48e46b26fad31$export$32180ef41b15b513;
var $cba48e46b26fad31$export$27c57cc52d388509;
var $cba48e46b26fad31$export$f22da7240b7add18;
var $cba48e46b26fad31$export$bfd8d51c3a53ed31;
var $cba48e46b26fad31$export$6fbb9cd2843e91b2;
var $cba48e46b26fad31$export$cc74dcc53cfce4eb;
$cba48e46b26fad31$export$32180ef41b15b513 = `wvGk9G_body`;
$cba48e46b26fad31$export$27c57cc52d388509 = `wvGk9G_collapsed`;
$cba48e46b26fad31$export$f22da7240b7add18 = `wvGk9G_main`;
$cba48e46b26fad31$export$bfd8d51c3a53ed31 = `wvGk9G_menuLoading`;
$cba48e46b26fad31$export$6fbb9cd2843e91b2 = `wvGk9G_sidebar`;
$cba48e46b26fad31$export$cc74dcc53cfce4eb = `wvGk9G_wrapper`;




var $ieT14 = parcelRequire("ieT14");

var $fgoQ6 = parcelRequire("fgoQ6");

var $ieT14 = parcelRequire("ieT14");

/**
 * @function useAnnouncement - Custom hook for the announcement edit pages
 */ const $cbb1bbab8b4a75ec$var$useAnnouncement = (client)=>{
    const { getAuth: getAuth, postAuth: postAuth } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    const [loading, setLoading] = $ieT14.useState(true);
    const [announcement, setAnnouncement] = $ieT14.useState('');
    const [errorMessage, setErrorMessage] = $ieT14.useState('');
    const { successMessage: successMessage, setSuccessMessage: setSuccessMessage } = (0, $fgoQ6.useTimedAlerts)();
    $ieT14.useEffect(()=>{
        if (client) {
            setAnnouncement('');
            fetchAnnouncement(client);
        }
    }, [
        client
    ]);
    const fetchAnnouncement = (subPath)=>{
        getAuth(`api/announcements/${subPath}`).then((res)=>{
            setAnnouncement(res);
            setLoading(false);
        }).catch((err)=>{
            setErrorMessage(err);
            setLoading(false);
        });
    };
    const updateAnnouncement = (subPath, content)=>{
        setLoading(true);
        postAuth(`api/announcements/${subPath}`, content).then((response)=>{
            setLoading(false);
            if (response.success) setSuccessMessage(response.message);
            else setErrorMessage(response.message);
        }).catch((err)=>{
            setErrorMessage(err.responseJSON.message);
            setLoading(false);
        });
    };
    return {
        loading: loading,
        announcement: announcement,
        errorMessage: errorMessage,
        successMessage: successMessage,
        updateAnnouncement: updateAnnouncement
    };
};
var $cbb1bbab8b4a75ec$export$2e2bcd8739ae039 = $cbb1bbab8b4a75ec$var$useAnnouncement;




var $fgoQ6 = parcelRequire("fgoQ6");
const $7c2917e09e02e963$var$ClientAnnouncement = ()=>{
    const { state: state, setState: setState } = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const [displayAnnouncement, setDisplayAnnouncement] = $ieT14.useState(true);
    const { loading: loading, announcement: clientAnnouncement } = (0, $cbb1bbab8b4a75ec$export$2e2bcd8739ae039)(state.clientId);
    $ieT14.useEffect(()=>{
        if (!loading && clientAnnouncement) {
            setState({
                clientAnnouncement: clientAnnouncement
            });
            // only display the announcement if it is new or hasn't been dismissed
            if (localStorage.getItem(`clientAnnouncement-${state.clientId}`) !== clientAnnouncement) {
                localStorage.setItem(`clientAnnouncement-${state.clientId}`, clientAnnouncement);
                localStorage.setItem(`hideClientAnnouncement-${state.clientId}`, 'false');
                setDisplayAnnouncement(true);
            } else if (localStorage.getItem(`hideClientAnnouncement-${state.clientId}`) === 'true') setDisplayAnnouncement(false);
            else if (localStorage.getItem(`hideClientAnnouncement-${state.clientId}`) === 'false') setDisplayAnnouncement(true);
        }
    }, [
        loading,
        clientAnnouncement
    ]);
    const hideClientAnnouncement = ()=>{
        localStorage.setItem(`hideClientAnnouncement-${state.clientId}`, 'true');
        setDisplayAnnouncement(false);
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($ieT14.Fragment, {
        children: displayAnnouncement && clientAnnouncement && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.Announcement), {
            type: "secondary",
            hasExitIcon: true,
            onClose: hideClientAnnouncement,
            content: state.clientAnnouncement
        })
    });
};
var $7c2917e09e02e963$export$2e2bcd8739ae039 = $7c2917e09e02e963$var$ClientAnnouncement;




var $ieT14 = parcelRequire("ieT14");



var $fgoQ6 = parcelRequire("fgoQ6");
const $27daedee549ef3a9$var$GlobalAnnouncement = ()=>{
    const { state: state, setState: setState } = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const [displayAnnouncement, setDisplayAnnouncement] = $ieT14.useState(true);
    const { loading: loading, announcement: globalAnnouncement } = (0, $cbb1bbab8b4a75ec$export$2e2bcd8739ae039)('global');
    $ieT14.useEffect(()=>{
        if (!loading && globalAnnouncement) {
            setState({
                globalAnnouncement: globalAnnouncement
            });
            // only display the announcement if it is new or hasn't been dismissed
            if (localStorage.getItem(`globalAnnouncement`) !== globalAnnouncement) {
                localStorage.setItem('globalAnnouncement', globalAnnouncement);
                localStorage.setItem('hideGlobalAnnouncement', 'false');
                setDisplayAnnouncement(true);
            } else if (localStorage.getItem('hideGlobalAnnouncement') === 'true') setDisplayAnnouncement(false);
        }
    }, [
        loading,
        globalAnnouncement
    ]);
    const hideGlobalAnnouncement = ()=>{
        localStorage.setItem('hideGlobalAnnouncement', 'true');
        setDisplayAnnouncement(false);
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($ieT14.Fragment, {
        children: displayAnnouncement && globalAnnouncement && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.Announcement), {
            type: "primary",
            hasExitIcon: true,
            onClose: hideGlobalAnnouncement,
            content: state.globalAnnouncement
        })
    });
};
var $27daedee549ef3a9$export$2e2bcd8739ae039 = $27daedee549ef3a9$var$GlobalAnnouncement;



var $eYoAG = parcelRequire("eYoAG");


var $ieT14 = parcelRequire("ieT14");

parcelRequire("ieT14");
var $967c65ecbe356105$export$3914d6a81335784f;
var $967c65ecbe356105$export$371137ceb8897acb;
var $967c65ecbe356105$export$8687ffcdea58e000;
$967c65ecbe356105$export$3914d6a81335784f = `chDcBW_backButtonIcon`;
$967c65ecbe356105$export$371137ceb8897acb = `chDcBW_revertIcon`;
$967c65ecbe356105$export$8687ffcdea58e000 = `chDcBW_searchIcon`;


const $9dac289cfe051c02$var$BackButtonIcon = ({ width: width, height: height, color: color })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("svg", {
        className: $967c65ecbe356105$export$3914d6a81335784f,
        width: width || '38px',
        height: height || '38px',
        viewBox: "0 0 38 38",
        version: "1.1",
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("g", {
            id: "Style-Guide",
            stroke: "none",
            strokeWidth: "1",
            fill: color || 'none',
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("g", {
                transform: "translate(-46.000000, -4329.000000)",
                id: "Group",
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("g", {
                    transform: "translate(47.000000, 4330.000000)",
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("circle", {
                            id: "Oval",
                            stroke: "#006DA8",
                            fill: "#FFFFFF",
                            cx: "18",
                            cy: "18",
                            r: "18"
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("polygon", {
                            id: "Imported-Layers-13",
                            fill: "#006DA8",
                            points: "12.50275 17.0625 20.532625 9.032625 18.5 7 7 18.5 18.5 30 20.532625 27.967375 12.50275 19.9375 30 19.9375 30 17.0625"
                        })
                    ]
                })
            })
        })
    });
};
var $9dac289cfe051c02$export$2e2bcd8739ae039 = $9dac289cfe051c02$var$BackButtonIcon;


var $c120b4155ee6df1f$export$8d6d009d1f06226e;
var $c120b4155ee6df1f$export$7fce8bd3f3363c0c;
$c120b4155ee6df1f$export$8d6d009d1f06226e = `uZo2KW_backButton`;
$c120b4155ee6df1f$export$7fce8bd3f3363c0c = `uZo2KW_backButtonAnnouncement`;




var $eYoAG = parcelRequire("eYoAG");

const $1aced3107d766ac6$var$BackButton = ({ location: location })=>{
    const { state: state } = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const [redirect, setRedirect] = $ieT14.useState(false);
    $ieT14.useEffect(()=>{
        if (redirect) setRedirect(false);
    }, [
        redirect
    ]);
    if (redirect) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Redirect), {
        to: location.state && location.state.redirect ? location.state.newPath : (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Home
    });
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
        className: state.globalAnnouncement ? $c120b4155ee6df1f$export$7fce8bd3f3363c0c : $c120b4155ee6df1f$export$8d6d009d1f06226e,
        onClick: ()=>setRedirect(true),
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $9dac289cfe051c02$export$2e2bcd8739ae039), {
            width: '38px',
            height: '38px'
        })
    });
};
var $1aced3107d766ac6$export$2e2bcd8739ae039 = (0, $eYoAG.withRouter)($1aced3107d766ac6$var$BackButton);





var $ieT14 = parcelRequire("ieT14");


var $ieT14 = parcelRequire("ieT14");
var $9063682047cb70ff$export$b0377cbbbdab6cba;
var $9063682047cb70ff$export$f27f0a643498ce3d;
var $9063682047cb70ff$export$b00c055587dc7469;
var $9063682047cb70ff$export$b1a09d22b7ad6c4;
var $9063682047cb70ff$export$509f3108fdd206bb;
var $9063682047cb70ff$export$42ff741d2868ee32;
var $9063682047cb70ff$export$8c430709db82137d;
var $9063682047cb70ff$export$2d4b1211b4389c3b;
var $9063682047cb70ff$export$3832be13857745bc;
var $9063682047cb70ff$export$f4c68800b094ddb1;
var $9063682047cb70ff$export$6fa445b97d2bf178;
var $9063682047cb70ff$export$52105d146316f63c;
var $9063682047cb70ff$export$60a21e6f120abdc8;
var $9063682047cb70ff$export$3ff8c533d254ed7c;
var $9063682047cb70ff$export$b1e5508a851be14d;
$9063682047cb70ff$export$b0377cbbbdab6cba = "#006da8";
$9063682047cb70ff$export$f27f0a643498ce3d = "#00aafc";
$9063682047cb70ff$export$b00c055587dc7469 = "#f5dbd9";
$9063682047cb70ff$export$b1a09d22b7ad6c4 = "#c92100";
$9063682047cb70ff$export$509f3108fdd206bb = "#ebafa6";
$9063682047cb70ff$export$42ff741d2868ee32 = "#074f86";
$9063682047cb70ff$export$8c430709db82137d = "#dadada";
$9063682047cb70ff$export$2d4b1211b4389c3b = "#dddbda";
$9063682047cb70ff$export$3832be13857745bc = "#eae9ed";
$9063682047cb70ff$export$f4c68800b094ddb1 = "#e9e8f4";
$9063682047cb70ff$export$6fa445b97d2bf178 = "collapsibleSidebar_fe43e6";
$9063682047cb70ff$export$52105d146316f63c = "expanded_fe43e6";
$9063682047cb70ff$export$60a21e6f120abdc8 = "collapseButton_fe43e6";
$9063682047cb70ff$export$3ff8c533d254ed7c = "arrowLeft_fe43e6";
$9063682047cb70ff$export$b1e5508a851be14d = "menu_fe43e6";



const $944aae8422412095$var$CollapsibleSidebar = (props)=>{
    const [collapsed, setCollapsed] = (0, $ieT14.useState)(props.initialCollapse);
    const toggleCollapse = ()=>{
        setCollapsed(!collapsed);
        props.onCollapseToggle(!collapsed);
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: `${props.sidebarClass} ${collapsed ? props.collapsedClass : ''} ${$9063682047cb70ff$export$6fa445b97d2bf178} `,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: `${props.iconClass ? props.iconClass : ''} ${$9063682047cb70ff$export$60a21e6f120abdc8}`,
                onClick: toggleCollapse,
                children: !collapsed ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                    icon: "keyboard_arrow_left",
                    className: $9063682047cb70ff$export$3ff8c533d254ed7c
                }) : props.arrowOpenIcon ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                    icon: "keyboard_arrow_right",
                    className: $9063682047cb70ff$export$3ff8c533d254ed7c
                }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                    icon: "menu",
                    className: $9063682047cb70ff$export$b1e5508a851be14d
                })
            }),
            props.children
        ]
    });
};
var $944aae8422412095$export$2e2bcd8739ae039 = $944aae8422412095$var$CollapsibleSidebar;




var $ieT14 = parcelRequire("ieT14");
var $ab8ad438073fe4a7$export$ff07a26348a13a9;
var $ab8ad438073fe4a7$export$b0859cf5bfecfc75;
var $ab8ad438073fe4a7$export$27c57cc52d388509;
var $ab8ad438073fe4a7$export$a7db06668cad9adb;
var $ab8ad438073fe4a7$export$b5b09ff7e34c8dba;
var $ab8ad438073fe4a7$export$bac611fc0051cb95;
$ab8ad438073fe4a7$export$ff07a26348a13a9 = `-RjXdq_activeClient`;
$ab8ad438073fe4a7$export$b0859cf5bfecfc75 = `-RjXdq_arrowDropDown`;
$ab8ad438073fe4a7$export$27c57cc52d388509 = `-RjXdq_collapsed`;
$ab8ad438073fe4a7$export$a7db06668cad9adb = `-RjXdq_content`;
$ab8ad438073fe4a7$export$b5b09ff7e34c8dba = `-RjXdq_imageHolder`;
$ab8ad438073fe4a7$export$bac611fc0051cb95 = `-RjXdq_singleClient`;




var $5d10f0a7aadd7c8c$exports = {};
'use strict';
Object.defineProperty($5d10f0a7aadd7c8c$exports, "__esModule", {
    value: true
});
$5d10f0a7aadd7c8c$exports.Scrollbars = undefined;
var $908aa1fd5bfdd6d6$exports = {};
'use strict';
Object.defineProperty($908aa1fd5bfdd6d6$exports, "__esModule", {
    value: true
});
var $908aa1fd5bfdd6d6$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $908aa1fd5bfdd6d6$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $38fd23a6c85b6141$exports = {};
var $31fb89c8fa91a84d$exports = {};
// Generated by CoffeeScript 1.12.2
(function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) $31fb89c8fa91a84d$exports = function() {
        return performance.now();
    };
    else if (Date.now) {
        $31fb89c8fa91a84d$exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        $31fb89c8fa91a84d$exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call($31fb89c8fa91a84d$exports);


var $38fd23a6c85b6141$var$root = typeof window === 'undefined' ? $parcel$global : window, $38fd23a6c85b6141$var$vendors = [
    'moz',
    'webkit'
], $38fd23a6c85b6141$var$suffix = 'AnimationFrame', $38fd23a6c85b6141$var$raf = $38fd23a6c85b6141$var$root['request' + $38fd23a6c85b6141$var$suffix], $38fd23a6c85b6141$var$caf = $38fd23a6c85b6141$var$root['cancel' + $38fd23a6c85b6141$var$suffix] || $38fd23a6c85b6141$var$root['cancelRequest' + $38fd23a6c85b6141$var$suffix];
for(var $38fd23a6c85b6141$var$i = 0; !$38fd23a6c85b6141$var$raf && $38fd23a6c85b6141$var$i < $38fd23a6c85b6141$var$vendors.length; $38fd23a6c85b6141$var$i++){
    $38fd23a6c85b6141$var$raf = $38fd23a6c85b6141$var$root[$38fd23a6c85b6141$var$vendors[$38fd23a6c85b6141$var$i] + 'Request' + $38fd23a6c85b6141$var$suffix];
    $38fd23a6c85b6141$var$caf = $38fd23a6c85b6141$var$root[$38fd23a6c85b6141$var$vendors[$38fd23a6c85b6141$var$i] + 'Cancel' + $38fd23a6c85b6141$var$suffix] || $38fd23a6c85b6141$var$root[$38fd23a6c85b6141$var$vendors[$38fd23a6c85b6141$var$i] + 'CancelRequest' + $38fd23a6c85b6141$var$suffix];
}
// Some versions of FF have rAF but not cAF
if (!$38fd23a6c85b6141$var$raf || !$38fd23a6c85b6141$var$caf) {
    var $38fd23a6c85b6141$var$last = 0, $38fd23a6c85b6141$var$id = 0, $38fd23a6c85b6141$var$queue = [], $38fd23a6c85b6141$var$frameDuration = 1000 / 60;
    $38fd23a6c85b6141$var$raf = function(callback) {
        if ($38fd23a6c85b6141$var$queue.length === 0) {
            var _now = $31fb89c8fa91a84d$exports(), next = Math.max(0, $38fd23a6c85b6141$var$frameDuration - (_now - $38fd23a6c85b6141$var$last));
            $38fd23a6c85b6141$var$last = next + _now;
            setTimeout(function() {
                var cp = $38fd23a6c85b6141$var$queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                $38fd23a6c85b6141$var$queue.length = 0;
                for(var i = 0; i < cp.length; i++){
                    if (!cp[i].cancelled) try {
                        cp[i].callback($38fd23a6c85b6141$var$last);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
            }, Math.round(next));
        }
        $38fd23a6c85b6141$var$queue.push({
            handle: ++$38fd23a6c85b6141$var$id,
            callback: callback,
            cancelled: false
        });
        return $38fd23a6c85b6141$var$id;
    };
    $38fd23a6c85b6141$var$caf = function(handle) {
        for(var i = 0; i < $38fd23a6c85b6141$var$queue.length; i++)if ($38fd23a6c85b6141$var$queue[i].handle === handle) $38fd23a6c85b6141$var$queue[i].cancelled = true;
    };
}
$38fd23a6c85b6141$exports = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return $38fd23a6c85b6141$var$raf.call($38fd23a6c85b6141$var$root, fn);
};
$38fd23a6c85b6141$exports.cancel = function() {
    $38fd23a6c85b6141$var$caf.apply($38fd23a6c85b6141$var$root, arguments);
};
$38fd23a6c85b6141$exports.polyfill = function(object) {
    if (!object) object = $38fd23a6c85b6141$var$root;
    object.requestAnimationFrame = $38fd23a6c85b6141$var$raf;
    object.cancelAnimationFrame = $38fd23a6c85b6141$var$caf;
};


var $908aa1fd5bfdd6d6$var$_raf3 = $908aa1fd5bfdd6d6$var$_interopRequireDefault($38fd23a6c85b6141$exports);
var $ce71465489edf688$exports = {};
var $47bf6aca9882f21b$exports = {};
var $47bf6aca9882f21b$var$div = null;
var $47bf6aca9882f21b$var$prefixes = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
$47bf6aca9882f21b$exports = function prefixStyle(prop) {
    // re-use a dummy div
    if (!$47bf6aca9882f21b$var$div) $47bf6aca9882f21b$var$div = document.createElement('div');
    var style = $47bf6aca9882f21b$var$div.style;
    // prop exists without prefix
    if (prop in style) return prop;
    // borderRadius -> BorderRadius
    var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1);
    // find the vendor-prefixed prop
    for(var i = $47bf6aca9882f21b$var$prefixes.length; i >= 0; i--){
        var name = $47bf6aca9882f21b$var$prefixes[i] + titleCase;
        // e.g. WebkitBorderRadius or webkitBorderRadius
        if (name in style) return name;
    }
    return false;
};


var $22dd408779b8cddc$exports = {};
var $40a24bb0f0c71def$exports = {};
var $458f1059c35b6715$exports = {};
/**
 * Export.
 */ $458f1059c35b6715$exports = $458f1059c35b6715$var$toNoCase;
/**
 * Test whether a string is camel-case.
 */ var $458f1059c35b6715$var$hasSpace = /\s/;
var $458f1059c35b6715$var$hasSeparator = /(_|-|\.|:)/;
var $458f1059c35b6715$var$hasCamel = /([a-z][A-Z]|[A-Z][a-z])/;
/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */ function $458f1059c35b6715$var$toNoCase(string) {
    if ($458f1059c35b6715$var$hasSpace.test(string)) return string.toLowerCase();
    if ($458f1059c35b6715$var$hasSeparator.test(string)) return ($458f1059c35b6715$var$unseparate(string) || string).toLowerCase();
    if ($458f1059c35b6715$var$hasCamel.test(string)) return $458f1059c35b6715$var$uncamelize(string).toLowerCase();
    return string.toLowerCase();
}
/**
 * Separator splitter.
 */ var $458f1059c35b6715$var$separatorSplitter = /[\W_]+(.|$)/g;
/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */ function $458f1059c35b6715$var$unseparate(string) {
    return string.replace($458f1059c35b6715$var$separatorSplitter, function(m, next) {
        return next ? ' ' + next : '';
    });
}
/**
 * Camelcase splitter.
 */ var $458f1059c35b6715$var$camelSplitter = /(.)([A-Z]+)/g;
/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */ function $458f1059c35b6715$var$uncamelize(string) {
    return string.replace($458f1059c35b6715$var$camelSplitter, function(m, previous, uppers) {
        return previous + ' ' + uppers.toLowerCase().split('').join(' ');
    });
}


/**
 * Export.
 */ $40a24bb0f0c71def$exports = $40a24bb0f0c71def$var$toSpaceCase;
/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */ function $40a24bb0f0c71def$var$toSpaceCase(string) {
    return $458f1059c35b6715$exports(string).replace(/[\W_]+(.|$)/g, function(matches, match) {
        return match ? ' ' + match : '';
    }).trim();
}


/**
 * Export.
 */ $22dd408779b8cddc$exports = $22dd408779b8cddc$var$toCamelCase;
/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */ function $22dd408779b8cddc$var$toCamelCase(string) {
    return $40a24bb0f0c71def$exports(string).replace(/\s(\w)/g, function(matches, letter) {
        return letter.toUpperCase();
    });
}


var $ce71465489edf688$var$cache = {
    'float': 'cssFloat'
};
var $4fbf15df027dacd9$exports = {};
/* The following list is defined in React's core */ var $4fbf15df027dacd9$var$IS_UNITLESS = {
    animationIterationCount: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridColumn: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    stopOpacity: true,
    strokeDashoffset: true,
    strokeOpacity: true,
    strokeWidth: true
};
$4fbf15df027dacd9$exports = function(name, value) {
    if (typeof value === 'number' && !$4fbf15df027dacd9$var$IS_UNITLESS[name]) return value + 'px';
    else return value;
};


function $ce71465489edf688$var$style(element, property, value) {
    var camel = $ce71465489edf688$var$cache[property];
    if (typeof camel === 'undefined') camel = $ce71465489edf688$var$detect(property);
    // may be false if CSS prop is unsupported
    if (camel) {
        if (value === undefined) return element.style[camel];
        element.style[camel] = $4fbf15df027dacd9$exports(camel, value);
    }
}
function $ce71465489edf688$var$each(element, properties) {
    for(var k in properties)if (properties.hasOwnProperty(k)) $ce71465489edf688$var$style(element, k, properties[k]);
}
function $ce71465489edf688$var$detect(cssProp) {
    var camel = $22dd408779b8cddc$exports(cssProp);
    var result = $47bf6aca9882f21b$exports(camel);
    $ce71465489edf688$var$cache[camel] = $ce71465489edf688$var$cache[cssProp] = $ce71465489edf688$var$cache[result] = result;
    return result;
}
function $ce71465489edf688$var$set() {
    if (arguments.length === 2) {
        if (typeof arguments[1] === 'string') arguments[0].style.cssText = arguments[1];
        else $ce71465489edf688$var$each(arguments[0], arguments[1]);
    } else $ce71465489edf688$var$style(arguments[0], arguments[1], arguments[2]);
}
$ce71465489edf688$exports = $ce71465489edf688$var$set;
$ce71465489edf688$exports.set = $ce71465489edf688$var$set;
$ce71465489edf688$exports.get = function(element, properties) {
    if (Array.isArray(properties)) return properties.reduce(function(obj, prop) {
        obj[prop] = $ce71465489edf688$var$style(element, prop || '');
        return obj;
    }, {});
    else return $ce71465489edf688$var$style(element, properties || '');
};


var $908aa1fd5bfdd6d6$var$_domCss2 = $908aa1fd5bfdd6d6$var$_interopRequireDefault($ce71465489edf688$exports);

var $ieT14 = parcelRequire("ieT14");

var $aLnZv = parcelRequire("aLnZv");
var $908aa1fd5bfdd6d6$var$_propTypes2 = $908aa1fd5bfdd6d6$var$_interopRequireDefault($aLnZv);
var $b4ed471b447d465f$exports = {};
'use strict';
Object.defineProperty($b4ed471b447d465f$exports, "__esModule", {
    value: true
});
$b4ed471b447d465f$exports["default"] = $b4ed471b447d465f$var$isString;
function $b4ed471b447d465f$var$isString(maybe) {
    return typeof maybe === 'string';
}


var $908aa1fd5bfdd6d6$var$_isString2 = $908aa1fd5bfdd6d6$var$_interopRequireDefault($b4ed471b447d465f$exports);
var $72f031794d8f7626$exports = {};
'use strict';
Object.defineProperty($72f031794d8f7626$exports, "__esModule", {
    value: true
});
$72f031794d8f7626$exports["default"] = $72f031794d8f7626$var$getScrollbarWidth;

var $72f031794d8f7626$var$_domCss2 = $72f031794d8f7626$var$_interopRequireDefault($ce71465489edf688$exports);
function $72f031794d8f7626$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $72f031794d8f7626$var$scrollbarWidth = false;
function $72f031794d8f7626$var$getScrollbarWidth() {
    if ($72f031794d8f7626$var$scrollbarWidth !== false) return $72f031794d8f7626$var$scrollbarWidth;
    /* istanbul ignore else */ if (typeof document !== 'undefined') {
        var div = document.createElement('div');
        (0, $72f031794d8f7626$var$_domCss2["default"])(div, {
            width: 100,
            height: 100,
            position: 'absolute',
            top: -9999,
            overflow: 'scroll',
            MsOverflowStyle: 'scrollbar'
        });
        document.body.appendChild(div);
        $72f031794d8f7626$var$scrollbarWidth = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    } else $72f031794d8f7626$var$scrollbarWidth = 0;
    return $72f031794d8f7626$var$scrollbarWidth || 0;
}


var $908aa1fd5bfdd6d6$var$_getScrollbarWidth2 = $908aa1fd5bfdd6d6$var$_interopRequireDefault($72f031794d8f7626$exports);
var $ab4f03c5a561728f$exports = {};
"use strict";
Object.defineProperty($ab4f03c5a561728f$exports, "__esModule", {
    value: true
});
$ab4f03c5a561728f$exports["default"] = $ab4f03c5a561728f$var$returnFalse;
function $ab4f03c5a561728f$var$returnFalse() {
    return false;
}


var $908aa1fd5bfdd6d6$var$_returnFalse2 = $908aa1fd5bfdd6d6$var$_interopRequireDefault($ab4f03c5a561728f$exports);
var $d429cfe4a01a1358$exports = {};
"use strict";
Object.defineProperty($d429cfe4a01a1358$exports, "__esModule", {
    value: true
});
$d429cfe4a01a1358$exports["default"] = $d429cfe4a01a1358$var$getInnerWidth;
function $d429cfe4a01a1358$var$getInnerWidth(el) {
    var clientWidth = el.clientWidth;
    var _getComputedStyle = getComputedStyle(el), paddingLeft = _getComputedStyle.paddingLeft, paddingRight = _getComputedStyle.paddingRight;
    return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
}


var $908aa1fd5bfdd6d6$var$_getInnerWidth2 = $908aa1fd5bfdd6d6$var$_interopRequireDefault($d429cfe4a01a1358$exports);
var $38d8b0fb9f3d3ea0$exports = {};
"use strict";
Object.defineProperty($38d8b0fb9f3d3ea0$exports, "__esModule", {
    value: true
});
$38d8b0fb9f3d3ea0$exports["default"] = $38d8b0fb9f3d3ea0$var$getInnerHeight;
function $38d8b0fb9f3d3ea0$var$getInnerHeight(el) {
    var clientHeight = el.clientHeight;
    var _getComputedStyle = getComputedStyle(el), paddingTop = _getComputedStyle.paddingTop, paddingBottom = _getComputedStyle.paddingBottom;
    return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
}


var $908aa1fd5bfdd6d6$var$_getInnerHeight2 = $908aa1fd5bfdd6d6$var$_interopRequireDefault($38d8b0fb9f3d3ea0$exports);
var $6382d197205bd039$exports = {};
'use strict';
Object.defineProperty($6382d197205bd039$exports, "__esModule", {
    value: true
});
var $6382d197205bd039$var$containerStyleDefault = $6382d197205bd039$exports.containerStyleDefault = {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: '100%'
};
// Overrides containerStyleDefault properties
var $6382d197205bd039$var$containerStyleAutoHeight = $6382d197205bd039$exports.containerStyleAutoHeight = {
    height: 'auto'
};
var $6382d197205bd039$var$viewStyleDefault = $6382d197205bd039$exports.viewStyleDefault = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'scroll',
    WebkitOverflowScrolling: 'touch'
};
// Overrides viewStyleDefault properties
var $6382d197205bd039$var$viewStyleAutoHeight = $6382d197205bd039$exports.viewStyleAutoHeight = {
    position: 'relative',
    top: undefined,
    left: undefined,
    right: undefined,
    bottom: undefined
};
var $6382d197205bd039$var$viewStyleUniversalInitial = $6382d197205bd039$exports.viewStyleUniversalInitial = {
    overflow: 'hidden',
    marginRight: 0,
    marginBottom: 0
};
var $6382d197205bd039$var$trackHorizontalStyleDefault = $6382d197205bd039$exports.trackHorizontalStyleDefault = {
    position: 'absolute',
    height: 6
};
var $6382d197205bd039$var$trackVerticalStyleDefault = $6382d197205bd039$exports.trackVerticalStyleDefault = {
    position: 'absolute',
    width: 6
};
var $6382d197205bd039$var$thumbHorizontalStyleDefault = $6382d197205bd039$exports.thumbHorizontalStyleDefault = {
    position: 'relative',
    display: 'block',
    height: '100%'
};
var $6382d197205bd039$var$thumbVerticalStyleDefault = $6382d197205bd039$exports.thumbVerticalStyleDefault = {
    position: 'relative',
    display: 'block',
    width: '100%'
};
var $6382d197205bd039$var$disableSelectStyle = $6382d197205bd039$exports.disableSelectStyle = {
    userSelect: 'none'
};
var $6382d197205bd039$var$disableSelectStyleReset = $6382d197205bd039$exports.disableSelectStyleReset = {
    userSelect: ''
};


var $24babc7650726a6e$exports = {};
'use strict';
Object.defineProperty($24babc7650726a6e$exports, "__esModule", {
    value: true
});
var $24babc7650726a6e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
$24babc7650726a6e$exports.renderViewDefault = $24babc7650726a6e$var$renderViewDefault;
$24babc7650726a6e$exports.renderTrackHorizontalDefault = $24babc7650726a6e$var$renderTrackHorizontalDefault;
$24babc7650726a6e$exports.renderTrackVerticalDefault = $24babc7650726a6e$var$renderTrackVerticalDefault;
$24babc7650726a6e$exports.renderThumbHorizontalDefault = $24babc7650726a6e$var$renderThumbHorizontalDefault;
$24babc7650726a6e$exports.renderThumbVerticalDefault = $24babc7650726a6e$var$renderThumbVerticalDefault;

var $ieT14 = parcelRequire("ieT14");
var $24babc7650726a6e$var$_react2 = $24babc7650726a6e$var$_interopRequireDefault($ieT14);
function $24babc7650726a6e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $24babc7650726a6e$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
/* eslint-disable react/prop-types */ function $24babc7650726a6e$var$renderViewDefault(props) {
    return $24babc7650726a6e$var$_react2["default"].createElement('div', props);
}
function $24babc7650726a6e$var$renderTrackHorizontalDefault(_ref) {
    var style = _ref.style, props = $24babc7650726a6e$var$_objectWithoutProperties(_ref, [
        'style'
    ]);
    var finalStyle = $24babc7650726a6e$var$_extends({}, style, {
        right: 2,
        bottom: 2,
        left: 2,
        borderRadius: 3
    });
    return $24babc7650726a6e$var$_react2["default"].createElement('div', $24babc7650726a6e$var$_extends({
        style: finalStyle
    }, props));
}
function $24babc7650726a6e$var$renderTrackVerticalDefault(_ref2) {
    var style = _ref2.style, props = $24babc7650726a6e$var$_objectWithoutProperties(_ref2, [
        'style'
    ]);
    var finalStyle = $24babc7650726a6e$var$_extends({}, style, {
        right: 2,
        bottom: 2,
        top: 2,
        borderRadius: 3
    });
    return $24babc7650726a6e$var$_react2["default"].createElement('div', $24babc7650726a6e$var$_extends({
        style: finalStyle
    }, props));
}
function $24babc7650726a6e$var$renderThumbHorizontalDefault(_ref3) {
    var style = _ref3.style, props = $24babc7650726a6e$var$_objectWithoutProperties(_ref3, [
        'style'
    ]);
    var finalStyle = $24babc7650726a6e$var$_extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return $24babc7650726a6e$var$_react2["default"].createElement('div', $24babc7650726a6e$var$_extends({
        style: finalStyle
    }, props));
}
function $24babc7650726a6e$var$renderThumbVerticalDefault(_ref4) {
    var style = _ref4.style, props = $24babc7650726a6e$var$_objectWithoutProperties(_ref4, [
        'style'
    ]);
    var finalStyle = $24babc7650726a6e$var$_extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return $24babc7650726a6e$var$_react2["default"].createElement('div', $24babc7650726a6e$var$_extends({
        style: finalStyle
    }, props));
}


function $908aa1fd5bfdd6d6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $908aa1fd5bfdd6d6$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $908aa1fd5bfdd6d6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $908aa1fd5bfdd6d6$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $908aa1fd5bfdd6d6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $908aa1fd5bfdd6d6$var$Scrollbars = function(_Component) {
    $908aa1fd5bfdd6d6$var$_inherits(Scrollbars, _Component);
    function Scrollbars(props) {
        var _ref;
        $908aa1fd5bfdd6d6$var$_classCallCheck(this, Scrollbars);
        for(var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
        var _this = $908aa1fd5bfdd6d6$var$_possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [
            this,
            props
        ].concat(rest)));
        _this.getScrollLeft = _this.getScrollLeft.bind(_this);
        _this.getScrollTop = _this.getScrollTop.bind(_this);
        _this.getScrollWidth = _this.getScrollWidth.bind(_this);
        _this.getScrollHeight = _this.getScrollHeight.bind(_this);
        _this.getClientWidth = _this.getClientWidth.bind(_this);
        _this.getClientHeight = _this.getClientHeight.bind(_this);
        _this.getValues = _this.getValues.bind(_this);
        _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_this);
        _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_this);
        _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_this);
        _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_this);
        _this.scrollLeft = _this.scrollLeft.bind(_this);
        _this.scrollTop = _this.scrollTop.bind(_this);
        _this.scrollToLeft = _this.scrollToLeft.bind(_this);
        _this.scrollToTop = _this.scrollToTop.bind(_this);
        _this.scrollToRight = _this.scrollToRight.bind(_this);
        _this.scrollToBottom = _this.scrollToBottom.bind(_this);
        _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_this);
        _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_this);
        _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_this);
        _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_this);
        _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_this);
        _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_this);
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleDrag = _this.handleDrag.bind(_this);
        _this.handleDragEnd = _this.handleDragEnd.bind(_this);
        _this.state = {
            didMountUniversal: false
        };
        return _this;
    }
    $908aa1fd5bfdd6d6$var$_createClass(Scrollbars, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.addListeners();
                this.update();
                this.componentDidMountUniversal();
            }
        },
        {
            key: 'componentDidMountUniversal',
            value: function componentDidMountUniversal() {
                // eslint-disable-line react/sort-comp
                var universal = this.props.universal;
                if (!universal) return;
                this.setState({
                    didMountUniversal: true
                });
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                this.update();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.removeListeners();
                (0, $38fd23a6c85b6141$exports.cancel)(this.requestFrame);
                clearTimeout(this.hideTracksTimeout);
                clearInterval(this.detectScrollingInterval);
            }
        },
        {
            key: 'getScrollLeft',
            value: function getScrollLeft() {
                if (!this.view) return 0;
                return this.view.scrollLeft;
            }
        },
        {
            key: 'getScrollTop',
            value: function getScrollTop() {
                if (!this.view) return 0;
                return this.view.scrollTop;
            }
        },
        {
            key: 'getScrollWidth',
            value: function getScrollWidth() {
                if (!this.view) return 0;
                return this.view.scrollWidth;
            }
        },
        {
            key: 'getScrollHeight',
            value: function getScrollHeight() {
                if (!this.view) return 0;
                return this.view.scrollHeight;
            }
        },
        {
            key: 'getClientWidth',
            value: function getClientWidth() {
                if (!this.view) return 0;
                return this.view.clientWidth;
            }
        },
        {
            key: 'getClientHeight',
            value: function getClientHeight() {
                if (!this.view) return 0;
                return this.view.clientHeight;
            }
        },
        {
            key: 'getValues',
            value: function getValues() {
                var _ref2 = this.view || {}, _ref2$scrollLeft = _ref2.scrollLeft, scrollLeft = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft, _ref2$scrollTop = _ref2.scrollTop, scrollTop = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop, _ref2$scrollWidth = _ref2.scrollWidth, scrollWidth = _ref2$scrollWidth === undefined ? 0 : _ref2$scrollWidth, _ref2$scrollHeight = _ref2.scrollHeight, scrollHeight = _ref2$scrollHeight === undefined ? 0 : _ref2$scrollHeight, _ref2$clientWidth = _ref2.clientWidth, clientWidth = _ref2$clientWidth === undefined ? 0 : _ref2$clientWidth, _ref2$clientHeight = _ref2.clientHeight, clientHeight = _ref2$clientHeight === undefined ? 0 : _ref2$clientHeight;
                return {
                    left: scrollLeft / (scrollWidth - clientWidth) || 0,
                    top: scrollTop / (scrollHeight - clientHeight) || 0,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollWidth: scrollWidth,
                    scrollHeight: scrollHeight,
                    clientWidth: clientWidth,
                    clientHeight: clientHeight
                };
            }
        },
        {
            key: 'getThumbHorizontalWidth',
            value: function getThumbHorizontalWidth() {
                var _props = this.props, thumbSize = _props.thumbSize, thumbMinSize = _props.thumbMinSize;
                var _view = this.view, scrollWidth = _view.scrollWidth, clientWidth = _view.clientWidth;
                var trackWidth = (0, $908aa1fd5bfdd6d6$var$_getInnerWidth2["default"])(this.trackHorizontal);
                var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
                if (trackWidth === width) return 0;
                if (thumbSize) return thumbSize;
                return Math.max(width, thumbMinSize);
            }
        },
        {
            key: 'getThumbVerticalHeight',
            value: function getThumbVerticalHeight() {
                var _props2 = this.props, thumbSize = _props2.thumbSize, thumbMinSize = _props2.thumbMinSize;
                var _view2 = this.view, scrollHeight = _view2.scrollHeight, clientHeight = _view2.clientHeight;
                var trackHeight = (0, $908aa1fd5bfdd6d6$var$_getInnerHeight2["default"])(this.trackVertical);
                var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
                if (trackHeight === height) return 0;
                if (thumbSize) return thumbSize;
                return Math.max(height, thumbMinSize);
            }
        },
        {
            key: 'getScrollLeftForOffset',
            value: function getScrollLeftForOffset(offset) {
                var _view3 = this.view, scrollWidth = _view3.scrollWidth, clientWidth = _view3.clientWidth;
                var trackWidth = (0, $908aa1fd5bfdd6d6$var$_getInnerWidth2["default"])(this.trackHorizontal);
                var thumbWidth = this.getThumbHorizontalWidth();
                return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
            }
        },
        {
            key: 'getScrollTopForOffset',
            value: function getScrollTopForOffset(offset) {
                var _view4 = this.view, scrollHeight = _view4.scrollHeight, clientHeight = _view4.clientHeight;
                var trackHeight = (0, $908aa1fd5bfdd6d6$var$_getInnerHeight2["default"])(this.trackVertical);
                var thumbHeight = this.getThumbVerticalHeight();
                return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
            }
        },
        {
            key: 'scrollLeft',
            value: function scrollLeft() {
                var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (!this.view) return;
                this.view.scrollLeft = left;
            }
        },
        {
            key: 'scrollTop',
            value: function scrollTop() {
                var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (!this.view) return;
                this.view.scrollTop = top;
            }
        },
        {
            key: 'scrollToLeft',
            value: function scrollToLeft() {
                if (!this.view) return;
                this.view.scrollLeft = 0;
            }
        },
        {
            key: 'scrollToTop',
            value: function scrollToTop() {
                if (!this.view) return;
                this.view.scrollTop = 0;
            }
        },
        {
            key: 'scrollToRight',
            value: function scrollToRight() {
                if (!this.view) return;
                this.view.scrollLeft = this.view.scrollWidth;
            }
        },
        {
            key: 'scrollToBottom',
            value: function scrollToBottom() {
                if (!this.view) return;
                this.view.scrollTop = this.view.scrollHeight;
            }
        },
        {
            key: 'addListeners',
            value: function addListeners() {
                /* istanbul ignore if */ if (typeof document === 'undefined' || !this.view) return;
                var view = this.view, trackHorizontal = this.trackHorizontal, trackVertical = this.trackVertical, thumbHorizontal = this.thumbHorizontal, thumbVertical = this.thumbVertical;
                view.addEventListener('scroll', this.handleScroll);
                if (!(0, $908aa1fd5bfdd6d6$var$_getScrollbarWidth2["default"])()) return;
                trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
                trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
                trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
                trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
                trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
                trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
                thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
                thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
                window.addEventListener('resize', this.handleWindowResize);
            }
        },
        {
            key: 'removeListeners',
            value: function removeListeners() {
                /* istanbul ignore if */ if (typeof document === 'undefined' || !this.view) return;
                var view = this.view, trackHorizontal = this.trackHorizontal, trackVertical = this.trackVertical, thumbHorizontal = this.thumbHorizontal, thumbVertical = this.thumbVertical;
                view.removeEventListener('scroll', this.handleScroll);
                if (!(0, $908aa1fd5bfdd6d6$var$_getScrollbarWidth2["default"])()) return;
                trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
                trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
                trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
                trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
                trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
                trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
                thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
                thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
                window.removeEventListener('resize', this.handleWindowResize);
                // Possibly setup by `handleDragStart`
                this.teardownDragging();
            }
        },
        {
            key: 'handleScroll',
            value: function handleScroll(event) {
                var _this2 = this;
                var _props3 = this.props, onScroll = _props3.onScroll, onScrollFrame = _props3.onScrollFrame;
                if (onScroll) onScroll(event);
                this.update(function(values) {
                    var scrollLeft = values.scrollLeft, scrollTop = values.scrollTop;
                    _this2.viewScrollLeft = scrollLeft;
                    _this2.viewScrollTop = scrollTop;
                    if (onScrollFrame) onScrollFrame(values);
                });
                this.detectScrolling();
            }
        },
        {
            key: 'handleScrollStart',
            value: function handleScrollStart() {
                var onScrollStart = this.props.onScrollStart;
                if (onScrollStart) onScrollStart();
                this.handleScrollStartAutoHide();
            }
        },
        {
            key: 'handleScrollStartAutoHide',
            value: function handleScrollStartAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.showTracks();
            }
        },
        {
            key: 'handleScrollStop',
            value: function handleScrollStop() {
                var onScrollStop = this.props.onScrollStop;
                if (onScrollStop) onScrollStop();
                this.handleScrollStopAutoHide();
            }
        },
        {
            key: 'handleScrollStopAutoHide',
            value: function handleScrollStopAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.hideTracks();
            }
        },
        {
            key: 'handleWindowResize',
            value: function handleWindowResize() {
                this.update();
            }
        },
        {
            key: 'handleHorizontalTrackMouseDown',
            value: function handleHorizontalTrackMouseDown(event) {
                event.preventDefault();
                var target = event.target, clientX = event.clientX;
                var _target$getBoundingCl = target.getBoundingClientRect(), targetLeft = _target$getBoundingCl.left;
                var thumbWidth = this.getThumbHorizontalWidth();
                var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
                this.view.scrollLeft = this.getScrollLeftForOffset(offset);
            }
        },
        {
            key: 'handleVerticalTrackMouseDown',
            value: function handleVerticalTrackMouseDown(event) {
                event.preventDefault();
                var target = event.target, clientY = event.clientY;
                var _target$getBoundingCl2 = target.getBoundingClientRect(), targetTop = _target$getBoundingCl2.top;
                var thumbHeight = this.getThumbVerticalHeight();
                var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
                this.view.scrollTop = this.getScrollTopForOffset(offset);
            }
        },
        {
            key: 'handleHorizontalThumbMouseDown',
            value: function handleHorizontalThumbMouseDown(event) {
                event.preventDefault();
                this.handleDragStart(event);
                var target = event.target, clientX = event.clientX;
                var offsetWidth = target.offsetWidth;
                var _target$getBoundingCl3 = target.getBoundingClientRect(), left = _target$getBoundingCl3.left;
                this.prevPageX = offsetWidth - (clientX - left);
            }
        },
        {
            key: 'handleVerticalThumbMouseDown',
            value: function handleVerticalThumbMouseDown(event) {
                event.preventDefault();
                this.handleDragStart(event);
                var target = event.target, clientY = event.clientY;
                var offsetHeight = target.offsetHeight;
                var _target$getBoundingCl4 = target.getBoundingClientRect(), top = _target$getBoundingCl4.top;
                this.prevPageY = offsetHeight - (clientY - top);
            }
        },
        {
            key: 'setupDragging',
            value: function setupDragging() {
                (0, $908aa1fd5bfdd6d6$var$_domCss2["default"])(document.body, $6382d197205bd039$exports.disableSelectStyle);
                document.addEventListener('mousemove', this.handleDrag);
                document.addEventListener('mouseup', this.handleDragEnd);
                document.onselectstart = $908aa1fd5bfdd6d6$var$_returnFalse2["default"];
            }
        },
        {
            key: 'teardownDragging',
            value: function teardownDragging() {
                (0, $908aa1fd5bfdd6d6$var$_domCss2["default"])(document.body, $6382d197205bd039$exports.disableSelectStyleReset);
                document.removeEventListener('mousemove', this.handleDrag);
                document.removeEventListener('mouseup', this.handleDragEnd);
                document.onselectstart = undefined;
            }
        },
        {
            key: 'handleDragStart',
            value: function handleDragStart(event) {
                this.dragging = true;
                event.stopImmediatePropagation();
                this.setupDragging();
            }
        },
        {
            key: 'handleDrag',
            value: function handleDrag(event) {
                if (this.prevPageX) {
                    var clientX = event.clientX;
                    var _trackHorizontal$getB = this.trackHorizontal.getBoundingClientRect(), trackLeft = _trackHorizontal$getB.left;
                    var thumbWidth = this.getThumbHorizontalWidth();
                    var clickPosition = thumbWidth - this.prevPageX;
                    var offset = -trackLeft + clientX - clickPosition;
                    this.view.scrollLeft = this.getScrollLeftForOffset(offset);
                }
                if (this.prevPageY) {
                    var clientY = event.clientY;
                    var _trackVertical$getBou = this.trackVertical.getBoundingClientRect(), trackTop = _trackVertical$getBou.top;
                    var thumbHeight = this.getThumbVerticalHeight();
                    var _clickPosition = thumbHeight - this.prevPageY;
                    var _offset = -trackTop + clientY - _clickPosition;
                    this.view.scrollTop = this.getScrollTopForOffset(_offset);
                }
                return false;
            }
        },
        {
            key: 'handleDragEnd',
            value: function handleDragEnd() {
                this.dragging = false;
                this.prevPageX = this.prevPageY = 0;
                this.teardownDragging();
                this.handleDragEndAutoHide();
            }
        },
        {
            key: 'handleDragEndAutoHide',
            value: function handleDragEndAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.hideTracks();
            }
        },
        {
            key: 'handleTrackMouseEnter',
            value: function handleTrackMouseEnter() {
                this.trackMouseOver = true;
                this.handleTrackMouseEnterAutoHide();
            }
        },
        {
            key: 'handleTrackMouseEnterAutoHide',
            value: function handleTrackMouseEnterAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.showTracks();
            }
        },
        {
            key: 'handleTrackMouseLeave',
            value: function handleTrackMouseLeave() {
                this.trackMouseOver = false;
                this.handleTrackMouseLeaveAutoHide();
            }
        },
        {
            key: 'handleTrackMouseLeaveAutoHide',
            value: function handleTrackMouseLeaveAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.hideTracks();
            }
        },
        {
            key: 'showTracks',
            value: function showTracks() {
                clearTimeout(this.hideTracksTimeout);
                (0, $908aa1fd5bfdd6d6$var$_domCss2["default"])(this.trackHorizontal, {
                    opacity: 1
                });
                (0, $908aa1fd5bfdd6d6$var$_domCss2["default"])(this.trackVertical, {
                    opacity: 1
                });
            }
        },
        {
            key: 'hideTracks',
            value: function hideTracks() {
                var _this3 = this;
                if (this.dragging) return;
                if (this.scrolling) return;
                if (this.trackMouseOver) return;
                var autoHideTimeout = this.props.autoHideTimeout;
                clearTimeout(this.hideTracksTimeout);
                this.hideTracksTimeout = setTimeout(function() {
                    (0, $908aa1fd5bfdd6d6$var$_domCss2["default"])(_this3.trackHorizontal, {
                        opacity: 0
                    });
                    (0, $908aa1fd5bfdd6d6$var$_domCss2["default"])(_this3.trackVertical, {
                        opacity: 0
                    });
                }, autoHideTimeout);
            }
        },
        {
            key: 'detectScrolling',
            value: function detectScrolling() {
                var _this4 = this;
                if (this.scrolling) return;
                this.scrolling = true;
                this.handleScrollStart();
                this.detectScrollingInterval = setInterval(function() {
                    if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
                        clearInterval(_this4.detectScrollingInterval);
                        _this4.scrolling = false;
                        _this4.handleScrollStop();
                    }
                    _this4.lastViewScrollLeft = _this4.viewScrollLeft;
                    _this4.lastViewScrollTop = _this4.viewScrollTop;
                }, 100);
            }
        },
        {
            key: 'raf',
            value: function raf(callback) {
                var _this5 = this;
                if (this.requestFrame) $908aa1fd5bfdd6d6$var$_raf3["default"].cancel(this.requestFrame);
                this.requestFrame = (0, $908aa1fd5bfdd6d6$var$_raf3["default"])(function() {
                    _this5.requestFrame = undefined;
                    callback();
                });
            }
        },
        {
            key: 'update',
            value: function update(callback) {
                var _this6 = this;
                this.raf(function() {
                    return _this6._update(callback);
                });
            }
        },
        {
            key: '_update',
            value: function _update(callback) {
                var _props4 = this.props, onUpdate = _props4.onUpdate, hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;
                var values = this.getValues();
                if ((0, $908aa1fd5bfdd6d6$var$_getScrollbarWidth2["default"])()) {
                    var scrollLeft = values.scrollLeft, clientWidth = values.clientWidth, scrollWidth = values.scrollWidth;
                    var trackHorizontalWidth = (0, $908aa1fd5bfdd6d6$var$_getInnerWidth2["default"])(this.trackHorizontal);
                    var thumbHorizontalWidth = this.getThumbHorizontalWidth();
                    var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
                    var thumbHorizontalStyle = {
                        width: thumbHorizontalWidth,
                        transform: 'translateX(' + thumbHorizontalX + 'px)'
                    };
                    var scrollTop = values.scrollTop, clientHeight = values.clientHeight, scrollHeight = values.scrollHeight;
                    var trackVerticalHeight = (0, $908aa1fd5bfdd6d6$var$_getInnerHeight2["default"])(this.trackVertical);
                    var thumbVerticalHeight = this.getThumbVerticalHeight();
                    var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
                    var thumbVerticalStyle = {
                        height: thumbVerticalHeight,
                        transform: 'translateY(' + thumbVerticalY + 'px)'
                    };
                    if (hideTracksWhenNotNeeded) {
                        var trackHorizontalStyle = {
                            visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
                        };
                        var trackVerticalStyle = {
                            visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
                        };
                        (0, $908aa1fd5bfdd6d6$var$_domCss2["default"])(this.trackHorizontal, trackHorizontalStyle);
                        (0, $908aa1fd5bfdd6d6$var$_domCss2["default"])(this.trackVertical, trackVerticalStyle);
                    }
                    (0, $908aa1fd5bfdd6d6$var$_domCss2["default"])(this.thumbHorizontal, thumbHorizontalStyle);
                    (0, $908aa1fd5bfdd6d6$var$_domCss2["default"])(this.thumbVertical, thumbVerticalStyle);
                }
                if (onUpdate) onUpdate(values);
                if (typeof callback !== 'function') return;
                callback(values);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this7 = this;
                var scrollbarWidth = (0, $908aa1fd5bfdd6d6$var$_getScrollbarWidth2["default"])();
                /* eslint-disable no-unused-vars */ var _props5 = this.props, onScroll = _props5.onScroll, onScrollFrame = _props5.onScrollFrame, onScrollStart = _props5.onScrollStart, onScrollStop = _props5.onScrollStop, onUpdate = _props5.onUpdate, renderView = _props5.renderView, renderTrackHorizontal = _props5.renderTrackHorizontal, renderTrackVertical = _props5.renderTrackVertical, renderThumbHorizontal = _props5.renderThumbHorizontal, renderThumbVertical = _props5.renderThumbVertical, tagName = _props5.tagName, hideTracksWhenNotNeeded = _props5.hideTracksWhenNotNeeded, autoHide = _props5.autoHide, autoHideTimeout = _props5.autoHideTimeout, autoHideDuration = _props5.autoHideDuration, thumbSize = _props5.thumbSize, thumbMinSize = _props5.thumbMinSize, universal = _props5.universal, autoHeight = _props5.autoHeight, autoHeightMin = _props5.autoHeightMin, autoHeightMax = _props5.autoHeightMax, style = _props5.style, children = _props5.children, props = $908aa1fd5bfdd6d6$var$_objectWithoutProperties(_props5, [
                    'onScroll',
                    'onScrollFrame',
                    'onScrollStart',
                    'onScrollStop',
                    'onUpdate',
                    'renderView',
                    'renderTrackHorizontal',
                    'renderTrackVertical',
                    'renderThumbHorizontal',
                    'renderThumbVertical',
                    'tagName',
                    'hideTracksWhenNotNeeded',
                    'autoHide',
                    'autoHideTimeout',
                    'autoHideDuration',
                    'thumbSize',
                    'thumbMinSize',
                    'universal',
                    'autoHeight',
                    'autoHeightMin',
                    'autoHeightMax',
                    'style',
                    'children'
                ]);
                /* eslint-enable no-unused-vars */ var didMountUniversal = this.state.didMountUniversal;
                var containerStyle = $908aa1fd5bfdd6d6$var$_extends({}, $6382d197205bd039$exports.containerStyleDefault, autoHeight && $908aa1fd5bfdd6d6$var$_extends({}, $6382d197205bd039$exports.containerStyleAutoHeight, {
                    minHeight: autoHeightMin,
                    maxHeight: autoHeightMax
                }), style);
                var viewStyle = $908aa1fd5bfdd6d6$var$_extends({}, $6382d197205bd039$exports.viewStyleDefault, {
                    // Hide scrollbars by setting a negative margin
                    marginRight: scrollbarWidth ? -scrollbarWidth : 0,
                    marginBottom: scrollbarWidth ? -scrollbarWidth : 0
                }, autoHeight && $908aa1fd5bfdd6d6$var$_extends({}, $6382d197205bd039$exports.viewStyleAutoHeight, {
                    // Add scrollbarWidth to autoHeight in order to compensate negative margins
                    minHeight: (0, $908aa1fd5bfdd6d6$var$_isString2["default"])(autoHeightMin) ? 'calc(' + autoHeightMin + ' + ' + scrollbarWidth + 'px)' : autoHeightMin + scrollbarWidth,
                    maxHeight: (0, $908aa1fd5bfdd6d6$var$_isString2["default"])(autoHeightMax) ? 'calc(' + autoHeightMax + ' + ' + scrollbarWidth + 'px)' : autoHeightMax + scrollbarWidth
                }), autoHeight && universal && !didMountUniversal && {
                    minHeight: autoHeightMin,
                    maxHeight: autoHeightMax
                }, universal && !didMountUniversal && $6382d197205bd039$exports.viewStyleUniversalInitial);
                var trackAutoHeightStyle = {
                    transition: 'opacity ' + autoHideDuration + 'ms',
                    opacity: 0
                };
                var trackHorizontalStyle = $908aa1fd5bfdd6d6$var$_extends({}, $6382d197205bd039$exports.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                    display: 'none'
                });
                var trackVerticalStyle = $908aa1fd5bfdd6d6$var$_extends({}, $6382d197205bd039$exports.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                    display: 'none'
                });
                return (0, $ieT14.createElement)(tagName, $908aa1fd5bfdd6d6$var$_extends({}, props, {
                    style: containerStyle,
                    ref: function ref(_ref3) {
                        _this7.container = _ref3;
                    }
                }), [
                    (0, $ieT14.cloneElement)(renderView({
                        style: viewStyle
                    }), {
                        key: 'view',
                        ref: function ref(_ref4) {
                            _this7.view = _ref4;
                        }
                    }, children),
                    (0, $ieT14.cloneElement)(renderTrackHorizontal({
                        style: trackHorizontalStyle
                    }), {
                        key: 'trackHorizontal',
                        ref: function ref(_ref5) {
                            _this7.trackHorizontal = _ref5;
                        }
                    }, (0, $ieT14.cloneElement)(renderThumbHorizontal({
                        style: $6382d197205bd039$exports.thumbHorizontalStyleDefault
                    }), {
                        ref: function ref(_ref6) {
                            _this7.thumbHorizontal = _ref6;
                        }
                    })),
                    (0, $ieT14.cloneElement)(renderTrackVertical({
                        style: trackVerticalStyle
                    }), {
                        key: 'trackVertical',
                        ref: function ref(_ref7) {
                            _this7.trackVertical = _ref7;
                        }
                    }, (0, $ieT14.cloneElement)(renderThumbVertical({
                        style: $6382d197205bd039$exports.thumbVerticalStyleDefault
                    }), {
                        ref: function ref(_ref8) {
                            _this7.thumbVertical = _ref8;
                        }
                    }))
                ]);
            }
        }
    ]);
    return Scrollbars;
}($ieT14.Component);
$908aa1fd5bfdd6d6$exports["default"] = $908aa1fd5bfdd6d6$var$Scrollbars;
$908aa1fd5bfdd6d6$var$Scrollbars.propTypes = {
    onScroll: $908aa1fd5bfdd6d6$var$_propTypes2["default"].func,
    onScrollFrame: $908aa1fd5bfdd6d6$var$_propTypes2["default"].func,
    onScrollStart: $908aa1fd5bfdd6d6$var$_propTypes2["default"].func,
    onScrollStop: $908aa1fd5bfdd6d6$var$_propTypes2["default"].func,
    onUpdate: $908aa1fd5bfdd6d6$var$_propTypes2["default"].func,
    renderView: $908aa1fd5bfdd6d6$var$_propTypes2["default"].func,
    renderTrackHorizontal: $908aa1fd5bfdd6d6$var$_propTypes2["default"].func,
    renderTrackVertical: $908aa1fd5bfdd6d6$var$_propTypes2["default"].func,
    renderThumbHorizontal: $908aa1fd5bfdd6d6$var$_propTypes2["default"].func,
    renderThumbVertical: $908aa1fd5bfdd6d6$var$_propTypes2["default"].func,
    tagName: $908aa1fd5bfdd6d6$var$_propTypes2["default"].string,
    thumbSize: $908aa1fd5bfdd6d6$var$_propTypes2["default"].number,
    thumbMinSize: $908aa1fd5bfdd6d6$var$_propTypes2["default"].number,
    hideTracksWhenNotNeeded: $908aa1fd5bfdd6d6$var$_propTypes2["default"].bool,
    autoHide: $908aa1fd5bfdd6d6$var$_propTypes2["default"].bool,
    autoHideTimeout: $908aa1fd5bfdd6d6$var$_propTypes2["default"].number,
    autoHideDuration: $908aa1fd5bfdd6d6$var$_propTypes2["default"].number,
    autoHeight: $908aa1fd5bfdd6d6$var$_propTypes2["default"].bool,
    autoHeightMin: $908aa1fd5bfdd6d6$var$_propTypes2["default"].oneOfType([
        $908aa1fd5bfdd6d6$var$_propTypes2["default"].number,
        $908aa1fd5bfdd6d6$var$_propTypes2["default"].string
    ]),
    autoHeightMax: $908aa1fd5bfdd6d6$var$_propTypes2["default"].oneOfType([
        $908aa1fd5bfdd6d6$var$_propTypes2["default"].number,
        $908aa1fd5bfdd6d6$var$_propTypes2["default"].string
    ]),
    universal: $908aa1fd5bfdd6d6$var$_propTypes2["default"].bool,
    style: $908aa1fd5bfdd6d6$var$_propTypes2["default"].object,
    children: $908aa1fd5bfdd6d6$var$_propTypes2["default"].node
};
$908aa1fd5bfdd6d6$var$Scrollbars.defaultProps = {
    renderView: $24babc7650726a6e$exports.renderViewDefault,
    renderTrackHorizontal: $24babc7650726a6e$exports.renderTrackHorizontalDefault,
    renderTrackVertical: $24babc7650726a6e$exports.renderTrackVerticalDefault,
    renderThumbHorizontal: $24babc7650726a6e$exports.renderThumbHorizontalDefault,
    renderThumbVertical: $24babc7650726a6e$exports.renderThumbVerticalDefault,
    tagName: 'div',
    thumbMinSize: 30,
    hideTracksWhenNotNeeded: false,
    autoHide: false,
    autoHideTimeout: 1000,
    autoHideDuration: 200,
    autoHeight: false,
    autoHeightMin: 0,
    autoHeightMax: 200,
    universal: false
};


var $5d10f0a7aadd7c8c$var$_Scrollbars2 = $5d10f0a7aadd7c8c$var$_interopRequireDefault($908aa1fd5bfdd6d6$exports);
function $5d10f0a7aadd7c8c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
$5d10f0a7aadd7c8c$exports["default"] = $5d10f0a7aadd7c8c$var$_Scrollbars2["default"];
$5d10f0a7aadd7c8c$exports.Scrollbars = $5d10f0a7aadd7c8c$var$_Scrollbars2["default"];




var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");


var $aIJrd = parcelRequire("aIJrd");

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var /**
 * @ignore - internal component.
 */ $1c601e5660f4c91b$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person');


var $ff51e565c472de00$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            width: 40,
            height: 40,
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(20),
            lineHeight: 1,
            borderRadius: '50%',
            overflow: 'hidden',
            userSelect: 'none'
        },
        /* Styles applied to the root element if not `src` or `srcSet`. */ colorDefault: {
            color: theme.palette.background.default,
            backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
        },
        /* Styles applied to the root element if `variant="circle"`. */ circle: {},
        /* Styles applied to the root element if `variant="circular"`. */ circular: {},
        /* Styles applied to the root element if `variant="rounded"`. */ rounded: {
            borderRadius: theme.shape.borderRadius
        },
        /* Styles applied to the root element if `variant="square"`. */ square: {
            borderRadius: 0
        },
        /* Styles applied to the img element if either `src` or `srcSet` is defined. */ img: {
            width: '100%',
            height: '100%',
            textAlign: 'center',
            // Handle non-square image. The property isn't supported by IE 11.
            objectFit: 'cover',
            // Hide alt text.
            color: 'transparent',
            // Hide the image broken icon, only works on Chrome.
            textIndent: 10000
        },
        /* Styles applied to the fallback icon */ fallback: {
            width: '75%',
            height: '75%'
        }
    };
};
function $ff51e565c472de00$var$useLoaded(_ref) {
    var src = _ref.src, srcSet = _ref.srcSet;
    var _React$useState = $ieT14.useState(false), loaded = _React$useState[0], setLoaded = _React$useState[1];
    $ieT14.useEffect(function() {
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        var active = true;
        var image = new Image();
        image.src = src;
        image.srcSet = srcSet;
        image.onload = function() {
            if (!active) return;
            setLoaded('loaded');
        };
        image.onerror = function() {
            if (!active) return;
            setLoaded('error');
        };
        return function() {
            active = false;
        };
    }, [
        src,
        srcSet
    ]);
    return loaded;
}
var $ff51e565c472de00$var$Avatar = /*#__PURE__*/ $ieT14.forwardRef(function Avatar(props, ref) {
    var alt = props.alt, childrenProp = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, imgProps = props.imgProps, sizes = props.sizes, src = props.src, srcSet = props.srcSet, _props$variant = props.variant, variant = _props$variant === void 0 ? 'circular' : _props$variant, other = (0, $eTwGP.default)(props, [
        "alt",
        "children",
        "classes",
        "className",
        "component",
        "imgProps",
        "sizes",
        "src",
        "srcSet",
        "variant"
    ]);
    var children = null; // Use a hook instead of onError on the img element to support server-side rendering.
    var loaded = $ff51e565c472de00$var$useLoaded({
        src: src,
        srcSet: srcSet
    });
    var hasImg = src || srcSet;
    var hasImgNotFailing = hasImg && loaded !== 'error';
    if (hasImgNotFailing) children = /*#__PURE__*/ $ieT14.createElement("img", (0, $edxsd.default)({
        alt: alt,
        src: src,
        srcSet: srcSet,
        sizes: sizes,
        className: classes.img
    }, imgProps));
    else if (childrenProp != null) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ $ieT14.createElement((0, $1c601e5660f4c91b$export$2e2bcd8739ae039), {
        className: classes.fallback
    });
    return /*#__PURE__*/ $ieT14.createElement(Component, (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, classes.system, classes[variant], className, !hasImgNotFailing && classes.colorDefault),
        ref: ref
    }, other), children);
});
var $ff51e565c472de00$export$2e2bcd8739ae039 = (0, $aIJrd.default)($ff51e565c472de00$export$9dd6ff9ea0189349, {
    name: 'MuiAvatar'
})($ff51e565c472de00$var$Avatar);


var $dxqtw = parcelRequire("dxqtw");
var $1fCJg = parcelRequire("1fCJg");
var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $aIJrd = parcelRequire("aIJrd");

var $2Mf9x = parcelRequire("2Mf9x");
var $8f4164b0daa98aaa$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        minWidth: 56,
        flexShrink: 0
    },
    /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */ alignItemsFlexStart: {
        marginTop: 8
    }
};
/**
 * A simple wrapper to apply `List` styles to an `Avatar`.
 */ var $8f4164b0daa98aaa$var$ListItemAvatar = /*#__PURE__*/ $ieT14.forwardRef(function ListItemAvatar(props, ref) {
    var classes = props.classes, className = props.className, other = (0, $eTwGP.default)(props, [
        "classes",
        "className"
    ]);
    var context = $ieT14.useContext((0, $2Mf9x.default));
    return /*#__PURE__*/ $ieT14.createElement("div", (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
        ref: ref
    }, other));
});
var $8f4164b0daa98aaa$export$2e2bcd8739ae039 = (0, $aIJrd.default)($8f4164b0daa98aaa$export$9dd6ff9ea0189349, {
    name: 'MuiListItemAvatar'
})($8f4164b0daa98aaa$var$ListItemAvatar);


var $bPjUl = parcelRequire("bPjUl");
var $lzS53 = parcelRequire("lzS53");

var $db7Kr = parcelRequire("db7Kr");

var $j6s32 = parcelRequire("j6s32");
// Color utilities for MaterialUI Theme/Styles
const $69ed148db7543104$export$2aa0182783e7e9de = {
    100: '#eaf3f8',
    200: '#89cbdf',
    300: '#00aafc',
    400: '#0092e0',
    500: '#0084ba',
    600: '#006da8',
    700: '#074F86',
    800: '#00223C'
};
const $69ed148db7543104$export$a4867fe9454f37a8 = {
    100: '#ffffff',
    200: '#efefef',
    300: '#d1cece',
    400: '#c6c4c4',
    500: '#8a8a8a',
    550: '#7f7f7f',
    600: '#4f4f4f',
    700: '#000000'
};
const $69ed148db7543104$export$471f7ae5c4103ae1 = {
    success: {
        light: '#dff0d0',
        medium: '#65B500',
        dark: '#04844B' // p1 fill
    },
    error: {
        light: '#f5dbd9',
        medium: '#ebafa6',
        dark: '#c92100'
    },
    warning: {
        light: '#ffeadb',
        medium: '#ff7e1c',
        dark: '#C25400'
    },
    info: {
        light: '#e1f1f6',
        medium: '#89cbdf',
        dark: '#007cbb'
    },
    deactive: '#8a8a8a'
};
const $69ed148db7543104$export$8f45430ccf837300 = {
    rustRed: '#c92100',
    lightGrey: '#dadada'
};


const $a414f09d93b4ed4c$export$709a39c897136e8 = {
    heading: 'Montserrat, Helvetica, sans-serif',
    body: "'Open Sans', Helvetica, Arial, sans-serif"
};
const $a414f09d93b4ed4c$export$c838579cfa8e3e4f = {
    h1: '20px',
    h2: '20px',
    h3: '18px',
    h4: '18px',
    h5: '16px',
    h6: '16px',
    body1: '14px',
    body2: '12px',
    label1: '12px',
    label2: '14px',
    caption: '12px'
};
/**
 * Common typographical styles from Portal Style Guide
 */ const $a414f09d93b4ed4c$var$TextStyles = {
    h1: {
        fontFamily: $a414f09d93b4ed4c$export$709a39c897136e8.heading,
        fontSize: $a414f09d93b4ed4c$export$c838579cfa8e3e4f.h1,
        fontWeight: 600
    },
    h2: {
        fontFamily: $a414f09d93b4ed4c$export$709a39c897136e8.heading,
        fontSize: $a414f09d93b4ed4c$export$c838579cfa8e3e4f.h2,
        fontWeight: 300,
        color: $69ed148db7543104$export$2aa0182783e7e9de[600]
    },
    h3: {
        fontFamily: $a414f09d93b4ed4c$export$709a39c897136e8.heading,
        fontSize: $a414f09d93b4ed4c$export$c838579cfa8e3e4f.h3,
        fontWeight: 600,
        textTransform: 'uppercase'
    },
    h4: {
        fontFamily: $a414f09d93b4ed4c$export$709a39c897136e8.heading,
        fontSize: $a414f09d93b4ed4c$export$c838579cfa8e3e4f.h4,
        fontWeight: 300,
        textTransform: 'uppercase'
    },
    h5: {
        fontFamily: $a414f09d93b4ed4c$export$709a39c897136e8.heading,
        fontSize: $a414f09d93b4ed4c$export$c838579cfa8e3e4f.h5,
        fontWeight: 600
    },
    h6: {
        fontFamily: $a414f09d93b4ed4c$export$709a39c897136e8.heading,
        fontSize: $a414f09d93b4ed4c$export$c838579cfa8e3e4f.h6,
        fontWeight: 300
    },
    label1: {
        fontFamily: $a414f09d93b4ed4c$export$709a39c897136e8.heading,
        color: $69ed148db7543104$export$a4867fe9454f37a8[600],
        fontWeight: 300,
        fontSize: $a414f09d93b4ed4c$export$c838579cfa8e3e4f.label1,
        margin: 0
    },
    label2: {
        fontFamily: $a414f09d93b4ed4c$export$709a39c897136e8.heading,
        color: $69ed148db7543104$export$a4867fe9454f37a8[600],
        fontWeight: 300,
        fontSize: $a414f09d93b4ed4c$export$c838579cfa8e3e4f.label2,
        margin: 0
    },
    label4: {
        fontFamily: $a414f09d93b4ed4c$export$709a39c897136e8.heading,
        fontWeight: 200,
        fontSize: 11,
        color: $69ed148db7543104$export$a4867fe9454f37a8[600]
    },
    body1: {
        fontFamily: $a414f09d93b4ed4c$export$709a39c897136e8.body,
        color: $69ed148db7543104$export$a4867fe9454f37a8[700],
        fontWeight: 300,
        fontSize: $a414f09d93b4ed4c$export$c838579cfa8e3e4f.body1,
        letterSpacing: 0.3,
        lineHeight: 1.43
    },
    body2: {
        fontFamily: $a414f09d93b4ed4c$export$709a39c897136e8.body,
        color: $69ed148db7543104$export$a4867fe9454f37a8[600],
        fontWeight: 400,
        fontSize: $a414f09d93b4ed4c$export$c838579cfa8e3e4f.body2,
        lineHeight: 1.33
    },
    caption: {
        fontFamily: $a414f09d93b4ed4c$export$709a39c897136e8.body,
        color: $69ed148db7543104$export$a4867fe9454f37a8[600],
        fontWeight: 300,
        fontSize: $a414f09d93b4ed4c$export$c838579cfa8e3e4f.caption
    }
};
var $a414f09d93b4ed4c$export$2e2bcd8739ae039 = $a414f09d93b4ed4c$var$TextStyles;



var $eYoAG = parcelRequire("eYoAG");


/** MUI Overrides */ const $19f667641f14b801$var$useStyles = (0, $db7Kr.default)({
    avatar: {
        width: 32,
        height: 32,
        '& .MuiAvatar-img': {
            objectFit: 'contain'
        }
    },
    listItemText: {
        '& .MuiListItemText-primary': {
            fontSize: 18,
            fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).heading
        }
    },
    buttonStyle: {
        paddingLeft: 0,
        border: 0,
        background: 'none',
        color: '#ffffff',
        width: '100%'
    },
    arrowStyle: {
        flex: 3,
        textAlign: 'right'
    }
});
/**
 * @function TeamDropdown - Component for the team dropdown menu used in the left toolbar
 */ const $19f667641f14b801$var$TeamDropdown = ({ clientId: clientId, collapsed: collapsed })=>{
    const classes = $19f667641f14b801$var$useStyles();
    const appContext = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const clientsQuery = (0, $f54f7d0a50104e94$export$4823a6cc022cca16)();
    const [currentClient, setCurrentClient] = $ieT14.useState(null);
    const { authState: authState } = (0, $4df32aa15a91038c$export$2ae4a19e09ca9a00)();
    const history = (0, $eYoAG.useHistory)();
    // Anchor element of popover menu
    const [anchorEl, setAnchorEl] = $ieT14.useState(null);
    const handleOpen = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    $ieT14.useEffect(()=>{
        if (clientsQuery.data && appContext.state.clientId) setCurrentClient(clientsQuery.data.results.find((client)=>client.clientId === Number(clientId)));
    }, [
        clientsQuery.data,
        appContext.state.clientId
    ]);
    /**
   * @function setActiveClient - Sets the active client in context and local storage after the client selects a client from the drop down menu
   */ const setActiveClient = (client)=>{
        localStorage.setItem('clientId', client.clientId.toString());
        localStorage.setItem('clientName', client.name);
        localStorage.setItem('enableServiceDesk', client.enableServiceDesk.toString());
        appContext.setState({
            clientId: client.clientId,
            clientName: client.name,
            enableServiceDesk: client.enableServiceDesk,
            clientChanging: true
        });
        handleClose();
        history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Reports);
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: "team",
        children: [
            currentClient && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("button", {
                id: currentClient.clientId.toString(),
                className: (0, $j6s32.default)(classes.buttonStyle, $ab8ad438073fe4a7$export$ff07a26348a13a9, clientsQuery.data && clientsQuery.data.results.length <= 1 && $ab8ad438073fe4a7$export$bac611fc0051cb95, collapsed && $ab8ad438073fe4a7$export$27c57cc52d388509),
                onClick: handleOpen,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: $ab8ad438073fe4a7$export$b5b09ff7e34c8dba,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("img", {
                            src: currentClient.brandImage + '&accessToken=' + authState.accessToken.accessToken
                        })
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        className: $ab8ad438073fe4a7$export$a7db06668cad9adb,
                        children: currentClient.displayName
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                        className: (0, $j6s32.default)($ab8ad438073fe4a7$export$b0859cf5bfecfc75, classes.arrowStyle),
                        icon: "arrow_drop_down"
                    })
                ]
            }, currentClient.clientId.toString()),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $lzS53.default), {
                open: open,
                onClose: handleClose,
                anchorEl: anchorEl,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                children: authState.accessToken && clientsQuery.data && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $5d10f0a7aadd7c8c$exports.Scrollbars), {
                    style: {
                        width: 280
                    },
                    autoHeight: true,
                    autoHeightMax: `calc(100vh - 165px)`,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $dxqtw.default), {
                        children: clientsQuery.data.results.map((client)=>{
                            return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $1fCJg.default), {
                                selected: client.clientId === Number(appContext.state.clientId),
                                onClick: ()=>setActiveClient(client),
                                button: true,
                                dense: true,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8f4164b0daa98aaa$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $ff51e565c472de00$export$2e2bcd8739ae039), {
                                            variant: "square",
                                            className: classes.avatar,
                                            src: client.brandImage + '&accessToken=' + authState.accessToken.accessToken
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $bPjUl.default), {
                                        primary: client.displayName,
                                        className: classes.listItemText
                                    })
                                ]
                            }, `client-${client.clientId}`);
                        })
                    })
                })
            })
        ]
    });
};
var $19f667641f14b801$export$2e2bcd8739ae039 = $19f667641f14b801$var$TeamDropdown;




var $ieT14 = parcelRequire("ieT14");
var $ff22b3212a120358$export$b0377cbbbdab6cba;
var $ff22b3212a120358$export$f27f0a643498ce3d;
var $ff22b3212a120358$export$b00c055587dc7469;
var $ff22b3212a120358$export$b1a09d22b7ad6c4;
var $ff22b3212a120358$export$509f3108fdd206bb;
var $ff22b3212a120358$export$42ff741d2868ee32;
var $ff22b3212a120358$export$8c430709db82137d;
var $ff22b3212a120358$export$2d4b1211b4389c3b;
var $ff22b3212a120358$export$3832be13857745bc;
var $ff22b3212a120358$export$f4c68800b094ddb1;
var $ff22b3212a120358$export$b1e5508a851be14d;
var $ff22b3212a120358$export$c176f998e71d0f08;
var $ff22b3212a120358$export$462ebd570cf3ba3a;
var $ff22b3212a120358$export$39e2e9f39931f5e4;
var $ff22b3212a120358$export$89da14300d534261;
$ff22b3212a120358$export$b0377cbbbdab6cba = "#006da8";
$ff22b3212a120358$export$f27f0a643498ce3d = "#00aafc";
$ff22b3212a120358$export$b00c055587dc7469 = "#f5dbd9";
$ff22b3212a120358$export$b1a09d22b7ad6c4 = "#c92100";
$ff22b3212a120358$export$509f3108fdd206bb = "#ebafa6";
$ff22b3212a120358$export$42ff741d2868ee32 = "#074f86";
$ff22b3212a120358$export$8c430709db82137d = "#dadada";
$ff22b3212a120358$export$2d4b1211b4389c3b = "#dddbda";
$ff22b3212a120358$export$3832be13857745bc = "#eae9ed";
$ff22b3212a120358$export$f4c68800b094ddb1 = "#e9e8f4";
$ff22b3212a120358$export$b1e5508a851be14d = "menu_64f1fc";
$ff22b3212a120358$export$c176f998e71d0f08 = "menuItem_64f1fc";
$ff22b3212a120358$export$462ebd570cf3ba3a = "menuItemIcon_64f1fc";
$ff22b3212a120358$export$39e2e9f39931f5e4 = "menuItemLabel_64f1fc";
$ff22b3212a120358$export$89da14300d534261 = "active_64f1fc";



var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $8275daba8096e5be$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement($ieT14.Fragment, null, /*#__PURE__*/ $ieT14.createElement("path", {
    d: "M12 2l-5.5 9h11z"
}), /*#__PURE__*/ $ieT14.createElement("circle", {
    cx: "17.5",
    cy: "17.5",
    r: "4.5"
}), /*#__PURE__*/ $ieT14.createElement("path", {
    d: "M3 13.5h8v8H3z"
})), 'Category');


var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $a2c87568bc732d39$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
}), 'Dashboard');



var $6mt9R = parcelRequire("6mt9R");


var $j6s32 = parcelRequire("j6s32");




var $ieT14 = parcelRequire("ieT14");


/**
 * useClient
 * @function useClient - Custom hook for the client models
 */ const $c400040bbf0b66f7$var$useClient = ()=>{
    const { getAuth: getAuth, postAuth: postAuth, postFileAuth: postFileAuth, putAuth: putAuth, baseURL: baseURL } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    const { oktaAuth: oktaAuth } = (0, $4df32aa15a91038c$export$2ae4a19e09ca9a00)();
    const accessToken = oktaAuth.getAccessToken();
    const fetchClients = (currentPage, pageSize, searchTerm, orderColumn, orderDirection)=>{
        return getClients('clients', currentPage, pageSize, searchTerm, orderColumn, orderDirection);
    };
    const fetchAdminClients = (currentPage, pageSize, searchTerm, orderColumn, orderDirection)=>{
        return getClients('clients/admin', currentPage, pageSize, searchTerm, orderColumn, orderDirection);
    };
    const getClients = (path, currentPage, pageSize, searchTerm, orderColumn, orderDirection)=>{
        let queryParams = `?page=${currentPage}&pageSize=${pageSize}`;
        if (!(searchTerm === null || searchTerm === undefined) && searchTerm.trim() !== '') queryParams += `&searchTerm=${searchTerm}`;
        if (orderColumn != null) queryParams += `&sort=${orderColumn}`;
        if (orderDirection != null) queryParams += `&sortDirection=${orderDirection}`;
        return getAuth(`api/${path}${queryParams}`);
    };
    const fetchAllClients = ()=>{
        let queryParams = `?page=1&pageSize=0`;
        return getAuth(`api/clients${queryParams}`);
    };
    const createClient = (client)=>{
        return postAuth('api/clients', client);
    };
    const storeLogo = (clientId, file)=>{
        return postFileAuth('api/clients/' + clientId + '/logo', null, file);
    };
    const fetchClient = (clientId)=>{
        return getAuth(`api/clients/${clientId}`);
    };
    const editClient = (client)=>{
        return putAuth(`api/clients/${client.clientId}`, client);
    };
    const fetchClientBrandImage = (brandImage)=>{
        return `${baseURL}api/assets?path=${brandImage}&accessToken=${accessToken}`;
    };
    return {
        fetchClients: fetchClients,
        fetchAdminClients: fetchAdminClients,
        fetchAllClients: fetchAllClients,
        fetchClient: fetchClient,
        createClient: createClient,
        storeLogo: storeLogo,
        fetchClientBrandImage: fetchClientBrandImage,
        editClient: editClient
    };
};
var $c400040bbf0b66f7$export$2e2bcd8739ae039 = $c400040bbf0b66f7$var$useClient;


/**
 * useUser
 * @function useUser - Custom hook for the user management page
 */ const $b19aa392df0f3838$var$useUser = ()=>{
    const { getAuth: getAuth, postAuth: postAuth, putAuth: putAuth } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    /**
   * @function createUser - Create a new user
   * @param user - the new user to create
   */ const createUser = (user)=>{
        return postAuth('api/users', user);
    };
    const [loadingAssociatedData, setLoadingAssociatedData] = $ieT14.useState(true);
    const [clients, setClients] = $ieT14.useState([]);
    const [applications, setApplications] = $ieT14.useState([]);
    const [currentUserRole, setCurrentUserRole] = $ieT14.useState('');
    const { fetchAdminClients: fetchAdminClients } = (0, $c400040bbf0b66f7$export$2e2bcd8739ae039)();
    /**
   * @function fetchAssociatedData - Get extra data needed to create/edit a user
   */ const fetchAssociatedData = ()=>{
        if (!loadingAssociatedData) setLoadingAssociatedData(true);
        Promise.all([
            fetchAdminClients(1, 0),
            fetchApplications()
        ]).then(([clients, applications])=>{
            setClients(clients?.results || []);
            setApplications(applications);
            setLoadingAssociatedData(false);
        });
    };
    const fetchCurrentUserRole = ()=>{
        if (!loadingAssociatedData) setLoadingAssociatedData(true);
        getCurrentUser().then((currentUser)=>{
            setCurrentUserRole(currentUser.role);
            setLoadingAssociatedData(false);
        });
    };
    const fetchApplications = ()=>{
        return getAuth(`api/management/applications`);
    };
    const fetchUser = (userId)=>{
        return getAuth(`api/users/${userId}`).then((user)=>{
            return user;
        });
    };
    const editUser = (user)=>{
        return putAuth(`api/users/${user.id}`, user);
    };
    const inviteUser = (user)=>{
        return postAuth(`api/users/${user.id}/invite`, user);
    };
    const getCurrentUser = ()=>{
        return getAuth(`api/users/current`);
    };
    return {
        createUser: createUser,
        loadingAssociatedData: loadingAssociatedData,
        clients: clients,
        applications: applications,
        currentUserRole: currentUserRole,
        fetchCurrentUserRole: fetchCurrentUserRole,
        fetchAssociatedData: fetchAssociatedData,
        fetchUser: fetchUser,
        editUser: editUser,
        inviteUser: inviteUser,
        getCurrentUser: getCurrentUser
    };
};
var $b19aa392df0f3838$export$2e2bcd8739ae039 = $b19aa392df0f3838$var$useUser;


/**
 * @enum - Segmentation Permission
 */ var $5294e215b521479c$var$SegmentationPermission = /*#__PURE__*/ function(SegmentationPermission) {
    SegmentationPermission[SegmentationPermission["None"] = 0] = "None";
    SegmentationPermission[SegmentationPermission["Basic"] = 1] = "Basic";
    SegmentationPermission[SegmentationPermission["Push"] = 2] = "Push";
    SegmentationPermission[SegmentationPermission["Power"] = 3] = "Power";
    return SegmentationPermission;
}($5294e215b521479c$var$SegmentationPermission || {});
var $5294e215b521479c$export$2e2bcd8739ae039 = $5294e215b521479c$var$SegmentationPermission;


const $f217cd5f3086e591$var$Menu = ({ collapsed: collapsed })=>{
    const { state: state } = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const clientsQuery = (0, $f54f7d0a50104e94$export$4823a6cc022cca16)();
    const { getCurrentUser: getCurrentUser } = (0, $b19aa392df0f3838$export$2e2bcd8739ae039)();
    const [userSegmentationAccess, setUserSegmentationAccess] = $ieT14.useState(false);
    $ieT14.useEffect(()=>{
        checkUser();
    }, [
        state.clientId,
        clientsQuery.data
    ]);
    const checkUser = async ()=>{
        try {
            const currentUser = await getCurrentUser();
            const assignedSegmentation = currentUser.assignedSegmentation.find((as)=>as.clientId === state.clientId);
            setUserSegmentationAccess(assignedSegmentation?.segmentationPermission !== (0, $5294e215b521479c$export$2e2bcd8739ae039).None);
        } catch (error) {
            setUserSegmentationAccess(false);
        }
    };
    const currentClient = $ieT14.useMemo(()=>{
        if (clientsQuery.data && state.clientId) return clientsQuery.data.results.find((client)=>client.clientId === state.clientId);
    }, [
        state.clientId,
        clientsQuery.data
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("nav", {
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("ul", {
            className: $ff22b3212a120358$export$b1e5508a851be14d,
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $6mt9R.NavLink), {
                        to: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Reports,
                        className: (isActive)=>(0, $j6s32.default)($ff22b3212a120358$export$c176f998e71d0f08, isActive && $ff22b3212a120358$export$89da14300d534261),
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $a2c87568bc732d39$export$2e2bcd8739ae039), {
                                className: $ff22b3212a120358$export$462ebd570cf3ba3a
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                className: (0, $j6s32.default)($ff22b3212a120358$export$39e2e9f39931f5e4, collapsed && 'sr-hidden'),
                                children: "Dashboards"
                            })
                        ]
                    })
                }),
                currentClient?.enableSegmentation && userSegmentationAccess && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $6mt9R.NavLink), {
                        to: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Segments,
                        className: (isActive)=>(0, $j6s32.default)($ff22b3212a120358$export$c176f998e71d0f08, isActive && $ff22b3212a120358$export$89da14300d534261),
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8275daba8096e5be$export$2e2bcd8739ae039), {
                                className: $ff22b3212a120358$export$462ebd570cf3ba3a
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                className: (0, $j6s32.default)($ff22b3212a120358$export$39e2e9f39931f5e4, collapsed && 'sr-hidden'),
                                children: "Segments"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $f217cd5f3086e591$export$2e2bcd8739ae039 = $f217cd5f3086e591$var$Menu;




var $fpdl2 = parcelRequire("fpdl2");


/**
 * LeftToolbar
 * @function LeftToolbar - Displays the left toolbar on the main page
 */ const $65af7149d3b61ab7$var$LeftToolbar = ()=>{
    const appContext = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const clientsQuery = (0, $f54f7d0a50104e94$export$4823a6cc022cca16)();
    const [collapsed, setCollapsed] = $ieT14.useState(localStorage.getItem('sidebarCollapsed') === 'true');
    $ieT14.useEffect(()=>{
        localStorage.setItem('sidebarCollapsed', String(collapsed));
    }, [
        collapsed
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $944aae8422412095$export$2e2bcd8739ae039), {
        initialCollapse: collapsed,
        collapsedClass: $cba48e46b26fad31$export$27c57cc52d388509,
        sidebarClass: $cba48e46b26fad31$export$6fbb9cd2843e91b2,
        onCollapseToggle: (collapseState)=>setCollapsed(collapseState),
        children: clientsQuery.isLoading ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
            className: $cba48e46b26fad31$export$bfd8d51c3a53ed31,
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {
                size: "20px",
                color: "inherit"
            })
        }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $19f667641f14b801$export$2e2bcd8739ae039), {
                    clientId: appContext.state.clientId,
                    collapsed: collapsed
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f217cd5f3086e591$export$2e2bcd8739ae039), {
                    collapsed: collapsed
                })
            ]
        })
    });
};
var $65af7149d3b61ab7$export$2e2bcd8739ae039 = $65af7149d3b61ab7$var$LeftToolbar;




var $ieT14 = parcelRequire("ieT14");



parcelRequire("ieT14");


var $6mt9R = parcelRequire("6mt9R");


var $j6s32 = parcelRequire("j6s32");

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $ec73bdc572d23151$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z"
}), 'Announcement');


var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $a62f442cac35cc1f$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
}), 'Business');


var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $6733f3dfc1165b5b$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z"
}), 'LibraryBooks');


var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $b0aaa2b89cf6d27a$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
}), 'People');


const $7b993bcef6a976df$var$menuItems = [
    {
        path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Clients,
        icon: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $a62f442cac35cc1f$export$2e2bcd8739ae039), {
            className: $ff22b3212a120358$export$462ebd570cf3ba3a
        }),
        label: 'Clients'
    },
    {
        path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Users,
        icon: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $b0aaa2b89cf6d27a$export$2e2bcd8739ae039), {
            className: $ff22b3212a120358$export$462ebd570cf3ba3a
        }),
        label: 'All Users'
    },
    {
        path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).GlobalHelpDocuments,
        icon: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6733f3dfc1165b5b$export$2e2bcd8739ae039), {
            className: $ff22b3212a120358$export$462ebd570cf3ba3a
        }),
        label: 'Global Help Docs'
    },
    {
        path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Announcements,
        icon: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $ec73bdc572d23151$export$2e2bcd8739ae039), {
            className: $ff22b3212a120358$export$462ebd570cf3ba3a
        }),
        label: 'Global Announcement'
    },
    {
        path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Segments,
        icon: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8275daba8096e5be$export$2e2bcd8739ae039), {
            className: $ff22b3212a120358$export$462ebd570cf3ba3a
        }),
        label: 'Segments'
    }
];
const $7b993bcef6a976df$var$Menu = ({ collapsed: collapsed, userRole: userRole })=>{
    const hideOption = (label)=>{
        if (userRole === 'Client Admin') return label !== 'clients';
        return false;
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("nav", {
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("ul", {
            className: $ff22b3212a120358$export$b1e5508a851be14d,
            children: $7b993bcef6a976df$var$menuItems.map((menuItem)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
                    hidden: hideOption(menuItem.label.toLowerCase()),
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $6mt9R.NavLink), {
                        to: menuItem.path,
                        className: (isActive)=>(0, $j6s32.default)($ff22b3212a120358$export$c176f998e71d0f08, isActive && $ff22b3212a120358$export$89da14300d534261),
                        children: [
                            menuItem.icon,
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                className: (0, $j6s32.default)($ff22b3212a120358$export$39e2e9f39931f5e4, collapsed && 'sr-hidden'),
                                children: menuItem.label
                            })
                        ]
                    })
                }, menuItem.label))
        })
    });
};
var $7b993bcef6a976df$export$2e2bcd8739ae039 = $7b993bcef6a976df$var$Menu;



/**
 * AdminToolbar
 * @function AdminToolbar - Displays the left toolbar on the main page
 */ const $b0907dd1b76198a6$var$AdminToolbar = ()=>{
    const [collapsed, setCollapsed] = $ieT14.useState(localStorage.getItem('adminSidebarCollapsed') === 'true');
    const { fetchCurrentUserRole: fetchCurrentUserRole, currentUserRole: currentUserRole, loadingAssociatedData: loadingAssociatedData } = (0, $b19aa392df0f3838$export$2e2bcd8739ae039)();
    const [userRole, setUserRole] = $ieT14.useState('');
    $ieT14.useEffect(()=>{
        fetchCurrentUserRole();
    }, []);
    $ieT14.useEffect(()=>{
        localStorage.setItem('adminSidebarCollapsed', String(collapsed));
    }, [
        collapsed
    ]);
    $ieT14.useEffect(()=>{
        if (!loadingAssociatedData) setUserRole(currentUserRole);
    }, [
        loadingAssociatedData
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($ieT14.Fragment, {
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $944aae8422412095$export$2e2bcd8739ae039), {
            initialCollapse: collapsed,
            collapsedClass: $cba48e46b26fad31$export$27c57cc52d388509,
            sidebarClass: $cba48e46b26fad31$export$6fbb9cd2843e91b2,
            onCollapseToggle: (collapseState)=>setCollapsed(collapseState),
            children: !loadingAssociatedData && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $7b993bcef6a976df$export$2e2bcd8739ae039), {
                collapsed: collapsed,
                userRole: userRole
            })
        })
    });
};
var $b0907dd1b76198a6$export$2e2bcd8739ae039 = $b0907dd1b76198a6$var$AdminToolbar;


const $49b5f1ea6af5bca5$var$Layout = (props)=>{
    const userInterface = window.env.USER_INTERFACE !== null && window.env.USER_INTERFACE !== undefined ? window.env.USER_INTERFACE : 'default';
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $cba48e46b26fad31$export$cc74dcc53cfce4eb,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $36f8756607a82807$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $cba48e46b26fad31$export$32180ef41b15b513,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $eYoAG.Switch), {
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Route), {
                                path: [
                                    (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Help,
                                    (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Management,
                                    (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Support,
                                    (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).AddRequest
                                ],
                                render: ()=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1aced3107d766ac6$export$2e2bcd8739ae039), {})
                            }),
                            userInterface !== 'management' && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Route), {
                                path: "/",
                                component: (0, $65af7149d3b61ab7$export$2e2bcd8739ae039)
                            }),
                            userInterface === 'management' && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Route), {
                                path: "/",
                                component: (0, $b0907dd1b76198a6$export$2e2bcd8739ae039)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        className: $cba48e46b26fad31$export$f22da7240b7add18,
                        children: [
                            userInterface !== 'management' && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $27daedee549ef3a9$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $7c2917e09e02e963$export$2e2bcd8739ae039), {})
                                ]
                            }),
                            props.children
                        ]
                    })
                ]
            })
        ]
    });
};
var $49b5f1ea6af5bca5$export$2e2bcd8739ae039 = $49b5f1ea6af5bca5$var$Layout;




var $ieT14 = parcelRequire("ieT14");
var $3ca278699d9732f8$export$b0377cbbbdab6cba;
var $3ca278699d9732f8$export$f27f0a643498ce3d;
var $3ca278699d9732f8$export$b00c055587dc7469;
var $3ca278699d9732f8$export$b1a09d22b7ad6c4;
var $3ca278699d9732f8$export$509f3108fdd206bb;
var $3ca278699d9732f8$export$42ff741d2868ee32;
var $3ca278699d9732f8$export$8c430709db82137d;
var $3ca278699d9732f8$export$2d4b1211b4389c3b;
var $3ca278699d9732f8$export$3832be13857745bc;
var $3ca278699d9732f8$export$f4c68800b094ddb1;
var $3ca278699d9732f8$export$f18d5b0af29128b7;
var $3ca278699d9732f8$export$c54b09e010026594;
var $3ca278699d9732f8$export$38e42c68cf43b5d4;
var $3ca278699d9732f8$export$84269455d6cf34e1;
var $3ca278699d9732f8$export$6bcd1691716bdcfb;
var $3ca278699d9732f8$export$1a4a45da1798e276;
var $3ca278699d9732f8$export$324d90190a8b822a;
var $3ca278699d9732f8$export$46c1c92549715335;
var $3ca278699d9732f8$export$f727f52c778e92d5;
var $3ca278699d9732f8$export$53b3a6aacbedbca0;
var $3ca278699d9732f8$export$935e8e660c24322;
var $3ca278699d9732f8$export$bd3b1236bac3ee14;
var $3ca278699d9732f8$export$dd149fccbe90353d;
var $3ca278699d9732f8$export$81207e5cc4186890;
var $3ca278699d9732f8$export$34512e3b2db52a4e;
var $3ca278699d9732f8$export$50799ef0f3192bd5;
var $3ca278699d9732f8$export$c176f998e71d0f08;
var $3ca278699d9732f8$export$94d09fb989a9df2e;
var $3ca278699d9732f8$export$3099d0daead893d3;
var $3ca278699d9732f8$export$8360e631d277ea4d;
var $3ca278699d9732f8$export$9b1610f4cf001bb8;
var $3ca278699d9732f8$export$7a85a8b07d5c2548;
var $3ca278699d9732f8$export$df2f46e3a734d408;
var $3ca278699d9732f8$export$a7dabb172976b078;
var $3ca278699d9732f8$export$d21ccd67febca1fc;
var $3ca278699d9732f8$export$d992296b9a725e45;
var $3ca278699d9732f8$export$4d0a1940c7ed2b3e;
var $3ca278699d9732f8$export$bc48b8aea52cfd28;
var $3ca278699d9732f8$export$b07e517d22efa1ca;
var $3ca278699d9732f8$export$f77685c252cbae87;
var $3ca278699d9732f8$export$b96bb35bc88d6fa;
var $3ca278699d9732f8$export$7edf0cee099ff617;
var $3ca278699d9732f8$export$87885aa627f93324;
var $3ca278699d9732f8$export$d675b3969e4857cb;
var $3ca278699d9732f8$export$4a94e106abcbc0a;
var $3ca278699d9732f8$export$c5a00ecdf4d56b76;
var $3ca278699d9732f8$export$f4cc6fffc2da71c8;
var $3ca278699d9732f8$export$a024168dd74c643c;
var $3ca278699d9732f8$export$ba184d72a832ebdd;
var $3ca278699d9732f8$export$200ac3d1223040f0;
var $3ca278699d9732f8$export$d2dcf3aefcbb6de8;
var $3ca278699d9732f8$export$560239d3315fb15a;
var $3ca278699d9732f8$export$e54f03703dfedd34;
var $3ca278699d9732f8$export$d727ccdbf4855090;
var $3ca278699d9732f8$export$98bdcda852cc137c;
var $3ca278699d9732f8$export$64a53ecd158b85c4;
var $3ca278699d9732f8$export$b290296436bdde1d;
var $3ca278699d9732f8$export$c9b2e5d36da1e7;
var $3ca278699d9732f8$export$17db8f373f565f31;
var $3ca278699d9732f8$export$6038a218a185fe99;
var $3ca278699d9732f8$export$9a9ba550e8aeeead;
var $3ca278699d9732f8$export$e0c21fe2a90ddc8e;
var $3ca278699d9732f8$export$ea3f3a5e726afb4f;
var $3ca278699d9732f8$export$518824cf31321346;
var $3ca278699d9732f8$export$34e0f9847d4c02dd;
var $3ca278699d9732f8$export$c94ad093f18c1c8d;
var $3ca278699d9732f8$export$dc57ddd528b7443f;
var $3ca278699d9732f8$export$7104031a6d2eee61;
var $3ca278699d9732f8$export$c967563cbfdc9900;
$3ca278699d9732f8$export$b0377cbbbdab6cba = "#006da8";
$3ca278699d9732f8$export$f27f0a643498ce3d = "#00aafc";
$3ca278699d9732f8$export$b00c055587dc7469 = "#f5dbd9";
$3ca278699d9732f8$export$b1a09d22b7ad6c4 = "#c92100";
$3ca278699d9732f8$export$509f3108fdd206bb = "#ebafa6";
$3ca278699d9732f8$export$42ff741d2868ee32 = "#074f86";
$3ca278699d9732f8$export$8c430709db82137d = "#dadada";
$3ca278699d9732f8$export$2d4b1211b4389c3b = "#dddbda";
$3ca278699d9732f8$export$3832be13857745bc = "#eae9ed";
$3ca278699d9732f8$export$f4c68800b094ddb1 = "#e9e8f4";
$3ca278699d9732f8$export$f18d5b0af29128b7 = "report_698a4c";
$3ca278699d9732f8$export$c54b09e010026594 = "fullscreenContainer_698a4c";
$3ca278699d9732f8$export$38e42c68cf43b5d4 = "header_698a4c";
$3ca278699d9732f8$export$84269455d6cf34e1 = "rightHeader_698a4c";
$3ca278699d9732f8$export$6bcd1691716bdcfb = "tooltipLine_698a4c";
$3ca278699d9732f8$export$1a4a45da1798e276 = "headerText_698a4c";
$3ca278699d9732f8$export$324d90190a8b822a = "date_698a4c";
$3ca278699d9732f8$export$46c1c92549715335 = "loading_698a4c";
$3ca278699d9732f8$export$f727f52c778e92d5 = "toolbar_698a4c";
$3ca278699d9732f8$export$53b3a6aacbedbca0 = "toolbarFullscreen_698a4c";
$3ca278699d9732f8$export$935e8e660c24322 = "leftTools_698a4c";
$3ca278699d9732f8$export$bd3b1236bac3ee14 = "rightTools_698a4c";
$3ca278699d9732f8$export$dd149fccbe90353d = "exportButtons_698a4c";
$3ca278699d9732f8$export$81207e5cc4186890 = "dropdown_698a4c";
$3ca278699d9732f8$export$34512e3b2db52a4e = "help_698a4c";
$3ca278699d9732f8$export$50799ef0f3192bd5 = "exportMenu_698a4c";
$3ca278699d9732f8$export$c176f998e71d0f08 = "menuItem_698a4c";
$3ca278699d9732f8$export$94d09fb989a9df2e = "viewsModal_698a4c";
$3ca278699d9732f8$export$3099d0daead893d3 = "modalHeader_698a4c";
$3ca278699d9732f8$export$8360e631d277ea4d = "close_698a4c";
$3ca278699d9732f8$export$9b1610f4cf001bb8 = "circularProgressContainer_698a4c";
$3ca278699d9732f8$export$7a85a8b07d5c2548 = "loadErrorContainer_698a4c";
$3ca278699d9732f8$export$df2f46e3a734d408 = "loadError_698a4c";
$3ca278699d9732f8$export$a7dabb172976b078 = "outerContainer_698a4c";
$3ca278699d9732f8$export$d21ccd67febca1fc = "manageTitle_698a4c";
$3ca278699d9732f8$export$d992296b9a725e45 = "manageButton_698a4c";
$3ca278699d9732f8$export$4d0a1940c7ed2b3e = "disabledManageButton_698a4c";
$3ca278699d9732f8$export$bc48b8aea52cfd28 = "checkboxForm_698a4c";
$3ca278699d9732f8$export$b07e517d22efa1ca = "checkbox_698a4c";
$3ca278699d9732f8$export$f77685c252cbae87 = "checkboxActive_698a4c";
$3ca278699d9732f8$export$b96bb35bc88d6fa = "checked_698a4c";
$3ca278699d9732f8$export$7edf0cee099ff617 = "viewNameForm_698a4c";
$3ca278699d9732f8$export$87885aa627f93324 = "viewNameInput_698a4c";
$3ca278699d9732f8$export$d675b3969e4857cb = "submitButton_698a4c";
$3ca278699d9732f8$export$4a94e106abcbc0a = "disabledSubmit_698a4c";
$3ca278699d9732f8$export$c5a00ecdf4d56b76 = "manageCustomContainer_698a4c";
$3ca278699d9732f8$export$f4cc6fffc2da71c8 = "customViews_698a4c";
$3ca278699d9732f8$export$a024168dd74c643c = "viewsContainer_698a4c";
$3ca278699d9732f8$export$ba184d72a832ebdd = "otherViews_698a4c";
$3ca278699d9732f8$export$200ac3d1223040f0 = "manageScroll_698a4c";
$3ca278699d9732f8$export$d2dcf3aefcbb6de8 = "manageOtherScroll_698a4c";
$3ca278699d9732f8$export$560239d3315fb15a = "viewName_698a4c";
$3ca278699d9732f8$export$e54f03703dfedd34 = "viewManage_698a4c";
$3ca278699d9732f8$export$d727ccdbf4855090 = "viewManageDefault_698a4c";
$3ca278699d9732f8$export$98bdcda852cc137c = "activeView_698a4c";
$3ca278699d9732f8$export$64a53ecd158b85c4 = "closeIcon_698a4c";
$3ca278699d9732f8$export$b290296436bdde1d = "editingContainer_698a4c";
$3ca278699d9732f8$export$c9b2e5d36da1e7 = "myViewName_698a4c";
$3ca278699d9732f8$export$17db8f373f565f31 = "manageOtherViewName_698a4c";
$3ca278699d9732f8$export$6038a218a185fe99 = "otherViewName_698a4c";
$3ca278699d9732f8$export$9a9ba550e8aeeead = "manageMyViewName_698a4c";
$3ca278699d9732f8$export$e0c21fe2a90ddc8e = "manageMyViewActions_698a4c";
$3ca278699d9732f8$export$ea3f3a5e726afb4f = "otherViewOwner_698a4c";
$3ca278699d9732f8$export$518824cf31321346 = "dialog_698a4c";
$3ca278699d9732f8$export$34e0f9847d4c02dd = "container_698a4c";
$3ca278699d9732f8$export$c94ad093f18c1c8d = "confirmationHeader_698a4c";
$3ca278699d9732f8$export$dc57ddd528b7443f = "buttonContainer_698a4c";
$3ca278699d9732f8$export$7104031a6d2eee61 = "confirmButton_698a4c";
$3ca278699d9732f8$export$c967563cbfdc9900 = "altTextScrolling_698a4c";





var $ieT14 = parcelRequire("ieT14");

var $6mt9R = parcelRequire("6mt9R");

var $7nM46 = parcelRequire("7nM46");
var $fdbf0d9f77db804d$export$b0377cbbbdab6cba;
var $fdbf0d9f77db804d$export$f27f0a643498ce3d;
var $fdbf0d9f77db804d$export$b00c055587dc7469;
var $fdbf0d9f77db804d$export$b1a09d22b7ad6c4;
var $fdbf0d9f77db804d$export$509f3108fdd206bb;
var $fdbf0d9f77db804d$export$42ff741d2868ee32;
var $fdbf0d9f77db804d$export$8c430709db82137d;
var $fdbf0d9f77db804d$export$2d4b1211b4389c3b;
var $fdbf0d9f77db804d$export$3832be13857745bc;
var $fdbf0d9f77db804d$export$f4c68800b094ddb1;
var $fdbf0d9f77db804d$export$a38812d1aa1302d9;
var $fdbf0d9f77db804d$export$f40c3b93aa85e075;
var $fdbf0d9f77db804d$export$228bcabfee25bcc7;
var $fdbf0d9f77db804d$export$29dd17c7f3c81c36;
var $fdbf0d9f77db804d$export$9a0dd4d839a90927;
var $fdbf0d9f77db804d$export$f2ea4ab276c3e3fa;
var $fdbf0d9f77db804d$export$d675b3969e4857cb;
var $fdbf0d9f77db804d$export$515d2155aaad79e4;
var $fdbf0d9f77db804d$export$5668677bb0c0ed27;
var $fdbf0d9f77db804d$export$130dd2cd4186e923;
var $fdbf0d9f77db804d$export$38fc320d708abb25;
var $fdbf0d9f77db804d$export$b07e517d22efa1ca;
var $fdbf0d9f77db804d$export$f77685c252cbae87;
var $fdbf0d9f77db804d$export$3a0ab88f0478b50d;
var $fdbf0d9f77db804d$export$135180a04c5d6085;
var $fdbf0d9f77db804d$export$aa8b8078be26284;
var $fdbf0d9f77db804d$export$f45508d19dce717b;
var $fdbf0d9f77db804d$export$9bb6a6f2774dc082;
var $fdbf0d9f77db804d$export$fe3d81a6d0bd342f;
var $fdbf0d9f77db804d$export$dc57ddd528b7443f;
$fdbf0d9f77db804d$export$b0377cbbbdab6cba = "#006da8";
$fdbf0d9f77db804d$export$f27f0a643498ce3d = "#00aafc";
$fdbf0d9f77db804d$export$b00c055587dc7469 = "#f5dbd9";
$fdbf0d9f77db804d$export$b1a09d22b7ad6c4 = "#c92100";
$fdbf0d9f77db804d$export$509f3108fdd206bb = "#ebafa6";
$fdbf0d9f77db804d$export$42ff741d2868ee32 = "#074f86";
$fdbf0d9f77db804d$export$8c430709db82137d = "#dadada";
$fdbf0d9f77db804d$export$2d4b1211b4389c3b = "#dddbda";
$fdbf0d9f77db804d$export$3832be13857745bc = "#eae9ed";
$fdbf0d9f77db804d$export$f4c68800b094ddb1 = "#e9e8f4";
$fdbf0d9f77db804d$export$a38812d1aa1302d9 = "fieldset_ed203a";
$fdbf0d9f77db804d$export$f40c3b93aa85e075 = "twoColumn_ed203a";
$fdbf0d9f77db804d$export$228bcabfee25bcc7 = "threeColumn_ed203a";
$fdbf0d9f77db804d$export$29dd17c7f3c81c36 = "overlay_ed203a";
$fdbf0d9f77db804d$export$9a0dd4d839a90927 = "fixedCircularProgress_ed203a";
$fdbf0d9f77db804d$export$f2ea4ab276c3e3fa = "searchBar_ed203a";
$fdbf0d9f77db804d$export$d675b3969e4857cb = "submitButton_ed203a";
$fdbf0d9f77db804d$export$515d2155aaad79e4 = "breadcrumbs_ed203a";
$fdbf0d9f77db804d$export$5668677bb0c0ed27 = "tertiary_ed203a";
$fdbf0d9f77db804d$export$130dd2cd4186e923 = "secondaryButton_ed203a";
$fdbf0d9f77db804d$export$38fc320d708abb25 = "deactive_ed203a";
$fdbf0d9f77db804d$export$b07e517d22efa1ca = "checkbox_ed203a";
$fdbf0d9f77db804d$export$f77685c252cbae87 = "checkboxActive_ed203a";
$fdbf0d9f77db804d$export$3a0ab88f0478b50d = "disabledMenuItem_ed203a";
$fdbf0d9f77db804d$export$135180a04c5d6085 = "formActions_ed203a";
$fdbf0d9f77db804d$export$aa8b8078be26284 = "singleFormAction_ed203a";
$fdbf0d9f77db804d$export$f45508d19dce717b = "dialogContainer_ed203a";
$fdbf0d9f77db804d$export$9bb6a6f2774dc082 = "dialogHeader_ed203a";
$fdbf0d9f77db804d$export$fe3d81a6d0bd342f = "dialogButtonContainer_ed203a";
$fdbf0d9f77db804d$export$dc57ddd528b7443f = "buttonContainer_ed203a";


/**
 * Breadcrumbs
 * @function Breadcrumbs - Component that shows path to current page (breadcrumbs)
 */ const $0cc2bc53567db499$var$Breadcrumbs = ({ breadcrumbs: breadcrumbs, currentPage: currentPage })=>{
    /**
   * @function renderBreadcrumbs - Renders each individual link/title and arrow
   */ const renderBreadcrumbs = ()=>{
        return breadcrumbs.map((breadcrumb, index)=>// Full syntax for fragment needed in order to complete build
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6mt9R.Link), {
                        to: breadcrumb.path,
                        children: breadcrumb.title
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $7nM46.default), {})
                ]
            }, `breadcrumb-${index}`));
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $fdbf0d9f77db804d$export$515d2155aaad79e4,
        children: [
            renderBreadcrumbs(),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h1", {
                children: currentPage
            })
        ]
    });
};
var $0cc2bc53567db499$export$2e2bcd8739ae039 = $0cc2bc53567db499$var$Breadcrumbs;


/**
 * BreadcrumbOptions
 * @enum Title for a breadcrumb
 */ var $e3b999dd4e075081$var$BreadcrumbOptions = /*#__PURE__*/ function(BreadcrumbOptions) {
    /** Dashboard title */ BreadcrumbOptions["Dashboard"] = "Dashboard";
    /** Clients */ BreadcrumbOptions["Clients"] = "All Clients";
    return BreadcrumbOptions;
}($e3b999dd4e075081$var$BreadcrumbOptions || {});
var $e3b999dd4e075081$export$2e2bcd8739ae039 = $e3b999dd4e075081$var$BreadcrumbOptions;


var $584968587d5f8f62$exports = {};
"use strict";
var $b24015bb0dc2bec9$exports = {};
function $b24015bb0dc2bec9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
$b24015bb0dc2bec9$exports = $b24015bb0dc2bec9$var$_interopRequireDefault, $b24015bb0dc2bec9$exports.__esModule = true, $b24015bb0dc2bec9$exports["default"] = $b24015bb0dc2bec9$exports;


var $633c7dc13d665c5e$exports = {};
var $abb968efd1f3566c$exports = {};
function $abb968efd1f3566c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $abb968efd1f3566c$exports = $abb968efd1f3566c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $abb968efd1f3566c$exports.__esModule = true, $abb968efd1f3566c$exports["default"] = $abb968efd1f3566c$exports, $abb968efd1f3566c$var$_typeof(o);
}
$abb968efd1f3566c$exports = $abb968efd1f3566c$var$_typeof, $abb968efd1f3566c$exports.__esModule = true, $abb968efd1f3566c$exports["default"] = $abb968efd1f3566c$exports;


var $633c7dc13d665c5e$var$_typeof = $abb968efd1f3566c$exports.default;
function $633c7dc13d665c5e$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($633c7dc13d665c5e$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $633c7dc13d665c5e$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $633c7dc13d665c5e$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $633c7dc13d665c5e$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
$633c7dc13d665c5e$exports = $633c7dc13d665c5e$var$_interopRequireWildcard, $633c7dc13d665c5e$exports.__esModule = true, $633c7dc13d665c5e$exports["default"] = $633c7dc13d665c5e$exports;


Object.defineProperty($584968587d5f8f62$exports, "__esModule", {
    value: true
});
$584968587d5f8f62$exports.default = void 0;

var $584968587d5f8f62$var$React = $633c7dc13d665c5e$exports((parcelRequire("ieT14")));

var $584968587d5f8f62$var$_createSvgIcon = $b24015bb0dc2bec9$exports((parcelRequire("3yIjW")));
var $584968587d5f8f62$var$_default = (0, $584968587d5f8f62$var$_createSvgIcon.default)(/*#__PURE__*/ $584968587d5f8f62$var$React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
}), 'Info');
$584968587d5f8f62$exports.default = $584968587d5f8f62$var$_default;



var $356Vi = parcelRequire("356Vi");

var $aIJrd = parcelRequire("aIJrd");

var $fpdl2 = parcelRequire("fpdl2");

var $eYoAG = parcelRequire("eYoAG");


var $ieT14 = parcelRequire("ieT14");


var $ieT14 = parcelRequire("ieT14");


parcelRequire("ieT14");

var $fVNJ1 = parcelRequire("fVNJ1");


var $ieT14 = parcelRequire("ieT14");
var $2b36415f25d48604$export$b0377cbbbdab6cba;
var $2b36415f25d48604$export$f27f0a643498ce3d;
var $2b36415f25d48604$export$b00c055587dc7469;
var $2b36415f25d48604$export$b1a09d22b7ad6c4;
var $2b36415f25d48604$export$509f3108fdd206bb;
var $2b36415f25d48604$export$42ff741d2868ee32;
var $2b36415f25d48604$export$8c430709db82137d;
var $2b36415f25d48604$export$2d4b1211b4389c3b;
var $2b36415f25d48604$export$3832be13857745bc;
var $2b36415f25d48604$export$f4c68800b094ddb1;
var $2b36415f25d48604$export$79191b5aedbf24d4;
var $2b36415f25d48604$export$38e42c68cf43b5d4;
var $2b36415f25d48604$export$c4b0f5819f6a6663;
var $2b36415f25d48604$export$998fc1525fc10cb4;
var $2b36415f25d48604$export$d7dc7be08229f0b2;
var $2b36415f25d48604$export$69090a1e7ff8614c;
var $2b36415f25d48604$export$2446a521e491a056;
var $2b36415f25d48604$export$26cf923f17b837e4;
var $2b36415f25d48604$export$5a7bfc01df82fcd1;
var $2b36415f25d48604$export$a301abe19dc6106;
var $2b36415f25d48604$export$8a3414480ef6a69;
var $2b36415f25d48604$export$2868e043eb9960bb;
var $2b36415f25d48604$export$182ead204233c2b3;
var $2b36415f25d48604$export$48c2d0f2f545ac27;
var $2b36415f25d48604$export$8aade8ce2b5d7e87;
var $2b36415f25d48604$export$cace0fe917d7fea5;
var $2b36415f25d48604$export$48884d2a5190dc73;
var $2b36415f25d48604$export$9b9ee9fa673496c9;
var $2b36415f25d48604$export$d254041e5e1db576;
var $2b36415f25d48604$export$6ee01cf16d42268d;
var $2b36415f25d48604$export$7e04648e6944ee4b;
var $2b36415f25d48604$export$91124bb58bc04465;
var $2b36415f25d48604$export$89da14300d534261;
var $2b36415f25d48604$export$22fde7aa351e938b;
var $2b36415f25d48604$export$86b4c3062752a703;
var $2b36415f25d48604$export$7fdff3da760639fa;
var $2b36415f25d48604$export$8dbb6aba9913d6e1;
var $2b36415f25d48604$export$bacb5cc5a11aef16;
var $2b36415f25d48604$export$9445a6ed6a41ad3f;
var $2b36415f25d48604$export$77825fa6f4ae045f;
var $2b36415f25d48604$export$cdc47cd250892a50;
var $2b36415f25d48604$export$ce564da75223fc73;
var $2b36415f25d48604$export$abbf891d14497896;
var $2b36415f25d48604$export$796e90bc7f93c68c;
var $2b36415f25d48604$export$8cda5e5bc1088076;
var $2b36415f25d48604$export$1a182f8896a5fd6a;
var $2b36415f25d48604$export$a606bd1b881a1ff8;
var $2b36415f25d48604$export$ea07a18aa00be18e;
var $2b36415f25d48604$export$6deed9990843f121;
var $2b36415f25d48604$export$a184029c150a81f4;
var $2b36415f25d48604$export$4b6d0099b3cbc3aa;
var $2b36415f25d48604$export$bf5daf80bda0b208;
var $2b36415f25d48604$export$c1b0e24ee081147d;
var $2b36415f25d48604$export$4767d4262788a6cc;
var $2b36415f25d48604$export$209876d7b1ac8f3;
var $2b36415f25d48604$export$d3710016b0f351d6;
var $2b36415f25d48604$export$edfe9515a4e42134;
$2b36415f25d48604$export$b0377cbbbdab6cba = "#006da8";
$2b36415f25d48604$export$f27f0a643498ce3d = "#00aafc";
$2b36415f25d48604$export$b00c055587dc7469 = "#f5dbd9";
$2b36415f25d48604$export$b1a09d22b7ad6c4 = "#c92100";
$2b36415f25d48604$export$509f3108fdd206bb = "#ebafa6";
$2b36415f25d48604$export$42ff741d2868ee32 = "#074f86";
$2b36415f25d48604$export$8c430709db82137d = "#dadada";
$2b36415f25d48604$export$2d4b1211b4389c3b = "#dddbda";
$2b36415f25d48604$export$3832be13857745bc = "#eae9ed";
$2b36415f25d48604$export$f4c68800b094ddb1 = "#e9e8f4";
$2b36415f25d48604$export$79191b5aedbf24d4 = "helpContainer_566faa";
$2b36415f25d48604$export$38e42c68cf43b5d4 = "header_566faa";
$2b36415f25d48604$export$c4b0f5819f6a6663 = "circularProgress_566faa";
$2b36415f25d48604$export$998fc1525fc10cb4 = "helpContent_566faa";
$2b36415f25d48604$export$d7dc7be08229f0b2 = "contentHeader_566faa";
$2b36415f25d48604$export$69090a1e7ff8614c = "fullScreenText_566faa";
$2b36415f25d48604$export$2446a521e491a056 = "helpDocuments_566faa";
$2b36415f25d48604$export$26cf923f17b837e4 = "documentsContainer_566faa";
$2b36415f25d48604$export$5a7bfc01df82fcd1 = "document_566faa";
$2b36415f25d48604$export$a301abe19dc6106 = "documentTools_566faa";
$2b36415f25d48604$export$8a3414480ef6a69 = "statusIndicators_566faa";
$2b36415f25d48604$export$2868e043eb9960bb = "statusChip_566faa";
$2b36415f25d48604$export$182ead204233c2b3 = "documentActions_566faa";
$2b36415f25d48604$export$48c2d0f2f545ac27 = "preview_566faa";
$2b36415f25d48604$export$8aade8ce2b5d7e87 = "previewContainer_566faa";
$2b36415f25d48604$export$cace0fe917d7fea5 = "tableOfContents_566faa";
$2b36415f25d48604$export$48884d2a5190dc73 = "tableHeader_566faa";
$2b36415f25d48604$export$9b9ee9fa673496c9 = "folders_566faa";
$2b36415f25d48604$export$d254041e5e1db576 = "documentSection_566faa";
$2b36415f25d48604$export$6ee01cf16d42268d = "navLink_566faa";
$2b36415f25d48604$export$7e04648e6944ee4b = "isTopLevelDoc_566faa";
$2b36415f25d48604$export$91124bb58bc04465 = "parent_566faa";
$2b36415f25d48604$export$89da14300d534261 = "active_566faa";
$2b36415f25d48604$export$22fde7aa351e938b = "activeLink_566faa";
$2b36415f25d48604$export$86b4c3062752a703 = "collapsibleSection_566faa";
$2b36415f25d48604$export$7fdff3da760639fa = "collapseIcon_566faa";
$2b36415f25d48604$export$8dbb6aba9913d6e1 = "collapsibleParentContent_566faa";
$2b36415f25d48604$export$bacb5cc5a11aef16 = "children_566faa";
$2b36415f25d48604$export$9445a6ed6a41ad3f = "collapsibleSectionClosed_566faa";
$2b36415f25d48604$export$77825fa6f4ae045f = "scrolling_566faa";
$2b36415f25d48604$export$cdc47cd250892a50 = "scrollTableOfContents_566faa";
$2b36415f25d48604$export$ce564da75223fc73 = "helpListDragIcon_566faa";
$2b36415f25d48604$export$abbf891d14497896 = "treeList_566faa";
$2b36415f25d48604$export$796e90bc7f93c68c = "treeListItem_566faa";
$2b36415f25d48604$export$8cda5e5bc1088076 = "treeListItemContent_566faa";
$2b36415f25d48604$export$1a182f8896a5fd6a = "treeListCollapseIcon_566faa";
$2b36415f25d48604$export$a606bd1b881a1ff8 = "treeListItemLink_566faa";
$2b36415f25d48604$export$ea07a18aa00be18e = "topLevel_566faa";
$2b36415f25d48604$export$6deed9990843f121 = "treeListItemActive_566faa";
$2b36415f25d48604$export$a184029c150a81f4 = "treeListItemHandle_566faa";
$2b36415f25d48604$export$4b6d0099b3cbc3aa = "helpDroppable_566faa";
$2b36415f25d48604$export$bf5daf80bda0b208 = "isDraggingOver_566faa";
$2b36415f25d48604$export$c1b0e24ee081147d = "globalTree_566faa";
$2b36415f25d48604$export$4767d4262788a6cc = "tree_566faa";
$2b36415f25d48604$export$209876d7b1ac8f3 = "scroll_566faa";
$2b36415f25d48604$export$d3710016b0f351d6 = "userForm_566faa";
$2b36415f25d48604$export$edfe9515a4e42134 = "modalActionFooter_566faa";




var $ieT14 = parcelRequire("ieT14");

var $3tOoB = parcelRequire("3tOoB");
var $477d756f937b0d61$exports = {};
$477d756f937b0d61$exports = $parcel$resolve("CUxfr");


const $8d3a72c073b907e7$var$ShadowDOMContent = ({ document: document, showAltText: showAltText })=>{
    const [shadowRoot, setShadowRoot] = $ieT14.useState(null);
    const node = $ieT14.useRef(null);
    $ieT14.useLayoutEffect(()=>{
        setShadowRoot(node.current.attachShadow({
            mode: 'open'
        }));
    }, []);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        ref: node,
        children: shadowRoot && /*#__PURE__*/ (0, $3tOoB.createPortal)(/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("link", {
                    rel: "stylesheet",
                    href: (0, (/*@__PURE__*/$parcel$interopDefault($477d756f937b0d61$exports)))
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: showAltText ? document.alternative : document.content
                    }
                })
            ]
        }), shadowRoot)
    });
};
var $8d3a72c073b907e7$export$2e2bcd8739ae039 = $8d3a72c073b907e7$var$ShadowDOMContent;


/**
 * HelpContent
 * @function HelpContent - Component that displays each individual help document
 */ const $1690831c660b35f6$var$HelpContent = ({ document: document, activeDoc: activeDoc, showAltText: showAltText })=>{
    const docRef = $ieT14.useRef(null);
    // If the active document changes, the window will scroll to the appropriate document
    $ieT14.useEffect(()=>{
        if (activeDoc === document.snippetGroupId) return docRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
        });
    }, [
        activeDoc
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        ref: docRef,
        className: $2b36415f25d48604$export$5a7bfc01df82fcd1,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8d3a72c073b907e7$export$2e2bcd8739ae039), {
            document: document,
            showAltText: showAltText
        })
    });
};
var $1690831c660b35f6$export$2e2bcd8739ae039 = $1690831c660b35f6$var$HelpContent;




const $cb9fc5b960fafc31$var$styles = {
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    container: {
        backgroundColor: 'white',
        borderRadius: '3px',
        boxShadow: '0 2px 2px 2px rgba(0, 0, 0, 0.7)',
        height: 'min-content',
        minHeight: 249,
        maxHeight: '80%',
        outline: 'none',
        overflow: 'auto',
        padding: '20px',
        width: '80%',
        minWidth: 576,
        maxWidth: 1300,
        margin: 'auto'
    }
};
/**
 * @function AltTextModal - Modal to show alternative text for help documents
 */ const $cb9fc5b960fafc31$var$AltTextModal = ({ open: open, onClose: onClose, allDocuments: allDocuments })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fVNJ1.default), {
        style: $cb9fc5b960fafc31$var$styles.modal,
        open: open,
        onClose: (isOpen)=>onClose(!isOpen),
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
            className: "altModal",
            style: $cb9fc5b960fafc31$var$styles.container,
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $5d10f0a7aadd7c8c$exports.Scrollbars), {
                className: $3ca278699d9732f8$export$c967563cbfdc9900,
                children: allDocuments.length > 0 && allDocuments.map((doc, index)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1690831c660b35f6$export$2e2bcd8739ae039), {
                        document: doc,
                        activeDoc: 0,
                        showAltText: true
                    }, `alt-text-${index}`))
            })
        })
    });
};
var $cb9fc5b960fafc31$export$2e2bcd8739ae039 = $cb9fc5b960fafc31$var$AltTextModal;




var $ieT14 = parcelRequire("ieT14");

var $7fec86fc4dd1b2fd$var$TableauTool = /*#__PURE__*/ function(TableauTool) {
    TableauTool["Pause"] = "pause";
    TableauTool["Revert"] = "revert";
    TableauTool["Refresh"] = "refresh";
    TableauTool["Export"] = "export";
    TableauTool["Undo"] = "undo";
    TableauTool["Redo"] = "redo";
    TableauTool["Maximize"] = "maximize";
    TableauTool["Views"] = "views";
    return TableauTool;
}($7fec86fc4dd1b2fd$var$TableauTool || {});
var $7fec86fc4dd1b2fd$export$2e2bcd8739ae039 = $7fec86fc4dd1b2fd$var$TableauTool;



parcelRequire("ieT14");

const $8136bd3178c97ebb$var$RevertIcon = ({ width: width, height: height, color: color, title: title, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("svg", {
        onClick: onClick,
        className: $967c65ecbe356105$export$371137ceb8897acb,
        width: width || '24',
        height: height || '24',
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("path", {
            fill: color || '#000000',
            d: "M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M12.16,14.31C10.6,14.31 9.19,14.89 8.11,15.83L6,13.72V19H11.28L9.15,16.88C9.97,16.2 11,15.78 12.16,15.78C14.23,15.78 16,17.13 16.61,19L18,18.54C17.19,16.09 14.88,14.31 12.16,14.31Z"
        })
    });
};
var $8136bd3178c97ebb$export$2e2bcd8739ae039 = $8136bd3178c97ebb$var$RevertIcon;



parcelRequire("ieT14");

var $5TjLg = parcelRequire("5TjLg");

var $3mOXj = parcelRequire("3mOXj");


/**
 * Render dropdown for export button
 */ const $680e662115bd2293$var$ExportDropdown = ({ viz: viz, anchorEl: anchorEl, setAnchorEl: setAnchorEl, dashboard: dashboard })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $5TjLg.default), {
        className: $3ca278699d9732f8$export$50799ef0f3192bd5,
        anchorEl: anchorEl,
        open: Boolean(anchorEl),
        onClose: ()=>setAnchorEl(),
        getContentAnchorEl: null,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'center'
        },
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                className: $3ca278699d9732f8$export$c176f998e71d0f08,
                onClick: async ()=>{
                    setAnchorEl();
                    await viz.displayDialogAsync('export-pdf');
                    (0, $80940237791545d7$export$65cc181beb0d2632).addUserAction('export-menu-option', {
                        user_action_details: {
                            type: 'tableau_toolbar',
                            name: 'export-menu-option',
                            option: 'pdf',
                            dashboard_name: dashboard
                        }
                    });
                },
                children: "PDF"
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                className: $3ca278699d9732f8$export$c176f998e71d0f08,
                onClick: async ()=>{
                    setAnchorEl();
                    await viz.displayDialogAsync('export-data');
                    (0, $80940237791545d7$export$65cc181beb0d2632).addUserAction('export-menu-option', {
                        user_action_details: {
                            type: 'tableau_toolbar',
                            name: 'export-menu-option',
                            option: 'raw',
                            dashboard_name: dashboard
                        }
                    });
                },
                children: "Raw Data"
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                className: $3ca278699d9732f8$export$c176f998e71d0f08,
                onClick: async ()=>{
                    setAnchorEl();
                    await viz.exportImageAsync();
                    (0, $80940237791545d7$export$65cc181beb0d2632).addUserAction('export-menu-option', {
                        user_action_details: {
                            type: 'tableau_toolbar',
                            name: 'export-menu-option',
                            option: 'image',
                            dashboard_name: dashboard
                        }
                    });
                },
                children: "Image"
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                className: $3ca278699d9732f8$export$c176f998e71d0f08,
                onClick: async ()=>{
                    setAnchorEl();
                    await viz.displayDialogAsync('export-cross-tab');
                    (0, $80940237791545d7$export$65cc181beb0d2632).addUserAction('export-menu-option', {
                        user_action_details: {
                            type: 'tableau_toolbar',
                            name: 'export-menu-option',
                            option: 'crossTab',
                            dashboard_name: dashboard
                        }
                    });
                },
                children: "CrossTab"
            })
        ]
    });
};
var $680e662115bd2293$export$2e2bcd8739ae039 = $680e662115bd2293$var$ExportDropdown;



parcelRequire("ieT14");

var $356Vi = parcelRequire("356Vi");

var $aIJrd = parcelRequire("aIJrd");

const $e5cb3fdcda0cefc7$var$CustomTooltip = (0, $aIJrd.default)((theme)=>({
        arrow: {
            color: 'rgba(48, 65, 84, 0.85)'
        },
        tooltip: {
            backgroundColor: 'rgba(48, 65, 84, 0.85)',
            fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).heading,
            fontSize: '12',
            fontWeight: 300
        }
    }))((0, $356Vi.default));
const $e5cb3fdcda0cefc7$var$customPopperProps = {
    disablePortal: true,
    modifiers: {
        flip: {
            enabled: false
        },
        offset: {
            offset: '0, -8'
        }
    }
};
const $e5cb3fdcda0cefc7$var$IconButtonTooltip = (props)=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($e5cb3fdcda0cefc7$var$CustomTooltip, {
        ...props,
        arrow: true,
        PopperProps: $e5cb3fdcda0cefc7$var$customPopperProps,
        children: props.children
    });
};
var $e5cb3fdcda0cefc7$export$2e2bcd8739ae039 = $e5cb3fdcda0cefc7$var$IconButtonTooltip;



var $1KcBP = parcelRequire("1KcBP");

var $kfphy = parcelRequire("kfphy");
var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $8cee76b8e63d8a7e$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
}), 'Fullscreen');


var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $9306b1e61e58870e$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
}), 'FullscreenExit');


var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $a6d91dcbb9445d31$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z"
}), 'ImportExport');


var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $2064d139b45a6dc1$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
}), 'Pause');


var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $8846d0dab74c5e94$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M8 5v14l11-7z"
}), 'PlayArrow');


var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $952796267115a844$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"
}), 'Redo');


var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $4747aae72d232ea0$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
}), 'Refresh');


var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $9fda3ef89c4d3022$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"
}), 'Undo');



class $8bfb54caced96889$var$TableauButton extends $ieT14.Component {
    constructor(props){
        super(props), this.openExportMenu = (event)=>{
            this.setState({
                anchorEl: event.currentTarget
            });
            (0, $80940237791545d7$export$65cc181beb0d2632).addUserAction('export-menu', {
                user_action_details: {
                    type: 'tableau_toolbar',
                    name: 'export-menu',
                    modal_state: 'open',
                    dashboard_name: this.props.dashboardName
                }
            });
        }, this.closeExportMenu = ()=>{
            this.setState({
                anchorEl: null
            });
            (0, $80940237791545d7$export$65cc181beb0d2632).addUserAction('export-menu', {
                user_action_details: {
                    type: 'tableau_toolbar',
                    name: 'export-menu',
                    modal_state: 'closed',
                    dashboard_name: this.props.dashboardName
                }
            });
        }, this.onClick = ()=>{
            switch(this.props.type){
                case (0, $7fec86fc4dd1b2fd$export$2e2bcd8739ae039).Pause:
                    (0, $80940237791545d7$export$65cc181beb0d2632).addUserAction('pause', {
                        user_action_details: {
                            type: 'tableau_toolbar',
                            name: 'pause',
                            isPaused: !this.state.isPaused,
                            dashboard_name: this.props.dashboardName
                        }
                    });
                    this.setState({
                        isPaused: !this.state.isPaused
                    });
                    this.state.isPaused ? this.props.viz.resumeAutomaticUpdatesAsync() : this.props.viz.pauseAutomaticUpdatesAsync();
                    break;
                case (0, $7fec86fc4dd1b2fd$export$2e2bcd8739ae039).Revert:
                    (0, $80940237791545d7$export$65cc181beb0d2632).addUserAction('revert', {
                        user_action_details: {
                            type: 'tableau_toolbar',
                            name: 'revert',
                            dashboard_name: this.props.dashboardName
                        }
                    });
                    this.props.viz.revertAllAsync();
                    break;
                case (0, $7fec86fc4dd1b2fd$export$2e2bcd8739ae039).Refresh:
                    (0, $80940237791545d7$export$65cc181beb0d2632).addUserAction('refresh', {
                        user_action_details: {
                            type: 'tableau_toolbar',
                            name: 'refresh',
                            dashboard_name: this.props.dashboardName
                        }
                    });
                    this.props.viz.refreshDataAsync();
                    break;
                case (0, $7fec86fc4dd1b2fd$export$2e2bcd8739ae039).Undo:
                    (0, $80940237791545d7$export$65cc181beb0d2632).addUserAction('undo', {
                        user_action_details: {
                            type: 'tableau_toolbar',
                            name: 'undo',
                            dashboard_name: this.props.dashboardName
                        }
                    });
                    this.props.viz.undoAsync();
                    break;
                case (0, $7fec86fc4dd1b2fd$export$2e2bcd8739ae039).Redo:
                    (0, $80940237791545d7$export$65cc181beb0d2632).addUserAction('redo', {
                        user_action_details: {
                            type: 'tableau_toolbar',
                            name: 'redo',
                            dashboard_name: this.props.dashboardName
                        }
                    });
                    this.props.viz.redoAsync();
                    break;
                case (0, $7fec86fc4dd1b2fd$export$2e2bcd8739ae039).Maximize:
                    if (this.props.fullScreen) {
                        if (document.exitFullscreen) document.exitFullscreen();
                        // @ts-ignore - IE/Edge exit full screen call
                        if (document.webkitExitFullscreen) // @ts-ignore - IE/Edge exit full screen call
                        document.webkitExitFullscreen();
                    } else {
                        if (this.props.container.requestFullscreen) this.props.container.requestFullscreen();
                        else if (this.props.container.webkitRequestFullscreen) // @ts-ignore - IE/Edge enter full screen call
                        this.props.container.webkitRequestFullscreen();
                    }
            }
        };
        this.state = {
            isPaused: false,
            showViews: false,
            anchorEl: null
        };
    }
    render() {
        switch(this.props.type){
            case (0, $7fec86fc4dd1b2fd$export$2e2bcd8739ae039).Pause:
                return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $e5cb3fdcda0cefc7$export$2e2bcd8739ae039), {
                    title: this.state.isPaused ? 'Resume' : 'Pause',
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                        onClick: this.onClick,
                        edge: this.props.edge ? this.props.edge : false,
                        size: "small",
                        children: !this.state.isPaused ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $2064d139b45a6dc1$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8846d0dab74c5e94$export$2e2bcd8739ae039), {})
                    })
                });
            case (0, $7fec86fc4dd1b2fd$export$2e2bcd8739ae039).Refresh:
                return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $e5cb3fdcda0cefc7$export$2e2bcd8739ae039), {
                    title: "Refresh",
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                        onClick: this.onClick,
                        edge: this.props.edge ? this.props.edge : false,
                        size: "small",
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4747aae72d232ea0$export$2e2bcd8739ae039), {})
                    })
                });
            case (0, $7fec86fc4dd1b2fd$export$2e2bcd8739ae039).Revert:
                return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $e5cb3fdcda0cefc7$export$2e2bcd8739ae039), {
                    title: "Revert",
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                        onClick: this.onClick,
                        edge: this.props.edge ? this.props.edge : false,
                        size: "small",
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8136bd3178c97ebb$export$2e2bcd8739ae039), {
                            color: "#006da8"
                        })
                    })
                });
            case (0, $7fec86fc4dd1b2fd$export$2e2bcd8739ae039).Export:
                return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                            className: $3ca278699d9732f8$export$dd149fccbe90353d,
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $e5cb3fdcda0cefc7$export$2e2bcd8739ae039), {
                                title: "Export",
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $1KcBP.default), {
                                    onClick: this.openExportMenu,
                                    edge: this.props.edge ? this.props.edge : false,
                                    size: "small",
                                    children: [
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $a6d91dcbb9445d31$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $kfphy.default), {
                                            className: $3ca278699d9732f8$export$81207e5cc4186890
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $680e662115bd2293$export$2e2bcd8739ae039), {
                            anchorEl: this.state.anchorEl,
                            viz: this.props.viz,
                            setAnchorEl: this.closeExportMenu,
                            dashboard: this.props.dashboardName
                        })
                    ]
                });
            case (0, $7fec86fc4dd1b2fd$export$2e2bcd8739ae039).Undo:
                return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $e5cb3fdcda0cefc7$export$2e2bcd8739ae039), {
                    title: "Undo",
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                        onClick: this.onClick,
                        edge: this.props.edge ? this.props.edge : false,
                        size: "small",
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $9fda3ef89c4d3022$export$2e2bcd8739ae039), {})
                    })
                });
            case (0, $7fec86fc4dd1b2fd$export$2e2bcd8739ae039).Redo:
                return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $e5cb3fdcda0cefc7$export$2e2bcd8739ae039), {
                    title: "Redo",
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                        onClick: this.onClick,
                        edge: this.props.edge ? this.props.edge : false,
                        size: "small",
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $952796267115a844$export$2e2bcd8739ae039), {})
                    })
                });
            case (0, $7fec86fc4dd1b2fd$export$2e2bcd8739ae039).Maximize:
                return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $e5cb3fdcda0cefc7$export$2e2bcd8739ae039), {
                    title: this.props.fullScreen ? 'Exit Full Screen' : 'Full Screen',
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                        onClick: this.onClick,
                        edge: this.props.edge ? this.props.edge : false,
                        size: "small",
                        children: this.props.fullScreen ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $9306b1e61e58870e$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8cee76b8e63d8a7e$export$2e2bcd8739ae039), {})
                    })
                });
        }
    }
}
var $8bfb54caced96889$export$2e2bcd8739ae039 = $8bfb54caced96889$var$TableauButton;





var $1KcBP = parcelRequire("1KcBP");

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $f3d3f58d1fb88d8a$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
}), 'Help');





var $ieT14 = parcelRequire("ieT14");


var $ieT14 = parcelRequire("ieT14");

var $fVNJ1 = parcelRequire("fVNJ1");


var $ieT14 = parcelRequire("ieT14");
/**
 * Hook: helper functions to render elements of the Custom Views modal
 */ const $64267c560b39f1c9$var$useCustomViews = (viz, closeModal, setLoadError)=>{
    const [customViews, setCustomViews] = $ieT14.useState([]);
    const [loading, setLoading] = $ieT14.useState(true);
    /**
   * Fetch any custom views available to the current user and attempt to parse metadata from the returned object.
   * If the data interface returned from the API has changed, set error to show instead of management dialog
   */ const fetchCustomViews = async ()=>{
        setLoading(true);
        return await viz.workbook.getCustomViewsAsync().then((views)=>{
            try {
                const parsedViews = views.map((rawView)=>{
                    return {
                        name: rawView.name,
                        isDefault: rawView.default,
                        isPublic: rawView.shared,
                        ownerName: rawView.ownerName,
                        raw: rawView._customViewImpl
                    };
                });
                setCustomViews(parsedViews);
                setLoading(false);
            } catch  {
                setLoadError('Error: could not load custom view data');
                setLoading(false);
            }
        });
    };
    /**
   * Display the selected custom view. If null, display the original, unmodified view.
   */ const showCustomView = (viewName)=>{
        viz.workbook.showCustomViewAsync(viewName || null);
        closeModal();
    };
    /**
   * Add a new custom view state, saving public and defaualt parameters and refresh custom views state
   */ const addCustomView = (event, customViewName, isDefault, isPublic)=>{
        event.preventDefault();
        if (customViewName) {
            viz.workbook.saveCustomViewAsync(customViewName).then((view)=>{
                fetchCustomViews().then(()=>{
                    view.setAdvertised(isPublic);
                    return view.saveAsync();
                }).then(()=>isDefault && viz.workbook.setActiveCustomViewAsDefaultAsync()).then(()=>fetchCustomViews());
            });
            closeModal();
        }
    };
    return {
        customViews: customViews,
        fetchCustomViews: fetchCustomViews,
        setCustomViews: setCustomViews,
        showCustomView: showCustomView,
        addCustomView: addCustomView,
        loading: loading
    };
};
var $64267c560b39f1c9$export$2e2bcd8739ae039 = $64267c560b39f1c9$var$useCustomViews;




var $ieT14 = parcelRequire("ieT14");

var $aIJrd = parcelRequire("aIJrd");

var $eYT2J = parcelRequire("eYT2J");

var $fRnKy = parcelRequire("fRnKy");
const $db32c8adf65b4dff$var$CssTextField = (0, $aIJrd.default)({
    root: {
        width: '100%',
        '& label.Mui-focused': {
            color: '#4F4F4F'
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                borderColor: '#00AAFC'
            }
        },
        '& .MuiFormHelperText-root': {
            color: 'red'
        }
    }
})((0, $eYT2J.default));
var $db32c8adf65b4dff$export$2e2bcd8739ae039 = /*#__PURE__*/ $ieT14.memo(function OutlinedInput(props) {
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($db32c8adf65b4dff$var$CssTextField, {
        ...props,
        margin: "normal",
        variant: "outlined"
    });
}, (prevProps, nextProps)=>(0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).isEqual(prevProps.value, nextProps.value) && (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).isEqual(prevProps.error, nextProps.error));



var $ekezX = parcelRequire("ekezX");
var $fpdl2 = parcelRequire("fpdl2");



var $lamW6 = parcelRequire("lamW6");

var $3WBJn = parcelRequire("3WBJn");

var $knRao = parcelRequire("knRao");



var $ieT14 = parcelRequire("ieT14");



parcelRequire("ieT14");
const $9838769971a0cf86$var$PublicEye = ({ width: width, height: height, handleClick: handleClick })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        title: "Public",
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("svg", {
            width: width || '24',
            height: height || '24',
            viewBox: "0 0 24 24",
            onClick: handleClick,
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("path", {
                d: "M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C17,4.5 21.27,7.61 23,12C21.27,16.39 17,19.5 12,19.5C7,19.5 2.73,16.39 1,12C2.73,7.61 7,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C15.76,17.5 19.17,15.36 20.82,12C19.17,8.64 15.76,6.5 12,6.5C8.24,6.5 4.83,8.64 3.18,12Z"
            })
        })
    });
};
var $9838769971a0cf86$export$2e2bcd8739ae039 = $9838769971a0cf86$var$PublicEye;





var $e1ONw = parcelRequire("e1ONw");

var $j6s32 = parcelRequire("j6s32");
const $29a3a2c0317f2ba3$var$useStyles = (0, $e1ONw.default)({
    buttonStyle: {
        paddingLeft: 0,
        border: 0,
        background: 'none'
    }
});
/**
 * Display the list of the current user's custom views
 */ const $29a3a2c0317f2ba3$var$CustomViewList = ({ customViews: customViews, activeCustomView: activeCustomView, showCustomView: showCustomView })=>{
    const { state: state } = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const classes = $29a3a2c0317f2ba3$var$useStyles();
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $5d10f0a7aadd7c8c$exports.Scrollbars), {
        autoHide: true,
        children: customViews.map((view)=>{
            if (state.email.toLowerCase() === view.ownerEmail) {
                // Even if custom views exist, getActiveCustomView can be non-existent during loading
                const activeViewName = activeCustomView ? activeCustomView.getName() : '';
                const isActiveView = view.name === activeViewName;
                return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("button", {
                    className: (0, $j6s32.default)(isActiveView ? $3ca278699d9732f8$export$98bdcda852cc137c : $3ca278699d9732f8$export$560239d3315fb15a, classes.buttonStyle),
                    onClick: ()=>showCustomView(view.name),
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                            className: $3ca278699d9732f8$export$c9b2e5d36da1e7,
                            children: [
                                view.isDefault && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                                    title: "Default",
                                    icon: "insert_chart"
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                                    children: [
                                        view.name,
                                        view.isDefault && ' (default)'
                                    ]
                                })
                            ]
                        }),
                        view.isPublic && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $9838769971a0cf86$export$2e2bcd8739ae039), {
                            width: "16",
                            height: "16"
                        })
                    ]
                }, view.name);
            }
        })
    });
};
var $29a3a2c0317f2ba3$export$2e2bcd8739ae039 = $29a3a2c0317f2ba3$var$CustomViewList;





var $ieT14 = parcelRequire("ieT14");




var $e1ONw = parcelRequire("e1ONw");

var $j6s32 = parcelRequire("j6s32");
const $de1948d1e3a5d855$var$useStyles = (0, $e1ONw.default)({
    buttonStyle: {
        paddingLeft: 0,
        border: 0,
        background: 'none'
    }
});
/**
 * Display the list of all public views not created by the current user
 */ const $de1948d1e3a5d855$var$OtherViewList = ({ customViews: customViews, activeCustomView: activeCustomView, showCustomView: showCustomView })=>{
    const { state: state } = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const defaultExists = customViews.find((view)=>view.isDefault) !== undefined;
    const publicViews = customViews.filter((view)=>view.isPublic && view.ownerEmail !== state.email.toLowerCase());
    const classes = $de1948d1e3a5d855$var$useStyles();
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $5d10f0a7aadd7c8c$exports.Scrollbars), {
        autoHide: true,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("button", {
                className: (0, $j6s32.default)(activeCustomView ? $3ca278699d9732f8$export$560239d3315fb15a : $3ca278699d9732f8$export$98bdcda852cc137c, classes.buttonStyle),
                onClick: ()=>showCustomView(),
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                    className: $3ca278699d9732f8$export$6038a218a185fe99,
                    children: [
                        !defaultExists && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                            title: "Default",
                            icon: "insert_chart"
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                            children: [
                                "Original ",
                                !defaultExists && ' (default)'
                            ]
                        })
                    ]
                })
            }),
            publicViews.length > 0 && publicViews.map((view)=>{
                const activeViewName = activeCustomView ? activeCustomView.getName() : '';
                const isActiveView = view.name === activeViewName;
                return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("button", {
                    className: (0, $j6s32.default)(isActiveView ? $3ca278699d9732f8$export$98bdcda852cc137c : $3ca278699d9732f8$export$560239d3315fb15a, classes.buttonStyle),
                    onClick: ()=>showCustomView(view.name),
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                            className: $3ca278699d9732f8$export$6038a218a185fe99,
                            children: [
                                view.isDefault && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                                    title: "Default",
                                    icon: "insert_chart"
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                                    children: [
                                        view.name,
                                        view.isDefault && ' (default)'
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                            className: $3ca278699d9732f8$export$ea3f3a5e726afb4f,
                            children: view.ownerName
                        })
                    ]
                }, view.name);
            })
        ]
    });
};
var $de1948d1e3a5d855$export$2e2bcd8739ae039 = $de1948d1e3a5d855$var$OtherViewList;




var $ieT14 = parcelRequire("ieT14");




parcelRequire("ieT14");
const $c8f070500b3eefbb$var$PrivateEye = ({ width: width, height: height, handleClick: handleClick })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        title: "Private",
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("svg", {
            width: width || '24',
            height: height || '24',
            viewBox: "0 0 24 24",
            onClick: handleClick,
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("path", {
                d: "M2,5.27L3.28,4L20,20.72L18.73,22L15.65,18.92C14.5,19.3 13.28,19.5 12,19.5C7,19.5 2.73,16.39 1,12C1.69,10.24 2.79,8.69 4.19,7.46L2,5.27M12,9A3,3 0 0,1 15,12C15,12.35 14.94,12.69 14.83,13L11,9.17C11.31,9.06 11.65,9 12,9M12,4.5C17,4.5 21.27,7.61 23,12C22.18,14.08 20.79,15.88 19,17.19L17.58,15.76C18.94,14.82 20.06,13.54 20.82,12C19.17,8.64 15.76,6.5 12,6.5C10.91,6.5 9.84,6.68 8.84,7L7.3,5.47C8.74,4.85 10.33,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C12.69,17.5 13.37,17.43 14,17.29L11.72,15C10.29,14.85 9.15,13.71 9,12.28L5.6,8.87C4.61,9.72 3.78,10.78 3.18,12Z"
            })
        })
    });
};
var $c8f070500b3eefbb$export$2e2bcd8739ae039 = $c8f070500b3eefbb$var$PrivateEye;




var $ieT14 = parcelRequire("ieT14");

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $9p9Gy = parcelRequire("9p9Gy");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $aIJrd = parcelRequire("aIJrd");

var $2EBFt = parcelRequire("2EBFt");


var $fVNJ1 = parcelRequire("fVNJ1");

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $aIJrd = parcelRequire("aIJrd");

var $edxsd = parcelRequire("edxsd");

var $dcIvM = parcelRequire("dcIvM");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $4XMe5 = parcelRequire("4XMe5");

var $ejUtG = parcelRequire("ejUtG");

var $hgPMF = parcelRequire("hgPMF");

var $1VWiP = parcelRequire("1VWiP");

var $3A1Xf = parcelRequire("3A1Xf");
var $5828ccb7eba373d9$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
var $5828ccb7eba373d9$var$defaultTimeout = {
    enter: (0, $ejUtG.duration).enteringScreen,
    exit: (0, $ejUtG.duration).leavingScreen
};
/**
 * The Fade transition is used by the [Modal](/components/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $5828ccb7eba373d9$var$Fade = /*#__PURE__*/ $ieT14.forwardRef(function Fade(props, ref) {
    var children = props.children, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $4XMe5.default) : _props$TransitionComp, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? $5828ccb7eba373d9$var$defaultTimeout : _props$timeout, other = (0, $eTwGP.default)(props, [
        "children",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "TransitionComponent",
        "timeout"
    ]);
    var theme = (0, $hgPMF.default)();
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $ieT14.useRef(null);
    var foreignRef = (0, $3A1Xf.default)(children.ref, ref);
    var handleRef = (0, $3A1Xf.default)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $dcIvM.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        (0, $1VWiP.reflow)(node); // So the animation always start from the start.
        var transitionProps = (0, $1VWiP.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var transitionProps = (0, $1VWiP.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    return /*#__PURE__*/ $ieT14.createElement(TransitionComponent, (0, $edxsd.default)({
        appear: true,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        timeout: timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $ieT14.cloneElement(children, (0, $edxsd.default)({
            style: (0, $edxsd.default)({
                opacity: 0,
                visibility: state === 'exited' && !inProp ? 'hidden' : undefined
            }, $5828ccb7eba373d9$var$styles[state], style, children.props.style),
            ref: handleRef
        }, childProps));
    });
});
var $5828ccb7eba373d9$export$2e2bcd8739ae039 = $5828ccb7eba373d9$var$Fade;


var $6d93bac9e2a7a50f$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        // Improve scrollable dialog support.
        zIndex: -1,
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    },
    /* Styles applied to the root element if `invisible={true}`. */ invisible: {
        backgroundColor: 'transparent'
    }
};
var $6d93bac9e2a7a50f$var$Backdrop = /*#__PURE__*/ $ieT14.forwardRef(function Backdrop(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$invisible = props.invisible, invisible = _props$invisible === void 0 ? false : _props$invisible, open = props.open, transitionDuration = props.transitionDuration, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $5828ccb7eba373d9$export$2e2bcd8739ae039) : _props$TransitionComp, other = (0, $eTwGP.default)(props, [
        "children",
        "classes",
        "className",
        "invisible",
        "open",
        "transitionDuration",
        "TransitionComponent"
    ]);
    return /*#__PURE__*/ $ieT14.createElement(TransitionComponent, (0, $edxsd.default)({
        in: open,
        timeout: transitionDuration
    }, other), /*#__PURE__*/ $ieT14.createElement("div", {
        className: (0, $j6s32.default)(classes.root, className, invisible && classes.invisible),
        "aria-hidden": true,
        ref: ref
    }, children));
});
var $6d93bac9e2a7a50f$export$2e2bcd8739ae039 = (0, $aIJrd.default)($6d93bac9e2a7a50f$export$9dd6ff9ea0189349, {
    name: 'MuiBackdrop'
})($6d93bac9e2a7a50f$var$Backdrop);




var $ejUtG = parcelRequire("ejUtG");

var $lwgYO = parcelRequire("lwgYO");
var $1c689a1559dbf5e9$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            '@media print': {
                // Use !important to override the Modal inline-style.
                position: 'absolute !important'
            }
        },
        /* Styles applied to the container element if `scroll="paper"`. */ scrollPaper: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        /* Styles applied to the container element if `scroll="body"`. */ scrollBody: {
            overflowY: 'auto',
            overflowX: 'hidden',
            textAlign: 'center',
            '&:after': {
                content: '""',
                display: 'inline-block',
                verticalAlign: 'middle',
                height: '100%',
                width: '0'
            }
        },
        /* Styles applied to the container element. */ container: {
            height: '100%',
            '@media print': {
                height: 'auto'
            },
            // We disable the focus ring for mouse, touch and keyboard users.
            outline: 0
        },
        /* Styles applied to the `Paper` component. */ paper: {
            margin: 32,
            position: 'relative',
            overflowY: 'auto',
            // Fix IE 11 issue, to remove at some point.
            '@media print': {
                overflowY: 'visible',
                boxShadow: 'none'
            }
        },
        /* Styles applied to the `Paper` component if `scroll="paper"`. */ paperScrollPaper: {
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'calc(100% - 64px)'
        },
        /* Styles applied to the `Paper` component if `scroll="body"`. */ paperScrollBody: {
            display: 'inline-block',
            verticalAlign: 'middle',
            textAlign: 'left' // 'initial' doesn't work on IE 11
        },
        /* Styles applied to the `Paper` component if `maxWidth=false`. */ paperWidthFalse: {
            maxWidth: 'calc(100% - 64px)'
        },
        /* Styles applied to the `Paper` component if `maxWidth="xs"`. */ paperWidthXs: {
            maxWidth: Math.max(theme.breakpoints.values.xs, 444),
            '&$paperScrollBody': (0, $9p9Gy.default)({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `maxWidth="sm"`. */ paperWidthSm: {
            maxWidth: theme.breakpoints.values.sm,
            '&$paperScrollBody': (0, $9p9Gy.default)({}, theme.breakpoints.down(theme.breakpoints.values.sm + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `maxWidth="md"`. */ paperWidthMd: {
            maxWidth: theme.breakpoints.values.md,
            '&$paperScrollBody': (0, $9p9Gy.default)({}, theme.breakpoints.down(theme.breakpoints.values.md + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `maxWidth="lg"`. */ paperWidthLg: {
            maxWidth: theme.breakpoints.values.lg,
            '&$paperScrollBody': (0, $9p9Gy.default)({}, theme.breakpoints.down(theme.breakpoints.values.lg + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `maxWidth="xl"`. */ paperWidthXl: {
            maxWidth: theme.breakpoints.values.xl,
            '&$paperScrollBody': (0, $9p9Gy.default)({}, theme.breakpoints.down(theme.breakpoints.values.xl + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `fullWidth={true}`. */ paperFullWidth: {
            width: 'calc(100% - 64px)'
        },
        /* Styles applied to the `Paper` component if `fullScreen={true}`. */ paperFullScreen: {
            margin: 0,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: 'none',
            borderRadius: 0,
            '&$paperScrollBody': {
                margin: 0,
                maxWidth: '100%'
            }
        }
    };
};
var $1c689a1559dbf5e9$var$defaultTransitionDuration = {
    enter: (0, $ejUtG.duration).enteringScreen,
    exit: (0, $ejUtG.duration).leavingScreen
};
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ var $1c689a1559dbf5e9$var$Dialog = /*#__PURE__*/ $ieT14.forwardRef(function Dialog(props, ref) {
    var BackdropProps = props.BackdropProps, children = props.children, classes = props.classes, className = props.className, _props$disableBackdro = props.disableBackdropClick, disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro, _props$disableEscapeK = props.disableEscapeKeyDown, disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK, _props$fullScreen = props.fullScreen, fullScreen = _props$fullScreen === void 0 ? false : _props$fullScreen, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$maxWidth = props.maxWidth, maxWidth = _props$maxWidth === void 0 ? 'sm' : _props$maxWidth, onBackdropClick = props.onBackdropClick, onClose = props.onClose, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onEscapeKeyDown = props.onEscapeKeyDown, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, open = props.open, _props$PaperComponent = props.PaperComponent, PaperComponent = _props$PaperComponent === void 0 ? (0, $lwgYO.default) : _props$PaperComponent, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, _props$scroll = props.scroll, scroll = _props$scroll === void 0 ? 'paper' : _props$scroll, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $5828ccb7eba373d9$export$2e2bcd8739ae039) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? $1c689a1559dbf5e9$var$defaultTransitionDuration : _props$transitionDura, TransitionProps = props.TransitionProps, ariaDescribedby = props['aria-describedby'], ariaLabelledby = props['aria-labelledby'], other = (0, $eTwGP.default)(props, [
        "BackdropProps",
        "children",
        "classes",
        "className",
        "disableBackdropClick",
        "disableEscapeKeyDown",
        "fullScreen",
        "fullWidth",
        "maxWidth",
        "onBackdropClick",
        "onClose",
        "onEnter",
        "onEntered",
        "onEntering",
        "onEscapeKeyDown",
        "onExit",
        "onExited",
        "onExiting",
        "open",
        "PaperComponent",
        "PaperProps",
        "scroll",
        "TransitionComponent",
        "transitionDuration",
        "TransitionProps",
        "aria-describedby",
        "aria-labelledby"
    ]);
    var mouseDownTarget = $ieT14.useRef();
    var handleMouseDown = function handleMouseDown(event) {
        mouseDownTarget.current = event.target;
    };
    var handleBackdropClick = function handleBackdropClick(event) {
        // Ignore the events not coming from the "backdrop"
        // We don't want to close the dialog when clicking the dialog content.
        if (event.target !== event.currentTarget) return;
         // Make sure the event starts and ends on the same DOM element.
        if (event.target !== mouseDownTarget.current) return;
        mouseDownTarget.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (!disableBackdropClick && onClose) onClose(event, 'backdropClick');
    };
    return /*#__PURE__*/ $ieT14.createElement((0, $fVNJ1.default), (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className),
        BackdropComponent: (0, $6d93bac9e2a7a50f$export$2e2bcd8739ae039),
        BackdropProps: (0, $edxsd.default)({
            transitionDuration: transitionDuration
        }, BackdropProps),
        closeAfterTransition: true
    }, disableBackdropClick ? {
        disableBackdropClick: disableBackdropClick
    } : {}, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        onEscapeKeyDown: onEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref
    }, other), /*#__PURE__*/ $ieT14.createElement(TransitionComponent, (0, $edxsd.default)({
        appear: true,
        in: open,
        timeout: transitionDuration,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited,
        role: "none presentation"
    }, TransitionProps), /*#__PURE__*/ $ieT14.createElement("div", {
        className: (0, $j6s32.default)(classes.container, classes["scroll".concat((0, $2EBFt.default)(scroll))]),
        onMouseUp: handleBackdropClick,
        onMouseDown: handleMouseDown
    }, /*#__PURE__*/ $ieT14.createElement(PaperComponent, (0, $edxsd.default)({
        elevation: 24,
        role: "dialog",
        "aria-describedby": ariaDescribedby,
        "aria-labelledby": ariaLabelledby
    }, PaperProps, {
        className: (0, $j6s32.default)(classes.paper, classes["paperScroll".concat((0, $2EBFt.default)(scroll))], classes["paperWidth".concat((0, $2EBFt.default)(String(maxWidth)))], PaperProps.className, fullScreen && classes.paperFullScreen, fullWidth && classes.paperFullWidth)
    }), children))));
});
var $1c689a1559dbf5e9$export$2e2bcd8739ae039 = (0, $aIJrd.default)($1c689a1559dbf5e9$export$9dd6ff9ea0189349, {
    name: 'MuiDialog'
})($1c689a1559dbf5e9$var$Dialog);



var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $aIJrd = parcelRequire("aIJrd");
var $881610d42277b808$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            flex: '1 1 auto',
            WebkitOverflowScrolling: 'touch',
            // Add iOS momentum scrolling.
            overflowY: 'auto',
            padding: '8px 24px',
            '&:first-child': {
                // dialog without title
                paddingTop: 20
            }
        },
        /* Styles applied to the root element if `dividers={true}`. */ dividers: {
            padding: '16px 24px',
            borderTop: "1px solid ".concat(theme.palette.divider),
            borderBottom: "1px solid ".concat(theme.palette.divider)
        }
    };
};
var $881610d42277b808$var$DialogContent = /*#__PURE__*/ $ieT14.forwardRef(function DialogContent(props, ref) {
    var classes = props.classes, className = props.className, _props$dividers = props.dividers, dividers = _props$dividers === void 0 ? false : _props$dividers, other = (0, $eTwGP.default)(props, [
        "classes",
        "className",
        "dividers"
    ]);
    return /*#__PURE__*/ $ieT14.createElement("div", (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className, dividers && classes.dividers),
        ref: ref
    }, other));
});
var $881610d42277b808$export$2e2bcd8739ae039 = (0, $aIJrd.default)($881610d42277b808$export$9dd6ff9ea0189349, {
    name: 'MuiDialogContent'
})($881610d42277b808$var$DialogContent);



const $9a2902e239ac61e9$var$ConfirmationModal = ({ open: open, closeModal: closeModal, children: children, handleOpen: handleOpen })=>{
    $ieT14.useEffect(()=>{
        if (open && handleOpen) handleOpen();
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1c689a1559dbf5e9$export$2e2bcd8739ae039), {
        className: $3ca278699d9732f8$export$518824cf31321346,
        open: open,
        onClose: closeModal,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $881610d42277b808$export$2e2bcd8739ae039), {
            children: children
        })
    });
};
var $9a2902e239ac61e9$export$2e2bcd8739ae039 = $9a2902e239ac61e9$var$ConfirmationModal;



parcelRequire("ieT14");

const $fcd3b8c5e9a7038b$var$TertiaryButton = ({ text: text, title: title, deactive: deactive, handleClick: handleClick, preventDefault: preventDefault = true })=>{
    if (deactive) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {});
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("button", {
        className: $fdbf0d9f77db804d$export$5668677bb0c0ed27,
        title: title,
        onClick: (event)=>{
            if (preventDefault) event.preventDefault();
            handleClick(event);
        },
        children: text
    });
};
var $fcd3b8c5e9a7038b$export$2e2bcd8739ae039 = $fcd3b8c5e9a7038b$var$TertiaryButton;



var $ekezX = parcelRequire("ekezX");
/**
 * A single line in the manage views state of the custom views representing a view
 */ const $13b73e03937f3214$var$EditingView = ({ viz: viz, view: view, customViews: customViews, setCustomViews: setCustomViews, otherView: otherView })=>{
    const [isEditingName, setIsEditingName] = $ieT14.useState(false);
    const [viewName, setViewName] = $ieT14.useState('');
    const [showConfirmation, setShowConfirmation] = $ieT14.useState(false);
    const [isDeleting, setIsDeleting] = $ieT14.useState(false);
    const updatePublicStatus = ()=>{
        view.raw.setAdvertised(!view.isPublic);
        view.raw.saveAsync().then(()=>{
            setCustomViews(customViews.map((cur)=>{
                if (cur.name === view.name) cur.isPublic = !view.isPublic;
                return cur;
            }));
        });
    };
    const updateViewName = ()=>{
        const newName = viewName;
        view.raw.setName(viewName);
        view.raw.saveAsync().then(()=>{
            setCustomViews(customViews.map((cur)=>{
                if (cur.name === view.name) cur.name = newName;
                return cur;
            }));
        });
        setIsEditingName(false);
        setViewName(view.name);
    };
    const updateDefault = ()=>{
        setShowConfirmation(false);
        if (!view) {
            // if this is the original view
            // Update the views state to show none as default
            const updatedViews = [
                ...customViews
            ].map((item)=>{
                item.isDefault = false;
                return item;
            });
            setCustomViews(updatedViews);
            // Reset the view to the original (null custom view), and set as default.
            viz.workbook.showCustomViewAsync(null).then(()=>{
                viz.workbook.setActiveCustomViewAsDefaultAsync();
            });
        } else {
            const updatedViews = [
                ...customViews
            ].map((item)=>{
                if (view.name === item.name) item.isDefault = true;
                else item.isDefault = false;
                return item;
            });
            setCustomViews(updatedViews);
            viz.workbook.showCustomViewAsync(view.name).then(()=>{
                viz.workbook.setActiveCustomViewAsDefaultAsync();
            });
        }
    };
    const closeModal = ()=>{
        if (deleteViews) setIsDeleting(false);
        setShowConfirmation(false);
    };
    const deleteViews = ()=>{
        view.raw.workbook.removeCustomViewAsync(view.name).then(()=>{
            const newViews = customViews.filter((item)=>view.name !== item.name);
            setCustomViews(newViews);
        });
        setShowConfirmation(false);
    };
    const renderChangeDefaultDialog = ()=>{
        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
            className: $3ca278699d9732f8$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                            className: `${$3ca278699d9732f8$export$c94ad093f18c1c8d} ${$3ca278699d9732f8$export$3099d0daead893d3}`,
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h1", {
                                children: "Confirmation"
                            })
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                            className: "body2",
                            children: "Changing the default view will automatically switch the view displaying on the screen to the selected view. Any unsaved changes may be lost. Would you like to continue?"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    className: $3ca278699d9732f8$export$dc57ddd528b7443f,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fcd3b8c5e9a7038b$export$2e2bcd8739ae039), {
                            text: "No",
                            title: "No",
                            handleClick: ()=>setShowConfirmation(false)
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $ekezX.default), {
                            className: $3ca278699d9732f8$export$7104031a6d2eee61,
                            onClick: ()=>updateDefault(),
                            children: "Yes"
                        })
                    ]
                })
            ]
        });
    };
    const renderDeleteViewDialog = ()=>{
        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
            className: $3ca278699d9732f8$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                            className: `${$3ca278699d9732f8$export$c94ad093f18c1c8d} ${$3ca278699d9732f8$export$3099d0daead893d3}`,
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h1", {
                                children: "Confirmation"
                            })
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                            className: "body2",
                            children: "The selected view will be deleted. Would you like to continue?"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    className: $3ca278699d9732f8$export$dc57ddd528b7443f,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fcd3b8c5e9a7038b$export$2e2bcd8739ae039), {
                            text: "No",
                            title: "No",
                            handleClick: ()=>setShowConfirmation(false)
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $ekezX.default), {
                            className: $3ca278699d9732f8$export$7104031a6d2eee61,
                            onClick: ()=>deleteViews(),
                            children: "Yes"
                        })
                    ]
                })
            ]
        });
    };
    /**
   * Render the 'Original' view line, showing the unmodified version of the viz
   */ if (!view) {
        const defaultExists = !!customViews.find((v)=>v.isDefault);
        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                    className: $3ca278699d9732f8$export$e54f03703dfedd34,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                        className: $3ca278699d9732f8$export$17db8f373f565f31,
                        children: [
                            !defaultExists ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                                title: "Default View",
                                icon: "insert_chart"
                            }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                                title: "Select as Default",
                                onClick: ()=>setShowConfirmation(true),
                                icon: "insert_chart_outlined"
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                children: `Original ${!defaultExists ? '(default)' : ''}`
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $9a2902e239ac61e9$export$2e2bcd8739ae039), {
                    open: showConfirmation,
                    closeModal: ()=>closeModal(),
                    children: isDeleting ? renderDeleteViewDialog() : renderChangeDefaultDialog()
                })
            ]
        });
    }
    /**
   * Render the record for a public custom view made by another user
   */ if (otherView) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                className: `${isEditingName ? $3ca278699d9732f8$export$b290296436bdde1d : ''} ${view.isDefault ? $3ca278699d9732f8$export$d727ccdbf4855090 : $3ca278699d9732f8$export$e54f03703dfedd34}`,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                        className: $3ca278699d9732f8$export$17db8f373f565f31,
                        children: [
                            view.isDefault ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                                title: "Default View",
                                icon: "insert_chart"
                            }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                                title: "Select as Default",
                                onClick: ()=>setShowConfirmation(true),
                                icon: "insert_chart_outlined"
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                children: `${view.name} ${view.name ? '(default)' : ''}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        className: $3ca278699d9732f8$export$ea3f3a5e726afb4f,
                        children: view.ownerName
                    })
                ]
            }, view.url),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $9a2902e239ac61e9$export$2e2bcd8739ae039), {
                open: showConfirmation,
                closeModal: ()=>closeModal(),
                children: isDeleting ? renderDeleteViewDialog() : renderChangeDefaultDialog()
            })
        ]
    });
    /**
   * Render the view for the user's own, fully editable custom views
   */ return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
        className: `${isEditingName ? $3ca278699d9732f8$export$b290296436bdde1d : ''} ${view.isDefault ? $3ca278699d9732f8$export$d727ccdbf4855090 : $3ca278699d9732f8$export$e54f03703dfedd34}`,
        children: [
            isEditingName ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("input", {
                        autoFocus: true,
                        onFocus: ()=>setViewName(view.name),
                        onChange: (event)=>setViewName(event.target.value),
                        onBlur: updateViewName,
                        onKeyDown: (event)=>{
                            if (event.key === 'Enter') updateViewName();
                        },
                        value: viewName
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                        title: "Close",
                        icon: "close",
                        className: $3ca278699d9732f8$export$64a53ecd158b85c4
                    })
                ]
            }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                        className: $3ca278699d9732f8$export$9a9ba550e8aeeead,
                        children: [
                            view.isDefault ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                                title: "Default View",
                                icon: "insert_chart"
                            }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                                title: "Select as Default",
                                onClick: ()=>setShowConfirmation(true),
                                icon: "insert_chart_outlined"
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                children: `${view.name} ${view.isDefault ? '(default)' : ''}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                        className: $3ca278699d9732f8$export$e0c21fe2a90ddc8e,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                                title: "Edit Name",
                                icon: "edit",
                                onClick: ()=>setIsEditingName(true)
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                                title: "Delete",
                                icon: "delete",
                                onClick: ()=>{
                                    setIsDeleting(true);
                                    setShowConfirmation(true);
                                }
                            }),
                            view.isPublic ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $9838769971a0cf86$export$2e2bcd8739ae039), {
                                width: "16",
                                height: "16",
                                handleClick: ()=>updatePublicStatus()
                            }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $c8f070500b3eefbb$export$2e2bcd8739ae039), {
                                width: "16",
                                height: "16",
                                handleClick: ()=>updatePublicStatus()
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $9a2902e239ac61e9$export$2e2bcd8739ae039), {
                open: showConfirmation,
                closeModal: ()=>closeModal(),
                children: isDeleting ? renderDeleteViewDialog() : renderChangeDefaultDialog()
            })
        ]
    }, view.url);
};
var $13b73e03937f3214$export$2e2bcd8739ae039 = $13b73e03937f3214$var$EditingView;


/**
 * @function CustomViewsModal - Modal to show custom views management tools
 */ const $9caf951882661b9f$var$CustomViewsModal = ({ open: open, onClose: onClose, viz: viz, isInteractive: isInteractive })=>{
    const [loadError, setLoadError] = $ieT14.useState(null);
    const { state: state } = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const [newViewName, setNewViewName] = $ieT14.useState('');
    const [isDefault, setIsDefault] = $ieT14.useState(false);
    const [isPublic, setIsPublic] = $ieT14.useState(false);
    const [isManaging, setIsManaging] = $ieT14.useState(false);
    const handleClose = ()=>{
        setNewViewName('');
        onClose();
    };
    const { customViews: customViews, fetchCustomViews: fetchCustomViews, setCustomViews: setCustomViews, addCustomView: addCustomView, showCustomView: showCustomView, loading: loading } = (0, $64267c560b39f1c9$export$2e2bcd8739ae039)(viz, handleClose, setLoadError);
    $ieT14.useEffect(()=>{
        if (!open) setIsManaging(false);
    }, [
        open
    ]);
    $ieT14.useEffect(()=>{
        if (isInteractive) fetchCustomViews();
    }, [
        isInteractive
    ]);
    const renderDefault = ()=>{
        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("form", {
                    className: $3ca278699d9732f8$export$7edf0cee099ff617,
                    onSubmit: (event)=>addCustomView(event, newViewName, isDefault, isPublic),
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $db32c8adf65b4dff$export$2e2bcd8739ae039), {
                            id: "outlined-view-name",
                            label: "View Name",
                            margin: "dense",
                            variant: "outlined",
                            onChange: (event)=>setNewViewName(event.target.value),
                            value: newViewName,
                            tabIndex: 1,
                            className: $3ca278699d9732f8$export$87885aa627f93324,
                            inputProps: {
                                maxLength: 1024
                            }
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $ekezX.default), {
                            type: "submit",
                            title: "Submit",
                            className: !newViewName ? $3ca278699d9732f8$export$4a94e106abcbc0a : $3ca278699d9732f8$export$d675b3969e4857cb,
                            variant: "contained",
                            color: "primary",
                            disabled: !newViewName,
                            children: "Save"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $3WBJn.default), {
                    row: true,
                    classes: {
                        root: $3ca278699d9732f8$export$bc48b8aea52cfd28
                    },
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $knRao.default), {
                            classes: {
                                root: $3ca278699d9732f8$export$b96bb35bc88d6fa
                            },
                            control: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $lamW6.default), {
                                checked: isDefault,
                                classes: {
                                    root: isDefault ? $3ca278699d9732f8$export$f77685c252cbae87 : $3ca278699d9732f8$export$b07e517d22efa1ca
                                },
                                onChange: ()=>setIsDefault((checked)=>!checked)
                            }),
                            label: "Make it my default"
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $knRao.default), {
                            classes: {
                                root: $3ca278699d9732f8$export$b96bb35bc88d6fa
                            },
                            control: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $lamW6.default), {
                                checked: isPublic,
                                classes: {
                                    root: isPublic ? $3ca278699d9732f8$export$f77685c252cbae87 : $3ca278699d9732f8$export$b07e517d22efa1ca
                                },
                                onChange: ()=>setIsPublic((checked)=>!checked)
                            }),
                            label: "Make it public"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    className: $3ca278699d9732f8$export$f4cc6fffc2da71c8,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                            className: "label2",
                            children: "My Views"
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                            className: $3ca278699d9732f8$export$a024168dd74c643c,
                            children: customViews.length > 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $29a3a2c0317f2ba3$export$2e2bcd8739ae039), {
                                customViews: customViews,
                                activeCustomView: viz.workbook.getCustomViewsAsync(),
                                showCustomView: showCustomView
                            }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                className: $3ca278699d9732f8$export$560239d3315fb15a,
                                style: {
                                    margin: 'auto'
                                },
                                children: "Nothing Saved Yet"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    className: $3ca278699d9732f8$export$ba184d72a832ebdd,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                            className: "label2",
                            children: "Other Views"
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                            className: $3ca278699d9732f8$export$a024168dd74c643c,
                            children: customViews.length > 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $de1948d1e3a5d855$export$2e2bcd8739ae039), {
                                customViews: customViews,
                                activeCustomView: viz.workbook.getCustomViewsAsync(),
                                showCustomView: showCustomView
                            }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                className: $3ca278699d9732f8$export$560239d3315fb15a,
                                style: {
                                    margin: 'auto'
                                },
                                children: "Nothing Saved Yet"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $ekezX.default), {
                    className: customViews.length > 0 ? $3ca278699d9732f8$export$d992296b9a725e45 : $3ca278699d9732f8$export$4d0a1940c7ed2b3e,
                    disabled: customViews.length === 0,
                    color: "primary",
                    variant: "contained",
                    onClick: ()=>setIsManaging(true),
                    children: "Manage"
                })
            ]
        });
    };
    const renderManageViews = ()=>{
        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    className: $3ca278699d9732f8$export$c5a00ecdf4d56b76,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                            className: $3ca278699d9732f8$export$d21ccd67febca1fc,
                            children: "Manage"
                        }),
                        customViews.length > 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $5d10f0a7aadd7c8c$exports.Scrollbars), {
                            className: $3ca278699d9732f8$export$200ac3d1223040f0,
                            autoHide: true,
                            children: customViews.map((view)=>{
                                if (state.email.toLowerCase() === view.ownerEmail) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $13b73e03937f3214$export$2e2bcd8739ae039), {
                                    viz: viz,
                                    view: view,
                                    customViews: customViews,
                                    otherView: false,
                                    setCustomViews: setCustomViews
                                }, view.name);
                            })
                        }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                            className: $3ca278699d9732f8$export$560239d3315fb15a,
                            style: {
                                margin: 'auto'
                            },
                            children: "Nothing Saved Yet"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    className: $3ca278699d9732f8$export$c5a00ecdf4d56b76,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                            className: $3ca278699d9732f8$export$d21ccd67febca1fc,
                            children: "Other Views"
                        }),
                        customViews.length > 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $5d10f0a7aadd7c8c$exports.Scrollbars), {
                            className: $3ca278699d9732f8$export$d2dcf3aefcbb6de8,
                            autoHide: true,
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $13b73e03937f3214$export$2e2bcd8739ae039), {
                                        viz: viz,
                                        customViews: customViews,
                                        otherView: true,
                                        setCustomViews: setCustomViews
                                    }),
                                    customViews.map((view)=>{
                                        if (view.isPublic && state.email.toLowerCase() !== view.ownerEmail) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $13b73e03937f3214$export$2e2bcd8739ae039), {
                                            viz: viz,
                                            view: view,
                                            customViews: customViews,
                                            otherView: true,
                                            setCustomViews: setCustomViews
                                        }, view.name);
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                            className: $3ca278699d9732f8$export$560239d3315fb15a,
                            style: {
                                margin: 'auto'
                            },
                            children: "Nothing Saved Yet"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $ekezX.default), {
                    className: $3ca278699d9732f8$export$d992296b9a725e45,
                    variant: "contained",
                    color: "primary",
                    onClick: ()=>setIsManaging(false),
                    children: "Done"
                })
            ]
        });
    };
    const renderContent = ()=>{
        if (loading) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
            className: $3ca278699d9732f8$export$9b1610f4cf001bb8,
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
        });
        else if (loadError) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
            className: $3ca278699d9732f8$export$7a85a8b07d5c2548,
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("p", {
                className: $3ca278699d9732f8$export$df2f46e3a734d408,
                children: loadError
            })
        });
        else if (isManaging) return renderManageViews();
        return renderDefault();
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fVNJ1.default), {
        className: $3ca278699d9732f8$export$94d09fb989a9df2e,
        open: open,
        onClose: handleClose,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
            className: $3ca278699d9732f8$export$a7dabb172976b078,
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    className: $3ca278699d9732f8$export$3099d0daead893d3,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h1", {
                            children: "Custom Views"
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                            icon: "close",
                            title: "Close",
                            className: $3ca278699d9732f8$export$8360e631d277ea4d,
                            onClick: handleClose
                        })
                    ]
                }),
                renderContent()
            ]
        })
    });
};
var $9caf951882661b9f$export$2e2bcd8739ae039 = $9caf951882661b9f$var$CustomViewsModal;




var $1KcBP = parcelRequire("1KcBP");

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $a7b778f1b6f74005$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z"
}), 'CropOriginal');



/**
 * Render the Custom Views Button and associated Modal components
 */ const $f9fba2702e463b3f$var$CustomViewsButton = ({ viz: viz, dashboardName: dashboardName, isInteractive: isInteractive, edge: edge })=>{
    const [showModal, setShowModal] = $ieT14.useState(false);
    const [currentViewName, setCurrentViewName] = $ieT14.useState('Original');
    function handleClick() {
        (0, $80940237791545d7$export$65cc181beb0d2632).addUserAction('views', {
            user_action_details: {
                type: 'tableau_toolbar',
                name: 'views',
                dashboard_name: dashboardName
            }
        });
        if (viz) setShowModal(true);
    }
    $ieT14.useEffect(()=>{
        if (viz && isInteractive && viz.workbook) setCurrentViewName(viz.workbook.name);
    }, [
        viz,
        isInteractive
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $9caf951882661b9f$export$2e2bcd8739ae039), {
                open: showModal,
                onClose: ()=>setShowModal(false),
                viz: viz,
                isInteractive: isInteractive
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $e5cb3fdcda0cefc7$export$2e2bcd8739ae039), {
                title: `View ${currentViewName}`,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                    onClick: handleClick,
                    edge: edge || false,
                    size: "small",
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $a7b778f1b6f74005$export$2e2bcd8739ae039), {})
                })
            })
        ]
    });
};
var $f9fba2702e463b3f$export$2e2bcd8739ae039 = $f9fba2702e463b3f$var$CustomViewsButton;


/**
 * @function ReportToolbar - Component for buttons for Tableau functions
 */ const $103d1cdb190551d2$var$ReportToolbar = ({ documents: documents, viz: viz, container: container, isInteractive: isInteractive, reportName: reportName })=>{
    const [showModal, setShowModal] = $ieT14.useState(false);
    const [fullScreen, setFullScreen] = $ieT14.useState(false);
    const initialShowModal = $ieT14.useRef(true);
    const initialFullScreen = $ieT14.useRef(true);
    $ieT14.useEffect(()=>{
        /** Adds event listener to detect full screen mode */ window.addEventListener('fullscreenchange', ()=>// @ts-ignore - webkitFullscreenElement for Edge only
            setFullScreen(!!document.fullscreenElement || !!document.webkitFullscreenElement));
    }, []);
    const altHelpClick = ()=>{
        setShowModal((show)=>!show);
        (0, $80940237791545d7$export$65cc181beb0d2632).addUserAction('help', {
            user_action_details: {
                type: 'tableau_toolbar',
                name: 'help',
                modal_state: 'open',
                dashboard_name: reportName
            }
        });
    };
    $ieT14.useEffect(()=>{
        if (initialShowModal.current) initialShowModal.current = false;
        else if (showModal == false) (0, $80940237791545d7$export$65cc181beb0d2632).addUserAction('help', {
            user_action_details: {
                type: 'tableau_toolbar',
                name: 'help',
                modal_state: 'closed',
                dashboard_name: reportName
            }
        });
    }, [
        showModal
    ]);
    $ieT14.useEffect(()=>{
        if (initialFullScreen.current) initialShowModal.current = false;
        else (0, $80940237791545d7$export$65cc181beb0d2632).addUserAction('fullscreen_toggle', {
            user_action_details: {
                type: 'tableau_toolbar',
                name: 'fullscreen_toggle',
                isFullscreen: fullScreen,
                dashboard_name: reportName
            }
        });
    }, [
        fullScreen
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: fullScreen ? $3ca278699d9732f8$export$53b3a6aacbedbca0 : $3ca278699d9732f8$export$f727f52c778e92d5,
        children: [
            showModal && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $cb9fc5b960fafc31$export$2e2bcd8739ae039), {
                open: showModal,
                allDocuments: documents,
                onClose: (show)=>setShowModal(show)
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $3ca278699d9732f8$export$935e8e660c24322,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8bfb54caced96889$export$2e2bcd8739ae039), {
                        viz: viz,
                        dashboardName: reportName,
                        type: (0, $7fec86fc4dd1b2fd$export$2e2bcd8739ae039).Undo,
                        edge: "start"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8bfb54caced96889$export$2e2bcd8739ae039), {
                        viz: viz,
                        dashboardName: reportName,
                        type: (0, $7fec86fc4dd1b2fd$export$2e2bcd8739ae039).Redo
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8bfb54caced96889$export$2e2bcd8739ae039), {
                        viz: viz,
                        dashboardName: reportName,
                        type: (0, $7fec86fc4dd1b2fd$export$2e2bcd8739ae039).Revert
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8bfb54caced96889$export$2e2bcd8739ae039), {
                        viz: viz,
                        dashboardName: reportName,
                        type: (0, $7fec86fc4dd1b2fd$export$2e2bcd8739ae039).Pause
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $3ca278699d9732f8$export$bd3b1236bac3ee14,
                children: [
                    documents.length > 0 && !fullScreen && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $e5cb3fdcda0cefc7$export$2e2bcd8739ae039), {
                        title: "Help",
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                            onClick: altHelpClick,
                            className: $3ca278699d9732f8$export$34512e3b2db52a4e,
                            size: "small",
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f3d3f58d1fb88d8a$export$2e2bcd8739ae039), {})
                        })
                    }),
                    !fullScreen && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f9fba2702e463b3f$export$2e2bcd8739ae039), {
                        viz: viz,
                        dashboardName: reportName,
                        isInteractive: isInteractive,
                        edge: false
                    }),
                    !fullScreen && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8bfb54caced96889$export$2e2bcd8739ae039), {
                        viz: viz,
                        dashboardName: reportName,
                        type: (0, $7fec86fc4dd1b2fd$export$2e2bcd8739ae039).Export
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8bfb54caced96889$export$2e2bcd8739ae039), {
                        viz: viz,
                        dashboardName: reportName,
                        type: (0, $7fec86fc4dd1b2fd$export$2e2bcd8739ae039).Maximize,
                        fullScreen: fullScreen,
                        container: container,
                        edge: "end"
                    })
                ]
            })
        ]
    });
};
var $103d1cdb190551d2$export$2e2bcd8739ae039 = $103d1cdb190551d2$var$ReportToolbar;



/**
 * Component to render the tableau toolbar and a container for the viz iframe, and initialize the viz
 */ const $958f5352742cf028$var$TableauReport = ({ url: url, documents: documents, options: options, isInteractive: isInteractive, viz: viz, setViz: setViz, reportMeta: reportMeta, tableauToken: tableauToken })=>{
    const [fullscreen, setFullscreen] = $ieT14.useState(false);
    const reportRef = $ieT14.useRef(null);
    $ieT14.useEffect(()=>{
        if (viz === null) initTableau();
        const handleFullscreen = ()=>setFullscreen(!!document.fullscreenElement);
        /** Adds event listener to detect full screen mode */ window.addEventListener('fullscreenchange', handleFullscreen);
        return function cleanup() {
            window.removeEventListener('fullscreenchange', handleFullscreen);
        };
    }, []);
    const initTableau = ()=>{
        // In case tableau has yet to bind to the window, set a timer for this function to re-run
        if (document.getElementById('tableau-viz') === undefined) {
            setTimeout(()=>{
                initTableau();
            }, 100);
            return;
        }
        setViz(document.getElementById('tableau-viz'));
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        ref: reportRef,
        className: fullscreen ? $3ca278699d9732f8$export$c54b09e010026594 : '',
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $103d1cdb190551d2$export$2e2bcd8739ae039), {
                viz: viz,
                documents: documents,
                container: reportRef && reportRef.current,
                isInteractive: isInteractive,
                reportName: reportMeta.name
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                style: {
                    height: 'calc(100vh - 37px)',
                    minHeight: fullscreen ? 'calc(100vh - 37px)' : 'calc(100vh - 200px)'
                },
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("tableau-viz", {
                    id: "tableau-viz",
                    src: url,
                    token: tableauToken.token,
                    width: "100vw",
                    height: "100vh",
                    toolbar: "hidden"
                })
            })
        ]
    });
};
var $958f5352742cf028$export$2e2bcd8739ae039 = $958f5352742cf028$var$TableauReport;





var $ieT14 = parcelRequire("ieT14");

var $3umuy = parcelRequire("3umuy");



var $eYoAG = parcelRequire("eYoAG");

/**
 * Custom hook which retrieves report data and report help documents
 *
 * @param clientId current client id
 * @param reportId id of the current report (from useParams)
 */ const $ec715403b1ec9999$var$useReports = (clientId, reportId)=>{
    const appContext = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { getAuth: getAuth } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    const [loading, setLoading] = $ieT14.useState(true);
    const [report, setReport] = $ieT14.useState(null);
    const [documents, setDocuments] = $ieT14.useState([]);
    const [lastUpdateDates, setLastUpdateDates] = $ieT14.useState([]);
    const history = (0, $eYoAG.useHistory)();
    /** on load, get help docs, report data and latest update dates */ $ieT14.useEffect(()=>{
        if (appContext.state.clientChanging) history.replace((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Home, {
            redirect: true
        });
        let isMounted = true;
        Promise.all([
            fetchHelpDocuments(),
            fetchReport()
        ]).then(([documents, report])=>{
            if (isMounted) {
                if (!report || report.reportId === 0 || report.reportContentViewModels === null) history.replace('/', {
                    error: 'Report not found for the current client'
                });
                else {
                    setDocuments(documents);
                    setReport(report);
                    /** fetch lastUpdateDates once the report name is available */ fetchLastUpdates(report.name).then((lastUpdateDates)=>{
                        if (isMounted) {
                            setLastUpdateDates(lastUpdateDates);
                            setLoading(false);
                        }
                    }).catch((e)=>{
                        setLoading(false);
                        console.log(e);
                    });
                }
            }
        }).catch((err)=>{
            setLoading(false);
            console.log(err);
        });
        return function cleanup() {
            isMounted = false;
        };
    }, []);
    const fetchReport = ()=>{
        return getAuth(`api/${clientId}/reports/${reportId}`);
    };
    const fetchLastUpdates = (dashboardName)=>{
        return getAuth(`api/${clientId}/reports/${reportId}/last-update-dates?dashboard=${dashboardName}`).then((dates)=>{
            if (dates && dates.length > 0) {
                let sorted = [
                    ...dates
                ].sort((a, b)=>a.LastUpdated >= b.LastUpdated ? 1 : -1);
                return sorted.map((date)=>{
                    return {
                        ...date,
                        LastUpdated: (0, (/*@__PURE__*/$parcel$interopDefault($3umuy)))(date.LastUpdated).format('L, h:mm:ss a').replace(/,/g, '')
                    };
                });
            }
            return [];
        });
    };
    const fetchHelpDocuments = ()=>{
        return getAuth(`api/${clientId}/reports/${reportId}/help`);
    };
    const refreshLastUpdate = ()=>{
        if (report) fetchLastUpdates(report.name).then((lastUpdateDates)=>setLastUpdateDates(lastUpdateDates)).catch((e)=>{
            console.log(e);
        });
    };
    return {
        loading: loading,
        report: report,
        documents: documents,
        lastUpdateDates: lastUpdateDates,
        refreshLastUpdate: refreshLastUpdate
    };
};
var $ec715403b1ec9999$export$2e2bcd8739ae039 = $ec715403b1ec9999$var$useReports;



const $8d9b7ae75d0d373c$var$useTableau = (clientId)=>{
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    const fetchTableauToken = ()=>{
        return fetchWrapper(`api/token/${clientId}/tableau`).catch((error)=>error);
    };
    return {
        fetchTableauToken: fetchTableauToken
    };
};
var $8d9b7ae75d0d373c$export$2e2bcd8739ae039 = $8d9b7ae75d0d373c$var$useTableau;


/**
 * @function InfoTooltip - Tooltip that displays last updated information
 */ const $07c15c32a1a1f15e$var$InfoTooltip = (0, $aIJrd.default)(()=>({
        tooltip: {
            backgroundColor: 'white',
            color: 'black',
            borderRadius: '4px',
            boxShadow: '0 2px 3px 1px rgba(0, 0, 0, 0.25)',
            maxWidth: '550px'
        }
    }))((0, $356Vi.default));
const $07c15c32a1a1f15e$var$tooltipStyles = {
    tooltipLine: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontFamily: 'Helvetica',
        fontSize: '12px',
        fontWeight: 300,
        margin: '5px 8px'
    },
    date: {
        fontWeight: 400,
        marginLeft: '7px'
    }
};
/**
 * Component to render a Tableau report view
 */ const $07c15c32a1a1f15e$var$Report = ({ clientId: clientId, ...rest })=>{
    const history = (0, $eYoAG.useHistory)();
    const { reportId: reportId } = (0, $eYoAG.useParams)();
    const { loading: loading, report: report, lastUpdateDates: lastUpdateDates, documents: documents, refreshLastUpdate: refreshLastUpdate } = (0, $ec715403b1ec9999$export$2e2bcd8739ae039)(clientId, reportId);
    const [viz, setViz] = $ieT14.useState(null);
    const [isInteractive, setIsInteractive] = $ieT14.useState(false);
    const clientRef = $ieT14.useRef(clientId);
    const { fetchTableauToken: fetchTableauToken } = (0, $8d9b7ae75d0d373c$export$2e2bcd8739ae039)(clientId);
    const [tableauToken, setTableauToken] = $ieT14.useState(undefined);
    const [fetchingToken, setFetchingToken] = $ieT14.useState(true);
    const options = {
        width: '100%',
        height: '100%',
        hideToolbar: 'true',
        onFirstInteractive: ()=>setIsInteractive(true)
    };
    $ieT14.useEffect(()=>{
        fetchTableauToken().then((response)=>{
            setTableauToken(response);
        }).finally(()=>setFetchingToken(false));
    }, []);
    $ieT14.useEffect(()=>{
        /** Redirect home if user selects different client */ if (clientRef.current != clientId) history.replace((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Home, {
            redirect: true
        });
    }, [
        clientId
    ]);
    const checkInteractive = ()=>{
        setIsInteractive(true);
    };
    $ieT14.useEffect(()=>{
        if (viz) viz.addEventListener('firstinteractive', checkInteractive);
    }, [
        viz
    ]);
    function renderDates() {
        return lastUpdateDates.length > 0 && lastUpdateDates.map((item, index)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                style: $07c15c32a1a1f15e$var$tooltipStyles.tooltipLine,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                        children: [
                            item.Label,
                            ": "
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        style: $07c15c32a1a1f15e$var$tooltipStyles.date,
                        children: item.LastUpdated
                    })
                ]
            }, `last-update-${index}`));
    }
    const urlText = report?.reportContentViewModels[0].children[0].desktop;
    const breadcrumbs = [
        {
            title: (0, $e3b999dd4e075081$export$2e2bcd8739ae039).Dashboard,
            path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Reports
        }
    ];
    function renderToolbar() {
        if (!report) return null;
        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $0cc2bc53567db499$export$2e2bcd8739ae039), {
                    breadcrumbs: breadcrumbs,
                    currentPage: report.name
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    className: $3ca278699d9732f8$export$84269455d6cf34e1,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                            onClick: ()=>refreshLastUpdate(),
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8bfb54caced96889$export$2e2bcd8739ae039), {
                                viz: viz,
                                dashboardName: report.name,
                                type: (0, $7fec86fc4dd1b2fd$export$2e2bcd8739ae039).Refresh,
                                edge: "end"
                            })
                        }),
                        lastUpdateDates && lastUpdateDates.length > 0 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                                    className: $3ca278699d9732f8$export$1a4a45da1798e276,
                                    children: [
                                        "Last update:",
                                        ' ',
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                            className: $3ca278699d9732f8$export$324d90190a8b822a,
                                            children: lastUpdateDates.length > 0 && lastUpdateDates[0].LastUpdated
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($07c15c32a1a1f15e$var$InfoTooltip, {
                                    title: renderDates(),
                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($584968587d5f8f62$exports))), {
                                        htmlColor: "#006da8"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $3ca278699d9732f8$export$f18d5b0af29128b7,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $3ca278699d9732f8$export$38e42c68cf43b5d4,
                children: loading || fetchingToken ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: $3ca278699d9732f8$export$46c1c92549715335,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
                }) : renderToolbar()
            }),
            !loading && tableauToken?.token && report && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $958f5352742cf028$export$2e2bcd8739ae039), {
                documents: documents,
                url: urlText,
                options: options,
                viz: viz,
                setViz: setViz,
                isInteractive: isInteractive,
                reportMeta: report,
                tableauToken: tableauToken
            })
        ]
    });
};
var $07c15c32a1a1f15e$export$2e2bcd8739ae039 = $07c15c32a1a1f15e$var$Report;




var $ieT14 = parcelRequire("ieT14");



var $ieT14 = parcelRequire("ieT14");



var $ieT14 = parcelRequire("ieT14");



var $ieT14 = parcelRequire("ieT14");


var $6mt9R = parcelRequire("6mt9R");



var $j6s32 = parcelRequire("j6s32");

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $b671d56ea25e8fed$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
}), 'KeyboardArrowDown');



var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");


var $aIJrd = parcelRequire("aIJrd");

var $2EBFt = parcelRequire("2EBFt");
var $711f256e1d9605c8$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            userSelect: 'none',
            fontSize: theme.typography.pxToRem(24),
            width: '1em',
            height: '1em',
            // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
            // To remove at some point.
            overflow: 'hidden',
            flexShrink: 0
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="action"`. */ colorAction: {
            color: theme.palette.action.active
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `color="disabled"`. */ colorDisabled: {
            color: theme.palette.action.disabled
        },
        /* Styles applied to the root element if `fontSize="inherit"`. */ fontSizeInherit: {
            fontSize: 'inherit'
        },
        /* Styles applied to the root element if `fontSize="small"`. */ fontSizeSmall: {
            fontSize: theme.typography.pxToRem(20)
        },
        /* Styles applied to the root element if `fontSize="large"`. */ fontSizeLarge: {
            fontSize: theme.typography.pxToRem(36)
        }
    };
};
var $711f256e1d9605c8$var$Icon = /*#__PURE__*/ $ieT14.forwardRef(function Icon(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'inherit' : _props$color, _props$component = props.component, Component = _props$component === void 0 ? 'span' : _props$component, _props$fontSize = props.fontSize, fontSize = _props$fontSize === void 0 ? 'medium' : _props$fontSize, other = (0, $eTwGP.default)(props, [
        "classes",
        "className",
        "color",
        "component",
        "fontSize"
    ]);
    return /*#__PURE__*/ $ieT14.createElement(Component, (0, $edxsd.default)({
        className: (0, $j6s32.default)('material-icons', classes.root, className, color !== 'inherit' && classes["color".concat((0, $2EBFt.default)(color))], fontSize !== 'default' && fontSize !== 'medium' && classes["fontSize".concat((0, $2EBFt.default)(fontSize))]),
        "aria-hidden": true,
        ref: ref
    }, other));
});
$711f256e1d9605c8$var$Icon.muiName = 'Icon';
var $711f256e1d9605c8$export$2e2bcd8739ae039 = (0, $aIJrd.default)($711f256e1d9605c8$export$9dd6ff9ea0189349, {
    name: 'MuiIcon'
})($711f256e1d9605c8$var$Icon);


/**
 * Panel
 * @function Panel - Individual panel for the left toolbar of the Help Screen
 */ const $0f6d7c11fe66653c$var$Panel = ({ parentDocument: parentDocument, documents: documents, margin: margin, activeDocument: activeDocument, setActiveDocument: setActiveDocument, setIsSearching: setIsSearching })=>{
    const [isOpen, setIsOpen] = $ieT14.useState(true);
    const { changeActiveDoc: changeActiveDoc, renderChildren: renderChildren, getChildDocsToRender: getChildDocsToRender, isActiveDoc: isActiveDoc, isTopLevelDoc: isTopLevelDoc } = (0, $dfbf579bea9f90b3$export$2e2bcd8739ae039)();
    /** @const childDocs - Array of the current documents children */ const childDocs = documents.filter((document)=>document.parentGroupId === parentDocument.snippetGroupId);
    let activeDocs = [];
    const selectedDocument = documents.find((doc)=>doc.snippetGroupId === activeDocument);
    if (selectedDocument) {
        let currentDocument = selectedDocument;
        // Runs until root document is found
        while(currentDocument.parentGroupId !== 0){
            currentDocument = documents.find((doc)=>doc.snippetGroupId === currentDocument.parentGroupId);
            if (currentDocument === undefined) {
                currentDocument = selectedDocument;
                break;
            }
        }
        activeDocs = getChildDocsToRender(documents, currentDocument, [
            currentDocument
        ]);
    }
    const isActive = isActiveDoc(parentDocument, activeDocs);
    const topLevelDoc = isTopLevelDoc(parentDocument);
    // Returns current document and child documents if child documents exist
    if (childDocs.length > 0) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: (0, $j6s32.default)($2b36415f25d48604$export$86b4c3062752a703, !isOpen && $2b36415f25d48604$export$9445a6ed6a41ad3f),
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: (0, $j6s32.default)($2b36415f25d48604$export$91124bb58bc04465, isActive && $2b36415f25d48604$export$89da14300d534261, topLevelDoc && $2b36415f25d48604$export$7e04648e6944ee4b),
                style: {
                    paddingLeft: margin
                },
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    className: $2b36415f25d48604$export$8dbb6aba9913d6e1,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $711f256e1d9605c8$export$2e2bcd8739ae039), {
                            className: $2b36415f25d48604$export$7fdff3da760639fa,
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $b671d56ea25e8fed$export$2e2bcd8739ae039), {
                                onClick: ()=>setIsOpen((open)=>!open)
                            })
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6mt9R.NavLink), {
                            to: {
                                pathname: `${(0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Help}/${parentDocument.snippetGroupId}`,
                                state: {
                                    id: parentDocument.snippetGroupId
                                }
                            },
                            onClick: ()=>setIsSearching(false),
                            isActive: (param, location)=>changeActiveDoc(param, location, parentDocument.snippetGroupId, setActiveDocument),
                            className: (0, $j6s32.default)($2b36415f25d48604$export$6ee01cf16d42268d, isActive && $2b36415f25d48604$export$22fde7aa351e938b),
                            children: parentDocument.title
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $2b36415f25d48604$export$bacb5cc5a11aef16,
                children: renderChildren(childDocs, margin, documents, activeDocument, setActiveDocument, setIsSearching)
            })
        ]
    });
    // Returns if document has no more children
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        className: (0, $j6s32.default)($2b36415f25d48604$export$d254041e5e1db576, isActive && $2b36415f25d48604$export$89da14300d534261, topLevelDoc && $2b36415f25d48604$export$7e04648e6944ee4b),
        style: {
            paddingLeft: margin
        },
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6mt9R.NavLink), {
            to: {
                pathname: `${(0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Help}/${parentDocument.snippetGroupId}`,
                state: {
                    id: parentDocument.snippetGroupId
                }
            },
            onClick: ()=>setIsSearching(false),
            isActive: (param, location)=>changeActiveDoc(param, location, parentDocument.snippetGroupId, setActiveDocument),
            className: (0, $j6s32.default)($2b36415f25d48604$export$6ee01cf16d42268d, isActive && $2b36415f25d48604$export$22fde7aa351e938b),
            children: parentDocument.title
        })
    });
};
var $0f6d7c11fe66653c$export$2e2bcd8739ae039 = $0f6d7c11fe66653c$var$Panel;




var $6mt9R = parcelRequire("6mt9R");




var $fRnKy = parcelRequire("fRnKy");
/**
 * useHelp
 * @function useHelp - Custom hook for the help page
 */ const $dfbf579bea9f90b3$var$useHelp = ()=>{
    const [loading, setLoading] = $ieT14.useState(false);
    const [documents, setDocuments] = $ieT14.useState([]);
    const [activeDocument, setActiveDocument] = $ieT14.useState(-1);
    const { getAuth: getAuth, postAuth: postAuth, putAuth: putAuth, deleteAuth: deleteAuth } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    /**
   * fetchHelpDocuments
   * @function fetchHelpDocuments - Fetches the help documents from the backend and sets them to the state
   * @param clientId Id of the active client
   */ const fetchHelpDocuments = (clientId)=>{
        setLoading(true);
        getHelpDocuments(clientId).then((documentsArray)=>{
            setLoading(false);
            setDocuments(documentsArray);
        }).catch(()=>setLoading(false));
    };
    /**
   * changeActiveDoc
   * @function changeActiveDoc - Changes the active document and checks if it matches the current document
   * @param params Parameters from the nav-link
   * @param location Location parameters from the nav-link
   * @param activeDoc Id of the document that the user selected
   */ const changeActiveDoc = (params, location, activeDoc, updateActiveDoc)=>{
        if (params && location.state) {
            if (activeDoc === location.state.id) {
                updateActiveDoc(activeDoc);
                return true;
            }
            if (!location.state.id) return false;
        }
    };
    /**
   * renderChildren
   * @function renderChildren - Renders child panels for the table of contents
   * @param childDocs Children documents from the parent document
   * @param margin Margin for the panel
   * @param allDocs An array of all help documents
   * @param activeDoc Id of the document that the user selected
   * @param updateActiveDoc - Function to update the active document
   * @param setIsSearching Function to indicate whether the user is currently searching or not
   */ const renderChildren = (childDocs, margin, allDocs, activeDoc, updateActiveDoc, setIsSearching)=>{
        return childDocs.map((doc)=>{
            return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $0f6d7c11fe66653c$export$2e2bcd8739ae039), {
                parentDocument: doc,
                documents: allDocs,
                margin: margin + 20,
                activeDocument: activeDoc,
                setActiveDocument: (doc)=>updateActiveDoc(doc),
                setIsSearching: setIsSearching
            }, `help-doc-${doc.snippetGroupId}`);
        });
    };
    /**
   * renderHelpContent
   * @function renderHelpContent - Renders the help documents
   * @param allDocuments Array of all help documents
   * @param activeDoc ID of document selected by the user
   * @returns Array of JSX elements to render the help document contents
   */ const renderHelpContent = (allDocuments, activeDoc)=>{
        if (allDocuments) {
            const selectedDocument = allDocuments.find((doc)=>doc.snippetGroupId === activeDoc);
            if (selectedDocument) {
                let currentDocument = selectedDocument;
                // Runs until root document is found
                while(currentDocument.parentGroupId !== 0){
                    currentDocument = allDocuments.find((doc)=>doc.snippetGroupId === currentDocument.parentGroupId);
                    if (currentDocument === undefined) return;
                }
                const children = getChildDocsToRender(allDocuments, currentDocument, [
                    currentDocument
                ]);
                (0, $80940237791545d7$export$65cc181beb0d2632).addRumGlobalContext('help', {
                    group_title: children[0].title,
                    selected_doc: children.find((child)=>child.snippetGroupId === activeDoc).title
                });
                return children.map((doc, index)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1690831c660b35f6$export$2e2bcd8739ae039), {
                        document: doc,
                        activeDoc: activeDoc
                    }, `help-doc-${doc.snippetGroupId}`));
            }
        }
    };
    /**
   * renderSidePanel
   * @function renderSidePanel - Renders the side panel for user to select a document
   * @param allDocuments An array of all the help documents
   * @param setIsSearching Function to indicate whether the user is currently searching or not
   * @returns Array of JSX elements to render the side panels
   */ const renderSidePanel = (allDocuments, setIsSearching)=>{
        /** @const rootDocuments - Documents at the top of the tree */ const rootDocuments = allDocuments.filter((doc)=>isParent(doc) && !isChild(doc));
        /** @const tree - Array of JSX elements to be rendered for the side panel  */ const tree = rootDocuments.map((rootDocument)=>{
            return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $0f6d7c11fe66653c$export$2e2bcd8739ae039), {
                parentDocument: rootDocument,
                documents: allDocuments,
                margin: 0,
                activeDocument: activeDocument,
                setActiveDocument: (doc)=>setActiveDocument(doc),
                setIsSearching: setIsSearching
            }, `table-of-contents-${rootDocument.snippetGroupId}`);
        });
        return tree;
    };
    /**
   * @function renderPreviews - Renders the preview for documents while searching
   * @param searchQuery The search query the user typed into the search bar
   * @param isSearching Boolean indicating whether or not the user is currently searching
   * @param allDocs An array of all documents
   * @param setIsSearching Function to indicate whether the user is currently searching or not
   * @returns An array of JSX elements with the preview of the documents
   */ const renderPreviews = (searchQuery, isSearching, allDocs, setIsSearching)=>{
        if (!isSearching) return;
        /** @const regex - Regex that uses the search query and an ignore case modifier */ const regex = RegExp(searchQuery, 'i');
        /** @const docsToPreview - Array of documents where either the title or the content match the search query */ const docsToPreview = allDocs.filter((doc)=>regex.test(doc.title) || regex.test(doc.content));
        if (docsToPreview.length === 0) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
            children: "No Matching Documents"
        });
        return docsToPreview.map((doc, index)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $6mt9R.NavLink), {
                className: $2b36415f25d48604$export$8aade8ce2b5d7e87,
                onClick: ()=>setIsSearching(false),
                to: {
                    pathname: `${(0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Help}/${doc.snippetGroupId}`,
                    state: {
                        id: doc.snippetGroupId
                    }
                },
                isActive: (param, location)=>{
                    return changeActiveDoc(param, location, doc.snippetGroupId, setActiveDocument);
                },
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        children: doc.title
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: $2b36415f25d48604$export$48c2d0f2f545ac27,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1690831c660b35f6$export$2e2bcd8739ae039), {
                            document: doc,
                            activeDoc: 0
                        }, `help-doc-${doc.snippetGroupId}`)
                    })
                ]
            }, `help-preview-${doc.snippetGroupId}`));
    };
    /**
   * getHelpDocuments
   * @method getHelpDocuments - API call to receive the help documents
   * @param clientId - ID of the client
   */ const getHelpDocuments = (clientId)=>{
        return getAuth(`api/clients/${clientId}/help-documents`).then((json)=>{
            if (json.error) throw json.error;
            return json;
        });
    };
    /**
   * getGlobalHelpDocuments
   * @method getGlobalHelpDocuments - API call to receive the global help documents
   */ const getGlobalHelpDocuments = ()=>{
        return getAuth(`api/help-documents`).then((json)=>{
            if (json.error) throw json.error;
            return json;
        });
    };
    /**
   * API call to update the sort order of the client help documents
   * @param clientId ID of the client who's documents will be updated
   * @param snippetGroupId The identifier of the document that will be updated
   * @param newParentGroupId The identifier of the parent document that it will be moved to
   * @param sourceGroupIds All the children and subchildren, along with the selected document, of the document that was moved
   * @param destinationGroupId The identifier of the next document in the list
   */ const updateClientHelpDocumentsSortOrder = (clientId, snippetGroupId, newParentGroupId, sourceGroupIds, destinationGroupId)=>{
        return putAuth(`api/clients/${clientId}/help-documents`, {
            snippetGroupId: snippetGroupId,
            newParentGroupId: newParentGroupId,
            sourceGroupIds: sourceGroupIds,
            destinationGroupId: destinationGroupId
        }).then((json)=>{
            if (json.error) throw json.error;
            return json;
        }).catch((error)=>{
            throw error;
        });
    };
    /**
   * API call to update the sort order of the global help documents
   * @param snippetGroupId The identifier of the document that will be updated
   * @param newParentGroupId The identifier of the parent document that it will be moved to
   * @param sourceGroupIds All the children and subchildren, along with the selected document, of the document that was moved
   * @param destinationGroupId The identifier of the next document in the list
   */ const updateGlobalHelpDocumentsSortOrder = (snippetGroupId, newParentGroupId, sourceGroupIds, destinationGroupId)=>{
        return putAuth(`api/help-documents`, {
            snippetGroupId: snippetGroupId,
            newParentGroupId: newParentGroupId,
            sourceGroupIds: sourceGroupIds,
            destinationGroupId: destinationGroupId
        }).then((json)=>{
            if (json.error) throw json.error;
            return json;
        }).catch((error)=>{
            throw error;
        });
    };
    /**
   * API call to receive help documents with the latest revisions
   * @param clientId - Identifier of the client who's documents we are retrieving
   */ const getLatestHelpDocuments = (clientId)=>{
        return getAuth(`api/clients/${clientId}/help-documents/latest-revisions`).then((json)=>{
            if (json.error) throw json.error;
            return json;
        });
    };
    /**
   * API call to delete a global help document
   * @param documentId - Identifier of the document to be deleted (snippetId)
   */ const deleteGlobalHelpDocument = (documentId)=>{
        return deleteAuth(`api/help-documents/${documentId}`).then((json)=>{
            return json;
        }).catch((error)=>{
            throw error;
        });
    };
    /**
   * API call to delete a client help document
   * @param clientId - Identifier of the client who's documents we are retrieving
   * @param documentId - Identifier of the document to be deleted (snippetId)
   */ const deleteClientHelpDocument = (clientId, documentId)=>{
        return deleteAuth(`api/clients/${clientId}/help-documents/${documentId}`).then((json)=>{
            return json;
        }).catch((error)=>{
            throw error;
        });
    };
    /**
   * API call to map a global document to selected clients
   * @param clientIds - List of clients to map the global document to
   * @param documentId - Identifier of the document to be mapped (snippetGroupId)
   */ const mapGlobalDocument = (clientIds, documentId)=>{
        return putAuth(`api/help-documents/${documentId}/map`, {
            clientIds: clientIds
        }).then((json)=>{
            return json;
        }).catch((error)=>{
            throw error;
        });
    };
    /**
   * API call to map a global document to selected clients
   * @param clientId - Unique identifier of the client
   * @param documentIds - List of documents that will be mapped to a given client(snippetGroupId)
   */ const mapGlobalDocumentsToClients = (clientId, snippetGroupIds)=>{
        return postAuth(`api/clients/${clientId}/help-documents/map`, {
            snippetGroupIds: snippetGroupIds
        }).then((json)=>{
            return json;
        }).catch((error)=>{
            throw error;
        });
    };
    /**
   * isParent
   * @method isParent - Checks to see if document is a parent document
   * @param doc - Document to be checked
   * @returns TRUE if snippetGroupId is not 0,
   * FALSE if snippetGroupId is 0
   */ const isParent = (doc)=>doc.snippetGroupId !== 0;
    /**
   * isChild
   * @method isChild - Checks to see if document is a child document
   * @param doc - Document to be checked
   * @returns TRUE if parentGroupId is not 0,
   * FALSE if parentGroupId is 0
   */ const isChild = (doc)=>doc.parentGroupId !== 0;
    /**
   * isActiveDoc
   * @method isActiveDoc - Checks if the document is active
   * @param parentDocument Document to be checked
   * @param activeDocuments Array of all active documents
   * @returns TRUE if the document is active, FALSE otherwise
   */ const isActiveDoc = (parentDocument, activeDocuments)=>{
        return activeDocuments.some((doc)=>parentDocument.snippetGroupId === doc.snippetGroupId);
    };
    /**
   * Gets all the documents without the root document
   * @param tree - The Atlassian Tree object containing all the documents
   */ const documentsWithoutRoot = (tree)=>Object.values(Object.values(tree)[1]).filter((doc)=>doc.id !== '-1');
    /**
   * Gets all the documents, includes the root document
   * @param tree - The Atlassian Tree object containing all the documents
   */ const documentsWithRoot = (tree)=>Object.values(Object.values(tree)[1]);
    const updateDocumentTreeAfterDelete = (prevDocumentTree, deletedDocId)=>{
        const documentTree = $fRnKy.cloneDeep(prevDocumentTree);
        const deletedDoc = documentsWithoutRoot(prevDocumentTree).find((doc)=>doc.data.snippetId === deletedDocId);
        const children = deletedDoc.children;
        const parent = documentsWithRoot(prevDocumentTree).find((doc)=>doc.children.includes(deletedDoc.id));
        const deletedDocIndex = parent.children.indexOf(deletedDoc.data.snippetGroupId);
        // Remove deleted document from the list of the parents children, and insert deleted documents children
        if (deletedDocIndex !== -1) documentTree.items[parent.id].children.splice(deletedDocIndex, 1, ...children);
        // If the parent no longer has any children, set hasChildren and isExpanded to false
        documentTree.items[parent.id].hasChildren = documentTree.items[parent.id].children.length > 0;
        documentTree.items[parent.id].isExpanded = documentTree.items[parent.id].children.length > 0;
        delete documentTree.items[`${deletedDoc.data.snippetGroupId}`];
        return documentTree;
    };
    const updateDocumentTreeAfterFetch = (prevTree, newDocuments)=>{
        const newTree = $fRnKy.cloneDeep(prevTree);
        const prevHelpDocuments = documentsWithoutRoot(prevTree).map((document)=>document.data);
        const newDocumentsIds = newDocuments.map((document)=>document.snippetGroupId);
        prevHelpDocuments.forEach((document)=>{
            if (newDocumentsIds.includes(document.snippetGroupId)) {
                const childrenList = newDocuments.filter((doc)=>doc.parentGroupId === document.snippetGroupId).map((doc)=>doc.snippetGroupId);
                newTree.items[`${document.snippetGroupId}`].data = newDocuments.find((doc)=>doc.snippetGroupId === document.snippetGroupId);
                newTree.items[`${document.snippetGroupId}`].hasChildren = childrenList.length > 0;
                newTree.items[`${document.snippetGroupId}`].children = childrenList;
            } else delete newTree.items[`${document.snippetGroupId}`];
        });
        newDocuments.forEach((document)=>{
            if (!newTree.items[`${document.snippetGroupId}`]) {
                const childrenList = newDocuments.filter((doc)=>doc.parentGroupId === document.snippetGroupId).map((doc)=>doc.snippetGroupId);
                const newItem = {
                    id: document.snippetGroupId,
                    data: document,
                    children: childrenList,
                    hasChildren: childrenList.length > 0,
                    isExpanded: true,
                    isChildrenLoading: false
                };
                newTree.items[`${document.snippetGroupId}`] = newItem;
            }
        });
        const rootDocuments = newDocuments.filter((doc)=>doc.parentGroupId === 0).map((doc)=>doc.snippetGroupId);
        newTree.items['-1'].hasChildren = rootDocuments.length > 0;
        newTree.items['-1'].children = rootDocuments;
        return newTree;
    };
    /**
   * Finds all the children and subchildren of the selected document
   * @param id - Identifier of the document to start the search from
   * @param idList - Array of child document ID's
   * @param newTree - The Atlassian Tree object containing all the documents
   */ const findChildren = (id, idList, newTree)=>{
        let arr = [
            id
        ];
        if (idList.length < 1) return arr;
        /** Goes through all the help documents and finds all the children, and does so repeatedly */ idList.forEach((doc)=>{
            const foundDocument = documentsWithoutRoot(newTree).find((d)=>d.data.snippetGroupId === doc);
            arr = [
                ...arr,
                ...findChildren(foundDocument.data.snippetGroupId, [
                    ...foundDocument.children
                ], newTree)
            ];
        });
        return arr;
    };
    /**
   * Finds the top level parent document for the document selected
   * @param documentId - Identifier of the document to start from
   * @param tree - The Atlassian Tree object containing all the documents
   */ const findTopLevelDocument = (documentId, tree)=>{
        const parent = documentsWithRoot(tree).find((doc)=>{
            return doc.children.includes(documentId);
        });
        if (!parent.data) return documentId;
        return findTopLevelDocument(parent.data.snippetGroupId, tree);
    };
    /**
   * Finds the document that's after the selected document
   * @param parentId - The identifier of the documents parent
   * @param index - The index of the current document
   * @param tree - The Atlassian Tree object containing all the documents
   */ const findNextDocument = (parentId, index, tree)=>{
        const parent = documentsWithRoot(tree).find((doc)=>{
            if (parentId === 0 || parentId === -1) return doc.id === '-1';
            return doc.data.snippetGroupId === parentId;
        });
        const grandParent = documentsWithRoot(tree).find((doc)=>{
            if (!parent.data || parent.data.snippetGroupId === 0 || !doc.data) return doc.id === '-1';
            return doc.children.includes(parent.id);
        });
        if (index === undefined) return findNextDocument(Number(grandParent.id), grandParent.children.findIndex((child)=>child === parent.data.snippetGroupId), tree);
        let nextDocument = parent.children[index + 1];
        if (nextDocument) return nextDocument;
        if (!parent.data) return -1;
        return findNextDocument(Number(grandParent.id), grandParent.children.findIndex((child)=>child === parent.data.snippetGroupId), tree);
    };
    /**
   * Parent of the dragged document
   * @param parentId - ID of the new parent
   * @param tree - The Atlassian Tree object containing all the documents
   */ const parentOfDocumentDragged = (parentId, tree)=>{
        return documentsWithRoot(tree).find((doc)=>{
            if (parentId === 0) return doc.id === '-1';
            return doc.data.snippetGroupId === parentId;
        });
    };
    /**
   * The snippetGroupId of the dragged document
   * @param index - Index where the document was dragged to
   * @param parentId - ID of the new parent
   * @param tree - The Atlassian Tree object containing all the documents
   */ const draggedSnippetGroupId = (index, parentId, tree)=>{
        return parentOfDocumentDragged(parentId, tree).children[index !== undefined ? index : parentOfDocumentDragged(parentId, tree).children.length - 1];
    };
    /**
   * The object for the dragged document
   */ const documentDragged = (documentId, tree)=>{
        return documentsWithoutRoot(tree).find((doc)=>doc.data.snippetGroupId === documentId);
    };
    /**
   * isTopLevelDoc
   * @method isTopLevelDoc - Checks if the document is a root level document
   * @param parentDocument Document to be checked
   * @returns TRUE if the document is a root level document, FALSE otherwise
   */ const isTopLevelDoc = (parentDocument)=>parentDocument.parentGroupId === 0;
    /**
   * getChildDocsToRender
   * @method getChildDocsToRender Creates an array of documents to render from the root doc to all it's children
   * @param allDocuments An array of all help documents
   * @param rootDoc The document at the top of the tree from the document that was selected by the user
   * @param docsToRender An array of the documents that will be rendered
   * @returns The array of documents that will be rendered
   */ const getChildDocsToRender = (allDocuments, rootDoc, docsToRender)=>{
        const children = allDocuments.filter((doc)=>doc.parentGroupId === rootDoc.snippetGroupId);
        // If there are children, push the children into the array, and then call this function
        if (children.length > 0) children.forEach((doc)=>{
            docsToRender.push(doc);
            return getChildDocsToRender(allDocuments, doc, docsToRender);
        });
        /** If there are no more children, push the document into the array and return the array */ if (children.length === 0) children.forEach((doc)=>docsToRender.push(doc));
        return docsToRender;
    };
    /**
   * Creates an array of documents to render from the root doc to all it's children
   * @param documentId ID of the selected document
   * @param tree The tree object of documents
   * @returns The array of documents that will be rendered
   */ const getChildDocsToRenderEdit = (documentId, tree)=>{
        const topLevelDocumentId = findTopLevelDocument(documentId, tree);
        const selectedDocument = documentDragged(topLevelDocumentId, tree);
        const childrenArray = findChildren(topLevelDocumentId, [
            ...selectedDocument.children
        ], tree);
        return documentsWithoutRoot(tree).filter((doc)=>childrenArray.includes(doc.data.snippetGroupId)).map((doc)=>doc.data).sort((a, b)=>childrenArray.indexOf(a.snippetGroupId) > childrenArray.indexOf(b.snippetGroupId) ? 1 : -1);
    };
    return {
        loading: loading,
        documents: documents,
        getHelpDocuments: getHelpDocuments,
        fetchHelpDocuments: fetchHelpDocuments,
        activeDocument: activeDocument,
        setActiveDocument: setActiveDocument,
        changeActiveDoc: changeActiveDoc,
        renderChildren: renderChildren,
        renderHelpContent: renderHelpContent,
        renderSidePanel: renderSidePanel,
        renderPreviews: renderPreviews,
        documentsWithoutRoot: documentsWithoutRoot,
        getChildDocsToRender: getChildDocsToRender,
        isActiveDoc: isActiveDoc,
        isTopLevelDoc: isTopLevelDoc,
        getGlobalHelpDocuments: getGlobalHelpDocuments,
        updateDocumentTreeAfterFetch: updateDocumentTreeAfterFetch,
        getLatestHelpDocuments: getLatestHelpDocuments,
        deleteGlobalHelpDocument: deleteGlobalHelpDocument,
        updateDocumentTreeAfterDelete: updateDocumentTreeAfterDelete,
        deleteClientHelpDocument: deleteClientHelpDocument,
        updateClientHelpDocumentsSortOrder: updateClientHelpDocumentsSortOrder,
        updateGlobalHelpDocumentsSortOrder: updateGlobalHelpDocumentsSortOrder,
        getChildDocsToRenderEdit: getChildDocsToRenderEdit,
        findNextDocument: findNextDocument,
        draggedSnippetGroupId: draggedSnippetGroupId,
        findChildren: findChildren,
        mapGlobalDocumentsToClients: mapGlobalDocumentsToClients,
        mapGlobalDocument: mapGlobalDocument,
        documentsWithRoot: documentsWithRoot
    };
};
var $dfbf579bea9f90b3$export$2e2bcd8739ae039 = $dfbf579bea9f90b3$var$useHelp;




var $5a696242325064a1$exports = {};
"use strict";


Object.defineProperty($5a696242325064a1$exports, "__esModule", {
    value: true
});
$5a696242325064a1$exports.default = void 0;

var $5a696242325064a1$var$React = $633c7dc13d665c5e$exports((parcelRequire("ieT14")));

var $5a696242325064a1$var$_createSvgIcon = $b24015bb0dc2bec9$exports((parcelRequire("3yIjW")));
var $5a696242325064a1$var$_default = (0, $5a696242325064a1$var$_createSvgIcon.default)(/*#__PURE__*/ $5a696242325064a1$var$React.createElement("path", {
    d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
}), 'Fullscreen');
$5a696242325064a1$exports.default = $5a696242325064a1$var$_default;


var $3a786cac0bbe966e$exports = {};
"use strict";


Object.defineProperty($3a786cac0bbe966e$exports, "__esModule", {
    value: true
});
$3a786cac0bbe966e$exports.default = void 0;

var $3a786cac0bbe966e$var$React = $633c7dc13d665c5e$exports((parcelRequire("ieT14")));

var $3a786cac0bbe966e$var$_createSvgIcon = $b24015bb0dc2bec9$exports((parcelRequire("3yIjW")));
var $3a786cac0bbe966e$var$_default = (0, $3a786cac0bbe966e$var$_createSvgIcon.default)(/*#__PURE__*/ $3a786cac0bbe966e$var$React.createElement("path", {
    d: "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
}), 'FullscreenExit');
$3a786cac0bbe966e$exports.default = $3a786cac0bbe966e$var$_default;




var $eYoAG = parcelRequire("eYoAG");


var $ieT14 = parcelRequire("ieT14");
/**
 * useMeasuredRef
 * @function useMeasuredRef Custom hook to get the dimensions of a node.
 * @param dependencies Any array of variables that might change that could effect the dimensions of the measuredRef
 * @param resize Boolean indicating to use resize event listener
 * @description Dimensions include {top, bottom, left, right, height, width, x, y}
 */ const $d9ed1b1da5a3379c$var$useMeasuredRef = (dependencies, resize, fullscreen)=>{
    const [dimensions, setDimensions] = $ieT14.useState(null);
    const measuredRef = $ieT14.useCallback((node)=>{
        if (node !== null) {
            resize && window.addEventListener('resize', ()=>setDimensions(node.getBoundingClientRect()));
            fullscreen && window.addEventListener('fullscreenchange', ()=>setDimensions(node.getBoundingClientRect()));
            setDimensions(node.getBoundingClientRect());
        }
    }, dependencies.length > 0 ? dependencies : []);
    return {
        measuredRef: measuredRef,
        dimensions: dimensions
    };
};
var $d9ed1b1da5a3379c$export$2e2bcd8739ae039 = $d9ed1b1da5a3379c$var$useMeasuredRef;




var $gXLwJ = parcelRequire("gXLwJ");
var $4gAfe = parcelRequire("4gAfe");

var $ieT14 = parcelRequire("ieT14");



var $2aIlz = parcelRequire("2aIlz");

var $kfQ2O = parcelRequire("kfQ2O");

var $6vrzA = parcelRequire("6vrzA");
function $544e32820ad8eb30$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        var mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $4gAfe.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $544e32820ad8eb30$var$ThemeProvider(props) {
    var children = props.children, localTheme = props.theme;
    var outerTheme = (0, $kfQ2O.default)();
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useMemo(function() {
        var output = outerTheme === null ? localTheme : $544e32820ad8eb30$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $6vrzA.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement((0, $2aIlz.default).Provider, {
        value: theme
    }, children);
}
var $544e32820ad8eb30$export$2e2bcd8739ae039 = $544e32820ad8eb30$var$ThemeProvider;


const $cf2b69105570b03d$var$dialogStyles = {
    helpDocuments: {
        width: '100%',
        border: '1px solid #dadada',
        overflowY: 'auto'
    },
    contentHeader: {
        height: '44px',
        display: 'flex',
        alignItems: 'center',
        padding: '0 16px 0 30px',
        fontWeight: '600',
        fontSize: '16px',
        borderBottom: '1px solid #8a8a8a',
        justifyContent: 'space-between'
    },
    fullScreenDiv: {
        color: '#006da8',
        fontWeight: '400',
        fontSize: '14px',
        textTransform: 'uppercase',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer'
    },
    fullScreenText: {
        marginLeft: '2px'
    },
    documentsContainer: {
        margin: '48px 57px',
        position: 'relative'
    }
};
const $cf2b69105570b03d$var$materialTheme = (0, $gXLwJ.default)({
    overrides: {
        MuiDialog: {
            root: {
                zIndex: '20000 !important'
            }
        }
    }
});
/**
 * FullScreenDialog
 * @function FullScreenDialog - Full screen dialog to show the contents of a help document
 */ const $cf2b69105570b03d$var$FullScreenDialog = ({ openFullScreen: openFullScreen, setOpenFullScreen: setOpenFullScreen, renderHelpContent: renderHelpContent, documents: documents, activeDocument: activeDocument })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $544e32820ad8eb30$export$2e2bcd8739ae039), {
        theme: $cf2b69105570b03d$var$materialTheme,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1c689a1559dbf5e9$export$2e2bcd8739ae039), {
            fullScreen: true,
            open: openFullScreen,
            onClose: ()=>setOpenFullScreen(false),
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $881610d42277b808$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    style: $cf2b69105570b03d$var$dialogStyles.helpDocuments,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                            style: $cf2b69105570b03d$var$dialogStyles.contentHeader,
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                    children: "Document"
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                    onClick: ()=>setOpenFullScreen(false),
                                    style: $cf2b69105570b03d$var$dialogStyles.fullScreenDiv,
                                    children: [
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3a786cac0bbe966e$exports))), {}),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                            style: $cf2b69105570b03d$var$dialogStyles.fullScreenText,
                                            children: "Minimize"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                            style: $cf2b69105570b03d$var$dialogStyles.documentsContainer,
                            children: renderHelpContent(documents, activeDocument)
                        })
                    ]
                })
            })
        })
    });
};
/**
 * TableOfContents
 * @function TableOfContents - Component for the left toolbar and the help documents page
 */ const $cf2b69105570b03d$var$TableOfContents = ({ documents: documents, searchQuery: searchQuery, isSearching: isSearching, setIsSearching: setIsSearching, setErrorMessage: setErrorMessage })=>{
    const { state: state } = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { activeDocument: activeDocument, renderHelpContent: renderHelpContent, renderSidePanel: renderSidePanel, renderPreviews: renderPreviews, setActiveDocument: setActiveDocument } = (0, $dfbf579bea9f90b3$export$2e2bcd8739ae039)();
    const [openFullScreen, setOpenFullScreen] = $ieT14.useState(false);
    const [redirect, setRedirect] = $ieT14.useState(false);
    const { document: document } = (0, $eYoAG.useParams)();
    const history = (0, $eYoAG.useHistory)();
    const announcementCount = +!!state.clientAnnouncement + +!!state.globalAnnouncement;
    const { measuredRef: measuredRef, dimensions: dimensions } = (0, $d9ed1b1da5a3379c$export$2e2bcd8739ae039)([
        announcementCount
    ], true);
    /** If there is no active document, the first document will become the active document so that there is always a document to display */ /** If a document is navigated to directly (via url) use param: document to set the active document */ $ieT14.useEffect(()=>{
        if (documents.length > 0) {
            if (activeDocument === -1 && document == undefined || Number(document) === -1) {
                setActiveDocument(documents[0].snippetGroupId);
                history.replace(`${(0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Help}/${documents[0].snippetGroupId}`);
            } else if (document != undefined && activeDocument != Number(document)) {
                const currentIndex = documents.findIndex((doc)=>doc.snippetGroupId === Number(document));
                if (currentIndex != -1) setActiveDocument(Number(document));
                else {
                    setErrorMessage('Help document not found for the current client');
                    setActiveDocument(documents[0].snippetGroupId);
                    history.replace((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Help);
                }
            } else if (activeDocument && !redirect) setRedirect(true);
        }
    }, [
        activeDocument,
        documents.length
    ]);
    if (redirect) {
        setRedirect(false);
        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Redirect), {
            to: `${(0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Help}/${activeDocument}`
        });
    }
    /** @const previews - Array of JSX elements that displays the preview of the help documents as the user is typing in the search bar */ const previews = renderPreviews(searchQuery, isSearching, documents, setIsSearching);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $2b36415f25d48604$export$998fc1525fc10cb4,
        ref: measuredRef,
        style: {
            height: `calc(100vh - ${dimensions ? 20 + dimensions.top : 0}px`
        },
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $2b36415f25d48604$export$cace0fe917d7fea5,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h5", {
                        className: $2b36415f25d48604$export$48884d2a5190dc73,
                        children: "Select a Document"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: $2b36415f25d48604$export$9b9ee9fa673496c9,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $5d10f0a7aadd7c8c$exports.Scrollbars), {
                            className: $2b36415f25d48604$export$cdc47cd250892a50,
                            autoHide: true,
                            universal: true,
                            children: renderSidePanel(documents, setIsSearching)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $2b36415f25d48604$export$2446a521e491a056,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        className: $2b36415f25d48604$export$d7dc7be08229f0b2,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h5", {
                                children: "Document"
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                onClick: ()=>setOpenFullScreen(true),
                                className: $2b36415f25d48604$export$69090a1e7ff8614c,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5a696242325064a1$exports))), {}),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                        children: "Maximize"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: $2b36415f25d48604$export$26cf923f17b837e4,
                        children: previews ? previews : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $5d10f0a7aadd7c8c$exports.Scrollbars), {
                            className: $2b36415f25d48604$export$77825fa6f4ae045f,
                            autoHide: true,
                            universal: true,
                            hideTracksWhenNotNeeded: true,
                            children: renderHelpContent(documents, activeDocument)
                        })
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($cf2b69105570b03d$var$FullScreenDialog, {
                        openFullScreen: openFullScreen,
                        setOpenFullScreen: setOpenFullScreen,
                        renderHelpContent: renderHelpContent,
                        documents: documents,
                        activeDocument: activeDocument
                    })
                ]
            })
        ]
    });
};
var $cf2b69105570b03d$export$2e2bcd8739ae039 = $cf2b69105570b03d$var$TableOfContents;





var $fpdl2 = parcelRequire("fpdl2");

var $ieT14 = parcelRequire("ieT14");
/**
 * useSearch
 * @function useSearch - Custom hook for the search bar
 */ const $b48f023b055940c4$var$useSearch = ()=>{
    const [isSearching, setIsSearching] = $ieT14.useState(false);
    const [searchQuery, setSearchQuery] = $ieT14.useState('');
    const updateSearchQuery = (value)=>{
        setSearchQuery(value);
        if (!value) setIsSearching(false);
        if (value) setIsSearching(true);
    };
    return {
        searchQuery: searchQuery,
        updateSearchQuery: updateSearchQuery,
        isSearching: isSearching,
        setIsSearching: setIsSearching
    };
};
var $b48f023b055940c4$export$2e2bcd8739ae039 = $b48f023b055940c4$var$useSearch;



parcelRequire("ieT14");


parcelRequire("ieT14");

const $d22c7b4f0e909693$var$SearchIcon = ({ handleClick: handleClick })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("svg", {
        className: handleClick ? $967c65ecbe356105$export$8687ffcdea58e000 : '',
        width: "16px",
        height: "16px",
        viewBox: "0 0 16 16",
        version: "1.1",
        onClick: (event)=>handleClick(event),
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("g", {
            id: "Symbols",
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("g", {
                id: "Search",
                transform: "translate(-32.000000, -7.000000)",
                fill: "#4F4F4F",
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("path", {
                    d: "M47.804749,21.3907416 L43.456393,17.0420523 C44.2140636,15.9983802 44.6667326,14.7190402 44.6667326,13.3333663 C44.6667326,9.8410148 41.8257178,7 38.3333663,7 C34.8410148,7 32,9.8410148 32,13.3333663 C32,16.8257178 34.8410148,19.6667326 38.3333663,19.6667326 C39.7190402,19.6667326 40.9983802,19.2140636 42.0420523,18.456393 L46.3907416,22.804749 C46.6510763,23.0650837 47.0730785,23.0650837 47.3334132,22.804749 L47.804749,22.3337465 C48.0650837,22.0730785 48.0650837,21.6510763 47.804749,21.3907416 L47.804749,21.3907416 Z M34.0000104,13.3333663 C34.0000104,10.9440205 35.9440205,9.00001042 38.3333663,9.00001042 C40.7227121,9.00001042 42.6667222,10.9440205 42.6667222,13.3333663 C42.6667222,15.7227121 40.7227121,17.6667222 38.3333663,17.6667222 C35.9440205,17.6667222 34.0000104,15.7227121 34.0000104,13.3333663 L34.0000104,13.3333663 Z",
                    id: "search-icon"
                })
            })
        })
    });
};
var $d22c7b4f0e909693$export$2e2bcd8739ae039 = $d22c7b4f0e909693$var$SearchIcon;


/**
 * SearchBar
 * @function SearchBar - Component for the search bar
 */ const $00cebbc6f72b4773$var$SearchBar = ({ value: value, updateValue: updateValue, setIsSearching: setIsSearching, placeholder: placeholder, submitHandler: submitHandler })=>{
    const handleSubmit = (event)=>{
        event.preventDefault();
        submitHandler && submitHandler();
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $fdbf0d9f77db804d$export$f2ea4ab276c3e3fa,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $d22c7b4f0e909693$export$2e2bcd8739ae039), {
                handleClick: (event)=>handleSubmit(event)
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("form", {
                onSubmit: (event)=>handleSubmit(event),
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("input", {
                    value: value,
                    onChange: (event)=>updateValue(event.target.value),
                    onFocus: ()=>value && setIsSearching(true),
                    placeholder: placeholder
                })
            })
        ]
    });
};
var $00cebbc6f72b4773$export$2e2bcd8739ae039 = $00cebbc6f72b4773$var$SearchBar;




parcelRequire("ieT14");
var $4157cfae1f03f09f$exports = {};
"use strict";


Object.defineProperty($4157cfae1f03f09f$exports, "__esModule", {
    value: true
});
$4157cfae1f03f09f$exports.default = void 0;

var $4157cfae1f03f09f$var$React = $633c7dc13d665c5e$exports((parcelRequire("ieT14")));

var $4157cfae1f03f09f$var$_createSvgIcon = $b24015bb0dc2bec9$exports((parcelRequire("3yIjW")));
var $4157cfae1f03f09f$var$_default = (0, $4157cfae1f03f09f$var$_createSvgIcon.default)(/*#__PURE__*/ $4157cfae1f03f09f$var$React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
}), 'Error');
$4157cfae1f03f09f$exports.default = $4157cfae1f03f09f$var$_default;


var $1a687f1fe4770831$export$b0377cbbbdab6cba;
var $1a687f1fe4770831$export$f27f0a643498ce3d;
var $1a687f1fe4770831$export$b00c055587dc7469;
var $1a687f1fe4770831$export$b1a09d22b7ad6c4;
var $1a687f1fe4770831$export$509f3108fdd206bb;
var $1a687f1fe4770831$export$42ff741d2868ee32;
var $1a687f1fe4770831$export$8c430709db82137d;
var $1a687f1fe4770831$export$2d4b1211b4389c3b;
var $1a687f1fe4770831$export$3832be13857745bc;
var $1a687f1fe4770831$export$f4c68800b094ddb1;
var $1a687f1fe4770831$export$d7283b082124d1f9;
var $1a687f1fe4770831$export$53f2c87d750bb57f;
var $1a687f1fe4770831$export$3ed881773c003eaf;
var $1a687f1fe4770831$export$7de13f83ae2e15ee;
$1a687f1fe4770831$export$b0377cbbbdab6cba = "#006da8";
$1a687f1fe4770831$export$f27f0a643498ce3d = "#00aafc";
$1a687f1fe4770831$export$b00c055587dc7469 = "#f5dbd9";
$1a687f1fe4770831$export$b1a09d22b7ad6c4 = "#c92100";
$1a687f1fe4770831$export$509f3108fdd206bb = "#ebafa6";
$1a687f1fe4770831$export$42ff741d2868ee32 = "#074f86";
$1a687f1fe4770831$export$8c430709db82137d = "#dadada";
$1a687f1fe4770831$export$2d4b1211b4389c3b = "#dddbda";
$1a687f1fe4770831$export$3832be13857745bc = "#eae9ed";
$1a687f1fe4770831$export$f4c68800b094ddb1 = "#e9e8f4";
$1a687f1fe4770831$export$d7283b082124d1f9 = "successAnnouncement_c1410c";
$1a687f1fe4770831$export$53f2c87d750bb57f = "failureAnnouncement_c1410c";
$1a687f1fe4770831$export$3ed881773c003eaf = "priorityTwoSuccess_c1410c";
$1a687f1fe4770831$export$7de13f83ae2e15ee = "priorityTwoFailure_c1410c";


/**
 * @function PriorityTwoFailure - Component for failure messages
 */ const $cd9e5d573af72510$var$PriorityTwoFailure = ({ message: message })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $1a687f1fe4770831$export$7de13f83ae2e15ee,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4157cfae1f03f09f$exports))), {}),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                children: message
            })
        ]
    });
};
var $cd9e5d573af72510$export$2e2bcd8739ae039 = $cd9e5d573af72510$var$PriorityTwoFailure;


/**
 * Help
 * @function Help - Outer component for the help page
 */ const $961de21096e2c5eb$var$Help = ()=>{
    const { state: state } = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { loading: loading, documents: documents, fetchHelpDocuments: fetchHelpDocuments } = (0, $dfbf579bea9f90b3$export$2e2bcd8739ae039)();
    const { searchQuery: searchQuery, updateSearchQuery: updateSearchQuery, isSearching: isSearching, setIsSearching: setIsSearching } = (0, $b48f023b055940c4$export$2e2bcd8739ae039)();
    const { errorMessage: errorMessage, setErrorMessage: setErrorMessage } = (0, $dc97b0794e0fd33b$export$2e2bcd8739ae039)();
    $ieT14.useEffect(()=>{
        fetchHelpDocuments(state.clientId);
    }, []);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $2b36415f25d48604$export$79191b5aedbf24d4,
        children: [
            errorMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $cd9e5d573af72510$export$2e2bcd8739ae039), {
                message: errorMessage
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $2b36415f25d48604$export$38e42c68cf43b5d4,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h1", {
                        children: "Help Documentation"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $00cebbc6f72b4773$export$2e2bcd8739ae039), {
                        value: searchQuery,
                        updateValue: (val)=>updateSearchQuery(val),
                        setIsSearching: (searching)=>setIsSearching(searching),
                        placeholder: 'Help Documentation'
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $2b36415f25d48604$export$c4b0f5819f6a6663,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
            }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $cf2b69105570b03d$export$2e2bcd8739ae039), {
                documents: documents,
                searchQuery: searchQuery,
                isSearching: isSearching,
                setIsSearching: (searching)=>setIsSearching(searching),
                setErrorMessage: setErrorMessage
            })
        ]
    });
};
var $961de21096e2c5eb$export$2e2bcd8739ae039 = $961de21096e2c5eb$var$Help;





var $ieT14 = parcelRequire("ieT14");
var $fffe59a493fce4d8$export$3481c78889e8fbe8;
var $fffe59a493fce4d8$export$c4b0f5819f6a6663;
var $fffe59a493fce4d8$export$34e0f9847d4c02dd;
var $fffe59a493fce4d8$export$a7db06668cad9adb;
var $fffe59a493fce4d8$export$38e42c68cf43b5d4;
var $fffe59a493fce4d8$export$3f6d243f5dbc1961;
var $fffe59a493fce4d8$export$57ad902a600ecd80;
var $fffe59a493fce4d8$export$e7d47881ec916f76;
$fffe59a493fce4d8$export$3481c78889e8fbe8 = `XvjIYq_center`;
$fffe59a493fce4d8$export$c4b0f5819f6a6663 = `XvjIYq_circularProgress`;
$fffe59a493fce4d8$export$34e0f9847d4c02dd = `XvjIYq_container`;
$fffe59a493fce4d8$export$a7db06668cad9adb = `XvjIYq_content`;
$fffe59a493fce4d8$export$38e42c68cf43b5d4 = `XvjIYq_header`;
$fffe59a493fce4d8$export$3f6d243f5dbc1961 = `XvjIYq_resultsCount`;
$fffe59a493fce4d8$export$57ad902a600ecd80 = `XvjIYq_scrollTable`;
$fffe59a493fce4d8$export$e7d47881ec916f76 = `XvjIYq_tableWrapper`;




var $fpdl2 = parcelRequire("fpdl2");

var $ieT14 = parcelRequire("ieT14");


var $ieT14 = parcelRequire("ieT14");
var $fe0b3f9952d5826a$export$3d87dc9a97d725e6 = /*#__PURE__*/ function(ClientSortingOptions) {
    ClientSortingOptions["Ascending"] = "asc";
    ClientSortingOptions["Descending"] = "desc";
    ClientSortingOptions["Name"] = "name";
    ClientSortingOptions["DisplayName"] = "displayName";
    ClientSortingOptions["Administrator"] = "administrator";
    ClientSortingOptions["Status"] = "status";
    return ClientSortingOptions;
}($fe0b3f9952d5826a$export$3d87dc9a97d725e6 || {});
var $fe0b3f9952d5826a$export$5468e3184eb0a928 = /*#__PURE__*/ function(UserSortingOptions) {
    UserSortingOptions["Ascending"] = "asc";
    UserSortingOptions["Descending"] = "desc";
    UserSortingOptions["Name"] = "lastName";
    UserSortingOptions["UserType"] = "role";
    UserSortingOptions["Email"] = "email";
    UserSortingOptions["Department"] = "department";
    UserSortingOptions["Status"] = "status";
    return UserSortingOptions;
}($fe0b3f9952d5826a$export$5468e3184eb0a928 || {});
var $fe0b3f9952d5826a$export$a0189e346cd07222 = /*#__PURE__*/ function(ClientUserSortingOptions) {
    ClientUserSortingOptions["Ascending"] = "asc";
    ClientUserSortingOptions["Descending"] = "desc";
    ClientUserSortingOptions["Name"] = "lastName";
    ClientUserSortingOptions["UserType"] = "role";
    ClientUserSortingOptions["Email"] = "email";
    ClientUserSortingOptions["Department"] = "department";
    ClientUserSortingOptions["Status"] = "status";
    return ClientUserSortingOptions;
}($fe0b3f9952d5826a$export$a0189e346cd07222 || {});
var $fe0b3f9952d5826a$export$e61061e57d0d071 = /*#__PURE__*/ function(DashboardSortingOptions) {
    DashboardSortingOptions["Ascending"] = "asc";
    DashboardSortingOptions["Descending"] = "desc";
    DashboardSortingOptions["Name"] = "name";
    DashboardSortingOptions["Description"] = "description";
    DashboardSortingOptions["Tags"] = "assignedTags";
    DashboardSortingOptions["ReportId"] = "reportId";
    DashboardSortingOptions["Status"] = "status";
    return DashboardSortingOptions;
}($fe0b3f9952d5826a$export$e61061e57d0d071 || {});


const $1931bd0aa9be7e6d$var$defaultState = {
    loading: false,
    results: [],
    currentPage: 1,
    totalResults: 0,
    pageSize: 60,
    orderColumn: (0, $fe0b3f9952d5826a$export$3d87dc9a97d725e6).Name,
    orderDirection: 'asc',
    searchTerm: null
};
const $1931bd0aa9be7e6d$export$45320e1731c4b48f = /*#__PURE__*/ $ieT14.createContext(null);
const $1931bd0aa9be7e6d$export$6e266bb8e66c156a = $1931bd0aa9be7e6d$export$45320e1731c4b48f.Consumer;
const $1931bd0aa9be7e6d$export$2052c90c9d1d90b = (props)=>{
    const [state, setState] = (0, $ieT14.useState)($1931bd0aa9be7e6d$var$defaultState);
    const dispatch = (newValue)=>{
        setState((prevState)=>{
            return {
                ...prevState,
                ...newValue
            };
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($1931bd0aa9be7e6d$export$45320e1731c4b48f.Provider, {
        value: {
            ...state,
            dispatch: dispatch
        },
        children: props.children
    });
};



/**
 * usePaginatedClients
 * @function usePaginatedClients - Custom hook for the client management page
 */ const $1c9f4c0c68498da7$var$usePaginatedClients = ()=>{
    const { loading: loading, dispatch: dispatch, results: results, totalResults: totalResults } = $ieT14.useContext((0, $1931bd0aa9be7e6d$export$45320e1731c4b48f));
    const { fetchAdminClients: fetchAdminClients } = (0, $c400040bbf0b66f7$export$2e2bcd8739ae039)();
    /**
   * fetchClientsPage
   * @function fetchClients - Fetches the clients from the backend and sets them to the state
   * @param options - Optional FetchOptions
   */ const fetchClientsPage = (options)=>{
        dispatch({
            loading: true
        });
        return fetchAdminClients(options.currentPage, options.pageSize, options.searchTerm, options.orderColumn, options.orderDirection).then((response)=>{
            dispatch({
                loading: false,
                currentPage: options.currentPage,
                pageSize: options.pageSize,
                results: response.results,
                totalResults: response.totalItems,
                orderColumn: options.orderColumn,
                orderDirection: options.orderDirection,
                searchTerm: options.searchTerm
            });
        }).catch(()=>console.log('Failed to get clients.'));
    };
    return {
        loading: loading,
        results: results,
        fetchClientsPage: fetchClientsPage,
        totalResults: totalResults
    };
};
var $1c9f4c0c68498da7$export$2e2bcd8739ae039 = $1c9f4c0c68498da7$var$usePaginatedClients;






var $ieT14 = parcelRequire("ieT14");




parcelRequire("ieT14");

parcelRequire("ieT14");


var $eYoAG = parcelRequire("eYoAG");

/**
 * ClientActionCell
 * @function ClientActionCell
 */ const $bec0780853d357e9$var$ClientActionCell = ({ client: client, isClientAdmin: isClientAdmin, history: history })=>{
    const redirectToEditClientId = (clientId)=>{
        if (isClientAdmin) history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).ClientDashboards.replace(':clientId', clientId.toString()));
        else history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).EditClient.replace(':clientId', clientId.toString()));
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fcd3b8c5e9a7038b$export$2e2bcd8739ae039), {
            text: "Edit Client",
            title: "Edit Client",
            handleClick: ()=>redirectToEditClientId(client.clientId)
        })
    });
};
var $bec0780853d357e9$export$2e2bcd8739ae039 = (0, $eYoAG.withRouter)($bec0780853d357e9$var$ClientActionCell);


/**
 * ClientEntry
 * @function ClientEntry
 */ const $f137ae1609694e0b$var$ClientEntry = ({ client: client, isClientAdmin: isClientAdmin })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                scope: "row",
                children: client.name
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                children: client.displayName
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                children: client.administrator
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                children: client.status === true ? 'ACTIVE' : 'INACTIVE'
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $bec0780853d357e9$export$2e2bcd8739ae039), {
                client: client,
                isClientAdmin: isClientAdmin
            })
        ]
    });
};
var $f137ae1609694e0b$export$2e2bcd8739ae039 = $f137ae1609694e0b$var$ClientEntry;



parcelRequire("ieT14");
var $dac203c01993210a$export$b0377cbbbdab6cba;
var $dac203c01993210a$export$f27f0a643498ce3d;
var $dac203c01993210a$export$b00c055587dc7469;
var $dac203c01993210a$export$b1a09d22b7ad6c4;
var $dac203c01993210a$export$509f3108fdd206bb;
var $dac203c01993210a$export$42ff741d2868ee32;
var $dac203c01993210a$export$8c430709db82137d;
var $dac203c01993210a$export$2d4b1211b4389c3b;
var $dac203c01993210a$export$3832be13857745bc;
var $dac203c01993210a$export$f4c68800b094ddb1;
var $dac203c01993210a$export$9852986a3ec5f6a0;
var $dac203c01993210a$export$46c1c92549715335;
var $dac203c01993210a$export$fbad004417327a18;
var $dac203c01993210a$export$b1acbb01c3dddb9b;
var $dac203c01993210a$export$90930a5fed7c8fda;
$dac203c01993210a$export$b0377cbbbdab6cba = "#006da8";
$dac203c01993210a$export$f27f0a643498ce3d = "#00aafc";
$dac203c01993210a$export$b00c055587dc7469 = "#f5dbd9";
$dac203c01993210a$export$b1a09d22b7ad6c4 = "#c92100";
$dac203c01993210a$export$509f3108fdd206bb = "#ebafa6";
$dac203c01993210a$export$42ff741d2868ee32 = "#074f86";
$dac203c01993210a$export$8c430709db82137d = "#dadada";
$dac203c01993210a$export$2d4b1211b4389c3b = "#dddbda";
$dac203c01993210a$export$3832be13857745bc = "#eae9ed";
$dac203c01993210a$export$f4c68800b094ddb1 = "#e9e8f4";
$dac203c01993210a$export$9852986a3ec5f6a0 = "table_21daf7";
$dac203c01993210a$export$46c1c92549715335 = "loading_21daf7";
$dac203c01993210a$export$fbad004417327a18 = "tableHead_21daf7";
$dac203c01993210a$export$b1acbb01c3dddb9b = "headerCellInner_21daf7";
$dac203c01993210a$export$90930a5fed7c8fda = "sortGroup_21daf7";



var $j6s32 = parcelRequire("j6s32");
const $0cbf74840f7b6287$var$Table = ({ children: children, loading: loading, results: results })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("table", {
        className: (0, $j6s32.default)(loading && results.length > 0 && $dac203c01993210a$export$46c1c92549715335, $dac203c01993210a$export$9852986a3ec5f6a0),
        children: children
    });
};
var $0cbf74840f7b6287$export$2e2bcd8739ae039 = $0cbf74840f7b6287$var$Table;



parcelRequire("ieT14");

const $0cd938f964be002d$var$TableHead = ({ children: children })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("thead", {
        className: $dac203c01993210a$export$fbad004417327a18,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("tr", {
            children: children
        })
    });
};
var $0cd938f964be002d$export$2e2bcd8739ae039 = $0cd938f964be002d$var$TableHead;



parcelRequire("ieT14");

const $a282f935ed3e599f$var$TableBody = ({ children: children })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("tbody", {
        className: $dac203c01993210a$export$fbad004417327a18,
        children: children
    });
};
var $a282f935ed3e599f$export$2e2bcd8739ae039 = $a282f935ed3e599f$var$TableBody;




var $ieT14 = parcelRequire("ieT14");


parcelRequire("ieT14");

var $kRJN7 = parcelRequire("kRJN7");
var $e1ONw = parcelRequire("e1ONw");

var $j6s32 = parcelRequire("j6s32");
const $79e6b89db86870eb$var$useStyles = (0, $e1ONw.default)(()=>(0, $kRJN7.default)({
        button: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: 'none',
            backgroundColor: 'white',
            padding: '0',
            margin: '0',
            cursor: 'pointer',
            '& svg': {
                width: '14px',
                height: '7px'
            }
        },
        ascending: {
            paddingTop: '3px',
            paddingBottom: '1px',
            paddingLeft: '2px',
            paddingRight: '2px'
        },
        descending: {
            paddingTop: '1px',
            paddingBottom: '3px',
            paddingLeft: '2px',
            paddingRight: '2px'
        },
        disabled: {
            cursor: 'default'
        }
    }));
const $79e6b89db86870eb$var$SortButton = ({ direction: direction, current: current, onClick: onClick })=>{
    const classes = $79e6b89db86870eb$var$useStyles();
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("button", {
        className: (0, $j6s32.default)(classes.button, direction == 'Ascending' ? classes.ascending : classes.descending, current && classes.disabled),
        "aria-label": direction,
        onClick: onClick,
        disabled: current,
        children: [
            direction == 'Ascending' && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("svg", {
                viewBox: "-100 -100 200 100",
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("polygon", {
                    points: "-80,-20 80,-20 0,-100",
                    fill: current ? '#00223c' : '#c4c4c4',
                    strokeWidth: "0"
                })
            }),
            direction == 'Descending' && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("svg", {
                viewBox: "-100 0 200 100",
                height: "16px",
                width: "16px",
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("polygon", {
                    points: "-80,20 80,20 0,100",
                    fill: current ? '#00223c' : '#c4c4c4'
                })
            })
        ]
    });
};
var $79e6b89db86870eb$export$2e2bcd8739ae039 = $79e6b89db86870eb$var$SortButton;


/**
 * HeaderCell -- renders th in table header with optional sorting buttons
 * @param title text displayed in the th cell
 * @param scope th attribute defining the values the header pertains to
 * @param orderField name of the field ordered by this column
 * @param orderColumn orderField currently being used for sort
 * @param orderDirection current sort direction
 * @param reorderHandler handler to be called on click events to reorder columns
 */ const $24e3ac690c79ee75$var$HeaderCell = ({ title: title, scope: scope, orderField: orderField, orderColumn: orderColumn, orderDirection: orderDirection, reorderHandler: reorderHandler })=>{
    const clickHandler = ()=>{
        let direction;
        if (orderField != orderColumn) direction = 'asc';
        else direction = orderDirection == 'asc' ? 'desc' : 'asc';
        reorderHandler(orderField, direction);
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("th", {
        scope: scope,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
            className: $dac203c01993210a$export$b1acbb01c3dddb9b,
            children: orderColumn ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("button", {
                        "aria-label": `Order by ${title}`,
                        title: `Order by ${title}`,
                        onClick: clickHandler,
                        children: title || ''
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        className: $dac203c01993210a$export$90930a5fed7c8fda,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $79e6b89db86870eb$export$2e2bcd8739ae039), {
                                direction: "Ascending",
                                current: orderField == orderColumn && orderDirection == 'asc',
                                onClick: ()=>reorderHandler(orderField, 'asc')
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $79e6b89db86870eb$export$2e2bcd8739ae039), {
                                direction: "Descending",
                                current: orderField == orderColumn && orderDirection == 'desc',
                                onClick: ()=>reorderHandler(orderField, 'desc')
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                children: title || ''
            })
        })
    });
};
var $24e3ac690c79ee75$export$2e2bcd8739ae039 = $24e3ac690c79ee75$var$HeaderCell;




const $76768940c212fa94$var$ClientTable = ({ loading: loading, isClientAdmin: isClientAdmin })=>{
    const { results: results, pageSize: pageSize, orderColumn: orderColumn, orderDirection: orderDirection, searchTerm: searchTerm } = $ieT14.useContext((0, $1931bd0aa9be7e6d$export$45320e1731c4b48f));
    const { fetchClientsPage: fetchClientsPage } = (0, $1c9f4c0c68498da7$export$2e2bcd8739ae039)();
    const reorderHandler = (orderColumn, orderDirection)=>{
        fetchClientsPage({
            currentPage: 1,
            pageSize: pageSize,
            orderColumn: orderColumn,
            orderDirection: orderDirection,
            searchTerm: searchTerm
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        className: $fffe59a493fce4d8$export$e7d47881ec916f76,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
            style: {
                height: '90%'
            },
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5d10f0a7aadd7c8c$exports))), {
                className: $fffe59a493fce4d8$export$57ad902a600ecd80,
                autoHide: true,
                universal: true,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $0cbf74840f7b6287$export$2e2bcd8739ae039), {
                    loading: loading,
                    results: results,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $0cd938f964be002d$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                    title: "Name",
                                    scope: "col",
                                    orderField: (0, $fe0b3f9952d5826a$export$3d87dc9a97d725e6).Name,
                                    orderColumn: orderColumn,
                                    orderDirection: orderDirection,
                                    reorderHandler: reorderHandler
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                    title: "Display Name",
                                    scope: "col",
                                    orderField: (0, $fe0b3f9952d5826a$export$3d87dc9a97d725e6).DisplayName,
                                    orderColumn: orderColumn,
                                    orderDirection: orderDirection,
                                    reorderHandler: reorderHandler
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                    title: "Administrator",
                                    scope: "col",
                                    orderField: (0, $fe0b3f9952d5826a$export$3d87dc9a97d725e6).Administrator,
                                    orderColumn: orderColumn,
                                    orderDirection: orderDirection,
                                    reorderHandler: reorderHandler
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                    title: "Status",
                                    scope: "col",
                                    orderField: (0, $fe0b3f9952d5826a$export$3d87dc9a97d725e6).Status,
                                    orderColumn: orderColumn,
                                    orderDirection: orderDirection,
                                    reorderHandler: reorderHandler
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                    title: ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $a282f935ed3e599f$export$2e2bcd8739ae039), {
                            children: !results || results.length === 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                    children: "There are no clients."
                                })
                            }) : results.map((client)=>{
                                return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f137ae1609694e0b$export$2e2bcd8739ae039), {
                                    client: client,
                                    isClientAdmin: isClientAdmin
                                }, client.clientId);
                            })
                        })
                    ]
                })
            })
        })
    });
};
var $76768940c212fa94$export$2e2bcd8739ae039 = $76768940c212fa94$var$ClientTable;




var $ieT14 = parcelRequire("ieT14");

var $fRnKy = parcelRequire("fRnKy");
var $731d79c43329f1a4$export$b0377cbbbdab6cba;
var $731d79c43329f1a4$export$f27f0a643498ce3d;
var $731d79c43329f1a4$export$b00c055587dc7469;
var $731d79c43329f1a4$export$b1a09d22b7ad6c4;
var $731d79c43329f1a4$export$509f3108fdd206bb;
var $731d79c43329f1a4$export$42ff741d2868ee32;
var $731d79c43329f1a4$export$8c430709db82137d;
var $731d79c43329f1a4$export$2d4b1211b4389c3b;
var $731d79c43329f1a4$export$3832be13857745bc;
var $731d79c43329f1a4$export$f4c68800b094ddb1;
var $731d79c43329f1a4$export$5dd819bdfbc7b15d;
var $731d79c43329f1a4$export$4945c604e8eedb97;
var $731d79c43329f1a4$export$908473471e9c0307;
var $731d79c43329f1a4$export$642451158120d88a;
var $731d79c43329f1a4$export$ba319923d57aa6fe;
var $731d79c43329f1a4$export$e02e799aaaceeea7;
var $731d79c43329f1a4$export$5b0f3a3d8bdfc3fb;
$731d79c43329f1a4$export$b0377cbbbdab6cba = "#006da8";
$731d79c43329f1a4$export$f27f0a643498ce3d = "#00aafc";
$731d79c43329f1a4$export$b00c055587dc7469 = "#f5dbd9";
$731d79c43329f1a4$export$b1a09d22b7ad6c4 = "#c92100";
$731d79c43329f1a4$export$509f3108fdd206bb = "#ebafa6";
$731d79c43329f1a4$export$42ff741d2868ee32 = "#074f86";
$731d79c43329f1a4$export$8c430709db82137d = "#dadada";
$731d79c43329f1a4$export$2d4b1211b4389c3b = "#dddbda";
$731d79c43329f1a4$export$3832be13857745bc = "#eae9ed";
$731d79c43329f1a4$export$f4c68800b094ddb1 = "#e9e8f4";
$731d79c43329f1a4$export$5dd819bdfbc7b15d = "paginationContainer_2b6a96";
$731d79c43329f1a4$export$4945c604e8eedb97 = "pageSelection_2b6a96";
$731d79c43329f1a4$export$908473471e9c0307 = "pageNumbers_2b6a96";
$731d79c43329f1a4$export$642451158120d88a = "paginationControl_2b6a96";
$731d79c43329f1a4$export$ba319923d57aa6fe = "activePage_2b6a96";
$731d79c43329f1a4$export$e02e799aaaceeea7 = "pageAmount_2b6a96";
$731d79c43329f1a4$export$5b0f3a3d8bdfc3fb = "pageAmountActive_2b6a96";




parcelRequire("ieT14");

/**
 * @function PageCount - Component displaying an option for page size on table components
 * @param {Props} props - Props to fetch the appropriate page of results
 */ const $7b4249539137e788$var$PageCount = ({ count: count, currentPageSize: currentPageSize, searchTerm: searchTerm, orderColumn: orderColumn, orderDirection: orderDirection, fetchResults: fetchResults, fetchExtraProps: fetchExtraProps })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
        onClick: ()=>fetchResults({
                currentPage: 1,
                pageSize: count,
                searchTerm: searchTerm,
                orderColumn: orderColumn,
                orderDirection: orderDirection,
                ...fetchExtraProps
            }),
        className: `${$731d79c43329f1a4$export$e02e799aaaceeea7} ${currentPageSize === count ? $731d79c43329f1a4$export$5b0f3a3d8bdfc3fb : ''}`,
        children: count
    });
};
var $7b4249539137e788$export$2e2bcd8739ae039 = $7b4249539137e788$var$PageCount;




var $ieT14 = parcelRequire("ieT14");
const $54cb69781cf7322a$var$PagesDisplay = ({ totalPages: totalPages, allPages: allPages, selectedPage: selectedPage, activeStyles: activeStyles, handlePageChange: handlePageChange })=>{
    /**
   * renderPages
   * @function renderPages - Renders the list of available pages
   */ const renderPages = ()=>{
        if (totalPages === 1) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
            className: activeStyles,
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                children: allPages[0]
            })
        });
        else if (totalPages <= 4) return allPages.map((page, index)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: selectedPage === page ? activeStyles : '',
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                    onClick: ()=>handlePageChange(page),
                    children: page
                })
            }, index));
        else if (totalPages > 4 && selectedPage === 1) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: activeStyles,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(selectedPage),
                        children: selectedPage
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(selectedPage + 1),
                        children: selectedPage + 1
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(selectedPage + 2),
                        children: selectedPage + 2
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                        onClick: ()=>handlePageChange(totalPages),
                        children: [
                            "...",
                            totalPages
                        ]
                    })
                })
            ]
        });
        else if (totalPages > 4 && selectedPage === 2) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(selectedPage - 1),
                        children: selectedPage - 1
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: activeStyles,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(selectedPage),
                        children: selectedPage
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(selectedPage + 1),
                        children: selectedPage + 1
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                        onClick: ()=>handlePageChange(totalPages),
                        children: [
                            "...",
                            totalPages
                        ]
                    })
                })
            ]
        });
        else if (totalPages > 4 && (selectedPage === totalPages || selectedPage === totalPages - 1)) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(1),
                        children: "1..."
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: selectedPage === totalPages - 2 ? activeStyles : '',
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(totalPages - 2),
                        children: totalPages - 2
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: selectedPage === totalPages - 1 ? activeStyles : '',
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(totalPages - 1),
                        children: totalPages - 1
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: selectedPage === totalPages ? activeStyles : '',
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(totalPages),
                        children: totalPages
                    })
                })
            ]
        });
        else if (totalPages > 4 && selectedPage <= totalPages - 2) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(1),
                        children: "1..."
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(selectedPage - 1),
                        children: selectedPage - 1
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: activeStyles,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(selectedPage),
                        children: selectedPage
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(selectedPage + 1),
                        children: selectedPage + 1
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                        onClick: ()=>handlePageChange(totalPages),
                        children: [
                            "...",
                            totalPages
                        ]
                    })
                })
            ]
        });
        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {});
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($ieT14.Fragment, {
        children: renderPages()
    });
};
var $54cb69781cf7322a$export$2e2bcd8739ae039 = $54cb69781cf7322a$var$PagesDisplay;



/**
 * Pagination
 * @function Pagination - Component to render pagination of results.
 * @param {PaginatedQueryFunction} fetchResults - Function to query for the pages of results.
 * @param {React.Context<ContextValue<any>>} paginatedContext - Context for the results and pages.
 * @param {string} searchTerm - Search term for the query.
 * @param {Object} fetchExtraProps - Optional object with extra properties to include in the fetchResults function call.
 */ const $f021d555e7f7d483$var$Pagination = ({ fetchResults: fetchResults, paginatedContext: paginatedContext, searchTerm: searchTerm, fetchExtraProps: fetchExtraProps })=>{
    const { pageSize: pageSize, currentPage: currentPage, totalResults: totalResults, orderColumn: orderColumn, orderDirection: orderDirection } = $ieT14.useContext(paginatedContext);
    const [inputPage, setInputPage] = $ieT14.useState(null);
    const totalPages = Math.ceil(totalResults / pageSize);
    const allPages = $fRnKy.range(1, totalPages + 1);
    /**
   * handlePageChange
   * @function handlePageChange - Fetches the results after the user selects the number page
   * @param newPage Selects which page will be requested
   */ const handlePageChange = (newPage)=>{
        if (newPage > totalPages) newPage = totalPages;
        else if (newPage < 1) newPage = 1;
        fetchResults({
            pageSize: pageSize,
            currentPage: newPage,
            searchTerm: searchTerm,
            orderColumn: orderColumn,
            orderDirection: orderDirection,
            ...fetchExtraProps
        });
    };
    // Clears out the number in input if the selectedPage is changed outside the input
    $ieT14.useEffect(()=>{
        if (currentPage !== inputPage) setInputPage(null);
    }, [
        currentPage
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $731d79c43329f1a4$export$5dd819bdfbc7b15d,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $731d79c43329f1a4$export$4945c604e8eedb97,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        children: "Show: "
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $7b4249539137e788$export$2e2bcd8739ae039), {
                        count: 15,
                        currentPageSize: pageSize,
                        searchTerm: searchTerm,
                        orderColumn: orderColumn,
                        orderDirection: orderDirection,
                        fetchResults: fetchResults,
                        fetchExtraProps: fetchExtraProps
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $7b4249539137e788$export$2e2bcd8739ae039), {
                        count: 30,
                        currentPageSize: pageSize,
                        searchTerm: searchTerm,
                        orderColumn: orderColumn,
                        orderDirection: orderDirection,
                        fetchResults: fetchResults,
                        fetchExtraProps: fetchExtraProps
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $7b4249539137e788$export$2e2bcd8739ae039), {
                        count: 60,
                        currentPageSize: pageSize,
                        searchTerm: searchTerm,
                        orderColumn: orderColumn,
                        orderDirection: orderDirection,
                        fetchResults: fetchResults,
                        fetchExtraProps: fetchExtraProps
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $731d79c43329f1a4$export$908473471e9c0307,
                children: [
                    currentPage !== 1 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                        icon: "keyboard_arrow_left",
                        className: $731d79c43329f1a4$export$642451158120d88a,
                        onClick: ()=>handlePageChange(currentPage - 1)
                    }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {}),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $54cb69781cf7322a$export$2e2bcd8739ae039), {
                        totalPages: totalPages,
                        allPages: allPages,
                        selectedPage: currentPage,
                        activeStyles: $731d79c43329f1a4$export$ba319923d57aa6fe,
                        handlePageChange: (page)=>handlePageChange(page)
                    }),
                    currentPage !== totalPages && totalPages > 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                        icon: "keyboard_arrow_right",
                        className: $731d79c43329f1a4$export$642451158120d88a,
                        onClick: ()=>handlePageChange(currentPage + 1)
                    }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {})
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $731d79c43329f1a4$export$4945c604e8eedb97,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        children: "Go To Page:"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("form", {
                        onSubmit: (event)=>{
                            event.preventDefault();
                            handlePageChange(inputPage);
                        },
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $db32c8adf65b4dff$export$2e2bcd8739ae039), {
                            id: "outlined-page-input",
                            margin: "dense",
                            variant: "outlined",
                            type: "number",
                            onChange: (event)=>setInputPage(Number(event.target.value)),
                            value: inputPage === 0 ? '0' : inputPage ? inputPage.toString().replace(/^0+/, '') : '',
                            tabIndex: 1
                        })
                    })
                ]
            })
        ]
    });
};
var $f021d555e7f7d483$export$2e2bcd8739ae039 = $f021d555e7f7d483$var$Pagination;





parcelRequire("ieT14");


var $ekezX = parcelRequire("ekezX");
const $f5afe0f42548a953$var$SecondaryButton = ({ text: text, title: title, deactive: deactive, styles: extraStyles, handleClick: handleClick, component: component, preventDefault: preventDefault, ...rest })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $ekezX.default), {
        ...rest,
        title: title,
        className: deactive ? $fdbf0d9f77db804d$export$38fc320d708abb25 : $fdbf0d9f77db804d$export$130dd2cd4186e923,
        onClick: (event)=>{
            if (preventDefault === undefined || preventDefault) event.preventDefault();
            handleClick();
        },
        variant: "contained",
        color: "primary",
        disabled: deactive,
        style: extraStyles,
        component: component,
        children: text
    });
};
var $f5afe0f42548a953$export$2e2bcd8739ae039 = $f5afe0f42548a953$var$SecondaryButton;



var $eYoAG = parcelRequire("eYoAG");


/**
 * Management
 * @function Management - Outer component for the management page
 */ const $0ad5c88c6d9fec0c$var$Management = ()=>{
    const { state: state } = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { pageSize: pageSize, currentPage: currentPage, orderColumn: orderColumn, orderDirection: orderDirection } = $ieT14.useContext((0, $1931bd0aa9be7e6d$export$45320e1731c4b48f));
    const { loading: loading, results: results, totalResults: totalResults, fetchClientsPage: fetchClientsPage } = (0, $1c9f4c0c68498da7$export$2e2bcd8739ae039)();
    const { searchQuery: searchTerm, updateSearchQuery: updateSearchQuery, setIsSearching: setIsSearching } = (0, $b48f023b055940c4$export$2e2bcd8739ae039)();
    const announcementCount = +!!state.clientAnnouncement + +!!state.globalAnnouncement;
    const { measuredRef: measuredRef, dimensions: dimensions } = (0, $d9ed1b1da5a3379c$export$2e2bcd8739ae039)([
        results,
        announcementCount
    ], true);
    const [redirectToAddClient, setRedirectToAddClient] = $ieT14.useState(false);
    const { fetchCurrentUserRole: fetchCurrentUserRole, currentUserRole: currentUserRole, loadingAssociatedData: loadingAssociatedData } = (0, $b19aa392df0f3838$export$2e2bcd8739ae039)();
    const [userRole, setUserRole] = $ieT14.useState('');
    // Fetches the client information for the page on mount
    $ieT14.useEffect(()=>{
        fetchClientsPage({
            currentPage: currentPage,
            pageSize: pageSize,
            searchTerm: searchTerm,
            orderColumn: orderColumn,
            orderDirection: orderDirection
        });
        fetchCurrentUserRole();
    }, []);
    $ieT14.useEffect(()=>{
        if (!loadingAssociatedData) setUserRole(currentUserRole);
    }, [
        loadingAssociatedData
    ]);
    const canAddClient = ()=>{
        return userRole === 'Elite Admin' || userRole === 'Super Admin';
    };
    if (redirectToAddClient) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Redirect), {
        push: true,
        to: {
            pathname: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).AddClient
        }
    });
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $fffe59a493fce4d8$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $fffe59a493fce4d8$export$38e42c68cf43b5d4,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center'
                        },
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h1", {
                                children: "Clients"
                            }),
                            canAddClient() && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f5afe0f42548a953$export$2e2bcd8739ae039), {
                                text: "Add a Client",
                                title: "Add a Client",
                                handleClick: ()=>setRedirectToAddClient(true)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $00cebbc6f72b4773$export$2e2bcd8739ae039), {
                        value: searchTerm,
                        updateValue: (val)=>updateSearchQuery(val),
                        setIsSearching: (searching)=>setIsSearching(searching),
                        placeholder: 'Search Clients',
                        submitHandler: ()=>fetchClientsPage({
                                currentPage: 1,
                                pageSize: pageSize,
                                searchTerm: searchTerm,
                                orderColumn: orderColumn,
                                orderDirection: orderDirection
                            })
                    })
                ]
            }),
            loading && results.length === 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $fffe59a493fce4d8$export$c4b0f5819f6a6663,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
            }) : !results || results.length === 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                children: "There are no clients."
            }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $fffe59a493fce4d8$export$3481c78889e8fbe8,
                ref: measuredRef,
                style: {
                    height: `calc(100vh - ${dimensions ? 20 + dimensions.top : 0}px`
                },
                children: [
                    loading && results.length > 0 || loading && results.length === 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: $fffe59a493fce4d8$export$c4b0f5819f6a6663,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
                    }) : null,
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        className: $fffe59a493fce4d8$export$a7db06668cad9adb,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                                    className: $fffe59a493fce4d8$export$3f6d243f5dbc1961,
                                    children: [
                                        totalResults,
                                        " results"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $76768940c212fa94$export$2e2bcd8739ae039), {
                                loading: loading || loadingAssociatedData,
                                isClientAdmin: userRole === 'Client Admin'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f021d555e7f7d483$export$2e2bcd8739ae039), {
                        fetchResults: fetchClientsPage,
                        paginatedContext: (0, $1931bd0aa9be7e6d$export$45320e1731c4b48f),
                        searchTerm: searchTerm
                    })
                ]
            })
        ]
    });
};
var $0ad5c88c6d9fec0c$export$2e2bcd8739ae039 = $0ad5c88c6d9fec0c$var$Management;




var $ieT14 = parcelRequire("ieT14");
var $f2b16bcfb478c50c$export$b0377cbbbdab6cba;
var $f2b16bcfb478c50c$export$f27f0a643498ce3d;
var $f2b16bcfb478c50c$export$b00c055587dc7469;
var $f2b16bcfb478c50c$export$b1a09d22b7ad6c4;
var $f2b16bcfb478c50c$export$509f3108fdd206bb;
var $f2b16bcfb478c50c$export$42ff741d2868ee32;
var $f2b16bcfb478c50c$export$8c430709db82137d;
var $f2b16bcfb478c50c$export$2d4b1211b4389c3b;
var $f2b16bcfb478c50c$export$3832be13857745bc;
var $f2b16bcfb478c50c$export$f4c68800b094ddb1;
var $f2b16bcfb478c50c$export$c5c64a3ebe462da4;
var $f2b16bcfb478c50c$export$38e42c68cf43b5d4;
var $f2b16bcfb478c50c$export$f22da7240b7add18;
var $f2b16bcfb478c50c$export$3f6d243f5dbc1961;
var $f2b16bcfb478c50c$export$ad379ef99350a631;
var $f2b16bcfb478c50c$export$6fbb9cd2843e91b2;
var $f2b16bcfb478c50c$export$27c57cc52d388509;
var $f2b16bcfb478c50c$export$f9f0abb6616caaca;
var $f2b16bcfb478c50c$export$82462a21aead86ed;
var $f2b16bcfb478c50c$export$57ad902a600ecd80;
var $f2b16bcfb478c50c$export$5b26fc7e638ec99f;
var $f2b16bcfb478c50c$export$4c396c7e5aec5550;
var $f2b16bcfb478c50c$export$1ca1ec8b29a4ce27;
var $f2b16bcfb478c50c$export$45d514ce1c64ae8a;
var $f2b16bcfb478c50c$export$acf4eaf431084f78;
var $f2b16bcfb478c50c$export$216c8a0373c9171b;
var $f2b16bcfb478c50c$export$9eaeb132619b6fc;
var $f2b16bcfb478c50c$export$37ea226ff2a44552;
var $f2b16bcfb478c50c$export$afcc4a2b8a081448;
var $f2b16bcfb478c50c$export$fb184b623420d9be;
var $f2b16bcfb478c50c$export$bc48b8aea52cfd28;
var $f2b16bcfb478c50c$export$b07e517d22efa1ca;
var $f2b16bcfb478c50c$export$f77685c252cbae87;
var $f2b16bcfb478c50c$export$b96bb35bc88d6fa;
var $f2b16bcfb478c50c$export$342db1f7d8ce61ac;
var $f2b16bcfb478c50c$export$e7d47881ec916f76;
var $f2b16bcfb478c50c$export$969e6b359c3584e7;
var $f2b16bcfb478c50c$export$73ba5813cda80a49;
var $f2b16bcfb478c50c$export$ba34808fa9be5682;
var $f2b16bcfb478c50c$export$269f8f10d9f976b6;
var $f2b16bcfb478c50c$export$193b67f0c6231f98;
var $f2b16bcfb478c50c$export$e0dc1a1d8b3e2bdb;
var $f2b16bcfb478c50c$export$41bdc12d2d25233b;
var $f2b16bcfb478c50c$export$5dd819bdfbc7b15d;
var $f2b16bcfb478c50c$export$4945c604e8eedb97;
var $f2b16bcfb478c50c$export$908473471e9c0307;
var $f2b16bcfb478c50c$export$ba319923d57aa6fe;
var $f2b16bcfb478c50c$export$e02e799aaaceeea7;
var $f2b16bcfb478c50c$export$5b0f3a3d8bdfc3fb;
var $f2b16bcfb478c50c$export$c4b0f5819f6a6663;
$f2b16bcfb478c50c$export$b0377cbbbdab6cba = "#006da8";
$f2b16bcfb478c50c$export$f27f0a643498ce3d = "#00aafc";
$f2b16bcfb478c50c$export$b00c055587dc7469 = "#f5dbd9";
$f2b16bcfb478c50c$export$b1a09d22b7ad6c4 = "#c92100";
$f2b16bcfb478c50c$export$509f3108fdd206bb = "#ebafa6";
$f2b16bcfb478c50c$export$42ff741d2868ee32 = "#074f86";
$f2b16bcfb478c50c$export$8c430709db82137d = "#dadada";
$f2b16bcfb478c50c$export$2d4b1211b4389c3b = "#dddbda";
$f2b16bcfb478c50c$export$3832be13857745bc = "#eae9ed";
$f2b16bcfb478c50c$export$f4c68800b094ddb1 = "#e9e8f4";
$f2b16bcfb478c50c$export$c5c64a3ebe462da4 = "supportContainer_2c83b5";
$f2b16bcfb478c50c$export$38e42c68cf43b5d4 = "header_2c83b5";
$f2b16bcfb478c50c$export$f22da7240b7add18 = "main_2c83b5";
$f2b16bcfb478c50c$export$3f6d243f5dbc1961 = "resultsCount_2c83b5";
$f2b16bcfb478c50c$export$ad379ef99350a631 = "sidebarContainer_2c83b5";
$f2b16bcfb478c50c$export$6fbb9cd2843e91b2 = "sidebar_2c83b5";
$f2b16bcfb478c50c$export$27c57cc52d388509 = "collapsed_2c83b5";
$f2b16bcfb478c50c$export$f9f0abb6616caaca = "collapsedFilters_2c83b5";
$f2b16bcfb478c50c$export$82462a21aead86ed = "filters_2c83b5";
$f2b16bcfb478c50c$export$57ad902a600ecd80 = "scrollTable_2c83b5";
$f2b16bcfb478c50c$export$5b26fc7e638ec99f = "filterSection_2c83b5";
$f2b16bcfb478c50c$export$4c396c7e5aec5550 = "filterButtons_2c83b5";
$f2b16bcfb478c50c$export$1ca1ec8b29a4ce27 = "icon_2c83b5";
$f2b16bcfb478c50c$export$45d514ce1c64ae8a = "topSection_2c83b5";
$f2b16bcfb478c50c$export$acf4eaf431084f78 = "iconContainer_2c83b5";
$f2b16bcfb478c50c$export$216c8a0373c9171b = "collapsedIconContainer_2c83b5";
$f2b16bcfb478c50c$export$9eaeb132619b6fc = "clearSection_2c83b5";
$f2b16bcfb478c50c$export$37ea226ff2a44552 = "collapsedClear_2c83b5";
$f2b16bcfb478c50c$export$afcc4a2b8a081448 = "filterCount_2c83b5";
$f2b16bcfb478c50c$export$fb184b623420d9be = "title_2c83b5";
$f2b16bcfb478c50c$export$bc48b8aea52cfd28 = "checkboxForm_2c83b5";
$f2b16bcfb478c50c$export$b07e517d22efa1ca = "checkbox_2c83b5";
$f2b16bcfb478c50c$export$f77685c252cbae87 = "checkboxActive_2c83b5";
$f2b16bcfb478c50c$export$b96bb35bc88d6fa = "checked_2c83b5";
$f2b16bcfb478c50c$export$342db1f7d8ce61ac = "paginatedContent_2c83b5";
$f2b16bcfb478c50c$export$e7d47881ec916f76 = "tableWrapper_2c83b5";
$f2b16bcfb478c50c$export$969e6b359c3584e7 = "sortContainer_2c83b5";
$f2b16bcfb478c50c$export$73ba5813cda80a49 = "bold_2c83b5";
$f2b16bcfb478c50c$export$ba34808fa9be5682 = "sortIcons_2c83b5";
$f2b16bcfb478c50c$export$269f8f10d9f976b6 = "refRow_2c83b5";
$f2b16bcfb478c50c$export$193b67f0c6231f98 = "noResults_2c83b5";
$f2b16bcfb478c50c$export$e0dc1a1d8b3e2bdb = "typeRow_2c83b5";
$f2b16bcfb478c50c$export$41bdc12d2d25233b = "summaryRow_2c83b5";
$f2b16bcfb478c50c$export$5dd819bdfbc7b15d = "paginationContainer_2c83b5";
$f2b16bcfb478c50c$export$4945c604e8eedb97 = "pageSelection_2c83b5";
$f2b16bcfb478c50c$export$908473471e9c0307 = "pageNumbers_2c83b5";
$f2b16bcfb478c50c$export$ba319923d57aa6fe = "activePage_2c83b5";
$f2b16bcfb478c50c$export$e02e799aaaceeea7 = "pageAmount_2c83b5";
$f2b16bcfb478c50c$export$5b0f3a3d8bdfc3fb = "pageAmountActive_2c83b5";
$f2b16bcfb478c50c$export$c4b0f5819f6a6663 = "circularProgress_2c83b5";




var $fpdl2 = parcelRequire("fpdl2");

var $ieT14 = parcelRequire("ieT14");

var $fRnKy = parcelRequire("fRnKy");


var $ieT14 = parcelRequire("ieT14");
const $9308be3dff04d2e5$var$defaultState = {
    loading: false,
    tickets: [],
    currentPage: 0,
    totalTickets: 1,
    pageSize: 60,
    orderDirection: null,
    orderColumn: '',
    searchQuery: '',
    allFilters: {
        organizations: [],
        types: [],
        statuses: [],
        requesters: []
    },
    selectedFilters: {
        requestTypeSelected: [],
        statusSelected: [],
        requesterSelected: [],
        organizationSelected: [],
        createdDateStart: null,
        createdDateEnd: null
    },
    localSelectedFilters: {
        requestTypeSelected: [],
        statusSelected: [],
        requesterSelected: [],
        organizationSelected: [],
        createdDateStart: null,
        createdDateEnd: null
    }
};
const $9308be3dff04d2e5$export$21063b480a162460 = /*#__PURE__*/ $ieT14.createContext(null);
const $9308be3dff04d2e5$export$74662fe143c1a260 = $9308be3dff04d2e5$export$21063b480a162460.Consumer;
const $9308be3dff04d2e5$export$692b183921950b7b = (props)=>{
    const [state, setState] = (0, $ieT14.useState)($9308be3dff04d2e5$var$defaultState);
    const dispatch = (newValue)=>{
        setState((prevState)=>{
            return {
                ...prevState,
                ...newValue
            };
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($9308be3dff04d2e5$export$21063b480a162460.Provider, {
        value: {
            ...state,
            dispatch: dispatch
        },
        children: props.children
    });
};


/**
 * FilterType
 * @enum FilterType - Types of filters that can be applied for the support page
 */ var $86201414f684ef37$var$FilterType = /*#__PURE__*/ function(FilterType) {
    /** Filter by type of ticket */ FilterType["Type"] = "Type";
    /** Filter by ticket status */ FilterType["Status"] = "Status";
    /** Filter by requester */ FilterType["Requester"] = "Requester";
    /** Filter by organization */ FilterType["Organization"] = "Organization";
    /** Filter by date ticket was created */ FilterType["CreatedDate"] = "Date Created";
    return FilterType;
}($86201414f684ef37$var$FilterType || {});
var $86201414f684ef37$export$2e2bcd8739ae039 = $86201414f684ef37$var$FilterType;



var $3umuy = parcelRequire("3umuy");

/**
 * useSupport
 * @function useSupport - Custom hook for the support page
 */ const $fb8741f1dceab0dd$var$useSupport = ()=>{
    const { loading: loading, tickets: tickets, dispatch: dispatch, orderDirection: orderDirection, orderColumn: orderColumn, allFilters: allFilters, localSelectedFilters: localSelectedFilters, searchQuery: searchQuery, pageSize: pageSize } = $ieT14.useContext((0, $9308be3dff04d2e5$export$21063b480a162460));
    const { getAuth: getAuth, postAuth: postAuth } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    /**
   * getSupportTickets
   * @method getSupportTickets - API call to receive the support tickets
   * @param clientId Identifier of the client to which the tickets belong
   * @param filters Optional filters to retrieve specific tickets
   */ const getSupportTickets = (clientId, filters)=>{
        return postAuth(`api/clients/${clientId}/support/tickets/list`, filters).then((json)=>{
            return json;
        }).catch((err)=>err);
    };
    /**
   * getSupportTicket
   * @method getSupportTicket - API call to retrieve a single support ticket
   * @param clientId Identifier of the client to which the ticket belongs to
   * @param issueId Identifier of the support ticket
   */ const getSupportTicket = (clientId, issueId)=>{
        return postAuth(`api/clients/${clientId}/support/tickets/${issueId}`, null).then((json)=>{
            return json;
        }).catch((err)=>err);
    };
    /**
   * getSupportTicket
   * @method getSupportTicket - API call to retrieve a single support ticket
   * @param clientId Identifier of the client to which the ticket belongs to
   * @param issueId Identifier of the support ticket
   */ const postTicket = (clientId, options)=>{
        return postAuth(`api/clients/${clientId}/support/tickets`, options).then((json)=>{
            return json;
        }).catch((err)=>err);
    };
    /**
   * postComments
   * @method postComments - API call to add a comment to a support ticket
   * @param clientId Identifier of the client to which the ticket belong
   * @param issueId Identifier of the support ticket
   * @param comment Information about the comment to be added
   */ const postComments = (clientId, issueId, comment)=>{
        return postAuth(`api/clients/${clientId}/support/tickets/${issueId}/comments`, comment).then((json)=>{
            return json;
        }).catch((err)=>err);
    };
    /**
   * getSupportFilters
   * @method getSupportFilters - A group of API calls to receive the different filters available for support
   * @param clientId Identifier of the client to which the tickets belong
   * @returns An object that contains filters { organizations, types, statuses, requesters }
   */ const getSupportFilters = (clientId)=>{
        /** @const getOrganizations - Gets the organization filters */ const getOrganizations = getAuth(`api/clients/${clientId}/support/organizations`).then((json)=>{
            return json.length > 0 ? json.map((item)=>item.name) : json;
        }).catch((err)=>err);
        /** @const getTypes - Gets the types filters */ const getTypes = getAuth(`api/clients/${clientId}/support/types`).then((json)=>{
            return json;
        }).catch((err)=>err);
        /** @const getStatuses - Gets the statuses filters */ const getStatuses = getAuth(`api/clients/${clientId}/support/statuses`).then((json)=>{
            return json;
        }).catch((err)=>err);
        /** @const getRequesters - Gets the requesters filters */ const getRequesters = getAuth(`api/clients/${clientId}/support/requesters`).then((json)=>{
            return json;
        }).catch((err)=>err);
        return Promise.all([
            getOrganizations,
            getTypes,
            getStatuses,
            getRequesters
        ]).then(([organizations, types, statuses, requesters])=>{
            return {
                organizations: organizations,
                types: types,
                statuses: statuses,
                requesters: requesters
            };
        });
    };
    /**
   * fetchSupportTickets
   * @function fetchSupportTickets - Fetches the support tickets from the backend and sets them to the state
   * @param clientId Id of the active client
   * @param options Options to narrow down search results
   * @param firstRender Optional boolean argument indicating whether this call is the first render
   */ const fetchSupportTickets = (clientId, options, firstRender)=>{
        dispatch({
            loading: true
        });
        if (options) {
            options.createdDateStart = options.createdDateStart ? (0, (/*@__PURE__*/$parcel$interopDefault($3umuy)))(options.createdDateStart).format('YYYY/MM/DD') : '';
            options.createdDateEnd = options.createdDateEnd ? (0, (/*@__PURE__*/$parcel$interopDefault($3umuy)))(options.createdDateEnd).format('YYYY/MM/DD') : '';
        }
        return getSupportTickets(clientId, options || null).then((response)=>{
            response.tickets.map((ticket)=>{
                ticket.createdTime = new Date(ticket.createdTime).toLocaleDateString('en-US', {
                    month: '2-digit',
                    day: '2-digit',
                    year: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit'
                }).replace(',', '');
                ticket.updatedTime = new Date(ticket.updatedTime).toLocaleDateString('en-US', {
                    month: '2-digit',
                    day: '2-digit',
                    year: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit'
                }).replace(',', '');
                return ticket;
            });
            !firstRender && dispatch({
                totalTickets: response.totalTickets,
                tickets: response.tickets,
                orderDirection: options && options.orderDirection,
                orderColumn: options && options.orderColumn,
                searchQuery: options && options.searchTerm,
                pageSize: options && options.count,
                currentPage: options && options.startAt,
                loading: false
            });
            return {
                totalTickets: response.totalTickets,
                tickets: response.tickets
            };
        }).catch(()=>dispatch({
                loading: false
            }));
    };
    /**
   * fetchSupportInformation
   * @function fetchSupportInformation - Fetches support ticket information and sets it into context
   * @param clientId Identifier of the client to which the tickets belong
   * @param options Options to narrow down search results
   */ const fetchSupportInformation = (clientId, options)=>{
        Promise.all([
            fetchSupportTickets(clientId, options, true),
            getSupportFilters(clientId)
        ]).then(([supportInfo, allFilters])=>{
            dispatch({
                ...supportInfo,
                allFilters: allFilters,
                loading: false
            });
        });
    };
    /**
   * addComment
   * @function addComment - Adds a comment to an issue
   * @param clientId Identifier of the client to which the tickets belong
   * @param issueId Identifier of the support issue
   * @param comment Comment details
   */ const addComment = (clientId, issueId, comment)=>{
        postComments(clientId, issueId, comment).then(()=>{
            getSupportTicket(clientId, issueId).then((ticket)=>{
                const ticketsClone = $fRnKy.cloneDeep(tickets);
                const updatedTickets = ticketsClone.map((issue)=>{
                    if (ticket.issueName === issue.issueName) return ticket;
                    return issue;
                });
                dispatch({
                    tickets: updatedTickets
                });
            });
        });
    };
    const addSupportTicket = (clientId, request)=>{
        return postTicket(clientId, request).then((json)=>{
            return json;
        }).catch((err)=>err);
    };
    /**
   * clearAllFilters
   * @function clearAllFilters Unchecks all the filters
   */ const clearAllFilters = (clientId)=>{
        const localFilters = {
            requestTypeSelected: [],
            statusSelected: [],
            requesterSelected: [],
            organizationSelected: [],
            createdDateStart: null,
            createdDateEnd: null
        };
        dispatch({
            selectedFilters: localFilters,
            localSelectedFilters: localFilters
        });
        fetchSupportTickets(clientId, {
            ...localFilters,
            orderColumn: orderColumn,
            orderDirection: orderDirection,
            searchTerm: searchQuery,
            startAt: 0,
            count: pageSize
        });
    };
    /**
   * countFilters
   * @function countFilters - Counts the amount of filters that have been applied. Excludes null values and incomplete dates
   */ const countFilters = ()=>{
        return [].concat.apply([], Object.values(localSelectedFilters)).filter((item)=>{
            if (!item || item._isAMomentObject && !item._isValid) return;
            return item;
        }).length;
    };
    /**
   * updateLocalFilters
   * @function updateLocalFilters - Updates the local filters as the user is updating
   * @param filterType Type of filter to be applied
   * @param value Name or date of the filter
   * @param checked Boolean value indicating whether the checkbox is checked
   * @param startDate Boolean value indicating whether the date is a start date
   */ const updateLocalFilters = (filterType, value, checked, startDate)=>{
        let updatedFilters;
        if (filterType === (0, $86201414f684ef37$export$2e2bcd8739ae039).CreatedDate) {
            if (startDate) return dispatch({
                localSelectedFilters: {
                    ...localSelectedFilters,
                    createdDateStart: value
                }
            });
            return dispatch({
                localSelectedFilters: {
                    ...localSelectedFilters,
                    createdDateEnd: value
                }
            });
        }
        if (checked) {
            if (!value) {
                switch(filterType){
                    case (0, $86201414f684ef37$export$2e2bcd8739ae039).Organization:
                        updatedFilters = [];
                        dispatch({
                            localSelectedFilters: {
                                ...localSelectedFilters,
                                organizationSelected: [
                                    ...updatedFilters
                                ]
                            }
                        });
                        break;
                    case (0, $86201414f684ef37$export$2e2bcd8739ae039).Requester:
                        updatedFilters = [];
                        dispatch({
                            localSelectedFilters: {
                                ...localSelectedFilters,
                                requesterSelected: [
                                    ...updatedFilters
                                ]
                            }
                        });
                        break;
                    case (0, $86201414f684ef37$export$2e2bcd8739ae039).Status:
                        updatedFilters = [];
                        dispatch({
                            localSelectedFilters: {
                                ...localSelectedFilters,
                                statusSelected: [
                                    ...updatedFilters
                                ]
                            }
                        });
                        break;
                    case (0, $86201414f684ef37$export$2e2bcd8739ae039).Type:
                        updatedFilters = [];
                        dispatch({
                            localSelectedFilters: {
                                ...localSelectedFilters,
                                requestTypeSelected: [
                                    ...updatedFilters
                                ]
                            }
                        });
                        break;
                }
                return;
            }
            switch(filterType){
                case (0, $86201414f684ef37$export$2e2bcd8739ae039).Organization:
                    updatedFilters = localSelectedFilters.organizationSelected.filter((item)=>item !== value);
                    dispatch({
                        localSelectedFilters: {
                            ...localSelectedFilters,
                            organizationSelected: updatedFilters
                        }
                    });
                    break;
                case (0, $86201414f684ef37$export$2e2bcd8739ae039).Requester:
                    updatedFilters = localSelectedFilters.requesterSelected.filter((item)=>item !== value);
                    dispatch({
                        localSelectedFilters: {
                            ...localSelectedFilters,
                            requesterSelected: updatedFilters
                        }
                    });
                    break;
                case (0, $86201414f684ef37$export$2e2bcd8739ae039).Status:
                    updatedFilters = localSelectedFilters.statusSelected.filter((item)=>item !== value);
                    dispatch({
                        localSelectedFilters: {
                            ...localSelectedFilters,
                            statusSelected: updatedFilters
                        }
                    });
                    break;
                case (0, $86201414f684ef37$export$2e2bcd8739ae039).Type:
                    updatedFilters = localSelectedFilters.requestTypeSelected.filter((item)=>item !== value && item.text !== value);
                    dispatch({
                        localSelectedFilters: {
                            ...localSelectedFilters,
                            requestTypeSelected: updatedFilters
                        }
                    });
                    break;
            }
        } else {
            if (!value) {
                switch(filterType){
                    case (0, $86201414f684ef37$export$2e2bcd8739ae039).Organization:
                        updatedFilters = allFilters.organizations;
                        dispatch({
                            localSelectedFilters: {
                                ...localSelectedFilters,
                                organizationSelected: updatedFilters
                            }
                        });
                        break;
                    case (0, $86201414f684ef37$export$2e2bcd8739ae039).Requester:
                        updatedFilters = allFilters.requesters;
                        dispatch({
                            localSelectedFilters: {
                                ...localSelectedFilters,
                                requesterSelected: updatedFilters
                            }
                        });
                        break;
                    case (0, $86201414f684ef37$export$2e2bcd8739ae039).Status:
                        updatedFilters = allFilters.statuses;
                        dispatch({
                            localSelectedFilters: {
                                ...localSelectedFilters,
                                statusSelected: updatedFilters
                            }
                        });
                        break;
                    case (0, $86201414f684ef37$export$2e2bcd8739ae039).Type:
                        updatedFilters = allFilters.types;
                        dispatch({
                            localSelectedFilters: {
                                ...localSelectedFilters,
                                requestTypeSelected: [
                                    ...updatedFilters
                                ]
                            }
                        });
                        break;
                }
                return;
            }
            switch(filterType){
                case (0, $86201414f684ef37$export$2e2bcd8739ae039).Organization:
                    updatedFilters = localSelectedFilters.organizationSelected.concat([
                        value
                    ]);
                    dispatch({
                        localSelectedFilters: {
                            ...localSelectedFilters,
                            organizationSelected: updatedFilters
                        }
                    });
                    break;
                case (0, $86201414f684ef37$export$2e2bcd8739ae039).Requester:
                    updatedFilters = localSelectedFilters.requesterSelected.concat([
                        value
                    ]);
                    dispatch({
                        localSelectedFilters: {
                            ...localSelectedFilters,
                            requesterSelected: updatedFilters
                        }
                    });
                    break;
                case (0, $86201414f684ef37$export$2e2bcd8739ae039).Status:
                    updatedFilters = localSelectedFilters.statusSelected.concat([
                        value
                    ]);
                    dispatch({
                        localSelectedFilters: {
                            ...localSelectedFilters,
                            statusSelected: updatedFilters
                        }
                    });
                    break;
                case (0, $86201414f684ef37$export$2e2bcd8739ae039).Type:
                    updatedFilters = localSelectedFilters.requestTypeSelected.concat([
                        value
                    ]);
                    dispatch({
                        localSelectedFilters: {
                            ...localSelectedFilters,
                            requestTypeSelected: updatedFilters
                        }
                    });
                    break;
            }
        }
    };
    return {
        loading: loading,
        tickets: tickets,
        fetchSupportTickets: fetchSupportTickets,
        fetchSupportInformation: fetchSupportInformation,
        orderDirection: orderDirection,
        orderColumn: orderColumn,
        allFilters: allFilters,
        updateLocalFilters: updateLocalFilters,
        clearAllFilters: clearAllFilters,
        countFilters: countFilters,
        addComment: addComment,
        addSupportTicket: addSupportTicket
    };
};
var $fb8741f1dceab0dd$export$2e2bcd8739ae039 = $fb8741f1dceab0dd$var$useSupport;








var $ieT14 = parcelRequire("ieT14");

var $fRnKy = parcelRequire("fRnKy");





var $ieT14 = parcelRequire("ieT14");


var $knRao = parcelRequire("knRao");
var $3WBJn = parcelRequire("3WBJn");


parcelRequire("ieT14");
function $f15ea8c2d53f96ab$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $f15ea8c2d53f96ab$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f15ea8c2d53f96ab$export$2e2bcd8739ae039(o);
}



function $df3477f0cc68bcd5$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $f15ea8c2d53f96ab$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $f15ea8c2d53f96ab$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $dd74376acd5e854c$export$2e2bcd8739ae039(t) {
    var i = (0, $df3477f0cc68bcd5$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $f15ea8c2d53f96ab$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $c5c97159e13895ef$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $dd74376acd5e854c$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



var $ieT14 = parcelRequire("ieT14");


var $ieT14 = parcelRequire("ieT14");

var $227fe7cc0a67c04e$export$407448d2b89b1813 = (0, $ieT14.createContext)(null);
var $227fe7cc0a67c04e$export$3a1a48c8f6ef640e = function MuiPickersUtilsProvider(_ref) {
    var Utils = _ref.utils, children = _ref.children, locale = _ref.locale, libInstance = _ref.libInstance;
    var utils = (0, $ieT14.useMemo)(function() {
        return new Utils({
            locale: locale,
            instance: libInstance
        });
    }, [
        Utils,
        libInstance,
        locale
    ]);
    return (0, $ieT14.createElement)($227fe7cc0a67c04e$export$407448d2b89b1813.Provider, {
        value: utils,
        children: children
    });
};
var $227fe7cc0a67c04e$var$checkUtils = function checkUtils(utils) {
    if (!utils) // tslint:disable-next-line
    throw new Error('Can not find utils in context. You either a) forgot to wrap your component tree in MuiPickersUtilsProvider; or b) mixed named and direct file imports.  Recommendation: use named imports from the module index.');
};
function $227fe7cc0a67c04e$export$3b14a55fb2447963() {
    var utils = (0, $ieT14.useContext)($227fe7cc0a67c04e$export$407448d2b89b1813);
    $227fe7cc0a67c04e$var$checkUtils(utils);
    return utils;
}



var $j6s32 = parcelRequire("j6s32");
function $c902b5d6d6384f3f$export$2e2bcd8739ae039() {
    return $c902b5d6d6384f3f$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c902b5d6d6384f3f$export$2e2bcd8739ae039.apply(null, arguments);
}


function $549adfa88b12ebb9$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $47143c6253cef6b3$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $549adfa88b12ebb9$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}




var $e1ONw = parcelRequire("e1ONw");


var $ieT14 = parcelRequire("ieT14");



var $j6s32 = parcelRequire("j6s32");



var $47zxZ = parcelRequire("47zxZ");

var $kRJN7 = parcelRequire("kRJN7");
var $86m3e = parcelRequire("86m3e");
var $e1ONw = parcelRequire("e1ONw");
var $aIJrd = parcelRequire("aIJrd");

var $ekezX = parcelRequire("ekezX");

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $9p9Gy = parcelRequire("9p9Gy");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $aIJrd = parcelRequire("aIJrd");
var $a8f70a0d45f814be$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center'
        },
        /* Styles applied to the root element if `disableGutters={false}`. */ gutters: (0, $9p9Gy.default)({
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        }, theme.breakpoints.up('sm'), {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }),
        /* Styles applied to the root element if `variant="regular"`. */ regular: theme.mixins.toolbar,
        /* Styles applied to the root element if `variant="dense"`. */ dense: {
            minHeight: 48
        }
    };
};
var $a8f70a0d45f814be$var$Toolbar = /*#__PURE__*/ $ieT14.forwardRef(function Toolbar(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$variant = props.variant, variant = _props$variant === void 0 ? 'regular' : _props$variant, other = (0, $eTwGP.default)(props, [
        "classes",
        "className",
        "component",
        "disableGutters",
        "variant"
    ]);
    return /*#__PURE__*/ $ieT14.createElement(Component, (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, classes[variant], className, !disableGutters && classes.gutters),
        ref: ref
    }, other));
});
var $a8f70a0d45f814be$export$2e2bcd8739ae039 = (0, $aIJrd.default)($a8f70a0d45f814be$export$9dd6ff9ea0189349, {
    name: 'MuiToolbar'
})($a8f70a0d45f814be$var$Toolbar);



var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");



var $kRJN7 = parcelRequire("kRJN7");
var $e1ONw = parcelRequire("e1ONw");
var $aIJrd = parcelRequire("aIJrd");

var $ekezX = parcelRequire("ekezX");

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $aIJrd = parcelRequire("aIJrd");
var $d176cc26269b23c2$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'flex',
        alignItems: 'center',
        padding: 8,
        justifyContent: 'flex-end',
        flex: '0 0 auto'
    },
    /* Styles applied to the root element if `disableSpacing={false}`. */ spacing: {
        '& > :not(:first-child)': {
            marginLeft: 8
        }
    }
};
var $d176cc26269b23c2$var$DialogActions = /*#__PURE__*/ $ieT14.forwardRef(function DialogActions(props, ref) {
    var _props$disableSpacing = props.disableSpacing, disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing, classes = props.classes, className = props.className, other = (0, $eTwGP.default)(props, [
        "disableSpacing",
        "classes",
        "className"
    ]);
    return /*#__PURE__*/ $ieT14.createElement("div", (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className, !disableSpacing && classes.spacing),
        ref: ref
    }, other));
});
var $d176cc26269b23c2$export$2e2bcd8739ae039 = (0, $aIJrd.default)($d176cc26269b23c2$export$9dd6ff9ea0189349, {
    name: 'MuiDialogActions'
})($d176cc26269b23c2$var$DialogActions);





var $lzS53 = parcelRequire("lzS53");
/** Use it instead of .includes method for IE support */ function $e4ddf05ffa240aa3$export$407448d2b89b1813(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every(function(item) {
        return array.indexOf(item) !== -1;
    });
    return array.indexOf(itemOrItems) !== -1;
}
var $e4ddf05ffa240aa3$export$96f57966bedc81b4 = 310;
var $e4ddf05ffa240aa3$export$db3b6bfb95261072 = 325;
var $e4ddf05ffa240aa3$export$8b22cf2602fb60ce = 305;
var $e4ddf05ffa240aa3$var$useStyles = (0, $e1ONw.default)(function(theme) {
    return {
        staticWrapperRoot: {
            overflow: 'hidden',
            minWidth: $e4ddf05ffa240aa3$export$96f57966bedc81b4,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: theme.palette.background.paper
        }
    };
}, {
    name: 'MuiPickersStaticWrapper'
});
var $e4ddf05ffa240aa3$var$StaticWrapper = function StaticWrapper(_ref) {
    var children = _ref.children;
    var classes = $e4ddf05ffa240aa3$var$useStyles();
    return (0, $ieT14.createElement)("div", {
        className: classes.staticWrapperRoot,
        children: children
    });
};
var $e4ddf05ffa240aa3$var$ModalDialog = function ModalDialog(_ref) {
    var children = _ref.children, classes = _ref.classes, onAccept = _ref.onAccept, onDismiss = _ref.onDismiss, onClear = _ref.onClear, onSetToday = _ref.onSetToday, okLabel = _ref.okLabel, cancelLabel = _ref.cancelLabel, clearLabel = _ref.clearLabel, todayLabel = _ref.todayLabel, clearable = _ref.clearable, showTodayButton = _ref.showTodayButton, showTabs = _ref.showTabs, wider = _ref.wider, other = (0, $47143c6253cef6b3$export$2e2bcd8739ae039)(_ref, [
        "children",
        "classes",
        "onAccept",
        "onDismiss",
        "onClear",
        "onSetToday",
        "okLabel",
        "cancelLabel",
        "clearLabel",
        "todayLabel",
        "clearable",
        "showTodayButton",
        "showTabs",
        "wider"
    ]);
    return (0, $ieT14.createElement)((0, $1c689a1559dbf5e9$export$2e2bcd8739ae039), (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({
        role: "dialog",
        onClose: onDismiss,
        classes: {
            paper: (0, $j6s32.default)(classes.dialogRoot, wider && classes.dialogRootWider)
        }
    }, other), (0, $ieT14.createElement)((0, $881610d42277b808$export$2e2bcd8739ae039), {
        children: children,
        className: classes.dialog
    }), (0, $ieT14.createElement)((0, $d176cc26269b23c2$export$2e2bcd8739ae039), {
        classes: {
            root: (0, $j6s32.default)((clearable || showTodayButton) && classes.withAdditionalAction)
        }
    }, clearable && (0, $ieT14.createElement)((0, $ekezX.default), {
        color: "primary",
        onClick: onClear
    }, clearLabel), showTodayButton && (0, $ieT14.createElement)((0, $ekezX.default), {
        color: "primary",
        onClick: onSetToday
    }, todayLabel), cancelLabel && (0, $ieT14.createElement)((0, $ekezX.default), {
        color: "primary",
        onClick: onDismiss
    }, cancelLabel), okLabel && (0, $ieT14.createElement)((0, $ekezX.default), {
        color: "primary",
        onClick: onAccept
    }, okLabel)));
};
$e4ddf05ffa240aa3$var$ModalDialog.displayName = 'ModalDialog';
var $e4ddf05ffa240aa3$var$styles = (0, $kRJN7.default)({
    dialogRoot: {
        minWidth: $e4ddf05ffa240aa3$export$96f57966bedc81b4
    },
    dialogRootWider: {
        minWidth: $e4ddf05ffa240aa3$export$db3b6bfb95261072
    },
    dialog: {
        '&:first-child': {
            padding: 0
        }
    },
    withAdditionalAction: {
        // set justifyContent to default value to fix IE11 layout bug
        // see https://github.com/dmtrKovalenko/material-ui-pickers/pull/267
        justifyContent: 'flex-start',
        '& > *:first-child': {
            marginRight: 'auto'
        }
    }
});
var $e4ddf05ffa240aa3$var$ModalDialog$1 = (0, $aIJrd.default)($e4ddf05ffa240aa3$var$styles, {
    name: 'MuiPickersModal'
})($e4ddf05ffa240aa3$var$ModalDialog);
var $e4ddf05ffa240aa3$export$3b14a55fb2447963 = typeof window === 'undefined' ? (0, $ieT14.useEffect) : (0, $ieT14.useLayoutEffect);
function $e4ddf05ffa240aa3$export$43caf9889c228507(e, keyHandlers) {
    var handler = keyHandlers[e.key];
    if (handler) {
        handler(); // if event was handled prevent other side effects (e.g. page scroll)
        e.preventDefault();
    }
}
function $e4ddf05ffa240aa3$var$useKeyDown(active, keyHandlers) {
    var keyHandlersRef = (0, $ieT14.useRef)(keyHandlers);
    keyHandlersRef.current = keyHandlers;
    $e4ddf05ffa240aa3$export$3b14a55fb2447963(function() {
        if (active) {
            var handleKeyDown = function handleKeyDown(event) {
                $e4ddf05ffa240aa3$export$43caf9889c228507(event, keyHandlersRef.current);
            };
            window.addEventListener('keydown', handleKeyDown);
            return function() {
                window.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [
        active
    ]);
}
var $e4ddf05ffa240aa3$var$ModalWrapper = function ModalWrapper(_ref) {
    var open = _ref.open, children = _ref.children, okLabel = _ref.okLabel, cancelLabel = _ref.cancelLabel, clearLabel = _ref.clearLabel, todayLabel = _ref.todayLabel, showTodayButton = _ref.showTodayButton, clearable = _ref.clearable, DialogProps = _ref.DialogProps, showTabs = _ref.showTabs, wider = _ref.wider, InputComponent = _ref.InputComponent, DateInputProps = _ref.DateInputProps, onClear = _ref.onClear, onAccept = _ref.onAccept, onDismiss = _ref.onDismiss, onSetToday = _ref.onSetToday, other = (0, $47143c6253cef6b3$export$2e2bcd8739ae039)(_ref, [
        "open",
        "children",
        "okLabel",
        "cancelLabel",
        "clearLabel",
        "todayLabel",
        "showTodayButton",
        "clearable",
        "DialogProps",
        "showTabs",
        "wider",
        "InputComponent",
        "DateInputProps",
        "onClear",
        "onAccept",
        "onDismiss",
        "onSetToday"
    ]);
    $e4ddf05ffa240aa3$var$useKeyDown(open, {
        Enter: onAccept
    });
    return (0, $ieT14.createElement)((0, $ieT14.Fragment), null, (0, $ieT14.createElement)(InputComponent, (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({}, other, DateInputProps)), (0, $ieT14.createElement)($e4ddf05ffa240aa3$var$ModalDialog$1, (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({
        wider: wider,
        showTabs: showTabs,
        open: open,
        onClear: onClear,
        onAccept: onAccept,
        onDismiss: onDismiss,
        onSetToday: onSetToday,
        clearLabel: clearLabel,
        todayLabel: todayLabel,
        okLabel: okLabel,
        cancelLabel: cancelLabel,
        clearable: clearable,
        showTodayButton: showTodayButton,
        children: children
    }, DialogProps)));
};
$e4ddf05ffa240aa3$var$ModalWrapper.defaultProps = {
    okLabel: 'OK',
    cancelLabel: 'Cancel',
    clearLabel: 'Clear',
    todayLabel: 'Today',
    clearable: false,
    showTodayButton: false
};
var $e4ddf05ffa240aa3$var$InlineWrapper = function InlineWrapper(_ref) {
    var open = _ref.open, wider = _ref.wider, children = _ref.children, PopoverProps = _ref.PopoverProps, onClear = _ref.onClear, onDismiss = _ref.onDismiss, onSetToday = _ref.onSetToday, onAccept = _ref.onAccept, showTabs = _ref.showTabs, DateInputProps = _ref.DateInputProps, InputComponent = _ref.InputComponent, other = (0, $47143c6253cef6b3$export$2e2bcd8739ae039)(_ref, [
        "open",
        "wider",
        "children",
        "PopoverProps",
        "onClear",
        "onDismiss",
        "onSetToday",
        "onAccept",
        "showTabs",
        "DateInputProps",
        "InputComponent"
    ]);
    var ref = (0, $ieT14.useRef)();
    $e4ddf05ffa240aa3$var$useKeyDown(open, {
        Enter: onAccept
    });
    return (0, $ieT14.createElement)((0, $ieT14.Fragment), null, (0, $ieT14.createElement)(InputComponent, (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({}, other, DateInputProps, {
        inputRef: ref
    })), (0, $ieT14.createElement)((0, $lzS53.default), (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({
        open: open,
        onClose: onDismiss,
        anchorEl: ref.current,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'center'
        },
        children: children
    }, PopoverProps)));
};
function $e4ddf05ffa240aa3$var$getWrapperFromVariant(variant) {
    switch(variant){
        case 'inline':
            return $e4ddf05ffa240aa3$var$InlineWrapper;
        case 'static':
            return $e4ddf05ffa240aa3$var$StaticWrapper;
        default:
            return $e4ddf05ffa240aa3$var$ModalWrapper;
    }
}
var $e4ddf05ffa240aa3$export$e7c866399fa523f5 = (0, $ieT14.createContext)(null);
var $e4ddf05ffa240aa3$export$71cec2538cb2c617 = function Wrapper(_ref) {
    var variant = _ref.variant, props = (0, $47143c6253cef6b3$export$2e2bcd8739ae039)(_ref, [
        "variant"
    ]);
    var Component = $e4ddf05ffa240aa3$var$getWrapperFromVariant(variant);
    return (0, $ieT14.createElement)($e4ddf05ffa240aa3$export$e7c866399fa523f5.Provider, {
        value: variant || 'dialog'
    }, (0, $ieT14.createElement)(Component, props));
};



var $eYT2J = parcelRequire("eYT2J");

var $1KcBP = parcelRequire("1KcBP");

var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $47zxZ = parcelRequire("47zxZ");

var $aIJrd = parcelRequire("aIJrd");

var $bJmSx = parcelRequire("bJmSx");
var $0183086ec949ac76$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'flex',
        height: '0.01em',
        // Fix IE 11 flexbox alignment. To remove at some point.
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap'
    },
    /* Styles applied to the root element if `variant="filled"`. */ filled: {
        '&$positionStart:not($hiddenLabel)': {
            marginTop: 16
        }
    },
    /* Styles applied to the root element if `position="start"`. */ positionStart: {
        marginRight: 8
    },
    /* Styles applied to the root element if `position="end"`. */ positionEnd: {
        marginLeft: 8
    },
    /* Styles applied to the root element if `disablePointerEvents=true`. */ disablePointerEvents: {
        pointerEvents: 'none'
    },
    /* Styles applied if the adornment is used inside <FormControl hiddenLabel />. */ hiddenLabel: {},
    /* Styles applied if the adornment is used inside <FormControl margin="dense" />. */ marginDense: {}
};
var $0183086ec949ac76$var$InputAdornment = /*#__PURE__*/ $ieT14.forwardRef(function InputAdornment(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$disablePointer = props.disablePointerEvents, disablePointerEvents = _props$disablePointer === void 0 ? false : _props$disablePointer, _props$disableTypogra = props.disableTypography, disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra, position = props.position, variantProp = props.variant, other = (0, $eTwGP.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "disablePointerEvents",
        "disableTypography",
        "position",
        "variant"
    ]);
    var muiFormControl = (0, $bJmSx.useFormControl)() || {};
    var variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    return /*#__PURE__*/ $ieT14.createElement((0, $bJmSx.default).Provider, {
        value: null
    }, /*#__PURE__*/ $ieT14.createElement(Component, (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className, position === 'end' ? classes.positionEnd : classes.positionStart, disablePointerEvents && classes.disablePointerEvents, muiFormControl.hiddenLabel && classes.hiddenLabel, variant === 'filled' && classes.filled, muiFormControl.margin === 'dense' && classes.marginDense),
        ref: ref
    }, other), typeof children === 'string' && !disableTypography ? /*#__PURE__*/ $ieT14.createElement((0, $47zxZ.default), {
        color: "textSecondary"
    }, children) : children));
});
var $0183086ec949ac76$export$2e2bcd8739ae039 = (0, $aIJrd.default)($0183086ec949ac76$export$9dd6ff9ea0189349, {
    name: 'MuiInputAdornment'
})($0183086ec949ac76$var$InputAdornment);


function $e9b1f38bc14cf873$export$2e2bcd8739ae039(t, e) {
    return $e9b1f38bc14cf873$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $e9b1f38bc14cf873$export$2e2bcd8739ae039(t, e);
}


function $d70e173f742a74f2$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $e9b1f38bc14cf873$export$2e2bcd8739ae039)(t, o);
}



var $ieT14 = parcelRequire("ieT14");
var $948b1749ef1e7b80$export$5519909ee832c7c = /*#__PURE__*/ function(_React$Component) {
    (0, $d70e173f742a74f2$export$2e2bcd8739ae039)(Rifm, _React$Component);
    function Rifm(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this._state = null;
        _this._del = false;
        _this._handleChange = function(evt) {
            var stateValue = _this.state.value;
            var value = evt.target.value;
            var input = evt.target;
            var op = value.length > stateValue.length;
            var del = _this._del;
            var noOp = stateValue === _this.props.format(value);
            _this.setState({
                value: value,
                local: true
            }, function() {
                var selectionStart = input.selectionStart;
                var refuse = _this.props.refuse || /[^\d]+/g;
                var before = value.substr(0, selectionStart).replace(refuse, '');
                _this._state = {
                    input: input,
                    before: before,
                    op: op,
                    di: del && noOp,
                    del: del
                };
                if (_this.props.replace && _this.props.replace(stateValue) && op && !noOp) {
                    var start = -1;
                    for(var i = 0; i !== before.length; ++i)start = Math.max(start, value.toLowerCase().indexOf(before[i].toLowerCase(), start + 1));
                    var c = value.substr(start + 1).replace(refuse, '')[0];
                    start = value.indexOf(c, start + 1);
                    value = "" + value.substr(0, start) + value.substr(start + 1);
                }
                var fv = _this.props.format(value);
                if (stateValue === fv) _this.setState({
                    value: value
                });
                else _this.props.onChange(fv);
            });
        };
        _this._hKD = function(evt) {
            if (evt.code === 'Delete') _this._del = true;
        };
        _this._hKU = function(evt) {
            if (evt.code === 'Delete') _this._del = false;
        };
        _this.state = {
            value: props.value,
            local: true
        };
        return _this;
    }
    Rifm.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        return {
            value: state.local ? state.value : props.value,
            local: false
        };
    };
    var _proto = Rifm.prototype;
    _proto.render = function render() {
        var _handleChange = this._handleChange, value = this.state.value, children = this.props.children;
        return children({
            value: value,
            onChange: _handleChange
        });
    } // delete when  https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported by all major browsers
    ;
    _proto.componentWillUnmount = function componentWillUnmount() {
        document.removeEventListener('keydown', this._hKD);
        document.removeEventListener('keyup', this._hKU);
    } // delete when  https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported by all major browsers
    ;
    _proto.componentDidMount = function componentDidMount() {
        document.addEventListener('keydown', this._hKD);
        document.addEventListener('keyup', this._hKU);
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
        var _state = this._state;
        if (_state) {
            var value = this.state.value;
            var start = -1;
            for(var i = 0; i !== _state.before.length; ++i)start = Math.max(start, value.toLowerCase().indexOf(_state.before[i].toLowerCase(), start + 1));
             // format usually looks better without this
            if (this.props.replace && (_state.op || _state.del && !_state.di)) while(value[start + 1] && (this.props.refuse || /[^\d]+/).test(value[start + 1]))start += 1;
            _state.input.selectionStart = _state.input.selectionEnd = start + 1 + (_state.di ? 1 : 0);
        }
        this._state = null;
    };
    return Rifm;
}((0, $ieT14.Component));



var $5SbGE = parcelRequire("5SbGE");
function $9796389cac29abfd$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $823697b08e154adb$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $fcc1df6a00ff04bf$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $123c75e948decc87$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $fcc1df6a00ff04bf$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $fcc1df6a00ff04bf$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $e14a564cf4e40383$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $d1e29df46c022672$export$2e2bcd8739ae039(r, e) {
    return (0, $9796389cac29abfd$export$2e2bcd8739ae039)(r) || (0, $823697b08e154adb$export$2e2bcd8739ae039)(r, e) || (0, $123c75e948decc87$export$2e2bcd8739ae039)(r, e) || (0, $e14a564cf4e40383$export$2e2bcd8739ae039)();
}




var $ieT14 = parcelRequire("ieT14");

var $aLnZv = parcelRequire("aLnZv");


var $j6s32 = parcelRequire("j6s32");



var $47zxZ = parcelRequire("47zxZ");

var $e1ONw = parcelRequire("e1ONw");


var $ieT14 = parcelRequire("ieT14");



var $j6s32 = parcelRequire("j6s32");



var $47zxZ = parcelRequire("47zxZ");

var $e1ONw = parcelRequire("e1ONw");
var $hgPMF = parcelRequire("hgPMF");
var $aIJrd = parcelRequire("aIJrd");


var $1KcBP = parcelRequire("1KcBP");

var $5SbGE = parcelRequire("5SbGE");
function $33ad4dc01d447109$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $566a078a6081ffc2$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $dd74376acd5e854c$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $566a078a6081ffc2$export$2e2bcd8739ae039(e, r, t) {
    return r && $566a078a6081ffc2$var$_defineProperties(e.prototype, r), t && $566a078a6081ffc2$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



function $cf34e34772cb037f$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $f9a7e2192d88e5f2$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $f15ea8c2d53f96ab$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $cf34e34772cb037f$export$2e2bcd8739ae039)(t);
}


function $663b6cab2e4d42aa$export$2e2bcd8739ae039(t) {
    return $663b6cab2e4d42aa$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $663b6cab2e4d42aa$export$2e2bcd8739ae039(t);
}


function $0f48027058c7cf8a$export$2e2bcd8739ae039(t, e) {
    return $0f48027058c7cf8a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0f48027058c7cf8a$export$2e2bcd8739ae039(t, e);
}


function $54945f590163aef0$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $0f48027058c7cf8a$export$2e2bcd8739ae039)(t, e);
}



var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");



var $47zxZ = parcelRequire("47zxZ");

var $e1ONw = parcelRequire("e1ONw");

var $1KcBP = parcelRequire("1KcBP");
var $30ba108ffd443f08$export$28e6b9b82ee883c = (0, $e1ONw.default)(function(theme) {
    return {
        day: {
            width: 36,
            height: 36,
            fontSize: theme.typography.caption.fontSize,
            margin: '0 2px',
            color: theme.palette.text.primary,
            fontWeight: theme.typography.fontWeightMedium,
            padding: 0
        },
        hidden: {
            opacity: 0,
            pointerEvents: 'none'
        },
        current: {
            color: theme.palette.primary.main,
            fontWeight: 600
        },
        daySelected: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            '&:hover': {
                backgroundColor: theme.palette.primary.main
            }
        },
        dayDisabled: {
            pointerEvents: 'none',
            color: theme.palette.text.hint
        }
    };
}, {
    name: 'MuiPickersDay'
});
var $30ba108ffd443f08$export$7a9a31a911eb9a20 = function Day(_ref) {
    var children = _ref.children, disabled = _ref.disabled, hidden = _ref.hidden, current = _ref.current, selected = _ref.selected, other = (0, $47143c6253cef6b3$export$2e2bcd8739ae039)(_ref, [
        "children",
        "disabled",
        "hidden",
        "current",
        "selected"
    ]);
    var classes = $30ba108ffd443f08$export$28e6b9b82ee883c();
    var className = (0, $j6s32.default)(classes.day, hidden && classes.hidden, current && classes.current, selected && classes.daySelected, disabled && classes.dayDisabled);
    return (0, $ieT14.createElement)((0, $1KcBP.default), (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({
        className: className,
        tabIndex: hidden || disabled ? -1 : 0
    }, other), (0, $ieT14.createElement)((0, $47zxZ.default), {
        variant: "body2",
        color: "inherit"
    }, children));
};
$30ba108ffd443f08$export$7a9a31a911eb9a20.displayName = 'Day';
$30ba108ffd443f08$export$7a9a31a911eb9a20.defaultProps = {
    disabled: false,
    hidden: false,
    current: false,
    selected: false
};
var $30ba108ffd443f08$export$2e2bcd8739ae039 = $30ba108ffd443f08$export$7a9a31a911eb9a20;



var $fMZXI = parcelRequire("fMZXI");

var $9YxmX = parcelRequire("9YxmX");

var $hsveB = parcelRequire("hsveB");

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $a3521c5f643d34d0$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $e4e7061143476ead$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $a3521c5f643d34d0$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}


function $0e42b63d6370ec02$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $0e42b63d6370ec02$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $0e42b63d6370ec02$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $0e42b63d6370ec02$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



var $ieT14 = parcelRequire("ieT14");

var $4XMe5 = parcelRequire("4XMe5");


var $cMgtJ = parcelRequire("cMgtJ");
var $b30dae942e7775a3$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $e4e7061143476ead$export$2e2bcd8739ae039)(node, c);
    });
};
var $b30dae942e7775a3$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $0e42b63d6370ec02$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $b30dae942e7775a3$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $hsveB.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $cMgtJ.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $b30dae942e7775a3$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $b30dae942e7775a3$var$removeClass(node, baseClassName);
        if (activeClassName) $b30dae942e7775a3$var$removeClass(node, activeClassName);
        if (doneClassName) $b30dae942e7775a3$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $9YxmX.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement((0, $4XMe5.default), (0, $fMZXI.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).Component);
$b30dae942e7775a3$var$CSSTransition.defaultProps = {
    classNames: ''
};
$b30dae942e7775a3$var$CSSTransition.propTypes = {};
var $b30dae942e7775a3$export$2e2bcd8739ae039 = $b30dae942e7775a3$var$CSSTransition;


var $5IIYw = parcelRequire("5IIYw");

var $fpdl2 = parcelRequire("fpdl2");
var $d97c7d9d60e2b0e4$var$findClosestEnabledDate = function findClosestEnabledDate(_ref) {
    var date = _ref.date, utils = _ref.utils, minDate = _ref.minDate, maxDate = _ref.maxDate, disableFuture = _ref.disableFuture, disablePast = _ref.disablePast, shouldDisableDate = _ref.shouldDisableDate;
    var today = utils.startOfDay(utils.date());
    if (disablePast && utils.isBefore(minDate, today)) minDate = today;
    if (disableFuture && utils.isAfter(maxDate, today)) maxDate = today;
    var forward = date;
    var backward = date;
    if (utils.isBefore(date, minDate)) {
        forward = utils.date(minDate);
        backward = null;
    }
    if (utils.isAfter(date, maxDate)) {
        if (backward) backward = utils.date(maxDate);
        forward = null;
    }
    while(forward || backward){
        if (forward && utils.isAfter(forward, maxDate)) forward = null;
        if (backward && utils.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!shouldDisableDate(forward)) return forward;
            forward = utils.addDays(forward, 1);
        }
        if (backward) {
            if (!shouldDisableDate(backward)) return backward;
            backward = utils.addDays(backward, -1);
        }
    } // fallback to today if no enabled days
    return utils.date();
};
var $d97c7d9d60e2b0e4$export$23f2a1d2818174ef = function isYearOnlyView(views) {
    return views.length === 1 && views[0] === 'year';
};
var $d97c7d9d60e2b0e4$export$8b22cf2602fb60ce = function isYearAndMonthViews(views) {
    return views.length === 2 && (0, $e4ddf05ffa240aa3$export$407448d2b89b1813)(views, 'month') && (0, $e4ddf05ffa240aa3$export$407448d2b89b1813)(views, 'year');
};
var $d97c7d9d60e2b0e4$export$39b482c5e57630a8 = function getFormatByViews(views, utils) {
    if ($d97c7d9d60e2b0e4$export$23f2a1d2818174ef(views)) return utils.yearFormat;
    if ($d97c7d9d60e2b0e4$export$8b22cf2602fb60ce(views)) return utils.yearMonthFormat;
    return utils.dateFormat;
};
var $d97c7d9d60e2b0e4$var$DayWrapper = function DayWrapper(_ref) {
    var children = _ref.children, value = _ref.value, disabled = _ref.disabled, onSelect = _ref.onSelect, dayInCurrentMonth = _ref.dayInCurrentMonth, other = (0, $47143c6253cef6b3$export$2e2bcd8739ae039)(_ref, [
        "children",
        "value",
        "disabled",
        "onSelect",
        "dayInCurrentMonth"
    ]);
    var handleClick = (0, $ieT14.useCallback)(function() {
        return onSelect(value);
    }, [
        onSelect,
        value
    ]);
    return (0, $ieT14.createElement)("div", (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({
        role: "presentation",
        onClick: dayInCurrentMonth && !disabled ? handleClick : undefined,
        onKeyPress: dayInCurrentMonth && !disabled ? handleClick : undefined
    }, other), children);
};
var $d97c7d9d60e2b0e4$var$animationDuration = 350;
var $d97c7d9d60e2b0e4$var$useStyles = (0, $e1ONw.default)(function(theme) {
    var slideTransition = theme.transitions.create('transform', {
        duration: $d97c7d9d60e2b0e4$var$animationDuration,
        easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
    });
    return {
        transitionContainer: {
            display: 'block',
            position: 'relative',
            '& > *': {
                position: 'absolute',
                top: 0,
                right: 0,
                left: 0
            }
        },
        'slideEnter-left': {
            willChange: 'transform',
            transform: 'translate(100%)'
        },
        'slideEnter-right': {
            willChange: 'transform',
            transform: 'translate(-100%)'
        },
        slideEnterActive: {
            transform: 'translate(0%)',
            transition: slideTransition
        },
        slideExit: {
            transform: 'translate(0%)'
        },
        'slideExitActiveLeft-left': {
            willChange: 'transform',
            transform: 'translate(-200%)',
            transition: slideTransition
        },
        'slideExitActiveLeft-right': {
            willChange: 'transform',
            transform: 'translate(200%)',
            transition: slideTransition
        }
    };
}, {
    name: 'MuiPickersSlideTransition'
});
var $d97c7d9d60e2b0e4$var$SlideTransition = function SlideTransition(_ref) {
    var children = _ref.children, transKey = _ref.transKey, slideDirection = _ref.slideDirection, _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className;
    var classes = $d97c7d9d60e2b0e4$var$useStyles();
    var transitionClasses = {
        exit: classes.slideExit,
        enterActive: classes.slideEnterActive,
        // @ts-ignore
        enter: classes['slideEnter-' + slideDirection],
        // @ts-ignore
        exitActive: classes['slideExitActiveLeft-' + slideDirection]
    };
    return (0, $ieT14.createElement)((0, $5IIYw.default), {
        className: (0, $j6s32.default)(classes.transitionContainer, className),
        childFactory: function childFactory(element) {
            return (0, $ieT14.cloneElement)(element, {
                classNames: transitionClasses
            });
        }
    }, (0, $ieT14.createElement)((0, $b30dae942e7775a3$export$2e2bcd8739ae039), {
        mountOnEnter: true,
        unmountOnExit: true,
        key: transKey + slideDirection,
        timeout: $d97c7d9d60e2b0e4$var$animationDuration,
        classNames: transitionClasses,
        children: children
    }));
};
var $d97c7d9d60e2b0e4$var$ArrowLeftIcon = function ArrowLeftIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement((0, $5SbGE.default), props, (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement("path", {
        d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement("path", {
        fill: "none",
        d: "M0 0h24v24H0V0z"
    }));
};
var $d97c7d9d60e2b0e4$var$ArrowRightIcon = function ArrowRightIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement((0, $5SbGE.default), props, (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement("path", {
        d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement("path", {
        fill: "none",
        d: "M0 0h24v24H0V0z"
    }));
};
var $d97c7d9d60e2b0e4$var$useStyles$1 = (0, $e1ONw.default)(function(theme) {
    return {
        switchHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: theme.spacing(0.5),
            marginBottom: theme.spacing(1)
        },
        transitionContainer: {
            width: '100%',
            overflow: 'hidden',
            height: 23
        },
        iconButton: {
            zIndex: 1,
            backgroundColor: theme.palette.background.paper
        },
        daysHeader: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: 16
        },
        dayLabel: {
            width: 36,
            margin: '0 2px',
            textAlign: 'center',
            color: theme.palette.text.hint
        }
    };
}, {
    name: 'MuiPickersCalendarHeader'
});
var $d97c7d9d60e2b0e4$var$CalendarHeader = function CalendarHeader(_ref) {
    var currentMonth = _ref.currentMonth, onMonthChange = _ref.onMonthChange, leftArrowIcon = _ref.leftArrowIcon, rightArrowIcon = _ref.rightArrowIcon, leftArrowButtonProps = _ref.leftArrowButtonProps, rightArrowButtonProps = _ref.rightArrowButtonProps, disablePrevMonth = _ref.disablePrevMonth, disableNextMonth = _ref.disableNextMonth, slideDirection = _ref.slideDirection;
    var utils = (0, $227fe7cc0a67c04e$export$3b14a55fb2447963)();
    var classes = $d97c7d9d60e2b0e4$var$useStyles$1();
    var theme = (0, $hgPMF.default)();
    var rtl = theme.direction === 'rtl';
    var selectNextMonth = function selectNextMonth() {
        return onMonthChange(utils.getNextMonth(currentMonth), 'left');
    };
    var selectPreviousMonth = function selectPreviousMonth() {
        return onMonthChange(utils.getPreviousMonth(currentMonth), 'right');
    };
    return (0, $ieT14.createElement)("div", null, (0, $ieT14.createElement)("div", {
        className: classes.switchHeader
    }, (0, $ieT14.createElement)((0, $1KcBP.default), (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({}, leftArrowButtonProps, {
        disabled: disablePrevMonth,
        onClick: selectPreviousMonth,
        className: classes.iconButton
    }), rtl ? rightArrowIcon : leftArrowIcon), (0, $ieT14.createElement)($d97c7d9d60e2b0e4$var$SlideTransition, {
        slideDirection: slideDirection,
        transKey: currentMonth.toString(),
        className: classes.transitionContainer
    }, (0, $ieT14.createElement)((0, $47zxZ.default), {
        align: "center",
        variant: "body1"
    }, utils.getCalendarHeaderText(currentMonth))), (0, $ieT14.createElement)((0, $1KcBP.default), (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({}, rightArrowButtonProps, {
        disabled: disableNextMonth,
        onClick: selectNextMonth,
        className: classes.iconButton
    }), rtl ? leftArrowIcon : rightArrowIcon)), (0, $ieT14.createElement)("div", {
        className: classes.daysHeader
    }, utils.getWeekdays().map(function(day, index) {
        return (0, $ieT14.createElement)((0, $47zxZ.default), {
            key: index // eslint-disable-line react/no-array-index-key
            ,
            variant: "caption",
            className: classes.dayLabel
        }, day);
    })));
};
$d97c7d9d60e2b0e4$var$CalendarHeader.displayName = 'CalendarHeader';
$d97c7d9d60e2b0e4$var$CalendarHeader.defaultProps = {
    leftArrowIcon: (0, $ieT14.createElement)($d97c7d9d60e2b0e4$var$ArrowLeftIcon, null),
    rightArrowIcon: (0, $ieT14.createElement)($d97c7d9d60e2b0e4$var$ArrowRightIcon, null),
    disablePrevMonth: false,
    disableNextMonth: false
};
var $d97c7d9d60e2b0e4$var$withUtils = function withUtils() {
    return function(Component) {
        var WithUtils = function WithUtils(props) {
            var utils = (0, $227fe7cc0a67c04e$export$3b14a55fb2447963)();
            return (0, $ieT14.createElement)(Component, (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({
                utils: utils
            }, props));
        };
        WithUtils.displayName = "WithUtils(".concat(Component.displayName || Component.name, ")");
        return WithUtils;
    };
};
var $d97c7d9d60e2b0e4$var$KeyDownListener = function KeyDownListener(_ref) {
    var onKeyDown = _ref.onKeyDown;
    (0, $ieT14.useEffect)(function() {
        window.addEventListener('keydown', onKeyDown);
        return function() {
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [
        onKeyDown
    ]);
    return null;
};
var $d97c7d9d60e2b0e4$export$e7094788287c5e9b = /*#__PURE__*/ function(_React$Component) {
    (0, $54945f590163aef0$export$2e2bcd8739ae039)(Calendar, _React$Component);
    function Calendar() {
        var _getPrototypeOf2;
        var _this;
        (0, $33ad4dc01d447109$export$2e2bcd8739ae039)(this, Calendar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $f9a7e2192d88e5f2$export$2e2bcd8739ae039)(this, (_getPrototypeOf2 = (0, $663b6cab2e4d42aa$export$2e2bcd8739ae039)(Calendar)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _this.state = {
            slideDirection: 'left',
            currentMonth: _this.props.utils.startOfMonth(_this.props.date),
            loadingQueue: 0
        };
        _this.pushToLoadingQueue = function() {
            var loadingQueue = _this.state.loadingQueue + 1;
            _this.setState({
                loadingQueue: loadingQueue
            });
        };
        _this.popFromLoadingQueue = function() {
            var loadingQueue = _this.state.loadingQueue;
            loadingQueue = loadingQueue <= 0 ? 0 : loadingQueue - 1;
            _this.setState({
                loadingQueue: loadingQueue
            });
        };
        _this.handleChangeMonth = function(newMonth, slideDirection) {
            _this.setState({
                currentMonth: newMonth,
                slideDirection: slideDirection
            });
            if (_this.props.onMonthChange) {
                var returnVal = _this.props.onMonthChange(newMonth);
                if (returnVal) {
                    _this.pushToLoadingQueue();
                    returnVal.then(function() {
                        _this.popFromLoadingQueue();
                    });
                }
            }
        };
        _this.validateMinMaxDate = function(day) {
            var _this$props = _this.props, minDate = _this$props.minDate, maxDate = _this$props.maxDate, utils = _this$props.utils, disableFuture = _this$props.disableFuture, disablePast = _this$props.disablePast;
            var now = utils.date();
            return Boolean(disableFuture && utils.isAfterDay(day, now) || disablePast && utils.isBeforeDay(day, now) || minDate && utils.isBeforeDay(day, utils.date(minDate)) || maxDate && utils.isAfterDay(day, utils.date(maxDate)));
        };
        _this.shouldDisablePrevMonth = function() {
            var _this$props2 = _this.props, utils = _this$props2.utils, disablePast = _this$props2.disablePast, minDate = _this$props2.minDate;
            var now = utils.date();
            var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, utils.date(minDate)) ? now : utils.date(minDate));
            return !utils.isBefore(firstEnabledMonth, _this.state.currentMonth);
        };
        _this.shouldDisableNextMonth = function() {
            var _this$props3 = _this.props, utils = _this$props3.utils, disableFuture = _this$props3.disableFuture, maxDate = _this$props3.maxDate;
            var now = utils.date();
            var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, utils.date(maxDate)) ? now : utils.date(maxDate));
            return !utils.isAfter(lastEnabledMonth, _this.state.currentMonth);
        };
        _this.shouldDisableDate = function(day) {
            var shouldDisableDate = _this.props.shouldDisableDate;
            return _this.validateMinMaxDate(day) || Boolean(shouldDisableDate && shouldDisableDate(day));
        };
        _this.handleDaySelect = function(day) {
            var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var _this$props4 = _this.props, date = _this$props4.date, utils = _this$props4.utils;
            _this.props.onChange(utils.mergeDateAndTime(day, date), isFinish);
        };
        _this.moveToDay = function(day) {
            var utils = _this.props.utils;
            if (day && !_this.shouldDisableDate(day)) {
                if (utils.getMonth(day) !== utils.getMonth(_this.state.currentMonth)) _this.handleChangeMonth(utils.startOfMonth(day), 'left');
                _this.handleDaySelect(day, false);
            }
        };
        _this.handleKeyDown = function(event) {
            var _this$props5 = _this.props, theme = _this$props5.theme, date = _this$props5.date, utils = _this$props5.utils;
            (0, $e4ddf05ffa240aa3$export$43caf9889c228507)(event, {
                ArrowUp: function ArrowUp() {
                    return _this.moveToDay(utils.addDays(date, -7));
                },
                ArrowDown: function ArrowDown() {
                    return _this.moveToDay(utils.addDays(date, 7));
                },
                ArrowLeft: function ArrowLeft() {
                    return _this.moveToDay(utils.addDays(date, theme.direction === 'ltr' ? -1 : 1));
                },
                ArrowRight: function ArrowRight() {
                    return _this.moveToDay(utils.addDays(date, theme.direction === 'ltr' ? 1 : -1));
                }
            });
        };
        _this.renderWeeks = function() {
            var _this$props6 = _this.props, utils = _this$props6.utils, classes = _this$props6.classes;
            var weeks = utils.getWeekArray(_this.state.currentMonth);
            return weeks.map(function(week) {
                return (0, $ieT14.createElement)("div", {
                    key: "week-".concat(week[0].toString()),
                    className: classes.week
                }, _this.renderDays(week));
            });
        };
        _this.renderDays = function(week) {
            var _this$props7 = _this.props, date = _this$props7.date, renderDay = _this$props7.renderDay, utils = _this$props7.utils;
            var now = utils.date();
            var selectedDate = utils.startOfDay(date);
            var currentMonthNumber = utils.getMonth(_this.state.currentMonth);
            return week.map(function(day) {
                var disabled = _this.shouldDisableDate(day);
                var isDayInCurrentMonth = utils.getMonth(day) === currentMonthNumber;
                var dayComponent = (0, $ieT14.createElement)((0, $30ba108ffd443f08$export$2e2bcd8739ae039), {
                    disabled: disabled,
                    current: utils.isSameDay(day, now),
                    hidden: !isDayInCurrentMonth,
                    selected: utils.isSameDay(selectedDate, day)
                }, utils.getDayText(day));
                if (renderDay) dayComponent = renderDay(day, selectedDate, isDayInCurrentMonth, dayComponent);
                return (0, $ieT14.createElement)($d97c7d9d60e2b0e4$var$DayWrapper, {
                    value: day,
                    key: day.toString(),
                    disabled: disabled,
                    dayInCurrentMonth: isDayInCurrentMonth,
                    onSelect: _this.handleDaySelect
                }, dayComponent);
            });
        };
        return _this;
    }
    (0, $566a078a6081ffc2$export$2e2bcd8739ae039)(Calendar, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props8 = this.props, date = _this$props8.date, minDate = _this$props8.minDate, maxDate = _this$props8.maxDate, utils = _this$props8.utils, disablePast = _this$props8.disablePast, disableFuture = _this$props8.disableFuture;
                if (this.shouldDisableDate(date)) {
                    var closestEnabledDate = $d97c7d9d60e2b0e4$var$findClosestEnabledDate({
                        date: date,
                        utils: utils,
                        minDate: utils.date(minDate),
                        maxDate: utils.date(maxDate),
                        disablePast: Boolean(disablePast),
                        disableFuture: Boolean(disableFuture),
                        shouldDisableDate: this.shouldDisableDate
                    });
                    this.handleDaySelect(closestEnabledDate, false);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$state = this.state, currentMonth = _this$state.currentMonth, slideDirection = _this$state.slideDirection;
                var _this$props9 = this.props, classes = _this$props9.classes, allowKeyboardControl = _this$props9.allowKeyboardControl, leftArrowButtonProps = _this$props9.leftArrowButtonProps, leftArrowIcon = _this$props9.leftArrowIcon, rightArrowButtonProps = _this$props9.rightArrowButtonProps, rightArrowIcon = _this$props9.rightArrowIcon, loadingIndicator = _this$props9.loadingIndicator;
                var loadingElement = loadingIndicator ? loadingIndicator : (0, $ieT14.createElement)((0, $fpdl2.default), null);
                return (0, $ieT14.createElement)((0, $ieT14.Fragment), null, allowKeyboardControl && this.context !== 'static' && (0, $ieT14.createElement)($d97c7d9d60e2b0e4$var$KeyDownListener, {
                    onKeyDown: this.handleKeyDown
                }), (0, $ieT14.createElement)($d97c7d9d60e2b0e4$var$CalendarHeader, {
                    currentMonth: currentMonth,
                    slideDirection: slideDirection,
                    onMonthChange: this.handleChangeMonth,
                    leftArrowIcon: leftArrowIcon,
                    leftArrowButtonProps: leftArrowButtonProps,
                    rightArrowIcon: rightArrowIcon,
                    rightArrowButtonProps: rightArrowButtonProps,
                    disablePrevMonth: this.shouldDisablePrevMonth(),
                    disableNextMonth: this.shouldDisableNextMonth()
                }), (0, $ieT14.createElement)($d97c7d9d60e2b0e4$var$SlideTransition, {
                    slideDirection: slideDirection,
                    transKey: currentMonth.toString(),
                    className: classes.transitionContainer
                }, (0, $ieT14.createElement)((0, $ieT14.Fragment), null, this.state.loadingQueue > 0 && (0, $ieT14.createElement)("div", {
                    className: classes.progressContainer
                }, loadingElement) || (0, $ieT14.createElement)("div", null, this.renderWeeks()))));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, state) {
                var utils = nextProps.utils, nextDate = nextProps.date;
                if (!utils.isEqual(nextDate, state.lastDate)) {
                    var nextMonth = utils.getMonth(nextDate);
                    var lastDate = state.lastDate || nextDate;
                    var lastMonth = utils.getMonth(lastDate);
                    return {
                        lastDate: nextDate,
                        currentMonth: nextProps.utils.startOfMonth(nextDate),
                        // prettier-ignore
                        slideDirection: nextMonth === lastMonth ? state.slideDirection : utils.isAfterDay(nextDate, lastDate) ? 'left' : 'right'
                    };
                }
                return null;
            }
        }
    ]);
    return Calendar;
}((0, $ieT14.Component));
$d97c7d9d60e2b0e4$export$e7094788287c5e9b.contextType = (0, $e4ddf05ffa240aa3$export$e7c866399fa523f5);
$d97c7d9d60e2b0e4$export$e7094788287c5e9b.defaultProps = {
    minDate: new Date('1900-01-01'),
    maxDate: new Date('2100-01-01'),
    disablePast: false,
    disableFuture: false,
    allowKeyboardControl: true
};
var $d97c7d9d60e2b0e4$export$2408f22a0fab9ae5 = function styles(theme) {
    return {
        transitionContainer: {
            minHeight: 216,
            marginTop: theme.spacing(1.5)
        },
        progressContainer: {
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        week: {
            display: 'flex',
            justifyContent: 'center'
        }
    };
};
var $d97c7d9d60e2b0e4$export$407448d2b89b1813 = (0, $aIJrd.default)($d97c7d9d60e2b0e4$export$2408f22a0fab9ae5, {
    name: 'MuiPickersCalendar',
    withTheme: true
})($d97c7d9d60e2b0e4$var$withUtils()($d97c7d9d60e2b0e4$export$e7094788287c5e9b));




var $ieT14 = parcelRequire("ieT14");



var $j6s32 = parcelRequire("j6s32");


var $47zxZ = parcelRequire("47zxZ");

var $e1ONw = parcelRequire("e1ONw");






var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $kRJN7 = parcelRequire("kRJN7");
var $aIJrd = parcelRequire("aIJrd");





var $ccdeb488b1382f5d$var$ClockType;
(function(ClockType) {
    ClockType["HOURS"] = "hours";
    ClockType["MINUTES"] = "minutes";
    ClockType["SECONDS"] = "seconds";
})($ccdeb488b1382f5d$var$ClockType || ($ccdeb488b1382f5d$var$ClockType = {}));
var $ccdeb488b1382f5d$export$8b22cf2602fb60ce = $ccdeb488b1382f5d$var$ClockType;
var $ccdeb488b1382f5d$var$ClockPointer = /*#__PURE__*/ function(_React$Component) {
    (0, $54945f590163aef0$export$2e2bcd8739ae039)(ClockPointer, _React$Component);
    function ClockPointer() {
        var _getPrototypeOf2;
        var _this;
        (0, $33ad4dc01d447109$export$2e2bcd8739ae039)(this, ClockPointer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $f9a7e2192d88e5f2$export$2e2bcd8739ae039)(this, (_getPrototypeOf2 = (0, $663b6cab2e4d42aa$export$2e2bcd8739ae039)(ClockPointer)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _this.state = {
            toAnimateTransform: false,
            previousType: undefined
        };
        _this.getAngleStyle = function() {
            var _this$props = _this.props, value = _this$props.value, isInner = _this$props.isInner, type = _this$props.type;
            var max = type === $ccdeb488b1382f5d$export$8b22cf2602fb60ce.HOURS ? 12 : 60;
            var angle = 360 / max * value;
            if (type === $ccdeb488b1382f5d$export$8b22cf2602fb60ce.HOURS && value > 12) angle -= 360; // round up angle to max 360 degrees
            return {
                height: isInner ? '26%' : '40%',
                transform: "rotateZ(".concat(angle, "deg)")
            };
        };
        return _this;
    }
    (0, $566a078a6081ffc2$export$2e2bcd8739ae039)(ClockPointer, [
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, classes = _this$props2.classes, hasSelected = _this$props2.hasSelected;
                return (0, $ieT14.createElement)("div", {
                    style: this.getAngleStyle(),
                    className: (0, $j6s32.default)(classes.pointer, this.state.toAnimateTransform && classes.animateTransform)
                }, (0, $ieT14.createElement)("div", {
                    className: (0, $j6s32.default)(classes.thumb, hasSelected && classes.noPoint)
                }));
            }
        }
    ]);
    return ClockPointer;
}((0, $ieT14.Component));
$ccdeb488b1382f5d$var$ClockPointer.getDerivedStateFromProps = function(nextProps, state) {
    if (nextProps.type !== state.previousType) return {
        toAnimateTransform: true,
        previousType: nextProps.type
    };
    return {
        toAnimateTransform: false,
        previousType: nextProps.type
    };
};
var $ccdeb488b1382f5d$var$styles = function styles(theme) {
    return (0, $kRJN7.default)({
        pointer: {
            width: 2,
            backgroundColor: theme.palette.primary.main,
            position: 'absolute',
            left: 'calc(50% - 1px)',
            bottom: '50%',
            transformOrigin: 'center bottom 0px'
        },
        animateTransform: {
            transition: theme.transitions.create([
                'transform',
                'height'
            ])
        },
        thumb: {
            width: 4,
            height: 4,
            backgroundColor: theme.palette.primary.contrastText,
            borderRadius: '100%',
            position: 'absolute',
            top: -21,
            left: -15,
            border: "14px solid ".concat(theme.palette.primary.main),
            boxSizing: 'content-box'
        },
        noPoint: {
            backgroundColor: theme.palette.primary.main
        }
    });
};
var $ccdeb488b1382f5d$var$ClockPointer$1 = (0, $aIJrd.default)($ccdeb488b1382f5d$var$styles, {
    name: 'MuiPickersClockPointer'
})($ccdeb488b1382f5d$var$ClockPointer);
var $ccdeb488b1382f5d$var$center = {
    x: 130,
    y: 130
};
var $ccdeb488b1382f5d$var$basePoint = {
    x: $ccdeb488b1382f5d$var$center.x,
    y: 0
};
var $ccdeb488b1382f5d$var$cx = $ccdeb488b1382f5d$var$basePoint.x - $ccdeb488b1382f5d$var$center.x;
var $ccdeb488b1382f5d$var$cy = $ccdeb488b1382f5d$var$basePoint.y - $ccdeb488b1382f5d$var$center.y;
var $ccdeb488b1382f5d$var$rad2deg = function rad2deg(rad) {
    return rad * 57.29577951308232;
};
var $ccdeb488b1382f5d$var$getAngleValue = function getAngleValue(step, offsetX, offsetY) {
    var x = offsetX - $ccdeb488b1382f5d$var$center.x;
    var y = offsetY - $ccdeb488b1382f5d$var$center.y;
    var atan = Math.atan2($ccdeb488b1382f5d$var$cx, $ccdeb488b1382f5d$var$cy) - Math.atan2(x, y);
    var deg = $ccdeb488b1382f5d$var$rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;
    var value = Math.floor(deg / step) || 0;
    var delta = Math.pow(x, 2) + Math.pow(y, 2);
    var distance = Math.sqrt(delta);
    return {
        value: value,
        distance: distance
    };
};
var $ccdeb488b1382f5d$var$getHours = function getHours(offsetX, offsetY, ampm) {
    var _getAngleValue = $ccdeb488b1382f5d$var$getAngleValue(30, offsetX, offsetY), value = _getAngleValue.value, distance = _getAngleValue.distance;
    value = value || 12;
    if (!ampm) {
        if (distance < 90) {
            value += 12;
            value %= 24;
        }
    } else value %= 12;
    return value;
};
var $ccdeb488b1382f5d$var$getMinutes = function getMinutes(offsetX, offsetY) {
    var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var angleStep = step * 6;
    var _getAngleValue2 = $ccdeb488b1382f5d$var$getAngleValue(angleStep, offsetX, offsetY), value = _getAngleValue2.value;
    value = value * step % 60;
    return value;
};
var $ccdeb488b1382f5d$export$39b482c5e57630a8 = function getMeridiem(date, utils) {
    return utils.getHours(date) >= 12 ? 'pm' : 'am';
};
var $ccdeb488b1382f5d$export$db3b6bfb95261072 = function convertToMeridiem(time, meridiem, ampm, utils) {
    if (ampm) {
        var currentMeridiem = utils.getHours(time) >= 12 ? 'pm' : 'am';
        if (currentMeridiem !== meridiem) {
            var hours = meridiem === 'am' ? utils.getHours(time) - 12 : utils.getHours(time) + 12;
            return utils.setHours(time, hours);
        }
    }
    return time;
};
var $ccdeb488b1382f5d$export$e7094788287c5e9b = /*#__PURE__*/ function(_React$Component) {
    (0, $54945f590163aef0$export$2e2bcd8739ae039)(Clock, _React$Component);
    function Clock() {
        var _getPrototypeOf2;
        var _this;
        (0, $33ad4dc01d447109$export$2e2bcd8739ae039)(this, Clock);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $f9a7e2192d88e5f2$export$2e2bcd8739ae039)(this, (_getPrototypeOf2 = (0, $663b6cab2e4d42aa$export$2e2bcd8739ae039)(Clock)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _this.isMoving = false;
        _this.handleTouchMove = function(e) {
            _this.isMoving = true;
            _this.setTime(e);
        };
        _this.handleTouchEnd = function(e) {
            if (_this.isMoving) {
                _this.setTime(e, true);
                _this.isMoving = false;
            }
        };
        _this.handleMove = function(e) {
            e.preventDefault();
            e.stopPropagation(); // MouseEvent.which is deprecated, but MouseEvent.buttons is not supported in Safari
            var isButtonPressed = typeof e.buttons === 'undefined' ? e.nativeEvent.which === 1 : e.buttons === 1;
            if (isButtonPressed) _this.setTime(e.nativeEvent, false);
        };
        _this.handleMouseUp = function(e) {
            if (_this.isMoving) _this.isMoving = false;
            _this.setTime(e.nativeEvent, true);
        };
        _this.hasSelected = function() {
            var _this$props = _this.props, type = _this$props.type, value = _this$props.value;
            if (type === $ccdeb488b1382f5d$export$8b22cf2602fb60ce.HOURS) return true;
            return value % 5 === 0;
        };
        return _this;
    }
    (0, $566a078a6081ffc2$export$2e2bcd8739ae039)(Clock, [
        {
            key: "setTime",
            value: function setTime(e) {
                var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var offsetX = e.offsetX, offsetY = e.offsetY;
                if (typeof offsetX === 'undefined') {
                    var rect = e.target.getBoundingClientRect();
                    offsetX = e.changedTouches[0].clientX - rect.left;
                    offsetY = e.changedTouches[0].clientY - rect.top;
                }
                var value = this.props.type === $ccdeb488b1382f5d$export$8b22cf2602fb60ce.SECONDS || this.props.type === $ccdeb488b1382f5d$export$8b22cf2602fb60ce.MINUTES ? $ccdeb488b1382f5d$var$getMinutes(offsetX, offsetY, this.props.minutesStep) : $ccdeb488b1382f5d$var$getHours(offsetX, offsetY, Boolean(this.props.ampm));
                this.props.onChange(value, isFinish);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, classes = _this$props2.classes, value = _this$props2.value, children = _this$props2.children, type = _this$props2.type, ampm = _this$props2.ampm;
                var isPointerInner = !ampm && type === $ccdeb488b1382f5d$export$8b22cf2602fb60ce.HOURS && (value < 1 || value > 12);
                return (0, $ieT14.createElement)("div", {
                    className: classes.container
                }, (0, $ieT14.createElement)("div", {
                    className: classes.clock
                }, (0, $ieT14.createElement)("div", {
                    role: "menu",
                    tabIndex: -1,
                    className: classes.squareMask,
                    onTouchMove: this.handleTouchMove,
                    onTouchEnd: this.handleTouchEnd,
                    onMouseUp: this.handleMouseUp,
                    onMouseMove: this.handleMove
                }), (0, $ieT14.createElement)("div", {
                    className: classes.pin
                }), (0, $ieT14.createElement)($ccdeb488b1382f5d$var$ClockPointer$1, {
                    type: type,
                    value: value,
                    isInner: isPointerInner,
                    hasSelected: this.hasSelected()
                }), children));
            }
        }
    ]);
    return Clock;
}((0, $ieT14.Component));
$ccdeb488b1382f5d$export$e7094788287c5e9b.defaultProps = {
    ampm: false,
    minutesStep: 1
};
var $ccdeb488b1382f5d$export$2408f22a0fab9ae5 = function styles(theme) {
    return (0, $kRJN7.default)({
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-end',
            margin: "".concat(theme.spacing(2), "px 0 ").concat(theme.spacing(1), "px")
        },
        clock: {
            backgroundColor: 'rgba(0,0,0,.07)',
            borderRadius: '50%',
            height: 260,
            width: 260,
            position: 'relative',
            pointerEvents: 'none'
        },
        squareMask: {
            width: '100%',
            height: '100%',
            position: 'absolute',
            pointerEvents: 'auto',
            outline: 'none',
            touchActions: 'none',
            userSelect: 'none',
            '&:active': {
                cursor: 'move'
            }
        },
        pin: {
            width: 6,
            height: 6,
            borderRadius: '50%',
            backgroundColor: theme.palette.primary.main,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        }
    });
};
var $ccdeb488b1382f5d$export$407448d2b89b1813 = (0, $aIJrd.default)($ccdeb488b1382f5d$export$2408f22a0fab9ae5, {
    name: 'MuiPickersClock'
})($ccdeb488b1382f5d$export$e7094788287c5e9b);


var $4b568819d971e0cb$var$positions = {
    0: [
        0,
        40
    ],
    1: [
        55,
        19.6
    ],
    2: [
        94.4,
        59.5
    ],
    3: [
        109,
        114
    ],
    4: [
        94.4,
        168.5
    ],
    5: [
        54.5,
        208.4
    ],
    6: [
        0,
        223
    ],
    7: [
        -54.5,
        208.4
    ],
    8: [
        -94.4,
        168.5
    ],
    9: [
        -109,
        114
    ],
    10: [
        -94.4,
        59.5
    ],
    11: [
        -54.5,
        19.6
    ],
    12: [
        0,
        5
    ],
    13: [
        36.9,
        49.9
    ],
    14: [
        64,
        77
    ],
    15: [
        74,
        114
    ],
    16: [
        64,
        151
    ],
    17: [
        37,
        178
    ],
    18: [
        0,
        188
    ],
    19: [
        -37,
        178
    ],
    20: [
        -64,
        151
    ],
    21: [
        -74,
        114
    ],
    22: [
        -64,
        77
    ],
    23: [
        -37,
        50
    ]
};
var $4b568819d971e0cb$var$useStyles = (0, $e1ONw.default)(function(theme) {
    var size = theme.spacing(4);
    return {
        clockNumber: {
            width: size,
            height: 32,
            userSelect: 'none',
            position: 'absolute',
            left: "calc((100% - ".concat(typeof size === 'number' ? "".concat(size, "px") : size, ") / 2)"),
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '50%',
            color: theme.palette.type === 'light' ? theme.palette.text.primary : theme.palette.text.hint
        },
        clockNumberSelected: {
            color: theme.palette.primary.contrastText
        }
    };
}, {
    name: 'MuiPickersClockNumber'
});
var $4b568819d971e0cb$var$ClockNumber = function ClockNumber(_ref) {
    var selected = _ref.selected, label = _ref.label, index = _ref.index, isInner = _ref.isInner;
    var classes = $4b568819d971e0cb$var$useStyles();
    var className = (0, $j6s32.default)(classes.clockNumber, selected && classes.clockNumberSelected);
    var transformStyle = (0, $ieT14.useMemo)(function() {
        var position = $4b568819d971e0cb$var$positions[index];
        return {
            transform: "translate(".concat(position[0], "px, ").concat(position[1], "px")
        };
    }, [
        index
    ]);
    return (0, $ieT14.createElement)((0, $47zxZ.default), {
        component: "span",
        className: className,
        variant: isInner ? 'body2' : 'body1',
        style: transformStyle,
        children: label
    });
};
var $4b568819d971e0cb$var$getHourNumbers = function getHourNumbers(_ref) {
    var ampm = _ref.ampm, utils = _ref.utils, date = _ref.date;
    var currentHours = utils.getHours(date);
    var hourNumbers = [];
    var startHour = ampm ? 1 : 0;
    var endHour = ampm ? 12 : 23;
    var isSelected = function isSelected(hour) {
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    for(var hour = startHour; hour <= endHour; hour += 1){
        var label = hour.toString();
        if (hour === 0) label = '00';
        var props = {
            index: hour,
            label: utils.formatNumber(label),
            selected: isSelected(hour),
            isInner: !ampm && (hour === 0 || hour > 12)
        };
        hourNumbers.push((0, $ieT14.createElement)($4b568819d971e0cb$var$ClockNumber, (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({
            key: hour
        }, props)));
    }
    return hourNumbers;
};
var $4b568819d971e0cb$var$getMinutesNumbers = function getMinutesNumbers(_ref2) {
    var value = _ref2.value, utils = _ref2.utils;
    var f = utils.formatNumber;
    return [
        (0, $ieT14.createElement)($4b568819d971e0cb$var$ClockNumber, {
            label: f('00'),
            selected: value === 0,
            index: 12,
            key: 12
        }),
        (0, $ieT14.createElement)($4b568819d971e0cb$var$ClockNumber, {
            label: f('05'),
            selected: value === 5,
            index: 1,
            key: 1
        }),
        (0, $ieT14.createElement)($4b568819d971e0cb$var$ClockNumber, {
            label: f('10'),
            selected: value === 10,
            index: 2,
            key: 2
        }),
        (0, $ieT14.createElement)($4b568819d971e0cb$var$ClockNumber, {
            label: f('15'),
            selected: value === 15,
            index: 3,
            key: 3
        }),
        (0, $ieT14.createElement)($4b568819d971e0cb$var$ClockNumber, {
            label: f('20'),
            selected: value === 20,
            index: 4,
            key: 4
        }),
        (0, $ieT14.createElement)($4b568819d971e0cb$var$ClockNumber, {
            label: f('25'),
            selected: value === 25,
            index: 5,
            key: 5
        }),
        (0, $ieT14.createElement)($4b568819d971e0cb$var$ClockNumber, {
            label: f('30'),
            selected: value === 30,
            index: 6,
            key: 6
        }),
        (0, $ieT14.createElement)($4b568819d971e0cb$var$ClockNumber, {
            label: f('35'),
            selected: value === 35,
            index: 7,
            key: 7
        }),
        (0, $ieT14.createElement)($4b568819d971e0cb$var$ClockNumber, {
            label: f('40'),
            selected: value === 40,
            index: 8,
            key: 8
        }),
        (0, $ieT14.createElement)($4b568819d971e0cb$var$ClockNumber, {
            label: f('45'),
            selected: value === 45,
            index: 9,
            key: 9
        }),
        (0, $ieT14.createElement)($4b568819d971e0cb$var$ClockNumber, {
            label: f('50'),
            selected: value === 50,
            index: 10,
            key: 10
        }),
        (0, $ieT14.createElement)($4b568819d971e0cb$var$ClockNumber, {
            label: f('55'),
            selected: value === 55,
            index: 11,
            key: 11
        })
    ];
};
var $4b568819d971e0cb$export$e6ca67116c8adcad = function ClockView(_ref) {
    var type = _ref.type, onHourChange = _ref.onHourChange, onMinutesChange = _ref.onMinutesChange, onSecondsChange = _ref.onSecondsChange, ampm = _ref.ampm, date = _ref.date, minutesStep = _ref.minutesStep;
    var utils = (0, $227fe7cc0a67c04e$export$3b14a55fb2447963)();
    var viewProps = (0, $ieT14.useMemo)(function() {
        switch(type){
            case (0, $ccdeb488b1382f5d$export$8b22cf2602fb60ce).HOURS:
                return {
                    value: utils.getHours(date),
                    children: $4b568819d971e0cb$var$getHourNumbers({
                        date: date,
                        utils: utils,
                        ampm: Boolean(ampm)
                    }),
                    onChange: function onChange(value, isFinish) {
                        var currentMeridiem = (0, $ccdeb488b1382f5d$export$39b482c5e57630a8)(date, utils);
                        var updatedTimeWithMeridiem = (0, $ccdeb488b1382f5d$export$db3b6bfb95261072)(utils.setHours(date, value), currentMeridiem, Boolean(ampm), utils);
                        onHourChange(updatedTimeWithMeridiem, isFinish);
                    }
                };
            case (0, $ccdeb488b1382f5d$export$8b22cf2602fb60ce).MINUTES:
                var minutesValue = utils.getMinutes(date);
                return {
                    value: minutesValue,
                    children: $4b568819d971e0cb$var$getMinutesNumbers({
                        value: minutesValue,
                        utils: utils
                    }),
                    onChange: function onChange(value, isFinish) {
                        var updatedTime = utils.setMinutes(date, value);
                        onMinutesChange(updatedTime, isFinish);
                    }
                };
            case (0, $ccdeb488b1382f5d$export$8b22cf2602fb60ce).SECONDS:
                var secondsValue = utils.getSeconds(date);
                return {
                    value: secondsValue,
                    children: $4b568819d971e0cb$var$getMinutesNumbers({
                        value: secondsValue,
                        utils: utils
                    }),
                    onChange: function onChange(value, isFinish) {
                        var updatedTime = utils.setSeconds(date, value);
                        onSecondsChange(updatedTime, isFinish);
                    }
                };
            default:
                throw new Error('You must provide the type for TimePickerView');
        }
    }, [
        ampm,
        date,
        onHourChange,
        onMinutesChange,
        onSecondsChange,
        type,
        utils
    ]);
    return (0, $ieT14.createElement)((0, $ccdeb488b1382f5d$export$407448d2b89b1813), (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({
        type: type,
        ampm: ampm,
        minutesStep: minutesStep
    }, viewProps));
};
$4b568819d971e0cb$export$e6ca67116c8adcad.displayName = 'TimePickerView';
$4b568819d971e0cb$export$e6ca67116c8adcad.defaultProps = {
    ampm: true,
    minutesStep: 1
};
var $4b568819d971e0cb$var$ClockView$1 = (0, $ieT14.memo)($4b568819d971e0cb$export$e6ca67116c8adcad);
var $4b568819d971e0cb$export$2e2bcd8739ae039 = $4b568819d971e0cb$var$ClockView$1;


function $a21d6ee6ab5a8fc2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a21d6ee6ab5a8fc2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a21d6ee6ab5a8fc2$var$ownKeys(source, true).forEach(function(key) {
            (0, $c5c97159e13895ef$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a21d6ee6ab5a8fc2$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $a21d6ee6ab5a8fc2$var$date = (0, $aLnZv.oneOfType)([
    (0, $aLnZv.object),
    (0, $aLnZv.string),
    (0, $aLnZv.number),
    (0, $aLnZv.instanceOf)(Date)
]);
var $a21d6ee6ab5a8fc2$var$datePickerView = (0, $aLnZv.oneOf)([
    'year',
    'month',
    'day'
]);
/* eslint-disable @typescript-eslint/no-object-literal-type-assertion */ var $a21d6ee6ab5a8fc2$export$625550452a3fa3ec = {
    ampm: true,
    invalidDateMessage: 'Invalid Time Format'
};
var $a21d6ee6ab5a8fc2$export$4368d992c4eafac0 = {
    minDate: new Date('1900-01-01'),
    maxDate: new Date('2100-01-01'),
    invalidDateMessage: 'Invalid Date Format',
    minDateMessage: 'Date should not be before minimal date',
    maxDateMessage: 'Date should not be after maximal date',
    allowKeyboardControl: true
};
var $a21d6ee6ab5a8fc2$export$407448d2b89b1813 = $a21d6ee6ab5a8fc2$var$_objectSpread({}, $a21d6ee6ab5a8fc2$export$625550452a3fa3ec, {}, $a21d6ee6ab5a8fc2$export$4368d992c4eafac0, {
    showTabs: true
});
function $a21d6ee6ab5a8fc2$var$useViews(views, openTo, onChange) {
    var _React$useState = (0, $ieT14.useState)(openTo && (0, $e4ddf05ffa240aa3$export$407448d2b89b1813)(views, openTo) ? openTo : views[0]), _React$useState2 = (0, $d1e29df46c022672$export$2e2bcd8739ae039)(_React$useState, 2), openView = _React$useState2[0], setOpenView = _React$useState2[1];
    var handleChangeAndOpenNext = (0, $ieT14.useCallback)(function(date, isFinish) {
        var nextViewToOpen = views[views.indexOf(openView) + 1];
        if (isFinish && nextViewToOpen) {
            // do not close picker if needs to show next view
            onChange(date, false);
            setOpenView(nextViewToOpen);
            return;
        }
        onChange(date, Boolean(isFinish));
    }, [
        onChange,
        openView,
        views
    ]);
    return {
        handleChangeAndOpenNext: handleChangeAndOpenNext,
        openView: openView,
        setOpenView: setOpenView
    };
}
var $a21d6ee6ab5a8fc2$var$useStyles = (0, $e1ONw.default)(function(theme) {
    return {
        root: {
            height: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            outline: 'none',
            '&:focus': {
                color: theme.palette.primary.main,
                fontWeight: theme.typography.fontWeightMedium
            }
        },
        yearSelected: {
            margin: '10px 0',
            fontWeight: theme.typography.fontWeightMedium
        },
        yearDisabled: {
            pointerEvents: 'none',
            color: theme.palette.text.hint
        }
    };
}, {
    name: 'MuiPickersYear'
});
var $a21d6ee6ab5a8fc2$var$Year = function Year(_ref) {
    var onSelect = _ref.onSelect, forwardedRef = _ref.forwardedRef, value = _ref.value, selected = _ref.selected, disabled = _ref.disabled, children = _ref.children, other = (0, $47143c6253cef6b3$export$2e2bcd8739ae039)(_ref, [
        "onSelect",
        "forwardedRef",
        "value",
        "selected",
        "disabled",
        "children"
    ]);
    var classes = $a21d6ee6ab5a8fc2$var$useStyles();
    var handleClick = (0, $ieT14.useCallback)(function() {
        return onSelect(value);
    }, [
        onSelect,
        value
    ]);
    return (0, $ieT14.createElement)((0, $47zxZ.default), (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({
        role: "button",
        component: "div",
        tabIndex: disabled ? -1 : 0,
        onClick: handleClick,
        onKeyPress: handleClick,
        color: selected ? 'primary' : undefined,
        variant: selected ? 'h5' : 'subtitle1',
        children: children,
        ref: forwardedRef,
        className: (0, $j6s32.default)(classes.root, selected && classes.yearSelected, disabled && classes.yearDisabled)
    }, other));
};
$a21d6ee6ab5a8fc2$var$Year.displayName = 'Year';
var $a21d6ee6ab5a8fc2$var$Year$1 = (0, $ieT14.forwardRef)(function(props, ref) {
    return (0, $ieT14.createElement)($a21d6ee6ab5a8fc2$var$Year, (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({}, props, {
        forwardedRef: ref
    }));
});
var $a21d6ee6ab5a8fc2$var$useStyles$1 = (0, $e1ONw.default)({
    container: {
        height: 300,
        overflowY: 'auto'
    }
}, {
    name: 'MuiPickersYearSelection'
});
var $a21d6ee6ab5a8fc2$var$YearSelection = function YearSelection(_ref) {
    var date = _ref.date, onChange = _ref.onChange, onYearChange = _ref.onYearChange, minDate = _ref.minDate, maxDate = _ref.maxDate, disablePast = _ref.disablePast, disableFuture = _ref.disableFuture, animateYearScrolling = _ref.animateYearScrolling;
    var utils = (0, $227fe7cc0a67c04e$export$3b14a55fb2447963)();
    var classes = $a21d6ee6ab5a8fc2$var$useStyles$1();
    var currentVariant = (0, $ieT14.useContext)((0, $e4ddf05ffa240aa3$export$e7c866399fa523f5));
    var selectedYearRef = (0, $ieT14.useRef)(null);
    (0, $ieT14.useEffect)(function() {
        if (selectedYearRef.current && selectedYearRef.current.scrollIntoView) try {
            selectedYearRef.current.scrollIntoView({
                block: currentVariant === 'static' ? 'nearest' : 'center',
                behavior: animateYearScrolling ? 'smooth' : 'auto'
            });
        } catch (e) {
            // call without arguments in case when scrollIntoView works improperly (e.g. Firefox 52-57)
            selectedYearRef.current.scrollIntoView();
        }
    }, []); // eslint-disable-line
    var currentYear = utils.getYear(date);
    var onYearSelect = (0, $ieT14.useCallback)(function(year) {
        var newDate = utils.setYear(date, year);
        if (onYearChange) onYearChange(newDate);
        onChange(newDate, true);
    }, [
        date,
        onChange,
        onYearChange,
        utils
    ]);
    return (0, $ieT14.createElement)("div", {
        className: classes.container
    }, utils.getYearRange(minDate, maxDate).map(function(year) {
        var yearNumber = utils.getYear(year);
        var selected = yearNumber === currentYear;
        return (0, $ieT14.createElement)($a21d6ee6ab5a8fc2$var$Year$1, {
            key: utils.getYearText(year),
            selected: selected,
            value: yearNumber,
            onSelect: onYearSelect,
            ref: selected ? selectedYearRef : undefined,
            disabled: Boolean(disablePast && utils.isBeforeYear(year, utils.date()) || disableFuture && utils.isAfterYear(year, utils.date()))
        }, utils.getYearText(year));
    }));
};
var $a21d6ee6ab5a8fc2$var$useStyles$2 = (0, $e1ONw.default)(function(theme) {
    return {
        root: {
            flex: '1 0 33.33%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            outline: 'none',
            height: 75,
            transition: theme.transitions.create('font-size', {
                duration: '100ms'
            }),
            '&:focus': {
                color: theme.palette.primary.main,
                fontWeight: theme.typography.fontWeightMedium
            }
        },
        monthSelected: {
            color: theme.palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium
        },
        monthDisabled: {
            pointerEvents: 'none',
            color: theme.palette.text.hint
        }
    };
}, {
    name: 'MuiPickersMonth'
});
var $a21d6ee6ab5a8fc2$var$Month = function Month(_ref) {
    var selected = _ref.selected, onSelect = _ref.onSelect, disabled = _ref.disabled, value = _ref.value, children = _ref.children, other = (0, $47143c6253cef6b3$export$2e2bcd8739ae039)(_ref, [
        "selected",
        "onSelect",
        "disabled",
        "value",
        "children"
    ]);
    var classes = $a21d6ee6ab5a8fc2$var$useStyles$2();
    var handleSelection = (0, $ieT14.useCallback)(function() {
        onSelect(value);
    }, [
        onSelect,
        value
    ]);
    return (0, $ieT14.createElement)((0, $47zxZ.default), (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({
        role: "button",
        component: "div",
        className: (0, $j6s32.default)(classes.root, selected && classes.monthSelected, disabled && classes.monthDisabled),
        tabIndex: disabled ? -1 : 0,
        onClick: handleSelection,
        onKeyPress: handleSelection,
        color: selected ? 'primary' : undefined,
        variant: selected ? 'h5' : 'subtitle1',
        children: children
    }, other));
};
$a21d6ee6ab5a8fc2$var$Month.displayName = 'Month';
var $a21d6ee6ab5a8fc2$var$useStyles$3 = (0, $e1ONw.default)({
    container: {
        width: 310,
        display: 'flex',
        flexWrap: 'wrap',
        alignContent: 'stretch'
    }
}, {
    name: 'MuiPickersMonthSelection'
});
var $a21d6ee6ab5a8fc2$var$MonthSelection = function MonthSelection(_ref) {
    var disablePast = _ref.disablePast, disableFuture = _ref.disableFuture, minDate = _ref.minDate, maxDate = _ref.maxDate, date = _ref.date, onMonthChange = _ref.onMonthChange, onChange = _ref.onChange;
    var utils = (0, $227fe7cc0a67c04e$export$3b14a55fb2447963)();
    var classes = $a21d6ee6ab5a8fc2$var$useStyles$3();
    var currentMonth = utils.getMonth(date);
    var shouldDisableMonth = function shouldDisableMonth(month) {
        var now = utils.date();
        var utilMinDate = utils.date(minDate);
        var utilMaxDate = utils.date(maxDate);
        var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, utilMinDate) ? now : utilMinDate);
        var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, utilMaxDate) ? now : utilMaxDate);
        var isBeforeFirstEnabled = utils.isBefore(month, firstEnabledMonth);
        var isAfterLastEnabled = utils.isAfter(month, lastEnabledMonth);
        return isBeforeFirstEnabled || isAfterLastEnabled;
    };
    var onMonthSelect = (0, $ieT14.useCallback)(function(month) {
        var newDate = utils.setMonth(date, month);
        onChange(newDate, true);
        if (onMonthChange) onMonthChange(newDate);
    }, [
        date,
        onChange,
        onMonthChange,
        utils
    ]);
    return (0, $ieT14.createElement)("div", {
        className: classes.container
    }, utils.getMonthArray(date).map(function(month) {
        var monthNumber = utils.getMonth(month);
        var monthText = utils.format(month, 'MMM');
        return (0, $ieT14.createElement)($a21d6ee6ab5a8fc2$var$Month, {
            key: monthText,
            value: monthNumber,
            selected: monthNumber === currentMonth,
            onSelect: onMonthSelect,
            disabled: shouldDisableMonth(month)
        }, monthText);
    }));
};
var $a21d6ee6ab5a8fc2$var$getOrientation = function getOrientation() {
    if (typeof window === 'undefined') return 'portrait';
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
     // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
    return 'portrait';
};
function $a21d6ee6ab5a8fc2$var$useIsLandscape(customOrientation) {
    var _React$useState = (0, $ieT14.useState)($a21d6ee6ab5a8fc2$var$getOrientation()), _React$useState2 = (0, $d1e29df46c022672$export$2e2bcd8739ae039)(_React$useState, 2), orientation = _React$useState2[0], setOrientation = _React$useState2[1];
    var eventHandler = (0, $ieT14.useCallback)(function() {
        return setOrientation($a21d6ee6ab5a8fc2$var$getOrientation());
    }, []);
    (0, $e4ddf05ffa240aa3$export$3b14a55fb2447963)(function() {
        window.addEventListener('orientationchange', eventHandler);
        return function() {
            return window.removeEventListener('orientationchange', eventHandler);
        };
    }, [
        eventHandler
    ]);
    var orientationToUse = customOrientation || orientation;
    return orientationToUse === 'landscape';
}
function $a21d6ee6ab5a8fc2$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a21d6ee6ab5a8fc2$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a21d6ee6ab5a8fc2$var$ownKeys$1(source, true).forEach(function(key) {
            (0, $c5c97159e13895ef$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a21d6ee6ab5a8fc2$var$ownKeys$1(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $a21d6ee6ab5a8fc2$var$viewsMap = {
    year: $a21d6ee6ab5a8fc2$var$YearSelection,
    month: $a21d6ee6ab5a8fc2$var$MonthSelection,
    date: (0, $d97c7d9d60e2b0e4$export$407448d2b89b1813),
    hours: (0, $4b568819d971e0cb$export$e6ca67116c8adcad),
    minutes: (0, $4b568819d971e0cb$export$e6ca67116c8adcad),
    seconds: (0, $4b568819d971e0cb$export$e6ca67116c8adcad)
};
var $a21d6ee6ab5a8fc2$var$useStyles$4 = (0, $e1ONw.default)({
    container: {
        display: 'flex',
        flexDirection: 'column'
    },
    containerLandscape: {
        flexDirection: 'row'
    },
    pickerView: {
        overflowX: 'hidden',
        minHeight: (0, $e4ddf05ffa240aa3$export$8b22cf2602fb60ce),
        minWidth: (0, $e4ddf05ffa240aa3$export$96f57966bedc81b4),
        maxWidth: (0, $e4ddf05ffa240aa3$export$db3b6bfb95261072),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    pickerViewLandscape: {
        padding: '0 8px'
    }
}, {
    name: 'MuiPickersBasePicker'
});
var $a21d6ee6ab5a8fc2$export$56c0d5a1e737357d = function Picker(_ref) {
    var date = _ref.date, views = _ref.views, disableToolbar = _ref.disableToolbar, onChange = _ref.onChange, openTo = _ref.openTo, unparsedMinDate = _ref.minDate, unparsedMaxDate = _ref.maxDate, ToolbarComponent = _ref.ToolbarComponent, orientation = _ref.orientation, rest = (0, $47143c6253cef6b3$export$2e2bcd8739ae039)(_ref, [
        "date",
        "views",
        "disableToolbar",
        "onChange",
        "openTo",
        "minDate",
        "maxDate",
        "ToolbarComponent",
        "orientation"
    ]);
    var utils = (0, $227fe7cc0a67c04e$export$3b14a55fb2447963)();
    var classes = $a21d6ee6ab5a8fc2$var$useStyles$4();
    var isLandscape = $a21d6ee6ab5a8fc2$var$useIsLandscape(orientation);
    var _useViews = $a21d6ee6ab5a8fc2$var$useViews(views, openTo, onChange), openView = _useViews.openView, setOpenView = _useViews.setOpenView, handleChangeAndOpenNext = _useViews.handleChangeAndOpenNext;
    var minDate = (0, $ieT14.useMemo)(function() {
        return utils.date(unparsedMinDate);
    }, [
        unparsedMinDate,
        utils
    ]);
    var maxDate = (0, $ieT14.useMemo)(function() {
        return utils.date(unparsedMaxDate);
    }, [
        unparsedMaxDate,
        utils
    ]);
    return (0, $ieT14.createElement)("div", {
        className: (0, $j6s32.default)(classes.container, isLandscape && classes.containerLandscape)
    }, !disableToolbar && (0, $ieT14.createElement)(ToolbarComponent, (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({}, rest, {
        views: views,
        isLandscape: isLandscape,
        date: date,
        onChange: onChange,
        setOpenView: setOpenView,
        openView: openView
    })), (0, $ieT14.createElement)("div", {
        className: (0, $j6s32.default)(classes.pickerView, isLandscape && classes.pickerViewLandscape)
    }, openView === 'year' && (0, $ieT14.createElement)($a21d6ee6ab5a8fc2$var$YearSelection, (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({}, rest, {
        date: date,
        onChange: handleChangeAndOpenNext,
        minDate: minDate,
        maxDate: maxDate
    })), openView === 'month' && (0, $ieT14.createElement)($a21d6ee6ab5a8fc2$var$MonthSelection, (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({}, rest, {
        date: date,
        onChange: handleChangeAndOpenNext,
        minDate: minDate,
        maxDate: maxDate
    })), openView === 'date' && (0, $ieT14.createElement)((0, $d97c7d9d60e2b0e4$export$407448d2b89b1813), (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({}, rest, {
        date: date,
        onChange: handleChangeAndOpenNext,
        minDate: minDate,
        maxDate: maxDate
    })), (openView === 'hours' || openView === 'minutes' || openView === 'seconds') && (0, $ieT14.createElement)((0, $4b568819d971e0cb$export$e6ca67116c8adcad), (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({}, rest, {
        date: date,
        type: openView,
        onHourChange: handleChangeAndOpenNext,
        onMinutesChange: handleChangeAndOpenNext,
        onSecondsChange: handleChangeAndOpenNext
    }))));
};
$a21d6ee6ab5a8fc2$export$56c0d5a1e737357d.defaultProps = $a21d6ee6ab5a8fc2$var$_objectSpread$1({}, $a21d6ee6ab5a8fc2$export$4368d992c4eafac0, {
    views: Object.keys($a21d6ee6ab5a8fc2$var$viewsMap)
});


var $739886c12c53b316$var$useStyles = (0, $e1ONw.default)(function(theme) {
    var textColor = theme.palette.type === 'light' ? theme.palette.primary.contrastText : theme.palette.getContrastText(theme.palette.background["default"]);
    return {
        toolbarTxt: {
            color: (0, $86m3e.fade)(textColor, 0.54)
        },
        toolbarBtnSelected: {
            color: textColor
        }
    };
}, {
    name: 'MuiPickersToolbarText'
});
var $739886c12c53b316$export$db3b6bfb95261072 = function ToolbarText(_ref) {
    var selected = _ref.selected, label = _ref.label, _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className, other = (0, $47143c6253cef6b3$export$2e2bcd8739ae039)(_ref, [
        "selected",
        "label",
        "className"
    ]);
    var classes = $739886c12c53b316$var$useStyles();
    return (0, $ieT14.createElement)((0, $47zxZ.default), (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({
        children: label,
        className: (0, $j6s32.default)(classes.toolbarTxt, className, selected && classes.toolbarBtnSelected)
    }, other));
};
var $739886c12c53b316$var$ToolbarButton = function ToolbarButton(_ref) {
    var classes = _ref.classes, _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className, label = _ref.label, selected = _ref.selected, variant = _ref.variant, align = _ref.align, typographyClassName = _ref.typographyClassName, other = (0, $47143c6253cef6b3$export$2e2bcd8739ae039)(_ref, [
        "classes",
        "className",
        "label",
        "selected",
        "variant",
        "align",
        "typographyClassName"
    ]);
    return (0, $ieT14.createElement)((0, $ekezX.default), (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({
        variant: "text",
        className: (0, $j6s32.default)(classes.toolbarBtn, className)
    }, other), (0, $ieT14.createElement)($739886c12c53b316$export$db3b6bfb95261072, {
        align: align,
        className: typographyClassName,
        variant: variant,
        label: label,
        selected: selected
    }));
};
$739886c12c53b316$var$ToolbarButton.defaultProps = {
    className: ''
};
var $739886c12c53b316$var$styles = (0, $kRJN7.default)({
    toolbarBtn: {
        padding: 0,
        minWidth: '16px',
        textTransform: 'none'
    }
});
var $739886c12c53b316$export$971d5caa766a69d7 = (0, $aIJrd.default)($739886c12c53b316$var$styles, {
    name: 'MuiPickersToolbarButton'
})($739886c12c53b316$var$ToolbarButton);
var $739886c12c53b316$var$useStyles$1 = (0, $e1ONw.default)(function(theme) {
    return {
        toolbar: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            height: 100,
            backgroundColor: theme.palette.type === 'light' ? theme.palette.primary.main : theme.palette.background["default"]
        },
        toolbarLandscape: {
            height: 'auto',
            maxWidth: 150,
            padding: 8,
            justifyContent: 'flex-start'
        }
    };
}, {
    name: 'MuiPickersToolbar'
});
var $739886c12c53b316$export$56c0d5a1e737357d = function PickerToolbar(_ref) {
    var children = _ref.children, isLandscape = _ref.isLandscape, _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className, other = (0, $47143c6253cef6b3$export$2e2bcd8739ae039)(_ref, [
        "children",
        "isLandscape",
        "className"
    ]);
    var classes = $739886c12c53b316$var$useStyles$1();
    return (0, $ieT14.createElement)((0, $a8f70a0d45f814be$export$2e2bcd8739ae039), (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({
        className: (0, $j6s32.default)(classes.toolbar, className, isLandscape && classes.toolbarLandscape)
    }, other), children);
};
function $739886c12c53b316$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $739886c12c53b316$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $739886c12c53b316$var$ownKeys(source, true).forEach(function(key) {
            (0, $c5c97159e13895ef$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $739886c12c53b316$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $739886c12c53b316$export$407448d2b89b1813 = function PureDateInput(_ref) {
    var inputValue = _ref.inputValue, inputVariant = _ref.inputVariant, validationError = _ref.validationError, InputProps = _ref.InputProps, onOpen = _ref.openPicker, _ref$TextFieldCompone = _ref.TextFieldComponent, TextFieldComponent = _ref$TextFieldCompone === void 0 ? (0, $eYT2J.default) : _ref$TextFieldCompone, other = (0, $47143c6253cef6b3$export$2e2bcd8739ae039)(_ref, [
        "inputValue",
        "inputVariant",
        "validationError",
        "InputProps",
        "openPicker",
        "TextFieldComponent"
    ]);
    var PureDateInputProps = (0, $ieT14.useMemo)(function() {
        return $739886c12c53b316$var$_objectSpread({}, InputProps, {
            readOnly: true
        });
    }, [
        InputProps
    ]);
    return (0, $ieT14.createElement)(TextFieldComponent, (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({
        error: Boolean(validationError),
        helperText: validationError
    }, other, {
        // do not overridable
        onClick: onOpen,
        value: inputValue,
        variant: inputVariant,
        InputProps: PureDateInputProps,
        onKeyDown: function onKeyDown(e) {
            // space
            if (e.keyCode === 32) {
                e.stopPropagation();
                onOpen();
            }
        }
    }));
};
$739886c12c53b316$export$407448d2b89b1813.displayName = 'PureDateInput';
var $739886c12c53b316$var$KeyboardIcon = function KeyboardIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement((0, $5SbGE.default), props, (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement("path", {
        d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement("path", {
        fill: "none",
        d: "M0 0h24v24H0z"
    }));
};
var $739886c12c53b316$var$getDisplayDate = function getDisplayDate(value, format, utils, isEmpty, _ref) {
    var invalidLabel = _ref.invalidLabel, emptyLabel = _ref.emptyLabel, labelFunc = _ref.labelFunc;
    var date = utils.date(value);
    if (labelFunc) return labelFunc(isEmpty ? null : date, invalidLabel);
    if (isEmpty) return emptyLabel || '';
    return utils.isValid(date) ? utils.format(date, format) : invalidLabel;
};
var $739886c12c53b316$var$getComparisonMaxDate = function getComparisonMaxDate(utils, strictCompareDates, date) {
    if (strictCompareDates) return date;
    return utils.endOfDay(date);
};
var $739886c12c53b316$var$getComparisonMinDate = function getComparisonMinDate(utils, strictCompareDates, date) {
    if (strictCompareDates) return date;
    return utils.startOfDay(date);
};
var $739886c12c53b316$export$90a7f3efeed30595 = function validate(value, utils, _ref2) {
    var maxDate = _ref2.maxDate, minDate = _ref2.minDate, disablePast = _ref2.disablePast, disableFuture = _ref2.disableFuture, maxDateMessage = _ref2.maxDateMessage, minDateMessage = _ref2.minDateMessage, invalidDateMessage = _ref2.invalidDateMessage, strictCompareDates = _ref2.strictCompareDates;
    var parsedValue = utils.date(value); // if null - do not show error
    if (value === null) return '';
    if (!utils.isValid(value)) return invalidDateMessage;
    if (maxDate && utils.isAfter(parsedValue, $739886c12c53b316$var$getComparisonMaxDate(utils, !!strictCompareDates, utils.date(maxDate)))) return maxDateMessage;
    if (disableFuture && utils.isAfter(parsedValue, $739886c12c53b316$var$getComparisonMaxDate(utils, !!strictCompareDates, utils.date()))) return maxDateMessage;
    if (minDate && utils.isBefore(parsedValue, $739886c12c53b316$var$getComparisonMinDate(utils, !!strictCompareDates, utils.date(minDate)))) return minDateMessage;
    if (disablePast && utils.isBefore(parsedValue, $739886c12c53b316$var$getComparisonMinDate(utils, !!strictCompareDates, utils.date()))) return minDateMessage;
    return '';
};
function $739886c12c53b316$export$ffb5f4729a158638(userFormat) {
    var ampm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var formats = arguments.length > 2 ? arguments[2] : undefined;
    if (userFormat) return userFormat;
    return ampm ? formats['12h'] : formats['24h'];
}
function $739886c12c53b316$var$makeMaskFromFormat(format, numberMaskChar) {
    return format.replace(/[a-z]/gi, numberMaskChar);
}
var $739886c12c53b316$var$maskedDateFormatter = function maskedDateFormatter(mask, numberMaskChar, refuse) {
    return function(value) {
        var result = '';
        var parsed = value.replace(refuse, '');
        if (parsed === '') return parsed;
        var i = 0;
        var n = 0;
        while(i < mask.length){
            var maskChar = mask[i];
            if (maskChar === numberMaskChar && n < parsed.length) {
                var parsedChar = parsed[n];
                result += parsedChar;
                n += 1;
            } else result += maskChar;
            i += 1;
        }
        return result;
    };
};
function $739886c12c53b316$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $739886c12c53b316$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $739886c12c53b316$var$ownKeys$1(source, true).forEach(function(key) {
            (0, $c5c97159e13895ef$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $739886c12c53b316$var$ownKeys$1(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $739886c12c53b316$export$3466f893ebf79586 = function KeyboardDateInput(_ref) {
    var inputValue = _ref.inputValue, inputVariant = _ref.inputVariant, validationError = _ref.validationError, KeyboardButtonProps = _ref.KeyboardButtonProps, InputAdornmentProps = _ref.InputAdornmentProps, onOpen = _ref.openPicker, onChange = _ref.onChange, InputProps = _ref.InputProps, mask = _ref.mask, _ref$maskChar = _ref.maskChar, maskChar = _ref$maskChar === void 0 ? '_' : _ref$maskChar, _ref$refuse = _ref.refuse, refuse = _ref$refuse === void 0 ? /[^\d]+/gi : _ref$refuse, format = _ref.format, keyboardIcon = _ref.keyboardIcon, disabled = _ref.disabled, rifmFormatter = _ref.rifmFormatter, _ref$TextFieldCompone = _ref.TextFieldComponent, TextFieldComponent = _ref$TextFieldCompone === void 0 ? (0, $eYT2J.default) : _ref$TextFieldCompone, other = (0, $47143c6253cef6b3$export$2e2bcd8739ae039)(_ref, [
        "inputValue",
        "inputVariant",
        "validationError",
        "KeyboardButtonProps",
        "InputAdornmentProps",
        "openPicker",
        "onChange",
        "InputProps",
        "mask",
        "maskChar",
        "refuse",
        "format",
        "keyboardIcon",
        "disabled",
        "rifmFormatter",
        "TextFieldComponent"
    ]);
    var inputMask = mask || $739886c12c53b316$var$makeMaskFromFormat(format, maskChar); // prettier-ignore
    var formatter = (0, $ieT14.useMemo)(function() {
        return $739886c12c53b316$var$maskedDateFormatter(inputMask, maskChar, refuse);
    }, [
        inputMask,
        maskChar,
        refuse
    ]);
    var position = InputAdornmentProps && InputAdornmentProps.position ? InputAdornmentProps.position : 'end';
    var handleChange = function handleChange(text) {
        var finalString = text === '' || text === inputMask ? null : text;
        onChange(finalString);
    };
    return (0, $ieT14.createElement)((0, $948b1749ef1e7b80$export$5519909ee832c7c), {
        key: inputMask,
        value: inputValue,
        onChange: handleChange,
        refuse: refuse,
        format: rifmFormatter || formatter
    }, function(_ref2) {
        var onChange = _ref2.onChange, value = _ref2.value;
        return (0, $ieT14.createElement)(TextFieldComponent, (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({
            disabled: disabled,
            error: Boolean(validationError),
            helperText: validationError
        }, other, {
            value: value,
            onChange: onChange,
            variant: inputVariant,
            InputProps: $739886c12c53b316$var$_objectSpread$1({}, InputProps, (0, $c5c97159e13895ef$export$2e2bcd8739ae039)({}, "".concat(position, "Adornment"), (0, $ieT14.createElement)((0, $0183086ec949ac76$export$2e2bcd8739ae039), (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({
                position: position
            }, InputAdornmentProps), (0, $ieT14.createElement)((0, $1KcBP.default), (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({
                disabled: disabled
            }, KeyboardButtonProps, {
                onClick: onOpen
            }), keyboardIcon))))
        }));
    });
};
$739886c12c53b316$export$3466f893ebf79586.defaultProps = {
    keyboardIcon: (0, $ieT14.createElement)($739886c12c53b316$var$KeyboardIcon, null)
};
function $739886c12c53b316$var$useOpenState(_ref) {
    var open = _ref.open, onOpen = _ref.onOpen, onClose = _ref.onClose;
    var setIsOpenState = null;
    if (open === undefined || open === null) {
        // The component is uncontrolled, so we need to give it its own state.
        var _useState = (0, $ieT14.useState)(false);
        var _useState2 = (0, $d1e29df46c022672$export$2e2bcd8739ae039)(_useState, 2);
        open = _useState2[0];
        setIsOpenState = _useState2[1];
    } // prettier-ignore
    var setIsOpen = (0, $ieT14.useCallback)(function(newIsOpen) {
        setIsOpenState && setIsOpenState(newIsOpen);
        return newIsOpen ? onOpen && onOpen() : onClose && onClose();
    }, [
        onOpen,
        onClose,
        setIsOpenState
    ]);
    return {
        isOpen: open,
        setIsOpen: setIsOpen
    };
}
var $739886c12c53b316$var$useValueToDate = function useValueToDate(utils, _ref) {
    var value = _ref.value, initialFocusedDate = _ref.initialFocusedDate;
    var nowRef = (0, $ieT14.useRef)(utils.date());
    var date = utils.date(value || initialFocusedDate || nowRef.current);
    return date && utils.isValid(date) ? date : nowRef.current;
};
function $739886c12c53b316$var$useDateValues(props, options) {
    var utils = (0, $227fe7cc0a67c04e$export$3b14a55fb2447963)();
    var date = $739886c12c53b316$var$useValueToDate(utils, props);
    var format = props.format || options.getDefaultFormat();
    return {
        date: date,
        format: format
    };
}
function $739886c12c53b316$export$3b14a55fb2447963(props, options) {
    var autoOk = props.autoOk, disabled = props.disabled, readOnly = props.readOnly, onAccept = props.onAccept, _onChange = props.onChange, onError = props.onError, value = props.value, variant = props.variant;
    var utils = (0, $227fe7cc0a67c04e$export$3b14a55fb2447963)();
    var _useOpenState = $739886c12c53b316$var$useOpenState(props), isOpen = _useOpenState.isOpen, setIsOpen = _useOpenState.setIsOpen;
    var _useDateValues = $739886c12c53b316$var$useDateValues(props, options), date = _useDateValues.date, format = _useDateValues.format;
    var _useState = (0, $ieT14.useState)(date), _useState2 = (0, $d1e29df46c022672$export$2e2bcd8739ae039)(_useState, 2), pickerDate = _useState2[0], setPickerDate = _useState2[1];
    (0, $ieT14.useEffect)(function() {
        // if value was changed in closed state - treat it as accepted
        if (!isOpen && !utils.isEqual(pickerDate, date)) setPickerDate(date);
    }, [
        date,
        isOpen,
        pickerDate,
        utils
    ]);
    var acceptDate = (0, $ieT14.useCallback)(function(acceptedDate) {
        _onChange(acceptedDate);
        if (onAccept) onAccept(acceptedDate);
        setIsOpen(false);
    }, [
        onAccept,
        _onChange,
        setIsOpen
    ]);
    var wrapperProps = (0, $ieT14.useMemo)(function() {
        return {
            format: format,
            open: isOpen,
            onClear: function onClear() {
                return acceptDate(null);
            },
            onAccept: function onAccept() {
                return acceptDate(pickerDate);
            },
            onSetToday: function onSetToday() {
                return setPickerDate(utils.date());
            },
            onDismiss: function onDismiss() {
                setIsOpen(false);
            }
        };
    }, [
        acceptDate,
        format,
        isOpen,
        pickerDate,
        setIsOpen,
        utils
    ]);
    var pickerProps = (0, $ieT14.useMemo)(function() {
        return {
            date: pickerDate,
            onChange: function onChange(newDate) {
                var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                setPickerDate(newDate);
                if (isFinish && autoOk) {
                    acceptDate(newDate);
                    return;
                } // simulate autoOk, but do not close the modal
                if (variant === 'inline' || variant === 'static') {
                    _onChange(newDate);
                    onAccept && onAccept(newDate);
                }
            }
        };
    }, [
        acceptDate,
        autoOk,
        onAccept,
        _onChange,
        pickerDate,
        variant
    ]);
    var validationError = $739886c12c53b316$export$90a7f3efeed30595(value, utils, props);
    (0, $ieT14.useEffect)(function() {
        if (onError) onError(validationError, value);
    }, [
        onError,
        validationError,
        value
    ]);
    var inputValue = $739886c12c53b316$var$getDisplayDate(date, format, utils, value === null, props);
    var inputProps = (0, $ieT14.useMemo)(function() {
        return {
            inputValue: inputValue,
            validationError: validationError,
            openPicker: function openPicker() {
                return !readOnly && !disabled && setIsOpen(true);
            }
        };
    }, [
        disabled,
        inputValue,
        readOnly,
        setIsOpen,
        validationError
    ]);
    var pickerState = {
        pickerProps: pickerProps,
        inputProps: inputProps,
        wrapperProps: wrapperProps
    };
    (0, $ieT14.useDebugValue)(pickerState);
    return pickerState;
}
function $739886c12c53b316$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $739886c12c53b316$var$_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $739886c12c53b316$var$ownKeys$2(source, true).forEach(function(key) {
            (0, $c5c97159e13895ef$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $739886c12c53b316$var$ownKeys$2(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $739886c12c53b316$var$parseInputString(value, utils, format) {
    try {
        return utils.parse(value, format);
    } catch (_unused) {
        return null;
    }
}
function $739886c12c53b316$export$8b22cf2602fb60ce(props, options) {
    var _props$format = props.format, format = _props$format === void 0 ? options.getDefaultFormat() : _props$format, inputValue = props.inputValue, _onChange = props.onChange, value = props.value;
    var utils = (0, $227fe7cc0a67c04e$export$3b14a55fb2447963)();
    var displayDate = $739886c12c53b316$var$getDisplayDate(value, format, utils, value === null, props);
    var _useState = (0, $ieT14.useState)(displayDate), _useState2 = (0, $d1e29df46c022672$export$2e2bcd8739ae039)(_useState, 2), innerInputValue = _useState2[0], setInnerInputValue = _useState2[1];
    var dateValue = inputValue ? $739886c12c53b316$var$parseInputString(inputValue, utils, format) : value;
    (0, $ieT14.useEffect)(function() {
        if (value === null || utils.isValid(value)) setInnerInputValue(displayDate);
    }, [
        displayDate,
        setInnerInputValue,
        utils,
        value
    ]);
    var handleKeyboardChange = (0, $ieT14.useCallback)(function(date) {
        _onChange(date, date === null ? null : utils.format(date, format));
    }, [
        format,
        _onChange,
        utils
    ]);
    var _usePickerState = $739886c12c53b316$export$3b14a55fb2447963($739886c12c53b316$var$_objectSpread$2({}, props, {
        value: dateValue,
        onChange: handleKeyboardChange
    }), options), innerInputProps = _usePickerState.inputProps, wrapperProps = _usePickerState.wrapperProps, pickerProps = _usePickerState.pickerProps;
    var inputProps = (0, $ieT14.useMemo)(function() {
        return $739886c12c53b316$var$_objectSpread$2({}, innerInputProps, {
            // reuse validation and open/close logic
            format: wrapperProps.format,
            inputValue: inputValue || innerInputValue,
            onChange: function onChange(value) {
                setInnerInputValue(value || '');
                var date = value === null ? null : utils.parse(value, wrapperProps.format);
                _onChange(date, value);
            }
        });
    }, [
        innerInputProps,
        innerInputValue,
        inputValue,
        _onChange,
        utils,
        wrapperProps.format
    ]);
    return {
        inputProps: inputProps,
        wrapperProps: wrapperProps,
        pickerProps: pickerProps
    };
}
function $739886c12c53b316$export$953cecd6e717a553(_ref) {
    var Input = _ref.Input, useState = _ref.useState, useOptions = _ref.useOptions, getCustomProps = _ref.getCustomProps, DefaultToolbarComponent = _ref.DefaultToolbarComponent;
    function PickerWithState(props) {
        var allowKeyboardControl = props.allowKeyboardControl, ampm = props.ampm, animateYearScrolling = props.animateYearScrolling, autoOk = props.autoOk, dateRangeIcon = props.dateRangeIcon, disableFuture = props.disableFuture, disablePast = props.disablePast, disableToolbar = props.disableToolbar, emptyLabel = props.emptyLabel, format = props.format, forwardedRef = props.forwardedRef, hideTabs = props.hideTabs, initialFocusedDate = props.initialFocusedDate, invalidDateMessage = props.invalidDateMessage, invalidLabel = props.invalidLabel, labelFunc = props.labelFunc, leftArrowButtonProps = props.leftArrowButtonProps, leftArrowIcon = props.leftArrowIcon, loadingIndicator = props.loadingIndicator, maxDate = props.maxDate, maxDateMessage = props.maxDateMessage, minDate = props.minDate, minDateMessage = props.minDateMessage, minutesStep = props.minutesStep, onAccept = props.onAccept, onChange = props.onChange, onClose = props.onClose, onMonthChange = props.onMonthChange, onOpen = props.onOpen, onYearChange = props.onYearChange, openTo = props.openTo, orientation = props.orientation, renderDay = props.renderDay, rightArrowButtonProps = props.rightArrowButtonProps, rightArrowIcon = props.rightArrowIcon, shouldDisableDate = props.shouldDisableDate, strictCompareDates = props.strictCompareDates, timeIcon = props.timeIcon, _props$ToolbarCompone = props.ToolbarComponent, ToolbarComponent = _props$ToolbarCompone === void 0 ? DefaultToolbarComponent : _props$ToolbarCompone, value = props.value, variant = props.variant, views = props.views, other = (0, $47143c6253cef6b3$export$2e2bcd8739ae039)(props, [
            "allowKeyboardControl",
            "ampm",
            "animateYearScrolling",
            "autoOk",
            "dateRangeIcon",
            "disableFuture",
            "disablePast",
            "disableToolbar",
            "emptyLabel",
            "format",
            "forwardedRef",
            "hideTabs",
            "initialFocusedDate",
            "invalidDateMessage",
            "invalidLabel",
            "labelFunc",
            "leftArrowButtonProps",
            "leftArrowIcon",
            "loadingIndicator",
            "maxDate",
            "maxDateMessage",
            "minDate",
            "minDateMessage",
            "minutesStep",
            "onAccept",
            "onChange",
            "onClose",
            "onMonthChange",
            "onOpen",
            "onYearChange",
            "openTo",
            "orientation",
            "renderDay",
            "rightArrowButtonProps",
            "rightArrowIcon",
            "shouldDisableDate",
            "strictCompareDates",
            "timeIcon",
            "ToolbarComponent",
            "value",
            "variant",
            "views"
        ]);
        var injectedProps = getCustomProps ? getCustomProps(props) : {};
        var options = useOptions(props);
        var _useState = useState(props, options), pickerProps = _useState.pickerProps, inputProps = _useState.inputProps, wrapperProps = _useState.wrapperProps;
        return (0, $ieT14.createElement)((0, $e4ddf05ffa240aa3$export$71cec2538cb2c617), (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({
            variant: variant,
            InputComponent: Input,
            DateInputProps: inputProps
        }, injectedProps, wrapperProps, other), (0, $ieT14.createElement)((0, $a21d6ee6ab5a8fc2$export$56c0d5a1e737357d), (0, $c902b5d6d6384f3f$export$2e2bcd8739ae039)({}, pickerProps, {
            allowKeyboardControl: allowKeyboardControl,
            ampm: ampm,
            animateYearScrolling: animateYearScrolling,
            dateRangeIcon: dateRangeIcon,
            disableFuture: disableFuture,
            disablePast: disablePast,
            disableToolbar: disableToolbar,
            hideTabs: hideTabs,
            leftArrowButtonProps: leftArrowButtonProps,
            leftArrowIcon: leftArrowIcon,
            loadingIndicator: loadingIndicator,
            maxDate: maxDate,
            minDate: minDate,
            minutesStep: minutesStep,
            onMonthChange: onMonthChange,
            onYearChange: onYearChange,
            openTo: openTo,
            orientation: orientation,
            renderDay: renderDay,
            rightArrowButtonProps: rightArrowButtonProps,
            rightArrowIcon: rightArrowIcon,
            shouldDisableDate: shouldDisableDate,
            strictCompareDates: strictCompareDates,
            timeIcon: timeIcon,
            ToolbarComponent: ToolbarComponent,
            views: views
        })));
    }
    return PickerWithState;
}



























var $d2c3211918dbdb4a$var$useStyles = (0, $e1ONw.default)({
    toolbar: {
        flexDirection: 'column',
        alignItems: 'flex-start'
    },
    toolbarLandscape: {
        padding: 16
    },
    dateLandscape: {
        marginRight: 16
    }
}, {
    name: 'MuiPickersDatePickerRoot'
});
var $d2c3211918dbdb4a$var$DatePickerToolbar = function DatePickerToolbar(_ref) {
    var date = _ref.date, views = _ref.views, setOpenView = _ref.setOpenView, isLandscape = _ref.isLandscape, openView = _ref.openView;
    var utils = (0, $227fe7cc0a67c04e$export$3b14a55fb2447963)();
    var classes = $d2c3211918dbdb4a$var$useStyles();
    var isYearOnly = (0, $ieT14.useMemo)(function() {
        return (0, $d97c7d9d60e2b0e4$export$23f2a1d2818174ef)(views);
    }, [
        views
    ]);
    var isYearAndMonth = (0, $ieT14.useMemo)(function() {
        return (0, $d97c7d9d60e2b0e4$export$8b22cf2602fb60ce)(views);
    }, [
        views
    ]);
    return (0, $ieT14.createElement)((0, $739886c12c53b316$export$56c0d5a1e737357d), {
        isLandscape: isLandscape,
        className: (0, $j6s32.default)(!isYearOnly && classes.toolbar, isLandscape && classes.toolbarLandscape)
    }, (0, $ieT14.createElement)((0, $739886c12c53b316$export$971d5caa766a69d7), {
        variant: isYearOnly ? 'h3' : 'subtitle1',
        onClick: function onClick() {
            return setOpenView('year');
        },
        selected: openView === 'year',
        label: utils.getYearText(date)
    }), !isYearOnly && !isYearAndMonth && (0, $ieT14.createElement)((0, $739886c12c53b316$export$971d5caa766a69d7), {
        variant: "h4",
        selected: openView === 'date',
        onClick: function onClick() {
            return setOpenView('date');
        },
        align: isLandscape ? 'left' : 'center',
        label: utils.getDatePickerHeaderText(date),
        className: (0, $j6s32.default)(isLandscape && classes.dateLandscape)
    }), isYearAndMonth && (0, $ieT14.createElement)((0, $739886c12c53b316$export$971d5caa766a69d7), {
        variant: "h4",
        onClick: function onClick() {
            return setOpenView('month');
        },
        selected: openView === 'month',
        label: utils.getMonthText(date)
    }));
};
function $d2c3211918dbdb4a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d2c3211918dbdb4a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d2c3211918dbdb4a$var$ownKeys(source, true).forEach(function(key) {
            (0, $c5c97159e13895ef$export$2e2bcd8739ae039)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d2c3211918dbdb4a$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $d2c3211918dbdb4a$var$defaultProps = $d2c3211918dbdb4a$var$_objectSpread({}, (0, $a21d6ee6ab5a8fc2$export$4368d992c4eafac0), {
    openTo: 'date',
    views: [
        'year',
        'date'
    ]
});
function $d2c3211918dbdb4a$var$useOptions(props) {
    var utils = (0, $227fe7cc0a67c04e$export$3b14a55fb2447963)();
    return {
        getDefaultFormat: function getDefaultFormat() {
            return (0, $d97c7d9d60e2b0e4$export$39b482c5e57630a8)(props.views, utils);
        }
    };
}
var $d2c3211918dbdb4a$export$5109c6dd95d8fb00 = (0, $739886c12c53b316$export$953cecd6e717a553)({
    useOptions: $d2c3211918dbdb4a$var$useOptions,
    Input: (0, $739886c12c53b316$export$407448d2b89b1813),
    useState: (0, $739886c12c53b316$export$3b14a55fb2447963),
    DefaultToolbarComponent: $d2c3211918dbdb4a$var$DatePickerToolbar
});
var $d2c3211918dbdb4a$export$d8c44f501031ee7c = (0, $739886c12c53b316$export$953cecd6e717a553)({
    useOptions: $d2c3211918dbdb4a$var$useOptions,
    Input: (0, $739886c12c53b316$export$3466f893ebf79586),
    useState: (0, $739886c12c53b316$export$8b22cf2602fb60ce),
    DefaultToolbarComponent: $d2c3211918dbdb4a$var$DatePickerToolbar
});
$d2c3211918dbdb4a$export$5109c6dd95d8fb00.defaultProps = $d2c3211918dbdb4a$var$defaultProps;
$d2c3211918dbdb4a$export$d8c44f501031ee7c.defaultProps = $d2c3211918dbdb4a$var$defaultProps;



var $gXLwJ = parcelRequire("gXLwJ");

var $aIJrd = parcelRequire("aIJrd");

const $9ef105b60e2d1d8b$var$materialTheme = (0, $gXLwJ.default)({
    overrides: {
        // @ts-ignore
        root: {
            width: 126
        },
        MuiPickersToolbar: {
            toolbar: {
                backgroundColor: '#1b7cbb'
            }
        },
        MuiPickersDay: {
            daySelected: {
                backgroundColor: `#1b7cbb`
            }
        },
        MuiButton: {
            textPrimary: {
                color: `#1b7cbb`
            }
        },
        MuiOutlinedInput: {
            root: {
                width: '100%',
                height: '100%',
                paddingBottom: 8,
                '&$focused $notchedOutline': {
                    borderColor: '#00AAFC'
                }
            },
            input: {
                fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).body,
                fontWeight: 300,
                letterSpacing: '0.3px',
                fontSize: 14,
                paddingLeft: 6
            },
            adornedEnd: {
                paddingRight: 6,
                paddingTop: 6
            }
        },
        MuiSvgIcon: {
            root: {
                fill: '#4f4f4f',
                width: 22,
                height: 22
            }
        },
        MuiIconButton: {
            root: {
                padding: 0
            }
        },
        MuiFormLabel: {
            root: {
                fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).heading,
                fontWeight: 300,
                color: '#4f4f4f !important',
                fontSize: 14,
                '&$focused': {
                    color: '#4f4f4f !important'
                }
            }
        }
    }
});
const $9ef105b60e2d1d8b$var$DatePicker = (0, $aIJrd.default)({
    root: {
        fontSize: '12px',
        height: 40,
        width: 126,
        marginBottom: 17,
        '& .MuiInputLabel-outlined': {
            transform: 'translate(8px, 14px) scale(1)',
            fontSize: 14
        },
        '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
            transform: 'translate(14px, -6px) scale(0.75) !important'
        }
    }
})((0, $d2c3211918dbdb4a$export$d8c44f501031ee7c));
const $9ef105b60e2d1d8b$var$FilterDatePicker = ({ date: date, label: label, isStartDate: isStartDate, changeDate: changeDate })=>{
    const handleChange = (date)=>{
        changeDate(date, isStartDate);
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $544e32820ad8eb30$export$2e2bcd8739ae039), {
        theme: $9ef105b60e2d1d8b$var$materialTheme,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($9ef105b60e2d1d8b$var$DatePicker, {
            autoOk: true,
            value: date,
            onChange: (date, value)=>handleChange(date),
            inputVariant: "outlined",
            format: "MM/DD/YYYY",
            emptyLabel: "__/__/____",
            label: label,
            invalidDateMessage: " ",
            minDateMessage: " ",
            maxDateMessage: " "
        })
    });
};
var $9ef105b60e2d1d8b$export$2e2bcd8739ae039 = $9ef105b60e2d1d8b$var$FilterDatePicker;






var $ieT14 = parcelRequire("ieT14");





var $lamW6 = parcelRequire("lamW6");
/**
 * Filter
 * @function Filter - Individual filter checkbox
 */ const $efea6629c01ed492$var$Filter = ({ filterType: filterType, label: label, allChecked: allChecked, setAllChecked: setAllChecked })=>{
    const { updateLocalFilters: updateLocalFilters } = (0, $fb8741f1dceab0dd$export$2e2bcd8739ae039)();
    const { localSelectedFilters: localSelectedFilters } = $ieT14.useContext((0, $9308be3dff04d2e5$export$21063b480a162460));
    /**
   * @function isChecked - Returns boolean indicating that the checkbox should be checked
   */ const isChecked = ()=>{
        switch(filterType){
            case (0, $86201414f684ef37$export$2e2bcd8739ae039).Organization:
                return !!localSelectedFilters.organizationSelected.find((filter)=>filter === label);
            case (0, $86201414f684ef37$export$2e2bcd8739ae039).Requester:
                return !!localSelectedFilters.requesterSelected.find((filter)=>filter === label);
            case (0, $86201414f684ef37$export$2e2bcd8739ae039).Status:
                return !!localSelectedFilters.statusSelected.find((filter)=>filter === label);
            case (0, $86201414f684ef37$export$2e2bcd8739ae039).Type:
                return !!localSelectedFilters.requestTypeSelected.find((filter)=>filter.text === label || filter === label);
        }
    };
    /**
   * @function chooseStyle - Chooses which classes should be applied to the checkbox
   */ const chooseStyle = ()=>{
        if (!label && allChecked || label && isChecked()) return $f2b16bcfb478c50c$export$f77685c252cbae87;
        return $f2b16bcfb478c50c$export$b07e517d22efa1ca;
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $lamW6.default), {
        checked: label ? isChecked() : allChecked,
        classes: {
            root: chooseStyle()
        },
        onChange: ()=>{
            !label && setAllChecked(!allChecked);
            updateLocalFilters(filterType, label, label ? isChecked() : allChecked);
        }
    });
};
var $efea6629c01ed492$export$2e2bcd8739ae039 = $efea6629c01ed492$var$Filter;


/**
 * FilterSection
 * @function FilterSection - Individual section for filters
 */ const $c73381962c9a814e$var$FilterSection = ({ filterType: filterType, filters: filters, localFilters: localFilters })=>{
    const { updateLocalFilters: updateLocalFilters } = (0, $fb8741f1dceab0dd$export$2e2bcd8739ae039)();
    const { localSelectedFilters: localSelectedFilters } = $ieT14.useContext((0, $9308be3dff04d2e5$export$21063b480a162460));
    const [allChecked, setAllChecked] = $ieT14.useState(false);
    //Removes "All" check if one of the filters is unchecked
    $ieT14.useEffect(()=>{
        if (localFilters && filters && localFilters.length !== filters.length && allChecked) setAllChecked(false);
    }, [
        localFilters
    ]);
    /**
   *
   * @param date Moment date object
   * @param isStartDate Boolean indicating whether the value is a start date or not
   */ const handleDateChange = (date, isStartDate)=>{
        if (date && date.isValid) return updateLocalFilters(filterType, date, null, isStartDate);
        updateLocalFilters(filterType, null, null, isStartDate);
    };
    /**
   * @function chooseFilters - Displays either date pickers or checkboxes based on FilterType
   */ const chooseFilters = ()=>{
        if (filterType === (0, $86201414f684ef37$export$2e2bcd8739ae039).CreatedDate) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $9ef105b60e2d1d8b$export$2e2bcd8739ae039), {
                    label: "Start Date",
                    date: localSelectedFilters.createdDateStart,
                    isStartDate: true,
                    changeDate: (date, isStartDate)=>handleDateChange(date, isStartDate)
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $9ef105b60e2d1d8b$export$2e2bcd8739ae039), {
                    label: "End Date",
                    date: localSelectedFilters.createdDateEnd,
                    isStartDate: false,
                    changeDate: (date, isStartDate)=>handleDateChange(date, isStartDate)
                })
            ]
        });
        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3WBJn.default), {
            row: true,
            classes: {
                root: $f2b16bcfb478c50c$export$bc48b8aea52cfd28
            },
            children: filters.length > 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $knRao.default), {
                        classes: {
                            root: $f2b16bcfb478c50c$export$b96bb35bc88d6fa
                        },
                        control: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $efea6629c01ed492$export$2e2bcd8739ae039), {
                            filterType: filterType,
                            allChecked: allChecked,
                            setAllChecked: (check)=>setAllChecked(check)
                        }),
                        label: "All"
                    }, `filter-all`),
                    filters.map((filter, index)=>{
                        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $knRao.default), {
                            classes: {
                                root: $f2b16bcfb478c50c$export$b96bb35bc88d6fa
                            },
                            control: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $efea6629c01ed492$export$2e2bcd8739ae039), {
                                label: typeof filter === 'string' ? filter : filter.text,
                                filterType: filterType
                            }),
                            label: typeof filter === 'string' ? filter : filter.text
                        }, `filter-${index}`);
                    })
                ]
            }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                className: $f2b16bcfb478c50c$export$b96bb35bc88d6fa,
                children: "No filters available"
            })
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $f2b16bcfb478c50c$export$5b26fc7e638ec99f,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                className: $f2b16bcfb478c50c$export$fb184b623420d9be,
                children: filterType
            }),
            chooseFilters()
        ]
    });
};
var $c73381962c9a814e$export$2e2bcd8739ae039 = $c73381962c9a814e$var$FilterSection;









/**
 * SupportSidebar
 * @function SupportSidebar - Sidebar on the support page used for filters
 */ const $5688c19c618620f0$var$SupportSidebar = ({ collapsed: collapsed })=>{
    const { state: state } = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { allFilters: allFilters, localSelectedFilters: localSelectedFilters, selectedFilters: selectedFilters, orderColumn: orderColumn, searchQuery: searchQuery, dispatch: dispatch, pageSize: pageSize, orderDirection: orderDirection } = $ieT14.useContext((0, $9308be3dff04d2e5$export$21063b480a162460));
    const { fetchSupportTickets: fetchSupportTickets, clearAllFilters: clearAllFilters, countFilters: countFilters } = (0, $fb8741f1dceab0dd$export$2e2bcd8739ae039)();
    const { measuredRef: measuredRef, dimensions: dimensions } = (0, $d9ed1b1da5a3379c$export$2e2bcd8739ae039)([], true);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $f2b16bcfb478c50c$export$45d514ce1c64ae8a,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        className: collapsed ? $f2b16bcfb478c50c$export$216c8a0373c9171b : $f2b16bcfb478c50c$export$acf4eaf431084f78,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                                icon: "filter_list"
                            }),
                            !collapsed && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                children: "Filters"
                            })
                        ]
                    }),
                    !collapsed && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        className: collapsed ? $f2b16bcfb478c50c$export$37ea226ff2a44552 : $f2b16bcfb478c50c$export$9eaeb132619b6fc,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fcd3b8c5e9a7038b$export$2e2bcd8739ae039), {
                                text: "Clear All",
                                title: "Clear All",
                                handleClick: ()=>clearAllFilters(state.clientId)
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                className: $f2b16bcfb478c50c$export$afcc4a2b8a081448,
                                children: countFilters()
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: collapsed ? $f2b16bcfb478c50c$export$f9f0abb6616caaca : $f2b16bcfb478c50c$export$82462a21aead86ed,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        className: $f2b16bcfb478c50c$export$4c396c7e5aec5550,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fcd3b8c5e9a7038b$export$2e2bcd8739ae039), {
                                text: "Cancel",
                                title: "Cancel",
                                deactive: $fRnKy.isEqual(localSelectedFilters, selectedFilters),
                                handleClick: ()=>dispatch({
                                        localSelectedFilters: selectedFilters
                                    })
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f5afe0f42548a953$export$2e2bcd8739ae039), {
                                text: "Apply",
                                title: "Apply Filters",
                                styles: {
                                    marginLeft: 18
                                },
                                deactive: !!(localSelectedFilters.createdDateStart && !localSelectedFilters.createdDateStart._isValid || localSelectedFilters.createdDateEnd && !localSelectedFilters.createdDateEnd._isValid) || $fRnKy.isEqual(localSelectedFilters, selectedFilters),
                                handleClick: ()=>{
                                    dispatch({
                                        selectedFilters: localSelectedFilters
                                    });
                                    fetchSupportTickets(state.clientId, {
                                        orderColumn: orderColumn,
                                        orderDirection: orderDirection,
                                        searchTerm: searchQuery,
                                        startAt: 0,
                                        count: pageSize
                                    });
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("form", {
                        ref: measuredRef,
                        style: {
                            height: `calc(100vh - ${dimensions ? 20 + dimensions.top : 0}px`
                        },
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5d10f0a7aadd7c8c$exports))), {
                            className: $f2b16bcfb478c50c$export$57ad902a600ecd80,
                            autoHide: true,
                            universal: true,
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $c73381962c9a814e$export$2e2bcd8739ae039), {
                                    filterType: (0, $86201414f684ef37$export$2e2bcd8739ae039).Type,
                                    filters: allFilters.types,
                                    localFilters: localSelectedFilters.requestTypeSelected
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $c73381962c9a814e$export$2e2bcd8739ae039), {
                                    filterType: (0, $86201414f684ef37$export$2e2bcd8739ae039).Status,
                                    filters: allFilters.statuses,
                                    localFilters: localSelectedFilters.statusSelected
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $c73381962c9a814e$export$2e2bcd8739ae039), {
                                    filterType: (0, $86201414f684ef37$export$2e2bcd8739ae039).Requester,
                                    filters: allFilters.requesters,
                                    localFilters: localSelectedFilters.requesterSelected
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $c73381962c9a814e$export$2e2bcd8739ae039), {
                                    filterType: (0, $86201414f684ef37$export$2e2bcd8739ae039).Organization,
                                    filters: allFilters.organizations,
                                    localFilters: localSelectedFilters.organizationSelected
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $c73381962c9a814e$export$2e2bcd8739ae039), {
                                    filterType: (0, $86201414f684ef37$export$2e2bcd8739ae039).CreatedDate
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $5688c19c618620f0$export$2e2bcd8739ae039 = $5688c19c618620f0$var$SupportSidebar;





var $ieT14 = parcelRequire("ieT14");

var $fRnKy = parcelRequire("fRnKy");







var $ieT14 = parcelRequire("ieT14");




var $638a6323d534592c$var$SortingOptions = /*#__PURE__*/ function(SortingOptions) {
    SortingOptions["Ascending"] = "asc";
    SortingOptions["Descending"] = "desc";
    SortingOptions["Summary"] = "summary";
    SortingOptions["Status"] = "status";
    SortingOptions["Reporter"] = "reporter";
    SortingOptions["Key"] = "key";
    SortingOptions["Created"] = "created";
    SortingOptions["Updated"] = "updated";
    return SortingOptions;
}($638a6323d534592c$var$SortingOptions || {});
var $638a6323d534592c$export$2e2bcd8739ae039 = $638a6323d534592c$var$SortingOptions;


/**
 * PageCount
 * @function PageCount - Component displaying an option for page size on the support page
 */ const $4cac80f4ef194115$var$PageCount = ({ count: count })=>{
    const { fetchSupportTickets: fetchSupportTickets } = (0, $fb8741f1dceab0dd$export$2e2bcd8739ae039)();
    const { state: state } = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { selectedFilters: selectedFilters, orderColumn: orderColumn, searchQuery: searchQuery, pageSize: pageSize } = $ieT14.useContext((0, $9308be3dff04d2e5$export$21063b480a162460));
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
        onClick: ()=>fetchSupportTickets(state.clientId, {
                ...selectedFilters,
                orderColumn: orderColumn,
                searchTerm: searchQuery,
                orderDirection: (0, $638a6323d534592c$export$2e2bcd8739ae039).Descending,
                startAt: 0,
                count: count
            }),
        className: `${$f2b16bcfb478c50c$export$e02e799aaaceeea7} ${pageSize === count ? $f2b16bcfb478c50c$export$5b0f3a3d8bdfc3fb : ''}`,
        children: count
    });
};
var $4cac80f4ef194115$export$2e2bcd8739ae039 = $4cac80f4ef194115$var$PageCount;




var $ieT14 = parcelRequire("ieT14");
const $f5b03ed54e3fcddc$var$PagesDisplay = ({ totalPages: totalPages, allPages: allPages, selectedPage: selectedPage, activeStyles: activeStyles, handlePageChange: handlePageChange })=>{
    /**
   * renderPages
   * @function renderPages - Renders the list of available pages
   */ const renderPages = ()=>{
        if (totalPages === 1) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
            className: activeStyles,
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                children: allPages[0]
            })
        });
        else if (totalPages <= 4) return allPages.map((page, index)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: selectedPage === page ? activeStyles : '',
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                    onClick: ()=>handlePageChange(page),
                    children: page
                })
            }, index));
        else if (totalPages > 4 && selectedPage === 1) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: activeStyles,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(selectedPage),
                        children: selectedPage
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(selectedPage + 1),
                        children: selectedPage + 1
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(selectedPage + 2),
                        children: selectedPage + 2
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                        onClick: ()=>handlePageChange(totalPages),
                        children: [
                            "...",
                            totalPages
                        ]
                    })
                })
            ]
        });
        else if (totalPages > 4 && selectedPage === 2) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(selectedPage - 1),
                        children: selectedPage - 1
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: activeStyles,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(selectedPage),
                        children: selectedPage
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(selectedPage + 1),
                        children: selectedPage + 1
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                        onClick: ()=>handlePageChange(totalPages),
                        children: [
                            "...",
                            totalPages
                        ]
                    })
                })
            ]
        });
        else if (totalPages > 4 && (selectedPage === totalPages || selectedPage === totalPages - 1)) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(1),
                        children: "1..."
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: selectedPage === totalPages - 2 ? activeStyles : '',
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(totalPages - 2),
                        children: totalPages - 2
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: selectedPage === totalPages - 1 ? activeStyles : '',
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(totalPages - 1),
                        children: totalPages - 1
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: selectedPage === totalPages ? activeStyles : '',
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(totalPages),
                        children: totalPages
                    })
                })
            ]
        });
        else if (totalPages > 4 && selectedPage <= totalPages - 2) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(1),
                        children: "1..."
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(selectedPage - 1),
                        children: selectedPage - 1
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: activeStyles,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(selectedPage),
                        children: selectedPage
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        onClick: ()=>handlePageChange(selectedPage + 1),
                        children: selectedPage + 1
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                        onClick: ()=>handlePageChange(totalPages),
                        children: [
                            "...",
                            totalPages
                        ]
                    })
                })
            ]
        });
        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {});
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($ieT14.Fragment, {
        children: renderPages()
    });
};
var $f5b03ed54e3fcddc$export$2e2bcd8739ae039 = $f5b03ed54e3fcddc$var$PagesDisplay;



/**
 * SupportPagination
 * @function SupportPagination - Componenet to render pagination on the support page
 */ const $b79abaa6f1ca53bf$var$SupportPagination = ()=>{
    const { fetchSupportTickets: fetchSupportTickets } = (0, $fb8741f1dceab0dd$export$2e2bcd8739ae039)();
    const { state: state } = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { selectedFilters: selectedFilters, orderColumn: orderColumn, orderDirection: orderDirection, searchQuery: searchQuery, pageSize: pageSize, totalTickets: totalTickets, currentPage: currentPage } = $ieT14.useContext((0, $9308be3dff04d2e5$export$21063b480a162460));
    const [inputPage, setInputPage] = $ieT14.useState(null);
    const totalPages = Math.ceil(totalTickets / pageSize);
    const selectedPage = Math.ceil((currentPage + 1) / pageSize);
    const allPages = $fRnKy.range(1, totalPages + 1);
    /**
   * handlePageChange
   * @function handlePageChange - Fetches the support tickets after the user selects the number page
   * @param newPage Selects which page will be requested
   */ const handlePageChange = (newPage)=>{
        if (newPage > totalPages) newPage = totalPages;
        else if (newPage < 1) newPage = 1;
        fetchSupportTickets(state.clientId, {
            ...selectedFilters,
            searchTerm: searchQuery,
            count: pageSize,
            startAt: (newPage - 1) * pageSize,
            orderColumn: orderColumn,
            orderDirection: orderDirection
        });
    };
    // Clears out the number in input if the selectedPage is changed outside the input
    $ieT14.useEffect(()=>{
        if (selectedPage !== inputPage) setInputPage(null);
    }, [
        selectedPage
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $f2b16bcfb478c50c$export$5dd819bdfbc7b15d,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $f2b16bcfb478c50c$export$4945c604e8eedb97,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        children: "Show: "
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4cac80f4ef194115$export$2e2bcd8739ae039), {
                        count: 15
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4cac80f4ef194115$export$2e2bcd8739ae039), {
                        count: 30
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4cac80f4ef194115$export$2e2bcd8739ae039), {
                        count: 60
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $f2b16bcfb478c50c$export$908473471e9c0307,
                children: [
                    selectedPage !== 1 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                        icon: "keyboard_arrow_left",
                        onClick: ()=>handlePageChange(selectedPage - 1)
                    }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {}),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f5b03ed54e3fcddc$export$2e2bcd8739ae039), {
                        totalPages: totalPages,
                        allPages: allPages,
                        selectedPage: selectedPage,
                        activeStyles: $f2b16bcfb478c50c$export$ba319923d57aa6fe,
                        handlePageChange: (page)=>handlePageChange(page)
                    }),
                    selectedPage !== totalPages && totalPages > 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                        icon: "keyboard_arrow_right",
                        onClick: ()=>handlePageChange(selectedPage + 1)
                    }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {})
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $f2b16bcfb478c50c$export$4945c604e8eedb97,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        children: "Go To Page:"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("form", {
                        onSubmit: (event)=>{
                            event.preventDefault();
                            handlePageChange(inputPage);
                        },
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $db32c8adf65b4dff$export$2e2bcd8739ae039), {
                            id: "outlined-page-input",
                            margin: "dense",
                            variant: "outlined",
                            type: "number",
                            onChange: (event)=>setInputPage(Number(event.target.value)),
                            value: inputPage === 0 ? '0' : inputPage ? inputPage.toString().replace(/^0+/, '') : '',
                            tabIndex: 1
                        })
                    })
                ]
            })
        ]
    });
};
var $b79abaa6f1ca53bf$export$2e2bcd8739ae039 = $b79abaa6f1ca53bf$var$SupportPagination;




var $ieT14 = parcelRequire("ieT14");



var $ieT14 = parcelRequire("ieT14");



parcelRequire("ieT14");
const $7f6a016235204928$var$ArrowDropDown = ({ height: height, width: width, color: color, title: title, styles: styles, handleClick: handleClick })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        title: title || '',
        style: {
            position: 'relative',
            width: 18,
            height: 10,
            top: 4
        },
        onClick: (event)=>handleClick(),
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width || '24',
            height: height || '24',
            viewBox: "0 0 24 24",
            style: styles,
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("path", {
                    d: "M7 10l5 5 5-5z",
                    fill: color || 'none'
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("path", {
                    d: "M0 0h24v24H0z",
                    fill: "none"
                })
            ]
        })
    });
};
var $7f6a016235204928$export$2e2bcd8739ae039 = $7f6a016235204928$var$ArrowDropDown;



parcelRequire("ieT14");
const $c4ad5bf876d04d61$var$ArrowDropUp = ({ height: height, width: width, color: color, title: title, styles: styles, handleClick: handleClick })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        title: title || '',
        style: {
            position: 'absolute',
            width: 18,
            height: 10,
            bottom: 4,
            zIndex: 999,
            overflow: 'hidden'
        },
        onClick: (event)=>{
            event.stopPropagation();
            handleClick();
        },
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: width || '24',
            height: height || '24',
            viewBox: "0 0 24 24",
            style: styles || {},
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("path", {
                    d: "M7 14l5-5 5 5z",
                    fill: color || 'none'
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("path", {
                    d: "M0 0h24v24H0z",
                    fill: "none"
                })
            ]
        })
    });
};
var $c4ad5bf876d04d61$export$2e2bcd8739ae039 = $c4ad5bf876d04d61$var$ArrowDropUp;




const $577f8f6fe7c41359$var$TableColumn = ({ title: title, orderType: orderType, fetchSupportTickets: fetchSupportTickets })=>{
    const { state: state } = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { orderColumn: orderColumn, orderDirection: orderDirection, searchQuery: searchQuery, selectedFilters: selectedFilters, pageSize: pageSize, currentPage: currentPage } = $ieT14.useContext((0, $9308be3dff04d2e5$export$21063b480a162460));
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $f2b16bcfb478c50c$export$969e6b359c3584e7,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                className: orderType === orderColumn ? $f2b16bcfb478c50c$export$73ba5813cda80a49 : '',
                children: title
            }),
            ' ',
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $f2b16bcfb478c50c$export$ba34808fa9be5682,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $c4ad5bf876d04d61$export$2e2bcd8739ae039), {
                        height: "16",
                        width: "16",
                        color: orderType === orderColumn && orderDirection === (0, $638a6323d534592c$export$2e2bcd8739ae039).Ascending ? '#00223c' : '#c4c4c4',
                        styles: {
                            bottom: '-5px'
                        },
                        title: "Ascending",
                        handleClick: ()=>fetchSupportTickets(state.clientId, {
                                ...selectedFilters,
                                searchTerm: searchQuery,
                                orderDirection: (0, $638a6323d534592c$export$2e2bcd8739ae039).Ascending,
                                orderColumn: orderType,
                                count: pageSize,
                                startAt: currentPage
                            })
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $7f6a016235204928$export$2e2bcd8739ae039), {
                        height: "16",
                        width: "16",
                        color: orderType === orderColumn && orderDirection === (0, $638a6323d534592c$export$2e2bcd8739ae039).Descending ? '#00223c' : '#c4c4c4',
                        styles: {
                            top: '-4px'
                        },
                        title: "Descending",
                        handleClick: ()=>fetchSupportTickets(state.clientId, {
                                ...selectedFilters,
                                searchTerm: searchQuery,
                                orderDirection: (0, $638a6323d534592c$export$2e2bcd8739ae039).Descending,
                                orderColumn: orderType,
                                count: pageSize,
                                startAt: currentPage
                            })
                    })
                ]
            })
        ]
    });
};
var $577f8f6fe7c41359$export$2e2bcd8739ae039 = $577f8f6fe7c41359$var$TableColumn;








var $ieT14 = parcelRequire("ieT14");

/**
 * SupportEntry
 * @function SupportEntry
 */ const $bae17111442efb5e$var$SupportEntry = ({ ticket: ticket, handleModal: handleModal })=>{
    const firstRender = $ieT14.useRef(true);
    $ieT14.useEffect(()=>{
        if (!firstRender.current) handleModal(true, ticket);
        firstRender.current = false;
    }, [
        ticket.comments.length
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                className: $f2b16bcfb478c50c$export$e0dc1a1d8b3e2bdb,
                children: ticket.issueType
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                className: $f2b16bcfb478c50c$export$269f8f10d9f976b6,
                onClick: ()=>handleModal(true, ticket),
                children: ticket.issueName
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                className: $f2b16bcfb478c50c$export$41bdc12d2d25233b,
                title: ticket.summary,
                children: ticket.summary
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                children: ticket.status
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                className: $f2b16bcfb478c50c$export$41bdc12d2d25233b,
                title: ticket.reporter,
                children: ticket.reporter
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                children: ticket.organizationName
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                children: ticket.createdTime
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                children: ticket.updatedTime
            })
        ]
    });
};
var $bae17111442efb5e$export$2e2bcd8739ae039 = $bae17111442efb5e$var$SupportEntry;



parcelRequire("ieT14");

var $fVNJ1 = parcelRequire("fVNJ1");
var $d3220a6a8b27e7c5$export$b0377cbbbdab6cba;
var $d3220a6a8b27e7c5$export$f27f0a643498ce3d;
var $d3220a6a8b27e7c5$export$b00c055587dc7469;
var $d3220a6a8b27e7c5$export$b1a09d22b7ad6c4;
var $d3220a6a8b27e7c5$export$509f3108fdd206bb;
var $d3220a6a8b27e7c5$export$42ff741d2868ee32;
var $d3220a6a8b27e7c5$export$8c430709db82137d;
var $d3220a6a8b27e7c5$export$2d4b1211b4389c3b;
var $d3220a6a8b27e7c5$export$3832be13857745bc;
var $d3220a6a8b27e7c5$export$f4c68800b094ddb1;
var $d3220a6a8b27e7c5$export$1f00992629d4f7f3;
var $d3220a6a8b27e7c5$export$34e0f9847d4c02dd;
var $d3220a6a8b27e7c5$export$285bd1d6c6bdf942;
var $d3220a6a8b27e7c5$export$4e4e15c4caa470ab;
var $d3220a6a8b27e7c5$export$bbea856fdb3e3c5f;
var $d3220a6a8b27e7c5$export$dff8b0850021a04b;
var $d3220a6a8b27e7c5$export$45547f6c19231c9;
var $d3220a6a8b27e7c5$export$a59643d115b68bf0;
var $d3220a6a8b27e7c5$export$38e42c68cf43b5d4;
var $d3220a6a8b27e7c5$export$471f7ae5c4103ae1;
var $d3220a6a8b27e7c5$export$1237798dc640739a;
var $d3220a6a8b27e7c5$export$3481c78889e8fbe8;
var $d3220a6a8b27e7c5$export$193b67f0c6231f98;
var $d3220a6a8b27e7c5$export$41ee12f6f6f05843;
var $d3220a6a8b27e7c5$export$4797d706c78651b3;
var $d3220a6a8b27e7c5$export$3a444357c5f65f65;
var $d3220a6a8b27e7c5$export$e07dbff9e94e0ca8;
var $d3220a6a8b27e7c5$export$693c78934807284f;
var $d3220a6a8b27e7c5$export$758a914e573c0865;
var $d3220a6a8b27e7c5$export$571b02044ddb2ab3;
var $d3220a6a8b27e7c5$export$b86a40e3809401fb;
$d3220a6a8b27e7c5$export$b0377cbbbdab6cba = "#006da8";
$d3220a6a8b27e7c5$export$f27f0a643498ce3d = "#00aafc";
$d3220a6a8b27e7c5$export$b00c055587dc7469 = "#f5dbd9";
$d3220a6a8b27e7c5$export$b1a09d22b7ad6c4 = "#c92100";
$d3220a6a8b27e7c5$export$509f3108fdd206bb = "#ebafa6";
$d3220a6a8b27e7c5$export$42ff741d2868ee32 = "#074f86";
$d3220a6a8b27e7c5$export$8c430709db82137d = "#dadada";
$d3220a6a8b27e7c5$export$2d4b1211b4389c3b = "#dddbda";
$d3220a6a8b27e7c5$export$3832be13857745bc = "#eae9ed";
$d3220a6a8b27e7c5$export$f4c68800b094ddb1 = "#e9e8f4";
$d3220a6a8b27e7c5$export$1f00992629d4f7f3 = "ticketModal_2e1ca9";
$d3220a6a8b27e7c5$export$34e0f9847d4c02dd = "container_2e1ca9";
$d3220a6a8b27e7c5$export$285bd1d6c6bdf942 = "commentForm_2e1ca9";
$d3220a6a8b27e7c5$export$4e4e15c4caa470ab = "textbox_2e1ca9";
$d3220a6a8b27e7c5$export$bbea856fdb3e3c5f = "buttons_2e1ca9";
$d3220a6a8b27e7c5$export$dff8b0850021a04b = "filePicker_2e1ca9";
$d3220a6a8b27e7c5$export$45547f6c19231c9 = "fileName_2e1ca9";
$d3220a6a8b27e7c5$export$a59643d115b68bf0 = "uploadButton_2e1ca9";
$d3220a6a8b27e7c5$export$38e42c68cf43b5d4 = "header_2e1ca9";
$d3220a6a8b27e7c5$export$471f7ae5c4103ae1 = "status_2e1ca9";
$d3220a6a8b27e7c5$export$1237798dc640739a = "label_2e1ca9";
$d3220a6a8b27e7c5$export$3481c78889e8fbe8 = "center_2e1ca9";
$d3220a6a8b27e7c5$export$193b67f0c6231f98 = "noResults_2e1ca9";
$d3220a6a8b27e7c5$export$41ee12f6f6f05843 = "details_2e1ca9";
$d3220a6a8b27e7c5$export$4797d706c78651b3 = "filesSection_2e1ca9";
$d3220a6a8b27e7c5$export$3a444357c5f65f65 = "files_2e1ca9";
$d3220a6a8b27e7c5$export$e07dbff9e94e0ca8 = "commentsSection_2e1ca9";
$d3220a6a8b27e7c5$export$693c78934807284f = "commentsMap_2e1ca9";
$d3220a6a8b27e7c5$export$758a914e573c0865 = "commentWrapper_2e1ca9";
$d3220a6a8b27e7c5$export$571b02044ddb2ab3 = "author_2e1ca9";
$d3220a6a8b27e7c5$export$b86a40e3809401fb = "commentDetails_2e1ca9";



parcelRequire("ieT14");

var $eYT2J = parcelRequire("eYT2J");

var $aIJrd = parcelRequire("aIJrd");

const $8b308bea4c0aef38$var$CssTextField = (0, $aIJrd.default)({
    root: {
        width: '100%',
        '& .MuiFormLabel-root.Mui-disabled': {
            fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).heading,
            fontSize: 11,
            fontWeight: 300,
            color: '#4f4f4f'
        },
        '& .MuiInputBase-input': {
            color: '#000000',
            fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).body,
            fontWeight: 300,
            letterSpacing: '0.3px',
            fontSize: 14,
            paddingTop: 0
        },
        '& .MuiInput-underline.Mui-disabled:before': {
            borderBottomStyle: 'none'
        }
    }
})((0, $eYT2J.default));
const $8b308bea4c0aef38$var$HeaderTextField = (0, $aIJrd.default)({
    root: {
        width: '100%',
        '& .MuiFormLabel-root.Mui-disabled': {
            fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).body,
            fontSize: 12,
            fontWeight: 300,
            color: '#4f4f4f'
        },
        '& .MuiInputBase-input': {
            color: '#000000',
            fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).heading,
            fontWeight: 500,
            letterSpacing: '0.3px',
            fontSize: 16,
            paddingTop: 0
        }
    }
})((0, $eYT2J.default));
/**
 * DisabledInput
 * @function - Component for a disabled input, used to display text with a label
 */ const $8b308bea4c0aef38$var$DisabledInput = (props)=>{
    if (props.isheader) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($8b308bea4c0aef38$var$HeaderTextField, {
        ...props
    });
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($8b308bea4c0aef38$var$CssTextField, {
        ...props
    });
};
var $8b308bea4c0aef38$export$2e2bcd8739ae039 = $8b308bea4c0aef38$var$DisabledInput;




var $ieT14 = parcelRequire("ieT14");



parcelRequire("ieT14");

var $eYT2J = parcelRequire("eYT2J");

var $aIJrd = parcelRequire("aIJrd");

const $6488f33c63e4bc0e$var$CssTextField = (0, $aIJrd.default)({
    root: {
        '& .MuiFormControl': {
            '&$root': {
                width: '100%',
                height: '100%'
            }
        },
        '& label.Mui-focused': {
            color: '#4F4F4F'
        },
        '& .MuiOutlinedInput-root': {
            height: 98,
            width: 600,
            fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).body,
            fontSize: 14,
            letterSpacing: '0.3px',
            color: 'black',
            fontWeight: 300,
            '&.Mui-focused fieldset': {
                borderColor: '#00AAFC'
            }
        },
        '& .MuiOutlinedInput-input': {
            height: '100% !important'
        }
    }
})((0, $eYT2J.default));
const $6488f33c63e4bc0e$var$Textbox = (props)=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($6488f33c63e4bc0e$var$CssTextField, {
        ...props,
        InputLabelProps: {
            shrink: true
        }
    });
};
var $6488f33c63e4bc0e$export$2e2bcd8739ae039 = $6488f33c63e4bc0e$var$Textbox;






parcelRequire("ieT14");


var $ekezX = parcelRequire("ekezX");

parcelRequire("ieT14");
const $c038df71a8126985$var$UploadIcon = ({ width: width, height: height, color: color })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        width: width || 24,
        height: height || 24,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("path", {
            fill: color || 'none',
            d: "M9,10V16H15V10H19L12,3L5,10H9M12,5.8L14.2,8H13V14H11V8H9.8L12,5.8M19,18H5V20H19V18Z"
        })
    });
};
var $c038df71a8126985$export$2e2bcd8739ae039 = $c038df71a8126985$var$UploadIcon;


/**
 * UploadFileButton
 * @function UploadFileButton - Button for uploading files
 */ const $cefaf8ef638c5af5$var$UploadFileButton = (props)=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $ekezX.default), {
        className: $d3220a6a8b27e7c5$export$a59643d115b68bf0,
        variant: "outlined",
        ...props,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $c038df71a8126985$export$2e2bcd8739ae039), {
                color: "#006da8"
            }),
            "Upload File"
        ]
    });
};
var $cefaf8ef638c5af5$export$2e2bcd8739ae039 = $cefaf8ef638c5af5$var$UploadFileButton;



/**
 * isValidPassword
 * @function isValidPassword Checks that password meets the minimum requirements
 * @param password Password to be checked
 * @description
 *  - Minimum 8 characters
 *  - One uppercase letter
 *  - One lowercase letter
 *  - One number
 *  - One special character
 */ const $d3440ce222a0c87c$export$1cf356d314abea16 = (password)=>{
    const regex = RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})');
    return regex.test(password);
};
const $d3440ce222a0c87c$export$4f14893deafec3b7 = (password)=>{
    const regex = RegExp('(?=.*[!@#$%^&*])');
    return regex.test(password);
};
const $d3440ce222a0c87c$export$e6c1bffe0c115f1a = (password)=>{
    const regex = RegExp('^(?=.*[a-z])');
    return regex.test(password);
};
const $d3440ce222a0c87c$export$f659e651135ed98d = (password)=>{
    const regex = RegExp('(?=.*[A-Z])');
    return regex.test(password);
};
const $d3440ce222a0c87c$export$b690537571bdb851 = (password)=>{
    const regex = RegExp('(?=.*[0-9])');
    return regex.test(password);
};
const $d3440ce222a0c87c$export$37cc283d8fbd3462 = (files)=>new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = ()=>{
            resolve(reader.result);
        };
        reader.onerror = (error)=>reject(error);
    });


/**
 * @function CommentForm - Component that holds the form for the comment section of the support ticket modal
 */ const $e1095599411f3759$var$CommentForm = ({ ticket: ticket })=>{
    const { addComment: addComment } = (0, $fb8741f1dceab0dd$export$2e2bcd8739ae039)();
    const { state: state } = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const [comment, setComment] = $ieT14.useState('');
    const [attachments, setAttachments] = $ieT14.useState([]);
    const fileUploader = $ieT14.useRef(null);
    $ieT14.useEffect(()=>{
        setComment('');
        setAttachments([]);
    }, [
        ticket.comments.length
    ]);
    /**
   * @function submitComment - Submits a comment for the backend
   * @param event Form Event
   */ const submitComment = (event)=>{
        event && event.preventDefault();
        addComment(state.clientId, ticket.issueName, {
            text: comment,
            attachments: attachments
        });
    };
    /**
   * @function resetComment - Resets the comment to it's default state
   */ const resetComment = ()=>{
        setComment('');
        setAttachments([]);
    };
    /**
   * @function addAttachment - Adds an attachment to the state, converts attachments to base64
   * @param event Input Event
   */ const addAttachment = (event)=>{
        const fileName = event.target.files[0].name;
        (0, $d3440ce222a0c87c$export$37cc283d8fbd3462)(event.target.files).then((data)=>{
            setAttachments((files)=>files.concat({
                    fileName: fileName,
                    data: data
                }));
        });
    };
    /**
   * @function renderAttachments - Renders the attachment name, or count if attachment count is greater than 1
   */ const renderAttachments = ()=>{
        if (attachments.length === 1) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
            className: $d3220a6a8b27e7c5$export$45547f6c19231c9,
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                    children: attachments[0].fileName
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                    title: "Remove Attachment",
                    icon: "close",
                    onClick: ()=>setAttachments([])
                })
            ]
        });
        else if (attachments.length > 1) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
            className: $d3220a6a8b27e7c5$export$45547f6c19231c9,
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                    children: [
                        attachments.length,
                        " files"
                    ]
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                    title: "Remove Attachments",
                    icon: "close",
                    onClick: ()=>setAttachments([])
                })
            ]
        });
        return null;
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("form", {
        onSubmit: (event)=>submitComment(event),
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6488f33c63e4bc0e$export$2e2bcd8739ae039), {
                value: comment,
                className: $d3220a6a8b27e7c5$export$4e4e15c4caa470ab,
                label: "Add a comment",
                multiline: true,
                variant: "outlined",
                style: {
                    width: '100%'
                },
                onChange: (event)=>setComment(event.target.value)
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $d3220a6a8b27e7c5$export$bbea856fdb3e3c5f,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fcd3b8c5e9a7038b$export$2e2bcd8739ae039), {
                                text: "Clear",
                                title: "Clear",
                                handleClick: ()=>resetComment()
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f5afe0f42548a953$export$2e2bcd8739ae039), {
                                text: "Submit",
                                title: "Submit Comment",
                                deactive: !comment && attachments.length === 0,
                                handleClick: ()=>submitComment(),
                                styles: {
                                    minHeight: '32px',
                                    marginLeft: '20px'
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        className: $d3220a6a8b27e7c5$export$dff8b0850021a04b,
                        children: [
                            renderAttachments(),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("label", {
                                htmlFor: "file",
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $cefaf8ef638c5af5$export$2e2bcd8739ae039), {
                                    onClick: ()=>fileUploader.current.click()
                                })
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("input", {
                                type: "file",
                                id: "file",
                                name: "file",
                                ref: fileUploader,
                                onChange: (event)=>addAttachment(event)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $e1095599411f3759$export$2e2bcd8739ae039 = $e1095599411f3759$var$CommentForm;




var $ieT14 = parcelRequire("ieT14");

var $fRnKy = parcelRequire("fRnKy");


parcelRequire("ieT14");

const $408fd453596e4a58$var$CommentDisplay = ({ comment: comment })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $d3220a6a8b27e7c5$export$758a914e573c0865,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                className: $d3220a6a8b27e7c5$export$571b02044ddb2ab3,
                children: comment.author
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $d3220a6a8b27e7c5$export$b86a40e3809401fb,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        children: comment.createdTimeFriendly
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: comment.body
                        }
                    })
                ]
            })
        ]
    });
};
var $408fd453596e4a58$export$2e2bcd8739ae039 = $408fd453596e4a58$var$CommentDisplay;



var $aIJrd = parcelRequire("aIJrd");

var $5TjLg = parcelRequire("5TjLg");

var $bPjUl = parcelRequire("bPjUl");
var $3mOXj = parcelRequire("3mOXj");


const $17d187dc83b200aa$var$StyledMenu = (0, $aIJrd.default)({
    paper: {
        border: '1px solid #d3d4d5'
    }
})((props)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $5TjLg.default), {
        elevation: 0,
        getContentAnchorEl: null,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'center'
        },
        ...props
    }));
const $17d187dc83b200aa$var$StyledMenuItem = (0, $aIJrd.default)((theme)=>({
        root: {
            '&:focus': {
                backgroundColor: theme.palette.primary.main,
                '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                    color: theme.palette.common.white
                }
            },
            '& .MuiTypography-body1': {
                fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).body,
                fontWeight: 200,
                fontSize: 14,
                letterSpacing: '0.2px',
                color: '#000000'
            },
            '& .MuiListItem-button:hover': {
                backgroundColor: '#eaf3f8'
            }
        },
        selected: {
            backgroundColor: '#eaf3f8'
        }
    }))((0, $3mOXj.default));
/**
 * CommentSection
 * @function CommentSection - Outer component to display comments in modal
 */ const $17d187dc83b200aa$var$CommentSection = ({ comments: comments })=>{
    const [anchorEl, setAnchorEl] = $ieT14.useState(null);
    const [commentsState, setCommentsState] = $ieT14.useState([]);
    const [sortAscending, setSortAscending] = $ieT14.useState(true);
    $ieT14.useEffect(()=>{
        // Sorts comments on mount, and when the amount of comments changes
        sortComments(sortAscending, comments);
    }, [
        comments && comments.length
    ]);
    /**
   * @function sortComments - Sorts comments and closes menu
   * @param ascending Boolean indicating whether to sort comment ascending/descending
   * @param updatedComments Comments to be updated
   */ const sortComments = (ascending, updatedComments)=>{
        if (ascending) {
            setAnchorEl(null);
            setSortAscending(true);
            if (updatedComments) {
                const commentsClone = $fRnKy.cloneDeep(updatedComments);
                return setCommentsState(commentsClone.sort((a, b)=>b.createdTime >= a.createdTime ? 1 : -1));
            }
            return setCommentsState((arr)=>arr.sort((a, b)=>b.createdTime >= a.createdTime ? 1 : -1));
        }
        setSortAscending(false);
        setAnchorEl(null);
        if (updatedComments) {
            const commentsClone = $fRnKy.cloneDeep(updatedComments);
            return setCommentsState(commentsClone.sort((a, b)=>a.createdTime >= b.createdTime ? 1 : -1));
        }
        return setCommentsState((arr)=>arr.sort((a, b)=>a.createdTime >= b.createdTime ? 1 : -1));
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $d3220a6a8b27e7c5$export$e07dbff9e94e0ca8,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $d3220a6a8b27e7c5$export$38e42c68cf43b5d4,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h6", {
                        children: "Comments"
                    }),
                    comments.length > 1 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fcd3b8c5e9a7038b$export$2e2bcd8739ae039), {
                        text: "Sort",
                        title: "Sort",
                        handleClick: (event)=>setAnchorEl(event.currentTarget)
                    })
                ]
            }),
            commentsState.length > 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $d3220a6a8b27e7c5$export$693c78934807284f,
                children: commentsState.map((comment, index)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $408fd453596e4a58$export$2e2bcd8739ae039), {
                        comment: comment
                    }, `comment-${index}`))
            }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                className: $d3220a6a8b27e7c5$export$193b67f0c6231f98,
                children: "No comments present"
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($17d187dc83b200aa$var$StyledMenu, {
                id: "customized-menu",
                anchorEl: anchorEl,
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: ()=>setAnchorEl(null),
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($17d187dc83b200aa$var$StyledMenuItem, {
                        selected: sortAscending,
                        onClick: ()=>sortComments(true),
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $bPjUl.default), {
                            primary: "Newest to Oldest"
                        })
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($17d187dc83b200aa$var$StyledMenuItem, {
                        selected: !sortAscending,
                        onClick: ()=>sortComments(false),
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $bPjUl.default), {
                            primary: "Oldest to Newest"
                        })
                    })
                ]
            })
        ]
    });
};
var $17d187dc83b200aa$export$2e2bcd8739ae039 = $17d187dc83b200aa$var$CommentSection;





parcelRequire("ieT14");

/**
 * AttachedFiles
 * @function AttachedFiles - Component for list of attached files
 */ const $9cb8fad942e6ea04$var$AttachedFiles = ({ files: files })=>{
    /**
   * @const renderFiles - Renders list of files
   */ const renderFiles = ()=>{
        return files.map((file)=>{
            return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("a", {
                href: file.downloadUrl,
                target: "_blank",
                children: file.fileName
            }, `file-${file.downloadUrl}`);
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $d3220a6a8b27e7c5$export$3a444357c5f65f65,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                children: "Attached Files"
            }),
            renderFiles()
        ]
    });
};
var $9cb8fad942e6ea04$export$2e2bcd8739ae039 = $9cb8fad942e6ea04$var$AttachedFiles;


/**
 * ViewTicketModal
 * @function ViewTicketModal - Modal that shows the details of an individual ticket
 */ const $daf4b0e1f703897d$var$ViewTicketModal = ({ ticket: ticket, isOpen: isOpen, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fVNJ1.default), {
        className: $d3220a6a8b27e7c5$export$1f00992629d4f7f3,
        open: isOpen,
        onClose: (isOpen, option)=>onClose(!isOpen, option),
        children: ticket ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
            className: $d3220a6a8b27e7c5$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($77d97b813128dd85$exports))), {
                    icon: "close",
                    onClick: ()=>onClose(!isOpen, null)
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    className: $d3220a6a8b27e7c5$export$38e42c68cf43b5d4,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8b308bea4c0aef38$export$2e2bcd8739ae039), {
                            value: ticket.summary,
                            label: ticket.issueName,
                            disabled: true,
                            isheader: "true",
                            InputProps: {
                                disableUnderline: true
                            }
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                            className: $d3220a6a8b27e7c5$export$471f7ae5c4103ae1,
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                    className: $d3220a6a8b27e7c5$export$1237798dc640739a,
                                    children: "Status:"
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                    children: ticket.status
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: $d3220a6a8b27e7c5$export$3481c78889e8fbe8,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5d10f0a7aadd7c8c$exports))), {
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                className: $d3220a6a8b27e7c5$export$41ee12f6f6f05843,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8b308bea4c0aef38$export$2e2bcd8739ae039), {
                                        value: ticket.issueType,
                                        label: "Type",
                                        disabled: true,
                                        InputProps: {
                                            disableUnderline: true
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8b308bea4c0aef38$export$2e2bcd8739ae039), {
                                        value: ticket.priority,
                                        label: "Priority",
                                        disabled: true,
                                        InputProps: {
                                            disableUnderline: true
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8b308bea4c0aef38$export$2e2bcd8739ae039), {
                                        value: ticket.organizationName,
                                        label: "Service Desk Organization",
                                        disabled: true,
                                        InputProps: {
                                            disableUnderline: true
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8b308bea4c0aef38$export$2e2bcd8739ae039), {
                                        value: ticket.reporter,
                                        label: "Reporter",
                                        disabled: true,
                                        InputProps: {
                                            disableUnderline: true
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8b308bea4c0aef38$export$2e2bcd8739ae039), {
                                        value: ticket.summary,
                                        label: "Summary",
                                        disabled: true,
                                        multiline: true,
                                        InputProps: {
                                            disableUnderline: true
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8b308bea4c0aef38$export$2e2bcd8739ae039), {
                                        value: ticket.resolution,
                                        label: "Resolution",
                                        disabled: true,
                                        InputProps: {
                                            disableUnderline: true
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                className: $d3220a6a8b27e7c5$export$4797d706c78651b3,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h6", {
                                        children: "Attachments"
                                    }),
                                    ticket.attachments && ticket.attachments.length > 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $9cb8fad942e6ea04$export$2e2bcd8739ae039), {
                                        files: ticket.attachments
                                    }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                        className: $d3220a6a8b27e7c5$export$193b67f0c6231f98,
                                        children: "No attachments present"
                                    }),
                                    ticket.description && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8b308bea4c0aef38$export$2e2bcd8739ae039), {
                                        value: ticket.description,
                                        label: "Description",
                                        disabled: true,
                                        InputProps: {
                                            disableUnderline: true
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $17d187dc83b200aa$export$2e2bcd8739ae039), {
                                comments: ticket.comments
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: $d3220a6a8b27e7c5$export$285bd1d6c6bdf942,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $e1095599411f3759$export$2e2bcd8739ae039), {
                        ticket: ticket
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {})
    });
};
var $daf4b0e1f703897d$export$2e2bcd8739ae039 = $daf4b0e1f703897d$var$ViewTicketModal;





const $2c14ce205c3a17ab$var$SupportTable = ({ loading: loading })=>{
    const { tickets: tickets } = $ieT14.useContext((0, $9308be3dff04d2e5$export$21063b480a162460));
    const { fetchSupportTickets: fetchSupportTickets } = (0, $fb8741f1dceab0dd$export$2e2bcd8739ae039)();
    const [isModalOpen, setIsModalOpen] = $ieT14.useState(false);
    const [activeTicket, setActiveTicket] = $ieT14.useState(null);
    const handleModal = (isOpen, ticket)=>{
        setIsModalOpen(isOpen);
        setActiveTicket(ticket);
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $f2b16bcfb478c50c$export$e7d47881ec916f76,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $daf4b0e1f703897d$export$2e2bcd8739ae039), {
                ticket: activeTicket,
                isOpen: isModalOpen,
                onClose: handleModal
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5d10f0a7aadd7c8c$exports))), {
                className: $f2b16bcfb478c50c$export$57ad902a600ecd80,
                autoHide: true,
                universal: true,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $0cbf74840f7b6287$export$2e2bcd8739ae039), {
                    loading: loading,
                    results: tickets,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $0cd938f964be002d$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("th", {
                                    children: "Type"
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("th", {
                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $577f8f6fe7c41359$export$2e2bcd8739ae039), {
                                        title: "Ref",
                                        orderType: (0, $638a6323d534592c$export$2e2bcd8739ae039).Key,
                                        fetchSupportTickets: fetchSupportTickets
                                    })
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("th", {
                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $577f8f6fe7c41359$export$2e2bcd8739ae039), {
                                        title: "Summary",
                                        orderType: (0, $638a6323d534592c$export$2e2bcd8739ae039).Summary,
                                        fetchSupportTickets: fetchSupportTickets
                                    })
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("th", {
                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $577f8f6fe7c41359$export$2e2bcd8739ae039), {
                                        title: "Status",
                                        orderType: (0, $638a6323d534592c$export$2e2bcd8739ae039).Status,
                                        fetchSupportTickets: fetchSupportTickets
                                    })
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("th", {
                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $577f8f6fe7c41359$export$2e2bcd8739ae039), {
                                        title: "Requester",
                                        orderType: (0, $638a6323d534592c$export$2e2bcd8739ae039).Reporter,
                                        fetchSupportTickets: fetchSupportTickets
                                    })
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("th", {
                                    children: "Org."
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("th", {
                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $577f8f6fe7c41359$export$2e2bcd8739ae039), {
                                        title: "Created",
                                        orderType: (0, $638a6323d534592c$export$2e2bcd8739ae039).Created,
                                        fetchSupportTickets: fetchSupportTickets
                                    })
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("th", {
                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $577f8f6fe7c41359$export$2e2bcd8739ae039), {
                                        title: "Updated",
                                        orderType: (0, $638a6323d534592c$export$2e2bcd8739ae039).Updated,
                                        fetchSupportTickets: fetchSupportTickets
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $a282f935ed3e599f$export$2e2bcd8739ae039), {
                            children: !tickets || tickets.length === 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                    className: $f2b16bcfb478c50c$export$193b67f0c6231f98,
                                    children: "There are currently no support requests"
                                })
                            }) : tickets.map((ticket, index)=>{
                                return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $bae17111442efb5e$export$2e2bcd8739ae039), {
                                    ticket: ticket,
                                    handleModal: handleModal
                                }, ticket.issueName);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $2c14ce205c3a17ab$export$2e2bcd8739ae039 = $2c14ce205c3a17ab$var$SupportTable;




var $eYoAG = parcelRequire("eYoAG");

/**
 * Support
 * @function Support - Outer component for the support page
 */ const $c9944a36932f78bd$var$Support = ()=>{
    const { state: state } = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { selectedFilters: selectedFilters, pageSize: pageSize, totalTickets: totalTickets } = $ieT14.useContext((0, $9308be3dff04d2e5$export$21063b480a162460));
    const { loading: loading, tickets: tickets, fetchSupportTickets: fetchSupportTickets, fetchSupportInformation: fetchSupportInformation, orderColumn: orderColumn, orderDirection: orderDirection, allFilters: allFilters } = (0, $fb8741f1dceab0dd$export$2e2bcd8739ae039)();
    const { searchQuery: searchQuery, updateSearchQuery: updateSearchQuery, setIsSearching: setIsSearching } = (0, $b48f023b055940c4$export$2e2bcd8739ae039)();
    const [collapsed, setCollapsed] = $ieT14.useState(false);
    const announcementCount = +!!state.clientAnnouncement + +!!state.globalAnnouncement;
    const { measuredRef: measuredRef, dimensions: dimensions } = (0, $d9ed1b1da5a3379c$export$2e2bcd8739ae039)([
        tickets,
        announcementCount
    ], true);
    const [redirect, setRedirect] = $ieT14.useState(false);
    const areSupportFilters = !!Object.values(allFilters).find((filter)=>filter.length > 0);
    // Fetches the support information for the page on mount
    $ieT14.useEffect(()=>{
        fetchSupportInformation(state.clientId, {
            count: pageSize
        });
    }, []);
    if (redirect) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Redirect), {
        to: {
            pathname: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).AddRequest,
            state: {
                redirect: true,
                newPath: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Support
            }
        }
    });
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $f2b16bcfb478c50c$export$c5c64a3ebe462da4,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $f2b16bcfb478c50c$export$38e42c68cf43b5d4,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center'
                        },
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h1", {
                                children: "Support"
                            }),
                            allFilters.types.length > 0 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f5afe0f42548a953$export$2e2bcd8739ae039), {
                                text: "Add a Request",
                                title: "Add a Request",
                                handleClick: ()=>setRedirect(true)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $00cebbc6f72b4773$export$2e2bcd8739ae039), {
                        value: searchQuery,
                        updateValue: (val)=>updateSearchQuery(val),
                        setIsSearching: (searching)=>setIsSearching(searching),
                        placeholder: 'Search Support Requests',
                        submitHandler: ()=>fetchSupportTickets(state.clientId, {
                                ...selectedFilters,
                                orderColumn: orderColumn,
                                orderDirection: orderDirection,
                                count: pageSize,
                                searchTerm: searchQuery,
                                startAt: 0
                            })
                    })
                ]
            }),
            loading && tickets.length === 0 && !areSupportFilters ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $f2b16bcfb478c50c$export$c4b0f5819f6a6663,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
            }) : (!tickets || tickets.length === 0) && !areSupportFilters ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                children: "There are currently no support requests"
            }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $f2b16bcfb478c50c$export$f22da7240b7add18,
                ref: measuredRef,
                style: {
                    height: `calc(100vh - ${dimensions ? 20 + dimensions.top : 0}px`
                },
                children: [
                    loading && tickets.length > 0 || loading && tickets.length === 0 && areSupportFilters ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: $f2b16bcfb478c50c$export$c4b0f5819f6a6663,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
                    }) : null,
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        className: $f2b16bcfb478c50c$export$ad379ef99350a631,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                                className: $f2b16bcfb478c50c$export$3f6d243f5dbc1961,
                                children: [
                                    totalTickets,
                                    " results"
                                ]
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $944aae8422412095$export$2e2bcd8739ae039), {
                                initialCollapse: false,
                                collapsedClass: $f2b16bcfb478c50c$export$27c57cc52d388509,
                                sidebarClass: $f2b16bcfb478c50c$export$6fbb9cd2843e91b2,
                                iconClass: $f2b16bcfb478c50c$export$1ca1ec8b29a4ce27,
                                arrowOpenIcon: true,
                                onCollapseToggle: ()=>setCollapsed(!collapsed),
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $5688c19c618620f0$export$2e2bcd8739ae039), {
                                    collapsed: collapsed
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        className: $f2b16bcfb478c50c$export$342db1f7d8ce61ac,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $2c14ce205c3a17ab$export$2e2bcd8739ae039), {
                                loading: loading
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $b79abaa6f1ca53bf$export$2e2bcd8739ae039), {})
                        ]
                    })
                ]
            })
        ]
    });
};
var $c9944a36932f78bd$export$2e2bcd8739ae039 = $c9944a36932f78bd$var$Support;




var $ieT14 = parcelRequire("ieT14");


var $ekezX = parcelRequire("ekezX");



const $d5a2ff8534408d9a$var$useLogin = ()=>{
    const { postAuth: postAuth } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    /**
   * changePassword
   * @method changePassword - API call to change the password
   * @param id ID of the client
   * @param oldPassword Client's old password
   * @param newPassword Client's new password
   */ const changePassword = (userId, oldPassword, newPassword)=>{
        return postAuth('api/accounts/change-password', {
            userId: userId,
            oldPassword: oldPassword,
            newPassword: newPassword
        });
    };
    return {
        changePassword: changePassword
    };
};
var $d5a2ff8534408d9a$export$2e2bcd8739ae039 = $d5a2ff8534408d9a$var$useLogin;




var $eYoAG = parcelRequire("eYoAG");


parcelRequire("ieT14");


/**
 * @function FailureAnnouncement - Component for failure messages
 */ const $22c6044c9b4de7db$var$FailureAnnouncement = ({ message: message })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $1a687f1fe4770831$export$53f2c87d750bb57f,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4157cfae1f03f09f$exports))), {}),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                children: message
            })
        ]
    });
};
var $22c6044c9b4de7db$export$2e2bcd8739ae039 = $22c6044c9b4de7db$var$FailureAnnouncement;


/**
 * ChangePassword
 * @function ChangePassword - Component for the change password form
 */ const $51cefd552a774a55$var$ChangePassword = (props)=>{
    const [oldPassword, setOldPassword] = $ieT14.useState('');
    const [newPassword, setNewPassword] = $ieT14.useState('');
    const [confirmPassword, setConfirmPassword] = $ieT14.useState('');
    const [oldPasswordError, setOldPasswordError] = $ieT14.useState(false);
    const [newPasswordError, setNewPasswordError] = $ieT14.useState(false);
    const [confirmPasswordError, setConfirmPasswordError] = $ieT14.useState(false);
    const [resetSuccess, setResetSuccess] = $ieT14.useState(false);
    const [resetErrorMessage, setResetErrorMessage] = $ieT14.useState(null);
    const { changePassword: changePassword } = (0, $d5a2ff8534408d9a$export$2e2bcd8739ae039)();
    /** @const validPassword checks to see if the password is a valid password */ const validPassword = (0, $d3440ce222a0c87c$export$1cf356d314abea16)(newPassword);
    /** @const validConfirmPassword checks to see if the confirm password is a valid password */ const validConfirmPassword = (0, $d3440ce222a0c87c$export$1cf356d314abea16)(confirmPassword);
    /** @const passwordsMatch Confirms that the new password and the confirmed password match */ const passwordsMatch = confirmPassword === newPassword;
    /** @const disabled - Update Password button is disabled if passwords don't match and password doesn't meet minimum requirements */ const disabled = !(passwordsMatch && validPassword);
    /** @const clientId - The ID of the client who's password will be updated */ const clientId = props.match.params.clientId;
    /**
   * @function updatePassword Updates the password in the database
   */ const updatePassword = ()=>{
        changePassword(clientId, oldPassword, newPassword).then(()=>{
            setResetSuccess(true);
        }).catch((err)=>{
            setResetErrorMessage(err.responseJSON.message);
        });
    };
    /**
   * @function displayErrorMessage Displays an error message
   * @param password Password to check to display error message
   */ const displayErrorMessage = (password)=>{
        if (password === confirmPassword && confirmPassword !== newPassword) return 'Passwords do not match';
        else if (password.length === 0) return 'Please enter password';
        else if (password.length > 0 && password.length < 8) return 'Password must be at least 8 characters';
        else if (!(0, $d3440ce222a0c87c$export$e6c1bffe0c115f1a)(password)) return 'Password must contain at least 1 lowercase character';
        else if (!(0, $d3440ce222a0c87c$export$f659e651135ed98d)(password)) return 'Password must contain at least 1 uppercase character';
        else if (!(0, $d3440ce222a0c87c$export$b690537571bdb851)(password)) return 'Password must contain at least 1 digit';
        else if (!(0, $d3440ce222a0c87c$export$4f14893deafec3b7)(password)) return 'Must contain at least 1 special character (!, @, #, $, %, ^)';
        return '';
    };
    if (resetSuccess) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Redirect), {
        to: {
            pathname: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Login,
            state: {
                loginSuccessful: true
            }
        }
    });
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        children: [
            resetErrorMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $22c6044c9b4de7db$export$2e2bcd8739ae039), {
                message: resetErrorMessage
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $74982d8296291a36$export$56c2ba9e13461f38,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    className: $74982d8296291a36$export$c055de499085ef99,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($a522310ce80f7363$exports)))
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $db32c8adf65b4dff$export$2e2bcd8739ae039), {
                            error: oldPassword.length > 0 && !validPassword,
                            id: "outlined-old-password",
                            type: "password",
                            label: "Old Password",
                            margin: "normal",
                            variant: "outlined",
                            value: oldPassword,
                            onChange: (event)=>setOldPassword(event.target.value),
                            onBlur: ()=>setOldPasswordError(!validPassword)
                        }),
                        oldPasswordError && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                            className: $74982d8296291a36$export$493b5823483d2c4e,
                            children: displayErrorMessage(oldPassword)
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $db32c8adf65b4dff$export$2e2bcd8739ae039), {
                            error: newPassword.length > 0 && !validPassword || confirmPassword.length > 0 && (!validPassword || !passwordsMatch),
                            id: "outlined-password",
                            type: "password",
                            label: "New Password",
                            margin: "normal",
                            variant: "outlined",
                            value: newPassword,
                            onChange: (event)=>setNewPassword(event.target.value),
                            onBlur: ()=>setNewPasswordError(!validPassword)
                        }),
                        newPasswordError && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                            className: $74982d8296291a36$export$493b5823483d2c4e,
                            children: displayErrorMessage(newPassword)
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $db32c8adf65b4dff$export$2e2bcd8739ae039), {
                            error: confirmPassword.length > 0 && (!validPassword || !passwordsMatch),
                            id: "outlined-confirm",
                            type: "password",
                            label: "Confirm Password",
                            margin: "normal",
                            variant: "outlined",
                            value: confirmPassword,
                            onChange: (event)=>setConfirmPassword(event.target.value),
                            onBlur: ()=>setConfirmPasswordError(!validConfirmPassword)
                        }),
                        confirmPasswordError && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                            className: $74982d8296291a36$export$493b5823483d2c4e,
                            children: displayErrorMessage(confirmPassword)
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                            className: $74982d8296291a36$export$dc57ddd528b7443f,
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $ekezX.default), {
                                disabled: disabled,
                                variant: "contained",
                                color: "primary",
                                className: $74982d8296291a36$export$7abe78e1eda562aa,
                                classes: {
                                    disabled: $74982d8296291a36$export$a4c9bc12643ea157
                                },
                                onClick: ()=>updatePassword(),
                                children: "Change Password"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $51cefd552a774a55$export$2e2bcd8739ae039 = (0, $eYoAG.withRouter)($51cefd552a774a55$var$ChangePassword);






var $ieT14 = parcelRequire("ieT14");

const $dee37b87a49977d2$var$defaultState = {
    loading: false,
    results: [],
    currentPage: 1,
    totalResults: 0,
    pageSize: 60,
    orderColumn: (0, $fe0b3f9952d5826a$export$5468e3184eb0a928).Name,
    orderDirection: (0, $fe0b3f9952d5826a$export$5468e3184eb0a928).Ascending,
    searchTerm: null
};
/** Context for sharing user results to be displayed in a paginated form */ const $dee37b87a49977d2$export$f97ffeb8e877952b = /*#__PURE__*/ $ieT14.createContext(null);
const $dee37b87a49977d2$export$625c69ebc15b66c0 = $dee37b87a49977d2$export$f97ffeb8e877952b.Consumer;
const $dee37b87a49977d2$export$273547615d3e6fa4 = (props)=>{
    const [state, setState] = (0, $ieT14.useState)($dee37b87a49977d2$var$defaultState);
    const dispatch = (newValue)=>{
        setState((prevState)=>{
            return {
                ...prevState,
                ...newValue
            };
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($dee37b87a49977d2$export$f97ffeb8e877952b.Provider, {
        value: {
            ...state,
            dispatch: dispatch
        },
        children: props.children
    });
};




var $ieT14 = parcelRequire("ieT14");

var $fRnKy = parcelRequire("fRnKy");
var $c72a0ad140a240c4$export$b0377cbbbdab6cba;
var $c72a0ad140a240c4$export$f27f0a643498ce3d;
var $c72a0ad140a240c4$export$b00c055587dc7469;
var $c72a0ad140a240c4$export$b1a09d22b7ad6c4;
var $c72a0ad140a240c4$export$509f3108fdd206bb;
var $c72a0ad140a240c4$export$42ff741d2868ee32;
var $c72a0ad140a240c4$export$8c430709db82137d;
var $c72a0ad140a240c4$export$2d4b1211b4389c3b;
var $c72a0ad140a240c4$export$3832be13857745bc;
var $c72a0ad140a240c4$export$f4c68800b094ddb1;
var $c72a0ad140a240c4$export$3e34f1f019623f2a;
var $c72a0ad140a240c4$export$38351e8fef44a335;
var $c72a0ad140a240c4$export$38e42c68cf43b5d4;
var $c72a0ad140a240c4$export$9fd0c31a46174c9d;
var $c72a0ad140a240c4$export$46c1c92549715335;
var $c72a0ad140a240c4$export$d675b3969e4857cb;
var $c72a0ad140a240c4$export$4797d706c78651b3;
var $c72a0ad140a240c4$export$3a444357c5f65f65;
var $c72a0ad140a240c4$export$c49ee1c5fd99a6b;
var $c72a0ad140a240c4$export$25d28aa93b971148;
var $c72a0ad140a240c4$export$a5227367dfab8c1;
var $c72a0ad140a240c4$export$c4b0f5819f6a6663;
var $c72a0ad140a240c4$export$56e133125d8c837a;
var $c72a0ad140a240c4$export$742ce9193de81b6b;
$c72a0ad140a240c4$export$b0377cbbbdab6cba = "#006da8";
$c72a0ad140a240c4$export$f27f0a643498ce3d = "#00aafc";
$c72a0ad140a240c4$export$b00c055587dc7469 = "#f5dbd9";
$c72a0ad140a240c4$export$b1a09d22b7ad6c4 = "#c92100";
$c72a0ad140a240c4$export$509f3108fdd206bb = "#ebafa6";
$c72a0ad140a240c4$export$42ff741d2868ee32 = "#074f86";
$c72a0ad140a240c4$export$8c430709db82137d = "#dadada";
$c72a0ad140a240c4$export$2d4b1211b4389c3b = "#dddbda";
$c72a0ad140a240c4$export$3832be13857745bc = "#eae9ed";
$c72a0ad140a240c4$export$f4c68800b094ddb1 = "#e9e8f4";
$c72a0ad140a240c4$export$3e34f1f019623f2a = "addRequestPage_393f0b";
$c72a0ad140a240c4$export$38351e8fef44a335 = "requestContainer_393f0b";
$c72a0ad140a240c4$export$38e42c68cf43b5d4 = "header_393f0b";
$c72a0ad140a240c4$export$9fd0c31a46174c9d = "requestSection_393f0b";
$c72a0ad140a240c4$export$46c1c92549715335 = "loading_393f0b";
$c72a0ad140a240c4$export$d675b3969e4857cb = "submitButton_393f0b";
$c72a0ad140a240c4$export$4797d706c78651b3 = "filesSection_393f0b";
$c72a0ad140a240c4$export$3a444357c5f65f65 = "files_393f0b";
$c72a0ad140a240c4$export$c49ee1c5fd99a6b = "inputSection_393f0b";
$c72a0ad140a240c4$export$25d28aa93b971148 = "flexInputs_393f0b";
$c72a0ad140a240c4$export$a5227367dfab8c1 = "textfieldSection_393f0b";
$c72a0ad140a240c4$export$c4b0f5819f6a6663 = "circularProgress_393f0b";
$c72a0ad140a240c4$export$56e133125d8c837a = "supportArea_393f0b";
$c72a0ad140a240c4$export$742ce9193de81b6b = "supportInfo_393f0b";




var $3umuy = parcelRequire("3umuy");

var $eYoAG = parcelRequire("eYoAG");




parcelRequire("ieT14");

var $ekezX = parcelRequire("ekezX");
var $gXLwJ = parcelRequire("gXLwJ");


const $07d7e09497a42e25$var$materialTheme = (0, $gXLwJ.default)({
    // @ts-ignore
    overrides: {
        MuiButton: {
            root: {
                padding: 0,
                textTransform: 'inherit',
                '&$disabled': {
                    backgroundColor: '#dadada !important',
                    color: '#4f4f4f !important'
                },
                fontWeight: 400,
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 'normal',
                letterSpacing: 'normal',
                fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).heading
            },
            colorInherit: {
                color: '#ffffff',
                backgroundColor: '#00223c',
                '&:hover': {
                    backgroundColor: '#0073b9'
                },
                '&:focus': {
                    backgroundColor: '#00aafc',
                    color: '#000000'
                }
            }
        },
        MuiButtonBase: {
            root: {
                width: '100%',
                height: '100%',
                fontWeight: 400,
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 'normal',
                letterSpacing: 'normal',
                fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).heading
            }
        }
    }
});
const $07d7e09497a42e25$var$PrimaryButton = ({ text: text, title: title, deactive: deactive, styles: extraStyles, handleClick: handleClick })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $544e32820ad8eb30$export$2e2bcd8739ae039), {
        theme: $07d7e09497a42e25$var$materialTheme,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $ekezX.default), {
            type: "submit",
            title: title,
            onClick: (event)=>{
                event.preventDefault();
                handleClick();
            },
            variant: "contained",
            color: "inherit",
            disabled: deactive,
            style: extraStyles,
            children: text
        })
    });
};
var $07d7e09497a42e25$export$2e2bcd8739ae039 = $07d7e09497a42e25$var$PrimaryButton;





parcelRequire("ieT14");


var $gXLwJ = parcelRequire("gXLwJ");

var $aIJrd = parcelRequire("aIJrd");

const $6e8671488e9952df$var$materialTheme = (0, $gXLwJ.default)({
    overrides: {
        // @ts-ignore
        root: {
            width: 126
        },
        MuiPickersToolbar: {
            toolbar: {
                backgroundColor: '#1b7cbb'
            }
        },
        MuiPickersDay: {
            daySelected: {
                backgroundColor: `#1b7cbb`
            }
        },
        MuiButton: {
            textPrimary: {
                color: `#1b7cbb`
            }
        },
        MuiOutlinedInput: {
            root: {
                width: '100%',
                height: '100%',
                paddingBottom: 8,
                '&$focused $notchedOutline': {
                    borderColor: '#00AAFC'
                }
            },
            input: {
                fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).body,
                fontWeight: 300,
                letterSpacing: '0.3px',
                fontSize: 14,
                paddingLeft: 6
            },
            adornedEnd: {
                paddingRight: 6,
                paddingTop: 6
            }
        },
        MuiSvgIcon: {
            root: {
                fill: '#4f4f4f',
                width: 22,
                height: 22
            }
        },
        MuiIconButton: {
            root: {
                padding: 0
            }
        },
        MuiFormLabel: {
            root: {
                fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).heading,
                fontWeight: 300,
                color: '#4f4f4f !important',
                fontSize: 14,
                '&$focused': {
                    color: '#4f4f4f !important'
                }
            }
        }
    }
});
const $6e8671488e9952df$var$DatePicker = (0, $aIJrd.default)({
    root: {
        fontSize: '12px',
        height: 40,
        width: 126,
        marginBottom: 17,
        '& .MuiInputLabel-outlined': {
            transform: 'translate(8px, 14px) scale(1)',
            fontSize: 14
        },
        '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
            transform: 'translate(14px, -6px) scale(0.75) !important'
        }
    }
})((0, $d2c3211918dbdb4a$export$d8c44f501031ee7c));
const $6e8671488e9952df$var$FilterDatePicker = ({ date: date, label: label, changeDate: changeDate })=>{
    const handleChange = (date)=>{
        changeDate(date);
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $544e32820ad8eb30$export$2e2bcd8739ae039), {
        theme: $6e8671488e9952df$var$materialTheme,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($6e8671488e9952df$var$DatePicker, {
            autoOk: true,
            value: date,
            onChange: (date, value)=>handleChange(date),
            inputVariant: "outlined",
            format: "MM/DD/YYYY",
            emptyLabel: "__/__/____",
            label: label,
            invalidDateMessage: " ",
            minDateMessage: " ",
            maxDateMessage: " ",
            InputLabelProps: {
                shrink: true
            }
        })
    });
};
var $6e8671488e9952df$export$2e2bcd8739ae039 = $6e8671488e9952df$var$FilterDatePicker;



parcelRequire("ieT14");

var $gXLwJ = parcelRequire("gXLwJ");
var $whS22 = parcelRequire("whS22");
var $knRao = parcelRequire("knRao");
var $f3VQ2 = parcelRequire("f3VQ2");
var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");


var $ak9X1 = parcelRequire("ak9X1");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var /**
 * @ignore - internal component.
 */ $0fac627329354bd3$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');



var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var /**
 * @ignore - internal component.
 */ $0d332d397449ac05$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');



var $aIJrd = parcelRequire("aIJrd");
var $b9349c53f47bfd99$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        root: {
            position: 'relative',
            display: 'flex',
            '&$checked $layer': {
                transform: 'scale(1)',
                transition: theme.transitions.create('transform', {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.shortest
                })
            }
        },
        layer: {
            left: 0,
            position: 'absolute',
            transform: 'scale(0)',
            transition: theme.transitions.create('transform', {
                easing: theme.transitions.easing.easeIn,
                duration: theme.transitions.duration.shortest
            })
        },
        checked: {}
    };
};
/**
 * @ignore - internal component.
 */ function $b9349c53f47bfd99$var$RadioButtonIcon(props) {
    var checked = props.checked, classes = props.classes, fontSize = props.fontSize;
    return /*#__PURE__*/ $ieT14.createElement("div", {
        className: (0, $j6s32.default)(classes.root, checked && classes.checked)
    }, /*#__PURE__*/ $ieT14.createElement((0, $0fac627329354bd3$export$2e2bcd8739ae039), {
        fontSize: fontSize
    }), /*#__PURE__*/ $ieT14.createElement((0, $0d332d397449ac05$export$2e2bcd8739ae039), {
        fontSize: fontSize,
        className: classes.layer
    }));
}
var $b9349c53f47bfd99$export$2e2bcd8739ae039 = (0, $aIJrd.default)($b9349c53f47bfd99$export$9dd6ff9ea0189349, {
    name: 'PrivateRadioButtonIcon'
})($b9349c53f47bfd99$var$RadioButtonIcon);



var $86m3e = parcelRequire("86m3e");

var $2EBFt = parcelRequire("2EBFt");

var $biB4f = parcelRequire("biB4f");

var $aIJrd = parcelRequire("aIJrd");

var $ieT14 = parcelRequire("ieT14");

var $ieT14 = parcelRequire("ieT14");
/**
 * @ignore - internal component.
 */ var $1cd3fcc60f51d299$var$RadioGroupContext = $ieT14.createContext();
var $1cd3fcc60f51d299$export$2e2bcd8739ae039 = $1cd3fcc60f51d299$var$RadioGroupContext;


function $8124aafefb77b8e9$export$2e2bcd8739ae039() {
    return $ieT14.useContext((0, $1cd3fcc60f51d299$export$2e2bcd8739ae039));
}


var $141807cd97d66e4d$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            color: theme.palette.text.secondary
        },
        /* Pseudo-class applied to the root element if `checked={true}`. */ checked: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            '&$checked': {
                color: theme.palette.primary.main,
                '&:hover': {
                    backgroundColor: (0, $86m3e.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            '&$disabled': {
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            '&$checked': {
                color: theme.palette.secondary.main,
                '&:hover': {
                    backgroundColor: (0, $86m3e.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            '&$disabled': {
                color: theme.palette.action.disabled
            }
        }
    };
};
var $141807cd97d66e4d$var$defaultCheckedIcon = /*#__PURE__*/ $ieT14.createElement((0, $b9349c53f47bfd99$export$2e2bcd8739ae039), {
    checked: true
});
var $141807cd97d66e4d$var$defaultIcon = /*#__PURE__*/ $ieT14.createElement((0, $b9349c53f47bfd99$export$2e2bcd8739ae039), null);
var $141807cd97d66e4d$var$Radio = /*#__PURE__*/ $ieT14.forwardRef(function Radio(props, ref) {
    var checkedProp = props.checked, classes = props.classes, _props$color = props.color, color = _props$color === void 0 ? 'secondary' : _props$color, nameProp = props.name, onChangeProp = props.onChange, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, other = (0, $eTwGP.default)(props, [
        "checked",
        "classes",
        "color",
        "name",
        "onChange",
        "size"
    ]);
    var radioGroup = (0, $8124aafefb77b8e9$export$2e2bcd8739ae039)();
    var checked = checkedProp;
    var onChange = (0, $biB4f.default)(onChangeProp, radioGroup && radioGroup.onChange);
    var name = nameProp;
    if (radioGroup) {
        if (typeof checked === 'undefined') checked = radioGroup.value === props.value;
        if (typeof name === 'undefined') name = radioGroup.name;
    }
    return /*#__PURE__*/ $ieT14.createElement((0, $ak9X1.default), (0, $edxsd.default)({
        color: color,
        type: "radio",
        icon: /*#__PURE__*/ $ieT14.cloneElement($141807cd97d66e4d$var$defaultIcon, {
            fontSize: size === 'small' ? 'small' : 'medium'
        }),
        checkedIcon: /*#__PURE__*/ $ieT14.cloneElement($141807cd97d66e4d$var$defaultCheckedIcon, {
            fontSize: size === 'small' ? 'small' : 'medium'
        }),
        classes: {
            root: (0, $j6s32.default)(classes.root, classes["color".concat((0, $2EBFt.default)(color))]),
            checked: classes.checked,
            disabled: classes.disabled
        },
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref
    }, other));
});
var $141807cd97d66e4d$export$2e2bcd8739ae039 = (0, $aIJrd.default)($141807cd97d66e4d$export$9dd6ff9ea0189349, {
    name: 'MuiRadio'
})($141807cd97d66e4d$var$Radio);


var $edxsd = parcelRequire("edxsd");

var $dcIvM = parcelRequire("dcIvM");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $3WBJn = parcelRequire("3WBJn");

var $3A1Xf = parcelRequire("3A1Xf");

var $kuovH = parcelRequire("kuovH");


var $BEV8A = parcelRequire("BEV8A");
var $62bbd6cebee2ba4a$var$RadioGroup = /*#__PURE__*/ $ieT14.forwardRef(function RadioGroup(props, ref) {
    var actions = props.actions, children = props.children, nameProp = props.name, valueProp = props.value, onChange = props.onChange, other = (0, $eTwGP.default)(props, [
        "actions",
        "children",
        "name",
        "value",
        "onChange"
    ]);
    var rootRef = $ieT14.useRef(null);
    var _useControlled = (0, $kuovH.default)({
        controlled: valueProp,
        default: props.defaultValue,
        name: 'RadioGroup'
    }), _useControlled2 = (0, $dcIvM.default)(_useControlled, 2), value = _useControlled2[0], setValue = _useControlled2[1];
    $ieT14.useImperativeHandle(actions, function() {
        return {
            focus: function focus() {
                var input = rootRef.current.querySelector('input:not(:disabled):checked');
                if (!input) input = rootRef.current.querySelector('input:not(:disabled)');
                if (input) input.focus();
            }
        };
    }, []);
    var handleRef = (0, $3A1Xf.default)(ref, rootRef);
    var handleChange = function handleChange(event) {
        setValue(event.target.value);
        if (onChange) onChange(event, event.target.value);
    };
    var name = (0, $BEV8A.default)(nameProp);
    return /*#__PURE__*/ $ieT14.createElement((0, $1cd3fcc60f51d299$export$2e2bcd8739ae039).Provider, {
        value: {
            name: name,
            onChange: handleChange,
            value: value
        }
    }, /*#__PURE__*/ $ieT14.createElement((0, $3WBJn.default), (0, $edxsd.default)({
        role: "radiogroup",
        ref: handleRef
    }, other), children));
});
var $62bbd6cebee2ba4a$export$2e2bcd8739ae039 = $62bbd6cebee2ba4a$var$RadioGroup;



var $aIJrd = parcelRequire("aIJrd");

const $eaaefced8e9d52f7$var$materialTheme = (0, $gXLwJ.default)({
    overrides: {
        // @ts-ignore
        MuiFormControlLabel: {
            label: {
                fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).body,
                fontWeight: 300,
                fontSize: 14,
                letterSpacing: '0.3px',
                color: '#000000'
            }
        },
        MuiFormLabel: {
            root: {
                fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).heading,
                fontWeight: 300,
                color: '#4f4f4f !important',
                fontSize: 11
            }
        },
        MuiRadio: {
            colorSecondary: {
                color: '#d1cece',
                '&$checked': {
                    color: '#006da8',
                    '&:hover': {
                        backgroundColor: 'transparent'
                    }
                }
            }
        },
        MuiSvgIcon: {
            root: {
                width: 20,
                height: 20,
                '&:hover': {
                    fill: '#006da8 !important'
                }
            }
        }
    }
});
const $eaaefced8e9d52f7$var$StyledRadioForm = (0, $aIJrd.default)({
    root: {
        '& .MuiRadio-colorSecondary.Mui-checked ': {
            color: '#006da8'
        },
        '& .MuiIconButton-colorSecondary:hover': {
            backgroundColor: 'transparent',
            '& svg': {
                '& path': {
                    fill: '#00aafc !important'
                }
            }
        },
        '& .MuiIconButton-colorSecondary.Mui-disabled': {
            backgroundColor: 'transparent',
            '& svg': {
                backgroundColor: '#8a8a8a',
                borderRadius: 10,
                width: 16,
                height: 16,
                margin: 2,
                '& path': {
                    fill: '#8a8a8a'
                }
            }
        }
    }
})((0, $whS22.default));
const $eaaefced8e9d52f7$var$RadioForm = ({ values: values, options: options, title: title, selectedValue: selectedValue, handleChange: handleChange })=>{
    const renderRadioButtons = ()=>{
        return values.map((item, index)=>{
            return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $knRao.default), {
                value: item.value,
                control: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $141807cd97d66e4d$export$2e2bcd8739ae039), {}),
                label: options[index],
                disabled: item.disabled
            }, `radio-${index}`);
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $544e32820ad8eb30$export$2e2bcd8739ae039), {
        theme: $eaaefced8e9d52f7$var$materialTheme,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($eaaefced8e9d52f7$var$StyledRadioForm, {
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f3VQ2.default), {
                    component: "legend",
                    children: title
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $62bbd6cebee2ba4a$export$2e2bcd8739ae039), {
                    defaultValue: selectedValue,
                    onChange: (event)=>handleChange(event.target.value),
                    children: renderRadioButtons()
                })
            ]
        })
    });
};
var $eaaefced8e9d52f7$export$2e2bcd8739ae039 = $eaaefced8e9d52f7$var$RadioForm;



parcelRequire("ieT14");


var $whS22 = parcelRequire("whS22");
var $Uxz4Y = parcelRequire("Uxz4Y");
var $bPjUl = parcelRequire("bPjUl");
var $3mOXj = parcelRequire("3mOXj");
var $d6SUv = parcelRequire("d6SUv");
var $aanJt = parcelRequire("aanJt");

var $aIJrd = parcelRequire("aIJrd");


const $ee9b4e5ae8c605cb$var$StyledFormControl = (0, $aIJrd.default)((theme)=>({
        root: {
            width: '100%',
            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#00AAFC'
            },
            '& .MuiOutlinedInput-input': {
                paddingTop: 0,
                paddingBottom: 0
            },
            '& .MuiOutlinedInput-root': {
                height: 40
            },
            '& .MuiInputLabel-outlined': {
                transform: 'translate(14px, 13px) scale(1)'
            },
            '& .MuiTypography-body1': {
                fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).body,
                fontWeight: 200,
                fontSize: 14,
                letterSpacing: '0.2px',
                color: '#000000'
            },
            '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
                fontSize: 11,
                backgroundColor: 'white',
                transform: 'translate(14px, -6px) scale(1) !important'
            },
            '& .MuiSelect-select:focus': {
                backgroundColor: 'white'
            }
        }
    }))((0, $whS22.default));
const $ee9b4e5ae8c605cb$var$StyledMenuItem = (0, $aIJrd.default)((theme)=>({
        root: {
            '& .MuiTypography-body1': {
                fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).body,
                fontWeight: 200,
                fontSize: 14,
                letterSpacing: '0.2px',
                color: '#000000'
            },
            '& .MuiListItem-button:hover': {
                backgroundColor: '#eaf3f8'
            },
            '& .MuiTypograph': {
                body1: {
                    color: 'black !important',
                    fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).body,
                    fontWeight: 200,
                    fontSize: 14,
                    letterSpacing: '0.2px'
                }
            },
            '.MuiButtonBase-root.Mui-disabled': {
                fontWeight: '600 !important',
                color: 'black !important'
            }
        },
        selected: {
            backgroundColor: '#eaf3f8 !important',
            color: 'black'
        }
    }))((0, $3mOXj.default));
const $ee9b4e5ae8c605cb$var$OutlinedDropdown = ({ values: values, selectedValue: selectedValue, title: title, handleChange: handleClick })=>{
    const { measuredRef: measuredRef, dimensions: dimensions } = (0, $d9ed1b1da5a3379c$export$2e2bcd8739ae039)([]);
    const renderMenuItems = ()=>{
        const valuesCopy = [
            ...values
        ];
        let formattedValues = [];
        valuesCopy.forEach((val)=>{
            if (!formattedValues.find((item)=>val.group && item.name === val.group.name)) val.group && formattedValues.push(val.group);
            val && formattedValues.push(val);
        });
        let updatedOptions = formattedValues.map((item)=>item.text || item.name);
        return formattedValues.map((item, index)=>{
            return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($ee9b4e5ae8c605cb$var$StyledMenuItem, {
                disabled: !!item.name,
                value: item.value,
                selected: selectedValue === item,
                classes: {
                    root: !!item.name ? $fdbf0d9f77db804d$export$3a0ab88f0478b50d : ''
                },
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $bPjUl.default), {
                    primary: updatedOptions[index]
                })
            }, `menu-item-${index}`);
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ee9b4e5ae8c605cb$var$StyledFormControl, {
        variant: "outlined",
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $Uxz4Y.default), {
                shrink: true,
                ref: measuredRef,
                htmlFor: "outlined-input",
                children: title
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $aanJt.default), {
                value: selectedValue !== null ? selectedValue : '',
                onChange: (item)=>handleClick(item.target.value),
                labelWidth: dimensions ? dimensions.width + 5 : 0,
                input: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $d6SUv.default), {
                    notched: true,
                    labelWidth: dimensions ? dimensions.width + 10 : 0,
                    id: "outlined-input"
                }),
                children: renderMenuItems()
            })
        ]
    });
};
var $ee9b4e5ae8c605cb$export$2e2bcd8739ae039 = $ee9b4e5ae8c605cb$var$OutlinedDropdown;




var $ieT14 = parcelRequire("ieT14");

var $lamW6 = parcelRequire("lamW6");
var $f7wB2 = parcelRequire("f7wB2");
var $gXLwJ = parcelRequire("gXLwJ");
var $whS22 = parcelRequire("whS22");
var $Uxz4Y = parcelRequire("Uxz4Y");
var $3mOXj = parcelRequire("3mOXj");
var $d6SUv = parcelRequire("d6SUv");
var $aanJt = parcelRequire("aanJt");





const $b423db00e45e1f69$var$materialTheme = (0, $gXLwJ.default)({
    overrides: {
        // @ts-ignore
        MuiFormControl: {
            root: {
                width: 290,
                minHeight: 40,
                height: 'min-content'
            }
        },
        MuiMenuItem: {
            root: {
                fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).body,
                fontSize: 14,
                letterSpacing: '0.3px',
                color: 'black',
                fontWeight: 300
            }
        },
        MuiChip: {
            root: {
                backgroundColor: '#1987b4',
                height: 25,
                color: 'white',
                marginRight: 6,
                marginBottom: 5
            }
        },
        MuiSelect: {
            selectMenu: {
                whiteSpace: 'inherit',
                maxHeight: 90,
                paddingBottom: 0,
                overflow: 'auto',
                minHeight: 26
            },
            select: {
                '&:focus': {
                    backgroundColor: 'white'
                }
            }
        },
        MuiFormLabel: {
            root: {
                fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).body,
                fontSize: 11,
                letterSpacing: 'normal',
                color: '#4f4f4f !important',
                fontWeight: 300
            }
        },
        MuiOutlinedInput: {
            root: {
                width: '100%',
                height: '100%',
                paddingBottom: 8,
                '&$focused $notchedOutline': {
                    borderColor: '#00AAFC'
                }
            },
            input: {
                height: '100% important'
            }
        },
        MuiInputLabel: {
            outlined: {
                fontSize: 14,
                backgroundColor: 'white'
            }
        },
        MuiListItem: {
            gutters: {
                paddingLeft: 10
            }
        }
    }
});
const $b423db00e45e1f69$var$MultiSelectMenu = /*#__PURE__*/ $ieT14.memo(({ label: label, values: values, options: options, selectedValues: selectedValues, handleChange: handleChange })=>{
    const { measuredRef: measuredRef, dimensions: dimensions } = (0, $d9ed1b1da5a3379c$export$2e2bcd8739ae039)([]);
    const renderMenuItems = ()=>{
        return values.map((item, index)=>{
            const isChecked = !!selectedValues.find((checked)=>checked.value === item.value);
            return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $3mOXj.default), {
                value: item,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $lamW6.default), {
                        checked: isChecked,
                        classes: {
                            root: isChecked ? $fdbf0d9f77db804d$export$f77685c252cbae87 : $fdbf0d9f77db804d$export$b07e517d22efa1ca
                        }
                    }),
                    ' ',
                    options[index]
                ]
            }, index);
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $544e32820ad8eb30$export$2e2bcd8739ae039), {
        theme: $b423db00e45e1f69$var$materialTheme,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
            variant: "outlined",
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $Uxz4Y.default), {
                    ref: measuredRef,
                    shrink: true,
                    htmlFor: "select-multiple-chip",
                    children: label
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $aanJt.default), {
                    multiple: true,
                    value: selectedValues,
                    onChange: (event)=>{
                        handleChange(event.target.value);
                    },
                    input: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $d6SUv.default), {
                        notched: true,
                        labelWidth: dimensions ? dimensions.width + 20 : 0,
                        id: "select-multiple-chip"
                    }),
                    renderValue: (selected)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5d10f0a7aadd7c8c$exports))), {
                            autoHide: true,
                            universal: true,
                            style: {
                                minHeight: '26px'
                            },
                            children: selected.map((value, index)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f7wB2.default), {
                                    label: value.text
                                }, index))
                        }),
                    children: renderMenuItems()
                })
            ]
        })
    });
}, (prevProps, nextProps)=>{
    if (prevProps.selectedValues.length === nextProps.selectedValues.length) return false;
});
var $b423db00e45e1f69$export$2e2bcd8739ae039 = $b423db00e45e1f69$var$MultiSelectMenu;



var $fpdl2 = parcelRequire("fpdl2");

parcelRequire("ieT14");
var $54e71f1fe288f634$exports = {};
"use strict";


Object.defineProperty($54e71f1fe288f634$exports, "__esModule", {
    value: true
});
$54e71f1fe288f634$exports.default = void 0;

var $54e71f1fe288f634$var$React = $633c7dc13d665c5e$exports((parcelRequire("ieT14")));

var $54e71f1fe288f634$var$_createSvgIcon = $b24015bb0dc2bec9$exports((parcelRequire("3yIjW")));
var $54e71f1fe288f634$var$_default = (0, $54e71f1fe288f634$var$_createSvgIcon.default)(/*#__PURE__*/ $54e71f1fe288f634$var$React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckCircle');
$54e71f1fe288f634$exports.default = $54e71f1fe288f634$var$_default;



/**
 * @function PriorityTwoSuccess - Component for success messages
 */ const $00b96652cf9f9fb7$var$PriorityTwoSuccess = ({ message: message })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $1a687f1fe4770831$export$3ed881773c003eaf,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($54e71f1fe288f634$exports))), {}),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                children: message
            })
        ]
    });
};
var $00b96652cf9f9fb7$export$2e2bcd8739ae039 = $00b96652cf9f9fb7$var$PriorityTwoSuccess;






parcelRequire("ieT14");



const $caf372f84efbe689$var$ConfirmationDialog = ({ title: title, message: message, confirmAction: confirmAction, cancelAction: cancelAction })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $fdbf0d9f77db804d$export$f45508d19dce717b,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: `${$fdbf0d9f77db804d$export$9bb6a6f2774dc082}`,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h1", {
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        className: "body2",
                        children: message
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $fdbf0d9f77db804d$export$fe3d81a6d0bd342f,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: $fdbf0d9f77db804d$export$dc57ddd528b7443f,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f5afe0f42548a953$export$2e2bcd8739ae039), {
                            text: "Yes",
                            title: "Yes",
                            handleClick: ()=>confirmAction()
                        })
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: $fdbf0d9f77db804d$export$dc57ddd528b7443f,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fcd3b8c5e9a7038b$export$2e2bcd8739ae039), {
                            text: "No",
                            title: "No",
                            handleClick: ()=>{
                                cancelAction();
                            }
                        })
                    })
                ]
            })
        ]
    });
};
var $caf372f84efbe689$export$2e2bcd8739ae039 = $caf372f84efbe689$var$ConfirmationDialog;



const $fc283ee35e620e7c$var$RequestDetails = ({ history: history })=>{
    const { allFilters: allFilters } = $ieT14.useContext((0, $9308be3dff04d2e5$export$21063b480a162460));
    if (allFilters.types.length < 1) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Redirect), {
        to: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Support
    });
    const [ticketType, setTicketType] = $ieT14.useState(0);
    const [values, setValues] = $ieT14.useState($fRnKy.cloneDeep(allFilters.types[0].fields));
    const { addSupportTicket: addSupportTicket } = (0, $fb8741f1dceab0dd$export$2e2bcd8739ae039)();
    const [loading, setLoading] = $ieT14.useState(false);
    const [requestSuccessful, setRequestSuccessful] = $ieT14.useState(null);
    const [requestResponse, setRequestResponse] = $ieT14.useState(null);
    const appContext = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const [displayDirtyWarning, setDisplayDirtyWarning] = $ieT14.useState(false);
    const [confirmedNavigation, setConfirmedNavigation] = $ieT14.useState(false);
    const [blockedLocation, setBlockedLocation] = $ieT14.useState('');
    const unblock = (0, $ieT14.useRef)(null);
    const isDirty = ()=>{
        //Get data
        const typeCopy = $fRnKy.cloneDeep(allFilters.types[ticketType]);
        typeCopy.fields = $fRnKy.cloneDeep(values);
        typeCopy.fields.map((item)=>{
            if (item.values && item.id !== 'attachment') {
                const stringValues = item.values.map((val)=>val.value || val);
                item.values = stringValues;
            }
            return item;
        });
        const data = {
            requestTypeId: typeCopy.value,
            requestTypes: [
                typeCopy
            ],
            serviceDeskOrganizationId: '4'
        };
        //Request type changed from the default 1 or a field is no longer null
        if (data.requestTypeId !== '1' || !$fRnKy.every(data.requestTypes[0].fields, {
            value: null
        })) return true;
        else return false;
    };
    $ieT14.useEffect(()=>{
        unblock.current = history.block((location)=>{
            if (isDirty() && !requestSuccessful) {
                setDisplayDirtyWarning(true);
                setBlockedLocation(location.pathname);
                return false;
            } else unblock.current();
        });
    }, [
        requestSuccessful
    ]);
    $ieT14.useEffect(()=>{
        if (confirmedNavigation) {
            unblock.current();
            history.push(blockedLocation);
        }
    }, [
        confirmedNavigation
    ]);
    const handleCancel = (dirty)=>{
        if (!dirty) unblock.current();
        history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Support);
    };
    const handleSubmit = (event)=>{
        event && event.preventDefault();
        event && event.persistData();
        const typeCopy = $fRnKy.cloneDeep(allFilters.types[ticketType]);
        typeCopy.fields = values;
        typeCopy.fields.map((item)=>{
            if (item.values && item.id !== 'attachment') {
                const stringValues = item.values.map((val)=>val.value || val);
                item.values = stringValues;
            }
            return item;
        });
        const data = {
            requestTypeId: typeCopy.value,
            requestTypes: [
                typeCopy
            ],
            serviceDeskOrganizationId: '4'
        };
        setLoading(true);
        addSupportTicket(appContext.state.clientId, data).then((ticket)=>{
            setLoading(false);
            setRequestResponse(ticket);
            setRequestSuccessful(true);
            setDisplayDirtyWarning(false);
        }).catch(()=>{
            setRequestSuccessful(false);
            setLoading(false);
        });
    };
    const renderTypes = ()=>{
        return allFilters.types[ticketType].fields.map((field, index)=>{
            switch(field.type){
                case 'string':
                    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        style: {
                            height: 98,
                            width: 600
                        },
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6488f33c63e4bc0e$export$2e2bcd8739ae039), {
                            value: values[index].value ? values[index].value : '',
                            label: field.name,
                            multiline: true,
                            variant: "outlined",
                            required: field.required,
                            error: field.required && !values[index].value && values[index].touched,
                            onChange: (event)=>{
                                event.persist();
                                setValues((arr)=>{
                                    const newArray = [
                                        ...arr
                                    ];
                                    newArray[index].value = event.target.value;
                                    newArray[index].touched = true;
                                    return newArray;
                                });
                            }
                        }, `field-${index}`)
                    });
                case 'date':
                    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6e8671488e9952df$export$2e2bcd8739ae039), {
                        date: values[index].value ? values[index].value : null,
                        label: field.name,
                        changeDate: (newDate)=>{
                            setValues((arr)=>{
                                const newArray = [
                                    ...arr
                                ];
                                newArray[index].value = !newDate ? null : (0, (/*@__PURE__*/$parcel$interopDefault($3umuy)))(newDate).format('YYYY-MM-DD');
                                return newArray;
                            });
                        }
                    }, `field-${index}`);
                case 'priority':
                case 'option':
                    if (field.validValues.length <= 4) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eaaefced8e9d52f7$export$2e2bcd8739ae039), {
                        values: field.validValues,
                        options: field.validValues.map((item)=>item.text),
                        title: field.name,
                        selectedValue: values[index].value,
                        handleChange: (val)=>{
                            setValues((arr)=>{
                                const newArray = [
                                    ...arr
                                ];
                                newArray[index].value = val;
                                return newArray;
                            });
                        }
                    }, `field-${index}`);
                    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        style: {
                            width: 290,
                            height: 40
                        },
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $ee9b4e5ae8c605cb$export$2e2bcd8739ae039), {
                            values: field.validValues,
                            title: field.name,
                            selectedValue: values[index].value,
                            handleChange: (val)=>{
                                setValues((arr)=>{
                                    const newArray = [
                                        ...arr
                                    ];
                                    newArray[index].value = val;
                                    return newArray;
                                });
                            }
                        })
                    }, `field-${index}`);
                case 'array':
                    if (field.id === 'attachment') return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        style: {
                            display: 'none'
                        }
                    }, `field-${index}`);
                    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $b423db00e45e1f69$export$2e2bcd8739ae039), {
                        label: field.name,
                        values: field.validValues,
                        options: field.validValues.map((item)=>item.text),
                        selectedValues: values[index].values || [],
                        handleChange: (val)=>{
                            setValues((arr)=>{
                                const newArray = [
                                    ...arr
                                ];
                                newArray[index].values = val;
                                return newArray;
                            });
                        }
                    }, `field-${index}`);
                case 'option-with-child':
                    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        style: {
                            width: 290,
                            height: 40
                        },
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $ee9b4e5ae8c605cb$export$2e2bcd8739ae039), {
                            values: field.validValues,
                            title: field.name,
                            selectedValue: values[index].value,
                            handleChange: (val)=>{
                                setValues((arr)=>{
                                    const newArray = [
                                        ...arr
                                    ];
                                    newArray[index].value = val;
                                    return newArray;
                                });
                            }
                        })
                    }, `field-${index}`);
            }
        });
    };
    const renderAfterSubmit = ()=>{
        return values.map((field, index)=>{
            const selectValidValue = ()=>{
                switch(field.type){
                    case 'string':
                    case 'date':
                        return field.value;
                    case 'priority':
                    case 'option-with-child':
                    case 'option':
                        const text = field.validValues.filter((val)=>val.value === field.value)[0].text;
                        return text;
                    case 'array':
                        const values = field.values.map((val)=>{
                            return field.validValues.find((item)=>item.value === val).text;
                        });
                        return values.join(', ');
                }
            };
            if (field.value) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8b308bea4c0aef38$export$2e2bcd8739ae039), {
                label: field.name,
                value: selectValidValue(),
                disabled: true,
                multiline: true
            }, index);
            else if (field.values && field.values.length > 0) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8b308bea4c0aef38$export$2e2bcd8739ae039), {
                label: field.name,
                value: selectValidValue(),
                disabled: true,
                multiline: true
            }, index);
            return null;
        });
    };
    const renderTypeOptions = ()=>{
        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8b308bea4c0aef38$export$2e2bcd8739ae039), {
            label: "What can we help you with?",
            value: allFilters.types[ticketType].text,
            disabled: true
        });
    };
    const isSubmitDisabled = values.map((val)=>{
        if (val.required && !val.value || val.type === 'date' && val.value === 'Invalid date' && !(0, (/*@__PURE__*/$parcel$interopDefault($3umuy)))(val.value).isValid()) return true;
        return false;
    }).filter((val)=>val).length > 0;
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $c72a0ad140a240c4$export$3e34f1f019623f2a,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $9a2902e239ac61e9$export$2e2bcd8739ae039), {
                open: isDirty() && displayDirtyWarning,
                closeModal: ()=>{},
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $caf372f84efbe689$export$2e2bcd8739ae039), {
                    title: "Confirmation",
                    message: "You have unsaved changes. Are you sure you would like to leave?",
                    confirmAction: ()=>{
                        setConfirmedNavigation(true);
                        history.push(blockedLocation);
                    },
                    cancelAction: ()=>{
                        setDisplayDirtyWarning(false);
                    }
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $c72a0ad140a240c4$export$38351e8fef44a335,
                children: [
                    requestSuccessful && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        style: {
                            width: '97%'
                        },
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $00b96652cf9f9fb7$export$2e2bcd8739ae039), {
                            message: `Support Request Submitted. Your reference is ${requestResponse.issueName}.`
                        })
                    }),
                    requestSuccessful === false && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        style: {
                            width: '97%'
                        },
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $cd9e5d573af72510$export$2e2bcd8739ae039), {
                            message: "Unable to add support ticket. Please try again or contact your system administrator."
                        })
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: $c72a0ad140a240c4$export$38e42c68cf43b5d4,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h5", {
                            children: " Submit a Request"
                        })
                    }),
                    loading && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: $c72a0ad140a240c4$export$c4b0f5819f6a6663,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("form", {
                        className: loading ? $c72a0ad140a240c4$export$46c1c92549715335 : $c72a0ad140a240c4$export$9fd0c31a46174c9d,
                        onSubmit: (event)=>handleSubmit(event),
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                style: {
                                    width: 290,
                                    height: 40
                                },
                                children: requestSuccessful ? renderTypeOptions() : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $ee9b4e5ae8c605cb$export$2e2bcd8739ae039), {
                                    values: allFilters.types,
                                    title: "What can we help you with?",
                                    selectedValue: allFilters.types[ticketType].value,
                                    handleChange: (val)=>{
                                        const newIndex = allFilters.types.findIndex((item)=>val === item.value);
                                        setTicketType(newIndex);
                                        setValues($fRnKy.cloneDeep(allFilters.types[newIndex].fields));
                                    }
                                })
                            }),
                            requestSuccessful ? renderAfterSubmit() : renderTypes(),
                            requestSuccessful !== true && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                className: $fdbf0d9f77db804d$export$135180a04c5d6085,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fcd3b8c5e9a7038b$export$2e2bcd8739ae039), {
                                        text: "Cancel",
                                        title: "Cancel",
                                        handleClick: ()=>{
                                            handleCancel(isDirty());
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                        className: $fdbf0d9f77db804d$export$d675b3969e4857cb,
                                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $07d7e09497a42e25$export$2e2bcd8739ae039), {
                                            text: "Submit",
                                            title: "Submit",
                                            deactive: isSubmitDisabled,
                                            handleClick: (event)=>handleSubmit(event)
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $c72a0ad140a240c4$export$56e133125d8c837a,
                children: requestSuccessful !== true && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    className: $c72a0ad140a240c4$export$742ce9193de81b6b,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h2", {
                            children: "Prefer to send a request by Email?"
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h3", {
                            children: "Contact Customer Service"
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("a", {
                            href: 'mailto:' + appContext.state.supportEmail,
                            target: "_blank",
                            children: [
                                "Email: ",
                                appContext.state.supportEmail
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $fc283ee35e620e7c$export$2e2bcd8739ae039 = (0, $eYoAG.withRouter)($fc283ee35e620e7c$var$RequestDetails);




var $ieT14 = parcelRequire("ieT14");


var $ieT14 = parcelRequire("ieT14");

var $8FQwk = parcelRequire("8FQwk");

var $e1ONw = parcelRequire("e1ONw");

var $77e47b6bc9169ce7$export$b0377cbbbdab6cba;
var $77e47b6bc9169ce7$export$f27f0a643498ce3d;
var $77e47b6bc9169ce7$export$b00c055587dc7469;
var $77e47b6bc9169ce7$export$b1a09d22b7ad6c4;
var $77e47b6bc9169ce7$export$509f3108fdd206bb;
var $77e47b6bc9169ce7$export$42ff741d2868ee32;
var $77e47b6bc9169ce7$export$8c430709db82137d;
var $77e47b6bc9169ce7$export$2d4b1211b4389c3b;
var $77e47b6bc9169ce7$export$3832be13857745bc;
var $77e47b6bc9169ce7$export$f4c68800b094ddb1;
var $77e47b6bc9169ce7$export$cc74dcc53cfce4eb;
var $77e47b6bc9169ce7$export$b1e5508a851be14d;
var $77e47b6bc9169ce7$export$c176f998e71d0f08;
var $77e47b6bc9169ce7$export$97aac956da55dae9;
var $77e47b6bc9169ce7$export$f22da7240b7add18;
var $77e47b6bc9169ce7$export$897fbb5bd1538ae2;
var $77e47b6bc9169ce7$export$faeb8e94f65170b1;
$77e47b6bc9169ce7$export$b0377cbbbdab6cba = "#006da8";
$77e47b6bc9169ce7$export$f27f0a643498ce3d = "#00aafc";
$77e47b6bc9169ce7$export$b00c055587dc7469 = "#f5dbd9";
$77e47b6bc9169ce7$export$b1a09d22b7ad6c4 = "#c92100";
$77e47b6bc9169ce7$export$509f3108fdd206bb = "#ebafa6";
$77e47b6bc9169ce7$export$42ff741d2868ee32 = "#074f86";
$77e47b6bc9169ce7$export$8c430709db82137d = "#dadada";
$77e47b6bc9169ce7$export$2d4b1211b4389c3b = "#dddbda";
$77e47b6bc9169ce7$export$3832be13857745bc = "#eae9ed";
$77e47b6bc9169ce7$export$f4c68800b094ddb1 = "#e9e8f4";
$77e47b6bc9169ce7$export$cc74dcc53cfce4eb = "wrapper_5636da";
$77e47b6bc9169ce7$export$b1e5508a851be14d = "menu_5636da";
$77e47b6bc9169ce7$export$c176f998e71d0f08 = "menuItem_5636da";
$77e47b6bc9169ce7$export$97aac956da55dae9 = "current_5636da";
$77e47b6bc9169ce7$export$f22da7240b7add18 = "main_5636da";
$77e47b6bc9169ce7$export$897fbb5bd1538ae2 = "formSectionHeading_5636da";
$77e47b6bc9169ce7$export$faeb8e94f65170b1 = "serviceDeskFieldsSection_5636da";




var $fpdl2 = parcelRequire("fpdl2");
// ES6 Map
var $8816731496aa8698$var$map;
try {
    $8816731496aa8698$var$map = Map;
} catch (_) {}
var $8816731496aa8698$var$set;
// ES6 Set
try {
    $8816731496aa8698$var$set = Set;
} catch (_) {}
function $8816731496aa8698$var$baseClone(src, circulars, clones) {
    // Null/undefined/functions/etc
    if (!src || typeof src !== 'object' || typeof src === 'function') return src;
    // DOM Node
    if (src.nodeType && 'cloneNode' in src) return src.cloneNode(true);
    // Date
    if (src instanceof Date) return new Date(src.getTime());
    // RegExp
    if (src instanceof RegExp) return new RegExp(src);
    // Arrays
    if (Array.isArray(src)) return src.map($8816731496aa8698$export$2e2bcd8739ae039);
    // ES6 Maps
    if ($8816731496aa8698$var$map && src instanceof $8816731496aa8698$var$map) return new Map(Array.from(src.entries()));
    // ES6 Sets
    if ($8816731496aa8698$var$set && src instanceof $8816731496aa8698$var$set) return new Set(Array.from(src.values()));
    // Object
    if (src instanceof Object) {
        circulars.push(src);
        var obj = Object.create(src);
        clones.push(obj);
        for(var key in src){
            var idx = circulars.findIndex(function(i) {
                return i === src[key];
            });
            obj[key] = idx > -1 ? clones[idx] : $8816731496aa8698$var$baseClone(src[key], circulars, clones);
        }
        return obj;
    }
    // ???
    return src;
}
function $8816731496aa8698$export$2e2bcd8739ae039(src) {
    return $8816731496aa8698$var$baseClone(src, [], []);
}


const $18c302d8aff04670$var$toString = Object.prototype.toString;
const $18c302d8aff04670$var$errorToString = Error.prototype.toString;
const $18c302d8aff04670$var$regExpToString = RegExp.prototype.toString;
const $18c302d8aff04670$var$symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : ()=>'';
const $18c302d8aff04670$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $18c302d8aff04670$var$printNumber(val) {
    if (val != +val) return 'NaN';
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? '-0' : '' + val;
}
function $18c302d8aff04670$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return '' + val;
    const typeOf = typeof val;
    if (typeOf === 'number') return $18c302d8aff04670$var$printNumber(val);
    if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
    if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
    if (typeOf === 'symbol') return $18c302d8aff04670$var$symbolToString.call(val).replace($18c302d8aff04670$var$SYMBOL_REGEXP, 'Symbol($1)');
    const tag = $18c302d8aff04670$var$toString.call(val).slice(8, -1);
    if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
    if (tag === 'Error' || val instanceof Error) return '[' + $18c302d8aff04670$var$errorToString.call(val) + ']';
    if (tag === 'RegExp') return $18c302d8aff04670$var$regExpToString.call(val);
    return null;
}
function $18c302d8aff04670$export$2e2bcd8739ae039(value, quoteStrings) {
    let result = $18c302d8aff04670$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $18c302d8aff04670$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}


let $0bc3a5a1f021de70$export$9b30b6294c1449a8 = {
    default: '${path} is invalid',
    required: '${path} is a required field',
    oneOf: '${path} must be one of the following values: ${values}',
    notOneOf: '${path} must not be one of the following values: ${values}',
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        let isCast = originalValue != null && originalValue !== value;
        let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${(0, $18c302d8aff04670$export$2e2bcd8739ae039)(value, true)}\`` + (isCast ? ` (cast from the value \`${(0, $18c302d8aff04670$export$2e2bcd8739ae039)(originalValue, true)}\`).` : '.');
        if (value === null) msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
        return msg;
    },
    defined: '${path} must be defined'
};
let $0bc3a5a1f021de70$export$22b082955e083ec3 = {
    length: '${path} must be exactly ${length} characters',
    min: '${path} must be at least ${min} characters',
    max: '${path} must be at most ${max} characters',
    matches: '${path} must match the following: "${regex}"',
    email: '${path} must be a valid email',
    url: '${path} must be a valid URL',
    uuid: '${path} must be a valid UUID',
    trim: '${path} must be a trimmed string',
    lowercase: '${path} must be a lowercase string',
    uppercase: '${path} must be a upper case string'
};
let $0bc3a5a1f021de70$export$98e628dec113755e = {
    min: '${path} must be greater than or equal to ${min}',
    max: '${path} must be less than or equal to ${max}',
    lessThan: '${path} must be less than ${less}',
    moreThan: '${path} must be greater than ${more}',
    positive: '${path} must be a positive number',
    negative: '${path} must be a negative number',
    integer: '${path} must be an integer'
};
let $0bc3a5a1f021de70$export$324d90190a8b822a = {
    min: '${path} field must be later than ${min}',
    max: '${path} field must be at earlier than ${max}'
};
let $0bc3a5a1f021de70$export$4a21f16c33752377 = {
    isValue: '${path} field must be ${value}'
};
let $0bc3a5a1f021de70$export$be5493f9613cbbe = {
    noUnknown: '${path} field has unspecified keys: ${unknown}'
};
let $0bc3a5a1f021de70$export$2f23118c22fb2630 = {
    min: '${path} field must have at least ${min} items',
    max: '${path} field must have less than or equal to ${max} items',
    length: '${path} must have ${length} items'
};
var $0bc3a5a1f021de70$export$2e2bcd8739ae039 = Object.assign(Object.create(null), {
    mixed: $0bc3a5a1f021de70$export$9b30b6294c1449a8,
    string: $0bc3a5a1f021de70$export$22b082955e083ec3,
    number: $0bc3a5a1f021de70$export$98e628dec113755e,
    date: $0bc3a5a1f021de70$export$324d90190a8b822a,
    object: $0bc3a5a1f021de70$export$be5493f9613cbbe,
    array: $0bc3a5a1f021de70$export$2f23118c22fb2630,
    boolean: $0bc3a5a1f021de70$export$4a21f16c33752377
});


var $cbcd9980dbc5c87e$exports = {};
var $460001af1ffdf93d$exports = {};
/** Used for built-in method references. */ var $460001af1ffdf93d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $460001af1ffdf93d$var$hasOwnProperty = $460001af1ffdf93d$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $460001af1ffdf93d$var$baseHas(object, key) {
    return object != null && $460001af1ffdf93d$var$hasOwnProperty.call(object, key);
}
$460001af1ffdf93d$exports = $460001af1ffdf93d$var$baseHas;


var $8b743d8f4acec4cf$exports = {};
var $1145c8db691336e2$exports = {};
var $2f83ca3523b5b10f$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $2f83ca3523b5b10f$var$isArray = Array.isArray;
$2f83ca3523b5b10f$exports = $2f83ca3523b5b10f$var$isArray;


var $8a67694528faa37e$exports = {};

var $eec85abb86f61bc3$exports = {};
var $004f8975423d307c$exports = {};
var $0f7ca8ef195ebffd$exports = {};

var $dSq9F = parcelRequire("dSq9F");
/** Built-in value references. */ var $0f7ca8ef195ebffd$var$Symbol = $dSq9F.Symbol;
$0f7ca8ef195ebffd$exports = $0f7ca8ef195ebffd$var$Symbol;


var $44f8987ccd50796b$exports = {};

/** Used for built-in method references. */ var $44f8987ccd50796b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $44f8987ccd50796b$var$hasOwnProperty = $44f8987ccd50796b$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $44f8987ccd50796b$var$nativeObjectToString = $44f8987ccd50796b$var$objectProto.toString;
/** Built-in value references. */ var $44f8987ccd50796b$var$symToStringTag = $0f7ca8ef195ebffd$exports ? $0f7ca8ef195ebffd$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $44f8987ccd50796b$var$getRawTag(value) {
    var isOwn = $44f8987ccd50796b$var$hasOwnProperty.call(value, $44f8987ccd50796b$var$symToStringTag), tag = value[$44f8987ccd50796b$var$symToStringTag];
    try {
        value[$44f8987ccd50796b$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $44f8987ccd50796b$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$44f8987ccd50796b$var$symToStringTag] = tag;
        else delete value[$44f8987ccd50796b$var$symToStringTag];
    }
    return result;
}
$44f8987ccd50796b$exports = $44f8987ccd50796b$var$getRawTag;


var $48cc9d55c034a455$exports = {};
/** Used for built-in method references. */ var $48cc9d55c034a455$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $48cc9d55c034a455$var$nativeObjectToString = $48cc9d55c034a455$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $48cc9d55c034a455$var$objectToString(value) {
    return $48cc9d55c034a455$var$nativeObjectToString.call(value);
}
$48cc9d55c034a455$exports = $48cc9d55c034a455$var$objectToString;


/** `Object#toString` result references. */ var $004f8975423d307c$var$nullTag = '[object Null]', $004f8975423d307c$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $004f8975423d307c$var$symToStringTag = $0f7ca8ef195ebffd$exports ? $0f7ca8ef195ebffd$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $004f8975423d307c$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $004f8975423d307c$var$undefinedTag : $004f8975423d307c$var$nullTag;
    return $004f8975423d307c$var$symToStringTag && $004f8975423d307c$var$symToStringTag in Object(value) ? $44f8987ccd50796b$exports(value) : $48cc9d55c034a455$exports(value);
}
$004f8975423d307c$exports = $004f8975423d307c$var$baseGetTag;


var $a587d40f568772b1$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $a587d40f568772b1$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$a587d40f568772b1$exports = $a587d40f568772b1$var$isObjectLike;


/** `Object#toString` result references. */ var $eec85abb86f61bc3$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $eec85abb86f61bc3$var$isSymbol(value) {
    return typeof value == 'symbol' || $a587d40f568772b1$exports(value) && $004f8975423d307c$exports(value) == $eec85abb86f61bc3$var$symbolTag;
}
$eec85abb86f61bc3$exports = $eec85abb86f61bc3$var$isSymbol;


/** Used to match property names within property paths. */ var $8a67694528faa37e$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $8a67694528faa37e$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $8a67694528faa37e$var$isKey(value, object) {
    if ($2f83ca3523b5b10f$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $eec85abb86f61bc3$exports(value)) return true;
    return $8a67694528faa37e$var$reIsPlainProp.test(value) || !$8a67694528faa37e$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$8a67694528faa37e$exports = $8a67694528faa37e$var$isKey;


var $81b8798df3054abb$exports = {};
var $c5f2d8b2c3606b71$exports = {};
var $4030158199cf74b9$exports = {};
var $3dd536b4a07d437f$exports = {};
var $bbe11d6847612c82$exports = {};
var $994ff8639137f621$exports = {};
var $b8480ad132d71ea6$exports = {};
var $5b6e52259761058d$exports = {};
var $89139cdb93325db3$exports = {};
var $0bf78a8f7b568a29$exports = {};
var $7bdb87608d1ac844$exports = {};

var $7f5ed5e16191144d$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $7f5ed5e16191144d$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$7f5ed5e16191144d$exports = $7f5ed5e16191144d$var$isObject;


/** `Object#toString` result references. */ var $7bdb87608d1ac844$var$asyncTag = '[object AsyncFunction]', $7bdb87608d1ac844$var$funcTag = '[object Function]', $7bdb87608d1ac844$var$genTag = '[object GeneratorFunction]', $7bdb87608d1ac844$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $7bdb87608d1ac844$var$isFunction(value) {
    if (!$7f5ed5e16191144d$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $004f8975423d307c$exports(value);
    return tag == $7bdb87608d1ac844$var$funcTag || tag == $7bdb87608d1ac844$var$genTag || tag == $7bdb87608d1ac844$var$asyncTag || tag == $7bdb87608d1ac844$var$proxyTag;
}
$7bdb87608d1ac844$exports = $7bdb87608d1ac844$var$isFunction;


var $1e9879be11c99256$exports = {};
var $f7eca2184d74e474$exports = {};

var $dSq9F = parcelRequire("dSq9F");
/** Used to detect overreaching core-js shims. */ var $f7eca2184d74e474$var$coreJsData = $dSq9F["__core-js_shared__"];
$f7eca2184d74e474$exports = $f7eca2184d74e474$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $1e9879be11c99256$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($f7eca2184d74e474$exports && $f7eca2184d74e474$exports.keys && $f7eca2184d74e474$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $1e9879be11c99256$var$isMasked(func) {
    return !!$1e9879be11c99256$var$maskSrcKey && $1e9879be11c99256$var$maskSrcKey in func;
}
$1e9879be11c99256$exports = $1e9879be11c99256$var$isMasked;



var $bf096c890d136c3d$exports = {};
/** Used for built-in method references. */ var $bf096c890d136c3d$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $bf096c890d136c3d$var$funcToString = $bf096c890d136c3d$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $bf096c890d136c3d$var$toSource(func) {
    if (func != null) {
        try {
            return $bf096c890d136c3d$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$bf096c890d136c3d$exports = $bf096c890d136c3d$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $0bf78a8f7b568a29$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $0bf78a8f7b568a29$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $0bf78a8f7b568a29$var$funcProto = Function.prototype, $0bf78a8f7b568a29$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0bf78a8f7b568a29$var$funcToString = $0bf78a8f7b568a29$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0bf78a8f7b568a29$var$hasOwnProperty = $0bf78a8f7b568a29$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $0bf78a8f7b568a29$var$reIsNative = RegExp('^' + $0bf78a8f7b568a29$var$funcToString.call($0bf78a8f7b568a29$var$hasOwnProperty).replace($0bf78a8f7b568a29$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $0bf78a8f7b568a29$var$baseIsNative(value) {
    if (!$7f5ed5e16191144d$exports(value) || $1e9879be11c99256$exports(value)) return false;
    var pattern = $7bdb87608d1ac844$exports(value) ? $0bf78a8f7b568a29$var$reIsNative : $0bf78a8f7b568a29$var$reIsHostCtor;
    return pattern.test($bf096c890d136c3d$exports(value));
}
$0bf78a8f7b568a29$exports = $0bf78a8f7b568a29$var$baseIsNative;


var $94cd9bf0f9fa0c9f$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $94cd9bf0f9fa0c9f$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$94cd9bf0f9fa0c9f$exports = $94cd9bf0f9fa0c9f$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $89139cdb93325db3$var$getNative(object, key) {
    var value = $94cd9bf0f9fa0c9f$exports(object, key);
    return $0bf78a8f7b568a29$exports(value) ? value : undefined;
}
$89139cdb93325db3$exports = $89139cdb93325db3$var$getNative;


/* Built-in method references that are verified to be native. */ var $5b6e52259761058d$var$nativeCreate = $89139cdb93325db3$exports(Object, 'create');
$5b6e52259761058d$exports = $5b6e52259761058d$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $b8480ad132d71ea6$var$hashClear() {
    this.__data__ = $5b6e52259761058d$exports ? $5b6e52259761058d$exports(null) : {};
    this.size = 0;
}
$b8480ad132d71ea6$exports = $b8480ad132d71ea6$var$hashClear;


var $59b1c1a961ade58b$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $59b1c1a961ade58b$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$59b1c1a961ade58b$exports = $59b1c1a961ade58b$var$hashDelete;


var $15e32282e6870b4b$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $15e32282e6870b4b$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $15e32282e6870b4b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $15e32282e6870b4b$var$hasOwnProperty = $15e32282e6870b4b$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $15e32282e6870b4b$var$hashGet(key) {
    var data = this.__data__;
    if ($5b6e52259761058d$exports) {
        var result = data[key];
        return result === $15e32282e6870b4b$var$HASH_UNDEFINED ? undefined : result;
    }
    return $15e32282e6870b4b$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$15e32282e6870b4b$exports = $15e32282e6870b4b$var$hashGet;


var $0f4e5e229214061d$exports = {};

/** Used for built-in method references. */ var $0f4e5e229214061d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0f4e5e229214061d$var$hasOwnProperty = $0f4e5e229214061d$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0f4e5e229214061d$var$hashHas(key) {
    var data = this.__data__;
    return $5b6e52259761058d$exports ? data[key] !== undefined : $0f4e5e229214061d$var$hasOwnProperty.call(data, key);
}
$0f4e5e229214061d$exports = $0f4e5e229214061d$var$hashHas;


var $722c012241bc35c0$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $722c012241bc35c0$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $722c012241bc35c0$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $5b6e52259761058d$exports && value === undefined ? $722c012241bc35c0$var$HASH_UNDEFINED : value;
    return this;
}
$722c012241bc35c0$exports = $722c012241bc35c0$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $994ff8639137f621$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$994ff8639137f621$var$Hash.prototype.clear = $b8480ad132d71ea6$exports;
$994ff8639137f621$var$Hash.prototype['delete'] = $59b1c1a961ade58b$exports;
$994ff8639137f621$var$Hash.prototype.get = $15e32282e6870b4b$exports;
$994ff8639137f621$var$Hash.prototype.has = $0f4e5e229214061d$exports;
$994ff8639137f621$var$Hash.prototype.set = $722c012241bc35c0$exports;
$994ff8639137f621$exports = $994ff8639137f621$var$Hash;


var $4ada2fad8de29e78$exports = {};
var $4b87381e3a4eb226$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $4b87381e3a4eb226$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$4b87381e3a4eb226$exports = $4b87381e3a4eb226$var$listCacheClear;


var $6ae49298d1ae3b2a$exports = {};
var $f753f0d4ee82f655$exports = {};
var $2cc958e3f9b9cbdf$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $2cc958e3f9b9cbdf$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$2cc958e3f9b9cbdf$exports = $2cc958e3f9b9cbdf$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f753f0d4ee82f655$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($2cc958e3f9b9cbdf$exports(array[length][0], key)) return length;
    }
    return -1;
}
$f753f0d4ee82f655$exports = $f753f0d4ee82f655$var$assocIndexOf;


/** Used for built-in method references. */ var $6ae49298d1ae3b2a$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $6ae49298d1ae3b2a$var$splice = $6ae49298d1ae3b2a$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6ae49298d1ae3b2a$var$listCacheDelete(key) {
    var data = this.__data__, index = $f753f0d4ee82f655$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $6ae49298d1ae3b2a$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$6ae49298d1ae3b2a$exports = $6ae49298d1ae3b2a$var$listCacheDelete;


var $2fde79a9e923e411$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $2fde79a9e923e411$var$listCacheGet(key) {
    var data = this.__data__, index = $f753f0d4ee82f655$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$2fde79a9e923e411$exports = $2fde79a9e923e411$var$listCacheGet;


var $74a4ff2fc36f2b34$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $74a4ff2fc36f2b34$var$listCacheHas(key) {
    return $f753f0d4ee82f655$exports(this.__data__, key) > -1;
}
$74a4ff2fc36f2b34$exports = $74a4ff2fc36f2b34$var$listCacheHas;


var $1f1a5365f60f4a00$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $1f1a5365f60f4a00$var$listCacheSet(key, value) {
    var data = this.__data__, index = $f753f0d4ee82f655$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$1f1a5365f60f4a00$exports = $1f1a5365f60f4a00$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4ada2fad8de29e78$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$4ada2fad8de29e78$var$ListCache.prototype.clear = $4b87381e3a4eb226$exports;
$4ada2fad8de29e78$var$ListCache.prototype['delete'] = $6ae49298d1ae3b2a$exports;
$4ada2fad8de29e78$var$ListCache.prototype.get = $2fde79a9e923e411$exports;
$4ada2fad8de29e78$var$ListCache.prototype.has = $74a4ff2fc36f2b34$exports;
$4ada2fad8de29e78$var$ListCache.prototype.set = $1f1a5365f60f4a00$exports;
$4ada2fad8de29e78$exports = $4ada2fad8de29e78$var$ListCache;


var $526800996a33daa9$exports = {};


var $dSq9F = parcelRequire("dSq9F");
/* Built-in method references that are verified to be native. */ var $526800996a33daa9$var$Map = $89139cdb93325db3$exports($dSq9F, 'Map');
$526800996a33daa9$exports = $526800996a33daa9$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $bbe11d6847612c82$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $994ff8639137f621$exports,
        'map': new ($526800996a33daa9$exports || $4ada2fad8de29e78$exports),
        'string': new $994ff8639137f621$exports
    };
}
$bbe11d6847612c82$exports = $bbe11d6847612c82$var$mapCacheClear;


var $a92524f74db51f6b$exports = {};
var $6ca5ed47a162b634$exports = {};
var $ddd126ca90275fd3$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $ddd126ca90275fd3$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$ddd126ca90275fd3$exports = $ddd126ca90275fd3$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $6ca5ed47a162b634$var$getMapData(map, key) {
    var data = map.__data__;
    return $ddd126ca90275fd3$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$6ca5ed47a162b634$exports = $6ca5ed47a162b634$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $a92524f74db51f6b$var$mapCacheDelete(key) {
    var result = $6ca5ed47a162b634$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$a92524f74db51f6b$exports = $a92524f74db51f6b$var$mapCacheDelete;


var $408262ea17c7b2dc$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $408262ea17c7b2dc$var$mapCacheGet(key) {
    return $6ca5ed47a162b634$exports(this, key).get(key);
}
$408262ea17c7b2dc$exports = $408262ea17c7b2dc$var$mapCacheGet;


var $c2a64c2e4ce7720d$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c2a64c2e4ce7720d$var$mapCacheHas(key) {
    return $6ca5ed47a162b634$exports(this, key).has(key);
}
$c2a64c2e4ce7720d$exports = $c2a64c2e4ce7720d$var$mapCacheHas;


var $a77b2c032f30634e$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $a77b2c032f30634e$var$mapCacheSet(key, value) {
    var data = $6ca5ed47a162b634$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$a77b2c032f30634e$exports = $a77b2c032f30634e$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3dd536b4a07d437f$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$3dd536b4a07d437f$var$MapCache.prototype.clear = $bbe11d6847612c82$exports;
$3dd536b4a07d437f$var$MapCache.prototype['delete'] = $a92524f74db51f6b$exports;
$3dd536b4a07d437f$var$MapCache.prototype.get = $408262ea17c7b2dc$exports;
$3dd536b4a07d437f$var$MapCache.prototype.has = $c2a64c2e4ce7720d$exports;
$3dd536b4a07d437f$var$MapCache.prototype.set = $a77b2c032f30634e$exports;
$3dd536b4a07d437f$exports = $3dd536b4a07d437f$var$MapCache;


/** Error message constants. */ var $4030158199cf74b9$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $4030158199cf74b9$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($4030158199cf74b9$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($4030158199cf74b9$var$memoize.Cache || $3dd536b4a07d437f$exports);
    return memoized;
}
// Expose `MapCache`.
$4030158199cf74b9$var$memoize.Cache = $3dd536b4a07d437f$exports;
$4030158199cf74b9$exports = $4030158199cf74b9$var$memoize;


/** Used as the maximum memoize cache size. */ var $c5f2d8b2c3606b71$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $c5f2d8b2c3606b71$var$memoizeCapped(func) {
    var result = $4030158199cf74b9$exports(func, function(key) {
        if (cache.size === $c5f2d8b2c3606b71$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$c5f2d8b2c3606b71$exports = $c5f2d8b2c3606b71$var$memoizeCapped;


/** Used to match property names within property paths. */ var $81b8798df3054abb$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $81b8798df3054abb$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $81b8798df3054abb$var$stringToPath = $c5f2d8b2c3606b71$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($81b8798df3054abb$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($81b8798df3054abb$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$81b8798df3054abb$exports = $81b8798df3054abb$var$stringToPath;


var $56ae5a8092ddcc58$exports = {};
var $1c32c5d63793eb25$exports = {};

var $a46e17e4f1b4f90d$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $a46e17e4f1b4f90d$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$a46e17e4f1b4f90d$exports = $a46e17e4f1b4f90d$var$arrayMap;




/** Used as references for various `Number` constants. */ var $1c32c5d63793eb25$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $1c32c5d63793eb25$var$symbolProto = $0f7ca8ef195ebffd$exports ? $0f7ca8ef195ebffd$exports.prototype : undefined, $1c32c5d63793eb25$var$symbolToString = $1c32c5d63793eb25$var$symbolProto ? $1c32c5d63793eb25$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $1c32c5d63793eb25$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($2f83ca3523b5b10f$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $a46e17e4f1b4f90d$exports(value, $1c32c5d63793eb25$var$baseToString) + '';
    if ($eec85abb86f61bc3$exports(value)) return $1c32c5d63793eb25$var$symbolToString ? $1c32c5d63793eb25$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$1c32c5d63793eb25$var$INFINITY ? '-0' : result;
}
$1c32c5d63793eb25$exports = $1c32c5d63793eb25$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $56ae5a8092ddcc58$var$toString(value) {
    return value == null ? '' : $1c32c5d63793eb25$exports(value);
}
$56ae5a8092ddcc58$exports = $56ae5a8092ddcc58$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $1145c8db691336e2$var$castPath(value, object) {
    if ($2f83ca3523b5b10f$exports(value)) return value;
    return $8a67694528faa37e$exports(value, object) ? [
        value
    ] : $81b8798df3054abb$exports($56ae5a8092ddcc58$exports(value));
}
$1145c8db691336e2$exports = $1145c8db691336e2$var$castPath;


var $05fd960b061b295a$exports = {};
var $1b41b08296be9eb8$exports = {};


/** `Object#toString` result references. */ var $1b41b08296be9eb8$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $1b41b08296be9eb8$var$baseIsArguments(value) {
    return $a587d40f568772b1$exports(value) && $004f8975423d307c$exports(value) == $1b41b08296be9eb8$var$argsTag;
}
$1b41b08296be9eb8$exports = $1b41b08296be9eb8$var$baseIsArguments;



/** Used for built-in method references. */ var $05fd960b061b295a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $05fd960b061b295a$var$hasOwnProperty = $05fd960b061b295a$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $05fd960b061b295a$var$propertyIsEnumerable = $05fd960b061b295a$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $05fd960b061b295a$var$isArguments = $1b41b08296be9eb8$exports(function() {
    return arguments;
}()) ? $1b41b08296be9eb8$exports : function(value) {
    return $a587d40f568772b1$exports(value) && $05fd960b061b295a$var$hasOwnProperty.call(value, 'callee') && !$05fd960b061b295a$var$propertyIsEnumerable.call(value, 'callee');
};
$05fd960b061b295a$exports = $05fd960b061b295a$var$isArguments;



var $1a051a033fd8e45d$exports = {};
/** Used as references for various `Number` constants. */ var $1a051a033fd8e45d$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $1a051a033fd8e45d$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $1a051a033fd8e45d$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $1a051a033fd8e45d$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $1a051a033fd8e45d$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$1a051a033fd8e45d$exports = $1a051a033fd8e45d$var$isIndex;


var $54ef4e7e75a91db1$exports = {};
/** Used as references for various `Number` constants. */ var $54ef4e7e75a91db1$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $54ef4e7e75a91db1$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $54ef4e7e75a91db1$var$MAX_SAFE_INTEGER;
}
$54ef4e7e75a91db1$exports = $54ef4e7e75a91db1$var$isLength;


var $59b2aef36a4fc0f2$exports = {};

/** Used as references for various `Number` constants. */ var $59b2aef36a4fc0f2$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $59b2aef36a4fc0f2$var$toKey(value) {
    if (typeof value == 'string' || $eec85abb86f61bc3$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$59b2aef36a4fc0f2$var$INFINITY ? '-0' : result;
}
$59b2aef36a4fc0f2$exports = $59b2aef36a4fc0f2$var$toKey;


/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $8b743d8f4acec4cf$var$hasPath(object, path, hasFunc) {
    path = $1145c8db691336e2$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $59b2aef36a4fc0f2$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $54ef4e7e75a91db1$exports(length) && $1a051a033fd8e45d$exports(key, length) && ($2f83ca3523b5b10f$exports(object) || $05fd960b061b295a$exports(object));
}
$8b743d8f4acec4cf$exports = $8b743d8f4acec4cf$var$hasPath;


/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $cbcd9980dbc5c87e$var$has(object, path) {
    return object != null && $8b743d8f4acec4cf$exports(object, path, $460001af1ffdf93d$exports);
}
$cbcd9980dbc5c87e$exports = $cbcd9980dbc5c87e$var$has;


const $521ce2c1367ddf6a$var$isSchema = (obj)=>obj && obj.__isYupSchema__;
var $521ce2c1367ddf6a$export$2e2bcd8739ae039 = $521ce2c1367ddf6a$var$isSchema;


class $1a05d4aadec864bb$var$Condition {
    constructor(refs, options){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        if (typeof options === 'function') {
            this.fn = options;
            return;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cbcd9980dbc5c87e$exports)))(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
        if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
        let { is: is, then: then, otherwise: otherwise } = options;
        let check = typeof is === 'function' ? is : (...values)=>values.every((value)=>value === is);
        this.fn = function(...args) {
            let options = args.pop();
            let schema = args.pop();
            let branch = check(...args) ? then : otherwise;
            if (!branch) return undefined;
            if (typeof branch === 'function') return branch(schema);
            return schema.concat(branch.resolve(options));
        };
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn.apply(base, values.concat(base, options));
        if (schema === undefined || schema === base) return base;
        if (!(0, $521ce2c1367ddf6a$export$2e2bcd8739ae039)(schema)) throw new TypeError('conditions must return a schema object');
        return schema.resolve(options);
    }
}
var $1a05d4aadec864bb$export$2e2bcd8739ae039 = $1a05d4aadec864bb$var$Condition;



function $0e925fb057f308b0$export$2e2bcd8739ae039(value) {
    return value == null ? [] : [].concat(value);
}


function $0d3dd0f474055a4e$var$_extends() {
    $0d3dd0f474055a4e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0d3dd0f474055a4e$var$_extends.apply(this, arguments);
}
let $0d3dd0f474055a4e$var$strReg = /\$\{\s*(\w+)\s*\}/g;
class $0d3dd0f474055a4e$export$2e2bcd8739ae039 extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || 'this';
        if (path !== params.path) params = $0d3dd0f474055a4e$var$_extends({}, params, {
            path: path
        });
        if (typeof message === 'string') return message.replace($0d3dd0f474055a4e$var$strReg, (_, key)=>(0, $18c302d8aff04670$export$2e2bcd8739ae039)(params[key]));
        if (typeof message === 'function') return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === 'ValidationError';
    }
    constructor(errorOrErrors, value, field, type){
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.errors = void 0;
        this.params = void 0;
        this.inner = void 0;
        this.name = 'ValidationError';
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        (0, $0e925fb057f308b0$export$2e2bcd8739ae039)(errorOrErrors).forEach((err)=>{
            if ($0d3dd0f474055a4e$export$2e2bcd8739ae039.isError(err)) {
                this.errors.push(...err.errors);
                this.inner = this.inner.concat(err.inner.length ? err.inner : err);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
        if (Error.captureStackTrace) Error.captureStackTrace(this, $0d3dd0f474055a4e$export$2e2bcd8739ae039);
    }
}


const $a0ed368902601763$var$once = (cb)=>{
    let fired = false;
    return (...args)=>{
        if (fired) return;
        fired = true;
        cb(...args);
    };
};
function $a0ed368902601763$export$2e2bcd8739ae039(options, cb) {
    let { endEarly: endEarly, tests: tests, args: args, value: value, errors: errors, sort: sort, path: path } = options;
    let callback = $a0ed368902601763$var$once(cb);
    let count = tests.length;
    const nestedErrors = [];
    errors = errors ? errors : [];
    if (!count) return errors.length ? callback(new (0, $0d3dd0f474055a4e$export$2e2bcd8739ae039)(errors, value, path)) : callback(null, value);
    for(let i = 0; i < tests.length; i++){
        const test = tests[i];
        test(args, function finishTestRun(err) {
            if (err) {
                // always return early for non validation errors
                if (!(0, $0d3dd0f474055a4e$export$2e2bcd8739ae039).isError(err)) return callback(err, value);
                if (endEarly) {
                    err.value = value;
                    return callback(err, value);
                }
                nestedErrors.push(err);
            }
            if (--count <= 0) {
                if (nestedErrors.length) {
                    if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name
                    if (errors.length) nestedErrors.push(...errors);
                    errors = nestedErrors;
                }
                if (errors.length) {
                    callback(new (0, $0d3dd0f474055a4e$export$2e2bcd8739ae039)(errors, value, path), value);
                    return;
                }
                callback(null, value);
            }
        });
    }
}


var $4c0a59ef68410050$exports = {};
var $529221a14fcc9889$exports = {};
var $76d9d7939ddaa524$exports = {};

var $76d9d7939ddaa524$var$defineProperty = function() {
    try {
        var func = $89139cdb93325db3$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$76d9d7939ddaa524$exports = $76d9d7939ddaa524$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $529221a14fcc9889$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $76d9d7939ddaa524$exports) $76d9d7939ddaa524$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$529221a14fcc9889$exports = $529221a14fcc9889$var$baseAssignValue;


var $810c828ac4dff00f$exports = {};
var $8ce8b85ee1d2f74b$exports = {};
var $dec0e3863107765c$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $dec0e3863107765c$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$dec0e3863107765c$exports = $dec0e3863107765c$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $8ce8b85ee1d2f74b$var$baseFor = $dec0e3863107765c$exports();
$8ce8b85ee1d2f74b$exports = $8ce8b85ee1d2f74b$var$baseFor;


var $ba9d8b90313399c4$exports = {};
var $2d2e043a2d4d43da$exports = {};
var $eb99efc4d85bb9ab$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $eb99efc4d85bb9ab$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$eb99efc4d85bb9ab$exports = $eb99efc4d85bb9ab$var$baseTimes;





var $l52Kb = parcelRequire("l52Kb");

var $574ddd6edb8f72f9$exports = {};
var $be463fd7df74f270$exports = {};



/** `Object#toString` result references. */ var $be463fd7df74f270$var$argsTag = '[object Arguments]', $be463fd7df74f270$var$arrayTag = '[object Array]', $be463fd7df74f270$var$boolTag = '[object Boolean]', $be463fd7df74f270$var$dateTag = '[object Date]', $be463fd7df74f270$var$errorTag = '[object Error]', $be463fd7df74f270$var$funcTag = '[object Function]', $be463fd7df74f270$var$mapTag = '[object Map]', $be463fd7df74f270$var$numberTag = '[object Number]', $be463fd7df74f270$var$objectTag = '[object Object]', $be463fd7df74f270$var$regexpTag = '[object RegExp]', $be463fd7df74f270$var$setTag = '[object Set]', $be463fd7df74f270$var$stringTag = '[object String]', $be463fd7df74f270$var$weakMapTag = '[object WeakMap]';
var $be463fd7df74f270$var$arrayBufferTag = '[object ArrayBuffer]', $be463fd7df74f270$var$dataViewTag = '[object DataView]', $be463fd7df74f270$var$float32Tag = '[object Float32Array]', $be463fd7df74f270$var$float64Tag = '[object Float64Array]', $be463fd7df74f270$var$int8Tag = '[object Int8Array]', $be463fd7df74f270$var$int16Tag = '[object Int16Array]', $be463fd7df74f270$var$int32Tag = '[object Int32Array]', $be463fd7df74f270$var$uint8Tag = '[object Uint8Array]', $be463fd7df74f270$var$uint8ClampedTag = '[object Uint8ClampedArray]', $be463fd7df74f270$var$uint16Tag = '[object Uint16Array]', $be463fd7df74f270$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $be463fd7df74f270$var$typedArrayTags = {};
$be463fd7df74f270$var$typedArrayTags[$be463fd7df74f270$var$float32Tag] = $be463fd7df74f270$var$typedArrayTags[$be463fd7df74f270$var$float64Tag] = $be463fd7df74f270$var$typedArrayTags[$be463fd7df74f270$var$int8Tag] = $be463fd7df74f270$var$typedArrayTags[$be463fd7df74f270$var$int16Tag] = $be463fd7df74f270$var$typedArrayTags[$be463fd7df74f270$var$int32Tag] = $be463fd7df74f270$var$typedArrayTags[$be463fd7df74f270$var$uint8Tag] = $be463fd7df74f270$var$typedArrayTags[$be463fd7df74f270$var$uint8ClampedTag] = $be463fd7df74f270$var$typedArrayTags[$be463fd7df74f270$var$uint16Tag] = $be463fd7df74f270$var$typedArrayTags[$be463fd7df74f270$var$uint32Tag] = true;
$be463fd7df74f270$var$typedArrayTags[$be463fd7df74f270$var$argsTag] = $be463fd7df74f270$var$typedArrayTags[$be463fd7df74f270$var$arrayTag] = $be463fd7df74f270$var$typedArrayTags[$be463fd7df74f270$var$arrayBufferTag] = $be463fd7df74f270$var$typedArrayTags[$be463fd7df74f270$var$boolTag] = $be463fd7df74f270$var$typedArrayTags[$be463fd7df74f270$var$dataViewTag] = $be463fd7df74f270$var$typedArrayTags[$be463fd7df74f270$var$dateTag] = $be463fd7df74f270$var$typedArrayTags[$be463fd7df74f270$var$errorTag] = $be463fd7df74f270$var$typedArrayTags[$be463fd7df74f270$var$funcTag] = $be463fd7df74f270$var$typedArrayTags[$be463fd7df74f270$var$mapTag] = $be463fd7df74f270$var$typedArrayTags[$be463fd7df74f270$var$numberTag] = $be463fd7df74f270$var$typedArrayTags[$be463fd7df74f270$var$objectTag] = $be463fd7df74f270$var$typedArrayTags[$be463fd7df74f270$var$regexpTag] = $be463fd7df74f270$var$typedArrayTags[$be463fd7df74f270$var$setTag] = $be463fd7df74f270$var$typedArrayTags[$be463fd7df74f270$var$stringTag] = $be463fd7df74f270$var$typedArrayTags[$be463fd7df74f270$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $be463fd7df74f270$var$baseIsTypedArray(value) {
    return $a587d40f568772b1$exports(value) && $54ef4e7e75a91db1$exports(value.length) && !!$be463fd7df74f270$var$typedArrayTags[$004f8975423d307c$exports(value)];
}
$be463fd7df74f270$exports = $be463fd7df74f270$var$baseIsTypedArray;


var $fcfd3b85a09e716e$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $fcfd3b85a09e716e$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$fcfd3b85a09e716e$exports = $fcfd3b85a09e716e$var$baseUnary;



var $9zqsx = parcelRequire("9zqsx");
/* Node.js helper references. */ var $574ddd6edb8f72f9$var$nodeIsTypedArray = $9zqsx && $9zqsx.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $574ddd6edb8f72f9$var$isTypedArray = $574ddd6edb8f72f9$var$nodeIsTypedArray ? $fcfd3b85a09e716e$exports($574ddd6edb8f72f9$var$nodeIsTypedArray) : $be463fd7df74f270$exports;
$574ddd6edb8f72f9$exports = $574ddd6edb8f72f9$var$isTypedArray;


/** Used for built-in method references. */ var $2d2e043a2d4d43da$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2d2e043a2d4d43da$var$hasOwnProperty = $2d2e043a2d4d43da$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $2d2e043a2d4d43da$var$arrayLikeKeys(value, inherited) {
    var isArr = $2f83ca3523b5b10f$exports(value), isArg = !isArr && $05fd960b061b295a$exports(value), isBuff = !isArr && !isArg && $l52Kb(value), isType = !isArr && !isArg && !isBuff && $574ddd6edb8f72f9$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $eb99efc4d85bb9ab$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $2d2e043a2d4d43da$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $1a051a033fd8e45d$exports(key, length)))) result.push(key);
    return result;
}
$2d2e043a2d4d43da$exports = $2d2e043a2d4d43da$var$arrayLikeKeys;


var $ca8b4e2e08737934$exports = {};
var $092bad3f0688f7fd$exports = {};
/** Used for built-in method references. */ var $092bad3f0688f7fd$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $092bad3f0688f7fd$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $092bad3f0688f7fd$var$objectProto;
    return value === proto;
}
$092bad3f0688f7fd$exports = $092bad3f0688f7fd$var$isPrototype;


var $f59cb353078461f2$exports = {};
var $4c59960e59aa1a86$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $4c59960e59aa1a86$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$4c59960e59aa1a86$exports = $4c59960e59aa1a86$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $f59cb353078461f2$var$nativeKeys = $4c59960e59aa1a86$exports(Object.keys, Object);
$f59cb353078461f2$exports = $f59cb353078461f2$var$nativeKeys;


/** Used for built-in method references. */ var $ca8b4e2e08737934$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ca8b4e2e08737934$var$hasOwnProperty = $ca8b4e2e08737934$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ca8b4e2e08737934$var$baseKeys(object) {
    if (!$092bad3f0688f7fd$exports(object)) return $f59cb353078461f2$exports(object);
    var result = [];
    for(var key in Object(object))if ($ca8b4e2e08737934$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$ca8b4e2e08737934$exports = $ca8b4e2e08737934$var$baseKeys;


var $ad22519fc5dc3b89$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ad22519fc5dc3b89$var$isArrayLike(value) {
    return value != null && $54ef4e7e75a91db1$exports(value.length) && !$7bdb87608d1ac844$exports(value);
}
$ad22519fc5dc3b89$exports = $ad22519fc5dc3b89$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $ba9d8b90313399c4$var$keys(object) {
    return $ad22519fc5dc3b89$exports(object) ? $2d2e043a2d4d43da$exports(object) : $ca8b4e2e08737934$exports(object);
}
$ba9d8b90313399c4$exports = $ba9d8b90313399c4$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $810c828ac4dff00f$var$baseForOwn(object, iteratee) {
    return object && $8ce8b85ee1d2f74b$exports(object, iteratee, $ba9d8b90313399c4$exports);
}
$810c828ac4dff00f$exports = $810c828ac4dff00f$var$baseForOwn;


var $f784bf4d7896d7fa$exports = {};
var $379969c01dd444ac$exports = {};
var $024a9cc2ead81e69$exports = {};
var $7ae04797a96477b9$exports = {};

var $ae0c9f913374230c$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $ae0c9f913374230c$var$stackClear() {
    this.__data__ = new $4ada2fad8de29e78$exports;
    this.size = 0;
}
$ae0c9f913374230c$exports = $ae0c9f913374230c$var$stackClear;


var $4ebca23da95ab888$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $4ebca23da95ab888$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$4ebca23da95ab888$exports = $4ebca23da95ab888$var$stackDelete;


var $516e3404832557b7$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $516e3404832557b7$var$stackGet(key) {
    return this.__data__.get(key);
}
$516e3404832557b7$exports = $516e3404832557b7$var$stackGet;


var $2f3891643ff42ac1$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2f3891643ff42ac1$var$stackHas(key) {
    return this.__data__.has(key);
}
$2f3891643ff42ac1$exports = $2f3891643ff42ac1$var$stackHas;


var $9a9b7cbf72f14604$exports = {};



/** Used as the size to enable large array optimizations. */ var $9a9b7cbf72f14604$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9a9b7cbf72f14604$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $4ada2fad8de29e78$exports) {
        var pairs = data.__data__;
        if (!$526800996a33daa9$exports || pairs.length < $9a9b7cbf72f14604$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $3dd536b4a07d437f$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$9a9b7cbf72f14604$exports = $9a9b7cbf72f14604$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7ae04797a96477b9$var$Stack(entries) {
    var data = this.__data__ = new $4ada2fad8de29e78$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$7ae04797a96477b9$var$Stack.prototype.clear = $ae0c9f913374230c$exports;
$7ae04797a96477b9$var$Stack.prototype['delete'] = $4ebca23da95ab888$exports;
$7ae04797a96477b9$var$Stack.prototype.get = $516e3404832557b7$exports;
$7ae04797a96477b9$var$Stack.prototype.has = $2f3891643ff42ac1$exports;
$7ae04797a96477b9$var$Stack.prototype.set = $9a9b7cbf72f14604$exports;
$7ae04797a96477b9$exports = $7ae04797a96477b9$var$Stack;


var $b94454686479760d$exports = {};
var $f6871a996483e8f7$exports = {};

var $9091348153b6e2f5$exports = {};
var $7ad8cdd96cde176b$exports = {};

var $403a09e2e70851b7$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $403a09e2e70851b7$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $403a09e2e70851b7$var$setCacheAdd(value) {
    this.__data__.set(value, $403a09e2e70851b7$var$HASH_UNDEFINED);
    return this;
}
$403a09e2e70851b7$exports = $403a09e2e70851b7$var$setCacheAdd;


var $432875418c3983a0$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $432875418c3983a0$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$432875418c3983a0$exports = $432875418c3983a0$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $7ad8cdd96cde176b$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $3dd536b4a07d437f$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$7ad8cdd96cde176b$var$SetCache.prototype.add = $7ad8cdd96cde176b$var$SetCache.prototype.push = $403a09e2e70851b7$exports;
$7ad8cdd96cde176b$var$SetCache.prototype.has = $432875418c3983a0$exports;
$7ad8cdd96cde176b$exports = $7ad8cdd96cde176b$var$SetCache;


var $b4527531b7d3dd7e$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $b4527531b7d3dd7e$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$b4527531b7d3dd7e$exports = $b4527531b7d3dd7e$var$arraySome;


var $f5e20d314284c4bb$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f5e20d314284c4bb$var$cacheHas(cache, key) {
    return cache.has(key);
}
$f5e20d314284c4bb$exports = $f5e20d314284c4bb$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $9091348153b6e2f5$var$COMPARE_PARTIAL_FLAG = 1, $9091348153b6e2f5$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $9091348153b6e2f5$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $9091348153b6e2f5$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $9091348153b6e2f5$var$COMPARE_UNORDERED_FLAG ? new $7ad8cdd96cde176b$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$b4527531b7d3dd7e$exports(other, function(othValue, othIndex) {
                if (!$f5e20d314284c4bb$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$9091348153b6e2f5$exports = $9091348153b6e2f5$var$equalArrays;


var $1cfa573806de2df6$exports = {};

var $062f3cc982ccdf24$exports = {};

var $dSq9F = parcelRequire("dSq9F");
/** Built-in value references. */ var $062f3cc982ccdf24$var$Uint8Array = $dSq9F.Uint8Array;
$062f3cc982ccdf24$exports = $062f3cc982ccdf24$var$Uint8Array;




var $5972164f84d0df11$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $5972164f84d0df11$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$5972164f84d0df11$exports = $5972164f84d0df11$var$mapToArray;


var $61b18d801b7fe92b$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $61b18d801b7fe92b$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$61b18d801b7fe92b$exports = $61b18d801b7fe92b$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $1cfa573806de2df6$var$COMPARE_PARTIAL_FLAG = 1, $1cfa573806de2df6$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $1cfa573806de2df6$var$boolTag = '[object Boolean]', $1cfa573806de2df6$var$dateTag = '[object Date]', $1cfa573806de2df6$var$errorTag = '[object Error]', $1cfa573806de2df6$var$mapTag = '[object Map]', $1cfa573806de2df6$var$numberTag = '[object Number]', $1cfa573806de2df6$var$regexpTag = '[object RegExp]', $1cfa573806de2df6$var$setTag = '[object Set]', $1cfa573806de2df6$var$stringTag = '[object String]', $1cfa573806de2df6$var$symbolTag = '[object Symbol]';
var $1cfa573806de2df6$var$arrayBufferTag = '[object ArrayBuffer]', $1cfa573806de2df6$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $1cfa573806de2df6$var$symbolProto = $0f7ca8ef195ebffd$exports ? $0f7ca8ef195ebffd$exports.prototype : undefined, $1cfa573806de2df6$var$symbolValueOf = $1cfa573806de2df6$var$symbolProto ? $1cfa573806de2df6$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $1cfa573806de2df6$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $1cfa573806de2df6$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $1cfa573806de2df6$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $062f3cc982ccdf24$exports(object), new $062f3cc982ccdf24$exports(other))) return false;
            return true;
        case $1cfa573806de2df6$var$boolTag:
        case $1cfa573806de2df6$var$dateTag:
        case $1cfa573806de2df6$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $2cc958e3f9b9cbdf$exports(+object, +other);
        case $1cfa573806de2df6$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $1cfa573806de2df6$var$regexpTag:
        case $1cfa573806de2df6$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $1cfa573806de2df6$var$mapTag:
            var convert = $5972164f84d0df11$exports;
        case $1cfa573806de2df6$var$setTag:
            var isPartial = bitmask & $1cfa573806de2df6$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $61b18d801b7fe92b$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $1cfa573806de2df6$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $9091348153b6e2f5$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $1cfa573806de2df6$var$symbolTag:
            if ($1cfa573806de2df6$var$symbolValueOf) return $1cfa573806de2df6$var$symbolValueOf.call(object) == $1cfa573806de2df6$var$symbolValueOf.call(other);
    }
    return false;
}
$1cfa573806de2df6$exports = $1cfa573806de2df6$var$equalByTag;


var $5c95f08038187f4e$exports = {};
var $5c65835ec1a5d2ba$exports = {};
var $07952fcdae749f94$exports = {};
var $50f8087107f98451$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $50f8087107f98451$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$50f8087107f98451$exports = $50f8087107f98451$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $07952fcdae749f94$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $2f83ca3523b5b10f$exports(object) ? result : $50f8087107f98451$exports(result, symbolsFunc(object));
}
$07952fcdae749f94$exports = $07952fcdae749f94$var$baseGetAllKeys;


var $372e4f2aa197135d$exports = {};
var $e6a8e270d25e3ba4$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $e6a8e270d25e3ba4$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$e6a8e270d25e3ba4$exports = $e6a8e270d25e3ba4$var$arrayFilter;


var $c7b28ffc7cc042cb$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $c7b28ffc7cc042cb$var$stubArray() {
    return [];
}
$c7b28ffc7cc042cb$exports = $c7b28ffc7cc042cb$var$stubArray;


/** Used for built-in method references. */ var $372e4f2aa197135d$var$objectProto = Object.prototype;
/** Built-in value references. */ var $372e4f2aa197135d$var$propertyIsEnumerable = $372e4f2aa197135d$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $372e4f2aa197135d$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $372e4f2aa197135d$var$getSymbols = !$372e4f2aa197135d$var$nativeGetSymbols ? $c7b28ffc7cc042cb$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $e6a8e270d25e3ba4$exports($372e4f2aa197135d$var$nativeGetSymbols(object), function(symbol) {
        return $372e4f2aa197135d$var$propertyIsEnumerable.call(object, symbol);
    });
};
$372e4f2aa197135d$exports = $372e4f2aa197135d$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $5c65835ec1a5d2ba$var$getAllKeys(object) {
    return $07952fcdae749f94$exports(object, $ba9d8b90313399c4$exports, $372e4f2aa197135d$exports);
}
$5c65835ec1a5d2ba$exports = $5c65835ec1a5d2ba$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $5c95f08038187f4e$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $5c95f08038187f4e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5c95f08038187f4e$var$hasOwnProperty = $5c95f08038187f4e$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $5c95f08038187f4e$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $5c95f08038187f4e$var$COMPARE_PARTIAL_FLAG, objProps = $5c65835ec1a5d2ba$exports(object), objLength = objProps.length, othProps = $5c65835ec1a5d2ba$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $5c95f08038187f4e$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$5c95f08038187f4e$exports = $5c95f08038187f4e$var$equalObjects;


var $bb6ab4118ee16e48$exports = {};
var $0f4b1ba4fea2beaa$exports = {};


var $dSq9F = parcelRequire("dSq9F");
/* Built-in method references that are verified to be native. */ var $0f4b1ba4fea2beaa$var$DataView = $89139cdb93325db3$exports($dSq9F, 'DataView');
$0f4b1ba4fea2beaa$exports = $0f4b1ba4fea2beaa$var$DataView;



var $2aee0d515c8e95dd$exports = {};


var $dSq9F = parcelRequire("dSq9F");
/* Built-in method references that are verified to be native. */ var $2aee0d515c8e95dd$var$Promise = $89139cdb93325db3$exports($dSq9F, 'Promise');
$2aee0d515c8e95dd$exports = $2aee0d515c8e95dd$var$Promise;


var $40fa98a6becc2290$exports = {};


var $dSq9F = parcelRequire("dSq9F");
/* Built-in method references that are verified to be native. */ var $40fa98a6becc2290$var$Set = $89139cdb93325db3$exports($dSq9F, 'Set');
$40fa98a6becc2290$exports = $40fa98a6becc2290$var$Set;


var $7bb278b7751fc960$exports = {};


var $dSq9F = parcelRequire("dSq9F");
/* Built-in method references that are verified to be native. */ var $7bb278b7751fc960$var$WeakMap = $89139cdb93325db3$exports($dSq9F, 'WeakMap');
$7bb278b7751fc960$exports = $7bb278b7751fc960$var$WeakMap;




/** `Object#toString` result references. */ var $bb6ab4118ee16e48$var$mapTag = '[object Map]', $bb6ab4118ee16e48$var$objectTag = '[object Object]', $bb6ab4118ee16e48$var$promiseTag = '[object Promise]', $bb6ab4118ee16e48$var$setTag = '[object Set]', $bb6ab4118ee16e48$var$weakMapTag = '[object WeakMap]';
var $bb6ab4118ee16e48$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $bb6ab4118ee16e48$var$dataViewCtorString = $bf096c890d136c3d$exports($0f4b1ba4fea2beaa$exports), $bb6ab4118ee16e48$var$mapCtorString = $bf096c890d136c3d$exports($526800996a33daa9$exports), $bb6ab4118ee16e48$var$promiseCtorString = $bf096c890d136c3d$exports($2aee0d515c8e95dd$exports), $bb6ab4118ee16e48$var$setCtorString = $bf096c890d136c3d$exports($40fa98a6becc2290$exports), $bb6ab4118ee16e48$var$weakMapCtorString = $bf096c890d136c3d$exports($7bb278b7751fc960$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $bb6ab4118ee16e48$var$getTag = $004f8975423d307c$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($0f4b1ba4fea2beaa$exports && $bb6ab4118ee16e48$var$getTag(new $0f4b1ba4fea2beaa$exports(new ArrayBuffer(1))) != $bb6ab4118ee16e48$var$dataViewTag || $526800996a33daa9$exports && $bb6ab4118ee16e48$var$getTag(new $526800996a33daa9$exports) != $bb6ab4118ee16e48$var$mapTag || $2aee0d515c8e95dd$exports && $bb6ab4118ee16e48$var$getTag($2aee0d515c8e95dd$exports.resolve()) != $bb6ab4118ee16e48$var$promiseTag || $40fa98a6becc2290$exports && $bb6ab4118ee16e48$var$getTag(new $40fa98a6becc2290$exports) != $bb6ab4118ee16e48$var$setTag || $7bb278b7751fc960$exports && $bb6ab4118ee16e48$var$getTag(new $7bb278b7751fc960$exports) != $bb6ab4118ee16e48$var$weakMapTag) $bb6ab4118ee16e48$var$getTag = function(value) {
    var result = $004f8975423d307c$exports(value), Ctor = result == $bb6ab4118ee16e48$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $bf096c890d136c3d$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $bb6ab4118ee16e48$var$dataViewCtorString:
            return $bb6ab4118ee16e48$var$dataViewTag;
        case $bb6ab4118ee16e48$var$mapCtorString:
            return $bb6ab4118ee16e48$var$mapTag;
        case $bb6ab4118ee16e48$var$promiseCtorString:
            return $bb6ab4118ee16e48$var$promiseTag;
        case $bb6ab4118ee16e48$var$setCtorString:
            return $bb6ab4118ee16e48$var$setTag;
        case $bb6ab4118ee16e48$var$weakMapCtorString:
            return $bb6ab4118ee16e48$var$weakMapTag;
    }
    return result;
};
$bb6ab4118ee16e48$exports = $bb6ab4118ee16e48$var$getTag;




var $l52Kb = parcelRequire("l52Kb");

/** Used to compose bitmasks for value comparisons. */ var $f6871a996483e8f7$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $f6871a996483e8f7$var$argsTag = '[object Arguments]', $f6871a996483e8f7$var$arrayTag = '[object Array]', $f6871a996483e8f7$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $f6871a996483e8f7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f6871a996483e8f7$var$hasOwnProperty = $f6871a996483e8f7$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $f6871a996483e8f7$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $2f83ca3523b5b10f$exports(object), othIsArr = $2f83ca3523b5b10f$exports(other), objTag = objIsArr ? $f6871a996483e8f7$var$arrayTag : $bb6ab4118ee16e48$exports(object), othTag = othIsArr ? $f6871a996483e8f7$var$arrayTag : $bb6ab4118ee16e48$exports(other);
    objTag = objTag == $f6871a996483e8f7$var$argsTag ? $f6871a996483e8f7$var$objectTag : objTag;
    othTag = othTag == $f6871a996483e8f7$var$argsTag ? $f6871a996483e8f7$var$objectTag : othTag;
    var objIsObj = objTag == $f6871a996483e8f7$var$objectTag, othIsObj = othTag == $f6871a996483e8f7$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $l52Kb(object)) {
        if (!$l52Kb(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $7ae04797a96477b9$exports);
        return objIsArr || $574ddd6edb8f72f9$exports(object) ? $9091348153b6e2f5$exports(object, other, bitmask, customizer, equalFunc, stack) : $1cfa573806de2df6$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $f6871a996483e8f7$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $f6871a996483e8f7$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $f6871a996483e8f7$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $7ae04797a96477b9$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $7ae04797a96477b9$exports);
    return $5c95f08038187f4e$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$f6871a996483e8f7$exports = $f6871a996483e8f7$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $b94454686479760d$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$a587d40f568772b1$exports(value) && !$a587d40f568772b1$exports(other)) return value !== value && other !== other;
    return $f6871a996483e8f7$exports(value, other, bitmask, customizer, $b94454686479760d$var$baseIsEqual, stack);
}
$b94454686479760d$exports = $b94454686479760d$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $024a9cc2ead81e69$var$COMPARE_PARTIAL_FLAG = 1, $024a9cc2ead81e69$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $024a9cc2ead81e69$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $7ae04797a96477b9$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $b94454686479760d$exports(srcValue, objValue, $024a9cc2ead81e69$var$COMPARE_PARTIAL_FLAG | $024a9cc2ead81e69$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$024a9cc2ead81e69$exports = $024a9cc2ead81e69$var$baseIsMatch;


var $3311060dce3c45f9$exports = {};
var $b2a848581fba85e7$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $b2a848581fba85e7$var$isStrictComparable(value) {
    return value === value && !$7f5ed5e16191144d$exports(value);
}
$b2a848581fba85e7$exports = $b2a848581fba85e7$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $3311060dce3c45f9$var$getMatchData(object) {
    var result = $ba9d8b90313399c4$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $b2a848581fba85e7$exports(value)
        ];
    }
    return result;
}
$3311060dce3c45f9$exports = $3311060dce3c45f9$var$getMatchData;


var $ecbed4cf72cb7095$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $ecbed4cf72cb7095$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$ecbed4cf72cb7095$exports = $ecbed4cf72cb7095$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $379969c01dd444ac$var$baseMatches(source) {
    var matchData = $3311060dce3c45f9$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $ecbed4cf72cb7095$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $024a9cc2ead81e69$exports(object, source, matchData);
    };
}
$379969c01dd444ac$exports = $379969c01dd444ac$var$baseMatches;


var $c1bb0c3800f10289$exports = {};

var $e1334e384c35b942$exports = {};
var $f94ff7100ca4473c$exports = {};


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $f94ff7100ca4473c$var$baseGet(object, path) {
    path = $1145c8db691336e2$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$59b2aef36a4fc0f2$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$f94ff7100ca4473c$exports = $f94ff7100ca4473c$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $e1334e384c35b942$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $f94ff7100ca4473c$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$e1334e384c35b942$exports = $e1334e384c35b942$var$get;


var $66cca81a77fed812$exports = {};
var $2d41e63f2a0dcf12$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $2d41e63f2a0dcf12$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$2d41e63f2a0dcf12$exports = $2d41e63f2a0dcf12$var$baseHasIn;



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $66cca81a77fed812$var$hasIn(object, path) {
    return object != null && $8b743d8f4acec4cf$exports(object, path, $2d41e63f2a0dcf12$exports);
}
$66cca81a77fed812$exports = $66cca81a77fed812$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $c1bb0c3800f10289$var$COMPARE_PARTIAL_FLAG = 1, $c1bb0c3800f10289$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $c1bb0c3800f10289$var$baseMatchesProperty(path, srcValue) {
    if ($8a67694528faa37e$exports(path) && $b2a848581fba85e7$exports(srcValue)) return $ecbed4cf72cb7095$exports($59b2aef36a4fc0f2$exports(path), srcValue);
    return function(object) {
        var objValue = $e1334e384c35b942$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $66cca81a77fed812$exports(object, path) : $b94454686479760d$exports(srcValue, objValue, $c1bb0c3800f10289$var$COMPARE_PARTIAL_FLAG | $c1bb0c3800f10289$var$COMPARE_UNORDERED_FLAG);
    };
}
$c1bb0c3800f10289$exports = $c1bb0c3800f10289$var$baseMatchesProperty;


var $77d6143c55d19f39$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $77d6143c55d19f39$var$identity(value) {
    return value;
}
$77d6143c55d19f39$exports = $77d6143c55d19f39$var$identity;



var $075c1c9567977b48$exports = {};
var $60415afcd1e0727d$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $60415afcd1e0727d$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$60415afcd1e0727d$exports = $60415afcd1e0727d$var$baseProperty;


var $a254a97823e82b0a$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $a254a97823e82b0a$var$basePropertyDeep(path) {
    return function(object) {
        return $f94ff7100ca4473c$exports(object, path);
    };
}
$a254a97823e82b0a$exports = $a254a97823e82b0a$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $075c1c9567977b48$var$property(path) {
    return $8a67694528faa37e$exports(path) ? $60415afcd1e0727d$exports($59b2aef36a4fc0f2$exports(path)) : $a254a97823e82b0a$exports(path);
}
$075c1c9567977b48$exports = $075c1c9567977b48$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $f784bf4d7896d7fa$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $77d6143c55d19f39$exports;
    if (typeof value == 'object') return $2f83ca3523b5b10f$exports(value) ? $c1bb0c3800f10289$exports(value[0], value[1]) : $379969c01dd444ac$exports(value);
    return $075c1c9567977b48$exports(value);
}
$f784bf4d7896d7fa$exports = $f784bf4d7896d7fa$var$baseIteratee;


/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $4c0a59ef68410050$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $f784bf4d7896d7fa$exports(iteratee, 3);
    $810c828ac4dff00f$exports(object, function(value, key, object) {
        $529221a14fcc9889$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$4c0a59ef68410050$exports = $4c0a59ef68410050$var$mapValues;



var $b00ee1b69bbd06ad$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ 'use strict';
function $b00ee1b69bbd06ad$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$b00ee1b69bbd06ad$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$b00ee1b69bbd06ad$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$b00ee1b69bbd06ad$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $b00ee1b69bbd06ad$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $b00ee1b69bbd06ad$var$DIGIT_REGEX = /^\d+$/, $b00ee1b69bbd06ad$var$LEAD_DIGIT_REGEX = /^\d/, $b00ee1b69bbd06ad$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $b00ee1b69bbd06ad$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $b00ee1b69bbd06ad$var$MAX_CACHE_SIZE = 512;
var $b00ee1b69bbd06ad$var$pathCache = new $b00ee1b69bbd06ad$var$Cache($b00ee1b69bbd06ad$var$MAX_CACHE_SIZE), $b00ee1b69bbd06ad$var$setCache = new $b00ee1b69bbd06ad$var$Cache($b00ee1b69bbd06ad$var$MAX_CACHE_SIZE), $b00ee1b69bbd06ad$var$getCache = new $b00ee1b69bbd06ad$var$Cache($b00ee1b69bbd06ad$var$MAX_CACHE_SIZE);
var $b00ee1b69bbd06ad$var$config;
$b00ee1b69bbd06ad$exports = {
    Cache: $b00ee1b69bbd06ad$var$Cache,
    split: $b00ee1b69bbd06ad$var$split,
    normalizePath: $b00ee1b69bbd06ad$var$normalizePath,
    setter: function(path) {
        var parts = $b00ee1b69bbd06ad$var$normalizePath(path);
        return $b00ee1b69bbd06ad$var$setCache.get(path) || $b00ee1b69bbd06ad$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === '__proto__' || part === 'constructor' || part === 'prototype') return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $b00ee1b69bbd06ad$var$normalizePath(path);
        return $b00ee1b69bbd06ad$var$getCache.get(path) || $b00ee1b69bbd06ad$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($b00ee1b69bbd06ad$var$isQuoted(part) || $b00ee1b69bbd06ad$var$DIGIT_REGEX.test(part) ? '[' + part + ']' : (path ? '.' : '') + part);
        }, '');
    },
    forEach: function(path, cb, thisArg) {
        $b00ee1b69bbd06ad$var$forEach(Array.isArray(path) ? path : $b00ee1b69bbd06ad$var$split(path), cb, thisArg);
    }
};
function $b00ee1b69bbd06ad$var$normalizePath(path) {
    return $b00ee1b69bbd06ad$var$pathCache.get(path) || $b00ee1b69bbd06ad$var$pathCache.set(path, $b00ee1b69bbd06ad$var$split(path).map(function(part) {
        return part.replace($b00ee1b69bbd06ad$var$CLEAN_QUOTES_REGEX, '$2');
    }));
}
function $b00ee1b69bbd06ad$var$split(path) {
    return path.match($b00ee1b69bbd06ad$var$SPLIT_REGEX) || [
        ''
    ];
}
function $b00ee1b69bbd06ad$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($b00ee1b69bbd06ad$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $b00ee1b69bbd06ad$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $b00ee1b69bbd06ad$var$isQuoted(str) {
    return typeof str === 'string' && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $b00ee1b69bbd06ad$var$hasLeadingNumber(part) {
    return part.match($b00ee1b69bbd06ad$var$LEAD_DIGIT_REGEX) && !part.match($b00ee1b69bbd06ad$var$DIGIT_REGEX);
}
function $b00ee1b69bbd06ad$var$hasSpecialChars(part) {
    return $b00ee1b69bbd06ad$var$SPEC_CHAR_REGEX.test(part);
}
function $b00ee1b69bbd06ad$var$shouldBeQuoted(part) {
    return !$b00ee1b69bbd06ad$var$isQuoted(part) && ($b00ee1b69bbd06ad$var$hasLeadingNumber(part) || $b00ee1b69bbd06ad$var$hasSpecialChars(part));
}


const $15f814065c3b4dba$var$prefixes = {
    context: '$',
    value: '.'
};
function $15f814065c3b4dba$export$185802fd694ee1f5(key, options) {
    return new $15f814065c3b4dba$export$2e2bcd8739ae039(key, options);
}
class $15f814065c3b4dba$export$2e2bcd8739ae039 {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
        this.key = key.trim();
        if (key === '') throw new TypeError('ref must be a non-empty string');
        this.isContext = this.key[0] === $15f814065c3b4dba$var$prefixes.context;
        this.isValue = this.key[0] === $15f814065c3b4dba$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $15f814065c3b4dba$var$prefixes.context : this.isValue ? $15f814065c3b4dba$var$prefixes.value : '';
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $b00ee1b69bbd06ad$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: 'ref',
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
} // @ts-ignore
$15f814065c3b4dba$export$2e2bcd8739ae039.prototype.__isYupRef = true;


function $6cda561f645239c4$var$_extends() {
    $6cda561f645239c4$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6cda561f645239c4$var$_extends.apply(this, arguments);
}
function $6cda561f645239c4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6cda561f645239c4$export$2e2bcd8739ae039(config) {
    function validate(_ref, cb) {
        let { value: value, path: path = '', label: label, options: options, originalValue: originalValue, sync: sync } = _ref, rest = $6cda561f645239c4$var$_objectWithoutPropertiesLoose(_ref, [
            "value",
            "path",
            "label",
            "options",
            "originalValue",
            "sync"
        ]);
        const { name: name, test: test, params: params, message: message } = config;
        let { parent: parent, context: context } = options;
        function resolve(item) {
            return (0, $15f814065c3b4dba$export$2e2bcd8739ae039).isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = (0, (/*@__PURE__*/$parcel$interopDefault($4c0a59ef68410050$exports)))($6cda561f645239c4$var$_extends({
                value: value,
                originalValue: originalValue,
                label: label,
                path: overrides.path || path
            }, params, overrides.params), resolve);
            const error = new (0, $0d3dd0f474055a4e$export$2e2bcd8739ae039)((0, $0d3dd0f474055a4e$export$2e2bcd8739ae039).formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
            error.params = nextParams;
            return error;
        }
        let ctx = $6cda561f645239c4$var$_extends({
            path: path,
            parent: parent,
            type: name,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue
        }, rest);
        if (!sync) {
            try {
                Promise.resolve(test.call(ctx, value, ctx)).then((validOrError)=>{
                    if ((0, $0d3dd0f474055a4e$export$2e2bcd8739ae039).isError(validOrError)) cb(validOrError);
                    else if (!validOrError) cb(createError());
                    else cb(null, validOrError);
                }).catch(cb);
            } catch (err) {
                cb(err);
            }
            return;
        }
        let result;
        try {
            var _ref2;
            result = test.call(ctx, value, ctx);
            if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === 'function') throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
        } catch (err) {
            cb(err);
            return;
        }
        if ((0, $0d3dd0f474055a4e$export$2e2bcd8739ae039).isError(result)) cb(result);
        else if (!result) cb(createError());
        else cb(null, result);
    }
    validate.OPTIONS = config;
    return validate;
}





let $8e647b5d8f2ec598$var$trim = (part)=>part.substr(0, part.length - 1).substr(1);
function $8e647b5d8f2ec598$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug; // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $b00ee1b69bbd06ad$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? $8e647b5d8f2ec598$var$trim(_part) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        if (schema.innerType) {
            let idx = isArray ? parseInt(part, 10) : 0;
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = schema.innerType;
        } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
const $8e647b5d8f2ec598$var$reach = (obj, path, value, context)=>$8e647b5d8f2ec598$export$c52e5867d5879e24(obj, path, value, context).schema;
var $8e647b5d8f2ec598$export$2e2bcd8739ae039 = $8e647b5d8f2ec598$var$reach;




class $7ae2a6bc39f9b42f$export$2e2bcd8739ae039 {
    constructor(){
        this.list = void 0;
        this.refs = void 0;
        this.list = new Set();
        this.refs = new Map();
    }
    get size() {
        return this.list.size + this.refs.size;
    }
    describe() {
        const description = [];
        for (const item of this.list)description.push(item);
        for (const [, ref] of this.refs)description.push(ref.describe());
        return description;
    }
    toArray() {
        return Array.from(this.list).concat(Array.from(this.refs.values()));
    }
    resolveAll(resolve) {
        return this.toArray().reduce((acc, e)=>acc.concat((0, $15f814065c3b4dba$export$2e2bcd8739ae039).isRef(e) ? resolve(e) : e), []);
    }
    add(value) {
        (0, $15f814065c3b4dba$export$2e2bcd8739ae039).isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
    }
    delete(value) {
        (0, $15f814065c3b4dba$export$2e2bcd8739ae039).isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
    }
    clone() {
        const next = new $7ae2a6bc39f9b42f$export$2e2bcd8739ae039();
        next.list = new Set(this.list);
        next.refs = new Map(this.refs);
        return next;
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.list.forEach((value)=>next.add(value));
        newItems.refs.forEach((value)=>next.add(value));
        removeItems.list.forEach((value)=>next.delete(value));
        removeItems.refs.forEach((value)=>next.delete(value));
        return next;
    }
}



function $fa353aae113a1391$var$_extends() {
    $fa353aae113a1391$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fa353aae113a1391$var$_extends.apply(this, arguments);
}
class $fa353aae113a1391$export$2e2bcd8739ae039 {
    constructor(options){
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this._typeError = void 0;
        this._whitelist = new (0, $7ae2a6bc39f9b42f$export$2e2bcd8739ae039)();
        this._blacklist = new (0, $7ae2a6bc39f9b42f$export$2e2bcd8739ae039)();
        this.exclusiveTests = Object.create(null);
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError((0, $0bc3a5a1f021de70$export$9b30b6294c1449a8).notType);
        });
        this.type = (options == null ? void 0 : options.type) || 'mixed';
        this.spec = $fa353aae113a1391$var$_extends({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            nullable: false,
            presence: 'optional'
        }, options == null ? void 0 : options.spec);
    }
    get _type() {
        return this.type;
    }
    _typeCheck(_value) {
        return true;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        } // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeError = this._typeError;
        next._whitelistError = this._whitelistError;
        next._blacklistError = this._blacklistError;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.exclusiveTests = $fa353aae113a1391$var$_extends({}, this.exclusiveTests); // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = (0, $8816731496aa8698$export$2e2bcd8739ae039)($fa353aae113a1391$var$_extends({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    //   TCast,
    //   TContext,
    //   TOutput
    // > {
    //   return this as any;
    // }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = $fa353aae113a1391$var$_extends({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
        //   mergedSpec.nullable = base.spec.nullable;
        // if (combined.spec.presence === UNSET)
        //   mergedSpec.presence = base.spec.presence;
        combined.spec = mergedSpec;
        combined._typeError || (combined._typeError = base._typeError);
        combined._whitelistError || (combined._whitelistError = base._whitelistError);
        combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (this.spec.nullable && v === null) return true;
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((schema, condition)=>condition.resolve(schema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve($fa353aae113a1391$var$_extends({
            value: value
        }, options));
        let result = resolvedSchema._cast(value, options);
        if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
            let formattedValue = (0, $18c302d8aff04670$export$2e2bcd8739ae039)(value);
            let formattedResult = (0, $18c302d8aff04670$export$2e2bcd8739ae039)(result);
            throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
        }
        return result;
    }
    _cast(rawValue, _options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn)=>fn.call(this, value, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault();
        return value;
    }
    _validate(_value, options = {}, cb) {
        let { sync: sync, path: path, from: from = [], originalValue: originalValue = _value, strict: strict = this.spec.strict, abortEarly: abortEarly = this.spec.abortEarly } = options;
        let value = _value;
        if (!strict) // this._validating = true;
        value = this._cast(value, $fa353aae113a1391$var$_extends({
            assert: false
        }, options)); // this._validating = false;
         // value is cast, we can check if it meets type requirements
        let args = {
            value: value,
            path: path,
            options: options,
            originalValue: originalValue,
            schema: this,
            label: this.spec.label,
            sync: sync,
            from: from
        };
        let initialTests = [];
        if (this._typeError) initialTests.push(this._typeError);
        let finalTests = [];
        if (this._whitelistError) finalTests.push(this._whitelistError);
        if (this._blacklistError) finalTests.push(this._blacklistError);
        (0, $a0ed368902601763$export$2e2bcd8739ae039)({
            args: args,
            value: value,
            path: path,
            sync: sync,
            tests: initialTests,
            endEarly: abortEarly
        }, (err)=>{
            if (err) return void cb(err, value);
            (0, $a0ed368902601763$export$2e2bcd8739ae039)({
                tests: this.tests.concat(finalTests),
                args: args,
                path: path,
                sync: sync,
                value: value,
                endEarly: abortEarly
            }, cb);
        });
    }
    validate(value, options, maybeCb) {
        let schema = this.resolve($fa353aae113a1391$var$_extends({}, options, {
            value: value
        })); // callback case is for nested validations
        return typeof maybeCb === 'function' ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject)=>schema._validate(value, options, (err, value)=>{
                if (err) reject(err);
                else resolve(value);
            }));
    }
    validateSync(value, options) {
        let schema = this.resolve($fa353aae113a1391$var$_extends({}, options, {
            value: value
        }));
        let result;
        schema._validate(value, $fa353aae113a1391$var$_extends({}, options, {
            sync: true
        }), (err, value)=>{
            if (err) throw err;
            result = value;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ((0, $0d3dd0f474055a4e$export$2e2bcd8739ae039).isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ((0, $0d3dd0f474055a4e$export$2e2bcd8739ae039).isError(err)) return false;
            throw err;
        }
    }
    _getDefault() {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === 'function' ? defaultValue.call(this) : (0, $8816731496aa8698$export$2e2bcd8739ae039)(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault();
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        let next = this.clone();
        next.spec.strict = isStrict;
        return next;
    }
    _isPresent(value) {
        return value != null;
    }
    defined(message = (0, $0bc3a5a1f021de70$export$9b30b6294c1449a8).defined) {
        return this.test({
            message: message,
            name: 'defined',
            exclusive: true,
            test (value) {
                return value !== undefined;
            }
        });
    }
    required(message = (0, $0bc3a5a1f021de70$export$9b30b6294c1449a8).required) {
        return this.clone({
            presence: 'required'
        }).withMutation((s)=>s.test({
                message: message,
                name: 'required',
                exclusive: true,
                test (value) {
                    return this.schema._isPresent(value);
                }
            }));
    }
    notRequired() {
        let next = this.clone({
            presence: 'optional'
        });
        next.tests = next.tests.filter((test)=>test.OPTIONS.name !== 'required');
        return next;
    }
    nullable(isNullable = true) {
        let next = this.clone({
            nullable: isNullable !== false
        });
        return next;
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === 'function') opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = (0, $0bc3a5a1f021de70$export$9b30b6294c1449a8).default;
        if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
        let next = this.clone();
        let validate = (0, $6cda561f645239c4$export$2e2bcd8739ae039)(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== 'string') {
            options = keys;
            keys = '.';
        }
        let next = this.clone();
        let deps = (0, $0e925fb057f308b0$export$2e2bcd8739ae039)(keys).map((key)=>new (0, $15f814065c3b4dba$export$2e2bcd8739ae039)(key));
        deps.forEach((dep)=>{
            // @ts-ignore
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(new (0, $1a05d4aadec864bb$export$2e2bcd8739ae039)(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next._typeError = (0, $6cda561f645239c4$export$2e2bcd8739ae039)({
            message: message,
            name: 'typeError',
            test (value) {
                if (value !== undefined && !this.schema.isType(value)) return this.createError({
                    params: {
                        type: this.schema._type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = (0, $0bc3a5a1f021de70$export$9b30b6294c1449a8).oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next._whitelistError = (0, $6cda561f645239c4$export$2e2bcd8739ae039)({
            message: message,
            name: 'oneOf',
            test (value) {
                if (value === undefined) return true;
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: valids.toArray().join(', '),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = (0, $0bc3a5a1f021de70$export$9b30b6294c1449a8).notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next._blacklistError = (0, $6cda561f645239c4$export$2e2bcd8739ae039)({
            message: message,
            name: 'notOneOf',
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: invalids.toArray().join(', '),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    describe() {
        const next = this.clone();
        const { label: label, meta: meta } = next.spec;
        const description = {
            meta: meta,
            label: label,
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
} // eslint-disable-next-line @typescript-eslint/no-unused-vars
// @ts-expect-error
$fa353aae113a1391$export$2e2bcd8739ae039.prototype.__isYupSchema__ = true;
for (const method of [
    'validate',
    'validateSync'
])$fa353aae113a1391$export$2e2bcd8739ae039.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = (0, $8e647b5d8f2ec598$export$c52e5867d5879e24)(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], $fa353aae113a1391$var$_extends({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    'equals',
    'is'
])$fa353aae113a1391$export$2e2bcd8739ae039.prototype[alias] = $fa353aae113a1391$export$2e2bcd8739ae039.prototype.oneOf;
for (const alias of [
    'not',
    'nope'
])$fa353aae113a1391$export$2e2bcd8739ae039.prototype[alias] = $fa353aae113a1391$export$2e2bcd8739ae039.prototype.notOneOf;
$fa353aae113a1391$export$2e2bcd8739ae039.prototype.optional = $fa353aae113a1391$export$2e2bcd8739ae039.prototype.notRequired;


const $c9d5b2bb2dfabd74$var$Mixed = (0, $fa353aae113a1391$export$2e2bcd8739ae039);
var $c9d5b2bb2dfabd74$export$2e2bcd8739ae039 = $c9d5b2bb2dfabd74$var$Mixed;
function $c9d5b2bb2dfabd74$export$185802fd694ee1f5() {
    return new $c9d5b2bb2dfabd74$var$Mixed();
} // XXX: this is using the Base schema so that `addMethod(mixed)` works as a base class
$c9d5b2bb2dfabd74$export$185802fd694ee1f5.prototype = $c9d5b2bb2dfabd74$var$Mixed.prototype;




const $1740bf431856338f$var$isAbsent = (value)=>value == null;
var $1740bf431856338f$export$2e2bcd8739ae039 = $1740bf431856338f$var$isAbsent;


function $8faac65507a642e4$export$185802fd694ee1f5() {
    return new $8faac65507a642e4$export$2e2bcd8739ae039();
}
class $8faac65507a642e4$export$2e2bcd8739ae039 extends (0, $fa353aae113a1391$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: 'boolean'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (!this.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    _typeCheck(v) {
        if (v instanceof Boolean) v = v.valueOf();
        return typeof v === 'boolean';
    }
    isTrue(message = (0, $0bc3a5a1f021de70$export$4a21f16c33752377).isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'true'
            },
            test (value) {
                return (0, $1740bf431856338f$export$2e2bcd8739ae039)(value) || value === true;
            }
        });
    }
    isFalse(message = (0, $0bc3a5a1f021de70$export$4a21f16c33752377).isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'false'
            },
            test (value) {
                return (0, $1740bf431856338f$export$2e2bcd8739ae039)(value) || value === false;
            }
        });
    }
}
$8faac65507a642e4$export$185802fd694ee1f5.prototype = $8faac65507a642e4$export$2e2bcd8739ae039.prototype;





let $55fd6d44ba3611c9$var$rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line
let $55fd6d44ba3611c9$var$rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line
let $55fd6d44ba3611c9$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $55fd6d44ba3611c9$var$isTrimmed = (value)=>(0, $1740bf431856338f$export$2e2bcd8739ae039)(value) || value === value.trim();
let $55fd6d44ba3611c9$var$objStringTag = ({}).toString();
function $55fd6d44ba3611c9$export$185802fd694ee1f5() {
    return new $55fd6d44ba3611c9$export$2e2bcd8739ae039();
}
class $55fd6d44ba3611c9$export$2e2bcd8739ae039 extends (0, $fa353aae113a1391$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: 'string'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                if (strValue === $55fd6d44ba3611c9$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof String) value = value.valueOf();
        return typeof value === 'string';
    }
    _isPresent(value) {
        return super._isPresent(value) && !!value.length;
    }
    length(length, message = (0, $0bc3a5a1f021de70$export$22b082955e083ec3).length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $1740bf431856338f$export$2e2bcd8739ae039)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message = (0, $0bc3a5a1f021de70$export$22b082955e083ec3).min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $1740bf431856338f$export$2e2bcd8739ae039)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $0bc3a5a1f021de70$export$22b082955e083ec3).max) {
        return this.test({
            name: 'max',
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            test (value) {
                return (0, $1740bf431856338f$export$2e2bcd8739ae039)(value) || value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === 'object') ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || 'matches',
            message: message || (0, $0bc3a5a1f021de70$export$22b082955e083ec3).matches,
            params: {
                regex: regex
            },
            test: (value)=>(0, $1740bf431856338f$export$2e2bcd8739ae039)(value) || value === '' && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = (0, $0bc3a5a1f021de70$export$22b082955e083ec3).email) {
        return this.matches($55fd6d44ba3611c9$var$rEmail, {
            name: 'email',
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = (0, $0bc3a5a1f021de70$export$22b082955e083ec3).url) {
        return this.matches($55fd6d44ba3611c9$var$rUrl, {
            name: 'url',
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = (0, $0bc3a5a1f021de70$export$22b082955e083ec3).uuid) {
        return this.matches($55fd6d44ba3611c9$var$rUUID, {
            name: 'uuid',
            message: message,
            excludeEmptyString: false
        });
    }
    ensure() {
        return this.default('').transform((val)=>val === null ? '' : val);
    }
    trim(message = (0, $0bc3a5a1f021de70$export$22b082955e083ec3).trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: 'trim',
            test: $55fd6d44ba3611c9$var$isTrimmed
        });
    }
    lowercase(message = (0, $0bc3a5a1f021de70$export$22b082955e083ec3).lowercase) {
        return this.transform((value)=>!(0, $1740bf431856338f$export$2e2bcd8739ae039)(value) ? value.toLowerCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            test: (value)=>(0, $1740bf431856338f$export$2e2bcd8739ae039)(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = (0, $0bc3a5a1f021de70$export$22b082955e083ec3).uppercase) {
        return this.transform((value)=>!(0, $1740bf431856338f$export$2e2bcd8739ae039)(value) ? value.toUpperCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            test: (value)=>(0, $1740bf431856338f$export$2e2bcd8739ae039)(value) || value === value.toUpperCase()
        });
    }
}
$55fd6d44ba3611c9$export$185802fd694ee1f5.prototype = $55fd6d44ba3611c9$export$2e2bcd8739ae039.prototype; //
 // String Interfaces
 //





let $111b61f80e1de09e$var$isNaN = (value)=>value != +value;
function $111b61f80e1de09e$export$185802fd694ee1f5() {
    return new $111b61f80e1de09e$export$2e2bcd8739ae039();
}
class $111b61f80e1de09e$export$2e2bcd8739ae039 extends (0, $fa353aae113a1391$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: 'number'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                let parsed = value;
                if (typeof parsed === 'string') {
                    parsed = parsed.replace(/\s/g, '');
                    if (parsed === '') return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                if (this.isType(parsed)) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof Number) value = value.valueOf();
        return typeof value === 'number' && !$111b61f80e1de09e$var$isNaN(value);
    }
    min(min, message = (0, $0bc3a5a1f021de70$export$98e628dec113755e).min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $1740bf431856338f$export$2e2bcd8739ae039)(value) || value >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $0bc3a5a1f021de70$export$98e628dec113755e).max) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $1740bf431856338f$export$2e2bcd8739ae039)(value) || value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = (0, $0bc3a5a1f021de70$export$98e628dec113755e).lessThan) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                less: less
            },
            test (value) {
                return (0, $1740bf431856338f$export$2e2bcd8739ae039)(value) || value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = (0, $0bc3a5a1f021de70$export$98e628dec113755e).moreThan) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                more: more
            },
            test (value) {
                return (0, $1740bf431856338f$export$2e2bcd8739ae039)(value) || value > this.resolve(more);
            }
        });
    }
    positive(msg = (0, $0bc3a5a1f021de70$export$98e628dec113755e).positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = (0, $0bc3a5a1f021de70$export$98e628dec113755e).negative) {
        return this.lessThan(0, msg);
    }
    integer(message = (0, $0bc3a5a1f021de70$export$98e628dec113755e).integer) {
        return this.test({
            name: 'integer',
            message: message,
            test: (val)=>(0, $1740bf431856338f$export$2e2bcd8739ae039)(val) || Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!(0, $1740bf431856338f$export$2e2bcd8739ae039)(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            'ceil',
            'floor',
            'round',
            'trunc'
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round'; // this exists for symemtry with the new Math.trunc
        if (method === 'trunc') return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
        return this.transform((value)=>!(0, $1740bf431856338f$export$2e2bcd8739ae039)(value) ? Math[method](value) : value);
    }
}
$111b61f80e1de09e$export$185802fd694ee1f5.prototype = $111b61f80e1de09e$export$2e2bcd8739ae039.prototype; //
 // Number Interfaces
 //


// @ts-ignore
/* eslint-disable */ /**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ //              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var $348dde2b0a69ec02$var$isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $348dde2b0a69ec02$export$2e2bcd8739ae039(date) {
    var numericKeys = [
        1,
        4,
        5,
        6,
        7,
        10,
        11
    ], minutesOffset = 0, timestamp, struct;
    if (struct = $348dde2b0a69ec02$var$isoReg.exec(date)) {
        // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
        for(var i = 0, k; k = numericKeys[i]; ++i)struct[k] = +struct[k] || 0; // allow undefined days and months
        struct[2] = (+struct[2] || 1) - 1;
        struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds
        struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time
        if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);
        else {
            if (struct[8] !== 'Z' && struct[9] !== undefined) {
                minutesOffset = struct[10] * 60 + struct[11];
                if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
            }
            timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
        }
    } else timestamp = Date.parse ? Date.parse(date) : NaN;
    return timestamp;
}






let $281b66c8decd15c7$var$invalidDate = new Date('');
let $281b66c8decd15c7$var$isDate = (obj)=>Object.prototype.toString.call(obj) === '[object Date]';
function $281b66c8decd15c7$export$185802fd694ee1f5() {
    return new $281b66c8decd15c7$export$2e2bcd8739ae039();
}
class $281b66c8decd15c7$export$2e2bcd8739ae039 extends (0, $fa353aae113a1391$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: 'date'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                value = (0, $348dde2b0a69ec02$export$2e2bcd8739ae039)(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $281b66c8decd15c7$var$invalidDate;
            });
        });
    }
    _typeCheck(v) {
        return $281b66c8decd15c7$var$isDate(v) && !isNaN(v.getTime());
    }
    prepareParam(ref, name) {
        let param;
        if (!(0, $15f814065c3b4dba$export$2e2bcd8739ae039).isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = (0, $0bc3a5a1f021de70$export$324d90190a8b822a).min) {
        let limit = this.prepareParam(min, 'min');
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $1740bf431856338f$export$2e2bcd8739ae039)(value) || value >= this.resolve(limit);
            }
        });
    }
    max(max, message = (0, $0bc3a5a1f021de70$export$324d90190a8b822a).max) {
        let limit = this.prepareParam(max, 'max');
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $1740bf431856338f$export$2e2bcd8739ae039)(value) || value <= this.resolve(limit);
            }
        });
    }
}
$281b66c8decd15c7$export$2e2bcd8739ae039.INVALID_DATE = $281b66c8decd15c7$var$invalidDate;
$281b66c8decd15c7$export$185802fd694ee1f5.prototype = $281b66c8decd15c7$export$2e2bcd8739ae039.prototype;
$281b66c8decd15c7$export$185802fd694ee1f5.INVALID_DATE = $281b66c8decd15c7$var$invalidDate;



var $7b46fefcd4cc0950$exports = {};
var $30cfefa687ef8dc0$exports = {};
var $bb905e7059f4e034$exports = {};
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $bb905e7059f4e034$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
$bb905e7059f4e034$exports = $bb905e7059f4e034$var$arrayReduce;


var $ec9505e4c6c3896a$exports = {};
var $8190c5a99ee4857f$exports = {};
var $afc29834b486c5db$exports = {};
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $afc29834b486c5db$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
$afc29834b486c5db$exports = $afc29834b486c5db$var$basePropertyOf;


/** Used to map Latin Unicode letters to basic Latin letters. */ var $8190c5a99ee4857f$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $8190c5a99ee4857f$var$deburrLetter = $afc29834b486c5db$exports($8190c5a99ee4857f$var$deburredLetters);
$8190c5a99ee4857f$exports = $8190c5a99ee4857f$var$deburrLetter;



/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $ec9505e4c6c3896a$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $ec9505e4c6c3896a$var$rsComboMarksRange = '\\u0300-\\u036f', $ec9505e4c6c3896a$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $ec9505e4c6c3896a$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $ec9505e4c6c3896a$var$rsComboRange = $ec9505e4c6c3896a$var$rsComboMarksRange + $ec9505e4c6c3896a$var$reComboHalfMarksRange + $ec9505e4c6c3896a$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $ec9505e4c6c3896a$var$rsCombo = '[' + $ec9505e4c6c3896a$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $ec9505e4c6c3896a$var$reComboMark = RegExp($ec9505e4c6c3896a$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $ec9505e4c6c3896a$var$deburr(string) {
    string = $56ae5a8092ddcc58$exports(string);
    return string && string.replace($ec9505e4c6c3896a$var$reLatin, $8190c5a99ee4857f$exports).replace($ec9505e4c6c3896a$var$reComboMark, '');
}
$ec9505e4c6c3896a$exports = $ec9505e4c6c3896a$var$deburr;


var $c72ae312c2cd9a41$exports = {};
var $b8a2fc2b57d0777b$exports = {};
/** Used to match words composed of alphanumeric characters. */ var $b8a2fc2b57d0777b$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $b8a2fc2b57d0777b$var$asciiWords(string) {
    return string.match($b8a2fc2b57d0777b$var$reAsciiWord) || [];
}
$b8a2fc2b57d0777b$exports = $b8a2fc2b57d0777b$var$asciiWords;


var $63e45877c95520c3$exports = {};
/** Used to detect strings that need a more robust regexp to match words. */ var $63e45877c95520c3$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $63e45877c95520c3$var$hasUnicodeWord(string) {
    return $63e45877c95520c3$var$reHasUnicodeWord.test(string);
}
$63e45877c95520c3$exports = $63e45877c95520c3$var$hasUnicodeWord;



var $9fd8e25343c60ac5$exports = {};
/** Used to compose unicode character classes. */ var $9fd8e25343c60ac5$var$rsAstralRange = '\\ud800-\\udfff', $9fd8e25343c60ac5$var$rsComboMarksRange = '\\u0300-\\u036f', $9fd8e25343c60ac5$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $9fd8e25343c60ac5$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $9fd8e25343c60ac5$var$rsComboRange = $9fd8e25343c60ac5$var$rsComboMarksRange + $9fd8e25343c60ac5$var$reComboHalfMarksRange + $9fd8e25343c60ac5$var$rsComboSymbolsRange, $9fd8e25343c60ac5$var$rsDingbatRange = '\\u2700-\\u27bf', $9fd8e25343c60ac5$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $9fd8e25343c60ac5$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $9fd8e25343c60ac5$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $9fd8e25343c60ac5$var$rsPunctuationRange = '\\u2000-\\u206f', $9fd8e25343c60ac5$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $9fd8e25343c60ac5$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $9fd8e25343c60ac5$var$rsVarRange = '\\ufe0e\\ufe0f', $9fd8e25343c60ac5$var$rsBreakRange = $9fd8e25343c60ac5$var$rsMathOpRange + $9fd8e25343c60ac5$var$rsNonCharRange + $9fd8e25343c60ac5$var$rsPunctuationRange + $9fd8e25343c60ac5$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $9fd8e25343c60ac5$var$rsApos = "['\u2019]", $9fd8e25343c60ac5$var$rsBreak = '[' + $9fd8e25343c60ac5$var$rsBreakRange + ']', $9fd8e25343c60ac5$var$rsCombo = '[' + $9fd8e25343c60ac5$var$rsComboRange + ']', $9fd8e25343c60ac5$var$rsDigits = '\\d+', $9fd8e25343c60ac5$var$rsDingbat = '[' + $9fd8e25343c60ac5$var$rsDingbatRange + ']', $9fd8e25343c60ac5$var$rsLower = '[' + $9fd8e25343c60ac5$var$rsLowerRange + ']', $9fd8e25343c60ac5$var$rsMisc = '[^' + $9fd8e25343c60ac5$var$rsAstralRange + $9fd8e25343c60ac5$var$rsBreakRange + $9fd8e25343c60ac5$var$rsDigits + $9fd8e25343c60ac5$var$rsDingbatRange + $9fd8e25343c60ac5$var$rsLowerRange + $9fd8e25343c60ac5$var$rsUpperRange + ']', $9fd8e25343c60ac5$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $9fd8e25343c60ac5$var$rsModifier = '(?:' + $9fd8e25343c60ac5$var$rsCombo + '|' + $9fd8e25343c60ac5$var$rsFitz + ')', $9fd8e25343c60ac5$var$rsNonAstral = '[^' + $9fd8e25343c60ac5$var$rsAstralRange + ']', $9fd8e25343c60ac5$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $9fd8e25343c60ac5$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $9fd8e25343c60ac5$var$rsUpper = '[' + $9fd8e25343c60ac5$var$rsUpperRange + ']', $9fd8e25343c60ac5$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $9fd8e25343c60ac5$var$rsMiscLower = '(?:' + $9fd8e25343c60ac5$var$rsLower + '|' + $9fd8e25343c60ac5$var$rsMisc + ')', $9fd8e25343c60ac5$var$rsMiscUpper = '(?:' + $9fd8e25343c60ac5$var$rsUpper + '|' + $9fd8e25343c60ac5$var$rsMisc + ')', $9fd8e25343c60ac5$var$rsOptContrLower = '(?:' + $9fd8e25343c60ac5$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $9fd8e25343c60ac5$var$rsOptContrUpper = '(?:' + $9fd8e25343c60ac5$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $9fd8e25343c60ac5$var$reOptMod = $9fd8e25343c60ac5$var$rsModifier + '?', $9fd8e25343c60ac5$var$rsOptVar = '[' + $9fd8e25343c60ac5$var$rsVarRange + ']?', $9fd8e25343c60ac5$var$rsOptJoin = '(?:' + $9fd8e25343c60ac5$var$rsZWJ + '(?:' + [
    $9fd8e25343c60ac5$var$rsNonAstral,
    $9fd8e25343c60ac5$var$rsRegional,
    $9fd8e25343c60ac5$var$rsSurrPair
].join('|') + ')' + $9fd8e25343c60ac5$var$rsOptVar + $9fd8e25343c60ac5$var$reOptMod + ')*', $9fd8e25343c60ac5$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $9fd8e25343c60ac5$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $9fd8e25343c60ac5$var$rsSeq = $9fd8e25343c60ac5$var$rsOptVar + $9fd8e25343c60ac5$var$reOptMod + $9fd8e25343c60ac5$var$rsOptJoin, $9fd8e25343c60ac5$var$rsEmoji = '(?:' + [
    $9fd8e25343c60ac5$var$rsDingbat,
    $9fd8e25343c60ac5$var$rsRegional,
    $9fd8e25343c60ac5$var$rsSurrPair
].join('|') + ')' + $9fd8e25343c60ac5$var$rsSeq;
/** Used to match complex or compound words. */ var $9fd8e25343c60ac5$var$reUnicodeWord = RegExp([
    $9fd8e25343c60ac5$var$rsUpper + '?' + $9fd8e25343c60ac5$var$rsLower + '+' + $9fd8e25343c60ac5$var$rsOptContrLower + '(?=' + [
        $9fd8e25343c60ac5$var$rsBreak,
        $9fd8e25343c60ac5$var$rsUpper,
        '$'
    ].join('|') + ')',
    $9fd8e25343c60ac5$var$rsMiscUpper + '+' + $9fd8e25343c60ac5$var$rsOptContrUpper + '(?=' + [
        $9fd8e25343c60ac5$var$rsBreak,
        $9fd8e25343c60ac5$var$rsUpper + $9fd8e25343c60ac5$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $9fd8e25343c60ac5$var$rsUpper + '?' + $9fd8e25343c60ac5$var$rsMiscLower + '+' + $9fd8e25343c60ac5$var$rsOptContrLower,
    $9fd8e25343c60ac5$var$rsUpper + '+' + $9fd8e25343c60ac5$var$rsOptContrUpper,
    $9fd8e25343c60ac5$var$rsOrdUpper,
    $9fd8e25343c60ac5$var$rsOrdLower,
    $9fd8e25343c60ac5$var$rsDigits,
    $9fd8e25343c60ac5$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $9fd8e25343c60ac5$var$unicodeWords(string) {
    return string.match($9fd8e25343c60ac5$var$reUnicodeWord) || [];
}
$9fd8e25343c60ac5$exports = $9fd8e25343c60ac5$var$unicodeWords;


/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $c72ae312c2cd9a41$var$words(string, pattern, guard) {
    string = $56ae5a8092ddcc58$exports(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $63e45877c95520c3$exports(string) ? $9fd8e25343c60ac5$exports(string) : $b8a2fc2b57d0777b$exports(string);
    return string.match(pattern) || [];
}
$c72ae312c2cd9a41$exports = $c72ae312c2cd9a41$var$words;


/** Used to compose unicode capture groups. */ var $30cfefa687ef8dc0$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $30cfefa687ef8dc0$var$reApos = RegExp($30cfefa687ef8dc0$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $30cfefa687ef8dc0$var$createCompounder(callback) {
    return function(string) {
        return $bb905e7059f4e034$exports($c72ae312c2cd9a41$exports($ec9505e4c6c3896a$exports(string).replace($30cfefa687ef8dc0$var$reApos, '')), callback, '');
    };
}
$30cfefa687ef8dc0$exports = $30cfefa687ef8dc0$var$createCompounder;


/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */ var $7b46fefcd4cc0950$var$snakeCase = $30cfefa687ef8dc0$exports(function(result, word, index) {
    return result + (index ? '_' : '') + word.toLowerCase();
});
$7b46fefcd4cc0950$exports = $7b46fefcd4cc0950$var$snakeCase;


var $f7197d9e4b641a79$exports = {};
var $4637b8881c38fa3a$exports = {};

var $5e166af4e6299fc5$exports = {};
var $de55ed0b728b41dd$exports = {};
var $bd37ee2a6283a10c$exports = {};
var $acab0851a14f6438$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $acab0851a14f6438$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$acab0851a14f6438$exports = $acab0851a14f6438$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $bd37ee2a6283a10c$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $acab0851a14f6438$exports(array, start, end);
}
$bd37ee2a6283a10c$exports = $bd37ee2a6283a10c$var$castSlice;


var $0854a9e05beb58cb$exports = {};
/** Used to compose unicode character classes. */ var $0854a9e05beb58cb$var$rsAstralRange = '\\ud800-\\udfff', $0854a9e05beb58cb$var$rsComboMarksRange = '\\u0300-\\u036f', $0854a9e05beb58cb$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $0854a9e05beb58cb$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $0854a9e05beb58cb$var$rsComboRange = $0854a9e05beb58cb$var$rsComboMarksRange + $0854a9e05beb58cb$var$reComboHalfMarksRange + $0854a9e05beb58cb$var$rsComboSymbolsRange, $0854a9e05beb58cb$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $0854a9e05beb58cb$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $0854a9e05beb58cb$var$reHasUnicode = RegExp('[' + $0854a9e05beb58cb$var$rsZWJ + $0854a9e05beb58cb$var$rsAstralRange + $0854a9e05beb58cb$var$rsComboRange + $0854a9e05beb58cb$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $0854a9e05beb58cb$var$hasUnicode(string) {
    return $0854a9e05beb58cb$var$reHasUnicode.test(string);
}
$0854a9e05beb58cb$exports = $0854a9e05beb58cb$var$hasUnicode;


var $d093f51e8c2ba42a$exports = {};
var $76d3d77e8c514eef$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $76d3d77e8c514eef$var$asciiToArray(string) {
    return string.split('');
}
$76d3d77e8c514eef$exports = $76d3d77e8c514eef$var$asciiToArray;



var $1231b3ca959687fc$exports = {};
/** Used to compose unicode character classes. */ var $1231b3ca959687fc$var$rsAstralRange = '\\ud800-\\udfff', $1231b3ca959687fc$var$rsComboMarksRange = '\\u0300-\\u036f', $1231b3ca959687fc$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $1231b3ca959687fc$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $1231b3ca959687fc$var$rsComboRange = $1231b3ca959687fc$var$rsComboMarksRange + $1231b3ca959687fc$var$reComboHalfMarksRange + $1231b3ca959687fc$var$rsComboSymbolsRange, $1231b3ca959687fc$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $1231b3ca959687fc$var$rsAstral = '[' + $1231b3ca959687fc$var$rsAstralRange + ']', $1231b3ca959687fc$var$rsCombo = '[' + $1231b3ca959687fc$var$rsComboRange + ']', $1231b3ca959687fc$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $1231b3ca959687fc$var$rsModifier = '(?:' + $1231b3ca959687fc$var$rsCombo + '|' + $1231b3ca959687fc$var$rsFitz + ')', $1231b3ca959687fc$var$rsNonAstral = '[^' + $1231b3ca959687fc$var$rsAstralRange + ']', $1231b3ca959687fc$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $1231b3ca959687fc$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $1231b3ca959687fc$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $1231b3ca959687fc$var$reOptMod = $1231b3ca959687fc$var$rsModifier + '?', $1231b3ca959687fc$var$rsOptVar = '[' + $1231b3ca959687fc$var$rsVarRange + ']?', $1231b3ca959687fc$var$rsOptJoin = '(?:' + $1231b3ca959687fc$var$rsZWJ + '(?:' + [
    $1231b3ca959687fc$var$rsNonAstral,
    $1231b3ca959687fc$var$rsRegional,
    $1231b3ca959687fc$var$rsSurrPair
].join('|') + ')' + $1231b3ca959687fc$var$rsOptVar + $1231b3ca959687fc$var$reOptMod + ')*', $1231b3ca959687fc$var$rsSeq = $1231b3ca959687fc$var$rsOptVar + $1231b3ca959687fc$var$reOptMod + $1231b3ca959687fc$var$rsOptJoin, $1231b3ca959687fc$var$rsSymbol = '(?:' + [
    $1231b3ca959687fc$var$rsNonAstral + $1231b3ca959687fc$var$rsCombo + '?',
    $1231b3ca959687fc$var$rsCombo,
    $1231b3ca959687fc$var$rsRegional,
    $1231b3ca959687fc$var$rsSurrPair,
    $1231b3ca959687fc$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $1231b3ca959687fc$var$reUnicode = RegExp($1231b3ca959687fc$var$rsFitz + '(?=' + $1231b3ca959687fc$var$rsFitz + ')|' + $1231b3ca959687fc$var$rsSymbol + $1231b3ca959687fc$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $1231b3ca959687fc$var$unicodeToArray(string) {
    return string.match($1231b3ca959687fc$var$reUnicode) || [];
}
$1231b3ca959687fc$exports = $1231b3ca959687fc$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $d093f51e8c2ba42a$var$stringToArray(string) {
    return $0854a9e05beb58cb$exports(string) ? $1231b3ca959687fc$exports(string) : $76d3d77e8c514eef$exports(string);
}
$d093f51e8c2ba42a$exports = $d093f51e8c2ba42a$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $de55ed0b728b41dd$var$createCaseFirst(methodName) {
    return function(string) {
        string = $56ae5a8092ddcc58$exports(string);
        var strSymbols = $0854a9e05beb58cb$exports(string) ? $d093f51e8c2ba42a$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $bd37ee2a6283a10c$exports(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$de55ed0b728b41dd$exports = $de55ed0b728b41dd$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $5e166af4e6299fc5$var$upperFirst = $de55ed0b728b41dd$exports('toUpperCase');
$5e166af4e6299fc5$exports = $5e166af4e6299fc5$var$upperFirst;


/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $4637b8881c38fa3a$var$capitalize(string) {
    return $5e166af4e6299fc5$exports($56ae5a8092ddcc58$exports(string).toLowerCase());
}
$4637b8881c38fa3a$exports = $4637b8881c38fa3a$var$capitalize;



/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $f7197d9e4b641a79$var$camelCase = $30cfefa687ef8dc0$exports(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $4637b8881c38fa3a$exports(word) : word);
});
$f7197d9e4b641a79$exports = $f7197d9e4b641a79$var$camelCase;


var $53b0aa1f4126b9a2$exports = {};



/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $53b0aa1f4126b9a2$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $f784bf4d7896d7fa$exports(iteratee, 3);
    $810c828ac4dff00f$exports(object, function(value, key, object) {
        $529221a14fcc9889$exports(result, iteratee(value, key, object), value);
    });
    return result;
}
$53b0aa1f4126b9a2$exports = $53b0aa1f4126b9a2$var$mapKeys;






var $037e3b3b61940898$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $037e3b3b61940898$exports = function(edges) {
    return $037e3b3b61940898$var$toposort($037e3b3b61940898$var$uniqueNodes(edges), edges);
};
$037e3b3b61940898$exports.array = $037e3b3b61940898$var$toposort;
function $037e3b3b61940898$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $037e3b3b61940898$var$makeOutgoingEdges(edges), nodesHash = $037e3b3b61940898$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error('Unknown node. There is an unknown node in the supplied edges.');
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error('Cyclic dependency' + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: ' + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $037e3b3b61940898$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $037e3b3b61940898$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $037e3b3b61940898$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}





function $ca337773b575ec4c$export$2e2bcd8739ae039(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $b00ee1b69bbd06ad$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for(const key in fields)if ((0, (/*@__PURE__*/$parcel$interopDefault($cbcd9980dbc5c87e$exports)))(fields, key)) {
        let value = fields[key];
        nodes.add(key);
        if ((0, $15f814065c3b4dba$export$2e2bcd8739ae039).isRef(value) && value.isSibling) addNode(value.path, key);
        else if ((0, $521ce2c1367ddf6a$export$2e2bcd8739ae039)(value) && 'deps' in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($037e3b3b61940898$exports))).array(Array.from(nodes), edges).reverse();
}


function $87917d5c95010188$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $87917d5c95010188$export$2e2bcd8739ae039(keys) {
    return (a, b)=>{
        return $87917d5c95010188$var$findIndex(keys, a) - $87917d5c95010188$var$findIndex(keys, b);
    };
}





function $e6c1ba40263f5002$var$_extends() {
    $e6c1ba40263f5002$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e6c1ba40263f5002$var$_extends.apply(this, arguments);
}
let $e6c1ba40263f5002$var$isObject = (obj)=>Object.prototype.toString.call(obj) === '[object Object]';
function $e6c1ba40263f5002$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $e6c1ba40263f5002$var$defaultSort = (0, $87917d5c95010188$export$2e2bcd8739ae039)([]);
class $e6c1ba40263f5002$export$2e2bcd8739ae039 extends (0, $fa353aae113a1391$export$2e2bcd8739ae039) {
    constructor(spec){
        super({
            type: 'object'
        });
        this.fields = Object.create(null);
        this._sortErrors = $e6c1ba40263f5002$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            this.transform(function coerce(value) {
                if (typeof value === 'string') try {
                    value = JSON.parse(value);
                } catch (err) {
                    value = null;
                }
                if (this.isType(value)) return value;
                return null;
            });
            if (spec) this.shape(spec);
        });
    }
    _typeCheck(value) {
        return $e6c1ba40263f5002$var$isObject(value) || typeof value === 'function';
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options); //should ignore nulls here
        if (value === undefined) return this.getDefault();
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = this._nodes.concat(Object.keys(value).filter((v)=>this._nodes.indexOf(v) === -1));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = $e6c1ba40263f5002$var$_extends({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = (0, (/*@__PURE__*/$parcel$interopDefault($cbcd9980dbc5c87e$exports)))(value, prop);
            if (field) {
                let fieldValue;
                let inputValue = value[prop]; // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : '') + prop; // innerOptions.value = value[prop];
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = 'spec' in field ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec == null ? void 0 : fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, opts = {}, callback) {
        let errors = [];
        let { sync: sync, from: from = [], originalValue: originalValue = _value, abortEarly: abortEarly = this.spec.abortEarly, recursive: recursive = this.spec.recursive } = opts;
        from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ]; // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        opts.__validating = true;
        opts.originalValue = originalValue;
        opts.from = from;
        super._validate(_value, opts, (err, value)=>{
            if (err) {
                if (!(0, $0d3dd0f474055a4e$export$2e2bcd8739ae039).isError(err) || abortEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !$e6c1ba40263f5002$var$isObject(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = this._nodes.map((key)=>(_, cb)=>{
                    let path = key.indexOf('.') === -1 ? (opts.path ? `${opts.path}.` : '') + key : `${opts.path || ''}["${key}"]`;
                    let field = this.fields[key];
                    if (field && 'validate' in field) {
                        field.validate(value[key], $e6c1ba40263f5002$var$_extends({}, opts, {
                            path: // @ts-ignore
                            path,
                            from: from,
                            // inner fields are always strict:
                            // 1. this isn't strict so the casting will also have cast inner values
                            // 2. this is strict in which case the nested values weren't cast either
                            strict: true,
                            parent: value,
                            originalValue: originalValue[key]
                        }), cb);
                        return;
                    }
                    cb(null);
                });
            (0, $a0ed368902601763$export$2e2bcd8739ae039)({
                sync: sync,
                tests: tests,
                value: value,
                errors: errors,
                endEarly: abortEarly,
                sort: this._sortErrors,
                path: opts.path
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = $e6c1ba40263f5002$var$_extends({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            if (target === undefined) nextFields[field] = schemaOrRef;
            else if (target instanceof (0, $fa353aae113a1391$export$2e2bcd8739ae039) && schemaOrRef instanceof (0, $fa353aae113a1391$export$2e2bcd8739ae039)) nextFields[field] = schemaOrRef.concat(target);
        }
        return next.withMutation(()=>next.shape(nextFields, this._excludedEdges));
    }
    getDefaultFromShape() {
        let dft = {};
        this._nodes.forEach((key)=>{
            const field = this.fields[key];
            dft[key] = 'default' in field ? field.getDefault() : undefined;
        });
        return dft;
    }
    _getDefault() {
        if ('default' in this.spec) return super._getDefault();
         // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        return this.getDefaultFromShape();
    }
    shape(additions, excludes = []) {
        let next = this.clone();
        let fields = Object.assign(next.fields, additions);
        next.fields = fields;
        next._sortErrors = (0, $87917d5c95010188$export$2e2bcd8739ae039)(Object.keys(fields));
        if (excludes.length) {
            // this is a convenience for when users only supply a single pair
            if (!Array.isArray(excludes[0])) excludes = [
                excludes
            ];
            next._excludedEdges = [
                ...next._excludedEdges,
                ...excludes
            ];
        }
        next._nodes = (0, $ca337773b575ec4c$export$2e2bcd8739ae039)(fields, next._excludedEdges);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.clone().withMutation((next)=>{
            next.fields = {};
            return next.shape(picked);
        });
    }
    omit(keys) {
        const next = this.clone();
        const fields = next.fields;
        next.fields = {};
        for (const key of keys)delete fields[key];
        return next.withMutation(()=>next.shape(fields));
    }
    from(from, to, alias) {
        let fromGetter = (0, $b00ee1b69bbd06ad$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (obj == null) return obj;
            let newObj = obj;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($cbcd9980dbc5c87e$exports)))(obj, from)) {
                newObj = $e6c1ba40263f5002$var$_extends({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    noUnknown(noAllow = true, message = (0, $0bc3a5a1f021de70$export$be5493f9613cbbe).noUnknown) {
        if (typeof noAllow === 'string') {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: 'noUnknown',
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $e6c1ba40263f5002$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(', ')
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = (0, $0bc3a5a1f021de70$export$be5493f9613cbbe).noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>obj && (0, (/*@__PURE__*/$parcel$interopDefault($53b0aa1f4126b9a2$exports)))(obj, (_, key)=>fn(key)));
    }
    camelCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($f7197d9e4b641a79$exports))));
    }
    snakeCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($7b46fefcd4cc0950$exports))));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, (/*@__PURE__*/$parcel$interopDefault($7b46fefcd4cc0950$exports)))(key).toUpperCase());
    }
    describe() {
        let base = super.describe();
        base.fields = (0, (/*@__PURE__*/$parcel$interopDefault($4c0a59ef68410050$exports)))(this.fields, (value)=>value.describe());
        return base;
    }
}
function $e6c1ba40263f5002$export$185802fd694ee1f5(spec) {
    return new $e6c1ba40263f5002$export$2e2bcd8739ae039(spec);
}
$e6c1ba40263f5002$export$185802fd694ee1f5.prototype = $e6c1ba40263f5002$export$2e2bcd8739ae039.prototype;









function $2a96cf2d67f8df4d$var$_extends() {
    $2a96cf2d67f8df4d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2a96cf2d67f8df4d$var$_extends.apply(this, arguments);
}
function $2a96cf2d67f8df4d$export$185802fd694ee1f5(type) {
    return new $2a96cf2d67f8df4d$export$2e2bcd8739ae039(type);
}
class $2a96cf2d67f8df4d$export$2e2bcd8739ae039 extends (0, $fa353aae113a1391$export$2e2bcd8739ae039) {
    constructor(type){
        super({
            type: 'array'
        }); // `undefined` specifically means uninitialized, as opposed to
        // "no subtype"
        this.innerType = void 0;
        this.innerType = type;
        this.withMutation(()=>{
            this.transform(function(values) {
                if (typeof values === 'string') try {
                    values = JSON.parse(values);
                } catch (err) {
                    values = null;
                }
                return this.isType(values) ? values : null;
            });
        });
    }
    _typeCheck(v) {
        return Array.isArray(v);
    }
    get _subType() {
        return this.innerType;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts); //should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, $2a96cf2d67f8df4d$var$_extends({}, _opts, {
                path: `${_opts.path || ''}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, callback) {
        var _options$abortEarly, _options$recursive;
        let errors = [];
        let sync = options.sync;
        let path = options.path;
        let innerType = this.innerType;
        let endEarly = (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        let originalValue = options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, (err, value)=>{
            if (err) {
                if (!(0, $0d3dd0f474055a4e$export$2e2bcd8739ae039).isError(err) || endEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !innerType || !this._typeCheck(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let idx = 0; idx < value.length; idx++){
                let item = value[idx];
                let path = `${options.path || ''}[${idx}]`; // object._validate note for isStrict explanation
                let innerOptions = $2a96cf2d67f8df4d$var$_extends({}, options, {
                    path: path,
                    strict: true,
                    parent: value,
                    index: idx,
                    originalValue: originalValue[idx]
                });
                tests[idx] = (_, cb)=>innerType.validate(item, innerOptions, cb);
            }
            (0, $a0ed368902601763$export$2e2bcd8739ae039)({
                sync: sync,
                path: path,
                value: value,
                errors: errors,
                endEarly: endEarly,
                tests: tests
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.innerType = this.innerType;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        next.innerType = this.innerType;
        if (schema.innerType) next.innerType = next.innerType ? next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!(0, $521ce2c1367ddf6a$export$2e2bcd8739ae039)(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + (0, $18c302d8aff04670$export$2e2bcd8739ae039)(schema)); // FIXME(ts):
        next.innerType = schema;
        return next;
    }
    length(length, message = (0, $0bc3a5a1f021de70$export$2f23118c22fb2630).length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $1740bf431856338f$export$2e2bcd8739ae039)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || (0, $0bc3a5a1f021de70$export$2f23118c22fb2630).min;
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            // FIXME(ts): Array<typeof T>
            test (value) {
                return (0, $1740bf431856338f$export$2e2bcd8739ae039)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || (0, $0bc3a5a1f021de70$export$2f23118c22fb2630).max;
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $1740bf431856338f$export$2e2bcd8739ae039)(value) || value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe() {
        let base = super.describe();
        if (this.innerType) base.innerType = this.innerType.describe();
        return base;
    }
    nullable(isNullable = true) {
        return super.nullable(isNullable);
    }
    defined() {
        return super.defined();
    }
    required(msg) {
        return super.required(msg);
    }
}
$2a96cf2d67f8df4d$export$185802fd694ee1f5.prototype = $2a96cf2d67f8df4d$export$2e2bcd8739ae039.prototype; //
 // Interfaces
 //




function $f8ecc9b5b05065a8$export$185802fd694ee1f5(builder) {
    return new $f8ecc9b5b05065a8$var$Lazy(builder);
}
class $f8ecc9b5b05065a8$var$Lazy {
    constructor(builder){
        this.type = 'lazy';
        this.__isYupSchema__ = true;
        this.__inputType = void 0;
        this.__outputType = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!(0, $521ce2c1367ddf6a$export$2e2bcd8739ae039)(schema)) throw new TypeError('lazy() functions must return a valid schema');
            return schema.resolve(options);
        };
        this.builder = builder;
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    validate(value, options, maybeCb) {
        // @ts-expect-error missing public callback on type
        return this._resolve(value, options).validate(value, options, maybeCb);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    describe() {
        return null;
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
}
var $f8ecc9b5b05065a8$export$2e2bcd8739ae039 = $f8ecc9b5b05065a8$var$Lazy;






function $34b268b3c3c04520$export$2e2bcd8739ae039(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            (0, $0bc3a5a1f021de70$export$2e2bcd8739ae039)[type][method] = custom[type][method];
        });
    });
}



function $3b307be98da76640$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !(0, $521ce2c1367ddf6a$export$2e2bcd8739ae039)(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
    if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
    if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
    schemaType.prototype[name] = fn;
}


var $1660499e25144ef7$exports = {};
$1660499e25144ef7$exports = JSON.parse("[{\"name\":\"Alabama\",\"abbreviation\":\"AL\"},{\"name\":\"Alaska\",\"abbreviation\":\"AK\"},{\"name\":\"Arizona\",\"abbreviation\":\"AZ\"},{\"name\":\"Arkansas\",\"abbreviation\":\"AR\"},{\"name\":\"California\",\"abbreviation\":\"CA\"},{\"name\":\"Colorado\",\"abbreviation\":\"CO\"},{\"name\":\"Connecticut\",\"abbreviation\":\"CT\"},{\"name\":\"Delaware\",\"abbreviation\":\"DE\"},{\"name\":\"Florida\",\"abbreviation\":\"FL\"},{\"name\":\"Georgia\",\"abbreviation\":\"GA\"},{\"name\":\"Hawaii\",\"abbreviation\":\"HI\"},{\"name\":\"Idaho\",\"abbreviation\":\"ID\"},{\"name\":\"Illinois\",\"abbreviation\":\"IL\"},{\"name\":\"Indiana\",\"abbreviation\":\"IN\"},{\"name\":\"Iowa\",\"abbreviation\":\"IA\"},{\"name\":\"Kansas\",\"abbreviation\":\"KS\"},{\"name\":\"Kentucky\",\"abbreviation\":\"KY\"},{\"name\":\"Louisiana\",\"abbreviation\":\"LA\"},{\"name\":\"Maine\",\"abbreviation\":\"ME\"},{\"name\":\"Maryland\",\"abbreviation\":\"MD\"},{\"name\":\"Massachusetts\",\"abbreviation\":\"MA\"},{\"name\":\"Michigan\",\"abbreviation\":\"MI\"},{\"name\":\"Minnesota\",\"abbreviation\":\"MN\"},{\"name\":\"Mississippi\",\"abbreviation\":\"MS\"},{\"name\":\"Missouri\",\"abbreviation\":\"MO\"},{\"name\":\"Montana\",\"abbreviation\":\"MT\"},{\"name\":\"Nebraska\",\"abbreviation\":\"NE\"},{\"name\":\"Nevada\",\"abbreviation\":\"NV\"},{\"name\":\"New Hampshire\",\"abbreviation\":\"NH\"},{\"name\":\"New Jersey\",\"abbreviation\":\"NJ\"},{\"name\":\"New Mexico\",\"abbreviation\":\"NM\"},{\"name\":\"New York\",\"abbreviation\":\"NY\"},{\"name\":\"North Carolina\",\"abbreviation\":\"NC\"},{\"name\":\"North Dakota\",\"abbreviation\":\"ND\"},{\"name\":\"Ohio\",\"abbreviation\":\"OH\"},{\"name\":\"Oklahoma\",\"abbreviation\":\"OK\"},{\"name\":\"Oregon\",\"abbreviation\":\"OR\"},{\"name\":\"Pennsylvania\",\"abbreviation\":\"PA\"},{\"name\":\"Rhode Island\",\"abbreviation\":\"RI\"},{\"name\":\"South Carolina\",\"abbreviation\":\"SC\"},{\"name\":\"South Dakota\",\"abbreviation\":\"SD\"},{\"name\":\"Tennessee\",\"abbreviation\":\"TN\"},{\"name\":\"Texas\",\"abbreviation\":\"TX\"},{\"name\":\"Utah\",\"abbreviation\":\"UT\"},{\"name\":\"Vermont\",\"abbreviation\":\"VT\"},{\"name\":\"Virginia\",\"abbreviation\":\"VA\"},{\"name\":\"Washington\",\"abbreviation\":\"WA\"},{\"name\":\"West Virginia\",\"abbreviation\":\"WV\"},{\"name\":\"Wisconsin\",\"abbreviation\":\"WI\"},{\"name\":\"Wyoming\",\"abbreviation\":\"WY\"}]");



var $eYoAG = parcelRequire("eYoAG");

parcelRequire("ieT14");

var $aIJrd = parcelRequire("aIJrd");

var $knRao = parcelRequire("knRao");
var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");


var $aIJrd = parcelRequire("aIJrd");

var $86m3e = parcelRequire("86m3e");

var $2EBFt = parcelRequire("2EBFt");

var $ak9X1 = parcelRequire("ak9X1");
var $ec9bd087a9f7604d$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'inline-flex',
            width: 58,
            height: 38,
            overflow: 'hidden',
            padding: 12,
            boxSizing: 'border-box',
            position: 'relative',
            flexShrink: 0,
            zIndex: 0,
            // Reset the stacking context.
            verticalAlign: 'middle',
            // For correct alignment with the text.
            '@media print': {
                colorAdjust: 'exact'
            }
        },
        /* Styles applied to the root element if `edge="start"`. */ edgeStart: {
            marginLeft: -8
        },
        /* Styles applied to the root element if `edge="end"`. */ edgeEnd: {
            marginRight: -8
        },
        /* Styles applied to the internal `SwitchBase` component's `root` class. */ switchBase: {
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 1,
            // Render above the focus ripple.
            color: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[400],
            transition: theme.transitions.create([
                'left',
                'transform'
            ], {
                duration: theme.transitions.duration.shortest
            }),
            '&$checked': {
                transform: 'translateX(20px)'
            },
            '&$disabled': {
                color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
            },
            '&$checked + $track': {
                opacity: 0.5
            },
            '&$disabled + $track': {
                opacity: theme.palette.type === 'light' ? 0.12 : 0.1
            }
        },
        /* Styles applied to the internal SwitchBase component's root element if `color="primary"`. */ colorPrimary: {
            '&$checked': {
                color: theme.palette.primary.main,
                '&:hover': {
                    backgroundColor: (0, $86m3e.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                    '@media (hover: none)': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            '&$disabled': {
                color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
            },
            '&$checked + $track': {
                backgroundColor: theme.palette.primary.main
            },
            '&$disabled + $track': {
                backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
            }
        },
        /* Styles applied to the internal SwitchBase component's root element if `color="secondary"`. */ colorSecondary: {
            '&$checked': {
                color: theme.palette.secondary.main,
                '&:hover': {
                    backgroundColor: (0, $86m3e.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                    '@media (hover: none)': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            '&$disabled': {
                color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
            },
            '&$checked + $track': {
                backgroundColor: theme.palette.secondary.main
            },
            '&$disabled + $track': {
                backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
            }
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            width: 40,
            height: 24,
            padding: 7,
            '& $thumb': {
                width: 16,
                height: 16
            },
            '& $switchBase': {
                padding: 4,
                '&$checked': {
                    transform: 'translateX(16px)'
                }
            }
        },
        /* Pseudo-class applied to the internal `SwitchBase` component's `checked` class. */ checked: {},
        /* Pseudo-class applied to the internal SwitchBase component's disabled class. */ disabled: {},
        /* Styles applied to the internal SwitchBase component's input element. */ input: {
            left: '-100%',
            width: '300%'
        },
        /* Styles used to create the thumb passed to the internal `SwitchBase` component `icon` prop. */ thumb: {
            boxShadow: theme.shadows[1],
            backgroundColor: 'currentColor',
            width: 20,
            height: 20,
            borderRadius: '50%'
        },
        /* Styles applied to the track element. */ track: {
            height: '100%',
            width: '100%',
            borderRadius: 7,
            zIndex: -1,
            transition: theme.transitions.create([
                'opacity',
                'background-color'
            ], {
                duration: theme.transitions.duration.shortest
            }),
            backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
            opacity: theme.palette.type === 'light' ? 0.38 : 0.3
        }
    };
};
var $ec9bd087a9f7604d$var$Switch = /*#__PURE__*/ $ieT14.forwardRef(function Switch(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'secondary' : _props$color, _props$edge = props.edge, edge = _props$edge === void 0 ? false : _props$edge, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, other = (0, $eTwGP.default)(props, [
        "classes",
        "className",
        "color",
        "edge",
        "size"
    ]);
    var icon = /*#__PURE__*/ $ieT14.createElement("span", {
        className: classes.thumb
    });
    return /*#__PURE__*/ $ieT14.createElement("span", {
        className: (0, $j6s32.default)(classes.root, className, {
            'start': classes.edgeStart,
            'end': classes.edgeEnd
        }[edge], size === "small" && classes["size".concat((0, $2EBFt.default)(size))])
    }, /*#__PURE__*/ $ieT14.createElement((0, $ak9X1.default), (0, $edxsd.default)({
        type: "checkbox",
        icon: icon,
        checkedIcon: icon,
        classes: {
            root: (0, $j6s32.default)(classes.switchBase, classes["color".concat((0, $2EBFt.default)(color))]),
            input: classes.input,
            checked: classes.checked,
            disabled: classes.disabled
        },
        ref: ref
    }, other)), /*#__PURE__*/ $ieT14.createElement("span", {
        className: classes.track
    }));
});
var $ec9bd087a9f7604d$export$2e2bcd8739ae039 = (0, $aIJrd.default)($ec9bd087a9f7604d$export$9dd6ff9ea0189349, {
    name: 'MuiSwitch'
})($ec9bd087a9f7604d$var$Switch);



const $87c09cb75a62e14f$var$SwitchLabel = (0, $aIJrd.default)({
    label: {
        textTransform: 'uppercase',
        fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).heading,
        fontWeight: 600,
        color: '#8a8a8a',
        marginTop: 15
    }
})((0, $knRao.default));
const $87c09cb75a62e14f$var$GreenSwitch = (0, $aIJrd.default)({
    root: {
        padding: 7,
        marginTop: 15
    },
    switchBase: {
        color: '#ffffff',
        fontWeight: 500,
        '&$checked': {
            color: '#ffffff'
        },
        '&$checked + $track': {
            backgroundColor: '#0e834a',
            opacity: 1
        },
        disabled: {
            opacity: 0.5
        }
    },
    checked: {},
    track: {
        borderRadius: 13,
        backgroundColor: '#8a8a8a',
        opacity: 1
    },
    disabled: {
        opacity: 0.5
    }
})((0, $ec9bd087a9f7604d$export$2e2bcd8739ae039));
const $87c09cb75a62e14f$var$SwitchBox = ({ id: id, value: value, label: label, handleChange: handleChange, disabled: disabled })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($87c09cb75a62e14f$var$SwitchLabel, {
        control: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($87c09cb75a62e14f$var$GreenSwitch, {
            id: id,
            checked: value,
            onChange: handleChange,
            disabled: disabled
        }),
        label: label
    });
};
var $87c09cb75a62e14f$export$2e2bcd8739ae039 = $87c09cb75a62e14f$var$SwitchBox;





var $fgoQ6 = parcelRequire("fgoQ6");


var $ieT14 = parcelRequire("ieT14");


var $ieT14 = parcelRequire("ieT14");

var $e1ONw = parcelRequire("e1ONw");
var $hgPMF = parcelRequire("hgPMF");

var $eTwGP = parcelRequire("eTwGP");

var $edxsd = parcelRequire("edxsd");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $aIJrd = parcelRequire("aIJrd");


var $75a5ff1d19f14e4e$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $75a5ff1d19f14e4e$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
function $75a5ff1d19f14e4e$var$generateGrid(globalStyles, theme, breakpoint) {
    var styles = {};
    $75a5ff1d19f14e4e$var$GRID_SIZES.forEach(function(size) {
        var key = "grid-".concat(breakpoint, "-").concat(size);
        if (size === true) {
            // For the auto layouting
            styles[key] = {
                flexBasis: 0,
                flexGrow: 1,
                maxWidth: '100%'
            };
            return;
        }
        if (size === 'auto') {
            styles[key] = {
                flexBasis: 'auto',
                flexGrow: 0,
                maxWidth: 'none'
            };
            return;
        } // Keep 7 significant numbers.
        var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
        // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
        styles[key] = {
            flexBasis: width,
            flexGrow: 0,
            maxWidth: width
        };
    }); // No need for a media query for the first size.
    if (breakpoint === 'xs') (0, $edxsd.default)(globalStyles, styles);
    else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
}
function $75a5ff1d19f14e4e$var$getOffset(val) {
    var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var parse = parseFloat(val);
    return "".concat(parse / div).concat(String(val).replace(String(parse), '') || 'px');
}
function $75a5ff1d19f14e4e$var$generateGutter(theme, breakpoint) {
    var styles = {};
    $75a5ff1d19f14e4e$var$SPACINGS.forEach(function(spacing) {
        var themeSpacing = theme.spacing(spacing);
        if (themeSpacing === 0) return;
        styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
            margin: "-".concat($75a5ff1d19f14e4e$var$getOffset(themeSpacing, 2)),
            width: "calc(100% + ".concat($75a5ff1d19f14e4e$var$getOffset(themeSpacing), ")"),
            '& > $item': {
                padding: $75a5ff1d19f14e4e$var$getOffset(themeSpacing, 2)
            }
        };
    });
    return styles;
} // Default CSS values
var $75a5ff1d19f14e4e$export$9dd6ff9ea0189349 = function styles(theme) {
    return (0, $edxsd.default)({
        /* Styles applied to the root element. */ root: {},
        /* Styles applied to the root element if `container={true}`. */ container: {
            boxSizing: 'border-box',
            display: 'flex',
            flexWrap: 'wrap',
            width: '100%'
        },
        /* Styles applied to the root element if `item={true}`. */ item: {
            boxSizing: 'border-box',
            margin: '0' // For instance, it's useful when used with a `figure` element.
        },
        /* Styles applied to the root element if `zeroMinWidth={true}`. */ zeroMinWidth: {
            minWidth: 0
        },
        /* Styles applied to the root element if `direction="column"`. */ 'direction-xs-column': {
            flexDirection: 'column'
        },
        /* Styles applied to the root element if `direction="column-reverse"`. */ 'direction-xs-column-reverse': {
            flexDirection: 'column-reverse'
        },
        /* Styles applied to the root element if `direction="row-reverse"`. */ 'direction-xs-row-reverse': {
            flexDirection: 'row-reverse'
        },
        /* Styles applied to the root element if `wrap="nowrap"`. */ 'wrap-xs-nowrap': {
            flexWrap: 'nowrap'
        },
        /* Styles applied to the root element if `wrap="reverse"`. */ 'wrap-xs-wrap-reverse': {
            flexWrap: 'wrap-reverse'
        },
        /* Styles applied to the root element if `alignItems="center"`. */ 'align-items-xs-center': {
            alignItems: 'center'
        },
        /* Styles applied to the root element if `alignItems="flex-start"`. */ 'align-items-xs-flex-start': {
            alignItems: 'flex-start'
        },
        /* Styles applied to the root element if `alignItems="flex-end"`. */ 'align-items-xs-flex-end': {
            alignItems: 'flex-end'
        },
        /* Styles applied to the root element if `alignItems="baseline"`. */ 'align-items-xs-baseline': {
            alignItems: 'baseline'
        },
        /* Styles applied to the root element if `alignContent="center"`. */ 'align-content-xs-center': {
            alignContent: 'center'
        },
        /* Styles applied to the root element if `alignContent="flex-start"`. */ 'align-content-xs-flex-start': {
            alignContent: 'flex-start'
        },
        /* Styles applied to the root element if `alignContent="flex-end"`. */ 'align-content-xs-flex-end': {
            alignContent: 'flex-end'
        },
        /* Styles applied to the root element if `alignContent="space-between"`. */ 'align-content-xs-space-between': {
            alignContent: 'space-between'
        },
        /* Styles applied to the root element if `alignContent="space-around"`. */ 'align-content-xs-space-around': {
            alignContent: 'space-around'
        },
        /* Styles applied to the root element if `justifyContent="center"`. */ 'justify-content-xs-center': {
            justifyContent: 'center'
        },
        /* Styles applied to the root element if `justifyContent="flex-end"`. */ 'justify-content-xs-flex-end': {
            justifyContent: 'flex-end'
        },
        /* Styles applied to the root element if `justifyContent="space-between"`. */ 'justify-content-xs-space-between': {
            justifyContent: 'space-between'
        },
        /* Styles applied to the root element if `justifyContent="space-around"`. */ 'justify-content-xs-space-around': {
            justifyContent: 'space-around'
        },
        /* Styles applied to the root element if `justifyContent="space-evenly"`. */ 'justify-content-xs-space-evenly': {
            justifyContent: 'space-evenly'
        }
    }, $75a5ff1d19f14e4e$var$generateGutter(theme, 'xs'), theme.breakpoints.keys.reduce(function(accumulator, key) {
        // Use side effect over immutability for better performance.
        $75a5ff1d19f14e4e$var$generateGrid(accumulator, theme, key);
        return accumulator;
    }, {}));
};
var $75a5ff1d19f14e4e$var$Grid = /*#__PURE__*/ $ieT14.forwardRef(function Grid(props, ref) {
    var _props$alignContent = props.alignContent, alignContent = _props$alignContent === void 0 ? 'stretch' : _props$alignContent, _props$alignItems = props.alignItems, alignItems = _props$alignItems === void 0 ? 'stretch' : _props$alignItems, classes = props.classes, classNameProp = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$container = props.container, container = _props$container === void 0 ? false : _props$container, _props$direction = props.direction, direction = _props$direction === void 0 ? 'row' : _props$direction, _props$item = props.item, item = _props$item === void 0 ? false : _props$item, justify = props.justify, _props$justifyContent = props.justifyContent, justifyContent = _props$justifyContent === void 0 ? 'flex-start' : _props$justifyContent, _props$lg = props.lg, lg = _props$lg === void 0 ? false : _props$lg, _props$md = props.md, md = _props$md === void 0 ? false : _props$md, _props$sm = props.sm, sm = _props$sm === void 0 ? false : _props$sm, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 0 : _props$spacing, _props$wrap = props.wrap, wrap = _props$wrap === void 0 ? 'wrap' : _props$wrap, _props$xl = props.xl, xl = _props$xl === void 0 ? false : _props$xl, _props$xs = props.xs, xs = _props$xs === void 0 ? false : _props$xs, _props$zeroMinWidth = props.zeroMinWidth, zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth, other = (0, $eTwGP.default)(props, [
        "alignContent",
        "alignItems",
        "classes",
        "className",
        "component",
        "container",
        "direction",
        "item",
        "justify",
        "justifyContent",
        "lg",
        "md",
        "sm",
        "spacing",
        "wrap",
        "xl",
        "xs",
        "zeroMinWidth"
    ]);
    var className = (0, $j6s32.default)(classes.root, classNameProp, container && [
        classes.container,
        spacing !== 0 && classes["spacing-xs-".concat(String(spacing))]
    ], item && classes.item, zeroMinWidth && classes.zeroMinWidth, direction !== 'row' && classes["direction-xs-".concat(String(direction))], wrap !== 'wrap' && classes["wrap-xs-".concat(String(wrap))], alignItems !== 'stretch' && classes["align-items-xs-".concat(String(alignItems))], alignContent !== 'stretch' && classes["align-content-xs-".concat(String(alignContent))], (justify || justifyContent) !== 'flex-start' && classes["justify-content-xs-".concat(String(justify || justifyContent))], xs !== false && classes["grid-xs-".concat(String(xs))], sm !== false && classes["grid-sm-".concat(String(sm))], md !== false && classes["grid-md-".concat(String(md))], lg !== false && classes["grid-lg-".concat(String(lg))], xl !== false && classes["grid-xl-".concat(String(xl))]);
    return /*#__PURE__*/ $ieT14.createElement(Component, (0, $edxsd.default)({
        className: className,
        ref: ref
    }, other));
});
var $75a5ff1d19f14e4e$var$StyledGrid = (0, $aIJrd.default)($75a5ff1d19f14e4e$export$9dd6ff9ea0189349, {
    name: 'MuiGrid'
})($75a5ff1d19f14e4e$var$Grid);
var $75a5ff1d19f14e4e$var$requireProp;
var $75a5ff1d19f14e4e$export$2e2bcd8739ae039 = $75a5ff1d19f14e4e$var$StyledGrid;



var $dxqtw = parcelRequire("dxqtw");

var $1fCJg = parcelRequire("1fCJg");

var $iwN3n = parcelRequire("iwN3n");

var $bPjUl = parcelRequire("bPjUl");

parcelRequire("ieT14");

var $aIJrd = parcelRequire("aIJrd");

var $lamW6 = parcelRequire("lamW6");

const $8d66a60ef98d2984$var$StyledCheckbox = (0, $aIJrd.default)({
    root: {
        height: 16,
        width: 16,
        borderRadius: 3,
        border: `1px solid ${(0, $69ed148db7543104$export$a4867fe9454f37a8)[300]}`,
        color: 'transparent',
        padding: 0,
        '&:hover': {
            border: `1px solid ${(0, $69ed148db7543104$export$2aa0182783e7e9de)[300]}`
        },
        '&$checked': {
            color: (0, $69ed148db7543104$export$2aa0182783e7e9de)[600]
        },
        '&$disabled': {
            color: (0, $69ed148db7543104$export$a4867fe9454f37a8)[500]
        }
    },
    checked: {},
    disabled: {}
})((props)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $lamW6.default), {
        color: "default",
        ...props
    }));
var $8d66a60ef98d2984$export$2e2bcd8739ae039 = $8d66a60ef98d2984$var$StyledCheckbox;



var $lwgYO = parcelRequire("lwgYO");

var $1KcBP = parcelRequire("1KcBP");
var $bede22632d93d4a9$exports = {};
"use strict";


Object.defineProperty($bede22632d93d4a9$exports, "__esModule", {
    value: true
});
$bede22632d93d4a9$exports.default = void 0;

var $bede22632d93d4a9$var$React = $633c7dc13d665c5e$exports((parcelRequire("ieT14")));

var $bede22632d93d4a9$var$_createSvgIcon = $b24015bb0dc2bec9$exports((parcelRequire("3yIjW")));
var $bede22632d93d4a9$var$_default = (0, $bede22632d93d4a9$var$_createSvgIcon.default)(/*#__PURE__*/ $bede22632d93d4a9$var$React.createElement("path", {
    d: "M14 7l-5 5 5 5V7z"
}), 'ArrowLeft');
$bede22632d93d4a9$exports.default = $bede22632d93d4a9$var$_default;


var $6faaeab4b2d551f9$exports = {};
"use strict";


Object.defineProperty($6faaeab4b2d551f9$exports, "__esModule", {
    value: true
});
$6faaeab4b2d551f9$exports.default = void 0;

var $6faaeab4b2d551f9$var$React = $633c7dc13d665c5e$exports((parcelRequire("ieT14")));

var $6faaeab4b2d551f9$var$_createSvgIcon = $b24015bb0dc2bec9$exports((parcelRequire("3yIjW")));
var $6faaeab4b2d551f9$var$_default = (0, $6faaeab4b2d551f9$var$_createSvgIcon.default)(/*#__PURE__*/ $6faaeab4b2d551f9$var$React.createElement("path", {
    d: "M10 17l5-5-5-5v10z"
}), 'ArrowRight');
$6faaeab4b2d551f9$exports.default = $6faaeab4b2d551f9$var$_default;




const $624bea18a01be01c$var$useStyles = (0, $e1ONw.default)({
    wrapper: {
        margin: '16px 0'
    },
    root: {
        margin: 'auto',
        flexWrap: 'nowrap',
        alignItems: 'stretch'
    },
    paperContainer: {
        width: '50%',
        display: 'flex',
        flexDirection: 'column'
    },
    paper: {
        flex: 1,
        minWidth: 200,
        width: '100%',
        overflow: 'auto',
        border: `1px solid ${(0, $69ed148db7543104$export$a4867fe9454f37a8)[300]}`,
        boxShadow: 'none',
        display: 'flex',
        flexDirection: 'column'
    },
    list: {
        flex: 1,
        paddingBottom: '24px'
    },
    buttonContainer: {
        padding: '16px'
    },
    listItem: {
        '& .MuiListItemIcon-root': {
            minWidth: '32px'
        }
    },
    selectAll: {
        color: (0, $69ed148db7543104$export$2aa0182783e7e9de)[600],
        textTransform: 'uppercase',
        position: 'sticky',
        bottom: 0,
        boxSizing: 'border-box',
        width: '100%',
        margin: 0,
        padding: '8px 16px',
        backgroundColor: 'white'
    },
    sectionHeading: {
        fontSize: 11
    }
});
function $624bea18a01be01c$var$not(a, b) {
    return a.filter((value)=>b.indexOf(value) === -1);
}
function $624bea18a01be01c$var$intersection(a, b) {
    return a.filter((value)=>b.indexOf(value) !== -1);
}
const $624bea18a01be01c$var$DefaultListItem = ({ value: value, checked: checked, idField: idField, labelField: labelField, handleToggle: handleToggle })=>{
    const classes = $624bea18a01be01c$var$useStyles();
    const labelId = `transfer-list-item-${value[idField]}-label`;
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $1fCJg.default), {
        role: "listitem",
        button: true,
        onClick: ()=>handleToggle(value),
        className: classes.listItem,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $iwN3n.default), {
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8d66a60ef98d2984$export$2e2bcd8739ae039), {
                    checked: checked.indexOf(value) !== -1,
                    tabIndex: -1,
                    disableRipple: true,
                    inputProps: {
                        'aria-labelledby': labelId
                    }
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $bPjUl.default), {
                id: labelId,
                primary: value[labelField]
            })
        ]
    });
};
/**
 * @function InnerTransferList This is a transfer list that lets you moves objects between two groups.
 */ const $624bea18a01be01c$var$TransferList = ({ idField: idField, labelField: labelField, left: left, setLeft: setLeft, leftLabel: leftLabel, right: right, setRight: setRight, rightLabel: rightLabel, setFieldValue: setFieldValue, setField: setField, height: height, rightListComponent: RightListComponent = $624bea18a01be01c$var$DefaultListItem, onMoveLeft: onMoveLeft, onMoveRight: onMoveRight })=>{
    const classes = $624bea18a01be01c$var$useStyles((0, $hgPMF.default)());
    const [checked, setChecked] = $ieT14.useState([]);
    const leftChecked = $624bea18a01be01c$var$intersection(checked, left);
    const rightChecked = $624bea18a01be01c$var$intersection(checked, right);
    const handleToggle = (value)=>{
        const currentIndex = checked.indexOf(value);
        const newChecked = [
            ...checked
        ];
        if (currentIndex === -1) newChecked.push(value);
        else newChecked.splice(currentIndex, 1);
        setChecked(newChecked);
    };
    const handleCheckedRight = ()=>{
        onMoveRight && onMoveRight(leftChecked);
        setRight(right.concat(leftChecked));
        setLeft($624bea18a01be01c$var$not(left, leftChecked));
        setChecked($624bea18a01be01c$var$not(checked, leftChecked));
        setFieldValue(setField, right.concat(leftChecked));
    };
    const handleCheckedLeft = ()=>{
        onMoveLeft && onMoveLeft(rightChecked);
        setLeft(left.concat(rightChecked));
        setRight($624bea18a01be01c$var$not(right, rightChecked));
        setChecked($624bea18a01be01c$var$not(checked, rightChecked));
        setFieldValue(setField, $624bea18a01be01c$var$not(right, rightChecked));
    };
    const selectAll = (items)=>{
        setChecked([
            ...checked,
            ...$624bea18a01be01c$var$not(items, checked)
        ]);
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        className: classes.wrapper,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $75a5ff1d19f14e4e$export$2e2bcd8739ae039), {
            container: true,
            spacing: 0,
            justifyContent: "center",
            alignItems: "center",
            className: classes.root,
            style: {
                height: height ? height : 230
            },
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $75a5ff1d19f14e4e$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 6,
                    className: classes.paperContainer,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h6", {
                            className: classes.sectionHeading,
                            children: leftLabel ? leftLabel : 'Available'
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $lwgYO.default), {
                            className: classes.paper,
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $dxqtw.default), {
                                    dense: true,
                                    role: "list",
                                    className: classes.list,
                                    children: left.map((value)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($624bea18a01be01c$var$DefaultListItem, {
                                            value: value,
                                            checked: checked,
                                            idField: idField,
                                            labelField: labelField,
                                            handleToggle: handleToggle
                                        }, value[idField]))
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("p", {
                                    className: classes.selectAll,
                                    children: left.length > 0 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fcd3b8c5e9a7038b$export$2e2bcd8739ae039), {
                                        text: "Select All",
                                        title: "Select All",
                                        handleClick: ()=>selectAll(left)
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $75a5ff1d19f14e4e$export$2e2bcd8739ae039), {
                    item: true,
                    className: classes.buttonContainer,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $75a5ff1d19f14e4e$export$2e2bcd8739ae039), {
                        container: true,
                        direction: "column",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                                size: "small",
                                onClick: handleCheckedRight,
                                disabled: leftChecked.length === 0,
                                "aria-label": "move selected right",
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6faaeab4b2d551f9$exports))), {
                                    fontSize: "large"
                                })
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                                size: "small",
                                onClick: handleCheckedLeft,
                                disabled: rightChecked.length === 0,
                                "aria-label": "move selected left",
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bede22632d93d4a9$exports))), {
                                    fontSize: "large"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $75a5ff1d19f14e4e$export$2e2bcd8739ae039), {
                    item: true,
                    xs: 6,
                    className: classes.paperContainer,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h6", {
                            className: classes.sectionHeading,
                            children: rightLabel ? rightLabel : 'Selected'
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $lwgYO.default), {
                            className: classes.paper,
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $dxqtw.default), {
                                    dense: true,
                                    role: "list",
                                    className: classes.list,
                                    children: right.map((value)=>RightListComponent ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)(RightListComponent, {
                                            value: value,
                                            checked: checked,
                                            idField: idField,
                                            labelField: labelField,
                                            handleToggle: handleToggle
                                        }, value[idField]) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($624bea18a01be01c$var$DefaultListItem, {
                                            value: value,
                                            checked: checked,
                                            idField: idField,
                                            labelField: labelField,
                                            handleToggle: handleToggle
                                        }, value[idField]))
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("p", {
                                    className: classes.selectAll,
                                    children: right.length > 0 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fcd3b8c5e9a7038b$export$2e2bcd8739ae039), {
                                        text: "Select All",
                                        title: "Select All",
                                        handleClick: ()=>selectAll(right)
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $624bea18a01be01c$export$2e2bcd8739ae039 = $624bea18a01be01c$var$TransferList;




function $92a94bacff6073c7$export$23bc01dde35d50d9() {
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    return (0, $137a3b252d598119$export$dd0a697e1782aedd)([
        'administrators'
    ], ()=>{
        return fetchWrapper('api/management/administrators');
    });
}



var $fRnKy = parcelRequire("fRnKy");

var $fpdl2 = parcelRequire("fpdl2");

const $765884c7df24d4a0$var$AdministratorTransfer = ({ client: client, setFieldValue: setFieldValue })=>{
    const administratorQuery = (0, $92a94bacff6073c7$export$23bc01dde35d50d9)();
    const [unassignedAdmins, setUnassignedAdmins] = $ieT14.useState([]);
    const [assignedAdmins, setAssignedAdmins] = $ieT14.useState(client.assignedAdministrators);
    $ieT14.useEffect(()=>{
        if (administratorQuery.data && client.assignedAdministrators.length == 0) setUnassignedAdmins(administratorQuery.data);
        else if (administratorQuery.data && client.assignedAdministrators.length > 0) setUnassignedAdmins((0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).differenceBy(administratorQuery.data, [
            ...client.assignedAdministrators
        ], 'id'));
    }, [
        administratorQuery.data,
        client
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("h2", {
                className: $77e47b6bc9169ce7$export$897fbb5bd1538ae2,
                children: [
                    "Administrators",
                    ' ',
                    (administratorQuery.isLoading || administratorQuery.isFetching) && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {
                        size: "1em"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $624bea18a01be01c$export$2e2bcd8739ae039), {
                idField: "id",
                labelField: "fullName",
                left: unassignedAdmins,
                right: assignedAdmins,
                setLeft: setUnassignedAdmins,
                setRight: setAssignedAdmins,
                setFieldValue: setFieldValue,
                setField: "assignedAdministrators"
            })
        ]
    });
};
var $765884c7df24d4a0$export$2e2bcd8739ae039 = $765884c7df24d4a0$var$AdministratorTransfer;




var $ieT14 = parcelRequire("ieT14");


var $fRnKy = parcelRequire("fRnKy");

var $fpdl2 = parcelRequire("fpdl2");


function $c930e47972554507$export$27f57c1c6f40bdc7(type) {
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    return (0, $137a3b252d598119$export$dd0a697e1782aedd)([
        'support-allowed-type',
        type
    ], ()=>{
        return fetchWrapper(`api/management/support/${type}`);
    });
}



const $768f2b973bd8283b$var$SupportTypeTransfer = ({ client: client, setFieldValue: setFieldValue, supportType: supportType })=>{
    const supportTypeQuery = (0, $c930e47972554507$export$27f57c1c6f40bdc7)(supportType);
    const [unassigned, setUnassigned] = $ieT14.useState([]);
    const [assigned, setAssigned] = $ieT14.useState(supportType == 'organizations' ? client.assignedOrganizations : client.assignedRequestTypes);
    $ieT14.useEffect(()=>{
        if (supportTypeQuery.data && assigned.length == 0) setUnassigned(supportTypeQuery.data);
        else if (supportTypeQuery.data && assigned.length > 0) setUnassigned((0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).differenceBy(supportTypeQuery.data, assigned, 'key'));
    }, [
        supportTypeQuery.data,
        client
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("h2", {
                className: $77e47b6bc9169ce7$export$897fbb5bd1538ae2,
                children: [
                    supportType == 'organizations' ? 'Service Desk Organizations' : 'Service Desk Request Types',
                    ' ',
                    (supportTypeQuery.isLoading || supportTypeQuery.isFetching) && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {
                        size: "1em"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $624bea18a01be01c$export$2e2bcd8739ae039), {
                idField: "key",
                labelField: "value",
                left: unassigned,
                right: assigned,
                setLeft: setUnassigned,
                setRight: setAssigned,
                setFieldValue: setFieldValue,
                setField: supportType == 'organizations' ? 'assignedOrganizations' : 'assignedRequestTypes'
            })
        ]
    });
};
var $768f2b973bd8283b$export$2e2bcd8739ae039 = $768f2b973bd8283b$var$SupportTypeTransfer;




var $ieT14 = parcelRequire("ieT14");


var $ieT14 = parcelRequire("ieT14");

var $aIJrd = parcelRequire("aIJrd");

var $edxsd = parcelRequire("edxsd");

var $dYa6U = parcelRequire("dYa6U");

var $5jWgG = parcelRequire("5jWgG");

var $3aDwg = parcelRequire("3aDwg");

var $7YQUf = parcelRequire("7YQUf");
function $8ba5c93284aa254c$export$2e2bcd8739ae039(r) {
    return (0, $dYa6U.default)(r) || (0, $5jWgG.default)(r) || (0, $3aDwg.default)(r) || (0, $7YQUf.default)();
}



var $dcIvM = parcelRequire("dcIvM");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");
parcelRequire("fqwRx");


var $j6s32 = parcelRequire("j6s32");


var $edxsd = parcelRequire("edxsd");

var $dcIvM = parcelRequire("dcIvM");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");

var $j6s32 = parcelRequire("j6s32");



var $4XMe5 = parcelRequire("4XMe5");

var $aIJrd = parcelRequire("aIJrd");

var $ejUtG = parcelRequire("ejUtG");


var $1VWiP = parcelRequire("1VWiP");

var $hgPMF = parcelRequire("hgPMF");

var $3A1Xf = parcelRequire("3A1Xf");
var $863c87a667a3ccc1$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            height: 0,
            overflow: 'hidden',
            transition: theme.transitions.create('height')
        },
        /* Styles applied to the root element when the transition has entered. */ entered: {
            height: 'auto',
            overflow: 'visible'
        },
        /* Styles applied to the root element when the transition has exited and `collapsedSize` != 0px. */ hidden: {
            visibility: 'hidden'
        },
        /* Styles applied to the outer wrapper element. */ wrapper: {
            // Hack to get children with a negative margin to not falsify the height computation.
            display: 'flex'
        },
        /* Styles applied to the inner wrapper element. */ wrapperInner: {
            width: '100%'
        }
    };
};
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $863c87a667a3ccc1$var$Collapse = /*#__PURE__*/ $ieT14.forwardRef(function Collapse(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, collapsedHeight = props.collapsedHeight, _props$collapsedSize = props.collapsedSize, collapsedSizeProp = _props$collapsedSize === void 0 ? '0px' : _props$collapsedSize, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? (0, $ejUtG.duration).standard : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $4XMe5.default) : _props$TransitionComp, other = (0, $eTwGP.default)(props, [
        "children",
        "classes",
        "className",
        "collapsedHeight",
        "collapsedSize",
        "component",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var theme = (0, $hgPMF.default)();
    var timer = $ieT14.useRef();
    var wrapperRef = $ieT14.useRef(null);
    var autoTransitionDuration = $ieT14.useRef();
    var collapsedSize = typeof (collapsedHeight || collapsedSizeProp) === 'number' ? "".concat(collapsedHeight || collapsedSizeProp, "px") : collapsedHeight || collapsedSizeProp;
    $ieT14.useEffect(function() {
        return function() {
            clearTimeout(timer.current);
        };
    }, []);
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $ieT14.useRef(null);
    var handleRef = (0, $3A1Xf.default)(ref, enableStrictModeCompat ? nodeRef : undefined);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $dcIvM.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        node.style.height = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntering = normalizedTransitionCallback(function(node, isAppearing) {
        var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
        var _getTransitionProps = (0, $1VWiP.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: 'enter'
        }), transitionDuration = _getTransitionProps.duration;
        if (timeout === 'auto') {
            var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
            node.style.transitionDuration = "".concat(duration2, "ms");
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
        node.style.height = "".concat(wrapperHeight, "px");
        if (onEntering) onEntering(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(function(node, isAppearing) {
        node.style.height = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    var handleExit = normalizedTransitionCallback(function(node) {
        var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
        node.style.height = "".concat(wrapperHeight, "px");
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var handleExiting = normalizedTransitionCallback(function(node) {
        var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
        var _getTransitionProps2 = (0, $1VWiP.getTransitionProps)({
            style: style,
            timeout: timeout
        }, {
            mode: 'exit'
        }), transitionDuration = _getTransitionProps2.duration;
        if (timeout === 'auto') {
            var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
            node.style.transitionDuration = "".concat(duration2, "ms");
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
        node.style.height = collapsedSize;
        if (onExiting) onExiting(node);
    });
    var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
        var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
        if (timeout === 'auto') timer.current = setTimeout(next, autoTransitionDuration.current || 0);
    };
    return /*#__PURE__*/ $ieT14.createElement(TransitionComponent, (0, $edxsd.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: addEndListener,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        timeout: timeout === 'auto' ? null : timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $ieT14.createElement(Component, (0, $edxsd.default)({
            className: (0, $j6s32.default)(classes.root, classes.container, className, {
                'entered': classes.entered,
                'exited': !inProp && collapsedSize === '0px' && classes.hidden
            }[state]),
            style: (0, $edxsd.default)({
                minHeight: collapsedSize
            }, style),
            ref: handleRef
        }, childProps), /*#__PURE__*/ $ieT14.createElement("div", {
            className: classes.wrapper,
            ref: wrapperRef
        }, /*#__PURE__*/ $ieT14.createElement("div", {
            className: classes.wrapperInner
        }, children)));
    });
});
$863c87a667a3ccc1$var$Collapse.muiSupportAuto = true;
var $863c87a667a3ccc1$export$2e2bcd8739ae039 = (0, $aIJrd.default)($863c87a667a3ccc1$export$9dd6ff9ea0189349, {
    name: 'MuiCollapse'
})($863c87a667a3ccc1$var$Collapse);



var $lwgYO = parcelRequire("lwgYO");

var $aIJrd = parcelRequire("aIJrd");

var $ieT14 = parcelRequire("ieT14");
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ var $8b593d0afd44c66c$var$AccordionContext = $ieT14.createContext({});
var $8b593d0afd44c66c$export$2e2bcd8739ae039 = $8b593d0afd44c66c$var$AccordionContext;



var $kuovH = parcelRequire("kuovH");
var $a15b543b042fe855$export$9dd6ff9ea0189349 = function styles(theme) {
    var transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative',
            transition: theme.transitions.create([
                'margin'
            ], transition),
            '&:before': {
                position: 'absolute',
                left: 0,
                top: -1,
                right: 0,
                height: 1,
                content: '""',
                opacity: 1,
                backgroundColor: theme.palette.divider,
                transition: theme.transitions.create([
                    'opacity',
                    'background-color'
                ], transition)
            },
            '&:first-child': {
                '&:before': {
                    display: 'none'
                }
            },
            '&$expanded': {
                margin: '16px 0',
                '&:first-child': {
                    marginTop: 0
                },
                '&:last-child': {
                    marginBottom: 0
                },
                '&:before': {
                    opacity: 0
                }
            },
            '&$expanded + &': {
                '&:before': {
                    display: 'none'
                }
            },
            '&$disabled': {
                backgroundColor: theme.palette.action.disabledBackground
            }
        },
        /* Styles applied to the root element if `square={false}`. */ rounded: {
            borderRadius: 0,
            '&:first-child': {
                borderTopLeftRadius: theme.shape.borderRadius,
                borderTopRightRadius: theme.shape.borderRadius
            },
            '&:last-child': {
                borderBottomLeftRadius: theme.shape.borderRadius,
                borderBottomRightRadius: theme.shape.borderRadius,
                // Fix a rendering issue on Edge
                '@supports (-ms-ime-align: auto)': {
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0
                }
            }
        },
        /* Styles applied to the root element if `expanded={true}`. */ expanded: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {}
    };
};
var $a15b543b042fe855$var$Accordion = /*#__PURE__*/ $ieT14.forwardRef(function Accordion(props, ref) {
    var childrenProp = props.children, classes = props.classes, className = props.className, _props$defaultExpande = props.defaultExpanded, defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, expandedProp = props.expanded, onChange = props.onChange, _props$square = props.square, square = _props$square === void 0 ? false : _props$square, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $863c87a667a3ccc1$export$2e2bcd8739ae039) : _props$TransitionComp, TransitionProps = props.TransitionProps, other = (0, $eTwGP.default)(props, [
        "children",
        "classes",
        "className",
        "defaultExpanded",
        "disabled",
        "expanded",
        "onChange",
        "square",
        "TransitionComponent",
        "TransitionProps"
    ]);
    var _useControlled = (0, $kuovH.default)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: 'Accordion',
        state: 'expanded'
    }), _useControlled2 = (0, $dcIvM.default)(_useControlled, 2), expanded = _useControlled2[0], setExpandedState = _useControlled2[1];
    var handleChange = $ieT14.useCallback(function(event) {
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    var _React$Children$toArr = $ieT14.Children.toArray(childrenProp), _React$Children$toArr2 = (0, $8ba5c93284aa254c$export$2e2bcd8739ae039)(_React$Children$toArr), summary = _React$Children$toArr2[0], children = _React$Children$toArr2.slice(1);
    var contextValue = $ieT14.useMemo(function() {
        return {
            expanded: expanded,
            disabled: disabled,
            toggle: handleChange
        };
    }, [
        expanded,
        disabled,
        handleChange
    ]);
    return /*#__PURE__*/ $ieT14.createElement((0, $lwgYO.default), (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className, expanded && classes.expanded, disabled && classes.disabled, !square && classes.rounded),
        ref: ref,
        square: square
    }, other), /*#__PURE__*/ $ieT14.createElement((0, $8b593d0afd44c66c$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, summary), /*#__PURE__*/ $ieT14.createElement(TransitionComponent, (0, $edxsd.default)({
        in: expanded,
        timeout: "auto"
    }, TransitionProps), /*#__PURE__*/ $ieT14.createElement("div", {
        "aria-labelledby": summary.props.id,
        id: summary.props['aria-controls'],
        role: "region"
    }, children)));
});
var $a15b543b042fe855$export$2e2bcd8739ae039 = (0, $aIJrd.default)($a15b543b042fe855$export$9dd6ff9ea0189349, {
    name: 'MuiAccordion'
})($a15b543b042fe855$var$Accordion);



var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");


var $51wR9 = parcelRequire("51wR9");

var $1KcBP = parcelRequire("1KcBP");

var $aIJrd = parcelRequire("aIJrd");

var $516680b382b90234$export$9dd6ff9ea0189349 = function styles(theme) {
    var transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        /* Styles applied to the root element. */ root: {
            display: 'flex',
            minHeight: 48,
            transition: theme.transitions.create([
                'min-height',
                'background-color'
            ], transition),
            padding: theme.spacing(0, 2),
            '&:hover:not($disabled)': {
                cursor: 'pointer'
            },
            '&$expanded': {
                minHeight: 64
            },
            '&$focused, &$focusVisible': {
                backgroundColor: theme.palette.action.focus
            },
            '&$disabled': {
                opacity: theme.palette.action.disabledOpacity
            }
        },
        /* Pseudo-class applied to the root element, children wrapper element and `IconButton` component if `expanded={true}`. */ expanded: {},
        /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */ focused: {},
        /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */ focusVisible: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the children wrapper element. */ content: {
            display: 'flex',
            flexGrow: 1,
            transition: theme.transitions.create([
                'margin'
            ], transition),
            margin: '12px 0',
            '&$expanded': {
                margin: '20px 0'
            }
        },
        /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */ expandIcon: {
            transform: 'rotate(0deg)',
            transition: theme.transitions.create('transform', transition),
            '&:hover': {
                // Disable the hover effect for the IconButton,
                // because a hover effect should apply to the entire Expand button and
                // not only to the IconButton.
                backgroundColor: 'transparent'
            },
            '&$expanded': {
                transform: 'rotate(180deg)'
            }
        }
    };
};
var $516680b382b90234$var$AccordionSummary = /*#__PURE__*/ $ieT14.forwardRef(function AccordionSummary(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, expandIcon = props.expandIcon, focusVisibleClassName = props.focusVisibleClassName, _props$IconButtonProp = props.IconButtonProps, IconButtonProps = _props$IconButtonProp === void 0 ? {} : _props$IconButtonProp, onClick = props.onClick, other = (0, $eTwGP.default)(props, [
        "children",
        "classes",
        "className",
        "expandIcon",
        "focusVisibleClassName",
        "IconButtonProps",
        "onClick"
    ]);
    var _React$useContext = $ieT14.useContext((0, $8b593d0afd44c66c$export$2e2bcd8739ae039)), _React$useContext$dis = _React$useContext.disabled, disabled = _React$useContext$dis === void 0 ? false : _React$useContext$dis, expanded = _React$useContext.expanded, toggle = _React$useContext.toggle;
    var handleChange = function handleChange(event) {
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    return /*#__PURE__*/ $ieT14.createElement((0, $51wR9.default), (0, $edxsd.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, $j6s32.default)(classes.root, className, disabled && classes.disabled, expanded && classes.expanded),
        focusVisibleClassName: (0, $j6s32.default)(classes.focusVisible, classes.focused, focusVisibleClassName),
        onClick: handleChange,
        ref: ref
    }, other), /*#__PURE__*/ $ieT14.createElement("div", {
        className: (0, $j6s32.default)(classes.content, expanded && classes.expanded)
    }, children), expandIcon && /*#__PURE__*/ $ieT14.createElement((0, $1KcBP.default), (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.expandIcon, expanded && classes.expanded),
        edge: "end",
        component: "div",
        tabIndex: null,
        role: null,
        "aria-hidden": true
    }, IconButtonProps), expandIcon));
});
var $516680b382b90234$export$2e2bcd8739ae039 = (0, $aIJrd.default)($516680b382b90234$export$9dd6ff9ea0189349, {
    name: 'MuiAccordionSummary'
})($516680b382b90234$var$AccordionSummary);



var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $aIJrd = parcelRequire("aIJrd");
var $754207d318f74219$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'flex',
            padding: theme.spacing(1, 2, 2)
        }
    };
};
var $754207d318f74219$var$AccordionDetails = /*#__PURE__*/ $ieT14.forwardRef(function AccordionDetails(props, ref) {
    var classes = props.classes, className = props.className, other = (0, $eTwGP.default)(props, [
        "classes",
        "className"
    ]);
    return /*#__PURE__*/ $ieT14.createElement("div", (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className),
        ref: ref
    }, other));
});
var $754207d318f74219$export$2e2bcd8739ae039 = (0, $aIJrd.default)($754207d318f74219$export$9dd6ff9ea0189349, {
    name: 'MuiAccordionDetails'
})($754207d318f74219$var$AccordionDetails);


var $18f07e71c772cd3d$exports = {};
"use strict";


Object.defineProperty($18f07e71c772cd3d$exports, "__esModule", {
    value: true
});
$18f07e71c772cd3d$exports.default = void 0;

var $18f07e71c772cd3d$var$React = $633c7dc13d665c5e$exports((parcelRequire("ieT14")));

var $18f07e71c772cd3d$var$_createSvgIcon = $b24015bb0dc2bec9$exports((parcelRequire("3yIjW")));
var $18f07e71c772cd3d$var$_default = (0, $18f07e71c772cd3d$var$_createSvgIcon.default)(/*#__PURE__*/ $18f07e71c772cd3d$var$React.createElement("path", {
    d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');
$18f07e71c772cd3d$exports.default = $18f07e71c772cd3d$var$_default;



var $dxqtw = parcelRequire("dxqtw");

var $1fCJg = parcelRequire("1fCJg");

var $bPjUl = parcelRequire("bPjUl");


var $iwN3n = parcelRequire("iwN3n");

const $b3895a7b2eec895c$var$ExpansionPanel = (0, $aIJrd.default)({
    root: {
        border: `1px solid ${(0, $69ed148db7543104$export$a4867fe9454f37a8)[300]}`,
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0
        },
        '&:before': {
            display: 'none'
        },
        '&$expanded': {
            margin: 'auto'
        }
    },
    expanded: {}
})((0, $a15b543b042fe855$export$2e2bcd8739ae039));
const $b3895a7b2eec895c$var$ExpansionPanelSummary = (0, $aIJrd.default)({
    root: {
        borderBottom: `1px solid ${(0, $69ed148db7543104$export$a4867fe9454f37a8)[300]}`,
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 56
        }
    },
    content: {
        '&$expanded': {
            margin: '12px 0'
        }
    },
    expanded: {}
})((0, $516680b382b90234$export$2e2bcd8739ae039));
const $b3895a7b2eec895c$var$ExpansionPanelDetails = (0, $aIJrd.default)((theme)=>({
        root: {
            padding: theme.spacing(2)
        }
    }))((0, $754207d318f74219$export$2e2bcd8739ae039));
/**
 * @function SimpleExpansionPanel This is an expandable panel that contains a list of checkboxes.
 */ function $b3895a7b2eec895c$var$SimpleExpansionPanel({ typeFields: typeFields, uncheckedFields: uncheckedFields, setUncheckedFields: setUncheckedFields, setFieldValue: setFieldValue, setField: setField }) {
    const [checked, setChecked] = $ieT14.useState(typeFields.fields.map((field)=>field.id).filter((field)=>{
        return uncheckedFields.value.indexOf(field) === -1;
    }));
    const handleToggle = (groupId, value)=>()=>{
            const typeField = typeFields.fields.find((field)=>field.id === value);
            if (typeField.required) return;
            const currentIndex = checked.indexOf(value);
            const newCheckedIds = [
                ...checked
            ];
            if (currentIndex === -1) newCheckedIds.push(value);
            else newCheckedIds.splice(currentIndex, 1);
            setChecked(newCheckedIds);
            updateUncheckedFields(groupId, typeFields, newCheckedIds);
        };
    const updateUncheckedFields = (groupId, typeFields, newChecked)=>{
        const allFields = typeFields.fields.map((field)=>field.id);
        const uncheckedFields = allFields.filter((field)=>!newChecked.includes(field));
        let newState;
        setUncheckedFields((prevState)=>{
            const groupIndex = prevState.findIndex((obj)=>{
                return obj.key === groupId;
            });
            newState = [
                ...prevState
            ];
            newState[groupIndex].value = uncheckedFields;
            return newState;
        });
        setFieldValue(setField, newState);
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($b3895a7b2eec895c$var$ExpansionPanel, {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($b3895a7b2eec895c$var$ExpansionPanelSummary, {
                expandIcon: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($18f07e71c772cd3d$exports))), {}),
                "aria-controls": "panel1a-content",
                id: "panel1a-header",
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h6", {
                    children: typeFields.text
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($b3895a7b2eec895c$var$ExpansionPanelDetails, {
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $dxqtw.default), {
                    dense: true,
                    role: "list",
                    style: {
                        width: '100%'
                    },
                    children: [
                        typeFields.fields.map((field)=>{
                            const labelId = `transfer-list-item-${field.id}-label`;
                            return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $1fCJg.default), {
                                role: "listitem",
                                button: true,
                                onClick: ()=>{
                                    handleToggle(typeFields.value, field.id)();
                                },
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $iwN3n.default), {
                                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8d66a60ef98d2984$export$2e2bcd8739ae039), {
                                            checked: checked.indexOf(field.id) !== -1 || field.required,
                                            disabled: field.required,
                                            tabIndex: -1,
                                            disableRipple: true,
                                            inputProps: {
                                                'aria-labelledby': labelId
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $bPjUl.default), {
                                        id: labelId,
                                        primary: field.name
                                    })
                                ]
                            }, field.id);
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1fCJg.default), {})
                    ]
                })
            })
        ]
    });
}
const $b3895a7b2eec895c$var$ExpansionList = /*#__PURE__*/ $ieT14.memo($b3895a7b2eec895c$var$SimpleExpansionPanel);
var $b3895a7b2eec895c$export$2e2bcd8739ae039 = $b3895a7b2eec895c$var$ExpansionList;




function $306770a5ca799879$export$8b579f221ad9c656() {
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    return (0, $137a3b252d598119$export$dd0a697e1782aedd)([
        'support-allowed-fields'
    ], ()=>{
        return fetchWrapper('api/management/support/request-type-fields');
    }, {
        staleTime: Infinity,
        select: (data)=>{
            return {
                requestTypeFields: data,
                initialHiddenFields: data.map((field)=>({
                        key: field.value,
                        value: []
                    }))
            };
        }
    });
}



var $fRnKy = parcelRequire("fRnKy");

const $d8d275573a76783d$var$ServiceDeskFields = ({ client: client, setFieldValue: setFieldValue })=>{
    const { data: data } = (0, $306770a5ca799879$export$8b579f221ad9c656)();
    // The unchecked service type fields are considered hidden.
    const [hiddenRequestTypeFields, setHiddenRequestTypeFields] = $ieT14.useState();
    $ieT14.useEffect(()=>{
        if (data) {
            if (client.hiddenRequestTypeFields.length == 0) setHiddenRequestTypeFields(data.initialHiddenFields);
            else {
                const defaultHiddenRequestTypesWithSavedTypes = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).unionWith(client.hiddenRequestTypeFields, data.initialHiddenFields, function(group, defaultGroup) {
                    return defaultGroup.key == group.key;
                });
                setHiddenRequestTypeFields(defaultHiddenRequestTypesWithSavedTypes);
            }
        }
    }, [
        data
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h2", {
                className: $77e47b6bc9169ce7$export$897fbb5bd1538ae2,
                children: "Service Desk Fields"
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $77e47b6bc9169ce7$export$faeb8e94f65170b1,
                children: data && hiddenRequestTypeFields && data.requestTypeFields.map((requestTypeFieldsGroup, index)=>{
                    const hiddenRequestTypeFieldsInGroup = hiddenRequestTypeFields.find((hiddenRequestTypeFieldsGroup)=>{
                        return hiddenRequestTypeFieldsGroup.key === requestTypeFieldsGroup.value;
                    });
                    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $b3895a7b2eec895c$export$2e2bcd8739ae039), {
                        typeFields: requestTypeFieldsGroup,
                        uncheckedFields: hiddenRequestTypeFieldsInGroup,
                        setUncheckedFields: setHiddenRequestTypeFields,
                        setFieldValue: setFieldValue,
                        setField: "hiddenRequestTypeFields"
                    }, index);
                })
            })
        ]
    });
};
var $d8d275573a76783d$export$2e2bcd8739ae039 = $d8d275573a76783d$var$ServiceDeskFields;






parcelRequire("ieT14");


const $0ee6d6b77f108c47$var$NavigationWarning = ({ formik: formik, displayDirtyWarning: displayDirtyWarning, confirmNavigationWarning: confirmNavigationWarning, cancleNavigationWarning: cancleNavigationWarning })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $9a2902e239ac61e9$export$2e2bcd8739ae039), {
        open: formik.dirty && displayDirtyWarning,
        closeModal: ()=>{},
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $caf372f84efbe689$export$2e2bcd8739ae039), {
            title: "Confirmation",
            message: "You have unsaved changes. Are you sure you would like to leave?",
            confirmAction: confirmNavigationWarning,
            cancelAction: cancleNavigationWarning
        })
    });
};
var $0ee6d6b77f108c47$export$2e2bcd8739ae039 = $0ee6d6b77f108c47$var$NavigationWarning;


const $30c6316d590b33ab$var$useStyles = (0, $e1ONw.default)({
    brandingInput: {
        display: 'none'
    }
});
const $30c6316d590b33ab$var$ManageClientSchema = $e6c1ba40263f5002$export$185802fd694ee1f5().shape({
    name: $55fd6d44ba3611c9$export$185802fd694ee1f5().required('Name is a required field.'),
    displayName: $55fd6d44ba3611c9$export$185802fd694ee1f5().required('Display name is a required field.'),
    addressOne: $55fd6d44ba3611c9$export$185802fd694ee1f5().required('Address is a required field.'),
    city: $55fd6d44ba3611c9$export$185802fd694ee1f5().required('City is a required field.'),
    state: $111b61f80e1de09e$export$185802fd694ee1f5().integer().positive('State is a required field'),
    zipCode: $55fd6d44ba3611c9$export$185802fd694ee1f5().matches(/^\d{5}$/, 'Zip code must be exactly 5 digits.').required('Zip code is a required field.'),
    firstName: $55fd6d44ba3611c9$export$185802fd694ee1f5().required('First name is a required field.'),
    lastName: $55fd6d44ba3611c9$export$185802fd694ee1f5().required('Last name is a required field.'),
    email: $55fd6d44ba3611c9$export$185802fd694ee1f5().email('Must be valid email.').required('Email is a required field.'),
    phone: $55fd6d44ba3611c9$export$185802fd694ee1f5().matches(/^\([1-9]\d{2}\)\ \d{3}\-\d{4}$|[1-9]\d{9}/, 'Phone must be exactly 10 digits.').required('Phone is a required field.'),
    supportEmail: $55fd6d44ba3611c9$export$185802fd694ee1f5().email('Must be valid email.').required('Support Email is a required field.')
});
/**
 * @function ClientManager Allows a user to view/create/edit a single client's information.
 */ const $30c6316d590b33ab$var$ClientManager = ({ loading: loadingClient, client: client, isNewClient: isNewClient, history: history })=>{
    const classes = $30c6316d590b33ab$var$useStyles();
    const adminsQuery = (0, $92a94bacff6073c7$export$23bc01dde35d50d9)();
    const orgsQuery = (0, $c930e47972554507$export$27f57c1c6f40bdc7)('organizations');
    const reqTypesQuery = (0, $c930e47972554507$export$27f57c1c6f40bdc7)('request-types');
    const fieldsQuery = (0, $306770a5ca799879$export$8b579f221ad9c656)();
    const { createClient: createClient, storeLogo: storeLogo, fetchClientBrandImage: fetchClientBrandImage, editClient: editClient } = (0, $c400040bbf0b66f7$export$2e2bcd8739ae039)();
    const [mutationError, setMutationError] = $ieT14.useState('');
    //Brand image file for uploading
    const [brandImageFile, setBrandImageFile] = $ieT14.useState(null);
    //Brand image for viewing
    const [brandImageSrc, setBrandImageSrc] = $ieT14.useState('');
    const [displayDirtyWarning, setDisplayDirtyWarning] = $ieT14.useState(false);
    const [confirmedNavigation, setConfirmedNavigation] = $ieT14.useState(false);
    const [blockedLocation, setBlockedLocation] = $ieT14.useState('');
    const unblock = (0, $ieT14.useRef)(null);
    const formikRef = (0, $ieT14.useRef)(null);
    $ieT14.useEffect(()=>{
        // Block history actions and register a function to call instead, unblocking if the form is unchanged
        unblock.current = history.block((location)=>{
            if (formikRef.current !== null && formikRef.current.dirty) {
                setDisplayDirtyWarning(true);
                setBlockedLocation(location.pathname);
                return false;
            } else unblock.current();
        });
    }, []);
    $ieT14.useEffect(()=>{
        if (confirmedNavigation) {
            unblock.current();
            history.push(blockedLocation);
        }
    }, [
        confirmedNavigation
    ]);
    $ieT14.useEffect(()=>{
        if (brandImageFile !== null) {
            let reader = new FileReader();
            reader.onload = (event)=>{
                setBrandImageSrc(event.target.result);
            };
            reader.readAsDataURL(brandImageFile);
        }
    }, [
        brandImageFile
    ]);
    $ieT14.useEffect(()=>{
        if (!isNewClient && !loadingClient && client.brandImage != null && client.brandImage !== '') setBrandImageSrc(fetchClientBrandImage(client.brandImage));
    }, [
        loadingClient,
        isNewClient
    ]);
    const handleCancel = (dirty)=>{
        if (!dirty) unblock.current();
        history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Home);
    };
    const handleSubmit = async (values, { setSubmitting: setSubmitting })=>{
        setSubmitting(true);
        values.phone = values.phone.match(/\d+/g).join('');
        try {
            // message is a string containing the integer id of the updated client
            let response;
            if (isNewClient) response = await createClient(values);
            else response = await editClient(values);
            if (response.success && brandImageFile != null) await storeLogo(Number(response.message), brandImageFile);
            setSubmitting(false);
            unblock.current();
            history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Home);
        } catch (err) {
            setMutationError(err.message);
            setSubmitting(false);
        }
    };
    if (loadingClient || adminsQuery.isLoading || orgsQuery.isLoading || reqTypesQuery.isLoading || fieldsQuery.isLoading) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        className: "loadingIndicator",
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
    });
    if (adminsQuery.isError || orgsQuery.isError || reqTypesQuery.isError || fieldsQuery.isError) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
        type: "error",
        message: "Error loading management options"
    });
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
        children: [
            mutationError && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
                type: "error",
                message: mutationError
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8FQwk.Formik), {
                innerRef: formikRef,
                initialValues: client,
                validationSchema: $30c6316d590b33ab$var$ManageClientSchema,
                onSubmit: (values, formikHelpers)=>handleSubmit(values, formikHelpers),
                children: (formik)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("form", {
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8FQwk.FormikConsumer), {
                                children: (formik)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $0ee6d6b77f108c47$export$2e2bcd8739ae039), {
                                        formik: formik,
                                        displayDirtyWarning: displayDirtyWarning,
                                        confirmNavigationWarning: ()=>{
                                            setConfirmedNavigation(true);
                                            history.push(blockedLocation);
                                        },
                                        cancleNavigationWarning: ()=>setDisplayDirtyWarning(false)
                                    })
                            }),
                            formik.isSubmitting && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                className: $fdbf0d9f77db804d$export$29dd17c7f3c81c36,
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                    className: $fdbf0d9f77db804d$export$9a0dd4d839a90927,
                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("fieldset", {
                                className: $fdbf0d9f77db804d$export$a38812d1aa1302d9,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h2", {
                                        className: $77e47b6bc9169ce7$export$897fbb5bd1538ae2,
                                        children: "Details"
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                        className: $fdbf0d9f77db804d$export$f40c3b93aa85e075,
                                        children: [
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.OutlinedInput), {
                                                id: "name",
                                                label: "Name",
                                                name: "name",
                                                ...formik.getFieldProps('name'),
                                                error: formik.errors.name && formik.touched.name,
                                                helperText: formik.touched.name && formik.errors.name,
                                                required: true
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.OutlinedInput), {
                                                id: "displayName",
                                                label: "Display Name",
                                                ...formik.getFieldProps('displayName'),
                                                error: formik.errors.displayName && formik.touched.displayName,
                                                helperText: formik.touched.displayName && formik.errors.displayName,
                                                required: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.OutlinedInput), {
                                        id: "description",
                                        label: "Description",
                                        ...formik.getFieldProps('description'),
                                        value: formik.values.description || ''
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                        className: $fdbf0d9f77db804d$export$f40c3b93aa85e075,
                                        children: [
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.OutlinedInput), {
                                                id: "addressOne",
                                                label: "Address",
                                                ...formik.getFieldProps('addressOne'),
                                                error: formik.errors.addressOne && formik.touched.addressOne,
                                                helperText: formik.touched.addressOne && formik.errors.addressOne,
                                                required: true
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.OutlinedInput), {
                                                id: "addressTwo",
                                                label: "Address Two",
                                                ...formik.getFieldProps('addressTwo'),
                                                value: formik.values.addressTwo || ''
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                        className: $fdbf0d9f77db804d$export$228bcabfee25bcc7,
                                        children: [
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.OutlinedInput), {
                                                id: "city",
                                                label: "City",
                                                ...formik.getFieldProps('city'),
                                                error: formik.errors.city && formik.touched.city,
                                                helperText: formik.touched.city && formik.errors.city,
                                                required: true
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.OutlinedSelect), {
                                                id: "state",
                                                title: "State",
                                                value: formik.values.state,
                                                handleChange: formik.handleChange,
                                                handleBlur: formik.handleBlur,
                                                options: [
                                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("option", {
                                                        value: 0
                                                    }, "none"),
                                                    ...(0, (/*@__PURE__*/$parcel$interopDefault($1660499e25144ef7$exports))).map((state, index)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("option", {
                                                            value: index + 1,
                                                            children: state.name
                                                        }, state.abbreviation))
                                                ],
                                                error: 'state' in formik.errors && formik.touched.state,
                                                selectProps: {
                                                    displayEmpty: true
                                                },
                                                required: true
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.OutlinedInput), {
                                                id: "zipCode",
                                                label: "Zip Code",
                                                ...formik.getFieldProps('zipCode'),
                                                error: formik.errors.zipCode && formik.touched.zipCode,
                                                helperText: formik.touched.zipCode && formik.errors.zipCode,
                                                required: true
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("fieldset", {
                                className: $fdbf0d9f77db804d$export$a38812d1aa1302d9,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h2", {
                                        className: $77e47b6bc9169ce7$export$897fbb5bd1538ae2,
                                        children: "Primary Contact"
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                        className: $fdbf0d9f77db804d$export$f40c3b93aa85e075,
                                        children: [
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.OutlinedInput), {
                                                id: "firstName",
                                                label: "First Name",
                                                ...formik.getFieldProps('firstName'),
                                                error: formik.errors.firstName && formik.touched.firstName,
                                                helperText: formik.touched.firstName && formik.errors.firstName,
                                                required: true
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.OutlinedInput), {
                                                id: "lastName",
                                                label: "Last Name",
                                                ...formik.getFieldProps('lastName'),
                                                error: formik.errors.lastName && formik.touched.lastName,
                                                helperText: formik.touched.lastName && formik.errors.lastName,
                                                required: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                        className: $fdbf0d9f77db804d$export$f40c3b93aa85e075,
                                        children: [
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.OutlinedInput), {
                                                id: "email",
                                                label: "Email",
                                                ...formik.getFieldProps('email'),
                                                error: formik.errors.email && formik.touched.email,
                                                helperText: formik.touched.email && formik.errors.email,
                                                required: true
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.OutlinedInput), {
                                                id: "phone",
                                                label: "Phone",
                                                ...formik.getFieldProps('phone'),
                                                error: formik.errors.phone && formik.touched.phone,
                                                helperText: formik.touched.phone && formik.errors.phone,
                                                InputProps: {
                                                    inputComponent: (0, $fgoQ6.PhoneInputMask)
                                                },
                                                required: true
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("fieldset", {
                                className: $fdbf0d9f77db804d$export$a38812d1aa1302d9,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h2", {
                                        className: $77e47b6bc9169ce7$export$897fbb5bd1538ae2,
                                        children: "Configuration"
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.OutlinedInput), {
                                        id: "supportEmail",
                                        label: "Support Email",
                                        ...formik.getFieldProps('supportEmail'),
                                        error: formik.errors.supportEmail && formik.touched.supportEmail,
                                        helperText: formik.errors.supportEmail && formik.touched.supportEmail && formik.errors.supportEmail,
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("fieldset", {
                                className: $fdbf0d9f77db804d$export$a38812d1aa1302d9,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h2", {
                                        className: $77e47b6bc9169ce7$export$897fbb5bd1538ae2,
                                        children: "Settings"
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $87c09cb75a62e14f$export$2e2bcd8739ae039), {
                                        id: "status",
                                        value: formik.values.status,
                                        handleChange: formik.handleChange,
                                        label: "Status"
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $87c09cb75a62e14f$export$2e2bcd8739ae039), {
                                        id: "enableServiceDesk",
                                        value: formik.values.enableServiceDesk,
                                        handleChange: formik.handleChange,
                                        label: "Service Desk"
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $87c09cb75a62e14f$export$2e2bcd8739ae039), {
                                        id: "enableSegmentation",
                                        value: formik.values.enableSegmentation,
                                        handleChange: formik.handleChange,
                                        label: "Fan Segmentation"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("fieldset", {
                                className: $fdbf0d9f77db804d$export$a38812d1aa1302d9,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h2", {
                                        className: $77e47b6bc9169ce7$export$897fbb5bd1538ae2,
                                        children: "Branding"
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                        style: {
                                            marginTop: 16
                                        },
                                        children: [
                                            brandImageSrc !== '' && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("img", {
                                                    src: brandImageSrc,
                                                    alt: "Brand Image",
                                                    style: {
                                                        maxWidth: 48,
                                                        height: 'auto',
                                                        marginBottom: 16
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("input", {
                                                accept: "image/*",
                                                className: classes.brandingInput,
                                                id: "brandImage",
                                                multiple: true,
                                                type: "file",
                                                onChange: (event)=>{
                                                    setBrandImageFile(event.target.files[0]);
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("label", {
                                                htmlFor: "brandImage",
                                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryButton), {
                                                    variant: "contained",
                                                    component: "span",
                                                    text: "Choose Company Logo File",
                                                    title: "Choose Company Logo File",
                                                    preventDefault: false,
                                                    handleClick: ()=>false
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("fieldset", {
                                className: $fdbf0d9f77db804d$export$a38812d1aa1302d9,
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $765884c7df24d4a0$export$2e2bcd8739ae039), {
                                    client: client,
                                    setFieldValue: formik.setFieldValue
                                })
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("fieldset", {
                                className: $fdbf0d9f77db804d$export$a38812d1aa1302d9,
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $768f2b973bd8283b$export$2e2bcd8739ae039), {
                                    client: client,
                                    setFieldValue: formik.setFieldValue,
                                    supportType: "organizations"
                                })
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("fieldset", {
                                className: $fdbf0d9f77db804d$export$a38812d1aa1302d9,
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $768f2b973bd8283b$export$2e2bcd8739ae039), {
                                    client: client,
                                    setFieldValue: formik.setFieldValue,
                                    supportType: "request-types"
                                })
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("fieldset", {
                                className: $fdbf0d9f77db804d$export$a38812d1aa1302d9,
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $d8d275573a76783d$export$2e2bcd8739ae039), {
                                    client: client,
                                    setFieldValue: formik.setFieldValue
                                })
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                className: $fdbf0d9f77db804d$export$135180a04c5d6085,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.TertiaryButton), {
                                        text: "Cancel",
                                        title: "Cancel",
                                        component: "button",
                                        handleClick: ()=>{
                                            handleCancel(formik.dirty);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                        className: $fdbf0d9f77db804d$export$d675b3969e4857cb,
                                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $07d7e09497a42e25$export$2e2bcd8739ae039), {
                                            text: "Save",
                                            title: "Save",
                                            deactive: formik.isSubmitting || !formik.isValid,
                                            handleClick: formik.handleSubmit
                                        })
                                    })
                                ]
                            })
                        ]
                    })
            })
        ]
    });
};
var $30c6316d590b33ab$export$2e2bcd8739ae039 = (0, $eYoAG.withRouter)($30c6316d590b33ab$var$ClientManager);


const $b12c3eb296716e23$var$AddClient = ()=>{
    let client = {
        name: '',
        displayName: '',
        supportEmail: '',
        brandImage: '',
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        description: '',
        addressOne: '',
        addressTwo: '',
        city: '',
        state: 0,
        zipCode: '',
        status: true,
        enableServiceDesk: false,
        enableSegmentation: false,
        assignedAdministrators: [],
        assignedUsers: [],
        assignedOrganizations: [],
        assignedRequestTypes: [],
        hiddenRequestTypeFields: []
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h1", {
                children: "Add Client"
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $30c6316d590b33ab$export$2e2bcd8739ae039), {
                client: client,
                isNewClient: true
            })
        ]
    });
};
var $b12c3eb296716e23$export$2e2bcd8739ae039 = $b12c3eb296716e23$var$AddClient;




var $ieT14 = parcelRequire("ieT14");
var $d12ed4b155edf633$export$3481c78889e8fbe8;
var $d12ed4b155edf633$export$c4b0f5819f6a6663;
var $d12ed4b155edf633$export$34e0f9847d4c02dd;
var $d12ed4b155edf633$export$a7db06668cad9adb;
var $d12ed4b155edf633$export$83f0b0882024f2e3;
var $d12ed4b155edf633$export$52cee236c7e4c7ca;
var $d12ed4b155edf633$export$38e42c68cf43b5d4;
var $d12ed4b155edf633$export$3f6d243f5dbc1961;
var $d12ed4b155edf633$export$57ad902a600ecd80;
var $d12ed4b155edf633$export$e7d47881ec916f76;
$d12ed4b155edf633$export$3481c78889e8fbe8 = `M3Wn7G_center`;
$d12ed4b155edf633$export$c4b0f5819f6a6663 = `M3Wn7G_circularProgress`;
$d12ed4b155edf633$export$34e0f9847d4c02dd = `M3Wn7G_container`;
$d12ed4b155edf633$export$a7db06668cad9adb = `M3Wn7G_content`;
$d12ed4b155edf633$export$83f0b0882024f2e3 = `M3Wn7G_departmentCol`;
$d12ed4b155edf633$export$52cee236c7e4c7ca = `M3Wn7G_emailCol`;
$d12ed4b155edf633$export$38e42c68cf43b5d4 = `M3Wn7G_header`;
$d12ed4b155edf633$export$3f6d243f5dbc1961 = `M3Wn7G_resultsCount`;
$d12ed4b155edf633$export$57ad902a600ecd80 = `M3Wn7G_scrollTable`;
$d12ed4b155edf633$export$e7d47881ec916f76 = `M3Wn7G_tableWrapper`;




var $ieT14 = parcelRequire("ieT14");


/**
 * usePaginatedUsers
 * @function usePaginatedUsers - Custom hook for the user management page, with pagination context
 */ const $6506ad6ffb96e4a6$var$usePaginatedUsers = ()=>{
    const { loading: loading, dispatch: dispatch, results: results, totalResults: totalResults } = $ieT14.useContext((0, $dee37b87a49977d2$export$f97ffeb8e877952b));
    const { getAuth: getAuth } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    /**
   * fetchUsersPage
   * @function fetchUsers - Fetches the users from the backend and sets them to the state
   * @param options - FetchOptions
   */ const fetchUsers = ({ currentPage: currentPage, pageSize: pageSize, searchTerm: searchTerm, orderColumn: orderColumn, orderDirection: orderDirection })=>{
        dispatch({
            loading: true
        });
        let queryParams = `?page=${currentPage}&pageSize=${pageSize}`;
        if (!(searchTerm === null || searchTerm === undefined) && searchTerm.trim() !== '') queryParams += `&searchTerm=${searchTerm}`;
        if (orderColumn != null) queryParams += `&sort=${orderColumn}`;
        if (orderDirection != null) queryParams += `&sortDirection=${orderDirection}`;
        return getAuth(`api/users${queryParams}`).then((response)=>{
            dispatch({
                loading: false,
                currentPage: currentPage,
                pageSize: pageSize,
                results: response.results,
                totalResults: response.totalItems,
                orderColumn: orderColumn,
                orderDirection: orderDirection,
                searchTerm: searchTerm
            });
        }).catch(()=>console.log('Failed to get users.'));
    };
    /**
   * fetchAllUsers
   * @function fetchAllUsers - Fetches all users without pagination
   * @param options fetch options object: searchTerm, orderColumn, orderDirection
   */ const fetchAllUsers = ({ searchTerm: searchTerm, orderColumn: orderColumn, orderDirection: orderDirection })=>{
        let queryParams = `?page=1&pageSize=0`;
        if (!(searchTerm === null || searchTerm === undefined) && searchTerm.trim() !== '') queryParams += `&searchTerm=${searchTerm}`;
        if (orderColumn != null) queryParams += `&sort=${orderColumn}`;
        if (orderDirection != null) queryParams += `&sortDirection=${orderDirection}`;
        return getAuth(`api/users${queryParams}`);
    };
    return {
        loading: loading,
        results: results,
        fetchUsers: fetchUsers,
        fetchAllUsers: fetchAllUsers,
        totalResults: totalResults
    };
};
var $6506ad6ffb96e4a6$export$2e2bcd8739ae039 = $6506ad6ffb96e4a6$var$usePaginatedUsers;





var $fpdl2 = parcelRequire("fpdl2");


var $ieT14 = parcelRequire("ieT14");




parcelRequire("ieT14");

var $2b84cffcdcc80653$export$53a7de2d42d4bd9e = /*#__PURE__*/ function(UserOktaStatus) {
    UserOktaStatus["STAGED"] = "Staged";
    UserOktaStatus["PROVISIONED"] = "	Pending User Action";
    UserOktaStatus["ACTIVE"] = "Active";
    UserOktaStatus["RECOVERY"] = "	Password Reset";
    UserOktaStatus["PASSWORD_EXPIRED"] = "Password Expired";
    UserOktaStatus["LOCKED_OUT"] = "Locked Out";
    UserOktaStatus["SUSPENDED"] = "Suspended";
    UserOktaStatus["DEPROVISIONED"] = "Deactivated";
    return UserOktaStatus;
}({});



var $eYoAG = parcelRequire("eYoAG");



/**
 * UserEntry
 * @function UserEntry
 */ const $b0275f178cc5fc4e$var$UserEntry = ({ user: user, setErrorMessage: setErrorMessage, setSuccessMessage: setSuccessMessage, history: history })=>{
    const { inviteUser: inviteUser } = (0, $b19aa392df0f3838$export$2e2bcd8739ae039)();
    const redirectToEditUserId = (userId)=>{
        history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).EditUser.replace(':userId', userId.toString()));
    };
    const handleInvite = ()=>{
        inviteUser(user).then((response)=>{
            if (response.success) setSuccessMessage(response.message);
            else setErrorMessage(response.message);
        }).catch((err)=>{
            setErrorMessage(err.responseJSON.message);
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("td", {
                children: [
                    user.lastName,
                    ", ",
                    user.firstName
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                children: user.role
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                className: $d12ed4b155edf633$export$52cee236c7e4c7ca,
                title: user.email,
                children: user.email
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                title: user.department,
                children: user.department
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                children: (0, $2b84cffcdcc80653$export$53a7de2d42d4bd9e)[user.status] ?? 'Unknown'
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fcd3b8c5e9a7038b$export$2e2bcd8739ae039), {
                    text: "Edit User",
                    title: "Edit User",
                    handleClick: ()=>redirectToEditUserId(user.id)
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fcd3b8c5e9a7038b$export$2e2bcd8739ae039), {
                    text: "Invite User",
                    title: "Invite User",
                    handleClick: handleInvite
                })
            })
        ]
    });
};
var $b0275f178cc5fc4e$export$2e2bcd8739ae039 = (0, $eYoAG.withRouter)($b0275f178cc5fc4e$var$UserEntry);








const $20d56db6f2aed740$var$UserTable = ({ loading: loading, setErrorMessage: setErrorMessage, setSuccessMessage: setSuccessMessage })=>{
    const { results: results, orderColumn: orderColumn, orderDirection: orderDirection, pageSize: pageSize, searchTerm: searchTerm } = $ieT14.useContext((0, $dee37b87a49977d2$export$f97ffeb8e877952b));
    const { fetchUsers: fetchUsers } = (0, $6506ad6ffb96e4a6$export$2e2bcd8739ae039)();
    const reorderHandler = (orderColumn, orderDirection)=>{
        fetchUsers({
            currentPage: 1,
            pageSize: pageSize,
            orderColumn: orderColumn,
            orderDirection: orderDirection,
            searchTerm: searchTerm
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        className: $d12ed4b155edf633$export$e7d47881ec916f76,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
            style: {
                height: '90%'
            },
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5d10f0a7aadd7c8c$exports))), {
                className: $d12ed4b155edf633$export$57ad902a600ecd80,
                autoHide: true,
                universal: true,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $0cbf74840f7b6287$export$2e2bcd8739ae039), {
                    loading: loading,
                    results: results,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $0cd938f964be002d$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                    title: "Name",
                                    scope: "col",
                                    orderField: (0, $fe0b3f9952d5826a$export$5468e3184eb0a928).Name,
                                    orderColumn: orderColumn,
                                    orderDirection: orderDirection,
                                    reorderHandler: reorderHandler
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                    title: "User Type",
                                    scope: "col",
                                    orderField: (0, $fe0b3f9952d5826a$export$5468e3184eb0a928).UserType,
                                    orderColumn: orderColumn,
                                    orderDirection: orderDirection,
                                    reorderHandler: reorderHandler
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                    title: "Email",
                                    scope: "col",
                                    orderField: (0, $fe0b3f9952d5826a$export$5468e3184eb0a928).Email,
                                    orderColumn: orderColumn,
                                    orderDirection: orderDirection,
                                    reorderHandler: reorderHandler
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                    title: "Company",
                                    scope: "col",
                                    orderField: (0, $fe0b3f9952d5826a$export$5468e3184eb0a928).Department,
                                    orderColumn: orderColumn,
                                    orderDirection: orderDirection,
                                    reorderHandler: reorderHandler
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                    title: "Status",
                                    scope: "col",
                                    orderField: (0, $fe0b3f9952d5826a$export$5468e3184eb0a928).Status,
                                    orderColumn: orderColumn,
                                    orderDirection: orderDirection,
                                    reorderHandler: reorderHandler
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                    title: ""
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                    title: ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $a282f935ed3e599f$export$2e2bcd8739ae039), {
                            children: !results || results.length === 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                    children: "There are no users."
                                })
                            }) : results.map((results, index)=>{
                                return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $b0275f178cc5fc4e$export$2e2bcd8739ae039), {
                                    user: results,
                                    setErrorMessage: setErrorMessage,
                                    setSuccessMessage: setSuccessMessage
                                }, index);
                            })
                        })
                    ]
                })
            })
        })
    });
};
var $20d56db6f2aed740$export$2e2bcd8739ae039 = $20d56db6f2aed740$var$UserTable;





var $eYoAG = parcelRequire("eYoAG");





const $548cfd5b251cff06$var$Users = ()=>{
    const { pageSize: pageSize, currentPage: currentPage, orderColumn: orderColumn, orderDirection: orderDirection } = $ieT14.useContext((0, $dee37b87a49977d2$export$f97ffeb8e877952b));
    const { loading: loading, results: results, totalResults: totalResults, fetchUsers: fetchUsers } = (0, $6506ad6ffb96e4a6$export$2e2bcd8739ae039)();
    const { searchQuery: searchTerm, updateSearchQuery: updateSearchQuery, setIsSearching: setIsSearching } = (0, $b48f023b055940c4$export$2e2bcd8739ae039)();
    const announcementCount = 0; //Announcements are not shown on management UI, so there is no need to get the real count
    const [redirectToAddUser, setRedirectToAddUser] = $ieT14.useState(false);
    const { successMessage: successMessage, setSuccessMessage: setSuccessMessage, errorMessage: errorMessage, setErrorMessage: setErrorMessage } = (0, $dc97b0794e0fd33b$export$2e2bcd8739ae039)();
    const { measuredRef: measuredRef, dimensions: dimensions } = (0, $d9ed1b1da5a3379c$export$2e2bcd8739ae039)([
        results,
        announcementCount,
        successMessage,
        errorMessage
    ], true);
    // Fetches the user information for the page on mount
    $ieT14.useEffect(()=>{
        fetchUsers({
            currentPage: currentPage,
            pageSize: pageSize,
            searchTerm: searchTerm,
            orderColumn: orderColumn,
            orderDirection: orderDirection
        });
    }, []);
    if (redirectToAddUser) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Redirect), {
        push: true,
        to: {
            pathname: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).AddUser
        }
    });
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $d12ed4b155edf633$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $d12ed4b155edf633$export$38e42c68cf43b5d4,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center'
                        },
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h1", {
                                children: "Users"
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f5afe0f42548a953$export$2e2bcd8739ae039), {
                                text: "Add a User",
                                title: "Add a User",
                                handleClick: ()=>setRedirectToAddUser(true)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $00cebbc6f72b4773$export$2e2bcd8739ae039), {
                        value: searchTerm,
                        updateValue: (val)=>updateSearchQuery(val),
                        setIsSearching: (searching)=>setIsSearching(searching),
                        placeholder: 'Search Users',
                        submitHandler: ()=>fetchUsers({
                                currentPage: 1,
                                pageSize: pageSize,
                                searchTerm: searchTerm,
                                orderColumn: orderColumn,
                                orderDirection: orderDirection
                            })
                    })
                ]
            }),
            errorMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $cd9e5d573af72510$export$2e2bcd8739ae039), {
                message: errorMessage
            }),
            successMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $00b96652cf9f9fb7$export$2e2bcd8739ae039), {
                message: successMessage
            }),
            loading && results.length === 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $d12ed4b155edf633$export$c4b0f5819f6a6663,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
            }) : !results || results.length === 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                children: "There are no users."
            }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $d12ed4b155edf633$export$3481c78889e8fbe8,
                ref: measuredRef,
                style: {
                    height: `calc(100vh - ${dimensions ? 20 + dimensions.top : 0}px`
                },
                children: [
                    loading && results.length > 0 || loading && results.length === 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: $d12ed4b155edf633$export$c4b0f5819f6a6663,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
                    }) : null,
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        className: $d12ed4b155edf633$export$a7db06668cad9adb,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                                    className: $d12ed4b155edf633$export$3f6d243f5dbc1961,
                                    children: [
                                        totalResults,
                                        " results"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $20d56db6f2aed740$export$2e2bcd8739ae039), {
                                loading: loading,
                                setErrorMessage: setErrorMessage,
                                setSuccessMessage: setSuccessMessage
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f021d555e7f7d483$export$2e2bcd8739ae039), {
                        fetchResults: fetchUsers,
                        paginatedContext: (0, $dee37b87a49977d2$export$f97ffeb8e877952b),
                        searchTerm: searchTerm
                    })
                ]
            })
        ]
    });
};
var $548cfd5b251cff06$export$2e2bcd8739ae039 = $548cfd5b251cff06$var$Users;



parcelRequire("ieT14");



var $ieT14 = parcelRequire("ieT14");

var $8FQwk = parcelRequire("8FQwk");





var $fpdl2 = parcelRequire("fpdl2");
var $e1ONw = parcelRequire("e1ONw");


var $eYoAG = parcelRequire("eYoAG");








/**
 * useTag
 * @function useTag - Custom hook for the tag models
 */ const $ddc981f711f942ee$var$useTag = ()=>{
    const { getAuth: getAuth, postAuth: postAuth, putAuth: putAuth, deleteAuth: deleteAuth } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    const fetchTags = (clientId)=>{
        return getAuth(`api/${clientId}/tags`);
    };
    const fetchTag = (clientId, tagId)=>{
        return getAuth(`api/${clientId}/tags/${tagId}`);
    };
    const createTag = (clientId, tagName)=>{
        return postAuth(`api/${clientId}/tags`, tagName);
    };
    const deleteTag = (clientId, tagId)=>{
        return deleteAuth(`api/${clientId}/tags/${tagId}`);
    };
    const updateTag = (clientId, tagId, data)=>{
        return putAuth(`api/${clientId}/tags/${tagId}`, data);
    };
    return {
        fetchTags: fetchTags,
        fetchTag: fetchTag,
        createTag: createTag,
        deleteTag: deleteTag,
        updateTag: updateTag
    };
};
var $ddc981f711f942ee$export$2e2bcd8739ae039 = $ddc981f711f942ee$var$useTag;




var $ieT14 = parcelRequire("ieT14");

var $1KcBP = parcelRequire("1KcBP");
var $1fCJg = parcelRequire("1fCJg");
var $iwN3n = parcelRequire("iwN3n");
var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $aIJrd = parcelRequire("aIJrd");
var $105db2ddc246141f$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        position: 'absolute',
        right: 16,
        top: '50%',
        transform: 'translateY(-50%)'
    }
};
/**
 * Must be used as the last child of ListItem to function properly.
 */ var $105db2ddc246141f$var$ListItemSecondaryAction = /*#__PURE__*/ $ieT14.forwardRef(function ListItemSecondaryAction(props, ref) {
    var classes = props.classes, className = props.className, other = (0, $eTwGP.default)(props, [
        "classes",
        "className"
    ]);
    return /*#__PURE__*/ $ieT14.createElement("div", (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className),
        ref: ref
    }, other));
});
$105db2ddc246141f$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $105db2ddc246141f$export$2e2bcd8739ae039 = (0, $aIJrd.default)($105db2ddc246141f$export$9dd6ff9ea0189349, {
    name: 'MuiListItemSecondaryAction'
})($105db2ddc246141f$var$ListItemSecondaryAction);


var $bPjUl = parcelRequire("bPjUl");
var $e1ONw = parcelRequire("e1ONw");


parcelRequire("ieT14");
var $f0f2faa401380369$export$b0377cbbbdab6cba;
var $f0f2faa401380369$export$f27f0a643498ce3d;
var $f0f2faa401380369$export$b00c055587dc7469;
var $f0f2faa401380369$export$b1a09d22b7ad6c4;
var $f0f2faa401380369$export$509f3108fdd206bb;
var $f0f2faa401380369$export$42ff741d2868ee32;
var $f0f2faa401380369$export$8c430709db82137d;
var $f0f2faa401380369$export$2d4b1211b4389c3b;
var $f0f2faa401380369$export$3832be13857745bc;
var $f0f2faa401380369$export$f4c68800b094ddb1;
var $f0f2faa401380369$export$96e4b36520c26a2c;
var $f0f2faa401380369$export$34e0f9847d4c02dd;
var $f0f2faa401380369$export$63ff2205e9e2843e;
var $f0f2faa401380369$export$38e42c68cf43b5d4;
var $f0f2faa401380369$export$fb184b623420d9be;
var $f0f2faa401380369$export$c96745152eb2740f;
var $f0f2faa401380369$export$148f1d8a17c0f2b1;
var $f0f2faa401380369$export$6386a1eb4a158302;
var $f0f2faa401380369$export$471f7ae5c4103ae1;
var $f0f2faa401380369$export$a7db06668cad9adb;
$f0f2faa401380369$export$b0377cbbbdab6cba = "#006da8";
$f0f2faa401380369$export$f27f0a643498ce3d = "#00aafc";
$f0f2faa401380369$export$b00c055587dc7469 = "#f5dbd9";
$f0f2faa401380369$export$b1a09d22b7ad6c4 = "#c92100";
$f0f2faa401380369$export$509f3108fdd206bb = "#ebafa6";
$f0f2faa401380369$export$42ff741d2868ee32 = "#074f86";
$f0f2faa401380369$export$8c430709db82137d = "#dadada";
$f0f2faa401380369$export$2d4b1211b4389c3b = "#dddbda";
$f0f2faa401380369$export$3832be13857745bc = "#eae9ed";
$f0f2faa401380369$export$f4c68800b094ddb1 = "#e9e8f4";
$f0f2faa401380369$export$96e4b36520c26a2c = "modal_47a5ca";
$f0f2faa401380369$export$34e0f9847d4c02dd = "container_47a5ca";
$f0f2faa401380369$export$63ff2205e9e2843e = "exitButton_47a5ca";
$f0f2faa401380369$export$38e42c68cf43b5d4 = "header_47a5ca";
$f0f2faa401380369$export$fb184b623420d9be = "title_47a5ca";
$f0f2faa401380369$export$c96745152eb2740f = "subtitle_47a5ca";
$f0f2faa401380369$export$148f1d8a17c0f2b1 = "mainTitle_47a5ca";
$f0f2faa401380369$export$6386a1eb4a158302 = "withoutSubtitle_47a5ca";
$f0f2faa401380369$export$471f7ae5c4103ae1 = "status_47a5ca";
$f0f2faa401380369$export$a7db06668cad9adb = "content_47a5ca";



var $1KcBP = parcelRequire("1KcBP");
var $fVNJ1 = parcelRequire("fVNJ1");

var $l1pHr = parcelRequire("l1pHr");

var $j6s32 = parcelRequire("j6s32");
/**
 * ModalDialog
 * @function ModalDialog - Base modal with header and close icon button
 */ const $3c302b0d44a45917$var$ModalDialog = ({ isOpen: isOpen, onClose: onClose, subtitle: subtitle, title: title, status: status, children: children, width: width })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fVNJ1.default), {
        className: $f0f2faa401380369$export$96e4b36520c26a2c,
        style: {
            width: width
        },
        open: isOpen,
        onClose: (isOpen, option)=>onClose(!isOpen, option),
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
            className: $f0f2faa401380369$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                    onClick: ()=>onClose(!isOpen, null),
                    size: "small",
                    className: $f0f2faa401380369$export$63ff2205e9e2843e,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $l1pHr.default), {})
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    className: $f0f2faa401380369$export$38e42c68cf43b5d4,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                            className: $f0f2faa401380369$export$fb184b623420d9be,
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("p", {
                                    className: $f0f2faa401380369$export$c96745152eb2740f,
                                    children: subtitle
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("p", {
                                    className: (0, $j6s32.default)($f0f2faa401380369$export$148f1d8a17c0f2b1, !subtitle && $f0f2faa401380369$export$6386a1eb4a158302),
                                    children: title
                                })
                            ]
                        }),
                        status && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("p", {
                            className: $f0f2faa401380369$export$471f7ae5c4103ae1,
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                    className: "label1",
                                    children: "Status:"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                    className: "body1",
                                    children: status
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: $f0f2faa401380369$export$a7db06668cad9adb,
                    children: children
                })
            ]
        })
    });
};
var $3c302b0d44a45917$export$2e2bcd8739ae039 = $3c302b0d44a45917$var$ModalDialog;



var $ieT14 = parcelRequire("ieT14");
function $a7347f5558ecc977$var$useModal() {
    const [modalIsOpen, setModalIsOpen] = $ieT14.useState(false);
    const openModal = ()=>setModalIsOpen(true);
    const closeModal = ()=>setModalIsOpen(false);
    return {
        modalIsOpen: modalIsOpen,
        openModal: openModal,
        closeModal: closeModal
    };
}
var $a7347f5558ecc977$export$2e2bcd8739ae039 = $a7347f5558ecc977$var$useModal;




var $ieT14 = parcelRequire("ieT14");

var $knRao = parcelRequire("knRao");
var $dxqtw = parcelRequire("dxqtw");
var $1fCJg = parcelRequire("1fCJg");
var $iwN3n = parcelRequire("iwN3n");
var $bPjUl = parcelRequire("bPjUl");
var $e1ONw = parcelRequire("e1ONw");
var $lwgYO = parcelRequire("lwgYO");
var $356Vi = parcelRequire("356Vi");






var $8FQwk = parcelRequire("8FQwk");

const $03002c6dd309d083$var$useStyles = (0, $e1ONw.default)({
    paper: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 200,
        width: '100%',
        overflow: 'auto',
        border: `1px solid ${(0, $69ed148db7543104$export$a4867fe9454f37a8)[300]}`,
        boxShadow: 'none',
        minHeight: '200px',
        maxHeight: '400px',
        margin: '0'
    },
    list: {
        flex: 1
    },
    selectAll: {
        color: (0, $69ed148db7543104$export$2aa0182783e7e9de)[600],
        textTransform: 'uppercase',
        position: 'sticky',
        bottom: 0,
        boxSizing: 'border-box',
        width: '100%',
        margin: 0,
        padding: '8px 16px',
        backgroundColor: 'white'
    },
    loading: {
        display: 'flex',
        justifyContent: 'center'
    },
    modalActionFooter: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: '10px',
        '& button': {
            width: '70px'
        }
    },
    sectionHeadings: {
        fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).heading,
        color: (0, $69ed148db7543104$export$a4867fe9454f37a8)[600],
        fontWeight: 600,
        fontSize: 16,
        margin: 8
    },
    segmentationSection: {
        display: 'flex',
        flexDirection: 'column',
        minWidth: 200,
        width: '100%',
        border: `1px solid ${(0, $69ed148db7543104$export$a4867fe9454f37a8)[300]}`,
        boxShadow: 'none',
        marginBottom: 8,
        '& .MuiFormControlLabel-root': {
            margin: '4px 16px',
            '& .MuiFormControlLabel-label': {
                marginLeft: 16,
                fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).body,
                fontWeight: 400
            }
        }
    },
    listItem: {
        '& .MuiListItemIcon-root': {
            minWidth: '32px'
        }
    },
    checkbox: {
        '&.Mui-disabled': {
            color: 'transparent'
        }
    }
});
/**
 * @function UserTagModalContent renders content of the user tag selection modal
 */ const $03002c6dd309d083$var$UserTagModalContent = ({ clientTags: clientTags, closeModal: closeModal, client: client })=>{
    const classes = $03002c6dd309d083$var$useStyles();
    const { values: values, setFieldValue: setFieldValue } = (0, $8FQwk.useFormikContext)();
    const [checked, setChecked] = $ieT14.useState(values.assignedTags.filter((assingedTag)=>assingedTag.clientId == client.clientId));
    const enableFanSegmentation = $ieT14.useRef(client.enableSegmentation);
    const clientFSPermission = $ieT14.useRef(values.assignedSegmentation.find((assignment)=>assignment.clientId === client.clientId));
    const [segmentAccess, setSegmentAccess] = $ieT14.useState(clientFSPermission.current.segmentationPermission);
    const handleToggle = (tag)=>{
        const currentIndex = checked.map((checkedTag)=>checkedTag.tagId).indexOf(tag.tagId);
        const newChecked = [
            ...checked
        ];
        if (currentIndex === -1) newChecked.push(tag);
        else newChecked.splice(currentIndex, 1);
        setChecked(newChecked);
    };
    const saveHandler = ()=>{
        setFieldValue('assignedTags', [
            ...values.assignedTags.filter((assignedTag)=>assignedTag.clientId !== client.clientId),
            ...checked
        ]);
        setFieldValue('assignedSegmentation', values.assignedSegmentation.map((assignment)=>{
            if (assignment.clientId === client.clientId) return {
                ...assignment,
                segmentationPermission: segmentAccess
            };
            return assignment;
        }));
        closeModal();
    };
    const selectAllHandler = ()=>{
        setChecked(clientTags);
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h2", {
                className: classes.sectionHeadings,
                children: "Tags"
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $lwgYO.default), {
                className: classes.paper,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $dxqtw.default), {
                        dense: true,
                        role: "list",
                        className: classes.list,
                        children: clientTags && clientTags.length > 0 ? clientTags.map((tag)=>{
                            const labelId = `tag-checklist-label-${tag.tagId}`;
                            return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $1fCJg.default), {
                                role: "listitem",
                                button: true,
                                onClick: ()=>handleToggle(tag),
                                className: classes.listItem,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $iwN3n.default), {
                                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8d66a60ef98d2984$export$2e2bcd8739ae039), {
                                            checked: checked.findIndex((checkedTag)=>tag.tagId === checkedTag.tagId) !== -1,
                                            tabIndex: -1,
                                            disableRipple: true,
                                            inputProps: {
                                                'aria-labelledby': labelId
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $bPjUl.default), {
                                        id: labelId,
                                        primary: tag.name
                                    })
                                ]
                            }, tag.tagId);
                        }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1fCJg.default), {
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $bPjUl.default), {
                                primary: "No tags are currently available for this client."
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("p", {
                        className: classes.selectAll,
                        children: clientTags.length > 1 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fcd3b8c5e9a7038b$export$2e2bcd8739ae039), {
                            text: "Select All",
                            title: "Select All",
                            handleClick: selectAllHandler
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h2", {
                className: classes.sectionHeadings,
                children: "Fan Segmentation"
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $lwgYO.default), {
                className: classes.segmentationSection,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $356Vi.default), {
                    title: !enableFanSegmentation.current ? 'Please enable the feature at the client level' : '',
                    arrow: true,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $62bbd6cebee2ba4a$export$2e2bcd8739ae039), {
                        "aria-label": "segmentation-permission",
                        name: "segmentation-permission",
                        value: segmentAccess,
                        onChange: (event)=>{
                            setSegmentAccess(Number(event.target.value));
                        },
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $knRao.default), {
                                disabled: !enableFanSegmentation.current,
                                value: (0, $5294e215b521479c$export$2e2bcd8739ae039).None,
                                control: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $141807cd97d66e4d$export$2e2bcd8739ae039), {}),
                                label: "None"
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $knRao.default), {
                                disabled: !enableFanSegmentation.current,
                                value: (0, $5294e215b521479c$export$2e2bcd8739ae039).Basic,
                                control: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $141807cd97d66e4d$export$2e2bcd8739ae039), {}),
                                label: "Basic User"
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $knRao.default), {
                                disabled: !enableFanSegmentation.current,
                                value: (0, $5294e215b521479c$export$2e2bcd8739ae039).Push,
                                control: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $141807cd97d66e4d$export$2e2bcd8739ae039), {}),
                                label: "Push User"
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $knRao.default), {
                                disabled: !enableFanSegmentation.current,
                                value: (0, $5294e215b521479c$export$2e2bcd8739ae039).Power,
                                control: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $141807cd97d66e4d$export$2e2bcd8739ae039), {}),
                                label: "Power User"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: classes.modalActionFooter,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f5afe0f42548a953$export$2e2bcd8739ae039), {
                    text: "Save",
                    title: "Save",
                    handleClick: saveHandler,
                    deactive: !clientTags || clientTags.length == 0
                })
            })
        ]
    });
};
var $03002c6dd309d083$export$2e2bcd8739ae039 = $03002c6dd309d083$var$UserTagModalContent;




var $j6s32 = parcelRequire("j6s32");


var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $5a6641286109afb6$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
}), 'AddCircle');



var $8FQwk = parcelRequire("8FQwk");

const $eca9af2447acc6e7$var$useStyles = (0, $e1ONw.default)({
    listItem: {
        '& .MuiListItemIcon-root': {
            minWidth: '32px'
        }
    },
    loading: {
        color: '#aaa',
        pointerEvents: 'none',
        position: 'relative',
        '& p, & span': {
            color: '#aaa'
        },
        '&::after': {
            content: "''",
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.1)'
        }
    },
    tagButton: {
        color: '#006da8'
    },
    tagButtonLoading: {
        opacity: 0.5
    }
});
/**
 * Transfer list item with extra controls for editing user-specific permissions (tags and fan segmentation)
 */ const $eca9af2447acc6e7$var$ClientListItem = ({ value: value, checked: checked, idField: idField, labelField: labelField, handleToggle: handleToggle })=>{
    const labelId = `transfer-list-item-${value[idField]}-label`;
    const { modalIsOpen: modalIsOpen, openModal: openModal, closeModal: closeModal } = (0, $a7347f5558ecc977$export$2e2bcd8739ae039)();
    const { fetchTags: fetchTags } = (0, $ddc981f711f942ee$export$2e2bcd8739ae039)();
    const [clientTags, setClientTags] = $ieT14.useState([]);
    const [loading, setLoading] = $ieT14.useState(true);
    const classes = $eca9af2447acc6e7$var$useStyles();
    const { values: formikValues } = (0, $8FQwk.useFormikContext)();
    $ieT14.useEffect(()=>{
        // retrieve tags for the current client
        fetchTags(value['clientId']).then((tags)=>{
            if (tags) setClientTags(tags);
            setLoading(false);
        }).catch((err)=>{
            console.log(err);
            setLoading(false);
        });
    }, []);
    const secondaryText = $ieT14.useMemo(()=>{
        const clientFanSegmentationPermission = formikValues.assignedSegmentation.find((fsPermission)=>fsPermission.clientId === value['clientId']);
        let permissions = '';
        switch(clientFanSegmentationPermission.segmentationPermission){
            case (0, $5294e215b521479c$export$2e2bcd8739ae039).None:
                permissions = '(none)';
                break;
            case (0, $5294e215b521479c$export$2e2bcd8739ae039).Basic:
                permissions = 'Fan Segmentation Cannot Push';
                break;
            case (0, $5294e215b521479c$export$2e2bcd8739ae039).Push:
                permissions = 'Fan Segmentation Can Push';
                break;
            case (0, $5294e215b521479c$export$2e2bcd8739ae039).Power:
                permissions = 'Power User';
                break;
        }
        return `Assigned Permissions: ${permissions}`;
    }, [
        formikValues.assignedSegmentation
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3c302b0d44a45917$export$2e2bcd8739ae039), {
                isOpen: !loading && modalIsOpen,
                onClose: closeModal,
                title: value[labelField],
                subtitle: "Assign Permissions",
                width: "345px",
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $03002c6dd309d083$export$2e2bcd8739ae039), {
                    clientTags: clientTags,
                    closeModal: closeModal,
                    client: value
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $1fCJg.default), {
                className: (0, $j6s32.default)(classes.listItem, loading && classes.loading),
                role: "listitem",
                button: true,
                onClick: ()=>handleToggle(value),
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $iwN3n.default), {
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8d66a60ef98d2984$export$2e2bcd8739ae039), {
                            checked: checked.indexOf(value) !== -1,
                            tabIndex: -1,
                            disableRipple: true,
                            inputProps: {
                                'aria-labelledby': labelId
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $bPjUl.default), {
                        id: labelId,
                        primary: value[labelField],
                        secondary: secondaryText
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $105db2ddc246141f$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $e5cb3fdcda0cefc7$export$2e2bcd8739ae039), {
                            title: "Assign Permissions",
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                                    onClick: openModal,
                                    size: "small",
                                    disabled: loading,
                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $5a6641286109afb6$export$2e2bcd8739ae039), {
                                        className: (0, $j6s32.default)(classes.tagButton, loading && classes.tagButtonLoading)
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $eca9af2447acc6e7$export$2e2bcd8739ae039 = $eca9af2447acc6e7$var$ClientListItem;





const $deaec261de48cbd7$var$ManageUserSchema = $e6c1ba40263f5002$export$185802fd694ee1f5().shape({
    firstName: $55fd6d44ba3611c9$export$185802fd694ee1f5().required('First name is a required field.').max(100, 'First name must be less than 1-100 characters'),
    lastName: $55fd6d44ba3611c9$export$185802fd694ee1f5().required('Last name is a required field.').max(100, 'Last name must be less than 1-100 characters'),
    email: $55fd6d44ba3611c9$export$185802fd694ee1f5().email('Must be valid email.').required('Email is a required field.')
});
const $deaec261de48cbd7$var$useStyles = (0, $e1ONw.default)({
    userSwitchBoxContainer: {
        display: 'flex',
        flexDirection: 'column'
    },
    switchBoxContainer: {
        display: 'flex'
    },
    oktaStatus: {
        fontSize: 12,
        color: (0, $69ed148db7543104$export$a4867fe9454f37a8)[500]
    }
});
/**
 * @function UserManager Allows a user to view/create/edit a single user's information.
 */ const $deaec261de48cbd7$var$UserManager = ({ loading: loadingUser, user: user, isNewUser: isNewUser, history: history })=>{
    const { createUser: createUser, loadingAssociatedData: loadingAssociatedData, clients: clients, applications: applications, fetchAssociatedData: fetchAssociatedData, editUser: editUser, fetchUser: fetchUser } = (0, $b19aa392df0f3838$export$2e2bcd8739ae039)();
    const { updateTag: updateTag } = (0, $ddc981f711f942ee$export$2e2bcd8739ae039)();
    const classes = $deaec261de48cbd7$var$useStyles();
    const roles = [
        {
            value: 'User',
            disabled: false
        },
        {
            value: 'Client Admin',
            disabled: false
        },
        {
            value: 'Elite Admin',
            disabled: false
        }
    ];
    const [unassignedApps, setUnassignedApps] = $ieT14.useState(applications);
    const [assignedApps, setAssignedApps] = $ieT14.useState(user.assignedApps);
    const [unassignedClients, setUnassignedClients] = $ieT14.useState([]);
    const [assignedClients, setAssignedClients] = $ieT14.useState(user.assignedClients);
    const [errorMessage, setErrorMessage] = $ieT14.useState('');
    const [displayDirtyWarning, setDisplayDirtyWarning] = $ieT14.useState(false);
    const [confirmedNavigation, setConfirmedNavigation] = $ieT14.useState(false);
    const [blockedLocation, setBlockedLocation] = $ieT14.useState('');
    const unblock = (0, $ieT14.useRef)(null);
    const formikRef = (0, $ieT14.useRef)(null);
    $ieT14.useEffect(()=>{
        fetchAssociatedData();
        unblock.current = history.block((location)=>{
            if (formikRef.current.dirty) {
                setDisplayDirtyWarning(true);
                setBlockedLocation(location.pathname);
                return false;
            } else unblock.current();
        });
    }, []);
    $ieT14.useEffect(()=>{
        if (confirmedNavigation) {
            unblock.current();
            history.push(blockedLocation);
        }
    }, [
        confirmedNavigation
    ]);
    $ieT14.useEffect(()=>{
        if (isNewUser) {
            if (!loadingAssociatedData) {
                setUnassignedApps(applications);
                setUnassignedClients(clients);
            }
        } else if (!loadingUser && !loadingAssociatedData) {
            if (user.assignedApps === null) user.assignedApps = [];
            if (user.assignedClients === null) user.assignedClients = [];
            setUnassignedApps(// filter out applications found in the user.assignedApps prop
            applications.filter((app)=>user.assignedApps.findIndex((assignedApp)=>app.entityDetailId === assignedApp.entityDetailId) === -1));
            setAssignedApps(user.assignedApps);
            setUnassignedClients(clients.filter((client)=>user.assignedClients.findIndex((assignedClient)=>client.clientId === assignedClient.clientId) === -1));
            setAssignedClients(user.assignedClients);
        }
    }, [
        loadingUser,
        loadingAssociatedData
    ]);
    const handleCancel = (dirty)=>{
        history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Users);
    };
    if (loadingUser || loadingAssociatedData) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        className: "loadingIndicator",
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
    });
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        children: [
            errorMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $cd9e5d573af72510$export$2e2bcd8739ae039), {
                message: errorMessage
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("h1", {
                children: [
                    isNewUser ? 'Add' : 'Edit',
                    " User"
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8FQwk.Formik), {
                innerRef: formikRef,
                initialValues: user,
                validationSchema: $deaec261de48cbd7$var$ManageUserSchema,
                onSubmit: async (values, { setSubmitting: setSubmitting })=>{
                    setSubmitting(true);
                    try {
                        const response = isNewUser ? await createUser(values) : await editUser(values);
                        if (!response.success) throw Error(`Failed to create user: ${response.message}`);
                        let tagUpdates = [];
                        if (isNewUser) {
                            // if new user, add all tags
                            // must fetch new user to get the assigned id
                            const newUser = await fetchUser(response.message);
                            const tagUser = {
                                id: newUser.id,
                                firstName: newUser.firstName,
                                lastName: newUser.lastName,
                                fullName: `${newUser.lastName}, ${newUser.firstName}`
                            };
                            tagUpdates = values.assignedTags.map((tag)=>updateTag(tag.clientId, tag.tagId, {
                                    ...tag,
                                    assignedUsers: [
                                        ...tag.assignedUsers,
                                        tagUser
                                    ]
                                }));
                        } else {
                            // if edited user, remove user from previous tags and add to newly assigned ones
                            tagUpdates.push(...user.assignedTags.filter((userTag)=>values.assignedTags.findIndex((assignedTag)=>assignedTag.tagId === userTag.tagId) === -1).map((removedTag)=>updateTag(removedTag.clientId, removedTag.tagId, {
                                    ...removedTag,
                                    assignedUsers: removedTag.assignedUsers.filter((assignedUser)=>assignedUser.id !== user.id)
                                })));
                            // add the user to any newly assigned tags
                            const tagUser = {
                                id: values.id,
                                firstName: values.firstName,
                                lastName: values.lastName,
                                fullName: `${values.lastName}, ${values.firstName}`
                            };
                            tagUpdates.push(...values.assignedTags.filter((tag)=>user.assignedTags.findIndex((userTag)=>userTag.tagId === tag.tagId) === -1).map((addedTag)=>updateTag(addedTag.clientId, addedTag.tagId, {
                                    ...addedTag,
                                    assignedUsers: [
                                        ...addedTag.assignedUsers,
                                        tagUser
                                    ]
                                })));
                        }
                        await Promise.all(tagUpdates);
                        setSubmitting(false);
                        unblock.current();
                        history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Users);
                    } catch (err) {
                        if (err instanceof Error) setErrorMessage(err.message);
                        else setErrorMessage(err.responseJSON.message);
                        window.scroll({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        });
                        setSubmitting(false);
                    }
                },
                children: ({ values: values, errors: errors, touched: touched, handleChange: handleChange, handleBlur: handleBlur, handleSubmit: handleSubmit, isSubmitting: isSubmitting, setFieldValue: setFieldValue, dirty: dirty })=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("form", {
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8FQwk.FormikConsumer), {
                                children: (formik)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $0ee6d6b77f108c47$export$2e2bcd8739ae039), {
                                        formik: formik,
                                        displayDirtyWarning: displayDirtyWarning,
                                        confirmNavigationWarning: ()=>{
                                            setConfirmedNavigation(true);
                                            history.push(blockedLocation);
                                        },
                                        cancleNavigationWarning: ()=>setDisplayDirtyWarning(false)
                                    })
                            }),
                            isSubmitting && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                className: $fdbf0d9f77db804d$export$29dd17c7f3c81c36,
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                    className: $fdbf0d9f77db804d$export$9a0dd4d839a90927,
                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("fieldset", {
                                className: $fdbf0d9f77db804d$export$a38812d1aa1302d9,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h5", {
                                        children: "Details"
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                        className: $fdbf0d9f77db804d$export$f40c3b93aa85e075,
                                        children: [
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $db32c8adf65b4dff$export$2e2bcd8739ae039), {
                                                id: "firstName",
                                                label: "First Name",
                                                name: "firstName",
                                                onChange: handleChange,
                                                onBlur: handleBlur,
                                                value: values.firstName || '',
                                                error: errors.firstName && touched.firstName,
                                                helperText: errors.firstName && touched.firstName && errors.firstName,
                                                required: true
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $db32c8adf65b4dff$export$2e2bcd8739ae039), {
                                                id: "lastName",
                                                label: "Last Name",
                                                onChange: handleChange,
                                                onBlur: handleBlur,
                                                value: values.lastName || '',
                                                error: errors.lastName && touched.lastName,
                                                helperText: errors.lastName && touched.lastName && errors.lastName,
                                                required: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $db32c8adf65b4dff$export$2e2bcd8739ae039), {
                                        id: "email",
                                        label: "Email Address",
                                        onChange: handleChange,
                                        onBlur: handleBlur,
                                        value: values.email || '',
                                        error: errors.email && touched.email,
                                        helperText: errors.email && touched.email && errors.email,
                                        disabled: !isNewUser,
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                        className: $fdbf0d9f77db804d$export$f40c3b93aa85e075,
                                        children: [
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $db32c8adf65b4dff$export$2e2bcd8739ae039), {
                                                id: "title",
                                                label: "Title",
                                                onChange: handleChange,
                                                onBlur: handleBlur,
                                                value: values.title || '',
                                                error: errors.title && touched.title,
                                                helperText: errors.title && touched.title && errors.title
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $db32c8adf65b4dff$export$2e2bcd8739ae039), {
                                                id: "department",
                                                label: "Company",
                                                onChange: handleChange,
                                                onBlur: handleBlur,
                                                value: values.department || '',
                                                error: errors.department && touched.department,
                                                helperText: errors.department && touched.department && errors.department
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("fieldset", {
                                className: $fdbf0d9f77db804d$export$a38812d1aa1302d9,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h5", {
                                        children: "Settings"
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                        className: classes.userSwitchBoxContainer,
                                        children: [
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                                className: classes.switchBoxContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $87c09cb75a62e14f$export$2e2bcd8739ae039), {
                                                        id: "activate",
                                                        value: values.activate,
                                                        handleChange: handleChange,
                                                        label: "ACTIVE",
                                                        disabled: !(0, $2b84cffcdcc80653$export$53a7de2d42d4bd9e)[values.status]
                                                    }),
                                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $87c09cb75a62e14f$export$2e2bcd8739ae039), {
                                                        id: "enhancedData",
                                                        value: values.enhancedData,
                                                        handleChange: handleChange,
                                                        label: "Enhanced Data"
                                                    }),
                                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $87c09cb75a62e14f$export$2e2bcd8739ae039), {
                                                        id: "isFederated",
                                                        value: values.isFederated,
                                                        handleChange: handleChange,
                                                        label: "Federated User",
                                                        disabled: !isNewUser
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                                                className: classes.oktaStatus,
                                                children: [
                                                    "Current Status: ",
                                                    (0, $2b84cffcdcc80653$export$53a7de2d42d4bd9e)[values.status] ?? 'Unknown'
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                        style: {
                                            marginTop: '10px'
                                        },
                                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eaaefced8e9d52f7$export$2e2bcd8739ae039), {
                                            values: roles,
                                            options: roles.map((role)=>role.value),
                                            title: 'User Type',
                                            selectedValue: user.role,
                                            handleChange: (val)=>{
                                                setFieldValue('role', val);
                                            }
                                        }, "role")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("fieldset", {
                                className: `${$fdbf0d9f77db804d$export$a38812d1aa1302d9}`,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h5", {
                                        children: "Apps"
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $624bea18a01be01c$export$2e2bcd8739ae039), {
                                        idField: "entityId",
                                        labelField: "name",
                                        left: unassignedApps,
                                        right: assignedApps,
                                        setLeft: setUnassignedApps,
                                        setRight: setAssignedApps,
                                        setFieldValue: setFieldValue,
                                        setField: "assignedApps"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("fieldset", {
                                className: `${$fdbf0d9f77db804d$export$a38812d1aa1302d9}`,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h5", {
                                        children: "Clients and Client Permissions"
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $624bea18a01be01c$export$2e2bcd8739ae039), {
                                        idField: "clientId",
                                        labelField: "name",
                                        left: unassignedClients,
                                        right: assignedClients,
                                        setLeft: setUnassignedClients,
                                        setRight: setAssignedClients,
                                        setFieldValue: setFieldValue,
                                        setField: "assignedClients",
                                        rightListComponent: (0, $eca9af2447acc6e7$export$2e2bcd8739ae039),
                                        onMoveLeft: (clientsToRemove)=>{
                                            // remove assigned tags belonging to the removed clients
                                            setFieldValue('assignedTags', values.assignedTags.filter((assignedTag)=>clientsToRemove.findIndex((client)=>client.clientId == assignedTag.clientId) === -1));
                                            // filter out assigned fs permissions whose client id is found in the clients to remove
                                            setFieldValue('assignedSegmentation', values.assignedSegmentation.filter((assignedFS)=>clientsToRemove.findIndex((client)=>client.clientId === assignedFS.clientId) === -1));
                                        },
                                        onMoveRight: (clientsToAdd)=>// add newly assigned clients fan segmentation permission objects
                                            setFieldValue('assignedSegmentation', [
                                                ...values.assignedSegmentation,
                                                ...clientsToAdd.map((client)=>({
                                                        clientId: client.clientId,
                                                        segmentationPermission: (0, $5294e215b521479c$export$2e2bcd8739ae039).None
                                                    }))
                                            ])
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                className: $fdbf0d9f77db804d$export$135180a04c5d6085,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fcd3b8c5e9a7038b$export$2e2bcd8739ae039), {
                                        text: "Cancel",
                                        title: "Cancel",
                                        handleClick: ()=>{
                                            handleCancel(dirty);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                        className: $fdbf0d9f77db804d$export$d675b3969e4857cb,
                                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $07d7e09497a42e25$export$2e2bcd8739ae039), {
                                            text: "Save",
                                            title: "Save",
                                            deactive: isSubmitting,
                                            handleClick: handleSubmit
                                        })
                                    })
                                ]
                            })
                        ]
                    })
            })
        ]
    });
};
var $deaec261de48cbd7$export$2e2bcd8739ae039 = (0, $eYoAG.withRouter)($deaec261de48cbd7$var$UserManager);


/**
 * Create a new user
 */ const $14c46cdcf5845036$var$AddUser = ()=>{
    const defaultUser = {
        id: null,
        firstName: '',
        lastName: '',
        email: '',
        role: 'User',
        accessLevel: '',
        status: (0, $2b84cffcdcc80653$export$53a7de2d42d4bd9e).ACTIVE,
        enhancedData: false,
        title: '',
        department: '',
        assignedApps: [],
        assignedClients: [],
        assignedTags: [],
        assignedSegmentation: [],
        isFederated: false,
        activate: true
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $deaec261de48cbd7$export$2e2bcd8739ae039), {
        loading: false,
        user: defaultUser,
        isNewUser: true
    });
};
var $14c46cdcf5845036$export$2e2bcd8739ae039 = $14c46cdcf5845036$var$AddUser;




var $ieT14 = parcelRequire("ieT14");




var $eYoAG = parcelRequire("eYoAG");
/**
 * Edit an existing user
 */ const $146cfb663f998c32$var$EditUser = ()=>{
    const defaultUser = {
        id: null,
        firstName: '',
        lastName: '',
        email: '',
        role: 'User',
        accessLevel: '',
        status: (0, $2b84cffcdcc80653$export$53a7de2d42d4bd9e).ACTIVE,
        enhancedData: false,
        title: '',
        department: '',
        assignedApps: [],
        assignedClients: [],
        assignedTags: [],
        assignedSegmentation: [],
        isFederated: false,
        activate: true
    };
    const { userId: userId } = (0, $eYoAG.useParams)();
    const [loading, setLoading] = $ieT14.useState(true);
    const [user, setUser] = $ieT14.useState(defaultUser);
    const { fetchUser: fetchUser } = (0, $b19aa392df0f3838$export$2e2bcd8739ae039)();
    // Fetches the user information for the page on mount
    $ieT14.useEffect(()=>{
        if (!loading) setLoading(true);
        fetchUser(userId).then((user)=>{
            user.activate = (0, $2b84cffcdcc80653$export$53a7de2d42d4bd9e)[user.status] === (0, $2b84cffcdcc80653$export$53a7de2d42d4bd9e).ACTIVE || (0, $2b84cffcdcc80653$export$53a7de2d42d4bd9e)[user.status] === (0, $2b84cffcdcc80653$export$53a7de2d42d4bd9e).PROVISIONED || (0, $2b84cffcdcc80653$export$53a7de2d42d4bd9e)[user.status] === (0, $2b84cffcdcc80653$export$53a7de2d42d4bd9e).SUSPENDED || (0, $2b84cffcdcc80653$export$53a7de2d42d4bd9e)[user.status] === (0, $2b84cffcdcc80653$export$53a7de2d42d4bd9e).LOCKED_OUT;
            setUser(user);
            setLoading(false);
        });
    }, []);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $deaec261de48cbd7$export$2e2bcd8739ae039), {
        isNewUser: false,
        loading: loading,
        user: user
    });
};
var $146cfb663f998c32$export$2e2bcd8739ae039 = $146cfb663f998c32$var$EditUser;



parcelRequire("ieT14");


var $ieT14 = parcelRequire("ieT14");


var $fgoQ6 = parcelRequire("fgoQ6");


parcelRequire("ieT14");


var $ieT14 = parcelRequire("ieT14");

var $aLnZv = parcelRequire("aLnZv");
var $231e5af09fff8797$var$__assign = undefined && undefined.__assign || function() {
    $231e5af09fff8797$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $231e5af09fff8797$var$__assign.apply(this, arguments);
};
var $231e5af09fff8797$export$55f393ee5b65665e = {
    onActivate: $aLnZv.func,
    onAddUndo: $aLnZv.func,
    onBeforeAddUndo: $aLnZv.func,
    onBeforeExecCommand: $aLnZv.func,
    onBeforeGetContent: $aLnZv.func,
    onBeforeRenderUI: $aLnZv.func,
    onBeforeSetContent: $aLnZv.func,
    onBeforePaste: $aLnZv.func,
    onBlur: $aLnZv.func,
    onChange: $aLnZv.func,
    onClearUndos: $aLnZv.func,
    onClick: $aLnZv.func,
    onContextMenu: $aLnZv.func,
    onCommentChange: $aLnZv.func,
    onCompositionEnd: $aLnZv.func,
    onCompositionStart: $aLnZv.func,
    onCompositionUpdate: $aLnZv.func,
    onCopy: $aLnZv.func,
    onCut: $aLnZv.func,
    onDblclick: $aLnZv.func,
    onDeactivate: $aLnZv.func,
    onDirty: $aLnZv.func,
    onDrag: $aLnZv.func,
    onDragDrop: $aLnZv.func,
    onDragEnd: $aLnZv.func,
    onDragGesture: $aLnZv.func,
    onDragOver: $aLnZv.func,
    onDrop: $aLnZv.func,
    onExecCommand: $aLnZv.func,
    onFocus: $aLnZv.func,
    onFocusIn: $aLnZv.func,
    onFocusOut: $aLnZv.func,
    onGetContent: $aLnZv.func,
    onHide: $aLnZv.func,
    onInit: $aLnZv.func,
    onInput: $aLnZv.func,
    onKeyDown: $aLnZv.func,
    onKeyPress: $aLnZv.func,
    onKeyUp: $aLnZv.func,
    onLoadContent: $aLnZv.func,
    onMouseDown: $aLnZv.func,
    onMouseEnter: $aLnZv.func,
    onMouseLeave: $aLnZv.func,
    onMouseMove: $aLnZv.func,
    onMouseOut: $aLnZv.func,
    onMouseOver: $aLnZv.func,
    onMouseUp: $aLnZv.func,
    onNodeChange: $aLnZv.func,
    onObjectResizeStart: $aLnZv.func,
    onObjectResized: $aLnZv.func,
    onObjectSelected: $aLnZv.func,
    onPaste: $aLnZv.func,
    onPostProcess: $aLnZv.func,
    onPostRender: $aLnZv.func,
    onPreProcess: $aLnZv.func,
    onProgressState: $aLnZv.func,
    onRedo: $aLnZv.func,
    onRemove: $aLnZv.func,
    onReset: $aLnZv.func,
    onSaveContent: $aLnZv.func,
    onSelectionChange: $aLnZv.func,
    onSetAttrib: $aLnZv.func,
    onSetContent: $aLnZv.func,
    onShow: $aLnZv.func,
    onSubmit: $aLnZv.func,
    onUndo: $aLnZv.func,
    onVisualAid: $aLnZv.func,
    onSkinLoadError: $aLnZv.func,
    onThemeLoadError: $aLnZv.func,
    onModelLoadError: $aLnZv.func,
    onPluginLoadError: $aLnZv.func,
    onIconsLoadError: $aLnZv.func,
    onLanguageLoadError: $aLnZv.func,
    onScriptsLoad: $aLnZv.func,
    onScriptsLoadError: $aLnZv.func
};
var $231e5af09fff8797$export$b925e942c73cf435 = $231e5af09fff8797$var$__assign({
    apiKey: $aLnZv.string,
    licenseKey: $aLnZv.string,
    id: $aLnZv.string,
    inline: $aLnZv.bool,
    init: $aLnZv.object,
    initialValue: $aLnZv.string,
    onEditorChange: $aLnZv.func,
    value: $aLnZv.string,
    tagName: $aLnZv.string,
    tabIndex: $aLnZv.number,
    cloudChannel: $aLnZv.string,
    plugins: $aLnZv.oneOfType([
        $aLnZv.string,
        $aLnZv.array
    ]),
    toolbar: $aLnZv.oneOfType([
        $aLnZv.string,
        $aLnZv.array
    ]),
    disabled: $aLnZv.bool,
    readonly: $aLnZv.bool,
    textareaName: $aLnZv.string,
    tinymceScriptSrc: $aLnZv.oneOfType([
        $aLnZv.string,
        $aLnZv.arrayOf($aLnZv.string),
        $aLnZv.arrayOf($aLnZv.shape({
            src: $aLnZv.string,
            async: $aLnZv.bool,
            defer: $aLnZv.bool
        }))
    ]),
    rollback: $aLnZv.oneOfType([
        $aLnZv.number,
        $aLnZv.oneOf([
            false
        ])
    ]),
    scriptLoading: $aLnZv.shape({
        async: $aLnZv.bool,
        defer: $aLnZv.bool,
        delay: $aLnZv.number
    })
}, $231e5af09fff8797$export$55f393ee5b65665e);


var $5c8c8380827261b1$export$d996549f383e26d7 = function(view) {
    var global = view;
    return global && global.tinymce ? global.tinymce : null;
};


var $4e62d3b9a45eece0$export$f6e2535fb5126e54 = function(x) {
    return typeof x === 'function';
};
var $4e62d3b9a45eece0$var$isEventProp = function(name) {
    return name in (0, $231e5af09fff8797$export$55f393ee5b65665e);
};
var $4e62d3b9a45eece0$var$eventAttrToEventName = function(attrName) {
    return attrName.substr(2);
};
var $4e62d3b9a45eece0$export$af36139ef88769c2 = function(handlerLookup, on, off, adapter, prevProps, props, boundHandlers) {
    var prevEventKeys = Object.keys(prevProps).filter($4e62d3b9a45eece0$var$isEventProp);
    var currEventKeys = Object.keys(props).filter($4e62d3b9a45eece0$var$isEventProp);
    var removedKeys = prevEventKeys.filter(function(key) {
        return props[key] === undefined;
    });
    var addedKeys = currEventKeys.filter(function(key) {
        return prevProps[key] === undefined;
    });
    removedKeys.forEach(function(key) {
        // remove event handler
        var eventName = $4e62d3b9a45eece0$var$eventAttrToEventName(key);
        var wrappedHandler = boundHandlers[eventName];
        off(eventName, wrappedHandler);
        delete boundHandlers[eventName];
    });
    addedKeys.forEach(function(key) {
        var wrappedHandler = adapter(handlerLookup, key);
        var eventName = $4e62d3b9a45eece0$var$eventAttrToEventName(key);
        boundHandlers[eventName] = wrappedHandler;
        on(eventName, wrappedHandler);
    });
};
var $4e62d3b9a45eece0$export$976afb4c0973ace0 = function(editor, prevProps, props, boundHandlers, lookup) {
    return $4e62d3b9a45eece0$export$af36139ef88769c2(lookup, editor.on.bind(editor), editor.off.bind(editor), function(handlerLookup, key) {
        return function(e) {
            var _a;
            return (_a = handlerLookup(key)) === null || _a === void 0 ? void 0 : _a(e, editor);
        };
    }, prevProps, props, boundHandlers);
};
var $4e62d3b9a45eece0$var$unique = 0;
var $4e62d3b9a45eece0$export$31b40729666a4ae0 = function(prefix) {
    var time = Date.now();
    var random = Math.floor(Math.random() * 1000000000);
    $4e62d3b9a45eece0$var$unique++;
    return prefix + '_' + random + $4e62d3b9a45eece0$var$unique + String(time);
};
var $4e62d3b9a45eece0$export$36d79ba83ca332ee = function(element) {
    return element !== null && (element.tagName.toLowerCase() === 'textarea' || element.tagName.toLowerCase() === 'input');
};
var $4e62d3b9a45eece0$var$normalizePluginArray = function(plugins) {
    if (typeof plugins === 'undefined' || plugins === '') return [];
    return Array.isArray(plugins) ? plugins : plugins.split(' ');
};
var $4e62d3b9a45eece0$export$baf513ab02aa4139 = function(initPlugins, inputPlugins) {
    return $4e62d3b9a45eece0$var$normalizePluginArray(initPlugins).concat($4e62d3b9a45eece0$var$normalizePluginArray(inputPlugins));
};
var $4e62d3b9a45eece0$export$db95927f7c59b055 = function() {
    return window.InputEvent && typeof InputEvent.prototype.getTargetRanges === 'function';
};
var $4e62d3b9a45eece0$export$7f84f389cd79ac30 = function(elem) {
    if (!('isConnected' in Node.prototype)) {
        // Fallback for IE and old Edge
        var current = elem;
        var parent_1 = elem.parentNode;
        while(parent_1 != null){
            current = parent_1;
            parent_1 = current.parentNode;
        }
        return current === elem.ownerDocument;
    }
    return elem.isConnected;
};
var $4e62d3b9a45eece0$export$d4f039427a1beff1 = function(editor, mode) {
    if (editor !== undefined) {
        if (editor.mode != null && typeof editor.mode === 'object' && typeof editor.mode.set === 'function') editor.mode.set(mode);
        else editor.setMode(mode);
    }
};
var $4e62d3b9a45eece0$export$8187edf6df8f23b7 = function(view) {
    var tinymce = (0, $5c8c8380827261b1$export$d996549f383e26d7)(view);
    if (!tinymce) throw new Error('tinymce should have been loaded into global scope');
    return tinymce;
};
var $4e62d3b9a45eece0$export$842fe946b20887d9 = function(editor) {
    return editor.options && editor.options.isRegistered('disabled');
};


var $36080251008011c7$var$__assign = undefined && undefined.__assign || function() {
    $36080251008011c7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $36080251008011c7$var$__assign.apply(this, arguments);
};
var $36080251008011c7$var$injectScriptTag = function(doc, item, handler) {
    var _a, _b;
    var scriptTag = doc.createElement('script');
    scriptTag.referrerPolicy = 'origin';
    scriptTag.type = 'application/javascript';
    scriptTag.id = item.id;
    scriptTag.src = item.src;
    scriptTag.async = (_a = item.async) !== null && _a !== void 0 ? _a : false;
    scriptTag.defer = (_b = item.defer) !== null && _b !== void 0 ? _b : false;
    var loadHandler = function() {
        scriptTag.removeEventListener('load', loadHandler);
        scriptTag.removeEventListener('error', errorHandler);
        handler(item.src);
    };
    var errorHandler = function(err) {
        scriptTag.removeEventListener('load', loadHandler);
        scriptTag.removeEventListener('error', errorHandler);
        handler(item.src, err);
    };
    scriptTag.addEventListener('load', loadHandler);
    scriptTag.addEventListener('error', errorHandler);
    if (doc.head) doc.head.appendChild(scriptTag);
};
var $36080251008011c7$var$createDocumentScriptLoader = function(doc) {
    var lookup = {};
    var scriptLoadOrErrorHandler = function(src, err) {
        var item = lookup[src];
        item.done = true;
        item.error = err;
        for(var _i = 0, _a = item.handlers; _i < _a.length; _i++){
            var h = _a[_i];
            h(src, err);
        }
        item.handlers = [];
    };
    var loadScripts = function(items, success, failure) {
        // eslint-disable-next-line no-console
        var failureOrLog = function(err) {
            return failure !== undefined ? failure(err) : console.error(err);
        };
        if (items.length === 0) {
            failureOrLog(new Error('At least one script must be provided'));
            return;
        }
        var successCount = 0;
        var failed = false;
        var loaded = function(_src, err) {
            if (failed) return;
            if (err) {
                failed = true;
                failureOrLog(err);
            } else if (++successCount === items.length) success();
        };
        for(var _i = 0, items_1 = items; _i < items_1.length; _i++){
            var item = items_1[_i];
            var existing = lookup[item.src];
            if (existing) {
                if (existing.done) loaded(item.src, existing.error);
                else existing.handlers.push(loaded);
            } else {
                // create a new entry
                var id = (0, $4e62d3b9a45eece0$export$31b40729666a4ae0)('tiny-');
                lookup[item.src] = {
                    id: id,
                    src: item.src,
                    done: false,
                    error: null,
                    handlers: [
                        loaded
                    ]
                };
                $36080251008011c7$var$injectScriptTag(doc, $36080251008011c7$var$__assign({
                    id: id
                }, item), scriptLoadOrErrorHandler);
            }
        }
    };
    var deleteScripts = function() {
        var _a;
        for(var _i = 0, _b = Object.values(lookup); _i < _b.length; _i++){
            var item = _b[_i];
            var scriptTag = doc.getElementById(item.id);
            if (scriptTag != null && scriptTag.tagName === 'SCRIPT') (_a = scriptTag.parentNode) === null || _a === void 0 || _a.removeChild(scriptTag);
        }
        lookup = {};
    };
    var getDocument = function() {
        return doc;
    };
    return {
        loadScripts: loadScripts,
        deleteScripts: deleteScripts,
        getDocument: getDocument
    };
};
var $36080251008011c7$var$createScriptLoader = function() {
    var cache = [];
    var getDocumentScriptLoader = function(doc) {
        var loader = cache.find(function(l) {
            return l.getDocument() === doc;
        });
        if (loader === undefined) {
            loader = $36080251008011c7$var$createDocumentScriptLoader(doc);
            cache.push(loader);
        }
        return loader;
    };
    var loadList = function(doc, items, delay, success, failure) {
        var doLoad = function() {
            return getDocumentScriptLoader(doc).loadScripts(items, success, failure);
        };
        if (delay > 0) setTimeout(doLoad, delay);
        else doLoad();
    };
    var reinitialize = function() {
        for(var loader = cache.pop(); loader != null; loader = cache.pop())loader.deleteScripts();
    };
    return {
        loadList: loadList,
        reinitialize: reinitialize
    };
};
var $36080251008011c7$export$7c69a55d426f4de9 = $36080251008011c7$var$createScriptLoader();





var $7ae21cd9dd6184c5$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7ae21cd9dd6184c5$var$__assign = undefined && undefined.__assign || function() {
    $7ae21cd9dd6184c5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7ae21cd9dd6184c5$var$__assign.apply(this, arguments);
};
var $7ae21cd9dd6184c5$var$changeEvents = 'change keyup compositionend setcontent CommentChange';
/**
 * @see {@link https://www.tiny.cloud/docs/tinymce/7/react-ref/ TinyMCE React Technical Reference}
 */ var $7ae21cd9dd6184c5$export$7cda8d932e2f33c0 = /** @class */ function(_super) {
    $7ae21cd9dd6184c5$var$__extends(Editor, _super);
    function Editor(props) {
        var _a, _b, _c;
        var _this = _super.call(this, props) || this;
        _this.rollbackTimer = undefined;
        _this.valueCursor = undefined;
        _this.rollbackChange = function() {
            var editor = _this.editor;
            var value = _this.props.value;
            if (editor && value && value !== _this.currentContent) editor.undoManager.ignore(function() {
                editor.setContent(value);
                // only restore cursor on inline editors when they are focused
                // as otherwise it will cause a focus grab
                if (_this.valueCursor && (!_this.inline || editor.hasFocus())) try {
                    editor.selection.moveToBookmark(_this.valueCursor);
                } catch (_e) {}
            });
            _this.rollbackTimer = undefined;
        };
        _this.handleBeforeInput = function(_evt) {
            if (_this.props.value !== undefined && _this.props.value === _this.currentContent && _this.editor) {
                if (!_this.inline || _this.editor.hasFocus()) try {
                    // getBookmark throws exceptions when the editor has not been focused
                    // possibly only in inline mode but I'm not taking chances
                    _this.valueCursor = _this.editor.selection.getBookmark(3);
                } catch (_e) {}
            }
        };
        _this.handleBeforeInputSpecial = function(evt) {
            if (evt.key === 'Enter' || evt.key === 'Backspace' || evt.key === 'Delete') _this.handleBeforeInput(evt);
        };
        _this.handleEditorChange = function(_evt) {
            var editor = _this.editor;
            if (editor && editor.initialized) {
                var newContent = editor.getContent();
                if (_this.props.value !== undefined && _this.props.value !== newContent && _this.props.rollback !== false) // start a timer and revert to the value if not applied in time
                {
                    if (!_this.rollbackTimer) _this.rollbackTimer = window.setTimeout(_this.rollbackChange, typeof _this.props.rollback === 'number' ? _this.props.rollback : 200);
                }
                if (newContent !== _this.currentContent) {
                    _this.currentContent = newContent;
                    if ((0, $4e62d3b9a45eece0$export$f6e2535fb5126e54)(_this.props.onEditorChange)) _this.props.onEditorChange(newContent, editor);
                }
            }
        };
        _this.handleEditorChangeSpecial = function(evt) {
            if (evt.key === 'Backspace' || evt.key === 'Delete') _this.handleEditorChange(evt);
        };
        _this.initialise = function(attempts) {
            var _a, _b, _c;
            if (attempts === void 0) attempts = 0;
            var target = _this.elementRef.current;
            if (!target) return; // Editor has been unmounted
            if (!(0, $4e62d3b9a45eece0$export$7f84f389cd79ac30)(target)) {
                // this is probably someone trying to help by rendering us offscreen
                // but we can't do that because the editor iframe must be in the document
                // in order to have state
                if (attempts === 0) // we probably just need to wait for the current events to be processed
                setTimeout(function() {
                    return _this.initialise(1);
                }, 1);
                else if (attempts < 100) // wait for ten seconds, polling every tenth of a second
                setTimeout(function() {
                    return _this.initialise(attempts + 1);
                }, 100);
                else // give up, at this point it seems that more polling is unlikely to help
                throw new Error('tinymce can only be initialised when in a document');
                return;
            }
            var tinymce = (0, $4e62d3b9a45eece0$export$8187edf6df8f23b7)(_this.view);
            var finalInit = $7ae21cd9dd6184c5$var$__assign($7ae21cd9dd6184c5$var$__assign($7ae21cd9dd6184c5$var$__assign($7ae21cd9dd6184c5$var$__assign({}, _this.props.init), {
                selector: undefined,
                target: target,
                disabled: _this.props.disabled,
                readonly: _this.props.readonly,
                inline: _this.inline,
                plugins: (0, $4e62d3b9a45eece0$export$baf513ab02aa4139)((_a = _this.props.init) === null || _a === void 0 ? void 0 : _a.plugins, _this.props.plugins),
                toolbar: (_b = _this.props.toolbar) !== null && _b !== void 0 ? _b : (_c = _this.props.init) === null || _c === void 0 ? void 0 : _c.toolbar
            }), _this.props.licenseKey ? {
                license_key: _this.props.licenseKey
            } : {}), {
                setup: function(editor) {
                    _this.editor = editor;
                    _this.bindHandlers({});
                    // When running in inline mode the editor gets the initial value
                    // from the innerHTML of the element it is initialized on.
                    // However we don't want to take on the responsibility of sanitizing
                    // to remove XSS in the react integration so we have a chicken and egg
                    // problem... We avoid it by sneaking in a set content before the first
                    // "official" setContent and using TinyMCE to do the sanitization.
                    if (_this.inline && !(0, $4e62d3b9a45eece0$export$36d79ba83ca332ee)(target)) editor.once('PostRender', function(_evt) {
                        editor.setContent(_this.getInitialValue(), {
                            no_events: true
                        });
                    });
                    if (_this.props.init && (0, $4e62d3b9a45eece0$export$f6e2535fb5126e54)(_this.props.init.setup)) _this.props.init.setup(editor);
                    if (_this.props.disabled) {
                        if ((0, $4e62d3b9a45eece0$export$842fe946b20887d9)(_this.editor)) _this.editor.options.set('disabled', _this.props.disabled);
                        else _this.editor.mode.set('readonly');
                    }
                },
                init_instance_callback: function(editor) {
                    var _a;
                    // check for changes that happened since tinymce.init() was called
                    var initialValue = _this.getInitialValue();
                    _this.currentContent = (_a = _this.currentContent) !== null && _a !== void 0 ? _a : editor.getContent();
                    if (_this.currentContent !== initialValue) {
                        _this.currentContent = initialValue;
                        // same as resetContent in TinyMCE 5
                        editor.setContent(initialValue);
                        editor.undoManager.clear();
                        editor.undoManager.add();
                        editor.setDirty(false);
                    }
                    // ensure existing init_instance_callback is called
                    if (_this.props.init && (0, $4e62d3b9a45eece0$export$f6e2535fb5126e54)(_this.props.init.init_instance_callback)) _this.props.init.init_instance_callback(editor);
                }
            });
            if (!_this.inline) target.style.visibility = '';
            if ((0, $4e62d3b9a45eece0$export$36d79ba83ca332ee)(target)) target.value = _this.getInitialValue();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            tinymce.init(finalInit);
        };
        _this.id = _this.props.id || (0, $4e62d3b9a45eece0$export$31b40729666a4ae0)('tiny-react');
        _this.elementRef = $ieT14.createRef();
        _this.inline = (_c = (_a = _this.props.inline) !== null && _a !== void 0 ? _a : (_b = _this.props.init) === null || _b === void 0 ? void 0 : _b.inline) !== null && _c !== void 0 ? _c : false;
        _this.boundHandlers = {};
        return _this;
    }
    Object.defineProperty(Editor.prototype, "view", {
        get: function() {
            var _a, _b;
            return (_b = (_a = this.elementRef.current) === null || _a === void 0 ? void 0 : _a.ownerDocument.defaultView) !== null && _b !== void 0 ? _b : window;
        },
        enumerable: false,
        configurable: true
    });
    Editor.prototype.componentDidUpdate = function(prevProps) {
        var _this = this;
        var _a, _b;
        if (this.rollbackTimer) {
            clearTimeout(this.rollbackTimer);
            this.rollbackTimer = undefined;
        }
        if (this.editor) {
            this.bindHandlers(prevProps);
            if (this.editor.initialized) {
                this.currentContent = (_a = this.currentContent) !== null && _a !== void 0 ? _a : this.editor.getContent();
                if (typeof this.props.initialValue === 'string' && this.props.initialValue !== prevProps.initialValue) {
                    // same as resetContent in TinyMCE 5
                    this.editor.setContent(this.props.initialValue);
                    this.editor.undoManager.clear();
                    this.editor.undoManager.add();
                    this.editor.setDirty(false);
                } else if (typeof this.props.value === 'string' && this.props.value !== this.currentContent) {
                    var localEditor_1 = this.editor;
                    localEditor_1.undoManager.transact(function() {
                        // inline editors grab focus when restoring selection
                        // so we don't try to keep their selection unless they are currently focused
                        var cursor;
                        if (!_this.inline || localEditor_1.hasFocus()) try {
                            // getBookmark throws exceptions when the editor has not been focused
                            // possibly only in inline mode but I'm not taking chances
                            cursor = localEditor_1.selection.getBookmark(3);
                        } catch (_e) {}
                        var valueCursor = _this.valueCursor;
                        localEditor_1.setContent(_this.props.value);
                        if (!_this.inline || localEditor_1.hasFocus()) for(var _i = 0, _a = [
                            cursor,
                            valueCursor
                        ]; _i < _a.length; _i++){
                            var bookmark = _a[_i];
                            if (bookmark) try {
                                localEditor_1.selection.moveToBookmark(bookmark);
                                _this.valueCursor = bookmark;
                                break;
                            } catch (_e) {}
                        }
                    });
                }
                if (this.props.readonly !== prevProps.readonly) {
                    var readonly = (_b = this.props.readonly) !== null && _b !== void 0 ? _b : false;
                    (0, $4e62d3b9a45eece0$export$d4f039427a1beff1)(this.editor, readonly ? 'readonly' : 'design');
                }
                if (this.props.disabled !== prevProps.disabled) {
                    if ((0, $4e62d3b9a45eece0$export$842fe946b20887d9)(this.editor)) this.editor.options.set('disabled', this.props.disabled);
                    else (0, $4e62d3b9a45eece0$export$d4f039427a1beff1)(this.editor, this.props.disabled ? 'readonly' : 'design');
                }
            }
        }
    };
    Editor.prototype.componentDidMount = function() {
        var _this = this;
        var _a, _b, _c, _d, _f;
        if ((0, $5c8c8380827261b1$export$d996549f383e26d7)(this.view) !== null) this.initialise();
        else if (Array.isArray(this.props.tinymceScriptSrc) && this.props.tinymceScriptSrc.length === 0) (_b = (_a = this.props).onScriptsLoadError) === null || _b === void 0 || _b.call(_a, new Error('No `tinymce` global is present but the `tinymceScriptSrc` prop was an empty array.'));
        else if ((_c = this.elementRef.current) === null || _c === void 0 ? void 0 : _c.ownerDocument) {
            var successHandler = function() {
                var _a, _b;
                (_b = (_a = _this.props).onScriptsLoad) === null || _b === void 0 || _b.call(_a);
                _this.initialise();
            };
            var errorHandler = function(err) {
                var _a, _b;
                (_b = (_a = _this.props).onScriptsLoadError) === null || _b === void 0 || _b.call(_a, err);
            };
            (0, $36080251008011c7$export$7c69a55d426f4de9).loadList(this.elementRef.current.ownerDocument, this.getScriptSources(), (_f = (_d = this.props.scriptLoading) === null || _d === void 0 ? void 0 : _d.delay) !== null && _f !== void 0 ? _f : 0, successHandler, errorHandler);
        }
    };
    Editor.prototype.componentWillUnmount = function() {
        var _this = this;
        var editor = this.editor;
        if (editor) {
            editor.off($7ae21cd9dd6184c5$var$changeEvents, this.handleEditorChange);
            editor.off(this.beforeInputEvent(), this.handleBeforeInput);
            editor.off('keypress', this.handleEditorChangeSpecial);
            editor.off('keydown', this.handleBeforeInputSpecial);
            editor.off('NewBlock', this.handleEditorChange);
            Object.keys(this.boundHandlers).forEach(function(eventName) {
                editor.off(eventName, _this.boundHandlers[eventName]);
            });
            this.boundHandlers = {};
            editor.remove();
            this.editor = undefined;
        }
    };
    Editor.prototype.render = function() {
        return this.inline ? this.renderInline() : this.renderIframe();
    };
    Editor.prototype.beforeInputEvent = function() {
        return (0, $4e62d3b9a45eece0$export$db95927f7c59b055)() ? 'beforeinput SelectionChange' : 'SelectionChange';
    };
    Editor.prototype.renderInline = function() {
        var _a = this.props.tagName, tagName = _a === void 0 ? 'div' : _a;
        return $ieT14.createElement(tagName, {
            ref: this.elementRef,
            id: this.id,
            tabIndex: this.props.tabIndex
        });
    };
    Editor.prototype.renderIframe = function() {
        return $ieT14.createElement('textarea', {
            ref: this.elementRef,
            style: {
                visibility: 'hidden'
            },
            name: this.props.textareaName,
            id: this.id,
            tabIndex: this.props.tabIndex
        });
    };
    Editor.prototype.getScriptSources = function() {
        var _a, _b;
        var async = (_a = this.props.scriptLoading) === null || _a === void 0 ? void 0 : _a.async;
        var defer = (_b = this.props.scriptLoading) === null || _b === void 0 ? void 0 : _b.defer;
        if (this.props.tinymceScriptSrc !== undefined) {
            if (typeof this.props.tinymceScriptSrc === 'string') return [
                {
                    src: this.props.tinymceScriptSrc,
                    async: async,
                    defer: defer
                }
            ];
            // multiple scripts can be specified which allows for hybrid mode
            return this.props.tinymceScriptSrc.map(function(item) {
                if (typeof item === 'string') // async does not make sense for multiple items unless
                // they are not dependent (which will be unlikely)
                return {
                    src: item,
                    async: async,
                    defer: defer
                };
                else return item;
            });
        }
        // fallback to the cloud when the tinymceScriptSrc is not specified
        var channel = this.props.cloudChannel; // `cloudChannel` is in `defaultProps`, so it's always defined.
        var apiKey = this.props.apiKey ? this.props.apiKey : 'no-api-key';
        var cloudTinyJs = "https://cdn.tiny.cloud/1/".concat(apiKey, "/tinymce/").concat(channel, "/tinymce.min.js");
        return [
            {
                src: cloudTinyJs,
                async: async,
                defer: defer
            }
        ];
    };
    Editor.prototype.getInitialValue = function() {
        if (typeof this.props.initialValue === 'string') return this.props.initialValue;
        else if (typeof this.props.value === 'string') return this.props.value;
        else return '';
    };
    Editor.prototype.bindHandlers = function(prevProps) {
        var _this = this;
        if (this.editor !== undefined) {
            // typescript chokes trying to understand the type of the lookup function
            (0, $4e62d3b9a45eece0$export$976afb4c0973ace0)(this.editor, prevProps, this.props, this.boundHandlers, function(key) {
                return _this.props[key];
            });
            // check if we should monitor editor changes
            var isValueControlled = function(p) {
                return p.onEditorChange !== undefined || p.value !== undefined;
            };
            var wasControlled = isValueControlled(prevProps);
            var nowControlled = isValueControlled(this.props);
            if (!wasControlled && nowControlled) {
                this.editor.on($7ae21cd9dd6184c5$var$changeEvents, this.handleEditorChange);
                this.editor.on(this.beforeInputEvent(), this.handleBeforeInput);
                this.editor.on('keydown', this.handleBeforeInputSpecial);
                this.editor.on('keyup', this.handleEditorChangeSpecial);
                this.editor.on('NewBlock', this.handleEditorChange);
            } else if (wasControlled && !nowControlled) {
                this.editor.off($7ae21cd9dd6184c5$var$changeEvents, this.handleEditorChange);
                this.editor.off(this.beforeInputEvent(), this.handleBeforeInput);
                this.editor.off('keydown', this.handleBeforeInputSpecial);
                this.editor.off('keyup', this.handleEditorChangeSpecial);
                this.editor.off('NewBlock', this.handleEditorChange);
            }
        }
    };
    Editor.propTypes = (0, $231e5af09fff8797$export$b925e942c73cf435);
    Editor.defaultProps = {
        cloudChannel: '8'
    };
    return Editor;
}($ieT14.Component);




/**
 * TinyEditor
 * Wrapper around the tinymce react component to provide the self-hosted tinymce assets instead of bundling them.
 * This prevents scripts and styles from being packaged directly in index js and css files and instead only loads them
 * when needed in the admin side, without polluting the global css scope.
 * See tiny.cloud/docs/integrations/react/#tinymcereacttechnicalreference for full Editor component reference.
 */ const $fb51feb4b146f19b$var$TinyEditor = ({ editorRef: editorRef, setField: setField, setFieldValue: setFieldValue, init: init, ...rest })=>{
    const { postFileAuth: postFileAuth } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $7ae21cd9dd6184c5$export$7cda8d932e2f33c0), {
        tinymceScriptSrc: `${document.baseURI}tinymce/tinymce.min.js`,
        onInit: (_evt, editor)=>editorRef.current = editor,
        init: {
            promotion: false,
            height: '300px',
            table_resize_bars: true,
            // This option specifies whether data:url images (inline images) should be removed or not from
            // the pasted contents. Setting paste_data_images to "true" will allow the pasted images, while
            // setting it to "false" will disallow pasted images.
            paste_data_images: true,
            images_upload_url: window.env.BASE_API + 'api/help-documents/image-upload',
            images_upload_handler: (blobInfo)=>new Promise((resolve, reject)=>{
                    postFileAuth('api/help-documents/image-upload', null, blobInfo.blob()).then((result)=>{
                        resolve(result.message);
                    }).catch(()=>{
                        reject('Failed to upload image.');
                    });
                }),
            image_advtab: true,
            font_formats: 'Montserrat="Montserrat",sans-serif; OpenSans="Open Sans",sans-serif',
            table_class_list: [
                {
                    title: 'Default',
                    value: 'styledTable'
                },
                {
                    title: 'Un-styled',
                    value: 'unstyledTable'
                }
            ],
            table_default_attributes: {
                class: 'styledTable'
            },
            setup: (editor)=>{
                editor.on('input change', ()=>{
                    const content = editor.getContent();
                    if (!!setFieldValue && !!setField) setFieldValue(setField, content);
                });
                editor.on('ExecCommand', (event)=>{
                    // the following block of code is used to fix the issue with TinyMCE's
                    // FullPage plugin not triggering a change event on Save
                    if (event.command === 'mceFullPageProperties' && !!setFieldValue && !!setField) {
                        // find tinymce dialog that contains title 'Metadata'
                        const metaTitles = Array.from(document.getElementsByClassName('tox-dialog__title')).filter((e)=>e.textContent.includes('Metadata'));
                        if (metaTitles.length > 0) {
                            // find the Save button
                            const saveButtons = Array.from(metaTitles[0].parentElement.parentElement.getElementsByTagName('button')).filter((e)=>e.textContent.includes('Save'));
                            if (saveButtons.length > 0) // update content on click
                            saveButtons[0].addEventListener('click', (_)=>{
                                // this click handler relies on the FullPage plugin's internal click handler being
                                // triggered first, seTimeout is used to ensure that this handler gets called the last
                                setTimeout((_)=>setFieldValue(setField, editor.getContent()), 1);
                            });
                        }
                    }
                });
            },
            highlight_on_focus: false,
            ...init
        },
        ...rest
    });
};
var $fb51feb4b146f19b$export$2e2bcd8739ae039 = $fb51feb4b146f19b$var$TinyEditor;


/**
 * Announcements
 * Edit view for both client-specific and global announcements.
 * @param client -- either the id of a client or 'global'
 */ const $5af5ff5099fa9274$var$Announcements = ({ client: client })=>{
    const { loading: loading, announcement: announcement, errorMessage: errorMessage, successMessage: successMessage, updateAnnouncement: updateAnnouncement } = (0, $cbb1bbab8b4a75ec$export$2e2bcd8739ae039)(client);
    const [initialEditorValue, setInitialEditorValue] = $ieT14.useState('');
    const editorRef = $ieT14.useRef(null);
    const [dirty, setDirty] = $ieT14.useState(false);
    $ieT14.useEffect(()=>{
        if (!loading && announcement) setInitialEditorValue(announcement);
    }, [
        loading,
        announcement
    ]);
    $ieT14.useEffect(()=>{
        setDirty(false);
    }, [
        initialEditorValue
    ]);
    const handleClick = ()=>{
        if (editorRef.current) {
            const content = editorRef.current.getContent();
            setDirty(false);
            editorRef.current.setDirty(false);
            updateAnnouncement(client, content);
        }
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        children: [
            errorMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
                type: "error",
                message: errorMessage
            }),
            successMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
                type: "success",
                message: successMessage
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fb51feb4b146f19b$export$2e2bcd8739ae039), {
                editorRef: editorRef,
                initialValue: initialEditorValue,
                onDirty: ()=>setDirty(true),
                disabled: loading
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $fdbf0d9f77db804d$export$aa8b8078be26284,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: $fdbf0d9f77db804d$export$d675b3969e4857cb,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.PrimaryButton), {
                        text: "Update",
                        title: "Update",
                        handleClick: handleClick,
                        deactive: !dirty
                    })
                })
            })
        ]
    });
};
var $5af5ff5099fa9274$export$2e2bcd8739ae039 = $5af5ff5099fa9274$var$Announcements;


var $f519309e24204e5b$export$38e42c68cf43b5d4;
$f519309e24204e5b$export$38e42c68cf43b5d4 = `TvWXra_header`;


const $3c266d141e86f58a$var$GlobalAnnouncements = ()=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $f519309e24204e5b$export$38e42c68cf43b5d4,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h1", {
                    children: "Global Announcement"
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $5af5ff5099fa9274$export$2e2bcd8739ae039), {
                client: "global"
            })
        ]
    });
};
var $3c266d141e86f58a$export$2e2bcd8739ae039 = $3c266d141e86f58a$var$GlobalAnnouncements;




var $ieT14 = parcelRequire("ieT14");




parcelRequire("ieT14");

var $6mt9R = parcelRequire("6mt9R");



var $eYoAG = parcelRequire("eYoAG");
const $af06fc2defd6d844$var$ClientAdminMenu = ({ clientId: clientId, userRole: userRole, location: location })=>{
    /** Checks user role to hide the tab if user is a Client Admin
   * Only tabs shown for client admin is Dashboards, Tags and Navigation
   */ const hideTab = ()=>{
        return userRole === 'Client Admin';
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("ul", {
            className: $77e47b6bc9169ce7$export$b1e5508a851be14d,
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6mt9R.Link), {
                    to: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).EditClient.replace(':clientId', clientId.toString()),
                    className: location.pathname.match(/clients\/\d+\/edit$/) ? $77e47b6bc9169ce7$export$97aac956da55dae9 : undefined,
                    hidden: hideTab(),
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
                        className: $77e47b6bc9169ce7$export$c176f998e71d0f08,
                        children: "Edit Client"
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6mt9R.Link), {
                    to: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).ClientUsers.replace(':clientId', clientId.toString()),
                    className: location.pathname.endsWith('users') ? $77e47b6bc9169ce7$export$97aac956da55dae9 : undefined,
                    hidden: hideTab(),
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
                        className: $77e47b6bc9169ce7$export$c176f998e71d0f08,
                        children: "Users"
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6mt9R.Link), {
                    to: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).ClientDashboards.replace(':clientId', clientId.toString()),
                    className: location.pathname.endsWith('dashboards') || location.pathname.endsWith('dashboards/create') || location.pathname.match(/dashboards\/\d+\/edit$/) ? $77e47b6bc9169ce7$export$97aac956da55dae9 : undefined,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
                        className: $77e47b6bc9169ce7$export$c176f998e71d0f08,
                        children: "Dashboards"
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6mt9R.Link), {
                    to: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).ClientTags.replace(':clientId', clientId.toString()),
                    className: location.pathname.endsWith('tags') ? $77e47b6bc9169ce7$export$97aac956da55dae9 : undefined,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
                        className: $77e47b6bc9169ce7$export$c176f998e71d0f08,
                        children: "Tags"
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6mt9R.Link), {
                    to: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).ClientNavigation.replace(':clientId', clientId.toString()),
                    className: location.pathname.endsWith('navigation') ? $77e47b6bc9169ce7$export$97aac956da55dae9 : undefined,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
                        className: $77e47b6bc9169ce7$export$c176f998e71d0f08,
                        children: "Navigation"
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6mt9R.Link), {
                    to: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).ClientHelpDocuments.replace(':clientId', clientId.toString()),
                    className: location.pathname.match(/edit\/help/) ? $77e47b6bc9169ce7$export$97aac956da55dae9 : undefined,
                    hidden: hideTab(),
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
                        className: $77e47b6bc9169ce7$export$c176f998e71d0f08,
                        children: "Help Documents"
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6mt9R.Link), {
                    to: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).ClientAnnouncements.replace(':clientId', clientId.toString()),
                    className: location.pathname.endsWith('announcements') ? $77e47b6bc9169ce7$export$97aac956da55dae9 : undefined,
                    hidden: hideTab(),
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
                        className: $77e47b6bc9169ce7$export$c176f998e71d0f08,
                        children: "Announcements"
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6mt9R.Link), {
                    to: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).SnowflakeConfiguration.replace(':clientId', clientId.toString()),
                    className: location.pathname.endsWith('snowflake') ? $77e47b6bc9169ce7$export$97aac956da55dae9 : undefined,
                    hidden: hideTab(),
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
                        className: $77e47b6bc9169ce7$export$c176f998e71d0f08,
                        children: "Snowflake"
                    })
                })
            ]
        })
    });
};
var $af06fc2defd6d844$export$2e2bcd8739ae039 = (0, $eYoAG.withRouter)($af06fc2defd6d844$var$ClientAdminMenu);




var $fpdl2 = parcelRequire("fpdl2");

var $eYoAG = parcelRequire("eYoAG");




var $ieT14 = parcelRequire("ieT14");
var $3d0c968d45f99356$export$b0377cbbbdab6cba;
var $3d0c968d45f99356$export$f27f0a643498ce3d;
var $3d0c968d45f99356$export$b00c055587dc7469;
var $3d0c968d45f99356$export$b1a09d22b7ad6c4;
var $3d0c968d45f99356$export$509f3108fdd206bb;
var $3d0c968d45f99356$export$42ff741d2868ee32;
var $3d0c968d45f99356$export$8c430709db82137d;
var $3d0c968d45f99356$export$2d4b1211b4389c3b;
var $3d0c968d45f99356$export$3832be13857745bc;
var $3d0c968d45f99356$export$f4c68800b094ddb1;
var $3d0c968d45f99356$export$d220bf936897c3f;
var $3d0c968d45f99356$export$8b7a896ae75accbf;
var $3d0c968d45f99356$export$95e30c449567cd72;
var $3d0c968d45f99356$export$f2d5245d66b09437;
var $3d0c968d45f99356$export$fbad004417327a18;
var $3d0c968d45f99356$export$ce666bf02318c957;
var $3d0c968d45f99356$export$95775961921333ee;
var $3d0c968d45f99356$export$23ef198012fb7186;
var $3d0c968d45f99356$export$fad4b7e4071716b4;
var $3d0c968d45f99356$export$3dcf5d666adf6ee5;
var $3d0c968d45f99356$export$f3a380badcbf8e95;
var $3d0c968d45f99356$export$f34b9ca138eab87c;
var $3d0c968d45f99356$export$b0493221521ca587;
var $3d0c968d45f99356$export$d3710016b0f351d6;
var $3d0c968d45f99356$export$edfe9515a4e42134;
$3d0c968d45f99356$export$b0377cbbbdab6cba = "#006da8";
$3d0c968d45f99356$export$f27f0a643498ce3d = "#00aafc";
$3d0c968d45f99356$export$b00c055587dc7469 = "#f5dbd9";
$3d0c968d45f99356$export$b1a09d22b7ad6c4 = "#c92100";
$3d0c968d45f99356$export$509f3108fdd206bb = "#ebafa6";
$3d0c968d45f99356$export$42ff741d2868ee32 = "#074f86";
$3d0c968d45f99356$export$8c430709db82137d = "#dadada";
$3d0c968d45f99356$export$2d4b1211b4389c3b = "#dddbda";
$3d0c968d45f99356$export$3832be13857745bc = "#eae9ed";
$3d0c968d45f99356$export$f4c68800b094ddb1 = "#e9e8f4";
$3d0c968d45f99356$export$d220bf936897c3f = "addTag_1211c8";
$3d0c968d45f99356$export$8b7a896ae75accbf = "tags_1211c8";
$3d0c968d45f99356$export$95e30c449567cd72 = "tagListWrap_1211c8";
$3d0c968d45f99356$export$f2d5245d66b09437 = "tableContainer_1211c8";
$3d0c968d45f99356$export$fbad004417327a18 = "tableHead_1211c8";
$3d0c968d45f99356$export$ce666bf02318c957 = "tableRow_1211c8";
$3d0c968d45f99356$export$95775961921333ee = "userCell_1211c8";
$3d0c968d45f99356$export$23ef198012fb7186 = "truncated_1211c8";
$3d0c968d45f99356$export$fad4b7e4071716b4 = "colorColumn_1211c8";
$3d0c968d45f99356$export$3dcf5d666adf6ee5 = "colorLabel_1211c8";
$3d0c968d45f99356$export$f3a380badcbf8e95 = "nameColumn_1211c8";
$3d0c968d45f99356$export$f34b9ca138eab87c = "usersColumn_1211c8";
$3d0c968d45f99356$export$b0493221521ca587 = "actionsColumn_1211c8";
$3d0c968d45f99356$export$d3710016b0f351d6 = "userForm_1211c8";
$3d0c968d45f99356$export$edfe9515a4e42134 = "modalActionFooter_1211c8";




var $ieT14 = parcelRequire("ieT14");



var $ieT14 = parcelRequire("ieT14");


parcelRequire("ieT14");

var $eYT2J = parcelRequire("eYT2J");

var $aIJrd = parcelRequire("aIJrd");
const $4293b04ece6aa3fa$var$CssTextField = (0, $aIJrd.default)({
    root: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: '#ffffff',
            width: '100%'
        },
        '& label.Mui-focused, & label.MuiFormLabel-filled': {
            display: 'none'
        }
    }
})((0, $eYT2J.default));
const $4293b04ece6aa3fa$var$SimpleOutlinedInput = (props)=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($4293b04ece6aa3fa$var$CssTextField, {
        ...props,
        variant: "outlined",
        size: "small",
        InputLabelProps: {
            shrink: false
        }
    });
};
var $4293b04ece6aa3fa$export$2e2bcd8739ae039 = $4293b04ece6aa3fa$var$SimpleOutlinedInput;



var $1KcBP = parcelRequire("1KcBP");
var $eTwGP = parcelRequire("eTwGP");

var $edxsd = parcelRequire("edxsd");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");


var $aIJrd = parcelRequire("aIJrd");

var $2EBFt = parcelRequire("2EBFt");

var $86m3e = parcelRequire("86m3e");

var $ieT14 = parcelRequire("ieT14");
/**
 * @ignore - internal component.
 */ var $9940515f66b699aa$var$TableContext = $ieT14.createContext();
var $9940515f66b699aa$export$2e2bcd8739ae039 = $9940515f66b699aa$var$TableContext;



var $ieT14 = parcelRequire("ieT14");
/**
 * @ignore - internal component.
 */ var $924d4b43d6e1558d$var$Tablelvl2Context = $ieT14.createContext();
var $924d4b43d6e1558d$export$2e2bcd8739ae039 = $924d4b43d6e1558d$var$Tablelvl2Context;


var $248bc6cb24906a61$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $edxsd.default)({}, theme.typography.body2, {
            display: 'table-cell',
            verticalAlign: 'inherit',
            // Workaround for a rendering bug with spanned columns in Chrome 62.0.
            // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
            borderBottom: "1px solid\n    ".concat(theme.palette.type === 'light' ? (0, $86m3e.lighten)((0, $86m3e.alpha)(theme.palette.divider, 1), 0.88) : (0, $86m3e.darken)((0, $86m3e.alpha)(theme.palette.divider, 1), 0.68)),
            textAlign: 'left',
            padding: 16
        }),
        /* Styles applied to the root element if `variant="head"` or `context.table.head`. */ head: {
            color: theme.palette.text.primary,
            lineHeight: theme.typography.pxToRem(24),
            fontWeight: theme.typography.fontWeightMedium
        },
        /* Styles applied to the root element if `variant="body"` or `context.table.body`. */ body: {
            color: theme.palette.text.primary
        },
        /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */ footer: {
            color: theme.palette.text.secondary,
            lineHeight: theme.typography.pxToRem(21),
            fontSize: theme.typography.pxToRem(12)
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            padding: '6px 24px 6px 16px',
            '&:last-child': {
                paddingRight: 16
            },
            '&$paddingCheckbox': {
                width: 24,
                // prevent the checkbox column from growing
                padding: '0 12px 0 16px',
                '&:last-child': {
                    paddingLeft: 12,
                    paddingRight: 16
                },
                '& > *': {
                    padding: 0
                }
            }
        },
        /* Styles applied to the root element if `padding="checkbox"`. */ paddingCheckbox: {
            width: 48,
            // prevent the checkbox column from growing
            padding: '0 0 0 4px',
            '&:last-child': {
                paddingLeft: 0,
                paddingRight: 4
            }
        },
        /* Styles applied to the root element if `padding="none"`. */ paddingNone: {
            padding: 0,
            '&:last-child': {
                padding: 0
            }
        },
        /* Styles applied to the root element if `align="left"`. */ alignLeft: {
            textAlign: 'left'
        },
        /* Styles applied to the root element if `align="center"`. */ alignCenter: {
            textAlign: 'center'
        },
        /* Styles applied to the root element if `align="right"`. */ alignRight: {
            textAlign: 'right',
            flexDirection: 'row-reverse'
        },
        /* Styles applied to the root element if `align="justify"`. */ alignJustify: {
            textAlign: 'justify'
        },
        /* Styles applied to the root element if `context.table.stickyHeader={true}`. */ stickyHeader: {
            position: 'sticky',
            top: 0,
            left: 0,
            zIndex: 2,
            backgroundColor: theme.palette.background.default
        }
    };
};
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ var $248bc6cb24906a61$var$TableCell = /*#__PURE__*/ $ieT14.forwardRef(function TableCell(props, ref) {
    var _props$align = props.align, align = _props$align === void 0 ? 'inherit' : _props$align, classes = props.classes, className = props.className, component = props.component, paddingProp = props.padding, scopeProp = props.scope, sizeProp = props.size, sortDirection = props.sortDirection, variantProp = props.variant, other = (0, $eTwGP.default)(props, [
        "align",
        "classes",
        "className",
        "component",
        "padding",
        "scope",
        "size",
        "sortDirection",
        "variant"
    ]);
    var table = $ieT14.useContext((0, $9940515f66b699aa$export$2e2bcd8739ae039));
    var tablelvl2 = $ieT14.useContext((0, $924d4b43d6e1558d$export$2e2bcd8739ae039));
    var isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    var role;
    var Component;
    if (component) {
        Component = component;
        role = isHeadCell ? 'columnheader' : 'cell';
    } else Component = isHeadCell ? 'th' : 'td';
    var scope = scopeProp;
    if (!scope && isHeadCell) scope = 'col';
    var padding = paddingProp || (table && table.padding ? table.padding : 'normal');
    var size = sizeProp || (table && table.size ? table.size : 'medium');
    var variant = variantProp || tablelvl2 && tablelvl2.variant;
    var ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ $ieT14.createElement(Component, (0, $edxsd.default)({
        ref: ref,
        className: (0, $j6s32.default)(classes.root, classes[variant], className, align !== 'inherit' && classes["align".concat((0, $2EBFt.default)(align))], padding !== 'normal' && classes["padding".concat((0, $2EBFt.default)(padding))], size !== 'medium' && classes["size".concat((0, $2EBFt.default)(size))], variant === 'head' && table && table.stickyHeader && classes.stickyHeader),
        "aria-sort": ariaSort,
        role: role,
        scope: scope
    }, other));
});
var $248bc6cb24906a61$export$2e2bcd8739ae039 = (0, $aIJrd.default)($248bc6cb24906a61$export$9dd6ff9ea0189349, {
    name: 'MuiTableCell'
})($248bc6cb24906a61$var$TableCell);



var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $70ccc3891d50e85f$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');




var $j6s32 = parcelRequire("j6s32");



var $ieT14 = parcelRequire("ieT14");



const $6ef3a2b88c457bb4$var$UserModalContent = ({ tag: tag, clientUsers: clientUsers, clientAdministrators: clientAdministrators, updateUsersHandler: updateUsersHandler })=>{
    const [unassignedUsers, setUnassignedUsers] = $ieT14.useState([]);
    const [assignedUsers, setAssignedUsers] = $ieT14.useState([]);
    const [updatedTag, setUpdatedTag] = $ieT14.useState(tag);
    $ieT14.useEffect(()=>{
        if (tag.assignedUsers) {
            setAssignedUsers(tag.assignedUsers);
            if (clientUsers || clientAdministrators) setUnassignedUsers([
                ...clientUsers.filter((clientUser)=>tag.assignedUsers.map((user)=>user.id).indexOf(clientUser.id) === -1),
                ...clientAdministrators.filter((clientAdmin)=>tag.assignedUsers.map((user)=>user.id).indexOf(clientAdmin.id) === -1)
            ]);
        } else if (clientUsers || clientAdministrators) setUnassignedUsers([
            ...clientUsers,
            ...clientAdministrators
        ]);
    }, []);
    $ieT14.useEffect(()=>{
        setUpdatedTag({
            ...updatedTag,
            assignedUsers: assignedUsers
        });
    }, [
        assignedUsers
    ]);
    const saveHandler = ()=>{
        updateUsersHandler(updatedTag);
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("form", {
                className: $3d0c968d45f99356$export$d3710016b0f351d6,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $624bea18a01be01c$export$2e2bcd8739ae039), {
                    idField: "id",
                    labelField: "fullName",
                    left: unassignedUsers,
                    right: assignedUsers,
                    setLeft: setUnassignedUsers,
                    setRight: setAssignedUsers,
                    leftLabel: "Unpermissioned Users",
                    rightLabel: "Permissioned Users",
                    setFieldValue: ()=>{},
                    setField: "",
                    height: "460px"
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $3d0c968d45f99356$export$edfe9515a4e42134,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f5afe0f42548a953$export$2e2bcd8739ae039), {
                    text: "Save",
                    title: "Save",
                    handleClick: saveHandler
                })
            })
        ]
    });
};
var $6ef3a2b88c457bb4$export$2e2bcd8739ae039 = $6ef3a2b88c457bb4$var$UserModalContent;




const $f25c15465c7d8cd3$var$TagTableItem = ({ tag: tag, clientId: clientId, windowSize: windowSize, clientUsers: clientUsers, clientAdministrators: clientAdministrators, fetchTagsHandler: fetchTagsHandler, deleteTagHandler: deleteTagHandler, setSuccessMessage: setSuccessMessage, setErrorMessage: setErrorMessage })=>{
    const [tagInputValue, setTagInputValue] = $ieT14.useState('');
    const [isTruncated, setIsTruncated] = $ieT14.useState(false);
    const { modalIsOpen: modalIsOpen, openModal: openModal, closeModal: closeModal } = (0, $a7347f5558ecc977$export$2e2bcd8739ae039)();
    const { updateTag: updateTag } = (0, $ddc981f711f942ee$export$2e2bcd8739ae039)();
    const updateUsersHandler = (tag)=>{
        updateTag(clientId, tag.tagId, tag).then((response)=>{
            if (response.success) {
                setSuccessMessage(`Success: Updated tag ${response.message}: ${tag.name}`);
                fetchTagsHandler();
            } else setErrorMessage(response.message);
        }).catch((err)=>{
            setErrorMessage(err.responseJSON.message);
        });
        closeModal();
    };
    $ieT14.useEffect(()=>{
        if (tag.name) setTagInputValue(tag.name);
    }, []);
    const handleNameSubmit = (event)=>{
        event.preventDefault();
        updateUsersHandler({
            ...tag,
            name: tagInputValue
        });
    };
    // detect whether permissioned user text is truncated when window is resized
    const measuredRef = $ieT14.useCallback((node)=>{
        if (node !== null) node.offsetHeight < node.scrollHeight ? setIsTruncated(true) : setIsTruncated(false);
    }, [
        windowSize
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3c302b0d44a45917$export$2e2bcd8739ae039), {
                isOpen: modalIsOpen,
                onClose: closeModal,
                title: tag.name,
                width: "650px",
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6ef3a2b88c457bb4$export$2e2bcd8739ae039), {
                    tag: tag,
                    clientUsers: clientUsers,
                    clientAdministrators: clientAdministrators,
                    updateUsersHandler: updateUsersHandler
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $248bc6cb24906a61$export$2e2bcd8739ae039), {
                className: $3d0c968d45f99356$export$fad4b7e4071716b4,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: $3d0c968d45f99356$export$3dcf5d666adf6ee5
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $248bc6cb24906a61$export$2e2bcd8739ae039), {
                className: $3d0c968d45f99356$export$f3a380badcbf8e95,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("form", {
                    onSubmit: (event)=>handleNameSubmit(event),
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4293b04ece6aa3fa$export$2e2bcd8739ae039), {
                        label: "Tag Name",
                        value: tagInputValue,
                        onChange: (event)=>setTagInputValue(event.target.value),
                        onBlur: ()=>setTagInputValue(tag.name)
                    })
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $248bc6cb24906a61$export$2e2bcd8739ae039), {
                className: $3d0c968d45f99356$export$95775961921333ee,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("p", {
                    ref: measuredRef,
                    title: isTruncated ? `${tag.users}` : '',
                    className: (0, $j6s32.default)(isTruncated && $3d0c968d45f99356$export$23ef198012fb7186),
                    children: tag.users
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $248bc6cb24906a61$export$2e2bcd8739ae039), {
                className: $3d0c968d45f99356$export$b0493221521ca587,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $e5cb3fdcda0cefc7$export$2e2bcd8739ae039), {
                        title: "Add Users",
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                            onClick: openModal,
                            size: "small",
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $5a6641286109afb6$export$2e2bcd8739ae039), {
                                style: {
                                    color: '#006da8'
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $e5cb3fdcda0cefc7$export$2e2bcd8739ae039), {
                        title: "Delete",
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                            edge: "end",
                            onClick: deleteTagHandler,
                            size: "small",
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $70ccc3891d50e85f$export$2e2bcd8739ae039), {
                                style: {
                                    color: '#006da8'
                                }
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $f25c15465c7d8cd3$export$2e2bcd8739ae039 = $f25c15465c7d8cd3$var$TagTableItem;



var $eTwGP = parcelRequire("eTwGP");

var $edxsd = parcelRequire("edxsd");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");


var $aIJrd = parcelRequire("aIJrd");

var $59739725ddd88dec$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'table',
            width: '100%',
            borderCollapse: 'collapse',
            borderSpacing: 0,
            '& caption': (0, $edxsd.default)({}, theme.typography.body2, {
                padding: theme.spacing(2),
                color: theme.palette.text.secondary,
                textAlign: 'left',
                captionSide: 'bottom'
            })
        },
        /* Styles applied to the root element if `stickyHeader={true}`. */ stickyHeader: {
            borderCollapse: 'separate'
        }
    };
};
var $59739725ddd88dec$var$defaultComponent = 'table';
var $59739725ddd88dec$var$Table = /*#__PURE__*/ $ieT14.forwardRef(function Table(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? $59739725ddd88dec$var$defaultComponent : _props$component, _props$padding = props.padding, padding = _props$padding === void 0 ? 'normal' : _props$padding, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, _props$stickyHeader = props.stickyHeader, stickyHeader = _props$stickyHeader === void 0 ? false : _props$stickyHeader, other = (0, $eTwGP.default)(props, [
        "classes",
        "className",
        "component",
        "padding",
        "size",
        "stickyHeader"
    ]);
    var table = $ieT14.useMemo(function() {
        return {
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        };
    }, [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ $ieT14.createElement((0, $9940515f66b699aa$export$2e2bcd8739ae039).Provider, {
        value: table
    }, /*#__PURE__*/ $ieT14.createElement(Component, (0, $edxsd.default)({
        role: Component === $59739725ddd88dec$var$defaultComponent ? null : 'table',
        ref: ref,
        className: (0, $j6s32.default)(classes.root, className, stickyHeader && classes.stickyHeader)
    }, other)));
});
var $59739725ddd88dec$export$2e2bcd8739ae039 = (0, $aIJrd.default)($59739725ddd88dec$export$9dd6ff9ea0189349, {
    name: 'MuiTable'
})($59739725ddd88dec$var$Table);


var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $aIJrd = parcelRequire("aIJrd");

var $8622dd35fedfb0c7$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'table-row-group'
    }
};
var $8622dd35fedfb0c7$var$tablelvl2 = {
    variant: 'body'
};
var $8622dd35fedfb0c7$var$defaultComponent = 'tbody';
var $8622dd35fedfb0c7$var$TableBody = /*#__PURE__*/ $ieT14.forwardRef(function TableBody(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? $8622dd35fedfb0c7$var$defaultComponent : _props$component, other = (0, $eTwGP.default)(props, [
        "classes",
        "className",
        "component"
    ]);
    return /*#__PURE__*/ $ieT14.createElement((0, $924d4b43d6e1558d$export$2e2bcd8739ae039).Provider, {
        value: $8622dd35fedfb0c7$var$tablelvl2
    }, /*#__PURE__*/ $ieT14.createElement(Component, (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className),
        ref: ref,
        role: Component === $8622dd35fedfb0c7$var$defaultComponent ? null : 'rowgroup'
    }, other)));
});
var $8622dd35fedfb0c7$export$2e2bcd8739ae039 = (0, $aIJrd.default)($8622dd35fedfb0c7$export$9dd6ff9ea0189349, {
    name: 'MuiTableBody'
})($8622dd35fedfb0c7$var$TableBody);


var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $aIJrd = parcelRequire("aIJrd");
var $6c51a2d032ad6a8c$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        width: '100%',
        overflowX: 'auto'
    }
};
var $6c51a2d032ad6a8c$var$TableContainer = /*#__PURE__*/ $ieT14.forwardRef(function TableContainer(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, other = (0, $eTwGP.default)(props, [
        "classes",
        "className",
        "component"
    ]);
    return /*#__PURE__*/ $ieT14.createElement(Component, (0, $edxsd.default)({
        ref: ref,
        className: (0, $j6s32.default)(classes.root, className)
    }, other));
});
var $6c51a2d032ad6a8c$export$2e2bcd8739ae039 = (0, $aIJrd.default)($6c51a2d032ad6a8c$export$9dd6ff9ea0189349, {
    name: 'MuiTableContainer'
})($6c51a2d032ad6a8c$var$TableContainer);


var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $aIJrd = parcelRequire("aIJrd");

var $84398180e24f8576$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'table-header-group'
    }
};
var $84398180e24f8576$var$tablelvl2 = {
    variant: 'head'
};
var $84398180e24f8576$var$defaultComponent = 'thead';
var $84398180e24f8576$var$TableHead = /*#__PURE__*/ $ieT14.forwardRef(function TableHead(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? $84398180e24f8576$var$defaultComponent : _props$component, other = (0, $eTwGP.default)(props, [
        "classes",
        "className",
        "component"
    ]);
    return /*#__PURE__*/ $ieT14.createElement((0, $924d4b43d6e1558d$export$2e2bcd8739ae039).Provider, {
        value: $84398180e24f8576$var$tablelvl2
    }, /*#__PURE__*/ $ieT14.createElement(Component, (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className),
        ref: ref,
        role: Component === $84398180e24f8576$var$defaultComponent ? null : 'rowgroup'
    }, other)));
});
var $84398180e24f8576$export$2e2bcd8739ae039 = (0, $aIJrd.default)($84398180e24f8576$export$9dd6ff9ea0189349, {
    name: 'MuiTableHead'
})($84398180e24f8576$var$TableHead);


var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $aIJrd = parcelRequire("aIJrd");


var $86m3e = parcelRequire("86m3e");
var $57cf0cd18ac88d0a$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            color: 'inherit',
            display: 'table-row',
            verticalAlign: 'middle',
            // We disable the focus ring for mouse, touch and keyboard users.
            outline: 0,
            '&$hover:hover': {
                backgroundColor: theme.palette.action.hover
            },
            '&$selected, &$selected:hover': {
                backgroundColor: (0, $86m3e.alpha)(theme.palette.secondary.main, theme.palette.action.selectedOpacity)
            }
        },
        /* Pseudo-class applied to the root element if `selected={true}`. */ selected: {},
        /* Pseudo-class applied to the root element if `hover={true}`. */ hover: {},
        /* Styles applied to the root element if table variant="head". */ head: {},
        /* Styles applied to the root element if table variant="footer". */ footer: {}
    };
};
var $57cf0cd18ac88d0a$var$defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ var $57cf0cd18ac88d0a$var$TableRow = /*#__PURE__*/ $ieT14.forwardRef(function TableRow(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? $57cf0cd18ac88d0a$var$defaultComponent : _props$component, _props$hover = props.hover, hover = _props$hover === void 0 ? false : _props$hover, _props$selected = props.selected, selected = _props$selected === void 0 ? false : _props$selected, other = (0, $eTwGP.default)(props, [
        "classes",
        "className",
        "component",
        "hover",
        "selected"
    ]);
    var tablelvl2 = $ieT14.useContext((0, $924d4b43d6e1558d$export$2e2bcd8739ae039));
    return /*#__PURE__*/ $ieT14.createElement(Component, (0, $edxsd.default)({
        ref: ref,
        className: (0, $j6s32.default)(classes.root, className, tablelvl2 && ({
            'head': classes.head,
            'footer': classes.footer
        })[tablelvl2.variant], hover && classes.hover, selected && classes.selected),
        role: Component === $57cf0cd18ac88d0a$var$defaultComponent ? null : 'row'
    }, other));
});
var $57cf0cd18ac88d0a$export$2e2bcd8739ae039 = (0, $aIJrd.default)($57cf0cd18ac88d0a$export$9dd6ff9ea0189349, {
    name: 'MuiTableRow'
})($57cf0cd18ac88d0a$var$TableRow);



const $84818efb6013b757$var$TagTable = ({ tags: tags, clientUsers: clientUsers, clientAdministrators: clientAdministrators, clientId: clientId, fetchTagsHandler: fetchTagsHandler, deleteTagHandler: deleteTagHandler, setSuccessMessage: setSuccessMessage, setErrorMessage: setErrorMessage })=>{
    const [windowSize, setWindowSize] = $ieT14.useState(0);
    $ieT14.useEffect(()=>{
        const resizeHandler = ()=>setWindowSize(window.innerWidth);
        window.addEventListener('resize', resizeHandler);
        return ()=>{
            window.removeEventListener('resize', resizeHandler);
        };
    }, []);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $6c51a2d032ad6a8c$export$2e2bcd8739ae039), {
        className: $3d0c968d45f99356$export$f2d5245d66b09437,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $59739725ddd88dec$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $84398180e24f8576$export$2e2bcd8739ae039), {
                    className: $3d0c968d45f99356$export$fbad004417327a18,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $57cf0cd18ac88d0a$export$2e2bcd8739ae039), {
                        className: $3d0c968d45f99356$export$ce666bf02318c957,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $248bc6cb24906a61$export$2e2bcd8739ae039), {
                                className: $3d0c968d45f99356$export$fad4b7e4071716b4
                            }, "color"),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $248bc6cb24906a61$export$2e2bcd8739ae039), {
                                className: $3d0c968d45f99356$export$f3a380badcbf8e95,
                                children: "TAG NAME"
                            }, "name"),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $248bc6cb24906a61$export$2e2bcd8739ae039), {
                                className: $3d0c968d45f99356$export$f34b9ca138eab87c,
                                children: "PERMISSIONED USERS"
                            }, "users"),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $248bc6cb24906a61$export$2e2bcd8739ae039), {}, "actions")
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5d10f0a7aadd7c8c$exports))), {
                autoHide: true,
                style: {
                    flex: 1
                },
                children: tags.length === 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("p", {
                    children: "There are no tags created for this client."
                }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $59739725ddd88dec$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8622dd35fedfb0c7$export$2e2bcd8739ae039), {
                        children: tags.map((tag)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $57cf0cd18ac88d0a$export$2e2bcd8739ae039), {
                                className: $3d0c968d45f99356$export$ce666bf02318c957,
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f25c15465c7d8cd3$export$2e2bcd8739ae039), {
                                    tag: tag,
                                    clientId: clientId,
                                    windowSize: windowSize,
                                    deleteTagHandler: ()=>deleteTagHandler(tag.tagId, tag.name),
                                    clientUsers: clientUsers,
                                    clientAdministrators: clientAdministrators,
                                    setSuccessMessage: setSuccessMessage,
                                    setErrorMessage: setErrorMessage,
                                    fetchTagsHandler: fetchTagsHandler
                                })
                            }, tag.tagId))
                    })
                })
            })
        ]
    });
};
var $84818efb6013b757$export$2e2bcd8739ae039 = $84818efb6013b757$var$TagTable;






var $fpdl2 = parcelRequire("fpdl2");


var $ieT14 = parcelRequire("ieT14");



var $eYT2J = parcelRequire("eYT2J");
const $16cea329e96e428a$var$AddTag = ({ addTagHandler: addTagHandler })=>{
    const [inputText, setInputText] = $ieT14.useState('');
    const addTag = (event)=>{
        event && event.preventDefault();
        if (inputText) {
            addTagHandler(inputText);
            setInputText('');
        }
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("form", {
        className: $3d0c968d45f99356$export$d220bf936897c3f,
        onSubmit: (event)=>addTag(event),
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYT2J.default), {
                id: "outlined-name",
                label: "Tag Name",
                size: "small",
                margin: "none",
                variant: "outlined",
                value: inputText,
                onChange: (event)=>setInputText(event.target.value)
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f5afe0f42548a953$export$2e2bcd8739ae039), {
                text: "Add",
                title: "Add",
                handleClick: addTag
            })
        ]
    });
};
var $16cea329e96e428a$export$2e2bcd8739ae039 = $16cea329e96e428a$var$AddTag;



const $9db911a6ebb6fcae$var$ClientTags = ({ clientId: clientId, assignedUsers: assignedUsers, assignedAdministrators: assignedAdministrators })=>{
    const [clientTags, setClientTags] = $ieT14.useState([]);
    const [loading, setLoading] = $ieT14.useState(true);
    const { fetchTags: fetchTags, createTag: createTag, deleteTag: deleteTag } = (0, $ddc981f711f942ee$export$2e2bcd8739ae039)();
    const { successMessage: successMessage, setSuccessMessage: setSuccessMessage, errorMessage: errorMessage, setErrorMessage: setErrorMessage } = (0, $dc97b0794e0fd33b$export$2e2bcd8739ae039)();
    const sortedTags = Array.from(clientTags);
    // order tags alphabetically for display
    sortedTags.sort((a, b)=>{
        if (a.name.toUpperCase() < b.name.toUpperCase()) return -1;
        if (a.name.toUpperCase() > b.name.toUpperCase()) return 1;
        return 0;
    });
    const fetchTagsHandler = ()=>{
        if (!loading) setLoading(true);
        fetchTags(clientId).then((tags)=>{
            if (tags) setClientTags(tags);
            setLoading(false);
        }).catch((err)=>{
            setErrorMessage(err.responseJSON.message);
        });
    };
    $ieT14.useEffect(()=>{
        fetchTagsHandler();
    }, []);
    const addTag = (tagName)=>{
        createTag(clientId, tagName).then((response)=>{
            if (response.success) {
                setSuccessMessage(`Success: Added tag ${response.message}: ${tagName}`);
                fetchTagsHandler();
            } else if (!response.success) setErrorMessage(response.message);
        }).catch((err)=>{
            setErrorMessage(err.responseJSON.message);
        });
    };
    const deleteTagHandler = (tagId, tagName)=>{
        deleteTag(clientId, tagId).then((response)=>{
            if (response.success) {
                setSuccessMessage(`Success: Removed tag ${response.message}: ${tagName}`);
                fetchTagsHandler();
            } else if (!response.success) setErrorMessage(response.message);
        }).catch((err)=>{
            setErrorMessage(err.responseJSON.message);
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $3d0c968d45f99356$export$8b7a896ae75accbf,
        children: [
            errorMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $cd9e5d573af72510$export$2e2bcd8739ae039), {
                message: errorMessage
            }),
            successMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $00b96652cf9f9fb7$export$2e2bcd8739ae039), {
                message: successMessage
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $16cea329e96e428a$export$2e2bcd8739ae039), {
                addTagHandler: addTag
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $3d0c968d45f99356$export$95e30c449567cd72,
                children: loading && sortedTags.length === 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: "loadingIndicator",
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
                }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $84818efb6013b757$export$2e2bcd8739ae039), {
                    tags: sortedTags,
                    deleteTagHandler: deleteTagHandler,
                    clientUsers: assignedUsers,
                    clientAdministrators: assignedAdministrators,
                    clientId: clientId,
                    setSuccessMessage: setSuccessMessage,
                    setErrorMessage: setErrorMessage,
                    fetchTagsHandler: fetchTagsHandler
                })
            })
        ]
    });
};
var $9db911a6ebb6fcae$export$2e2bcd8739ae039 = $9db911a6ebb6fcae$var$ClientTags;




var $ieT14 = parcelRequire("ieT14");
var $97348d904b593e2b$export$409285bd72865153;
var $97348d904b593e2b$export$3481c78889e8fbe8;
var $97348d904b593e2b$export$c4b0f5819f6a6663;
var $97348d904b593e2b$export$34e0f9847d4c02dd;
var $97348d904b593e2b$export$a7db06668cad9adb;
var $97348d904b593e2b$export$a262c45c089b4470;
var $97348d904b593e2b$export$38e42c68cf43b5d4;
var $97348d904b593e2b$export$3f6d243f5dbc1961;
var $97348d904b593e2b$export$57ad902a600ecd80;
var $97348d904b593e2b$export$e7d47881ec916f76;
var $97348d904b593e2b$export$295b6249f136149;
$97348d904b593e2b$export$409285bd72865153 = `_3roJTa_actionCol`;
$97348d904b593e2b$export$3481c78889e8fbe8 = `_3roJTa_center`;
$97348d904b593e2b$export$c4b0f5819f6a6663 = `_3roJTa_circularProgress`;
$97348d904b593e2b$export$34e0f9847d4c02dd = `_3roJTa_container`;
$97348d904b593e2b$export$a7db06668cad9adb = `_3roJTa_content`;
$97348d904b593e2b$export$a262c45c089b4470 = `_3roJTa_descriptionCol`;
$97348d904b593e2b$export$38e42c68cf43b5d4 = `_3roJTa_header`;
$97348d904b593e2b$export$3f6d243f5dbc1961 = `_3roJTa_resultsCount`;
$97348d904b593e2b$export$57ad902a600ecd80 = `_3roJTa_scrollTable`;
$97348d904b593e2b$export$e7d47881ec916f76 = `_3roJTa_tableWrapper`;
$97348d904b593e2b$export$295b6249f136149 = `_3roJTa_tagsCol`;




var $ieT14 = parcelRequire("ieT14");

const $45da3e4d81119192$var$defaultState = {
    loading: false,
    results: [],
    currentPage: 1,
    totalResults: 0,
    pageSize: 60,
    orderColumn: (0, $fe0b3f9952d5826a$export$e61061e57d0d071).Name,
    orderDirection: (0, $fe0b3f9952d5826a$export$e61061e57d0d071).Ascending,
    searchTerm: null
};
/** Context for sharing dashboard results to be displayed in a paginated form */ const $45da3e4d81119192$export$39e17749c7e1bbb9 = /*#__PURE__*/ $ieT14.createContext(null);
const $45da3e4d81119192$export$5935c4cd8c6169e3 = $45da3e4d81119192$export$39e17749c7e1bbb9.Consumer;
const $45da3e4d81119192$export$dd8ebb69a2ca9f35 = (props)=>{
    const [state, setState] = (0, $ieT14.useState)($45da3e4d81119192$var$defaultState);
    const dispatch = (newValue)=>{
        setState((prevState)=>{
            return {
                ...prevState,
                ...newValue
            };
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($45da3e4d81119192$export$39e17749c7e1bbb9.Provider, {
        value: {
            ...state,
            dispatch: dispatch
        },
        children: props.children
    });
};



var $ieT14 = parcelRequire("ieT14");



/**
 * @function usePaginatedDashboards - Custom hook for the dashboard management page, with pagination context
 */ const $0e7ba525b24d50fb$var$usePaginatedDashboards = ()=>{
    const { getAuth: getAuth } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    const { loading: loading, dispatch: dispatch, results: results, totalResults: totalResults } = $ieT14.useContext((0, $45da3e4d81119192$export$39e17749c7e1bbb9));
    const { errorMessage: errorMessage, setErrorMessage: setErrorMessage } = (0, $dc97b0794e0fd33b$export$2e2bcd8739ae039)();
    /**
   * fetchDashboardsPage
   * @function fetchDashboards - Fetches the dashboards from the backend and sets them to the state
   * @param options - FetchOptions
   */ const fetchDashboards = ({ currentPage: currentPage, pageSize: pageSize, searchTerm: searchTerm, clientId: clientId, orderColumn: orderColumn, orderDirection: orderDirection })=>{
        dispatch({
            loading: true
        });
        let queryParams = `?page=${currentPage}&pageSize=${pageSize}`;
        if (searchTerm && searchTerm.trim()) queryParams += `&searchTerm=${searchTerm}`;
        if (orderColumn != null) queryParams += `&sort=${orderColumn}`;
        if (orderDirection != null) queryParams += `&sortDirection=${orderDirection}`;
        return getAuth(`api/${clientId}/dashboards${queryParams}`).then((response)=>{
            dispatch({
                loading: false,
                currentPage: currentPage,
                pageSize: pageSize,
                results: response.results,
                totalResults: response.totalItems,
                orderColumn: orderColumn,
                orderDirection: orderDirection,
                searchTerm: searchTerm
            });
        }).catch(()=>setErrorMessage('Failed to get dashboards.'));
    };
    return {
        loading: loading,
        results: results,
        fetchDashboards: fetchDashboards,
        totalResults: totalResults,
        errorMessage: errorMessage
    };
};
var $0e7ba525b24d50fb$export$2e2bcd8739ae039 = $0e7ba525b24d50fb$var$usePaginatedDashboards;





var $fpdl2 = parcelRequire("fpdl2");


var $ieT14 = parcelRequire("ieT14");




parcelRequire("ieT14");


var $eYoAG = parcelRequire("eYoAG");


/**
 * @function DashboardEntry
 */ const $828048e7d4271ff9$var$DashboardEntry = ({ clientId: clientId, dashboard: dashboard, history: history })=>{
    const redirectToEditDashboard = ()=>{
        history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).EditClientDashboard.replace(':clientId', String(clientId)).replace(':dashboardId', dashboard.reportId.toString()));
    };
    let dashboardTags = '';
    if (dashboard.assignedTags) dashboardTags = dashboard.assignedTags.map((tag)=>tag.name).join(',');
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                children: dashboard.name
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                className: $97348d904b593e2b$export$a262c45c089b4470,
                title: dashboard.description,
                children: dashboard.description
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                className: $97348d904b593e2b$export$295b6249f136149,
                title: dashboardTags,
                children: dashboardTags
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                children: dashboard.reportId
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                children: dashboard.status === true ? 'ACTIVE' : 'INACTIVE'
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                className: $97348d904b593e2b$export$409285bd72865153,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fcd3b8c5e9a7038b$export$2e2bcd8739ae039), {
                    text: "Edit Dashboard",
                    title: "Edit Dashboard",
                    handleClick: ()=>redirectToEditDashboard()
                })
            })
        ]
    });
};
var $828048e7d4271ff9$export$2e2bcd8739ae039 = (0, $eYoAG.withRouter)($828048e7d4271ff9$var$DashboardEntry);








const $412eb17e3fc895d9$var$DashboardTable = ({ clientId: clientId, loading: loading })=>{
    const { results: results, pageSize: pageSize, orderColumn: orderColumn, orderDirection: orderDirection, searchTerm: searchTerm } = $ieT14.useContext((0, $45da3e4d81119192$export$39e17749c7e1bbb9));
    const { fetchDashboards: fetchDashboards } = (0, $0e7ba525b24d50fb$export$2e2bcd8739ae039)();
    const reorderHandler = (orderColumn, orderDirection)=>{
        fetchDashboards({
            clientId: clientId,
            currentPage: 1,
            pageSize: pageSize,
            searchTerm: searchTerm,
            orderColumn: orderColumn,
            orderDirection: orderDirection
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        className: $97348d904b593e2b$export$e7d47881ec916f76,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
            style: {
                height: '90%'
            },
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5d10f0a7aadd7c8c$exports))), {
                className: $97348d904b593e2b$export$57ad902a600ecd80,
                autoHide: true,
                universal: true,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $0cbf74840f7b6287$export$2e2bcd8739ae039), {
                    loading: loading,
                    results: results,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $0cd938f964be002d$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                    title: "Name",
                                    scope: "col",
                                    orderField: (0, $fe0b3f9952d5826a$export$e61061e57d0d071).Name,
                                    orderColumn: orderColumn,
                                    orderDirection: orderDirection,
                                    reorderHandler: reorderHandler
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                    title: "Description",
                                    scope: "col",
                                    orderField: (0, $fe0b3f9952d5826a$export$e61061e57d0d071).Description,
                                    orderColumn: orderColumn,
                                    orderDirection: orderDirection,
                                    reorderHandler: reorderHandler
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                    title: "Tags",
                                    scope: "col"
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                    title: "Report ID",
                                    scope: "col",
                                    orderField: (0, $fe0b3f9952d5826a$export$e61061e57d0d071).ReportId,
                                    orderColumn: orderColumn,
                                    orderDirection: orderDirection,
                                    reorderHandler: reorderHandler
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                    title: "Status",
                                    scope: "col",
                                    orderField: (0, $fe0b3f9952d5826a$export$e61061e57d0d071).Status,
                                    orderColumn: orderColumn,
                                    orderDirection: orderDirection,
                                    reorderHandler: reorderHandler
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                    title: ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $a282f935ed3e599f$export$2e2bcd8739ae039), {
                            children: !results || results.length === 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                    children: "There are no dashboards."
                                })
                            }) : results.map((results, index)=>{
                                return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $828048e7d4271ff9$export$2e2bcd8739ae039), {
                                    clientId: clientId,
                                    dashboard: results
                                }, results.reportId);
                            })
                        })
                    ]
                })
            })
        })
    });
};
var $412eb17e3fc895d9$export$2e2bcd8739ae039 = $412eb17e3fc895d9$var$DashboardTable;







var $eYoAG = parcelRequire("eYoAG");

const $3bdb82499444f547$var$Dashboards = ({ clientId: clientId })=>{
    const { pageSize: pageSize, currentPage: currentPage, orderColumn: orderColumn, orderDirection: orderDirection } = $ieT14.useContext((0, $45da3e4d81119192$export$39e17749c7e1bbb9));
    const { loading: loading, results: results, totalResults: totalResults, fetchDashboards: fetchDashboards, errorMessage: errorMessage } = (0, $0e7ba525b24d50fb$export$2e2bcd8739ae039)();
    const { searchQuery: searchTerm, updateSearchQuery: updateSearchQuery, setIsSearching: setIsSearching } = (0, $b48f023b055940c4$export$2e2bcd8739ae039)();
    const announcementCount = 0; //Announcements are not shown on management UI, so there is no need to get the real count
    const { measuredRef: measuredRef, dimensions: dimensions } = (0, $d9ed1b1da5a3379c$export$2e2bcd8739ae039)([
        results,
        announcementCount,
        errorMessage
    ], true);
    const [redirectToAddDashboard, setRedirectToAddDashboard] = $ieT14.useState(false);
    // Fetches the dashboard information for the page on mount
    $ieT14.useEffect(()=>{
        fetchDashboards({
            currentPage: currentPage,
            pageSize: pageSize,
            searchTerm: searchTerm,
            clientId: clientId,
            orderColumn: orderColumn,
            orderDirection: orderDirection
        });
    }, []);
    if (redirectToAddDashboard) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Redirect), {
        push: true,
        to: {
            pathname: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).AddClientDashboard.replace(':clientId', clientId.toString())
        }
    });
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $97348d904b593e2b$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $97348d904b593e2b$export$38e42c68cf43b5d4,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center'
                        },
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h1", {
                                children: "Dashboards"
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f5afe0f42548a953$export$2e2bcd8739ae039), {
                                text: "Add a Dashboard",
                                title: "Add a Dashboard",
                                handleClick: ()=>setRedirectToAddDashboard(true)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $00cebbc6f72b4773$export$2e2bcd8739ae039), {
                        value: searchTerm,
                        updateValue: (val)=>updateSearchQuery(val),
                        setIsSearching: (searching)=>setIsSearching(searching),
                        placeholder: 'Search Dashboards',
                        submitHandler: ()=>fetchDashboards({
                                currentPage: 1,
                                pageSize: pageSize,
                                searchTerm: searchTerm,
                                clientId: clientId,
                                orderColumn: orderColumn,
                                orderDirection: orderDirection
                            })
                    })
                ]
            }),
            errorMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $cd9e5d573af72510$export$2e2bcd8739ae039), {
                message: errorMessage
            }),
            loading && results.length === 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $97348d904b593e2b$export$c4b0f5819f6a6663,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
            }) : !results || results.length === 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                children: "There are no Dashboards."
            }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $97348d904b593e2b$export$3481c78889e8fbe8,
                ref: measuredRef,
                style: {
                    height: `calc(100vh - ${dimensions ? 20 + dimensions.top : 0}px`
                },
                children: [
                    loading && results.length > 0 || loading && results.length === 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: $97348d904b593e2b$export$c4b0f5819f6a6663,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
                    }) : null,
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        className: $97348d904b593e2b$export$a7db06668cad9adb,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                                    className: $97348d904b593e2b$export$3f6d243f5dbc1961,
                                    children: [
                                        totalResults,
                                        " results"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $412eb17e3fc895d9$export$2e2bcd8739ae039), {
                                clientId: clientId,
                                loading: loading
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f021d555e7f7d483$export$2e2bcd8739ae039), {
                        fetchResults: fetchDashboards,
                        paginatedContext: (0, $45da3e4d81119192$export$39e17749c7e1bbb9),
                        searchTerm: searchTerm,
                        fetchExtraProps: {
                            clientId: clientId
                        }
                    })
                ]
            })
        ]
    });
};
var $3bdb82499444f547$export$2e2bcd8739ae039 = $3bdb82499444f547$var$Dashboards;





var $ieT14 = parcelRequire("ieT14");


var $ieT14 = parcelRequire("ieT14");

/**
 * useDashboard
 * @function useDashboard - Custom hook for the user management page
 */ const $11b569dffddc8c64$var$useDashboardManagement = ()=>{
    const { getAuth: getAuth, postAuth: postAuth, putAuth: putAuth } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    /**
   * @function createDashboard - Create a new dashboard
   * @param dashboard - the new dashboard to create
   */ const createDashboard = (clientId, dashboard)=>{
        dashboard.status = true;
        dashboard.reportId = 0;
        return postAuth(`api/${clientId}/dashboards`, dashboard);
    };
    /**
   * @function fetchDashboard - Create a new dashboard
   * @param clientId - the client ID to fetch a dashboard from
   * @param dashboardId - the dashboard ID to fetch the dashboard of
   */ const fetchDashboard = (clientId, dashboardId)=>{
        return getAuth(`api/${clientId}/dashboards/${dashboardId}`);
    };
    const [loadingAssociatedData, setLoadingAssociatedData] = $ieT14.useState(true);
    const [tags, setTags] = $ieT14.useState([]);
    const { fetchTags: fetchTags } = (0, $ddc981f711f942ee$export$2e2bcd8739ae039)();
    /**
   * @function fetchAssociatedData - Get extra data needed to create/edit a user
   */ const fetchAssociatedData = (clientId)=>{
        if (!loadingAssociatedData) setLoadingAssociatedData(true);
        Promise.all([
            fetchTags(clientId)
        ]).then(([tags])=>{
            setTags(tags);
            setLoadingAssociatedData(false);
        });
    };
    /**
   * @function editDashboard - Edit a dashboard
   * @param clientId - the client id the dashboard belongs to
   * @param dashboard - the updated dashboard
   */ const editDashboard = (clientId, dashboard)=>{
        return putAuth(`api/${clientId}/dashboards/${dashboard.reportId}`, dashboard);
    };
    /**
   * fetchAllDashboards
   * @function fetchAllDashboards - Fetches the dashboards for a single client
   * @param clientId - the client id
   */ const fetchAllDashboards = (clientId)=>{
        let queryParams = `?page=1&pageSize=0`;
        return getAuth(`api/${clientId}/dashboards${queryParams}`);
    };
    const fetchAllDashboardsFromTableau = (clientId)=>{
        return getAuth(`api/${clientId}/dashboards/tableau/list`);
    };
    return {
        createDashboard: createDashboard,
        fetchDashboard: fetchDashboard,
        editDashboard: editDashboard,
        loadingAssociatedData: loadingAssociatedData,
        tags: tags,
        fetchAssociatedData: fetchAssociatedData,
        fetchAllDashboards: fetchAllDashboards,
        fetchAllDashboardsFromTableau: fetchAllDashboardsFromTableau
    };
};
var $11b569dffddc8c64$export$2e2bcd8739ae039 = $11b569dffddc8c64$var$useDashboardManagement;




var $ieT14 = parcelRequire("ieT14");

var $8FQwk = parcelRequire("8FQwk");




var $fpdl2 = parcelRequire("fpdl2");


var $eYoAG = parcelRequire("eYoAG");






parcelRequire("ieT14");

var $aIJrd = parcelRequire("aIJrd");

var $whS22 = parcelRequire("whS22");
var $Uxz4Y = parcelRequire("Uxz4Y");
var $aanJt = parcelRequire("aanJt");
const $3cfd911fb57d1e56$var$CssSelect = (0, $aIJrd.default)({
    root: {
        '& .MuiInputBase-root': {
            minWidth: 125,
            '&.Mui-focused fieldset': {
                borderColor: '#00AAFC'
            },
            '&.Mui-focused .MuiSelect-root': {
                backgroundColor: '#FFFFFF'
            }
        }
    }
})((0, $whS22.default));
const $3cfd911fb57d1e56$var$OutlinedSelect = (props)=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($3cfd911fb57d1e56$var$CssSelect, {
        variant: "outlined",
        margin: "normal",
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $Uxz4Y.default), {
                children: props.title
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $aanJt.default), {
                native: true,
                id: props.id,
                value: props.value,
                onChange: props.handleChange,
                onBlur: props.handleBlur,
                children: props.options
            })
        ]
    });
};
var $3cfd911fb57d1e56$export$2e2bcd8739ae039 = $3cfd911fb57d1e56$var$OutlinedSelect;


/**
 * Dashboard Types used for creating Dashboards.
 */ const $412bd15806135993$var$DashboardTypes = [
    {
        name: 'Details',
        key: 1
    },
    {
        name: 'Account',
        key: 2
    },
    {
        name: 'Audience',
        key: 3
    },
    {
        name: 'Macro',
        key: 4
    }
];
var $412bd15806135993$export$2e2bcd8739ae039 = $412bd15806135993$var$DashboardTypes;



const $55fa41603ae82cea$var$ManageDashboardSchema = $e6c1ba40263f5002$export$185802fd694ee1f5().shape({
    name: $55fd6d44ba3611c9$export$185802fd694ee1f5().required('Dashboard name is a required field.').max(100, 'Dashboard name must be less than 100 characters'),
    description: $55fd6d44ba3611c9$export$185802fd694ee1f5().required('Dashboard description is a required field.').max(500, 'Dashboard description must be less than 500 characters')
});
/**
 * @function DashboardManager Allows a user to view/create/edit a single dashboard's information.
 */ const $55fa41603ae82cea$var$DashboardManager = ({ clientId: clientId, loading: loadingDashboard, dashboard: dashboard, isNewDashboard: isNewDashboard, history: history, desktopOptions: desktopOptions })=>{
    if (isNewDashboard) //Set default dashboard values, used for Formik validation.
    dashboard = {
        reportId: null,
        name: '',
        description: '',
        assignedTags: [],
        status: null,
        reportLevel: (0, $412bd15806135993$export$2e2bcd8739ae039)[0].key,
        contentText: ''
    };
    const { createDashboard: createDashboard, editDashboard: editDashboard, loadingAssociatedData: loadingAssociatedData, tags: tags, fetchAssociatedData: fetchAssociatedData } = (0, $11b569dffddc8c64$export$2e2bcd8739ae039)();
    const [unassignedTags, setUnassignedTags] = $ieT14.useState(tags);
    const [assignedTags, setAssignedTags] = $ieT14.useState(dashboard.assignedTags);
    const [errorMessage, setErrorMessage] = $ieT14.useState('');
    const [displayDirtyWarning, setDisplayDirtyWarning] = $ieT14.useState(false);
    const [confirmedNavigation, setConfirmedNavigation] = $ieT14.useState(false);
    const [blockedLocation, setBlockedLocation] = $ieT14.useState('');
    const unblock = (0, $ieT14.useRef)(null);
    const formikRef = (0, $ieT14.useRef)(null);
    $ieT14.useEffect(()=>{
        fetchAssociatedData(clientId);
        unblock.current = history.block((location)=>{
            if (formikRef.current.dirty) {
                setDisplayDirtyWarning(true);
                setBlockedLocation(location.pathname);
                return false;
            } else unblock.current();
        });
    }, []);
    $ieT14.useEffect(()=>{
        if (confirmedNavigation) {
            unblock.current();
            history.push(blockedLocation);
        }
    }, [
        confirmedNavigation
    ]);
    $ieT14.useEffect(()=>{
        if (isNewDashboard) {
            if (!loadingAssociatedData) setUnassignedTags(tags);
        } else if (!loadingDashboard && !loadingAssociatedData) {
            if (dashboard.assignedTags === null) dashboard.assignedTags = [];
            setUnassignedTags(tags.filter((tag)=>{
                let assigned = false;
                dashboard.assignedTags.forEach((assignedApp)=>{
                    if (tag.tagId === assignedApp.tagId) assigned = true;
                });
                return !assigned;
            }));
            setAssignedTags(dashboard.assignedTags);
        }
    }, [
        loadingDashboard,
        loadingAssociatedData
    ]);
    const handleCancel = (dirty)=>{
        if (!dirty) unblock.current();
        history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).ClientDashboards.replace(':clientId', clientId.toString()));
    };
    const mapDesktopOptions = ()=>{
        const options = [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("option", {
                hidden: true,
                value: ""
            }, "none")
        ];
        desktopOptions?.map((desktopView)=>options.push(/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("option", {
                value: desktopView.url,
                children: desktopView.url
            }, desktopView.viewId)));
        return options;
    };
    return loadingDashboard || loadingAssociatedData ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        className: "loadingIndicator",
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
    }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        children: [
            errorMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $cd9e5d573af72510$export$2e2bcd8739ae039), {
                message: errorMessage
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("h1", {
                children: [
                    isNewDashboard ? 'Add' : 'Edit',
                    " Dashboard"
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8FQwk.Formik), {
                innerRef: formikRef,
                initialValues: dashboard,
                validationSchema: $55fa41603ae82cea$var$ManageDashboardSchema,
                onSubmit: (dashboard, { setSubmitting: setSubmitting })=>{
                    setSubmitting(true);
                    if (isNewDashboard) createDashboard(clientId, dashboard).then((response)=>{
                        if (response.success) {
                            setSubmitting(false);
                            unblock.current();
                            history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).ClientDashboards.replace(':clientId', clientId.toString()));
                        }
                    }).catch((err)=>{
                        setErrorMessage(err.responseJSON.message);
                        window.scroll({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        });
                        setSubmitting(false);
                    });
                    else editDashboard(clientId, dashboard).then((response)=>{
                        if (response.success) {
                            setSubmitting(false);
                            unblock.current();
                            history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).ClientDashboards.replace(':clientId', clientId.toString()));
                        }
                    }).catch((err)=>{
                        setErrorMessage(err.responseJSON.message);
                        window.scroll({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        });
                        setSubmitting(false);
                    });
                },
                children: ({ values: values, errors: errors, touched: touched, handleChange: handleChange, handleBlur: handleBlur, handleSubmit: handleSubmit, isSubmitting: isSubmitting, setFieldValue: setFieldValue, dirty: dirty })=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("form", {
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8FQwk.FormikConsumer), {
                                children: (formik)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $0ee6d6b77f108c47$export$2e2bcd8739ae039), {
                                        formik: formik,
                                        displayDirtyWarning: displayDirtyWarning,
                                        confirmNavigationWarning: ()=>{
                                            setConfirmedNavigation(true);
                                            history.push(blockedLocation);
                                        },
                                        cancleNavigationWarning: ()=>setDisplayDirtyWarning(false)
                                    })
                            }),
                            isSubmitting && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                className: $fdbf0d9f77db804d$export$29dd17c7f3c81c36,
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                    className: $fdbf0d9f77db804d$export$9a0dd4d839a90927,
                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("fieldset", {
                                className: $fdbf0d9f77db804d$export$a38812d1aa1302d9,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h5", {
                                        children: "Details"
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $db32c8adf65b4dff$export$2e2bcd8739ae039), {
                                            id: "name",
                                            label: "Dashboard Name",
                                            name: "name",
                                            onChange: handleChange,
                                            onBlur: handleBlur,
                                            value: values.name || '',
                                            error: errors.name && touched.name,
                                            helperText: errors.name && touched.name && errors.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $db32c8adf65b4dff$export$2e2bcd8739ae039), {
                                        id: "description",
                                        label: "Dashboard Description",
                                        onChange: handleChange,
                                        onBlur: handleBlur,
                                        value: values.description || '',
                                        error: errors.description && touched.description,
                                        helperText: errors.description && touched.description && errors.description
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3cfd911fb57d1e56$export$2e2bcd8739ae039), {
                                        id: "reportLevel",
                                        title: "Dashboard Type",
                                        value: values.reportLevel,
                                        handleChange: handleChange,
                                        handleBlur: handleBlur,
                                        options: (0, $412bd15806135993$export$2e2bcd8739ae039).map((dashboardType)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("option", {
                                                value: dashboardType.key,
                                                children: dashboardType.name
                                            }, dashboardType.key))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("fieldset", {
                                className: $fdbf0d9f77db804d$export$a38812d1aa1302d9,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h5", {
                                        children: "Content Column"
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3cfd911fb57d1e56$export$2e2bcd8739ae039), {
                                        id: "contentText",
                                        title: "Desktop",
                                        handleChange: handleChange,
                                        handleBlur: handleBlur,
                                        value: values.contentText,
                                        options: mapDesktopOptions()
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("fieldset", {
                                className: `${$fdbf0d9f77db804d$export$a38812d1aa1302d9}`,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h5", {
                                        children: "Permission Tags"
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $624bea18a01be01c$export$2e2bcd8739ae039), {
                                        idField: "tagId",
                                        labelField: "name",
                                        left: unassignedTags,
                                        right: assignedTags,
                                        setLeft: setUnassignedTags,
                                        setRight: setAssignedTags,
                                        setFieldValue: setFieldValue,
                                        setField: "assignedTags"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                className: $fdbf0d9f77db804d$export$135180a04c5d6085,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fcd3b8c5e9a7038b$export$2e2bcd8739ae039), {
                                        text: "Cancel",
                                        title: "Cancel",
                                        handleClick: ()=>handleCancel(dirty)
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                        className: $fdbf0d9f77db804d$export$d675b3969e4857cb,
                                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $07d7e09497a42e25$export$2e2bcd8739ae039), {
                                            text: "Save",
                                            title: "Save",
                                            deactive: isSubmitting,
                                            handleClick: handleSubmit
                                        })
                                    })
                                ]
                            })
                        ]
                    })
            })
        ]
    });
};
var $55fa41603ae82cea$export$2e2bcd8739ae039 = (0, $eYoAG.withRouter)($55fa41603ae82cea$var$DashboardManager);


const $046abf7a055fb93a$var$AddDashboard = ({ clientId: clientId })=>{
    const [loading, setLoading] = $ieT14.useState(true);
    const [desktopOptions, setDesktopOptions] = $ieT14.useState([]);
    const { fetchAllDashboardsFromTableau: fetchAllDashboardsFromTableau } = (0, $11b569dffddc8c64$export$2e2bcd8739ae039)();
    $ieT14.useEffect(()=>{
        if (!loading) setLoading(true);
        fetchAllDashboardsFromTableau(clientId).then((tableauList)=>{
            setDesktopOptions(tableauList);
            setLoading(false);
        });
    }, []);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $55fa41603ae82cea$export$2e2bcd8739ae039), {
        clientId: clientId,
        isNewDashboard: true,
        loading: loading,
        desktopOptions: desktopOptions
    });
};
var $046abf7a055fb93a$export$2e2bcd8739ae039 = $046abf7a055fb93a$var$AddDashboard;




var $ieT14 = parcelRequire("ieT14");
var $008d8028b93fa80d$export$b0377cbbbdab6cba;
var $008d8028b93fa80d$export$f27f0a643498ce3d;
var $008d8028b93fa80d$export$b00c055587dc7469;
var $008d8028b93fa80d$export$b1a09d22b7ad6c4;
var $008d8028b93fa80d$export$509f3108fdd206bb;
var $008d8028b93fa80d$export$42ff741d2868ee32;
var $008d8028b93fa80d$export$8c430709db82137d;
var $008d8028b93fa80d$export$2d4b1211b4389c3b;
var $008d8028b93fa80d$export$3832be13857745bc;
var $008d8028b93fa80d$export$f4c68800b094ddb1;
var $008d8028b93fa80d$export$dff72a5fd5ad3e0c;
var $008d8028b93fa80d$export$b6e43b52b188ac0f;
var $008d8028b93fa80d$export$7246d22ab0922ede;
var $008d8028b93fa80d$export$64528cb06183cfba;
var $008d8028b93fa80d$export$ad03a22c34ccf90e;
var $008d8028b93fa80d$export$2d644207714cbedf;
var $008d8028b93fa80d$export$2e6c959c16ff56b8;
var $008d8028b93fa80d$export$f15b31aa3f8d543f;
var $008d8028b93fa80d$export$428e7c787d57587d;
var $008d8028b93fa80d$export$80a6180f57d52770;
var $008d8028b93fa80d$export$7c6191f25b7d8c71;
var $008d8028b93fa80d$export$b5cb804542eb9e20;
var $008d8028b93fa80d$export$22c3fa72cbbcdc02;
var $008d8028b93fa80d$export$6a6e38f6cd58c8a2;
var $008d8028b93fa80d$export$74d7c0edf95632ad;
var $008d8028b93fa80d$export$25f281a96778caf1;
var $008d8028b93fa80d$export$bf5daf80bda0b208;
var $008d8028b93fa80d$export$aaf041586c7e9139;
$008d8028b93fa80d$export$b0377cbbbdab6cba = "#006da8";
$008d8028b93fa80d$export$f27f0a643498ce3d = "#00aafc";
$008d8028b93fa80d$export$b00c055587dc7469 = "#f5dbd9";
$008d8028b93fa80d$export$b1a09d22b7ad6c4 = "#c92100";
$008d8028b93fa80d$export$509f3108fdd206bb = "#ebafa6";
$008d8028b93fa80d$export$42ff741d2868ee32 = "#074f86";
$008d8028b93fa80d$export$8c430709db82137d = "#dadada";
$008d8028b93fa80d$export$2d4b1211b4389c3b = "#dddbda";
$008d8028b93fa80d$export$3832be13857745bc = "#eae9ed";
$008d8028b93fa80d$export$f4c68800b094ddb1 = "#e9e8f4";
$008d8028b93fa80d$export$dff72a5fd5ad3e0c = "addNavigation_e696d2";
$008d8028b93fa80d$export$b6e43b52b188ac0f = "radioGroupLabel_e696d2";
$008d8028b93fa80d$export$7246d22ab0922ede = "radioGroup_e696d2";
$008d8028b93fa80d$export$64528cb06183cfba = "radioLabel_e696d2";
$008d8028b93fa80d$export$ad03a22c34ccf90e = "radioDisabled_e696d2";
$008d8028b93fa80d$export$2d644207714cbedf = "categoryNameInput_e696d2";
$008d8028b93fa80d$export$2e6c959c16ff56b8 = "select_e696d2";
$008d8028b93fa80d$export$f15b31aa3f8d543f = "selectDisabled_e696d2";
$008d8028b93fa80d$export$428e7c787d57587d = "navigation_e696d2";
$008d8028b93fa80d$export$80a6180f57d52770 = "navListWrap_e696d2";
$008d8028b93fa80d$export$7c6191f25b7d8c71 = "navListHeader_e696d2";
$008d8028b93fa80d$export$b5cb804542eb9e20 = "navList_e696d2";
$008d8028b93fa80d$export$22c3fa72cbbcdc02 = "navListItem_e696d2";
$008d8028b93fa80d$export$6a6e38f6cd58c8a2 = "navListDragIcon_e696d2";
$008d8028b93fa80d$export$74d7c0edf95632ad = "navListForm_e696d2";
$008d8028b93fa80d$export$25f281a96778caf1 = "dashboardList_e696d2";
$008d8028b93fa80d$export$bf5daf80bda0b208 = "isDraggingOver_e696d2";
$008d8028b93fa80d$export$aaf041586c7e9139 = "formControl_e696d2";



var $fpdl2 = parcelRequire("fpdl2");


var $ieT14 = parcelRequire("ieT14");


var $dxqtw = parcelRequire("dxqtw");


var $ieT14 = parcelRequire("ieT14");


var $6a14edd9ac02d0a6$exports = {};
"use strict";


Object.defineProperty($6a14edd9ac02d0a6$exports, "__esModule", {
    value: true
});
$6a14edd9ac02d0a6$exports.default = void 0;

var $6a14edd9ac02d0a6$var$React = $633c7dc13d665c5e$exports((parcelRequire("ieT14")));

var $6a14edd9ac02d0a6$var$_createSvgIcon = $b24015bb0dc2bec9$exports((parcelRequire("3yIjW")));
var $6a14edd9ac02d0a6$var$_default = (0, $6a14edd9ac02d0a6$var$_createSvgIcon.default)(/*#__PURE__*/ $6a14edd9ac02d0a6$var$React.createElement("path", {
    d: "M20 9H4v2h16V9zM4 15h16v-2H4v2z"
}), 'DragHandle');
$6a14edd9ac02d0a6$exports.default = $6a14edd9ac02d0a6$var$_default;



var $1KcBP = parcelRequire("1KcBP");
var $dxqtw = parcelRequire("dxqtw");
var $1fCJg = parcelRequire("1fCJg");
var $iwN3n = parcelRequire("iwN3n");


var $ieT14 = parcelRequire("ieT14");



var $kRJN7 = parcelRequire("kRJN7");
var $whS22 = parcelRequire("whS22");
var $1KcBP = parcelRequire("1KcBP");
var $Uxz4Y = parcelRequire("Uxz4Y");
var $1fCJg = parcelRequire("1fCJg");
var $iwN3n = parcelRequire("iwN3n");
var $3mOXj = parcelRequire("3mOXj");
var $aanJt = parcelRequire("aanJt");
var $aIJrd = parcelRequire("aIJrd");

var $eg6hn = parcelRequire("eg6hn");


const $c3b96bca0fceac56$var$DashboardInput = (0, $aIJrd.default)(()=>(0, $kRJN7.default)({
        input: {
            borderRadius: 4,
            position: 'relative',
            border: '1px solid #d1cece',
            padding: '6px',
            fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).body,
            fontSize: '12px',
            lineHeight: '17px',
            '&:focus': {
                borderRadius: 4,
                borderColor: '#80bdff',
                backgroundColor: 'white'
            }
        }
    }))((0, $eg6hn.default));
const $c3b96bca0fceac56$var$DashListItem = ({ childNavigation: childNavigation, provided: provided, clientDashboards: clientDashboards, updateDashboardNavigation: updateDashboardNavigation, deleteDashboard: deleteDashboard })=>{
    const [dashboard, setDashboard] = $ieT14.useState(Number(childNavigation.link));
    const handleChange = (event)=>{
        setDashboard(Number(event.target.value));
        const linkedDashboard = clientDashboards.find((dashboard)=>dashboard.reportId === Number(event.target.value));
        const newNavigation = {
            ...childNavigation,
            link: linkedDashboard.reportId.toString(),
            name: linkedDashboard.name,
            description: linkedDashboard.description
        };
        updateDashboardNavigation(newNavigation);
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $1fCJg.default), {
        className: $008d8028b93fa80d$export$22c3fa72cbbcdc02,
        ref: provided.innerRef,
        ...provided.draggableProps,
        ...provided.dragHandleProps,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $iwN3n.default), {
                className: $008d8028b93fa80d$export$6a6e38f6cd58c8a2,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6a14edd9ac02d0a6$exports))), {})
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("form", {
                className: $008d8028b93fa80d$export$74d7c0edf95632ad,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
                        className: $008d8028b93fa80d$export$aaf041586c7e9139,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $Uxz4Y.default), {
                                id: `dashboard-select-${childNavigation.navigationId}`,
                                style: {
                                    display: 'none'
                                },
                                children: "Dashboard"
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $aanJt.default), {
                                className: $008d8028b93fa80d$export$2e6c959c16ff56b8,
                                labelId: `dashboard-select-${childNavigation.navigationId}`,
                                value: dashboard,
                                onChange: handleChange,
                                input: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($c3b96bca0fceac56$var$DashboardInput, {}),
                                children: clientDashboards.map((dashboard)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                        value: dashboard.reportId,
                                        children: dashboard.name
                                    }, dashboard.reportId))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $105db2ddc246141f$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                            title: "Delete",
                            edge: "end",
                            "aria-label": "delete",
                            onClick: ()=>deleteDashboard(childNavigation),
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $70ccc3891d50e85f$export$2e2bcd8739ae039), {
                                style: {
                                    color: '#006da8'
                                }
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $c3b96bca0fceac56$export$2e2bcd8739ae039 = $c3b96bca0fceac56$var$DashListItem;



var $ieT14 = parcelRequire("ieT14");

var $ieT14 = parcelRequire("ieT14");
function $9da7c6a4dfccef3e$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $9da7c6a4dfccef3e$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $ieT14.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $ieT14.useRef)(true);
    var committed = (0, $ieT14.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $9da7c6a4dfccef3e$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $ieT14.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $9da7c6a4dfccef3e$export$33752cf3ee811995(callback, inputs) {
    return $9da7c6a4dfccef3e$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $9da7c6a4dfccef3e$export$1538c33de8887b59 = $9da7c6a4dfccef3e$export$b6feb8998cd9b342;
var $9da7c6a4dfccef3e$export$35808ee640e87ca7 = $9da7c6a4dfccef3e$export$33752cf3ee811995;


var $74a8ae6f9f5b4013$exports = {};

var $5Q5bp = parcelRequire("5Q5bp");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$5Q5bp($5Q5bp.S, 'Object', {
    create: (parcelRequire("fuayA"))
});



var $drUUa = parcelRequire("drUUa");
var $74a8ae6f9f5b4013$require$$Object = $drUUa.Object;
$74a8ae6f9f5b4013$exports = function create(P, D) {
    return $74a8ae6f9f5b4013$require$$Object.create(P, D);
};


var $42c8acf9f2cacf27$exports = {};
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $5Q5bp = parcelRequire("5Q5bp");

$5Q5bp($5Q5bp.S, 'Object', {
    setPrototypeOf: (parcelRequire("kpHXZ")).set
});



$42c8acf9f2cacf27$exports = (parcelRequire("drUUa")).Object.setPrototypeOf;


function $b9f5d87637fa8f7b$export$2e2bcd8739ae039(t, e) {
    return $b9f5d87637fa8f7b$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($42c8acf9f2cacf27$exports))) ? (0, (/*@__PURE__*/$parcel$interopDefault($42c8acf9f2cacf27$exports))).bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $b9f5d87637fa8f7b$export$2e2bcd8739ae039(t, e);
}


function $31b5b7cf3016567e$export$2e2bcd8739ae039(t, o) {
    t.prototype = (0, (/*@__PURE__*/$parcel$interopDefault($74a8ae6f9f5b4013$exports)))(o.prototype), t.prototype.constructor = t, (0, $b9f5d87637fa8f7b$export$2e2bcd8739ae039)(t, o);
}



var $2tNbD = parcelRequire("2tNbD");
function $28b08d9c869f9be4$export$2e2bcd8739ae039() {
    return $28b08d9c869f9be4$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($2tNbD))) ? (0, (/*@__PURE__*/$parcel$interopDefault($2tNbD))).bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $28b08d9c869f9be4$export$2e2bcd8739ae039.apply(null, arguments);
}


function $c30f144cdf91ac45$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $c30f144cdf91ac45$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c30f144cdf91ac45$export$2e2bcd8739ae039(o);
}



function $8f819da4694e43e8$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $c30f144cdf91ac45$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $c30f144cdf91ac45$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $0724bfacedb01285$export$2e2bcd8739ae039(t) {
    var i = (0, $8f819da4694e43e8$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $c30f144cdf91ac45$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $add72c1f7eabc93b$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $0724bfacedb01285$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $7dc744f1edb34efd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7dc744f1edb34efd$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7dc744f1edb34efd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $add72c1f7eabc93b$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7dc744f1edb34efd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $7778c83e64d928d5$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $7778c83e64d928d5$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $7778c83e64d928d5$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $7778c83e64d928d5$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $7778c83e64d928d5$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $7778c83e64d928d5$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $7778c83e64d928d5$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $7778c83e64d928d5$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $7778c83e64d928d5$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($7778c83e64d928d5$var$isDate(val)) return 'date';
    if ($7778c83e64d928d5$var$isError(val)) return 'error';
    var constructorName = $7778c83e64d928d5$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $7778c83e64d928d5$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $7778c83e64d928d5$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $7778c83e64d928d5$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $7778c83e64d928d5$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $7778c83e64d928d5$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($7778c83e64d928d5$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($7778c83e64d928d5$var$formatProdErrorMessage(1));
        return enhancer($7778c83e64d928d5$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($7778c83e64d928d5$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($7778c83e64d928d5$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($7778c83e64d928d5$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($7778c83e64d928d5$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($7778c83e64d928d5$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$7778c83e64d928d5$var$isPlainObject(action)) throw new Error($7778c83e64d928d5$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($7778c83e64d928d5$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($7778c83e64d928d5$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($7778c83e64d928d5$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $7778c83e64d928d5$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($7778c83e64d928d5$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$7778c83e64d928d5$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $7778c83e64d928d5$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$7778c83e64d928d5$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $7778c83e64d928d5$export$8928921ea2d3b126 = $7778c83e64d928d5$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $7778c83e64d928d5$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $7778c83e64d928d5$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $7778c83e64d928d5$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$7778c83e64d928d5$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $7778c83e64d928d5$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $7778c83e64d928d5$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $7778c83e64d928d5$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $7778c83e64d928d5$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($7778c83e64d928d5$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $7778c83e64d928d5$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($7778c83e64d928d5$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $7778c83e64d928d5$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $7778c83e64d928d5$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($7778c83e64d928d5$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $7778c83e64d928d5$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $7778c83e64d928d5$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $7778c83e64d928d5$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($7778c83e64d928d5$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $7778c83e64d928d5$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $7778c83e64d928d5$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $7778c83e64d928d5$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($7778c83e64d928d5$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $7778c83e64d928d5$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $7dc744f1edb34efd$export$2e2bcd8739ae039)((0, $7dc744f1edb34efd$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}



var $ieT14 = parcelRequire("ieT14");


var $ieT14 = parcelRequire("ieT14");
var $03f043030020d781$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createContext(null);
var $03f043030020d781$export$2e2bcd8739ae039 = $03f043030020d781$export$cc80c08dc91f1c00;


// Default to a dummy "batch" implementation that just runs the callback
function $b2d40baee5e79531$var$defaultNoopBatch(callback) {
    callback();
}
var $b2d40baee5e79531$var$batch = $b2d40baee5e79531$var$defaultNoopBatch; // Allow injecting another batching function later
var $b2d40baee5e79531$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $b2d40baee5e79531$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $b2d40baee5e79531$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $b2d40baee5e79531$var$batch;
};


// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $205354d773685e5d$var$createListenerCollection() {
    var batch = (0, $b2d40baee5e79531$export$fc47d4c0ba3bd2c6)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $205354d773685e5d$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $205354d773685e5d$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $205354d773685e5d$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $205354d773685e5d$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $205354d773685e5d$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}



var $ieT14 = parcelRequire("ieT14");
var $73864253894adc8c$export$700979bc83e7db82 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $ieT14.useLayoutEffect) : (0, $ieT14.useEffect);


function $bea69f7496a97ae0$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $ieT14.useMemo)(function() {
        var subscription = (0, $205354d773685e5d$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $ieT14.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $73864253894adc8c$export$700979bc83e7db82)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $03f043030020d781$export$cc80c08dc91f1c00);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $bea69f7496a97ae0$export$2e2bcd8739ae039 = $bea69f7496a97ae0$var$Provider;


function $42f10a969a1969f5$export$2e2bcd8739ae039() {
    return $42f10a969a1969f5$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $42f10a969a1969f5$export$2e2bcd8739ae039.apply(null, arguments);
}


function $8c6e226a14a743f4$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $6YpfP = parcelRequire("6YpfP");

var $ieT14 = parcelRequire("ieT14");

var $fqwRx = parcelRequire("fqwRx");



var $7611f4e26d6f540c$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $7611f4e26d6f540c$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $7611f4e26d6f540c$var$EMPTY_ARRAY = [];
var $7611f4e26d6f540c$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $7611f4e26d6f540c$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $7611f4e26d6f540c$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $7611f4e26d6f540c$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $73864253894adc8c$export$700979bc83e7db82)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $7611f4e26d6f540c$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $7611f4e26d6f540c$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: 'STORE_UPDATED',
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $7611f4e26d6f540c$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $7611f4e26d6f540c$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $03f043030020d781$export$cc80c08dc91f1c00) : _ref2$context, connectOptions = (0, $8c6e226a14a743f4$export$2e2bcd8739ae039)(_ref2, $7611f4e26d6f540c$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $42f10a969a1969f5$export$2e2bcd8739ae039)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $ieT14.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $ieT14.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $8c6e226a14a743f4$export$2e2bcd8739ae039)(props, $7611f4e26d6f540c$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $ieT14.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $fqwRx.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $ieT14.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $ieT14.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $ieT14.useMemo)(function() {
                if (!shouldHandleStateChanges) return $7611f4e26d6f540c$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $205354d773685e5d$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $ieT14.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $42f10a969a1969f5$export$2e2bcd8739ae039)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $ieT14.useReducer)($7611f4e26d6f540c$var$storeStateUpdatesReducer, $7611f4e26d6f540c$var$EMPTY_ARRAY, $7611f4e26d6f540c$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $ieT14.useRef)();
            var lastWrapperProps = (0, $ieT14.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $ieT14.useRef)();
            var renderIsScheduled = (0, $ieT14.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $7611f4e26d6f540c$var$useIsomorphicLayoutEffectWithArgs($7611f4e26d6f540c$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $7611f4e26d6f540c$var$useIsomorphicLayoutEffectWithArgs($7611f4e26d6f540c$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $ieT14.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement(WrappedComponent, (0, $42f10a969a1969f5$export$2e2bcd8739ae039)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $ieT14.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement(Connect, (0, $42f10a969a1969f5$export$2e2bcd8739ae039)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($6YpfP)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($6YpfP)))(Connect, WrappedComponent);
    };
}






function $e8f3b395157b53f0$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $e8f3b395157b53f0$export$2e2bcd8739ae039(objA, objB) {
    if ($e8f3b395157b53f0$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$e8f3b395157b53f0$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}


function $7244957e6079aa2a$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $7d47f8215d03f9bb$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}


/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $8f7c60eeae13c32c$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $c23d497d9f6eaf00$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $7d47f8215d03f9bb$export$2e2bcd8739ae039)(value)) (0, $8f7c60eeae13c32c$export$2e2bcd8739ae039)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}


function $f67ea0e97d232922$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $f67ea0e97d232922$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $f67ea0e97d232922$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $f67ea0e97d232922$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $f67ea0e97d232922$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $04f7d09025081369$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, $f67ea0e97d232922$export$8d46c7f53c8c602f)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function $04f7d09025081369$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $f67ea0e97d232922$export$710f7c60f68acd3e)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $04f7d09025081369$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $f67ea0e97d232922$export$710f7c60f68acd3e)(function(dispatch) {
        return (0, $7244957e6079aa2a$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $04f7d09025081369$export$2e2bcd8739ae039 = [
    $04f7d09025081369$export$a9f27b4b187c1166,
    $04f7d09025081369$export$ba20d1a7aa0c4a90,
    $04f7d09025081369$export$94a6e55709d4d961
];



function $fe55f05f4e617204$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, $f67ea0e97d232922$export$8d46c7f53c8c602f)(mapStateToProps, 'mapStateToProps') : undefined;
}
function $fe55f05f4e617204$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $f67ea0e97d232922$export$710f7c60f68acd3e)(function() {
        return {};
    }) : undefined;
}
var $fe55f05f4e617204$export$2e2bcd8739ae039 = [
    $fe55f05f4e617204$export$23fc470827b14aa,
    $fe55f05f4e617204$export$514bc8c1a53c1d66
];




function $3db46c0852f41d2a$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $42f10a969a1969f5$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $3db46c0852f41d2a$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $3db46c0852f41d2a$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === 'function' ? $3db46c0852f41d2a$export$5b105939c84b5234(mergeProps) : undefined;
}
function $3db46c0852f41d2a$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $3db46c0852f41d2a$export$691c327fc30bc857;
    } : undefined;
}
var $3db46c0852f41d2a$export$2e2bcd8739ae039 = [
    $3db46c0852f41d2a$export$d61b680184bc3f00,
    $3db46c0852f41d2a$export$a13ba70ef50dda6d
];




function $3e03c2772a134e00$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $8f7c60eeae13c32c$export$2e2bcd8739ae039)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $3e03c2772a134e00$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $3e03c2772a134e00$var$verify(mapStateToProps, 'mapStateToProps', displayName);
    $3e03c2772a134e00$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    $3e03c2772a134e00$var$verify(mergeProps, 'mergeProps', displayName);
}


var $5446f4ce9532e6e6$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $5446f4ce9532e6e6$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $5446f4ce9532e6e6$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $5446f4ce9532e6e6$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $8c6e226a14a743f4$export$2e2bcd8739ae039)(_ref2, $5446f4ce9532e6e6$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $5446f4ce9532e6e6$export$d20c0c2ca6eb2b6f : $5446f4ce9532e6e6$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


var $a3b0bcd7a825bc6d$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $a3b0bcd7a825bc6d$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $a3b0bcd7a825bc6d$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $a3b0bcd7a825bc6d$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $7611f4e26d6f540c$export$2e2bcd8739ae039) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $fe55f05f4e617204$export$2e2bcd8739ae039) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $04f7d09025081369$export$2e2bcd8739ae039) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $3db46c0852f41d2a$export$2e2bcd8739ae039) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $5446f4ce9532e6e6$export$2e2bcd8739ae039) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $a3b0bcd7a825bc6d$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $e8f3b395157b53f0$export$2e2bcd8739ae039) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $e8f3b395157b53f0$export$2e2bcd8739ae039) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $e8f3b395157b53f0$export$2e2bcd8739ae039) : _ref3$areMergedPropsE, extraOptions = (0, $8c6e226a14a743f4$export$2e2bcd8739ae039)(_ref3, $a3b0bcd7a825bc6d$var$_excluded);
        var initMapStateToProps = $a3b0bcd7a825bc6d$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = $a3b0bcd7a825bc6d$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = $a3b0bcd7a825bc6d$var$match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, $42f10a969a1969f5$export$2e2bcd8739ae039)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $a3b0bcd7a825bc6d$export$2e2bcd8739ae039 = /*#__PURE__*/ $a3b0bcd7a825bc6d$export$9f9feb656dec1fc4();




var $ieT14 = parcelRequire("ieT14");


var $ieT14 = parcelRequire("ieT14");

function $06579d52fc2cea43$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $ieT14.useContext)((0, $03f043030020d781$export$cc80c08dc91f1c00));
    return contextValue;
}


function $f2bfe7ab6bc1c5cf$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $03f043030020d781$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $03f043030020d781$export$cc80c08dc91f1c00) ? (0, $06579d52fc2cea43$export$c1275ca9a6fd3ec5) : function() {
        return (0, $ieT14.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $f2bfe7ab6bc1c5cf$export$6ccbb43953eebf8 = /*#__PURE__*/ $f2bfe7ab6bc1c5cf$export$671dba69185d0304();


function $95fb9f5aa791daa4$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $03f043030020d781$export$cc80c08dc91f1c00);
    var useStore = context === (0, $03f043030020d781$export$cc80c08dc91f1c00) ? (0, $f2bfe7ab6bc1c5cf$export$6ccbb43953eebf8) : (0, $f2bfe7ab6bc1c5cf$export$671dba69185d0304)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $95fb9f5aa791daa4$export$8ad76b76a4c905f8 = /*#__PURE__*/ $95fb9f5aa791daa4$export$bc9b55530897c558();



var $ieT14 = parcelRequire("ieT14");




var $7ad69a027cb22e9d$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $7ad69a027cb22e9d$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $ieT14.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $ieT14.useMemo)(function() {
        return (0, $205354d773685e5d$export$d567d2b9af322f8f)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $ieT14.useRef)();
    var latestSelector = (0, $ieT14.useRef)();
    var latestStoreState = (0, $ieT14.useRef)();
    var latestSelectedState = (0, $ieT14.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $73864253894adc8c$export$700979bc83e7db82)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $73864253894adc8c$export$700979bc83e7db82)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $7ad69a027cb22e9d$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $03f043030020d781$export$cc80c08dc91f1c00);
    var useReduxContext = context === (0, $03f043030020d781$export$cc80c08dc91f1c00) ? (0, $06579d52fc2cea43$export$c1275ca9a6fd3ec5) : function() {
        return (0, $ieT14.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $7ad69a027cb22e9d$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $7ad69a027cb22e9d$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $ieT14.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $7ad69a027cb22e9d$export$2105062e25df4afe = /*#__PURE__*/ $7ad69a027cb22e9d$export$2b53f90d2bd1cbfb();






/* eslint-disable import/no-unresolved */ 
var $3tOoB = parcelRequire("3tOoB");


var $3tOoB = parcelRequire("3tOoB");

// with standard React renderers (ReactDOM, React Native)
(0, $b2d40baee5e79531$export$4b9874722d0da7bc)((0, $3tOoB.unstable_batchedUpdates));



var $kuuqU = parcelRequire("kuuqU");
var $b703e4029dc36ed5$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $b703e4029dc36ed5$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $b703e4029dc36ed5$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $b703e4029dc36ed5$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $b703e4029dc36ed5$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $b703e4029dc36ed5$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $b703e4029dc36ed5$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $b703e4029dc36ed5$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $b703e4029dc36ed5$var$noSpacing : _ref2$padding;
    var marginBox = $b703e4029dc36ed5$export$4b834cebd9e5cebe($b703e4029dc36ed5$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $b703e4029dc36ed5$export$4b834cebd9e5cebe($b703e4029dc36ed5$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $b703e4029dc36ed5$export$4b834cebd9e5cebe($b703e4029dc36ed5$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $b703e4029dc36ed5$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $b703e4029dc36ed5$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== 'px') return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $kuuqU.default)(false);
    return result;
};
var $b703e4029dc36ed5$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $b703e4029dc36ed5$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $b703e4029dc36ed5$var$shift(borderBox, change);
    return $b703e4029dc36ed5$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $b703e4029dc36ed5$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $b703e4029dc36ed5$var$getWindowScroll();
    return $b703e4029dc36ed5$export$cc800923e997bb8(original, scroll);
};
var $b703e4029dc36ed5$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $b703e4029dc36ed5$var$parse(styles.marginTop),
        right: $b703e4029dc36ed5$var$parse(styles.marginRight),
        bottom: $b703e4029dc36ed5$var$parse(styles.marginBottom),
        left: $b703e4029dc36ed5$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $b703e4029dc36ed5$var$parse(styles.paddingTop),
        right: $b703e4029dc36ed5$var$parse(styles.paddingRight),
        bottom: $b703e4029dc36ed5$var$parse(styles.paddingBottom),
        left: $b703e4029dc36ed5$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $b703e4029dc36ed5$var$parse(styles.borderTopWidth),
        right: $b703e4029dc36ed5$var$parse(styles.borderRightWidth),
        bottom: $b703e4029dc36ed5$var$parse(styles.borderBottomWidth),
        left: $b703e4029dc36ed5$var$parse(styles.borderLeftWidth)
    };
    return $b703e4029dc36ed5$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $b703e4029dc36ed5$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $b703e4029dc36ed5$export$b8dfc5d4e552b8e1(borderBox, styles);
};


var $bab2733189173eea$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $bab2733189173eea$var$isEqual(first, second) {
    if (first === second) return true;
    if ($bab2733189173eea$var$safeIsNaN(first) && $bab2733189173eea$var$safeIsNaN(second)) return true;
    return false;
}
function $bab2733189173eea$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$bab2733189173eea$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $bab2733189173eea$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $bab2733189173eea$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $bab2733189173eea$export$2e2bcd8739ae039 = $bab2733189173eea$var$memoizeOne;


var $9af2d53c4ea14e37$exports = {};

$9af2d53c4ea14e37$exports = (parcelRequire("lwi4T"));


var $215be2e2d7075d90$exports = {};

$215be2e2d7075d90$exports = (parcelRequire("4IhFa"));


var $3a3632abf48ab519$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $3a3632abf48ab519$export$2e2bcd8739ae039 = $3a3632abf48ab519$var$rafSchd;


var $2844f46160634521$exports = {};

$2844f46160634521$exports = (parcelRequire("i3LOS"));


var $0f31be94f80b080a$exports = {};

$0f31be94f80b080a$exports = (parcelRequire("2tNbD"));



var $3tOoB = parcelRequire("3tOoB");
var $e28cdd20687c4c2b$exports = {};

$e28cdd20687c4c2b$exports = (parcelRequire("cct7W"));


var $83a769edb27eac89$var$isProduction = true;
var $83a769edb27eac89$var$spacesAndTabs = /[ \t]{2,}/g;
var $83a769edb27eac89$var$lineStartWithSpaces = /^[ \t]*/gm;
var $83a769edb27eac89$var$clean = function clean(value) {
    return value.replace($83a769edb27eac89$var$spacesAndTabs, ' ').replace($83a769edb27eac89$var$lineStartWithSpaces, '').trim();
};
var $83a769edb27eac89$var$getDevMessage = function getDevMessage(message) {
    return $83a769edb27eac89$var$clean("\n  %creact-beautiful-dnd\n\n  %c" + $83a769edb27eac89$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};
var $83a769edb27eac89$var$getFormattedMessage = function getFormattedMessage(message) {
    return [
        $83a769edb27eac89$var$getDevMessage(message),
        'color: #00C584; font-size: 1.2em; font-weight: bold;',
        'line-height: 1.5',
        'color: #723874;'
    ];
};
var $83a769edb27eac89$var$isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';
function $83a769edb27eac89$var$log(type, message) {
    var _console;
    if ($83a769edb27eac89$var$isProduction) return;
    if (typeof window !== 'undefined' && window[$83a769edb27eac89$var$isDisabledFlag]) return;
    (_console = console)[type].apply(_console, $83a769edb27eac89$var$getFormattedMessage(message));
}
var $83a769edb27eac89$var$warning = $83a769edb27eac89$var$log.bind(null, 'warn');
var $83a769edb27eac89$var$error = $83a769edb27eac89$var$log.bind(null, 'error');
function $83a769edb27eac89$var$noop() {}
function $83a769edb27eac89$var$getOptions(shared, fromBinding) {
    return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, shared, fromBinding);
}
function $83a769edb27eac89$var$bindEvents(el, bindings, sharedOptions) {
    var unbindings = bindings.map(function(binding) {
        var options = $83a769edb27eac89$var$getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
        return function unbind() {
            el.removeEventListener(binding.eventName, binding.fn, options);
        };
    });
    return function unbindAll() {
        unbindings.forEach(function(unbind) {
            unbind();
        });
    };
}
var $83a769edb27eac89$var$isProduction$1 = true;
var $83a769edb27eac89$var$prefix = 'Invariant failed';
function $83a769edb27eac89$var$RbdInvariant(message) {
    this.message = message;
}
$83a769edb27eac89$var$RbdInvariant.prototype.toString = function toString() {
    return this.message;
};
function $83a769edb27eac89$var$invariant(condition, message) {
    if (condition) return;
    if ($83a769edb27eac89$var$isProduction$1) throw new $83a769edb27eac89$var$RbdInvariant($83a769edb27eac89$var$prefix);
    else throw new $83a769edb27eac89$var$RbdInvariant($83a769edb27eac89$var$prefix + ": " + (message || ''));
}
var $83a769edb27eac89$var$ErrorBoundary = function(_React$Component) {
    (0, $31b5b7cf3016567e$export$2e2bcd8739ae039)(ErrorBoundary, _React$Component);
    function ErrorBoundary() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.callbacks = null;
        _this.unbind = $83a769edb27eac89$var$noop;
        _this.onWindowError = function(event) {
            var callbacks = _this.getCallbacks();
            if (callbacks.isDragging()) callbacks.tryAbort();
            var err = event.error;
            if (err instanceof $83a769edb27eac89$var$RbdInvariant) event.preventDefault();
        };
        _this.getCallbacks = function() {
            if (!_this.callbacks) throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
            return _this.callbacks;
        };
        _this.setCallbacks = function(callbacks) {
            _this.callbacks = callbacks;
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.unbind = $83a769edb27eac89$var$bindEvents(window, [
            {
                eventName: 'error',
                fn: this.onWindowError
            }
        ]);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.unbind();
    };
    _proto.componentDidCatch = function componentDidCatch(err) {
        if (err instanceof $83a769edb27eac89$var$RbdInvariant) {
            this.setState({});
            return;
        }
        throw err;
    };
    _proto.render = function render() {
        return this.props.children(this.setCallbacks);
    };
    return ErrorBoundary;
}((0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).Component);
var $83a769edb27eac89$var$liftInstruction = "Draggable item. Ensure your screen reader is not in browse mode and then press space bar to lift.";
var $83a769edb27eac89$var$position = function position(index) {
    return index + 1;
};
var $83a769edb27eac89$var$onDragStart = function onDragStart(start) {
    return "\n  You have lifted an item in position " + $83a769edb27eac89$var$position(start.source.index) + ".\n  Use the arrow keys to move, space bar to drop, and escape to cancel.\n";
};
var $83a769edb27eac89$var$withLocation = function withLocation(source, destination) {
    var isInHomeList = source.droppableId === destination.droppableId;
    var startPosition = $83a769edb27eac89$var$position(source.index);
    var endPosition = $83a769edb27eac89$var$position(destination.index);
    if (isInHomeList) return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
    return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};
var $83a769edb27eac89$var$withCombine = function withCombine(id, source, combine) {
    var inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
    return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};
var $83a769edb27eac89$var$onDragUpdate = function onDragUpdate(update) {
    var location = update.destination;
    if (location) return $83a769edb27eac89$var$withLocation(update.source, location);
    var combine = update.combine;
    if (combine) return $83a769edb27eac89$var$withCombine(update.draggableId, update.source, combine);
    return 'You are over an area that cannot be dropped on';
};
var $83a769edb27eac89$var$returnedToStart = function returnedToStart(source) {
    return "\n  The item has returned to its starting position\n  of " + $83a769edb27eac89$var$position(source.index) + "\n";
};
var $83a769edb27eac89$var$onDragEnd = function onDragEnd(result) {
    if (result.reason === 'CANCEL') return "\n      Movement cancelled.\n      " + $83a769edb27eac89$var$returnedToStart(result.source) + "\n    ";
    var location = result.destination;
    var combine = result.combine;
    if (location) return "\n      You have dropped the item.\n      " + $83a769edb27eac89$var$withLocation(result.source, location) + "\n    ";
    if (combine) return "\n      You have dropped the item.\n      " + $83a769edb27eac89$var$withCombine(result.draggableId, result.source, combine) + "\n    ";
    return "\n    The item has been dropped while not over a drop area.\n    " + $83a769edb27eac89$var$returnedToStart(result.source) + "\n  ";
};
var $83a769edb27eac89$var$preset = {
    liftInstruction: $83a769edb27eac89$var$liftInstruction,
    onDragStart: $83a769edb27eac89$var$onDragStart,
    onDragUpdate: $83a769edb27eac89$var$onDragUpdate,
    onDragEnd: $83a769edb27eac89$var$onDragEnd
};
var $83a769edb27eac89$var$origin = {
    x: 0,
    y: 0
};
var $83a769edb27eac89$var$add = function add(point1, point2) {
    return {
        x: point1.x + point2.x,
        y: point1.y + point2.y
    };
};
var $83a769edb27eac89$var$subtract = function subtract(point1, point2) {
    return {
        x: point1.x - point2.x,
        y: point1.y - point2.y
    };
};
var $83a769edb27eac89$var$isEqual = function isEqual(point1, point2) {
    return point1.x === point2.x && point1.y === point2.y;
};
var $83a769edb27eac89$var$negate = function negate(point) {
    return {
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    };
};
var $83a769edb27eac89$var$patch = function patch(line, value, otherValue) {
    var _ref;
    if (otherValue === void 0) otherValue = 0;
    return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};
var $83a769edb27eac89$var$distance = function distance(point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var $83a769edb27eac89$var$closest = function closest(target, points) {
    return Math.min.apply(Math, points.map(function(point) {
        return $83a769edb27eac89$var$distance(target, point);
    }));
};
var $83a769edb27eac89$var$apply = function apply(fn) {
    return function(point) {
        return {
            x: fn(point.x),
            y: fn(point.y)
        };
    };
};
var $83a769edb27eac89$var$executeClip = function(frame, subject) {
    var result = (0, $b703e4029dc36ed5$export$4b834cebd9e5cebe)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
var $83a769edb27eac89$var$offsetByPosition = function offsetByPosition(spacing, point) {
    return {
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    };
};
var $83a769edb27eac89$var$getCorners = function getCorners(spacing) {
    return [
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
};
var $83a769edb27eac89$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $83a769edb27eac89$var$scroll = function scroll(target, frame) {
    if (!frame) return target;
    return $83a769edb27eac89$var$offsetByPosition(target, frame.scroll.diff.displacement);
};
var $83a769edb27eac89$var$increase = function increase(target, axis, withPlaceholder) {
    if (withPlaceholder && withPlaceholder.increasedBy) {
        var _extends2;
        return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
    }
    return target;
};
var $83a769edb27eac89$var$clip = function clip(target, frame) {
    if (frame && frame.shouldClipSubject) return $83a769edb27eac89$var$executeClip(frame.pageMarginBox, target);
    return (0, $b703e4029dc36ed5$export$4b834cebd9e5cebe)(target);
};
var $83a769edb27eac89$var$getSubject = function(_ref) {
    var page = _ref.page, withPlaceholder = _ref.withPlaceholder, axis = _ref.axis, frame = _ref.frame;
    var scrolled = $83a769edb27eac89$var$scroll(page.marginBox, frame);
    var increased = $83a769edb27eac89$var$increase(scrolled, axis, withPlaceholder);
    var clipped = $83a769edb27eac89$var$clip(increased, frame);
    return {
        page: page,
        withPlaceholder: withPlaceholder,
        active: clipped
    };
};
var $83a769edb27eac89$var$scrollDroppable = function(droppable, newScroll) {
    !droppable.frame && $83a769edb27eac89$var$invariant(false);
    var scrollable = droppable.frame;
    var scrollDiff = $83a769edb27eac89$var$subtract(newScroll, scrollable.scroll.initial);
    var scrollDisplacement = $83a769edb27eac89$var$negate(scrollDiff);
    var frame = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, scrollable, {
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    });
    var subject = $83a769edb27eac89$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame: frame
    });
    var result = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, droppable, {
        frame: frame,
        subject: subject
    });
    return result;
};
function $83a769edb27eac89$var$values(map) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9af2d53c4ea14e37$exports)))(map);
}
function $83a769edb27eac89$var$findIndex(list, predicate) {
    if (list.findIndex) return list.findIndex(predicate);
    for(var i = 0; i < list.length; i++){
        if (predicate(list[i])) return i;
    }
    return -1;
}
function $83a769edb27eac89$var$find(list, predicate) {
    if (list.find) return list.find(predicate);
    var index = $83a769edb27eac89$var$findIndex(list, predicate);
    if (index !== -1) return list[index];
    return undefined;
}
function $83a769edb27eac89$var$toArray(list) {
    return Array.prototype.slice.call(list);
}
var $83a769edb27eac89$var$toDroppableMap = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(droppables) {
    return droppables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $83a769edb27eac89$var$toDraggableMap = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(draggables) {
    return draggables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $83a769edb27eac89$var$toDroppableList = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(droppables) {
    return $83a769edb27eac89$var$values(droppables);
});
var $83a769edb27eac89$var$toDraggableList = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(draggables) {
    return $83a769edb27eac89$var$values(draggables);
});
var $83a769edb27eac89$var$getDraggablesInsideDroppable = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(droppableId, draggables) {
    var result = $83a769edb27eac89$var$toDraggableList(draggables).filter(function(draggable) {
        return droppableId === draggable.descriptor.droppableId;
    }).sort(function(a, b) {
        return a.descriptor.index - b.descriptor.index;
    });
    return result;
});
function $83a769edb27eac89$var$tryGetDestination(impact) {
    if (impact.at && impact.at.type === 'REORDER') return impact.at.destination;
    return null;
}
function $83a769edb27eac89$var$tryGetCombine(impact) {
    if (impact.at && impact.at.type === 'COMBINE') return impact.at.combine;
    return null;
}
var $83a769edb27eac89$var$removeDraggableFromList = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(remove, list) {
    return list.filter(function(item) {
        return item.descriptor.id !== remove.descriptor.id;
    });
});
var $83a769edb27eac89$var$moveToNextCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact;
    if (!destination.isCombineEnabled) return null;
    var location = $83a769edb27eac89$var$tryGetDestination(previousImpact);
    if (!location) return null;
    function getImpact(target) {
        var at = {
            type: 'COMBINE',
            combine: {
                draggableId: target,
                droppableId: destination.descriptor.id
            }
        };
        return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, previousImpact, {
            at: at
        });
    }
    var all = previousImpact.displaced.all;
    var closestId = all.length ? all[0] : null;
    if (isMovingForward) return closestId ? getImpact(closestId) : null;
    var withoutDraggable = $83a769edb27eac89$var$removeDraggableFromList(draggable, insideDestination);
    if (!closestId) {
        if (!withoutDraggable.length) return null;
        var last = withoutDraggable[withoutDraggable.length - 1];
        return getImpact(last.descriptor.id);
    }
    var indexOfClosest = $83a769edb27eac89$var$findIndex(withoutDraggable, function(d) {
        return d.descriptor.id === closestId;
    });
    !(indexOfClosest !== -1) && $83a769edb27eac89$var$invariant(false);
    var proposedIndex = indexOfClosest - 1;
    if (proposedIndex < 0) return null;
    var before = withoutDraggable[proposedIndex];
    return getImpact(before.descriptor.id);
};
var $83a769edb27eac89$var$isHomeOf = function(draggable, destination) {
    return draggable.descriptor.droppableId === destination.descriptor.id;
};
var $83a769edb27eac89$var$noDisplacedBy = {
    point: $83a769edb27eac89$var$origin,
    value: 0
};
var $83a769edb27eac89$var$emptyGroups = {
    invisible: {},
    visible: {},
    all: []
};
var $83a769edb27eac89$var$noImpact = {
    displaced: $83a769edb27eac89$var$emptyGroups,
    displacedBy: $83a769edb27eac89$var$noDisplacedBy,
    at: null
};
var $83a769edb27eac89$var$isWithin = function(lowerBound, upperBound) {
    return function(value) {
        return lowerBound <= value && value <= upperBound;
    };
};
var $83a769edb27eac89$var$isPartiallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $83a769edb27eac89$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $83a769edb27eac89$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var $83a769edb27eac89$var$isTotallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $83a769edb27eac89$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $83a769edb27eac89$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
var $83a769edb27eac89$var$vertical = {
    direction: 'vertical',
    line: 'y',
    crossAxisLine: 'x',
    start: 'top',
    end: 'bottom',
    size: 'height',
    crossAxisStart: 'left',
    crossAxisEnd: 'right',
    crossAxisSize: 'width'
};
var $83a769edb27eac89$var$horizontal = {
    direction: 'horizontal',
    line: 'x',
    crossAxisLine: 'y',
    start: 'left',
    end: 'right',
    size: 'width',
    crossAxisStart: 'top',
    crossAxisEnd: 'bottom',
    crossAxisSize: 'height'
};
var $83a769edb27eac89$var$isTotallyVisibleThroughFrameOnAxis = function(axis) {
    return function(frame) {
        var isWithinVertical = $83a769edb27eac89$var$isWithin(frame.top, frame.bottom);
        var isWithinHorizontal = $83a769edb27eac89$var$isWithin(frame.left, frame.right);
        return function(subject) {
            if (axis === $83a769edb27eac89$var$vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
};
var $83a769edb27eac89$var$getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
    var displacement = destination.frame ? destination.frame.scroll.diff.displacement : $83a769edb27eac89$var$origin;
    return $83a769edb27eac89$var$offsetByPosition(target, displacement);
};
var $83a769edb27eac89$var$isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
var $83a769edb27eac89$var$isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
    return isVisibleThroughFrameFn(viewport)(target);
};
var $83a769edb27eac89$var$isVisible = function isVisible(_ref) {
    var toBeDisplaced = _ref.target, destination = _ref.destination, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
    var displacedTarget = withDroppableDisplacement ? $83a769edb27eac89$var$getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return $83a769edb27eac89$var$isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && $83a769edb27eac89$var$isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
var $83a769edb27eac89$var$isPartiallyVisible = function isPartiallyVisible(args) {
    return $83a769edb27eac89$var$isVisible((0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, args, {
        isVisibleThroughFrameFn: $83a769edb27eac89$var$isPartiallyVisibleThroughFrame
    }));
};
var $83a769edb27eac89$var$isTotallyVisible = function isTotallyVisible(args) {
    return $83a769edb27eac89$var$isVisible((0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, args, {
        isVisibleThroughFrameFn: $83a769edb27eac89$var$isTotallyVisibleThroughFrame
    }));
};
var $83a769edb27eac89$var$isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
    return $83a769edb27eac89$var$isVisible((0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, args, {
        isVisibleThroughFrameFn: $83a769edb27eac89$var$isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    }));
};
var $83a769edb27eac89$var$getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
    if (typeof forceShouldAnimate === 'boolean') return forceShouldAnimate;
    if (!last) return true;
    var invisible = last.invisible, visible = last.visible;
    if (invisible[id]) return false;
    var previous = visible[id];
    return previous ? previous.shouldAnimate : true;
};
function $83a769edb27eac89$var$getTarget(draggable, displacedBy) {
    var marginBox = draggable.page.marginBox;
    var expandBy = {
        top: displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: displacedBy.point.x
    };
    return (0, $b703e4029dc36ed5$export$4b834cebd9e5cebe)((0, $b703e4029dc36ed5$export$9f77e0932fb78f72)(marginBox, expandBy));
}
function $83a769edb27eac89$var$getDisplacementGroups(_ref) {
    var afterDragging = _ref.afterDragging, destination = _ref.destination, displacedBy = _ref.displacedBy, viewport = _ref.viewport, forceShouldAnimate = _ref.forceShouldAnimate, last = _ref.last;
    return afterDragging.reduce(function process(groups, draggable) {
        var target = $83a769edb27eac89$var$getTarget(draggable, displacedBy);
        var id = draggable.descriptor.id;
        groups.all.push(id);
        var isVisible = $83a769edb27eac89$var$isPartiallyVisible({
            target: target,
            destination: destination,
            viewport: viewport,
            withDroppableDisplacement: true
        });
        if (!isVisible) {
            groups.invisible[draggable.descriptor.id] = true;
            return groups;
        }
        var shouldAnimate = $83a769edb27eac89$var$getShouldAnimate(id, last, forceShouldAnimate);
        var displacement = {
            draggableId: id,
            shouldAnimate: shouldAnimate
        };
        groups.visible[id] = displacement;
        return groups;
    }, {
        all: [],
        visible: {},
        invisible: {}
    });
}
function $83a769edb27eac89$var$getIndexOfLastItem(draggables, options) {
    if (!draggables.length) return 0;
    var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
    return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function $83a769edb27eac89$var$goAtEnd(_ref) {
    var insideDestination = _ref.insideDestination, inHomeList = _ref.inHomeList, displacedBy = _ref.displacedBy, destination = _ref.destination;
    var newIndex = $83a769edb27eac89$var$getIndexOfLastItem(insideDestination, {
        inHomeList: inHomeList
    });
    return {
        displaced: $83a769edb27eac89$var$emptyGroups,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: newIndex
            }
        }
    };
}
function $83a769edb27eac89$var$calculateReorderImpact(_ref2) {
    var draggable = _ref2.draggable, insideDestination = _ref2.insideDestination, destination = _ref2.destination, viewport = _ref2.viewport, displacedBy = _ref2.displacedBy, last = _ref2.last, index = _ref2.index, forceShouldAnimate = _ref2.forceShouldAnimate;
    var inHomeList = $83a769edb27eac89$var$isHomeOf(draggable, destination);
    if (index == null) return $83a769edb27eac89$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var match = $83a769edb27eac89$var$find(insideDestination, function(item) {
        return item.descriptor.index === index;
    });
    if (!match) return $83a769edb27eac89$var$goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var withoutDragging = $83a769edb27eac89$var$removeDraggableFromList(draggable, insideDestination);
    var sliceFrom = insideDestination.indexOf(match);
    var impacted = withoutDragging.slice(sliceFrom);
    var displaced = $83a769edb27eac89$var$getDisplacementGroups({
        afterDragging: impacted,
        destination: destination,
        displacedBy: displacedBy,
        last: last,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate
    });
    return {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: index
            }
        }
    };
}
function $83a769edb27eac89$var$didStartAfterCritical(draggableId, afterCritical) {
    return Boolean(afterCritical.effected[draggableId]);
}
var $83a769edb27eac89$var$fromCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, destination = _ref.destination, draggables = _ref.draggables, combine = _ref.combine, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var combineId = combine.draggableId;
    var combineWith = draggables[combineId];
    var combineWithIndex = combineWith.descriptor.index;
    var didCombineWithStartAfterCritical = $83a769edb27eac89$var$didStartAfterCritical(combineId, afterCritical);
    if (didCombineWithStartAfterCritical) {
        if (isMovingForward) return combineWithIndex;
        return combineWithIndex - 1;
    }
    if (isMovingForward) return combineWithIndex + 1;
    return combineWithIndex;
};
var $83a769edb27eac89$var$fromReorder = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, insideDestination = _ref.insideDestination, location = _ref.location;
    if (!insideDestination.length) return null;
    var currentIndex = location.index;
    var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    var firstIndex = insideDestination[0].descriptor.index;
    var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
    var upperBound = isInHomeList ? lastIndex : lastIndex + 1;
    if (proposedIndex < firstIndex) return null;
    if (proposedIndex > upperBound) return null;
    return proposedIndex;
};
var $83a769edb27eac89$var$moveToNextIndex = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var wasAt = previousImpact.at;
    !wasAt && $83a769edb27eac89$var$invariant(false);
    if (wasAt.type === 'REORDER') {
        var _newIndex = $83a769edb27eac89$var$fromReorder({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            location: wasAt.destination,
            insideDestination: insideDestination
        });
        if (_newIndex == null) return null;
        return $83a769edb27eac89$var$calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: _newIndex
        });
    }
    var newIndex = $83a769edb27eac89$var$fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        displaced: previousImpact.displaced,
        draggables: draggables,
        combine: wasAt.combine,
        afterCritical: afterCritical
    });
    if (newIndex == null) return null;
    return $83a769edb27eac89$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: previousImpact.displaced,
        displacedBy: previousImpact.displacedBy,
        index: newIndex
    });
};
var $83a769edb27eac89$var$getCombinedItemDisplacement = function(_ref) {
    var displaced = _ref.displaced, afterCritical = _ref.afterCritical, combineWith = _ref.combineWith, displacedBy = _ref.displacedBy;
    var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
    if ($83a769edb27eac89$var$didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? $83a769edb27eac89$var$origin : $83a769edb27eac89$var$negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : $83a769edb27eac89$var$origin;
};
var $83a769edb27eac89$var$whenCombining = function(_ref) {
    var afterCritical = _ref.afterCritical, impact = _ref.impact, draggables = _ref.draggables;
    var combine = $83a769edb27eac89$var$tryGetCombine(impact);
    !combine && $83a769edb27eac89$var$invariant(false);
    var combineWith = combine.draggableId;
    var center = draggables[combineWith].page.borderBox.center;
    var displaceBy = $83a769edb27eac89$var$getCombinedItemDisplacement({
        displaced: impact.displaced,
        afterCritical: afterCritical,
        combineWith: combineWith,
        displacedBy: impact.displacedBy
    });
    return $83a769edb27eac89$var$add(center, displaceBy);
};
var $83a769edb27eac89$var$distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
    return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};
var $83a769edb27eac89$var$distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
    return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};
var $83a769edb27eac89$var$getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
    return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};
var $83a769edb27eac89$var$goAfter = function goAfter(_ref) {
    var axis = _ref.axis, moveRelativeTo = _ref.moveRelativeTo, isMoving = _ref.isMoving;
    return $83a769edb27eac89$var$patch(axis.line, moveRelativeTo.marginBox[axis.end] + $83a769edb27eac89$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $83a769edb27eac89$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $83a769edb27eac89$var$goBefore = function goBefore(_ref2) {
    var axis = _ref2.axis, moveRelativeTo = _ref2.moveRelativeTo, isMoving = _ref2.isMoving;
    return $83a769edb27eac89$var$patch(axis.line, moveRelativeTo.marginBox[axis.start] - $83a769edb27eac89$var$distanceFromEndToBorderBoxCenter(axis, isMoving), $83a769edb27eac89$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $83a769edb27eac89$var$goIntoStart = function goIntoStart(_ref3) {
    var axis = _ref3.axis, moveInto = _ref3.moveInto, isMoving = _ref3.isMoving;
    return $83a769edb27eac89$var$patch(axis.line, moveInto.contentBox[axis.start] + $83a769edb27eac89$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $83a769edb27eac89$var$getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};
var $83a769edb27eac89$var$whenReordering = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, draggables = _ref.draggables, droppable = _ref.droppable, afterCritical = _ref.afterCritical;
    var insideDestination = $83a769edb27eac89$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var draggablePage = draggable.page;
    var axis = droppable.axis;
    if (!insideDestination.length) return $83a769edb27eac89$var$goIntoStart({
        axis: axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    var displaced = impact.displaced, displacedBy = impact.displacedBy;
    var closestAfter = displaced.all[0];
    if (closestAfter) {
        var closest = draggables[closestAfter];
        if ($83a769edb27eac89$var$didStartAfterCritical(closestAfter, afterCritical)) return $83a769edb27eac89$var$goBefore({
            axis: axis,
            moveRelativeTo: closest.page,
            isMoving: draggablePage
        });
        var withDisplacement = (0, $b703e4029dc36ed5$export$cc800923e997bb8)(closest.page, displacedBy.point);
        return $83a769edb27eac89$var$goBefore({
            axis: axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    var last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if ($83a769edb27eac89$var$didStartAfterCritical(last.descriptor.id, afterCritical)) {
        var page = (0, $b703e4029dc36ed5$export$cc800923e997bb8)(last.page, $83a769edb27eac89$var$negate(afterCritical.displacedBy.point));
        return $83a769edb27eac89$var$goAfter({
            axis: axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return $83a769edb27eac89$var$goAfter({
        axis: axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var $83a769edb27eac89$var$withDroppableDisplacement = function(droppable, point) {
    var frame = droppable.frame;
    if (!frame) return point;
    return $83a769edb27eac89$var$add(point, frame.scroll.diff.displacement);
};
var $83a769edb27eac89$var$getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, afterCritical = _ref.afterCritical;
    var original = draggable.page.borderBox.center;
    var at = impact.at;
    if (!droppable) return original;
    if (!at) return original;
    if (at.type === 'REORDER') return $83a769edb27eac89$var$whenReordering({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $83a769edb27eac89$var$whenCombining({
        impact: impact,
        draggables: draggables,
        afterCritical: afterCritical
    });
};
var $83a769edb27eac89$var$getPageBorderBoxCenterFromImpact = function(args) {
    var withoutDisplacement = $83a769edb27eac89$var$getResultWithoutDroppableDisplacement(args);
    var droppable = args.droppable;
    var withDisplacement = droppable ? $83a769edb27eac89$var$withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var $83a769edb27eac89$var$scrollViewport = function(viewport, newScroll) {
    var diff = $83a769edb27eac89$var$subtract(newScroll, viewport.scroll.initial);
    var displacement = $83a769edb27eac89$var$negate(diff);
    var frame = (0, $b703e4029dc36ed5$export$4b834cebd9e5cebe)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    var updated = {
        frame: frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement: displacement
            }
        }
    };
    return updated;
};
function $83a769edb27eac89$var$getDraggables(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
function $83a769edb27eac89$var$tryGetVisible(id, groups) {
    for(var i = 0; i < groups.length; i++){
        var displacement = groups[i].visible[id];
        if (displacement) return displacement;
    }
    return null;
}
var $83a769edb27eac89$var$speculativelyIncrease = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, destination = _ref.destination, draggables = _ref.draggables, maxScrollChange = _ref.maxScrollChange;
    var scrolledViewport = $83a769edb27eac89$var$scrollViewport(viewport, $83a769edb27eac89$var$add(viewport.scroll.current, maxScrollChange));
    var scrolledDroppable = destination.frame ? $83a769edb27eac89$var$scrollDroppable(destination, $83a769edb27eac89$var$add(destination.frame.scroll.current, maxScrollChange)) : destination;
    var last = impact.displaced;
    var withViewportScroll = $83a769edb27eac89$var$getDisplacementGroups({
        afterDragging: $83a769edb27eac89$var$getDraggables(last.all, draggables),
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: scrolledViewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var withDroppableScroll = $83a769edb27eac89$var$getDisplacementGroups({
        afterDragging: $83a769edb27eac89$var$getDraggables(last.all, draggables),
        destination: scrolledDroppable,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var invisible = {};
    var visible = {};
    var groups = [
        last,
        withViewportScroll,
        withDroppableScroll
    ];
    last.all.forEach(function(id) {
        var displacement = $83a769edb27eac89$var$tryGetVisible(id, groups);
        if (displacement) {
            visible[id] = displacement;
            return;
        }
        invisible[id] = true;
    });
    var newImpact = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, impact, {
        displaced: {
            all: last.all,
            invisible: invisible,
            visible: visible
        }
    });
    return newImpact;
};
var $83a769edb27eac89$var$withViewportDisplacement = function(viewport, point) {
    return $83a769edb27eac89$var$add(viewport.scroll.diff.displacement, point);
};
var $83a769edb27eac89$var$getClientFromPageBorderBoxCenter = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, draggable = _ref.draggable, viewport = _ref.viewport;
    var withoutPageScrollChange = $83a769edb27eac89$var$withViewportDisplacement(viewport, pageBorderBoxCenter);
    var offset = $83a769edb27eac89$var$subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return $83a769edb27eac89$var$add(draggable.client.borderBox.center, offset);
};
var $83a769edb27eac89$var$isTotallyVisibleInNewLocation = function(_ref) {
    var draggable = _ref.draggable, destination = _ref.destination, newPageBorderBoxCenter = _ref.newPageBorderBoxCenter, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, _ref$onlyOnMainAxis = _ref.onlyOnMainAxis, onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
    var changeNeeded = $83a769edb27eac89$var$subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    var shifted = $83a769edb27eac89$var$offsetByPosition(draggable.page.borderBox, changeNeeded);
    var args = {
        target: shifted,
        destination: destination,
        withDroppableDisplacement: withDroppableDisplacement,
        viewport: viewport
    };
    return onlyOnMainAxis ? $83a769edb27eac89$var$isTotallyVisibleOnAxis(args) : $83a769edb27eac89$var$isTotallyVisible(args);
};
var $83a769edb27eac89$var$moveToNextPlace = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, draggables = _ref.draggables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, previousClientSelection = _ref.previousClientSelection, afterCritical = _ref.afterCritical;
    if (!destination.isEnabled) return null;
    var insideDestination = $83a769edb27eac89$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var isInHomeList = $83a769edb27eac89$var$isHomeOf(draggable, destination);
    var impact = $83a769edb27eac89$var$moveToNextCombine({
        isMovingForward: isMovingForward,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact
    }) || $83a769edb27eac89$var$moveToNextIndex({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        draggables: draggables,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $83a769edb27eac89$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var isVisibleInNewLocation = $83a769edb27eac89$var$isTotallyVisibleInNewLocation({
        draggable: draggable,
        destination: destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        var clientSelection = $83a769edb27eac89$var$getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    }
    var distance = $83a769edb27eac89$var$subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    var cautious = $83a769edb27eac89$var$speculativelyIncrease({
        impact: impact,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        maxScrollChange: distance
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
var $83a769edb27eac89$var$getKnownActive = function getKnownActive(droppable) {
    var rect = droppable.subject.active;
    !rect && $83a769edb27eac89$var$invariant(false);
    return rect;
};
var $83a769edb27eac89$var$getBestCrossAxisDroppable = function(_ref) {
    var isMovingForward = _ref.isMovingForward, pageBorderBoxCenter = _ref.pageBorderBoxCenter, source = _ref.source, droppables = _ref.droppables, viewport = _ref.viewport;
    var active = source.subject.active;
    if (!active) return null;
    var axis = source.axis;
    var isBetweenSourceClipped = $83a769edb27eac89$var$isWithin(active[axis.start], active[axis.end]);
    var candidates = $83a769edb27eac89$var$toDroppableList(droppables).filter(function(droppable) {
        return droppable !== source;
    }).filter(function(droppable) {
        return droppable.isEnabled;
    }).filter(function(droppable) {
        return Boolean(droppable.subject.active);
    }).filter(function(droppable) {
        return $83a769edb27eac89$var$isPartiallyVisibleThroughFrame(viewport.frame)($83a769edb27eac89$var$getKnownActive(droppable));
    }).filter(function(droppable) {
        var activeOfTarget = $83a769edb27eac89$var$getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter(function(droppable) {
        var activeOfTarget = $83a769edb27eac89$var$getKnownActive(droppable);
        var isBetweenDestinationClipped = $83a769edb27eac89$var$isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort(function(a, b) {
        var first = $83a769edb27eac89$var$getKnownActive(a)[axis.crossAxisStart];
        var second = $83a769edb27eac89$var$getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter(function(droppable, index, array) {
        return $83a769edb27eac89$var$getKnownActive(droppable)[axis.crossAxisStart] === $83a769edb27eac89$var$getKnownActive(array[0])[axis.crossAxisStart];
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    var contains = candidates.filter(function(droppable) {
        var isWithinDroppable = $83a769edb27eac89$var$isWithin($83a769edb27eac89$var$getKnownActive(droppable)[axis.start], $83a769edb27eac89$var$getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort(function(a, b) {
        return $83a769edb27eac89$var$getKnownActive(a)[axis.start] - $83a769edb27eac89$var$getKnownActive(b)[axis.start];
    })[0];
    return candidates.sort(function(a, b) {
        var first = $83a769edb27eac89$var$closest(pageBorderBoxCenter, $83a769edb27eac89$var$getCorners($83a769edb27eac89$var$getKnownActive(a)));
        var second = $83a769edb27eac89$var$closest(pageBorderBoxCenter, $83a769edb27eac89$var$getCorners($83a769edb27eac89$var$getKnownActive(b)));
        if (first !== second) return first - second;
        return $83a769edb27eac89$var$getKnownActive(a)[axis.start] - $83a769edb27eac89$var$getKnownActive(b)[axis.start];
    })[0];
};
var $83a769edb27eac89$var$getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
    var original = draggable.page.borderBox.center;
    return $83a769edb27eac89$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $83a769edb27eac89$var$subtract(original, afterCritical.displacedBy.point) : original;
};
var $83a769edb27eac89$var$getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
    var original = draggable.page.borderBox;
    return $83a769edb27eac89$var$didStartAfterCritical(draggable.descriptor.id, afterCritical) ? $83a769edb27eac89$var$offsetByPosition(original, $83a769edb27eac89$var$negate(afterCritical.displacedBy.point)) : original;
};
var $83a769edb27eac89$var$getClosestDraggable = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, viewport = _ref.viewport, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    var sorted = insideDestination.filter(function(draggable) {
        return $83a769edb27eac89$var$isTotallyVisible({
            target: $83a769edb27eac89$var$getCurrentPageBorderBox(draggable, afterCritical),
            destination: destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        });
    }).sort(function(a, b) {
        var distanceToA = $83a769edb27eac89$var$distance(pageBorderBoxCenter, $83a769edb27eac89$var$withDroppableDisplacement(destination, $83a769edb27eac89$var$getCurrentPageBorderBoxCenter(a, afterCritical)));
        var distanceToB = $83a769edb27eac89$var$distance(pageBorderBoxCenter, $83a769edb27eac89$var$withDroppableDisplacement(destination, $83a769edb27eac89$var$getCurrentPageBorderBoxCenter(b, afterCritical)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var $83a769edb27eac89$var$getDisplacedBy = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function getDisplacedBy(axis, displaceBy) {
    var displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: $83a769edb27eac89$var$patch(axis.line, displacement)
    };
});
var $83a769edb27eac89$var$getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
    var axis = droppable.axis;
    if (droppable.descriptor.mode === 'virtual') return $83a769edb27eac89$var$patch(axis.line, placeholderSize[axis.line]);
    var availableSpace = droppable.subject.page.contentBox[axis.size];
    var insideDroppable = $83a769edb27eac89$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var spaceUsed = insideDroppable.reduce(function(sum, dimension) {
        return sum + dimension.client.marginBox[axis.size];
    }, 0);
    var requiredSpace = spaceUsed + placeholderSize[axis.line];
    var needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return $83a769edb27eac89$var$patch(axis.line, needsToGrowBy);
};
var $83a769edb27eac89$var$withMaxScroll = function withMaxScroll(frame, max) {
    return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, frame, {
        scroll: (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, frame.scroll, {
            max: max
        })
    });
};
var $83a769edb27eac89$var$addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
    var frame = droppable.frame;
    !!$83a769edb27eac89$var$isHomeOf(draggable, droppable) && $83a769edb27eac89$var$invariant(false);
    !!droppable.subject.withPlaceholder && $83a769edb27eac89$var$invariant(false);
    var placeholderSize = $83a769edb27eac89$var$getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    var requiredGrowth = $83a769edb27eac89$var$getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    var added = {
        placeholderSize: placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        var _subject = $83a769edb27eac89$var$getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, droppable, {
            subject: _subject
        });
    }
    var maxScroll = requiredGrowth ? $83a769edb27eac89$var$add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    var newFrame = $83a769edb27eac89$var$withMaxScroll(frame, maxScroll);
    var subject = $83a769edb27eac89$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $83a769edb27eac89$var$removePlaceholder = function removePlaceholder(droppable) {
    var added = droppable.subject.withPlaceholder;
    !added && $83a769edb27eac89$var$invariant(false);
    var frame = droppable.frame;
    if (!frame) {
        var _subject2 = $83a769edb27eac89$var$getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, droppable, {
            subject: _subject2
        });
    }
    var oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && $83a769edb27eac89$var$invariant(false);
    var newFrame = $83a769edb27eac89$var$withMaxScroll(frame, oldMaxScroll);
    var subject = $83a769edb27eac89$var$getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $83a769edb27eac89$var$moveToNewDroppable = function(_ref) {
    var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, moveRelativeTo = _ref.moveRelativeTo, insideDestination = _ref.insideDestination, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        var proposed = {
            displaced: $83a769edb27eac89$var$emptyGroups,
            displacedBy: $83a769edb27eac89$var$noDisplacedBy,
            at: {
                type: 'REORDER',
                destination: {
                    droppableId: destination.descriptor.id,
                    index: 0
                }
            }
        };
        var proposedPageBorderBoxCenter = $83a769edb27eac89$var$getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        var withPlaceholder = $83a769edb27eac89$var$isHomeOf(draggable, destination) ? destination : $83a769edb27eac89$var$addPlaceholder(destination, draggable, draggables);
        var isVisibleInNewLocation = $83a769edb27eac89$var$isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
    var proposedIndex = function() {
        var relativeTo = moveRelativeTo.descriptor.index;
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
        if (isGoingBeforeTarget) return relativeTo;
        return relativeTo + 1;
    }();
    var displacedBy = $83a769edb27eac89$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    return $83a769edb27eac89$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        displacedBy: displacedBy,
        last: $83a769edb27eac89$var$emptyGroups,
        index: proposedIndex
    });
};
var $83a769edb27eac89$var$moveCrossAxis = function(_ref) {
    var isMovingForward = _ref.isMovingForward, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, draggable = _ref.draggable, isOver = _ref.isOver, draggables = _ref.draggables, droppables = _ref.droppables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var destination = $83a769edb27eac89$var$getBestCrossAxisDroppable({
        isMovingForward: isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables: droppables,
        viewport: viewport
    });
    if (!destination) return null;
    var insideDestination = $83a769edb27eac89$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var moveRelativeTo = $83a769edb27eac89$var$getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport: viewport,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    });
    var impact = $83a769edb27eac89$var$moveToNewDroppable({
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        destination: destination,
        draggable: draggable,
        draggables: draggables,
        moveRelativeTo: moveRelativeTo,
        insideDestination: insideDestination,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $83a769edb27eac89$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var clientSelection = $83a769edb27eac89$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
    return {
        clientSelection: clientSelection,
        impact: impact,
        scrollJumpRequest: null
    };
};
var $83a769edb27eac89$var$whatIsDraggedOver = function(impact) {
    var at = impact.at;
    if (!at) return null;
    if (at.type === 'REORDER') return at.destination.droppableId;
    return at.combine.droppableId;
};
var $83a769edb27eac89$var$getDroppableOver = function getDroppableOver(impact, droppables) {
    var id = $83a769edb27eac89$var$whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var $83a769edb27eac89$var$moveInDirection = function(_ref) {
    var state = _ref.state, type = _ref.type;
    var isActuallyOver = $83a769edb27eac89$var$getDroppableOver(state.impact, state.dimensions.droppables);
    var isMainAxisMovementAllowed = Boolean(isActuallyOver);
    var home = state.dimensions.droppables[state.critical.droppable.id];
    var isOver = isActuallyOver || home;
    var direction = isOver.axis.direction;
    var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    var _state$dimensions = state.dimensions, draggables = _state$dimensions.draggables, droppables = _state$dimensions.droppables;
    return isMovingOnMainAxis ? $83a769edb27eac89$var$moveToNextPlace({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        destination: isOver,
        draggables: draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        afterCritical: state.afterCritical
    }) : $83a769edb27eac89$var$moveCrossAxis({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        isOver: isOver,
        draggables: draggables,
        droppables: droppables,
        viewport: state.viewport,
        afterCritical: state.afterCritical
    });
};
function $83a769edb27eac89$var$isMovementAllowed(state) {
    return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}
function $83a769edb27eac89$var$isPositionInFrame(frame) {
    var isWithinVertical = $83a769edb27eac89$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $83a769edb27eac89$var$isWithin(frame.left, frame.right);
    return function run(point) {
        return isWithinVertical(point.y) && isWithinHorizontal(point.x);
    };
}
function $83a769edb27eac89$var$getHasOverlap(first, second) {
    return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}
function $83a769edb27eac89$var$getFurthestAway(_ref) {
    var pageBorderBox = _ref.pageBorderBox, draggable = _ref.draggable, candidates = _ref.candidates;
    var startCenter = draggable.page.borderBox.center;
    var sorted = candidates.map(function(candidate) {
        var axis = candidate.axis;
        var target = $83a769edb27eac89$var$patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
        return {
            id: candidate.descriptor.id,
            distance: $83a769edb27eac89$var$distance(startCenter, target)
        };
    }).sort(function(a, b) {
        return b.distance - a.distance;
    });
    return sorted[0] ? sorted[0].id : null;
}
function $83a769edb27eac89$var$getDroppableOver$1(_ref2) {
    var pageBorderBox = _ref2.pageBorderBox, draggable = _ref2.draggable, droppables = _ref2.droppables;
    var candidates = $83a769edb27eac89$var$toDroppableList(droppables).filter(function(item) {
        if (!item.isEnabled) return false;
        var active = item.subject.active;
        if (!active) return false;
        if (!$83a769edb27eac89$var$getHasOverlap(pageBorderBox, active)) return false;
        if ($83a769edb27eac89$var$isPositionInFrame(active)(pageBorderBox.center)) return true;
        var axis = item.axis;
        var childCenter = active.center[axis.crossAxisLine];
        var crossAxisStart = pageBorderBox[axis.crossAxisStart];
        var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
        var isContained = $83a769edb27eac89$var$isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
        var isStartContained = isContained(crossAxisStart);
        var isEndContained = isContained(crossAxisEnd);
        if (!isStartContained && !isEndContained) return true;
        if (isStartContained) return crossAxisStart < childCenter;
        return crossAxisEnd > childCenter;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].descriptor.id;
    return $83a769edb27eac89$var$getFurthestAway({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        candidates: candidates
    });
}
var $83a769edb27eac89$var$offsetRectByPosition = function offsetRectByPosition(rect, point) {
    return (0, $b703e4029dc36ed5$export$4b834cebd9e5cebe)($83a769edb27eac89$var$offsetByPosition(rect, point));
};
var $83a769edb27eac89$var$withDroppableScroll = function(droppable, area) {
    var frame = droppable.frame;
    if (!frame) return area;
    return $83a769edb27eac89$var$offsetRectByPosition(area, frame.scroll.diff.value);
};
function $83a769edb27eac89$var$getIsDisplaced(_ref) {
    var displaced = _ref.displaced, id = _ref.id;
    return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function $83a769edb27eac89$var$atIndex(_ref) {
    var draggable = _ref.draggable, closest = _ref.closest, inHomeList = _ref.inHomeList;
    if (!closest) return null;
    if (!inHomeList) return closest.descriptor.index;
    if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
    return closest.descriptor.index;
}
var $83a769edb27eac89$var$getReorderImpact = function(_ref2) {
    var targetRect = _ref2.pageBorderBoxWithDroppableScroll, draggable = _ref2.draggable, destination = _ref2.destination, insideDestination = _ref2.insideDestination, last = _ref2.last, viewport = _ref2.viewport, afterCritical = _ref2.afterCritical;
    var axis = destination.axis;
    var displacedBy = $83a769edb27eac89$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $83a769edb27eac89$var$removeDraggableFromList(draggable, insideDestination);
    var closest = $83a769edb27eac89$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childCenter = child.page.borderBox.center[axis.line];
        var didStartAfterCritical$1 = $83a769edb27eac89$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $83a769edb27eac89$var$getIsDisplaced({
            displaced: last,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd <= childCenter;
            return targetStart < childCenter - displacement;
        }
        if (isDisplaced) return targetEnd <= childCenter + displacement;
        return targetStart < childCenter;
    });
    var newIndex = $83a769edb27eac89$var$atIndex({
        draggable: draggable,
        closest: closest,
        inHomeList: $83a769edb27eac89$var$isHomeOf(draggable, destination)
    });
    return $83a769edb27eac89$var$calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: last,
        displacedBy: displacedBy,
        index: newIndex
    });
};
var $83a769edb27eac89$var$combineThresholdDivisor = 4;
var $83a769edb27eac89$var$getCombineImpact = function(_ref) {
    var draggable = _ref.draggable, targetRect = _ref.pageBorderBoxWithDroppableScroll, previousImpact = _ref.previousImpact, destination = _ref.destination, insideDestination = _ref.insideDestination, afterCritical = _ref.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var axis = destination.axis;
    var displacedBy = $83a769edb27eac89$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = $83a769edb27eac89$var$removeDraggableFromList(draggable, insideDestination);
    var combineWith = $83a769edb27eac89$var$find(withoutDragging, function(child) {
        var id = child.descriptor.id;
        var childRect = child.page.borderBox;
        var childSize = childRect[axis.size];
        var threshold = childSize / $83a769edb27eac89$var$combineThresholdDivisor;
        var didStartAfterCritical$1 = $83a769edb27eac89$var$didStartAfterCritical(id, afterCritical);
        var isDisplaced = $83a769edb27eac89$var$getIsDisplaced({
            displaced: previousImpact.displaced,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
            return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
        }
        if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
        return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
    });
    if (!combineWith) return null;
    var impact = {
        displacedBy: displacedBy,
        displaced: previousImpact.displaced,
        at: {
            type: 'COMBINE',
            combine: {
                draggableId: combineWith.descriptor.id,
                droppableId: destination.descriptor.id
            }
        }
    };
    return impact;
};
var $83a769edb27eac89$var$getDragImpact = function(_ref) {
    var pageOffset = _ref.pageOffset, draggable = _ref.draggable, draggables = _ref.draggables, droppables = _ref.droppables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBox = $83a769edb27eac89$var$offsetRectByPosition(draggable.page.borderBox, pageOffset);
    var destinationId = $83a769edb27eac89$var$getDroppableOver$1({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        droppables: droppables
    });
    if (!destinationId) return $83a769edb27eac89$var$noImpact;
    var destination = droppables[destinationId];
    var insideDestination = $83a769edb27eac89$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var pageBorderBoxWithDroppableScroll = $83a769edb27eac89$var$withDroppableScroll(destination, pageBorderBox);
    return $83a769edb27eac89$var$getCombineImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        previousImpact: previousImpact,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    }) || $83a769edb27eac89$var$getReorderImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        last: previousImpact.displaced,
        viewport: viewport,
        afterCritical: afterCritical
    });
};
var $83a769edb27eac89$var$patchDroppableMap = function(droppables, updated) {
    var _extends2;
    return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
};
var $83a769edb27eac89$var$clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
    var previousImpact = _ref.previousImpact, impact = _ref.impact, droppables = _ref.droppables;
    var last = $83a769edb27eac89$var$whatIsDraggedOver(previousImpact);
    var now = $83a769edb27eac89$var$whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    var lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    var updated = $83a769edb27eac89$var$removePlaceholder(lastDroppable);
    return $83a769edb27eac89$var$patchDroppableMap(droppables, updated);
};
var $83a769edb27eac89$var$recomputePlaceholders = function(_ref2) {
    var draggable = _ref2.draggable, draggables = _ref2.draggables, droppables = _ref2.droppables, previousImpact = _ref2.previousImpact, impact = _ref2.impact;
    var cleaned = $83a769edb27eac89$var$clearUnusedPlaceholder({
        previousImpact: previousImpact,
        impact: impact,
        droppables: droppables
    });
    var isOver = $83a769edb27eac89$var$whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    var droppable = droppables[isOver];
    if ($83a769edb27eac89$var$isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    var patched = $83a769edb27eac89$var$addPlaceholder(droppable, draggable, draggables);
    return $83a769edb27eac89$var$patchDroppableMap(cleaned, patched);
};
var $83a769edb27eac89$var$update = function(_ref) {
    var state = _ref.state, forcedClientSelection = _ref.clientSelection, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport, forcedImpact = _ref.impact, scrollJumpRequest = _ref.scrollJumpRequest;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var clientSelection = forcedClientSelection || state.current.client.selection;
    var offset = $83a769edb27eac89$var$subtract(clientSelection, state.initial.client.selection);
    var client = {
        offset: offset,
        selection: clientSelection,
        borderBoxCenter: $83a769edb27eac89$var$add(state.initial.client.borderBoxCenter, offset)
    };
    var page = {
        selection: $83a769edb27eac89$var$add(client.selection, viewport.scroll.current),
        borderBoxCenter: $83a769edb27eac89$var$add(client.borderBoxCenter, viewport.scroll.current),
        offset: $83a769edb27eac89$var$add(client.offset, viewport.scroll.diff.value)
    };
    var current = {
        client: client,
        page: page
    };
    if (state.phase === 'COLLECTING') return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({
        phase: 'COLLECTING'
    }, state, {
        dimensions: dimensions,
        viewport: viewport,
        current: current
    });
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var newImpact = forcedImpact || $83a769edb27eac89$var$getDragImpact({
        pageOffset: page.offset,
        draggable: draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    var withUpdatedPlaceholders = $83a769edb27eac89$var$recomputePlaceholders({
        draggable: draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    var result = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, state, {
        current: current,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport: viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    });
    return result;
};
function $83a769edb27eac89$var$getDraggables$1(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
var $83a769edb27eac89$var$recompute = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, draggables = _ref.draggables, destination = _ref.destination, forceShouldAnimate = _ref.forceShouldAnimate;
    var last = impact.displaced;
    var afterDragging = $83a769edb27eac89$var$getDraggables$1(last.all, draggables);
    var displaced = $83a769edb27eac89$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate,
        last: last
    });
    return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, impact, {
        displaced: displaced
    });
};
var $83a769edb27eac89$var$getClientBorderBoxCenter = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var pageBorderBoxCenter = $83a769edb27eac89$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return $83a769edb27eac89$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
};
var $83a769edb27eac89$var$refreshSnap = function(_ref) {
    var state = _ref.state, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport;
    !(state.movementMode === 'SNAP') && $83a769edb27eac89$var$invariant(false);
    var needsVisibilityCheck = state.impact;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var draggable = draggables[state.critical.draggable.id];
    var isOver = $83a769edb27eac89$var$whatIsDraggedOver(needsVisibilityCheck);
    !isOver && $83a769edb27eac89$var$invariant(false);
    var destination = droppables[isOver];
    var impact = $83a769edb27eac89$var$recompute({
        impact: needsVisibilityCheck,
        viewport: viewport,
        destination: destination,
        draggables: draggables
    });
    var clientSelection = $83a769edb27eac89$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    return $83a769edb27eac89$var$update({
        impact: impact,
        clientSelection: clientSelection,
        state: state,
        dimensions: dimensions,
        viewport: viewport
    });
};
var $83a769edb27eac89$var$getHomeLocation = function(descriptor) {
    return {
        index: descriptor.index,
        droppableId: descriptor.droppableId
    };
};
var $83a769edb27eac89$var$getLiftEffect = function(_ref) {
    var draggable = _ref.draggable, home = _ref.home, draggables = _ref.draggables, viewport = _ref.viewport;
    var displacedBy = $83a769edb27eac89$var$getDisplacedBy(home.axis, draggable.displaceBy);
    var insideHome = $83a769edb27eac89$var$getDraggablesInsideDroppable(home.descriptor.id, draggables);
    var rawIndex = insideHome.indexOf(draggable);
    !(rawIndex !== -1) && $83a769edb27eac89$var$invariant(false);
    var afterDragging = insideHome.slice(rawIndex + 1);
    var effected = afterDragging.reduce(function(previous, item) {
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    var afterCritical = {
        inVirtualList: home.descriptor.mode === 'virtual',
        displacedBy: displacedBy,
        effected: effected
    };
    var displaced = $83a769edb27eac89$var$getDisplacementGroups({
        afterDragging: afterDragging,
        destination: home,
        displacedBy: displacedBy,
        last: null,
        viewport: viewport.frame,
        forceShouldAnimate: false
    });
    var impact = {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: 'REORDER',
            destination: $83a769edb27eac89$var$getHomeLocation(draggable.descriptor)
        }
    };
    return {
        impact: impact,
        afterCritical: afterCritical
    };
};
var $83a769edb27eac89$var$patchDimensionMap = function(dimensions, updated) {
    return {
        draggables: dimensions.draggables,
        droppables: $83a769edb27eac89$var$patchDroppableMap(dimensions.droppables, updated)
    };
};
var $83a769edb27eac89$var$records = {};
var $83a769edb27eac89$var$isEnabled = false;
var $83a769edb27eac89$var$isTimingsEnabled = function isTimingsEnabled() {
    return $83a769edb27eac89$var$isEnabled;
};
var $83a769edb27eac89$var$start = function start(key) {
    var now;
};
var $83a769edb27eac89$var$finish = function finish(key) {
    var now, previous, result, rounded, style;
};
var $83a769edb27eac89$var$offsetDraggable = function(_ref) {
    var draggable = _ref.draggable, offset$1 = _ref.offset, initialWindowScroll = _ref.initialWindowScroll;
    var client = (0, $b703e4029dc36ed5$export$cc800923e997bb8)(draggable.client, offset$1);
    var page = (0, $b703e4029dc36ed5$export$1d0caec378d7d0ae)(client, initialWindowScroll);
    var moved = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, draggable, {
        placeholder: (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, draggable.placeholder, {
            client: client
        }),
        client: client,
        page: page
    });
    return moved;
};
var $83a769edb27eac89$var$getFrame = function(droppable) {
    var frame = droppable.frame;
    !frame && $83a769edb27eac89$var$invariant(false);
    return frame;
};
var $83a769edb27eac89$var$adjustAdditionsForScrollChanges = function(_ref) {
    var additions = _ref.additions, updatedDroppables = _ref.updatedDroppables, viewport = _ref.viewport;
    var windowScrollChange = viewport.scroll.diff.value;
    return additions.map(function(draggable) {
        var droppableId = draggable.descriptor.droppableId;
        var modified = updatedDroppables[droppableId];
        var frame = $83a769edb27eac89$var$getFrame(modified);
        var droppableScrollChange = frame.scroll.diff.value;
        var totalChange = $83a769edb27eac89$var$add(windowScrollChange, droppableScrollChange);
        var moved = $83a769edb27eac89$var$offsetDraggable({
            draggable: draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
var $83a769edb27eac89$var$timingsKey = 'Processing dynamic changes';
var $83a769edb27eac89$var$publishWhileDraggingInVirtual = function(_ref) {
    var _extends2, _extends3;
    var state = _ref.state, published = _ref.published;
    $83a769edb27eac89$var$start($83a769edb27eac89$var$timingsKey);
    var withScrollChange = published.modified.map(function(update) {
        var existing = state.dimensions.droppables[update.droppableId];
        var scrolled = $83a769edb27eac89$var$scrollDroppable(existing, update.scroll);
        return scrolled;
    });
    var droppables = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, state.dimensions.droppables, $83a769edb27eac89$var$toDroppableMap(withScrollChange));
    var updatedAdditions = $83a769edb27eac89$var$toDraggableMap($83a769edb27eac89$var$adjustAdditionsForScrollChanges({
        additions: published.additions,
        updatedDroppables: droppables,
        viewport: state.viewport
    }));
    var draggables = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, state.dimensions.draggables, updatedAdditions);
    published.removals.forEach(function(id) {
        delete draggables[id];
    });
    var dimensions = {
        droppables: droppables,
        draggables: draggables
    };
    var wasOverId = $83a769edb27eac89$var$whatIsDraggedOver(state.impact);
    var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var home = dimensions.droppables[state.critical.droppable.id];
    var _getLiftEffect = $83a769edb27eac89$var$getLiftEffect({
        draggable: draggable,
        home: home,
        draggables: draggables,
        viewport: state.viewport
    }), onLiftImpact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
    var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
    var impact = $83a769edb27eac89$var$getDragImpact({
        pageOffset: state.current.page.offset,
        draggable: dimensions.draggables[state.critical.draggable.id],
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: previousImpact,
        viewport: state.viewport,
        afterCritical: afterCritical
    });
    $83a769edb27eac89$var$finish($83a769edb27eac89$var$timingsKey);
    var draggingState = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({
        phase: 'DRAGGING'
    }, state, (_extends2 = {}, _extends2["phase"] = 'DRAGGING', _extends2.impact = impact, _extends2.onLiftImpact = onLiftImpact, _extends2.dimensions = dimensions, _extends2.afterCritical = afterCritical, _extends2.forceShouldAnimate = false, _extends2));
    if (state.phase === 'COLLECTING') return draggingState;
    var dropPending = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({
        phase: 'DROP_PENDING'
    }, draggingState, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.reason = state.reason, _extends3.isWaiting = false, _extends3));
    return dropPending;
};
var $83a769edb27eac89$var$isSnapping = function isSnapping(state) {
    return state.movementMode === 'SNAP';
};
var $83a769edb27eac89$var$postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
    var dimensions = $83a769edb27eac89$var$patchDimensionMap(state.dimensions, updated);
    if (!$83a769edb27eac89$var$isSnapping(state) || isEnabledChanging) return $83a769edb27eac89$var$update({
        state: state,
        dimensions: dimensions
    });
    return $83a769edb27eac89$var$refreshSnap({
        state: state,
        dimensions: dimensions
    });
};
function $83a769edb27eac89$var$removeScrollJumpRequest(state) {
    if (state.isDragging && state.movementMode === 'SNAP') return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({
        phase: 'DRAGGING'
    }, state, {
        scrollJumpRequest: null
    });
    return state;
}
var $83a769edb27eac89$var$idle = {
    phase: 'IDLE',
    completed: null,
    shouldFlush: false
};
var $83a769edb27eac89$var$reducer = function(state, action) {
    if (state === void 0) state = $83a769edb27eac89$var$idle;
    if (action.type === 'FLUSH') return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, $83a769edb27eac89$var$idle, {
        shouldFlush: true
    });
    if (action.type === 'INITIAL_PUBLISH') {
        !(state.phase === 'IDLE') && $83a769edb27eac89$var$invariant(false);
        var _action$payload = action.payload, critical = _action$payload.critical, clientSelection = _action$payload.clientSelection, viewport = _action$payload.viewport, dimensions = _action$payload.dimensions, movementMode = _action$payload.movementMode;
        var draggable = dimensions.draggables[critical.draggable.id];
        var home = dimensions.droppables[critical.droppable.id];
        var client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: $83a769edb27eac89$var$origin
        };
        var initial = {
            client: client,
            page: {
                selection: $83a769edb27eac89$var$add(client.selection, viewport.scroll.initial),
                borderBoxCenter: $83a769edb27eac89$var$add(client.selection, viewport.scroll.initial),
                offset: $83a769edb27eac89$var$add(client.selection, viewport.scroll.diff.value)
            }
        };
        var isWindowScrollAllowed = $83a769edb27eac89$var$toDroppableList(dimensions.droppables).every(function(item) {
            return !item.isFixedOnPage;
        });
        var _getLiftEffect = $83a769edb27eac89$var$getLiftEffect({
            draggable: draggable,
            home: home,
            draggables: dimensions.draggables,
            viewport: viewport
        }), impact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
        var result = {
            phase: 'DRAGGING',
            isDragging: true,
            critical: critical,
            movementMode: movementMode,
            dimensions: dimensions,
            initial: initial,
            current: initial,
            isWindowScrollAllowed: isWindowScrollAllowed,
            impact: impact,
            afterCritical: afterCritical,
            onLiftImpact: impact,
            viewport: viewport,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === 'COLLECTION_STARTING') {
        var _extends2;
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $83a769edb27eac89$var$invariant(false);
        var _result = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({
            phase: 'COLLECTING'
        }, state, (_extends2 = {}, _extends2["phase"] = 'COLLECTING', _extends2));
        return _result;
    }
    if (action.type === 'PUBLISH_WHILE_DRAGGING') {
        !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') && $83a769edb27eac89$var$invariant(false);
        return $83a769edb27eac89$var$publishWhileDraggingInVirtual({
            state: state,
            published: action.payload
        });
    }
    if (action.type === 'MOVE') {
        if (state.phase === 'DROP_PENDING') return state;
        !$83a769edb27eac89$var$isMovementAllowed(state) && $83a769edb27eac89$var$invariant(false);
        var _clientSelection = action.payload.client;
        if ($83a769edb27eac89$var$isEqual(_clientSelection, state.current.client.selection)) return state;
        return $83a769edb27eac89$var$update({
            state: state,
            clientSelection: _clientSelection,
            impact: $83a769edb27eac89$var$isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
        if (state.phase === 'DROP_PENDING') return $83a769edb27eac89$var$removeScrollJumpRequest(state);
        if (state.phase === 'COLLECTING') return $83a769edb27eac89$var$removeScrollJumpRequest(state);
        !$83a769edb27eac89$var$isMovementAllowed(state) && $83a769edb27eac89$var$invariant(false);
        var _action$payload2 = action.payload, id = _action$payload2.id, newScroll = _action$payload2.newScroll;
        var target = state.dimensions.droppables[id];
        if (!target) return state;
        var scrolled = $83a769edb27eac89$var$scrollDroppable(target, newScroll);
        return $83a769edb27eac89$var$postDroppableChange(state, scrolled, false);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$83a769edb27eac89$var$isMovementAllowed(state) && $83a769edb27eac89$var$invariant(false);
        var _action$payload3 = action.payload, _id = _action$payload3.id, isEnabled = _action$payload3.isEnabled;
        var _target = state.dimensions.droppables[_id];
        !_target && $83a769edb27eac89$var$invariant(false);
        !(_target.isEnabled !== isEnabled) && $83a769edb27eac89$var$invariant(false);
        var updated = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, _target, {
            isEnabled: isEnabled
        });
        return $83a769edb27eac89$var$postDroppableChange(state, updated, true);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$83a769edb27eac89$var$isMovementAllowed(state) && $83a769edb27eac89$var$invariant(false);
        var _action$payload4 = action.payload, _id2 = _action$payload4.id, isCombineEnabled = _action$payload4.isCombineEnabled;
        var _target2 = state.dimensions.droppables[_id2];
        !_target2 && $83a769edb27eac89$var$invariant(false);
        !(_target2.isCombineEnabled !== isCombineEnabled) && $83a769edb27eac89$var$invariant(false);
        var _updated = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, _target2, {
            isCombineEnabled: isCombineEnabled
        });
        return $83a769edb27eac89$var$postDroppableChange(state, _updated, true);
    }
    if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
        if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') return state;
        !$83a769edb27eac89$var$isMovementAllowed(state) && $83a769edb27eac89$var$invariant(false);
        !state.isWindowScrollAllowed && $83a769edb27eac89$var$invariant(false);
        var _newScroll = action.payload.newScroll;
        if ($83a769edb27eac89$var$isEqual(state.viewport.scroll.current, _newScroll)) return $83a769edb27eac89$var$removeScrollJumpRequest(state);
        var _viewport = $83a769edb27eac89$var$scrollViewport(state.viewport, _newScroll);
        if ($83a769edb27eac89$var$isSnapping(state)) return $83a769edb27eac89$var$refreshSnap({
            state: state,
            viewport: _viewport
        });
        return $83a769edb27eac89$var$update({
            state: state,
            viewport: _viewport
        });
    }
    if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
        if (!$83a769edb27eac89$var$isMovementAllowed(state)) return state;
        var maxScroll = action.payload.maxScroll;
        if ($83a769edb27eac89$var$isEqual(maxScroll, state.viewport.scroll.max)) return state;
        var withMaxScroll = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, state.viewport, {
            scroll: (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, state.viewport.scroll, {
                max: maxScroll
            })
        });
        return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({
            phase: 'DRAGGING'
        }, state, {
            viewport: withMaxScroll
        });
    }
    if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && $83a769edb27eac89$var$invariant(false);
        var _result2 = $83a769edb27eac89$var$moveInDirection({
            state: state,
            type: action.type
        });
        if (!_result2) return state;
        return $83a769edb27eac89$var$update({
            state: state,
            impact: _result2.impact,
            clientSelection: _result2.clientSelection,
            scrollJumpRequest: _result2.scrollJumpRequest
        });
    }
    if (action.type === 'DROP_PENDING') {
        var _extends3;
        var reason = action.payload.reason;
        !(state.phase === 'COLLECTING') && $83a769edb27eac89$var$invariant(false);
        var newState = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({
            phase: 'DROP_PENDING'
        }, state, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.isWaiting = true, _extends3.reason = reason, _extends3));
        return newState;
    }
    if (action.type === 'DROP_ANIMATE') {
        var _action$payload5 = action.payload, completed = _action$payload5.completed, dropDuration = _action$payload5.dropDuration, newHomeClientOffset = _action$payload5.newHomeClientOffset;
        !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $83a769edb27eac89$var$invariant(false);
        var _result3 = {
            phase: 'DROP_ANIMATING',
            completed: completed,
            dropDuration: dropDuration,
            newHomeClientOffset: newHomeClientOffset,
            dimensions: state.dimensions
        };
        return _result3;
    }
    if (action.type === 'DROP_COMPLETE') {
        var _completed = action.payload.completed;
        return {
            phase: 'IDLE',
            completed: _completed,
            shouldFlush: false
        };
    }
    return state;
};
var $83a769edb27eac89$var$beforeInitialCapture = function beforeInitialCapture(args) {
    return {
        type: 'BEFORE_INITIAL_CAPTURE',
        payload: args
    };
};
var $83a769edb27eac89$var$lift = function lift(args) {
    return {
        type: 'LIFT',
        payload: args
    };
};
var $83a769edb27eac89$var$initialPublish = function initialPublish(args) {
    return {
        type: 'INITIAL_PUBLISH',
        payload: args
    };
};
var $83a769edb27eac89$var$publishWhileDragging = function publishWhileDragging(args) {
    return {
        type: 'PUBLISH_WHILE_DRAGGING',
        payload: args
    };
};
var $83a769edb27eac89$var$collectionStarting = function collectionStarting() {
    return {
        type: 'COLLECTION_STARTING',
        payload: null
    };
};
var $83a769edb27eac89$var$updateDroppableScroll = function updateDroppableScroll(args) {
    return {
        type: 'UPDATE_DROPPABLE_SCROLL',
        payload: args
    };
};
var $83a769edb27eac89$var$updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
    return {
        type: 'UPDATE_DROPPABLE_IS_ENABLED',
        payload: args
    };
};
var $83a769edb27eac89$var$updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
    return {
        type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
        payload: args
    };
};
var $83a769edb27eac89$var$move = function move(args) {
    return {
        type: 'MOVE',
        payload: args
    };
};
var $83a769edb27eac89$var$moveByWindowScroll = function moveByWindowScroll(args) {
    return {
        type: 'MOVE_BY_WINDOW_SCROLL',
        payload: args
    };
};
var $83a769edb27eac89$var$updateViewportMaxScroll = function updateViewportMaxScroll(args) {
    return {
        type: 'UPDATE_VIEWPORT_MAX_SCROLL',
        payload: args
    };
};
var $83a769edb27eac89$var$moveUp = function moveUp() {
    return {
        type: 'MOVE_UP',
        payload: null
    };
};
var $83a769edb27eac89$var$moveDown = function moveDown() {
    return {
        type: 'MOVE_DOWN',
        payload: null
    };
};
var $83a769edb27eac89$var$moveRight = function moveRight() {
    return {
        type: 'MOVE_RIGHT',
        payload: null
    };
};
var $83a769edb27eac89$var$moveLeft = function moveLeft() {
    return {
        type: 'MOVE_LEFT',
        payload: null
    };
};
var $83a769edb27eac89$var$flush = function flush() {
    return {
        type: 'FLUSH',
        payload: null
    };
};
var $83a769edb27eac89$var$animateDrop = function animateDrop(args) {
    return {
        type: 'DROP_ANIMATE',
        payload: args
    };
};
var $83a769edb27eac89$var$completeDrop = function completeDrop(args) {
    return {
        type: 'DROP_COMPLETE',
        payload: args
    };
};
var $83a769edb27eac89$var$drop = function drop(args) {
    return {
        type: 'DROP',
        payload: args
    };
};
var $83a769edb27eac89$var$dropPending = function dropPending(args) {
    return {
        type: 'DROP_PENDING',
        payload: args
    };
};
var $83a769edb27eac89$var$dropAnimationFinished = function dropAnimationFinished() {
    return {
        type: 'DROP_ANIMATION_FINISHED',
        payload: null
    };
};
function $83a769edb27eac89$var$checkIndexes(insideDestination) {
    if (insideDestination.length <= 1) return;
    var indexes = insideDestination.map(function(d) {
        return d.descriptor.index;
    });
    var errors = {};
    for(var i = 1; i < indexes.length; i++){
        var current = indexes[i];
        var previous = indexes[i - 1];
        if (current !== previous + 1) errors[current] = true;
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($215be2e2d7075d90$exports)))(errors).length) return;
    var formatted = indexes.map(function(index) {
        var hasError = Boolean(errors[index]);
        return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
    }).join(', ');
}
function $83a769edb27eac89$var$validateDimensions(critical, dimensions) {
    var insideDestination;
}
var $83a769edb27eac89$var$lift$1 = function(marshal) {
    return function(_ref) {
        var getState = _ref.getState, dispatch = _ref.dispatch;
        return function(next) {
            return function(action) {
                if (action.type !== 'LIFT') {
                    next(action);
                    return;
                }
                var _action$payload = action.payload, id = _action$payload.id, clientSelection = _action$payload.clientSelection, movementMode = _action$payload.movementMode;
                var initial = getState();
                if (initial.phase === 'DROP_ANIMATING') dispatch($83a769edb27eac89$var$completeDrop({
                    completed: initial.completed
                }));
                !(getState().phase === 'IDLE') && $83a769edb27eac89$var$invariant(false);
                dispatch($83a769edb27eac89$var$flush());
                dispatch($83a769edb27eac89$var$beforeInitialCapture({
                    draggableId: id,
                    movementMode: movementMode
                }));
                var scrollOptions = {
                    shouldPublishImmediately: movementMode === 'SNAP'
                };
                var request = {
                    draggableId: id,
                    scrollOptions: scrollOptions
                };
                var _marshal$startPublish = marshal.startPublishing(request), critical = _marshal$startPublish.critical, dimensions = _marshal$startPublish.dimensions, viewport = _marshal$startPublish.viewport;
                $83a769edb27eac89$var$validateDimensions(critical, dimensions);
                dispatch($83a769edb27eac89$var$initialPublish({
                    critical: critical,
                    dimensions: dimensions,
                    clientSelection: clientSelection,
                    movementMode: movementMode,
                    viewport: viewport
                }));
            };
        };
    };
};
var $83a769edb27eac89$var$style = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'INITIAL_PUBLISH') marshal.dragging();
                if (action.type === 'DROP_ANIMATE') marshal.dropping(action.payload.completed.result.reason);
                if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE') marshal.resting();
                next(action);
            };
        };
    };
};
var $83a769edb27eac89$var$curves = {
    outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
    drop: 'cubic-bezier(.2,1,.1,1)'
};
var $83a769edb27eac89$var$combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
var $83a769edb27eac89$var$timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
var $83a769edb27eac89$var$outOfTheWayTiming = $83a769edb27eac89$var$timings.outOfTheWay + "s " + $83a769edb27eac89$var$curves.outOfTheWay;
var $83a769edb27eac89$var$transitions = {
    fluid: "opacity " + $83a769edb27eac89$var$outOfTheWayTiming,
    snap: "transform " + $83a769edb27eac89$var$outOfTheWayTiming + ", opacity " + $83a769edb27eac89$var$outOfTheWayTiming,
    drop: function drop(duration) {
        var timing = duration + "s " + $83a769edb27eac89$var$curves.drop;
        return "transform " + timing + ", opacity " + timing;
    },
    outOfTheWay: "transform " + $83a769edb27eac89$var$outOfTheWayTiming,
    placeholder: "height " + $83a769edb27eac89$var$outOfTheWayTiming + ", width " + $83a769edb27eac89$var$outOfTheWayTiming + ", margin " + $83a769edb27eac89$var$outOfTheWayTiming
};
var $83a769edb27eac89$var$moveTo = function moveTo(offset) {
    return $83a769edb27eac89$var$isEqual(offset, $83a769edb27eac89$var$origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};
var $83a769edb27eac89$var$transforms = {
    moveTo: $83a769edb27eac89$var$moveTo,
    drop: function drop(offset, isCombining) {
        var translate = $83a769edb27eac89$var$moveTo(offset);
        if (!translate) return null;
        if (!isCombining) return translate;
        return translate + " scale(" + $83a769edb27eac89$var$combine.scale.drop + ")";
    }
};
var $83a769edb27eac89$var$minDropTime = $83a769edb27eac89$var$timings.minDropTime, $83a769edb27eac89$var$maxDropTime = $83a769edb27eac89$var$timings.maxDropTime;
var $83a769edb27eac89$var$dropTimeRange = $83a769edb27eac89$var$maxDropTime - $83a769edb27eac89$var$minDropTime;
var $83a769edb27eac89$var$maxDropTimeAtDistance = 1500;
var $83a769edb27eac89$var$cancelDropModifier = 0.6;
var $83a769edb27eac89$var$getDropDuration = function(_ref) {
    var current = _ref.current, destination = _ref.destination, reason = _ref.reason;
    var distance$1 = $83a769edb27eac89$var$distance(current, destination);
    if (distance$1 <= 0) return $83a769edb27eac89$var$minDropTime;
    if (distance$1 >= $83a769edb27eac89$var$maxDropTimeAtDistance) return $83a769edb27eac89$var$maxDropTime;
    var percentage = distance$1 / $83a769edb27eac89$var$maxDropTimeAtDistance;
    var duration = $83a769edb27eac89$var$minDropTime + $83a769edb27eac89$var$dropTimeRange * percentage;
    var withDuration = reason === 'CANCEL' ? duration * $83a769edb27eac89$var$cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var $83a769edb27eac89$var$getNewHomeClientOffset = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, dimensions = _ref.dimensions, viewport = _ref.viewport, afterCritical = _ref.afterCritical;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var droppableId = $83a769edb27eac89$var$whatIsDraggedOver(impact);
    var destination = droppableId ? droppables[droppableId] : null;
    var home = droppables[draggable.descriptor.droppableId];
    var newClientCenter = $83a769edb27eac89$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        afterCritical: afterCritical,
        droppable: destination || home,
        viewport: viewport
    });
    var offset = $83a769edb27eac89$var$subtract(newClientCenter, draggable.client.borderBox.center);
    return offset;
};
var $83a769edb27eac89$var$getDropImpact = function(_ref) {
    var draggables = _ref.draggables, reason = _ref.reason, lastImpact = _ref.lastImpact, home = _ref.home, viewport = _ref.viewport, onLiftImpact = _ref.onLiftImpact;
    if (!lastImpact.at || reason !== 'DROP') {
        var recomputedHomeImpact = $83a769edb27eac89$var$recompute({
            draggables: draggables,
            impact: onLiftImpact,
            destination: home,
            viewport: viewport,
            forceShouldAnimate: true
        });
        return {
            impact: recomputedHomeImpact,
            didDropInsideDroppable: false
        };
    }
    if (lastImpact.at.type === 'REORDER') return {
        impact: lastImpact,
        didDropInsideDroppable: true
    };
    var withoutMovement = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, lastImpact, {
        displaced: $83a769edb27eac89$var$emptyGroups
    });
    return {
        impact: withoutMovement,
        didDropInsideDroppable: true
    };
};
var $83a769edb27eac89$var$drop$1 = function(_ref) {
    var getState = _ref.getState, dispatch = _ref.dispatch;
    return function(next) {
        return function(action) {
            if (action.type !== 'DROP') {
                next(action);
                return;
            }
            var state = getState();
            var reason = action.payload.reason;
            if (state.phase === 'COLLECTING') {
                dispatch($83a769edb27eac89$var$dropPending({
                    reason: reason
                }));
                return;
            }
            if (state.phase === 'IDLE') return;
            var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
            !!isWaitingForDrop && $83a769edb27eac89$var$invariant(false);
            !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && $83a769edb27eac89$var$invariant(false);
            var critical = state.critical;
            var dimensions = state.dimensions;
            var draggable = dimensions.draggables[state.critical.draggable.id];
            var _getDropImpact = $83a769edb27eac89$var$getDropImpact({
                reason: reason,
                lastImpact: state.impact,
                afterCritical: state.afterCritical,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            }), impact = _getDropImpact.impact, didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;
            var destination = didDropInsideDroppable ? $83a769edb27eac89$var$tryGetDestination(impact) : null;
            var combine = didDropInsideDroppable ? $83a769edb27eac89$var$tryGetCombine(impact) : null;
            var source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            var result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source: source,
                reason: reason,
                mode: state.movementMode,
                destination: destination,
                combine: combine
            };
            var newHomeClientOffset = $83a769edb27eac89$var$getNewHomeClientOffset({
                impact: impact,
                draggable: draggable,
                dimensions: dimensions,
                viewport: state.viewport,
                afterCritical: state.afterCritical
            });
            var completed = {
                critical: state.critical,
                afterCritical: state.afterCritical,
                result: result,
                impact: impact
            };
            var isAnimationRequired = !$83a769edb27eac89$var$isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch($83a769edb27eac89$var$completeDrop({
                    completed: completed
                }));
                return;
            }
            var dropDuration = $83a769edb27eac89$var$getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason: reason
            });
            var args = {
                newHomeClientOffset: newHomeClientOffset,
                dropDuration: dropDuration,
                completed: completed
            };
            dispatch($83a769edb27eac89$var$animateDrop(args));
        };
    };
};
var $83a769edb27eac89$var$getWindowScroll = function() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
function $83a769edb27eac89$var$getWindowScrollBinding(update) {
    return {
        eventName: 'scroll',
        options: {
            passive: true,
            capture: false
        },
        fn: function fn(event) {
            if (event.target !== window && event.target !== window.document) return;
            update();
        }
    };
}
function $83a769edb27eac89$var$getScrollListener(_ref) {
    var onWindowScroll = _ref.onWindowScroll;
    function updateScroll() {
        onWindowScroll($83a769edb27eac89$var$getWindowScroll());
    }
    var scheduled = (0, $3a3632abf48ab519$export$2e2bcd8739ae039)(updateScroll);
    var binding = $83a769edb27eac89$var$getWindowScrollBinding(scheduled);
    var unbind = $83a769edb27eac89$var$noop;
    function isActive() {
        return unbind !== $83a769edb27eac89$var$noop;
    }
    function start() {
        !!isActive() && $83a769edb27eac89$var$invariant(false);
        unbind = $83a769edb27eac89$var$bindEvents(window, [
            binding
        ]);
    }
    function stop() {
        !isActive() && $83a769edb27eac89$var$invariant(false);
        scheduled.cancel();
        unbind();
        unbind = $83a769edb27eac89$var$noop;
    }
    return {
        start: start,
        stop: stop,
        isActive: isActive
    };
}
var $83a769edb27eac89$var$shouldEnd = function shouldEnd(action) {
    return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};
var $83a769edb27eac89$var$scrollListener = function(store) {
    var listener = $83a769edb27eac89$var$getScrollListener({
        onWindowScroll: function onWindowScroll(newScroll) {
            store.dispatch($83a769edb27eac89$var$moveByWindowScroll({
                newScroll: newScroll
            }));
        }
    });
    return function(next) {
        return function(action) {
            if (!listener.isActive() && action.type === 'INITIAL_PUBLISH') listener.start();
            if (listener.isActive() && $83a769edb27eac89$var$shouldEnd(action)) listener.stop();
            next(action);
        };
    };
};
var $83a769edb27eac89$var$getExpiringAnnounce = function(announce) {
    var wasCalled = false;
    var isExpired = false;
    var timeoutId = setTimeout(function() {
        isExpired = true;
    });
    var result = function result(message) {
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = function() {
        return wasCalled;
    };
    return result;
};
var $83a769edb27eac89$var$getAsyncMarshal = function() {
    var entries = [];
    var execute = function execute(timerId) {
        var index = $83a769edb27eac89$var$findIndex(entries, function(item) {
            return item.timerId === timerId;
        });
        !(index !== -1) && $83a769edb27eac89$var$invariant(false);
        var _entries$splice = entries.splice(index, 1), entry = _entries$splice[0];
        entry.callback();
    };
    var add = function add(fn) {
        var timerId = setTimeout(function() {
            return execute(timerId);
        });
        var entry = {
            timerId: timerId,
            callback: fn
        };
        entries.push(entry);
    };
    var flush = function flush() {
        if (!entries.length) return;
        var shallow = [].concat(entries);
        entries.length = 0;
        shallow.forEach(function(entry) {
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add: add,
        flush: flush
    };
};
var $83a769edb27eac89$var$areLocationsEqual = function areLocationsEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
var $83a769edb27eac89$var$isCombineEqual = function isCombineEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var $83a769edb27eac89$var$isCriticalEqual = function isCriticalEqual(first, second) {
    if (first === second) return true;
    var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
var $83a769edb27eac89$var$withTimings = function withTimings(key, fn) {
    $83a769edb27eac89$var$start(key);
    fn();
    $83a769edb27eac89$var$finish(key);
};
var $83a769edb27eac89$var$getDragStart = function getDragStart(critical, mode) {
    return {
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode: mode
    };
};
var $83a769edb27eac89$var$execute = function execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    var willExpire = $83a769edb27eac89$var$getExpiringAnnounce(announce);
    var provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
};
var $83a769edb27eac89$var$getPublisher = function(getResponders, announce) {
    var asyncMarshal = $83a769edb27eac89$var$getAsyncMarshal();
    var dragging = null;
    var beforeCapture = function beforeCapture(draggableId, mode) {
        !!dragging && $83a769edb27eac89$var$invariant(false);
        $83a769edb27eac89$var$withTimings('onBeforeCapture', function() {
            var fn = getResponders().onBeforeCapture;
            if (fn) {
                var before = {
                    draggableId: draggableId,
                    mode: mode
                };
                fn(before);
            }
        });
    };
    var beforeStart = function beforeStart(critical, mode) {
        !!dragging && $83a769edb27eac89$var$invariant(false);
        $83a769edb27eac89$var$withTimings('onBeforeDragStart', function() {
            var fn = getResponders().onBeforeDragStart;
            if (fn) fn($83a769edb27eac89$var$getDragStart(critical, mode));
        });
    };
    var start = function start(critical, mode) {
        !!dragging && $83a769edb27eac89$var$invariant(false);
        var data = $83a769edb27eac89$var$getDragStart(critical, mode);
        dragging = {
            mode: mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(function() {
            $83a769edb27eac89$var$withTimings('onDragStart', function() {
                return $83a769edb27eac89$var$execute(getResponders().onDragStart, data, announce, $83a769edb27eac89$var$preset.onDragStart);
            });
        });
    };
    var update = function update(critical, impact) {
        var location = $83a769edb27eac89$var$tryGetDestination(impact);
        var combine = $83a769edb27eac89$var$tryGetCombine(impact);
        !dragging && $83a769edb27eac89$var$invariant(false);
        var hasCriticalChanged = !$83a769edb27eac89$var$isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        var hasLocationChanged = !$83a769edb27eac89$var$areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        var hasGroupingChanged = !$83a769edb27eac89$var$isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        var data = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, $83a769edb27eac89$var$getDragStart(critical, dragging.mode), {
            combine: combine,
            destination: location
        });
        asyncMarshal.add(function() {
            $83a769edb27eac89$var$withTimings('onDragUpdate', function() {
                return $83a769edb27eac89$var$execute(getResponders().onDragUpdate, data, announce, $83a769edb27eac89$var$preset.onDragUpdate);
            });
        });
    };
    var flush = function flush() {
        !dragging && $83a769edb27eac89$var$invariant(false);
        asyncMarshal.flush();
    };
    var drop = function drop(result) {
        !dragging && $83a769edb27eac89$var$invariant(false);
        dragging = null;
        $83a769edb27eac89$var$withTimings('onDragEnd', function() {
            return $83a769edb27eac89$var$execute(getResponders().onDragEnd, result, announce, $83a769edb27eac89$var$preset.onDragEnd);
        });
    };
    var abort = function abort() {
        if (!dragging) return;
        var result = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, $83a769edb27eac89$var$getDragStart(dragging.lastCritical, dragging.mode), {
            combine: null,
            destination: null,
            reason: 'CANCEL'
        });
        drop(result);
    };
    return {
        beforeCapture: beforeCapture,
        beforeStart: beforeStart,
        start: start,
        update: update,
        flush: flush,
        drop: drop,
        abort: abort
    };
};
var $83a769edb27eac89$var$responders = function(getResponders, announce) {
    var publisher = $83a769edb27eac89$var$getPublisher(getResponders, announce);
    return function(store) {
        return function(next) {
            return function(action) {
                if (action.type === 'BEFORE_INITIAL_CAPTURE') {
                    publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    var critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    var result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if (action.type === 'FLUSH') {
                    publisher.abort();
                    return;
                }
                var state = store.getState();
                if (state.phase === 'DRAGGING') publisher.update(state.critical, state.impact);
            };
        };
    };
};
var $83a769edb27eac89$var$dropAnimationFinish = function(store) {
    return function(next) {
        return function(action) {
            if (action.type !== 'DROP_ANIMATION_FINISHED') {
                next(action);
                return;
            }
            var state = store.getState();
            !(state.phase === 'DROP_ANIMATING') && $83a769edb27eac89$var$invariant(false);
            store.dispatch($83a769edb27eac89$var$completeDrop({
                completed: state.completed
            }));
        };
    };
};
var $83a769edb27eac89$var$dropAnimationFlushOnScroll = function(store) {
    var unbind = null;
    var frameId = null;
    function clear() {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (unbind) {
            unbind();
            unbind = null;
        }
    }
    return function(next) {
        return function(action) {
            if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATION_FINISHED') clear();
            next(action);
            if (action.type !== 'DROP_ANIMATE') return;
            var binding = {
                eventName: 'scroll',
                options: {
                    capture: true,
                    passive: false,
                    once: true
                },
                fn: function flushDropAnimation() {
                    var state = store.getState();
                    if (state.phase === 'DROP_ANIMATING') store.dispatch($83a769edb27eac89$var$dropAnimationFinished());
                }
            };
            frameId = requestAnimationFrame(function() {
                frameId = null;
                unbind = $83a769edb27eac89$var$bindEvents(window, [
                    binding
                ]);
            });
        };
    };
};
var $83a769edb27eac89$var$dimensionMarshalStopper = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'DROP_COMPLETE' || action.type === 'FLUSH' || action.type === 'DROP_ANIMATE') marshal.stopPublishing();
                next(action);
            };
        };
    };
};
var $83a769edb27eac89$var$focus = function(marshal) {
    var isWatching = false;
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'INITIAL_PUBLISH') {
                    isWatching = true;
                    marshal.tryRecordFocus(action.payload.critical.draggable.id);
                    next(action);
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                next(action);
                if (!isWatching) return;
                if (action.type === 'FLUSH') {
                    isWatching = false;
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    isWatching = false;
                    var result = action.payload.completed.result;
                    if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                    marshal.tryRestoreFocusRecorded();
                }
            };
        };
    };
};
var $83a769edb27eac89$var$shouldStop = function shouldStop(action) {
    return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};
var $83a769edb27eac89$var$autoScroll = function(autoScroller) {
    return function(store) {
        return function(next) {
            return function(action) {
                if ($83a769edb27eac89$var$shouldStop(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    next(action);
                    var state = store.getState();
                    !(state.phase === 'DRAGGING') && $83a769edb27eac89$var$invariant(false);
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
        };
    };
};
var $83a769edb27eac89$var$pendingDrop = function(store) {
    return function(next) {
        return function(action) {
            next(action);
            if (action.type !== 'PUBLISH_WHILE_DRAGGING') return;
            var postActionState = store.getState();
            if (postActionState.phase !== 'DROP_PENDING') return;
            if (postActionState.isWaiting) return;
            store.dispatch($83a769edb27eac89$var$drop({
                reason: postActionState.reason
            }));
        };
    };
};
var $83a769edb27eac89$var$composeEnhancers = (0, $7778c83e64d928d5$export$f672e0b6f7222cd7);
var $83a769edb27eac89$var$createStore = function(_ref) {
    var dimensionMarshal = _ref.dimensionMarshal, focusMarshal = _ref.focusMarshal, styleMarshal = _ref.styleMarshal, getResponders = _ref.getResponders, announce = _ref.announce, autoScroller = _ref.autoScroller;
    return (0, $7778c83e64d928d5$export$f51a9068ac82ea43)($83a769edb27eac89$var$reducer, $83a769edb27eac89$var$composeEnhancers((0, $7778c83e64d928d5$export$9ff26e0402cc7b7)($83a769edb27eac89$var$style(styleMarshal), $83a769edb27eac89$var$dimensionMarshalStopper(dimensionMarshal), $83a769edb27eac89$var$lift$1(dimensionMarshal), $83a769edb27eac89$var$drop$1, $83a769edb27eac89$var$dropAnimationFinish, $83a769edb27eac89$var$dropAnimationFlushOnScroll, $83a769edb27eac89$var$pendingDrop, $83a769edb27eac89$var$autoScroll(autoScroller), $83a769edb27eac89$var$scrollListener, $83a769edb27eac89$var$focus(focusMarshal), $83a769edb27eac89$var$responders(getResponders, announce))));
};
var $83a769edb27eac89$var$clean$1 = function clean() {
    return {
        additions: {},
        removals: {},
        modified: {}
    };
};
var $83a769edb27eac89$var$timingKey = 'Publish collection from DOM';
function $83a769edb27eac89$var$createPublisher(_ref) {
    var registry = _ref.registry, callbacks = _ref.callbacks;
    var staging = $83a769edb27eac89$var$clean$1();
    var frameId = null;
    var collect = function collect() {
        if (frameId) return;
        callbacks.collectionStarting();
        frameId = requestAnimationFrame(function() {
            frameId = null;
            $83a769edb27eac89$var$start($83a769edb27eac89$var$timingKey);
            var _staging = staging, additions = _staging.additions, removals = _staging.removals, modified = _staging.modified;
            var added = (0, (/*@__PURE__*/$parcel$interopDefault($215be2e2d7075d90$exports)))(additions).map(function(id) {
                return registry.draggable.getById(id).getDimension($83a769edb27eac89$var$origin);
            }).sort(function(a, b) {
                return a.descriptor.index - b.descriptor.index;
            });
            var updated = (0, (/*@__PURE__*/$parcel$interopDefault($215be2e2d7075d90$exports)))(modified).map(function(id) {
                var entry = registry.droppable.getById(id);
                var scroll = entry.callbacks.getScrollWhileDragging();
                return {
                    droppableId: id,
                    scroll: scroll
                };
            });
            var result = {
                additions: added,
                removals: (0, (/*@__PURE__*/$parcel$interopDefault($215be2e2d7075d90$exports)))(removals),
                modified: updated
            };
            staging = $83a769edb27eac89$var$clean$1();
            $83a769edb27eac89$var$finish($83a769edb27eac89$var$timingKey);
            callbacks.publish(result);
        });
    };
    var add = function add(entry) {
        var id = entry.descriptor.id;
        staging.additions[id] = entry;
        staging.modified[entry.descriptor.droppableId] = true;
        if (staging.removals[id]) delete staging.removals[id];
        collect();
    };
    var remove = function remove(entry) {
        var descriptor = entry.descriptor;
        staging.removals[descriptor.id] = true;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    var stop = function stop() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = $83a769edb27eac89$var$clean$1();
    };
    return {
        add: add,
        remove: remove,
        stop: stop
    };
}
var $83a769edb27eac89$var$getMaxScroll = function(_ref) {
    var scrollHeight = _ref.scrollHeight, scrollWidth = _ref.scrollWidth, height = _ref.height, width = _ref.width;
    var maxScroll = $83a769edb27eac89$var$subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    var adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var $83a769edb27eac89$var$getDocumentElement = function() {
    var doc = document.documentElement;
    !doc && $83a769edb27eac89$var$invariant(false);
    return doc;
};
var $83a769edb27eac89$var$getMaxWindowScroll = function() {
    var doc = $83a769edb27eac89$var$getDocumentElement();
    var maxScroll = $83a769edb27eac89$var$getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var $83a769edb27eac89$var$getViewport = function() {
    var scroll = $83a769edb27eac89$var$getWindowScroll();
    var maxScroll = $83a769edb27eac89$var$getMaxWindowScroll();
    var top = scroll.y;
    var left = scroll.x;
    var doc = $83a769edb27eac89$var$getDocumentElement();
    var width = doc.clientWidth;
    var height = doc.clientHeight;
    var right = left + width;
    var bottom = top + height;
    var frame = (0, $b703e4029dc36ed5$export$4b834cebd9e5cebe)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    var viewport = {
        frame: frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: $83a769edb27eac89$var$origin,
                displacement: $83a769edb27eac89$var$origin
            }
        }
    };
    return viewport;
};
var $83a769edb27eac89$var$getInitialPublish = function(_ref) {
    var critical = _ref.critical, scrollOptions = _ref.scrollOptions, registry = _ref.registry;
    var timingKey = 'Initial collection from DOM';
    $83a769edb27eac89$var$start(timingKey);
    var viewport = $83a769edb27eac89$var$getViewport();
    var windowScroll = viewport.scroll.current;
    var home = critical.droppable;
    var droppables = registry.droppable.getAllByType(home.type).map(function(entry) {
        return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
    });
    var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function(entry) {
        return entry.getDimension(windowScroll);
    });
    var dimensions = {
        draggables: $83a769edb27eac89$var$toDraggableMap(draggables),
        droppables: $83a769edb27eac89$var$toDroppableMap(droppables)
    };
    $83a769edb27eac89$var$finish(timingKey);
    var result = {
        dimensions: dimensions,
        critical: critical,
        viewport: viewport
    };
    return result;
};
function $83a769edb27eac89$var$shouldPublishUpdate(registry, dragging, entry) {
    if (entry.descriptor.id === dragging.id) return false;
    if (entry.descriptor.type !== dragging.type) return false;
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    if (home.descriptor.mode !== 'virtual') return false;
    return true;
}
var $83a769edb27eac89$var$createDimensionMarshal = function(registry, callbacks) {
    var collection = null;
    var publisher = $83a769edb27eac89$var$createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting
        },
        registry: registry
    });
    var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
        !registry.droppable.exists(id) && $83a769edb27eac89$var$invariant(false);
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id: id,
            isEnabled: isEnabled
        });
    };
    var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
        if (!collection) return;
        !registry.droppable.exists(id) && $83a769edb27eac89$var$invariant(false);
        callbacks.updateDroppableIsCombineEnabled({
            id: id,
            isCombineEnabled: isCombineEnabled
        });
    };
    var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
        if (!collection) return;
        !registry.droppable.exists(id) && $83a769edb27eac89$var$invariant(false);
        callbacks.updateDroppableScroll({
            id: id,
            newScroll: newScroll
        });
    };
    var scrollDroppable = function scrollDroppable(id, change) {
        if (!collection) return;
        registry.droppable.getById(id).callbacks.scroll(change);
    };
    var stopPublishing = function stopPublishing() {
        if (!collection) return;
        publisher.stop();
        var home = collection.critical.droppable;
        registry.droppable.getAllByType(home.type).forEach(function(entry) {
            return entry.callbacks.dragStopped();
        });
        collection.unsubscribe();
        collection = null;
    };
    var subscriber = function subscriber(event) {
        !collection && $83a769edb27eac89$var$invariant(false);
        var dragging = collection.critical.draggable;
        if (event.type === 'ADDITION') {
            if ($83a769edb27eac89$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
        }
        if (event.type === 'REMOVAL') {
            if ($83a769edb27eac89$var$shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
        }
    };
    var startPublishing = function startPublishing(request) {
        !!collection && $83a769edb27eac89$var$invariant(false);
        var entry = registry.draggable.getById(request.draggableId);
        var home = registry.droppable.getById(entry.descriptor.droppableId);
        var critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        var unsubscribe = registry.subscribe(subscriber);
        collection = {
            critical: critical,
            unsubscribe: unsubscribe
        };
        return $83a769edb27eac89$var$getInitialPublish({
            critical: critical,
            registry: registry,
            scrollOptions: request.scrollOptions
        });
    };
    var marshal = {
        updateDroppableIsEnabled: updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
        scrollDroppable: scrollDroppable,
        updateDroppableScroll: updateDroppableScroll,
        startPublishing: startPublishing,
        stopPublishing: stopPublishing
    };
    return marshal;
};
var $83a769edb27eac89$var$canStartDrag = function(state, id) {
    if (state.phase === 'IDLE') return true;
    if (state.phase !== 'DROP_ANIMATING') return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === 'DROP';
};
var $83a769edb27eac89$var$scrollWindow = function(change) {
    window.scrollBy(change.x, change.y);
};
var $83a769edb27eac89$var$getScrollableDroppables = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(droppables) {
    return $83a769edb27eac89$var$toDroppableList(droppables).filter(function(droppable) {
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    });
});
var $83a769edb27eac89$var$getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
    var maybe = $83a769edb27eac89$var$find($83a769edb27eac89$var$getScrollableDroppables(droppables), function(droppable) {
        !droppable.frame && $83a769edb27eac89$var$invariant(false);
        return $83a769edb27eac89$var$isPositionInFrame(droppable.frame.pageMarginBox)(target);
    });
    return maybe;
};
var $83a769edb27eac89$var$getBestScrollableDroppable = function(_ref) {
    var center = _ref.center, destination = _ref.destination, droppables = _ref.droppables;
    if (destination) {
        var _dimension = droppables[destination];
        if (!_dimension.frame) return null;
        return _dimension;
    }
    var dimension = $83a769edb27eac89$var$getScrollableDroppableOver(center, droppables);
    return dimension;
};
var $83a769edb27eac89$var$config = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: function ease(percentage) {
        return Math.pow(percentage, 2);
    },
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    }
};
var $83a769edb27eac89$var$getDistanceThresholds = function(container, axis) {
    var startScrollingFrom = container[axis.size] * $83a769edb27eac89$var$config.startFromPercentage;
    var maxScrollValueAt = container[axis.size] * $83a769edb27eac89$var$config.maxScrollAtPercentage;
    var thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $83a769edb27eac89$var$getPercentage = function(_ref) {
    var startOfRange = _ref.startOfRange, endOfRange = _ref.endOfRange, current = _ref.current;
    var range = endOfRange - startOfRange;
    if (range === 0) return 0;
    var currentInRange = current - startOfRange;
    var percentage = currentInRange / range;
    return percentage;
};
var $83a769edb27eac89$var$minScroll = 1;
var $83a769edb27eac89$var$getValueFromDistance = function(distanceToEdge, thresholds) {
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return $83a769edb27eac89$var$config.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return $83a769edb27eac89$var$minScroll;
    var percentageFromMaxScrollValueAt = $83a769edb27eac89$var$getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    var scroll = $83a769edb27eac89$var$config.maxPixelScroll * $83a769edb27eac89$var$config.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var $83a769edb27eac89$var$accelerateAt = $83a769edb27eac89$var$config.durationDampening.accelerateAt;
var $83a769edb27eac89$var$stopAt = $83a769edb27eac89$var$config.durationDampening.stopDampeningAt;
var $83a769edb27eac89$var$dampenValueByTime = function(proposedScroll, dragStartTime) {
    var startOfRange = dragStartTime;
    var endOfRange = $83a769edb27eac89$var$stopAt;
    var now = (0, (/*@__PURE__*/$parcel$interopDefault($2844f46160634521$exports)))();
    var runTime = now - startOfRange;
    if (runTime >= $83a769edb27eac89$var$stopAt) return proposedScroll;
    if (runTime < $83a769edb27eac89$var$accelerateAt) return $83a769edb27eac89$var$minScroll;
    var betweenAccelerateAtAndStopAtPercentage = $83a769edb27eac89$var$getPercentage({
        startOfRange: $83a769edb27eac89$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    var scroll = proposedScroll * $83a769edb27eac89$var$config.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var $83a769edb27eac89$var$getValue = function(_ref) {
    var distanceToEdge = _ref.distanceToEdge, thresholds = _ref.thresholds, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $83a769edb27eac89$var$getValueFromDistance(distanceToEdge, thresholds);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max($83a769edb27eac89$var$dampenValueByTime(scroll, dragStartTime), $83a769edb27eac89$var$minScroll);
};
var $83a769edb27eac89$var$getScrollOnAxis = function(_ref) {
    var container = _ref.container, distanceToEdges = _ref.distanceToEdges, dragStartTime = _ref.dragStartTime, axis = _ref.axis, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var thresholds = $83a769edb27eac89$var$getDistanceThresholds(container, axis);
    var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return $83a769edb27eac89$var$getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * $83a769edb27eac89$var$getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};
var $83a769edb27eac89$var$adjustForSizeLimits = function(_ref) {
    var container = _ref.container, subject = _ref.subject, proposedScroll = _ref.proposedScroll;
    var isTooBigVertically = subject.height > container.height;
    var isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
var $83a769edb27eac89$var$clean$2 = $83a769edb27eac89$var$apply(function(value) {
    return value === 0 ? 0 : value;
});
var $83a769edb27eac89$var$getScroll = function(_ref) {
    var dragStartTime = _ref.dragStartTime, container = _ref.container, subject = _ref.subject, center = _ref.center, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    var y = $83a769edb27eac89$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $83a769edb27eac89$var$vertical,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var x = $83a769edb27eac89$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $83a769edb27eac89$var$horizontal,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var required = $83a769edb27eac89$var$clean$2({
        x: x,
        y: y
    });
    if ($83a769edb27eac89$var$isEqual(required, $83a769edb27eac89$var$origin)) return null;
    var limited = $83a769edb27eac89$var$adjustForSizeLimits({
        container: container,
        subject: subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return $83a769edb27eac89$var$isEqual(limited, $83a769edb27eac89$var$origin) ? null : limited;
};
var $83a769edb27eac89$var$smallestSigned = $83a769edb27eac89$var$apply(function(value) {
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
var $83a769edb27eac89$var$getOverlap = function() {
    var getRemainder = function getRemainder(target, max) {
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return function(_ref) {
        var current = _ref.current, max = _ref.max, change = _ref.change;
        var targetScroll = $83a769edb27eac89$var$add(current, change);
        var overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ($83a769edb27eac89$var$isEqual(overlap, $83a769edb27eac89$var$origin)) return null;
        return overlap;
    };
}();
var $83a769edb27eac89$var$canPartiallyScroll = function canPartiallyScroll(_ref2) {
    var rawMax = _ref2.max, current = _ref2.current, change = _ref2.change;
    var max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    var smallestChange = $83a769edb27eac89$var$smallestSigned(change);
    var overlap = $83a769edb27eac89$var$getOverlap({
        max: max,
        current: current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
var $83a769edb27eac89$var$canScrollWindow = function canScrollWindow(viewport, change) {
    return $83a769edb27eac89$var$canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
};
var $83a769edb27eac89$var$getWindowOverlap = function getWindowOverlap(viewport, change) {
    if (!$83a769edb27eac89$var$canScrollWindow(viewport, change)) return null;
    var max = viewport.scroll.max;
    var current = viewport.scroll.current;
    return $83a769edb27eac89$var$getOverlap({
        current: current,
        max: max,
        change: change
    });
};
var $83a769edb27eac89$var$canScrollDroppable = function canScrollDroppable(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return false;
    return $83a769edb27eac89$var$canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $83a769edb27eac89$var$getDroppableOverlap = function getDroppableOverlap(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return null;
    if (!$83a769edb27eac89$var$canScrollDroppable(droppable, change)) return null;
    return $83a769edb27eac89$var$getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $83a769edb27eac89$var$getWindowScrollChange = function(_ref) {
    var viewport = _ref.viewport, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $83a769edb27eac89$var$getScroll({
        dragStartTime: dragStartTime,
        container: viewport.frame,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $83a769edb27eac89$var$canScrollWindow(viewport, scroll) ? scroll : null;
};
var $83a769edb27eac89$var$getDroppableScrollChange = function(_ref) {
    var droppable = _ref.droppable, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var frame = droppable.frame;
    if (!frame) return null;
    var scroll = $83a769edb27eac89$var$getScroll({
        dragStartTime: dragStartTime,
        container: frame.pageMarginBox,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $83a769edb27eac89$var$canScrollDroppable(droppable, scroll) ? scroll : null;
};
var $83a769edb27eac89$var$scroll$1 = function(_ref) {
    var state = _ref.state, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening, scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var center = state.current.page.borderBoxCenter;
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        var viewport = state.viewport;
        var _change = $83a769edb27eac89$var$getWindowScrollChange({
            dragStartTime: dragStartTime,
            viewport: viewport,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (_change) {
            scrollWindow(_change);
            return;
        }
    }
    var droppable = $83a769edb27eac89$var$getBestScrollableDroppable({
        center: center,
        destination: $83a769edb27eac89$var$whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    var change = $83a769edb27eac89$var$getDroppableScrollChange({
        dragStartTime: dragStartTime,
        droppable: droppable,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    if (change) scrollDroppable(droppable.descriptor.id, change);
};
var $83a769edb27eac89$var$createFluidScroller = function(_ref) {
    var scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var scheduleWindowScroll = (0, $3a3632abf48ab519$export$2e2bcd8739ae039)(scrollWindow);
    var scheduleDroppableScroll = (0, $3a3632abf48ab519$export$2e2bcd8739ae039)(scrollDroppable);
    var dragging = null;
    var tryScroll = function tryScroll(state) {
        !dragging && $83a769edb27eac89$var$invariant(false);
        var _dragging = dragging, shouldUseTimeDampening = _dragging.shouldUseTimeDampening, dragStartTime = _dragging.dragStartTime;
        $83a769edb27eac89$var$scroll$1({
            state: state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
    };
    var start$1 = function start$1(state) {
        $83a769edb27eac89$var$start('starting fluid scroller');
        !!dragging && $83a769edb27eac89$var$invariant(false);
        var dragStartTime = (0, (/*@__PURE__*/$parcel$interopDefault($2844f46160634521$exports)))();
        var wasScrollNeeded = false;
        var fakeScrollCallback = function fakeScrollCallback() {
            wasScrollNeeded = true;
        };
        $83a769edb27eac89$var$scroll$1({
            state: state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback
        });
        dragging = {
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        $83a769edb27eac89$var$finish('starting fluid scroller');
        if (wasScrollNeeded) tryScroll(state);
    };
    var stop = function stop() {
        if (!dragging) return;
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
        dragging = null;
    };
    return {
        start: start$1,
        stop: stop,
        scroll: tryScroll
    };
};
var $83a769edb27eac89$var$createJumpScroller = function(_ref) {
    var move = _ref.move, scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow;
    var moveByOffset = function moveByOffset(state, offset) {
        var client = $83a769edb27eac89$var$add(state.current.client.selection, offset);
        move({
            client: client
        });
    };
    var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
        if (!$83a769edb27eac89$var$canScrollDroppable(droppable, change)) return change;
        var overlap = $83a769edb27eac89$var$getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        var whatTheDroppableCanScroll = $83a769edb27eac89$var$subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        var remainder = $83a769edb27eac89$var$subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
        if (!isWindowScrollAllowed) return change;
        if (!$83a769edb27eac89$var$canScrollWindow(viewport, change)) return change;
        var overlap = $83a769edb27eac89$var$getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        var whatTheWindowCanScroll = $83a769edb27eac89$var$subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        var remainder = $83a769edb27eac89$var$subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    var jumpScroller = function jumpScroller(state) {
        var request = state.scrollJumpRequest;
        if (!request) return;
        var destination = $83a769edb27eac89$var$whatIsDraggedOver(state.impact);
        !destination && $83a769edb27eac89$var$invariant(false);
        var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        var viewport = state.viewport;
        var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var $83a769edb27eac89$var$createAutoScroller = function(_ref) {
    var scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow, move = _ref.move;
    var fluidScroller = $83a769edb27eac89$var$createFluidScroller({
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var jumpScroll = $83a769edb27eac89$var$createJumpScroller({
        move: move,
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var scroll = function scroll(state) {
        if (state.phase !== 'DRAGGING') return;
        if (state.movementMode === 'FLUID') {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    var scroller = {
        scroll: scroll,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
var $83a769edb27eac89$var$prefix$1 = 'data-rbd';
var $83a769edb27eac89$var$dragHandle = function() {
    var base = $83a769edb27eac89$var$prefix$1 + "-drag-handle";
    return {
        base: base,
        draggableId: base + "-draggable-id",
        contextId: base + "-context-id"
    };
}();
var $83a769edb27eac89$var$draggable = function() {
    var base = $83a769edb27eac89$var$prefix$1 + "-draggable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $83a769edb27eac89$var$droppable = function() {
    var base = $83a769edb27eac89$var$prefix$1 + "-droppable";
    return {
        base: base,
        contextId: base + "-context-id",
        id: base + "-id"
    };
}();
var $83a769edb27eac89$var$scrollContainer = {
    contextId: $83a769edb27eac89$var$prefix$1 + "-scroll-container-context-id"
};
var $83a769edb27eac89$var$makeGetSelector = function makeGetSelector(context) {
    return function(attribute) {
        return "[" + attribute + "=\"" + context + "\"]";
    };
};
var $83a769edb27eac89$var$getStyles = function getStyles(rules, property) {
    return rules.map(function(rule) {
        var value = rule.styles[property];
        if (!value) return '';
        return rule.selector + " { " + value + " }";
    }).join(' ');
};
var $83a769edb27eac89$var$noPointerEvents = 'pointer-events: none;';
var $83a769edb27eac89$var$getStyles$1 = function(contextId) {
    var getSelector = $83a769edb27eac89$var$makeGetSelector(contextId);
    var dragHandle$1 = function() {
        var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
        return {
            selector: getSelector($83a769edb27eac89$var$dragHandle.contextId),
            styles: {
                always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
                resting: grabCursor,
                dragging: $83a769edb27eac89$var$noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    }();
    var draggable$1 = function() {
        var transition = "\n      transition: " + $83a769edb27eac89$var$transitions.outOfTheWay + ";\n    ";
        return {
            selector: getSelector($83a769edb27eac89$var$draggable.contextId),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    }();
    var droppable$1 = {
        selector: getSelector($83a769edb27eac89$var$droppable.contextId),
        styles: {
            always: "overflow-anchor: none;"
        }
    };
    var body = {
        selector: 'body',
        styles: {
            dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
        }
    };
    var rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: $83a769edb27eac89$var$getStyles(rules, 'always'),
        resting: $83a769edb27eac89$var$getStyles(rules, 'resting'),
        dragging: $83a769edb27eac89$var$getStyles(rules, 'dragging'),
        dropAnimating: $83a769edb27eac89$var$getStyles(rules, 'dropAnimating'),
        userCancel: $83a769edb27eac89$var$getStyles(rules, 'userCancel')
    };
};
var $83a769edb27eac89$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $ieT14.useLayoutEffect) : (0, $ieT14.useEffect);
var $83a769edb27eac89$var$getHead = function getHead() {
    var head = document.querySelector('head');
    !head && $83a769edb27eac89$var$invariant(false);
    return head;
};
var $83a769edb27eac89$var$createStyleEl = function createStyleEl(nonce) {
    var el = document.createElement('style');
    if (nonce) el.setAttribute('nonce', nonce);
    el.type = 'text/css';
    return el;
};
function $83a769edb27eac89$var$useStyleMarshal(contextId, nonce) {
    var styles = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return $83a769edb27eac89$var$getStyles$1(contextId);
    }, [
        contextId
    ]);
    var alwaysRef = (0, $ieT14.useRef)(null);
    var dynamicRef = (0, $ieT14.useRef)(null);
    var setDynamicStyle = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)((0, $bab2733189173eea$export$2e2bcd8739ae039)(function(proposed) {
        var el = dynamicRef.current;
        !el && $83a769edb27eac89$var$invariant(false);
        el.textContent = proposed;
    }), []);
    var setAlwaysStyle = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(proposed) {
        var el = alwaysRef.current;
        !el && $83a769edb27eac89$var$invariant(false);
        el.textContent = proposed;
    }, []);
    $83a769edb27eac89$var$useIsomorphicLayoutEffect(function() {
        !(!alwaysRef.current && !dynamicRef.current) && $83a769edb27eac89$var$invariant(false);
        var always = $83a769edb27eac89$var$createStyleEl(nonce);
        var dynamic = $83a769edb27eac89$var$createStyleEl(nonce);
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute($83a769edb27eac89$var$prefix$1 + "-always", contextId);
        dynamic.setAttribute($83a769edb27eac89$var$prefix$1 + "-dynamic", contextId);
        $83a769edb27eac89$var$getHead().appendChild(always);
        $83a769edb27eac89$var$getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return function() {
            var remove = function remove(ref) {
                var current = ref.current;
                !current && $83a769edb27eac89$var$invariant(false);
                $83a769edb27eac89$var$getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        nonce,
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        contextId
    ]);
    var dragging = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        return setDynamicStyle(styles.dragging);
    }, [
        setDynamicStyle,
        styles.dragging
    ]);
    var dropping = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(reason) {
        if (reason === 'DROP') {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    var resting = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    var marshal = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            dragging: dragging,
            dropping: dropping,
            resting: resting
        };
    }, [
        dragging,
        dropping,
        resting
    ]);
    return marshal;
}
var $83a769edb27eac89$var$getWindowFromEl = function(el) {
    return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
};
function $83a769edb27eac89$var$isHtmlElement(el) {
    return el instanceof $83a769edb27eac89$var$getWindowFromEl(el).HTMLElement;
}
function $83a769edb27eac89$var$findDragHandle(contextId, draggableId) {
    var selector = "[" + $83a769edb27eac89$var$dragHandle.contextId + "=\"" + contextId + "\"]";
    var possible = $83a769edb27eac89$var$toArray(document.querySelectorAll(selector));
    if (!possible.length) return null;
    var handle = $83a769edb27eac89$var$find(possible, function(el) {
        return el.getAttribute($83a769edb27eac89$var$dragHandle.draggableId) === draggableId;
    });
    if (!handle) return null;
    if (!$83a769edb27eac89$var$isHtmlElement(handle)) return null;
    return handle;
}
function $83a769edb27eac89$var$useFocusMarshal(contextId) {
    var entriesRef = (0, $ieT14.useRef)({});
    var recordRef = (0, $ieT14.useRef)(null);
    var restoreFocusFrameRef = (0, $ieT14.useRef)(null);
    var isMountedRef = (0, $ieT14.useRef)(false);
    var register = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function register(id, focus) {
        var entry = {
            id: id,
            focus: focus
        };
        entriesRef.current[id] = entry;
        return function unregister() {
            var entries = entriesRef.current;
            var current = entries[id];
            if (current !== entry) delete entries[id];
        };
    }, []);
    var tryGiveFocus = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function tryGiveFocus(tryGiveFocusTo) {
        var handle = $83a769edb27eac89$var$findDragHandle(contextId, tryGiveFocusTo);
        if (handle && handle !== document.activeElement) handle.focus();
    }, [
        contextId
    ]);
    var tryShiftRecord = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function tryShiftRecord(previous, redirectTo) {
        if (recordRef.current === previous) recordRef.current = redirectTo;
    }, []);
    var tryRestoreFocusRecorded = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function tryRestoreFocusRecorded() {
        if (restoreFocusFrameRef.current) return;
        if (!isMountedRef.current) return;
        restoreFocusFrameRef.current = requestAnimationFrame(function() {
            restoreFocusFrameRef.current = null;
            var record = recordRef.current;
            if (record) tryGiveFocus(record);
        });
    }, [
        tryGiveFocus
    ]);
    var tryRecordFocus = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function tryRecordFocus(id) {
        recordRef.current = null;
        var focused = document.activeElement;
        if (!focused) return;
        if (focused.getAttribute($83a769edb27eac89$var$dragHandle.draggableId) !== id) return;
        recordRef.current = id;
    }, []);
    $83a769edb27eac89$var$useIsomorphicLayoutEffect(function() {
        isMountedRef.current = true;
        return function clearFrameOnUnmount() {
            isMountedRef.current = false;
            var frameId = restoreFocusFrameRef.current;
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, []);
    var marshal = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            register: register,
            tryRecordFocus: tryRecordFocus,
            tryRestoreFocusRecorded: tryRestoreFocusRecorded,
            tryShiftRecord: tryShiftRecord
        };
    }, [
        register,
        tryRecordFocus,
        tryRestoreFocusRecorded,
        tryShiftRecord
    ]);
    return marshal;
}
function $83a769edb27eac89$var$createRegistry() {
    var entries = {
        draggables: {},
        droppables: {}
    };
    var subscribers = [];
    function subscribe(cb) {
        subscribers.push(cb);
        return function unsubscribe() {
            var index = subscribers.indexOf(cb);
            if (index === -1) return;
            subscribers.splice(index, 1);
        };
    }
    function notify(event) {
        if (subscribers.length) subscribers.forEach(function(cb) {
            return cb(event);
        });
    }
    function findDraggableById(id) {
        return entries.draggables[id] || null;
    }
    function getDraggableById(id) {
        var entry = findDraggableById(id);
        !entry && $83a769edb27eac89$var$invariant(false);
        return entry;
    }
    var draggableAPI = {
        register: function register(entry) {
            entries.draggables[entry.descriptor.id] = entry;
            notify({
                type: 'ADDITION',
                value: entry
            });
        },
        update: function update(entry, last) {
            var current = entries.draggables[last.descriptor.id];
            if (!current) return;
            if (current.uniqueId !== entry.uniqueId) return;
            delete entries.draggables[last.descriptor.id];
            entries.draggables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var draggableId = entry.descriptor.id;
            var current = findDraggableById(draggableId);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.draggables[draggableId];
            notify({
                type: 'REMOVAL',
                value: entry
            });
        },
        getById: getDraggableById,
        findById: findDraggableById,
        exists: function exists(id) {
            return Boolean(findDraggableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $83a769edb27eac89$var$values(entries.draggables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function findDroppableById(id) {
        return entries.droppables[id] || null;
    }
    function getDroppableById(id) {
        var entry = findDroppableById(id);
        !entry && $83a769edb27eac89$var$invariant(false);
        return entry;
    }
    var droppableAPI = {
        register: function register(entry) {
            entries.droppables[entry.descriptor.id] = entry;
        },
        unregister: function unregister(entry) {
            var current = findDroppableById(entry.descriptor.id);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.droppables[entry.descriptor.id];
        },
        getById: getDroppableById,
        findById: findDroppableById,
        exists: function exists(id) {
            return Boolean(findDroppableById(id));
        },
        getAllByType: function getAllByType(type) {
            return $83a769edb27eac89$var$values(entries.droppables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function clean() {
        entries.draggables = {};
        entries.droppables = {};
        subscribers.length = 0;
    }
    return {
        draggable: draggableAPI,
        droppable: droppableAPI,
        subscribe: subscribe,
        clean: clean
    };
}
function $83a769edb27eac89$var$useRegistry() {
    var registry = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)($83a769edb27eac89$var$createRegistry, []);
    (0, $ieT14.useEffect)(function() {
        return function unmount() {
            requestAnimationFrame(registry.clean);
        };
    }, [
        registry
    ]);
    return registry;
}
var $83a769edb27eac89$var$StoreContext = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createContext(null);
var $83a769edb27eac89$var$getBodyElement = function() {
    var body = document.body;
    !body && $83a769edb27eac89$var$invariant(false);
    return body;
};
var $83a769edb27eac89$var$visuallyHidden = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: '-1px',
    border: '0',
    padding: '0',
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    'clip-path': 'inset(100%)'
};
var $83a769edb27eac89$var$getId = function getId(contextId) {
    return "rbd-announcement-" + contextId;
};
function $83a769edb27eac89$var$useAnnouncer(contextId) {
    var id = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return $83a769edb27eac89$var$getId(contextId);
    }, [
        contextId
    ]);
    var ref = (0, $ieT14.useRef)(null);
    (0, $ieT14.useEffect)(function setup() {
        var el = document.createElement('div');
        ref.current = el;
        el.id = id;
        el.setAttribute('aria-live', 'assertive');
        el.setAttribute('role', 'log');
        el.setAttribute('aria-atomic', 'true');
        (0, (/*@__PURE__*/$parcel$interopDefault($0f31be94f80b080a$exports)))(el.style, $83a769edb27eac89$var$visuallyHidden);
        $83a769edb27eac89$var$getBodyElement().appendChild(el);
        return function cleanup() {
            setTimeout(function remove() {
                $83a769edb27eac89$var$getBodyElement().removeChild(el);
                if (el === ref.current) ref.current = null;
            });
        };
    }, [
        id
    ]);
    var announce = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(message) {
        var el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
var $83a769edb27eac89$var$getId$1 = function getId(contextId) {
    return "rbd-lift-instruction-" + contextId;
};
function $83a769edb27eac89$var$useLiftInstruction(contextId, liftInstruction) {
    var id = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return $83a769edb27eac89$var$getId$1(contextId);
    }, [
        contextId
    ]);
    (0, $ieT14.useEffect)(function mount() {
        var el = document.createElement('div');
        el.id = id;
        el.textContent = liftInstruction;
        (0, (/*@__PURE__*/$parcel$interopDefault($0f31be94f80b080a$exports)))(el.style, {
            display: 'none'
        });
        $83a769edb27eac89$var$getBodyElement().appendChild(el);
        return function unmount() {
            $83a769edb27eac89$var$getBodyElement().removeChild(el);
        };
    }, [
        id,
        liftInstruction
    ]);
    return id;
}
var $83a769edb27eac89$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createContext(null);
var $83a769edb27eac89$var$peerDependencies = {
    react: "^16.8.5",
    "react-dom": "^16.8.5"
};
var $83a769edb27eac89$var$semver = /(\d+)\.(\d+)\.(\d+)/;
var $83a769edb27eac89$var$getVersion = function getVersion(value) {
    var result = $83a769edb27eac89$var$semver.exec(value);
    !(result != null) && $83a769edb27eac89$var$invariant(false);
    var major = Number(result[1]);
    var minor = Number(result[2]);
    var patch = Number(result[3]);
    return {
        major: major,
        minor: minor,
        patch: patch,
        raw: value
    };
};
var $83a769edb27eac89$var$isSatisfied = function isSatisfied(expected, actual) {
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var $83a769edb27eac89$var$checkReactVersion = function(peerDepValue, actualValue) {
    var peerDep = $83a769edb27eac89$var$getVersion(peerDepValue);
    var actual = $83a769edb27eac89$var$getVersion(actualValue);
    if ($83a769edb27eac89$var$isSatisfied(peerDep, actual)) return;
};
var $83a769edb27eac89$var$suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var $83a769edb27eac89$var$checkDoctype = function(doc) {
    var doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function $83a769edb27eac89$var$useDev(useHook) {}
function $83a769edb27eac89$var$useDevSetupWarning(fn, inputs) {
    $83a769edb27eac89$var$useDev(function() {
        (0, $ieT14.useEffect)(function() {
            try {
                fn();
            } catch (e) {
                $83a769edb27eac89$var$error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
            }
        }, inputs);
    });
}
function $83a769edb27eac89$var$useStartupValidation() {
    $83a769edb27eac89$var$useDevSetupWarning(function() {
        $83a769edb27eac89$var$checkReactVersion($83a769edb27eac89$var$peerDependencies.react, (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).version);
        $83a769edb27eac89$var$checkDoctype(document);
    }, []);
}
function $83a769edb27eac89$var$usePrevious(current) {
    var ref = (0, $ieT14.useRef)(current);
    (0, $ieT14.useEffect)(function() {
        ref.current = current;
    });
    return ref;
}
function $83a769edb27eac89$var$create() {
    var lock = null;
    function isClaimed() {
        return Boolean(lock);
    }
    function isActive(value) {
        return value === lock;
    }
    function claim(abandon) {
        !!lock && $83a769edb27eac89$var$invariant(false);
        var newLock = {
            abandon: abandon
        };
        lock = newLock;
        return newLock;
    }
    function release() {
        !lock && $83a769edb27eac89$var$invariant(false);
        lock = null;
    }
    function tryAbandon() {
        if (lock) {
            lock.abandon();
            release();
        }
    }
    return {
        isClaimed: isClaimed,
        isActive: isActive,
        claim: claim,
        release: release,
        tryAbandon: tryAbandon
    };
}
var $83a769edb27eac89$var$tab = 9;
var $83a769edb27eac89$var$enter = 13;
var $83a769edb27eac89$var$escape = 27;
var $83a769edb27eac89$var$space = 32;
var $83a769edb27eac89$var$pageUp = 33;
var $83a769edb27eac89$var$pageDown = 34;
var $83a769edb27eac89$var$end = 35;
var $83a769edb27eac89$var$home = 36;
var $83a769edb27eac89$var$arrowLeft = 37;
var $83a769edb27eac89$var$arrowUp = 38;
var $83a769edb27eac89$var$arrowRight = 39;
var $83a769edb27eac89$var$arrowDown = 40;
var $83a769edb27eac89$var$_preventedKeys;
var $83a769edb27eac89$var$preventedKeys = ($83a769edb27eac89$var$_preventedKeys = {}, $83a769edb27eac89$var$_preventedKeys[$83a769edb27eac89$var$enter] = true, $83a769edb27eac89$var$_preventedKeys[$83a769edb27eac89$var$tab] = true, $83a769edb27eac89$var$_preventedKeys);
var $83a769edb27eac89$var$preventStandardKeyEvents = function(event) {
    if ($83a769edb27eac89$var$preventedKeys[event.keyCode]) event.preventDefault();
};
var $83a769edb27eac89$var$supportedEventName = function() {
    var base = 'visibilitychange';
    if (typeof document === 'undefined') return base;
    var candidates = [
        base,
        "ms" + base,
        "webkit" + base,
        "moz" + base,
        "o" + base
    ];
    var supported = $83a769edb27eac89$var$find(candidates, function(eventName) {
        return "on" + eventName in document;
    });
    return supported || base;
}();
var $83a769edb27eac89$var$primaryButton = 0;
var $83a769edb27eac89$var$sloppyClickThreshold = 5;
function $83a769edb27eac89$var$isSloppyClickThresholdExceeded(original, current) {
    return Math.abs(current.x - original.x) >= $83a769edb27eac89$var$sloppyClickThreshold || Math.abs(current.y - original.y) >= $83a769edb27eac89$var$sloppyClickThreshold;
}
var $83a769edb27eac89$var$idle$1 = {
    type: 'IDLE'
};
function $83a769edb27eac89$var$getCaptureBindings(_ref) {
    var cancel = _ref.cancel, completed = _ref.completed, getPhase = _ref.getPhase, setPhase = _ref.setPhase;
    return [
        {
            eventName: 'mousemove',
            fn: function fn(event) {
                var button = event.button, clientX = event.clientX, clientY = event.clientY;
                if (button !== $83a769edb27eac89$var$primaryButton) return;
                var point = {
                    x: clientX,
                    y: clientY
                };
                var phase = getPhase();
                if (phase.type === 'DRAGGING') {
                    event.preventDefault();
                    phase.actions.move(point);
                    return;
                }
                !(phase.type === 'PENDING') && $83a769edb27eac89$var$invariant(false);
                var pending = phase.point;
                if (!$83a769edb27eac89$var$isSloppyClickThresholdExceeded(pending, point)) return;
                event.preventDefault();
                var actions = phase.actions.fluidLift(point);
                setPhase({
                    type: 'DRAGGING',
                    actions: actions
                });
            }
        },
        {
            eventName: 'mouseup',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'mousedown',
            fn: function fn(event) {
                if (getPhase().type === 'DRAGGING') event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'keydown',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type === 'PENDING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $83a769edb27eac89$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                $83a769edb27eac89$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'scroll',
            options: {
                passive: true,
                capture: false
            },
            fn: function fn() {
                if (getPhase().type === 'PENDING') cancel();
            }
        },
        {
            eventName: 'webkitmouseforcedown',
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== 'IDLE') && $83a769edb27eac89$var$invariant(false);
                if (phase.actions.shouldRespectForcePress()) {
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $83a769edb27eac89$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $83a769edb27eac89$var$useMouseSensor(api) {
    var phaseRef = (0, $ieT14.useRef)($83a769edb27eac89$var$idle$1);
    var unbindEventsRef = (0, $ieT14.useRef)($83a769edb27eac89$var$noop);
    var startCaptureBinding = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            eventName: 'mousedown',
            fn: function onMouseDown(event) {
                if (event.defaultPrevented) return;
                if (event.button !== $83a769edb27eac89$var$primaryButton) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                event.preventDefault();
                var point = {
                    x: event.clientX,
                    y: event.clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var preventForcePressBinding = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            eventName: 'webkitmouseforcewillbegin',
            fn: function fn(event) {
                if (event.defaultPrevented) return;
                var id = api.findClosestDraggableId(event);
                if (!id) return;
                var options = api.findOptionsForDraggable(id);
                if (!options) return;
                if (options.shouldRespectForcePress) return;
                if (!api.canGetLock(id)) return;
                event.preventDefault();
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function listenForCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $83a769edb27eac89$var$bindEvents(window, [
            preventForcePressBinding,
            startCaptureBinding
        ], options);
    }, [
        preventForcePressBinding,
        startCaptureBinding
    ]);
    var stop = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        var current = phaseRef.current;
        if (current.type === 'IDLE') return;
        phaseRef.current = $83a769edb27eac89$var$idle$1;
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture
    ]);
    var cancel = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var bindings = $83a769edb27eac89$var$getCaptureBindings({
            cancel: cancel,
            completed: stop,
            getPhase: function getPhase() {
                return phaseRef.current;
            },
            setPhase: function setPhase(phase) {
                phaseRef.current = phase;
            }
        });
        unbindEventsRef.current = $83a769edb27eac89$var$bindEvents(window, bindings, options);
    }, [
        cancel,
        stop
    ]);
    var startPendingDrag = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function startPendingDrag(actions, point) {
        !(phaseRef.current.type === 'IDLE') && $83a769edb27eac89$var$invariant(false);
        phaseRef.current = {
            type: 'PENDING',
            point: point,
            actions: actions
        };
        bindCapturingEvents();
    }, [
        bindCapturingEvents
    ]);
    $83a769edb27eac89$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $83a769edb27eac89$var$_scrollJumpKeys;
function $83a769edb27eac89$var$noop$1() {}
var $83a769edb27eac89$var$scrollJumpKeys = ($83a769edb27eac89$var$_scrollJumpKeys = {}, $83a769edb27eac89$var$_scrollJumpKeys[$83a769edb27eac89$var$pageDown] = true, $83a769edb27eac89$var$_scrollJumpKeys[$83a769edb27eac89$var$pageUp] = true, $83a769edb27eac89$var$_scrollJumpKeys[$83a769edb27eac89$var$home] = true, $83a769edb27eac89$var$_scrollJumpKeys[$83a769edb27eac89$var$end] = true, $83a769edb27eac89$var$_scrollJumpKeys);
function $83a769edb27eac89$var$getDraggingBindings(actions, stop) {
    function cancel() {
        stop();
        actions.cancel();
    }
    function drop() {
        stop();
        actions.drop();
    }
    return [
        {
            eventName: 'keydown',
            fn: function fn(event) {
                if (event.keyCode === $83a769edb27eac89$var$escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                if (event.keyCode === $83a769edb27eac89$var$space) {
                    event.preventDefault();
                    drop();
                    return;
                }
                if (event.keyCode === $83a769edb27eac89$var$arrowDown) {
                    event.preventDefault();
                    actions.moveDown();
                    return;
                }
                if (event.keyCode === $83a769edb27eac89$var$arrowUp) {
                    event.preventDefault();
                    actions.moveUp();
                    return;
                }
                if (event.keyCode === $83a769edb27eac89$var$arrowRight) {
                    event.preventDefault();
                    actions.moveRight();
                    return;
                }
                if (event.keyCode === $83a769edb27eac89$var$arrowLeft) {
                    event.preventDefault();
                    actions.moveLeft();
                    return;
                }
                if ($83a769edb27eac89$var$scrollJumpKeys[event.keyCode]) {
                    event.preventDefault();
                    return;
                }
                $83a769edb27eac89$var$preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'mousedown',
            fn: cancel
        },
        {
            eventName: 'mouseup',
            fn: cancel
        },
        {
            eventName: 'click',
            fn: cancel
        },
        {
            eventName: 'touchstart',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'wheel',
            fn: cancel,
            options: {
                passive: true
            }
        },
        {
            eventName: $83a769edb27eac89$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $83a769edb27eac89$var$useKeyboardSensor(api) {
    var unbindEventsRef = (0, $ieT14.useRef)($83a769edb27eac89$var$noop$1);
    var startCaptureBinding = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            eventName: 'keydown',
            fn: function onKeyDown(event) {
                if (event.defaultPrevented) return;
                if (event.keyCode !== $83a769edb27eac89$var$space) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var preDrag = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!preDrag) return;
                event.preventDefault();
                var isCapturing = true;
                var actions = preDrag.snapLift();
                unbindEventsRef.current();
                function stop() {
                    !isCapturing && $83a769edb27eac89$var$invariant(false);
                    isCapturing = false;
                    unbindEventsRef.current();
                    listenForCapture();
                }
                unbindEventsRef.current = $83a769edb27eac89$var$bindEvents(window, $83a769edb27eac89$var$getDraggingBindings(actions, stop), {
                    capture: true,
                    passive: false
                });
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function tryStartCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = $83a769edb27eac89$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    $83a769edb27eac89$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var $83a769edb27eac89$var$idle$2 = {
    type: 'IDLE'
};
var $83a769edb27eac89$var$timeForLongPress = 120;
var $83a769edb27eac89$var$forcePressThreshold = 0.15;
function $83a769edb27eac89$var$getWindowBindings(_ref) {
    var cancel = _ref.cancel, getPhase = _ref.getPhase;
    return [
        {
            eventName: 'orientationchange',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'contextmenu',
            fn: function fn(event) {
                event.preventDefault();
            }
        },
        {
            eventName: 'keydown',
            fn: function fn(event) {
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                if (event.keyCode === $83a769edb27eac89$var$escape) event.preventDefault();
                cancel();
            }
        },
        {
            eventName: $83a769edb27eac89$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $83a769edb27eac89$var$getHandleBindings(_ref2) {
    var cancel = _ref2.cancel, completed = _ref2.completed, getPhase = _ref2.getPhase;
    return [
        {
            eventName: 'touchmove',
            options: {
                capture: false
            },
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                phase.hasMoved = true;
                var _event$touches$ = event.touches[0], clientX = _event$touches$.clientX, clientY = _event$touches$.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                event.preventDefault();
                phase.actions.move(point);
            }
        },
        {
            eventName: 'touchend',
            fn: function fn(event) {
                var phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'touchcancel',
            fn: function fn(event) {
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'touchforcechange',
            fn: function fn(event) {
                var phase = getPhase();
                !(phase.type !== 'IDLE') && $83a769edb27eac89$var$invariant(false);
                var touch = event.touches[0];
                if (!touch) return;
                var isForcePress = touch.force >= $83a769edb27eac89$var$forcePressThreshold;
                if (!isForcePress) return;
                var shouldRespect = phase.actions.shouldRespectForcePress();
                if (phase.type === 'PENDING') {
                    if (shouldRespect) cancel();
                    return;
                }
                if (shouldRespect) {
                    if (phase.hasMoved) {
                        event.preventDefault();
                        return;
                    }
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: $83a769edb27eac89$var$supportedEventName,
            fn: cancel
        }
    ];
}
function $83a769edb27eac89$var$useMouseSensor$1(api) {
    var phaseRef = (0, $ieT14.useRef)($83a769edb27eac89$var$idle$2);
    var unbindEventsRef = (0, $ieT14.useRef)($83a769edb27eac89$var$noop);
    var getPhase = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function getPhase() {
        return phaseRef.current;
    }, []);
    var setPhase = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function setPhase(phase) {
        phaseRef.current = phase;
    }, []);
    var startCaptureBinding = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            eventName: 'touchstart',
            fn: function onTouchStart(event) {
                if (event.defaultPrevented) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                var touch = event.touches[0];
                var clientX = touch.clientX, clientY = touch.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function listenForCapture() {
        var options = {
            capture: true,
            passive: false
        };
        unbindEventsRef.current = $83a769edb27eac89$var$bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    var stop = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        var current = phaseRef.current;
        if (current.type === 'IDLE') return;
        if (current.type === 'PENDING') clearTimeout(current.longPressTimerId);
        setPhase($83a769edb27eac89$var$idle$2);
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture,
        setPhase
    ]);
    var cancel = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var args = {
            cancel: cancel,
            completed: stop,
            getPhase: getPhase
        };
        var unbindTarget = $83a769edb27eac89$var$bindEvents(window, $83a769edb27eac89$var$getHandleBindings(args), options);
        var unbindWindow = $83a769edb27eac89$var$bindEvents(window, $83a769edb27eac89$var$getWindowBindings(args), options);
        unbindEventsRef.current = function unbindAll() {
            unbindTarget();
            unbindWindow();
        };
    }, [
        cancel,
        getPhase,
        stop
    ]);
    var startDragging = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function startDragging() {
        var phase = getPhase();
        !(phase.type === 'PENDING') && $83a769edb27eac89$var$invariant(false);
        var actions = phase.actions.fluidLift(phase.point);
        setPhase({
            type: 'DRAGGING',
            actions: actions,
            hasMoved: false
        });
    }, [
        getPhase,
        setPhase
    ]);
    var startPendingDrag = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function startPendingDrag(actions, point) {
        !(getPhase().type === 'IDLE') && $83a769edb27eac89$var$invariant(false);
        var longPressTimerId = setTimeout(startDragging, $83a769edb27eac89$var$timeForLongPress);
        setPhase({
            type: 'PENDING',
            point: point,
            actions: actions,
            longPressTimerId: longPressTimerId
        });
        bindCapturingEvents();
    }, [
        bindCapturingEvents,
        getPhase,
        setPhase,
        startDragging
    ]);
    $83a769edb27eac89$var$useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
            var phase = getPhase();
            if (phase.type === 'PENDING') {
                clearTimeout(phase.longPressTimerId);
                setPhase($83a769edb27eac89$var$idle$2);
            }
        };
    }, [
        getPhase,
        listenForCapture,
        setPhase
    ]);
    $83a769edb27eac89$var$useIsomorphicLayoutEffect(function webkitHack() {
        var unbind = $83a769edb27eac89$var$bindEvents(window, [
            {
                eventName: 'touchmove',
                fn: function fn() {},
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
}
function $83a769edb27eac89$var$useValidateSensorHooks(sensorHooks) {
    $83a769edb27eac89$var$useDev(function() {
        var previousRef = $83a769edb27eac89$var$usePrevious(sensorHooks);
        $83a769edb27eac89$var$useDevSetupWarning(function() {
            !(previousRef.current.length === sensorHooks.length) && $83a769edb27eac89$var$invariant(false);
        });
    });
}
var $83a769edb27eac89$var$interactiveTagNames = {
    input: true,
    button: true,
    textarea: true,
    select: true,
    option: true,
    optgroup: true,
    video: true,
    audio: true
};
function $83a769edb27eac89$var$isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    var hasAnInteractiveTag = Boolean($83a769edb27eac89$var$interactiveTagNames[current.tagName.toLowerCase()]);
    if (hasAnInteractiveTag) return true;
    var attribute = current.getAttribute('contenteditable');
    if (attribute === 'true' || attribute === '') return true;
    if (current === parent) return false;
    return $83a769edb27eac89$var$isAnInteractiveElement(parent, current.parentElement);
}
function $83a769edb27eac89$var$isEventInInteractiveElement(draggable, event) {
    var target = event.target;
    if (!$83a769edb27eac89$var$isHtmlElement(target)) return false;
    return $83a769edb27eac89$var$isAnInteractiveElement(draggable, target);
}
var $83a769edb27eac89$var$getBorderBoxCenterPosition = function(el) {
    return (0, $b703e4029dc36ed5$export$4b834cebd9e5cebe)(el.getBoundingClientRect()).center;
};
function $83a769edb27eac89$var$isElement(el) {
    return el instanceof $83a769edb27eac89$var$getWindowFromEl(el).Element;
}
var $83a769edb27eac89$var$supportedMatchesName = function() {
    var base = 'matches';
    if (typeof document === 'undefined') return base;
    var candidates = [
        base,
        'msMatchesSelector',
        'webkitMatchesSelector'
    ];
    var value = $83a769edb27eac89$var$find(candidates, function(name) {
        return name in Element.prototype;
    });
    return value || base;
}();
function $83a769edb27eac89$var$closestPonyfill(el, selector) {
    if (el == null) return null;
    if (el[$83a769edb27eac89$var$supportedMatchesName](selector)) return el;
    return $83a769edb27eac89$var$closestPonyfill(el.parentElement, selector);
}
function $83a769edb27eac89$var$closest$1(el, selector) {
    if (el.closest) return el.closest(selector);
    return $83a769edb27eac89$var$closestPonyfill(el, selector);
}
function $83a769edb27eac89$var$getSelector(contextId) {
    return "[" + $83a769edb27eac89$var$dragHandle.contextId + "=\"" + contextId + "\"]";
}
function $83a769edb27eac89$var$findClosestDragHandleFromEvent(contextId, event) {
    var target = event.target;
    if (!$83a769edb27eac89$var$isElement(target)) return null;
    var selector = $83a769edb27eac89$var$getSelector(contextId);
    var handle = $83a769edb27eac89$var$closest$1(target, selector);
    if (!handle) return null;
    if (!$83a769edb27eac89$var$isHtmlElement(handle)) return null;
    return handle;
}
function $83a769edb27eac89$var$tryGetClosestDraggableIdFromEvent(contextId, event) {
    var handle = $83a769edb27eac89$var$findClosestDragHandleFromEvent(contextId, event);
    if (!handle) return null;
    return handle.getAttribute($83a769edb27eac89$var$dragHandle.draggableId);
}
function $83a769edb27eac89$var$findDraggable(contextId, draggableId) {
    var selector = "[" + $83a769edb27eac89$var$draggable.contextId + "=\"" + contextId + "\"]";
    var possible = $83a769edb27eac89$var$toArray(document.querySelectorAll(selector));
    var draggable$1 = $83a769edb27eac89$var$find(possible, function(el) {
        return el.getAttribute($83a769edb27eac89$var$draggable.id) === draggableId;
    });
    if (!draggable$1) return null;
    if (!$83a769edb27eac89$var$isHtmlElement(draggable$1)) return null;
    return draggable$1;
}
function $83a769edb27eac89$var$preventDefault(event) {
    event.preventDefault();
}
function $83a769edb27eac89$var$_isActive(_ref) {
    var expected = _ref.expected, phase = _ref.phase, isLockActive = _ref.isLockActive, shouldWarn = _ref.shouldWarn;
    if (!isLockActive()) {
        shouldWarn;
        return false;
    }
    if (expected !== phase) {
        shouldWarn;
        return false;
    }
    return true;
}
function $83a769edb27eac89$var$canStart(_ref2) {
    var lockAPI = _ref2.lockAPI, store = _ref2.store, registry = _ref2.registry, draggableId = _ref2.draggableId;
    if (lockAPI.isClaimed()) return false;
    var entry = registry.draggable.findById(draggableId);
    if (!entry) return false;
    if (!entry.options.isEnabled) return false;
    if (!$83a769edb27eac89$var$canStartDrag(store.getState(), draggableId)) return false;
    return true;
}
function $83a769edb27eac89$var$tryStart(_ref3) {
    var lockAPI = _ref3.lockAPI, contextId = _ref3.contextId, store = _ref3.store, registry = _ref3.registry, draggableId = _ref3.draggableId, forceSensorStop = _ref3.forceSensorStop, sourceEvent = _ref3.sourceEvent;
    var shouldStart = $83a769edb27eac89$var$canStart({
        lockAPI: lockAPI,
        store: store,
        registry: registry,
        draggableId: draggableId
    });
    if (!shouldStart) return null;
    var entry = registry.draggable.getById(draggableId);
    var el = $83a769edb27eac89$var$findDraggable(contextId, entry.descriptor.id);
    if (!el) return null;
    if (sourceEvent && !entry.options.canDragInteractiveElements && $83a769edb27eac89$var$isEventInInteractiveElement(el, sourceEvent)) return null;
    var lock = lockAPI.claim(forceSensorStop || $83a769edb27eac89$var$noop);
    var phase = 'PRE_DRAG';
    function getShouldRespectForcePress() {
        return entry.options.shouldRespectForcePress;
    }
    function isLockActive() {
        return lockAPI.isActive(lock);
    }
    function tryDispatch(expected, getAction) {
        if ($83a769edb27eac89$var$_isActive({
            expected: expected,
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        })) store.dispatch(getAction());
    }
    var tryDispatchWhenDragging = tryDispatch.bind(this, 'DRAGGING');
    function lift$1(args) {
        function completed() {
            lockAPI.release();
            phase = 'COMPLETED';
        }
        if (phase !== 'PRE_DRAG') {
            completed();
            !(phase === 'PRE_DRAG') && $83a769edb27eac89$var$invariant(false);
        }
        store.dispatch($83a769edb27eac89$var$lift(args.liftActionArgs));
        phase = 'DRAGGING';
        function finish(reason, options) {
            if (options === void 0) options = {
                shouldBlockNextClick: false
            };
            args.cleanup();
            if (options.shouldBlockNextClick) {
                var unbind = $83a769edb27eac89$var$bindEvents(window, [
                    {
                        eventName: 'click',
                        fn: $83a769edb27eac89$var$preventDefault,
                        options: {
                            once: true,
                            passive: false,
                            capture: true
                        }
                    }
                ]);
                setTimeout(unbind);
            }
            completed();
            store.dispatch($83a769edb27eac89$var$drop({
                reason: reason
            }));
        }
        return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({
            isActive: function isActive() {
                return $83a769edb27eac89$var$_isActive({
                    expected: 'DRAGGING',
                    phase: phase,
                    isLockActive: isLockActive,
                    shouldWarn: false
                });
            },
            shouldRespectForcePress: getShouldRespectForcePress,
            drop: function drop(options) {
                return finish('DROP', options);
            },
            cancel: function cancel(options) {
                return finish('CANCEL', options);
            }
        }, args.actions);
    }
    function fluidLift(clientSelection) {
        var move$1 = (0, $3a3632abf48ab519$export$2e2bcd8739ae039)(function(client) {
            tryDispatchWhenDragging(function() {
                return $83a769edb27eac89$var$move({
                    client: client
                });
            });
        });
        var api = lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: clientSelection,
                movementMode: 'FLUID'
            },
            cleanup: function cleanup() {
                return move$1.cancel();
            },
            actions: {
                move: move$1
            }
        });
        return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, api, {
            move: move$1
        });
    }
    function snapLift() {
        var actions = {
            moveUp: function moveUp$1() {
                return tryDispatchWhenDragging($83a769edb27eac89$var$moveUp);
            },
            moveRight: function moveRight$1() {
                return tryDispatchWhenDragging($83a769edb27eac89$var$moveRight);
            },
            moveDown: function moveDown$1() {
                return tryDispatchWhenDragging($83a769edb27eac89$var$moveDown);
            },
            moveLeft: function moveLeft$1() {
                return tryDispatchWhenDragging($83a769edb27eac89$var$moveLeft);
            }
        };
        return lift$1({
            liftActionArgs: {
                id: draggableId,
                clientSelection: $83a769edb27eac89$var$getBorderBoxCenterPosition(el),
                movementMode: 'SNAP'
            },
            cleanup: $83a769edb27eac89$var$noop,
            actions: actions
        });
    }
    function abortPreDrag() {
        var shouldRelease = $83a769edb27eac89$var$_isActive({
            expected: 'PRE_DRAG',
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        });
        if (shouldRelease) lockAPI.release();
    }
    var preDrag = {
        isActive: function isActive() {
            return $83a769edb27eac89$var$_isActive({
                expected: 'PRE_DRAG',
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: false
            });
        },
        shouldRespectForcePress: getShouldRespectForcePress,
        fluidLift: fluidLift,
        snapLift: snapLift,
        abort: abortPreDrag
    };
    return preDrag;
}
var $83a769edb27eac89$var$defaultSensors = [
    $83a769edb27eac89$var$useMouseSensor,
    $83a769edb27eac89$var$useKeyboardSensor,
    $83a769edb27eac89$var$useMouseSensor$1
];
function $83a769edb27eac89$var$useSensorMarshal(_ref4) {
    var contextId = _ref4.contextId, store = _ref4.store, registry = _ref4.registry, customSensors = _ref4.customSensors, enableDefaultSensors = _ref4.enableDefaultSensors;
    var useSensors = [].concat(enableDefaultSensors ? $83a769edb27eac89$var$defaultSensors : [], customSensors || []);
    var lockAPI = (0, $ieT14.useState)(function() {
        return $83a769edb27eac89$var$create();
    })[0];
    var tryAbandonLock = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function tryAbandonLock(previous, current) {
        if (previous.isDragging && !current.isDragging) lockAPI.tryAbandon();
    }, [
        lockAPI
    ]);
    $83a769edb27eac89$var$useIsomorphicLayoutEffect(function listenToStore() {
        var previous = store.getState();
        var unsubscribe = store.subscribe(function() {
            var current = store.getState();
            tryAbandonLock(previous, current);
            previous = current;
        });
        return unsubscribe;
    }, [
        lockAPI,
        store,
        tryAbandonLock
    ]);
    $83a769edb27eac89$var$useIsomorphicLayoutEffect(function() {
        return lockAPI.tryAbandon;
    }, [
        lockAPI.tryAbandon
    ]);
    var canGetLock = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(draggableId) {
        return $83a769edb27eac89$var$canStart({
            lockAPI: lockAPI,
            registry: registry,
            store: store,
            draggableId: draggableId
        });
    }, [
        lockAPI,
        registry,
        store
    ]);
    var tryGetLock = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(draggableId, forceStop, options) {
        return $83a769edb27eac89$var$tryStart({
            lockAPI: lockAPI,
            registry: registry,
            contextId: contextId,
            store: store,
            draggableId: draggableId,
            forceSensorStop: forceStop,
            sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
        });
    }, [
        contextId,
        lockAPI,
        registry,
        store
    ]);
    var findClosestDraggableId = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(event) {
        return $83a769edb27eac89$var$tryGetClosestDraggableIdFromEvent(contextId, event);
    }, [
        contextId
    ]);
    var findOptionsForDraggable = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(id) {
        var entry = registry.draggable.findById(id);
        return entry ? entry.options : null;
    }, [
        registry.draggable
    ]);
    var tryReleaseLock = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(lockAPI.tryAbandon, [
        lockAPI
    ]);
    var isLockClaimed = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(lockAPI.isClaimed, [
        lockAPI
    ]);
    var api = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            canGetLock: canGetLock,
            tryGetLock: tryGetLock,
            findClosestDraggableId: findClosestDraggableId,
            findOptionsForDraggable: findOptionsForDraggable,
            tryReleaseLock: tryReleaseLock,
            isLockClaimed: isLockClaimed
        };
    }, [
        canGetLock,
        tryGetLock,
        findClosestDraggableId,
        findOptionsForDraggable,
        tryReleaseLock,
        isLockClaimed
    ]);
    $83a769edb27eac89$var$useValidateSensorHooks(useSensors);
    for(var i = 0; i < useSensors.length; i++)useSensors[i](api);
}
var $83a769edb27eac89$var$createResponders = function createResponders(props) {
    return {
        onBeforeCapture: props.onBeforeCapture,
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    };
};
function $83a769edb27eac89$var$getStore(lazyRef) {
    !lazyRef.current && $83a769edb27eac89$var$invariant(false);
    return lazyRef.current;
}
function $83a769edb27eac89$var$App(props) {
    var contextId = props.contextId, setCallbacks = props.setCallbacks, sensors = props.sensors, nonce = props.nonce, liftInstruction = props.liftInstruction;
    var lazyStoreRef = (0, $ieT14.useRef)(null);
    $83a769edb27eac89$var$useStartupValidation();
    var lastPropsRef = $83a769edb27eac89$var$usePrevious(props);
    var getResponders = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        return $83a769edb27eac89$var$createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    var announce = $83a769edb27eac89$var$useAnnouncer(contextId);
    var liftInstructionId = $83a769edb27eac89$var$useLiftInstruction(contextId, liftInstruction);
    var styleMarshal = $83a769edb27eac89$var$useStyleMarshal(contextId, nonce);
    var lazyDispatch = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(action) {
        $83a769edb27eac89$var$getStore(lazyStoreRef).dispatch(action);
    }, []);
    var marshalCallbacks = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return (0, $7778c83e64d928d5$export$aea084d96e84da92)({
            publishWhileDragging: $83a769edb27eac89$var$publishWhileDragging,
            updateDroppableScroll: $83a769edb27eac89$var$updateDroppableScroll,
            updateDroppableIsEnabled: $83a769edb27eac89$var$updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: $83a769edb27eac89$var$updateDroppableIsCombineEnabled,
            collectionStarting: $83a769edb27eac89$var$collectionStarting
        }, lazyDispatch);
    }, [
        lazyDispatch
    ]);
    var registry = $83a769edb27eac89$var$useRegistry();
    var dimensionMarshal = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return $83a769edb27eac89$var$createDimensionMarshal(registry, marshalCallbacks);
    }, [
        registry,
        marshalCallbacks
    ]);
    var autoScroller = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return $83a769edb27eac89$var$createAutoScroller((0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({
            scrollWindow: $83a769edb27eac89$var$scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable
        }, (0, $7778c83e64d928d5$export$aea084d96e84da92)({
            move: $83a769edb27eac89$var$move
        }, lazyDispatch)));
    }, [
        dimensionMarshal.scrollDroppable,
        lazyDispatch
    ]);
    var focusMarshal = $83a769edb27eac89$var$useFocusMarshal(contextId);
    var store = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return $83a769edb27eac89$var$createStore({
            announce: announce,
            autoScroller: autoScroller,
            dimensionMarshal: dimensionMarshal,
            focusMarshal: focusMarshal,
            getResponders: getResponders,
            styleMarshal: styleMarshal
        });
    }, [
        announce,
        autoScroller,
        dimensionMarshal,
        focusMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    var tryResetStore = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        var current = $83a769edb27eac89$var$getStore(lazyStoreRef);
        var state = current.getState();
        if (state.phase !== 'IDLE') current.dispatch($83a769edb27eac89$var$flush());
    }, []);
    var isDragging = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        var state = $83a769edb27eac89$var$getStore(lazyStoreRef).getState();
        return state.isDragging || state.phase === 'DROP_ANIMATING';
    }, []);
    var appCallbacks = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            isDragging: isDragging,
            tryAbort: tryResetStore
        };
    }, [
        isDragging,
        tryResetStore
    ]);
    setCallbacks(appCallbacks);
    var getCanLift = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(id) {
        return $83a769edb27eac89$var$canStartDrag($83a769edb27eac89$var$getStore(lazyStoreRef).getState(), id);
    }, []);
    var getIsMovementAllowed = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        return $83a769edb27eac89$var$isMovementAllowed($83a769edb27eac89$var$getStore(lazyStoreRef).getState());
    }, []);
    var appContext = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            marshal: dimensionMarshal,
            focus: focusMarshal,
            contextId: contextId,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed,
            liftInstructionId: liftInstructionId,
            registry: registry
        };
    }, [
        contextId,
        dimensionMarshal,
        focusMarshal,
        getCanLift,
        getIsMovementAllowed,
        liftInstructionId,
        registry
    ]);
    $83a769edb27eac89$var$useSensorMarshal({
        contextId: contextId,
        store: store,
        registry: registry,
        customSensors: sensors,
        enableDefaultSensors: props.enableDefaultSensors !== false
    });
    (0, $ieT14.useEffect)(function() {
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($83a769edb27eac89$var$AppContext.Provider, {
        value: appContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement((0, $bea69f7496a97ae0$export$2e2bcd8739ae039), {
        context: $83a769edb27eac89$var$StoreContext,
        store: store
    }, props.children));
}
var $83a769edb27eac89$var$instanceCount = 0;
function $83a769edb27eac89$export$2bfe52350fc0150d() {
    $83a769edb27eac89$var$instanceCount = 0;
}
function $83a769edb27eac89$export$237bd83162c14364(props) {
    var contextId = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return "" + $83a769edb27eac89$var$instanceCount++;
    }, []);
    var liftInstruction = props.liftInstruction || $83a769edb27eac89$var$preset.liftInstruction;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($83a769edb27eac89$var$ErrorBoundary, null, function(setCallbacks) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($83a769edb27eac89$var$App, {
            nonce: props.nonce,
            contextId: contextId,
            setCallbacks: setCallbacks,
            liftInstruction: liftInstruction,
            enableDefaultSensors: props.enableDefaultSensors,
            sensors: props.sensors,
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragUpdate: props.onDragUpdate,
            onDragEnd: props.onDragEnd
        }, props.children);
    });
}
var $83a769edb27eac89$var$isEqual$1 = function isEqual(base) {
    return function(value) {
        return base === value;
    };
};
var $83a769edb27eac89$var$isScroll = $83a769edb27eac89$var$isEqual$1('scroll');
var $83a769edb27eac89$var$isAuto = $83a769edb27eac89$var$isEqual$1('auto');
var $83a769edb27eac89$var$isVisible$1 = $83a769edb27eac89$var$isEqual$1('visible');
var $83a769edb27eac89$var$isEither = function isEither(overflow, fn) {
    return fn(overflow.overflowX) || fn(overflow.overflowY);
};
var $83a769edb27eac89$var$isBoth = function isBoth(overflow, fn) {
    return fn(overflow.overflowX) && fn(overflow.overflowY);
};
var $83a769edb27eac89$var$isElementScrollable = function isElementScrollable(el) {
    var style = window.getComputedStyle(el);
    var overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $83a769edb27eac89$var$isEither(overflow, $83a769edb27eac89$var$isScroll) || $83a769edb27eac89$var$isEither(overflow, $83a769edb27eac89$var$isAuto);
};
var $83a769edb27eac89$var$isBodyScrollable = function isBodyScrollable() {
    var body, html, htmlStyle, htmlOverflow;
    return false;
};
var $83a769edb27eac89$var$getClosestScrollable = function getClosestScrollable(el) {
    if (el == null) return null;
    if (el === document.body) return $83a769edb27eac89$var$isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!$83a769edb27eac89$var$isElementScrollable(el)) return getClosestScrollable(el.parentElement);
    return el;
};
var $83a769edb27eac89$var$checkForNestedScrollContainers = function(scrollable) {
    if (!scrollable) return;
    var anotherScrollParent = $83a769edb27eac89$var$getClosestScrollable(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var $83a769edb27eac89$var$getScroll$1 = function(el) {
    return {
        x: el.scrollLeft,
        y: el.scrollTop
    };
};
var $83a769edb27eac89$var$getIsFixed = function getIsFixed(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.position === 'fixed') return true;
    return getIsFixed(el.parentElement);
};
var $83a769edb27eac89$var$getEnv = function(start) {
    var closestScrollable = $83a769edb27eac89$var$getClosestScrollable(start);
    var isFixedOnPage = $83a769edb27eac89$var$getIsFixed(start);
    return {
        closestScrollable: closestScrollable,
        isFixedOnPage: isFixedOnPage
    };
};
var $83a769edb27eac89$var$getDroppableDimension = function(_ref) {
    var descriptor = _ref.descriptor, isEnabled = _ref.isEnabled, isCombineEnabled = _ref.isCombineEnabled, isFixedOnPage = _ref.isFixedOnPage, direction = _ref.direction, client = _ref.client, page = _ref.page, closest = _ref.closest;
    var frame = function() {
        if (!closest) return null;
        var scrollSize = closest.scrollSize, frameClient = closest.client;
        var maxScroll = $83a769edb27eac89$var$getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient: frameClient,
            scrollSize: scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: $83a769edb27eac89$var$origin,
                    displacement: $83a769edb27eac89$var$origin
                }
            }
        };
    }();
    var axis = direction === 'vertical' ? $83a769edb27eac89$var$vertical : $83a769edb27eac89$var$horizontal;
    var subject = $83a769edb27eac89$var$getSubject({
        page: page,
        withPlaceholder: null,
        axis: axis,
        frame: frame
    });
    var dimension = {
        descriptor: descriptor,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: isFixedOnPage,
        axis: axis,
        isEnabled: isEnabled,
        client: client,
        page: page,
        frame: frame,
        subject: subject
    };
    return dimension;
};
var $83a769edb27eac89$var$getClient = function getClient(targetRef, closestScrollable) {
    var base = (0, $b703e4029dc36ed5$export$34928e660d2a8702)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    var top = base.paddingBox.top - closestScrollable.scrollTop;
    var left = base.paddingBox.left - closestScrollable.scrollLeft;
    var bottom = top + closestScrollable.scrollHeight;
    var right = left + closestScrollable.scrollWidth;
    var paddingBox = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    var borderBox = (0, $b703e4029dc36ed5$export$9f77e0932fb78f72)(paddingBox, base.border);
    var client = (0, $b703e4029dc36ed5$export$6459fc9e86be362e)({
        borderBox: borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var $83a769edb27eac89$var$getDimension = function(_ref) {
    var ref = _ref.ref, descriptor = _ref.descriptor, env = _ref.env, windowScroll = _ref.windowScroll, direction = _ref.direction, isDropDisabled = _ref.isDropDisabled, isCombineEnabled = _ref.isCombineEnabled, shouldClipSubject = _ref.shouldClipSubject;
    var closestScrollable = env.closestScrollable;
    var client = $83a769edb27eac89$var$getClient(ref, closestScrollable);
    var page = (0, $b703e4029dc36ed5$export$1d0caec378d7d0ae)(client, windowScroll);
    var closest = function() {
        if (!closestScrollable) return null;
        var frameClient = (0, $b703e4029dc36ed5$export$34928e660d2a8702)(closestScrollable);
        var scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, $b703e4029dc36ed5$export$1d0caec378d7d0ae)(frameClient, windowScroll),
            scroll: $83a769edb27eac89$var$getScroll$1(closestScrollable),
            scrollSize: scrollSize,
            shouldClipSubject: shouldClipSubject
        };
    }();
    var dimension = $83a769edb27eac89$var$getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction: direction,
        client: client,
        page: page,
        closest: closest
    });
    return dimension;
};
var $83a769edb27eac89$var$immediate = {
    passive: false
};
var $83a769edb27eac89$var$delayed = {
    passive: true
};
var $83a769edb27eac89$var$getListenerOptions = function(options) {
    return options.shouldPublishImmediately ? $83a769edb27eac89$var$immediate : $83a769edb27eac89$var$delayed;
};
function $83a769edb27eac89$var$useRequiredContext(Context) {
    var result = (0, $ieT14.useContext)(Context);
    !result && $83a769edb27eac89$var$invariant(false);
    return result;
}
var $83a769edb27eac89$var$count = 0;
function $83a769edb27eac89$var$useUniqueId(prefix) {
    var countRef = (0, $ieT14.useRef)($83a769edb27eac89$var$count++);
    return prefix + "::" + countRef.current;
}
var $83a769edb27eac89$var$getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
    return dragging && dragging.env.closestScrollable || null;
};
function $83a769edb27eac89$var$useDroppablePublisher(args) {
    var whileDraggingRef = (0, $ieT14.useRef)(null);
    var appContext = $83a769edb27eac89$var$useRequiredContext($83a769edb27eac89$var$AppContext);
    var uniqueId = $83a769edb27eac89$var$useUniqueId('droppable');
    var registry = appContext.registry, marshal = appContext.marshal;
    var previousRef = $83a769edb27eac89$var$usePrevious(args);
    var descriptor = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            id: args.droppableId,
            type: args.type,
            mode: args.mode
        };
    }, [
        args.droppableId,
        args.mode,
        args.type
    ]);
    var publishedDescriptorRef = (0, $ieT14.useRef)(descriptor);
    var memoizedUpdateScroll = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(x, y) {
            !whileDraggingRef.current && $83a769edb27eac89$var$invariant(false);
            var scroll = {
                x: x,
                y: y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        });
    }, [
        descriptor.id,
        marshal
    ]);
    var getClosestScroll = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return $83a769edb27eac89$var$origin;
        return $83a769edb27eac89$var$getScroll$1(dragging.env.closestScrollable);
    }, []);
    var updateScroll = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        var scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    var scheduleScrollUpdate = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return (0, $3a3632abf48ab519$export$2e2bcd8739ae039)(updateScroll);
    }, [
        updateScroll
    ]);
    var onClosestScroll = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $83a769edb27eac89$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $83a769edb27eac89$var$invariant(false);
        var options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    var getDimensionAndWatchScroll = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(windowScroll, options) {
        !!whileDraggingRef.current && $83a769edb27eac89$var$invariant(false);
        var previous = previousRef.current;
        var ref = previous.getDroppableRef();
        !ref && $83a769edb27eac89$var$invariant(false);
        var env = $83a769edb27eac89$var$getEnv(ref);
        var dragging = {
            ref: ref,
            descriptor: descriptor,
            env: env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        var dimension = $83a769edb27eac89$var$getDimension({
            ref: ref,
            descriptor: descriptor,
            env: env,
            windowScroll: windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        var scrollable = env.closestScrollable;
        if (scrollable) {
            scrollable.setAttribute($83a769edb27eac89$var$scrollContainer.contextId, appContext.contextId);
            scrollable.addEventListener('scroll', onClosestScroll, $83a769edb27eac89$var$getListenerOptions(dragging.scrollOptions));
        }
        return dimension;
    }, [
        appContext.contextId,
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    var getScrollWhileDragging = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $83a769edb27eac89$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && $83a769edb27eac89$var$invariant(false);
        return $83a769edb27eac89$var$getScroll$1(closest);
    }, []);
    var dragStopped = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        !dragging && $83a769edb27eac89$var$invariant(false);
        var closest = $83a769edb27eac89$var$getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeAttribute($83a769edb27eac89$var$scrollContainer.contextId);
        closest.removeEventListener('scroll', onClosestScroll, $83a769edb27eac89$var$getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    var scroll = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(change) {
        var dragging = whileDraggingRef.current;
        !dragging && $83a769edb27eac89$var$invariant(false);
        var closest = $83a769edb27eac89$var$getClosestScrollableFromDrag(dragging);
        !closest && $83a769edb27eac89$var$invariant(false);
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    var callbacks = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            getDimensionAndWatchScroll: getDimensionAndWatchScroll,
            getScrollWhileDragging: getScrollWhileDragging,
            dragStopped: dragStopped,
            scroll: scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        getScrollWhileDragging,
        scroll
    ]);
    var entry = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            callbacks: callbacks
        };
    }, [
        callbacks,
        descriptor,
        uniqueId
    ]);
    $83a769edb27eac89$var$useIsomorphicLayoutEffect(function() {
        publishedDescriptorRef.current = entry.descriptor;
        registry.droppable.register(entry);
        return function() {
            if (whileDraggingRef.current) dragStopped();
            registry.droppable.unregister(entry);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        entry,
        marshal,
        registry.droppable
    ]);
    $83a769edb27eac89$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    $83a769edb27eac89$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function $83a769edb27eac89$var$noop$2() {}
var $83a769edb27eac89$var$empty = {
    width: 0,
    height: 0,
    margin: $83a769edb27eac89$var$noSpacing
};
var $83a769edb27eac89$var$getSize = function getSize(_ref) {
    var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount, placeholder = _ref.placeholder, animate = _ref.animate;
    if (isAnimatingOpenOnMount) return $83a769edb27eac89$var$empty;
    if (animate === 'close') return $83a769edb27eac89$var$empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
var $83a769edb27eac89$var$getStyle = function getStyle(_ref2) {
    var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount, placeholder = _ref2.placeholder, animate = _ref2.animate;
    var size = $83a769edb27eac89$var$getSize({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        placeholder: placeholder,
        animate: animate
    });
    return {
        display: placeholder.display,
        boxSizing: 'border-box',
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: '0',
        flexGrow: '0',
        pointerEvents: 'none',
        transition: animate !== 'none' ? $83a769edb27eac89$var$transitions.placeholder : null
    };
};
function $83a769edb27eac89$var$Placeholder(props) {
    var animateOpenTimerRef = (0, $ieT14.useRef)(null);
    var tryClearAnimateOpenTimer = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    var animate = props.animate, onTransitionEnd = props.onTransitionEnd, onClose = props.onClose, contextId = props.contextId;
    var _useState = (0, $ieT14.useState)(props.animate === 'open'), isAnimatingOpenOnMount = _useState[0], setIsAnimatingOpenOnMount = _useState[1];
    (0, $ieT14.useEffect)(function() {
        if (!isAnimatingOpenOnMount) return $83a769edb27eac89$var$noop$2;
        if (animate !== 'open') {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return $83a769edb27eac89$var$noop$2;
        }
        if (animateOpenTimerRef.current) return $83a769edb27eac89$var$noop$2;
        animateOpenTimerRef.current = setTimeout(function() {
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    var onSizeChangeEnd = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(event) {
        if (event.propertyName !== 'height') return;
        onTransitionEnd();
        if (animate === 'close') onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    var style = $83a769edb27eac89$var$getStyle({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement(props.placeholder.tagName, {
        style: style,
        'data-rbd-placeholder-context-id': contextId,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
}
var $83a769edb27eac89$var$Placeholder$1 = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).memo($83a769edb27eac89$var$Placeholder);
var $83a769edb27eac89$var$DroppableContext = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createContext(null);
function $83a769edb27eac89$var$checkIsValidInnerRef(el) {
    !(el && $83a769edb27eac89$var$isHtmlElement(el)) && $83a769edb27eac89$var$invariant(false);
}
function $83a769edb27eac89$var$isBoolean(value) {
    return typeof value === 'boolean';
}
function $83a769edb27eac89$var$runChecks(args, checks) {
    checks.forEach(function(check) {
        return check(args);
    });
}
var $83a769edb27eac89$var$shared = [
    function required(_ref) {
        var props = _ref.props;
        !props.droppableId && $83a769edb27eac89$var$invariant(false);
        !(typeof props.droppableId === 'string') && $83a769edb27eac89$var$invariant(false);
    },
    function _boolean(_ref2) {
        var props = _ref2.props;
        !$83a769edb27eac89$var$isBoolean(props.isDropDisabled) && $83a769edb27eac89$var$invariant(false);
        !$83a769edb27eac89$var$isBoolean(props.isCombineEnabled) && $83a769edb27eac89$var$invariant(false);
        !$83a769edb27eac89$var$isBoolean(props.ignoreContainerClipping) && $83a769edb27eac89$var$invariant(false);
    },
    function ref(_ref3) {
        var getDroppableRef = _ref3.getDroppableRef;
        $83a769edb27eac89$var$checkIsValidInnerRef(getDroppableRef());
    }
];
var $83a769edb27eac89$var$standard = [
    function placeholder(_ref4) {
        var props = _ref4.props, getPlaceholderRef = _ref4.getPlaceholderRef;
        if (!props.placeholder) return;
        var ref = getPlaceholderRef();
        if (ref) return;
    }
];
var $83a769edb27eac89$var$virtual = [
    function hasClone(_ref5) {
        var props = _ref5.props;
        !props.renderClone && $83a769edb27eac89$var$invariant(false);
    },
    function hasNoPlaceholder(_ref6) {
        var getPlaceholderRef = _ref6.getPlaceholderRef;
        !!getPlaceholderRef() && $83a769edb27eac89$var$invariant(false);
    }
];
function $83a769edb27eac89$var$useValidation(args) {
    $83a769edb27eac89$var$useDevSetupWarning(function() {
        $83a769edb27eac89$var$runChecks(args, $83a769edb27eac89$var$shared);
        if (args.props.mode === 'standard') $83a769edb27eac89$var$runChecks(args, $83a769edb27eac89$var$standard);
        if (args.props.mode === 'virtual') $83a769edb27eac89$var$runChecks(args, $83a769edb27eac89$var$virtual);
    });
}
var $83a769edb27eac89$var$AnimateInOut = function(_React$PureComponent) {
    (0, $31b5b7cf3016567e$export$2e2bcd8739ae039)(AnimateInOut, _React$PureComponent);
    function AnimateInOut() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$PureComponent.call.apply(_React$PureComponent, [
            this
        ].concat(args)) || this;
        _this.state = {
            isVisible: Boolean(_this.props.on),
            data: _this.props.on,
            animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
        };
        _this.onClose = function() {
            if (_this.state.animate !== 'close') return;
            _this.setState({
                isVisible: false
            });
        };
        return _this;
    }
    AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (!props.shouldAnimate) return {
            isVisible: Boolean(props.on),
            data: props.on,
            animate: 'none'
        };
        if (props.on) return {
            isVisible: true,
            data: props.on,
            animate: 'open'
        };
        if (state.isVisible) return {
            isVisible: true,
            data: state.data,
            animate: 'close'
        };
        return {
            isVisible: false,
            animate: 'close',
            data: null
        };
    };
    var _proto = AnimateInOut.prototype;
    _proto.render = function render() {
        if (!this.state.isVisible) return null;
        var provided = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
        };
        return this.props.children(provided);
    };
    return AnimateInOut;
}((0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).PureComponent);
var $83a769edb27eac89$var$zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
var $83a769edb27eac89$var$getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
    if (dropping) return $83a769edb27eac89$var$transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return $83a769edb27eac89$var$transitions.snap;
    return $83a769edb27eac89$var$transitions.fluid;
};
var $83a769edb27eac89$var$getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
    if (!isCombining) return null;
    return isDropAnimating ? $83a769edb27eac89$var$combine.opacity.drop : $83a769edb27eac89$var$combine.opacity.combining;
};
var $83a769edb27eac89$var$getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === 'SNAP';
};
function $83a769edb27eac89$var$getDraggingStyle(dragging) {
    var dimension = dragging.dimension;
    var box = dimension.client;
    var offset = dragging.offset, combineWith = dragging.combineWith, dropping = dragging.dropping;
    var isCombining = Boolean(combineWith);
    var shouldAnimate = $83a769edb27eac89$var$getShouldDraggingAnimate(dragging);
    var isDropAnimating = Boolean(dropping);
    var transform = isDropAnimating ? $83a769edb27eac89$var$transforms.drop(offset, isCombining) : $83a769edb27eac89$var$transforms.moveTo(offset);
    var style = {
        position: 'fixed',
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: 'border-box',
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: $83a769edb27eac89$var$getDraggingTransition(shouldAnimate, dropping),
        transform: transform,
        opacity: $83a769edb27eac89$var$getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? $83a769edb27eac89$var$zIndexOptions.dropAnimating : $83a769edb27eac89$var$zIndexOptions.dragging,
        pointerEvents: 'none'
    };
    return style;
}
function $83a769edb27eac89$var$getSecondaryStyle(secondary) {
    return {
        transform: $83a769edb27eac89$var$transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? null : 'none'
    };
}
function $83a769edb27eac89$var$getStyle$1(mapped) {
    return mapped.type === 'DRAGGING' ? $83a769edb27eac89$var$getDraggingStyle(mapped) : $83a769edb27eac89$var$getSecondaryStyle(mapped);
}
function $83a769edb27eac89$var$getDimension$1(descriptor, el, windowScroll) {
    if (windowScroll === void 0) windowScroll = $83a769edb27eac89$var$origin;
    var computedStyles = window.getComputedStyle(el);
    var borderBox = el.getBoundingClientRect();
    var client = (0, $b703e4029dc36ed5$export$b8dfc5d4e552b8e1)(borderBox, computedStyles);
    var page = (0, $b703e4029dc36ed5$export$1d0caec378d7d0ae)(client, windowScroll);
    var placeholder = {
        client: client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    var displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    var dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        displaceBy: displaceBy,
        client: client,
        page: page
    };
    return dimension;
}
function $83a769edb27eac89$var$useDraggablePublisher(args) {
    var uniqueId = $83a769edb27eac89$var$useUniqueId('draggable');
    var descriptor = args.descriptor, registry = args.registry, getDraggableRef = args.getDraggableRef, canDragInteractiveElements = args.canDragInteractiveElements, shouldRespectForcePress = args.shouldRespectForcePress, isEnabled = args.isEnabled;
    var options = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            canDragInteractiveElements: canDragInteractiveElements,
            shouldRespectForcePress: shouldRespectForcePress,
            isEnabled: isEnabled
        };
    }, [
        canDragInteractiveElements,
        isEnabled,
        shouldRespectForcePress
    ]);
    var getDimension = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(windowScroll) {
        var el = getDraggableRef();
        !el && $83a769edb27eac89$var$invariant(false);
        return $83a769edb27eac89$var$getDimension$1(descriptor, el, windowScroll);
    }, [
        descriptor,
        getDraggableRef
    ]);
    var entry = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            options: options,
            getDimension: getDimension
        };
    }, [
        descriptor,
        getDimension,
        options,
        uniqueId
    ]);
    var publishedRef = (0, $ieT14.useRef)(entry);
    var isFirstPublishRef = (0, $ieT14.useRef)(true);
    $83a769edb27eac89$var$useIsomorphicLayoutEffect(function() {
        registry.draggable.register(publishedRef.current);
        return function() {
            return registry.draggable.unregister(publishedRef.current);
        };
    }, [
        registry.draggable
    ]);
    $83a769edb27eac89$var$useIsomorphicLayoutEffect(function() {
        if (isFirstPublishRef.current) {
            isFirstPublishRef.current = false;
            return;
        }
        var last = publishedRef.current;
        publishedRef.current = entry;
        registry.draggable.update(entry, last);
    }, [
        entry,
        registry.draggable
    ]);
}
function $83a769edb27eac89$var$useValidation$1(props, contextId, getRef) {
    $83a769edb27eac89$var$useDevSetupWarning(function() {
        function prefix(id) {
            return "Draggable[id: " + id + "]: ";
        }
        var id = props.draggableId;
        !id && $83a769edb27eac89$var$invariant(false);
        !(typeof id === 'string') && $83a769edb27eac89$var$invariant(false);
        !(0, (/*@__PURE__*/$parcel$interopDefault($e28cdd20687c4c2b$exports)))(props.index) && $83a769edb27eac89$var$invariant(false);
        if (props.mapped.type === 'DRAGGING') return;
        $83a769edb27eac89$var$checkIsValidInnerRef(getRef());
        if (props.isEnabled) !$83a769edb27eac89$var$findDragHandle(contextId, id) && $83a769edb27eac89$var$invariant(false);
    });
}
function $83a769edb27eac89$var$useClonePropValidation(isClone) {
    $83a769edb27eac89$var$useDev(function() {
        var initialRef = (0, $ieT14.useRef)(isClone);
        $83a769edb27eac89$var$useDevSetupWarning(function() {
            !(isClone === initialRef.current) && $83a769edb27eac89$var$invariant(false);
        }, [
            isClone
        ]);
    });
}
function $83a769edb27eac89$var$preventHtml5Dnd(event) {
    event.preventDefault();
}
function $83a769edb27eac89$var$Draggable(props) {
    var ref = (0, $ieT14.useRef)(null);
    var setRef = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(el) {
        ref.current = el;
    }, []);
    var getRef = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        return ref.current;
    }, []);
    var _useRequiredContext = $83a769edb27eac89$var$useRequiredContext($83a769edb27eac89$var$AppContext), contextId = _useRequiredContext.contextId, liftInstructionId = _useRequiredContext.liftInstructionId, registry = _useRequiredContext.registry;
    var _useRequiredContext2 = $83a769edb27eac89$var$useRequiredContext($83a769edb27eac89$var$DroppableContext), type = _useRequiredContext2.type, droppableId = _useRequiredContext2.droppableId;
    var descriptor = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            id: props.draggableId,
            index: props.index,
            type: type,
            droppableId: droppableId
        };
    }, [
        props.draggableId,
        props.index,
        type,
        droppableId
    ]);
    var children = props.children, draggableId = props.draggableId, isEnabled = props.isEnabled, shouldRespectForcePress = props.shouldRespectForcePress, canDragInteractiveElements = props.canDragInteractiveElements, isClone = props.isClone, mapped = props.mapped, dropAnimationFinishedAction = props.dropAnimationFinished;
    $83a769edb27eac89$var$useValidation$1(props, contextId, getRef);
    $83a769edb27eac89$var$useClonePropValidation(isClone);
    if (!isClone) {
        var forPublisher = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
            return {
                descriptor: descriptor,
                registry: registry,
                getDraggableRef: getRef,
                canDragInteractiveElements: canDragInteractiveElements,
                shouldRespectForcePress: shouldRespectForcePress,
                isEnabled: isEnabled
            };
        }, [
            descriptor,
            registry,
            getRef,
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        ]);
        $83a769edb27eac89$var$useDraggablePublisher(forPublisher);
    }
    var dragHandleProps = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return isEnabled ? {
            tabIndex: 0,
            'data-rbd-drag-handle-draggable-id': draggableId,
            'data-rbd-drag-handle-context-id': contextId,
            'aria-labelledby': liftInstructionId,
            draggable: false,
            onDragStart: $83a769edb27eac89$var$preventHtml5Dnd
        } : null;
    }, [
        contextId,
        draggableId,
        isEnabled,
        liftInstructionId
    ]);
    var onMoveEnd = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(event) {
        if (mapped.type !== 'DRAGGING') return;
        if (!mapped.dropping) return;
        if (event.propertyName !== 'transform') return;
        dropAnimationFinishedAction();
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    var provided = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        var style = $83a769edb27eac89$var$getStyle$1(mapped);
        var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
        var result = {
            innerRef: setRef,
            draggableProps: {
                'data-rbd-draggable-context-id': contextId,
                'data-rbd-draggable-id': draggableId,
                style: style,
                onTransitionEnd: onTransitionEnd
            },
            dragHandleProps: dragHandleProps
        };
        return result;
    }, [
        contextId,
        dragHandleProps,
        draggableId,
        mapped,
        onMoveEnd,
        setRef
    ]);
    var rubric = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    }, [
        descriptor.droppableId,
        descriptor.id,
        descriptor.index,
        descriptor.type
    ]);
    return children(provided, mapped.snapshot, rubric);
}
var $83a769edb27eac89$var$isStrictEqual = function(a, b) {
    return a === b;
};
var $83a769edb27eac89$var$whatIsDraggedOverFromResult = function(result) {
    var combine = result.combine, destination = result.destination;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
var $83a769edb27eac89$var$getCombineWithFromResult = function getCombineWithFromResult(result) {
    return result.combine ? result.combine.draggableId : null;
};
var $83a769edb27eac89$var$getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
    return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
};
function $83a769edb27eac89$var$getDraggableSelector() {
    var memoizedOffset = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(mode, isClone, draggingOver, combineWith, dropping) {
        return {
            isDragging: true,
            isClone: isClone,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode: mode,
            draggingOver: draggingOver,
            combineWith: combineWith,
            combineTargetFor: null
        };
    });
    var getMemoizedProps = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
        return {
            mapped: {
                type: 'DRAGGING',
                dropping: null,
                draggingOver: draggingOver,
                combineWith: combineWith,
                mode: mode,
                offset: offset,
                dimension: dimension,
                forceShouldAnimate: forceShouldAnimate,
                snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
            }
        };
    });
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            var offset = state.current.client.offset;
            var dimension = state.dimensions.draggables[ownProps.draggableId];
            var draggingOver = $83a769edb27eac89$var$whatIsDraggedOver(state.impact);
            var combineWith = $83a769edb27eac89$var$getCombineWithFromImpact(state.impact);
            var forceShouldAnimate = state.forceShouldAnimate;
            return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            var isClone = ownProps.isClone;
            var _dimension = state.dimensions.draggables[ownProps.draggableId];
            var result = completed.result;
            var mode = result.mode;
            var _draggingOver = $83a769edb27eac89$var$whatIsDraggedOverFromResult(result);
            var _combineWith = $83a769edb27eac89$var$getCombineWithFromResult(result);
            var duration = state.dropDuration;
            var dropping = {
                duration: duration,
                curve: $83a769edb27eac89$var$curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: _combineWith ? $83a769edb27eac89$var$combine.opacity.drop : null,
                scale: _combineWith ? $83a769edb27eac89$var$combine.scale.drop : null
            };
            return {
                mapped: {
                    type: 'DRAGGING',
                    offset: state.newHomeClientOffset,
                    dimension: _dimension,
                    dropping: dropping,
                    draggingOver: _draggingOver,
                    combineWith: _combineWith,
                    mode: mode,
                    forceShouldAnimate: null,
                    snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
                }
            };
        }
        return null;
    };
    return selector;
}
function $83a769edb27eac89$var$getSecondarySnapshot(combineTargetFor) {
    return {
        isDragging: false,
        isDropAnimating: false,
        isClone: false,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor: combineTargetFor,
        combineWith: null
    };
}
var $83a769edb27eac89$var$atRest = {
    mapped: {
        type: 'SECONDARY',
        offset: $83a769edb27eac89$var$origin,
        combineTargetFor: null,
        shouldAnimateDisplacement: true,
        snapshot: $83a769edb27eac89$var$getSecondarySnapshot(null)
    }
};
function $83a769edb27eac89$var$getSecondarySelector() {
    var memoizedOffset = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, $bab2733189173eea$export$2e2bcd8739ae039)($83a769edb27eac89$var$getSecondarySnapshot);
    var getMemoizedProps = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(offset, combineTargetFor, shouldAnimateDisplacement) {
        if (combineTargetFor === void 0) combineTargetFor = null;
        return {
            mapped: {
                type: 'SECONDARY',
                offset: offset,
                combineTargetFor: combineTargetFor,
                shouldAnimateDisplacement: shouldAnimateDisplacement,
                snapshot: getMemoizedSnapshot(combineTargetFor)
            }
        };
    });
    var getFallback = function getFallback(combineTargetFor) {
        return combineTargetFor ? getMemoizedProps($83a769edb27eac89$var$origin, combineTargetFor, true) : null;
    };
    var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
        var visualDisplacement = impact.displaced.visible[ownId];
        var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
        var combine = $83a769edb27eac89$var$tryGetCombine(impact);
        var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
        if (!visualDisplacement) {
            if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            if (impact.displaced.invisible[ownId]) return null;
            var change = $83a769edb27eac89$var$negate(afterCritical.displacedBy.point);
            var _offset = memoizedOffset(change.x, change.y);
            return getMemoizedProps(_offset, combineTargetFor, true);
        }
        if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
        var displaceBy = impact.displacedBy.point;
        var offset = memoizedOffset(displaceBy.x, displaceBy.y);
        return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
    };
    var selector = function selector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
        }
        return null;
    };
    return selector;
}
var $83a769edb27eac89$var$makeMapStateToProps = function makeMapStateToProps() {
    var draggingSelector = $83a769edb27eac89$var$getDraggableSelector();
    var secondarySelector = $83a769edb27eac89$var$getSecondarySelector();
    var selector = function selector(state, ownProps) {
        return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || $83a769edb27eac89$var$atRest;
    };
    return selector;
};
var $83a769edb27eac89$var$mapDispatchToProps = {
    dropAnimationFinished: $83a769edb27eac89$var$dropAnimationFinished
};
var $83a769edb27eac89$var$ConnectedDraggable = (0, $a3b0bcd7a825bc6d$export$2e2bcd8739ae039)($83a769edb27eac89$var$makeMapStateToProps, $83a769edb27eac89$var$mapDispatchToProps, null, {
    context: $83a769edb27eac89$var$StoreContext,
    pure: true,
    areStatePropsEqual: $83a769edb27eac89$var$isStrictEqual
})($83a769edb27eac89$var$Draggable);
function $83a769edb27eac89$var$PrivateDraggable(props) {
    var droppableContext = $83a769edb27eac89$var$useRequiredContext($83a769edb27eac89$var$DroppableContext);
    var isUsingCloneFor = droppableContext.isUsingCloneFor;
    if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($83a769edb27eac89$var$ConnectedDraggable, props);
}
function $83a769edb27eac89$export$f2a139e5d18b9882(props) {
    var isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
    var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
    var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($83a769edb27eac89$var$PrivateDraggable, (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, props, {
        isClone: false,
        isEnabled: isEnabled,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress
    }));
}
function $83a769edb27eac89$var$Droppable(props) {
    var appContext = (0, $ieT14.useContext)($83a769edb27eac89$var$AppContext);
    !appContext && $83a769edb27eac89$var$invariant(false);
    var contextId = appContext.contextId, isMovementAllowed = appContext.isMovementAllowed;
    var droppableRef = (0, $ieT14.useRef)(null);
    var placeholderRef = (0, $ieT14.useRef)(null);
    var children = props.children, droppableId = props.droppableId, type = props.type, mode = props.mode, direction = props.direction, ignoreContainerClipping = props.ignoreContainerClipping, isDropDisabled = props.isDropDisabled, isCombineEnabled = props.isCombineEnabled, snapshot = props.snapshot, useClone = props.useClone, updateViewportMaxScroll = props.updateViewportMaxScroll, getContainerForClone = props.getContainerForClone;
    var getDroppableRef = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        return droppableRef.current;
    }, []);
    var setDroppableRef = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(value) {
        droppableRef.current = value;
    }, []);
    var getPlaceholderRef = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        return placeholderRef.current;
    }, []);
    var setPlaceholderRef = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(value) {
        placeholderRef.current = value;
    }, []);
    $83a769edb27eac89$var$useValidation({
        props: props,
        getDroppableRef: getDroppableRef,
        getPlaceholderRef: getPlaceholderRef
    });
    var onPlaceholderTransitionEnd = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: $83a769edb27eac89$var$getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    $83a769edb27eac89$var$useDroppablePublisher({
        droppableId: droppableId,
        type: type,
        mode: mode,
        direction: direction,
        isDropDisabled: isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        ignoreContainerClipping: ignoreContainerClipping,
        getDroppableRef: getDroppableRef
    });
    var placeholder = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($83a769edb27eac89$var$AnimateInOut, {
        on: props.placeholder,
        shouldAnimate: props.shouldAnimatePlaceholder
    }, function(_ref) {
        var onClose = _ref.onClose, data = _ref.data, animate = _ref.animate;
        return (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($83a769edb27eac89$var$Placeholder$1, {
            placeholder: data,
            onClose: onClose,
            innerRef: setPlaceholderRef,
            animate: animate,
            contextId: contextId,
            onTransitionEnd: onPlaceholderTransitionEnd
        });
    });
    var provided = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            innerRef: setDroppableRef,
            placeholder: placeholder,
            droppableProps: {
                'data-rbd-droppable-id': droppableId,
                'data-rbd-droppable-context-id': contextId
            }
        };
    }, [
        contextId,
        droppableId,
        placeholder,
        setDroppableRef
    ]);
    var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
    var droppableContext = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            droppableId: droppableId,
            type: type,
            isUsingCloneFor: isUsingCloneFor
        };
    }, [
        droppableId,
        isUsingCloneFor,
        type
    ]);
    function getClone() {
        if (!useClone) return null;
        var dragging = useClone.dragging, render = useClone.render;
        var node = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($83a769edb27eac89$var$PrivateDraggable, {
            draggableId: dragging.draggableId,
            index: dragging.source.index,
            isClone: true,
            isEnabled: true,
            shouldRespectForcePress: false,
            canDragInteractiveElements: true
        }, function(draggableProvided, draggableSnapshot) {
            return render(draggableProvided, draggableSnapshot, dragging);
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($3tOoB))).createPortal(node, getContainerForClone());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($83a769edb27eac89$var$DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot), getClone());
}
var $83a769edb27eac89$var$isMatchingType = function isMatchingType(type, critical) {
    return type === critical.droppable.type;
};
var $83a769edb27eac89$var$getDraggable = function getDraggable(critical, dimensions) {
    return dimensions.draggables[critical.draggable.id];
};
var $83a769edb27eac89$var$makeMapStateToProps$1 = function makeMapStateToProps() {
    var idleWithAnimation = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null,
            isUsingPlaceholder: false
        },
        useClone: null
    };
    var idleWithoutAnimation = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, idleWithAnimation, {
        shouldAnimatePlaceholder: false
    });
    var getDraggableRubric = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(descriptor) {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    });
    var getMapProps = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
        var draggableId = dragging.descriptor.id;
        var isHome = dragging.descriptor.droppableId === id;
        if (isHome) {
            var useClone = renderClone ? {
                render: renderClone,
                dragging: getDraggableRubric(dragging.descriptor)
            } : null;
            var _snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                draggingFromThisWith: draggableId,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: false,
                snapshot: _snapshot,
                useClone: useClone
            };
        }
        if (!isEnabled) return idleWithoutAnimation;
        if (!isDraggingOverForImpact) return idleWithAnimation;
        var snapshot = {
            isDraggingOver: isDraggingOverForConsumer,
            draggingOverWith: draggableId,
            draggingFromThisWith: null,
            isUsingPlaceholder: true
        };
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot: snapshot,
            useClone: null
        };
    });
    var selector = function selector(state, ownProps) {
        var id = ownProps.droppableId;
        var type = ownProps.type;
        var isEnabled = !ownProps.isDropDisabled;
        var renderClone = ownProps.renderClone;
        if (state.isDragging) {
            var critical = state.critical;
            if (!$83a769edb27eac89$var$isMatchingType(type, critical)) return idleWithoutAnimation;
            var dragging = $83a769edb27eac89$var$getDraggable(critical, state.dimensions);
            var isDraggingOver = $83a769edb27eac89$var$whatIsDraggedOver(state.impact) === id;
            return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (!$83a769edb27eac89$var$isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            var _dragging = $83a769edb27eac89$var$getDraggable(completed.critical, state.dimensions);
            return getMapProps(id, isEnabled, $83a769edb27eac89$var$whatIsDraggedOverFromResult(completed.result) === id, $83a769edb27eac89$var$whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
        }
        if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
            var _completed = state.completed;
            if (!$83a769edb27eac89$var$isMatchingType(type, _completed.critical)) return idleWithoutAnimation;
            var wasOver = $83a769edb27eac89$var$whatIsDraggedOver(_completed.impact) === id;
            var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === 'COMBINE');
            var isHome = _completed.critical.droppable.id === id;
            if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
            if (isHome) return idleWithAnimation;
            return idleWithoutAnimation;
        }
        return idleWithoutAnimation;
    };
    return selector;
};
var $83a769edb27eac89$var$mapDispatchToProps$1 = {
    updateViewportMaxScroll: $83a769edb27eac89$var$updateViewportMaxScroll
};
function $83a769edb27eac89$var$getBody() {
    !document.body && $83a769edb27eac89$var$invariant(false);
    return document.body;
}
var $83a769edb27eac89$var$defaultProps = {
    mode: 'standard',
    type: 'DEFAULT',
    direction: 'vertical',
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: $83a769edb27eac89$var$getBody
};
var $83a769edb27eac89$export$423ec2075359570a = (0, $a3b0bcd7a825bc6d$export$2e2bcd8739ae039)($83a769edb27eac89$var$makeMapStateToProps$1, $83a769edb27eac89$var$mapDispatchToProps$1, null, {
    context: $83a769edb27eac89$var$StoreContext,
    pure: true,
    areStatePropsEqual: $83a769edb27eac89$var$isStrictEqual
})($83a769edb27eac89$var$Droppable);
$83a769edb27eac89$export$423ec2075359570a.defaultProps = $83a769edb27eac89$var$defaultProps;



var $j6s32 = parcelRequire("j6s32");



/**
 * Component that contains a category item, along with it's associated dashboard items
 */ const $d714cff826c671bb$var$CateogryListItem = ({ navigation: navigation, provided: provided, clientDashboards: clientDashboards, updateDashboardNavigation: updateDashboardNavigation, updateCategoryNavigation: updateCategoryNavigation, deleteCategory: deleteCategory, deleteDashboard: deleteDashboard })=>{
    const [categoryInputValue, setCategoryInputValue] = $ieT14.useState(navigation.name);
    const [modalOpen, setModalOpen] = $ieT14.useState(false);
    const addCategoryHandler = (event)=>{
        event.preventDefault();
        if (categoryInputValue) updateCategoryNavigation({
            ...navigation,
            name: categoryInputValue
        });
    };
    const deleteCategoryHandler = ()=>{
        if (navigation.children.length > 0) setModalOpen(true);
        else deleteCategory(navigation.navigationId);
    };
    const deleteOnConfirmation = ()=>{
        deleteCategory(navigation.navigationId);
        setModalOpen(false);
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        ref: provided.innerRef,
        ...provided.draggableProps,
        ...provided.dragHandleProps,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $1fCJg.default), {
                className: $008d8028b93fa80d$export$22c3fa72cbbcdc02,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $9a2902e239ac61e9$export$2e2bcd8739ae039), {
                        open: modalOpen,
                        closeModal: ()=>{},
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $caf372f84efbe689$export$2e2bcd8739ae039), {
                            title: "Confirmation",
                            message: "Are you sure you want to delete this category and all of its dashboards?",
                            confirmAction: deleteOnConfirmation,
                            cancelAction: ()=>setModalOpen(false)
                        })
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $iwN3n.default), {
                        className: $008d8028b93fa80d$export$6a6e38f6cd58c8a2,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6a14edd9ac02d0a6$exports))), {})
                    }),
                    ' ',
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("form", {
                        className: $008d8028b93fa80d$export$74d7c0edf95632ad,
                        onSubmit: (event)=>addCategoryHandler(event),
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4293b04ece6aa3fa$export$2e2bcd8739ae039), {
                                label: "Name",
                                value: categoryInputValue,
                                onChange: (event)=>setCategoryInputValue(event.target.value),
                                onBlur: ()=>setCategoryInputValue(navigation.name)
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $105db2ddc246141f$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                                    title: "Delete",
                                    onClick: deleteCategoryHandler,
                                    edge: "end",
                                    "aria-label": "delete",
                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $70ccc3891d50e85f$export$2e2bcd8739ae039), {
                                        style: {
                                            color: '#006da8'
                                        }
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $83a769edb27eac89$export$423ec2075359570a), {
                droppableId: `${navigation.navigationId}`,
                type: "DASHBOARD",
                children: (provided, snapshot)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $dxqtw.default), {
                        className: (0, $j6s32.default)($008d8028b93fa80d$export$25f281a96778caf1, snapshot.isDraggingOver && $008d8028b93fa80d$export$bf5daf80bda0b208),
                        ref: provided.innerRef,
                        ...provided.droppableProps,
                        children: [
                            navigation.children.map((child)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $83a769edb27eac89$export$f2a139e5d18b9882), {
                                    draggableId: `${child.navigationId}`,
                                    index: child.seqOrder,
                                    children: (provided)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $c3b96bca0fceac56$export$2e2bcd8739ae039), {
                                            childNavigation: child,
                                            provided: provided,
                                            clientDashboards: clientDashboards,
                                            updateDashboardNavigation: updateDashboardNavigation,
                                            deleteDashboard: deleteDashboard
                                        })
                                }, child.navigationId)),
                            provided.placeholder
                        ]
                    })
            })
        ]
    });
};
var $d714cff826c671bb$export$2e2bcd8739ae039 = $d714cff826c671bb$var$CateogryListItem;




/**
 * Component which contains the section for navigation categories
 */ const $9b263a6cfe96b048$var$NavList = ({ navigations: navigations, clientDashboards: clientDashboards, updateDashboardNavigation: updateDashboardNavigation, updateCategoryNavigation: updateCategoryNavigation, deleteCategory: deleteCategory, deleteDashboard: deleteDashboard, scrollRef: scrollRef })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $008d8028b93fa80d$export$7c6191f25b7d8c71,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("p", {
                    children: "Name"
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5d10f0a7aadd7c8c$exports))), {
                autoHide: true,
                style: {
                    flex: 1
                },
                ref: scrollRef,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $83a769edb27eac89$export$423ec2075359570a), {
                    droppableId: "droppable-top-level",
                    type: "CATEGORY",
                    children: (provided, snapshot)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $dxqtw.default), {
                            className: $008d8028b93fa80d$export$b5cb804542eb9e20,
                            ref: provided.innerRef,
                            ...provided.droppableProps,
                            children: [
                                navigations.map((navigation)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $83a769edb27eac89$export$f2a139e5d18b9882), {
                                        draggableId: `${navigation.navigationId}`,
                                        index: navigation.seqOrder,
                                        children: (provided)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $d714cff826c671bb$export$2e2bcd8739ae039), {
                                                navigation: navigation,
                                                provided: provided,
                                                clientDashboards: clientDashboards,
                                                updateDashboardNavigation: updateDashboardNavigation,
                                                updateCategoryNavigation: updateCategoryNavigation,
                                                deleteCategory: deleteCategory,
                                                deleteDashboard: deleteDashboard
                                            })
                                    }, navigation.navigationId)),
                                provided.placeholder
                            ]
                        })
                })
            })
        ]
    });
};
var $9b263a6cfe96b048$export$2e2bcd8739ae039 = $9b263a6cfe96b048$var$NavList;



/**
 * useNavigation
 * @function useNavigation - Custom hook for the navigation models
 */ const $bc232ecb332d8aef$var$useNavigation = ()=>{
    const { getAuth: getAuth, postAuth: postAuth, putAuth: putAuth, deleteAuth: deleteAuth } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    /**
   * fetchNavigations
   * @function fetchNavigations - fetch complete navigation tree for a specified client
   * @param clientId Id of the active client
   */ const fetchNavigations = (clientId)=>{
        return getAuth(`api/${clientId}/navigations`);
    };
    /**
   * updateNavigation
   * @function updateNavigation - update navigation object including any children navigation objects
   * @param clientId Id of the active client
   * @param data - Navigation object
   */ const updateNavigations = (clientId, data)=>{
        return putAuth(`api/${clientId}/navigations/`, data);
    };
    /**
   * addNavigation
   * @function addNavigation - Create a single new top level navigation category with no children
   * @param clientId Id of the active client
   * @param name name of the new navigation category
   */ const addNavigation = (clientId, data)=>{
        return postAuth(`api/${clientId}/navigations/`, data);
    };
    /**
   * deleteNavigation
   * @function deleteNavigation - delete a single navigation item
   * @param clientId Id of the active client
   * @param navigationId id of the navigation item to be deleted
   */ const deleteNavigation = (clientId, navigationId)=>{
        return deleteAuth(`api/${clientId}/navigations/${navigationId}`);
    };
    return {
        fetchNavigations: fetchNavigations,
        updateNavigations: updateNavigations,
        addNavigation: addNavigation,
        deleteNavigation: deleteNavigation
    };
};
var $bc232ecb332d8aef$export$2e2bcd8739ae039 = $bc232ecb332d8aef$var$useNavigation;








var $ieT14 = parcelRequire("ieT14");


var $whS22 = parcelRequire("whS22");
var $knRao = parcelRequire("knRao");
var $f3VQ2 = parcelRequire("f3VQ2");



var $ieT14 = parcelRequire("ieT14");



var $kRJN7 = parcelRequire("kRJN7");
var $whS22 = parcelRequire("whS22");
var $eg6hn = parcelRequire("eg6hn");
var $Uxz4Y = parcelRequire("Uxz4Y");
var $3mOXj = parcelRequire("3mOXj");
var $aanJt = parcelRequire("aanJt");
var $aIJrd = parcelRequire("aIJrd");

var $j6s32 = parcelRequire("j6s32");

const $bbb0fa994b214d8b$var$AddDashboardInput = (0, $aIJrd.default)(()=>(0, $kRJN7.default)({
        root: {
            marginRight: '20px'
        },
        input: {
            borderRadius: 4,
            position: 'relative',
            border: '1px solid #d1cece',
            padding: '10.5px 14px',
            fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).body,
            fontSize: '16px',
            lineHeight: '17px',
            width: '250px',
            color: '#4f4f4f',
            '&:focus': {
                borderRadius: 4,
                borderColor: '#80bdff',
                backgroundColor: 'white'
            }
        }
    }))((0, $eg6hn.default));
const $bbb0fa994b214d8b$var$AddDashboardNav = ({ navigations: navigations, updating: updating, addNavigationHandler: addNavigationHandler, loadingDashboards: loadingDashboards, clientDashboards: clientDashboards })=>{
    const [selectedDashboard, setSelectedDashboard] = $ieT14.useState(0);
    const addDashboardSelectHandler = (event)=>{
        setSelectedDashboard(Number(event.target.value));
    };
    const addDashboardHandler = (event)=>{
        event && event.preventDefault();
        const [parentNav] = navigations.slice(-1);
        const dashboard = clientDashboards.find((dashboard)=>dashboard.reportId === selectedDashboard);
        const seqOrder = parentNav.children.length;
        const newDashboard = {
            name: dashboard.name,
            seqOrder: seqOrder,
            link: dashboard.reportId.toString(),
            parentId: parentNav.navigationId
        };
        addNavigationHandler(newDashboard);
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("form", {
        onSubmit: (event)=>addDashboardHandler(event),
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
                className: $008d8028b93fa80d$export$aaf041586c7e9139,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $Uxz4Y.default), {
                        id: 'add-dashboard-select',
                        style: {
                            display: 'none'
                        },
                        children: "Add Dashboard"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $aanJt.default), {
                        className: (0, $j6s32.default)($008d8028b93fa80d$export$2e6c959c16ff56b8, clientDashboards.length === 0 && $008d8028b93fa80d$export$f15b31aa3f8d543f),
                        labelId: 'add-dashboard-select',
                        value: selectedDashboard ? selectedDashboard : '',
                        onChange: addDashboardSelectHandler,
                        input: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($bbb0fa994b214d8b$var$AddDashboardInput, {}),
                        disabled: loadingDashboards || clientDashboards.length === 0,
                        children: clientDashboards && clientDashboards.map((dashboard)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                value: dashboard.reportId,
                                children: dashboard.name
                            }, dashboard.reportId))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f5afe0f42548a953$export$2e2bcd8739ae039), {
                text: "Add",
                title: "Add",
                handleClick: addDashboardHandler,
                deactive: !selectedDashboard || updating
            })
        ]
    });
};
var $bbb0fa994b214d8b$export$2e2bcd8739ae039 = $bbb0fa994b214d8b$var$AddDashboardNav;



parcelRequire("ieT14");



var $eYT2J = parcelRequire("eYT2J");
const $c304bd2d18c578a0$var$AddCategory = ({ inputText: inputText, setInputText: setInputText, navigations: navigations, updating: updating, addNavigationHandler: addNavigationHandler })=>{
    const addCategoryHandler = (event)=>{
        event && event.preventDefault();
        if (inputText) {
            const seqOrder = navigations.length;
            const newCategory = {
                seqOrder: seqOrder,
                name: inputText
            };
            addNavigationHandler(newCategory);
        }
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("form", {
        onSubmit: (event)=>addCategoryHandler(event),
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYT2J.default), {
                id: "outlined-name",
                label: "Name",
                size: "small",
                margin: "none",
                variant: "outlined",
                value: inputText,
                onChange: (event)=>setInputText(event.target.value),
                disabled: updating,
                className: $008d8028b93fa80d$export$2d644207714cbedf
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f5afe0f42548a953$export$2e2bcd8739ae039), {
                text: "Add",
                title: "Add",
                handleClick: addCategoryHandler,
                deactive: inputText === '' || updating
            })
        ]
    });
};
var $c304bd2d18c578a0$export$2e2bcd8739ae039 = $c304bd2d18c578a0$var$AddCategory;



var $j6s32 = parcelRequire("j6s32");
const $354db0c3f8e2d9cd$var$AddNavigation = ({ clientId: clientId, navigations: navigations, setNavigations: setNavigations, setSuccessMessage: setSuccessMessage, setErrorMessage: setErrorMessage, loadingDashboards: loadingDashboards, clientDashboards: clientDashboards, scrollRef: scrollRef })=>{
    const [inputText, setInputText] = $ieT14.useState('');
    const [radioValue, setRadioValue] = $ieT14.useState('category');
    const [updating, setUpdating] = $ieT14.useState(false);
    const { fetchNavigations: fetchNavigations, addNavigation: addNavigation } = (0, $bc232ecb332d8aef$export$2e2bcd8739ae039)();
    const addNavigationHandler = (newNavigation)=>{
        addNavigation(clientId, newNavigation).then((response)=>{
            setUpdating(true);
            if (response.success) {
                setSuccessMessage(`Navigation ${response.message} created`);
                setInputText('');
                fetchNavigations(clientId).then((fetched)=>{
                    if (fetched) {
                        setNavigations(fetched);
                        scrollRef.current.scrollToBottom();
                    } else setErrorMessage('Navigation fetch failed');
                    setUpdating(false);
                }).catch((err)=>{
                    setErrorMessage(err.responseJSON.message);
                });
            } else setErrorMessage(response.message);
        }).catch((err)=>{
            setErrorMessage(err.responseJSON.message);
        });
    };
    const radioChangeHandler = (event)=>{
        setRadioValue(event.target.value);
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $008d8028b93fa80d$export$dff72a5fd5ad3e0c,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
                size: "small",
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f3VQ2.default), {
                        component: "legend",
                        className: $008d8028b93fa80d$export$b6e43b52b188ac0f,
                        children: "Add Dashboard Type"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $62bbd6cebee2ba4a$export$2e2bcd8739ae039), {
                        name: "add-type",
                        value: radioValue,
                        onChange: radioChangeHandler,
                        className: $008d8028b93fa80d$export$7246d22ab0922ede,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $knRao.default), {
                                value: "category",
                                control: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $141807cd97d66e4d$export$2e2bcd8739ae039), {
                                    color: "primary"
                                }),
                                label: "Dashboard Category",
                                className: $008d8028b93fa80d$export$64528cb06183cfba
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $knRao.default), {
                                value: "dashboard",
                                control: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $141807cd97d66e4d$export$2e2bcd8739ae039), {
                                    color: "primary"
                                }),
                                label: "Dashboard",
                                className: (0, $j6s32.default)($008d8028b93fa80d$export$64528cb06183cfba, navigations.length === 0 && $008d8028b93fa80d$export$ad03a22c34ccf90e),
                                disabled: navigations.length === 0
                            })
                        ]
                    })
                ]
            }),
            radioValue === 'category' ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $c304bd2d18c578a0$export$2e2bcd8739ae039), {
                inputText: inputText,
                setInputText: setInputText,
                updating: updating,
                navigations: navigations,
                addNavigationHandler: addNavigationHandler
            }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $bbb0fa994b214d8b$export$2e2bcd8739ae039), {
                clientId: clientId,
                navigations: navigations,
                updating: updating,
                addNavigationHandler: addNavigationHandler,
                setErrorMessage: setErrorMessage,
                setSuccessMessage: setSuccessMessage,
                loadingDashboards: loadingDashboards,
                clientDashboards: clientDashboards
            })
        ]
    });
};
var $354db0c3f8e2d9cd$export$2e2bcd8739ae039 = $354db0c3f8e2d9cd$var$AddNavigation;



const $02d9a65ac8e83b0d$var$ClientNavigation = ({ clientId: clientId })=>{
    const [loading, setLoading] = $ieT14.useState(true);
    const [loadingDashboards, setLoadingDashboards] = $ieT14.useState(true);
    const [navigations, setNavigations] = $ieT14.useState([]);
    const [clientDashboards, setClientDashboards] = $ieT14.useState([]);
    const { successMessage: successMessage, setSuccessMessage: setSuccessMessage, errorMessage: errorMessage, setErrorMessage: setErrorMessage } = (0, $dc97b0794e0fd33b$export$2e2bcd8739ae039)();
    const { fetchNavigations: fetchNavigations, updateNavigations: updateNavigations, deleteNavigation: deleteNavigation } = (0, $bc232ecb332d8aef$export$2e2bcd8739ae039)();
    const { fetchAllDashboards: fetchAllDashboards } = (0, $11b569dffddc8c64$export$2e2bcd8739ae039)();
    const scrollRef = $ieT14.useRef(null);
    let prevNavs = [];
    const updateNavigationsHandler = (data)=>{
        updateNavigations(clientId, data).then((response)=>{
            if (response.success) setSuccessMessage('Navigation updated successfully');
            else {
                setErrorMessage(response.message);
                setNavigations(prevNavs);
            }
        }).catch((err)=>{
            setErrorMessage(err.responseJSON ? err.responseJSON.message : 'Request failed');
            setNavigations(prevNavs);
        });
    };
    const updateDashboardNavigation = (newDashboard)=>{
        const updatedNavigations = navigations.map((nav)=>{
            if (nav.navigationId === newDashboard.parentId) {
                const updatedChildren = nav.children.map((child)=>{
                    if (child.navigationId === newDashboard.navigationId) return newDashboard;
                    return child;
                });
                return {
                    ...nav,
                    children: updatedChildren
                };
            }
            return nav;
        });
        prevNavs = navigations;
        setNavigations(updatedNavigations);
        updateNavigationsHandler(updatedNavigations);
    };
    const updateCategoryNavigation = (newCategory)=>{
        const updatedNavigations = navigations.map((nav)=>{
            if (nav.navigationId === newCategory.navigationId) return newCategory;
            return nav;
        });
        prevNavs = navigations;
        setNavigations(updatedNavigations);
        updateNavigationsHandler(updatedNavigations);
    };
    const deleteCategory = (navigationId)=>{
        const newNavigations = navigations.filter((nav)=>nav.navigationId !== navigationId).map((navigation, i)=>{
            navigation.seqOrder = i;
            return navigation;
        });
        deleteNavigation(clientId, navigationId).then((response)=>{
            if (response.success) {
                setSuccessMessage(`Dashboard Category ${response.message} removed`);
                setNavigations(newNavigations);
            } else setErrorMessage(response.message);
        }).catch((err)=>{
            setErrorMessage(err.responseJSON ? err.responseJSON.message : 'Request failed');
        });
    };
    const deleteDashboard = (dashboard)=>{
        const navigationId = dashboard.navigationId;
        const parentNav = navigations.find((navigation)=>navigation.navigationId === dashboard.parentId);
        const newChildren = parentNav.children.filter((child)=>child.navigationId !== navigationId).map((child, i)=>{
            child.seqOrder = i;
            return child;
        });
        const newParent = {
            ...parentNav,
            children: newChildren
        };
        deleteNavigation(clientId, navigationId).then((response)=>{
            if (response.success) {
                setSuccessMessage(`Dashboard ${response.message} removed`);
                setNavigations(navigations.map((navigation)=>{
                    if (navigation.navigationId === parentNav.navigationId) return newParent;
                    return navigation;
                }));
            } else setErrorMessage(response.message);
        }).catch((err)=>{
            setErrorMessage(err.responseJSON ? err.responseJSON.message : 'Request failed');
        });
    };
    $ieT14.useEffect(()=>{
        fetchNavigations(clientId).then((fetchedNavs)=>{
            if (fetchedNavs) {
                // standardize seqOrder values in case of old data in both parents and children
                const orderednavs = fetchedNavs.map((navigation, index)=>({
                        ...navigation,
                        seqOrder: index
                    }));
                orderednavs.forEach((nav)=>{
                    if (nav.children) nav.children = nav.children.map((child, index)=>({
                            ...child,
                            seqOrder: index
                        }));
                });
                setNavigations(orderednavs);
                setLoading(false);
            }
        }).catch((err)=>{
            setErrorMessage(err.responseJSON.message);
        });
        fetchAllDashboards(clientId).then((response)=>{
            setClientDashboards(response.results);
            setLoadingDashboards(false);
        }).catch((err)=>{
            setErrorMessage(err.responseJSON.message);
            setLoadingDashboards(false);
        });
    }, []);
    const onDragEnd = (result)=>{
        const { destination: destination, source: source, type: type } = result;
        // user cancels interaction (i.e. drags off the droppable area)
        if (!destination) return;
        // user dropped item in the same location it was in
        if (destination.droppableId === source.droppableId && destination.index === source.index) return;
        let updatedNavigations = [];
        if (type === 'CATEGORY') {
            // if top-level navigation category is dragged
            const nextNavs = Array.from(navigations);
            const [moved] = nextNavs.splice(source.index, 1);
            nextNavs.splice(destination.index, 0, moved);
            updatedNavigations = nextNavs.map((nav, i)=>({
                    ...nav,
                    seqOrder: i
                }));
        } else if (type === 'DASHBOARD') {
            // if dashboard is dragged
            const sourceParent = navigations.find((navigation)=>navigation.navigationId === parseInt(source.droppableId));
            const destinationParent = navigations.find((navigation)=>navigation.navigationId === parseInt(destination.droppableId));
            if (destination.droppableId === source.droppableId) {
                // if dashboard is dropped within its original parent category
                const nextDashes = Array.from(sourceParent.children);
                const [moved] = nextDashes.splice(source.index, 1);
                nextDashes.splice(destination.index, 0, moved);
                // update dashboard list seqOrders
                const updatedDashes = nextDashes.map((dash, i)=>({
                        ...dash,
                        seqOrder: i
                    }));
                // update parent navigation with new dashboard
                updatedNavigations = navigations.map((nav)=>{
                    if (nav.navigationId === parseInt(destination.droppableId)) return {
                        ...nav,
                        children: updatedDashes
                    };
                    return nav;
                });
            } else {
                // if dashboard is dropped on a different parent
                const nextSource = Array.from(sourceParent.children);
                const nextDest = Array.from(destinationParent.children);
                const [moved] = nextSource.splice(source.index, 1);
                // update parent id of dragged element
                moved.parentId = destinationParent.navigationId;
                nextDest.splice(destination.index, 0, moved);
                // update dashboard list seqOrders
                const updatedSource = nextSource.map((dash, i)=>({
                        ...dash,
                        seqOrder: i
                    }));
                const updatedDest = nextDest.map((dash, i)=>({
                        ...dash,
                        seqOrder: i
                    }));
                // update parent navigation with new dashboard
                updatedNavigations = navigations.map((nav)=>{
                    if (nav.navigationId === parseInt(source.droppableId)) return {
                        ...nav,
                        children: updatedSource
                    };
                    else if (nav.navigationId === parseInt(destination.droppableId)) return {
                        ...nav,
                        children: updatedDest
                    };
                    return nav;
                });
            }
        }
        // store fallback in case update fails
        prevNavs = navigations;
        setNavigations(updatedNavigations);
        updateNavigationsHandler(updatedNavigations);
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $008d8028b93fa80d$export$428e7c787d57587d,
        children: [
            errorMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $cd9e5d573af72510$export$2e2bcd8739ae039), {
                message: errorMessage
            }),
            successMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $00b96652cf9f9fb7$export$2e2bcd8739ae039), {
                message: successMessage
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $354db0c3f8e2d9cd$export$2e2bcd8739ae039), {
                clientId: clientId,
                navigations: navigations,
                setNavigations: setNavigations,
                setSuccessMessage: setSuccessMessage,
                setErrorMessage: setErrorMessage,
                loadingDashboards: loadingDashboards,
                clientDashboards: clientDashboards,
                scrollRef: scrollRef
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $008d8028b93fa80d$export$80a6180f57d52770,
                children: loading ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: "loadingIndicator",
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
                }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $83a769edb27eac89$export$237bd83162c14364), {
                    onDragEnd: onDragEnd,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $9b263a6cfe96b048$export$2e2bcd8739ae039), {
                        navigations: navigations,
                        clientDashboards: clientDashboards,
                        updateDashboardNavigation: updateDashboardNavigation,
                        updateCategoryNavigation: updateCategoryNavigation,
                        deleteCategory: deleteCategory,
                        deleteDashboard: deleteDashboard,
                        scrollRef: scrollRef
                    })
                })
            })
        ]
    });
};
var $02d9a65ac8e83b0d$export$2e2bcd8739ae039 = $02d9a65ac8e83b0d$var$ClientNavigation;




var $ieT14 = parcelRequire("ieT14");



const $fb007376d95acb76$var$EditDashboard = ({ match: { params: { clientId: clientId, dashboardId: dashboardId } } })=>{
    const defaultDashboard = {
        reportId: null,
        name: '',
        description: '',
        assignedTags: [],
        status: null,
        reportLevel: (0, $412bd15806135993$export$2e2bcd8739ae039)[0].key,
        contentText: ''
    };
    const [loading, setLoading] = $ieT14.useState(true);
    const [dashboard, setDashboard] = $ieT14.useState(defaultDashboard);
    const [desktopOptions, setDesktopOptions] = $ieT14.useState([]);
    const { fetchDashboard: fetchDashboard, fetchAllDashboardsFromTableau: fetchAllDashboardsFromTableau } = (0, $11b569dffddc8c64$export$2e2bcd8739ae039)();
    $ieT14.useEffect(()=>{
        if (!loading) setLoading(true);
        Promise.all([
            fetchDashboard(clientId, dashboardId),
            fetchAllDashboardsFromTableau(clientId)
        ]).then(([dashboard, tableauList])=>{
            setDashboard(dashboard);
            setDesktopOptions(tableauList);
            setLoading(false);
        });
    }, []);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $55fa41603ae82cea$export$2e2bcd8739ae039), {
        clientId: clientId,
        dashboard: dashboard,
        isNewDashboard: false,
        loading: loading,
        desktopOptions: desktopOptions
    });
};
var $fb007376d95acb76$export$2e2bcd8739ae039 = $fb007376d95acb76$var$EditDashboard;




var $ieT14 = parcelRequire("ieT14");

var $fRnKy = parcelRequire("fRnKy");
const $524bc7b3eb0618a2$var$defaultState = {
    loading: false,
    helpDocuments: {},
    globalHelpDocuments: {},
    clientList: [],
    activeDocumentId: null,
    errorMessage: '',
    successMessage: ''
};
const $524bc7b3eb0618a2$export$a7348e1183383d51 = /*#__PURE__*/ $ieT14.createContext(null);
const $524bc7b3eb0618a2$export$7ad40d984dda31e2 = $524bc7b3eb0618a2$export$a7348e1183383d51.Consumer;
const $524bc7b3eb0618a2$export$752cfdd6bed7d744 = (props)=>{
    const [state, setState] = (0, $ieT14.useState)($524bc7b3eb0618a2$var$defaultState);
    const dispatch = (newValue)=>{
        setState((prevState)=>{
            if (!$fRnKy.isEqual({
                ...prevState
            }, {
                ...prevState,
                ...newValue
            })) return {
                ...prevState,
                ...newValue
            };
            return prevState;
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($524bc7b3eb0618a2$export$a7348e1183383d51.Provider, {
        value: {
            ...state,
            dispatch: dispatch
        },
        children: props.children
    });
};




var $ieT14 = parcelRequire("ieT14");


var $fpdl2 = parcelRequire("fpdl2");





var $ieT14 = parcelRequire("ieT14");



var $6mt9R = parcelRequire("6mt9R");
var $eYoAG = parcelRequire("eYoAG");



var $ieT14 = parcelRequire("ieT14");


parcelRequire("ieT14");

const $af7f992ccbc9b6b6$var$StatusChip = ({ text: text, backgroundColor: backgroundColor })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
        className: $2b36415f25d48604$export$2868e043eb9960bb,
        style: {
            backgroundColor: backgroundColor
        },
        children: text
    });
};
var $af7f992ccbc9b6b6$export$2e2bcd8739ae039 = $af7f992ccbc9b6b6$var$StatusChip;



var $1KcBP = parcelRequire("1KcBP");

var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $fcd47f6d20144afc$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5zM5.12 5l.81-1h12l.94 1H5.12z"
}), 'Archive');


var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $f55c34e9129cfe0a$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), 'Edit');


var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $c7d72f700aa06b90$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreVert');


var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $57e19fc3c6f8b8b8$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z"
}), 'Navigation');






var $eYoAG = parcelRequire("eYoAG");


parcelRequire("ieT14");

var $5TjLg = parcelRequire("5TjLg");

var $3mOXj = parcelRequire("3mOXj");

var $gXLwJ = parcelRequire("gXLwJ");
var $bPjUl = parcelRequire("bPjUl");

const $ea8e93ac18f04e22$var$materialTheme = (0, $gXLwJ.default)({
    overrides: {
        MuiMenuItem: {
            root: {
                color: '#006DA8',
                paddingTop: '2px',
                paddingBottom: '2px',
                '&$selected': {
                    backgroundColor: '#eaf3f8 !important',
                    color: 'black'
                }
            }
        },
        MuiListItemText: {
            primary: {
                fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).heading,
                fontSize: '11px !important',
                color: '#006DA8',
                textTransform: 'uppercase',
                marginLeft: '4px'
            }
        },
        MuiSvgIcon: {
            root: {
                height: 18,
                width: 18
            }
        }
    }
});
const $ea8e93ac18f04e22$var$DropdownMenu = ({ menuItems: menuItems, anchorEl: anchorEl, setAnchorEl: setAnchorEl })=>{
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $544e32820ad8eb30$export$2e2bcd8739ae039), {
            theme: $ea8e93ac18f04e22$var$materialTheme,
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $5TjLg.default), {
                id: "simple-menu",
                anchorEl: anchorEl,
                open: Boolean(anchorEl),
                onClose: handleClose,
                children: menuItems.map((item)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $3mOXj.default), {
                        onClick: ()=>{
                            item.eventHandler();
                            handleClose();
                        },
                        children: [
                            item.icon && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)(item.icon, {}),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $bPjUl.default), {
                                children: item.text
                            })
                        ]
                    }, item.text))
            })
        })
    });
};
var $ea8e93ac18f04e22$export$2e2bcd8739ae039 = $ea8e93ac18f04e22$var$DropdownMenu;






var $ieT14 = parcelRequire("ieT14");

var $fRnKy = parcelRequire("fRnKy");





const $e9c3f614124580da$var$GlobalMapModalContent = ({ initialMappedClients: initialMappedClients, initialUnmappedClients: initialUnmappedClients, documentId: documentId, closeMapModal: closeMapModal })=>{
    const [unmappedClients, setUnmappedClients] = $ieT14.useState(initialUnmappedClients);
    const [mappedClients, setMappedClients] = $ieT14.useState(initialMappedClients);
    const { fetchGlobalHelpDocuments: fetchGlobalHelpDocuments } = (0, $c807f91b5abb1e86$export$2e2bcd8739ae039)();
    const { mapGlobalDocument: mapGlobalDocument } = (0, $dfbf579bea9f90b3$export$2e2bcd8739ae039)();
    const saveHandler = ()=>{
        const clientList = mappedClients.map((client)=>client.clientId);
        mapGlobalDocument(clientList, documentId).then(()=>fetchGlobalHelpDocuments(true));
        closeMapModal();
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("form", {
                className: $2b36415f25d48604$export$d3710016b0f351d6,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $624bea18a01be01c$export$2e2bcd8739ae039), {
                    idField: "clientId",
                    labelField: "name",
                    left: unmappedClients,
                    right: mappedClients,
                    setLeft: setUnmappedClients,
                    setRight: setMappedClients,
                    leftLabel: "Unmapped Clients",
                    rightLabel: "Mapped Clients",
                    setFieldValue: ()=>{},
                    setField: "",
                    height: "460px"
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $2b36415f25d48604$export$edfe9515a4e42134,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f5afe0f42548a953$export$2e2bcd8739ae039), {
                    text: "Save",
                    title: "Save",
                    deactive: $fRnKy.isEqual(mappedClients, initialMappedClients),
                    handleClick: saveHandler
                })
            })
        ]
    });
};
var $e9c3f614124580da$export$2e2bcd8739ae039 = $e9c3f614124580da$var$GlobalMapModalContent;



/**
 * Component that displays each individual help document
 */ const $54689d44f1f183ab$var$HelpDocumentContent = ({ document: document, activeDoc: activeDoc, isSearching: isSearching })=>{
    const { clientId: clientId } = (0, $eYoAG.useParams)();
    const docRef = $ieT14.useRef(null);
    const [modalOpen, setModalOpen] = $ieT14.useState(false);
    const { deleteGlobalHelpDocument: deleteGlobalHelpDocument, deleteClientHelpDocument: deleteClientHelpDocument, clientList: clientList } = (0, $c807f91b5abb1e86$export$2e2bcd8739ae039)();
    const history = (0, $eYoAG.useHistory)();
    const [anchorEl, setAnchorEl] = $ieT14.useState(null);
    const { modalIsOpen: mapModalIsOpen, openModal: openMapModal, closeModal: closeMapModal } = (0, $a7347f5558ecc977$export$2e2bcd8739ae039)();
    // If the active document changes, the window will scroll to the appropriate document
    $ieT14.useEffect(()=>{
        // Set timeout is necessary in order to fully scroll to the document, otherwise, the images that are part of that document might not be fully rendered.
        const timer = setTimeout(()=>{
            if (activeDoc === document.snippetGroupId) docRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest'
            });
        }, 0);
        return ()=>clearTimeout(timer);
    }, [
        activeDoc
    ]);
    const isGlobal = document.clientId === -1;
    const deleteDocument = ()=>{
        if (!clientId) deleteGlobalHelpDocument(document.snippetId).then((newDocumentTree)=>{
            if (document.snippetGroupId === activeDoc) history.push(`${(0, $4bbac098dba9d86f$export$2e2bcd8739ae039).GlobalHelpDocuments}/${newDocumentTree.items['-1'].children[0] || ''}`.replace(':clientId', clientId));
        });
        else deleteClientHelpDocument(document.snippetId).then((newDocumentTree)=>{
            if (document.snippetGroupId === activeDoc) history.push(`${(0, $4bbac098dba9d86f$export$2e2bcd8739ae039).ClientHelpDocuments}/${newDocumentTree.items['-1'].children[0] || ''} `.replace(':clientId', clientId));
        });
        setModalOpen(false);
    };
    const editDocument = ()=>{
        if (!isGlobal && clientId) history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).EditClientHelpDocument.replace(':clientId', clientId).replace(':snippetId', document.snippetId.toString()));
        else if (isGlobal && clientId) history.push(`${(0, $4bbac098dba9d86f$export$2e2bcd8739ae039).EditClientHelpDocument.replace(':clientId', clientId).replace(':snippetId', document.snippetId.toString())}/global`);
        else if (isGlobal && !clientId) history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).EditGlobalHelpDocument.replace(':snippetId', document.snippetId.toString()));
    };
    const viewRevisionsList = ()=>{
        if (isGlobal) history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).ViewGlobalHelpDocumentRevisions.replace(':snippetGroupId', document.snippetGroupId.toString()));
        else history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).ViewClientHelpDocumentRevisions.replace(':clientId', clientId).replace(':snippetGroupId', document.snippetGroupId.toString()));
    };
    const openMenu = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const menuItems = [
        {
            type: 'revisions',
            text: 'Revisions',
            eventHandler: viewRevisionsList,
            icon: (0, $fcd47f6d20144afc$export$2e2bcd8739ae039)
        },
        {
            type: 'mapping',
            text: 'Map to Clients',
            eventHandler: openMapModal,
            icon: (0, $57e19fc3c6f8b8b8$export$2e2bcd8739ae039)
        }
    ];
    const mappedClients = clientList.filter((client)=>document.mappedClient.includes(client.clientId));
    const unmappedClients = clientList.filter((client)=>!document.mappedClient.includes(client.clientId));
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $2b36415f25d48604$export$5a7bfc01df82fcd1,
        ref: docRef,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $9a2902e239ac61e9$export$2e2bcd8739ae039), {
                open: modalOpen,
                closeModal: ()=>{},
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $caf372f84efbe689$export$2e2bcd8739ae039), {
                    title: "Confirmation",
                    message: "Are you sure you want to delete this document? Deleting the document also deletes all of its revisions.",
                    confirmAction: deleteDocument,
                    cancelAction: ()=>setModalOpen(false)
                })
            }),
            isGlobal && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3c302b0d44a45917$export$2e2bcd8739ae039), {
                isOpen: mapModalIsOpen,
                onClose: closeMapModal,
                title: !clientId && 'Map Document to Clients',
                width: "650px",
                children: !clientId && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $e9c3f614124580da$export$2e2bcd8739ae039), {
                    initialMappedClients: mappedClients,
                    initialUnmappedClients: unmappedClients,
                    documentId: document.snippetGroupId,
                    closeMapModal: closeMapModal
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $2b36415f25d48604$export$a301abe19dc6106,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        className: $2b36415f25d48604$export$8a3414480ef6a69,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $af7f992ccbc9b6b6$export$2e2bcd8739ae039), {
                                text: isGlobal ? 'Global' : 'Client',
                                backgroundColor: $2b36415f25d48604$export$3832be13857745bc
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $af7f992ccbc9b6b6$export$2e2bcd8739ae039), {
                                text: document.isPublished ? 'Published' : 'Draft',
                                backgroundColor: $2b36415f25d48604$export$f4c68800b094ddb1
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $af7f992ccbc9b6b6$export$2e2bcd8739ae039), {
                                text: `Rev. #${document.revision}`,
                                backgroundColor: $2b36415f25d48604$export$f4c68800b094ddb1
                            })
                        ]
                    }),
                    !isSearching && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        className: $2b36415f25d48604$export$182ead204233c2b3,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                                title: "Edit",
                                size: "small",
                                onClick: editDocument,
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f55c34e9129cfe0a$export$2e2bcd8739ae039), {
                                    style: {
                                        fill: '#006DA8'
                                    }
                                })
                            }),
                            (!isGlobal && clientId || isGlobal && !clientId) && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                                title: "Delete",
                                size: "small",
                                onClick: ()=>setModalOpen(true),
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $70ccc3891d50e85f$export$2e2bcd8739ae039), {
                                    style: {
                                        fill: '#006DA8'
                                    }
                                })
                            }),
                            (!isGlobal && clientId || isGlobal && !clientId) && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                                        title: "Menu",
                                        size: "small",
                                        onClick: openMenu,
                                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $c7d72f700aa06b90$export$2e2bcd8739ae039), {
                                            style: {
                                                fill: '#006DA8'
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $ea8e93ac18f04e22$export$2e2bcd8739ae039), {
                                        anchorEl: anchorEl,
                                        setAnchorEl: setAnchorEl,
                                        menuItems: isGlobal ? menuItems : menuItems.filter((item)=>item.type !== 'mapping')
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8d3a72c073b907e7$export$2e2bcd8739ae039), {
                document: document
            })
        ]
    });
};
var $54689d44f1f183ab$export$2e2bcd8739ae039 = $54689d44f1f183ab$var$HelpDocumentContent;




/**
 * Custom hook for the help page
 */ const $c807f91b5abb1e86$var$useHelpDocuments = ()=>{
    const { helpDocuments: helpDocuments, globalHelpDocuments: globalHelpDocuments, loading: loading, activeDocumentId: activeDocumentId, clientList: clientList, dispatch: dispatch, errorMessage: errorMessage, successMessage: successMessage } = $ieT14.useContext((0, $524bc7b3eb0618a2$export$a7348e1183383d51));
    const { clientId: clientId } = (0, $eYoAG.useParams)();
    const { errorMessage: message, setErrorMessage: setErrorMessage } = (0, $dc97b0794e0fd33b$export$2e2bcd8739ae039)();
    const { getHelpDocuments: getHelpDocuments, getGlobalHelpDocuments: getGlobalHelpDocuments, updateDocumentTreeAfterFetch: updateDocumentTreeAfterFetch, getLatestHelpDocuments: getLatestHelpDocuments, deleteGlobalHelpDocument: deleteGlobalHelpDocument, deleteClientHelpDocument: deleteClientHelpDocument, updateClientHelpDocumentsSortOrder: updateClientHelpDocumentsSortOrder, updateDocumentTreeAfterDelete: updateDocumentTreeAfterDelete, updateGlobalHelpDocumentsSortOrder: updateGlobalHelpDocumentsSortOrder, getChildDocsToRenderEdit: getChildDocsToRenderEdit, documentsWithoutRoot: documentsWithoutRoot } = (0, $dfbf579bea9f90b3$export$2e2bcd8739ae039)();
    $ieT14.useEffect(()=>{
        dispatch({
            errorMessage: message
        });
    }, [
        message
    ]);
    // Clears success message after interval if success message is present on page load
    $ieT14.useEffect(()=>{
        const timer = setTimeout(()=>{
            if (successMessage) dispatch({
                successMessage: ''
            });
        }, 5000);
        return ()=>{
            if (timer) clearTimeout(timer);
        };
    }, []);
    // Clears error message after it appears in context
    $ieT14.useEffect(()=>{
        const timer = setTimeout(()=>{
            if (errorMessage) dispatch({
                errorMessage: ''
            });
        }, 5000);
        return ()=>{
            if (timer) clearTimeout(timer);
        };
    }, [
        errorMessage
    ]);
    /**
   * Fetches the help documents from the backend and puts them in context
   */ const fetchClientHelpDocuments = ()=>{
        getHelpDocuments(Number(clientId)).then((helpDocumentsRes)=>{
            dispatch({
                helpDocuments: createDocumentsList(helpDocumentsRes)
            });
        }).catch(()=>dispatch({
                loading: false
            }));
    };
    /**
   * Fetches the global help documents from the backend and puts them in context
   * @param update - Boolean indicate if the list of documents is being updated
   * @param globalContext - Indicates whether to use helpDocuments or globalHelpDocuments
   */ const fetchGlobalHelpDocuments = (update, globalContext)=>{
        getGlobalHelpDocuments().then((response)=>{
            if (!globalContext) dispatch({
                helpDocuments: update ? updateDocumentTreeAfterFetch(helpDocuments, response) : createDocumentsList(response)
            });
            else dispatch({
                globalHelpDocuments: createDocumentsList(response)
            });
        }).catch(()=>dispatch({
                loading: false
            }));
    };
    /**
   * Fetches the help documents with the latest revisions from the backend and puts them in context
   */ const fetchHelpDocumentsWithRevisions = (update)=>{
        return getLatestHelpDocuments(Number(clientId)).then((response)=>{
            dispatch({
                helpDocuments: update ? updateDocumentTreeAfterFetch(helpDocuments, response) : createDocumentsList(response)
            });
        }).catch(()=>dispatch({
                loading: false
            }));
    };
    /**
   * Deletes the selected global document
   * @param documentId - Identifier of the document to be deleted (snippetId)
   */ const triggerDeleteGlobalHelpDocument = (documentId)=>{
        dispatch({
            loading: true
        });
        return deleteGlobalHelpDocument(documentId).then(()=>{
            const documentTree = updateDocumentTreeAfterDelete(helpDocuments, documentId);
            dispatch({
                helpDocuments: documentTree,
                activeDocumentId: Number(documentTree.items['-1'].children[0]),
                loading: false
            });
            return documentTree;
        }).catch((error)=>{
            dispatch({
                loading: false
            });
            dispatch({
                errorMessage: error.responseJSON && error.responseJSON.message || 'Error deleting document, please try again or contact your System Administrator.'
            });
        });
    };
    /**
   * Deletes the selected client help document
   * @param documentId - Identifier of the document to be deleted (snippetId)
   */ const triggerDeleteClientHelpDocument = (documentId)=>{
        dispatch({
            loading: true
        });
        return deleteClientHelpDocument(clientId, documentId).then(()=>{
            const documentTree = updateDocumentTreeAfterDelete(helpDocuments, documentId);
            dispatch({
                helpDocuments: documentTree,
                activeDocumentId: Number(documentTree.items['-1'].children[0]),
                loading: false
            });
            return documentTree;
        }).catch((error)=>{
            dispatch({
                loading: false
            });
            dispatch({
                errorMessage: error.responseJSON && error.responseJSON.message || 'Error deleting document, please try again or contact your System Administrator.'
            });
            throw error;
        });
    };
    /**
   * Updates the sort order of the client help documents
   * @param snippetGroupId The identifier of the document that will be updated
   * @param newParentGroupId The identifier of the parent document that it will be moved to
   * @param sourceGroupIds All the children and subchildren of the document that was moved
   * @param destinationGroupId The identifier of the next document in the list
   * @param prevState - Previous state of the help documents to be used in case of an error
   */ const triggerUpdateClientDocumentsSortOrder = (snippetGroupId, newParentGroupId, sourceGroupIds, destinationGroupId, prevState)=>{
        updateClientHelpDocumentsSortOrder(Number(clientId), snippetGroupId, newParentGroupId, sourceGroupIds, destinationGroupId).catch((error)=>{
            setErrorMessage(error.responseJSON.message);
            dispatch({
                helpDocuments: prevState
            });
        });
    };
    /**
   * Updates the sort order of the global help documents
   * @param snippetGroupId The identifier of the document that will be updated
   * @param newParentGroupId The identifier of the parent document that it will be moved to
   * @param sourceGroupIds All the children and subchildren of the document that was moved
   * @param destinationGroupId The identifier of the next document in the list
   * @param prevState - Previous state of the help documents to be used in case of an error
   */ const triggerUpdateGlobalDocumentsSortOrder = (snippetGroupId, newParentGroupId, sourceGroupIds, destinationGroupId, prevState)=>{
        updateGlobalHelpDocumentsSortOrder(snippetGroupId, newParentGroupId, sourceGroupIds, destinationGroupId).catch((error)=>{
            setErrorMessage(error.responseJSON.message);
            dispatch({
                helpDocuments: prevState
            });
        });
    };
    /**
   * Changes the active document and checks if it matches the current document
   * @param params Parameters from the nav-link
   * @param location Location parameters from the nav-link
   * @param activeDocumentId Id of the document that the user selected
   */ const changeActiveDoc = (params, location, activeDocumentId)=>{
        if (params && location.state) {
            if (activeDocumentId === location.state.id) {
                dispatch({
                    activeDocumentId: activeDocumentId
                });
                return true;
            }
        }
        return false;
    };
    /**
   * Creates the document tree using the Atlassian Tree structure
   * @param documents - Array of all help documents
   */ const createDocumentsList = (documents)=>{
        const tree = {
            rootId: '-1',
            items: {
                '-1': {
                    id: '-1',
                    hasChildren: true,
                    isExpanded: true,
                    isChildrenLoading: false,
                    children: documents.filter((doc)=>doc.parentGroupId === 0).map((doc)=>doc.snippetGroupId)
                }
            }
        };
        const items = {};
        documents.forEach((document)=>{
            const childrenList = documents.filter((doc)=>doc.parentGroupId === document.snippetGroupId).map((doc)=>doc.snippetGroupId);
            items[document.snippetGroupId] = {
                id: document.snippetGroupId,
                hasChildren: childrenList.length > 0,
                isExpanded: true,
                isChildrenLoading: false,
                data: document,
                children: childrenList
            };
        });
        tree.items = {
            ...tree.items,
            ...items
        };
        return tree;
    };
    /**
   * Renders the help documents
   * @returns Array of JSX elements to render the help document contents
   */ const renderHelpContent = (isSearching)=>{
        if (helpDocuments.rootId && activeDocumentId) return getChildDocsToRenderEdit(activeDocumentId, helpDocuments).map((doc)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $54689d44f1f183ab$export$2e2bcd8739ae039), {
                document: doc,
                activeDoc: activeDocumentId,
                isSearching: isSearching
            }, `help-doc-${doc.snippetGroupId}`));
    };
    /**
   * Renders the preview for documents while searching
   * @param searchQuery The search query the user typed into the search bar
   * @param isSearching Boolean indicating whether or not the user is currently searching
   * @param setIsSearching Function to indicate whether the user is currently searching or not
   * @returns An array of JSX elements with the preview of the documents
   */ const renderPreviews = (searchQuery, isSearching, setIsSearching)=>{
        if (!isSearching) return;
        /** Regex that uses the search query and an ignore case modifier */ const regex = RegExp(searchQuery, 'i');
        /** Array of documents where either the title or the content match the search query */ const docsToPreview = documentsWithoutRoot(helpDocuments).map((doc)=>doc.data).filter((doc)=>regex.test(doc.title) || regex.test(doc.content));
        if (docsToPreview.length === 0) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
            children: "No Matching Documents"
        });
        const currentRoute = clientId ? `/clients/${clientId}/edit/help` : (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).GlobalHelpDocuments;
        return docsToPreview.map((doc)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $6mt9R.NavLink), {
                className: $2b36415f25d48604$export$8aade8ce2b5d7e87,
                onClick: ()=>setIsSearching(false),
                to: {
                    pathname: `${currentRoute}/${doc.snippetGroupId}`,
                    state: {
                        id: doc.snippetGroupId
                    }
                },
                isActive: (param, location)=>{
                    return changeActiveDoc(param, location, doc.snippetGroupId);
                },
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        children: doc.title
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: $2b36415f25d48604$export$48c2d0f2f545ac27,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $54689d44f1f183ab$export$2e2bcd8739ae039), {
                            document: doc,
                            activeDoc: 0,
                            isSearching: isSearching
                        }, `help-doc-${doc.snippetGroupId}`)
                    })
                ]
            }, `help-preview-${doc.snippetGroupId}`));
    };
    return {
        loading: loading,
        helpDocuments: helpDocuments,
        globalHelpDocuments: globalHelpDocuments,
        activeDocumentId: activeDocumentId,
        clientList: clientList,
        dispatch: dispatch,
        errorMessage: errorMessage,
        successMessage: successMessage,
        fetchClientHelpDocuments: fetchClientHelpDocuments,
        fetchGlobalHelpDocuments: fetchGlobalHelpDocuments,
        fetchHelpDocumentsWithRevisions: fetchHelpDocumentsWithRevisions,
        changeActiveDoc: changeActiveDoc,
        renderHelpContent: renderHelpContent,
        renderPreviews: renderPreviews,
        createDocumentsList: createDocumentsList,
        updateClientDocumentsSortOrder: triggerUpdateClientDocumentsSortOrder,
        updateGlobalDocumentsSortOrder: triggerUpdateGlobalDocumentsSortOrder,
        deleteGlobalHelpDocument: triggerDeleteGlobalHelpDocument,
        deleteClientHelpDocument: triggerDeleteClientHelpDocument
    };
};
var $c807f91b5abb1e86$export$2e2bcd8739ae039 = $c807f91b5abb1e86$var$useHelpDocuments;




var $ieT14 = parcelRequire("ieT14");






var $eYoAG = parcelRequire("eYoAG");





parcelRequire("ieT14");

var $fRnKy = parcelRequire("fRnKy");




var $j6s32 = parcelRequire("j6s32");
var $c3f46f9735a25a96$exports = {};
function $c3f46f9735a25a96$var$_extends() {
    return $c3f46f9735a25a96$exports = $c3f46f9735a25a96$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c3f46f9735a25a96$exports.__esModule = true, $c3f46f9735a25a96$exports["default"] = $c3f46f9735a25a96$exports, $c3f46f9735a25a96$var$_extends.apply(null, arguments);
}
$c3f46f9735a25a96$exports = $c3f46f9735a25a96$var$_extends, $c3f46f9735a25a96$exports.__esModule = true, $c3f46f9735a25a96$exports["default"] = $c3f46f9735a25a96$exports;


var $6b5d58ae6912feb1$exports = {};
function $6b5d58ae6912feb1$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
$6b5d58ae6912feb1$exports = $6b5d58ae6912feb1$var$_classCallCheck, $6b5d58ae6912feb1$exports.__esModule = true, $6b5d58ae6912feb1$exports["default"] = $6b5d58ae6912feb1$exports;


var $5debd17a1d994b8d$exports = {};
var $263cb649ce89bab5$exports = {};
var $d7e718cb624c6e18$exports = {};
function $d7e718cb624c6e18$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d7e718cb624c6e18$exports = $d7e718cb624c6e18$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d7e718cb624c6e18$exports.__esModule = true, $d7e718cb624c6e18$exports["default"] = $d7e718cb624c6e18$exports, $d7e718cb624c6e18$var$_typeof(o);
}
$d7e718cb624c6e18$exports = $d7e718cb624c6e18$var$_typeof, $d7e718cb624c6e18$exports.__esModule = true, $d7e718cb624c6e18$exports["default"] = $d7e718cb624c6e18$exports;


var $263cb649ce89bab5$var$_typeof = $d7e718cb624c6e18$exports.default;
var $74c2d90c3fe51272$exports = {};

var $74c2d90c3fe51272$var$_typeof = $d7e718cb624c6e18$exports.default;
function $74c2d90c3fe51272$var$toPrimitive(t, r) {
    if ("object" != $74c2d90c3fe51272$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $74c2d90c3fe51272$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$74c2d90c3fe51272$exports = $74c2d90c3fe51272$var$toPrimitive, $74c2d90c3fe51272$exports.__esModule = true, $74c2d90c3fe51272$exports["default"] = $74c2d90c3fe51272$exports;


function $263cb649ce89bab5$var$toPropertyKey(t) {
    var i = $74c2d90c3fe51272$exports(t, "string");
    return "symbol" == $263cb649ce89bab5$var$_typeof(i) ? i : i + "";
}
$263cb649ce89bab5$exports = $263cb649ce89bab5$var$toPropertyKey, $263cb649ce89bab5$exports.__esModule = true, $263cb649ce89bab5$exports["default"] = $263cb649ce89bab5$exports;


function $5debd17a1d994b8d$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $263cb649ce89bab5$exports(o.key), o);
    }
}
function $5debd17a1d994b8d$var$_createClass(e, r, t) {
    return r && $5debd17a1d994b8d$var$_defineProperties(e.prototype, r), t && $5debd17a1d994b8d$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
$5debd17a1d994b8d$exports = $5debd17a1d994b8d$var$_createClass, $5debd17a1d994b8d$exports.__esModule = true, $5debd17a1d994b8d$exports["default"] = $5debd17a1d994b8d$exports;


var $f96fea7485054db2$exports = {};
function $f96fea7485054db2$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
$f96fea7485054db2$exports = $f96fea7485054db2$var$_assertThisInitialized, $f96fea7485054db2$exports.__esModule = true, $f96fea7485054db2$exports["default"] = $f96fea7485054db2$exports;


var $69c14df2b00cc6b7$exports = {};
var $e56930fba480ad18$exports = {};
function $e56930fba480ad18$var$_setPrototypeOf(t, e) {
    return $e56930fba480ad18$exports = $e56930fba480ad18$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $e56930fba480ad18$exports.__esModule = true, $e56930fba480ad18$exports["default"] = $e56930fba480ad18$exports, $e56930fba480ad18$var$_setPrototypeOf(t, e);
}
$e56930fba480ad18$exports = $e56930fba480ad18$var$_setPrototypeOf, $e56930fba480ad18$exports.__esModule = true, $e56930fba480ad18$exports["default"] = $e56930fba480ad18$exports;


function $69c14df2b00cc6b7$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $e56930fba480ad18$exports(t, e);
}
$69c14df2b00cc6b7$exports = $69c14df2b00cc6b7$var$_inherits, $69c14df2b00cc6b7$exports.__esModule = true, $69c14df2b00cc6b7$exports["default"] = $69c14df2b00cc6b7$exports;


var $6a9451cd79a02d8d$exports = {};

var $6a9451cd79a02d8d$var$_typeof = $d7e718cb624c6e18$exports.default;

function $6a9451cd79a02d8d$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $6a9451cd79a02d8d$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $f96fea7485054db2$exports(t);
}
$6a9451cd79a02d8d$exports = $6a9451cd79a02d8d$var$_possibleConstructorReturn, $6a9451cd79a02d8d$exports.__esModule = true, $6a9451cd79a02d8d$exports["default"] = $6a9451cd79a02d8d$exports;


var $0028efb354ad91cb$exports = {};
function $0028efb354ad91cb$var$_getPrototypeOf(t) {
    return $0028efb354ad91cb$exports = $0028efb354ad91cb$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $0028efb354ad91cb$exports.__esModule = true, $0028efb354ad91cb$exports["default"] = $0028efb354ad91cb$exports, $0028efb354ad91cb$var$_getPrototypeOf(t);
}
$0028efb354ad91cb$exports = $0028efb354ad91cb$var$_getPrototypeOf, $0028efb354ad91cb$exports.__esModule = true, $0028efb354ad91cb$exports["default"] = $0028efb354ad91cb$exports;


var $610273e25df12631$exports = {};

function $610273e25df12631$var$_defineProperty(e, r, t) {
    return (r = $263cb649ce89bab5$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$610273e25df12631$exports = $610273e25df12631$var$_defineProperty, $610273e25df12631$exports.__esModule = true, $610273e25df12631$exports["default"] = $610273e25df12631$exports;



var $ieT14 = parcelRequire("ieT14");


var $ieT14 = parcelRequire("ieT14");



var $kuuqU = parcelRequire("kuuqU");










var $bd7d663e2fcda8c2$var$isProduction = true;
var $bd7d663e2fcda8c2$var$spacesAndTabs = /[ \t]{2,}/g;
var $bd7d663e2fcda8c2$var$lineStartWithSpaces = /^[ \t]*/gm;
var $bd7d663e2fcda8c2$var$clean = function clean(value) {
    return value.replace($bd7d663e2fcda8c2$var$spacesAndTabs, ' ').replace($bd7d663e2fcda8c2$var$lineStartWithSpaces, '').trim();
};
var $bd7d663e2fcda8c2$var$getDevMessage = function getDevMessage(message) {
    return $bd7d663e2fcda8c2$var$clean("\n  %creact-beautiful-dnd\n\n  %c" + $bd7d663e2fcda8c2$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};
var $bd7d663e2fcda8c2$var$getFormattedMessage = function getFormattedMessage(message) {
    return [
        $bd7d663e2fcda8c2$var$getDevMessage(message),
        'color: #00C584; font-size: 1.2em; font-weight: bold;',
        'line-height: 1.5',
        'color: #723874;'
    ];
};
var $bd7d663e2fcda8c2$var$isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';
var $bd7d663e2fcda8c2$var$warning = function warning(message) {
    var _console;
    if ($bd7d663e2fcda8c2$var$isProduction) return;
    if (typeof window !== 'undefined' && window[$bd7d663e2fcda8c2$var$isDisabledFlag]) return;
    (_console = console).warn.apply(_console, $bd7d663e2fcda8c2$var$getFormattedMessage(message));
};
function $bd7d663e2fcda8c2$var$printFatalError(error) {
    var _console;
    return;
}
function $bd7d663e2fcda8c2$var$shouldRecover(error) {
    return error.message.indexOf('Invariant failed') !== -1;
}
var $bd7d663e2fcda8c2$var$ErrorBoundary = function(_React$Component) {
    (0, $31b5b7cf3016567e$export$2e2bcd8739ae039)(ErrorBoundary, _React$Component);
    function ErrorBoundary() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.onError = void 0;
        _this.setOnError = function(fn) {
            _this.onError = fn;
        };
        _this.onFatalError = function(error) {
            $bd7d663e2fcda8c2$var$printFatalError(error);
            if (_this.onError) _this.onError();
            if ($bd7d663e2fcda8c2$var$shouldRecover(error)) _this.setState({});
        };
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidMount = function componentDidMount() {
        window.addEventListener('error', this.onFatalError);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('error', this.onFatalError);
    };
    _proto.componentDidCatch = function componentDidCatch(error) {
        this.onFatalError(error);
        if (!$bd7d663e2fcda8c2$var$shouldRecover(error)) throw error;
    };
    _proto.render = function render() {
        return this.props.children(this.setOnError);
    };
    return ErrorBoundary;
}((0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).Component);
var $bd7d663e2fcda8c2$var$origin = {
    x: 0,
    y: 0
};
var $bd7d663e2fcda8c2$var$add = function add(point1, point2) {
    return {
        x: point1.x + point2.x,
        y: point1.y + point2.y
    };
};
var $bd7d663e2fcda8c2$var$subtract = function subtract(point1, point2) {
    return {
        x: point1.x - point2.x,
        y: point1.y - point2.y
    };
};
var $bd7d663e2fcda8c2$var$isEqual = function isEqual(point1, point2) {
    return point1.x === point2.x && point1.y === point2.y;
};
var $bd7d663e2fcda8c2$var$negate = function negate(point) {
    return {
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    };
};
var $bd7d663e2fcda8c2$var$patch = function patch(line, value, otherValue) {
    var _ref;
    if (otherValue === void 0) otherValue = 0;
    return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};
var $bd7d663e2fcda8c2$var$distance = function distance(point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var $bd7d663e2fcda8c2$var$closest = function closest(target, points) {
    return Math.min.apply(Math, points.map(function(point) {
        return $bd7d663e2fcda8c2$var$distance(target, point);
    }));
};
var $bd7d663e2fcda8c2$var$apply = function apply(fn) {
    return function(point) {
        return {
            x: fn(point.x),
            y: fn(point.y)
        };
    };
};
var $bd7d663e2fcda8c2$var$executeClip = function(frame, subject) {
    var result = (0, $b703e4029dc36ed5$export$4b834cebd9e5cebe)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
var $bd7d663e2fcda8c2$var$isEqual$1 = function isEqual(first, second) {
    return first.top === second.top && first.right === second.right && first.bottom === second.bottom && first.left === second.left;
};
var $bd7d663e2fcda8c2$var$offsetByPosition = function offsetByPosition(spacing, point) {
    return {
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    };
};
var $bd7d663e2fcda8c2$var$getCorners = function getCorners(spacing) {
    return [
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
};
var $bd7d663e2fcda8c2$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $bd7d663e2fcda8c2$var$scroll = function scroll(target, frame) {
    if (!frame) return target;
    return $bd7d663e2fcda8c2$var$offsetByPosition(target, frame.scroll.diff.displacement);
};
var $bd7d663e2fcda8c2$var$increase = function increase(target, axis, withPlaceholder) {
    if (withPlaceholder && withPlaceholder.increasedBy) {
        var _extends2;
        return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
    }
    return target;
};
var $bd7d663e2fcda8c2$var$clip = function clip(target, frame) {
    if (frame && frame.shouldClipSubject) return $bd7d663e2fcda8c2$var$executeClip(frame.pageMarginBox, target);
    return (0, $b703e4029dc36ed5$export$4b834cebd9e5cebe)(target);
};
var $bd7d663e2fcda8c2$var$getSubject = function(_ref) {
    var page = _ref.page, withPlaceholder = _ref.withPlaceholder, axis = _ref.axis, frame = _ref.frame;
    var scrolled = $bd7d663e2fcda8c2$var$scroll(page.marginBox, frame);
    var increased = $bd7d663e2fcda8c2$var$increase(scrolled, axis, withPlaceholder);
    var clipped = $bd7d663e2fcda8c2$var$clip(increased, frame);
    return {
        page: page,
        withPlaceholder: withPlaceholder,
        active: clipped
    };
};
var $bd7d663e2fcda8c2$var$scrollDroppable = function(droppable, newScroll) {
    !droppable.frame && (0, $kuuqU.default)(false);
    var scrollable = droppable.frame;
    var scrollDiff = $bd7d663e2fcda8c2$var$subtract(newScroll, scrollable.scroll.initial);
    var scrollDisplacement = $bd7d663e2fcda8c2$var$negate(scrollDiff);
    var frame = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, scrollable, {
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    });
    var subject = $bd7d663e2fcda8c2$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame: frame
    });
    var result = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, droppable, {
        frame: frame,
        subject: subject
    });
    return result;
};
var $bd7d663e2fcda8c2$var$records = {};
var $bd7d663e2fcda8c2$var$isEnabled = false;
var $bd7d663e2fcda8c2$var$isTimingsEnabled = function isTimingsEnabled() {
    return $bd7d663e2fcda8c2$var$isEnabled;
};
var $bd7d663e2fcda8c2$var$start = function start(key) {
    var now;
};
var $bd7d663e2fcda8c2$var$finish = function finish(key) {
    var now, previous, result, rounded, style;
};
var $bd7d663e2fcda8c2$var$whatIsDraggedOver = function(impact) {
    var merge = impact.merge, destination = impact.destination;
    if (destination) return destination.droppableId;
    if (merge) return merge.combine.droppableId;
    return null;
};
function $bd7d663e2fcda8c2$var$values(map) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9af2d53c4ea14e37$exports)))(map);
}
function $bd7d663e2fcda8c2$var$findIndex(list, predicate) {
    if (list.findIndex) return list.findIndex(predicate);
    for(var i = 0; i < list.length; i++){
        if (predicate(list[i])) return i;
    }
    return -1;
}
function $bd7d663e2fcda8c2$var$find(list, predicate) {
    if (list.find) return list.find(predicate);
    var index = $bd7d663e2fcda8c2$var$findIndex(list, predicate);
    if (index !== -1) return list[index];
    return undefined;
}
var $bd7d663e2fcda8c2$var$toDroppableMap = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(droppables) {
    return droppables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $bd7d663e2fcda8c2$var$toDraggableMap = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(draggables) {
    return draggables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var $bd7d663e2fcda8c2$var$toDroppableList = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(droppables) {
    return $bd7d663e2fcda8c2$var$values(droppables);
});
var $bd7d663e2fcda8c2$var$toDraggableList = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(draggables) {
    return $bd7d663e2fcda8c2$var$values(draggables);
});
var $bd7d663e2fcda8c2$var$isWithin = function(lowerBound, upperBound) {
    return function(value) {
        return lowerBound <= value && value <= upperBound;
    };
};
var $bd7d663e2fcda8c2$var$isPositionInFrame = function(frame) {
    var isWithinVertical = $bd7d663e2fcda8c2$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $bd7d663e2fcda8c2$var$isWithin(frame.left, frame.right);
    return function(point) {
        return isWithinVertical(point.y) && isWithinVertical(point.y) && isWithinHorizontal(point.x) && isWithinHorizontal(point.x);
    };
};
var $bd7d663e2fcda8c2$var$getDroppableOver = function(_ref) {
    var target = _ref.target, droppables = _ref.droppables;
    var maybe = $bd7d663e2fcda8c2$var$find($bd7d663e2fcda8c2$var$toDroppableList(droppables), function(droppable) {
        if (!droppable.isEnabled) return false;
        var active = droppable.subject.active;
        if (!active) return false;
        return $bd7d663e2fcda8c2$var$isPositionInFrame(active)(target);
    });
    return maybe ? maybe.descriptor.id : null;
};
var $bd7d663e2fcda8c2$var$getDraggablesInsideDroppable = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(droppableId, draggables) {
    var result = $bd7d663e2fcda8c2$var$toDraggableList(draggables).filter(function(draggable) {
        return droppableId === draggable.descriptor.droppableId;
    }).sort(function(a, b) {
        return a.descriptor.index - b.descriptor.index;
    });
    return result;
});
var $bd7d663e2fcda8c2$var$withDroppableScroll = function(droppable, point) {
    var frame = droppable.frame;
    if (!frame) return point;
    return $bd7d663e2fcda8c2$var$add(point, frame.scroll.diff.value);
};
var $bd7d663e2fcda8c2$var$vertical = {
    direction: 'vertical',
    line: 'y',
    crossAxisLine: 'x',
    start: 'top',
    end: 'bottom',
    size: 'height',
    crossAxisStart: 'left',
    crossAxisEnd: 'right',
    crossAxisSize: 'width'
};
var $bd7d663e2fcda8c2$var$horizontal = {
    direction: 'horizontal',
    line: 'x',
    crossAxisLine: 'y',
    start: 'left',
    end: 'right',
    size: 'width',
    crossAxisStart: 'top',
    crossAxisEnd: 'bottom',
    crossAxisSize: 'height'
};
var $bd7d663e2fcda8c2$var$isUserMovingForward = function(axis, direction) {
    return axis === $bd7d663e2fcda8c2$var$vertical ? direction.vertical === 'down' : direction.horizontal === 'right';
};
var $bd7d663e2fcda8c2$var$didStartDisplaced = function(draggableId, onLift) {
    return Boolean(onLift.wasDisplaced[draggableId]);
};
var $bd7d663e2fcda8c2$var$getCombinedItemDisplacement = function(_ref) {
    var displaced = _ref.displaced, onLift = _ref.onLift, combineWith = _ref.combineWith, displacedBy = _ref.displacedBy;
    var isDisplaced = Boolean(displaced[combineWith]);
    if ($bd7d663e2fcda8c2$var$didStartDisplaced(combineWith, onLift)) return isDisplaced ? $bd7d663e2fcda8c2$var$origin : $bd7d663e2fcda8c2$var$negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : $bd7d663e2fcda8c2$var$origin;
};
var $bd7d663e2fcda8c2$var$getWhenEntered = function getWhenEntered(id, current, oldMerge) {
    if (!oldMerge) return current;
    if (id !== oldMerge.combine.draggableId) return current;
    return oldMerge.whenEntered;
};
var $bd7d663e2fcda8c2$var$isCombiningWith = function isCombiningWith(_ref) {
    var id = _ref.id, currentCenter = _ref.currentCenter, axis = _ref.axis, borderBox = _ref.borderBox, displaceBy = _ref.displaceBy, currentUserDirection = _ref.currentUserDirection, oldMerge = _ref.oldMerge;
    var start = borderBox[axis.start] + displaceBy[axis.line];
    var end = borderBox[axis.end] + displaceBy[axis.line];
    var size = borderBox[axis.size];
    var twoThirdsOfSize = size * 0.666;
    var whenEntered = $bd7d663e2fcda8c2$var$getWhenEntered(id, currentUserDirection, oldMerge);
    var isMovingForward = $bd7d663e2fcda8c2$var$isUserMovingForward(axis, whenEntered);
    var targetCenter = currentCenter[axis.line];
    if (isMovingForward) return $bd7d663e2fcda8c2$var$isWithin(start, start + twoThirdsOfSize)(targetCenter);
    return $bd7d663e2fcda8c2$var$isWithin(end - twoThirdsOfSize, end)(targetCenter);
};
var $bd7d663e2fcda8c2$var$getCombineImpact = function(_ref2) {
    var currentCenter = _ref2.pageBorderBoxCenterWithDroppableScrollChange, previousImpact = _ref2.previousImpact, destination = _ref2.destination, insideDestinationWithoutDraggable = _ref2.insideDestinationWithoutDraggable, userDirection = _ref2.userDirection, onLift = _ref2.onLift;
    if (!destination.isCombineEnabled) return null;
    var axis = destination.axis;
    var map = previousImpact.movement.map;
    var canBeDisplacedBy = previousImpact.movement.displacedBy;
    var oldMerge = previousImpact.merge;
    var target = $bd7d663e2fcda8c2$var$find(insideDestinationWithoutDraggable, function(child) {
        var id = child.descriptor.id;
        var displaceBy = $bd7d663e2fcda8c2$var$getCombinedItemDisplacement({
            displaced: map,
            onLift: onLift,
            combineWith: id,
            displacedBy: canBeDisplacedBy
        });
        return $bd7d663e2fcda8c2$var$isCombiningWith({
            id: id,
            currentCenter: currentCenter,
            axis: axis,
            borderBox: child.page.borderBox,
            displaceBy: displaceBy,
            currentUserDirection: userDirection,
            oldMerge: oldMerge
        });
    });
    if (!target) return null;
    var merge = {
        whenEntered: $bd7d663e2fcda8c2$var$getWhenEntered(target.descriptor.id, userDirection, oldMerge),
        combine: {
            draggableId: target.descriptor.id,
            droppableId: destination.descriptor.id
        }
    };
    var withMerge = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, previousImpact, {
        destination: null,
        merge: merge
    });
    return withMerge;
};
var $bd7d663e2fcda8c2$var$isPartiallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $bd7d663e2fcda8c2$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $bd7d663e2fcda8c2$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var $bd7d663e2fcda8c2$var$isTotallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = $bd7d663e2fcda8c2$var$isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = $bd7d663e2fcda8c2$var$isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
var $bd7d663e2fcda8c2$var$isTotallyVisibleThroughFrameOnAxis = function(axis) {
    return function(frame) {
        var isWithinVertical = $bd7d663e2fcda8c2$var$isWithin(frame.top, frame.bottom);
        var isWithinHorizontal = $bd7d663e2fcda8c2$var$isWithin(frame.left, frame.right);
        return function(subject) {
            if (axis === $bd7d663e2fcda8c2$var$vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
};
var $bd7d663e2fcda8c2$var$getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
    var displacement = destination.frame ? destination.frame.scroll.diff.displacement : $bd7d663e2fcda8c2$var$origin;
    return $bd7d663e2fcda8c2$var$offsetByPosition(target, displacement);
};
var $bd7d663e2fcda8c2$var$isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
var $bd7d663e2fcda8c2$var$isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
    return isVisibleThroughFrameFn(viewport)(target);
};
var $bd7d663e2fcda8c2$var$isVisible = function isVisible(_ref) {
    var toBeDisplaced = _ref.target, destination = _ref.destination, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
    var displacedTarget = withDroppableDisplacement ? $bd7d663e2fcda8c2$var$getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return $bd7d663e2fcda8c2$var$isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && $bd7d663e2fcda8c2$var$isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
var $bd7d663e2fcda8c2$var$isPartiallyVisible = function isPartiallyVisible(args) {
    return $bd7d663e2fcda8c2$var$isVisible((0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, args, {
        isVisibleThroughFrameFn: $bd7d663e2fcda8c2$var$isPartiallyVisibleThroughFrame
    }));
};
var $bd7d663e2fcda8c2$var$isTotallyVisible = function isTotallyVisible(args) {
    return $bd7d663e2fcda8c2$var$isVisible((0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, args, {
        isVisibleThroughFrameFn: $bd7d663e2fcda8c2$var$isTotallyVisibleThroughFrame
    }));
};
var $bd7d663e2fcda8c2$var$isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
    return $bd7d663e2fcda8c2$var$isVisible((0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, args, {
        isVisibleThroughFrameFn: $bd7d663e2fcda8c2$var$isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    }));
};
var $bd7d663e2fcda8c2$var$getShouldAnimate = function getShouldAnimate(forceShouldAnimate, isVisible, previous) {
    if (typeof forceShouldAnimate === 'boolean') return forceShouldAnimate;
    if (!isVisible) return false;
    if (!previous) return true;
    return previous.shouldAnimate;
};
var $bd7d663e2fcda8c2$var$getTarget = function getTarget(draggable, onLift) {
    var marginBox = draggable.page.marginBox;
    if (!$bd7d663e2fcda8c2$var$didStartDisplaced(draggable.descriptor.id, onLift)) return marginBox;
    var expandBy = {
        top: onLift.displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: onLift.displacedBy.point.x
    };
    return (0, $b703e4029dc36ed5$export$4b834cebd9e5cebe)((0, $b703e4029dc36ed5$export$9f77e0932fb78f72)(marginBox, expandBy));
};
var $bd7d663e2fcda8c2$var$getDisplacement = function(_ref) {
    var draggable = _ref.draggable, destination = _ref.destination, previousImpact = _ref.previousImpact, viewport = _ref.viewport, onLift = _ref.onLift, forceShouldAnimate = _ref.forceShouldAnimate;
    var id = draggable.descriptor.id;
    var map = previousImpact.movement.map;
    var target = $bd7d663e2fcda8c2$var$getTarget(draggable, onLift);
    var isVisible = $bd7d663e2fcda8c2$var$isPartiallyVisible({
        target: target,
        destination: destination,
        viewport: viewport,
        withDroppableDisplacement: true
    });
    var shouldAnimate = $bd7d663e2fcda8c2$var$getShouldAnimate(forceShouldAnimate, isVisible, map[id]);
    var displacement = {
        draggableId: id,
        isVisible: isVisible,
        shouldAnimate: shouldAnimate
    };
    return displacement;
};
var $bd7d663e2fcda8c2$var$getDisplacementMap = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(displaced) {
    return displaced.reduce(function(map, displacement) {
        map[displacement.draggableId] = displacement;
        return map;
    }, {});
});
var $bd7d663e2fcda8c2$var$getDisplacedBy = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(axis, displaceBy) {
    var displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: $bd7d663e2fcda8c2$var$patch(axis.line, displacement)
    };
});
var $bd7d663e2fcda8c2$var$getReorderImpact = function(_ref) {
    var currentCenter = _ref.pageBorderBoxCenterWithDroppableScrollChange, draggable = _ref.draggable, destination = _ref.destination, insideDestinationWithoutDraggable = _ref.insideDestinationWithoutDraggable, previousImpact = _ref.previousImpact, viewport = _ref.viewport, userDirection = _ref.userDirection, onLift = _ref.onLift;
    var axis = destination.axis;
    var isMovingForward = $bd7d663e2fcda8c2$var$isUserMovingForward(destination.axis, userDirection);
    var displacedBy = $bd7d663e2fcda8c2$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var targetCenter = currentCenter[axis.line];
    var displacement = displacedBy.value;
    var displaced = insideDestinationWithoutDraggable.filter(function(child) {
        var borderBox = child.page.borderBox;
        var start = borderBox[axis.start];
        var end = borderBox[axis.end];
        var didStartDisplaced$1 = $bd7d663e2fcda8c2$var$didStartDisplaced(child.descriptor.id, onLift);
        if (isMovingForward) {
            if (didStartDisplaced$1) return targetCenter < start;
            return targetCenter < start + displacement;
        }
        if (didStartDisplaced$1) return targetCenter <= end - displacement;
        return targetCenter <= end;
    }).map(function(dimension) {
        return $bd7d663e2fcda8c2$var$getDisplacement({
            draggable: dimension,
            destination: destination,
            previousImpact: previousImpact,
            viewport: viewport.frame,
            onLift: onLift
        });
    });
    var newIndex = insideDestinationWithoutDraggable.length - displaced.length;
    var movement = {
        displacedBy: displacedBy,
        displaced: displaced,
        map: $bd7d663e2fcda8c2$var$getDisplacementMap(displaced)
    };
    var impact = {
        movement: movement,
        destination: {
            droppableId: destination.descriptor.id,
            index: newIndex
        },
        merge: null
    };
    return impact;
};
var $bd7d663e2fcda8c2$var$noDisplacedBy = {
    point: $bd7d663e2fcda8c2$var$origin,
    value: 0
};
var $bd7d663e2fcda8c2$var$noMovement = {
    displaced: [],
    map: {},
    displacedBy: $bd7d663e2fcda8c2$var$noDisplacedBy
};
var $bd7d663e2fcda8c2$var$noImpact = {
    movement: $bd7d663e2fcda8c2$var$noMovement,
    destination: null,
    merge: null
};
var $bd7d663e2fcda8c2$var$removeDraggableFromList = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(remove, list) {
    return list.filter(function(item) {
        return item.descriptor.id !== remove.descriptor.id;
    });
});
var $bd7d663e2fcda8c2$var$getDragImpact = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, draggable = _ref.draggable, draggables = _ref.draggables, droppables = _ref.droppables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, userDirection = _ref.userDirection, onLift = _ref.onLift;
    var destinationId = $bd7d663e2fcda8c2$var$getDroppableOver({
        target: pageBorderBoxCenter,
        droppables: droppables
    });
    if (!destinationId) return $bd7d663e2fcda8c2$var$noImpact;
    var destination = droppables[destinationId];
    var insideDestination = $bd7d663e2fcda8c2$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var insideDestinationWithoutDraggable = $bd7d663e2fcda8c2$var$removeDraggableFromList(draggable, insideDestination);
    var pageBorderBoxCenterWithDroppableScrollChange = $bd7d663e2fcda8c2$var$withDroppableScroll(destination, pageBorderBoxCenter);
    var withMerge = $bd7d663e2fcda8c2$var$getCombineImpact({
        pageBorderBoxCenterWithDroppableScrollChange: pageBorderBoxCenterWithDroppableScrollChange,
        previousImpact: previousImpact,
        destination: destination,
        insideDestinationWithoutDraggable: insideDestinationWithoutDraggable,
        userDirection: userDirection,
        onLift: onLift
    });
    if (withMerge) return withMerge;
    return $bd7d663e2fcda8c2$var$getReorderImpact({
        pageBorderBoxCenterWithDroppableScrollChange: pageBorderBoxCenterWithDroppableScrollChange,
        destination: destination,
        draggable: draggable,
        insideDestinationWithoutDraggable: insideDestinationWithoutDraggable,
        previousImpact: previousImpact,
        viewport: viewport,
        userDirection: userDirection,
        onLift: onLift
    });
};
var $bd7d663e2fcda8c2$var$getHomeLocation = function(descriptor) {
    return {
        index: descriptor.index,
        droppableId: descriptor.droppableId
    };
};
var $bd7d663e2fcda8c2$var$getHomeOnLift = function(_ref) {
    var draggable = _ref.draggable, home = _ref.home, draggables = _ref.draggables, viewport = _ref.viewport;
    var displacedBy = $bd7d663e2fcda8c2$var$getDisplacedBy(home.axis, draggable.displaceBy);
    var insideHome = $bd7d663e2fcda8c2$var$getDraggablesInsideDroppable(home.descriptor.id, draggables);
    var originallyDisplaced = insideHome.slice(draggable.descriptor.index + 1);
    var wasDisplaced = originallyDisplaced.reduce(function(previous, item) {
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    var onLift = {
        displacedBy: displacedBy,
        wasDisplaced: wasDisplaced
    };
    var displaced = originallyDisplaced.map(function(dimension) {
        return $bd7d663e2fcda8c2$var$getDisplacement({
            draggable: dimension,
            destination: home,
            previousImpact: $bd7d663e2fcda8c2$var$noImpact,
            viewport: viewport.frame,
            forceShouldAnimate: false,
            onLift: onLift
        });
    });
    var movement = {
        displaced: displaced,
        map: $bd7d663e2fcda8c2$var$getDisplacementMap(displaced),
        displacedBy: displacedBy
    };
    var impact = {
        movement: movement,
        destination: $bd7d663e2fcda8c2$var$getHomeLocation(draggable.descriptor),
        merge: null
    };
    return {
        impact: impact,
        onLift: onLift
    };
};
var $bd7d663e2fcda8c2$var$getDragPositions = function(_ref) {
    var oldInitial = _ref.initial, oldCurrent = _ref.current, oldClientBorderBoxCenter = _ref.oldClientBorderBoxCenter, newClientBorderBoxCenter = _ref.newClientBorderBoxCenter, viewport = _ref.viewport;
    var shift = $bd7d663e2fcda8c2$var$subtract(newClientBorderBoxCenter, oldClientBorderBoxCenter);
    var initial = function() {
        var client = {
            selection: $bd7d663e2fcda8c2$var$add(oldInitial.client.selection, shift),
            borderBoxCenter: newClientBorderBoxCenter,
            offset: $bd7d663e2fcda8c2$var$origin
        };
        var page = {
            selection: $bd7d663e2fcda8c2$var$add(client.selection, viewport.scroll.initial),
            borderBoxCenter: $bd7d663e2fcda8c2$var$add(client.selection, viewport.scroll.initial)
        };
        return {
            client: client,
            page: page
        };
    }();
    var current = function() {
        var reverse = $bd7d663e2fcda8c2$var$negate(shift);
        var offset = $bd7d663e2fcda8c2$var$add(oldCurrent.client.offset, reverse);
        var client = {
            selection: $bd7d663e2fcda8c2$var$add(initial.client.selection, offset),
            borderBoxCenter: $bd7d663e2fcda8c2$var$add(initial.client.borderBoxCenter, offset),
            offset: offset
        };
        var page = {
            selection: $bd7d663e2fcda8c2$var$add(client.selection, viewport.scroll.current),
            borderBoxCenter: $bd7d663e2fcda8c2$var$add(client.borderBoxCenter, viewport.scroll.current)
        };
        !$bd7d663e2fcda8c2$var$isEqual(oldCurrent.client.borderBoxCenter, client.borderBoxCenter) && (0, $kuuqU.default)(false);
        return {
            client: client,
            page: page
        };
    }();
    return {
        current: current,
        initial: initial
    };
};
var $bd7d663e2fcda8c2$var$offsetDraggable = function(_ref) {
    var draggable = _ref.draggable, offset$1 = _ref.offset, initialWindowScroll = _ref.initialWindowScroll;
    var client = (0, $b703e4029dc36ed5$export$cc800923e997bb8)(draggable.client, offset$1);
    var page = (0, $b703e4029dc36ed5$export$1d0caec378d7d0ae)(client, initialWindowScroll);
    var moved = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, draggable, {
        placeholder: (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, draggable.placeholder, {
            client: client
        }),
        client: client,
        page: page
    });
    return moved;
};
var $bd7d663e2fcda8c2$var$adjustExistingForAdditionsAndRemovals = function(_ref) {
    var existing = _ref.existing, droppables = _ref.droppables, addedDraggables = _ref.additions, removedDraggables = _ref.removals, viewport = _ref.viewport;
    var shifted = {};
    $bd7d663e2fcda8c2$var$toDroppableList(droppables).forEach(function(droppable) {
        var axis = droppable.axis;
        var original = $bd7d663e2fcda8c2$var$getDraggablesInsideDroppable(droppable.descriptor.id, existing);
        var toShift = {};
        var addShift = function addShift(id, shift) {
            var previous = toShift[id];
            if (!previous) {
                toShift[id] = shift;
                return;
            }
            toShift[id] = {
                indexChange: previous.indexChange + shift.indexChange,
                offset: $bd7d663e2fcda8c2$var$add(previous.offset, shift.offset)
            };
        };
        var removals = $bd7d663e2fcda8c2$var$toDraggableMap(removedDraggables.map(function(id) {
            var item = existing[id];
            !item && (0, $kuuqU.default)(false);
            return item;
        }).filter(function(draggable) {
            return draggable.descriptor.droppableId === droppable.descriptor.id;
        }));
        var withRemovals = original.filter(function(item, index) {
            var isBeingRemoved = Boolean(removals[item.descriptor.id]);
            if (!isBeingRemoved) return true;
            var offset = $bd7d663e2fcda8c2$var$negate($bd7d663e2fcda8c2$var$patch(axis.line, item.displaceBy[axis.line]));
            original.slice(index).forEach(function(sibling) {
                if (removals[sibling.descriptor.id]) return;
                addShift(sibling.descriptor.id, {
                    indexChange: -1,
                    offset: offset
                });
            });
            return false;
        });
        var additions = addedDraggables.filter(function(draggable) {
            return draggable.descriptor.droppableId === droppable.descriptor.id;
        });
        var withAdditions = withRemovals.slice(0);
        additions.forEach(function(item) {
            withAdditions.splice(item.descriptor.index, 0, item);
        });
        var additionMap = $bd7d663e2fcda8c2$var$toDraggableMap(additions);
        withAdditions.forEach(function(item, index) {
            var wasAdded = Boolean(additionMap[item.descriptor.id]);
            if (!wasAdded) return;
            var offset = $bd7d663e2fcda8c2$var$patch(axis.line, item.client.marginBox[axis.size]);
            withAdditions.slice(index).forEach(function(sibling) {
                if (additionMap[sibling.descriptor.id]) return;
                addShift(sibling.descriptor.id, {
                    indexChange: 1,
                    offset: offset
                });
            });
        });
        withAdditions.forEach(function(item) {
            if (additionMap[item.descriptor.id]) return;
            var shift = toShift[item.descriptor.id];
            if (!shift) return;
            var moved = $bd7d663e2fcda8c2$var$offsetDraggable({
                draggable: item,
                offset: shift.offset,
                initialWindowScroll: viewport.scroll.initial
            });
            var index = item.descriptor.index + shift.indexChange;
            var updated = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, moved, {
                descriptor: (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, item.descriptor, {
                    index: index
                })
            });
            shifted[moved.descriptor.id] = updated;
        });
    });
    var map = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, existing, shifted);
    return map;
};
var $bd7d663e2fcda8c2$var$adjustAdditionsForScrollChanges = function(_ref) {
    var additions = _ref.additions, updatedDroppables = _ref.updatedDroppables, viewport = _ref.viewport;
    var windowScrollChange = viewport.scroll.diff.value;
    return additions.map(function(draggable) {
        var droppableId = draggable.descriptor.droppableId;
        var modified = updatedDroppables[droppableId];
        var frame = modified.frame;
        !frame && (0, $kuuqU.default)(false);
        var droppableScrollChange = frame.scroll.diff.value;
        var totalChange = $bd7d663e2fcda8c2$var$add(windowScrollChange, droppableScrollChange);
        var moved = $bd7d663e2fcda8c2$var$offsetDraggable({
            draggable: draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
var $bd7d663e2fcda8c2$var$adjustAdditionsForCollapsedHome = function(_ref) {
    var additions = _ref.additions, dragging = _ref.dragging, home = _ref.home, viewport = _ref.viewport;
    var displacedBy = $bd7d663e2fcda8c2$var$getDisplacedBy(home.axis, dragging.displaceBy);
    return additions.map(function(draggable) {
        if (draggable.descriptor.droppableId !== home.descriptor.id) return draggable;
        if (draggable.descriptor.index < dragging.descriptor.index) return draggable;
        return $bd7d663e2fcda8c2$var$offsetDraggable({
            draggable: draggable,
            offset: displacedBy.point,
            initialWindowScroll: viewport.scroll.initial
        });
    });
};
var $bd7d663e2fcda8c2$var$updateDraggables = function(_ref) {
    var updatedDroppables = _ref.updatedDroppables, criticalId = _ref.criticalId, unmodifiedExisting = _ref.existing, unmodifiedAdditions = _ref.additions, removals = _ref.removals, viewport = _ref.viewport;
    var existing = $bd7d663e2fcda8c2$var$adjustExistingForAdditionsAndRemovals({
        droppables: updatedDroppables,
        existing: unmodifiedExisting,
        additions: unmodifiedAdditions,
        removals: removals,
        viewport: viewport
    });
    var dragging = existing[criticalId];
    var home = updatedDroppables[dragging.descriptor.droppableId];
    var scrolledAdditions = $bd7d663e2fcda8c2$var$adjustAdditionsForScrollChanges({
        additions: unmodifiedAdditions,
        updatedDroppables: updatedDroppables,
        viewport: viewport
    });
    var additions = $bd7d663e2fcda8c2$var$adjustAdditionsForCollapsedHome({
        additions: scrolledAdditions,
        dragging: dragging,
        home: home,
        viewport: viewport
    });
    var map = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, existing, $bd7d663e2fcda8c2$var$toDraggableMap(additions));
    removals.forEach(function(id) {
        delete map[id];
    });
    return map;
};
var $bd7d663e2fcda8c2$var$getMaxScroll = function(_ref) {
    var scrollHeight = _ref.scrollHeight, scrollWidth = _ref.scrollWidth, height = _ref.height, width = _ref.width;
    var maxScroll = $bd7d663e2fcda8c2$var$subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    var adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var $bd7d663e2fcda8c2$var$getDroppableDimension = function(_ref) {
    var descriptor = _ref.descriptor, isEnabled = _ref.isEnabled, isCombineEnabled = _ref.isCombineEnabled, isFixedOnPage = _ref.isFixedOnPage, direction = _ref.direction, client = _ref.client, page = _ref.page, closest = _ref.closest;
    var frame = function() {
        if (!closest) return null;
        var scrollSize = closest.scrollSize, frameClient = closest.client;
        var maxScroll = $bd7d663e2fcda8c2$var$getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient: frameClient,
            scrollSize: scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: $bd7d663e2fcda8c2$var$origin,
                    displacement: $bd7d663e2fcda8c2$var$origin
                }
            }
        };
    }();
    var axis = direction === 'vertical' ? $bd7d663e2fcda8c2$var$vertical : $bd7d663e2fcda8c2$var$horizontal;
    var subject = $bd7d663e2fcda8c2$var$getSubject({
        page: page,
        withPlaceholder: null,
        axis: axis,
        frame: frame
    });
    var dimension = {
        descriptor: descriptor,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: isFixedOnPage,
        axis: axis,
        isEnabled: isEnabled,
        client: client,
        page: page,
        frame: frame,
        subject: subject
    };
    return dimension;
};
var $bd7d663e2fcda8c2$var$isHomeOf = function(draggable, destination) {
    return draggable.descriptor.droppableId === destination.descriptor.id;
};
var $bd7d663e2fcda8c2$var$getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
    var axis = droppable.axis;
    var availableSpace = droppable.subject.page.contentBox[axis.size];
    var insideDroppable = $bd7d663e2fcda8c2$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var spaceUsed = insideDroppable.reduce(function(sum, dimension) {
        return sum + dimension.client.marginBox[axis.size];
    }, 0);
    var requiredSpace = spaceUsed + placeholderSize[axis.line];
    var needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return $bd7d663e2fcda8c2$var$patch(axis.line, needsToGrowBy);
};
var $bd7d663e2fcda8c2$var$withMaxScroll = function withMaxScroll(frame, max) {
    return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, frame, {
        scroll: (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, frame.scroll, {
            max: max
        })
    });
};
var $bd7d663e2fcda8c2$var$addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
    var frame = droppable.frame;
    !!$bd7d663e2fcda8c2$var$isHomeOf(draggable, droppable) && (0, $kuuqU.default)(false);
    !!droppable.subject.withPlaceholder && (0, $kuuqU.default)(false);
    var placeholderSize = $bd7d663e2fcda8c2$var$getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    var requiredGrowth = $bd7d663e2fcda8c2$var$getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    var added = {
        placeholderSize: placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        var _subject = $bd7d663e2fcda8c2$var$getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, droppable, {
            subject: _subject
        });
    }
    var maxScroll = requiredGrowth ? $bd7d663e2fcda8c2$var$add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    var newFrame = $bd7d663e2fcda8c2$var$withMaxScroll(frame, maxScroll);
    var subject = $bd7d663e2fcda8c2$var$getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $bd7d663e2fcda8c2$var$removePlaceholder = function removePlaceholder(droppable) {
    var added = droppable.subject.withPlaceholder;
    !added && (0, $kuuqU.default)(false);
    var frame = droppable.frame;
    if (!frame) {
        var _subject2 = $bd7d663e2fcda8c2$var$getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, droppable, {
            subject: _subject2
        });
    }
    var oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && (0, $kuuqU.default)(false);
    var newFrame = $bd7d663e2fcda8c2$var$withMaxScroll(frame, oldMaxScroll);
    var subject = $bd7d663e2fcda8c2$var$getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, droppable, {
        subject: subject,
        frame: newFrame
    });
};
var $bd7d663e2fcda8c2$var$getFrame = function(droppable) {
    var frame = droppable.frame;
    !frame && (0, $kuuqU.default)(false);
    return frame;
};
var $bd7d663e2fcda8c2$var$throwIfSpacingChange = function throwIfSpacingChange(old, fresh) {
    var getMessage;
};
var $bd7d663e2fcda8c2$var$adjustBorderBoxSize = function adjustBorderBoxSize(axis, old, fresh) {
    return {
        top: old.top,
        left: old.left,
        right: old.left + fresh.width,
        bottom: old.top + fresh.height
    };
};
var $bd7d663e2fcda8c2$var$updateDroppables = function(_ref) {
    var modified = _ref.modified, existing = _ref.existing, viewport = _ref.viewport;
    if (!modified.length) return existing;
    var adjusted = modified.map(function(provided) {
        var raw = existing[provided.descriptor.id];
        !raw && (0, $kuuqU.default)(false);
        var hasPlaceholder = Boolean(raw.subject.withPlaceholder);
        var dimension = hasPlaceholder ? $bd7d663e2fcda8c2$var$removePlaceholder(raw) : raw;
        var oldClient = dimension.client;
        var newClient = provided.client;
        var oldScrollable = $bd7d663e2fcda8c2$var$getFrame(dimension);
        var newScrollable = $bd7d663e2fcda8c2$var$getFrame(provided);
        var isFrameEqual;
        var client = (0, $b703e4029dc36ed5$export$6459fc9e86be362e)({
            borderBox: $bd7d663e2fcda8c2$var$adjustBorderBoxSize(dimension.axis, oldClient.borderBox, newClient.borderBox),
            margin: oldClient.margin,
            border: oldClient.border,
            padding: oldClient.padding
        });
        var closest = {
            client: oldScrollable.frameClient,
            page: (0, $b703e4029dc36ed5$export$1d0caec378d7d0ae)(oldScrollable.frameClient, viewport.scroll.initial),
            shouldClipSubject: oldScrollable.shouldClipSubject,
            scrollSize: newScrollable.scrollSize,
            scroll: oldScrollable.scroll.initial
        };
        var withSizeChanged = $bd7d663e2fcda8c2$var$getDroppableDimension({
            descriptor: provided.descriptor,
            isEnabled: provided.isEnabled,
            isCombineEnabled: provided.isCombineEnabled,
            isFixedOnPage: provided.isFixedOnPage,
            direction: provided.axis.direction,
            client: client,
            page: (0, $b703e4029dc36ed5$export$1d0caec378d7d0ae)(client, viewport.scroll.initial),
            closest: closest
        });
        var scrolled = $bd7d663e2fcda8c2$var$scrollDroppable(withSizeChanged, newScrollable.scroll.current);
        return scrolled;
    });
    var result = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, existing, $bd7d663e2fcda8c2$var$toDroppableMap(adjusted));
    return result;
};
var $bd7d663e2fcda8c2$var$withNoAnimatedDisplacement = function(impact) {
    var displaced = impact.movement.displaced;
    if (!displaced.length) return impact;
    var withoutAnimation = displaced.map(function(displacement) {
        if (!displacement.isVisible) return displacement;
        if (!displacement.shouldAnimate) return displacement;
        return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, displacement, {
            shouldAnimate: false
        });
    });
    var result = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, impact, {
        movement: (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, impact.movement, {
            displaced: withoutAnimation,
            map: $bd7d663e2fcda8c2$var$getDisplacementMap(withoutAnimation)
        })
    });
    return result;
};
var $bd7d663e2fcda8c2$var$patchDroppableMap = function(droppables, updated) {
    var _extends2;
    return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
};
var $bd7d663e2fcda8c2$var$clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
    var previousImpact = _ref.previousImpact, impact = _ref.impact, droppables = _ref.droppables;
    var last = $bd7d663e2fcda8c2$var$whatIsDraggedOver(previousImpact);
    var now = $bd7d663e2fcda8c2$var$whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    var lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    var updated = $bd7d663e2fcda8c2$var$removePlaceholder(lastDroppable);
    return $bd7d663e2fcda8c2$var$patchDroppableMap(droppables, updated);
};
var $bd7d663e2fcda8c2$var$recomputePlaceholders = function(_ref2) {
    var draggable = _ref2.draggable, draggables = _ref2.draggables, droppables = _ref2.droppables, previousImpact = _ref2.previousImpact, impact = _ref2.impact;
    var cleaned = $bd7d663e2fcda8c2$var$clearUnusedPlaceholder({
        previousImpact: previousImpact,
        impact: impact,
        droppables: droppables
    });
    var isOver = $bd7d663e2fcda8c2$var$whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    var droppable = droppables[isOver];
    if ($bd7d663e2fcda8c2$var$isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    var patched = $bd7d663e2fcda8c2$var$addPlaceholder(droppable, draggable, draggables);
    return $bd7d663e2fcda8c2$var$patchDroppableMap(cleaned, patched);
};
var $bd7d663e2fcda8c2$var$timingsKey = 'Processing dynamic changes';
var $bd7d663e2fcda8c2$var$publishWhileDragging = function(_ref) {
    var _extends2, _extends3;
    var state = _ref.state, published = _ref.published;
    $bd7d663e2fcda8c2$var$start($bd7d663e2fcda8c2$var$timingsKey);
    var updatedDroppables = $bd7d663e2fcda8c2$var$updateDroppables({
        modified: published.modified,
        existing: state.dimensions.droppables,
        viewport: state.viewport
    });
    var draggables = $bd7d663e2fcda8c2$var$updateDraggables({
        updatedDroppables: updatedDroppables,
        criticalId: state.critical.draggable.id,
        existing: state.dimensions.draggables,
        additions: published.additions,
        removals: published.removals,
        viewport: state.viewport
    });
    var critical = {
        draggable: draggables[state.critical.draggable.id].descriptor,
        droppable: updatedDroppables[state.critical.droppable.id].descriptor
    };
    var original = state.dimensions.draggables[critical.draggable.id];
    var updated = draggables[critical.draggable.id];
    var droppables = $bd7d663e2fcda8c2$var$recomputePlaceholders({
        draggable: updated,
        draggables: draggables,
        droppables: updatedDroppables,
        previousImpact: state.impact,
        impact: state.impact
    });
    var dimensions = {
        draggables: draggables,
        droppables: droppables
    };
    var _getDragPositions = $bd7d663e2fcda8c2$var$getDragPositions({
        initial: state.initial,
        current: state.current,
        oldClientBorderBoxCenter: original.client.borderBox.center,
        newClientBorderBoxCenter: updated.client.borderBox.center,
        viewport: state.viewport
    }), initial = _getDragPositions.initial, current = _getDragPositions.current;
    var _getHomeOnLift = $bd7d663e2fcda8c2$var$getHomeOnLift({
        draggable: updated,
        home: dimensions.droppables[critical.droppable.id],
        draggables: dimensions.draggables,
        viewport: state.viewport
    }), homeImpact = _getHomeOnLift.impact, onLift = _getHomeOnLift.onLift;
    var impact = $bd7d663e2fcda8c2$var$withNoAnimatedDisplacement($bd7d663e2fcda8c2$var$getDragImpact({
        pageBorderBoxCenter: current.page.borderBoxCenter,
        draggable: updated,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: homeImpact,
        viewport: state.viewport,
        userDirection: state.userDirection,
        onLift: onLift
    }));
    var isOrphaned = Boolean(state.movementMode === 'SNAP' && !$bd7d663e2fcda8c2$var$whatIsDraggedOver(impact));
    !!isOrphaned && (0, $kuuqU.default)(false);
    $bd7d663e2fcda8c2$var$finish($bd7d663e2fcda8c2$var$timingsKey);
    var draggingState = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({
        phase: 'DRAGGING'
    }, state, (_extends2 = {}, _extends2["phase"] = 'DRAGGING', _extends2.critical = critical, _extends2.current = current, _extends2.initial = initial, _extends2.impact = impact, _extends2.dimensions = dimensions, _extends2.onLift = onLift, _extends2.onLiftImpact = homeImpact, _extends2.forceShouldAnimate = false, _extends2));
    if (state.phase === 'COLLECTING') return draggingState;
    var dropPending = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({
        phase: 'DROP_PENDING'
    }, draggingState, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.reason = state.reason, _extends3.isWaiting = false, _extends3));
    return dropPending;
};
var $bd7d663e2fcda8c2$var$forward = {
    vertical: 'down',
    horizontal: 'right'
};
var $bd7d663e2fcda8c2$var$backward = {
    vertical: 'up',
    horizontal: 'left'
};
var $bd7d663e2fcda8c2$var$moveToNextCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable = _ref.draggable, destination = _ref.destination, originalInsideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact;
    if (!destination.isCombineEnabled) return null;
    if (previousImpact.merge) return null;
    var location = previousImpact.destination;
    !location && (0, $kuuqU.default)(false);
    var currentIndex = location.index;
    var currentInsideDestination = function() {
        var shallow = originalInsideDestination.slice();
        if (isInHomeList) shallow.splice(draggable.descriptor.index, 1);
        shallow.splice(location.index, 0, draggable);
        return shallow;
    }();
    var targetIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    if (targetIndex < 0) return null;
    if (targetIndex > currentInsideDestination.length - 1) return null;
    var target = currentInsideDestination[targetIndex];
    !(target !== draggable) && (0, $kuuqU.default)(false);
    var merge = {
        whenEntered: isMovingForward ? $bd7d663e2fcda8c2$var$forward : $bd7d663e2fcda8c2$var$backward,
        combine: {
            draggableId: target.descriptor.id,
            droppableId: destination.descriptor.id
        }
    };
    var impact = {
        movement: previousImpact.movement,
        destination: null,
        merge: merge
    };
    return impact;
};
var $bd7d663e2fcda8c2$var$addClosest = function addClosest(add, displaced) {
    var added = {
        draggableId: add.descriptor.id,
        isVisible: true,
        shouldAnimate: true
    };
    return [
        added
    ].concat(displaced);
};
var $bd7d663e2fcda8c2$var$removeClosest = function removeClosest(displaced) {
    return displaced.slice(1);
};
var $bd7d663e2fcda8c2$var$fromReorder = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable = _ref.draggable, initialInside = _ref.insideDestination, location = _ref.location;
    var insideDestination = initialInside.slice();
    var currentIndex = location.index;
    var isInForeignList = !isInHomeList;
    if (isInForeignList) insideDestination.splice(location.index, 0, draggable);
    var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    if (proposedIndex < 0) return null;
    if (proposedIndex > insideDestination.length - 1) return null;
    return {
        proposedIndex: proposedIndex,
        modifyDisplacement: true
    };
};
var $bd7d663e2fcda8c2$var$fromCombine = function(_ref) {
    var isMovingForward = _ref.isMovingForward, destination = _ref.destination, previousImpact = _ref.previousImpact, draggables = _ref.draggables, merge = _ref.merge, onLift = _ref.onLift;
    if (!destination.isCombineEnabled) return null;
    var movement = previousImpact.movement;
    var combineId = merge.combine.draggableId;
    var combine = draggables[combineId];
    var combineIndex = combine.descriptor.index;
    var wasDisplacedAtStart = $bd7d663e2fcda8c2$var$didStartDisplaced(combineId, onLift);
    if (wasDisplacedAtStart) {
        var hasDisplacedFromStart = !movement.map[combineId];
        if (hasDisplacedFromStart) {
            if (isMovingForward) return {
                proposedIndex: combineIndex,
                modifyDisplacement: false
            };
            return {
                proposedIndex: combineIndex - 1,
                modifyDisplacement: true
            };
        }
        if (isMovingForward) return {
            proposedIndex: combineIndex,
            modifyDisplacement: true
        };
        return {
            proposedIndex: combineIndex - 1,
            modifyDisplacement: false
        };
    }
    var isDisplaced = Boolean(movement.map[combineId]);
    if (isDisplaced) {
        if (isMovingForward) return {
            proposedIndex: combineIndex + 1,
            modifyDisplacement: true
        };
        return {
            proposedIndex: combineIndex,
            modifyDisplacement: false
        };
    }
    if (isMovingForward) return {
        proposedIndex: combineIndex + 1,
        modifyDisplacement: false
    };
    return {
        proposedIndex: combineIndex,
        modifyDisplacement: true
    };
};
var $bd7d663e2fcda8c2$var$moveToNextIndex = function(_ref) {
    var isMovingForward = _ref.isMovingForward, isInHomeList = _ref.isInHomeList, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, insideDestination = _ref.insideDestination, previousImpact = _ref.previousImpact, onLift = _ref.onLift;
    var instruction = function() {
        if (previousImpact.destination) return $bd7d663e2fcda8c2$var$fromReorder({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            draggable: draggable,
            location: previousImpact.destination,
            insideDestination: insideDestination
        });
        if (previousImpact.merge) return $bd7d663e2fcda8c2$var$fromCombine({
            isMovingForward: isMovingForward,
            destination: destination,
            previousImpact: previousImpact,
            draggables: draggables,
            merge: previousImpact.merge,
            onLift: onLift
        });
        return null;
    }();
    if (instruction == null) return null;
    var proposedIndex = instruction.proposedIndex, modifyDisplacement = instruction.modifyDisplacement;
    var displacedBy = $bd7d663e2fcda8c2$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var displaced = function() {
        var lastDisplaced = previousImpact.movement.displaced;
        if (!modifyDisplacement) return lastDisplaced;
        if (isMovingForward) return $bd7d663e2fcda8c2$var$removeClosest(lastDisplaced);
        var withoutDraggable = $bd7d663e2fcda8c2$var$removeDraggableFromList(draggable, insideDestination);
        var atProposedIndex = withoutDraggable[proposedIndex];
        return $bd7d663e2fcda8c2$var$addClosest(atProposedIndex, lastDisplaced);
    }();
    return {
        movement: {
            displacedBy: displacedBy,
            displaced: displaced,
            map: $bd7d663e2fcda8c2$var$getDisplacementMap(displaced)
        },
        destination: {
            droppableId: destination.descriptor.id,
            index: proposedIndex
        },
        merge: null
    };
};
var $bd7d663e2fcda8c2$var$whenCombining = function(_ref) {
    var combine = _ref.combine, onLift = _ref.onLift, movement = _ref.movement, draggables = _ref.draggables;
    var combineWith = combine.draggableId;
    var center = draggables[combineWith].page.borderBox.center;
    var displaceBy = $bd7d663e2fcda8c2$var$getCombinedItemDisplacement({
        displaced: movement.map,
        onLift: onLift,
        combineWith: combineWith,
        displacedBy: movement.displacedBy
    });
    return $bd7d663e2fcda8c2$var$add(center, displaceBy);
};
var $bd7d663e2fcda8c2$var$distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
    return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};
var $bd7d663e2fcda8c2$var$distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
    return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};
var $bd7d663e2fcda8c2$var$getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
    return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};
var $bd7d663e2fcda8c2$var$goAfter = function goAfter(_ref) {
    var axis = _ref.axis, moveRelativeTo = _ref.moveRelativeTo, isMoving = _ref.isMoving;
    return $bd7d663e2fcda8c2$var$patch(axis.line, moveRelativeTo.marginBox[axis.end] + $bd7d663e2fcda8c2$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $bd7d663e2fcda8c2$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $bd7d663e2fcda8c2$var$goBefore = function goBefore(_ref2) {
    var axis = _ref2.axis, moveRelativeTo = _ref2.moveRelativeTo, isMoving = _ref2.isMoving;
    return $bd7d663e2fcda8c2$var$patch(axis.line, moveRelativeTo.marginBox[axis.start] - $bd7d663e2fcda8c2$var$distanceFromEndToBorderBoxCenter(axis, isMoving), $bd7d663e2fcda8c2$var$getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var $bd7d663e2fcda8c2$var$goIntoStart = function goIntoStart(_ref3) {
    var axis = _ref3.axis, moveInto = _ref3.moveInto, isMoving = _ref3.isMoving;
    return $bd7d663e2fcda8c2$var$patch(axis.line, moveInto.contentBox[axis.start] + $bd7d663e2fcda8c2$var$distanceFromStartToBorderBoxCenter(axis, isMoving), $bd7d663e2fcda8c2$var$getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};
var $bd7d663e2fcda8c2$var$whenReordering = function(_ref) {
    var movement = _ref.movement, draggable = _ref.draggable, draggables = _ref.draggables, droppable = _ref.droppable, onLift = _ref.onLift;
    var insideDestination = $bd7d663e2fcda8c2$var$getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var draggablePage = draggable.page;
    var axis = droppable.axis;
    if (!insideDestination.length) return $bd7d663e2fcda8c2$var$goIntoStart({
        axis: axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    var displaced = movement.displaced, displacedBy = movement.displacedBy;
    if (displaced.length) {
        var closestAfter = draggables[displaced[0].draggableId];
        if ($bd7d663e2fcda8c2$var$didStartDisplaced(closestAfter.descriptor.id, onLift)) return $bd7d663e2fcda8c2$var$goBefore({
            axis: axis,
            moveRelativeTo: closestAfter.page,
            isMoving: draggablePage
        });
        var withDisplacement = (0, $b703e4029dc36ed5$export$cc800923e997bb8)(closestAfter.page, displacedBy.point);
        return $bd7d663e2fcda8c2$var$goBefore({
            axis: axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    var last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if ($bd7d663e2fcda8c2$var$didStartDisplaced(last.descriptor.id, onLift)) {
        var page = (0, $b703e4029dc36ed5$export$cc800923e997bb8)(last.page, $bd7d663e2fcda8c2$var$negate(onLift.displacedBy.point));
        return $bd7d663e2fcda8c2$var$goAfter({
            axis: axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return $bd7d663e2fcda8c2$var$goAfter({
        axis: axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var $bd7d663e2fcda8c2$var$withDroppableDisplacement = function(droppable, point) {
    var frame = droppable.frame;
    if (!frame) return point;
    return $bd7d663e2fcda8c2$var$add(point, frame.scroll.diff.displacement);
};
var $bd7d663e2fcda8c2$var$getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, onLift = _ref.onLift;
    var merge = impact.merge;
    var destination = impact.destination;
    var original = draggable.page.borderBox.center;
    if (!droppable) return original;
    if (destination) return $bd7d663e2fcda8c2$var$whenReordering({
        movement: impact.movement,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        onLift: onLift
    });
    if (merge) return $bd7d663e2fcda8c2$var$whenCombining({
        movement: impact.movement,
        combine: merge.combine,
        draggables: draggables,
        onLift: onLift
    });
    return original;
};
var $bd7d663e2fcda8c2$var$getPageBorderBoxCenterFromImpact = function(args) {
    var withoutDisplacement = $bd7d663e2fcda8c2$var$getResultWithoutDroppableDisplacement(args);
    var droppable = args.droppable;
    var withDisplacement = droppable ? $bd7d663e2fcda8c2$var$withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var $bd7d663e2fcda8c2$var$scrollViewport = function(viewport, newScroll) {
    var diff = $bd7d663e2fcda8c2$var$subtract(newScroll, viewport.scroll.initial);
    var displacement = $bd7d663e2fcda8c2$var$negate(diff);
    var frame = (0, $b703e4029dc36ed5$export$4b834cebd9e5cebe)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    var updated = {
        frame: frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement: displacement
            }
        }
    };
    return updated;
};
var $bd7d663e2fcda8c2$var$withNewDisplacement = function(impact, displaced) {
    return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, impact, {
        movement: (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, impact.movement, {
            displaced: displaced,
            map: $bd7d663e2fcda8c2$var$getDisplacementMap(displaced)
        })
    });
};
var $bd7d663e2fcda8c2$var$speculativelyIncrease = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, destination = _ref.destination, draggables = _ref.draggables, maxScrollChange = _ref.maxScrollChange, onLift = _ref.onLift;
    var displaced = impact.movement.displaced;
    var scrolledViewport = $bd7d663e2fcda8c2$var$scrollViewport(viewport, $bd7d663e2fcda8c2$var$add(viewport.scroll.current, maxScrollChange));
    var scrolledDroppable = destination.frame ? $bd7d663e2fcda8c2$var$scrollDroppable(destination, $bd7d663e2fcda8c2$var$add(destination.frame.scroll.current, maxScrollChange)) : destination;
    var updated = displaced.map(function(entry) {
        if (entry.isVisible) return entry;
        var draggable = draggables[entry.draggableId];
        var withScrolledViewport = $bd7d663e2fcda8c2$var$getDisplacement({
            draggable: draggable,
            destination: destination,
            previousImpact: impact,
            viewport: scrolledViewport.frame,
            onLift: onLift,
            forceShouldAnimate: false
        });
        if (withScrolledViewport.isVisible) return withScrolledViewport;
        var withScrolledDroppable = $bd7d663e2fcda8c2$var$getDisplacement({
            draggable: draggable,
            destination: scrolledDroppable,
            previousImpact: impact,
            viewport: viewport.frame,
            onLift: onLift,
            forceShouldAnimate: false
        });
        if (withScrolledDroppable.isVisible) return withScrolledDroppable;
        return entry;
    });
    return $bd7d663e2fcda8c2$var$withNewDisplacement(impact, updated);
};
var $bd7d663e2fcda8c2$var$withViewportDisplacement = function(viewport, point) {
    return $bd7d663e2fcda8c2$var$add(viewport.scroll.diff.displacement, point);
};
var $bd7d663e2fcda8c2$var$getClientFromPageBorderBoxCenter = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, draggable = _ref.draggable, viewport = _ref.viewport;
    var withoutPageScrollChange = $bd7d663e2fcda8c2$var$withViewportDisplacement(viewport, pageBorderBoxCenter);
    var offset = $bd7d663e2fcda8c2$var$subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return $bd7d663e2fcda8c2$var$add(draggable.client.borderBox.center, offset);
};
var $bd7d663e2fcda8c2$var$isTotallyVisibleInNewLocation = function(_ref) {
    var draggable = _ref.draggable, destination = _ref.destination, newPageBorderBoxCenter = _ref.newPageBorderBoxCenter, viewport = _ref.viewport, withDroppableDisplacement = _ref.withDroppableDisplacement, _ref$onlyOnMainAxis = _ref.onlyOnMainAxis, onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
    var changeNeeded = $bd7d663e2fcda8c2$var$subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    var shifted = $bd7d663e2fcda8c2$var$offsetByPosition(draggable.page.borderBox, changeNeeded);
    var args = {
        target: shifted,
        destination: destination,
        withDroppableDisplacement: withDroppableDisplacement,
        viewport: viewport
    };
    return onlyOnMainAxis ? $bd7d663e2fcda8c2$var$isTotallyVisibleOnAxis(args) : $bd7d663e2fcda8c2$var$isTotallyVisible(args);
};
var $bd7d663e2fcda8c2$var$moveToNextPlace = function(_ref) {
    var isMovingForward = _ref.isMovingForward, draggable = _ref.draggable, destination = _ref.destination, draggables = _ref.draggables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, previousClientSelection = _ref.previousClientSelection, onLift = _ref.onLift;
    if (!destination.isEnabled) return null;
    var insideDestination = $bd7d663e2fcda8c2$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var isInHomeList = $bd7d663e2fcda8c2$var$isHomeOf(draggable, destination);
    var impact = $bd7d663e2fcda8c2$var$moveToNextCombine({
        isInHomeList: isInHomeList,
        isMovingForward: isMovingForward,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact
    }) || $bd7d663e2fcda8c2$var$moveToNextIndex({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        draggables: draggables,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        onLift: onLift
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $bd7d663e2fcda8c2$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        onLift: onLift
    });
    var isVisibleInNewLocation = $bd7d663e2fcda8c2$var$isTotallyVisibleInNewLocation({
        draggable: draggable,
        destination: destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        var clientSelection = $bd7d663e2fcda8c2$var$getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    }
    var distance = $bd7d663e2fcda8c2$var$subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    var cautious = $bd7d663e2fcda8c2$var$speculativelyIncrease({
        impact: impact,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        maxScrollChange: distance,
        onLift: onLift
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
var $bd7d663e2fcda8c2$var$getKnownActive = function getKnownActive(droppable) {
    var rect = droppable.subject.active;
    !rect && (0, $kuuqU.default)(false);
    return rect;
};
var $bd7d663e2fcda8c2$var$getBestCrossAxisDroppable = function(_ref) {
    var isMovingForward = _ref.isMovingForward, pageBorderBoxCenter = _ref.pageBorderBoxCenter, source = _ref.source, droppables = _ref.droppables, viewport = _ref.viewport;
    var active = source.subject.active;
    if (!active) return null;
    var axis = source.axis;
    var isBetweenSourceClipped = $bd7d663e2fcda8c2$var$isWithin(active[axis.start], active[axis.end]);
    var candidates = $bd7d663e2fcda8c2$var$toDroppableList(droppables).filter(function(droppable) {
        return droppable !== source;
    }).filter(function(droppable) {
        return droppable.isEnabled;
    }).filter(function(droppable) {
        return Boolean(droppable.subject.active);
    }).filter(function(droppable) {
        return $bd7d663e2fcda8c2$var$isPartiallyVisibleThroughFrame(viewport.frame)($bd7d663e2fcda8c2$var$getKnownActive(droppable));
    }).filter(function(droppable) {
        var activeOfTarget = $bd7d663e2fcda8c2$var$getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter(function(droppable) {
        var activeOfTarget = $bd7d663e2fcda8c2$var$getKnownActive(droppable);
        var isBetweenDestinationClipped = $bd7d663e2fcda8c2$var$isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort(function(a, b) {
        var first = $bd7d663e2fcda8c2$var$getKnownActive(a)[axis.crossAxisStart];
        var second = $bd7d663e2fcda8c2$var$getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter(function(droppable, index, array) {
        return $bd7d663e2fcda8c2$var$getKnownActive(droppable)[axis.crossAxisStart] === $bd7d663e2fcda8c2$var$getKnownActive(array[0])[axis.crossAxisStart];
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    var contains = candidates.filter(function(droppable) {
        var isWithinDroppable = $bd7d663e2fcda8c2$var$isWithin($bd7d663e2fcda8c2$var$getKnownActive(droppable)[axis.start], $bd7d663e2fcda8c2$var$getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort(function(a, b) {
        return $bd7d663e2fcda8c2$var$getKnownActive(a)[axis.start] - $bd7d663e2fcda8c2$var$getKnownActive(b)[axis.start];
    })[0];
    return candidates.sort(function(a, b) {
        var first = $bd7d663e2fcda8c2$var$closest(pageBorderBoxCenter, $bd7d663e2fcda8c2$var$getCorners($bd7d663e2fcda8c2$var$getKnownActive(a)));
        var second = $bd7d663e2fcda8c2$var$closest(pageBorderBoxCenter, $bd7d663e2fcda8c2$var$getCorners($bd7d663e2fcda8c2$var$getKnownActive(b)));
        if (first !== second) return first - second;
        return $bd7d663e2fcda8c2$var$getKnownActive(a)[axis.start] - $bd7d663e2fcda8c2$var$getKnownActive(b)[axis.start];
    })[0];
};
var $bd7d663e2fcda8c2$var$getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, onLift) {
    var original = draggable.page.borderBox.center;
    return $bd7d663e2fcda8c2$var$didStartDisplaced(draggable.descriptor.id, onLift) ? $bd7d663e2fcda8c2$var$subtract(original, onLift.displacedBy.point) : original;
};
var $bd7d663e2fcda8c2$var$getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, onLift) {
    var original = draggable.page.borderBox;
    return $bd7d663e2fcda8c2$var$didStartDisplaced(draggable.descriptor.id, onLift) ? $bd7d663e2fcda8c2$var$offsetByPosition(original, $bd7d663e2fcda8c2$var$negate(onLift.displacedBy.point)) : original;
};
var $bd7d663e2fcda8c2$var$getClosestDraggable = function(_ref) {
    var pageBorderBoxCenter = _ref.pageBorderBoxCenter, viewport = _ref.viewport, destination = _ref.destination, insideDestination = _ref.insideDestination, onLift = _ref.onLift;
    var sorted = insideDestination.filter(function(draggable) {
        return $bd7d663e2fcda8c2$var$isTotallyVisible({
            target: $bd7d663e2fcda8c2$var$getCurrentPageBorderBox(draggable, onLift),
            destination: destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        });
    }).sort(function(a, b) {
        var distanceToA = $bd7d663e2fcda8c2$var$distance(pageBorderBoxCenter, $bd7d663e2fcda8c2$var$withDroppableDisplacement(destination, $bd7d663e2fcda8c2$var$getCurrentPageBorderBoxCenter(a, onLift)));
        var distanceToB = $bd7d663e2fcda8c2$var$distance(pageBorderBoxCenter, $bd7d663e2fcda8c2$var$withDroppableDisplacement(destination, $bd7d663e2fcda8c2$var$getCurrentPageBorderBoxCenter(b, onLift)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var $bd7d663e2fcda8c2$var$moveToNewDroppable = function(_ref) {
    var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, moveRelativeTo = _ref.moveRelativeTo, insideDestination = _ref.insideDestination, draggable = _ref.draggable, draggables = _ref.draggables, destination = _ref.destination, previousImpact = _ref.previousImpact, viewport = _ref.viewport, onLift = _ref.onLift;
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        var proposed = {
            movement: $bd7d663e2fcda8c2$var$noMovement,
            destination: {
                droppableId: destination.descriptor.id,
                index: 0
            },
            merge: null
        };
        var proposedPageBorderBoxCenter = $bd7d663e2fcda8c2$var$getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            onLift: onLift
        });
        var withPlaceholder = $bd7d663e2fcda8c2$var$isHomeOf(draggable, destination) ? destination : $bd7d663e2fcda8c2$var$addPlaceholder(destination, draggable, draggables);
        var isVisibleInNewLocation = $bd7d663e2fcda8c2$var$isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] < moveRelativeTo.page.borderBox.center[destination.axis.line]);
    var targetIndex = insideDestination.indexOf(moveRelativeTo);
    !(targetIndex !== -1) && (0, $kuuqU.default)(false);
    var proposedIndex = function() {
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return targetIndex;
        if (isGoingBeforeTarget) return targetIndex;
        return targetIndex + 1;
    }();
    var displaced = $bd7d663e2fcda8c2$var$removeDraggableFromList(draggable, insideDestination).slice(proposedIndex).map(function(dimension) {
        return $bd7d663e2fcda8c2$var$getDisplacement({
            draggable: dimension,
            destination: destination,
            viewport: viewport.frame,
            previousImpact: previousImpact,
            onLift: onLift
        });
    });
    var displacedBy = $bd7d663e2fcda8c2$var$getDisplacedBy(destination.axis, draggable.displaceBy);
    var impact = {
        movement: {
            displacedBy: displacedBy,
            displaced: displaced,
            map: $bd7d663e2fcda8c2$var$getDisplacementMap(displaced)
        },
        destination: {
            droppableId: destination.descriptor.id,
            index: proposedIndex
        },
        merge: null
    };
    return impact;
};
var $bd7d663e2fcda8c2$var$moveCrossAxis = function(_ref) {
    var isMovingForward = _ref.isMovingForward, previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter, draggable = _ref.draggable, isOver = _ref.isOver, draggables = _ref.draggables, droppables = _ref.droppables, previousImpact = _ref.previousImpact, viewport = _ref.viewport, onLift = _ref.onLift;
    var destination = $bd7d663e2fcda8c2$var$getBestCrossAxisDroppable({
        isMovingForward: isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables: droppables,
        viewport: viewport
    });
    if (!destination) return null;
    var insideDestination = $bd7d663e2fcda8c2$var$getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var moveRelativeTo = $bd7d663e2fcda8c2$var$getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport: viewport,
        destination: destination,
        insideDestination: insideDestination,
        onLift: onLift
    });
    var impact = $bd7d663e2fcda8c2$var$moveToNewDroppable({
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        destination: destination,
        draggable: draggable,
        draggables: draggables,
        moveRelativeTo: moveRelativeTo,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        viewport: viewport,
        onLift: onLift
    });
    if (!impact) return null;
    var pageBorderBoxCenter = $bd7d663e2fcda8c2$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        onLift: onLift
    });
    var clientSelection = $bd7d663e2fcda8c2$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
    return {
        clientSelection: clientSelection,
        impact: impact,
        scrollJumpRequest: null
    };
};
var $bd7d663e2fcda8c2$var$getDroppableOver$1 = function getDroppableOver(impact, droppables) {
    var id = $bd7d663e2fcda8c2$var$whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var $bd7d663e2fcda8c2$var$moveInDirection = function(_ref) {
    var state = _ref.state, type = _ref.type;
    var isActuallyOver = $bd7d663e2fcda8c2$var$getDroppableOver$1(state.impact, state.dimensions.droppables);
    var isMainAxisMovementAllowed = Boolean(isActuallyOver);
    var home = state.dimensions.droppables[state.critical.droppable.id];
    var isOver = isActuallyOver || home;
    var direction = isOver.axis.direction;
    var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    var _state$dimensions = state.dimensions, draggables = _state$dimensions.draggables, droppables = _state$dimensions.droppables;
    return isMovingOnMainAxis ? $bd7d663e2fcda8c2$var$moveToNextPlace({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        destination: isOver,
        draggables: draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        onLift: state.onLift
    }) : $bd7d663e2fcda8c2$var$moveCrossAxis({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        isOver: isOver,
        draggables: draggables,
        droppables: droppables,
        previousImpact: state.impact,
        viewport: state.viewport,
        onLift: state.onLift
    });
};
function $bd7d663e2fcda8c2$var$isMovementAllowed(state) {
    return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}
var $bd7d663e2fcda8c2$var$getVertical = function getVertical(previous, diff) {
    if (diff === 0) return previous;
    return diff > 0 ? 'down' : 'up';
};
var $bd7d663e2fcda8c2$var$getHorizontal = function getHorizontal(previous, diff) {
    if (diff === 0) return previous;
    return diff > 0 ? 'right' : 'left';
};
var $bd7d663e2fcda8c2$var$getUserDirection = function(previous, oldPageBorderBoxCenter, newPageBorderBoxCenter) {
    var diff = $bd7d663e2fcda8c2$var$subtract(newPageBorderBoxCenter, oldPageBorderBoxCenter);
    return {
        horizontal: $bd7d663e2fcda8c2$var$getHorizontal(previous.horizontal, diff.x),
        vertical: $bd7d663e2fcda8c2$var$getVertical(previous.vertical, diff.y)
    };
};
var $bd7d663e2fcda8c2$var$update = function(_ref) {
    var state = _ref.state, forcedClientSelection = _ref.clientSelection, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport, forcedImpact = _ref.impact, scrollJumpRequest = _ref.scrollJumpRequest;
    var viewport = forcedViewport || state.viewport;
    var currentWindowScroll = viewport.scroll.current;
    var dimensions = forcedDimensions || state.dimensions;
    var clientSelection = forcedClientSelection || state.current.client.selection;
    var offset = $bd7d663e2fcda8c2$var$subtract(clientSelection, state.initial.client.selection);
    var client = {
        offset: offset,
        selection: clientSelection,
        borderBoxCenter: $bd7d663e2fcda8c2$var$add(state.initial.client.borderBoxCenter, offset)
    };
    var page = {
        selection: $bd7d663e2fcda8c2$var$add(client.selection, currentWindowScroll),
        borderBoxCenter: $bd7d663e2fcda8c2$var$add(client.borderBoxCenter, currentWindowScroll)
    };
    var current = {
        client: client,
        page: page
    };
    var userDirection = $bd7d663e2fcda8c2$var$getUserDirection(state.userDirection, state.current.page.borderBoxCenter, current.page.borderBoxCenter);
    if (state.phase === 'COLLECTING') return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({
        phase: 'COLLECTING'
    }, state, {
        dimensions: dimensions,
        viewport: viewport,
        current: current,
        userDirection: userDirection
    });
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var newImpact = forcedImpact || $bd7d663e2fcda8c2$var$getDragImpact({
        pageBorderBoxCenter: page.borderBoxCenter,
        draggable: draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport: viewport,
        userDirection: userDirection,
        onLift: state.onLift
    });
    var withUpdatedPlaceholders = $bd7d663e2fcda8c2$var$recomputePlaceholders({
        draggable: draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    var result = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, state, {
        current: current,
        userDirection: userDirection,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport: viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    });
    return result;
};
var $bd7d663e2fcda8c2$var$recompute = function(_ref) {
    var impact = _ref.impact, viewport = _ref.viewport, destination = _ref.destination, draggables = _ref.draggables, onLift = _ref.onLift, forceShouldAnimate = _ref.forceShouldAnimate;
    var updated = impact.movement.displaced.map(function(entry) {
        return $bd7d663e2fcda8c2$var$getDisplacement({
            draggable: draggables[entry.draggableId],
            destination: destination,
            previousImpact: impact,
            viewport: viewport.frame,
            onLift: onLift,
            forceShouldAnimate: forceShouldAnimate
        });
    });
    return $bd7d663e2fcda8c2$var$withNewDisplacement(impact, updated);
};
var $bd7d663e2fcda8c2$var$getClientBorderBoxCenter = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, droppable = _ref.droppable, draggables = _ref.draggables, viewport = _ref.viewport, onLift = _ref.onLift;
    var pageBorderBoxCenter = $bd7d663e2fcda8c2$var$getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        onLift: onLift
    });
    return $bd7d663e2fcda8c2$var$getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
};
var $bd7d663e2fcda8c2$var$refreshSnap = function(_ref) {
    var state = _ref.state, forcedDimensions = _ref.dimensions, forcedViewport = _ref.viewport;
    !(state.movementMode === 'SNAP') && (0, $kuuqU.default)(false);
    var needsVisibilityCheck = state.impact;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var draggable = draggables[state.critical.draggable.id];
    var isOver = $bd7d663e2fcda8c2$var$whatIsDraggedOver(needsVisibilityCheck);
    !isOver && (0, $kuuqU.default)(false);
    var destination = droppables[isOver];
    var impact = $bd7d663e2fcda8c2$var$recompute({
        impact: needsVisibilityCheck,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        onLift: state.onLift
    });
    var clientSelection = $bd7d663e2fcda8c2$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        viewport: viewport,
        onLift: state.onLift
    });
    return $bd7d663e2fcda8c2$var$update({
        impact: impact,
        clientSelection: clientSelection,
        state: state,
        dimensions: dimensions,
        viewport: viewport
    });
};
var $bd7d663e2fcda8c2$var$patchDimensionMap = function(dimensions, updated) {
    return {
        draggables: dimensions.draggables,
        droppables: $bd7d663e2fcda8c2$var$patchDroppableMap(dimensions.droppables, updated)
    };
};
var $bd7d663e2fcda8c2$var$isSnapping = function isSnapping(state) {
    return state.movementMode === 'SNAP';
};
var $bd7d663e2fcda8c2$var$postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
    var dimensions = $bd7d663e2fcda8c2$var$patchDimensionMap(state.dimensions, updated);
    if (!$bd7d663e2fcda8c2$var$isSnapping(state) || isEnabledChanging) return $bd7d663e2fcda8c2$var$update({
        state: state,
        dimensions: dimensions
    });
    return $bd7d663e2fcda8c2$var$refreshSnap({
        state: state,
        dimensions: dimensions
    });
};
var $bd7d663e2fcda8c2$var$idle = {
    phase: 'IDLE',
    completed: null,
    shouldFlush: false
};
var $bd7d663e2fcda8c2$var$reducer = function(state, action) {
    if (state === void 0) state = $bd7d663e2fcda8c2$var$idle;
    if (action.type === 'CLEAN') return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, $bd7d663e2fcda8c2$var$idle, {
        shouldFlush: action.payload.shouldFlush
    });
    if (action.type === 'INITIAL_PUBLISH') {
        !(state.phase === 'IDLE') && (0, $kuuqU.default)(false);
        var _action$payload = action.payload, critical = _action$payload.critical, clientSelection = _action$payload.clientSelection, viewport = _action$payload.viewport, dimensions = _action$payload.dimensions, movementMode = _action$payload.movementMode;
        var draggable = dimensions.draggables[critical.draggable.id];
        var home = dimensions.droppables[critical.droppable.id];
        var client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: $bd7d663e2fcda8c2$var$origin
        };
        var initial = {
            client: client,
            page: {
                selection: $bd7d663e2fcda8c2$var$add(client.selection, viewport.scroll.initial),
                borderBoxCenter: $bd7d663e2fcda8c2$var$add(client.selection, viewport.scroll.initial)
            }
        };
        var isWindowScrollAllowed = $bd7d663e2fcda8c2$var$toDroppableList(dimensions.droppables).every(function(item) {
            return !item.isFixedOnPage;
        });
        var _getHomeOnLift = $bd7d663e2fcda8c2$var$getHomeOnLift({
            draggable: draggable,
            home: home,
            draggables: dimensions.draggables,
            viewport: viewport
        }), impact = _getHomeOnLift.impact, onLift = _getHomeOnLift.onLift;
        var result = {
            phase: 'DRAGGING',
            isDragging: true,
            critical: critical,
            movementMode: movementMode,
            dimensions: dimensions,
            initial: initial,
            current: initial,
            isWindowScrollAllowed: isWindowScrollAllowed,
            impact: impact,
            onLift: onLift,
            onLiftImpact: impact,
            viewport: viewport,
            userDirection: $bd7d663e2fcda8c2$var$forward,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === 'COLLECTION_STARTING') {
        var _extends2;
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && (0, $kuuqU.default)(false);
        var _result = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({
            phase: 'COLLECTING'
        }, state, (_extends2 = {}, _extends2["phase"] = 'COLLECTING', _extends2));
        return _result;
    }
    if (action.type === 'PUBLISH_WHILE_DRAGGING') {
        !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') && (0, $kuuqU.default)(false);
        return $bd7d663e2fcda8c2$var$publishWhileDragging({
            state: state,
            published: action.payload
        });
    }
    if (action.type === 'MOVE') {
        if (state.phase === 'DROP_PENDING') return state;
        !$bd7d663e2fcda8c2$var$isMovementAllowed(state) && (0, $kuuqU.default)(false);
        var _clientSelection = action.payload.client;
        if ($bd7d663e2fcda8c2$var$isEqual(_clientSelection, state.current.client.selection)) return state;
        return $bd7d663e2fcda8c2$var$update({
            state: state,
            clientSelection: _clientSelection,
            impact: $bd7d663e2fcda8c2$var$isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
        if (state.phase === 'DROP_PENDING') return state;
        if (state.phase === 'COLLECTING') return state;
        !$bd7d663e2fcda8c2$var$isMovementAllowed(state) && (0, $kuuqU.default)(false);
        var _action$payload2 = action.payload, id = _action$payload2.id, offset = _action$payload2.offset;
        var target = state.dimensions.droppables[id];
        if (!target) return state;
        var scrolled = $bd7d663e2fcda8c2$var$scrollDroppable(target, offset);
        return $bd7d663e2fcda8c2$var$postDroppableChange(state, scrolled, false);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$bd7d663e2fcda8c2$var$isMovementAllowed(state) && (0, $kuuqU.default)(false);
        var _action$payload3 = action.payload, _id = _action$payload3.id, isEnabled = _action$payload3.isEnabled;
        var _target = state.dimensions.droppables[_id];
        !_target && (0, $kuuqU.default)(false);
        !(_target.isEnabled !== isEnabled) && (0, $kuuqU.default)(false);
        var updated = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, _target, {
            isEnabled: isEnabled
        });
        return $bd7d663e2fcda8c2$var$postDroppableChange(state, updated, true);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !$bd7d663e2fcda8c2$var$isMovementAllowed(state) && (0, $kuuqU.default)(false);
        var _action$payload4 = action.payload, _id2 = _action$payload4.id, isCombineEnabled = _action$payload4.isCombineEnabled;
        var _target2 = state.dimensions.droppables[_id2];
        !_target2 && (0, $kuuqU.default)(false);
        !(_target2.isCombineEnabled !== isCombineEnabled) && (0, $kuuqU.default)(false);
        var _updated = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, _target2, {
            isCombineEnabled: isCombineEnabled
        });
        return $bd7d663e2fcda8c2$var$postDroppableChange(state, _updated, true);
    }
    if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
        if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') return state;
        !$bd7d663e2fcda8c2$var$isMovementAllowed(state) && (0, $kuuqU.default)(false);
        !state.isWindowScrollAllowed && (0, $kuuqU.default)(false);
        var newScroll = action.payload.newScroll;
        if ($bd7d663e2fcda8c2$var$isEqual(state.viewport.scroll.current, newScroll)) return state;
        var _viewport = $bd7d663e2fcda8c2$var$scrollViewport(state.viewport, newScroll);
        if ($bd7d663e2fcda8c2$var$isSnapping(state)) return $bd7d663e2fcda8c2$var$refreshSnap({
            state: state,
            viewport: _viewport
        });
        return $bd7d663e2fcda8c2$var$update({
            state: state,
            viewport: _viewport
        });
    }
    if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
        if (!$bd7d663e2fcda8c2$var$isMovementAllowed(state)) return state;
        var maxScroll = action.payload.maxScroll;
        if ($bd7d663e2fcda8c2$var$isEqual(maxScroll, state.viewport.scroll.max)) return state;
        var withMaxScroll = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, state.viewport, {
            scroll: (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, state.viewport.scroll, {
                max: maxScroll
            })
        });
        return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({
            phase: 'DRAGGING'
        }, state, {
            viewport: withMaxScroll
        });
    }
    if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && (0, $kuuqU.default)(false);
        var _result2 = $bd7d663e2fcda8c2$var$moveInDirection({
            state: state,
            type: action.type
        });
        if (!_result2) return state;
        return $bd7d663e2fcda8c2$var$update({
            state: state,
            impact: _result2.impact,
            clientSelection: _result2.clientSelection,
            scrollJumpRequest: _result2.scrollJumpRequest
        });
    }
    if (action.type === 'DROP_PENDING') {
        var _extends3;
        var reason = action.payload.reason;
        !(state.phase === 'COLLECTING') && (0, $kuuqU.default)(false);
        var newState = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({
            phase: 'DROP_PENDING'
        }, state, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.isWaiting = true, _extends3.reason = reason, _extends3));
        return newState;
    }
    if (action.type === 'DROP_ANIMATE') {
        var _action$payload5 = action.payload, completed = _action$payload5.completed, dropDuration = _action$payload5.dropDuration, newHomeClientOffset = _action$payload5.newHomeClientOffset;
        !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && (0, $kuuqU.default)(false);
        var _result3 = {
            phase: 'DROP_ANIMATING',
            dimensions: state.dimensions,
            completed: completed,
            dropDuration: dropDuration,
            newHomeClientOffset: newHomeClientOffset
        };
        return _result3;
    }
    if (action.type === 'DROP_COMPLETE') {
        var _action$payload6 = action.payload, _completed = _action$payload6.completed, shouldFlush = _action$payload6.shouldFlush;
        return {
            phase: 'IDLE',
            completed: _completed,
            shouldFlush: shouldFlush
        };
    }
    return state;
};
var $bd7d663e2fcda8c2$var$lift = function lift(args) {
    return {
        type: 'LIFT',
        payload: args
    };
};
var $bd7d663e2fcda8c2$var$initialPublish = function initialPublish(args) {
    return {
        type: 'INITIAL_PUBLISH',
        payload: args
    };
};
var $bd7d663e2fcda8c2$var$publishWhileDragging$1 = function publishWhileDragging(args) {
    return {
        type: 'PUBLISH_WHILE_DRAGGING',
        payload: args
    };
};
var $bd7d663e2fcda8c2$var$collectionStarting = function collectionStarting() {
    return {
        type: 'COLLECTION_STARTING',
        payload: null
    };
};
var $bd7d663e2fcda8c2$var$updateDroppableScroll = function updateDroppableScroll(args) {
    return {
        type: 'UPDATE_DROPPABLE_SCROLL',
        payload: args
    };
};
var $bd7d663e2fcda8c2$var$updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
    return {
        type: 'UPDATE_DROPPABLE_IS_ENABLED',
        payload: args
    };
};
var $bd7d663e2fcda8c2$var$updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
    return {
        type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
        payload: args
    };
};
var $bd7d663e2fcda8c2$var$move = function move(args) {
    return {
        type: 'MOVE',
        payload: args
    };
};
var $bd7d663e2fcda8c2$var$moveByWindowScroll = function moveByWindowScroll(args) {
    return {
        type: 'MOVE_BY_WINDOW_SCROLL',
        payload: args
    };
};
var $bd7d663e2fcda8c2$var$updateViewportMaxScroll = function updateViewportMaxScroll(args) {
    return {
        type: 'UPDATE_VIEWPORT_MAX_SCROLL',
        payload: args
    };
};
var $bd7d663e2fcda8c2$var$moveUp = function moveUp() {
    return {
        type: 'MOVE_UP',
        payload: null
    };
};
var $bd7d663e2fcda8c2$var$moveDown = function moveDown() {
    return {
        type: 'MOVE_DOWN',
        payload: null
    };
};
var $bd7d663e2fcda8c2$var$moveRight = function moveRight() {
    return {
        type: 'MOVE_RIGHT',
        payload: null
    };
};
var $bd7d663e2fcda8c2$var$moveLeft = function moveLeft() {
    return {
        type: 'MOVE_LEFT',
        payload: null
    };
};
var $bd7d663e2fcda8c2$var$clean$1 = function clean(args) {
    if (args === void 0) args = {
        shouldFlush: false
    };
    return {
        type: 'CLEAN',
        payload: args
    };
};
var $bd7d663e2fcda8c2$var$animateDrop = function animateDrop(args) {
    return {
        type: 'DROP_ANIMATE',
        payload: args
    };
};
var $bd7d663e2fcda8c2$var$completeDrop = function completeDrop(args) {
    return {
        type: 'DROP_COMPLETE',
        payload: args
    };
};
var $bd7d663e2fcda8c2$var$drop = function drop(args) {
    return {
        type: 'DROP',
        payload: args
    };
};
var $bd7d663e2fcda8c2$var$dropPending = function dropPending(args) {
    return {
        type: 'DROP_PENDING',
        payload: args
    };
};
var $bd7d663e2fcda8c2$var$dropAnimationFinished = function dropAnimationFinished() {
    return {
        type: 'DROP_ANIMATION_FINISHED',
        payload: null
    };
};
var $bd7d663e2fcda8c2$var$lift$1 = function(marshal) {
    return function(_ref) {
        var getState = _ref.getState, dispatch = _ref.dispatch;
        return function(next) {
            return function(action) {
                if (action.type !== 'LIFT') {
                    next(action);
                    return;
                }
                var _action$payload = action.payload, id = _action$payload.id, clientSelection = _action$payload.clientSelection, movementMode = _action$payload.movementMode;
                var initial = getState();
                if (initial.phase === 'DROP_ANIMATING') dispatch($bd7d663e2fcda8c2$var$completeDrop({
                    completed: initial.completed,
                    shouldFlush: true
                }));
                !(getState().phase === 'IDLE') && (0, $kuuqU.default)(false);
                var scrollOptions = {
                    shouldPublishImmediately: movementMode === 'SNAP'
                };
                var request = {
                    draggableId: id,
                    scrollOptions: scrollOptions
                };
                var _marshal$startPublish = marshal.startPublishing(request), critical = _marshal$startPublish.critical, dimensions = _marshal$startPublish.dimensions, viewport = _marshal$startPublish.viewport;
                dispatch($bd7d663e2fcda8c2$var$initialPublish({
                    critical: critical,
                    dimensions: dimensions,
                    clientSelection: clientSelection,
                    movementMode: movementMode,
                    viewport: viewport
                }));
            };
        };
    };
};
var $bd7d663e2fcda8c2$var$style = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'INITIAL_PUBLISH') marshal.dragging();
                if (action.type === 'DROP_ANIMATE') marshal.dropping(action.payload.completed.result.reason);
                if (action.type === 'CLEAN' || action.type === 'DROP_COMPLETE') marshal.resting();
                next(action);
            };
        };
    };
};
var $bd7d663e2fcda8c2$var$curves = {
    outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
    drop: 'cubic-bezier(.2,1,.1,1)'
};
var $bd7d663e2fcda8c2$var$combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
var $bd7d663e2fcda8c2$var$timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
var $bd7d663e2fcda8c2$var$outOfTheWayTiming = $bd7d663e2fcda8c2$var$timings.outOfTheWay + "s " + $bd7d663e2fcda8c2$var$curves.outOfTheWay;
var $bd7d663e2fcda8c2$var$transitions = {
    fluid: "opacity " + $bd7d663e2fcda8c2$var$outOfTheWayTiming,
    snap: "transform " + $bd7d663e2fcda8c2$var$outOfTheWayTiming + ", opacity " + $bd7d663e2fcda8c2$var$outOfTheWayTiming,
    drop: function drop(duration) {
        var timing = duration + "s " + $bd7d663e2fcda8c2$var$curves.drop;
        return "transform " + timing + ", opacity " + timing;
    },
    outOfTheWay: "transform " + $bd7d663e2fcda8c2$var$outOfTheWayTiming,
    placeholder: "height " + $bd7d663e2fcda8c2$var$outOfTheWayTiming + ", width " + $bd7d663e2fcda8c2$var$outOfTheWayTiming + ", margin " + $bd7d663e2fcda8c2$var$outOfTheWayTiming
};
var $bd7d663e2fcda8c2$var$moveTo = function moveTo(offset) {
    return $bd7d663e2fcda8c2$var$isEqual(offset, $bd7d663e2fcda8c2$var$origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};
var $bd7d663e2fcda8c2$var$transforms = {
    moveTo: $bd7d663e2fcda8c2$var$moveTo,
    drop: function drop(offset, isCombining) {
        var translate = $bd7d663e2fcda8c2$var$moveTo(offset);
        if (!translate) return null;
        if (!isCombining) return translate;
        return translate + " scale(" + $bd7d663e2fcda8c2$var$combine.scale.drop + ")";
    }
};
var $bd7d663e2fcda8c2$var$minDropTime = $bd7d663e2fcda8c2$var$timings.minDropTime, $bd7d663e2fcda8c2$var$maxDropTime = $bd7d663e2fcda8c2$var$timings.maxDropTime;
var $bd7d663e2fcda8c2$var$dropTimeRange = $bd7d663e2fcda8c2$var$maxDropTime - $bd7d663e2fcda8c2$var$minDropTime;
var $bd7d663e2fcda8c2$var$maxDropTimeAtDistance = 1500;
var $bd7d663e2fcda8c2$var$cancelDropModifier = 0.6;
var $bd7d663e2fcda8c2$var$getDropDuration = function(_ref) {
    var current = _ref.current, destination = _ref.destination, reason = _ref.reason;
    var distance$1 = $bd7d663e2fcda8c2$var$distance(current, destination);
    if (distance$1 <= 0) return $bd7d663e2fcda8c2$var$minDropTime;
    if (distance$1 >= $bd7d663e2fcda8c2$var$maxDropTimeAtDistance) return $bd7d663e2fcda8c2$var$maxDropTime;
    var percentage = distance$1 / $bd7d663e2fcda8c2$var$maxDropTimeAtDistance;
    var duration = $bd7d663e2fcda8c2$var$minDropTime + $bd7d663e2fcda8c2$var$dropTimeRange * percentage;
    var withDuration = reason === 'CANCEL' ? duration * $bd7d663e2fcda8c2$var$cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var $bd7d663e2fcda8c2$var$getNewHomeClientOffset = function(_ref) {
    var impact = _ref.impact, draggable = _ref.draggable, dimensions = _ref.dimensions, viewport = _ref.viewport, onLift = _ref.onLift;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var droppableId = $bd7d663e2fcda8c2$var$whatIsDraggedOver(impact);
    var destination = droppableId ? droppables[droppableId] : null;
    var home = droppables[draggable.descriptor.droppableId];
    var newClientCenter = $bd7d663e2fcda8c2$var$getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        onLift: onLift,
        droppable: destination || home,
        viewport: viewport
    });
    var offset = $bd7d663e2fcda8c2$var$subtract(newClientCenter, draggable.client.borderBox.center);
    var merge = impact.merge;
    if (merge && $bd7d663e2fcda8c2$var$didStartDisplaced(merge.combine.draggableId, onLift)) return $bd7d663e2fcda8c2$var$subtract(offset, onLift.displacedBy.point);
    return offset;
};
var $bd7d663e2fcda8c2$var$getDropImpact = function(_ref) {
    var reason = _ref.reason, lastImpact = _ref.lastImpact, home = _ref.home, viewport = _ref.viewport, draggables = _ref.draggables, onLiftImpact = _ref.onLiftImpact, onLift = _ref.onLift;
    var didDropInsideDroppable = reason === 'DROP' && Boolean($bd7d663e2fcda8c2$var$whatIsDraggedOver(lastImpact));
    if (!didDropInsideDroppable) {
        var impact = $bd7d663e2fcda8c2$var$recompute({
            impact: onLiftImpact,
            destination: home,
            viewport: viewport,
            draggables: draggables,
            onLift: onLift,
            forceShouldAnimate: true
        });
        return {
            impact: impact,
            didDropInsideDroppable: didDropInsideDroppable
        };
    }
    if (lastImpact.destination) return {
        impact: lastImpact,
        didDropInsideDroppable: didDropInsideDroppable
    };
    var withoutMovement = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, lastImpact, {
        movement: $bd7d663e2fcda8c2$var$noMovement
    });
    return {
        impact: withoutMovement,
        didDropInsideDroppable: didDropInsideDroppable
    };
};
var $bd7d663e2fcda8c2$var$drop$1 = function(_ref) {
    var getState = _ref.getState, dispatch = _ref.dispatch;
    return function(next) {
        return function(action) {
            if (action.type !== 'DROP') {
                next(action);
                return;
            }
            var state = getState();
            var reason = action.payload.reason;
            if (state.phase === 'COLLECTING') {
                dispatch($bd7d663e2fcda8c2$var$dropPending({
                    reason: reason
                }));
                return;
            }
            if (state.phase === 'IDLE') return;
            var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
            !!isWaitingForDrop && (0, $kuuqU.default)(false);
            !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && (0, $kuuqU.default)(false);
            var critical = state.critical;
            var dimensions = state.dimensions;
            var _getDropImpact = $bd7d663e2fcda8c2$var$getDropImpact({
                reason: reason,
                lastImpact: state.impact,
                onLift: state.onLift,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            }), impact = _getDropImpact.impact, didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;
            var draggable = dimensions.draggables[state.critical.draggable.id];
            var destination = didDropInsideDroppable ? impact.destination : null;
            var combine = didDropInsideDroppable && impact.merge ? impact.merge.combine : null;
            var source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            var result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source: source,
                reason: reason,
                mode: state.movementMode,
                destination: destination,
                combine: combine
            };
            var newHomeClientOffset = $bd7d663e2fcda8c2$var$getNewHomeClientOffset({
                impact: impact,
                draggable: draggable,
                dimensions: dimensions,
                viewport: state.viewport,
                onLift: state.onLift
            });
            var completed = {
                critical: state.critical,
                result: result,
                impact: impact
            };
            var isAnimationRequired = !$bd7d663e2fcda8c2$var$isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch($bd7d663e2fcda8c2$var$completeDrop({
                    completed: completed,
                    shouldFlush: false
                }));
                return;
            }
            var dropDuration = $bd7d663e2fcda8c2$var$getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason: reason
            });
            var args = {
                newHomeClientOffset: newHomeClientOffset,
                dropDuration: dropDuration,
                completed: completed
            };
            dispatch($bd7d663e2fcda8c2$var$animateDrop(args));
        };
    };
};
var $bd7d663e2fcda8c2$var$position = function position(index) {
    return index + 1;
};
var $bd7d663e2fcda8c2$var$onDragStart = function onDragStart(start) {
    return "\n  You have lifted an item in position " + $bd7d663e2fcda8c2$var$position(start.source.index) + ".\n  Use the arrow keys to move, space bar to drop, and escape to cancel.\n";
};
var $bd7d663e2fcda8c2$var$withLocation = function withLocation(source, destination) {
    var isInHomeList = source.droppableId === destination.droppableId;
    var startPosition = $bd7d663e2fcda8c2$var$position(source.index);
    var endPosition = $bd7d663e2fcda8c2$var$position(destination.index);
    if (isInHomeList) return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
    return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};
var $bd7d663e2fcda8c2$var$withCombine = function withCombine(id, source, combine) {
    var inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
    return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};
var $bd7d663e2fcda8c2$var$onDragUpdate = function onDragUpdate(update) {
    var location = update.destination;
    if (location) return $bd7d663e2fcda8c2$var$withLocation(update.source, location);
    var combine = update.combine;
    if (combine) return $bd7d663e2fcda8c2$var$withCombine(update.draggableId, update.source, combine);
    return 'You are over an area that cannot be dropped on';
};
var $bd7d663e2fcda8c2$var$returnedToStart = function returnedToStart(source) {
    return "\n  The item has returned to its starting position\n  of " + $bd7d663e2fcda8c2$var$position(source.index) + "\n";
};
var $bd7d663e2fcda8c2$var$onDragEnd = function onDragEnd(result) {
    if (result.reason === 'CANCEL') return "\n      Movement cancelled.\n      " + $bd7d663e2fcda8c2$var$returnedToStart(result.source) + "\n    ";
    var location = result.destination;
    var combine = result.combine;
    if (location) return "\n      You have dropped the item.\n      " + $bd7d663e2fcda8c2$var$withLocation(result.source, location) + "\n    ";
    if (combine) return "\n      You have dropped the item.\n      " + $bd7d663e2fcda8c2$var$withCombine(result.draggableId, result.source, combine) + "\n    ";
    return "\n    The item has been dropped while not over a drop area.\n    " + $bd7d663e2fcda8c2$var$returnedToStart(result.source) + "\n  ";
};
var $bd7d663e2fcda8c2$var$preset = {
    onDragStart: $bd7d663e2fcda8c2$var$onDragStart,
    onDragUpdate: $bd7d663e2fcda8c2$var$onDragUpdate,
    onDragEnd: $bd7d663e2fcda8c2$var$onDragEnd
};
var $bd7d663e2fcda8c2$var$getExpiringAnnounce = function(announce) {
    var wasCalled = false;
    var isExpired = false;
    var timeoutId = setTimeout(function() {
        isExpired = true;
    });
    var result = function result(message) {
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = function() {
        return wasCalled;
    };
    return result;
};
var $bd7d663e2fcda8c2$var$getAsyncMarshal = function() {
    var entries = [];
    var execute = function execute(timerId) {
        var index = $bd7d663e2fcda8c2$var$findIndex(entries, function(item) {
            return item.timerId === timerId;
        });
        !(index !== -1) && (0, $kuuqU.default)(false);
        var _entries$splice = entries.splice(index, 1), entry = _entries$splice[0];
        entry.callback();
    };
    var add = function add(fn) {
        var timerId = setTimeout(function() {
            return execute(timerId);
        });
        var entry = {
            timerId: timerId,
            callback: fn
        };
        entries.push(entry);
    };
    var flush = function flush() {
        if (!entries.length) return;
        var shallow = [].concat(entries);
        entries.length = 0;
        shallow.forEach(function(entry) {
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add: add,
        flush: flush
    };
};
var $bd7d663e2fcda8c2$var$areLocationsEqual = function areLocationsEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
var $bd7d663e2fcda8c2$var$isCombineEqual = function isCombineEqual(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var $bd7d663e2fcda8c2$var$isCriticalEqual = function isCriticalEqual(first, second) {
    if (first === second) return true;
    var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
var $bd7d663e2fcda8c2$var$withTimings = function withTimings(key, fn) {
    $bd7d663e2fcda8c2$var$start(key);
    fn();
    $bd7d663e2fcda8c2$var$finish(key);
};
var $bd7d663e2fcda8c2$var$getDragStart = function getDragStart(critical, mode) {
    return {
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode: mode
    };
};
var $bd7d663e2fcda8c2$var$execute = function execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    var willExpire = $bd7d663e2fcda8c2$var$getExpiringAnnounce(announce);
    var provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
};
var $bd7d663e2fcda8c2$var$getPublisher = function(getResponders, announce) {
    var asyncMarshal = $bd7d663e2fcda8c2$var$getAsyncMarshal();
    var dragging = null;
    var beforeStart = function beforeStart(critical, mode) {
        !!dragging && (0, $kuuqU.default)(false);
        $bd7d663e2fcda8c2$var$withTimings('onBeforeDragStart', function() {
            var fn = getResponders().onBeforeDragStart;
            if (fn) fn($bd7d663e2fcda8c2$var$getDragStart(critical, mode));
        });
    };
    var start = function start(critical, mode) {
        !!dragging && (0, $kuuqU.default)(false);
        var data = $bd7d663e2fcda8c2$var$getDragStart(critical, mode);
        dragging = {
            mode: mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(function() {
            $bd7d663e2fcda8c2$var$withTimings('onDragStart', function() {
                return $bd7d663e2fcda8c2$var$execute(getResponders().onDragStart, data, announce, $bd7d663e2fcda8c2$var$preset.onDragStart);
            });
        });
    };
    var update = function update(critical, impact) {
        var location = impact.destination;
        var combine = impact.merge ? impact.merge.combine : null;
        !dragging && (0, $kuuqU.default)(false);
        var hasCriticalChanged = !$bd7d663e2fcda8c2$var$isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        var hasLocationChanged = !$bd7d663e2fcda8c2$var$areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        var hasGroupingChanged = !$bd7d663e2fcda8c2$var$isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        var data = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, $bd7d663e2fcda8c2$var$getDragStart(critical, dragging.mode), {
            combine: combine,
            destination: location
        });
        asyncMarshal.add(function() {
            $bd7d663e2fcda8c2$var$withTimings('onDragUpdate', function() {
                return $bd7d663e2fcda8c2$var$execute(getResponders().onDragUpdate, data, announce, $bd7d663e2fcda8c2$var$preset.onDragUpdate);
            });
        });
    };
    var flush = function flush() {
        !dragging && (0, $kuuqU.default)(false);
        asyncMarshal.flush();
    };
    var drop = function drop(result) {
        !dragging && (0, $kuuqU.default)(false);
        dragging = null;
        $bd7d663e2fcda8c2$var$withTimings('onDragEnd', function() {
            return $bd7d663e2fcda8c2$var$execute(getResponders().onDragEnd, result, announce, $bd7d663e2fcda8c2$var$preset.onDragEnd);
        });
    };
    var abort = function abort() {
        if (!dragging) return;
        var result = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, $bd7d663e2fcda8c2$var$getDragStart(dragging.lastCritical, dragging.mode), {
            combine: null,
            destination: null,
            reason: 'CANCEL'
        });
        drop(result);
    };
    return {
        beforeStart: beforeStart,
        start: start,
        update: update,
        flush: flush,
        drop: drop,
        abort: abort
    };
};
var $bd7d663e2fcda8c2$var$responders = function(getResponders, announce) {
    var publisher = $bd7d663e2fcda8c2$var$getPublisher(getResponders, announce);
    return function(store) {
        return function(next) {
            return function(action) {
                if (action.type === 'INITIAL_PUBLISH') {
                    var critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if (action.type === 'DROP_COMPLETE') {
                    var result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if (action.type === 'CLEAN') {
                    publisher.abort();
                    return;
                }
                var state = store.getState();
                if (state.phase === 'DRAGGING') publisher.update(state.critical, state.impact);
            };
        };
    };
};
var $bd7d663e2fcda8c2$var$dropAnimationFinish = function(store) {
    return function(next) {
        return function(action) {
            if (action.type !== 'DROP_ANIMATION_FINISHED') {
                next(action);
                return;
            }
            var state = store.getState();
            !(state.phase === 'DROP_ANIMATING') && (0, $kuuqU.default)(false);
            store.dispatch($bd7d663e2fcda8c2$var$completeDrop({
                completed: state.completed,
                shouldFlush: false
            }));
        };
    };
};
var $bd7d663e2fcda8c2$var$dimensionMarshalStopper = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === 'DROP_COMPLETE' || action.type === 'CLEAN' || action.type === 'DROP_ANIMATE') marshal.stopPublishing();
                next(action);
            };
        };
    };
};
var $bd7d663e2fcda8c2$var$shouldEnd = function shouldEnd(action) {
    return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'CLEAN';
};
var $bd7d663e2fcda8c2$var$shouldCancelPending = function shouldCancelPending(action) {
    return action.type === 'COLLECTION_STARTING';
};
var $bd7d663e2fcda8c2$var$autoScroll = function(autoScroller) {
    return function(store) {
        return function(next) {
            return function(action) {
                if ($bd7d663e2fcda8c2$var$shouldEnd(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if ($bd7d663e2fcda8c2$var$shouldCancelPending(action)) {
                    autoScroller.cancelPending();
                    next(action);
                    return;
                }
                if (action.type === 'INITIAL_PUBLISH') {
                    next(action);
                    var state = store.getState();
                    !(state.phase === 'DRAGGING') && (0, $kuuqU.default)(false);
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
        };
    };
};
var $bd7d663e2fcda8c2$var$pendingDrop = function(store) {
    return function(next) {
        return function(action) {
            next(action);
            if (action.type !== 'PUBLISH_WHILE_DRAGGING') return;
            var postActionState = store.getState();
            if (postActionState.phase !== 'DROP_PENDING') return;
            if (postActionState.isWaiting) return;
            store.dispatch($bd7d663e2fcda8c2$var$drop({
                reason: postActionState.reason
            }));
        };
    };
};
var $bd7d663e2fcda8c2$var$composeEnhancers = (0, $7778c83e64d928d5$export$f672e0b6f7222cd7);
var $bd7d663e2fcda8c2$var$createStore = function(_ref) {
    var dimensionMarshal = _ref.dimensionMarshal, styleMarshal = _ref.styleMarshal, getResponders = _ref.getResponders, announce = _ref.announce, autoScroller = _ref.autoScroller;
    return (0, $7778c83e64d928d5$export$f51a9068ac82ea43)($bd7d663e2fcda8c2$var$reducer, $bd7d663e2fcda8c2$var$composeEnhancers((0, $7778c83e64d928d5$export$9ff26e0402cc7b7)($bd7d663e2fcda8c2$var$style(styleMarshal), $bd7d663e2fcda8c2$var$dimensionMarshalStopper(dimensionMarshal), $bd7d663e2fcda8c2$var$lift$1(dimensionMarshal), $bd7d663e2fcda8c2$var$drop$1, $bd7d663e2fcda8c2$var$dropAnimationFinish, $bd7d663e2fcda8c2$var$pendingDrop, $bd7d663e2fcda8c2$var$autoScroll(autoScroller), $bd7d663e2fcda8c2$var$responders(getResponders, announce))));
};
var $bd7d663e2fcda8c2$var$clean$2 = function clean() {
    return {
        additions: {},
        removals: {},
        modified: {}
    };
};
var $bd7d663e2fcda8c2$var$timingKey = 'Publish collection from DOM';
var $bd7d663e2fcda8c2$var$createPublisher = function(_ref) {
    var getEntries = _ref.getEntries, callbacks = _ref.callbacks;
    var advancedUsageWarning = function() {
        var hasAnnounced;
        return function() {};
    }();
    var staging = $bd7d663e2fcda8c2$var$clean$2();
    var frameId = null;
    var collect = function collect() {
        advancedUsageWarning();
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            callbacks.collectionStarting();
            var critical = callbacks.getCritical();
            $bd7d663e2fcda8c2$var$start($bd7d663e2fcda8c2$var$timingKey);
            var entries = getEntries();
            var _staging = staging, additions = _staging.additions, removals = _staging.removals, modified = _staging.modified;
            var added = (0, (/*@__PURE__*/$parcel$interopDefault($215be2e2d7075d90$exports)))(additions).map(function(id) {
                return entries.draggables[id].getDimension($bd7d663e2fcda8c2$var$origin);
            }).sort(function(a, b) {
                return a.descriptor.index - b.descriptor.index;
            });
            var updated = (0, (/*@__PURE__*/$parcel$interopDefault($215be2e2d7075d90$exports)))(modified).map(function(id) {
                var entry = entries.droppables[id];
                !entry && (0, $kuuqU.default)(false);
                var isHome = entry.descriptor.id === critical.droppable.id;
                var options = {
                    withoutPlaceholder: !isHome
                };
                return entry.callbacks.recollect(options);
            });
            var result = {
                additions: added,
                removals: (0, (/*@__PURE__*/$parcel$interopDefault($215be2e2d7075d90$exports)))(removals),
                modified: updated
            };
            staging = $bd7d663e2fcda8c2$var$clean$2();
            $bd7d663e2fcda8c2$var$finish($bd7d663e2fcda8c2$var$timingKey);
            callbacks.publish(result);
        });
    };
    var add = function add(descriptor) {
        staging.additions[descriptor.id] = descriptor;
        staging.modified[descriptor.droppableId] = true;
        if (staging.removals[descriptor.id]) delete staging.removals[descriptor.id];
        collect();
    };
    var remove = function remove(descriptor) {
        staging.removals[descriptor.id] = descriptor;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    var stop = function stop() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = $bd7d663e2fcda8c2$var$clean$2();
    };
    return {
        add: add,
        remove: remove,
        stop: stop
    };
};
var $bd7d663e2fcda8c2$var$getWindowScroll = function() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $bd7d663e2fcda8c2$var$getDocumentElement = function() {
    var doc = document.documentElement;
    !doc && (0, $kuuqU.default)(false);
    return doc;
};
var $bd7d663e2fcda8c2$var$getMaxWindowScroll = function() {
    var doc = $bd7d663e2fcda8c2$var$getDocumentElement();
    var maxScroll = $bd7d663e2fcda8c2$var$getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var $bd7d663e2fcda8c2$var$getViewport = function() {
    var scroll = $bd7d663e2fcda8c2$var$getWindowScroll();
    var maxScroll = $bd7d663e2fcda8c2$var$getMaxWindowScroll();
    var top = scroll.y;
    var left = scroll.x;
    var doc = $bd7d663e2fcda8c2$var$getDocumentElement();
    var width = doc.clientWidth;
    var height = doc.clientHeight;
    var right = left + width;
    var bottom = top + height;
    var frame = (0, $b703e4029dc36ed5$export$4b834cebd9e5cebe)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    var viewport = {
        frame: frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: $bd7d663e2fcda8c2$var$origin,
                displacement: $bd7d663e2fcda8c2$var$origin
            }
        }
    };
    return viewport;
};
var $bd7d663e2fcda8c2$var$getInitialPublish = function(_ref) {
    var critical = _ref.critical, scrollOptions = _ref.scrollOptions, entries = _ref.entries;
    var timingKey = 'Initial collection from DOM';
    $bd7d663e2fcda8c2$var$start(timingKey);
    var viewport = $bd7d663e2fcda8c2$var$getViewport();
    var windowScroll = viewport.scroll.current;
    var home = critical.droppable;
    var droppables = $bd7d663e2fcda8c2$var$values(entries.droppables).filter(function(entry) {
        return entry.descriptor.type === home.type;
    }).map(function(entry) {
        return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
    });
    var draggables = $bd7d663e2fcda8c2$var$values(entries.draggables).filter(function(entry) {
        return entry.descriptor.type === critical.draggable.type;
    }).map(function(entry) {
        return entry.getDimension(windowScroll);
    });
    var dimensions = {
        draggables: $bd7d663e2fcda8c2$var$toDraggableMap(draggables),
        droppables: $bd7d663e2fcda8c2$var$toDroppableMap(droppables)
    };
    $bd7d663e2fcda8c2$var$finish(timingKey);
    var result = {
        dimensions: dimensions,
        critical: critical,
        viewport: viewport
    };
    return result;
};
var $bd7d663e2fcda8c2$var$throwIfAddOrRemoveOfWrongType = function throwIfAddOrRemoveOfWrongType(collection, descriptor) {
    !(collection.critical.draggable.type === descriptor.type) && (0, $kuuqU.default)(false);
};
var $bd7d663e2fcda8c2$var$createDimensionMarshal = function(callbacks) {
    var entries = {
        droppables: {},
        draggables: {}
    };
    var collection = null;
    var publisher = $bd7d663e2fcda8c2$var$createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting,
            getCritical: function getCritical() {
                !collection && (0, $kuuqU.default)(false);
                return collection.critical;
            }
        },
        getEntries: function getEntries() {
            return entries;
        }
    });
    var registerDraggable = function registerDraggable(descriptor, getDimension) {
        var entry = {
            descriptor: descriptor,
            getDimension: getDimension
        };
        entries.draggables[descriptor.id] = entry;
        if (!collection) return;
        $bd7d663e2fcda8c2$var$throwIfAddOrRemoveOfWrongType(collection, descriptor);
        publisher.add(descriptor);
    };
    var updateDraggable = function updateDraggable(published, descriptor, getDimension) {
        var existing = entries.draggables[published.id];
        !existing && (0, $kuuqU.default)(false);
        if (existing.descriptor === published) delete entries.draggables[published.id];
        var entry = {
            descriptor: descriptor,
            getDimension: getDimension
        };
        entries.draggables[descriptor.id] = entry;
    };
    var unregisterDraggable = function unregisterDraggable(descriptor) {
        var entry = entries.draggables[descriptor.id];
        !entry && (0, $kuuqU.default)(false);
        if (entry.descriptor !== descriptor) return;
        delete entries.draggables[descriptor.id];
        if (!collection) return;
        !(collection.critical.draggable.id !== descriptor.id) && (0, $kuuqU.default)(false);
        $bd7d663e2fcda8c2$var$throwIfAddOrRemoveOfWrongType(collection, descriptor);
        publisher.remove(descriptor);
    };
    var registerDroppable = function registerDroppable(descriptor, droppableCallbacks) {
        var id = descriptor.id;
        entries.droppables[id] = {
            descriptor: descriptor,
            callbacks: droppableCallbacks
        };
        !!collection && (0, $kuuqU.default)(false);
    };
    var unregisterDroppable = function unregisterDroppable(descriptor) {
        var entry = entries.droppables[descriptor.id];
        !entry && (0, $kuuqU.default)(false);
        if (entry.descriptor !== descriptor) return;
        delete entries.droppables[descriptor.id];
        !!collection && (0, $kuuqU.default)(false);
    };
    var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
        !entries.droppables[id] && (0, $kuuqU.default)(false);
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id: id,
            isEnabled: isEnabled
        });
    };
    var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
        !entries.droppables[id] && (0, $kuuqU.default)(false);
        if (!collection) return;
        callbacks.updateDroppableIsCombineEnabled({
            id: id,
            isCombineEnabled: isCombineEnabled
        });
    };
    var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
        !entries.droppables[id] && (0, $kuuqU.default)(false);
        if (!collection) return;
        callbacks.updateDroppableScroll({
            id: id,
            offset: newScroll
        });
    };
    var scrollDroppable = function scrollDroppable(id, change) {
        var entry = entries.droppables[id];
        !entry && (0, $kuuqU.default)(false);
        if (!collection) return;
        entry.callbacks.scroll(change);
    };
    var stopPublishing = function stopPublishing() {
        if (!collection) return;
        publisher.stop();
        var home = collection.critical.droppable;
        $bd7d663e2fcda8c2$var$values(entries.droppables).filter(function(entry) {
            return entry.descriptor.type === home.type;
        }).forEach(function(entry) {
            return entry.callbacks.dragStopped();
        });
        collection = null;
    };
    var startPublishing = function startPublishing(request) {
        !!collection && (0, $kuuqU.default)(false);
        var entry = entries.draggables[request.draggableId];
        !entry && (0, $kuuqU.default)(false);
        var home = entries.droppables[entry.descriptor.droppableId];
        !home && (0, $kuuqU.default)(false);
        var critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        collection = {
            critical: critical
        };
        return $bd7d663e2fcda8c2$var$getInitialPublish({
            critical: critical,
            entries: entries,
            scrollOptions: request.scrollOptions
        });
    };
    var marshal = {
        registerDraggable: registerDraggable,
        updateDraggable: updateDraggable,
        unregisterDraggable: unregisterDraggable,
        registerDroppable: registerDroppable,
        unregisterDroppable: unregisterDroppable,
        updateDroppableIsEnabled: updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
        scrollDroppable: scrollDroppable,
        updateDroppableScroll: updateDroppableScroll,
        startPublishing: startPublishing,
        stopPublishing: stopPublishing
    };
    return marshal;
};
var $bd7d663e2fcda8c2$var$canStartDrag = function(state, id) {
    if (state.phase === 'IDLE') return true;
    if (state.phase !== 'DROP_ANIMATING') return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === 'DROP';
};
var $bd7d663e2fcda8c2$var$scrollWindow = function(change) {
    window.scrollBy(change.x, change.y);
};
var $bd7d663e2fcda8c2$var$getScrollableDroppables = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(droppables) {
    return $bd7d663e2fcda8c2$var$toDroppableList(droppables).filter(function(droppable) {
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    });
});
var $bd7d663e2fcda8c2$var$getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
    var maybe = $bd7d663e2fcda8c2$var$find($bd7d663e2fcda8c2$var$getScrollableDroppables(droppables), function(droppable) {
        !droppable.frame && (0, $kuuqU.default)(false);
        return $bd7d663e2fcda8c2$var$isPositionInFrame(droppable.frame.pageMarginBox)(target);
    });
    return maybe;
};
var $bd7d663e2fcda8c2$var$getBestScrollableDroppable = function(_ref) {
    var center = _ref.center, destination = _ref.destination, droppables = _ref.droppables;
    if (destination) {
        var _dimension = droppables[destination];
        if (!_dimension.frame) return null;
        return _dimension;
    }
    var dimension = $bd7d663e2fcda8c2$var$getScrollableDroppableOver(center, droppables);
    return dimension;
};
var $bd7d663e2fcda8c2$var$config = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: function ease(percentage) {
        return Math.pow(percentage, 2);
    },
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    }
};
var $bd7d663e2fcda8c2$var$getDistanceThresholds = function(container, axis) {
    var startScrollingFrom = container[axis.size] * $bd7d663e2fcda8c2$var$config.startFromPercentage;
    var maxScrollValueAt = container[axis.size] * $bd7d663e2fcda8c2$var$config.maxScrollAtPercentage;
    var thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $bd7d663e2fcda8c2$var$getPercentage = function(_ref) {
    var startOfRange = _ref.startOfRange, endOfRange = _ref.endOfRange, current = _ref.current;
    var range = endOfRange - startOfRange;
    if (range === 0) return 0;
    var currentInRange = current - startOfRange;
    var percentage = currentInRange / range;
    return percentage;
};
var $bd7d663e2fcda8c2$var$minScroll = 1;
var $bd7d663e2fcda8c2$var$getValueFromDistance = function(distanceToEdge, thresholds) {
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return $bd7d663e2fcda8c2$var$config.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return $bd7d663e2fcda8c2$var$minScroll;
    var percentageFromMaxScrollValueAt = $bd7d663e2fcda8c2$var$getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    var scroll = $bd7d663e2fcda8c2$var$config.maxPixelScroll * $bd7d663e2fcda8c2$var$config.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var $bd7d663e2fcda8c2$var$accelerateAt = $bd7d663e2fcda8c2$var$config.durationDampening.accelerateAt;
var $bd7d663e2fcda8c2$var$stopAt = $bd7d663e2fcda8c2$var$config.durationDampening.stopDampeningAt;
var $bd7d663e2fcda8c2$var$dampenValueByTime = function(proposedScroll, dragStartTime) {
    var startOfRange = dragStartTime;
    var endOfRange = $bd7d663e2fcda8c2$var$stopAt;
    var now = (0, (/*@__PURE__*/$parcel$interopDefault($2844f46160634521$exports)))();
    var runTime = now - startOfRange;
    if (runTime >= $bd7d663e2fcda8c2$var$stopAt) return proposedScroll;
    if (runTime < $bd7d663e2fcda8c2$var$accelerateAt) return $bd7d663e2fcda8c2$var$minScroll;
    var betweenAccelerateAtAndStopAtPercentage = $bd7d663e2fcda8c2$var$getPercentage({
        startOfRange: $bd7d663e2fcda8c2$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    var scroll = proposedScroll * $bd7d663e2fcda8c2$var$config.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var $bd7d663e2fcda8c2$var$getValue = function(_ref) {
    var distanceToEdge = _ref.distanceToEdge, thresholds = _ref.thresholds, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $bd7d663e2fcda8c2$var$getValueFromDistance(distanceToEdge, thresholds);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max($bd7d663e2fcda8c2$var$dampenValueByTime(scroll, dragStartTime), $bd7d663e2fcda8c2$var$minScroll);
};
var $bd7d663e2fcda8c2$var$getScrollOnAxis = function(_ref) {
    var container = _ref.container, distanceToEdges = _ref.distanceToEdges, dragStartTime = _ref.dragStartTime, axis = _ref.axis, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var thresholds = $bd7d663e2fcda8c2$var$getDistanceThresholds(container, axis);
    var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return $bd7d663e2fcda8c2$var$getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * $bd7d663e2fcda8c2$var$getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};
var $bd7d663e2fcda8c2$var$adjustForSizeLimits = function(_ref) {
    var container = _ref.container, subject = _ref.subject, proposedScroll = _ref.proposedScroll;
    var isTooBigVertically = subject.height > container.height;
    var isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
var $bd7d663e2fcda8c2$var$clean$3 = $bd7d663e2fcda8c2$var$apply(function(value) {
    return value === 0 ? 0 : value;
});
var $bd7d663e2fcda8c2$var$getScroll = function(_ref) {
    var dragStartTime = _ref.dragStartTime, container = _ref.container, subject = _ref.subject, center = _ref.center, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    var y = $bd7d663e2fcda8c2$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $bd7d663e2fcda8c2$var$vertical,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var x = $bd7d663e2fcda8c2$var$getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: $bd7d663e2fcda8c2$var$horizontal,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    var required = $bd7d663e2fcda8c2$var$clean$3({
        x: x,
        y: y
    });
    if ($bd7d663e2fcda8c2$var$isEqual(required, $bd7d663e2fcda8c2$var$origin)) return null;
    var limited = $bd7d663e2fcda8c2$var$adjustForSizeLimits({
        container: container,
        subject: subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return $bd7d663e2fcda8c2$var$isEqual(limited, $bd7d663e2fcda8c2$var$origin) ? null : limited;
};
var $bd7d663e2fcda8c2$var$smallestSigned = $bd7d663e2fcda8c2$var$apply(function(value) {
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
var $bd7d663e2fcda8c2$var$getOverlap = function() {
    var getRemainder = function getRemainder(target, max) {
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return function(_ref) {
        var current = _ref.current, max = _ref.max, change = _ref.change;
        var targetScroll = $bd7d663e2fcda8c2$var$add(current, change);
        var overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ($bd7d663e2fcda8c2$var$isEqual(overlap, $bd7d663e2fcda8c2$var$origin)) return null;
        return overlap;
    };
}();
var $bd7d663e2fcda8c2$var$canPartiallyScroll = function canPartiallyScroll(_ref2) {
    var rawMax = _ref2.max, current = _ref2.current, change = _ref2.change;
    var max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    var smallestChange = $bd7d663e2fcda8c2$var$smallestSigned(change);
    var overlap = $bd7d663e2fcda8c2$var$getOverlap({
        max: max,
        current: current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
var $bd7d663e2fcda8c2$var$canScrollWindow = function canScrollWindow(viewport, change) {
    return $bd7d663e2fcda8c2$var$canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
};
var $bd7d663e2fcda8c2$var$getWindowOverlap = function getWindowOverlap(viewport, change) {
    if (!$bd7d663e2fcda8c2$var$canScrollWindow(viewport, change)) return null;
    var max = viewport.scroll.max;
    var current = viewport.scroll.current;
    return $bd7d663e2fcda8c2$var$getOverlap({
        current: current,
        max: max,
        change: change
    });
};
var $bd7d663e2fcda8c2$var$canScrollDroppable = function canScrollDroppable(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return false;
    return $bd7d663e2fcda8c2$var$canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $bd7d663e2fcda8c2$var$getDroppableOverlap = function getDroppableOverlap(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return null;
    if (!$bd7d663e2fcda8c2$var$canScrollDroppable(droppable, change)) return null;
    return $bd7d663e2fcda8c2$var$getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var $bd7d663e2fcda8c2$var$getWindowScrollChange = function(_ref) {
    var viewport = _ref.viewport, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var scroll = $bd7d663e2fcda8c2$var$getScroll({
        dragStartTime: dragStartTime,
        container: viewport.frame,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $bd7d663e2fcda8c2$var$canScrollWindow(viewport, scroll) ? scroll : null;
};
var $bd7d663e2fcda8c2$var$getDroppableScrollChange = function(_ref) {
    var droppable = _ref.droppable, subject = _ref.subject, center = _ref.center, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening;
    var frame = droppable.frame;
    if (!frame) return null;
    var scroll = $bd7d663e2fcda8c2$var$getScroll({
        dragStartTime: dragStartTime,
        container: frame.pageMarginBox,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && $bd7d663e2fcda8c2$var$canScrollDroppable(droppable, scroll) ? scroll : null;
};
var $bd7d663e2fcda8c2$var$scroll$1 = function(_ref) {
    var state = _ref.state, dragStartTime = _ref.dragStartTime, shouldUseTimeDampening = _ref.shouldUseTimeDampening, scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var center = state.current.page.borderBoxCenter;
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        var viewport = state.viewport;
        var _change = $bd7d663e2fcda8c2$var$getWindowScrollChange({
            dragStartTime: dragStartTime,
            viewport: viewport,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (_change) {
            scrollWindow(_change);
            return;
        }
    }
    var droppable = $bd7d663e2fcda8c2$var$getBestScrollableDroppable({
        center: center,
        destination: $bd7d663e2fcda8c2$var$whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    var change = $bd7d663e2fcda8c2$var$getDroppableScrollChange({
        dragStartTime: dragStartTime,
        droppable: droppable,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    if (change) scrollDroppable(droppable.descriptor.id, change);
};
var $bd7d663e2fcda8c2$var$createFluidScroller = function(_ref) {
    var scrollWindow = _ref.scrollWindow, scrollDroppable = _ref.scrollDroppable;
    var scheduleWindowScroll = (0, $3a3632abf48ab519$export$2e2bcd8739ae039)(scrollWindow);
    var scheduleDroppableScroll = (0, $3a3632abf48ab519$export$2e2bcd8739ae039)(scrollDroppable);
    var dragging = null;
    var tryScroll = function tryScroll(state) {
        !dragging && (0, $kuuqU.default)(false);
        var _dragging = dragging, shouldUseTimeDampening = _dragging.shouldUseTimeDampening, dragStartTime = _dragging.dragStartTime;
        $bd7d663e2fcda8c2$var$scroll$1({
            state: state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
    };
    var cancelPending = function cancelPending() {
        !dragging && (0, $kuuqU.default)(false);
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
    };
    var start$1 = function start$1(state) {
        $bd7d663e2fcda8c2$var$start('starting fluid scroller');
        !!dragging && (0, $kuuqU.default)(false);
        var dragStartTime = (0, (/*@__PURE__*/$parcel$interopDefault($2844f46160634521$exports)))();
        var wasScrollNeeded = false;
        var fakeScrollCallback = function fakeScrollCallback() {
            wasScrollNeeded = true;
        };
        $bd7d663e2fcda8c2$var$scroll$1({
            state: state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback
        });
        dragging = {
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        $bd7d663e2fcda8c2$var$finish('starting fluid scroller');
        if (wasScrollNeeded) tryScroll(state);
    };
    var stop = function stop() {
        if (!dragging) return;
        cancelPending();
        dragging = null;
    };
    return {
        start: start$1,
        stop: stop,
        cancelPending: cancelPending,
        scroll: tryScroll
    };
};
var $bd7d663e2fcda8c2$var$createJumpScroller = function(_ref) {
    var move = _ref.move, scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow;
    var moveByOffset = function moveByOffset(state, offset) {
        var client = $bd7d663e2fcda8c2$var$add(state.current.client.selection, offset);
        move({
            client: client
        });
    };
    var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
        if (!$bd7d663e2fcda8c2$var$canScrollDroppable(droppable, change)) return change;
        var overlap = $bd7d663e2fcda8c2$var$getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        var whatTheDroppableCanScroll = $bd7d663e2fcda8c2$var$subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        var remainder = $bd7d663e2fcda8c2$var$subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
        if (!isWindowScrollAllowed) return change;
        if (!$bd7d663e2fcda8c2$var$canScrollWindow(viewport, change)) return change;
        var overlap = $bd7d663e2fcda8c2$var$getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        var whatTheWindowCanScroll = $bd7d663e2fcda8c2$var$subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        var remainder = $bd7d663e2fcda8c2$var$subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    var jumpScroller = function jumpScroller(state) {
        var request = state.scrollJumpRequest;
        if (!request) return;
        var destination = $bd7d663e2fcda8c2$var$whatIsDraggedOver(state.impact);
        !destination && (0, $kuuqU.default)(false);
        var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        var viewport = state.viewport;
        var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var $bd7d663e2fcda8c2$var$createAutoScroller = function(_ref) {
    var scrollDroppable = _ref.scrollDroppable, scrollWindow = _ref.scrollWindow, move = _ref.move;
    var fluidScroller = $bd7d663e2fcda8c2$var$createFluidScroller({
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var jumpScroll = $bd7d663e2fcda8c2$var$createJumpScroller({
        move: move,
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var scroll = function scroll(state) {
        if (state.phase !== 'DRAGGING') return;
        if (state.movementMode === 'FLUID') {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    var scroller = {
        scroll: scroll,
        cancelPending: fluidScroller.cancelPending,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
var $bd7d663e2fcda8c2$var$prefix = 'data-react-beautiful-dnd';
var $bd7d663e2fcda8c2$var$dragHandle = $bd7d663e2fcda8c2$var$prefix + "-drag-handle";
var $bd7d663e2fcda8c2$var$draggable = $bd7d663e2fcda8c2$var$prefix + "-draggable";
var $bd7d663e2fcda8c2$var$droppable = $bd7d663e2fcda8c2$var$prefix + "-droppable";
var $bd7d663e2fcda8c2$var$makeGetSelector = function makeGetSelector(context) {
    return function(attribute) {
        return "[" + attribute + "=\"" + context + "\"]";
    };
};
var $bd7d663e2fcda8c2$var$getStyles = function getStyles(rules, property) {
    return rules.map(function(rule) {
        var value = rule.styles[property];
        if (!value) return '';
        return rule.selector + " { " + value + " }";
    }).join(' ');
};
var $bd7d663e2fcda8c2$var$noPointerEvents = 'pointer-events: none;';
var $bd7d663e2fcda8c2$var$getStyles$1 = function(uniqueContext) {
    var getSelector = $bd7d663e2fcda8c2$var$makeGetSelector(uniqueContext);
    var dragHandle$1 = function() {
        var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
        return {
            selector: getSelector($bd7d663e2fcda8c2$var$dragHandle),
            styles: {
                always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
                resting: grabCursor,
                dragging: $bd7d663e2fcda8c2$var$noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    }();
    var draggable$1 = function() {
        var transition = "\n      transition: " + $bd7d663e2fcda8c2$var$transitions.outOfTheWay + ";\n    ";
        return {
            selector: getSelector($bd7d663e2fcda8c2$var$draggable),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    }();
    var droppable$1 = {
        selector: getSelector($bd7d663e2fcda8c2$var$droppable),
        styles: {
            always: "overflow-anchor: none;"
        }
    };
    var body = {
        selector: 'body',
        styles: {
            dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
        }
    };
    var rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: $bd7d663e2fcda8c2$var$getStyles(rules, 'always'),
        resting: $bd7d663e2fcda8c2$var$getStyles(rules, 'resting'),
        dragging: $bd7d663e2fcda8c2$var$getStyles(rules, 'dragging'),
        dropAnimating: $bd7d663e2fcda8c2$var$getStyles(rules, 'dropAnimating'),
        userCancel: $bd7d663e2fcda8c2$var$getStyles(rules, 'userCancel')
    };
};
var $bd7d663e2fcda8c2$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? (0, $ieT14.useLayoutEffect) : (0, $ieT14.useEffect);
var $bd7d663e2fcda8c2$var$getHead = function getHead() {
    var head = document.querySelector('head');
    !head && (0, $kuuqU.default)(false);
    return head;
};
var $bd7d663e2fcda8c2$var$createStyleEl = function createStyleEl() {
    var el = document.createElement('style');
    el.type = 'text/css';
    return el;
};
function $bd7d663e2fcda8c2$var$useStyleMarshal(uniqueId) {
    var uniqueContext = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return "" + uniqueId;
    }, [
        uniqueId
    ]);
    var styles = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return $bd7d663e2fcda8c2$var$getStyles$1(uniqueContext);
    }, [
        uniqueContext
    ]);
    var alwaysRef = (0, $ieT14.useRef)(null);
    var dynamicRef = (0, $ieT14.useRef)(null);
    var setDynamicStyle = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)((0, $bab2733189173eea$export$2e2bcd8739ae039)(function(proposed) {
        var el = dynamicRef.current;
        !el && (0, $kuuqU.default)(false);
        el.textContent = proposed;
    }), []);
    var setAlwaysStyle = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(proposed) {
        var el = alwaysRef.current;
        !el && (0, $kuuqU.default)(false);
        el.textContent = proposed;
    }, []);
    $bd7d663e2fcda8c2$var$useIsomorphicLayoutEffect(function() {
        !(!alwaysRef.current && !dynamicRef.current) && (0, $kuuqU.default)(false);
        var always = $bd7d663e2fcda8c2$var$createStyleEl();
        var dynamic = $bd7d663e2fcda8c2$var$createStyleEl();
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute($bd7d663e2fcda8c2$var$prefix + "-always", uniqueContext);
        dynamic.setAttribute($bd7d663e2fcda8c2$var$prefix + "-dynamic", uniqueContext);
        $bd7d663e2fcda8c2$var$getHead().appendChild(always);
        $bd7d663e2fcda8c2$var$getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return function() {
            var remove = function remove(ref) {
                var current = ref.current;
                !current && (0, $kuuqU.default)(false);
                $bd7d663e2fcda8c2$var$getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        uniqueContext
    ]);
    var dragging = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        return setDynamicStyle(styles.dragging);
    }, [
        setDynamicStyle,
        styles.dragging
    ]);
    var dropping = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(reason) {
        if (reason === 'DROP') {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    var resting = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    var marshal = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            dragging: dragging,
            dropping: dropping,
            resting: resting,
            styleContext: uniqueContext
        };
    }, [
        dragging,
        dropping,
        resting,
        uniqueContext
    ]);
    return marshal;
}
var $bd7d663e2fcda8c2$var$StoreContext = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createContext(null);
var $bd7d663e2fcda8c2$var$getBodyElement = function() {
    var body = document.body;
    !body && (0, $kuuqU.default)(false);
    return body;
};
var $bd7d663e2fcda8c2$var$visuallyHidden = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: '-1px',
    border: '0',
    padding: '0',
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    'clip-path': 'inset(100%)'
};
var $bd7d663e2fcda8c2$var$getId = function getId(uniqueId) {
    return "react-beautiful-dnd-announcement-" + uniqueId;
};
function $bd7d663e2fcda8c2$var$useAnnouncer(uniqueId) {
    var id = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return $bd7d663e2fcda8c2$var$getId(uniqueId);
    }, [
        uniqueId
    ]);
    var ref = (0, $ieT14.useRef)(null);
    (0, $ieT14.useEffect)(function() {
        !!ref.current && (0, $kuuqU.default)(false);
        var el = document.createElement('div');
        ref.current = el;
        el.id = id;
        el.setAttribute('aria-live', 'assertive');
        el.setAttribute('role', 'log');
        el.setAttribute('aria-atomic', 'true');
        (0, (/*@__PURE__*/$parcel$interopDefault($0f31be94f80b080a$exports)))(el.style, $bd7d663e2fcda8c2$var$visuallyHidden);
        $bd7d663e2fcda8c2$var$getBodyElement().appendChild(el);
        return function() {
            var toBeRemoved = ref.current;
            !toBeRemoved && (0, $kuuqU.default)(false);
            $bd7d663e2fcda8c2$var$getBodyElement().removeChild(toBeRemoved);
            ref.current = null;
        };
    }, [
        id
    ]);
    var announce = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(message) {
        var el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
var $bd7d663e2fcda8c2$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createContext(null);
var $bd7d663e2fcda8c2$var$peerDependencies = {
    react: "^16.8.5"
};
var $bd7d663e2fcda8c2$var$semver = /(\d+)\.(\d+)\.(\d+)/;
var $bd7d663e2fcda8c2$var$getVersion = function getVersion(value) {
    var result = $bd7d663e2fcda8c2$var$semver.exec(value);
    !(result != null) && (0, $kuuqU.default)(false);
    var major = Number(result[1]);
    var minor = Number(result[2]);
    var patch = Number(result[3]);
    return {
        major: major,
        minor: minor,
        patch: patch,
        raw: value
    };
};
var $bd7d663e2fcda8c2$var$isSatisfied = function isSatisfied(expected, actual) {
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var $bd7d663e2fcda8c2$var$checkReactVersion = function(peerDepValue, actualValue) {
    var peerDep = $bd7d663e2fcda8c2$var$getVersion(peerDepValue);
    var actual = $bd7d663e2fcda8c2$var$getVersion(actualValue);
    if ($bd7d663e2fcda8c2$var$isSatisfied(peerDep, actual)) return;
};
var $bd7d663e2fcda8c2$var$suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var $bd7d663e2fcda8c2$var$checkDoctype = function(doc) {
    var doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function $bd7d663e2fcda8c2$var$useStartupValidation() {
    (0, $ieT14.useEffect)(function() {
        return;
    }, []);
}
function $bd7d663e2fcda8c2$var$usePrevious(current) {
    var ref = (0, $ieT14.useRef)(current);
    (0, $ieT14.useEffect)(function() {
        ref.current = current;
    });
    return ref;
}
var $bd7d663e2fcda8c2$var$createResponders = function createResponders(props) {
    return {
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    };
};
function $bd7d663e2fcda8c2$var$getStore(lazyRef) {
    !lazyRef.current && (0, $kuuqU.default)(false);
    return lazyRef.current;
}
function $bd7d663e2fcda8c2$var$App(props) {
    var uniqueId = props.uniqueId, setOnError = props.setOnError;
    var lazyStoreRef = (0, $ieT14.useRef)(null);
    $bd7d663e2fcda8c2$var$useStartupValidation();
    var lastPropsRef = $bd7d663e2fcda8c2$var$usePrevious(props);
    var getResponders = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        return $bd7d663e2fcda8c2$var$createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    var announce = $bd7d663e2fcda8c2$var$useAnnouncer(uniqueId);
    var styleMarshal = $bd7d663e2fcda8c2$var$useStyleMarshal(uniqueId);
    var lazyDispatch = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(action) {
        $bd7d663e2fcda8c2$var$getStore(lazyStoreRef).dispatch(action);
    }, []);
    var callbacks = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return (0, $7778c83e64d928d5$export$aea084d96e84da92)({
            publishWhileDragging: $bd7d663e2fcda8c2$var$publishWhileDragging$1,
            updateDroppableScroll: $bd7d663e2fcda8c2$var$updateDroppableScroll,
            updateDroppableIsEnabled: $bd7d663e2fcda8c2$var$updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: $bd7d663e2fcda8c2$var$updateDroppableIsCombineEnabled,
            collectionStarting: $bd7d663e2fcda8c2$var$collectionStarting
        }, lazyDispatch);
    }, [
        lazyDispatch
    ]);
    var dimensionMarshal = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return $bd7d663e2fcda8c2$var$createDimensionMarshal(callbacks);
    }, [
        callbacks
    ]);
    var autoScroller = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return $bd7d663e2fcda8c2$var$createAutoScroller((0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({
            scrollWindow: $bd7d663e2fcda8c2$var$scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable
        }, (0, $7778c83e64d928d5$export$aea084d96e84da92)({
            move: $bd7d663e2fcda8c2$var$move
        }, lazyDispatch)));
    }, [
        dimensionMarshal.scrollDroppable,
        lazyDispatch
    ]);
    var store = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return $bd7d663e2fcda8c2$var$createStore({
            dimensionMarshal: dimensionMarshal,
            styleMarshal: styleMarshal,
            announce: announce,
            autoScroller: autoScroller,
            getResponders: getResponders
        });
    }, [
        announce,
        autoScroller,
        dimensionMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    var tryResetStore = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        var current = $bd7d663e2fcda8c2$var$getStore(lazyStoreRef);
        var state = current.getState();
        if (state.phase !== 'IDLE') current.dispatch($bd7d663e2fcda8c2$var$clean$1({
            shouldFlush: true
        }));
    }, []);
    setOnError(tryResetStore);
    var getCanLift = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(id) {
        return $bd7d663e2fcda8c2$var$canStartDrag($bd7d663e2fcda8c2$var$getStore(lazyStoreRef).getState(), id);
    }, []);
    var getIsMovementAllowed = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        return $bd7d663e2fcda8c2$var$isMovementAllowed($bd7d663e2fcda8c2$var$getStore(lazyStoreRef).getState());
    }, []);
    var appContext = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            marshal: dimensionMarshal,
            style: styleMarshal.styleContext,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed
        };
    }, [
        dimensionMarshal,
        getCanLift,
        getIsMovementAllowed,
        styleMarshal.styleContext
    ]);
    (0, $ieT14.useEffect)(function() {
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($bd7d663e2fcda8c2$var$AppContext.Provider, {
        value: appContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement((0, $bea69f7496a97ae0$export$2e2bcd8739ae039), {
        context: $bd7d663e2fcda8c2$var$StoreContext,
        store: store
    }, props.children));
}
var $bd7d663e2fcda8c2$var$instanceCount = 0;
function $bd7d663e2fcda8c2$export$2bfe52350fc0150d() {
    $bd7d663e2fcda8c2$var$instanceCount = 0;
}
function $bd7d663e2fcda8c2$export$237bd83162c14364(props) {
    var uniqueId = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return $bd7d663e2fcda8c2$var$instanceCount++;
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($bd7d663e2fcda8c2$var$ErrorBoundary, null, function(setOnError) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($bd7d663e2fcda8c2$var$App, (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({
            setOnError: setOnError,
            uniqueId: uniqueId
        }, props), props.children);
    });
}
var $bd7d663e2fcda8c2$var$isEqual$2 = function isEqual(base) {
    return function(value) {
        return base === value;
    };
};
var $bd7d663e2fcda8c2$var$isScroll = $bd7d663e2fcda8c2$var$isEqual$2('scroll');
var $bd7d663e2fcda8c2$var$isAuto = $bd7d663e2fcda8c2$var$isEqual$2('auto');
var $bd7d663e2fcda8c2$var$isVisible$1 = $bd7d663e2fcda8c2$var$isEqual$2('visible');
var $bd7d663e2fcda8c2$var$isEither = function isEither(overflow, fn) {
    return fn(overflow.overflowX) || fn(overflow.overflowY);
};
var $bd7d663e2fcda8c2$var$isBoth = function isBoth(overflow, fn) {
    return fn(overflow.overflowX) && fn(overflow.overflowY);
};
var $bd7d663e2fcda8c2$var$isElementScrollable = function isElementScrollable(el) {
    var style = window.getComputedStyle(el);
    var overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $bd7d663e2fcda8c2$var$isEither(overflow, $bd7d663e2fcda8c2$var$isScroll) || $bd7d663e2fcda8c2$var$isEither(overflow, $bd7d663e2fcda8c2$var$isAuto);
};
var $bd7d663e2fcda8c2$var$isBodyScrollable = function isBodyScrollable() {
    var body, html, htmlStyle, htmlOverflow;
    return false;
};
var $bd7d663e2fcda8c2$var$getClosestScrollable = function getClosestScrollable(el) {
    if (el == null) return null;
    if (el === document.body) return $bd7d663e2fcda8c2$var$isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!$bd7d663e2fcda8c2$var$isElementScrollable(el)) return getClosestScrollable(el.parentElement);
    return el;
};
var $bd7d663e2fcda8c2$var$checkForNestedScrollContainers = function(scrollable) {
    if (!scrollable) return;
    var anotherScrollParent = $bd7d663e2fcda8c2$var$getClosestScrollable(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var $bd7d663e2fcda8c2$var$getScroll$1 = function(el) {
    return {
        x: el.scrollLeft,
        y: el.scrollTop
    };
};
var $bd7d663e2fcda8c2$var$getIsFixed = function getIsFixed(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.position === 'fixed') return true;
    return getIsFixed(el.parentElement);
};
var $bd7d663e2fcda8c2$var$getEnv = function(start) {
    var closestScrollable = $bd7d663e2fcda8c2$var$getClosestScrollable(start);
    var isFixedOnPage = $bd7d663e2fcda8c2$var$getIsFixed(start);
    return {
        closestScrollable: closestScrollable,
        isFixedOnPage: isFixedOnPage
    };
};
var $bd7d663e2fcda8c2$var$getClient = function getClient(targetRef, closestScrollable) {
    var base = (0, $b703e4029dc36ed5$export$34928e660d2a8702)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    var top = base.paddingBox.top - closestScrollable.scrollTop;
    var left = base.paddingBox.left - closestScrollable.scrollLeft;
    var bottom = top + closestScrollable.scrollHeight;
    var right = left + closestScrollable.scrollWidth;
    var paddingBox = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    var borderBox = (0, $b703e4029dc36ed5$export$9f77e0932fb78f72)(paddingBox, base.border);
    var client = (0, $b703e4029dc36ed5$export$6459fc9e86be362e)({
        borderBox: borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var $bd7d663e2fcda8c2$var$getDimension = function(_ref) {
    var ref = _ref.ref, descriptor = _ref.descriptor, env = _ref.env, windowScroll = _ref.windowScroll, direction = _ref.direction, isDropDisabled = _ref.isDropDisabled, isCombineEnabled = _ref.isCombineEnabled, shouldClipSubject = _ref.shouldClipSubject;
    var closestScrollable = env.closestScrollable;
    var client = $bd7d663e2fcda8c2$var$getClient(ref, closestScrollable);
    var page = (0, $b703e4029dc36ed5$export$1d0caec378d7d0ae)(client, windowScroll);
    var closest = function() {
        if (!closestScrollable) return null;
        var frameClient = (0, $b703e4029dc36ed5$export$34928e660d2a8702)(closestScrollable);
        var scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, $b703e4029dc36ed5$export$1d0caec378d7d0ae)(frameClient, windowScroll),
            scroll: $bd7d663e2fcda8c2$var$getScroll$1(closestScrollable),
            scrollSize: scrollSize,
            shouldClipSubject: shouldClipSubject
        };
    }();
    var dimension = $bd7d663e2fcda8c2$var$getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction: direction,
        client: client,
        page: page,
        closest: closest
    });
    return dimension;
};
function $bd7d663e2fcda8c2$var$withoutPlaceholder(placeholder, fn) {
    if (!placeholder) return fn();
    var last = placeholder.style.display;
    placeholder.style.display = 'none';
    var result = fn();
    placeholder.style.display = last;
    return result;
}
var $bd7d663e2fcda8c2$var$immediate = {
    passive: false
};
var $bd7d663e2fcda8c2$var$delayed = {
    passive: true
};
var $bd7d663e2fcda8c2$var$getListenerOptions = function(options) {
    return options.shouldPublishImmediately ? $bd7d663e2fcda8c2$var$immediate : $bd7d663e2fcda8c2$var$delayed;
};
function $bd7d663e2fcda8c2$var$useRequiredContext(Context) {
    var result = (0, $ieT14.useContext)(Context);
    !result && (0, $kuuqU.default)(false);
    return result;
}
var $bd7d663e2fcda8c2$var$getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
    return dragging && dragging.env.closestScrollable || null;
};
function $bd7d663e2fcda8c2$var$useDroppableDimensionPublisher(args) {
    var whileDraggingRef = (0, $ieT14.useRef)(null);
    var appContext = $bd7d663e2fcda8c2$var$useRequiredContext($bd7d663e2fcda8c2$var$AppContext);
    var marshal = appContext.marshal;
    var previousRef = $bd7d663e2fcda8c2$var$usePrevious(args);
    var descriptor = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            id: args.droppableId,
            type: args.type
        };
    }, [
        args.droppableId,
        args.type
    ]);
    var publishedDescriptorRef = (0, $ieT14.useRef)(descriptor);
    var memoizedUpdateScroll = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(x, y) {
            !whileDraggingRef.current && (0, $kuuqU.default)(false);
            var scroll = {
                x: x,
                y: y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        });
    }, [
        descriptor.id,
        marshal
    ]);
    var getClosestScroll = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return $bd7d663e2fcda8c2$var$origin;
        return $bd7d663e2fcda8c2$var$getScroll$1(dragging.env.closestScrollable);
    }, []);
    var updateScroll = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        var scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    var scheduleScrollUpdate = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return (0, $3a3632abf48ab519$export$2e2bcd8739ae039)(updateScroll);
    }, [
        updateScroll
    ]);
    var onClosestScroll = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        var closest = $bd7d663e2fcda8c2$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && (0, $kuuqU.default)(false);
        var options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    var getDimensionAndWatchScroll = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(windowScroll, options) {
        !!whileDraggingRef.current && (0, $kuuqU.default)(false);
        var previous = previousRef.current;
        var ref = previous.getDroppableRef();
        !ref && (0, $kuuqU.default)(false);
        var env = $bd7d663e2fcda8c2$var$getEnv(ref);
        var dragging = {
            ref: ref,
            descriptor: descriptor,
            env: env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        var dimension = $bd7d663e2fcda8c2$var$getDimension({
            ref: ref,
            descriptor: descriptor,
            env: env,
            windowScroll: windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        if (env.closestScrollable) env.closestScrollable.addEventListener('scroll', onClosestScroll, $bd7d663e2fcda8c2$var$getListenerOptions(dragging.scrollOptions));
        return dimension;
    }, [
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    var recollect = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(options) {
        var dragging = whileDraggingRef.current;
        var closest = $bd7d663e2fcda8c2$var$getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && (0, $kuuqU.default)(false);
        var previous = previousRef.current;
        var execute = function execute() {
            return $bd7d663e2fcda8c2$var$getDimension({
                ref: dragging.ref,
                descriptor: dragging.descriptor,
                env: dragging.env,
                windowScroll: $bd7d663e2fcda8c2$var$origin,
                direction: previous.direction,
                isDropDisabled: previous.isDropDisabled,
                isCombineEnabled: previous.isCombineEnabled,
                shouldClipSubject: !previous.ignoreContainerClipping
            });
        };
        if (!options.withoutPlaceholder) return execute();
        return $bd7d663e2fcda8c2$var$withoutPlaceholder(previous.getPlaceholderRef(), execute);
    }, [
        previousRef
    ]);
    var dragStopped = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        var dragging = whileDraggingRef.current;
        !dragging && (0, $kuuqU.default)(false);
        var closest = $bd7d663e2fcda8c2$var$getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeEventListener('scroll', onClosestScroll, $bd7d663e2fcda8c2$var$getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    var scroll = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(change) {
        var dragging = whileDraggingRef.current;
        !dragging && (0, $kuuqU.default)(false);
        var closest = $bd7d663e2fcda8c2$var$getClosestScrollableFromDrag(dragging);
        !closest && (0, $kuuqU.default)(false);
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    var callbacks = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            getDimensionAndWatchScroll: getDimensionAndWatchScroll,
            recollect: recollect,
            dragStopped: dragStopped,
            scroll: scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        recollect,
        scroll
    ]);
    $bd7d663e2fcda8c2$var$useIsomorphicLayoutEffect(function() {
        publishedDescriptorRef.current = descriptor;
        marshal.registerDroppable(descriptor, callbacks);
        return function() {
            if (whileDraggingRef.current) dragStopped();
            marshal.unregisterDroppable(descriptor);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        marshal
    ]);
    $bd7d663e2fcda8c2$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    $bd7d663e2fcda8c2$var$useIsomorphicLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function $bd7d663e2fcda8c2$var$noop() {}
var $bd7d663e2fcda8c2$var$empty = {
    width: 0,
    height: 0,
    margin: $bd7d663e2fcda8c2$var$noSpacing
};
var $bd7d663e2fcda8c2$var$getSize = function getSize(_ref) {
    var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount, placeholder = _ref.placeholder, animate = _ref.animate;
    if (isAnimatingOpenOnMount) return $bd7d663e2fcda8c2$var$empty;
    if (animate === 'close') return $bd7d663e2fcda8c2$var$empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
var $bd7d663e2fcda8c2$var$getStyle = function getStyle(_ref2) {
    var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount, placeholder = _ref2.placeholder, animate = _ref2.animate;
    var size = $bd7d663e2fcda8c2$var$getSize({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        placeholder: placeholder,
        animate: animate
    });
    return {
        display: placeholder.display,
        boxSizing: 'border-box',
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: '0',
        flexGrow: '0',
        pointerEvents: 'none',
        transition: $bd7d663e2fcda8c2$var$transitions.placeholder
    };
};
function $bd7d663e2fcda8c2$var$Placeholder(props) {
    var animateOpenTimerRef = (0, $ieT14.useRef)(null);
    var tryClearAnimateOpenTimer = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    var animate = props.animate, onTransitionEnd = props.onTransitionEnd, onClose = props.onClose, styleContext = props.styleContext;
    var _useState = (0, $ieT14.useState)(props.animate === 'open'), isAnimatingOpenOnMount = _useState[0], setIsAnimatingOpenOnMount = _useState[1];
    (0, $ieT14.useEffect)(function() {
        if (!isAnimatingOpenOnMount) return $bd7d663e2fcda8c2$var$noop;
        if (animate !== 'open') {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return $bd7d663e2fcda8c2$var$noop;
        }
        if (animateOpenTimerRef.current) return $bd7d663e2fcda8c2$var$noop;
        animateOpenTimerRef.current = setTimeout(function() {
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    var onSizeChangeEnd = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(event) {
        if (event.propertyName !== 'height') return;
        onTransitionEnd();
        if (animate === 'close') onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    var style = $bd7d663e2fcda8c2$var$getStyle({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement(props.placeholder.tagName, {
        style: style,
        'data-react-beautiful-dnd-placeholder': styleContext,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
}
var $bd7d663e2fcda8c2$var$Placeholder$1 = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).memo($bd7d663e2fcda8c2$var$Placeholder);
var $bd7d663e2fcda8c2$var$DroppableContext = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createContext(null);
var $bd7d663e2fcda8c2$var$getWindowFromEl = function(el) {
    return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
};
function $bd7d663e2fcda8c2$var$isHtmlElement(el) {
    return el instanceof $bd7d663e2fcda8c2$var$getWindowFromEl(el).HTMLElement;
}
function $bd7d663e2fcda8c2$var$checkIsValidInnerRef(el) {
    !(el && $bd7d663e2fcda8c2$var$isHtmlElement(el)) && (0, $kuuqU.default)(false);
}
function $bd7d663e2fcda8c2$var$checkOwnProps(props) {
    !props.droppableId && (0, $kuuqU.default)(false);
    !(typeof props.isDropDisabled === 'boolean') && (0, $kuuqU.default)(false);
    !(typeof props.isCombineEnabled === 'boolean') && (0, $kuuqU.default)(false);
    !(typeof props.ignoreContainerClipping === 'boolean') && (0, $kuuqU.default)(false);
}
function $bd7d663e2fcda8c2$var$checkPlaceholderRef(props, placeholderEl) {
    if (!props.placeholder) return;
    if (placeholderEl) return;
}
function $bd7d663e2fcda8c2$var$useValidation(_ref) {
    var props = _ref.props, getDroppableRef = _ref.getDroppableRef, getPlaceholderRef = _ref.getPlaceholderRef;
    (0, $ieT14.useEffect)(function() {});
}
var $bd7d663e2fcda8c2$var$AnimateInOut = function(_React$PureComponent) {
    (0, $31b5b7cf3016567e$export$2e2bcd8739ae039)(AnimateInOut, _React$PureComponent);
    function AnimateInOut() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$PureComponent.call.apply(_React$PureComponent, [
            this
        ].concat(args)) || this;
        _this.state = {
            isVisible: Boolean(_this.props.on),
            data: _this.props.on,
            animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
        };
        _this.onClose = function() {
            if (_this.state.animate !== 'close') return;
            _this.setState({
                isVisible: false
            });
        };
        return _this;
    }
    AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (!props.shouldAnimate) return {
            isVisible: Boolean(props.on),
            data: props.on,
            animate: 'none'
        };
        if (props.on) return {
            isVisible: true,
            data: props.on,
            animate: 'open'
        };
        if (state.isVisible) return {
            isVisible: true,
            data: state.data,
            animate: 'close'
        };
        return {
            isVisible: false,
            animate: 'close',
            data: null
        };
    };
    var _proto = AnimateInOut.prototype;
    _proto.render = function render() {
        if (!this.state.isVisible) return null;
        var provided = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
        };
        return this.props.children(provided);
    };
    return AnimateInOut;
}((0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).PureComponent);
function $bd7d663e2fcda8c2$var$Droppable(props) {
    var appContext = (0, $ieT14.useContext)($bd7d663e2fcda8c2$var$AppContext);
    !appContext && (0, $kuuqU.default)(false);
    var styleContext = appContext.style, isMovementAllowed = appContext.isMovementAllowed;
    var droppableRef = (0, $ieT14.useRef)(null);
    var placeholderRef = (0, $ieT14.useRef)(null);
    var children = props.children, droppableId = props.droppableId, type = props.type, direction = props.direction, ignoreContainerClipping = props.ignoreContainerClipping, isDropDisabled = props.isDropDisabled, isCombineEnabled = props.isCombineEnabled, snapshot = props.snapshot, updateViewportMaxScroll = props.updateViewportMaxScroll;
    var getDroppableRef = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        return droppableRef.current;
    }, []);
    var getPlaceholderRef = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        return placeholderRef.current;
    }, []);
    var setDroppableRef = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(value) {
        droppableRef.current = value;
    }, []);
    var setPlaceholderRef = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(value) {
        placeholderRef.current = value;
    }, []);
    var onPlaceholderTransitionEnd = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: $bd7d663e2fcda8c2$var$getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    $bd7d663e2fcda8c2$var$useDroppableDimensionPublisher({
        droppableId: droppableId,
        type: type,
        direction: direction,
        isDropDisabled: isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        ignoreContainerClipping: ignoreContainerClipping,
        getDroppableRef: getDroppableRef,
        getPlaceholderRef: getPlaceholderRef
    });
    var placeholder = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($bd7d663e2fcda8c2$var$AnimateInOut, {
        on: props.placeholder,
        shouldAnimate: props.shouldAnimatePlaceholder
    }, function(_ref) {
        var onClose = _ref.onClose, data = _ref.data, animate = _ref.animate;
        return (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($bd7d663e2fcda8c2$var$Placeholder$1, {
            placeholder: data,
            onClose: onClose,
            innerRef: setPlaceholderRef,
            animate: animate,
            styleContext: styleContext,
            onTransitionEnd: onPlaceholderTransitionEnd
        });
    });
    var provided = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            innerRef: setDroppableRef,
            placeholder: placeholder,
            droppableProps: {
                'data-react-beautiful-dnd-droppable': styleContext
            }
        };
    }, [
        placeholder,
        setDroppableRef,
        styleContext
    ]);
    var droppableContext = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            droppableId: droppableId,
            type: type
        };
    }, [
        droppableId,
        type
    ]);
    $bd7d663e2fcda8c2$var$useValidation({
        props: props,
        getDroppableRef: function getDroppableRef() {
            return droppableRef.current;
        },
        getPlaceholderRef: function getPlaceholderRef() {
            return placeholderRef.current;
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement($bd7d663e2fcda8c2$var$DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot));
}
var $bd7d663e2fcda8c2$var$isStrictEqual = function(a, b) {
    return a === b;
};
var $bd7d663e2fcda8c2$var$whatIsDraggedOverFromResult = function(result) {
    var combine = result.combine, destination = result.destination;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
var $bd7d663e2fcda8c2$var$isMatchingType = function isMatchingType(type, critical) {
    return type === critical.droppable.type;
};
var $bd7d663e2fcda8c2$var$getDraggable = function getDraggable(critical, dimensions) {
    return dimensions.draggables[critical.draggable.id];
};
var $bd7d663e2fcda8c2$var$makeMapStateToProps = function makeMapStateToProps() {
    var idle = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null
        }
    };
    var idleWithoutAnimation = (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, idle, {
        shouldAnimatePlaceholder: false
    });
    var getMapProps = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(id, isDraggingOver, dragging, snapshot) {
        var isHome = dragging.descriptor.droppableId === id;
        if (isHome) return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: false,
            snapshot: snapshot
        };
        if (!isDraggingOver) return idle;
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot: snapshot
        };
    });
    var getSnapshot = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(id, isDraggingOver, dragging) {
        var draggableId = dragging.descriptor.id;
        var isHome = dragging.descriptor.droppableId === id;
        var draggingOverWith = isDraggingOver ? draggableId : null;
        var draggingFromThisWith = isHome ? draggableId : null;
        return {
            isDraggingOver: isDraggingOver,
            draggingOverWith: draggingOverWith,
            draggingFromThisWith: draggingFromThisWith
        };
    });
    var selector = function selector(state, ownProps) {
        var id = ownProps.droppableId;
        var type = ownProps.type;
        if (state.isDragging) {
            var critical = state.critical;
            if (!$bd7d663e2fcda8c2$var$isMatchingType(type, critical)) return idle;
            var dragging = $bd7d663e2fcda8c2$var$getDraggable(critical, state.dimensions);
            var isDraggingOver = $bd7d663e2fcda8c2$var$whatIsDraggedOver(state.impact) === id;
            var snapshot = getSnapshot(id, isDraggingOver, dragging);
            return getMapProps(id, isDraggingOver, dragging, snapshot);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (!$bd7d663e2fcda8c2$var$isMatchingType(type, completed.critical)) return idle;
            var _dragging = $bd7d663e2fcda8c2$var$getDraggable(completed.critical, state.dimensions);
            var _snapshot = getSnapshot(id, $bd7d663e2fcda8c2$var$whatIsDraggedOverFromResult(completed.result) === id, _dragging);
            return getMapProps(id, $bd7d663e2fcda8c2$var$whatIsDraggedOver(completed.impact) === id, _dragging, _snapshot);
        }
        if (state.phase === 'IDLE' && !state.completed && state.shouldFlush) return idleWithoutAnimation;
        if (state.phase === 'IDLE' && state.completed) {
            var _completed = state.completed;
            if (!$bd7d663e2fcda8c2$var$isMatchingType(type, _completed.critical)) return idle;
            var wasOver = $bd7d663e2fcda8c2$var$whatIsDraggedOver(_completed.impact) === id;
            var wasCombining = Boolean(_completed.impact.merge);
            if (state.shouldFlush) return idleWithoutAnimation;
            if (wasOver) return wasCombining ? idle : idleWithoutAnimation;
            return idle;
        }
        return idle;
    };
    return selector;
};
var $bd7d663e2fcda8c2$var$mapDispatchToProps = {
    updateViewportMaxScroll: $bd7d663e2fcda8c2$var$updateViewportMaxScroll
};
var $bd7d663e2fcda8c2$var$defaultProps = {
    type: 'DEFAULT',
    direction: 'vertical',
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false
};
var $bd7d663e2fcda8c2$export$423ec2075359570a = (0, $a3b0bcd7a825bc6d$export$2e2bcd8739ae039)($bd7d663e2fcda8c2$var$makeMapStateToProps, $bd7d663e2fcda8c2$var$mapDispatchToProps, null, {
    context: $bd7d663e2fcda8c2$var$StoreContext,
    pure: true,
    areStatePropsEqual: $bd7d663e2fcda8c2$var$isStrictEqual
})($bd7d663e2fcda8c2$var$Droppable);
$bd7d663e2fcda8c2$export$423ec2075359570a.defaultProps = $bd7d663e2fcda8c2$var$defaultProps;
var $bd7d663e2fcda8c2$var$zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
var $bd7d663e2fcda8c2$var$getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
    if (dropping) return $bd7d663e2fcda8c2$var$transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return $bd7d663e2fcda8c2$var$transitions.snap;
    return $bd7d663e2fcda8c2$var$transitions.fluid;
};
var $bd7d663e2fcda8c2$var$getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
    if (!isCombining) return null;
    return isDropAnimating ? $bd7d663e2fcda8c2$var$combine.opacity.drop : $bd7d663e2fcda8c2$var$combine.opacity.combining;
};
var $bd7d663e2fcda8c2$var$getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === 'SNAP';
};
function $bd7d663e2fcda8c2$var$getDraggingStyle(dragging) {
    var dimension = dragging.dimension;
    var box = dimension.client;
    var offset = dragging.offset, combineWith = dragging.combineWith, dropping = dragging.dropping;
    var isCombining = Boolean(combineWith);
    var shouldAnimate = $bd7d663e2fcda8c2$var$getShouldDraggingAnimate(dragging);
    var isDropAnimating = Boolean(dropping);
    var transform = isDropAnimating ? $bd7d663e2fcda8c2$var$transforms.drop(offset, isCombining) : $bd7d663e2fcda8c2$var$transforms.moveTo(offset);
    var style = {
        position: 'fixed',
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: 'border-box',
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: $bd7d663e2fcda8c2$var$getDraggingTransition(shouldAnimate, dropping),
        transform: transform,
        opacity: $bd7d663e2fcda8c2$var$getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? $bd7d663e2fcda8c2$var$zIndexOptions.dropAnimating : $bd7d663e2fcda8c2$var$zIndexOptions.dragging,
        pointerEvents: 'none'
    };
    return style;
}
function $bd7d663e2fcda8c2$var$getSecondaryStyle(secondary) {
    return {
        transform: $bd7d663e2fcda8c2$var$transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? null : 'none'
    };
}
function $bd7d663e2fcda8c2$var$getStyle$1(mapped) {
    return mapped.type === 'DRAGGING' ? $bd7d663e2fcda8c2$var$getDraggingStyle(mapped) : $bd7d663e2fcda8c2$var$getSecondaryStyle(mapped);
}
var $bd7d663e2fcda8c2$var$createEventMarshal = function() {
    var isMouseDownHandled = false;
    var handle = function handle() {
        !!isMouseDownHandled && (0, $kuuqU.default)(false);
        isMouseDownHandled = true;
    };
    var isHandled = function isHandled() {
        return isMouseDownHandled;
    };
    var reset = function reset() {
        isMouseDownHandled = false;
    };
    return {
        handle: handle,
        isHandled: isHandled,
        reset: reset
    };
};
var $bd7d663e2fcda8c2$var$getOptions = function getOptions(shared, fromBinding) {
    return (0, $28b08d9c869f9be4$export$2e2bcd8739ae039)({}, shared, fromBinding);
};
var $bd7d663e2fcda8c2$var$bindEvents = function bindEvents(el, bindings, sharedOptions) {
    bindings.forEach(function(binding) {
        var options = $bd7d663e2fcda8c2$var$getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
    });
};
var $bd7d663e2fcda8c2$var$unbindEvents = function unbindEvents(el, bindings, sharedOptions) {
    bindings.forEach(function(binding) {
        var options = $bd7d663e2fcda8c2$var$getOptions(sharedOptions, binding.options);
        el.removeEventListener(binding.eventName, binding.fn, options);
    });
};
var $bd7d663e2fcda8c2$var$createScheduler = function(callbacks) {
    var memoizedMove = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(x, y) {
        var point = {
            x: x,
            y: y
        };
        callbacks.onMove(point);
    });
    var move = (0, $3a3632abf48ab519$export$2e2bcd8739ae039)(function(point) {
        return memoizedMove(point.x, point.y);
    });
    var moveUp = (0, $3a3632abf48ab519$export$2e2bcd8739ae039)(callbacks.onMoveUp);
    var moveDown = (0, $3a3632abf48ab519$export$2e2bcd8739ae039)(callbacks.onMoveDown);
    var moveRight = (0, $3a3632abf48ab519$export$2e2bcd8739ae039)(callbacks.onMoveRight);
    var moveLeft = (0, $3a3632abf48ab519$export$2e2bcd8739ae039)(callbacks.onMoveLeft);
    var windowScrollMove = (0, $3a3632abf48ab519$export$2e2bcd8739ae039)(callbacks.onWindowScroll);
    var cancel = function cancel() {
        move.cancel();
        moveUp.cancel();
        moveDown.cancel();
        moveRight.cancel();
        moveLeft.cancel();
        windowScrollMove.cancel();
    };
    return {
        move: move,
        moveUp: moveUp,
        moveDown: moveDown,
        moveRight: moveRight,
        moveLeft: moveLeft,
        windowScrollMove: windowScrollMove,
        cancel: cancel
    };
};
var $bd7d663e2fcda8c2$var$tab = 9;
var $bd7d663e2fcda8c2$var$enter = 13;
var $bd7d663e2fcda8c2$var$escape = 27;
var $bd7d663e2fcda8c2$var$space = 32;
var $bd7d663e2fcda8c2$var$pageUp = 33;
var $bd7d663e2fcda8c2$var$pageDown = 34;
var $bd7d663e2fcda8c2$var$end = 35;
var $bd7d663e2fcda8c2$var$home = 36;
var $bd7d663e2fcda8c2$var$arrowLeft = 37;
var $bd7d663e2fcda8c2$var$arrowUp = 38;
var $bd7d663e2fcda8c2$var$arrowRight = 39;
var $bd7d663e2fcda8c2$var$arrowDown = 40;
var $bd7d663e2fcda8c2$var$supportedEventName = function() {
    var base = 'visibilitychange';
    if (typeof document === 'undefined') return base;
    var candidates = [
        base,
        "ms" + base,
        "webkit" + base,
        "moz" + base,
        "o" + base
    ];
    var supported = $bd7d663e2fcda8c2$var$find(candidates, function(eventName) {
        return "on" + eventName in document;
    });
    return supported || base;
}();
var $bd7d663e2fcda8c2$var$sharedOptions = {
    capture: true
};
var $bd7d663e2fcda8c2$var$createPostDragEventPreventer = function(getWindow) {
    var isBound = false;
    var bind = function bind() {
        if (isBound) return;
        isBound = true;
        $bd7d663e2fcda8c2$var$bindEvents(getWindow(), pointerEvents, $bd7d663e2fcda8c2$var$sharedOptions);
    };
    var unbind = function unbind() {
        if (!isBound) return;
        isBound = false;
        $bd7d663e2fcda8c2$var$unbindEvents(getWindow(), pointerEvents, $bd7d663e2fcda8c2$var$sharedOptions);
    };
    var pointerEvents = [
        {
            eventName: 'click',
            fn: function fn(event) {
                event.preventDefault();
                unbind();
            }
        },
        {
            eventName: 'mousedown',
            fn: unbind
        },
        {
            eventName: 'touchstart',
            fn: unbind
        }
    ];
    var preventNext = function preventNext() {
        if (isBound) unbind();
        bind();
    };
    var preventer = {
        preventNext: preventNext,
        abort: unbind
    };
    return preventer;
};
var $bd7d663e2fcda8c2$var$sloppyClickThreshold = 5;
var $bd7d663e2fcda8c2$var$isSloppyClickThresholdExceeded = function(original, current) {
    return Math.abs(current.x - original.x) >= $bd7d663e2fcda8c2$var$sloppyClickThreshold || Math.abs(current.y - original.y) >= $bd7d663e2fcda8c2$var$sloppyClickThreshold;
};
var $bd7d663e2fcda8c2$var$_preventedKeys;
var $bd7d663e2fcda8c2$var$preventedKeys = ($bd7d663e2fcda8c2$var$_preventedKeys = {}, $bd7d663e2fcda8c2$var$_preventedKeys[$bd7d663e2fcda8c2$var$enter] = true, $bd7d663e2fcda8c2$var$_preventedKeys[$bd7d663e2fcda8c2$var$tab] = true, $bd7d663e2fcda8c2$var$_preventedKeys);
var $bd7d663e2fcda8c2$var$preventStandardKeyEvents = function(event) {
    if ($bd7d663e2fcda8c2$var$preventedKeys[event.keyCode]) event.preventDefault();
};
var $bd7d663e2fcda8c2$var$primaryButton = 0;
var $bd7d663e2fcda8c2$var$noop$1 = function noop() {};
var $bd7d663e2fcda8c2$var$mouseDownMarshal = $bd7d663e2fcda8c2$var$createEventMarshal();
function $bd7d663e2fcda8c2$var$useMouseSensor(args) {
    var canStartCapturing = args.canStartCapturing, getWindow = args.getWindow, callbacks = args.callbacks, onCaptureStart = args.onCaptureStart, onCaptureEnd = args.onCaptureEnd;
    var pendingRef = (0, $ieT14.useRef)(null);
    var isDraggingRef = (0, $ieT14.useRef)(false);
    var unbindWindowEventsRef = (0, $ieT14.useRef)($bd7d663e2fcda8c2$var$noop$1);
    var getIsCapturing = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        return Boolean(pendingRef.current || isDraggingRef.current);
    }, []);
    var schedule = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        !!getIsCapturing() && (0, $kuuqU.default)(false);
        return $bd7d663e2fcda8c2$var$createScheduler(callbacks);
    }, [
        callbacks,
        getIsCapturing
    ]);
    var postDragEventPreventer = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return $bd7d663e2fcda8c2$var$createPostDragEventPreventer(getWindow);
    }, [
        getWindow
    ]);
    var stop = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        if (!getIsCapturing()) return;
        schedule.cancel();
        unbindWindowEventsRef.current();
        var shouldBlockClick = isDraggingRef.current;
        $bd7d663e2fcda8c2$var$mouseDownMarshal.reset();
        if (shouldBlockClick) postDragEventPreventer.preventNext();
        pendingRef.current = null;
        isDraggingRef.current = false;
        onCaptureEnd();
    }, [
        getIsCapturing,
        onCaptureEnd,
        postDragEventPreventer,
        schedule
    ]);
    var cancel = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        var wasDragging = isDraggingRef.current;
        stop();
        if (wasDragging) callbacks.onCancel();
    }, [
        callbacks,
        stop
    ]);
    var startDragging = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        !!isDraggingRef.current && (0, $kuuqU.default)(false);
        var pending = pendingRef.current;
        !pending && (0, $kuuqU.default)(false);
        pendingRef.current = null;
        isDraggingRef.current = true;
        callbacks.onLift({
            clientSelection: pending,
            movementMode: 'FLUID'
        });
    }, [
        callbacks
    ]);
    var windowBindings = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        !!getIsCapturing() && (0, $kuuqU.default)(false);
        var bindings = [
            {
                eventName: 'mousemove',
                fn: function fn(event) {
                    var button = event.button, clientX = event.clientX, clientY = event.clientY;
                    if (button !== $bd7d663e2fcda8c2$var$primaryButton) return;
                    var point = {
                        x: clientX,
                        y: clientY
                    };
                    if (isDraggingRef.current) {
                        event.preventDefault();
                        schedule.move(point);
                        return;
                    }
                    var pending = pendingRef.current;
                    if (!pending) {
                        stop();
                        (0, $kuuqU.default)(false);
                    }
                    if (!$bd7d663e2fcda8c2$var$isSloppyClickThresholdExceeded(pending, point)) return;
                    event.preventDefault();
                    startDragging();
                }
            },
            {
                eventName: 'mouseup',
                fn: function fn(event) {
                    var wasDragging = isDraggingRef.current;
                    stop();
                    if (wasDragging) {
                        event.preventDefault();
                        callbacks.onDrop();
                    }
                }
            },
            {
                eventName: 'mousedown',
                fn: function fn(event) {
                    if (isDraggingRef.current) event.preventDefault();
                    cancel();
                }
            },
            {
                eventName: 'keydown',
                fn: function fn(event) {
                    if (pendingRef.current) {
                        stop();
                        return;
                    }
                    if (event.keyCode === $bd7d663e2fcda8c2$var$escape) {
                        event.preventDefault();
                        cancel();
                        return;
                    }
                    $bd7d663e2fcda8c2$var$preventStandardKeyEvents(event);
                }
            },
            {
                eventName: 'resize',
                fn: cancel
            },
            {
                eventName: 'scroll',
                options: {
                    passive: true,
                    capture: false
                },
                fn: function fn(event) {
                    if (event.currentTarget !== getWindow()) return;
                    if (pendingRef.current) {
                        stop();
                        return;
                    }
                    schedule.windowScrollMove();
                }
            },
            {
                eventName: 'webkitmouseforcedown',
                fn: function fn() {
                    cancel();
                }
            },
            {
                eventName: $bd7d663e2fcda8c2$var$supportedEventName,
                fn: cancel
            }
        ];
        return bindings;
    }, [
        getIsCapturing,
        cancel,
        startDragging,
        schedule,
        stop,
        callbacks,
        getWindow
    ]);
    var bindWindowEvents = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        var win = getWindow();
        var options = {
            capture: true
        };
        unbindWindowEventsRef.current = function() {
            return $bd7d663e2fcda8c2$var$unbindEvents(win, windowBindings, options);
        };
        $bd7d663e2fcda8c2$var$bindEvents(win, windowBindings, options);
    }, [
        getWindow,
        windowBindings
    ]);
    var startPendingDrag = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(point) {
        !!pendingRef.current && (0, $kuuqU.default)(false);
        pendingRef.current = point;
        onCaptureStart(stop);
        bindWindowEvents();
    }, [
        bindWindowEvents,
        onCaptureStart,
        stop
    ]);
    var onMouseDown = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(event) {
        if ($bd7d663e2fcda8c2$var$mouseDownMarshal.isHandled()) return;
        !!getIsCapturing() && (0, $kuuqU.default)(false);
        if (!canStartCapturing(event)) return;
        if (event.button !== $bd7d663e2fcda8c2$var$primaryButton) return;
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        $bd7d663e2fcda8c2$var$mouseDownMarshal.handle();
        event.preventDefault();
        var point = {
            x: event.clientX,
            y: event.clientY
        };
        startPendingDrag(point);
    }, [
        canStartCapturing,
        getIsCapturing,
        startPendingDrag
    ]);
    return onMouseDown;
}
function $bd7d663e2fcda8c2$var$isElement(el) {
    return el instanceof $bd7d663e2fcda8c2$var$getWindowFromEl(el).Element;
}
var $bd7d663e2fcda8c2$var$interactiveTagNames = {
    input: true,
    button: true,
    textarea: true,
    select: true,
    option: true,
    optgroup: true,
    video: true,
    audio: true
};
var $bd7d663e2fcda8c2$var$isAnInteractiveElement = function isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    var hasAnInteractiveTag = Boolean($bd7d663e2fcda8c2$var$interactiveTagNames[current.tagName.toLowerCase()]);
    if (hasAnInteractiveTag) return true;
    var attribute = current.getAttribute('contenteditable');
    if (attribute === 'true' || attribute === '') return true;
    if (current === parent) return false;
    return isAnInteractiveElement(parent, current.parentElement);
};
var $bd7d663e2fcda8c2$var$shouldAllowDraggingFromTarget = function(event, canDragInteractiveElements) {
    if (canDragInteractiveElements) return true;
    var target = event.target, currentTarget = event.currentTarget;
    if (!$bd7d663e2fcda8c2$var$isElement(target) || !$bd7d663e2fcda8c2$var$isElement(currentTarget)) return true;
    return !$bd7d663e2fcda8c2$var$isAnInteractiveElement(currentTarget, target);
};
var $bd7d663e2fcda8c2$var$getBorderBoxCenterPosition = function(el) {
    return (0, $b703e4029dc36ed5$export$4b834cebd9e5cebe)(el.getBoundingClientRect()).center;
};
var $bd7d663e2fcda8c2$var$_scrollJumpKeys;
var $bd7d663e2fcda8c2$var$scrollJumpKeys = ($bd7d663e2fcda8c2$var$_scrollJumpKeys = {}, $bd7d663e2fcda8c2$var$_scrollJumpKeys[$bd7d663e2fcda8c2$var$pageDown] = true, $bd7d663e2fcda8c2$var$_scrollJumpKeys[$bd7d663e2fcda8c2$var$pageUp] = true, $bd7d663e2fcda8c2$var$_scrollJumpKeys[$bd7d663e2fcda8c2$var$home] = true, $bd7d663e2fcda8c2$var$_scrollJumpKeys[$bd7d663e2fcda8c2$var$end] = true, $bd7d663e2fcda8c2$var$_scrollJumpKeys);
function $bd7d663e2fcda8c2$var$noop$2() {}
function $bd7d663e2fcda8c2$var$useKeyboardSensor(args) {
    var canStartCapturing = args.canStartCapturing, getWindow = args.getWindow, callbacks = args.callbacks, onCaptureStart = args.onCaptureStart, onCaptureEnd = args.onCaptureEnd, getDraggableRef = args.getDraggableRef;
    var isDraggingRef = (0, $ieT14.useRef)(false);
    var unbindWindowEventsRef = (0, $ieT14.useRef)($bd7d663e2fcda8c2$var$noop$2);
    var getIsDragging = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        return isDraggingRef.current;
    }, []);
    var schedule = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        !!getIsDragging() && (0, $kuuqU.default)(false);
        return $bd7d663e2fcda8c2$var$createScheduler(callbacks);
    }, [
        callbacks,
        getIsDragging
    ]);
    var stop = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        if (!getIsDragging()) return;
        schedule.cancel();
        unbindWindowEventsRef.current();
        isDraggingRef.current = false;
        onCaptureEnd();
    }, [
        getIsDragging,
        onCaptureEnd,
        schedule
    ]);
    var cancel = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        var wasDragging = isDraggingRef.current;
        stop();
        if (wasDragging) callbacks.onCancel();
    }, [
        callbacks,
        stop
    ]);
    var windowBindings = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        !!getIsDragging() && (0, $kuuqU.default)(false);
        return [
            {
                eventName: 'mousedown',
                fn: cancel
            },
            {
                eventName: 'mouseup',
                fn: cancel
            },
            {
                eventName: 'click',
                fn: cancel
            },
            {
                eventName: 'touchstart',
                fn: cancel
            },
            {
                eventName: 'resize',
                fn: cancel
            },
            {
                eventName: 'wheel',
                fn: cancel,
                options: {
                    passive: true
                }
            },
            {
                eventName: 'scroll',
                options: {
                    capture: false
                },
                fn: function fn(event) {
                    if (event.currentTarget !== getWindow()) return;
                    callbacks.onWindowScroll();
                }
            },
            {
                eventName: $bd7d663e2fcda8c2$var$supportedEventName,
                fn: cancel
            }
        ];
    }, [
        callbacks,
        cancel,
        getIsDragging,
        getWindow
    ]);
    var bindWindowEvents = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        var win = getWindow();
        var options = {
            capture: true
        };
        unbindWindowEventsRef.current = function() {
            return $bd7d663e2fcda8c2$var$unbindEvents(win, windowBindings, options);
        };
        $bd7d663e2fcda8c2$var$bindEvents(win, windowBindings, options);
    }, [
        getWindow,
        windowBindings
    ]);
    var startDragging = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        !!isDraggingRef.current && (0, $kuuqU.default)(false);
        var ref = getDraggableRef();
        !ref && (0, $kuuqU.default)(false);
        isDraggingRef.current = true;
        onCaptureStart(stop);
        bindWindowEvents();
        var center = $bd7d663e2fcda8c2$var$getBorderBoxCenterPosition(ref);
        callbacks.onLift({
            clientSelection: center,
            movementMode: 'SNAP'
        });
    }, [
        bindWindowEvents,
        callbacks,
        getDraggableRef,
        onCaptureStart,
        stop
    ]);
    var onKeyDown = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(event) {
        if (!getIsDragging()) {
            if (event.defaultPrevented) return;
            if (!canStartCapturing(event)) return;
            if (event.keyCode !== $bd7d663e2fcda8c2$var$space) return;
            event.preventDefault();
            startDragging();
            return;
        }
        if (event.keyCode === $bd7d663e2fcda8c2$var$escape) {
            event.preventDefault();
            cancel();
            return;
        }
        if (event.keyCode === $bd7d663e2fcda8c2$var$space) {
            event.preventDefault();
            stop();
            callbacks.onDrop();
            return;
        }
        if (event.keyCode === $bd7d663e2fcda8c2$var$arrowDown) {
            event.preventDefault();
            schedule.moveDown();
            return;
        }
        if (event.keyCode === $bd7d663e2fcda8c2$var$arrowUp) {
            event.preventDefault();
            schedule.moveUp();
            return;
        }
        if (event.keyCode === $bd7d663e2fcda8c2$var$arrowRight) {
            event.preventDefault();
            schedule.moveRight();
            return;
        }
        if (event.keyCode === $bd7d663e2fcda8c2$var$arrowLeft) {
            event.preventDefault();
            schedule.moveLeft();
            return;
        }
        if ($bd7d663e2fcda8c2$var$scrollJumpKeys[event.keyCode]) {
            event.preventDefault();
            return;
        }
        $bd7d663e2fcda8c2$var$preventStandardKeyEvents(event);
    }, [
        callbacks,
        canStartCapturing,
        cancel,
        getIsDragging,
        schedule,
        startDragging,
        stop
    ]);
    return onKeyDown;
}
var $bd7d663e2fcda8c2$var$timeForLongPress = 120;
var $bd7d663e2fcda8c2$var$forcePressThreshold = 0.15;
var $bd7d663e2fcda8c2$var$touchStartMarshal = $bd7d663e2fcda8c2$var$createEventMarshal();
var $bd7d663e2fcda8c2$var$noop$3 = function noop() {};
function $bd7d663e2fcda8c2$var$useTouchSensor(args) {
    var callbacks = args.callbacks, getWindow = args.getWindow, canStartCapturing = args.canStartCapturing, getShouldRespectForcePress = args.getShouldRespectForcePress, onCaptureStart = args.onCaptureStart, onCaptureEnd = args.onCaptureEnd;
    var pendingRef = (0, $ieT14.useRef)(null);
    var isDraggingRef = (0, $ieT14.useRef)(false);
    var hasMovedRef = (0, $ieT14.useRef)(false);
    var unbindWindowEventsRef = (0, $ieT14.useRef)($bd7d663e2fcda8c2$var$noop$3);
    var getIsCapturing = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        return Boolean(pendingRef.current || isDraggingRef.current);
    }, []);
    var postDragClickPreventer = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return $bd7d663e2fcda8c2$var$createPostDragEventPreventer(getWindow);
    }, [
        getWindow
    ]);
    var schedule = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        !!getIsCapturing() && (0, $kuuqU.default)(false);
        return $bd7d663e2fcda8c2$var$createScheduler(callbacks);
    }, [
        callbacks,
        getIsCapturing
    ]);
    var stop = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        if (!getIsCapturing()) return;
        schedule.cancel();
        unbindWindowEventsRef.current();
        $bd7d663e2fcda8c2$var$touchStartMarshal.reset();
        hasMovedRef.current = false;
        onCaptureEnd();
        if (isDraggingRef.current) {
            postDragClickPreventer.preventNext();
            isDraggingRef.current = false;
            return;
        }
        var pending = pendingRef.current;
        !pending && (0, $kuuqU.default)(false);
        clearTimeout(pending.longPressTimerId);
        pendingRef.current = null;
    }, [
        getIsCapturing,
        onCaptureEnd,
        postDragClickPreventer,
        schedule
    ]);
    var cancel = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        var wasDragging = isDraggingRef.current;
        stop();
        if (wasDragging) callbacks.onCancel();
    }, [
        callbacks,
        stop
    ]);
    var windowBindings = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        !!getIsCapturing() && (0, $kuuqU.default)(false);
        var bindings = [
            {
                eventName: 'touchmove',
                options: {
                    passive: false,
                    capture: false
                },
                fn: function fn(event) {
                    if (!isDraggingRef.current) {
                        stop();
                        return;
                    }
                    if (!hasMovedRef.current) hasMovedRef.current = true;
                    var touch = event.touches[0];
                    if (!touch) return;
                    var point = {
                        x: touch.clientX,
                        y: touch.clientY
                    };
                    event.preventDefault();
                    schedule.move(point);
                }
            },
            {
                eventName: 'touchend',
                fn: function fn(event) {
                    if (!isDraggingRef.current) {
                        stop();
                        return;
                    }
                    event.preventDefault();
                    stop();
                    callbacks.onDrop();
                }
            },
            {
                eventName: 'touchcancel',
                fn: function fn(event) {
                    if (!isDraggingRef.current) {
                        stop();
                        return;
                    }
                    event.preventDefault();
                    cancel();
                }
            },
            {
                eventName: 'touchstart',
                fn: cancel
            },
            {
                eventName: 'orientationchange',
                fn: cancel
            },
            {
                eventName: 'resize',
                fn: cancel
            },
            {
                eventName: 'scroll',
                options: {
                    passive: true,
                    capture: false
                },
                fn: function fn() {
                    if (pendingRef.current) {
                        stop();
                        return;
                    }
                    schedule.windowScrollMove();
                }
            },
            {
                eventName: 'contextmenu',
                fn: function fn(event) {
                    event.preventDefault();
                }
            },
            {
                eventName: 'keydown',
                fn: function fn(event) {
                    if (!isDraggingRef.current) {
                        cancel();
                        return;
                    }
                    if (event.keyCode === $bd7d663e2fcda8c2$var$escape) event.preventDefault();
                    cancel();
                }
            },
            {
                eventName: 'touchforcechange',
                fn: function fn(event) {
                    var touch = event.touches[0];
                    var isForcePress = touch.force >= $bd7d663e2fcda8c2$var$forcePressThreshold;
                    if (!isForcePress) return;
                    var shouldRespect = getShouldRespectForcePress();
                    if (pendingRef.current) {
                        if (shouldRespect) cancel();
                        return;
                    }
                    if (shouldRespect) {
                        if (hasMovedRef.current) {
                            event.preventDefault();
                            return;
                        }
                        cancel();
                        return;
                    }
                    event.preventDefault();
                }
            },
            {
                eventName: $bd7d663e2fcda8c2$var$supportedEventName,
                fn: cancel
            }
        ];
        return bindings;
    }, [
        callbacks,
        cancel,
        getIsCapturing,
        getShouldRespectForcePress,
        schedule,
        stop
    ]);
    var bindWindowEvents = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        var win = getWindow();
        var options = {
            capture: true
        };
        unbindWindowEventsRef.current = function() {
            return $bd7d663e2fcda8c2$var$unbindEvents(win, windowBindings, options);
        };
        $bd7d663e2fcda8c2$var$bindEvents(win, windowBindings, options);
    }, [
        getWindow,
        windowBindings
    ]);
    var startDragging = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        var pending = pendingRef.current;
        !pending && (0, $kuuqU.default)(false);
        isDraggingRef.current = true;
        pendingRef.current = null;
        hasMovedRef.current = false;
        callbacks.onLift({
            clientSelection: pending.point,
            movementMode: 'FLUID'
        });
    }, [
        callbacks
    ]);
    var startPendingDrag = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(event) {
        !!pendingRef.current && (0, $kuuqU.default)(false);
        var touch = event.touches[0];
        var clientX = touch.clientX, clientY = touch.clientY;
        var point = {
            x: clientX,
            y: clientY
        };
        var longPressTimerId = setTimeout(startDragging, $bd7d663e2fcda8c2$var$timeForLongPress);
        var pending = {
            point: point,
            longPressTimerId: longPressTimerId
        };
        pendingRef.current = pending;
        onCaptureStart(stop);
        bindWindowEvents();
    }, [
        bindWindowEvents,
        onCaptureStart,
        startDragging,
        stop
    ]);
    var onTouchStart = function onTouchStart(event) {
        if ($bd7d663e2fcda8c2$var$touchStartMarshal.isHandled()) return;
        !!getIsCapturing() && (0, $kuuqU.default)(false);
        if (!canStartCapturing(event)) return;
        $bd7d663e2fcda8c2$var$touchStartMarshal.handle();
        startPendingDrag(event);
    };
    $bd7d663e2fcda8c2$var$useIsomorphicLayoutEffect(function webkitHack() {
        var unbind = $bd7d663e2fcda8c2$var$bindEvents(window, [
            {
                eventName: 'touchmove',
                fn: $bd7d663e2fcda8c2$var$noop$3,
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
    return onTouchStart;
}
function $bd7d663e2fcda8c2$var$isSvgElement(el) {
    return Boolean($bd7d663e2fcda8c2$var$getWindowFromEl(el).SVGElement) && el instanceof $bd7d663e2fcda8c2$var$getWindowFromEl(el).SVGElement;
}
var $bd7d663e2fcda8c2$var$selector = "[" + $bd7d663e2fcda8c2$var$dragHandle + "]";
var $bd7d663e2fcda8c2$var$throwIfSVG = function throwIfSVG(el) {
    !!$bd7d663e2fcda8c2$var$isSvgElement(el) && (0, $kuuqU.default)(false);
};
var $bd7d663e2fcda8c2$var$getDragHandleRef = function getDragHandleRef(draggableRef) {
    if (draggableRef.hasAttribute($bd7d663e2fcda8c2$var$dragHandle)) {
        $bd7d663e2fcda8c2$var$throwIfSVG(draggableRef);
        return draggableRef;
    }
    var el = draggableRef.querySelector($bd7d663e2fcda8c2$var$selector);
    $bd7d663e2fcda8c2$var$throwIfSVG(draggableRef);
    !el && (0, $kuuqU.default)(false);
    !$bd7d663e2fcda8c2$var$isHtmlElement(el) && (0, $kuuqU.default)(false);
    return el;
};
function $bd7d663e2fcda8c2$var$useValidation$1(_ref) {
    var isEnabled = _ref.isEnabled, getDraggableRef = _ref.getDraggableRef;
    (0, $ieT14.useEffect)(function() {
        var draggableRef;
    }, [
        getDraggableRef,
        isEnabled
    ]);
}
var $bd7d663e2fcda8c2$var$retainingFocusFor = null;
var $bd7d663e2fcda8c2$var$listenerOptions = {
    capture: true
};
var $bd7d663e2fcda8c2$var$clearRetentionOnFocusChange = function() {
    var isBound = false;
    var bind = function bind() {
        if (isBound) return;
        isBound = true;
        window.addEventListener('focus', onWindowFocusChange, $bd7d663e2fcda8c2$var$listenerOptions);
    };
    var unbind = function unbind() {
        if (!isBound) return;
        isBound = false;
        window.removeEventListener('focus', onWindowFocusChange, $bd7d663e2fcda8c2$var$listenerOptions);
    };
    var onWindowFocusChange = function onWindowFocusChange() {
        unbind();
        $bd7d663e2fcda8c2$var$retainingFocusFor = null;
    };
    var result = function result() {
        return bind();
    };
    result.cancel = function() {
        return unbind();
    };
    return result;
}();
var $bd7d663e2fcda8c2$var$retain = function retain(id) {
    $bd7d663e2fcda8c2$var$retainingFocusFor = id;
    $bd7d663e2fcda8c2$var$clearRetentionOnFocusChange();
};
var $bd7d663e2fcda8c2$var$tryRestoreFocus = function tryRestoreFocus(id, draggableRef) {
    if (!$bd7d663e2fcda8c2$var$retainingFocusFor) return;
    if (id !== $bd7d663e2fcda8c2$var$retainingFocusFor) return;
    $bd7d663e2fcda8c2$var$retainingFocusFor = null;
    $bd7d663e2fcda8c2$var$clearRetentionOnFocusChange.cancel();
    var dragHandleRef = $bd7d663e2fcda8c2$var$getDragHandleRef(draggableRef);
    if (!dragHandleRef) return;
    dragHandleRef.focus();
};
var $bd7d663e2fcda8c2$var$retainer = {
    retain: $bd7d663e2fcda8c2$var$retain,
    tryRestoreFocus: $bd7d663e2fcda8c2$var$tryRestoreFocus
};
function $bd7d663e2fcda8c2$var$noop$4() {}
function $bd7d663e2fcda8c2$var$useFocusRetainer(args) {
    var isFocusedRef = (0, $ieT14.useRef)(false);
    var lastArgsRef = $bd7d663e2fcda8c2$var$usePrevious(args);
    var getDraggableRef = args.getDraggableRef;
    var onFocus = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        isFocusedRef.current = true;
    }, []);
    var onBlur = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        isFocusedRef.current = false;
    }, []);
    $bd7d663e2fcda8c2$var$useIsomorphicLayoutEffect(function() {
        var first = lastArgsRef.current;
        if (!first.isEnabled) return $bd7d663e2fcda8c2$var$noop$4;
        var draggable = getDraggableRef();
        !draggable && (0, $kuuqU.default)(false);
        var dragHandle = $bd7d663e2fcda8c2$var$getDragHandleRef(draggable);
        $bd7d663e2fcda8c2$var$retainer.tryRestoreFocus(first.draggableId, dragHandle);
        return function() {
            var last = lastArgsRef.current;
            var shouldRetainFocus = function() {
                if (!last.isEnabled) return false;
                if (!isFocusedRef.current) return false;
                return last.isDragging || last.isDropAnimating;
            }();
            if (shouldRetainFocus) $bd7d663e2fcda8c2$var$retainer.retain(last.draggableId);
        };
    }, [
        getDraggableRef,
        lastArgsRef
    ]);
    var lastDraggableRef = (0, $ieT14.useRef)(null);
    $bd7d663e2fcda8c2$var$useIsomorphicLayoutEffect(function() {
        if (!lastDraggableRef.current) return;
        var draggableRef = getDraggableRef();
        if (!draggableRef) return;
        if (draggableRef === lastDraggableRef.current) return;
        if (isFocusedRef.current && lastArgsRef.current.isEnabled) $bd7d663e2fcda8c2$var$getDragHandleRef(draggableRef).focus();
    });
    $bd7d663e2fcda8c2$var$useIsomorphicLayoutEffect(function() {
        lastDraggableRef.current = getDraggableRef();
    });
    return {
        onBlur: onBlur,
        onFocus: onFocus
    };
}
function $bd7d663e2fcda8c2$var$preventHtml5Dnd(event) {
    event.preventDefault();
}
function $bd7d663e2fcda8c2$var$useDragHandle(args) {
    var capturingRef = (0, $ieT14.useRef)(null);
    var onCaptureStart = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(abort) {
        !!capturingRef.current && (0, $kuuqU.default)(false);
        capturingRef.current = {
            abort: abort
        };
    }, []);
    var onCaptureEnd = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        !capturingRef.current && (0, $kuuqU.default)(false);
        capturingRef.current = null;
    }, []);
    var abortCapture = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        !capturingRef.current && (0, $kuuqU.default)(false);
        capturingRef.current.abort();
    }, []);
    var _useRequiredContext = $bd7d663e2fcda8c2$var$useRequiredContext($bd7d663e2fcda8c2$var$AppContext), canLift = _useRequiredContext.canLift, styleContext = _useRequiredContext.style;
    var isDragging = args.isDragging, isEnabled = args.isEnabled, draggableId = args.draggableId, callbacks = args.callbacks, getDraggableRef = args.getDraggableRef, getShouldRespectForcePress = args.getShouldRespectForcePress, canDragInteractiveElements = args.canDragInteractiveElements;
    var lastArgsRef = $bd7d663e2fcda8c2$var$usePrevious(args);
    $bd7d663e2fcda8c2$var$useValidation$1({
        isEnabled: isEnabled,
        getDraggableRef: getDraggableRef
    });
    var getWindow = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        return $bd7d663e2fcda8c2$var$getWindowFromEl(getDraggableRef());
    }, [
        getDraggableRef
    ]);
    var canStartCapturing = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(event) {
        if (!isEnabled) return false;
        if (capturingRef.current) return false;
        if (!canLift(draggableId)) return false;
        return $bd7d663e2fcda8c2$var$shouldAllowDraggingFromTarget(event, canDragInteractiveElements);
    }, [
        canDragInteractiveElements,
        canLift,
        draggableId,
        isEnabled
    ]);
    var _useFocusRetainer = $bd7d663e2fcda8c2$var$useFocusRetainer(args), onBlur = _useFocusRetainer.onBlur, onFocus = _useFocusRetainer.onFocus;
    var mouseArgs = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            callbacks: callbacks,
            getDraggableRef: getDraggableRef,
            getWindow: getWindow,
            canStartCapturing: canStartCapturing,
            onCaptureStart: onCaptureStart,
            onCaptureEnd: onCaptureEnd,
            getShouldRespectForcePress: getShouldRespectForcePress
        };
    }, [
        callbacks,
        getDraggableRef,
        getWindow,
        canStartCapturing,
        onCaptureStart,
        onCaptureEnd,
        getShouldRespectForcePress
    ]);
    var onMouseDown = $bd7d663e2fcda8c2$var$useMouseSensor(mouseArgs);
    var keyboardArgs = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            callbacks: callbacks,
            getDraggableRef: getDraggableRef,
            getWindow: getWindow,
            canStartCapturing: canStartCapturing,
            onCaptureStart: onCaptureStart,
            onCaptureEnd: onCaptureEnd
        };
    }, [
        callbacks,
        canStartCapturing,
        getDraggableRef,
        getWindow,
        onCaptureEnd,
        onCaptureStart
    ]);
    var onKeyDown = $bd7d663e2fcda8c2$var$useKeyboardSensor(keyboardArgs);
    var touchArgs = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            callbacks: callbacks,
            getDraggableRef: getDraggableRef,
            getWindow: getWindow,
            canStartCapturing: canStartCapturing,
            getShouldRespectForcePress: getShouldRespectForcePress,
            onCaptureStart: onCaptureStart,
            onCaptureEnd: onCaptureEnd
        };
    }, [
        callbacks,
        getDraggableRef,
        getWindow,
        canStartCapturing,
        getShouldRespectForcePress,
        onCaptureStart,
        onCaptureEnd
    ]);
    var onTouchStart = $bd7d663e2fcda8c2$var$useTouchSensor(touchArgs);
    $bd7d663e2fcda8c2$var$useIsomorphicLayoutEffect(function() {
        return function() {
            if (!capturingRef.current) return;
            abortCapture();
            if (lastArgsRef.current.isDragging) lastArgsRef.current.callbacks.onCancel();
        };
    }, []);
    if (!isEnabled && capturingRef.current) {
        abortCapture();
        if (lastArgsRef.current.isDragging) callbacks.onCancel();
    }
    $bd7d663e2fcda8c2$var$useIsomorphicLayoutEffect(function() {
        if (!isDragging && capturingRef.current) abortCapture();
    }, [
        abortCapture,
        isDragging
    ]);
    var props = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        if (!isEnabled) return null;
        return {
            onMouseDown: onMouseDown,
            onKeyDown: onKeyDown,
            onTouchStart: onTouchStart,
            onFocus: onFocus,
            onBlur: onBlur,
            tabIndex: 0,
            'data-react-beautiful-dnd-drag-handle': styleContext,
            'aria-roledescription': 'Draggable item. Press space bar to lift',
            draggable: false,
            onDragStart: $bd7d663e2fcda8c2$var$preventHtml5Dnd
        };
    }, [
        isEnabled,
        onBlur,
        onFocus,
        onKeyDown,
        onMouseDown,
        onTouchStart,
        styleContext
    ]);
    return props;
}
function $bd7d663e2fcda8c2$var$getDimension$1(descriptor, el, windowScroll) {
    if (windowScroll === void 0) windowScroll = $bd7d663e2fcda8c2$var$origin;
    var computedStyles = window.getComputedStyle(el);
    var borderBox = el.getBoundingClientRect();
    var client = (0, $b703e4029dc36ed5$export$b8dfc5d4e552b8e1)(borderBox, computedStyles);
    var page = (0, $b703e4029dc36ed5$export$1d0caec378d7d0ae)(client, windowScroll);
    var placeholder = {
        client: client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    var displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    var dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        displaceBy: displaceBy,
        client: client,
        page: page
    };
    return dimension;
}
function $bd7d663e2fcda8c2$var$useDraggableDimensionPublisher(args) {
    var draggableId = args.draggableId, index = args.index, getDraggableRef = args.getDraggableRef;
    var appContext = $bd7d663e2fcda8c2$var$useRequiredContext($bd7d663e2fcda8c2$var$AppContext);
    var marshal = appContext.marshal;
    var droppableContext = $bd7d663e2fcda8c2$var$useRequiredContext($bd7d663e2fcda8c2$var$DroppableContext);
    var droppableId = droppableContext.droppableId, type = droppableContext.type;
    var descriptor = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        var result = {
            id: draggableId,
            droppableId: droppableId,
            type: type,
            index: index
        };
        return result;
    }, [
        draggableId,
        droppableId,
        index,
        type
    ]);
    var publishedDescriptorRef = (0, $ieT14.useRef)(descriptor);
    var makeDimension = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(windowScroll) {
        var latest = publishedDescriptorRef.current;
        var el = getDraggableRef();
        !el && (0, $kuuqU.default)(false);
        return $bd7d663e2fcda8c2$var$getDimension$1(latest, el, windowScroll);
    }, [
        getDraggableRef
    ]);
    $bd7d663e2fcda8c2$var$useIsomorphicLayoutEffect(function() {
        marshal.registerDraggable(publishedDescriptorRef.current, makeDimension);
        return function() {
            return marshal.unregisterDraggable(publishedDescriptorRef.current);
        };
    }, [
        makeDimension,
        marshal
    ]);
    $bd7d663e2fcda8c2$var$useIsomorphicLayoutEffect(function() {
        if (publishedDescriptorRef.current === descriptor) return;
        var previous = publishedDescriptorRef.current;
        publishedDescriptorRef.current = descriptor;
        marshal.updateDraggable(previous, descriptor, makeDimension);
    }, [
        descriptor,
        makeDimension,
        marshal
    ]);
}
function $bd7d663e2fcda8c2$var$checkOwnProps$1(props) {
    !(0, (/*@__PURE__*/$parcel$interopDefault($e28cdd20687c4c2b$exports)))(props.index) && (0, $kuuqU.default)(false);
    !props.draggableId && (0, $kuuqU.default)(false);
    !(typeof props.isDragDisabled === 'boolean') && (0, $kuuqU.default)(false);
}
function $bd7d663e2fcda8c2$var$checkForOutdatedProps(props) {
    Object.prototype.hasOwnProperty.call(props, 'shouldRespectForceTouch');
}
function $bd7d663e2fcda8c2$var$useValidation$2(props, getRef) {
    (0, $ieT14.useEffect)(function() {});
}
function $bd7d663e2fcda8c2$var$Draggable(props) {
    var ref = (0, $ieT14.useRef)(null);
    var setRef = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(el) {
        ref.current = el;
    }, []);
    var getRef = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        return ref.current;
    }, []);
    var appContext = $bd7d663e2fcda8c2$var$useRequiredContext($bd7d663e2fcda8c2$var$AppContext);
    $bd7d663e2fcda8c2$var$useValidation$2(props, getRef);
    var children = props.children, draggableId = props.draggableId, isDragDisabled = props.isDragDisabled, shouldRespectForcePress = props.shouldRespectForcePress, canDragInteractiveElements = props.disableInteractiveElementBlocking, index = props.index, mapped = props.mapped, moveUpAction = props.moveUp, moveAction = props.move, dropAction = props.drop, moveDownAction = props.moveDown, moveRightAction = props.moveRight, moveLeftAction = props.moveLeft, moveByWindowScrollAction = props.moveByWindowScroll, liftAction = props.lift, dropAnimationFinishedAction = props.dropAnimationFinished;
    var forPublisher = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            draggableId: draggableId,
            index: index,
            getDraggableRef: getRef
        };
    }, [
        draggableId,
        getRef,
        index
    ]);
    $bd7d663e2fcda8c2$var$useDraggableDimensionPublisher(forPublisher);
    var onLift = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(options) {
        $bd7d663e2fcda8c2$var$start('LIFT');
        var el = ref.current;
        !el && (0, $kuuqU.default)(false);
        !!isDragDisabled && (0, $kuuqU.default)(false);
        var clientSelection = options.clientSelection, movementMode = options.movementMode;
        liftAction({
            id: draggableId,
            clientSelection: clientSelection,
            movementMode: movementMode
        });
        $bd7d663e2fcda8c2$var$finish('LIFT');
    }, [
        draggableId,
        isDragDisabled,
        liftAction
    ]);
    var getShouldRespectForcePress = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function() {
        return shouldRespectForcePress;
    }, [
        shouldRespectForcePress
    ]);
    var callbacks = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            onLift: onLift,
            onMove: function onMove(clientSelection) {
                return moveAction({
                    client: clientSelection
                });
            },
            onDrop: function onDrop() {
                return dropAction({
                    reason: 'DROP'
                });
            },
            onCancel: function onCancel() {
                return dropAction({
                    reason: 'CANCEL'
                });
            },
            onMoveUp: moveUpAction,
            onMoveDown: moveDownAction,
            onMoveRight: moveRightAction,
            onMoveLeft: moveLeftAction,
            onWindowScroll: function onWindowScroll() {
                return moveByWindowScrollAction({
                    newScroll: $bd7d663e2fcda8c2$var$getWindowScroll()
                });
            }
        };
    }, [
        dropAction,
        moveAction,
        moveByWindowScrollAction,
        moveDownAction,
        moveLeftAction,
        moveRightAction,
        moveUpAction,
        onLift
    ]);
    var isDragging = mapped.type === 'DRAGGING';
    var isDropAnimating = mapped.type === 'DRAGGING' && Boolean(mapped.dropping);
    var dragHandleArgs = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        return {
            draggableId: draggableId,
            isDragging: isDragging,
            isDropAnimating: isDropAnimating,
            isEnabled: !isDragDisabled,
            callbacks: callbacks,
            getDraggableRef: getRef,
            canDragInteractiveElements: canDragInteractiveElements,
            getShouldRespectForcePress: getShouldRespectForcePress
        };
    }, [
        callbacks,
        canDragInteractiveElements,
        draggableId,
        getRef,
        getShouldRespectForcePress,
        isDragDisabled,
        isDragging,
        isDropAnimating
    ]);
    var dragHandleProps = $bd7d663e2fcda8c2$var$useDragHandle(dragHandleArgs);
    var onMoveEnd = (0, $9da7c6a4dfccef3e$export$35808ee640e87ca7)(function(event) {
        if (mapped.type !== 'DRAGGING') return;
        if (!mapped.dropping) return;
        if (event.propertyName !== 'transform') return;
        dropAnimationFinishedAction();
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    var provided = (0, $9da7c6a4dfccef3e$export$1538c33de8887b59)(function() {
        var style = $bd7d663e2fcda8c2$var$getStyle$1(mapped);
        var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
        var result = {
            innerRef: setRef,
            draggableProps: {
                'data-react-beautiful-dnd-draggable': appContext.style,
                style: style,
                onTransitionEnd: onTransitionEnd
            },
            dragHandleProps: dragHandleProps
        };
        return result;
    }, [
        appContext.style,
        dragHandleProps,
        mapped,
        onMoveEnd,
        setRef
    ]);
    return children(provided, mapped.snapshot);
}
var $bd7d663e2fcda8c2$var$getCombineWithFromResult = function getCombineWithFromResult(result) {
    return result.combine ? result.combine.draggableId : null;
};
var $bd7d663e2fcda8c2$var$getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
    return impact.merge ? impact.merge.combine.draggableId : null;
};
var $bd7d663e2fcda8c2$var$makeMapStateToProps$1 = function makeMapStateToProps() {
    var getDraggingSnapshot = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(mode, draggingOver, combineWith, dropping) {
        return {
            isDragging: true,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode: mode,
            draggingOver: draggingOver,
            combineWith: combineWith,
            combineTargetFor: null
        };
    });
    var getSecondarySnapshot = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(combineTargetFor) {
        return {
            isDragging: false,
            isDropAnimating: false,
            dropAnimation: null,
            mode: null,
            draggingOver: null,
            combineTargetFor: combineTargetFor,
            combineWith: null
        };
    });
    var defaultMapProps = {
        mapped: {
            type: 'SECONDARY',
            offset: $bd7d663e2fcda8c2$var$origin,
            combineTargetFor: null,
            shouldAnimateDisplacement: true,
            snapshot: getSecondarySnapshot(null)
        }
    };
    var memoizedOffset = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getDraggingProps = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(offset, mode, dimension, draggingOver, combineWith, forceShouldAnimate) {
        return {
            mapped: {
                type: 'DRAGGING',
                dropping: null,
                draggingOver: draggingOver,
                combineWith: combineWith,
                mode: mode,
                offset: offset,
                dimension: dimension,
                forceShouldAnimate: forceShouldAnimate,
                snapshot: getDraggingSnapshot(mode, draggingOver, combineWith, null)
            }
        };
    });
    var getSecondaryProps = (0, $bab2733189173eea$export$2e2bcd8739ae039)(function(offset, combineTargetFor, shouldAnimateDisplacement) {
        if (combineTargetFor === void 0) combineTargetFor = null;
        return {
            mapped: {
                type: 'SECONDARY',
                offset: offset,
                combineTargetFor: combineTargetFor,
                shouldAnimateDisplacement: shouldAnimateDisplacement,
                snapshot: getSecondarySnapshot(combineTargetFor)
            }
        };
    });
    var getSecondaryMovement = function getSecondaryMovement(ownId, draggingId, impact) {
        var map = impact.movement.map;
        var displacement = map[ownId];
        var movement = impact.movement;
        var merge = impact.merge;
        var isCombinedWith = Boolean(merge && merge.combine.draggableId === ownId);
        var displacedBy = movement.displacedBy.point;
        var offset = memoizedOffset(displacedBy.x, displacedBy.y);
        if (isCombinedWith) return getSecondaryProps(displacement ? offset : $bd7d663e2fcda8c2$var$origin, draggingId, displacement ? displacement.shouldAnimate : true);
        if (!displacement) return null;
        if (!displacement.isVisible) return null;
        return getSecondaryProps(offset, null, displacement.shouldAnimate);
    };
    var draggingSelector = function draggingSelector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            var offset = state.current.client.offset;
            var dimension = state.dimensions.draggables[ownProps.draggableId];
            var mode = state.movementMode;
            var draggingOver = $bd7d663e2fcda8c2$var$whatIsDraggedOver(state.impact);
            var combineWith = $bd7d663e2fcda8c2$var$getCombineWithFromImpact(state.impact);
            var forceShouldAnimate = state.forceShouldAnimate;
            return getDraggingProps(memoizedOffset(offset.x, offset.y), mode, dimension, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            var _dimension = state.dimensions.draggables[ownProps.draggableId];
            var result = completed.result;
            var _mode = result.mode;
            var _draggingOver = $bd7d663e2fcda8c2$var$whatIsDraggedOverFromResult(result);
            var _combineWith = $bd7d663e2fcda8c2$var$getCombineWithFromResult(result);
            var duration = state.dropDuration;
            var dropping = {
                duration: duration,
                curve: $bd7d663e2fcda8c2$var$curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: _combineWith ? $bd7d663e2fcda8c2$var$combine.opacity.drop : null,
                scale: _combineWith ? $bd7d663e2fcda8c2$var$combine.scale.drop : null
            };
            return {
                mapped: {
                    type: 'DRAGGING',
                    offset: state.newHomeClientOffset,
                    dimension: _dimension,
                    dropping: dropping,
                    draggingOver: _draggingOver,
                    combineWith: _combineWith,
                    mode: _mode,
                    forceShouldAnimate: null,
                    snapshot: getDraggingSnapshot(_mode, _draggingOver, _combineWith, dropping)
                }
            };
        }
        return null;
    };
    var secondarySelector = function secondarySelector(state, ownProps) {
        if (state.isDragging) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getSecondaryMovement(ownProps.draggableId, state.critical.draggable.id, state.impact);
        }
        if (state.phase === 'DROP_ANIMATING') {
            var completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getSecondaryMovement(ownProps.draggableId, completed.result.draggableId, completed.impact);
        }
        return null;
    };
    var selector = function selector(state, ownProps) {
        return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || defaultMapProps;
    };
    return selector;
};
var $bd7d663e2fcda8c2$var$mapDispatchToProps$1 = {
    lift: $bd7d663e2fcda8c2$var$lift,
    move: $bd7d663e2fcda8c2$var$move,
    moveUp: $bd7d663e2fcda8c2$var$moveUp,
    moveDown: $bd7d663e2fcda8c2$var$moveDown,
    moveLeft: $bd7d663e2fcda8c2$var$moveLeft,
    moveRight: $bd7d663e2fcda8c2$var$moveRight,
    moveByWindowScroll: $bd7d663e2fcda8c2$var$moveByWindowScroll,
    drop: $bd7d663e2fcda8c2$var$drop,
    dropAnimationFinished: $bd7d663e2fcda8c2$var$dropAnimationFinished
};
var $bd7d663e2fcda8c2$var$defaultProps$1 = {
    isDragDisabled: false,
    disableInteractiveElementBlocking: false,
    shouldRespectForcePress: false
};
var $bd7d663e2fcda8c2$export$f2a139e5d18b9882 = (0, $a3b0bcd7a825bc6d$export$2e2bcd8739ae039)($bd7d663e2fcda8c2$var$makeMapStateToProps$1, $bd7d663e2fcda8c2$var$mapDispatchToProps$1, null, {
    context: $bd7d663e2fcda8c2$var$StoreContext,
    pure: true,
    areStatePropsEqual: $bd7d663e2fcda8c2$var$isStrictEqual
})($bd7d663e2fcda8c2$var$Draggable);
$bd7d663e2fcda8c2$export$f2a139e5d18b9882.defaultProps = $bd7d663e2fcda8c2$var$defaultProps$1;




var $f0c8170cebff136f$exports = {};
var $5a0fba43801bfd55$exports = {};
var $4442d734a365f78f$exports = {};
function $4442d734a365f78f$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$4442d734a365f78f$exports = $4442d734a365f78f$var$_arrayLikeToArray, $4442d734a365f78f$exports.__esModule = true, $4442d734a365f78f$exports["default"] = $4442d734a365f78f$exports;


function $5a0fba43801bfd55$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $4442d734a365f78f$exports(r);
}
$5a0fba43801bfd55$exports = $5a0fba43801bfd55$var$_arrayWithoutHoles, $5a0fba43801bfd55$exports.__esModule = true, $5a0fba43801bfd55$exports["default"] = $5a0fba43801bfd55$exports;


var $826529c4504f3362$exports = {};
function $826529c4504f3362$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
$826529c4504f3362$exports = $826529c4504f3362$var$_iterableToArray, $826529c4504f3362$exports.__esModule = true, $826529c4504f3362$exports["default"] = $826529c4504f3362$exports;


var $218445cf9875b386$exports = {};

function $218445cf9875b386$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $4442d734a365f78f$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $4442d734a365f78f$exports(r, a) : void 0;
    }
}
$218445cf9875b386$exports = $218445cf9875b386$var$_unsupportedIterableToArray, $218445cf9875b386$exports.__esModule = true, $218445cf9875b386$exports["default"] = $218445cf9875b386$exports;


var $062e9c30dd28cd6f$exports = {};
function $062e9c30dd28cd6f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$062e9c30dd28cd6f$exports = $062e9c30dd28cd6f$var$_nonIterableSpread, $062e9c30dd28cd6f$exports.__esModule = true, $062e9c30dd28cd6f$exports["default"] = $062e9c30dd28cd6f$exports;


function $f0c8170cebff136f$var$_toConsumableArray(r) {
    return $5a0fba43801bfd55$exports(r) || $826529c4504f3362$exports(r) || $218445cf9875b386$exports(r) || $062e9c30dd28cd6f$exports();
}
$f0c8170cebff136f$exports = $f0c8170cebff136f$var$_toConsumableArray, $f0c8170cebff136f$exports.__esModule = true, $f0c8170cebff136f$exports["default"] = $f0c8170cebff136f$exports;



var $12b872540830a075$export$b905424651869ffc = function isSamePath(a, b) {
    if (a === b) return true;
    return a.length === b.length && a.every(function(v, i) {
        return v === b[i];
    });
};
var $12b872540830a075$export$bd8d12a141c2ce47 = function hasSameParent(a, b) {
    return $12b872540830a075$export$b905424651869ffc($12b872540830a075$export$5a4b9be52684123a(a), $12b872540830a075$export$5a4b9be52684123a(b));
};
var $12b872540830a075$export$5a4b9be52684123a = function getParentPath(child) {
    return child.slice(0, child.length - 1);
};
var $12b872540830a075$export$260d01e2c619ef53 = function isTopOfSubtree(belowPath, abovePath) {
    return !abovePath || $12b872540830a075$var$isParentOf(abovePath, belowPath);
};
var $12b872540830a075$var$isParentOf = function isParentOf(parent, child) {
    return $12b872540830a075$export$b905424651869ffc(parent, $12b872540830a075$export$5a4b9be52684123a(child));
};
var $12b872540830a075$export$e88fa6a24cf6e513 = function getIndexAmongSiblings(path) {
    var lastIndex = path[path.length - 1];
    return lastIndex;
};
var $12b872540830a075$export$6bd207b7797289cf = function getPathOnLevel(path, level) {
    return path.slice(0, level);
};
var $12b872540830a075$export$dee1279409ac9da3 = function moveAfterPath(after, from) {
    var newPath = (0, (/*@__PURE__*/$parcel$interopDefault($f0c8170cebff136f$exports)))(after);
    var movedDownOnTheSameLevel = $12b872540830a075$export$820cfeea20144afe(newPath, from);
    if (!movedDownOnTheSameLevel) // not moved within the same subtree
    newPath[newPath.length - 1] += 1;
    return newPath;
};
var $12b872540830a075$export$820cfeea20144afe = function isLowerSibling(a, other) {
    return $12b872540830a075$export$bd8d12a141c2ce47(a, other) && $12b872540830a075$export$e88fa6a24cf6e513(a) > $12b872540830a075$export$e88fa6a24cf6e513(other);
};



function $02009d388fb5698d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $02009d388fb5698d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $02009d388fb5698d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($610273e25df12631$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $02009d388fb5698d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $02009d388fb5698d$export$b1dddf78efe19152 = function mutateTree(tree, itemId, mutation) {
    var itemToChange = tree.items[itemId];
    if (!itemToChange) // Item not found
    return tree;
    // Returning a clone of the tree structure and overwriting the field coming in mutation
    return {
        // rootId should not change
        rootId: tree.rootId,
        items: $02009d388fb5698d$var$_objectSpread($02009d388fb5698d$var$_objectSpread({}, tree.items), {}, (0, (/*@__PURE__*/$parcel$interopDefault($610273e25df12631$exports)))({}, itemId, $02009d388fb5698d$var$_objectSpread($02009d388fb5698d$var$_objectSpread({}, itemToChange), mutation)))
    };
};


function $f81ad458a3082102$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $f81ad458a3082102$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $f81ad458a3082102$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f81ad458a3082102$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f81ad458a3082102$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f81ad458a3082102$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $f81ad458a3082102$export$79f9fa345a841d8b = function flattenTree(tree) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return tree.items[tree.rootId] ? tree.items[tree.rootId].children.reduce(function(accum, itemId, index) {
        // iterating through all the children on the given level
        var item = tree.items[itemId];
        var currentPath = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($f0c8170cebff136f$exports)))(path), [
            index
        ]);
        // we create a flattened item for the current item
        var currentItem = $f81ad458a3082102$var$createFlattenedItem(item, currentPath);
        // we flatten its children
        var children = $f81ad458a3082102$var$flattenChildren(tree, item, currentPath);
        // append to the accumulator
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($f0c8170cebff136f$exports)))(accum), [
            currentItem
        ], (0, (/*@__PURE__*/$parcel$interopDefault($f0c8170cebff136f$exports)))(children));
    }, []) : [];
};
/*
  Constructs a new FlattenedItem
 */ var $f81ad458a3082102$var$createFlattenedItem = function createFlattenedItem(item, currentPath) {
    return {
        item: item,
        path: currentPath
    };
};
/*
  Flatten the children of the given subtree
*/ var $f81ad458a3082102$var$flattenChildren = function flattenChildren(tree, item, currentPath) {
    return item.isExpanded ? $f81ad458a3082102$export$79f9fa345a841d8b({
        rootId: item.id,
        items: tree.items
    }, currentPath) : [];
};
var $f81ad458a3082102$export$f92dfeb71e9bb569 = function getItem(tree, path) {
    var cursor = tree.items[tree.rootId];
    var _iterator = $f81ad458a3082102$var$_createForOfIteratorHelper(path), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var i = _step.value;
            cursor = tree.items[cursor.children[i]];
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return cursor;
};
var $f81ad458a3082102$export$58081aedf094d85b = function getParent(tree, path) {
    var parentPath = (0, $12b872540830a075$export$5a4b9be52684123a)(path);
    return $f81ad458a3082102$export$f92dfeb71e9bb569(tree, parentPath);
};
var $f81ad458a3082102$export$3ae3f1e7e6829490 = function getTreePosition(tree, path) {
    var parent = $f81ad458a3082102$export$58081aedf094d85b(tree, path);
    var index = (0, $12b872540830a075$export$e88fa6a24cf6e513)(path);
    return {
        parentId: parent.id,
        index: index
    };
};
var $f81ad458a3082102$var$hasLoadedChildren = function hasLoadedChildren(item) {
    return !!item.hasChildren && item.children.length > 0;
};
var $f81ad458a3082102$var$isLeafItem = function isLeafItem(item) {
    return !item.hasChildren;
};
var $f81ad458a3082102$export$a04a6dbb7f0831c4 = function removeItemFromTree(tree, position) {
    var sourceParent = tree.items[position.parentId];
    var newSourceChildren = (0, (/*@__PURE__*/$parcel$interopDefault($f0c8170cebff136f$exports)))(sourceParent.children);
    var itemRemoved = newSourceChildren.splice(position.index, 1)[0];
    var newTree = (0, $02009d388fb5698d$export$b1dddf78efe19152)(tree, position.parentId, {
        children: newSourceChildren,
        hasChildren: newSourceChildren.length > 0,
        isExpanded: newSourceChildren.length > 0 && sourceParent.isExpanded
    });
    return {
        tree: newTree,
        itemRemoved: itemRemoved
    };
};
var $f81ad458a3082102$export$8724f2dce7199d63 = function addItemToTree(tree, position, item) {
    var destinationParent = tree.items[position.parentId];
    var newDestinationChildren = (0, (/*@__PURE__*/$parcel$interopDefault($f0c8170cebff136f$exports)))(destinationParent.children);
    if (typeof position.index === 'undefined') {
        if ($f81ad458a3082102$var$hasLoadedChildren(destinationParent) || $f81ad458a3082102$var$isLeafItem(destinationParent)) newDestinationChildren.push(item);
    } else newDestinationChildren.splice(position.index, 0, item);
    return (0, $02009d388fb5698d$export$b1dddf78efe19152)(tree, position.parentId, {
        children: newDestinationChildren,
        hasChildren: true
    });
};



var $558f0975868bcc6c$export$8793edee2d425525 = function noop() {};
var $558f0975868bcc6c$export$d02631cccf789723 = function range(n) {
    return Array.from({
        length: n
    }, function(v, i) {
        return i;
    });
};
var $558f0975868bcc6c$export$cf95c51b03f10bae = function between(min, max, number) {
    return Math.min(max, Math.max(min, number));
};
var $558f0975868bcc6c$export$a9a18ae5ba42aeab = function oneOf(a, b) {
    return typeof a !== 'undefined' ? a : b;
};


var $c5172c14ff1cd2d5$export$7c875ece62096e1f = function getFlatItemPath(flattenedTree, sourceIndex) {
    return flattenedTree[sourceIndex].path;
};
var $c5172c14ff1cd2d5$export$cb1160e3e55f8781 = $c5172c14ff1cd2d5$export$7c875ece62096e1f;
var $c5172c14ff1cd2d5$export$9fda8f575307aefa = function getDestinationPath(flattenedTree, sourceIndex, destinationIndex, level) {
    // Moving down
    var down = destinationIndex > sourceIndex;
    // Path of the source location
    var sourcePath = $c5172c14ff1cd2d5$export$cb1160e3e55f8781(flattenedTree, sourceIndex);
    // Stayed at the same place
    var sameIndex = destinationIndex === sourceIndex;
    // Path of the upper item where the item was dropped
    var upperPath = down ? flattenedTree[destinationIndex].path : flattenedTree[destinationIndex - 1] && flattenedTree[destinationIndex - 1].path;
    // Path of the lower item where the item was dropped
    var lowerPath = down || sameIndex ? flattenedTree[destinationIndex + 1] && flattenedTree[destinationIndex + 1].path : flattenedTree[destinationIndex].path;
    /*
     We are going to differentiate 4 cases:
       - item didn't change position, only moved horizontally
       - item moved to the top of a list
       - item moved between two items on the same level
       - item moved to the end of list. This is an ambiguous case.
   */ // Stayed in place, might moved horizontally
    if (sameIndex) {
        if (typeof level !== 'number') return sourcePath;
        if (!upperPath) // Not possible to move
        return sourcePath;
        var minLevel = lowerPath ? lowerPath.length : 1;
        var maxLevel = Math.max(sourcePath.length, upperPath.length);
        var finalLevel = (0, $558f0975868bcc6c$export$cf95c51b03f10bae)(minLevel, maxLevel, level);
        var sameLevel = finalLevel === sourcePath.length;
        if (sameLevel) // Didn't change level
        return sourcePath;
        var previousPathOnTheFinalLevel = (0, $12b872540830a075$export$6bd207b7797289cf)(upperPath, finalLevel);
        return (0, $12b872540830a075$export$dee1279409ac9da3)(previousPathOnTheFinalLevel, sourcePath);
    }
    // Moved to top of the list
    if (lowerPath && (0, $12b872540830a075$export$260d01e2c619ef53)(lowerPath, upperPath)) return lowerPath;
    // Moved between two items on the same level
    if (upperPath && lowerPath && (0, $12b872540830a075$export$bd8d12a141c2ce47)(upperPath, lowerPath)) {
        if (down && (0, $12b872540830a075$export$bd8d12a141c2ce47)(upperPath, sourcePath)) // if item was moved down within the list, it will replace the displaced item
        return upperPath;
        return lowerPath;
    }
    // Moved to end of list
    if (upperPath) {
        // this means that the upper item is deeper in the tree.
        var _finalLevel = $c5172c14ff1cd2d5$var$calculateFinalLevel(sourcePath, upperPath, lowerPath, level);
        // Insert to higher levels
        var _previousPathOnTheFinalLevel = (0, $12b872540830a075$export$6bd207b7797289cf)(upperPath, _finalLevel);
        return (0, $12b872540830a075$export$dee1279409ac9da3)(_previousPathOnTheFinalLevel, sourcePath);
    }
    // In case of any other impossible case
    return sourcePath;
};
var $c5172c14ff1cd2d5$var$calculateFinalLevel = function calculateFinalLevel(sourcePath, upperPath, lowerPath, level) {
    var upperLevel = upperPath.length;
    var lowerLevel = lowerPath ? lowerPath.length : 1;
    var sourceLevel = sourcePath.length;
    if (typeof level === 'number') // Explicit disambiguation based on level
    // Final level has to be between the levels of bounding items, inclusive
    return (0, $558f0975868bcc6c$export$cf95c51b03f10bae)(lowerLevel, upperLevel, level);
    // Automatic disambiguation based on the initial level
    return sourceLevel <= lowerLevel ? lowerLevel : upperLevel;
};
var $c5172c14ff1cd2d5$export$cde8ca1b2caa28d = function getItemById(flattenedTree, id) {
    return flattenedTree.find(function(item) {
        return item.item.id === id;
    });
};
var $c5172c14ff1cd2d5$export$489ac0f4353bcbd0 = function getIndexById(flattenedTree, id) {
    return flattenedTree.findIndex(function(item) {
        return item.item.id === id;
    });
};


function $95a970f142d66264$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $95a970f142d66264$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $95a970f142d66264$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($610273e25df12631$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $95a970f142d66264$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $95a970f142d66264$export$e553b4d75f67d0a7 = function calculateFinalDropPositions(tree, flattenedTree, dragState) {
    var source = dragState.source, destination = dragState.destination, combine = dragState.combine, horizontalLevel = dragState.horizontalLevel;
    var sourcePath = (0, $c5172c14ff1cd2d5$export$cb1160e3e55f8781)(flattenedTree, source.index);
    var sourcePosition = (0, $f81ad458a3082102$export$3ae3f1e7e6829490)(tree, sourcePath);
    if (combine) return {
        sourcePosition: sourcePosition,
        destinationPosition: {
            parentId: combine.draggableId
        }
    };
    if (!destination) return {
        sourcePosition: sourcePosition,
        destinationPosition: undefined
    };
    var destinationPath = (0, $c5172c14ff1cd2d5$export$9fda8f575307aefa)(flattenedTree, source.index, destination.index, horizontalLevel);
    var destinationPosition = $95a970f142d66264$var$_objectSpread({}, (0, $f81ad458a3082102$export$3ae3f1e7e6829490)(tree, destinationPath));
    return {
        sourcePosition: sourcePosition,
        destinationPosition: destinationPosition
    };
};













var $ieT14 = parcelRequire("ieT14");

var $1761f064d167decc$export$e68503335021ed9 = function sameProps(oldProps, newProps, props) {
    return props.find(function(p) {
        return oldProps[p] !== newProps[p];
    }) === undefined;
};


function $0b0e2e6b6c23bb08$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0b0e2e6b6c23bb08$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0b0e2e6b6c23bb08$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($610273e25df12631$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0b0e2e6b6c23bb08$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0b0e2e6b6c23bb08$var$_createSuper(t) {
    var r = $0b0e2e6b6c23bb08$var$_isNativeReflectConstruct();
    return function() {
        var e, o = (0, (/*@__PURE__*/$parcel$interopDefault($0028efb354ad91cb$exports)))(t);
        if (r) {
            var s = (0, (/*@__PURE__*/$parcel$interopDefault($0028efb354ad91cb$exports)))(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($6a9451cd79a02d8d$exports)))(this, e);
    };
}
function $0b0e2e6b6c23bb08$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0b0e2e6b6c23bb08$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $0b0e2e6b6c23bb08$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($69c14df2b00cc6b7$exports)))(TreeItem, _Component);
    var _super = $0b0e2e6b6c23bb08$var$_createSuper(TreeItem);
    function TreeItem() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6b5d58ae6912feb1$exports)))(this, TreeItem);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($610273e25df12631$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f96fea7485054db2$exports)))(_this), "patchDraggableProps", function(draggableProps, snapshot) {
            var _this$props = _this.props, path = _this$props.path, offsetPerLevel = _this$props.offsetPerLevel;
            var transitions = draggableProps.style && draggableProps.style.transition ? [
                draggableProps.style.transition
            ] : [];
            if (snapshot.dropAnimation) transitions.push("padding-left ".concat(snapshot.dropAnimation.duration, "s ").concat(snapshot.dropAnimation.curve));
            var transition = transitions.join(', ');
            return $0b0e2e6b6c23bb08$var$_objectSpread($0b0e2e6b6c23bb08$var$_objectSpread({}, draggableProps), {}, {
                style: $0b0e2e6b6c23bb08$var$_objectSpread($0b0e2e6b6c23bb08$var$_objectSpread({}, draggableProps.style), {}, {
                    paddingLeft: (path.length - 1) * offsetPerLevel,
                    // @ts-ignore
                    transition: transition
                })
            });
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($5debd17a1d994b8d$exports)))(TreeItem, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return !(0, $1761f064d167decc$export$e68503335021ed9)(this.props, nextProps, [
                    'item',
                    'provided',
                    'snapshot',
                    'onCollapse',
                    'onExpand'
                ]) || !(0, $12b872540830a075$export$b905424651869ffc)(this.props.path, nextProps.path) || // also rerender tree item even if the item is not draggable, this allows draggable/nondraggable items to behave the same
                this.props.provided.dragHandleProps === null;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, item = _this$props2.item, path = _this$props2.path, _onExpand = _this$props2.onExpand, _onCollapse = _this$props2.onCollapse, renderItem = _this$props2.renderItem, provided = _this$props2.provided, snapshot = _this$props2.snapshot, itemRef = _this$props2.itemRef;
                var innerRef = function innerRef(el) {
                    itemRef(item.id, el);
                    provided.innerRef(el);
                };
                var finalProvided = {
                    draggableProps: this.patchDraggableProps(provided.draggableProps, snapshot),
                    dragHandleProps: provided.dragHandleProps,
                    innerRef: innerRef
                };
                return renderItem({
                    item: item,
                    depth: path.length - 1,
                    onExpand: function onExpand(itemId) {
                        return _onExpand(itemId, path);
                    },
                    onCollapse: function onCollapse(itemId) {
                        return _onCollapse(itemId, path);
                    },
                    provided: finalProvided,
                    snapshot: snapshot
                });
            }
        }
    ]);
    return TreeItem;
}((0, $ieT14.Component));





var $8a13d580773d77b9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function DelayedFunction(delay) {
        (0, (/*@__PURE__*/$parcel$interopDefault($6b5d58ae6912feb1$exports)))(this, DelayedFunction);
        this.delay = delay;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($5debd17a1d994b8d$exports)))(DelayedFunction, [
        {
            key: "start",
            value: function start(fn) {
                this.stop();
                this.timeoutId = window.setTimeout(fn, this.delay);
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.timeoutId) {
                    clearTimeout(this.timeoutId);
                    this.timeoutId = undefined;
                }
            }
        }
    ]);
    return DelayedFunction;
}();


function $c69f600a0e5cd9df$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c69f600a0e5cd9df$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c69f600a0e5cd9df$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($610273e25df12631$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c69f600a0e5cd9df$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c69f600a0e5cd9df$var$_createSuper(t) {
    var r = $c69f600a0e5cd9df$var$_isNativeReflectConstruct();
    return function() {
        var e, o = (0, (/*@__PURE__*/$parcel$interopDefault($0028efb354ad91cb$exports)))(t);
        if (r) {
            var s = (0, (/*@__PURE__*/$parcel$interopDefault($0028efb354ad91cb$exports)))(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($6a9451cd79a02d8d$exports)))(this, e);
    };
}
function $c69f600a0e5cd9df$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c69f600a0e5cd9df$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $c69f600a0e5cd9df$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($69c14df2b00cc6b7$exports)))(Tree, _Component);
    var _super = $c69f600a0e5cd9df$var$_createSuper(Tree);
    function Tree() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($6b5d58ae6912feb1$exports)))(this, Tree);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($610273e25df12631$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f96fea7485054db2$exports)))(_this), "state", {
            flattenedTree: [],
            draggedItemId: undefined
        });
        // HTMLElement for each rendered item
        (0, (/*@__PURE__*/$parcel$interopDefault($610273e25df12631$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f96fea7485054db2$exports)))(_this), "itemsElement", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($610273e25df12631$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f96fea7485054db2$exports)))(_this), "expandTimer", new (0, $8a13d580773d77b9$export$2e2bcd8739ae039)(500));
        (0, (/*@__PURE__*/$parcel$interopDefault($610273e25df12631$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f96fea7485054db2$exports)))(_this), "onDragStart", function(result) {
            var onDragStart = _this.props.onDragStart;
            _this.dragState = {
                source: result.source,
                destination: result.source,
                mode: result.mode
            };
            _this.setState({
                draggedItemId: result.draggableId
            });
            if (onDragStart) onDragStart(result.draggableId);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($610273e25df12631$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f96fea7485054db2$exports)))(_this), "onDragUpdate", function(update) {
            var onExpand = _this.props.onExpand;
            var flattenedTree = _this.state.flattenedTree;
            if (!_this.dragState) return;
            _this.expandTimer.stop();
            if (update.combine) {
                var draggableId = update.combine.draggableId;
                var item = (0, $c5172c14ff1cd2d5$export$cde8ca1b2caa28d)(flattenedTree, draggableId);
                if (item && _this.isExpandable(item)) _this.expandTimer.start(function() {
                    return onExpand(draggableId, item.path);
                });
            }
            _this.dragState = $c69f600a0e5cd9df$var$_objectSpread($c69f600a0e5cd9df$var$_objectSpread({}, _this.dragState), {}, {
                destination: update.destination,
                combine: update.combine
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($610273e25df12631$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f96fea7485054db2$exports)))(_this), "onDropAnimating", function() {
            _this.expandTimer.stop();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($610273e25df12631$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f96fea7485054db2$exports)))(_this), "onDragEnd", function(result) {
            var _this$props = _this.props, onDragEnd = _this$props.onDragEnd, tree = _this$props.tree;
            var flattenedTree = _this.state.flattenedTree;
            _this.expandTimer.stop();
            var finalDragState = $c69f600a0e5cd9df$var$_objectSpread($c69f600a0e5cd9df$var$_objectSpread({}, _this.dragState), {}, {
                source: result.source,
                destination: result.destination,
                combine: result.combine
            });
            _this.setState({
                draggedItemId: undefined
            });
            var _calculateFinalDropPo = (0, $95a970f142d66264$export$e553b4d75f67d0a7)(tree, flattenedTree, finalDragState), sourcePosition = _calculateFinalDropPo.sourcePosition, destinationPosition = _calculateFinalDropPo.destinationPosition;
            onDragEnd(sourcePosition, destinationPosition);
            _this.dragState = undefined;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($610273e25df12631$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f96fea7485054db2$exports)))(_this), "onPointerMove", function() {
            if (_this.dragState) _this.dragState = $c69f600a0e5cd9df$var$_objectSpread($c69f600a0e5cd9df$var$_objectSpread({}, _this.dragState), {}, {
                horizontalLevel: _this.getDroppedLevel()
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($610273e25df12631$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f96fea7485054db2$exports)))(_this), "calculateEffectivePath", function(flatItem, snapshot) {
            var _this$state = _this.state, flattenedTree = _this$state.flattenedTree, draggedItemId = _this$state.draggedItemId;
            if (_this.dragState && draggedItemId === flatItem.item.id && (_this.dragState.destination || _this.dragState.combine)) {
                var _this$dragState = _this.dragState, source = _this$dragState.source, destination = _this$dragState.destination, combine = _this$dragState.combine, horizontalLevel = _this$dragState.horizontalLevel, mode = _this$dragState.mode;
                // We only update the path when it's dragged by keyboard or drop is animated
                if (mode === 'SNAP' || snapshot.isDropAnimating) {
                    if (destination) // Between two items
                    return (0, $c5172c14ff1cd2d5$export$9fda8f575307aefa)(flattenedTree, source.index, destination.index, horizontalLevel);
                    if (combine) // Hover on other item while dragging
                    return (0, $c5172c14ff1cd2d5$export$9fda8f575307aefa)(flattenedTree, source.index, (0, $c5172c14ff1cd2d5$export$489ac0f4353bcbd0)(flattenedTree, combine.draggableId), horizontalLevel);
                }
            }
            return flatItem.path;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($610273e25df12631$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f96fea7485054db2$exports)))(_this), "isExpandable", function(item) {
            return !!item.item.hasChildren && !item.item.isExpanded;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($610273e25df12631$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f96fea7485054db2$exports)))(_this), "getDroppedLevel", function() {
            var offsetPerLevel = _this.props.offsetPerLevel;
            var draggedItemId = _this.state.draggedItemId;
            if (!_this.dragState || !_this.containerElement) return undefined;
            var containerLeft = (0, $b703e4029dc36ed5$export$34928e660d2a8702)(_this.containerElement).contentBox.left;
            var itemElement = _this.itemsElement[draggedItemId];
            if (itemElement) {
                var currentLeft = (0, $b703e4029dc36ed5$export$34928e660d2a8702)(itemElement).contentBox.left;
                var relativeLeft = Math.max(currentLeft - containerLeft, 0);
                return Math.floor((relativeLeft + offsetPerLevel / 2) / offsetPerLevel) + 1;
            }
            return undefined;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($610273e25df12631$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f96fea7485054db2$exports)))(_this), "patchDroppableProvided", function(provided) {
            return $c69f600a0e5cd9df$var$_objectSpread($c69f600a0e5cd9df$var$_objectSpread({}, provided), {}, {
                innerRef: function innerRef(el) {
                    _this.containerElement = el;
                    provided.innerRef(el);
                }
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($610273e25df12631$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f96fea7485054db2$exports)))(_this), "setItemRef", function(itemId, el) {
            if (!!el) _this.itemsElement[itemId] = el;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($610273e25df12631$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f96fea7485054db2$exports)))(_this), "renderItems", function() {
            var flattenedTree = _this.state.flattenedTree;
            return flattenedTree.map(_this.renderItem);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($610273e25df12631$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f96fea7485054db2$exports)))(_this), "renderItem", function(flatItem, index) {
            var isDragEnabled = _this.props.isDragEnabled;
            // If drag and drop is explicitly disabled for all items, render TreeItem directly with stubbed provided and snapshot
            if (isDragEnabled === false) return _this.renderTreeItem({
                flatItem: flatItem,
                path: flatItem.path,
                provided: {
                    draggableProps: {
                        'data-react-beautiful-dnd-draggable': ''
                    },
                    innerRef: function innerRef() {},
                    dragHandleProps: null
                },
                snapshot: {
                    isDragging: false,
                    isDropAnimating: false
                }
            });
            var isDragDisabled = typeof isDragEnabled === 'function' ? !isDragEnabled(flatItem.item) : !isDragEnabled;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement((0, $bd7d663e2fcda8c2$export$f2a139e5d18b9882), {
                key: flatItem.item.id,
                draggableId: flatItem.item.id.toString(),
                index: index,
                isDragDisabled: isDragDisabled
            }, _this.renderDraggableItem(flatItem));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($610273e25df12631$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f96fea7485054db2$exports)))(_this), "renderDraggableItem", function(flatItem) {
            return function(provided, snapshot) {
                var currentPath = _this.calculateEffectivePath(flatItem, snapshot);
                if (snapshot.isDropAnimating) _this.onDropAnimating();
                return _this.renderTreeItem({
                    flatItem: flatItem,
                    path: currentPath,
                    provided: provided,
                    snapshot: snapshot
                });
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($610273e25df12631$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($f96fea7485054db2$exports)))(_this), "renderTreeItem", function(_ref) {
            var flatItem = _ref.flatItem, path = _ref.path, provided = _ref.provided, snapshot = _ref.snapshot;
            var _this$props2 = _this.props, renderItem = _this$props2.renderItem, onExpand = _this$props2.onExpand, onCollapse = _this$props2.onCollapse, offsetPerLevel = _this$props2.offsetPerLevel;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement((0, $0b0e2e6b6c23bb08$export$2e2bcd8739ae039), {
                key: flatItem.item.id,
                item: flatItem.item,
                path: path,
                onExpand: onExpand,
                onCollapse: onCollapse,
                renderItem: renderItem,
                provided: provided,
                snapshot: snapshot,
                itemRef: _this.setItemRef,
                offsetPerLevel: offsetPerLevel
            });
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($5debd17a1d994b8d$exports)))(Tree, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var isNestingEnabled = this.props.isNestingEnabled;
                var renderedItems = this.renderItems();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement((0, $bd7d663e2fcda8c2$export$237bd83162c14364), {
                    onDragStart: this.onDragStart,
                    onDragEnd: this.onDragEnd,
                    onDragUpdate: this.onDragUpdate
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement((0, $bd7d663e2fcda8c2$export$423ec2075359570a), {
                    droppableId: "tree",
                    isCombineEnabled: isNestingEnabled,
                    ignoreContainerClipping: true
                }, function(provided) {
                    var finalProvided = _this2.patchDroppableProvided(provided);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($c3f46f9735a25a96$exports)))({
                        ref: finalProvided.innerRef,
                        style: {
                            pointerEvents: 'auto'
                        },
                        onTouchMove: _this2.onPointerMove,
                        onMouseMove: _this2.onPointerMove
                    }, finalProvided.droppableProps), renderedItems, provided.placeholder);
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var draggedItemId = state.draggedItemId;
                var tree = props.tree;
                var finalTree = Tree.closeParentIfNeeded(tree, draggedItemId);
                var flattenedTree = (0, $f81ad458a3082102$export$79f9fa345a841d8b)(finalTree);
                return $c69f600a0e5cd9df$var$_objectSpread($c69f600a0e5cd9df$var$_objectSpread({}, state), {}, {
                    flattenedTree: flattenedTree
                });
            }
        },
        {
            key: "closeParentIfNeeded",
            value: function closeParentIfNeeded(tree, draggedItemId) {
                if (!!draggedItemId) // Closing parent internally during dragging, because visually we can only move one item not a subtree
                return (0, $02009d388fb5698d$export$b1dddf78efe19152)(tree, draggedItemId, {
                    isExpanded: false
                });
                return tree;
            }
        }
    ]);
    return Tree;
}((0, $ieT14.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($610273e25df12631$exports)))($c69f600a0e5cd9df$export$2e2bcd8739ae039, "defaultProps", {
    tree: {
        children: []
    },
    onExpand: (0, $558f0975868bcc6c$export$8793edee2d425525),
    onCollapse: (0, $558f0975868bcc6c$export$8793edee2d425525),
    onDragStart: (0, $558f0975868bcc6c$export$8793edee2d425525),
    onDragEnd: (0, $558f0975868bcc6c$export$8793edee2d425525),
    renderItem: (0, $558f0975868bcc6c$export$8793edee2d425525),
    offsetPerLevel: 35,
    isDragEnabled: false,
    isNestingEnabled: false
});


var $00ef0119e15633da$export$7714407ea87aca85 = function moveItemOnTree(tree, from, to) {
    var _removeItemFromTree = (0, $f81ad458a3082102$export$a04a6dbb7f0831c4)(tree, from), treeWithoutSource = _removeItemFromTree.tree, itemRemoved = _removeItemFromTree.itemRemoved;
    return (0, $f81ad458a3082102$export$8724f2dce7199d63)(treeWithoutSource, to, itemRemoved);
};




var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $71a00901af78c32d$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M20 9H4v2h16V9zM4 15h16v-2H4v2z"
}), 'DragHandle');


var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $b231e483803be961$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), 'ExpandLess');


var $e1kqS = parcelRequire("e1kqS");

var $6mt9R = parcelRequire("6mt9R");
var $eYoAG = parcelRequire("eYoAG");

/**
 * Component rendering the drag and drop menu for help documents
 */ const $6b99a4afaebc49ab$var$SidePanel = ({ documentsList: documentsList, setIsSearching: setIsSearching })=>{
    const { dispatch: dispatch, changeActiveDoc: changeActiveDoc, updateClientDocumentsSortOrder: updateClientDocumentsSortOrder, updateGlobalDocumentsSortOrder: updateGlobalDocumentsSortOrder, activeDocumentId: activeDocumentId, helpDocuments: helpDocuments } = (0, $c807f91b5abb1e86$export$2e2bcd8739ae039)();
    const { clientId: clientId } = (0, $eYoAG.useParams)();
    const { documentsWithoutRoot: documentsWithoutRoot, findNextDocument: findNextDocument, draggedSnippetGroupId: draggedSnippetGroupId, findChildren: findChildren, getChildDocsToRenderEdit: getChildDocsToRenderEdit } = (0, $dfbf579bea9f90b3$export$2e2bcd8739ae039)();
    const currentRoute = clientId ? `/clients/${clientId}/edit/help` : (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).GlobalHelpDocuments;
    const onDragEnd = (source, destination)=>{
        if (!destination) return;
        /** The previous help document tree */ const prevState = documentsList;
        /** The new tree after the drag has ended */ const newTree = (0, $00ef0119e15633da$export$7714407ea87aca85)(documentsList, source, destination);
        /** A copy of the source (includes parentId and index) */ const sourceCopy = source;
        /** A copy of the destination (includes parentId and index) */ const destinationCopy = destination;
        sourceCopy.parentId = sourceCopy.parentId === '-1' ? 0 : Number(sourceCopy.parentId);
        destinationCopy.parentId = destinationCopy.parentId === '-1' ? 0 : Number(destinationCopy.parentId);
        if (newTree.items[destinationCopy.parentId]) newTree.items[destinationCopy.parentId].isExpanded = true;
        dispatch({
            helpDocuments: newTree
        });
        /** Array of tree items without the root document */ const innerDocumentsWithoutRoot = documentsWithoutRoot(newTree);
        /** The document that comes after the document that was moved */ const nextDocumentId = findNextDocument(destinationCopy.parentId, destination.index, newTree);
        /** SnippetGroupId of the document that was moved */ const snippetGroupId = draggedSnippetGroupId(destinationCopy.index, destinationCopy.parentId, newTree);
        /** The full data of the document that was moved */ const documentDragged = innerDocumentsWithoutRoot.find((doc)=>doc.data.snippetGroupId === snippetGroupId);
        /** All the children of the document that was moved */ const allChildren = findChildren(snippetGroupId, [
            ...documentDragged.children
        ], newTree);
        if (!clientId) updateGlobalDocumentsSortOrder(snippetGroupId, destinationCopy.parentId, allChildren, nextDocumentId, prevState);
        else updateClientDocumentsSortOrder(snippetGroupId, destinationCopy.parentId, allChildren, nextDocumentId, prevState);
    };
    const onExpand = (itemId)=>{
        const documents = $fRnKy.cloneDeep(documentsList);
        documents.items[`${itemId}`].isExpanded = !documents.items[`${itemId}`].isExpanded;
        dispatch({
            helpDocuments: documents
        });
    };
    /** Currently active help documents to be highlighted in renderItem */ let activeItems = [];
    if (activeDocumentId) activeItems = [
        ...getChildDocsToRenderEdit(activeDocumentId, helpDocuments).map((doc)=>doc.snippetGroupId)
    ];
    const renderItem = ({ item: item, depth: depth, provided: provided, onExpand: onExpand })=>{
        const active = activeItems && activeItems.includes(Number(item.id));
        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
            className: (0, $j6s32.default)($2b36415f25d48604$export$796e90bc7f93c68c, depth === 0 && $2b36415f25d48604$export$ea07a18aa00be18e, active && $2b36415f25d48604$export$6deed9990843f121),
            ref: provided.innerRef,
            ...provided.draggableProps,
            ...provided.dragHandleProps,
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $2b36415f25d48604$export$8cda5e5bc1088076,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $711f256e1d9605c8$export$2e2bcd8739ae039), {
                        className: $2b36415f25d48604$export$1a182f8896a5fd6a,
                        onClick: ()=>onExpand(item.id),
                        children: item.hasChildren && item.isExpanded ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $e1kqS.default), {
                            style: {
                                cursor: 'pointer'
                            }
                        }) : item.hasChildren && !item.isExpanded && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $b231e483803be961$export$2e2bcd8739ae039), {
                            style: {
                                transform: 'rotate(90deg)',
                                cursor: 'pointer'
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6mt9R.NavLink), {
                        className: $2b36415f25d48604$export$a606bd1b881a1ff8,
                        to: {
                            pathname: `${currentRoute}/${item.data.snippetGroupId}`,
                            state: {
                                id: item.data.snippetGroupId
                            }
                        },
                        onClick: ()=>setIsSearching(false),
                        isActive: (param, location)=>changeActiveDoc(param, location, item.data.snippetGroupId),
                        children: item.data && item.data.title
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $711f256e1d9605c8$export$2e2bcd8739ae039), {
                        className: $2b36415f25d48604$export$a184029c150a81f4,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $71a00901af78c32d$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        });
    };
    if (!documentsList.items) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {});
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("ul", {
        className: $2b36415f25d48604$export$abbf891d14497896,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $c69f600a0e5cd9df$export$2e2bcd8739ae039), {
            tree: documentsList,
            renderItem: renderItem,
            offsetPerLevel: 20,
            isDragEnabled: true,
            onDragEnd: onDragEnd,
            isNestingEnabled: true,
            onExpand: onExpand
        })
    });
};
var $6b99a4afaebc49ab$export$2e2bcd8739ae039 = $6b99a4afaebc49ab$var$SidePanel;




var $gXLwJ = parcelRequire("gXLwJ");
const $c46f303aaa525c96$var$dialogStyles = {
    helpDocuments: {
        width: '100%',
        border: '1px solid #dadada',
        overflowY: 'scroll'
    },
    contentHeader: {
        height: '44px',
        display: 'flex',
        alignItems: 'center',
        padding: '0 16px 0 30px',
        fontWeight: '600',
        fontSize: '16px',
        borderBottom: '1px solid #8a8a8a',
        justifyContent: 'space-between'
    },
    fullScreenDiv: {
        color: '#006da8',
        fontWeight: '400',
        fontSize: '14px',
        textTransform: 'uppercase',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer'
    },
    fullScreenText: {
        marginLeft: '2px'
    },
    documentsContainer: {
        margin: '48px 57px',
        position: 'relative'
    }
};
const $c46f303aaa525c96$var$materialTheme = (0, $gXLwJ.default)({
    overrides: {
        MuiDialog: {
            root: {
                zIndex: '20000 !important'
            }
        }
    }
});
/**
 * FullScreenDialog
 * @function FullScreenDialog - Full screen dialog to show the contents of a help document
 */ const $c46f303aaa525c96$var$FullScreenDialog = ({ openFullScreen: openFullScreen, setOpenFullScreen: setOpenFullScreen, isSearching: isSearching })=>{
    const { renderHelpContent: renderHelpContent } = (0, $c807f91b5abb1e86$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $544e32820ad8eb30$export$2e2bcd8739ae039), {
        theme: $c46f303aaa525c96$var$materialTheme,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1c689a1559dbf5e9$export$2e2bcd8739ae039), {
            fullScreen: true,
            open: openFullScreen,
            onClose: ()=>setOpenFullScreen(false),
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $881610d42277b808$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    style: $c46f303aaa525c96$var$dialogStyles.helpDocuments,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                            style: $c46f303aaa525c96$var$dialogStyles.contentHeader,
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                    children: "Document"
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                    onClick: ()=>setOpenFullScreen(false),
                                    style: $c46f303aaa525c96$var$dialogStyles.fullScreenDiv,
                                    children: [
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3a786cac0bbe966e$exports))), {}),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                            style: $c46f303aaa525c96$var$dialogStyles.fullScreenText,
                                            children: "Minimize"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                            style: $c46f303aaa525c96$var$dialogStyles.documentsContainer,
                            children: renderHelpContent(isSearching)
                        })
                    ]
                })
            })
        })
    });
};
/**
 * HelpSection
 * @function HelpSection - Component for the left toolbar and the help documents page
 */ const $c46f303aaa525c96$var$HelpSection = ({ searchQuery: searchQuery, isSearching: isSearching, setIsSearching: setIsSearching })=>{
    const { helpDocuments: helpDocuments, activeDocumentId: activeDocumentId, renderHelpContent: renderHelpContent, renderPreviews: renderPreviews, dispatch: dispatch } = (0, $c807f91b5abb1e86$export$2e2bcd8739ae039)();
    const [openFullScreen, setOpenFullScreen] = $ieT14.useState(false);
    const [redirect, setRedirect] = $ieT14.useState(false);
    const { documentsWithRoot: documentsWithRoot } = (0, $dfbf579bea9f90b3$export$2e2bcd8739ae039)();
    const { measuredRef: measuredRef, dimensions: dimensions } = (0, $d9ed1b1da5a3379c$export$2e2bcd8739ae039)([], true);
    // If there is no active document, the first document will become the active document so that there is always a document to display
    $ieT14.useEffect(()=>{
        if (helpDocuments.rootId) {
            if (!activeDocumentId) dispatch({
                activeDocumentId: documentsWithRoot(helpDocuments).find((doc)=>doc.id === '-1').children[0]
            });
            else if (activeDocumentId && !redirect) setRedirect(true);
        }
    }, [
        activeDocumentId,
        helpDocuments.rootId
    ]);
    // Redirects to the first document from the document list if there is no active document
    if (redirect) {
        setRedirect(false);
        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Redirect), {
            to: `${(0, $4bbac098dba9d86f$export$2e2bcd8739ae039).ClientHelpDocuments}/${activeDocumentId}`
        });
    }
    /** Array of JSX elements that displays the preview of the help documents as the user is typing in the search bar */ const previews = renderPreviews(searchQuery, isSearching, setIsSearching);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $2b36415f25d48604$export$998fc1525fc10cb4,
        ref: measuredRef,
        style: {
            height: `calc(100vh - ${dimensions ? 20 + dimensions.top : 0}px`
        },
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $2b36415f25d48604$export$cace0fe917d7fea5,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h5", {
                        className: $2b36415f25d48604$export$48884d2a5190dc73,
                        children: "Select a Document"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: $2b36415f25d48604$export$9b9ee9fa673496c9,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $5d10f0a7aadd7c8c$exports.Scrollbars), {
                            className: $2b36415f25d48604$export$cdc47cd250892a50,
                            autoHide: true,
                            universal: true,
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6b99a4afaebc49ab$export$2e2bcd8739ae039), {
                                documentsList: helpDocuments,
                                setIsSearching: setIsSearching
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $2b36415f25d48604$export$2446a521e491a056,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        className: $2b36415f25d48604$export$d7dc7be08229f0b2,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h5", {
                                children: "Document"
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                onClick: ()=>setOpenFullScreen(true),
                                className: $2b36415f25d48604$export$69090a1e7ff8614c,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5a696242325064a1$exports))), {}),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                        children: "Maximize"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: $2b36415f25d48604$export$26cf923f17b837e4,
                        children: previews ? previews : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $5d10f0a7aadd7c8c$exports.Scrollbars), {
                            className: $2b36415f25d48604$export$77825fa6f4ae045f,
                            autoHide: true,
                            universal: true,
                            hideTracksWhenNotNeeded: true,
                            children: renderHelpContent(isSearching)
                        })
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($c46f303aaa525c96$var$FullScreenDialog, {
                        openFullScreen: openFullScreen,
                        setOpenFullScreen: setOpenFullScreen,
                        isSearching: isSearching
                    })
                ]
            })
        ]
    });
};
var $c46f303aaa525c96$export$2e2bcd8739ae039 = $c46f303aaa525c96$var$HelpSection;



var $eYoAG = parcelRequire("eYoAG");









var $ieT14 = parcelRequire("ieT14");

var $fRnKy = parcelRequire("fRnKy");







var $eYoAG = parcelRequire("eYoAG");


const $8ccaf37a2b253d5d$var$ClientMapModalContent = ({ globalHelpDocuments: globalHelpDocuments, mappedDocuments: mappedDocuments, closeModal: closeModal })=>{
    const { clientId: clientId } = (0, $eYoAG.useParams)();
    const { fetchHelpDocumentsWithRevisions: fetchHelpDocumentsWithRevisions, fetchGlobalHelpDocuments: fetchGlobalHelpDocuments, dispatch: dispatch } = (0, $c807f91b5abb1e86$export$2e2bcd8739ae039)();
    const [mappedGlobalDocuments, setMappedGlobalDocuments] = $ieT14.useState(mappedDocuments);
    const { documentsWithoutRoot: documentsWithoutRoot, findChildren: findChildren, mapGlobalDocumentsToClients: mapGlobalDocumentsToClients } = (0, $dfbf579bea9f90b3$export$2e2bcd8739ae039)();
    const handleMapping = (documentId, toCheck)=>{
        const selectedDocument = documentsWithoutRoot(globalHelpDocuments).find((doc)=>doc.data.snippetGroupId === documentId);
        const documentsToAlter = findChildren(documentId, [
            ...selectedDocument.children
        ], globalHelpDocuments);
        setMappedGlobalDocuments((prevState)=>{
            const nextState = $fRnKy.cloneDeep(prevState);
            const mappedGlobalDocumentsIds = nextState.map((doc)=>doc.snippetGroupId);
            documentsToAlter.forEach((doc)=>{
                const checked = mappedGlobalDocuments.map((doc)=>doc.snippetGroupId).includes(doc);
                const alter = checked !== toCheck;
                if (alter) {
                    if (mappedGlobalDocumentsIds.includes(doc)) {
                        const docIndex = nextState.map((i)=>i.snippetGroupId).indexOf(doc);
                        if (docIndex > -1) nextState.splice(docIndex, 1);
                    } else nextState.push(globalHelpDocuments.items[`${doc}`].data);
                }
            });
            if (!$fRnKy.isEqual(prevState, nextState)) return nextState;
            return prevState;
        });
    };
    const selectAll = ()=>{
        setMappedGlobalDocuments(documentsWithoutRoot(globalHelpDocuments).map((doc)=>doc.data));
    };
    const saveMapping = ()=>{
        const snippetGroupIds = mappedGlobalDocuments.map((doc)=>doc.snippetGroupId);
        closeModal();
        dispatch({
            loading: true
        });
        return mapGlobalDocumentsToClients(Number(clientId), snippetGroupIds).then(()=>Promise.all([
                fetchHelpDocumentsWithRevisions(true),
                fetchGlobalHelpDocuments(true, true)
            ])).then(()=>dispatch({
                loading: false
            })).catch((err)=>dispatch({
                loading: false,
                errorMessage: err.responseJSON.message
            }));
    };
    const renderItem = ({ item: item, provided: provided, onExpand: onExpand })=>{
        const checked = mappedGlobalDocuments.map((doc)=>doc.snippetGroupId).includes(Number(item.id));
        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("li", {
            ref: provided.innerRef,
            ...provided.draggableProps,
            ...provided.dragHandleProps,
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8d66a60ef98d2984$export$2e2bcd8739ae039), {
                    checked: checked,
                    tabIndex: -1,
                    disableRipple: true,
                    onClick: ()=>{
                        handleMapping(Number(item.id), !checked);
                    }
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                    children: item.data.title
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $2b36415f25d48604$export$c1b0e24ee081147d,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("ul", {
                className: $2b36415f25d48604$export$4767d4262788a6cc,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5d10f0a7aadd7c8c$exports))), {
                        autoHide: true,
                        className: $2b36415f25d48604$export$209876d7b1ac8f3,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $c69f600a0e5cd9df$export$2e2bcd8739ae039), {
                            tree: globalHelpDocuments,
                            onExpand: handleMapping,
                            renderItem: (item)=>renderItem(item),
                            offsetPerLevel: 20,
                            isNestingEnabled: true
                        })
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fcd3b8c5e9a7038b$export$2e2bcd8739ae039), {
                        text: "Select All",
                        handleClick: selectAll
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f5afe0f42548a953$export$2e2bcd8739ae039), {
                text: "Save",
                handleClick: saveMapping
            })
        ]
    });
};
var $8ccaf37a2b253d5d$export$2e2bcd8739ae039 = $8ccaf37a2b253d5d$var$ClientMapModalContent;



/**
 * Outer component for the help page
 */ const $4c3bb60c07737b6c$var$ClientHelpDocuments = ()=>{
    const { loading: loading, fetchHelpDocumentsWithRevisions: fetchHelpDocumentsWithRevisions, fetchGlobalHelpDocuments: fetchGlobalHelpDocuments, globalHelpDocuments: globalHelpDocuments, helpDocuments: helpDocuments, errorMessage: errorMessage, successMessage: successMessage, dispatch: dispatch } = (0, $c807f91b5abb1e86$export$2e2bcd8739ae039)();
    const { fetchAllClients: fetchAllClients } = (0, $c400040bbf0b66f7$export$2e2bcd8739ae039)();
    const { searchQuery: searchQuery, updateSearchQuery: updateSearchQuery, isSearching: isSearching, setIsSearching: setIsSearching } = (0, $b48f023b055940c4$export$2e2bcd8739ae039)();
    const [redirectToAddDocument, setRedirectToAddDocument] = $ieT14.useState(false);
    const { clientId: clientId } = (0, $eYoAG.useParams)();
    const { modalIsOpen: modalIsOpen, openModal: openModal, closeModal: closeModal } = (0, $a7347f5558ecc977$export$2e2bcd8739ae039)();
    const { documentsWithoutRoot: documentsWithoutRoot } = (0, $dfbf579bea9f90b3$export$2e2bcd8739ae039)();
    $ieT14.useEffect(()=>{
        dispatch({
            loading: true
        });
        if (!clientId) Promise.all([
            fetchGlobalHelpDocuments(),
            fetchAllClients()
        ]).then(([helpDocuments, clientList])=>{
            dispatch({
                clientList: clientList.results,
                loading: false
            });
        });
        else Promise.all([
            fetchHelpDocumentsWithRevisions(),
            fetchGlobalHelpDocuments(false, true)
        ]).then(()=>dispatch({
                loading: false
            }));
    }, []);
    if (redirectToAddDocument) {
        if (!clientId) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Redirect), {
            push: true,
            to: {
                pathname: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).AddGlobalHelpDocument
            }
        });
        else return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Redirect), {
            push: true,
            to: {
                pathname: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).AddClientHelpDocument.replace(':clientId', clientId)
            }
        });
    }
    const mappedDocuments = helpDocuments.rootId ? documentsWithoutRoot(helpDocuments).filter((document)=>document.data.clientId === -1).map((document)=>document.data) : [];
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $2b36415f25d48604$export$79191b5aedbf24d4,
        children: [
            errorMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $cd9e5d573af72510$export$2e2bcd8739ae039), {
                message: errorMessage
            }),
            successMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $00b96652cf9f9fb7$export$2e2bcd8739ae039), {
                message: successMessage
            }),
            clientId && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3c302b0d44a45917$export$2e2bcd8739ae039), {
                isOpen: modalIsOpen,
                onClose: closeModal,
                title: 'Map Document to Clients',
                width: "345px",
                children: clientId && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8ccaf37a2b253d5d$export$2e2bcd8739ae039), {
                    globalHelpDocuments: globalHelpDocuments,
                    mappedDocuments: mappedDocuments,
                    closeModal: closeModal
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $2b36415f25d48604$export$38e42c68cf43b5d4,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column'
                        },
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    paddingRight: '10px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("h1", {
                                        children: [
                                            !clientId ? 'Global ' : '',
                                            "Help Documentation"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f5afe0f42548a953$export$2e2bcd8739ae039), {
                                        text: "Add a Document",
                                        title: "Add a Document",
                                        handleClick: ()=>setRedirectToAddDocument(true)
                                    })
                                ]
                            }),
                            clientId && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fcd3b8c5e9a7038b$export$2e2bcd8739ae039), {
                                text: "Document Mapping",
                                handleClick: openModal
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $00cebbc6f72b4773$export$2e2bcd8739ae039), {
                        value: searchQuery,
                        updateValue: (val)=>updateSearchQuery(val),
                        setIsSearching: (searching)=>setIsSearching(searching),
                        placeholder: 'Help Documentation'
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $2b36415f25d48604$export$c4b0f5819f6a6663,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
            }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $c46f303aaa525c96$export$2e2bcd8739ae039), {
                searchQuery: searchQuery,
                isSearching: isSearching,
                setIsSearching: (searching)=>setIsSearching(searching)
            })
        ]
    });
};
var $4c3bb60c07737b6c$export$2e2bcd8739ae039 = $4c3bb60c07737b6c$var$ClientHelpDocuments;



parcelRequire("ieT14");


var $ieT14 = parcelRequire("ieT14");

var $fRnKy = parcelRequire("fRnKy");
var $bf430c8d4ddc7049$export$38e42c68cf43b5d4;
var $bf430c8d4ddc7049$export$12137be6a76729c3;
$bf430c8d4ddc7049$export$38e42c68cf43b5d4 = `nwSluW_header`;
$bf430c8d4ddc7049$export$12137be6a76729c3 = `nwSluW_primaryFormActions`;










var $8FQwk = parcelRequire("8FQwk");


var $ieT14 = parcelRequire("ieT14");





/**
 * @function useHelpDocumentManagement - Custom hook for the document management page
 */ const $e58898431820526c$var$useHelpDocumentManagement = ()=>{
    const { successMessage: successMessage, dispatch: dispatch, activeDocumentId: activeDocumentId } = $ieT14.useContext((0, $524bc7b3eb0618a2$export$a7348e1183383d51));
    const { errorMessage: errorMessage, successMessage: message, setSuccessMessage: setSuccessMessage } = (0, $dc97b0794e0fd33b$export$2e2bcd8739ae039)();
    const { getAuth: getAuth, postAuth: postAuth, postFileAuth: postFileAuth, putAuth: putAuth } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    $ieT14.useEffect(()=>{
        dispatch({
            successMessage: message
        });
    }, [
        message
    ]);
    // Clears success message after interval if success message is present on page load
    $ieT14.useEffect(()=>{
        const timer = setTimeout(()=>{
            if (successMessage) dispatch({
                successMessage: ''
            });
        }, 5000);
        return ()=>{
            if (timer) clearTimeout(timer);
        };
    }, [
        successMessage
    ]);
    /**
   * @function fetchGlobalDocument - Fetches a global document
   * @param documentId - the snippetId of the document to fetch
   */ const fetchGlobalDocument = (documentId)=>{
        return getAuth(`api/help-documents/${documentId}`);
    };
    /**
   * @function fetchClientDocument - Fetches a client document
   * @param clientId - Unique identifier for the client
   * @param documentId - the snippetId of the document to fetch
   */ const fetchClientDocument = (clientId, documentId)=>{
        return getAuth(`api/clients/${clientId}/help-documents/${documentId}`);
    };
    /**
   * @function fetchGlobalDocumentFromClient - Fetches a client document
   * @param clientId - Unique identifier for the client
   * @param documentId - the snippetId of the document to fetch
   */ const fetchGlobalDocumentFromClient = (clientId, documentId)=>{
        return getAuth(`api/clients/${clientId}/help-documents/global/${documentId}`);
    };
    /**
   * @function saveGlobalDocument - Create or save a new global document
   * @param document - the new document to create
   */ const saveGlobalDocument = (document)=>{
        return postAuth('api/help-documents', document);
    };
    /**
   * @function saveClientDocument - Create or save a new client document
   * @param document - the new document to create
   */ const saveClientDocument = (document, clientId)=>{
        return postAuth(`api/clients/${clientId}/help-documents`, document);
    };
    /**
   * @function publishGlobalDocument - Publish a revision of a global document
   * @param documentId - the snippetId of the document to publish
   */ const publishGlobalDocument = (documentId)=>{
        return putAuth(`api/help-documents/${documentId}/publish`, '');
    };
    /**
   * @function publishClientDocument - Publish a revision of a client document
   * @param clientId - the id of the client that owns the document
   * @param documentId - the snippetId of the document to publish
   */ const publishClientDocument = (clientId, documentId)=>{
        return putAuth(`api/clients/${clientId}/help-documents/${documentId}/publish`, '');
    };
    /**
   * @function uploadDocumentImage - Uploade an image for a document
   * @param image - the image file to upload
   */ const uploadDocumentImage = (image)=>{
        return postFileAuth('api/help-documents/image-upload', null, image);
    };
    const [loadingAssociatedData, setLoadingAssociatedData] = $ieT14.useState(true);
    const [tags, setTags] = $ieT14.useState([]);
    const [dashboards, setDashboards] = $ieT14.useState([]);
    const { fetchTags: fetchTags } = (0, $ddc981f711f942ee$export$2e2bcd8739ae039)();
    const { fetchAllDashboards: fetchAllDashboards } = (0, $11b569dffddc8c64$export$2e2bcd8739ae039)();
    /**
   * @function fetchAssociatedData - Get extra data needed to create/edit a document
   */ const fetchAssociatedData = (clientId)=>{
        if (!loadingAssociatedData) setLoadingAssociatedData(true);
        Promise.all([
            fetchTags(clientId),
            fetchAllDashboards(clientId)
        ]).then(([tags, dashboards])=>{
            setTags(tags);
            setDashboards(dashboards.results);
            setLoadingAssociatedData(false);
        });
    };
    return {
        fetchGlobalDocument: fetchGlobalDocument,
        fetchClientDocument: fetchClientDocument,
        fetchGlobalDocumentFromClient: fetchGlobalDocumentFromClient,
        saveGlobalDocument: saveGlobalDocument,
        saveClientDocument: saveClientDocument,
        publishGlobalDocument: publishGlobalDocument,
        publishClientDocument: publishClientDocument,
        uploadDocumentImage: uploadDocumentImage,
        fetchAssociatedData: fetchAssociatedData,
        loadingAssociatedData: loadingAssociatedData,
        tags: tags,
        dashboards: dashboards,
        successMessage: successMessage,
        errorMessage: errorMessage,
        setSuccessMessage: setSuccessMessage,
        activeDocumentId: activeDocumentId
    };
};
var $e58898431820526c$export$2e2bcd8739ae039 = $e58898431820526c$var$useHelpDocumentManagement;





var $eYoAG = parcelRequire("eYoAG");



var $fpdl2 = parcelRequire("fpdl2");


const $cb0991c7f4819f22$var$ManageHelpDocument = ({ document: document, isNewDocument: isNewDocument, isGlobal: isGlobal, loading: loading })=>{
    const { clientId: clientId, revisions: revisions } = (0, $eYoAG.useParams)();
    const history = (0, $eYoAG.useHistory)();
    const ManageDocumentSchema = $e6c1ba40263f5002$export$185802fd694ee1f5().shape({
        title: $55fd6d44ba3611c9$export$185802fd694ee1f5().required('Name is a required field.')
    });
    const tinyMcePlugins = 'autolink fullscreen image link media charmap insertdatetime lists advlist wordcount help code searchreplace table';
    const tinyMceToolbar = 'insertfile formatselect | bold italic underline strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat';
    const { saveGlobalDocument: saveGlobalDocument, saveClientDocument: saveClientDocument, publishClientDocument: publishClientDocument, publishGlobalDocument: publishGlobalDocument, fetchAssociatedData: fetchAssociatedData, loadingAssociatedData: loadingAssociatedData, tags: tags, dashboards: dashboards, successMessage: successMessage, setSuccessMessage: setSuccessMessage, activeDocumentId: activeDocumentId } = (0, $e58898431820526c$export$2e2bcd8739ae039)();
    const [unassignedTags, setUnassignedTags] = $ieT14.useState(tags);
    const [assignedTags, setAssignedTags] = $ieT14.useState([]);
    const [unassignedDashboards, setUnassignedDashboards] = $ieT14.useState(dashboards);
    const [assignedDashboards, setAssignedDashboards] = $ieT14.useState([]);
    const [displayDirtyWarning, setDisplayDirtyWarning] = $ieT14.useState(false);
    const [confirmedNavigation, setConfirmedNavigation] = $ieT14.useState(false);
    const [blockedLocation, setBlockedLocation] = $ieT14.useState('');
    const [initialValues, setInitialValues] = $ieT14.useState(document);
    const [isPublishing, setIsPublishing] = $ieT14.useState(false);
    const { errorMessage: errorMessage, setErrorMessage: setErrorMessage } = (0, $dc97b0794e0fd33b$export$2e2bcd8739ae039)();
    const [isDebouncing, setIsDebouncing] = $ieT14.useState(false);
    const [newDocument, setNewDocument] = $ieT14.useState(isNewDocument);
    const primaryEditorRef = $ieT14.useRef(null);
    const alternativeEditorRef = $ieT14.useRef(null);
    const unblock = (0, $ieT14.useRef)(null);
    const formikRef = (0, $ieT14.useRef)(null);
    $ieT14.useEffect(()=>{
        if (clientId) fetchAssociatedData(Number(clientId));
        unblock.current = history.block((location)=>{
            if (formikRef.current !== null && formikRef.current.dirty) {
                setDisplayDirtyWarning(true);
                setBlockedLocation(location.pathname);
                return false;
            } else unblock.current();
        });
    }, []);
    $ieT14.useEffect(()=>{
        setInitialValues(document);
        if (clientId) {
            if (!loadingAssociatedData) {
                setAssignedDashboards(document.dashboards);
                setAssignedTags(document.tags);
                const loadedDashboards = dashboards.filter((dashboard)=>!document.dashboards.map((dash)=>dash.reportId).includes(dashboard.reportId));
                setUnassignedDashboards(loadedDashboards);
                const loadedTags = tags.filter((tag)=>!document.tags.map((dash)=>dash.tagId).includes(tag.tagId));
                setUnassignedTags(loadedTags);
            }
        }
    }, [
        document,
        loadingAssociatedData
    ]);
    $ieT14.useEffect(()=>{
        if (confirmedNavigation) {
            unblock.current();
            history.push(blockedLocation);
        }
    }, [
        confirmedNavigation
    ]);
    $ieT14.useEffect(()=>{
        if (isPublishing && !initialValues.isPublished) handlePublish(initialValues.snippetId);
    }, [
        initialValues
    ]);
    const handleCancel = (dirty)=>{
        cancelAutoSave();
        if (!dirty) unblock.current();
        if (clientId) {
            if (revisions) history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).ViewClientHelpDocumentRevisions.replace(':clientId', clientId).replace(':snippetGroupId', initialValues.snippetGroupId.toString()));
            else history.push(`${(0, $4bbac098dba9d86f$export$2e2bcd8739ae039).ClientHelpDocuments.replace(':clientId', clientId)}/${activeDocumentId || ''}`);
        } else if (revisions) history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).ViewGlobalHelpDocumentRevisions.replace(':snippetGroupId', initialValues.snippetGroupId.toString()));
        else history.push(`${(0, $4bbac098dba9d86f$export$2e2bcd8739ae039).GlobalHelpDocuments}/${activeDocumentId || ''}`);
    };
    const handleGlobalPublish = async (snippetId)=>{
        try {
            const response = await publishGlobalDocument(snippetId);
            if (response.success) {
                setSuccessMessage(response.message);
                setInitialValues({
                    ...initialValues,
                    isPublished: true
                });
                if (!isNewDocument) history.replace(`${(0, $4bbac098dba9d86f$export$2e2bcd8739ae039).EditGlobalHelpDocument.replace(':snippetId', snippetId.toString())}${revisions ? '/revisions' : ''}`);
            } else setErrorMessage(response.message);
        } catch (err) {
            setErrorMessage(err.responseJSON.message);
        } finally{
            setIsPublishing(false);
        }
    };
    const handleClientPublish = async (snippetId)=>{
        try {
            const response = await publishClientDocument(Number(clientId), snippetId);
            if (response.success) {
                setSuccessMessage(response.message);
                setInitialValues({
                    ...initialValues,
                    isPublished: true
                });
                if (!isNewDocument) history.replace(`${(0, $4bbac098dba9d86f$export$2e2bcd8739ae039).EditClientHelpDocument.replace(':clientId', clientId).replace(':snippetId', snippetId.toString())}${revisions ? '/revisions' : ''}`);
            } else setErrorMessage(response.message);
        } catch (err) {
            setErrorMessage(err.responseJSON.message);
        } finally{
            setIsPublishing(false);
        }
    };
    const handlePublish = (snippetId)=>{
        if (isGlobal) handleGlobalPublish(snippetId);
        else handleClientPublish(snippetId);
    };
    const onSubmitSuccess = (documentSubmitted, response)=>{
        const name = documentSubmitted.title || `Document ${response.snippetGroupId}`;
        const action = newDocument ? 'added' : 'updated';
        setSuccessMessage(`${name} has been ${action}`);
        setInitialValues({
            ...document,
            snippetId: response.snippetId,
            snippetGroupId: response.snippetGroupId,
            isPublished: response.isPublished,
            revision: response.revision
        });
        if (newDocument) setNewDocument(false);
    };
    const callSubmitFunction = $ieT14.useCallback((func)=>func(), []);
    const startDebounce = $ieT14.useCallback($fRnKy.debounce(callSubmitFunction, 30000), []);
    const startAutoSave = (handleSubmitFunction)=>{
        setIsDebouncing(true);
        startDebounce(handleSubmitFunction);
    };
    const cancelAutoSave = ()=>{
        setIsDebouncing(false);
        startDebounce.cancel();
    };
    return loading ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        className: "loadingIndicator",
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
    }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $bf430c8d4ddc7049$export$38e42c68cf43b5d4,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("h1", {
                    children: [
                        newDocument ? 'Add' : 'Edit',
                        " ",
                        clientId ? 'Client' : 'Global',
                        " Document - Revision #",
                        initialValues.revision
                    ]
                })
            }),
            errorMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $cd9e5d573af72510$export$2e2bcd8739ae039), {
                message: errorMessage
            }),
            successMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $00b96652cf9f9fb7$export$2e2bcd8739ae039), {
                message: successMessage
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8FQwk.Formik), {
                innerRef: formikRef,
                enableReinitialize: true,
                initialValues: initialValues,
                validationSchema: ManageDocumentSchema,
                onSubmit: (doc, { resetForm: resetForm })=>{
                    const docCopy = $fRnKy.cloneDeep(doc);
                    doc.isPublished = false;
                    if (doc.feature === 'None') doc.feature = '';
                    const contentChanged = doc.content !== initialValues.content;
                    const alternativeChanged = doc.alternative !== initialValues.alternative;
                    doc.contentChanged = contentChanged;
                    doc.alternativeChanged = alternativeChanged;
                    if (!contentChanged) doc.content = null;
                    if (!alternativeChanged) doc.alternative = null;
                    if (!clientId || clientId && isGlobal && !newDocument) {
                        doc.titleChanged = true;
                        doc.dashboardChanged = false;
                        doc.tagsChanged = false;
                        doc.featureChanged = true;
                        if (clientId && isGlobal && !newDocument) {
                            doc.content = null;
                            doc.alternative = null;
                            doc.clientId = Number(clientId);
                            doc.titleChanged = false;
                            doc.dashboardChanged = true;
                            doc.tagsChanged = true;
                        }
                        saveGlobalDocument(doc).then((response)=>{
                            docCopy.revision = response.revision;
                            docCopy.snippetId = response.snippetId;
                            onSubmitSuccess(docCopy, response);
                            resetForm();
                        }).catch((err)=>{
                            setErrorMessage(err.responseJSON.message);
                            if (isPublishing) setIsPublishing(false);
                        });
                    } else {
                        doc.contentChanged = contentChanged;
                        doc.alternativeChanged = alternativeChanged;
                        doc.titleChanged = true;
                        doc.dashboardChanged = true;
                        doc.tagsChanged = true;
                        doc.featureChanged = true;
                        saveClientDocument(doc, clientId).then((response)=>{
                            docCopy.revision = response.revision;
                            docCopy.snippetId = response.snippetId;
                            onSubmitSuccess(docCopy, response);
                            resetForm();
                        }).catch((err)=>{
                            setErrorMessage(err.responseJSON.message);
                        });
                    }
                },
                children: ({ values: values, errors: errors, touched: touched, handleChange: handleChange, handleBlur: handleBlur, handleSubmit: handleSubmit, setFieldValue: setFieldValue, dirty: dirty, isValid: isValid })=>{
                    const contentIsDirty = values.title !== initialValues.title || values.content !== initialValues.content || values.alternative !== initialValues.alternative;
                    if ((!dirty || !isValid) && isDebouncing) cancelAutoSave();
                    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("form", {
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8FQwk.FormikConsumer), {
                                children: (formik)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $0ee6d6b77f108c47$export$2e2bcd8739ae039), {
                                        formik: formik,
                                        displayDirtyWarning: displayDirtyWarning,
                                        confirmNavigationWarning: ()=>{
                                            setConfirmedNavigation(true);
                                            history.push(blockedLocation);
                                        },
                                        cancleNavigationWarning: ()=>{
                                            startAutoSave(handleSubmit);
                                            setDisplayDirtyWarning(false);
                                        }
                                    })
                            }),
                            (!isGlobal && clientId || isGlobal && !clientId) && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $db32c8adf65b4dff$export$2e2bcd8739ae039), {
                                        id: "title",
                                        label: "Name",
                                        name: "title",
                                        onChange: (event)=>{
                                            startAutoSave(handleSubmit);
                                            handleChange(event);
                                        },
                                        onBlur: handleBlur,
                                        onKeyDown: (event)=>{
                                            // Prevents submit when pressing enter on title input
                                            if (event.keyCode === 13) event.preventDefault();
                                        },
                                        value: values.title || '',
                                        error: errors.title && touched.title,
                                        helperText: errors.title && touched.title && errors.title
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("fieldset", {
                                        className: `${$fdbf0d9f77db804d$export$a38812d1aa1302d9}`,
                                        children: [
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h5", {
                                                children: "Main Text"
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fb51feb4b146f19b$export$2e2bcd8739ae039), {
                                                editorRef: primaryEditorRef,
                                                init: {
                                                    content_css: (0, (/*@__PURE__*/$parcel$interopDefault($477d756f937b0d61$exports)))
                                                },
                                                initialValue: initialValues.content || '',
                                                setFieldValue: (field, value, shouldValidate)=>{
                                                    startAutoSave(handleSubmit);
                                                    setFieldValue(field, value, shouldValidate);
                                                },
                                                setField: "content",
                                                plugins: tinyMcePlugins,
                                                toolbar: tinyMceToolbar
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("fieldset", {
                                        className: `${$fdbf0d9f77db804d$export$a38812d1aa1302d9}`,
                                        children: [
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h5", {
                                                children: "Alternative Text"
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fb51feb4b146f19b$export$2e2bcd8739ae039), {
                                                editorRef: alternativeEditorRef,
                                                initialValue: initialValues.alternative || '',
                                                setFieldValue: (field, value, shouldValidate)=>{
                                                    startAutoSave(handleSubmit);
                                                    setFieldValue(field, value, shouldValidate);
                                                },
                                                setField: "alternative",
                                                plugins: tinyMcePlugins,
                                                toolbar: tinyMceToolbar
                                            })
                                        ]
                                    })
                                ]
                            }),
                            clientId && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("fieldset", {
                                className: `${$fdbf0d9f77db804d$export$a38812d1aa1302d9}`,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h5", {
                                        children: "Permission Tags"
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $624bea18a01be01c$export$2e2bcd8739ae039), {
                                        idField: "tagId",
                                        labelField: "name",
                                        left: unassignedTags,
                                        right: assignedTags,
                                        setLeft: setUnassignedTags,
                                        setRight: setAssignedTags,
                                        setFieldValue: (field, value, shouldValidate)=>{
                                            startAutoSave(handleSubmit);
                                            setFieldValue(field, value, shouldValidate);
                                        },
                                        setField: "tags"
                                    })
                                ]
                            }),
                            clientId && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("fieldset", {
                                className: `${$fdbf0d9f77db804d$export$a38812d1aa1302d9}`,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h5", {
                                        children: "Dashboards"
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $624bea18a01be01c$export$2e2bcd8739ae039), {
                                        idField: "reportId",
                                        labelField: "name",
                                        left: unassignedDashboards,
                                        right: assignedDashboards,
                                        setLeft: setUnassignedDashboards,
                                        setRight: setAssignedDashboards,
                                        setFieldValue: (field, value, shouldValidate)=>{
                                            startAutoSave(handleSubmit);
                                            setFieldValue(field, value, shouldValidate);
                                        },
                                        setField: "dashboards"
                                    })
                                ]
                            }),
                            (clientId && !isGlobal || isGlobal && !clientId) && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("fieldset", {
                                className: `${$fdbf0d9f77db804d$export$a38812d1aa1302d9}`,
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3cfd911fb57d1e56$export$2e2bcd8739ae039), {
                                    id: "feature",
                                    title: "Assigned Feature",
                                    value: values.feature || 'None',
                                    handleChange: (event)=>{
                                        startAutoSave(handleSubmit);
                                        handleChange(event);
                                    },
                                    handleBlur: handleBlur,
                                    options: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $ieT14.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("option", {
                                                value: "None",
                                                children: "None"
                                            }, "none"),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("option", {
                                                value: "Tableau",
                                                children: "Tableau"
                                            }, "Tableau")
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                className: $fdbf0d9f77db804d$export$135180a04c5d6085,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fcd3b8c5e9a7038b$export$2e2bcd8739ae039), {
                                        text: "Back",
                                        title: "Back",
                                        handleClick: ()=>handleCancel(dirty)
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                        className: $bf430c8d4ddc7049$export$12137be6a76729c3,
                                        children: [
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                                className: $fdbf0d9f77db804d$export$d675b3969e4857cb,
                                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $07d7e09497a42e25$export$2e2bcd8739ae039), {
                                                    text: "Publish",
                                                    title: "Publish",
                                                    deactive: !isValid || initialValues.isPublished && !contentIsDirty,
                                                    handleClick: (event)=>{
                                                        cancelAutoSave();
                                                        if (!dirty) handlePublish(values.snippetId);
                                                        else {
                                                            setIsPublishing(true);
                                                            handleSubmit(event);
                                                        }
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                                className: $fdbf0d9f77db804d$export$d675b3969e4857cb,
                                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $07d7e09497a42e25$export$2e2bcd8739ae039), {
                                                    text: "Save",
                                                    title: "Save",
                                                    deactive: !dirty || !isValid,
                                                    handleClick: (event)=>{
                                                        cancelAutoSave();
                                                        handleSubmit(event);
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    });
                }
            })
        ]
    });
};
var $cb0991c7f4819f22$export$2e2bcd8739ae039 = $cb0991c7f4819f22$var$ManageHelpDocument;


const $46466578ceca5add$var$AddClientDocument = ()=>{
    const defaultDocument = {
        feature: '',
        title: '',
        content: '',
        alternative: '',
        snippetId: -1,
        snippetGroupId: 0,
        revision: 0,
        clientId: -1,
        tags: [],
        dashboards: []
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $cb0991c7f4819f22$export$2e2bcd8739ae039), {
        document: defaultDocument,
        isNewDocument: true
    });
};
var $46466578ceca5add$export$2e2bcd8739ae039 = $46466578ceca5add$var$AddClientDocument;




var $ieT14 = parcelRequire("ieT14");



var $eYoAG = parcelRequire("eYoAG");
const $4a4e3fde644a6094$var$EditClientDocument = ()=>{
    const defaultDocument = {
        feature: '',
        title: '',
        content: '',
        alternative: '',
        snippetId: -1,
        snippetGroupId: 0,
        revision: 0,
        clientId: -1,
        tags: [],
        dashboards: []
    };
    const { clientId: clientId, snippetId: snippetId } = (0, $eYoAG.useParams)();
    const [loading, setLoading] = $ieT14.useState(true);
    const [document, setDocument] = $ieT14.useState(defaultDocument);
    const { fetchClientDocument: fetchClientDocument } = (0, $e58898431820526c$export$2e2bcd8739ae039)();
    $ieT14.useEffect(()=>{
        if (!loading) setLoading(true);
        fetchClientDocument(Number(clientId), Number(snippetId)).then((document)=>{
            setLoading(false);
            if (document) setDocument(document);
        }).catch((err)=>{
            console.log(err.responseJSON.message);
        });
    }, []);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $cb0991c7f4819f22$export$2e2bcd8739ae039), {
        document: document,
        loading: loading
    });
};
var $4a4e3fde644a6094$export$2e2bcd8739ae039 = $4a4e3fde644a6094$var$EditClientDocument;




var $ieT14 = parcelRequire("ieT14");



var $eYoAG = parcelRequire("eYoAG");
const $30682a56d7cd742d$var$EditGlobalDocument = ()=>{
    const defaultDocument = {
        feature: '',
        title: '',
        content: '',
        alternative: '',
        snippetId: -1,
        snippetGroupId: 0,
        revision: 0,
        clientId: -1,
        tags: [],
        dashboards: []
    };
    const { clientId: clientId, snippetId: snippetId } = (0, $eYoAG.useParams)();
    const [loading, setLoading] = $ieT14.useState(true);
    const [document, setDocument] = $ieT14.useState(defaultDocument);
    const { fetchGlobalDocument: fetchGlobalDocument, fetchGlobalDocumentFromClient: fetchGlobalDocumentFromClient } = (0, $e58898431820526c$export$2e2bcd8739ae039)();
    $ieT14.useEffect(()=>{
        if (!loading) setLoading(true);
        if (clientId) fetchGlobalDocumentFromClient(Number(clientId), Number(snippetId)).then((document)=>{
            setLoading(false);
            setDocument(document);
        }).catch((err)=>{
            console.log(err.responseJSON.message);
        });
        else fetchGlobalDocument(Number(snippetId)).then((document)=>{
            setLoading(false);
            setDocument(document);
        }).catch((err)=>{
            console.log(err.responseJSON.message);
        });
    }, []);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $cb0991c7f4819f22$export$2e2bcd8739ae039), {
        document: document,
        loading: loading,
        isGlobal: true
    });
};
var $30682a56d7cd742d$export$2e2bcd8739ae039 = $30682a56d7cd742d$var$EditGlobalDocument;




var $ieT14 = parcelRequire("ieT14");

var $eYoAG = parcelRequire("eYoAG");


var $ieT14 = parcelRequire("ieT14");
const $e48cd4f69810746a$var$defaultState = {
    loading: false,
    results: [],
    currentPage: 1,
    totalResults: 0,
    pageSize: 60,
    orderDirection: null,
    orderColumn: '',
    searchTerm: null
};
/** Context for sharing revisions results to be displayed in a paginated form */ const $e48cd4f69810746a$export$634861ef3b4272ed = /*#__PURE__*/ $ieT14.createContext(null);
const $e48cd4f69810746a$export$793c65621cb6de89 = $e48cd4f69810746a$export$634861ef3b4272ed.Consumer;
const $e48cd4f69810746a$export$86457176ea54894f = (props)=>{
    const [state, setState] = $ieT14.useState($e48cd4f69810746a$var$defaultState);
    const dispatch = (newValue)=>{
        setState((prevState)=>{
            return {
                ...prevState,
                ...newValue
            };
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($e48cd4f69810746a$export$634861ef3b4272ed.Provider, {
        value: {
            ...state,
            dispatch: dispatch
        },
        children: props.children
    });
};


var $6ad6a26fd264318c$export$3481c78889e8fbe8;
var $6ad6a26fd264318c$export$c4b0f5819f6a6663;
var $6ad6a26fd264318c$export$34e0f9847d4c02dd;
var $6ad6a26fd264318c$export$a7db06668cad9adb;
var $6ad6a26fd264318c$export$38e42c68cf43b5d4;
var $6ad6a26fd264318c$export$3f6d243f5dbc1961;
var $6ad6a26fd264318c$export$57ad902a600ecd80;
var $6ad6a26fd264318c$export$e7d47881ec916f76;
$6ad6a26fd264318c$export$3481c78889e8fbe8 = `G9Oliq_center`;
$6ad6a26fd264318c$export$c4b0f5819f6a6663 = `G9Oliq_circularProgress`;
$6ad6a26fd264318c$export$34e0f9847d4c02dd = `G9Oliq_container`;
$6ad6a26fd264318c$export$a7db06668cad9adb = `G9Oliq_content`;
$6ad6a26fd264318c$export$38e42c68cf43b5d4 = `G9Oliq_header`;
$6ad6a26fd264318c$export$3f6d243f5dbc1961 = `G9Oliq_resultsCount`;
$6ad6a26fd264318c$export$57ad902a600ecd80 = `G9Oliq_scrollTable`;
$6ad6a26fd264318c$export$e7d47881ec916f76 = `G9Oliq_tableWrapper`;




var $fpdl2 = parcelRequire("fpdl2");




var $ieT14 = parcelRequire("ieT14");



parcelRequire("ieT14");

var $eYoAG = parcelRequire("eYoAG");




var $ieT14 = parcelRequire("ieT14");

var $fRnKy = parcelRequire("fRnKy");



const $2d8debdc49649ca4$var$usePaginatedRevisions = ()=>{
    const { results: results, dispatch: dispatch } = $ieT14.useContext((0, $e48cd4f69810746a$export$634861ef3b4272ed));
    const { errorMessage: errorMessage, setErrorMessage: setErrorMessage, successMessage: successMessage, setSuccessMessage: setSuccessMessage } = (0, $dc97b0794e0fd33b$export$2e2bcd8739ae039)();
    const { getAuth: getAuth } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    /**
   * Gets a list of global revisions
   * @param documentId - the snippetId of the document to get the revisions for
   * @param currentPage - The page number for the revisions list
   * @param pageSize - The size of the revisions list
   */ const getGlobalRevisions = (documentId, currentPage, pageSize)=>{
        dispatch({
            loading: true
        });
        return getAuth(`api/help-documents/${documentId}/revisions?Page=${currentPage}&PageSize=${pageSize}&Sort=revision&SortDirection=desc`).then((response)=>{
            dispatch({
                currentPage: currentPage,
                pageSize: pageSize,
                results: response.results,
                totalResults: response.totalItems,
                loading: false
            });
        }).catch((err)=>{
            dispatch({
                loading: false
            });
            setErrorMessage(err.responseJSON.message);
        });
    };
    /**
   * Gets a list of all client document revisions
   * @param clientId - Unique identifier of the client
   * @param documentId - the snippetId of the document to get the revisions for
   * @param currentPage - The page number for the revisions list
   * @param pageSize - The size of the revisions list
   */ const getClientRevisions = (clientId, documentId, currentPage, pageSize)=>{
        dispatch({
            loading: true
        });
        return getAuth(`api/clients/${clientId}/help-documents/${documentId}/revisions?Page=${currentPage}&PageSize=${pageSize}&Sort=revision&SortDirection=desc`).then((response)=>{
            dispatch({
                currentPage: currentPage,
                pageSize: pageSize,
                results: response.results,
                totalResults: response.totalItems,
                loading: false
            });
        }).catch((err)=>{
            dispatch({
                loading: false
            });
            setErrorMessage(err.responseJSON.message);
        });
    };
    /**
   * Updates which revision is published in context
   * @param snippetId Identifier for a revision for a help document
   */ const updatePublishedRevision = (snippetId)=>{
        const revisions = $fRnKy.cloneDeep(results);
        const previousActiveIndex = revisions.findIndex((revision)=>revision.isActive);
        if (previousActiveIndex > -1) revisions[previousActiveIndex].isActive = false;
        const nextActiveIndex = revisions.findIndex((revisions)=>revisions.snippetId === snippetId);
        if (nextActiveIndex > -1) revisions[nextActiveIndex].isActive = true;
        dispatch({
            results: revisions
        });
    };
    return {
        getGlobalRevisions: getGlobalRevisions,
        updatePublishedRevision: updatePublishedRevision,
        errorMessage: errorMessage,
        setErrorMessage: setErrorMessage,
        successMessage: successMessage,
        setSuccessMessage: setSuccessMessage,
        getClientRevisions: getClientRevisions
    };
};
var $2d8debdc49649ca4$export$2e2bcd8739ae039 = $2d8debdc49649ca4$var$usePaginatedRevisions;



/**
 * Individual row for revisions
 */ const $12dc5b4068744d09$var$RevisionRow = ({ clientId: clientId, revision: revision, isGlobal: isGlobal, setErrorMessage: setErrorMessage, setSuccessMessage: setSuccessMessage })=>{
    const { publishClientDocument: publishClientDocument, publishGlobalDocument: publishGlobalDocument } = (0, $e58898431820526c$export$2e2bcd8739ae039)();
    const { updatePublishedRevision: updatePublishedRevision } = (0, $2d8debdc49649ca4$export$2e2bcd8739ae039)();
    const history = (0, $eYoAG.useHistory)();
    /**
   * Redirects to edit an individual revision
   */ const redirectToEditRevision = ()=>{
        if (!isGlobal) history.push(`${(0, $4bbac098dba9d86f$export$2e2bcd8739ae039).EditClientHelpDocument.replace(':clientId', clientId.toString()).replace(':snippetId', revision.snippetId.toString())}/revisions`);
        else history.push(`${(0, $4bbac098dba9d86f$export$2e2bcd8739ae039).EditGlobalHelpDocument.replace(':snippetId', revision.snippetId.toString())}/revisions`);
    };
    /**
   * Publishes the selected revision
   */ const publishRevision = ()=>{
        if (isGlobal) publishGlobalDocument(revision.snippetId).then(()=>{
            setSuccessMessage(`Help document is now published`);
            updatePublishedRevision(revision.snippetId);
        }).catch((err)=>setErrorMessage(err.responseJSON.message));
        else publishClientDocument(Number(clientId), revision.snippetId).then(()=>{
            setSuccessMessage(`${revision.snippetId} is now published`);
            updatePublishedRevision(revision.snippetId);
        }).catch((err)=>setErrorMessage(err.responseJSON.message));
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                children: revision.revNumber
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                title: revision.modifiedBy,
                children: revision.modifiedBy
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                title: revision.modifiedTimeFriendly,
                children: revision.modifiedTimeFriendly
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fcd3b8c5e9a7038b$export$2e2bcd8739ae039), {
                    text: "Edit",
                    title: "",
                    handleClick: redirectToEditRevision
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("td", {
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fcd3b8c5e9a7038b$export$2e2bcd8739ae039), {
                        text: "Publish",
                        title: "",
                        handleClick: publishRevision
                    }),
                    revision.isActive && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($54e71f1fe288f634$exports))), {
                        style: {
                            position: 'absolute',
                            color: '#65b500',
                            height: '18px',
                            width: '18px',
                            marginLeft: '5px'
                        }
                    })
                ]
            })
        ]
    });
};
var $12dc5b4068744d09$export$2e2bcd8739ae039 = $12dc5b4068744d09$var$RevisionRow;







/**
 * Table that contains all revisions for an individual help document
 */ const $6c83acd967fa44e1$var$RevisionsTable = ({ clientId: clientId, loading: loading, isGlobal: isGlobal, setErrorMessage: setErrorMessage, setSuccessMessage: setSuccessMessage })=>{
    const { results: results } = $ieT14.useContext((0, $e48cd4f69810746a$export$634861ef3b4272ed));
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        className: $6ad6a26fd264318c$export$e7d47881ec916f76,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
            style: {
                height: '90%'
            },
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5d10f0a7aadd7c8c$exports))), {
                className: $6ad6a26fd264318c$export$57ad902a600ecd80,
                autoHide: true,
                universal: true,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $0cbf74840f7b6287$export$2e2bcd8739ae039), {
                    loading: loading,
                    results: results,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $0cd938f964be002d$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                    title: "Revision #",
                                    scope: "col"
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                    title: "Modified By",
                                    scope: "col"
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                    title: "Modified Date",
                                    scope: "col"
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                    title: ""
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                    title: ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $a282f935ed3e599f$export$2e2bcd8739ae039), {
                            children: !results || results.length === 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                    children: "There are no revisions."
                                })
                            }) : results.map((result, index)=>{
                                return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $12dc5b4068744d09$export$2e2bcd8739ae039), {
                                    clientId: clientId,
                                    revision: result,
                                    isGlobal: isGlobal,
                                    setErrorMessage: setErrorMessage,
                                    setSuccessMessage: setSuccessMessage
                                }, result.snippetId);
                            })
                        })
                    ]
                })
            })
        })
    });
};
var $6c83acd967fa44e1$export$2e2bcd8739ae039 = $6c83acd967fa44e1$var$RevisionsTable;




const $285438b7d136a22f$var$ManageRevisions = ({ isGlobal: isGlobal })=>{
    const { snippetGroupId: snippetGroupId, clientId: clientId } = (0, $eYoAG.useParams)();
    const { loading: loading, results: results, pageSize: pageSize, currentPage: currentPage, totalResults: totalResults } = $ieT14.useContext((0, $e48cd4f69810746a$export$634861ef3b4272ed));
    const { getGlobalRevisions: getGlobalRevisions, getClientRevisions: getClientRevisions, successMessage: successMessage, errorMessage: errorMessage, setSuccessMessage: setSuccessMessage, setErrorMessage: setErrorMessage } = (0, $2d8debdc49649ca4$export$2e2bcd8739ae039)();
    const { measuredRef: measuredRef, dimensions: dimensions } = (0, $d9ed1b1da5a3379c$export$2e2bcd8739ae039)([
        results,
        successMessage,
        errorMessage
    ], true);
    $ieT14.useEffect(()=>{
        if (isGlobal) getGlobalRevisions(Number(snippetGroupId), currentPage, pageSize);
        else getClientRevisions(Number(clientId), Number(snippetGroupId), currentPage, pageSize);
    }, []);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $6ad6a26fd264318c$export$34e0f9847d4c02dd,
        children: [
            successMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $00b96652cf9f9fb7$export$2e2bcd8739ae039), {
                message: successMessage
            }),
            errorMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $cd9e5d573af72510$export$2e2bcd8739ae039), {
                message: errorMessage
            }),
            loading && results.length === 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $6ad6a26fd264318c$export$c4b0f5819f6a6663,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
            }) : !results || results.length === 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                children: "There are no revisions."
            }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $6ad6a26fd264318c$export$3481c78889e8fbe8,
                ref: measuredRef,
                style: {
                    height: `calc(100vh - ${dimensions ? 20 + dimensions.top : 0}px`
                },
                children: [
                    loading && results.length > 0 || loading && results.length === 0 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: $6ad6a26fd264318c$export$c4b0f5819f6a6663,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        className: $6ad6a26fd264318c$export$a7db06668cad9adb,
                        style: {
                            height: `calc(100vh - ${dimensions ? 20 + dimensions.top : 0}px`
                        },
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                                    className: $6ad6a26fd264318c$export$3f6d243f5dbc1961,
                                    children: [
                                        totalResults,
                                        " results"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6c83acd967fa44e1$export$2e2bcd8739ae039), {
                                clientId: Number(clientId),
                                loading: loading,
                                isGlobal: isGlobal,
                                setSuccessMessage: setSuccessMessage,
                                setErrorMessage: setErrorMessage
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f021d555e7f7d483$export$2e2bcd8739ae039), {
                        fetchResults: ({ pageSize: pageSize, currentPage: currentPage })=>{
                            if (isGlobal) getGlobalRevisions(Number(snippetGroupId), currentPage, pageSize);
                            else getClientRevisions(Number(clientId), Number(snippetGroupId), currentPage, pageSize);
                        },
                        paginatedContext: (0, $e48cd4f69810746a$export$634861ef3b4272ed),
                        searchTerm: '',
                        fetchExtraProps: {
                            clientId: clientId
                        }
                    })
                ]
            })
        ]
    });
};
var $285438b7d136a22f$export$2e2bcd8739ae039 = $285438b7d136a22f$var$ManageRevisions;





var $ieT14 = parcelRequire("ieT14");





var $9797c5824a56476a$export$c4b0f5819f6a6663;
var $9797c5824a56476a$export$34e0f9847d4c02dd;
var $9797c5824a56476a$export$a7db06668cad9adb;
var $9797c5824a56476a$export$38e42c68cf43b5d4;
var $9797c5824a56476a$export$3f6d243f5dbc1961;
var $9797c5824a56476a$export$57ad902a600ecd80;
var $9797c5824a56476a$export$e7d47881ec916f76;
$9797c5824a56476a$export$c4b0f5819f6a6663 = `zbWQPa_circularProgress`;
$9797c5824a56476a$export$34e0f9847d4c02dd = `zbWQPa_container`;
$9797c5824a56476a$export$a7db06668cad9adb = `zbWQPa_content`;
$9797c5824a56476a$export$38e42c68cf43b5d4 = `zbWQPa_header`;
$9797c5824a56476a$export$3f6d243f5dbc1961 = `zbWQPa_resultsCount`;
$9797c5824a56476a$export$57ad902a600ecd80 = `zbWQPa_scrollTable`;
$9797c5824a56476a$export$e7d47881ec916f76 = `zbWQPa_tableWrapper`;



parcelRequire("ieT14");



var $eYoAG = parcelRequire("eYoAG");

const $3105928a1c9b665f$var$ClientUserEntry = ({ user: user })=>{
    const history = (0, $eYoAG.useHistory)();
    const redirectToEditUserId = (userId)=>{
        history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).EditUser.replace(':userId', userId));
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("td", {
                children: [
                    user.lastName,
                    ", ",
                    user.firstName
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                children: user.role
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                title: user.email,
                children: user.email
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                title: user.department,
                children: user.department
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                children: (0, $2b84cffcdcc80653$export$53a7de2d42d4bd9e)[user.status] === 'Active' ? 'ACTIVE' : 'INACTIVE'
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fcd3b8c5e9a7038b$export$2e2bcd8739ae039), {
                    text: "Edit User",
                    title: "Edit User",
                    handleClick: ()=>redirectToEditUserId(user.id)
                })
            })
        ]
    });
};
var $3105928a1c9b665f$export$2e2bcd8739ae039 = $3105928a1c9b665f$var$ClientUserEntry;



var $fpdl2 = parcelRequire("fpdl2");




const $7fdac64985cfca49$var$useClientUser = ()=>{
    const { fetchUser: fetchUser } = (0, $b19aa392df0f3838$export$2e2bcd8739ae039)();
    /**
   * @function fetchUsersDetails fetch user data for each user in Client.assignedUsers array
   */ const fetchUsersDetails = (assignedUsers)=>{
        const promises = [];
        assignedUsers.forEach((user)=>{
            promises.push(fetchUser(user.id));
        });
        return Promise.all(promises);
    };
    /**
   * @function userSort sort the array of users by a given property. If property values are boolean, first sort by name.
   * @param users array of User objects to sort
   * @param property User property to sort on
   * @param direction sort direction: 'asc' or 'desc'
   */ const userSort = (users, property, direction)=>{
        if (typeof users[0][property] == 'string') return users.sort((a, b)=>{
            if (a[property].toUpperCase() < b[property].toUpperCase()) {
                if (direction == 'asc') return -1;
                else if (direction == 'desc') return 1;
            }
            if (a[property].toUpperCase() > b[property].toUpperCase()) {
                if (direction == 'asc') return 1;
                else if (direction == 'desc') return -1;
            }
            return 0;
        });
        else if (typeof users[0][property] == 'boolean') {
            const nameSorted = userSort(users, 'lastName', 'asc');
            if (direction == 'asc') return nameSorted.sort((a, b)=>Number(a.status) - Number(b.status));
            if (direction == 'desc') return nameSorted.sort((a, b)=>Number(b.status) - Number(a.status));
        }
    };
    return {
        userSort: userSort,
        fetchUsersDetails: fetchUsersDetails
    };
};
var $7fdac64985cfca49$export$2e2bcd8739ae039 = $7fdac64985cfca49$var$useClientUser;


/**
 * ClientUsersTable - fetch individual user data and display table of current client's users
 */ const $b786b2c8a4bf1859$var$ClientUsersTable = ({ assignedUsers: assignedUsers, assignedAdministrators: assignedAdministrators })=>{
    const [loading, setLoading] = $ieT14.useState(true);
    const [users, setUsers] = $ieT14.useState(null);
    const [sort, setSort] = $ieT14.useState({
        sortColumn: (0, $fe0b3f9952d5826a$export$a0189e346cd07222).Name,
        direction: 'asc'
    });
    const { errorMessage: errorMessage, setErrorMessage: setErrorMessage } = (0, $dc97b0794e0fd33b$export$2e2bcd8739ae039)();
    const { userSort: userSort, fetchUsersDetails: fetchUsersDetails } = (0, $7fdac64985cfca49$export$2e2bcd8739ae039)();
    $ieT14.useEffect(()=>{
        const allUsers = [
            ...assignedUsers,
            ...assignedAdministrators
        ];
        if (allUsers.length > 0) fetchUsersDetails(allUsers).then((users)=>{
            setUsers(userSort(users, sort.sortColumn, sort.direction));
            setLoading(false);
        }).catch((err)=>{
            setErrorMessage(err);
            setLoading(false);
        });
        else {
            setUsers([]);
            setLoading(false);
        }
    }, []);
    const reorderHandler = (orderColumn, orderDirection)=>{
        setUsers(userSort(users, orderColumn, orderDirection));
        setSort({
            sortColumn: orderColumn,
            direction: orderDirection
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $9797c5824a56476a$export$34e0f9847d4c02dd,
        children: [
            errorMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $cd9e5d573af72510$export$2e2bcd8739ae039), {
                message: errorMessage
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $9797c5824a56476a$export$38e42c68cf43b5d4,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h1", {
                    children: "Users"
                })
            }),
            loading ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $9797c5824a56476a$export$c4b0f5819f6a6663,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
            }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $9797c5824a56476a$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                            className: $9797c5824a56476a$export$3f6d243f5dbc1961,
                            children: [
                                users.length,
                                " users"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5d10f0a7aadd7c8c$exports))), {
                        className: $9797c5824a56476a$export$57ad902a600ecd80,
                        autoHide: true,
                        universal: true,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $0cbf74840f7b6287$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $0cd938f964be002d$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                            title: "Name",
                                            scope: "col",
                                            orderField: (0, $fe0b3f9952d5826a$export$a0189e346cd07222).Name,
                                            orderColumn: sort.sortColumn,
                                            orderDirection: sort.direction,
                                            reorderHandler: reorderHandler
                                        }),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                            title: "User Type",
                                            scope: "col",
                                            orderField: (0, $fe0b3f9952d5826a$export$a0189e346cd07222).UserType,
                                            orderColumn: sort.sortColumn,
                                            orderDirection: sort.direction,
                                            reorderHandler: reorderHandler
                                        }),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                            title: "Email",
                                            scope: "col",
                                            orderField: (0, $fe0b3f9952d5826a$export$a0189e346cd07222).Email,
                                            orderColumn: sort.sortColumn,
                                            orderDirection: sort.direction,
                                            reorderHandler: reorderHandler
                                        }),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                            title: "Company",
                                            scope: "col",
                                            orderField: (0, $fe0b3f9952d5826a$export$a0189e346cd07222).Department,
                                            orderColumn: sort.sortColumn,
                                            orderDirection: sort.direction,
                                            reorderHandler: reorderHandler
                                        }),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                            title: "Status",
                                            scope: "col",
                                            orderField: (0, $fe0b3f9952d5826a$export$a0189e346cd07222).Status,
                                            orderColumn: sort.sortColumn,
                                            orderDirection: sort.direction,
                                            reorderHandler: reorderHandler
                                        }),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $24e3ac690c79ee75$export$2e2bcd8739ae039), {
                                            title: ""
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $a282f935ed3e599f$export$2e2bcd8739ae039), {
                                    children: !users || users.length == 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                            children: "No users are assigned to this client"
                                        })
                                    }) : users.map((user, index)=>{
                                        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3105928a1c9b665f$export$2e2bcd8739ae039), {
                                            user: user
                                        }, index);
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $b786b2c8a4bf1859$export$2e2bcd8739ae039 = $b786b2c8a4bf1859$var$ClientUsersTable;



var $fgoQ6 = parcelRequire("fgoQ6");


var $fpdl2 = parcelRequire("fpdl2");
var $cecER = parcelRequire("cecER");
var $aIJrd = parcelRequire("aIJrd");

var $ieT14 = parcelRequire("ieT14");

const $5dc1edca8aaa6139$var$useSnowflakeProperties = ()=>{
    const { getAuth: getAuth, putAuth: putAuth } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    const fetchSnowflakeProperties = (clientId)=>{
        return getAuth(`api/clients/${clientId}/snowflake-properties`).then((snowflakeProperties)=>{
            return snowflakeProperties;
        });
    };
    const editSnowflakeProperties = (clientId, snowflakeProperties)=>{
        return putAuth(`api/clients/${clientId}/snowflake-properties`, snowflakeProperties);
    };
    return {
        fetchSnowflakeProperties: fetchSnowflakeProperties,
        editSnowflakeProperties: editSnowflakeProperties
    };
};
var $5dc1edca8aaa6139$export$2e2bcd8739ae039 = $5dc1edca8aaa6139$var$useSnowflakeProperties;



var $8FQwk = parcelRequire("8FQwk");




var $eYoAG = parcelRequire("eYoAG");





const $30368fe5b11d84b8$var$SnowflakeSchema = $e6c1ba40263f5002$export$185802fd694ee1f5().shape({
    snowflakeAccountName: $55fd6d44ba3611c9$export$185802fd694ee1f5().matches(/^[^;]+$/, 'Snowflake account name cannot have a semicolon').required('Snowflake account name is a required field.').max(50, 'Snowflake account name must be less than 50 characters'),
    snowflakeDatabaseName: $55fd6d44ba3611c9$export$185802fd694ee1f5().matches(/^[^;]+$/, 'Snowflake database name cannot have a semicolon').required('Snowflake database name is a required field.').max(50, 'Snowflake database name must be less than 50 characters'),
    snowflakeRoleName: $55fd6d44ba3611c9$export$185802fd694ee1f5().matches(/^[^;]+$/, 'Snowflake role name cannot have a semicolon').required('Snowflake role name is a required field.').max(50, 'Snowflake role name must be less than 50 characters'),
    snowflakeWarehouseName: $55fd6d44ba3611c9$export$185802fd694ee1f5().matches(/^[^;]+$/, 'Snowflake warehouse name cannot have a semicolon').max(50, 'Snowflake warehouse name must be less than 50 characters').nullable()
});
const $30368fe5b11d84b8$var$SnowflakeInfo = (0, $aIJrd.default)({
    root: {
        fontSize: 10,
        margin: '-5px 15px 0'
    }
})((0, $cecER.default));
const $30368fe5b11d84b8$var$Snowflake = ({ clientId: clientId })=>{
    const { fetchSnowflakeProperties: fetchSnowflakeProperties, editSnowflakeProperties: editSnowflakeProperties } = (0, $5dc1edca8aaa6139$export$2e2bcd8739ae039)();
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useState(true);
    const [errorMessage, setErrorMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useState('');
    const formikRef = (0, $ieT14.useRef)(null);
    const unblock = (0, $ieT14.useRef)(null);
    const history = (0, $eYoAG.useHistory)();
    const [snowflakeProperties, setSnowflakeProperties] = (0, $ieT14.useState)({
        snowflakeAccountName: '',
        snowflakeDatabaseName: '',
        snowflakeRoleName: '',
        snowflakeWarehouseName: ''
    });
    const [displayDirtyWarning, setDisplayDirtyWarning] = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useState(false);
    const [confirmedNavigation, setConfirmedNavigation] = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useState(false);
    const [blockedLocation, setBlockedLocation] = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useState('');
    (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useEffect(()=>{
        fetchSnowflakeProperties(clientId.toString()).then((snowflakeProperties)=>{
            setSnowflakeProperties({
                snowflakeAccountName: snowflakeProperties.snowflakeAccountName ?? '',
                snowflakeDatabaseName: snowflakeProperties.snowflakeDatabaseName ?? '',
                snowflakeRoleName: snowflakeProperties.snowflakeRoleName ?? '',
                snowflakeWarehouseName: snowflakeProperties.snowflakeWarehouseName ?? ''
            });
            setLoading(false);
        });
        unblock.current = history.block((location)=>{
            if (formikRef.current.dirty) {
                setDisplayDirtyWarning(true);
                setBlockedLocation(location.pathname);
                return false;
            } else unblock.current();
        });
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useEffect(()=>{
        if (confirmedNavigation) {
            unblock.current();
            history.push(blockedLocation);
        }
    }, [
        confirmedNavigation
    ]);
    const handleCancel = (dirty)=>{
        history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Clients);
    };
    if (loading) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        className: "loadingIndicator",
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
    });
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        children: [
            errorMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $cd9e5d573af72510$export$2e2bcd8739ae039), {
                message: errorMessage
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h1", {
                children: "Edit Snowflake Configuration"
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8FQwk.Formik), {
                innerRef: formikRef,
                initialValues: snowflakeProperties,
                validationSchema: $30368fe5b11d84b8$var$SnowflakeSchema,
                onSubmit: async (values, { setSubmitting: setSubmitting })=>{
                    setSubmitting(true);
                    try {
                        const response = await editSnowflakeProperties(clientId.toString(), values);
                        if (!response.success) throw Error(`Failed to update Snowflake properties: ${response.message}`);
                        setSubmitting(false);
                        unblock.current();
                        history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Clients);
                    } catch (err) {
                        if (err instanceof Error) setErrorMessage(err.message);
                        else setErrorMessage(err.responseJSON.message);
                        setSubmitting(false);
                    }
                },
                children: ({ values: values, errors: errors, touched: touched, handleChange: handleChange, handleBlur: handleBlur, handleSubmit: handleSubmit, isSubmitting: isSubmitting, dirty: dirty })=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("form", {
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8FQwk.FormikConsumer), {
                                children: (formik)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $0ee6d6b77f108c47$export$2e2bcd8739ae039), {
                                        formik: formik,
                                        displayDirtyWarning: displayDirtyWarning,
                                        confirmNavigationWarning: ()=>{
                                            setConfirmedNavigation(true);
                                            history.push(blockedLocation);
                                        },
                                        cancleNavigationWarning: ()=>setDisplayDirtyWarning(false)
                                    })
                            }),
                            isSubmitting && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                className: $fdbf0d9f77db804d$export$29dd17c7f3c81c36,
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                    className: $fdbf0d9f77db804d$export$9a0dd4d839a90927,
                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("fieldset", {
                                className: $fdbf0d9f77db804d$export$a38812d1aa1302d9,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $db32c8adf65b4dff$export$2e2bcd8739ae039), {
                                        id: "snowflakeAccountName",
                                        label: "Snowflake Account Name",
                                        name: "snowflakeAccountName",
                                        onChange: handleChange,
                                        onBlur: handleBlur,
                                        value: values.snowflakeAccountName ?? '',
                                        error: errors.snowflakeAccountName && touched.snowflakeAccountName,
                                        helperText: errors.snowflakeAccountName && touched.snowflakeAccountName && errors.snowflakeAccountName,
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($30368fe5b11d84b8$var$SnowflakeInfo, {
                                        children: "Snowflake Account Locator where customer database is located"
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $db32c8adf65b4dff$export$2e2bcd8739ae039), {
                                        id: "snowflakeRoleName",
                                        label: "Snowflake Role Name",
                                        name: "snowflakeRoleName",
                                        onChange: handleChange,
                                        onBlur: handleBlur,
                                        value: values.snowflakeRoleName ?? '',
                                        error: errors.snowflakeRoleName && touched.snowflakeRoleName,
                                        helperText: errors.snowflakeRoleName && touched.snowflakeRoleName && errors.snowflakeRoleName,
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($30368fe5b11d84b8$var$SnowflakeInfo, {
                                        children: 'Snowflake role which is set up for the portal to query data.  E.g. <Client><Env>_PORTAL'
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $db32c8adf65b4dff$export$2e2bcd8739ae039), {
                                        id: "snowflakeDatabaseName",
                                        label: "Snowflake Database Name",
                                        name: "snowflakeDatabaseName",
                                        onChange: handleChange,
                                        onBlur: handleBlur,
                                        value: values.snowflakeDatabaseName ?? '',
                                        error: errors.snowflakeDatabaseName && touched.snowflakeDatabaseName,
                                        helperText: errors.snowflakeDatabaseName && touched.snowflakeDatabaseName && errors.snowflakeDatabaseName,
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($30368fe5b11d84b8$var$SnowflakeInfo, {
                                        children: "Snowflake Database where customer data is"
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $db32c8adf65b4dff$export$2e2bcd8739ae039), {
                                        id: "snowflakeWarehouseName",
                                        label: "Snowflake Warehouse Name",
                                        onChange: handleChange,
                                        onBlur: handleBlur,
                                        value: values.snowflakeWarehouseName ?? '',
                                        error: errors.snowflakeWarehouseName && touched.snowflakeWarehouseName,
                                        helperText: errors.snowflakeWarehouseName && touched.snowflakeWarehouseName && errors.snowflakeWarehouseName
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($30368fe5b11d84b8$var$SnowflakeInfo, {
                                        children: "Snowflake warehouse used for compute by the portal"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                className: $fdbf0d9f77db804d$export$135180a04c5d6085,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fcd3b8c5e9a7038b$export$2e2bcd8739ae039), {
                                        text: "Cancel",
                                        title: "Cancel",
                                        handleClick: ()=>{
                                            handleCancel(dirty);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                        className: $fdbf0d9f77db804d$export$d675b3969e4857cb,
                                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $07d7e09497a42e25$export$2e2bcd8739ae039), {
                                            text: "Save",
                                            title: "Save",
                                            deactive: isSubmitting,
                                            handleClick: handleSubmit
                                        })
                                    })
                                ]
                            })
                        ]
                    })
            })
        ]
    });
};
var $30368fe5b11d84b8$export$2e2bcd8739ae039 = $30368fe5b11d84b8$var$Snowflake;



/**
 * AdminClient
 * Outer Component for the client management area, renders the header and secondary navigation, routes the secondary navigation views.
 */ const $053de9380ceb4e28$var$AdminClient = ()=>{
    const { clientId: clientId } = (0, $eYoAG.useParams)();
    const [loading, setLoading] = $ieT14.useState(true);
    const [client, setClient] = $ieT14.useState(null);
    const { fetchClient: fetchClient } = (0, $c400040bbf0b66f7$export$2e2bcd8739ae039)();
    const breadcrumbs = [
        {
            title: (0, $e3b999dd4e075081$export$2e2bcd8739ae039).Clients,
            path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Home
        }
    ];
    const currentPath = (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).EditClient.replace(':clientId', clientId);
    const [fetchError, setFetchError] = $ieT14.useState('');
    const { getCurrentUser: getCurrentUser } = (0, $b19aa392df0f3838$export$2e2bcd8739ae039)();
    const [userRole, setUserRole] = $ieT14.useState('');
    // Fetches the client information for the page on mount
    $ieT14.useEffect(()=>{
        Promise.all([
            fetchClient(clientId),
            getCurrentUser()
        ]).then(([client, user])=>{
            if (client) setClient(client);
            else setFetchError(`Error: Failed to load client ${clientId}`);
            setUserRole(user?.role);
            setLoading(false);
        }).catch((err)=>{
            console.log(err);
            setFetchError(err);
        });
    }, []);
    if (loading) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        className: "loadingIndicator",
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
    });
    else if (fetchError) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
            type: "error",
            message: fetchError
        })
    });
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $77e47b6bc9169ce7$export$cc74dcc53cfce4eb,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.Breadcrumbs), {
                        currentPage: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h1", {
                            children: client.name
                        }),
                        breadcrumbs: breadcrumbs
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $af06fc2defd6d844$export$2e2bcd8739ae039), {
                        clientId: client.clientId,
                        userRole: userRole
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $77e47b6bc9169ce7$export$f22da7240b7add18,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $eYoAG.Switch), {
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Route), {
                            exact: true,
                            path: currentPath,
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $30c6316d590b33ab$export$2e2bcd8739ae039), {
                                loading: loading,
                                client: client,
                                isNewClient: false
                            })
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Route), {
                            exact: true,
                            path: `${currentPath}/tags`,
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $9db911a6ebb6fcae$export$2e2bcd8739ae039), {
                                clientId: client.clientId,
                                assignedUsers: client.assignedUsers,
                                assignedAdministrators: client.assignedAdministrators
                            })
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Route), {
                            exact: true,
                            path: `${currentPath}/navigation`,
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $02d9a65ac8e83b0d$export$2e2bcd8739ae039), {
                                clientId: client.clientId
                            })
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Route), {
                            exact: true,
                            path: `${currentPath}/announcements`,
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $5af5ff5099fa9274$export$2e2bcd8739ae039), {
                                client: client.clientId
                            })
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Route), {
                            exact: true,
                            path: `${currentPath}/snowflake`,
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $30368fe5b11d84b8$export$2e2bcd8739ae039), {
                                clientId: client.clientId
                            })
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Route), {
                            path: `${currentPath}/dashboards`,
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $45da3e4d81119192$export$dd8ebb69a2ca9f35), {
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $eYoAG.Switch), {
                                    children: [
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Route), {
                                            exact: true,
                                            path: `${currentPath}/dashboards`,
                                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3bdb82499444f547$export$2e2bcd8739ae039), {
                                                clientId: Number(clientId)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Route), {
                                            exact: true,
                                            path: `${currentPath}/dashboards/create`,
                                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $046abf7a055fb93a$export$2e2bcd8739ae039), {
                                                clientId: Number(clientId)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Route), {
                                            exact: true,
                                            path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).EditClientDashboard,
                                            component: (0, $fb007376d95acb76$export$2e2bcd8739ae039)
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Route), {
                            path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).ClientHelpDocuments,
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $524bc7b3eb0618a2$export$752cfdd6bed7d744), {
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $eYoAG.Switch), {
                                    children: [
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Route), {
                                            path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).AddClientHelpDocument,
                                            exact: true,
                                            component: (0, $46466578ceca5add$export$2e2bcd8739ae039)
                                        }),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Route), {
                                            path: `${(0, $4bbac098dba9d86f$export$2e2bcd8739ae039).EditClientHelpDocument}/global`,
                                            exact: true,
                                            component: (0, $30682a56d7cd742d$export$2e2bcd8739ae039)
                                        }),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Route), {
                                            path: `${(0, $4bbac098dba9d86f$export$2e2bcd8739ae039).EditClientHelpDocument}/:revisions?`,
                                            exact: true,
                                            component: (0, $4a4e3fde644a6094$export$2e2bcd8739ae039)
                                        }),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Route), {
                                            path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).ViewClientHelpDocumentRevisions,
                                            exact: true,
                                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $e48cd4f69810746a$export$86457176ea54894f), {
                                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $285438b7d136a22f$export$2e2bcd8739ae039), {})
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Route), {
                                            path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).ClientHelpDocuments,
                                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4c3bb60c07737b6c$export$2e2bcd8739ae039), {})
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Route), {
                            exact: true,
                            path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).ClientUsers.replace(':clientId', clientId),
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $b786b2c8a4bf1859$export$2e2bcd8739ae039), {
                                assignedUsers: client.assignedUsers,
                                assignedAdministrators: client.assignedAdministrators
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $053de9380ceb4e28$export$2e2bcd8739ae039 = $053de9380ceb4e28$var$AdminClient;





parcelRequire("ieT14");

const $9f48766971a2e84f$var$AddGlobalDocument = ()=>{
    const defaultDocument = {
        feature: '',
        title: '',
        content: '',
        alternative: '',
        snippetId: -1,
        snippetGroupId: 0,
        revision: 0,
        clientId: -1,
        tags: [],
        dashboards: []
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $cb0991c7f4819f22$export$2e2bcd8739ae039), {
        document: defaultDocument,
        isNewDocument: true,
        isGlobal: true
    });
};
var $9f48766971a2e84f$export$2e2bcd8739ae039 = $9f48766971a2e84f$var$AddGlobalDocument;









var $lwgYO = parcelRequire("lwgYO");

var $fgoQ6 = parcelRequire("fgoQ6");

var $ieT14 = parcelRequire("ieT14");

var $eYoAG = parcelRequire("eYoAG");

var $ieT14 = parcelRequire("ieT14");



const $5255668c33a98545$var$staleTime = 1800000;
function $5255668c33a98545$export$b9ffd2bb384f6d1b() {
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    return (0, $137a3b252d598119$export$dd0a697e1782aedd)([
        'segments-admin-filters'
    ], ()=>{
        return fetchWrapper(`api/segments/filters`);
    }, {
        staleTime: $5255668c33a98545$var$staleTime
    });
}
function $5255668c33a98545$export$5aedb1be3806683c() {
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    const appState = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    return (0, $137a3b252d598119$export$dd0a697e1782aedd)([
        'segments-filters',
        appState.state.clientId
    ], ()=>{
        return fetchWrapper(`api/${appState.state.clientId}/segments/filters`);
    }, {
        staleTime: $5255668c33a98545$var$staleTime
    });
}





var $ieT14 = parcelRequire("ieT14");
var $246ccfbc8d89a664$export$b0377cbbbdab6cba;
var $246ccfbc8d89a664$export$f27f0a643498ce3d;
var $246ccfbc8d89a664$export$b00c055587dc7469;
var $246ccfbc8d89a664$export$b1a09d22b7ad6c4;
var $246ccfbc8d89a664$export$509f3108fdd206bb;
var $246ccfbc8d89a664$export$42ff741d2868ee32;
var $246ccfbc8d89a664$export$8c430709db82137d;
var $246ccfbc8d89a664$export$2d4b1211b4389c3b;
var $246ccfbc8d89a664$export$3832be13857745bc;
var $246ccfbc8d89a664$export$f4c68800b094ddb1;
var $246ccfbc8d89a664$export$e8e78c978b129247;
var $246ccfbc8d89a664$export$38e42c68cf43b5d4;
var $246ccfbc8d89a664$export$914772be44022da8;
var $246ccfbc8d89a664$export$6fbb9cd2843e91b2;
var $246ccfbc8d89a664$export$a7db06668cad9adb;
var $246ccfbc8d89a664$export$48884d2a5190dc73;
var $246ccfbc8d89a664$export$12948adc4d562794;
var $246ccfbc8d89a664$export$82456417dae51472;
var $246ccfbc8d89a664$export$e7d47881ec916f76;
var $246ccfbc8d89a664$export$9852986a3ec5f6a0;
var $246ccfbc8d89a664$export$a80eff00d507d114;
var $246ccfbc8d89a664$export$120b13130c77685f;
var $246ccfbc8d89a664$export$46c1c92549715335;
var $246ccfbc8d89a664$export$a3bc9b8ed74fc;
var $246ccfbc8d89a664$export$e19d3e3c28de4af;
var $246ccfbc8d89a664$export$9b1610f4cf001bb8;
var $246ccfbc8d89a664$export$b1e5508a851be14d;
var $246ccfbc8d89a664$export$c176f998e71d0f08;
var $246ccfbc8d89a664$export$97aac956da55dae9;
$246ccfbc8d89a664$export$b0377cbbbdab6cba = "#006da8";
$246ccfbc8d89a664$export$f27f0a643498ce3d = "#00aafc";
$246ccfbc8d89a664$export$b00c055587dc7469 = "#f5dbd9";
$246ccfbc8d89a664$export$b1a09d22b7ad6c4 = "#c92100";
$246ccfbc8d89a664$export$509f3108fdd206bb = "#ebafa6";
$246ccfbc8d89a664$export$42ff741d2868ee32 = "#074f86";
$246ccfbc8d89a664$export$8c430709db82137d = "#dadada";
$246ccfbc8d89a664$export$2d4b1211b4389c3b = "#dddbda";
$246ccfbc8d89a664$export$3832be13857745bc = "#eae9ed";
$246ccfbc8d89a664$export$f4c68800b094ddb1 = "#e9e8f4";
$246ccfbc8d89a664$export$e8e78c978b129247 = "root_963074";
$246ccfbc8d89a664$export$38e42c68cf43b5d4 = "header_963074";
$246ccfbc8d89a664$export$914772be44022da8 = "paper_963074";
$246ccfbc8d89a664$export$6fbb9cd2843e91b2 = "sidebar_963074";
$246ccfbc8d89a664$export$a7db06668cad9adb = "content_963074";
$246ccfbc8d89a664$export$48884d2a5190dc73 = "tableHeader_963074";
$246ccfbc8d89a664$export$12948adc4d562794 = "titleContainer_963074";
$246ccfbc8d89a664$export$82456417dae51472 = "tableTitle_963074";
$246ccfbc8d89a664$export$e7d47881ec916f76 = "tableWrapper_963074";
$246ccfbc8d89a664$export$9852986a3ec5f6a0 = "table_963074";
$246ccfbc8d89a664$export$a80eff00d507d114 = "tableLink_963074";
$246ccfbc8d89a664$export$120b13130c77685f = "lastModifiedColumn_963074";
$246ccfbc8d89a664$export$46c1c92549715335 = "loading_963074";
$246ccfbc8d89a664$export$a3bc9b8ed74fc = "error_963074";
$246ccfbc8d89a664$export$e19d3e3c28de4af = "paginationFooter_963074";
$246ccfbc8d89a664$export$9b1610f4cf001bb8 = "circularProgressContainer_963074";
$246ccfbc8d89a664$export$b1e5508a851be14d = "menu_963074";
$246ccfbc8d89a664$export$c176f998e71d0f08 = "menuItem_963074";
$246ccfbc8d89a664$export$97aac956da55dae9 = "current_963074";



var $fpdl2 = parcelRequire("fpdl2");

var $fgoQ6 = parcelRequire("fgoQ6");

parcelRequire("ieT14");

var $e1ONw = parcelRequire("e1ONw");


var $etCDZ = parcelRequire("etCDZ");



var $fgoQ6 = parcelRequire("fgoQ6");
const $9321cd731676f243$var$useStyles = (0, $e1ONw.default)({
    root: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
    },
    header: (props)=>({
            height: 43,
            padding: 8,
            display: 'flex',
            justifyContent: 'space-between',
            fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).heading,
            borderBottom: props.isCollapsed ? 'none' : `1px solid ${(0, $69ed148db7543104$export$a4867fe9454f37a8)[300]}`
        }),
    iconWrapper: (props)=>({
            width: props.isCollapsed ? '100%' : 'auto',
            display: 'flex',
            alignItems: 'center',
            '& svg': {
                display: 'block',
                margin: props.isCollapsed ? '0 auto' : '0 5px 0 0'
            },
            '& .filters': {
                margin: 0,
                fontWeight: 600,
                fontSize: '1rem'
            }
        }),
    loadingFilters: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        paddingTop: '12px'
    },
    inactive: {
        display: 'flex',
        justifyContent: 'center',
        paddingTop: '12px',
        ...(0, $a414f09d93b4ed4c$export$2e2bcd8739ae039).label1,
        whiteSpace: 'nowrap',
        opacity: 1,
        transition: 'opacity 150ms',
        '&.collapsed': {
            opacity: 0
        }
    },
    filterActions: (props)=>({
            visibility: props.isCollapsed ? 'hidden' : 'visible',
            borderBottom: `1px solid ${(0, $69ed148db7543104$export$a4867fe9454f37a8)[300]}`,
            padding: 8,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '& button:first-of-type': {
                marginRight: 8
            }
        }),
    content: (props)=>({
            '& > div, & > fieldset': {
                visibility: props.isCollapsed ? 'hidden' : 'visible',
                padding: 8,
                marginTop: 8,
                whiteSpace: 'nowrap',
                width: '100%',
                boxSizing: 'border-box',
                '&:not(:last-child)': {
                    borderBottom: `1px solid ${(0, $69ed148db7543104$export$a4867fe9454f37a8)[300]}`
                }
            }
        }),
    clearFilters: {
        display: 'flex',
        alignItems: 'center'
    },
    chip: {
        fontSize: 12,
        lineHeight: '14px',
        fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).body,
        color: 'white',
        backgroundColor: (0, $69ed148db7543104$export$2aa0182783e7e9de)[500],
        padding: '0 8px',
        borderRadius: '8px'
    }
});
/**
 * Render filter sidebar content
 */ const $9321cd731676f243$var$FilterMenu = ({ isCollapsed: isCollapsed, isLoading: isLoading, isInvalid: isInvalid, activeFilterCount: activeFilterCount, onApply: onApply, onCancel: onCancel, onClearAll: onClearAll, children: children })=>{
    const classes = $9321cd731676f243$var$useStyles({
        isCollapsed: isCollapsed
    });
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("form", {
        className: classes.root,
        onSubmit: (event)=>{
            onApply();
            event.preventDefault();
        },
        onReset: (event)=>{
            onClearAll();
            event.preventDefault();
        },
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: classes.header,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        className: classes.iconWrapper,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $etCDZ.default), {}),
                            !isCollapsed && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("p", {
                                className: "filters",
                                children: "Filters"
                            })
                        ]
                    }),
                    !isCollapsed && activeFilterCount > 0 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        className: classes.clearFilters,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.TertiaryButton), {
                                component: "button",
                                title: "Clear All",
                                text: "Clear All",
                                handleClick: onClearAll,
                                className: classes.clearButton
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                className: classes.chip,
                                children: activeFilterCount
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: classes.filterActions,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.TertiaryButton), {
                        component: "button",
                        text: "cancel",
                        title: "cancel",
                        handleClick: onCancel
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryButton), {
                        text: "Apply",
                        title: "Apply",
                        handleClick: onApply,
                        deactive: isLoading || isInvalid
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5d10f0a7aadd7c8c$exports))), {
                style: {
                    flex: 1
                },
                hidden: isCollapsed,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: classes.content,
                    children: children
                })
            })
        ]
    });
};
var $9321cd731676f243$export$2e2bcd8739ae039 = $9321cd731676f243$var$FilterMenu;



parcelRequire("ieT14");

var $whS22 = parcelRequire("whS22");
var $knRao = parcelRequire("knRao");
var $3WBJn = parcelRequire("3WBJn");
var $f3VQ2 = parcelRequire("f3VQ2");
var $e1ONw = parcelRequire("e1ONw");



var $fgoQ6 = parcelRequire("fgoQ6");
const $c596e54e20dca69a$var$useStyles = (0, $e1ONw.default)({
    formGroup: {
        alignItems: 'flex-start',
        '& MuiCheckbox-root': {
            padding: 0
        }
    },
    formLabel: {
        color: (0, $69ed148db7543104$export$a4867fe9454f37a8)[600],
        fontWeight: 500
    },
    inputLabel: {
        marginLeft: 0,
        '& .MuiFormControlLabel-label': {
            fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).heading,
            fontSize: 14,
            lineHeight: 1.25
        },
        '& .MuiIconButton-root': {
            padding: 4
        }
    },
    selectActions: {
        fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).heading,
        fontSize: 11,
        color: (0, $69ed148db7543104$export$a4867fe9454f37a8)[500],
        padding: '0 4px',
        '& p': {
            margin: 0
        }
    },
    selectAllNone: {
        height: 30
    },
    noFilters: {
        ...(0, $a414f09d93b4ed4c$export$2e2bcd8739ae039).label1
    }
});
/**
 * Render a section of filter options in the fitler sidebar
 */ const $c596e54e20dca69a$var$OptionsFilterGroup = ({ options: options, title: title, selected: selected, updateSelectedFilters: updateSelectedFilters })=>{
    const classes = $c596e54e20dca69a$var$useStyles();
    const handleCheckToggle = (event)=>{
        if (!selected.includes(event.target.value)) updateSelectedFilters([
            ...selected,
            event.target.value
        ]);
        else updateSelectedFilters(selected.filter((selection)=>selection != event.target.value));
    };
    const selectAll = ()=>{
        updateSelectedFilters(options.map((option)=>option.id));
    };
    const selectNone = ()=>{
        updateSelectedFilters([]);
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
        component: "fieldset",
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f3VQ2.default), {
                component: "legend",
                className: classes.formLabel,
                children: title
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $3WBJn.default), {
                className: classes.formGroup,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: classes.selectActions,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("p", {
                            children: [
                                "Select:",
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.TertiaryButton), {
                                    component: "button",
                                    text: "All",
                                    title: "All",
                                    handleClick: selectAll,
                                    className: classes.selectAllNone
                                }),
                                "|",
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.TertiaryButton), {
                                    component: "button",
                                    text: "None",
                                    title: "None",
                                    handleClick: selectNone,
                                    className: classes.selectAllNone
                                })
                            ]
                        })
                    }),
                    options.length ? options.map((option)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $knRao.default), {
                            control: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.StyledCheckbox), {
                                checked: selected.includes(option.id),
                                onChange: (event)=>{
                                    handleCheckToggle(event);
                                },
                                name: option.name,
                                value: option.id
                            }),
                            label: option.name,
                            className: classes.inputLabel
                        }, `${option.name}-${option.id}`)) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("p", {
                        className: classes.noFilters,
                        children: "No filters available"
                    })
                ]
            })
        ]
    });
};
var $c596e54e20dca69a$export$2e2bcd8739ae039 = $c596e54e20dca69a$var$OptionsFilterGroup;



parcelRequire("ieT14");

var $whS22 = parcelRequire("whS22");
var $3WBJn = parcelRequire("3WBJn");
var $f3VQ2 = parcelRequire("f3VQ2");
var $e1ONw = parcelRequire("e1ONw");
var $eYT2J = parcelRequire("eYT2J");
var $aIJrd = parcelRequire("aIJrd");


const $9f14f9705f520ed9$var$useStyles = (0, $e1ONw.default)({
    formGroup: {
        alignItems: 'flex-start',
        whiteSpace: 'nowrap'
    },
    formLabel: {
        color: (0, $69ed148db7543104$export$a4867fe9454f37a8)[600],
        fontWeight: 500
    },
    input: {
        maxWidth: 150,
        marginTop: 8,
        marginBottom: 8
    }
});
const $9f14f9705f520ed9$var$CustomizedTextField = (0, $aIJrd.default)({
    root: {
        '& .MuiOutlinedInput-root': {
            fontSize: '14px'
        }
    }
})((0, $eYT2J.default));
const $9f14f9705f520ed9$var$SmallTextField = (props)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($9f14f9705f520ed9$var$CustomizedTextField, {
        ...props,
        size: "small",
        variant: "outlined"
    });
/**
 * Render a section of date filters
 */ const $9f14f9705f520ed9$var$DateFilterGroup = ({ title: title, startDate: startDate, endDate: endDate, onStartDateChange: onStartDateChange, onEndDateChange: onEndDateChange })=>{
    const classes = $9f14f9705f520ed9$var$useStyles();
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
        component: "fieldset",
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f3VQ2.default), {
                component: "legend",
                className: classes.formLabel,
                children: title
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $3WBJn.default), {
                className: classes.formGroup,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $d2c3211918dbdb4a$export$d8c44f501031ee7c), {
                        label: "Start Date",
                        value: startDate,
                        onChange: onStartDateChange,
                        format: "MM/DD/YYYY",
                        variant: "inline",
                        inputVariant: "outlined",
                        TextFieldComponent: $9f14f9705f520ed9$var$SmallTextField,
                        KeyboardButtonProps: {
                            size: 'small',
                            edge: 'end'
                        },
                        className: classes.input
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $d2c3211918dbdb4a$export$d8c44f501031ee7c), {
                        label: "End Date",
                        value: endDate,
                        onChange: onEndDateChange,
                        format: "MM/DD/YYYY",
                        variant: "inline",
                        inputVariant: "outlined",
                        TextFieldComponent: $9f14f9705f520ed9$var$SmallTextField,
                        KeyboardButtonProps: {
                            size: 'small',
                            edge: 'end'
                        },
                        className: classes.input
                    })
                ]
            })
        ]
    });
};
var $9f14f9705f520ed9$export$2e2bcd8739ae039 = $9f14f9705f520ed9$var$DateFilterGroup;




var $ieT14 = parcelRequire("ieT14");

var $whS22 = parcelRequire("whS22");
var $3WBJn = parcelRequire("3WBJn");
var $f3VQ2 = parcelRequire("f3VQ2");
var $e1ONw = parcelRequire("e1ONw");
var $eYT2J = parcelRequire("eYT2J");
var $aIJrd = parcelRequire("aIJrd");

const $a5d21a2879a6ca14$var$useStyles = (0, $e1ONw.default)({
    formGroup: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        whiteSpace: 'nowrap'
    },
    formLabel: {
        color: (0, $69ed148db7543104$export$a4867fe9454f37a8)[600],
        fontWeight: 500
    },
    input: {
        maxWidth: 100,
        marginTop: 8,
        marginBottom: 8
    },
    dash: {
        margin: '4px',
        fontSize: '22px',
        fontWeight: 500
    }
});
const $a5d21a2879a6ca14$var$CustomizedTextField = (0, $aIJrd.default)({
    root: {
        '& .MuiOutlinedInput-root': {
            fontSize: '14px'
        }
    }
})((0, $eYT2J.default));
/**
 * Render a section of filter options in the fitler sidebar
 */ const $a5d21a2879a6ca14$var$MinMaxFilterGroup = ({ title: title, min: min, max: max, setMin: setMin, setMax: setMax, isValid: isValid, setIsValid: setIsValid })=>{
    const classes = $a5d21a2879a6ca14$var$useStyles();
    const validRegex = /(^\d+$|^$)/;
    const handleMinChange = (event)=>{
        const next = event.target.value;
        if (next.match(validRegex)) setMin(next === '' ? '' : Number(next));
    };
    const handleMaxChange = (event)=>{
        const next = event.target.value;
        if (next.match(validRegex)) setMax(next === '' ? '' : Number(next));
    };
    $ieT14.useEffect(()=>{
        if (max !== '' && min !== '' && Number(max) <= Number(min)) setIsValid(false);
        else setIsValid(true);
    }, [
        min,
        max
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
        component: "fieldset",
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f3VQ2.default), {
                component: "legend",
                className: classes.formLabel,
                children: title
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $3WBJn.default), {
                className: classes.formGroup,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($a5d21a2879a6ca14$var$CustomizedTextField, {
                        size: "small",
                        variant: "outlined",
                        label: "Min",
                        value: min,
                        onChange: handleMinChange,
                        error: !isValid,
                        className: classes.input
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        className: classes.dash,
                        children: "-"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($a5d21a2879a6ca14$var$CustomizedTextField, {
                        size: "small",
                        variant: "outlined",
                        label: "Max",
                        value: max,
                        onChange: handleMaxChange,
                        error: !isValid,
                        className: classes.input
                    })
                ]
            })
        ]
    });
};
var $a5d21a2879a6ca14$export$2e2bcd8739ae039 = $a5d21a2879a6ca14$var$MinMaxFilterGroup;



var $ieT14 = parcelRequire("ieT14");
function $5b4192b55457c972$var$calculateAppliedCount(appliedFilters) {
    const activeDates = Number(appliedFilters.startDate !== null) + Number(appliedFilters.endDate !== null);
    const activeCustomers = Number(appliedFilters.min !== '') + Number(appliedFilters.max !== '');
    return activeDates + activeCustomers + appliedFilters.isShared.length + ('teams' in appliedFilters && appliedFilters.teams.length) + appliedFilters.users.length;
}
function $5b4192b55457c972$export$8e352e155ba0e7af(state, action) {
    switch(action.type){
        case 'setFilters':
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.filters
                }
            };
        case 'cancel':
            return {
                ...state,
                filters: state.previousFilters,
                filterCount: $5b4192b55457c972$var$calculateAppliedCount(state.previousFilters)
            };
        case 'clearAll':
            return {
                filters: action.defaultFilters,
                previousFilters: action.defaultFilters,
                filterCount: 0
            };
        case 'apply':
            return {
                ...state,
                previousFilters: state.filters,
                filterCount: $5b4192b55457c972$var$calculateAppliedCount(state.filters)
            };
    }
}


function $a1a4cdba1f312a74$export$c31df1e3563c2582(setActiveFilters, defaultActiveFilters) {
    const [state, dispatch] = $ieT14.useReducer((0, $5b4192b55457c972$export$8e352e155ba0e7af), {
        filters: defaultActiveFilters,
        previousFilters: defaultActiveFilters,
        filterCount: 0
    });
    function handleApply() {
        setActiveFilters(state.filters);
        dispatch({
            type: 'apply'
        });
    }
    function handleClearAll() {
        setActiveFilters(defaultActiveFilters);
        dispatch({
            type: 'clearAll',
            defaultFilters: defaultActiveFilters
        });
    }
    return {
        state: state,
        dispatch: dispatch,
        handleApply: handleApply,
        handleClearAll: handleClearAll
    };
}


const $a9c90e42e1f0237c$var$SegmentsSidebar = ({ setActiveFilters: setActiveFilters, defaultActiveFilters: defaultActiveFilters, isLoading: isLoading, loadedFilters: loadedFilters })=>{
    const { state: state, dispatch: dispatch, handleApply: handleApply, handleClearAll: handleClearAll } = (0, $a1a4cdba1f312a74$export$c31df1e3563c2582)(setActiveFilters, defaultActiveFilters);
    const [filtersCollapsed, setFiltersCollapsed] = $ieT14.useState(true);
    const [isMinmaxValid, setIsMinmaxValid] = $ieT14.useState(true);
    const formIsValid = (state.filters.startDate == null || state.filters.startDate.isValid()) && (state.filters.endDate == null || state.filters.endDate.isValid()) && isMinmaxValid;
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.CollapsibleSidebar), {
        collapsed: filtersCollapsed,
        setCollapsed: setFiltersCollapsed,
        initialCollapse: true,
        width: "260px",
        collapsedWidth: "70px",
        className: $246ccfbc8d89a664$export$6fbb9cd2843e91b2,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $9321cd731676f243$export$2e2bcd8739ae039), {
            isLoading: isLoading,
            isCollapsed: filtersCollapsed,
            isInvalid: !formIsValid,
            activeFilterCount: state.filterCount,
            onApply: handleApply,
            onCancel: ()=>dispatch({
                    type: 'cancel'
                }),
            onClearAll: handleClearAll,
            children: [
                isLoading && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: $246ccfbc8d89a664$export$9b1610f4cf001bb8,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {
                        size: "20px"
                    })
                }),
                loadedFilters && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
                    children: [
                        loadedFilters.clients && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $c596e54e20dca69a$export$2e2bcd8739ae039), {
                            title: "Teams",
                            options: loadedFilters.clients,
                            selected: 'teams' in state.filters && state.filters.teams,
                            updateSelectedFilters: (selected)=>dispatch({
                                    type: 'setFilters',
                                    filters: {
                                        teams: selected
                                    }
                                })
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $9f14f9705f520ed9$export$2e2bcd8739ae039), {
                            title: "Modified Date",
                            startDate: state.filters.startDate,
                            endDate: state.filters.endDate,
                            onStartDateChange: (date)=>dispatch({
                                    type: 'setFilters',
                                    filters: {
                                        startDate: date
                                    }
                                }),
                            onEndDateChange: (date)=>dispatch({
                                    type: 'setFilters',
                                    filters: {
                                        endDate: date
                                    }
                                })
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $a5d21a2879a6ca14$export$2e2bcd8739ae039), {
                            title: "# of Customers",
                            min: state.filters.min,
                            max: state.filters.max,
                            setMin: (min)=>dispatch({
                                    type: 'setFilters',
                                    filters: {
                                        min: min
                                    }
                                }),
                            setMax: (max)=>dispatch({
                                    type: 'setFilters',
                                    filters: {
                                        max: max
                                    }
                                }),
                            isValid: isMinmaxValid,
                            setIsValid: setIsMinmaxValid
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $c596e54e20dca69a$export$2e2bcd8739ae039), {
                            title: "Created By",
                            options: loadedFilters.users,
                            selected: state.filters.users,
                            updateSelectedFilters: (selected)=>dispatch({
                                    type: 'setFilters',
                                    filters: {
                                        users: selected
                                    }
                                })
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $c596e54e20dca69a$export$2e2bcd8739ae039), {
                            options: [
                                {
                                    name: 'Shared',
                                    id: 'true'
                                },
                                {
                                    name: 'Not shared',
                                    id: 'false'
                                }
                            ],
                            title: "Sharing",
                            selected: state.filters.isShared,
                            updateSelectedFilters: (selected)=>dispatch({
                                    type: 'setFilters',
                                    filters: {
                                        isShared: selected
                                    }
                                })
                        })
                    ]
                })
            ]
        })
    });
};
var $a9c90e42e1f0237c$export$2e2bcd8739ae039 = $a9c90e42e1f0237c$var$SegmentsSidebar;




var $fpdl2 = parcelRequire("fpdl2");
var $edxsd = parcelRequire("edxsd");

var $eTwGP = parcelRequire("eTwGP");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");

var $aIJrd = parcelRequire("aIJrd");

var $47zxZ = parcelRequire("47zxZ");
var $6830d3674ad61fd5$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        margin: 0,
        padding: '16px 24px',
        flex: '0 0 auto'
    }
};
var $6830d3674ad61fd5$var$DialogTitle = /*#__PURE__*/ $ieT14.forwardRef(function DialogTitle(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$disableTypogra = props.disableTypography, disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra, other = (0, $eTwGP.default)(props, [
        "children",
        "classes",
        "className",
        "disableTypography"
    ]);
    return /*#__PURE__*/ $ieT14.createElement("div", (0, $edxsd.default)({
        className: (0, $j6s32.default)(classes.root, className),
        ref: ref
    }, other), disableTypography ? children : /*#__PURE__*/ $ieT14.createElement((0, $47zxZ.default), {
        component: "h2",
        variant: "h6"
    }, children));
});
var $6830d3674ad61fd5$export$2e2bcd8739ae039 = (0, $aIJrd.default)($6830d3674ad61fd5$export$9dd6ff9ea0189349, {
    name: 'MuiDialogTitle'
})($6830d3674ad61fd5$var$DialogTitle);


var $1KcBP = parcelRequire("1KcBP");
var $e1ONw = parcelRequire("e1ONw");
var $5TjLg = parcelRequire("5TjLg");
var $3mOXj = parcelRequire("3mOXj");

var $fgoQ6 = parcelRequire("fgoQ6");

var $ieT14 = parcelRequire("ieT14");

var $6mt9R = parcelRequire("6mt9R");
var $eYoAG = parcelRequire("eYoAG");

var $ieT14 = parcelRequire("ieT14");



function $bc1da11b3d648f78$export$35888604389caffd(sort, searchTerm, activeFilters) {
    const appState = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    const userInterface = window.env.USER_INTERFACE != null ? window.env.USER_INTERFACE : 'default';
    return (0, $137a3b252d598119$export$dd0a697e1782aedd)([
        'segments',
        appState.state.clientId,
        sort,
        searchTerm,
        activeFilters
    ], ()=>{
        let query = `Page=${sort.page}` + `&PageSize=${sort.pageSize}` + `&Sort=${sort.orderColumn}` + `&SortDirection=${sort.orderDirection}`;
        if (searchTerm) query += `&SearchTerm=${searchTerm}`;
        if (activeFilters.startDate) query += `&StartDate=${activeFilters.startDate.toISOString()}`;
        if (activeFilters.endDate) query += `&EndDate=${activeFilters.endDate.toISOString()}`;
        if (activeFilters.min) query += `&MinRecordAmount=${activeFilters.min}`;
        if (activeFilters.max) query += `&MaxRecordAmount=${activeFilters.max}`;
        activeFilters.users.forEach((userId)=>{
            query += `&UserIds=${userId}`;
        });
        if ('teams' in activeFilters) activeFilters.teams.forEach((teamId)=>{
            query += `&ClientIds=${teamId}`;
        });
        // Do not filter on `isShared` if 0 or both of the possible filters are selected.
        if (activeFilters.isShared.length === 1) query += `&IsShared=${activeFilters.isShared[0]}`;
        if (userInterface !== 'management') return fetchWrapper(`api/${appState.state.clientId}/segments?${query}`);
        return fetchWrapper(`api/segments?${query}`);
    }, {
        keepPreviousData: true
    });
}



const $28c5efff86001588$export$ad991b66133851cf = Intl.DateTimeFormat('en-US');
const $28c5efff86001588$export$3245e15bf4cbdd6c = Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
});




var $ieT14 = parcelRequire("ieT14");
var $767389d4dff48cc9$export$b0377cbbbdab6cba;
var $767389d4dff48cc9$export$f27f0a643498ce3d;
var $767389d4dff48cc9$export$b00c055587dc7469;
var $767389d4dff48cc9$export$b1a09d22b7ad6c4;
var $767389d4dff48cc9$export$509f3108fdd206bb;
var $767389d4dff48cc9$export$42ff741d2868ee32;
var $767389d4dff48cc9$export$8c430709db82137d;
var $767389d4dff48cc9$export$2d4b1211b4389c3b;
var $767389d4dff48cc9$export$3832be13857745bc;
var $767389d4dff48cc9$export$f4c68800b094ddb1;
var $767389d4dff48cc9$export$e8e78c978b129247;
var $767389d4dff48cc9$export$fe14be68655a3881;
var $767389d4dff48cc9$export$e6dcc0f0935f9e6f;
var $767389d4dff48cc9$export$5b1c922c81430b65;
var $767389d4dff48cc9$export$89da14300d534261;
var $767389d4dff48cc9$export$b2f9e9b6a20ac8eb;
var $767389d4dff48cc9$export$ba319923d57aa6fe;
$767389d4dff48cc9$export$b0377cbbbdab6cba = "#006da8";
$767389d4dff48cc9$export$f27f0a643498ce3d = "#00aafc";
$767389d4dff48cc9$export$b00c055587dc7469 = "#f5dbd9";
$767389d4dff48cc9$export$b1a09d22b7ad6c4 = "#c92100";
$767389d4dff48cc9$export$509f3108fdd206bb = "#ebafa6";
$767389d4dff48cc9$export$42ff741d2868ee32 = "#074f86";
$767389d4dff48cc9$export$8c430709db82137d = "#dadada";
$767389d4dff48cc9$export$2d4b1211b4389c3b = "#dddbda";
$767389d4dff48cc9$export$3832be13857745bc = "#eae9ed";
$767389d4dff48cc9$export$f4c68800b094ddb1 = "#e9e8f4";
$767389d4dff48cc9$export$e8e78c978b129247 = "root_dc47a4";
$767389d4dff48cc9$export$fe14be68655a3881 = "pagesizeContainer_dc47a4";
$767389d4dff48cc9$export$e6dcc0f0935f9e6f = "pageNavigation_dc47a4";
$767389d4dff48cc9$export$5b1c922c81430b65 = "pageNumber_dc47a4";
$767389d4dff48cc9$export$89da14300d534261 = "active_dc47a4";
$767389d4dff48cc9$export$b2f9e9b6a20ac8eb = "pageinputContainer_dc47a4";
$767389d4dff48cc9$export$ba319923d57aa6fe = "activePage_dc47a4";



var $8DFBm = parcelRequire("8DFBm");
var $7nM46 = parcelRequire("7nM46");

var $fgoQ6 = parcelRequire("fgoQ6");

var $j6s32 = parcelRequire("j6s32");

var $1KcBP = parcelRequire("1KcBP");
const $d776a68ec1e862ae$export$a47da89cf252e6cf = [
    15,
    30,
    60
];
function $d776a68ec1e862ae$export$d02631cccf789723(start, end) {
    const length = end - start + 1;
    return Array.from({
        length: length
    }, (_, i)=>start + i);
}
function $d776a68ec1e862ae$export$43e8e66f273a0e38(totalPages, currentPage, siblingCount = 1) {
    // Calculate the beginning of pages shown surrounding the currently selected page
    const siblingsStart = Math.max(Math.min(// Natural start
    currentPage - siblingCount, // Lower boundary when page is high (page count - siblings - first and last)
    totalPages - siblingCount * 2 - 2), // Greater than startPages
    3);
    // End of pages surrounding the currently selected page
    const siblingsEnd = Math.min(Math.max(// Natural end
    currentPage + siblingCount, // Upper boundary when page is low
    1 + siblingCount * 2 + 2), // Less than endPages
    totalPages - 2);
    return [
        1,
        // Start ellipsis or second page, if needed
        ...siblingsStart > 3 ? [
            'startEllipsis'
        ] : 2 < totalPages - 1 ? [
            2
        ] : [],
        // Sibling and current pages
        ...$d776a68ec1e862ae$export$d02631cccf789723(siblingsStart, siblingsEnd),
        // End ellipsis or second to last page, if needed
        ...siblingsEnd < totalPages - 2 ? [
            'endEllipsis'
        ] : totalPages - 1 > 1 ? [
            totalPages - 1
        ] : [],
        // Last page, if not already shown as sibling
        ...totalPages > siblingsEnd && totalPages > 1 ? [
            totalPages
        ] : []
    ];
}



var $8awOk = parcelRequire("8awOk");

const $fce6a9cfa0ef4de9$var$StyledIconButton = (0, $8awOk.default)({
    root: {
        color: (0, $69ed148db7543104$export$2aa0182783e7e9de)[600]
    }
})((0, $1KcBP.default));
/**
 * Pagination
 * Component to render paged navigation controls
 */ const $fce6a9cfa0ef4de9$var$Pagination = ({ totalPages: totalPages, pageSize: pageSize, currentPage: currentPage, disabled: disabled, handlePageChange: handlePageChange, handlePageSizeChange: handlePageSizeChange })=>{
    const [inputPage, setInputPage] = $ieT14.useState(null);
    const displayedPages = (0, $d776a68ec1e862ae$export$43e8e66f273a0e38)(totalPages, currentPage);
    // Clears out the number in input if the selectedPage is changed outside the input
    $ieT14.useEffect(()=>{
        if (currentPage !== inputPage) setInputPage(null);
    }, [
        currentPage
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $767389d4dff48cc9$export$e8e78c978b129247,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $767389d4dff48cc9$export$fe14be68655a3881,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        children: "Show:"
                    }),
                    (0, $d776a68ec1e862ae$export$a47da89cf252e6cf).map((option)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("button", {
                            onClick: ()=>handlePageSizeChange(option),
                            className: (0, $j6s32.default)(pageSize === option && $767389d4dff48cc9$export$89da14300d534261),
                            "aria-label": `Set page size to ${option}`,
                            children: option
                        }, `pageOption-${option}`))
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("nav", {
                "aria-label": "pagination navigation",
                className: $767389d4dff48cc9$export$e6dcc0f0935f9e6f,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($fce6a9cfa0ef4de9$var$StyledIconButton, {
                                size: "small",
                                disabled: currentPage === 1 || disabled,
                                onClick: ()=>handlePageChange(currentPage - 1),
                                "aria-label": "Go to previous page",
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8DFBm.default), {})
                            })
                        }),
                        displayedPages.map((page)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
                                children: typeof page === 'number' ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("button", {
                                    className: (0, $j6s32.default)($767389d4dff48cc9$export$5b1c922c81430b65, page === currentPage && $767389d4dff48cc9$export$89da14300d534261),
                                    onClick: ()=>handlePageChange(page),
                                    disabled: disabled,
                                    "aria-label": `Go to page ${page}`,
                                    children: page
                                }) : '...'
                            }, page)),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($fce6a9cfa0ef4de9$var$StyledIconButton, {
                                color: "inherit",
                                size: "small",
                                disabled: currentPage === totalPages || disabled,
                                onClick: ()=>handlePageChange(currentPage + 1),
                                "aria-label": "Go to next page",
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $7nM46.default), {})
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $767389d4dff48cc9$export$b2f9e9b6a20ac8eb,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        children: "Go To Page:"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("form", {
                        onSubmit: (event)=>{
                            event.preventDefault();
                            if (inputPage > totalPages) {
                                setInputPage(totalPages);
                                handlePageChange(totalPages);
                            } else handlePageChange(inputPage);
                        },
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.OutlinedInput), {
                            id: "outlined-page-input",
                            margin: "dense",
                            variant: "outlined",
                            type: "number",
                            onChange: (event)=>setInputPage(Number(event.target.value)),
                            value: inputPage ? String(inputPage) : '',
                            tabIndex: 1
                        })
                    })
                ]
            })
        ]
    });
};
var $fce6a9cfa0ef4de9$export$2e2bcd8739ae039 = $fce6a9cfa0ef4de9$var$Pagination;





var $ieT14 = parcelRequire("ieT14");

var $whS22 = parcelRequire("whS22");
var $Uxz4Y = parcelRequire("Uxz4Y");
var $e1ONw = parcelRequire("e1ONw");
var $3mOXj = parcelRequire("3mOXj");
var $aanJt = parcelRequire("aanJt");
var $356Vi = parcelRequire("356Vi");

var $1vmhz = parcelRequire("1vmhz");

var $ieT14 = parcelRequire("ieT14");

var $ieT14 = parcelRequire("ieT14");
const $dfd64722afb66cad$export$1cf3d545f2d4635c = console;




class $bfe96b6a319fad0f$export$e09608847fcc8c59 {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $18693172d3695360$export$e539f754e934e270)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, $18693172d3695360$export$6acf61af03e62db) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}



// CLASS
class $a3529469b4436299$export$17b8b19c814bcf56 extends (0, $bfe96b6a319fad0f$export$e09608847fcc8c59) {
    constructor(config){
        super();
        this.defaultOptions = config.defaultOptions;
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, $dfd64722afb66cad$export$1cf3d545f2d4635c);
        this.observers = [];
        this.state = config.state || $a3529469b4436299$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    get meta() {
        return this.options.meta;
    }
    setState(state) {
        this.dispatch({
            type: 'setState',
            state: state
        });
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: 'observerAdded',
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: 'observerRemoved',
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === 'loading') this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        var _this$retryer$continu, _this$retryer;
        return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, $984e1698e746a614$export$2cbd00fe8a2c8d85)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject('No mutationFn found');
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: (failureCount, error)=>{
                    this.dispatch({
                        type: 'failed',
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: 'pause'
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: 'continue'
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === 'loading';
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: 'loading',
                    variables: this.options.variables
                }); // Notify cache callback
                await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: 'loading',
                    context: context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback
            await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: 'success',
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback
                await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: 'error',
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case 'failed':
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case 'pause':
                    return {
                        ...state,
                        isPaused: true
                    };
                case 'continue':
                    return {
                        ...state,
                        isPaused: false
                    };
                case 'loading':
                    return {
                        ...state,
                        context: action.context,
                        data: undefined,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: !(0, $984e1698e746a614$export$61b92f63f30245cf)(this.options.networkMode),
                        status: 'loading',
                        variables: action.variables
                    };
                case 'success':
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: 'success',
                        isPaused: false
                    };
                case 'error':
                    return {
                        ...state,
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: 'error'
                    };
                case 'setState':
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $c92d7790084acd39$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: 'updated',
                action: action
            });
        });
    }
}
function $a3529469b4436299$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: 'idle',
        variables: undefined
    };
}





// CLASS
class $a0a85f4baed61d3e$export$d3c1860ee66f291a extends (0, $9cc1a4e40d9960ad$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.client = client;
        this.setOptions(options);
        this.bindMethods();
        this.updateResult();
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _this$currentMutation;
        const prevOptions = this.options;
        this.options = this.client.defaultMutationOptions(options);
        if (!(0, $18693172d3695360$export$3e67810a3f0e9f1c)(prevOptions, this.options)) this.client.getMutationCache().notify({
            type: 'observerOptionsUpdated',
            mutation: this.currentMutation,
            observer: this
        });
        (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.setOptions(this.options);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$currentMutation2;
            (_this$currentMutation2 = this.currentMutation) == null || _this$currentMutation2.removeObserver(this);
        }
    }
    onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        const notifyOptions = {
            listeners: true
        };
        if (action.type === 'success') notifyOptions.onSuccess = true;
        else if (action.type === 'error') notifyOptions.onError = true;
        this.notify(notifyOptions);
    }
    getCurrentResult() {
        return this.currentResult;
    }
    reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    }
    mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, {
            ...this.options,
            variables: typeof variables !== 'undefined' ? variables : this.options.variables
        });
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    }
    updateResult() {
        const state = this.currentMutation ? this.currentMutation.state : (0, $a3529469b4436299$export$a1659b54bac3252a)();
        const result = {
            ...state,
            isLoading: state.status === 'loading',
            isSuccess: state.status === 'success',
            isError: state.status === 'error',
            isIdle: state.status === 'idle',
            mutate: this.mutate,
            reset: this.reset
        };
        this.currentResult = result;
    }
    notify(options) {
        (0, $c92d7790084acd39$export$520687f44db6e1ab).batch(()=>{
            // First trigger the mutate callbacks
            if (this.mutateOptions && this.hasListeners()) {
                if (options.onSuccess) {
                    var _this$mutateOptions$o, _this$mutateOptions, _this$mutateOptions$o2, _this$mutateOptions2;
                    (_this$mutateOptions$o = (_this$mutateOptions = this.mutateOptions).onSuccess) == null || _this$mutateOptions$o.call(_this$mutateOptions, this.currentResult.data, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o2 = (_this$mutateOptions2 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o2.call(_this$mutateOptions2, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
                } else if (options.onError) {
                    var _this$mutateOptions$o3, _this$mutateOptions3, _this$mutateOptions$o4, _this$mutateOptions4;
                    (_this$mutateOptions$o3 = (_this$mutateOptions3 = this.mutateOptions).onError) == null || _this$mutateOptions$o3.call(_this$mutateOptions3, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o4 = (_this$mutateOptions4 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o4.call(_this$mutateOptions4, undefined, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
        });
    }
}





'use client';
function $34ef30a348505f7e$export$609860bf8b0084c(arg1, arg2, arg3) {
    const options = (0, $18693172d3695360$export$b646c531ea475334)(arg1, arg2, arg3);
    const queryClient = (0, $7fd0e6909adb481d$export$22e77b9572c4fded)({
        context: options.context
    });
    const [observer] = $ieT14.useState(()=>new (0, $a0a85f4baed61d3e$export$d3c1860ee66f291a)(queryClient, options));
    $ieT14.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = (0, $c6770b5961e89267$export$306c0aa65ff9ec16)($ieT14.useCallback((onStoreChange)=>observer.subscribe((0, $c92d7790084acd39$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $ieT14.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch($34ef30a348505f7e$var$noop);
    }, [
        observer
    ]);
    if (result.error && (0, $ed090e6cb168c602$export$2072f68e6c3507cf)(observer.options.useErrorBoundary, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
} // eslint-disable-next-line @typescript-eslint/no-empty-function
function $34ef30a348505f7e$var$noop() {}




var $a9d5bf712846139f$export$905dbc95765b1ada = /*#__PURE__*/ function(SegmentAttributeOperator) {
    SegmentAttributeOperator[SegmentAttributeOperator["And"] = 0] = "And";
    SegmentAttributeOperator[SegmentAttributeOperator["Or"] = 1] = "Or";
    return SegmentAttributeOperator;
}({});
var $a9d5bf712846139f$export$165a359d8710f906 = /*#__PURE__*/ function(SegmentFilterOperator) {
    SegmentFilterOperator[SegmentFilterOperator["Is"] = 0] = "Is";
    SegmentFilterOperator[SegmentFilterOperator["Is Not"] = 1] = "Is Not";
    SegmentFilterOperator[SegmentFilterOperator["Begins With"] = 2] = "Begins With";
    SegmentFilterOperator[SegmentFilterOperator["Does Not Begin With"] = 3] = "Does Not Begin With";
    SegmentFilterOperator[SegmentFilterOperator["Ends With"] = 4] = "Ends With";
    SegmentFilterOperator[SegmentFilterOperator["Does Not End With"] = 5] = "Does Not End With";
    SegmentFilterOperator[SegmentFilterOperator["Contains"] = 6] = "Contains";
    SegmentFilterOperator[SegmentFilterOperator["Does Not Contain"] = 7] = "Does Not Contain";
    SegmentFilterOperator[SegmentFilterOperator["Where"] = 8] = "Where";
    return SegmentFilterOperator;
}({});
var $a9d5bf712846139f$export$13d7493ba19b9f11 = /*#__PURE__*/ function(SegmentAttributeFilterRender) {
    SegmentAttributeFilterRender[SegmentAttributeFilterRender["Input"] = 0] = "Input";
    SegmentAttributeFilterRender[SegmentAttributeFilterRender["Options"] = 1] = "Options";
    SegmentAttributeFilterRender[SegmentAttributeFilterRender["Range"] = 2] = "Range";
    SegmentAttributeFilterRender[SegmentAttributeFilterRender["Datetime"] = 3] = "Datetime";
    SegmentAttributeFilterRender[SegmentAttributeFilterRender["Transactional"] = 4] = "Transactional";
    return SegmentAttributeFilterRender;
}({});
var $a9d5bf712846139f$export$48733c9c52b2aead = /*#__PURE__*/ function(GroupByAggregateFunction) {
    GroupByAggregateFunction[GroupByAggregateFunction["Sum"] = 0] = "Sum";
    GroupByAggregateFunction[GroupByAggregateFunction["Average"] = 1] = "Average";
    GroupByAggregateFunction[GroupByAggregateFunction["Count"] = 2] = "Count";
    GroupByAggregateFunction[GroupByAggregateFunction["Count Distinct"] = 3] = "Count Distinct";
    GroupByAggregateFunction[GroupByAggregateFunction["Minimum"] = 4] = "Minimum";
    GroupByAggregateFunction[GroupByAggregateFunction["Maximum"] = 5] = "Maximum";
    return GroupByAggregateFunction;
}({});
var $a9d5bf712846139f$export$a7b636559b01a55f = /*#__PURE__*/ function(GroupByOperator) {
    GroupByOperator[GroupByOperator["Is Greater Than"] = 0] = "Is Greater Than";
    GroupByOperator[GroupByOperator["Is Less Than"] = 1] = "Is Less Than";
    GroupByOperator[GroupByOperator["Is Equal To"] = 2] = "Is Equal To";
    return GroupByOperator;
}({});



var $fRnKy = parcelRequire("fRnKy");
const $6a74c864676f2556$var$isInputAttribute = (filterOperator, selectedAttribute)=>{
    return !(filterOperator === (0, $a9d5bf712846139f$export$165a359d8710f906).Is || filterOperator === (0, $a9d5bf712846139f$export$165a359d8710f906)['Is Not']) || 'searchText' in selectedAttribute;
};
const $6a74c864676f2556$export$18b16d7af99ad313 = (attribute, selectedAttribute)=>{
    if (attribute) {
        if (attribute.filterType === 'options') {
            if ($6a74c864676f2556$var$isInputAttribute(selectedAttribute.filterOperator, selectedAttribute)) return (0, $a9d5bf712846139f$export$13d7493ba19b9f11).Input;
            else if ('options' in selectedAttribute) return (0, $a9d5bf712846139f$export$13d7493ba19b9f11).Options;
        }
        if (attribute.filterType === 'range' && 'range' in selectedAttribute) return (0, $a9d5bf712846139f$export$13d7493ba19b9f11).Range;
        if (attribute.filterType === 'datetime' && ('dateRange' in selectedAttribute || 'numberOfDays' in selectedAttribute)) return (0, $a9d5bf712846139f$export$13d7493ba19b9f11).Datetime;
        return (0, $a9d5bf712846139f$export$13d7493ba19b9f11).Transactional;
    }
    return undefined;
};
const $6a74c864676f2556$export$e13898261d3600c8 = (id, name, columnName)=>{
    return {
        isError: false,
        error: undefined,
        isLoading: false,
        data: {
            id: id,
            name: name,
            columnName: columnName,
            populatedPercentage: undefined,
            filterType: undefined,
            isTransactional: true,
            filters: {
                where: 'all'
            }
        }
    };
};
function $6a74c864676f2556$export$1363d1c8d6e714b5(predicate) {
    if ('attributeId' in predicate) return predicate.attributeId;
    return $6a74c864676f2556$export$1363d1c8d6e714b5(predicate.predicates[0]);
}
const $6a74c864676f2556$export$56656b6753da686 = 1000000;
const $6a74c864676f2556$export$6c2f0c4ba08ceac5 = (attribute)=>{
    const attributeId = attribute['attributeId'] || attribute['id'];
    const newId = !attribute.isTransactional ? attributeId : attributeId + $6a74c864676f2556$export$56656b6753da686;
    return {
        ...attribute,
        id: newId,
        attributeId: newId,
        filterOperator: !attribute.isTransactional ? attribute.filterOperator : (0, $a9d5bf712846139f$export$165a359d8710f906).Where
    };
};
const $6a74c864676f2556$export$ab977a05d452db44 = (attribute)=>{
    const attributeId = attribute['attributeId'] || attribute['id'];
    const newId = !attribute.isTransactional ? attributeId : attributeId - $6a74c864676f2556$export$56656b6753da686;
    if (attribute.isTransactional) attribute = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).omit(attribute, [
        'options',
        'dateRange',
        'range',
        'numberOfDays'
    ]);
    return {
        ...attribute,
        id: newId,
        attributeId: newId
    };
};
const $6a74c864676f2556$export$616542113386b517 = (attributes)=>attributes?.map((attribute)=>{
        if ('predicates' in attribute) {
            const listOfAttributes = $6a74c864676f2556$export$616542113386b517(attribute.predicates);
            return {
                operator: attribute.operator,
                predicates: listOfAttributes,
                customers: attribute.customers
            };
        } else {
            const attributeId = attribute['attributeId'] || attribute['id'];
            const newId = !attribute.isTransactional ? attributeId : attributeId + $6a74c864676f2556$export$56656b6753da686;
            return {
                ...attribute,
                id: newId,
                attributeId: newId,
                filterOperator: !attribute.isTransactional ? attribute.filterOperator : (0, $a9d5bf712846139f$export$165a359d8710f906).Where
            };
        }
    });
const $6a74c864676f2556$export$c5f6e2d1b329a9aa = (attributes)=>attributes?.map((attribute)=>{
        if ('predicates' in attribute) {
            const listOfAttributes = $6a74c864676f2556$export$c5f6e2d1b329a9aa(attribute.predicates);
            return {
                operator: attribute.operator,
                predicates: listOfAttributes,
                customers: attribute.customers
            };
        } else {
            const attributeId = attribute['attributeId'] || attribute['id'];
            const newId = !attribute.isTransactional ? attributeId : attributeId - $6a74c864676f2556$export$56656b6753da686;
            if (attribute.isTransactional) attribute = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).omit(attribute, [
                'options',
                'dateRange',
                'range',
                'numberOfDays'
            ]);
            return {
                ...attribute,
                id: newId,
                attributeId: newId
            };
        }
    });


function $dd3a9e68638db4d4$export$4bb391d737872cb3(segmentId) {
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    const queryClient = (0, $7fd0e6909adb481d$export$22e77b9572c4fded)();
    const appState = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const cleanUpNewSegment = (key, value)=>{
        if (key === 'composition' && Object.keys(value).length === 0) return undefined;
        return value;
    };
    return (0, $34ef30a348505f7e$export$609860bf8b0084c)((newSegment)=>{
        return fetchWrapper(`api/${appState.state.clientId}/segments/${segmentId}`, {
            method: 'PUT',
            body: JSON.stringify({
                ...newSegment,
                attributes: {
                    ...newSegment.attributes,
                    include: {
                        ...newSegment.attributes.include,
                        predicates: (0, $6a74c864676f2556$export$c5f6e2d1b329a9aa)(newSegment.attributes.include.predicates)
                    },
                    exclude: {
                        ...newSegment.attributes.exclude,
                        predicates: (0, $6a74c864676f2556$export$c5f6e2d1b329a9aa)(newSegment.attributes.exclude?.predicates)
                    }
                },
                composition: {
                    ...newSegment.composition
                }
            }, cleanUpNewSegment)
        });
    }, {
        onSuccess: ()=>{
            queryClient.invalidateQueries([
                'segment',
                segmentId
            ]);
            queryClient.invalidateQueries([
                'segments'
            ]);
        }
    });
}
function $dd3a9e68638db4d4$export$5fadda07e3eb09fd() {
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    const queryClient = (0, $7fd0e6909adb481d$export$22e77b9572c4fded)();
    const appState = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    return (0, $34ef30a348505f7e$export$609860bf8b0084c)((variables)=>{
        return fetchWrapper(`api/${appState.state.clientId}/segments/${variables.segmentId}/shared`, {
            method: 'PUT',
            body: JSON.stringify({
                isShared: variables.isShared
            })
        });
    }, {
        onSuccess: (_data, variables)=>{
            queryClient.invalidateQueries([
                'segment',
                String(variables.segmentId)
            ]);
            queryClient.invalidateQueries([
                'segments'
            ]);
            queryClient.invalidateQueries([
                'available-compositions'
            ]);
            queryClient.invalidateQueries([
                'dependencies'
            ]);
        }
    });
}




const $b9379467d5ad0a14$var$useStyles = (0, $e1ONw.default)({
    select: {
        minWidth: 105,
        // visually hide the select label
        '& label.Mui-focused, & label.MuiFormLabel-filled': {
            clip: 'rect(0 0 0 0)',
            clipPath: 'inset(50%)',
            height: 1,
            overflow: 'hidden',
            position: 'absolute',
            whiteSpace: 'nowrap',
            width: 1
        },
        '& .MuiSelect-root': {
            padding: '5px 26px 5px 6px',
            fontSize: 12,
            fontWeight: 300,
            fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).body,
            borderColor: (0, $69ed148db7543104$export$a4867fe9454f37a8)[300]
        },
        '& .MuiSelect-iconOutlined': {
            right: 0
        }
    },
    innerContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    errorIcon: {
        marginLeft: 4
    }
});
const $b9379467d5ad0a14$var$SharingCell = ({ segment: segment })=>{
    const overrides = $b9379467d5ad0a14$var$useStyles();
    const segmentSharingMutation = (0, $dd3a9e68638db4d4$export$5fadda07e3eb09fd)();
    const userInterface = window.env.USER_INTERFACE != null ? window.env.USER_INTERFACE : 'default';
    const [isShared, setIsShared] = $ieT14.useState(segment.isShared);
    $ieT14.useEffect(()=>{
        setIsShared(segment.isShared);
    }, [
        segment
    ]);
    function onSharedChange(shared) {
        segmentSharingMutation.mutate({
            segmentId: segment.id,
            isShared: shared === 'Share'
        }, {
            onSuccess: (_data, variables)=>setIsShared(variables.isShared)
        });
    }
    if (userInterface === 'management' || !segment.isEditable) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
        children: segment.isShared ? 'Shared' : 'Not Shared'
    });
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
            className: overrides.innerContainer,
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
                    size: "small",
                    variant: "outlined",
                    className: overrides.select,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $Uxz4Y.default), {
                            id: "shared-select-label",
                            children: "Shared"
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $aanJt.default), {
                            labelId: "shared-select-label",
                            id: "shared-select",
                            value: isShared ? 'Share' : 'Do not share',
                            onChange: (event)=>onSharedChange(event.target.value),
                            disabled: segmentSharingMutation.isLoading,
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                    value: "Share",
                                    children: "Share"
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                    value: "Do not share",
                                    children: "Do not share"
                                })
                            ]
                        })
                    ]
                }),
                segmentSharingMutation.isError && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $356Vi.default), {
                    title: segmentSharingMutation.error.message,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1vmhz.default), {
                        htmlColor: (0, $69ed148db7543104$export$471f7ae5c4103ae1).error.dark,
                        fontSize: "small",
                        className: overrides.errorIcon
                    })
                })
            ]
        })
    });
};
var $b9379467d5ad0a14$export$2e2bcd8739ae039 = $b9379467d5ad0a14$var$SharingCell;



var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $f02d5e2ef63acbfe$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M17 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-6 8H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2zm-3-4h8v2H8zm9-4h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-6 8H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2zm-3-4h8v2H8z"
}), 'LinkSharp');


var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $acd0459d69229986$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreVertSharp');



var $ieT14 = parcelRequire("ieT14");



function $450578b3a5744949$export$8451d8228c915887() {
    const appState = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    const queryClient = (0, $7fd0e6909adb481d$export$22e77b9572c4fded)();
    return (0, $34ef30a348505f7e$export$609860bf8b0084c)((segemtDelete)=>{
        const { segmentId: segmentId } = segemtDelete;
        return fetchWrapper(`api/${appState.state.clientId}/segments/${segmentId}`, {
            method: 'DELETE'
        });
    }, {
        onSuccess: ()=>{
            queryClient.invalidateQueries([
                'segments'
            ]);
            queryClient.invalidateQueries([
                'segment'
            ]);
            queryClient.invalidateQueries([
                'available-compositions'
            ]);
            queryClient.invalidateQueries([
                'dependencies'
            ]);
        }
    });
}







const $0dcf413cd3c5adee$var$useStyles = (0, $e1ONw.default)((theme)=>({
        dialog: {
            [theme.breakpoints.up('sm')]: {
                '& .MuiDialog-paperWidthSm': {
                    width: '95rem',
                    maxWidth: '95rem'
                }
            }
        },
        dialogContent: {
            padding: 0
        },
        dialogActions: {
            justifyContent: 'space-between',
            height: 57,
            padding: '0 24px'
        },
        divider: {
            height: '25px',
            borderRight: '1px solid #979797',
            margin: '5px 0'
        },
        deleteMessage: {
            position: 'absolute',
            top: '20px',
            left: '45%'
        },
        linkCell: {
            '& td,th': {
                '&:first-child': {
                    paddingLeft: 0,
                    paddingRight: 5,
                    textAlign: 'center'
                }
            }
        },
        noResultsMessage: {
            paddingLeft: 38
        },
        linkIconAlign: {
            paddingTop: 5
        }
    }));
const $0dcf413cd3c5adee$var$SegmentsTable = ({ columnHeaders: columnHeaders, initialSortState: initialSortState, activeFilters: activeFilters })=>{
    const overrides = $0dcf413cd3c5adee$var$useStyles();
    const [sort, setSort] = $ieT14.useState(initialSortState);
    const [searchValue, setSearchValue] = $ieT14.useState();
    const [activeSearchTerm, setActiveSearchTerm] = $ieT14.useState();
    const segmentsQuery = (0, $bc1da11b3d648f78$export$35888604389caffd)(sort, activeSearchTerm, activeFilters);
    const [deleteSegment, setDeleteSegment] = $ieT14.useState(null);
    const segmentDelete = (0, $450578b3a5744949$export$8451d8228c915887)();
    const { successMessage: successMessage, setSuccessMessage: setSuccessMessage } = (0, $dc97b0794e0fd33b$export$2e2bcd8739ae039)();
    const appState = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { getCurrentUser: getCurrentUser } = (0, $b19aa392df0f3838$export$2e2bcd8739ae039)();
    const [segmentationPermission, setSegmentationPermission] = $ieT14.useState(0);
    const userName = $ieT14.useRef('');
    $ieT14.useEffect(()=>{
        checkUser();
    }, []);
    const checkUser = async ()=>{
        try {
            const currentUser = await getCurrentUser();
            userName.current = `${currentUser.firstName} ${currentUser.lastName}`;
            const assignedSegmentation = currentUser.assignedSegmentation.find((as)=>as.clientId === appState.state.clientId);
            setSegmentationPermission(assignedSegmentation.segmentationPermission);
        } catch (error) {
            setSegmentationPermission(0);
        }
    };
    const userInterface = window.env.USER_INTERFACE ?? 'default';
    function reorderHandler(column, direction) {
        setSort((state)=>({
                ...state,
                orderColumn: column,
                orderDirection: direction
            }));
    }
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $246ccfbc8d89a664$export$a7db06668cad9adb,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $246ccfbc8d89a664$export$48884d2a5190dc73,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        className: $246ccfbc8d89a664$export$12948adc4d562794,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h2", {
                                className: $246ccfbc8d89a664$export$82456417dae51472,
                                children: "Team Segments"
                            }),
                            segmentsQuery.isFetching && !segmentsQuery.isLoading && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {
                                size: "16px"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SearchBar), {
                        value: searchValue,
                        updateValue: setSearchValue,
                        placeholder: "Search by Name",
                        submitHandler: ()=>setActiveSearchTerm(searchValue)
                    })
                ]
            }),
            segmentsQuery.isLoading && !segmentsQuery.data && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $246ccfbc8d89a664$export$46c1c92549715335,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
            }),
            segmentsQuery.isError && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $246ccfbc8d89a664$export$a3bc9b8ed74fc,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
                    type: "error",
                    message: `Failed to fetch results: ${segmentsQuery.error.message}`
                })
            }),
            segmentsQuery.data && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $246ccfbc8d89a664$export$e7d47881ec916f76,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $fgoQ6.Table), {
                    className: $246ccfbc8d89a664$export$9852986a3ec5f6a0,
                    loading: segmentsQuery.isPreviousData && segmentsQuery.isFetching,
                    results: segmentsQuery.data.results,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $fgoQ6.TableHead), {
                            className: overrides.linkCell,
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.HeaderCell), {
                                    title: ""
                                }),
                                columnHeaders.map((header)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.HeaderCell), {
                                        title: header.title,
                                        orderField: header.orderField ? header.orderField : null,
                                        orderColumn: header.orderField ? sort.orderColumn : null,
                                        orderDirection: header.orderField ? sort.orderDirection : null,
                                        reorderHandler: header.orderField ? reorderHandler : null
                                    }, header.title)),
                                userInterface !== 'management' && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.HeaderCell), {
                                    title: ""
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $fgoQ6.TableBody), {
                            className: overrides.linkCell,
                            children: [
                                segmentsQuery.data.totalItems === 0 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                        colSpan: columnHeaders.length,
                                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                            className: overrides.noResultsMessage,
                                            children: "No results found"
                                        })
                                    })
                                }),
                                segmentsQuery.data.results.map((data)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                                children: data.isDependency && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                                    className: overrides.linkIconAlign,
                                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f02d5e2ef63acbfe$export$2e2bcd8739ae039), {})
                                                })
                                            }),
                                            columnHeaders.find((header)=>header.title == 'Team') !== undefined && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                                children: data.clientName
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6mt9R.Link), {
                                                    to: {
                                                        pathname: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Segment.replace(':segmentId', String(data.id)),
                                                        state: {
                                                            isEditing: false
                                                        }
                                                    },
                                                    className: $246ccfbc8d89a664$export$a80eff00d507d114,
                                                    onClick: ()=>{
                                                        (0, $80940237791545d7$export$65cc181beb0d2632).addUserAction('view-segment', {
                                                            user_action_details: {
                                                                segment_id: data.id,
                                                                segment_name: data.name,
                                                                is_segment_shared: data.isShared ? 'Shared' : 'Not Shared',
                                                                user_name: userName.current
                                                            }
                                                        });
                                                    },
                                                    children: data.name
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                                className: $246ccfbc8d89a664$export$120b13130c77685f,
                                                children: (0, $28c5efff86001588$export$3245e15bf4cbdd6c).format(new Date(data.lastModifiedDate))
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                                children: data.description
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                                children: data.totalCustomers.toLocaleString()
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                                children: data.createdByName
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $b9379467d5ad0a14$export$2e2bcd8739ae039), {
                                                segment: data
                                            }),
                                            userInterface !== 'management' && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($0dcf413cd3c5adee$var$SegmentOptions, {
                                                segment: data,
                                                segmentationPermission: segmentationPermission,
                                                deleteModal: (segment)=>setDeleteSegment(segment),
                                                userName: userName.current
                                            })
                                        ]
                                    }, `${data.id}`))
                            ]
                        })
                    ]
                })
            }),
            segmentsQuery.data && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $246ccfbc8d89a664$export$e19d3e3c28de4af,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fce6a9cfa0ef4de9$export$2e2bcd8739ae039), {
                    totalPages: Math.ceil(segmentsQuery.data.totalItems / sort.pageSize),
                    pageSize: sort.pageSize,
                    currentPage: sort.page,
                    disabled: segmentsQuery.isPreviousData && segmentsQuery.isFetching,
                    handlePageChange: (page)=>setSort((state)=>({
                                ...state,
                                page: page
                            })),
                    handlePageSizeChange: (pageSize)=>setSort((state)=>({
                                ...state,
                                pageSize: pageSize
                            }))
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $1c689a1559dbf5e9$export$2e2bcd8739ae039), {
                open: !!deleteSegment,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6830d3674ad61fd5$export$2e2bcd8739ae039), {
                        disableTypography: true,
                        children: "Delete Segment"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $881610d42277b808$export$2e2bcd8739ae039), {
                        children: "Are you sure you want to delete this segment?"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $d176cc26269b23c2$export$2e2bcd8739ae039), {
                        className: overrides.dialogActions,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.TertiaryButton), {
                                text: "Cancel",
                                title: "Cancel",
                                component: "button",
                                handleClick: ()=>setDeleteSegment(null)
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryButton), {
                                text: "Delete",
                                title: "Delete",
                                handleClick: ()=>{
                                    segmentDelete.mutate({
                                        segmentId: deleteSegment.id
                                    }, {
                                        onSuccess () {
                                            (0, $80940237791545d7$export$65cc181beb0d2632).addUserAction('delete-segment', {
                                                user_action_details: {
                                                    segment_id: deleteSegment.id,
                                                    segment_name: deleteSegment.name,
                                                    is_segment_shared: deleteSegment.isShared ? 'Shared' : 'Not Shared',
                                                    user_name: userName.current
                                                }
                                            });
                                            segmentsQuery.refetch();
                                            setSuccessMessage('Segment deleted');
                                        },
                                        onSettled () {
                                            setDeleteSegment(null);
                                        }
                                    });
                                }
                            })
                        ]
                    })
                ]
            }),
            successMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: overrides.deleteMessage,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
                    type: "success",
                    message: successMessage
                })
            })
        ]
    });
};
const $0dcf413cd3c5adee$var$SegmentOptions = ({ segment: segment, segmentationPermission: segmentationPermission, deleteModal: deleteModal, userName: userName })=>{
    const history = (0, $eYoAG.useHistory)();
    const [anchorEl, setAnchorEl] = $ieT14.useState(null);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("td", {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                "aria-controls": "segment-options-menu",
                "aria-haspopup": "true",
                onClick: handleClick,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $acd0459d69229986$export$2e2bcd8739ae039), {
                    color: "secondary"
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $5TjLg.default), {
                id: "segment-options-menu",
                anchorEl: anchorEl,
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: handleClose,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                        onClick: ()=>{
                            handleClose();
                            (0, $80940237791545d7$export$65cc181beb0d2632).addUserAction('clone-segment', {
                                user_action_details: {
                                    segment_id: segment.id,
                                    segment_name: segment.name,
                                    is_segment_shared: segment.isShared ? 'Shared' : 'Not Shared',
                                    user_name: userName
                                }
                            });
                            history.push(`${(0, $4bbac098dba9d86f$export$2e2bcd8739ae039).NewSegment}?clonedId=${segment.id}`);
                        },
                        children: "Clone"
                    }),
                    (segment.isEditable || segmentationPermission === (0, $5294e215b521479c$export$2e2bcd8739ae039).Power) && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                        onClick: ()=>{
                            handleClose();
                            deleteModal(segment);
                        },
                        children: "Delete"
                    }),
                    (segment.isEditable || segmentationPermission === (0, $5294e215b521479c$export$2e2bcd8739ae039).Power) && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                        onClick: ()=>{
                            handleClose();
                            history.push(`${(0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Segment.replace(':segmentId', String(segment.id))}`, {
                                isEditing: true
                            });
                        },
                        children: "Edit"
                    })
                ]
            })
        ]
    });
};
var $0dcf413cd3c5adee$export$2e2bcd8739ae039 = $0dcf413cd3c5adee$var$SegmentsTable;



var $8b17776987f48cd0$export$2ef47a058bb9473c = /*#__PURE__*/ function(SegmentSortFields) {
    SegmentSortFields["Name"] = "name";
    SegmentSortFields["LastModified"] = "lastModifiedDate";
    SegmentSortFields["CreatedBy"] = "createdByName";
    SegmentSortFields["Customers"] = "customers";
    SegmentSortFields["Sharing"] = "isShared";
    return SegmentSortFields;
}({});
const $8b17776987f48cd0$export$82e642b0d625c931 = {
    startDate: null,
    endDate: null,
    min: '',
    max: '',
    isShared: [],
    users: []
};
const $8b17776987f48cd0$export$3f583c8dc8ad42b7 = [
    {
        title: 'Name',
        orderField: "name"
    },
    {
        title: 'Modified Date',
        orderField: "lastModifiedDate"
    },
    {
        title: 'Description'
    },
    {
        title: '# of Customers',
        orderField: "customers"
    },
    {
        title: 'Created By',
        orderField: "createdByName"
    },
    {
        title: 'Sharing',
        orderField: "isShared"
    }
];
const $8b17776987f48cd0$var$initialSortState = {
    page: 1,
    pageSize: 15,
    orderColumn: "lastModifiedDate",
    orderDirection: 'desc'
};
/**
 * User view of the available segments table
 */ const $8b17776987f48cd0$var$Segments = ()=>{
    const [activeFilters, setActiveFilters] = $ieT14.useState($8b17776987f48cd0$export$82e642b0d625c931);
    const filtersQuery = (0, $5255668c33a98545$export$5aedb1be3806683c)();
    const history = (0, $eYoAG.useHistory)();
    const location = (0, $eYoAG.useLocation)();
    const { successMessage: successMessage, setSuccessMessage: setSuccessMessage } = (0, $fgoQ6.useTimedAlerts)();
    $ieT14.useEffect(()=>{
        if (location.state && location.state.successMessage) {
            setSuccessMessage(location.state.successMessage);
            // Reset the scroll to the top of the segment overview in case the scroll state was changed while updating the segment
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        }
    }, [
        location.state
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $246ccfbc8d89a664$export$e8e78c978b129247,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $246ccfbc8d89a664$export$38e42c68cf43b5d4,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h1", {
                        children: "Segments"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryButton), {
                        text: "Create New Segment",
                        handleClick: ()=>{
                            history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).NewSegment);
                        }
                    })
                ]
            }),
            successMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
                type: "success",
                message: successMessage
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $lwgYO.default), {
                elevation: 1,
                className: $246ccfbc8d89a664$export$914772be44022da8,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $a9c90e42e1f0237c$export$2e2bcd8739ae039), {
                        setActiveFilters: setActiveFilters,
                        defaultActiveFilters: $8b17776987f48cd0$export$82e642b0d625c931,
                        isLoading: filtersQuery.isLoading,
                        loadedFilters: filtersQuery.data
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $0dcf413cd3c5adee$export$2e2bcd8739ae039), {
                        columnHeaders: $8b17776987f48cd0$export$3f583c8dc8ad42b7,
                        initialSortState: $8b17776987f48cd0$var$initialSortState,
                        activeFilters: activeFilters
                    })
                ]
            })
        ]
    });
};
var $8b17776987f48cd0$export$2e2bcd8739ae039 = $8b17776987f48cd0$var$Segments;




var $fgoQ6 = parcelRequire("fgoQ6");

var $ieT14 = parcelRequire("ieT14");

var $adc248bb409000ee$export$b0377cbbbdab6cba;
var $adc248bb409000ee$export$f27f0a643498ce3d;
var $adc248bb409000ee$export$b00c055587dc7469;
var $adc248bb409000ee$export$b1a09d22b7ad6c4;
var $adc248bb409000ee$export$509f3108fdd206bb;
var $adc248bb409000ee$export$42ff741d2868ee32;
var $adc248bb409000ee$export$8c430709db82137d;
var $adc248bb409000ee$export$2d4b1211b4389c3b;
var $adc248bb409000ee$export$3832be13857745bc;
var $adc248bb409000ee$export$f4c68800b094ddb1;
var $adc248bb409000ee$export$e8e78c978b129247;
var $adc248bb409000ee$export$a3bc9b8ed74fc;
var $adc248bb409000ee$export$59bc6e0c0b51d74a;
var $adc248bb409000ee$export$370d47912bf58482;
var $adc248bb409000ee$export$c4cc592d9243d26f;
var $adc248bb409000ee$export$9f9fbb0073a1ff20;
var $adc248bb409000ee$export$665e0f4515a68234;
var $adc248bb409000ee$export$f22da7240b7add18;
$adc248bb409000ee$export$b0377cbbbdab6cba = "#006da8";
$adc248bb409000ee$export$f27f0a643498ce3d = "#00aafc";
$adc248bb409000ee$export$b00c055587dc7469 = "#f5dbd9";
$adc248bb409000ee$export$b1a09d22b7ad6c4 = "#c92100";
$adc248bb409000ee$export$509f3108fdd206bb = "#ebafa6";
$adc248bb409000ee$export$42ff741d2868ee32 = "#074f86";
$adc248bb409000ee$export$8c430709db82137d = "#dadada";
$adc248bb409000ee$export$2d4b1211b4389c3b = "#dddbda";
$adc248bb409000ee$export$3832be13857745bc = "#eae9ed";
$adc248bb409000ee$export$f4c68800b094ddb1 = "#e9e8f4";
$adc248bb409000ee$export$e8e78c978b129247 = "root_e85694";
$adc248bb409000ee$export$a3bc9b8ed74fc = "error_e85694";
$adc248bb409000ee$export$59bc6e0c0b51d74a = "detailsSectionContent_e85694";
$adc248bb409000ee$export$370d47912bf58482 = "descriptionField_e85694";
$adc248bb409000ee$export$c4cc592d9243d26f = "actionFooter_e85694";
$adc248bb409000ee$export$9f9fbb0073a1ff20 = "editFooter_e85694";
$adc248bb409000ee$export$665e0f4515a68234 = "buildSection_e85694";
$adc248bb409000ee$export$f22da7240b7add18 = "main_e85694";


var $8caa2dfa516972d4$export$a40ebde8ba896166;
var $8caa2dfa516972d4$export$38e42c68cf43b5d4;
$8caa2dfa516972d4$export$a40ebde8ba896166 = `m9UTIq_breadcrumb`;
$8caa2dfa516972d4$export$38e42c68cf43b5d4 = `m9UTIq_header`;



var $eYoAG = parcelRequire("eYoAG");

var $ieT14 = parcelRequire("ieT14");




function $ad0226f2a2576692$export$60a89511ea3568e3() {
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    const queryClient = (0, $7fd0e6909adb481d$export$22e77b9572c4fded)();
    const appState = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const cleanUpNewSegment = (key, value)=>{
        if (key === 'composition' && Object.keys(value).length === 0) return undefined;
        return value;
    };
    return (0, $34ef30a348505f7e$export$609860bf8b0084c)((newSegment)=>{
        return fetchWrapper(`api/${appState.state.clientId}/segments`, {
            method: 'POST',
            body: JSON.stringify({
                ...newSegment,
                attributes: {
                    ...newSegment.attributes,
                    include: {
                        ...newSegment.attributes.include,
                        predicates: (0, $6a74c864676f2556$export$c5f6e2d1b329a9aa)(newSegment.attributes.include.predicates)
                    },
                    exclude: {
                        ...newSegment.attributes.exclude,
                        predicates: (0, $6a74c864676f2556$export$c5f6e2d1b329a9aa)(newSegment.attributes.exclude?.predicates)
                    }
                },
                composition: {
                    ...newSegment.composition
                }
            }, cleanUpNewSegment)
        });
    }, {
        onSuccess: ()=>{
            queryClient.invalidateQueries([
                'segments'
            ]);
            queryClient.invalidateQueries([
                'available-compositions'
            ]);
        }
    });
}



parcelRequire("ieT14");

var $1KcBP = parcelRequire("1KcBP");


var $db7Kr = parcelRequire("db7Kr");

var $j6s32 = parcelRequire("j6s32");

const $365a06e4442a50da$var$useStyles = (0, $db7Kr.default)({
    root: {
        marginTop: 20
    },
    expand: {
        transform: 'rotate(0deg)',
        transition: 'transform 200ms'
    },
    expandOpen: {
        transform: 'rotate(180deg)'
    },
    sectionHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: `1px solid ${(0, $69ed148db7543104$export$a4867fe9454f37a8)[500]}`
    },
    title: {
        color: (0, $69ed148db7543104$export$a4867fe9454f37a8)[600],
        fontSize: 16,
        fontWeight: 600,
        margin: '8px 0',
        lineHeight: '1em'
    },
    actionWrapper: {
        display: 'flex',
        alignItems: 'center'
    }
});
function $365a06e4442a50da$export$55b973e094275b13({ title: title, titleComponent: TitleComponent = 'h2', collapsed: collapsed, onCollapse: onCollapse, children: children, className: className, secondaryAction: secondaryAction }) {
    const classes = $365a06e4442a50da$var$useStyles();
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("section", {
        className: (0, $j6s32.default)(classes.root, className),
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: classes.sectionHeader,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        className: classes.actionWrapper,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                                size: "small",
                                onClick: ()=>{
                                    onCollapse(!collapsed);
                                },
                                className: (0, $j6s32.default)(classes.expand, !collapsed && classes.expandOpen),
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $b231e483803be961$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)(TitleComponent, {
                                className: classes.title,
                                children: title
                            })
                        ]
                    }),
                    secondaryAction && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: classes.actionWrapper,
                        children: secondaryAction
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $863c87a667a3ccc1$export$2e2bcd8739ae039), {
                in: !collapsed,
                children: children
            })
        ]
    });
}




parcelRequire("ieT14");

var $whS22 = parcelRequire("whS22");
var $Uxz4Y = parcelRequire("Uxz4Y");
var $e1ONw = parcelRequire("e1ONw");
var $3mOXj = parcelRequire("3mOXj");
var $aanJt = parcelRequire("aanJt");
var $eYT2J = parcelRequire("eYT2J");


var $j6s32 = parcelRequire("j6s32");
const $17b3f83bdc759c12$var$useStyles = (0, $e1ONw.default)({
    inputs: {
        margin: '0 16px',
        '& .MuiInputLabel-asterisk': {
            color: (0, $69ed148db7543104$export$8f45430ccf837300).rustRed
        }
    },
    select: {
        minWidth: 160
    }
});
const $17b3f83bdc759c12$var$EditSegmentDetails = ({ name: name, description: description, shared: shared, onNameChange: onNameChange, onDescriptionChange: onDescriptionChange, onSharedChange: onSharedChange, isClonedSegment: isClonedSegment })=>{
    const overrides = $17b3f83bdc759c12$var$useStyles();
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $adc248bb409000ee$export$59bc6e0c0b51d74a,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYT2J.default), {
                size: "small",
                variant: "outlined",
                label: "Segment Name",
                id: "segment-name",
                className: overrides.inputs,
                required: true,
                value: name,
                onChange: (event)=>{
                    onNameChange(event.target.value);
                },
                inputProps: {
                    maxLength: 100
                },
                autoFocus: isClonedSegment
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYT2J.default), {
                size: "small",
                variant: "outlined",
                label: "Segment Description",
                id: "segment-description",
                className: (0, $j6s32.default)(overrides.inputs, $adc248bb409000ee$export$370d47912bf58482),
                required: true,
                value: description,
                onChange: (event)=>{
                    onDescriptionChange(event.target.value);
                },
                inputProps: {
                    maxLength: 500
                }
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
                required: true,
                size: "small",
                variant: "outlined",
                className: (0, $j6s32.default)(overrides.inputs, overrides.select),
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $Uxz4Y.default), {
                        id: "shared-select-label",
                        children: "Shared"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $aanJt.default), {
                        labelId: "shared-select-label",
                        id: "shared-select",
                        value: shared,
                        onChange: (event)=>onSharedChange(event.target.value),
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                value: "Share",
                                children: "Share"
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                value: "Do not share",
                                children: "Do not share"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $17b3f83bdc759c12$export$2e2bcd8739ae039 = $17b3f83bdc759c12$var$EditSegmentDetails;




var $ieT14 = parcelRequire("ieT14");

var $ekezX = parcelRequire("ekezX");
var $fpdl2 = parcelRequire("fpdl2");
var $e1ONw = parcelRequire("e1ONw");
var $356Vi = parcelRequire("356Vi");

var $1vmhz = parcelRequire("1vmhz");
var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $4ed0027b15bcfd82$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
}), 'GetApp');





var $ieT14 = parcelRequire("ieT14");




function $b579f40dda2316fa$export$3ac7c39b1cdb82f6() {
    const appState = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    return (0, $34ef30a348505f7e$export$609860bf8b0084c)((exportConfig)=>{
        return fetchWrapper(`api/${appState.state.clientId}/segments/customers/csv`, {
            method: 'POST',
            body: JSON.stringify({
                ...exportConfig,
                attributes: {
                    ...exportConfig.attributes,
                    include: {
                        ...exportConfig.attributes.include,
                        predicates: (0, $6a74c864676f2556$export$c5f6e2d1b329a9aa)(exportConfig.attributes.include.predicates)
                    },
                    exclude: {
                        ...exportConfig.attributes.exclude,
                        predicates: (0, $6a74c864676f2556$export$c5f6e2d1b329a9aa)(exportConfig.attributes.exclude?.predicates)
                    }
                }
            })
        }, 'blob');
    });
}




var $3umuy = parcelRequire("3umuy");

const $4d5deb8da6079694$var$useStyles = (0, $e1ONw.default)({
    button: {
        '&.MuiButton-root': {
            fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).heading,
            fontSize: 11
        },
        '&.MuiButton-root:not(.Mui-disabled)': {
            color: (0, $69ed148db7543104$export$2aa0182783e7e9de)[600]
        }
    }
});
const $4d5deb8da6079694$var$ExportSegment = ({ name: name, includedAttributes: includedAttributes, excludedAttributes: excludedAttributes, segmentId: segmentId, segmentShared: segmentShared, userName: userName })=>{
    const overrides = $4d5deb8da6079694$var$useStyles();
    const exportQuery = (0, $b579f40dda2316fa$export$3ac7c39b1cdb82f6)();
    const { errorMessage: errorMessage, setErrorMessage: setErrorMessage } = (0, $dc97b0794e0fd33b$export$2e2bcd8739ae039)();
    const requestExport = ()=>{
        exportQuery.mutate({
            fileName: name,
            attributes: {
                include: includedAttributes,
                exclude: excludedAttributes
            }
        }, {
            onSuccess: (data)=>{
                const url = URL.createObjectURL(data);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${name || 'Untitled Segment'} ${(0, (/*@__PURE__*/$parcel$interopDefault($3umuy)))().format('YYYY-MM-DD')}.csv`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                (0, $80940237791545d7$export$65cc181beb0d2632).addUserAction('download-segment', {
                    user_action_details: {
                        segment_id: segmentId,
                        segment_name: name,
                        is_segment_shared: segmentShared,
                        user_name: userName
                    }
                });
            }
        });
    };
    $ieT14.useEffect(()=>{
        if (exportQuery.isError) setErrorMessage(exportQuery.error.message);
    }, [
        exportQuery.isError
    ]);
    $ieT14.useEffect(()=>{
        if (exportQuery.isLoading) setErrorMessage('');
    }, [
        exportQuery.isLoading
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
        children: [
            exportQuery.isLoading && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {
                size: "16px"
            }),
            errorMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $356Vi.default), {
                title: errorMessage,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1vmhz.default), {
                    htmlColor: (0, $69ed148db7543104$export$471f7ae5c4103ae1).error.dark
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $ekezX.default), {
                startIcon: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4ed0027b15bcfd82$export$2e2bcd8739ae039), {}),
                onClick: requestExport,
                className: overrides.button,
                disabled: includedAttributes.predicates.length === 0 && excludedAttributes.predicates.length === 0,
                children: "Download"
            })
        ]
    });
};
var $4d5deb8da6079694$export$2e2bcd8739ae039 = $4d5deb8da6079694$var$ExportSegment;



var $ieT14 = parcelRequire("ieT14");


var $fRnKy = parcelRequire("fRnKy");
const $79aece72917dec2b$export$917e8dab6495b1e6 = /*#__PURE__*/ $ieT14.createContext(undefined);
const $79aece72917dec2b$export$f754003632709cde = /*#__PURE__*/ $ieT14.createContext(undefined);
const $79aece72917dec2b$export$fe31d6c99f271165 = /*#__PURE__*/ $ieT14.createContext(undefined);
const $79aece72917dec2b$export$d84346a295b37585 = /*#__PURE__*/ $ieT14.createContext(undefined);
/**
 * Handles applyAttributes action
 */ const $79aece72917dec2b$var$handleApplyAttributesAction = (state, action)=>{
    const nextState = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).cloneDeep(state);
    // Zero attributes are checked this will remove that attribute grouping
    if (action.checked.length === 0) $79aece72917dec2b$var$mutateNode(nextState, (parentNode)=>{
        const lastPosition = action.position[action.position.length - 1];
        parentNode.predicates.splice(lastPosition, 1);
    }, action.position.slice(0, -1));
    else $79aece72917dec2b$var$mutateNode(nextState, (node)=>$79aece72917dec2b$var$applyAttributes(node, action.checked, action.attributes), action.position);
    return nextState;
};
/**
 * Handles deleteAttribute action
 */ const $79aece72917dec2b$var$handleDeleteAttributesAction = (state, action)=>{
    const nextState = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).cloneDeep(state);
    $79aece72917dec2b$var$mutateNode(nextState, (node)=>{
        node.predicates.splice(action.attributeIndex, 1);
        // if there are no items left in the group, remove the group
        if (node.predicates.length == 0) $79aece72917dec2b$var$mutateNode(nextState, (parentNode)=>{
            const lastPosition = action.position[action.position.length - 1];
            parentNode.predicates.splice(lastPosition, 1);
        }, action.position.slice(0, -1));
        else if (node.predicates.length > 0 && 'predicates' in node.predicates[0]) {
            const remainder = node.predicates;
            $79aece72917dec2b$var$mutateNode(nextState, (parentNode)=>{
                const lastPosition = action.position[action.position.length - 1];
                parentNode.predicates.splice(lastPosition, 1, remainder[0]);
            }, action.position.slice(0, -1));
        }
    }, action.position);
    return nextState;
};
/**
 * Handles updateAttribute action
 */ const $79aece72917dec2b$var$handleUpdateAttributeAction = (state, action)=>{
    const nextState = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).cloneDeep(state);
    $79aece72917dec2b$var$mutateNode(nextState, (node)=>{
        node.predicates = node.predicates.map((existingAttribute, index)=>{
            if ('attributeId' in existingAttribute && index == action.attributeIndex) return action.attribute;
            return existingAttribute;
        });
    }, action.position);
    return nextState;
};
/**
 * Handles updateOperator action
 */ const $79aece72917dec2b$var$handleUpdateOperatorAction = (state, action)=>{
    const nextState = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).cloneDeep(state);
    $79aece72917dec2b$var$mutateNode(nextState, (node)=>{
        node.operator = action.operator;
    }, action.position);
    return nextState;
};
/**
 * Handles convertAttributeToGroup action
 */ const $79aece72917dec2b$var$handleConvertAttributeToGroupAction = (state, action)=>{
    // convert an attribute to a group and apply newly selected attributes to the new group
    const newGroup = {
        operator: 0,
        predicates: [
            action.attribute
        ]
    };
    $79aece72917dec2b$var$applyAttributes(newGroup, action.newGroupAttributeIds, action.attributes);
    // swap out the original attribute for the new group
    return {
        operator: state.operator,
        predicates: state.predicates.map((predicate)=>{
            if ('attributeId' in predicate && predicate.attributeId === action.attribute.attributeId && predicate.isTransactional === action.attribute.isTransactional) return newGroup;
            return predicate;
        })
    };
};
const $79aece72917dec2b$var$handleApplyNewBaseGroup = (state, action)=>{
    const newGroup = {
        operator: 0,
        predicates: []
    };
    $79aece72917dec2b$var$applyAttributes(newGroup, action.newGroupAttributeIds, action.attributes);
    return {
        operator: state.operator,
        predicates: state.predicates.concat(newGroup)
    };
};
/**
 * Handles addGroup action
 */ const $79aece72917dec2b$var$handleAddGroupAction = (state, action)=>{
    if (action.attributeIdsToAdd.length === 0) return state;
    const nextState = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).cloneDeep(state);
    const newGroup = {
        operator: (0, $a9d5bf712846139f$export$905dbc95765b1ada).And,
        predicates: []
    };
    $79aece72917dec2b$var$applyAttributes(newGroup, action.attributeIdsToAdd, action.attributes);
    // if adding a group to an attribute in the base level, convert the attribute to a group first
    if (action.position.length === 0) {
        const attributeIndex = state.predicates.findIndex((predicate)=>'attributeId' in predicate && predicate.attributeId === action.afterAttributeId && predicate.isTransactional === action.afterIsTransactional);
        nextState.predicates.splice(attributeIndex, 1, {
            operator: (0, $a9d5bf712846139f$export$905dbc95765b1ada).And,
            predicates: [
                state.predicates[attributeIndex],
                newGroup
            ]
        });
    } else // otherwise simply add the new group after the appropriate attribute
    $79aece72917dec2b$var$mutateNode(nextState, (node)=>{
        const location = node.predicates.findIndex((predicate)=>'attributeId' in predicate && predicate.attributeId === action.afterAttributeId && predicate.isTransactional === action.afterIsTransactional);
        node.predicates.splice(location + 1, 0, newGroup);
    }, action.position);
    return nextState;
};
const $79aece72917dec2b$var$handleUpdateTransactionalFilter = (state, action)=>{
    const nextState = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).cloneDeep(state);
    $79aece72917dec2b$var$mutateNode(nextState, (node)=>{
        node.predicates = node.predicates.map((existingAttribute, index)=>{
            if ('attributeId' in existingAttribute && index == action.attributeIndex) return action.attribute;
            return existingAttribute;
        });
    }, action.position);
    return nextState;
};
function $79aece72917dec2b$export$86e9f3b355bd161d(state, action) {
    switch(action.type){
        case 'setAttributes':
            return action.attributes;
        case 'applyAttributes':
            return $79aece72917dec2b$var$handleApplyAttributesAction(state, action);
        case 'deleteAttribute':
            return $79aece72917dec2b$var$handleDeleteAttributesAction(state, action);
        case 'updateAttribute':
            return $79aece72917dec2b$var$handleUpdateAttributeAction(state, action);
        case 'updateOperator':
            return $79aece72917dec2b$var$handleUpdateOperatorAction(state, action);
        case 'convertAttributeToGroup':
            return $79aece72917dec2b$var$handleConvertAttributeToGroupAction(state, action);
        case 'addGroup':
            return $79aece72917dec2b$var$handleAddGroupAction(state, action);
        case 'updateTransactionalFilter':
            return $79aece72917dec2b$var$handleUpdateTransactionalFilter(state, action);
        case 'addNewBaseGroup':
            return $79aece72917dec2b$var$handleApplyNewBaseGroup(state, action);
        default:
            // @ts-ignore - default will only be reached if a new action type is unaccounted for
            throw new Error(`Unhandled action type: ${action.type}`);
    }
}
/**
 * Mutate a single attribute group node on the segment tree
 * @param groupNode the attribute group node object to mutate
 * @param mutate a function called to perform the mutation
 * @param position the position of the node as an array of predicate array locations starting with the root predicates property.
 *   ex. to mutate the root object, postion = []. To mutate the second child of the root predicates property, position = [1]
 * @returns null
 */ function $79aece72917dec2b$var$mutateNode(groupNode, mutate, position) {
    if (position.length === 0) {
        mutate(groupNode);
        return;
    }
    if ('predicates' in groupNode.predicates[position[0]]) $79aece72917dec2b$var$mutateNode(groupNode.predicates[position[0]], mutate, position.slice(1));
}
/**
 * Resolve checked attribute ids from attribute select dialog with previous predicates property of a SegmentAttributeGroup
 * @param node the segment tree node to mutate
 * @param checked an array of attribute ids requested by the user
 * @param attributes an array of attribute detail objects containing necessary attribute metadata
 */ function $79aece72917dec2b$var$applyAttributes(node, checked, attributes) {
    // for newly checked attributes at the base level, add and create default attribute filter objects based on filter type
    //@ts-ignore
    const newAttributes = checked.map((attributeId)=>{
        const attribute = attributes.find((attr)=>attr.id === attributeId);
        const commonAttributeInfo = {
            attributeId: attribute.id,
            columnName: attribute.columnName,
            name: attribute.name
        };
        if (attribute.filterType === 'options') return {
            ...commonAttributeInfo,
            filterOperator: (0, $a9d5bf712846139f$export$165a359d8710f906).Is,
            options: []
        };
        if (attribute.filterType === 'range') return {
            ...commonAttributeInfo,
            filterOperator: (0, $a9d5bf712846139f$export$165a359d8710f906).Is,
            range: {
                min: null,
                max: null
            }
        };
        if (attribute.filterType === 'datetime') return {
            ...commonAttributeInfo,
            filterOperator: (0, $a9d5bf712846139f$export$165a359d8710f906).Is,
            dateRange: {
                min: null,
                max: null
            }
        };
        if (attribute.isTransactional) return {
            ...commonAttributeInfo,
            filterOperator: (0, $a9d5bf712846139f$export$165a359d8710f906).Where,
            where: 'all',
            isTransactional: true
        };
    });
    node.predicates = [
        ...node.predicates,
        ...newAttributes
    ];
}
function $79aece72917dec2b$export$7cea9ed133024a2d(exclude) {
    const context = $ieT14.useContext(exclude ? $79aece72917dec2b$export$f754003632709cde : $79aece72917dec2b$export$917e8dab6495b1e6);
    if (context === undefined) throw new Error('useBuildSegment must be used within a BuildSegmentProvider');
    return context;
}
function $79aece72917dec2b$export$3260c0a5a28fb657(exclude) {
    const context = $ieT14.useContext(exclude ? $79aece72917dec2b$export$d84346a295b37585 : $79aece72917dec2b$export$fe31d6c99f271165);
    if (context === undefined) throw new Error('useBuildSegmentComposition must be used within a BuildSegmentProvider');
    return context;
}





var $ieT14 = parcelRequire("ieT14");

var $ieT14 = parcelRequire("ieT14");




const $146f6eb1ee275194$export$fd5d22c8ab0990ad = (includedAttributes, excludedAttributes, includedComposition, excludedComposition)=>{
    const appState = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    const hasIncludeAttributes = !!includedAttributes && includedAttributes.predicates.length > 0;
    const hasExcludeAttributes = !!excludedAttributes && excludedAttributes.predicates.length > 0;
    const hasIncludedComposition = !!includedComposition?.segmentId;
    const hasExcludedComposition = !!excludedComposition?.segmentId;
    const enabled = hasIncludeAttributes || hasExcludeAttributes;
    const attributesValid = $ieT14.useMemo(()=>{
        return !!includedAttributes && !!excludedAttributes;
    }, [
        includedAttributes,
        excludedAttributes
    ]);
    const queryKey = [
        'segment-results',
        appState.state.clientId,
        includedAttributes,
        excludedAttributes,
        includedComposition,
        excludedComposition
    ];
    const cleanUpNewSegment = (key, value)=>{
        if (key === 'composition' && Object.keys(value).length === 0) return undefined;
        return value;
    };
    return (0, $137a3b252d598119$export$dd0a697e1782aedd)(queryKey, ()=>{
        let selectedComposition = {};
        if (hasIncludedComposition) selectedComposition['include'] = {
            ...includedComposition
        };
        if (hasExcludedComposition) selectedComposition['exclude'] = {
            ...excludedComposition
        };
        return fetchWrapper(`api/${appState.state.clientId}/segments/customers`, {
            method: 'POST',
            body: JSON.stringify({
                attributes: {
                    include: {
                        ...includedAttributes,
                        predicates: (0, $6a74c864676f2556$export$c5f6e2d1b329a9aa)(includedAttributes?.predicates)
                    },
                    exclude: {
                        ...excludedAttributes,
                        predicates: (0, $6a74c864676f2556$export$c5f6e2d1b329a9aa)(excludedAttributes?.predicates)
                    }
                },
                composition: {
                    ...selectedComposition
                }
            }, cleanUpNewSegment)
        });
    }, {
        enabled: enabled && attributesValid,
        keepPreviousData: enabled
    });
};





var $fpdl2 = parcelRequire("fpdl2");

var $j6s32 = parcelRequire("j6s32");

var $fgoQ6 = parcelRequire("fgoQ6");
parcelRequire("ieT14");
var $d74434fe0d31e6a3$export$b0377cbbbdab6cba;
var $d74434fe0d31e6a3$export$f27f0a643498ce3d;
var $d74434fe0d31e6a3$export$b00c055587dc7469;
var $d74434fe0d31e6a3$export$b1a09d22b7ad6c4;
var $d74434fe0d31e6a3$export$509f3108fdd206bb;
var $d74434fe0d31e6a3$export$42ff741d2868ee32;
var $d74434fe0d31e6a3$export$8c430709db82137d;
var $d74434fe0d31e6a3$export$2d4b1211b4389c3b;
var $d74434fe0d31e6a3$export$3832be13857745bc;
var $d74434fe0d31e6a3$export$f4c68800b094ddb1;
var $d74434fe0d31e6a3$export$81d69db2e95c59e3;
var $d74434fe0d31e6a3$export$7ded837413103211;
var $d74434fe0d31e6a3$export$5be82eb8d376fece;
var $d74434fe0d31e6a3$export$46c1c92549715335;
$d74434fe0d31e6a3$export$b0377cbbbdab6cba = "#006da8";
$d74434fe0d31e6a3$export$f27f0a643498ce3d = "#00aafc";
$d74434fe0d31e6a3$export$b00c055587dc7469 = "#f5dbd9";
$d74434fe0d31e6a3$export$b1a09d22b7ad6c4 = "#c92100";
$d74434fe0d31e6a3$export$509f3108fdd206bb = "#ebafa6";
$d74434fe0d31e6a3$export$42ff741d2868ee32 = "#074f86";
$d74434fe0d31e6a3$export$8c430709db82137d = "#dadada";
$d74434fe0d31e6a3$export$2d4b1211b4389c3b = "#dddbda";
$d74434fe0d31e6a3$export$3832be13857745bc = "#eae9ed";
$d74434fe0d31e6a3$export$f4c68800b094ddb1 = "#e9e8f4";
$d74434fe0d31e6a3$export$81d69db2e95c59e3 = "segmentResultsRoot_02a174";
$d74434fe0d31e6a3$export$7ded837413103211 = "previousData_02a174";
$d74434fe0d31e6a3$export$5be82eb8d376fece = "results_02a174";
$d74434fe0d31e6a3$export$46c1c92549715335 = "loading_02a174";


const $162f0a5823a32900$var$SegmentResults = ({ total: total, included: included, excluded: excluded, isLoading: isLoading, isError: isError, errorMessage: errorMessage, isStale: isStale })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: (0, $j6s32.default)($d74434fe0d31e6a3$export$81d69db2e95c59e3, isStale && $d74434fe0d31e6a3$export$7ded837413103211),
        children: [
            isError && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
                type: "error",
                message: errorMessage || ''
            }),
            isLoading && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {
                size: "1em",
                classes: {
                    root: $d74434fe0d31e6a3$export$46c1c92549715335
                }
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("table", {
                className: $d74434fe0d31e6a3$export$5be82eb8d376fece,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("thead", {
                        hidden: true,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("th", {}),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("th", {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("tbody", {
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                        children: included.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                        children: "included"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                        children: excluded.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                        children: "excluded"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                        children: total.toLocaleString()
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                        children: "total customers in segment"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $162f0a5823a32900$export$2e2bcd8739ae039 = $162f0a5823a32900$var$SegmentResults;


const $733f69a6c8a00721$var$SegmentResultsBuild = ()=>{
    const { selectedAttributes: includedAttributes } = (0, $79aece72917dec2b$export$7cea9ed133024a2d)();
    const { selectedAttributes: excludedAttributes } = (0, $79aece72917dec2b$export$7cea9ed133024a2d)(true);
    const { selectedComoposition: includedComposition } = (0, $79aece72917dec2b$export$3260c0a5a28fb657)();
    const { selectedComoposition: excludedComposition } = (0, $79aece72917dec2b$export$3260c0a5a28fb657)(true);
    const resultsQuery = (0, $146f6eb1ee275194$export$fd5d22c8ab0990ad)(includedAttributes, excludedAttributes, includedComposition, excludedComposition);
    (0, $ieT14.useEffect)(()=>{
        const hasIncludeAttributes = includedAttributes?.predicates.length > 0;
        const hasExcludeAttributes = excludedAttributes?.predicates.length > 0;
        if (hasIncludeAttributes || hasExcludeAttributes) resultsQuery.refetch();
    }, [
        includedAttributes,
        excludedAttributes,
        includedComposition,
        excludedComposition
    ]);
    const segmentResults = resultsQuery.data;
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $162f0a5823a32900$export$2e2bcd8739ae039), {
        total: segmentResults?.totalCustomers || 0,
        included: segmentResults?.includedCustomers || 0,
        excluded: segmentResults?.excludedCustomers || 0,
        isLoading: resultsQuery.isFetching,
        isError: resultsQuery.isError,
        errorMessage: resultsQuery.error?.message,
        isStale: resultsQuery.isPreviousData
    });
};
var $733f69a6c8a00721$export$2e2bcd8739ae039 = $733f69a6c8a00721$var$SegmentResultsBuild;




var $ieT14 = parcelRequire("ieT14");
var $d3a6c5cfb2396086$export$b0377cbbbdab6cba;
var $d3a6c5cfb2396086$export$f27f0a643498ce3d;
var $d3a6c5cfb2396086$export$b00c055587dc7469;
var $d3a6c5cfb2396086$export$b1a09d22b7ad6c4;
var $d3a6c5cfb2396086$export$509f3108fdd206bb;
var $d3a6c5cfb2396086$export$42ff741d2868ee32;
var $d3a6c5cfb2396086$export$8c430709db82137d;
var $d3a6c5cfb2396086$export$2d4b1211b4389c3b;
var $d3a6c5cfb2396086$export$3832be13857745bc;
var $d3a6c5cfb2396086$export$f4c68800b094ddb1;
var $d3a6c5cfb2396086$export$149f03f7aebc2e19;
var $d3a6c5cfb2396086$export$b8772d08938399e8;
var $d3a6c5cfb2396086$export$caf37b18e66e7c16;
var $d3a6c5cfb2396086$export$9771f61076faa58d;
var $d3a6c5cfb2396086$export$e49b12bf00f5c746;
var $d3a6c5cfb2396086$export$5e7f86f864e6509c;
var $d3a6c5cfb2396086$export$908a233be4ecde8e;
var $d3a6c5cfb2396086$export$b0dc76ccb49f2cec;
var $d3a6c5cfb2396086$export$ced7484dd0a65e67;
var $d3a6c5cfb2396086$export$119f7e232b163996;
var $d3a6c5cfb2396086$export$a2aa70cfed4a3fa5;
var $d3a6c5cfb2396086$export$c15719ce02e29531;
var $d3a6c5cfb2396086$export$c5b104fde295bf8f;
var $d3a6c5cfb2396086$export$dac863774b2ab841;
var $d3a6c5cfb2396086$export$ee4937ff310842b5;
var $d3a6c5cfb2396086$export$d55a54c110df7b5e;
var $d3a6c5cfb2396086$export$4babbd232a636c2f;
var $d3a6c5cfb2396086$export$2b33c41f722d2be0;
var $d3a6c5cfb2396086$export$7f38f2f20b85e352;
var $d3a6c5cfb2396086$export$e74aea68478c2a7;
var $d3a6c5cfb2396086$export$93173788ec86ec91;
var $d3a6c5cfb2396086$export$8bb22f439af601c0;
$d3a6c5cfb2396086$export$b0377cbbbdab6cba = "#006da8";
$d3a6c5cfb2396086$export$f27f0a643498ce3d = "#00aafc";
$d3a6c5cfb2396086$export$b00c055587dc7469 = "#f5dbd9";
$d3a6c5cfb2396086$export$b1a09d22b7ad6c4 = "#c92100";
$d3a6c5cfb2396086$export$509f3108fdd206bb = "#ebafa6";
$d3a6c5cfb2396086$export$42ff741d2868ee32 = "#074f86";
$d3a6c5cfb2396086$export$8c430709db82137d = "#dadada";
$d3a6c5cfb2396086$export$2d4b1211b4389c3b = "#dddbda";
$d3a6c5cfb2396086$export$3832be13857745bc = "#eae9ed";
$d3a6c5cfb2396086$export$f4c68800b094ddb1 = "#e9e8f4";
$d3a6c5cfb2396086$export$149f03f7aebc2e19 = "buildSegmentRoot_60af68";
$d3a6c5cfb2396086$export$b8772d08938399e8 = "dialogTitle_60af68";
$d3a6c5cfb2396086$export$caf37b18e66e7c16 = "modalFooter_60af68";
$d3a6c5cfb2396086$export$9771f61076faa58d = "filterSelectLoading_60af68";
$d3a6c5cfb2396086$export$e49b12bf00f5c746 = "filterError_60af68";
$d3a6c5cfb2396086$export$5e7f86f864e6509c = "dialogLoading_60af68";
$d3a6c5cfb2396086$export$908a233be4ecde8e = "blankOption_60af68";
$d3a6c5cfb2396086$export$b0dc76ccb49f2cec = "transactionalOptionName_60af68";
$d3a6c5cfb2396086$export$ced7484dd0a65e67 = "filterChips_60af68";
$d3a6c5cfb2396086$export$119f7e232b163996 = "transactionalFilterChipsContainer_60af68";
$d3a6c5cfb2396086$export$a2aa70cfed4a3fa5 = "transactionalFilters_60af68";
$d3a6c5cfb2396086$export$c15719ce02e29531 = "groupBySelections_60af68";
$d3a6c5cfb2396086$export$c5b104fde295bf8f = "transactionalGroupOperatorText_60af68";
$d3a6c5cfb2396086$export$dac863774b2ab841 = "filterText_60af68";
$d3a6c5cfb2396086$export$ee4937ff310842b5 = "attributeSearch_60af68";
$d3a6c5cfb2396086$export$d55a54c110df7b5e = "rangeFilterTitle_60af68";
$d3a6c5cfb2396086$export$4babbd232a636c2f = "rangeInputGroup_60af68";
$d3a6c5cfb2396086$export$2b33c41f722d2be0 = "rangeInputGroupDash_60af68";
$d3a6c5cfb2396086$export$7f38f2f20b85e352 = "dateRangeWarning_60af68";
$d3a6c5cfb2396086$export$e74aea68478c2a7 = "dateRangeDaysRadio_60af68";
$d3a6c5cfb2396086$export$93173788ec86ec91 = "dateRangeDaysError_60af68";
$d3a6c5cfb2396086$export$8bb22f439af601c0 = "rangeWarning_60af68";




var $ieT14 = parcelRequire("ieT14");

var $4830ac0c4a56bbcf$export$b0377cbbbdab6cba;
var $4830ac0c4a56bbcf$export$f27f0a643498ce3d;
var $4830ac0c4a56bbcf$export$b00c055587dc7469;
var $4830ac0c4a56bbcf$export$b1a09d22b7ad6c4;
var $4830ac0c4a56bbcf$export$509f3108fdd206bb;
var $4830ac0c4a56bbcf$export$42ff741d2868ee32;
var $4830ac0c4a56bbcf$export$8c430709db82137d;
var $4830ac0c4a56bbcf$export$2d4b1211b4389c3b;
var $4830ac0c4a56bbcf$export$3832be13857745bc;
var $4830ac0c4a56bbcf$export$f4c68800b094ddb1;
var $4830ac0c4a56bbcf$export$120ff0929b202a6d;
var $4830ac0c4a56bbcf$export$913c2d8c9fd26aee;
var $4830ac0c4a56bbcf$export$cc1adf6fb659c762;
var $4830ac0c4a56bbcf$export$857200a0d311d659;
var $4830ac0c4a56bbcf$export$6b8b92a9240a8a67;
var $4830ac0c4a56bbcf$export$bc3d4b1fe1693fc6;
var $4830ac0c4a56bbcf$export$f98f2d26ae95425a;
var $4830ac0c4a56bbcf$export$ffe5e8c7e30de942;
var $4830ac0c4a56bbcf$export$cdbed24db7b9850b;
var $4830ac0c4a56bbcf$export$af4b9a83f4b00434;
var $4830ac0c4a56bbcf$export$c8f07a9b573bdaf3;
var $4830ac0c4a56bbcf$export$995e14ef61d916e6;
var $4830ac0c4a56bbcf$export$982740ec81581fef;
var $4830ac0c4a56bbcf$export$faadaf0198b97fbe;
var $4830ac0c4a56bbcf$export$e6cadc5386456097;
var $4830ac0c4a56bbcf$export$bc6dd6ebdae3bcd9;
var $4830ac0c4a56bbcf$export$52954c71cfc30c7e;
var $4830ac0c4a56bbcf$export$a4cd26c910efa75f;
$4830ac0c4a56bbcf$export$b0377cbbbdab6cba = "#006da8";
$4830ac0c4a56bbcf$export$f27f0a643498ce3d = "#00aafc";
$4830ac0c4a56bbcf$export$b00c055587dc7469 = "#f5dbd9";
$4830ac0c4a56bbcf$export$b1a09d22b7ad6c4 = "#c92100";
$4830ac0c4a56bbcf$export$509f3108fdd206bb = "#ebafa6";
$4830ac0c4a56bbcf$export$42ff741d2868ee32 = "#074f86";
$4830ac0c4a56bbcf$export$8c430709db82137d = "#dadada";
$4830ac0c4a56bbcf$export$2d4b1211b4389c3b = "#dddbda";
$4830ac0c4a56bbcf$export$3832be13857745bc = "#eae9ed";
$4830ac0c4a56bbcf$export$f4c68800b094ddb1 = "#e9e8f4";
$4830ac0c4a56bbcf$export$120ff0929b202a6d = "row_3ae580";
$4830ac0c4a56bbcf$export$913c2d8c9fd26aee = "rowInner_3ae580";
$4830ac0c4a56bbcf$export$cc1adf6fb659c762 = "controls_3ae580";
$4830ac0c4a56bbcf$export$857200a0d311d659 = "attributeOperator_3ae580";
$4830ac0c4a56bbcf$export$6b8b92a9240a8a67 = "attributeOperatorText_3ae580";
$4830ac0c4a56bbcf$export$bc3d4b1fe1693fc6 = "baseAttributeText_3ae580";
$4830ac0c4a56bbcf$export$f98f2d26ae95425a = "groupOperatorText_3ae580";
$4830ac0c4a56bbcf$export$ffe5e8c7e30de942 = "attributeGroup_3ae580";
$4830ac0c4a56bbcf$export$cdbed24db7b9850b = "hasGroupBracket_3ae580";
$4830ac0c4a56bbcf$export$af4b9a83f4b00434 = "attribute_3ae580";
$4830ac0c4a56bbcf$export$c8f07a9b573bdaf3 = "attributeInner_3ae580";
$4830ac0c4a56bbcf$export$995e14ef61d916e6 = "inputGroup_3ae580";
$4830ac0c4a56bbcf$export$982740ec81581fef = "filterGroup_3ae580";
$4830ac0c4a56bbcf$export$faadaf0198b97fbe = "addControls_3ae580";
$4830ac0c4a56bbcf$export$e6cadc5386456097 = "customerCountRow_3ae580";
$4830ac0c4a56bbcf$export$bc6dd6ebdae3bcd9 = "customerCountBox_3ae580";
$4830ac0c4a56bbcf$export$52954c71cfc30c7e = "customerCount_3ae580";
$4830ac0c4a56bbcf$export$a4cd26c910efa75f = "customersFetching_3ae580";




parcelRequire("ieT14");




var $fpdl2 = parcelRequire("fpdl2");

var $j6s32 = parcelRequire("j6s32");
const $d0801aa0edace1ae$var$defaultGroup = {
    operator: 0,
    predicates: []
};
const $d0801aa0edace1ae$var$AttributeRowCustomers = ({ order: order, exclude: exclude })=>{
    const { selectedAttributes: includedAttributes } = (0, $79aece72917dec2b$export$7cea9ed133024a2d)();
    const { selectedAttributes: excludedAttributes } = (0, $79aece72917dec2b$export$7cea9ed133024a2d)(true);
    const { selectedComoposition: includedComposition } = (0, $79aece72917dec2b$export$3260c0a5a28fb657)();
    const { selectedComoposition: excludedComposition } = (0, $79aece72917dec2b$export$3260c0a5a28fb657)(true);
    const resultsQuery = (0, $146f6eb1ee275194$export$fd5d22c8ab0990ad)(includedAttributes, excludedAttributes, includedComposition, excludedComposition);
    const perIncludedAttributeGroup = resultsQuery.data?.perAttributeGroup.include;
    const includedAttributeCustomers = perIncludedAttributeGroup ? perIncludedAttributeGroup[order] : undefined;
    const perExcludedAttributeGroup = resultsQuery.data?.perAttributeGroup.exclude;
    const excludedAttributeCustomers = perExcludedAttributeGroup ? perExcludedAttributeGroup[order] : undefined;
    const attributeCustomers = exclude ? excludedAttributeCustomers : includedAttributeCustomers;
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        className: $4830ac0c4a56bbcf$export$e6cadc5386456097,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
            className: $4830ac0c4a56bbcf$export$bc6dd6ebdae3bcd9,
            children: [
                resultsQuery.isLoading && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: $4830ac0c4a56bbcf$export$52954c71cfc30c7e,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {
                        size: '1em'
                    })
                }),
                resultsQuery.data && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("p", {
                    className: (0, $j6s32.default)($4830ac0c4a56bbcf$export$52954c71cfc30c7e, resultsQuery.isPreviousData && resultsQuery.isFetching && $4830ac0c4a56bbcf$export$a4cd26c910efa75f),
                    children: `${attributeCustomers?.toLocaleString() || 0} ${attributeCustomers !== 1 ? 'customers meet criteria' : 'customer meets criteria'}`
                })
            ]
        })
    });
};
var $d0801aa0edace1ae$export$2e2bcd8739ae039 = $d0801aa0edace1ae$var$AttributeRowCustomers;




var $ieT14 = parcelRequire("ieT14");




var $ieT14 = parcelRequire("ieT14");


var $whS22 = parcelRequire("whS22");
var $1KcBP = parcelRequire("1KcBP");
var $Uxz4Y = parcelRequire("Uxz4Y");
var $e1ONw = parcelRequire("e1ONw");
var $3mOXj = parcelRequire("3mOXj");
var $aanJt = parcelRequire("aanJt");

var $j6s32 = parcelRequire("j6s32");

parcelRequire("ieT14");


var $fpdl2 = parcelRequire("fpdl2");
var $3mOXj = parcelRequire("3mOXj");
var $aanJt = parcelRequire("aanJt");

var $3umuy = parcelRequire("3umuy");

var $ieT14 = parcelRequire("ieT14");




function $49f64957c05f123f$export$275540052f30cbba(attributeId, enabled, isTransactional) {
    const appState = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    const normalizedId = !isTransactional ? attributeId : attributeId - (0, $6a74c864676f2556$export$56656b6753da686) < 0 ? attributeId : attributeId - (0, $6a74c864676f2556$export$56656b6753da686);
    const fetchURL = isTransactional ? `api/${appState.state.clientId}/attributes/transactional/${normalizedId}` : `api/${appState.state.clientId}/attributes/${normalizedId}`;
    return (0, $137a3b252d598119$export$dd0a697e1782aedd)([
        'segment-attribute-details',
        appState.state.clientId,
        attributeId
    ], async ()=>{
        return fetchWrapper(fetchURL);
    }, {
        select: (data)=>{
            const filters = data.filters ? JSON.parse(data.filters) : [];
            if (data.filterType === 'datetime') return {
                ...data,
                filters: {
                    ...filters,
                    min: (0, (/*@__PURE__*/$parcel$interopDefault($3umuy)))(filters.min),
                    max: (0, (/*@__PURE__*/$parcel$interopDefault($3umuy)))(filters.max)
                }
            };
            return {
                ...data,
                filters: filters
            };
        },
        enabled: enabled
    });
}





var $ieT14 = parcelRequire("ieT14");

var $knRao = parcelRequire("knRao");
var $e1ONw = parcelRequire("e1ONw");
var $aanJt = parcelRequire("aanJt");
var $eYT2J = parcelRequire("eYT2J");
var $aIJrd = parcelRequire("aIJrd");


var $4leCF = parcelRequire("4leCF");

var $f7wB2 = parcelRequire("f7wB2");
var $aIJrd = parcelRequire("aIJrd");

const $1fc2eb6485c96dfd$export$522e6e3e785eb2cd = (0, $aIJrd.default)({
    root: {
        margin: 2,
        backgroundColor: 'rgb(25, 135, 180)',
        color: (0, $69ed148db7543104$export$a4867fe9454f37a8)[100],
        '&:focus': {
            backgroundColor: 'rgba(25, 135, 180,.7)'
        },
        '& .MuiChip-deleteIcon': {
            color: (0, $69ed148db7543104$export$a4867fe9454f37a8)[100]
        }
    }
})((0, $f7wB2.default));



parcelRequire("ieT14");


var $e1ONw = parcelRequire("e1ONw");
var $edxsd = parcelRequire("edxsd");

var $ieT14 = parcelRequire("ieT14");

var $bKHfy = parcelRequire("bKHfy");
var $kfQ2O = parcelRequire("kfQ2O");
function $e3f2b79e5e31197b$export$2e2bcd8739ae039(queryInput) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var theme = (0, $kfQ2O.default)();
    var props = (0, $bKHfy.default)({
        theme: theme,
        name: 'MuiUseMediaQuery',
        props: {}
    });
    var query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, ''); // Wait for jsdom to support the match media feature.
    // All the browsers Material-UI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    var supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
    var _props$options = (0, $edxsd.default)({}, props, options), _props$options$defaul = _props$options.defaultMatches, defaultMatches = _props$options$defaul === void 0 ? false : _props$options$defaul, _props$options$matchM = _props$options.matchMedia, matchMedia = _props$options$matchM === void 0 ? supportMatchMedia ? window.matchMedia : null : _props$options$matchM, _props$options$noSsr = _props$options.noSsr, noSsr = _props$options$noSsr === void 0 ? false : _props$options$noSsr, _props$options$ssrMat = _props$options.ssrMatchMedia, ssrMatchMedia = _props$options$ssrMat === void 0 ? null : _props$options$ssrMat;
    var _React$useState = $ieT14.useState(function() {
        if (noSsr && supportMatchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
         // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    }), match = _React$useState[0], setMatch = _React$useState[1];
    $ieT14.useEffect(function() {
        var active = true;
        if (!supportMatchMedia) return undefined;
        var queryList = matchMedia(query);
        var updateMatch = function updateMatch() {
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui-org/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addListener(updateMatch);
        return function() {
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia,
        supportMatchMedia
    ]);
    return match;
}


var $hgPMF = parcelRequire("hgPMF");

var $fgoQ6 = parcelRequire("fgoQ6");
const $d7db63c711af8c68$var$useStyles = (0, $e1ONw.default)((theme)=>({
        dialog: {
            [theme.breakpoints.up('sm')]: {
                '& .MuiDialog-paperWidthSm': {
                    maxWidth: '640px'
                }
            }
        },
        dialogActions: {
            justifyContent: 'space-between',
            height: 57,
            padding: '0 24px'
        }
    }));
/**
 * Dialog menu for use in attribute filtering for menus not requiring a search bar (range and datetime).
 */ const $d7db63c711af8c68$var$AttributeFilterDialog = ({ open: open, title: title, children: children, applyDisabled: applyDisabled = false, handleCancel: handleCancel, handleApply: handleApply })=>{
    const overrides = $d7db63c711af8c68$var$useStyles();
    const theme = (0, $hgPMF.default)();
    const fullScreen = (0, $e3f2b79e5e31197b$export$2e2bcd8739ae039)(theme.breakpoints.only('xs'));
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $1c689a1559dbf5e9$export$2e2bcd8739ae039), {
        open: open,
        maxWidth: "sm",
        scroll: "paper",
        fullScreen: fullScreen,
        className: overrides.dialog,
        "aria-labelledby": "select-attribute-dialog-title",
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6830d3674ad61fd5$export$2e2bcd8739ae039), {
                id: "select-attribute-dialog-title",
                disableTypography: true,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h3", {
                    className: $d3a6c5cfb2396086$export$b8772d08938399e8,
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $881610d42277b808$export$2e2bcd8739ae039), {
                dividers: true,
                children: children
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $d176cc26269b23c2$export$2e2bcd8739ae039), {
                className: overrides.dialogActions,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.TertiaryButton), {
                        text: "Cancel",
                        title: "Cancel",
                        component: "button",
                        handleClick: handleCancel
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryButton), {
                        text: "Apply",
                        title: "Apply",
                        handleClick: handleApply,
                        deactive: applyDisabled
                    })
                ]
            })
        ]
    });
};
var $d7db63c711af8c68$export$2e2bcd8739ae039 = $d7db63c711af8c68$var$AttributeFilterDialog;



var $3umuy = parcelRequire("3umuy");


var $3umuy = parcelRequire("3umuy");

var $ieT14 = parcelRequire("ieT14");
function $7ea1741e335f9375$export$33cc6739154a284f(initialMin, initialMax) {
    const [minValue, setMinValue] = $ieT14.useState(initialMin && (0, (/*@__PURE__*/$parcel$interopDefault($3umuy)))(initialMin));
    const [maxValue, setMaxValue] = $ieT14.useState(initialMax && (0, (/*@__PURE__*/$parcel$interopDefault($3umuy)))(initialMax));
    const [isMinValid, setIsMinValid] = $ieT14.useState(true);
    const [isMaxValid, setIsMaxValid] = $ieT14.useState(true);
    const [warning, setWarning] = $ieT14.useState('');
    const onMinValueChange = (date)=>{
        setMinValue(date);
    };
    const onMaxValueChange = (date)=>{
        setMaxValue(date);
    };
    $ieT14.useEffect(()=>{
        setIsMinValid(minValue ? minValue.isValid() : false);
        setIsMaxValid(maxValue ? maxValue.isValid() : false);
        if (minValue && maxValue && minValue > maxValue) setWarning('End date is earlier than start date');
        else setWarning('');
    }, [
        minValue,
        maxValue
    ]);
    return {
        minValue: minValue,
        setMinValue: setMinValue,
        maxValue: maxValue,
        setMaxValue: setMaxValue,
        isMinValid: isMinValid,
        isMaxValid: isMaxValid,
        warning: warning,
        onMinValueChange: onMinValueChange,
        onMaxValueChange: onMaxValueChange
    };
}




const $dbae8c3125deffbd$var$useStyles = (0, $e1ONw.default)({
    datePicker: {
        display: 'block',
        margin: '0 0 10px 30px',
        width: 150
    },
    daysInput: {
        width: 60,
        margin: '0 4px',
        // visually hide the select label
        '& label.MuiFormLabel-root, legend': {
            clip: 'rect(0 0 0 0)',
            clipPath: 'inset(50%)',
            height: 1,
            overflow: 'hidden',
            position: 'absolute',
            whiteSpace: 'nowrap',
            width: 1
        },
        '& .MuiOutlinedInput-notchedOutline': {
            top: 0
        }
    }
});
const $dbae8c3125deffbd$var$DatePickerStyledInput = (0, $aIJrd.default)({
    root: {
        '& .MuiOutlinedInput-root': {
            fontSize: '14px'
        }
    }
})((0, $eYT2J.default));
const $dbae8c3125deffbd$var$DatePickerInput = (props)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($dbae8c3125deffbd$var$DatePickerStyledInput, {
        ...props,
        size: "small",
        variant: "outlined"
    });
const $dbae8c3125deffbd$var$nDaysSchema = (0, $111b61f80e1de09e$export$185802fd694ee1f5)().integer('Must be an integer').min(1, 'Must be greater than 1').max(365, 'Must be less than 365').typeError('Must be a number');
/**
 * Modal dialog component to render the filter options for a single attribute when building a segment
 */ const $dbae8c3125deffbd$var$AttributeFilterDatetime = ({ attribute: attribute, selectedAttribute: selectedAttribute, position: position, exclude: exclude, applyTransactional: applyTransactional, attributeIndex: attributeIndex })=>{
    const overrides = $dbae8c3125deffbd$var$useStyles();
    const { dispatch: dispatch } = (0, $79aece72917dec2b$export$7cea9ed133024a2d)(exclude);
    const [dialogOpen, setDialogOpen] = $ieT14.useState(false);
    const [rangeType, setRangeType] = $ieT14.useState('numberOfDays' in selectedAttribute ? 'n-days' : 'custom');
    const [nDaysValue, setNDaysValue] = $ieT14.useState('numberOfDays' in selectedAttribute ? String(selectedAttribute.numberOfDays) : '30');
    const [nDaysValidationError, setNDaysValidationError] = $ieT14.useState('');
    const [selectedRange, setSelectedRange] = $ieT14.useState(()=>{
        if ('dateRange' in selectedAttribute) return {
            min: selectedAttribute.dateRange.min && (0, (/*@__PURE__*/$parcel$interopDefault($3umuy)))(selectedAttribute.dateRange.min),
            max: selectedAttribute.dateRange.max && (0, (/*@__PURE__*/$parcel$interopDefault($3umuy)))(selectedAttribute.dateRange.max)
        };
        if ('numberOfDays' in selectedAttribute) return String(selectedAttribute.numberOfDays);
        return {
            min: null,
            max: null
        };
    });
    const { minValue: minValue, setMinValue: setMinValue, maxValue: maxValue, setMaxValue: setMaxValue, isMinValid: isMinValid, isMaxValid: isMaxValid, warning: customRangeWarning, onMinValueChange: onMinValueChange, onMaxValueChange: onMaxValueChange } = (0, $7ea1741e335f9375$export$33cc6739154a284f)('dateRange' in selectedAttribute ? selectedAttribute.dateRange.min : null, 'dateRange' in selectedAttribute ? selectedAttribute.dateRange.max : null);
    $ieT14.useEffect(()=>{
        if (typeof selectedRange == 'string') {
            setNDaysValue(selectedRange);
            if (applyTransactional) applyTransactional({
                rangeType: 'n-days',
                numberOfDays: parseInt(selectedRange)
            });
            else {
                // @ts-ignore -- removing dateRange which may or may not exist, only use remaining properties
                const { dateRange: _, ...rest } = selectedAttribute;
                dispatch({
                    type: 'updateAttribute',
                    attribute: {
                        ...rest,
                        numberOfDays: parseInt(selectedRange)
                    },
                    position: position,
                    attributeIndex: attributeIndex
                });
            }
        } else {
            setMinValue(selectedRange.min);
            setMaxValue(selectedRange.max);
            if (applyTransactional) applyTransactional({
                rangeType: 'custom',
                min: selectedRange.min ?? null,
                max: selectedRange.max ?? null
            });
            else {
                // @ts-ignore -- removing numberOfDays which may or may not exist, only use remaining properties
                const { numberOfDays: _, ...rest } = selectedAttribute;
                dispatch({
                    type: 'updateAttribute',
                    attribute: {
                        ...rest,
                        dateRange: {
                            min: selectedRange.min && selectedRange.min.toISOString(),
                            max: selectedRange.max && selectedRange.max.toISOString()
                        }
                    },
                    position: position,
                    attributeIndex: attributeIndex
                });
            }
        }
    }, [
        selectedRange
    ]);
    $ieT14.useEffect(()=>{
        try {
            $dbae8c3125deffbd$var$nDaysSchema.validateSync(nDaysValue);
            setNDaysValidationError('');
        } catch (err) {
            if (err instanceof (0, $0d3dd0f474055a4e$export$2e2bcd8739ae039)) setNDaysValidationError(err.message);
        }
    }, [
        nDaysValue
    ]);
    /** Reset to previous filters on cancel */ const handleCancel = ()=>{
        if (typeof selectedRange == 'string') {
            setNDaysValue(selectedRange);
            setMinValue(null);
            setMaxValue(null);
        } else {
            setNDaysValue('30');
            setMinValue(selectedRange.min);
            setMaxValue(selectedRange.max);
        }
        setDialogOpen(false);
    };
    const handleApply = ()=>{
        if (rangeType === 'custom') setSelectedRange({
            min: minValue,
            max: maxValue
        });
        else setSelectedRange(nDaysValue);
        setDialogOpen(false);
    };
    const handleMinBlur = ()=>{
        if (minValue != null && minValue.isBefore(attribute.filters.min)) setMinValue(attribute.filters.min);
    };
    const handleMaxBlur = ()=>{
        if (maxValue != null && maxValue.isAfter(attribute.filters.max)) setMaxValue(attribute.filters.max);
    };
    /** Function passed to filter select `renderValue` prop: conditionally render the custom content of the filter multi-select menu */ const renderFilterValues = (value)=>{
        if (typeof value == 'string') return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
            className: $d3a6c5cfb2396086$export$ced7484dd0a65e67,
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1fc2eb6485c96dfd$export$522e6e3e785eb2cd), {
                label: `Last ${value} days`,
                size: "small",
                deleteIcon: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4leCF.default), {
                    onMouseDown: (event)=>event.stopPropagation(),
                    "aria-label": "delete filter"
                }),
                onDelete: ()=>{
                    setRangeType('custom');
                    setSelectedRange({
                        min: null,
                        max: null
                    });
                }
            }, `${attribute.id}-min`)
        });
        if (value.max == null && value.min == null) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
            className: $d3a6c5cfb2396086$export$dac863774b2ab841,
            children: "All - click for additional filtering"
        });
        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
            className: $d3a6c5cfb2396086$export$ced7484dd0a65e67,
            children: [
                value.min && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1fc2eb6485c96dfd$export$522e6e3e785eb2cd), {
                    label: `Start: ${value.min.format('MM/DD/YYYY')}`,
                    size: "small",
                    deleteIcon: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4leCF.default), {
                        onMouseDown: (event)=>event.stopPropagation(),
                        "aria-label": "delete filter"
                    }),
                    onDelete: ()=>setSelectedRange((prev)=>({
                                ...prev,
                                min: null
                            }))
                }, `${attribute.id}-min`),
                value.max && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1fc2eb6485c96dfd$export$522e6e3e785eb2cd), {
                    label: `End: ${value.max.format('MM/DD/YYYY')}`,
                    size: "small",
                    deleteIcon: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4leCF.default), {
                        onMouseDown: (event)=>event.stopPropagation(),
                        "aria-label": "delete filter"
                    }),
                    onDelete: ()=>setSelectedRange((prev)=>({
                                ...prev,
                                max: null
                            }))
                }, `${attribute.id}-max`)
            ]
        });
    };
    function formIsNotValid() {
        if (rangeType == 'custom') return minValue && !isMinValid || maxValue && !isMaxValid || customRangeWarning != '';
        if (rangeType == 'n-days') return nDaysValidationError !== '';
    }
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $aanJt.default), {
                id: `filter-attribute-${attribute.id}`,
                multiple: true,
                value: selectedRange,
                open: false,
                onOpen: ()=>{
                    setDialogOpen(true);
                },
                renderValue: renderFilterValues,
                displayEmpty: true
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $d7db63c711af8c68$export$2e2bcd8739ae039), {
                open: dialogOpen,
                title: "Select Filters",
                applyDisabled: formIsNotValid(),
                handleCancel: handleCancel,
                handleApply: handleApply,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h4", {
                        className: $d3a6c5cfb2396086$export$d55a54c110df7b5e,
                        children: "Date Range"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $62bbd6cebee2ba4a$export$2e2bcd8739ae039), {
                        "aria-label": `${attribute.name}-filter-options`,
                        name: `${attribute.name}-filter-options`,
                        value: rangeType,
                        onChange: (event)=>setRangeType(event.target.value),
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $knRao.default), {
                                value: "n-days",
                                control: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $141807cd97d66e4d$export$2e2bcd8739ae039), {}),
                                label: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                                    className: $d3a6c5cfb2396086$export$e74aea68478c2a7,
                                    children: [
                                        "Within the last",
                                        ' ',
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYT2J.default), {
                                            label: "N-days",
                                            id: `${attribute.name}-days`,
                                            size: "small",
                                            type: "number",
                                            variant: "outlined",
                                            disabled: rangeType !== 'n-days',
                                            className: overrides.daysInput,
                                            InputProps: {
                                                inputProps: {
                                                    min: 1,
                                                    max: 365
                                                }
                                            },
                                            value: nDaysValue,
                                            onChange: (event)=>setNDaysValue(event.target.value),
                                            error: nDaysValidationError !== ''
                                        }),
                                        "days"
                                    ]
                                })
                            }),
                            rangeType === 'n-days' && nDaysValidationError && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("p", {
                                className: $d3a6c5cfb2396086$export$93173788ec86ec91,
                                children: nDaysValidationError
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $knRao.default), {
                                value: "custom",
                                control: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $141807cd97d66e4d$export$2e2bcd8739ae039), {}),
                                label: "Custom date range"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $d2c3211918dbdb4a$export$d8c44f501031ee7c), {
                        label: "Start Date",
                        value: minValue,
                        onChange: onMinValueChange,
                        format: "MM/DD/YYYY",
                        variant: "inline",
                        inputVariant: "outlined",
                        TextFieldComponent: $dbae8c3125deffbd$var$DatePickerInput,
                        KeyboardButtonProps: {
                            size: 'small',
                            edge: 'end'
                        },
                        minDate: attribute.filters.min,
                        minDateMessage: rangeType === 'custom' && `Earliest available date: ${attribute.filters.min.format('M/D/YYYY')}`,
                        maxDate: attribute.filters.max,
                        maxDateMessage: `Latest available date: ${attribute.filters.max.format('M/D/YYYY')}`,
                        onBlur: handleMinBlur,
                        className: overrides.datePicker,
                        disabled: rangeType !== 'custom'
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $d2c3211918dbdb4a$export$d8c44f501031ee7c), {
                        label: "End Date",
                        value: maxValue,
                        onChange: onMaxValueChange,
                        format: "MM/DD/YYYY",
                        variant: "inline",
                        inputVariant: "outlined",
                        TextFieldComponent: $dbae8c3125deffbd$var$DatePickerInput,
                        KeyboardButtonProps: {
                            size: 'small',
                            edge: 'end'
                        },
                        minDate: attribute.filters.min,
                        minDateMessage: `Earliest available date: ${attribute.filters.min.format('M/D/YYYY')}`,
                        maxDate: attribute.filters.max,
                        maxDateMessage: `Latest available date: ${attribute.filters.max.format('M/D/YYYY')}`,
                        onBlur: handleMaxBlur,
                        className: overrides.datePicker,
                        disabled: rangeType !== 'custom'
                    }),
                    rangeType === 'custom' && customRangeWarning && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("p", {
                        className: $d3a6c5cfb2396086$export$7f38f2f20b85e352,
                        children: customRangeWarning
                    })
                ]
            })
        ]
    });
};
var $dbae8c3125deffbd$export$2e2bcd8739ae039 = $dbae8c3125deffbd$var$AttributeFilterDatetime;




var $ieT14 = parcelRequire("ieT14");

var $3WBJn = parcelRequire("3WBJn");
var $e1ONw = parcelRequire("e1ONw");
var $aanJt = parcelRequire("aanJt");
var $hgPMF = parcelRequire("hgPMF");


var $fgoQ6 = parcelRequire("fgoQ6");


var $ieT14 = parcelRequire("ieT14");

var $knRao = parcelRequire("knRao");
var $e1ONw = parcelRequire("e1ONw");



var $fgoQ6 = parcelRequire("fgoQ6");


var $j6s32 = parcelRequire("j6s32");

parcelRequire("ieT14");
const $71578961b1a8465c$var$TransactionIndicatorIcon = ({ width: width, height: height, color: color })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("svg", {
        width: width || '14px',
        height: height || '14px',
        viewBox: "0 0 18 18",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("title", {
                children: "icon transaction indicator"
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("g", {
                id: "2023-revision",
                stroke: "none",
                strokeWidth: "1",
                fill: color || 'none',
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("g", {
                    id: "KFS-292-Add-Indicator",
                    transform: "translate(-1547, -712)",
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("g", {
                        id: "icon-transaction-indicator",
                        transform: "translate(1547, 712)",
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("g", {
                                id: "transaction-ind-copy-5",
                                transform: "translate(0, 1)",
                                fill: "#006DA8",
                                fillRule: "nonzero",
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("path", {
                                    d: "M6.04210526,8.91621053 L0.842105263,8.91621053 C0.603508772,8.91621053 0.403508772,8.83550877 0.242105263,8.67410526 C0.0807017544,8.51270175 0,8.31270175 0,8.07410526 C0,7.83550877 0.0807017544,7.63550877 0.242105263,7.47410526 C0.403508772,7.31270175 0.603508772,7.232 0.842105263,7.232 L6.04210526,7.232 L4.46315789,5.65305263 C4.30877193,5.49866667 4.23157895,5.30568421 4.23157895,5.07410526 C4.23157895,4.84252632 4.30877193,4.64252632 4.46315789,4.47410526 C4.63157895,4.30568421 4.83157895,4.22147368 5.06315789,4.22147368 C5.29473684,4.22147368 5.49473684,4.30568421 5.66315789,4.47410526 L8.67368421,7.48463158 C8.75789474,7.56884211 8.81754386,7.66007018 8.85263158,7.75831579 C8.8877193,7.8565614 8.90526316,7.96182456 8.90526316,8.07410526 C8.90526316,8.18638596 8.8877193,8.29164912 8.85263158,8.38989474 C8.81754386,8.48814035 8.75789474,8.57936842 8.67368421,8.66357895 L5.64210526,11.6951579 C5.47368421,11.8635789 5.27719298,11.9442807 5.05263158,11.9372632 C4.82807018,11.9302456 4.63157895,11.8425263 4.46315789,11.6741053 C4.30877193,11.5056842 4.22807018,11.309193 4.22105263,11.0846316 C4.21403509,10.8600702 4.29473684,10.6635789 4.46315789,10.4951579 L6.04210526,8.91621053 Z M9.95789474,4.70568421 L11.5368421,6.28463158 C11.6912281,6.43901754 11.7684211,6.632 11.7684211,6.86357895 C11.7684211,7.09515789 11.6912281,7.29515789 11.5368421,7.46357895 C11.3684211,7.632 11.1684211,7.71621053 10.9368421,7.71621053 C10.7052632,7.71621053 10.5052632,7.632 10.3368421,7.46357895 L7.32631579,4.45305263 C7.24210526,4.36884211 7.18245614,4.27761404 7.14736842,4.17936842 C7.1122807,4.08112281 7.09473684,3.97585965 7.09473684,3.86357895 C7.09473684,3.75129825 7.1122807,3.64603509 7.14736842,3.54778947 C7.18245614,3.44954386 7.24210526,3.35831579 7.32631579,3.27410526 L10.3578947,0.242526316 C10.5263158,0.0741052632 10.722807,-0.00659649123 10.9473684,0.000421052632 C11.1719298,0.00743859649 11.3684211,0.0951578947 11.5368421,0.263578947 C11.6912281,0.432 11.7719298,0.628491228 11.7789474,0.853052632 C11.7859649,1.07761404 11.7052632,1.27410526 11.5368421,1.44252632 L9.95789474,3.02147368 L15.1578947,3.02147368 C15.3964912,3.02147368 15.5964912,3.10217544 15.7578947,3.26357895 C15.9192982,3.42498246 16,3.62498246 16,3.86357895 C16,4.10217544 15.9192982,4.30217544 15.7578947,4.46357895 C15.5964912,4.62498246 15.3964912,4.70568421 15.1578947,4.70568421 L9.95789474,4.70568421 Z M9.95789474,13.1267368 L11.5368421,14.7056842 C11.6912281,14.8600702 11.7684211,15.0530526 11.7684211,15.2846316 C11.7684211,15.5162105 11.6912281,15.7162105 11.5368421,15.8846316 C11.3684211,16.0530526 11.1684211,16.1372632 10.9368421,16.1372632 C10.7052632,16.1372632 10.5052632,16.0530526 10.3368421,15.8846316 L7.32631579,12.8741053 C7.24210526,12.7898947 7.18245614,12.6986667 7.14736842,12.6004211 C7.1122807,12.5021754 7.09473684,12.3969123 7.09473684,12.2846316 C7.09473684,12.1723509 7.1122807,12.0670877 7.14736842,11.9688421 C7.18245614,11.8705965 7.24210526,11.7793684 7.32631579,11.6951579 L10.3578947,8.66357895 C10.5263158,8.49515789 10.722807,8.41445614 10.9473684,8.42147368 C11.1719298,8.42849123 11.3684211,8.51621053 11.5368421,8.68463158 C11.6912281,8.85305263 11.7719298,9.04954386 11.7789474,9.27410526 C11.7859649,9.49866667 11.7052632,9.69515789 11.5368421,9.86357895 L9.95789474,11.4425263 L15.1578947,11.4425263 C15.3964912,11.4425263 15.5964912,11.5232281 15.7578947,11.6846316 C15.9192982,11.8460351 16,12.0460351 16,12.2846316 C16,12.5232281 15.9192982,12.7232281 15.7578947,12.8846316 C15.5964912,13.0460351 15.3964912,13.1267368 15.1578947,13.1267368 L9.95789474,13.1267368 Z",
                                    id: "Shape"
                                })
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("circle", {
                                id: "Oval",
                                stroke: "#006DA8",
                                cx: "9",
                                cy: "9",
                                r: "8.5"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $71578961b1a8465c$export$2e2bcd8739ae039 = $71578961b1a8465c$var$TransactionIndicatorIcon;


const $013bb0a1cc411906$var$useStyles = (0, $e1ONw.default)({
    formControlLabel: {
        marginLeft: 2,
        width: '100%',
        '& .MuiFormControlLabel-label': {
            fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).heading,
            fontSize: 12,
            fontWeight: 400,
            color: (0, $69ed148db7543104$export$a4867fe9454f37a8)[700],
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    hidden: {
        display: 'none'
    },
    inputLabel: {
        display: 'flex',
        alignItems: 'center'
    }
});
/**
 * Display a single option with a checkbox input in the segment attribute and filter dialog menus.
 *
 * Stores checked state locally to avoid re-rendering all menu items in long list. `onChange` function should avoid changing
 * parent state (ex. altering `useState` member) to avoid re-rendering other checkboxes on change.
 *
 * Care must be taken when conditionally rendering based on a search to hide rather than unmount options so that this
 * is not lost
 */ const $013bb0a1cc411906$var$AttributeMenuOption = ({ id: id, name: name, secondaryText: secondaryText, initialChecked: initialChecked, onChange: onChange, hidden: hidden, forceChecked: forceChecked, isTransactional: isTransactional })=>{
    const overrides = $013bb0a1cc411906$var$useStyles();
    const [checkedState, setCheckedState] = $ieT14.useState(initialChecked);
    const handleChange = (event, checked)=>{
        setCheckedState(checked);
        onChange(event, checked);
    };
    $ieT14.useEffect(()=>{
        if (forceChecked !== undefined) setCheckedState(forceChecked);
    }, [
        forceChecked
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $knRao.default), {
        control: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.StyledCheckbox), {
            name: name,
            value: id,
            edge: "start",
            checked: checkedState,
            onChange: handleChange
        }),
        label: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
            className: overrides.inputLabel,
            children: [
                isTransactional && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $8991ead30e777b29$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $71578961b1a8465c$export$2e2bcd8739ae039), {
                            height: "12px",
                            width: "12px"
                        }),
                        "\xa0"
                    ]
                }),
                name.trim() === '' ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                    className: $d3a6c5cfb2396086$export$908a233be4ecde8e,
                    children: "blank"
                }) : name,
                "\xa0",
                secondaryText && `(${secondaryText})`
            ]
        }),
        title: name,
        className: (0, $j6s32.default)(overrides.formControlLabel, hidden && overrides.hidden)
    });
};
var $013bb0a1cc411906$export$2e2bcd8739ae039 = $013bb0a1cc411906$var$AttributeMenuOption;



var $4leCF = parcelRequire("4leCF");


const $e906967d5eb28744$var$useStyles = (0, $e1ONw.default)((theme)=>({
        dialog: {
            [theme.breakpoints.up('sm')]: {
                '& .MuiDialog-paperWidthSm': {
                    maxWidth: '640px'
                }
            }
        },
        dialogTitle: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        dialogActions: {
            justifyContent: 'space-between',
            height: 57,
            padding: '0 24px'
        },
        searchBar: {
            width: 180
        }
    }));
/**
 * Select menu and accompanying modal dialog for filtering a single attribute of filterType: options when building a segment
 */ const $e906967d5eb28744$var$AttributeFilterOptions = ({ attribute: attribute, selectedAttribute: selectedAttribute, position: position, exclude: exclude, applyTransactional: applyTransactional, deleteTransactionalChip: deleteTransactionalChip, attributeIndex: attributeIndex })=>{
    const overrides = $e906967d5eb28744$var$useStyles();
    const { dispatch: dispatch } = (0, $79aece72917dec2b$export$7cea9ed133024a2d)(exclude);
    const [dialogOpen, setDialogOpen] = $ieT14.useState(false);
    /** Currently checked filters in the filter dialog, not yet applied to select menu */ const checkedFilters = $ieT14.useRef(selectedAttribute.options);
    const theme = (0, $hgPMF.default)();
    const fullScreen = (0, $e3f2b79e5e31197b$export$2e2bcd8739ae039)(theme.breakpoints.only('xs'));
    const [searchValue, setSearchValue] = $ieT14.useState('');
    /** Only query for filter values if user opens the filter menu dialog, don't prefetch */ $ieT14.useEffect(()=>{
        if (!dialogOpen) setSearchValue('');
    }, [
        dialogOpen
    ]);
    $ieT14.useEffect(()=>{
        checkedFilters.current = selectedAttribute.options;
    }, [
        selectedAttribute.options
    ]);
    /** Reset to previous filters on cancel */ const handleCancel = ()=>{
        checkedFilters.current = selectedAttribute.options;
        setDialogOpen(false);
    };
    const handleApply = ()=>{
        if (!!applyTransactional) applyTransactional(checkedFilters.current);
        else dispatch({
            type: 'updateAttribute',
            attribute: {
                ...selectedAttribute,
                options: checkedFilters.current
            },
            position: position,
            attributeIndex: attributeIndex
        });
        setDialogOpen(false);
    };
    /** Callback passed to checkboxes inputs which manage their own checked state */ const handleChange = (event, checked)=>{
        if (checked) checkedFilters.current = [
            ...checkedFilters.current,
            event.target.value
        ];
        else checkedFilters.current = checkedFilters.current.filter((filterName)=>filterName != event.target.value);
    };
    const handleDeleteChip = (option)=>{
        if (!!deleteTransactionalChip) deleteTransactionalChip(option);
        else dispatch({
            type: 'updateAttribute',
            attribute: {
                ...selectedAttribute,
                options: selectedAttribute.options.filter((filterName)=>filterName !== option)
            },
            position: position,
            attributeIndex: attributeIndex
        });
    };
    /** Function passed to filter select `renderValue` prop: conditionally render the custom content of the filter multi-select menu */ const renderFilterValues = (value)=>{
        if (attribute.filters.length === 0) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
            className: $d3a6c5cfb2396086$export$dac863774b2ab841,
            children: "There are no filters to apply"
        });
        if (selectedAttribute.options.length === 0 || selectedAttribute.options.length === attribute.filters.length) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
            className: $d3a6c5cfb2396086$export$dac863774b2ab841,
            children: "All - click for additional filtering"
        });
        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
            className: $d3a6c5cfb2396086$export$ced7484dd0a65e67,
            children: value.map((valueName)=>{
                const label = valueName.trim() === '' ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                    className: $d3a6c5cfb2396086$export$908a233be4ecde8e,
                    children: "blank"
                }) : valueName;
                return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1fc2eb6485c96dfd$export$522e6e3e785eb2cd), {
                    label: label,
                    size: "small",
                    deleteIcon: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4leCF.default), {
                        onMouseDown: (event)=>event.stopPropagation(),
                        "aria-label": "delete filter"
                    }),
                    onDelete: ()=>handleDeleteChip(valueName)
                }, valueName);
            })
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $aanJt.default), {
                id: `filter-attribute-${attribute.id}`,
                multiple: true,
                disabled: attribute.filters.length === 0,
                value: selectedAttribute.options,
                open: false,
                onOpen: ()=>{
                    setDialogOpen(true);
                },
                renderValue: renderFilterValues,
                displayEmpty: true
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $1c689a1559dbf5e9$export$2e2bcd8739ae039), {
                open: dialogOpen,
                maxWidth: "sm",
                scroll: "paper",
                fullScreen: fullScreen,
                className: overrides.dialog,
                "aria-labelledby": "select-attribute-dialog-title",
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $6830d3674ad61fd5$export$2e2bcd8739ae039), {
                        className: overrides.dialogTitle,
                        id: "select-attribute-dialog-title",
                        disableTypography: true,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h3", {
                                className: $d3a6c5cfb2396086$export$b8772d08938399e8,
                                children: "Select Filters"
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SearchBar), {
                                value: searchValue,
                                updateValue: setSearchValue,
                                placeholder: "Search Filters",
                                allowSubmitButton: false,
                                showClearButton: true,
                                className: overrides.searchBar
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $881610d42277b808$export$2e2bcd8739ae039), {
                        dividers: true,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3WBJn.default), {
                            children: attribute.filters.map((filterOption)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $013bb0a1cc411906$export$2e2bcd8739ae039), {
                                    id: filterOption.value,
                                    name: String(filterOption.value),
                                    secondaryText: filterOption.customers.toLocaleString(),
                                    initialChecked: selectedAttribute.options.includes(String(filterOption.value)),
                                    onChange: handleChange,
                                    hidden: searchValue.length >= 3 && !String(filterOption.value).toLowerCase().includes(searchValue.toLowerCase())
                                }, `${filterOption.value}`))
                        })
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $d176cc26269b23c2$export$2e2bcd8739ae039), {
                        className: overrides.dialogActions,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.TertiaryButton), {
                                text: "Cancel",
                                title: "Cancel",
                                component: "button",
                                handleClick: handleCancel
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryButton), {
                                text: "Apply",
                                title: "Apply",
                                handleClick: handleApply
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $e906967d5eb28744$export$2e2bcd8739ae039 = $e906967d5eb28744$var$AttributeFilterOptions;




var $ieT14 = parcelRequire("ieT14");

var $e1ONw = parcelRequire("e1ONw");
var $aanJt = parcelRequire("aanJt");
var $83KOU = parcelRequire("83KOU");

var $dcIvM = parcelRequire("dcIvM");

var $eTwGP = parcelRequire("eTwGP");

var $edxsd = parcelRequire("edxsd");

var $ieT14 = parcelRequire("ieT14");


var $j6s32 = parcelRequire("j6s32");


var $aIJrd = parcelRequire("aIJrd");

var $hgPMF = parcelRequire("hgPMF");

var $86m3e = parcelRequire("86m3e");

var $6LYoZ = parcelRequire("6LYoZ");

var $7e6Rg = parcelRequire("7e6Rg");

var $N8hF2 = parcelRequire("N8hF2");

var $3A1Xf = parcelRequire("3A1Xf");

var $2EBFt = parcelRequire("2EBFt");

var $kuovH = parcelRequire("kuovH");

var $edxsd = parcelRequire("edxsd");

var $ieT14 = parcelRequire("ieT14");

var $j6s32 = parcelRequire("j6s32");

var $aIJrd = parcelRequire("aIJrd");
var $e4821fdac5ed4d6d$var$styles = function styles(theme) {
    return {
        thumb: {
            '&$open': {
                '& $offset': {
                    transform: 'scale(1) translateY(-10px)'
                }
            }
        },
        open: {},
        offset: (0, $edxsd.default)({
            zIndex: 1
        }, theme.typography.body2, {
            fontSize: theme.typography.pxToRem(12),
            lineHeight: 1.2,
            transition: theme.transitions.create([
                'transform'
            ], {
                duration: theme.transitions.duration.shortest
            }),
            top: -34,
            transformOrigin: 'bottom center',
            transform: 'scale(0)',
            position: 'absolute'
        }),
        circle: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 32,
            height: 32,
            borderRadius: '50% 50% 50% 0',
            backgroundColor: 'currentColor',
            transform: 'rotate(-45deg)'
        },
        label: {
            color: theme.palette.primary.contrastText,
            transform: 'rotate(45deg)'
        }
    };
};
/**
 * @ignore - internal component.
 */ function $e4821fdac5ed4d6d$var$ValueLabel(props) {
    var children = props.children, classes = props.classes, className = props.className, open = props.open, value = props.value, valueLabelDisplay = props.valueLabelDisplay;
    if (valueLabelDisplay === 'off') return children;
    return /*#__PURE__*/ $ieT14.cloneElement(children, {
        className: (0, $j6s32.default)(children.props.className, (open || valueLabelDisplay === 'on') && classes.open, classes.thumb)
    }, /*#__PURE__*/ $ieT14.createElement("span", {
        className: (0, $j6s32.default)(classes.offset, className)
    }, /*#__PURE__*/ $ieT14.createElement("span", {
        className: classes.circle
    }, /*#__PURE__*/ $ieT14.createElement("span", {
        className: classes.label
    }, value))));
}
var $e4821fdac5ed4d6d$export$2e2bcd8739ae039 = (0, $aIJrd.default)($e4821fdac5ed4d6d$var$styles, {
    name: 'PrivateValueLabel'
})($e4821fdac5ed4d6d$var$ValueLabel);


function $183d092b326e173d$var$asc(a, b) {
    return a - b;
}
function $183d092b326e173d$var$clamp(value, min, max) {
    return Math.min(Math.max(min, value), max);
}
function $183d092b326e173d$var$findClosest(values, currentValue) {
    var _values$reduce = values.reduce(function(acc, value, index) {
        var distance = Math.abs(currentValue - value);
        if (acc === null || distance < acc.distance || distance === acc.distance) return {
            distance: distance,
            index: index
        };
        return acc;
    }, null), closestIndex = _values$reduce.index;
    return closestIndex;
}
function $183d092b326e173d$var$trackFinger(event, touchId) {
    if (touchId.current !== undefined && event.changedTouches) {
        for(var i = 0; i < event.changedTouches.length; i += 1){
            var touch = event.changedTouches[i];
            if (touch.identifier === touchId.current) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $183d092b326e173d$var$valueToPercent(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $183d092b326e173d$var$percentToValue(percent, min, max) {
    return (max - min) * percent + min;
}
function $183d092b326e173d$var$getDecimalPrecision(num) {
    // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
    // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
    if (Math.abs(num) < 1) {
        var parts = num.toExponential().split('e-');
        var matissaDecimalPart = parts[0].split('.')[1];
        return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
    }
    var decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function $183d092b326e173d$var$roundValueToStep(value, step, min) {
    var nearest = Math.round((value - min) / step) * step + min;
    return Number(nearest.toFixed($183d092b326e173d$var$getDecimalPrecision(step)));
}
function $183d092b326e173d$var$setValueIndex(_ref) {
    var values = _ref.values, source = _ref.source, newValue = _ref.newValue, index = _ref.index;
    // Performance shortcut
    if (values[index] === newValue) return source;
    var output = values.slice();
    output[index] = newValue;
    return output;
}
function $183d092b326e173d$var$focusThumb(_ref2) {
    var sliderRef = _ref2.sliderRef, activeIndex = _ref2.activeIndex, setActive = _ref2.setActive;
    if (!sliderRef.current.contains(document.activeElement) || Number(document.activeElement.getAttribute('data-index')) !== activeIndex) sliderRef.current.querySelector("[role=\"slider\"][data-index=\"".concat(activeIndex, "\"]")).focus();
    if (setActive) setActive(activeIndex);
}
var $183d092b326e173d$var$axisProps = {
    horizontal: {
        offset: function offset(percent) {
            return {
                left: "".concat(percent, "%")
            };
        },
        leap: function leap(percent) {
            return {
                width: "".concat(percent, "%")
            };
        }
    },
    'horizontal-reverse': {
        offset: function offset(percent) {
            return {
                right: "".concat(percent, "%")
            };
        },
        leap: function leap(percent) {
            return {
                width: "".concat(percent, "%")
            };
        }
    },
    vertical: {
        offset: function offset(percent) {
            return {
                bottom: "".concat(percent, "%")
            };
        },
        leap: function leap(percent) {
            return {
                height: "".concat(percent, "%")
            };
        }
    }
};
var $183d092b326e173d$var$Identity = function Identity(x) {
    return x;
};
var $183d092b326e173d$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            height: 2,
            width: '100%',
            boxSizing: 'content-box',
            padding: '13px 0',
            display: 'inline-block',
            position: 'relative',
            cursor: 'pointer',
            touchAction: 'none',
            color: theme.palette.primary.main,
            WebkitTapHighlightColor: 'transparent',
            '&$disabled': {
                pointerEvents: 'none',
                cursor: 'default',
                color: theme.palette.grey[400]
            },
            '&$vertical': {
                width: 2,
                height: '100%',
                padding: '0 13px'
            },
            // The primary input mechanism of the device includes a pointing device of limited accuracy.
            '@media (pointer: coarse)': {
                // Reach 42px touch target, about ~8mm on screen.
                padding: '20px 0',
                '&$vertical': {
                    padding: '0 20px'
                }
            },
            '@media print': {
                colorAdjust: 'exact'
            }
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {},
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `marks` is provided with at least one label. */ marked: {
            marginBottom: 20,
            '&$vertical': {
                marginBottom: 'auto',
                marginRight: 20
            }
        },
        /* Pseudo-class applied to the root element if `orientation="vertical"`. */ vertical: {},
        /* Pseudo-class applied to the root and thumb element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the rail element. */ rail: {
            display: 'block',
            position: 'absolute',
            width: '100%',
            height: 2,
            borderRadius: 1,
            backgroundColor: 'currentColor',
            opacity: 0.38,
            '$vertical &': {
                height: '100%',
                width: 2
            }
        },
        /* Styles applied to the track element. */ track: {
            display: 'block',
            position: 'absolute',
            height: 2,
            borderRadius: 1,
            backgroundColor: 'currentColor',
            '$vertical &': {
                width: 2
            }
        },
        /* Styles applied to the track element if `track={false}`. */ trackFalse: {
            '& $track': {
                display: 'none'
            }
        },
        /* Styles applied to the track element if `track="inverted"`. */ trackInverted: {
            '& $track': {
                backgroundColor: theme.palette.type === 'light' ? (0, $86m3e.lighten)(theme.palette.primary.main, 0.62) : (0, $86m3e.darken)(theme.palette.primary.main, 0.5)
            },
            '& $rail': {
                opacity: 1
            }
        },
        /* Styles applied to the thumb element. */ thumb: {
            position: 'absolute',
            width: 12,
            height: 12,
            marginLeft: -6,
            marginTop: -5,
            boxSizing: 'border-box',
            borderRadius: '50%',
            outline: 0,
            backgroundColor: 'currentColor',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: theme.transitions.create([
                'box-shadow'
            ], {
                duration: theme.transitions.duration.shortest
            }),
            '&::after': {
                position: 'absolute',
                content: '""',
                borderRadius: '50%',
                // reach 42px hit target (2 * 15 + thumb diameter)
                left: -15,
                top: -15,
                right: -15,
                bottom: -15
            },
            '&$focusVisible,&:hover': {
                boxShadow: "0px 0px 0px 8px ".concat((0, $86m3e.alpha)(theme.palette.primary.main, 0.16)),
                '@media (hover: none)': {
                    boxShadow: 'none'
                }
            },
            '&$active': {
                boxShadow: "0px 0px 0px 14px ".concat((0, $86m3e.alpha)(theme.palette.primary.main, 0.16))
            },
            '&$disabled': {
                width: 8,
                height: 8,
                marginLeft: -4,
                marginTop: -3,
                '&:hover': {
                    boxShadow: 'none'
                }
            },
            '$vertical &': {
                marginLeft: -5,
                marginBottom: -6
            },
            '$vertical &$disabled': {
                marginLeft: -3,
                marginBottom: -4
            }
        },
        /* Styles applied to the thumb element if `color="primary"`. */ thumbColorPrimary: {},
        /* Styles applied to the thumb element if `color="secondary"`. */ thumbColorSecondary: {
            '&$focusVisible,&:hover': {
                boxShadow: "0px 0px 0px 8px ".concat((0, $86m3e.alpha)(theme.palette.secondary.main, 0.16))
            },
            '&$active': {
                boxShadow: "0px 0px 0px 14px ".concat((0, $86m3e.alpha)(theme.palette.secondary.main, 0.16))
            }
        },
        /* Pseudo-class applied to the thumb element if it's active. */ active: {},
        /* Pseudo-class applied to the thumb element if keyboard focused. */ focusVisible: {},
        /* Styles applied to the thumb label element. */ valueLabel: {
            // IE 11 centering bug, to remove from the customization demos once no longer supported
            left: 'calc(-50% - 4px)'
        },
        /* Styles applied to the mark element. */ mark: {
            position: 'absolute',
            width: 2,
            height: 2,
            borderRadius: 1,
            backgroundColor: 'currentColor'
        },
        /* Styles applied to the mark element if active (depending on the value). */ markActive: {
            backgroundColor: theme.palette.background.paper,
            opacity: 0.8
        },
        /* Styles applied to the mark label element. */ markLabel: (0, $edxsd.default)({}, theme.typography.body2, {
            color: theme.palette.text.secondary,
            position: 'absolute',
            top: 26,
            transform: 'translateX(-50%)',
            whiteSpace: 'nowrap',
            '$vertical &': {
                top: 'auto',
                left: 26,
                transform: 'translateY(50%)'
            },
            '@media (pointer: coarse)': {
                top: 40,
                '$vertical &': {
                    left: 31
                }
            }
        }),
        /* Styles applied to the mark label element if active (depending on the value). */ markLabelActive: {
            color: theme.palette.text.primary
        }
    };
};
var $183d092b326e173d$var$Slider = /*#__PURE__*/ $ieT14.forwardRef(function Slider(props, ref) {
    var ariaLabel = props['aria-label'], ariaLabelledby = props['aria-labelledby'], ariaValuetext = props['aria-valuetext'], classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, _props$component = props.component, Component = _props$component === void 0 ? 'span' : _props$component, defaultValue = props.defaultValue, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, getAriaLabel = props.getAriaLabel, getAriaValueText = props.getAriaValueText, _props$marks = props.marks, marksProp = _props$marks === void 0 ? false : _props$marks, _props$max = props.max, max = _props$max === void 0 ? 100 : _props$max, _props$min = props.min, min = _props$min === void 0 ? 0 : _props$min, name = props.name, onChange = props.onChange, onChangeCommitted = props.onChangeCommitted, onMouseDown = props.onMouseDown, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation, _props$scale = props.scale, scale = _props$scale === void 0 ? $183d092b326e173d$var$Identity : _props$scale, _props$step = props.step, step = _props$step === void 0 ? 1 : _props$step, _props$ThumbComponent = props.ThumbComponent, ThumbComponent = _props$ThumbComponent === void 0 ? 'span' : _props$ThumbComponent, _props$track = props.track, track = _props$track === void 0 ? 'normal' : _props$track, valueProp = props.value, _props$ValueLabelComp = props.ValueLabelComponent, ValueLabelComponent = _props$ValueLabelComp === void 0 ? (0, $e4821fdac5ed4d6d$export$2e2bcd8739ae039) : _props$ValueLabelComp, _props$valueLabelDisp = props.valueLabelDisplay, valueLabelDisplay = _props$valueLabelDisp === void 0 ? 'off' : _props$valueLabelDisp, _props$valueLabelForm = props.valueLabelFormat, valueLabelFormat = _props$valueLabelForm === void 0 ? $183d092b326e173d$var$Identity : _props$valueLabelForm, other = (0, $eTwGP.default)(props, [
        "aria-label",
        "aria-labelledby",
        "aria-valuetext",
        "classes",
        "className",
        "color",
        "component",
        "defaultValue",
        "disabled",
        "getAriaLabel",
        "getAriaValueText",
        "marks",
        "max",
        "min",
        "name",
        "onChange",
        "onChangeCommitted",
        "onMouseDown",
        "orientation",
        "scale",
        "step",
        "ThumbComponent",
        "track",
        "value",
        "ValueLabelComponent",
        "valueLabelDisplay",
        "valueLabelFormat"
    ]);
    var theme = (0, $hgPMF.default)();
    var touchId = $ieT14.useRef(); // We can't use the :active browser pseudo-classes.
    // - The active state isn't triggered when clicking on the rail.
    // - The active state isn't transfered when inversing a range slider.
    var _React$useState = $ieT14.useState(-1), active = _React$useState[0], setActive = _React$useState[1];
    var _React$useState2 = $ieT14.useState(-1), open = _React$useState2[0], setOpen = _React$useState2[1];
    var _useControlled = (0, $kuovH.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Slider'
    }), _useControlled2 = (0, $dcIvM.default)(_useControlled, 2), valueDerived = _useControlled2[0], setValueState = _useControlled2[1];
    var range = Array.isArray(valueDerived);
    var values = range ? valueDerived.slice().sort($183d092b326e173d$var$asc) : [
        valueDerived
    ];
    values = values.map(function(value) {
        return $183d092b326e173d$var$clamp(value, min, max);
    });
    var marks = marksProp === true && step !== null ? (0, $83KOU.default)(Array(Math.floor((max - min) / step) + 1)).map(function(_, index) {
        return {
            value: min + step * index
        };
    }) : marksProp || [];
    var _useIsFocusVisible = (0, $6LYoZ.default)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    var _React$useState3 = $ieT14.useState(-1), focusVisible = _React$useState3[0], setFocusVisible = _React$useState3[1];
    var sliderRef = $ieT14.useRef();
    var handleFocusRef = (0, $3A1Xf.default)(focusVisibleRef, sliderRef);
    var handleRef = (0, $3A1Xf.default)(ref, handleFocusRef);
    var handleFocus = (0, $N8hF2.default)(function(event) {
        var index = Number(event.currentTarget.getAttribute('data-index'));
        if (isFocusVisible(event)) setFocusVisible(index);
        setOpen(index);
    });
    var handleBlur = (0, $N8hF2.default)(function() {
        if (focusVisible !== -1) {
            setFocusVisible(-1);
            onBlurVisible();
        }
        setOpen(-1);
    });
    var handleMouseOver = (0, $N8hF2.default)(function(event) {
        var index = Number(event.currentTarget.getAttribute('data-index'));
        setOpen(index);
    });
    var handleMouseLeave = (0, $N8hF2.default)(function() {
        setOpen(-1);
    });
    var isRtl = theme.direction === 'rtl';
    var handleKeyDown = (0, $N8hF2.default)(function(event) {
        var index = Number(event.currentTarget.getAttribute('data-index'));
        var value = values[index];
        var tenPercents = (max - min) / 10;
        var marksValues = marks.map(function(mark) {
            return mark.value;
        });
        var marksIndex = marksValues.indexOf(value);
        var newValue;
        var increaseKey = isRtl ? 'ArrowLeft' : 'ArrowRight';
        var decreaseKey = isRtl ? 'ArrowRight' : 'ArrowLeft';
        switch(event.key){
            case 'Home':
                newValue = min;
                break;
            case 'End':
                newValue = max;
                break;
            case 'PageUp':
                if (step) newValue = value + tenPercents;
                break;
            case 'PageDown':
                if (step) newValue = value - tenPercents;
                break;
            case increaseKey:
            case 'ArrowUp':
                if (step) newValue = value + step;
                else newValue = marksValues[marksIndex + 1] || marksValues[marksValues.length - 1];
                break;
            case decreaseKey:
            case 'ArrowDown':
                if (step) newValue = value - step;
                else newValue = marksValues[marksIndex - 1] || marksValues[0];
                break;
            default:
                return;
        } // Prevent scroll of the page
        event.preventDefault();
        if (step) newValue = $183d092b326e173d$var$roundValueToStep(newValue, step, min);
        newValue = $183d092b326e173d$var$clamp(newValue, min, max);
        if (range) {
            var previousValue = newValue;
            newValue = $183d092b326e173d$var$setValueIndex({
                values: values,
                source: valueDerived,
                newValue: newValue,
                index: index
            }).sort($183d092b326e173d$var$asc);
            $183d092b326e173d$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: newValue.indexOf(previousValue)
            });
        }
        setValueState(newValue);
        setFocusVisible(index);
        if (onChange) onChange(event, newValue);
        if (onChangeCommitted) onChangeCommitted(event, newValue);
    });
    var previousIndex = $ieT14.useRef();
    var axis = orientation;
    if (isRtl && orientation !== "vertical") axis += '-reverse';
    var getFingerNewValue = function getFingerNewValue(_ref3) {
        var finger = _ref3.finger, _ref3$move = _ref3.move, move = _ref3$move === void 0 ? false : _ref3$move, values2 = _ref3.values, source = _ref3.source;
        var slider = sliderRef.current;
        var _slider$getBoundingCl = slider.getBoundingClientRect(), width = _slider$getBoundingCl.width, height = _slider$getBoundingCl.height, bottom = _slider$getBoundingCl.bottom, left = _slider$getBoundingCl.left;
        var percent;
        if (axis.indexOf('vertical') === 0) percent = (bottom - finger.y) / height;
        else percent = (finger.x - left) / width;
        if (axis.indexOf('-reverse') !== -1) percent = 1 - percent;
        var newValue;
        newValue = $183d092b326e173d$var$percentToValue(percent, min, max);
        if (step) newValue = $183d092b326e173d$var$roundValueToStep(newValue, step, min);
        else {
            var marksValues = marks.map(function(mark) {
                return mark.value;
            });
            var closestIndex = $183d092b326e173d$var$findClosest(marksValues, newValue);
            newValue = marksValues[closestIndex];
        }
        newValue = $183d092b326e173d$var$clamp(newValue, min, max);
        var activeIndex = 0;
        if (range) {
            if (!move) activeIndex = $183d092b326e173d$var$findClosest(values2, newValue);
            else activeIndex = previousIndex.current;
            var previousValue = newValue;
            newValue = $183d092b326e173d$var$setValueIndex({
                values: values2,
                source: source,
                newValue: newValue,
                index: activeIndex
            }).sort($183d092b326e173d$var$asc);
            activeIndex = newValue.indexOf(previousValue);
            previousIndex.current = activeIndex;
        }
        return {
            newValue: newValue,
            activeIndex: activeIndex
        };
    };
    var handleTouchMove = (0, $N8hF2.default)(function(event) {
        var finger = $183d092b326e173d$var$trackFinger(event, touchId);
        if (!finger) return;
        var _getFingerNewValue = getFingerNewValue({
            finger: finger,
            move: true,
            values: values,
            source: valueDerived
        }), newValue = _getFingerNewValue.newValue, activeIndex = _getFingerNewValue.activeIndex;
        $183d092b326e173d$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (onChange) onChange(event, newValue);
    });
    var handleTouchEnd = (0, $N8hF2.default)(function(event) {
        var finger = $183d092b326e173d$var$trackFinger(event, touchId);
        if (!finger) return;
        var _getFingerNewValue2 = getFingerNewValue({
            finger: finger,
            values: values,
            source: valueDerived
        }), newValue = _getFingerNewValue2.newValue;
        setActive(-1);
        if (event.type === 'touchend') setOpen(-1);
        if (onChangeCommitted) onChangeCommitted(event, newValue);
        touchId.current = undefined;
        var doc = (0, $7e6Rg.default)(sliderRef.current);
        doc.removeEventListener('mousemove', handleTouchMove);
        doc.removeEventListener('mouseup', handleTouchEnd);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
    });
    var handleTouchStart = (0, $N8hF2.default)(function(event) {
        // Workaround as Safari has partial support for touchAction: 'none'.
        event.preventDefault();
        var touch = event.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        var finger = $183d092b326e173d$var$trackFinger(event, touchId);
        var _getFingerNewValue3 = getFingerNewValue({
            finger: finger,
            values: values,
            source: valueDerived
        }), newValue = _getFingerNewValue3.newValue, activeIndex = _getFingerNewValue3.activeIndex;
        $183d092b326e173d$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (onChange) onChange(event, newValue);
        var doc = (0, $7e6Rg.default)(sliderRef.current);
        doc.addEventListener('touchmove', handleTouchMove);
        doc.addEventListener('touchend', handleTouchEnd);
    });
    $ieT14.useEffect(function() {
        var slider = sliderRef.current;
        slider.addEventListener('touchstart', handleTouchStart);
        var doc = (0, $7e6Rg.default)(slider);
        return function() {
            slider.removeEventListener('touchstart', handleTouchStart);
            doc.removeEventListener('mousemove', handleTouchMove);
            doc.removeEventListener('mouseup', handleTouchEnd);
            doc.removeEventListener('touchmove', handleTouchMove);
            doc.removeEventListener('touchend', handleTouchEnd);
        };
    }, [
        handleTouchEnd,
        handleTouchMove,
        handleTouchStart
    ]);
    var handleMouseDown = (0, $N8hF2.default)(function(event) {
        if (onMouseDown) onMouseDown(event);
        event.preventDefault();
        var finger = $183d092b326e173d$var$trackFinger(event, touchId);
        var _getFingerNewValue4 = getFingerNewValue({
            finger: finger,
            values: values,
            source: valueDerived
        }), newValue = _getFingerNewValue4.newValue, activeIndex = _getFingerNewValue4.activeIndex;
        $183d092b326e173d$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (onChange) onChange(event, newValue);
        var doc = (0, $7e6Rg.default)(sliderRef.current);
        doc.addEventListener('mousemove', handleTouchMove);
        doc.addEventListener('mouseup', handleTouchEnd);
    });
    var trackOffset = $183d092b326e173d$var$valueToPercent(range ? values[0] : min, min, max);
    var trackLeap = $183d092b326e173d$var$valueToPercent(values[values.length - 1], min, max) - trackOffset;
    var trackStyle = (0, $edxsd.default)({}, $183d092b326e173d$var$axisProps[axis].offset(trackOffset), $183d092b326e173d$var$axisProps[axis].leap(trackLeap));
    return /*#__PURE__*/ $ieT14.createElement(Component, (0, $edxsd.default)({
        ref: handleRef,
        className: (0, $j6s32.default)(classes.root, classes["color".concat((0, $2EBFt.default)(color))], className, disabled && classes.disabled, marks.length > 0 && marks.some(function(mark) {
            return mark.label;
        }) && classes.marked, track === false && classes.trackFalse, orientation === 'vertical' && classes.vertical, track === 'inverted' && classes.trackInverted),
        onMouseDown: handleMouseDown
    }, other), /*#__PURE__*/ $ieT14.createElement("span", {
        className: classes.rail
    }), /*#__PURE__*/ $ieT14.createElement("span", {
        className: classes.track,
        style: trackStyle
    }), /*#__PURE__*/ $ieT14.createElement("input", {
        value: values.join(','),
        name: name,
        type: "hidden"
    }), marks.map(function(mark, index) {
        var percent = $183d092b326e173d$var$valueToPercent(mark.value, min, max);
        var style = $183d092b326e173d$var$axisProps[axis].offset(percent);
        var markActive;
        if (track === false) markActive = values.indexOf(mark.value) !== -1;
        else markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
        return /*#__PURE__*/ $ieT14.createElement($ieT14.Fragment, {
            key: mark.value
        }, /*#__PURE__*/ $ieT14.createElement("span", {
            style: style,
            "data-index": index,
            className: (0, $j6s32.default)(classes.mark, markActive && classes.markActive)
        }), mark.label != null ? /*#__PURE__*/ $ieT14.createElement("span", {
            "aria-hidden": true,
            "data-index": index,
            style: style,
            className: (0, $j6s32.default)(classes.markLabel, markActive && classes.markLabelActive)
        }, mark.label) : null);
    }), values.map(function(value, index) {
        var percent = $183d092b326e173d$var$valueToPercent(value, min, max);
        var style = $183d092b326e173d$var$axisProps[axis].offset(percent);
        return /*#__PURE__*/ $ieT14.createElement(ValueLabelComponent, {
            key: index,
            valueLabelFormat: valueLabelFormat,
            valueLabelDisplay: valueLabelDisplay,
            className: classes.valueLabel,
            value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
            index: index,
            open: open === index || active === index || valueLabelDisplay === 'on',
            disabled: disabled
        }, /*#__PURE__*/ $ieT14.createElement(ThumbComponent, {
            className: (0, $j6s32.default)(classes.thumb, classes["thumbColor".concat((0, $2EBFt.default)(color))], active === index && classes.active, disabled && classes.disabled, focusVisible === index && classes.focusVisible),
            tabIndex: disabled ? null : 0,
            role: "slider",
            style: style,
            "data-index": index,
            "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-orientation": orientation,
            "aria-valuemax": scale(max),
            "aria-valuemin": scale(min),
            "aria-valuenow": scale(value),
            "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
            onKeyDown: handleKeyDown,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onMouseOver: handleMouseOver,
            onMouseLeave: handleMouseLeave
        }));
    }));
});
var $183d092b326e173d$export$2e2bcd8739ae039 = (0, $aIJrd.default)($183d092b326e173d$export$9dd6ff9ea0189349, {
    name: 'MuiSlider'
})($183d092b326e173d$var$Slider);


var $eYT2J = parcelRequire("eYT2J");


var $4leCF = parcelRequire("4leCF");

var $ieT14 = parcelRequire("ieT14");
const $b122ec9cd0599730$export$54f15d3027438ccd = (attribute, initialValues)=>{
    const [minValue, setMinValue] = $ieT14.useState(initialValues.min || attribute.filters.min);
    const [maxValue, setMaxValue] = $ieT14.useState(initialValues.max || attribute.filters.max);
    const [warning, setWarning] = $ieT14.useState('');
    const handleSliderChange = (_event, value)=>{
        setMinValue(value[0]);
        setMaxValue(value[1]);
    };
    $ieT14.useEffect(()=>{
        if (maxValue === '') setWarning('');
        else if (minValue < attribute.filters.min) setWarning(`Minimum value is ${attribute.filters.min}`);
        else if (minValue > attribute.filters.max) setWarning(`Maximum value is ${attribute.filters.max}`);
        else setWarning('');
    }, [
        minValue
    ]);
    $ieT14.useEffect(()=>{
        if (maxValue === '') setWarning('');
        else if (maxValue < attribute.filters.min) setWarning(`Minimum value is ${attribute.filters.min}`);
        else if (maxValue > attribute.filters.max) setWarning(`Maximum value is ${attribute.filters.max}`);
        else setWarning('');
    }, [
        maxValue
    ]);
    const handleMinChange = (event)=>{
        setMinValue(event.target.value === '' ? '' : Number(event.target.value));
    };
    const handleMaxChange = (event)=>{
        setMaxValue(event.target.value === '' ? '' : Number(event.target.value));
    };
    const handleMinBlur = ()=>{
        if (minValue === '') setMinValue(attribute.filters.min);
        else if (minValue < attribute.filters.min) setMinValue(attribute.filters.min);
        else if (minValue > attribute.filters.max) setMinValue(attribute.filters.max);
    };
    const handleMaxBlur = ()=>{
        if (maxValue === '') setMaxValue(attribute.filters.max);
        else if (maxValue < attribute.filters.min) setMaxValue(attribute.filters.min);
        else if (maxValue > attribute.filters.max) setMaxValue(attribute.filters.max);
    };
    return {
        minValue: minValue,
        setMinValue: setMinValue,
        maxValue: maxValue,
        setMaxValue: setMaxValue,
        handleSliderChange: handleSliderChange,
        handleMinChange: handleMinChange,
        handleMinBlur: handleMinBlur,
        handleMaxChange: handleMaxChange,
        handleMaxBlur: handleMaxBlur,
        warning: warning
    };
};






const $cb9afff3bff80545$var$useStyles = (0, $e1ONw.default)({
    slider: {
        '& .MuiSlider-thumb': {
            color: (0, $69ed148db7543104$export$a4867fe9454f37a8)[300],
            border: `1px solid ${(0, $69ed148db7543104$export$a4867fe9454f37a8)[500]}`
        },
        '& .MuiSlider-track': {
            color: (0, $69ed148db7543104$export$2aa0182783e7e9de)[500]
        }
    },
    minmaxInput: {
        maxWidth: 100,
        marginTop: 8,
        marginBottom: 8
    }
});
/**
 * Modal dialog component to render the filter options for a single attribute when building a segment
 */ const $cb9afff3bff80545$var$AttributeFilterRange = ({ attribute: attribute, selectedAttribute: selectedAttribute, position: position, exclude: exclude, applyTransactional: applyTransactional, attributeIndex: attributeIndex })=>{
    const overrides = $cb9afff3bff80545$var$useStyles();
    const { dispatch: dispatch } = (0, $79aece72917dec2b$export$7cea9ed133024a2d)(exclude);
    const [dialogOpen, setDialogOpen] = $ieT14.useState(false);
    const [selectedRange, setSelectedRange] = $ieT14.useState({
        min: selectedAttribute.range.min || attribute.filters.min,
        max: selectedAttribute.range.max || attribute.filters.max
    });
    const { minValue: minValue, setMinValue: setMinValue, maxValue: maxValue, setMaxValue: setMaxValue, handleSliderChange: handleSliderChange, handleMinChange: handleMinChange, handleMinBlur: handleMinBlur, handleMaxChange: handleMaxChange, handleMaxBlur: handleMaxBlur, warning: warning } = (0, $b122ec9cd0599730$export$54f15d3027438ccd)(attribute, selectedAttribute.range);
    $ieT14.useEffect(()=>{
        setMinValue(selectedRange.min);
        setMaxValue(selectedRange.max);
        const selectedMin = selectedRange.min === attribute.filters.min ? null : selectedRange.min;
        const selectedMax = selectedRange.max === attribute.filters.max ? null : selectedRange.max;
        if (!applyTransactional) dispatch({
            type: 'updateAttribute',
            attribute: {
                ...selectedAttribute,
                range: {
                    min: selectedMin,
                    max: selectedMax
                }
            },
            position: position,
            attributeIndex: attributeIndex
        });
        else applyTransactional({
            min: selectedMin,
            max: selectedMax
        });
    }, [
        selectedRange
    ]);
    /** Reset to previous filters on cancel */ const handleCancel = ()=>{
        setMinValue(selectedRange.min);
        setMaxValue(selectedRange.max);
        setDialogOpen(false);
    };
    const handleApply = ()=>{
        const nextMin = minValue === '' ? attribute.filters.min : minValue;
        const nextMax = maxValue === '' ? attribute.filters.max : maxValue;
        setSelectedRange({
            // Ensure that min is lower than max, swap if needed
            min: nextMin < nextMax ? nextMin : nextMax,
            max: nextMax > nextMin ? nextMax : nextMin
        });
        setDialogOpen(false);
    };
    /** Function passed to filter select `renderValue` prop: conditionally render the custom content of the filter multi-select menu */ const renderFilterValues = (value)=>{
        if (selectedRange.min == attribute.filters.min && selectedRange.max == attribute.filters.max) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
            className: $d3a6c5cfb2396086$export$dac863774b2ab841,
            children: "All - click for additional filtering"
        });
        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
            className: $d3a6c5cfb2396086$export$ced7484dd0a65e67,
            children: [
                value.min != attribute.filters.min && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1fc2eb6485c96dfd$export$522e6e3e785eb2cd), {
                    label: `Min: ${value.min.toLocaleString()}`,
                    size: "small",
                    deleteIcon: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4leCF.default), {
                        onMouseDown: (event)=>event.stopPropagation(),
                        "aria-label": "delete filter"
                    }),
                    onDelete: ()=>setSelectedRange((prev)=>({
                                ...prev,
                                min: attribute.filters.min
                            }))
                }, `${attribute.id}-min`),
                value.max != attribute.filters.max && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1fc2eb6485c96dfd$export$522e6e3e785eb2cd), {
                    label: `Max: ${value.max.toLocaleString()}`,
                    size: "small",
                    deleteIcon: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4leCF.default), {
                        onMouseDown: (event)=>event.stopPropagation(),
                        "aria-label": "delete filter"
                    }),
                    onDelete: ()=>setSelectedRange((prev)=>({
                                ...prev,
                                max: attribute.filters.max
                            }))
                }, `${attribute.id}-max`)
            ]
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $aanJt.default), {
                id: `filter-attribute-${attribute.id}`,
                multiple: true,
                value: selectedRange,
                open: false,
                onOpen: ()=>{
                    setDialogOpen(true);
                },
                renderValue: renderFilterValues,
                displayEmpty: true
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $d7db63c711af8c68$export$2e2bcd8739ae039), {
                open: dialogOpen,
                title: "Select Filters",
                handleCancel: handleCancel,
                handleApply: handleApply,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h4", {
                        className: $d3a6c5cfb2396086$export$d55a54c110df7b5e,
                        children: attribute.name
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $183d092b326e173d$export$2e2bcd8739ae039), {
                        value: [
                            typeof minValue == 'number' ? minValue : attribute.filters.min,
                            typeof maxValue == 'number' ? maxValue : attribute.filters.max
                        ],
                        min: attribute.filters.min,
                        max: attribute.filters.max,
                        onChange: handleSliderChange,
                        valueLabelDisplay: "off",
                        className: overrides.slider
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("form", {
                        className: $d3a6c5cfb2396086$export$4babbd232a636c2f,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYT2J.default), {
                                size: "small",
                                variant: "outlined",
                                label: "Min",
                                value: minValue,
                                onChange: handleMinChange,
                                onBlur: handleMinBlur,
                                className: overrides.minmaxInput,
                                inputProps: {
                                    type: 'number',
                                    min: attribute.filters.min,
                                    max: attribute.filters.max
                                }
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                className: $d3a6c5cfb2396086$export$2b33c41f722d2be0,
                                children: "-"
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYT2J.default), {
                                size: "small",
                                variant: "outlined",
                                label: "Max",
                                value: maxValue,
                                onChange: handleMaxChange,
                                onBlur: handleMaxBlur,
                                className: overrides.minmaxInput,
                                inputProps: {
                                    type: 'number',
                                    min: attribute.filters.min,
                                    max: attribute.filters.max
                                }
                            })
                        ]
                    }),
                    warning && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("p", {
                        className: $d3a6c5cfb2396086$export$8bb22f439af601c0,
                        children: warning
                    })
                ]
            })
        ]
    });
};
var $cb9afff3bff80545$export$2e2bcd8739ae039 = $cb9afff3bff80545$var$AttributeFilterRange;




var $ieT14 = parcelRequire("ieT14");

var $3WBJn = parcelRequire("3WBJn");
var $e1ONw = parcelRequire("e1ONw");
var $aanJt = parcelRequire("aanJt");
var $eYT2J = parcelRequire("eYT2J");
var $hgPMF = parcelRequire("hgPMF");


var $fgoQ6 = parcelRequire("fgoQ6");

var $4leCF = parcelRequire("4leCF");


const $fa6006f241582940$var$useStyles = (0, $e1ONw.default)((theme)=>({
        dialog: {
            [theme.breakpoints.up('sm')]: {
                '& .MuiDialog-paperWidthSm': {
                    maxWidth: '640px'
                }
            }
        },
        dialogTitle: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        dialogActions: {
            justifyContent: 'space-between',
            height: 57,
            padding: '0 24px'
        }
    }));
/**
 * Input text and accompanying modal dialog for filtering a single attribute of filterType: search text when building a segment
 */ const $fa6006f241582940$var$AttributeFilterInput = ({ attribute: attribute, selectedAttribute: selectedAttribute, position: position, exclude: exclude, applyTransactional: applyTransactional, attributeIndex: attributeIndex })=>{
    const overrides = $fa6006f241582940$var$useStyles();
    const { dispatch: dispatch } = (0, $79aece72917dec2b$export$7cea9ed133024a2d)(exclude);
    const [dialogOpen, setDialogOpen] = $ieT14.useState(false);
    const [searchText, setSearchText] = $ieT14.useState(selectedAttribute.searchText);
    const [chipText, setChipText] = $ieT14.useState(selectedAttribute.searchText);
    const theme = (0, $hgPMF.default)();
    const fullScreen = (0, $e3f2b79e5e31197b$export$2e2bcd8739ae039)(theme.breakpoints.only('xs'));
    /** Reset to previous text on cancel */ const handleCancel = ()=>{
        setSearchText(selectedAttribute.searchText);
        setDialogOpen(false);
    };
    const handleApply = ()=>{
        if (!!applyTransactional) applyTransactional(searchText);
        else dispatch({
            type: 'updateAttribute',
            attribute: {
                ...selectedAttribute,
                searchText: searchText
            },
            position: position,
            attributeIndex: attributeIndex
        });
        setChipText(searchText);
        setDialogOpen(false);
    };
    /** Callback passed to TextField */ const handleChange = (event)=>{
        setSearchText(event.target.value);
    };
    const handleDeleteChip = ()=>{
        setSearchText('');
        setChipText('');
        dispatch({
            type: 'updateAttribute',
            attribute: {
                ...selectedAttribute,
                searchText: ''
            },
            position: position,
            attributeIndex: attributeIndex
        });
    };
    /** Function passed to filter select `renderValue` prop: conditionally render the custom content of the filter multi-select menu */ const renderSearchText = (value)=>{
        if (!value || value.length === 0 || !value[0]) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
            className: $d3a6c5cfb2396086$export$dac863774b2ab841,
            children: "Click here to enter text"
        });
        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
            className: $d3a6c5cfb2396086$export$ced7484dd0a65e67,
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1fc2eb6485c96dfd$export$522e6e3e785eb2cd), {
                label: value[0],
                size: "small",
                deleteIcon: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4leCF.default), {
                    onMouseDown: (event)=>event.stopPropagation(),
                    "aria-label": "delete filter"
                }),
                onDelete: handleDeleteChip
            }, value[0])
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $aanJt.default), {
                id: `filter-attribute-${attribute.id}`,
                multiple: true,
                value: chipText ? [
                    chipText
                ] : [],
                open: false,
                onOpen: ()=>{
                    setDialogOpen(true);
                },
                renderValue: renderSearchText,
                displayEmpty: true
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $1c689a1559dbf5e9$export$2e2bcd8739ae039), {
                open: dialogOpen,
                maxWidth: "sm",
                scroll: "paper",
                fullScreen: fullScreen,
                className: overrides.dialog,
                "aria-labelledby": "select-attribute-dialog-title",
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6830d3674ad61fd5$export$2e2bcd8739ae039), {
                        className: overrides.dialogTitle,
                        id: "select-attribute-dialog-title",
                        disableTypography: true,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h3", {
                            className: $d3a6c5cfb2396086$export$b8772d08938399e8,
                            children: "Enter Search Text"
                        })
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $881610d42277b808$export$2e2bcd8739ae039), {
                        dividers: true,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3WBJn.default), {
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYT2J.default), {
                                id: "search-text",
                                name: "search-text",
                                size: "small",
                                variant: "outlined",
                                label: "Search Text",
                                value: searchText || '',
                                onChange: handleChange,
                                inputProps: {
                                    maxLength: 100
                                },
                                autoFocus: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $d176cc26269b23c2$export$2e2bcd8739ae039), {
                        className: overrides.dialogActions,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.TertiaryButton), {
                                text: "Cancel",
                                title: "Cancel",
                                component: "button",
                                handleClick: handleCancel
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryButton), {
                                text: "Apply",
                                title: "Apply",
                                handleClick: handleApply
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $fa6006f241582940$export$2e2bcd8739ae039 = $fa6006f241582940$var$AttributeFilterInput;





var $ieT14 = parcelRequire("ieT14");

var $whS22 = parcelRequire("whS22");
var $1KcBP = parcelRequire("1KcBP");
var $Uxz4Y = parcelRequire("Uxz4Y");
var $e1ONw = parcelRequire("e1ONw");
var $3mOXj = parcelRequire("3mOXj");
var $aanJt = parcelRequire("aanJt");

var $4leCF = parcelRequire("4leCF");

var $j6s32 = parcelRequire("j6s32");




var $fgoQ6 = parcelRequire("fgoQ6");


parcelRequire("ieT14");
var $23d05f9437fc576c$export$b0377cbbbdab6cba;
var $23d05f9437fc576c$export$f27f0a643498ce3d;
var $23d05f9437fc576c$export$b00c055587dc7469;
var $23d05f9437fc576c$export$b1a09d22b7ad6c4;
var $23d05f9437fc576c$export$509f3108fdd206bb;
var $23d05f9437fc576c$export$42ff741d2868ee32;
var $23d05f9437fc576c$export$8c430709db82137d;
var $23d05f9437fc576c$export$2d4b1211b4389c3b;
var $23d05f9437fc576c$export$3832be13857745bc;
var $23d05f9437fc576c$export$f4c68800b094ddb1;
var $23d05f9437fc576c$export$5dcb5c23b6ba980a;
var $23d05f9437fc576c$export$1237798dc640739a;
var $23d05f9437fc576c$export$683472f6198a076e;
$23d05f9437fc576c$export$b0377cbbbdab6cba = "#006da8";
$23d05f9437fc576c$export$f27f0a643498ce3d = "#00aafc";
$23d05f9437fc576c$export$b00c055587dc7469 = "#f5dbd9";
$23d05f9437fc576c$export$b1a09d22b7ad6c4 = "#c92100";
$23d05f9437fc576c$export$509f3108fdd206bb = "#ebafa6";
$23d05f9437fc576c$export$42ff741d2868ee32 = "#074f86";
$23d05f9437fc576c$export$8c430709db82137d = "#dadada";
$23d05f9437fc576c$export$2d4b1211b4389c3b = "#dddbda";
$23d05f9437fc576c$export$3832be13857745bc = "#eae9ed";
$23d05f9437fc576c$export$f4c68800b094ddb1 = "#e9e8f4";
$23d05f9437fc576c$export$5dcb5c23b6ba980a = "addAttribute_155bf6";
$23d05f9437fc576c$export$1237798dc640739a = "label_155bf6";
$23d05f9437fc576c$export$683472f6198a076e = "disabled_155bf6";



var $1KcBP = parcelRequire("1KcBP");



var $j6s32 = parcelRequire("j6s32");
const $b1c3fceec5a3a004$var$AddAttribute = ({ label: label, handleClick: handleClick, disabled: disabled })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $23d05f9437fc576c$export$5dcb5c23b6ba980a,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                size: "small",
                onClick: handleClick,
                "aria-label": label,
                disabled: disabled,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $5a6641286109afb6$export$2e2bcd8739ae039), {
                    htmlColor: disabled ? (0, $69ed148db7543104$export$8f45430ccf837300).lightGrey : (0, $69ed148db7543104$export$2aa0182783e7e9de)[600],
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("p", {
                className: (0, $j6s32.default)($23d05f9437fc576c$export$1237798dc640739a, disabled && $23d05f9437fc576c$export$683472f6198a076e),
                children: label
            })
        ]
    });
};
var $b1c3fceec5a3a004$export$2e2bcd8739ae039 = $b1c3fceec5a3a004$var$AddAttribute;





var $3umuy = parcelRequire("3umuy");



var $fRnKy = parcelRequire("fRnKy");


var $ieT14 = parcelRequire("ieT14");

var $whS22 = parcelRequire("whS22");
var $Uxz4Y = parcelRequire("Uxz4Y");
var $e1ONw = parcelRequire("e1ONw");
var $3mOXj = parcelRequire("3mOXj");
var $aanJt = parcelRequire("aanJt");


const $0e860a8a329fdc63$var$useStyles = (0, $e1ONw.default)({
    inputs: {
        margin: '4px 12px',
        flex: '0 0 96px',
        '& .MuiInputLabel-root': {
            backgroundColor: '#f8f8f8'
        },
        '& .MuiInputLabel-asterisk': {
            color: (0, $69ed148db7543104$export$8f45430ccf837300).rustRed
        }
    }
});
/**
 * AND/OR Attribute group operator
 */ const $0e860a8a329fdc63$var$OperatorSelect = ({ disabled: disabled, operator: operator, handleChange: handleChange })=>{
    const overrides = $0e860a8a329fdc63$var$useStyles();
    const id = $ieT14.useId();
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
        required: true,
        size: "small",
        variant: "outlined",
        className: overrides.inputs,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $Uxz4Y.default), {
                htmlFor: `select-operator-${id}`,
                children: "And/Or"
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $aanJt.default), {
                id: `select-operator-${id}`,
                value: operator,
                onChange: (event)=>{
                    handleChange(event.target.value);
                },
                disabled: disabled,
                required: true,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                        value: (0, $a9d5bf712846139f$export$905dbc95765b1ada).And,
                        children: "And"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                        value: (0, $a9d5bf712846139f$export$905dbc95765b1ada).Or,
                        children: "Or"
                    })
                ]
            })
        ]
    });
};
var $0e860a8a329fdc63$export$2e2bcd8739ae039 = $0e860a8a329fdc63$var$OperatorSelect;







var $whS22 = parcelRequire("whS22");
var $1KcBP = parcelRequire("1KcBP");
var $Uxz4Y = parcelRequire("Uxz4Y");
var $e1ONw = parcelRequire("e1ONw");
var $3mOXj = parcelRequire("3mOXj");
var $aanJt = parcelRequire("aanJt");
var $eYT2J = parcelRequire("eYT2J");

var $ieT14 = parcelRequire("ieT14");




var $j6s32 = parcelRequire("j6s32");



var $4leCF = parcelRequire("4leCF");



var $fRnKy = parcelRequire("fRnKy");

const $e92b4c687e06a774$var$breakpoints = {
    xs: 640,
    sm: 1020,
    md: 1200
};
const $e92b4c687e06a774$var$useStyles = (0, $e1ONw.default)((theme)=>({
        groupByContainer: {
            display: 'flex',
            flexDirection: 'column',
            padding: '15px 0 10px'
        },
        headerMargin: {
            marginTop: 0
        },
        inputs: {
            margin: '4px 12px',
            '& .MuiInputLabel-asterisk': {
                color: (0, $69ed148db7543104$export$8f45430ccf837300).rustRed
            },
            width: '300px'
        },
        attributeSelect: {
            [theme.breakpoints.down($e92b4c687e06a774$var$breakpoints.sm)]: {
                flex: 1
            },
            [theme.breakpoints.up($e92b4c687e06a774$var$breakpoints.sm)]: {
                flex: '0 0 200px'
            },
            [theme.breakpoints.up($e92b4c687e06a774$var$breakpoints.md)]: {
                flex: '0 0 300px'
            }
        },
        attribute: {
            flex: 1,
            minWidth: 0,
            display: 'flex',
            alignItems: 'center',
            paddingTop: 10,
            paddingBottom: 10
        },
        filterOperatorSelect: {
            flex: '0 0 200px',
            [theme.breakpoints.up($e92b4c687e06a774$var$breakpoints.xs)]: {
                flex: '0 0 225px'
            }
        },
        addControls: {
            display: 'flex',
            'align-items': 'center',
            'justify-content': 'flex-end'
        },
        valueInput: {
            width: '230px'
        },
        delete: {
            flex: '0 0 48px',
            marginRight: 12,
            zIndex: 1,
            '&.Mui-disabled': {
                opacity: 0.5
            }
        }
    }));
const $e92b4c687e06a774$var$defaultGroupByValuesPredicates = {
    aggregateFunction: (0, $a9d5bf712846139f$export$48733c9c52b2aead).Sum,
    aggregateOperator: (0, $a9d5bf712846139f$export$a7b636559b01a55f)['Is Greater Than'],
    value: '',
    valueFilterColumnName: '',
    valueFilterId: undefined,
    valueFilterName: ''
};
const $e92b4c687e06a774$var$defaultGroupByValues = {
    groupByOperator: 0,
    groupByPredicates: [
        {
            ...$e92b4c687e06a774$var$defaultGroupByValuesPredicates
        }
    ]
};
const $e92b4c687e06a774$var$AttributeGroupBy = ({ transactionalFilterOptions: transactionalFilterOptions, selectedGroupBy: selectedGroupBy, updateGroupBy: updateGroupBy })=>{
    const classes = $e92b4c687e06a774$var$useStyles();
    const getTransactionalFilter = (filterId)=>{
        return transactionalFilterOptions.find((option)=>option.filterId === filterId);
    };
    const [selectionCollapsed, setSelectionCollapsed] = $ieT14.useState(true);
    const [selectedGroupByOption, setSelectedGroupByOption] = $ieT14.useState(selectedGroupBy?.groupByFilterId ? getTransactionalFilter(selectedGroupBy.groupByFilterId) : null);
    const [groupByValues, setGroupByValues] = $ieT14.useState(selectedGroupBy?.groupByValues ?? $e92b4c687e06a774$var$defaultGroupByValues);
    $ieT14.useEffect(()=>{
        if (!selectedGroupByOption?.filterId) updateGroupBy(null);
        else {
            const updatedGroupByValues = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).cloneDeep(groupByValues);
            const groupBy = {
                groupByFilterId: selectedGroupByOption.filterId,
                groupByFilterColumnName: selectedGroupByOption.columnName,
                groupByFilterName: selectedGroupByOption.name,
                groupByValues: updatedGroupByValues
            };
            updateGroupBy(groupBy);
        }
    }, [
        selectedGroupByOption,
        groupByValues
    ]);
    const clearGroupBy = ()=>{
        setSelectedGroupByOption(null);
    };
    const updateGroupByValues = (updatedValue, groupByRow)=>{
        const clonedFilter = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).cloneDeep(groupByValues);
        clonedFilter.groupByPredicates[groupByRow] = {
            ...updatedValue
        };
        setGroupByValues(clonedFilter);
    };
    const updateGroupByOperator = (operator)=>{
        const clonedFilter = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).cloneDeep(groupByValues);
        clonedFilter.groupByOperator = operator;
        setGroupByValues(clonedFilter);
    };
    const renderFilterValues = (value)=>{
        if (!value || !selectedGroupByOption) return '';
        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
            className: $d3a6c5cfb2396086$export$ced7484dd0a65e67,
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1fc2eb6485c96dfd$export$522e6e3e785eb2cd), {
                label: selectedGroupByOption.columnName,
                size: "small",
                deleteIcon: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4leCF.default), {
                    onMouseDown: (event)=>event.stopPropagation(),
                    "aria-label": "remove group by"
                }),
                onDelete: clearGroupBy
            })
        });
    };
    const addAnotherGroupByFilter = ()=>{
        const clonedFilter = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).cloneDeep(groupByValues);
        clonedFilter.groupByPredicates.push($e92b4c687e06a774$var$defaultGroupByValuesPredicates);
        setGroupByValues(clonedFilter);
    };
    const handleDeleteGroupByValueRow = (rowIndex)=>{
        const clonedFilters = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).cloneDeep(groupByValues);
        clonedFilters.groupByPredicates.splice(rowIndex, 1);
        if (clonedFilters.groupByPredicates.length === 0) clonedFilters.groupByPredicates.push($e92b4c687e06a774$var$defaultGroupByValuesPredicates);
        setGroupByValues(clonedFilters);
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $365a06e4442a50da$export$55b973e094275b13), {
        title: "Group By (Optional)",
        collapsed: selectionCollapsed,
        onCollapse: setSelectionCollapsed,
        className: classes.headerMargin,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
            className: classes.groupByContainer,
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
                    size: "small",
                    variant: "outlined",
                    className: classes.inputs,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $Uxz4Y.default), {
                            id: "group-by-selection",
                            children: "What do you want to group by?"
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $aanJt.default), {
                            labelId: "group-by-selection",
                            value: selectedGroupByOption?.filterId ?? '',
                            renderValue: renderFilterValues,
                            onChange: (event)=>{
                                const selectedOption = transactionalFilterOptions.find((option)=>option.filterId === Number(event.target.value));
                                setSelectedGroupByOption(selectedOption);
                            },
                            children: transactionalFilterOptions?.map((filter)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                    value: filter.filterId,
                                    children: filter.name
                                }, `Group-By-Option-${filter.filterId}`))
                        })
                    ]
                }),
                groupByValues.groupByPredicates.map((groupByPredicate, index)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($e92b4c687e06a774$var$GroupByPredicatesRow, {
                        groupByPredicate: groupByPredicate,
                        groupByOperator: groupByValues.groupByOperator,
                        filterSelectDisabled: !selectedGroupByOption,
                        transactionalFilterOptions: transactionalFilterOptions.filter((option)=>option.filterType === 'range'),
                        predicateIndex: index,
                        updateGroupByValueRow: updateGroupByValues,
                        updateGroupByOperator: updateGroupByOperator,
                        handleDeleteGroupByValueRow: handleDeleteGroupByValueRow
                    }, `${groupByPredicate.valueFilterId} - ${index}`)),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: classes.addControls,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $b1c3fceec5a3a004$export$2e2bcd8739ae039), {
                        label: "Add another value",
                        handleClick: addAnotherGroupByFilter,
                        disabled: !selectedGroupByOption
                    })
                })
            ]
        })
    });
};
const $e92b4c687e06a774$var$GroupByPredicatesRow = ({ groupByPredicate: groupByPredicate, groupByOperator: groupByOperator, transactionalFilterOptions: transactionalFilterOptions, filterSelectDisabled: filterSelectDisabled, predicateIndex: predicateIndex, updateGroupByValueRow: updateGroupByValueRow, updateGroupByOperator: updateGroupByOperator, handleDeleteGroupByValueRow: handleDeleteGroupByValueRow })=>{
    const classes = $e92b4c687e06a774$var$useStyles();
    const updatePredicateValue = (updatedValue)=>{
        updateGroupByValueRow(updatedValue, predicateIndex);
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: classes.attribute,
        children: [
            predicateIndex === 0 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $4830ac0c4a56bbcf$export$6b8b92a9240a8a67
            }),
            predicateIndex === 1 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $0e860a8a329fdc63$export$2e2bcd8739ae039), {
                operator: groupByOperator,
                handleChange: (operator)=>updateGroupByOperator(operator)
            }),
            predicateIndex > 1 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $4830ac0c4a56bbcf$export$6b8b92a9240a8a67,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("p", {
                    className: $4830ac0c4a56bbcf$export$f98f2d26ae95425a,
                    children: (0, $a9d5bf712846139f$export$905dbc95765b1ada)[groupByOperator]
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
                size: "small",
                variant: "outlined",
                className: classes.inputs,
                required: true,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $Uxz4Y.default), {
                        id: "target-by-selection",
                        children: "What do you want to target?"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $aanJt.default), {
                        labelId: "target-by-selection",
                        value: groupByPredicate?.valueFilterId ?? '',
                        disabled: filterSelectDisabled,
                        onChange: (event)=>{
                            const selectedOption = transactionalFilterOptions.find((option)=>option.filterId === Number(event.target.value));
                            updatePredicateValue({
                                ...groupByPredicate,
                                valueFilterId: selectedOption.filterId,
                                valueFilterColumnName: selectedOption.columnName,
                                valueFilterName: selectedOption.name
                            });
                        },
                        children: transactionalFilterOptions?.map((filter)=>{
                            return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                value: filter.filterId,
                                children: filter.name
                            }, `Target-Option-${filter.filterId}`);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
                size: "small",
                variant: "outlined",
                className: (0, $j6s32.default)(classes.inputs, classes.filterOperatorSelect),
                required: true,
                disabled: filterSelectDisabled,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $Uxz4Y.default), {
                        id: "aggregate-function-filter-selection",
                        children: "Aggregate Function"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $aanJt.default), {
                        labelId: "aggregate-function-filter-selection",
                        value: groupByPredicate.aggregateFunction,
                        disabled: filterSelectDisabled,
                        onChange: (event)=>{
                            updatePredicateValue({
                                ...groupByPredicate,
                                aggregateFunction: event.target.value
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                value: (0, $a9d5bf712846139f$export$48733c9c52b2aead)['Sum'],
                                children: "Sum"
                            }, "Sum"),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                value: (0, $a9d5bf712846139f$export$48733c9c52b2aead)['Average'],
                                children: "Average"
                            }, "Average"),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                value: (0, $a9d5bf712846139f$export$48733c9c52b2aead)['Count'],
                                children: "Count"
                            }, "Count"),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                value: (0, $a9d5bf712846139f$export$48733c9c52b2aead)['Count Distinct'],
                                children: "Count Distinct"
                            }, "Count Distinct"),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                value: (0, $a9d5bf712846139f$export$48733c9c52b2aead)['Minimum'],
                                children: "Minimum"
                            }, "Minimum"),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                value: (0, $a9d5bf712846139f$export$48733c9c52b2aead)['Maximum'],
                                children: "Maximum"
                            }, "Maximum")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
                size: "small",
                variant: "outlined",
                className: (0, $j6s32.default)(classes.inputs, classes.filterOperatorSelect),
                required: true,
                disabled: filterSelectDisabled,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $Uxz4Y.default), {
                        id: "operator-filter-selection",
                        children: "Operator"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $aanJt.default), {
                        labelId: "operator-filter-selection",
                        value: groupByPredicate.aggregateOperator,
                        disabled: filterSelectDisabled,
                        onChange: (event)=>{
                            updatePredicateValue({
                                ...groupByPredicate,
                                aggregateOperator: event.target.value
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                value: (0, $a9d5bf712846139f$export$a7b636559b01a55f)['Is Greater Than'],
                                children: "Is Greater Than"
                            }, "Is Greater Than"),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                value: (0, $a9d5bf712846139f$export$a7b636559b01a55f)['Is Less Than'],
                                children: "Is Less Than"
                            }, "Is Less Than"),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                value: (0, $a9d5bf712846139f$export$a7b636559b01a55f)['Is Equal To'],
                                children: "Is Equal To"
                            }, "Is Equal To")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $whS22.default), {
                size: "small",
                variant: "outlined",
                className: (0, $j6s32.default)(classes.inputs, classes.filterOperatorSelect),
                required: true,
                disabled: filterSelectDisabled,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYT2J.default), {
                    required: true,
                    size: "small",
                    variant: "outlined",
                    label: "Value",
                    value: groupByPredicate.value,
                    className: classes.valueInput,
                    onChange: (e)=>updatePredicateValue({
                            ...groupByPredicate,
                            value: e.target.value
                        }),
                    disabled: filterSelectDisabled,
                    inputProps: {
                        type: 'number'
                    }
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                onClick: ()=>handleDeleteGroupByValueRow(predicateIndex),
                className: classes.delete,
                disabled: predicateIndex === 0 && !groupByPredicate?.valueFilterId,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $70ccc3891d50e85f$export$2e2bcd8739ae039), {
                    htmlColor: (0, $69ed148db7543104$export$2aa0182783e7e9de)[600]
                })
            })
        ]
    });
};
var $e92b4c687e06a774$export$2e2bcd8739ae039 = $e92b4c687e06a774$var$AttributeGroupBy;


const $5d5cc9f35839daa0$var$breakpoints = {
    xs: 640,
    sm: 1020,
    md: 1200
};
const $5d5cc9f35839daa0$var$useStyles = (0, $e1ONw.default)((theme)=>({
        dialog: {
            [theme.breakpoints.up('md')]: {
                '& .MuiDialog-paperWidthSm': {
                    width: '83rem',
                    minWidth: '83rem'
                }
            }
        },
        dialogTitle: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        dialogActions: {
            justifyContent: 'space-between',
            height: 57,
            padding: '0 24px'
        },
        inputs: {
            margin: '4px 12px',
            '& .MuiInputLabel-asterisk': {
                color: (0, $69ed148db7543104$export$8f45430ccf837300).rustRed
            }
        },
        attributeSelect: {
            [theme.breakpoints.down($5d5cc9f35839daa0$var$breakpoints.sm)]: {
                flex: 1
            },
            [theme.breakpoints.up($5d5cc9f35839daa0$var$breakpoints.sm)]: {
                flex: '0 0 200px'
            },
            [theme.breakpoints.up($5d5cc9f35839daa0$var$breakpoints.md)]: {
                flex: '0 0 300px'
            }
        },
        filterOperatorSelect: {
            flex: '0 0 200px',
            [theme.breakpoints.up($5d5cc9f35839daa0$var$breakpoints.xs)]: {
                flex: '0 0 225px'
            }
        },
        filterMenu: {
            flex: '1 0 480px',
            '& .MuiSelect-root': {
                paddingTop: 6,
                paddingBottom: 6,
                minHeight: 28
            }
        },
        delete: {
            flex: '0 0 48px',
            marginRight: 12,
            zIndex: 1,
            '&.Mui-disabled': {
                opacity: 0.5
            }
        },
        addControls: {
            display: 'flex',
            'align-items': 'center',
            'justify-content': 'flex-end'
        },
        attributePadding: {
            paddingTop: 10,
            paddingBottom: 10
        },
        filterPadding: {
            paddingRight: 10
        },
        groupByContainter: {
            display: 'flex',
            flexWrap: 'wrap'
        },
        operatorText: {
            fontWeight: 600,
            textTransform: 'uppercase'
        }
    }));
const $5d5cc9f35839daa0$var$emptyFilter = {
    filterId: undefined,
    columnName: undefined,
    name: undefined,
    filterOperator: (0, $a9d5bf712846139f$export$165a359d8710f906).Is,
    filterType: undefined,
    transactionalFilterOptions: undefined
};
var $5d5cc9f35839daa0$var$GroupByAggregateFunction = /*#__PURE__*/ function(GroupByAggregateFunction) {
    GroupByAggregateFunction[GroupByAggregateFunction["Sum of"] = 0] = "Sum of";
    GroupByAggregateFunction[GroupByAggregateFunction["Average"] = 1] = "Average";
    GroupByAggregateFunction[GroupByAggregateFunction["Count of"] = 2] = "Count of";
    GroupByAggregateFunction[GroupByAggregateFunction["Distinct count of"] = 3] = "Distinct count of";
    GroupByAggregateFunction[GroupByAggregateFunction["Minimum"] = 4] = "Minimum";
    GroupByAggregateFunction[GroupByAggregateFunction["Maximum"] = 5] = "Maximum";
    return GroupByAggregateFunction;
}($5d5cc9f35839daa0$var$GroupByAggregateFunction || {});
var $5d5cc9f35839daa0$var$GroupByOperatorChipLabel = /*#__PURE__*/ function(GroupByOperatorChipLabel) {
    GroupByOperatorChipLabel[GroupByOperatorChipLabel[">"] = 0] = ">";
    GroupByOperatorChipLabel[GroupByOperatorChipLabel["<"] = 1] = "<";
    GroupByOperatorChipLabel[GroupByOperatorChipLabel["="] = 2] = "=";
    return GroupByOperatorChipLabel;
}($5d5cc9f35839daa0$var$GroupByOperatorChipLabel || {});
/**
 * Select menu and accompanying modal dialog for filtering a single attribute of filterType: transactional when building a segment
 */ const $5d5cc9f35839daa0$var$AttributeFilterTransactional = ({ attribute: attribute, selectedAttribute: selectedAttribute, position: position, exclude: exclude, attributeIndex: attributeIndex })=>{
    const overrides = $5d5cc9f35839daa0$var$useStyles();
    const { dispatch: dispatch } = (0, $79aece72917dec2b$export$7cea9ed133024a2d)(exclude);
    const [dialogOpen, setDialogOpen] = $ieT14.useState(false);
    /** Currently checked filters in the filter dialog, not yet applied to select menu */ const originalSelectedAttribute = $ieT14.useRef(selectedAttribute);
    const [selectedFilters, setSelectedFilters] = $ieT14.useState([]);
    const [transactionalFilterOperator, setTransactionalFilterOperator] = $ieT14.useState(selectedAttribute.transactionalFilters?.operator ?? (0, $a9d5bf712846139f$export$905dbc95765b1ada).And);
    const [groupBy, setGroupBy] = $ieT14.useState(selectedAttribute.groupBy ? selectedAttribute.groupBy : null);
    const [disableApply, setDisableApply] = $ieT14.useState(false);
    $ieT14.useEffect(()=>{
        setDisableApply(groupBy?.groupByFilterId && !!groupBy.groupByValues.groupByPredicates.find((predicate)=>!predicate.valueFilterId || !predicate.value));
    }, [
        groupBy
    ]);
    $ieT14.useEffect(()=>{
        if (selectedAttribute.transactionalFilters) buildOutFilters();
    }, []);
    $ieT14.useEffect(()=>{
        originalSelectedAttribute.current = selectedAttribute;
    }, [
        selectedAttribute
    ]);
    const buildOutFilters = ()=>{
        const createdFilters = [];
        originalSelectedAttribute.current.transactionalFilters.predicates.forEach((filter)=>{
            const newTransactionalFilter = createBaseTransactionalFilter(filter.filterId);
            const baseFilter = {
                filterId: filter.filterId,
                columnName: filter.columnName,
                name: filter.name,
                filterOperator: filter.filterOperator,
                filterType: filter.filterType,
                transactionalFilterOptions: newTransactionalFilter
            };
            switch(baseFilter.transactionalFilterOptions?.filterType.toLowerCase()){
                case 'datetime':
                    if ('dateRange' in filter) createdFilters.push({
                        ...baseFilter,
                        dateRange: {
                            rangeType: 'custom',
                            min: filter.dateRange.min ? (0, (/*@__PURE__*/$parcel$interopDefault($3umuy)))(filter.dateRange.min) : null,
                            max: filter.dateRange.max ? (0, (/*@__PURE__*/$parcel$interopDefault($3umuy)))(filter.dateRange.max) : null
                        }
                    });
                    if ('numberOfDays' in filter) createdFilters.push({
                        ...baseFilter,
                        dateRange: {
                            rangeType: 'n-days',
                            numberOfDays: filter.numberOfDays
                        }
                    });
                    break;
                case 'range':
                    createdFilters.push({
                        ...baseFilter,
                        range: filter.range
                    });
                    break;
                case 'options':
                    if ('searchText' in filter) createdFilters.push({
                        ...baseFilter,
                        filterType: 'options',
                        searchText: filter.searchText
                    });
                    else createdFilters.push({
                        ...baseFilter,
                        options: filter.options
                    });
                    break;
                default:
                    createdFilters.push({
                        ...baseFilter
                    });
            }
        });
        setSelectedFilters(createdFilters);
    };
    const handleApplyFilterOptions = (filter, index = 0)=>{
        const clonedFilter = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).cloneDeep(selectedFilters);
        clonedFilter[index] = {
            ...filter
        };
        setSelectedFilters(clonedFilter);
    };
    $ieT14.useEffect(()=>{
        if (!!dialogOpen && selectedFilters.length < 1) setSelectedFilters([
            $5d5cc9f35839daa0$var$emptyFilter
        ]);
    }, [
        dialogOpen
    ]);
    const handleFilterOperator = (newSelectedOperator, index = 0)=>{
        const clonedFilter = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).cloneDeep(selectedFilters);
        clonedFilter[index].filterOperator = newSelectedOperator;
        // Check if switching between search text and options
        if ('options' in clonedFilter[index] && newSelectedOperator !== (0, $a9d5bf712846139f$export$165a359d8710f906).Is && newSelectedOperator !== (0, $a9d5bf712846139f$export$165a359d8710f906)['Is Not']) {
            clonedFilter[index] = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).omit(clonedFilter[index], [
                'options'
            ]);
            clonedFilter[index].searchText = '';
        }
        if ('searchText' in clonedFilter[index] && (newSelectedOperator === (0, $a9d5bf712846139f$export$165a359d8710f906).Is || newSelectedOperator === (0, $a9d5bf712846139f$export$165a359d8710f906)['Is Not'])) {
            clonedFilter[index] = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).omit(clonedFilter[index], [
                'searchText'
            ]);
            clonedFilter[index].options = [];
        }
        setSelectedFilters([
            ...clonedFilter
        ]);
    };
    const changedTransactionalFilter = (baseTransactional, index = 0)=>{
        if (selectedFilters.length === 0) setSelectedFilters([
            {
                ...baseTransactional
            }
        ]);
        else {
            const clonedFilter = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).cloneDeep(selectedFilters);
            clonedFilter[index] = {
                ...baseTransactional
            };
            setSelectedFilters(clonedFilter);
        }
    };
    const createBaseTransactionalFilter = (selectedId)=>{
        //@ts-ignore
        const newTransactionalFilter = Object.assign({}, attribute.transactionalFilters.find((f)=>f.filterId === selectedId));
        if (!newTransactionalFilter) return undefined;
        if (typeof newTransactionalFilter.filters === 'string') newTransactionalFilter.filters = newTransactionalFilter.filters ? JSON.parse(newTransactionalFilter.filters) : [];
        if (newTransactionalFilter?.filterType.toLowerCase() === 'datetime') newTransactionalFilter.filters = {
            ...newTransactionalFilter.filters,
            min: (0, (/*@__PURE__*/$parcel$interopDefault($3umuy)))(newTransactionalFilter.filters.min),
            max: (0, (/*@__PURE__*/$parcel$interopDefault($3umuy)))(newTransactionalFilter.filters.max)
        };
        return newTransactionalFilter;
    };
    const handleChangeTransactionalFilter = (selectedId, filterIndex)=>{
        const newTransactionalFilter = createBaseTransactionalFilter(selectedId);
        const baseFilter = {
            filterId: newTransactionalFilter.filterId,
            columnName: newTransactionalFilter.columnName,
            name: newTransactionalFilter.name,
            filterOperator: (0, $a9d5bf712846139f$export$165a359d8710f906).Is,
            filterType: newTransactionalFilter.filterType,
            transactionalFilterOptions: newTransactionalFilter
        };
        if (baseFilter?.filterType.toLowerCase() === 'datetime') changedTransactionalFilter({
            ...baseFilter,
            dateRange: {
                min: null,
                max: null
            }
        }, filterIndex);
        if (baseFilter?.filterType.toLowerCase() === 'range') changedTransactionalFilter({
            ...baseFilter,
            range: {
                min: baseFilter.transactionalFilterOptions.filters.min,
                max: baseFilter.transactionalFilterOptions.filters.max
            }
        }, filterIndex);
        if (baseFilter.transactionalFilterOptions?.filterType.toLowerCase() === 'options') changedTransactionalFilter({
            ...baseFilter,
            options: []
        }, filterIndex);
    };
    /** Reset to previous filters on cancel */ const handleCancel = ()=>{
        if (originalSelectedAttribute.current.transactionalFilters) {
            buildOutFilters();
            setTransactionalFilterOperator(originalSelectedAttribute.current.transactionalFilters.operator);
        } else {
            setSelectedFilters([]);
            setTransactionalFilterOperator(0);
        }
        if (originalSelectedAttribute.current.groupBy) setGroupBy(originalSelectedAttribute.current.groupBy);
        else setGroupBy(null);
        setDialogOpen(false);
    };
    const handleApply = ()=>{
        const completedFilters = selectedFilters.filter((f)=>!!f.filterId);
        updateSelectedAttribute(completedFilters, groupBy);
        setDialogOpen(false);
    };
    const buildOptionChipLabel = (value)=>{
        if ('searchText' in value) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($ieT14.Fragment, {
            children: value.searchText
        });
        let optionsList = '';
        value.options.forEach((option, index)=>{
            if (index === value.options.length - 1) optionsList = optionsList.concat(`${option}`);
            else optionsList = optionsList.concat(`${option}, `);
        });
        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($ieT14.Fragment, {
            children: optionsList
        });
    };
    const buildRangeChipLabel = (value)=>{
        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                    className: overrides.filterPadding,
                    children: !!value.range.min && value.range.min !== value.transactionalFilterOptions.filters.min && `Min: ${value.range.min}`
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                    children: !!value.range.max && value.range.max !== value.transactionalFilterOptions.filters.max && `Max: ${value.range.max}`
                })
            ]
        });
    };
    const buildDateTimeChipLabel = (value)=>{
        if (value.dateRange.rangeType === 'n-days') return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
            children: [
                "Last ",
                value.dateRange.numberOfDays,
                " days"
            ]
        });
        else return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                    className: overrides.filterPadding,
                    children: value.dateRange.min && `Start: ${value.dateRange.min.format('MM/DD/YYYY')}`
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                    children: value.dateRange.max && `End: ${value.dateRange.max.format('MM/DD/YYYY')}`
                })
            ]
        });
    };
    const buildGroupByLabel = (selectedGroupByFilter)=>{
        const selectedOperator = selectedGroupByFilter.groupByValues.groupByOperator;
        const selectedGroupByValues = /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($ieT14.Fragment, {
            children: selectedGroupByFilter.groupByValues.groupByPredicates.map((predicate, index)=>{
                return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    children: [
                        index > 0 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                            className: overrides.operatorText,
                            children: $5d5cc9f35839daa0$var$GroupByAggregateFunction[predicate.aggregateFunction]
                        }),
                        ' ',
                        predicate.valueFilterName,
                        ' ',
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                            className: overrides.operatorText,
                            children: $5d5cc9f35839daa0$var$GroupByOperatorChipLabel[predicate.aggregateOperator]
                        }),
                        ' ',
                        predicate.value,
                        index + 1 < selectedGroupByFilter.groupByValues.groupByPredicates.length ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                            className: overrides.operatorText,
                            children: [
                                " ",
                                (0, $a9d5bf712846139f$export$905dbc95765b1ada)[selectedOperator]
                            ]
                        }) : ''
                    ]
                }, `${predicate.valueFilterId} - ${index}`);
            })
        });
        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
            className: overrides.groupByContainter,
            children: [
                "Group By: ",
                selectedGroupByFilter.groupByFilterName,
                ' (',
                selectedGroupByValues,
                ')'
            ]
        });
    };
    const handleChipDelete = (filterId)=>{
        const filterIndex = selectedFilters.findIndex((f)=>f.filterId === filterId);
        const clonedFilters = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).cloneDeep(selectedFilters);
        clonedFilters.splice(filterIndex, 1);
        updateSelectedAttribute(clonedFilters, groupBy);
    };
    const updateSelectedAttribute = (currentFilters, currentGroupBy)=>{
        const updatedGroupBy = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).cloneDeep(currentGroupBy);
        let filterArray = currentFilters.map((filter)=>{
            if (filter.filterType === 'datetime') {
                if (filter.dateRange?.rangeType === 'n-days') {
                    const clonedFilter = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).omit(filter, [
                        'dateRange'
                    ]);
                    return {
                        ...clonedFilter,
                        numberOfDays: Number(filter.dateRange.numberOfDays)
                    };
                }
                return {
                    ...filter,
                    dateRange: {
                        max: filter.dateRange?.max?.toISOString() ?? null,
                        min: filter.dateRange?.min?.toISOString() ?? null
                    }
                };
            }
            if ('searchText' in filter) return (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).omit(filter, [
                'filterType'
            ]);
            return {
                ...filter
            };
        });
        if (filterArray.length > 0) dispatch({
            type: 'updateTransactionalFilter',
            attribute: {
                ...selectedAttribute,
                transactionalFilters: {
                    operator: transactionalFilterOperator,
                    predicates: filterArray
                },
                groupBy: updatedGroupBy
            },
            position: position,
            attributeIndex: attributeIndex
        });
        else {
            const { transactionalFilters: _, ...rest } = selectedAttribute;
            dispatch({
                type: 'updateTransactionalFilter',
                attribute: {
                    ...rest,
                    groupBy: updatedGroupBy
                },
                position: position,
                attributeIndex: attributeIndex
            });
        }
        setSelectedFilters(currentFilters);
        setGroupBy(updatedGroupBy);
    };
    const handleAddAnotherAttribute = ()=>{
        const clonedFilters = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).cloneDeep(selectedFilters);
        clonedFilters.push($5d5cc9f35839daa0$var$emptyFilter);
        setSelectedFilters(clonedFilters);
    };
    const handleDeleteFilterRow = (filterIndex)=>{
        const clonedFilters = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).cloneDeep(selectedFilters);
        clonedFilters.splice(filterIndex, 1);
        if (clonedFilters.length === 0) clonedFilters.push($5d5cc9f35839daa0$var$emptyFilter);
        setSelectedFilters(clonedFilters);
    };
    /** Function passed to filter select `renderValue` prop: conditionally render the custom content of the filter multi-select menu */ const renderFilterValues = (selectedTransactionalFilters)=>{
        if (dialogOpen) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {});
        if (!attribute.transactionalFilters || attribute.transactionalFilters.length < 1) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
            className: $d3a6c5cfb2396086$export$dac863774b2ab841,
            children: "There are no filters to apply"
        });
        if (selectedTransactionalFilters.filter((f)=>!!f.filterId).length === 0) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
            className: $d3a6c5cfb2396086$export$119f7e232b163996,
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                    className: $d3a6c5cfb2396086$export$dac863774b2ab841,
                    children: "All - click for additional filtering"
                }),
                !!groupBy?.groupByFilterId && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1fc2eb6485c96dfd$export$522e6e3e785eb2cd), {
                    className: $d3a6c5cfb2396086$export$c15719ce02e29531,
                    label: buildGroupByLabel(groupBy),
                    size: "small",
                    deleteIcon: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4leCF.default), {
                        onMouseDown: (event)=>event.stopPropagation(),
                        "aria-label": "delete filter"
                    }),
                    onDelete: ()=>{
                        const clonedFilters = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).cloneDeep(selectedFilters);
                        updateSelectedAttribute(clonedFilters, null);
                    }
                })
            ]
        });
        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
            className: $d3a6c5cfb2396086$export$ced7484dd0a65e67,
            children: selectedTransactionalFilters.map((value, index)=>{
                const lastChip = index === selectedTransactionalFilters.length - 1;
                const filterName = value.name.trim() === '' ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                    className: $d3a6c5cfb2396086$export$908a233be4ecde8e,
                    children: "blank"
                }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                    className: $d3a6c5cfb2396086$export$b0dc76ccb49f2cec,
                    children: value.name
                });
                let chipLabel;
                switch(value.filterType.toLowerCase()){
                    case 'options':
                        chipLabel = /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
                            children: [
                                filterName,
                                ": ",
                                buildOptionChipLabel(value)
                            ]
                        });
                        break;
                    case 'range':
                        chipLabel = /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
                            children: [
                                filterName,
                                ": ",
                                buildRangeChipLabel(value)
                            ]
                        });
                        break;
                    case 'datetime':
                        chipLabel = /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
                            children: [
                                filterName,
                                ": ",
                                buildDateTimeChipLabel(value)
                            ]
                        });
                        break;
                    default:
                        chipLabel = /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($ieT14.Fragment, {
                            children: filterName
                        });
                }
                return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    className: $d3a6c5cfb2396086$export$119f7e232b163996,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1fc2eb6485c96dfd$export$522e6e3e785eb2cd), {
                            className: $d3a6c5cfb2396086$export$a2aa70cfed4a3fa5,
                            label: chipLabel,
                            size: "small",
                            deleteIcon: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4leCF.default), {
                                onMouseDown: (event)=>event.stopPropagation(),
                                "aria-label": "delete filter"
                            }),
                            onDelete: ()=>handleChipDelete(value.filterId)
                        }),
                        !lastChip && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                            className: $d3a6c5cfb2396086$export$c5b104fde295bf8f,
                            children: (0, $a9d5bf712846139f$export$905dbc95765b1ada)[transactionalFilterOperator]
                        }),
                        !!groupBy?.groupByFilterId && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1fc2eb6485c96dfd$export$522e6e3e785eb2cd), {
                            className: $d3a6c5cfb2396086$export$c15719ce02e29531,
                            label: buildGroupByLabel(groupBy),
                            size: "small",
                            deleteIcon: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4leCF.default), {
                                onMouseDown: (event)=>event.stopPropagation(),
                                "aria-label": "delete filter"
                            }),
                            onDelete: ()=>{
                                const clonedFilters = (0, (/*@__PURE__*/$parcel$interopDefault($fRnKy))).cloneDeep(selectedFilters);
                                updateSelectedAttribute(clonedFilters, null);
                            }
                        })
                    ]
                }, `Multi-Chip-${value.filterId}-${index}`);
            })
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $aanJt.default), {
                id: `filter-attribute-${attribute.id}`,
                multiple: true,
                disabled: !attribute.transactionalFilters || attribute.transactionalFilters.length < 1,
                value: selectedFilters,
                open: false,
                onOpen: ()=>{
                    setDialogOpen(true);
                },
                renderValue: renderFilterValues,
                displayEmpty: true
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $1c689a1559dbf5e9$export$2e2bcd8739ae039), {
                open: dialogOpen,
                scroll: "paper",
                className: overrides.dialog,
                "aria-labelledby": "select-attribute-dialog-title",
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6830d3674ad61fd5$export$2e2bcd8739ae039), {
                        className: overrides.dialogTitle,
                        id: "select-attribute-dialog-title",
                        disableTypography: true,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h3", {
                            className: $d3a6c5cfb2396086$export$b8772d08938399e8,
                            children: "Select Filters"
                        })
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $881610d42277b808$export$2e2bcd8739ae039), {
                        dividers: true,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                className: $d3a6c5cfb2396086$export$149f03f7aebc2e19,
                                children: selectedFilters.map((parameterSet, index)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                        className: (0, $j6s32.default)($4830ac0c4a56bbcf$export$af4b9a83f4b00434, overrides.attributePadding),
                                        children: [
                                            index === 0 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                                className: $4830ac0c4a56bbcf$export$6b8b92a9240a8a67
                                            }),
                                            index === 1 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $0e860a8a329fdc63$export$2e2bcd8739ae039), {
                                                operator: transactionalFilterOperator,
                                                handleChange: (operator)=>setTransactionalFilterOperator(operator)
                                            }),
                                            index > 1 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                                className: $4830ac0c4a56bbcf$export$6b8b92a9240a8a67,
                                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("p", {
                                                    className: $4830ac0c4a56bbcf$export$f98f2d26ae95425a,
                                                    children: (0, $a9d5bf712846139f$export$905dbc95765b1ada)[transactionalFilterOperator]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($5d5cc9f35839daa0$var$FilterOptions, {
                                                transactionalAttribute: attribute,
                                                handleChangeTransactionalFilter: handleChangeTransactionalFilter,
                                                selectedAttribute: selectedAttribute,
                                                selectedFilter: parameterSet,
                                                handleApplyFilterOptions: handleApplyFilterOptions,
                                                filterIndex: index,
                                                handleFilterOperator: handleFilterOperator,
                                                handleDeleteFilterRow: handleDeleteFilterRow
                                            })
                                        ]
                                    }, `Selected-Filter-${parameterSet.filterId}-${index}`))
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                className: overrides.addControls,
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $b1c3fceec5a3a004$export$2e2bcd8739ae039), {
                                    label: "Add another Filter",
                                    handleClick: handleAddAnotherAttribute
                                })
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $e92b4c687e06a774$export$2e2bcd8739ae039), {
                                transactionalFilterOptions: attribute.transactionalFilters,
                                selectedGroupBy: groupBy,
                                updateGroupBy: (newGroupBy)=>{
                                    setGroupBy(newGroupBy);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $d176cc26269b23c2$export$2e2bcd8739ae039), {
                        className: overrides.dialogActions,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.TertiaryButton), {
                                text: "Cancel",
                                title: "Cancel",
                                component: "button",
                                handleClick: handleCancel
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryButton), {
                                text: "Apply",
                                title: "Apply",
                                handleClick: handleApply,
                                deactive: disableApply
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
function $5d5cc9f35839daa0$var$buildDate(dateFilter) {
    if (dateFilter.rangeType === 'n-days') return {
        numberOfDays: dateFilter.numberOfDays
    };
    else return {
        dateRange: {
            min: dateFilter.min ? (0, (/*@__PURE__*/$parcel$interopDefault($3umuy)))(dateFilter.min) : null,
            max: dateFilter.max ? (0, (/*@__PURE__*/$parcel$interopDefault($3umuy)))(dateFilter.max) : null
        }
    };
}
const $5d5cc9f35839daa0$var$FilterOptions = ({ transactionalAttribute: transactionalAttribute, handleChangeTransactionalFilter: handleChangeTransactionalFilter, selectedAttribute: selectedAttribute, selectedFilter: selectedFilter, handleApplyFilterOptions: handleApplyFilterOptions, filterIndex: filterIndex, handleFilterOperator: handleFilterOperator, handleDeleteFilterRow: handleDeleteFilterRow })=>{
    const overrides = $5d5cc9f35839daa0$var$useStyles();
    const [filterOptions, setFilterOptions] = $ieT14.useState(selectedFilter.options ? selectedFilter.options : []);
    const [filterText, setFilterText] = $ieT14.useState(selectedFilter.searchText ? selectedFilter.searchText : '');
    const [dateRangeFilters, setDateRangeFilters] = $ieT14.useState(selectedFilter.dateRange ? $5d5cc9f35839daa0$var$buildDate(selectedFilter.dateRange) : null);
    const [rangeFilters, setRangeFilters] = $ieT14.useState({
        min: selectedFilter.range?.min ?? null,
        max: selectedFilter.range?.max ?? null
    });
    $ieT14.useEffect(()=>{
        if (selectedFilter?.filterId && selectedFilter?.filterType) switch(selectedFilter.filterType){
            case 'options':
                setFilterText(selectedFilter.searchText);
                setFilterOptions(selectedFilter.options);
                break;
            case 'datetime':
                if (selectedFilter.dateRange && selectedFilter.dateRange.rangeType === 'n-days') setDateRangeFilters({
                    numberOfDays: selectedFilter.dateRange.numberOfDays
                });
                else setDateRangeFilters({
                    dateRange: {
                        min: selectedFilter.dateRange?.min ? (0, (/*@__PURE__*/$parcel$interopDefault($3umuy)))(selectedFilter.dateRange?.min) : null,
                        max: selectedFilter.dateRange?.max ? (0, (/*@__PURE__*/$parcel$interopDefault($3umuy)))(selectedFilter.dateRange?.max) : null
                    }
                });
                break;
            case 'range':
                setRangeFilters({
                    min: selectedFilter.range?.min ?? null,
                    max: selectedFilter.range?.max ?? null
                });
                break;
        }
    }, [
        selectedFilter
    ]);
    const updateSelectedOptions = (options)=>{
        if (selectedFilter) {
            const updatedFilter = {
                ...selectedFilter,
                options: options
            };
            handleApplyFilterOptions(updatedFilter, filterIndex);
            setFilterOptions(options);
        }
    };
    const updateSelectedSearchText = (searchString)=>{
        if (searchString) {
            const updatedFilter = {
                ...selectedFilter,
                searchText: searchString
            };
            handleApplyFilterOptions(updatedFilter, filterIndex);
            setFilterText(searchString);
        }
    };
    const updateSelectedDateRange = (options)=>{
        if (selectedFilter) {
            const updatedFilter = {
                ...selectedFilter,
                dateRange: options
            };
            handleApplyFilterOptions(updatedFilter, filterIndex);
            if (options.rangeType === 'n-days') setDateRangeFilters({
                numberOfDays: Number(options.nDaysValue)
            });
            else setDateRangeFilters({
                dateRange: {
                    min: options.min ?? null,
                    max: options.max ?? null
                }
            });
        }
    };
    const updateSelectedRange = (options)=>{
        if (selectedFilter) {
            const updatedFilter = {
                ...selectedFilter,
                range: options
            };
            handleApplyFilterOptions(updatedFilter, filterIndex);
            setRangeFilters(options);
        }
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
            className: $4830ac0c4a56bbcf$export$cc1adf6fb659c762,
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $4830ac0c4a56bbcf$export$995e14ef61d916e6,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
                        size: "small",
                        variant: "outlined",
                        className: (0, $j6s32.default)(overrides.inputs, overrides.attributeSelect),
                        required: true,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $Uxz4Y.default), {
                                id: "transactional-filter-selection",
                                children: "Transactional Filters"
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $aanJt.default), {
                                labelId: "transactional-filter-selection",
                                value: selectedFilter?.filterId ?? '',
                                onChange: (event)=>handleChangeTransactionalFilter(Number(event.target.value), filterIndex),
                                children: transactionalAttribute.transactionalFilters?.map((filter)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                        value: filter.filterId,
                                        children: filter.name
                                    }, `Filter-Option-${filter.filterId}`))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
                        size: "small",
                        variant: "outlined",
                        className: (0, $j6s32.default)(overrides.inputs, overrides.filterOperatorSelect),
                        required: true,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $Uxz4Y.default), {
                                id: "filter-logic",
                                children: "Filter Logic"
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $aanJt.default), {
                                labelId: "transactional-filter-selection",
                                value: selectedFilter?.filterOperator ?? (0, $a9d5bf712846139f$export$165a359d8710f906).Is,
                                disabled: !selectedFilter.transactionalFilterOptions,
                                onChange: (event)=>{
                                    handleFilterOperator(event.target.value, filterIndex);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                        value: (0, $a9d5bf712846139f$export$165a359d8710f906).Is,
                                        children: "Is"
                                    }, "Is"),
                                    ",",
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                        value: (0, $a9d5bf712846139f$export$165a359d8710f906)['Is Not'],
                                        children: "Is Not"
                                    }, "Is Not"),
                                    selectedFilter && !('range' in selectedFilter || 'dateRange' in selectedFilter || 'numberOfDays' in selectedFilter || 'where' in selectedFilter) && [
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                            value: (0, $a9d5bf712846139f$export$165a359d8710f906)['Begins With'],
                                            children: "Begins With"
                                        }, "Begins With"),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                            value: (0, $a9d5bf712846139f$export$165a359d8710f906)['Does Not Begin With'],
                                            children: "Does Not Begin With"
                                        }, "Does Not Begin With"),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                            value: (0, $a9d5bf712846139f$export$165a359d8710f906)['Ends With'],
                                            children: "Ends With"
                                        }, "Ends With"),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                            value: (0, $a9d5bf712846139f$export$165a359d8710f906)['Does Not End With'],
                                            children: "Does Not End With"
                                        }, "Does Not End With"),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                            value: (0, $a9d5bf712846139f$export$165a359d8710f906)['Contains'],
                                            children: "Contains"
                                        }, "Contains"),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                            value: (0, $a9d5bf712846139f$export$165a359d8710f906)['Does Not Contain'],
                                            children: "Does Not Contain"
                                        }, "Does Not Contain")
                                    ]
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
                        size: "small",
                        variant: "outlined",
                        className: (0, $j6s32.default)(overrides.inputs, overrides.filterMenu),
                        children: [
                            !selectedFilter.filterId && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $8991ead30e777b29$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $Uxz4Y.default), {
                                        htmlFor: `filter-attribute-0`,
                                        children: "Filter the Attribute"
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $aanJt.default), {
                                        id: "filter-attribute-0",
                                        value: "",
                                        disabled: true
                                    })
                                ]
                            }),
                            !(0, $6a74c864676f2556$export$18b16d7af99ad313)(selectedFilter, selectedFilter) && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $Uxz4Y.default), {
                                htmlFor: `filter-attribute-${selectedFilter.filterId}`,
                                shrink: true,
                                children: "Select a Filter"
                            }),
                            (0, $6a74c864676f2556$export$18b16d7af99ad313)(selectedFilter, selectedFilter) === (0, $a9d5bf712846139f$export$13d7493ba19b9f11).Input && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fa6006f241582940$export$2e2bcd8739ae039), {
                                attribute: selectedFilter.transactionalFilterOptions,
                                selectedAttribute: {
                                    ...selectedFilter,
                                    searchText: filterText
                                },
                                position: [],
                                applyTransactional: (searchString)=>{
                                    updateSelectedSearchText(searchString);
                                }
                            }),
                            (0, $6a74c864676f2556$export$18b16d7af99ad313)(selectedFilter, selectedFilter) === (0, $a9d5bf712846139f$export$13d7493ba19b9f11).Options && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $e906967d5eb28744$export$2e2bcd8739ae039), {
                                attribute: selectedFilter.transactionalFilterOptions,
                                selectedAttribute: {
                                    ...selectedAttribute,
                                    options: filterOptions ?? []
                                },
                                position: [],
                                applyTransactional: (options)=>{
                                    updateSelectedOptions(options);
                                },
                                deleteTransactionalChip: (option)=>{
                                    const updatedOptions = filterOptions.filter((op)=>op !== option);
                                    updateSelectedOptions(updatedOptions);
                                }
                            }),
                            (0, $6a74c864676f2556$export$18b16d7af99ad313)(selectedFilter, selectedFilter) === (0, $a9d5bf712846139f$export$13d7493ba19b9f11).Datetime && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $dbae8c3125deffbd$export$2e2bcd8739ae039), {
                                //@ts-ignore
                                attribute: selectedFilter.transactionalFilterOptions,
                                selectedAttribute: {
                                    ...selectedAttribute,
                                    ...dateRangeFilters
                                },
                                applyTransactional: (options)=>{
                                    updateSelectedDateRange(options);
                                },
                                position: []
                            }),
                            (0, $6a74c864676f2556$export$18b16d7af99ad313)(selectedFilter, selectedFilter) === (0, $a9d5bf712846139f$export$13d7493ba19b9f11).Range && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $cb9afff3bff80545$export$2e2bcd8739ae039), {
                                //@ts-ignore
                                attribute: selectedFilter.transactionalFilterOptions,
                                selectedAttribute: {
                                    ...selectedAttribute,
                                    range: {
                                        ...rangeFilters
                                    }
                                },
                                applyTransactional: (options)=>{
                                    updateSelectedRange(options);
                                },
                                position: []
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                        onClick: ()=>handleDeleteFilterRow(filterIndex),
                        className: overrides.delete,
                        disabled: filterIndex === 0 && !selectedFilter.filterId,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $70ccc3891d50e85f$export$2e2bcd8739ae039), {
                            htmlColor: (0, $69ed148db7543104$export$2aa0182783e7e9de)[600]
                        })
                    })
                ]
            })
        })
    });
};
var $5d5cc9f35839daa0$export$2e2bcd8739ae039 = $5d5cc9f35839daa0$var$AttributeFilterTransactional;


/**
 * Attribute Filter - based on the type of the selected attribute's value, render the filter select menu
 */ const $7ee69279e31a81d5$var$AttributeFilter = ({ selectedAttribute: selectedAttribute, position: position, exclude: exclude, attributeIndex: attributeIndex })=>{
    let attributeDetailsQuery = (0, $49f64957c05f123f$export$275540052f30cbba)(selectedAttribute?.attributeId, selectedAttribute != undefined, selectedAttribute?.isTransactional);
    const renderEmpty = ()=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $aanJt.default), {
            id: "filter-attribute-0",
            value: "",
            disabled: true
        });
    const renderLoading = ()=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $aanJt.default), {
            id: `filter-attribute-${selectedAttribute.attributeId}`,
            value: "loading",
            disabled: true,
            renderValue: ()=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: $d3a6c5cfb2396086$export$9771f61076faa58d,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {
                        size: "22px"
                    })
                }),
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                value: "loading",
                children: "Loading"
            })
        });
    const renderError = ()=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $aanJt.default), {
            id: `filter-attribute-${selectedAttribute.attributeId}`,
            className: $d3a6c5cfb2396086$export$e49b12bf00f5c746,
            value: "error",
            disabled: true,
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $3mOXj.default), {
                value: "error",
                children: [
                    "Error: ",
                    attributeDetailsQuery.error.message
                ]
            })
        });
    const renderRange = (attributeRange, sa)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $cb9afff3bff80545$export$2e2bcd8739ae039), {
            attribute: attributeRange,
            selectedAttribute: sa,
            position: position,
            exclude: exclude,
            attributeIndex: attributeIndex
        });
    const renderDatetime = (attributeDatetime, sa)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $dbae8c3125deffbd$export$2e2bcd8739ae039), {
            attribute: attributeDatetime,
            selectedAttribute: sa,
            position: position,
            exclude: exclude,
            attributeIndex: attributeIndex
        });
    const renderInput = (attributeOptions, sa)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fa6006f241582940$export$2e2bcd8739ae039), {
            attribute: attributeOptions,
            selectedAttribute: sa,
            position: position,
            exclude: exclude,
            attributeIndex: attributeIndex
        });
    const renderTransactional = (attributeTransactional, sa)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $5d5cc9f35839daa0$export$2e2bcd8739ae039), {
            attribute: attributeTransactional,
            selectedAttribute: sa,
            position: position,
            exclude: exclude,
            attributeIndex: attributeIndex
        });
    const renderOptions = (attributeOptions, sa)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $e906967d5eb28744$export$2e2bcd8739ae039), {
            attribute: attributeOptions,
            selectedAttribute: sa,
            position: position,
            exclude: exclude,
            attributeIndex: attributeIndex
        });
    const renderAttribute = ()=>{
        const attributeRangeFilter = (0, $6a74c864676f2556$export$18b16d7af99ad313)(attributeDetailsQuery.data, selectedAttribute);
        switch(attributeRangeFilter){
            case (0, $a9d5bf712846139f$export$13d7493ba19b9f11).Input:
                return renderInput(attributeDetailsQuery.data, selectedAttribute);
            case (0, $a9d5bf712846139f$export$13d7493ba19b9f11).Options:
                return renderOptions(attributeDetailsQuery.data, selectedAttribute);
            case (0, $a9d5bf712846139f$export$13d7493ba19b9f11).Range:
                return renderRange(attributeDetailsQuery.data, selectedAttribute);
            case (0, $a9d5bf712846139f$export$13d7493ba19b9f11).Datetime:
                return renderDatetime(attributeDetailsQuery.data, selectedAttribute);
            case (0, $a9d5bf712846139f$export$13d7493ba19b9f11).Transactional:
                return renderTransactional(attributeDetailsQuery.data, selectedAttribute);
            default:
                return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8991ead30e777b29$exports.Fragment), {});
        }
    };
    /** New segment with no attribute selected */ if (!selectedAttribute) return renderEmpty();
    /** Attribute selected and available filters loading */ if (attributeDetailsQuery.isLoading) return renderLoading();
    /** Attribute filters fail to load */ if (attributeDetailsQuery.isError) return renderError();
    return renderAttribute();
};
var $7ee69279e31a81d5$export$2e2bcd8739ae039 = $7ee69279e31a81d5$var$AttributeFilter;




var $ieT14 = parcelRequire("ieT14");




/**
 * Hook to retrieve and cache client-specific segment attribute metadata via React Query
 */ const $0ac9b016f561a44f$var$useSegmentAttributes = ()=>{
    const appState = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    return (0, $137a3b252d598119$export$dd0a697e1782aedd)([
        'segment-attributes',
        appState.state.clientId
    ], ()=>{
        return fetchWrapper(`api/${appState.state.clientId}/attributes`);
    }, {
        staleTime: Infinity,
        select: (data)=>{
            // map attributeId to id
            const mappedData = data.map((attributeCategory)=>{
                return {
                    category: attributeCategory.category,
                    attributes: (0, $6a74c864676f2556$export$616542113386b517)(attributeCategory.attributes)
                };
            });
            return {
                categories: mappedData,
                attributes: mappedData.reduce((prev, cur)=>[
                        ...prev,
                        ...cur.attributes
                    ], [])
            };
        }
    });
};
var $0ac9b016f561a44f$export$2e2bcd8739ae039 = $0ac9b016f561a44f$var$useSegmentAttributes;




var $ieT14 = parcelRequire("ieT14");

var $6432u = parcelRequire("6432u");
var $00ab641e898f8f9d$export$2e2bcd8739ae039 = (0, $6432u.default)(/*#__PURE__*/ $ieT14.createElement("path", {
    d: "M7 10l5 5 5-5H7z"
}), 'ArrowDropDownSharp');







var $ieT14 = parcelRequire("ieT14");

var $fpdl2 = parcelRequire("fpdl2");
var $e1ONw = parcelRequire("e1ONw");
var $hgPMF = parcelRequire("hgPMF");

var $fgoQ6 = parcelRequire("fgoQ6");



var $ieT14 = parcelRequire("ieT14");

var $whS22 = parcelRequire("whS22");
var $3WBJn = parcelRequire("3WBJn");
var $f3VQ2 = parcelRequire("f3VQ2");
var $1KcBP = parcelRequire("1KcBP");
var $e1ONw = parcelRequire("e1ONw");




var $j6s32 = parcelRequire("j6s32");

const $d894cdec60fc66eb$var$useStyles = (0, $e1ONw.default)({
    expand: {
        transform: 'rotate(0deg)',
        transition: 'transform 200ms'
    },
    expandOpen: {
        transform: 'rotate(180deg)'
    },
    expandableTitle: {
        display: 'flex',
        alignItems: 'center'
    },
    collapse: {
        paddingLeft: 30
    },
    fieldset: {
        padding: '16px 0',
        borderBottom: `1px solid ${(0, $69ed148db7543104$export$a4867fe9454f37a8)[300]}`,
        boxSizing: 'border-box',
        width: '100%',
        '&:first-of-type': {
            paddingTop: 0
        },
        '&:last-of-type': {
            border: 'none'
        },
        '&.collapsed': {
            border: `1px solid ${(0, $69ed148db7543104$export$a4867fe9454f37a8)[300]}`,
            padding: '2px 0',
            margin: '8px 0'
        }
    },
    formLabel: {
        color: (0, $69ed148db7543104$export$a4867fe9454f37a8)[600],
        fontFamily: (0, $a414f09d93b4ed4c$export$709a39c897136e8).heading,
        fontSize: 14,
        fontWeight: 500,
        textTransform: 'uppercase',
        float: 'left',
        display: 'flex'
    }
});
/**
 * Render a collapsible, titled group of attribute inputs in the segment attribute dialog menu
 */ const $d894cdec60fc66eb$var$AttributeMenuCategory = ({ name: name, children: children, forceExpand: forceExpand, constainsTransactionalAttribute: constainsTransactionalAttribute })=>{
    const overrides = $d894cdec60fc66eb$var$useStyles();
    const [collapsed, setCollapsed] = $ieT14.useState(true);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
        component: "fieldset",
        className: (0, $j6s32.default)(overrides.fieldset, collapsed && !forceExpand && 'collapsed'),
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: overrides.expandableTitle,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                        size: "small",
                        onClick: ()=>{
                            setCollapsed(!collapsed);
                        },
                        disabled: forceExpand,
                        className: (0, $j6s32.default)(overrides.expand, (!collapsed || forceExpand) && overrides.expandOpen),
                        "aria-label": `expand ${name}`,
                        "aria-expanded": !collapsed || forceExpand,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $b231e483803be961$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $f3VQ2.default), {
                        component: "legend",
                        className: overrides.formLabel,
                        children: [
                            constainsTransactionalAttribute && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $8991ead30e777b29$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $71578961b1a8465c$export$2e2bcd8739ae039), {}),
                                    "\xa0"
                                ]
                            }),
                            name
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $863c87a667a3ccc1$export$2e2bcd8739ae039), {
                in: !collapsed || forceExpand,
                className: overrides.collapse,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3WBJn.default), {
                    children: children
                })
            })
        ]
    });
};
var $d894cdec60fc66eb$export$2e2bcd8739ae039 = $d894cdec60fc66eb$var$AttributeMenuCategory;




const $b0ee6880b35b2190$var$useStyles = (0, $e1ONw.default)((theme)=>({
        dialog: {
            [theme.breakpoints.up('sm')]: {
                '& .MuiDialog-paperWidthSm': {
                    maxWidth: '640px'
                }
            }
        },
        dialogTitle: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        dialogActions: {
            justifyContent: 'space-between',
            height: 57,
            padding: '0 24px'
        },
        searchProgress: {
            marginRight: 8
        },
        searchBar: {
            width: 200
        }
    }));
const $b0ee6880b35b2190$var$AttributeMenu = ({ open: open, onApply: onApply, onCancel: onCancel })=>{
    const overrides = $b0ee6880b35b2190$var$useStyles();
    const theme = (0, $hgPMF.default)();
    const fullScreen = (0, $e3f2b79e5e31197b$export$2e2bcd8739ae039)(theme.breakpoints.only('xs'));
    const attributesQuery = (0, $0ac9b016f561a44f$export$2e2bcd8739ae039)();
    const checked = $ieT14.useRef([]);
    const [searchValue, setSearchValue] = $ieT14.useState('');
    const [searched, setSearched] = $ieT14.useState('');
    const [isSearching, setIsSearching] = $ieT14.useState(false);
    /** Callback passed to attribute checkboxes which track their own checked state */ const handleChange = (event)=>{
        if (event.target.checked) checked.current = [
            ...checked.current,
            Number(event.target.value)
        ];
        else checked.current = checked.current.filter((id)=>id !== Number(event.target.value));
    };
    const handleCancel = ()=>{
        checked.current = [];
        onCancel();
    };
    const handleApply = ()=>{
        onApply(checked.current);
        checked.current = [];
    };
    $ieT14.useEffect(()=>{
        if (searchValue.length >= 3) setIsSearching(true);
        const debounceTimer = setTimeout(()=>{
            if (searchValue.length >= 3) setSearched(searchValue);
            else setSearched('');
            setIsSearching(false);
        }, 400);
        return ()=>clearTimeout(debounceTimer);
    }, [
        searchValue
    ]);
    $ieT14.useEffect(()=>{
        if (!open) setSearchValue('');
    }, [
        open
    ]);
    const checkForTransactional = (categoryAttributes)=>{
        return !!categoryAttributes.find((att)=>att.isTransactional === true);
    };
    const content = $ieT14.useMemo(()=>{
        if (attributesQuery.data) return attributesQuery.data.categories.map((category)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $d894cdec60fc66eb$export$2e2bcd8739ae039), {
                name: category.category,
                forceExpand: searched != '',
                constainsTransactionalAttribute: checkForTransactional(category.attributes),
                children: category.attributes.map((attribute)=>{
                    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $013bb0a1cc411906$export$2e2bcd8739ae039), {
                        id: attribute.id,
                        name: attribute.name,
                        secondaryText: attribute.populatedPercentage !== undefined ? `${Math.round(attribute.populatedPercentage)}%` : '',
                        initialChecked: checked.current.includes(attribute.id),
                        onChange: handleChange,
                        hidden: !attribute.name.toLowerCase().includes(searched.toLowerCase()),
                        isTransactional: attribute.isTransactional
                    }, `${attribute.name}-${attribute.id}`);
                })
            }, category.category));
        return null;
    }, [
        attributesQuery.data,
        searched
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $1c689a1559dbf5e9$export$2e2bcd8739ae039), {
        open: open,
        maxWidth: "sm",
        scroll: "paper",
        fullScreen: fullScreen,
        className: overrides.dialog,
        "aria-labelledby": "select-attribute-dialog-title",
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $6830d3674ad61fd5$export$2e2bcd8739ae039), {
                id: "select-attribute-dialog-title",
                className: overrides.dialogTitle,
                disableTypography: true,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h3", {
                        className: $d3a6c5cfb2396086$export$b8772d08938399e8,
                        children: "Select an Attribute"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        className: $d3a6c5cfb2396086$export$ee4937ff310842b5,
                        children: [
                            isSearching && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {
                                size: "20px",
                                className: overrides.searchProgress
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SearchBar), {
                                value: searchValue,
                                updateValue: setSearchValue,
                                placeholder: "Search Attributes",
                                allowSubmitButton: false,
                                showClearButton: true,
                                inputProps: {
                                    disabled: attributesQuery.isLoading
                                },
                                className: overrides.searchBar
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $881610d42277b808$export$2e2bcd8739ae039), {
                dividers: true,
                children: [
                    attributesQuery.isLoading && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: $d3a6c5cfb2396086$export$5e7f86f864e6509c,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {
                            size: "20px"
                        })
                    }),
                    attributesQuery.isError && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
                        type: "error",
                        message: attributesQuery.error.message
                    }),
                    content
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $d176cc26269b23c2$export$2e2bcd8739ae039), {
                className: overrides.dialogActions,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.TertiaryButton), {
                        text: "Cancel",
                        title: "Cancel",
                        component: "button",
                        handleClick: handleCancel
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryButton), {
                        text: "Apply",
                        title: "Apply",
                        handleClick: handleApply
                    })
                ]
            })
        ]
    });
};
var $b0ee6880b35b2190$export$2e2bcd8739ae039 = $b0ee6880b35b2190$var$AttributeMenu;



const $43ac9fa9eea2010a$var$breakpoints = {
    xs: 640,
    sm: 1020,
    md: 1200
};
const $43ac9fa9eea2010a$var$useStyles = (0, $e1ONw.default)((theme)=>({
        inputs: {
            margin: '4px 12px',
            '& .MuiInputLabel-root': {
                backgroundColor: '#f8f8f8'
            },
            '& .MuiInputLabel-asterisk': {
                color: (0, $69ed148db7543104$export$8f45430ccf837300).rustRed
            }
        },
        attributeSelect: {
            [theme.breakpoints.down($43ac9fa9eea2010a$var$breakpoints.sm)]: {
                flex: 1
            },
            [theme.breakpoints.up($43ac9fa9eea2010a$var$breakpoints.sm)]: {
                flex: '0 0 200px'
            },
            [theme.breakpoints.up($43ac9fa9eea2010a$var$breakpoints.md)]: {
                flex: '0 0 300px'
            }
        },
        filterOperatorSelect: {
            flex: '0 0 126px',
            [theme.breakpoints.up($43ac9fa9eea2010a$var$breakpoints.xs)]: {
                flex: '0 0 150px'
            }
        },
        filterMenu: {
            flex: '1 0 280px',
            '& .MuiSelect-root': {
                paddingTop: 6,
                paddingBottom: 6,
                minHeight: 28
            }
        },
        delete: {
            flex: '0 0 48px',
            marginRight: 12,
            zIndex: 1,
            '&.Mui-disabled': {
                opacity: 0.5
            }
        },
        selectOptions: {
            '&.MuiInputBase-root.Mui-disabled': {
                color: 'rgba(0, 0, 0, 0.87)'
            }
        },
        selectedAttribute: {
            display: 'flex',
            alignItems: 'center'
        }
    }));
/**
 * Component that renders the inputs controlling the selection and filtering of a single attribute within an attribute row
 */ const $43ac9fa9eea2010a$var$Attribute = ({ selectedAttribute: selectedAttribute, required: required, handleDelete: handleDelete, handleOpen: handleOpen, handleAddToGroup: handleAddToGroup, position: position, exclude: exclude, attributeIndex: attributeIndex })=>{
    const overrides = $43ac9fa9eea2010a$var$useStyles();
    const { dispatch: dispatch } = (0, $79aece72917dec2b$export$7cea9ed133024a2d)(exclude);
    const attributesQuery = (0, $0ac9b016f561a44f$export$2e2bcd8739ae039)();
    const renderDropDownArrow = $ieT14.useCallback(()=>{
        if (selectedAttribute?.attributeId) return null;
        else return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $00ab641e898f8f9d$export$2e2bcd8739ae039), {});
    }, []);
    let attributeDetailsQuery = (0, $49f64957c05f123f$export$275540052f30cbba)(selectedAttribute?.attributeId, selectedAttribute != undefined, selectedAttribute?.isTransactional);
    const [groupAdditionMenuOpen, setGroupAdditionMenuOpen] = $ieT14.useState(false);
    // Get basic attribute
    const attribute = $ieT14.useMemo(()=>{
        if (attributesQuery.data && attributesQuery.data.attributes.length > 0 && selectedAttribute) return attributesQuery.data.attributes.find((option)=>option.id === selectedAttribute.attributeId && option.isTransactional === selectedAttribute.isTransactional);
    }, [
        attributesQuery.data,
        selectedAttribute
    ]);
    const isIsNotOperator = (filterOperatpr)=>{
        return filterOperatpr === (0, $a9d5bf712846139f$export$165a359d8710f906).Is || filterOperatpr === (0, $a9d5bf712846139f$export$165a359d8710f906)['Is Not'];
    };
    const handleFilterLogicChange = (event)=>{
        const newFilterOperator = event.target.value;
        const newAttribute = {
            ...selectedAttribute,
            filterOperator: newFilterOperator
        };
        if (isIsNotOperator(newFilterOperator)) {
            if (!isIsNotOperator(selectedAttribute.filterOperator)) {
                delete newAttribute['searchText'];
                newAttribute['options'] = [];
            }
        } else if (isIsNotOperator(selectedAttribute.filterOperator)) {
            delete newAttribute['options'];
            newAttribute['searchText'] = '';
        }
        dispatch({
            type: 'updateAttribute',
            attribute: newAttribute,
            position: position,
            attributeIndex: attributeIndex
        });
    };
    const selectedAttributeId = selectedAttribute ? selectedAttribute.attributeId : 0;
    const isSelectedAttributeEmpty = !selectedAttribute;
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        className: $4830ac0c4a56bbcf$export$af4b9a83f4b00434,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
            className: $4830ac0c4a56bbcf$export$c8f07a9b573bdaf3,
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    className: $4830ac0c4a56bbcf$export$995e14ef61d916e6,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
                            required: required,
                            size: "small",
                            variant: "outlined",
                            className: (0, $j6s32.default)(overrides.inputs, overrides.attributeSelect),
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $Uxz4Y.default), {
                                    htmlFor: `select-attribute-${selectedAttributeId}`,
                                    children: "Select an Attribute"
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $aanJt.default), {
                                    id: `select-attribute-${selectedAttributeId}`,
                                    // Always open Dialog instead of standard select menu
                                    open: false,
                                    onOpen: handleOpen,
                                    title: attribute && attribute.name,
                                    disabled: !!selectedAttribute?.attributeId,
                                    className: overrides.selectOptions,
                                    value: attributesQuery.data && attributesQuery.data.attributes.length > 0 && selectedAttribute ? String(selectedAttribute.attributeId) : '',
                                    // @ts-ignore data-* should be whitelisted but is not, used here as last resort for testing id
                                    SelectDisplayProps: {
                                        'data-testid': 'select-attribute'
                                    },
                                    inputProps: {
                                        IconComponent: renderDropDownArrow
                                    },
                                    children: attributesQuery.data && attributesQuery.data.attributes.map((attributeOption)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                            value: attributeOption.id,
                                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                                className: overrides.selectedAttribute,
                                                children: [
                                                    attributeOption.isTransactional && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $8991ead30e777b29$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $71578961b1a8465c$export$2e2bcd8739ae039), {}),
                                                            "\xa0"
                                                        ]
                                                    }),
                                                    attributeOption.name
                                                ]
                                            })
                                        }, attributeOption.id))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                            className: $4830ac0c4a56bbcf$export$982740ec81581fef,
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
                                    required: required,
                                    size: "small",
                                    variant: "outlined",
                                    className: (0, $j6s32.default)(overrides.inputs, overrides.filterOperatorSelect),
                                    children: [
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $Uxz4Y.default), {
                                            htmlFor: `select-filter-logic-${selectedAttributeId}`,
                                            children: "Filter Logic"
                                        }),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $aanJt.default), {
                                            id: `select-filter-logic-${selectedAttributeId}`,
                                            value: selectedAttribute ? selectedAttribute.filterOperator : '',
                                            onChange: handleFilterLogicChange,
                                            disabled: !selectedAttribute || 'where' in selectedAttribute,
                                            children: [
                                                selectedAttribute && (selectedAttribute.isTransactional ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                                    value: (0, $a9d5bf712846139f$export$165a359d8710f906).Where,
                                                    children: "Where"
                                                }) : [
                                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                                        value: (0, $a9d5bf712846139f$export$165a359d8710f906).Is,
                                                        children: "Is"
                                                    }, "Is"),
                                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                                        value: (0, $a9d5bf712846139f$export$165a359d8710f906)['Is Not'],
                                                        children: "Is Not"
                                                    }, "Is Not")
                                                ]),
                                                selectedAttribute && !('range' in selectedAttribute || 'dateRange' in selectedAttribute || 'numberOfDays' in selectedAttribute || 'where' in selectedAttribute) && [
                                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                                        value: (0, $a9d5bf712846139f$export$165a359d8710f906)['Begins With'],
                                                        children: "Begins With"
                                                    }, "Begins With"),
                                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                                        value: (0, $a9d5bf712846139f$export$165a359d8710f906)['Does Not Begin With'],
                                                        children: "Does Not Begin With"
                                                    }, "Does Not Begin With"),
                                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                                        value: (0, $a9d5bf712846139f$export$165a359d8710f906)['Ends With'],
                                                        children: "Ends With"
                                                    }, "Ends With"),
                                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                                        value: (0, $a9d5bf712846139f$export$165a359d8710f906)['Does Not End With'],
                                                        children: "Does Not End With"
                                                    }, "Does Not End With"),
                                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                                        value: (0, $a9d5bf712846139f$export$165a359d8710f906)['Contains'],
                                                        children: "Contains"
                                                    }, "Contains"),
                                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                                        value: (0, $a9d5bf712846139f$export$165a359d8710f906)['Does Not Contain'],
                                                        children: "Does Not Contain"
                                                    }, "Does Not Contain")
                                                ]
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
                                    size: "small",
                                    variant: "outlined",
                                    className: (0, $j6s32.default)(overrides.inputs, overrides.filterMenu),
                                    error: attributeDetailsQuery.isError,
                                    children: [
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $Uxz4Y.default), {
                                            htmlFor: `filter-attribute-${selectedAttributeId}`,
                                            shrink: !isSelectedAttributeEmpty,
                                            children: "Filter the Attribute"
                                        }),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $7ee69279e31a81d5$export$2e2bcd8739ae039), {
                                            selectedAttribute: selectedAttribute,
                                            position: position,
                                            exclude: exclude,
                                            attributeIndex: attributeIndex
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1KcBP.default), {
                                    onClick: ()=>handleDelete(selectedAttribute.attributeId, attributeIndex),
                                    disabled: isSelectedAttributeEmpty,
                                    className: overrides.delete,
                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $70ccc3891d50e85f$export$2e2bcd8739ae039), {
                                        htmlColor: (0, $69ed148db7543104$export$2aa0182783e7e9de)[600]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                selectedAttribute && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    className: $4830ac0c4a56bbcf$export$faadaf0198b97fbe,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $b1c3fceec5a3a004$export$2e2bcd8739ae039), {
                            label: "Add Attribute to Group",
                            handleClick: handleAddToGroup,
                            disabled: isSelectedAttributeEmpty
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $b1c3fceec5a3a004$export$2e2bcd8739ae039), {
                            label: "Add Nested Group",
                            handleClick: ()=>setGroupAdditionMenuOpen(true),
                            disabled: isSelectedAttributeEmpty
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $b0ee6880b35b2190$export$2e2bcd8739ae039), {
                            open: groupAdditionMenuOpen,
                            onApply: (checked)=>{
                                dispatch({
                                    type: 'addGroup',
                                    afterAttributeId: selectedAttribute.attributeId,
                                    afterIsTransactional: selectedAttribute.isTransactional,
                                    attributeIdsToAdd: checked,
                                    attributes: attributesQuery.data.attributes,
                                    position: position
                                });
                                setGroupAdditionMenuOpen(false);
                            },
                            onCancel: ()=>setGroupAdditionMenuOpen(false)
                        })
                    ]
                })
            ]
        })
    });
};
var $43ac9fa9eea2010a$export$2e2bcd8739ae039 = $43ac9fa9eea2010a$var$Attribute;







var $j6s32 = parcelRequire("j6s32");

const $e81f9e81ac1d6ecd$var$AttributeGroup = ({ attributeGroup: attributeGroup, position: position, exclude: exclude })=>{
    const [dialogOpen, setDialogOpen] = $ieT14.useState(false);
    const { dispatch: dispatch } = (0, $79aece72917dec2b$export$7cea9ed133024a2d)(exclude);
    const attributesQuery = (0, $0ac9b016f561a44f$export$2e2bcd8739ae039)();
    const handleCancel = ()=>{
        setDialogOpen(false);
    };
    const handleApply = (checked)=>{
        if (checked.length > 0) dispatch({
            type: 'applyAttributes',
            checked: checked,
            attributes: attributesQuery.data.attributes,
            position: position
        });
        setDialogOpen(false);
    };
    const handleOpen = ()=>{
        setDialogOpen(true);
    };
    const handleDelete = (attributeId, attributeIndex)=>{
        dispatch({
            type: 'deleteAttribute',
            attributeId: attributeId,
            position: position,
            attributeIndex: attributeIndex
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: (0, $j6s32.default)($4830ac0c4a56bbcf$export$ffe5e8c7e30de942, attributeGroup.predicates.length > 0 && position.length > 1 && $4830ac0c4a56bbcf$export$cdbed24db7b9850b),
        children: [
            attributeGroup.predicates.length === 0 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $43ac9fa9eea2010a$export$2e2bcd8739ae039), {
                selectedAttribute: undefined,
                required: false,
                handleDelete: handleDelete,
                handleOpen: handleOpen,
                handleAddToGroup: handleOpen,
                position: position,
                exclude: exclude
            }),
            attributeGroup.predicates.map((predicate, idx)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
                    children: [
                        idx === 1 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                            className: $4830ac0c4a56bbcf$export$857200a0d311d659,
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $0e860a8a329fdc63$export$2e2bcd8739ae039), {
                                operator: attributeGroup.operator,
                                handleChange: (operator)=>{
                                    dispatch({
                                        type: 'updateOperator',
                                        operator: operator,
                                        position: position
                                    });
                                }
                            })
                        }),
                        idx > 1 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                            className: $4830ac0c4a56bbcf$export$857200a0d311d659,
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                className: $4830ac0c4a56bbcf$export$6b8b92a9240a8a67,
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("p", {
                                    className: $4830ac0c4a56bbcf$export$f98f2d26ae95425a,
                                    children: (0, $a9d5bf712846139f$export$905dbc95765b1ada)[attributeGroup.operator]
                                })
                            })
                        }),
                        'attributeId' in predicate ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $43ac9fa9eea2010a$export$2e2bcd8739ae039), {
                            selectedAttribute: predicate,
                            required: false,
                            handleDelete: handleDelete,
                            handleOpen: handleOpen,
                            handleAddToGroup: handleOpen,
                            position: position,
                            exclude: exclude,
                            attributeIndex: idx
                        }, `attribute-${(0, $6a74c864676f2556$export$1363d1c8d6e714b5)(predicate)}`) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($e81f9e81ac1d6ecd$var$AttributeGroup, {
                            attributeGroup: predicate,
                            position: [
                                ...position,
                                idx
                            ],
                            exclude: exclude
                        })
                    ]
                }, `${(0, $6a74c864676f2556$export$1363d1c8d6e714b5)(predicate)}-${idx}`)),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $b0ee6880b35b2190$export$2e2bcd8739ae039), {
                open: dialogOpen,
                onCancel: handleCancel,
                onApply: handleApply
            })
        ]
    });
};
var $e81f9e81ac1d6ecd$export$2e2bcd8739ae039 = $e81f9e81ac1d6ecd$var$AttributeGroup;








var $fpdl2 = parcelRequire("fpdl2");
var $whS22 = parcelRequire("whS22");
var $Uxz4Y = parcelRequire("Uxz4Y");
var $e1ONw = parcelRequire("e1ONw");
var $3mOXj = parcelRequire("3mOXj");
var $aanJt = parcelRequire("aanJt");
var $aIJrd = parcelRequire("aIJrd");

var $ieT14 = parcelRequire("ieT14");




var $eYoAG = parcelRequire("eYoAG");

var $ieT14 = parcelRequire("ieT14");



function $12734a0bfffae223$export$2abf1296ffa2d8d5(segmentId) {
    const appState = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    return (0, $137a3b252d598119$export$dd0a697e1782aedd)([
        'available-compositions',
        appState.state.clientId,
        segmentId
    ], ()=>{
        return fetchWrapper(`api/${appState.state.clientId}/segments/${segmentId}/available-compositions`);
    }, {
        keepPreviousData: true
    });
}




var $j6s32 = parcelRequire("j6s32");




var $4leCF = parcelRequire("4leCF");


var $fgoQ6 = parcelRequire("fgoQ6");

var $ieT14 = parcelRequire("ieT14");





function $1517e00917d95652$export$204800eede9ea29f(segmentId) {
    const appState = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    const userInterface = window.env.USER_INTERFACE ?? 'default';
    const segmentQuery = (0, $137a3b252d598119$export$dd0a697e1782aedd)([
        'segment',
        segmentId,
        userInterface,
        appState.state.clientId
    ], ()=>{
        if (userInterface === 'management') return fetchWrapper(`api/segments/${segmentId}`);
        return fetchWrapper(`api/${appState.state.clientId}/segments/${segmentId}`);
    }, {
        select: (data)=>{
            const newData = {
                ...data,
                attributes: {
                    include: {
                        ...data.attributes.include,
                        predicates: (0, $6a74c864676f2556$export$616542113386b517)(data.attributes.include.predicates)
                    },
                    exclude: {
                        ...data.attributes.exclude,
                        predicates: (0, $6a74c864676f2556$export$616542113386b517)(data.attributes.exclude?.predicates)
                    }
                }
            };
            // returned attributes with all selected filters deserialized
            const includedAttributes = $1517e00917d95652$var$deserializeSelectedFilters(newData.attributes.include);
            const excludedAttributes = $1517e00917d95652$var$deserializeSelectedFilters(newData.attributes.exclude);
            // convert attributes list into SegmentGroup
            const selectedIncludedAttributes = $1517e00917d95652$var$responseGroupToAttributeGroup(includedAttributes);
            const selectedExcludedAttributes = $1517e00917d95652$var$responseGroupToAttributeGroup(excludedAttributes);
            // data to preload the results table as SegmentResults
            const results = {
                totalCustomers: newData.totalCustomers,
                includedCustomers: newData.includedCustomers,
                excludedCustomers: newData.excludedCustomers,
                perAttributeGroup: {
                    include: newData.attributes.include.predicates.map((predicate)=>predicate.customers),
                    exclude: newData.attributes.exclude?.predicates.map((predicate)=>predicate.customers)
                }
            };
            return {
                ...newData,
                attributes: {
                    include: includedAttributes,
                    exclude: excludedAttributes
                },
                selectedAttributes: {
                    include: selectedIncludedAttributes,
                    exclude: selectedExcludedAttributes
                },
                results: results
            };
        },
        enabled: !!segmentId
    });
    return {
        segmentQuery: segmentQuery,
        userInterface: userInterface
    };
}
/**
 * Recursively map over the segment attributes and deserialize any attributes' JSON filters
 * Copy all group properties in order to not overwrite base attributes' customers property
 */ function $1517e00917d95652$var$deserializeSelectedFilters(group) {
    return group ? {
        ...group,
        predicates: group.predicates ? group.predicates.map((predicate)=>{
            if ('predicates' in predicate) return $1517e00917d95652$var$deserializeSelectedFilters(predicate);
            if (predicate.isTransactional) {
                //@ts-ignore
                const transactionalPredicates = predicate.selectedTransactionalFilters?.predicates.map((item)=>{
                    return {
                        ...item,
                        selectedFilters: item.selectedFilters ? JSON.parse(item.selectedFilters) : undefined
                    };
                });
                return {
                    ...predicate,
                    selectedTransactionalFilters: transactionalPredicates ? {
                        //@ts-ignore
                        operator: predicate.selectedTransactionalFilters?.operator,
                        //@ts-ignore
                        predicates: transactionalPredicates ?? []
                    } : {}
                };
            } else return {
                ...predicate,
                selectedFilters: predicate.selectedFilters ? JSON.parse(predicate.selectedFilters) : undefined
            };
        }) : []
    } : undefined;
}
/**
 * Recursively map the segment attributes (from deserializeSelectedFilters) from SegmentDetailParsedAttributeGroup to SegmentAttributeGroup
 * Required for loading initial state when editing an existing segment
 */ function $1517e00917d95652$var$responseGroupToAttributeGroup(group) {
    return group ? {
        operator: group.operator,
        predicates: group.predicates.map((predicate)=>{
            if ('predicates' in predicate) return $1517e00917d95652$var$responseGroupToAttributeGroup(predicate);
            //@ts-ignore
            return $1517e00917d95652$var$mapAttributesToSelected(predicate);
        })
    } : undefined;
}
/**
 * Map parsed SegmentDetailAttribute objects with generic `selectedFilters` properties into SelectedAttributes used in segment editing/building
 */ function $1517e00917d95652$var$mapAttributesToSelected(attribute) {
    const attributeBase = {
        attributeId: attribute.attributeId,
        columnName: attribute.columnName,
        name: attribute.name,
        filterOperator: attribute.filterOperator
    };
    if (attribute.isTransactional) return $1517e00917d95652$var$buildTransactionalAttribute(attribute);
    switch(attribute.filterType){
        case 'options':
            if (attribute.filterOperator === (0, $a9d5bf712846139f$export$165a359d8710f906).Is || attribute.filterOperator === (0, $a9d5bf712846139f$export$165a359d8710f906)['Is Not']) return {
                ...attributeBase,
                options: attribute.selectedFilters
            };
            else return {
                ...attributeBase,
                searchText: attribute.selectedFilters
            };
        case 'range':
            {
                const { min: min, max: max } = attribute.selectedFilters;
                return {
                    ...attributeBase,
                    range: {
                        min: min,
                        max: max
                    }
                };
            }
        case 'datetime':
            {
                if (typeof attribute.selectedFilters == 'number') return {
                    ...attributeBase,
                    numberOfDays: attribute.selectedFilters
                };
                const { min: min, max: max } = attribute.selectedFilters;
                return {
                    ...attributeBase,
                    dateRange: {
                        min: min,
                        max: max
                    }
                };
            }
        default:
            // @ts-ignore - will only throw if a new filterType is unaccounted for
            throw new Error(`Unhandled filter type: ${attribute.filterType}`);
    }
}
function $1517e00917d95652$var$buildTransactionalAttribute(attribute) {
    const selectedFilters = attribute.selectedTransactionalFilters.predicates?.map((filter)=>{
        const filterBase = {
            columnName: filter.columnName,
            filterId: filter.filterId,
            filterOperator: filter.filterOperator,
            filterType: filter.filterType,
            name: filter.name
        };
        switch(filter.filterType){
            case 'options':
                if (filter.filterOperator === (0, $a9d5bf712846139f$export$165a359d8710f906).Is || filter.filterOperator === (0, $a9d5bf712846139f$export$165a359d8710f906)['Is Not']) return {
                    ...filterBase,
                    options: filter.selectedFilters
                };
                else return {
                    ...filterBase,
                    searchText: filter.selectedFilters
                };
            case 'range':
                {
                    const { min: min, max: max } = filter.selectedFilters;
                    return {
                        ...filterBase,
                        range: {
                            min: min,
                            max: max
                        }
                    };
                }
            case 'datetime':
                {
                    if (typeof filter.selectedFilters == 'number') return {
                        ...filterBase,
                        numberOfDays: filter.selectedFilters
                    };
                    const { min: min, max: max } = filter.selectedFilters;
                    return {
                        ...filterBase,
                        dateRange: {
                            min: min,
                            max: max
                        }
                    };
                }
            default:
                // @ts-ignore - will only throw if a new filterType is unaccounted for
                throw new Error(`Unhandled filter type: ${filter.filterType}`);
        }
    });
    if (!selectedFilters) return {
        attributeId: attribute.attributeId,
        columnName: attribute.columnName,
        filterOperator: attribute.filterOperator,
        where: 'all',
        isTransactional: true,
        groupBy: attribute.groupBy ? JSON.parse(JSON.stringify(attribute.groupBy)) : undefined
    };
    return {
        attributeId: attribute.attributeId,
        columnName: attribute.columnName,
        filterOperator: attribute.filterOperator,
        where: 'all',
        isTransactional: true,
        groupBy: attribute.groupBy ? JSON.parse(JSON.stringify(attribute.groupBy)) : undefined,
        transactionalFilters: {
            operator: attribute.selectedTransactionalFilters.operator ?? undefined,
            //@ts-ignore
            predicates: selectedFilters
        }
    };
}




var $ieT14 = parcelRequire("ieT14");
var $c7480ef281c02b11$export$b0377cbbbdab6cba;
var $c7480ef281c02b11$export$f27f0a643498ce3d;
var $c7480ef281c02b11$export$b00c055587dc7469;
var $c7480ef281c02b11$export$b1a09d22b7ad6c4;
var $c7480ef281c02b11$export$509f3108fdd206bb;
var $c7480ef281c02b11$export$42ff741d2868ee32;
var $c7480ef281c02b11$export$8c430709db82137d;
var $c7480ef281c02b11$export$2d4b1211b4389c3b;
var $c7480ef281c02b11$export$3832be13857745bc;
var $c7480ef281c02b11$export$f4c68800b094ddb1;
var $c7480ef281c02b11$export$e8e78c978b129247;
var $c7480ef281c02b11$export$a40ebde8ba896166;
var $c7480ef281c02b11$export$a3bc9b8ed74fc;
var $c7480ef281c02b11$export$59bc6e0c0b51d74a;
var $c7480ef281c02b11$export$370d47912bf58482;
var $c7480ef281c02b11$export$665e0f4515a68234;
var $c7480ef281c02b11$export$c657596daa39a84e;
var $c7480ef281c02b11$export$e7d47881ec916f76;
var $c7480ef281c02b11$export$7dc31a927bb1641e;
var $c7480ef281c02b11$export$985c2484b69174d5;
var $c7480ef281c02b11$export$af4b9a83f4b00434;
var $c7480ef281c02b11$export$890e38aac5063dc6;
var $c7480ef281c02b11$export$ffe5e8c7e30de942;
var $c7480ef281c02b11$export$7608d1b15f24c2a5;
var $c7480ef281c02b11$export$8e830b0a8238aa08;
var $c7480ef281c02b11$export$dac863774b2ab841;
var $c7480ef281c02b11$export$dbd72860f701d4f3;
var $c7480ef281c02b11$export$1525ade026b25155;
var $c7480ef281c02b11$export$f94159c072f7db60;
var $c7480ef281c02b11$export$908a233be4ecde8e;
var $c7480ef281c02b11$export$4ce7dd94b992d866;
var $c7480ef281c02b11$export$69c38880c311a6cb;
var $c7480ef281c02b11$export$4ebfe5b2998441f3;
var $c7480ef281c02b11$export$63e74f062b99a6b3;
var $c7480ef281c02b11$export$ac4a8cea196e7773;
$c7480ef281c02b11$export$b0377cbbbdab6cba = "#006da8";
$c7480ef281c02b11$export$f27f0a643498ce3d = "#00aafc";
$c7480ef281c02b11$export$b00c055587dc7469 = "#f5dbd9";
$c7480ef281c02b11$export$b1a09d22b7ad6c4 = "#c92100";
$c7480ef281c02b11$export$509f3108fdd206bb = "#ebafa6";
$c7480ef281c02b11$export$42ff741d2868ee32 = "#074f86";
$c7480ef281c02b11$export$8c430709db82137d = "#dadada";
$c7480ef281c02b11$export$2d4b1211b4389c3b = "#dddbda";
$c7480ef281c02b11$export$3832be13857745bc = "#eae9ed";
$c7480ef281c02b11$export$f4c68800b094ddb1 = "#e9e8f4";
$c7480ef281c02b11$export$e8e78c978b129247 = "root_a74cc6";
$c7480ef281c02b11$export$a40ebde8ba896166 = "breadcrumb_a74cc6";
$c7480ef281c02b11$export$a3bc9b8ed74fc = "error_a74cc6";
$c7480ef281c02b11$export$59bc6e0c0b51d74a = "detailsSectionContent_a74cc6";
$c7480ef281c02b11$export$370d47912bf58482 = "descriptionField_a74cc6";
$c7480ef281c02b11$export$665e0f4515a68234 = "buildSection_a74cc6";
$c7480ef281c02b11$export$c657596daa39a84e = "detailListItem_a74cc6";
$c7480ef281c02b11$export$e7d47881ec916f76 = "tableWrapper_a74cc6";
$c7480ef281c02b11$export$7dc31a927bb1641e = "attributeRow_a74cc6";
$c7480ef281c02b11$export$985c2484b69174d5 = "baseOperator_a74cc6";
$c7480ef281c02b11$export$af4b9a83f4b00434 = "attribute_a74cc6";
$c7480ef281c02b11$export$890e38aac5063dc6 = "customers_a74cc6";
$c7480ef281c02b11$export$ffe5e8c7e30de942 = "attributeGroup_a74cc6";
$c7480ef281c02b11$export$7608d1b15f24c2a5 = "deeplyNested_a74cc6";
$c7480ef281c02b11$export$8e830b0a8238aa08 = "attributeName_a74cc6";
$c7480ef281c02b11$export$dac863774b2ab841 = "filterText_a74cc6";
$c7480ef281c02b11$export$dbd72860f701d4f3 = "operator_a74cc6";
$c7480ef281c02b11$export$1525ade026b25155 = "filterOperator_a74cc6";
$c7480ef281c02b11$export$f94159c072f7db60 = "inlineOperator_a74cc6";
$c7480ef281c02b11$export$908a233be4ecde8e = "blankOption_a74cc6";
$c7480ef281c02b11$export$4ce7dd94b992d866 = "transactionalRow_a74cc6";
$c7480ef281c02b11$export$69c38880c311a6cb = "transactionalFilterName_a74cc6";
$c7480ef281c02b11$export$4ebfe5b2998441f3 = "transactionalAttributeContainer_a74cc6";
$c7480ef281c02b11$export$63e74f062b99a6b3 = "transActionalSegmentalOperator_a74cc6";
$c7480ef281c02b11$export$ac4a8cea196e7773 = "transactionalOperator_a74cc6";




var $j6s32 = parcelRequire("j6s32");


var $ieT14 = parcelRequire("ieT14");



var $3umuy = parcelRequire("3umuy");

var $j6s32 = parcelRequire("j6s32");

var $e1ONw = parcelRequire("e1ONw");

const $35d9329663c8433e$var$useStyles = (0, $e1ONw.default)(()=>({
        viewAttributeContainer: {
            width: '100%'
        },
        groupByContainer: {
            padding: '5px 0px 5px 40px',
            display: 'flex',
            flexDirection: 'column'
        },
        groupByName: {
            fontWeight: 600
        },
        groupByValuesRow: {
            display: 'flex',
            flexDirection: 'row',
            padding: '10px'
        },
        groupByValuesName: {
            flex: '0 0 300px'
        },
        groupByValuesAggregateFunction: {
            width: '100%',
            textAlign: 'center',
            flex: '0 0 100px'
        },
        groupByValuesOperator: {
            width: '100%',
            textAlign: 'center',
            flex: '0 0 150px'
        }
    }));
const $35d9329663c8433e$var$ViewAttribute = ({ attribute: attribute, depth: depth, inlineOperator: inlineOperator })=>{
    const classes = $35d9329663c8433e$var$useStyles();
    const matches = (0, $e3f2b79e5e31197b$export$2e2bcd8739ae039)('(min-width: 1200px)');
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: classes.viewAttributeContainer,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("ul", {
                className: $c7480ef281c02b11$export$af4b9a83f4b00434,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("li", {
                        className: $c7480ef281c02b11$export$8e830b0a8238aa08,
                        style: {
                            flex: `0 0 ${(matches ? 300 : 200) - depth * 12}px`
                        },
                        title: attribute.name,
                        children: [
                            inlineOperator !== undefined && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                className: (0, $j6s32.default)($c7480ef281c02b11$export$dbd72860f701d4f3, $c7480ef281c02b11$export$f94159c072f7db60),
                                children: (0, $a9d5bf712846139f$export$905dbc95765b1ada)[inlineOperator]
                            }),
                            attribute.isTransactional && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $8991ead30e777b29$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $71578961b1a8465c$export$2e2bcd8739ae039), {}),
                                    "\xa0"
                                ]
                            }),
                            attribute.name
                        ]
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
                        className: (0, $j6s32.default)($c7480ef281c02b11$export$dbd72860f701d4f3, $c7480ef281c02b11$export$1525ade026b25155),
                        children: (0, $a9d5bf712846139f$export$165a359d8710f906)[attribute.filterOperator]
                    }),
                    !attribute.isTransactional && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
                        className: $c7480ef281c02b11$export$dac863774b2ab841,
                        children: $35d9329663c8433e$var$filtersToText(attribute)
                    }),
                    !!attribute.isTransactional && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8991ead30e777b29$exports.Fragment), {
                        children: $35d9329663c8433e$var$transactionalToText(attribute)
                    })
                ]
            }),
            !!attribute.isTransactional && !!attribute.groupBy && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($35d9329663c8433e$var$ViewGroupBy, {
                groupBy: attribute.groupBy
            })
        ]
    });
};
var $35d9329663c8433e$export$2e2bcd8739ae039 = $35d9329663c8433e$var$ViewAttribute;
/**
 * Render appropriate text representing selected filters based on the filter type
 */ function $35d9329663c8433e$var$filtersToText(attribute) {
    if (attribute.isTransactional === true) return $35d9329663c8433e$var$transactionalToText(attribute);
    switch(attribute.filterType){
        case 'options':
            return $35d9329663c8433e$var$optionsToText(attribute);
        case 'range':
            return $35d9329663c8433e$var$rangeToText(attribute);
        case 'datetime':
            return $35d9329663c8433e$var$dateRangeToText(attribute);
        default:
            return '';
    }
}
/**
 * Render options type filter into a comma separated list, transforming empty strings into a special blank value
 */ function $35d9329663c8433e$var$optionsToText(attribute) {
    if (Array.isArray(attribute.selectedFilters)) {
        if (attribute.selectedFilters.findIndex((filterValue)=>filterValue.trim() === '') !== -1) {
            const filters = attribute.selectedFilters.filter((filter)=>filter.trim() !== '');
            return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        className: $c7480ef281c02b11$export$908a233be4ecde8e,
                        children: "blank"
                    }),
                    filters.length > 0 && `, ${filters.join(', ')}`
                ]
            });
        } else return attribute.selectedFilters.length > 0 ? attribute.selectedFilters.join(', ') : 'All - No additional filtering applied';
    } else if (typeof attribute.selectedFilters === 'string') return attribute.selectedFilters;
    else return '';
}
/**
 * Render numerical range filters to a comma delimited Min/Max string
 */ function $35d9329663c8433e$var$rangeToText(attribute) {
    let rangeText = '';
    if (attribute.selectedFilters) {
        const rangeArray = [];
        if (attribute.selectedFilters.min) rangeArray.push(`Min: ${attribute.selectedFilters.min}`);
        if (attribute.selectedFilters.max) rangeArray.push(`Max: ${attribute.selectedFilters.max}`);
        rangeText = rangeArray.join(', ');
    }
    if (rangeText === '') return 'All - No additional filtering applied';
    return rangeText;
}
/**
 * Render datetime range filters to a comma delimited Start/End string
 */ function $35d9329663c8433e$var$dateRangeToText(attribute) {
    if (typeof attribute.selectedFilters == 'number') return `Last ${attribute.selectedFilters} days`;
    let dateRangeText = '';
    if (attribute.selectedFilters) {
        const dateRangeArray = [];
        if (attribute.selectedFilters.min) dateRangeArray.push(`Start: ${(0, (/*@__PURE__*/$parcel$interopDefault($3umuy)))(attribute.selectedFilters.min).format('MM/DD/YYYY')}`);
        if (attribute.selectedFilters.max) dateRangeArray.push(`End: ${(0, (/*@__PURE__*/$parcel$interopDefault($3umuy)))(attribute.selectedFilters.max).format('MM/DD/YYYY')}`);
        dateRangeText = dateRangeArray.join(', ');
    }
    if (dateRangeText === '') return 'All - No additional filtering applied';
    return dateRangeText;
}
/**
 * Render transactional filters to a where string
 */ function $35d9329663c8433e$var$transactionalToText(_attribute) {
    if (!_attribute.selectedTransactionalFilters?.predicates || _attribute.selectedTransactionalFilters.predicates.length === 0) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
        className: $c7480ef281c02b11$export$dac863774b2ab841,
        children: "All - No additional filtering applied"
    });
    let attributeText = [];
    const attributesLength = _attribute.selectedTransactionalFilters.predicates.length;
    _attribute.selectedTransactionalFilters.predicates.forEach((filter, index)=>{
        //@ts-ignore
        const filterName = `${filter.name}`;
        attributeText.push(/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
            className: $c7480ef281c02b11$export$4ebfe5b2998441f3,
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                    className: $c7480ef281c02b11$export$69c38880c311a6cb,
                    children: filterName
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                    className: $c7480ef281c02b11$export$dbd72860f701d4f3,
                    children: (0, $a9d5bf712846139f$export$165a359d8710f906)[filter.filterOperator]
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
                    className: $c7480ef281c02b11$export$dac863774b2ab841,
                    children: $35d9329663c8433e$var$filtersToText(filter)
                }),
                index !== attributesLength - 1 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                    className: $c7480ef281c02b11$export$ac4a8cea196e7773,
                    children: (0, $a9d5bf712846139f$export$905dbc95765b1ada)[_attribute.selectedTransactionalFilters.operator]
                })
            ]
        }, filter.filterId));
    });
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        className: $c7480ef281c02b11$export$4ce7dd94b992d866,
        children: attributeText
    }, _attribute.attributeId);
}
const $35d9329663c8433e$var$ViewGroupBy = ({ groupBy: groupBy })=>{
    const classes = $35d9329663c8433e$var$useStyles();
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: classes.groupByContainer,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                children: [
                    "Group By: ",
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                        className: classes.groupByName,
                        children: groupBy.groupByFilterName
                    })
                ]
            }),
            groupBy.groupByValues.groupByPredicates.map((values, index)=>{
                return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    className: classes.groupByValuesRow,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                            className: classes.groupByValuesName,
                            children: values.valueFilterName
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                            className: classes.groupByValuesAggregateFunction,
                            children: (0, $a9d5bf712846139f$export$48733c9c52b2aead)[values.aggregateFunction]
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                            className: classes.groupByValuesOperator,
                            children: (0, $a9d5bf712846139f$export$a7b636559b01a55f)[values.aggregateOperator]
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                            children: values.value
                        })
                    ]
                }, `${values.valueFilterId} - ${index}`);
            })
        ]
    });
};




var $ieT14 = parcelRequire("ieT14");




var $j6s32 = parcelRequire("j6s32");

const $88a60072f9aaa3d6$var$ViewAttributeGroup = ({ attributeGroup: attributeGroup, depth: depth })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($ieT14.Fragment, {
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("ul", {
            className: (0, $j6s32.default)($c7480ef281c02b11$export$ffe5e8c7e30de942, depth > 0 && $c7480ef281c02b11$export$7608d1b15f24c2a5),
            children: attributeGroup.predicates.map((predicate, idx)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
                    children: [
                        idx > 0 && ('predicates' in predicate || depth === 0) && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
                            className: $c7480ef281c02b11$export$dbd72860f701d4f3,
                            children: (0, $a9d5bf712846139f$export$905dbc95765b1ada)[attributeGroup.operator]
                        }),
                        'attributeId' in predicate ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $35d9329663c8433e$export$2e2bcd8739ae039), {
                            attribute: predicate,
                            depth: depth,
                            inlineOperator: idx > 0 && depth > 0 ? attributeGroup.operator : undefined
                        }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($88a60072f9aaa3d6$var$ViewAttributeGroup, {
                            attributeGroup: predicate,
                            depth: depth + 1
                        })
                    ]
                }, `${(0, $6a74c864676f2556$export$1363d1c8d6e714b5)(predicate)}-${idx}`))
        })
    });
};
var $88a60072f9aaa3d6$export$2e2bcd8739ae039 = $88a60072f9aaa3d6$var$ViewAttributeGroup;



parcelRequire("ieT14");
var $205a7ff7f2955c23$export$a15dbbd5464f0291;
$205a7ff7f2955c23$export$a15dbbd5464f0291 = `lrTyWG_includeExcludeHeader`;


/**
 * Renders an Included or Excluded header
 */ const $4044eb6d334b86b4$var$SegmentIncludeExcludeHeader = ({ isNew: isNew, exclude: exclude })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h2", {
        className: $205a7ff7f2955c23$export$a15dbbd5464f0291,
        children: `${exclude ? 'Exclude' : 'Include'}${isNew ? '' : 'd'}`
    });
};
var $4044eb6d334b86b4$export$2e2bcd8739ae039 = $4044eb6d334b86b4$var$SegmentIncludeExcludeHeader;





var $e1ONw = parcelRequire("e1ONw");

var $ieT14 = parcelRequire("ieT14");




var $j6s32 = parcelRequire("j6s32");
const $1b923a5b0142184d$var$useStyles = (0, $e1ONw.default)({
    headerMargin: {
        margin: 20,
        marginTop: 5
    },
    inputGrouping: {
        flexDirection: 'column'
    },
    segmentInfoRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 10
    },
    segmentName: {
        fontWeight: 600
    }
});
const $1b923a5b0142184d$var$ViewCompositionSelection = ({ composition: composition })=>{
    const classes = $1b923a5b0142184d$var$useStyles();
    const [selectionCollapsed, setSelectionCollapsed] = (0, $ieT14.useState)(false);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $365a06e4442a50da$export$55b973e094275b13), {
        title: "Optional: Segment Selection",
        collapsed: selectionCollapsed,
        onCollapse: setSelectionCollapsed,
        className: classes.headerMargin,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
            className: (0, $j6s32.default)($c7480ef281c02b11$export$7dc31a927bb1641e, classes.inputGrouping),
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    className: classes.segmentInfoRow,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                            children: [
                                "Selected Segment: ",
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                    className: classes.segmentName,
                                    children: composition.segmentName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                            className: $c7480ef281c02b11$export$890e38aac5063dc6,
                            children: [
                                "Total Customer: ",
                                composition.customers?.toLocaleString()
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    children: [
                        "Interaction: ",
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                            className: $c7480ef281c02b11$export$dbd72860f701d4f3,
                            children: (0, $a9d5bf712846139f$export$905dbc95765b1ada)[composition.segmentOperator]
                        })
                    ]
                })
            ]
        })
    });
};
var $1b923a5b0142184d$export$2e2bcd8739ae039 = $1b923a5b0142184d$var$ViewCompositionSelection;


/**
 * Render the segment attributes table in a view-only segment
 */ const $4e1477e19f32cf4c$var$ViewSegmentAttributes = ({ includedAttributes: includedAttributes, excludedAttributes: excludedAttributes, includeComposition: includeComposition, excludeComposition: excludeComposition })=>{
    const firstAttributeLabel = (attributes)=>JSON.stringify(attributes) === JSON.stringify(includedAttributes) ? 'Base Attribute' : 'Exclude';
    const isExclude = (attributes)=>JSON.stringify(attributes) === JSON.stringify(excludedAttributes);
    const includedAtt = {
        attributes: JSON.parse(JSON.stringify(includedAttributes)),
        composition: {
            ...includeComposition
        }
    };
    const excludedAtt = {
        attributes: JSON.parse(JSON.stringify(excludedAttributes)),
        composition: {
            ...excludeComposition
        }
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8991ead30e777b29$exports.Fragment), {
        children: [
            includedAtt,
            excludedAtt
        ].map((segmentAttributes)=>segmentAttributes && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4044eb6d334b86b4$export$2e2bcd8739ae039), {
                        isNew: false,
                        exclude: isExclude(segmentAttributes.attributes)
                    }),
                    !!segmentAttributes.composition?.segmentId && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1b923a5b0142184d$export$2e2bcd8739ae039), {
                        composition: segmentAttributes.composition
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: $c7480ef281c02b11$export$e7d47881ec916f76,
                        children: segmentAttributes.attributes.predicates.map((predicate, idx)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("ul", {
                                className: $c7480ef281c02b11$export$7dc31a927bb1641e,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
                                        className: (0, $j6s32.default)($c7480ef281c02b11$export$985c2484b69174d5, idx != 0 && $c7480ef281c02b11$export$dbd72860f701d4f3),
                                        children: idx == 0 ? firstAttributeLabel(segmentAttributes.attributes) : (0, $a9d5bf712846139f$export$905dbc95765b1ada)[segmentAttributes.attributes.operator]
                                    }),
                                    'attributeId' in predicate ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $35d9329663c8433e$export$2e2bcd8739ae039), {
                                        attribute: predicate,
                                        depth: 0
                                    }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $88a60072f9aaa3d6$export$2e2bcd8739ae039), {
                                        attributeGroup: predicate,
                                        depth: 0
                                    }),
                                    'customers' in predicate && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
                                        className: $c7480ef281c02b11$export$890e38aac5063dc6,
                                        children: `${predicate.customers.toLocaleString()} customers meet criteria`
                                    })
                                ]
                            }, `${(0, $6a74c864676f2556$export$1363d1c8d6e714b5)(predicate)}-${idx}`))
                    })
                ]
            }, isExclude(segmentAttributes.attributes) ? 'include' : 'exclude'))
    });
};
var $4e1477e19f32cf4c$export$2e2bcd8739ae039 = $4e1477e19f32cf4c$var$ViewSegmentAttributes;


const $8b1ea82366557785$var$useStyles = (0, $e1ONw.default)((theme)=>({
        selectInputs: {
            margin: '10px 12px',
            '& .MuiInputLabel-root': {
                backgroundColor: '#f8f8f8'
            },
            '& .MuiInputLabel-asterisk': {
                color: (0, $69ed148db7543104$export$8f45430ccf837300).rustRed
            }
        },
        headerMargin: {
            margin: 20,
            marginTop: 5
        },
        inputGrouping: {
            flexDirection: 'column'
        },
        segmentCompositionSelector: {
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            alignItems: 'center',
            '& .MuiInputBase-root': {
                width: '40%'
            }
        },
        previewSegment: {
            fontSize: 12,
            marginLeft: 10,
            cursor: 'pointer',
            color: (0, $69ed148db7543104$export$2aa0182783e7e9de)[600],
            border: 'none',
            padding: 0,
            background: 'none'
        },
        segmentOperatorSelector: {
            width: '15%'
        },
        rowInner: {
            backgroundColor: '#f8f8f8'
        },
        dialog: {
            [theme.breakpoints.up('sm')]: {
                '& .MuiDialog-paperWidthSm': {
                    width: '90%',
                    maxWidth: '90%',
                    height: '90%',
                    maxHeight: '90%'
                }
            }
        }
    }));
const $8b1ea82366557785$var$DependencyAlert = (0, $aIJrd.default)({
    root: {
        width: '55%',
        marginBottom: 0,
        marginLeft: 12
    }
})((0, $fgoQ6.SecondaryAlert));
const $8b1ea82366557785$var$defaultComposition = {
    segmentId: null,
    segmentOperator: (0, $a9d5bf712846139f$export$905dbc95765b1ada).And,
    customers: null,
    segmentName: ''
};
const $8b1ea82366557785$var$SegmentCompositionSelector = ({ exclude: exclude, isDependency: isDependency })=>{
    const dependencyMessage = 'You cannot select a segment because this segment is already used by other segments';
    const { segmentId: segmentId } = (0, $eYoAG.useParams)();
    const { selectedComoposition: selectedComoposition, changeSelectedComposition: changeSelectedComposition } = (0, $79aece72917dec2b$export$3260c0a5a28fb657)(exclude);
    const classes = $8b1ea82366557785$var$useStyles();
    const selectableSegments = (0, $12734a0bfffae223$export$2abf1296ffa2d8d5)(segmentId);
    const [selectionCollapsed, setSelectionCollapsed] = (0, $ieT14.useState)(false);
    const [selectedSegmentId, setSelectedSegmentId] = (0, $ieT14.useState)(selectedComoposition.segmentId?.toString() ?? '');
    const [selectedSegmentOperator, setSelectedSegmentOperator] = (0, $ieT14.useState)(selectedComoposition.segmentOperator?.toString() ?? '');
    const [segmentPreviewOpen, setSegmentPreviewOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useEffect(()=>{
        if (selectableSegments.data) {
            const selectedSegment = selectableSegments.data.find((data)=>data.segmentId.toString() === selectedSegmentId);
            changeSelectedComposition(selectedSegment?.segmentId ? {
                ...selectedSegment,
                segmentOperator: Number(selectedSegmentOperator)
            } : $8b1ea82366557785$var$defaultComposition);
        }
    }, [
        selectedSegmentId,
        selectedSegmentOperator
    ]);
    const removeCompositionSelection = ()=>{
        setSelectedSegmentId('');
        setSelectedSegmentOperator('');
    };
    const renderFilterValues = (value)=>{
        const segmentInfo = selectableSegments?.data.find((data)=>data.segmentId.toString() === value);
        if (!value || !segmentInfo) return '';
        return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
            className: $d3a6c5cfb2396086$export$ced7484dd0a65e67,
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1fc2eb6485c96dfd$export$522e6e3e785eb2cd), {
                label: segmentInfo.segmentName,
                size: "small",
                deleteIcon: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4leCF.default), {
                    onMouseDown: (event)=>event.stopPropagation(),
                    "aria-label": "remove segmentation"
                }),
                onDelete: removeCompositionSelection
            })
        });
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $365a06e4442a50da$export$55b973e094275b13), {
        title: "Optional: Segment Selection",
        collapsed: selectionCollapsed,
        onCollapse: setSelectionCollapsed,
        className: classes.headerMargin,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
            className: $4830ac0c4a56bbcf$export$120ff0929b202a6d,
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: classes.rowInner,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    className: (0, $j6s32.default)($4830ac0c4a56bbcf$export$995e14ef61d916e6, classes.inputGrouping),
                    children: [
                        isDependency && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($8b1ea82366557785$var$DependencyAlert, {
                            type: "info",
                            message: dependencyMessage
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
                            size: "small",
                            variant: "outlined",
                            className: (0, $j6s32.default)(classes.selectInputs, classes.segmentCompositionSelector),
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $Uxz4Y.default), {
                                    id: "segment-composition-selector-label",
                                    children: "Select a Segment"
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $aanJt.default), {
                                    labelId: "segment-composition-selector-label",
                                    label: "Select a Segment",
                                    id: "segment-composition-selector",
                                    renderValue: renderFilterValues,
                                    value: selectableSegments?.data && selectableSegments.data.length > 0 && selectedSegmentId ? selectedSegmentId : '',
                                    onChange: (e)=>{
                                        setSelectedSegmentId(e.target.value.toString());
                                        if (!selectedSegmentOperator) setSelectedSegmentOperator((0, $a9d5bf712846139f$export$905dbc95765b1ada).And.toString());
                                    },
                                    disabled: isDependency,
                                    children: [
                                        "``",
                                        selectableSegments?.data && selectableSegments.data.length > 0 && selectableSegments.data.map((segmentInfo)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $3mOXj.default), {
                                                value: segmentInfo.segmentId,
                                                children: [
                                                    segmentInfo.segmentName,
                                                    " - ",
                                                    segmentInfo.totalCustomers.toLocaleString(),
                                                    " customers"
                                                ]
                                            }, segmentInfo.segmentId))
                                    ]
                                }),
                                !!selectedSegmentId && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("button", {
                                    className: classes.previewSegment,
                                    onClick: ()=>setSegmentPreviewOpen(true),
                                    children: "PREVIEW SEGMENT"
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($8b1ea82366557785$var$SegmentPreview, {
                                    openDialog: segmentPreviewOpen,
                                    segmentId: selectedSegmentId,
                                    closePreview: ()=>setSegmentPreviewOpen(false)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
                            size: "small",
                            variant: "outlined",
                            className: (0, $j6s32.default)(classes.selectInputs, classes.segmentOperatorSelector),
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $Uxz4Y.default), {
                                    id: "segment-operator-selector-label",
                                    children: "Interaction"
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $aanJt.default), {
                                    labelId: "segment-operator-selector-label",
                                    label: "Select a Segment",
                                    id: "segment-operator-selector",
                                    value: selectedSegmentOperator,
                                    disabled: !selectedSegmentId || isDependency,
                                    onChange: (e)=>setSelectedSegmentOperator(e.target.value.toString()),
                                    children: [
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                            value: (0, $a9d5bf712846139f$export$905dbc95765b1ada).And,
                                            children: "And"
                                        }),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                            value: (0, $a9d5bf712846139f$export$905dbc95765b1ada).Or,
                                            children: "Or"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var $8b1ea82366557785$export$2e2bcd8739ae039 = $8b1ea82366557785$var$SegmentCompositionSelector;
const $8b1ea82366557785$var$SegmentPreview = ({ openDialog: openDialog, segmentId: segmentId, closePreview: closePreview })=>{
    const { segmentQuery: segmentQuery } = (0, $1517e00917d95652$export$204800eede9ea29f)(segmentId);
    const classes = $8b1ea82366557785$var$useStyles();
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $1c689a1559dbf5e9$export$2e2bcd8739ae039), {
        open: openDialog,
        className: classes.dialog,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6830d3674ad61fd5$export$2e2bcd8739ae039), {
                disableTypography: true,
                children: segmentQuery.data?.name ?? ''
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $881610d42277b808$export$2e2bcd8739ae039), {
                dividers: true,
                children: [
                    segmentQuery.isLoading && !segmentQuery.data && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: $246ccfbc8d89a664$export$46c1c92549715335,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
                    }),
                    segmentQuery.isError && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: $246ccfbc8d89a664$export$a3bc9b8ed74fc,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
                            type: "error",
                            message: `Failed to fetch segment`
                        })
                    }),
                    segmentQuery.data && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4e1477e19f32cf4c$export$2e2bcd8739ae039), {
                        excludedAttributes: segmentQuery.data.attributes.exclude,
                        includedAttributes: segmentQuery.data.attributes.include,
                        includeComposition: segmentQuery.data.composition?.include,
                        excludeComposition: segmentQuery.data.composition?.exclude
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $d176cc26269b23c2$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.TertiaryButton), {
                    text: "Close",
                    title: "Close",
                    component: "button",
                    handleClick: closePreview
                })
            })
        ]
    });
};


/**
 * Render a single row in the create segment view with select menus for attributes and filtering attributes
 *
 * The select menu value here serves as a button to open a custom dialog which can both set this select and add/remove
 * more AttributeRows and as a display of the row's currently selected attribute. The select menus in all rows have the
 * same options and open the same dialog. Nested groups within each row share their own dialogue with
 */ const $26eb53c3967ed768$var$AttributeRow = ({ predicate: predicate, required: required, handleOpen: handleOpen, handleDelete: handleDelete, order: order, exclude: exclude, isSubTransactional: isSubTransactional, isDependency: isDependency })=>{
    const { selectedAttributes: selectedAttributes, dispatch: dispatch } = (0, $79aece72917dec2b$export$7cea9ed133024a2d)(exclude);
    const attributesQuery = (0, $0ac9b016f561a44f$export$2e2bcd8739ae039)();
    const [groupConversionMenuOpen, setGroupConversionMenuOpen] = $ieT14.useState(false);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        className: $4830ac0c4a56bbcf$export$120ff0929b202a6d,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
            className: $4830ac0c4a56bbcf$export$913c2d8c9fd26aee,
            children: [
                order === 0 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8b1ea82366557785$export$2e2bcd8739ae039), {
                    exclude: exclude,
                    isDependency: isDependency
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    className: $4830ac0c4a56bbcf$export$cc1adf6fb659c762,
                    children: [
                        (order === 0 || order !== 1) && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                            className: $4830ac0c4a56bbcf$export$6b8b92a9240a8a67,
                            children: order === 0 ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("p", {
                                className: $4830ac0c4a56bbcf$export$bc3d4b1fe1693fc6,
                                children: !isSubTransactional ? exclude ? 'Exclude' : 'Base Attribute' : ''
                            }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("p", {
                                className: $4830ac0c4a56bbcf$export$f98f2d26ae95425a,
                                children: (0, $a9d5bf712846139f$export$905dbc95765b1ada)[selectedAttributes.operator]
                            })
                        }),
                        order === 1 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $0e860a8a329fdc63$export$2e2bcd8739ae039), {
                            operator: selectedAttributes.operator,
                            handleChange: (operator)=>dispatch({
                                    type: 'updateOperator',
                                    operator: operator,
                                    position: []
                                })
                        }),
                        predicate === undefined && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $43ac9fa9eea2010a$export$2e2bcd8739ae039), {
                            selectedAttribute: undefined,
                            required: required,
                            handleDelete: handleDelete,
                            handleOpen: handleOpen,
                            handleAddToGroup: ()=>{},
                            position: [],
                            exclude: exclude,
                            attributeIndex: order
                        }),
                        predicate !== undefined && ('attributeId' in predicate ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $43ac9fa9eea2010a$export$2e2bcd8739ae039), {
                                    selectedAttribute: predicate,
                                    required: required,
                                    handleDelete: handleDelete,
                                    handleOpen: handleOpen,
                                    handleAddToGroup: ()=>setGroupConversionMenuOpen(true),
                                    position: [],
                                    exclude: exclude,
                                    attributeIndex: order
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $b0ee6880b35b2190$export$2e2bcd8739ae039), {
                                    open: groupConversionMenuOpen,
                                    onApply: (checked)=>{
                                        if (checked.length > 0) dispatch({
                                            type: 'convertAttributeToGroup',
                                            attribute: predicate,
                                            newGroupAttributeIds: checked,
                                            attributes: attributesQuery.data.attributes
                                        });
                                    },
                                    onCancel: ()=>setGroupConversionMenuOpen(false)
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $e81f9e81ac1d6ecd$export$2e2bcd8739ae039), {
                            attributeGroup: predicate,
                            position: [
                                order
                            ],
                            exclude: exclude
                        }))
                    ]
                }),
                predicate && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $d0801aa0edace1ae$export$2e2bcd8739ae039), {
                    order: order,
                    exclude: exclude
                })
            ]
        })
    });
};
var $26eb53c3967ed768$export$2e2bcd8739ae039 = /*#__PURE__*/ $ieT14.memo($26eb53c3967ed768$var$AttributeRow);








/**
 * Main component for the Build Segment section of the Create New Segment view, renders the rows of attribute
 * select and filter inputs and the attribute selection dialog.
 */ const $9fed084411757902$var$BuildSegment = ({ isNew: isNew, exclude: exclude, isDependency: isDependency })=>{
    const { selectedAttributes: selectedAttributes, dispatch: dispatch } = (0, $79aece72917dec2b$export$7cea9ed133024a2d)(exclude);
    const [dialogOpen, setDialogOpen] = $ieT14.useState(false);
    const attributesQuery = (0, $0ac9b016f561a44f$export$2e2bcd8739ae039)();
    /** Prevent select input from opening default menu, open alternative dialog */ const handleOpen = ()=>{
        setDialogOpen(true);
    };
    const handleCancel = ()=>{
        setDialogOpen(false);
    };
    /** Update `selectedAttributes`, maintaining the order of `checked.current` and any previously selected filter options */ const handleApply = (checked)=>{
        if (checked.length === 1) dispatch({
            type: 'applyAttributes',
            checked: checked,
            attributes: attributesQuery.data.attributes,
            position: []
        });
        if (checked.length > 1) dispatch({
            type: 'addNewBaseGroup',
            newGroupAttributeIds: checked,
            attributes: attributesQuery.data.attributes
        });
        setDialogOpen(false);
    };
    /** Remove a single attribute from both selected attributes via delete icon */ const handleDelete = (attributeId, attributeIndex)=>{
        dispatch({
            type: 'deleteAttribute',
            attributeId: attributeId,
            position: [],
            attributeIndex: attributeIndex
        });
    };
    const emptyAttributes = (buildAttributes)=>{
        if ('predicates' in buildAttributes) return buildAttributes.predicates.every(emptyAttributes);
        else return buildAttributes.length === 0;
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4044eb6d334b86b4$export$2e2bcd8739ae039), {
                isNew: isNew,
                exclude: exclude
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $d3a6c5cfb2396086$export$149f03f7aebc2e19,
                children: [
                    selectedAttributes?.predicates.every(emptyAttributes) ? /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $26eb53c3967ed768$export$2e2bcd8739ae039), {
                        required: true,
                        handleOpen: handleOpen,
                        handleDelete: handleDelete,
                        order: 0,
                        exclude: exclude,
                        isDependency: isDependency
                    }) : selectedAttributes?.predicates.map((predicate, idx)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $26eb53c3967ed768$export$2e2bcd8739ae039), {
                            predicate: predicate,
                            required: idx === 0,
                            handleOpen: handleOpen,
                            handleDelete: handleDelete,
                            order: idx,
                            exclude: exclude,
                            isDependency: isDependency
                        }, `attribute-row-${(0, $6a74c864676f2556$export$1363d1c8d6e714b5)(predicate)}-${idx}`)),
                    selectedAttributes?.predicates.length > 0 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $b1c3fceec5a3a004$export$2e2bcd8739ae039), {
                        label: "Add Group",
                        handleClick: handleOpen
                    }),
                    selectedAttributes && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $b0ee6880b35b2190$export$2e2bcd8739ae039), {
                        open: dialogOpen,
                        onCancel: handleCancel,
                        onApply: handleApply
                    })
                ]
            })
        ]
    });
};
var $9fed084411757902$export$2e2bcd8739ae039 = /*#__PURE__*/ $ieT14.memo($9fed084411757902$var$BuildSegment);





const $a84c717865e82d71$var$breadcrumbs = [
    {
        title: 'Segments',
        path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Segments
    }
];
/**
 * Create New Segment view
 * Interface rendered to create a new segment from scratch
 */ const $a84c717865e82d71$var$CreateSegment = ()=>{
    const history = (0, $eYoAG.useHistory)();
    const { search: search } = (0, $eYoAG.useLocation)();
    const clonedId = new URLSearchParams(search);
    const { segmentQuery: segmentQuery } = (0, $1517e00917d95652$export$204800eede9ea29f)(clonedId.get('clonedId'));
    const segmentMutation = (0, $ad0226f2a2576692$export$60a89511ea3568e3)();
    const [detailsCollapsed, setDetailsCollapsed] = $ieT14.useState(false);
    const [buildCollapsed, setBuildCollapsed] = $ieT14.useState(false);
    const [name, setName] = $ieT14.useState('');
    const [description, setDescription] = $ieT14.useState('');
    const [shared, setShared] = $ieT14.useState('Do not share');
    const [includedAttributes, dispatch] = $ieT14.useReducer((0, $79aece72917dec2b$export$86e9f3b355bd161d), {
        operator: (0, $a9d5bf712846139f$export$905dbc95765b1ada).And,
        predicates: []
    });
    const [excludedAttributes, excludedDispatch] = $ieT14.useReducer((0, $79aece72917dec2b$export$86e9f3b355bd161d), {
        operator: (0, $a9d5bf712846139f$export$905dbc95765b1ada).And,
        predicates: []
    });
    const [includeSegmentComposition, setIncludeSegmentComposition] = $ieT14.useState({
        segmentId: null,
        segmentOperator: null,
        customers: null,
        segmentName: ''
    });
    const [excludeSegmentComposition, setExcludeSegmentComposition] = $ieT14.useState({
        segmentId: null,
        segmentOperator: null,
        customers: null,
        segmentName: ''
    });
    const clonedSegment = $ieT14.useRef(!!clonedId?.get('clonedId'));
    const { getCurrentUser: getCurrentUser } = (0, $b19aa392df0f3838$export$2e2bcd8739ae039)();
    const userName = $ieT14.useRef('');
    $ieT14.useEffect(()=>{
        checkUser();
    }, []);
    const checkUser = async ()=>{
        try {
            const currentUser = await getCurrentUser();
            userName.current = `${currentUser.firstName} ${currentUser.lastName}`;
        } catch  {
            userName.current = '';
        }
    };
    $ieT14.useEffect(()=>{
        if (segmentQuery.data) {
            setName(`Copy of ${segmentQuery.data.name}`);
            setDescription(segmentQuery.data.description);
            setShared(segmentQuery.data.isShared ? 'Share' : 'Do not share');
            dispatch({
                type: 'setAttributes',
                attributes: segmentQuery.data.selectedAttributes.include
            });
            excludedDispatch({
                type: 'setAttributes',
                attributes: segmentQuery.data.selectedAttributes.exclude
            });
            if (segmentQuery.data.composition?.include) setIncludeSegmentComposition({
                segmentId: segmentQuery.data.composition.include.segmentId,
                segmentOperator: segmentQuery.data.composition.include.segmentOperator,
                customers: segmentQuery.data.composition.include.customers,
                segmentName: segmentQuery.data.composition.include.segmentName
            });
            if (segmentQuery.data.composition?.exclude) setExcludeSegmentComposition({
                segmentId: segmentQuery.data.composition.exclude.segmentId,
                segmentOperator: segmentQuery.data.composition.exclude.segmentOperator,
                customers: segmentQuery.data.composition.exclude.customers,
                segmentName: segmentQuery.data.composition.exclude.segmentName
            });
            clonedSegment.current = true;
        }
    }, [
        segmentQuery.data
    ]);
    function createSegment() {
        let selectedComposition = {};
        if (includeSegmentComposition.segmentId) selectedComposition = {
            include: includeSegmentComposition
        };
        if (excludeSegmentComposition.segmentId) selectedComposition = {
            ...selectedComposition,
            exclude: excludeSegmentComposition
        };
        segmentMutation.mutate({
            name: name,
            description: description,
            isShared: shared == 'Share',
            attributes: {
                include: includedAttributes,
                exclude: excludedAttributes
            },
            composition: {
                ...selectedComposition
            }
        }, {
            onSuccess: ()=>{
                includedAttributes.predicates.forEach((att)=>{
                    logCreatedAttributes(att);
                });
                excludedAttributes.predicates.forEach((att)=>{
                    logCreatedAttributes(att);
                });
                history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Segments);
            }
        });
    }
    const logCreatedAttributes = (included)=>{
        if ('predicates' in included) included.predicates.forEach((att)=>{
            logCreatedAttributes(att);
        });
        else (0, $80940237791545d7$export$65cc181beb0d2632).addUserAction('create-segment', {
            user_action_details: {
                segment_id: 'new segment',
                segment_name: name,
                is_segment_shared: shared,
                user_name: userName.current,
                attribute: included.name
            }
        });
    };
    const buildIncludeSelectedCompositionObj = $ieT14.useMemo(()=>({
            selectedComoposition: includeSegmentComposition,
            changeSelectedComposition: setIncludeSegmentComposition
        }), [
        includeSegmentComposition,
        setIncludeSegmentComposition
    ]);
    const buildExcludeSelectedCompositionObj = $ieT14.useMemo(()=>({
            selectedComoposition: excludeSegmentComposition,
            changeSelectedComposition: setExcludeSegmentComposition
        }), [
        excludeSegmentComposition,
        setExcludeSegmentComposition
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $adc248bb409000ee$export$e8e78c978b129247,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.Breadcrumbs), {
                breadcrumbs: $a84c717865e82d71$var$breadcrumbs,
                currentPage: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h1", {
                    children: "Create New Segment"
                }),
                className: $8caa2dfa516972d4$export$a40ebde8ba896166
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $adc248bb409000ee$export$a3bc9b8ed74fc,
                children: segmentMutation.isError && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
                    type: "error",
                    message: segmentMutation.error.message
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $365a06e4442a50da$export$55b973e094275b13), {
                title: "Enter Segment Details",
                collapsed: detailsCollapsed,
                onCollapse: setDetailsCollapsed,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $17b3f83bdc759c12$export$2e2bcd8739ae039), {
                    name: name,
                    description: description,
                    shared: shared,
                    onNameChange: setName,
                    onDescriptionChange: setDescription,
                    onSharedChange: setShared,
                    isClonedSegment: clonedSegment.current
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $365a06e4442a50da$export$55b973e094275b13), {
                title: "Summary",
                collapsed: buildCollapsed,
                onCollapse: setBuildCollapsed,
                className: $adc248bb409000ee$export$665e0f4515a68234,
                secondaryAction: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4d5deb8da6079694$export$2e2bcd8739ae039), {
                    name: name,
                    includedAttributes: includedAttributes,
                    excludedAttributes: excludedAttributes,
                    segmentId: '',
                    segmentShared: shared,
                    userName: userName.current
                }),
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($ieT14.Fragment, {
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $79aece72917dec2b$export$917e8dab6495b1e6).Provider, {
                        value: {
                            selectedAttributes: includedAttributes,
                            dispatch: dispatch
                        },
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $79aece72917dec2b$export$f754003632709cde).Provider, {
                            value: {
                                selectedAttributes: excludedAttributes,
                                dispatch: excludedDispatch
                            },
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $79aece72917dec2b$export$fe31d6c99f271165).Provider, {
                                value: buildIncludeSelectedCompositionObj,
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $79aece72917dec2b$export$d84346a295b37585).Provider, {
                                    value: buildExcludeSelectedCompositionObj,
                                    children: [
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $733f69a6c8a00721$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $9fed084411757902$export$2e2bcd8739ae039), {
                                            isNew: true
                                        }),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $9fed084411757902$export$2e2bcd8739ae039), {
                                            isNew: true,
                                            exclude: true
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $adc248bb409000ee$export$c4cc592d9243d26f,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.TertiaryButton), {
                        component: "button",
                        text: "Cancel",
                        title: "Cancel",
                        handleClick: ()=>{
                            history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Segments);
                        }
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.PrimaryButton), {
                        text: "Save Segment",
                        title: "Save Segment",
                        handleClick: createSegment,
                        deactive: name.length === 0 || description.length === 0 || includedAttributes.predicates.length === 0 && excludedAttributes.predicates.length === 0 || shared === ''
                    })
                ]
            })
        ]
    });
};
var $a84c717865e82d71$export$2e2bcd8739ae039 = $a84c717865e82d71$var$CreateSegment;




var $lwgYO = parcelRequire("lwgYO");

var $ieT14 = parcelRequire("ieT14");





var $b6cae2dd779d4f78$export$2ef47a058bb9473c = /*#__PURE__*/ function(SegmentSortFields) {
    SegmentSortFields["Team"] = "clientName";
    SegmentSortFields["Name"] = "name";
    SegmentSortFields["LastModified"] = "lastModifiedDate";
    SegmentSortFields["CreatedBy"] = "createdByName";
    SegmentSortFields["Customers"] = "customers";
    SegmentSortFields["Sharing"] = "isShared";
    return SegmentSortFields;
}({});
const $b6cae2dd779d4f78$var$defaultActiveFiltersAdmin = {
    ...(0, $8b17776987f48cd0$export$82e642b0d625c931),
    teams: []
};
const $b6cae2dd779d4f78$var$adminSegmentsHeaders = [
    {
        title: 'Team',
        orderField: "clientName"
    },
    ...(0, $8b17776987f48cd0$export$3f583c8dc8ad42b7)
];
const $b6cae2dd779d4f78$var$initialSortState = {
    page: 1,
    pageSize: 15,
    orderColumn: "lastModifiedDate",
    orderDirection: 'desc'
};
/**
 * In admin/management portal, view table of all created segments by any user
 */ const $b6cae2dd779d4f78$var$AdminSegments = ()=>{
    const [activeFilters, setActiveFilters] = $ieT14.useState($b6cae2dd779d4f78$var$defaultActiveFiltersAdmin);
    const filtersQuery = (0, $5255668c33a98545$export$b9ffd2bb384f6d1b)();
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $246ccfbc8d89a664$export$e8e78c978b129247,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $246ccfbc8d89a664$export$38e42c68cf43b5d4,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h1", {
                    children: "Segments"
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $lwgYO.default), {
                elevation: 1,
                className: $246ccfbc8d89a664$export$914772be44022da8,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $a9c90e42e1f0237c$export$2e2bcd8739ae039), {
                        setActiveFilters: setActiveFilters,
                        defaultActiveFilters: $b6cae2dd779d4f78$var$defaultActiveFiltersAdmin,
                        isLoading: filtersQuery.isLoading,
                        loadedFilters: filtersQuery.data
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $0dcf413cd3c5adee$export$2e2bcd8739ae039), {
                        columnHeaders: $b6cae2dd779d4f78$var$adminSegmentsHeaders,
                        initialSortState: $b6cae2dd779d4f78$var$initialSortState,
                        activeFilters: activeFilters
                    })
                ]
            })
        ]
    });
};
var $b6cae2dd779d4f78$export$2e2bcd8739ae039 = $b6cae2dd779d4f78$var$AdminSegments;




var $ieT14 = parcelRequire("ieT14");

var $eYoAG = parcelRequire("eYoAG");



/**
 * Wrapper around fan segmentation routes to prevent users without access from navigating to segmentation pages directly
 */ const $1b5cf9b2bde9348f$var$SegmentsRoutesWrapper = ({ children: children })=>{
    const { state: state } = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const clientsQuery = (0, $f54f7d0a50104e94$export$4823a6cc022cca16)();
    const currentClient = $ieT14.useMemo(()=>{
        if (clientsQuery.data && state.clientId) return clientsQuery.data.results.find((client)=>client.clientId === state.clientId);
    }, [
        state,
        clientsQuery.data
    ]);
    if (!currentClient) return null;
    if (currentClient && !currentClient.enableSegmentation) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Redirect), {
        to: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Reports
    });
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($ieT14.Fragment, {
        children: children
    });
};
var $1b5cf9b2bde9348f$export$2e2bcd8739ae039 = $1b5cf9b2bde9348f$var$SegmentsRoutesWrapper;




var $fpdl2 = parcelRequire("fpdl2");
var $whS22 = parcelRequire("whS22");
var $knRao = parcelRequire("knRao");
var $Uxz4Y = parcelRequire("Uxz4Y");
var $e1ONw = parcelRequire("e1ONw");
var $3mOXj = parcelRequire("3mOXj");
var $aanJt = parcelRequire("aanJt");
var $eYT2J = parcelRequire("eYT2J");

var $kfphy = parcelRequire("kfphy");

var $ieT14 = parcelRequire("ieT14");

var $ieT14 = parcelRequire("ieT14");



function $2cc14d441a2df122$export$49199fe9925bd982() {
    const appState = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    return (0, $137a3b252d598119$export$dd0a697e1782aedd)([
        'push-destinations',
        appState.state.clientId
    ], ()=>{
        return fetchWrapper(`api/${appState.state.clientId}/push-destinations`);
    });
}
function $2cc14d441a2df122$export$7fa8c342159b8c73(pushDestinationId, clientId) {
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    return (0, $137a3b252d598119$export$dd0a697e1782aedd)([
        'campaign-term',
        clientId,
        pushDestinationId
    ], ()=>{
        return fetchWrapper(`api/${clientId}/push-destinations/${pushDestinationId}/campaign-term`, {
            method: 'GET'
        }, 'text');
    }, {
        enabled: !!pushDestinationId
    });
}
function $2cc14d441a2df122$export$8d6f84febf768661(pushDestinationId, tableSort, searchValue) {
    const appState = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    let query = `Page=${tableSort.page}` + `&PageSize=${tableSort.pageSize}` + `&Sort=${tableSort.orderColumn}` + `&SortDirection=${tableSort.orderDirection}`;
    if (searchValue) query += `&SearchTerm=${searchValue}`;
    return (0, $137a3b252d598119$export$dd0a697e1782aedd)([
        'campaign-list',
        appState.state.clientId,
        pushDestinationId,
        tableSort,
        searchValue
    ], ()=>{
        return fetchWrapper(`api/${appState.state.clientId}/push-destinations/${pushDestinationId}/campaigns?${query}`);
    }, {
        enabled: !!pushDestinationId
    });
}
function $2cc14d441a2df122$export$4603fea083d1f8ca() {
    const appState = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    const queryClient = (0, $7fd0e6909adb481d$export$22e77b9572c4fded)();
    return (0, $34ef30a348505f7e$export$609860bf8b0084c)((pushDetails)=>{
        const { pushDestinationId: pushDestinationId, campaignId: campaignId, campaignName: campaignName, segmentId: segmentId, isOneTime: isOneTime } = pushDetails;
        return fetchWrapper(`api/${appState.state.clientId}/push-destinations/${pushDestinationId}/campaigns/${campaignId}/push/${segmentId}`, {
            method: 'POST',
            body: JSON.stringify({
                campaignName: campaignName,
                isOneTime: isOneTime
            })
        });
    }, {
        onSuccess: ()=>queryClient.invalidateQueries([
                'push-history'
            ])
    });
}
function $2cc14d441a2df122$export$a5fa6e09294ac637(segmentId, tableSort, searchValue) {
    const appState = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    let query = `Page=${tableSort.page}` + `&PageSize=${tableSort.pageSize}` + `&Sort=${tableSort.orderColumn}` + `&SortDirection=${tableSort.orderDirection}`;
    if (searchValue) query += `&SearchTerm=${searchValue}`;
    return (0, $137a3b252d598119$export$dd0a697e1782aedd)([
        'push-history',
        appState.state.clientId,
        segmentId,
        tableSort,
        searchValue
    ], ()=>{
        return fetchWrapper(`api/${appState.state.clientId}/segments/${segmentId}/push-history?${query}`);
    }, {
        enabled: !!segmentId
    });
}
function $2cc14d441a2df122$export$48fcf5586cfec2ef(segmentId, pushId, tableSort, searchValue) {
    const appState = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    let query = `Page=${tableSort.page}` + `&PageSize=${tableSort.pageSize}` + `&Sort=${tableSort.orderColumn}` + `&SortDirection=${tableSort.orderDirection}`;
    if (searchValue) query += `&SearchTerm=${searchValue}`;
    return (0, $137a3b252d598119$export$dd0a697e1782aedd)([
        'push-runs',
        appState.state.clientId,
        pushId,
        segmentId,
        tableSort,
        searchValue
    ], ()=>{
        return fetchWrapper(`api/${appState.state.clientId}/segments/${segmentId}/push-history/${pushId}?${query}`);
    }, {
        enabled: !!segmentId && !!pushId
    });
}
function $2cc14d441a2df122$export$a9cd06f95aedc027() {
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    const queryClient = (0, $7fd0e6909adb481d$export$22e77b9572c4fded)();
    return (0, $34ef30a348505f7e$export$609860bf8b0084c)((pushDetails)=>{
        const { segmentId: segmentId, pushId: pushId, clientId: clientId } = pushDetails;
        return fetchWrapper(`api/${clientId}/segments/${segmentId}/push-history/${pushId}/stop`, {
            method: 'PUT'
        });
    }, {
        onSuccess: (results)=>{
            if (results.success) queryClient.invalidateQueries([
                'push-runs'
            ]);
        }
    });
}



var $fgoQ6 = parcelRequire("fgoQ6");




var $j6s32 = parcelRequire("j6s32");


var $eYoAG = parcelRequire("eYoAG");




var $ieT14 = parcelRequire("ieT14");

var $fpdl2 = parcelRequire("fpdl2");
var $e1ONw = parcelRequire("e1ONw");
var $356Vi = parcelRequire("356Vi");

var $1vmhz = parcelRequire("1vmhz");


var $fgoQ6 = parcelRequire("fgoQ6");


var $eYoAG = parcelRequire("eYoAG");


const $34fc1605bcad7d00$var$defaultBreadCrumbs = [
    {
        title: 'Segments',
        path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Segments
    }
];
const $34fc1605bcad7d00$var$useStyles = (0, $e1ONw.default)({
    circularProgress: {
        display: 'block',
        '& svg.MuiCircularProgress-svg': {
            margin: 0
        }
    },
    errorIcon: {
        fontSize: 20,
        color: (0, $69ed148db7543104$export$471f7ae5c4103ae1).error.medium,
        '&.MuiSvgIcon-root': {
            margin: 0
        }
    }
});
const $34fc1605bcad7d00$var$PushSegmentBreadcrumbs = ({ currentPage: currentPage })=>{
    const overrides = $34fc1605bcad7d00$var$useStyles();
    const { segmentId: segmentId } = (0, $eYoAG.useParams)();
    const { segmentQuery: segmentQuery } = (0, $1517e00917d95652$export$204800eede9ea29f)(segmentId);
    const [breadCrumbs, setBreadCrumbs] = $ieT14.useState($34fc1605bcad7d00$var$defaultBreadCrumbs);
    $ieT14.useEffect(()=>{
        if (segmentQuery.data) setBreadCrumbs([
            {
                title: 'Segments',
                path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Segments
            },
            {
                title: segmentQuery.data.name,
                path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Segment.replace(':segmentId', segmentId)
            }
        ]);
    }, [
        segmentQuery.data
    ]);
    function currentBreadcrumb() {
        if (segmentQuery.isError) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $356Vi.default), {
            title: "Segment title failed to load",
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1vmhz.default), {
                className: overrides.errorIcon
            })
        });
        if (segmentQuery.isLoading) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {
            size: "20px",
            className: overrides.circularProgress
        });
        if (segmentQuery.data) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
            className: $8caa2dfa516972d4$export$38e42c68cf43b5d4,
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h1", {
                children: currentPage
            })
        });
    }
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.Breadcrumbs), {
        breadcrumbs: breadCrumbs,
        currentPage: currentBreadcrumb(),
        className: $8caa2dfa516972d4$export$a40ebde8ba896166
    });
};
var $34fc1605bcad7d00$export$2e2bcd8739ae039 = $34fc1605bcad7d00$var$PushSegmentBreadcrumbs;






const $3658a2d28fd0ba5c$var$useStyles = (0, $e1ONw.default)((theme)=>({
        dialog: {
            [theme.breakpoints.up('sm')]: {
                '& .MuiDialog-paperWidthSm': {
                    width: '95rem',
                    maxWidth: '95rem'
                }
            }
        },
        dialogContent: {
            padding: 0
        },
        dialogActions: {
            justifyContent: 'space-between',
            height: 57,
            padding: '0 24px'
        },
        searchBar: {
            width: 180
        },
        tableRow: {
            cursor: 'pointer'
        },
        tableHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '10px 30px 0'
        },
        pushHistoryLabel: {
            color: '#074F86',
            textTransform: 'none',
            textDecoration: 'underline',
            fontSize: '12px'
        },
        pushPagination: {
            display: 'flex',
            justifyContent: 'center'
        },
        sourceSystem: {
            fontWeight: 'normal'
        },
        pushMessage: {
            position: 'absolute',
            top: '20px',
            left: '30%'
        },
        inputs: {
            margin: '15px 0',
            '& .MuiInputLabel-asterisk': {
                color: (0, $69ed148db7543104$export$8f45430ccf837300).rustRed
            }
        },
        attributeSelect: {
            width: '360px'
        },
        header: {
            display: 'flex',
            marginBottom: '8px',
            borderBottom: '1px solid #979797'
        },
        title: {
            color: (0, $69ed148db7543104$export$a4867fe9454f37a8)[600],
            fontSize: 18,
            fontWeight: 600,
            margin: '8px 0',
            lineHeight: '1em'
        },
        wizardMain: {
            padding: '25px',
            display: 'flex',
            flexDirection: 'column',
            minHeight: '90%'
        },
        wizardContainer: {
            padding: '25px',
            display: 'flex',
            flexDirection: 'column',
            height: '80%'
        },
        selectionContainer: {
            padding: '20px 0',
            display: 'flex',
            flexDirection: 'column'
        },
        selectionTitle: {
            fontSize: '16px',
            fontWeight: 500
        },
        campaignInput: {
            '& .MuiOutlinedInput-input': {
                paddingTop: '10.5px',
                paddingBottom: '10.5px',
                cursor: 'pointer'
            }
        },
        emptyInput: {
            '& .MuiInputLabel-outlined': {
                transform: 'translate(14px, 12px) scale(1)'
            }
        }
    }));
var $3658a2d28fd0ba5c$var$PushType = /*#__PURE__*/ function(PushType) {
    PushType[PushType["Single"] = 1] = "Single";
    PushType[PushType["Automatic"] = 2] = "Automatic";
    return PushType;
}($3658a2d28fd0ba5c$var$PushType || {});
const $3658a2d28fd0ba5c$var$PushSegment = ({ history: history })=>{
    const { segmentId: segmentId } = (0, $eYoAG.useParams)();
    const { segmentQuery: segmentQuery } = (0, $1517e00917d95652$export$204800eede9ea29f)(segmentId);
    const [selectedDestination, setSelectedDestination] = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useState(null);
    const [selectedCampaign, setSelectedCampaign] = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useState(null);
    const [campaignMenuOpen, setCampaignMenuOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useState(false);
    const [pushType, setPushType] = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useState('');
    const [campaignTerm, setCampaignTerm] = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useState('Campaign');
    const classes = $3658a2d28fd0ba5c$var$useStyles();
    const { errorMessage: errorMessage, setErrorMessage: setErrorMessage } = (0, $dc97b0794e0fd33b$export$2e2bcd8739ae039)();
    const pushSelectedCampaign = (0, $2cc14d441a2df122$export$4603fea083d1f8ca)();
    const clientsQuery = (0, $f54f7d0a50104e94$export$4823a6cc022cca16)();
    const { state: state } = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const campaignTermQuery = (0, $2cc14d441a2df122$export$7fa8c342159b8c73)(selectedDestination?.pushDestinationId.toString(), state?.clientId.toString());
    const userName = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useRef('');
    const segmentName = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useRef('');
    const segmentShare = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useRef('');
    (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useEffect(()=>{
        if (segmentQuery.data) {
            segmentName.current = segmentQuery.data.name;
            segmentShare.current = segmentQuery.data.isShared ? 'Share' : 'Do not share';
        }
    }, [
        segmentQuery.data
    ]);
    const currentClient = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useMemo(()=>{
        userName.current = `${state.firstName} ${state.lastName}`;
        if (clientsQuery.data && state.clientId) return clientsQuery.data.results.find((client)=>client.clientId === state.clientId);
    }, [
        state.clientId,
        clientsQuery.data
    ]);
    const pushDestinations = (0, $2cc14d441a2df122$export$49199fe9925bd982)();
    const selectDestionation = (destinationId)=>{
        const newDestination = pushDestinations.data?.find((pd)=>pd.pushDestinationId === destinationId);
        setSelectedDestination(newDestination ? newDestination : null);
        setSelectedCampaign(null);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useEffect(()=>{
        if (campaignTermQuery.data) setCampaignTerm(campaignTermQuery.data);
    }, [
        campaignTermQuery.data
    ]);
    const createPush = ()=>{
        pushSelectedCampaign.mutate({
            pushDestinationId: selectedDestination.pushDestinationId,
            campaignId: selectedCampaign.id,
            campaignName: selectedCampaign.name,
            segmentId: segmentId,
            isOneTime: pushType !== 2
        }, {
            onSuccess () {
                (0, $80940237791545d7$export$65cc181beb0d2632).addUserAction('push-segment', {
                    user_action_details: {
                        segment_id: segmentId,
                        segment_name: segmentName.current,
                        is_segment_shared: segmentShare.current,
                        user_name: userName.current,
                        system: selectedDestination.displayName,
                        campaignId: selectedCampaign.id
                    }
                });
                history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).SegmentPushes.replace(':segmentId', segmentId));
            },
            onError () {
                setErrorMessage('There was an error creating the push');
            }
        });
    };
    const canUseAutomaticPush = ()=>{
        return currentClient?.enableAutomaticPushes && selectedDestination?.supportsAutomaticPushes;
    };
    const invalidPush = ()=>{
        const validPushType = !canUseAutomaticPush() || !!pushType;
        return !selectedDestination || !selectedCampaign || !validPushType;
    };
    const getCampaignLabel = ()=>{
        const regex = new RegExp(/^[aeiou]/i);
        return regex.test(campaignTerm) ? `Select an ${campaignTerm}` : `Select a ${campaignTerm}`;
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).Fragment, {
        children: [
            errorMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: classes.pushMessage,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
                    type: "error",
                    message: errorMessage
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $246ccfbc8d89a664$export$e8e78c978b129247,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $34fc1605bcad7d00$export$2e2bcd8739ae039), {
                        currentPage: 'Create New Push'
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        className: classes.wizardMain,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                className: classes.header,
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h2", {
                                    className: classes.title,
                                    children: "Push Configuration"
                                })
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("section", {
                                className: classes.wizardContainer,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                        className: classes.selectionContainer,
                                        children: [
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                                className: classes.selectionTitle,
                                                children: "Which system do you want to push to?"
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
                                                size: "small",
                                                variant: "outlined",
                                                className: (0, $j6s32.default)(classes.inputs, classes.attributeSelect),
                                                required: true,
                                                children: [
                                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $Uxz4Y.default), {
                                                        id: "system-selection",
                                                        children: "Select a System"
                                                    }),
                                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $aanJt.default), {
                                                        labelId: "system-selection",
                                                        value: selectedDestination ? String(selectedDestination.pushDestinationId) : '',
                                                        onChange: (event)=>selectDestionation(event.target.value),
                                                        children: pushDestinations.data?.map((destination)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3mOXj.default), {
                                                                value: destination.pushDestinationId,
                                                                children: destination.displayName
                                                            }, `Destination-Option-${destination.pushDestinationId}`))
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                        className: classes.selectionContainer,
                                        children: [
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                                className: classes.selectionTitle,
                                                children: [
                                                    "Which ",
                                                    campaignTerm,
                                                    " do you want to push to?"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $whS22.default), {
                                                size: "small",
                                                variant: "outlined",
                                                className: (0, $j6s32.default)(classes.inputs, classes.attributeSelect),
                                                required: true,
                                                children: [
                                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYT2J.default), {
                                                        required: true,
                                                        id: "outlined-read-only-input",
                                                        label: getCampaignLabel(),
                                                        value: selectedCampaign?.name ?? '',
                                                        onClick: ()=>{
                                                            if (selectedDestination) setCampaignMenuOpen(true);
                                                        },
                                                        InputProps: {
                                                            readOnly: true,
                                                            endAdornment: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $kfphy.default), {})
                                                        },
                                                        variant: "outlined",
                                                        disabled: !selectedDestination,
                                                        className: (0, $j6s32.default)(classes.campaignInput, selectedCampaign ? '' : classes.emptyInput)
                                                    }),
                                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($3658a2d28fd0ba5c$var$CampaignMenu, {
                                                        openDialog: campaignMenuOpen,
                                                        destinationId: selectedDestination?.pushDestinationId,
                                                        destinationTitle: selectedDestination?.displayName,
                                                        cancelPush: ()=>setCampaignMenuOpen(false),
                                                        pushToCampaign: (newSelectedCampaign)=>{
                                                            let campaignId = '';
                                                            let campaignName = '';
                                                            // The keys coming back from the Integration API aren't always the same casing but the keys we are looking for are the same
                                                            // Doing this step to find the information we need to send when creating a new push
                                                            Object.keys(newSelectedCampaign).forEach((key)=>{
                                                                if (key.toLocaleLowerCase() === 'id') campaignId = newSelectedCampaign[key];
                                                                if (key.toLocaleLowerCase() === 'name') campaignName = newSelectedCampaign[key];
                                                            });
                                                            setSelectedCampaign({
                                                                id: campaignId,
                                                                name: campaignName
                                                            });
                                                            setCampaignMenuOpen(false);
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    canUseAutomaticPush() && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                                className: classes.selectionTitle,
                                                children: "How often do you want to push?"
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $62bbd6cebee2ba4a$export$2e2bcd8739ae039), {
                                                "aria-label": "push-type",
                                                name: "push-type",
                                                value: pushType,
                                                onChange: (event)=>{
                                                    setPushType(Number(event.target.value));
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $knRao.default), {
                                                        value: 1,
                                                        control: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $141807cd97d66e4d$export$2e2bcd8739ae039), {}),
                                                        label: "One time"
                                                    }),
                                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $knRao.default), {
                                                        value: 2,
                                                        control: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $141807cd97d66e4d$export$2e2bcd8739ae039), {}),
                                                        label: "Every time warehouse data refreshes"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                className: $adc248bb409000ee$export$c4cc592d9243d26f,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.TertiaryButton), {
                                        component: "button",
                                        text: "Cancel",
                                        title: "Cancel",
                                        handleClick: ()=>{
                                            history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).SegmentPushes.replace(':segmentId', segmentId));
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.PrimaryButton), {
                                        text: "Create Push",
                                        title: "Create Push",
                                        handleClick: createPush,
                                        deactive: invalidPush()
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $3658a2d28fd0ba5c$var$CampaignMenu = ({ openDialog: openDialog, destinationId: destinationId, destinationTitle: destinationTitle, cancelPush: cancelPush, pushToCampaign: pushToCampaign })=>{
    const overrides = $3658a2d28fd0ba5c$var$useStyles();
    const [tableSort, setTableSort] = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useState({
        page: 1,
        pageSize: 15,
        orderColumn: '',
        orderDirection: 'desc'
    });
    const [selectedCampaign, setSelectedCampaign] = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useState(null);
    const [searchValue, setSearchValue] = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useState('');
    const [activeSearchTerm, setActiveSearchTerm] = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useState('');
    const [pushCampaignNames, setPushCampaignNames] = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useState([]);
    const idKey = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useRef('Id');
    const campaignList = (0, $2cc14d441a2df122$export$8d6f84febf768661)(destinationId, tableSort, activeSearchTerm);
    function reorderHandler(column, direction) {
        setTableSort((state)=>({
                ...state,
                orderColumn: column,
                orderDirection: direction
            }));
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useEffect(()=>{
        if (campaignList.data) {
            const newPushCampaignNames = [];
            campaignList.data.propertyNames?.forEach((propertyName, index)=>{
                // Getting the id key that will be used to make sure we get the correct campaign
                // Id key coming back from the Integration API might not always be the same case, so doing this to make sure we capture the id key
                if (propertyName.toLocaleLowerCase() === 'id') idKey.current = propertyName;
                newPushCampaignNames.push({
                    title: campaignList.data.displayNames[index],
                    orderField: propertyName
                });
            });
            setPushCampaignNames(newPushCampaignNames);
        }
    }, [
        campaignList.data
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $1c689a1559dbf5e9$export$2e2bcd8739ae039), {
        open: openDialog,
        className: overrides.dialog,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6830d3674ad61fd5$export$2e2bcd8739ae039), {
                disableTypography: true,
                children: "Select Campaign"
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $881610d42277b808$export$2e2bcd8739ae039), {
                dividers: true,
                className: overrides.dialogContent,
                children: [
                    campaignList.isLoading && !campaignList.data && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: $246ccfbc8d89a664$export$46c1c92549715335,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
                    }),
                    campaignList.isError && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: $246ccfbc8d89a664$export$a3bc9b8ed74fc,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
                            type: "error",
                            message: `Failed to fetch results: ${campaignList.error.message}`
                        })
                    }),
                    campaignList.data && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $8991ead30e777b29$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                className: overrides.tableHeader,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                        className: $246ccfbc8d89a664$export$12948adc4d562794,
                                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                            className: $246ccfbc8d89a664$export$82456417dae51472,
                                            children: [
                                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                                    className: overrides.sourceSystem,
                                                    children: "SOURCE SYSTEM:"
                                                }),
                                                " ",
                                                destinationTitle
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SearchBar), {
                                        value: searchValue,
                                        updateValue: setSearchValue,
                                        submitHandler: ()=>setActiveSearchTerm(searchValue),
                                        placeholder: "Search by Keyword",
                                        allowSubmitButton: false,
                                        className: overrides.searchBar
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $fgoQ6.Table), {
                                className: $246ccfbc8d89a664$export$9852986a3ec5f6a0,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.TableHead), {
                                        children: pushCampaignNames.map((header)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.HeaderCell), {
                                                title: header.title,
                                                orderField: header.orderField ? header.orderField : null,
                                                orderColumn: header.orderField ? tableSort.orderColumn : null,
                                                orderDirection: header.orderField ? tableSort.orderDirection : null,
                                                reorderHandler: header.orderField ? reorderHandler : null
                                            }, header.title))
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $fgoQ6.TableBody), {
                                        children: [
                                            campaignList.data.items.totalItems === 0 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                                    colSpan: pushCampaignNames.length,
                                                    children: "No results found"
                                                })
                                            }),
                                            campaignList.data.items.results.map((data, rowIndex)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $57cf0cd18ac88d0a$export$2e2bcd8739ae039), {
                                                    hover: true,
                                                    onClick: ()=>setSelectedCampaign(data[idKey.current]),
                                                    className: overrides.tableRow,
                                                    selected: data[idKey.current] === selectedCampaign,
                                                    children: campaignList.data.propertyNames.map((prop, dataIndex)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                                            children: data[prop]
                                                        }, `${rowIndex} - ${dataIndex} - ${data[prop]}`))
                                                }, rowIndex))
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    campaignList.data && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: `${$246ccfbc8d89a664$export$e19d3e3c28de4af} ${overrides.pushPagination}`,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fce6a9cfa0ef4de9$export$2e2bcd8739ae039), {
                            totalPages: Math.ceil(campaignList.data.items.totalItems / tableSort.pageSize),
                            pageSize: tableSort.pageSize,
                            currentPage: tableSort.page,
                            disabled: campaignList.isPreviousData && campaignList.isFetching,
                            handlePageChange: (page)=>setTableSort((state)=>({
                                        ...state,
                                        page: page
                                    })),
                            handlePageSizeChange: (pageSize)=>setTableSort((state)=>({
                                        ...state,
                                        page: 1,
                                        pageSize: pageSize
                                    }))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $d176cc26269b23c2$export$2e2bcd8739ae039), {
                className: overrides.dialogActions,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.TertiaryButton), {
                        text: "Cancel",
                        title: "Cancel",
                        component: "button",
                        handleClick: cancelPush
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryButton), {
                        text: "Push",
                        title: "Push",
                        disabled: !selectedCampaign,
                        handleClick: ()=>{
                            const newCampaign = campaignList.data.items.results.find((c)=>c[idKey.current] === selectedCampaign);
                            pushToCampaign(newCampaign);
                        }
                    })
                ]
            })
        ]
    });
};
var $3658a2d28fd0ba5c$export$2e2bcd8739ae039 = (0, $eYoAG.withRouter)($3658a2d28fd0ba5c$var$PushSegment);




var $ieT14 = parcelRequire("ieT14");

var $fpdl2 = parcelRequire("fpdl2");
var $e1ONw = parcelRequire("e1ONw");
var $lwgYO = parcelRequire("lwgYO");

var $fgoQ6 = parcelRequire("fgoQ6");

var $eYoAG = parcelRequire("eYoAG");




var $ffd20a85af893246$exports = {};
"use strict";


Object.defineProperty($ffd20a85af893246$exports, "__esModule", {
    value: true
});
$ffd20a85af893246$exports.default = void 0;

var $ffd20a85af893246$var$React = $633c7dc13d665c5e$exports((parcelRequire("ieT14")));

var $ffd20a85af893246$var$_createSvgIcon = $b24015bb0dc2bec9$exports((parcelRequire("3yIjW")));
var $ffd20a85af893246$var$_default = (0, $ffd20a85af893246$var$_createSvgIcon.default)(/*#__PURE__*/ $ffd20a85af893246$var$React.createElement("path", {
    d: "M6 6h12v12H6z"
}), 'Stop');
$ffd20a85af893246$exports.default = $ffd20a85af893246$var$_default;




/**
 * @enum - Run status
 */ var $4565272e09d26a7a$var$RunStatus = /*#__PURE__*/ function(RunStatus) {
    RunStatus[RunStatus["In Progress"] = 0] = "In Progress";
    RunStatus[RunStatus["Complete"] = 1] = "Complete";
    RunStatus[RunStatus["Failed"] = 2] = "Failed";
    return RunStatus;
}($4565272e09d26a7a$var$RunStatus || {});
var $4565272e09d26a7a$export$2e2bcd8739ae039 = $4565272e09d26a7a$var$RunStatus;


/**
 * @enum - Push status
 */ var $2656f14350f409a4$var$PushStatus = /*#__PURE__*/ function(PushStatus) {
    PushStatus[PushStatus["N/A"] = 0] = "N/A";
    PushStatus[PushStatus["Active"] = 1] = "Active";
    PushStatus[PushStatus["Stopped"] = 2] = "Stopped";
    return PushStatus;
}($2656f14350f409a4$var$PushStatus || {});
var $2656f14350f409a4$export$2e2bcd8739ae039 = $2656f14350f409a4$var$PushStatus;



var $j6s32 = parcelRequire("j6s32");
var $4585747b2328cee7$var$PushDetailsSortFields = /*#__PURE__*/ function(PushDetailsSortFields) {
    PushDetailsSortFields["DateCreated"] = "dateCreated";
    PushDetailsSortFields["TotalCustomers"] = "totalCustomers";
    PushDetailsSortFields["CustomersPushed"] = "customersPushed";
    PushDetailsSortFields["Status"] = "status";
    return PushDetailsSortFields;
}($4585747b2328cee7$var$PushDetailsSortFields || {});
const $4585747b2328cee7$var$pushDetailsHeaders = [
    {
        title: 'Date/Time',
        orderField: "dateCreated"
    },
    {
        title: '# Customers in Segment',
        orderField: "totalCustomers"
    },
    {
        title: '# Customers Added to',
        orderField: "customersPushed"
    },
    {
        title: 'Status',
        orderField: "status"
    }
];
const $4585747b2328cee7$var$useStyles = (0, $e1ONw.default)(()=>({
        tableHeader: {
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '30px 30px 0 0',
            display: 'flex'
        },
        pushInfo: {
            display: 'flex',
            padding: '10px',
            backgroundColor: '#F9F9F9',
            alignItems: 'center'
        },
        infoContainer: {
            display: 'flex',
            flexDirection: 'column',
            padding: '5px 40px 5px 10px'
        },
        infoTitle: {
            color: '#4F4F4F',
            fontSize: '12px',
            marginBottom: '10px',
            textTransform: 'uppercase'
        },
        infoValue: {
            color: '#4F4F4F',
            fontSize: '16px',
            fontWeight: 600,
            minHeight: '20px'
        },
        stop: {
            color: '#C92100',
            border: '3px solid',
            borderRadius: '20px',
            cursor: 'pointer'
        },
        stopDisabled: {
            color: 'gray',
            cursor: 'not-allowed'
        },
        pushMessage: {
            position: 'absolute',
            top: '20px',
            left: 0,
            right: 0,
            marginLeft: 'auto',
            marginRight: 'auto',
            width: 'fit-content'
        },
        dialogActions: {
            justifyContent: 'space-between',
            height: 57,
            padding: '0 24px'
        }
    }));
const $4585747b2328cee7$var$ViewPushDetails = ()=>{
    const classes = $4585747b2328cee7$var$useStyles();
    const { segmentId: segmentId, pushId: pushId } = (0, $eYoAG.useParams)();
    const { state: state } = (0, $eYoAG.useLocation)();
    const { successMessage: successMessage, setSuccessMessage: setSuccessMessage, errorMessage: errorMessage, setErrorMessage: setErrorMessage } = (0, $dc97b0794e0fd33b$export$2e2bcd8739ae039)();
    const [tableSort, setTableSort] = $ieT14.useState({
        page: 1,
        pageSize: 15,
        orderColumn: 'dateCreated',
        orderDirection: 'desc'
    });
    const [searchValue, setSearchValue] = $ieT14.useState('');
    const [activeSearchTerm, setActiveSearchTerm] = $ieT14.useState('');
    const [showStopDialog, setShowStopDialog] = $ieT14.useState(false);
    const pushQuery = (0, $2cc14d441a2df122$export$48fcf5586cfec2ef)(segmentId, pushId, tableSort, activeSearchTerm);
    const stopAutomaticPush = (0, $2cc14d441a2df122$export$a9cd06f95aedc027)();
    const campaignTermQuery = (0, $2cc14d441a2df122$export$7fa8c342159b8c73)(pushQuery?.data?.pushDestinationId.toString(), state.clientIdForSegment?.toString());
    const [campaignTerm, setCampaignTerm] = $ieT14.useState('Campaign');
    function reorderHandler(column, direction) {
        setTableSort((state)=>({
                ...state,
                orderColumn: column,
                orderDirection: direction
            }));
    }
    $ieT14.useEffect(()=>{
        if (campaignTermQuery.data) setCampaignTerm(campaignTermQuery.data);
    }, [
        campaignTermQuery.data
    ]);
    const stopAutomaticCampaign = ()=>{
        setShowStopDialog(false);
        stopAutomaticPush.mutate({
            segmentId: segmentId,
            pushId: pushId,
            clientId: state.clientIdForSegment?.toString()
        }, {
            onSuccess (results) {
                if (results.success) setSuccessMessage('Push successfully stopped');
                else setErrorMessage('Failed to stop push');
            },
            onError () {
                setErrorMessage('There was an error stopping the push');
            }
        });
    };
    const setHeaderTitle = (title)=>{
        if (title === '# Customers Added to') return `${title} ${campaignTerm}`;
        return title;
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
        children: [
            errorMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: classes.pushMessage,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
                    type: "error",
                    message: errorMessage
                })
            }),
            successMessage && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: classes.pushMessage,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
                    type: "success",
                    message: successMessage
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $246ccfbc8d89a664$export$e8e78c978b129247,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $34fc1605bcad7d00$export$2e2bcd8739ae039), {
                        currentPage: 'View Push'
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $lwgYO.default), {
                        elevation: 1,
                        className: $246ccfbc8d89a664$export$914772be44022da8,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                            className: $246ccfbc8d89a664$export$a7db06668cad9adb,
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                    className: classes.tableHeader,
                                    children: [
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                            className: classes.pushInfo,
                                            children: [
                                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                                    className: classes.infoContainer,
                                                    children: [
                                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                                            className: classes.infoTitle,
                                                            children: "Push Id"
                                                        }),
                                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                                            className: classes.infoValue,
                                                            children: pushId
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                                    className: classes.infoContainer,
                                                    children: [
                                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                                            className: classes.infoTitle,
                                                            children: "Destination"
                                                        }),
                                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                                            className: classes.infoValue,
                                                            children: pushQuery.data?.pushDestinationName
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                                                    className: classes.infoContainer,
                                                    children: [
                                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("span", {
                                                            className: classes.infoTitle,
                                                            children: [
                                                                campaignTerm,
                                                                " Id"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("span", {
                                                            className: classes.infoValue,
                                                            children: pushQuery.data?.campaignId
                                                        })
                                                    ]
                                                }),
                                                pushQuery.data && pushQuery.data.status !== (0, $2656f14350f409a4$export$2e2bcd8739ae039)['N/A'] && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $8991ead30e777b29$exports.Fragment), {
                                                    children: [
                                                        pushQuery.data.status === (0, $2656f14350f409a4$export$2e2bcd8739ae039).Active && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ffd20a85af893246$exports))), {
                                                            className: classes.stop,
                                                            onClick: ()=>setShowStopDialog(true)
                                                        }),
                                                        pushQuery.data.status === (0, $2656f14350f409a4$export$2e2bcd8739ae039).Stopped && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ffd20a85af893246$exports))), {
                                                            className: (0, $j6s32.default)(classes.stop, classes.stopDisabled)
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SearchBar), {
                                            value: searchValue,
                                            updateValue: setSearchValue,
                                            placeholder: "Search by Name",
                                            submitHandler: ()=>setActiveSearchTerm(searchValue)
                                        })
                                    ]
                                }),
                                pushQuery.isLoading && !pushQuery.data && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                    className: $246ccfbc8d89a664$export$46c1c92549715335,
                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
                                }),
                                pushQuery.isError && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                    className: $246ccfbc8d89a664$export$a3bc9b8ed74fc,
                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
                                        type: "error",
                                        message: `Failed to fetch results: ${pushQuery.error.message}`
                                    })
                                }),
                                pushQuery.data && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                    className: $246ccfbc8d89a664$export$e7d47881ec916f76,
                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $fgoQ6.Table), {
                                        className: $246ccfbc8d89a664$export$9852986a3ec5f6a0,
                                        loading: pushQuery.isPreviousData && pushQuery.isFetching,
                                        results: pushQuery.data.runs.results,
                                        children: [
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.TableHead), {
                                                children: $4585747b2328cee7$var$pushDetailsHeaders.map((header)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.HeaderCell), {
                                                        title: setHeaderTitle(header.title),
                                                        orderField: header.orderField ? header.orderField : null,
                                                        orderColumn: header.orderField ? tableSort.orderColumn : null,
                                                        orderDirection: header.orderField ? tableSort.orderDirection : null,
                                                        reorderHandler: header.orderField ? reorderHandler : null
                                                    }, header.title))
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $fgoQ6.TableBody), {
                                                children: [
                                                    pushQuery.data.runs.totalItems === 0 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("tr", {
                                                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                                            colSpan: pushQuery.data.runs.results.length,
                                                            children: "No results found"
                                                        })
                                                    }),
                                                    pushQuery.data.runs.results.map((run)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                                                    className: $246ccfbc8d89a664$export$120b13130c77685f,
                                                                    children: (0, $28c5efff86001588$export$3245e15bf4cbdd6c).format(new Date(run.dateCreated))
                                                                }),
                                                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                                                    children: run.totalCustomers
                                                                }),
                                                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                                                    children: run.customersPushed
                                                                }),
                                                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                                                    children: (0, $4565272e09d26a7a$export$2e2bcd8739ae039)[run.status]
                                                                })
                                                            ]
                                                        }, `${run.pushId}`))
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                pushQuery.data && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                    className: $246ccfbc8d89a664$export$e19d3e3c28de4af,
                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fce6a9cfa0ef4de9$export$2e2bcd8739ae039), {
                                        totalPages: Math.ceil(pushQuery.data.runs.totalItems / tableSort.pageSize),
                                        pageSize: tableSort.pageSize,
                                        currentPage: tableSort.page,
                                        disabled: pushQuery.isPreviousData && pushQuery.isFetching,
                                        handlePageChange: (page)=>setTableSort((state)=>({
                                                    ...state,
                                                    page: page
                                                })),
                                        handlePageSizeChange: (pageSize)=>setTableSort((state)=>({
                                                    ...state,
                                                    pageSize: pageSize
                                                }))
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $1c689a1559dbf5e9$export$2e2bcd8739ae039), {
                open: showStopDialog,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6830d3674ad61fd5$export$2e2bcd8739ae039), {
                        disableTypography: true,
                        children: "Stop Automatic Run?"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $881610d42277b808$export$2e2bcd8739ae039), {
                        children: "Are you sure you want to stop this automatic run?"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $d176cc26269b23c2$export$2e2bcd8739ae039), {
                        className: classes.dialogActions,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.TertiaryButton), {
                                text: "Cancel",
                                title: "Cancel",
                                component: "button",
                                handleClick: ()=>setShowStopDialog(false)
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryButton), {
                                text: "Stop",
                                title: "Stop",
                                handleClick: stopAutomaticCampaign
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $4585747b2328cee7$export$2e2bcd8739ae039 = $4585747b2328cee7$var$ViewPushDetails;




var $ieT14 = parcelRequire("ieT14");



var $eYoAG = parcelRequire("eYoAG");


parcelRequire("ieT14");

var $fpdl2 = parcelRequire("fpdl2");
var $e1ONw = parcelRequire("e1ONw");
var $356Vi = parcelRequire("356Vi");

var $1vmhz = parcelRequire("1vmhz");


var $fgoQ6 = parcelRequire("fgoQ6");


var $eYoAG = parcelRequire("eYoAG");


const $a498acb6c44028b9$var$breadcrumbs = [
    {
        title: 'Segments',
        path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Segments
    }
];
const $a498acb6c44028b9$var$useStyles = (0, $e1ONw.default)({
    circularProgress: {
        display: 'block',
        '& svg.MuiCircularProgress-svg': {
            margin: 0
        }
    },
    errorIcon: {
        fontSize: 20,
        color: (0, $69ed148db7543104$export$471f7ae5c4103ae1).error.medium,
        '&.MuiSvgIcon-root': {
            margin: 0
        }
    }
});
const $a498acb6c44028b9$var$SegmentBreadcrumbs = ()=>{
    const overrides = $a498acb6c44028b9$var$useStyles();
    const { segmentId: segmentId } = (0, $eYoAG.useParams)();
    const { segmentQuery: segmentQuery } = (0, $1517e00917d95652$export$204800eede9ea29f)(segmentId);
    function currentBreadcrumb() {
        if (segmentQuery.isError) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $356Vi.default), {
            title: "Segment title failed to load",
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1vmhz.default), {
                className: overrides.errorIcon
            })
        });
        if (segmentQuery.isLoading) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {
            size: "20px",
            className: overrides.circularProgress
        });
        if (segmentQuery.data) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
            className: $8caa2dfa516972d4$export$38e42c68cf43b5d4,
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("h1", {
                    children: segmentQuery.data.name
                }),
                segmentQuery.isFetching && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {
                    size: "16px",
                    className: overrides.circularProgress
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.Breadcrumbs), {
        breadcrumbs: $a498acb6c44028b9$var$breadcrumbs,
        currentPage: currentBreadcrumb(),
        className: $8caa2dfa516972d4$export$a40ebde8ba896166
    });
};
var $a498acb6c44028b9$export$2e2bcd8739ae039 = $a498acb6c44028b9$var$SegmentBreadcrumbs;




parcelRequire("ieT14");

var $6mt9R = parcelRequire("6mt9R");



var $eYoAG = parcelRequire("eYoAG");
const $ced85e21f8aa5734$var$SegmentMenu = ({ segmentId: segmentId, location: location })=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("ul", {
            className: $246ccfbc8d89a664$export$b1e5508a851be14d,
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6mt9R.Link), {
                    to: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Segment.replace(':segmentId', segmentId),
                    className: location.pathname.endsWith(segmentId) ? $246ccfbc8d89a664$export$97aac956da55dae9 : undefined,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
                        className: $246ccfbc8d89a664$export$c176f998e71d0f08,
                        children: "Query"
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6mt9R.Link), {
                    to: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).SegmentPushes.replace(':segmentId', segmentId),
                    className: location.pathname.endsWith('pushes') ? $246ccfbc8d89a664$export$97aac956da55dae9 : undefined,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
                        className: $246ccfbc8d89a664$export$c176f998e71d0f08,
                        children: "Pushes"
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6mt9R.Link), {
                    to: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).SegmantDependencies.replace(':segmentId', segmentId),
                    className: location.pathname.endsWith('dependencies') ? $246ccfbc8d89a664$export$97aac956da55dae9 : undefined,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("li", {
                        className: $246ccfbc8d89a664$export$c176f998e71d0f08,
                        children: "Dependencies"
                    })
                })
            ]
        })
    });
};
var $ced85e21f8aa5734$export$2e2bcd8739ae039 = (0, $eYoAG.withRouter)($ced85e21f8aa5734$var$SegmentMenu);




var $ieT14 = parcelRequire("ieT14");


var $fpdl2 = parcelRequire("fpdl2");
var $e1ONw = parcelRequire("e1ONw");
var $lwgYO = parcelRequire("lwgYO");

var $fgoQ6 = parcelRequire("fgoQ6");



var $3umuy = parcelRequire("3umuy");

var $j6s32 = parcelRequire("j6s32");


var $6mt9R = parcelRequire("6mt9R");
var $eYoAG = parcelRequire("eYoAG");


var $26bea0643660e1ea$var$PushHistorySortFields = /*#__PURE__*/ function(PushHistorySortFields) {
    PushHistorySortFields["TargetSystemName"] = "targetSystemName";
    PushHistorySortFields["CampaignName"] = "campaignName";
    PushHistorySortFields["DateLastRun"] = "dateLastRun";
    PushHistorySortFields["Status"] = "status";
    PushHistorySortFields["PushId"] = "pushId";
    PushHistorySortFields["Type"] = "isOneTime";
    return PushHistorySortFields;
}($26bea0643660e1ea$var$PushHistorySortFields || {});
const $26bea0643660e1ea$var$pushHistoryHeaders = [
    {
        title: 'Push Id',
        orderField: "pushId"
    },
    {
        title: 'Destination System',
        orderField: "targetSystemName"
    },
    {
        title: 'Campaign',
        orderField: "campaignName"
    },
    {
        title: 'Type',
        orderField: "isOneTime"
    },
    {
        title: 'Last Run',
        orderField: "dateLastRun"
    },
    {
        title: 'Status',
        orderField: "status"
    }
];
const $26bea0643660e1ea$var$useStyles = (0, $e1ONw.default)(()=>({
        tablePadding: {
            padding: '25px 0'
        },
        searchBar: {
            width: 180
        },
        tableHeader: {
            display: 'flex',
            justifyContent: 'end',
            alignItems: 'center',
            padding: '10px 30px 0'
        },
        pushHistoryDetailsContainer: {
            display: 'flex',
            flexDirection: 'row',
            fontWeight: 600,
            '& div': {
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                '& div': {
                    padding: '0 15px'
                }
            }
        },
        pushPagination: {
            display: 'flex',
            justifyContent: 'flex-end',
            borderTop: '1px solid #DAD5D5'
        },
        pushDetailsCellCollapsed: {
            borderBottom: 'none'
        },
        pushDetailsCellExpand: {
            borderBottom: '1px solid rgba(224, 224, 224, 1);'
        },
        noHistoryContainer: {
            margin: '10rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            '& div': {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }
        },
        paperColumn: {
            flexDirection: 'column'
        },
        pushHeader: {
            justifyContent: 'flex-end',
            marginTop: '8px'
        },
        linkText: {
            textDecoration: 'none',
            fontWeight: 500,
            color: '#006DA8'
        }
    }));
const $26bea0643660e1ea$var$PushHistoryDetails = ({ segmentId: segmentId, canPush: canPush, clientIdForSegment: clientIdForSegment })=>{
    const history = (0, $eYoAG.useHistory)();
    const classes = $26bea0643660e1ea$var$useStyles();
    const [tableSort, setTableSort] = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useState({
        page: 1,
        pageSize: 15,
        orderColumn: "dateLastRun",
        orderDirection: 'desc'
    });
    const [searchValue, setSearchValue] = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useState('');
    const [activeSearchTerm, setActiveSearchTerm] = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useState('');
    const pushHistoryList = (0, $2cc14d441a2df122$export$a5fa6e09294ac637)(segmentId, tableSort, activeSearchTerm);
    function reorderHandler(column, direction) {
        setTableSort((state)=>({
                ...state,
                orderColumn: column,
                orderDirection: direction
            }));
    }
    if (!!pushHistoryList.data && pushHistoryList.data.totalItems === 0) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        className: classes.noHistoryContainer,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: $246ccfbc8d89a664$export$82456417dae51472,
                    children: "The segment has not been pushed to a destination yet"
                }),
                canPush && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                    className: (0, $j6s32.default)($246ccfbc8d89a664$export$38e42c68cf43b5d4, classes.pushHeader),
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryButton), {
                        text: "Create New Push",
                        handleClick: ()=>{
                            history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).PushSegment.replace(':segmentId', segmentId));
                        }
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $246ccfbc8d89a664$export$e8e78c978b129247,
        children: [
            canPush && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: (0, $j6s32.default)($246ccfbc8d89a664$export$38e42c68cf43b5d4, classes.pushHeader),
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryButton), {
                    text: "Create New Push",
                    handleClick: ()=>{
                        history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).PushSegment.replace(':segmentId', segmentId));
                    }
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("section", {
                className: classes.tablePadding,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $lwgYO.default), {
                    elevation: 1,
                    className: (0, $j6s32.default)($246ccfbc8d89a664$export$914772be44022da8, classes.paperColumn),
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        className: $246ccfbc8d89a664$export$a7db06668cad9adb,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                className: classes.tableHeader,
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SearchBar), {
                                    value: searchValue,
                                    updateValue: setSearchValue,
                                    submitHandler: ()=>setActiveSearchTerm(searchValue),
                                    placeholder: "Search by Keyword",
                                    allowSubmitButton: false,
                                    className: classes.searchBar
                                })
                            }),
                            pushHistoryList.isLoading && !pushHistoryList.data && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                className: $246ccfbc8d89a664$export$46c1c92549715335,
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
                            }),
                            pushHistoryList.isError && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                className: $246ccfbc8d89a664$export$a3bc9b8ed74fc,
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
                                    type: "error",
                                    message: `Failed to fetch results: ${pushHistoryList.error.message}`
                                })
                            }),
                            !!pushHistoryList.data && pushHistoryList.data.totalItems > 0 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                className: $246ccfbc8d89a664$export$e7d47881ec916f76,
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $59739725ddd88dec$export$2e2bcd8739ae039), {
                                    stickyHeader: true,
                                    className: $246ccfbc8d89a664$export$9852986a3ec5f6a0,
                                    children: [
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $fgoQ6.TableHead), {
                                            children: [
                                                $26bea0643660e1ea$var$pushHistoryHeaders.map((header)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.HeaderCell), {
                                                        title: header.title,
                                                        orderField: header.orderField ? header.orderField : null,
                                                        orderColumn: header.orderField ? tableSort.orderColumn : null,
                                                        orderDirection: header.orderField ? tableSort.orderDirection : null,
                                                        reorderHandler: header.orderField ? reorderHandler : null
                                                    }, header.title)),
                                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.HeaderCell), {
                                                    title: ""
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $fgoQ6.TableBody), {
                                            children: [
                                                pushHistoryList.data.totalItems === 0 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("tr", {
                                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                                        colSpan: $26bea0643660e1ea$var$pushHistoryHeaders.length,
                                                        children: "No results found"
                                                    })
                                                }),
                                                pushHistoryList.data.results.map((pushHistory)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $57cf0cd18ac88d0a$export$2e2bcd8739ae039), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $248bc6cb24906a61$export$2e2bcd8739ae039), {
                                                                padding: "none",
                                                                children: pushHistory.pushId
                                                            }),
                                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $248bc6cb24906a61$export$2e2bcd8739ae039), {
                                                                padding: "none",
                                                                children: pushHistory.targetSystemName
                                                            }),
                                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $248bc6cb24906a61$export$2e2bcd8739ae039), {
                                                                padding: "none",
                                                                children: pushHistory.campaignName
                                                            }),
                                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $248bc6cb24906a61$export$2e2bcd8739ae039), {
                                                                padding: "none",
                                                                children: pushHistory.isOneTime ? 'One time' : 'Automatic'
                                                            }),
                                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $248bc6cb24906a61$export$2e2bcd8739ae039), {
                                                                padding: "none",
                                                                children: pushHistory.dateLastRun ? (0, (/*@__PURE__*/$parcel$interopDefault($3umuy)))(pushHistory.dateLastRun).format('M/D/YYYY h:mm:ss a') : ''
                                                            }),
                                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $248bc6cb24906a61$export$2e2bcd8739ae039), {
                                                                padding: "none",
                                                                children: (0, $2656f14350f409a4$export$2e2bcd8739ae039)[pushHistory.automaticPushStatus] ?? (0, $4565272e09d26a7a$export$2e2bcd8739ae039)[pushHistory.oneTimePushStatus]
                                                            }),
                                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $248bc6cb24906a61$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6mt9R.Link), {
                                                                    to: {
                                                                        pathname: `/segments/${segmentId}/pushes/${pushHistory.pushId}`,
                                                                        state: {
                                                                            clientIdForSegment: clientIdForSegment
                                                                        }
                                                                    },
                                                                    className: classes.linkText,
                                                                    children: "View Push"
                                                                })
                                                            })
                                                        ]
                                                    }, pushHistory.pushId))
                                            ]
                                        })
                                    ]
                                })
                            }),
                            pushHistoryList.data && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                className: `${$246ccfbc8d89a664$export$e19d3e3c28de4af} ${classes.pushPagination}`,
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fce6a9cfa0ef4de9$export$2e2bcd8739ae039), {
                                    totalPages: Math.ceil(pushHistoryList.data.totalItems / tableSort.pageSize),
                                    pageSize: tableSort.pageSize,
                                    currentPage: tableSort.page,
                                    disabled: pushHistoryList.isPreviousData && pushHistoryList.isFetching,
                                    handlePageChange: (page)=>setTableSort((state)=>({
                                                ...state,
                                                page: page
                                            })),
                                    handlePageSizeChange: (pageSize)=>setTableSort((state)=>({
                                                ...state,
                                                page: 1,
                                                pageSize: pageSize
                                            }))
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $26bea0643660e1ea$export$2e2bcd8739ae039 = $26bea0643660e1ea$var$PushHistoryDetails;





var $ieT14 = parcelRequire("ieT14");


var $fgoQ6 = parcelRequire("fgoQ6");


var $eYoAG = parcelRequire("eYoAG");




parcelRequire("ieT14");


/**
 * Render a single segment's details for a view-only segment
 */ const $3db4f4ce63eaceab$var$ViewSegmentDetails = ({ segmentId: segmentId })=>{
    const { segmentQuery: segmentQuery, userInterface: userInterface } = (0, $1517e00917d95652$export$204800eede9ea29f)(segmentId);
    if (segmentQuery.data) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("dl", {
        className: $c7480ef281c02b11$export$59bc6e0c0b51d74a,
        children: [
            userInterface === 'management' && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $c7480ef281c02b11$export$c657596daa39a84e,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("dt", {
                        children: "Team Name"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("dd", {
                        children: segmentQuery.data.clientName
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $c7480ef281c02b11$export$c657596daa39a84e,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("dt", {
                        children: "Segment Name"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("dd", {
                        children: segmentQuery.data.name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $c7480ef281c02b11$export$c657596daa39a84e,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("dt", {
                        children: "Segment Description"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("dd", {
                        children: segmentQuery.data.description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $c7480ef281c02b11$export$c657596daa39a84e,
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("dt", {
                        children: "Segment Sharing"
                    }),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("dd", {
                        children: segmentQuery.data.isShared ? 'Shared' : 'Not shared'
                    })
                ]
            })
        ]
    });
};
var $3db4f4ce63eaceab$export$2e2bcd8739ae039 = $3db4f4ce63eaceab$var$ViewSegmentDetails;




parcelRequire("ieT14");

var $eYoAG = parcelRequire("eYoAG");


const $0696841b245222b4$var$SegmentResultsView = ()=>{
    const { segmentId: segmentId } = (0, $eYoAG.useParams)();
    const { segmentQuery: segmentQuery } = (0, $1517e00917d95652$export$204800eede9ea29f)(segmentId);
    const segmentResults = segmentQuery.data?.results;
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $162f0a5823a32900$export$2e2bcd8739ae039), {
        total: segmentResults?.totalCustomers || 0,
        included: segmentResults?.includedCustomers || 0,
        excluded: segmentResults?.excludedCustomers || 0,
        isLoading: segmentQuery.isFetching
    });
};
var $0696841b245222b4$export$2e2bcd8739ae039 = $0696841b245222b4$var$SegmentResultsView;










var $aIJrd = parcelRequire("aIJrd");
const $64180d5c126386e0$var$DependencyAlert = (0, $aIJrd.default)({
    root: {
        width: '55%'
    }
})((0, $fgoQ6.SecondaryAlert));
/**
 * View or update a single segment
 * Component renders either a view-only or editable segment view conditionally based on the ownership of the segment.
 */ const $64180d5c126386e0$var$Segment = ({ segmentId: segmentId, segmentQuery: segmentQuery, powerUser: powerUser, userName: userName })=>{
    const history = (0, $eYoAG.useHistory)();
    const segmentMutation = (0, $dd3a9e68638db4d4$export$4bb391d737872cb3)(segmentId);
    const { state: state } = (0, $eYoAG.useLocation)();
    const [isEditingSegment, setIsEditingSegment] = $ieT14.useState(state?.isEditing);
    const [detailsCollapsed, setDetailsCollapsed] = $ieT14.useState(false);
    const [buildCollapsed, setBuildCollapsed] = $ieT14.useState(false);
    const [name, setName] = $ieT14.useState('');
    const [description, setDescription] = $ieT14.useState('');
    const [shared, setShared] = $ieT14.useState('');
    const [includedAttributes, dispatch] = $ieT14.useReducer((0, $79aece72917dec2b$export$86e9f3b355bd161d), {
        operator: (0, $a9d5bf712846139f$export$905dbc95765b1ada).And,
        predicates: []
    });
    const [excludedAttributes, excludedDispatch] = $ieT14.useReducer((0, $79aece72917dec2b$export$86e9f3b355bd161d), {
        operator: (0, $a9d5bf712846139f$export$905dbc95765b1ada).And,
        predicates: []
    });
    const [canEditSegment, setCanEditSegment] = $ieT14.useState(false);
    const [isDependency, setIsDependency] = $ieT14.useState(false);
    const dependencyMessage = `Changes made to this segment will impact dependent segments. For more details see "Dependencies" tab.`;
    const [includeSegmentComposition, setIncludeSegmentComposition] = $ieT14.useState({
        segmentId: null,
        segmentOperator: null,
        customers: null,
        segmentName: ''
    });
    const [excludeSegmentComposition, setExcludeSegmentComposition] = $ieT14.useState({
        segmentId: null,
        segmentOperator: null,
        customers: null,
        segmentName: ''
    });
    const queryClient = (0, $7fd0e6909adb481d$export$22e77b9572c4fded)();
    function updateSegment() {
        let selectedComposition = {};
        if (includeSegmentComposition.segmentId) selectedComposition = {
            include: includeSegmentComposition
        };
        if (excludeSegmentComposition.segmentId) selectedComposition = {
            ...selectedComposition,
            exclude: excludeSegmentComposition
        };
        segmentMutation.mutate({
            name: name,
            description: description,
            isShared: shared == 'Share',
            attributes: {
                include: includedAttributes,
                exclude: excludedAttributes
            },
            composition: {
                ...selectedComposition
            }
        }, {
            onSuccess: ()=>{
                includedAttributes.predicates.forEach((att)=>{
                    logCreatedAttributes(att);
                });
                excludedAttributes.predicates.forEach((att)=>{
                    logCreatedAttributes(att);
                });
                history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Segments, {
                    successMessage: `Success: Segment "${name}" Saved`
                });
            }
        });
    }
    const logCreatedAttributes = (included)=>{
        if ('predicates' in included) included.predicates.forEach((att)=>{
            logCreatedAttributes(att);
        });
        else (0, $80940237791545d7$export$65cc181beb0d2632).addUserAction('edit-segment', {
            user_action_details: {
                segment_id: segmentId,
                segment_name: name,
                is_segment_shared: shared,
                user_name: userName,
                attribute: included.name
            }
        });
    };
    $ieT14.useEffect(()=>{
        if (segmentQuery.data) {
            setName(segmentQuery.data.name);
            setDescription(segmentQuery.data.description);
            setShared(segmentQuery.data.isShared ? 'Share' : 'Do not share');
            dispatch({
                type: 'setAttributes',
                attributes: segmentQuery.data.selectedAttributes.include
            });
            excludedDispatch({
                type: 'setAttributes',
                attributes: segmentQuery.data.selectedAttributes.exclude
            });
            queryClient.setQueryData([
                'segment-results',
                segmentQuery.data.clientId,
                segmentQuery.data.selectedAttributes.include,
                segmentQuery.data.selectedAttributes.exclude
            ], segmentQuery.data.results);
            if (segmentQuery.data.composition?.include) setIncludeSegmentComposition({
                segmentId: segmentQuery.data.composition.include.segmentId,
                segmentOperator: segmentQuery.data.composition.include.segmentOperator,
                customers: segmentQuery.data.composition.include.customers,
                segmentName: segmentQuery.data.composition.include.segmentName
            });
            if (segmentQuery.data.composition?.exclude) setExcludeSegmentComposition({
                segmentId: segmentQuery.data.composition.exclude.segmentId,
                segmentOperator: segmentQuery.data.composition.exclude.segmentOperator,
                customers: segmentQuery.data.composition.exclude.customers,
                segmentName: segmentQuery.data.composition.exclude.segmentName
            });
            setIsDependency(segmentQuery.data.isDependency);
        }
    }, [
        segmentQuery.data
    ]);
    $ieT14.useEffect(()=>{
        setCanEditSegment(powerUser || segmentQuery.data?.isEditable);
    }, [
        segmentQuery.data,
        powerUser
    ]);
    const buildIncludeSelectedCompositionObj = $ieT14.useMemo(()=>({
            selectedComoposition: includeSegmentComposition,
            changeSelectedComposition: setIncludeSegmentComposition
        }), [
        includeSegmentComposition,
        setIncludeSegmentComposition
    ]);
    const buildExcludeSelectedCompositionObj = $ieT14.useMemo(()=>({
            selectedComoposition: excludeSegmentComposition,
            changeSelectedComposition: setExcludeSegmentComposition
        }), [
        excludeSegmentComposition,
        setExcludeSegmentComposition
    ]);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $adc248bb409000ee$export$e8e78c978b129247,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                className: $adc248bb409000ee$export$a3bc9b8ed74fc,
                children: [
                    segmentQuery.isError && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
                        type: "error",
                        message: segmentQuery.error.message
                    }),
                    segmentMutation.isError && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
                        type: "error",
                        message: segmentMutation.error.message
                    }),
                    isDependency && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($64180d5c126386e0$var$DependencyAlert, {
                        type: "info",
                        message: dependencyMessage
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $365a06e4442a50da$export$55b973e094275b13), {
                title: "Enter Segment Details",
                collapsed: detailsCollapsed,
                onCollapse: setDetailsCollapsed,
                children: [
                    segmentQuery.data && canEditSegment && isEditingSegment && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $17b3f83bdc759c12$export$2e2bcd8739ae039), {
                        name: name,
                        description: description,
                        shared: shared,
                        onNameChange: setName,
                        onDescriptionChange: setDescription,
                        onSharedChange: setShared
                    }),
                    segmentQuery.data && (!canEditSegment || !isEditingSegment) && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3db4f4ce63eaceab$export$2e2bcd8739ae039), {
                        segmentId: segmentId
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $365a06e4442a50da$export$55b973e094275b13), {
                title: "Summary",
                collapsed: buildCollapsed,
                onCollapse: setBuildCollapsed,
                className: $adc248bb409000ee$export$665e0f4515a68234,
                secondaryAction: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($ieT14.Fragment, {
                    children: powerUser && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4d5deb8da6079694$export$2e2bcd8739ae039), {
                        name: name,
                        includedAttributes: includedAttributes,
                        excludedAttributes: excludedAttributes,
                        segmentId: segmentId,
                        segmentShared: shared,
                        userName: userName
                    })
                }),
                children: [
                    segmentQuery.data && canEditSegment && isEditingSegment && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($ieT14.Fragment, {
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $79aece72917dec2b$export$917e8dab6495b1e6).Provider, {
                            value: {
                                selectedAttributes: includedAttributes,
                                dispatch: dispatch
                            },
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $79aece72917dec2b$export$f754003632709cde).Provider, {
                                value: {
                                    selectedAttributes: excludedAttributes,
                                    dispatch: excludedDispatch
                                },
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $79aece72917dec2b$export$fe31d6c99f271165).Provider, {
                                    value: buildIncludeSelectedCompositionObj,
                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $79aece72917dec2b$export$d84346a295b37585).Provider, {
                                        value: buildExcludeSelectedCompositionObj,
                                        children: [
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $733f69a6c8a00721$export$2e2bcd8739ae039), {}),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $9fed084411757902$export$2e2bcd8739ae039), {
                                                isDependency: isDependency
                                            }),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $9fed084411757902$export$2e2bcd8739ae039), {
                                                exclude: true,
                                                isDependency: isDependency
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    }),
                    segmentQuery.data && (!canEditSegment || !isEditingSegment) && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)($ieT14.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $0696841b245222b4$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4e1477e19f32cf4c$export$2e2bcd8739ae039), {
                                includedAttributes: segmentQuery.data.attributes.include,
                                excludedAttributes: segmentQuery.data.attributes.exclude,
                                includeComposition: segmentQuery.data.composition?.include,
                                excludeComposition: segmentQuery.data.composition?.exclude
                            })
                        ]
                    })
                ]
            }),
            segmentQuery.data && canEditSegment && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $8991ead30e777b29$exports.Fragment), {
                children: [
                    isEditingSegment && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                        className: $adc248bb409000ee$export$c4cc592d9243d26f,
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.TertiaryButton), {
                                component: "button",
                                text: "Cancel",
                                title: "Cancel",
                                handleClick: ()=>{
                                    history.push((0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Segments);
                                }
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.PrimaryButton), {
                                text: "Save Segment",
                                title: "Save Segment",
                                handleClick: updateSegment,
                                deactive: name.length === 0 || description.length === 0 || includedAttributes.predicates.length === 0 && excludedAttributes.predicates.length === 0 || shared === ''
                            })
                        ]
                    }),
                    !isEditingSegment && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                        className: $adc248bb409000ee$export$9f9fbb0073a1ff20,
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.PrimaryButton), {
                            text: "Edit Segment",
                            title: "Edit Segment",
                            handleClick: ()=>setIsEditingSegment(true)
                        })
                    })
                ]
            })
        ]
    });
};
var $64180d5c126386e0$export$2e2bcd8739ae039 = $64180d5c126386e0$var$Segment;




var $ieT14 = parcelRequire("ieT14");

var $fgoQ6 = parcelRequire("fgoQ6");








var $e1ONw = parcelRequire("e1ONw");
const $046ab0e1a946b046$var$useStyles = (0, $e1ONw.default)(()=>({
        divider: {
            height: '25px',
            borderRight: '1px solid #979797',
            margin: '5px 0'
        }
    }));
/**
 * View a single existing segment without editing
 */ const $046ab0e1a946b046$var$ViewSegment = ({ segmentId: segmentId, segmentQuery: segmentQuery, powerUser: powerUser, userName: userName })=>{
    const classes = $046ab0e1a946b046$var$useStyles();
    const [detailsCollapsed, setDetailsCollapsed] = $ieT14.useState(false);
    const [buildCollapsed, setBuildCollapsed] = $ieT14.useState(false);
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $c7480ef281c02b11$export$e8e78c978b129247,
        children: [
            segmentQuery.isError && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $c7480ef281c02b11$export$a3bc9b8ed74fc,
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
                    type: "error",
                    message: segmentQuery.error.message
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $365a06e4442a50da$export$55b973e094275b13), {
                title: "Segment Details",
                collapsed: detailsCollapsed,
                onCollapse: setDetailsCollapsed,
                children: segmentQuery.data && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $3db4f4ce63eaceab$export$2e2bcd8739ae039), {
                    segmentId: segmentId
                })
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $365a06e4442a50da$export$55b973e094275b13), {
                title: "Summary",
                collapsed: buildCollapsed,
                onCollapse: setBuildCollapsed,
                className: $c7480ef281c02b11$export$665e0f4515a68234,
                secondaryAction: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)($ieT14.Fragment, {
                    children: powerUser && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $8991ead30e777b29$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                                className: classes.divider
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4d5deb8da6079694$export$2e2bcd8739ae039), {
                                name: segmentQuery.data ? segmentQuery.data.name : 'Untitled',
                                includedAttributes: segmentQuery.data ? segmentQuery.data.selectedAttributes.include : {
                                    operator: (0, $a9d5bf712846139f$export$905dbc95765b1ada).And,
                                    predicates: []
                                },
                                excludedAttributes: segmentQuery.data ? segmentQuery.data.selectedAttributes.exclude : {
                                    operator: (0, $a9d5bf712846139f$export$905dbc95765b1ada).And,
                                    predicates: []
                                },
                                segmentId: segmentId,
                                segmentShared: segmentQuery.data.isShared ? 'Share' : 'Do not share',
                                userName: userName
                            })
                        ]
                    })
                }),
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $0696841b245222b4$export$2e2bcd8739ae039), {}),
                    segmentQuery.data && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4e1477e19f32cf4c$export$2e2bcd8739ae039), {
                        includedAttributes: segmentQuery.data.attributes.include,
                        excludedAttributes: segmentQuery.data.attributes.exclude,
                        includeComposition: segmentQuery.data.composition?.include,
                        excludeComposition: segmentQuery.data.composition?.exclude
                    })
                ]
            })
        ]
    });
};
var $046ab0e1a946b046$export$2e2bcd8739ae039 = $046ab0e1a946b046$var$ViewSegment;




var $ieT14 = parcelRequire("ieT14");

var $fpdl2 = parcelRequire("fpdl2");
var $e1ONw = parcelRequire("e1ONw");
var $lwgYO = parcelRequire("lwgYO");

var $fgoQ6 = parcelRequire("fgoQ6");



var $j6s32 = parcelRequire("j6s32");

var $ieT14 = parcelRequire("ieT14");



function $bc2ca1a4dca94fa3$export$e7c0f2f1814f284(segmentId, sort) {
    const appState = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const { fetchWrapper: fetchWrapper } = (0, $65ff79d5f12a411e$export$2e2bcd8739ae039)();
    return (0, $137a3b252d598119$export$dd0a697e1782aedd)([
        'dependencies',
        appState.state.clientId,
        segmentId,
        sort
    ], ()=>{
        let query = `Page=${sort.page}` + `&PageSize=${sort.pageSize}` + `&Sort=${sort.orderColumn}` + `&SortDirection=${sort.orderDirection}`;
        return fetchWrapper(`api/${appState.state.clientId}/segments/${segmentId}/dependencies?${query}`);
    }, {
        keepPreviousData: true
    });
}



var $d99407d8d94223d7$var$SegmentDependenciesSortFields = /*#__PURE__*/ function(SegmentDependenciesSortFields) {
    SegmentDependenciesSortFields["Name"] = "name";
    SegmentDependenciesSortFields["ModifiedDate"] = "lastModifiedDate";
    SegmentDependenciesSortFields["Description"] = "description";
    SegmentDependenciesSortFields["NumberOfCustomers"] = "totalCustomers";
    SegmentDependenciesSortFields["CreatedBy"] = "createdByName";
    return SegmentDependenciesSortFields;
}($d99407d8d94223d7$var$SegmentDependenciesSortFields || {});
const $d99407d8d94223d7$var$segmentDependenciesHeaders = [
    {
        title: 'Name',
        orderField: "name"
    },
    {
        title: 'Modified Date',
        orderField: "lastModifiedDate"
    },
    {
        title: 'Description',
        orderField: "description"
    },
    {
        title: '# of Customers',
        orderField: "totalCustomers"
    },
    {
        title: 'Created By',
        orderField: "createdByName"
    },
    {
        title: 'View Segment',
        orderField: null
    }
];
const $d99407d8d94223d7$var$useStyles = (0, $e1ONw.default)(()=>({
        tablePadding: {
            padding: '25px 0'
        },
        tableHeader: {
            display: 'flex',
            justifyContent: 'end',
            alignItems: 'center',
            padding: '10px 30px 0'
        },
        dependenciesagination: {
            display: 'flex',
            justifyContent: 'flex-end',
            borderTop: '1px solid #DAD5D5'
        },
        noDependenciesContainer: {
            margin: '10rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            '& div': {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }
        },
        paperColumn: {
            flexDirection: 'column'
        },
        linkText: {
            textDecoration: 'none',
            fontWeight: 500,
            color: '#006DA8',
            cursor: 'pointer',
            border: 'none',
            background: 'none',
            padding: 0
        }
    }));
const $d99407d8d94223d7$var$SegmentDependenciesTable = ({ segmentId: segmentId })=>{
    const classes = $d99407d8d94223d7$var$useStyles();
    const [tableSort, setTableSort] = (0, (/*@__PURE__*/$parcel$interopDefault($ieT14))).useState({
        page: 1,
        pageSize: 15,
        orderColumn: "name",
        orderDirection: 'desc'
    });
    const segmentDependenciesQuery = (0, $bc2ca1a4dca94fa3$export$e7c0f2f1814f284)(segmentId, tableSort);
    function reorderHandler(column, direction) {
        setTableSort((state)=>({
                ...state,
                orderColumn: column,
                orderDirection: direction
            }));
    }
    if (!!segmentDependenciesQuery.data && segmentDependenciesQuery.data.totalItems === 0) return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        className: classes.noDependenciesContainer,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                className: $246ccfbc8d89a664$export$82456417dae51472,
                children: "This segment has no dependencies"
            })
        })
    });
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
        className: $246ccfbc8d89a664$export$e8e78c978b129247,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("section", {
            className: classes.tablePadding,
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $lwgYO.default), {
                elevation: 1,
                className: (0, $j6s32.default)($246ccfbc8d89a664$export$914772be44022da8, classes.paperColumn),
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
                    className: $246ccfbc8d89a664$export$a7db06668cad9adb,
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                            className: classes.tableHeader
                        }),
                        segmentDependenciesQuery.isLoading && !segmentDependenciesQuery.data && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                            className: $246ccfbc8d89a664$export$46c1c92549715335,
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fpdl2.default), {})
                        }),
                        segmentDependenciesQuery.isError && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                            className: $246ccfbc8d89a664$export$a3bc9b8ed74fc,
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.SecondaryAlert), {
                                type: "error",
                                message: `Failed to fetch results: ${segmentDependenciesQuery.error.message}`
                            })
                        }),
                        !!segmentDependenciesQuery.data && segmentDependenciesQuery.data.totalItems > 0 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                            className: $246ccfbc8d89a664$export$e7d47881ec916f76,
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $59739725ddd88dec$export$2e2bcd8739ae039), {
                                stickyHeader: true,
                                className: $246ccfbc8d89a664$export$9852986a3ec5f6a0,
                                children: [
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $fgoQ6.TableHead), {
                                        children: [
                                            $d99407d8d94223d7$var$segmentDependenciesHeaders.map((header)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.HeaderCell), {
                                                    title: header.title,
                                                    orderField: header.orderField ? header.orderField : null,
                                                    orderColumn: header.orderField ? tableSort.orderColumn : null,
                                                    orderDirection: header.orderField ? tableSort.orderDirection : null,
                                                    reorderHandler: header.orderField ? reorderHandler : null
                                                }, header.title)),
                                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fgoQ6.HeaderCell), {
                                                title: ""
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $fgoQ6.TableBody), {
                                        children: [
                                            segmentDependenciesQuery.data.totalItems === 0 && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("td", {
                                                    colSpan: $d99407d8d94223d7$var$segmentDependenciesHeaders.length,
                                                    children: "No results found"
                                                })
                                            }),
                                            segmentDependenciesQuery.data.results.map((segmentDependency)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $57cf0cd18ac88d0a$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $248bc6cb24906a61$export$2e2bcd8739ae039), {
                                                            padding: "none",
                                                            children: segmentDependency.name
                                                        }),
                                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $248bc6cb24906a61$export$2e2bcd8739ae039), {
                                                            padding: "none",
                                                            children: segmentDependency.lastModifiedDate ? (0, $28c5efff86001588$export$3245e15bf4cbdd6c).format(new Date(segmentDependency.lastModifiedDate)) : ''
                                                        }),
                                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $248bc6cb24906a61$export$2e2bcd8739ae039), {
                                                            padding: "none",
                                                            children: segmentDependency.description
                                                        }),
                                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $248bc6cb24906a61$export$2e2bcd8739ae039), {
                                                            padding: "none",
                                                            children: segmentDependency.totalCustomers.toLocaleString()
                                                        }),
                                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $248bc6cb24906a61$export$2e2bcd8739ae039), {
                                                            padding: "none",
                                                            children: segmentDependency.createdByName
                                                        }),
                                                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $248bc6cb24906a61$export$2e2bcd8739ae039), {
                                                            padding: "none",
                                                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("button", {
                                                                onClick: ()=>window.open(`${window.location.origin}/segments/${segmentDependency.id}`, '_blank'),
                                                                className: classes.linkText,
                                                                children: "View in New Tab"
                                                            })
                                                        })
                                                    ]
                                                }, segmentDependency.id))
                                        ]
                                    })
                                ]
                            })
                        }),
                        segmentDependenciesQuery.data && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                            className: `${$246ccfbc8d89a664$export$e19d3e3c28de4af} ${classes.dependenciesagination}`,
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $fce6a9cfa0ef4de9$export$2e2bcd8739ae039), {
                                totalPages: Math.ceil(segmentDependenciesQuery.data.totalItems / tableSort.pageSize),
                                pageSize: tableSort.pageSize,
                                currentPage: tableSort.page,
                                disabled: segmentDependenciesQuery.isPreviousData && segmentDependenciesQuery.isFetching,
                                handlePageChange: (page)=>setTableSort((state)=>({
                                            ...state,
                                            page: page
                                        })),
                                handlePageSizeChange: (pageSize)=>setTableSort((state)=>({
                                            ...state,
                                            page: 1,
                                            pageSize: pageSize
                                        }))
                            })
                        })
                    ]
                })
            })
        })
    });
};
var $d99407d8d94223d7$export$2e2bcd8739ae039 = $d99407d8d94223d7$var$SegmentDependenciesTable;


const $643c22d107e64c15$var$SegmentTab = ()=>{
    const { segmentId: segmentId } = (0, $eYoAG.useParams)();
    const currentPath = (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Segment.replace(':segmentId', segmentId);
    const { segmentQuery: segmentQuery } = (0, $1517e00917d95652$export$204800eede9ea29f)(segmentId);
    const [pushUser, setPushUser] = $ieT14.useState(false);
    const [powerUser, setPowerUser] = $ieT14.useState(false);
    const [clientIdForSegment, setClientIdForSegment] = $ieT14.useState(null);
    const { getCurrentUser: getCurrentUser } = (0, $b19aa392df0f3838$export$2e2bcd8739ae039)();
    const userName = $ieT14.useRef('');
    const userInterface = window.env.USER_INTERFACE ?? 'default';
    $ieT14.useEffect(()=>{
        if (segmentQuery.data) checkUser();
    }, [
        segmentQuery.data
    ]);
    const checkUser = async ()=>{
        try {
            const currentUser = await getCurrentUser();
            userName.current = `${currentUser.firstName} ${currentUser.lastName}`;
            const assignedSegmentation = currentUser.assignedSegmentation.find((as)=>as.clientId === segmentQuery.data.clientId);
            setClientIdForSegment(segmentQuery.data.clientId);
            setPushUser(assignedSegmentation.segmentationPermission === (0, $5294e215b521479c$export$2e2bcd8739ae039).Push);
            setPowerUser(assignedSegmentation.segmentationPermission === (0, $5294e215b521479c$export$2e2bcd8739ae039).Power);
        } catch (error) {
            setClientIdForSegment(null);
            setPushUser(false);
            setPowerUser(false);
        }
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)("div", {
        className: $adc248bb409000ee$export$e8e78c978b129247,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $8991ead30e777b29$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $a498acb6c44028b9$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $ced85e21f8aa5734$export$2e2bcd8739ae039), {
                        segmentId: segmentId
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $eYoAG.Switch), {
                    children: [
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $eYoAG.Route), {
                            exact: true,
                            path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Segment,
                            children: [
                                userInterface !== 'management' && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $64180d5c126386e0$export$2e2bcd8739ae039), {
                                    segmentId: segmentId,
                                    segmentQuery: segmentQuery,
                                    powerUser: powerUser,
                                    userName: userName.current
                                }),
                                userInterface === 'management' && /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $046ab0e1a946b046$export$2e2bcd8739ae039), {
                                    segmentId: segmentId,
                                    segmentQuery: segmentQuery,
                                    powerUser: powerUser,
                                    userName: userName.current
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Route), {
                            exact: true,
                            path: `${currentPath}/pushes`,
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $26bea0643660e1ea$export$2e2bcd8739ae039), {
                                segmentId: segmentId,
                                canPush: pushUser || powerUser,
                                clientIdForSegment: clientIdForSegment
                            })
                        }),
                        /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Route), {
                            exact: true,
                            path: `${currentPath}/dependencies`,
                            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $d99407d8d94223d7$export$2e2bcd8739ae039), {
                                segmentId: segmentId
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $643c22d107e64c15$export$2e2bcd8739ae039 = $643c22d107e64c15$var$SegmentTab;


const $fbf6d60ebd90a051$var$LayoutRouter = ()=>{
    const { state: state } = $ieT14.useContext((0, $04456a55398eabf4$export$122994dc05ba4308));
    const userInterface = window.env.USER_INTERFACE !== null && window.env.USER_INTERFACE !== undefined ? window.env.USER_INTERFACE : 'default';
    if (userInterface === 'management') return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $49b5f1ea6af5bca5$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $eYoAG.Switch), {
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                    path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).GlobalHelpDocuments,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $524bc7b3eb0618a2$export$752cfdd6bed7d744), {
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $eYoAG.Switch), {
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                                    path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).AddGlobalHelpDocument,
                                    exact: true,
                                    component: (0, $9f48766971a2e84f$export$2e2bcd8739ae039)
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                                    path: `${(0, $4bbac098dba9d86f$export$2e2bcd8739ae039).EditGlobalHelpDocument}/:revisions?`,
                                    exact: false,
                                    component: (0, $30682a56d7cd742d$export$2e2bcd8739ae039)
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                                    path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).ViewGlobalHelpDocumentRevisions,
                                    exact: true,
                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $e48cd4f69810746a$export$86457176ea54894f), {
                                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $285438b7d136a22f$export$2e2bcd8739ae039), {
                                            isGlobal: true
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                                    path: `${(0, $4bbac098dba9d86f$export$2e2bcd8739ae039).GlobalHelpDocuments}/:document?`,
                                    exact: true,
                                    component: (0, $4c3bb60c07737b6c$export$2e2bcd8739ae039)
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                    path: "/clients",
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $eYoAG.Switch), {
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                                path: "/clients",
                                exact: true,
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1931bd0aa9be7e6d$export$2052c90c9d1d90b), {
                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $0ad5c88c6d9fec0c$export$2e2bcd8739ae039), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                                path: "/clients/create",
                                exact: true,
                                component: (0, $b12c3eb296716e23$export$2e2bcd8739ae039)
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                                path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).EditClient,
                                exact: false,
                                component: (0, $053de9380ceb4e28$export$2e2bcd8739ae039)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                    path: "/users",
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $eYoAG.Switch), {
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                                path: "/users",
                                exact: true,
                                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $dee37b87a49977d2$export$273547615d3e6fa4), {
                                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $548cfd5b251cff06$export$2e2bcd8739ae039), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                                path: "/users/create",
                                exact: true,
                                component: (0, $14c46cdcf5845036$export$2e2bcd8739ae039)
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                                path: "/users/:userId/edit",
                                exact: false,
                                component: (0, $146cfb663f998c32$export$2e2bcd8739ae039)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                    path: "/announcements",
                    exact: true,
                    component: (0, $3c266d141e86f58a$export$2e2bcd8739ae039)
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                    path: "/change-password",
                    exact: true,
                    component: (0, $51cefd552a774a55$export$2e2bcd8739ae039)
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                    exact: true,
                    path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Segments,
                    component: (0, $b6cae2dd779d4f78$export$2e2bcd8739ae039)
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                    path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).PushDetails,
                    component: (0, $4585747b2328cee7$export$2e2bcd8739ae039)
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                    path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Segment,
                    component: (0, $643c22d107e64c15$export$2e2bcd8739ae039)
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Redirect), {
                    from: "*",
                    to: "/clients"
                })
            ]
        })
    });
    else return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $49b5f1ea6af5bca5$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $eYoAG.Switch), {
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                    exact: true,
                    path: "/reports",
                    component: (0, $3c58e713e466d62d$export$2e2bcd8739ae039)
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                    path: "/reports/:reportId",
                    exact: false,
                    component: (routeProps)=>/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $07c15c32a1a1f15e$export$2e2bcd8739ae039), {
                            clientId: state.clientId,
                            ...routeProps
                        })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                    exact: false,
                    path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Segments,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $1b5cf9b2bde9348f$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $eYoAG.Switch), {
                            children: [
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                                    exact: true,
                                    path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Segments,
                                    component: (0, $8b17776987f48cd0$export$2e2bcd8739ae039)
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                                    exact: true,
                                    path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).NewSegment,
                                    component: (0, $a84c717865e82d71$export$2e2bcd8739ae039)
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                                    exact: true,
                                    path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).PushSegment,
                                    component: (0, $3658a2d28fd0ba5c$export$2e2bcd8739ae039)
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                                    exact: true,
                                    path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).PushDetails,
                                    component: (0, $4585747b2328cee7$export$2e2bcd8739ae039)
                                }),
                                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                                    path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Segment,
                                    component: (0, $643c22d107e64c15$export$2e2bcd8739ae039)
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                    exact: true,
                    path: "/change-password",
                    component: (0, $51cefd552a774a55$export$2e2bcd8739ae039)
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                    path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Help + '/:document?',
                    exact: false,
                    component: (0, $961de21096e2c5eb$export$2e2bcd8739ae039)
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                    exact: false,
                    path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Support,
                    children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $9308be3dff04d2e5$export$692b183921950b7b), {
                        children: [
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                                path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Support,
                                exact: true,
                                component: (0, $c9944a36932f78bd$export$2e2bcd8739ae039)
                            }),
                            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                                path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).AddRequest,
                                exact: false,
                                component: (0, $fc283ee35e620e7c$export$2e2bcd8739ae039)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Redirect), {
                    from: "*",
                    to: "/reports"
                })
            ]
        })
    });
};
var $fbf6d60ebd90a051$export$2e2bcd8739ae039 = $fbf6d60ebd90a051$var$LayoutRouter;







const $5767ffcbcf09e40e$var$oktaAuth = new (0, $c54b3d2ef9f9e60a$exports.OktaAuth)((0, $0eef21711cc31468$export$2055a4168038516));
const $5767ffcbcf09e40e$var$Router = ()=>{
    const history = (0, $eYoAG.useHistory)();
    const queryClient = (0, $7fd0e6909adb481d$export$22e77b9572c4fded)();
    const customAuthHandler = ()=>{
        history.push('/login');
        queryClient.removeQueries();
    };
    const restoreOriginalUri = async (_oktaAuth, originalUri)=>{
        const url = originalUri || '/';
        history.replace((0, $c54b3d2ef9f9e60a$exports.toRelativeUrl)(url, window.location.origin));
    };
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$9fb697de7778c436), {
        oktaAuth: $5767ffcbcf09e40e$var$oktaAuth,
        onAuthRequired: customAuthHandler,
        restoreOriginalUri: restoreOriginalUri,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $eYoAG.Switch), {
            children: [
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Route), {
                    path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).LoginCallback,
                    component: (0, $f2d6d43ad1660b76$export$2e2bcd8739ae039)
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $eYoAG.Route), {
                    path: (0, $4bbac098dba9d86f$export$2e2bcd8739ae039).Login,
                    exact: true,
                    component: (0, $15519e994ec8144e$export$2e2bcd8739ae039)
                }),
                /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $4df32aa15a91038c$export$d93cdd50e579241c), {
                    path: "/",
                    exact: false,
                    component: (0, $fbf6d60ebd90a051$export$2e2bcd8739ae039)
                })
            ]
        })
    });
};
var $5767ffcbcf09e40e$export$2e2bcd8739ae039 = $5767ffcbcf09e40e$var$Router;



var $gXLwJ = parcelRequire("gXLwJ");


const $27703dbb28c47a75$export$bd5f1a547a7fc66c = (0, $gXLwJ.default)({
    palette: {
        primary: {
            main: $69ed148db7543104$export$2aa0182783e7e9de[700]
        },
        secondary: {
            main: $69ed148db7543104$export$2aa0182783e7e9de[600]
        },
        background: {
            default: '#fff'
        },
        success: {
            main: $69ed148db7543104$export$471f7ae5c4103ae1.success.dark // priority 1
        },
        info: {
            main: $69ed148db7543104$export$471f7ae5c4103ae1.info.dark // priority 1
        },
        error: {
            main: $69ed148db7543104$export$471f7ae5c4103ae1.error.dark // priority 1
        },
        warning: {
            main: $69ed148db7543104$export$471f7ae5c4103ae1.warning.dark // priority 1
        }
    },
    typography: {
        fontFamily: $a414f09d93b4ed4c$export$709a39c897136e8.body,
        h1: {
            fontFamily: $a414f09d93b4ed4c$export$709a39c897136e8.heading,
            fontSize: $a414f09d93b4ed4c$export$c838579cfa8e3e4f.h1,
            fontWeight: 600
        },
        h2: {
            fontFamily: $a414f09d93b4ed4c$export$709a39c897136e8.heading,
            fontSize: $a414f09d93b4ed4c$export$c838579cfa8e3e4f.h2,
            fontWeight: 300,
            color: $69ed148db7543104$export$2aa0182783e7e9de[600]
        },
        h3: {
            fontFamily: $a414f09d93b4ed4c$export$709a39c897136e8.heading,
            fontSize: $a414f09d93b4ed4c$export$c838579cfa8e3e4f.h3,
            fontWeight: 600,
            textTransform: 'uppercase'
        },
        h4: {
            fontFamily: $a414f09d93b4ed4c$export$709a39c897136e8.heading,
            fontSize: $a414f09d93b4ed4c$export$c838579cfa8e3e4f.h4,
            fontWeight: 300,
            textTransform: 'uppercase'
        },
        h5: {
            fontFamily: $a414f09d93b4ed4c$export$709a39c897136e8.heading,
            fontSize: $a414f09d93b4ed4c$export$c838579cfa8e3e4f.h5,
            fontWeight: 600
        },
        h6: {
            fontFamily: $a414f09d93b4ed4c$export$709a39c897136e8.heading,
            fontSize: $a414f09d93b4ed4c$export$c838579cfa8e3e4f.h6,
            fontWeight: 300
        }
    },
    overrides: {
        MuiMenuItem: {
            root: {
                '&$selected': {
                    backgroundColor: '#eaf3f8 !important',
                    color: 'black'
                }
            }
        },
        MuiFormControlLabel: {
            label: {
                fontFamily: $a414f09d93b4ed4c$export$709a39c897136e8.body,
                fontWeight: 300,
                fontSize: 14,
                letterSpacing: '0.3px',
                color: '#000000'
            }
        },
        MuiFormLabel: {
            root: {
                fontFamily: $a414f09d93b4ed4c$export$709a39c897136e8.heading,
                fontWeight: 300,
                color: '#4f4f4f !important',
                fontSize: 14,
                backgroundColor: 'white',
                '&$focused': {
                    color: '#4f4f4f !important'
                }
            }
        },
        MuiInputLabel: {
            root: {
                fontFamily: $a414f09d93b4ed4c$export$709a39c897136e8.heading,
                fontWeight: 300,
                color: '#4f4f4f !important',
                fontSize: 14,
                backgroundColor: 'white'
            },
            outlined: {
                fontFamily: $a414f09d93b4ed4c$export$709a39c897136e8.heading,
                fontWeight: 300,
                color: '#4f4f4f !important',
                fontSize: 14
            }
        }
    }
});



var $3umuy = parcelRequire("3umuy");
var $156bf768e84d6d87$var$MomentUtils = /** @class */ function() {
    function MomentUtils(_a) {
        var _b = _a === void 0 ? {} : _a, locale = _b.locale, instance = _b.instance, moment = _b.moment;
        this.yearFormat = "YYYY";
        this.yearMonthFormat = "MMMM YYYY";
        this.dateTime12hFormat = "MMMM Do hh:mm a";
        this.dateTime24hFormat = "MMMM Do HH:mm";
        this.time12hFormat = "hh:mm A";
        this.time24hFormat = "HH:mm";
        this.dateFormat = "MMMM Do";
        this.moment = instance || moment || (0, (/*@__PURE__*/$parcel$interopDefault($3umuy)));
        this.locale = locale;
    }
    MomentUtils.prototype.parse = function(value, format) {
        if (value === "") return null;
        return this.moment(value, format, true);
    };
    MomentUtils.prototype.date = function(value) {
        if (value === null) return null;
        var moment = this.moment(value);
        moment.locale(this.locale);
        return moment;
    };
    MomentUtils.prototype.isValid = function(value) {
        return this.moment(value).isValid();
    };
    MomentUtils.prototype.isNull = function(date) {
        return date === null;
    };
    MomentUtils.prototype.getDiff = function(date, comparing) {
        return date.diff(comparing);
    };
    MomentUtils.prototype.isAfter = function(date, value) {
        return date.isAfter(value);
    };
    MomentUtils.prototype.isBefore = function(date, value) {
        return date.isBefore(value);
    };
    MomentUtils.prototype.isAfterDay = function(date, value) {
        return date.isAfter(value, "day");
    };
    MomentUtils.prototype.isBeforeDay = function(date, value) {
        return date.isBefore(value, "day");
    };
    MomentUtils.prototype.isBeforeYear = function(date, value) {
        return date.isBefore(value, "year");
    };
    MomentUtils.prototype.isAfterYear = function(date, value) {
        return date.isAfter(value, "year");
    };
    MomentUtils.prototype.startOfDay = function(date) {
        return date.clone().startOf("day");
    };
    MomentUtils.prototype.endOfDay = function(date) {
        return date.clone().endOf("day");
    };
    MomentUtils.prototype.format = function(date, formatString) {
        date.locale(this.locale);
        return date.format(formatString);
    };
    MomentUtils.prototype.formatNumber = function(numberToFormat) {
        return numberToFormat;
    };
    MomentUtils.prototype.getHours = function(date) {
        return date.get("hours");
    };
    MomentUtils.prototype.addDays = function(date, count) {
        return count < 0 ? date.clone().subtract(Math.abs(count), "days") : date.clone().add(count, "days");
    };
    MomentUtils.prototype.setHours = function(date, count) {
        return date.clone().hours(count);
    };
    MomentUtils.prototype.getMinutes = function(date) {
        return date.get("minutes");
    };
    MomentUtils.prototype.setMinutes = function(date, count) {
        return date.clone().minutes(count);
    };
    MomentUtils.prototype.getSeconds = function(date) {
        return date.get("seconds");
    };
    MomentUtils.prototype.setSeconds = function(date, count) {
        return date.clone().seconds(count);
    };
    MomentUtils.prototype.getMonth = function(date) {
        return date.get("month");
    };
    MomentUtils.prototype.isSameDay = function(date, comparing) {
        return date.isSame(comparing, "day");
    };
    MomentUtils.prototype.isSameMonth = function(date, comparing) {
        return date.isSame(comparing, "month");
    };
    MomentUtils.prototype.isSameYear = function(date, comparing) {
        return date.isSame(comparing, "year");
    };
    MomentUtils.prototype.isSameHour = function(date, comparing) {
        return date.isSame(comparing, "hour");
    };
    MomentUtils.prototype.setMonth = function(date, count) {
        return date.clone().month(count);
    };
    MomentUtils.prototype.getMeridiemText = function(ampm) {
        return ampm === "am" ? "AM" : "PM";
    };
    MomentUtils.prototype.startOfMonth = function(date) {
        return date.clone().startOf("month");
    };
    MomentUtils.prototype.endOfMonth = function(date) {
        return date.clone().endOf("month");
    };
    MomentUtils.prototype.getNextMonth = function(date) {
        return date.clone().add(1, "month");
    };
    MomentUtils.prototype.getPreviousMonth = function(date) {
        return date.clone().subtract(1, "month");
    };
    MomentUtils.prototype.getMonthArray = function(date) {
        var firstMonth = date.clone().startOf("year");
        var monthArray = [
            firstMonth
        ];
        while(monthArray.length < 12){
            var prevMonth = monthArray[monthArray.length - 1];
            monthArray.push(this.getNextMonth(prevMonth));
        }
        return monthArray;
    };
    MomentUtils.prototype.getYear = function(date) {
        return date.get("year");
    };
    MomentUtils.prototype.setYear = function(date, year) {
        return date.clone().set("year", year);
    };
    MomentUtils.prototype.mergeDateAndTime = function(date, time) {
        return this.setMinutes(this.setHours(date, this.getHours(time)), this.getMinutes(time));
    };
    MomentUtils.prototype.getWeekdays = function() {
        return this.moment.weekdaysShort(true);
    };
    MomentUtils.prototype.isEqual = function(value, comparing) {
        if (value === null && comparing === null) return true;
        return this.moment(value).isSame(comparing);
    };
    MomentUtils.prototype.getWeekArray = function(date) {
        var start = date.clone().startOf("month").startOf("week");
        var end = date.clone().endOf("month").endOf("week");
        var count = 0;
        var current = start;
        var nestedWeeks = [];
        while(current.isBefore(end)){
            var weekNumber = Math.floor(count / 7);
            nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
            nestedWeeks[weekNumber].push(current);
            current = current.clone().add(1, "day");
            count += 1;
        }
        return nestedWeeks;
    };
    MomentUtils.prototype.getYearRange = function(start, end) {
        var startDate = this.moment(start).startOf("year");
        var endDate = this.moment(end).endOf("year");
        var years = [];
        var current = startDate;
        while(current.isBefore(endDate)){
            years.push(current);
            current = current.clone().add(1, "year");
        }
        return years;
    };
    // displaying methods
    MomentUtils.prototype.getCalendarHeaderText = function(date) {
        return this.format(date, this.yearMonthFormat);
    };
    MomentUtils.prototype.getYearText = function(date) {
        return this.format(date, "YYYY");
    };
    MomentUtils.prototype.getDatePickerHeaderText = function(date) {
        return this.format(date, "ddd, MMM D");
    };
    MomentUtils.prototype.getDateTimePickerHeaderText = function(date) {
        return this.format(date, "MMM D");
    };
    MomentUtils.prototype.getMonthText = function(date) {
        return this.format(date, "MMMM");
    };
    MomentUtils.prototype.getDayText = function(date) {
        return this.format(date, "D");
    };
    MomentUtils.prototype.getHourText = function(date, ampm) {
        return this.format(date, ampm ? "hh" : "HH");
    };
    MomentUtils.prototype.getMinuteText = function(date) {
        return this.format(date, "mm");
    };
    MomentUtils.prototype.getSecondText = function(date) {
        return this.format(date, "ss");
    };
    return MomentUtils;
}();
var $156bf768e84d6d87$export$2e2bcd8739ae039 = $156bf768e84d6d87$var$MomentUtils;




const $8e3430a80e1f240c$var$ApplicationRouter = ()=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $6mt9R.BrowserRouter), {
        basename: window.env.BASE_URL,
        children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $227fe7cc0a67c04e$export$3a1a48c8f6ef640e), {
            utils: (0, $156bf768e84d6d87$export$2e2bcd8739ae039),
            children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $544e32820ad8eb30$export$2e2bcd8739ae039), {
                theme: (0, $27703dbb28c47a75$export$bd5f1a547a7fc66c),
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $5767ffcbcf09e40e$export$2e2bcd8739ae039), {})
            })
        })
    });
};
var $8e3430a80e1f240c$export$2e2bcd8739ae039 = $8e3430a80e1f240c$var$ApplicationRouter;












// CLASS
class $183b9f3e218469a2$export$62297b13309008b2 extends (0, $bfe96b6a319fad0f$export$e09608847fcc8c59) {
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, $dfd64722afb66cad$export$1cf3d545f2d4635c);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || $183b9f3e218469a2$var$getDefaultState(this.options);
        this.state = this.initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === 'idle') this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $18693172d3695360$export$17619bac5b909b23)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: 'success',
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: 'setState',
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $18693172d3695360$export$8793edee2d425525)).catch((0, $18693172d3695360$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $18693172d3695360$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: 'observerAdded',
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: 'observerRemoved',
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: 'invalidate'
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== 'idle') {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = (0, $18693172d3695360$export$382ca5d13a8f252c)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, 'signal', {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === 'idle' || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: 'fetch',
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, $984e1698e746a614$export$986cc6445c1d323)(error) && error.silent)) this.dispatch({
                type: 'error',
                error: error
            });
            if (!(0, $984e1698e746a614$export$986cc6445c1d323)(error)) {
                var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null || _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, $984e1698e746a614$export$2cbd00fe8a2c8d85)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
                if (typeof data === 'undefined') {
                    onError(new Error(this.queryHash + " data is undefined"));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null || _this$cache$config$on3.call(_this$cache$config3, data, this);
                (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null || _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.dispatch({
                    type: 'failed',
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: 'pause'
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: 'continue'
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case 'failed':
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case 'pause':
                    return {
                        ...state,
                        fetchStatus: 'paused'
                    };
                case 'continue':
                    return {
                        ...state,
                        fetchStatus: 'fetching'
                    };
                case 'fetch':
                    return {
                        ...state,
                        fetchFailureCount: 0,
                        fetchFailureReason: null,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, $984e1698e746a614$export$61b92f63f30245cf)(this.options.networkMode) ? 'fetching' : 'paused',
                        ...!state.dataUpdatedAt && {
                            error: null,
                            status: 'loading'
                        }
                    };
                case 'success':
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: 'success',
                        ...!action.manual && {
                            fetchStatus: 'idle',
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case 'error':
                    const error = action.error;
                    if ((0, $984e1698e746a614$export$986cc6445c1d323)(error) && error.revert && this.revertState) return {
                        ...this.revertState,
                        fetchStatus: 'idle'
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: 'idle',
                        status: 'error'
                    };
                case 'invalidate':
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case 'setState':
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $c92d7790084acd39$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: 'updated',
                action: action
            });
        });
    }
}
function $183b9f3e218469a2$var$getDefaultState(options) {
    const data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    const hasData = typeof data !== 'undefined';
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? 'success' : 'loading',
        fetchStatus: 'idle'
    };
}




// CLASS
class $1f114715fec0cc1f$export$5dde0cd941da8468 extends (0, $9cc1a4e40d9960ad$export$d26086b469ecdbcc) {
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $18693172d3695360$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $183b9f3e218469a2$export$62297b13309008b2)({
                cache: this,
                logger: client.getLogger(),
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: 'added',
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: 'removed',
                query: query
            });
        }
    }
    clear() {
        (0, $c92d7790084acd39$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    find(arg1, arg2) {
        const [filters] = (0, $18693172d3695360$export$18e8f4b987e6c111)(arg1, arg2);
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.queries.find((query)=>(0, $18693172d3695360$export$c5d1efe363797780)(filters, query));
    }
    findAll(arg1, arg2) {
        const [filters] = (0, $18693172d3695360$export$18e8f4b987e6c111)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, $18693172d3695360$export$c5d1efe363797780)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, $c92d7790084acd39$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $c92d7790084acd39$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $c92d7790084acd39$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
}






// CLASS
class $59350746d9ea6f07$export$1fcfd9a244434844 extends (0, $9cc1a4e40d9960ad$export$d26086b469ecdbcc) {
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
    build(client, options, state) {
        const mutation = new (0, $a3529469b4436299$export$17b8b19c814bcf56)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: 'added',
            mutation: mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: 'removed',
            mutation: mutation
        });
    }
    clear() {
        (0, $c92d7790084acd39$export$520687f44db6e1ab).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.mutations.find((mutation)=>(0, $18693172d3695360$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, $18693172d3695360$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $c92d7790084acd39$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        var _this$resuming;
        this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(()=>{
            const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
            return (0, $c92d7790084acd39$export$520687f44db6e1ab).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $18693172d3695360$export$8793edee2d425525))), Promise.resolve()));
        }).then(()=>{
            this.resuming = undefined;
        });
        return this.resuming;
    }
}





function $b7cec18f611e87d0$export$84470d1367601e8d() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, 'signal', {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener('abort', ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject('Cancelled');
                    if (typeof param === 'undefined' && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== 'undefined';
                    const param = manual ? pageParam : $b7cec18f611e87d0$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== 'undefined';
                    const param = manual ? pageParam : $b7cec18f611e87d0$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === 'undefined';
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : $b7cec18f611e87d0$export$1186159d57de7255(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages: pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function $b7cec18f611e87d0$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $b7cec18f611e87d0$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function $b7cec18f611e87d0$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = $b7cec18f611e87d0$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
    }
    return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function $b7cec18f611e87d0$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = $b7cec18f611e87d0$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
    }
    return;
}



// CLASS
class $4349a17a675223d5$export$405d0624ed55a03f {
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, $1f114715fec0cc1f$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $59350746d9ea6f07$export$1fcfd9a244434844)();
        this.logger = config.logger || (0, $dfd64722afb66cad$export$1cf3d545f2d4635c);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
        this.mountCount = 0;
    }
    mount() {
        this.mountCount++;
        if (this.mountCount !== 1) return;
        this.unsubscribeFocus = (0, $57859f5d4fbb2468$export$6bf54661be5b02cf).subscribe(()=>{
            if ((0, $57859f5d4fbb2468$export$6bf54661be5b02cf).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $c5be52d7b8157150$export$b113e788b2dd3fdc).subscribe(()=>{
            if ((0, $c5be52d7b8157150$export$b113e788b2dd3fdc).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        this.mountCount--;
        if (this.mountCount !== 0) return;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        this.unsubscribeFocus = undefined;
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
        this.unsubscribeOnline = undefined;
    }
    isFetching(arg1, arg2) {
        const [filters] = (0, $18693172d3695360$export$18e8f4b987e6c111)(arg1, arg2);
        filters.fetchStatus = 'fetching';
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll({
            ...filters,
            fetching: true
        }).length;
    }
    getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    ensureQueryData(arg1, arg2, arg3) {
        const parsedOptions = (0, $18693172d3695360$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        const cachedData = this.getQueryData(parsedOptions.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
    getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $18693172d3695360$export$7f095f455ad5af3f)(updater, prevData);
        if (typeof data === 'undefined') return undefined;
        const parsedOptions = (0, $18693172d3695360$export$8a11fbc2c8ea08fd)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, $c92d7790084acd39$export$520687f44db6e1ab).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    removeQueries(arg1, arg2) {
        const [filters] = (0, $18693172d3695360$export$18e8f4b987e6c111)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, $c92d7790084acd39$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $18693172d3695360$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = {
            type: 'active',
            ...filters
        };
        return (0, $c92d7790084acd39$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, $18693172d3695360$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === 'undefined') cancelOptions.revert = true;
        const promises = (0, $c92d7790084acd39$export$520687f44db6e1ab).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, $18693172d3695360$export$8793edee2d425525)).catch((0, $18693172d3695360$export$8793edee2d425525));
    }
    invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $18693172d3695360$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        return (0, $c92d7790084acd39$export$520687f44db6e1ab).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === 'none') return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : 'active'
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $18693172d3695360$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        const promises = (0, $c92d7790084acd39$export$520687f44db6e1ab).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, {
                    ...options,
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                });
            }));
        let promise = Promise.all(promises).then((0, $18693172d3695360$export$8793edee2d425525));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, $18693172d3695360$export$8793edee2d425525));
        return promise;
    }
    fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $18693172d3695360$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === 'undefined') defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $18693172d3695360$export$8793edee2d425525)).catch((0, $18693172d3695360$export$8793edee2d425525));
    }
    fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $18693172d3695360$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $b7cec18f611e87d0$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    }
    prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $18693172d3695360$export$8793edee2d425525)).catch((0, $18693172d3695360$export$8793edee2d425525));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, $18693172d3695360$export$5fcb678681417b54)(queryKey) === (0, $18693172d3695360$export$5fcb678681417b54)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, $18693172d3695360$export$2f07189bb9fa26a7)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, $18693172d3695360$export$5fcb678681417b54)(mutationKey) === (0, $18693172d3695360$export$5fcb678681417b54)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, $18693172d3695360$export$2f07189bb9fa26a7)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = {
            ...this.defaultOptions.queries,
            ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $18693172d3695360$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === 'undefined') defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== 'always';
        if (typeof defaultedOptions.useErrorBoundary === 'undefined') defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return {
            ...this.defaultOptions.mutations,
            ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
}



'use client';
const $f2bd41fe75d03c6d$export$fd1469cb3147d866 = function() {
    return null;
};
const $f2bd41fe75d03c6d$export$6d64409a8b475869 = function() {
    return null;
};


// default RUM sampleRate to 100% of sessions
let $71d6b724b4939219$var$rumSamplerate = 100;
if (window.env.RUM_SAMPLERATE !== undefined && window.env.RUM_SAMPLERATE !== '==window.env.RUM_SAMPLERATE==') $71d6b724b4939219$var$rumSamplerate = Number(window.env.RUM_SAMPLERATE);
// don't try to initialize RUM without client token
if (window.env.RUM_CLIENT_TOKEN !== undefined) (0, $80940237791545d7$export$65cc181beb0d2632).init({
    applicationId: '13b91b9e-49c3-4691-a42f-2ed537c89a02',
    clientToken: window.env.RUM_CLIENT_TOKEN,
    datacenter: (0, $be3c451a0388de8d$export$b73954fdb789ff1d).US,
    sampleRate: $71d6b724b4939219$var$rumSamplerate
});
const $71d6b724b4939219$var$queryClient = new (0, $4349a17a675223d5$export$405d0624ed55a03f)({
    defaultOptions: {
        queries: {
            staleTime: 30000
        }
    }
});
const $71d6b724b4939219$var$Application = ()=>{
    return /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsxs)((0, $7fd0e6909adb481d$export$45604f0cc8ae667b), {
        client: $71d6b724b4939219$var$queryClient,
        children: [
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $04456a55398eabf4$export$20d2b7652facc723), {
                children: /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $8e3430a80e1f240c$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $f2bd41fe75d03c6d$export$fd1469cb3147d866), {
                initialIsOpen: false
            })
        ]
    });
};
var $71d6b724b4939219$export$2e2bcd8739ae039 = $71d6b724b4939219$var$Application;


const $5f01065f81d1918b$var$container = document.getElementById('app');
const $5f01065f81d1918b$var$root = (0, $74fc34f240fc23e5$export$882461b6382ed46c)($5f01065f81d1918b$var$container);
$5f01065f81d1918b$var$root.render(/*#__PURE__*/ (0, $8991ead30e777b29$exports.jsx)((0, $71d6b724b4939219$export$2e2bcd8739ae039), {}));

})();
//# sourceMappingURL=index.js.map
